/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "./";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(2319);
	module.exports = __webpack_require__(1140);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(2330);
	} else {
	  module.exports = require('./cjs/react.development.js');
	}


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(2199)();
	}


/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
		Copyright (c) 2018 Jed Watson.
		Licensed under the MIT License (MIT), see
		http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = '';
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (arg) {
					classes = appendClass(classes, parseValue(arg));
				}
			}
	
			return classes;
		}
	
		function parseValue (arg) {
			if (typeof arg === 'string' || typeof arg === 'number') {
				return arg;
			}
	
			if (typeof arg !== 'object') {
				return '';
			}
	
			if (Array.isArray(arg)) {
				return classNames.apply(null, arg);
			}
	
			if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
				return arg.toString();
			}
	
			var classes = '';
	
			for (var key in arg) {
				if (hasOwn.call(arg, key) && arg[key]) {
					classes = appendClass(classes, key);
				}
			}
	
			return classes;
		}
	
		function appendClass (value, newClass) {
			if (!newClass) {
				return value;
			}
		
			if (value) {
				return value + ' ' + newClass;
			}
		
			return value + newClass;
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 4 */
/***/ function(module, exports) {

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	}
	module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 5 */
/***/ function(module, exports) {

	function _extends() {
	  module.exports = _extends = Object.assign ? Object.assign.bind() : function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	    return target;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
	  return _extends.apply(this, arguments);
	}
	module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 6 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = requiredArgs;
	
	function requiredArgs(required, args) {
	  if (args.length < required) {
	    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
	  }
	}
	
	module.exports = exports.default;

/***/ },
/* 7 */
/***/ function(module, exports) {

	function _objectWithoutPropertiesLoose(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  for (var key in source) {
	    if (Object.prototype.hasOwnProperty.call(source, key)) {
	      if (excluded.indexOf(key) >= 0) continue;
	      target[key] = source[key];
	    }
	  }
	  return target;
	}
	module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.30.1
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks() {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback(callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return (
	            input instanceof Array ||
	            Object.prototype.toString.call(input) === '[object Array]'
	        );
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return (
	            input != null &&
	            Object.prototype.toString.call(input) === '[object Object]'
	        );
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return Object.getOwnPropertyNames(obj).length === 0;
	        } else {
	            var k;
	            for (k in obj) {
	                if (hasOwnProp(obj, k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return (
	            typeof input === 'number' ||
	            Object.prototype.toString.call(input) === '[object Number]'
	        );
	    }
	
	    function isDate(input) {
	        return (
	            input instanceof Date ||
	            Object.prototype.toString.call(input) === '[object Date]'
	        );
	    }
	
	    function map(arr, fn) {
	        var res = [],
	            i,
	            arrLen = arr.length;
	        for (i = 0; i < arrLen; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty: false,
	            unusedTokens: [],
	            unusedInput: [],
	            overflow: -2,
	            charsLeftOver: 0,
	            nullInput: false,
	            invalidEra: null,
	            invalidMonth: null,
	            invalidFormat: false,
	            userInvalidated: false,
	            iso: false,
	            parsedDateParts: [],
	            era: null,
	            meridiem: null,
	            rfc2822: false,
	            weekdayMismatch: false,
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this),
	                len = t.length >>> 0,
	                i;
	
	            for (i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        var flags = null,
	            parsedParts = false,
	            isNowValid = m._d && !isNaN(m._d.getTime());
	        if (isNowValid) {
	            flags = getParsingFlags(m);
	            parsedParts = some.call(flags.parsedDateParts, function (i) {
	                return i != null;
	            });
	            isNowValid =
	                flags.overflow < 0 &&
	                !flags.empty &&
	                !flags.invalidEra &&
	                !flags.invalidMonth &&
	                !flags.invalidWeekday &&
	                !flags.weekdayMismatch &&
	                !flags.nullInput &&
	                !flags.invalidFormat &&
	                !flags.userInvalidated &&
	                (!flags.meridiem || (flags.meridiem && parsedParts));
	            if (m._strict) {
	                isNowValid =
	                    isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	        }
	        if (Object.isFrozen == null || !Object.isFrozen(m)) {
	            m._isValid = isNowValid;
	        } else {
	            return isNowValid;
	        }
	        return m._isValid;
	    }
	
	    function createInvalid(flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        } else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = (hooks.momentProperties = []),
	        updateInProgress = false;
	
	    function copyConfig(to, from) {
	        var i,
	            prop,
	            val,
	            momentPropertiesLen = momentProperties.length;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentPropertiesLen > 0) {
	            for (i = 0; i < momentPropertiesLen; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment(obj) {
	        return (
	            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
	        );
	    }
	
	    function warn(msg) {
	        if (
	            hooks.suppressDeprecationWarnings === false &&
	            typeof console !== 'undefined' &&
	            console.warn
	        ) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [],
	                    arg,
	                    i,
	                    key,
	                    argLen = arguments.length;
	                for (i = 0; i < argLen; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (key in arguments[0]) {
	                            if (hasOwnProp(arguments[0], key)) {
	                                arg += key + ': ' + arguments[0][key] + ', ';
	                            }
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(
	                    msg +
	                        '\nArguments: ' +
	                        Array.prototype.slice.call(args).join('') +
	                        '\n' +
	                        new Error().stack
	                );
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    function set(config) {
	        var prop, i;
	        for (i in config) {
	            if (hasOwnProp(config, i)) {
	                prop = config[i];
	                if (isFunction(prop)) {
	                    this[i] = prop;
	                } else {
	                    this['_' + i] = prop;
	                }
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' +
	                /\d{1,2}/.source
	        );
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig),
	            prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (
	                hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])
	            ) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i,
	                res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay: '[Today at] LT',
	        nextDay: '[Tomorrow at] LT',
	        nextWeek: 'dddd [at] LT',
	        lastDay: '[Yesterday at] LT',
	        lastWeek: '[Last] dddd [at] LT',
	        sameElse: 'L',
	    };
	
	    function calendar(key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (
	            (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
	            absNumber
	        );
	    }
	
	    var formattingTokens =
	            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
	        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
	        formatFunctions = {},
	        formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken(token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(
	                    func.apply(this, arguments),
	                    token
	                );
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens),
	            i,
	            length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '',
	                i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i])
	                    ? array[i].call(mom, format)
	                    : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] =
	            formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(
	                localFormattingTokens,
	                replaceLongDateFormatTokens
	            );
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var defaultLongDateFormat = {
	        LTS: 'h:mm:ss A',
	        LT: 'h:mm A',
	        L: 'MM/DD/YYYY',
	        LL: 'MMMM D, YYYY',
	        LLL: 'MMMM D, YYYY h:mm A',
	        LLLL: 'dddd, MMMM D, YYYY h:mm A',
	    };
	
	    function longDateFormat(key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper
	            .match(formattingTokens)
	            .map(function (tok) {
	                if (
	                    tok === 'MMMM' ||
	                    tok === 'MM' ||
	                    tok === 'DD' ||
	                    tok === 'dddd'
	                ) {
	                    return tok.slice(1);
	                }
	                return tok;
	            })
	            .join('');
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate() {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d',
	        defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal(number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future: 'in %s',
	        past: '%s ago',
	        s: 'a few seconds',
	        ss: '%d seconds',
	        m: 'a minute',
	        mm: '%d minutes',
	        h: 'an hour',
	        hh: '%d hours',
	        d: 'a day',
	        dd: '%d days',
	        w: 'a week',
	        ww: '%d weeks',
	        M: 'a month',
	        MM: '%d months',
	        y: 'a year',
	        yy: '%d years',
	    };
	
	    function relativeTime(number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return isFunction(output)
	            ? output(number, withoutSuffix, string, isFuture)
	            : output.replace(/%d/i, number);
	    }
	
	    function pastFuture(diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {
	        D: 'date',
	        dates: 'date',
	        date: 'date',
	        d: 'day',
	        days: 'day',
	        day: 'day',
	        e: 'weekday',
	        weekdays: 'weekday',
	        weekday: 'weekday',
	        E: 'isoWeekday',
	        isoweekdays: 'isoWeekday',
	        isoweekday: 'isoWeekday',
	        DDD: 'dayOfYear',
	        dayofyears: 'dayOfYear',
	        dayofyear: 'dayOfYear',
	        h: 'hour',
	        hours: 'hour',
	        hour: 'hour',
	        ms: 'millisecond',
	        milliseconds: 'millisecond',
	        millisecond: 'millisecond',
	        m: 'minute',
	        minutes: 'minute',
	        minute: 'minute',
	        M: 'month',
	        months: 'month',
	        month: 'month',
	        Q: 'quarter',
	        quarters: 'quarter',
	        quarter: 'quarter',
	        s: 'second',
	        seconds: 'second',
	        second: 'second',
	        gg: 'weekYear',
	        weekyears: 'weekYear',
	        weekyear: 'weekYear',
	        GG: 'isoWeekYear',
	        isoweekyears: 'isoWeekYear',
	        isoweekyear: 'isoWeekYear',
	        w: 'week',
	        weeks: 'week',
	        week: 'week',
	        W: 'isoWeek',
	        isoweeks: 'isoWeek',
	        isoweek: 'isoWeek',
	        y: 'year',
	        years: 'year',
	        year: 'year',
	    };
	
	    function normalizeUnits(units) {
	        return typeof units === 'string'
	            ? aliases[units] || aliases[units.toLowerCase()]
	            : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {
	        date: 9,
	        day: 11,
	        weekday: 11,
	        isoWeekday: 11,
	        dayOfYear: 4,
	        hour: 13,
	        millisecond: 16,
	        minute: 14,
	        month: 8,
	        quarter: 7,
	        second: 15,
	        weekYear: 1,
	        isoWeekYear: 1,
	        week: 5,
	        isoWeek: 5,
	        year: 1,
	    };
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [],
	            u;
	        for (u in unitsObj) {
	            if (hasOwnProp(unitsObj, u)) {
	                units.push({ unit: u, priority: priorities[u] });
	            }
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    var match1 = /\d/, //       0 - 9
	        match2 = /\d\d/, //      00 - 99
	        match3 = /\d{3}/, //     000 - 999
	        match4 = /\d{4}/, //    0000 - 9999
	        match6 = /[+-]?\d{6}/, // -999999 - 999999
	        match1to2 = /\d\d?/, //       0 - 99
	        match3to4 = /\d\d\d\d?/, //     999 - 9999
	        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
	        match1to3 = /\d{1,3}/, //       0 - 999
	        match1to4 = /\d{1,4}/, //       0 - 9999
	        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
	        matchUnsigned = /\d+/, //       0 - inf
	        matchSigned = /[+-]?\d+/, //    -inf - inf
	        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
	        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
	        // any word (or two) characters or numbers including two/three word month in arabic.
	        // includes scottish gaelic two word and hyphenated months
	        matchWord =
	            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
	        match1to2NoLeadingZero = /^[1-9]\d?/, //         1-99
	        match1to2HasZero = /^([1-9]\d|\d)/, //           0-99
	        regexes;
	
	    regexes = {};
	
	    function addRegexToken(token, regex, strictRegex) {
	        regexes[token] = isFunction(regex)
	            ? regex
	            : function (isStrict, localeData) {
	                  return isStrict && strictRegex ? strictRegex : regex;
	              };
	    }
	
	    function getParseRegexForToken(token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(
	            s
	                .replace('\\', '')
	                .replace(
	                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
	                    function (matched, p1, p2, p3, p4) {
	                        return p1 || p2 || p3 || p4;
	                    }
	                )
	        );
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    function absFloor(number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    var tokens = {};
	
	    function addParseToken(token, callback) {
	        var i,
	            func = callback,
	            tokenLen;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        tokenLen = token.length;
	        for (i = 0; i < tokenLen; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken(token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    var YEAR = 0,
	        MONTH = 1,
	        DATE = 2,
	        HOUR = 3,
	        MINUTE = 4,
	        SECOND = 5,
	        MILLISECOND = 6,
	        WEEK = 7,
	        WEEKDAY = 8;
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY', 4], 0, 'year');
	    addFormatToken(0, ['YYYYY', 5], 0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // PARSING
	
	    addRegexToken('Y', matchSigned);
	    addRegexToken('YY', match1to2, match2);
	    addRegexToken('YYYY', match1to4, match4);
	    addRegexToken('YYYYY', match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] =
	            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear() {
	        return isLeapYear(this.year());
	    }
	
	    function makeGetSet(unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get(mom, unit) {
	        if (!mom.isValid()) {
	            return NaN;
	        }
	
	        var d = mom._d,
	            isUTC = mom._isUTC;
	
	        switch (unit) {
	            case 'Milliseconds':
	                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
	            case 'Seconds':
	                return isUTC ? d.getUTCSeconds() : d.getSeconds();
	            case 'Minutes':
	                return isUTC ? d.getUTCMinutes() : d.getMinutes();
	            case 'Hours':
	                return isUTC ? d.getUTCHours() : d.getHours();
	            case 'Date':
	                return isUTC ? d.getUTCDate() : d.getDate();
	            case 'Day':
	                return isUTC ? d.getUTCDay() : d.getDay();
	            case 'Month':
	                return isUTC ? d.getUTCMonth() : d.getMonth();
	            case 'FullYear':
	                return isUTC ? d.getUTCFullYear() : d.getFullYear();
	            default:
	                return NaN; // Just in case
	        }
	    }
	
	    function set$1(mom, unit, value) {
	        var d, isUTC, year, month, date;
	
	        if (!mom.isValid() || isNaN(value)) {
	            return;
	        }
	
	        d = mom._d;
	        isUTC = mom._isUTC;
	
	        switch (unit) {
	            case 'Milliseconds':
	                return void (isUTC
	                    ? d.setUTCMilliseconds(value)
	                    : d.setMilliseconds(value));
	            case 'Seconds':
	                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
	            case 'Minutes':
	                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
	            case 'Hours':
	                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
	            case 'Date':
	                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
	            // case 'Day': // Not real
	            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
	            // case 'Month': // Not used because we need to pass two variables
	            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
	            case 'FullYear':
	                break; // See below ...
	            default:
	                return; // Just in case
	        }
	
	        year = value;
	        month = mom.month();
	        date = mom.date();
	        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
	        void (isUTC
	            ? d.setUTCFullYear(year, month, date)
	            : d.setFullYear(year, month, date));
	    }
	
	    // MOMENTS
	
	    function stringGet(units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	    function stringSet(units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units),
	                i,
	                prioritizedLen = prioritized.length;
	            for (i = 0; i < prioritizedLen; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1
	            ? isLeapYear(year)
	                ? 29
	                : 28
	            : 31 - ((modMonth % 7) % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // PARSING
	
	    addRegexToken('M', match1to2, match1to2NoLeadingZero);
	    addRegexToken('MM', match1to2, match2);
	    addRegexToken('MMM', function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var defaultLocaleMonths =
	            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	                '_'
	            ),
	        defaultLocaleMonthsShort =
	            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
	        defaultMonthsShortRegex = matchWord,
	        defaultMonthsRegex = matchWord;
	
	    function localeMonths(m, format) {
	        if (!m) {
	            return isArray(this._months)
	                ? this._months
	                : this._months['standalone'];
	        }
	        return isArray(this._months)
	            ? this._months[m.month()]
	            : this._months[
	                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
	                      ? 'format'
	                      : 'standalone'
	              ][m.month()];
	    }
	
	    function localeMonthsShort(m, format) {
	        if (!m) {
	            return isArray(this._monthsShort)
	                ? this._monthsShort
	                : this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort)
	            ? this._monthsShort[m.month()]
	            : this._monthsShort[
	                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
	              ][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse(monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp(
	                    '^' + this.months(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	                this._shortMonthsParse[i] = new RegExp(
	                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex =
	                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'MMMM' &&
	                this._longMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'MMM' &&
	                this._shortMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth(mom, value) {
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        var month = value,
	            date = mom.date();
	
	        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
	        void (mom._isUTC
	            ? mom._d.setUTCMonth(month, date)
	            : mom._d.setMonth(month, date));
	        return mom;
	    }
	
	    function getSetMonth(value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth() {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    function monthsShortRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict
	                ? this._monthsShortStrictRegex
	                : this._monthsShortRegex;
	        }
	    }
	
	    function monthsRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict
	                ? this._monthsStrictRegex
	                : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom,
	            shortP,
	            longP;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortP = regexEscape(this.monthsShort(mom, ''));
	            longP = regexEscape(this.months(mom, ''));
	            shortPieces.push(shortP);
	            longPieces.push(longP);
	            mixedPieces.push(longP);
	            mixedPieces.push(shortP);
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._monthsShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    function createDate(y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date;
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            date = new Date(y + 400, m, d, h, M, s, ms);
	            if (isFinite(date.getFullYear())) {
	                date.setFullYear(y);
	            }
	        } else {
	            date = new Date(y, m, d, h, M, s, ms);
	        }
	
	        return date;
	    }
	
	    function createUTCDate(y) {
	        var date, args;
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            args = Array.prototype.slice.call(arguments);
	            // preserve leap years using a full 400 year cycle, then reset
	            args[0] = y + 400;
	            date = new Date(Date.UTC.apply(null, args));
	            if (isFinite(date.getUTCFullYear())) {
	                date.setUTCFullYear(y);
	            }
	        } else {
	            date = new Date(Date.UTC.apply(null, arguments));
	        }
	
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear,
	            resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear,
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek,
	            resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear,
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // PARSING
	
	    addRegexToken('w', match1to2, match1to2NoLeadingZero);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W', match1to2, match1to2NoLeadingZero);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(
	        ['w', 'ww', 'W', 'WW'],
	        function (input, week, config, token) {
	            week[token.substr(0, 1)] = toInt(input);
	        }
	    );
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek(mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow: 0, // Sunday is the first day of the week.
	        doy: 6, // The week that contains Jan 6th is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek() {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear() {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek(input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek(input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // PARSING
	
	    addRegexToken('d', match1to2);
	    addRegexToken('e', match1to2);
	    addRegexToken('E', match1to2);
	    addRegexToken('dd', function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd', function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd', function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	    function shiftWeekdays(ws, n) {
	        return ws.slice(n, 7).concat(ws.slice(0, n));
	    }
	
	    var defaultLocaleWeekdays =
	            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        defaultWeekdaysRegex = matchWord,
	        defaultWeekdaysShortRegex = matchWord,
	        defaultWeekdaysMinRegex = matchWord;
	
	    function localeWeekdays(m, format) {
	        var weekdays = isArray(this._weekdays)
	            ? this._weekdays
	            : this._weekdays[
	                  m && m !== true && this._weekdays.isFormat.test(format)
	                      ? 'format'
	                      : 'standalone'
	              ];
	        return m === true
	            ? shiftWeekdays(weekdays, this._week.dow)
	            : m
	              ? weekdays[m.day()]
	              : weekdays;
	    }
	
	    function localeWeekdaysShort(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
	            : m
	              ? this._weekdaysShort[m.day()]
	              : this._weekdaysShort;
	    }
	
	    function localeWeekdaysMin(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
	            : m
	              ? this._weekdaysMin[m.day()]
	              : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse(weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._shortWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._minWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	            }
	            if (!this._weekdaysParse[i]) {
	                regex =
	                    '^' +
	                    this.weekdays(mom, '') +
	                    '|^' +
	                    this.weekdaysShort(mom, '') +
	                    '|^' +
	                    this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'dddd' &&
	                this._fullWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'ddd' &&
	                this._shortWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'dd' &&
	                this._minWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        var day = get(this, 'Day');
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    function weekdaysRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict
	                ? this._weekdaysStrictRegex
	                : this._weekdaysRegex;
	        }
	    }
	
	    function weekdaysShortRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict
	                ? this._weekdaysShortStrictRegex
	                : this._weekdaysShortRegex;
	        }
	    }
	
	    function weekdaysMinRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict
	                ? this._weekdaysMinStrictRegex
	                : this._weekdaysMinRegex;
	        }
	    }
	
	    function computeWeekdaysParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [],
	            shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom,
	            minp,
	            shortp,
	            longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = regexEscape(this.weekdaysMin(mom, ''));
	            shortp = regexEscape(this.weekdaysShort(mom, ''));
	            longp = regexEscape(this.weekdays(mom, ''));
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysMinStrictRegex = new RegExp(
	            '^(' + minPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return (
	            '' +
	            hFormat.apply(this) +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return (
	            '' +
	            this.hours() +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    function meridiem(token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(
	                this.hours(),
	                this.minutes(),
	                lowercase
	            );
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // PARSING
	
	    function matchMeridiem(isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a', matchMeridiem);
	    addRegexToken('A', matchMeridiem);
	    addRegexToken('H', match1to2, match1to2HasZero);
	    addRegexToken('h', match1to2, match1to2NoLeadingZero);
	    addRegexToken('k', match1to2, match1to2NoLeadingZero);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM(input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return (input + '').toLowerCase().charAt(0) === 'p';
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
	        // Setting the hour should keep the time, because the user explicitly
	        // specified which hour they want. So trying to maintain the same hour (in
	        // a new timezone) makes sense. Adding/subtracting hours does not follow
	        // this rule.
	        getSetHour = makeGetSet('Hours', true);
	
	    function localeMeridiem(hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse,
	    };
	
	    // internal storage for locale config files
	    var locales = {},
	        localeFamilies = {},
	        globalLocale;
	
	    function commonPrefix(arr1, arr2) {
	        var i,
	            minl = Math.min(arr1.length, arr2.length);
	        for (i = 0; i < minl; i += 1) {
	            if (arr1[i] !== arr2[i]) {
	                return i;
	            }
	        }
	        return minl;
	    }
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0,
	            j,
	            next,
	            locale,
	            split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (
	                    next &&
	                    next.length >= j &&
	                    commonPrefix(split, next) >= j - 1
	                ) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function isLocaleNameSane(name) {
	        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
	        // Ensure name is available and function returns boolean
	        return !!(name && name.match('^[^/\\\\]*$'));
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null,
	            aliasedRequire;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (
	            locales[name] === undefined &&
	            typeof module !== 'undefined' &&
	            module &&
	            module.exports &&
	            isLocaleNameSane(name)
	        ) {
	            try {
	                oldLocale = globalLocale._abbr;
	                aliasedRequire = require;
	                __webpack_require__(2190)("./" + name);
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {
	                // mark as not found to avoid repeating expensive file require call causing high CPU
	                // when trying to find en-US, en_US, en-us for every format call
	                locales[name] = null; // null means not found
	            }
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale(key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            } else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            } else {
	                if (typeof console !== 'undefined' && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn(
	                        'Locale ' + key + ' not found. Did you forget to load it?'
	                    );
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale(name, config) {
	        if (config !== null) {
	            var locale,
	                parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple(
	                    'defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
	                );
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config,
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale,
	                tmpLocale,
	                parentConfig = baseConfig;
	
	            if (locales[name] != null && locales[name].parentLocale != null) {
	                // Update existing child locale in-place to avoid memory-leaks
	                locales[name].set(mergeConfigs(locales[name]._config, config));
	            } else {
	                // MERGE
	                tmpLocale = loadLocale(name);
	                if (tmpLocale != null) {
	                    parentConfig = tmpLocale._config;
	                }
	                config = mergeConfigs(parentConfig, config);
	                if (tmpLocale == null) {
	                    // updateLocale is called for creating a new locale
	                    // Set abbr so it will have a name (getters return
	                    // undefined otherwise).
	                    config.abbr = name;
	                }
	                locale = new Locale(config);
	                locale.parentLocale = locales[name];
	                locales[name] = locale;
	            }
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                    if (name === getSetGlobalLocale()) {
	                        getSetGlobalLocale(name);
	                    }
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale(key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow(m) {
	        var overflow,
	            a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH] < 0 || a[MONTH] > 11
	                    ? MONTH
	                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
	                      ? DATE
	                      : a[HOUR] < 0 ||
	                          a[HOUR] > 24 ||
	                          (a[HOUR] === 24 &&
	                              (a[MINUTE] !== 0 ||
	                                  a[SECOND] !== 0 ||
	                                  a[MILLISECOND] !== 0))
	                        ? HOUR
	                        : a[MINUTE] < 0 || a[MINUTE] > 59
	                          ? MINUTE
	                          : a[SECOND] < 0 || a[SECOND] > 59
	                            ? SECOND
	                            : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
	                              ? MILLISECOND
	                              : -1;
	
	            if (
	                getParsingFlags(m)._overflowDayOfYear &&
	                (overflow < YEAR || overflow > DATE)
	            ) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex =
	            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        basicIsoRegex =
	            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
	        isoDates = [
	            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	            ['YYYY-DDD', /\d{4}-\d{3}/],
	            ['YYYY-MM', /\d{4}-\d\d/, false],
	            ['YYYYYYMMDD', /[+-]\d{10}/],
	            ['YYYYMMDD', /\d{8}/],
	            ['GGGG[W]WWE', /\d{4}W\d{3}/],
	            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	            ['YYYYDDD', /\d{7}/],
	            ['YYYYMM', /\d{6}/, false],
	            ['YYYY', /\d{4}/, false],
	        ],
	        // iso time formats and regexes
	        isoTimes = [
	            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	            ['HH:mm', /\d\d:\d\d/],
	            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	            ['HHmmss', /\d\d\d\d\d\d/],
	            ['HHmm', /\d\d\d\d/],
	            ['HH', /\d\d/],
	        ],
	        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
	        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	        rfc2822 =
	            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
	        obsOffsets = {
	            UT: 0,
	            GMT: 0,
	            EDT: -4 * 60,
	            EST: -5 * 60,
	            CDT: -5 * 60,
	            CST: -6 * 60,
	            MDT: -6 * 60,
	            MST: -7 * 60,
	            PDT: -7 * 60,
	            PST: -8 * 60,
	        };
	
	    // date from iso format
	    function configFromISO(config) {
	        var i,
	            l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime,
	            dateFormat,
	            timeFormat,
	            tzFormat,
	            isoDatesLen = isoDates.length,
	            isoTimesLen = isoTimes.length;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	            for (i = 0, l = isoDatesLen; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimesLen; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    function extractFromRFC2822Strings(
	        yearStr,
	        monthStr,
	        dayStr,
	        hourStr,
	        minuteStr,
	        secondStr
	    ) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10),
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s
	            .replace(/\([^()]*\)|[\n\t]/g, ' ')
	            .replace(/(\s\s+)/g, ' ')
	            .replace(/^\s\s*/, '')
	            .replace(/\s\s*$/, '');
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(
	                    parsedInput[0],
	                    parsedInput[1],
	                    parsedInput[2]
	                ).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10),
	                m = hm % 100,
	                h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i)),
	            parsedArray;
	        if (match) {
	            parsedArray = extractFromRFC2822Strings(
	                match[4],
	                match[3],
	                match[2],
	                match[5],
	                match[6],
	                match[7]
	            );
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        if (config._strict) {
	            config._isValid = false;
	        } else {
	            // Final attempt, use Input Fallback
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [
	                nowValue.getUTCFullYear(),
	                nowValue.getUTCMonth(),
	                nowValue.getUTCDate(),
	            ];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray(config) {
	        var i,
	            date,
	            input = [],
	            currentDate,
	            expectedWeekday,
	            yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (
	                config._dayOfYear > daysInYear(yearToUse) ||
	                config._dayOfYear === 0
	            ) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] =
	                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (
	            config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0
	        ) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(
	            null,
	            input
	        );
	        expectedWeekday = config._useUTC
	            ? config._d.getUTCDay()
	            : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (
	            config._w &&
	            typeof config._w.d !== 'undefined' &&
	            config._w.d !== expectedWeekday
	        ) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(
	                w.GG,
	                config._a[YEAR],
	                weekOfYear(createLocal(), 1, 4).year
	            );
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from beginning of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to beginning of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i,
	            parsedInput,
	            tokens,
	            token,
	            skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0,
	            era,
	            tokenLen;
	
	        tokens =
	            expandFormat(config._f, config._locale).match(formattingTokens) || [];
	        tokenLen = tokens.length;
	        for (i = 0; i < tokenLen; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
	                [])[0];
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(
	                    string.indexOf(parsedInput) + parsedInput.length
	                );
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                } else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            } else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver =
	            stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (
	            config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0
	        ) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(
	            config._locale,
	            config._a[HOUR],
	            config._meridiem
	        );
	
	        // handle era
	        era = getParsingFlags(config).era;
	        if (era !== null) {
	            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
	        }
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	    function meridiemFixWrap(locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	            scoreToBeat,
	            i,
	            currentScore,
	            validFormatFound,
	            bestFormatIsValid = false,
	            configfLen = config._f.length;
	
	        if (configfLen === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < configfLen; i++) {
	            currentScore = 0;
	            validFormatFound = false;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (isValid(tempConfig)) {
	                validFormatFound = true;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (!bestFormatIsValid) {
	                if (
	                    scoreToBeat == null ||
	                    currentScore < scoreToBeat ||
	                    validFormatFound
	                ) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                    if (validFormatFound) {
	                        bestFormatIsValid = true;
	                    }
	                }
	            } else {
	                if (currentScore < scoreToBeat) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                }
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i),
	            dayOrDate = i.day === undefined ? i.date : i.day;
	        config._a = map(
	            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
	            function (obj) {
	                return obj && parseInt(obj, 10);
	            }
	        );
	
	        configFromArray(config);
	    }
	
	    function createFromConfig(config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig(config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({ nullInput: true });
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        } else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC(input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (format === true || format === false) {
	            strict = format;
	            format = undefined;
	        }
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if (
	            (isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)
	        ) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other < this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        ),
	        prototypeMax = deprecate(
	            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other > this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +new Date();
	    };
	
	    var ordering = [
	        'year',
	        'quarter',
	        'month',
	        'week',
	        'day',
	        'hour',
	        'minute',
	        'second',
	        'millisecond',
	    ];
	
	    function isDurationValid(m) {
	        var key,
	            unitHasDecimal = false,
	            i,
	            orderLen = ordering.length;
	        for (key in m) {
	            if (
	                hasOwnProp(m, key) &&
	                !(
	                    indexOf.call(ordering, key) !== -1 &&
	                    (m[key] == null || !isNaN(m[key]))
	                )
	            ) {
	                return false;
	            }
	        }
	
	        for (i = 0; i < orderLen; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration(duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds =
	            +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days + weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months + quarters * 3 + years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration(obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound(number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if (
	                (dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
	            ) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    // FORMATTING
	
	    function offset(token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset(),
	                sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return (
	                sign +
	                zeroFill(~~(offset / 60), 2) +
	                separator +
	                zeroFill(~~offset % 60, 2)
	            );
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z', matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher),
	            chunk,
	            parts,
	            minutes;
	
	        if (matches === null) {
	            return null;
	        }
	
	        chunk = matches[matches.length - 1] || [];
	        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff =
	                (isMoment(input) || isDate(input)
	                    ? input.valueOf()
	                    : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset(m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset());
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset(input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(
	                        this,
	                        createDuration(input - offset, 'm'),
	                        1,
	                        false
	                    );
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone(input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC(keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal(keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset() {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            } else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset(input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime() {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted() {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {},
	            other;
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted =
	                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal() {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset() {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc() {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
	        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	        // and further modified to allow for strings containing both week and day
	        isoRegex =
	            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration(input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms: input._milliseconds,
	                d: input._days,
	                M: input._months,
	            };
	        } else if (isNumber(input) || !isNaN(+input)) {
	            duration = {};
	            if (key) {
	                duration[key] = +input;
	            } else {
	                duration.milliseconds = +input;
	            }
	        } else if ((match = aspNetRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: 0,
	                d: toInt(match[DATE]) * sign,
	                h: toInt(match[HOUR]) * sign,
	                m: toInt(match[MINUTE]) * sign,
	                s: toInt(match[SECOND]) * sign,
	                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
	            };
	        } else if ((match = isoRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: parseIso(match[2], sign),
	                M: parseIso(match[3], sign),
	                w: parseIso(match[4], sign),
	                d: parseIso(match[5], sign),
	                h: parseIso(match[6], sign),
	                m: parseIso(match[7], sign),
	                s: parseIso(match[8], sign),
	            };
	        } else if (duration == null) {
	            // checks for null or undefined
	            duration = {};
	        } else if (
	            typeof duration === 'object' &&
	            ('from' in duration || 'to' in duration)
	        ) {
	            diffRes = momentsDifference(
	                createLocal(duration.from),
	                createLocal(duration.to)
	            );
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
	            ret._isValid = input._isValid;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso(inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {};
	
	        res.months =
	            other.month() - base.month() + (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +base.clone().add(res.months, 'M');
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return { milliseconds: 0, months: 0 };
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(
	                    name,
	                    'moment().' +
	                        name +
	                        '(period, number) is deprecated. Please use moment().' +
	                        name +
	                        '(number, period). ' +
	                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
	                );
	                tmp = val;
	                val = period;
	                period = tmp;
	            }
	
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract(mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add = createAdder(1, 'add'),
	        subtract = createAdder(-1, 'subtract');
	
	    function isString(input) {
	        return typeof input === 'string' || input instanceof String;
	    }
	
	    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
	    function isMomentInput(input) {
	        return (
	            isMoment(input) ||
	            isDate(input) ||
	            isString(input) ||
	            isNumber(input) ||
	            isNumberOrStringArray(input) ||
	            isMomentInputObject(input) ||
	            input === null ||
	            input === undefined
	        );
	    }
	
	    function isMomentInputObject(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'years',
	                'year',
	                'y',
	                'months',
	                'month',
	                'M',
	                'days',
	                'day',
	                'd',
	                'dates',
	                'date',
	                'D',
	                'hours',
	                'hour',
	                'h',
	                'minutes',
	                'minute',
	                'm',
	                'seconds',
	                'second',
	                's',
	                'milliseconds',
	                'millisecond',
	                'ms',
	            ],
	            i,
	            property,
	            propertyLen = properties.length;
	
	        for (i = 0; i < propertyLen; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function isNumberOrStringArray(input) {
	        var arrayTest = isArray(input),
	            dataTypeTest = false;
	        if (arrayTest) {
	            dataTypeTest =
	                input.filter(function (item) {
	                    return !isNumber(item) && isString(input);
	                }).length === 0;
	        }
	        return arrayTest && dataTypeTest;
	    }
	
	    function isCalendarSpec(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'sameDay',
	                'nextDay',
	                'lastDay',
	                'nextWeek',
	                'lastWeek',
	                'sameElse',
	            ],
	            i,
	            property;
	
	        for (i = 0; i < properties.length; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6
	            ? 'sameElse'
	            : diff < -1
	              ? 'lastWeek'
	              : diff < 0
	                ? 'lastDay'
	                : diff < 1
	                  ? 'sameDay'
	                  : diff < 2
	                    ? 'nextDay'
	                    : diff < 7
	                      ? 'nextWeek'
	                      : 'sameElse';
	    }
	
	    function calendar$1(time, formats) {
	        // Support for single parameter, formats only overload to the calendar function
	        if (arguments.length === 1) {
	            if (!arguments[0]) {
	                time = undefined;
	                formats = undefined;
	            } else if (isMomentInput(arguments[0])) {
	                time = arguments[0];
	                formats = undefined;
	            } else if (isCalendarSpec(arguments[0])) {
	                formats = arguments[0];
	                time = undefined;
	            }
	        }
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse',
	            output =
	                formats &&
	                (isFunction(formats[format])
	                    ? formats[format].call(this, now)
	                    : formats[format]);
	
	        return this.format(
	            output || this.localeData().calendar(format, this, createLocal(now))
	        );
	    }
	
	    function clone() {
	        return new Moment(this);
	    }
	
	    function isAfter(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween(from, to, units, inclusivity) {
	        var localFrom = isMoment(from) ? from : createLocal(from),
	            localTo = isMoment(to) ? to : createLocal(to);
	        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	            return false;
	        }
	        inclusivity = inclusivity || '()';
	        return (
	            (inclusivity[0] === '('
	                ? this.isAfter(localFrom, units)
	                : !this.isBefore(localFrom, units)) &&
	            (inclusivity[1] === ')'
	                ? this.isBefore(localTo, units)
	                : !this.isAfter(localTo, units))
	        );
	    }
	
	    function isSame(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return (
	                this.clone().startOf(units).valueOf() <= inputMs &&
	                inputMs <= this.clone().endOf(units).valueOf()
	            );
	        }
	    }
	
	    function isSameOrAfter(input, units) {
	        return this.isSame(input, units) || this.isAfter(input, units);
	    }
	
	    function isSameOrBefore(input, units) {
	        return this.isSame(input, units) || this.isBefore(input, units);
	    }
	
	    function diff(input, units, asFloat) {
	        var that, zoneDelta, output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year':
	                output = monthDiff(this, that) / 12;
	                break;
	            case 'month':
	                output = monthDiff(this, that);
	                break;
	            case 'quarter':
	                output = monthDiff(this, that) / 3;
	                break;
	            case 'second':
	                output = (this - that) / 1e3;
	                break; // 1000
	            case 'minute':
	                output = (this - that) / 6e4;
	                break; // 1000 * 60
	            case 'hour':
	                output = (this - that) / 36e5;
	                break; // 1000 * 60 * 60
	            case 'day':
	                output = (this - that - zoneDelta) / 864e5;
	                break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week':
	                output = (this - that - zoneDelta) / 6048e5;
	                break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default:
	                output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff(a, b) {
	        if (a.date() < b.date()) {
	            // end-of-month calculations work correct when the start month has more
	            // days than the end month.
	            return -monthDiff(b, a);
	        }
	        // difference in months
	        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2,
	            adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString() {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true,
	            m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(
	                m,
	                utc
	                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
	                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
	            );
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
	                    .toISOString()
	                    .replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(
	            m,
	            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
	        );
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect() {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment',
	            zone = '',
	            prefix,
	            year,
	            datetime,
	            suffix;
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        prefix = '[' + func + '("]';
	        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
	        datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format(inputString) {
	        if (!inputString) {
	            inputString = this.isUtc()
	                ? hooks.defaultFormatUtc
	                : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ to: this, from: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow(withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ from: this, to: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow(withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale(key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData() {
	        return this._locale;
	    }
	
	    var MS_PER_SECOND = 1000,
	        MS_PER_MINUTE = 60 * MS_PER_SECOND,
	        MS_PER_HOUR = 60 * MS_PER_MINUTE,
	        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
	
	    // actual modulo - handles negative numbers (for dates before 1970):
	    function mod$1(dividend, divisor) {
	        return ((dividend % divisor) + divisor) % divisor;
	    }
	
	    function localStartOfDate(y, m, d) {
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return new Date(y, m, d).valueOf();
	        }
	    }
	
	    function utcStartOfDate(y, m, d) {
	        // Date.UTC remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return Date.UTC(y, m, d);
	        }
	    }
	
	    function startOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year(), 0, 1);
	                break;
	            case 'quarter':
	                time = startOfDate(
	                    this.year(),
	                    this.month() - (this.month() % 3),
	                    1
	                );
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month(), 1);
	                break;
	            case 'week':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - this.weekday()
	                );
	                break;
	            case 'isoWeek':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - (this.isoWeekday() - 1)
	                );
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date());
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time -= mod$1(
	                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                    MS_PER_HOUR
	                );
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_MINUTE);
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_SECOND);
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function endOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year() + 1, 0, 1) - 1;
	                break;
	            case 'quarter':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month() - (this.month() % 3) + 3,
	                        1
	                    ) - 1;
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	                break;
	            case 'week':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - this.weekday() + 7
	                    ) - 1;
	                break;
	            case 'isoWeek':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - (this.isoWeekday() - 1) + 7
	                    ) - 1;
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time +=
	                    MS_PER_HOUR -
	                    mod$1(
	                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                        MS_PER_HOUR
	                    ) -
	                    1;
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function valueOf() {
	        return this._d.valueOf() - (this._offset || 0) * 60000;
	    }
	
	    function unix() {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate() {
	        return new Date(this.valueOf());
	    }
	
	    function toArray() {
	        var m = this;
	        return [
	            m.year(),
	            m.month(),
	            m.date(),
	            m.hour(),
	            m.minute(),
	            m.second(),
	            m.millisecond(),
	        ];
	    }
	
	    function toObject() {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds(),
	        };
	    }
	
	    function toJSON() {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2() {
	        return isValid(this);
	    }
	
	    function parsingFlags() {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt() {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict,
	        };
	    }
	
	    addFormatToken('N', 0, 0, 'eraAbbr');
	    addFormatToken('NN', 0, 0, 'eraAbbr');
	    addFormatToken('NNN', 0, 0, 'eraAbbr');
	    addFormatToken('NNNN', 0, 0, 'eraName');
	    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
	
	    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
	    addFormatToken('y', ['yy', 2], 0, 'eraYear');
	    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
	    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');
	
	    addRegexToken('N', matchEraAbbr);
	    addRegexToken('NN', matchEraAbbr);
	    addRegexToken('NNN', matchEraAbbr);
	    addRegexToken('NNNN', matchEraName);
	    addRegexToken('NNNNN', matchEraNarrow);
	
	    addParseToken(
	        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
	        function (input, array, config, token) {
	            var era = config._locale.erasParse(input, token, config._strict);
	            if (era) {
	                getParsingFlags(config).era = era;
	            } else {
	                getParsingFlags(config).invalidEra = input;
	            }
	        }
	    );
	
	    addRegexToken('y', matchUnsigned);
	    addRegexToken('yy', matchUnsigned);
	    addRegexToken('yyy', matchUnsigned);
	    addRegexToken('yyyy', matchUnsigned);
	    addRegexToken('yo', matchEraYearOrdinal);
	
	    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
	    addParseToken(['yo'], function (input, array, config, token) {
	        var match;
	        if (config._locale._eraYearOrdinalRegex) {
	            match = input.match(config._locale._eraYearOrdinalRegex);
	        }
	
	        if (config._locale.eraYearOrdinalParse) {
	            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
	        } else {
	            array[YEAR] = parseInt(input, 10);
	        }
	    });
	
	    function localeEras(m, format) {
	        var i,
	            l,
	            date,
	            eras = this._eras || getLocale('en')._eras;
	        for (i = 0, l = eras.length; i < l; ++i) {
	            switch (typeof eras[i].since) {
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].since).startOf('day');
	                    eras[i].since = date.valueOf();
	                    break;
	            }
	
	            switch (typeof eras[i].until) {
	                case 'undefined':
	                    eras[i].until = +Infinity;
	                    break;
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].until).startOf('day').valueOf();
	                    eras[i].until = date.valueOf();
	                    break;
	            }
	        }
	        return eras;
	    }
	
	    function localeErasParse(eraName, format, strict) {
	        var i,
	            l,
	            eras = this.eras(),
	            name,
	            abbr,
	            narrow;
	        eraName = eraName.toUpperCase();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            name = eras[i].name.toUpperCase();
	            abbr = eras[i].abbr.toUpperCase();
	            narrow = eras[i].narrow.toUpperCase();
	
	            if (strict) {
	                switch (format) {
	                    case 'N':
	                    case 'NN':
	                    case 'NNN':
	                        if (abbr === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNN':
	                        if (name === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNNN':
	                        if (narrow === eraName) {
	                            return eras[i];
	                        }
	                        break;
	                }
	            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
	                return eras[i];
	            }
	        }
	    }
	
	    function localeErasConvertYear(era, year) {
	        var dir = era.since <= era.until ? +1 : -1;
	        if (year === undefined) {
	            return hooks(era.since).year();
	        } else {
	            return hooks(era.since).year() + (year - era.offset) * dir;
	        }
	    }
	
	    function getEraName() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].name;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].name;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraNarrow() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].narrow;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].narrow;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraAbbr() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].abbr;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].abbr;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraYear() {
	        var i,
	            l,
	            dir,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            dir = eras[i].since <= eras[i].until ? +1 : -1;
	
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (
	                (eras[i].since <= val && val <= eras[i].until) ||
	                (eras[i].until <= val && val <= eras[i].since)
	            ) {
	                return (
	                    (this.year() - hooks(eras[i].since).year()) * dir +
	                    eras[i].offset
	                );
	            }
	        }
	
	        return this.year();
	    }
	
	    function erasNameRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNameRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNameRegex : this._erasRegex;
	    }
	
	    function erasAbbrRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasAbbrRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasAbbrRegex : this._erasRegex;
	    }
	
	    function erasNarrowRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNarrowRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNarrowRegex : this._erasRegex;
	    }
	
	    function matchEraAbbr(isStrict, locale) {
	        return locale.erasAbbrRegex(isStrict);
	    }
	
	    function matchEraName(isStrict, locale) {
	        return locale.erasNameRegex(isStrict);
	    }
	
	    function matchEraNarrow(isStrict, locale) {
	        return locale.erasNarrowRegex(isStrict);
	    }
	
	    function matchEraYearOrdinal(isStrict, locale) {
	        return locale._eraYearOrdinalRegex || matchUnsigned;
	    }
	
	    function computeErasParse() {
	        var abbrPieces = [],
	            namePieces = [],
	            narrowPieces = [],
	            mixedPieces = [],
	            i,
	            l,
	            erasName,
	            erasAbbr,
	            erasNarrow,
	            eras = this.eras();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            erasName = regexEscape(eras[i].name);
	            erasAbbr = regexEscape(eras[i].abbr);
	            erasNarrow = regexEscape(eras[i].narrow);
	
	            namePieces.push(erasName);
	            abbrPieces.push(erasAbbr);
	            narrowPieces.push(erasNarrow);
	            mixedPieces.push(erasName);
	            mixedPieces.push(erasAbbr);
	            mixedPieces.push(erasNarrow);
	        }
	
	        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
	        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
	        this._erasNarrowRegex = new RegExp(
	            '^(' + narrowPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken(token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg', 'weekYear');
	    addWeekYearFormatToken('ggggg', 'weekYear');
	    addWeekYearFormatToken('GGGG', 'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    // PARSING
	
	    addRegexToken('G', matchSigned);
	    addRegexToken('g', matchSigned);
	    addRegexToken('GG', match1to2, match2);
	    addRegexToken('gg', match1to2, match2);
	    addRegexToken('GGGG', match1to4, match4);
	    addRegexToken('gggg', match1to4, match4);
	    addRegexToken('GGGGG', match1to6, match6);
	    addRegexToken('ggggg', match1to6, match6);
	
	    addWeekParseToken(
	        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
	        function (input, week, config, token) {
	            week[token.substr(0, 2)] = toInt(input);
	        }
	    );
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.week(),
	            this.weekday() + this.localeData()._week.dow,
	            this.localeData()._week.dow,
	            this.localeData()._week.doy
	        );
	    }
	
	    function getSetISOWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.isoWeek(),
	            this.isoWeekday(),
	            1,
	            4
	        );
	    }
	
	    function getISOWeeksInYear() {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getISOWeeksInISOWeekYear() {
	        return weeksInYear(this.isoWeekYear(), 1, 4);
	    }
	
	    function getWeeksInYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getWeeksInWeekYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter(input) {
	        return input == null
	            ? Math.ceil((this.month() + 1) / 3)
	            : this.month((input - 1) * 3 + (this.month() % 3));
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // PARSING
	
	    addRegexToken('D', match1to2, match1to2NoLeadingZero);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict
	            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
	            : locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // PARSING
	
	    addRegexToken('DDD', match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear(input) {
	        var dayOfYear =
	            Math.round(
	                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
	            ) + 1;
	        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // PARSING
	
	    addRegexToken('m', match1to2, match1to2HasZero);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // PARSING
	
	    addRegexToken('s', match1to2, match1to2HasZero);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	    // PARSING
	
	    addRegexToken('S', match1to3, match1);
	    addRegexToken('SS', match1to3, match2);
	    addRegexToken('SSS', match1to3, match3);
	
	    var token, getSetMillisecond;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	
	    getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z', 0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr() {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName() {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add = add;
	    proto.calendar = calendar$1;
	    proto.clone = clone;
	    proto.diff = diff;
	    proto.endOf = endOf;
	    proto.format = format;
	    proto.from = from;
	    proto.fromNow = fromNow;
	    proto.to = to;
	    proto.toNow = toNow;
	    proto.get = stringGet;
	    proto.invalidAt = invalidAt;
	    proto.isAfter = isAfter;
	    proto.isBefore = isBefore;
	    proto.isBetween = isBetween;
	    proto.isSame = isSame;
	    proto.isSameOrAfter = isSameOrAfter;
	    proto.isSameOrBefore = isSameOrBefore;
	    proto.isValid = isValid$2;
	    proto.lang = lang;
	    proto.locale = locale;
	    proto.localeData = localeData;
	    proto.max = prototypeMax;
	    proto.min = prototypeMin;
	    proto.parsingFlags = parsingFlags;
	    proto.set = stringSet;
	    proto.startOf = startOf;
	    proto.subtract = subtract;
	    proto.toArray = toArray;
	    proto.toObject = toObject;
	    proto.toDate = toDate;
	    proto.toISOString = toISOString;
	    proto.inspect = inspect;
	    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
	        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
	            return 'Moment<' + this.format() + '>';
	        };
	    }
	    proto.toJSON = toJSON;
	    proto.toString = toString;
	    proto.unix = unix;
	    proto.valueOf = valueOf;
	    proto.creationData = creationData;
	    proto.eraName = getEraName;
	    proto.eraNarrow = getEraNarrow;
	    proto.eraAbbr = getEraAbbr;
	    proto.eraYear = getEraYear;
	    proto.year = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week = proto.weeks = getSetWeek;
	    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
	    proto.weeksInYear = getWeeksInYear;
	    proto.weeksInWeekYear = getWeeksInWeekYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
	    proto.date = getSetDayOfMonth;
	    proto.day = proto.days = getSetDayOfWeek;
	    proto.weekday = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset = getSetOffset;
	    proto.utc = setOffsetToUTC;
	    proto.local = setOffsetToLocal;
	    proto.parseZone = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST = isDaylightSavingTime;
	    proto.isLocal = isLocal;
	    proto.isUtcOffset = isUtcOffset;
	    proto.isUtc = isUtc;
	    proto.isUTC = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates = deprecate(
	        'dates accessor is deprecated. Use date instead.',
	        getSetDayOfMonth
	    );
	    proto.months = deprecate(
	        'months accessor is deprecated. Use month instead',
	        getSetMonth
	    );
	    proto.years = deprecate(
	        'years accessor is deprecated. Use year instead',
	        getSetYear
	    );
	    proto.zone = deprecate(
	        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
	        getSetZone
	    );
	    proto.isDSTShifted = deprecate(
	        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
	        isDaylightSavingTimeShifted
	    );
	
	    function createUnix(input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone() {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat(string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar = calendar;
	    proto$1.longDateFormat = longDateFormat;
	    proto$1.invalidDate = invalidDate;
	    proto$1.ordinal = ordinal;
	    proto$1.preparse = preParsePostFormat;
	    proto$1.postformat = preParsePostFormat;
	    proto$1.relativeTime = relativeTime;
	    proto$1.pastFuture = pastFuture;
	    proto$1.set = set;
	    proto$1.eras = localeEras;
	    proto$1.erasParse = localeErasParse;
	    proto$1.erasConvertYear = localeErasConvertYear;
	    proto$1.erasAbbrRegex = erasAbbrRegex;
	    proto$1.erasNameRegex = erasNameRegex;
	    proto$1.erasNarrowRegex = erasNarrowRegex;
	
	    proto$1.months = localeMonths;
	    proto$1.monthsShort = localeMonthsShort;
	    proto$1.monthsParse = localeMonthsParse;
	    proto$1.monthsRegex = monthsRegex;
	    proto$1.monthsShortRegex = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays = localeWeekdays;
	    proto$1.weekdaysMin = localeWeekdaysMin;
	    proto$1.weekdaysShort = localeWeekdaysShort;
	    proto$1.weekdaysParse = localeWeekdaysParse;
	
	    proto$1.weekdaysRegex = weekdaysRegex;
	    proto$1.weekdaysShortRegex = weekdaysShortRegex;
	    proto$1.weekdaysMinRegex = weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1(format, index, field, setter) {
	        var locale = getLocale(),
	            utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl(format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i,
	            out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl(localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0,
	            i,
	            out = [];
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths(format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort(format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        eras: [
	            {
	                since: '0001-01-01',
	                until: +Infinity,
	                offset: 1,
	                name: 'Anno Domini',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: 'Before Christ',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    toInt((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate(
	        'moment.lang is deprecated. Use moment.locale instead.',
	        getSetGlobalLocale
	    );
	    hooks.langData = deprecate(
	        'moment.langData is deprecated. Use moment.localeData instead.',
	        getLocale
	    );
	
	    var mathAbs = Math.abs;
	
	    function abs() {
	        var data = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days = mathAbs(this._days);
	        this._months = mathAbs(this._months);
	
	        data.milliseconds = mathAbs(data.milliseconds);
	        data.seconds = mathAbs(data.seconds);
	        data.minutes = mathAbs(data.minutes);
	        data.hours = mathAbs(data.hours);
	        data.months = mathAbs(data.months);
	        data.years = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1(duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days += direction * other._days;
	        duration._months += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1(input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1(input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil(number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble() {
	        var milliseconds = this._milliseconds,
	            days = this._days,
	            months = this._months,
	            data = this._data,
	            seconds,
	            minutes,
	            hours,
	            years,
	            monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (
	            !(
	                (milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0)
	            )
	        ) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds = absFloor(milliseconds / 1000);
	        data.seconds = seconds % 60;
	
	        minutes = absFloor(seconds / 60);
	        data.minutes = minutes % 60;
	
	        hours = absFloor(minutes / 60);
	        data.hours = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days = days;
	        data.months = months;
	        data.years = years;
	
	        return this;
	    }
	
	    function daysToMonths(days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return (days * 4800) / 146097;
	    }
	
	    function monthsToDays(months) {
	        // the reverse of daysToMonths
	        return (months * 146097) / 4800;
	    }
	
	    function as(units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days,
	            months,
	            milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'quarter' || units === 'year') {
	            days = this._days + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            switch (units) {
	                case 'month':
	                    return months;
	                case 'quarter':
	                    return months / 3;
	                case 'year':
	                    return months / 12;
	            }
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week':
	                    return days / 7 + milliseconds / 6048e5;
	                case 'day':
	                    return days + milliseconds / 864e5;
	                case 'hour':
	                    return days * 24 + milliseconds / 36e5;
	                case 'minute':
	                    return days * 1440 + milliseconds / 6e4;
	                case 'second':
	                    return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond':
	                    return Math.floor(days * 864e5) + milliseconds;
	                default:
	                    throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    function makeAs(alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms'),
	        asSeconds = makeAs('s'),
	        asMinutes = makeAs('m'),
	        asHours = makeAs('h'),
	        asDays = makeAs('d'),
	        asWeeks = makeAs('w'),
	        asMonths = makeAs('M'),
	        asQuarters = makeAs('Q'),
	        asYears = makeAs('y'),
	        valueOf$1 = asMilliseconds;
	
	    function clone$1() {
	        return createDuration(this);
	    }
	
	    function get$2(units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds'),
	        seconds = makeGetter('seconds'),
	        minutes = makeGetter('minutes'),
	        hours = makeGetter('hours'),
	        days = makeGetter('days'),
	        months = makeGetter('months'),
	        years = makeGetter('years');
	
	    function weeks() {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round,
	        thresholds = {
	            ss: 44, // a few seconds to seconds
	            s: 45, // seconds to minute
	            m: 45, // minutes to hour
	            h: 22, // hours to day
	            d: 26, // days to month/week
	            w: null, // weeks to month
	            M: 11, // months to year
	        };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
	        var duration = createDuration(posNegDuration).abs(),
	            seconds = round(duration.as('s')),
	            minutes = round(duration.as('m')),
	            hours = round(duration.as('h')),
	            days = round(duration.as('d')),
	            months = round(duration.as('M')),
	            weeks = round(duration.as('w')),
	            years = round(duration.as('y')),
	            a =
	                (seconds <= thresholds.ss && ['s', seconds]) ||
	                (seconds < thresholds.s && ['ss', seconds]) ||
	                (minutes <= 1 && ['m']) ||
	                (minutes < thresholds.m && ['mm', minutes]) ||
	                (hours <= 1 && ['h']) ||
	                (hours < thresholds.h && ['hh', hours]) ||
	                (days <= 1 && ['d']) ||
	                (days < thresholds.d && ['dd', days]);
	
	        if (thresholds.w != null) {
	            a =
	                a ||
	                (weeks <= 1 && ['w']) ||
	                (weeks < thresholds.w && ['ww', weeks]);
	        }
	        a = a ||
	            (months <= 1 && ['M']) ||
	            (months < thresholds.M && ['MM', months]) ||
	            (years <= 1 && ['y']) || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding(roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof roundingFunction === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold(threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize(argWithSuffix, argThresholds) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var withSuffix = false,
	            th = thresholds,
	            locale,
	            output;
	
	        if (typeof argWithSuffix === 'object') {
	            argThresholds = argWithSuffix;
	            argWithSuffix = false;
	        }
	        if (typeof argWithSuffix === 'boolean') {
	            withSuffix = argWithSuffix;
	        }
	        if (typeof argThresholds === 'object') {
	            th = Object.assign({}, thresholds, argThresholds);
	            if (argThresholds.s != null && argThresholds.ss == null) {
	                th.ss = argThresholds.s - 1;
	            }
	        }
	
	        locale = this.localeData();
	        output = relativeTime$1(this, !withSuffix, th, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return (x > 0) - (x < 0) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000,
	            days = abs$1(this._days),
	            months = abs$1(this._months),
	            minutes,
	            hours,
	            years,
	            s,
	            total = this.asSeconds(),
	            totalSign,
	            ymSign,
	            daysSign,
	            hmsSign;
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes = absFloor(seconds / 60);
	        hours = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	
	        totalSign = total < 0 ? '-' : '';
	        ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return (
	            totalSign +
	            'P' +
	            (years ? ymSign + years + 'Y' : '') +
	            (months ? ymSign + months + 'M' : '') +
	            (days ? daysSign + days + 'D' : '') +
	            (hours || minutes || seconds ? 'T' : '') +
	            (hours ? hmsSign + hours + 'H' : '') +
	            (minutes ? hmsSign + minutes + 'M' : '') +
	            (seconds ? hmsSign + s + 'S' : '')
	        );
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid = isValid$1;
	    proto$2.abs = abs;
	    proto$2.add = add$1;
	    proto$2.subtract = subtract$1;
	    proto$2.as = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds = asSeconds;
	    proto$2.asMinutes = asMinutes;
	    proto$2.asHours = asHours;
	    proto$2.asDays = asDays;
	    proto$2.asWeeks = asWeeks;
	    proto$2.asMonths = asMonths;
	    proto$2.asQuarters = asQuarters;
	    proto$2.asYears = asYears;
	    proto$2.valueOf = valueOf$1;
	    proto$2._bubble = bubble;
	    proto$2.clone = clone$1;
	    proto$2.get = get$2;
	    proto$2.milliseconds = milliseconds;
	    proto$2.seconds = seconds;
	    proto$2.minutes = minutes;
	    proto$2.hours = hours;
	    proto$2.days = days;
	    proto$2.weeks = weeks;
	    proto$2.months = months;
	    proto$2.years = years;
	    proto$2.humanize = humanize;
	    proto$2.toISOString = toISOString$1;
	    proto$2.toString = toISOString$1;
	    proto$2.toJSON = toISOString$1;
	    proto$2.locale = locale;
	    proto$2.localeData = localeData;
	
	    proto$2.toIsoString = deprecate(
	        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
	        toISOString$1
	    );
	    proto$2.lang = lang;
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    //! moment.js
	
	    hooks.version = '2.30.1';
	
	    setHookCallback(createLocal);
	
	    hooks.fn = proto;
	    hooks.min = min;
	    hooks.max = max;
	    hooks.now = now;
	    hooks.utc = createUTC;
	    hooks.unix = createUnix;
	    hooks.months = listMonths;
	    hooks.isDate = isDate;
	    hooks.locale = getSetGlobalLocale;
	    hooks.invalid = createInvalid;
	    hooks.duration = createDuration;
	    hooks.isMoment = isMoment;
	    hooks.weekdays = listWeekdays;
	    hooks.parseZone = createInZone;
	    hooks.localeData = getLocale;
	    hooks.isDuration = isDuration;
	    hooks.monthsShort = listMonthsShort;
	    hooks.weekdaysMin = listWeekdaysMin;
	    hooks.defineLocale = defineLocale;
	    hooks.updateLocale = updateLocale;
	    hooks.locales = listLocales;
	    hooks.weekdaysShort = listWeekdaysShort;
	    hooks.normalizeUnits = normalizeUnits;
	    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat = getCalendarFormat;
	    hooks.prototype = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD', // <input type="date" />
	        TIME: 'HH:mm', // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
	        WEEK: 'GGGG-[W]WW', // <input type="week" />
	        MONTH: 'YYYY-MM', // <input type="month" />
	    };
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(192)(module)))

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toDate;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name toDate
	 * @category Common Helpers
	 * @summary Convert the given argument to an instance of Date.
	 *
	 * @description
	 * Convert the given argument to an instance of Date.
	 *
	 * If the argument is an instance of Date, the function returns its clone.
	 *
	 * If the argument is a number, it is treated as a timestamp.
	 *
	 * If the argument is none of the above, the function returns Invalid Date.
	 *
	 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
	 *
	 * @param {Date|Number} argument - the value to convert
	 * @returns {Date} the parsed date in the local time zone
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Clone the date:
	 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
	 * //=> Tue Feb 11 2014 11:30:30
	 *
	 * @example
	 * // Convert the timestamp to date:
	 * const result = toDate(1392098430000)
	 * //=> Tue Feb 11 2014 11:30:30
	 */
	function toDate(argument) {
	  (0, _index.default)(1, arguments);
	  var argStr = Object.prototype.toString.call(argument); // Clone the date
	
	  if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') {
	    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
	    return new Date(argument.getTime());
	  } else if (typeof argument === 'number' || argStr === '[object Number]') {
	    return new Date(argument);
	  } else {
	    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
	      // eslint-disable-next-line no-console
	      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console
	
	      console.warn(new Error().stack);
	    }
	
	    return new Date(NaN);
	  }
	}
	
	module.exports = exports.default;

/***/ },
/* 10 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var HOST = exports.HOST = 'http://localhost:3000/';
	
	var CURRENT_LANGUAGE = exports.CURRENT_LANGUAGE = 1;
	var TIME_ALWAYS_VISIBLE = exports.TIME_ALWAYS_VISIBLE = 2;
	var CALL_KEY_MAX_LENGHT = exports.CALL_KEY_MAX_LENGHT = 40;
	var STR_SOFTPHONE = exports.STR_SOFTPHONE = 'softphone';
	var SM_QUEUE_SERVER = exports.SM_QUEUE_SERVER = 'server';
	
	var SOFTPHONES_DEFAULT = exports.SOFTPHONES_DEFAULT = {
		4: 'WebRTC',
		5: 'MizuJS'
	};
	
	var SOFTPHONES_KEY = exports.SOFTPHONES_KEY = {
		WEBRTC: 4,
		MIZUJS: 5
	};
	
	var SOFTPHONES = exports.SOFTPHONES = {
		4: 'WEBRTC',
		5: 'MIZUJS'
	};
	var OTHER_ACTIONS = exports.OTHER_ACTIONS = {
		NO_ACTION: 'NO_OTHER_ACTION',
		UPDATE_WB_INFO: 'UPDATE_WORK_BAR_INFO',
		MARK_CALL: 'MARK_CALL_OTHER',
		RESET_MARKS: 'RESET_MARKS_OTHER',
		DELETE_CHAT_NOTIFICATIONS: 'DELETE_CHAT_NOTIFICATIONS'
	};
	
	var HANG_UP_SUBACTIONS = exports.HANG_UP_SUBACTIONS = {
		MANUAL_CALL: 'ManualCall', //Cancel ManualCall before connecting
		FISRT_CALL: 'FirstCall',
		CALL: 'Call', //HangUp a dial
		LEAVE_MESSAGE: 'LeaveMessage'
	};
	
	var CONSULTING_WINDOW = exports.CONSULTING_WINDOW = {
		CONSULTING: 'CONSULTING_UA',
		NO_CONSULTING: 'NO_CONSULTING_UA'
	};
	
	var ACTIONS_FROM_SM = exports.ACTIONS_FROM_SM = {
		NO_ACTION: 'NO_ACTION_FROM_ST',
		CALL_TYPE: 'CALL_TYPE_UA',
		MESSAGE_FROM_SUPERVISOR: 'MESSAGE_FROM_SUPERVISOR',
		NO_AVAILABLE_INFO: 'NO_AVAILABLE_INFO'
	};
	
	var ACTIONS_FROM_WHITE_LABEL = exports.ACTIONS_FROM_WHITE_LABEL = {
		SET_CUSTOM_IMAGES: 'SET_CUSTOM_IMAGES'
	};
	var ACTIONS_FROM_LOCAL_LOGGING = exports.ACTIONS_FROM_LOCAL_LOGGING = {
		SET_LOCAL_LOGGING: 'SET_LOCAL_LOGGING'
	};
	
	var ACTIONS_FROM_UNIFIED_INBOX = exports.ACTIONS_FROM_UNIFIED_INBOX = {
		SHOW: 'SHOW',
		TYPING: 'TYPING',
		SELECT_CONVERSATION: 'SELECT_CONVERSATION',
		END_CONVERSATION: 'END_CONVERSATION',
		CHAT_CUSTOMER_TERMINATION: 'CHAT_CUSTOMER_TERMINATION',
		CHAT_CLIENT_DISCONNECT: 'CHAT_CLIENT_DISCONNECT',
		NEW_CONVERSATION: {
			0: 'CHAT',
			1: 'CHAT',
			2: 'MAIL',
			3: 'TWITTER',
			4: 'WHATSAPP'
		},
		NEW_MESSAGE_INBOX: {
			0: 'CHAT_MESSAGE',
			1: 'CHAT_MESSAGE',
			2: 'MAIL_MESSAGE',
			3: 'TWITTER_MESSAGE'
		},
		NEW_DRAFT_MESSAGE: 'NEW_DRAFT_MESSAGE',
		DELETE_DRAFT_MESSAGE: 'DELETE_DRAFT_MESSAGE',
		UPDATE_DRAFT_MESSAGE: 'UPDATE_DRAFT_MESSAGE',
		UPDATE_DRAFT_ATTACHMENTS: 'UPDATE_DRAFT_ATTACHMENTS',
		GET_DRAFT_MESSAGES_LIST: 'GET_DRAFT_MESSAGES_LIST',
		SPAM_CONVERSATION: 'SPAM_CONVERSATION',
		UNASSIGN_CONVERSATION: 'UNASSIGN_CONVERSATION',
		DISCARD_CONVERSATION: 'DISCARD_CONVERSATION',
		ANSWERS_TEMPLATES_CHAT: 'ANSWERS_TEMPLATES_CHAT',
		CHAT_TAKEOVER: 'CHAT_TAKEOVER',
		SEND_UNIFIED_RESPONSE: 'SEND_UNIFIED_RESPONSE',
		LOGOUT: 'LOGOUT',
		MULTIMEDIA_DISPOSITION: 'MULTIMEDIA_DISPOSITION',
		ACEPTED_CHAT: 'ACEPTED_CHAT',
		CHANGE_STATE_MULTIMEDIA: 'CHANGE_STATE_MULTIMEDIA',
		EXTERNAL_MESSAGING_CUSTOMER: 'EXTERNAL_MESSAGING_CUSTOMER',
		MULTIMEDIA_MESSAGE_ERROR_MMC: 'MULTIMEDIA_MESSAGE_ERROR_MMC',
	
		EXTERNAL_NEW_MESSAGING: 'EXTERNAL_NEW_MESSAGING',
		CHANGE_STATE: 'CHANGE_STATE',
		UPLOAD_ATTACHMENT: 'UPLOAD_ATTACHMENT',
		CONVERSATION_TIMEOUT_REACHED: 'CONVERSATION_TIMEOUT_REACHED',
		END_CONVERSATIONS_CAMPAIGN_DELETED: 'END_CONVERSATIONS_CAMPAIGN_DELETED',
		UPDATE_CONVS_DELETED_BY_ERROR: 'UPDATE_CONVS_DELETED_BY_ERROR',
		RESET_TIMEOUT: 'RESET_TIMEOUT',
		FETCHING_CONVERSATION: 'FETCHING_CONVERSATION',
		NEW_HISTORICAL_CONVERSATION: 'NEW_HISTORICAL_CONVERSATION',
		ERROR_HISTORICAL_CONVERSATION: 'ERROR_HISTORICAL_CONVERSATION',
		UPDATE_PERMISSION: 'UPDATE_PERMISSION',
		UPDATE_CONVERSATIONS_PHONE_CHANGE: 'UPDATE_CONVERSATIONS_PHONE_CHANGE',
		CHANGE_STATE_MULTIMEDIA_ALL: 'CHANGE_STATE_MULTIMEDIA_ALL',
		CHAT_CONVERSATION_READ: 'CHAT_CONVERSATION_READ'
	};
	
	var DRAGGABLE_WINDOWS_ACTIONS = exports.DRAGGABLE_WINDOWS_ACTIONS = {
		NONE: 'NONE_WINDOW_DRAGGABLE',
		INSERT_WINDOW: 'INSERT_WINDOW_DRAGGABLE',
		REMOVE_WINDOW: 'REMOVE_WINDOW_DRAGGABLE'
	};
	
	var MESSAGES_TO_SM = exports.MESSAGES_TO_SM = {
		NO_MESSAGE: 'NO_MESSAGE',
		MESSAGE_TO_SM: 'MESSAGE_TO_SM_ACTION',
		NO_AVAILABLE_EVENT: 'NO_AVAILABLE_EVENT',
		RETRY_FIRST_CALL: 'RETRY_FIRST_CALL',
		AGENT_READY: 'AGENT_READY_MESSAGE',
		MESSAGE_TO_SUPERVISOR: 'MESSAGE_TO_SUPERVISOR',
		CHANGE_STATE: 'CHANGE_STATE_MESSAGE',
		START_STOP_RECORDING: 'START_STOP_RECORDING',
		API_REQUEST: 'API_REQUEST',
		MARKS_CALL: 'MARKS_CALL_TO_SM',
		UPDATE_DATA_CALL: 'UPDATE_DATA_CALL',
		TRANSFER_CALL: 'TRANSFER_CALL',
		MANUAL_CALL: 'MANUAL_CALL ',
		HANG_UP: 'HANG_UP',
		ASSISTED_TRANSFER_CALL: 'ASSISTED_TRANSFER_CALL',
		ONGOING_CALL_IVR: 'ONGOING_CALL_IVR',
		END_CONVERSATION_CHAT: 'END_CONVERSATION_CHAT',
		REJECT_CONVERSATION: 'REJECT_CONVERSATION',
		SPAM_CONVERSATION: 'SPAM_CONVERSATION',
		UNASSIGN_CONVERSATION: 'UNASSIGN_CONVERSATION',
		DISCARD_CONVERSATION: 'DISCARD_CONVERSATION',
		SELECTED_MESSAGE: 'SELECTED_MESSAGE',
		SEND_UNIFIED_RESPONSE: 'SEND_UNIFIED_RESPONSE',
		SEND_DISPOSITION: 'SEND_DISPOSITION',
		SEND_EXTERNAL_UNIFIED_RESPONSE: 'SEND_EXTERNAL_UNIFIED_RESPONSE',
		ACEPTED_CHAT: 'ACEPTED_CHAT',
		DIALOG_WHATSAPP: 'DIALOG_WHATSAPP',
		WHATSAPP: 'WHATSAPP',
		CHANGE_STATE_MULTIMEDIA: 'CHANGE_STATE_MULTIMEDIA',
		CHANGE_DIALINGMODE_SCH: "CHANGE_DIALINGMODE_SCH",
		PREVIEW_RECORD: "PREVIEW_RECORD",
		PREVIEW_TRANSFER: "PREVIEW_TRANSFER",
		SEND_RESPONSE_TRANSFER: "SEND_RESPONSE_TRANSFER",
		ACCEPT_CHAT_SAVE_TIME: "ACCEPT_CHAT_SAVE_TIME",
		GET_MORE_MESSAGES: 'GET_MORE_MESSAGES',
		CHANGE_STATE_MULTIMEDIA_ALL: 'CHANGE_STATE_MULTIMEDIA_ALL',
		MANUAL_MESSAGE: 'MANUAL_MESSAGE',
		API_REQUEST_ANI_LIST: 'API_REQUEST_ANI_LIST',
		GET_RECORD_CALL_PERMISSION: 'GET_RECORD_CALL_PERMISSION',
		GET_PREVIEW_CAMPAIGNS: 'GET_PREVIEW_CAMPAIGNS'
	};
	
	var USER_ACTIONS = exports.USER_ACTIONS = {
		NONE: 'NONE_USER_ACTION',
		LOGIN: 'LOGIN_UA',
		CHANGE_LANGUAGE: 'CHANGE_LANGUAGE_UA',
		LOGOUT: 'LOGOUT',
		SHOW_PSW_RESET: 'SHOW_PSW_RESET'
	};
	
	var USER_STATE = exports.USER_STATE = {
		CHANGE_STATE: 'CHANGE_STATE',
		CALL_OUT: 'CALL_OUT',
		LOGED_OUT: 'LOGED_OUT',
		LOGED_IN: 'LOGED_IN',
		AGENT_READY: 'AGENT_READY',
		NO_AVAILABLE: 'NO_AVAILABLE',
		DIALOG: 'DIALOG',
		MANUAL_CALL: 'MANUAL_CALL',
		WAITING_TRANSFER: 'WAITING_TRANSFER',
		ERROR: 'ERROR',
		CALL_TRANSFER: 'CALL_TRANSFER',
		RINGING: 'RINGING',
		WRAPUP: 'WRAPUP',
		XFER: 'XFER',
		OTHER: 'OTHER',
		EXCLUSIVE_CALLBACK: 'EXCLUSIVE_CALLBACK',
		CHATTING: 'CHATTING',
		READY_PREVIEW: 'READY_PREVIEW',
		ASSISTED: 'ASSISTED',
		DIALOG_WHATSAPP: 'DIALOG_WHATSAPP',
		WHATSAPP: 'WHATSAPP',
		AGENT_PREVIEW: 'AGENT_PREVIEW',
		INACTIVE: 'INACTIVE',
		DIALOG_EMAIL: 'DIALOG_EMAIL',
		OTHER_PREVIEW: 'OTHER_PREVIEW'
	};
	
	var INTEGRATION = exports.INTEGRATION = {
		ASSISTED_DIAL_ACD: 'assistedDialACD',
		ASSISTED_DIAL_AGENT: 'assistedDialAgent',
		ASSISTED_DIAL_NUMBER: 'assistedDialNumber',
		ASSISTED_TRANSFER_CALL_HANGUP: 'AssistedTransferCallHangUp',
		CALL_ACTION: 'CallAction',
		CALL_RECORD: 'onCallHistory',
		CHANGE_PASSWORD: 'ChangePassword',
		CHAT: 'Chat',
		DISPOSITION: 'Disposition',
		DROP_SECOND_CALL: 'DropSecondCall',
		DTMF: 'DTMF',
		EXIT_ASSISTED_MODE: 'exitAssistedMode',
		GET_ACD_DISPOSITIONS: 'getACDDispositions',
		GET_CAMPAIGN_DISPOSITIONS: 'getCampaignDispositions',
		GET_DISPOSITIONS: 'getDispositions',
		GET_DISPOSITIONS_AND_NUMBERS: 'GetDispositionsAndNumbers',
		GET_IVR_LIST: 'GetIVRList',
		GET_PHONE_NUMBERS: 'getPhoneNumbers',
		GET_TRANSFER_DATA: 'GetTransferData',
		HANG_UP: 'HangUp',
		HANG_UP_AND_LEAVE_MESSAGE: 'hangUpAndLeaveMessage',
		HANG_UP_MANUAL_DIAL: 'HangUpManualDial',
		HOLD: 'Hold',
		IDLE_START: 'IdleStart',
		LOGIN: 'Login',
		LOGOUT: 'Logout',
		MAKE_CALL: 'MakeCall',
		MANUAL_CALL: 'ManualCall',
		MARK_ADD: 'MarkAdd',
		MICROPHONE: 'Microphone',
		MUTE: 'Mute',
		OPEN_VOLUME_WINDOW: 'OpenVolumeWindow',
		OPEN_WINDOW: 'OpenWindow',
		RECORDING_STOP_START: 'recordingStopStart',
		RESCHEDULE_CALL_ACD: 'reprogramCall',
		SAVE_DISPOSITION: 'saveDisposition',
		READY_WITH_PASSWORD: 'setReadyWithPassword',
		SET_VOLUME: 'SetVolume',
		SETTINGS: 'Settings',
		SPEAKER: 'Speaker',
		UPDATE_DATA_CALL: 'UpdateDataCall'
	};
	
	var INTEGRATION_SUBACTION = exports.INTEGRATION_SUBACTION = {
		CHAT_NEW_MESSAGE: 'NewMessage',
		CHAT_SUPERVISORS: 'SupervisorsToChat',
		ERROR_SUPERVISOR_LIST_EVENT: 'errorOnChatAdministratorsList',
		TIME_ZONE_NUMBER_EVENT: 'timeZoneNumber'
	};
	
	var PREVIEW_TRANSFER_SUBACTION = exports.PREVIEW_TRANSFER_SUBACTION = {
		TRANSFER_REQUEST: 'RequestAgent',
		TRANSFER_RESPONSE: 'AnswerAgentTransfer'
	};
	
	var ASSISTED_TRANSFER_SUBACTION = exports.ASSISTED_TRANSFER_SUBACTION = {
		ASSISTED: 'assistedCallTransfer',
		PREVIEW: 'TransferPreviewCall'
	};
	
	var ASSISTED_TRANSFER = exports.ASSISTED_TRANSFER = {
		CHANGE_STATE: 'ASSISTED_TRANSFER_CHANGE_STATE',
		SECOND_CALL_CONNECTED: 'SECOND_CALL_CONNECTED',
		ON_STATUS: 'ON_STATUS',
		SECOND_CALL_HANG_UP: 'SECOND_CALL_HANG_UP',
		CONFERENCE_CALL_CONNECTED: 'CONFERENCE_CALL_CONNECTED',
		CONFERENCE_CALL_HANG_UP: 'CONFERENCE_CALL_HANG_UP',
		NEW_SECOND_CALL_SET: 'NEW_SECOND_CALL_SET',
		MAIN_CALL: 'MAIN_CALL',
		ON_CONFERENCE: 'ON_CONFERENCE',
		ON_CONFERENCE_CALL: 'ON_CONFERENCE_CALL',
		TRANSFERRING: 'TRANSFERRING',
		IDDLE_END: 'IDDLE_END'
	
	};
	
	var TRANSFER_ACTIONS = exports.TRANSFER_ACTIONS = {
		BLIND_TRANSFER: 'BLIND_TRANSFER',
		RESET_BLIND_TRANSFER: 'RESET_BLIND_TRANSFER',
		ASSISTED_TRANSFER: 'ASSISTED_TRANSFER',
		RESET_ASSISTED_TRANSFER: 'RESET_ASSISTED_TRANSFER',
		SHOW_DATA_TRANSGER_BY_SETTING: 'SHOW_DATA_TRANSGER_BY_SETTING'
	};
	
	var BLIND_TRANSFER = exports.BLIND_TRANSFER = {
		BLIND_TRANSFER_HANG_UP: 'BLIND_TRANSFER_HANG_UP'
	};
	
	var WORKBAR_ACTIONS = exports.WORKBAR_ACTIONS = {
		INSERT_WINDOW: 'INSERT_WINDOW_WORKBAR',
		REMOVE_WINDOW: 'REMOVE_WINDOW_WORKBAR',
		NONE: 'NONE_WORK_BAR_ACTIONS',
		SUPERVISOR_CHAT: 'SUPERVISOR_CHAT_WORK_BAR',
		NO_AVAILABLE: 'NO_AVAILABLE_WORK_BAR',
		NO_AVAILABLE_RECORD: 'NO_AVAILABLE_RECORD_EXPANDED'
		// CALL_RECORD: "CALL_RECORD",
		// MANUAL_CALL:"MANUAL_CALL",
		// MARK_CALL:"MARK_CALL"
	};
	
	var PREVIEW_TRANSFER = exports.PREVIEW_TRANSFER = {
		DATA_CALL_PREVIEW: "DATA_CALL_PREVIEW",
		ON_RESPONSE_TRANSFER: "ON_RESPONSE_TRANSFER",
		SHOW_ALERT: "SHOW_ALERT",
		SHOW_PREVIEW_DATA: "SHOW_PREVIEW_DATA",
		SET_AGENT_LIST: "SET_AGENT_LIST",
		TRANSFER_IN_PROGRESS: "TRANSFER_IN_PROGRESS",
		UNNASIGN_BY_XFER: "UNNASIGN_BY_XFER"
	};
	
	var VALIDATING_TELEPHONY = exports.VALIDATING_TELEPHONY = {
		VALIDATING: 'VALIDATING_TELEPHONY',
		VALID: 'VALID_TELEPHONY',
		ERROR: 'ERROR_TELEPHONY'
	};
	
	var CALL_ACTIONS = exports.CALL_ACTIONS = {
		DATA_CALL: 'DATA_CALL',
		EXTRA_DATA_CALL: 'EXTRA_DATA_CALL'
	};
	
	var ACTION_CALL_ACD = exports.ACTION_CALL_ACD = {
		MUTE: 'MUTE',
		HOLD: 'HOLD',
		DTMF: 'DTMF'
	};
	
	var VOLUME = exports.VOLUME = {
		SPEAKER: 'SPEAKER_VOLUME',
		MICROPHONE: 'MICROPHONE_VOLUME'
	};
	
	var REDUCERS = exports.REDUCERS = {
		ACTIOS_FROM_SM: 'REDUCER_ACTIOS_FROM_SM',
		CALL_ACD: 'CALL_ACD',
		CONSULTING_WINDOW: 'REDUCER_CONSULTING_WINDOW',
		MESSAGES_TO_SM: 'REDUCER_MESSAGES_TO_SM',
		NO_AVAILABLE: 'REDUCER_NO_AVAILABLE',
		OTHER_ACTIONS: 'REDUCER_OTHER_ACTIONS',
		USER_ACTIONS: 'REDUCER_USER_ACTIONS',
		USER_STATES: 'REDUCER_USER_STATES',
		WORK_BAR_SELECTED: 'REDUCER_WORK_BAR_SELECTED',
		VALIDATING_TELEPHONY: 'REDUCER_VALIDATING_TELEPHONY',
		VOLUME: 'REDUCER_VOLUME',
		WINDOW_VISIBLE: 'REDUCER_WINDOW_VISIBLE_500',
		DRAGGABLE_WINDOWS_CONTROLLER: 'REDUCER_DRAGGABLE_WINDOWS_CONTROLLER',
		SIP_CLIENT_ACTIONS: 'SIP_CLIENT_ACTIONS',
		BLOCKING_PANEL: 'BLOCKING_PANEL',
		PREVIEW_DATA: 'PREVIEW_DATA'
	};
	
	var API_ENDPOINTS = exports.API_ENDPOINTS = {
		HOLD: 'Hold',
		SAVE_DISPOSITION: 'SaveDispositionListACD',
		CALL_OUT_CAMPAIGNS: 'CallOutCampaigns',
		CALL_BACK: 'InsertCallBack',
		TRANSFER_CALL_PREVIEW: 'TransferCallData',
		UPDATE_CALL_KEY: 'UpdateCallKey',
		SELECT_ANI_MANUAL_CALL: 'SelectAniManualCall',
		GET_RECORD_CALL_PERMISSION: 'GetRecordCallPermission'
	};
	
	var BLOCKING_PANEL = exports.BLOCKING_PANEL = {
		Z_INDEX: 'Z_INDEX'
	};
	var TYPE_CALL = exports.TYPE_CALL = {
		INBOUND: 1,
		OUTBOUND: 2
	};
	
	var TYPE_DESIGN_CALL = exports.TYPE_DESIGN_CALL = {
		INBOUND: 'inboundDesign',
		OUTBOUND: 'outboundDesign',
		WRAPUP: 'wrapUpDesign'
	};
	
	var WINDOW_AT_500 = exports.WINDOW_AT_500 = {
		NONE: 'WINDOW_VISIBLE_AT_500_NONE',
		MESSAGE: 'MESSAGE_VISIBLE_AT_500',
		CALL: 'CALL_VISIBLE_AT_500'
	};
	
	var QUEUE_COUNT = exports.QUEUE_COUNT = {
		CALLS: 1,
		MESSAGES: 2,
		FACEBOOK: 3,
		LINKEDIN: 4,
		TWITTER: 5,
		MAIL: 6
	};
	
	var SEARCH_OPTIONS = exports.SEARCH_OPTIONS = {
		BY_NAME: 'name',
		BY_PHONE: 'phone',
		BY_CALL_KEY: 'callKey'
	};
	
	var CUSTOM_CELLS = exports.CUSTOM_CELLS = {
		BY_NAME: 'cellDirectory',
		BY_CALL_KEY: 'cellDirectoryByCallKey'
	};
	
	var DRAGGABLE_WINDOWS = exports.DRAGGABLE_WINDOWS = {
		NONE: 'NONE_DRAGGABLE_WINDOW',
		MANUAL_CALL: 'MANUAL_CALL_DRAGGABLE_WINDOW',
		TRANSFER_CALL: 'TRANSFER_CALL_DRAGGABLE_WINDOW',
		DTMF_TONES: 'DTMF_TONES_DRAGGABLE_WINDOW',
		MARK_CALL: 'MARK_CALL_DRAGGABLE_WINDOW',
		NO_AVAILABLE_LOCKED: 'NO_AVAILABLE_LOCKED_NO_DRAGGABLE_WINDOW',
		NO_AVAILABLE: 'NO_AVAILABLE_DRAGGABLE_WINDOW',
		SUPERVISOR_CHAT: 'SUPERVISOR_CHAT_DRAGGABLE_WINDOW',
		NO_AVAILABLE_RECORD: 'NO_AVAILABLE_RECORD_DRAGGABLE_WINDOW',
		CALL_RECORD: 'CALL_RECORD_DRAGGABLE_WINDOW',
		EXCLUSIVE_CALLBACK: 'EXCLUSIVE_CALLBACK_NO_DRAGGABLE_WINDOW',
		ONGOING_CALL_IVR: ' ONGOING_CALL_IVR_DRAGGABLE_WINDOW',
		MANUAL_MESSAGE: 'MANUAL_MESSAGE',
		TEMPLATES_WHATSAPP: 'TEMPLATES_WHATSAPP',
		RATE_RECORD: 'RATE_RECORD'
	};
	
	var TYPE_MARKS = exports.TYPE_MARKS = {
		ADMIN: 'ADMIN_TYPE_MARK',
		AGENT: 'AGENT_TYPE_MARK'
	};
	
	var SIP_CLIENT_ACTIONS = exports.SIP_CLIENT_ACTIONS = {
		HANGUP: 'HANGUP_FROM_SIP',
		NONE: 'NONE_FROM_SIP',
		STREAM: 'STREAM_FROM_SIP'
	};
	
	var STEP_MANUAL_CALL = exports.STEP_MANUAL_CALL = {
		FIRST_TRY: 0,
		BLACKLIST_OR_WRONG_CAMP: 2,
		INCORRECT_NUMBER: 3
	};
	
	var ALERT_CATALOG = exports.ALERT_CATALOG = {
		NO_CAMPAINS: 1090,
		CHECK_NUMBER: 1091,
		INCORRECT_NUMBER: 1092,
		TIME_ZONE: 1095
	};
	
	var ERROR_CATALOG = exports.ERROR_CATALOG = {
		UNABLE_VERIFY_PHONE_NUMBER: 1081,
		ON_BLACKLIST: 1090,
		NO_CELLPHONE: 1091,
		NO_LONG_DISTANCE: 1092,
		NO_LOCAL_CALLS: 1093,
		USER_OUT_CAMP: 1094,
		NO_PORTS_ASSIGNED: 1098,
		NO_CAMPAIGN: 1099,
		NO_CAMPAIGN_FOUND: 1083
	};
	
	var BLOCKING_ALERTS = exports.BLOCKING_ALERTS = {
		1093: 'CALL_ON_NOT_READY'
	};
	
	var BLOCKING_ERRORS = exports.BLOCKING_ERRORS = {};
	
	var ALERTS_SHOWED = exports.ALERTS_SHOWED = {
		INSERT_CALL_ALERT: 'INSERT_CALL_ALERT',
		REMOVE_CALL_ALERT: 'REMOVE_CALL_ALERT',
		INSERT_NO_AVAILABLE_ALERT: 'INSERT_NO_AVAILABLE_ALERT',
		REMOVE_NO_AVAILABLE_ALERT: 'REMOVE_NO_AVAILABLE_ALERT',
		INSERT_VOLUME_ALERT: 'INSERT_VOLUME_ALERT',
		REMOVE_VOLUME_ALERT: 'REMOVE_VOLUME_ALERT',
		INSERT_PREVIEW_MODE_ALERT: 'INSERT_PREVIEW_MODE_ALERT',
		INSERT_PREVIEW_TRANSFER_ALERT: 'INSERT_PREVIEW_TRANSFER_ALERT'
	};
	
	var ALERTS_SHOWED_CODE = exports.ALERTS_SHOWED_CODE = {
		REPROGRAM_CALL_DIALOG: 1093,
		REPROGRAM_CALL_NA: 1094,
		REPROGRAM_NA_STATE: 'NO_AVAILABLE_REPROGRAM',
		VOLUMEN_DISABLED: 'VOLUME_DISABLED',
		READY_PREVIEW_MODE: 'READY_PREVIEW_MODE',
		PREVIEW_TRANSFER: 'PREVIEW_TRANSFER'
	};
	
	var ACTIONS_INTEGRATION = exports.ACTIONS_INTEGRATION = {
		CHANGE_IS_INTEGRATION: 'CHANGE_IS_INTIGRATION',
		MESSAGE: 'MESSAGE_INTEGRATION',
		NONE: 'NONE_INTEGRATION'
	};
	
	var STATES_INTEGRATION = exports.STATES_INTEGRATION = {
		connected: 'connectedIntegration',
		connecting: 'connectingIntegration',
		disconnecting: 'disconnectedIntegration',
		notFound: 'notFoundIntegration'
	};
	
	var PREVIEW = exports.PREVIEW = {
		SetAgentDialingMode: 'SetAgentDialingMode',
		SET_PREVIEW_RECORD: 'SET_PREVIEW_RECORD',
		UPDATE_PREVIEW_RECORD: 'UPDATE_PREVIEW_RECORD',
		INCREMENT_DISCARDED: 'INCREMENT_DISCARDED',
		UPDATE_PREVIEWTIME: 'UPDATE_PREVIEWTIME',
		SET_TEMP_DATA: 'SET_TEMP_DATA',
		CLEAN_DATA: 'CLEAN_DATA',
		SET_PHONE_CALL: 'SET_PHONE_CALL',
		CHANGE_CAMPAIGN_TYPE: 'CHANGE_CAMPAIGN_TYPE',
		SUCCESSFUL_CHANGE: 'SUCCESSFUL_CHANGE',
		SET_ISRUNNING_CLOCK: 'SET_ISRUNNING_CLOCK',
		SET_NEWPREVIEW_TIME: 'SET_NEWPREVIEW_TIME',
		SET_FINAL_TIME: 'SET_FINAL_TIME',
		SET_INITIAL_TIME: 'SET_INITIAL_TIME',
		SET_DATA_TRANSFER: 'SET_DATA_TRANSFER',
		SET_DIALOG_TIME: 'SET_DIALOG_TIME',
		SET_DIALINGMODE: 'SET_DIALINGMODE',
		SET_IS_SEND_PROCESS: 'SET_IS_SEND_PROCESS',
		SET_TEMP_PREVIEW_RECORD: 'SET_TEMP_PREVIEW_RECORD',
		SELECTED_PREVIEW_CAMPAIGN: 'SELECTED_PREVIEW_CAMPAIGN'
	};
	var PREVIEW_SIMULTANEOUS_REC = exports.PREVIEW_SIMULTANEOUS_REC = {
		SET_TOTAL_TIME: 'SET_TOTAL_TIME',
		SET_PHONE_TO_CALL: 'SET_PHONE_TO_CALL',
		REMOVE_RECORD: 'REMOVE_RECORD',
		SAVE_LOG_DIAL: 'SAVE_LOG_DIAL',
		SET_INITIAL_TIMESEC: "SET_INITIAL_TIMESEC",
		CHANGE_RECORD_STATE: "CHANGE_RECORD_STATE",
		SELECTED_RECORD: "SELECTED_RECORD",
		MESSAGE_STATUS: "MESSAGE_STATUS",
		RESET_RECORD: "RESET_RECORD",
		SET_CALL_ID: "SET_CALL_ID",
		SET_DIALOG_TIME: "SET_DIALOG_TIME_SIMULTANEOUS",
		SET_MAXIMUM_ASSIGNMENTS: "SET_MAXIMUM_ASSIGNMENTS",
		SET_INITIAL_DIALOG_TIME: "SET_INITIAL_DIALOG_TIME",
		SET_IT_WAS_SENT_TIME: "SET_IT_WAS_SENT_TIME",
		SET_VOLUME: "SET_VOLUME",
		SET_MARKS: "SET_MARKS",
		SET_DISPOSITION_DATA: "SET_DISPOSITION_DATA",
		SET_ND_SCHEDULED: "SET_ND_SCHEDULED",
		SET_FLAG_LOGDIAL: "SET_FLAG_LOGDIAL"
	};
	
	var ADMIN_MODAL_ACTIONS = exports.ADMIN_MODAL_ACTIONS = {
		SHOW_ADMIN_MODAL: 'SHOW_ADMIN_MODAL',
		HIDE_ADMIN_MODAL: 'HIDE_ADMIN_MODAL'
	};
	
	var UNIFIED_INBOX_PERMISSIONS = exports.UNIFIED_INBOX_PERMISSIONS = {
		AllowUnassign: "AllowUnassign",
		AllowSpam: "AllowSpam"
	};
	
	var CONVERSATION_TYPES = exports.CONVERSATION_TYPES = {
		CHAT: 'CHAT',
		MAIL: 'MAIL',
		TWITTER: 'TWITTER',
		WHATSAPP: 'WHATSAPP'
	};
	
	var CONVERSATION_TYPES_IDS = exports.CONVERSATION_TYPES_IDS = {
		CHAT: 1,
		MAIL: 2,
		TWITTER: 3,
		WHATSAPP: 5
	};
	
	var AGENT_PERMISSIONS_ACTIONS = exports.AGENT_PERMISSIONS_ACTIONS = {
		ALLOW_PLAY_RECORDS_ON_CALL_HISTORY: 'ALLOW_PLAY_RECORDS_ON_CALL_HISTORY',
		SET_ALLOW_CHANGE_DIALING: 'SET_ALLOW_CHANGE_DIALING'
	};
	
	var AGENT_PERMISSIONS = exports.AGENT_PERMISSIONS = {
		AllowPlayRecordsOnCallHistory: 'AllowPlayRecordsOnCallHistory'
	};
	
	var LANGUAGE = exports.LANGUAGE = {
		0: 'es',
		1: 'en',
		2: 'pt'
	};
	
	var OUTBOUND_CAMP_TYPES = exports.OUTBOUND_CAMP_TYPES = {
		WHATSAPP: 5
	};
	
	var MANUAL_MESSAGES_STATUS = exports.MANUAL_MESSAGES_STATUS = {
		SEND: 0,
		SENDING: 1,
		INCORRECT_NUMBER: 2,
		NETWORK_ERROR: 3,
		PROVIDER_ERROR: 4,
		SYSTEM_ERROR: 5
	};
	
	var MANUAL_MESSAGES_STATUS_CODE = exports.MANUAL_MESSAGES_STATUS_CODE = {
		0: 'SEND',
		1: 'SENDING',
		2: 'INCORRECT_NUMBER',
		3: 'NETWORK_ERROR',
		4: 'PROVIDER_ERROR',
		5: 'SYSTEM_ERROR'
	};
	
	var MANUAL_MESSAGES_STATUS_TAG = exports.MANUAL_MESSAGES_STATUS_TAG = {
		2: 'error-number',
		3: 'error-connection',
		4: 'error-carrier',
		5: 'error-system',
		6: 'error-whatsapp-body1',
		7: 'error-whatsapp-body2'
	};
	
	var MESSAGE_STATUS = exports.MESSAGE_STATUS = {
		send: "send",
		delivered: "delivered",
		error: "error"
	};
	
	var CAMP_TYPES = exports.CAMP_TYPES = {
		IN: 0,
		OUT: 1
	};
	
	var STATE_TO_PLAY_END_AUDIO = exports.STATE_TO_PLAY_END_AUDIO = {
		LOADING: 0,
		HANG_UP_CLIENT: 1,
		HANG_UP_AGENT: 2
	};
	
	var RECORD_STATE = exports.RECORD_STATE = {
		PREVIEW: 'PREVIEW-REC',
		DIALING: 'DIALING-REC',
		DIALOG: 'DIALOG-REC',
		ERROR: 'ERROR-REC',
		ALERT: "ALERT-REC",
		WRAPUP: 'WRAPUP-REC',
		TIME_OVER: "TIMEOVER-REC",
		HOLD: 'HOLD-REC',
		DEFAULT: 'DEFAULT-REC',
		ABANDONED: 'ABANDONED-REC',
		WAITING_WRAPUP: 'WAITING-WRAPUP-REC'
	};
	
	var STATES_TO_SHOW_CTC = exports.STATES_TO_SHOW_CTC = [USER_STATE.AGENT_PREVIEW, USER_STATE.READY_PREVIEW];

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(35);
	var core = __webpack_require__(46);
	var hide = __webpack_require__(78);
	var redefine = __webpack_require__(68);
	var ctx = __webpack_require__(91);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if (target) redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.getScrollbarWidth = getScrollbarWidth;
	exports.setScrollbarWidth = setScrollbarWidth;
	exports.isBodyOverflowing = isBodyOverflowing;
	exports.getOriginalBodyPadding = getOriginalBodyPadding;
	exports.conditionallyUpdateScrollbar = conditionallyUpdateScrollbar;
	exports.setGlobalCssModule = setGlobalCssModule;
	exports.mapToCssModules = mapToCssModules;
	exports.omit = omit;
	exports.pick = pick;
	exports.warnOnce = warnOnce;
	exports.deprecated = deprecated;
	exports.DOMElement = DOMElement;
	exports.isReactRefObj = isReactRefObj;
	exports.toNumber = toNumber;
	exports.isObject = isObject;
	exports.isFunction = isFunction;
	exports.findDOMElements = findDOMElements;
	exports.isArrayOrNodeList = isArrayOrNodeList;
	exports.getTarget = getTarget;
	exports.addMultipleEventListeners = addMultipleEventListeners;
	exports.focusableElements = exports.defaultToggleEvents = exports.canUseDOM = exports.PopperPlacements = exports.keyCodes = exports.TransitionStatuses = exports.TransitionPropTypeKeys = exports.TransitionTimeouts = exports.tagPropType = exports.targetPropType = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	// https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.4/js/src/modal.js#L436-L443
	function getScrollbarWidth() {
	  var scrollDiv = document.createElement('div'); // .modal-scrollbar-measure styles // https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.4/scss/_modal.scss#L106-L113
	
	  scrollDiv.style.position = 'absolute';
	  scrollDiv.style.top = '-9999px';
	  scrollDiv.style.width = '50px';
	  scrollDiv.style.height = '50px';
	  scrollDiv.style.overflow = 'scroll';
	  document.body.appendChild(scrollDiv);
	  var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
	  document.body.removeChild(scrollDiv);
	  return scrollbarWidth;
	}
	
	function setScrollbarWidth(padding) {
	  document.body.style.paddingRight = padding > 0 ? padding + "px" : null;
	}
	
	function isBodyOverflowing() {
	  return document.body.clientWidth < window.innerWidth;
	}
	
	function getOriginalBodyPadding() {
	  var style = window.getComputedStyle(document.body, null);
	  return parseInt(style && style.getPropertyValue('padding-right') || 0, 10);
	}
	
	function conditionallyUpdateScrollbar() {
	  var scrollbarWidth = getScrollbarWidth(); // https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.6/js/src/modal.js#L433
	
	  var fixedContent = document.querySelectorAll('.fixed-top, .fixed-bottom, .is-fixed, .sticky-top')[0];
	  var bodyPadding = fixedContent ? parseInt(fixedContent.style.paddingRight || 0, 10) : 0;
	
	  if (isBodyOverflowing()) {
	    setScrollbarWidth(bodyPadding + scrollbarWidth);
	  }
	}
	
	var globalCssModule;
	
	function setGlobalCssModule(cssModule) {
	  globalCssModule = cssModule;
	}
	
	function mapToCssModules(className, cssModule) {
	  if (className === void 0) {
	    className = '';
	  }
	
	  if (cssModule === void 0) {
	    cssModule = globalCssModule;
	  }
	
	  if (!cssModule) return className;
	  return className.split(' ').map(function (c) {
	    return cssModule[c] || c;
	  }).join(' ');
	}
	/**
	 * Returns a new object with the key/value pairs from `obj` that are not in the array `omitKeys`.
	 */
	
	
	function omit(obj, omitKeys) {
	  var result = {};
	  Object.keys(obj).forEach(function (key) {
	    if (omitKeys.indexOf(key) === -1) {
	      result[key] = obj[key];
	    }
	  });
	  return result;
	}
	/**
	 * Returns a filtered copy of an object with only the specified keys.
	 */
	
	
	function pick(obj, keys) {
	  var pickKeys = Array.isArray(keys) ? keys : [keys];
	  var length = pickKeys.length;
	  var key;
	  var result = {};
	
	  while (length > 0) {
	    length -= 1;
	    key = pickKeys[length];
	    result[key] = obj[key];
	  }
	
	  return result;
	}
	
	var warned = {};
	
	function warnOnce(message) {
	  if (!warned[message]) {
	    /* istanbul ignore else */
	    if (typeof console !== 'undefined') {
	      console.error(message); // eslint-disable-line no-console
	    }
	
	    warned[message] = true;
	  }
	}
	
	function deprecated(propType, explanation) {
	  return function validate(props, propName, componentName) {
	    if (props[propName] !== null && typeof props[propName] !== 'undefined') {
	      warnOnce("\"" + propName + "\" property of \"" + componentName + "\" has been deprecated.\n" + explanation);
	    }
	
	    for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	      rest[_key - 3] = arguments[_key];
	    }
	
	    return propType.apply(void 0, [props, propName, componentName].concat(rest));
	  };
	} // Shim Element if needed (e.g. in Node environment)
	
	
	var Element = typeof window === 'object' && window.Element || function () {};
	
	function DOMElement(props, propName, componentName) {
	  if (!(props[propName] instanceof Element)) {
	    return new Error('Invalid prop `' + propName + '` supplied to `' + componentName + '`. Expected prop to be an instance of Element. Validation failed.');
	  }
	}
	
	var targetPropType = _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, DOMElement, _propTypes.default.shape({
	  current: _propTypes.default.any
	})]);
	
	exports.targetPropType = targetPropType;
	
	var tagPropType = _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.string, _propTypes.default.shape({
	  $$typeof: _propTypes.default.symbol,
	  render: _propTypes.default.func
	}), _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.string, _propTypes.default.shape({
	  $$typeof: _propTypes.default.symbol,
	  render: _propTypes.default.func
	})]))]);
	/* eslint key-spacing: ["error", { afterColon: true, align: "value" }] */
	// These are all setup to match what is in the bootstrap _variables.scss
	// https://github.com/twbs/bootstrap/blob/v4-dev/scss/_variables.scss
	
	
	exports.tagPropType = tagPropType;
	var TransitionTimeouts = {
	  Fade: 150,
	  // $transition-fade
	  Collapse: 350,
	  // $transition-collapse
	  Modal: 300,
	  // $modal-transition
	  Carousel: 600 // $carousel-transition
	
	}; // Duplicated Transition.propType keys to ensure that Reactstrap builds
	// for distribution properly exclude these keys for nested child HTML attributes
	// since `react-transition-group` removes propTypes in production builds.
	
	exports.TransitionTimeouts = TransitionTimeouts;
	var TransitionPropTypeKeys = ['in', 'mountOnEnter', 'unmountOnExit', 'appear', 'enter', 'exit', 'timeout', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited'];
	exports.TransitionPropTypeKeys = TransitionPropTypeKeys;
	var TransitionStatuses = {
	  ENTERING: 'entering',
	  ENTERED: 'entered',
	  EXITING: 'exiting',
	  EXITED: 'exited'
	};
	exports.TransitionStatuses = TransitionStatuses;
	var keyCodes = {
	  esc: 27,
	  space: 32,
	  enter: 13,
	  tab: 9,
	  up: 38,
	  down: 40,
	  home: 36,
	  end: 35,
	  n: 78,
	  p: 80
	};
	exports.keyCodes = keyCodes;
	var PopperPlacements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];
	exports.PopperPlacements = PopperPlacements;
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	exports.canUseDOM = canUseDOM;
	
	function isReactRefObj(target) {
	  if (target && typeof target === 'object') {
	    return 'current' in target;
	  }
	
	  return false;
	}
	
	function getTag(value) {
	  if (value == null) {
	    return value === undefined ? '[object Undefined]' : '[object Null]';
	  }
	
	  return Object.prototype.toString.call(value);
	}
	
	function toNumber(value) {
	  var type = typeof value;
	  var NAN = 0 / 0;
	
	  if (type === 'number') {
	    return value;
	  }
	
	  if (type === 'symbol' || type === 'object' && getTag(value) === '[object Symbol]') {
	    return NAN;
	  }
	
	  if (isObject(value)) {
	    var other = typeof value.valueOf === 'function' ? value.valueOf() : value;
	    value = isObject(other) ? "" + other : other;
	  }
	
	  if (type !== 'string') {
	    return value === 0 ? value : +value;
	  }
	
	  value = value.replace(/^\s+|\s+$/g, '');
	  var isBinary = /^0b[01]+$/i.test(value);
	  return isBinary || /^0o[0-7]+$/i.test(value) ? parseInt(value.slice(2), isBinary ? 2 : 8) : /^[-+]0x[0-9a-f]+$/i.test(value) ? NAN : +value;
	}
	
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type === 'object' || type === 'function');
	}
	
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	
	  var tag = getTag(value);
	  return tag === '[object Function]' || tag === '[object AsyncFunction]' || tag === '[object GeneratorFunction]' || tag === '[object Proxy]';
	}
	
	function findDOMElements(target) {
	  if (isReactRefObj(target)) {
	    return target.current;
	  }
	
	  if (isFunction(target)) {
	    return target();
	  }
	
	  if (typeof target === 'string' && canUseDOM) {
	    var selection = document.querySelectorAll(target);
	
	    if (!selection.length) {
	      selection = document.querySelectorAll("#" + target);
	    }
	
	    if (!selection.length) {
	      throw new Error("The target '" + target + "' could not be identified in the dom, tip: check spelling");
	    }
	
	    return selection;
	  }
	
	  return target;
	}
	
	function isArrayOrNodeList(els) {
	  if (els === null) {
	    return false;
	  }
	
	  return Array.isArray(els) || canUseDOM && typeof els.length === 'number';
	}
	
	function getTarget(target, allElements) {
	  var els = findDOMElements(target);
	
	  if (allElements) {
	    if (isArrayOrNodeList(els)) {
	      return els;
	    }
	
	    if (els === null) {
	      return [];
	    }
	
	    return [els];
	  } else {
	    if (isArrayOrNodeList(els)) {
	      return els[0];
	    }
	
	    return els;
	  }
	}
	
	var defaultToggleEvents = ['touchstart', 'click'];
	exports.defaultToggleEvents = defaultToggleEvents;
	
	function addMultipleEventListeners(_els, handler, _events, useCapture) {
	  var els = _els;
	
	  if (!isArrayOrNodeList(els)) {
	    els = [els];
	  }
	
	  var events = _events;
	
	  if (typeof events === 'string') {
	    events = events.split(/\s+/);
	  }
	
	  if (!isArrayOrNodeList(els) || typeof handler !== 'function' || !Array.isArray(events)) {
	    throw new Error("\n      The first argument of this function must be DOM node or an array on DOM nodes or NodeList.\n      The second must be a function.\n      The third is a string or an array of strings that represents DOM events\n    ");
	  }
	
	  Array.prototype.forEach.call(events, function (event) {
	    Array.prototype.forEach.call(els, function (el) {
	      el.addEventListener(event, handler, useCapture);
	    });
	  });
	  return function removeEvents() {
	    Array.prototype.forEach.call(events, function (event) {
	      Array.prototype.forEach.call(els, function (el) {
	        el.removeEventListener(event, handler, useCapture);
	      });
	    });
	  };
	}
	
	var focusableElements = ['a[href]', 'area[href]', 'input:not([disabled]):not([type=hidden])', 'select:not([disabled])', 'textarea:not([disabled])', 'button:not([disabled])', 'object', 'embed', '[tabindex]:not(.modal)', 'audio[controls]', 'video[controls]', '[contenteditable]:not([contenteditable="false"])'];
	exports.focusableElements = focusableElements;

/***/ },
/* 13 */
12,
/* 14 */
12,
/* 15 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _setPrototypeOf = __webpack_require__(1200);
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _create = __webpack_require__(1199);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _typeof2 = __webpack_require__(337);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
	  }
	
	  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	};

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _typeof2 = __webpack_require__(337);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	};

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(516);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ },
/* 19 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	var setPrototypeOf = __webpack_require__(486);
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  setPrototypeOf(subClass, superClass);
	}
	module.exports = _inheritsLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 21 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var instance = null;
	var jsonLanguage = {};
	
	var Singleton = function () {
	  function Singleton() {
	    _classCallCheck(this, Singleton);
	
	    if (!instance) {
	      instance = this;
	    }
	    this.current_Language = '-1';
	    return instance;
	  }
	
	  _createClass(Singleton, [{
	    key: 'setLanguage',
	    value: function setLanguage(c_language) {
	      this.current_Language = c_language;
	    }
	  }, {
	    key: 'getLanguage',
	    value: function getLanguage() {
	      return this.current_Language;
	    }
	  }, {
	    key: 'getText',
	    value: function getText(key) {
	      return jsonLanguage[key];
	    }
	  }, {
	    key: 'jsonGut',
	    value: function jsonGut(jsonObject) {
	      var father = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	      var propValue;
	      var key;
	      for (var propName in jsonObject) {
	        propValue = jsonObject[propName];
	        if (this.typeOf(propValue) === 'string') {
	          switch (propValue.toLowerCase()) {
	            case "january":
	            case "enero":
	              jsonLanguage['January'] = propValue;
	              break;
	            case "february":
	            case "febrero":
	              jsonLanguage['February'] = propValue;
	              break;
	            case "march":
	            case "marzo":
	              jsonLanguage['March'] = propValue;
	              break;
	            case "april":
	            case "abril":
	              jsonLanguage['April'] = propValue;
	              break;
	            case "may":
	            case "mayo":
	              jsonLanguage['May'] = propValue;
	              break;
	            case "june":
	            case "junio":
	              jsonLanguage['June'] = propValue;
	              break;
	            case "july":
	            case "julio":
	              jsonLanguage['July'] = propValue;
	              break;
	            case "august":
	            case "agosto":
	              jsonLanguage['August'] = propValue;
	              break;
	            case "september":
	            case "septiembre":
	              jsonLanguage['September'] = propValue;
	              break;
	            case "october":
	            case "octubre":
	              jsonLanguage['October'] = propValue;
	              break;
	            case "november":
	            case "noviembre":
	              jsonLanguage['November'] = propValue;
	              break;
	            case "december":
	            case "diciembre":
	              jsonLanguage['December'] = propValue;
	              break;
	            default:
	              key = father + propName;
	              key = key.replace("parameters", "");
	              key = key.replace("Internacionlizacion", "");
	              jsonLanguage[key] = propValue;
	              break;
	          }
	        } else {
	          this.jsonGut(propValue, father + propName);
	        }
	      }
	    }
	  }, {
	    key: 'jsonAlert',
	    value: function jsonAlert(_jsonAlert) {
	      var propValue;
	      for (var propName in _jsonAlert['catalogueAlert']['Alert']) {
	        propValue = _jsonAlert['catalogueAlert']['Alert'][propName];
	        jsonLanguage['alert-' + propValue['code']] = propValue['message'];
	      }
	    }
	  }, {
	    key: 'jsonError',
	    value: function jsonError(_jsonError) {
	      var propValue;
	      for (var propName in _jsonError['catalogueError']['error']) {
	        propValue = _jsonError['catalogueError']['error'][propName];
	        jsonLanguage['error-' + propValue['code']] = propValue['message'];
	      }
	    }
	  }, {
	    key: 'setJsonLanguage',
	    value: function setJsonLanguage(json) {
	      jsonLanguage = {};
	      this.jsonGut(json.Response[0]);
	      this.jsonAlert(json.Response[1]);
	      this.jsonError(json.Response[2]);
	    }
	  }, {
	    key: 'typeOf',
	    value: function typeOf(obj) {
	      return {}.toString.call(obj).split(' ')[1].slice(0, -1).toLowerCase();
	    }
	  }]);

	  return Singleton;
	}();

	exports.Singleton = Singleton;

/***/ },
/* 22 */
/***/ function(module, exports) {

	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	  return self;
	}
	module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.SingletonSharedData = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _constants = __webpack_require__(10);
	
	var _NoAvailableIconsSVG = __webpack_require__(1060);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var instance = null;
	
	var SingletonSharedData = exports.SingletonSharedData = function () {
		function SingletonSharedData() {
			var _windowsOpened, _expandedWindowsToClo;
	
			_classCallCheck(this, SingletonSharedData);
	
			if (!instance) {
				instance = this;
			}
			this.volumeSpeaker = 50;
			this.volumeMic = 50;
			this.currentSoftPhone = _constants.SOFTPHONES_KEY.WebRTC;
			this.problemInManualCall = false;
			this.ipAddress = '';
			this.ipAddressAPI = '';
			this.ipIntegration = '';
			this.chatsList = {};
			this.integrationPort = '';
			this.integrationServer = '';
			this.integrationAutorun = false;
			this.integrationIconActived = false;
			this.integrationConnectionStatus = _constants.STATES_INTEGRATION.disconnecting;
			this.integrationLog = [];
			this.chatListNotReaded = {};
			this.currentTimeInState = 0;
			this.barExpanded = false;
			this.isLogged = false;
			this.manualCallTime = 0;
			this.XferTime = 0;
			this.chatWindowOpen = false;
			this.supervisorChat = '';
			this.textToSendSupervisorChat = '';
			this.currentCallTime = '';
			this.currentCallMarks = [];
			this.extraCallsConference = 0;
			this.hasUnifiedMessage = false;
			this.telephoneCallBack = '';
			this.currentState = 'logout';
			this.assistedTransferState = '';
			this.requestTimeout = 60000;
			this.isPreview = false;
			this.isAssisted = false;
			this.selectedConversationId = 0;
			this.prevNotificationError = true;
			this.dataObject = {}, this.dataPreviewPro = {}, this.callDataPreviewPro = {}, this.isCallPreview = false, this.isInactiveState = false;
			this.isTabFocused = true, this.iconsNA = {
				1: _NoAvailableIconsSVG.naBreak,
				2: _NoAvailableIconsSVG.banio,
				3: _NoAvailableIconsSVG.conCliente,
				4: _NoAvailableIconsSVG.conSupervisor,
				5: _NoAvailableIconsSVG.aclaracion,
				6: _NoAvailableIconsSVG.junta,
				7: _NoAvailableIconsSVG.comida,
				8: _NoAvailableIconsSVG.sistemas,
				9: _NoAvailableIconsSVG.cafe,
				10: _NoAvailableIconsSVG.agua,
				11: _NoAvailableIconsSVG.otro,
				12: _NoAvailableIconsSVG.duda,
				13: _NoAvailableIconsSVG.salud,
				14: _NoAvailableIconsSVG.queja,
				15: _NoAvailableIconsSVG.dinero,
				16: _NoAvailableIconsSVG.cambio
			};
	
			this.windowsOpened = (_windowsOpened = {}, _defineProperty(_windowsOpened, _constants.DRAGGABLE_WINDOWS.MANUAL_CALL, false), _defineProperty(_windowsOpened, _constants.DRAGGABLE_WINDOWS.NO_AVAILABLE, false), _defineProperty(_windowsOpened, _constants.DRAGGABLE_WINDOWS.SUPERVISOR_CHAT, false), _defineProperty(_windowsOpened, _constants.DRAGGABLE_WINDOWS.NO_AVAILABLE_RECORD, false), _defineProperty(_windowsOpened, _constants.DRAGGABLE_WINDOWS.CALL_RECORD, false), _windowsOpened);
			//TheFollowing array helps identify the components to be closed when another expanded component is open
			this.expandedWindowsToClose = (_expandedWindowsToClo = {}, _defineProperty(_expandedWindowsToClo, _constants.DRAGGABLE_WINDOWS.NO_AVAILABLE, [_constants.DRAGGABLE_WINDOWS.SUPERVISOR_CHAT, _constants.DRAGGABLE_WINDOWS.NO_AVAILABLE_RECORD]), _defineProperty(_expandedWindowsToClo, _constants.DRAGGABLE_WINDOWS.SUPERVISOR_CHAT, [_constants.DRAGGABLE_WINDOWS.NO_AVAILABLE, _constants.DRAGGABLE_WINDOWS.NO_AVAILABLE_RECORD]), _defineProperty(_expandedWindowsToClo, _constants.DRAGGABLE_WINDOWS.NO_AVAILABLE_RECORD, [_constants.DRAGGABLE_WINDOWS.SUPERVISOR_CHAT, _constants.DRAGGABLE_WINDOWS.NO_AVAILABLE]), _expandedWindowsToClo);
			this.windowExpandedActive = _constants.DRAGGABLE_WINDOWS.NONE;
			this.isIntegration = false;
			this.isIntegrationManualCall = false;
			this.windowChatOpen = false;
			this.secureConnection = false;
			this.callOutCampaigns = null;
			this.versionAgentKolob = '';
			this.country = '';
			this.campID = '';
			this.focusTel = false;
			this.isRated = false;
			this.isPendingMessage = false;
			this.audioNotificationCallStart = null;
			this.audioNotificationCallEnd = null;
			this.isHangedUpByAgent = _constants.STATE_TO_PLAY_END_AUDIO.LOADING;
			this.odbcExternalCall = false;
			this.AllowMarksPermission = true;
			this.callIcon = null;
			this.integrationCallData = null;
			this.sendDataOncallout = false;
			this.aniList = [];
			this.isANIListEmpty = false;
			this.agentList = [];
			this.doConnectCall = true;
			return instance;
		}
	
		_createClass(SingletonSharedData, [{
			key: 'setAllowMarksPermission',
			value: function setAllowMarksPermission(value) {
				this.AllowMarksPermission = value;
			}
		}, {
			key: 'getAllowMarksPermission',
			value: function getAllowMarksPermission() {
				return this.AllowMarksPermission;
			}
		}, {
			key: 'setOdbcExternalCall',
			value: function setOdbcExternalCall(value) {
				this.odbcExternalCall = value;
			}
		}, {
			key: 'getOdbcExternalCall',
			value: function getOdbcExternalCall() {
				return this.odbcExternalCall;
			}
		}, {
			key: 'setIsTabFocused',
			value: function setIsTabFocused(value) {
				this.isTabFocused = value;
			}
		}, {
			key: 'getIsTabFocused',
			value: function getIsTabFocused() {
				return this.isTabFocused;
			}
		}, {
			key: 'setIsRated',
			value: function setIsRated(value) {
				this.isRated = value;
			}
		}, {
			key: 'getIsRated',
			value: function getIsRated() {
				return this.isRated;
			}
		}, {
			key: 'setVolumeSpeaker',
			value: function setVolumeSpeaker(volumeSpeaker) {
				this.volumeSpeaker = volumeSpeaker;
			}
		}, {
			key: 'getVolumeSpeaker',
			value: function getVolumeSpeaker() {
				return this.volumeSpeaker;
			}
		}, {
			key: 'setVolumeMic',
			value: function setVolumeMic(volumeMic) {
				this.volumeMic = volumeMic;
			}
		}, {
			key: 'getVolumeMic',
			value: function getVolumeMic() {
				return this.volumeMic;
			}
		}, {
			key: 'setIPIntegration',
			value: function setIPIntegration(ipAddress) {
				this.ipIntegration = ipAddress;
			}
		}, {
			key: 'getIPIntegration',
			value: function getIPIntegration() {
				return this.ipAddress;
			}
		}, {
			key: 'setIPAddress',
			value: function setIPAddress(ipAddress) {
				this.ipAddress = ipAddress;
			}
		}, {
			key: 'getIPAddress',
			value: function getIPAddress() {
				return this.ipAddress;
			}
		}, {
			key: 'setCampaingID',
			value: function setCampaingID(campID) {
				this.campID = campID;
			}
		}, {
			key: 'getCampaingID',
			value: function getCampaingID() {
				return this.campID;
			}
		}, {
			key: 'setIPfromAPI',
			value: function setIPfromAPI(ipAddressAPI) {
				this.ipAddressAPI = ipAddressAPI;
			}
		}, {
			key: 'getIPfromAPI',
			value: function getIPfromAPI() {
				return this.ipAddressAPI;
			}
		}, {
			key: 'getCurrentState',
			value: function getCurrentState() {
				return this.currentState;
			}
		}, {
			key: 'setCurrentState',
			value: function setCurrentState(currentState) {
				this.currentState = currentState;
			}
		}, {
			key: 'setIsIntegration',
			value: function setIsIntegration() {
				this.isIntegration = !this.isIntegration;
			}
		}, {
			key: 'getIsIntegration',
			value: function getIsIntegration() {
				return this.isIntegration;
			}
		}, {
			key: 'setIsIntegrationManualCall',
			value: function setIsIntegrationManualCall() {
				this.isIntegrationManualCall = !this.isIntegrationManualCall;
			}
		}, {
			key: 'getIsIntegrationManualCall',
			value: function getIsIntegrationManualCall() {
				return this.isIntegrationManualCall;
			}
		}, {
			key: 'setIntegrationConnectionStatus',
			value: function setIntegrationConnectionStatus(newStatus) {
				this.integrationConnectionStatus = newStatus;
			}
		}, {
			key: 'getIntegrationConnectionStatus',
			value: function getIntegrationConnectionStatus() {
				return this.integrationConnectionStatus;
			}
		}, {
			key: 'setIntegrationConfiguration',
			value: function setIntegrationConfiguration(integrations) {
				var integrationData = integrations.split('|');
				// IP|WEBSOCKETPORT|SOCKETPORT|AUTORUN|ICONACTIVED
				this.integrationPort = this.secureConnection ? integrationData[2] : integrationData[1];
	
				console.log('readhostname integrationPort', this.integrationPort);
				this.integrationIconActived = integrationData[4] === '1';
				if (integrationData[4] === '1') {
					this.integrationAutorun = integrationData[3] === '1';
				}
			}
		}, {
			key: 'getIntegrationServer',
			value: function getIntegrationServer() {
				return this.integrationServer;
			}
		}, {
			key: 'getIntegrationPort',
			value: function getIntegrationPort() {
				return this.integrationPort;
			}
		}, {
			key: 'getIntegrationAutorun',
			value: function getIntegrationAutorun() {
				return this.integrationAutorun;
			}
		}, {
			key: 'getintegrationIconActived',
			value: function getintegrationIconActived() {
				return this.integrationIconActived;
			}
		}, {
			key: 'getIntegrationLog',
			value: function getIntegrationLog() {
				return this.integrationLog;
			}
		}, {
			key: 'setIntegrationLog',
			value: function setIntegrationLog(updatedLog) {
				this.integrationLog = updatedLog;
			}
		}, {
			key: 'setWindowExpandedActive',
			value: function setWindowExpandedActive(windowTag) {
				this.windowExpandedActive = windowTag;
			}
		}, {
			key: 'getWindowExpandedActive',
			value: function getWindowExpandedActive() {
				return this.windowExpandedActive;
			}
		}, {
			key: 'setStateWindow',
			value: function setStateWindow(windowTag, windowState) {
				if (!windowState) {
					this.windowsOpened[windowTag] = windowState;
				} else {
					this.windowsOpened[windowTag] = !this.windowsOpened[windowTag];
				}
			}
		}, {
			key: 'getExpandedWindowsToClose',
			value: function getExpandedWindowsToClose(newUpenWindow) {
				return this.expandedWindowsToClose[newUpenWindow];
			}
		}, {
			key: 'getStateWindow',
			value: function getStateWindow(windowTag) {
				return this.windowsOpened[windowTag];
			}
		}, {
			key: 'setPhoneCallBack',
			value: function setPhoneCallBack(phone) {
				this.telephoneCallBack = phone;
			}
		}, {
			key: 'getPhoneCallBack',
			value: function getPhoneCallBack() {
				return this.telephoneCallBack;
			}
		}, {
			key: 'setSoftPhone',
			value: function setSoftPhone(softPhone) {
				this.currentSoftPhone = softPhone;
			}
		}, {
			key: 'getSoftPhone',
			value: function getSoftPhone() {
				return this.currentSoftPhone;
			}
		}, {
			key: 'setLogged',
			value: function setLogged(logged) {
				this.isLogged = logged;
			}
		}, {
			key: 'getLogged',
			value: function getLogged() {
				return this.isLogged;
			}
		}, {
			key: 'setUserData',
			value: function setUserData(user) {
				this.user = user;
				this.setDataPreviewPro(user.DialingMode, user.AllowChangeDialingMode);
			}
		}, {
			key: 'setPhoneNumber',
			value: function setPhoneNumber(phoneNumber) {
				this.phoneNumber = phoneNumber;
			}
		}, {
			key: 'setParameters',
			value: function setParameters(parameters) {
				this.parameters = parameters;
			}
		}, {
			key: 'setPermissions',
			value: function setPermissions(permissions) {
				this.permissions = Object.assign({}, permissions);
			}
		}, {
			key: 'setGeneralPermissions',
			value: function setGeneralPermissions(generalPermissions) {
				this.generalPermissions = generalPermissions;
			}
		}, {
			key: 'setCallOutCampaigns',
			value: function setCallOutCampaigns(callOutCampaigns) {
				this.callOutCampaigns = callOutCampaigns;
			}
		}, {
			key: 'setANIListCampaign',
			value: function setANIListCampaign(aniList) {
				this.aniList = aniList;
			}
		}, {
			key: 'setIsANIListEmpty',
			value: function setIsANIListEmpty(isANIListEmpty) {
				this.isANIListEmpty = isANIListEmpty;
			}
		}, {
			key: 'setCurrentTimeInState',
			value: function setCurrentTimeInState(currentTime) {
				this.currentTimeInState = currentTime;
			}
		}, {
			key: 'getUserData',
			value: function getUserData() {
				return this.user;
			}
		}, {
			key: 'getPhoneNumber',
			value: function getPhoneNumber() {
				return this.phoneNumber;
			}
		}, {
			key: 'getParameters',
			value: function getParameters() {
				return this.parameters;
			}
		}, {
			key: 'getPermissions',
			value: function getPermissions() {
				return this.permissions;
			}
		}, {
			key: 'getGeneralPermissions',
			value: function getGeneralPermissions() {
				return this.generalPermissions;
			}
		}, {
			key: 'isInCallState',
			value: function isInCallState(userState) {
				if (userState === _constants.USER_STATE.DIALOG || userState === _constants.USER_STATE.WRAPUP || userState === _constants.USER_STATE.ASSISTED || this.isLogged && userState === _constants.USER_STATE.OTHER) {
					return true;
				}
				return false;
			}
		}, {
			key: 'setBarExpandedShowed',
			value: function setBarExpandedShowed(barExpanded) {
				this.barExpanded = barExpanded;
			}
		}, {
			key: 'isBarExpandedSowed',
			value: function isBarExpandedSowed() {
				return this.barExpanded;
			}
		}, {
			key: 'getIconNoAvailable',
			value: function getIconNoAvailable(frame) {
				return this.iconsNA[frame];
			}
	
			//SUPERVISOR LIST FUNCTIONS
	
		}, {
			key: 'setSupervisorList',
			value: function setSupervisorList(supervisorList) {
				this.supervisorList = supervisorList;
				this.supervisorObserver(supervisorList);
			}
		}, {
			key: 'observerSupervisor',
			value: function observerSupervisor(supervisorObserver) {
				this.supervisorObserver = supervisorObserver;
			}
		}, {
			key: 'getSupervisorList',
			value: function getSupervisorList() {
				return this.supervisorList;
			}
		}, {
			key: 'setChatWindowOpen',
			value: function setChatWindowOpen(open) {
				this.chatWindowOpen = open;
			}
		}, {
			key: 'getChatWindowOpen',
			value: function getChatWindowOpen() {
				return this.chatWindowOpen;
			}
		}, {
			key: 'clearChatList',
			value: function clearChatList() {
				this.chatsList = {};
			}
		}, {
			key: 'setObjectChat',
			value: function setObjectChat(object, chatList) {
				if (!this.chatsList[chatList]) {
					this.chatsList[chatList] = [];
				}
				this.chatsList[chatList].push(object);
			}
		}, {
			key: 'getChatList',
			value: function getChatList(chatList) {
				if (typeof this.chatsList[chatList] === 'undefined') {
					return [];
				}
				return this.chatsList[chatList];
			}
		}, {
			key: 'setNewNotificationChat',
			value: function setNewNotificationChat(chatList) {
				var resetChat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
				if (!this.chatListNotReaded[chatList]) {
					this.chatListNotReaded[chatList] = 1;
				} else {
					this.chatListNotReaded[chatList]++;
				}
				if (resetChat) {
					this.chatListNotReaded[chatList] = 0;
				}
			}
		}, {
			key: 'getNotificationChat',
			value: function getNotificationChat(chatList) {
				return this.chatListNotReaded[chatList];
			}
		}, {
			key: 'setCurrentSuperVisor',
			value: function setCurrentSuperVisor(supervisor) {
				this.supervisorChat = supervisor;
			}
		}, {
			key: 'getCurrentSuperVisor',
			value: function getCurrentSuperVisor() {
				return this.supervisorChat;
			}
		}, {
			key: 'setTextToSend',
			value: function setTextToSend(textToSend) {
				this.textToSendSupervisorChat = textToSend;
			}
		}, {
			key: 'getTextToSend',
			value: function getTextToSend() {
				return this.textToSendSupervisorChat;
			}
		}, {
			key: 'setCurrentCallTime',
			value: function setCurrentCallTime(currentCallTime) {
				this.currentCallTime = currentCallTime;
			}
		}, {
			key: 'getCurrentCallTime',
			value: function getCurrentCallTime() {
				return this.currentCallTime;
			}
		}, {
			key: 'setCurrentCallMarks',
			value: function setCurrentCallMarks(currentCallMarks) {
				this.currentCallMarks = currentCallMarks;
			}
		}, {
			key: 'getCurrentCallMarks',
			value: function getCurrentCallMarks() {
				return this.currentCallMarks;
			}
		}, {
			key: 'setManualCallTime',
			value: function setManualCallTime(time) {
				this.manualCallTime = time;
			}
		}, {
			key: 'getManualCallTime',
			value: function getManualCallTime() {
				return this.manualCallTime;
			}
		}, {
			key: 'setXferTime',
			value: function setXferTime(time) {
				this.XferTime = time;
			}
		}, {
			key: 'getXferTime',
			value: function getXferTime() {
				return this.XferTime;
			}
		}, {
			key: 'setConferenceCallID',
			value: function setConferenceCallID(callID) {
				this.conferenceCallID = callID;
			}
		}, {
			key: 'getConferenceCallID',
			value: function getConferenceCallID() {
				return this.conferenceCallID;
			}
		}, {
			key: 'setConferenceHangUpOther',
			value: function setConferenceHangUpOther(callID) {
				this.conferenceHangUpOther = callID;
			}
		}, {
			key: 'getConferenceHangUpOther',
			value: function getConferenceHangUpOther() {
				return this.conferenceHangUpOther;
			}
		}, {
			key: 'addCallConference',
			value: function addCallConference() {
				this.extraCallsConference++;
			}
		}, {
			key: 'substractCallConference',
			value: function substractCallConference() {
				this.extraCallsConference--;
			}
		}, {
			key: 'getextraCallsConference',
			value: function getextraCallsConference() {
				return this.extraCallsConference;
			}
		}, {
			key: 'setCallConferencetoZero',
			value: function setCallConferencetoZero() {
				this.extraCallsConference = 0;
			}
		}, {
			key: 'setConferenceNewNumber',
			value: function setConferenceNewNumber(newNumber) {
				this.conferenceNewNumber = newNumber;
			}
		}, {
			key: 'getConferenceNewNumber',
			value: function getConferenceNewNumber() {
				return this.conferenceNewNumber;
			}
		}, {
			key: 'setWindowChatOpen',
			value: function setWindowChatOpen(chatOpen) {
				this.windowChatOpen = chatOpen;
			}
		}, {
			key: 'getWindowChatOpen',
			value: function getWindowChatOpen(chatOpen) {
				return this.windowChatOpen;
			}
		}, {
			key: 'getSecureConnection',
			value: function getSecureConnection() {
				return this.secureConnection;
			}
		}, {
			key: 'setSecureConnection',
			value: function setSecureConnection(secureConnection) {
				this.secureConnection = secureConnection;
			}
		}, {
			key: 'setVersionAgent',
			value: function setVersionAgent(versionAgentKolob) {
				this.versionAgentKolob = versionAgentKolob;
			}
		}, {
			key: 'getVersionAgent',
			value: function getVersionAgent() {
				return this.versionAgentKolob;
			}
		}, {
			key: 'setCountry',
			value: function setCountry(country) {
				this.country = country;
			}
		}, {
			key: 'getCountry',
			value: function getCountry() {
				return this.country;
			}
		}, {
			key: 'setFocusTel',
			value: function setFocusTel(focusTel) {
				this.focusTel = focusTel;
			}
		}, {
			key: 'getFocusTel',
			value: function getFocusTel() {
				return this.focusTel;
			}
		}, {
			key: 'getAssistedTransferCurrentState',
			value: function getAssistedTransferCurrentState() {
				return this.assistedTransferState;
			}
		}, {
			key: 'setAssistedTransferCurrentState',
			value: function setAssistedTransferCurrentState(assistedTransferState) {
				this.assistedTransferState = assistedTransferState;
			}
		}, {
			key: 'setRequestTimeout',
			value: function setRequestTimeout(requestTimeout) {
				var castNumber = parseInt(requestTimeout, 10);
				if (Number.isInteger(castNumber)) {
					this.requestTimeout = castNumber;
				}
			}
		}, {
			key: 'getRequestTimeout',
			value: function getRequestTimeout() {
				return this.requestTimeout;
			}
		}, {
			key: 'setIsAssisted',
			value: function setIsAssisted(isAssisted) {
				this.isAssisted = isAssisted;
			}
		}, {
			key: 'getIsAssisted',
			value: function getIsAssisted() {
				return this.isAssisted;
			}
		}, {
			key: 'setDataAssistedCall',
			value: function setDataAssistedCall(dataCall) {
				this.dataObject = {
					campaingName: dataCall.CampaignName,
					iconCampaing: dataCall.GraphId,
					calKey: dataCall.CallKey,
					Id: dataCall.CamId,
					iconCall: '1',
					enableBtnAssistedCall: dataCall.ExitAssistedDialMode,
					CallOutId: dataCall.CallOutId
				};
				this.phoneNumber = dataCall.PhoneNumber;
			}
		}, {
			key: 'getDataAssistedCall',
			value: function getDataAssistedCall() {
				return this.dataObject;
			}
		}, {
			key: 'getIsEnableBtnExitAssited',
			value: function getIsEnableBtnExitAssited() {
				return this.dataObject.enableBtnAssistedCall;
			}
		}, {
			key: 'getIsPendingMessage',
			value: function getIsPendingMessage() {
				return this.isPendingMessage;
			}
		}, {
			key: 'setIsPendingMessage',
			value: function setIsPendingMessage(isPendingMessage) {
				this.isPendingMessage = isPendingMessage;
			}
		}, {
			key: 'getSelectedConversationId',
			value: function getSelectedConversationId() {
				return this.selectedConversationId;
			}
		}, {
			key: 'setSelectedConversationId',
			value: function setSelectedConversationId(conversationId) {
				this.selectedConversationId = conversationId;
			}
		}, {
			key: 'getPrevNotificationError',
			value: function getPrevNotificationError() {
				return this.prevNotificationError;
			}
		}, {
			key: 'setPrevNotificationError',
			value: function setPrevNotificationError(value) {
				this.prevNotificationError = value;
			}
		}, {
			key: 'setDataPreviewPro',
			value: function setDataPreviewPro(dialingMode, allowChangeDialMode) {
				this.dataPreviewPro = {
					dialingMode: dialingMode,
					allowChangeDialMode: allowChangeDialMode
				};
			}
		}, {
			key: 'getDataPreviewPro',
			value: function getDataPreviewPro() {
				return this.dataPreviewPro;
			}
		}, {
			key: 'setDataCallPreview',
			value: function setDataCallPreview(data) {
				this.callDataPreviewPro = {
					CampaignName: data.CampaignName ? data.CampaignName : '',
					iconCampaing: data.GraphId ? data.GraphId : '',
					CamId: data.Cam_id,
					WrapUpTime: data.WrapUpTime,
					PreviewTime: data.previewTime,
					CallKey: data.CallKey ? data.CallKey : '',
					CallId: data.CallOut_id,
					Phone: data.Phone,
					DataContact: data.DataContact,
					DataHeaders: data.DataHeaders,
					PermissionDiscard: data.PermissionDiscard
				};
			}
		}, {
			key: 'getDataCallPreview',
			value: function getDataCallPreview() {
				return this.callDataPreviewPro;
			}
		}, {
			key: 'setIsInactiveState',
			value: function setIsInactiveState(isInactive) {
				this.isInactiveState = isInactive;
			}
		}, {
			key: 'getIsInactiveState',
			value: function getIsInactiveState() {
				return this.isInactiveState;
			}
		}, {
			key: 'setAudioNotificationCallStart',
			value: function setAudioNotificationCallStart(audio) {
				this.audioNotificationCallStart = audio;
			}
		}, {
			key: 'getAudioNotificationCallStart',
			value: function getAudioNotificationCallStart() {
				return this.audioNotificationCallStart;
			}
		}, {
			key: 'setAudioNotificationCallEnd',
			value: function setAudioNotificationCallEnd(audio) {
				this.audioNotificationCallEnd = audio;
			}
		}, {
			key: 'getAudioNotificationCallEnd',
			value: function getAudioNotificationCallEnd() {
				return this.audioNotificationCallEnd;
			}
		}, {
			key: 'setIsHangedUpByAgent',
			value: function setIsHangedUpByAgent(isHangedUp) {
				this.isHangedUpByAgent = isHangedUp;
			}
		}, {
			key: 'getIsHangedUpByAgent',
			value: function getIsHangedUpByAgent() {
				return this.isHangedUpByAgent;
			}
		}, {
			key: 'setCallIcon',
			value: function setCallIcon(callIcon) {
				this.callIcon = callIcon;
			}
		}, {
			key: 'getCallIcon',
			value: function getCallIcon() {
				return this.callIcon;
			}
		}, {
			key: 'setIntegrationCallData',
			value: function setIntegrationCallData(integrationCallData) {
				this.integrationCallData = integrationCallData;
			}
		}, {
			key: 'getIntegrationCallData',
			value: function getIntegrationCallData() {
				return this.integrationCallData;
			}
		}, {
			key: 'setSendDataOncallout',
			value: function setSendDataOncallout(send) {
				this.sendDataOncallout = send;
			}
		}, {
			key: 'getSendDataOncallout',
			value: function getSendDataOncallout() {
				return this.sendDataOncallout;
			}
		}, {
			key: 'setAgentList',
			value: function setAgentList(agentList) {
				this.agentList = agentList;
			}
		}, {
			key: 'getAgentList',
			value: function getAgentList() {
				return this.agentList;
			}
		}, {
			key: 'setDoConnectCall',
			value: function setDoConnectCall(flag) {
				this.doConnectCall = flag;
			}
		}, {
			key: 'getDoConnectCall',
			value: function getDoConnectCall() {
				return this.doConnectCall;
			}
		}]);

		return SingletonSharedData;
	}();

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports._curry = exports.bsSizes = exports.bsStyles = exports.bsClass = undefined;
	
	var _entries = __webpack_require__(517);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.prefix = prefix;
	exports.getClassSet = getClassSet;
	exports.splitBsProps = splitBsProps;
	exports.splitBsPropsAndOmit = splitBsPropsAndOmit;
	exports.addStyle = addStyle;
	
	var _invariant = __webpack_require__(124);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _StyleConfig = __webpack_require__(64);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function curry(fn) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var last = args[args.length - 1];
	    if (typeof last === 'function') {
	      return fn.apply(undefined, args);
	    }
	    return function (Component) {
	      return fn.apply(undefined, args.concat([Component]));
	    };
	  };
	} // TODO: The publicly exposed parts of this should be in lib/BootstrapUtils.
	
	function prefix(props, variant) {
	  !(props.bsClass != null) ?  false ? (0, _invariant2['default'])(false, 'A `bsClass` prop is required for this component') : (0, _invariant2['default'])(false) : void 0;
	  return props.bsClass + (variant ? '-' + variant : '');
	}
	
	var bsClass = exports.bsClass = curry(function (defaultClass, Component) {
	  var propTypes = Component.propTypes || (Component.propTypes = {});
	  var defaultProps = Component.defaultProps || (Component.defaultProps = {});
	
	  propTypes.bsClass = _propTypes2['default'].string;
	  defaultProps.bsClass = defaultClass;
	
	  return Component;
	});
	
	var bsStyles = exports.bsStyles = curry(function (styles, defaultStyle, Component) {
	  if (typeof defaultStyle !== 'string') {
	    Component = defaultStyle;
	    defaultStyle = undefined;
	  }
	
	  var existing = Component.STYLES || [];
	  var propTypes = Component.propTypes || {};
	
	  styles.forEach(function (style) {
	    if (existing.indexOf(style) === -1) {
	      existing.push(style);
	    }
	  });
	
	  var propType = _propTypes2['default'].oneOf(existing);
	
	  // expose the values on the propType function for documentation
	  Component.STYLES = propType._values = existing;
	
	  Component.propTypes = (0, _extends3['default'])({}, propTypes, {
	    bsStyle: propType
	  });
	
	  if (defaultStyle !== undefined) {
	    var defaultProps = Component.defaultProps || (Component.defaultProps = {});
	    defaultProps.bsStyle = defaultStyle;
	  }
	
	  return Component;
	});
	
	var bsSizes = exports.bsSizes = curry(function (sizes, defaultSize, Component) {
	  if (typeof defaultSize !== 'string') {
	    Component = defaultSize;
	    defaultSize = undefined;
	  }
	
	  var existing = Component.SIZES || [];
	  var propTypes = Component.propTypes || {};
	
	  sizes.forEach(function (size) {
	    if (existing.indexOf(size) === -1) {
	      existing.push(size);
	    }
	  });
	
	  var values = [];
	  existing.forEach(function (size) {
	    var mappedSize = _StyleConfig.SIZE_MAP[size];
	    if (mappedSize && mappedSize !== size) {
	      values.push(mappedSize);
	    }
	
	    values.push(size);
	  });
	
	  var propType = _propTypes2['default'].oneOf(values);
	  propType._values = values;
	
	  // expose the values on the propType function for documentation
	  Component.SIZES = existing;
	
	  Component.propTypes = (0, _extends3['default'])({}, propTypes, {
	    bsSize: propType
	  });
	
	  if (defaultSize !== undefined) {
	    if (!Component.defaultProps) {
	      Component.defaultProps = {};
	    }
	    Component.defaultProps.bsSize = defaultSize;
	  }
	
	  return Component;
	});
	
	function getClassSet(props) {
	  var _classes;
	
	  var classes = (_classes = {}, _classes[prefix(props)] = true, _classes);
	
	  if (props.bsSize) {
	    var bsSize = _StyleConfig.SIZE_MAP[props.bsSize] || props.bsSize;
	    classes[prefix(props, bsSize)] = true;
	  }
	
	  if (props.bsStyle) {
	    classes[prefix(props, props.bsStyle)] = true;
	  }
	
	  return classes;
	}
	
	function getBsProps(props) {
	  return {
	    bsClass: props.bsClass,
	    bsSize: props.bsSize,
	    bsStyle: props.bsStyle,
	    bsRole: props.bsRole
	  };
	}
	
	function isBsProp(propName) {
	  return propName === 'bsClass' || propName === 'bsSize' || propName === 'bsStyle' || propName === 'bsRole';
	}
	
	function splitBsProps(props) {
	  var elementProps = {};
	  (0, _entries2['default'])(props).forEach(function (_ref) {
	    var propName = _ref[0],
	        propValue = _ref[1];
	
	    if (!isBsProp(propName)) {
	      elementProps[propName] = propValue;
	    }
	  });
	
	  return [getBsProps(props), elementProps];
	}
	
	function splitBsPropsAndOmit(props, omittedPropNames) {
	  var isOmittedProp = {};
	  omittedPropNames.forEach(function (propName) {
	    isOmittedProp[propName] = true;
	  });
	
	  var elementProps = {};
	  (0, _entries2['default'])(props).forEach(function (_ref2) {
	    var propName = _ref2[0],
	        propValue = _ref2[1];
	
	    if (!isBsProp(propName) && !isOmittedProp[propName]) {
	      elementProps[propName] = propValue;
	    }
	  });
	
	  return [getBsProps(props), elementProps];
	}
	
	/**
	 * Add a style variant to a Component. Mutates the propTypes of the component
	 * in order to validate the new variant.
	 */
	function addStyle(Component) {
	  for (var _len2 = arguments.length, styleVariant = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	    styleVariant[_key2 - 1] = arguments[_key2];
	  }
	
	  bsStyles(styleVariant, Component);
	}
	
	var _curry = exports._curry = curry;

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	var _exportNames = {
	  batch: true
	};
	
	var _exports = __webpack_require__(2306);
	
	Object.keys(_exports).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  if (key in exports && exports[key] === _exports[key]) return;
	  exports[key] = _exports[key];
	});
	
	var _reactBatchedUpdates = __webpack_require__(2311);
	
	exports.batch = _reactBatchedUpdates.unstable_batchedUpdates;
	
	var _batch = __webpack_require__(951);
	
	// Enable batched updates in our subscriptions for use
	// with standard React renderers (ReactDOM, React Native)
	(0, _batch.setBatch)(_reactBatchedUpdates.unstable_batchedUpdates);

/***/ },
/* 26 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toInteger;
	
	function toInteger(dirtyNumber) {
	  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
	    return NaN;
	  }
	
	  var number = Number(dirtyNumber);
	
	  if (isNaN(number)) {
	    return number;
	  }
	
	  return number < 0 ? Math.ceil(number) : Math.floor(number);
	}
	
	module.exports = exports.default;

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	var toPropertyKey = __webpack_require__(487);
	function _defineProperty(obj, key, value) {
	  key = toPropertyKey(key);
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	  return obj;
	}
	module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "AGENT_STATUS_TO_ICON", {
	  enumerable: true,
	  get: function get() {
	    return _constants.AGENT_STATUS_TO_ICON;
	  }
	});
	Object.defineProperty(exports, "AddressInput", {
	  enumerable: true,
	  get: function get() {
	    return _AddressInput["default"];
	  }
	});
	Object.defineProperty(exports, "AdminModal", {
	  enumerable: true,
	  get: function get() {
	    return _AdminModal["default"];
	  }
	});
	Object.defineProperty(exports, "AgentButton", {
	  enumerable: true,
	  get: function get() {
	    return _AgentButton["default"];
	  }
	});
	Object.defineProperty(exports, "AgentState", {
	  enumerable: true,
	  get: function get() {
	    return _AgentState["default"];
	  }
	});
	Object.defineProperty(exports, "AreasItem", {
	  enumerable: true,
	  get: function get() {
	    return _AreasItem["default"];
	  }
	});
	Object.defineProperty(exports, "AreasItemCounter", {
	  enumerable: true,
	  get: function get() {
	    return _AreasItemCounter["default"];
	  }
	});
	Object.defineProperty(exports, "AudioIcon", {
	  enumerable: true,
	  get: function get() {
	    return _AudioIcon["default"];
	  }
	});
	Object.defineProperty(exports, "Button", {
	  enumerable: true,
	  get: function get() {
	    return _Button["default"];
	  }
	});
	Object.defineProperty(exports, "ButtonIcon", {
	  enumerable: true,
	  get: function get() {
	    return _ButtonIcon["default"];
	  }
	});
	Object.defineProperty(exports, "ButtonSwitch", {
	  enumerable: true,
	  get: function get() {
	    return _ButtonSwitch["default"];
	  }
	});
	Object.defineProperty(exports, "CampaignIcon", {
	  enumerable: true,
	  get: function get() {
	    return _CampaignIcon["default"];
	  }
	});
	Object.defineProperty(exports, "CampaignIconOption", {
	  enumerable: true,
	  get: function get() {
	    return _CampaignIconOption["default"];
	  }
	});
	Object.defineProperty(exports, "CampaignItem", {
	  enumerable: true,
	  get: function get() {
	    return _CampaignItem["default"];
	  }
	});
	Object.defineProperty(exports, "CampaignItemOption", {
	  enumerable: true,
	  get: function get() {
	    return _CampaignItemOption["default"];
	  }
	});
	Object.defineProperty(exports, "CardFormat", {
	  enumerable: true,
	  get: function get() {
	    return _CardFormat["default"];
	  }
	});
	Object.defineProperty(exports, "Cards", {
	  enumerable: true,
	  get: function get() {
	    return _Cards["default"];
	  }
	});
	Object.defineProperty(exports, "CheckAll", {
	  enumerable: true,
	  get: function get() {
	    return _CheckAll["default"];
	  }
	});
	Object.defineProperty(exports, "Checkbox", {
	  enumerable: true,
	  get: function get() {
	    return _Checkbox["default"];
	  }
	});
	Object.defineProperty(exports, "CheckboxGroup", {
	  enumerable: true,
	  get: function get() {
	    return _CheckboxContext["default"];
	  }
	});
	Object.defineProperty(exports, "Chips", {
	  enumerable: true,
	  get: function get() {
	    return _Chips["default"];
	  }
	});
	Object.defineProperty(exports, "ColorPicker", {
	  enumerable: true,
	  get: function get() {
	    return _ColorPicker["default"];
	  }
	});
	Object.defineProperty(exports, "ColorPickerPopover", {
	  enumerable: true,
	  get: function get() {
	    return _ColorPickerPopover["default"];
	  }
	});
	Object.defineProperty(exports, "Column", {
	  enumerable: true,
	  get: function get() {
	    return _Table.Column;
	  }
	});
	Object.defineProperty(exports, "Content", {
	  enumerable: true,
	  get: function get() {
	    return _DropDownMenu.Content;
	  }
	});
	Object.defineProperty(exports, "Counter", {
	  enumerable: true,
	  get: function get() {
	    return _Counter["default"];
	  }
	});
	Object.defineProperty(exports, "CounterFilter", {
	  enumerable: true,
	  get: function get() {
	    return _FilterPopover.CounterFilter;
	  }
	});
	Object.defineProperty(exports, "DatePicker", {
	  enumerable: true,
	  get: function get() {
	    return _DatePickerInput.DatePicker;
	  }
	});
	Object.defineProperty(exports, "DatePickerInput", {
	  enumerable: true,
	  get: function get() {
	    return _DatePickerInput["default"];
	  }
	});
	Object.defineProperty(exports, "DialogBox", {
	  enumerable: true,
	  get: function get() {
	    return _DialogBox["default"];
	  }
	});
	Object.defineProperty(exports, "DragNDrop", {
	  enumerable: true,
	  get: function get() {
	    return _DragNDrop["default"];
	  }
	});
	Object.defineProperty(exports, "DragNDropWrapper", {
	  enumerable: true,
	  get: function get() {
	    return _DragNDropWrapper["default"];
	  }
	});
	Object.defineProperty(exports, "DropDown", {
	  enumerable: true,
	  get: function get() {
	    return _DropDown["default"];
	  }
	});
	Object.defineProperty(exports, "DropDownMenu", {
	  enumerable: true,
	  get: function get() {
	    return _DropDownMenu["default"];
	  }
	});
	Object.defineProperty(exports, "FilterInput", {
	  enumerable: true,
	  get: function get() {
	    return _FilterInput["default"];
	  }
	});
	Object.defineProperty(exports, "FilterPopover", {
	  enumerable: true,
	  get: function get() {
	    return _FilterPopover["default"];
	  }
	});
	Object.defineProperty(exports, "Header", {
	  enumerable: true,
	  get: function get() {
	    return _DropDownMenu.Header;
	  }
	});
	Object.defineProperty(exports, "IconItem", {
	  enumerable: true,
	  get: function get() {
	    return _IconItem["default"];
	  }
	});
	Object.defineProperty(exports, "IconItemList", {
	  enumerable: true,
	  get: function get() {
	    return _IconItemList["default"];
	  }
	});
	Object.defineProperty(exports, "InputChip", {
	  enumerable: true,
	  get: function get() {
	    return _InputChip["default"];
	  }
	});
	Object.defineProperty(exports, "InputFileUpload", {
	  enumerable: true,
	  get: function get() {
	    return _InputFileUpload["default"];
	  }
	});
	Object.defineProperty(exports, "ItemFilter", {
	  enumerable: true,
	  get: function get() {
	    return _FilterPopover.ItemFilter;
	  }
	});
	Object.defineProperty(exports, "ItemSelectContext", {
	  enumerable: true,
	  get: function get() {
	    return _ItemSelectContext["default"];
	  }
	});
	Object.defineProperty(exports, "LabelInput", {
	  enumerable: true,
	  get: function get() {
	    return _LabelInput["default"];
	  }
	});
	Object.defineProperty(exports, "ListDropDown", {
	  enumerable: true,
	  get: function get() {
	    return _ListDropDown["default"];
	  }
	});
	Object.defineProperty(exports, "ListFilter", {
	  enumerable: true,
	  get: function get() {
	    return _FilterPopover.ListFilter;
	  }
	});
	Object.defineProperty(exports, "ListInput", {
	  enumerable: true,
	  get: function get() {
	    return _ListInput["default"];
	  }
	});
	Object.defineProperty(exports, "ListItem", {
	  enumerable: true,
	  get: function get() {
	    return _ListDropDown.ListItem;
	  }
	});
	Object.defineProperty(exports, "LoadingBar", {
	  enumerable: true,
	  get: function get() {
	    return _LoadingBar["default"];
	  }
	});
	Object.defineProperty(exports, "Menu", {
	  enumerable: true,
	  get: function get() {
	    return _MenuBar.Menu;
	  }
	});
	Object.defineProperty(exports, "MenuBar", {
	  enumerable: true,
	  get: function get() {
	    return _MenuBar["default"];
	  }
	});
	Object.defineProperty(exports, "MenuItem", {
	  enumerable: true,
	  get: function get() {
	    return _MenuBar.MenuItem;
	  }
	});
	Object.defineProperty(exports, "MessageInput", {
	  enumerable: true,
	  get: function get() {
	    return _MessageInput["default"];
	  }
	});
	Object.defineProperty(exports, "NotFoundException", {
	  enumerable: true,
	  get: function get() {
	    return _exceptions.NotFoundException;
	  }
	});
	Object.defineProperty(exports, "NotificationCounter", {
	  enumerable: true,
	  get: function get() {
	    return _NotificationCounter["default"];
	  }
	});
	Object.defineProperty(exports, "NumericStepper", {
	  enumerable: true,
	  get: function get() {
	    return _NumericStepper["default"];
	  }
	});
	Object.defineProperty(exports, "Option", {
	  enumerable: true,
	  get: function get() {
	    return _DropDownMenu.Option;
	  }
	});
	Object.defineProperty(exports, "OutsideClickWrapper", {
	  enumerable: true,
	  get: function get() {
	    return _OutsideClickWrapper["default"];
	  }
	});
	Object.defineProperty(exports, "PrimaryTab", {
	  enumerable: true,
	  get: function get() {
	    return _Tab["default"];
	  }
	});
	Object.defineProperty(exports, "RadioButton", {
	  enumerable: true,
	  get: function get() {
	    return _RadioButton["default"];
	  }
	});
	Object.defineProperty(exports, "RangeFilter", {
	  enumerable: true,
	  get: function get() {
	    return _FilterPopover.RangeFilter;
	  }
	});
	Object.defineProperty(exports, "RatingStars", {
	  enumerable: true,
	  get: function get() {
	    return _RatingStars["default"];
	  }
	});
	Object.defineProperty(exports, "RequestException", {
	  enumerable: true,
	  get: function get() {
	    return _exceptions.RequestException;
	  }
	});
	Object.defineProperty(exports, "Row", {
	  enumerable: true,
	  get: function get() {
	    return _Table.Row;
	  }
	});
	Object.defineProperty(exports, "SearchSelection", {
	  enumerable: true,
	  get: function get() {
	    return _SearchSelection["default"];
	  }
	});
	Object.defineProperty(exports, "SearchSelectionAgent", {
	  enumerable: true,
	  get: function get() {
	    return _SearchSelectionAgent["default"];
	  }
	});
	Object.defineProperty(exports, "SecondaryTab", {
	  enumerable: true,
	  get: function get() {
	    return _Tab2["default"];
	  }
	});
	Object.defineProperty(exports, "Select", {
	  enumerable: true,
	  get: function get() {
	    return _Select["default"];
	  }
	});
	Object.defineProperty(exports, "SelectListItem", {
	  enumerable: true,
	  get: function get() {
	    return _SelectListItem["default"];
	  }
	});
	Object.defineProperty(exports, "SelectOptionIcon", {
	  enumerable: true,
	  get: function get() {
	    return _Select.SelectOptionIcon;
	  }
	});
	Object.defineProperty(exports, "SideBarTab", {
	  enumerable: true,
	  get: function get() {
	    return _Tab3["default"];
	  }
	});
	Object.defineProperty(exports, "SimpleLineChart", {
	  enumerable: true,
	  get: function get() {
	    return _SimpleLineChart["default"];
	  }
	});
	Object.defineProperty(exports, "SimplePieChart", {
	  enumerable: true,
	  get: function get() {
	    return _SimplePieChart["default"];
	  }
	});
	Object.defineProperty(exports, "Slider", {
	  enumerable: true,
	  get: function get() {
	    return _Slider["default"];
	  }
	});
	Object.defineProperty(exports, "SubMenu", {
	  enumerable: true,
	  get: function get() {
	    return _MenuBar.SubMenu;
	  }
	});
	Object.defineProperty(exports, "Switch", {
	  enumerable: true,
	  get: function get() {
	    return _Switch["default"];
	  }
	});
	Object.defineProperty(exports, "TabPanel", {
	  enumerable: true,
	  get: function get() {
	    return _TabPanel["default"];
	  }
	});
	Object.defineProperty(exports, "Table", {
	  enumerable: true,
	  get: function get() {
	    return _Table["default"];
	  }
	});
	Object.defineProperty(exports, "TextFilter", {
	  enumerable: true,
	  get: function get() {
	    return _FilterPopover.TextFilter;
	  }
	});
	Object.defineProperty(exports, "TimePicker", {
	  enumerable: true,
	  get: function get() {
	    return _TimePicker["default"];
	  }
	});
	Object.defineProperty(exports, "Toast", {
	  enumerable: true,
	  get: function get() {
	    return _Toast["default"];
	  }
	});
	Object.defineProperty(exports, "ToastConsumer", {
	  enumerable: true,
	  get: function get() {
	    return _Toasts.ToastConsumer;
	  }
	});
	Object.defineProperty(exports, "ToastProvider", {
	  enumerable: true,
	  get: function get() {
	    return _Toasts.ToastProvider;
	  }
	});
	Object.defineProperty(exports, "ToggleChip", {
	  enumerable: true,
	  get: function get() {
	    return _ToggleChip["default"];
	  }
	});
	Object.defineProperty(exports, "UNAVAILABLE_ICONS", {
	  enumerable: true,
	  get: function get() {
	    return _UnavailableIcon.UNAVAILABLE_ICONS;
	  }
	});
	Object.defineProperty(exports, "UNAVAILABLE_ICONS_DICTIONARY", {
	  enumerable: true,
	  get: function get() {
	    return _UnavailableIcon.UNAVAILABLE_ICONS_DICTIONARY;
	  }
	});
	Object.defineProperty(exports, "UnavailableIcon", {
	  enumerable: true,
	  get: function get() {
	    return _UnavailableIcon["default"];
	  }
	});
	Object.defineProperty(exports, "WGResourceItem", {
	  enumerable: true,
	  get: function get() {
	    return _WGResourceItem["default"];
	  }
	});
	Object.defineProperty(exports, "WizardProgressBar", {
	  enumerable: true,
	  get: function get() {
	    return _WizardProgress["default"];
	  }
	});
	Object.defineProperty(exports, "WizardStep", {
	  enumerable: true,
	  get: function get() {
	    return _WizardProgress.WizardStep;
	  }
	});
	Object.defineProperty(exports, "classNames", {
	  enumerable: true,
	  get: function get() {
	    return _classNames["default"];
	  }
	});
	Object.defineProperty(exports, "formatDateForRequest", {
	  enumerable: true,
	  get: function get() {
	    return _formatters.formatDateForRequest;
	  }
	});
	Object.defineProperty(exports, "formatDateLongYear", {
	  enumerable: true,
	  get: function get() {
	    return _formatters.formatDateLongYear;
	  }
	});
	Object.defineProperty(exports, "formatDateShort", {
	  enumerable: true,
	  get: function get() {
	    return _formatters.formatDateShort;
	  }
	});
	Object.defineProperty(exports, "formatDateShortTwoDigits", {
	  enumerable: true,
	  get: function get() {
	    return _formatters.formatDateShortTwoDigits;
	  }
	});
	Object.defineProperty(exports, "formatDateWithHour", {
	  enumerable: true,
	  get: function get() {
	    return _formatters.formatDateWithHour;
	  }
	});
	Object.defineProperty(exports, "formatDatetimeForRequest", {
	  enumerable: true,
	  get: function get() {
	    return _formatters.formatDatetimeForRequest;
	  }
	});
	Object.defineProperty(exports, "formatTime", {
	  enumerable: true,
	  get: function get() {
	    return _formatters.formatTime;
	  }
	});
	Object.defineProperty(exports, "formatTimeShort", {
	  enumerable: true,
	  get: function get() {
	    return _formatters.formatTimeShort;
	  }
	});
	Object.defineProperty(exports, "getSizeString", {
	  enumerable: true,
	  get: function get() {
	    return _formatters.getSizeString;
	  }
	});
	Object.defineProperty(exports, "getTime", {
	  enumerable: true,
	  get: function get() {
	    return _helpers.getTime;
	  }
	});
	Object.defineProperty(exports, "isValidDate", {
	  enumerable: true,
	  get: function get() {
	    return _helpers.isValidDate;
	  }
	});
	Object.defineProperty(exports, "isValidMail", {
	  enumerable: true,
	  get: function get() {
	    return _helpers.isValidMail;
	  }
	});
	Object.defineProperty(exports, "isValidTime", {
	  enumerable: true,
	  get: function get() {
	    return _helpers.isValidTime;
	  }
	});
	Object.defineProperty(exports, "itemselectContext", {
	  enumerable: true,
	  get: function get() {
	    return _ItemSelectContext.Context;
	  }
	});
	Object.defineProperty(exports, "range", {
	  enumerable: true,
	  get: function get() {
	    return _util.range;
	  }
	});
	Object.defineProperty(exports, "removeFromObject", {
	  enumerable: true,
	  get: function get() {
	    return _helpers.removeFromObject;
	  }
	});
	Object.defineProperty(exports, "updateArrayImmutably", {
	  enumerable: true,
	  get: function get() {
	    return _helpers.updateArrayImmutably;
	  }
	});
	Object.defineProperty(exports, "useInfiniteScroll", {
	  enumerable: true,
	  get: function get() {
	    return _hooks.useInfiniteScroll;
	  }
	});
	Object.defineProperty(exports, "useInfiniteScrollWithRefCallback", {
	  enumerable: true,
	  get: function get() {
	    return _hooks.useInfiniteScrollWithRefCallback;
	  }
	});
	Object.defineProperty(exports, "useLatest", {
	  enumerable: true,
	  get: function get() {
	    return _hooks.useLatest;
	  }
	});
	Object.defineProperty(exports, "useOutsideClick", {
	  enumerable: true,
	  get: function get() {
	    return _hooks.useOutsideClick;
	  }
	});
	Object.defineProperty(exports, "usePrevious", {
	  enumerable: true,
	  get: function get() {
	    return _hooks.usePrevious;
	  }
	});
	Object.defineProperty(exports, "useScaledBottomLimit", {
	  enumerable: true,
	  get: function get() {
	    return _hooks.useScaledBottomLimit;
	  }
	});
	Object.defineProperty(exports, "useScaledRightLimit", {
	  enumerable: true,
	  get: function get() {
	    return _hooks.useScaledRightLimit;
	  }
	});
	Object.defineProperty(exports, "useStopWatchBasic", {
	  enumerable: true,
	  get: function get() {
	    return _index.useStopWatchBasic;
	  }
	});
	Object.defineProperty(exports, "useStopWatchCountDown", {
	  enumerable: true,
	  get: function get() {
	    return _index.useStopWatchCountDown;
	  }
	});
	Object.defineProperty(exports, "useStopWatchInterval", {
	  enumerable: true,
	  get: function get() {
	    return _index.useStopWatchInterval;
	  }
	});
	Object.defineProperty(exports, "useStopWatchWorker", {
	  enumerable: true,
	  get: function get() {
	    return _index.useStopWatchWorker;
	  }
	});
	Object.defineProperty(exports, "useTimerDownUp", {
	  enumerable: true,
	  get: function get() {
	    return _useTimerDownUp["default"];
	  }
	});
	Object.defineProperty(exports, "useToasts", {
	  enumerable: true,
	  get: function get() {
	    return _Toasts.useToasts;
	  }
	});
	Object.defineProperty(exports, "useUpdateEffect", {
	  enumerable: true,
	  get: function get() {
	    return _hooks.useUpdateEffect;
	  }
	});
	
	var _AudioIcon = _interopRequireDefault(__webpack_require__(1886));
	
	var _Button = _interopRequireDefault(__webpack_require__(97));
	
	var _ButtonIcon = _interopRequireDefault(__webpack_require__(421));
	
	var _Chips = _interopRequireDefault(__webpack_require__(1893));
	
	var _DatePickerInput = _interopRequireWildcard(__webpack_require__(1897));
	
	var _DialogBox = _interopRequireDefault(__webpack_require__(1898));
	
	var _DropDownMenu = _interopRequireWildcard(__webpack_require__(693));
	
	var _IconItem = _interopRequireDefault(__webpack_require__(694));
	
	var _IconItemList = _interopRequireDefault(__webpack_require__(1903));
	
	var _Checkbox = _interopRequireDefault(__webpack_require__(274));
	
	var _CheckAll = _interopRequireDefault(__webpack_require__(1904));
	
	var _CheckboxContext = _interopRequireDefault(__webpack_require__(423));
	
	var _FilterInput = _interopRequireDefault(__webpack_require__(696));
	
	var _FilterPopover = _interopRequireWildcard(__webpack_require__(1902));
	
	var _DropDown = _interopRequireDefault(__webpack_require__(1901));
	
	var _NotificationCounter = _interopRequireDefault(__webpack_require__(1909));
	
	var _Tab = _interopRequireDefault(__webpack_require__(1926));
	
	var _Tab2 = _interopRequireDefault(__webpack_require__(1927));
	
	var _Tab3 = _interopRequireDefault(__webpack_require__(1928));
	
	var _Slider = _interopRequireDefault(__webpack_require__(700));
	
	var _TabPanel = _interopRequireDefault(__webpack_require__(1929));
	
	var _ItemSelectContext = _interopRequireWildcard(__webpack_require__(425));
	
	var _Toasts = __webpack_require__(1933);
	
	var _Toast = _interopRequireDefault(__webpack_require__(702));
	
	var _LabelInput = _interopRequireDefault(__webpack_require__(697));
	
	var _Table = _interopRequireWildcard(__webpack_require__(1930));
	
	var _CampaignItem = _interopRequireDefault(__webpack_require__(1890));
	
	var _ListDropDown = _interopRequireWildcard(__webpack_require__(698));
	
	var _DragNDropWrapper = _interopRequireDefault(__webpack_require__(1899));
	
	var _DragNDrop = _interopRequireDefault(__webpack_require__(1900));
	
	var _OutsideClickWrapper = _interopRequireDefault(__webpack_require__(219));
	
	var _index = __webpack_require__(1924);
	
	var _formatters = __webpack_require__(427);
	
	var _helpers = __webpack_require__(176);
	
	var _util = __webpack_require__(1940);
	
	var _exceptions = __webpack_require__(1939);
	
	var _AgentState = _interopRequireDefault(__webpack_require__(1883));
	
	var _Switch = _interopRequireDefault(__webpack_require__(1925));
	
	var _Counter = _interopRequireDefault(__webpack_require__(692));
	
	var _Cards = _interopRequireDefault(__webpack_require__(1892));
	
	var _CardFormat = _interopRequireDefault(__webpack_require__(1891));
	
	var _AreasItem = _interopRequireDefault(__webpack_require__(1884));
	
	var _AreasItemCounter = _interopRequireDefault(__webpack_require__(1885));
	
	var _ToggleChip = _interopRequireDefault(__webpack_require__(1934));
	
	var _InputChip = _interopRequireDefault(__webpack_require__(695));
	
	var _ListInput = _interopRequireDefault(__webpack_require__(689));
	
	var _AddressInput = _interopRequireDefault(__webpack_require__(1880));
	
	var _MenuBar = _interopRequireWildcard(__webpack_require__(1908));
	
	var _SimpleLineChart = _interopRequireDefault(__webpack_require__(1916));
	
	var _SimplePieChart = _interopRequireDefault(__webpack_require__(1917));
	
	var _hooks = __webpack_require__(110);
	
	var _SelectListItem = _interopRequireDefault(__webpack_require__(1914));
	
	var _RadioButton = _interopRequireDefault(__webpack_require__(699));
	
	var _TimePicker = _interopRequireDefault(__webpack_require__(701));
	
	var _WGResourceItem = _interopRequireDefault(__webpack_require__(1936));
	
	var _LoadingBar = _interopRequireDefault(__webpack_require__(1907));
	
	var _CampaignItemOption = _interopRequireDefault(__webpack_require__(1889));
	
	var _CampaignIconOption = _interopRequireDefault(__webpack_require__(1888));
	
	var _WizardProgress = _interopRequireWildcard(__webpack_require__(1937));
	
	var _RatingStars = _interopRequireDefault(__webpack_require__(1911));
	
	var _Select = _interopRequireWildcard(__webpack_require__(1915));
	
	var _UnavailableIcon = _interopRequireWildcard(__webpack_require__(1935));
	
	var _ColorPickerPopover = _interopRequireDefault(__webpack_require__(1894));
	
	var _ColorPicker = _interopRequireDefault(__webpack_require__(691));
	
	var _constants = __webpack_require__(275);
	
	var _classNames = _interopRequireDefault(__webpack_require__(61));
	
	var _SearchSelection = _interopRequireDefault(__webpack_require__(1913));
	
	var _ButtonSwitch = _interopRequireDefault(__webpack_require__(1887));
	
	var _AgentButton = _interopRequireDefault(__webpack_require__(1882));
	
	var _InputFileUpload = _interopRequireDefault(__webpack_require__(1905));
	
	var _AdminModal = _interopRequireDefault(__webpack_require__(1881));
	
	var _CampaignIcon = _interopRequireDefault(__webpack_require__(690));
	
	var _MessageInput = _interopRequireDefault(__webpack_require__(1906));
	
	var _SearchSelectionAgent = _interopRequireDefault(__webpack_require__(1912));
	
	var _NumericStepper = _interopRequireDefault(__webpack_require__(1910));
	
	var _useTimerDownUp = _interopRequireDefault(__webpack_require__(1938));
	
	__webpack_require__(1727);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.parseChildIndex = exports.getReactEventByType = exports.renderByOrder = exports.isChildrenEqual = exports.isSingleChildEqual = exports.filterSvgElements = exports.isSsr = exports.validateWidthHeight = exports.filterEventsOfChild = exports.filterEventAttributes = exports.getPresentationAttributes = exports.withoutType = exports.findChildByType = exports.findAllByType = exports.getDisplayName = exports.TOOLTIP_TYPES = exports.LEGEND_TYPES = exports.SCALE_TYPES = exports.EVENT_ATTRIBUTES = exports.PRESENTATION_ATTRIBUTES = void 0;
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(71));
	
	var _isString2 = _interopRequireDefault(__webpack_require__(292));
	
	var _isObject2 = _interopRequireDefault(__webpack_require__(72));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(38));
	
	var _isArray2 = _interopRequireDefault(__webpack_require__(43));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _DataUtils = __webpack_require__(39);
	
	var _ShallowEqual = __webpack_require__(314);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var PRESENTATION_ATTRIBUTES = {
	  'aria-current': _propTypes["default"].string,
	  // state
	  'aria-details': _propTypes["default"].any,
	  'aria-disabled': _propTypes["default"].any,
	  // state
	  'aria-hidden': _propTypes["default"].any,
	  // state
	  'aria-invalid': _propTypes["default"].any,
	  // state
	  'aria-keyshortcuts': _propTypes["default"].any,
	  'aria-label': _propTypes["default"].any,
	  'aria-roledescription': _propTypes["default"].any,
	  // Widget Attributes
	  'aria-autocomplete': _propTypes["default"].any,
	  'aria-checked': _propTypes["default"].any,
	  'aria-expanded': _propTypes["default"].any,
	  'aria-haspopup': _propTypes["default"].any,
	  'aria-level': _propTypes["default"].any,
	  'aria-modal': _propTypes["default"].any,
	  'aria-multiline': _propTypes["default"].any,
	  'aria-multiselectable': _propTypes["default"].any,
	  'aria-orientation': _propTypes["default"].any,
	  'aria-placeholder': _propTypes["default"].any,
	  'aria-pressed': _propTypes["default"].any,
	  'aria-readonly': _propTypes["default"].any,
	  'aria-required': _propTypes["default"].any,
	  'aria-selected': _propTypes["default"].any,
	  'aria-sort': _propTypes["default"].any,
	  'aria-valuemax': _propTypes["default"].any,
	  'aria-valuemin': _propTypes["default"].any,
	  'aria-valuenow': _propTypes["default"].any,
	  'aria-valuetext': _propTypes["default"].any,
	  // Live Region Attributes
	  'aria-atomic': _propTypes["default"].any,
	  'aria-busy': _propTypes["default"].any,
	  'aria-live': _propTypes["default"].any,
	  'aria-relevant': _propTypes["default"].any,
	  // Drag-and-Drop Attributes
	  'aria-dropeffect': _propTypes["default"].any,
	  'aria-grabbed': _propTypes["default"].any,
	  // Relationship Attributes
	  'aria-activedescendant': _propTypes["default"].any,
	  'aria-colcount': _propTypes["default"].any,
	  'aria-colindex': _propTypes["default"].any,
	  'aria-colspan': _propTypes["default"].any,
	  'aria-controls': _propTypes["default"].any,
	  'aria-describedby': _propTypes["default"].any,
	  'aria-errormessage': _propTypes["default"].any,
	  'aria-flowto': _propTypes["default"].any,
	  'aria-labelledby': _propTypes["default"].any,
	  'aria-owns': _propTypes["default"].any,
	  'aria-posinset': _propTypes["default"].any,
	  'aria-rowcount': _propTypes["default"].any,
	  'aria-rowindex': _propTypes["default"].any,
	  'aria-rowspan': _propTypes["default"].any,
	  'aria-setsize': _propTypes["default"].any,
	  alignmentBaseline: _propTypes["default"].string,
	  angle: _propTypes["default"].number,
	  baselineShift: _propTypes["default"].string,
	  clip: _propTypes["default"].string,
	  clipPath: _propTypes["default"].string,
	  clipRule: _propTypes["default"].string,
	  color: _propTypes["default"].string,
	  colorInterpolation: _propTypes["default"].string,
	  colorInterpolationFilters: _propTypes["default"].string,
	  colorProfile: _propTypes["default"].string,
	  colorRendering: _propTypes["default"].string,
	  cursor: _propTypes["default"].string,
	  direction: _propTypes["default"].oneOf(['ltr', 'rtl', 'inherit']),
	  display: _propTypes["default"].string,
	  dominantBaseline: _propTypes["default"].string,
	  enableBackground: _propTypes["default"].string,
	  fill: _propTypes["default"].string,
	  fillOpacity: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  fillRule: _propTypes["default"].oneOf(['nonzero', 'evenodd', 'inherit']),
	  filter: _propTypes["default"].string,
	  floodColor: _propTypes["default"].string,
	  floodOpacity: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  font: _propTypes["default"].string,
	  fontFamily: _propTypes["default"].string,
	  fontSize: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  fontSizeAdjust: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  fontStretch: _propTypes["default"].oneOf(['normal', 'wider', 'narrower', 'ultra-condensed', 'extra-condensed', 'condensed', 'semi-condensed', 'semi-expanded', 'expanded', 'extra-expanded', 'ultra-expanded', 'inherit']),
	  fontStyle: _propTypes["default"].oneOf(['normal', 'italic', 'oblique', 'inherit']),
	  fontVariant: _propTypes["default"].oneOf(['normal', 'small-caps', 'inherit']),
	  fontWeight: _propTypes["default"].oneOf(['normal', 'bold', 'bolder', 'lighter', 100, 200, 300, 400, 500, 600, 700, 800, 900, 'inherit']),
	  glyphOrientationHorizontal: _propTypes["default"].string,
	  glyphOrientationVertical: _propTypes["default"].string,
	  imageRendering: _propTypes["default"].oneOf(['auto', 'optimizeSpeed', 'optimizeQuality', 'inherit']),
	  kerning: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  letterSpacing: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  lightingColor: _propTypes["default"].string,
	  lineHeight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  markerEnd: _propTypes["default"].string,
	  markerMid: _propTypes["default"].string,
	  markerStart: _propTypes["default"].string,
	  mask: _propTypes["default"].string,
	  opacity: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  overflow: _propTypes["default"].oneOf(['visible', 'hidden', 'scroll', 'auto', 'inherit']),
	  pointerEvents: _propTypes["default"].oneOf(['visiblePainted', 'visibleFill', 'visibleStroke', 'visible', 'painted', 'fill', 'stroke', 'all', 'none', 'inherit']),
	  shapeRendering: _propTypes["default"].oneOf(['auto', 'optimizeSpeed', 'crispEdges', 'geometricPrecision', 'inherit']),
	  stopColor: _propTypes["default"].string,
	  stopOpacity: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  stroke: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  strokeDasharray: _propTypes["default"].string,
	  strokeDashoffset: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  strokeLinecap: _propTypes["default"].oneOf(['butt', 'round', 'square', 'inherit']),
	  strokeLinejoin: _propTypes["default"].oneOf(['miter', 'round', 'bevel', 'inherit']),
	  strokeMiterlimit: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  strokeOpacity: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  strokeWidth: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  textAnchor: _propTypes["default"].oneOf(['start', 'middle', 'end', 'inherit']),
	  textDecoration: _propTypes["default"].oneOf(['none', 'underline', 'overline', 'line-through', 'blink', 'inherit']),
	  textRendering: _propTypes["default"].oneOf(['auto', 'optimizeSpeed', 'optimizeLegibility', 'geometricPrecision', 'inherit']),
	  unicodeBidi: _propTypes["default"].oneOf(['normal', 'embed', 'bidi-override', 'inherit']),
	  visibility: _propTypes["default"].oneOf(['visible', 'hidden', 'collapse', 'inherit']),
	  wordSpacing: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  writingMode: _propTypes["default"].oneOf(['lr-tb', 'rl-tb', 'tb-rl', 'lr', 'rl', 'tb', 'inherit']),
	  transform: _propTypes["default"].string,
	  role: _propTypes["default"].string,
	  focusable: _propTypes["default"].string,
	  tabIndex: _propTypes["default"].string,
	  style: _propTypes["default"].object,
	  width: _propTypes["default"].number,
	  height: _propTypes["default"].number,
	  dx: _propTypes["default"].number,
	  dy: _propTypes["default"].number,
	  x: _propTypes["default"].number,
	  y: _propTypes["default"].number,
	  r: _propTypes["default"].number,
	  // The radius of Rectangle
	  radius: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].array])
	};
	exports.PRESENTATION_ATTRIBUTES = PRESENTATION_ATTRIBUTES;
	var EVENT_ATTRIBUTES = {
	  onClick: _propTypes["default"].func,
	  onMouseDown: _propTypes["default"].func,
	  onMouseUp: _propTypes["default"].func,
	  onMouseOver: _propTypes["default"].func,
	  onMouseMove: _propTypes["default"].func,
	  onMouseOut: _propTypes["default"].func,
	  onMouseEnter: _propTypes["default"].func,
	  onMouseLeave: _propTypes["default"].func,
	  onTouchEnd: _propTypes["default"].func,
	  onTouchMove: _propTypes["default"].func,
	  onTouchStart: _propTypes["default"].func,
	  onTouchCancel: _propTypes["default"].func
	};
	exports.EVENT_ATTRIBUTES = EVENT_ATTRIBUTES;
	var REACT_BROWSER_EVENT_MAP = {
	  click: 'onClick',
	  mousedown: 'onMouseDown',
	  mouseup: 'onMouseUp',
	  mouseover: 'onMouseOver',
	  mousemove: 'onMouseMove',
	  mouseout: 'onMouseOut',
	  mouseenter: 'onMouseEnter',
	  mouseleave: 'onMouseLeave',
	  touchcancel: 'onTouchCancel',
	  touchend: 'onTouchEnd',
	  touchmove: 'onTouchMove',
	  touchstart: 'onTouchStart'
	};
	var SCALE_TYPES = ['auto', 'linear', 'pow', 'sqrt', 'log', 'identity', 'time', 'band', 'point', 'ordinal', 'quantile', 'quantize', 'utc', 'sequential', 'threshold'];
	exports.SCALE_TYPES = SCALE_TYPES;
	var LEGEND_TYPES = ['plainline', 'line', 'square', 'rect', 'circle', 'cross', 'diamond', 'star', 'triangle', 'wye', 'none'];
	exports.LEGEND_TYPES = LEGEND_TYPES;
	var TOOLTIP_TYPES = ['none'];
	/**
	 * Get the display name of a component
	 * @param  {Object} Comp Specified Component
	 * @return {String}      Display name of Component
	 */
	
	exports.TOOLTIP_TYPES = TOOLTIP_TYPES;
	
	var getDisplayName = function getDisplayName(Comp) {
	  if (typeof Comp === 'string') {
	    return Comp;
	  }
	
	  if (!Comp) {
	    return '';
	  }
	
	  return Comp.displayName || Comp.name || 'Component';
	};
	/*
	 * Find and return all matched children by type. `type` can be a React element class or
	 * string
	 */
	
	
	exports.getDisplayName = getDisplayName;
	
	var findAllByType = function findAllByType(children, type) {
	  var result = [];
	  var types = [];
	
	  if ((0, _isArray2["default"])(type)) {
	    types = type.map(function (t) {
	      return getDisplayName(t);
	    });
	  } else {
	    types = [getDisplayName(type)];
	  }
	
	  _react["default"].Children.forEach(children, function (child) {
	    var childType = child && child.type && (child.type.displayName || child.type.name);
	
	    if (types.indexOf(childType) !== -1) {
	      result.push(child);
	    }
	  });
	
	  return result;
	};
	/*
	 * Return the first matched child by type, return null otherwise.
	 * `type` can be a React element class or string.
	 */
	
	
	exports.findAllByType = findAllByType;
	
	var findChildByType = function findChildByType(children, type) {
	  var result = findAllByType(children, type);
	  return result && result[0];
	};
	/*
	 * Create a new array of children excluding the ones matched the type
	 */
	
	
	exports.findChildByType = findChildByType;
	
	var withoutType = function withoutType(children, type) {
	  var newChildren = [];
	  var types;
	
	  if ((0, _isArray2["default"])(type)) {
	    types = type.map(function (t) {
	      return getDisplayName(t);
	    });
	  } else {
	    types = [getDisplayName(type)];
	  }
	
	  _react["default"].Children.forEach(children, function (child) {
	    if (child && child.type && child.type.displayName && types.indexOf(child.type.displayName) !== -1) {
	      return;
	    }
	
	    newChildren.push(child);
	  });
	
	  return newChildren;
	};
	/**
	 * get all the presentation attribute of svg element
	 * @param  {Object} el A react element or the props of a react element
	 * @return {Object}    attributes or null
	 */
	
	
	exports.withoutType = withoutType;
	
	var getPresentationAttributes = function getPresentationAttributes(el) {
	  if (!el || (0, _isFunction2["default"])(el)) {
	    return null;
	  }
	
	  var props = _react["default"].isValidElement(el) ? el.props : el;
	
	  if (!(0, _isObject2["default"])(props)) {
	    return null;
	  }
	
	  var out = null; // eslint-disable-next-line no-restricted-syntax
	
	  for (var i in props) {
	    if ({}.hasOwnProperty.call(props, i) && PRESENTATION_ATTRIBUTES[i]) {
	      if (!out) out = {};
	      out[i] = props[i];
	    }
	  }
	
	  return out;
	};
	
	exports.getPresentationAttributes = getPresentationAttributes;
	
	var getEventHandlerOfElement = function getEventHandlerOfElement(originalHandler, props) {
	  return function (e) {
	    originalHandler(props, e);
	    return null;
	  };
	};
	/**
	 * get all the event attribute of svg element
	 * @param  {Object}   el           A react element or the props of a react element
	 * @param  {Function} newHandler   New handler of event
	 * @param  {Boolean}  wrapCallback Wrap callback and return more parameters or not
	 * @return {Object}                attributes or null
	 */
	
	
	var filterEventAttributes = function filterEventAttributes(el, newHandler) {
	  var wrapCallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  if (!el || (0, _isFunction2["default"])(el)) {
	    return null;
	  }
	
	  var props = _react["default"].isValidElement(el) ? el.props : el;
	
	  if (!(0, _isObject2["default"])(props)) {
	    return null;
	  }
	
	  var out = null; // eslint-disable-next-line no-restricted-syntax
	
	  for (var i in props) {
	    if ({}.hasOwnProperty.call(props, i) && EVENT_ATTRIBUTES[i]) {
	      if (!out) out = {};
	      out[i] = newHandler || (wrapCallback ? getEventHandlerOfElement(props[i], props) : props[i]);
	    }
	  }
	
	  return out;
	};
	
	exports.filterEventAttributes = filterEventAttributes;
	
	var getEventHandlerOfChild = function getEventHandlerOfChild(originalHandler, data, index) {
	  return function (e) {
	    originalHandler(data, index, e);
	    return null;
	  };
	};
	
	var filterEventsOfChild = function filterEventsOfChild(props, data, index) {
	  if (!(0, _isObject2["default"])(props)) {
	    return null;
	  }
	
	  var out = null; // eslint-disable-next-line no-restricted-syntax
	
	  for (var i in props) {
	    if ({}.hasOwnProperty.call(props, i) && EVENT_ATTRIBUTES[i] && (0, _isFunction2["default"])(props[i])) {
	      if (!out) out = {};
	      out[i] = getEventHandlerOfChild(props[i], data, index);
	    }
	  }
	
	  return out;
	};
	/**
	 * validate the width and height props of a chart element
	 * @param  {Object} el A chart element
	 * @return {Boolean}   true If the props width and height are number, and greater than 0
	 */
	
	
	exports.filterEventsOfChild = filterEventsOfChild;
	
	var validateWidthHeight = function validateWidthHeight(el) {
	  if (!el || !el.props) {
	    return false;
	  }
	
	  var _el$props = el.props,
	      width = _el$props.width,
	      height = _el$props.height;
	
	  if (!(0, _DataUtils.isNumber)(width) || width <= 0 || !(0, _DataUtils.isNumber)(height) || height <= 0) {
	    return false;
	  }
	
	  return true;
	};
	
	exports.validateWidthHeight = validateWidthHeight;
	
	var isSsr = function isSsr() {
	  return !(typeof window !== 'undefined' && window.document && window.document.createElement && window.setTimeout);
	};
	
	exports.isSsr = isSsr;
	var SVG_TAGS = ['a', 'altGlyph', 'altGlyphDef', 'altGlyphItem', 'animate', 'animateColor', 'animateMotion', 'animateTransform', 'circle', 'clipPath', 'color-profile', 'cursor', 'defs', 'desc', 'ellipse', 'feBlend', 'feColormatrix', 'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap', 'feDistantLight', 'feFlood', 'feFuncA', 'feFuncB', 'feFuncG', 'feFuncR', 'feGaussianBlur', 'feImage', 'feMerge', 'feMergeNode', 'feMorphology', 'feOffset', 'fePointLight', 'feSpecularLighting', 'feSpotLight', 'feTile', 'feTurbulence', 'filter', 'font', 'font-face', 'font-face-format', 'font-face-name', 'font-face-url', 'foreignObject', 'g', 'glyph', 'glyphRef', 'hkern', 'image', 'line', 'lineGradient', 'marker', 'mask', 'metadata', 'missing-glyph', 'mpath', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'script', 'set', 'stop', 'style', 'svg', 'switch', 'symbol', 'text', 'textPath', 'title', 'tref', 'tspan', 'use', 'view', 'vkern'];
	
	var isSvgElement = function isSvgElement(child) {
	  return child && child.type && (0, _isString2["default"])(child.type) && SVG_TAGS.indexOf(child.type) >= 0;
	};
	/**
	 * Filter all the svg elements of children
	 * @param  {Array} children The children of a react element
	 * @return {Array}          All the svg elements
	 */
	
	
	var filterSvgElements = function filterSvgElements(children) {
	  var svgElements = [];
	
	  _react["default"].Children.forEach(children, function (entry) {
	    if (entry && entry.type && (0, _isString2["default"])(entry.type) && SVG_TAGS.indexOf(entry.type) >= 0) {
	      svgElements.push(entry);
	    }
	  });
	
	  return svgElements;
	};
	
	exports.filterSvgElements = filterSvgElements;
	
	var isSingleChildEqual = function isSingleChildEqual(nextChild, prevChild) {
	  if ((0, _isNil2["default"])(nextChild) && (0, _isNil2["default"])(prevChild)) {
	    return true;
	  }
	
	  if (!(0, _isNil2["default"])(nextChild) && !(0, _isNil2["default"])(prevChild)) {
	    var _ref = nextChild.props || {},
	        nextChildren = _ref.children,
	        nextProps = _objectWithoutProperties(_ref, ["children"]);
	
	    var _ref2 = prevChild.props || {},
	        prevChildren = _ref2.children,
	        prevProps = _objectWithoutProperties(_ref2, ["children"]);
	
	    if (nextChildren && prevChildren) {
	      // eslint-disable-next-line no-use-before-define
	      return (0, _ShallowEqual.shallowEqual)(nextProps, prevProps) && isChildrenEqual(nextChildren, prevChildren);
	    }
	
	    if (!nextChildren && !prevChildren) {
	      return (0, _ShallowEqual.shallowEqual)(nextProps, prevProps);
	    }
	
	    return false;
	  }
	
	  return false;
	};
	/**
	 * Wether props of children changed
	 * @param  {Object} nextChildren The latest children
	 * @param  {Object} prevChildren The prev children
	 * @return {Boolean}             equal or not
	 */
	
	
	exports.isSingleChildEqual = isSingleChildEqual;
	
	var isChildrenEqual = function isChildrenEqual(nextChildren, prevChildren) {
	  if (nextChildren === prevChildren) {
	    return true;
	  }
	
	  if (_react.Children.count(nextChildren) !== _react.Children.count(prevChildren)) {
	    return false;
	  }
	
	  var count = _react.Children.count(nextChildren);
	
	  if (count === 0) {
	    return true;
	  }
	
	  if (count === 1) {
	    return isSingleChildEqual((0, _isArray2["default"])(nextChildren) ? nextChildren[0] : nextChildren, (0, _isArray2["default"])(prevChildren) ? prevChildren[0] : prevChildren);
	  }
	
	  for (var _i = 0; _i < count; _i++) {
	    var nextChild = nextChildren[_i];
	    var prevChild = prevChildren[_i];
	
	    if ((0, _isArray2["default"])(nextChild) || (0, _isArray2["default"])(prevChild)) {
	      if (!isChildrenEqual(nextChild, prevChild)) {
	        return false;
	      }
	    } else if (!isSingleChildEqual(nextChild, prevChild)) {
	      return false;
	    }
	  }
	
	  return true;
	};
	
	exports.isChildrenEqual = isChildrenEqual;
	
	var renderByOrder = function renderByOrder(children, renderMap) {
	  var elements = [];
	  var record = {};
	
	  _react.Children.forEach(children, function (child, index) {
	    if (child && isSvgElement(child)) {
	      elements.push(child);
	    } else if (child && renderMap[getDisplayName(child.type)]) {
	      var displayName = getDisplayName(child.type);
	      var _renderMap$displayNam = renderMap[displayName],
	          handler = _renderMap$displayNam.handler,
	          once = _renderMap$displayNam.once;
	
	      if (once && !record[displayName] || !once) {
	        var results = handler(child, displayName, index);
	
	        if ((0, _isArray2["default"])(results)) {
	          elements = [elements].concat(_toConsumableArray(results));
	        } else {
	          elements.push(results);
	        }
	
	        record[displayName] = true;
	      }
	    }
	  });
	
	  return elements;
	};
	
	exports.renderByOrder = renderByOrder;
	
	var getReactEventByType = function getReactEventByType(e) {
	  var type = e && e.type;
	
	  if (type && REACT_BROWSER_EVENT_MAP[type]) {
	    return REACT_BROWSER_EVENT_MAP[type];
	  }
	
	  return null;
	};
	
	exports.getReactEventByType = getReactEventByType;
	
	var parseChildIndex = function parseChildIndex(child, children) {
	  var result = -1;
	
	  _react.Children.forEach(children, function (entry, index) {
	    if (entry === child) {
	      result = index;
	    }
	  });
	
	  return result;
	};
	
	exports.parseChildIndex = parseChildIndex;

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var imageLogin = exports.imageLogin = __webpack_require__(2600);
	var overFooter = exports.overFooter = __webpack_require__(1772);
	var logoKolobAgent = exports.logoKolobAgent = __webpack_require__(2599);
	var poweredNuxiba = exports.poweredNuxiba = __webpack_require__(1773);
	
	var agentHeader = exports.agentHeader = __webpack_require__(1777);
	var arrowHeader = exports.arrowHeader = __webpack_require__(1781);
	var arrowHistorialND = exports.arrowHistorialND = __webpack_require__(1782);
	var logoHeader = exports.logoHeader = __webpack_require__(1789);
	var logoHeaderTxt = exports.logoHeaderTxt = __webpack_require__(1790);
	var macHeader = exports.macHeader = __webpack_require__(1793);
	var logOutHeader = exports.logOutHeader = __webpack_require__(1784);
	var clockHeader = exports.clockHeader = __webpack_require__(1799);
	var agentInbound = exports.agentInbound = __webpack_require__(1778);
	var agentOutbound = exports.agentOutbound = __webpack_require__(1779);
	var agentBoth = exports.agentBoth = __webpack_require__(1780);
	var successChange = exports.successChange = __webpack_require__(1783);
	var iconConfig = exports.iconConfig = __webpack_require__(1785);
	var hiddenPassword = exports.hiddenPassword = __webpack_require__(1786);
	var showPassword = exports.showPassword = __webpack_require__(1787);
	var changePassIcon = exports.changePassIcon = __webpack_require__(1798);
	var queueMessages = exports.queueMessages = __webpack_require__(1796);
	var tick = exports.tick = __webpack_require__(1797);
	
	var agentInboundInfo = exports.agentInboundInfo = __webpack_require__(1774);
	var agentOutboundInfo = exports.agentOutboundInfo = __webpack_require__(1776);
	var agentBothInfo = exports.agentBothInfo = __webpack_require__(1775);
	
	var facebookHeader = exports.facebookHeader = __webpack_require__(1788);
	var linkedinHeader = exports.linkedinHeader = __webpack_require__(1791);
	var mensajesHeader = exports.mensajesHeader = __webpack_require__(1795);
	var llamadasHeader = exports.llamadasHeader = __webpack_require__(1792);
	var mailHeader = exports.mailHeader = __webpack_require__(1794);
	var twitterHeader = exports.twitterHeader = __webpack_require__(1800);
	
	var mensajeriaUnificada = exports.mensajeriaUnificada = __webpack_require__(1871);
	var chatAgenteWB = exports.chatAgenteWB = __webpack_require__(1858);
	var noDisponibleWB = exports.noDisponibleWB = __webpack_require__(1861);
	var marcacionManualWB = exports.marcacionManualWB = __webpack_require__(1870);
	var historialNoDisponibleWB = exports.historialNoDisponibleWB = __webpack_require__(1860);
	var historialLlamadasWB = exports.historialLlamadasWB = __webpack_require__(1859);
	
	var alertIconMessage = exports.alertIconMessage = __webpack_require__(1810);
	var attachedFileMessage = exports.attachedFileMessage = __webpack_require__(1811);
	var deploBarMessage = exports.deploBarMessage = __webpack_require__(1812);
	var chatIconMessage = exports.chatIconMessage = __webpack_require__(1813);
	var mailIconMessage = exports.mailIconMessage = __webpack_require__(1814);
	var twitterIconMessage = exports.twitterIconMessage = __webpack_require__(1815);
	var userIconMessage = exports.userIconMessage = __webpack_require__(1816);
	
	var appleNoAvailable = exports.appleNoAvailable = __webpack_require__(1818);
	var headerNoAvailable = exports.headerNoAvailable = __webpack_require__(1819);
	var headerHistorialNA = exports.headerHistorialNA = __webpack_require__(1817);
	var undefinedNoAvailable = exports.undefinedNoAvailable = __webpack_require__(1820);
	var otherNoAvailable = exports.otherNoAvailable = __webpack_require__(1821);
	var bathRoomNoAvailable = exports.bathRoomNoAvailable = __webpack_require__(1822);
	var selectedNoAvailable = exports.selectedNoAvailable = __webpack_require__(1823);
	
	var iconChatSupervisor = exports.iconChatSupervisor = __webpack_require__(1834);
	var flechaChatSupervisor = exports.flechaChatSupervisor = __webpack_require__(1831);
	var agentChat = exports.agentChat = __webpack_require__(1833);
	var supervisorSelected = exports.supervisorSelected = __webpack_require__(1835);
	var sendChat = exports.sendChat = __webpack_require__(1830);
	var workGroup = exports.workGroup = __webpack_require__(1832);
	var workGroupSelected = exports.workGroupSelected = __webpack_require__(1836);
	var selectedBack = exports.selectedBack = __webpack_require__(1838);
	var back = exports.back = __webpack_require__(1837);
	var supervisorChat = exports.supervisorChat = __webpack_require__(1839);
	
	var loadingConsulting = exports.loadingConsulting = __webpack_require__(2602);
	
	var EstadoAgenteDispLlamManual = exports.EstadoAgenteDispLlamManual = __webpack_require__(1767);
	var EstadoAgenteError = exports.EstadoAgenteError = __webpack_require__(1768);
	var EstadoAgenteNoDisponible = exports.EstadoAgenteNoDisponible = __webpack_require__(1769);
	var EstadoAgenteNotas = exports.EstadoAgenteNotas = __webpack_require__(1770);
	var EstadoAgenteTransferencia = exports.EstadoAgenteTransferencia = __webpack_require__(1771);
	var AgentStateassistedTransfer = exports.AgentStateassistedTransfer = __webpack_require__(1766);
	
	var validatingTelephony = exports.validatingTelephony = __webpack_require__(2601);
	var validTelephony = exports.validTelephony = __webpack_require__(1852);
	var invalidTelephony = exports.invalidTelephony = __webpack_require__(1851);
	
	var btnCerrar = exports.btnCerrar = __webpack_require__(1873);
	var btnCloseBlack = exports.btnCloseBlack = __webpack_require__(1874);
	var btnCloseGray = exports.btnCloseGray = __webpack_require__(1872);
	
	var noVolume = exports.noVolume = __webpack_require__(1857);
	var noMircrophone = exports.noMircrophone = __webpack_require__(1856);
	var microphone = exports.microphone = __webpack_require__(1855);
	var mediumVolume = exports.mediumVolume = __webpack_require__(1854);
	var heightVolume = exports.heightVolume = __webpack_require__(1853);
	
	var all = exports.all = __webpack_require__(1846);
	var chat = exports.chat = __webpack_require__(1847);
	var facebook = exports.facebook = __webpack_require__(1848);
	var linkedin = exports.linkedin = __webpack_require__(1845);
	var twitter = exports.twitter = __webpack_require__(1850);
	var mail = exports.mail = __webpack_require__(1849);
	
	var callIcon = exports.callIcon = __webpack_require__(1748);
	var inboundCall = exports.inboundCall = __webpack_require__(1755);
	var outBoundCall = exports.outBoundCall = __webpack_require__(1756);
	var phoneIcon = exports.phoneIcon = __webpack_require__(1757);
	var typeCell = exports.typeCell = __webpack_require__(1759);
	var typeHome = exports.typeHome = __webpack_require__(1760);
	var typeOffice = exports.typeOffice = __webpack_require__(1762);
	var typePricipal = exports.typePricipal = __webpack_require__(1763);
	var typeDetermined = exports.typeDetermined = __webpack_require__(1761);
	var key = exports.key = __webpack_require__(1758);
	
	var reprogramacion1 = exports.reprogramacion1 = __webpack_require__(1753);
	var reprogramacion2 = exports.reprogramacion2 = __webpack_require__(1751);
	var reprogramacion3 = exports.reprogramacion3 = __webpack_require__(1754);
	var reprogramacion4 = exports.reprogramacion4 = __webpack_require__(1750);
	var reprogramacion5 = exports.reprogramacion5 = __webpack_require__(1752);
	
	var phoneIconChange = exports.phoneIconChange = __webpack_require__(1749);
	
	var dateReschedule = exports.dateReschedule = __webpack_require__(1828);
	var timeReschedule = exports.timeReschedule = __webpack_require__(1829);
	
	var search = exports.search = __webpack_require__(1825);
	var pause = exports.pause = __webpack_require__(1826);
	
	var agenda = exports.agenda = __webpack_require__(1841);
	var agentTransfer = exports.agentTransfer = __webpack_require__(1843);
	var conference = exports.conference = __webpack_require__(1842);
	var transferCall = exports.transferCall = __webpack_require__(1844);
	var leaveConference = exports.leaveConference = __webpack_require__(1840);
	
	var playRecord = exports.playRecord = __webpack_require__(1733);
	var moveRecord = exports.moveRecord = __webpack_require__(1746);
	var entryCallRecord = exports.entryCallRecord = __webpack_require__(1741);
	var outCallRecord = exports.outCallRecord = __webpack_require__(1742);
	var resizeManual = exports.resizeManual = __webpack_require__(1734);
	var checked = exports.checked = __webpack_require__(1737);
	var agentMark = exports.agentMark = __webpack_require__(1743);
	var adminMark = exports.adminMark = __webpack_require__(1744);
	var orderColum = exports.orderColum = __webpack_require__(1745);
	var leftArrow = exports.leftArrow = __webpack_require__(1740);
	var rightArrow = exports.rightArrow = __webpack_require__(1747);
	var firstPage = exports.firstPage = __webpack_require__(1738);
	var lastPage = exports.lastPage = __webpack_require__(1739);
	var iconInfo = exports.iconInfo = __webpack_require__(1732);
	
	var entryCallRecordSelected = exports.entryCallRecordSelected = __webpack_require__(1735);
	var outCallRecordSelected = exports.outCallRecordSelected = __webpack_require__(1736);
	
	var alert = exports.alert = __webpack_require__(1824);
	
	var send = exports.send = __webpack_require__(1765);
	var digits = exports.digits = __webpack_require__(1764);
	
	var mark = exports.mark = __webpack_require__(1807);
	var clock = exports.clock = __webpack_require__(1808);
	var cross = exports.cross = __webpack_require__(1809);
	var addMark = exports.addMark = __webpack_require__(1806);
	var infoAd = exports.infoAd = __webpack_require__(1805);
	
	var frames = {};
	for (var i = 1; i <= 32; i++) {
		frames[i] = __webpack_require__(2620)("./" + ('00' + i).slice(-3) + '.png');
	}
	var framesCamp = exports.framesCamp = frames;
	
	var connectedIntegration = exports.connectedIntegration = __webpack_require__(1801);
	var connectingIntegration = exports.connectingIntegration = __webpack_require__(1802);
	var disconnectedIntegration = exports.disconnectedIntegration = __webpack_require__(1803);
	var notFoundIntegration = exports.notFoundIntegration = __webpack_require__(1804);

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function checkDCE() {
	  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
	  if (
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
	  ) {
	    return;
	  }
	  if (false) {
	    // This branch is unreachable because this function is only called
	    // in production, but the condition is true only in development.
	    // Therefore if the branch is still here, dead code elimination wasn't
	    // properly applied.
	    // Don't change the message. React DevTools relies on it. Also make sure
	    // this message doesn't occur elsewhere in this function, or it will cause
	    // a false positive.
	    throw new Error('^_^');
	  }
	  try {
	    // Verify that the code above has been dead code eliminated (DCE'd).
	    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
	  } catch (err) {
	    // DevTools shouldn't crash React, no matter what.
	    // We should still report in case we break this code.
	    console.error(err);
	  }
	}
	
	if (true) {
	  // DCE check should happen before ReactDOM bundle executes so that
	  // DevTools can report bad minification during injection.
	  checkDCE();
	  module.exports = __webpack_require__(2271);
	} else {
	  module.exports = require('./cjs/react-dom.development.js');
	}


/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.messageToStateMachine = messageToStateMachine;
	exports.sendMessageNoAvailable = sendMessageNoAvailable;
	exports.sendMessageAgentReady = sendMessageAgentReady;
	exports.retryFirstCall = retryFirstCall;
	exports.messageToSupervisor = messageToSupervisor;
	exports.messageChangeState = messageChangeState;
	exports.messageMarksCall = messageMarksCall;
	exports.messageApiRequest = messageApiRequest;
	exports.messageHangUp = messageHangUp;
	exports.updateInfoCall = updateInfoCall;
	exports.messageTransferCall = messageTransferCall;
	exports.messageAssistedTransferCall = messageAssistedTransferCall;
	exports.manualCall = manualCall;
	exports.messageOngoingCallIvr = messageOngoingCallIvr;
	exports.aceptedChat = aceptedChat;
	exports.endConversationChat = endConversationChat;
	exports.spamConversation = spamConversation;
	exports.unassignConversation = unassignConversation;
	exports.discardConversation = discardConversation;
	exports.onSendUnifiedResponse = onSendUnifiedResponse;
	exports.onSendExternalUnifiedResponse = onSendExternalUnifiedResponse;
	exports.sendDispositionOnWrapUp = sendDispositionOnWrapUp;
	exports.selectedMessage = selectedMessage;
	exports.changeStateMultimedia = changeStateMultimedia;
	exports.changeStateMultimediaAll = changeStateMultimediaAll;
	exports.sendChangeDialingMode = sendChangeDialingMode;
	exports.actionPreviewRecord = actionPreviewRecord;
	exports.actionPreviewTransfer = actionPreviewTransfer;
	exports.actionResponseTransfer = actionResponseTransfer;
	exports.getMoreMessages = getMoreMessages;
	exports.acceptChatSaveTime = acceptChatSaveTime;
	exports.messageApiRequestANIList = messageApiRequestANIList;
	exports.getRecordCallPermission = getRecordCallPermission;
	exports.messageGetPreviewCampaigns = messageGetPreviewCampaigns;
	
	var _constants = __webpack_require__(10);
	
	function messageToStateMachine(message) {
	  return {
	    type: _constants.MESSAGES_TO_SM.MESSAGE_TO_SM,
	    message: message
	  };
	}
	
	function sendMessageNoAvailable(userName, userID, notReadyID, conversationID, timeInPreview) {
	  return {
	    type: _constants.MESSAGES_TO_SM.NO_AVAILABLE_EVENT,
	    userName: userName,
	    userID: userID,
	    notReadyID: notReadyID,
	    conversationID: conversationID,
	    TimePreview: timeInPreview
	  };
	}
	
	function sendMessageAgentReady() {
	  return {
	    type: _constants.MESSAGES_TO_SM.AGENT_READY
	  };
	}
	
	function retryFirstCall(userName, userID) {
	  return {
	    type: _constants.MESSAGES_TO_SM.RETRY_FIRST_CALL,
	    userName: userName,
	    userID: userID
	  };
	}
	
	function messageToSupervisor(message, supervisor) {
	  return {
	    type: _constants.MESSAGES_TO_SM.MESSAGE_TO_SUPERVISOR,
	    message: message,
	    supervisor: supervisor
	  };
	}
	
	function messageChangeState() {
	  return {
	    type: _constants.MESSAGES_TO_SM.CHANGE_STATE
	  };
	}
	
	function messageMarksCall(marks, callOutId) {
	  return {
	    type: _constants.MESSAGES_TO_SM.MARKS_CALL,
	    marks: marks,
	    callOutId: callOutId
	  };
	}
	
	function messageApiRequest(subaction, json, expectsResponse) {
	  return {
	    type: _constants.MESSAGES_TO_SM.API_REQUEST,
	    subaction: subaction,
	    json: json,
	    expectsResponse: expectsResponse
	  };
	}
	
	function messageHangUp(subaction, callOutId, maxTime) {
	  return {
	    type: _constants.MESSAGES_TO_SM.HANG_UP,
	    subaction: subaction,
	    callOutId: callOutId,
	    calloutMaxTime: maxTime
	  };
	}
	
	function updateInfoCall(callKey_A, camID_A, dataCall_A, callOutId_A) {
	  return {
	    type: _constants.MESSAGES_TO_SM.UPDATE_DATA_CALL,
	    callKey: callKey_A,
	    dataCall: dataCall_A,
	    camId: camID_A,
	    CallOutId: callOutId_A
	  };
	}
	
	function messageTransferCall(data) {
	  return {
	    type: _constants.MESSAGES_TO_SM.TRANSFER_CALL,
	    data: data
	  };
	}
	
	function messageAssistedTransferCall(process, data) {
	  return {
	    type: _constants.MESSAGES_TO_SM.ASSISTED_TRANSFER_CALL,
	    process: process,
	    data: data
	  };
	}
	
	function manualCall(data) {
	  return {
	    type: _constants.MESSAGES_TO_SM.MANUAL_CALL,
	    data: data
	  };
	}
	
	function messageOngoingCallIvr(id) {
	  return {
	    type: _constants.MESSAGES_TO_SM.ONGOING_CALL_IVR,
	    id: id
	  };
	}
	
	function aceptedChat(data) {
	  return {
	    type: _constants.MESSAGES_TO_SM.ACEPTED_CHAT,
	    data: data
	  };
	}
	
	function endConversationChat(data) {
	  return {
	    type: _constants.MESSAGES_TO_SM.END_CONVERSATION_CHAT,
	    data: data
	  };
	}
	
	function spamConversation(data) {
	  return {
	    type: _constants.MESSAGES_TO_SM.SPAM_CONVERSATION,
	    data: data
	  };
	}
	
	function unassignConversation(data) {
	  return {
	    type: _constants.MESSAGES_TO_SM.UNASSIGN_CONVERSATION,
	    data: data
	  };
	}
	
	function discardConversation(data) {
	  return {
	    type: _constants.MESSAGES_TO_SM.DISCARD_CONVERSATION,
	    data: data
	  };
	}
	
	function onSendUnifiedResponse(data) {
	  return {
	    type: _constants.MESSAGES_TO_SM.SEND_UNIFIED_RESPONSE,
	    data: data
	  };
	}
	
	function onSendExternalUnifiedResponse(data) {
	  return {
	    type: _constants.MESSAGES_TO_SM.SEND_EXTERNAL_UNIFIED_RESPONSE,
	    data: data
	  };
	}
	
	function sendDispositionOnWrapUp(data) {
	  return {
	    type: _constants.MESSAGES_TO_SM.SEND_DISPOSITION,
	    data: data
	  };
	}
	
	function selectedMessage(data) {
	  return {
	    type: _constants.MESSAGES_TO_SM.SELECTED_MESSAGE,
	    data: data
	  };
	}
	
	function changeStateMultimedia(data) {
	  return {
	    type: _constants.MESSAGES_TO_SM.CHANGE_STATE_MULTIMEDIA,
	    data: data
	  };
	}
	
	function changeStateMultimediaAll(data) {
	  return {
	    type: _constants.MESSAGES_TO_SM.CHANGE_STATE_MULTIMEDIA_ALL,
	    data: data
	  };
	}
	
	function sendChangeDialingMode(data) {
	  return {
	    type: _constants.MESSAGES_TO_SM.CHANGE_DIALINGMODE_SCH,
	    data: data
	  };
	}
	function actionPreviewRecord(data) {
	  return {
	    type: _constants.MESSAGES_TO_SM.PREVIEW_RECORD,
	    data: data
	  };
	}
	
	function actionPreviewTransfer(subaction, agent, callOutId) {
	  return {
	    type: _constants.MESSAGES_TO_SM.PREVIEW_TRANSFER,
	    subaction: subaction,
	    agent: agent,
	    callOutId: callOutId
	  };
	}
	
	function actionResponseTransfer(agent, response) {
	  return {
	    type: _constants.MESSAGES_TO_SM.SEND_RESPONSE_TRANSFER,
	    agent: agent,
	    response: response
	  };
	}
	function getMoreMessages(data) {
	  return {
	    type: _constants.MESSAGES_TO_SM.GET_MORE_MESSAGES,
	    data: data
	  };
	}
	
	function acceptChatSaveTime(data) {
	  return {
	    type: _constants.MESSAGES_TO_SM.ACCEPT_CHAT_SAVE_TIME,
	    data: data
	  };
	}
	
	function messageApiRequestANIList(subaction, camId, expectsResponse) {
	  return {
	    type: _constants.MESSAGES_TO_SM.API_REQUEST_ANI_LIST,
	    subaction: subaction,
	    campId: camId,
	    expectsResponse: expectsResponse
	  };
	}
	
	function getRecordCallPermission(subaction, camId, expectsResponse) {
	  return {
	    type: _constants.MESSAGES_TO_SM.GET_RECORD_CALL_PERMISSION,
	    subaction: subaction,
	    campId: camId,
	    expectsResponse: expectsResponse
	  };
	}
	function messageGetPreviewCampaigns(subaction) {
	  return {
	    type: _constants.MESSAGES_TO_SM.GET_PREVIEW_CAMPAIGNS,
	    subaction: subaction
	  };
	}

/***/ },
/* 33 */
[2624, 36],
/* 34 */
/***/ function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ },
/* 35 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ },
/* 36 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.Logger = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _globalLoggerServicesJsBundle = __webpack_require__(2019);
	
	var _singletonSharedData = __webpack_require__(23);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	_globalLoggerServicesJsBundle.LoggerInstance.setApplication("[Galatea-UI]");
	
	var Logger = exports.Logger = function () {
		function Logger() {
			_classCallCheck(this, Logger);
		}
	
		_createClass(Logger, [{
			key: 'setUserType',
			value: function setUserType(userType) {
				Logger.setUserType(userType);
			}
		}], [{
			key: 'getUserID',
			value: function getUserID() {
				var sharedData = new _singletonSharedData.SingletonSharedData();
				var user = sharedData.getParameters();
				var userId = user ? user.UserID : 0;
				_globalLoggerServicesJsBundle.LoggerInstance.setUserId(userId);
				return userId;
			}
		}, {
			key: 'setUserId',
			value: function setUserId(userId) {
				_globalLoggerServicesJsBundle.LoggerInstance.setUserId(userId);
			}
		}, {
			key: 'Trace',
			value: function Trace() {
				for (var _len = arguments.length, msg = Array(_len), _key = 0; _key < _len; _key++) {
					msg[_key] = arguments[_key];
				}
	
				_globalLoggerServicesJsBundle.LoggerInstance.Trace(['[Galatea-UI]'].concat(msg));
			}
		}, {
			key: 'Debug',
			value: function Debug() {
				for (var _len2 = arguments.length, msg = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
					msg[_key2] = arguments[_key2];
				}
	
				_globalLoggerServicesJsBundle.LoggerInstance.Debug(['[Galatea-UI]'].concat(msg));
			}
		}, {
			key: 'Warning',
			value: function Warning() {
				for (var _len3 = arguments.length, msg = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
					msg[_key3] = arguments[_key3];
				}
	
				_globalLoggerServicesJsBundle.LoggerInstance.Warning(['[Galatea-UI]'].concat(msg));
			}
		}, {
			key: 'Warn',
			value: function Warn() {
				for (var _len4 = arguments.length, msg = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
					msg[_key4] = arguments[_key4];
				}
	
				_globalLoggerServicesJsBundle.LoggerInstance.Warning(['[Galatea-UI]'].concat(msg));
			}
		}, {
			key: 'Info',
			value: function Info() {
				for (var _len5 = arguments.length, msg = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
					msg[_key5] = arguments[_key5];
				}
	
				_globalLoggerServicesJsBundle.LoggerInstance.Info(['[Galatea-UI]'].concat(msg));
			}
		}, {
			key: 'Error',
			value: function Error() {
				for (var _len6 = arguments.length, msg = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
					msg[_key6] = arguments[_key6];
				}
	
				_globalLoggerServicesJsBundle.LoggerInstance.Error.apply(_globalLoggerServicesJsBundle.LoggerInstance, ['[Galatea-UI]lib[UserID:' + Logger.getUserID() + ']'].concat(msg));
			}
		}, {
			key: 'JsError',
			value: function JsError() {
				for (var _len7 = arguments.length, msg = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
					msg[_key7] = arguments[_key7];
				}
	
				_globalLoggerServicesJsBundle.LoggerInstance.JsError.apply(_globalLoggerServicesJsBundle.LoggerInstance, ['[Galatea-UI]lib[UserID:' + Logger.getUserID() + ']'].concat(msg));
			}
		}, {
			key: 'JsWarning',
			value: function JsWarning() {
				for (var _len8 = arguments.length, msg = Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
					msg[_key8] = arguments[_key8];
				}
	
				_globalLoggerServicesJsBundle.LoggerInstance.JsWarning(['[Galatea-UI]'].concat(msg));
			}
		}, {
			key: 'EnableLocalLog',
			value: function EnableLocalLog(enabled, time) {
				_globalLoggerServicesJsBundle.LoggerInstance.setLocalLogger(enabled);
				enabled && _globalLoggerServicesJsBundle.LoggerInstance.setLocalStorageTime(time);
			}
		}]);

		return Logger;
	}();

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(125),
	    isObject = __webpack_require__(72);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getLinearRegression = exports.findEntryInArray = exports.interpolateNumber = exports.hasDuplicate = exports.getAnyElementOfObject = exports.getPercentValue = exports.uniqueId = exports.isNumOrStr = exports.isNumber = exports.isPercent = exports.mathSign = void 0;
	
	var _get2 = _interopRequireDefault(__webpack_require__(180));
	
	var _isArray2 = _interopRequireDefault(__webpack_require__(43));
	
	var _isNaN2 = _interopRequireDefault(__webpack_require__(290));
	
	var _isNumber2 = _interopRequireDefault(__webpack_require__(291));
	
	var _isString2 = _interopRequireDefault(__webpack_require__(292));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var mathSign = function mathSign(value) {
	  if (value === 0) {
	    return 0;
	  }
	
	  if (value > 0) {
	    return 1;
	  }
	
	  return -1;
	};
	
	exports.mathSign = mathSign;
	
	var isPercent = function isPercent(value) {
	  return (0, _isString2["default"])(value) && value.indexOf('%') === value.length - 1;
	};
	
	exports.isPercent = isPercent;
	
	var isNumber = function isNumber(value) {
	  return (0, _isNumber2["default"])(value) && !(0, _isNaN2["default"])(value);
	};
	
	exports.isNumber = isNumber;
	
	var isNumOrStr = function isNumOrStr(value) {
	  return isNumber(value) || (0, _isString2["default"])(value);
	};
	
	exports.isNumOrStr = isNumOrStr;
	var idCounter = 0;
	
	var uniqueId = function uniqueId(prefix) {
	  var id = ++idCounter;
	  return "".concat(prefix || '').concat(id);
	};
	/**
	 * Get percent value of a total value
	 * @param {Number|String} percent A percent
	 * @param {Number} totalValue     Total value
	 * @param {NUmber} defaultValue   The value returned when percent is undefined or invalid
	 * @param {Boolean} validate      If set to be true, the result will be validated
	 * @return {Number} value
	 */
	
	
	exports.uniqueId = uniqueId;
	
	var getPercentValue = function getPercentValue(percent, totalValue) {
	  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	  var validate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	  if (!isNumber(percent) && !(0, _isString2["default"])(percent)) {
	    return defaultValue;
	  }
	
	  var value;
	
	  if (isPercent(percent)) {
	    var index = percent.indexOf('%');
	    value = totalValue * parseFloat(percent.slice(0, index)) / 100;
	  } else {
	    value = +percent;
	  }
	
	  if ((0, _isNaN2["default"])(value)) {
	    value = defaultValue;
	  }
	
	  if (validate && value > totalValue) {
	    value = totalValue;
	  }
	
	  return value;
	};
	
	exports.getPercentValue = getPercentValue;
	
	var getAnyElementOfObject = function getAnyElementOfObject(obj) {
	  if (!obj) {
	    return null;
	  }
	
	  var keys = Object.keys(obj);
	
	  if (keys && keys.length) {
	    return obj[keys[0]];
	  }
	
	  return null;
	};
	
	exports.getAnyElementOfObject = getAnyElementOfObject;
	
	var hasDuplicate = function hasDuplicate(ary) {
	  if (!(0, _isArray2["default"])(ary)) {
	    return false;
	  }
	
	  var len = ary.length;
	  var cache = {};
	
	  for (var i = 0; i < len; i++) {
	    if (!cache[ary[i]]) {
	      cache[ary[i]] = true;
	    } else {
	      return true;
	    }
	  }
	
	  return false;
	};
	
	exports.hasDuplicate = hasDuplicate;
	
	var interpolateNumber = function interpolateNumber(numberA, numberB) {
	  if (isNumber(numberA) && isNumber(numberB)) {
	    return function (t) {
	      return numberA + t * (numberB - numberA);
	    };
	  }
	
	  return function () {
	    return numberB;
	  };
	};
	
	exports.interpolateNumber = interpolateNumber;
	
	var findEntryInArray = function findEntryInArray(ary, specifiedKey, specifiedValue) {
	  if (!ary || !ary.length) {
	    return null;
	  }
	
	  return ary.find(function (entry) {
	    return entry && (typeof specifiedKey === 'function' ? specifiedKey(entry) : (0, _get2["default"])(entry, specifiedKey)) === specifiedValue;
	  });
	};
	/**
	 * The least square linear regression
	 * @param {Array} data The array of points
	 * @returns {Object} The domain of x, and the parameter of linear function
	 */
	
	
	exports.findEntryInArray = findEntryInArray;
	
	var getLinearRegression = function getLinearRegression(data) {
	  if (!data || !data.length) {
	    return null;
	  }
	
	  var len = data.length;
	  var xsum = 0;
	  var ysum = 0;
	  var xysum = 0;
	  var xxsum = 0;
	  var xmin = Infinity;
	  var xmax = -Infinity;
	
	  for (var i = 0; i < len; i++) {
	    xsum += data[i].cx;
	    ysum += data[i].cy;
	    xysum += data[i].cx * data[i].cy;
	    xxsum += data[i].cx * data[i].cx;
	    xmin = Math.min(xmin, data[i].cx);
	    xmax = Math.max(xmax, data[i].cx);
	  }
	
	  var a = len * xxsum !== xsum * xsum ? (len * xysum - xsum * ysum) / (len * xxsum - xsum * xsum) : 0;
	  return {
	    xmin: xmin,
	    xmax: xmax,
	    a: a,
	    b: (ysum - a * xsum) / len
	  };
	};
	
	exports.getLinearRegression = getLinearRegression;

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	// [NUXIBA]  Version: 2023.828.0 - 2023-08-29 15:17:02  
	 (function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define([], factory);
		else if(typeof exports === 'object')
			exports["EntryPoint"] = factory();
		else
			root["EntryPoint"] = factory();
	})(typeof self !== 'undefined' ? self : this, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 1);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.Logger = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _globalLoggerServicesJsBundle = __webpack_require__(3);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Logger = exports.Logger = function () {
		function Logger() {
			_classCallCheck(this, Logger);
		}
	
		_createClass(Logger, null, [{
			key: 'Trace',
			value: function Trace() {
				for (var _len = arguments.length, msg = Array(_len), _key = 0; _key < _len; _key++) {
					msg[_key] = arguments[_key];
				}
	
				_globalLoggerServicesJsBundle.LoggerInstance.Trace.apply(_globalLoggerServicesJsBundle.LoggerInstance, ['[API-JS] '].concat(msg));
			}
		}, {
			key: 'Debug',
			value: function Debug() {
				for (var _len2 = arguments.length, msg = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
					msg[_key2] = arguments[_key2];
				}
	
				_globalLoggerServicesJsBundle.LoggerInstance.Debug.apply(_globalLoggerServicesJsBundle.LoggerInstance, ['[API-JS] '].concat(msg));
			}
		}, {
			key: 'Warning',
			value: function Warning() {
				for (var _len3 = arguments.length, msg = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
					msg[_key3] = arguments[_key3];
				}
	
				_globalLoggerServicesJsBundle.LoggerInstance.Warning.apply(_globalLoggerServicesJsBundle.LoggerInstance, ['[API-JS] '].concat(msg));
			}
		}, {
			key: 'Info',
			value: function Info() {
				for (var _len4 = arguments.length, msg = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
					msg[_key4] = arguments[_key4];
				}
	
				_globalLoggerServicesJsBundle.LoggerInstance.Info.apply(_globalLoggerServicesJsBundle.LoggerInstance, ['[API-JS] '].concat(msg));
			}
		}, {
			key: 'Error',
			value: function Error() {
				for (var _len5 = arguments.length, msg = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
					msg[_key5] = arguments[_key5];
				}
	
				_globalLoggerServicesJsBundle.LoggerInstance.Error.apply(_globalLoggerServicesJsBundle.LoggerInstance, ['[API-JS] '].concat(msg));
			}
		}]);
	
		return Logger;
	}();
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.APIFactory = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _apiController = __webpack_require__(2);
	
	var _galateaAPIWrapper = __webpack_require__(4);
	
	var _globalCipherServicesJsBundleMin = __webpack_require__(10);
	
	var _Logger = __webpack_require__(0);
	
	var _package = __webpack_require__(11);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var APIFactory = exports.APIFactory = function () {
		function APIFactory() {
			_classCallCheck(this, APIFactory);
		}
	
		_createClass(APIFactory, [{
			key: 'buildClient',
			value: function buildClient() {
				_Logger.Logger.Info("Version ", _package.version);
				var galateaAPI = new _galateaAPIWrapper.galateaAPIWrapper();
				var cypherFactory = new _globalCipherServicesJsBundleMin.CypherFactory();
				var cypher = cypherFactory.buildClient();
	
				return new _apiController.ApiController(galateaAPI.getAPI(), cypher);
			}
		}]);
	
		return APIFactory;
	}();
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ApiController = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Logger = __webpack_require__(0);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var instance = null;
	
	var ApiController = exports.ApiController = function () {
	  function ApiController(galateaAPI, cypher) {
	    _classCallCheck(this, ApiController);
	
	    _Logger.Logger.Debug(" ApiController init constructor ... ");
	    if (!instance) {
	      this.galateaAPI = galateaAPI;
	      this.cypher = cypher;
	      instance = this;
	      this.unExpectedError = 9999;
	      this.unexpectedErrorJson = {
	        "Type": "ERROR",
	        "InternalCode": 9999,
	        "Message": ""
	      };
	    }
	    return instance;
	  }
	
	  _createClass(ApiController, [{
	    key: "getObjectResponse",
	    value: function getObjectResponse() {
	      return {
	        onError: function onError() {
	          console.log("Stack");
	        },
	        onSuccess: function onSuccess() {
	          console.log("Stack");
	        },
	        onCatch: function onCatch(err) {
	          console.log("Stack", err);
	        }
	      };
	    }
	  }, {
	    key: "agentLogin",
	    value: function agentLogin(loginData, objectResponse) {
	      var _this = this;
	      var user = this.cypher.blowfishEncryption(loginData.user);
	      var password = this.cypher.md5Encryption(loginData.password);
	      var ipAddress = this.cypher.blowfishEncryption(loginData.ipAddress);
	      var RequestOk = true;
	      _Logger.Logger.Debug("agentLogin->user:", user);
	      this.galateaAPI.loginService(user, password, ipAddress, loginData.isRemote).then(function (response) {
	        RequestOk = response.ok;
	        return response.json();
	      }).then(function (json) {
	        var userResponse = json;
	        if (RequestOk) {
	          objectResponse.onSuccess(userResponse);
	        } else {
	          objectResponse.onError(userResponse);
	        }
	      }).catch(function (error) {
	        var errorJson = { Type: "ERROR", InternalCode: _this.unExpectedError, Message: "" };
	        console.log("Login - Ocurrio un error inesperado ", error);
	        objectResponse.onError(errorJson);
	      });
	    }
	  }, {
	    key: "getAttachments",
	    value: function getAttachments(data, objectResponse) {
	      var _this = this;
	      this.galateaAPI.attachmentsService(data).then(function (response) {
	        return _this.getResponseGlobal(response, objectResponse);
	      }).then(function (json) {
	        _this.getResponseGlobalThen(json, objectResponse);
	      }).catch(function (error) {
	        _this.getResponseGlobalCatch(error, objectResponse);
	      });
	    }
	  }, {
	    key: "getLanguage",
	    value: function getLanguage(language, objectResponse) {
	      var _this = this;
	      this.galateaAPI.languageService(language).then(function (response) {
	        return _this.getResponseGlobal(response, objectResponse);
	      }).then(function (json) {
	        _this.getResponseGlobalThen(json, objectResponse);
	      }).catch(function (error) {
	        _this.getResponseGlobalCatch(error, objectResponse);
	      });
	    }
	  }, {
	    key: "getListNoAvailable",
	    value: function getListNoAvailable(userID, objectResponse) {
	      var _this2 = this;
	
	      var timeOut = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10000;
	
	      var AbortController = window.AbortController;
	      var controller = new AbortController();
	      var timeoutId = setTimeout(function () {
	        return controller.abort();
	      }, timeOut);
	      this.galateaAPI.noAvailableService(userID, controller).then(function (response) {
	        _this2.responseOK = response.ok;
	        return response.json();
	      }).then(function (json) {
	        clearTimeout(timeoutId);
	        if (json != null) {
	          if (_this2.responseOK) {
	            objectResponse.onSuccess(json);
	          } else {
	            _Logger.Logger.Error("getListNoAvailable error:", json);
	            objectResponse.onError(json);
	          }
	        }
	      }).catch(function (error) {
	        _Logger.Logger.Error("getListNoAvailable catch:", error);
	        objectResponse.onCatch(error);
	      });
	    }
	  }, {
	    key: "getNotReadyHistory",
	    value: function getNotReadyHistory(userId, objectResponse) {
	      var _this3 = this;
	
	      var timeOut = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10000;
	
	      var AbortController = window.AbortController;
	      var controller = new AbortController();
	      var timeoutId = setTimeout(function () {
	        return controller.abort();
	      }, timeOut);
	      this.galateaAPI.notReadyHistoryService(userId, controller).then(function (response) {
	        _this3.responseOK = response.ok;
	        return response.json();
	      }).then(function (json) {
	        clearTimeout(timeoutId);
	        if (json != null) {
	          if (_this3.responseOK) {
	            objectResponse.onSuccess(json);
	          } else {
	            _Logger.Logger.Error("getNotReadyHistory error:", json);
	            objectResponse.onError(json);
	          }
	        }
	      }).catch(function (error) {
	        _Logger.Logger.Error("getNotReadyHistory catch:", error);
	        objectResponse.onCatch(error);
	      });
	    }
	  }, {
	    key: "validateNotAvailablePassword",
	    value: function validateNotAvailablePassword(validationData, objectResponse) {
	      validationData.nombre = this.cypher.blowfishEncryption(validationData.nombre);
	      validationData.password = this.cypher.md5Encryption(validationData.password);
	      validationData.supervisorPassword = this.cypher.md5Encryption(validationData.supervisorPassword);
	      var RequestOk = true;
	      this.galateaAPI.validateNotAvailablePasswords(validationData).then(function (response) {
	        RequestOk = response.ok;
	        return response.json();
	      }).then(function (json) {
	        if (RequestOk) {
	          objectResponse.onSuccess(json);
	        } else {
	          objectResponse.onError(json);
	        }
	      }).catch(function (error) {
	        objectResponse.onError(error);
	      });
	    }
	  }, {
	    key: "getSupervisorList",
	    value: function getSupervisorList(agentId, objectResponse) {
	      var _this4 = this;
	
	      var timeOut = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10000;
	
	      var AbortController = window.AbortController;
	      var controller = new AbortController();
	      var timeoutId = setTimeout(function () {
	        return controller.abort();
	      }, timeOut);
	
	      this.galateaAPI.getSupervisorList(agentId, controller).then(function (response) {
	        _this4.responseOK = response.ok;
	        return response.json();
	      }).then(function (json) {
	        clearTimeout(timeoutId);
	        if (json != null) {
	          if (_this4.responseOK) {
	            objectResponse.onSuccess(json);
	          } else {
	            _Logger.Logger.Error("getSupervisorList error:", json);
	            objectResponse.onError(json);
	          }
	        }
	      }).catch(function (error) {
	        _Logger.Logger.Error("getSupervisorList catch:", error);
	        objectResponse.onError(error);
	      });
	    }
	  }, {
	    key: "changePassword",
	    value: function changePassword(agentId, password, confirmPassword, newPassword, objectResponse) {
	      password = this.cypher.md5Encryption(password);
	      confirmPassword = this.cypher.blowfishEncryption(confirmPassword);
	      newPassword = this.cypher.blowfishEncryption(newPassword);
	      this.responseOK = false;
	      this.changePasswordProcess(agentId, password, confirmPassword, newPassword, objectResponse);
	    }
	  }, {
	    key: "changePasswordProcess",
	    value: function changePasswordProcess(agentId, password, confirmPassword, newPassword, objectResponse) {
	      var _this5 = this;
	
	      var _this = this;
	      this.galateaAPI.changePassword(agentId, password, confirmPassword, newPassword).then(function (response) {
	        if (response.ok) {
	          objectResponse.onSuccess("Ok");
	          _this5.responseOK = true;
	        } else {
	          return response.json();
	        }
	      }).then(function (json) {
	        if (!_this5.responseOK) {
	          _Logger.Logger.Debug(json);
	          objectResponse.onError(json);
	        }
	      }).catch(function (error) {
	        _Logger.Logger.Debug(error);
	        objectResponse.onError(_this.unExpectedError);
	      });
	    }
	  }, {
	    key: "dispositionList",
	    value: function dispositionList(data, objectResponse) {
	      var _this6 = this;
	
	      var timeOut = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10000;
	
	      this.responseOK = false;
	      var AbortController = window.AbortController;
	      var controller = new AbortController();
	      var timeoutId = setTimeout(function () {
	        return controller.abort();
	      }, timeOut);
	      this.galateaAPI.dispositionList(data.Id, data.Type, data.CallOutId, data.UserId, data.CamId, controller).then(function (response) {
	        _this6.responseOK = response.ok;
	        return response.json();
	      }).then(function (json) {
	        clearTimeout(timeoutId);
	        if (json != null) {
	          if (_this6.responseOK) {
	            objectResponse.onSuccess(json.Response);
	          } else {
	            _Logger.Logger.Error("DispositionList error: ", json);
	            objectResponse.onError(json);
	          }
	        }
	      }).catch(function (error) {
	        _Logger.Logger.Error("DispositionList catch: ", error);
	        objectResponse.onCatch(error);
	      });
	    }
	  }, {
	    key: "saveDispositionListACD",
	    value: function saveDispositionListACD(dataObject, objectResponse) {
	      this.responseOK = false;
	      var _this = this;
	      this.galateaAPI.saveDispositionListACD(dataObject).then(function (response) {
	        return _this.getResponseGlobal(response, objectResponse);
	      }).then(function (json) {
	        _this.getResponseGlobalResponseThen(json, objectResponse);
	      }).catch(function (error) {
	        _this.getResponseGlobalCatch(error, objectResponse);
	      });
	    }
	  }, {
	    key: "callIcon",
	    value: function callIcon(dataObject, objectResponse) {
	      this.responseOK = false;
	      var _this = this;
	      this.galateaAPI.callIcon(dataObject).then(function (response) {
	        return _this.getResponseGlobal(response, objectResponse);
	      }).then(function (json) {
	        _this.getResponseGlobalResponseThen(json, objectResponse);
	      }).catch(function (error) {
	        _this.getResponseGlobalCatch(error, objectResponse);
	      });
	    }
	  }, {
	    key: "GetRecordCallPermission",
	    value: function GetRecordCallPermission(dataObject, objectResponse) {
	      this.responseOK = false;
	      var _this = this;
	      this.galateaAPI.GetRecordCallPermission(dataObject).then(function (response) {
	        return _this.getResponseGlobal(response, objectResponse);
	      }).then(function (json) {
	        _this.getResponseGlobalResponseThen(json, objectResponse);
	      }).catch(function (error) {
	        _this.getResponseGlobalCatch(error, objectResponse);
	      });
	    }
	  }, {
	    key: "transferCall",
	    value: function transferCall(userId, acdId, objectResponse) {
	      var _this7 = this;
	
	      var timeOut = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 10000;
	
	      this.responseOK = false;
	      var AbortController = window.AbortController;
	      var controller = new AbortController();
	      var timeoutId = setTimeout(function () {
	        return controller.abort();
	      }, timeOut);
	      this.galateaAPI.transferCall(userId, acdId, controller).then(function (response) {
	        _this7.responseOK = response.ok;
	        return response.json();
	      }).then(function (json) {
	        clearTimeout(timeoutId);
	        if (json != null) {
	          if (_this7.responseOK) {
	            objectResponse.onSuccess(json.Response);
	          } else {
	            _Logger.Logger.Error("transferCall options error: ", json);
	            objectResponse.onError(json);
	          }
	        }
	      }).catch(function (error) {
	        _Logger.Logger.Error("transferCall options catch: ", error);
	        objectResponse.onCatch(error);
	      });
	    }
	  }, {
	    key: "callHistory",
	    value: function callHistory(userId, objectResponse) {
	      var _this8 = this;
	
	      var timeOut = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10000;
	
	      var AbortController = window.AbortController;
	      var controller = new AbortController();
	      var timeoutId = setTimeout(function () {
	        return controller.abort();
	      }, timeOut);
	      this.galateaAPI.callHistory(userId, controller).then(function (response) {
	        _this8.responseOK = response.ok;
	        return response.json();
	      }).then(function (json) {
	        clearTimeout(timeoutId);
	        if (json != null) {
	          if (_this8.responseOK) {
	            objectResponse.onSuccess(json.Response);
	          } else {
	            _Logger.Logger.Error("CallHistory error: ", json);
	            objectResponse.onError(json);
	          }
	        }
	      }).catch(function (error) {
	        _Logger.Logger.Error("CallHistory catch: ", error);
	        objectResponse.onCatch(error);
	      });
	    }
	  }, {
	    key: "saveDataCallOut",
	    value: function saveDataCallOut(dataObject, objectResponse) {
	      this.responseOK = false;
	      var _this = this;
	      this.galateaAPI.saveDataCallOut(dataObject).then(function (response) {
	        return _this.getResponseGlobal(response, objectResponse);
	      }).then(function (json) {
	        _this.getResponseGlobalResponseThen(json, objectResponse);
	      }).catch(function (error) {
	        _this.getResponseGlobalCatch(error, objectResponse);
	      });
	    }
	  }, {
	    key: "validatePhoneNumber",
	    value: function validatePhoneNumber(dataObject, objectResponse) {
	      this.responseOK = false;
	      var ApiResponse = {
	        ResponseOk: true,
	        Status: 200,
	        Description: "OK",
	        Json: {}
	      };
	      this.validatePhoneNumberProcess(dataObject, objectResponse, ApiResponse);
	    }
	  }, {
	    key: "validatePhoneNumberProcess",
	    value: function validatePhoneNumberProcess(dataObject, objectResponse, ApiResponse) {
	      this.galateaAPI.validatePhoneNumber(dataObject).then(function (response) {
	        ApiResponse.ResponseOk = response.ok;
	        ApiResponse.Status = response.status;
	        ApiResponse.Description = response.statusText;
	        return response.json();
	      }).then(function (json) {
	        if (json != null) {
	          ApiResponse.Json = json;
	          if (ApiResponse.ResponseOk) {
	            objectResponse.onSuccess(ApiResponse);
	          } else {
	            objectResponse.onError(ApiResponse);
	          }
	        }
	      }).catch(function (error) {
	        objectResponse.onError("Ocurrio un error inesperado" + error);
	      });
	    }
	  }, {
	    key: "callAudio",
	    value: function callAudio(dataObject, objectResponse) {
	      this.responseOK = false;
	      var _this = this;
	      this.galateaAPI.callAudio(dataObject).then(function (response) {
	        return _this.getResponseGlobal(response, objectResponse);
	      }).then(function (json) {
	        _this.getResponseGlobalResponseThen(json, objectResponse);
	      }).catch(function (error) {
	        _this.getResponseGlobalCatch(error, objectResponse);
	      });
	    }
	  }, {
	    key: "markCall",
	    value: function markCall(dataObject, objectResponse) {
	      this.responseOK = false;
	      var _this = this;
	      this.galateaAPI.markCall(dataObject).then(function (response) {
	        return _this.getResponseGlobal(response, objectResponse);
	      }).then(function (json) {
	        _this.getResponseGlobalResponseThen(json, objectResponse);
	      }).catch(function (error) {
	        _this.getResponseGlobalCatch(error, objectResponse);
	      });
	    }
	  }, {
	    key: "getDayCallBack",
	    value: function getDayCallBack(userId, date, objectResponse) {
	      this.responseOK = false;
	      var _this = this;
	      this.galateaAPI.getDayCallBack(userId, date).then(function (response) {
	        return _this.getResponseGlobal(response, objectResponse);
	      }).then(function (json) {
	        _this.getResponseGlobalResponseThen(json, objectResponse);
	      }).catch(function (error) {
	        _this.getResponseGlobalCatch(error, objectResponse);
	      });
	    }
	  }, {
	    key: "externalContacts",
	    value: function externalContacts(objectResponse) {
	      this.responseOK = false;
	      var _this = this;
	      this.galateaAPI.externalContacts().then(function (response) {
	        return _this.getResponseGlobal(response, objectResponse);
	      }).then(function (json) {
	        _this.getResponseGlobalResponseThen(json, objectResponse);
	      }).catch(function (error) {
	        _this.getResponseGlobalCatch(error, objectResponse);
	      });
	    }
	  }, {
	    key: "externalOdbcCampaign",
	    value: function externalOdbcCampaign(campID, objectResponse) {
	      var _this9 = this;
	
	      var AbortController = window.AbortController;
	      var controller = new AbortController();
	      var timeoutId = setTimeout(function () {
	        return controller.abort();
	      }, 30000);
	      this.responseOK = false;
	      this.galateaAPI.externalOdbcCampaign(campID, controller).then(function (response) {
	        _this9.responseOK = response.ok;
	        return response.json();
	      }).then(function (json) {
	        clearTimeout(timeoutId);
	        if (json != null) {
	          _this9.responseOK ? objectResponse.onSuccess(json.Response) : objectResponse.onError(json.Message);
	        }
	      }).catch(function (error) {
	        objectResponse.onCatch(error);
	      });
	    }
	  }, {
	    key: "ongoingCallIvr",
	    value: function ongoingCallIvr(objectResponse) {
	      this.responseOK = false;
	      var _this = this;
	      this.galateaAPI.ongoingCallIvr().then(function (response) {
	        return _this.getResponseGlobal(response, objectResponse);
	      }).then(function (json) {
	        _this.getResponseGlobalResponseThen(json, objectResponse);
	      }).catch(function (error) {
	        _this.getResponseGlobalCatch(error, objectResponse);
	      });
	    }
	  }, {
	    key: "getChatLog",
	    value: function getChatLog(userId, objectResponse) {
	      this.responseOK = false;
	      var _this = this;
	      this.galateaAPI.getChatLog(userId).then(function (response) {
	        return _this.getResponseGlobal(response, objectResponse);
	      }).then(function (json) {
	        _this.getResponseGlobalResponseThen(json, objectResponse);
	      }).catch(function (error) {
	        _this.getResponseGlobalCatch(error, objectResponse);
	      });
	    }
	  }, {
	    key: "updloadAttachments",
	    value: function updloadAttachments(file, body, objectResponse) {
	      var _this = this;
	      this.galateaAPI.uploadAttachment(file, body).then(function (response) {
	        return _this.getResponseGlobal(response, objectResponse);
	      }).then(function (json) {
	        _this.getResponseGlobalResponseThen(json, objectResponse);
	      }).catch(function (error) {
	        _this.getResponseGlobalCatch(error, objectResponse);
	      });
	    }
	  }, {
	    key: "deleteAttachment",
	    value: function deleteAttachment(body, objectResponse) {
	      var _this = this;
	      this.galateaAPI.deleteAttachment(body).then(function (response) {
	        return _this.getResponseGlobal(response, objectResponse);
	      }).then(function (json) {
	        _this.getResponseGlobalResponseThen(json, objectResponse);
	      }).catch(function (error) {
	        _this.getResponseGlobalCatch(error, objectResponse);
	      });
	    }
	  }, {
	    key: "uploadUnifiedInboxAttachments",
	    value: function uploadUnifiedInboxAttachments(file, body, objectResponse) {
	      var _this = this;
	      this.galateaAPI.uploadUnifiedInboxAttachments(file, body).then(function (response) {
	        return _this.getResponseGlobal(response, objectResponse);
	      }).then(function (json) {
	        if (json != null) {
	          objectResponse.onSuccess({ data: json, type: body.MediaType });
	        }
	      }).catch(function (error) {
	        _this.getResponseGlobalCatch(error, objectResponse);
	      });
	    }
	  }, {
	    key: "deleteUnifiedInboxAttachment",
	    value: function deleteUnifiedInboxAttachment(body, objectResponse) {
	      var _this = this;
	      this.galateaAPI.deleteUnifiedInboxAttachment(body).then(function (response) {
	        return _this.getResponseGlobal(response, objectResponse);
	      }).then(function (json) {
	        _this.getResponseGlobalThen(json, objectResponse);
	      }).catch(function (error) {
	        _this.getResponseGlobalCatch(error, objectResponse);
	      });
	    }
	  }, {
	    key: "getPreviewHistory",
	    value: function getPreviewHistory(data, objectResponse) {
	      var _this = this;
	      this.galateaAPI.getPreviewHistory(data).then(function (response) {
	        return _this.getResponseGlobal(response, objectResponse);
	      }).then(function (json) {
	        _this.getResponseGlobalThen(json, objectResponse);
	      }).catch(function (error) {
	        _this.getResponseGlobalCatch(error, objectResponse);
	      });
	    }
	  }, {
	    key: "getResponseGlobal",
	    value: function getResponseGlobal(response, objectResponse) {
	      if (!response || !response.ok) {
	        objectResponse.onError("Ocurrio un error inesperado");
	      }
	      return response.json();
	    }
	  }, {
	    key: "getResponseGlobalThen",
	    value: function getResponseGlobalThen(json, objectResponse) {
	      if (json) {
	        objectResponse.onSuccess(json);
	      }
	    }
	  }, {
	    key: "getResponseGlobalResponseThen",
	    value: function getResponseGlobalResponseThen(json, objectResponse) {
	      if (json) {
	        objectResponse.onSuccess(json.Response);
	      }
	    }
	  }, {
	    key: "getResponseGlobalCatch",
	    value: function getResponseGlobalCatch(error, objectResponse) {
	      objectResponse.onError("ocurrio un error inesperado " + error);
	    }
	  }, {
	    key: "uploadAttachmentsChats",
	    value: function uploadAttachmentsChats(file, body, objectResponse) {
	      this.galateaAPI.uploadAttachmentsChats(file, body).then(function (response) {
	        if (!response.ok) {
	          objectResponse.onError("Ocurrio un error inesperado");
	        }
	        return response.json();
	      }).then(function (json) {
	        if (json != null) {
	          objectResponse.onSuccess({ url: json, type: body.MediaType });
	        }
	      }).catch(function (error) {
	        objectResponse.onError("ocurrio un error inesperado " + error);
	      });
	    }
	  }, {
	    key: "validateWhatsAppPhoneNumber",
	    value: function validateWhatsAppPhoneNumber(dataObject, objectResponse) {
	      this.responseOK = false;
	      var ApiResponse = {
	        ResponseOk: true,
	        Status: 200,
	        Description: "OK",
	        Json: {}
	      };
	      this.validateWhatsAppPhoneNumberProcess(dataObject, objectResponse, ApiResponse);
	    }
	  }, {
	    key: "validateWhatsAppPhoneNumberProcess",
	    value: function validateWhatsAppPhoneNumberProcess(dataObject, objectResponse, ApiResponse) {
	      this.galateaAPI.validateWhatsAppPhoneNumber(dataObject).then(function (response) {
	        ApiResponse.ResponseOk = response.ok;
	        ApiResponse.Status = response.status;
	        ApiResponse.Description = response.statusText;
	        return response.json();
	      }).then(function (json) {
	        if (json != null) {
	          ApiResponse.Json = json;
	          if (ApiResponse.ResponseOk) {
	            objectResponse.onSuccess(ApiResponse);
	          } else {
	            objectResponse.onError(ApiResponse);
	          }
	        }
	      }).catch(function (error) {
	        objectResponse.onError("Ocurrio un error inesperado" + error);
	      });
	    }
	  }, {
	    key: "getWhatsAppTemplates",
	    value: function getWhatsAppTemplates(dataObject, objectResponse) {
	      this.responseOK = false;
	      var ApiResponse = {
	        ResponseOk: true,
	        Status: 200,
	        Description: "OK",
	        Json: {}
	      };
	      this.getWhatsAppTemplatesProcess(dataObject, objectResponse, ApiResponse);
	    }
	  }, {
	    key: "getWhatsAppTemplatesProcess",
	    value: function getWhatsAppTemplatesProcess(dataObject, objectResponse, ApiResponse) {
	      this.galateaAPI.getWhatsAppTemplates(dataObject).then(function (response) {
	        ApiResponse.ResponseOk = response.ok;
	        ApiResponse.Status = response.status;
	        ApiResponse.Description = response.statusText;
	        return response.json();
	      }).then(function (json) {
	        if (json != null) {
	          ApiResponse.Json = json;
	          if (ApiResponse.ResponseOk) {
	            objectResponse.onSuccess(ApiResponse);
	          } else {
	            objectResponse.onError(ApiResponse);
	          }
	        }
	      }).catch(function (error) {
	        objectResponse.onError("Ocurrio un error inesperado" + error);
	      });
	    }
	  }, {
	    key: "PathWS",
	    set: function set(webServices) {
	      this.galateaAPI.PathWS = webServices;
	    },
	    get: function get() {
	      return this.galateaAPI.PathWS;
	    }
	  }]);
	
	  return ApiController;
	}();
	
	exports.default = ApiController;
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// [NUXIBA]  Version: 2022.0.0 - 2022-11-10  
	 (function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define([], factory);
		else if(typeof exports === 'object')
			exports["LoggerEntryPoint"] = factory();
		else
			root["LoggerEntryPoint"] = factory();
	})(typeof self !== 'undefined' ? self : this, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 3);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var bind = __webpack_require__(5);
	var isBuffer = __webpack_require__(15);
	
	/*global toString:true*/
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return toString.call(val) === '[object Array]';
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	function isArrayBuffer(val) {
	  return toString.call(val) === '[object ArrayBuffer]';
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(val) {
	  return (typeof FormData !== 'undefined') && (val instanceof FormData);
	}
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  var result;
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
	  }
	  return result;
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	function isDate(val) {
	  return toString.call(val) === '[object Date]';
	}
	
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	function isFile(val) {
	  return toString.call(val) === '[object File]';
	}
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	function isBlob(val) {
	  return toString.call(val) === '[object Blob]';
	}
	
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */
	function isFunction(val) {
	  return toString.call(val) === '[object Function]';
	}
	
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */
	function isStream(val) {
	  return isObject(val) && isFunction(val.pipe);
	}
	
	/**
	 * Determine if a value is a URLSearchParams object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	 */
	function isURLSearchParams(val) {
	  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
	}
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.replace(/^\s*/, '').replace(/\s*$/, '');
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  navigator.product -> 'ReactNative'
	 */
	function isStandardBrowserEnv() {
	  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
	    return false;
	  }
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object') {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }
	
	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (typeof result[key] === 'object' && typeof val === 'object') {
	      result[key] = merge(result[key], val);
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	/**
	 * Extends object a by mutably adding to it the properties of object b.
	 *
	 * @param {Object} a The object to be extended
	 * @param {Object} b The object to copy properties from
	 * @param {Object} thisArg The object to bind function to
	 * @return {Object} The resulting value of object a
	 */
	function extend(a, b, thisArg) {
	  forEach(b, function assignValue(val, key) {
	    if (thisArg && typeof val === 'function') {
	      a[key] = bind(val, thisArg);
	    } else {
	      a[key] = val;
	    }
	  });
	  return a;
	}
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isBuffer: isBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isFunction: isFunction,
	  isStream: isStream,
	  isURLSearchParams: isURLSearchParams,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  extend: extend,
	  trim: trim
	};
	
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var instance = null;
	
	var Constants = exports.Constants = function Constants() {
	    _classCallCheck(this, Constants);
	
	    if (!instance) {
	        instance = this;
	    }
	};
	
	Constants._LOGGER_VAR_WINDOW = "NuxibaLogger";
	Constants._LOGGER_CONFIGURATION_FILE_LOCALE = './logger.json';
	Constants._LOGGER_CONFIGURATION_FILE_REMOTE = 'logger.json';
	Constants._LOGGER_CONFIGURATION_FILE_ENCODE = 'utf8';
	Constants._LOGGER_CONFIGURATION_ASSIGNED = window[Constants._LOGGER_VAR_WINDOW] ? true : false;
	Constants._LOG_LEVELS = {
	    "TRACE": { logLevel: 0 },
	    "DEBUG": { logLevel: 1 },
	    "INFO": { logLevel: 2 },
	    "WARN": { logLevel: 3 },
	    "ERROR": { logLevel: 4 }
	};
	Constants._Log_CONSOLE = {
	    "TRACE": console.log,
	    "DEBUG": console.log,
	    "INFO": console.info,
	    "WARN": console.warn,
	    "ERROR": console.error
	};
	Constants._CONFIGURATIONS = {
	    "_ENABLE_DEFAULT": true,
	    "_ENABLE_AJAX": false,
	    "_USE_WINDOW_ORIGIN": true,
	    "_SERVER": "http://127.0.0.1",
	    "_DOMAIN": "/LoggerWS/api/Logger",
	    "_SEVERITY": "INFO",
	    "_SEVERITY_CONSOLE": "INFO",
	    "_NUMBER_ATTEMP_POST": 10,
	    "_FILTER_USER_POST": [],
	    "_FILTER_APP_POST": []
	};
	Constants._REST = {
	    _POST_METHOD: "POST",
	    _MODE: "cors",
	    _CONTENT_TYPE: "content-type",
	    _APPLICATION_JSON: "application/json"
	};
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(process) {
	
	var utils = __webpack_require__(0);
	var normalizeHeaderName = __webpack_require__(18);
	
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	function setContentTypeIfUnset(headers, value) {
	  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
	    headers['Content-Type'] = value;
	  }
	}
	
	function getDefaultAdapter() {
	  var adapter;
	  if (typeof XMLHttpRequest !== 'undefined') {
	    // For browsers use XHR adapter
	    adapter = __webpack_require__(6);
	  } else if (typeof process !== 'undefined') {
	    // For node use HTTP adapter
	    adapter = __webpack_require__(6);
	  }
	  return adapter;
	}
	
	var defaults = {
	  adapter: getDefaultAdapter(),
	
	  transformRequest: [function transformRequest(data, headers) {
	    normalizeHeaderName(headers, 'Content-Type');
	    if (utils.isFormData(data) ||
	      utils.isArrayBuffer(data) ||
	      utils.isBuffer(data) ||
	      utils.isStream(data) ||
	      utils.isFile(data) ||
	      utils.isBlob(data)
	    ) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isURLSearchParams(data)) {
	      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	      return data.toString();
	    }
	    if (utils.isObject(data)) {
	      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
	      return JSON.stringify(data);
	    }
	    return data;
	  }],
	
	  transformResponse: [function transformResponse(data) {
	    /*eslint no-param-reassign:0*/
	    if (typeof data === 'string') {
	      try {
	        data = JSON.parse(data);
	      } catch (e) { /* Ignore */ }
	    }
	    return data;
	  }],
	
	  /**
	   * A timeout in milliseconds to abort a request. If set to 0 (default) a
	   * timeout is not created.
	   */
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	
	  maxContentLength: -1,
	
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  }
	};
	
	defaults.headers = {
	  common: {
	    'Accept': 'application/json, text/plain, */*'
	  }
	};
	
	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  defaults.headers[method] = {};
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
	});
	
	module.exports = defaults;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17)))
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.LoggerInstance = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _LoggerDispatcher = __webpack_require__(12);
	
	var _Constants = __webpack_require__(1);
	
	var _LoggerLocal = __webpack_require__(11);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var usertype = 'AGENT';
	var userId = '';
	var application = '';
	
	var LoggerInstance = function () {
		function LoggerInstance() {
			_classCallCheck(this, LoggerInstance);
		}
	
		_createClass(LoggerInstance, null, [{
			key: 'setUsertype',
			value: function setUsertype(value) {
				usertype = value;
			}
		}, {
			key: 'setUserId',
			value: function setUserId(value) {
				userId = value;
			}
		}, {
			key: 'getUserId',
			value: function getUserId() {
				return userId;
			}
		}, {
			key: 'setApplication',
			value: function setApplication(value) {
				application = value;
			}
		}, {
			key: 'setLocalLogger',
			value: function setLocalLogger(value) {
				_LoggerLocal.LoggerLocal.setEnabled(value);
			}
		}, {
			key: 'setLocalStorageTime',
			value: function setLocalStorageTime(minutes) {
				_LoggerLocal.LoggerLocal.setStorageTimeMin(minutes);
			}
		}, {
			key: 'getApplication',
			value: function getApplication() {
				return application;
			}
		}, {
			key: 'SetUseServerWithLocation',
			value: function SetUseServerWithLocation(useWindowLocation) {
				window[_Constants.Constants._LOGGER_VAR_WINDOW]._USE_WINDOW_LOCATION = useWindowLocation;
			}
		}, {
			key: 'addUserId',
			value: function addUserId(msg) {
				if (userId) {
					var userIdPrint = '[UserId:' + userId + ']';
					msg.unshift(userIdPrint);
				}
			}
		}, {
			key: 'Group',
			value: function Group(label) {
				console.group(label);
			}
		}, {
			key: 'GroupEnd',
			value: function GroupEnd() {
				console.groupEnd();
			}
		}, {
			key: 'CleanLocalLog',
			value: function CleanLocalLog() {
				_LoggerLocal.LoggerLocal.Clean();
			}
		}, {
			key: 'Trace',
			value: function Trace() {
				for (var _len = arguments.length, msg = Array(_len), _key = 0; _key < _len; _key++) {
					msg[_key] = arguments[_key];
				}
	
				_LoggerDispatcher.LoggerDispatcher.Dispatch(usertype, 'Trace', ['[UserId:' + userId + ']'].concat(msg));
			}
		}, {
			key: 'Debug',
			value: function Debug() {
				for (var _len2 = arguments.length, msg = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
					msg[_key2] = arguments[_key2];
				}
	
				LoggerInstance.addUserId(msg);
				_LoggerDispatcher.LoggerDispatcher.Dispatch(usertype, 'Debug', ['[UserId:' + userId + ']'].concat(msg));
			}
		}, {
			key: 'Warning',
			value: function Warning() {
				for (var _len3 = arguments.length, msg = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
					msg[_key3] = arguments[_key3];
				}
	
				LoggerInstance.addUserId(msg);
				_LoggerDispatcher.LoggerDispatcher.Dispatch(usertype, 'Warn', ['[UserId:' + userId + ']'].concat(msg));
			}
		}, {
			key: 'Warn',
			value: function Warn() {
				for (var _len4 = arguments.length, msg = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
					msg[_key4] = arguments[_key4];
				}
	
				LoggerInstance.Warning(msg);
			}
		}, {
			key: 'Info',
			value: function Info() {
				for (var _len5 = arguments.length, msg = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
					msg[_key5] = arguments[_key5];
				}
	
				LoggerInstance.addUserId(msg);
				_LoggerDispatcher.LoggerDispatcher.Dispatch(usertype, 'Info', ['[UserId:' + userId + ']'].concat(msg));
			}
		}, {
			key: 'Error',
			value: function Error() {
				for (var _len6 = arguments.length, msg = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
					msg[_key6] = arguments[_key6];
				}
	
				LoggerInstance.addUserId(msg);
				_LoggerDispatcher.LoggerDispatcher.Dispatch(usertype, 'Error', ['[UserId:' + userId + ']'].concat(msg));
			}
		}, {
			key: 'JsWarning',
			value: function JsWarning() {
				for (var _len7 = arguments.length, msg = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
					msg[_key7] = arguments[_key7];
				}
	
				LoggerInstance.addUserId(msg);
				_LoggerDispatcher.LoggerDispatcher.Dispatch(usertype, 'Warn', ['[UserId:' + userId + ']'].concat(msg), true);
			}
		}, {
			key: 'JsError',
			value: function JsError() {
				for (var _len8 = arguments.length, msg = Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
					msg[_key8] = arguments[_key8];
				}
	
				LoggerInstance.addUserId(msg);
				_LoggerDispatcher.LoggerDispatcher.Dispatch(usertype, 'Error', ['[UserId:' + userId + ']'].concat(msg), true);
			}
		}, {
			key: 'LevelConsole',
			get: function get() {
				return window[_Constants.Constants._LOGGER_VAR_WINDOW]._SEVERITY_CONSOLE;
			}
		}]);
	
		return LoggerInstance;
	}();
	
	exports.LoggerInstance = LoggerInstance;
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __webpack_require__) {
	
	module.exports = __webpack_require__(14);
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	module.exports = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	    return fn.apply(thisArg, args);
	  };
	};
	
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var utils = __webpack_require__(0);
	var settle = __webpack_require__(19);
	var buildURL = __webpack_require__(21);
	var parseHeaders = __webpack_require__(22);
	var isURLSameOrigin = __webpack_require__(23);
	var createError = __webpack_require__(7);
	
	module.exports = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	
	    if (utils.isFormData(requestData)) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }
	
	    var request = new XMLHttpRequest();
	
	    // HTTP basic authentication
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password || '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }
	
	    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);
	
	    // Set the request timeout in MS
	    request.timeout = config.timeout;
	
	    // Listen for ready state
	    request.onreadystatechange = function handleLoad() {
	      if (!request || request.readyState !== 4) {
	        return;
	      }
	
	      // The request errored out and we didn't get a response, this will be
	      // handled by onerror instead
	      // With one exception: request that using file: protocol, most browsers
	      // will return status as 0 even though it's a successful request
	      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	        return;
	      }
	
	      // Prepare the response
	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
	      var response = {
	        data: responseData,
	        status: request.status,
	        statusText: request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };
	
	      settle(resolve, reject, response);
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle low level network errors
	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(createError('Network Error', config, null, request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle timeout
	    request.ontimeout = function handleTimeout() {
	      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
	        request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.
	    if (utils.isStandardBrowserEnv()) {
	      var cookies = __webpack_require__(24);
	
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
	          cookies.read(config.xsrfCookieName) :
	          undefined;
	
	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    }
	
	    // Add headers to the request
	    if ('setRequestHeader' in request) {
	      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    }
	
	    // Add withCredentials to request if needed
	    if (config.withCredentials) {
	      request.withCredentials = true;
	    }
	
	    // Add responseType to request if needed
	    if (config.responseType) {
	      try {
	        request.responseType = config.responseType;
	      } catch (e) {
	        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
	        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
	        if (config.responseType !== 'json') {
	          throw e;
	        }
	      }
	    }
	
	    // Handle progress if needed
	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    }
	
	    // Not all browsers support upload events
	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }
	
	    if (config.cancelToken) {
	      // Handle cancellation
	      config.cancelToken.promise.then(function onCanceled(cancel) {
	        if (!request) {
	          return;
	        }
	
	        request.abort();
	        reject(cancel);
	        // Clean up request
	        request = null;
	      });
	    }
	
	    if (requestData === undefined) {
	      requestData = null;
	    }
	
	    // Send the request
	    request.send(requestData);
	  });
	};
	
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var enhanceError = __webpack_require__(20);
	
	/**
	 * Create an Error with the specified message, config, error code, request and response.
	 *
	 * @param {string} message The error message.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */
	module.exports = function createError(message, config, code, request, response) {
	  var error = new Error(message);
	  return enhanceError(error, config, code, request, response);
	};
	
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	module.exports = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};
	
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	/**
	 * A `Cancel` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */
	function Cancel(message) {
	  this.message = message;
	}
	
	Cancel.prototype.toString = function toString() {
	  return 'Cancel' + (this.message ? ': ' + this.message : '');
	};
	
	Cancel.prototype.__CANCEL__ = true;
	
	module.exports = Cancel;
	
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.LoggerUtils = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Constants = __webpack_require__(1);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LoggerUtils = function () {
		function LoggerUtils() {
			_classCallCheck(this, LoggerUtils);
		}
	
		_createClass(LoggerUtils, null, [{
			key: 'GetLogLevelBySeverity',
			value: function GetLogLevelBySeverity(severity) {
				var logLevel = 1;
				severity = severity.toUpperCase();
				if (_Constants.Constants._LOG_LEVELS[severity]) {
					logLevel = _Constants.Constants._LOG_LEVELS[severity].logLevel;
				}
				return logLevel;
			}
		}, {
			key: 'IsAllowedRemoteToLogBySeverity',
			value: function IsAllowedRemoteToLogBySeverity(severity) {
				return LoggerUtils.GetLogLevelBySeverity(severity) >= LoggerUtils.GetCurrentRemoteSeverityLevelConfigured();
			}
		}, {
			key: 'GetCurrentRemoteSeverityLevelConfigured',
			value: function GetCurrentRemoteSeverityLevelConfigured() {
				return LoggerUtils.GetLogLevelBySeverity(window[_Constants.Constants._LOGGER_VAR_WINDOW]['_SEVERITY']);
			}
		}, {
			key: 'IsAllowedConsoleToLogBySeverity',
			value: function IsAllowedConsoleToLogBySeverity(severity) {
				return LoggerUtils.GetLogLevelBySeverity(severity) >= LoggerUtils.GetCurrentConsoleSeverityLevelConfigured();
			}
		}, {
			key: 'GetCurrentConsoleSeverityLevelConfigured',
			value: function GetCurrentConsoleSeverityLevelConfigured() {
				return LoggerUtils.GetLogLevelBySeverity(window[_Constants.Constants._LOGGER_VAR_WINDOW]['_SEVERITY_CONSOLE']);
			}
		}, {
			key: 'ToStringMessage',
			value: function ToStringMessage() {
				var messageString = '';
	
				for (var _len = arguments.length, message = Array(_len), _key = 0; _key < _len; _key++) {
					message[_key] = arguments[_key];
				}
	
				message.forEach(function (entry) {
					messageString += LoggerUtils.ToStringObject(entry);
				});
				return messageString;
			}
		}, {
			key: 'ToStringObject',
			value: function ToStringObject(entry) {
				return LoggerUtils.IsObject(entry) ? '\n' + LoggerUtils.JsonToString(entry) : entry;
			}
		}, {
			key: 'IsObject',
			value: function IsObject(value) {
				return value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value.constructor === Object;
			}
		}, {
			key: 'JsonToString',
			value: function JsonToString(entry) {
				var seen = [];
				var jsonReplacerConst = 2;
				return JSON.stringify(entry, function (key, val) {
					if (val && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) == 'object') {
						seen.push(val);
					}
					return val;
				}, jsonReplacerConst);
			}
		}]);
	
		return LoggerUtils;
	}();
	
	exports.LoggerUtils = LoggerUtils;
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ls = window.localStorage;
	var logKey = 'LOG-' + new Date().getDate() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getFullYear();
	var logDateKey = 'GalateaLoggerDate';
	var enabled = false;
	var storageTimeMin = 0;
	var firstLogTs = null;
	var storageTimeFactor = 60000;
	
	var LoggerLocal = function () {
		function LoggerLocal() {
			_classCallCheck(this, LoggerLocal);
		}
	
		_createClass(LoggerLocal, null, [{
			key: 'getKey',
			value: function getKey() {
				return logKey;
			}
		}, {
			key: 'setEnabled',
			value: function setEnabled(value) {
				enabled = value;
			}
		}, {
			key: 'setStorageTimeMin',
			value: function setStorageTimeMin(minutes) {
				storageTimeMin = minutes;
			}
		}, {
			key: 'Add',
			value: function Add(message, usertype, severity) {
				if (enabled) {
					var ts = new Date();
					var prevEntries = ls.getItem(logKey);
					var newEntry = usertype + '-' + severity + ' ' + ts.getDate() + '-' + (ts.getMonth() + 1) + '-' + ts.getFullYear() + '-' + ts.getDate() + ' ' + ts.toLocaleTimeString() + ' - MSG: ' + message;
					if (prevEntries) {
						if (!firstLogTs) {
							firstLogTs = new Date(JSON.parse(ls.getItem(logDateKey)));
						}
						if (storageTimeMin !== 0 && (ts - firstLogTs) / storageTimeFactor > storageTimeMin) {
							LoggerLocal.Clean();
							firstLogTs = ts;
							ls.setItem(logDateKey, JSON.stringify(ts));
						} else {
							newEntry = prevEntries + ';' + newEntry;
						}
						ls.setItem(logKey, '' + newEntry);
					} else {
						firstLogTs = ts;
						ls.setItem(logKey, newEntry);
						ls.setItem(logDateKey, JSON.stringify(ts));
					}
				}
			}
		}, {
			key: 'getRawLogs',
			value: function getRawLogs() {
				return ls.getItem(logKey);
			}
		}, {
			key: 'getLogs',
			value: function getLogs() {
				return ls.getItem(logKey).replaceAll(';', '\n');
			}
		}, {
			key: 'Clean',
			value: function Clean() {
				console.log('Cleaning local storage ', logKey);
				ls.removeItem(logKey);
			}
		}]);
	
		return LoggerLocal;
	}();
	
	exports.LoggerLocal = LoggerLocal;
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.LoggerDispatcher = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _LoggerRestClient = __webpack_require__(13);
	
	var _Constants = __webpack_require__(1);
	
	var _LoggerUtils = __webpack_require__(10);
	
	var _LoggerConfigurator = __webpack_require__(32);
	
	var _LoggerInstance = __webpack_require__(3);
	
	var _LoggerLocal = __webpack_require__(11);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ls = window.localStorage;
	
	var LoggerDispatcher = function () {
		function LoggerDispatcher() {
			_classCallCheck(this, LoggerDispatcher);
		}
	
		_createClass(LoggerDispatcher, null, [{
			key: 'Dispatch',
			value: function Dispatch(usertype, severity, message, hideInConsole) {
				_LoggerLocal.LoggerLocal.Add(message, usertype, severity);
				_LoggerConfigurator.LoggerConfigurator.Init(function () {
					!hideInConsole && LoggerDispatcher.DefaultOutput.apply(LoggerDispatcher, [usertype, severity].concat(_toConsumableArray(message)));
					LoggerDispatcher.RemoteOutput.apply(LoggerDispatcher, [usertype, severity].concat(_toConsumableArray(message)));
				});
			}
		}, {
			key: 'RemoteOutput',
			value: function RemoteOutput(usertype, severity) {
				if (window[_Constants.Constants._LOGGER_VAR_WINDOW] && window[_Constants.Constants._LOGGER_VAR_WINDOW]['_ENABLE_AJAX'] && _LoggerUtils.LoggerUtils.IsAllowedRemoteToLogBySeverity(severity)) {
					for (var _len = arguments.length, message = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
						message[_key - 2] = arguments[_key];
					}
	
					if (severity.toUpperCase() === 'WARN' || severity.toUpperCase() === 'ERROR') {
						_LoggerRestClient.LoggerRestClient.log(usertype, severity, '[' + usertype + '] ' + message);
					} else {
						var isEmptyFilterUser = window[_Constants.Constants._LOGGER_VAR_WINDOW]._FILTER_USER_POST.length === 0;
						var isEmptyFilterApp = window[_Constants.Constants._LOGGER_VAR_WINDOW]._FILTER_APP_POST.length === 0;
	
						if (isEmptyFilterUser && isEmptyFilterApp) {
							_LoggerRestClient.LoggerRestClient.log.apply(_LoggerRestClient.LoggerRestClient, [usertype, severity].concat(message));
						} else {
							var containtUserId = true;
							var containtApp = true;
	
							if (!isEmptyFilterUser) {
								containtUserId = window[_Constants.Constants._LOGGER_VAR_WINDOW]._FILTER_USER_POST.find(function (ele) {
									return ele === _LoggerInstance.LoggerInstance.getUserId();
								});
							}
							if (!isEmptyFilterApp) {
								containtApp = window[_Constants.Constants._LOGGER_VAR_WINDOW]._FILTER_APP_POST.find(function (ele) {
									return ele === _LoggerInstance.LoggerInstance.getApplication();
								});
							}
	
							if (containtUserId && containtApp) {
								_LoggerRestClient.LoggerRestClient.log(usertype, severity, '[' + usertype + '] ' + message);
							}
						}
					}
				}
			}
		}, {
			key: 'DefaultOutput',
			value: function DefaultOutput(usertype, severity) {
				severity = severity.toUpperCase();
				if (window[_Constants.Constants._LOGGER_VAR_WINDOW] && window[_Constants.Constants._LOGGER_VAR_WINDOW]._ENABLE_DEFAULT && _LoggerUtils.LoggerUtils.IsAllowedConsoleToLogBySeverity(severity)) {
					var _consoleLogLevel;
	
					var consoleLogLevel = console.log;
					if (_Constants.Constants._Log_CONSOLE[severity]) {
						consoleLogLevel = _Constants.Constants._Log_CONSOLE[severity];
					}
					var time = new Date().toLocaleTimeString();
	
					for (var _len2 = arguments.length, message = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
						message[_key2 - 2] = arguments[_key2];
					}
	
					(_consoleLogLevel = consoleLogLevel).call.apply(_consoleLogLevel, [null, '[' + time + '][' + severity + '][' + usertype + ']'].concat(message));
				}
			}
		}]);
	
		return LoggerDispatcher;
	}();
	
	exports.LoggerDispatcher = LoggerDispatcher;
	
	/***/ }),
	/* 13 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.LoggerRestClient = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _axios = __webpack_require__(4);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _Constants = __webpack_require__(1);
	
	var _LoggerUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var numberAttemp = 0;
	var numMessageWarn = true;
	
	var LoggerRestClient = function () {
		function LoggerRestClient() {
			_classCallCheck(this, LoggerRestClient);
		}
	
		_createClass(LoggerRestClient, null, [{
			key: 'log',
			value: function log(usertype, severity) {
				if (window[_Constants.Constants._LOGGER_VAR_WINDOW]._ENABLE_AJAX) {
					if (window[_Constants.Constants._LOGGER_VAR_WINDOW]._NUMBER_ATTEMP_POST === 0 || numberAttemp < window[_Constants.Constants._LOGGER_VAR_WINDOW]._NUMBER_ATTEMP_POST) {
						try {
							var serverUrl = new URL(window[_Constants.Constants._LOGGER_VAR_WINDOW]['_SERVER']);
							var server = new URL(window[_Constants.Constants._LOGGER_VAR_WINDOW]['_DOMAIN'], serverUrl);
	
							for (var _len = arguments.length, message = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
								message[_key - 2] = arguments[_key];
							}
	
							var msg = _LoggerUtils.LoggerUtils.ToStringMessage(message);
							_axios2.default.post(server, { UserType: usertype, Message: msg, Severity: severity }).then(function () {
								numberAttemp = 0;
							}).catch(function (error) {
								numberAttemp++;
								console.warn('It was not possible to send the message server:', server, error);
							});
						} catch (e) {
							numberAttemp++;
							console.error('it was not possible to send the log message because an error ocurred servidor:' + window[_Constants.Constants._LOGGER_VAR_WINDOW]['_SERVER'] + ' error:' + e + ' recommendation: you could check the logger configuration');
						}
					} else {
						if (numMessageWarn) {
							numMessageWarn = false;
							console.warn('number of attempts to overcome Api web is necessary to check the configuration file for logger.json');
						}
					}
				}
			}
		}]);
	
		return LoggerRestClient;
	}();
	
	exports.LoggerRestClient = LoggerRestClient;
	
	/***/ }),
	/* 14 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var utils = __webpack_require__(0);
	var bind = __webpack_require__(5);
	var Axios = __webpack_require__(16);
	var defaults = __webpack_require__(2);
	
	/**
	 * Create an instance of Axios
	 *
	 * @param {Object} defaultConfig The default config for the instance
	 * @return {Axios} A new instance of Axios
	 */
	function createInstance(defaultConfig) {
	  var context = new Axios(defaultConfig);
	  var instance = bind(Axios.prototype.request, context);
	
	  // Copy axios.prototype to instance
	  utils.extend(instance, Axios.prototype, context);
	
	  // Copy context to instance
	  utils.extend(instance, context);
	
	  return instance;
	}
	
	// Create the default instance to be exported
	var axios = createInstance(defaults);
	
	// Expose Axios class to allow class inheritance
	axios.Axios = Axios;
	
	// Factory for creating new instances
	axios.create = function create(instanceConfig) {
	  return createInstance(utils.merge(defaults, instanceConfig));
	};
	
	// Expose Cancel & CancelToken
	axios.Cancel = __webpack_require__(9);
	axios.CancelToken = __webpack_require__(30);
	axios.isCancel = __webpack_require__(8);
	
	// Expose all/spread
	axios.all = function all(promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__(31);
	
	module.exports = axios;
	
	// Allow use of default import syntax in TypeScript
	module.exports.default = axios;
	
	
	/***/ }),
	/* 15 */
	/***/ (function(module, exports) {
	
	/*!
	 * Determine if an object is a Buffer
	 *
	 * @author   Feross Aboukhadijeh <https://feross.org>
	 * @license  MIT
	 */
	
	module.exports = function isBuffer (obj) {
	  return obj != null && obj.constructor != null &&
	    typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
	}
	
	
	/***/ }),
	/* 16 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var defaults = __webpack_require__(2);
	var utils = __webpack_require__(0);
	var InterceptorManager = __webpack_require__(25);
	var dispatchRequest = __webpack_require__(26);
	
	/**
	 * Create a new instance of Axios
	 *
	 * @param {Object} instanceConfig The default config for the instance
	 */
	function Axios(instanceConfig) {
	  this.defaults = instanceConfig;
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	
	/**
	 * Dispatch a request
	 *
	 * @param {Object} config The config specific for this request (merged with this.defaults)
	 */
	Axios.prototype.request = function request(config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof config === 'string') {
	    config = utils.merge({
	      url: arguments[0]
	    }, arguments[1]);
	  }
	
	  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
	  config.method = config.method.toLowerCase();
	
	  // Hook up interceptors middleware
	  var chain = [dispatchRequest, undefined];
	  var promise = Promise.resolve(config);
	
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    chain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    chain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  while (chain.length) {
	    promise = promise.then(chain.shift(), chain.shift());
	  }
	
	  return promise;
	};
	
	// Provide aliases for supported request methods
	utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url
	    }));
	  };
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, data, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	});
	
	module.exports = Axios;
	
	
	/***/ }),
	/* 17 */
	/***/ (function(module, exports) {
	
	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };
	
	
	/***/ }),
	/* 18 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var utils = __webpack_require__(0);
	
	module.exports = function normalizeHeaderName(headers, normalizedName) {
	  utils.forEach(headers, function processHeader(value, name) {
	    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	      headers[normalizedName] = value;
	      delete headers[name];
	    }
	  });
	};
	
	
	/***/ }),
	/* 19 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var createError = __webpack_require__(7);
	
	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	module.exports = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  // Note: status is not exposed by XDomainRequest
	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(createError(
	      'Request failed with status code ' + response.status,
	      response.config,
	      null,
	      response.request,
	      response
	    ));
	  }
	};
	
	
	/***/ }),
	/* 20 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	/**
	 * Update an Error with the specified config, error code, and response.
	 *
	 * @param {Error} error The error to update.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The error.
	 */
	module.exports = function enhanceError(error, config, code, request, response) {
	  error.config = config;
	  if (code) {
	    error.code = code;
	  }
	  error.request = request;
	  error.response = response;
	  return error;
	};
	
	
	/***/ }),
	/* 21 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var utils = __webpack_require__(0);
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%40/gi, '@').
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }
	
	  var serializedParams;
	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else if (utils.isURLSearchParams(params)) {
	    serializedParams = params.toString();
	  } else {
	    var parts = [];
	
	    utils.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }
	
	      if (utils.isArray(val)) {
	        key = key + '[]';
	      } else {
	        val = [val];
	      }
	
	      utils.forEach(val, function parseValue(v) {
	        if (utils.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils.isObject(v)) {
	          v = JSON.stringify(v);
	        }
	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	
	    serializedParams = parts.join('&');
	  }
	
	  if (serializedParams) {
	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }
	
	  return url;
	};
	
	
	/***/ }),
	/* 22 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var utils = __webpack_require__(0);
	
	// Headers whose duplicates are ignored by node
	// c.f. https://nodejs.org/api/http.html#http_message_headers
	var ignoreDuplicateOf = [
	  'age', 'authorization', 'content-length', 'content-type', 'etag',
	  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
	  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
	  'referer', 'retry-after', 'user-agent'
	];
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
	        return;
	      }
	      if (key === 'set-cookie') {
	        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
	      } else {
	        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	      }
	    }
	  });
	
	  return parsed;
	};
	
	
	/***/ }),
	/* 23 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var utils = __webpack_require__(0);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	  (function standardBrowserEnv() {
	    var msie = /(msie|trident)/i.test(navigator.userAgent);
	    var urlParsingNode = document.createElement('a');
	    var originURL;
	
	    /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	    function resolveURL(url) {
	      var href = url;
	
	      if (msie) {
	        // IE needs attribute set twice to normalize properties
	        urlParsingNode.setAttribute('href', href);
	        href = urlParsingNode.href;
	      }
	
	      urlParsingNode.setAttribute('href', href);
	
	      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	      return {
	        href: urlParsingNode.href,
	        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	        host: urlParsingNode.host,
	        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	        hostname: urlParsingNode.hostname,
	        port: urlParsingNode.port,
	        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	                  urlParsingNode.pathname :
	                  '/' + urlParsingNode.pathname
	      };
	    }
	
	    originURL = resolveURL(window.location.href);
	
	    /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	    return function isURLSameOrigin(requestURL) {
	      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	      return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	    };
	  })() :
	
	  // Non standard browser envs (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return function isURLSameOrigin() {
	      return true;
	    };
	  })()
	);
	
	
	/***/ }),
	/* 24 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var utils = __webpack_require__(0);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs support document.cookie
	  (function standardBrowserEnv() {
	    return {
	      write: function write(name, value, expires, path, domain, secure) {
	        var cookie = [];
	        cookie.push(name + '=' + encodeURIComponent(value));
	
	        if (utils.isNumber(expires)) {
	          cookie.push('expires=' + new Date(expires).toGMTString());
	        }
	
	        if (utils.isString(path)) {
	          cookie.push('path=' + path);
	        }
	
	        if (utils.isString(domain)) {
	          cookie.push('domain=' + domain);
	        }
	
	        if (secure === true) {
	          cookie.push('secure');
	        }
	
	        document.cookie = cookie.join('; ');
	      },
	
	      read: function read(name) {
	        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	        return (match ? decodeURIComponent(match[3]) : null);
	      },
	
	      remove: function remove(name) {
	        this.write(name, '', Date.now() - 86400000);
	      }
	    };
	  })() :
	
	  // Non standard browser env (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return {
	      write: function write() {},
	      read: function read() { return null; },
	      remove: function remove() {}
	    };
	  })()
	);
	
	
	/***/ }),
	/* 25 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var utils = __webpack_require__(0);
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function use(fulfilled, rejected) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;
	
	
	/***/ }),
	/* 26 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var utils = __webpack_require__(0);
	var transformData = __webpack_require__(27);
	var isCancel = __webpack_require__(8);
	var defaults = __webpack_require__(2);
	var isAbsoluteURL = __webpack_require__(28);
	var combineURLs = __webpack_require__(29);
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	function throwIfCancellationRequested(config) {
	  if (config.cancelToken) {
	    config.cancelToken.throwIfRequested();
	  }
	}
	
	/**
	 * Dispatch a request to the server using the configured adapter.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  throwIfCancellationRequested(config);
	
	  // Support baseURL config
	  if (config.baseURL && !isAbsoluteURL(config.url)) {
	    config.url = combineURLs(config.baseURL, config.url);
	  }
	
	  // Ensure headers exist
	  config.headers = config.headers || {};
	
	  // Transform request data
	  config.data = transformData(
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Flatten headers
	  config.headers = utils.merge(
	    config.headers.common || {},
	    config.headers[config.method] || {},
	    config.headers || {}
	  );
	
	  utils.forEach(
	    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
	    function cleanHeaderConfig(method) {
	      delete config.headers[method];
	    }
	  );
	
	  var adapter = config.adapter || defaults.adapter;
	
	  return adapter(config).then(function onAdapterResolution(response) {
	    throwIfCancellationRequested(config);
	
	    // Transform response data
	    response.data = transformData(
	      response.data,
	      response.headers,
	      config.transformResponse
	    );
	
	    return response;
	  }, function onAdapterRejection(reason) {
	    if (!isCancel(reason)) {
	      throwIfCancellationRequested(config);
	
	      // Transform response data
	      if (reason && reason.response) {
	        reason.response.data = transformData(
	          reason.response.data,
	          reason.response.headers,
	          config.transformResponse
	        );
	      }
	    }
	
	    return Promise.reject(reason);
	  });
	};
	
	
	/***/ }),
	/* 27 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var utils = __webpack_require__(0);
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  /*eslint no-param-reassign:0*/
	  utils.forEach(fns, function transform(fn) {
	    data = fn(data, headers);
	  });
	
	  return data;
	};
	
	
	/***/ }),
	/* 28 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	module.exports = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};
	
	
	/***/ }),
	/* 29 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	module.exports = function combineURLs(baseURL, relativeURL) {
	  return relativeURL
	    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
	    : baseURL;
	};
	
	
	/***/ }),
	/* 30 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var Cancel = __webpack_require__(9);
	
	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */
	function CancelToken(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }
	
	  var resolvePromise;
	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });
	
	  var token = this;
	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }
	
	    token.reason = new Cancel(message);
	    resolvePromise(token.reason);
	  });
	}
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};
	
	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */
	CancelToken.source = function source() {
	  var cancel;
	  var token = new CancelToken(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};
	
	module.exports = CancelToken;
	
	
	/***/ }),
	/* 31 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};
	
	
	/***/ }),
	/* 32 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.LoggerConfigurator = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Constants = __webpack_require__(1);
	
	var _axios = __webpack_require__(4);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _loadFirst = true;
	
	var LoggerConfigurator = function () {
		function LoggerConfigurator() {
			_classCallCheck(this, LoggerConfigurator);
		}
	
		_createClass(LoggerConfigurator, null, [{
			key: 'Init',
			value: function Init(callback) {
				if (_loadFirst && LoggerConfigurator.IsConfigurationNotAssigned()) {
					_loadFirst = false;
					LoggerConfigurator.GetByExecutionEnvironment(callback);
				} else {
					callback();
				}
			}
		}, {
			key: 'Setup',
			value: function Setup(configuration, callback) {
				console.info('Setup ', configuration);
				if (configuration) {
					window[_Constants.Constants._LOGGER_VAR_WINDOW] = {};
	
					var _iteratorNormalCompletion = true;
					var _didIteratorError = false;
					var _iteratorError = undefined;
	
					try {
						for (var _iterator = Object.entries(_Constants.Constants._CONFIGURATIONS)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
							var _step$value = _slicedToArray(_step.value, 2),
							    key = _step$value[0],
							    value = _step$value[1];
	
							setValueDefatult(configuration, key, value);
						}
					} catch (err) {
						_didIteratorError = true;
						_iteratorError = err;
					} finally {
						try {
							if (!_iteratorNormalCompletion && _iterator.return) {
								_iterator.return();
							}
						} finally {
							if (_didIteratorError) {
								throw _iteratorError;
							}
						}
					}
	
					Object.keys(configuration).forEach(function (key) {
						return window[_Constants.Constants._LOGGER_VAR_WINDOW][key] = configuration[key];
					});
	
					if (window[_Constants.Constants._LOGGER_VAR_WINDOW]._USE_WINDOW_ORIGIN) {
						LoggerConfigurator.SetConfigurationServer();
					}
				} else {
					window[_Constants.Constants._LOGGER_VAR_WINDOW] = _Constants.Constants._CONFIGURATIONS;
					console.info('Logger will use default configuration ... ', _Constants.Constants._CONFIGURATIONS);
				}
				callback();
			}
		}, {
			key: 'GetByExecutionEnvironment',
			value: function GetByExecutionEnvironment(callback) {
				if (LoggerConfigurator.IsBrowser()) {
					LoggerConfigurator.GetRemote(callback);
				} else {
					LoggerConfigurator.GetLocal(callback);
				}
			}
		}, {
			key: 'IsBrowser',
			value: function IsBrowser() {
				return window ? true : false;
			}
		}, {
			key: 'GetLocal',
			value: function GetLocal(callback) {
				LoggerConfigurator.Setup(null, callback);
			}
		}, {
			key: 'GetRemote',
			value: function GetRemote(callback) {
	
				var remoteLocation = '' + window.location.origin + window.location.pathname;
				var arrayPathname = remoteLocation.split('/');
				console.log("Remove Last element ", arrayPathname.pop());
				remoteLocation = arrayPathname.join('/') + '/';
	
				remoteLocation = remoteLocation + _Constants.Constants._LOGGER_CONFIGURATION_FILE_REMOTE;
	
				_axios2.default.get(remoteLocation, { responseType: 'json' }).then(function (response) {
					LoggerConfigurator.Setup(response.data, callback);
				}).catch(function (error) {
					console.error('It was not possible to get remote file configuration', error);
					LoggerConfigurator.Setup(null, callback);
				});
			}
		}, {
			key: 'SetConfigurationServer',
			value: function SetConfigurationServer() {
				if (window[_Constants.Constants._LOGGER_VAR_WINDOW]._USE_WINDOW_ORIGIN) {
					var hostname = window.location.hostname;
					if (hostname !== '127.0.0.1' && hostname !== 'localhost') {
						var remoteLocation = window.location.origin;
						console.debug('SetConfigurationServer withLocation', remoteLocation);
						window[_Constants.Constants._LOGGER_VAR_WINDOW]['_SERVER'] = remoteLocation;
					}
				}
			}
		}, {
			key: 'ExistExternalConfiguration',
			value: function ExistExternalConfiguration(configuration) {
				return configuration ? true : false;
			}
		}, {
			key: 'IsConfigurationNotAssigned',
			value: function IsConfigurationNotAssigned() {
				return !_Constants.Constants._LOGGER_CONFIGURATION_ASSIGNED;
			}
		}]);
	
		return LoggerConfigurator;
	}();
	
	function setValueDefatult(configuration, property, valueDefault) {
		if (configuration[property] === undefined) {
			console.info('file logger.json does not contain field [%s] set value default [%s]', property, valueDefault);
			configuration[property] = valueDefault;
		}
	}
	
	exports.LoggerConfigurator = LoggerConfigurator;
	
	/***/ })
	/******/ ]);
	});
	//# sourceMappingURL=global-logger-services-js-bundle.js.map 
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.galateaAPIWrapper = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _galateaAPI = __webpack_require__(5);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var galateaAPIWrapper = exports.galateaAPIWrapper = function () {
		function galateaAPIWrapper() {
			_classCallCheck(this, galateaAPIWrapper);
		}
	
		_createClass(galateaAPIWrapper, [{
			key: 'getAPI',
			value: function getAPI() {
				return new _galateaAPI.GalateaAPI();
			}
		}]);
	
		return galateaAPIWrapper;
	}();
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GalateaAPI = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _isomorphicFetch = __webpack_require__(6);
	
	var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);
	
	var _constants = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var GalateaAPI = exports.GalateaAPI = function () {
	  function GalateaAPI() {
	    _classCallCheck(this, GalateaAPI);
	
	    this.PATH_WS = _constants.IP_WEB_API;
	  }
	
	  _createClass(GalateaAPI, [{
	    key: 'loginService',
	    value: function loginService(username, password, ipAddress, isRemote) {
	      return (0, _isomorphicFetch2.default)(this.PATH_WS + _constants.END_POINT_LOGIN, {
	        method: "POST",
	        body: JSON.stringify({
	          Username: username,
	          Password: password,
	          IPAddress: ipAddress,
	          IsRemote: isRemote
	        }),
	        headers: this.buildHeader(),
	        mode: 'cors'
	      });
	    }
	  }, {
	    key: 'languageService',
	    value: function languageService(language) {
	      if (language === '') {
	        return (0, _isomorphicFetch2.default)(this.PATH_WS + _constants.GET_LANGUAGE, {
	          method: "GET",
	          headers: this.buildHeader(),
	          mode: 'cors'
	        });
	      } else {
	        return (0, _isomorphicFetch2.default)(this.PATH_WS + _constants.GET_LANGUAGE, {
	          method: "POST",
	          body: JSON.stringify({
	            requiredLanguage: language
	          }),
	          headers: this.buildHeader(),
	          mode: 'cors'
	        });
	      }
	    }
	  }, {
	    key: 'attachmentsService',
	    value: function attachmentsService(body) {
	      return (0, _isomorphicFetch2.default)(this.PATH_WS + _constants.GET_ATTCHMENTS, {
	        method: "POST",
	        body: JSON.stringify({
	          ConversationId: body.ConversationId,
	          InboundId: body.InboundId,
	          MultimediaType: body.MultimediaType,
	          userId: body.UserId
	        }),
	        headers: this.buildHeader(),
	        mode: 'cors'
	      });
	    }
	  }, {
	    key: 'noAvailableService',
	    value: function noAvailableService(userId, controller) {
	      return (0, _isomorphicFetch2.default)(this.PATH_WS + _constants.GET_NO_AVAILABLE, {
	        method: "POST",
	        body: JSON.stringify({
	          UserId: userId
	        }),
	        headers: this.buildHeader(),
	        mode: 'cors',
	        signal: controller.signal
	      });
	    }
	  }, {
	    key: 'notReadyHistoryService',
	    value: function notReadyHistoryService(userId, controller) {
	      return (0, _isomorphicFetch2.default)(this.PATH_WS + _constants.GET_NOT_READY_HISTORY, {
	        method: "POST",
	        body: JSON.stringify({
	          UserId: userId
	        }),
	        headers: this.buildHeader(),
	        mode: 'cors',
	        signal: controller.signal
	      });
	    }
	  }, {
	    key: 'validateNotAvailablePasswords',
	    value: function validateNotAvailablePasswords(validationData) {
	      return (0, _isomorphicFetch2.default)(this.PATH_WS + _constants.VALIDATE_NOT_AVAILABLE_PASSWORD, {
	        method: "POST",
	        body: JSON.stringify({
	          EncryptedAgentUserName: validationData.nombre,
	          AgentPassword: validationData.password,
	          SupervisorPassword: validationData.supervisorPassword,
	          supervisorPasswordRequired: validationData.supervisorPasswordRequired,
	          IpAddress: validationData.ipAddress
	        }),
	        headers: this.buildHeader(),
	        mode: 'cors'
	      });
	    }
	  }, {
	    key: 'getSupervisorList',
	    value: function getSupervisorList(userId) {
	      return (0, _isomorphicFetch2.default)(this.PATH_WS + _constants.GET_SUPERVISOR_LIST, {
	        method: "POST",
	        body: JSON.stringify({
	          userid: userId
	        }),
	        headers: this.buildHeader(),
	        mode: 'cors'
	      });
	    }
	  }, {
	    key: 'changePassword',
	    value: function changePassword(userId, password, confirmPassword, newPassword) {
	      return (0, _isomorphicFetch2.default)(this.PATH_WS + _constants.CHANGE_PASSWORD, {
	        method: "POST",
	        body: JSON.stringify({
	          Userid: userId,
	          Password: password,
	          PasswordConfimation: confirmPassword,
	          NewPassword: newPassword
	        }),
	        headers: this.buildHeader(),
	        mode: 'cors'
	      });
	    }
	  }, {
	    key: 'dispositionList',
	    value: function dispositionList(id, type, callOutId, userId, camId, controller) {
	      return (0, _isomorphicFetch2.default)(this.PATH_WS + _constants.DISPOSITION_LIST, {
	        method: "POST",
	        body: JSON.stringify({
	          Id: id,
	          Type: type,
	          CallOutId: callOutId,
	          UserID: userId,
	          CamId: camId
	        }),
	        headers: this.buildHeader(),
	        mode: 'cors',
	        signal: controller.signal
	      });
	    }
	  }, {
	    key: 'saveDispositionListACD',
	    value: function saveDispositionListACD(data) {
	      return (0, _isomorphicFetch2.default)(this.PATH_WS + _constants.SAVE_DISPOSITION_LIST_ACD, {
	        method: "POST",
	        body: JSON.stringify({
	          CallId: data.CallId,
	          DispositionId: data.DispositionId,
	          Origin: data.Origin,
	          CallKey: data.CallKey,
	          CallOutId: data.CallOutId,
	          SubId: data.SubId
	        }),
	        headers: this.buildHeader(),
	        mode: 'cors'
	      });
	    }
	  }, {
	    key: 'callIcon',
	    value: function callIcon(data) {
	      return (0, _isomorphicFetch2.default)(this.PATH_WS + _constants.CALL_ICON, {
	        method: "POST",
	        body: JSON.stringify({
	          UserId: data.UserId,
	          Id: data.Id,
	          CallType: data.CallType,
	          CallOutId: data.CallOutId,
	          Phone: data.Phone
	        }),
	        headers: this.buildHeader(),
	        mode: 'cors'
	      });
	    }
	  }, {
	    key: 'GetRecordCallPermission',
	    value: function GetRecordCallPermission(data) {
	      return (0, _isomorphicFetch2.default)(this.PATH_WS + _constants.GET_RECORD_CALL_PERMISSION, {
	        method: "POST",
	        body: JSON.stringify({
	          campId: data.campId,
	          option: data.option
	        }),
	        headers: this.buildHeader(),
	        mode: 'cors'
	      });
	    }
	  }, {
	    key: 'transferCall',
	    value: function transferCall(userId, acdId, controller) {
	      return (0, _isomorphicFetch2.default)(this.PATH_WS + _constants.TRANSFER_CALL, {
	        method: "POST",
	        body: JSON.stringify({
	          userID: userId,
	          acdID: acdId
	        }),
	        headers: this.buildHeader(),
	        mode: 'cors',
	        signal: controller.signal
	      });
	    }
	  }, {
	    key: 'callHistory',
	    value: function callHistory(userId, controller) {
	      return (0, _isomorphicFetch2.default)(this.PATH_WS + _constants.CALL_HISTORY, {
	        method: "POST",
	        body: JSON.stringify({ userId: userId }),
	        headers: this.buildHeader(),
	        mode: 'cors',
	        signal: controller.signal
	      });
	    }
	  }, {
	    key: 'saveDataCallOut',
	    value: function saveDataCallOut(data) {
	      return (0, _isomorphicFetch2.default)(this.PATH_WS + _constants.SAVE_DATA_CALL_OUT, {
	        method: "POST",
	        body: JSON.stringify(data),
	        headers: this.buildHeader(),
	        mode: 'cors'
	      });
	    }
	  }, {
	    key: 'validatePhoneNumber',
	    value: function validatePhoneNumber(data) {
	      return (0, _isomorphicFetch2.default)(this.PATH_WS + _constants.VALIDATE_PHONE_NUMBER, {
	        method: "POST",
	        body: JSON.stringify({
	          UserID: data.UserID,
	          CampID: data.CampID,
	          Ext: data.Ext,
	          PhoneNumber: data.PhoneNumber,
	          Name: data.Name,
	          CallOutChange: data.CallOutChange,
	          Status: data.Status,
	          CallKey: data.CallKey,
	          CallMode: data.CallKey
	        }),
	        headers: this.buildHeader(),
	        mode: 'cors'
	      });
	    }
	  }, {
	    key: 'callAudio',
	    value: function callAudio(data) {
	      return (0, _isomorphicFetch2.default)(this.PATH_WS + _constants.CALL_AUDIO, {
	        method: "POST",
	        body: JSON.stringify({ userId: data.userId, calId: data.calId, type: data.type }),
	        headers: this.buildHeader(),
	        mode: 'cors'
	      });
	    }
	  }, {
	    key: 'markCall',
	    value: function markCall(data) {
	      return (0, _isomorphicFetch2.default)(this.PATH_WS + _constants.MARK_CALL, {
	        method: "POST",
	        body: JSON.stringify({ times: data.times, callId: data.calId, callType: data.type, userId: data.userId }),
	        headers: this.buildHeader(),
	        mode: 'cors'
	      });
	    }
	  }, {
	    key: 'externalContacts',
	    value: function externalContacts() {
	      return (0, _isomorphicFetch2.default)(this.PATH_WS + _constants.EXTERNAL_CONTACTS, {
	        method: "POST",
	        body: JSON.stringify({}),
	        headers: this.buildHeader(),
	        mode: 'cors'
	      });
	    }
	  }, {
	    key: 'externalOdbcCampaign',
	    value: function externalOdbcCampaign(campID, controller) {
	      return (0, _isomorphicFetch2.default)(this.PATH_WS + _constants.EXTERNAL_ODBC_CAMPAIGN, {
	        method: "POST",
	        body: JSON.stringify({ CampID: campID }),
	        headers: this.buildHeader(),
	        mode: 'cors',
	        signal: controller.signal
	      });
	    }
	  }, {
	    key: 'buildHeader',
	    value: function buildHeader() {
	      var header = new Headers();
	      header.append('content-type', 'application/json');
	      return header;
	    }
	  }, {
	    key: 'getDayCallBack',
	    value: function getDayCallBack(userId, date) {
	      return (0, _isomorphicFetch2.default)(this.PATH_WS + _constants.CALLBACK_DAY, {
	        method: "POST",
	        body: JSON.stringify({ UserId: userId, DateCallBacks: date }),
	        headers: this.buildHeader(),
	        mode: 'cors'
	      });
	    }
	  }, {
	    key: 'ongoingCallIvr',
	    value: function ongoingCallIvr() {
	      return (0, _isomorphicFetch2.default)(this.PATH_WS + _constants.ONGOING_CALL_IVR, {
	        method: "POST",
	        body: JSON.stringify({}),
	        headers: this.buildHeader(),
	        mode: 'cors'
	      });
	    }
	  }, {
	    key: 'getChatLog',
	    value: function getChatLog(userId) {
	      return (0, _isomorphicFetch2.default)(this.PATH_WS + _constants.GET_CHAT_LOG, {
	        method: "POST",
	        body: JSON.stringify({ UserId: userId }),
	        headers: this.buildHeader(),
	        mode: 'cors'
	      });
	    }
	  }, {
	    key: 'uploadAttachment',
	    value: function uploadAttachment(file, body) {
	      var formData = new FormData();
	      formData.append('fileName', file);
	      formData.append('MultimediaType', body.MultimediaType);
	      formData.append('UserId', body.UserId);
	      formData.append('InboundId', body.InboundId);
	      formData.append('ConversationId', body.ConversationId);
	      formData.append('NewFileName', body.NewFileName);
	      return (0, _isomorphicFetch2.default)(this.PATH_WS + _constants.POST_ATTACHMENTS, {
	        method: 'POST',
	        body: formData,
	        mode: 'cors'
	      });
	    }
	  }, {
	    key: 'deleteAttachment',
	    value: function deleteAttachment(body) {
	      return (0, _isomorphicFetch2.default)(this.PATH_WS + _constants.DELETE_ATTACHMENT, {
	        method: 'DELETE',
	        body: JSON.stringify({
	          MultimediaType: body.MultimediaType,
	          UserId: body.UserId,
	          InboundId: body.InboundId,
	          ConversationId: body.ConversationId,
	          FileName: body.FileName
	        }),
	        mode: 'cors',
	        headers: this.buildHeader()
	      });
	    }
	  }, {
	    key: 'uploadUnifiedInboxAttachments',
	    value: function uploadUnifiedInboxAttachments(file, body) {
	      var formData = new FormData();
	      formData.append('fileName', file);
	      formData.append('MultimediaType', body.MultimediaType);
	      formData.append('From', body.From);
	      formData.append('to', body.To);
	      formData.append('conversationId', body.ConversationId);
	      formData.append('newFileName', body.NewFileName);
	      formData.append('clientName', body.ClientName);
	      formData.append('mediaType', body.MediaType);
	      formData.append('Version', '2');
	      return (0, _isomorphicFetch2.default)(_constants.WHATSAPP_ATTACHMENTS_URL, {
	        method: 'POST',
	        body: formData,
	        mode: 'cors'
	      });
	    }
	  }, {
	    key: 'deleteUnifiedInboxAttachment',
	    value: function deleteUnifiedInboxAttachment(body) {
	      return (0, _isomorphicFetch2.default)(_constants.WHATSAPP_ATTACHMENTS_URL, {
	        method: 'DELETE',
	        body: JSON.stringify({
	          MultimediaType: body.MultimediaType,
	          Path: body.FileName
	        }),
	        mode: 'cors',
	        headers: this.buildHeader()
	      });
	    }
	  }, {
	    key: 'getPreviewHistory',
	    value: function getPreviewHistory(data) {
	      return (0, _isomorphicFetch2.default)(this.PATH_WS + _constants.GET_PREVIEW_HISTORY, {
	        method: "POST",
	        body: JSON.stringify({
	          UserId: data.userId,
	          CallOutId: data.callOutId,
	          CamId: data.camId,
	          InitialRow: data.initialRow,
	          FinalRow: data.finalRow
	        }),
	        headers: this.buildHeader(),
	        mode: 'cors'
	      });
	    }
	  }, {
	    key: 'uploadAttachmentsChats',
	    value: function uploadAttachmentsChats(file, body) {
	      var formData = new FormData();
	      formData.append("fileName", file);
	      formData.append("MultimediaType", "1");
	      formData.append("UserId", body.UserId);
	      formData.append("InboundId", "1");
	      formData.append("ConversationId", body.ConversationId);
	      formData.append("NewFileName", body.NewFileName);
	      return (0, _isomorphicFetch2.default)(this.PATH_WS + _constants.POST_ATTACHMENTS, {
	        method: "POST",
	        body: formData,
	        mode: "cors"
	      });
	    }
	  }, {
	    key: 'validateWhatsAppPhoneNumber',
	    value: function validateWhatsAppPhoneNumber(data) {
	      return (0, _isomorphicFetch2.default)(this.PATH_WS + _constants.VALIDATE_WHATS_APP_PHONE_NUMBER, {
	        method: "POST",
	        body: JSON.stringify({
	          UserID: data.UserID,
	          CampID: data.CampID,
	          PhoneNumber: data.PhoneNumber
	        }),
	        headers: this.buildHeader(),
	        mode: 'cors'
	      });
	    }
	  }, {
	    key: 'getWhatsAppTemplates',
	    value: function getWhatsAppTemplates(data) {
	      return (0, _isomorphicFetch2.default)(this.PATH_WS + _constants.GET_WHATS_APP_TEMPLATES, {
	        method: "POST",
	        body: JSON.stringify({
	          UserID: data.UserID,
	          CampID: data.CampID,
	          PhoneNumber: data.PhoneNumber
	        }),
	        headers: this.buildHeader(),
	        mode: 'cors'
	      });
	    }
	  }, {
	    key: 'PathWS',
	    set: function set(webServices) {
	      this.PATH_WS = webServices;
	    },
	    get: function get() {
	      return this.PATH_WS;
	    }
	  }]);
	
	  return GalateaAPI;
	}();
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// the whatwg-fetch polyfill installs the fetch() function
	// on the global object (window or self)
	//
	// Return that as the export for use in Webpack, Browserify etc.
	__webpack_require__(7);
	module.exports = self.fetch.bind(self);
	
	
	/***/ }),
	/* 7 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (immutable) */ __webpack_exports__["Headers"] = Headers;
	/* harmony export (immutable) */ __webpack_exports__["Request"] = Request;
	/* harmony export (immutable) */ __webpack_exports__["Response"] = Response;
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DOMException", function() { return DOMException; });
	/* harmony export (immutable) */ __webpack_exports__["fetch"] = fetch;
	/* eslint-disable no-prototype-builtins */
	var g =
	  (typeof globalThis !== 'undefined' && globalThis) ||
	  (typeof self !== 'undefined' && self) ||
	  // eslint-disable-next-line no-undef
	  (typeof global !== 'undefined' && global) ||
	  {}
	
	var support = {
	  searchParams: 'URLSearchParams' in g,
	  iterable: 'Symbol' in g && 'iterator' in Symbol,
	  blob:
	    'FileReader' in g &&
	    'Blob' in g &&
	    (function() {
	      try {
	        new Blob()
	        return true
	      } catch (e) {
	        return false
	      }
	    })(),
	  formData: 'FormData' in g,
	  arrayBuffer: 'ArrayBuffer' in g
	}
	
	function isDataView(obj) {
	  return obj && DataView.prototype.isPrototypeOf(obj)
	}
	
	if (support.arrayBuffer) {
	  var viewClasses = [
	    '[object Int8Array]',
	    '[object Uint8Array]',
	    '[object Uint8ClampedArray]',
	    '[object Int16Array]',
	    '[object Uint16Array]',
	    '[object Int32Array]',
	    '[object Uint32Array]',
	    '[object Float32Array]',
	    '[object Float64Array]'
	  ]
	
	  var isArrayBufferView =
	    ArrayBuffer.isView ||
	    function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	}
	
	function normalizeName(name) {
	  if (typeof name !== 'string') {
	    name = String(name)
	  }
	  if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') {
	    throw new TypeError('Invalid character in header field name: "' + name + '"')
	  }
	  return name.toLowerCase()
	}
	
	function normalizeValue(value) {
	  if (typeof value !== 'string') {
	    value = String(value)
	  }
	  return value
	}
	
	// Build a destructive iterator for the value list
	function iteratorFor(items) {
	  var iterator = {
	    next: function() {
	      var value = items.shift()
	      return {done: value === undefined, value: value}
	    }
	  }
	
	  if (support.iterable) {
	    iterator[Symbol.iterator] = function() {
	      return iterator
	    }
	  }
	
	  return iterator
	}
	
	function Headers(headers) {
	  this.map = {}
	
	  if (headers instanceof Headers) {
	    headers.forEach(function(value, name) {
	      this.append(name, value)
	    }, this)
	  } else if (Array.isArray(headers)) {
	    headers.forEach(function(header) {
	      if (header.length != 2) {
	        throw new TypeError('Headers constructor: expected name/value pair to be length 2, found' + header.length)
	      }
	      this.append(header[0], header[1])
	    }, this)
	  } else if (headers) {
	    Object.getOwnPropertyNames(headers).forEach(function(name) {
	      this.append(name, headers[name])
	    }, this)
	  }
	}
	
	Headers.prototype.append = function(name, value) {
	  name = normalizeName(name)
	  value = normalizeValue(value)
	  var oldValue = this.map[name]
	  this.map[name] = oldValue ? oldValue + ', ' + value : value
	}
	
	Headers.prototype['delete'] = function(name) {
	  delete this.map[normalizeName(name)]
	}
	
	Headers.prototype.get = function(name) {
	  name = normalizeName(name)
	  return this.has(name) ? this.map[name] : null
	}
	
	Headers.prototype.has = function(name) {
	  return this.map.hasOwnProperty(normalizeName(name))
	}
	
	Headers.prototype.set = function(name, value) {
	  this.map[normalizeName(name)] = normalizeValue(value)
	}
	
	Headers.prototype.forEach = function(callback, thisArg) {
	  for (var name in this.map) {
	    if (this.map.hasOwnProperty(name)) {
	      callback.call(thisArg, this.map[name], name, this)
	    }
	  }
	}
	
	Headers.prototype.keys = function() {
	  var items = []
	  this.forEach(function(value, name) {
	    items.push(name)
	  })
	  return iteratorFor(items)
	}
	
	Headers.prototype.values = function() {
	  var items = []
	  this.forEach(function(value) {
	    items.push(value)
	  })
	  return iteratorFor(items)
	}
	
	Headers.prototype.entries = function() {
	  var items = []
	  this.forEach(function(value, name) {
	    items.push([name, value])
	  })
	  return iteratorFor(items)
	}
	
	if (support.iterable) {
	  Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	}
	
	function consumed(body) {
	  if (body._noBody) return
	  if (body.bodyUsed) {
	    return Promise.reject(new TypeError('Already read'))
	  }
	  body.bodyUsed = true
	}
	
	function fileReaderReady(reader) {
	  return new Promise(function(resolve, reject) {
	    reader.onload = function() {
	      resolve(reader.result)
	    }
	    reader.onerror = function() {
	      reject(reader.error)
	    }
	  })
	}
	
	function readBlobAsArrayBuffer(blob) {
	  var reader = new FileReader()
	  var promise = fileReaderReady(reader)
	  reader.readAsArrayBuffer(blob)
	  return promise
	}
	
	function readBlobAsText(blob) {
	  var reader = new FileReader()
	  var promise = fileReaderReady(reader)
	  var match = /charset=([A-Za-z0-9_-]+)/.exec(blob.type)
	  var encoding = match ? match[1] : 'utf-8'
	  reader.readAsText(blob, encoding)
	  return promise
	}
	
	function readArrayBufferAsText(buf) {
	  var view = new Uint8Array(buf)
	  var chars = new Array(view.length)
	
	  for (var i = 0; i < view.length; i++) {
	    chars[i] = String.fromCharCode(view[i])
	  }
	  return chars.join('')
	}
	
	function bufferClone(buf) {
	  if (buf.slice) {
	    return buf.slice(0)
	  } else {
	    var view = new Uint8Array(buf.byteLength)
	    view.set(new Uint8Array(buf))
	    return view.buffer
	  }
	}
	
	function Body() {
	  this.bodyUsed = false
	
	  this._initBody = function(body) {
	    /*
	      fetch-mock wraps the Response object in an ES6 Proxy to
	      provide useful test harness features such as flush. However, on
	      ES5 browsers without fetch or Proxy support pollyfills must be used;
	      the proxy-pollyfill is unable to proxy an attribute unless it exists
	      on the object before the Proxy is created. This change ensures
	      Response.bodyUsed exists on the instance, while maintaining the
	      semantic of setting Request.bodyUsed in the constructor before
	      _initBody is called.
	    */
	    // eslint-disable-next-line no-self-assign
	    this.bodyUsed = this.bodyUsed
	    this._bodyInit = body
	    if (!body) {
	      this._noBody = true;
	      this._bodyText = ''
	    } else if (typeof body === 'string') {
	      this._bodyText = body
	    } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	      this._bodyBlob = body
	    } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	      this._bodyFormData = body
	    } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	      this._bodyText = body.toString()
	    } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	      this._bodyArrayBuffer = bufferClone(body.buffer)
	      // IE 10-11 can't handle a DataView body.
	      this._bodyInit = new Blob([this._bodyArrayBuffer])
	    } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	      this._bodyArrayBuffer = bufferClone(body)
	    } else {
	      this._bodyText = body = Object.prototype.toString.call(body)
	    }
	
	    if (!this.headers.get('content-type')) {
	      if (typeof body === 'string') {
	        this.headers.set('content-type', 'text/plain;charset=UTF-8')
	      } else if (this._bodyBlob && this._bodyBlob.type) {
	        this.headers.set('content-type', this._bodyBlob.type)
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	      }
	    }
	  }
	
	  if (support.blob) {
	    this.blob = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return Promise.resolve(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as blob')
	      } else {
	        return Promise.resolve(new Blob([this._bodyText]))
	      }
	    }
	  }
	
	  this.arrayBuffer = function() {
	    if (this._bodyArrayBuffer) {
	      var isConsumed = consumed(this)
	      if (isConsumed) {
	        return isConsumed
	      } else if (ArrayBuffer.isView(this._bodyArrayBuffer)) {
	        return Promise.resolve(
	          this._bodyArrayBuffer.buffer.slice(
	            this._bodyArrayBuffer.byteOffset,
	            this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength
	          )
	        )
	      } else {
	        return Promise.resolve(this._bodyArrayBuffer)
	      }
	    } else if (support.blob) {
	      return this.blob().then(readBlobAsArrayBuffer)
	    } else {
	      throw new Error('could not read as ArrayBuffer')
	    }
	  }
	
	  this.text = function() {
	    var rejected = consumed(this)
	    if (rejected) {
	      return rejected
	    }
	
	    if (this._bodyBlob) {
	      return readBlobAsText(this._bodyBlob)
	    } else if (this._bodyArrayBuffer) {
	      return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	    } else if (this._bodyFormData) {
	      throw new Error('could not read FormData body as text')
	    } else {
	      return Promise.resolve(this._bodyText)
	    }
	  }
	
	  if (support.formData) {
	    this.formData = function() {
	      return this.text().then(decode)
	    }
	  }
	
	  this.json = function() {
	    return this.text().then(JSON.parse)
	  }
	
	  return this
	}
	
	// HTTP methods whose capitalization should be normalized
	var methods = ['CONNECT', 'DELETE', 'GET', 'HEAD', 'OPTIONS', 'PATCH', 'POST', 'PUT', 'TRACE']
	
	function normalizeMethod(method) {
	  var upcased = method.toUpperCase()
	  return methods.indexOf(upcased) > -1 ? upcased : method
	}
	
	function Request(input, options) {
	  if (!(this instanceof Request)) {
	    throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.')
	  }
	
	  options = options || {}
	  var body = options.body
	
	  if (input instanceof Request) {
	    if (input.bodyUsed) {
	      throw new TypeError('Already read')
	    }
	    this.url = input.url
	    this.credentials = input.credentials
	    if (!options.headers) {
	      this.headers = new Headers(input.headers)
	    }
	    this.method = input.method
	    this.mode = input.mode
	    this.signal = input.signal
	    if (!body && input._bodyInit != null) {
	      body = input._bodyInit
	      input.bodyUsed = true
	    }
	  } else {
	    this.url = String(input)
	  }
	
	  this.credentials = options.credentials || this.credentials || 'same-origin'
	  if (options.headers || !this.headers) {
	    this.headers = new Headers(options.headers)
	  }
	  this.method = normalizeMethod(options.method || this.method || 'GET')
	  this.mode = options.mode || this.mode || null
	  this.signal = options.signal || this.signal || (function () {
	    if ('AbortController' in g) {
	      var ctrl = new AbortController();
	      return ctrl.signal;
	    }
	  }());
	  this.referrer = null
	
	  if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	    throw new TypeError('Body not allowed for GET or HEAD requests')
	  }
	  this._initBody(body)
	
	  if (this.method === 'GET' || this.method === 'HEAD') {
	    if (options.cache === 'no-store' || options.cache === 'no-cache') {
	      // Search for a '_' parameter in the query string
	      var reParamSearch = /([?&])_=[^&]*/
	      if (reParamSearch.test(this.url)) {
	        // If it already exists then set the value with the current time
	        this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime())
	      } else {
	        // Otherwise add a new '_' parameter to the end with the current time
	        var reQueryString = /\?/
	        this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime()
	      }
	    }
	  }
	}
	
	Request.prototype.clone = function() {
	  return new Request(this, {body: this._bodyInit})
	}
	
	function decode(body) {
	  var form = new FormData()
	  body
	    .trim()
	    .split('&')
	    .forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	  return form
	}
	
	function parseHeaders(rawHeaders) {
	  var headers = new Headers()
	  // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
	  // https://tools.ietf.org/html/rfc7230#section-3.2
	  var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
	  // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
	  // https://github.com/github/fetch/issues/748
	  // https://github.com/zloirock/core-js/issues/751
	  preProcessedHeaders
	    .split('\r')
	    .map(function(header) {
	      return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header
	    })
	    .forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        try {
	          headers.append(key, value)
	        } catch (error) {
	          console.warn('Response ' + error.message)
	        }
	      }
	    })
	  return headers
	}
	
	Body.call(Request.prototype)
	
	function Response(bodyInit, options) {
	  if (!(this instanceof Response)) {
	    throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.')
	  }
	  if (!options) {
	    options = {}
	  }
	
	  this.type = 'default'
	  this.status = options.status === undefined ? 200 : options.status
	  if (this.status < 200 || this.status > 599) {
	    throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].")
	  }
	  this.ok = this.status >= 200 && this.status < 300
	  this.statusText = options.statusText === undefined ? '' : '' + options.statusText
	  this.headers = new Headers(options.headers)
	  this.url = options.url || ''
	  this._initBody(bodyInit)
	}
	
	Body.call(Response.prototype)
	
	Response.prototype.clone = function() {
	  return new Response(this._bodyInit, {
	    status: this.status,
	    statusText: this.statusText,
	    headers: new Headers(this.headers),
	    url: this.url
	  })
	}
	
	Response.error = function() {
	  var response = new Response(null, {status: 200, statusText: ''})
	  response.status = 0
	  response.type = 'error'
	  return response
	}
	
	var redirectStatuses = [301, 302, 303, 307, 308]
	
	Response.redirect = function(url, status) {
	  if (redirectStatuses.indexOf(status) === -1) {
	    throw new RangeError('Invalid status code')
	  }
	
	  return new Response(null, {status: status, headers: {location: url}})
	}
	
	var DOMException = g.DOMException
	try {
	  new DOMException()
	} catch (err) {
	  DOMException = function(message, name) {
	    this.message = message
	    this.name = name
	    var error = Error(message)
	    this.stack = error.stack
	  }
	  DOMException.prototype = Object.create(Error.prototype)
	  DOMException.prototype.constructor = DOMException
	}
	
	function fetch(input, init) {
	  return new Promise(function(resolve, reject) {
	    var request = new Request(input, init)
	
	    if (request.signal && request.signal.aborted) {
	      return reject(new DOMException('Aborted', 'AbortError'))
	    }
	
	    var xhr = new XMLHttpRequest()
	
	    function abortXhr() {
	      xhr.abort()
	    }
	
	    xhr.onload = function() {
	      var options = {
	        status: xhr.status,
	        statusText: xhr.statusText,
	        headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	      }
	      options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	      var body = 'response' in xhr ? xhr.response : xhr.responseText
	      setTimeout(function() {
	        resolve(new Response(body, options))
	      }, 0)
	    }
	
	    xhr.onerror = function() {
	      setTimeout(function() {
	        reject(new TypeError('Network request failed'))
	      }, 0)
	    }
	
	    xhr.ontimeout = function() {
	      setTimeout(function() {
	        reject(new TypeError('Network request failed'))
	      }, 0)
	    }
	
	    xhr.onabort = function() {
	      setTimeout(function() {
	        reject(new DOMException('Aborted', 'AbortError'))
	      }, 0)
	    }
	
	    function fixUrl(url) {
	      try {
	        return url === '' && g.location.href ? g.location.href : url
	      } catch (e) {
	        return url
	      }
	    }
	
	    xhr.open(request.method, fixUrl(request.url), true)
	
	    if (request.credentials === 'include') {
	      xhr.withCredentials = true
	    } else if (request.credentials === 'omit') {
	      xhr.withCredentials = false
	    }
	
	    if ('responseType' in xhr) {
	      if (support.blob) {
	        xhr.responseType = 'blob'
	      } else if (
	        support.arrayBuffer
	      ) {
	        xhr.responseType = 'arraybuffer'
	      }
	    }
	
	    if (init && typeof init.headers === 'object' && !(init.headers instanceof Headers || (g.Headers && init.headers instanceof g.Headers))) {
	      var names = [];
	      Object.getOwnPropertyNames(init.headers).forEach(function(name) {
	        names.push(normalizeName(name))
	        xhr.setRequestHeader(name, normalizeValue(init.headers[name]))
	      })
	      request.headers.forEach(function(value, name) {
	        if (names.indexOf(name) === -1) {
	          xhr.setRequestHeader(name, value)
	        }
	      })
	    } else {
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	    }
	
	    if (request.signal) {
	      request.signal.addEventListener('abort', abortXhr)
	
	      xhr.onreadystatechange = function() {
	        // DONE (success or failure)
	        if (xhr.readyState === 4) {
	          request.signal.removeEventListener('abort', abortXhr)
	        }
	      }
	    }
	
	    xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	  })
	}
	
	fetch.polyfill = true
	
	if (!g.fetch) {
	  g.fetch = fetch
	  g.Headers = Headers
	  g.Request = Request
	  g.Response = Response
	}
	
	/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(8)))
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports) {
	
	var g;
	
	// This works in non-strict mode
	g = (function() {
		return this;
	})();
	
	try {
		// This works if eval is allowed (see CSP)
		g = g || Function("return this")() || (1,eval)("this");
	} catch(e) {
		// This works if the window reference is available
		if(typeof window === "object")
			g = window;
	}
	
	// g can still be undefined, but nothing to do about it...
	// We return undefined, instead of nothing here, so it's
	// easier to handle this case. if(!global) { ...}
	
	module.exports = g;
	
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var IP_WEB_API = exports.IP_WEB_API = 'http://localhost/';
	var END_POINT_LOGIN = exports.END_POINT_LOGIN = './LoginWS/api/LoginAgent';
	var CHANGE_PASSWORD = exports.CHANGE_PASSWORD = './LoginWS/api/ChangePassword';
	
	var GET_LANGUAGE = exports.GET_LANGUAGE = './GalateaWS/api/LanguageTags';
	var GET_NO_AVAILABLE = exports.GET_NO_AVAILABLE = './GalateaWS/api/NotReady';
	var GET_NOT_READY_HISTORY = exports.GET_NOT_READY_HISTORY = './GalateaWS/api/NotReadyHistory';
	var VALIDATE_NOT_AVAILABLE_PASSWORD = exports.VALIDATE_NOT_AVAILABLE_PASSWORD = './LoginWS/api/LoginToReturnFromNotReady';
	var GET_SUPERVISOR_LIST = exports.GET_SUPERVISOR_LIST = './GalateaWS/api/OnlineSupervisors';
	var DISPOSITION_LIST = exports.DISPOSITION_LIST = './GalateaWS/api/DispositionList';
	var SAVE_DISPOSITION_LIST_ACD = exports.SAVE_DISPOSITION_LIST_ACD = './GalateaWS/api/SaveDispositionListACD';
	var CALL_ICON = exports.CALL_ICON = './GalateaWS/api/CallIcon';
	var GET_RECORD_CALL_PERMISSION = exports.GET_RECORD_CALL_PERMISSION = './GalateaWS/api/GetRecordCallPermission';
	var TRANSFER_CALL = exports.TRANSFER_CALL = './GalateaWS/api/TransferCall';
	var CALL_HISTORY = exports.CALL_HISTORY = './GalateaWS/api/CallHistory';
	var SAVE_DATA_CALL_OUT = exports.SAVE_DATA_CALL_OUT = './GalateaWS/api/UpdateDataOut';
	var VALIDATE_PHONE_NUMBER = exports.VALIDATE_PHONE_NUMBER = './GalateaWS/api/PhoneNumber';
	var CALL_AUDIO = exports.CALL_AUDIO = './GalateaWS/api/CallAudio';
	var MARK_CALL = exports.MARK_CALL = './GalateaWS/api/MarkCall';
	var EXTERNAL_CONTACTS = exports.EXTERNAL_CONTACTS = './GalateaWS/api/ExternalContacts';
	var EXTERNAL_ODBC_CAMPAIGN = exports.EXTERNAL_ODBC_CAMPAIGN = './GalateaWS/api/ExternalOdbcCampaign';
	var CALLBACK_DAY = exports.CALLBACK_DAY = './GalateaWS/api/CallBacksData';
	var ONGOING_CALL_IVR = exports.ONGOING_CALL_IVR = './GalateaWS/api/OngoingCallIvr';
	var GET_CHAT_LOG = exports.GET_CHAT_LOG = './GalateaWS/api/ChatLog';
	var GET_ATTCHMENTS = exports.GET_ATTCHMENTS = './GalateaWS/api/DownloadZip';
	var POST_ATTACHMENTS = exports.POST_ATTACHMENTS = './GalateaWS/api/Attachments';
	var DELETE_ATTACHMENT = exports.DELETE_ATTACHMENT = './GalateaWS/api/Attachments';
	var WHATSAPP_ATTACHMENTS_URL = exports.WHATSAPP_ATTACHMENTS_URL = 'https://cwkolob249.nuxiba.com/whatsappfiles2/api/Attachments';
	var GET_PREVIEW_HISTORY = exports.GET_PREVIEW_HISTORY = './GalateaWS/api/Preview';
	var VALIDATE_WHATS_APP_PHONE_NUMBER = exports.VALIDATE_WHATS_APP_PHONE_NUMBER = './GalateaWS/api/WhatsAppPhoneNumber';
	var GET_WHATS_APP_TEMPLATES = exports.GET_WHATS_APP_TEMPLATES = './GalateaWS/api/WhatsAppTemplates';
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// [NUXIBA]  Version: 2022.0.1 - 2022-11-10 09:29:54  
	 !function(r,e){ true?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports.EntryPoint=e():r.EntryPoint=e()}("undefined"!=typeof self?self:this,function(){return function(r){function e(a){if(t[a])return t[a].exports;var o=t[a]={i:a,l:!1,exports:{}};return r[a].call(o.exports,o,o.exports,e),o.l=!0,o.exports}var t={};return e.m=r,e.c=t,e.d=function(r,t,a){e.o(r,t)||Object.defineProperty(r,t,{configurable:!1,enumerable:!0,get:a})},e.n=function(r){var t=r&&r.__esModule?function(){return r.default}:function(){return r};return e.d(t,"a",t),t},e.o=function(r,e){return Object.prototype.hasOwnProperty.call(r,e)},e.p="",e(e.s=0)}([function(r,e,t){"use strict";function a(r,e){if(!(r instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0}),e.CypherFactory=void 0;var o=function(){function r(r,e){for(var t=0;t<e.length;t++){var a=e[t];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(r,a.key,a)}}return function(e,t,a){return t&&r(e.prototype,t),a&&r(e,a),e}}(),i=t(1),c=t(2),s=t(3);e.CypherFactory=function(){function r(){a(this,r)}return o(r,[{key:"buildClient",value:function(){return new s.CipherService(c.md5,i.blowfishEncryption)}}]),r}()},function(r,e,t){"use strict";function a(){this.IV=this.SetRandomIV();var r=this.HexToByte("nxbcipherkey2017");this.SetUpKey(r),this.escape=function(r){for(var e="",t=0;t<r.length;t++){var a=r.charCodeAt(t),o=Math.floor(a/16),i=a%16;o+=o<10?48:55,i+=i<10?48:55,e+=String.fromCharCode(o)+String.fromCharCode(i)}return e},this.unescape=function(r){for(var e="",t=0;t<r.length;t++){var a=r.charCodeAt(t++),o=r.charCodeAt(t);a-=a<58?48:a>96?87:55,o-=o<58?48:o>96?87:55,e+=String.fromCharCode(16*a+o)}return e}}function o(r){return(new a).encrypt(r)}Object.defineProperty(e,"__esModule",{value:!0}),e.blowfishEncryption=o,a.prototype.xor=function(r,e){var t=r^e;return t<0&&(t=4294967296+t),t},a.prototype.HexToByte=function(r){for(var e=new Uint8Array(r.length/2),t=0;t<r.length-1;t+=2){var a=this.GetHex(r.charCodeAt(t)),o=this.GetHex(r.charCodeAt(t+1));e[t/2]=16*a+o}return e},a.prototype.GetHex=function(r){return r<=57&&r>=48?r-48:r<=122&&r>=97?r-97+10:r<=90&&r>=65?r-65+10:0},a.prototype.SetUpKey=function(r){this.bf_P=this.Fbf_P(),this.bf_S0=this.Fbf_S0(),this.bf_S1=this.Fbf_S1(),this.bf_S2=this.Fbf_S2(),this.bf_S3=this.Fbf_S3();var e=new Uint8Array(r.length);e=r.length>56?r.substr(0,56):r;for(var t=0,a=0;a<18;a++){var o=256*e[t%r.length]+e[(t+1)%r.length],i=256*(256*o+e[(t+2)%r.length])+e[(t+3)%r.length],c=parseInt(i,10);this.bf_P[a]=this.xor(this.bf_P[a],c),t=(t+4)%r.length}for(this.xl_par=0,this.xr_par=0,a=0;a<18;a+=2)this.encipher(),this.bf_P[a]=this.xl_par,this.bf_P[a+1]=this.xr_par;for(t=0;t<256;t+=2)this.encipher(),this.bf_S0[t]=this.xl_par,this.bf_S0[t+1]=this.xr_par;for(t=0;t<256;t+=2)this.encipher(),this.bf_S1[t]=this.xl_par,this.bf_S1[t+1]=this.xr_par;for(t=0;t<256;t+=2)this.encipher(),this.bf_S2[t]=this.xl_par,this.bf_S2[t+1]=this.xr_par;for(t=0;t<256;t+=2)this.encipher(),this.bf_S3[t]=this.xl_par,this.bf_S3[t+1]=this.xr_par},a.prototype.wordbyte0=function(r){return Math.floor(Math.floor(Math.floor(r/256)/256)/256)%256},a.prototype.wordbyte1=function(r){return Math.floor(Math.floor(r/256)/256)%256},a.prototype.wordbyte2=function(r){return Math.floor(r/256)%256},a.prototype.wordbyte3=function(r){return r%256},a.prototype.SetRandomIV=function(){var r=new Uint8Array(8);try{window.crypto.getRandomValues(r)}catch(e){try{window.msCrypto.getRandomValues(r)}catch(r){}}return r},a.prototype.ConvertStringToByteArray=function(r){for(var e=new ArrayBuffer(r.length),t=new Uint8Array(e),a=0,o=r.length;a<o;a++)t[a]=r.charCodeAt(a);return t},a.prototype.Fbf_P=function(){return[608135816,2242054355,320440878,57701188,2752067618,698298832,137296536,3964562569,1160258022,953160567,3193202383,887688300,3232508343,3380367581,1065670069,3041331479,2450970073,2306472731]},a.prototype.Fbf_S0=function(){return[3509652390,2564797868,805139163,3491422135,3101798381,1780907670,3128725573,4046225305,614570311,3012652279,134345442,2240740374,1667834072,1901547113,2757295779,4103290238,227898511,1921955416,1904987480,2182433518,2069144605,3260701109,2620446009,720527379,3318853667,677414384,3393288472,3101374703,2390351024,1614419982,1822297739,2954791486,3608508353,3174124327,2024746970,1432378464,3864339955,2857741204,1464375394,1676153920,1439316330,715854006,3033291828,289532110,2706671279,2087905683,3018724369,1668267050,732546397,1947742710,3462151702,2609353502,2950085171,1814351708,2050118529,680887927,999245976,1800124847,3300911131,1713906067,1641548236,4213287313,1216130144,1575780402,4018429277,3917837745,3693486850,3949271944,596196993,3549867205,258830323,2213823033,772490370,2760122372,1774776394,2652871518,566650946,4142492826,1728879713,2882767088,1783734482,3629395816,2517608232,2874225571,1861159788,326777828,3124490320,2130389656,2716951837,967770486,1724537150,2185432712,2364442137,1164943284,2105845187,998989502,3765401048,2244026483,1075463327,1455516326,1322494562,910128902,469688178,1117454909,936433444,3490320968,3675253459,1240580251,122909385,2157517691,634681816,4142456567,3825094682,3061402683,2540495037,79693498,3249098678,1084186820,1583128258,426386531,1761308591,1047286709,322548459,995290223,1845252383,2603652396,3431023940,2942221577,3202600964,3727903485,1712269319,422464435,3234572375,1170764815,3523960633,3117677531,1434042557,442511882,3600875718,1076654713,1738483198,4213154764,2393238008,3677496056,1014306527,4251020053,793779912,2902807211,842905082,4246964064,1395751752,1040244610,2656851899,3396308128,445077038,3742853595,3577915638,679411651,2892444358,2354009459,1767581616,3150600392,3791627101,3102740896,284835224,4246832056,1258075500,768725851,2589189241,3069724005,3532540348,1274779536,3789419226,2764799539,1660621633,3471099624,4011903706,913787905,3497959166,737222580,2514213453,2928710040,3937242737,1804850592,3499020752,2949064160,2386320175,2390070455,2415321851,4061277028,2290661394,2416832540,1336762016,1754252060,3520065937,3014181293,791618072,3188594551,3933548030,2332172193,3852520463,3043980520,413987798,3465142937,3030929376,4245938359,2093235073,3534596313,375366246,2157278981,2479649556,555357303,3870105701,2008414854,3344188149,4221384143,3956125452,2067696032,3594591187,2921233993,2428461,544322398,577241275,1471733935,610547355,4027169054,1432588573,1507829418,2025931657,3646575487,545086370,48609733,2200306550,1653985193,298326376,1316178497,3007786442,2064951626,458293330,2589141269,3591329599,3164325604,727753846,2179363840,146436021,1461446943,4069977195,705550613,3059967265,3887724982,4281599278,3313849956,1404054877,2845806497,146425753,1854211946]},a.prototype.Fbf_S1=function(){return[1266315497,3048417604,3681880366,3289982499,290971e4,1235738493,2632868024,2414719590,3970600049,1771706367,1449415276,3266420449,422970021,1963543593,2690192192,3826793022,1062508698,1531092325,1804592342,2583117782,2714934279,4024971509,1294809318,4028980673,1289560198,2221992742,1669523910,35572830,157838143,1052438473,1016535060,1802137761,1753167236,1386275462,3080475397,2857371447,1040679964,2145300060,2390574316,1461121720,2956646967,4031777805,4028374788,33600511,2920084762,1018524850,629373528,3691585981,3515945977,2091462646,2486323059,586499841,988145025,935516892,3367335476,2599673255,2839830854,265290510,3972581182,2759138881,3795373465,1005194799,847297441,406762289,1314163512,1332590856,1866599683,4127851711,750260880,613907577,1450815602,3165620655,3734664991,3650291728,3012275730,3704569646,1427272223,778793252,1343938022,2676280711,2052605720,1946737175,3164576444,3914038668,3967478842,3682934266,1661551462,3294938066,4011595847,840292616,3712170807,616741398,312560963,711312465,1351876610,322626781,1910503582,271666773,2175563734,1594956187,70604529,3617834859,1007753275,1495573769,4069517037,2549218298,2663038764,504708206,2263041392,3941167025,2249088522,1514023603,1998579484,1312622330,694541497,2582060303,2151582166,1382467621,776784248,2618340202,3323268794,2497899128,2784771155,503983604,4076293799,907881277,423175695,432175456,1378068232,4145222326,3954048622,3938656102,3820766613,2793130115,2977904593,26017576,3274890735,3194772133,1700274565,1756076034,4006520079,3677328699,720338349,1533947780,354530856,688349552,3973924725,1637815568,332179504,3949051286,53804574,2852348879,3044236432,1282449977,3583942155,3416972820,4006381244,1617046695,2628476075,3002303598,1686838959,431878346,2686675385,1700445008,1080580658,1009431731,832498133,3223435511,2605976345,2271191193,2516031870,1648197032,4164389018,2548247927,300782431,375919233,238389289,3353747414,2531188641,2019080857,1475708069,455242339,2609103871,448939670,3451063019,1395535956,2413381860,1841049896,1491858159,885456874,4264095073,4001119347,1565136089,3898914787,1108368660,540939232,1173283510,2745871338,3681308437,4207628240,3343053890,4016749493,1699691293,1103962373,3625875870,2256883143,3830138730,1031889488,3479347698,1535977030,4236805024,3251091107,2132092099,1774941330,1199868427,1452454533,157007616,2904115357,342012276,595725824,1480756522,206960106,497939518,591360097,863170706,2375253569,3596610801,1814182875,2094937945,3421402208,1082520231,3463918190,2785509508,435703966,3908032597,1641649973,2842273706,3305899714,1510255612,2148256476,2655287854,3276092548,4258621189,236887753,3681803219,274041037,1734335097,3815195456,3317970021,1899903192,1026095262,4050517792,356393447,2410691914,3873677099,3682840055]},a.prototype.Fbf_S2=function(){return[3913112168,2491498743,4132185628,2489919796,1091903735,1979897079,3170134830,3567386728,3557303409,857797738,1136121015,1342202287,507115054,2535736646,337727348,3213592640,1301675037,2528481711,1895095763,1721773893,3216771564,62756741,2142006736,835421444,2531993523,1442658625,3659876326,2882144922,676362277,1392781812,170690266,3921047035,1759253602,3611846912,1745797284,664899054,1329594018,3901205900,3045908486,2062866102,2865634940,3543621612,3464012697,1080764994,553557557,3656615353,3996768171,991055499,499776247,1265440854,648242737,3940784050,980351604,3713745714,1749149687,3396870395,4211799374,3640570775,1161844396,3125318951,1431517754,545492359,4268468663,3499529547,1437099964,2702547544,3433638243,2581715763,2787789398,1060185593,1593081372,2418618748,4260947970,69676912,2159744348,86519011,2512459080,3838209314,1220612927,3339683548,133810670,1090789135,1078426020,1569222167,845107691,3583754449,4072456591,1091646820,628848692,1613405280,3757631651,526609435,236106946,48312990,2942717905,3402727701,1797494240,859738849,992217954,4005476642,2243076622,3870952857,3732016268,765654824,3490871365,2511836413,1685915746,3888969200,1414112111,2273134842,3281911079,4080962846,172450625,2569994100,980381355,4109958455,2819808352,2716589560,2568741196,3681446669,3329971472,1835478071,660984891,3704678404,4045999559,3422617507,3040415634,1762651403,1719377915,3470491036,2693910283,3642056355,3138596744,1364962596,2073328063,1983633131,926494387,3423689081,2150032023,4096667949,1749200295,3328846651,309677260,2016342300,1779581495,3079819751,111262694,1274766160,443224088,298511866,1025883608,3806446537,1145181785,168956806,3641502830,3584813610,1689216846,3666258015,3200248200,1692713982,2646376535,4042768518,1618508792,1610833997,3523052358,4130873264,2001055236,3610705100,2202168115,4028541809,2961195399,1006657119,2006996926,3186142756,1430667929,3210227297,1314452623,4074634658,4101304120,2273951170,1399257539,3367210612,3027628629,1190975929,2062231137,2333990788,2221543033,2438960610,1181637006,548689776,2362791313,3372408396,3104550113,3145860560,296247880,1970579870,3078560182,3769228297,1714227617,3291629107,3898220290,166772364,1251581989,493813264,448347421,195405023,2709975567,677966185,3703036547,1463355134,2715995803,1338867538,1343315457,2802222074,2684532164,233230375,2599980071,2000651841,3277868038,1638401717,4028070440,3237316320,6314154,819756386,300326615,590932579,1405279636,3267499572,3150704214,2428286686,3959192993,3461946742,1862657033,1266418056,963775037,2089974820,2263052895,1917689273,448879540,3550394620,3981727096,150775221,3627908307,1303187396,508620638,2975983352,2726630617,1817252668,1876281319,1457606340,908771278,3720792119,3617206836,2455994898,1729034894,1080033504]},a.prototype.Fbf_S3=function(){return[976866871,3556439503,2881648439,1522871579,1555064734,1336096578,3548522304,2579274686,3574697629,3205460757,3593280638,3338716283,3079412587,564236357,2993598910,1781952180,1464380207,3163844217,3332601554,1699332808,1393555694,1183702653,3581086237,1288719814,691649499,2847557200,2895455976,3193889540,2717570544,1781354906,1676643554,2592534050,3230253752,1126444790,2770207658,2633158820,2210423226,2615765581,2414155088,3127139286,673620729,2805611233,1269405062,4015350505,3341807571,4149409754,1057255273,2012875353,2162469141,2276492801,2601117357,993977747,3918593370,2654263191,753973209,36408145,2530585658,25011837,3520020182,2088578344,530523599,2918365339,1524020338,1518925132,3760827505,3759777254,1202760957,3985898139,3906192525,674977740,4174734889,2031300136,2019492241,3983892565,4153806404,3822280332,352677332,2297720250,60907813,90501309,3286998549,1016092578,2535922412,2839152426,457141659,509813237,4120667899,652014361,1966332200,2975202805,55981186,2327461051,676427537,3255491064,2882294119,3433927263,1307055953,942726286,933058658,2468411793,3933900994,4215176142,1361170020,2001714738,2830558078,3274259782,1222529897,1679025792,2729314320,3714953764,1770335741,151462246,3013232138,1682292957,1483529935,471910574,1539241949,458788160,3436315007,1807016891,3718408830,978976581,1043663428,3165965781,1927990952,4200891579,2372276910,3208408903,3533431907,1412390302,2931980059,4132332400,1947078029,3881505623,4168226417,2941484381,1077988104,1320477388,886195818,18198404,3786409e3,2509781533,112762804,3463356488,1866414978,891333506,18488651,661792760,1628790961,3885187036,3141171499,876946877,2693282273,1372485963,791857591,2686433993,3759982718,3167212022,3472953795,2716379847,445679433,3561995674,3504004811,3574258232,54117162,3331405415,2381918588,3769707343,4154350007,1140177722,4074052095,668550556,3214352940,367459370,261225585,2610173221,4209349473,3468074219,3265815641,314222801,3066103646,3808782860,282218597,3406013506,3773591054,379116347,1285071038,846784868,2669647154,3771962079,3550491691,2305946142,453669953,1268987020,3317592352,3279303384,3744833421,2610507566,3859509063,266596637,3847019092,517658769,3462560207,3443424879,370717030,4247526661,2224018117,4143653529,4112773975,2788324899,2477274417,1456262402,2901442914,1517677493,1846949527,2295493580,3734397586,2176403920,1280348187,1908823572,3871786941,846861322,1172426758,3287448474,3383383037,1655181056,3139813346,901632758,1897031941,2986607138,3066810236,3447102507,1393639104,373351379,950779232,625454576,3124240540,4148612726,2007998917,544563296,2244738638,2330496472,2058025392,1291430526,424198748,50039436,29584100,3605783033,2429876329,2791104160,1057563949,3255363231,3075367218,3463963227,1469046755,985887462]},a.prototype.ByteArrayToHex=function(r){for(var e="",t=0;t<r.length;t++){var a=r[t].toString(16);1===a.length&&(a="0"+a),e+=a}return e},a.prototype.encrypt=function(r){var e=this.ConvertStringToByteArray(r),t=this.Encrypt_CBC(e),a=this.ByteArrayToHex(t);return this.ByteArrayToHex(this.IV)+a},a.prototype.Encrypt_CBC=function(r){return this.Crypt_CBC(r,!1)},a.prototype.Crypt_CBC=function(r,e){var t=r.length%8,a=0===t?r.length:r.length+8-t,o=new Uint8Array(a);o=this.BlockCopy(r,0,o,0,r.length);var i=new Uint8Array(8),c=new Uint8Array(8);c=this.BlockCopy(this.IV,0,c,0,8);for(var s=0;s<o.length;s+=8)i=this.BlockCopy(o,s,i,0,8),i=this.XorBlock(i,c),i=this.BlockEncrypt(i),c=this.BlockCopy(i,0,c,0,8),o=this.BlockCopy(i,0,o,s,8);return o},a.prototype.BlockEncrypt=function(r){return this.SetBlock(r),this.encipher(),r=this.GetBlock(r)},a.prototype.GetBlock=function(r){var e=new Uint8Array(4),t=new Uint8Array(4);e=this.IntToByteArray(this.xl_par),t=this.IntToByteArray(this.xr_par);try{e=e.reverse(),t=t.reverse()}catch(r){e=this.Reverse(e),t=this.Reverse(t)}return r=this.BlockCopy(e,0,r,0,4),r=this.BlockCopy(t,0,r,4,4)},a.prototype.IntToByteArray=function(r){for(var e=[0,0,0,0],t=0;t<e.length;t++){var a=255&r;e[t]=a,r=(r-a)/256}return e},a.prototype.SetBlock=function(r){var e=new Uint8Array(4),t=new Uint8Array(4);e=this.BlockCopy(r,0,e,0,4),t=this.BlockCopy(r,4,t,0,4);try{e=e.reverse(),t=t.reverse()}catch(r){e=this.Reverse(e),t=this.Reverse(t)}this.xl_par=this.ByteArrayToUInt32(e,0),this.xr_par=this.ByteArrayToUInt32(t,0)},a.prototype.ByteArrayToUInt32=function(r,e){return new Uint32Array(r.buffer,0,1)[0]},a.prototype.Reverse=function(r){for(var e,t=Math.floor(r.length/2),a=r.length-1,o=0;o<t;o++)e=r[o],r[o]=r[a],r[a]=e,a--;return r},a.prototype.XorBlock=function(r,e){for(var t=0;t<r.length;t++)r[t]^=e[t];return r},a.prototype.BlockCopy=function(r,e,t,a,o){for(var i=0;i<o;i++)t[a]=r[e],a++,e++;return t},a.prototype.decrypt=function(r){for(var e=0;e<r.length%16;e++)r+="0";var t="";for(e=0;e<r.length;e+=16){var a=this.unescape(r.substr(e,8)),o=this.unescape(r.substr(e+8,8)),i=a.charCodeAt(3)|a.charCodeAt(2)<<8|a.charCodeAt(1)<<16|a.charCodeAt(0)<<24;i<0&&(i=4294967296+i);var c=o.charCodeAt(3)|o.charCodeAt(2)<<8|o.charCodeAt(1)<<16|o.charCodeAt(0)<<24;c<0&&(c=4294967296+c),this.xl_par=i,this.xr_par=c,this.decipher(),t+=this.wordescape(this.xl_par)+this.wordescape(this.xr_par)}return this.unescape(t)},a.prototype.wordescape=function(r){for(var e="",t=[this.wordbyte3(r),this.wordbyte2(r),this.wordbyte1(r),this.wordbyte0(r)],a=3;a>=0;a--){var o=Math.floor(t[a]/16),i=t[a]%16;o+=o<10?48:55,i+=i<10?48:55,e+=String.fromCharCode(o)+String.fromCharCode(i)}return e},a.prototype.wordunescape=function(r){for(var e=0,t=6;t>=0;t-=2){var a=r.charCodeAt(t),o=r.charCodeAt(t+1);a-=a<58?48:55,o-=o<58?48:55,e=256*e+(16*a+o)}return e},a.prototype.round=function(r,e,t){var a=this,o=this.xor(a.bf_S0[a.wordbyte0(e)]+a.bf_S1[a.wordbyte1(e)],a.bf_S2[a.wordbyte2(e)]),i=o+a.bf_S3[a.wordbyte3(e)],c=this.xor(i,a.bf_P[t]);return this.xor(r,c)},a.prototype.encipher=function(){this.xl_par=this.xor(this.xl_par,this.bf_P[0]);for(var r=0;r<16;r+=2)this.xr_par=this.round(this.xr_par,this.xl_par,r+1),this.xl_par=this.round(this.xl_par,this.xr_par,r+2);this.xr_par=this.xor(this.xr_par,this.bf_P[17]);var e=this.xl_par;this.xl_par=this.xr_par,this.xr_par=e},a.prototype.decipher=function(){var r=this,e=r.xl_par,t=r.xr_par;e=r.xor(e,r.bf_P[17]),t=r.round(t,e,16),e=r.round(e,t,15),t=r.round(t,e,14),e=r.round(e,t,13),t=r.round(t,e,12),e=r.round(e,t,11),t=r.round(t,e,10),e=r.round(e,t,9),t=r.round(t,e,8),e=r.round(e,t,7),t=r.round(t,e,6),e=r.round(e,t,5),t=r.round(t,e,4),e=r.round(e,t,3),t=r.round(t,e,2),e=r.round(e,t,1),t=r.xor(t,r.bf_P[0]),r.xl_par=t,r.xr_par=e}},function(r,e,t){"use strict";function a(r,e){var t=(65535&r)+(65535&e);return(r>>16)+(e>>16)+(t>>16)<<16|65535&t}function o(r,e){return r<<e|r>>>32-e}function i(r,e,t,i,c,s){return a(o(a(a(e,r),a(i,s)),c),t)}function c(r,e,t,a,o,c,s){return i(e&t|~e&a,r,e,o,c,s)}function s(r,e,t,a,o,c,s){return i(e&a|t&~a,r,e,o,c,s)}function n(r,e,t,a,o,c,s){return i(e^t^a,r,e,o,c,s)}function l(r,e,t,a,o,c,s){return i(t^(e|~a),r,e,o,c,s)}function u(r,e){r[e>>5]|=128<<e%32,r[14+(e+64>>>9<<4)]=e;var t,o,i,u,p,d=1732584193,g=-271733879,h=-1732584194,f=271733878;for(t=0;t<r.length;t+=16)o=d,i=g,u=h,p=f,d=c(d,g,h,f,r[t],7,-680876936),f=c(f,d,g,h,r[t+1],12,-389564586),h=c(h,f,d,g,r[t+2],17,606105819),g=c(g,h,f,d,r[t+3],22,-1044525330),d=c(d,g,h,f,r[t+4],7,-176418897),f=c(f,d,g,h,r[t+5],12,1200080426),h=c(h,f,d,g,r[t+6],17,-1473231341),g=c(g,h,f,d,r[t+7],22,-45705983),d=c(d,g,h,f,r[t+8],7,1770035416),f=c(f,d,g,h,r[t+9],12,-1958414417),h=c(h,f,d,g,r[t+10],17,-42063),g=c(g,h,f,d,r[t+11],22,-1990404162),d=c(d,g,h,f,r[t+12],7,1804603682),f=c(f,d,g,h,r[t+13],12,-40341101),h=c(h,f,d,g,r[t+14],17,-1502002290),g=c(g,h,f,d,r[t+15],22,1236535329),d=s(d,g,h,f,r[t+1],5,-165796510),f=s(f,d,g,h,r[t+6],9,-1069501632),h=s(h,f,d,g,r[t+11],14,643717713),g=s(g,h,f,d,r[t],20,-373897302),d=s(d,g,h,f,r[t+5],5,-701558691),f=s(f,d,g,h,r[t+10],9,38016083),h=s(h,f,d,g,r[t+15],14,-660478335),g=s(g,h,f,d,r[t+4],20,-405537848),d=s(d,g,h,f,r[t+9],5,568446438),f=s(f,d,g,h,r[t+14],9,-1019803690),h=s(h,f,d,g,r[t+3],14,-187363961),g=s(g,h,f,d,r[t+8],20,1163531501),d=s(d,g,h,f,r[t+13],5,-1444681467),f=s(f,d,g,h,r[t+2],9,-51403784),h=s(h,f,d,g,r[t+7],14,1735328473),g=s(g,h,f,d,r[t+12],20,-1926607734),d=n(d,g,h,f,r[t+5],4,-378558),f=n(f,d,g,h,r[t+8],11,-2022574463),h=n(h,f,d,g,r[t+11],16,1839030562),g=n(g,h,f,d,r[t+14],23,-35309556),d=n(d,g,h,f,r[t+1],4,-1530992060),f=n(f,d,g,h,r[t+4],11,1272893353),h=n(h,f,d,g,r[t+7],16,-155497632),g=n(g,h,f,d,r[t+10],23,-1094730640),d=n(d,g,h,f,r[t+13],4,681279174),f=n(f,d,g,h,r[t],11,-358537222),h=n(h,f,d,g,r[t+3],16,-722521979),g=n(g,h,f,d,r[t+6],23,76029189),d=n(d,g,h,f,r[t+9],4,-640364487),f=n(f,d,g,h,r[t+12],11,-421815835),h=n(h,f,d,g,r[t+15],16,530742520),g=n(g,h,f,d,r[t+2],23,-995338651),d=l(d,g,h,f,r[t],6,-198630844),f=l(f,d,g,h,r[t+7],10,1126891415),h=l(h,f,d,g,r[t+14],15,-1416354905),g=l(g,h,f,d,r[t+5],21,-57434055),d=l(d,g,h,f,r[t+12],6,1700485571),f=l(f,d,g,h,r[t+3],10,-1894986606),h=l(h,f,d,g,r[t+10],15,-1051523),g=l(g,h,f,d,r[t+1],21,-2054922799),d=l(d,g,h,f,r[t+8],6,1873313359),f=l(f,d,g,h,r[t+15],10,-30611744),h=l(h,f,d,g,r[t+6],15,-1560198380),g=l(g,h,f,d,r[t+13],21,1309151649),d=l(d,g,h,f,r[t+4],6,-145523070),f=l(f,d,g,h,r[t+11],10,-1120210379),h=l(h,f,d,g,r[t+2],15,718787259),g=l(g,h,f,d,r[t+9],21,-343485551),d=a(d,o),g=a(g,i),h=a(h,u),f=a(f,p);return[d,g,h,f]}function p(r){var e,t="",a=32*r.length;for(e=0;e<a;e+=8)t+=String.fromCharCode(r[e>>5]>>>e%32&255);return t}function d(r){var e,t=[];for(t[(r.length>>2)-1]=void 0,e=0;e<t.length;e+=1)t[e]=0;var a=8*r.length;for(e=0;e<a;e+=8)t[e>>5]|=(255&r.charCodeAt(e/8))<<e%32;return t}function g(r){return p(u(d(r),8*r.length))}function h(r){var e,t,a="0123456789abcdef",o="";for(t=0;t<r.length;t+=1)e=r.charCodeAt(t),o+=a.charAt(e>>>4&15)+a.charAt(15&e);return o}function f(r){return unescape(encodeURIComponent(r))}function m(r){return g(f(r))}function b(r){return h(m(r))}function v(r){return b(r)}Object.defineProperty(e,"__esModule",{value:!0}),e.md5=v},function(r,e,t){"use strict";function a(r,e){if(!(r instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0}),e.CipherService=void 0;var o=function(){function r(r,e){for(var t=0;t<e.length;t++){var a=e[t];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(r,a.key,a)}}return function(e,t,a){return t&&r(e.prototype,t),a&&r(e,a),e}}(),i=t(4),c=null,s=e.CipherService=function(){function r(e,t){return a(this,r),c||(c=this,this.encryptionMD5=e,this.encryptionBlowfish=t),c}return o(r,[{key:"md5Encryption",value:function(r){return this.encryptionMD5(r)}},{key:"blowfishEncryption",value:function(r){var e=(0,i.encode)(r,{mode:"nonAsciiPrintable"});return this.encryptionBlowfish(e)}}]),r}();e.default=s},function(r,e,t){"use strict";function a(r,e){var t=void 0===e?d:e,a=t.mode,o=void 0===a?"specialChars":a,i=t.numeric,c=void 0===i?"decimal":i,s=t.level,n=void 0===s?"all":s;if(!r)return"";var g=p[o],h=u[n].characters,f="hexadecimal"===c;g.lastIndex=0;var a,t=g.exec(r);if(t){a="";var i=0;do{i!==t.index&&(a+=r.substring(i,t.index));var s=t[0],m=h[s];if(!m){var b=s.length>1?l.getCodePoint(s,0):s.charCodeAt(0);m=(f?"&#x"+b.toString(16):"&#"+b)+";"}a+=m,i=t.index+s.length}while(t=g.exec(r));i!==r.length&&(a+=r.substring(i))}else a=r;return a}function o(r,e){var t=(void 0===e?q:e).level,a=void 0===t?"all":t;if(!r)return"";var t=r,o=(r[r.length-1],u[a].entities[r]);if(o)t=o;else if("&"===r[0]&&"#"===r[1]){var i=r[2],c="x"==i||"X"==i?parseInt(r.substr(3),16):parseInt(r.substr(2));t=c>=1114111?y:c>65535?l.fromCodePoint(c):v(n.numericUnicodeMap[c]||c)}return t}function i(r,e){var t=void 0===e?g:e,a=t.level,o=void 0===a?"all":a,i=t.scope,c=void 0===i?"xml"===o?"strict":"body":i;if(!r)return"";var s=b[o][c],p=u[o].entities,d="attribute"===c,h="strict"===c;s.lastIndex=0;var f,m=s.exec(r);if(m){f="";var q=0;do{q!==m.index&&(f+=r.substring(q,m.index));var w=m[0],x=w,A=w[w.length-1];if(d&&"="===A)x=w;else if(h&&";"!==A)x=w;else{var E=p[w];if(E)x=E;else if("&"===w[0]&&"#"===w[1]){var D=w[2],k="x"==D||"X"==D?parseInt(w.substr(3),16):parseInt(w.substr(2));x=k>=1114111?y:k>65535?l.fromCodePoint(k):v(n.numericUnicodeMap[k]||k)}}f+=x,q=m.index+w.length}while(m=s.exec(r));q!==r.length&&(f+=r.substring(q))}else f=r;return f}var c=this&&this.__assign||function(){return c=Object.assign||function(r){for(var e,t=1,a=arguments.length;t<a;t++){e=arguments[t];for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&(r[o]=e[o])}return r},c.apply(this,arguments)};Object.defineProperty(e,"__esModule",{value:!0});var s=t(5),n=t(6),l=t(7),u=c(c({},s.namedReferences),{all:s.namedReferences.html5}),p={specialChars:/[<>'"&]/g,nonAscii:/(?:[<>'"&\u0080-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/g,nonAsciiPrintable:/(?:[<>'"&\x01-\x08\x11-\x15\x17-\x1F\x7f-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/g,extensive:/(?:[\x01-\x0c\x0e-\x1f\x21-\x2c\x2e-\x2f\x3a-\x40\x5b-\x60\x7b-\x7d\x7f-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/g},d={mode:"specialChars",level:"all",numeric:"decimal"};e.encode=a;var g={scope:"body",level:"all"},h=/&(?:#\d+|#[xX][\da-fA-F]+|[0-9a-zA-Z]+);/g,f=/&(?:#\d+|#[xX][\da-fA-F]+|[0-9a-zA-Z]+)[;=]?/g,m={xml:{strict:h,attribute:f,body:s.bodyRegExps.xml},html4:{strict:h,attribute:f,body:s.bodyRegExps.html4},html5:{strict:h,attribute:f,body:s.bodyRegExps.html5}},b=c(c({},m),{all:m.html5}),v=String.fromCharCode,y=v(65533),q={level:"all"};e.decodeEntity=o,e.decode=i},function(r,e,t){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.bodyRegExps={xml:/&(?:#\d+|#[xX][\da-fA-F]+|[0-9a-zA-Z]+);?/g,html4:/&(?:nbsp|iexcl|cent|pound|curren|yen|brvbar|sect|uml|copy|ordf|laquo|not|shy|reg|macr|deg|plusmn|sup2|sup3|acute|micro|para|middot|cedil|sup1|ordm|raquo|frac14|frac12|frac34|iquest|Agrave|Aacute|Acirc|Atilde|Auml|Aring|AElig|Ccedil|Egrave|Eacute|Ecirc|Euml|Igrave|Iacute|Icirc|Iuml|ETH|Ntilde|Ograve|Oacute|Ocirc|Otilde|Ouml|times|Oslash|Ugrave|Uacute|Ucirc|Uuml|Yacute|THORN|szlig|agrave|aacute|acirc|atilde|auml|aring|aelig|ccedil|egrave|eacute|ecirc|euml|igrave|iacute|icirc|iuml|eth|ntilde|ograve|oacute|ocirc|otilde|ouml|divide|oslash|ugrave|uacute|ucirc|uuml|yacute|thorn|yuml|quot|amp|lt|gt|#\d+|#[xX][\da-fA-F]+|[0-9a-zA-Z]+);?/g,html5:/&(?:AElig|AMP|Aacute|Acirc|Agrave|Aring|Atilde|Auml|COPY|Ccedil|ETH|Eacute|Ecirc|Egrave|Euml|GT|Iacute|Icirc|Igrave|Iuml|LT|Ntilde|Oacute|Ocirc|Ograve|Oslash|Otilde|Ouml|QUOT|REG|THORN|Uacute|Ucirc|Ugrave|Uuml|Yacute|aacute|acirc|acute|aelig|agrave|amp|aring|atilde|auml|brvbar|ccedil|cedil|cent|copy|curren|deg|divide|eacute|ecirc|egrave|eth|euml|frac12|frac14|frac34|gt|iacute|icirc|iexcl|igrave|iquest|iuml|laquo|lt|macr|micro|middot|nbsp|not|ntilde|oacute|ocirc|ograve|ordf|ordm|oslash|otilde|ouml|para|plusmn|pound|quot|raquo|reg|sect|shy|sup1|sup2|sup3|szlig|thorn|times|uacute|ucirc|ugrave|uml|uuml|yacute|yen|yuml|#\d+|#[xX][\da-fA-F]+|[0-9a-zA-Z]+);?/g},e.namedReferences={xml:{entities:{"&lt;":"<","&gt;":">","&quot;":'"',"&apos;":"'","&amp;":"&"},characters:{"<":"&lt;",">":"&gt;",'"':"&quot;","'":"&apos;","&":"&amp;"}},html4:{entities:{"&apos;":"'","&nbsp":" ","&nbsp;":" ","&iexcl":"¡","&iexcl;":"¡","&cent":"¢","&cent;":"¢","&pound":"£","&pound;":"£","&curren":"¤","&curren;":"¤","&yen":"¥","&yen;":"¥","&brvbar":"¦","&brvbar;":"¦","&sect":"§","&sect;":"§","&uml":"¨","&uml;":"¨","&copy":"©","&copy;":"©","&ordf":"ª","&ordf;":"ª","&laquo":"«","&laquo;":"«","&not":"¬","&not;":"¬","&shy":"­","&shy;":"­","&reg":"®","&reg;":"®","&macr":"¯","&macr;":"¯","&deg":"°","&deg;":"°","&plusmn":"±","&plusmn;":"±","&sup2":"²","&sup2;":"²","&sup3":"³","&sup3;":"³","&acute":"´","&acute;":"´","&micro":"µ","&micro;":"µ","&para":"¶","&para;":"¶","&middot":"·","&middot;":"·","&cedil":"¸","&cedil;":"¸","&sup1":"¹","&sup1;":"¹","&ordm":"º","&ordm;":"º","&raquo":"»","&raquo;":"»","&frac14":"¼","&frac14;":"¼","&frac12":"½","&frac12;":"½","&frac34":"¾","&frac34;":"¾","&iquest":"¿","&iquest;":"¿","&Agrave":"À","&Agrave;":"À","&Aacute":"Á","&Aacute;":"Á","&Acirc":"Â","&Acirc;":"Â","&Atilde":"Ã","&Atilde;":"Ã","&Auml":"Ä","&Auml;":"Ä","&Aring":"Å","&Aring;":"Å","&AElig":"Æ","&AElig;":"Æ","&Ccedil":"Ç","&Ccedil;":"Ç","&Egrave":"È","&Egrave;":"È","&Eacute":"É","&Eacute;":"É","&Ecirc":"Ê","&Ecirc;":"Ê","&Euml":"Ë","&Euml;":"Ë","&Igrave":"Ì","&Igrave;":"Ì","&Iacute":"Í","&Iacute;":"Í","&Icirc":"Î","&Icirc;":"Î","&Iuml":"Ï","&Iuml;":"Ï","&ETH":"Ð","&ETH;":"Ð","&Ntilde":"Ñ","&Ntilde;":"Ñ","&Ograve":"Ò","&Ograve;":"Ò","&Oacute":"Ó","&Oacute;":"Ó","&Ocirc":"Ô","&Ocirc;":"Ô","&Otilde":"Õ","&Otilde;":"Õ","&Ouml":"Ö","&Ouml;":"Ö","&times":"×","&times;":"×","&Oslash":"Ø","&Oslash;":"Ø","&Ugrave":"Ù","&Ugrave;":"Ù","&Uacute":"Ú","&Uacute;":"Ú","&Ucirc":"Û","&Ucirc;":"Û","&Uuml":"Ü","&Uuml;":"Ü","&Yacute":"Ý","&Yacute;":"Ý","&THORN":"Þ","&THORN;":"Þ","&szlig":"ß","&szlig;":"ß","&agrave":"à","&agrave;":"à","&aacute":"á","&aacute;":"á","&acirc":"â","&acirc;":"â","&atilde":"ã","&atilde;":"ã","&auml":"ä","&auml;":"ä","&aring":"å","&aring;":"å","&aelig":"æ","&aelig;":"æ","&ccedil":"ç","&ccedil;":"ç","&egrave":"è","&egrave;":"è","&eacute":"é","&eacute;":"é","&ecirc":"ê","&ecirc;":"ê","&euml":"ë","&euml;":"ë","&igrave":"ì","&igrave;":"ì","&iacute":"í","&iacute;":"í","&icirc":"î","&icirc;":"î","&iuml":"ï","&iuml;":"ï","&eth":"ð","&eth;":"ð","&ntilde":"ñ","&ntilde;":"ñ","&ograve":"ò","&ograve;":"ò","&oacute":"ó","&oacute;":"ó","&ocirc":"ô","&ocirc;":"ô","&otilde":"õ","&otilde;":"õ","&ouml":"ö","&ouml;":"ö","&divide":"÷","&divide;":"÷","&oslash":"ø","&oslash;":"ø","&ugrave":"ù","&ugrave;":"ù","&uacute":"ú","&uacute;":"ú","&ucirc":"û","&ucirc;":"û","&uuml":"ü","&uuml;":"ü","&yacute":"ý","&yacute;":"ý","&thorn":"þ","&thorn;":"þ","&yuml":"ÿ","&yuml;":"ÿ","&quot":'"',"&quot;":'"',"&amp":"&","&amp;":"&","&lt":"<","&lt;":"<","&gt":">","&gt;":">","&OElig;":"Œ","&oelig;":"œ","&Scaron;":"Š","&scaron;":"š","&Yuml;":"Ÿ","&circ;":"ˆ","&tilde;":"˜","&ensp;":" ","&emsp;":" ","&thinsp;":" ","&zwnj;":"‌","&zwj;":"‍","&lrm;":"‎","&rlm;":"‏","&ndash;":"–","&mdash;":"—","&lsquo;":"‘","&rsquo;":"’","&sbquo;":"‚","&ldquo;":"“","&rdquo;":"”","&bdquo;":"„","&dagger;":"†","&Dagger;":"‡","&permil;":"‰","&lsaquo;":"‹","&rsaquo;":"›","&euro;":"€","&fnof;":"ƒ","&Alpha;":"Α","&Beta;":"Β","&Gamma;":"Γ","&Delta;":"Δ","&Epsilon;":"Ε","&Zeta;":"Ζ","&Eta;":"Η","&Theta;":"Θ","&Iota;":"Ι","&Kappa;":"Κ","&Lambda;":"Λ","&Mu;":"Μ","&Nu;":"Ν","&Xi;":"Ξ","&Omicron;":"Ο","&Pi;":"Π","&Rho;":"Ρ","&Sigma;":"Σ","&Tau;":"Τ","&Upsilon;":"Υ","&Phi;":"Φ","&Chi;":"Χ","&Psi;":"Ψ","&Omega;":"Ω","&alpha;":"α","&beta;":"β","&gamma;":"γ","&delta;":"δ","&epsilon;":"ε","&zeta;":"ζ","&eta;":"η","&theta;":"θ","&iota;":"ι","&kappa;":"κ","&lambda;":"λ","&mu;":"μ","&nu;":"ν","&xi;":"ξ","&omicron;":"ο","&pi;":"π","&rho;":"ρ","&sigmaf;":"ς","&sigma;":"σ","&tau;":"τ","&upsilon;":"υ","&phi;":"φ","&chi;":"χ","&psi;":"ψ","&omega;":"ω","&thetasym;":"ϑ","&upsih;":"ϒ","&piv;":"ϖ","&bull;":"•","&hellip;":"…","&prime;":"′","&Prime;":"″","&oline;":"‾","&frasl;":"⁄","&weierp;":"℘","&image;":"ℑ","&real;":"ℜ","&trade;":"™","&alefsym;":"ℵ","&larr;":"←","&uarr;":"↑","&rarr;":"→","&darr;":"↓","&harr;":"↔","&crarr;":"↵","&lArr;":"⇐","&uArr;":"⇑","&rArr;":"⇒","&dArr;":"⇓","&hArr;":"⇔","&forall;":"∀","&part;":"∂","&exist;":"∃","&empty;":"∅","&nabla;":"∇","&isin;":"∈","&notin;":"∉","&ni;":"∋","&prod;":"∏","&sum;":"∑","&minus;":"−","&lowast;":"∗","&radic;":"√","&prop;":"∝","&infin;":"∞","&ang;":"∠","&and;":"∧","&or;":"∨","&cap;":"∩","&cup;":"∪","&int;":"∫","&there4;":"∴","&sim;":"∼","&cong;":"≅","&asymp;":"≈","&ne;":"≠","&equiv;":"≡","&le;":"≤","&ge;":"≥","&sub;":"⊂","&sup;":"⊃","&nsub;":"⊄","&sube;":"⊆","&supe;":"⊇","&oplus;":"⊕","&otimes;":"⊗","&perp;":"⊥","&sdot;":"⋅","&lceil;":"⌈","&rceil;":"⌉","&lfloor;":"⌊","&rfloor;":"⌋","&lang;":"〈","&rang;":"〉","&loz;":"◊","&spades;":"♠","&clubs;":"♣","&hearts;":"♥","&diams;":"♦"},characters:{"'":"&apos;"," ":"&nbsp;","¡":"&iexcl;","¢":"&cent;","£":"&pound;","¤":"&curren;","¥":"&yen;","¦":"&brvbar;","§":"&sect;","¨":"&uml;","©":"&copy;","ª":"&ordf;","«":"&laquo;","¬":"&not;","­":"&shy;","®":"&reg;","¯":"&macr;","°":"&deg;","±":"&plusmn;","²":"&sup2;","³":"&sup3;","´":"&acute;","µ":"&micro;","¶":"&para;","·":"&middot;","¸":"&cedil;","¹":"&sup1;","º":"&ordm;","»":"&raquo;","¼":"&frac14;","½":"&frac12;","¾":"&frac34;","¿":"&iquest;","À":"&Agrave;","Á":"&Aacute;","Â":"&Acirc;","Ã":"&Atilde;","Ä":"&Auml;","Å":"&Aring;","Æ":"&AElig;","Ç":"&Ccedil;","È":"&Egrave;","É":"&Eacute;","Ê":"&Ecirc;","Ë":"&Euml;","Ì":"&Igrave;","Í":"&Iacute;","Î":"&Icirc;","Ï":"&Iuml;","Ð":"&ETH;","Ñ":"&Ntilde;","Ò":"&Ograve;","Ó":"&Oacute;","Ô":"&Ocirc;","Õ":"&Otilde;","Ö":"&Ouml;","×":"&times;","Ø":"&Oslash;","Ù":"&Ugrave;","Ú":"&Uacute;","Û":"&Ucirc;","Ü":"&Uuml;","Ý":"&Yacute;","Þ":"&THORN;","ß":"&szlig;","à":"&agrave;","á":"&aacute;","â":"&acirc;","ã":"&atilde;","ä":"&auml;","å":"&aring;","æ":"&aelig;","ç":"&ccedil;","è":"&egrave;","é":"&eacute;","ê":"&ecirc;","ë":"&euml;","ì":"&igrave;","í":"&iacute;","î":"&icirc;","ï":"&iuml;","ð":"&eth;","ñ":"&ntilde;","ò":"&ograve;","ó":"&oacute;","ô":"&ocirc;","õ":"&otilde;","ö":"&ouml;","÷":"&divide;","ø":"&oslash;","ù":"&ugrave;","ú":"&uacute;","û":"&ucirc;","ü":"&uuml;","ý":"&yacute;","þ":"&thorn;","ÿ":"&yuml;",'"':"&quot;","&":"&amp;","<":"&lt;",">":"&gt;","Œ":"&OElig;","œ":"&oelig;","Š":"&Scaron;","š":"&scaron;","Ÿ":"&Yuml;","ˆ":"&circ;","˜":"&tilde;"," ":"&ensp;"," ":"&emsp;"," ":"&thinsp;","‌":"&zwnj;","‍":"&zwj;","‎":"&lrm;","‏":"&rlm;","–":"&ndash;","—":"&mdash;","‘":"&lsquo;","’":"&rsquo;","‚":"&sbquo;","“":"&ldquo;","”":"&rdquo;","„":"&bdquo;","†":"&dagger;","‡":"&Dagger;","‰":"&permil;","‹":"&lsaquo;","›":"&rsaquo;","€":"&euro;","ƒ":"&fnof;","Α":"&Alpha;","Β":"&Beta;","Γ":"&Gamma;","Δ":"&Delta;","Ε":"&Epsilon;","Ζ":"&Zeta;","Η":"&Eta;","Θ":"&Theta;","Ι":"&Iota;","Κ":"&Kappa;","Λ":"&Lambda;","Μ":"&Mu;","Ν":"&Nu;","Ξ":"&Xi;","Ο":"&Omicron;","Π":"&Pi;","Ρ":"&Rho;","Σ":"&Sigma;","Τ":"&Tau;","Υ":"&Upsilon;","Φ":"&Phi;","Χ":"&Chi;","Ψ":"&Psi;","Ω":"&Omega;","α":"&alpha;","β":"&beta;","γ":"&gamma;","δ":"&delta;","ε":"&epsilon;","ζ":"&zeta;","η":"&eta;","θ":"&theta;","ι":"&iota;","κ":"&kappa;","λ":"&lambda;","μ":"&mu;","ν":"&nu;","ξ":"&xi;","ο":"&omicron;","π":"&pi;","ρ":"&rho;","ς":"&sigmaf;","σ":"&sigma;","τ":"&tau;","υ":"&upsilon;","φ":"&phi;","χ":"&chi;","ψ":"&psi;","ω":"&omega;","ϑ":"&thetasym;","ϒ":"&upsih;","ϖ":"&piv;","•":"&bull;","…":"&hellip;","′":"&prime;","″":"&Prime;","‾":"&oline;","⁄":"&frasl;","℘":"&weierp;","ℑ":"&image;","ℜ":"&real;","™":"&trade;","ℵ":"&alefsym;","←":"&larr;","↑":"&uarr;","→":"&rarr;","↓":"&darr;","↔":"&harr;","↵":"&crarr;","⇐":"&lArr;","⇑":"&uArr;","⇒":"&rArr;","⇓":"&dArr;","⇔":"&hArr;","∀":"&forall;","∂":"&part;","∃":"&exist;","∅":"&empty;","∇":"&nabla;","∈":"&isin;","∉":"&notin;","∋":"&ni;","∏":"&prod;","∑":"&sum;","−":"&minus;","∗":"&lowast;","√":"&radic;","∝":"&prop;","∞":"&infin;","∠":"&ang;","∧":"&and;","∨":"&or;","∩":"&cap;","∪":"&cup;","∫":"&int;","∴":"&there4;","∼":"&sim;","≅":"&cong;","≈":"&asymp;","≠":"&ne;","≡":"&equiv;","≤":"&le;","≥":"&ge;","⊂":"&sub;","⊃":"&sup;","⊄":"&nsub;","⊆":"&sube;","⊇":"&supe;","⊕":"&oplus;","⊗":"&otimes;","⊥":"&perp;","⋅":"&sdot;","⌈":"&lceil;","⌉":"&rceil;","⌊":"&lfloor;","⌋":"&rfloor;","〈":"&lang;","〉":"&rang;","◊":"&loz;","♠":"&spades;","♣":"&clubs;","♥":"&hearts;","♦":"&diams;"}},html5:{entities:{"&AElig":"Æ","&AElig;":"Æ","&AMP":"&","&AMP;":"&","&Aacute":"Á","&Aacute;":"Á","&Abreve;":"Ă","&Acirc":"Â","&Acirc;":"Â","&Acy;":"А","&Afr;":"𝔄","&Agrave":"À","&Agrave;":"À","&Alpha;":"Α","&Amacr;":"Ā","&And;":"⩓","&Aogon;":"Ą","&Aopf;":"𝔸","&ApplyFunction;":"⁡","&Aring":"Å","&Aring;":"Å","&Ascr;":"𝒜","&Assign;":"≔","&Atilde":"Ã","&Atilde;":"Ã","&Auml":"Ä","&Auml;":"Ä","&Backslash;":"∖","&Barv;":"⫧","&Barwed;":"⌆","&Bcy;":"Б","&Because;":"∵","&Bernoullis;":"ℬ","&Beta;":"Β","&Bfr;":"𝔅","&Bopf;":"𝔹","&Breve;":"˘","&Bscr;":"ℬ","&Bumpeq;":"≎","&CHcy;":"Ч","&COPY":"©","&COPY;":"©","&Cacute;":"Ć","&Cap;":"⋒","&CapitalDifferentialD;":"ⅅ","&Cayleys;":"ℭ","&Ccaron;":"Č","&Ccedil":"Ç","&Ccedil;":"Ç","&Ccirc;":"Ĉ","&Cconint;":"∰","&Cdot;":"Ċ","&Cedilla;":"¸","&CenterDot;":"·","&Cfr;":"ℭ","&Chi;":"Χ","&CircleDot;":"⊙","&CircleMinus;":"⊖","&CirclePlus;":"⊕","&CircleTimes;":"⊗","&ClockwiseContourIntegral;":"∲","&CloseCurlyDoubleQuote;":"”","&CloseCurlyQuote;":"’","&Colon;":"∷","&Colone;":"⩴","&Congruent;":"≡","&Conint;":"∯","&ContourIntegral;":"∮","&Copf;":"ℂ","&Coproduct;":"∐","&CounterClockwiseContourIntegral;":"∳","&Cross;":"⨯","&Cscr;":"𝒞","&Cup;":"⋓","&CupCap;":"≍","&DD;":"ⅅ","&DDotrahd;":"⤑","&DJcy;":"Ђ","&DScy;":"Ѕ","&DZcy;":"Џ","&Dagger;":"‡","&Darr;":"↡","&Dashv;":"⫤","&Dcaron;":"Ď","&Dcy;":"Д","&Del;":"∇","&Delta;":"Δ","&Dfr;":"𝔇","&DiacriticalAcute;":"´","&DiacriticalDot;":"˙","&DiacriticalDoubleAcute;":"˝","&DiacriticalGrave;":"`","&DiacriticalTilde;":"˜","&Diamond;":"⋄","&DifferentialD;":"ⅆ","&Dopf;":"𝔻","&Dot;":"¨","&DotDot;":"⃜","&DotEqual;":"≐","&DoubleContourIntegral;":"∯","&DoubleDot;":"¨","&DoubleDownArrow;":"⇓","&DoubleLeftArrow;":"⇐","&DoubleLeftRightArrow;":"⇔","&DoubleLeftTee;":"⫤","&DoubleLongLeftArrow;":"⟸","&DoubleLongLeftRightArrow;":"⟺","&DoubleLongRightArrow;":"⟹","&DoubleRightArrow;":"⇒","&DoubleRightTee;":"⊨","&DoubleUpArrow;":"⇑","&DoubleUpDownArrow;":"⇕","&DoubleVerticalBar;":"∥","&DownArrow;":"↓","&DownArrowBar;":"⤓","&DownArrowUpArrow;":"⇵","&DownBreve;":"̑","&DownLeftRightVector;":"⥐","&DownLeftTeeVector;":"⥞","&DownLeftVector;":"↽","&DownLeftVectorBar;":"⥖","&DownRightTeeVector;":"⥟","&DownRightVector;":"⇁","&DownRightVectorBar;":"⥗","&DownTee;":"⊤","&DownTeeArrow;":"↧","&Downarrow;":"⇓","&Dscr;":"𝒟","&Dstrok;":"Đ","&ENG;":"Ŋ","&ETH":"Ð","&ETH;":"Ð","&Eacute":"É","&Eacute;":"É","&Ecaron;":"Ě","&Ecirc":"Ê","&Ecirc;":"Ê","&Ecy;":"Э","&Edot;":"Ė","&Efr;":"𝔈","&Egrave":"È","&Egrave;":"È","&Element;":"∈","&Emacr;":"Ē","&EmptySmallSquare;":"◻","&EmptyVerySmallSquare;":"▫","&Eogon;":"Ę","&Eopf;":"𝔼","&Epsilon;":"Ε","&Equal;":"⩵","&EqualTilde;":"≂","&Equilibrium;":"⇌","&Escr;":"ℰ","&Esim;":"⩳","&Eta;":"Η","&Euml":"Ë","&Euml;":"Ë","&Exists;":"∃","&ExponentialE;":"ⅇ","&Fcy;":"Ф","&Ffr;":"𝔉","&FilledSmallSquare;":"◼","&FilledVerySmallSquare;":"▪","&Fopf;":"𝔽","&ForAll;":"∀","&Fouriertrf;":"ℱ","&Fscr;":"ℱ","&GJcy;":"Ѓ","&GT":">","&GT;":">","&Gamma;":"Γ","&Gammad;":"Ϝ","&Gbreve;":"Ğ","&Gcedil;":"Ģ","&Gcirc;":"Ĝ","&Gcy;":"Г","&Gdot;":"Ġ","&Gfr;":"𝔊","&Gg;":"⋙","&Gopf;":"𝔾","&GreaterEqual;":"≥","&GreaterEqualLess;":"⋛","&GreaterFullEqual;":"≧","&GreaterGreater;":"⪢","&GreaterLess;":"≷","&GreaterSlantEqual;":"⩾","&GreaterTilde;":"≳","&Gscr;":"𝒢","&Gt;":"≫","&HARDcy;":"Ъ","&Hacek;":"ˇ","&Hat;":"^","&Hcirc;":"Ĥ","&Hfr;":"ℌ","&HilbertSpace;":"ℋ","&Hopf;":"ℍ","&HorizontalLine;":"─","&Hscr;":"ℋ","&Hstrok;":"Ħ","&HumpDownHump;":"≎","&HumpEqual;":"≏","&IEcy;":"Е","&IJlig;":"Ĳ","&IOcy;":"Ё","&Iacute":"Í","&Iacute;":"Í","&Icirc":"Î","&Icirc;":"Î","&Icy;":"И","&Idot;":"İ","&Ifr;":"ℑ","&Igrave":"Ì","&Igrave;":"Ì","&Im;":"ℑ","&Imacr;":"Ī","&ImaginaryI;":"ⅈ","&Implies;":"⇒","&Int;":"∬","&Integral;":"∫","&Intersection;":"⋂","&InvisibleComma;":"⁣","&InvisibleTimes;":"⁢","&Iogon;":"Į","&Iopf;":"𝕀","&Iota;":"Ι","&Iscr;":"ℐ","&Itilde;":"Ĩ","&Iukcy;":"І","&Iuml":"Ï","&Iuml;":"Ï","&Jcirc;":"Ĵ","&Jcy;":"Й","&Jfr;":"𝔍","&Jopf;":"𝕁","&Jscr;":"𝒥","&Jsercy;":"Ј","&Jukcy;":"Є","&KHcy;":"Х","&KJcy;":"Ќ","&Kappa;":"Κ","&Kcedil;":"Ķ","&Kcy;":"К","&Kfr;":"𝔎","&Kopf;":"𝕂","&Kscr;":"𝒦","&LJcy;":"Љ","&LT":"<","&LT;":"<","&Lacute;":"Ĺ","&Lambda;":"Λ","&Lang;":"⟪","&Laplacetrf;":"ℒ","&Larr;":"↞","&Lcaron;":"Ľ","&Lcedil;":"Ļ","&Lcy;":"Л","&LeftAngleBracket;":"⟨","&LeftArrow;":"←","&LeftArrowBar;":"⇤","&LeftArrowRightArrow;":"⇆","&LeftCeiling;":"⌈","&LeftDoubleBracket;":"⟦","&LeftDownTeeVector;":"⥡","&LeftDownVector;":"⇃","&LeftDownVectorBar;":"⥙","&LeftFloor;":"⌊","&LeftRightArrow;":"↔","&LeftRightVector;":"⥎","&LeftTee;":"⊣","&LeftTeeArrow;":"↤","&LeftTeeVector;":"⥚","&LeftTriangle;":"⊲","&LeftTriangleBar;":"⧏","&LeftTriangleEqual;":"⊴","&LeftUpDownVector;":"⥑","&LeftUpTeeVector;":"⥠","&LeftUpVector;":"↿","&LeftUpVectorBar;":"⥘","&LeftVector;":"↼","&LeftVectorBar;":"⥒","&Leftarrow;":"⇐","&Leftrightarrow;":"⇔","&LessEqualGreater;":"⋚","&LessFullEqual;":"≦","&LessGreater;":"≶","&LessLess;":"⪡","&LessSlantEqual;":"⩽","&LessTilde;":"≲","&Lfr;":"𝔏","&Ll;":"⋘","&Lleftarrow;":"⇚","&Lmidot;":"Ŀ","&LongLeftArrow;":"⟵","&LongLeftRightArrow;":"⟷","&LongRightArrow;":"⟶","&Longleftarrow;":"⟸","&Longleftrightarrow;":"⟺","&Longrightarrow;":"⟹","&Lopf;":"𝕃","&LowerLeftArrow;":"↙","&LowerRightArrow;":"↘","&Lscr;":"ℒ","&Lsh;":"↰","&Lstrok;":"Ł","&Lt;":"≪","&Map;":"⤅","&Mcy;":"М","&MediumSpace;":" ","&Mellintrf;":"ℳ","&Mfr;":"𝔐","&MinusPlus;":"∓","&Mopf;":"𝕄","&Mscr;":"ℳ","&Mu;":"Μ","&NJcy;":"Њ","&Nacute;":"Ń","&Ncaron;":"Ň","&Ncedil;":"Ņ","&Ncy;":"Н","&NegativeMediumSpace;":"​","&NegativeThickSpace;":"​","&NegativeThinSpace;":"​","&NegativeVeryThinSpace;":"​","&NestedGreaterGreater;":"≫","&NestedLessLess;":"≪","&NewLine;":"\n","&Nfr;":"𝔑","&NoBreak;":"⁠","&NonBreakingSpace;":" ","&Nopf;":"ℕ","&Not;":"⫬","&NotCongruent;":"≢","&NotCupCap;":"≭","&NotDoubleVerticalBar;":"∦","&NotElement;":"∉","&NotEqual;":"≠","&NotEqualTilde;":"≂̸","&NotExists;":"∄","&NotGreater;":"≯","&NotGreaterEqual;":"≱","&NotGreaterFullEqual;":"≧̸","&NotGreaterGreater;":"≫̸","&NotGreaterLess;":"≹","&NotGreaterSlantEqual;":"⩾̸","&NotGreaterTilde;":"≵","&NotHumpDownHump;":"≎̸","&NotHumpEqual;":"≏̸","&NotLeftTriangle;":"⋪","&NotLeftTriangleBar;":"⧏̸","&NotLeftTriangleEqual;":"⋬","&NotLess;":"≮","&NotLessEqual;":"≰","&NotLessGreater;":"≸","&NotLessLess;":"≪̸","&NotLessSlantEqual;":"⩽̸","&NotLessTilde;":"≴","&NotNestedGreaterGreater;":"⪢̸","&NotNestedLessLess;":"⪡̸","&NotPrecedes;":"⊀","&NotPrecedesEqual;":"⪯̸","&NotPrecedesSlantEqual;":"⋠","&NotReverseElement;":"∌","&NotRightTriangle;":"⋫","&NotRightTriangleBar;":"⧐̸","&NotRightTriangleEqual;":"⋭","&NotSquareSubset;":"⊏̸","&NotSquareSubsetEqual;":"⋢","&NotSquareSuperset;":"⊐̸","&NotSquareSupersetEqual;":"⋣","&NotSubset;":"⊂⃒","&NotSubsetEqual;":"⊈","&NotSucceeds;":"⊁","&NotSucceedsEqual;":"⪰̸","&NotSucceedsSlantEqual;":"⋡","&NotSucceedsTilde;":"≿̸","&NotSuperset;":"⊃⃒","&NotSupersetEqual;":"⊉","&NotTilde;":"≁","&NotTildeEqual;":"≄","&NotTildeFullEqual;":"≇","&NotTildeTilde;":"≉","&NotVerticalBar;":"∤","&Nscr;":"𝒩","&Ntilde":"Ñ","&Ntilde;":"Ñ","&Nu;":"Ν","&OElig;":"Œ","&Oacute":"Ó","&Oacute;":"Ó","&Ocirc":"Ô","&Ocirc;":"Ô","&Ocy;":"О","&Odblac;":"Ő","&Ofr;":"𝔒","&Ograve":"Ò","&Ograve;":"Ò","&Omacr;":"Ō","&Omega;":"Ω","&Omicron;":"Ο","&Oopf;":"𝕆","&OpenCurlyDoubleQuote;":"“","&OpenCurlyQuote;":"‘","&Or;":"⩔","&Oscr;":"𝒪","&Oslash":"Ø","&Oslash;":"Ø","&Otilde":"Õ","&Otilde;":"Õ","&Otimes;":"⨷","&Ouml":"Ö","&Ouml;":"Ö","&OverBar;":"‾","&OverBrace;":"⏞","&OverBracket;":"⎴","&OverParenthesis;":"⏜","&PartialD;":"∂","&Pcy;":"П","&Pfr;":"𝔓","&Phi;":"Φ","&Pi;":"Π","&PlusMinus;":"±","&Poincareplane;":"ℌ","&Popf;":"ℙ","&Pr;":"⪻","&Precedes;":"≺","&PrecedesEqual;":"⪯","&PrecedesSlantEqual;":"≼","&PrecedesTilde;":"≾","&Prime;":"″","&Product;":"∏","&Proportion;":"∷","&Proportional;":"∝","&Pscr;":"𝒫","&Psi;":"Ψ","&QUOT":'"',"&QUOT;":'"',"&Qfr;":"𝔔","&Qopf;":"ℚ","&Qscr;":"𝒬","&RBarr;":"⤐","&REG":"®","&REG;":"®","&Racute;":"Ŕ","&Rang;":"⟫","&Rarr;":"↠","&Rarrtl;":"⤖","&Rcaron;":"Ř","&Rcedil;":"Ŗ","&Rcy;":"Р","&Re;":"ℜ","&ReverseElement;":"∋","&ReverseEquilibrium;":"⇋","&ReverseUpEquilibrium;":"⥯","&Rfr;":"ℜ","&Rho;":"Ρ","&RightAngleBracket;":"⟩","&RightArrow;":"→","&RightArrowBar;":"⇥","&RightArrowLeftArrow;":"⇄","&RightCeiling;":"⌉","&RightDoubleBracket;":"⟧","&RightDownTeeVector;":"⥝","&RightDownVector;":"⇂","&RightDownVectorBar;":"⥕","&RightFloor;":"⌋","&RightTee;":"⊢","&RightTeeArrow;":"↦","&RightTeeVector;":"⥛","&RightTriangle;":"⊳","&RightTriangleBar;":"⧐","&RightTriangleEqual;":"⊵","&RightUpDownVector;":"⥏","&RightUpTeeVector;":"⥜","&RightUpVector;":"↾","&RightUpVectorBar;":"⥔","&RightVector;":"⇀","&RightVectorBar;":"⥓","&Rightarrow;":"⇒","&Ropf;":"ℝ","&RoundImplies;":"⥰","&Rrightarrow;":"⇛","&Rscr;":"ℛ","&Rsh;":"↱","&RuleDelayed;":"⧴","&SHCHcy;":"Щ","&SHcy;":"Ш","&SOFTcy;":"Ь","&Sacute;":"Ś","&Sc;":"⪼","&Scaron;":"Š","&Scedil;":"Ş","&Scirc;":"Ŝ","&Scy;":"С","&Sfr;":"𝔖","&ShortDownArrow;":"↓","&ShortLeftArrow;":"←","&ShortRightArrow;":"→","&ShortUpArrow;":"↑","&Sigma;":"Σ","&SmallCircle;":"∘","&Sopf;":"𝕊","&Sqrt;":"√","&Square;":"□","&SquareIntersection;":"⊓","&SquareSubset;":"⊏","&SquareSubsetEqual;":"⊑","&SquareSuperset;":"⊐","&SquareSupersetEqual;":"⊒","&SquareUnion;":"⊔","&Sscr;":"𝒮","&Star;":"⋆","&Sub;":"⋐","&Subset;":"⋐","&SubsetEqual;":"⊆","&Succeeds;":"≻","&SucceedsEqual;":"⪰","&SucceedsSlantEqual;":"≽","&SucceedsTilde;":"≿","&SuchThat;":"∋","&Sum;":"∑","&Sup;":"⋑","&Superset;":"⊃","&SupersetEqual;":"⊇","&Supset;":"⋑","&THORN":"Þ","&THORN;":"Þ","&TRADE;":"™","&TSHcy;":"Ћ","&TScy;":"Ц","&Tab;":"\t","&Tau;":"Τ","&Tcaron;":"Ť","&Tcedil;":"Ţ","&Tcy;":"Т","&Tfr;":"𝔗","&Therefore;":"∴","&Theta;":"Θ","&ThickSpace;":"  ","&ThinSpace;":" ","&Tilde;":"∼","&TildeEqual;":"≃","&TildeFullEqual;":"≅","&TildeTilde;":"≈","&Topf;":"𝕋","&TripleDot;":"⃛","&Tscr;":"𝒯","&Tstrok;":"Ŧ","&Uacute":"Ú","&Uacute;":"Ú","&Uarr;":"↟","&Uarrocir;":"⥉","&Ubrcy;":"Ў","&Ubreve;":"Ŭ","&Ucirc":"Û","&Ucirc;":"Û","&Ucy;":"У","&Udblac;":"Ű","&Ufr;":"𝔘","&Ugrave":"Ù","&Ugrave;":"Ù","&Umacr;":"Ū","&UnderBar;":"_","&UnderBrace;":"⏟","&UnderBracket;":"⎵","&UnderParenthesis;":"⏝","&Union;":"⋃","&UnionPlus;":"⊎","&Uogon;":"Ų","&Uopf;":"𝕌","&UpArrow;":"↑","&UpArrowBar;":"⤒","&UpArrowDownArrow;":"⇅","&UpDownArrow;":"↕","&UpEquilibrium;":"⥮","&UpTee;":"⊥","&UpTeeArrow;":"↥","&Uparrow;":"⇑","&Updownarrow;":"⇕","&UpperLeftArrow;":"↖","&UpperRightArrow;":"↗","&Upsi;":"ϒ","&Upsilon;":"Υ","&Uring;":"Ů","&Uscr;":"𝒰","&Utilde;":"Ũ","&Uuml":"Ü","&Uuml;":"Ü","&VDash;":"⊫","&Vbar;":"⫫","&Vcy;":"В","&Vdash;":"⊩","&Vdashl;":"⫦","&Vee;":"⋁","&Verbar;":"‖","&Vert;":"‖","&VerticalBar;":"∣","&VerticalLine;":"|","&VerticalSeparator;":"❘","&VerticalTilde;":"≀","&VeryThinSpace;":" ","&Vfr;":"𝔙","&Vopf;":"𝕍","&Vscr;":"𝒱","&Vvdash;":"⊪","&Wcirc;":"Ŵ","&Wedge;":"⋀","&Wfr;":"𝔚","&Wopf;":"𝕎","&Wscr;":"𝒲","&Xfr;":"𝔛","&Xi;":"Ξ","&Xopf;":"𝕏","&Xscr;":"𝒳","&YAcy;":"Я","&YIcy;":"Ї","&YUcy;":"Ю","&Yacute":"Ý","&Yacute;":"Ý","&Ycirc;":"Ŷ","&Ycy;":"Ы","&Yfr;":"𝔜","&Yopf;":"𝕐","&Yscr;":"𝒴","&Yuml;":"Ÿ","&ZHcy;":"Ж","&Zacute;":"Ź","&Zcaron;":"Ž","&Zcy;":"З","&Zdot;":"Ż","&ZeroWidthSpace;":"​","&Zeta;":"Ζ","&Zfr;":"ℨ","&Zopf;":"ℤ","&Zscr;":"𝒵","&aacute":"á","&aacute;":"á","&abreve;":"ă","&ac;":"∾","&acE;":"∾̳","&acd;":"∿","&acirc":"â","&acirc;":"â","&acute":"´","&acute;":"´","&acy;":"а","&aelig":"æ","&aelig;":"æ","&af;":"⁡","&afr;":"𝔞","&agrave":"à","&agrave;":"à","&alefsym;":"ℵ","&aleph;":"ℵ","&alpha;":"α","&amacr;":"ā","&amalg;":"⨿","&amp":"&","&amp;":"&","&and;":"∧","&andand;":"⩕","&andd;":"⩜","&andslope;":"⩘","&andv;":"⩚","&ang;":"∠","&ange;":"⦤","&angle;":"∠","&angmsd;":"∡","&angmsdaa;":"⦨","&angmsdab;":"⦩","&angmsdac;":"⦪","&angmsdad;":"⦫","&angmsdae;":"⦬","&angmsdaf;":"⦭","&angmsdag;":"⦮","&angmsdah;":"⦯","&angrt;":"∟","&angrtvb;":"⊾","&angrtvbd;":"⦝","&angsph;":"∢","&angst;":"Å","&angzarr;":"⍼","&aogon;":"ą","&aopf;":"𝕒","&ap;":"≈","&apE;":"⩰","&apacir;":"⩯","&ape;":"≊","&apid;":"≋","&apos;":"'","&approx;":"≈","&approxeq;":"≊","&aring":"å","&aring;":"å","&ascr;":"𝒶","&ast;":"*","&asymp;":"≈","&asympeq;":"≍","&atilde":"ã","&atilde;":"ã","&auml":"ä","&auml;":"ä","&awconint;":"∳","&awint;":"⨑","&bNot;":"⫭","&backcong;":"≌","&backepsilon;":"϶","&backprime;":"‵","&backsim;":"∽","&backsimeq;":"⋍","&barvee;":"⊽","&barwed;":"⌅","&barwedge;":"⌅","&bbrk;":"⎵","&bbrktbrk;":"⎶","&bcong;":"≌","&bcy;":"б","&bdquo;":"„","&becaus;":"∵","&because;":"∵","&bemptyv;":"⦰","&bepsi;":"϶","&bernou;":"ℬ","&beta;":"β","&beth;":"ℶ","&between;":"≬","&bfr;":"𝔟","&bigcap;":"⋂","&bigcirc;":"◯","&bigcup;":"⋃","&bigodot;":"⨀","&bigoplus;":"⨁","&bigotimes;":"⨂","&bigsqcup;":"⨆","&bigstar;":"★","&bigtriangledown;":"▽","&bigtriangleup;":"△","&biguplus;":"⨄","&bigvee;":"⋁","&bigwedge;":"⋀","&bkarow;":"⤍","&blacklozenge;":"⧫","&blacksquare;":"▪","&blacktriangle;":"▴","&blacktriangledown;":"▾","&blacktriangleleft;":"◂","&blacktriangleright;":"▸","&blank;":"␣","&blk12;":"▒","&blk14;":"░","&blk34;":"▓","&block;":"█","&bne;":"=⃥","&bnequiv;":"≡⃥","&bnot;":"⌐","&bopf;":"𝕓","&bot;":"⊥","&bottom;":"⊥","&bowtie;":"⋈","&boxDL;":"╗","&boxDR;":"╔","&boxDl;":"╖","&boxDr;":"╓","&boxH;":"═","&boxHD;":"╦","&boxHU;":"╩","&boxHd;":"╤","&boxHu;":"╧","&boxUL;":"╝","&boxUR;":"╚","&boxUl;":"╜","&boxUr;":"╙","&boxV;":"║","&boxVH;":"╬","&boxVL;":"╣","&boxVR;":"╠","&boxVh;":"╫","&boxVl;":"╢","&boxVr;":"╟","&boxbox;":"⧉","&boxdL;":"╕","&boxdR;":"╒","&boxdl;":"┐","&boxdr;":"┌","&boxh;":"─","&boxhD;":"╥","&boxhU;":"╨","&boxhd;":"┬","&boxhu;":"┴","&boxminus;":"⊟","&boxplus;":"⊞","&boxtimes;":"⊠","&boxuL;":"╛","&boxuR;":"╘","&boxul;":"┘","&boxur;":"└","&boxv;":"│","&boxvH;":"╪","&boxvL;":"╡","&boxvR;":"╞","&boxvh;":"┼","&boxvl;":"┤","&boxvr;":"├","&bprime;":"‵","&breve;":"˘","&brvbar":"¦","&brvbar;":"¦","&bscr;":"𝒷","&bsemi;":"⁏","&bsim;":"∽","&bsime;":"⋍","&bsol;":"\\","&bsolb;":"⧅","&bsolhsub;":"⟈","&bull;":"•","&bullet;":"•","&bump;":"≎","&bumpE;":"⪮","&bumpe;":"≏","&bumpeq;":"≏","&cacute;":"ć","&cap;":"∩","&capand;":"⩄","&capbrcup;":"⩉","&capcap;":"⩋","&capcup;":"⩇","&capdot;":"⩀","&caps;":"∩︀","&caret;":"⁁","&caron;":"ˇ","&ccaps;":"⩍","&ccaron;":"č","&ccedil":"ç","&ccedil;":"ç","&ccirc;":"ĉ","&ccups;":"⩌","&ccupssm;":"⩐","&cdot;":"ċ","&cedil":"¸","&cedil;":"¸","&cemptyv;":"⦲","&cent":"¢","&cent;":"¢","&centerdot;":"·","&cfr;":"𝔠","&chcy;":"ч","&check;":"✓","&checkmark;":"✓","&chi;":"χ","&cir;":"○","&cirE;":"⧃","&circ;":"ˆ","&circeq;":"≗","&circlearrowleft;":"↺","&circlearrowright;":"↻","&circledR;":"®","&circledS;":"Ⓢ","&circledast;":"⊛","&circledcirc;":"⊚","&circleddash;":"⊝","&cire;":"≗","&cirfnint;":"⨐","&cirmid;":"⫯","&cirscir;":"⧂","&clubs;":"♣","&clubsuit;":"♣","&colon;":":","&colone;":"≔","&coloneq;":"≔","&comma;":",","&commat;":"@","&comp;":"∁","&compfn;":"∘","&complement;":"∁","&complexes;":"ℂ","&cong;":"≅","&congdot;":"⩭","&conint;":"∮","&copf;":"𝕔","&coprod;":"∐","&copy":"©","&copy;":"©","&copysr;":"℗","&crarr;":"↵","&cross;":"✗","&cscr;":"𝒸","&csub;":"⫏","&csube;":"⫑","&csup;":"⫐","&csupe;":"⫒","&ctdot;":"⋯","&cudarrl;":"⤸","&cudarrr;":"⤵","&cuepr;":"⋞","&cuesc;":"⋟","&cularr;":"↶","&cularrp;":"⤽","&cup;":"∪","&cupbrcap;":"⩈","&cupcap;":"⩆","&cupcup;":"⩊","&cupdot;":"⊍","&cupor;":"⩅","&cups;":"∪︀","&curarr;":"↷","&curarrm;":"⤼","&curlyeqprec;":"⋞","&curlyeqsucc;":"⋟","&curlyvee;":"⋎","&curlywedge;":"⋏","&curren":"¤","&curren;":"¤","&curvearrowleft;":"↶","&curvearrowright;":"↷","&cuvee;":"⋎","&cuwed;":"⋏","&cwconint;":"∲","&cwint;":"∱","&cylcty;":"⌭","&dArr;":"⇓","&dHar;":"⥥","&dagger;":"†","&daleth;":"ℸ","&darr;":"↓","&dash;":"‐","&dashv;":"⊣","&dbkarow;":"⤏","&dblac;":"˝","&dcaron;":"ď","&dcy;":"д","&dd;":"ⅆ","&ddagger;":"‡","&ddarr;":"⇊","&ddotseq;":"⩷","&deg":"°","&deg;":"°","&delta;":"δ","&demptyv;":"⦱","&dfisht;":"⥿","&dfr;":"𝔡","&dharl;":"⇃","&dharr;":"⇂","&diam;":"⋄","&diamond;":"⋄","&diamondsuit;":"♦","&diams;":"♦","&die;":"¨","&digamma;":"ϝ","&disin;":"⋲","&div;":"÷","&divide":"÷","&divide;":"÷","&divideontimes;":"⋇","&divonx;":"⋇","&djcy;":"ђ","&dlcorn;":"⌞","&dlcrop;":"⌍","&dollar;":"$","&dopf;":"𝕕","&dot;":"˙","&doteq;":"≐","&doteqdot;":"≑","&dotminus;":"∸","&dotplus;":"∔","&dotsquare;":"⊡","&doublebarwedge;":"⌆","&downarrow;":"↓","&downdownarrows;":"⇊","&downharpoonleft;":"⇃","&downharpoonright;":"⇂","&drbkarow;":"⤐","&drcorn;":"⌟","&drcrop;":"⌌","&dscr;":"𝒹","&dscy;":"ѕ","&dsol;":"⧶","&dstrok;":"đ","&dtdot;":"⋱","&dtri;":"▿","&dtrif;":"▾","&duarr;":"⇵","&duhar;":"⥯","&dwangle;":"⦦","&dzcy;":"џ","&dzigrarr;":"⟿","&eDDot;":"⩷","&eDot;":"≑","&eacute":"é","&eacute;":"é","&easter;":"⩮","&ecaron;":"ě","&ecir;":"≖","&ecirc":"ê","&ecirc;":"ê","&ecolon;":"≕","&ecy;":"э","&edot;":"ė","&ee;":"ⅇ","&efDot;":"≒","&efr;":"𝔢","&eg;":"⪚","&egrave":"è","&egrave;":"è","&egs;":"⪖","&egsdot;":"⪘","&el;":"⪙","&elinters;":"⏧","&ell;":"ℓ","&els;":"⪕","&elsdot;":"⪗","&emacr;":"ē","&empty;":"∅","&emptyset;":"∅","&emptyv;":"∅","&emsp13;":" ","&emsp14;":" ","&emsp;":" ","&eng;":"ŋ","&ensp;":" ","&eogon;":"ę","&eopf;":"𝕖","&epar;":"⋕","&eparsl;":"⧣","&eplus;":"⩱","&epsi;":"ε","&epsilon;":"ε","&epsiv;":"ϵ","&eqcirc;":"≖","&eqcolon;":"≕","&eqsim;":"≂","&eqslantgtr;":"⪖","&eqslantless;":"⪕","&equals;":"=","&equest;":"≟","&equiv;":"≡","&equivDD;":"⩸","&eqvparsl;":"⧥","&erDot;":"≓","&erarr;":"⥱","&escr;":"ℯ","&esdot;":"≐","&esim;":"≂","&eta;":"η","&eth":"ð","&eth;":"ð","&euml":"ë","&euml;":"ë","&euro;":"€","&excl;":"!","&exist;":"∃","&expectation;":"ℰ","&exponentiale;":"ⅇ","&fallingdotseq;":"≒","&fcy;":"ф","&female;":"♀","&ffilig;":"ﬃ","&fflig;":"ﬀ","&ffllig;":"ﬄ","&ffr;":"𝔣","&filig;":"ﬁ","&fjlig;":"fj","&flat;":"♭","&fllig;":"ﬂ","&fltns;":"▱","&fnof;":"ƒ","&fopf;":"𝕗","&forall;":"∀","&fork;":"⋔","&forkv;":"⫙","&fpartint;":"⨍","&frac12":"½","&frac12;":"½","&frac13;":"⅓","&frac14":"¼","&frac14;":"¼","&frac15;":"⅕","&frac16;":"⅙","&frac18;":"⅛","&frac23;":"⅔","&frac25;":"⅖","&frac34":"¾","&frac34;":"¾","&frac35;":"⅗","&frac38;":"⅜","&frac45;":"⅘","&frac56;":"⅚","&frac58;":"⅝","&frac78;":"⅞","&frasl;":"⁄","&frown;":"⌢","&fscr;":"𝒻","&gE;":"≧","&gEl;":"⪌","&gacute;":"ǵ","&gamma;":"γ","&gammad;":"ϝ","&gap;":"⪆","&gbreve;":"ğ","&gcirc;":"ĝ","&gcy;":"г","&gdot;":"ġ","&ge;":"≥","&gel;":"⋛","&geq;":"≥","&geqq;":"≧","&geqslant;":"⩾","&ges;":"⩾","&gescc;":"⪩","&gesdot;":"⪀","&gesdoto;":"⪂","&gesdotol;":"⪄","&gesl;":"⋛︀","&gesles;":"⪔","&gfr;":"𝔤","&gg;":"≫","&ggg;":"⋙","&gimel;":"ℷ","&gjcy;":"ѓ","&gl;":"≷","&glE;":"⪒","&gla;":"⪥","&glj;":"⪤","&gnE;":"≩","&gnap;":"⪊","&gnapprox;":"⪊","&gne;":"⪈","&gneq;":"⪈","&gneqq;":"≩","&gnsim;":"⋧","&gopf;":"𝕘","&grave;":"`","&gscr;":"ℊ","&gsim;":"≳","&gsime;":"⪎","&gsiml;":"⪐","&gt":">","&gt;":">","&gtcc;":"⪧","&gtcir;":"⩺","&gtdot;":"⋗","&gtlPar;":"⦕","&gtquest;":"⩼","&gtrapprox;":"⪆","&gtrarr;":"⥸","&gtrdot;":"⋗","&gtreqless;":"⋛","&gtreqqless;":"⪌","&gtrless;":"≷","&gtrsim;":"≳","&gvertneqq;":"≩︀","&gvnE;":"≩︀","&hArr;":"⇔","&hairsp;":" ","&half;":"½","&hamilt;":"ℋ","&hardcy;":"ъ","&harr;":"↔","&harrcir;":"⥈","&harrw;":"↭","&hbar;":"ℏ","&hcirc;":"ĥ","&hearts;":"♥","&heartsuit;":"♥","&hellip;":"…","&hercon;":"⊹","&hfr;":"𝔥","&hksearow;":"⤥","&hkswarow;":"⤦","&hoarr;":"⇿","&homtht;":"∻","&hookleftarrow;":"↩","&hookrightarrow;":"↪","&hopf;":"𝕙","&horbar;":"―","&hscr;":"𝒽","&hslash;":"ℏ","&hstrok;":"ħ","&hybull;":"⁃","&hyphen;":"‐","&iacute":"í","&iacute;":"í","&ic;":"⁣","&icirc":"î","&icirc;":"î","&icy;":"и","&iecy;":"е","&iexcl":"¡","&iexcl;":"¡","&iff;":"⇔","&ifr;":"𝔦","&igrave":"ì","&igrave;":"ì","&ii;":"ⅈ","&iiiint;":"⨌","&iiint;":"∭","&iinfin;":"⧜","&iiota;":"℩","&ijlig;":"ĳ","&imacr;":"ī","&image;":"ℑ","&imagline;":"ℐ","&imagpart;":"ℑ","&imath;":"ı","&imof;":"⊷","&imped;":"Ƶ","&in;":"∈","&incare;":"℅","&infin;":"∞","&infintie;":"⧝","&inodot;":"ı","&int;":"∫","&intcal;":"⊺","&integers;":"ℤ","&intercal;":"⊺","&intlarhk;":"⨗","&intprod;":"⨼","&iocy;":"ё","&iogon;":"į","&iopf;":"𝕚","&iota;":"ι","&iprod;":"⨼","&iquest":"¿","&iquest;":"¿","&iscr;":"𝒾","&isin;":"∈","&isinE;":"⋹","&isindot;":"⋵","&isins;":"⋴","&isinsv;":"⋳","&isinv;":"∈","&it;":"⁢","&itilde;":"ĩ","&iukcy;":"і","&iuml":"ï","&iuml;":"ï","&jcirc;":"ĵ","&jcy;":"й","&jfr;":"𝔧","&jmath;":"ȷ","&jopf;":"𝕛","&jscr;":"𝒿","&jsercy;":"ј","&jukcy;":"є","&kappa;":"κ","&kappav;":"ϰ","&kcedil;":"ķ","&kcy;":"к","&kfr;":"𝔨","&kgreen;":"ĸ","&khcy;":"х","&kjcy;":"ќ","&kopf;":"𝕜","&kscr;":"𝓀","&lAarr;":"⇚","&lArr;":"⇐","&lAtail;":"⤛","&lBarr;":"⤎","&lE;":"≦","&lEg;":"⪋","&lHar;":"⥢","&lacute;":"ĺ","&laemptyv;":"⦴","&lagran;":"ℒ","&lambda;":"λ","&lang;":"⟨","&langd;":"⦑","&langle;":"⟨","&lap;":"⪅","&laquo":"«","&laquo;":"«","&larr;":"←","&larrb;":"⇤","&larrbfs;":"⤟","&larrfs;":"⤝","&larrhk;":"↩","&larrlp;":"↫","&larrpl;":"⤹","&larrsim;":"⥳","&larrtl;":"↢","&lat;":"⪫","&latail;":"⤙","&late;":"⪭","&lates;":"⪭︀","&lbarr;":"⤌","&lbbrk;":"❲","&lbrace;":"{","&lbrack;":"[","&lbrke;":"⦋","&lbrksld;":"⦏","&lbrkslu;":"⦍","&lcaron;":"ľ","&lcedil;":"ļ","&lceil;":"⌈","&lcub;":"{","&lcy;":"л","&ldca;":"⤶","&ldquo;":"“","&ldquor;":"„","&ldrdhar;":"⥧","&ldrushar;":"⥋","&ldsh;":"↲","&le;":"≤","&leftarrow;":"←","&leftarrowtail;":"↢","&leftharpoondown;":"↽","&leftharpoonup;":"↼","&leftleftarrows;":"⇇","&leftrightarrow;":"↔","&leftrightarrows;":"⇆","&leftrightharpoons;":"⇋","&leftrightsquigarrow;":"↭","&leftthreetimes;":"⋋","&leg;":"⋚","&leq;":"≤","&leqq;":"≦","&leqslant;":"⩽","&les;":"⩽","&lescc;":"⪨","&lesdot;":"⩿","&lesdoto;":"⪁","&lesdotor;":"⪃","&lesg;":"⋚︀","&lesges;":"⪓","&lessapprox;":"⪅","&lessdot;":"⋖","&lesseqgtr;":"⋚","&lesseqqgtr;":"⪋","&lessgtr;":"≶","&lesssim;":"≲","&lfisht;":"⥼","&lfloor;":"⌊","&lfr;":"𝔩","&lg;":"≶","&lgE;":"⪑","&lhard;":"↽","&lharu;":"↼","&lharul;":"⥪","&lhblk;":"▄","&ljcy;":"љ","&ll;":"≪","&llarr;":"⇇","&llcorner;":"⌞","&llhard;":"⥫","&lltri;":"◺","&lmidot;":"ŀ","&lmoust;":"⎰","&lmoustache;":"⎰","&lnE;":"≨","&lnap;":"⪉","&lnapprox;":"⪉","&lne;":"⪇","&lneq;":"⪇","&lneqq;":"≨","&lnsim;":"⋦","&loang;":"⟬","&loarr;":"⇽","&lobrk;":"⟦","&longleftarrow;":"⟵","&longleftrightarrow;":"⟷","&longmapsto;":"⟼","&longrightarrow;":"⟶","&looparrowleft;":"↫","&looparrowright;":"↬","&lopar;":"⦅","&lopf;":"𝕝","&loplus;":"⨭","&lotimes;":"⨴","&lowast;":"∗","&lowbar;":"_","&loz;":"◊","&lozenge;":"◊","&lozf;":"⧫","&lpar;":"(","&lparlt;":"⦓","&lrarr;":"⇆","&lrcorner;":"⌟","&lrhar;":"⇋","&lrhard;":"⥭","&lrm;":"‎","&lrtri;":"⊿","&lsaquo;":"‹","&lscr;":"𝓁","&lsh;":"↰","&lsim;":"≲","&lsime;":"⪍","&lsimg;":"⪏","&lsqb;":"[","&lsquo;":"‘","&lsquor;":"‚","&lstrok;":"ł","&lt":"<","&lt;":"<","&ltcc;":"⪦","&ltcir;":"⩹","&ltdot;":"⋖","&lthree;":"⋋","&ltimes;":"⋉","&ltlarr;":"⥶","&ltquest;":"⩻","&ltrPar;":"⦖","&ltri;":"◃","&ltrie;":"⊴","&ltrif;":"◂","&lurdshar;":"⥊","&luruhar;":"⥦","&lvertneqq;":"≨︀","&lvnE;":"≨︀","&mDDot;":"∺","&macr":"¯","&macr;":"¯","&male;":"♂","&malt;":"✠","&maltese;":"✠","&map;":"↦","&mapsto;":"↦","&mapstodown;":"↧","&mapstoleft;":"↤","&mapstoup;":"↥","&marker;":"▮","&mcomma;":"⨩","&mcy;":"м","&mdash;":"—","&measuredangle;":"∡","&mfr;":"𝔪","&mho;":"℧","&micro":"µ","&micro;":"µ","&mid;":"∣","&midast;":"*","&midcir;":"⫰","&middot":"·","&middot;":"·","&minus;":"−","&minusb;":"⊟","&minusd;":"∸","&minusdu;":"⨪","&mlcp;":"⫛","&mldr;":"…","&mnplus;":"∓","&models;":"⊧","&mopf;":"𝕞","&mp;":"∓","&mscr;":"𝓂","&mstpos;":"∾","&mu;":"μ","&multimap;":"⊸","&mumap;":"⊸","&nGg;":"⋙̸","&nGt;":"≫⃒","&nGtv;":"≫̸","&nLeftarrow;":"⇍","&nLeftrightarrow;":"⇎","&nLl;":"⋘̸","&nLt;":"≪⃒","&nLtv;":"≪̸","&nRightarrow;":"⇏","&nVDash;":"⊯","&nVdash;":"⊮","&nabla;":"∇","&nacute;":"ń","&nang;":"∠⃒","&nap;":"≉","&napE;":"⩰̸","&napid;":"≋̸","&napos;":"ŉ","&napprox;":"≉","&natur;":"♮","&natural;":"♮","&naturals;":"ℕ","&nbsp":" ","&nbsp;":" ","&nbump;":"≎̸","&nbumpe;":"≏̸","&ncap;":"⩃","&ncaron;":"ň","&ncedil;":"ņ","&ncong;":"≇","&ncongdot;":"⩭̸","&ncup;":"⩂","&ncy;":"н","&ndash;":"–","&ne;":"≠","&neArr;":"⇗","&nearhk;":"⤤","&nearr;":"↗","&nearrow;":"↗","&nedot;":"≐̸","&nequiv;":"≢","&nesear;":"⤨","&nesim;":"≂̸","&nexist;":"∄","&nexists;":"∄","&nfr;":"𝔫","&ngE;":"≧̸","&nge;":"≱","&ngeq;":"≱","&ngeqq;":"≧̸","&ngeqslant;":"⩾̸","&nges;":"⩾̸","&ngsim;":"≵","&ngt;":"≯","&ngtr;":"≯","&nhArr;":"⇎","&nharr;":"↮","&nhpar;":"⫲","&ni;":"∋","&nis;":"⋼","&nisd;":"⋺","&niv;":"∋","&njcy;":"њ","&nlArr;":"⇍","&nlE;":"≦̸","&nlarr;":"↚","&nldr;":"‥","&nle;":"≰","&nleftarrow;":"↚","&nleftrightarrow;":"↮","&nleq;":"≰","&nleqq;":"≦̸","&nleqslant;":"⩽̸","&nles;":"⩽̸","&nless;":"≮","&nlsim;":"≴","&nlt;":"≮","&nltri;":"⋪","&nltrie;":"⋬","&nmid;":"∤","&nopf;":"𝕟","&not":"¬","&not;":"¬","&notin;":"∉","&notinE;":"⋹̸","&notindot;":"⋵̸","&notinva;":"∉","&notinvb;":"⋷","&notinvc;":"⋶","&notni;":"∌","&notniva;":"∌","&notnivb;":"⋾","&notnivc;":"⋽","&npar;":"∦","&nparallel;":"∦","&nparsl;":"⫽⃥","&npart;":"∂̸","&npolint;":"⨔","&npr;":"⊀","&nprcue;":"⋠","&npre;":"⪯̸","&nprec;":"⊀","&npreceq;":"⪯̸","&nrArr;":"⇏","&nrarr;":"↛","&nrarrc;":"⤳̸","&nrarrw;":"↝̸","&nrightarrow;":"↛","&nrtri;":"⋫","&nrtrie;":"⋭","&nsc;":"⊁","&nsccue;":"⋡","&nsce;":"⪰̸","&nscr;":"𝓃","&nshortmid;":"∤","&nshortparallel;":"∦","&nsim;":"≁","&nsime;":"≄","&nsimeq;":"≄","&nsmid;":"∤","&nspar;":"∦","&nsqsube;":"⋢","&nsqsupe;":"⋣","&nsub;":"⊄","&nsubE;":"⫅̸","&nsube;":"⊈","&nsubset;":"⊂⃒","&nsubseteq;":"⊈","&nsubseteqq;":"⫅̸","&nsucc;":"⊁","&nsucceq;":"⪰̸","&nsup;":"⊅","&nsupE;":"⫆̸","&nsupe;":"⊉","&nsupset;":"⊃⃒","&nsupseteq;":"⊉","&nsupseteqq;":"⫆̸","&ntgl;":"≹","&ntilde":"ñ","&ntilde;":"ñ","&ntlg;":"≸","&ntriangleleft;":"⋪","&ntrianglelefteq;":"⋬","&ntriangleright;":"⋫","&ntrianglerighteq;":"⋭","&nu;":"ν","&num;":"#","&numero;":"№","&numsp;":" ","&nvDash;":"⊭","&nvHarr;":"⤄","&nvap;":"≍⃒","&nvdash;":"⊬","&nvge;":"≥⃒","&nvgt;":">⃒","&nvinfin;":"⧞","&nvlArr;":"⤂","&nvle;":"≤⃒","&nvlt;":"<⃒","&nvltrie;":"⊴⃒","&nvrArr;":"⤃","&nvrtrie;":"⊵⃒","&nvsim;":"∼⃒","&nwArr;":"⇖","&nwarhk;":"⤣","&nwarr;":"↖","&nwarrow;":"↖","&nwnear;":"⤧","&oS;":"Ⓢ","&oacute":"ó","&oacute;":"ó","&oast;":"⊛","&ocir;":"⊚","&ocirc":"ô","&ocirc;":"ô","&ocy;":"о","&odash;":"⊝","&odblac;":"ő","&odiv;":"⨸","&odot;":"⊙","&odsold;":"⦼","&oelig;":"œ","&ofcir;":"⦿","&ofr;":"𝔬","&ogon;":"˛","&ograve":"ò","&ograve;":"ò","&ogt;":"⧁","&ohbar;":"⦵","&ohm;":"Ω","&oint;":"∮","&olarr;":"↺","&olcir;":"⦾","&olcross;":"⦻","&oline;":"‾","&olt;":"⧀","&omacr;":"ō","&omega;":"ω","&omicron;":"ο","&omid;":"⦶","&ominus;":"⊖","&oopf;":"𝕠","&opar;":"⦷","&operp;":"⦹","&oplus;":"⊕","&or;":"∨","&orarr;":"↻","&ord;":"⩝","&order;":"ℴ","&orderof;":"ℴ","&ordf":"ª","&ordf;":"ª","&ordm":"º","&ordm;":"º","&origof;":"⊶","&oror;":"⩖","&orslope;":"⩗","&orv;":"⩛","&oscr;":"ℴ","&oslash":"ø","&oslash;":"ø","&osol;":"⊘","&otilde":"õ","&otilde;":"õ","&otimes;":"⊗","&otimesas;":"⨶","&ouml":"ö","&ouml;":"ö","&ovbar;":"⌽","&par;":"∥","&para":"¶","&para;":"¶","&parallel;":"∥","&parsim;":"⫳","&parsl;":"⫽","&part;":"∂","&pcy;":"п","&percnt;":"%","&period;":".","&permil;":"‰","&perp;":"⊥","&pertenk;":"‱","&pfr;":"𝔭","&phi;":"φ","&phiv;":"ϕ","&phmmat;":"ℳ","&phone;":"☎","&pi;":"π","&pitchfork;":"⋔","&piv;":"ϖ","&planck;":"ℏ","&planckh;":"ℎ","&plankv;":"ℏ","&plus;":"+","&plusacir;":"⨣","&plusb;":"⊞","&pluscir;":"⨢","&plusdo;":"∔","&plusdu;":"⨥","&pluse;":"⩲","&plusmn":"±","&plusmn;":"±","&plussim;":"⨦","&plustwo;":"⨧","&pm;":"±","&pointint;":"⨕","&popf;":"𝕡","&pound":"£","&pound;":"£","&pr;":"≺","&prE;":"⪳","&prap;":"⪷","&prcue;":"≼","&pre;":"⪯","&prec;":"≺","&precapprox;":"⪷","&preccurlyeq;":"≼","&preceq;":"⪯","&precnapprox;":"⪹","&precneqq;":"⪵","&precnsim;":"⋨","&precsim;":"≾","&prime;":"′","&primes;":"ℙ","&prnE;":"⪵","&prnap;":"⪹","&prnsim;":"⋨","&prod;":"∏","&profalar;":"⌮","&profline;":"⌒","&profsurf;":"⌓","&prop;":"∝","&propto;":"∝","&prsim;":"≾","&prurel;":"⊰","&pscr;":"𝓅","&psi;":"ψ","&puncsp;":" ","&qfr;":"𝔮","&qint;":"⨌","&qopf;":"𝕢","&qprime;":"⁗","&qscr;":"𝓆","&quaternions;":"ℍ","&quatint;":"⨖","&quest;":"?","&questeq;":"≟","&quot":'"',"&quot;":'"',"&rAarr;":"⇛","&rArr;":"⇒","&rAtail;":"⤜","&rBarr;":"⤏","&rHar;":"⥤","&race;":"∽̱","&racute;":"ŕ","&radic;":"√","&raemptyv;":"⦳","&rang;":"⟩","&rangd;":"⦒","&range;":"⦥","&rangle;":"⟩","&raquo":"»","&raquo;":"»","&rarr;":"→","&rarrap;":"⥵","&rarrb;":"⇥","&rarrbfs;":"⤠","&rarrc;":"⤳","&rarrfs;":"⤞","&rarrhk;":"↪","&rarrlp;":"↬","&rarrpl;":"⥅","&rarrsim;":"⥴","&rarrtl;":"↣","&rarrw;":"↝","&ratail;":"⤚","&ratio;":"∶","&rationals;":"ℚ","&rbarr;":"⤍","&rbbrk;":"❳","&rbrace;":"}","&rbrack;":"]","&rbrke;":"⦌","&rbrksld;":"⦎","&rbrkslu;":"⦐","&rcaron;":"ř","&rcedil;":"ŗ","&rceil;":"⌉","&rcub;":"}","&rcy;":"р","&rdca;":"⤷","&rdldhar;":"⥩","&rdquo;":"”","&rdquor;":"”","&rdsh;":"↳","&real;":"ℜ","&realine;":"ℛ","&realpart;":"ℜ","&reals;":"ℝ","&rect;":"▭","&reg":"®","&reg;":"®","&rfisht;":"⥽","&rfloor;":"⌋","&rfr;":"𝔯","&rhard;":"⇁","&rharu;":"⇀","&rharul;":"⥬","&rho;":"ρ","&rhov;":"ϱ","&rightarrow;":"→","&rightarrowtail;":"↣","&rightharpoondown;":"⇁","&rightharpoonup;":"⇀","&rightleftarrows;":"⇄","&rightleftharpoons;":"⇌","&rightrightarrows;":"⇉","&rightsquigarrow;":"↝","&rightthreetimes;":"⋌","&ring;":"˚","&risingdotseq;":"≓","&rlarr;":"⇄","&rlhar;":"⇌","&rlm;":"‏","&rmoust;":"⎱","&rmoustache;":"⎱","&rnmid;":"⫮","&roang;":"⟭","&roarr;":"⇾","&robrk;":"⟧","&ropar;":"⦆","&ropf;":"𝕣","&roplus;":"⨮","&rotimes;":"⨵","&rpar;":")","&rpargt;":"⦔","&rppolint;":"⨒","&rrarr;":"⇉","&rsaquo;":"›","&rscr;":"𝓇","&rsh;":"↱","&rsqb;":"]","&rsquo;":"’","&rsquor;":"’","&rthree;":"⋌","&rtimes;":"⋊","&rtri;":"▹","&rtrie;":"⊵","&rtrif;":"▸","&rtriltri;":"⧎","&ruluhar;":"⥨","&rx;":"℞","&sacute;":"ś","&sbquo;":"‚","&sc;":"≻","&scE;":"⪴","&scap;":"⪸","&scaron;":"š","&sccue;":"≽","&sce;":"⪰","&scedil;":"ş","&scirc;":"ŝ","&scnE;":"⪶","&scnap;":"⪺","&scnsim;":"⋩","&scpolint;":"⨓","&scsim;":"≿","&scy;":"с","&sdot;":"⋅","&sdotb;":"⊡","&sdote;":"⩦","&seArr;":"⇘","&searhk;":"⤥","&searr;":"↘","&searrow;":"↘","&sect":"§","&sect;":"§","&semi;":";","&seswar;":"⤩","&setminus;":"∖","&setmn;":"∖","&sext;":"✶","&sfr;":"𝔰","&sfrown;":"⌢","&sharp;":"♯","&shchcy;":"щ","&shcy;":"ш","&shortmid;":"∣","&shortparallel;":"∥","&shy":"­","&shy;":"­","&sigma;":"σ","&sigmaf;":"ς","&sigmav;":"ς","&sim;":"∼","&simdot;":"⩪","&sime;":"≃","&simeq;":"≃","&simg;":"⪞","&simgE;":"⪠","&siml;":"⪝","&simlE;":"⪟","&simne;":"≆","&simplus;":"⨤","&simrarr;":"⥲","&slarr;":"←","&smallsetminus;":"∖","&smashp;":"⨳","&smeparsl;":"⧤","&smid;":"∣","&smile;":"⌣","&smt;":"⪪","&smte;":"⪬","&smtes;":"⪬︀","&softcy;":"ь","&sol;":"/","&solb;":"⧄","&solbar;":"⌿","&sopf;":"𝕤","&spades;":"♠","&spadesuit;":"♠","&spar;":"∥","&sqcap;":"⊓","&sqcaps;":"⊓︀","&sqcup;":"⊔","&sqcups;":"⊔︀","&sqsub;":"⊏","&sqsube;":"⊑","&sqsubset;":"⊏","&sqsubseteq;":"⊑","&sqsup;":"⊐","&sqsupe;":"⊒","&sqsupset;":"⊐","&sqsupseteq;":"⊒","&squ;":"□","&square;":"□","&squarf;":"▪","&squf;":"▪","&srarr;":"→","&sscr;":"𝓈","&ssetmn;":"∖","&ssmile;":"⌣","&sstarf;":"⋆","&star;":"☆","&starf;":"★","&straightepsilon;":"ϵ","&straightphi;":"ϕ","&strns;":"¯","&sub;":"⊂","&subE;":"⫅","&subdot;":"⪽","&sube;":"⊆","&subedot;":"⫃","&submult;":"⫁","&subnE;":"⫋","&subne;":"⊊","&subplus;":"⪿","&subrarr;":"⥹","&subset;":"⊂","&subseteq;":"⊆","&subseteqq;":"⫅","&subsetneq;":"⊊","&subsetneqq;":"⫋","&subsim;":"⫇","&subsub;":"⫕","&subsup;":"⫓","&succ;":"≻","&succapprox;":"⪸","&succcurlyeq;":"≽","&succeq;":"⪰","&succnapprox;":"⪺","&succneqq;":"⪶","&succnsim;":"⋩","&succsim;":"≿","&sum;":"∑","&sung;":"♪","&sup1":"¹","&sup1;":"¹","&sup2":"²","&sup2;":"²","&sup3":"³","&sup3;":"³","&sup;":"⊃","&supE;":"⫆","&supdot;":"⪾","&supdsub;":"⫘","&supe;":"⊇","&supedot;":"⫄","&suphsol;":"⟉","&suphsub;":"⫗","&suplarr;":"⥻","&supmult;":"⫂","&supnE;":"⫌","&supne;":"⊋","&supplus;":"⫀","&supset;":"⊃","&supseteq;":"⊇","&supseteqq;":"⫆","&supsetneq;":"⊋","&supsetneqq;":"⫌","&supsim;":"⫈","&supsub;":"⫔","&supsup;":"⫖","&swArr;":"⇙","&swarhk;":"⤦","&swarr;":"↙","&swarrow;":"↙","&swnwar;":"⤪","&szlig":"ß","&szlig;":"ß","&target;":"⌖","&tau;":"τ","&tbrk;":"⎴","&tcaron;":"ť","&tcedil;":"ţ","&tcy;":"т","&tdot;":"⃛","&telrec;":"⌕","&tfr;":"𝔱","&there4;":"∴","&therefore;":"∴","&theta;":"θ","&thetasym;":"ϑ","&thetav;":"ϑ","&thickapprox;":"≈","&thicksim;":"∼","&thinsp;":" ","&thkap;":"≈","&thksim;":"∼","&thorn":"þ","&thorn;":"þ","&tilde;":"˜","&times":"×","&times;":"×","&timesb;":"⊠","&timesbar;":"⨱","&timesd;":"⨰","&tint;":"∭","&toea;":"⤨","&top;":"⊤","&topbot;":"⌶","&topcir;":"⫱","&topf;":"𝕥","&topfork;":"⫚","&tosa;":"⤩","&tprime;":"‴","&trade;":"™","&triangle;":"▵","&triangledown;":"▿","&triangleleft;":"◃","&trianglelefteq;":"⊴","&triangleq;":"≜","&triangleright;":"▹","&trianglerighteq;":"⊵","&tridot;":"◬","&trie;":"≜","&triminus;":"⨺","&triplus;":"⨹","&trisb;":"⧍","&tritime;":"⨻","&trpezium;":"⏢","&tscr;":"𝓉","&tscy;":"ц","&tshcy;":"ћ","&tstrok;":"ŧ","&twixt;":"≬","&twoheadleftarrow;":"↞","&twoheadrightarrow;":"↠","&uArr;":"⇑","&uHar;":"⥣","&uacute":"ú","&uacute;":"ú","&uarr;":"↑","&ubrcy;":"ў","&ubreve;":"ŭ","&ucirc":"û","&ucirc;":"û","&ucy;":"у","&udarr;":"⇅","&udblac;":"ű","&udhar;":"⥮","&ufisht;":"⥾","&ufr;":"𝔲","&ugrave":"ù","&ugrave;":"ù","&uharl;":"↿","&uharr;":"↾","&uhblk;":"▀","&ulcorn;":"⌜","&ulcorner;":"⌜","&ulcrop;":"⌏","&ultri;":"◸","&umacr;":"ū","&uml":"¨","&uml;":"¨","&uogon;":"ų","&uopf;":"𝕦","&uparrow;":"↑","&updownarrow;":"↕","&upharpoonleft;":"↿","&upharpoonright;":"↾","&uplus;":"⊎","&upsi;":"υ","&upsih;":"ϒ","&upsilon;":"υ","&upuparrows;":"⇈","&urcorn;":"⌝","&urcorner;":"⌝","&urcrop;":"⌎","&uring;":"ů","&urtri;":"◹","&uscr;":"𝓊","&utdot;":"⋰","&utilde;":"ũ","&utri;":"▵","&utrif;":"▴","&uuarr;":"⇈","&uuml":"ü","&uuml;":"ü","&uwangle;":"⦧","&vArr;":"⇕","&vBar;":"⫨","&vBarv;":"⫩","&vDash;":"⊨","&vangrt;":"⦜","&varepsilon;":"ϵ","&varkappa;":"ϰ","&varnothing;":"∅","&varphi;":"ϕ","&varpi;":"ϖ","&varpropto;":"∝","&varr;":"↕","&varrho;":"ϱ","&varsigma;":"ς","&varsubsetneq;":"⊊︀","&varsubsetneqq;":"⫋︀","&varsupsetneq;":"⊋︀","&varsupsetneqq;":"⫌︀","&vartheta;":"ϑ","&vartriangleleft;":"⊲","&vartriangleright;":"⊳","&vcy;":"в","&vdash;":"⊢","&vee;":"∨","&veebar;":"⊻","&veeeq;":"≚","&vellip;":"⋮","&verbar;":"|","&vert;":"|","&vfr;":"𝔳","&vltri;":"⊲","&vnsub;":"⊂⃒","&vnsup;":"⊃⃒","&vopf;":"𝕧","&vprop;":"∝","&vrtri;":"⊳","&vscr;":"𝓋","&vsubnE;":"⫋︀","&vsubne;":"⊊︀","&vsupnE;":"⫌︀","&vsupne;":"⊋︀","&vzigzag;":"⦚","&wcirc;":"ŵ","&wedbar;":"⩟","&wedge;":"∧","&wedgeq;":"≙","&weierp;":"℘","&wfr;":"𝔴","&wopf;":"𝕨","&wp;":"℘","&wr;":"≀","&wreath;":"≀","&wscr;":"𝓌","&xcap;":"⋂","&xcirc;":"◯","&xcup;":"⋃","&xdtri;":"▽","&xfr;":"𝔵","&xhArr;":"⟺","&xharr;":"⟷","&xi;":"ξ","&xlArr;":"⟸","&xlarr;":"⟵","&xmap;":"⟼","&xnis;":"⋻","&xodot;":"⨀","&xopf;":"𝕩","&xoplus;":"⨁","&xotime;":"⨂","&xrArr;":"⟹","&xrarr;":"⟶","&xscr;":"𝓍","&xsqcup;":"⨆","&xuplus;":"⨄","&xutri;":"△","&xvee;":"⋁","&xwedge;":"⋀","&yacute":"ý","&yacute;":"ý","&yacy;":"я","&ycirc;":"ŷ","&ycy;":"ы","&yen":"¥","&yen;":"¥","&yfr;":"𝔶","&yicy;":"ї","&yopf;":"𝕪","&yscr;":"𝓎","&yucy;":"ю","&yuml":"ÿ","&yuml;":"ÿ","&zacute;":"ź","&zcaron;":"ž","&zcy;":"з","&zdot;":"ż","&zeetrf;":"ℨ","&zeta;":"ζ","&zfr;":"𝔷","&zhcy;":"ж","&zigrarr;":"⇝","&zopf;":"𝕫","&zscr;":"𝓏","&zwj;":"‍","&zwnj;":"‌"},characters:{"Æ":"&AElig;","&":"&amp;","Á":"&Aacute;","Ă":"&Abreve;","Â":"&Acirc;","А":"&Acy;","𝔄":"&Afr;","À":"&Agrave;","Α":"&Alpha;","Ā":"&Amacr;","⩓":"&And;","Ą":"&Aogon;","𝔸":"&Aopf;","⁡":"&af;","Å":"&angst;","𝒜":"&Ascr;","≔":"&coloneq;","Ã":"&Atilde;","Ä":"&Auml;","∖":"&ssetmn;","⫧":"&Barv;","⌆":"&doublebarwedge;","Б":"&Bcy;","∵":"&because;","ℬ":"&bernou;","Β":"&Beta;","𝔅":"&Bfr;","𝔹":"&Bopf;","˘":"&breve;","≎":"&bump;","Ч":"&CHcy;","©":"&copy;","Ć":"&Cacute;","⋒":"&Cap;","ⅅ":"&DD;","ℭ":"&Cfr;","Č":"&Ccaron;","Ç":"&Ccedil;","Ĉ":"&Ccirc;","∰":"&Cconint;","Ċ":"&Cdot;","¸":"&cedil;","·":"&middot;","Χ":"&Chi;","⊙":"&odot;","⊖":"&ominus;","⊕":"&oplus;","⊗":"&otimes;","∲":"&cwconint;","”":"&rdquor;","’":"&rsquor;","∷":"&Proportion;","⩴":"&Colone;","≡":"&equiv;","∯":"&DoubleContourIntegral;","∮":"&oint;","ℂ":"&complexes;","∐":"&coprod;","∳":"&awconint;","⨯":"&Cross;","𝒞":"&Cscr;","⋓":"&Cup;","≍":"&asympeq;","⤑":"&DDotrahd;","Ђ":"&DJcy;","Ѕ":"&DScy;","Џ":"&DZcy;","‡":"&ddagger;","↡":"&Darr;","⫤":"&DoubleLeftTee;","Ď":"&Dcaron;","Д":"&Dcy;","∇":"&nabla;","Δ":"&Delta;","𝔇":"&Dfr;","´":"&acute;","˙":"&dot;","˝":"&dblac;","`":"&grave;","˜":"&tilde;","⋄":"&diamond;","ⅆ":"&dd;","𝔻":"&Dopf;","¨":"&uml;","⃜":"&DotDot;","≐":"&esdot;","⇓":"&dArr;","⇐":"&lArr;","⇔":"&iff;","⟸":"&xlArr;","⟺":"&xhArr;","⟹":"&xrArr;","⇒":"&rArr;","⊨":"&vDash;","⇑":"&uArr;","⇕":"&vArr;","∥":"&spar;","↓":"&downarrow;","⤓":"&DownArrowBar;","⇵":"&duarr;","̑":"&DownBreve;","⥐":"&DownLeftRightVector;","⥞":"&DownLeftTeeVector;","↽":"&lhard;","⥖":"&DownLeftVectorBar;","⥟":"&DownRightTeeVector;","⇁":"&rightharpoondown;","⥗":"&DownRightVectorBar;","⊤":"&top;","↧":"&mapstodown;","𝒟":"&Dscr;","Đ":"&Dstrok;","Ŋ":"&ENG;","Ð":"&ETH;","É":"&Eacute;","Ě":"&Ecaron;","Ê":"&Ecirc;","Э":"&Ecy;","Ė":"&Edot;","𝔈":"&Efr;","È":"&Egrave;","∈":"&isinv;","Ē":"&Emacr;","◻":"&EmptySmallSquare;","▫":"&EmptyVerySmallSquare;","Ę":"&Eogon;","𝔼":"&Eopf;","Ε":"&Epsilon;","⩵":"&Equal;","≂":"&esim;","⇌":"&rlhar;","ℰ":"&expectation;","⩳":"&Esim;","Η":"&Eta;","Ë":"&Euml;","∃":"&exist;","ⅇ":"&exponentiale;","Ф":"&Fcy;","𝔉":"&Ffr;","◼":"&FilledSmallSquare;","▪":"&squf;","𝔽":"&Fopf;","∀":"&forall;","ℱ":"&Fscr;","Ѓ":"&GJcy;",">":"&gt;","Γ":"&Gamma;","Ϝ":"&Gammad;","Ğ":"&Gbreve;","Ģ":"&Gcedil;","Ĝ":"&Gcirc;","Г":"&Gcy;","Ġ":"&Gdot;","𝔊":"&Gfr;","⋙":"&ggg;","𝔾":"&Gopf;","≥":"&geq;","⋛":"&gtreqless;","≧":"&geqq;","⪢":"&GreaterGreater;","≷":"&gtrless;","⩾":"&ges;","≳":"&gtrsim;","𝒢":"&Gscr;","≫":"&gg;","Ъ":"&HARDcy;","ˇ":"&caron;","^":"&Hat;","Ĥ":"&Hcirc;","ℌ":"&Poincareplane;","ℋ":"&hamilt;","ℍ":"&quaternions;","─":"&boxh;","Ħ":"&Hstrok;","≏":"&bumpeq;","Е":"&IEcy;","Ĳ":"&IJlig;","Ё":"&IOcy;","Í":"&Iacute;","Î":"&Icirc;","И":"&Icy;","İ":"&Idot;","ℑ":"&imagpart;","Ì":"&Igrave;","Ī":"&Imacr;","ⅈ":"&ii;","∬":"&Int;","∫":"&int;","⋂":"&xcap;","⁣":"&ic;","⁢":"&it;","Į":"&Iogon;","𝕀":"&Iopf;","Ι":"&Iota;","ℐ":"&imagline;","Ĩ":"&Itilde;","І":"&Iukcy;","Ï":"&Iuml;","Ĵ":"&Jcirc;","Й":"&Jcy;","𝔍":"&Jfr;","𝕁":"&Jopf;","𝒥":"&Jscr;","Ј":"&Jsercy;","Є":"&Jukcy;","Х":"&KHcy;","Ќ":"&KJcy;","Κ":"&Kappa;","Ķ":"&Kcedil;","К":"&Kcy;","𝔎":"&Kfr;","𝕂":"&Kopf;","𝒦":"&Kscr;","Љ":"&LJcy;","<":"&lt;","Ĺ":"&Lacute;","Λ":"&Lambda;","⟪":"&Lang;","ℒ":"&lagran;","↞":"&twoheadleftarrow;","Ľ":"&Lcaron;","Ļ":"&Lcedil;","Л":"&Lcy;","⟨":"&langle;","←":"&slarr;","⇤":"&larrb;","⇆":"&lrarr;","⌈":"&lceil;","⟦":"&lobrk;","⥡":"&LeftDownTeeVector;","⇃":"&downharpoonleft;","⥙":"&LeftDownVectorBar;","⌊":"&lfloor;","↔":"&leftrightarrow;","⥎":"&LeftRightVector;","⊣":"&dashv;","↤":"&mapstoleft;","⥚":"&LeftTeeVector;","⊲":"&vltri;","⧏":"&LeftTriangleBar;","⊴":"&trianglelefteq;","⥑":"&LeftUpDownVector;","⥠":"&LeftUpTeeVector;","↿":"&upharpoonleft;","⥘":"&LeftUpVectorBar;","↼":"&lharu;","⥒":"&LeftVectorBar;","⋚":"&lesseqgtr;","≦":"&leqq;","≶":"&lg;","⪡":"&LessLess;","⩽":"&les;","≲":"&lsim;","𝔏":"&Lfr;","⋘":"&Ll;","⇚":"&lAarr;","Ŀ":"&Lmidot;","⟵":"&xlarr;","⟷":"&xharr;","⟶":"&xrarr;","𝕃":"&Lopf;","↙":"&swarrow;","↘":"&searrow;","↰":"&lsh;","Ł":"&Lstrok;","≪":"&ll;","⤅":"&Map;","М":"&Mcy;"," ":"&MediumSpace;","ℳ":"&phmmat;","𝔐":"&Mfr;","∓":"&mp;","𝕄":"&Mopf;","Μ":"&Mu;","Њ":"&NJcy;","Ń":"&Nacute;","Ň":"&Ncaron;","Ņ":"&Ncedil;","Н":"&Ncy;","​":"&ZeroWidthSpace;","\n":"&NewLine;","𝔑":"&Nfr;","⁠":"&NoBreak;"," ":"&nbsp;","ℕ":"&naturals;","⫬":"&Not;","≢":"&nequiv;","≭":"&NotCupCap;","∦":"&nspar;","∉":"&notinva;","≠":"&ne;","≂̸":"&nesim;","∄":"&nexists;","≯":"&ngtr;","≱":"&ngeq;","≧̸":"&ngeqq;","≫̸":"&nGtv;","≹":"&ntgl;","⩾̸":"&nges;","≵":"&ngsim;","≎̸":"&nbump;","≏̸":"&nbumpe;","⋪":"&ntriangleleft;","⧏̸":"&NotLeftTriangleBar;","⋬":"&ntrianglelefteq;","≮":"&nlt;","≰":"&nleq;","≸":"&ntlg;","≪̸":"&nLtv;","⩽̸":"&nles;","≴":"&nlsim;","⪢̸":"&NotNestedGreaterGreater;","⪡̸":"&NotNestedLessLess;","⊀":"&nprec;","⪯̸":"&npreceq;","⋠":"&nprcue;","∌":"&notniva;","⋫":"&ntriangleright;","⧐̸":"&NotRightTriangleBar;","⋭":"&ntrianglerighteq;","⊏̸":"&NotSquareSubset;","⋢":"&nsqsube;","⊐̸":"&NotSquareSuperset;","⋣":"&nsqsupe;","⊂⃒":"&vnsub;","⊈":"&nsubseteq;","⊁":"&nsucc;","⪰̸":"&nsucceq;","⋡":"&nsccue;","≿̸":"&NotSucceedsTilde;","⊃⃒":"&vnsup;","⊉":"&nsupseteq;","≁":"&nsim;","≄":"&nsimeq;","≇":"&ncong;","≉":"&napprox;","∤":"&nsmid;","𝒩":"&Nscr;","Ñ":"&Ntilde;","Ν":"&Nu;","Œ":"&OElig;","Ó":"&Oacute;","Ô":"&Ocirc;","О":"&Ocy;","Ő":"&Odblac;","𝔒":"&Ofr;","Ò":"&Ograve;","Ō":"&Omacr;","Ω":"&ohm;","Ο":"&Omicron;","𝕆":"&Oopf;","“":"&ldquo;","‘":"&lsquo;","⩔":"&Or;","𝒪":"&Oscr;","Ø":"&Oslash;","Õ":"&Otilde;","⨷":"&Otimes;","Ö":"&Ouml;","‾":"&oline;","⏞":"&OverBrace;","⎴":"&tbrk;","⏜":"&OverParenthesis;","∂":"&part;","П":"&Pcy;","𝔓":"&Pfr;","Φ":"&Phi;","Π":"&Pi;","±":"&pm;","ℙ":"&primes;","⪻":"&Pr;","≺":"&prec;","⪯":"&preceq;","≼":"&preccurlyeq;","≾":"&prsim;","″":"&Prime;","∏":"&prod;","∝":"&vprop;","𝒫":"&Pscr;","Ψ":"&Psi;",'"':"&quot;","𝔔":"&Qfr;","ℚ":"&rationals;","𝒬":"&Qscr;","⤐":"&drbkarow;","®":"&reg;","Ŕ":"&Racute;","⟫":"&Rang;","↠":"&twoheadrightarrow;","⤖":"&Rarrtl;","Ř":"&Rcaron;","Ŗ":"&Rcedil;","Р":"&Rcy;","ℜ":"&realpart;","∋":"&niv;","⇋":"&lrhar;","⥯":"&duhar;","Ρ":"&Rho;","⟩":"&rangle;","→":"&srarr;","⇥":"&rarrb;","⇄":"&rlarr;","⌉":"&rceil;","⟧":"&robrk;","⥝":"&RightDownTeeVector;","⇂":"&downharpoonright;","⥕":"&RightDownVectorBar;","⌋":"&rfloor;","⊢":"&vdash;","↦":"&mapsto;","⥛":"&RightTeeVector;","⊳":"&vrtri;","⧐":"&RightTriangleBar;","⊵":"&trianglerighteq;","⥏":"&RightUpDownVector;","⥜":"&RightUpTeeVector;","↾":"&upharpoonright;","⥔":"&RightUpVectorBar;","⇀":"&rightharpoonup;","⥓":"&RightVectorBar;","ℝ":"&reals;","⥰":"&RoundImplies;","⇛":"&rAarr;","ℛ":"&realine;","↱":"&rsh;","⧴":"&RuleDelayed;","Щ":"&SHCHcy;","Ш":"&SHcy;","Ь":"&SOFTcy;","Ś":"&Sacute;","⪼":"&Sc;","Š":"&Scaron;","Ş":"&Scedil;","Ŝ":"&Scirc;","С":"&Scy;","𝔖":"&Sfr;","↑":"&uparrow;","Σ":"&Sigma;","∘":"&compfn;","𝕊":"&Sopf;","√":"&radic;","□":"&square;","⊓":"&sqcap;","⊏":"&sqsubset;","⊑":"&sqsubseteq;","⊐":"&sqsupset;","⊒":"&sqsupseteq;","⊔":"&sqcup;","𝒮":"&Sscr;","⋆":"&sstarf;","⋐":"&Subset;","⊆":"&subseteq;","≻":"&succ;","⪰":"&succeq;","≽":"&succcurlyeq;","≿":"&succsim;","∑":"&sum;","⋑":"&Supset;","⊃":"&supset;","⊇":"&supseteq;","Þ":"&THORN;","™":"&trade;","Ћ":"&TSHcy;","Ц":"&TScy;","\t":"&Tab;","Τ":"&Tau;","Ť":"&Tcaron;","Ţ":"&Tcedil;","Т":"&Tcy;","𝔗":"&Tfr;","∴":"&therefore;","Θ":"&Theta;","  ":"&ThickSpace;"," ":"&thinsp;","∼":"&thksim;","≃":"&simeq;","≅":"&cong;","≈":"&thkap;","𝕋":"&Topf;","⃛":"&tdot;","𝒯":"&Tscr;","Ŧ":"&Tstrok;","Ú":"&Uacute;","↟":"&Uarr;","⥉":"&Uarrocir;","Ў":"&Ubrcy;","Ŭ":"&Ubreve;","Û":"&Ucirc;","У":"&Ucy;","Ű":"&Udblac;","𝔘":"&Ufr;","Ù":"&Ugrave;","Ū":"&Umacr;",_:"&lowbar;","⏟":"&UnderBrace;","⎵":"&bbrk;","⏝":"&UnderParenthesis;","⋃":"&xcup;","⊎":"&uplus;","Ų":"&Uogon;","𝕌":"&Uopf;","⤒":"&UpArrowBar;","⇅":"&udarr;","↕":"&varr;","⥮":"&udhar;","⊥":"&perp;","↥":"&mapstoup;","↖":"&nwarrow;","↗":"&nearrow;","ϒ":"&upsih;","Υ":"&Upsilon;","Ů":"&Uring;","𝒰":"&Uscr;","Ũ":"&Utilde;","Ü":"&Uuml;","⊫":"&VDash;","⫫":"&Vbar;","В":"&Vcy;","⊩":"&Vdash;","⫦":"&Vdashl;","⋁":"&xvee;","‖":"&Vert;","∣":"&smid;","|":"&vert;","❘":"&VerticalSeparator;","≀":"&wreath;"," ":"&hairsp;","𝔙":"&Vfr;","𝕍":"&Vopf;","𝒱":"&Vscr;","⊪":"&Vvdash;","Ŵ":"&Wcirc;","⋀":"&xwedge;","𝔚":"&Wfr;","𝕎":"&Wopf;","𝒲":"&Wscr;","𝔛":"&Xfr;","Ξ":"&Xi;","𝕏":"&Xopf;","𝒳":"&Xscr;","Я":"&YAcy;","Ї":"&YIcy;","Ю":"&YUcy;","Ý":"&Yacute;","Ŷ":"&Ycirc;","Ы":"&Ycy;","𝔜":"&Yfr;","𝕐":"&Yopf;","𝒴":"&Yscr;","Ÿ":"&Yuml;","Ж":"&ZHcy;","Ź":"&Zacute;","Ž":"&Zcaron;","З":"&Zcy;","Ż":"&Zdot;","Ζ":"&Zeta;","ℨ":"&zeetrf;","ℤ":"&integers;","𝒵":"&Zscr;","á":"&aacute;","ă":"&abreve;","∾":"&mstpos;","∾̳":"&acE;","∿":"&acd;","â":"&acirc;","а":"&acy;","æ":"&aelig;","𝔞":"&afr;","à":"&agrave;","ℵ":"&aleph;","α":"&alpha;","ā":"&amacr;","⨿":"&amalg;","∧":"&wedge;","⩕":"&andand;","⩜":"&andd;","⩘":"&andslope;","⩚":"&andv;","∠":"&angle;","⦤":"&ange;","∡":"&measuredangle;","⦨":"&angmsdaa;","⦩":"&angmsdab;","⦪":"&angmsdac;","⦫":"&angmsdad;","⦬":"&angmsdae;","⦭":"&angmsdaf;","⦮":"&angmsdag;","⦯":"&angmsdah;","∟":"&angrt;","⊾":"&angrtvb;","⦝":"&angrtvbd;","∢":"&angsph;","⍼":"&angzarr;","ą":"&aogon;","𝕒":"&aopf;","⩰":"&apE;","⩯":"&apacir;","≊":"&approxeq;","≋":"&apid;","'":"&apos;","å":"&aring;","𝒶":"&ascr;","*":"&midast;","ã":"&atilde;","ä":"&auml;","⨑":"&awint;","⫭":"&bNot;","≌":"&bcong;","϶":"&bepsi;","‵":"&bprime;","∽":"&bsim;","⋍":"&bsime;","⊽":"&barvee;","⌅":"&barwedge;","⎶":"&bbrktbrk;","б":"&bcy;","„":"&ldquor;","⦰":"&bemptyv;","β":"&beta;","ℶ":"&beth;","≬":"&twixt;","𝔟":"&bfr;","◯":"&xcirc;","⨀":"&xodot;","⨁":"&xoplus;","⨂":"&xotime;","⨆":"&xsqcup;","★":"&starf;","▽":"&xdtri;","△":"&xutri;","⨄":"&xuplus;","⤍":"&rbarr;","⧫":"&lozf;","▴":"&utrif;","▾":"&dtrif;","◂":"&ltrif;","▸":"&rtrif;","␣":"&blank;","▒":"&blk12;","░":"&blk14;","▓":"&blk34;","█":"&block;","=⃥":"&bne;","≡⃥":"&bnequiv;","⌐":"&bnot;","𝕓":"&bopf;","⋈":"&bowtie;","╗":"&boxDL;","╔":"&boxDR;","╖":"&boxDl;","╓":"&boxDr;","═":"&boxH;","╦":"&boxHD;","╩":"&boxHU;","╤":"&boxHd;","╧":"&boxHu;","╝":"&boxUL;","╚":"&boxUR;","╜":"&boxUl;","╙":"&boxUr;","║":"&boxV;","╬":"&boxVH;","╣":"&boxVL;","╠":"&boxVR;","╫":"&boxVh;","╢":"&boxVl;","╟":"&boxVr;","⧉":"&boxbox;","╕":"&boxdL;","╒":"&boxdR;","┐":"&boxdl;","┌":"&boxdr;","╥":"&boxhD;","╨":"&boxhU;","┬":"&boxhd;","┴":"&boxhu;","⊟":"&minusb;","⊞":"&plusb;","⊠":"&timesb;","╛":"&boxuL;","╘":"&boxuR;","┘":"&boxul;","└":"&boxur;","│":"&boxv;","╪":"&boxvH;","╡":"&boxvL;","╞":"&boxvR;","┼":"&boxvh;","┤":"&boxvl;","├":"&boxvr;","¦":"&brvbar;","𝒷":"&bscr;","⁏":"&bsemi;","\\":"&bsol;","⧅":"&bsolb;","⟈":"&bsolhsub;","•":"&bullet;","⪮":"&bumpE;","ć":"&cacute;","∩":"&cap;","⩄":"&capand;","⩉":"&capbrcup;","⩋":"&capcap;","⩇":"&capcup;","⩀":"&capdot;","∩︀":"&caps;","⁁":"&caret;","⩍":"&ccaps;","č":"&ccaron;","ç":"&ccedil;","ĉ":"&ccirc;","⩌":"&ccups;","⩐":"&ccupssm;","ċ":"&cdot;","⦲":"&cemptyv;","¢":"&cent;","𝔠":"&cfr;","ч":"&chcy;","✓":"&checkmark;","χ":"&chi;","○":"&cir;","⧃":"&cirE;","ˆ":"&circ;","≗":"&cire;","↺":"&olarr;","↻":"&orarr;","Ⓢ":"&oS;","⊛":"&oast;","⊚":"&ocir;","⊝":"&odash;","⨐":"&cirfnint;","⫯":"&cirmid;","⧂":"&cirscir;","♣":"&clubsuit;",":":"&colon;",",":"&comma;","@":"&commat;","∁":"&complement;","⩭":"&congdot;","𝕔":"&copf;","℗":"&copysr;","↵":"&crarr;","✗":"&cross;","𝒸":"&cscr;","⫏":"&csub;","⫑":"&csube;","⫐":"&csup;","⫒":"&csupe;","⋯":"&ctdot;","⤸":"&cudarrl;","⤵":"&cudarrr;","⋞":"&curlyeqprec;","⋟":"&curlyeqsucc;","↶":"&curvearrowleft;","⤽":"&cularrp;","∪":"&cup;","⩈":"&cupbrcap;","⩆":"&cupcap;","⩊":"&cupcup;","⊍":"&cupdot;","⩅":"&cupor;","∪︀":"&cups;","↷":"&curvearrowright;","⤼":"&curarrm;","⋎":"&cuvee;","⋏":"&cuwed;","¤":"&curren;","∱":"&cwint;","⌭":"&cylcty;","⥥":"&dHar;","†":"&dagger;","ℸ":"&daleth;","‐":"&hyphen;","⤏":"&rBarr;","ď":"&dcaron;","д":"&dcy;","⇊":"&downdownarrows;","⩷":"&eDDot;","°":"&deg;","δ":"&delta;","⦱":"&demptyv;","⥿":"&dfisht;","𝔡":"&dfr;","♦":"&diams;","ϝ":"&gammad;","⋲":"&disin;","÷":"&divide;","⋇":"&divonx;","ђ":"&djcy;","⌞":"&llcorner;","⌍":"&dlcrop;",$:"&dollar;","𝕕":"&dopf;","≑":"&eDot;","∸":"&minusd;","∔":"&plusdo;","⊡":"&sdotb;","⌟":"&lrcorner;","⌌":"&drcrop;","𝒹":"&dscr;","ѕ":"&dscy;","⧶":"&dsol;","đ":"&dstrok;","⋱":"&dtdot;","▿":"&triangledown;","⦦":"&dwangle;","џ":"&dzcy;","⟿":"&dzigrarr;","é":"&eacute;","⩮":"&easter;","ě":"&ecaron;","≖":"&eqcirc;","ê":"&ecirc;","≕":"&eqcolon;","э":"&ecy;","ė":"&edot;","≒":"&fallingdotseq;","𝔢":"&efr;","⪚":"&eg;","è":"&egrave;","⪖":"&eqslantgtr;","⪘":"&egsdot;","⪙":"&el;","⏧":"&elinters;","ℓ":"&ell;","⪕":"&eqslantless;","⪗":"&elsdot;","ē":"&emacr;","∅":"&varnothing;"," ":"&emsp13;"," ":"&emsp14;"," ":"&emsp;","ŋ":"&eng;"," ":"&ensp;","ę":"&eogon;","𝕖":"&eopf;","⋕":"&epar;","⧣":"&eparsl;","⩱":"&eplus;","ε":"&epsilon;","ϵ":"&varepsilon;","=":"&equals;","≟":"&questeq;","⩸":"&equivDD;","⧥":"&eqvparsl;","≓":"&risingdotseq;","⥱":"&erarr;","ℯ":"&escr;","η":"&eta;","ð":"&eth;","ë":"&euml;","€":"&euro;","!":"&excl;","ф":"&fcy;","♀":"&female;","ﬃ":"&ffilig;","ﬀ":"&fflig;","ﬄ":"&ffllig;","𝔣":"&ffr;","ﬁ":"&filig;",fj:"&fjlig;","♭":"&flat;","ﬂ":"&fllig;","▱":"&fltns;","ƒ":"&fnof;","𝕗":"&fopf;","⋔":"&pitchfork;","⫙":"&forkv;","⨍":"&fpartint;","½":"&half;","⅓":"&frac13;","¼":"&frac14;","⅕":"&frac15;","⅙":"&frac16;","⅛":"&frac18;","⅔":"&frac23;","⅖":"&frac25;","¾":"&frac34;","⅗":"&frac35;","⅜":"&frac38;","⅘":"&frac45;","⅚":"&frac56;","⅝":"&frac58;","⅞":"&frac78;","⁄":"&frasl;","⌢":"&sfrown;","𝒻":"&fscr;","⪌":"&gtreqqless;","ǵ":"&gacute;","γ":"&gamma;","⪆":"&gtrapprox;","ğ":"&gbreve;","ĝ":"&gcirc;","г":"&gcy;","ġ":"&gdot;","⪩":"&gescc;","⪀":"&gesdot;","⪂":"&gesdoto;","⪄":"&gesdotol;","⋛︀":"&gesl;","⪔":"&gesles;","𝔤":"&gfr;","ℷ":"&gimel;","ѓ":"&gjcy;","⪒":"&glE;","⪥":"&gla;","⪤":"&glj;","≩":"&gneqq;","⪊":"&gnapprox;","⪈":"&gneq;","⋧":"&gnsim;","𝕘":"&gopf;","ℊ":"&gscr;","⪎":"&gsime;","⪐":"&gsiml;","⪧":"&gtcc;","⩺":"&gtcir;","⋗":"&gtrdot;","⦕":"&gtlPar;","⩼":"&gtquest;","⥸":"&gtrarr;","≩︀":"&gvnE;","ъ":"&hardcy;","⥈":"&harrcir;","↭":"&leftrightsquigarrow;","ℏ":"&plankv;","ĥ":"&hcirc;","♥":"&heartsuit;","…":"&mldr;","⊹":"&hercon;","𝔥":"&hfr;","⤥":"&searhk;","⤦":"&swarhk;","⇿":"&hoarr;","∻":"&homtht;","↩":"&larrhk;","↪":"&rarrhk;","𝕙":"&hopf;","―":"&horbar;","𝒽":"&hscr;","ħ":"&hstrok;","⁃":"&hybull;","í":"&iacute;","î":"&icirc;","и":"&icy;","е":"&iecy;","¡":"&iexcl;","𝔦":"&ifr;","ì":"&igrave;","⨌":"&qint;","∭":"&tint;","⧜":"&iinfin;","℩":"&iiota;","ĳ":"&ijlig;","ī":"&imacr;","ı":"&inodot;","⊷":"&imof;","Ƶ":"&imped;","℅":"&incare;","∞":"&infin;","⧝":"&infintie;","⊺":"&intercal;","⨗":"&intlarhk;","⨼":"&iprod;","ё":"&iocy;","į":"&iogon;","𝕚":"&iopf;","ι":"&iota;","¿":"&iquest;","𝒾":"&iscr;","⋹":"&isinE;","⋵":"&isindot;","⋴":"&isins;","⋳":"&isinsv;","ĩ":"&itilde;","і":"&iukcy;","ï":"&iuml;","ĵ":"&jcirc;","й":"&jcy;","𝔧":"&jfr;","ȷ":"&jmath;","𝕛":"&jopf;","𝒿":"&jscr;","ј":"&jsercy;","є":"&jukcy;","κ":"&kappa;","ϰ":"&varkappa;","ķ":"&kcedil;","к":"&kcy;","𝔨":"&kfr;","ĸ":"&kgreen;","х":"&khcy;","ќ":"&kjcy;","𝕜":"&kopf;","𝓀":"&kscr;","⤛":"&lAtail;","⤎":"&lBarr;","⪋":"&lesseqqgtr;","⥢":"&lHar;","ĺ":"&lacute;","⦴":"&laemptyv;","λ":"&lambda;","⦑":"&langd;","⪅":"&lessapprox;","«":"&laquo;","⤟":"&larrbfs;","⤝":"&larrfs;","↫":"&looparrowleft;","⤹":"&larrpl;","⥳":"&larrsim;","↢":"&leftarrowtail;","⪫":"&lat;","⤙":"&latail;","⪭":"&late;","⪭︀":"&lates;","⤌":"&lbarr;","❲":"&lbbrk;","{":"&lcub;","[":"&lsqb;","⦋":"&lbrke;","⦏":"&lbrksld;","⦍":"&lbrkslu;","ľ":"&lcaron;","ļ":"&lcedil;","л":"&lcy;","⤶":"&ldca;","⥧":"&ldrdhar;","⥋":"&ldrushar;","↲":"&ldsh;","≤":"&leq;","⇇":"&llarr;","⋋":"&lthree;","⪨":"&lescc;","⩿":"&lesdot;","⪁":"&lesdoto;","⪃":"&lesdotor;","⋚︀":"&lesg;","⪓":"&lesges;","⋖":"&ltdot;","⥼":"&lfisht;","𝔩":"&lfr;","⪑":"&lgE;","⥪":"&lharul;","▄":"&lhblk;","љ":"&ljcy;","⥫":"&llhard;","◺":"&lltri;","ŀ":"&lmidot;","⎰":"&lmoustache;","≨":"&lneqq;","⪉":"&lnapprox;","⪇":"&lneq;","⋦":"&lnsim;","⟬":"&loang;","⇽":"&loarr;","⟼":"&xmap;","↬":"&rarrlp;","⦅":"&lopar;","𝕝":"&lopf;","⨭":"&loplus;","⨴":"&lotimes;","∗":"&lowast;","◊":"&lozenge;","(":"&lpar;","⦓":"&lparlt;","⥭":"&lrhard;","‎":"&lrm;","⊿":"&lrtri;","‹":"&lsaquo;","𝓁":"&lscr;","⪍":"&lsime;","⪏":"&lsimg;","‚":"&sbquo;","ł":"&lstrok;","⪦":"&ltcc;","⩹":"&ltcir;","⋉":"&ltimes;","⥶":"&ltlarr;","⩻":"&ltquest;","⦖":"&ltrPar;","◃":"&triangleleft;","⥊":"&lurdshar;","⥦":"&luruhar;","≨︀":"&lvnE;","∺":"&mDDot;","¯":"&strns;","♂":"&male;","✠":"&maltese;","▮":"&marker;","⨩":"&mcomma;","м":"&mcy;","—":"&mdash;","𝔪":"&mfr;","℧":"&mho;","µ":"&micro;","⫰":"&midcir;","−":"&minus;","⨪":"&minusdu;","⫛":"&mlcp;","⊧":"&models;","𝕞":"&mopf;","𝓂":"&mscr;","μ":"&mu;","⊸":"&mumap;","⋙̸":"&nGg;","≫⃒":"&nGt;","⇍":"&nlArr;","⇎":"&nhArr;","⋘̸":"&nLl;","≪⃒":"&nLt;","⇏":"&nrArr;","⊯":"&nVDash;","⊮":"&nVdash;","ń":"&nacute;","∠⃒":"&nang;","⩰̸":"&napE;","≋̸":"&napid;","ŉ":"&napos;","♮":"&natural;","⩃":"&ncap;","ň":"&ncaron;","ņ":"&ncedil;","⩭̸":"&ncongdot;","⩂":"&ncup;","н":"&ncy;","–":"&ndash;","⇗":"&neArr;","⤤":"&nearhk;","≐̸":"&nedot;","⤨":"&toea;","𝔫":"&nfr;","↮":"&nleftrightarrow;","⫲":"&nhpar;","⋼":"&nis;","⋺":"&nisd;","њ":"&njcy;","≦̸":"&nleqq;","↚":"&nleftarrow;","‥":"&nldr;","𝕟":"&nopf;","¬":"&not;","⋹̸":"&notinE;","⋵̸":"&notindot;","⋷":"&notinvb;","⋶":"&notinvc;","⋾":"&notnivb;","⋽":"&notnivc;","⫽⃥":"&nparsl;","∂̸":"&npart;","⨔":"&npolint;","↛":"&nrightarrow;","⤳̸":"&nrarrc;","↝̸":"&nrarrw;","𝓃":"&nscr;","⊄":"&nsub;","⫅̸":"&nsubseteqq;","⊅":"&nsup;","⫆̸":"&nsupseteqq;","ñ":"&ntilde;","ν":"&nu;","#":"&num;","№":"&numero;"," ":"&numsp;","⊭":"&nvDash;","⤄":"&nvHarr;","≍⃒":"&nvap;","⊬":"&nvdash;","≥⃒":"&nvge;",">⃒":"&nvgt;","⧞":"&nvinfin;","⤂":"&nvlArr;","≤⃒":"&nvle;","<⃒":"&nvlt;","⊴⃒":"&nvltrie;","⤃":"&nvrArr;","⊵⃒":"&nvrtrie;","∼⃒":"&nvsim;","⇖":"&nwArr;","⤣":"&nwarhk;","⤧":"&nwnear;","ó":"&oacute;","ô":"&ocirc;","о":"&ocy;","ő":"&odblac;","⨸":"&odiv;","⦼":"&odsold;","œ":"&oelig;","⦿":"&ofcir;","𝔬":"&ofr;","˛":"&ogon;","ò":"&ograve;","⧁":"&ogt;","⦵":"&ohbar;","⦾":"&olcir;","⦻":"&olcross;","⧀":"&olt;","ō":"&omacr;","ω":"&omega;","ο":"&omicron;","⦶":"&omid;","𝕠":"&oopf;","⦷":"&opar;","⦹":"&operp;","∨":"&vee;","⩝":"&ord;","ℴ":"&oscr;","ª":"&ordf;","º":"&ordm;","⊶":"&origof;","⩖":"&oror;","⩗":"&orslope;","⩛":"&orv;","ø":"&oslash;","⊘":"&osol;","õ":"&otilde;","⨶":"&otimesas;","ö":"&ouml;","⌽":"&ovbar;","¶":"&para;","⫳":"&parsim;","⫽":"&parsl;","п":"&pcy;","%":"&percnt;",".":"&period;","‰":"&permil;","‱":"&pertenk;","𝔭":"&pfr;","φ":"&phi;","ϕ":"&varphi;","☎":"&phone;","π":"&pi;","ϖ":"&varpi;","ℎ":"&planckh;","+":"&plus;","⨣":"&plusacir;","⨢":"&pluscir;","⨥":"&plusdu;","⩲":"&pluse;","⨦":"&plussim;","⨧":"&plustwo;","⨕":"&pointint;","𝕡":"&popf;","£":"&pound;","⪳":"&prE;","⪷":"&precapprox;","⪹":"&prnap;","⪵":"&prnE;","⋨":"&prnsim;","′":"&prime;","⌮":"&profalar;","⌒":"&profline;","⌓":"&profsurf;","⊰":"&prurel;","𝓅":"&pscr;","ψ":"&psi;"," ":"&puncsp;","𝔮":"&qfr;","𝕢":"&qopf;","⁗":"&qprime;","𝓆":"&qscr;","⨖":"&quatint;","?":"&quest;","⤜":"&rAtail;","⥤":"&rHar;","∽̱":"&race;","ŕ":"&racute;","⦳":"&raemptyv;","⦒":"&rangd;","⦥":"&range;","»":"&raquo;","⥵":"&rarrap;","⤠":"&rarrbfs;","⤳":"&rarrc;","⤞":"&rarrfs;","⥅":"&rarrpl;","⥴":"&rarrsim;","↣":"&rightarrowtail;","↝":"&rightsquigarrow;","⤚":"&ratail;","∶":"&ratio;","❳":"&rbbrk;","}":"&rcub;","]":"&rsqb;","⦌":"&rbrke;","⦎":"&rbrksld;","⦐":"&rbrkslu;","ř":"&rcaron;","ŗ":"&rcedil;","р":"&rcy;","⤷":"&rdca;","⥩":"&rdldhar;","↳":"&rdsh;","▭":"&rect;","⥽":"&rfisht;","𝔯":"&rfr;","⥬":"&rharul;","ρ":"&rho;","ϱ":"&varrho;","⇉":"&rrarr;","⋌":"&rthree;","˚":"&ring;","‏":"&rlm;","⎱":"&rmoustache;","⫮":"&rnmid;","⟭":"&roang;","⇾":"&roarr;","⦆":"&ropar;","𝕣":"&ropf;","⨮":"&roplus;","⨵":"&rotimes;",")":"&rpar;","⦔":"&rpargt;","⨒":"&rppolint;","›":"&rsaquo;","𝓇":"&rscr;","⋊":"&rtimes;","▹":"&triangleright;","⧎":"&rtriltri;","⥨":"&ruluhar;","℞":"&rx;","ś":"&sacute;","⪴":"&scE;","⪸":"&succapprox;","š":"&scaron;","ş":"&scedil;","ŝ":"&scirc;","⪶":"&succneqq;","⪺":"&succnapprox;","⋩":"&succnsim;","⨓":"&scpolint;","с":"&scy;","⋅":"&sdot;","⩦":"&sdote;","⇘":"&seArr;","§":"&sect;",";":"&semi;","⤩":"&tosa;","✶":"&sext;","𝔰":"&sfr;","♯":"&sharp;","щ":"&shchcy;","ш":"&shcy;","­":"&shy;","σ":"&sigma;","ς":"&varsigma;","⩪":"&simdot;","⪞":"&simg;","⪠":"&simgE;","⪝":"&siml;","⪟":"&simlE;","≆":"&simne;","⨤":"&simplus;","⥲":"&simrarr;","⨳":"&smashp;","⧤":"&smeparsl;","⌣":"&ssmile;","⪪":"&smt;","⪬":"&smte;","⪬︀":"&smtes;","ь":"&softcy;","/":"&sol;","⧄":"&solb;","⌿":"&solbar;","𝕤":"&sopf;","♠":"&spadesuit;","⊓︀":"&sqcaps;","⊔︀":"&sqcups;","𝓈":"&sscr;","☆":"&star;","⊂":"&subset;","⫅":"&subseteqq;","⪽":"&subdot;","⫃":"&subedot;","⫁":"&submult;","⫋":"&subsetneqq;","⊊":"&subsetneq;","⪿":"&subplus;","⥹":"&subrarr;","⫇":"&subsim;","⫕":"&subsub;","⫓":"&subsup;","♪":"&sung;","¹":"&sup1;","²":"&sup2;","³":"&sup3;","⫆":"&supseteqq;","⪾":"&supdot;","⫘":"&supdsub;","⫄":"&supedot;","⟉":"&suphsol;","⫗":"&suphsub;","⥻":"&suplarr;","⫂":"&supmult;","⫌":"&supsetneqq;","⊋":"&supsetneq;","⫀":"&supplus;","⫈":"&supsim;","⫔":"&supsub;","⫖":"&supsup;","⇙":"&swArr;","⤪":"&swnwar;","ß":"&szlig;","⌖":"&target;","τ":"&tau;","ť":"&tcaron;","ţ":"&tcedil;","т":"&tcy;","⌕":"&telrec;","𝔱":"&tfr;","θ":"&theta;","ϑ":"&vartheta;","þ":"&thorn;","×":"&times;","⨱":"&timesbar;","⨰":"&timesd;","⌶":"&topbot;","⫱":"&topcir;","𝕥":"&topf;","⫚":"&topfork;","‴":"&tprime;","▵":"&utri;","≜":"&trie;","◬":"&tridot;","⨺":"&triminus;","⨹":"&triplus;","⧍":"&trisb;","⨻":"&tritime;","⏢":"&trpezium;","𝓉":"&tscr;","ц":"&tscy;","ћ":"&tshcy;","ŧ":"&tstrok;","⥣":"&uHar;","ú":"&uacute;","ў":"&ubrcy;","ŭ":"&ubreve;","û":"&ucirc;","у":"&ucy;","ű":"&udblac;","⥾":"&ufisht;","𝔲":"&ufr;","ù":"&ugrave;","▀":"&uhblk;","⌜":"&ulcorner;","⌏":"&ulcrop;","◸":"&ultri;","ū":"&umacr;","ų":"&uogon;","𝕦":"&uopf;","υ":"&upsilon;","⇈":"&uuarr;","⌝":"&urcorner;","⌎":"&urcrop;","ů":"&uring;","◹":"&urtri;","𝓊":"&uscr;","⋰":"&utdot;","ũ":"&utilde;","ü":"&uuml;","⦧":"&uwangle;","⫨":"&vBar;","⫩":"&vBarv;","⦜":"&vangrt;","⊊︀":"&vsubne;","⫋︀":"&vsubnE;","⊋︀":"&vsupne;","⫌︀":"&vsupnE;","в":"&vcy;","⊻":"&veebar;","≚":"&veeeq;","⋮":"&vellip;","𝔳":"&vfr;","𝕧":"&vopf;","𝓋":"&vscr;","⦚":"&vzigzag;","ŵ":"&wcirc;","⩟":"&wedbar;","≙":"&wedgeq;","℘":"&wp;","𝔴":"&wfr;","𝕨":"&wopf;","𝓌":"&wscr;","𝔵":"&xfr;","ξ":"&xi;","⋻":"&xnis;","𝕩":"&xopf;","𝓍":"&xscr;","ý":"&yacute;","я":"&yacy;","ŷ":"&ycirc;","ы":"&ycy;","¥":"&yen;","𝔶":"&yfr;","ї":"&yicy;","𝕪":"&yopf;","𝓎":"&yscr;","ю":"&yucy;","ÿ":"&yuml;","ź":"&zacute;","ž":"&zcaron;","з":"&zcy;","ż":"&zdot;","ζ":"&zeta;","𝔷":"&zfr;","ж":"&zhcy;","⇝":"&zigrarr;","𝕫":"&zopf;","𝓏":"&zscr;","‍":"&zwj;","‌":"&zwnj;"}}}},function(r,e,t){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.numericUnicodeMap={0:65533,128:8364,130:8218,131:402,132:8222,133:8230,134:8224,135:8225,136:710,137:8240,138:352,139:8249,140:338,142:381,145:8216,146:8217,147:8220,148:8221,149:8226,150:8211,151:8212,152:732,153:8482,154:353,155:8250,156:339,158:382,159:376}},function(r,e,t){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.fromCodePoint=String.fromCodePoint||function(r){return String.fromCharCode(Math.floor((r-65536)/1024)+55296,(r-65536)%1024+56320)},e.getCodePoint=String.prototype.codePointAt?function(r,e){return r.codePointAt(e)}:function(r,e){return 1024*(r.charCodeAt(e)-55296)+r.charCodeAt(e+1)-56320+65536},e.highSurrogateFrom=55296,e.highSurrogateTo=56319}])}); 
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports) {
	
	module.exports = {"name":"cw-galatea-api-js","version":"2023.828.0","description":"","main":"index.js","scripts":{"test":"jest --coverage","sonarScanner":"node sonarqube-scanner.js CW_GALATEA_API_JS_DEV","sonarScanner:release":"node sonarqube-scanner.js CW_GALATEA_API_JS_RELEASE"},"author":"Copyright © 2022 Nuxiba Technologies Inc. All Rights Reserved.","license":"ISC","devDependencies":{"babel-core":"^6.25.0","babel-loader":"^7.1.1","babel-preset-es2015":"^6.24.1","babel-preset-stage-0":"^6.24.1","jest":"^23.6.0","jest-html-reporter":"^2.6.0","mocha":"^3.4.2","webpack":"^3.12.0","webpack-auto-inject-version":"^1.2.2","webpack-shell-plugin":"^0.5.0","pre-build-webpack":"^0.1.0","sinon":"^4.0.1","sonarqube-scanner":"^2.8.2"},"dependencies":{"babel-plugin-transform-class-properties":"^6.24.1","chai":"^4.1.0","chdir":"0.0.0","global-cipher-services-js":"git+ssh://git@bitbucket.org/nuxibatechnologies/global-cipher-services-js.git","global-logger-services-js":"git+ssh://git@bitbucket.org/nuxibatechnologies/global-logger-services-js.git","isomorphic-fetch":"^2.2.1"},"jest":{"testEnvironment":"node","moduleFileExtensions":["ts","tsx","js","json"]}}
	
	/***/ })
	/******/ ]);
	});
	//# sourceMappingURL=cw-galatea-api-js-bundle.js.map 

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "Trans", {
	  enumerable: true,
	  get: function get() {
	    return _Trans.Trans;
	  }
	});
	Object.defineProperty(exports, "useTranslation", {
	  enumerable: true,
	  get: function get() {
	    return _useTranslation.useTranslation;
	  }
	});
	Object.defineProperty(exports, "withTranslation", {
	  enumerable: true,
	  get: function get() {
	    return _withTranslation.withTranslation;
	  }
	});
	Object.defineProperty(exports, "Translation", {
	  enumerable: true,
	  get: function get() {
	    return _Translation.Translation;
	  }
	});
	Object.defineProperty(exports, "I18nextProvider", {
	  enumerable: true,
	  get: function get() {
	    return _I18nextProvider.I18nextProvider;
	  }
	});
	Object.defineProperty(exports, "withSSR", {
	  enumerable: true,
	  get: function get() {
	    return _withSSR.withSSR;
	  }
	});
	Object.defineProperty(exports, "useSSR", {
	  enumerable: true,
	  get: function get() {
	    return _useSSR.useSSR;
	  }
	});
	Object.defineProperty(exports, "I18nContext", {
	  enumerable: true,
	  get: function get() {
	    return _context.I18nContext;
	  }
	});
	Object.defineProperty(exports, "initReactI18next", {
	  enumerable: true,
	  get: function get() {
	    return _context.initReactI18next;
	  }
	});
	Object.defineProperty(exports, "setDefaults", {
	  enumerable: true,
	  get: function get() {
	    return _context.setDefaults;
	  }
	});
	Object.defineProperty(exports, "getDefaults", {
	  enumerable: true,
	  get: function get() {
	    return _context.getDefaults;
	  }
	});
	Object.defineProperty(exports, "setI18n", {
	  enumerable: true,
	  get: function get() {
	    return _context.setI18n;
	  }
	});
	Object.defineProperty(exports, "getI18n", {
	  enumerable: true,
	  get: function get() {
	    return _context.getI18n;
	  }
	});
	Object.defineProperty(exports, "composeInitialProps", {
	  enumerable: true,
	  get: function get() {
	    return _context.composeInitialProps;
	  }
	});
	Object.defineProperty(exports, "getInitialProps", {
	  enumerable: true,
	  get: function get() {
	    return _context.getInitialProps;
	  }
	});
	exports.selectOrdinal = exports.plural = exports.select = exports.number = exports.time = exports.date = void 0;
	
	var _Trans = __webpack_require__(2276);
	
	var _useTranslation = __webpack_require__(464);
	
	var _withTranslation = __webpack_require__(2279);
	
	var _Translation = __webpack_require__(2277);
	
	var _I18nextProvider = __webpack_require__(2275);
	
	var _withSSR = __webpack_require__(2278);
	
	var _useSSR = __webpack_require__(934);
	
	var _context = __webpack_require__(184);
	
	var date = function date() {
	  return '';
	};
	
	exports.date = date;
	
	var time = function time() {
	  return '';
	};
	
	exports.time = time;
	
	var number = function number() {
	  return '';
	};
	
	exports.number = number;
	
	var select = function select() {
	  return '';
	};
	
	exports.select = select;
	
	var plural = function plural() {
	  return '';
	};
	
	exports.plural = plural;
	
	var selectOrdinal = function selectOrdinal() {
	  return '';
	};
	
	exports.selectOrdinal = selectOrdinal;

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createChainableTypeChecker = __webpack_require__(467);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function elementType(props, propName, componentName, location, propFullName) {
	  var propValue = props[propName];
	  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);
	
	  if (_react2.default.isValidElement(propValue)) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
	  }
	
	  if (propType !== 'function' && propType !== 'string') {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
	  }
	
	  return null;
	}
	
	exports.default = (0, _createChainableTypeChecker2.default)(elementType);

/***/ },
/* 43 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ },
/* 44 */
[2666, 254, 143, 35],
/* 45 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.secondsInMinute = exports.secondsInHour = exports.quartersInYear = exports.monthsInYear = exports.monthsInQuarter = exports.minutesInHour = exports.minTime = exports.millisecondsInSecond = exports.millisecondsInHour = exports.millisecondsInMinute = exports.maxTime = exports.daysInWeek = void 0;
	
	/**
	 * Days in 1 week.
	 *
	 * @name daysInWeek
	 * @constant
	 * @type {number}
	 * @default
	 */
	var daysInWeek = 7;
	/**
	 * Maximum allowed time.
	 *
	 * @name maxTime
	 * @constant
	 * @type {number}
	 * @default
	 */
	
	exports.daysInWeek = daysInWeek;
	var maxTime = Math.pow(10, 8) * 24 * 60 * 60 * 1000;
	/**
	 * Milliseconds in 1 minute
	 *
	 * @name millisecondsInMinute
	 * @constant
	 * @type {number}
	 * @default
	 */
	
	exports.maxTime = maxTime;
	var millisecondsInMinute = 60000;
	/**
	 * Milliseconds in 1 hour
	 *
	 * @name millisecondsInHour
	 * @constant
	 * @type {number}
	 * @default
	 */
	
	exports.millisecondsInMinute = millisecondsInMinute;
	var millisecondsInHour = 3600000;
	/**
	 * Milliseconds in 1 second
	 *
	 * @name millisecondsInSecond
	 * @constant
	 * @type {number}
	 * @default
	 */
	
	exports.millisecondsInHour = millisecondsInHour;
	var millisecondsInSecond = 1000;
	/**
	 * Minimum allowed time.
	 *
	 * @name minTime
	 * @constant
	 * @type {number}
	 * @default
	 */
	
	exports.millisecondsInSecond = millisecondsInSecond;
	var minTime = -maxTime;
	/**
	 * Minutes in 1 hour
	 *
	 * @name minutesInHour
	 * @constant
	 * @type {number}
	 * @default
	 */
	
	exports.minTime = minTime;
	var minutesInHour = 60;
	/**
	 * Months in 1 quarter
	 *
	 * @name monthsInQuarter
	 * @constant
	 * @type {number}
	 * @default
	 */
	
	exports.minutesInHour = minutesInHour;
	var monthsInQuarter = 3;
	/**
	 * Months in 1 year
	 *
	 * @name monthsInYear
	 * @constant
	 * @type {number}
	 * @default
	 */
	
	exports.monthsInQuarter = monthsInQuarter;
	var monthsInYear = 12;
	/**
	 * Quarters in 1 year
	 *
	 * @name quartersInYear
	 * @constant
	 * @type {number}
	 * @default
	 */
	
	exports.monthsInYear = monthsInYear;
	var quartersInYear = 4;
	/**
	 * Seconds in 1 hour
	 *
	 * @name secondsInHour
	 * @constant
	 * @type {number}
	 * @default
	 */
	
	exports.quartersInYear = quartersInYear;
	var secondsInHour = 3600;
	/**
	 * Seconds in 1 minute
	 *
	 * @name secondsInMinute
	 * @constant
	 * @type {number}
	 * @default
	 */
	
	exports.secondsInHour = secondsInHour;
	var secondsInMinute = 60;
	exports.secondsInMinute = secondsInMinute;

/***/ },
/* 46 */
/***/ function(module, exports) {

	var core = module.exports = { version: '2.6.12' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ },
/* 47 */
[2661, 94],
/* 48 */
[2771, 1962, 2003, 1961, 1991, 1992, 1993, 1994, 1988, 1989, 1990, 1943, 1944, 428, 1946, 704, 1945, 1947, 277, 1964, 1965, 1966, 220, 221, 1942, 1948, 1953, 1951, 1950, 1949, 1957, 1952, 1954, 1955, 1956, 705, 2013, 707, 429, 708, 706, 1958, 1959, 1960, 710, 1963, 713, 2000, 712, 2016, 1999, 1998, 2002, 1984, 1987, 1985, 1986, 715, 2007, 1978, 1967, 1968, 1969, 1970, 1971, 1972, 1973, 1974, 711, 1976, 1983, 1995, 1996, 1997, 2005, 2006, 1975, 703, 2008, 2009, 2010, 709, 1979, 1980, 1981, 1977, 1982, 2011, 2012, 2014, 2015, 2017, 2004, 13, 2018],
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var propTypes = {
	  className: _propTypes["default"].string,
	  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node])
	};
	
	function Layer(props) {
	  var children = props.children,
	      className = props.className,
	      others = _objectWithoutProperties(props, ["children", "className"]);
	
	  var layerClass = (0, _classnames["default"])('recharts-layer', className);
	  return _react["default"].createElement("g", _extends({
	    className: layerClass
	  }, others), children);
	}
	
	Layer.propTypes = propTypes;
	var _default = Layer;
	exports["default"] = _default;

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _globalWebSocketClientJsBundleMin = __webpack_require__(2020);
	
	var _Logger = __webpack_require__(37);
	
	var _singletonSharedData = __webpack_require__(23);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var webSocketClient = null;
	var wsServer = null;
	var _port = null;
	var _that = null;
	var token = null;
	var sharedData = null;
	var _isOpen = false;
	
	var SingletonWebSocket = function () {
	    function SingletonWebSocket() {
	        _classCallCheck(this, SingletonWebSocket);
	
	        this._dataCall = null;
	    }
	
	    _createClass(SingletonWebSocket, [{
	        key: 'dataCall',
	        set: function set(dataCall) {
	            this._dataCall = dataCall;
	        },
	        get: function get() {
	            return this._dataCall;
	        }
	    }], [{
	        key: 'setwsServer',
	        value: function setwsServer(server) {
	            _Logger.Logger.Trace("WebSocket Server: ", server);
	            wsServer = server;
	        }
	    }, {
	        key: 'setUserId',
	        value: function setUserId(value) {
	            if (webSocketClient) {
	                webSocketClient.setUserId(value);
	            }
	        }
	    }, {
	        key: 'SetOnMessage',
	        value: function SetOnMessage(that) {
	            _that = that;
	        }
	    }, {
	        key: 'setPort',
	        value: function setPort(port) {
	            _Logger.Logger.Trace("WebSocket Port: ", port);
	            _port = port;
	        }
	    }, {
	        key: 'connect',
	        value: function connect() {
	            var secureConnection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	            sharedData = new _singletonSharedData.SingletonSharedData();
	            if (!token) {
	                var helperFrameWindow = document.getElementById('helperFrame').contentWindow;
	
	                var getUserId = function getUserId() {
	                    helperFrameWindow.postMessage('getNuxibaTokenAgent', '*');
	                };
	
	                var messageEvent = function messageEvent(event) {
	                    if (!token && typeof event.data === "string") {
	                        token = event.data;
	                        window.removeEventListener('message', messageEvent);
	                        console.log("getNuxibaTokenAgent", token);
	
	                        SingletonWebSocket.validate();
	                        webSocketClient.connect(secureConnection);
	                    }
	                };
	                window.addEventListener('message', messageEvent);
	
	                getUserId();
	            } else {
	                SingletonWebSocket.validate();
	                webSocketClient.connect(secureConnection);
	            }
	        }
	    }, {
	        key: 'validate',
	        value: function validate() {
	            if (!webSocketClient) {
	                webSocketClient = new _globalWebSocketClientJsBundleMin.WebSocketFactory().buildClient();
	                webSocketClient.WSParameter.serverIP = wsServer;
	                webSocketClient.WSParameter.port = _port;
	                webSocketClient.WSParameter.keepAliveTimeRequest = 30000;
	                webSocketClient.WSParameter.keepAliveTimeResponse = 5000;
	                webSocketClient.WSParameter.keepAliveMessage = '{client : "galatea", action: "KeepAlive", ip:"' + token + '"}';
	                webSocketClient.WSParameter.onClose = function () {
	                    if (_that && _that.onCloseIntegration) {
	                        _that.onCloseIntegration();
	                    }
	                };
	                webSocketClient.WSParameter.onMessage = function (message) {
	                    _Logger.Logger.Trace("Socket Response", message);
	                    if (message.data === "added" && _that && _that.onOpenIntegration) {
	                        _that.onOpenIntegration();
	                    } else if (_that && _that.onIntegrationMessage) {
	                        _that.onIntegrationMessage(JSON.parse(message.data));
	                    }
	                };
	                webSocketClient.WSParameter.onOpen = function () {
	                    _isOpen = true;
	                    var message = { action: "firstConnection" };
	                    SingletonWebSocket.send(message);
	                };
	                webSocketClient.WSParameter.onError = function (err) {
	                    _isOpen = false;
	                    if (_that && _that.onError) {
	                        _that.onError(err);
	                    }
	                };
	            }
	        }
	    }, {
	        key: 'send',
	        value: function send(message) {
	            if (webSocketClient && _isOpen) {
	                message.agentId = sharedData.getUserData() ? sharedData.getUserData().User_id : 0;
	
	                message.userName = sharedData.getUserData() ? sharedData.getUserData().Login : "0";
	
	                message.ip = token;
	                message.client = "galatea";
	                webSocketClient.send(JSON.stringify(message));
	                _that.addIntegrationLog("Message Sent", message);
	            }
	        }
	    }, {
	        key: 'getJson',
	        value: function getJson(action, subaction, data) {
	            var dataObject = !data || typeof data === "undefined" ? "" : data;
	            return {
	                client: "galatea",
	                data: dataObject,
	                action: action,
	                subaction: subaction
	            };
	        }
	    }, {
	        key: 'getJsonError',
	        value: function getJsonError(code, message) {
	            return {
	                code: code,
	                message: message
	            };
	        }
	    }, {
	        key: 'close',
	        value: function close() {
	            if (webSocketClient) {
	                webSocketClient.close();
	                webSocketClient = null;
	            }
	        }
	    }]);
	
	    return SingletonWebSocket;
	}();
	
	exports.default = SingletonWebSocket;

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.arrowNDlogSVG = exports.agentSVG = exports.clockIcon = exports.triangle = exports.deleteNumber = exports.starFav = exports.btnClear = exports.arrowBack = exports.tacheCirculo = exports.send = exports.closeSvg = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var closeSvg = exports.closeSvg = _react2.default.createElement(
		"svg",
		{ className: "closeSvg", version: "1.1", id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
			width: "100%", height: "100%", viewBox: "-3.083 -2.083 30 30", enableBackground: "new -3.083 -2.083 30 30", xmlSpace: "preserve" },
		_react2.default.createElement(
			"g",
			{ id: "Group_2473", transform: "translate(-732 8712)" },
			_react2.default.createElement("path", { id: "Path_531", d: "M749.661-8707.083l-5.744,5.744l-5.744-5.744l-2.256,2.257l5.744,5.743l-5.744,5.743\r l2.256,2.257l5.744-5.743l5.744,5.743l2.256-2.257l-5.744-5.743l5.744-5.743L749.661-8707.083z" })
		)
	);
	
	var send = exports.send = _react2.default.createElement(
		"svg",
		{ version: "1.1", id: "Capa_1", className: "sendSVG", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
			viewBox: "0 0 17.3 14", enableBackground: "new 0 0 17.3 14;", xmlSpace: "preserve" },
		_react2.default.createElement(
			"g",
			{ id: "Group_3967", transform: "translate(-10472 -10547) rotate(-30)" },
			_react2.default.createElement(
				"g",
				{ id: "Group_984", transform: "translate(0)" },
				_react2.default.createElement("path", { id: "Path_570", className: "st0", d: "M3794.5,14371.8l0,5.3l11.4,1.5l-11.4,1.5l0,5.3l16-6.9L3794.5,14371.8z" })
			)
		)
	);
	
	var tacheCirculo = exports.tacheCirculo = _react2.default.createElement(
		"svg",
		{ xmlns: "http://www.w3.org/2000/svg", viewBox: "4426 4347 16 16" },
		_react2.default.createElement(
			"defs",
			null,
			_react2.default.createElement(
				"clipPath",
				{ id: "clip-path" },
				_react2.default.createElement("path", { id: "Path_1711", "data-name": "Path 1711", className: "cls-1", d: "M0-20H16V-4H0Z", transform: "translate(0 20)" })
			)
		),
		_react2.default.createElement(
			"g",
			{ id: "Group_5421", "data-name": "Group 5421", className: "cls-2", transform: "translate(4426 4347)" },
			_react2.default.createElement(
				"g",
				{ id: "Group_3172", "data-name": "Group 3172", className: "cls-3" },
				_react2.default.createElement(
					"g",
					{ id: "Group_3171", "data-name": "Group 3171", transform: "translate(0 0)" },
					_react2.default.createElement("path", { id: "Path_1710", "data-name": "Path 1710", d: "M-3-2.718-4.128-1.59-7-4.462-9.872-1.59-11-2.718-8.128-5.59-11-8.462-9.872-9.59-7-6.718-4.128-9.59-3-8.462-5.872-5.59ZM-7-13.59a7.993,7.993,0,0,0-8,8,7.993,7.993,0,0,0,8,8,7.993,7.993,0,0,0,8-8,7.993,7.993,0,0,0-8-8", transform: "translate(15 13.59)" })
				)
			)
		)
	);
	
	var arrowBack = exports.arrowBack = _react2.default.createElement(
		"svg",
		{ version: "1.1", className: "arrowBack", id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
			width: "100%", height: "100%", viewBox: "0 0 640 480", enableBackground: "new 0 0 640 480;", xmlSpace: "preserve" },
		_react2.default.createElement(
			"g",
			{ id: "Group_958", transform: "translate(80 82) rotate(-90)" },
			_react2.default.createElement(
				"g",
				{ id: "Group_957" },
				_react2.default.createElement(
					"g",
					{ id: "Group_956" },
					_react2.default.createElement(
						"g",
						{ id: "Group_955" },
						_react2.default.createElement(
							"g",
							{ id: "Group_954" },
							_react2.default.createElement("path", { id: "Path_560", className: "st0", d: "M-271.5,332.7l114.4-114.2L-43,332.7l35.3-35.1l-149.5-149.5l-149.5,149.5L-271.5,332.7z" })
						)
					)
				)
			)
		)
	);
	
	var btnClear = exports.btnClear = _react2.default.createElement(
		"svg",
		{ version: "1.1", className: "btnClearSVG", id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
			viewBox: "0 0 30 30", enableBackground: "new 0 0 30 30;", xmlSpace: "preserve" },
		_react2.default.createElement("path", { className: "st0", d: "M15,1.2C7.5,1.2,1.3,7.3,1.3,14.9c0,7.6,6.2,13.7,13.7,13.7c7.6,0,13.7-6.2,13.7-13.7C28.8,7.3,22.6,1.2,15,1.2\r z M23,20.6l-2.3,2.3L15,17.2l-5.7,5.7L7,20.6l5.7-5.7L7,9.2l2.3-2.3l5.7,5.7l5.7-5.7L23,9.2l-5.7,5.7L23,20.6z" })
	);
	
	var starFav = exports.starFav = _react2.default.createElement(
		"svg",
		{ version: "1.1", className: "starFav", id: "Capa_1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
			viewBox: "0 0 20 20", enableBackground: "new 0 0 20 20;", xmlSpace: "preserve" },
		_react2.default.createElement("path", { id: "Path_2060", className: "st1", d: "M10,13.2l3.7,2.8l-1.4-4.6L16,8.7h-4.6L10,4L8.6,8.7H4l3.7,2.7L6.3,16L10,13.2z" })
	);
	
	var deleteNumber = exports.deleteNumber = _react2.default.createElement(
		"svg",
		{ version: "1.1", className: "deleteNumberSVG", id: "Capa_1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
			viewBox: "0 0 21.3 16", enableBackground: "new 0 0 21.3 16;", xmlSpace: "preserve" },
		_react2.default.createElement("path", { id: "Path_1974", className: "st0", d: "M19.6,0H6.2C5.6,0,5.1,0.3,4.8,0.8L0,8l4.8,7.2C5.1,15.7,5.6,16,6.2,16h13.3\r c1,0,1.8-0.8,1.8-1.8V1.8C21.3,0.8,20.5,0,19.6,0z M16.9,11.2l-1.2,1.2l-3.2-3.2l-3.2,3.2L8,11.2L11.2,8L8,4.8l1.2-1.2l3.2,3.2\r l3.2-3.2l1.2,1.2L13.7,8L16.9,11.2z" })
	);
	
	var triangle = exports.triangle = _react2.default.createElement(
		"svg",
		{ version: "1.1", className: "triangleSVG", id: "Capa_1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
			viewBox: "0 0 8 7", enableBackground: "new 0 0 8 7;", xmlSpace: "preserve" },
		_react2.default.createElement("path", { id: "Path_1131", className: "st0", d: "M8,0H0l4,7L8,0z" })
	);
	
	var clockIcon = exports.clockIcon = _react2.default.createElement(
		"svg",
		{ className: "clockSvg", version: "1.1", id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
			viewBox: "0 0 40 40", enableBackground: "new 0 0 40 40", xmlSpace: "preserve" },
		_react2.default.createElement(
			"g",
			null,
			_react2.default.createElement(
				"g",
				null,
				_react2.default.createElement("path", { className: "st0", d: "M20,1.1C9.6,1.1,1.1,9.6,1.1,20S9.6,38.9,20,38.9c10.5,0,18.9-8.5,18.9-18.9S30.4,1.1,20,1.1z M20,35.1\r c-8.4,0-15.1-6.8-15.1-15.1S11.7,4.9,20,4.9S35.1,11.7,35.1,20S28.4,35.1,20,35.1z" }),
				_react2.default.createElement("path", { className: "st0", d: "M21,10.6h-2.8v11.3l9.9,6l1.4-2.3l-8.5-5V10.6z" })
			)
		)
	);
	
	var agentSVG = exports.agentSVG = _react2.default.createElement(
		"svg",
		{ version: "1.1", id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
			viewBox: "0 0 640 480", enableBackground: "new 0 0 640 480", xmlSpace: "preserve" },
		_react2.default.createElement(
			"g",
			{ id: "Group_951", transform: "translate(2124 1771)" },
			_react2.default.createElement(
				"g",
				{ id: "Group_949", transform: "translate(3 0)" },
				_react2.default.createElement("path", { id: "Path_556", className: "st0", d: "M-1829.9-1766.5c55.1,0,99.8,44.7,99.8,99.8c0,55.1-44.7,99.8-99.8,99.8s-99.8-44.7-99.8-99.8\r C-1929.8-1721.8-1885-1766.5-1829.9-1766.5" })
			),
			_react2.default.createElement(
				"g",
				{ id: "Group_950", transform: "translate(0 7.9)" },
				_react2.default.createElement("path", { id: "Path_557", className: "st0", d: "M-1826.9-1301.9c-80.3,0-155.3-40.2-199.7-107.2c1-66.3,133.1-102.5,199.7-102.5\r s198.7,36.2,199.7,102.5C-1671.7-1342.1-1746.6-1301.9-1826.9-1301.9" })
			)
		)
	);
	
	var arrowNDlogSVG = exports.arrowNDlogSVG = _react2.default.createElement(
		"svg",
		{ version: "1.1", id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
			width: "12px", height: "7.411px", viewBox: "0 0 12 7.411", enableBackground: "new 0 0 12 7.411", xmlSpace: "preserve" },
		_react2.default.createElement("path", { id: "Path_989", fill: "#D5D5D5", d: "M6,7.411l6-6L10.59,0L6,4.58L1.411,0L0,1.411L6,7.411z" })
	);

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.incrementDiscardedRegisters = incrementDiscardedRegisters;
	exports.savePreviewRecord = savePreviewRecord;
	exports.updatePreviewRecord = updatePreviewRecord;
	exports.updatePreviewTime = updatePreviewTime;
	exports.setTempData = setTempData;
	exports.cleanData = cleanData;
	exports.setPhoneToCall = setPhoneToCall;
	exports.changeCampaignType = changeCampaignType;
	exports.isSuccessfullChangeCamp = isSuccessfullChangeCamp;
	exports.setIsRunningClock = setIsRunningClock;
	exports.setNewPreviewTime = setNewPreviewTime;
	exports.saveTotalPreviewTime = saveTotalPreviewTime;
	exports.saveInitialTime = saveInitialTime;
	exports.saveDataFromTransfer = saveDataFromTransfer;
	exports.setDialogTime = setDialogTime;
	exports.setDialingMode = setDialingMode;
	exports.setIsSendProcess = setIsSendProcess;
	exports.setTempPrevRecord = setTempPrevRecord;
	exports.setPreviewSelectedCampaign = setPreviewSelectedCampaign;
	exports.saveTotalTimePerRec = saveTotalTimePerRec;
	exports.setPhoneToCallPerRec = setPhoneToCallPerRec;
	exports.removeRecord = removeRecord;
	exports.saveLogDial = saveLogDial;
	exports.setItSimultaneousView = setItSimultaneousView;
	exports.changePreviewRecordStatus = changePreviewRecordStatus;
	exports.setInitialDialogTime = setInitialDialogTime;
	exports.setSelectedRecord = setSelectedRecord;
	exports.resetRecordPreview = resetRecordPreview;
	exports.setCallId = setCallId;
	exports.setDialogTimeSimultaneousView = setDialogTimeSimultaneousView;
	exports.setMaximumAssignmentPreview = setMaximumAssignmentPreview;
	exports.setWasItwasSentPreviewTime = setWasItwasSentPreviewTime;
	exports.setVolume = setVolume;
	exports.setMarks = setMarks;
	exports.setDispositionData = setDispositionData;
	exports.setNDScheduled = setNDScheduled;
	exports.setFlagLogDial = setFlagLogDial;
	
	var _constants = __webpack_require__(10);
	
	var _formats = __webpack_require__(54);
	
	function incrementDiscardedRegisters() {
	  return {
	    type: _constants.PREVIEW.INCREMENT_DISCARDED
	  };
	}
	function savePreviewRecord(record) {
	  return {
	    type: _constants.PREVIEW.SET_PREVIEW_RECORD,
	    payload: record
	  };
	}
	function updatePreviewRecord(record) {
	  return {
	    type: _constants.PREVIEW.UPDATE_PREVIEW_RECORD,
	    payload: record
	  };
	}
	function updatePreviewTime(time) {
	  return {
	    type: _constants.PREVIEW.UPDATE_PREVIEWTIME,
	    payload: time
	  };
	}
	function setTempData(tempData) {
	  return {
	    type: _constants.PREVIEW.SET_TEMP_DATA,
	    payload: tempData
	  };
	}
	function cleanData() {
	  return {
	    type: _constants.PREVIEW.CLEAN_DATA
	  };
	}
	function setPhoneToCall(phone) {
	  return {
	    type: _constants.PREVIEW.SET_PHONE_CALL,
	    payload: phone
	  };
	}
	function changeCampaignType(flag) {
	  return {
	    type: _constants.PREVIEW.CHANGE_CAMPAIGN_TYPE,
	    payload: flag
	  };
	}
	function isSuccessfullChangeCamp(change) {
	  return {
	    type: _constants.PREVIEW.SUCCESSFUL_CHANGE,
	    payload: change
	  };
	}
	function setIsRunningClock(flag) {
	  return {
	    type: _constants.PREVIEW.SET_ISRUNNING_CLOCK,
	    payload: flag
	  };
	}
	function setNewPreviewTime(time) {
	  return {
	    type: _constants.PREVIEW.SET_NEWPREVIEW_TIME,
	    payload: time
	  };
	}
	function saveTotalPreviewTime(time) {
	  return {
	    type: _constants.PREVIEW.SET_FINAL_TIME,
	    payload: time
	  };
	}
	function saveInitialTime() {
	  var time = (0, _formats.getCurrentTimeInSec)();
	  return {
	    type: _constants.PREVIEW.SET_INITIAL_TIME,
	    payload: time
	  };
	}
	function saveDataFromTransfer(data) {
	  return {
	    type: _constants.PREVIEW.SET_DATA_TRANSFER,
	    payload: data
	  };
	}
	function setDialogTime(data) {
	  return {
	    type: _constants.PREVIEW.SET_DIALOG_TIME,
	    payload: data
	  };
	}
	function setDialingMode(data) {
	  return {
	    type: _constants.PREVIEW.SET_DIALINGMODE,
	    payload: data
	  };
	}
	function setIsSendProcess(data) {
	  return {
	    type: _constants.PREVIEW.SET_IS_SEND_PROCESS,
	    payload: data
	  };
	}
	function setTempPrevRecord(data) {
	  return {
	    type: _constants.PREVIEW.SET_TEMP_PREVIEW_RECORD,
	    payload: data
	  };
	}
	function setPreviewSelectedCampaign(data) {
	  return {
	    type: _constants.PREVIEW.SELECTED_PREVIEW_CAMPAIGN,
	    payload: data
	  };
	}
	function saveTotalTimePerRec(data) {
	  return {
	    type: _constants.PREVIEW_SIMULTANEOUS_REC.SET_TOTAL_TIME,
	    payload: data
	  };
	}
	function setPhoneToCallPerRec(data) {
	  return {
	    type: _constants.PREVIEW_SIMULTANEOUS_REC.SET_PHONE_TO_CALL,
	    payload: data
	  };
	}
	function removeRecord(data) {
	  return {
	    type: _constants.PREVIEW_SIMULTANEOUS_REC.REMOVE_RECORD,
	    payload: data //
	  };
	}
	function saveLogDial(data) {
	  return {
	    type: _constants.PREVIEW_SIMULTANEOUS_REC.SAVE_LOG_DIAL,
	    payload: data
	  };
	}
	function setItSimultaneousView(data) {
	  return {
	    type: _constants.PREVIEW_SIMULTANEOUS_REC.SET_INITIAL_TIMESEC,
	    payload: data
	  };
	}
	function changePreviewRecordStatus(payload) {
	  return {
	    type: _constants.PREVIEW_SIMULTANEOUS_REC.CHANGE_RECORD_STATE,
	    payload: payload
	  };
	}
	function setInitialDialogTime(payload) {
	  return {
	    type: _constants.PREVIEW_SIMULTANEOUS_REC.SET_INITIAL_DIALOG_TIME,
	    payload: payload
	  };
	}
	function setSelectedRecord(payload) {
	  return {
	    type: _constants.PREVIEW_SIMULTANEOUS_REC.SELECTED_RECORD,
	    payload: payload
	  };
	}
	function resetRecordPreview(payload) {
	  return {
	    type: _constants.PREVIEW_SIMULTANEOUS_REC.RESET_RECORD,
	    payload: payload
	  };
	}
	function setCallId(payload) {
	  return {
	    type: _constants.PREVIEW_SIMULTANEOUS_REC.SET_CALL_ID,
	    payload: payload
	  };
	}
	function setDialogTimeSimultaneousView(payload) {
	  return {
	    type: _constants.PREVIEW_SIMULTANEOUS_REC.SET_DIALOG_TIME,
	    payload: payload
	  };
	}
	function setMaximumAssignmentPreview(payload) {
	  return {
	    type: _constants.PREVIEW_SIMULTANEOUS_REC.SET_MAXIMUM_ASSIGNMENTS,
	    payload: payload
	  };
	}
	function setWasItwasSentPreviewTime(payload) {
	  return {
	    type: _constants.PREVIEW_SIMULTANEOUS_REC.SET_IT_WAS_SENT_TIME,
	    payload: payload
	  };
	}
	function setVolume(payload) {
	  return {
	    type: _constants.PREVIEW_SIMULTANEOUS_REC.SET_VOLUME,
	    payload: payload
	  };
	}
	function setMarks(payload) {
	  return {
	    type: _constants.PREVIEW_SIMULTANEOUS_REC.SET_MARKS,
	    payload: payload
	  };
	}
	
	function setDispositionData(payload) {
	  return {
	    type: _constants.PREVIEW_SIMULTANEOUS_REC.SET_DISPOSITION_DATA,
	    payload: payload
	  };
	}
	
	function setNDScheduled() {
	  return {
	    type: _constants.PREVIEW_SIMULTANEOUS_REC.SET_ND_SCHEDULED
	  };
	}
	
	function setFlagLogDial(payload) {
	  return {
	    type: _constants.PREVIEW_SIMULTANEOUS_REC.SET_FLAG_LOGDIAL,
	    payload: payload
	  };
	}

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getLocation = exports.getFilenameFromURL = exports.fileSizeReadable = exports.fileExtension = exports.countUnread = exports.cheksWhatsApp = exports.addTarget = void 0;
	exports.getOuterWidth = getOuterWidth;
	exports.urlFormatHelper = exports.updateArrayImmutably = exports.removeFromObjectImmutably = exports.mimeTypeLeft = exports.linkify = exports.linebreaks = exports.isValidURL = exports.isValidMail = exports.isValidDate = exports.isUnsafeFile = exports.isUnattended = exports.isNotFileAllowed = exports.isNewMedia2 = exports.isNewMedia = exports.isLocalServer = exports.isImageURL = exports.isImageType = exports.isChatStarted = exports.hasUnread = exports.groupImages = void 0;
	var _react = _interopRequireDefault(__webpack_require__(1));
	var _constants = __webpack_require__(58);
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
	function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
	var linkify = exports.linkify = function linkify(text) {
	  var urlRegex = /(\b(?:(?:https?|ftp|file):\/\/|www\.)[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/gi;
	  return text.split(urlRegex).map(function (e, i) {
	    return urlRegex.test(e) ? /*#__PURE__*/_react["default"].createElement("a", {
	      key: i,
	      target: "_blank",
	      rel: "noopener noreferrer",
	      href: e.startsWith('www') ? 'http://' + e : e
	    }, e) : e;
	  });
	};
	var splitBreaks = function splitBreaks(text) {
	  var lines = [];
	  text.split('\n').map(function (t, i) {
	    return lines.push.apply(lines, [t, /*#__PURE__*/_react["default"].createElement("br", {
	      key: i
	    })]);
	  });
	  return lines;
	};
	var linebreaks = exports.linebreaks = function linebreaks(texts) {
	  var newtexts = [];
	  texts.map(function (text) {
	    return typeof text === 'string' && text.includes('\n') ? newtexts.push.apply(newtexts, _toConsumableArray(splitBreaks(text))) : newtexts.push(text);
	  });
	  return newtexts;
	};
	var onImageClick = function onImageClick(e, onClick) {
	  return onClick ? onClick(Number(e.currentTarget.id)) : undefined;
	};
	var groupImages = exports.groupImages = function groupImages(arr, _onClick) {
	  if (arr.length <= 2) return arr.map(function (image, i) {
	    return /*#__PURE__*/_react["default"].createElement("img", {
	      key: i,
	      id: i,
	      src: image,
	      alt: 'image' + i,
	      onClick: function onClick(e) {
	        return onImageClick(e, _onClick);
	      }
	    });
	  });else if (arr.length === 3) return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("img", {
	    id: 0,
	    src: arr[0],
	    alt: "image0",
	    onClick: function onClick(e) {
	      return onImageClick(e, _onClick);
	    }
	  }), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("img", {
	    id: 1,
	    src: arr[1],
	    alt: "image1",
	    onClick: function onClick(e) {
	      return onImageClick(e, _onClick);
	    }
	  }), /*#__PURE__*/_react["default"].createElement("img", {
	    id: 2,
	    src: arr[2],
	    alt: "image2",
	    onClick: function onClick(e) {
	      return onImageClick(e, _onClick);
	    }
	  })));else return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("img", {
	    id: 0,
	    src: arr[0],
	    alt: "image0",
	    onClick: function onClick(e) {
	      return onImageClick(e, _onClick);
	    }
	  }), /*#__PURE__*/_react["default"].createElement("img", {
	    id: 2,
	    src: arr[2],
	    alt: "image2",
	    onClick: function onClick(e) {
	      return onImageClick(e, _onClick);
	    }
	  })), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("img", {
	    id: 1,
	    src: arr[1],
	    alt: "image1",
	    onClick: function onClick(e) {
	      return onImageClick(e, _onClick);
	    }
	  }), /*#__PURE__*/_react["default"].createElement("img", {
	    id: 3,
	    src: arr[3],
	    alt: "image3",
	    onClick: function onClick(e) {
	      return onImageClick(e, _onClick);
	    }
	  }), arr.length >= 5 && /*#__PURE__*/_react["default"].createElement("span", {
	    onClick: _onClick ? function () {
	      return _onClick(0);
	    } : undefined
	  }, "+", arr.length - 4)));
	};
	var countUnread = exports.countUnread = function countUnread(messages) {
	  return messages.reduce(function (counter, _ref) {
	    var seen = _ref.seen,
	      origin = _ref.origin;
	    return !seen && origin !== 'AGENT' ? counter + 1 : counter;
	  }, 0);
	};
	var hasUnread = exports.hasUnread = function hasUnread(messages, type, unread) {
	  if (isNewMedia(type)) {
	    return unread;
	  } else {
	    return messages.some(function (m) {
	      return !m.seen;
	    });
	  }
	};
	var isUnattended = exports.isUnattended = function isUnattended(c, active) {
	  return !active && c.messages && hasUnread(c.messages, c.type, c.unreadMessage);
	};
	var isChatStarted = exports.isChatStarted = function isChatStarted(c) {
	  if (isNewMedia(c.type)) {
	    return c.chatStarted === undefined ? false : c.chatStarted;
	  }
	  return true;
	};
	var isNewMedia = exports.isNewMedia = function isNewMedia(type) {
	  return type !== 'TWITTER' && type !== 'MAIL' && type !== 'CHAT' && type !== '' && type !== undefined;
	};
	var isNewMedia2 = exports.isNewMedia2 = function isNewMedia2(type) {
	  return type !== 'TWITTER' && type !== 'CHAT' && type !== '' && type !== undefined;
	};
	var urlFormatHelper = exports.urlFormatHelper = function urlFormatHelper(url, source) {
	  var mult = 'WhatsApp';
	  var multChat = 'chats';
	  if (url.includes(mult) && source === _constants.MSG_SOURCE.USER) {
	    var index0 = url.indexOf('WhatsApp');
	    var host = window.location.protocol + '//' + (window.location.hostname === 'localhost' ? '192.168.1.30' : window.location.hostname) + '/WhatsAppMedia';
	    var subUrl = url.substring(index0 + mult.length);
	    subUrl = decodeURIComponent(subUrl);
	    var pipeIndex = subUrl.indexOf('|');
	    if (pipeIndex !== -1) {
	      subUrl = subUrl.substring(0, pipeIndex);
	    }
	    return host + subUrl;
	  } else if (url.includes(multChat)) {
	    var _index = url.indexOf('chats');
	    var _host = window.location.protocol + '//' + (window.location.hostname === 'localhost' ? '192.168.1.33' : window.location.hostname) + '/chats';
	    var _subUrl = url.substring(_index + multChat.length);
	    _subUrl = decodeURIComponent(_subUrl);
	    var _pipeIndex = _subUrl.indexOf('|');
	    if (_pipeIndex !== -1) {
	      _subUrl = _subUrl.substring(0, _pipeIndex);
	    }
	    return _host + _subUrl;
	  }
	  return url;
	};
	
	/* istanbul ignore next */
	var updateArrayImmutably = exports.updateArrayImmutably = function updateArrayImmutably(arr, i, value) {
	  return Object.assign(_toConsumableArray(arr), _defineProperty({}, i, value));
	};
	var removeFromObjectImmutably = exports.removeFromObjectImmutably = function removeFromObjectImmutably(key, _ref2) {
	  var _ = _ref2[key],
	    newObj = _objectWithoutProperties(_ref2, [key].map(_toPropertyKey));
	  return newObj;
	};
	var isValidDate = exports.isValidDate = function isValidDate(date) {
	  if (date) {
	    if (date instanceof Date) {
	      return true;
	    } else if (!isNaN(new Date(date))) {
	      return true;
	    } else {
	      return false;
	    }
	  }
	  return false;
	};
	var mailRegEx = RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]{2,}\.)+[a-zA-Z]{2,}))$/);
	var isValidMail = exports.isValidMail = function isValidMail(mail) {
	  return mailRegEx.test(mail);
	};
	var urlRegEx = RegExp(/[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/);
	var isValidURL = exports.isValidURL = function isValidURL(url) {
	  if (urlRegEx.test(url)) {
	    try {
	      new URL(url);
	      return true;
	    } catch (_unused) {
	      return false;
	    }
	  }
	  return false;
	};
	var isImageURL = exports.isImageURL = function isImageURL(url) {
	  if (!url) return false;
	  if (!isValidURL(url)) return false;
	  var ext = new URL(url, url.startsWith('/') ? window.location.origin : undefined).pathname.split('.').pop();
	  return ['jpg', 'png', 'jpeg', 'gif', 'bmp'].includes(ext);
	};
	var isImageType = exports.isImageType = function isImageType(file) {
	  return file.type.split('/')[0] === 'image';
	};
	var getFilenameFromURL = exports.getFilenameFromURL = function getFilenameFromURL(url) {
	  return isValidURL(url) ? decodeURI(new URL(url).pathname.split('/').pop()) : '';
	};
	var isUnsafeFile = exports.isUnsafeFile = function isUnsafeFile(file) {
	  var ext = file.name.split('.').pop();
	  return _constants.UNSAFE_FILE_EXTS.includes(ext);
	};
	var getLocation = exports.getLocation = function getLocation(contentHtml, hostname, href) {
	  var environment = href.split('/')[0];
	  hostname = environment + '//' + hostname + '/EmailFiles';
	  var res = contentHtml.split('$domain$').join(hostname);
	  res = addTarget(res);
	  return res;
	};
	var addTarget = exports.addTarget = function addTarget(contentHtml) {
	  var result = contentHtml.split('<a ').join('<a target="_blank"');
	  return result;
	};
	var cheksWhatsApp = exports.cheksWhatsApp = function cheksWhatsApp(status) {
	  return status === 'send' || status === 'submitted' ? 'sent-v02' : 'read-v02';
	};
	function getOuterWidth(el) {
	  var style = getComputedStyle(el);
	  return el.offsetWidth + (parseInt(style.marginLeft, 10) || 0) + (parseInt(style.marginRight, 10) || 0);
	}
	var mimeTypeLeft = exports.mimeTypeLeft = function mimeTypeLeft(mime) {
	  return mime.split('/')[0];
	};
	var fileSizeReadable = exports.fileSizeReadable = function fileSizeReadable(size) {
	  if (isNaN(size)) {
	    return '';
	  } else if (size >= 1000000000) {
	    return Math.ceil(size / 1000000000) + ' GB';
	  } else if (size >= 1000000) {
	    return Math.ceil(size / 1000000) + ' MB';
	  } else if (size >= 1000) {
	    return Math.ceil(size / 1000) + ' kB';
	  } else {
	    return Math.ceil(size) + ' B';
	  }
	};
	var fileExtension = exports.fileExtension = function fileExtension(file) {
	  var extensionSplit = file.split('.');
	  if (extensionSplit.length > 1) {
	    return extensionSplit[extensionSplit.length - 1];
	  } else {
	    return 'none';
	  }
	};
	var isLocalServer = exports.isLocalServer = function isLocalServer() {
	  return window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' || window.location.hostname === '';
	};
	var isNotFileAllowed = exports.isNotFileAllowed = function isNotFileAllowed(file) {
	  var ext = file.name.split('.').pop();
	  return !['jpg', 'png', 'PNG', 'jpeg', 'gif', 'bmp'].includes(ext);
	};

/***/ },
/* 54 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.secondsToFormat = secondsToFormat;
	exports.encodeUnescapedStr = encodeUnescapedStr;
	exports.decodeUnescapedStr = decodeUnescapedStr;
	exports.hidePhone = hidePhone;
	exports.getCurrentTimeInSec = getCurrentTimeInSec;
	function secondsToFormat(seconds) {
	  var hours = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	  var date = new Date(null);
	  seconds ? date.setSeconds(seconds) : date.setSeconds(0);
	  return hours ? date.toISOString().substr(11, 8) : date.toISOString().substr(14, 5);
	}
	
	function encodeUnescapedStr(str) {
	  var buf = [];
	  for (var i = str.length - 1; i >= 0; i--) {
	    buf.unshift(['&#', str[i].charCodeAt(), ';'].join(''));
	  }
	  return buf.join('');
	}
	
	function decodeUnescapedStr(str) {
	  return str.replace(/&#(\d+);/g, function (match, dec) {
	    return String.fromCharCode(dec);
	  });
	}
	
	function hidePhone(hidePhoneValue, phoneNumber) {
	  if (phoneNumber) {
	    if (hidePhoneValue === '-1') {
	      return phoneNumber.replace(/./g, "*");
	    } else if (hidePhoneValue > 0) {
	      var regex = new RegExp(".(?=.{" + hidePhoneValue + ",}$)", 'g');
	      return phoneNumber.replace(regex, "*");
	    } else {
	      return phoneNumber;
	    }
	  } else {
	    return phoneNumber;
	  }
	}
	function getCurrentTimeInSec() {
	  var currentTime = new Date();
	  var currentHourInSeconds = currentTime.getHours() * 3600;
	  var currentMinutesInSeconds = currentTime.getMinutes() * 60;
	  var currentSeconds = currentTime.getSeconds();
	  return currentHourInSeconds + currentMinutesInSeconds + currentSeconds;
	}

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.insertWindow = insertWindow;
	exports.removeWindow = removeWindow;
	
	var _constants = __webpack_require__(10);
	
	function insertWindow(dragComponent, closeComponentIfOpen) {
	  return {
	    type: _constants.DRAGGABLE_WINDOWS_ACTIONS.INSERT_WINDOW,
	    closeIfOpen: closeComponentIfOpen,
	    draggableComponent: dragComponent
	  };
	}
	
	function removeWindow(iDdragComponents) {
	  var drag = [];
	
	  if (typeof iDdragComponents !== 'undefined' && iDdragComponents !== null) {
	    if (typeof iDdragComponents === 'string') {
	      drag = [iDdragComponents];
	    } else {
	      drag = iDdragComponents;
	    }
	  }
	  return {
	    type: _constants.DRAGGABLE_WINDOWS_ACTIONS.REMOVE_WINDOW,
	    idComponents: drag
	  };
	}

/***/ },
/* 56 */
[2629, 34],
/* 57 */
[2645, 33, 539, 118, 56],
/* 58 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.USER_STATE = exports.UNSAFE_FILE_EXTS = exports.TEXT_ALIGN = exports.TABS = exports.REASSIGNED_TYPES = exports.NOTIFICATIONS = exports.MSG_SOURCE = exports.MEDIATYPE = exports.LIST_TYPES = exports.FONT_SIZES = exports.FONTS = exports.FILE_ICONS = exports.COLORS = exports.CAMPTYPE = void 0;
	var MEDIATYPE = exports.MEDIATYPE = {
	  CHAT: 1,
	  MAIL: 2,
	  TWITTER: 3,
	  WHATSAPP: 5
	};
	var TABS = exports.TABS = {
	  HOME: 'HOME',
	  TWITTER: 'TWITTER',
	  CHAT: 'CHAT',
	  MAIL: 'MAIL',
	  WHATSAPP: 'WHATSAPP',
	  MESSENGER: 'MESSENGER',
	  TELEGRAM: 'TELEGRAM'
	};
	var CAMPTYPE = exports.CAMPTYPE = {
	  INBOUND: 0,
	  OUTBOUND: 1
	};
	var NOTIFICATIONS = exports.NOTIFICATIONS = {
	  TWITTER: 'tweet',
	  CHAT: 'chat',
	  MAIL: 'mail'
	};
	var MSG_SOURCE = exports.MSG_SOURCE = {
	  USER: 'USER',
	  AGENT: 'AGENT',
	  ADMIN: 'ADMIN',
	  COACH: 'COACH'
	};
	var COLORS = exports.COLORS = {
	  red: '#FF0000',
	  coralred: '#FF4040',
	  vividtangerine: '#FF8080',
	  evony: '#05060B',
	  abbey: '#444548',
	  oslogray: '#828385',
	  blueribbon: '#0062FF',
	  dodgerblue: '#408AFF',
	  malibu: '#80B1FF',
	  japaneselaurel: '#1FA000',
	  apple: '#57B840',
	  deyork: '#8FCF80',
	  flushorange: '#FF7F00',
	  yelloworange: '#FF9F40',
	  macaroniandcheese: '#FFBF80'
	};
	var FONT_SIZES = exports.FONT_SIZES = {
	  8: '8px',
	  10: '10px',
	  12: '12px',
	  14: '14px',
	  16: '16px',
	  18: '18px',
	  20: '20px',
	  22: '22px'
	};
	var TEXT_ALIGN = exports.TEXT_ALIGN = {
	  left: 'left',
	  center: 'center',
	  right: 'right'
	};
	var FONTS = exports.FONTS = {
	  Arial: 'Arial, Helvetica, sans-serif',
	  Georgia: "Georgia, 'Times New Roman', Times, serif",
	  'Times New Roman': "'Times New Roman', Times, serif",
	  'Courier New': "'Courier New', Courier, monospace",
	  Verdana: 'Verdana, Geneva, Tahoma, sans-serif',
	  'Franklin Gothic': "'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif",
	  'Comic Sans': "'Comic Sans ms', sans-serif",
	  'Arial Narrow': "'Arial Narrow', Verdana, Tahoma, sans-serif",
	  'Lucida Sans': "'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif"
	};
	var LIST_TYPES = exports.LIST_TYPES = ['numbered-list', 'bulleted-list'];
	var UNSAFE_FILE_EXTS = exports.UNSAFE_FILE_EXTS = ['gif', 'ade', 'adp', 'apk', 'appx', 'appxbundle', 'bat', 'cab', 'chm', 'cmd', 'com', 'cpl', 'dll', 'dmg', 'exe', 'hta', 'ins', 'isp', 'iso', 'jar', 'js', 'jse', 'lib', 'lnk', 'mde', 'msc', 'msi', 'msix', 'msixbundle', 'msp', 'mst', 'nsh', 'pif', 'ps1', 'scr', 'sct', 'shb', 'sys', 'vb', 'vbe', 'vbs', 'vxd', 'wsc', 'wsf', 'wsh', 'log'];
	var USER_STATE = exports.USER_STATE = {
	  CHANGE_STATE: 'CHANGE_STATE',
	  CALL_OUT: 'CALL_OUT',
	  LOGED_OUT: 'LOGED_OUT',
	  LOGED_IN: 'LOGED_IN',
	  AGENT_READY: 'AGENT_READY',
	  NO_AVAILABLE: 'NO_AVAILABLE',
	  DIALOG: 'DIALOG',
	  MANUAL_CALL: 'MANUAL_CALL',
	  WAITING_TRANSFER: 'WAITING_TRANSFER',
	  ERROR: 'ERROR',
	  CALL_TRANSFER: 'CALL_TRANSFER',
	  RINGING: 'RINGING',
	  WRAPUP: 'WRAPUP',
	  XFER: 'XFER',
	  OTHER: 'OTHER',
	  EXCLUSIVE_CALLBACK: 'EXCLUSIVE_CALLBACK',
	  CHATTING: 'CHATTING',
	  READY_PREVIEW: 'READY_PREVIEW',
	  ASSISTED: 'ASSISTED',
	  DIALOG_WHATSAPP: 'DIALOG_WHATSAPP',
	  WHATSAPP: 'WHATSAPP',
	  DIALOG_EMAIL: 'DIALOG_EMAIL'
	};
	var REASSIGNED_TYPES = exports.REASSIGNED_TYPES = {
	  BY_AGENT: 'byAgent',
	  BY_TIMEOUT: 'byTimeout'
	};
	var FILE_ICONS_DICTIONARY = {
	  pdf: 'pdf',
	  xls: 'excel',
	  xlsx: 'excel',
	  doc: 'document',
	  docx: 'document',
	  txt: 'document',
	  csv: 'csv'
	};
	var FILE_ICONS = exports.FILE_ICONS = new Proxy(FILE_ICONS_DICTIONARY, {
	  get: function get(object, property) {
	    return object.hasOwnProperty(property) ? object[property] : 'document';
	  }
	});

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CUSTOM_COMPONENTS = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _GenericSVG = __webpack_require__(51);
	
	var _Images = __webpack_require__(30);
	
	var _Validations = __webpack_require__(131);
	
	var _Singleton = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var language = new _Singleton.Singleton();
	
	var CUSTOM_COMPONENTS = exports.CUSTOM_COMPONENTS = {
	  bigDisplayer: function bigDisplayer(displayerFunction) {
	    var customStyles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { height: 30, width: 30 };
	    var inverted = arguments[2];
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'arrowButton', onClick: displayerFunction, style: customStyles },
	      _react2.default.createElement(
	        'div',
	        { className: "containerTriangle " + (inverted && "inverted") },
	        _GenericSVG.triangle
	      )
	    );
	  },
	  displayBlack: function displayBlack(displayerFunction) {
	    var customStyles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { height: 24, width: 24 };
	    var inverted = arguments[2];
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'arrowButtonBlack', onClick: displayerFunction, style: customStyles },
	      _react2.default.createElement(
	        'div',
	        { className: "containerTriangle " + (inverted && "inverted") },
	        _GenericSVG.triangle
	      )
	    );
	  },
	  texSelection: function texSelection() {
	    var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : language.getText("CallControlCRMxcontrolsselectAnOption");
	    var styles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "textSelection";
	
	    return _react2.default.createElement(
	      'p',
	      { className: styles },
	      text
	    );
	  },
	  draggableHeader: function draggableHeader(icon) {
	    var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Ventana";
	    var closeFunction = arguments[2];
	    var classes = arguments[3];
	
	    return _react2.default.createElement(
	      'drag',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'floatingHeader' },
	        _react2.default.createElement(
	          'div',
	          { className: 'iconFloatingHeader ' + (classes && classes.iconHeader) },
	          icon
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'titleFloatingHeader' },
	          title
	        ),
	        closeFunction && _react2.default.createElement('img', { className: 'buttonFloatingClose', onClick: closeFunction, src: _Images.btnCerrar, alt: 'close' })
	      )
	    );
	  },
	  sideBarHeader: function sideBarHeader(iconSVG) {
	    var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Ventana";
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'sideBarHeader' },
	      _react2.default.createElement(
	        'div',
	        { className: 'sideBarICon' },
	        iconSVG
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'sideBarTitle' },
	        title
	      )
	    );
	  },
	  configBarHeader: function configBarHeader(icon, title, backFunction) {
	    var backHiden = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'configBarHeader' },
	      _react2.default.createElement(
	        'div',
	        { className: "backConfigBar " + (backHiden ? "hidden" : ""), onClick: backFunction },
	        _GenericSVG.arrowBack
	      ),
	      _react2.default.createElement('img', { className: 'iconConfigBar', src: icon, alt: 'icon' }),
	      _react2.default.createElement(
	        'p',
	        { className: 'txtConfigBar' },
	        title
	      )
	    );
	  },
	  inputDelete: function inputDelete(value, newValue, className, inputClass, deleteClass) {
	    var svgClose = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : _GenericSVG.btnClear;
	    var onlyNumbers = arguments[6];
	    var image = arguments[7];
	    var imageClass = arguments[8];
	    var placeholder = arguments[9];
	    var disabled = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : false;
	
	    return _react2.default.createElement(
	      'div',
	      { className: className },
	      image && _react2.default.createElement('img', { className: imageClass, src: image, alt: 'close' }),
	      _react2.default.createElement('input', { type: 'text',
	        placeholder: placeholder,
	        className: inputClass,
	        value: value,
	        onKeyPress: function onKeyPress(evt) {
	          onlyNumbers && (0, _Validations.validateOnlyNumbers)(evt) ? true : undefined;
	        },
	        onChange: function onChange(event) {
	          newValue(event.target.value);
	        },
	        maxlength: '20',
	        readOnly: disabled }),
	      value !== "" && _react2.default.createElement(
	        'div',
	        { className: deleteClass, onClick: function onClick() {
	            return newValue("");
	          } },
	        svgClose
	      )
	    );
	  },
	  configCampaignType: function configCampaignType(title, backFunction) {
	    var backHiden = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'configBarHeader' },
	      _react2.default.createElement(
	        'div',
	        { className: "backConfigBar " + (backHiden ? "hidden" : ""), onClick: backFunction },
	        _GenericSVG.arrowBack
	      ),
	      _react2.default.createElement('i', { className: 'iconConfigBar  gcl-icon camps', alt: 'icon' }),
	      _react2.default.createElement(
	        'p',
	        { className: 'txtConfigBar' },
	        title
	      )
	    );
	  }
	};

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.templateType = exports.messageType = exports.dispositionType = exports.conversationType = exports.contactType = exports.campaignType = exports.arrayMultimedia = void 0;
	var _propTypes = __webpack_require__(2);
	var _constants = __webpack_require__(58);
	var templateType = exports.templateType = (0, _propTypes.shape)({
	  title: _propTypes.string.isRequired,
	  text: _propTypes.string.isRequired
	});
	var contactType = exports.contactType = (0, _propTypes.shape)({
	  name: _propTypes.string,
	  account: _propTypes.string,
	  image: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.element])
	});
	var campaignType = exports.campaignType = (0, _propTypes.shape)({
	  id: _propTypes.number.isRequired,
	  name: _propTypes.string.isRequired,
	  account: _propTypes.string,
	  senderName: _propTypes.string,
	  timeout: _propTypes.number.isRequired,
	  timeoutWarning: _propTypes.number.isRequired,
	  image: _propTypes.string
	});
	var messageType = exports.messageType = (0, _propTypes.shape)({
	  id: _propTypes.number,
	  origin: (0, _propTypes.oneOf)(Object.values(_constants.MSG_SOURCE)).isRequired,
	  seen: _propTypes.bool,
	  date: (0, _propTypes.instanceOf)(Date).isRequired,
	  subject: _propTypes.string,
	  content: _propTypes.string,
	  media: (0, _propTypes.arrayOf)(_propTypes.string)
	});
	var conversationType = exports.conversationType = (0, _propTypes.shape)({
	  id: _propTypes.number.isRequired,
	  type: (0, _propTypes.oneOf)(Object.values(_constants.TABS)).isRequired,
	  contact: contactType.isRequired,
	  campaign: campaignType.isRequired,
	  initialTime: (0, _propTypes.instanceOf)(Date).isRequired,
	  templates: (0, _propTypes.arrayOf)(templateType),
	  typing: _propTypes.bool,
	  disabled: _propTypes.bool,
	  messages: (0, _propTypes.arrayOf)(messageType)
	});
	var dispositionType = exports.dispositionType = (0, _propTypes.shape)({
	  id: _propTypes.number.isRequired,
	  text: _propTypes.string.isRequired
	});
	var arrayMultimedia = exports.arrayMultimedia = (0, _propTypes.shape)({
	  url: _propTypes.string.isRequired,
	  mediaType: _propTypes.string.isRequired
	});

/***/ },
/* 61 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = _default;
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function _default(classes) {
	  return Object.entries(classes).filter(function (_ref) {
	    var _ref2 = _slicedToArray(_ref, 2),
	        condition = _ref2[1];
	
	    return condition;
	  }).map(function (_ref3) {
	    var _ref4 = _slicedToArray(_ref3, 1),
	        className = _ref4[0];
	
	    return className;
	  }).join(' ');
	}

/***/ },
/* 62 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Safe chained function
	 *
	 * Will only create a new function if needed,
	 * otherwise will pass back existing functions or null.
	 *
	 * @param {function} functions to chain
	 * @returns {function|null}
	 */
	function createChainedFunction() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  return funcs.filter(function (f) {
	    return f != null;
	  }).reduce(function (acc, f) {
	    if (typeof f !== 'function') {
	      throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
	    }
	
	    if (acc === null) {
	      return f;
	    }
	
	    return function chainedFunction() {
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      acc.apply(this, args);
	      f.apply(this, args);
	    };
	  }, null);
	}
	
	exports['default'] = createChainedFunction;
	module.exports = exports['default'];

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reduxActions = __webpack_require__(995);
	
	var ALERT_MODAL_SHOW = 'ALERT_MODAL_SHOW';
	var ALERT_MODAL_HIDE = 'ALERT_MODAL_HIDE';
	
	var showAlertModal = (0, _reduxActions.createAction)(ALERT_MODAL_SHOW);
	var hideAlertModal = (0, _reduxActions.createAction)(ALERT_MODAL_HIDE);
	
	exports.default = {
	  types: {
	    ALERT_MODAL_SHOW: ALERT_MODAL_SHOW,
	    ALERT_MODAL_HIDE: ALERT_MODAL_HIDE
	  },
	  creators: {
	    showAlertModal: showAlertModal,
	    hideAlertModal: hideAlertModal
	  }
	};

/***/ },
/* 64 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var Size = exports.Size = {
	  LARGE: 'large',
	  SMALL: 'small',
	  XSMALL: 'xsmall'
	};
	
	var SIZE_MAP = exports.SIZE_MAP = {
	  large: 'lg',
	  medium: 'md',
	  small: 'sm',
	  xsmall: 'xs',
	  lg: 'lg',
	  md: 'md',
	  sm: 'sm',
	  xs: 'xs'
	};
	
	var DEVICE_SIZES = exports.DEVICE_SIZES = ['lg', 'md', 'sm', 'xs'];
	
	var State = exports.State = {
	  SUCCESS: 'success',
	  WARNING: 'warning',
	  DANGER: 'danger',
	  INFO: 'info'
	};
	
	var Style = exports.Style = {
	  DEFAULT: 'default',
	  PRIMARY: 'primary',
	  LINK: 'link',
	  INVERSE: 'inverse'
	};

/***/ },
/* 65 */
[2662, 105],
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.parseDomainOfCategoryAxis = exports.getBandSizeOfAxis = exports.parseSpecifiedDomain = exports.MAX_VALUE_REG = exports.MIN_VALUE_REG = exports.getDomainOfStackGroups = exports.getStackedDataOfItem = exports.getBaseValueOfBar = exports.getCateCoordinateOfBar = exports.getCateCoordinateOfLine = exports.getTicksOfScale = exports.calculateDomainOfTicks = exports.getStackGroupsByAxisId = exports.getStackedData = exports.offsetSign = exports.truncateByDomain = exports.findPositionOfBar = exports.checkDomainOfScale = exports.parseScale = exports.combineEventHandlers = exports.getTicksOfAxis = exports.getCoordinatesOfGrid = exports.isCategorialAxis = exports.getDomainOfItemsWithSameAxis = exports.parseErrorBarsOfAxis = exports.getDomainOfErrorBars = exports.appendOffsetOfLegend = exports.getBarPosition = exports.getBarSizeList = exports.getLegendProps = exports.getMainColorOfGraphicItem = exports.calculateActiveTickIndex = exports.getDomainOfDataByKey = exports.getValueByDataKey = void 0;
	
	var _isEqual2 = _interopRequireDefault(__webpack_require__(98));
	
	var _sortBy2 = _interopRequireDefault(__webpack_require__(455));
	
	var _isNaN2 = _interopRequireDefault(__webpack_require__(290));
	
	var _isString2 = _interopRequireDefault(__webpack_require__(292));
	
	var _isArray2 = _interopRequireDefault(__webpack_require__(43));
	
	var _max2 = _interopRequireDefault(__webpack_require__(755));
	
	var _min2 = _interopRequireDefault(__webpack_require__(757));
	
	var _flatMap2 = _interopRequireDefault(__webpack_require__(2166));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(38));
	
	var _get2 = _interopRequireDefault(__webpack_require__(180));
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(71));
	
	var _rechartsScale = __webpack_require__(2412);
	
	var d3Scales = _interopRequireWildcard(__webpack_require__(614));
	
	var _d3Shape = __webpack_require__(382);
	
	var _DataUtils = __webpack_require__(39);
	
	var _ErrorBar = _interopRequireDefault(__webpack_require__(230));
	
	var _Legend = _interopRequireDefault(__webpack_require__(477));
	
	var _ReactUtils = __webpack_require__(29);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var getValueByDataKey = function getValueByDataKey(obj, dataKey, defaultValue) {
	  if ((0, _isNil2["default"])(obj) || (0, _isNil2["default"])(dataKey)) {
	    return defaultValue;
	  }
	
	  if ((0, _DataUtils.isNumOrStr)(dataKey)) {
	    return (0, _get2["default"])(obj, dataKey, defaultValue);
	  }
	
	  if ((0, _isFunction2["default"])(dataKey)) {
	    return dataKey(obj);
	  }
	
	  return defaultValue;
	};
	/**
	 * Get domain of data by key
	 * @param  {Array}   data      The data displayed in the chart
	 * @param  {String}  key       The unique key of a group of data
	 * @param  {String}  type      The type of axis
	 * @param  {Boolean} filterNil Whether or not filter nil values
	 * @return {Array} Domain of data
	 */
	
	
	exports.getValueByDataKey = getValueByDataKey;
	
	var getDomainOfDataByKey = function getDomainOfDataByKey(data, key, type, filterNil) {
	  var flattenData = (0, _flatMap2["default"])(data, function (entry) {
	    return getValueByDataKey(entry, key);
	  });
	
	  if (type === 'number') {
	    var domain = flattenData.filter(function (entry) {
	      return (0, _DataUtils.isNumber)(entry) || parseFloat(entry, 10);
	    });
	    return domain.length ? [(0, _min2["default"])(domain), (0, _max2["default"])(domain)] : [Infinity, -Infinity];
	  }
	
	  var validateData = filterNil ? flattenData.filter(function (entry) {
	    return !(0, _isNil2["default"])(entry);
	  }) : flattenData;
	  return validateData.map(function (entry) {
	    return (0, _DataUtils.isNumOrStr)(entry) ? entry : '';
	  });
	};
	
	exports.getDomainOfDataByKey = getDomainOfDataByKey;
	
	var calculateActiveTickIndex = function calculateActiveTickIndex(coordinate, ticks, unsortedTicks, axis) {
	  var index = -1;
	  var len = ticks.length;
	
	  if (len > 1) {
	    if (axis && axis.axisType === 'angleAxis' && Math.abs(Math.abs(axis.range[1] - axis.range[0]) - 360) <= 1e-6) {
	      var range = axis.range; // ticks are distributed in a circle
	
	      for (var i = 0; i < len; i++) {
	        var before = i > 0 ? unsortedTicks[i - 1].coordinate : unsortedTicks[len - 1].coordinate;
	        var cur = unsortedTicks[i].coordinate;
	        var after = i >= len - 1 ? unsortedTicks[0].coordinate : unsortedTicks[i + 1].coordinate;
	        var sameDirectionCoord = void 0;
	
	        if ((0, _DataUtils.mathSign)(cur - before) !== (0, _DataUtils.mathSign)(after - cur)) {
	          var diffInterval = [];
	
	          if ((0, _DataUtils.mathSign)(after - cur) === (0, _DataUtils.mathSign)(range[1] - range[0])) {
	            sameDirectionCoord = after;
	            var curInRange = cur + range[1] - range[0];
	            diffInterval[0] = Math.min(curInRange, (curInRange + before) / 2);
	            diffInterval[1] = Math.max(curInRange, (curInRange + before) / 2);
	          } else {
	            sameDirectionCoord = before;
	            var afterInRange = after + range[1] - range[0];
	            diffInterval[0] = Math.min(cur, (afterInRange + cur) / 2);
	            diffInterval[1] = Math.max(cur, (afterInRange + cur) / 2);
	          }
	
	          var sameInterval = [Math.min(cur, (sameDirectionCoord + cur) / 2), Math.max(cur, (sameDirectionCoord + cur) / 2)];
	
	          if (coordinate > sameInterval[0] && coordinate <= sameInterval[1] || coordinate >= diffInterval[0] && coordinate <= diffInterval[1]) {
	            index = unsortedTicks[i].index;
	            break;
	          }
	        } else {
	          var min = Math.min(before, after);
	          var max = Math.max(before, after);
	
	          if (coordinate > (min + cur) / 2 && coordinate <= (max + cur) / 2) {
	            index = unsortedTicks[i].index;
	            break;
	          }
	        }
	      }
	    } else {
	      // ticks are distributed in a single direction
	      for (var _i = 0; _i < len; _i++) {
	        if (_i === 0 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i > 0 && _i < len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i === len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2) {
	          index = ticks[_i].index;
	          break;
	        }
	      }
	    }
	  } else {
	    index = 0;
	  }
	
	  return index;
	};
	/**
	 * Get the main color of each graphic item
	 * @param  {ReactElement} item A graphic item
	 * @return {String}            Color
	 */
	
	
	exports.calculateActiveTickIndex = calculateActiveTickIndex;
	
	var getMainColorOfGraphicItem = function getMainColorOfGraphicItem(item) {
	  var displayName = item.type.displayName;
	  var _item$props = item.props,
	      stroke = _item$props.stroke,
	      fill = _item$props.fill;
	  var result;
	
	  switch (displayName) {
	    case 'Line':
	      result = stroke;
	      break;
	
	    case 'Area':
	    case 'Radar':
	      result = stroke && stroke !== 'none' ? stroke : fill;
	      break;
	
	    default:
	      result = fill;
	      break;
	  }
	
	  return result;
	};
	
	exports.getMainColorOfGraphicItem = getMainColorOfGraphicItem;
	
	var getLegendProps = function getLegendProps(_ref) {
	  var children = _ref.children,
	      formatedGraphicalItems = _ref.formatedGraphicalItems,
	      legendWidth = _ref.legendWidth,
	      legendContent = _ref.legendContent;
	  var legendItem = (0, _ReactUtils.findChildByType)(children, _Legend["default"]);
	
	  if (!legendItem) {
	    return null;
	  }
	
	  var legendData;
	
	  if (legendItem.props && legendItem.props.payload) {
	    legendData = legendItem.props && legendItem.props.payload;
	  } else if (legendContent === 'children') {
	    legendData = (formatedGraphicalItems || []).reduce(function (result, _ref2) {
	      var item = _ref2.item,
	          props = _ref2.props;
	      var data = props.sectors || props.data || [];
	      return result.concat(data.map(function (entry) {
	        return {
	          type: legendItem.props.iconType || item.props.legendType,
	          value: entry.name,
	          color: entry.fill,
	          payload: entry
	        };
	      }));
	    }, []);
	  } else {
	    legendData = (formatedGraphicalItems || []).map(function (_ref3) {
	      var item = _ref3.item;
	      var _item$props2 = item.props,
	          dataKey = _item$props2.dataKey,
	          name = _item$props2.name,
	          legendType = _item$props2.legendType,
	          hide = _item$props2.hide;
	      return {
	        inactive: hide,
	        dataKey: dataKey,
	        type: legendItem.props.iconType || legendType || 'square',
	        color: getMainColorOfGraphicItem(item),
	        value: name || dataKey,
	        payload: item.props
	      };
	    });
	  }
	
	  return _objectSpread({}, legendItem.props, {}, _Legend["default"].getWithHeight(legendItem, legendWidth), {
	    payload: legendData,
	    item: legendItem
	  });
	};
	/**
	 * Calculate the size of all groups for stacked bar graph
	 * @param  {Object} stackGroups The items grouped by axisId and stackId
	 * @return {Object} The size of all groups
	 */
	
	
	exports.getLegendProps = getLegendProps;
	
	var getBarSizeList = function getBarSizeList(_ref4) {
	  var globalSize = _ref4.barSize,
	      _ref4$stackGroups = _ref4.stackGroups,
	      stackGroups = _ref4$stackGroups === void 0 ? {} : _ref4$stackGroups;
	
	  if (!stackGroups) {
	    return {};
	  }
	
	  var result = {};
	  var numericAxisIds = Object.keys(stackGroups);
	
	  for (var i = 0, len = numericAxisIds.length; i < len; i++) {
	    var sgs = stackGroups[numericAxisIds[i]].stackGroups;
	    var stackIds = Object.keys(sgs);
	
	    for (var j = 0, sLen = stackIds.length; j < sLen; j++) {
	      var _sgs$stackIds$j = sgs[stackIds[j]],
	          items = _sgs$stackIds$j.items,
	          cateAxisId = _sgs$stackIds$j.cateAxisId;
	      var barItems = items.filter(function (item) {
	        return (0, _ReactUtils.getDisplayName)(item.type).indexOf('Bar') >= 0;
	      });
	
	      if (barItems && barItems.length) {
	        var selfSize = barItems[0].props.barSize;
	        var cateId = barItems[0].props[cateAxisId];
	
	        if (!result[cateId]) {
	          result[cateId] = [];
	        }
	
	        result[cateId].push({
	          item: barItems[0],
	          stackList: barItems.slice(1),
	          barSize: (0, _isNil2["default"])(selfSize) ? globalSize : selfSize
	        });
	      }
	    }
	  }
	
	  return result;
	};
	/**
	   * Calculate the size of each bar and the gap between two bars
	   * @param  {Number} bandSize  The size of each category
	   * @param  {sizeList} sizeList  The size of all groups
	   * @param  {maxBarSize} maxBarSize The maximum size of bar
	   * @return {Number} The size of each bar and the gap between two bars
	   */
	
	
	exports.getBarSizeList = getBarSizeList;
	
	var getBarPosition = function getBarPosition(_ref5) {
	  var barGap = _ref5.barGap,
	      barCategoryGap = _ref5.barCategoryGap,
	      bandSize = _ref5.bandSize,
	      _ref5$sizeList = _ref5.sizeList,
	      sizeList = _ref5$sizeList === void 0 ? [] : _ref5$sizeList,
	      maxBarSize = _ref5.maxBarSize;
	  var len = sizeList.length;
	  if (len < 1) return null;
	  var realBarGap = (0, _DataUtils.getPercentValue)(barGap, bandSize, 0, true);
	  var result; // whether or not is barSize setted by user
	
	  if (sizeList[0].barSize === +sizeList[0].barSize) {
	    var useFull = false;
	    var fullBarSize = bandSize / len;
	    var sum = sizeList.reduce(function (res, entry) {
	      return res + entry.barSize || 0;
	    }, 0);
	    sum += (len - 1) * realBarGap;
	
	    if (sum >= bandSize) {
	      sum -= (len - 1) * realBarGap;
	      realBarGap = 0;
	    }
	
	    if (sum >= bandSize && fullBarSize > 0) {
	      useFull = true;
	      fullBarSize *= 0.9;
	      sum = len * fullBarSize;
	    }
	
	    var offset = (bandSize - sum) / 2 >> 0;
	    var prev = {
	      offset: offset - realBarGap,
	      size: 0
	    };
	    result = sizeList.reduce(function (res, entry) {
	      var newRes = [].concat(_toConsumableArray(res), [{
	        item: entry.item,
	        position: {
	          offset: prev.offset + prev.size + realBarGap,
	          size: useFull ? fullBarSize : entry.barSize
	        }
	      }]);
	      prev = newRes[newRes.length - 1].position;
	
	      if (entry.stackList && entry.stackList.length) {
	        entry.stackList.forEach(function (item) {
	          newRes.push({
	            item: item,
	            position: prev
	          });
	        });
	      }
	
	      return newRes;
	    }, []);
	  } else {
	    var _offset = (0, _DataUtils.getPercentValue)(barCategoryGap, bandSize, 0, true);
	
	    if (bandSize - 2 * _offset - (len - 1) * realBarGap <= 0) {
	      realBarGap = 0;
	    }
	
	    var originalSize = (bandSize - 2 * _offset - (len - 1) * realBarGap) / len;
	
	    if (originalSize > 1) {
	      originalSize >>= 0;
	    }
	
	    var size = maxBarSize === +maxBarSize ? Math.min(originalSize, maxBarSize) : originalSize;
	    result = sizeList.reduce(function (res, entry, i) {
	      var newRes = [].concat(_toConsumableArray(res), [{
	        item: entry.item,
	        position: {
	          offset: _offset + (originalSize + realBarGap) * i + (originalSize - size) / 2,
	          size: size
	        }
	      }]);
	
	      if (entry.stackList && entry.stackList.length) {
	        entry.stackList.forEach(function (item) {
	          newRes.push({
	            item: item,
	            position: newRes[newRes.length - 1].position
	          });
	        });
	      }
	
	      return newRes;
	    }, []);
	  }
	
	  return result;
	};
	
	exports.getBarPosition = getBarPosition;
	
	var appendOffsetOfLegend = function appendOffsetOfLegend(offset, items, props, legendBox) {
	  var children = props.children,
	      width = props.width,
	      height = props.height,
	      margin = props.margin;
	  var legendWidth = width - (margin.left || 0) - (margin.right || 0);
	  var legendHeight = height - (margin.top || 0) - (margin.bottom || 0);
	  var legendProps = getLegendProps({
	    children: children,
	    items: items,
	    legendWidth: legendWidth,
	    legendHeight: legendHeight
	  });
	  var newOffset = offset;
	
	  if (legendProps) {
	    var box = legendBox || {};
	    var align = legendProps.align,
	        verticalAlign = legendProps.verticalAlign,
	        layout = legendProps.layout;
	
	    if ((layout === 'vertical' || layout === 'horizontal' && verticalAlign === 'center') && (0, _DataUtils.isNumber)(offset[align])) {
	      newOffset = _objectSpread({}, offset, _defineProperty({}, align, newOffset[align] + (box.width || 0)));
	    }
	
	    if ((layout === 'horizontal' || layout === 'vertical' && align === 'center') && (0, _DataUtils.isNumber)(offset[verticalAlign])) {
	      newOffset = _objectSpread({}, offset, _defineProperty({}, verticalAlign, newOffset[verticalAlign] + (box.height || 0)));
	    }
	  }
	
	  return newOffset;
	};
	
	exports.appendOffsetOfLegend = appendOffsetOfLegend;
	
	var getDomainOfErrorBars = function getDomainOfErrorBars(data, item, dataKey, axisType) {
	  var children = item.props.children;
	  var errorBars = (0, _ReactUtils.findAllByType)(children, _ErrorBar["default"]).filter(function (errorBarChild) {
	    var direction = errorBarChild.props.direction;
	    return (0, _isNil2["default"])(direction) || (0, _isNil2["default"])(axisType) ? true : axisType.indexOf(direction) >= 0;
	  });
	
	  if (errorBars && errorBars.length) {
	    var keys = errorBars.map(function (errorBarChild) {
	      return errorBarChild.props.dataKey;
	    });
	    return data.reduce(function (result, entry) {
	      var entryValue = getValueByDataKey(entry, dataKey, 0);
	      var mainValue = (0, _isArray2["default"])(entryValue) ? [(0, _min2["default"])(entryValue), (0, _max2["default"])(entryValue)] : [entryValue, entryValue];
	      var errorDomain = keys.reduce(function (prevErrorArr, k) {
	        var errorValue = getValueByDataKey(entry, k, 0);
	        var lowerValue = mainValue[0] - Math.abs((0, _isArray2["default"])(errorValue) ? errorValue[0] : errorValue);
	        var upperValue = mainValue[1] + Math.abs((0, _isArray2["default"])(errorValue) ? errorValue[1] : errorValue);
	        return [Math.min(lowerValue, prevErrorArr[0]), Math.max(upperValue, prevErrorArr[1])];
	      }, [Infinity, -Infinity]);
	      return [Math.min(errorDomain[0], result[0]), Math.max(errorDomain[1], result[1])];
	    }, [Infinity, -Infinity]);
	  }
	
	  return null;
	};
	
	exports.getDomainOfErrorBars = getDomainOfErrorBars;
	
	var parseErrorBarsOfAxis = function parseErrorBarsOfAxis(data, items, dataKey, axisType) {
	  var domains = items.map(function (item) {
	    return getDomainOfErrorBars(data, item, dataKey, axisType);
	  }).filter(function (entry) {
	    return !(0, _isNil2["default"])(entry);
	  });
	
	  if (domains && domains.length) {
	    return domains.reduce(function (result, entry) {
	      return [Math.min(result[0], entry[0]), Math.max(result[1], entry[1])];
	    }, [Infinity, -Infinity]);
	  }
	
	  return null;
	};
	/**
	 * Get domain of data by the configuration of item element
	 * @param  {Array}   data      The data displayed in the chart
	 * @param  {Array}   items     The instances of item
	 * @param  {String}  type      The type of axis, number - Number Axis, category - Category Axis
	 * @param  {Boolean} filterNil Whether or not filter nil values
	 * @return {Array}        Domain
	 */
	
	
	exports.parseErrorBarsOfAxis = parseErrorBarsOfAxis;
	
	var getDomainOfItemsWithSameAxis = function getDomainOfItemsWithSameAxis(data, items, type, filterNil) {
	  var domains = items.map(function (item) {
	    var dataKey = item.props.dataKey;
	
	    if (type === 'number' && dataKey) {
	      return getDomainOfErrorBars(data, item, dataKey) || getDomainOfDataByKey(data, dataKey, type, filterNil);
	    }
	
	    return getDomainOfDataByKey(data, dataKey, type, filterNil);
	  });
	
	  if (type === 'number') {
	    // Calculate the domain of number axis
	    return domains.reduce(function (result, entry) {
	      return [Math.min(result[0], entry[0]), Math.max(result[1], entry[1])];
	    }, [Infinity, -Infinity]);
	  }
	
	  var tag = {}; // Get the union set of category axis
	
	  return domains.reduce(function (result, entry) {
	    for (var i = 0, len = entry.length; i < len; i++) {
	      if (!tag[entry[i]]) {
	        tag[entry[i]] = true;
	        result.push(entry[i]);
	      }
	    }
	
	    return result;
	  }, []);
	};
	
	exports.getDomainOfItemsWithSameAxis = getDomainOfItemsWithSameAxis;
	
	var isCategorialAxis = function isCategorialAxis(layout, axisType) {
	  return layout === 'horizontal' && axisType === 'xAxis' || layout === 'vertical' && axisType === 'yAxis' || layout === 'centric' && axisType === 'angleAxis' || layout === 'radial' && axisType === 'radiusAxis';
	};
	/**
	 * Calculate the Coordinates of grid
	 * @param  {Array} ticks The ticks in axis
	 * @param {Number} min   The minimun value of axis
	 * @param {Number} max   The maximun value of axis
	 * @return {Array}       Coordinates
	 */
	
	
	exports.isCategorialAxis = isCategorialAxis;
	
	var getCoordinatesOfGrid = function getCoordinatesOfGrid(ticks, min, max) {
	  var hasMin, hasMax;
	  var values = ticks.map(function (entry) {
	    if (entry.coordinate === min) {
	      hasMin = true;
	    }
	
	    if (entry.coordinate === max) {
	      hasMax = true;
	    }
	
	    return entry.coordinate;
	  });
	
	  if (!hasMin) {
	    values.push(min);
	  }
	
	  if (!hasMax) {
	    values.push(max);
	  }
	
	  return values;
	};
	/**
	 * Get the ticks of an axis
	 * @param  {Object}  axis The configuration of an axis
	 * @param {Boolean} isGrid Whether or not are the ticks in grid
	 * @param {Boolean} isAll Return the ticks of all the points or not
	 * @return {Array}  Ticks
	 */
	
	
	exports.getCoordinatesOfGrid = getCoordinatesOfGrid;
	
	var getTicksOfAxis = function getTicksOfAxis(axis, isGrid, isAll) {
	  if (!axis) return null;
	  var scale = axis.scale;
	  var duplicateDomain = axis.duplicateDomain,
	      type = axis.type,
	      range = axis.range;
	  var offset = (isGrid || isAll) && type === 'category' && scale.bandwidth ? scale.bandwidth() / 2 : 0;
	  offset = axis.axisType === 'angleAxis' ? (0, _DataUtils.mathSign)(range[0] - range[1]) * 2 * offset : offset; // The ticks setted by user should only affect the ticks adjacent to axis line
	
	  if (isGrid && (axis.ticks || axis.niceTicks)) {
	    return (axis.ticks || axis.niceTicks).map(function (entry) {
	      var scaleContent = duplicateDomain ? duplicateDomain.indexOf(entry) : entry;
	      return {
	        coordinate: scale(scaleContent) + offset,
	        value: entry,
	        offset: offset
	      };
	    });
	  }
	
	  if (axis.isCategorial && axis.categoricalDomain) {
	    return axis.categoricalDomain.map(function (entry, index) {
	      return {
	        coordinate: scale(entry),
	        value: entry,
	        index: index,
	        offset: offset
	      };
	    });
	  }
	
	  if (scale.ticks && !isAll) {
	    return scale.ticks(axis.tickCount).map(function (entry) {
	      return {
	        coordinate: scale(entry) + offset,
	        value: entry,
	        offset: offset
	      };
	    });
	  } // When axis has duplicated text, serial numbers are used to generate scale
	
	
	  return scale.domain().map(function (entry, index) {
	    return {
	      coordinate: scale(entry) + offset,
	      value: duplicateDomain ? duplicateDomain[entry] : entry,
	      index: index,
	      offset: offset
	    };
	  });
	};
	/**
	 * combine the handlers
	 * @param  {Function} defaultHandler Internal private handler
	 * @param  {Function} parentHandler  Handler function specified in parent component
	 * @param  {Function} childHandler   Handler function specified in child component
	 * @return {Function}                The combined handler
	 */
	
	
	exports.getTicksOfAxis = getTicksOfAxis;
	
	var combineEventHandlers = function combineEventHandlers(defaultHandler, parentHandler, childHandler) {
	  var customizedHandler;
	
	  if ((0, _isFunction2["default"])(childHandler)) {
	    customizedHandler = childHandler;
	  } else if ((0, _isFunction2["default"])(parentHandler)) {
	    customizedHandler = parentHandler;
	  }
	
	  if ((0, _isFunction2["default"])(defaultHandler) || customizedHandler) {
	    return function (arg1, arg2, arg3, arg4) {
	      if ((0, _isFunction2["default"])(defaultHandler)) {
	        defaultHandler(arg1, arg2, arg3, arg4);
	      }
	
	      if ((0, _isFunction2["default"])(customizedHandler)) {
	        customizedHandler(arg1, arg2, arg3, arg4);
	      }
	    };
	  }
	
	  return null;
	};
	/**
	 * Parse the scale function of axis
	 * @param  {Object}   axis          The option of axis
	 * @param  {String}   chartType     The displayName of chart
	 * @return {Function}               The scale funcion
	 */
	
	
	exports.combineEventHandlers = combineEventHandlers;
	
	var parseScale = function parseScale(axis, chartType) {
	  var scale = axis.scale,
	      type = axis.type,
	      layout = axis.layout,
	      axisType = axis.axisType;
	
	  if (scale === 'auto') {
	    if (layout === 'radial' && axisType === 'radiusAxis') {
	      return {
	        scale: d3Scales.scaleBand(),
	        realScaleType: 'band'
	      };
	    }
	
	    if (layout === 'radial' && axisType === 'angleAxis') {
	      return {
	        scale: d3Scales.scaleLinear(),
	        realScaleType: 'linear'
	      };
	    }
	
	    if (type === 'category' && chartType && (chartType.indexOf('LineChart') >= 0 || chartType.indexOf('AreaChart') >= 0)) {
	      return {
	        scale: d3Scales.scalePoint(),
	        realScaleType: 'point'
	      };
	    }
	
	    if (type === 'category') {
	      return {
	        scale: d3Scales.scaleBand(),
	        realScaleType: 'band'
	      };
	    }
	
	    return {
	      scale: d3Scales.scaleLinear(),
	      realScaleType: 'linear'
	    };
	  }
	
	  if ((0, _isString2["default"])(scale)) {
	    var name = "scale".concat(scale.slice(0, 1).toUpperCase()).concat(scale.slice(1));
	    return {
	      scale: (d3Scales[name] || d3Scales.scalePoint)(),
	      realScaleType: d3Scales[name] ? name : 'point'
	    };
	  }
	
	  return (0, _isFunction2["default"])(scale) ? {
	    scale: scale
	  } : {
	    scale: d3Scales.scalePoint(),
	    realScaleType: 'point'
	  };
	};
	
	exports.parseScale = parseScale;
	var EPS = 1e-4;
	
	var checkDomainOfScale = function checkDomainOfScale(scale) {
	  var domain = scale.domain();
	
	  if (!domain || domain.length <= 2) {
	    return;
	  }
	
	  var len = domain.length;
	  var range = scale.range();
	  var min = Math.min(range[0], range[1]) - EPS;
	  var max = Math.max(range[0], range[1]) + EPS;
	  var first = scale(domain[0]);
	  var last = scale(domain[len - 1]);
	
	  if (first < min || first > max || last < min || last > max) {
	    scale.domain([domain[0], domain[len - 1]]);
	  }
	};
	
	exports.checkDomainOfScale = checkDomainOfScale;
	
	var findPositionOfBar = function findPositionOfBar(barPosition, child) {
	  if (!barPosition) {
	    return null;
	  }
	
	  for (var i = 0, len = barPosition.length; i < len; i++) {
	    if (barPosition[i].item === child) {
	      return barPosition[i].position;
	    }
	  }
	
	  return null;
	};
	
	exports.findPositionOfBar = findPositionOfBar;
	
	var truncateByDomain = function truncateByDomain(value, domain) {
	  if (!domain || domain.length !== 2 || !(0, _DataUtils.isNumber)(domain[0]) || !(0, _DataUtils.isNumber)(domain[1])) {
	    return value;
	  }
	
	  var min = Math.min(domain[0], domain[1]);
	  var max = Math.max(domain[0], domain[1]);
	  var result = [value[0], value[1]];
	
	  if (!(0, _DataUtils.isNumber)(value[0]) || value[0] < min) {
	    result[0] = min;
	  }
	
	  if (!(0, _DataUtils.isNumber)(value[1]) || value[1] > max) {
	    result[1] = max;
	  }
	
	  if (result[0] > max) {
	    result[0] = max;
	  }
	
	  if (result[1] < min) {
	    result[1] = min;
	  }
	
	  return result;
	};
	/* eslint no-param-reassign: 0 */
	
	
	exports.truncateByDomain = truncateByDomain;
	
	var offsetSign = function offsetSign(series) {
	  var n = series.length;
	
	  if (n <= 0) {
	    return;
	  }
	
	  for (var j = 0, m = series[0].length; j < m; ++j) {
	    var positive = 0;
	    var negative = 0;
	
	    for (var i = 0; i < n; ++i) {
	      var value = (0, _isNaN2["default"])(series[i][j][1]) ? series[i][j][0] : series[i][j][1];
	      /* eslint-disable prefer-destructuring */
	
	      if (value >= 0) {
	        series[i][j][0] = positive;
	        series[i][j][1] = positive + value;
	        positive = series[i][j][1];
	      } else {
	        series[i][j][0] = negative;
	        series[i][j][1] = negative + value;
	        negative = series[i][j][1];
	      }
	      /* eslint-enable prefer-destructuring */
	
	    }
	  }
	};
	
	exports.offsetSign = offsetSign;
	var STACK_OFFSET_MAP = {
	  sign: offsetSign,
	  expand: _d3Shape.stackOffsetExpand,
	  none: _d3Shape.stackOffsetNone,
	  silhouette: _d3Shape.stackOffsetSilhouette,
	  wiggle: _d3Shape.stackOffsetWiggle
	};
	
	var getStackedData = function getStackedData(data, stackItems, offsetType) {
	  var dataKeys = stackItems.map(function (item) {
	    return item.props.dataKey;
	  });
	  var stack = (0, _d3Shape.stack)().keys(dataKeys).value(function (d, key) {
	    return +getValueByDataKey(d, key, 0);
	  }).order(_d3Shape.stackOrderNone).offset(STACK_OFFSET_MAP[offsetType]);
	  return stack(data);
	};
	
	exports.getStackedData = getStackedData;
	
	var getStackGroupsByAxisId = function getStackGroupsByAxisId(data, _items, numericAxisId, cateAxisId, offsetType, reverseStackOrder) {
	  if (!data) {
	    return null;
	  } // reversing items to affect render order (for layering)
	
	
	  var items = reverseStackOrder ? _items.reverse() : _items;
	  var stackGroups = items.reduce(function (result, item) {
	    var _item$props3 = item.props,
	        stackId = _item$props3.stackId,
	        hide = _item$props3.hide;
	
	    if (hide) {
	      return result;
	    }
	
	    var axisId = item.props[numericAxisId];
	    var parentGroup = result[axisId] || {
	      hasStack: false,
	      stackGroups: {}
	    };
	
	    if ((0, _DataUtils.isNumOrStr)(stackId)) {
	      var childGroup = parentGroup.stackGroups[stackId] || {
	        numericAxisId: numericAxisId,
	        cateAxisId: cateAxisId,
	        items: []
	      };
	      childGroup.items.push(item);
	      parentGroup.hasStack = true;
	      parentGroup.stackGroups[stackId] = childGroup;
	    } else {
	      parentGroup.stackGroups[(0, _DataUtils.uniqueId)('_stackId_')] = {
	        numericAxisId: numericAxisId,
	        cateAxisId: cateAxisId,
	        items: [item]
	      };
	    }
	
	    return _objectSpread({}, result, _defineProperty({}, axisId, parentGroup));
	  }, {});
	  return Object.keys(stackGroups).reduce(function (result, axisId) {
	    var group = stackGroups[axisId];
	
	    if (group.hasStack) {
	      group.stackGroups = Object.keys(group.stackGroups).reduce(function (res, stackId) {
	        var g = group.stackGroups[stackId];
	        return _objectSpread({}, res, _defineProperty({}, stackId, {
	          numericAxisId: numericAxisId,
	          cateAxisId: cateAxisId,
	          items: g.items,
	          stackedData: getStackedData(data, g.items, offsetType)
	        }));
	      }, {});
	    }
	
	    return _objectSpread({}, result, _defineProperty({}, axisId, group));
	  }, {});
	};
	/**
	 * get domain of ticks
	 * @param  {Array} ticks Ticks of axis
	 * @param  {String} type  The type of axis
	 * @return {Array} domain
	 */
	
	
	exports.getStackGroupsByAxisId = getStackGroupsByAxisId;
	
	var calculateDomainOfTicks = function calculateDomainOfTicks(ticks, type) {
	  if (type === 'number') {
	    return [(0, _min2["default"])(ticks), (0, _max2["default"])(ticks)];
	  }
	
	  return ticks;
	};
	/**
	 * Configure the scale function of axis
	 * @param {Object} scale The scale function
	 * @param {Object} opts  The configuration of axis
	 * @return {Object}      null
	 */
	
	
	exports.calculateDomainOfTicks = calculateDomainOfTicks;
	
	var getTicksOfScale = function getTicksOfScale(scale, opts) {
	  var realScaleType = opts.realScaleType,
	      type = opts.type,
	      tickCount = opts.tickCount,
	      originalDomain = opts.originalDomain,
	      allowDecimals = opts.allowDecimals;
	  var scaleType = realScaleType || opts.scale;
	
	  if (scaleType !== 'auto' && scaleType !== 'linear') {
	    return null;
	  }
	
	  if (tickCount && type === 'number' && originalDomain && (originalDomain[0] === 'auto' || originalDomain[1] === 'auto')) {
	    // Calculate the ticks by the number of grid when the axis is a number axis
	    var domain = scale.domain();
	    var tickValues = (0, _rechartsScale.getNiceTickValues)(domain, tickCount, allowDecimals);
	    scale.domain(calculateDomainOfTicks(tickValues, type));
	    return {
	      niceTicks: tickValues
	    };
	  }
	
	  if (tickCount && type === 'number') {
	    var _domain = scale.domain();
	
	    var _tickValues = (0, _rechartsScale.getTickValuesFixedDomain)(_domain, tickCount, allowDecimals);
	
	    return {
	      niceTicks: _tickValues
	    };
	  }
	
	  return null;
	};
	
	exports.getTicksOfScale = getTicksOfScale;
	
	var getCateCoordinateOfLine = function getCateCoordinateOfLine(_ref6) {
	  var axis = _ref6.axis,
	      ticks = _ref6.ticks,
	      bandSize = _ref6.bandSize,
	      entry = _ref6.entry,
	      index = _ref6.index,
	      dataKey = _ref6.dataKey;
	
	  if (axis.type === 'category') {
	    // find coordinate of category axis by the value of category
	    if (!axis.allowDuplicatedCategory && axis.dataKey && !(0, _isNil2["default"])(entry[axis.dataKey])) {
	      var matchedTick = (0, _DataUtils.findEntryInArray)(ticks, 'value', entry[axis.dataKey]);
	
	      if (matchedTick) {
	        return matchedTick.coordinate + bandSize / 2;
	      }
	    }
	
	    return ticks[index] ? ticks[index].coordinate + bandSize / 2 : null;
	  }
	
	  var value = getValueByDataKey(entry, !(0, _isNil2["default"])(dataKey) ? dataKey : axis.dataKey);
	  return !(0, _isNil2["default"])(value) ? axis.scale(value) : null;
	};
	
	exports.getCateCoordinateOfLine = getCateCoordinateOfLine;
	
	var getCateCoordinateOfBar = function getCateCoordinateOfBar(_ref7) {
	  var axis = _ref7.axis,
	      ticks = _ref7.ticks,
	      offset = _ref7.offset,
	      bandSize = _ref7.bandSize,
	      entry = _ref7.entry,
	      index = _ref7.index;
	
	  if (axis.type === 'category') {
	    return ticks[index] ? ticks[index].coordinate + offset : null;
	  }
	
	  var value = getValueByDataKey(entry, axis.dataKey, axis.domain[index]);
	  return !(0, _isNil2["default"])(value) ? axis.scale(value) - bandSize / 2 + offset : null;
	};
	
	exports.getCateCoordinateOfBar = getCateCoordinateOfBar;
	
	var getBaseValueOfBar = function getBaseValueOfBar(_ref8) {
	  var numericAxis = _ref8.numericAxis;
	  var domain = numericAxis.scale.domain();
	
	  if (numericAxis.type === 'number') {
	    var min = Math.min(domain[0], domain[1]);
	    var max = Math.max(domain[0], domain[1]);
	
	    if (min <= 0 && max >= 0) {
	      return 0;
	    }
	
	    if (max < 0) {
	      return max;
	    }
	
	    return min;
	  }
	
	  return domain[0];
	};
	
	exports.getBaseValueOfBar = getBaseValueOfBar;
	
	var getStackedDataOfItem = function getStackedDataOfItem(item, stackGroups) {
	  var stackId = item.props.stackId;
	
	  if ((0, _DataUtils.isNumOrStr)(stackId)) {
	    var group = stackGroups[stackId];
	
	    if (group && group.items.length) {
	      var itemIndex = -1;
	
	      for (var i = 0, len = group.items.length; i < len; i++) {
	        if (group.items[i] === item) {
	          itemIndex = i;
	          break;
	        }
	      }
	
	      return itemIndex >= 0 ? group.stackedData[itemIndex] : null;
	    }
	  }
	
	  return null;
	};
	
	exports.getStackedDataOfItem = getStackedDataOfItem;
	
	var getDomainOfSingle = function getDomainOfSingle(data) {
	  return data.reduce(function (result, entry) {
	    return [(0, _min2["default"])(entry.concat([result[0]]).filter(_DataUtils.isNumber)), (0, _max2["default"])(entry.concat([result[1]]).filter(_DataUtils.isNumber))];
	  }, [Infinity, -Infinity]);
	};
	
	var getDomainOfStackGroups = function getDomainOfStackGroups(stackGroups, startIndex, endIndex) {
	  return Object.keys(stackGroups).reduce(function (result, stackId) {
	    var group = stackGroups[stackId];
	    var stackedData = group.stackedData;
	    var domain = stackedData.reduce(function (res, entry) {
	      var s = getDomainOfSingle(entry.slice(startIndex, endIndex + 1));
	      return [Math.min(res[0], s[0]), Math.max(res[1], s[1])];
	    }, [Infinity, -Infinity]);
	    return [Math.min(domain[0], result[0]), Math.max(domain[1], result[1])];
	  }, [Infinity, -Infinity]).map(function (result) {
	    return result === Infinity || result === -Infinity ? 0 : result;
	  });
	};
	
	exports.getDomainOfStackGroups = getDomainOfStackGroups;
	var MIN_VALUE_REG = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
	exports.MIN_VALUE_REG = MIN_VALUE_REG;
	var MAX_VALUE_REG = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
	exports.MAX_VALUE_REG = MAX_VALUE_REG;
	
	var parseSpecifiedDomain = function parseSpecifiedDomain(specifiedDomain, dataDomain, allowDataOverflow) {
	  if (!(0, _isArray2["default"])(specifiedDomain)) {
	    return dataDomain;
	  }
	
	  var domain = [];
	  /* eslint-disable prefer-destructuring */
	
	  if ((0, _DataUtils.isNumber)(specifiedDomain[0])) {
	    domain[0] = allowDataOverflow ? specifiedDomain[0] : Math.min(specifiedDomain[0], dataDomain[0]);
	  } else if (MIN_VALUE_REG.test(specifiedDomain[0])) {
	    var value = +MIN_VALUE_REG.exec(specifiedDomain[0])[1];
	    domain[0] = dataDomain[0] - value;
	  } else if ((0, _isFunction2["default"])(specifiedDomain[0])) {
	    domain[0] = specifiedDomain[0](dataDomain[0]);
	  } else {
	    domain[0] = dataDomain[0];
	  }
	
	  if ((0, _DataUtils.isNumber)(specifiedDomain[1])) {
	    domain[1] = allowDataOverflow ? specifiedDomain[1] : Math.max(specifiedDomain[1], dataDomain[1]);
	  } else if (MAX_VALUE_REG.test(specifiedDomain[1])) {
	    var _value = +MAX_VALUE_REG.exec(specifiedDomain[1])[1];
	
	    domain[1] = dataDomain[1] + _value;
	  } else if ((0, _isFunction2["default"])(specifiedDomain[1])) {
	    domain[1] = specifiedDomain[1](dataDomain[1]);
	  } else {
	    domain[1] = dataDomain[1];
	  }
	  /* eslint-enable prefer-destructuring */
	
	
	  return domain;
	};
	/**
	 * Calculate the size between two category
	 * @param  {Object} axis  The options of axis
	 * @param  {Array}  ticks The ticks of axis
	 * @return {Number} Size
	 */
	
	
	exports.parseSpecifiedDomain = parseSpecifiedDomain;
	
	var getBandSizeOfAxis = function getBandSizeOfAxis(axis, ticks) {
	  if (axis && axis.scale && axis.scale.bandwidth) {
	    return axis.scale.bandwidth();
	  }
	
	  if (axis && ticks && ticks.length >= 2) {
	    var orderedTicks = (0, _sortBy2["default"])(ticks, function (o) {
	      return o.coordinate;
	    });
	    var bandSize = Infinity;
	
	    for (var i = 1, len = orderedTicks.length; i < len; i++) {
	      var cur = orderedTicks[i];
	      var prev = orderedTicks[i - 1];
	      bandSize = Math.min((cur.coordinate || 0) - (prev.coordinate || 0), bandSize);
	    }
	
	    return bandSize === Infinity ? 0 : bandSize;
	  }
	
	  return 0;
	};
	/**
	 * parse the domain of a category axis when a domain is specified
	 * @param   {Array}        specifiedDomain  The domain specified by users
	 * @param   {Array}        calculatedDomain The domain calculated by dateKey
	 * @param   {ReactElement} axisChild        The axis element
	 * @returns {Array}        domains
	 */
	
	
	exports.getBandSizeOfAxis = getBandSizeOfAxis;
	
	var parseDomainOfCategoryAxis = function parseDomainOfCategoryAxis(specifiedDomain, calculatedDomain, axisChild) {
	  if (!specifiedDomain || !specifiedDomain.length) {
	    return calculatedDomain;
	  }
	
	  if ((0, _isEqual2["default"])(specifiedDomain, (0, _get2["default"])(axisChild, 'type.defaultProps.domain'))) {
	    return calculatedDomain;
	  }
	
	  return specifiedDomain;
	};
	
	exports.parseDomainOfCategoryAxis = parseDomainOfCategoryAxis;

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.assistedTransfer = exports.moreOptions = exports.hangUpLeaveMessage = exports.hangUp = exports.record = exports.ivr = exports.resume = exports.hold = exports.mute = exports.noVolume = exports.volumeMedium = exports.volume = exports.dtmfSVG = exports.rateCallSvg = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rateCallSvg = exports.rateCallSvg = _react2.default.createElement(
		"svg",
		{ className: "iconBarCall", version: "1.1", id: "Capa_1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
			viewBox: "-3 -3 30 30", enableBackground: "new 0 0 24 24", xmlSpace: "preserve" },
		_react2.default.createElement(
			"g",
			null,
			_react2.default.createElement("polygon", { className: "st0", points: "8,20.6 2,14.6 4.1,12.5 8,16.4 19.9,4.5 22,6.6 \t\t\t\t" })
		)
	);
	
	var dtmfSVG = exports.dtmfSVG = _react2.default.createElement(
		"svg",
		{ className: "iconBarCall", version: "1.1", id: "Capa_1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
			viewBox: "-1 -3 26 26", enableBackground: "new 0 0 24 24", xmlSpace: "preserve" },
		_react2.default.createElement(
			"g",
			null,
			_react2.default.createElement("circle", { className: "st0", cx: "6.2", cy: "2.7", r: "1.9" })
		),
		_react2.default.createElement(
			"g",
			null,
			_react2.default.createElement("circle", { className: "st0", cx: "12", cy: "2.7", r: "1.9" })
		),
		_react2.default.createElement(
			"g",
			null,
			_react2.default.createElement("circle", { className: "st0", cx: "17.8", cy: "2.7", r: "1.9" })
		),
		_react2.default.createElement(
			"g",
			null,
			_react2.default.createElement("circle", { className: "st0", cx: "6.2", cy: "8.5", r: "1.9" })
		),
		_react2.default.createElement(
			"g",
			null,
			_react2.default.createElement("circle", { className: "st0", cx: "12", cy: "8.5", r: "1.9" })
		),
		_react2.default.createElement(
			"g",
			null,
			_react2.default.createElement("circle", { className: "st0", cx: "17.8", cy: "8.5", r: "1.9" })
		),
		_react2.default.createElement(
			"g",
			null,
			_react2.default.createElement("circle", { className: "st0", cx: "6.2", cy: "14.3", r: "1.9" })
		),
		_react2.default.createElement(
			"g",
			null,
			_react2.default.createElement("circle", { className: "st0", cx: "12", cy: "14.3", r: "1.9" })
		),
		_react2.default.createElement(
			"g",
			null,
			_react2.default.createElement("circle", { className: "st0", cx: "17.8", cy: "14.3", r: "1.9" })
		),
		_react2.default.createElement(
			"g",
			null,
			_react2.default.createElement("circle", { className: "st0", cx: "12", cy: "20.1", r: "1.9" })
		)
	);
	
	var volume = exports.volume = _react2.default.createElement(
		"svg",
		{ version: "1.1", id: "Layer_1", className: "iconBarCall", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
			width: "100%", height: "100%", viewBox: "0 0 30 30", enableBackground: "new 0 0 30 30", xmlSpace: "preserve" },
		_react2.default.createElement("path", { d: "M6,11.921v6.158h3.999L15,23.21V6.79l-5.001,5.132H6z M19.5,15c0-1.816-1.02-3.376-2.5-4.135v8.26\r C18.48,18.377,19.5,16.816,19.5,15z M17,6v2.114c2.891,0.883,5,3.633,5,6.886c0,3.253-2.109,6.003-5,6.887V24\r c4.01-0.934,7-4.608,7-9S21.01,6.934,17,6z" })
	);
	
	var volumeMedium = exports.volumeMedium = _react2.default.createElement(
		"svg",
		{ version: "1.1", id: "Layer_1", className: "iconBarCall", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
			width: "100%", height: "100%", viewBox: "0 2 26 26", enableBackground: "new 0 0 30 30", xmlSpace: "preserve" },
		_react2.default.createElement("path", { d: "M6,11.921v6.158h3.999L15,23.21V6.79l-5.001,5.132H6z M19.5,15c0-1.816-1.02-3.376-2.5-4.135v8.26\r C18.48,18.377,19.5,16.816,19.5,15z" })
	);
	
	var noVolume = exports.noVolume = _react2.default.createElement(
		"svg",
		{ version: "1.1", className: "iconBarCall", id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
			width: "100%", height: "100%", viewBox: "0 0 30 30", enableBackground: "new 0 0 30 30;", xmlSpace: "preserve" },
		_react2.default.createElement("path", { className: "st0", d: "M19.5,15c0-1.8-1-3.3-2.5-4v2.2l2.4,2.4C19.5,15.4,19.5,15.2,19.5,15z M22,15c0,0.9-0.2,1.8-0.5,2.6l1.5,1.5\r c0.7-1.2,1-2.7,1-4.2c0-4.3-3-7.9-7-8.8v2.1C19.9,9.1,22,11.8,22,15z M7.3,6L6,7.3l4.7,4.7H6v6h4l5,5v-6.7l4.2,4.2\r c-0.7,0.5-1.4,0.9-2.2,1.2v2.1c1.4-0.3,2.6-0.9,3.7-1.8l2,2l1.3-1.3l-9-9L7.3,6z M15,7l-2.1,2.1l2.1,2.1V7z" })
	);
	
	var mute = exports.mute = _react2.default.createElement(
		"svg",
		{ version: "1.1", className: "iconBarCall", id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
			width: "100%", height: "100%", viewBox: "0 0 30 30", enableBackground: "new 0 0 30 30;", xmlSpace: "preserve" },
		_react2.default.createElement(
			"g",
			{ id: "Group_1341", transform: "translate(6951 -27)" },
			_react2.default.createElement(
				"g",
				{ id: "Group_1235" },
				_react2.default.createElement(
					"g",
					{ id: "Group_1234" },
					_react2.default.createElement("path", { id: "Path_639", d: "M-6943.729,33.5l-1.271,1.27l6.01,6.01v0.72c-0.007,1.649,1.324,2.992,2.974,3\r c0.005,0,0.011,0,0.016,0c0.219-0.001,0.437-0.028,0.649-0.08l1.661,1.659c-0.724,0.34-1.512,0.518-2.311,0.521\r c-2.865,0.061-5.238-2.212-5.3-5.077c0-0.008,0-0.016,0-0.024h-1.7c0.095,3.403,2.63,6.242,6,6.72v3.28h1.999v-3.28\r c0.897-0.133,1.761-0.438,2.541-0.899l4.189,4.18l1.271-1.271L-6943.729,33.5z M-6933.021,41.67c0-0.06,0.021-0.11,0.021-0.17v-6\r c0-1.657-1.344-3-3-3c-1.657,0-3,1.343-3,3v0.18L-6933.021,41.67z M-6929,41.5h-1.7c0,0.706-0.146,1.404-0.43,2.05l1.229,1.23\r C-6929.318,43.784-6929.008,42.653-6929,41.5" })
				)
			)
		)
	);
	
	var hold = exports.hold = _react2.default.createElement(
		"svg",
		{ version: "1.1", className: "iconBarCall", id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
			width: "100%", height: "100%", viewBox: "0 0 30 30", enableBackground: "new 0 0 30 30;", xmlSpace: "preserve" },
		_react2.default.createElement(
			"g",
			{ id: "Group_1346", transform: "translate(7014 -27)" },
			_react2.default.createElement("path", { id: "Path_544", d: "M-6996.334,51h5.334V33h-5.334V51z M-7007,51h5.332V33H-7007V51z" })
		)
	);
	
	var resume = exports.resume = _react2.default.createElement(
		"svg",
		{ version: "1.1", className: "iconBarCall", id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
			width: "100%", height: "100%", viewBox: "2 2 26 26", enableBackground: "new 0 0 30 30;", xmlSpace: "preserve" },
		_react2.default.createElement(
			"g",
			{ id: "Group_1367", transform: "translate(3642 -1424.15)" },
			_react2.default.createElement("path", { id: "Path_634", d: "M-3622.896,1438.745l-4.038,4.982l-4.038-4.982v-7.595h8.076V1438.745z" }),
			_react2.default.createElement("rect", { id: "Rectangle_258", x: "-3634", y: "1445.147", width: "14", height: "2.003" })
		)
	);
	
	var ivr = exports.ivr = _react2.default.createElement(
		"svg",
		{ version: "1.1", className: "iconBarCall", id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
			width: "100%", height: "100%", viewBox: "2 3 26 26", enableBackground: "new 0 0 30 30;", xmlSpace: "preserve" },
		_react2.default.createElement(
			"g",
			{ id: "Group_1355", transform: "translate(7131 -23)" },
			_react2.default.createElement(
				"g",
				{ id: "Group_1252" },
				_react2.default.createElement(
					"g",
					{ id: "Group_1247", transform: "translate(0 9.5)" },
					_react2.default.createElement("path", { id: "Path_643", d: "M-7120.071,35.06c-0.001,0.249-0.203,0.451-0.452,0.451h-4.524\r c-0.249,0-0.451-0.201-0.453-0.451V31.44c0.001-0.249,0.203-0.45,0.452-0.452h4.525c0.249,0.002,0.45,0.203,0.451,0.452\r L-7120.071,35.06z" })
				),
				_react2.default.createElement(
					"g",
					{ id: "Group_1248", transform: "translate(6.786 9.5)" },
					_react2.default.createElement("path", { id: "Path_644", d: "M-7120.071,35.06c-0.001,0.249-0.202,0.451-0.452,0.451h-4.524\r c-0.249,0-0.452-0.201-0.453-0.451V31.44c0.001-0.249,0.203-0.45,0.452-0.452h4.525c0.248,0.002,0.45,0.203,0.451,0.452\r L-7120.071,35.06z" })
				),
				_react2.default.createElement(
					"g",
					{ id: "Group_1249", transform: "translate(13.571 9.5)" },
					_react2.default.createElement("path", { id: "Path_645", d: "M-7120.071,35.06c-0.001,0.249-0.203,0.451-0.452,0.451h-4.524\r c-0.249,0-0.451-0.201-0.452-0.451V31.44c0.001-0.249,0.202-0.45,0.451-0.452h4.524c0.249,0.002,0.45,0.203,0.452,0.452\r L-7120.071,35.06z" })
				),
				_react2.default.createElement(
					"g",
					{ id: "Group_1250", transform: "translate(2.262 4.071)" },
					_react2.default.createElement("path", { id: "Path_646", d: "M-7125.5,30.989v4.071c-0.023,0.248,0.159,0.469,0.407,0.492\r s0.469-0.159,0.492-0.407c0.003-0.028,0.003-0.057,0-0.085v-3.171h12.671v3.171c-0.023,0.248,0.158,0.469,0.407,0.492\r s0.47-0.159,0.493-0.407c0.002-0.028,0.002-0.057,0-0.085v-4.071H-7125.5z" })
				),
				_react2.default.createElement(
					"g",
					{ id: "Group_1251", transform: "translate(9.048)" },
					_react2.default.createElement("path", { id: "Path_647", d: "M-7125.5,30.988v8.144c-0.023,0.249,0.159,0.469,0.408,0.492\r s0.469-0.159,0.492-0.407c0.002-0.028,0.002-0.057,0-0.085v-8.144H-7125.5z" })
				)
			)
		)
	);
	
	var record = exports.record = _react2.default.createElement(
		"svg",
		{ version: "1.1", className: "iconBarCall", id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
			width: "100%", height: "100%", viewBox: "2 2 26 26", enableBackground: "new 0 0 30 30;", xmlSpace: "preserve" },
		_react2.default.createElement(
			"g",
			{ id: "Group_1359", transform: "translate(7181 -20)" },
			_react2.default.createElement(
				"g",
				{ id: "Group_1293" },
				_react2.default.createElement(
					"g",
					{ id: "Group_1292", transform: "translate(0 0)" },
					_react2.default.createElement("path", { id: "Path_665", d: "M-7160.312,38.004c-1.673,0.014-3.042-1.328-3.063-3\r c0.018-1.676,1.388-3.021,3.062-3.007c1.676-0.014,3.046,1.332,3.063,3.007C-7157.271,36.676-7158.64,38.017-7160.312,38.004\r M-7171.688,38.004c-1.672,0.014-3.042-1.328-3.062-3c0.017-1.675,1.386-3.021,3.062-3.007c1.675-0.014,3.046,1.332,3.063,3.007\r C-7168.646,36.676-7170.015,38.017-7171.688,38.004 M-7160.312,30.271c-2.632-0.025-4.787,2.088-4.812,4.721\r c0,0.003,0,0.007,0,0.011c0,1.099,0.391,2.162,1.104,3h-3.956c0.711-0.838,1.102-1.901,1.102-3\r c-0.023-2.633-2.177-4.749-4.809-4.725c-0.001,0-0.003,0-0.004,0c-2.633-0.025-4.788,2.089-4.812,4.722c0,0.001,0,0.002,0,0.003\r c0.023,2.632,2.176,4.748,4.809,4.725c0.001,0,0.002,0,0.004,0h11.375c2.633,0.025,4.787-2.089,4.812-4.721\r c0-0.001,0-0.002,0-0.003c-0.023-2.633-2.177-4.749-4.809-4.725c-0.001,0-0.003,0-0.004,0" })
				)
			)
		)
	);
	
	var hangUp = exports.hangUp = _react2.default.createElement(
		"svg",
		{ version: "1.1", className: "iconBarHangUp", id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
			width: "100%", height: "100%", viewBox: "0 0 30 30", enableBackground: "new 0 0 30 30;", xmlSpace: "preserve" },
		_react2.default.createElement(
			"g",
			{ id: "Group_1556", transform: "translate(7231 -22)" },
			_react2.default.createElement(
				"g",
				{ id: "Group_1054" },
				_react2.default.createElement(
					"g",
					{ id: "Group_1053" },
					_react2.default.createElement("path", { id: "Path_549", d: "M-7216,34.57c-1.562-0.002-3.114,0.241-4.6,0.72v3.1c0,0.382-0.217,0.73-0.56,0.9\r c-0.969,0.487-1.865,1.11-2.66,1.85c-0.186,0.183-0.438,0.283-0.7,0.279c-0.266,0.002-0.521-0.102-0.709-0.289l-2.48-2.48\r c-0.189-0.184-0.294-0.437-0.29-0.7c-0.002-0.266,0.103-0.521,0.29-0.709c3.159-3.003,7.352-4.675,11.71-4.67\r c4.357-0.004,8.552,1.667,11.71,4.67c0.387,0.394,0.387,1.025,0,1.419l-2.48,2.48c-0.189,0.187-0.443,0.291-0.709,0.289\r c-0.262-0.001-0.512-0.101-0.7-0.279c-0.797-0.742-1.695-1.365-2.67-1.851c-0.344-0.168-0.562-0.517-0.561-0.899v-3.1\r C-7212.891,34.812-7214.44,34.565-7216,34.57" })
				)
			)
		)
	);
	
	var hangUpLeaveMessage = exports.hangUpLeaveMessage = _react2.default.createElement(
		"svg",
		{ className: "iconBarCall", version: "1.1", id: "Capa_1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
			width: "26.5px", viewBox: "0 0 22 22", enableBackground: "new 0 0 22 22", xmlSpace: "preserve" },
		_react2.default.createElement("path", { d: "M11,2.5c-5.5,0-10,3.6-10,8c0,1.8,0.8,3.5,2,4.8l-1,4.2l4.1-2c1.5,0.7,3.1,1,4.9,1c5.5,0,10-3.6,10-8\r\nC21,6.1,16.5,2.5,11,2.5z M16.3,13.8l-2.7-2V9.6c-0.8-0.3-1.7-0.5-2.7-0.5c-0.9,0-1.8,0.2-2.7,0.5v2.2l-2.7,2L3,11.2\r\nc1.3-1.7,3.2-3,5.3-3.6c0.9-0.2,1.7-0.4,2.7-0.4s1.8,0.1,2.7,0.4c2.2,0.6,4,1.9,5.3,3.6L16.3,13.8z" })
	);
	
	var moreOptions = exports.moreOptions = _react2.default.createElement(
		"svg",
		{ version: "1.1", className: "iconBarCall", id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
			width: "100%", height: "100%", viewBox: "0 0 30 30", enableBackground: "new 0 0 30 30", xmlSpace: "preserve" },
		_react2.default.createElement(
			"g",
			{ id: "Group_2372", transform: "translate(2463 -315)" },
			_react2.default.createElement("circle", { id: "Ellipse_15", cx: "-2455", cy: "330", r: "2.5" }),
			_react2.default.createElement("circle", { id: "Ellipse_16", cx: "-2448", cy: "330", r: "2.5" }),
			_react2.default.createElement("circle", { id: "Ellipse_17", cx: "-2441", cy: "330", r: "2.5" })
		)
	);
	
	var assistedTransfer = exports.assistedTransfer = _react2.default.createElement(
		"svg",
		{ className: "iconBarCall", version: "1.1", id: "Capa_1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
			viewBox: "-3 -3 30 30", enableBackground: "new 0 0 24 24;", xmlSpace: "preserve" },
		_react2.default.createElement(
			"g",
			{ id: "Group_1128_1_" },
			_react2.default.createElement(
				"g",
				{ id: "Path_587_1_" },
				_react2.default.createElement("path", { className: "st0", d: "M2.1,15.5v3.5c0,0.5,0.4,1,1,1c9.3,0,16.9-7.5,16.9-16.9v0c0-0.5-0.4-1-1-1h-3.5c-0.5,0-1,0.4-1,1\r c0,1.2-0.2,2.4-0.6,3.5c-0.1,0.4,0,0.7,0.2,1l2.2,2.2c-1.4,2.8-3.7,5.1-6.5,6.5l-2.2-2.2c-0.3-0.3-0.7-0.3-1-0.2\r c-1.1,0.4-2.3,0.6-3.5,0.6C2.5,14.5,2.1,14.9,2.1,15.5" })
			)
		),
		_react2.default.createElement(
			"g",
			{ id: "Group_1129_2_", transform: "translate(1.763 0.735)" },
			_react2.default.createElement(
				"g",
				{ id: "Path_588_2_" },
				_react2.default.createElement(
					"g",
					null,
					_react2.default.createElement("polygon", { className: "st0", points: "3.8,5.1 2.3,3.7 2.3,8.8 7.4,8.8 5.9,7.3 \t\t\t\t\t\t" })
				)
			)
		),
		_react2.default.createElement(
			"g",
			null,
			_react2.default.createElement("rect", { x: "4.8", y: "4.7", transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -2.0367 7.1378)", className: "st0", width: "5.6", height: "2.6" })
		),
		_react2.default.createElement(
			"g",
			{ id: "Group_1129_1_", transform: "translate(1.763 0.735)" },
			_react2.default.createElement(
				"g",
				{ id: "Path_588_1_" },
				_react2.default.createElement(
					"g",
					null,
					_react2.default.createElement("polygon", { className: "st0", points: "18.7,18.4 20.1,19.8 20.1,14.7 15.1,14.7 16.6,16.3 \t\t\t\t\t\t" })
				)
			)
		),
		_react2.default.createElement(
			"g",
			null,
			_react2.default.createElement("rect", { x: "15.6", y: "17.7", transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -8.0253 18.5622)", className: "st0", width: "5.6", height: "2.6" })
		)
	);

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(35);
	var hide = __webpack_require__(78);
	var has = __webpack_require__(77);
	var SRC = __webpack_require__(143)('src');
	var $toString = __webpack_require__(1270);
	var TO_STRING = 'toString';
	var TPL = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(46).inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});


/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(11);
	var fails = __webpack_require__(34);
	var defined = __webpack_require__(105);
	var quot = /"/g;
	// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
	var createHTML = function (string, tag, attribute, value) {
	  var S = String(defined(string));
	  var p1 = '<' + tag;
	  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};
	module.exports = function (NAME, exec) {
	  var O = {};
	  O[NAME] = exec(createHTML);
	  $export($export.P + $export.F * fails(function () {
	    var test = ''[NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  }), 'String', O);
	};


/***/ },
/* 70 */
[2771, 1470, 1511, 1469, 1499, 1500, 1501, 1502, 1496, 1497, 1498, 1451, 1452, 380, 1454, 601, 1453, 1455, 258, 1472, 1473, 1474, 205, 206, 1450, 1456, 1461, 1459, 1458, 1457, 1465, 1460, 1462, 1463, 1464, 602, 1521, 604, 381, 605, 603, 1466, 1467, 1468, 607, 1471, 610, 1508, 609, 1524, 1507, 1506, 1510, 1492, 1495, 1493, 1494, 612, 1515, 1486, 1475, 1476, 1477, 1478, 1479, 1480, 1481, 1482, 608, 1484, 1491, 1503, 1504, 1505, 1513, 1514, 1483, 600, 1516, 1517, 1518, 606, 1487, 1488, 1489, 1485, 1490, 1519, 1520, 1522, 1523, 1525, 1512, 12, 1526],
/* 71 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is `null` or `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	 * @example
	 *
	 * _.isNil(null);
	 * // => true
	 *
	 * _.isNil(void 0);
	 * // => true
	 *
	 * _.isNil(NaN);
	 * // => false
	 */
	function isNil(value) {
	  return value == null;
	}
	
	module.exports = isNil;


/***/ },
/* 72 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.utils = exports.Well = exports.Tooltip = exports.Thumbnail = exports.Tabs = exports.TabPane = exports.Table = exports.TabContent = exports.TabContainer = exports.Tab = exports.SplitButton = exports.SafeAnchor = exports.Row = exports.ResponsiveEmbed = exports.Radio = exports.ProgressBar = exports.Popover = exports.PanelGroup = exports.Panel = exports.PaginationButton = exports.Pagination = exports.Pager = exports.PageItem = exports.PageHeader = exports.OverlayTrigger = exports.Overlay = exports.NavItem = exports.NavDropdown = exports.NavbarBrand = exports.Navbar = exports.Nav = exports.ModalTitle = exports.ModalHeader = exports.ModalFooter = exports.ModalBody = exports.Modal = exports.MenuItem = exports.Media = exports.ListGroupItem = exports.ListGroup = exports.Label = exports.Jumbotron = exports.InputGroup = exports.Image = exports.HelpBlock = exports.Grid = exports.Glyphicon = exports.FormGroup = exports.FormControl = exports.Form = exports.Fade = exports.DropdownButton = exports.Dropdown = exports.Collapse = exports.Col = exports.ControlLabel = exports.Clearfix = exports.Checkbox = exports.CarouselItem = exports.Carousel = exports.ButtonToolbar = exports.ButtonGroup = exports.Button = exports.BreadcrumbItem = exports.Breadcrumb = exports.Badge = exports.Alert = exports.Accordion = undefined;
	
	var _Accordion2 = __webpack_require__(2202);
	
	var _Accordion3 = _interopRequireDefault(_Accordion2);
	
	var _Alert2 = __webpack_require__(2203);
	
	var _Alert3 = _interopRequireDefault(_Alert2);
	
	var _Badge2 = __webpack_require__(2204);
	
	var _Badge3 = _interopRequireDefault(_Badge2);
	
	var _Breadcrumb2 = __webpack_require__(2205);
	
	var _Breadcrumb3 = _interopRequireDefault(_Breadcrumb2);
	
	var _BreadcrumbItem2 = __webpack_require__(912);
	
	var _BreadcrumbItem3 = _interopRequireDefault(_BreadcrumbItem2);
	
	var _Button2 = __webpack_require__(226);
	
	var _Button3 = _interopRequireDefault(_Button2);
	
	var _ButtonGroup2 = __webpack_require__(913);
	
	var _ButtonGroup3 = _interopRequireDefault(_ButtonGroup2);
	
	var _ButtonToolbar2 = __webpack_require__(2206);
	
	var _ButtonToolbar3 = _interopRequireDefault(_ButtonToolbar2);
	
	var _Carousel2 = __webpack_require__(2207);
	
	var _Carousel3 = _interopRequireDefault(_Carousel2);
	
	var _CarouselItem2 = __webpack_require__(914);
	
	var _CarouselItem3 = _interopRequireDefault(_CarouselItem2);
	
	var _Checkbox2 = __webpack_require__(2209);
	
	var _Checkbox3 = _interopRequireDefault(_Checkbox2);
	
	var _Clearfix2 = __webpack_require__(2210);
	
	var _Clearfix3 = _interopRequireDefault(_Clearfix2);
	
	var _ControlLabel2 = __webpack_require__(2212);
	
	var _ControlLabel3 = _interopRequireDefault(_ControlLabel2);
	
	var _Col2 = __webpack_require__(2211);
	
	var _Col3 = _interopRequireDefault(_Col2);
	
	var _Collapse2 = __webpack_require__(458);
	
	var _Collapse3 = _interopRequireDefault(_Collapse2);
	
	var _Dropdown2 = __webpack_require__(295);
	
	var _Dropdown3 = _interopRequireDefault(_Dropdown2);
	
	var _DropdownButton2 = __webpack_require__(2213);
	
	var _DropdownButton3 = _interopRequireDefault(_DropdownButton2);
	
	var _Fade2 = __webpack_require__(296);
	
	var _Fade3 = _interopRequireDefault(_Fade2);
	
	var _Form2 = __webpack_require__(2215);
	
	var _Form3 = _interopRequireDefault(_Form2);
	
	var _FormControl2 = __webpack_require__(2216);
	
	var _FormControl3 = _interopRequireDefault(_FormControl2);
	
	var _FormGroup2 = __webpack_require__(2219);
	
	var _FormGroup3 = _interopRequireDefault(_FormGroup2);
	
	var _Glyphicon2 = __webpack_require__(459);
	
	var _Glyphicon3 = _interopRequireDefault(_Glyphicon2);
	
	var _Grid2 = __webpack_require__(917);
	
	var _Grid3 = _interopRequireDefault(_Grid2);
	
	var _HelpBlock2 = __webpack_require__(2220);
	
	var _HelpBlock3 = _interopRequireDefault(_HelpBlock2);
	
	var _Image2 = __webpack_require__(2221);
	
	var _Image3 = _interopRequireDefault(_Image2);
	
	var _InputGroup2 = __webpack_require__(2222);
	
	var _InputGroup3 = _interopRequireDefault(_InputGroup2);
	
	var _Jumbotron2 = __webpack_require__(2225);
	
	var _Jumbotron3 = _interopRequireDefault(_Jumbotron2);
	
	var _Label2 = __webpack_require__(2226);
	
	var _Label3 = _interopRequireDefault(_Label2);
	
	var _ListGroup2 = __webpack_require__(2227);
	
	var _ListGroup3 = _interopRequireDefault(_ListGroup2);
	
	var _ListGroupItem2 = __webpack_require__(918);
	
	var _ListGroupItem3 = _interopRequireDefault(_ListGroupItem2);
	
	var _Media2 = __webpack_require__(460);
	
	var _Media3 = _interopRequireDefault(_Media2);
	
	var _MenuItem2 = __webpack_require__(2234);
	
	var _MenuItem3 = _interopRequireDefault(_MenuItem2);
	
	var _Modal2 = __webpack_require__(2235);
	
	var _Modal3 = _interopRequireDefault(_Modal2);
	
	var _ModalBody2 = __webpack_require__(919);
	
	var _ModalBody3 = _interopRequireDefault(_ModalBody2);
	
	var _ModalFooter2 = __webpack_require__(920);
	
	var _ModalFooter3 = _interopRequireDefault(_ModalFooter2);
	
	var _ModalHeader2 = __webpack_require__(921);
	
	var _ModalHeader3 = _interopRequireDefault(_ModalHeader2);
	
	var _ModalTitle2 = __webpack_require__(922);
	
	var _ModalTitle3 = _interopRequireDefault(_ModalTitle2);
	
	var _Nav2 = __webpack_require__(923);
	
	var _Nav3 = _interopRequireDefault(_Nav2);
	
	var _Navbar2 = __webpack_require__(2238);
	
	var _Navbar3 = _interopRequireDefault(_Navbar2);
	
	var _NavbarBrand2 = __webpack_require__(925);
	
	var _NavbarBrand3 = _interopRequireDefault(_NavbarBrand2);
	
	var _NavDropdown2 = __webpack_require__(2237);
	
	var _NavDropdown3 = _interopRequireDefault(_NavDropdown2);
	
	var _NavItem2 = __webpack_require__(924);
	
	var _NavItem3 = _interopRequireDefault(_NavItem2);
	
	var _Overlay2 = __webpack_require__(926);
	
	var _Overlay3 = _interopRequireDefault(_Overlay2);
	
	var _OverlayTrigger2 = __webpack_require__(2242);
	
	var _OverlayTrigger3 = _interopRequireDefault(_OverlayTrigger2);
	
	var _PageHeader2 = __webpack_require__(2243);
	
	var _PageHeader3 = _interopRequireDefault(_PageHeader2);
	
	var _PageItem2 = __webpack_require__(2244);
	
	var _PageItem3 = _interopRequireDefault(_PageItem2);
	
	var _Pager2 = __webpack_require__(2245);
	
	var _Pager3 = _interopRequireDefault(_Pager2);
	
	var _Pagination2 = __webpack_require__(2246);
	
	var _Pagination3 = _interopRequireDefault(_Pagination2);
	
	var _PaginationButton2 = __webpack_require__(928);
	
	var _PaginationButton3 = _interopRequireDefault(_PaginationButton2);
	
	var _Panel2 = __webpack_require__(2247);
	
	var _Panel3 = _interopRequireDefault(_Panel2);
	
	var _PanelGroup2 = __webpack_require__(929);
	
	var _PanelGroup3 = _interopRequireDefault(_PanelGroup2);
	
	var _Popover2 = __webpack_require__(2248);
	
	var _Popover3 = _interopRequireDefault(_Popover2);
	
	var _ProgressBar2 = __webpack_require__(2249);
	
	var _ProgressBar3 = _interopRequireDefault(_ProgressBar2);
	
	var _Radio2 = __webpack_require__(2250);
	
	var _Radio3 = _interopRequireDefault(_Radio2);
	
	var _ResponsiveEmbed2 = __webpack_require__(2251);
	
	var _ResponsiveEmbed3 = _interopRequireDefault(_ResponsiveEmbed2);
	
	var _Row2 = __webpack_require__(2252);
	
	var _Row3 = _interopRequireDefault(_Row2);
	
	var _SafeAnchor2 = __webpack_require__(99);
	
	var _SafeAnchor3 = _interopRequireDefault(_SafeAnchor2);
	
	var _SplitButton2 = __webpack_require__(2253);
	
	var _SplitButton3 = _interopRequireDefault(_SplitButton2);
	
	var _Tab2 = __webpack_require__(2255);
	
	var _Tab3 = _interopRequireDefault(_Tab2);
	
	var _TabContainer2 = __webpack_require__(461);
	
	var _TabContainer3 = _interopRequireDefault(_TabContainer2);
	
	var _TabContent2 = __webpack_require__(462);
	
	var _TabContent3 = _interopRequireDefault(_TabContent2);
	
	var _Table2 = __webpack_require__(2256);
	
	var _Table3 = _interopRequireDefault(_Table2);
	
	var _TabPane2 = __webpack_require__(930);
	
	var _TabPane3 = _interopRequireDefault(_TabPane2);
	
	var _Tabs2 = __webpack_require__(2257);
	
	var _Tabs3 = _interopRequireDefault(_Tabs2);
	
	var _Thumbnail2 = __webpack_require__(2258);
	
	var _Thumbnail3 = _interopRequireDefault(_Thumbnail2);
	
	var _Tooltip2 = __webpack_require__(2259);
	
	var _Tooltip3 = _interopRequireDefault(_Tooltip2);
	
	var _Well2 = __webpack_require__(2260);
	
	var _Well3 = _interopRequireDefault(_Well2);
	
	var _utils2 = __webpack_require__(2264);
	
	var _utils = _interopRequireWildcard(_utils2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports.Accordion = _Accordion3['default'];
	exports.Alert = _Alert3['default'];
	exports.Badge = _Badge3['default'];
	exports.Breadcrumb = _Breadcrumb3['default'];
	exports.BreadcrumbItem = _BreadcrumbItem3['default'];
	exports.Button = _Button3['default'];
	exports.ButtonGroup = _ButtonGroup3['default'];
	exports.ButtonToolbar = _ButtonToolbar3['default'];
	exports.Carousel = _Carousel3['default'];
	exports.CarouselItem = _CarouselItem3['default'];
	exports.Checkbox = _Checkbox3['default'];
	exports.Clearfix = _Clearfix3['default'];
	exports.ControlLabel = _ControlLabel3['default'];
	exports.Col = _Col3['default'];
	exports.Collapse = _Collapse3['default'];
	exports.Dropdown = _Dropdown3['default'];
	exports.DropdownButton = _DropdownButton3['default'];
	exports.Fade = _Fade3['default'];
	exports.Form = _Form3['default'];
	exports.FormControl = _FormControl3['default'];
	exports.FormGroup = _FormGroup3['default'];
	exports.Glyphicon = _Glyphicon3['default'];
	exports.Grid = _Grid3['default'];
	exports.HelpBlock = _HelpBlock3['default'];
	exports.Image = _Image3['default'];
	exports.InputGroup = _InputGroup3['default'];
	exports.Jumbotron = _Jumbotron3['default'];
	exports.Label = _Label3['default'];
	exports.ListGroup = _ListGroup3['default'];
	exports.ListGroupItem = _ListGroupItem3['default'];
	exports.Media = _Media3['default'];
	exports.MenuItem = _MenuItem3['default'];
	exports.Modal = _Modal3['default'];
	exports.ModalBody = _ModalBody3['default'];
	exports.ModalFooter = _ModalFooter3['default'];
	exports.ModalHeader = _ModalHeader3['default'];
	exports.ModalTitle = _ModalTitle3['default'];
	exports.Nav = _Nav3['default'];
	exports.Navbar = _Navbar3['default'];
	exports.NavbarBrand = _NavbarBrand3['default'];
	exports.NavDropdown = _NavDropdown3['default'];
	exports.NavItem = _NavItem3['default'];
	exports.Overlay = _Overlay3['default'];
	exports.OverlayTrigger = _OverlayTrigger3['default'];
	exports.PageHeader = _PageHeader3['default'];
	exports.PageItem = _PageItem3['default'];
	exports.Pager = _Pager3['default'];
	exports.Pagination = _Pagination3['default'];
	exports.PaginationButton = _PaginationButton3['default'];
	exports.Panel = _Panel3['default'];
	exports.PanelGroup = _PanelGroup3['default'];
	exports.Popover = _Popover3['default'];
	exports.ProgressBar = _ProgressBar3['default'];
	exports.Radio = _Radio3['default'];
	exports.ResponsiveEmbed = _ResponsiveEmbed3['default'];
	exports.Row = _Row3['default'];
	exports.SafeAnchor = _SafeAnchor3['default'];
	exports.SplitButton = _SplitButton3['default'];
	exports.Tab = _Tab3['default'];
	exports.TabContainer = _TabContainer3['default'];
	exports.TabContent = _TabContent3['default'];
	exports.Table = _Table3['default'];
	exports.TabPane = _TabPane3['default'];
	exports.Tabs = _Tabs3['default'];
	exports.Thumbnail = _Thumbnail3['default'];
	exports.Tooltip = _Tooltip3['default'];
	exports.Well = _Well3['default'];
	exports.utils = _utils;

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Iterates through children that are typically specified as `props.children`,
	 * but only maps over children that are "valid components".
	 *
	 * The mapFunction provided index will be normalised to the components mapped,
	 * so an invalid component would not increase the index.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func.
	 * @param {*} context Context for func.
	 * @return {object} Object containing the ordered map of results.
	 */
	function map(children, func, context) {
	  var index = 0;
	
	  return _react2['default'].Children.map(children, function (child) {
	    if (!_react2['default'].isValidElement(child)) {
	      return child;
	    }
	
	    return func.call(context, child, index++);
	  });
	}
	
	/**
	 * Iterates through children that are "valid components".
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child with the index reflecting the position relative to "valid components".
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func.
	 * @param {*} context Context for context.
	 */
	// TODO: This module should be ElementChildren, and should use named exports.
	
	function forEach(children, func, context) {
	  var index = 0;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    func.call(context, child, index++);
	  });
	}
	
	/**
	 * Count the number of "valid components" in the Children container.
	 *
	 * @param {?*} children Children tree container.
	 * @returns {number}
	 */
	function count(children) {
	  var result = 0;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    ++result;
	  });
	
	  return result;
	}
	
	/**
	 * Finds children that are typically specified as `props.children`,
	 * but only iterates over children that are "valid components".
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child with the index reflecting the position relative to "valid components".
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func.
	 * @param {*} context Context for func.
	 * @returns {array} of children that meet the func return statement
	 */
	function filter(children, func, context) {
	  var index = 0;
	  var result = [];
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    if (func.call(context, child, index++)) {
	      result.push(child);
	    }
	  });
	
	  return result;
	}
	
	function find(children, func, context) {
	  var index = 0;
	  var result = undefined;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (result) {
	      return;
	    }
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    if (func.call(context, child, index++)) {
	      result = child;
	    }
	  });
	
	  return result;
	}
	
	function every(children, func, context) {
	  var index = 0;
	  var result = true;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (!result) {
	      return;
	    }
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    if (!func.call(context, child, index++)) {
	      result = false;
	    }
	  });
	
	  return result;
	}
	
	function some(children, func, context) {
	  var index = 0;
	  var result = false;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (result) {
	      return;
	    }
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    if (func.call(context, child, index++)) {
	      result = true;
	    }
	  });
	
	  return result;
	}
	
	function toArray(children) {
	  var result = [];
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    result.push(child);
	  });
	
	  return result;
	}
	
	exports['default'] = {
	  map: map,
	  forEach: forEach,
	  count: count,
	  find: find,
	  filter: filter,
	  every: every,
	  some: some,
	  toArray: toArray
	};
	module.exports = exports['default'];

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	var _interopRequireWildcard = __webpack_require__(154);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "Popper", {
	  enumerable: true,
	  get: function get() {
	    return _Popper.default;
	  }
	});
	Object.defineProperty(exports, "placements", {
	  enumerable: true,
	  get: function get() {
	    return _Popper.placements;
	  }
	});
	Object.defineProperty(exports, "Manager", {
	  enumerable: true,
	  get: function get() {
	    return _Manager.default;
	  }
	});
	Object.defineProperty(exports, "Reference", {
	  enumerable: true,
	  get: function get() {
	    return _Reference.default;
	  }
	});
	
	var _Popper = _interopRequireWildcard(__webpack_require__(2297));
	
	var _Manager = _interopRequireDefault(__webpack_require__(466));
	
	var _Reference = _interopRequireDefault(__webpack_require__(2298));

/***/ },
/* 76 */
46,
/* 77 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ },
/* 78 */
[2632, 57, 141, 56],
/* 79 */
[2660, 202, 105],
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(2083),
	    baseMatchesProperty = __webpack_require__(2084),
	    identity = __webpack_require__(181),
	    isArray = __webpack_require__(43),
	    property = __webpack_require__(2179);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "configBezier", {
	  enumerable: true,
	  get: function get() {
	    return _easing.configBezier;
	  }
	});
	Object.defineProperty(exports, "configSpring", {
	  enumerable: true,
	  get: function get() {
	    return _easing.configSpring;
	  }
	});
	Object.defineProperty(exports, "translateStyle", {
	  enumerable: true,
	  get: function get() {
	    return _util.translateStyle;
	  }
	});
	Object.defineProperty(exports, "AnimateGroup", {
	  enumerable: true,
	  get: function get() {
	    return _AnimateGroup.default;
	  }
	});
	exports.default = void 0;
	
	var _Animate = _interopRequireDefault(__webpack_require__(958));
	
	var _easing = __webpack_require__(959);
	
	var _util = __webpack_require__(304);
	
	var _AnimateGroup = _interopRequireDefault(__webpack_require__(2322));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = _Animate.default;
	exports.default = _default;

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(34);
	
	module.exports = function (method, arg) {
	  return !!method && fails(function () {
	    // eslint-disable-next-line no-useless-call
	    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
	  });
	};


/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.formatTweetDate = exports.formatTimeShort24hrs = exports.formatTimeShort = exports.formatTimeOrDateShort = exports.formatTimeLong = exports.formatMailDate = exports.formatDateWithDayOfWeek = exports.formatDateShort = exports.formatDateLong = exports.formatAccount = void 0;
	var _dateFns = __webpack_require__(147);
	var _es = _interopRequireDefault(__webpack_require__(408));
	var _enUS = _interopRequireDefault(__webpack_require__(108));
	var _helpers = __webpack_require__(53);
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	var locales = {
	  es: _es["default"],
	  en: _enUS["default"]
	};
	var dateFormats = {
	  es: 'd/M/yy',
	  en: 'M/d/yy'
	};
	
	/**DATE FORMATTERS */
	var formatTweetDate = exports.formatTweetDate = function formatTweetDate(date, lang) {
	  return (0, _helpers.isValidDate)(date) && (0, _dateFns.format)(date, "h:mm a '·' PP", {
	    locale: locales[lang]
	  });
	};
	/* istanbul ignore next */
	var formatTimeLong = exports.formatTimeLong = function formatTimeLong(date, lang) {
	  return (0, _helpers.isValidDate)(date) && (0, _dateFns.format)(date, 'p', {
	    locale: locales[lang]
	  });
	};
	var formatTimeShort = exports.formatTimeShort = function formatTimeShort(date) {
	  return (0, _helpers.isValidDate)(date) && (0, _dateFns.format)(date, 'h:mm a');
	};
	var formatTimeShort24hrs = exports.formatTimeShort24hrs = function formatTimeShort24hrs(date, lang) {
	  return (0, _helpers.isValidDate)(date) && (0, _dateFns.format)(new Date(date), 'HH:mm', {
	    locale: locales[lang]
	  });
	};
	var formatDateLong = exports.formatDateLong = function formatDateLong(date, lang) {
	  return (0, _helpers.isValidDate)(date) && (0, _dateFns.format)(date, 'PP', {
	    locale: locales[lang]
	  });
	};
	var formatDateShort = exports.formatDateShort = function formatDateShort(date, lang) {
	  return (0, _helpers.isValidDate)(date) && (0, _dateFns.format)(new Date(date), dateFormats[lang], {
	    locale: locales[lang]
	  });
	};
	var formatMailDate = exports.formatMailDate = function formatMailDate(date, lang) {
	  return (0, _helpers.isValidDate)(date) && (0, _dateFns.format)(new Date(date), 'PP h:mm a', {
	    locale: locales[lang]
	  });
	};
	var formatTimeOrDateShort = exports.formatTimeOrDateShort = function formatTimeOrDateShort(date, lang) {
	  return (0, _helpers.isValidDate)(date) && ((0, _dateFns.isToday)(date) ? formatTimeShort(date) : formatDateShort(date, lang));
	};
	var formatDateWithDayOfWeek = exports.formatDateWithDayOfWeek = function formatDateWithDayOfWeek(date, lang) {
	  return (0, _helpers.isValidDate)(date) && (0, _dateFns.format)(date, 'iii d MMMM y', {
	    locale: locales[lang]
	  });
	};
	
	/**OTHERS */
	var formatAccount = exports.formatAccount = function formatAccount(account) {
	  return account.startsWith('@') ? account : '<' + account + '>';
	};

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(742);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ },
/* 85 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.inRangeOfSector = exports.formatAngleOfSector = exports.getAngleOfPoint = exports.distanceBetweenPoints = exports.formatAxisMap = exports.getMaxRadius = exports.polarToCartesian = exports.radianToDegree = exports.degreeToRadian = exports.RADIAN = void 0;
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(71));
	
	var _DataUtils = __webpack_require__(39);
	
	var _ChartUtils = __webpack_require__(66);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var RADIAN = Math.PI / 180;
	exports.RADIAN = RADIAN;
	
	var degreeToRadian = function degreeToRadian(angle) {
	  return angle * Math.PI / 180;
	};
	
	exports.degreeToRadian = degreeToRadian;
	
	var radianToDegree = function radianToDegree(angleInRadian) {
	  return angleInRadian * 180 / Math.PI;
	};
	
	exports.radianToDegree = radianToDegree;
	
	var polarToCartesian = function polarToCartesian(cx, cy, radius, angle) {
	  return {
	    x: cx + Math.cos(-RADIAN * angle) * radius,
	    y: cy + Math.sin(-RADIAN * angle) * radius
	  };
	};
	
	exports.polarToCartesian = polarToCartesian;
	
	var getMaxRadius = function getMaxRadius(width, height) {
	  var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
	    top: 0,
	    right: 0,
	    bottom: 0,
	    left: 0
	  };
	  return Math.min(Math.abs(width - (offset.left || 0) - (offset.right || 0)), Math.abs(height - (offset.top || 0) - (offset.bottom || 0))) / 2;
	};
	/**
	 * Calculate the scale function, position, width, height of axes
	 * @param  {Object} props     Latest props
	 * @param  {Object} axisMap   The configuration of axes
	 * @param  {Object} offset    The offset of main part in the svg element
	 * @param  {Object} axisType  The type of axes, radius-axis or angle-axis
	 * @param  {String} chartName The name of chart
	 * @return {Object} Configuration
	 */
	
	
	exports.getMaxRadius = getMaxRadius;
	
	var formatAxisMap = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
	  var width = props.width,
	      height = props.height;
	  var startAngle = props.startAngle,
	      endAngle = props.endAngle;
	  var cx = (0, _DataUtils.getPercentValue)(props.cx, width, width / 2);
	  var cy = (0, _DataUtils.getPercentValue)(props.cy, height, height / 2);
	  var maxRadius = getMaxRadius(width, height, offset);
	  var innerRadius = (0, _DataUtils.getPercentValue)(props.innerRadius, maxRadius, 0);
	  var outerRadius = (0, _DataUtils.getPercentValue)(props.outerRadius, maxRadius, maxRadius * 0.8);
	  var ids = Object.keys(axisMap);
	  return ids.reduce(function (result, id) {
	    var axis = axisMap[id];
	    var domain = axis.domain,
	        reversed = axis.reversed;
	    var range;
	
	    if ((0, _isNil2["default"])(axis.range)) {
	      if (axisType === 'angleAxis') {
	        range = [startAngle, endAngle];
	      } else if (axisType === 'radiusAxis') {
	        range = [innerRadius, outerRadius];
	      }
	
	      if (reversed) {
	        range = [range[1], range[0]];
	      }
	    } else {
	      range = axis.range;
	      var _range = range;
	
	      var _range2 = _slicedToArray(_range, 2);
	
	      startAngle = _range2[0];
	      endAngle = _range2[1];
	    }
	
	    var _parseScale = (0, _ChartUtils.parseScale)(axis, chartName),
	        realScaleType = _parseScale.realScaleType,
	        scale = _parseScale.scale;
	
	    scale.domain(domain).range(range);
	    (0, _ChartUtils.checkDomainOfScale)(scale);
	    var ticks = (0, _ChartUtils.getTicksOfScale)(scale, _objectSpread({}, axis, {
	      realScaleType: realScaleType
	    }));
	
	    var finalAxis = _objectSpread({}, axis, {}, ticks, {
	      range: range,
	      radius: outerRadius,
	      realScaleType: realScaleType,
	      scale: scale,
	      cx: cx,
	      cy: cy,
	      innerRadius: innerRadius,
	      outerRadius: outerRadius,
	      startAngle: startAngle,
	      endAngle: endAngle
	    });
	
	    return _objectSpread({}, result, _defineProperty({}, id, finalAxis));
	  }, {});
	};
	
	exports.formatAxisMap = formatAxisMap;
	
	var distanceBetweenPoints = function distanceBetweenPoints(point, anotherPoint) {
	  var x1 = point.x,
	      y1 = point.y;
	  var x2 = anotherPoint.x,
	      y2 = anotherPoint.y;
	  return Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2));
	};
	
	exports.distanceBetweenPoints = distanceBetweenPoints;
	
	var getAngleOfPoint = function getAngleOfPoint(_ref, _ref2) {
	  var x = _ref.x,
	      y = _ref.y;
	  var cx = _ref2.cx,
	      cy = _ref2.cy;
	  var radius = distanceBetweenPoints({
	    x: x,
	    y: y
	  }, {
	    x: cx,
	    y: cy
	  });
	
	  if (radius <= 0) {
	    return {
	      radius: radius
	    };
	  }
	
	  var cos = (x - cx) / radius;
	  var angleInRadian = Math.acos(cos);
	
	  if (y > cy) {
	    angleInRadian = 2 * Math.PI - angleInRadian;
	  }
	
	  return {
	    radius: radius,
	    angle: radianToDegree(angleInRadian),
	    angleInRadian: angleInRadian
	  };
	};
	
	exports.getAngleOfPoint = getAngleOfPoint;
	
	var formatAngleOfSector = function formatAngleOfSector(_ref3) {
	  var startAngle = _ref3.startAngle,
	      endAngle = _ref3.endAngle;
	  var startCnt = Math.floor(startAngle / 360);
	  var endCnt = Math.floor(endAngle / 360);
	  var min = Math.min(startCnt, endCnt);
	  return {
	    startAngle: startAngle - min * 360,
	    endAngle: endAngle - min * 360
	  };
	};
	
	exports.formatAngleOfSector = formatAngleOfSector;
	
	var reverseFormatAngleOfSetor = function reverseFormatAngleOfSetor(angle, _ref4) {
	  var startAngle = _ref4.startAngle,
	      endAngle = _ref4.endAngle;
	  var startCnt = Math.floor(startAngle / 360);
	  var endCnt = Math.floor(endAngle / 360);
	  var min = Math.min(startCnt, endCnt);
	  return angle + min * 360;
	};
	
	var inRangeOfSector = function inRangeOfSector(_ref5, sector) {
	  var x = _ref5.x,
	      y = _ref5.y;
	
	  var _getAngleOfPoint = getAngleOfPoint({
	    x: x,
	    y: y
	  }, sector),
	      radius = _getAngleOfPoint.radius,
	      angle = _getAngleOfPoint.angle;
	
	  var innerRadius = sector.innerRadius,
	      outerRadius = sector.outerRadius;
	
	  if (radius < innerRadius || radius > outerRadius) {
	    return false;
	  }
	
	  if (radius === 0) {
	    return true;
	  }
	
	  var _formatAngleOfSector = formatAngleOfSector(sector),
	      startAngle = _formatAngleOfSector.startAngle,
	      endAngle = _formatAngleOfSector.endAngle;
	
	  var formatAngle = angle;
	  var inRange;
	
	  if (startAngle <= endAngle) {
	    while (formatAngle > endAngle) {
	      formatAngle -= 360;
	    }
	
	    while (formatAngle < startAngle) {
	      formatAngle += 360;
	    }
	
	    inRange = formatAngle >= startAngle && formatAngle <= endAngle;
	  } else {
	    while (formatAngle > startAngle) {
	      formatAngle -= 360;
	    }
	
	    while (formatAngle < endAngle) {
	      formatAngle += 360;
	    }
	
	    inRange = formatAngle >= endAngle && formatAngle <= startAngle;
	  }
	
	  if (inRange) {
	    return _objectSpread({}, sector, {
	      radius: radius,
	      angle: reverseFormatAngleOfSetor(formatAngle, sector)
	    });
	  }
	
	  return null;
	};
	
	exports.inRangeOfSector = inRangeOfSector;

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.closeUnified = exports.changeMultimediaState = exports.changeState = exports.acceptChatSaveTime = exports.aceptedChat = exports.sendMessageToExternalMU = exports.Reconnected = undefined;
	exports.messageLogin = messageLogin;
	exports.messageLogOut = messageLogOut;
	exports.messageKeepAlive = messageKeepAlive;
	exports.messageNoAvailable = messageNoAvailable;
	exports.messageAgentRedy = messageAgentRedy;
	exports.messageFirstCall = messageFirstCall;
	exports.messageRetryFirstCall = messageRetryFirstCall;
	exports.messagePassToReady = messagePassToReady;
	exports.messageToSupervisor = messageToSupervisor;
	exports.messageNotifyAlreadyWrapUp = messageNotifyAlreadyWrapUp;
	exports.messageChangeStateHelper = messageChangeStateHelper;
	exports.messageStartStopRecording = messageStartStopRecording;
	exports.messageSaveMarksSM = messageSaveMarksSM;
	exports.messageApiRequest = messageApiRequest;
	exports.messageHangUp = messageHangUp;
	exports.messageTransferCall = messageTransferCall;
	exports.messageAssistedTransferCall = messageAssistedTransferCall;
	exports.updateInfoCall = updateInfoCall;
	exports.manualCall = manualCall;
	exports.manualMessage = manualMessage;
	exports.messageOngoingCallIvr = messageOngoingCallIvr;
	exports.endConversationChat = endConversationChat;
	exports.sendDisposition = sendDisposition;
	exports.spamConversation = spamConversation;
	exports.unassignConversation = unassignConversation;
	exports.discardConversation = discardConversation;
	exports.selectedMessage = selectedMessage;
	exports.RequestedLogout = RequestedLogout;
	exports.sendUnifiedResponse = sendUnifiedResponse;
	exports.SetAgentDialingMode = SetAgentDialingMode;
	exports.PreviewRecord = PreviewRecord;
	exports.messagePreviewTransfer = messagePreviewTransfer;
	exports.responsePreviewTransfer = responsePreviewTransfer;
	exports.GetMoreMessages = GetMoreMessages;
	exports.messageApiRequestANIList = messageApiRequestANIList;
	exports.messageGetPreviewCampaigns = messageGetPreviewCampaigns;
	exports.GetRecordCallPermission = GetRecordCallPermission;
	
	var _singletonSharedData = __webpack_require__(23);
	
	var _constants = __webpack_require__(10);
	
	var sharedData = new _singletonSharedData.SingletonSharedData();
	var senderType = 2;
	var timeStampSession = '';
	
	function messageLogin(timeStamp) {
	    try {
	        timeStampSession = timeStamp;
	    } catch (error) {
	        console.warn(error);
	    }
	
	    var isRemote = sharedData.getSoftPhone() === _constants.SOFTPHONES_KEY.MIZUJS ? 0 : 1;
	    var myStorage = window.localStorage;
	    var lastAgentTimeSpam = myStorage.getItem('AgentTimeSpam');
	
	    return {
	        action: 'login',
	        username: sharedData.getUserData().Login,
	        userID: sharedData.getParameters().UserID,
	        ext: sharedData.getParameters().Extension,
	        computer: sharedData.getParameters().ClientComp,
	        Timestamp: timeStamp,
	        Sender: senderType,
	        remote: isRemote,
	        LastNotReadyID: sharedData.getParameters().LastNotREADY,
	        Ip: sharedData.getIPAddress(),
	        LastAgentTimeSpam: lastAgentTimeSpam,
	        DialingMode: sharedData.getUserData().DialingMode
	    };
	}
	
	function messageLogOut(timeStamp) {
	    var obj = {
	        action: 'Logout',
	        username: sharedData.getUserData().Login,
	        userID: sharedData.getParameters().UserID,
	        Timestamp: timeStamp
	    };
	    return JSON.stringify(obj);
	}
	
	function messageKeepAlive() {
	    var username = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var timeSpam = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	    return {
	        keepAlive: 1,
	        action: 'KeepAlive',
	        Sender: senderType,
	        username: username,
	        timeSpam: timeSpam
	    };
	}
	
	function messageNoAvailable(userName, userID, notReadyID, conversationID, timeInPreview) {
	    var obj = {
	        action: 'notReady',
	        username: userName,
	        userID: userID,
	        notReadyId: notReadyID,
	        conversationID: conversationID != null ? conversationID : undefined,
	        Sender: senderType,
	        TimePreview: timeInPreview
	    };
	    return JSON.stringify(obj);
	}
	
	function messageAgentRedy() {
	    var obj = {
	        action: 'ready',
	        username: sharedData.getUserData().Login,
	        userID: sharedData.getParameters().UserID,
	        Sender: senderType
	    };
	    return JSON.stringify(obj);
	}
	
	function messageFirstCall(username, userID) {
	    return {
	        action: 'firstCall',
	        username: username,
	        userID: userID,
	        Sender: senderType
	    };
	}
	
	function messageRetryFirstCall(username, userID) {
	    var obj = {
	        action: 'reconnect',
	        username: username,
	        userID: userID,
	        Sender: senderType
	    };
	    return JSON.stringify(obj);
	}
	
	function messagePassToReady(password, supervisorPassword, requieredSupervisorPass) {
	    var obj = {
	        nombre: sharedData.getUserData().Login,
	        password: password,
	        supervisorPassword: supervisorPassword,
	        supervisorPasswordRequired: requieredSupervisorPass,
	        ipAddress: sharedData.getParameters().ClientComp,
	        Sender: senderType
	    };
	    return obj;
	}
	
	function messageToSupervisor(message, admin) {
	    var obj = {
	        action: 'chatMessageAdmin',
	        username: sharedData.getUserData().Login,
	        userID: sharedData.getParameters().UserID,
	        message: message,
	        admin: admin,
	        Sender: senderType
	    };
	    return JSON.stringify(obj);
	}
	
	function messageNotifyAlreadyWrapUp() {
	    var obj = {
	        action: 'WrapUp',
	        username: sharedData.getUserData().Login,
	        userID: sharedData.getParameters().UserID
	    };
	    return JSON.stringify(obj);
	}
	
	function messageChangeStateHelper() {
	    var obj = {
	        action: 'ChangeState',
	        username: sharedData.getUserData().Login,
	        userID: sharedData.getParameters().UserID
	    };
	    return JSON.stringify(obj);
	}
	
	function messageStartStopRecording(isStop) {
	    var callOutId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	    var obj = {
	        action: 'StartStopRecording',
	        username: sharedData.getUserData().Login,
	        userID: sharedData.getParameters().UserID,
	        isStop: isStop,
	        callOutId: callOutId
	    };
	    return JSON.stringify(obj);
	}
	
	function messageSaveMarksSM(marks, callOutId) {
	    var obj = {
	        action: 'markCall',
	        username: sharedData.getUserData().Login,
	        userID: sharedData.getParameters().UserID,
	        Times: marks,
	        callOutId: callOutId
	    };
	    return JSON.stringify(obj);
	}
	
	function messageApiRequest(subaction, json) {
	    var expectsResponse = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	    var callOutId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
	
	    return {
	        action: 'Api',
	        username: sharedData.getUserData().Login,
	        userID: sharedData.getParameters().UserID,
	        Subaction: subaction,
	        Json: JSON.stringify(json),
	        ExpectsReponse: expectsResponse,
	        callOutId: callOutId
	    };
	}
	
	function messageHangUp(subaction, callOutId, maxTime) {
	    sharedData.setIsHangedUpByAgent(_constants.STATE_TO_PLAY_END_AUDIO.HANG_UP_AGENT);
	    return {
	        action: 'HangUp',
	        username: sharedData.getUserData().Login,
	        userID: sharedData.getParameters().UserID,
	        Subaction: subaction,
	        callOutId: callOutId,
	        calloutMaxTime: maxTime
	    };
	}
	function messageTransferCall(data) {
	    sharedData.setIsHangedUpByAgent(_constants.STATE_TO_PLAY_END_AUDIO.HANG_UP_AGENT);
	    return {
	        action: 'TransferCall',
	        username: sharedData.getUserData().Login,
	        userID: sharedData.getParameters().UserID,
	        acdID: data.acdID,
	        callKey: data.callKey,
	        datos: data.array,
	        typeTransfer: data.typeTransfer,
	        camId: data.camId,
	        sPhone: data.sPhone,
	        dnis: data.dnis,
	        extId: data.extId
	    };
	}
	function messageAssistedTransferCall(action, data) {
	    var obj = Object.assign({
	        action: action,
	        username: sharedData.getUserData().Login,
	        reference: data.reference,
	        phoneNumber: data.sPhone,
	        callId: data.callId,
	        typeTransfer: data.typeTransfer !== undefined ? data.typeTransfer : '-1'
	    }, action === "TransferPreviewCall" && { subaction: 'PreviewCallTransfer' }, data.agentDest && { agentDest: data.agentDest });
	    return JSON.stringify(obj);
	}
	
	function updateInfoCall(callKey, camId, dataCall, callOutId) {
	    var obj = {
	        action: 'UpdateDataCall',
	        username: sharedData.getUserData().Login,
	        userID: sharedData.getParameters().UserID,
	        Data: dataCall,
	        callKey: callKey,
	        camID: camId,
	        CallOutId: callOutId
	    };
	    return JSON.stringify(obj);
	}
	
	function manualCall(data) {
	    var obj = {
	        action: 'manualCall',
	        username: sharedData.getUserData().Login,
	        userID: sharedData.getParameters().UserID,
	        CamId: data.CamId,
	        CallKey: data.CallKey,
	        Phone: data.Phone,
	        Data: data.Data,
	        ExistsCallout: data.ExistsCallout,
	        CallMode: data.CallMode,
	        integration: data.integration,
	        Odbc: data.Odbc,
	        Ani: data.ani
	    };
	    return JSON.stringify(obj);
	}
	
	function manualMessage(data) {
	    var obj = {
	        action: 'manualMessage',
	        username: sharedData.getUserData().Login,
	        userID: sharedData.getParameters().UserID,
	        CamId: data.CamId,
	        Phone: data.Phone,
	        Message: data.Message
	    };
	    return JSON.stringify(obj);
	}
	
	function messageOngoingCallIvr(id) {
	    var obj = {
	        action: 'OngoingCallIvr',
	        username: sharedData.getUserData().Login,
	        userID: sharedData.getParameters().UserID,
	        id: id
	    };
	    return JSON.stringify(obj);
	}
	
	function endConversationChat(data) {
	    var obj = {
	        action: 'responseMedia',
	        username: sharedData.getUserData().Login,
	        userID: sharedData.getParameters().UserID,
	        Timestamp: timeStampSession,
	        MediaType: data.MediaType > 3 ? data.MediaType : 1,
	        ConversationId: data.ConversationId,
	        MessageId: 0,
	        AcdId: data.AcdId,
	        isFinished: data.isReassigned ? false : true,
	        MessageText: '',
	        Subject: '',
	        SenderName: '',
	        Addresses: { From: '', To: [''], CC: [''], BCC: [''] },
	        FileList: ['', ''],
	        showCalifWnd: data.ShowWrapUp,
	        isReassigned: data.isReassigned ? true : false,
	        isSendDouble: data.isSendDouble,
	        IsReassignedByAgent: data.IsReassignedByAgent,
	        CampType: data.CampType
	    };
	    return JSON.stringify(obj);
	}
	
	function sendDisposition(data) {
	    var obj = {
	        action: 'endResponseMedia',
	        username: sharedData.getUserData().Login,
	        userID: sharedData.getParameters().UserID,
	        Timestamp: timeStampSession,
	        MediaType: data.type,
	        DispositionID: data.disposition,
	        SubDispositionID: data.subDisposition,
	        ConversationId: data.conversationId,
	        MessageId: data.messageId ? data.messageId : 0,
	        TWrapUp: data.wrapUp,
	        AcdId: data.acdId,
	        ExitWrapUpDisposition: data.closeModal,
	        CampType: data.camptype != null ? data.camptype : 0
	    };
	    return JSON.stringify(obj);
	}
	
	function spamConversation(data) {
	    var obj = {
	        action: 'spamMedia',
	        username: sharedData.getUserData().Login,
	        userID: sharedData.getUserData().User_id,
	        Timestamp: timeStampSession,
	        MediaType: data.mediaType,
	        ConversationId: data.conversationId,
	        MessageId: data.messageId,
	        AcdId: data.acdID,
	        SubAction: data.mediaType === 5 ? 'WhatsAppSpam' : null,
	        CampType: data.campType
	    };
	    return JSON.stringify(obj);
	}
	
	function unassignConversation(data) {
	    var obj = {
	        action: 'unAssignMedia',
	        username: sharedData.getUserData().Login,
	        userID: sharedData.getUserData().User_id,
	        Timestamp: timeStampSession,
	        MediaType: data.mediaType,
	        ConversationId: data.conversationId,
	        MessageId: data.messageId,
	        AcdId: data.acdID,
	        CampType: data.campType
	    };
	    return JSON.stringify(obj);
	}
	
	function discardConversation(data) {
	    var obj = {
	        action: 'discardMedia',
	        username: sharedData.getUserData().Login,
	        userID: sharedData.getUserData().User_id,
	        Timestamp: timeStampSession,
	        MediaType: data.mediaType,
	        ConversationId: data.conversationId,
	        MessageId: data.messageId,
	        AcdId: data.acdID,
	        CampType: data.campType
	    };
	    return JSON.stringify(obj);
	}
	
	function selectedMessage(data) {
	    var obj = {
	        action: 'selectedMessage',
	        username: sharedData.getUserData().Login,
	        userID: sharedData.getUserData().User_id,
	        TimeStamp: timeStampSession,
	        MediaType: data.mediaType,
	        ConversationId: data.conversationId,
	        MessageId: data.messageId,
	        AcdId: data.acdID,
	        CampType: data.campType
	    };
	    return JSON.stringify(obj);
	}
	
	function RequestedLogout() {
	    return {
	        action: 'logout',
	        username: sharedData.getUserData().Login,
	        userID: sharedData.getParameters().UserID,
	        conversationID: sharedData.getCurrentState() !== "DialogWhatsApp" || !sharedData.getSelectedConversationId() ? 0 : sharedData.selectedConversationId
	    };
	}
	
	var Reconnected = exports.Reconnected = function Reconnected() {
	    return {
	        action: 'Reconnected',
	        username: sharedData.getUserData().Login,
	        userID: sharedData.getParameters().UserID
	    };
	};
	
	function sendUnifiedResponse(data) {
	    if (data.attachments && data.MediaType !== 2) {
	        if (data.MessageType === 'file') {
	            data.MessageText = data.attachments.Name + '>' + data.attachments.Size + '|' + data.attachments.Url;
	        } else {
	            data.MessageText = data.attachments.Url;
	        }
	    }
	
	    var obj = Object.assign({
	        action: 'responseMedia',
	        username: sharedData.getUserData().Login,
	        userID: sharedData.getUserData().User_id,
	        Timestamp: timeStampSession,
	        MediaType: data.MediaType,
	        ConversationId: data.ConversationId,
	        MessageId: !data.messageId || data.MediaType === 1 ? 0 : data.messageId,
	        AcdId: data.AcdId,
	        MessageText: data.MediaType === 1 ? data.MessageText.replaceAll('\n', '\\n').replaceAll('\r', '\\r') : data.MessageText,
	        isFinished: false,
	        Subject: data.subject,
	        SenderName: data.senderName,
	        Addresses: data.addresses,
	        showCalifWnd: true,
	        IsAzure: data.IsAzure,
	        MessageType: data.MessageType,
	        isSendDouble: false,
	        CamType: data.CamType ? data.CamType : 0,
	        ConvUiId: data.CamType && data.ConvUiId ? data.ConvUiId : undefined,
	        CampType: data.CamType
	    }, data.MediaType === 2 && { FileList: data.attachments });
	    return JSON.stringify(obj);
	}
	var sendMessageToExternalMU = exports.sendMessageToExternalMU = function sendMessageToExternalMU(data) {
	
	    var obj = {
	        action: 'responseMedia',
	        username: sharedData.getUserData().Login,
	        userID: sharedData.getUserData().User_id,
	        Timestamp: timeStampSession,
	        MediaType: data.ServiceType,
	        ConversationId: data.ConversationID,
	        MessageId: 0,
	        AcdId: data.AcdId,
	        MessageText: data.data.endConversationChat,
	        isFinished: false,
	        MessageType: data.Type,
	        isSendDouble: false
	    };
	    return JSON.stringify(obj);
	};
	
	var aceptedChat = exports.aceptedChat = function aceptedChat(data) {
	    var obj = {
	        action: 'conversationAcceptedMedia',
	        username: sharedData.getUserData().Login,
	        userID: sharedData.getUserData().User_id,
	        Timestamp: timeStampSession,
	        MediaType: data.MediaType,
	        ConversationId: data.ConversationId,
	        CampType: data.CampType
	    };
	    return JSON.stringify(obj);
	};
	
	var acceptChatSaveTime = exports.acceptChatSaveTime = function acceptChatSaveTime(data) {
	    var obj = {
	        action: 'AcceptConversationWA',
	        username: sharedData.getUserData().Login,
	        ConversationId: data.ConversationId,
	        CamId: data.CamId,
	        CamType: data.CampType
	    };
	    return JSON.stringify(obj);
	};
	
	var changeState = exports.changeState = function changeState(data) {
	    var obj = {
	        action: 'WhatsAppDialog',
	        username: sharedData.getUserData().Login,
	        userID: sharedData.getUserData().User_id,
	        Timestamp: timeStampSession,
	        ConversationId: data.ConversationId,
	        Tel: data.Tel,
	        CamId: data.CamiId,
	        CamType: data.CamType
	    };
	    return JSON.stringify(obj);
	};
	
	var changeMultimediaState = exports.changeMultimediaState = function changeMultimediaState(data) {
	    var obj = {
	        action: 'MultimediaDialogState',
	        username: sharedData.getUserData().Login,
	        userID: sharedData.getUserData().User_id,
	        Timestamp: timeStampSession,
	        ConversationId: data.ConversationId,
	        MediaType: data.MediaType,
	        ClientAccount: data.ClientAccount,
	        CamId: data.CamiId,
	        CamType: data.CamType,
	        AllowCalls: data.AllowCalls,
	        CampType: data.CampType
	    };
	    return JSON.stringify(obj);
	};
	
	var closeUnified = exports.closeUnified = function closeUnified() {
	    var obj = {
	        action: 'CloseModalUnified',
	        username: sharedData.getUserData().Login,
	        userID: sharedData.getUserData().User_id,
	        Timestamp: timeStampSession
	    };
	    return JSON.stringify(obj);
	};
	function SetAgentDialingMode(data) {
	
	    var obj = {
	        action: 'SetAgentDialingMode',
	        username: sharedData.getUserData().Login,
	        userID: sharedData.getParameters().UserID,
	        active: data
	    };
	    return JSON.stringify(obj);
	}
	
	function PreviewRecord(data) {
	
	    var obj = {
	        action: 'Preview',
	        username: sharedData.getUserData().Login,
	        userID: sharedData.getParameters().UserID,
	        callOutId: data.callOutId,
	        camId: data.camId,
	        Process: data.process,
	        TimePreview: data.previewTime,
	        callId: data.callId,
	        fMultipleJob: data.fMultipleJob || 0,
	        fReplacementJob: data.fReplacementJob || 0
	
	    };
	    return JSON.stringify(obj);
	}
	
	function messagePreviewTransfer(subaction, transferAgent, callOutId) {
	    var obj = {
	        action: 'TransferPreviewCall',
	        Subaction: subaction,
	        username: sharedData.getUserData().Login,
	        userID: sharedData.getParameters().UserID,
	        Timestamp: timeStampSession,
	        callOutId: callOutId,
	        transferAgent: transferAgent
	    };
	    return JSON.stringify(obj);
	}
	
	function responsePreviewTransfer(agent, response) {
	    var obj = {
	        action: 'TransferPreviewCall',
	        Subaction: 'AnswerAgentTransfer',
	        username: sharedData.getUserData().Login,
	        userID: sharedData.getParameters().UserID,
	        Timestamp: timeStampSession,
	        mainAgent: agent,
	        answerTransfer: response
	    };
	    return JSON.stringify(obj);
	}
	
	function GetMoreMessages(data) {
	    var obj = {
	        action: 'HistoricalChats',
	        username: sharedData.getUserData().Login,
	        userID: sharedData.getParameters().UserID,
	        MediaType: data.MediaType,
	        ConversationID: data.ConversationId,
	        LastConversationId: data.LastConversationId,
	        CampType: data.CampType
	    };
	    return JSON.stringify(obj);
	}
	
	function messageApiRequestANIList(subaction, campId) {
	    var expectsResponse = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	    return {
	        action: 'Api',
	        username: sharedData.getUserData().Login,
	        userID: sharedData.getParameters().UserID,
	        Subaction: subaction,
	        CampId: campId,
	        ExpectsReponse: expectsResponse
	    };
	}
	function messageGetPreviewCampaigns(subaction) {
	    var obj = {
	        action: 'Campaigns',
	        username: sharedData.getUserData().Login,
	        userID: sharedData.getParameters().UserID,
	        AgentID: sharedData.getParameters().UserID,
	        Subaction: subaction
	    };
	    return JSON.stringify(obj);
	}
	
	function GetRecordCallPermission(subaction, campId) {
	    var expectsResponse = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	    return {
	        action: 'Api',
	        username: sharedData.getUserData().Login,
	        userID: sharedData.getParameters().UserID,
	        Subaction: subaction,
	        CampId: campId,
	        ExpectsReponse: expectsResponse
	    };
	}

/***/ },
/* 88 */
[2666, 347, 244, 103],
/* 89 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx = __webpack_require__(91);
	var IObject = __webpack_require__(202);
	var toObject = __webpack_require__(65);
	var toLength = __webpack_require__(47);
	var asc = __webpack_require__(535);
	module.exports = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || asc;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IObject(O);
	    var f = ctx(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      val = self[index];
	      res = f(val, index, O);
	      if (TYPE) {
	        if (IS_MAP) result[index] = res;   // map
	        else if (res) switch (TYPE) {
	          case 3: return true;             // some
	          case 5: return val;              // find
	          case 6: return index;            // findIndex
	          case 2: result.push(val);        // filter
	        } else if (IS_EVERY) return false; // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};


/***/ },
/* 91 */
[2628, 89],
/* 92 */
[2647, 203, 141, 79, 118, 77, 539, 56],
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(11);
	var core = __webpack_require__(46);
	var fails = __webpack_require__(34);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ },
/* 94 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addDays;
	
	var _index = _interopRequireDefault(__webpack_require__(26));
	
	var _index2 = _interopRequireDefault(__webpack_require__(9));
	
	var _index3 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name addDays
	 * @category Day Helpers
	 * @summary Add the specified number of days to the given date.
	 *
	 * @description
	 * Add the specified number of days to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} - the new date with the days added
	 * @throws {TypeError} - 2 arguments required
	 *
	 * @example
	 * // Add 10 days to 1 September 2014:
	 * const result = addDays(new Date(2014, 8, 1), 10)
	 * //=> Thu Sep 11 2014 00:00:00
	 */
	function addDays(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var amount = (0, _index.default)(dirtyAmount);
	
	  if (isNaN(amount)) {
	    return new Date(NaN);
	  }
	
	  if (!amount) {
	    // If 0 days, no-op to avoid changing times in the hour before end of DST
	    return date;
	  }
	
	  date.setDate(date.getDate() + amount);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isValid;
	
	var _index = _interopRequireDefault(__webpack_require__(398));
	
	var _index2 = _interopRequireDefault(__webpack_require__(9));
	
	var _index3 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isValid
	 * @category Common Helpers
	 * @summary Is the given date valid?
	 *
	 * @description
	 * Returns false if argument is Invalid Date and true otherwise.
	 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * Invalid Date is a Date, whose time value is NaN.
	 *
	 * Time value of Date: http://es5.github.io/#x15.9.1.1
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - Now `isValid` doesn't throw an exception
	 *   if the first argument is not an instance of Date.
	 *   Instead, argument is converted beforehand using `toDate`.
	 *
	 *   Examples:
	 *
	 *   | `isValid` argument        | Before v2.0.0 | v2.0.0 onward |
	 *   |---------------------------|---------------|---------------|
	 *   | `new Date()`              | `true`        | `true`        |
	 *   | `new Date('2016-01-01')`  | `true`        | `true`        |
	 *   | `new Date('')`            | `false`       | `false`       |
	 *   | `new Date(1488370835081)` | `true`        | `true`        |
	 *   | `new Date(NaN)`           | `false`       | `false`       |
	 *   | `'2016-01-01'`            | `TypeError`   | `false`       |
	 *   | `''`                      | `TypeError`   | `false`       |
	 *   | `1488370835081`           | `TypeError`   | `true`        |
	 *   | `NaN`                     | `TypeError`   | `false`       |
	 *
	 *   We introduce this change to make *date-fns* consistent with ECMAScript behavior
	 *   that try to coerce arguments to the expected type
	 *   (which is also the case with other *date-fns* functions).
	 *
	 * @param {*} date - the date to check
	 * @returns {Boolean} the date is valid
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // For the valid date:
	 * const result = isValid(new Date(2014, 1, 31))
	 * //=> true
	 *
	 * @example
	 * // For the value, convertable into a date:
	 * const result = isValid(1393804800000)
	 * //=> true
	 *
	 * @example
	 * // For the invalid date:
	 * const result = isValid(new Date(''))
	 * //=> false
	 */
	function isValid(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	
	  if (!(0, _index.default)(dirtyDate) && typeof dirtyDate !== 'number') {
	    return false;
	  }
	
	  var date = (0, _index2.default)(dirtyDate);
	  return !isNaN(Number(date));
	}
	
	module.exports = exports.default;

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _reactstrap = __webpack_require__(48);
	
	var _classNames = _interopRequireDefault(__webpack_require__(61));
	
	__webpack_require__(2526);
	
	__webpack_require__(2527);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var Button = function Button(_ref) {
	  var id = _ref.id,
	      color = _ref.color,
	      alt = _ref.alt,
	      disabled = _ref.disabled,
	      onClick = _ref.onClick,
	      children = _ref.children,
	      clicked = _ref.clicked,
	      toggle = _ref.toggle,
	      associate = _ref.associate,
	      active = _ref.active,
	      loading = _ref.loading;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      innerLoading = _useState2[0],
	      setInnerLoading = _useState2[1];
	
	  (0, _react.useEffect)(function () {
	    if (!loading) setInnerLoading(false);
	  }, [active, loading]);
	
	  var toggleClick = function toggleClick() {
	    setInnerLoading(true);
	    onClick();
	  };
	
	  var classes = (0, _classNames["default"])({
	    assign: clicked,
	    toggle: toggle || associate,
	    associate: associate,
	    active: active,
	    alt: alt,
	    loading: innerLoading || loading
	  });
	  var icon = toggle ? active ? 'round-minus' : 'close-circle-in' : associate ? active ? 'disassociate' : 'associate' : '';
	  return /*#__PURE__*/_react["default"].createElement("button", {
	    id: id,
	    onClick: toggle ? toggleClick : onClick,
	    className: "gcl-btn ".concat(color, " ").concat(classes),
	    disabled: disabled
	  }, (toggle || associate) && /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon ".concat(icon)
	  }), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-btn-label"
	  }, children), (innerLoading || loading) && /*#__PURE__*/_react["default"].createElement(_reactstrap.Spinner, {
	    color: "primary",
	    style: {
	      width: '1.5rem',
	      height: '1.5rem'
	    }
	  }));
	};
	
	Button.propTypes = {
	  id: _propTypes["default"].string,
	  color: _propTypes["default"].oneOf(['primary', 'secondary', 'tertiary']),
	  alt: _propTypes["default"].bool,
	  onClick: _propTypes["default"].func.isRequired,
	  disabled: _propTypes["default"].bool,
	  clicked: _propTypes["default"].bool,
	  toggle: _propTypes["default"].bool,
	  associate: _propTypes["default"].bool,
	  active: _propTypes["default"].bool,
	  loading: _propTypes["default"].bool
	};
	Button.defaultProps = {
	  color: 'secondary',
	  onClick: function onClick() {
	    return console.warn('no function was assigned as prop');
	  },
	  toggle: false,
	  active: false,
	  alt: false,
	  loading: false
	};
	var _default = Button;
	exports["default"] = _default;

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(440);
	
	/**
	 * Performs a deep comparison between two values to determine if they are
	 * equivalent.
	 *
	 * **Note:** This method supports comparing arrays, array buffers, booleans,
	 * date objects, error objects, maps, numbers, `Object` objects, regexes,
	 * sets, strings, symbols, and typed arrays. `Object` objects are compared
	 * by their own, not inherited, enumerable properties. Functions and DOM
	 * nodes are compared by strict equality, i.e. `===`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.isEqual(object, other);
	 * // => true
	 *
	 * object === other;
	 * // => false
	 */
	function isEqual(value, other) {
	  return baseIsEqual(value, other);
	}
	
	module.exports = isEqual;


/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(42);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  href: _propTypes2['default'].string,
	  onClick: _propTypes2['default'].func,
	  disabled: _propTypes2['default'].bool,
	  role: _propTypes2['default'].string,
	  tabIndex: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	  /**
	   * this is sort of silly but needed for Button
	   */
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'a'
	};
	
	function isTrivialHref(href) {
	  return !href || href.trim() === '#';
	}
	
	/**
	 * There are situations due to browser quirks or Bootstrap CSS where
	 * an anchor tag is needed, when semantically a button tag is the
	 * better choice. SafeAnchor ensures that when an anchor is used like a
	 * button its accessible. It also emulates input `disabled` behavior for
	 * links, which is usually desirable for Buttons, NavItems, MenuItems, etc.
	 */
	
	var SafeAnchor = function (_React$Component) {
	  (0, _inherits3['default'])(SafeAnchor, _React$Component);
	
	  function SafeAnchor(props, context) {
	    (0, _classCallCheck3['default'])(this, SafeAnchor);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  SafeAnchor.prototype.handleClick = function handleClick(event) {
	    var _props = this.props,
	        disabled = _props.disabled,
	        href = _props.href,
	        onClick = _props.onClick;
	
	
	    if (disabled || isTrivialHref(href)) {
	      event.preventDefault();
	    }
	
	    if (disabled) {
	      event.stopPropagation();
	      return;
	    }
	
	    if (onClick) {
	      onClick(event);
	    }
	  };
	
	  SafeAnchor.prototype.render = function render() {
	    var _props2 = this.props,
	        Component = _props2.componentClass,
	        disabled = _props2.disabled,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['componentClass', 'disabled']);
	
	
	    if (isTrivialHref(props.href)) {
	      props.role = props.role || 'button';
	      // we want to make sure there is a href attribute on the node
	      // otherwise, the cursor incorrectly styled (except with role='button')
	      props.href = props.href || '#';
	    }
	
	    if (disabled) {
	      props.tabIndex = -1;
	      props.style = (0, _extends3['default'])({ pointerEvents: 'none' }, props.style);
	    }
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, props, {
	      onClick: this.handleClick
	    }));
	  };
	
	  return SafeAnchor;
	}(_react2['default'].Component);
	
	SafeAnchor.propTypes = propTypes;
	SafeAnchor.defaultProps = defaultProps;
	
	exports['default'] = SafeAnchor;
	module.exports = exports['default'];

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.manualCallWindow = manualCallWindow;
	exports.templatesWhatsappWindow = templatesWhatsappWindow;
	exports.transferCallWindow = transferCallWindow;
	exports.dtmfTonesWindow = dtmfTonesWindow;
	exports.ongoingCallIvrWindow = ongoingCallIvrWindow;
	exports.callRecord = callRecord;
	exports.markCallWindow = markCallWindow;
	exports.noAvailableLocked = noAvailableLocked;
	exports.supervisorChatFloating = supervisorChatFloating;
	exports.noAvailableFloating = noAvailableFloating;
	exports.noAvailableRecordDrag = noAvailableRecordDrag;
	exports.callBackEsclusive = callBackEsclusive;
	exports.rateRecordWindow = rateRecordWindow;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(10);
	
	var _reactDraggable = __webpack_require__(298);
	
	var _reactDraggable2 = _interopRequireDefault(_reactDraggable);
	
	var _NoAvailableFloat = __webpack_require__(1125);
	
	var _NoAvailableFloat2 = _interopRequireDefault(_NoAvailableFloat);
	
	var _ManualCall = __webpack_require__(1123);
	
	var _ManualCall2 = _interopRequireDefault(_ManualCall);
	
	var _CallTransfer = __webpack_require__(1119);
	
	var _CallTransfer2 = _interopRequireDefault(_CallTransfer);
	
	var _DTMFWindow = __webpack_require__(1121);
	
	var _DTMFWindow2 = _interopRequireDefault(_DTMFWindow);
	
	var _OngoingCallIvrWindow = __webpack_require__(1128);
	
	var _OngoingCallIvrWindow2 = _interopRequireDefault(_OngoingCallIvrWindow);
	
	var _CallMark = __webpack_require__(1117);
	
	var _CallMark2 = _interopRequireDefault(_CallMark);
	
	var _noAvailableLocked = __webpack_require__(1134);
	
	var _noAvailableLocked2 = _interopRequireDefault(_noAvailableLocked);
	
	var _SuperVisorChatFloating = __webpack_require__(1130);
	
	var _SuperVisorChatFloating2 = _interopRequireDefault(_SuperVisorChatFloating);
	
	var _CallRecord = __webpack_require__(1118);
	
	var _CallRecord2 = _interopRequireDefault(_CallRecord);
	
	var _NoAvailableRecordFloating = __webpack_require__(1126);
	
	var _NoAvailableRecordFloating2 = _interopRequireDefault(_NoAvailableRecordFloating);
	
	var _ExclusiveCallBack = __webpack_require__(1097);
	
	var _ExclusiveCallBack2 = _interopRequireDefault(_ExclusiveCallBack);
	
	var _TemplatesWhatsapp = __webpack_require__(1131);
	
	var _TemplatesWhatsapp2 = _interopRequireDefault(_TemplatesWhatsapp);
	
	var _RateRecord = __webpack_require__(1129);
	
	var _RateRecord2 = _interopRequireDefault(_RateRecord);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function manualCallWindow() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var isManualMessage = arguments[1];
	
	  return {
	    idComponent: isManualMessage ? _constants.DRAGGABLE_WINDOWS.MANUAL_MESSAGE : _constants.DRAGGABLE_WINDOWS.MANUAL_CALL,
	    componentProps: props,
	    component: function component(propsComponent, z_Index, newTopZIndex) {
	      return _react2.default.createElement(
	        _reactDraggable2.default,
	        { bounds: 'parent', handle: 'drag', key: isManualMessage ? 'manualMessage' : 'manualCall' },
	        _react2.default.createElement(
	          'div',
	          { className: 'manualCallContainer', style: { zIndex: z_Index, position: 'absolute', top: 'calc(50% - 150px)', left: 'calc(50% - 100px)' } },
	          _react2.default.createElement(_ManualCall2.default, { id: isManualMessage ? _constants.DRAGGABLE_WINDOWS.MANUAL_MESSAGE : _constants.DRAGGABLE_WINDOWS.MANUAL_CALL, objProps: { propsData: props, propsAlert: propsComponent, isManualMessage: isManualMessage }, goTopZ: function goTopZ(component) {
	              return newTopZIndex(component);
	            } })
	        )
	      );
	    }
	  };
	}
	
	function templatesWhatsappWindow() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var setTemplateWhatsapp = arguments[1];
	  var templatesList = arguments[2];
	
	  return {
	    idComponent: _constants.DRAGGABLE_WINDOWS.TEMPLATES_WHATSAPP,
	    componentProps: props,
	    component: function component(propsComponent, z_Index, newTopZIndex) {
	      return _react2.default.createElement(
	        _reactDraggable2.default,
	        { bounds: 'parent', handle: 'drag', key: 'templatesWhatsapp' },
	        _react2.default.createElement(
	          'div',
	          { className: 'templatesWhatsappContainer', style: { zIndex: z_Index, position: 'absolute', top: 'calc(50% - 150px)', left: 'calc(50% - 100px)' } },
	          _react2.default.createElement(_TemplatesWhatsapp2.default, { id: _constants.DRAGGABLE_WINDOWS.TEMPLATES_WHATSAPP, objProps: { propsData: props, propsAlert: propsComponent, setTemplateWhatsapp: setTemplateWhatsapp, templatesList: templatesList }, goTopZ: function goTopZ(component) {
	              return newTopZIndex(component);
	            } })
	        )
	      );
	    }
	  };
	}
	
	function transferCallWindow() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return {
	    idComponent: _constants.DRAGGABLE_WINDOWS.TRANSFER_CALL,
	    componentProps: props,
	    component: function component(propsComponent, z_Index, newTopZIndex) {
	      return _react2.default.createElement(
	        _reactDraggable2.default,
	        { bounds: 'parent', handle: 'drag', key: 'tranferCall' },
	        _react2.default.createElement(
	          'div',
	          { className: 'tranferCallContainer', style: { zIndex: z_Index, position: 'absolute', top: 'calc(50% - 174px)', left: 'calc(50% - 100px)' } },
	          _react2.default.createElement(_CallTransfer2.default, { id: _constants.DRAGGABLE_WINDOWS.TRANSFER_CALL, objProps: { propsData: props, propsAlert: propsComponent }, goTopZ: function goTopZ(component) {
	              return newTopZIndex(component);
	            } })
	        )
	      );
	    }
	  };
	}
	
	function dtmfTonesWindow() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var oncloseDtmfTonesWindow = arguments[1];
	
	  return {
	    idComponent: _constants.DRAGGABLE_WINDOWS.DTMF_TONES,
	    componentProps: props,
	    component: function component(propsComponent, z_Index, newTopZIndex) {
	      return _react2.default.createElement(
	        _reactDraggable2.default,
	        { bounds: 'parent', handle: 'drag', key: 'dtmfTones' },
	        _react2.default.createElement(
	          'div',
	          { className: 'dtmfWindowContainer', style: { zIndex: z_Index, position: 'absolute', top: 'calc(50% - 150px)', left: 'calc(50% - 100px)' } },
	          _react2.default.createElement(_DTMFWindow2.default, { id: _constants.DRAGGABLE_WINDOWS.DTMF_TONES, objProps: props, goTopZ: function goTopZ(component) {
	              return newTopZIndex(component);
	            }, oncloseDtmfTonesWindow: oncloseDtmfTonesWindow })
	        )
	      );
	    }
	  };
	}
	
	function ongoingCallIvrWindow() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var onCloseIVR = arguments[1];
	
	  return {
	    idComponent: _constants.DRAGGABLE_WINDOWS.ONGOING_CALL_IVR,
	    componentProps: props,
	    component: function component(propsComponent, z_Index, newTopZIndex) {
	      return _react2.default.createElement(
	        _reactDraggable2.default,
	        { bounds: 'parent', handle: 'drag', key: 'ongoingCallIvr' },
	        _react2.default.createElement(
	          'div',
	          { className: 'dtmfWindowContainer', style: { zIndex: z_Index, position: 'absolute', top: 'calc(50% - 150px)', left: 'calc(50% - 100px)' } },
	          _react2.default.createElement(_OngoingCallIvrWindow2.default, { id: _constants.DRAGGABLE_WINDOWS.ONGOING_CALL_IVR, objProps: props, goTopZ: function goTopZ(component) {
	              return newTopZIndex(component);
	            }, onCloseIVR: onCloseIVR })
	        )
	      );
	    }
	  };
	}
	
	function callRecord() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var xPosition = 150 - props.position.xPosition;
	  var yPosition = 100 - props.position.yPosition;
	  return {
	    idComponent: _constants.DRAGGABLE_WINDOWS.CALL_RECORD,
	    componentProps: props,
	    component: function component(propsComponent, z_Index, newTopZIndex) {
	      return _react2.default.createElement(
	        _reactDraggable2.default,
	        { bounds: 'parent', handle: 'drag', key: 'callRecord', onDrag: props.dragFunc },
	        _react2.default.createElement(
	          'div',
	          { className: 'callRecordContainer', style: { zIndex: z_Index, position: 'absolute', top: 'calc(50% - ' + yPosition + 'px)', left: 'calc(50% - ' + xPosition + 'px)' } },
	          _react2.default.createElement(_CallRecord2.default, { id: _constants.DRAGGABLE_WINDOWS.CALL_RECORD, objProps: props, goTopZ: function goTopZ(component) {
	              return newTopZIndex(component);
	            } })
	        )
	      );
	    }
	  };
	}
	
	function markCallWindow() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var initialDialogTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	  var callout_id = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	  var onCloseMarCallkWindow = arguments[3];
	
	  return {
	    idComponent: _constants.DRAGGABLE_WINDOWS.MARK_CALL,
	    componentProps: props,
	    component: function component(propsComponent, z_Index, newTopZIndex) {
	      return _react2.default.createElement(
	        _reactDraggable2.default,
	        { bounds: 'parent', handle: 'drag', key: 'markCall' },
	        _react2.default.createElement(
	          'div',
	          { className: 'markCallContainer', style: { zIndex: z_Index, position: 'absolute', top: 'calc(50% - 150px)', left: 'calc(50% - 100px)' } },
	          _react2.default.createElement(_CallMark2.default, { id: _constants.DRAGGABLE_WINDOWS.MARK_CALL, objProps: props, goTopZ: function goTopZ(component) {
	              return newTopZIndex(component);
	            }, initialDialogTime: initialDialogTime, callout_id: callout_id, onCloseMarCallkWindow: onCloseMarCallkWindow })
	        )
	      );
	    }
	  };
	}
	
	function noAvailableLocked() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return {
	    idComponent: _constants.DRAGGABLE_WINDOWS.NO_AVAILABLE_LOCKED,
	    componentProps: props,
	    component: function component(propsComponent, z_Index, newTopZIndex) {
	      return _react2.default.createElement(_noAvailableLocked2.default, { key: 'NoAvailableFloating', goTopZ: function goTopZ(component) {
	          return newTopZIndex(component);
	        }, id: _constants.DRAGGABLE_WINDOWS.NO_AVAILABLE_LOCKED, style: z_Index });
	    }
	  };
	}
	
	function supervisorChatFloating() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return {
	    idComponent: _constants.DRAGGABLE_WINDOWS.SUPERVISOR_CHAT,
	    componentProps: props,
	    component: function component(propsComponent, z_Index, newTopZIndex) {
	      return _react2.default.createElement(
	        _reactDraggable2.default,
	        { bounds: 'parent', handle: 'drag', key: 'supervisorChatFloating' },
	        _react2.default.createElement(
	          'div',
	          { className: 'supervisorChatDragContainer ' + (props.regsMultiple ? 'displayBlock' : '') + ' ', style: { zIndex: z_Index, position: 'absolute', top: 'calc(50% - 150px)', left: 'calc(50% - 100px)' } },
	          _react2.default.createElement(_SuperVisorChatFloating2.default, { id: _constants.DRAGGABLE_WINDOWS.SUPERVISOR_CHAT, objProps: props, goTopZ: function goTopZ(component) {
	              return newTopZIndex(component);
	            } })
	        )
	      );
	    }
	  };
	}
	
	function noAvailableFloating() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return {
	    idComponent: _constants.DRAGGABLE_WINDOWS.NO_AVAILABLE,
	    componentProps: props,
	    component: function component(propsComponent, z_Index, newTopZIndex) {
	      return _react2.default.createElement(
	        _reactDraggable2.default,
	        { bounds: 'parent', handle: 'drag', key: 'noAvailableFloating' },
	        _react2.default.createElement(
	          'div',
	          { className: 'noAvailableDragContainer ' + (props.regsMultiple ? 'regsMultiple' : '') + ' ', style: { z_Index: z_Index, position: 'absolute', top: 'calc(50% - 150px)', left: 'calc(50% - 100px)' } },
	          _react2.default.createElement(_NoAvailableFloat2.default, { id: _constants.DRAGGABLE_WINDOWS.NO_AVAILABLE, objProps: props, z_Index: z_Index, goTopZ: function goTopZ(component) {
	              return newTopZIndex(component);
	            } })
	        )
	      );
	    }
	  };
	}
	
	function noAvailableRecordDrag() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return {
	    idComponent: _constants.DRAGGABLE_WINDOWS.NO_AVAILABLE_RECORD,
	    componentProps: props,
	    component: function component(propsComponent, z_Index, newTopZIndex) {
	      return _react2.default.createElement(
	        _reactDraggable2.default,
	        { bounds: 'parent', handle: 'drag', key: 'noAvailableRecordFloating' },
	        _react2.default.createElement(
	          'div',
	          { className: 'noAvailableRecordFloating   ' + (props.regsMultiple ? 'regsMultiple' : ''), style: { zIndex: z_Index, position: 'absolute', top: 'calc(50% - 150px)', left: 'calc(50% - 100px)' } },
	          _react2.default.createElement(_NoAvailableRecordFloating2.default, { id: _constants.DRAGGABLE_WINDOWS.NO_AVAILABLE_RECORD, objProps: props, goTopZ: function goTopZ(component) {
	              return newTopZIndex(component);
	            } })
	        )
	      );
	    }
	  };
	}
	
	function callBackEsclusive() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return {
	    idComponent: _constants.DRAGGABLE_WINDOWS.EXCLUSIVE_CALLBACK,
	    componentProps: props,
	    component: function component(propsComponent, z_Index, newTopZIndex) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'callBackEsclusiveFloating', style: { zIndex: z_Index, position: 'absolute', top: 'calc(50% - 10.205rem)', left: 'calc((50% + 30px) - 8.08rem)' } },
	        _react2.default.createElement(_ExclusiveCallBack2.default, { id: _constants.DRAGGABLE_WINDOWS.EXCLUSIVE_CALLBACK, objProps: props, goTopZ: function goTopZ(component) {
	            return newTopZIndex(component);
	          } })
	      );
	    }
	  };
	}
	
	function rateRecordWindow() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var initialDialogTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	  var callout_id = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	  var onCloseDispositionWindow = arguments[3];
	
	  return {
	    idComponent: _constants.DRAGGABLE_WINDOWS.RATE_RECORD,
	    componentProps: props,
	    component: function component(propsComponent, z_Index, newTopZIndex) {
	      return _react2.default.createElement(
	        _reactDraggable2.default,
	        { axis: 'y', key: 'rateRecordFloating' },
	        _react2.default.createElement(
	          'div',
	          { className: 'rateRecordContainer', id: 'recordWindow', style: { zIndex: z_Index, position: 'absolute', top: 'calc(50% - 150px)', left: 'calc(60% - 100px)' } },
	          _react2.default.createElement(_RateRecord2.default, { id: _constants.DRAGGABLE_WINDOWS.RATE_RECORD, objProps: props, goTopZ: function goTopZ(component) {
	              return newTopZIndex(component);
	            }, initialDialogTime: initialDialogTime, callout_id: callout_id, onCloseDispositionWindow: onCloseDispositionWindow })
	        )
	      );
	    }
	  };
	}

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(103);
	var core = __webpack_require__(76);
	var ctx = __webpack_require__(340);
	var hide = __webpack_require__(159);
	var has = __webpack_require__(132);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ },
/* 103 */
35,
/* 104 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ },
/* 105 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	if (__webpack_require__(56)) {
	  var LIBRARY = __webpack_require__(136);
	  var global = __webpack_require__(35);
	  var fails = __webpack_require__(34);
	  var $export = __webpack_require__(11);
	  var $typed = __webpack_require__(255);
	  var $buffer = __webpack_require__(373);
	  var ctx = __webpack_require__(91);
	  var anInstance = __webpack_require__(161);
	  var propertyDesc = __webpack_require__(141);
	  var hide = __webpack_require__(78);
	  var redefineAll = __webpack_require__(163);
	  var toInteger = __webpack_require__(94);
	  var toLength = __webpack_require__(47);
	  var toIndex = __webpack_require__(558);
	  var toAbsoluteIndex = __webpack_require__(142);
	  var toPrimitive = __webpack_require__(118);
	  var has = __webpack_require__(77);
	  var classof = __webpack_require__(201);
	  var isObject = __webpack_require__(36);
	  var toObject = __webpack_require__(65);
	  var isArrayIter = __webpack_require__(360);
	  var create = __webpack_require__(137);
	  var getPrototypeOf = __webpack_require__(139);
	  var gOPN = __webpack_require__(138).f;
	  var getIterFn = __webpack_require__(375);
	  var uid = __webpack_require__(143);
	  var wks = __webpack_require__(44);
	  var createArrayMethod = __webpack_require__(90);
	  var createArrayIncludes = __webpack_require__(245);
	  var speciesConstructor = __webpack_require__(204);
	  var ArrayIterators = __webpack_require__(376);
	  var Iterators = __webpack_require__(162);
	  var $iterDetect = __webpack_require__(251);
	  var setSpecies = __webpack_require__(164);
	  var arrayFill = __webpack_require__(353);
	  var arrayCopyWithin = __webpack_require__(533);
	  var $DP = __webpack_require__(57);
	  var $GOPD = __webpack_require__(92);
	  var dP = $DP.f;
	  var gOPD = $GOPD.f;
	  var RangeError = global.RangeError;
	  var TypeError = global.TypeError;
	  var Uint8Array = global.Uint8Array;
	  var ARRAY_BUFFER = 'ArrayBuffer';
	  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
	  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
	  var PROTOTYPE = 'prototype';
	  var ArrayProto = Array[PROTOTYPE];
	  var $ArrayBuffer = $buffer.ArrayBuffer;
	  var $DataView = $buffer.DataView;
	  var arrayForEach = createArrayMethod(0);
	  var arrayFilter = createArrayMethod(2);
	  var arraySome = createArrayMethod(3);
	  var arrayEvery = createArrayMethod(4);
	  var arrayFind = createArrayMethod(5);
	  var arrayFindIndex = createArrayMethod(6);
	  var arrayIncludes = createArrayIncludes(true);
	  var arrayIndexOf = createArrayIncludes(false);
	  var arrayValues = ArrayIterators.values;
	  var arrayKeys = ArrayIterators.keys;
	  var arrayEntries = ArrayIterators.entries;
	  var arrayLastIndexOf = ArrayProto.lastIndexOf;
	  var arrayReduce = ArrayProto.reduce;
	  var arrayReduceRight = ArrayProto.reduceRight;
	  var arrayJoin = ArrayProto.join;
	  var arraySort = ArrayProto.sort;
	  var arraySlice = ArrayProto.slice;
	  var arrayToString = ArrayProto.toString;
	  var arrayToLocaleString = ArrayProto.toLocaleString;
	  var ITERATOR = wks('iterator');
	  var TAG = wks('toStringTag');
	  var TYPED_CONSTRUCTOR = uid('typed_constructor');
	  var DEF_CONSTRUCTOR = uid('def_constructor');
	  var ALL_CONSTRUCTORS = $typed.CONSTR;
	  var TYPED_ARRAY = $typed.TYPED;
	  var VIEW = $typed.VIEW;
	  var WRONG_LENGTH = 'Wrong length!';
	
	  var $map = createArrayMethod(1, function (O, length) {
	    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
	  });
	
	  var LITTLE_ENDIAN = fails(function () {
	    // eslint-disable-next-line no-undef
	    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
	  });
	
	  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
	    new Uint8Array(1).set({});
	  });
	
	  var toOffset = function (it, BYTES) {
	    var offset = toInteger(it);
	    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
	    return offset;
	  };
	
	  var validate = function (it) {
	    if (isObject(it) && TYPED_ARRAY in it) return it;
	    throw TypeError(it + ' is not a typed array!');
	  };
	
	  var allocate = function (C, length) {
	    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
	      throw TypeError('It is not a typed array constructor!');
	    } return new C(length);
	  };
	
	  var speciesFromList = function (O, list) {
	    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
	  };
	
	  var fromList = function (C, list) {
	    var index = 0;
	    var length = list.length;
	    var result = allocate(C, length);
	    while (length > index) result[index] = list[index++];
	    return result;
	  };
	
	  var addGetter = function (it, key, internal) {
	    dP(it, key, { get: function () { return this._d[internal]; } });
	  };
	
	  var $from = function from(source /* , mapfn, thisArg */) {
	    var O = toObject(source);
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var iterFn = getIterFn(O);
	    var i, length, values, result, step, iterator;
	    if (iterFn != undefined && !isArrayIter(iterFn)) {
	      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
	        values.push(step.value);
	      } O = values;
	    }
	    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
	    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
	      result[i] = mapping ? mapfn(O[i], i) : O[i];
	    }
	    return result;
	  };
	
	  var $of = function of(/* ...items */) {
	    var index = 0;
	    var length = arguments.length;
	    var result = allocate(this, length);
	    while (length > index) result[index] = arguments[index++];
	    return result;
	  };
	
	  // iOS Safari 6.x fails here
	  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });
	
	  var $toLocaleString = function toLocaleString() {
	    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
	  };
	
	  var proto = {
	    copyWithin: function copyWithin(target, start /* , end */) {
	      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	    },
	    every: function every(callbackfn /* , thisArg */) {
	      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
	      return arrayFill.apply(validate(this), arguments);
	    },
	    filter: function filter(callbackfn /* , thisArg */) {
	      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
	        arguments.length > 1 ? arguments[1] : undefined));
	    },
	    find: function find(predicate /* , thisArg */) {
	      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    findIndex: function findIndex(predicate /* , thisArg */) {
	      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    forEach: function forEach(callbackfn /* , thisArg */) {
	      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    indexOf: function indexOf(searchElement /* , fromIndex */) {
	      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    includes: function includes(searchElement /* , fromIndex */) {
	      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    join: function join(separator) { // eslint-disable-line no-unused-vars
	      return arrayJoin.apply(validate(this), arguments);
	    },
	    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
	      return arrayLastIndexOf.apply(validate(this), arguments);
	    },
	    map: function map(mapfn /* , thisArg */) {
	      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduce.apply(validate(this), arguments);
	    },
	    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduceRight.apply(validate(this), arguments);
	    },
	    reverse: function reverse() {
	      var that = this;
	      var length = validate(that).length;
	      var middle = Math.floor(length / 2);
	      var index = 0;
	      var value;
	      while (index < middle) {
	        value = that[index];
	        that[index++] = that[--length];
	        that[length] = value;
	      } return that;
	    },
	    some: function some(callbackfn /* , thisArg */) {
	      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    sort: function sort(comparefn) {
	      return arraySort.call(validate(this), comparefn);
	    },
	    subarray: function subarray(begin, end) {
	      var O = validate(this);
	      var length = O.length;
	      var $begin = toAbsoluteIndex(begin, length);
	      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
	        O.buffer,
	        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
	        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
	      );
	    }
	  };
	
	  var $slice = function slice(start, end) {
	    return speciesFromList(this, arraySlice.call(validate(this), start, end));
	  };
	
	  var $set = function set(arrayLike /* , offset */) {
	    validate(this);
	    var offset = toOffset(arguments[1], 1);
	    var length = this.length;
	    var src = toObject(arrayLike);
	    var len = toLength(src.length);
	    var index = 0;
	    if (len + offset > length) throw RangeError(WRONG_LENGTH);
	    while (index < len) this[offset + index] = src[index++];
	  };
	
	  var $iterators = {
	    entries: function entries() {
	      return arrayEntries.call(validate(this));
	    },
	    keys: function keys() {
	      return arrayKeys.call(validate(this));
	    },
	    values: function values() {
	      return arrayValues.call(validate(this));
	    }
	  };
	
	  var isTAIndex = function (target, key) {
	    return isObject(target)
	      && target[TYPED_ARRAY]
	      && typeof key != 'symbol'
	      && key in target
	      && String(+key) == String(key);
	  };
	  var $getDesc = function getOwnPropertyDescriptor(target, key) {
	    return isTAIndex(target, key = toPrimitive(key, true))
	      ? propertyDesc(2, target[key])
	      : gOPD(target, key);
	  };
	  var $setDesc = function defineProperty(target, key, desc) {
	    if (isTAIndex(target, key = toPrimitive(key, true))
	      && isObject(desc)
	      && has(desc, 'value')
	      && !has(desc, 'get')
	      && !has(desc, 'set')
	      // TODO: add validation descriptor w/o calling accessors
	      && !desc.configurable
	      && (!has(desc, 'writable') || desc.writable)
	      && (!has(desc, 'enumerable') || desc.enumerable)
	    ) {
	      target[key] = desc.value;
	      return target;
	    } return dP(target, key, desc);
	  };
	
	  if (!ALL_CONSTRUCTORS) {
	    $GOPD.f = $getDesc;
	    $DP.f = $setDesc;
	  }
	
	  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
	    getOwnPropertyDescriptor: $getDesc,
	    defineProperty: $setDesc
	  });
	
	  if (fails(function () { arrayToString.call({}); })) {
	    arrayToString = arrayToLocaleString = function toString() {
	      return arrayJoin.call(this);
	    };
	  }
	
	  var $TypedArrayPrototype$ = redefineAll({}, proto);
	  redefineAll($TypedArrayPrototype$, $iterators);
	  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
	  redefineAll($TypedArrayPrototype$, {
	    slice: $slice,
	    set: $set,
	    constructor: function () { /* noop */ },
	    toString: arrayToString,
	    toLocaleString: $toLocaleString
	  });
	  addGetter($TypedArrayPrototype$, 'buffer', 'b');
	  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
	  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
	  addGetter($TypedArrayPrototype$, 'length', 'e');
	  dP($TypedArrayPrototype$, TAG, {
	    get: function () { return this[TYPED_ARRAY]; }
	  });
	
	  // eslint-disable-next-line max-statements
	  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
	    CLAMPED = !!CLAMPED;
	    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
	    var GETTER = 'get' + KEY;
	    var SETTER = 'set' + KEY;
	    var TypedArray = global[NAME];
	    var Base = TypedArray || {};
	    var TAC = TypedArray && getPrototypeOf(TypedArray);
	    var FORCED = !TypedArray || !$typed.ABV;
	    var O = {};
	    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
	    var getter = function (that, index) {
	      var data = that._d;
	      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
	    };
	    var setter = function (that, index, value) {
	      var data = that._d;
	      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
	      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
	    };
	    var addElement = function (that, index) {
	      dP(that, index, {
	        get: function () {
	          return getter(this, index);
	        },
	        set: function (value) {
	          return setter(this, index, value);
	        },
	        enumerable: true
	      });
	    };
	    if (FORCED) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME, '_d');
	        var index = 0;
	        var offset = 0;
	        var buffer, byteLength, length, klass;
	        if (!isObject(data)) {
	          length = toIndex(data);
	          byteLength = length * BYTES;
	          buffer = new $ArrayBuffer(byteLength);
	        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          buffer = data;
	          offset = toOffset($offset, BYTES);
	          var $len = data.byteLength;
	          if ($length === undefined) {
	            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
	            byteLength = $len - offset;
	            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
	          } else {
	            byteLength = toLength($length) * BYTES;
	            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
	          }
	          length = byteLength / BYTES;
	        } else if (TYPED_ARRAY in data) {
	          return fromList(TypedArray, data);
	        } else {
	          return $from.call(TypedArray, data);
	        }
	        hide(that, '_d', {
	          b: buffer,
	          o: offset,
	          l: byteLength,
	          e: length,
	          v: new $DataView(buffer)
	        });
	        while (index < length) addElement(that, index++);
	      });
	      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
	      hide(TypedArrayPrototype, 'constructor', TypedArray);
	    } else if (!fails(function () {
	      TypedArray(1);
	    }) || !fails(function () {
	      new TypedArray(-1); // eslint-disable-line no-new
	    }) || !$iterDetect(function (iter) {
	      new TypedArray(); // eslint-disable-line no-new
	      new TypedArray(null); // eslint-disable-line no-new
	      new TypedArray(1.5); // eslint-disable-line no-new
	      new TypedArray(iter); // eslint-disable-line no-new
	    }, true)) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME);
	        var klass;
	        // `ws` module bug, temporarily remove validation length for Uint8Array
	        // https://github.com/websockets/ws/pull/645
	        if (!isObject(data)) return new Base(toIndex(data));
	        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          return $length !== undefined
	            ? new Base(data, toOffset($offset, BYTES), $length)
	            : $offset !== undefined
	              ? new Base(data, toOffset($offset, BYTES))
	              : new Base(data);
	        }
	        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
	        return $from.call(TypedArray, data);
	      });
	      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
	        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
	      });
	      TypedArray[PROTOTYPE] = TypedArrayPrototype;
	      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
	    }
	    var $nativeIterator = TypedArrayPrototype[ITERATOR];
	    var CORRECT_ITER_NAME = !!$nativeIterator
	      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
	    var $iterator = $iterators.values;
	    hide(TypedArray, TYPED_CONSTRUCTOR, true);
	    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
	    hide(TypedArrayPrototype, VIEW, true);
	    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
	
	    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
	      dP(TypedArrayPrototype, TAG, {
	        get: function () { return NAME; }
	      });
	    }
	
	    O[NAME] = TypedArray;
	
	    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
	
	    $export($export.S, NAME, {
	      BYTES_PER_ELEMENT: BYTES
	    });
	
	    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
	      from: $from,
	      of: $of
	    });
	
	    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
	
	    $export($export.P, NAME, proto);
	
	    setSpecies(NAME);
	
	    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });
	
	    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
	
	    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;
	
	    $export($export.P + $export.F * fails(function () {
	      new TypedArray(1).slice();
	    }), NAME, { slice: $slice });
	
	    $export($export.P + $export.F * (fails(function () {
	      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
	    }) || !fails(function () {
	      TypedArrayPrototype.toLocaleString.call([1, 2]);
	    })), NAME, { toLocaleString: $toLocaleString });
	
	    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
	    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
	  };
	} else module.exports = function () { /* empty */ };


/***/ },
/* 107 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getTimezoneOffsetInMilliseconds;
	
	/**
	 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
	 * They usually appear for dates that denote time before the timezones were introduced
	 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
	 * and GMT+01:00:00 after that date)
	 *
	 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
	 * which would lead to incorrect calculations.
	 *
	 * This function returns the timezone offset in milliseconds that takes seconds in account.
	 */
	function getTimezoneOffsetInMilliseconds(date) {
	  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
	  utcDate.setUTCFullYear(date.getFullYear());
	  return date.getTime() - utcDate.getTime();
	}
	
	module.exports = exports.default;

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1625));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1626));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1627));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1628));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1629));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary English locale (United States).
	 * @language English
	 * @iso-639-2 eng
	 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
	 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
	 */
	var locale = {
	  code: 'en-US',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 0
	    /* Sunday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(26));
	
	var _index3 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfWeek
	 * @category Week Helpers
	 * @summary Return the start of a week for the given date.
	 *
	 * @description
	 * Return the start of a week for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Date} the start of a week
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // The start of a week for 2 September 2014 11:55:00:
	 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Sun Aug 31 2014 00:00:00
	 *
	 * @example
	 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
	 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
	 * //=> Mon Sep 01 2014 00:00:00
	 */
	function startOfWeek(dirtyDate, dirtyOptions) {
	  (0, _index3.default)(1, arguments);
	  var options = dirtyOptions || {};
	  var locale = options.locale;
	  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
	  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, _index2.default)(localeWeekStartsOn);
	  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, _index2.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getDay();
	  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
	  date.setDate(date.getDate() - diff);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.useUpdateEffect = exports.useScaledRightLimit = exports.useScaledBottomLimit = exports.usePrevious = exports.useOutsideClick = exports.useLatest = exports.useInfiniteScrollWithRefCallback = exports.useInfiniteScroll = void 0;
	
	var _react = __webpack_require__(1);
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var useOutsideClick = function useOutsideClick(ref, handler) {
	  (0, _react.useEffect)(function () {
	    var listener = function listener(event) {
	      if (ref.current && !ref.current.contains(event.target)) {
	        handler(event);
	      }
	    };
	
	    document.addEventListener('mousedown', listener);
	    document.addEventListener('touchstart', listener);
	    return function () {
	      document.removeEventListener('mousedown', listener);
	      document.removeEventListener('touchstart', listener);
	    };
	  }, [ref, handler]);
	};
	
	exports.useOutsideClick = useOutsideClick;
	
	var useInfiniteScroll = function useInfiniteScroll(element, callback, disabled) {
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      isFetching = _useState2[0],
	      setIsFetching = _useState2[1];
	
	  (0, _react.useEffect)(function () {
	    function isScrolling(e) {
	      if (e.currentTarget.scrollTop === 0 || e.currentTarget.scrollHeight - e.currentTarget.scrollTop !== e.currentTarget.clientHeight || isFetching) return;
	      setIsFetching(true);
	    }
	
	    if (element && !disabled) {
	      element.addEventListener('scroll', isScrolling);
	      return function () {
	        return element.removeEventListener('scroll', isScrolling);
	      };
	    }
	  }, [element, isFetching, disabled]);
	  (0, _react.useEffect)(function () {
	    if (!isFetching || disabled) return;
	    callback();
	  }, [isFetching]);
	  return [isFetching, setIsFetching];
	};
	
	exports.useInfiniteScroll = useInfiniteScroll;
	
	var useInfiniteScrollWithRefCallback = function useInfiniteScrollWithRefCallback(callback, disabled) {
	  var distanceInPixels = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      isFetching = _useState4[0],
	      setIsFetching = _useState4[1];
	
	  var scrolledToBottom = function scrolledToBottom() {
	    if (!disabled && !isFetching) setIsFetching(true);
	  };
	
	  var scrolledRef = (0, _react.useRef)(scrolledToBottom);
	  (0, _react.useEffect)(function () {
	    scrolledRef.current = scrolledToBottom;
	  });
	  var ref = (0, _react.useRef)(null);
	  var setRef = (0, _react.useCallback)(function (node) {
	    function isScrolling(e) {
	      if (e.currentTarget.scrollTop === 0 || Math.round(e.currentTarget.scrollHeight - e.currentTarget.scrollTop) > e.currentTarget.clientHeight + distanceInPixels) return;
	      scrolledRef.current();
	    }
	
	    if (ref.current) {
	      ref.current.removeEventListener('scroll', isScrolling);
	    }
	
	    if (node) {
	      node.addEventListener('scroll', isScrolling);
	    }
	
	    ref.current = node;
	  }, []);
	  (0, _react.useEffect)(function () {
	    if (!isFetching || disabled) return;
	    callback();
	  }, [isFetching, disabled]);
	  return [setRef, isFetching, setIsFetching];
	};
	
	exports.useInfiniteScrollWithRefCallback = useInfiniteScrollWithRefCallback;
	
	var useScaledRightLimit = function useScaledRightLimit() {
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      limit = _useState6[0],
	      setLimit = _useState6[1];
	
	  var elementRef = (0, _react.useCallback)(function (node) {
	    if (node !== null) {
	      var rect = node.getBoundingClientRect();
	
	      if (rect.left + rect.width / 0.8 > window.innerWidth) {
	        console.log('trespass');
	        setLimit(true);
	      }
	    }
	  }, []);
	  return [elementRef, limit];
	};
	
	exports.useScaledRightLimit = useScaledRightLimit;
	
	var useScaledBottomLimit = function useScaledBottomLimit() {
	  var _useState7 = (0, _react.useState)(false),
	      _useState8 = _slicedToArray(_useState7, 2),
	      limit = _useState8[0],
	      setLimit = _useState8[1];
	
	  var elementRef = (0, _react.useCallback)(function (node) {
	    if (node !== null) {
	      // const rect = node.getBoundingClientRect();
	      var parent = getScrollParent(node);
	      var top = node.offsetTop + node.parentNode.offsetTop - parent.offsetTop;
	      console.log('meassurements: ', node.offsetTop, node.parentNode.offsetTop, parent.offsetTop, '=>', top, node.scrollHeight, '=>', top + node.scrollHeight, '?', parent.clientHeight);
	
	      if (top + node.scrollHeight > parent.clientHeight) {
	        console.log('trespass');
	        setLimit(true);
	      }
	    }
	  }, []);
	  return [elementRef, limit];
	};
	
	exports.useScaledBottomLimit = useScaledBottomLimit;
	
	var getScrollParent = function getScrollParent(node) {
	  var regex = /(auto|scroll)/;
	
	  var parents = function parents(_node, ps) {
	    if (_node.parentNode === null) {
	      return ps;
	    }
	
	    return parents(_node.parentNode, ps.concat([_node]));
	  };
	
	  var style = function style(_node, prop) {
	    return getComputedStyle(_node, null).getPropertyValue(prop);
	  };
	
	  var overflow = function overflow(_node) {
	    return style(_node, 'overflow') + style(_node, 'overflow-y') + style(_node, 'overflow-x');
	  };
	
	  var scroll = function scroll(_node) {
	    return regex.test(overflow(_node));
	  };
	  /* eslint-disable consistent-return */
	
	
	  var scrollParent = function scrollParent(_node) {
	    if (!(_node instanceof HTMLElement || _node instanceof SVGElement)) {
	      return;
	    }
	
	    var ps = parents(_node.parentNode, []);
	
	    for (var i = 0; i < ps.length; i += 1) {
	      if (scroll(ps[i])) {
	        return ps[i];
	      }
	    }
	
	    return document.scrollingElement || document.documentElement;
	  };
	
	  return scrollParent(node);
	  /* eslint-enable consistent-return */
	};
	
	var useLatest = function useLatest(value) {
	  var valueRef = (0, _react.useRef)(value);
	  (0, _react.useEffect)(function () {
	    valueRef.current = value;
	  });
	  return valueRef;
	};
	
	exports.useLatest = useLatest;
	
	var usePrevious = function usePrevious(value) {
	  var valueRef = (0, _react.useRef)();
	  (0, _react.useEffect)(function () {
	    valueRef.current = value;
	  }, [value]);
	  return valueRef.current;
	};
	
	exports.usePrevious = usePrevious;
	
	var useUpdateEffect = function useUpdateEffect(fn, inputs) {
	  var didMountRef = (0, _react.useRef)(false);
	  (0, _react.useEffect)(function () {
	    if (didMountRef.current) return fn();else didMountRef.current = true;
	  }, inputs);
	};
	
	exports.useUpdateEffect = useUpdateEffect;

/***/ },
/* 111 */
[2771, 2351, 2392, 2350, 2380, 2381, 2382, 2383, 2377, 2378, 2379, 2332, 2333, 470, 2335, 964, 2334, 2336, 305, 2353, 2354, 2355, 228, 229, 2331, 2337, 2342, 2340, 2339, 2338, 2346, 2341, 2343, 2344, 2345, 965, 2402, 967, 471, 968, 966, 2347, 2348, 2349, 970, 2352, 973, 2389, 972, 2405, 2388, 2387, 2391, 2373, 2376, 2374, 2375, 975, 2396, 2367, 2356, 2357, 2358, 2359, 2360, 2361, 2362, 2363, 971, 2365, 2372, 2384, 2385, 2386, 2394, 2395, 2364, 963, 2397, 2398, 2399, 969, 2368, 2369, 2370, 2366, 2371, 2400, 2401, 2403, 2404, 2406, 2393, 14, 2407],
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _every2 = _interopRequireDefault(__webpack_require__(752));
	
	var _find2 = _interopRequireDefault(__webpack_require__(2164));
	
	var _sortBy2 = _interopRequireDefault(__webpack_require__(455));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(38));
	
	var _range2 = _interopRequireDefault(__webpack_require__(759));
	
	var _throttle2 = _interopRequireDefault(__webpack_require__(761));
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(71));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _Surface = _interopRequireDefault(__webpack_require__(231));
	
	var _Layer = _interopRequireDefault(__webpack_require__(49));
	
	var _Tooltip = _interopRequireDefault(__webpack_require__(307));
	
	var _Legend = _interopRequireDefault(__webpack_require__(477));
	
	var _Curve = _interopRequireDefault(__webpack_require__(189));
	
	var _Cross = _interopRequireDefault(__webpack_require__(992));
	
	var _Sector = _interopRequireDefault(__webpack_require__(311));
	
	var _Dot = _interopRequireDefault(__webpack_require__(153));
	
	var _Rectangle = _interopRequireDefault(__webpack_require__(190));
	
	var _ReactUtils = __webpack_require__(29);
	
	var _CartesianAxis = _interopRequireDefault(__webpack_require__(983));
	
	var _Brush = _interopRequireDefault(__webpack_require__(982));
	
	var _DOMUtils = __webpack_require__(312);
	
	var _DataUtils = __webpack_require__(39);
	
	var _ChartUtils = __webpack_require__(66);
	
	var _DetectReferenceElementsDomain = __webpack_require__(2434);
	
	var _PolarUtils = __webpack_require__(86);
	
	var _ShallowEqual = __webpack_require__(314);
	
	var _Events = __webpack_require__(2435);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var ORIENT_MAP = {
	  xAxis: ['bottom', 'top'],
	  yAxis: ['left', 'right']
	};
	var originCoordinate = {
	  x: 0,
	  y: 0
	};
	
	var generateCategoricalChart = function generateCategoricalChart(_ref) {
	  var chartName = _ref.chartName,
	      GraphicalChild = _ref.GraphicalChild,
	      _ref$eventType = _ref.eventType,
	      eventType = _ref$eventType === void 0 ? 'axis' : _ref$eventType,
	      axisComponents = _ref.axisComponents,
	      legendContent = _ref.legendContent,
	      formatAxisMap = _ref.formatAxisMap,
	      defaultProps = _ref.defaultProps,
	      propTypes = _ref.propTypes;
	
	  var CategoricalChartWrapper =
	  /*#__PURE__*/
	  function (_Component) {
	    _inherits(CategoricalChartWrapper, _Component);
	
	    /**
	     * Returns default, reset state for the categorical chart.
	     * @param {Object} props Props object to use when creating the default state
	     * @return {Object} Whole new state
	     */
	    function CategoricalChartWrapper(_props) {
	      var _this;
	
	      _classCallCheck(this, CategoricalChartWrapper);
	
	      _this = _possibleConstructorReturn(this, _getPrototypeOf(CategoricalChartWrapper).call(this, _props));
	
	      _this.handleLegendBBoxUpdate = function (box) {
	        if (box && _this.legendInstance) {
	          var _this$state = _this.state,
	              dataStartIndex = _this$state.dataStartIndex,
	              dataEndIndex = _this$state.dataEndIndex,
	              updateId = _this$state.updateId;
	
	          _this.setState(_this.updateStateOfAxisMapsOffsetAndStackGroups({
	            props: _this.props,
	            dataStartIndex: dataStartIndex,
	            dataEndIndex: dataEndIndex,
	            updateId: updateId
	          }));
	        }
	      };
	
	      _this.handleReceiveSyncEvent = function (cId, chartId, data) {
	        var _this$props = _this.props,
	            syncId = _this$props.syncId,
	            layout = _this$props.layout;
	        var updateId = _this.state.updateId;
	
	        if (syncId === cId && chartId !== _this.uniqueChartId) {
	          var dataStartIndex = data.dataStartIndex,
	              dataEndIndex = data.dataEndIndex;
	
	          if (!(0, _isNil2["default"])(data.dataStartIndex) || !(0, _isNil2["default"])(data.dataEndIndex)) {
	            _this.setState(_objectSpread({
	              dataStartIndex: dataStartIndex,
	              dataEndIndex: dataEndIndex
	            }, _this.updateStateOfAxisMapsOffsetAndStackGroups({
	              props: _this.props,
	              dataStartIndex: dataStartIndex,
	              dataEndIndex: dataEndIndex,
	              updateId: updateId
	            })));
	          } else if (!(0, _isNil2["default"])(data.activeTooltipIndex)) {
	            var chartX = data.chartX,
	                chartY = data.chartY,
	                activeTooltipIndex = data.activeTooltipIndex;
	            var _this$state2 = _this.state,
	                offset = _this$state2.offset,
	                tooltipTicks = _this$state2.tooltipTicks;
	
	            if (!offset) {
	              return;
	            }
	
	            var viewBox = _objectSpread({}, offset, {
	              x: offset.left,
	              y: offset.top
	            }); // When a categotical chart is combined with another chart, the value of chartX
	            // and chartY may beyond the boundaries.
	
	
	            var validateChartX = Math.min(chartX, viewBox.x + viewBox.width);
	            var validateChartY = Math.min(chartY, viewBox.y + viewBox.height);
	            var activeLabel = tooltipTicks[activeTooltipIndex] && tooltipTicks[activeTooltipIndex].value;
	
	            var activePayload = _this.getTooltipContent(activeTooltipIndex);
	
	            var activeCoordinate = tooltipTicks[activeTooltipIndex] ? {
	              x: layout === 'horizontal' ? tooltipTicks[activeTooltipIndex].coordinate : validateChartX,
	              y: layout === 'horizontal' ? validateChartY : tooltipTicks[activeTooltipIndex].coordinate
	            } : originCoordinate;
	
	            _this.setState(_objectSpread({}, data, {
	              activeLabel: activeLabel,
	              activeCoordinate: activeCoordinate,
	              activePayload: activePayload
	            }));
	          } else {
	            _this.setState(data);
	          }
	        }
	      };
	
	      _this.handleBrushChange = function (_ref2) {
	        var startIndex = _ref2.startIndex,
	            endIndex = _ref2.endIndex;
	
	        // Only trigger changes if the extents of the brush have actually changed
	        if (startIndex !== _this.state.dataStartIndex || endIndex !== _this.state.dataEndIndex) {
	          var updateId = _this.state.updateId;
	
	          _this.setState(function () {
	            return _objectSpread({
	              dataStartIndex: startIndex,
	              dataEndIndex: endIndex
	            }, _this.updateStateOfAxisMapsOffsetAndStackGroups({
	              props: _this.props,
	              dataStartIndex: startIndex,
	              dataEndIndex: endIndex,
	              updateId: updateId
	            }));
	          });
	
	          _this.triggerSyncEvent({
	            dataStartIndex: startIndex,
	            dataEndIndex: endIndex
	          });
	        }
	      };
	
	      _this.handleMouseEnter = function (e) {
	        var onMouseEnter = _this.props.onMouseEnter;
	
	        var mouse = _this.getMouseInfo(e);
	
	        if (mouse) {
	          var nextState = _objectSpread({}, mouse, {
	            isTooltipActive: true
	          });
	
	          _this.setState(nextState);
	
	          _this.triggerSyncEvent(nextState);
	
	          if ((0, _isFunction2["default"])(onMouseEnter)) {
	            onMouseEnter(nextState, e);
	          }
	        }
	      };
	
	      _this.triggeredAfterMouseMove = function (e) {
	        var onMouseMove = _this.props.onMouseMove;
	
	        var mouse = _this.getMouseInfo(e);
	
	        var nextState = mouse ? _objectSpread({}, mouse, {
	          isTooltipActive: true
	        }) : {
	          isTooltipActive: false
	        };
	
	        _this.setState(nextState);
	
	        _this.triggerSyncEvent(nextState);
	
	        if ((0, _isFunction2["default"])(onMouseMove)) {
	          onMouseMove(nextState, e);
	        }
	      };
	
	      _this.handleItemMouseEnter = function (el) {
	        _this.setState(function () {
	          return {
	            isTooltipActive: true,
	            activeItem: el,
	            activePayload: el.tooltipPayload,
	            activeCoordinate: el.tooltipPosition || {
	              x: el.cx,
	              y: el.cy
	            }
	          };
	        });
	      };
	
	      _this.handleItemMouseLeave = function () {
	        _this.setState(function () {
	          return {
	            isTooltipActive: false
	          };
	        });
	      };
	
	      _this.handleMouseMove = function (e) {
	        if (e && (0, _isFunction2["default"])(e.persist)) {
	          e.persist();
	        }
	
	        _this.triggeredAfterMouseMove(e);
	      };
	
	      _this.handleMouseLeave = function (e) {
	        var onMouseLeave = _this.props.onMouseLeave;
	        var nextState = {
	          isTooltipActive: false
	        };
	
	        _this.setState(nextState);
	
	        _this.triggerSyncEvent(nextState);
	
	        if ((0, _isFunction2["default"])(onMouseLeave)) {
	          onMouseLeave(nextState, e);
	        }
	      };
	
	      _this.handleOuterEvent = function (e) {
	        var eventName = (0, _ReactUtils.getReactEventByType)(e);
	
	        if (eventName && (0, _isFunction2["default"])(_this.props[eventName])) {
	          var mouse = _this.getMouseInfo(e);
	
	          var handler = _this.props[eventName];
	          handler(mouse, e);
	        }
	      };
	
	      _this.handleClick = function (e) {
	        var onClick = _this.props.onClick;
	
	        if ((0, _isFunction2["default"])(onClick)) {
	          var mouse = _this.getMouseInfo(e);
	
	          onClick(mouse, e);
	        }
	      };
	
	      _this.handleMouseDown = function (e) {
	        var onMouseDown = _this.props.onMouseDown;
	
	        if ((0, _isFunction2["default"])(onMouseDown)) {
	          var mouse = _this.getMouseInfo(e);
	
	          onMouseDown(mouse, e);
	        }
	      };
	
	      _this.handleMouseUp = function (e) {
	        var onMouseUp = _this.props.onMouseUp;
	
	        if ((0, _isFunction2["default"])(onMouseUp)) {
	          var mouse = _this.getMouseInfo(e);
	
	          onMouseUp(mouse, e);
	        }
	      };
	
	      _this.handleTouchMove = function (e) {
	        if (e.changedTouches != null && e.changedTouches.length > 0) {
	          _this.handleMouseMove(e.changedTouches[0]);
	        }
	      };
	
	      _this.handleTouchStart = function (e) {
	        if (e.changedTouches != null && e.changedTouches.length > 0) {
	          _this.handleMouseDown(e.changedTouches[0]);
	        }
	      };
	
	      _this.handleTouchEnd = function (e) {
	        if (e.changedTouches != null && e.changedTouches.length > 0) {
	          _this.handleMouseUp(e.changedTouches[0]);
	        }
	      };
	
	      _this.verticalCoordinatesGenerator = function (_ref3) {
	        var xAxis = _ref3.xAxis,
	            width = _ref3.width,
	            height = _ref3.height,
	            offset = _ref3.offset;
	        return (0, _ChartUtils.getCoordinatesOfGrid)(_CartesianAxis["default"].getTicks(_objectSpread({}, _CartesianAxis["default"].defaultProps, {}, xAxis, {
	          ticks: (0, _ChartUtils.getTicksOfAxis)(xAxis, true),
	          viewBox: {
	            x: 0,
	            y: 0,
	            width: width,
	            height: height
	          }
	        })), offset.left, offset.left + offset.width);
	      };
	
	      _this.horizontalCoordinatesGenerator = function (_ref4) {
	        var yAxis = _ref4.yAxis,
	            width = _ref4.width,
	            height = _ref4.height,
	            offset = _ref4.offset;
	        return (0, _ChartUtils.getCoordinatesOfGrid)(_CartesianAxis["default"].getTicks(_objectSpread({}, _CartesianAxis["default"].defaultProps, {}, yAxis, {
	          ticks: (0, _ChartUtils.getTicksOfAxis)(yAxis, true),
	          viewBox: {
	            x: 0,
	            y: 0,
	            width: width,
	            height: height
	          }
	        })), offset.top, offset.top + offset.height);
	      };
	
	      _this.axesTicksGenerator = function (axis) {
	        return (0, _ChartUtils.getTicksOfAxis)(axis, true);
	      };
	
	      _this.tooltipTicksGenerator = function (axisMap) {
	        var axis = (0, _DataUtils.getAnyElementOfObject)(axisMap);
	        var tooltipTicks = (0, _ChartUtils.getTicksOfAxis)(axis, false, true);
	        return {
	          tooltipTicks: tooltipTicks,
	          orderedTooltipTicks: (0, _sortBy2["default"])(tooltipTicks, function (o) {
	            return o.coordinate;
	          }),
	          tooltipAxis: axis,
	          tooltipAxisBandSize: (0, _ChartUtils.getBandSizeOfAxis)(axis)
	        };
	      };
	
	      _this.renderCursor = function (element) {
	        var _this$state3 = _this.state,
	            isTooltipActive = _this$state3.isTooltipActive,
	            activeCoordinate = _this$state3.activeCoordinate,
	            activePayload = _this$state3.activePayload,
	            offset = _this$state3.offset;
	
	        if (!element || !element.props.cursor || !isTooltipActive || !activeCoordinate) {
	          return null;
	        }
	
	        var layout = _this.props.layout;
	        var restProps;
	        var cursorComp = _Curve["default"];
	
	        if (chartName === 'ScatterChart') {
	          restProps = activeCoordinate;
	          cursorComp = _Cross["default"];
	        } else if (chartName === 'BarChart') {
	          restProps = _this.getCursorRectangle();
	          cursorComp = _Rectangle["default"];
	        } else if (layout === 'radial') {
	          var _this$getCursorPoints = _this.getCursorPoints(),
	              cx = _this$getCursorPoints.cx,
	              cy = _this$getCursorPoints.cy,
	              radius = _this$getCursorPoints.radius,
	              startAngle = _this$getCursorPoints.startAngle,
	              endAngle = _this$getCursorPoints.endAngle;
	
	          restProps = {
	            cx: cx,
	            cy: cy,
	            startAngle: startAngle,
	            endAngle: endAngle,
	            innerRadius: radius,
	            outerRadius: radius
	          };
	          cursorComp = _Sector["default"];
	        } else {
	          restProps = {
	            points: _this.getCursorPoints()
	          };
	          cursorComp = _Curve["default"];
	        }
	
	        var key = element.key || '_recharts-cursor';
	
	        var cursorProps = _objectSpread({
	          stroke: '#ccc',
	          pointerEvents: 'none'
	        }, offset, {}, restProps, {}, (0, _ReactUtils.getPresentationAttributes)(element.props.cursor), {
	          payload: activePayload,
	          key: key,
	          className: 'recharts-tooltip-cursor'
	        });
	
	        return (0, _react.isValidElement)(element.props.cursor) ? (0, _react.cloneElement)(element.props.cursor, cursorProps) : (0, _react.createElement)(cursorComp, cursorProps);
	      };
	
	      _this.renderPolarAxis = function (element, displayName, index) {
	        var axisType = element.type.axisType;
	
	        var axisMap = _this.state["".concat(axisType, "Map")];
	
	        var axisOption = axisMap[element.props["".concat(axisType, "Id")]];
	        return (0, _react.cloneElement)(element, _objectSpread({}, axisOption, {
	          className: axisType,
	          key: element.key || "".concat(displayName, "-").concat(index),
	          ticks: (0, _ChartUtils.getTicksOfAxis)(axisOption, true)
	        }));
	      };
	
	      _this.renderXAxis = function (element, displayName, index) {
	        var xAxisMap = _this.state.xAxisMap;
	        var axisObj = xAxisMap[element.props.xAxisId];
	        return _this.renderAxis(axisObj, element, displayName, index);
	      };
	
	      _this.renderYAxis = function (element, displayName, index) {
	        var yAxisMap = _this.state.yAxisMap;
	        var axisObj = yAxisMap[element.props.yAxisId];
	        return _this.renderAxis(axisObj, element, displayName, index);
	      };
	
	      _this.renderGrid = function (element) {
	        var _this$state4 = _this.state,
	            xAxisMap = _this$state4.xAxisMap,
	            yAxisMap = _this$state4.yAxisMap,
	            offset = _this$state4.offset;
	        var _this$props2 = _this.props,
	            width = _this$props2.width,
	            height = _this$props2.height;
	        var xAxis = (0, _DataUtils.getAnyElementOfObject)(xAxisMap);
	        var yAxisWithFiniteDomain = (0, _find2["default"])(yAxisMap, function (axis) {
	          return (0, _every2["default"])(axis.domain, Number.isFinite);
	        });
	        var yAxis = yAxisWithFiniteDomain || (0, _DataUtils.getAnyElementOfObject)(yAxisMap);
	        var props = element.props || {};
	        return (0, _react.cloneElement)(element, {
	          key: element.key || 'grid',
	          x: (0, _DataUtils.isNumber)(props.x) ? props.x : offset.left,
	          y: (0, _DataUtils.isNumber)(props.y) ? props.y : offset.top,
	          width: (0, _DataUtils.isNumber)(props.width) ? props.width : offset.width,
	          height: (0, _DataUtils.isNumber)(props.height) ? props.height : offset.height,
	          xAxis: xAxis,
	          yAxis: yAxis,
	          offset: offset,
	          chartWidth: width,
	          chartHeight: height,
	          verticalCoordinatesGenerator: props.verticalCoordinatesGenerator || _this.verticalCoordinatesGenerator,
	          horizontalCoordinatesGenerator: props.horizontalCoordinatesGenerator || _this.horizontalCoordinatesGenerator
	        });
	      };
	
	      _this.renderPolarGrid = function (element) {
	        var _this$state5 = _this.state,
	            radiusAxisMap = _this$state5.radiusAxisMap,
	            angleAxisMap = _this$state5.angleAxisMap;
	        var radiusAxis = (0, _DataUtils.getAnyElementOfObject)(radiusAxisMap);
	        var angleAxis = (0, _DataUtils.getAnyElementOfObject)(angleAxisMap);
	        var cx = angleAxis.cx,
	            cy = angleAxis.cy,
	            innerRadius = angleAxis.innerRadius,
	            outerRadius = angleAxis.outerRadius;
	        return (0, _react.cloneElement)(element, {
	          polarAngles: (0, _ChartUtils.getTicksOfAxis)(angleAxis, true).map(function (entry) {
	            return entry.coordinate;
	          }),
	          polarRadius: (0, _ChartUtils.getTicksOfAxis)(radiusAxis, true).map(function (entry) {
	            return entry.coordinate;
	          }),
	          cx: cx,
	          cy: cy,
	          innerRadius: innerRadius,
	          outerRadius: outerRadius,
	          key: element.key || 'polar-grid'
	        });
	      };
	
	      _this.renderBrush = function (element) {
	        var _this$props3 = _this.props,
	            margin = _this$props3.margin,
	            data = _this$props3.data;
	        var _this$state6 = _this.state,
	            offset = _this$state6.offset,
	            dataStartIndex = _this$state6.dataStartIndex,
	            dataEndIndex = _this$state6.dataEndIndex,
	            updateId = _this$state6.updateId; // TODO: update brush when children update
	
	        return (0, _react.cloneElement)(element, {
	          key: element.key || '_recharts-brush',
	          onChange: (0, _ChartUtils.combineEventHandlers)(_this.handleBrushChange, null, element.props.onChange),
	          data: data,
	          x: (0, _DataUtils.isNumber)(element.props.x) ? element.props.x : offset.left,
	          y: (0, _DataUtils.isNumber)(element.props.y) ? element.props.y : offset.top + offset.height + offset.brushBottom - (margin.bottom || 0),
	          width: (0, _DataUtils.isNumber)(element.props.width) ? element.props.width : offset.width,
	          startIndex: dataStartIndex,
	          endIndex: dataEndIndex,
	          updateId: "brush-".concat(updateId)
	        });
	      };
	
	      _this.renderReferenceElement = function (element, displayName, index) {
	        if (!element) {
	          return null;
	        }
	
	        var _assertThisInitialize = _assertThisInitialized(_this),
	            clipPathId = _assertThisInitialize.clipPathId;
	
	        var _this$state7 = _this.state,
	            xAxisMap = _this$state7.xAxisMap,
	            yAxisMap = _this$state7.yAxisMap,
	            offset = _this$state7.offset;
	        var _element$props = element.props,
	            xAxisId = _element$props.xAxisId,
	            yAxisId = _element$props.yAxisId;
	        return (0, _react.cloneElement)(element, {
	          key: element.key || "".concat(displayName, "-").concat(index),
	          xAxis: xAxisMap[xAxisId],
	          yAxis: yAxisMap[yAxisId],
	          viewBox: {
	            x: offset.left,
	            y: offset.top,
	            width: offset.width,
	            height: offset.height
	          },
	          clipPathId: clipPathId
	        });
	      };
	
	      _this.renderGraphicChild = function (element, displayName, index) {
	        var item = _this.filterFormatItem(element, displayName, index);
	
	        if (!item) {
	          return null;
	        }
	
	        var graphicalItem = (0, _react.cloneElement)(element, item.props);
	        var _this$state8 = _this.state,
	            isTooltipActive = _this$state8.isTooltipActive,
	            tooltipAxis = _this$state8.tooltipAxis,
	            activeTooltipIndex = _this$state8.activeTooltipIndex,
	            activeLabel = _this$state8.activeLabel;
	        var children = _this.props.children;
	        var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip["default"]);
	        var _item$props = item.props,
	            points = _item$props.points,
	            isRange = _item$props.isRange,
	            baseLine = _item$props.baseLine;
	        var _item$item$props = item.item.props,
	            activeDot = _item$item$props.activeDot,
	            hide = _item$item$props.hide;
	        var hasActive = !hide && isTooltipActive && tooltipItem && activeDot && activeTooltipIndex >= 0;
	
	        function findWithPayload(entry) {
	          return tooltipAxis.dataKey(entry.payload);
	        }
	
	        if (hasActive) {
	          var activePoint, basePoint;
	
	          if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
	            var specifiedKey = typeof tooltipAxis.dataKey === 'function' ? findWithPayload : 'payload.'.concat(tooltipAxis.dataKey);
	            activePoint = (0, _DataUtils.findEntryInArray)(points, specifiedKey, activeLabel);
	            basePoint = isRange && baseLine && (0, _DataUtils.findEntryInArray)(baseLine, specifiedKey, activeLabel);
	          } else {
	            activePoint = points[activeTooltipIndex];
	            basePoint = isRange && baseLine && baseLine[activeTooltipIndex];
	          }
	
	          if (!(0, _isNil2["default"])(activePoint)) {
	            return [graphicalItem].concat(_toConsumableArray(_this.renderActivePoints({
	              item: item,
	              activePoint: activePoint,
	              basePoint: basePoint,
	              childIndex: activeTooltipIndex,
	              isRange: isRange
	            })));
	          }
	        }
	
	        if (isRange) {
	          return [graphicalItem, null, null];
	        }
	
	        return [graphicalItem, null];
	      };
	
	      _this.renderCustomized = function (element) {
	        return (0, _react.cloneElement)(element, _objectSpread({}, _this.props, {}, _this.state));
	      };
	
	      var defaultState = _this.constructor.createDefaultState(_props);
	
	      var _updateId = 0;
	      _this.state = _objectSpread({}, defaultState, {
	        updateId: 0
	      }, _this.updateStateOfAxisMapsOffsetAndStackGroups(_objectSpread({
	        props: _props
	      }, defaultState, {
	        updateId: _updateId
	      })));
	      _this.uniqueChartId = (0, _isNil2["default"])(_props.id) ? (0, _DataUtils.uniqueId)('recharts') : _props.id;
	      _this.clipPathId = "".concat(_this.uniqueChartId, "-clip");
	
	      if (_props.throttleDelay) {
	        _this.triggeredAfterMouseMove = (0, _throttle2["default"])(_this.triggeredAfterMouseMove, _props.throttleDelay);
	      }
	
	      return _this;
	    }
	    /* eslint-disable  react/no-did-mount-set-state */
	
	
	    _createClass(CategoricalChartWrapper, [{
	      key: "componentDidMount",
	      value: function componentDidMount() {
	        if (!(0, _isNil2["default"])(this.props.syncId)) {
	          this.addListener();
	        }
	      } // eslint-disable-next-line camelcase
	
	    }, {
	      key: "componentWillReceiveProps",
	      value: function componentWillReceiveProps(nextProps) {
	        var _this2 = this;
	
	        var _this$props4 = this.props,
	            data = _this$props4.data,
	            children = _this$props4.children,
	            width = _this$props4.width,
	            height = _this$props4.height,
	            layout = _this$props4.layout,
	            stackOffset = _this$props4.stackOffset,
	            margin = _this$props4.margin;
	        var updateId = this.state.updateId;
	
	        if (nextProps.data !== data || nextProps.width !== width || nextProps.height !== height || nextProps.layout !== layout || nextProps.stackOffset !== stackOffset || !(0, _ShallowEqual.shallowEqual)(nextProps.margin, margin)) {
	          var defaultState = this.constructor.createDefaultState(nextProps);
	          this.setState(_objectSpread({}, defaultState, {
	            updateId: updateId + 1
	          }, this.updateStateOfAxisMapsOffsetAndStackGroups(_objectSpread({
	            props: nextProps
	          }, defaultState, {
	            updateId: updateId + 1
	          }))));
	        } else if (!(0, _ReactUtils.isChildrenEqual)(nextProps.children, children)) {
	          // update configuration in chilren
	          var hasGlobalData = !(0, _isNil2["default"])(nextProps.data);
	          var newUpdateId = hasGlobalData ? updateId : updateId + 1;
	          this.setState(function (prevState) {
	            return _objectSpread({
	              updateId: newUpdateId
	            }, _this2.updateStateOfAxisMapsOffsetAndStackGroups(_objectSpread({
	              props: nextProps
	            }, prevState, {
	              updateId: newUpdateId
	            })));
	          });
	        } // add syncId
	
	
	        if ((0, _isNil2["default"])(this.props.syncId) && !(0, _isNil2["default"])(nextProps.syncId)) {
	          this.addListener();
	        } // remove syncId
	
	
	        if (!(0, _isNil2["default"])(this.props.syncId) && (0, _isNil2["default"])(nextProps.syncId)) {
	          this.removeListener();
	        }
	      }
	    }, {
	      key: "componentWillUnmount",
	      value: function componentWillUnmount() {
	        if (!(0, _isNil2["default"])(this.props.syncId)) {
	          this.removeListener();
	        }
	
	        if (typeof this.triggeredAfterMouseMove.cancel === 'function') {
	          this.triggeredAfterMouseMove.cancel();
	        }
	      }
	      /**
	      * Get the configuration of all x-axis or y-axis
	      * @param  {Object} props          Latest props
	      * @param  {String} axisType       The type of axis
	      * @param  {Array}  graphicalItems The instances of item
	      * @param  {Object} stackGroups    The items grouped by axisId and stackId
	      * @param {Number} dataStartIndex  The start index of the data series when a brush is applied
	      * @param {Number} dataEndIndex    The end index of the data series when a brush is applied
	      * @return {Object}          Configuration
	      */
	
	    }, {
	      key: "getAxisMap",
	      value: function getAxisMap(props, _ref5) {
	        var _ref5$axisType = _ref5.axisType,
	            axisType = _ref5$axisType === void 0 ? 'xAxis' : _ref5$axisType,
	            AxisComp = _ref5.AxisComp,
	            graphicalItems = _ref5.graphicalItems,
	            stackGroups = _ref5.stackGroups,
	            dataStartIndex = _ref5.dataStartIndex,
	            dataEndIndex = _ref5.dataEndIndex;
	        var children = props.children;
	        var axisIdKey = "".concat(axisType, "Id"); // Get all the instance of Axis
	
	        var axes = (0, _ReactUtils.findAllByType)(children, AxisComp);
	        var axisMap = {};
	
	        if (axes && axes.length) {
	          axisMap = this.getAxisMapByAxes(props, {
	            axes: axes,
	            graphicalItems: graphicalItems,
	            axisType: axisType,
	            axisIdKey: axisIdKey,
	            stackGroups: stackGroups,
	            dataStartIndex: dataStartIndex,
	            dataEndIndex: dataEndIndex
	          });
	        } else if (graphicalItems && graphicalItems.length) {
	          axisMap = this.getAxisMapByItems(props, {
	            Axis: AxisComp,
	            graphicalItems: graphicalItems,
	            axisType: axisType,
	            axisIdKey: axisIdKey,
	            stackGroups: stackGroups,
	            dataStartIndex: dataStartIndex,
	            dataEndIndex: dataEndIndex
	          });
	        }
	
	        return axisMap;
	      }
	      /**
	       * Get the configuration of axis by the options of axis instance
	       * @param  {Object} props         Latest props
	       * @param {Array}  axes           The instance of axes
	       * @param  {Array} graphicalItems The instances of item
	       * @param  {String} axisType      The type of axis, xAxis - x-axis, yAxis - y-axis
	       * @param  {String} axisIdKey     The unique id of an axis
	       * @param  {Object} stackGroups   The items grouped by axisId and stackId
	       * @param {Number} dataStartIndex The start index of the data series when a brush is applied
	       * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
	       * @return {Object}      Configuration
	       */
	
	    }, {
	      key: "getAxisMapByAxes",
	      value: function getAxisMapByAxes(props, _ref6) {
	        var _this3 = this;
	
	        var axes = _ref6.axes,
	            graphicalItems = _ref6.graphicalItems,
	            axisType = _ref6.axisType,
	            axisIdKey = _ref6.axisIdKey,
	            stackGroups = _ref6.stackGroups,
	            dataStartIndex = _ref6.dataStartIndex,
	            dataEndIndex = _ref6.dataEndIndex;
	        var layout = props.layout,
	            children = props.children,
	            stackOffset = props.stackOffset;
	        var isCategorial = (0, _ChartUtils.isCategorialAxis)(layout, axisType); // Eliminate duplicated axes
	
	        var axisMap = axes.reduce(function (result, child) {
	          var _child$props = child.props,
	              type = _child$props.type,
	              dataKey = _child$props.dataKey,
	              allowDataOverflow = _child$props.allowDataOverflow,
	              allowDuplicatedCategory = _child$props.allowDuplicatedCategory,
	              scale = _child$props.scale,
	              ticks = _child$props.ticks;
	          var axisId = child.props[axisIdKey];
	
	          var displayedData = _this3.constructor.getDisplayedData(props, {
	            graphicalItems: graphicalItems.filter(function (item) {
	              return item.props[axisIdKey] === axisId;
	            }),
	            dataStartIndex: dataStartIndex,
	            dataEndIndex: dataEndIndex
	          });
	
	          var len = displayedData.length;
	
	          if (!result[axisId]) {
	            var domain, duplicateDomain, categoricalDomain;
	
	            if (dataKey) {
	              domain = (0, _ChartUtils.getDomainOfDataByKey)(displayedData, dataKey, type);
	
	              if (type === 'category' && isCategorial) {
	                var duplicate = (0, _DataUtils.hasDuplicate)(domain);
	
	                if (allowDuplicatedCategory && duplicate) {
	                  duplicateDomain = domain; // When category axis has duplicated text, serial numbers are used to generate scale
	
	                  domain = (0, _range2["default"])(0, len);
	                } else if (!allowDuplicatedCategory) {
	                  // remove duplicated category
	                  domain = (0, _ChartUtils.parseDomainOfCategoryAxis)(child.props.domain, domain, child).reduce(function (finalDomain, entry) {
	                    return finalDomain.indexOf(entry) >= 0 ? finalDomain : [].concat(_toConsumableArray(finalDomain), [entry]);
	                  }, []);
	                }
	              } else if (type === 'category') {
	                if (!allowDuplicatedCategory) {
	                  domain = (0, _ChartUtils.parseDomainOfCategoryAxis)(child.props.domain, domain, child).reduce(function (finalDomain, entry) {
	                    return finalDomain.indexOf(entry) >= 0 || entry === '' || (0, _isNil2["default"])(entry) ? finalDomain : [].concat(_toConsumableArray(finalDomain), [entry]);
	                  }, []);
	                } else {
	                  // eliminate undefined or null or empty string
	                  domain = domain.filter(function (entry) {
	                    return entry !== '' && !(0, _isNil2["default"])(entry);
	                  });
	                }
	              } else if (type === 'number') {
	                var errorBarsDomain = (0, _ChartUtils.parseErrorBarsOfAxis)(displayedData, graphicalItems.filter(function (item) {
	                  return item.props[axisIdKey] === axisId && !item.props.hide;
	                }), dataKey, axisType);
	
	                if (errorBarsDomain) {
	                  domain = errorBarsDomain;
	                }
	              }
	
	              if (isCategorial && (type === 'number' || scale !== 'auto')) {
	                categoricalDomain = (0, _ChartUtils.getDomainOfDataByKey)(displayedData, dataKey, 'category');
	              }
	            } else if (isCategorial) {
	              domain = (0, _range2["default"])(0, len);
	            } else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack && type === 'number') {
	              // when stackOffset is 'expand', the domain may be calculated as [0, 1.000000000002]
	              domain = stackOffset === 'expand' ? [0, 1] : (0, _ChartUtils.getDomainOfStackGroups)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
	            } else {
	              domain = (0, _ChartUtils.getDomainOfItemsWithSameAxis)(displayedData, graphicalItems.filter(function (item) {
	                return item.props[axisIdKey] === axisId && !item.props.hide;
	              }), type, true);
	            }
	
	            if (type === 'number') {
	              // To detect wether there is any reference lines whose props alwaysShow is true
	              domain = (0, _DetectReferenceElementsDomain.detectReferenceElementsDomain)(children, domain, axisId, axisType, ticks);
	
	              if (child.props.domain) {
	                domain = (0, _ChartUtils.parseSpecifiedDomain)(child.props.domain, domain, allowDataOverflow);
	              }
	            }
	
	            return _objectSpread({}, result, _defineProperty({}, axisId, _objectSpread({}, child.props, {
	              axisType: axisType,
	              domain: domain,
	              categoricalDomain: categoricalDomain,
	              duplicateDomain: duplicateDomain,
	              originalDomain: child.props.domain,
	              isCategorial: isCategorial,
	              layout: layout
	            })));
	          }
	
	          return result;
	        }, {});
	        return axisMap;
	      }
	      /**
	       * Get the configuration of axis by the options of item,
	       * this kind of axis does not display in chart
	       * @param  {Object} props         Latest props
	       * @param  {Array} graphicalItems The instances of item
	       * @param  {ReactElement} Axis    Axis Component
	       * @param  {String} axisType      The type of axis, xAxis - x-axis, yAxis - y-axis
	       * @param  {String} axisIdKey     The unique id of an axis
	       * @param  {Object} stackGroups   The items grouped by axisId and stackId
	       * @param {Number} dataStartIndex The start index of the data series when a brush is applied
	       * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
	       * @return {Object}               Configuration
	       */
	
	    }, {
	      key: "getAxisMapByItems",
	      value: function getAxisMapByItems(props, _ref7) {
	        var graphicalItems = _ref7.graphicalItems,
	            Axis = _ref7.Axis,
	            axisType = _ref7.axisType,
	            axisIdKey = _ref7.axisIdKey,
	            stackGroups = _ref7.stackGroups,
	            dataStartIndex = _ref7.dataStartIndex,
	            dataEndIndex = _ref7.dataEndIndex;
	        var layout = props.layout,
	            children = props.children;
	        var displayedData = this.constructor.getDisplayedData(props, {
	          graphicalItems: graphicalItems,
	          dataStartIndex: dataStartIndex,
	          dataEndIndex: dataEndIndex
	        });
	        var len = displayedData.length;
	        var isCategorial = (0, _ChartUtils.isCategorialAxis)(layout, axisType);
	        var index = -1; // The default type of x-axis is category axis,
	        // The default contents of x-axis is the serial numbers of data
	        // The default type of y-axis is number axis
	        // The default contents of y-axis is the domain of data
	
	        var axisMap = graphicalItems.reduce(function (result, child) {
	          var axisId = child.props[axisIdKey];
	
	          if (!result[axisId]) {
	            index++;
	            var domain;
	
	            if (isCategorial) {
	              domain = (0, _range2["default"])(0, len);
	            } else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack) {
	              domain = (0, _ChartUtils.getDomainOfStackGroups)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
	              domain = (0, _DetectReferenceElementsDomain.detectReferenceElementsDomain)(children, domain, axisId, axisType);
	            } else {
	              domain = (0, _ChartUtils.parseSpecifiedDomain)(Axis.defaultProps.domain, (0, _ChartUtils.getDomainOfItemsWithSameAxis)(displayedData, graphicalItems.filter(function (item) {
	                return item.props[axisIdKey] === axisId && !item.props.hide;
	              }), 'number'), Axis.defaultProps.allowDataOverflow);
	              domain = (0, _DetectReferenceElementsDomain.detectReferenceElementsDomain)(children, domain, axisId, axisType);
	            }
	
	            return _objectSpread({}, result, _defineProperty({}, axisId, _objectSpread({
	              axisType: axisType
	            }, Axis.defaultProps, {
	              hide: true,
	              orientation: ORIENT_MAP[axisType] && ORIENT_MAP[axisType][index % 2],
	              domain: domain,
	              originalDomain: Axis.defaultProps.domain,
	              isCategorial: isCategorial,
	              layout: layout // specify scale when no Axis
	              // scale: isCategorial ? 'band' : 'linear',
	
	            })));
	          }
	
	          return result;
	        }, {});
	        return axisMap;
	      }
	    }, {
	      key: "getActiveCoordinate",
	      value: function getActiveCoordinate(tooltipTicks, activeIndex, rangeObj) {
	        var layout = this.props.layout;
	        var entry = tooltipTicks.find(function (tick) {
	          return tick && tick.index === activeIndex;
	        });
	
	        if (entry) {
	          if (layout === 'horizontal') {
	            return {
	              x: entry.coordinate,
	              y: rangeObj.y
	            };
	          }
	
	          if (layout === 'vertical') {
	            return {
	              x: rangeObj.x,
	              y: entry.coordinate
	            };
	          }
	
	          if (layout === 'centric') {
	            var _angle = entry.coordinate;
	            var _radius = rangeObj.radius;
	            return _objectSpread({}, rangeObj, {}, (0, _PolarUtils.polarToCartesian)(rangeObj.cx, rangeObj.cy, _radius, _angle), {
	              angle: _angle,
	              radius: _radius
	            });
	          }
	
	          var radius = entry.coordinate;
	          var angle = rangeObj.angle;
	          return _objectSpread({}, rangeObj, {}, (0, _PolarUtils.polarToCartesian)(rangeObj.cx, rangeObj.cy, radius, angle), {
	            angle: angle,
	            radius: radius
	          });
	        }
	
	        return originCoordinate;
	      }
	      /**
	       * Get the information of mouse in chart, return null when the mouse is not in the chart
	       * @param  {Object} event    The event object
	       * @return {Object}          Mouse data
	       */
	
	    }, {
	      key: "getMouseInfo",
	      value: function getMouseInfo(event) {
	        if (!this.container) {
	          return null;
	        }
	
	        var containerOffset = (0, _DOMUtils.getOffset)(this.container);
	        var e = (0, _DOMUtils.calculateChartCoordinate)(event, containerOffset);
	        var rangeObj = this.inRange(e.chartX, e.chartY);
	
	        if (!rangeObj) {
	          return null;
	        }
	
	        var _this$state9 = this.state,
	            xAxisMap = _this$state9.xAxisMap,
	            yAxisMap = _this$state9.yAxisMap;
	
	        if (eventType !== 'axis' && xAxisMap && yAxisMap) {
	          var xScale = (0, _DataUtils.getAnyElementOfObject)(xAxisMap).scale;
	          var yScale = (0, _DataUtils.getAnyElementOfObject)(yAxisMap).scale;
	          var xValue = xScale && xScale.invert ? xScale.invert(e.chartX) : null;
	          var yValue = yScale && yScale.invert ? yScale.invert(e.chartY) : null;
	          return _objectSpread({}, e, {
	            xValue: xValue,
	            yValue: yValue
	          });
	        }
	
	        var _this$state10 = this.state,
	            ticks = _this$state10.orderedTooltipTicks,
	            axis = _this$state10.tooltipAxis,
	            tooltipTicks = _this$state10.tooltipTicks;
	        var pos = this.calculateTooltipPos(rangeObj);
	        var activeIndex = (0, _ChartUtils.calculateActiveTickIndex)(pos, ticks, tooltipTicks, axis);
	
	        if (activeIndex >= 0 && tooltipTicks) {
	          var activeLabel = tooltipTicks[activeIndex] && tooltipTicks[activeIndex].value;
	          var activePayload = this.getTooltipContent(activeIndex, activeLabel);
	          var activeCoordinate = this.getActiveCoordinate(ticks, activeIndex, rangeObj);
	          return _objectSpread({}, e, {
	            activeTooltipIndex: activeIndex,
	            activeLabel: activeLabel,
	            activePayload: activePayload,
	            activeCoordinate: activeCoordinate
	          });
	        }
	
	        return null;
	      }
	      /**
	       * Get the content to be displayed in the tooltip
	       * @param  {Number} activeIndex    Active index of data
	       * @param  {String} activeLabel    Active label of data
	       * @return {Array}                 The content of tooltip
	       */
	
	    }, {
	      key: "getTooltipContent",
	      value: function getTooltipContent(activeIndex, activeLabel) {
	        var _this$state11 = this.state,
	            graphicalItems = _this$state11.graphicalItems,
	            tooltipAxis = _this$state11.tooltipAxis;
	        var displayedData = this.constructor.getDisplayedData(this.props, this.state);
	
	        if (activeIndex < 0 || !graphicalItems || !graphicalItems.length || activeIndex >= displayedData.length) {
	          return null;
	        } // get data by activeIndex when the axis don't allow duplicated category
	
	
	        return graphicalItems.reduce(function (result, child) {
	          var hide = child.props.hide;
	
	          if (hide) {
	            return result;
	          }
	
	          var _child$props2 = child.props,
	              dataKey = _child$props2.dataKey,
	              name = _child$props2.name,
	              unit = _child$props2.unit,
	              formatter = _child$props2.formatter,
	              data = _child$props2.data,
	              tooltipType = _child$props2.tooltipType;
	          var payload;
	
	          if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
	            // graphic child has data props
	            payload = (0, _DataUtils.findEntryInArray)(data || displayedData, tooltipAxis.dataKey, activeLabel);
	          } else {
	            payload = data && data[activeIndex] || displayedData[activeIndex];
	          }
	
	          if (!payload) {
	            return result;
	          }
	
	          return [].concat(_toConsumableArray(result), [_objectSpread({}, (0, _ReactUtils.getPresentationAttributes)(child), {
	            dataKey: dataKey,
	            unit: unit,
	            formatter: formatter,
	            name: name || dataKey,
	            color: (0, _ChartUtils.getMainColorOfGraphicItem)(child),
	            value: (0, _ChartUtils.getValueByDataKey)(payload, dataKey),
	            type: tooltipType,
	            payload: payload
	          })]);
	        }, []);
	      }
	    }, {
	      key: "getFormatItems",
	      value: function getFormatItems(props, currentState) {
	        var _this4 = this;
	
	        var graphicalItems = currentState.graphicalItems,
	            stackGroups = currentState.stackGroups,
	            offset = currentState.offset,
	            updateId = currentState.updateId,
	            dataStartIndex = currentState.dataStartIndex,
	            dataEndIndex = currentState.dataEndIndex;
	        var barSize = props.barSize,
	            layout = props.layout,
	            barGap = props.barGap,
	            barCategoryGap = props.barCategoryGap,
	            globalMaxBarSize = props.maxBarSize;
	
	        var _this$constructor$get = this.constructor.getAxisNameByLayout(layout),
	            numericAxisName = _this$constructor$get.numericAxisName,
	            cateAxisName = _this$constructor$get.cateAxisName;
	
	        var hasBar = this.constructor.hasBar(graphicalItems);
	        var sizeList = hasBar && (0, _ChartUtils.getBarSizeList)({
	          barSize: barSize,
	          stackGroups: stackGroups
	        });
	        var formatedItems = [];
	        graphicalItems.forEach(function (item, index) {
	          var displayedData = _this4.constructor.getDisplayedData(props, {
	            dataStartIndex: dataStartIndex,
	            dataEndIndex: dataEndIndex
	          }, item);
	
	          var _item$props2 = item.props,
	              dataKey = _item$props2.dataKey,
	              childMaxBarSize = _item$props2.maxBarSize;
	          var numericAxisId = item.props["".concat(numericAxisName, "Id")];
	          var cateAxisId = item.props["".concat(cateAxisName, "Id")];
	          var axisObj = axisComponents.reduce(function (result, entry) {
	            var _objectSpread4;
	
	            var axisMap = currentState["".concat(entry.axisType, "Map")];
	            var id = item.props["".concat(entry.axisType, "Id")];
	            var axis = axisMap && axisMap[id];
	            return _objectSpread({}, result, (_objectSpread4 = {}, _defineProperty(_objectSpread4, entry.axisType, axis), _defineProperty(_objectSpread4, "".concat(entry.axisType, "Ticks"), (0, _ChartUtils.getTicksOfAxis)(axis)), _objectSpread4));
	          }, {});
	          var cateAxis = axisObj[cateAxisName];
	          var cateTicks = axisObj["".concat(cateAxisName, "Ticks")];
	          var stackedData = stackGroups && stackGroups[numericAxisId] && stackGroups[numericAxisId].hasStack && (0, _ChartUtils.getStackedDataOfItem)(item, stackGroups[numericAxisId].stackGroups);
	          var bandSize = (0, _ChartUtils.getBandSizeOfAxis)(cateAxis, cateTicks);
	          var maxBarSize = (0, _isNil2["default"])(childMaxBarSize) ? globalMaxBarSize : childMaxBarSize;
	          var barPosition = hasBar && (0, _ChartUtils.getBarPosition)({
	            barGap: barGap,
	            barCategoryGap: barCategoryGap,
	            bandSize: bandSize,
	            sizeList: sizeList[cateAxisId],
	            maxBarSize: maxBarSize
	          });
	          var componsedFn = item && item.type && item.type.getComposedData;
	
	          if (componsedFn) {
	            var _objectSpread5;
	
	            formatedItems.push({
	              props: _objectSpread({}, componsedFn(_objectSpread({}, axisObj, {
	                displayedData: displayedData,
	                props: props,
	                dataKey: dataKey,
	                item: item,
	                bandSize: bandSize,
	                barPosition: barPosition,
	                offset: offset,
	                stackedData: stackedData,
	                layout: layout,
	                dataStartIndex: dataStartIndex,
	                dataEndIndex: dataEndIndex,
	                onItemMouseLeave: (0, _ChartUtils.combineEventHandlers)(_this4.handleItemMouseLeave, null, item.props.onMouseLeave),
	                onItemMouseEnter: (0, _ChartUtils.combineEventHandlers)(_this4.handleItemMouseEnter, null, item.props.onMouseEnter)
	              })), (_objectSpread5 = {
	                key: item.key || "item-".concat(index)
	              }, _defineProperty(_objectSpread5, numericAxisName, axisObj[numericAxisName]), _defineProperty(_objectSpread5, cateAxisName, axisObj[cateAxisName]), _defineProperty(_objectSpread5, "animationId", updateId), _objectSpread5)),
	              childIndex: (0, _ReactUtils.parseChildIndex)(item, props.children),
	              item: item
	            });
	          }
	        });
	        return formatedItems;
	      }
	    }, {
	      key: "getCursorRectangle",
	      value: function getCursorRectangle() {
	        var layout = this.props.layout;
	        var _this$state12 = this.state,
	            activeCoordinate = _this$state12.activeCoordinate,
	            offset = _this$state12.offset,
	            tooltipAxisBandSize = _this$state12.tooltipAxisBandSize;
	        var halfSize = tooltipAxisBandSize / 2;
	        return {
	          stroke: 'none',
	          fill: '#ccc',
	          x: layout === 'horizontal' ? activeCoordinate.x - halfSize : offset.left + 0.5,
	          y: layout === 'horizontal' ? offset.top + 0.5 : activeCoordinate.y - halfSize,
	          width: layout === 'horizontal' ? tooltipAxisBandSize : offset.width - 1,
	          height: layout === 'horizontal' ? offset.height - 1 : tooltipAxisBandSize
	        };
	      }
	    }, {
	      key: "getCursorPoints",
	      value: function getCursorPoints() {
	        var layout = this.props.layout;
	        var _this$state13 = this.state,
	            activeCoordinate = _this$state13.activeCoordinate,
	            offset = _this$state13.offset;
	        var x1, y1, x2, y2;
	
	        if (layout === 'horizontal') {
	          x1 = activeCoordinate.x;
	          x2 = x1;
	          y1 = offset.top;
	          y2 = offset.top + offset.height;
	        } else if (layout === 'vertical') {
	          y1 = activeCoordinate.y;
	          y2 = y1;
	          x1 = offset.left;
	          x2 = offset.left + offset.width;
	        } else if (!(0, _isNil2["default"])(activeCoordinate.cx) || !(0, _isNil2["default"])(activeCoordinate.cy)) {
	          if (layout === 'centric') {
	            var cx = activeCoordinate.cx,
	                cy = activeCoordinate.cy,
	                innerRadius = activeCoordinate.innerRadius,
	                outerRadius = activeCoordinate.outerRadius,
	                angle = activeCoordinate.angle;
	            var innerPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, innerRadius, angle);
	            var outerPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, outerRadius, angle);
	            x1 = innerPoint.x;
	            y1 = innerPoint.y;
	            x2 = outerPoint.x;
	            y2 = outerPoint.y;
	          } else {
	            var _cx = activeCoordinate.cx,
	                _cy = activeCoordinate.cy,
	                radius = activeCoordinate.radius,
	                startAngle = activeCoordinate.startAngle,
	                endAngle = activeCoordinate.endAngle;
	            var startPoint = (0, _PolarUtils.polarToCartesian)(_cx, _cy, radius, startAngle);
	            var endPoint = (0, _PolarUtils.polarToCartesian)(_cx, _cy, radius, endAngle);
	            return {
	              points: [startPoint, endPoint],
	              cx: _cx,
	              cy: _cy,
	              radius: radius,
	              startAngle: startAngle,
	              endAngle: endAngle
	            };
	          }
	        }
	
	        return [{
	          x: x1,
	          y: y1
	        }, {
	          x: x2,
	          y: y2
	        }];
	      }
	    }, {
	      key: "calculateTooltipPos",
	      value: function calculateTooltipPos(rangeObj) {
	        var layout = this.props.layout;
	
	        if (layout === 'horizontal') {
	          return rangeObj.x;
	        }
	
	        if (layout === 'vertical') {
	          return rangeObj.y;
	        }
	
	        if (layout === 'centric') {
	          return rangeObj.angle;
	        }
	
	        return rangeObj.radius;
	      }
	    }, {
	      key: "inRange",
	      value: function inRange(x, y) {
	        var layout = this.props.layout;
	
	        if (layout === 'horizontal' || layout === 'vertical') {
	          var offset = this.state.offset;
	          var isInRange = x >= offset.left && x <= offset.left + offset.width && y >= offset.top && y <= offset.top + offset.height;
	          return isInRange ? {
	            x: x,
	            y: y
	          } : null;
	        }
	
	        var _this$state14 = this.state,
	            angleAxisMap = _this$state14.angleAxisMap,
	            radiusAxisMap = _this$state14.radiusAxisMap;
	
	        if (angleAxisMap && radiusAxisMap) {
	          var angleAxis = (0, _DataUtils.getAnyElementOfObject)(angleAxisMap);
	          return (0, _PolarUtils.inRangeOfSector)({
	            x: x,
	            y: y
	          }, angleAxis);
	        }
	
	        return null;
	      }
	    }, {
	      key: "parseEventsOfWrapper",
	      value: function parseEventsOfWrapper() {
	        var children = this.props.children;
	        var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip["default"]);
	        var tooltipEvents = tooltipItem && eventType === 'axis' ? {
	          onMouseEnter: this.handleMouseEnter,
	          onMouseMove: this.handleMouseMove,
	          onMouseLeave: this.handleMouseLeave,
	          onTouchMove: this.handleTouchMove,
	          onTouchStart: this.handleTouchStart,
	          onTouchEnd: this.handleTouchEnd
	        } : {};
	        var outerEvents = (0, _ReactUtils.filterEventAttributes)(this.props, this.handleOuterEvent);
	        return _objectSpread({}, outerEvents, {}, tooltipEvents);
	      }
	      /**
	       * The AxisMaps are expensive to render on large data sets
	       * so provide the ability to store them in state and only update them when necessary
	       * they are dependent upon the start and end index of
	       * the brush so it's important that this method is called _after_
	       * the state is updated with any new start/end indices
	       *
	       * @param {Object} props          The props object to be used for updating the axismaps
	       * @param {Number} dataStartIndex The start index of the data series when a brush is applied
	       * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
	       * @param {Number} updateId       The update id
	       * @return {Object} state New state to set
	       */
	
	    }, {
	      key: "updateStateOfAxisMapsOffsetAndStackGroups",
	      value: function updateStateOfAxisMapsOffsetAndStackGroups(_ref8) {
	        var _this5 = this;
	
	        var props = _ref8.props,
	            dataStartIndex = _ref8.dataStartIndex,
	            dataEndIndex = _ref8.dataEndIndex,
	            updateId = _ref8.updateId;
	
	        if (!(0, _ReactUtils.validateWidthHeight)({
	          props: props
	        })) {
	          return null;
	        }
	
	        var children = props.children,
	            layout = props.layout,
	            stackOffset = props.stackOffset,
	            data = props.data,
	            reverseStackOrder = props.reverseStackOrder;
	
	        var _this$constructor$get2 = this.constructor.getAxisNameByLayout(layout),
	            numericAxisName = _this$constructor$get2.numericAxisName,
	            cateAxisName = _this$constructor$get2.cateAxisName;
	
	        var graphicalItems = (0, _ReactUtils.findAllByType)(children, GraphicalChild);
	        var stackGroups = (0, _ChartUtils.getStackGroupsByAxisId)(data, graphicalItems, "".concat(numericAxisName, "Id"), "".concat(cateAxisName, "Id"), stackOffset, reverseStackOrder);
	        var axisObj = axisComponents.reduce(function (result, entry) {
	          var name = "".concat(entry.axisType, "Map");
	          return _objectSpread({}, result, _defineProperty({}, name, _this5.getAxisMap(props, _objectSpread({}, entry, {
	            graphicalItems: graphicalItems,
	            stackGroups: entry.axisType === numericAxisName && stackGroups,
	            dataStartIndex: dataStartIndex,
	            dataEndIndex: dataEndIndex
	          }))));
	        }, {});
	        var offset = this.calculateOffset(_objectSpread({}, axisObj, {
	          props: props,
	          graphicalItems: graphicalItems
	        }));
	        Object.keys(axisObj).forEach(function (key) {
	          axisObj[key] = formatAxisMap(props, axisObj[key], offset, key.replace('Map', ''), chartName);
	        });
	        var cateAxisMap = axisObj["".concat(cateAxisName, "Map")];
	        var ticksObj = this.tooltipTicksGenerator(cateAxisMap);
	        var formatedGraphicalItems = this.getFormatItems(props, _objectSpread({}, axisObj, {
	          dataStartIndex: dataStartIndex,
	          dataEndIndex: dataEndIndex,
	          updateId: updateId,
	          graphicalItems: graphicalItems,
	          stackGroups: stackGroups,
	          offset: offset
	        }));
	        return _objectSpread({
	          formatedGraphicalItems: formatedGraphicalItems,
	          graphicalItems: graphicalItems,
	          offset: offset,
	          stackGroups: stackGroups
	        }, ticksObj, {}, axisObj);
	      }
	      /* eslint-disable  no-underscore-dangle */
	
	    }, {
	      key: "addListener",
	      value: function addListener() {
	        _Events.eventCenter.on(_Events.SYNC_EVENT, this.handleReceiveSyncEvent);
	
	        if (_Events.eventCenter.setMaxListeners && _Events.eventCenter._maxListeners) {
	          _Events.eventCenter.setMaxListeners(_Events.eventCenter._maxListeners + 1);
	        }
	      }
	    }, {
	      key: "removeListener",
	      value: function removeListener() {
	        _Events.eventCenter.removeListener(_Events.SYNC_EVENT, this.handleReceiveSyncEvent);
	
	        if (_Events.eventCenter.setMaxListeners && _Events.eventCenter._maxListeners) {
	          _Events.eventCenter.setMaxListeners(_Events.eventCenter._maxListeners - 1);
	        }
	      }
	      /**
	       * Calculate the offset of main part in the svg element
	       * @param  {Object} props          Latest props
	       * @param  {Array}  graphicalItems The instances of item
	       * @param  {Object} xAxisMap       The configuration of x-axis
	       * @param  {Object} yAxisMap       The configuration of y-axis
	       * @return {Object} The offset of main part in the svg element
	       */
	
	    }, {
	      key: "calculateOffset",
	      value: function calculateOffset(_ref9) {
	        var props = _ref9.props,
	            graphicalItems = _ref9.graphicalItems,
	            _ref9$xAxisMap = _ref9.xAxisMap,
	            xAxisMap = _ref9$xAxisMap === void 0 ? {} : _ref9$xAxisMap,
	            _ref9$yAxisMap = _ref9.yAxisMap,
	            yAxisMap = _ref9$yAxisMap === void 0 ? {} : _ref9$yAxisMap;
	        var width = props.width,
	            height = props.height,
	            children = props.children;
	        var margin = props.margin || {};
	        var brushItem = (0, _ReactUtils.findChildByType)(children, _Brush["default"]);
	        var legendItem = (0, _ReactUtils.findChildByType)(children, _Legend["default"]);
	        var offsetH = Object.keys(yAxisMap).reduce(function (result, id) {
	          var entry = yAxisMap[id];
	          var orientation = entry.orientation;
	
	          if (!entry.mirror && !entry.hide) {
	            return _objectSpread({}, result, _defineProperty({}, orientation, result[orientation] + entry.width));
	          }
	
	          return result;
	        }, {
	          left: margin.left || 0,
	          right: margin.right || 0
	        });
	        var offsetV = Object.keys(xAxisMap).reduce(function (result, id) {
	          var entry = xAxisMap[id];
	          var orientation = entry.orientation;
	
	          if (!entry.mirror && !entry.hide) {
	            return _objectSpread({}, result, _defineProperty({}, orientation, result[orientation] + entry.height));
	          }
	
	          return result;
	        }, {
	          top: margin.top || 0,
	          bottom: margin.bottom || 0
	        });
	
	        var offset = _objectSpread({}, offsetV, {}, offsetH);
	
	        var brushBottom = offset.bottom;
	
	        if (brushItem) {
	          offset.bottom += brushItem.props.height || _Brush["default"].defaultProps.height;
	        }
	
	        if (legendItem && this.legendInstance) {
	          var legendBox = this.legendInstance.getBBox();
	          offset = (0, _ChartUtils.appendOffsetOfLegend)(offset, graphicalItems, props, legendBox);
	        }
	
	        return _objectSpread({
	          brushBottom: brushBottom
	        }, offset, {
	          width: width - offset.left - offset.right,
	          height: height - offset.top - offset.bottom
	        });
	      }
	    }, {
	      key: "triggerSyncEvent",
	      value: function triggerSyncEvent(data) {
	        var syncId = this.props.syncId;
	
	        if (!(0, _isNil2["default"])(syncId)) {
	          _Events.eventCenter.emit(_Events.SYNC_EVENT, syncId, this.uniqueChartId, data);
	        }
	      }
	    }, {
	      key: "filterFormatItem",
	      value: function filterFormatItem(item, displayName, childIndex) {
	        var formatedGraphicalItems = this.state.formatedGraphicalItems;
	
	        for (var i = 0, len = formatedGraphicalItems.length; i < len; i++) {
	          var entry = formatedGraphicalItems[i];
	
	          if (entry.item === item || entry.props.key === item.key || displayName === (0, _ReactUtils.getDisplayName)(entry.item.type) && childIndex === entry.childIndex) {
	            return entry;
	          }
	        }
	
	        return null;
	      }
	    }, {
	      key: "renderAxis",
	
	      /**
	       * Draw axis
	       * @param {Object} axisOptions The options of axis
	       * @param {Object} element      The axis element
	       * @param {String} displayName  The display name of axis
	       * @param {Number} index        The index of element
	       * @return {ReactElement}       The instance of x-axes
	       */
	      value: function renderAxis(axisOptions, element, displayName, index) {
	        var _this$props5 = this.props,
	            width = _this$props5.width,
	            height = _this$props5.height;
	        return _react["default"].createElement(_CartesianAxis["default"], _extends({}, axisOptions, {
	          className: "recharts-".concat(axisOptions.axisType, " ").concat(axisOptions.axisType),
	          key: element.key || "".concat(displayName, "-").concat(index),
	          viewBox: {
	            x: 0,
	            y: 0,
	            width: width,
	            height: height
	          },
	          ticksGenerator: this.axesTicksGenerator
	        }));
	      }
	      /**
	       * Draw grid
	       * @param  {ReactElement} element the grid item
	       * @return {ReactElement} The instance of grid
	       */
	
	    }, {
	      key: "renderLegend",
	
	      /**
	       * Draw legend
	       * @return {ReactElement}            The instance of Legend
	       */
	      value: function renderLegend() {
	        var _this6 = this;
	
	        var formatedGraphicalItems = this.state.formatedGraphicalItems;
	        var _this$props6 = this.props,
	            children = _this$props6.children,
	            width = _this$props6.width,
	            height = _this$props6.height;
	        var margin = this.props.margin || {};
	        var legendWidth = width - (margin.left || 0) - (margin.right || 0);
	        var legendHeight = height - (margin.top || 0) - (margin.bottom || 0);
	        var props = (0, _ChartUtils.getLegendProps)({
	          children: children,
	          formatedGraphicalItems: formatedGraphicalItems,
	          legendWidth: legendWidth,
	          legendHeight: legendHeight,
	          legendContent: legendContent
	        });
	
	        if (!props) {
	          return null;
	        }
	
	        var item = props.item,
	            otherProps = _objectWithoutProperties(props, ["item"]);
	
	        return (0, _react.cloneElement)(item, _objectSpread({}, otherProps, {
	          chartWidth: width,
	          chartHeight: height,
	          margin: margin,
	          ref: function ref(legend) {
	            _this6.legendInstance = legend;
	          },
	          onBBoxUpdate: this.handleLegendBBoxUpdate
	        }));
	      }
	      /**
	       * Draw Tooltip
	       * @return {ReactElement}  The instance of Tooltip
	       */
	
	    }, {
	      key: "renderTooltip",
	      value: function renderTooltip() {
	        var children = this.props.children;
	        var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip["default"]);
	
	        if (!tooltipItem) {
	          return null;
	        }
	
	        var _this$state15 = this.state,
	            isTooltipActive = _this$state15.isTooltipActive,
	            activeCoordinate = _this$state15.activeCoordinate,
	            activePayload = _this$state15.activePayload,
	            activeLabel = _this$state15.activeLabel,
	            offset = _this$state15.offset;
	        return (0, _react.cloneElement)(tooltipItem, {
	          viewBox: _objectSpread({}, offset, {
	            x: offset.left,
	            y: offset.top
	          }),
	          active: isTooltipActive,
	          label: activeLabel,
	          payload: isTooltipActive ? activePayload : [],
	          coordinate: activeCoordinate
	        });
	      }
	    }, {
	      key: "renderActivePoints",
	      value: function renderActivePoints(_ref10) {
	        var item = _ref10.item,
	            activePoint = _ref10.activePoint,
	            basePoint = _ref10.basePoint,
	            childIndex = _ref10.childIndex,
	            isRange = _ref10.isRange;
	        var result = [];
	        var key = item.props.key;
	        var _item$item$props2 = item.item.props,
	            activeDot = _item$item$props2.activeDot,
	            dataKey = _item$item$props2.dataKey;
	
	        var dotProps = _objectSpread({
	          index: childIndex,
	          dataKey: dataKey,
	          cx: activePoint.x,
	          cy: activePoint.y,
	          r: 4,
	          fill: (0, _ChartUtils.getMainColorOfGraphicItem)(item.item),
	          strokeWidth: 2,
	          stroke: '#fff',
	          payload: activePoint.payload,
	          value: activePoint.value,
	          key: "".concat(key, "-activePoint-").concat(childIndex)
	        }, (0, _ReactUtils.getPresentationAttributes)(activeDot), {}, (0, _ReactUtils.filterEventAttributes)(activeDot));
	
	        result.push(this.constructor.renderActiveDot(activeDot, dotProps, childIndex));
	
	        if (basePoint) {
	          result.push(this.constructor.renderActiveDot(activeDot, _objectSpread({}, dotProps, {
	            cx: basePoint.x,
	            cy: basePoint.y,
	            key: "".concat(key, "-basePoint-").concat(childIndex)
	          }), childIndex));
	        } else if (isRange) {
	          result.push(null);
	        }
	
	        return result;
	      }
	    }, {
	      key: "renderClipPath",
	      value: function renderClipPath() {
	        var clipPathId = this.clipPathId;
	        var _this$state$offset = this.state.offset,
	            left = _this$state$offset.left,
	            top = _this$state$offset.top,
	            height = _this$state$offset.height,
	            width = _this$state$offset.width;
	        return _react["default"].createElement("defs", null, _react["default"].createElement("clipPath", {
	          id: clipPathId
	        }, _react["default"].createElement("rect", {
	          x: left,
	          y: top,
	          height: height,
	          width: width
	        })));
	      }
	    }, {
	      key: "render",
	      value: function render() {
	        var _this7 = this;
	
	        if (!(0, _ReactUtils.validateWidthHeight)(this)) {
	          return null;
	        }
	
	        var _this$props7 = this.props,
	            children = _this$props7.children,
	            className = _this$props7.className,
	            width = _this$props7.width,
	            height = _this$props7.height,
	            style = _this$props7.style,
	            compact = _this$props7.compact,
	            others = _objectWithoutProperties(_this$props7, ["children", "className", "width", "height", "style", "compact"]);
	
	        var attrs = (0, _ReactUtils.getPresentationAttributes)(others);
	        var map = {
	          CartesianGrid: {
	            handler: this.renderGrid,
	            once: true
	          },
	          ReferenceArea: {
	            handler: this.renderReferenceElement
	          },
	          ReferenceLine: {
	            handler: this.renderReferenceElement
	          },
	          ReferenceDot: {
	            handler: this.renderReferenceElement
	          },
	          XAxis: {
	            handler: this.renderXAxis
	          },
	          YAxis: {
	            handler: this.renderYAxis
	          },
	          Brush: {
	            handler: this.renderBrush,
	            once: true
	          },
	          Bar: {
	            handler: this.renderGraphicChild
	          },
	          Line: {
	            handler: this.renderGraphicChild
	          },
	          Area: {
	            handler: this.renderGraphicChild
	          },
	          Radar: {
	            handler: this.renderGraphicChild
	          },
	          RadialBar: {
	            handler: this.renderGraphicChild
	          },
	          Scatter: {
	            handler: this.renderGraphicChild
	          },
	          Pie: {
	            handler: this.renderGraphicChild
	          },
	          Funnel: {
	            handler: this.renderGraphicChild
	          },
	          Tooltip: {
	            handler: this.renderCursor,
	            once: true
	          },
	          PolarGrid: {
	            handler: this.renderPolarGrid,
	            once: true
	          },
	          PolarAngleAxis: {
	            handler: this.renderPolarAxis
	          },
	          PolarRadiusAxis: {
	            handler: this.renderPolarAxis
	          },
	          Customized: {
	            handler: this.renderCustomized
	          }
	        }; // The "compact" mode is mainly used as the panorama within Brush
	
	        if (compact) {
	          return _react["default"].createElement(_Surface["default"], _extends({}, attrs, {
	            width: width,
	            height: height
	          }), this.renderClipPath(), (0, _ReactUtils.renderByOrder)(children, map));
	        }
	
	        var events = this.parseEventsOfWrapper();
	        return _react["default"].createElement("div", _extends({
	          className: (0, _classnames["default"])('recharts-wrapper', className),
	          style: _objectSpread({
	            position: 'relative',
	            cursor: 'default',
	            width: width,
	            height: height
	          }, style)
	        }, events, {
	          ref: function ref(node) {
	            _this7.container = node;
	          }
	        }), _react["default"].createElement(_Surface["default"], _extends({}, attrs, {
	          width: width,
	          height: height
	        }), this.renderClipPath(), (0, _ReactUtils.renderByOrder)(children, map)), this.renderLegend(), this.renderTooltip());
	      }
	    }], [{
	      key: "getAxisNameByLayout",
	      value: function getAxisNameByLayout(layout) {
	        if (layout === 'horizontal') {
	          return {
	            numericAxisName: 'yAxis',
	            cateAxisName: 'xAxis'
	          };
	        }
	
	        if (layout === 'vertical') {
	          return {
	            numericAxisName: 'xAxis',
	            cateAxisName: 'yAxis'
	          };
	        }
	
	        if (layout === 'centric') {
	          return {
	            numericAxisName: 'radiusAxis',
	            cateAxisName: 'angleAxis'
	          };
	        }
	
	        return {
	          numericAxisName: 'angleAxis',
	          cateAxisName: 'radiusAxis'
	        };
	      }
	    }, {
	      key: "renderActiveDot",
	      value: function renderActiveDot(option, props) {
	        var dot;
	
	        if ((0, _react.isValidElement)(option)) {
	          dot = (0, _react.cloneElement)(option, props);
	        } else if ((0, _isFunction2["default"])(option)) {
	          dot = option(props);
	        } else {
	          dot = _react["default"].createElement(_Dot["default"], props);
	        }
	
	        return _react["default"].createElement(_Layer["default"], {
	          className: "recharts-active-dot",
	          key: props.key
	        }, dot);
	      }
	    }]);
	
	    return CategoricalChartWrapper;
	  }(_react.Component);
	
	  CategoricalChartWrapper.displayName = chartName;
	  CategoricalChartWrapper.propTypes = _objectSpread({
	    syncId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	    compact: _propTypes["default"].bool,
	    width: _propTypes["default"].number,
	    height: _propTypes["default"].number,
	    data: _propTypes["default"].arrayOf(_propTypes["default"].object),
	    layout: _propTypes["default"].oneOf(['horizontal', 'vertical']),
	    stackOffset: _propTypes["default"].oneOf(['sign', 'expand', 'none', 'wiggle', 'silhouette']),
	    throttleDelay: _propTypes["default"].number,
	    margin: _propTypes["default"].shape({
	      top: _propTypes["default"].number,
	      right: _propTypes["default"].number,
	      bottom: _propTypes["default"].number,
	      left: _propTypes["default"].number
	    }),
	    barCategoryGap: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	    barGap: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	    barSize: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	    maxBarSize: _propTypes["default"].number,
	    style: _propTypes["default"].object,
	    className: _propTypes["default"].string,
	    children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),
	    defaultShowTooltip: _propTypes["default"].bool,
	    onClick: _propTypes["default"].func,
	    onMouseLeave: _propTypes["default"].func,
	    onMouseEnter: _propTypes["default"].func,
	    onMouseMove: _propTypes["default"].func,
	    onMouseDown: _propTypes["default"].func,
	    onMouseUp: _propTypes["default"].func,
	    reverseStackOrder: _propTypes["default"].bool,
	    id: _propTypes["default"].string
	  }, propTypes);
	  CategoricalChartWrapper.defaultProps = _objectSpread({
	    layout: 'horizontal',
	    stackOffset: 'none',
	    barCategoryGap: '10%',
	    barGap: 4,
	    margin: {
	      top: 5,
	      right: 5,
	      bottom: 5,
	      left: 5
	    },
	    reverseStackOrder: false
	  }, defaultProps);
	
	  CategoricalChartWrapper.createDefaultState = function (props) {
	    var children = props.children,
	        defaultShowTooltip = props.defaultShowTooltip;
	    var brushItem = (0, _ReactUtils.findChildByType)(children, _Brush["default"]);
	    var startIndex = brushItem && brushItem.props && brushItem.props.startIndex || 0;
	    var endIndex = brushItem && brushItem.props && brushItem.props.endIndex || props.data && props.data.length - 1 || 0;
	    return {
	      chartX: 0,
	      chartY: 0,
	      dataStartIndex: startIndex,
	      dataEndIndex: endIndex,
	      activeTooltipIndex: -1,
	      isTooltipActive: !(0, _isNil2["default"])(defaultShowTooltip) ? defaultShowTooltip : false
	    };
	  };
	
	  CategoricalChartWrapper.hasBar = function (graphicalItems) {
	    if (!graphicalItems || !graphicalItems.length) {
	      return false;
	    }
	
	    return graphicalItems.some(function (item) {
	      var name = (0, _ReactUtils.getDisplayName)(item && item.type);
	      return name && name.indexOf('Bar') >= 0;
	    });
	  };
	
	  CategoricalChartWrapper.getDisplayedData = function (props, _ref11, item) {
	    var graphicalItems = _ref11.graphicalItems,
	        dataStartIndex = _ref11.dataStartIndex,
	        dataEndIndex = _ref11.dataEndIndex;
	    var itemsData = (graphicalItems || []).reduce(function (result, child) {
	      var itemData = child.props.data;
	
	      if (itemData && itemData.length) {
	        return [].concat(_toConsumableArray(result), _toConsumableArray(itemData));
	      }
	
	      return result;
	    }, []);
	
	    if (itemsData && itemsData.length > 0) {
	      return itemsData;
	    }
	
	    if (item && item.props && item.props.data && item.props.data.length > 0) {
	      return item.props.data;
	    }
	
	    var data = props.data;
	
	    if (data && data.length && (0, _DataUtils.isNumber)(dataStartIndex) && (0, _DataUtils.isNumber)(dataEndIndex)) {
	      return data.slice(dataStartIndex, dataEndIndex + 1);
	    }
	
	    return [];
	  };
	
	  return CategoricalChartWrapper;
	};
	
	var _default = generateCategoricalChart;
	exports["default"] = _default;

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isObject2 = _interopRequireDefault(__webpack_require__(72));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(38));
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(71));
	
	var _last2 = _interopRequireDefault(__webpack_require__(754));
	
	var _isArray2 = _interopRequireDefault(__webpack_require__(43));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _Label = _interopRequireDefault(__webpack_require__(127));
	
	var _Layer = _interopRequireDefault(__webpack_require__(49));
	
	var _ReactUtils = __webpack_require__(29);
	
	var _ChartUtils = __webpack_require__(66);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var propTypes = {
	  id: _propTypes["default"].string,
	  data: _propTypes["default"].arrayOf(_propTypes["default"].object),
	  valueAccessor: _propTypes["default"].func,
	  clockWise: _propTypes["default"].bool,
	  dataKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func])
	};
	var defaultProps = {
	  valueAccessor: function valueAccessor(entry) {
	    return (0, _isArray2["default"])(entry.value) ? (0, _last2["default"])(entry.value) : entry.value;
	  }
	};
	
	function LabelList(props) {
	  var data = props.data,
	      valueAccessor = props.valueAccessor,
	      dataKey = props.dataKey,
	      clockWise = props.clockWise,
	      id = props.id,
	      others = _objectWithoutProperties(props, ["data", "valueAccessor", "dataKey", "clockWise", "id"]);
	
	  if (!data || !data.length) {
	    return null;
	  }
	
	  return _react["default"].createElement(_Layer["default"], {
	    className: "recharts-label-list"
	  }, data.map(function (entry, index) {
	    var value = (0, _isNil2["default"])(dataKey) ? valueAccessor(entry, index) : (0, _ChartUtils.getValueByDataKey)(entry && entry.payload, dataKey);
	    var idProps = (0, _isNil2["default"])(id) ? {} : {
	      id: "".concat(id, "-").concat(index)
	    };
	    return _react["default"].createElement(_Label["default"], _extends({}, (0, _ReactUtils.getPresentationAttributes)(entry), others, idProps, {
	      index: index,
	      value: value,
	      viewBox: _Label["default"].parseViewBox((0, _isNil2["default"])(clockWise) ? entry : _objectSpread({}, entry, {
	        clockWise: clockWise
	      })),
	      key: "label-".concat(index) // eslint-disable-line react/no-array-index-key
	
	    }));
	  }));
	}
	
	LabelList.propTypes = propTypes;
	LabelList.displayName = 'LabelList';
	
	var parseLabelList = function parseLabelList(label, data) {
	  if (!label) {
	    return null;
	  }
	
	  if (label === true) {
	    return _react["default"].createElement(LabelList, {
	      key: "labelList-implicit",
	      data: data
	    });
	  }
	
	  if (_react["default"].isValidElement(label) || (0, _isFunction2["default"])(label)) {
	    return _react["default"].createElement(LabelList, {
	      key: "labelList-implicit",
	      data: data,
	      content: label
	    });
	  }
	
	  if ((0, _isObject2["default"])(label)) {
	    return _react["default"].createElement(LabelList, _extends({
	      data: data
	    }, label, {
	      key: "labelList-implicit"
	    }));
	  }
	
	  return null;
	};
	
	var renderCallByParent = function renderCallByParent(parentProps, data) {
	  var ckeckPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  if (!parentProps || !parentProps.children && ckeckPropsLabel && !parentProps.label) {
	    return null;
	  }
	
	  var children = parentProps.children;
	  var explicitChilren = (0, _ReactUtils.findAllByType)(children, LabelList).map(function (child, index) {
	    return (0, _react.cloneElement)(child, {
	      data: data,
	      key: "labelList-".concat(index)
	    });
	  });
	
	  if (!ckeckPropsLabel) {
	    return explicitChilren;
	  }
	
	  var implicitLabelList = parseLabelList(parentProps.label, data);
	  return [implicitLabelList].concat(_toConsumableArray(explicitChilren));
	};
	
	LabelList.renderCallByParent = renderCallByParent;
	LabelList.defaultProps = defaultProps;
	var _default = LabelList;
	exports["default"] = _default;

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.clock2 = exports.infinito = exports.noAvailableRecordIcon = exports.noAvailableSVG = exports.noAvailableIcon = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var noAvailableIcon = exports.noAvailableIcon = _react2.default.createElement(
		"svg",
		{ version: "1.1", className: "manualCallSvg", id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
			width: "100%", height: "100%", viewBox: "0 0 40 40", enableBackground: "new 0 0 40 40", xmlSpace: "preserve" },
		_react2.default.createElement(
			"g",
			null,
			_react2.default.createElement(
				"linearGradient",
				{ id: "SVGID_1_", gradientUnits: "userSpaceOnUse", x1: "19.5005", y1: "39.626", x2: "19.5005", y2: "8.0401" },
				_react2.default.createElement("stop", { offset: "0", style: { stopColor: "#FFFFFF" } }),
				_react2.default.createElement("stop", { offset: "1", style: { stopColor: "#F2F2F2" } })
			),
			_react2.default.createElement("path", { fill: "url(#SVGID_1_)", d: "M20.164,31.001l-3.619-0.733c-0.746-0.15-1.48,0.191-1.869,0.799\r c-1.109-0.402-2.033-1.022-2.768-1.764C11.51,28.898,11.199,29,10.955,28h0.094C11.596,28,12,27.412,12,26.863v-8.379\r C12,17.935,11.596,18,11.049,18H9.65c-0.158,0-0.299-0.189-0.42-0.131c0.203-1.75,0.668-3.774,1.639-5.439\r c0.459,0.002,0.928-0.245,1.26-0.715c3.408-4.822,11.834-4.85,15.242-0.029c0.332,0.47,0.799,0.646,1.26,0.645\r c0.959,1.65,1.424,3.765,1.631,5.505C30.146,17.803,30.029,18,29.916,18H28.52C27.971,18,27,17.935,27,18.484v3.059\r c0-0.13,0.973-0.207,1.537-0.207c1.758,0,3.463,0.667,4.463,1.756V21.26c0-1.159-0.146-2.09-1.307-2.428\r c-0.004-0.072,0.133-0.143,0.129-0.215c-0.174-2.742-0.765-5.139-1.858-7.048c0.252-0.396,0.323-0.903-0.044-1.423\r c-2.418-3.416-6.053-4.985-10.188-5.029c-4.109-0.043-7.818,1.664-10.197,5.029c-0.367,0.521-0.327,1.029-0.075,1.423\r c-1.094,1.91-1.751,4.306-1.923,7.048c-0.012,0.161-0.148,0.32-0.154,0.477C6.666,19.543,6,20.328,6,21.26v2.827\r c0,1.397,1.33,2.475,2.551,2.562c0.02,0.087,0.107,0.176,0.131,0.267c0.01,0.265,0.13,0.552,0.28,0.778\r c0.332,0.88,0.892,1.858,1.772,2.757c0.949,0.967,2.15,1.695,3.578,2.184c0.084,0.755,0.65,1.405,1.432,1.564l3.622,0.733\r c0.969,0.195,1.919-0.436,2.116-1.403l0.084-0.411C21.762,32.15,21.133,31.197,20.164,31.001z" }),
			_react2.default.createElement("circle", { fill: "#FF0000", cx: "29.151", cy: "28.172", r: "5.47" }),
			_react2.default.createElement("rect", { x: "28.466", y: "24.187", transform: "matrix(0.7082 0.706 -0.706 0.7082 28.5988 -12.2775)", fill: "#FFFFFF", width: "1.371", height: "8.54" })
		),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null)
	);
	
	var noAvailableSVG = exports.noAvailableSVG = _react2.default.createElement(
		"svg",
		{ version: "1.1", id: "Layer_1", className: "workBarItem", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
			width: "100%", height: "100%", viewBox: "0 0 40 40", enableBackground: "new 0 0 40 40", xmlSpace: "preserve" },
		_react2.default.createElement(
			"g",
			null,
			_react2.default.createElement(
				"linearGradient",
				{ className: "workBarItem", id: "SVGID_1_", gradientUnits: "userSpaceOnUse", x1: "19.5005", y1: "39.626", x2: "19.5005", y2: "8.0401" },
				_react2.default.createElement("stop", { offset: "0", style: { stopColor: "#FFFFFF" } }),
				_react2.default.createElement("stop", { offset: "1", style: { stopColor: "#F2F2F2" } })
			),
			_react2.default.createElement("path", { className: "workBarItem", fill: "url(#SVGID_1_)", d: "M20.164,31.001l-3.619-0.733c-0.746-0.15-1.48,0.191-1.869,0.799\r c-1.109-0.402-2.033-1.022-2.768-1.764C11.51,28.898,11.199,29,10.955,28h0.094C11.596,28,12,27.412,12,26.863v-8.379\r C12,17.935,11.596,18,11.049,18H9.65c-0.158,0-0.299-0.189-0.42-0.131c0.203-1.75,0.668-3.774,1.639-5.439\r c0.459,0.002,0.928-0.245,1.26-0.715c3.408-4.822,11.834-4.85,15.242-0.029c0.332,0.47,0.799,0.646,1.26,0.645\r c0.959,1.65,1.424,3.765,1.631,5.505C30.146,17.803,30.029,18,29.916,18H28.52C27.971,18,27,17.935,27,18.484v3.059\r c0-0.13,0.973-0.207,1.537-0.207c1.758,0,3.463,0.667,4.463,1.756V21.26c0-1.159-0.146-2.09-1.307-2.428\r c-0.004-0.072,0.133-0.143,0.129-0.215c-0.174-2.742-0.765-5.139-1.858-7.048c0.252-0.396,0.323-0.903-0.044-1.423\r c-2.418-3.416-6.053-4.985-10.188-5.029c-4.109-0.043-7.818,1.664-10.197,5.029c-0.367,0.521-0.327,1.029-0.075,1.423\r c-1.094,1.91-1.751,4.306-1.923,7.048c-0.012,0.161-0.148,0.32-0.154,0.477C6.666,19.543,6,20.328,6,21.26v2.827\r c0,1.397,1.33,2.475,2.551,2.562c0.02,0.087,0.107,0.176,0.131,0.267c0.01,0.265,0.13,0.552,0.28,0.778\r c0.332,0.88,0.892,1.858,1.772,2.757c0.949,0.967,2.15,1.695,3.578,2.184c0.084,0.755,0.65,1.405,1.432,1.564l3.622,0.733\r c0.969,0.195,1.919-0.436,2.116-1.403l0.084-0.411C21.762,32.15,21.133,31.197,20.164,31.001z" }),
			_react2.default.createElement("circle", { className: "workBarItem", fill: "#FF0000", cx: "29.151", cy: "28.172", r: "5.47" }),
			_react2.default.createElement("rect", { fill: "#FFFFFF", className: "workBarItemTransparent", x: "28.466", y: "24.187", transform: "matrix(0.7082 0.706 -0.706 0.7082 28.5988 -12.2775)", width: "1.371", height: "8.54" })
		)
	);
	
	var noAvailableRecordIcon = exports.noAvailableRecordIcon = _react2.default.createElement(
		"svg",
		{ version: "1.1", className: "workBarItem", id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
			width: "100%", height: "100%", viewBox: "0 0 40 40", enableBackground: "new 0 0 40 40", xmlSpace: "preserve" },
		_react2.default.createElement(
			"g",
			null,
			_react2.default.createElement(
				"linearGradient",
				{ className: "workBarItem", id: "SVGID_1_", gradientUnits: "userSpaceOnUse", x1: "19.5005", y1: "36.9004", x2: "19.5005", y2: "5.9492" },
				_react2.default.createElement("stop", { offset: "0", style: { stopColor: "#F2F2F2" } }),
				_react2.default.createElement("stop", { offset: "1", style: { stopColor: "#FFFFFF" } })
			),
			_react2.default.createElement("path", { className: "workBarItem", fill: "url(#SVGID_1_)", d: "M19.962,30.947l-3.629-0.735c-0.748-0.151-1.485,0.19-1.874,0.8\r c-1.113-0.402-2.04-0.994-2.775-1.736C11.282,28.87,10.974,29,10.727,28h0.093C11.368,28,12,27.348,12,26.797v-8.403\r C12,17.842,11.368,18,10.819,18H9.418c-0.157,0-0.299-0.234-0.422-0.178c0.205-1.754,0.672-3.807,1.644-5.478\r c0.462,0.002,0.931-0.258,1.265-0.729c3.417-4.834,11.867-4.868,15.285-0.034c0.334,0.472,0.803,0.646,1.265,0.644\r c0.96,1.656,1.428,3.82,1.636,5.565C29.975,17.758,29.857,18,29.742,18h-1.4C27.791,18,27,17.842,27,18.394v2.735\r c1-0.094,0.825-0.145,1.315-0.145c1.852,0,3.685,0.719,4.685,1.885v-1.692c0-1.161-0.229-2.095-1.392-2.435\r c-0.004-0.071,0.091-0.143,0.087-0.215c-0.174-2.749-0.785-5.154-1.881-7.068c0.251-0.396,0.31-0.906-0.058-1.426\r c-2.424-3.428-6.076-5-10.223-5.045c-4.121-0.043-7.841,1.669-10.229,5.045c-0.367,0.521-0.327,1.031-0.079,1.426\r c-1.094,1.916-1.753,4.319-1.927,7.068c-0.01,0.162-0.027,0.321-0.033,0.479C6.547,19.456,6,20.243,6,21.177v2.837\r c0,1.4,1.213,2.48,2.436,2.568c0.021,0.088,0.047,0.176,0.072,0.268c0.01,0.265,0.102,0.553,0.252,0.779\r c0.333,0.883,0.878,1.864,1.762,2.766c0.951,0.97,2.149,1.7,3.58,2.189c0.085,0.757,0.648,1.41,1.434,1.569l3.629,0.735\r c0.97,0.195,1.928-0.437,2.123-1.407l0.084-0.412C21.566,32.1,20.934,31.145,19.962,30.947z" }),
			_react2.default.createElement(
				"radialGradient",
				{ className: "workBarItem", id: "SVGID_256_", cx: "29.0098", cy: "28.5781", r: "9.5765", gradientUnits: "userSpaceOnUse" },
				_react2.default.createElement("stop", { offset: "0", style: { stopColor: "#00D6FF" } }),
				_react2.default.createElement("stop", { offset: "0.3193", style: { stopColor: "#00C1FF" } }),
				_react2.default.createElement("stop", { offset: "0.9782", style: { stopColor: "#008AFF" } }),
				_react2.default.createElement("stop", { offset: "1", style: { stopColor: "#0088FF" } })
			),
			_react2.default.createElement("path", { className: "workBarItem", fill: "url(#SVGID_256_)", d: "M28.77,22.543c-3.102,0-5.613,2.518-5.613,5.619s2.512,5.619,5.613,5.619\r c3.108,0,5.625-2.518,5.625-5.619S31.878,22.543,28.77,22.543z" }),
			_react2.default.createElement("path", { className: "workBarItemTransparent", fill: "#FFFFFF", d: "M29.088,25.305H28.15v3.746l3.278,1.968l0.469-0.769l-2.81-1.667V25.305z" })
		),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null)
	);
	
	var infinito = exports.infinito = _react2.default.createElement(
		"svg",
		{ version: "1.1", id: "Capa_1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
			viewBox: "0 0 14 12", enableBackground: "new 0 0 14 12", xmlSpace: "preserve" },
		_react2.default.createElement("path", { d: "M10.7,2.7c-0.2,0-0.4,0-0.6,0.1C9.7,2.8,9.3,2.9,8.9,3c-1.1,0.5-2,1.4-2.6,2.8c-0.4,0.9-1,1.6-1.7,1.9C4,8,3.5,8,3.4,8\r\nc0,0-0.1,0-0.1,0c-1.1,0-2-0.9-2-2s0.9-2,2-2s2.1,0.9,2.1,2c0,0,0,0,0,0.1c0.1-0.2,0.2-0.3,0.3-0.5c0.2-0.4,0.4-0.8,0.6-1.1\r\nc-0.6-1.1-1.7-1.8-3-1.8C1.5,2.7,0,4.2,0,6c0,1.8,1.5,3.3,3.3,3.3c0.1,0,0.2,0,0.3,0C4,9.3,4.5,9.2,5.1,9c1-0.5,1.8-1.4,2.4-2.6l0,0\r\nc0.4-1,1.1-1.7,1.9-2.1C9.9,4.1,10.3,4,10.6,4c1.1,0,2,0.9,2,2c0,1.1-0.9,2-2,2S8.4,7.1,8.4,6c0,0,0,0,0,0C8.3,6.2,8.2,6.4,8.1,6.6\r\nl0,0C8,6.9,7.8,7.2,7.7,7.5c0.5,1.1,1.7,1.9,3,1.9C12.5,9.3,14,7.8,14,6C14,4.2,12.5,2.7,10.7,2.7z" })
	);
	
	var clock2 = exports.clock2 = _react2.default.createElement(
		"svg",
		{ version: "1.1", id: "Capa_1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
			viewBox: "0 0 12 12", enableBackground: "new 0 0 12 12", xmlSpace: "preserve" },
		_react2.default.createElement(
			"g",
			null,
			_react2.default.createElement("path", { d: "M3.3,2.1L2.4,1.2l0,0C0.9,2.3,0,4,0,6c0,3.3,2.7,6,6,6s6-2.7,6-6S9.3,0,6,0H5.3v2.7h1.3V1.4c2.3,0.3,4,2.3,4,4.6\r c0,2.6-2.1,4.7-4.7,4.7S1.3,8.6,1.3,6c0-1.1,0.4-2.1,1.1-2.9C2.4,3,2.7,2.5,3.3,2.1z" }),
			_react2.default.createElement("path", { d: "M6.4,5.1L3.7,3.5l1.7,2.6c0.1,0.1,0.3,0.2,0.5,0.2c0.4,0,0.7-0.3,0.7-0.7C6.7,5.5,6.5,5.3,6.4,5.1z" })
		)
	);

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.consultingApp = consultingApp;
	exports.noConsultingApp = noConsultingApp;
	
	var _constants = __webpack_require__(10);
	
	function consultingApp() {
	  return {
	    type: _constants.CONSULTING_WINDOW.CONSULTING
	  };
	}
	
	function noConsultingApp() {
	  return {
	    type: _constants.CONSULTING_WINDOW.NO_CONSULTING
	  };
	}

/***/ },
/* 116 */
[2629, 196],
/* 117 */
[2642, 143, 36, 77, 57, 34],
/* 118 */
[2663, 36],
/* 119 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = _default;
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
	function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	function _default(classes) {
	  return Object.entries(classes).filter(function (_ref) {
	    var _ref2 = _slicedToArray(_ref, 2),
	      className = _ref2[0],
	      condition = _ref2[1];
	    return condition;
	  }).map(function (_ref3) {
	    var _ref4 = _slicedToArray(_ref3, 2),
	      className = _ref4[0],
	      condition = _ref4[1];
	    return className;
	  }).join(' ').toString();
	}

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInCalendarDays;
	
	var _index = _interopRequireDefault(__webpack_require__(107));
	
	var _index2 = _interopRequireDefault(__webpack_require__(211));
	
	var _index3 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_DAY = 86400000;
	/**
	 * @name differenceInCalendarDays
	 * @category Day Helpers
	 * @summary Get the number of calendar days between the given dates.
	 *
	 * @description
	 * Get the number of calendar days between the given dates. This means that the times are removed
	 * from the dates and then the difference in days is calculated.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of calendar days
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many calendar days are between
	 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
	 * const result = differenceInCalendarDays(
	 *   new Date(2012, 6, 2, 0, 0),
	 *   new Date(2011, 6, 2, 23, 0)
	 * )
	 * //=> 366
	 * // How many calendar days are between
	 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
	 * const result = differenceInCalendarDays(
	 *   new Date(2011, 6, 3, 0, 1),
	 *   new Date(2011, 6, 2, 23, 59)
	 * )
	 * //=> 1
	 */
	
	function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
	  (0, _index3.default)(2, arguments);
	  var startOfDayLeft = (0, _index2.default)(dirtyDateLeft);
	  var startOfDayRight = (0, _index2.default)(dirtyDateRight);
	  var timestampLeft = startOfDayLeft.getTime() - (0, _index.default)(startOfDayLeft);
	  var timestampRight = startOfDayRight.getTime() - (0, _index.default)(startOfDayRight); // Round the number of days to the nearest integer
	  // because the number of milliseconds in a day is not constant
	  // (e.g. it's different in the day of the daylight saving time clock shift)
	
	  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
	}
	
	module.exports = exports.default;

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = nextDay;
	
	var _index = _interopRequireDefault(__webpack_require__(95));
	
	var _index2 = _interopRequireDefault(__webpack_require__(210));
	
	var _index3 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name nextDay
	 * @category Weekday Helpers
	 * @summary When is the next day of the week?
	 *
	 * @description
	 * When is the next day of the week? 0-6 the day of the week, 0 represents Sunday.
	 *
	 * @param {Date | number} date - the date to check
	 * @param {Day} day - day of the week
	 * @returns {Date} - the date is the next day of week
	 * @throws {TypeError} - 2 arguments required
	 *
	 * @example
	 * // When is the next Monday after Mar, 20, 2020?
	 * const result = nextDay(new Date(2020, 2, 20), 1)
	 * //=> Mon Mar 23 2020 00:00:00
	 *
	 * @example
	 * // When is the next Tuesday after Mar, 21, 2020?
	 * const result = nextDay(new Date(2020, 2, 21), 2)
	 * //=> Tue Mar 24 2020 00:00:00
	 */
	function nextDay(date, day) {
	  (0, _index3.default)(2, arguments);
	  var delta = day - (0, _index2.default)(date);
	  if (delta <= 0) delta += 7;
	  return (0, _index.default)(date, delta);
	}
	
	module.exports = exports.default;

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = previousDay;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	var _index2 = _interopRequireDefault(__webpack_require__(210));
	
	var _index3 = _interopRequireDefault(__webpack_require__(214));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name previousDay
	 * @category Weekday Helpers
	 * @summary When is the previous day of the week?
	 *
	 * @description
	 * When is the previous day of the week? 0-6 the day of the week, 0 represents Sunday.
	 *
	 * @param {Date | number} date - the date to check
	 * @param {number} day - day of the week
	 * @returns {Date} - the date is the previous day of week
	 * @throws {TypeError} - 2 arguments required
	 *
	 * @example
	 * // When is the previous Monday before Mar, 20, 2020?
	 * const result = previousDay(new Date(2020, 2, 20), 1)
	 * //=> Mon Mar 16 2020 00:00:00
	 *
	 * @example
	 * // When is the previous Tuesday before Mar, 21, 2020?
	 * const result = previousDay(new Date(2020, 2, 21), 2)
	 * //=> Tue Mar 17 2020 00:00:00
	 */
	function previousDay(date, day) {
	  (0, _index.default)(2, arguments);
	  var delta = (0, _index2.default)(date) - day;
	  if (delta <= 0) delta += 7;
	  return (0, _index3.default)(date, delta);
	}
	
	module.exports = exports.default;

/***/ },
/* 123 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(178),
	    getRawTag = __webpack_require__(2121),
	    objectToString = __webpack_require__(2149);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ },
/* 126 */
[2774, 2327, 2328, 961, 960],
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isObject2 = _interopRequireDefault(__webpack_require__(72));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(38));
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(71));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _Text = _interopRequireDefault(__webpack_require__(152));
	
	var _ReactUtils = __webpack_require__(29);
	
	var _DataUtils = __webpack_require__(39);
	
	var _PolarUtils = __webpack_require__(86);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var cartesianViewBoxShape = _propTypes["default"].shape({
	  x: _propTypes["default"].number,
	  y: _propTypes["default"].number,
	  width: _propTypes["default"].number,
	  height: _propTypes["default"].number
	});
	
	var polarViewBoxShape = _propTypes["default"].shape({
	  cx: _propTypes["default"].number,
	  cy: _propTypes["default"].number,
	  innerRadius: _propTypes["default"].number,
	  outerRadius: _propTypes["default"].number,
	  startAngle: _propTypes["default"].number,
	  endAngle: _propTypes["default"].number
	});
	
	var propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  viewBox: _propTypes["default"].oneOfType([cartesianViewBoxShape, polarViewBoxShape]),
	  formatter: _propTypes["default"].func,
	  value: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  offset: _propTypes["default"].number,
	  position: _propTypes["default"].oneOf(['top', 'left', 'right', 'bottom', 'inside', 'outside', 'insideLeft', 'insideRight', 'insideTop', 'insideBottom', 'insideTopLeft', 'insideBottomLeft', 'insideTopRight', 'insideBottomRight', 'insideStart', 'insideEnd', 'end', 'center', 'centerTop', 'centerBottom']),
	  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),
	  className: _propTypes["default"].string,
	  content: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].func])
	});
	
	var defaultProps = {
	  offset: 5
	};
	
	var getLabel = function getLabel(props) {
	  var value = props.value,
	      formatter = props.formatter;
	  var label = (0, _isNil2["default"])(props.children) ? value : props.children;
	
	  if ((0, _isFunction2["default"])(formatter)) {
	    return formatter(label);
	  }
	
	  return label;
	};
	
	var getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
	  var sign = (0, _DataUtils.mathSign)(endAngle - startAngle);
	  var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
	  return sign * deltaAngle;
	};
	
	var renderRadialLabel = function renderRadialLabel(labelProps, label, attrs) {
	  var position = labelProps.position,
	      viewBox = labelProps.viewBox,
	      offset = labelProps.offset,
	      className = labelProps.className;
	  var cx = viewBox.cx,
	      cy = viewBox.cy,
	      innerRadius = viewBox.innerRadius,
	      outerRadius = viewBox.outerRadius,
	      startAngle = viewBox.startAngle,
	      endAngle = viewBox.endAngle,
	      clockWise = viewBox.clockWise;
	  var radius = (innerRadius + outerRadius) / 2;
	  var deltaAngle = getDeltaAngle(startAngle, endAngle);
	  var sign = deltaAngle >= 0 ? 1 : -1;
	  var labelAngle, direction;
	
	  if (position === 'insideStart') {
	    labelAngle = startAngle + sign * offset;
	    direction = clockWise;
	  } else if (position === 'insideEnd') {
	    labelAngle = endAngle - sign * offset;
	    direction = !clockWise;
	  } else if (position === 'end') {
	    labelAngle = endAngle + sign * offset;
	    direction = clockWise;
	  }
	
	  direction = deltaAngle <= 0 ? direction : !direction;
	  var startPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, radius, labelAngle);
	  var endPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, radius, labelAngle + (direction ? 1 : -1) * 359);
	  var path = "M".concat(startPoint.x, ",").concat(startPoint.y, "\n    A").concat(radius, ",").concat(radius, ",0,1,").concat(direction ? 0 : 1, ",\n    ").concat(endPoint.x, ",").concat(endPoint.y);
	  var id = (0, _isNil2["default"])(labelProps.id) ? (0, _DataUtils.uniqueId)('recharts-radial-line-') : labelProps.id;
	  return _react["default"].createElement("text", _extends({}, attrs, {
	    dominantBaseline: "central",
	    className: (0, _classnames["default"])('recharts-radial-bar-label', className)
	  }), _react["default"].createElement("defs", null, _react["default"].createElement("path", {
	    id: id,
	    d: path
	  })), _react["default"].createElement("textPath", {
	    xlinkHref: "#".concat(id)
	  }, label));
	};
	
	var getAttrsOfPolarLabel = function getAttrsOfPolarLabel(props) {
	  var viewBox = props.viewBox,
	      offset = props.offset,
	      position = props.position;
	  var cx = viewBox.cx,
	      cy = viewBox.cy,
	      innerRadius = viewBox.innerRadius,
	      outerRadius = viewBox.outerRadius,
	      startAngle = viewBox.startAngle,
	      endAngle = viewBox.endAngle;
	  var midAngle = (startAngle + endAngle) / 2;
	
	  if (position === 'outside') {
	    var _polarToCartesian = (0, _PolarUtils.polarToCartesian)(cx, cy, outerRadius + offset, midAngle),
	        _x = _polarToCartesian.x,
	        _y = _polarToCartesian.y;
	
	    return {
	      x: _x,
	      y: _y,
	      textAnchor: _x >= cx ? 'start' : 'end',
	      verticalAnchor: 'middle'
	    };
	  }
	
	  if (position === 'center') {
	    return {
	      x: cx,
	      y: cy,
	      textAnchor: 'middle',
	      verticalAnchor: 'middle'
	    };
	  }
	
	  if (position === 'centerTop') {
	    return {
	      x: cx,
	      y: cy,
	      textAnchor: 'middle',
	      verticalAnchor: 'start'
	    };
	  }
	
	  if (position === 'centerBottom') {
	    return {
	      x: cx,
	      y: cy,
	      textAnchor: 'middle',
	      verticalAnchor: 'end'
	    };
	  }
	
	  var r = (innerRadius + outerRadius) / 2;
	
	  var _polarToCartesian2 = (0, _PolarUtils.polarToCartesian)(cx, cy, r, midAngle),
	      x = _polarToCartesian2.x,
	      y = _polarToCartesian2.y;
	
	  return {
	    x: x,
	    y: y,
	    textAnchor: 'middle',
	    verticalAnchor: 'middle'
	  };
	};
	
	var getAttrsOfCartesianLabel = function getAttrsOfCartesianLabel(props) {
	  var viewBox = props.viewBox,
	      offset = props.offset,
	      position = props.position;
	  var x = viewBox.x,
	      y = viewBox.y,
	      width = viewBox.width,
	      height = viewBox.height;
	  var sign = height >= 0 ? 1 : -1;
	
	  if (position === 'top') {
	    return {
	      x: x + width / 2,
	      y: y - sign * offset,
	      textAnchor: 'middle',
	      verticalAnchor: sign > 0 ? 'end' : 'start'
	    };
	  }
	
	  if (position === 'bottom') {
	    return {
	      x: x + width / 2,
	      y: y + height + sign * offset,
	      textAnchor: 'middle',
	      verticalAnchor: 'start'
	    };
	  }
	
	  if (position === 'left') {
	    return {
	      x: x - offset,
	      y: y + height / 2,
	      textAnchor: 'end',
	      verticalAnchor: 'middle'
	    };
	  }
	
	  if (position === 'right') {
	    return {
	      x: x + width + offset,
	      y: y + height / 2,
	      textAnchor: 'start',
	      verticalAnchor: 'middle'
	    };
	  }
	
	  if (position === 'insideLeft') {
	    return {
	      x: x + offset,
	      y: y + height / 2,
	      textAnchor: 'start',
	      verticalAnchor: 'middle'
	    };
	  }
	
	  if (position === 'insideRight') {
	    return {
	      x: x + width - offset,
	      y: y + height / 2,
	      textAnchor: 'end',
	      verticalAnchor: 'middle'
	    };
	  }
	
	  if (position === 'insideTop') {
	    return {
	      x: x + width / 2,
	      y: y + sign * offset,
	      textAnchor: 'middle',
	      verticalAnchor: 'start'
	    };
	  }
	
	  if (position === 'insideBottom') {
	    return {
	      x: x + width / 2,
	      y: y + height - sign * offset,
	      textAnchor: 'middle',
	      verticalAnchor: 'end'
	    };
	  }
	
	  if (position === 'insideTopLeft') {
	    return {
	      x: x + offset,
	      y: y + sign * offset,
	      textAnchor: 'start',
	      verticalAnchor: 'start'
	    };
	  }
	
	  if (position === 'insideTopRight') {
	    return {
	      x: x + width - offset,
	      y: y + sign * offset,
	      textAnchor: 'end',
	      verticalAnchor: 'start'
	    };
	  }
	
	  if (position === 'insideBottomLeft') {
	    return {
	      x: x + offset,
	      y: y + height - sign * offset,
	      textAnchor: 'start',
	      verticalAnchor: 'end'
	    };
	  }
	
	  if (position === 'insideBottomRight') {
	    return {
	      x: x + width - offset,
	      y: y + height - sign * offset,
	      textAnchor: 'end',
	      verticalAnchor: 'end'
	    };
	  }
	
	  if ((0, _isObject2["default"])(position) && ((0, _DataUtils.isNumber)(position.x) || (0, _DataUtils.isPercent)(position.x)) && ((0, _DataUtils.isNumber)(position.y) || (0, _DataUtils.isPercent)(position.y))) {
	    return {
	      x: x + (0, _DataUtils.getPercentValue)(position.x, width),
	      y: y + (0, _DataUtils.getPercentValue)(position.y, height),
	      textAnchor: 'end',
	      verticalAnchor: 'end'
	    };
	  }
	
	  return {
	    x: x + width / 2,
	    y: y + height / 2,
	    textAnchor: 'middle',
	    verticalAnchor: 'middle'
	  };
	};
	
	var isPolar = function isPolar(viewBox) {
	  return (0, _DataUtils.isNumber)(viewBox.cx);
	};
	
	function Label(props) {
	  var viewBox = props.viewBox,
	      position = props.position,
	      value = props.value,
	      children = props.children,
	      content = props.content,
	      _props$className = props.className,
	      className = _props$className === void 0 ? '' : _props$className;
	
	  if (!viewBox || (0, _isNil2["default"])(value) && (0, _isNil2["default"])(children) && !(0, _react.isValidElement)(content) && !(0, _isFunction2["default"])(content)) {
	    return null;
	  }
	
	  if ((0, _react.isValidElement)(content)) {
	    return (0, _react.cloneElement)(content, props);
	  }
	
	  var label;
	
	  if ((0, _isFunction2["default"])(content)) {
	    label = content(props);
	
	    if ((0, _react.isValidElement)(label)) {
	      return label;
	    }
	  } else {
	    label = getLabel(props);
	  }
	
	  var isPolarLabel = isPolar(viewBox);
	  var attrs = (0, _ReactUtils.getPresentationAttributes)(props);
	  var events = (0, _ReactUtils.filterEventAttributes)(props);
	
	  if (isPolarLabel && (position === 'insideStart' || position === 'insideEnd' || position === 'end')) {
	    return renderRadialLabel(props, label, attrs);
	  }
	
	  var positionAttrs = isPolarLabel ? getAttrsOfPolarLabel(props) : getAttrsOfCartesianLabel(props);
	  return _react["default"].createElement(_Text["default"], _extends({
	    className: (0, _classnames["default"])('recharts-label', className)
	  }, attrs, positionAttrs, events), label);
	}
	
	Label.displayName = 'Label';
	Label.defaultProps = defaultProps;
	Label.propTypes = propTypes;
	
	var parseViewBox = function parseViewBox(props) {
	  var cx = props.cx,
	      cy = props.cy,
	      angle = props.angle,
	      startAngle = props.startAngle,
	      endAngle = props.endAngle,
	      r = props.r,
	      radius = props.radius,
	      innerRadius = props.innerRadius,
	      outerRadius = props.outerRadius,
	      x = props.x,
	      y = props.y,
	      top = props.top,
	      left = props.left,
	      width = props.width,
	      height = props.height,
	      clockWise = props.clockWise;
	
	  if ((0, _DataUtils.isNumber)(width) && (0, _DataUtils.isNumber)(height)) {
	    if ((0, _DataUtils.isNumber)(x) && (0, _DataUtils.isNumber)(y)) {
	      return {
	        x: x,
	        y: y,
	        width: width,
	        height: height
	      };
	    }
	
	    if ((0, _DataUtils.isNumber)(top) && (0, _DataUtils.isNumber)(left)) {
	      return {
	        x: top,
	        y: left,
	        width: width,
	        height: height
	      };
	    }
	  }
	
	  if ((0, _DataUtils.isNumber)(x) && (0, _DataUtils.isNumber)(y)) {
	    return {
	      x: x,
	      y: y,
	      width: 0,
	      height: 0
	    };
	  }
	
	  if ((0, _DataUtils.isNumber)(cx) && (0, _DataUtils.isNumber)(cy)) {
	    return {
	      cx: cx,
	      cy: cy,
	      startAngle: startAngle || angle || 0,
	      endAngle: endAngle || angle || 0,
	      innerRadius: innerRadius || 0,
	      outerRadius: outerRadius || radius || r || 0,
	      clockWise: clockWise
	    };
	  }
	
	  if (props.viewBox) {
	    return props.viewBox;
	  }
	
	  return {};
	};
	
	var parseLabel = function parseLabel(label, viewBox) {
	  if (!label) {
	    return null;
	  }
	
	  if (label === true) {
	    return _react["default"].createElement(Label, {
	      key: "label-implicit",
	      viewBox: viewBox
	    });
	  }
	
	  if ((0, _DataUtils.isNumOrStr)(label)) {
	    return _react["default"].createElement(Label, {
	      key: "label-implicit",
	      viewBox: viewBox,
	      value: label
	    });
	  }
	
	  if ((0, _react.isValidElement)(label)) {
	    if (label.type === Label) {
	      return (0, _react.cloneElement)(label, {
	        key: 'label-implicit',
	        viewBox: viewBox
	      });
	    }
	
	    return _react["default"].createElement(Label, {
	      key: "label-implicit",
	      content: label,
	      viewBox: viewBox
	    });
	  }
	
	  if ((0, _isFunction2["default"])(label)) {
	    return _react["default"].createElement(Label, {
	      key: "label-implicit",
	      content: label,
	      viewBox: viewBox
	    });
	  }
	
	  if ((0, _isObject2["default"])(label)) {
	    return _react["default"].createElement(Label, _extends({
	      viewBox: viewBox
	    }, label, {
	      key: "label-implicit"
	    }));
	  }
	
	  return null;
	};
	
	var renderCallByParent = function renderCallByParent(parentProps, viewBox) {
	  var ckeckPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  if (!parentProps || !parentProps.children && ckeckPropsLabel && !parentProps.label) {
	    return null;
	  }
	
	  var children = parentProps.children;
	  var parentViewBox = parseViewBox(parentProps);
	  var explicitChilren = (0, _ReactUtils.findAllByType)(children, Label).map(function (child, index) {
	    return (0, _react.cloneElement)(child, {
	      viewBox: viewBox || parentViewBox,
	      key: "label-".concat(index)
	    });
	  });
	
	  if (!ckeckPropsLabel) {
	    return explicitChilren;
	  }
	
	  var implicitLabel = parseLabel(parentProps.label, viewBox || parentViewBox);
	  return [implicitLabel].concat(_toConsumableArray(explicitChilren));
	};
	
	Label.parseViewBox = parseViewBox;
	Label.renderCallByParent = renderCallByParent;
	var _default = Label;
	exports["default"] = _default;

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LabeledScaleHelper = exports.ScaleHelper = exports.rectWithCoords = exports.rectWithPoints = exports.formatAxisMap = void 0;
	
	var _every2 = _interopRequireDefault(__webpack_require__(752));
	
	var _mapValues2 = _interopRequireDefault(__webpack_require__(2174));
	
	var _ChartUtils = __webpack_require__(66);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/**
	 * Calculate the scale function, position, width, height of axes
	 * @param  {Object} props     Latest props
	 * @param  {Object} axisMap   The configuration of axes
	 * @param  {Object} offset    The offset of main part in the svg element
	 * @param  {String} axisType  The type of axes, x-axis or y-axis
	 * @param  {String} chartName The name of chart
	 * @return {Object} Configuration
	 */
	var formatAxisMap = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
	  var width = props.width,
	      height = props.height,
	      layout = props.layout;
	  var ids = Object.keys(axisMap);
	  var steps = {
	    left: offset.left,
	    leftMirror: offset.left,
	    right: width - offset.right,
	    rightMirror: width - offset.right,
	    top: offset.top,
	    topMirror: offset.top,
	    bottom: height - offset.bottom,
	    bottomMirror: height - offset.bottom
	  };
	  return ids.reduce(function (result, id) {
	    var axis = axisMap[id];
	    var orientation = axis.orientation,
	        domain = axis.domain,
	        _axis$padding = axis.padding,
	        padding = _axis$padding === void 0 ? {} : _axis$padding,
	        mirror = axis.mirror,
	        reversed = axis.reversed;
	    var offsetKey = "".concat(orientation).concat(mirror ? 'Mirror' : '');
	    var range, x, y, needSpace;
	
	    if (axisType === 'xAxis') {
	      range = [offset.left + (padding.left || 0), offset.left + offset.width - (padding.right || 0)];
	    } else if (axisType === 'yAxis') {
	      range = layout === 'horizontal' ? [offset.top + offset.height - (padding.bottom || 0), offset.top + (padding.top || 0)] : [offset.top + (padding.top || 0), offset.top + offset.height - (padding.bottom || 0)];
	    } else {
	      range = axis.range;
	    }
	
	    if (reversed) {
	      range = [range[1], range[0]];
	    }
	
	    var _parseScale = (0, _ChartUtils.parseScale)(axis, chartName),
	        scale = _parseScale.scale,
	        realScaleType = _parseScale.realScaleType;
	
	    scale.domain(domain).range(range);
	    (0, _ChartUtils.checkDomainOfScale)(scale);
	    var ticks = (0, _ChartUtils.getTicksOfScale)(scale, _objectSpread({}, axis, {
	      realScaleType: realScaleType
	    }));
	
	    if (axisType === 'xAxis') {
	      needSpace = orientation === 'top' && !mirror || orientation === 'bottom' && mirror;
	      x = offset.left;
	      y = steps[offsetKey] - needSpace * axis.height;
	    } else if (axisType === 'yAxis') {
	      needSpace = orientation === 'left' && !mirror || orientation === 'right' && mirror;
	      x = steps[offsetKey] - needSpace * axis.width;
	      y = offset.top;
	    }
	
	    var finalAxis = _objectSpread({}, axis, {}, ticks, {
	      realScaleType: realScaleType,
	      x: x,
	      y: y,
	      scale: scale,
	      width: axisType === 'xAxis' ? offset.width : axis.width,
	      height: axisType === 'yAxis' ? offset.height : axis.height
	    });
	
	    finalAxis.bandSize = (0, _ChartUtils.getBandSizeOfAxis)(finalAxis, ticks);
	
	    if (!axis.hide && axisType === 'xAxis') {
	      steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.height;
	    } else if (!axis.hide) {
	      steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.width;
	    }
	
	    return _objectSpread({}, result, _defineProperty({}, id, finalAxis));
	  }, {});
	};
	
	exports.formatAxisMap = formatAxisMap;
	
	var rectWithPoints = function rectWithPoints(_ref, _ref2) {
	  var x1 = _ref.x,
	      y1 = _ref.y;
	  var x2 = _ref2.x,
	      y2 = _ref2.y;
	  return {
	    x: Math.min(x1, x2),
	    y: Math.min(y1, y2),
	    width: Math.abs(x2 - x1),
	    height: Math.abs(y2 - y1)
	  };
	};
	/**
	 * Compute the x, y, width, and height of a box from two reference points.
	 * @param  {Object} coords     x1, x2, y1, and y2
	 * @return {Object} object
	 */
	
	
	exports.rectWithPoints = rectWithPoints;
	
	var rectWithCoords = function rectWithCoords(_ref3) {
	  var x1 = _ref3.x1,
	      y1 = _ref3.y1,
	      x2 = _ref3.x2,
	      y2 = _ref3.y2;
	  return rectWithPoints({
	    x: x1,
	    y: y1
	  }, {
	    x: x2,
	    y: y2
	  });
	};
	
	exports.rectWithCoords = rectWithCoords;
	
	var ScaleHelper =
	/*#__PURE__*/
	function () {
	  _createClass(ScaleHelper, null, [{
	    key: "create",
	    value: function create(obj) {
	      return new ScaleHelper(obj);
	    }
	  }]);
	
	  function ScaleHelper(scale) {
	    _classCallCheck(this, ScaleHelper);
	
	    this.scale = scale;
	  }
	
	  _createClass(ScaleHelper, [{
	    key: "apply",
	    value: function apply(value) {
	      var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	          bandAware = _ref4.bandAware,
	          position = _ref4.position;
	
	      if (value === undefined) {
	        return undefined;
	      }
	
	      if (position) {
	        switch (position) {
	          case 'start':
	            {
	              return this.scale(value);
	            }
	
	          case 'middle':
	            {
	              var offset = this.bandwidth ? this.bandwidth() / 2 : 0;
	              return this.scale(value) + offset;
	            }
	
	          case 'end':
	            {
	              var _offset = this.bandwidth ? this.bandwidth() : 0;
	
	              return this.scale(value) + _offset;
	            }
	
	          default:
	            {
	              return this.scale(value);
	            }
	        }
	      }
	
	      if (bandAware) {
	        var _offset2 = this.bandwidth ? this.bandwidth() / 2 : 0;
	
	        return this.scale(value) + _offset2;
	      }
	
	      return this.scale(value);
	    }
	  }, {
	    key: "isInRange",
	    value: function isInRange(value) {
	      var range = this.range();
	      var first = range[0];
	      var last = range[range.length - 1];
	      return first <= last ? value >= first && value <= last : value >= last && value <= first;
	    }
	  }, {
	    key: "domain",
	    get: function get() {
	      return this.scale.domain;
	    }
	  }, {
	    key: "range",
	    get: function get() {
	      return this.scale.range;
	    }
	  }, {
	    key: "rangeMin",
	    get: function get() {
	      return this.range()[0];
	    }
	  }, {
	    key: "rangeMax",
	    get: function get() {
	      return this.range()[1];
	    }
	  }, {
	    key: "bandwidth",
	    get: function get() {
	      return this.scale.bandwidth;
	    }
	  }]);
	
	  return ScaleHelper;
	}();
	
	exports.ScaleHelper = ScaleHelper;
	ScaleHelper.EPS = 1e-4;
	
	var LabeledScaleHelper =
	/*#__PURE__*/
	function () {
	  _createClass(LabeledScaleHelper, null, [{
	    key: "create",
	    value: function create(obj) {
	      return new this(obj);
	    }
	  }]);
	
	  function LabeledScaleHelper(scales) {
	    _classCallCheck(this, LabeledScaleHelper);
	
	    this.scales = (0, _mapValues2["default"])(scales, ScaleHelper.create);
	    Object.assign(this, this.scales);
	  }
	
	  _createClass(LabeledScaleHelper, [{
	    key: "apply",
	    value: function apply(coords) {
	      var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	          bandAware = _ref5.bandAware;
	
	      var scales = this.scales;
	      return (0, _mapValues2["default"])(coords, function (value, label) {
	        return scales[label].apply(value, {
	          bandAware: bandAware
	        });
	      });
	    }
	  }, {
	    key: "isInRange",
	    value: function isInRange(coords) {
	      var scales = this.scales;
	      return (0, _every2["default"])(coords, function (value, label) {
	        return scales[label].isInRange(value);
	      });
	    }
	  }]);
	
	  return LabeledScaleHelper;
	}();
	
	exports.LabeledScaleHelper = LabeledScaleHelper;

/***/ },
/* 129 */
/***/ function(module, exports) {

	function _typeof(o) {
	  "@babel/helpers - typeof";
	
	  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
	    return typeof o;
	  } : function (o) {
	    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(o);
	}
	module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.alertQueryErrorBody = alertQueryErrorBody;
	
	var _Singleton = __webpack_require__(21);
	
	function alertQueryErrorBody() {
	    var language = new _Singleton.Singleton();
	    var body = {
	        type: "ModalError",
	        title: language.getText("GUIErrorMessagetitle"),
	        message: language.getText("error-8000"),
	        button: language.getText("GUIErrorMessageclose"),
	        secondButtonFtn: function secondButtonFtn() {},
	        buttonFun: function buttonFun() {}
	    };
	    return body;
	}

/***/ },
/* 131 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.validateOnlyNumbers = validateOnlyNumbers;
	exports.validateCallKey = validateCallKey;
	function validateOnlyNumbers(evt) {
	  var theEvent = evt || window.event;
	  var key = theEvent.keyCode || theEvent.which;
	  key = String.fromCharCode(key);
	  var regex = /[0-9]|#|-|\*/;
	  if (!regex.test(key)) {
	    theEvent.returnValue = false;
	    if (theEvent.preventDefault) {
	      theEvent.preventDefault();
	    }
	    return false;
	  }
	  return true;
	}
	
	function validateCallKey(evt) {
	  var theEvent = evt || window.event;
	  var key = theEvent.keyCode || theEvent.which;
	  key = String.fromCharCode(key);
	  var regex = /^[^~|]*$/;
	  if (!regex.test(key)) {
	    theEvent.returnValue = false;
	    if (theEvent.preventDefault) {
	      theEvent.preventDefault();
	    }
	  }
	}

/***/ },
/* 132 */
77,
/* 133 */
[2645, 158, 522, 349, 116],
/* 134 */
[2660, 523, 341],
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(44)('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(78)(ArrayProto, UNSCOPABLES, {});
	module.exports = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};


/***/ },
/* 136 */
/***/ function(module, exports) {

	module.exports = false;


/***/ },
/* 137 */
[2644, 33, 548, 356, 367, 355, 358],
/* 138 */
[2649, 550, 356],
/* 139 */
[2650, 77, 65, 367],
/* 140 */
[2652, 550, 356],
/* 141 */
/***/ function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ },
/* 142 */
[2659, 94],
/* 143 */
/***/ function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(36);
	module.exports = function (it, TYPE) {
	  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
	  return it;
	};


/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var _react = _interopRequireWildcard(__webpack_require__(1));
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	var _hooks = __webpack_require__(168);
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
	function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	var Stopwatch = function Stopwatch(_ref) {
	  var initialTime = _ref.initialTime,
	    countdown = _ref.countdown,
	    countdownAction = _ref.countdownAction,
	    currentDate = _ref.currentDate,
	    disabled = _ref.disabled,
	    viewHours = _ref.viewHours;
	  var _useState = (0, _react.useState)(0),
	    _useState2 = _slicedToArray(_useState, 2),
	    elapsed = _useState2[0],
	    setElapsed = _useState2[1];
	  var _useState3 = (0, _react.useState)(1000),
	    _useState4 = _slicedToArray(_useState3, 2),
	    delay = _useState4[0],
	    setDelay = _useState4[1];
	  var start = (0, _react.useRef)(Date.now());
	  var _useState5 = (0, _react.useState)(initialTime),
	    _useState6 = _slicedToArray(_useState5, 2),
	    countdownValue = _useState6[0],
	    setCountdownValue = _useState6[1];
	  (0, _hooks.useInterval)(function () {
	    if (!disabled) {
	      if (countdown) {
	        setCountdownValue(countdownValue - 1000);
	      } else {
	        setElapsed(Date.now() - start.current);
	      }
	    }
	  }, delay);
	  (0, _react.useEffect)(function () {
	    if (countdownValue === 0 && countdown) {
	      setDelay(null);
	      if (countdownAction) countdownAction();
	    }
	  }, [countdownValue]);
	  (0, _react.useEffect)(function () {
	    if (currentDate) {
	      start.current = currentDate;
	    } else {
	      start.current = Date.now();
	    }
	  }, [initialTime]);
	  var convertToString = function convertToString(ms) {
	    var showWith0 = function showWith0(value) {
	      return value < 10 ? '0' + value : value;
	    };
	    var days = Math.floor(ms / (1000 * 60 * 60 * 24));
	    var hours = showWith0(Math.floor(ms / (1000 * 60 * 60) % 24));
	    var minutes = showWith0(Math.floor(ms / (1000 * 60) % 60));
	    var seconds = showWith0(Math.floor(ms / 1000 % 60));
	    return (parseInt(days, 10) ? days + 'd ' : '') + (viewHours || parseInt(hours, 10) ? hours + ':' : '') + minutes + ':' + seconds;
	  };
	  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, currentDate ? convertToString(elapsed) : countdown ? convertToString(countdownValue) : convertToString(Math.abs(start.current - (initialTime || start.current)) + elapsed));
	};
	Stopwatch.propTypes = {
	  initialTime: _propTypes["default"].oneOfType([_propTypes["default"].instanceOf(Date), _propTypes["default"].number]),
	  countdown: _propTypes["default"].bool,
	  countdownAction: _propTypes["default"].func,
	  currentDate: _propTypes["default"].oneOfType([_propTypes["default"].instanceOf(Date), _propTypes["default"].number]),
	  disabled: _propTypes["default"].bool,
	  viewHours: _propTypes["default"].bool
	};
	Stopwatch.defaultProps = {
	  disabled: false,
	  viewHours: false
	};
	var _default = exports["default"] = Stopwatch;

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = compareAsc;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name compareAsc
	 * @category Common Helpers
	 * @summary Compare the two dates and return -1, 0 or 1.
	 *
	 * @description
	 * Compare the two dates and return 1 if the first date is after the second,
	 * -1 if the first date is before the second or 0 if dates are equal.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the first date to compare
	 * @param {Date|Number} dateRight - the second date to compare
	 * @returns {Number} the result of the comparison
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Compare 11 February 1987 and 10 July 1989:
	 * const result = compareAsc(new Date(1987, 1, 11), new Date(1989, 6, 10))
	 * //=> -1
	 *
	 * @example
	 * // Sort the array of dates:
	 * const result = [
	 *   new Date(1995, 6, 2),
	 *   new Date(1987, 1, 11),
	 *   new Date(1989, 6, 10)
	 * ].sort(compareAsc)
	 * //=> [
	 * //   Wed Feb 11 1987 00:00:00,
	 * //   Mon Jul 10 1989 00:00:00,
	 * //   Sun Jul 02 1995 00:00:00
	 * // ]
	 */
	function compareAsc(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  var diff = dateLeft.getTime() - dateRight.getTime();
	
	  if (diff < 0) {
	    return -1;
	  } else if (diff > 0) {
	    return 1; // Return 0 if diff is 0; return NaN if diff is NaN
	  } else {
	    return diff;
	  }
	}
	
	module.exports = exports.default;

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _exportNames = {
	  add: true,
	  addBusinessDays: true,
	  addDays: true,
	  addHours: true,
	  addISOWeekYears: true,
	  addMilliseconds: true,
	  addMinutes: true,
	  addMonths: true,
	  addQuarters: true,
	  addSeconds: true,
	  addWeeks: true,
	  addYears: true,
	  areIntervalsOverlapping: true,
	  clamp: true,
	  closestIndexTo: true,
	  closestTo: true,
	  compareAsc: true,
	  compareDesc: true,
	  daysToWeeks: true,
	  differenceInBusinessDays: true,
	  differenceInCalendarDays: true,
	  differenceInCalendarISOWeekYears: true,
	  differenceInCalendarISOWeeks: true,
	  differenceInCalendarMonths: true,
	  differenceInCalendarQuarters: true,
	  differenceInCalendarWeeks: true,
	  differenceInCalendarYears: true,
	  differenceInDays: true,
	  differenceInHours: true,
	  differenceInISOWeekYears: true,
	  differenceInMilliseconds: true,
	  differenceInMinutes: true,
	  differenceInMonths: true,
	  differenceInQuarters: true,
	  differenceInSeconds: true,
	  differenceInWeeks: true,
	  differenceInYears: true,
	  eachDayOfInterval: true,
	  eachHourOfInterval: true,
	  eachMinuteOfInterval: true,
	  eachMonthOfInterval: true,
	  eachQuarterOfInterval: true,
	  eachWeekOfInterval: true,
	  eachWeekendOfInterval: true,
	  eachWeekendOfMonth: true,
	  eachWeekendOfYear: true,
	  eachYearOfInterval: true,
	  endOfDay: true,
	  endOfDecade: true,
	  endOfHour: true,
	  endOfISOWeek: true,
	  endOfISOWeekYear: true,
	  endOfMinute: true,
	  endOfMonth: true,
	  endOfQuarter: true,
	  endOfSecond: true,
	  endOfToday: true,
	  endOfTomorrow: true,
	  endOfWeek: true,
	  endOfYear: true,
	  endOfYesterday: true,
	  format: true,
	  formatDistance: true,
	  formatDistanceStrict: true,
	  formatDistanceToNow: true,
	  formatDistanceToNowStrict: true,
	  formatDuration: true,
	  formatISO: true,
	  formatISO9075: true,
	  formatISODuration: true,
	  formatRFC3339: true,
	  formatRFC7231: true,
	  formatRelative: true,
	  fromUnixTime: true,
	  getDate: true,
	  getDay: true,
	  getDayOfYear: true,
	  getDaysInMonth: true,
	  getDaysInYear: true,
	  getDecade: true,
	  getHours: true,
	  getISODay: true,
	  getISOWeek: true,
	  getISOWeekYear: true,
	  getISOWeeksInYear: true,
	  getMilliseconds: true,
	  getMinutes: true,
	  getMonth: true,
	  getOverlappingDaysInIntervals: true,
	  getQuarter: true,
	  getSeconds: true,
	  getTime: true,
	  getUnixTime: true,
	  getWeek: true,
	  getWeekOfMonth: true,
	  getWeekYear: true,
	  getWeeksInMonth: true,
	  getYear: true,
	  hoursToMilliseconds: true,
	  hoursToMinutes: true,
	  hoursToSeconds: true,
	  intervalToDuration: true,
	  intlFormat: true,
	  isAfter: true,
	  isBefore: true,
	  isDate: true,
	  isEqual: true,
	  isExists: true,
	  isFirstDayOfMonth: true,
	  isFriday: true,
	  isFuture: true,
	  isLastDayOfMonth: true,
	  isLeapYear: true,
	  isMatch: true,
	  isMonday: true,
	  isPast: true,
	  isSameDay: true,
	  isSameHour: true,
	  isSameISOWeek: true,
	  isSameISOWeekYear: true,
	  isSameMinute: true,
	  isSameMonth: true,
	  isSameQuarter: true,
	  isSameSecond: true,
	  isSameWeek: true,
	  isSameYear: true,
	  isSaturday: true,
	  isSunday: true,
	  isThisHour: true,
	  isThisISOWeek: true,
	  isThisMinute: true,
	  isThisMonth: true,
	  isThisQuarter: true,
	  isThisSecond: true,
	  isThisWeek: true,
	  isThisYear: true,
	  isThursday: true,
	  isToday: true,
	  isTomorrow: true,
	  isTuesday: true,
	  isValid: true,
	  isWednesday: true,
	  isWeekend: true,
	  isWithinInterval: true,
	  isYesterday: true,
	  lastDayOfDecade: true,
	  lastDayOfISOWeek: true,
	  lastDayOfISOWeekYear: true,
	  lastDayOfMonth: true,
	  lastDayOfQuarter: true,
	  lastDayOfWeek: true,
	  lastDayOfYear: true,
	  lightFormat: true,
	  max: true,
	  milliseconds: true,
	  millisecondsToHours: true,
	  millisecondsToMinutes: true,
	  millisecondsToSeconds: true,
	  min: true,
	  minutesToHours: true,
	  minutesToMilliseconds: true,
	  minutesToSeconds: true,
	  monthsToQuarters: true,
	  monthsToYears: true,
	  nextDay: true,
	  nextFriday: true,
	  nextMonday: true,
	  nextSaturday: true,
	  nextSunday: true,
	  nextThursday: true,
	  nextTuesday: true,
	  nextWednesday: true,
	  parse: true,
	  parseISO: true,
	  parseJSON: true,
	  previousDay: true,
	  previousFriday: true,
	  previousMonday: true,
	  previousSaturday: true,
	  previousSunday: true,
	  previousThursday: true,
	  previousTuesday: true,
	  previousWednesday: true,
	  quartersToMonths: true,
	  quartersToYears: true,
	  roundToNearestMinutes: true,
	  secondsToHours: true,
	  secondsToMilliseconds: true,
	  secondsToMinutes: true,
	  set: true,
	  setDate: true,
	  setDay: true,
	  setDayOfYear: true,
	  setHours: true,
	  setISODay: true,
	  setISOWeek: true,
	  setISOWeekYear: true,
	  setMilliseconds: true,
	  setMinutes: true,
	  setMonth: true,
	  setQuarter: true,
	  setSeconds: true,
	  setWeek: true,
	  setWeekYear: true,
	  setYear: true,
	  startOfDay: true,
	  startOfDecade: true,
	  startOfHour: true,
	  startOfISOWeek: true,
	  startOfISOWeekYear: true,
	  startOfMinute: true,
	  startOfMonth: true,
	  startOfQuarter: true,
	  startOfSecond: true,
	  startOfToday: true,
	  startOfTomorrow: true,
	  startOfWeek: true,
	  startOfWeekYear: true,
	  startOfYear: true,
	  startOfYesterday: true,
	  sub: true,
	  subBusinessDays: true,
	  subDays: true,
	  subHours: true,
	  subISOWeekYears: true,
	  subMilliseconds: true,
	  subMinutes: true,
	  subMonths: true,
	  subQuarters: true,
	  subSeconds: true,
	  subWeeks: true,
	  subYears: true,
	  toDate: true,
	  weeksToDays: true,
	  yearsToMonths: true,
	  yearsToQuarters: true
	};
	Object.defineProperty(exports, "add", {
	  enumerable: true,
	  get: function () {
	    return _index.default;
	  }
	});
	Object.defineProperty(exports, "addBusinessDays", {
	  enumerable: true,
	  get: function () {
	    return _index2.default;
	  }
	});
	Object.defineProperty(exports, "addDays", {
	  enumerable: true,
	  get: function () {
	    return _index3.default;
	  }
	});
	Object.defineProperty(exports, "addHours", {
	  enumerable: true,
	  get: function () {
	    return _index4.default;
	  }
	});
	Object.defineProperty(exports, "addISOWeekYears", {
	  enumerable: true,
	  get: function () {
	    return _index5.default;
	  }
	});
	Object.defineProperty(exports, "addMilliseconds", {
	  enumerable: true,
	  get: function () {
	    return _index6.default;
	  }
	});
	Object.defineProperty(exports, "addMinutes", {
	  enumerable: true,
	  get: function () {
	    return _index7.default;
	  }
	});
	Object.defineProperty(exports, "addMonths", {
	  enumerable: true,
	  get: function () {
	    return _index8.default;
	  }
	});
	Object.defineProperty(exports, "addQuarters", {
	  enumerable: true,
	  get: function () {
	    return _index9.default;
	  }
	});
	Object.defineProperty(exports, "addSeconds", {
	  enumerable: true,
	  get: function () {
	    return _index10.default;
	  }
	});
	Object.defineProperty(exports, "addWeeks", {
	  enumerable: true,
	  get: function () {
	    return _index11.default;
	  }
	});
	Object.defineProperty(exports, "addYears", {
	  enumerable: true,
	  get: function () {
	    return _index12.default;
	  }
	});
	Object.defineProperty(exports, "areIntervalsOverlapping", {
	  enumerable: true,
	  get: function () {
	    return _index13.default;
	  }
	});
	Object.defineProperty(exports, "clamp", {
	  enumerable: true,
	  get: function () {
	    return _index14.default;
	  }
	});
	Object.defineProperty(exports, "closestIndexTo", {
	  enumerable: true,
	  get: function () {
	    return _index15.default;
	  }
	});
	Object.defineProperty(exports, "closestTo", {
	  enumerable: true,
	  get: function () {
	    return _index16.default;
	  }
	});
	Object.defineProperty(exports, "compareAsc", {
	  enumerable: true,
	  get: function () {
	    return _index17.default;
	  }
	});
	Object.defineProperty(exports, "compareDesc", {
	  enumerable: true,
	  get: function () {
	    return _index18.default;
	  }
	});
	Object.defineProperty(exports, "daysToWeeks", {
	  enumerable: true,
	  get: function () {
	    return _index19.default;
	  }
	});
	Object.defineProperty(exports, "differenceInBusinessDays", {
	  enumerable: true,
	  get: function () {
	    return _index20.default;
	  }
	});
	Object.defineProperty(exports, "differenceInCalendarDays", {
	  enumerable: true,
	  get: function () {
	    return _index21.default;
	  }
	});
	Object.defineProperty(exports, "differenceInCalendarISOWeekYears", {
	  enumerable: true,
	  get: function () {
	    return _index22.default;
	  }
	});
	Object.defineProperty(exports, "differenceInCalendarISOWeeks", {
	  enumerable: true,
	  get: function () {
	    return _index23.default;
	  }
	});
	Object.defineProperty(exports, "differenceInCalendarMonths", {
	  enumerable: true,
	  get: function () {
	    return _index24.default;
	  }
	});
	Object.defineProperty(exports, "differenceInCalendarQuarters", {
	  enumerable: true,
	  get: function () {
	    return _index25.default;
	  }
	});
	Object.defineProperty(exports, "differenceInCalendarWeeks", {
	  enumerable: true,
	  get: function () {
	    return _index26.default;
	  }
	});
	Object.defineProperty(exports, "differenceInCalendarYears", {
	  enumerable: true,
	  get: function () {
	    return _index27.default;
	  }
	});
	Object.defineProperty(exports, "differenceInDays", {
	  enumerable: true,
	  get: function () {
	    return _index28.default;
	  }
	});
	Object.defineProperty(exports, "differenceInHours", {
	  enumerable: true,
	  get: function () {
	    return _index29.default;
	  }
	});
	Object.defineProperty(exports, "differenceInISOWeekYears", {
	  enumerable: true,
	  get: function () {
	    return _index30.default;
	  }
	});
	Object.defineProperty(exports, "differenceInMilliseconds", {
	  enumerable: true,
	  get: function () {
	    return _index31.default;
	  }
	});
	Object.defineProperty(exports, "differenceInMinutes", {
	  enumerable: true,
	  get: function () {
	    return _index32.default;
	  }
	});
	Object.defineProperty(exports, "differenceInMonths", {
	  enumerable: true,
	  get: function () {
	    return _index33.default;
	  }
	});
	Object.defineProperty(exports, "differenceInQuarters", {
	  enumerable: true,
	  get: function () {
	    return _index34.default;
	  }
	});
	Object.defineProperty(exports, "differenceInSeconds", {
	  enumerable: true,
	  get: function () {
	    return _index35.default;
	  }
	});
	Object.defineProperty(exports, "differenceInWeeks", {
	  enumerable: true,
	  get: function () {
	    return _index36.default;
	  }
	});
	Object.defineProperty(exports, "differenceInYears", {
	  enumerable: true,
	  get: function () {
	    return _index37.default;
	  }
	});
	Object.defineProperty(exports, "eachDayOfInterval", {
	  enumerable: true,
	  get: function () {
	    return _index38.default;
	  }
	});
	Object.defineProperty(exports, "eachHourOfInterval", {
	  enumerable: true,
	  get: function () {
	    return _index39.default;
	  }
	});
	Object.defineProperty(exports, "eachMinuteOfInterval", {
	  enumerable: true,
	  get: function () {
	    return _index40.default;
	  }
	});
	Object.defineProperty(exports, "eachMonthOfInterval", {
	  enumerable: true,
	  get: function () {
	    return _index41.default;
	  }
	});
	Object.defineProperty(exports, "eachQuarterOfInterval", {
	  enumerable: true,
	  get: function () {
	    return _index42.default;
	  }
	});
	Object.defineProperty(exports, "eachWeekOfInterval", {
	  enumerable: true,
	  get: function () {
	    return _index43.default;
	  }
	});
	Object.defineProperty(exports, "eachWeekendOfInterval", {
	  enumerable: true,
	  get: function () {
	    return _index44.default;
	  }
	});
	Object.defineProperty(exports, "eachWeekendOfMonth", {
	  enumerable: true,
	  get: function () {
	    return _index45.default;
	  }
	});
	Object.defineProperty(exports, "eachWeekendOfYear", {
	  enumerable: true,
	  get: function () {
	    return _index46.default;
	  }
	});
	Object.defineProperty(exports, "eachYearOfInterval", {
	  enumerable: true,
	  get: function () {
	    return _index47.default;
	  }
	});
	Object.defineProperty(exports, "endOfDay", {
	  enumerable: true,
	  get: function () {
	    return _index48.default;
	  }
	});
	Object.defineProperty(exports, "endOfDecade", {
	  enumerable: true,
	  get: function () {
	    return _index49.default;
	  }
	});
	Object.defineProperty(exports, "endOfHour", {
	  enumerable: true,
	  get: function () {
	    return _index50.default;
	  }
	});
	Object.defineProperty(exports, "endOfISOWeek", {
	  enumerable: true,
	  get: function () {
	    return _index51.default;
	  }
	});
	Object.defineProperty(exports, "endOfISOWeekYear", {
	  enumerable: true,
	  get: function () {
	    return _index52.default;
	  }
	});
	Object.defineProperty(exports, "endOfMinute", {
	  enumerable: true,
	  get: function () {
	    return _index53.default;
	  }
	});
	Object.defineProperty(exports, "endOfMonth", {
	  enumerable: true,
	  get: function () {
	    return _index54.default;
	  }
	});
	Object.defineProperty(exports, "endOfQuarter", {
	  enumerable: true,
	  get: function () {
	    return _index55.default;
	  }
	});
	Object.defineProperty(exports, "endOfSecond", {
	  enumerable: true,
	  get: function () {
	    return _index56.default;
	  }
	});
	Object.defineProperty(exports, "endOfToday", {
	  enumerable: true,
	  get: function () {
	    return _index57.default;
	  }
	});
	Object.defineProperty(exports, "endOfTomorrow", {
	  enumerable: true,
	  get: function () {
	    return _index58.default;
	  }
	});
	Object.defineProperty(exports, "endOfWeek", {
	  enumerable: true,
	  get: function () {
	    return _index59.default;
	  }
	});
	Object.defineProperty(exports, "endOfYear", {
	  enumerable: true,
	  get: function () {
	    return _index60.default;
	  }
	});
	Object.defineProperty(exports, "endOfYesterday", {
	  enumerable: true,
	  get: function () {
	    return _index61.default;
	  }
	});
	Object.defineProperty(exports, "format", {
	  enumerable: true,
	  get: function () {
	    return _index62.default;
	  }
	});
	Object.defineProperty(exports, "formatDistance", {
	  enumerable: true,
	  get: function () {
	    return _index63.default;
	  }
	});
	Object.defineProperty(exports, "formatDistanceStrict", {
	  enumerable: true,
	  get: function () {
	    return _index64.default;
	  }
	});
	Object.defineProperty(exports, "formatDistanceToNow", {
	  enumerable: true,
	  get: function () {
	    return _index65.default;
	  }
	});
	Object.defineProperty(exports, "formatDistanceToNowStrict", {
	  enumerable: true,
	  get: function () {
	    return _index66.default;
	  }
	});
	Object.defineProperty(exports, "formatDuration", {
	  enumerable: true,
	  get: function () {
	    return _index67.default;
	  }
	});
	Object.defineProperty(exports, "formatISO", {
	  enumerable: true,
	  get: function () {
	    return _index68.default;
	  }
	});
	Object.defineProperty(exports, "formatISO9075", {
	  enumerable: true,
	  get: function () {
	    return _index69.default;
	  }
	});
	Object.defineProperty(exports, "formatISODuration", {
	  enumerable: true,
	  get: function () {
	    return _index70.default;
	  }
	});
	Object.defineProperty(exports, "formatRFC3339", {
	  enumerable: true,
	  get: function () {
	    return _index71.default;
	  }
	});
	Object.defineProperty(exports, "formatRFC7231", {
	  enumerable: true,
	  get: function () {
	    return _index72.default;
	  }
	});
	Object.defineProperty(exports, "formatRelative", {
	  enumerable: true,
	  get: function () {
	    return _index73.default;
	  }
	});
	Object.defineProperty(exports, "fromUnixTime", {
	  enumerable: true,
	  get: function () {
	    return _index74.default;
	  }
	});
	Object.defineProperty(exports, "getDate", {
	  enumerable: true,
	  get: function () {
	    return _index75.default;
	  }
	});
	Object.defineProperty(exports, "getDay", {
	  enumerable: true,
	  get: function () {
	    return _index76.default;
	  }
	});
	Object.defineProperty(exports, "getDayOfYear", {
	  enumerable: true,
	  get: function () {
	    return _index77.default;
	  }
	});
	Object.defineProperty(exports, "getDaysInMonth", {
	  enumerable: true,
	  get: function () {
	    return _index78.default;
	  }
	});
	Object.defineProperty(exports, "getDaysInYear", {
	  enumerable: true,
	  get: function () {
	    return _index79.default;
	  }
	});
	Object.defineProperty(exports, "getDecade", {
	  enumerable: true,
	  get: function () {
	    return _index80.default;
	  }
	});
	Object.defineProperty(exports, "getHours", {
	  enumerable: true,
	  get: function () {
	    return _index81.default;
	  }
	});
	Object.defineProperty(exports, "getISODay", {
	  enumerable: true,
	  get: function () {
	    return _index82.default;
	  }
	});
	Object.defineProperty(exports, "getISOWeek", {
	  enumerable: true,
	  get: function () {
	    return _index83.default;
	  }
	});
	Object.defineProperty(exports, "getISOWeekYear", {
	  enumerable: true,
	  get: function () {
	    return _index84.default;
	  }
	});
	Object.defineProperty(exports, "getISOWeeksInYear", {
	  enumerable: true,
	  get: function () {
	    return _index85.default;
	  }
	});
	Object.defineProperty(exports, "getMilliseconds", {
	  enumerable: true,
	  get: function () {
	    return _index86.default;
	  }
	});
	Object.defineProperty(exports, "getMinutes", {
	  enumerable: true,
	  get: function () {
	    return _index87.default;
	  }
	});
	Object.defineProperty(exports, "getMonth", {
	  enumerable: true,
	  get: function () {
	    return _index88.default;
	  }
	});
	Object.defineProperty(exports, "getOverlappingDaysInIntervals", {
	  enumerable: true,
	  get: function () {
	    return _index89.default;
	  }
	});
	Object.defineProperty(exports, "getQuarter", {
	  enumerable: true,
	  get: function () {
	    return _index90.default;
	  }
	});
	Object.defineProperty(exports, "getSeconds", {
	  enumerable: true,
	  get: function () {
	    return _index91.default;
	  }
	});
	Object.defineProperty(exports, "getTime", {
	  enumerable: true,
	  get: function () {
	    return _index92.default;
	  }
	});
	Object.defineProperty(exports, "getUnixTime", {
	  enumerable: true,
	  get: function () {
	    return _index93.default;
	  }
	});
	Object.defineProperty(exports, "getWeek", {
	  enumerable: true,
	  get: function () {
	    return _index94.default;
	  }
	});
	Object.defineProperty(exports, "getWeekOfMonth", {
	  enumerable: true,
	  get: function () {
	    return _index95.default;
	  }
	});
	Object.defineProperty(exports, "getWeekYear", {
	  enumerable: true,
	  get: function () {
	    return _index96.default;
	  }
	});
	Object.defineProperty(exports, "getWeeksInMonth", {
	  enumerable: true,
	  get: function () {
	    return _index97.default;
	  }
	});
	Object.defineProperty(exports, "getYear", {
	  enumerable: true,
	  get: function () {
	    return _index98.default;
	  }
	});
	Object.defineProperty(exports, "hoursToMilliseconds", {
	  enumerable: true,
	  get: function () {
	    return _index99.default;
	  }
	});
	Object.defineProperty(exports, "hoursToMinutes", {
	  enumerable: true,
	  get: function () {
	    return _index100.default;
	  }
	});
	Object.defineProperty(exports, "hoursToSeconds", {
	  enumerable: true,
	  get: function () {
	    return _index101.default;
	  }
	});
	Object.defineProperty(exports, "intervalToDuration", {
	  enumerable: true,
	  get: function () {
	    return _index102.default;
	  }
	});
	Object.defineProperty(exports, "intlFormat", {
	  enumerable: true,
	  get: function () {
	    return _index103.default;
	  }
	});
	Object.defineProperty(exports, "isAfter", {
	  enumerable: true,
	  get: function () {
	    return _index104.default;
	  }
	});
	Object.defineProperty(exports, "isBefore", {
	  enumerable: true,
	  get: function () {
	    return _index105.default;
	  }
	});
	Object.defineProperty(exports, "isDate", {
	  enumerable: true,
	  get: function () {
	    return _index106.default;
	  }
	});
	Object.defineProperty(exports, "isEqual", {
	  enumerable: true,
	  get: function () {
	    return _index107.default;
	  }
	});
	Object.defineProperty(exports, "isExists", {
	  enumerable: true,
	  get: function () {
	    return _index108.default;
	  }
	});
	Object.defineProperty(exports, "isFirstDayOfMonth", {
	  enumerable: true,
	  get: function () {
	    return _index109.default;
	  }
	});
	Object.defineProperty(exports, "isFriday", {
	  enumerable: true,
	  get: function () {
	    return _index110.default;
	  }
	});
	Object.defineProperty(exports, "isFuture", {
	  enumerable: true,
	  get: function () {
	    return _index111.default;
	  }
	});
	Object.defineProperty(exports, "isLastDayOfMonth", {
	  enumerable: true,
	  get: function () {
	    return _index112.default;
	  }
	});
	Object.defineProperty(exports, "isLeapYear", {
	  enumerable: true,
	  get: function () {
	    return _index113.default;
	  }
	});
	Object.defineProperty(exports, "isMatch", {
	  enumerable: true,
	  get: function () {
	    return _index114.default;
	  }
	});
	Object.defineProperty(exports, "isMonday", {
	  enumerable: true,
	  get: function () {
	    return _index115.default;
	  }
	});
	Object.defineProperty(exports, "isPast", {
	  enumerable: true,
	  get: function () {
	    return _index116.default;
	  }
	});
	Object.defineProperty(exports, "isSameDay", {
	  enumerable: true,
	  get: function () {
	    return _index117.default;
	  }
	});
	Object.defineProperty(exports, "isSameHour", {
	  enumerable: true,
	  get: function () {
	    return _index118.default;
	  }
	});
	Object.defineProperty(exports, "isSameISOWeek", {
	  enumerable: true,
	  get: function () {
	    return _index119.default;
	  }
	});
	Object.defineProperty(exports, "isSameISOWeekYear", {
	  enumerable: true,
	  get: function () {
	    return _index120.default;
	  }
	});
	Object.defineProperty(exports, "isSameMinute", {
	  enumerable: true,
	  get: function () {
	    return _index121.default;
	  }
	});
	Object.defineProperty(exports, "isSameMonth", {
	  enumerable: true,
	  get: function () {
	    return _index122.default;
	  }
	});
	Object.defineProperty(exports, "isSameQuarter", {
	  enumerable: true,
	  get: function () {
	    return _index123.default;
	  }
	});
	Object.defineProperty(exports, "isSameSecond", {
	  enumerable: true,
	  get: function () {
	    return _index124.default;
	  }
	});
	Object.defineProperty(exports, "isSameWeek", {
	  enumerable: true,
	  get: function () {
	    return _index125.default;
	  }
	});
	Object.defineProperty(exports, "isSameYear", {
	  enumerable: true,
	  get: function () {
	    return _index126.default;
	  }
	});
	Object.defineProperty(exports, "isSaturday", {
	  enumerable: true,
	  get: function () {
	    return _index127.default;
	  }
	});
	Object.defineProperty(exports, "isSunday", {
	  enumerable: true,
	  get: function () {
	    return _index128.default;
	  }
	});
	Object.defineProperty(exports, "isThisHour", {
	  enumerable: true,
	  get: function () {
	    return _index129.default;
	  }
	});
	Object.defineProperty(exports, "isThisISOWeek", {
	  enumerable: true,
	  get: function () {
	    return _index130.default;
	  }
	});
	Object.defineProperty(exports, "isThisMinute", {
	  enumerable: true,
	  get: function () {
	    return _index131.default;
	  }
	});
	Object.defineProperty(exports, "isThisMonth", {
	  enumerable: true,
	  get: function () {
	    return _index132.default;
	  }
	});
	Object.defineProperty(exports, "isThisQuarter", {
	  enumerable: true,
	  get: function () {
	    return _index133.default;
	  }
	});
	Object.defineProperty(exports, "isThisSecond", {
	  enumerable: true,
	  get: function () {
	    return _index134.default;
	  }
	});
	Object.defineProperty(exports, "isThisWeek", {
	  enumerable: true,
	  get: function () {
	    return _index135.default;
	  }
	});
	Object.defineProperty(exports, "isThisYear", {
	  enumerable: true,
	  get: function () {
	    return _index136.default;
	  }
	});
	Object.defineProperty(exports, "isThursday", {
	  enumerable: true,
	  get: function () {
	    return _index137.default;
	  }
	});
	Object.defineProperty(exports, "isToday", {
	  enumerable: true,
	  get: function () {
	    return _index138.default;
	  }
	});
	Object.defineProperty(exports, "isTomorrow", {
	  enumerable: true,
	  get: function () {
	    return _index139.default;
	  }
	});
	Object.defineProperty(exports, "isTuesday", {
	  enumerable: true,
	  get: function () {
	    return _index140.default;
	  }
	});
	Object.defineProperty(exports, "isValid", {
	  enumerable: true,
	  get: function () {
	    return _index141.default;
	  }
	});
	Object.defineProperty(exports, "isWednesday", {
	  enumerable: true,
	  get: function () {
	    return _index142.default;
	  }
	});
	Object.defineProperty(exports, "isWeekend", {
	  enumerable: true,
	  get: function () {
	    return _index143.default;
	  }
	});
	Object.defineProperty(exports, "isWithinInterval", {
	  enumerable: true,
	  get: function () {
	    return _index144.default;
	  }
	});
	Object.defineProperty(exports, "isYesterday", {
	  enumerable: true,
	  get: function () {
	    return _index145.default;
	  }
	});
	Object.defineProperty(exports, "lastDayOfDecade", {
	  enumerable: true,
	  get: function () {
	    return _index146.default;
	  }
	});
	Object.defineProperty(exports, "lastDayOfISOWeek", {
	  enumerable: true,
	  get: function () {
	    return _index147.default;
	  }
	});
	Object.defineProperty(exports, "lastDayOfISOWeekYear", {
	  enumerable: true,
	  get: function () {
	    return _index148.default;
	  }
	});
	Object.defineProperty(exports, "lastDayOfMonth", {
	  enumerable: true,
	  get: function () {
	    return _index149.default;
	  }
	});
	Object.defineProperty(exports, "lastDayOfQuarter", {
	  enumerable: true,
	  get: function () {
	    return _index150.default;
	  }
	});
	Object.defineProperty(exports, "lastDayOfWeek", {
	  enumerable: true,
	  get: function () {
	    return _index151.default;
	  }
	});
	Object.defineProperty(exports, "lastDayOfYear", {
	  enumerable: true,
	  get: function () {
	    return _index152.default;
	  }
	});
	Object.defineProperty(exports, "lightFormat", {
	  enumerable: true,
	  get: function () {
	    return _index153.default;
	  }
	});
	Object.defineProperty(exports, "max", {
	  enumerable: true,
	  get: function () {
	    return _index154.default;
	  }
	});
	Object.defineProperty(exports, "milliseconds", {
	  enumerable: true,
	  get: function () {
	    return _index155.default;
	  }
	});
	Object.defineProperty(exports, "millisecondsToHours", {
	  enumerable: true,
	  get: function () {
	    return _index156.default;
	  }
	});
	Object.defineProperty(exports, "millisecondsToMinutes", {
	  enumerable: true,
	  get: function () {
	    return _index157.default;
	  }
	});
	Object.defineProperty(exports, "millisecondsToSeconds", {
	  enumerable: true,
	  get: function () {
	    return _index158.default;
	  }
	});
	Object.defineProperty(exports, "min", {
	  enumerable: true,
	  get: function () {
	    return _index159.default;
	  }
	});
	Object.defineProperty(exports, "minutesToHours", {
	  enumerable: true,
	  get: function () {
	    return _index160.default;
	  }
	});
	Object.defineProperty(exports, "minutesToMilliseconds", {
	  enumerable: true,
	  get: function () {
	    return _index161.default;
	  }
	});
	Object.defineProperty(exports, "minutesToSeconds", {
	  enumerable: true,
	  get: function () {
	    return _index162.default;
	  }
	});
	Object.defineProperty(exports, "monthsToQuarters", {
	  enumerable: true,
	  get: function () {
	    return _index163.default;
	  }
	});
	Object.defineProperty(exports, "monthsToYears", {
	  enumerable: true,
	  get: function () {
	    return _index164.default;
	  }
	});
	Object.defineProperty(exports, "nextDay", {
	  enumerable: true,
	  get: function () {
	    return _index165.default;
	  }
	});
	Object.defineProperty(exports, "nextFriday", {
	  enumerable: true,
	  get: function () {
	    return _index166.default;
	  }
	});
	Object.defineProperty(exports, "nextMonday", {
	  enumerable: true,
	  get: function () {
	    return _index167.default;
	  }
	});
	Object.defineProperty(exports, "nextSaturday", {
	  enumerable: true,
	  get: function () {
	    return _index168.default;
	  }
	});
	Object.defineProperty(exports, "nextSunday", {
	  enumerable: true,
	  get: function () {
	    return _index169.default;
	  }
	});
	Object.defineProperty(exports, "nextThursday", {
	  enumerable: true,
	  get: function () {
	    return _index170.default;
	  }
	});
	Object.defineProperty(exports, "nextTuesday", {
	  enumerable: true,
	  get: function () {
	    return _index171.default;
	  }
	});
	Object.defineProperty(exports, "nextWednesday", {
	  enumerable: true,
	  get: function () {
	    return _index172.default;
	  }
	});
	Object.defineProperty(exports, "parse", {
	  enumerable: true,
	  get: function () {
	    return _index173.default;
	  }
	});
	Object.defineProperty(exports, "parseISO", {
	  enumerable: true,
	  get: function () {
	    return _index174.default;
	  }
	});
	Object.defineProperty(exports, "parseJSON", {
	  enumerable: true,
	  get: function () {
	    return _index175.default;
	  }
	});
	Object.defineProperty(exports, "previousDay", {
	  enumerable: true,
	  get: function () {
	    return _index176.default;
	  }
	});
	Object.defineProperty(exports, "previousFriday", {
	  enumerable: true,
	  get: function () {
	    return _index177.default;
	  }
	});
	Object.defineProperty(exports, "previousMonday", {
	  enumerable: true,
	  get: function () {
	    return _index178.default;
	  }
	});
	Object.defineProperty(exports, "previousSaturday", {
	  enumerable: true,
	  get: function () {
	    return _index179.default;
	  }
	});
	Object.defineProperty(exports, "previousSunday", {
	  enumerable: true,
	  get: function () {
	    return _index180.default;
	  }
	});
	Object.defineProperty(exports, "previousThursday", {
	  enumerable: true,
	  get: function () {
	    return _index181.default;
	  }
	});
	Object.defineProperty(exports, "previousTuesday", {
	  enumerable: true,
	  get: function () {
	    return _index182.default;
	  }
	});
	Object.defineProperty(exports, "previousWednesday", {
	  enumerable: true,
	  get: function () {
	    return _index183.default;
	  }
	});
	Object.defineProperty(exports, "quartersToMonths", {
	  enumerable: true,
	  get: function () {
	    return _index184.default;
	  }
	});
	Object.defineProperty(exports, "quartersToYears", {
	  enumerable: true,
	  get: function () {
	    return _index185.default;
	  }
	});
	Object.defineProperty(exports, "roundToNearestMinutes", {
	  enumerable: true,
	  get: function () {
	    return _index186.default;
	  }
	});
	Object.defineProperty(exports, "secondsToHours", {
	  enumerable: true,
	  get: function () {
	    return _index187.default;
	  }
	});
	Object.defineProperty(exports, "secondsToMilliseconds", {
	  enumerable: true,
	  get: function () {
	    return _index188.default;
	  }
	});
	Object.defineProperty(exports, "secondsToMinutes", {
	  enumerable: true,
	  get: function () {
	    return _index189.default;
	  }
	});
	Object.defineProperty(exports, "set", {
	  enumerable: true,
	  get: function () {
	    return _index190.default;
	  }
	});
	Object.defineProperty(exports, "setDate", {
	  enumerable: true,
	  get: function () {
	    return _index191.default;
	  }
	});
	Object.defineProperty(exports, "setDay", {
	  enumerable: true,
	  get: function () {
	    return _index192.default;
	  }
	});
	Object.defineProperty(exports, "setDayOfYear", {
	  enumerable: true,
	  get: function () {
	    return _index193.default;
	  }
	});
	Object.defineProperty(exports, "setHours", {
	  enumerable: true,
	  get: function () {
	    return _index194.default;
	  }
	});
	Object.defineProperty(exports, "setISODay", {
	  enumerable: true,
	  get: function () {
	    return _index195.default;
	  }
	});
	Object.defineProperty(exports, "setISOWeek", {
	  enumerable: true,
	  get: function () {
	    return _index196.default;
	  }
	});
	Object.defineProperty(exports, "setISOWeekYear", {
	  enumerable: true,
	  get: function () {
	    return _index197.default;
	  }
	});
	Object.defineProperty(exports, "setMilliseconds", {
	  enumerable: true,
	  get: function () {
	    return _index198.default;
	  }
	});
	Object.defineProperty(exports, "setMinutes", {
	  enumerable: true,
	  get: function () {
	    return _index199.default;
	  }
	});
	Object.defineProperty(exports, "setMonth", {
	  enumerable: true,
	  get: function () {
	    return _index200.default;
	  }
	});
	Object.defineProperty(exports, "setQuarter", {
	  enumerable: true,
	  get: function () {
	    return _index201.default;
	  }
	});
	Object.defineProperty(exports, "setSeconds", {
	  enumerable: true,
	  get: function () {
	    return _index202.default;
	  }
	});
	Object.defineProperty(exports, "setWeek", {
	  enumerable: true,
	  get: function () {
	    return _index203.default;
	  }
	});
	Object.defineProperty(exports, "setWeekYear", {
	  enumerable: true,
	  get: function () {
	    return _index204.default;
	  }
	});
	Object.defineProperty(exports, "setYear", {
	  enumerable: true,
	  get: function () {
	    return _index205.default;
	  }
	});
	Object.defineProperty(exports, "startOfDay", {
	  enumerable: true,
	  get: function () {
	    return _index206.default;
	  }
	});
	Object.defineProperty(exports, "startOfDecade", {
	  enumerable: true,
	  get: function () {
	    return _index207.default;
	  }
	});
	Object.defineProperty(exports, "startOfHour", {
	  enumerable: true,
	  get: function () {
	    return _index208.default;
	  }
	});
	Object.defineProperty(exports, "startOfISOWeek", {
	  enumerable: true,
	  get: function () {
	    return _index209.default;
	  }
	});
	Object.defineProperty(exports, "startOfISOWeekYear", {
	  enumerable: true,
	  get: function () {
	    return _index210.default;
	  }
	});
	Object.defineProperty(exports, "startOfMinute", {
	  enumerable: true,
	  get: function () {
	    return _index211.default;
	  }
	});
	Object.defineProperty(exports, "startOfMonth", {
	  enumerable: true,
	  get: function () {
	    return _index212.default;
	  }
	});
	Object.defineProperty(exports, "startOfQuarter", {
	  enumerable: true,
	  get: function () {
	    return _index213.default;
	  }
	});
	Object.defineProperty(exports, "startOfSecond", {
	  enumerable: true,
	  get: function () {
	    return _index214.default;
	  }
	});
	Object.defineProperty(exports, "startOfToday", {
	  enumerable: true,
	  get: function () {
	    return _index215.default;
	  }
	});
	Object.defineProperty(exports, "startOfTomorrow", {
	  enumerable: true,
	  get: function () {
	    return _index216.default;
	  }
	});
	Object.defineProperty(exports, "startOfWeek", {
	  enumerable: true,
	  get: function () {
	    return _index217.default;
	  }
	});
	Object.defineProperty(exports, "startOfWeekYear", {
	  enumerable: true,
	  get: function () {
	    return _index218.default;
	  }
	});
	Object.defineProperty(exports, "startOfYear", {
	  enumerable: true,
	  get: function () {
	    return _index219.default;
	  }
	});
	Object.defineProperty(exports, "startOfYesterday", {
	  enumerable: true,
	  get: function () {
	    return _index220.default;
	  }
	});
	Object.defineProperty(exports, "sub", {
	  enumerable: true,
	  get: function () {
	    return _index221.default;
	  }
	});
	Object.defineProperty(exports, "subBusinessDays", {
	  enumerable: true,
	  get: function () {
	    return _index222.default;
	  }
	});
	Object.defineProperty(exports, "subDays", {
	  enumerable: true,
	  get: function () {
	    return _index223.default;
	  }
	});
	Object.defineProperty(exports, "subHours", {
	  enumerable: true,
	  get: function () {
	    return _index224.default;
	  }
	});
	Object.defineProperty(exports, "subISOWeekYears", {
	  enumerable: true,
	  get: function () {
	    return _index225.default;
	  }
	});
	Object.defineProperty(exports, "subMilliseconds", {
	  enumerable: true,
	  get: function () {
	    return _index226.default;
	  }
	});
	Object.defineProperty(exports, "subMinutes", {
	  enumerable: true,
	  get: function () {
	    return _index227.default;
	  }
	});
	Object.defineProperty(exports, "subMonths", {
	  enumerable: true,
	  get: function () {
	    return _index228.default;
	  }
	});
	Object.defineProperty(exports, "subQuarters", {
	  enumerable: true,
	  get: function () {
	    return _index229.default;
	  }
	});
	Object.defineProperty(exports, "subSeconds", {
	  enumerable: true,
	  get: function () {
	    return _index230.default;
	  }
	});
	Object.defineProperty(exports, "subWeeks", {
	  enumerable: true,
	  get: function () {
	    return _index231.default;
	  }
	});
	Object.defineProperty(exports, "subYears", {
	  enumerable: true,
	  get: function () {
	    return _index232.default;
	  }
	});
	Object.defineProperty(exports, "toDate", {
	  enumerable: true,
	  get: function () {
	    return _index233.default;
	  }
	});
	Object.defineProperty(exports, "weeksToDays", {
	  enumerable: true,
	  get: function () {
	    return _index234.default;
	  }
	});
	Object.defineProperty(exports, "yearsToMonths", {
	  enumerable: true,
	  get: function () {
	    return _index235.default;
	  }
	});
	Object.defineProperty(exports, "yearsToQuarters", {
	  enumerable: true,
	  get: function () {
	    return _index236.default;
	  }
	});
	
	var _index = _interopRequireDefault(__webpack_require__(1542));
	
	var _index2 = _interopRequireDefault(__webpack_require__(624));
	
	var _index3 = _interopRequireDefault(__webpack_require__(95));
	
	var _index4 = _interopRequireDefault(__webpack_require__(261));
	
	var _index5 = _interopRequireDefault(__webpack_require__(625));
	
	var _index6 = _interopRequireDefault(__webpack_require__(208));
	
	var _index7 = _interopRequireDefault(__webpack_require__(262));
	
	var _index8 = _interopRequireDefault(__webpack_require__(170));
	
	var _index9 = _interopRequireDefault(__webpack_require__(384));
	
	var _index10 = _interopRequireDefault(__webpack_require__(626));
	
	var _index11 = _interopRequireDefault(__webpack_require__(209));
	
	var _index12 = _interopRequireDefault(__webpack_require__(385));
	
	var _index13 = _interopRequireDefault(__webpack_require__(1543));
	
	var _index14 = _interopRequireDefault(__webpack_require__(1544));
	
	var _index15 = _interopRequireDefault(__webpack_require__(1545));
	
	var _index16 = _interopRequireDefault(__webpack_require__(1546));
	
	var _index17 = _interopRequireDefault(__webpack_require__(146));
	
	var _index18 = _interopRequireDefault(__webpack_require__(1547));
	
	var _index19 = _interopRequireDefault(__webpack_require__(1548));
	
	var _index20 = _interopRequireDefault(__webpack_require__(1549));
	
	var _index21 = _interopRequireDefault(__webpack_require__(120));
	
	var _index22 = _interopRequireDefault(__webpack_require__(627));
	
	var _index23 = _interopRequireDefault(__webpack_require__(1550));
	
	var _index24 = _interopRequireDefault(__webpack_require__(386));
	
	var _index25 = _interopRequireDefault(__webpack_require__(1551));
	
	var _index26 = _interopRequireDefault(__webpack_require__(387));
	
	var _index27 = _interopRequireDefault(__webpack_require__(388));
	
	var _index28 = _interopRequireDefault(__webpack_require__(389));
	
	var _index29 = _interopRequireDefault(__webpack_require__(628));
	
	var _index30 = _interopRequireDefault(__webpack_require__(1552));
	
	var _index31 = _interopRequireDefault(__webpack_require__(263));
	
	var _index32 = _interopRequireDefault(__webpack_require__(629));
	
	var _index33 = _interopRequireDefault(__webpack_require__(264));
	
	var _index34 = _interopRequireDefault(__webpack_require__(1553));
	
	var _index35 = _interopRequireDefault(__webpack_require__(390));
	
	var _index36 = _interopRequireDefault(__webpack_require__(1554));
	
	var _index37 = _interopRequireDefault(__webpack_require__(630));
	
	var _index38 = _interopRequireDefault(__webpack_require__(631));
	
	var _index39 = _interopRequireDefault(__webpack_require__(1555));
	
	var _index40 = _interopRequireDefault(__webpack_require__(1556));
	
	var _index41 = _interopRequireDefault(__webpack_require__(1557));
	
	var _index42 = _interopRequireDefault(__webpack_require__(1558));
	
	var _index43 = _interopRequireDefault(__webpack_require__(1559));
	
	var _index44 = _interopRequireDefault(__webpack_require__(391));
	
	var _index45 = _interopRequireDefault(__webpack_require__(1560));
	
	var _index46 = _interopRequireDefault(__webpack_require__(1561));
	
	var _index47 = _interopRequireDefault(__webpack_require__(1562));
	
	var _index48 = _interopRequireDefault(__webpack_require__(265));
	
	var _index49 = _interopRequireDefault(__webpack_require__(1563));
	
	var _index50 = _interopRequireDefault(__webpack_require__(1564));
	
	var _index51 = _interopRequireDefault(__webpack_require__(1566));
	
	var _index52 = _interopRequireDefault(__webpack_require__(1565));
	
	var _index53 = _interopRequireDefault(__webpack_require__(1567));
	
	var _index54 = _interopRequireDefault(__webpack_require__(266));
	
	var _index55 = _interopRequireDefault(__webpack_require__(1568));
	
	var _index56 = _interopRequireDefault(__webpack_require__(1569));
	
	var _index57 = _interopRequireDefault(__webpack_require__(1570));
	
	var _index58 = _interopRequireDefault(__webpack_require__(1571));
	
	var _index59 = _interopRequireDefault(__webpack_require__(392));
	
	var _index60 = _interopRequireDefault(__webpack_require__(632));
	
	var _index61 = _interopRequireDefault(__webpack_require__(1572));
	
	var _index62 = _interopRequireDefault(__webpack_require__(393));
	
	var _index63 = _interopRequireDefault(__webpack_require__(634));
	
	var _index64 = _interopRequireDefault(__webpack_require__(633));
	
	var _index65 = _interopRequireDefault(__webpack_require__(1574));
	
	var _index66 = _interopRequireDefault(__webpack_require__(1573));
	
	var _index67 = _interopRequireDefault(__webpack_require__(1575));
	
	var _index68 = _interopRequireDefault(__webpack_require__(1578));
	
	var _index69 = _interopRequireDefault(__webpack_require__(1576));
	
	var _index70 = _interopRequireDefault(__webpack_require__(1577));
	
	var _index71 = _interopRequireDefault(__webpack_require__(1579));
	
	var _index72 = _interopRequireDefault(__webpack_require__(1580));
	
	var _index73 = _interopRequireDefault(__webpack_require__(1581));
	
	var _index74 = _interopRequireDefault(__webpack_require__(1582));
	
	var _index75 = _interopRequireDefault(__webpack_require__(394));
	
	var _index76 = _interopRequireDefault(__webpack_require__(210));
	
	var _index77 = _interopRequireDefault(__webpack_require__(1583));
	
	var _index78 = _interopRequireDefault(__webpack_require__(635));
	
	var _index79 = _interopRequireDefault(__webpack_require__(1584));
	
	var _index80 = _interopRequireDefault(__webpack_require__(1585));
	
	var _index81 = _interopRequireDefault(__webpack_require__(636));
	
	var _index82 = _interopRequireDefault(__webpack_require__(637));
	
	var _index83 = _interopRequireDefault(__webpack_require__(638));
	
	var _index84 = _interopRequireDefault(__webpack_require__(171));
	
	var _index85 = _interopRequireDefault(__webpack_require__(1586));
	
	var _index86 = _interopRequireDefault(__webpack_require__(1587));
	
	var _index87 = _interopRequireDefault(__webpack_require__(639));
	
	var _index88 = _interopRequireDefault(__webpack_require__(640));
	
	var _index89 = _interopRequireDefault(__webpack_require__(1588));
	
	var _index90 = _interopRequireDefault(__webpack_require__(395));
	
	var _index91 = _interopRequireDefault(__webpack_require__(641));
	
	var _index92 = _interopRequireDefault(__webpack_require__(396));
	
	var _index93 = _interopRequireDefault(__webpack_require__(1589));
	
	var _index94 = _interopRequireDefault(__webpack_require__(397));
	
	var _index95 = _interopRequireDefault(__webpack_require__(1590));
	
	var _index96 = _interopRequireDefault(__webpack_require__(642));
	
	var _index97 = _interopRequireDefault(__webpack_require__(1591));
	
	var _index98 = _interopRequireDefault(__webpack_require__(643));
	
	var _index99 = _interopRequireDefault(__webpack_require__(1592));
	
	var _index100 = _interopRequireDefault(__webpack_require__(1593));
	
	var _index101 = _interopRequireDefault(__webpack_require__(1594));
	
	var _index102 = _interopRequireDefault(__webpack_require__(1595));
	
	var _index103 = _interopRequireDefault(__webpack_require__(1596));
	
	var _index104 = _interopRequireDefault(__webpack_require__(644));
	
	var _index105 = _interopRequireDefault(__webpack_require__(645));
	
	var _index106 = _interopRequireDefault(__webpack_require__(398));
	
	var _index107 = _interopRequireDefault(__webpack_require__(646));
	
	var _index108 = _interopRequireDefault(__webpack_require__(1597));
	
	var _index109 = _interopRequireDefault(__webpack_require__(1598));
	
	var _index110 = _interopRequireDefault(__webpack_require__(1599));
	
	var _index111 = _interopRequireDefault(__webpack_require__(1600));
	
	var _index112 = _interopRequireDefault(__webpack_require__(647));
	
	var _index113 = _interopRequireDefault(__webpack_require__(648));
	
	var _index114 = _interopRequireDefault(__webpack_require__(1601));
	
	var _index115 = _interopRequireDefault(__webpack_require__(1602));
	
	var _index116 = _interopRequireDefault(__webpack_require__(1603));
	
	var _index117 = _interopRequireDefault(__webpack_require__(172));
	
	var _index118 = _interopRequireDefault(__webpack_require__(649));
	
	var _index119 = _interopRequireDefault(__webpack_require__(650));
	
	var _index120 = _interopRequireDefault(__webpack_require__(1604));
	
	var _index121 = _interopRequireDefault(__webpack_require__(651));
	
	var _index122 = _interopRequireDefault(__webpack_require__(399));
	
	var _index123 = _interopRequireDefault(__webpack_require__(400));
	
	var _index124 = _interopRequireDefault(__webpack_require__(652));
	
	var _index125 = _interopRequireDefault(__webpack_require__(401));
	
	var _index126 = _interopRequireDefault(__webpack_require__(402));
	
	var _index127 = _interopRequireDefault(__webpack_require__(653));
	
	var _index128 = _interopRequireDefault(__webpack_require__(403));
	
	var _index129 = _interopRequireDefault(__webpack_require__(1605));
	
	var _index130 = _interopRequireDefault(__webpack_require__(1606));
	
	var _index131 = _interopRequireDefault(__webpack_require__(1607));
	
	var _index132 = _interopRequireDefault(__webpack_require__(1608));
	
	var _index133 = _interopRequireDefault(__webpack_require__(1609));
	
	var _index134 = _interopRequireDefault(__webpack_require__(1610));
	
	var _index135 = _interopRequireDefault(__webpack_require__(1611));
	
	var _index136 = _interopRequireDefault(__webpack_require__(1612));
	
	var _index137 = _interopRequireDefault(__webpack_require__(1613));
	
	var _index138 = _interopRequireDefault(__webpack_require__(1614));
	
	var _index139 = _interopRequireDefault(__webpack_require__(1615));
	
	var _index140 = _interopRequireDefault(__webpack_require__(1616));
	
	var _index141 = _interopRequireDefault(__webpack_require__(96));
	
	var _index142 = _interopRequireDefault(__webpack_require__(1617));
	
	var _index143 = _interopRequireDefault(__webpack_require__(267));
	
	var _index144 = _interopRequireDefault(__webpack_require__(654));
	
	var _index145 = _interopRequireDefault(__webpack_require__(1618));
	
	var _index146 = _interopRequireDefault(__webpack_require__(1619));
	
	var _index147 = _interopRequireDefault(__webpack_require__(1621));
	
	var _index148 = _interopRequireDefault(__webpack_require__(1620));
	
	var _index149 = _interopRequireDefault(__webpack_require__(655));
	
	var _index150 = _interopRequireDefault(__webpack_require__(1622));
	
	var _index151 = _interopRequireDefault(__webpack_require__(656));
	
	var _index152 = _interopRequireDefault(__webpack_require__(1623));
	
	var _index153 = _interopRequireDefault(__webpack_require__(1624));
	
	var _index154 = _interopRequireDefault(__webpack_require__(409));
	
	var _index155 = _interopRequireDefault(__webpack_require__(1643));
	
	var _index156 = _interopRequireDefault(__webpack_require__(1640));
	
	var _index157 = _interopRequireDefault(__webpack_require__(1641));
	
	var _index158 = _interopRequireDefault(__webpack_require__(1642));
	
	var _index159 = _interopRequireDefault(__webpack_require__(410));
	
	var _index160 = _interopRequireDefault(__webpack_require__(1644));
	
	var _index161 = _interopRequireDefault(__webpack_require__(1645));
	
	var _index162 = _interopRequireDefault(__webpack_require__(1646));
	
	var _index163 = _interopRequireDefault(__webpack_require__(1647));
	
	var _index164 = _interopRequireDefault(__webpack_require__(1648));
	
	var _index165 = _interopRequireDefault(__webpack_require__(121));
	
	var _index166 = _interopRequireDefault(__webpack_require__(1649));
	
	var _index167 = _interopRequireDefault(__webpack_require__(1650));
	
	var _index168 = _interopRequireDefault(__webpack_require__(1651));
	
	var _index169 = _interopRequireDefault(__webpack_require__(1652));
	
	var _index170 = _interopRequireDefault(__webpack_require__(1653));
	
	var _index171 = _interopRequireDefault(__webpack_require__(1654));
	
	var _index172 = _interopRequireDefault(__webpack_require__(1655));
	
	var _index173 = _interopRequireDefault(__webpack_require__(411));
	
	var _index174 = _interopRequireDefault(__webpack_require__(658));
	
	var _index175 = _interopRequireDefault(__webpack_require__(1656));
	
	var _index176 = _interopRequireDefault(__webpack_require__(122));
	
	var _index177 = _interopRequireDefault(__webpack_require__(1658));
	
	var _index178 = _interopRequireDefault(__webpack_require__(1659));
	
	var _index179 = _interopRequireDefault(__webpack_require__(1660));
	
	var _index180 = _interopRequireDefault(__webpack_require__(1661));
	
	var _index181 = _interopRequireDefault(__webpack_require__(1662));
	
	var _index182 = _interopRequireDefault(__webpack_require__(1663));
	
	var _index183 = _interopRequireDefault(__webpack_require__(1664));
	
	var _index184 = _interopRequireDefault(__webpack_require__(1665));
	
	var _index185 = _interopRequireDefault(__webpack_require__(1666));
	
	var _index186 = _interopRequireDefault(__webpack_require__(1667));
	
	var _index187 = _interopRequireDefault(__webpack_require__(1668));
	
	var _index188 = _interopRequireDefault(__webpack_require__(1669));
	
	var _index189 = _interopRequireDefault(__webpack_require__(1670));
	
	var _index190 = _interopRequireDefault(__webpack_require__(1679));
	
	var _index191 = _interopRequireDefault(__webpack_require__(1671));
	
	var _index192 = _interopRequireDefault(__webpack_require__(1673));
	
	var _index193 = _interopRequireDefault(__webpack_require__(1672));
	
	var _index194 = _interopRequireDefault(__webpack_require__(659));
	
	var _index195 = _interopRequireDefault(__webpack_require__(1674));
	
	var _index196 = _interopRequireDefault(__webpack_require__(1675));
	
	var _index197 = _interopRequireDefault(__webpack_require__(660));
	
	var _index198 = _interopRequireDefault(__webpack_require__(1676));
	
	var _index199 = _interopRequireDefault(__webpack_require__(661));
	
	var _index200 = _interopRequireDefault(__webpack_require__(268));
	
	var _index201 = _interopRequireDefault(__webpack_require__(662));
	
	var _index202 = _interopRequireDefault(__webpack_require__(663));
	
	var _index203 = _interopRequireDefault(__webpack_require__(1678));
	
	var _index204 = _interopRequireDefault(__webpack_require__(1677));
	
	var _index205 = _interopRequireDefault(__webpack_require__(664));
	
	var _index206 = _interopRequireDefault(__webpack_require__(211));
	
	var _index207 = _interopRequireDefault(__webpack_require__(1680));
	
	var _index208 = _interopRequireDefault(__webpack_require__(665));
	
	var _index209 = _interopRequireDefault(__webpack_require__(148));
	
	var _index210 = _interopRequireDefault(__webpack_require__(212));
	
	var _index211 = _interopRequireDefault(__webpack_require__(412));
	
	var _index212 = _interopRequireDefault(__webpack_require__(213));
	
	var _index213 = _interopRequireDefault(__webpack_require__(269));
	
	var _index214 = _interopRequireDefault(__webpack_require__(666));
	
	var _index215 = _interopRequireDefault(__webpack_require__(1681));
	
	var _index216 = _interopRequireDefault(__webpack_require__(1682));
	
	var _index217 = _interopRequireDefault(__webpack_require__(109));
	
	var _index218 = _interopRequireDefault(__webpack_require__(413));
	
	var _index219 = _interopRequireDefault(__webpack_require__(270));
	
	var _index220 = _interopRequireDefault(__webpack_require__(1683));
	
	var _index221 = _interopRequireDefault(__webpack_require__(672));
	
	var _index222 = _interopRequireDefault(__webpack_require__(1684));
	
	var _index223 = _interopRequireDefault(__webpack_require__(214));
	
	var _index224 = _interopRequireDefault(__webpack_require__(667));
	
	var _index225 = _interopRequireDefault(__webpack_require__(668));
	
	var _index226 = _interopRequireDefault(__webpack_require__(215));
	
	var _index227 = _interopRequireDefault(__webpack_require__(669));
	
	var _index228 = _interopRequireDefault(__webpack_require__(414));
	
	var _index229 = _interopRequireDefault(__webpack_require__(1685));
	
	var _index230 = _interopRequireDefault(__webpack_require__(1686));
	
	var _index231 = _interopRequireDefault(__webpack_require__(670));
	
	var _index232 = _interopRequireDefault(__webpack_require__(671));
	
	var _index233 = _interopRequireDefault(__webpack_require__(9));
	
	var _index234 = _interopRequireDefault(__webpack_require__(1687));
	
	var _index235 = _interopRequireDefault(__webpack_require__(1688));
	
	var _index236 = _interopRequireDefault(__webpack_require__(1689));
	
	var _index237 = __webpack_require__(45);
	
	Object.keys(_index237).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _index237[key];
	    }
	  });
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfISOWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(109));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfISOWeek
	 * @category ISO Week Helpers
	 * @summary Return the start of an ISO week for the given date.
	 *
	 * @description
	 * Return the start of an ISO week for the given date.
	 * The result will be in the local timezone.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of an ISO week
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of an ISO week for 2 September 2014 11:55:00:
	 * var result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Mon Sep 01 2014 00:00:00
	 */
	function startOfISOWeek(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, {
	    weekStartsOn: 1
	  });
	}
	
	module.exports = exports.default;

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(2078),
	    getValue = __webpack_require__(2122);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(38),
	    isLength = __webpack_require__(453);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4)["default"];
	
	exports.__esModule = true;
	exports["default"] = exports.ReactReduxContext = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var ReactReduxContext = /*#__PURE__*/_react["default"].createContext(null);
	
	exports.ReactReduxContext = ReactReduxContext;
	
	if (false) {
	  ReactReduxContext.displayName = 'ReactRedux';
	}
	
	var _default = ReactReduxContext;
	exports["default"] = _default;

/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(71));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _reduceCssCalc = _interopRequireDefault(__webpack_require__(2436));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _DataUtils = __webpack_require__(39);
	
	var _ReactUtils = __webpack_require__(29);
	
	var _DOMUtils = __webpack_require__(312);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var BREAKING_SPACES = /[ \f\n\r\t\v\u2028\u2029]+/;
	
	var calculateWordWidths = function calculateWordWidths(props) {
	  try {
	    var words = !(0, _isNil2["default"])(props.children) ? props.children.toString().split(BREAKING_SPACES) : [];
	    var wordsWithComputedWidth = words.map(function (word) {
	      return {
	        word: word,
	        width: (0, _DOMUtils.getStringSize)(word, props.style).width
	      };
	    });
	    var spaceWidth = (0, _DOMUtils.getStringSize)("\xA0", props.style).width;
	    return {
	      wordsWithComputedWidth: wordsWithComputedWidth,
	      spaceWidth: spaceWidth
	    };
	  } catch (e) {
	    return null;
	  }
	};
	
	var Text =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(Text, _Component);
	
	  function Text(_props) {
	    var _this;
	
	    _classCallCheck(this, Text);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(Text).call(this, _props));
	
	    _this.getWordsWithoutCalculate = function (props) {
	      var words = !(0, _isNil2["default"])(props.children) ? props.children.toString().split(BREAKING_SPACES) : [];
	      return [{
	        words: words
	      }];
	    };
	
	    _this.state = {
	      wordsByLines: _this.getWordsByLines(_props, true)
	    };
	    return _this;
	  }
	
	  _createClass(Text, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.updateWordsByLines(this.props, true);
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.width !== this.props.width || prevProps.scaleToFit !== this.props.scaleToFit || prevProps.children !== this.props.children || prevProps.style !== this.props.style) {
	        var needCalculate = this.props.children !== prevProps.children || this.props.style !== prevProps.style;
	        this.updateWordsByLines(this.props, needCalculate);
	      }
	    }
	  }, {
	    key: "updateWordsByLines",
	    value: function updateWordsByLines(props, needCalculate) {
	      this.setState({
	        wordsByLines: this.getWordsByLines(props, needCalculate)
	      });
	    }
	  }, {
	    key: "getWordsByLines",
	    value: function getWordsByLines(props, needCalculate) {
	      // Only perform calculations if using features that require them (multiline, scaleToFit)
	      if ((props.width || props.scaleToFit) && !(0, _ReactUtils.isSsr)()) {
	        if (needCalculate) {
	          var wordWidths = calculateWordWidths(props);
	
	          if (wordWidths) {
	            var wordsWithComputedWidth = wordWidths.wordsWithComputedWidth,
	                spaceWidth = wordWidths.spaceWidth;
	            this.wordsWithComputedWidth = wordsWithComputedWidth;
	            this.spaceWidth = spaceWidth;
	          } else {
	            return this.getWordsWithoutCalculate(props);
	          }
	        }
	
	        return this.calculateWordsByLines(this.wordsWithComputedWidth, this.spaceWidth, props.width);
	      }
	
	      return this.getWordsWithoutCalculate(props);
	    }
	  }, {
	    key: "calculateWordsByLines",
	    value: function calculateWordsByLines(wordsWithComputedWidth, spaceWidth, lineWidth) {
	      var scaleToFit = this.props.scaleToFit;
	      return (wordsWithComputedWidth || []).reduce(function (result, _ref) {
	        var word = _ref.word,
	            width = _ref.width;
	        var currentLine = result[result.length - 1];
	
	        if (currentLine && (lineWidth == null || scaleToFit || currentLine.width + width + spaceWidth < lineWidth)) {
	          // Word can be added to an existing line
	          currentLine.words.push(word);
	          currentLine.width += width + spaceWidth;
	        } else {
	          // Add first word to line or word is too long to scaleToFit on existing line
	          var newLine = {
	            words: [word],
	            width: width
	          };
	          result.push(newLine);
	        }
	
	        return result;
	      }, []);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          dx = _this$props.dx,
	          dy = _this$props.dy,
	          textAnchor = _this$props.textAnchor,
	          verticalAnchor = _this$props.verticalAnchor,
	          scaleToFit = _this$props.scaleToFit,
	          angle = _this$props.angle,
	          lineHeight = _this$props.lineHeight,
	          capHeight = _this$props.capHeight,
	          className = _this$props.className,
	          textProps = _objectWithoutProperties(_this$props, ["dx", "dy", "textAnchor", "verticalAnchor", "scaleToFit", "angle", "lineHeight", "capHeight", "className"]);
	
	      var wordsByLines = this.state.wordsByLines;
	
	      if (!(0, _DataUtils.isNumOrStr)(textProps.x) || !(0, _DataUtils.isNumOrStr)(textProps.y)) {
	        return null;
	      }
	
	      var x = textProps.x + ((0, _DataUtils.isNumber)(dx) ? dx : 0);
	      var y = textProps.y + ((0, _DataUtils.isNumber)(dy) ? dy : 0);
	      var startDy;
	
	      switch (verticalAnchor) {
	        case 'start':
	          startDy = (0, _reduceCssCalc["default"])("calc(".concat(capHeight, ")"));
	          break;
	
	        case 'middle':
	          startDy = (0, _reduceCssCalc["default"])("calc(".concat((wordsByLines.length - 1) / 2, " * -").concat(lineHeight, " + (").concat(capHeight, " / 2))"));
	          break;
	
	        default:
	          startDy = (0, _reduceCssCalc["default"])("calc(".concat(wordsByLines.length - 1, " * -").concat(lineHeight, ")"));
	          break;
	      }
	
	      var transforms = [];
	
	      if (scaleToFit) {
	        var lineWidth = wordsByLines[0].width;
	        transforms.push("scale(".concat(this.props.width / lineWidth, ")"));
	      }
	
	      if (angle) {
	        transforms.push("rotate(".concat(angle, ", ").concat(x, ", ").concat(y, ")"));
	      }
	
	      if (transforms.length) {
	        textProps.transform = transforms.join(' ');
	      }
	
	      return _react["default"].createElement("text", _extends({}, (0, _ReactUtils.getPresentationAttributes)(textProps), (0, _ReactUtils.filterEventAttributes)(textProps), {
	        x: x,
	        y: y,
	        className: (0, _classnames["default"])('recharts-text', className),
	        textAnchor: textAnchor
	      }), wordsByLines.map(function (line, index) {
	        return (// eslint-disable-next-line react/no-array-index-key
	          _react["default"].createElement("tspan", {
	            x: x,
	            dy: index === 0 ? startDy : lineHeight,
	            key: index
	          }, line.words.join(' '))
	        );
	      }));
	    }
	  }]);
	
	  return Text;
	}(_react.Component);
	
	Text.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  scaleToFit: _propTypes["default"].bool,
	  angle: _propTypes["default"].number,
	  textAnchor: _propTypes["default"].oneOf(['start', 'middle', 'end', 'inherit']),
	  verticalAnchor: _propTypes["default"].oneOf(['start', 'middle', 'end']),
	  style: _propTypes["default"].object
	});
	Text.defaultProps = {
	  x: 0,
	  y: 0,
	  lineHeight: '1em',
	  capHeight: '0.71em',
	  // Magic number from d3
	  scaleToFit: false,
	  textAnchor: 'start',
	  verticalAnchor: 'end' // Maintain compat with existing charts / default SVG behavior
	
	};
	var _default = Text;
	exports["default"] = _default;

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _ReactUtils = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var Dot =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Dot, _PureComponent);
	
	  function Dot() {
	    _classCallCheck(this, Dot);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(Dot).apply(this, arguments));
	  }
	
	  _createClass(Dot, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          cx = _this$props.cx,
	          cy = _this$props.cy,
	          r = _this$props.r,
	          className = _this$props.className;
	      var layerClass = (0, _classnames["default"])('recharts-dot', className);
	
	      if (cx === +cx && cy === +cy && r === +r) {
	        return _react["default"].createElement("circle", _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props, null, true), {
	          className: layerClass,
	          cx: cx,
	          cy: cy,
	          r: r
	        }));
	      }
	
	      return null;
	    }
	  }]);
	
	  return Dot;
	}(_react.PureComponent);
	
	Dot.displayName = 'Dot';
	Dot.propTypes = {
	  className: _propTypes["default"].string,
	  cx: _propTypes["default"].number,
	  cy: _propTypes["default"].number,
	  r: _propTypes["default"].number
	};
	var _default = Dot;
	exports["default"] = _default;

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(129)["default"];
	function _getRequireWildcardCache(e) {
	  if ("function" != typeof WeakMap) return null;
	  var r = new WeakMap(),
	    t = new WeakMap();
	  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
	    return e ? t : r;
	  })(e);
	}
	function _interopRequireWildcard(e, r) {
	  if (!r && e && e.__esModule) return e;
	  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
	    "default": e
	  };
	  var t = _getRequireWildcardCache(r);
	  if (t && t.has(e)) return t.get(e);
	  var n = {
	      __proto__: null
	    },
	    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
	  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
	    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
	    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
	  }
	  return n["default"] = e, t && t.set(e, n), n;
	}
	module.exports = _interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _customCell = __webpack_require__(509);
	
	var _customComponents = __webpack_require__(59);
	
	var _Logger = __webpack_require__(37);
	
	var _singletonSharedData = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SelectComponent = function (_Component) {
	  _inherits(SelectComponent, _Component);
	
	  // PROPS:
	  // customCell : Nombre de la celda que lo va a mapear, esta celda deber ir en customCell.js
	  // parameters : objecto con los parametros que se van a mapear en la celda
	  // dataSource : array de objetos a listar
	  // cellsStyles : estilo de la celda en hover
	  // onSelectItem : funcion que se ejecutara cuando se seleccione una celda
	  // onDisplayList : funcion que se ejecuta cuando se abren las opciones, esto se usa solo en caso de que solo un selectComponent pueda permanecer abierto
	  // itemDefault : item de la lista que aparece por default
	  // displayedList : Componente que esta actualmente abierto
	  // displayer : Nombre del boton para desplegar la lista de opcinoes, debe esta en customComponents.js
	  // defaultDiv : Nombre del div default en caso de necesitar uno especial añadir en customComponents.js => por default es un div con el texto : seleccione una opcion
	  // closeOthers : En true para cerrar la lista de opciones de los demas selectComponent, en caso de que solo una pueda estar abierta
	  // tag : Tag para identificar cada selectComponent que este dentro de un componente
	  // bottomBox : El maximo fondo para que aparezcan las opciones, si la lista esta mas abajo se muesta para arriba, por default 0
	  // maxHeigh : El maximo tamaño de la lista de opciones desplegadas
	  // disabled : Si esta desabilitado el despliegue de informacion, por default false
	  // styleContainer : Nombre de una clase con estilos css para el contenedor
	  function SelectComponent(props) {
	    _classCallCheck(this, SelectComponent);
	
	    var _this2 = _possibleConstructorReturn(this, (SelectComponent.__proto__ || Object.getPrototypeOf(SelectComponent)).call(this, props));
	
	    _this2.deployOptions = function () {
	      _Logger.Logger.Trace('[Select Component][selectItem] clicked!');
	      if (_this2.isBlur) {
	        _this2.setState({ displayOptions: !_this2.state.displayOptions });
	      } else {
	        _this2.setState({ displayOptions: true });
	      }
	    };
	
	    _this2.state = {
	      displayOptions: false,
	      selectedDiv: _this2.props.initialSelection,
	      displayedList: _this2.props.displayedComponent ? _this2.props.displayedComponent : -1,
	      bottomBox: _this2.props.bottomBox || 0.0,
	      invertedList: false,
	      maxHeigh: _this2.props.maxHeigh || 100,
	      disabled: _this2.props.disabled || false,
	      itemProposed: null
	    };
	    _this2.searching = "";
	    _this2.isBlur = false;
	
	    _this2.onSearching = _this2.onSearching.bind(_this2);
	    _this2.setDataSource(_this2.props.dataSource);
	    _this2.sharedData = new _singletonSharedData.SingletonSharedData();
	    _this2.isHidePhone = _this2.sharedData.getGeneralPermissions()[223];
	    _this2.cellContainerRef = _react2.default.createRef();
	    _this2.itemChange = null;
	    return _this2;
	  }
	
	  _createClass(SelectComponent, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.selectItemRef = this.refs["selectItem"];
	      this.setSelectdedItem();
	      window.addEventListener("keydown", this.onSearching, false);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps) if (this.props.dataSource !== nextProps.dataSource) {
	        this.setDataSource(nextProps.dataSource);
	        this.setSelectdedItem();
	      }
	      if (this.props.closeOthers && nextProps.displayedList !== this.props.displayedList && nextProps.displayedList !== this.props.tag) {
	        this.setState({ displayOptions: false });
	      }
	      this.setState({ disabled: nextProps.disabled || false });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener("keydown", this.onSearching, false);
	      this.props.tag && _Logger.Logger.Trace('[RateCall] Select Component no \xB4' + this.props.tag + '\xB4 was visibled\xB4');
	    }
	  }, {
	    key: 'setDataSource',
	    value: function setDataSource(dataSource) {
	      this.dataSource = [];
	      if (this.props.parameters) {
	        this.parameters = this.props.parameters;
	        for (var i in dataSource) {
	          var item = dataSource[i];
	          item["proposed"] = false;
	          this.dataSource.push(item);
	        }
	      } else {
	        this.parameters = { text: "text" };
	        for (var _i in dataSource) {
	          var _item = dataSource[_i];
	          var obj = { text: _item, proposed: false };
	          this.dataSource.push(obj);
	        }
	      }
	    }
	    //cellImageText: (item, parameters, cellStyles, selectCell, hidePhone) => {
	
	  }, {
	    key: 'setSelectdedItem',
	    value: function setSelectdedItem() {
	      if (typeof this.props.itemDefault === 'number' && this.dataSource[this.props.itemDefault]) {
	        this.props.onSelectItem(this.dataSource[this.props.itemDefault]);
	        this.setState(this.props.customCell === 'cellImageText' ? {
	          selectedDiv: _customCell.CUSTOM_CELLS[this.props.customCell](this.dataSource[this.props.itemDefault], this.parameters, "transparent", null, this.isHidePhone)
	        } : {
	          selectedDiv: _customCell.CUSTOM_CELLS[this.props.customCell](this.dataSource[this.props.itemDefault], this.parameters, "transparent")
	        });
	      } else {
	        var defaultDiv = this.props.defaultDiv ? this.props.defaultDiv.item : "texSelection";
	        var defaultText = this.props.defaultDiv && this.props.defaultDiv.text;
	        var styles = this.props.defaultDiv && this.props.defaultDiv.styles;
	        this.setState({
	          selectedDiv: _customComponents.CUSTOM_COMPONENTS[defaultDiv](defaultText, styles)
	        });
	      }
	    }
	    /*checkInverted() {
	      let rectContainer = ReactDOM.findDOMNode(this).getBoundingClientRect();
	      let inverted = (rectContainer.bottom + rectContainer.height + this.state.bottomBox + this.state.maxHeigh) > window.innerHeight;
	      if (inverted !== this.state.invertedList) {
	        this.setState({ invertedList: inverted });
	      }
	    }*/
	
	  }, {
	    key: 'resetProposedItem',
	    value: function resetProposedItem() {
	      this.searching = "";
	      for (var i in this.dataSource) {
	        var item = this.dataSource[i];
	        item["proposed"] = false;
	      }
	      this.setState({ itemProposed: null });
	    }
	  }, {
	    key: 'selectItem',
	    value: function selectItem(item) {
	      this.props.onSelectItem(item);
	      _Logger.Logger.Trace('[Select Component] an item was selected by the agent ' + item);
	      _Logger.Logger.Trace('[Select Component][selectItem] item:  ' + item);
	      this.setState({
	        selectedDiv: _customCell.CUSTOM_CELLS[this.props.customCell](item, this.parameters, "transparent", null, this.isHidePhone),
	        displayOptions: false
	      });
	      this.resetProposedItem();
	    }
	  }, {
	    key: 'displayOptions',
	    value: function displayOptions() {
	      if (this.props.closeOthers) {
	        this.props.onDisplayList && this.props.onDisplayList(this.props.tag);
	      }
	      this.resetProposedItem();
	      this.selectItemRef.focus();
	    }
	  }, {
	    key: 'renderOptions',
	    value: function renderOptions() {
	      var _this3 = this;
	
	      var styles = { maxHeight: this.state.maxHeigh };
	      return _react2.default.createElement(
	        'ul',
	        { ref: this.cellContainerRef, className: "listCellsSelect " + (this.state.invertedList && "inverted"), style: styles },
	        this.dataSource.map(function (item) {
	          return _customCell.CUSTOM_CELLS[_this3.props.customCell](item, _this3.parameters, "selectable " + (_this3.props.cellsStyles || "hoverGray ") + (item.proposed && (_this3.props.proposedStyles || "normalProposed ")), _this3.selectItem.bind(_this3), _this3.isHidePhone);
	        })
	      );
	    }
	  }, {
	    key: 'onSearching',
	    value: function onSearching(e) {
	      if (this.state.displayOptions) {
	        if (e.key === "Backspace" && e.target.tagName.toLowerCase() != "textarea") {
	          _Logger.Logger.Trace('[Select Component] backspace e:' + e);
	          e.preventDefault();
	        }
	        if (e.key === "Enter") {
	          if (this.state.itemProposed) {
	            ;
	            this.selectItem(this.state.itemProposed);
	          }
	        } else {
	          this.searching += e.key;
	          for (var i in this.dataSource) {
	            var item = this.dataSource[i];
	            item["proposed"] = false;
	            for (var p in this.parameters) {
	              var parameter = item[this.parameters[p]];
	              if ((typeof parameter === 'string' || typeof parameter === 'number') && !parameter.toLowerCase().includes(".svg")) {
	                //NOT SEARCH IN OBJECTS, NOT SEARCH IN SVG FILES (IMAGES)
	                if (parameter.toLowerCase().startsWith(this.searching.toLowerCase()) && this.cellContainerRef) {
	                  _Logger.Logger.Trace('[Select Component][selectItem] onkeyDown', e, this.cellContainerRef);
	                  item["proposed"] = true;
	                  var scroll = (parseInt(i, 10) - 1) * 25;
	                  this.cellContainerRef.current.scrollTo(0, scroll);
	                  this.setState({ itemProposed: item });
	                  return;
	                }
	              }
	            }
	          }
	          this.resetProposedItem();
	        }
	      }
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      if (this.selectItemRef !== this.itemChange) {
	        this.setState({ displayOptions: true });
	      }
	      this.selectItemRef.focus();
	      if (this.props.onFocus) {
	        this.props.onFocus();
	      }
	      var _this = this;
	      setTimeout(function () {
	        _this.isBlur = true;
	      }, 100);
	      this.itemChange = this.selectItemRef;
	    }
	  }, {
	    key: 'blur',
	    value: function blur() {
	      this.isBlur = false;
	      this.setState({ displayOptions: false });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: "selectComponent " + (this.state.disabled && "disabled"), ref: 'selectItem', tabIndex: '1', onClick: this.deployOptions, onFocus: function onFocus() {
	            return _this4.focus();
	          }, onBlur: function onBlur() {
	            return _this4.blur();
	          } },
	        _react2.default.createElement(
	          'div',
	          { className: "selectComponentContainer " + (this.props.styleContainer || "normalBorder") },
	          _customComponents.CUSTOM_COMPONENTS[this.props.displayer](this.displayOptions.bind(this), this.props.stylesSelector, this.state.invertedList),
	          _react2.default.createElement(
	            'div',
	            { className: 'selectedDiv' },
	            this.state.selectedDiv
	          )
	        ),
	        this.state.displayOptions && this.renderOptions()
	      );
	    }
	  }]);
	
	  return SelectComponent;
	}(_react.Component);
	
	exports.default = SelectComponent;

/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.callAction = callAction;
	exports.actionHangUpCall = actionHangUpCall;
	exports.actionNotifyAlreadyWrapUp = actionNotifyAlreadyWrapUp;
	exports.actionMuteCall = actionMuteCall;
	exports.actionHoldCall = actionHoldCall;
	exports.actionStartStopRecording = actionStartStopRecording;
	exports.actionDTMF = actionDTMF;
	
	var _constants = __webpack_require__(10);
	
	function callAction(type) {
	  var parameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var callOutId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	
	  return {
	    type: type,
	    parameters: parameters,
	    callOutId: callOutId
	  };
	}
	
	function actionHangUpCall() {
	  return {
	    type: _constants.ACTION_CALL_ACD.HANGUP
	  };
	}
	
	function actionNotifyAlreadyWrapUp() {
	  return {
	    type: _constants.ACTION_CALL_ACD.ALREADY_WRAPUP
	  };
	}
	
	function actionMuteCall(value) {
	  return {
	    type: _constants.ACTION_CALL_ACD.MUTE,
	    value: value
	  };
	}
	
	function actionHoldCall() {
	  return {
	    type: _constants.ACTION_CALL_ACD.HOLD
	  };
	}
	
	function actionStartStopRecording(isStop) {
	  return {
	    type: _constants.ACTION_CALL_ACD.START_STOP_RECORDING,
	    isStop: isStop
	  };
	}
	
	function actionDTMF(digit) {
	  return {
	    type: _constants.ACTION_CALL_ACD.DTMF,
	    digit: digit
	  };
	}

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1227), __esModule: true };

/***/ },
/* 158 */
[2624, 160],
/* 159 */
[2632, 133, 200, 116],
/* 160 */
36,
/* 161 */
/***/ function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ },
/* 162 */
/***/ function(module, exports) {

	module.exports = {};


/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(68);
	module.exports = function (target, src, safe) {
	  for (var key in src) redefine(target, key, src[key], safe);
	  return target;
	};


/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(35);
	var dP = __webpack_require__(57);
	var DESCRIPTORS = __webpack_require__(56);
	var SPECIES = __webpack_require__(44)('species');
	
	module.exports = function (KEY) {
	  var C = global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ },
/* 165 */
[2655, 57, 77, 44],
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(11);
	var defined = __webpack_require__(105);
	var fails = __webpack_require__(34);
	var spaces = __webpack_require__(371);
	var space = '[' + spaces + ']';
	var non = '\u200b\u0085';
	var ltrim = RegExp('^' + space + space + '*');
	var rtrim = RegExp(space + space + '*$');
	
	var exporter = function (KEY, exec, ALIAS) {
	  var exp = {};
	  var FORCE = fails(function () {
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if (ALIAS) exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function (string, TYPE) {
	  string = String(defined(string));
	  if (TYPE & 1) string = string.replace(ltrim, '');
	  if (TYPE & 2) string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;


/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var _react = _interopRequireWildcard(__webpack_require__(1));
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	var _reactstrap = __webpack_require__(70);
	__webpack_require__(2508);
	var _constants = __webpack_require__(275);
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
	function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	var ImageIcon = function ImageIcon(_ref) {
	  var id = _ref.id,
	    type = _ref.type,
	    image = _ref.image,
	    _ref$name = _ref.name,
	    name = _ref$name === void 0 ? "" : _ref$name,
	    icon = _ref.icon,
	    _ref$showTooltip = _ref.showTooltip,
	    showTooltip = _ref$showTooltip === void 0 ? true : _ref$showTooltip;
	  var _useState = (0, _react.useState)(false),
	    _useState2 = _slicedToArray(_useState, 2),
	    isMissing = _useState2[0],
	    setIsMissing = _useState2[1];
	  var handleError = function handleError() {
	    return setIsMissing(true);
	  };
	  var idHolder = id || (name && showTooltip ? 'uin-iic-' + name.replace(/\s+/g, '') : undefined);
	  return /*#__PURE__*/_react["default"].createElement("span", {
	    className: "uin-image-icon ".concat(type ? 'outbound' : 'inbound', " ").concat(icon ? 'icon' : ''),
	    id: idHolder
	  }, icon ? /*#__PURE__*/_react["default"].createElement("i", {
	    className: 'gcl-icon ' + icon
	  }) : !isMissing && image > 0 && typeof _constants.CAMPAIGN_ICONS[image - 1] !== 'undefined' ? /*#__PURE__*/_react["default"].createElement("i", {
	    className: 'gcl-icon ' + _constants.CAMPAIGN_ICONS[image - 1].icon
	  }) : /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon anchor"
	  }), name && showTooltip && /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
	    target: idHolder,
	    boundariesElement: "window"
	  }, name));
	};
	ImageIcon.propTypes = {
	  id: _propTypes["default"].string,
	  type: _propTypes["default"].number,
	  image: _propTypes["default"].number,
	  name: _propTypes["default"].string,
	  icon: _propTypes["default"].string,
	  showTooltip: _propTypes["default"].bool
	};
	var _default = exports["default"] = ImageIcon;

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.useWarningTimeout = exports.usePrevious = exports.useInterval = exports.useInfiniteScrollWithRefCallback = exports.useFileHandler = exports.useError = void 0;
	var _react = __webpack_require__(1);
	var _reactI18next = __webpack_require__(41);
	var _constants = __webpack_require__(58);
	var _helpers = __webpack_require__(53);
	function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
	function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
	function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
	function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
	function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	/* istanbul ignore next */
	var useWarningTimeout = exports.useWarningTimeout = function useWarningTimeout(active, timeout) {
	  var _useState = (0, _react.useState)(false),
	    _useState2 = _slicedToArray(_useState, 2),
	    warning = _useState2[0],
	    setWarning = _useState2[1];
	  (0, _react.useEffect)(function () {
	    if (warning) return;
	    if (active && timeout !== null) {
	      console.log('timeout: ', timeout);
	      if (timeout <= 0) {
	        setWarning(true);
	      } else {
	        var timer = setTimeout(function () {
	          console.log('triggered');
	          setWarning(true);
	        }, timeout * 1000);
	        return function () {
	          return clearTimeout(timer);
	        };
	      }
	    } else {
	      setWarning(false);
	    }
	  }, [active, timeout, warning]);
	  return warning;
	};
	var useInterval = exports.useInterval = function useInterval(callback, delay) {
	  var savedCallback = (0, _react.useRef)();
	  (0, _react.useEffect)(function () {
	    savedCallback.current = callback;
	  }, [callback]);
	  (0, _react.useEffect)(function () {
	    function tick() {
	      savedCallback.current();
	    }
	    if (delay !== null) {
	      var id = setInterval(tick, delay);
	      return function () {
	        return clearInterval(id);
	      };
	    }
	  }, [delay]);
	};
	var usePrevious = exports.usePrevious = function usePrevious(value) {
	  var ref = (0, _react.useRef)();
	  (0, _react.useEffect)(function () {
	    ref.current = value;
	  });
	  return ref.current;
	};
	var useInfiniteScrollWithRefCallback = exports.useInfiniteScrollWithRefCallback = function useInfiniteScrollWithRefCallback(callback, disabled, setMemoryScrollTop, setMemoryScrollHeight, refDates, refDateSticky) {
	  var _useState3 = (0, _react.useState)(false),
	    _useState4 = _slicedToArray(_useState3, 2),
	    isFetching = _useState4[0],
	    setIsFetching = _useState4[1];
	  var scrolledTo = function scrolledTo(ref) {
	    if (disabled && !isFetching) {
	      setIsFetching(true);
	      setMemoryScrollTop(true);
	      setMemoryScrollHeight(ref.scrollHeight);
	    }
	  };
	  var scrolledRef = (0, _react.useRef)(scrolledTo);
	  (0, _react.useEffect)(function () {
	    scrolledRef.current = scrolledTo;
	  });
	  var ref = (0, _react.useRef)(null);
	  var setRef = (0, _react.useCallback)(function (node) {
	    function isScrolling(e) {
	      var topLabel = refDateSticky.current;
	      var dateLabels = refDates.current;
	      var currentLabel = null;
	      dateLabels.forEach(function (dateLabel) {
	        if (dateLabel != null && e.currentTarget.scrollTop >= dateLabel.offsetTop) {
	          currentLabel = dateLabel;
	        }
	      });
	      if (currentLabel) {
	        topLabel.style.opacity = '1';
	        topLabel.innerText = currentLabel.innerText;
	        topLabel.style.height = 'fit-content';
	      } else {
	        if (topLabel) {
	          topLabel.style.opacity = '0';
	          topLabel.style.height = '0px';
	        }
	      }
	      if (e.currentTarget.scrollTop + e.currentTarget.clientHeight === e.currentTarget.scrollHeight) setMemoryScrollTop(false);
	      if (e.currentTarget.scrollTop !== 0 || isFetching) return;
	      scrolledRef.current(e.currentTarget);
	    }
	    if (ref.current) {
	      ref.current.removeEventListener('scroll', isScrolling);
	    }
	    if (node) {
	      node.addEventListener('scroll', isScrolling);
	    }
	    ref.current = node;
	  }, []);
	  (0, _react.useEffect)(function () {
	    if (!isFetching || !disabled) {
	      if (!isFetching) setMemoryScrollTop(false);
	      return;
	    }
	    callback();
	  }, [isFetching, disabled]);
	  return [setRef, isFetching, setIsFetching, ref.current];
	};
	var useError = exports.useError = function useError() {
	  var _useState5 = (0, _react.useState)({
	      show: false,
	      title: '',
	      content: ''
	    }),
	    _useState6 = _slicedToArray(_useState5, 2),
	    error = _useState6[0],
	    setError = _useState6[1];
	  var showError = function showError(title, message) {
	    return setError({
	      show: true,
	      title: title,
	      content: message
	    });
	  };
	  var toggleError = function toggleError() {
	    return setError(function (e) {
	      return _objectSpread(_objectSpread({}, e), {}, {
	        show: !e.show
	      });
	    });
	  };
	  return [error, showError, toggleError];
	};
	var useFileHandler = exports.useFileHandler = function useFileHandler(mediaType, maxImgToSend, onError) {
	  var _useTranslation = (0, _reactI18next.useTranslation)('chat'),
	    t = _useTranslation.t;
	  var getFiles = function getFiles(fileList) {
	    var files = Array.from(fileList);
	    var preview = [];
	    if (_constants.TABS.CHAT === mediaType) {
	      if (Object.values(files).filter(function (f) {
	        return (0, _helpers.isNotFileAllowed)(f);
	      }).length > 0) {
	        onError(files.length > 1 ? t('errorFormat.attachErrorTitleMultiple') : t('errorFormat.attachErrorTitleSingle'), t('errorFormat.attachErrorMessage'));
	        return;
	      }
	      if (Object.values(files).filter(function (f) {
	        return f.size / 1000000 > 16;
	      }).length > 0) {
	        onError(files.length > 1 ? t('errorSize.attachErrorTitleMultiple') : t('errorSize.attachErrorTitleSingle'), files.length > 1 ? t('errorSize.attachErrorMultiple') : t('errorSize.attachErrorSingle'));
	        return;
	      }
	      preview = files.slice(0, maxImgToSend).map(function (f) {
	        var url = window.URL.createObjectURL(f);
	        return {
	          currentFile: f,
	          name: f.name,
	          size: f.size,
	          preview: {
	            type: 'image',
	            url: url
	          },
	          type: 'image',
	          urllocal: url
	        };
	      });
	    } else {
	      var filtered = files.filter(function (f) {
	        return !(0, _helpers.isUnsafeFile)(f);
	      }).filter(function (f) {
	        return f.size / 1000000 <= 64;
	      });
	      if (Object.values(files).filter(function (f) {
	        return (0, _helpers.isUnsafeFile)(f);
	      }).length > 0) {
	        onError(files.length > 1 ? t('errorFormat.attachErrorTitleMultiple') : t('errorFormat.attachErrorTitleSingle'), t('errorFormat.attachErrorMessageWhatsapp'));
	        throw new Error("File Type Not Supported");
	      }
	      if (Object.values(files).filter(function (f) {
	        return f.size / 1000000 > 64;
	      }).length > 0) {
	        onError(files.length > 1 ? t('errorSize.attachErrorTitleMultiple') : t('errorSize.attachErrorTitleSingle'), files.length > 1 ? t('errorSize.attachErrorMultipleWhatsapp') : t('errorSize.attachErrorSingleWhatsapp'));
	        throw new Error("File Size Not Allowed");
	      }
	      preview = filtered.map(function (f) {
	        var temp = (0, _helpers.mimeTypeLeft)(f.type);
	        var type = temp !== 'image' && temp !== 'video' && temp !== 'audio' ? 'file' : temp;
	        var url = window.URL.createObjectURL(f);
	        f.preview = {
	          type: type,
	          url: url
	        };
	        // f.type = type;
	        f.urllocal = url;
	        return f;
	      });
	    }
	    return preview;
	  };
	  return getFiles;
	};

/***/ },
/* 169 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addLeadingZeros;
	
	function addLeadingZeros(number, targetLength) {
	  var sign = number < 0 ? '-' : '';
	  var output = Math.abs(number).toString();
	
	  while (output.length < targetLength) {
	    output = '0' + output;
	  }
	
	  return sign + output;
	}
	
	module.exports = exports.default;

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addMonths;
	
	var _index = _interopRequireDefault(__webpack_require__(26));
	
	var _index2 = _interopRequireDefault(__webpack_require__(9));
	
	var _index3 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name addMonths
	 * @category Month Helpers
	 * @summary Add the specified number of months to the given date.
	 *
	 * @description
	 * Add the specified number of months to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of months to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the months added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 5 months to 1 September 2014:
	 * const result = addMonths(new Date(2014, 8, 1), 5)
	 * //=> Sun Feb 01 2015 00:00:00
	 */
	function addMonths(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var amount = (0, _index.default)(dirtyAmount);
	
	  if (isNaN(amount)) {
	    return new Date(NaN);
	  }
	
	  if (!amount) {
	    // If 0 months, no-op to avoid changing times in the hour before end of DST
	    return date;
	  }
	
	  var dayOfMonth = date.getDate(); // The JS Date object supports date math by accepting out-of-bounds values for
	  // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
	  // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
	  // want except that dates will wrap around the end of a month, meaning that
	  // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
	  // we'll default to the end of the desired month by adding 1 to the desired
	  // month and using a date of 0 to back up one day to the end of the desired
	  // month.
	
	  var endOfDesiredMonth = new Date(date.getTime());
	  endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
	  var daysInMonth = endOfDesiredMonth.getDate();
	
	  if (dayOfMonth >= daysInMonth) {
	    // If we're already at the end of the month, then this is the correct date
	    // and we're done.
	    return endOfDesiredMonth;
	  } else {
	    // Otherwise, we now know that setting the original day-of-month value won't
	    // cause an overflow, so set the desired day-of-month. Note that we can't
	    // just set the date of `endOfDesiredMonth` because that object may have had
	    // its time changed in the unusual case where where a DST transition was on
	    // the last day of the month and its local time was in the hour skipped or
	    // repeated next to a DST transition.  So we use `date` instead which is
	    // guaranteed to still have the original time.
	    date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
	    return date;
	  }
	}
	
	module.exports = exports.default;

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getISOWeekYear;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(148));
	
	var _index3 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getISOWeekYear
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Get the ISO week-numbering year of the given date.
	 *
	 * @description
	 * Get the ISO week-numbering year of the given date,
	 * which always starts 3 days before the year's first Thursday.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `getISOYear` to `getISOWeekYear`.
	 *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
	 *   This change makes the name consistent with
	 *   locale-dependent week-numbering year helpers, e.g., `getWeekYear`.
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the ISO week-numbering year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which ISO-week numbering year is 2 January 2005?
	 * const result = getISOWeekYear(new Date(2005, 0, 2))
	 * //=> 2004
	 */
	function getISOWeekYear(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  var fourthOfJanuaryOfNextYear = new Date(0);
	  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
	  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
	  var startOfNextYear = (0, _index2.default)(fourthOfJanuaryOfNextYear);
	  var fourthOfJanuaryOfThisYear = new Date(0);
	  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
	  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
	  var startOfThisYear = (0, _index2.default)(fourthOfJanuaryOfThisYear);
	
	  if (date.getTime() >= startOfNextYear.getTime()) {
	    return year + 1;
	  } else if (date.getTime() >= startOfThisYear.getTime()) {
	    return year;
	  } else {
	    return year - 1;
	  }
	}
	
	module.exports = exports.default;

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameDay;
	
	var _index = _interopRequireDefault(__webpack_require__(211));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isSameDay
	 * @category Day Helpers
	 * @summary Are the given dates in the same day (and year and month)?
	 *
	 * @description
	 * Are the given dates in the same day (and year and month)?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same day (and year and month)
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
	 * var result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
	 * //=> true
	 * 
	 * @example
	 * // Are 4 September and 4 October in the same day?
	 * var result = isSameDay(new Date(2014, 8, 4), new Date(2014, 9, 4))
	 * //=> false
	 * 
	 * @example
	 * // Are 4 September, 2014 and 4 September, 2015 in the same day?
	 * var result = isSameDay(new Date(2014, 8, 4), new Date(2015, 8, 4))
	 * //=> false
	 */
	function isSameDay(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeftStartOfDay = (0, _index.default)(dirtyDateLeft);
	  var dateRightStartOfDay = (0, _index.default)(dirtyDateRight);
	  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
	}
	
	module.exports = exports.default;

/***/ },
/* 173 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = ownerDocument;
	
	function ownerDocument(node) {
	  return node && node.ownerDocument || document;
	}
	
	module.exports = exports["default"];

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(123));
	
	var _default = function () {
	  // HTML DOM and SVG DOM may have different support levels,
	  // so we need to check on context instead of a document root element.
	  return _inDOM.default ? function (context, node) {
	    if (context.contains) {
	      return context.contains(node);
	    } else if (context.compareDocumentPosition) {
	      return context === node || !!(context.compareDocumentPosition(node) & 16);
	    } else {
	      return fallback(context, node);
	    }
	  } : fallback;
	}();
	
	exports.default = _default;
	
	function fallback(context, node) {
	  if (node) do {
	    if (node === context) return true;
	  } while (node = node.parentNode);
	  return false;
	}
	
	module.exports = exports["default"];

/***/ },
/* 175 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./type')} */
	module.exports = TypeError;


/***/ },
/* 176 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.updateArrayImmutably = exports.removeFromObject = exports.isValidTime = exports.isValidMail = exports.isValidDate = exports.getTime = void 0;
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
	
	function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	var updateArrayImmutably = function updateArrayImmutably(arr, i, value) {
	  return Object.assign(_toConsumableArray(arr), _defineProperty({}, i, value));
	};
	
	exports.updateArrayImmutably = updateArrayImmutably;
	
	var removeFromObject = function removeFromObject(obj, key) {
	  var removed = obj[key],
	      objWithout = _objectWithoutProperties(obj, [key].map(_toPropertyKey));
	
	  return objWithout;
	};
	
	exports.removeFromObject = removeFromObject;
	
	var isValidDate = function isValidDate(date) {
	  if (date) {
	    if (date instanceof Date) {
	      return true;
	    } else if (!isNaN(new Date(date))) {
	      return true;
	    } else {
	      return false;
	    }
	  }
	
	  return false;
	};
	
	exports.isValidDate = isValidDate;
	var mailRegEx = RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]{2,}\.)+[a-zA-Z]{2,}))$/);
	
	var isValidMail = function isValidMail(mail) {
	  return mailRegEx.test(mail);
	};
	
	exports.isValidMail = isValidMail;
	var timeRegEx = RegExp(/(?:([0-9]?[0-9]):)?([0-9]?[0-9]):([0-9][0-9])/);
	
	var isValidTime = function isValidTime(val) {
	  return timeRegEx.test(val);
	};
	
	exports.isValidTime = isValidTime;
	
	var getTime = function getTime(timeString) {
	  if (timeString == null) return undefined;
	  if (!isValidTime(timeString)) return parseInt(timeString, 10);
	  var regExTimeArr = timeRegEx.exec(timeString); // ["01:12:33", "01", "12", "33", index: 0, input: "01:12:33", groups: undefined]
	
	  return (regExTimeArr[1] || 0) * 3600 + regExTimeArr[2] * 60 + regExTimeArr[3] * 1;
	};
	
	exports.getTime = getTime;

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	var Parser = __webpack_require__(719);
	var DomHandler = __webpack_require__(683);
	
	function defineProp(name, value) {
	    delete module.exports[name];
	    module.exports[name] = value;
	    return value;
	}
	
	module.exports = {
	    Parser: Parser,
	    Tokenizer: __webpack_require__(720),
	    ElementType: __webpack_require__(217),
	    DomHandler: DomHandler,
	    get FeedHandler() {
	        return defineProp("FeedHandler", __webpack_require__(2029));
	    },
	    get Stream() {
	        return defineProp("Stream", __webpack_require__(2031));
	    },
	    get WritableStream() {
	        return defineProp("WritableStream", __webpack_require__(721));
	    },
	    get ProxyHandler() {
	        return defineProp("ProxyHandler", __webpack_require__(2030));
	    },
	    get DomUtils() {
	        return defineProp("DomUtils", __webpack_require__(685));
	    },
	    get CollectingHandler() {
	        return defineProp(
	            "CollectingHandler",
	            __webpack_require__(2028)
	        );
	    },
	    // For legacy support
	    DefaultHandler: DomHandler,
	    get RssHandler() {
	        return defineProp("RssHandler", this.FeedHandler);
	    },
	    //helper methods
	    parseDOM: function(data, options) {
	        var handler = new DomHandler(options);
	        new Parser(handler, options).end(data);
	        return handler.dom;
	    },
	    parseFeed: function(feed, options) {
	        var handler = new module.exports.FeedHandler(options);
	        new Parser(handler, options).end(feed);
	        return handler.dom;
	    },
	    createDomStream: function(cb, options, elementCb) {
	        var handler = new DomHandler(cb, options, elementCb);
	        return new Parser(handler, options);
	    },
	    // List of all events that the parser emits
	    EVENTS: {
	        /* Format: eventname: number of arguments */
	        attribute: 2,
	        cdatastart: 0,
	        cdataend: 0,
	        text: 1,
	        processinginstruction: 2,
	        comment: 1,
	        commentend: 0,
	        closetag: 1,
	        opentag: 2,
	        opentagname: 1,
	        error: 1,
	        end: 0
	    }
	};


/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(84);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },
/* 179 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(283);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ },
/* 181 */
/***/ function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(125),
	    isObjectLike = __webpack_require__(85);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(730),
	    baseKeys = __webpack_require__(2081),
	    isArrayLike = __webpack_require__(150);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setDefaults = setDefaults;
	exports.getDefaults = getDefaults;
	exports.setI18n = setI18n;
	exports.getI18n = getI18n;
	exports.composeInitialProps = composeInitialProps;
	exports.getInitialProps = getInitialProps;
	exports.initReactI18next = exports.ReportNamespaces = exports.I18nContext = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(484));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(485));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(27));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	var defaultOptions = {
	  bindI18n: 'languageChanged',
	  bindI18nStore: '',
	  transEmptyNodeValue: '',
	  transSupportBasicHtmlNodes: true,
	  transWrapTextNodes: '',
	  transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p'],
	  useSuspense: true
	};
	var i18nInstance;
	
	var I18nContext = _react["default"].createContext();
	
	exports.I18nContext = I18nContext;
	
	function setDefaults() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  defaultOptions = _objectSpread(_objectSpread({}, defaultOptions), options);
	}
	
	function getDefaults() {
	  return defaultOptions;
	}
	
	var ReportNamespaces = function () {
	  function ReportNamespaces() {
	    (0, _classCallCheck2["default"])(this, ReportNamespaces);
	    this.usedNamespaces = {};
	  }
	
	  (0, _createClass2["default"])(ReportNamespaces, [{
	    key: "addUsedNamespaces",
	    value: function addUsedNamespaces(namespaces) {
	      var _this = this;
	
	      namespaces.forEach(function (ns) {
	        if (!_this.usedNamespaces[ns]) _this.usedNamespaces[ns] = true;
	      });
	    }
	  }, {
	    key: "getUsedNamespaces",
	    value: function getUsedNamespaces() {
	      return Object.keys(this.usedNamespaces);
	    }
	  }]);
	  return ReportNamespaces;
	}();
	
	exports.ReportNamespaces = ReportNamespaces;
	
	function setI18n(instance) {
	  i18nInstance = instance;
	}
	
	function getI18n() {
	  return i18nInstance;
	}
	
	var initReactI18next = {
	  type: '3rdParty',
	  init: function init(instance) {
	    setDefaults(instance.options.react);
	    setI18n(instance);
	  }
	};
	exports.initReactI18next = initReactI18next;
	
	function composeInitialProps(ForComponent) {
	  return function (ctx) {
	    return new Promise(function (resolve) {
	      var i18nInitialProps = getInitialProps();
	
	      if (ForComponent.getInitialProps) {
	        ForComponent.getInitialProps(ctx).then(function (componentsInitialProps) {
	          resolve(_objectSpread(_objectSpread({}, componentsInitialProps), i18nInitialProps));
	        });
	      } else {
	        resolve(i18nInitialProps);
	      }
	    });
	  };
	}
	
	function getInitialProps() {
	  var i18n = getI18n();
	  var namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
	  var ret = {};
	  var initialI18nStore = {};
	  i18n.languages.forEach(function (l) {
	    initialI18nStore[l] = {};
	    namespaces.forEach(function (ns) {
	      initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
	    });
	  });
	  ret.initialI18nStore = initialI18nStore;
	  ret.initialLanguage = i18n.language;
	  return ret;
	}

/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (componentOrElement) {
	  return (0, _ownerDocument2.default)(_reactDom2.default.findDOMNode(componentOrElement));
	};
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _ownerDocument = __webpack_require__(173);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports['default'];

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = __webpack_require__(1);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _ReactUtils = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var XAxis =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(XAxis, _PureComponent);
	
	  function XAxis() {
	    _classCallCheck(this, XAxis);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(XAxis).apply(this, arguments));
	  }
	
	  _createClass(XAxis, [{
	    key: "render",
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return XAxis;
	}(_react.PureComponent);
	
	XAxis.displayName = 'XAxis';
	XAxis.propTypes = {
	  allowDecimals: _propTypes["default"].bool,
	  allowDuplicatedCategory: _propTypes["default"].bool,
	  hide: _propTypes["default"].bool,
	  // The name of data displayed in the axis
	  name: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  // The unit of data displayed in the axis
	  unit: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  // The unique id of x-axis
	  xAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  domain: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func, _propTypes["default"].oneOf(['auto', 'dataMin', 'dataMax'])])),
	  // The key of data displayed in the axis
	  dataKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func]),
	  // The width of axis which is usually calculated internally
	  width: _propTypes["default"].number,
	  // The height of axis, which need to be setted by user
	  height: _propTypes["default"].number,
	  mirror: _propTypes["default"].bool,
	  // The orientation of axis
	  orientation: _propTypes["default"].oneOf(['top', 'bottom']),
	  type: _propTypes["default"].oneOf(['number', 'category']),
	  // Ticks can be any type when the axis is the type of category
	  // Ticks must be numbers when the axis is the type of number
	  ticks: _propTypes["default"].array,
	  // The count of ticks
	  tickCount: _propTypes["default"].number,
	  // The formatter function of tick
	  tickFormatter: _propTypes["default"].func,
	  padding: _propTypes["default"].shape({
	    left: _propTypes["default"].number,
	    right: _propTypes["default"].number
	  }),
	  allowDataOverflow: _propTypes["default"].bool,
	  scale: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(_ReactUtils.SCALE_TYPES), _propTypes["default"].func]),
	  tick: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].func, _propTypes["default"].object, _propTypes["default"].element]),
	  axisLine: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].object]),
	  tickLine: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].object]),
	  minTickGap: _propTypes["default"].number,
	  tickSize: _propTypes["default"].number,
	  interval: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].oneOf(['preserveStart', 'preserveEnd', 'preserveStartEnd'])]),
	  reversed: _propTypes["default"].bool
	};
	XAxis.defaultProps = {
	  allowDecimals: true,
	  hide: false,
	  orientation: 'bottom',
	  width: 0,
	  height: 30,
	  mirror: false,
	  xAxisId: 0,
	  tickCount: 5,
	  type: 'category',
	  domain: [0, 'auto'],
	  padding: {
	    left: 0,
	    right: 0
	  },
	  allowDataOverflow: false,
	  scale: 'auto',
	  reversed: false,
	  allowDuplicatedCategory: true
	};
	var _default = XAxis;
	exports["default"] = _default;

/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = __webpack_require__(1);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var YAxis =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(YAxis, _PureComponent);
	
	  function YAxis() {
	    _classCallCheck(this, YAxis);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(YAxis).apply(this, arguments));
	  }
	
	  _createClass(YAxis, [{
	    key: "render",
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return YAxis;
	}(_react.PureComponent);
	
	YAxis.displayName = 'YAxis';
	YAxis.propTypes = {
	  allowDecimals: _propTypes["default"].bool,
	  allowDuplicatedCategory: _propTypes["default"].bool,
	  hide: _propTypes["default"].bool,
	  // The name of data displayed in the axis
	  name: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  // The unit of data displayed in the axis
	  unit: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  // The unique id of y-axis
	  yAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  domain: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func, _propTypes["default"].oneOf(['auto', 'dataMin', 'dataMax'])])),
	  // The key of data displayed in the axis
	  dataKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func]),
	  // Ticks can be any type when the axis is the type of category
	  // Ticks must be numbers when the axis is the type of number
	  ticks: _propTypes["default"].array,
	  // The count of ticks
	  tickCount: _propTypes["default"].number,
	  // The formatter function of tick
	  tickFormatter: _propTypes["default"].func,
	  // The width of axis, which need to be setted by user
	  width: _propTypes["default"].number,
	  // The height of axis which is usually calculated in Chart
	  height: _propTypes["default"].number,
	  mirror: _propTypes["default"].bool,
	  // The orientation of axis
	  orientation: _propTypes["default"].oneOf(['left', 'right']),
	  type: _propTypes["default"].oneOf(['number', 'category']),
	  padding: _propTypes["default"].shape({
	    top: _propTypes["default"].number,
	    bottom: _propTypes["default"].number
	  }),
	  allowDataOverflow: _propTypes["default"].bool,
	  scale: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(['auto', 'linear', 'pow', 'sqrt', 'log', 'identity', 'time', 'band', 'point', 'ordinal', 'quantile', 'quantize', 'utc', 'sequential', 'threshold']), _propTypes["default"].func]),
	  tick: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].func, _propTypes["default"].object, _propTypes["default"].element]),
	  axisLine: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].object]),
	  tickLine: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].object]),
	  minTickGap: _propTypes["default"].number,
	  tickSize: _propTypes["default"].number,
	  interval: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].oneOf(['preserveStart', 'preserveEnd', 'preserveStartEnd'])]),
	  reversed: _propTypes["default"].bool
	};
	YAxis.defaultProps = {
	  allowDuplicatedCategory: true,
	  allowDecimals: true,
	  hide: false,
	  orientation: 'left',
	  width: 60,
	  height: 0,
	  mirror: false,
	  yAxisId: 0,
	  tickCount: 5,
	  type: 'number',
	  domain: [0, 'auto'],
	  padding: {
	    top: 0,
	    bottom: 0
	  },
	  allowDataOverflow: false,
	  scale: 'auto',
	  reversed: false
	};
	var _default = YAxis;
	exports["default"] = _default;

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _ReactUtils = __webpack_require__(29);
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function Cell() {
	  return null;
	}
	
	Cell.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES);
	Cell.displayName = 'Cell';
	var _default = Cell;
	exports["default"] = _default;

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isArray2 = _interopRequireDefault(__webpack_require__(43));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(38));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _d3Shape = __webpack_require__(382);
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _ReactUtils = __webpack_require__(29);
	
	var _DataUtils = __webpack_require__(39);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var CURVE_FACTORIES = {
	  curveBasisClosed: _d3Shape.curveBasisClosed,
	  curveBasisOpen: _d3Shape.curveBasisOpen,
	  curveBasis: _d3Shape.curveBasis,
	  curveLinearClosed: _d3Shape.curveLinearClosed,
	  curveLinear: _d3Shape.curveLinear,
	  curveMonotoneX: _d3Shape.curveMonotoneX,
	  curveMonotoneY: _d3Shape.curveMonotoneY,
	  curveNatural: _d3Shape.curveNatural,
	  curveStep: _d3Shape.curveStep,
	  curveStepAfter: _d3Shape.curveStepAfter,
	  curveStepBefore: _d3Shape.curveStepBefore
	};
	
	var defined = function defined(p) {
	  return p.x === +p.x && p.y === +p.y;
	};
	
	var getX = function getX(p) {
	  return p.x;
	};
	
	var getY = function getY(p) {
	  return p.y;
	};
	
	var getCurveFactory = function getCurveFactory(type, layout) {
	  if ((0, _isFunction2["default"])(type)) {
	    return type;
	  }
	
	  var name = "curve".concat(type.slice(0, 1).toUpperCase()).concat(type.slice(1));
	
	  if (name === 'curveMonotone' && layout) {
	    return CURVE_FACTORIES["".concat(name).concat(layout === 'vertical' ? 'Y' : 'X')];
	  }
	
	  return CURVE_FACTORIES[name] || _d3Shape.curveLinear;
	};
	
	var Curve =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Curve, _PureComponent);
	
	  function Curve() {
	    _classCallCheck(this, Curve);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(Curve).apply(this, arguments));
	  }
	
	  _createClass(Curve, [{
	    key: "getPath",
	
	    /**
	     * Calculate the path of curve
	     * @return {String} path
	     */
	    value: function getPath() {
	      var _this$props = this.props,
	          type = _this$props.type,
	          points = _this$props.points,
	          baseLine = _this$props.baseLine,
	          layout = _this$props.layout,
	          connectNulls = _this$props.connectNulls;
	      var curveFactory = getCurveFactory(type, layout);
	      var formatPoints = connectNulls ? points.filter(function (entry) {
	        return defined(entry);
	      }) : points;
	      var lineFunction;
	
	      if ((0, _isArray2["default"])(baseLine)) {
	        var formatBaseLine = connectNulls ? baseLine.filter(function (base) {
	          return defined(base);
	        }) : baseLine;
	        var areaPoints = formatPoints.map(function (entry, index) {
	          return _objectSpread({}, entry, {
	            base: formatBaseLine[index]
	          });
	        });
	
	        if (layout === 'vertical') {
	          lineFunction = (0, _d3Shape.area)().y(getY).x1(getX).x0(function (d) {
	            return d.base.x;
	          });
	        } else {
	          lineFunction = (0, _d3Shape.area)().x(getX).y1(getY).y0(function (d) {
	            return d.base.y;
	          });
	        }
	
	        lineFunction.defined(defined).curve(curveFactory);
	        return lineFunction(areaPoints);
	      }
	
	      if (layout === 'vertical' && (0, _DataUtils.isNumber)(baseLine)) {
	        lineFunction = (0, _d3Shape.area)().y(getY).x1(getX).x0(baseLine);
	      } else if ((0, _DataUtils.isNumber)(baseLine)) {
	        lineFunction = (0, _d3Shape.area)().x(getX).y1(getY).y0(baseLine);
	      } else {
	        lineFunction = (0, _d3Shape.line)().x(getX).y(getY);
	      }
	
	      lineFunction.defined(defined).curve(curveFactory);
	      return lineFunction(formatPoints);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          className = _this$props2.className,
	          points = _this$props2.points,
	          path = _this$props2.path,
	          pathRef = _this$props2.pathRef;
	
	      if ((!points || !points.length) && !path) {
	        return null;
	      }
	
	      var realPath = points && points.length ? this.getPath() : path;
	      return _react["default"].createElement("path", _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props, null, true), {
	        className: (0, _classnames["default"])('recharts-curve', className),
	        d: realPath,
	        ref: pathRef
	      }));
	    }
	  }]);
	
	  return Curve;
	}(_react.PureComponent);
	
	Curve.displayName = 'Curve';
	Curve.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  className: _propTypes["default"].string,
	  type: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(['basis', 'basisClosed', 'basisOpen', 'linear', 'linearClosed', 'natural', 'monotoneX', 'monotoneY', 'monotone', 'step', 'stepBefore', 'stepAfter']), _propTypes["default"].func]),
	  layout: _propTypes["default"].oneOf(['horizontal', 'vertical']),
	  baseLine: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].array]),
	  points: _propTypes["default"].arrayOf(_propTypes["default"].object),
	  connectNulls: _propTypes["default"].bool,
	  path: _propTypes["default"].string,
	  pathRef: _propTypes["default"].func
	});
	Curve.defaultProps = {
	  type: 'linear',
	  points: [],
	  connectNulls: false
	};
	var _default = Curve;
	exports["default"] = _default;

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _reactSmooth = _interopRequireDefault(__webpack_require__(81));
	
	var _ReactUtils = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var getRectangePath = function getRectangePath(x, y, width, height, radius) {
	  var maxRadius = Math.min(Math.abs(width) / 2, Math.abs(height) / 2);
	  var ySign = height >= 0 ? 1 : -1;
	  var xSign = width >= 0 ? 1 : -1;
	  var clockWise = height >= 0 && width >= 0 || height < 0 && width < 0 ? 1 : 0;
	  var path;
	
	  if (maxRadius > 0 && radius instanceof Array) {
	    var newRadius = [];
	
	    for (var i = 0, len = 4; i < len; i++) {
	      newRadius[i] = radius[i] > maxRadius ? maxRadius : radius[i];
	    }
	
	    path = "M".concat(x, ",").concat(y + ySign * newRadius[0]);
	
	    if (newRadius[0] > 0) {
	      path += "A ".concat(newRadius[0], ",").concat(newRadius[0], ",0,0,").concat(clockWise, ",").concat(x + xSign * newRadius[0], ",").concat(y);
	    }
	
	    path += "L ".concat(x + width - xSign * newRadius[1], ",").concat(y);
	
	    if (newRadius[1] > 0) {
	      path += "A ".concat(newRadius[1], ",").concat(newRadius[1], ",0,0,").concat(clockWise, ",\n        ").concat(x + width, ",").concat(y + ySign * newRadius[1]);
	    }
	
	    path += "L ".concat(x + width, ",").concat(y + height - ySign * newRadius[2]);
	
	    if (newRadius[2] > 0) {
	      path += "A ".concat(newRadius[2], ",").concat(newRadius[2], ",0,0,").concat(clockWise, ",\n        ").concat(x + width - xSign * newRadius[2], ",").concat(y + height);
	    }
	
	    path += "L ".concat(x + xSign * newRadius[3], ",").concat(y + height);
	
	    if (newRadius[3] > 0) {
	      path += "A ".concat(newRadius[3], ",").concat(newRadius[3], ",0,0,").concat(clockWise, ",\n        ").concat(x, ",").concat(y + height - ySign * newRadius[3]);
	    }
	
	    path += 'Z';
	  } else if (maxRadius > 0 && radius === +radius && radius > 0) {
	    var _newRadius = Math.min(maxRadius, radius);
	
	    path = "M ".concat(x, ",").concat(y + ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + xSign * _newRadius, ",").concat(y, "\n            L ").concat(x + width - xSign * _newRadius, ",").concat(y, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + width, ",").concat(y + ySign * _newRadius, "\n            L ").concat(x + width, ",").concat(y + height - ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + width - xSign * _newRadius, ",").concat(y + height, "\n            L ").concat(x + xSign * _newRadius, ",").concat(y + height, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x, ",").concat(y + height - ySign * _newRadius, " Z");
	  } else {
	    path = "M ".concat(x, ",").concat(y, " h ").concat(width, " v ").concat(height, " h ").concat(-width, " Z");
	  }
	
	  return path;
	};
	
	var Rectangle =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Rectangle, _PureComponent);
	
	  function Rectangle() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Rectangle);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Rectangle)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      totalLength: -1
	    };
	    return _this;
	  }
	
	  _createClass(Rectangle, [{
	    key: "componentDidMount",
	
	    /* eslint-disable  react/no-did-mount-set-state */
	    value: function componentDidMount() {
	      if (this.node && this.node.getTotalLength) {
	        try {
	          var totalLength = this.node.getTotalLength();
	
	          if (totalLength) {
	            this.setState({
	              totalLength: totalLength
	            });
	          }
	        } catch (err) {// calculate total length error
	        }
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _this$props = this.props,
	          x = _this$props.x,
	          y = _this$props.y,
	          width = _this$props.width,
	          height = _this$props.height,
	          radius = _this$props.radius,
	          className = _this$props.className;
	      var totalLength = this.state.totalLength;
	      var _this$props2 = this.props,
	          animationEasing = _this$props2.animationEasing,
	          animationDuration = _this$props2.animationDuration,
	          animationBegin = _this$props2.animationBegin,
	          isAnimationActive = _this$props2.isAnimationActive,
	          isUpdateAnimationActive = _this$props2.isUpdateAnimationActive;
	
	      if (x !== +x || y !== +y || width !== +width || height !== +height || width === 0 || height === 0) {
	        return null;
	      }
	
	      var layerClass = (0, _classnames["default"])('recharts-rectangle', className);
	
	      if (!isUpdateAnimationActive) {
	        return _react["default"].createElement("path", _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), {
	          className: layerClass,
	          d: getRectangePath(x, y, width, height, radius)
	        }));
	      }
	
	      return _react["default"].createElement(_reactSmooth["default"], {
	        canBegin: totalLength > 0,
	        from: {
	          width: width,
	          height: height,
	          x: x,
	          y: y
	        },
	        to: {
	          width: width,
	          height: height,
	          x: x,
	          y: y
	        },
	        duration: animationDuration,
	        animationEasing: animationEasing,
	        isActive: isUpdateAnimationActive
	      }, function (_ref) {
	        var currWidth = _ref.width,
	            currHeight = _ref.height,
	            currX = _ref.x,
	            currY = _ref.y;
	        return _react["default"].createElement(_reactSmooth["default"], {
	          canBegin: totalLength > 0,
	          from: "0px ".concat(totalLength === -1 ? 1 : totalLength, "px"),
	          to: "".concat(totalLength, "px 0px"),
	          attributeName: "strokeDasharray",
	          begin: animationBegin,
	          duration: animationDuration,
	          isActive: isAnimationActive,
	          easing: animationEasing
	        }, _react["default"].createElement("path", _extends({}, (0, _ReactUtils.getPresentationAttributes)(_this2.props), (0, _ReactUtils.filterEventAttributes)(_this2.props), {
	          className: layerClass,
	          d: getRectangePath(currX, currY, currWidth, currHeight, radius),
	          ref: function ref(node) {
	            _this2.node = node;
	          }
	        })));
	      });
	    }
	  }]);
	
	  return Rectangle;
	}(_react.PureComponent);
	
	Rectangle.displayName = 'Rectangle';
	Rectangle.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {}, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _propTypes["default"].string,
	  x: _propTypes["default"].number,
	  y: _propTypes["default"].number,
	  width: _propTypes["default"].number,
	  height: _propTypes["default"].number,
	  radius: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].array]),
	  isAnimationActive: _propTypes["default"].bool,
	  isUpdateAnimationActive: _propTypes["default"].bool,
	  animationBegin: _propTypes["default"].number,
	  animationDuration: _propTypes["default"].number,
	  animationEasing: _propTypes["default"].oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
	});
	Rectangle.defaultProps = {
	  x: 0,
	  y: 0,
	  width: 0,
	  height: 0,
	  // The radius of border
	  // The radius of four corners when radius is a number
	  // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
	  radius: 0,
	  isAnimationActive: false,
	  isUpdateAnimationActive: false,
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'ease'
	};
	var _default = Rectangle;
	exports["default"] = _default;

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.warn = void 0;
	
	/* eslint no-console: 0 */
	var isDev = ("production") !== 'production';
	
	var warn = function warn(condition, format, a, b, c, d, e, f) {
	  if (isDev && typeof console !== 'undefined' && console.warn) {
	    if (format === undefined) {
	      console.warn('LogUtils requires an error message argument');
	    }
	
	    if (!condition) {
	      if (format === undefined) {
	        console.warn('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	      } else {
	        var args = [a, b, c, d, e, f];
	        var argIndex = 0;
	        console.warn(format.replace(/%s/g, function () {
	          return args[argIndex++];
	        }));
	      }
	    }
	  }
	};
	
	exports.warn = warn;

/***/ },
/* 192 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.dataTransferPreview = dataTransferPreview;
	exports.onAcceptedTransfer = onAcceptedTransfer;
	exports.showAlert = showAlert;
	exports.showPreviewData = showPreviewData;
	exports.setAgentList = setAgentList;
	exports.setTransferInProgress = setTransferInProgress;
	exports.setUnnasignByXfer = setUnnasignByXfer;
	
	var _constants = __webpack_require__(10);
	
	function dataTransferPreview(previewAction, phoneList, acdList, agentList) {
	  return {
	    type: _constants.PREVIEW_TRANSFER.DATA_CALL_PREVIEW,
	    previewAction: previewAction,
	    phoneList: phoneList,
	    acdList: acdList,
	    agentList: agentList
	  };
	}
	
	function onAcceptedTransfer(value) {
	  return {
	    type: _constants.PREVIEW_TRANSFER.ON_RESPONSE_TRANSFER,
	    isAccepted: value
	  };
	}
	
	function showAlert() {
	  return {
	    type: _constants.PREVIEW_TRANSFER.SHOW_ALERT
	  };
	}
	
	function showPreviewData(show) {
	  return {
	    type: _constants.PREVIEW_TRANSFER.SHOW_PREVIEW_DATA,
	    show: show
	  };
	}
	
	function setAgentList(agentList) {
	  return {
	    type: _constants.PREVIEW_TRANSFER.SET_AGENT_LIST,
	    agentList: agentList
	  };
	}
	
	function setTransferInProgress(flag) {
	  return {
	    type: _constants.PREVIEW_TRANSFER.TRANSFER_IN_PROGRESS,
	    flag: flag
	  };
	}
	
	function setUnnasignByXfer(flag) {
	  return {
	    type: _constants.PREVIEW_TRANSFER.UNNASIGN_BY_XFER,
	    flag: flag
	  };
	}

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.change_language = change_language;
	exports.loginAction = loginAction;
	exports.logout = logout;
	exports.userNoAction = userNoAction;
	
	var _constants = __webpack_require__(10);
	
	function change_language(c_language) {
	  return {
	    type: _constants.USER_ACTIONS.CHANGE_LANGUAGE,
	    c_language: c_language
	  };
	}
	
	function loginAction(wLogged, ccsLogged) {
	  return {
	    type: _constants.USER_ACTIONS.LOGIN,
	    webLogged: wLogged,
	    ccserverLogged: ccsLogged
	  };
	}
	
	function logout() {
	  return {
	    type: _constants.USER_ACTIONS.LOGOUT
	  };
	}
	
	function userNoAction() {
	  return {
	    type: _constants.USER_ACTIONS.NONE
	  };
	}

/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.activateWorkAction = activateWorkAction;
	exports.removeWorkAction = removeWorkAction;
	
	var _constants = __webpack_require__(10);
	
	function activateWorkAction(expandedComponent) {
	  return {
	    type: _constants.WORKBAR_ACTIONS.INSERT_WINDOW,
	    componentOpen: expandedComponent
	  };
	}
	
	function removeWorkAction(idRemove) {
	  return {
	    type: _constants.WORKBAR_ACTIONS.REMOVE_WINDOW,
	    componentRemove: idRemove
	  };
	}

/***/ },
/* 196 */
34,
/* 197 */
162,
/* 198 */
[2652, 527, 342],
/* 199 */
/***/ function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ },
/* 200 */
141,
/* 201 */
[2626, 104, 44],
/* 202 */
[2635, 104],
/* 203 */
199,
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(33);
	var aFunction = __webpack_require__(89);
	var SPECIES = __webpack_require__(44)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.DropdownContext = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	/**
	 * DropdownContext
	 * {
	 *  toggle: PropTypes.func.isRequired,
	 *  isOpen: PropTypes.bool.isRequired,
	 *  direction: PropTypes.oneOf(['up', 'down', 'left', 'right']).isRequired,
	 *  inNavbar: PropTypes.bool.isRequired,
	 *  disabled: PropTypes.bool
	 * }
	 */
	var DropdownContext = /*#__PURE__*/_react.default.createContext({});
	
	exports.DropdownContext = DropdownContext;

/***/ },
/* 206 */
[2714, 12],
/* 207 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getRoundingMethod = getRoundingMethod;
	var roundingMap = {
	  ceil: Math.ceil,
	  round: Math.round,
	  floor: Math.floor,
	  trunc: function (value) {
	    return value < 0 ? Math.ceil(value) : Math.floor(value);
	  } // Math.trunc is not supported by IE
	
	};
	var defaultRoundingMethod = 'trunc';
	
	function getRoundingMethod(method) {
	  return method ? roundingMap[method] : roundingMap[defaultRoundingMethod];
	}

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addMilliseconds;
	
	var _index = _interopRequireDefault(__webpack_require__(26));
	
	var _index2 = _interopRequireDefault(__webpack_require__(9));
	
	var _index3 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name addMilliseconds
	 * @category Millisecond Helpers
	 * @summary Add the specified number of milliseconds to the given date.
	 *
	 * @description
	 * Add the specified number of milliseconds to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the milliseconds added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
	 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
	 * //=> Thu Jul 10 2014 12:45:30.750
	 */
	function addMilliseconds(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var timestamp = (0, _index2.default)(dirtyDate).getTime();
	  var amount = (0, _index.default)(dirtyAmount);
	  return new Date(timestamp + amount);
	}
	
	module.exports = exports.default;

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addWeeks;
	
	var _index = _interopRequireDefault(__webpack_require__(26));
	
	var _index2 = _interopRequireDefault(__webpack_require__(95));
	
	var _index3 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name addWeeks
	 * @category Week Helpers
	 * @summary Add the specified number of weeks to the given date.
	 *
	 * @description
	 * Add the specified number of week to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of weeks to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the weeks added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 4 weeks to 1 September 2014:
	 * const result = addWeeks(new Date(2014, 8, 1), 4)
	 * //=> Mon Sep 29 2014 00:00:00
	 */
	function addWeeks(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  var days = amount * 7;
	  return (0, _index2.default)(dirtyDate, days);
	}
	
	module.exports = exports.default;

/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDay;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getDay
	 * @category Weekday Helpers
	 * @summary Get the day of the week of the given date.
	 *
	 * @description
	 * Get the day of the week of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {0|1|2|3|4|5|6} the day of week, 0 represents Sunday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which day of the week is 29 February 2012?
	 * const result = getDay(new Date(2012, 1, 29))
	 * //=> 3
	 */
	function getDay(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getDay();
	  return day;
	}
	
	module.exports = exports.default;

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfDay;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfDay
	 * @category Day Helpers
	 * @summary Return the start of a day for the given date.
	 *
	 * @description
	 * Return the start of a day for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of a day
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of a day for 2 September 2014 11:55:00:
	 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 02 2014 00:00:00
	 */
	function startOfDay(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfISOWeekYear;
	
	var _index = _interopRequireDefault(__webpack_require__(171));
	
	var _index2 = _interopRequireDefault(__webpack_require__(148));
	
	var _index3 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfISOWeekYear
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Return the start of an ISO week-numbering year for the given date.
	 *
	 * @description
	 * Return the start of an ISO week-numbering year,
	 * which always starts 3 days before the year's first Thursday.
	 * The result will be in the local timezone.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of an ISO week-numbering year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of an ISO week-numbering year for 2 July 2005:
	 * const result = startOfISOWeekYear(new Date(2005, 6, 2))
	 * //=> Mon Jan 03 2005 00:00:00
	 */
	function startOfISOWeekYear(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  var year = (0, _index.default)(dirtyDate);
	  var fourthOfJanuary = new Date(0);
	  fourthOfJanuary.setFullYear(year, 0, 4);
	  fourthOfJanuary.setHours(0, 0, 0, 0);
	  var date = (0, _index2.default)(fourthOfJanuary);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfMonth;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfMonth
	 * @category Month Helpers
	 * @summary Return the start of a month for the given date.
	 *
	 * @description
	 * Return the start of a month for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of a month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of a month for 2 September 2014 11:55:00:
	 * const result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Mon Sep 01 2014 00:00:00
	 */
	function startOfMonth(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setDate(1);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subDays;
	
	var _index = _interopRequireDefault(__webpack_require__(26));
	
	var _index2 = _interopRequireDefault(__webpack_require__(95));
	
	var _index3 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name subDays
	 * @category Day Helpers
	 * @summary Subtract the specified number of days from the given date.
	 *
	 * @description
	 * Subtract the specified number of days from the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of days to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the days subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 10 days from 1 September 2014:
	 * const result = subDays(new Date(2014, 8, 1), 10)
	 * //=> Fri Aug 22 2014 00:00:00
	 */
	function subDays(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	
	module.exports = exports.default;

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subMilliseconds;
	
	var _index = _interopRequireDefault(__webpack_require__(26));
	
	var _index2 = _interopRequireDefault(__webpack_require__(208));
	
	var _index3 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name subMilliseconds
	 * @category Millisecond Helpers
	 * @summary Subtract the specified number of milliseconds from the given date.
	 *
	 * @description
	 * Subtract the specified number of milliseconds from the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the milliseconds subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
	 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
	 * //=> Thu Jul 10 2014 12:45:29.250
	 */
	function subMilliseconds(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	
	module.exports = exports.default;

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var keys = __webpack_require__(905);
	var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
	
	var toStr = Object.prototype.toString;
	var concat = Array.prototype.concat;
	var defineDataProperty = __webpack_require__(415);
	
	var isFunction = function (fn) {
		return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
	};
	
	var supportsDescriptors = __webpack_require__(430)();
	
	var defineProperty = function (object, name, value, predicate) {
		if (name in object) {
			if (predicate === true) {
				if (object[name] === value) {
					return;
				}
			} else if (!isFunction(predicate) || !predicate()) {
				return;
			}
		}
	
		if (supportsDescriptors) {
			defineDataProperty(object, name, value, true);
		} else {
			defineDataProperty(object, name, value);
		}
	};
	
	var defineProperties = function (object, map) {
		var predicates = arguments.length > 2 ? arguments[2] : {};
		var props = keys(map);
		if (hasSymbols) {
			props = concat.call(props, Object.getOwnPropertySymbols(map));
		}
		for (var i = 0; i < props.length; i += 1) {
			defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
		}
	};
	
	defineProperties.supportsDescriptors = !!supportsDescriptors;
	
	module.exports = defineProperties;


/***/ },
/* 217 */
/***/ function(module, exports) {

	//Types of elements found in the DOM
	module.exports = {
		Text: "text", //Text
		Directive: "directive", //<? ... ?>
		Comment: "comment", //<!-- ... -->
		Script: "script", //<script> tags
		Style: "style", //<style> tags
		Tag: "tag", //Any tag
		CDATA: "cdata", //<![CDATA[ ... ]]>
		Doctype: "doctype",
	
		isTag: function(elem){
			return elem.type === "tag" || elem.type === "script" || elem.type === "style";
		}
	};


/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var undefined;
	
	var $Error = __webpack_require__(1719);
	var $EvalError = __webpack_require__(1718);
	var $RangeError = __webpack_require__(1720);
	var $ReferenceError = __webpack_require__(1721);
	var $SyntaxError = __webpack_require__(686);
	var $TypeError = __webpack_require__(175);
	var $URIError = __webpack_require__(1722);
	
	var $Function = Function;
	
	// eslint-disable-next-line consistent-return
	var getEvalledConstructor = function (expressionSyntax) {
		try {
			return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
		} catch (e) {}
	};
	
	var $gOPD = Object.getOwnPropertyDescriptor;
	if ($gOPD) {
		try {
			$gOPD({}, '');
		} catch (e) {
			$gOPD = null; // this is IE 8, which has a broken gOPD
		}
	}
	
	var throwTypeError = function () {
		throw new $TypeError();
	};
	var ThrowTypeError = $gOPD
		? (function () {
			try {
				// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
				arguments.callee; // IE 8 does not throw here
				return throwTypeError;
			} catch (calleeThrows) {
				try {
					// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
					return $gOPD(arguments, 'callee').get;
				} catch (gOPDthrows) {
					return throwTypeError;
				}
			}
		}())
		: throwTypeError;
	
	var hasSymbols = __webpack_require__(2023)();
	var hasProto = __webpack_require__(2022)();
	
	var getProto = Object.getPrototypeOf || (
		hasProto
			? function (x) { return x.__proto__; } // eslint-disable-line no-proto
			: null
	);
	
	var needsEval = {};
	
	var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined : getProto(Uint8Array);
	
	var INTRINSICS = {
		__proto__: null,
		'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
		'%Array%': Array,
		'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
		'%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
		'%AsyncFromSyncIteratorPrototype%': undefined,
		'%AsyncFunction%': needsEval,
		'%AsyncGenerator%': needsEval,
		'%AsyncGeneratorFunction%': needsEval,
		'%AsyncIteratorPrototype%': needsEval,
		'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
		'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
		'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
		'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
		'%Boolean%': Boolean,
		'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
		'%Date%': Date,
		'%decodeURI%': decodeURI,
		'%decodeURIComponent%': decodeURIComponent,
		'%encodeURI%': encodeURI,
		'%encodeURIComponent%': encodeURIComponent,
		'%Error%': $Error,
		'%eval%': eval, // eslint-disable-line no-eval
		'%EvalError%': $EvalError,
		'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
		'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
		'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
		'%Function%': $Function,
		'%GeneratorFunction%': needsEval,
		'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
		'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
		'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
		'%isFinite%': isFinite,
		'%isNaN%': isNaN,
		'%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
		'%JSON%': typeof JSON === 'object' ? JSON : undefined,
		'%Map%': typeof Map === 'undefined' ? undefined : Map,
		'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
		'%Math%': Math,
		'%Number%': Number,
		'%Object%': Object,
		'%parseFloat%': parseFloat,
		'%parseInt%': parseInt,
		'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
		'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
		'%RangeError%': $RangeError,
		'%ReferenceError%': $ReferenceError,
		'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
		'%RegExp%': RegExp,
		'%Set%': typeof Set === 'undefined' ? undefined : Set,
		'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
		'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
		'%String%': String,
		'%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined,
		'%Symbol%': hasSymbols ? Symbol : undefined,
		'%SyntaxError%': $SyntaxError,
		'%ThrowTypeError%': ThrowTypeError,
		'%TypedArray%': TypedArray,
		'%TypeError%': $TypeError,
		'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
		'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
		'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
		'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
		'%URIError%': $URIError,
		'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
		'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
		'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
	};
	
	if (getProto) {
		try {
			null.error; // eslint-disable-line no-unused-expressions
		} catch (e) {
			// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
			var errorProto = getProto(getProto(e));
			INTRINSICS['%Error.prototype%'] = errorProto;
		}
	}
	
	var doEval = function doEval(name) {
		var value;
		if (name === '%AsyncFunction%') {
			value = getEvalledConstructor('async function () {}');
		} else if (name === '%GeneratorFunction%') {
			value = getEvalledConstructor('function* () {}');
		} else if (name === '%AsyncGeneratorFunction%') {
			value = getEvalledConstructor('async function* () {}');
		} else if (name === '%AsyncGenerator%') {
			var fn = doEval('%AsyncGeneratorFunction%');
			if (fn) {
				value = fn.prototype;
			}
		} else if (name === '%AsyncIteratorPrototype%') {
			var gen = doEval('%AsyncGenerator%');
			if (gen && getProto) {
				value = getProto(gen.prototype);
			}
		}
	
		INTRINSICS[name] = value;
	
		return value;
	};
	
	var LEGACY_ALIASES = {
		__proto__: null,
		'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
		'%ArrayPrototype%': ['Array', 'prototype'],
		'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
		'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
		'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
		'%ArrayProto_values%': ['Array', 'prototype', 'values'],
		'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
		'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
		'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
		'%BooleanPrototype%': ['Boolean', 'prototype'],
		'%DataViewPrototype%': ['DataView', 'prototype'],
		'%DatePrototype%': ['Date', 'prototype'],
		'%ErrorPrototype%': ['Error', 'prototype'],
		'%EvalErrorPrototype%': ['EvalError', 'prototype'],
		'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
		'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
		'%FunctionPrototype%': ['Function', 'prototype'],
		'%Generator%': ['GeneratorFunction', 'prototype'],
		'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
		'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
		'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
		'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
		'%JSONParse%': ['JSON', 'parse'],
		'%JSONStringify%': ['JSON', 'stringify'],
		'%MapPrototype%': ['Map', 'prototype'],
		'%NumberPrototype%': ['Number', 'prototype'],
		'%ObjectPrototype%': ['Object', 'prototype'],
		'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
		'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
		'%PromisePrototype%': ['Promise', 'prototype'],
		'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
		'%Promise_all%': ['Promise', 'all'],
		'%Promise_reject%': ['Promise', 'reject'],
		'%Promise_resolve%': ['Promise', 'resolve'],
		'%RangeErrorPrototype%': ['RangeError', 'prototype'],
		'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
		'%RegExpPrototype%': ['RegExp', 'prototype'],
		'%SetPrototype%': ['Set', 'prototype'],
		'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
		'%StringPrototype%': ['String', 'prototype'],
		'%SymbolPrototype%': ['Symbol', 'prototype'],
		'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
		'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
		'%TypeErrorPrototype%': ['TypeError', 'prototype'],
		'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
		'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
		'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
		'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
		'%URIErrorPrototype%': ['URIError', 'prototype'],
		'%WeakMapPrototype%': ['WeakMap', 'prototype'],
		'%WeakSetPrototype%': ['WeakSet', 'prototype']
	};
	
	var bind = __webpack_require__(420);
	var hasOwn = __webpack_require__(2024);
	var $concat = bind.call(Function.call, Array.prototype.concat);
	var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
	var $replace = bind.call(Function.call, String.prototype.replace);
	var $strSlice = bind.call(Function.call, String.prototype.slice);
	var $exec = bind.call(Function.call, RegExp.prototype.exec);
	
	/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
	var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
	var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
	var stringToPath = function stringToPath(string) {
		var first = $strSlice(string, 0, 1);
		var last = $strSlice(string, -1);
		if (first === '%' && last !== '%') {
			throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
		} else if (last === '%' && first !== '%') {
			throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
		}
		var result = [];
		$replace(string, rePropName, function (match, number, quote, subString) {
			result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
		});
		return result;
	};
	/* end adaptation */
	
	var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
		var intrinsicName = name;
		var alias;
		if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
			alias = LEGACY_ALIASES[intrinsicName];
			intrinsicName = '%' + alias[0] + '%';
		}
	
		if (hasOwn(INTRINSICS, intrinsicName)) {
			var value = INTRINSICS[intrinsicName];
			if (value === needsEval) {
				value = doEval(intrinsicName);
			}
			if (typeof value === 'undefined' && !allowMissing) {
				throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
			}
	
			return {
				alias: alias,
				name: intrinsicName,
				value: value
			};
		}
	
		throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
	};
	
	module.exports = function GetIntrinsic(name, allowMissing) {
		if (typeof name !== 'string' || name.length === 0) {
			throw new $TypeError('intrinsic name must be a non-empty string');
		}
		if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
			throw new $TypeError('"allowMissing" argument must be a boolean');
		}
	
		if ($exec(/^%?[^%]*%?$/, name) === null) {
			throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
		}
		var parts = stringToPath(name);
		var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
	
		var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
		var intrinsicRealName = intrinsic.name;
		var value = intrinsic.value;
		var skipFurtherCaching = false;
	
		var alias = intrinsic.alias;
		if (alias) {
			intrinsicBaseName = alias[0];
			$spliceApply(parts, $concat([0, 1], alias));
		}
	
		for (var i = 1, isOwn = true; i < parts.length; i += 1) {
			var part = parts[i];
			var first = $strSlice(part, 0, 1);
			var last = $strSlice(part, -1);
			if (
				(
					(first === '"' || first === "'" || first === '`')
					|| (last === '"' || last === "'" || last === '`')
				)
				&& first !== last
			) {
				throw new $SyntaxError('property names with quotes must have matching quotes');
			}
			if (part === 'constructor' || !isOwn) {
				skipFurtherCaching = true;
			}
	
			intrinsicBaseName += '.' + part;
			intrinsicRealName = '%' + intrinsicBaseName + '%';
	
			if (hasOwn(INTRINSICS, intrinsicRealName)) {
				value = INTRINSICS[intrinsicRealName];
			} else if (value != null) {
				if (!(part in value)) {
					if (!allowMissing) {
						throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
					}
					return void undefined;
				}
				if ($gOPD && (i + 1) >= parts.length) {
					var desc = $gOPD(value, part);
					isOwn = !!desc;
	
					// By convention, when a data property is converted to an accessor
					// property to emulate a data property that does not suffer from
					// the override mistake, that accessor's getter is marked with
					// an `originalValue` property. Here, when we detect this, we
					// uphold the illusion by pretending to see that original data
					// property, i.e., returning the value rather than the getter
					// itself.
					if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
						value = desc.get;
					} else {
						value = value[part];
					}
				} else {
					isOwn = hasOwn(value, part);
					value = value[part];
				}
	
				if (isOwn && !skipFurtherCaching) {
					INTRINSICS[intrinsicRealName] = value;
				}
			}
		}
		return value;
	};


/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function useOutsideClick(ref, action) {
	  (0, _react.useEffect)(function () {
	    function handleClickOutside(event) {
	      if (ref.current && !ref.current.contains(event.target)) {
	        action();
	      }
	    }
	
	    document.addEventListener('mousedown', handleClickOutside);
	    return function () {
	      document.removeEventListener('mousedown', handleClickOutside);
	    };
	  }, [ref]);
	}
	
	var OutsideClickWrapper = function OutsideClickWrapper(props) {
	  var wrapperRef = (0, _react.useRef)(null);
	  useOutsideClick(wrapperRef, props.action);
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    ref: wrapperRef,
	    className: 'gcl-outside-click-wrapper ' + props.className
	  }, props.children);
	};
	
	OutsideClickWrapper.propTypes = {
	  children: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].array]).isRequired,
	  action: _propTypes["default"].func.isRequired,
	  className: _propTypes["default"].string
	};
	OutsideClickWrapper.defaultProps = {
	  className: ''
	};
	var _default = OutsideClickWrapper;
	exports["default"] = _default;

/***/ },
/* 220 */
205,
/* 221 */
[2714, 13],
/* 222 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(732),
	    baseAssignValue = __webpack_require__(438);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(182);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(125),
	    getPrototype = __webpack_require__(443),
	    isObjectLike = __webpack_require__(85);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(157);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends3 = __webpack_require__(18);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(42);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(24);
	
	var _StyleConfig = __webpack_require__(64);
	
	var _SafeAnchor = __webpack_require__(99);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  active: _propTypes2['default'].bool,
	  disabled: _propTypes2['default'].bool,
	  block: _propTypes2['default'].bool,
	  onClick: _propTypes2['default'].func,
	  componentClass: _elementType2['default'],
	  href: _propTypes2['default'].string,
	  /**
	   * Defines HTML button type attribute
	   * @defaultValue 'button'
	   */
	  type: _propTypes2['default'].oneOf(['button', 'reset', 'submit'])
	};
	
	var defaultProps = {
	  active: false,
	  block: false,
	  disabled: false
	};
	
	var Button = function (_React$Component) {
	  (0, _inherits3['default'])(Button, _React$Component);
	
	  function Button() {
	    (0, _classCallCheck3['default'])(this, Button);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Button.prototype.renderAnchor = function renderAnchor(elementProps, className) {
	    return _react2['default'].createElement(_SafeAnchor2['default'], (0, _extends4['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, elementProps.disabled && 'disabled')
	    }));
	  };
	
	  Button.prototype.renderButton = function renderButton(_ref, className) {
	    var componentClass = _ref.componentClass,
	        elementProps = (0, _objectWithoutProperties3['default'])(_ref, ['componentClass']);
	
	    var Component = componentClass || 'button';
	
	    return _react2['default'].createElement(Component, (0, _extends4['default'])({}, elementProps, {
	      type: elementProps.type || 'button',
	      className: className
	    }));
	  };
	
	  Button.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        active = _props.active,
	        block = _props.block,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['active', 'block', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {
	      active: active
	    }, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'block')] = block, _extends2));
	    var fullClassName = (0, _classnames2['default'])(className, classes);
	
	    if (elementProps.href) {
	      return this.renderAnchor(elementProps, fullClassName);
	    }
	
	    return this.renderButton(elementProps, fullClassName);
	  };
	
	  return Button;
	}(_react2['default'].Component);
	
	Button.propTypes = propTypes;
	Button.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('btn', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL, _StyleConfig.Size.XSMALL], (0, _bootstrapUtils.bsStyles)([].concat((0, _values2['default'])(_StyleConfig.State), [_StyleConfig.Style.DEFAULT, _StyleConfig.Style.PRIMARY, _StyleConfig.Style.LINK]), _StyleConfig.Style.DEFAULT, Button)));
	module.exports = exports['default'];

/***/ },
/* 227 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	function componentWillMount() {
	  // Call this.constructor.gDSFP to support sub-classes.
	  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
	  if (state !== null && state !== undefined) {
	    this.setState(state);
	  }
	}
	
	function componentWillReceiveProps(nextProps) {
	  // Call this.constructor.gDSFP to support sub-classes.
	  // Use the setState() updater to ensure state isn't stale in certain edge cases.
	  function updater(prevState) {
	    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
	    return state !== null && state !== undefined ? state : null;
	  }
	  // Binding "this" is important for shallow renderer support.
	  this.setState(updater.bind(this));
	}
	
	function componentWillUpdate(nextProps, nextState) {
	  try {
	    var prevProps = this.props;
	    var prevState = this.state;
	    this.props = nextProps;
	    this.state = nextState;
	    this.__reactInternalSnapshotFlag = true;
	    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
	      prevProps,
	      prevState
	    );
	  } finally {
	    this.props = prevProps;
	    this.state = prevState;
	  }
	}
	
	// React may warn about cWM/cWRP/cWU methods being deprecated.
	// Add a flag to suppress these warnings for this special case.
	componentWillMount.__suppressDeprecationWarning = true;
	componentWillReceiveProps.__suppressDeprecationWarning = true;
	componentWillUpdate.__suppressDeprecationWarning = true;
	
	function polyfill(Component) {
	  var prototype = Component.prototype;
	
	  if (!prototype || !prototype.isReactComponent) {
	    throw new Error('Can only polyfill class components');
	  }
	
	  if (
	    typeof Component.getDerivedStateFromProps !== 'function' &&
	    typeof prototype.getSnapshotBeforeUpdate !== 'function'
	  ) {
	    return Component;
	  }
	
	  // If new component APIs are defined, "unsafe" lifecycles won't be called.
	  // Error if any of these lifecycles are present,
	  // Because they would work differently between older and newer (16.3+) versions of React.
	  var foundWillMountName = null;
	  var foundWillReceivePropsName = null;
	  var foundWillUpdateName = null;
	  if (typeof prototype.componentWillMount === 'function') {
	    foundWillMountName = 'componentWillMount';
	  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
	    foundWillMountName = 'UNSAFE_componentWillMount';
	  }
	  if (typeof prototype.componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'componentWillReceiveProps';
	  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
	  }
	  if (typeof prototype.componentWillUpdate === 'function') {
	    foundWillUpdateName = 'componentWillUpdate';
	  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
	    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
	  }
	  if (
	    foundWillMountName !== null ||
	    foundWillReceivePropsName !== null ||
	    foundWillUpdateName !== null
	  ) {
	    var componentName = Component.displayName || Component.name;
	    var newApiName =
	      typeof Component.getDerivedStateFromProps === 'function'
	        ? 'getDerivedStateFromProps()'
	        : 'getSnapshotBeforeUpdate()';
	
	    throw Error(
	      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
	        componentName +
	        ' uses ' +
	        newApiName +
	        ' but also contains the following legacy lifecycles:' +
	        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
	        (foundWillReceivePropsName !== null
	          ? '\n  ' + foundWillReceivePropsName
	          : '') +
	        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
	        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
	        'https://fb.me/react-async-component-lifecycle-hooks'
	    );
	  }
	
	  // React <= 16.2 does not support static getDerivedStateFromProps.
	  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
	  // Newer versions of React will ignore these lifecycles if gDSFP exists.
	  if (typeof Component.getDerivedStateFromProps === 'function') {
	    prototype.componentWillMount = componentWillMount;
	    prototype.componentWillReceiveProps = componentWillReceiveProps;
	  }
	
	  // React <= 16.2 does not support getSnapshotBeforeUpdate.
	  // As a workaround, use cWU to invoke the new lifecycle.
	  // Newer versions of React will ignore that lifecycle if gSBU exists.
	  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
	    if (typeof prototype.componentDidUpdate !== 'function') {
	      throw new Error(
	        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
	      );
	    }
	
	    prototype.componentWillUpdate = componentWillUpdate;
	
	    var componentDidUpdate = prototype.componentDidUpdate;
	
	    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
	      prevProps,
	      prevState,
	      maybeSnapshot
	    ) {
	      // 16.3+ will not execute our will-update method;
	      // It will pass a snapshot value to did-update though.
	      // Older versions will require our polyfilled will-update value.
	      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
	      // Because for <= 15.x versions this might be a "prevContext" object.
	      // We also can't just check "__reactInternalSnapshot",
	      // Because get-snapshot might return a falsy value.
	      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
	      var snapshot = this.__reactInternalSnapshotFlag
	        ? this.__reactInternalSnapshot
	        : maybeSnapshot;
	
	      componentDidUpdate.call(this, prevProps, prevState, snapshot);
	    };
	  }
	
	  return Component;
	}
	
	exports.polyfill = polyfill;


/***/ },
/* 228 */
205,
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(27));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _reactTransitionGroup = __webpack_require__(472);
	
	var _utils = __webpack_require__(14);
	
	var _excluded = ["tag", "baseClass", "baseClassActive", "className", "cssModule", "children", "innerRef"];
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	var propTypes = _objectSpread(_objectSpread({}, _reactTransitionGroup.Transition.propTypes), {}, {
	  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]),
	  tag: _utils.tagPropType,
	  baseClass: _propTypes.default.string,
	  baseClassActive: _propTypes.default.string,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  innerRef: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string, _propTypes.default.func])
	});
	
	var defaultProps = _objectSpread(_objectSpread({}, _reactTransitionGroup.Transition.defaultProps), {}, {
	  tag: 'div',
	  baseClass: 'fade',
	  baseClassActive: 'show',
	  timeout: _utils.TransitionTimeouts.Fade,
	  appear: true,
	  enter: true,
	  exit: true,
	  in: true
	});
	
	function Fade(props) {
	  var Tag = props.tag,
	      baseClass = props.baseClass,
	      baseClassActive = props.baseClassActive,
	      className = props.className,
	      cssModule = props.cssModule,
	      children = props.children,
	      innerRef = props.innerRef,
	      otherProps = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
	  var transitionProps = (0, _utils.pick)(otherProps, _utils.TransitionPropTypeKeys);
	  var childProps = (0, _utils.omit)(otherProps, _utils.TransitionPropTypeKeys);
	  return /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.Transition, transitionProps, function (status) {
	    var isActive = status === 'entered';
	    var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, baseClass, isActive && baseClassActive), cssModule);
	    return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({
	      className: classes
	    }, childProps, {
	      ref: innerRef
	    }), children);
	  });
	}
	
	Fade.propTypes = propTypes;
	Fade.defaultProps = defaultProps;
	var _default = Fade;
	exports.default = _default;

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _Layer = _interopRequireDefault(__webpack_require__(49));
	
	var _ReactUtils = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var ErrorBar =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(ErrorBar, _Component);
	
	  function ErrorBar() {
	    _classCallCheck(this, ErrorBar);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(ErrorBar).apply(this, arguments));
	  }
	
	  _createClass(ErrorBar, [{
	    key: "renderErrorBars",
	    value: function renderErrorBars() {
	      var _this$props = this.props,
	          offset = _this$props.offset,
	          layout = _this$props.layout,
	          width = _this$props.width,
	          dataKey = _this$props.dataKey,
	          data = _this$props.data,
	          dataPointFormatter = _this$props.dataPointFormatter,
	          xAxis = _this$props.xAxis,
	          yAxis = _this$props.yAxis,
	          others = _objectWithoutProperties(_this$props, ["offset", "layout", "width", "dataKey", "data", "dataPointFormatter", "xAxis", "yAxis"]);
	
	      var props = (0, _ReactUtils.getPresentationAttributes)(others);
	      return data.map(function (entry, i) {
	        var _dataPointFormatter = dataPointFormatter(entry, dataKey),
	            x = _dataPointFormatter.x,
	            y = _dataPointFormatter.y,
	            value = _dataPointFormatter.value,
	            errorVal = _dataPointFormatter.errorVal;
	
	        if (!errorVal) {
	          return null;
	        }
	
	        var xMid, yMid, xMin, yMin, xMax, yMax, scale, coordsTop, coordsMid, coordsBot, lowBound, highBound;
	
	        if (Array.isArray(errorVal)) {
	          var _errorVal = _slicedToArray(errorVal, 2);
	
	          lowBound = _errorVal[0];
	          highBound = _errorVal[1];
	        } else {
	          lowBound = highBound = errorVal;
	        }
	
	        if (layout === 'vertical') {
	          scale = xAxis.scale;
	          xMid = value;
	          yMid = y + offset;
	          xMin = scale(xMid - lowBound);
	          yMin = yMid + width;
	          xMax = scale(xMid + highBound);
	          yMax = yMid - width;
	          coordsTop = {
	            x1: xMax,
	            y1: yMin,
	            x2: xMax,
	            y2: yMax
	          };
	          coordsMid = {
	            x1: xMin,
	            y1: yMid,
	            x2: xMax,
	            y2: yMid
	          };
	          coordsBot = {
	            x1: xMin,
	            y1: yMin,
	            x2: xMin,
	            y2: yMax
	          };
	        } else if (layout === 'horizontal') {
	          scale = yAxis.scale;
	          xMid = x + offset;
	          yMid = value;
	          xMin = xMid - width;
	          xMax = xMid + width;
	          yMin = scale(yMid - lowBound);
	          yMax = scale(yMid + highBound);
	          coordsTop = {
	            x1: xMin,
	            y1: yMax,
	            x2: xMax,
	            y2: yMax
	          };
	          coordsMid = {
	            x1: xMid,
	            y1: yMin,
	            x2: xMid,
	            y2: yMax
	          };
	          coordsBot = {
	            x1: xMin,
	            y1: yMin,
	            x2: xMax,
	            y2: yMin
	          };
	        }
	
	        return (// eslint-disable-next-line react/no-array-index-key
	          _react["default"].createElement(_Layer["default"], _extends({
	            className: "recharts-errorBar",
	            key: "bar-".concat(i)
	          }, props), _react["default"].createElement("line", coordsTop), _react["default"].createElement("line", coordsMid), _react["default"].createElement("line", coordsBot))
	        );
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react["default"].createElement(_Layer["default"], {
	        className: "recharts-errorBars"
	      }, this.renderErrorBars());
	    }
	  }]);
	
	  return ErrorBar;
	}(_react.Component);
	
	ErrorBar.propTypes = {
	  dataKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func]).isRequired,
	  data: _propTypes["default"].array,
	  xAxis: _propTypes["default"].object,
	  yAxis: _propTypes["default"].object,
	  layout: _propTypes["default"].string,
	  dataPointFormatter: _propTypes["default"].func,
	  stroke: _propTypes["default"].string,
	  strokeWidth: _propTypes["default"].number,
	  width: _propTypes["default"].number,
	  offset: _propTypes["default"].number
	};
	ErrorBar.defaultProps = {
	  stroke: 'black',
	  strokeWidth: 1.5,
	  width: 5,
	  offset: 0,
	  layout: 'horizontal'
	};
	var _default = ErrorBar;
	exports["default"] = _default;

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _ReactUtils = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var propTypes = {
	  width: _propTypes["default"].number.isRequired,
	  height: _propTypes["default"].number.isRequired,
	  viewBox: _propTypes["default"].shape({
	    x: _propTypes["default"].number,
	    y: _propTypes["default"].number,
	    width: _propTypes["default"].number,
	    height: _propTypes["default"].number
	  }),
	  className: _propTypes["default"].string,
	  style: _propTypes["default"].object,
	  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node])
	};
	
	function Surface(props) {
	  var children = props.children,
	      width = props.width,
	      height = props.height,
	      viewBox = props.viewBox,
	      className = props.className,
	      style = props.style,
	      others = _objectWithoutProperties(props, ["children", "width", "height", "viewBox", "className", "style"]);
	
	  var svgView = viewBox || {
	    width: width,
	    height: height,
	    x: 0,
	    y: 0
	  };
	  var layerClass = (0, _classnames["default"])('recharts-surface', className);
	  var attrs = (0, _ReactUtils.getPresentationAttributes)(others);
	  return _react["default"].createElement("svg", _extends({}, attrs, {
	    className: layerClass,
	    width: width,
	    height: height,
	    style: style,
	    viewBox: "".concat(svgView.x, " ").concat(svgView.y, " ").concat(svgView.width, " ").concat(svgView.height),
	    version: "1.1"
	  }), children);
	}
	
	Surface.propTypes = propTypes;
	var _default = Surface;
	exports["default"] = _default;

/***/ },
/* 232 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var DEFAULT_NAMESPACE = exports.DEFAULT_NAMESPACE = '/';
	var ACTION_TYPE_DELIMITER = exports.ACTION_TYPE_DELIMITER = '||';

/***/ },
/* 233 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = function (value) {
	  if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object' || value === null) return false;
	
	  var proto = value;
	  while (Object.getPrototypeOf(proto) !== null) {
	    proto = Object.getPrototypeOf(proto);
	  }
	
	  return Object.getPrototypeOf(value) === proto;
	};

/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	var objectWithoutPropertiesLoose = __webpack_require__(7);
	function _objectWithoutProperties(source, excluded) {
	  if (source == null) return {};
	  var target = objectWithoutPropertiesLoose(source, excluded);
	  var key, i;
	  if (Object.getOwnPropertySymbols) {
	    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
	    for (i = 0; i < sourceSymbolKeys.length; i++) {
	      key = sourceSymbolKeys[i];
	      if (excluded.indexOf(key) >= 0) continue;
	      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
	      target[key] = source[key];
	    }
	  }
	  return target;
	}
	module.exports = _objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.supervisorChatSVG = exports.supervisorChatSimpleSVG = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var supervisorChatSimpleSVG = exports.supervisorChatSimpleSVG = _react2.default.createElement(
		"svg",
		{ className: "supervisorChatSimpleSVG", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", width: "85%", height: "85%", viewBox: "77 1428 20 22.765" },
		_react2.default.createElement(
			"defs",
			null,
			_react2.default.createElement(
				"clipPath",
				{ id: "clip-path" },
				_react2.default.createElement("path", { id: "Path_553", "data-name": "Path 553", className: "cls-1", d: "M0-20.57H20V2.194H0Z", transform: "translate(0 20.57)" })
			)
		),
		_react2.default.createElement(
			"g",
			{ id: "Group_967", "data-name": "Group 967", className: "cls-2", transform: "translate(77 1428)" },
			_react2.default.createElement(
				"g",
				{ id: "Group_946", "data-name": "Group 946", className: "cls-3", transform: "translate(0 0)" },
				_react2.default.createElement(
					"g",
					{ id: "Group_943", "data-name": "Group 943", transform: "translate(0 12.659)" },
					_react2.default.createElement("path", { id: "Path_550", "data-name": "Path 550", d: "M1.284,0C.968,5.845-2.032,8.51-2.032,8.51S-5.009,5.806-5.343,0C-8.523.71-12,2.325-12.033,4.728a12,12,0,0,0,10,5.375,11.993,11.993,0,0,0,10-5.375C7.933,2.329,4.461.713,1.284,0", transform: "translate(12.033 0.002)" })
				),
				_react2.default.createElement(
					"g",
					{ id: "Group_944", "data-name": "Group 944", transform: "translate(5.385 0)" },
					_react2.default.createElement("path", { id: "Path_551", "data-name": "Path 551", d: "M.452,0a4.7,4.7,0,1,1,0,9.4,4.7,4.7,0,0,1,0-9.4", transform: "translate(4.238 0)" })
				),
				_react2.default.createElement(
					"g",
					{ id: "Group_945", "data-name": "Group 945", transform: "translate(8.765 12.261)" },
					_react2.default.createElement("path", { id: "Path_552", "data-name": "Path 552", d: "M.085,0-.8,1.2l.635.953L-.8,3.954.085,6.78.431,7.8.792,6.78l.882-2.825-.636-1.8L1.674,1.2.792,0Z", transform: "translate(0.799)" })
				)
			)
		)
	);
	
	var supervisorChatSVG = exports.supervisorChatSVG = _react2.default.createElement(
		"svg",
		{ version: "1.1", id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
			width: "100%", height: "100%", viewBox: "0 0 40 40", enableBackground: "new 0 0 40 40", xmlSpace: "preserve" },
		_react2.default.createElement(
			"g",
			null,
			_react2.default.createElement(
				"linearGradient",
				{ className: "supervisorChatIconBorder", id: "SVGID_2_", gradientUnits: "userSpaceOnUse", x1: "32.7842", y1: "3.5283", x2: "5.7695", y2: "35.5194" },
				_react2.default.createElement("stop", { offset: "0", style: { stopColor: "#009FFF" } }),
				_react2.default.createElement("stop", { offset: "0.6111", style: { stopColor: "#0066CC" } }),
				_react2.default.createElement("stop", { offset: "0.7346", style: { stopColor: "#005FD3" } }),
				_react2.default.createElement("stop", { offset: "1", style: { stopColor: "#0055DD" } })
			),
			_react2.default.createElement("path", { className: "supervisorChatIconBorder", fill: "url(#SVGID_2_)", d: "M20.244,4.84c-9.323,0-16.884,6.676-16.884,13.516c0,4.273,2.954,9.312,7.447,11.539\r c-0.144,0.669-0.422,1.871-1.869,3.627c-0.451,0.449-0.83,1.091,0.321,1.215c1.215,0.516,5.524,0.035,9.277-2.793\r c0.564,0.041,1.133,0.064,1.707,0.064c9.326,0,16.884-6.816,16.884-13.652C37.128,11.516,29.57,4.84,20.244,4.84z" }),
			_react2.default.createElement(
				"g",
				null,
				_react2.default.createElement("path", { className: "supervisorChatIcon", fill: "#FFFFFF", d: "M22.381,19.24c-0.217,4.023-2.283,5.857-2.283,5.857s-2.049-1.861-2.279-5.859\r c-2.188,0.489-4.581,1.602-4.605,3.257c1.48,2.228,4.017,3.7,6.885,3.7c2.869,0,5.404-1.473,6.884-3.7\r C26.958,20.843,24.568,19.73,22.381,19.24z" }),
				_react2.default.createElement("path", { className: "supervisorChatIcon", fill: "#FFFFFF", d: "M20.148,10.523c1.791,0,3.237,1.443,3.237,3.234s-1.446,3.236-3.237,3.236\r c-1.786,0-3.229-1.445-3.229-3.236S18.362,10.523,20.148,10.523z" }),
				_react2.default.createElement("polygon", { className: "supervisorChatIcon", fill: "#FFFFFF", points: "19.855,18.964 19.247,19.791 19.685,20.447 19.247,21.688 19.855,23.632 20.094,24.335\r 20.343,23.632 20.949,21.688 20.513,20.447 20.949,19.791 20.343,18.964 \t\t" })
			)
		)
	);

/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.manualCallSvg = exports.AtoZ = exports.ZtoA = exports.CellIConAlert = exports.iconList = exports.cellICon = exports.SendMessageIcon = exports.phoneIcon = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var phoneIcon = exports.phoneIcon = _react2.default.createElement(
		"svg",
		{ version: "1.1", className: "phoneIcon", id: "Capa_1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
			viewBox: "0 0 16 16", enableBackground: "new 0 0 16 16;", xmlSpace: "preserve" },
		_react2.default.createElement(
			"g",
			{ id: "Group_3984", transform: "translate(1787 -4216)" },
			_react2.default.createElement("path", { id: "Path_506", className: "st0", d: "M-1781.8,4223c0.8,1.6,2.1,2.9,3.7,3.7l1.2-1.2c0.1-0.1,0.4-0.2,0.6-0.1c0.6,0.2,1.3,0.3,2,0.3\r c0.3,0,0.6,0.2,0.6,0.6v1.9c0,0.3-0.2,0.6-0.6,0.6c-5.2,0-9.4-4.2-9.4-9.4c0,0,0,0,0,0c0-0.3,0.2-0.6,0.6-0.6h1.9\r c0.3,0,0.6,0.2,0.6,0.6c0,0.7,0.1,1.3,0.3,2c0.1,0.2,0,0.4-0.1,0.6L-1781.8,4223z" })
		)
	);
	
	var SendMessageIcon = exports.SendMessageIcon = function SendMessageIcon(props) {
		return _react2.default.createElement(
			"svg",
			{ xmlns: "http://www.w3.org/2000/svg", width: props.width, height: props.height, viewBox: "0 0 24.166 23.19" },
			_react2.default.createElement(
				"g",
				{ id: "Grupo_19307", "data-name": "Grupo 19307", transform: "translate(0 9.333) rotate(-30)" },
				_react2.default.createElement(
					"g",
					{ id: "Grupo_984", "data-name": "Grupo 984", transform: "translate(0 0)" },
					_react2.default.createElement("path", { id: "Trazado_570", "data-name": "Trazado 570", d: "M.009,0,0,6.222,13.333,8,0,9.778.009,16,18.667,8Z", transform: "translate(0 0)", fill: props.fill })
				)
			)
		);
	};
	
	var cellICon = exports.cellICon = _react2.default.createElement(
		"svg",
		{ xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", viewBox: "0 0 20 20" },
		_react2.default.createElement(
			"g",
			{ id: "Icon-11", opacity: "0.401" },
			_react2.default.createElement("path", { id: "Trazado_42", "data-name": "Trazado 42", d: "M68.083,20H61.917A1.919,1.919,0,0,0,60,21.917V34.75a1.919,1.919,0,0,0,1.917,1.917h6.167A1.919,1.919,0,0,0,70,34.75V21.917A1.919,1.919,0,0,0,68.083,20ZM65,35.833A.833.833,0,1,1,65.833,35,.833.833,0,0,1,65,35.833Zm3.333-2.917a.417.417,0,0,1-.417.417H62.083a.417.417,0,0,1-.417-.417V22.083a.417.417,0,0,1,.417-.417h1.25l.833.833h1.667l.833-.833h1.25a.417.417,0,0,1,.417.417Z", transform: "translate(-55 -18.333)" }),
			_react2.default.createElement("rect", { id: "Rect\xE1ngulo_21", "data-name": "Rect\xE1ngulo 21", width: "20", height: "20", fill: "rgba(255,255,255,0)" })
		)
	);
	
	var iconList = exports.iconList = _react2.default.createElement(
		"svg",
		{ id: "Icon-list", xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", viewBox: "0 0 20 20" },
		_react2.default.createElement("path", { id: "Uni\xF3n_16", "data-name": "Uni\xF3n 16", d: "M0,11.666a1.667,1.667,0,1,1,1.667,1.667A1.667,1.667,0,0,1,0,11.666Zm6.25,1.25a1.25,1.25,0,0,1,0-2.5h9.167a1.25,1.25,0,0,1,0,2.5ZM0,6.667A1.667,1.667,0,1,1,1.667,8.333,1.666,1.666,0,0,1,0,6.667Zm6.25,1.25a1.25,1.25,0,0,1,0-2.5h9.167a1.25,1.25,0,0,1,0,2.5ZM0,1.666A1.667,1.667,0,1,1,1.667,3.333,1.667,1.667,0,0,1,0,1.666Zm6.25,1.25a1.25,1.25,0,0,1,0-2.5h9.167a1.25,1.25,0,0,1,0,2.5Z", transform: "translate(1.667 3.333)", fill: "#4b4b4b", stroke: "rgba(0,0,0,0)", "stroke-width": "1" }),
		_react2.default.createElement("rect", { id: "Rect\xE1ngulo_10938", "data-name": "Rect\xE1ngulo 10938", width: "20", height: "20", fill: "none" })
	);
	
	var CellIConAlert = exports.CellIConAlert = function CellIConAlert(props) {
		return _react2.default.createElement(
			"svg",
			{ xmlns: "http://www.w3.org/2000/svg", width: props.width ? props.width : "20", height: props.height ? props.height : "20", viewBox: "0 0 20 20" },
			_react2.default.createElement(
				"g",
				{ id: "Icon-11", opacity: props.opacity ? props.opacity : "0.401" },
				_react2.default.createElement("path", { fill: props.fill, id: "Trazado_42", "data-name": "Trazado 42", d: "M68.083,20H61.917A1.919,1.919,0,0,0,60,21.917V34.75a1.919,1.919,0,0,0,1.917,1.917h6.167A1.919,1.919,0,0,0,70,34.75V21.917A1.919,1.919,0,0,0,68.083,20ZM65,35.833A.833.833,0,1,1,65.833,35,.833.833,0,0,1,65,35.833Zm3.333-2.917a.417.417,0,0,1-.417.417H62.083a.417.417,0,0,1-.417-.417V22.083a.417.417,0,0,1,.417-.417h1.25l.833.833h1.667l.833-.833h1.25a.417.417,0,0,1,.417.417Z", transform: "translate(-55 -18.333)" }),
				_react2.default.createElement("rect", { id: "Rect\xE1ngulo_21", "data-name": "Rect\xE1ngulo 21", width: "20", height: "20", fill: "rgba(255,255,255,0)" })
			)
		);
	};
	
	var ZtoA = exports.ZtoA = _react2.default.createElement(
		"svg",
		{ version: "1.1", className: "orderSVG", id: "Capa_1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
			viewBox: "0 0 10.8 12", enableBackground: "new 0 0 10.8 12;", xmlSpace: "preserve" },
		_react2.default.createElement(
			"g",
			{ id: "Group_3897", transform: "translate(-13337 -13247)", className: "st0" },
			_react2.default.createElement("path", { id: "Path_2033", d: "M13340.5,13247.2h-1.8v8.7h-1.6l2.6,2.9l2.6-2.8l-1.7,0V13247.2z" }),
			_react2.default.createElement("path", { id: "Path_2034", d: "M13345.7,13253.9h-0.7l-2,5.1h0.8l0.4-1.1h2.3l0.4,1.1h0.8L13345.7,13253.9z M13344.5,13257.2l0.9-2.3\r l0.9,2.3H13344.5z" }),
			_react2.default.createElement("path", { id: "Path_2035", d: "M13344.5,13251.4h2.7v0.7h-3.8v-0.5l2.6-3.8h-2.6v-0.7h3.7v0.5L13344.5,13251.4z" })
		)
	);
	
	var AtoZ = exports.AtoZ = _react2.default.createElement(
		"svg",
		{ version: "1.1", className: "orderSVG", id: "Capa_1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
			viewBox: "0 0 10.6 12", enableBackground: "new 0 0 10.6 12;", xmlSpace: "preserve" },
		_react2.default.createElement(
			"g",
			{ id: "Group_3900", transform: "translate(-13477 -13286)", className: "st0" },
			_react2.default.createElement("path", { id: "Path_2026", d: "M13480.4,13286.3h-1.8v8.6h-1.6l2.6,2.8l2.5-2.8h-1.7V13286.3z" }),
			_react2.default.createElement("path", { id: "Path_2027", d: "M13485.6,13286h-0.7l-2,5.1h0.8l0.4-1.1h2.3l0.4,1.1h0.8L13485.6,13286z M13484.4,13289.3l0.9-2.3l0.9,2.3\r H13484.4z" }),
			_react2.default.createElement("path", { id: "Path_2028", d: "M13484.4,13297.3h2.7v0.7h-3.8v-0.6l2.6-3.8h-2.6v-0.7h3.6v0.5L13484.4,13297.3z" })
		)
	);
	
	var manualCallSvg = exports.manualCallSvg = _react2.default.createElement(
		"svg",
		{ version: "1.1", className: "manualCallSvg", id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
			width: "100%", height: "100%", viewBox: "0 0 40 40", enableBackground: "new 0 0 40 40", xmlSpace: "preserve" },
		_react2.default.createElement(
			"g",
			null,
			_react2.default.createElement(
				"linearGradient",
				{ id: "SVGID_3_", gradientUnits: "userSpaceOnUse", x1: "11.3789", y1: "5.9849", x2: "11.3789", y2: "32.6956" },
				_react2.default.createElement("stop", { offset: "0", style: { stopColor: "#00EB0F" } }),
				_react2.default.createElement("stop", { offset: "0.3085", style: { stopColor: "#05D311" } }),
				_react2.default.createElement("stop", { offset: "0.7492", style: { stopColor: "#0CB512" } }),
				_react2.default.createElement("stop", { offset: "1", style: { stopColor: "#0EAA13" } })
			),
			_react2.default.createElement("path", { fill: "url(#SVGID_3_)", d: "M9.135,14.316c-1.197,3.68-1.189,7.67,0,11.359h3.792c0.464,0,0.889,0.268,1.087,0.672l2.586,3.57\r c0.474,0.473,0.474,1.249,0,1.723l-3.009,3.01c-0.474,0.474-1.25,0.474-1.724,0c-8.096-8.096-8.096-21.214,0-29.309\r c0.474-0.473,1.25-0.473,1.724,0l3.018,3.019c0.472,0.474,0.472,1.249,0,1.724l-2.587,3.568c-0.206,0.396-0.612,0.664-1.095,0.664\r H9.135z" }),
			_react2.default.createElement(
				"linearGradient",
				{ id: "SVGID_9_", gradientUnits: "userSpaceOnUse", x1: "32.2051", y1: "13.8291", x2: "28.759", y2: "9.1206" },
				_react2.default.createElement("stop", { offset: "0", style: { stopColor: "#F2F2F2" } }),
				_react2.default.createElement("stop", { offset: "0.3881", style: { stopColor: "#F9F9F9" } }),
				_react2.default.createElement("stop", { offset: "1", style: { stopColor: "#FFFFFF" } })
			),
			_react2.default.createElement("path", { fill: "url(#SVGID_9_)", d: "M33,12.629C33,13.386,32.386,14,31.628,14h-2.256C28.614,14,28,13.386,28,12.629v-2.258\r C28,9.614,28.614,9,29.372,9h2.256C32.386,9,33,9.614,33,10.371V12.629z" }),
			_react2.default.createElement(
				"linearGradient",
				{ id: "SVGID_10_", gradientUnits: "userSpaceOnUse", x1: "24.2041", y1: "13.8281", x2: "20.758", y2: "9.1196" },
				_react2.default.createElement("stop", { offset: "0", style: { stopColor: "#F2F2F2" } }),
				_react2.default.createElement("stop", { offset: "0.3881", style: { stopColor: "#F9F9F9" } }),
				_react2.default.createElement("stop", { offset: "1", style: { stopColor: "#FFFFFF" } })
			),
			_react2.default.createElement("path", { fill: "url(#SVGID_10_)", d: "M25,12.629C25,13.386,24.386,14,23.628,14h-2.256C20.614,14,20,13.386,20,12.629v-2.258\r C20,9.614,20.614,9,21.372,9h2.256C24.386,9,25,9.614,25,10.371V12.629z" }),
			_react2.default.createElement(
				"linearGradient",
				{ id: "SVGID_4_", gradientUnits: "userSpaceOnUse", x1: "32.2051", y1: "21.8301", x2: "28.7578", y2: "17.12" },
				_react2.default.createElement("stop", { offset: "0", style: { stopColor: "#F2F2F2" } }),
				_react2.default.createElement("stop", { offset: "0.3881", style: { stopColor: "#F9F9F9" } }),
				_react2.default.createElement("stop", { offset: "1", style: { stopColor: "#FFFFFF" } })
			),
			_react2.default.createElement("path", { fill: "url(#SVGID_4_)", d: "M33,20.629C33,21.387,32.386,22,31.628,22h-2.256C28.614,22,28,21.387,28,20.629v-2.258\r C28,17.613,28.614,17,29.372,17h2.256C32.386,17,33,17.613,33,18.371V20.629z" }),
			_react2.default.createElement(
				"linearGradient",
				{ id: "SVGID_5_", gradientUnits: "userSpaceOnUse", x1: "24.2051", y1: "21.8301", x2: "20.7578", y2: "17.12" },
				_react2.default.createElement("stop", { offset: "0", style: { stopColor: "#F2F2F2" } }),
				_react2.default.createElement("stop", { offset: "0.3881", style: { stopColor: "#F9F9F9" } }),
				_react2.default.createElement("stop", { offset: "1", style: { stopColor: "#FFFFFF" } })
			),
			_react2.default.createElement("path", { fill: "url(#SVGID_5_)", d: "M25,20.629C25,21.387,24.386,22,23.628,22h-2.256C20.614,22,20,21.387,20,20.629v-2.258\r C20,17.613,20.614,17,21.372,17h2.256C24.386,17,25,17.613,25,18.371V20.629z" }),
			_react2.default.createElement(
				"linearGradient",
				{ id: "SVGID_6_", gradientUnits: "userSpaceOnUse", x1: "24.2051", y1: "29.8291", x2: "20.759", y2: "25.1206" },
				_react2.default.createElement("stop", { offset: "0", style: { stopColor: "#F2F2F2" } }),
				_react2.default.createElement("stop", { offset: "0.3881", style: { stopColor: "#F9F9F9" } }),
				_react2.default.createElement("stop", { offset: "1", style: { stopColor: "#FFFFFF" } })
			),
			_react2.default.createElement("path", { fill: "url(#SVGID_6_)", d: "M25,28.629C25,29.387,24.386,30,23.628,30h-2.256C20.614,30,20,29.387,20,28.629v-2.258\r C20,25.613,20.614,25,21.372,25h2.256C24.386,25,25,25.613,25,26.371V28.629z" }),
			_react2.default.createElement(
				"linearGradient",
				{ id: "SVGID_7_", gradientUnits: "userSpaceOnUse", x1: "16.2041", y1: "21.8291", x2: "12.7574", y2: "17.1198" },
				_react2.default.createElement("stop", { offset: "0", style: { stopColor: "#F2F2F2" } }),
				_react2.default.createElement("stop", { offset: "0.3881", style: { stopColor: "#F9F9F9" } }),
				_react2.default.createElement("stop", { offset: "1", style: { stopColor: "#FFFFFF" } })
			),
			_react2.default.createElement("path", { fill: "url(#SVGID_7_)", d: "M17,20.629C17,21.387,16.386,22,15.628,22h-2.256C12.614,22,12,21.387,12,20.629v-2.258\r C12,17.613,12.614,17,13.372,17h2.256C16.386,17,17,17.613,17,18.371V20.629z" }),
			_react2.default.createElement(
				"linearGradient",
				{ id: "SVGID_8_", gradientUnits: "userSpaceOnUse", x1: "32.2051", y1: "29.8291", x2: "28.759", y2: "25.1206" },
				_react2.default.createElement("stop", { offset: "0", style: { stopColor: "#F2F2F2" } }),
				_react2.default.createElement("stop", { offset: "0.3881", style: { stopColor: "#F9F9F9" } }),
				_react2.default.createElement("stop", { offset: "1", style: { stopColor: "#FFFFFF" } })
			),
			_react2.default.createElement("path", { fill: "url(#SVGID_8_)", d: "M33,28.629C33,29.386,32.386,30,31.628,30h-2.256C28.614,30,28,29.386,28,28.629v-2.258\r C28,25.614,28.614,25,29.372,25h2.256C32.386,25,33,25.614,33,26.371V28.629z" })
		),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null)
	);

/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Images = __webpack_require__(30);
	
	var _globalComponentsLibrary = __webpack_require__(28);
	
	var _Singleton = __webpack_require__(21);
	
	var _constants = __webpack_require__(10);
	
	var _reactstrap = __webpack_require__(111);
	
	var _reactRedux = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var language = new _Singleton.Singleton();
	
	var ContainerDataPreview = function ContainerDataPreview(_ref) {
	  var updateDataCallPreview = _ref.updateDataCallPreview,
	      userState = _ref.userState,
	      data = _ref.data,
	      headers = _ref.headers,
	      callKey = _ref.callKey,
	      showLog = _ref.showLog,
	      setShowLog = _ref.setShowLog,
	      _ref$showOnlyData = _ref.showOnlyData,
	      showOnlyData = _ref$showOnlyData === undefined ? false : _ref$showOnlyData,
	      _ref$showDataLogDisp = _ref.showDataLogDisp,
	      showDataLogDisp = _ref$showDataLogDisp === undefined ? false : _ref$showDataLogDisp,
	      onChangeData = _ref.onChangeData,
	      disableInput = _ref.disableInput;
	
	  var _useState = (0, _react.useState)([]),
	      _useState2 = _slicedToArray(_useState, 2),
	      listData = _useState2[0],
	      setListData = _useState2[1];
	
	  var _useState3 = (0, _react.useState)([]),
	      _useState4 = _slicedToArray(_useState3, 2),
	      listaHeaders = _useState4[0],
	      setListaHeaders = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      showData = _useState6[0],
	      setShowData = _useState6[1];
	
	  var _useState7 = (0, _react.useState)([{}]),
	      _useState8 = _slicedToArray(_useState7, 2),
	      original = _useState8[0],
	      setOriginal = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(true),
	      _useState10 = _slicedToArray(_useState9, 2),
	      disabledUpdate = _useState10[0],
	      setDisabledUpdate = _useState10[1];
	
	  var showContainer = (0, _reactRedux.useSelector)(function (state) {
	    return state.previewActions.showData;
	  });
	  var recordPreview = (0, _reactRedux.useSelector)(function (state) {
	    return state.preview;
	  });
	
	  var _useState11 = (0, _react.useState)([]),
	      _useState12 = _slicedToArray(_useState11, 2),
	      dataObj = _useState12[0],
	      setDataObj = _useState12[1];
	
	  var _useState13 = (0, _react.useState)('colN2'),
	      _useState14 = _slicedToArray(_useState13, 2),
	      width = _useState14[0],
	      setWidth = _useState14[1];
	
	  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
	    return state.preview;
	  }),
	      simultaneosRecs = _useSelector.simultaneosRecs;
	
	  var _useState15 = (0, _react.useState)(''),
	      _useState16 = _slicedToArray(_useState15, 2),
	      tempWidth = _useState16[0],
	      setTempWidth = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(),
	      _useState18 = _slicedToArray(_useState17, 2),
	      labelDataClientTitle = _useState18[0],
	      setLabelDataClientTitle = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(data),
	      _useState20 = _slicedToArray(_useState19, 2),
	      tempArrayToSave = _useState20[0],
	      setTempArrayToSave = _useState20[1];
	
	  (0, _react.useEffect)(function () {
	    if (userState === _constants.USER_STATE.AGENT_PREVIEW || userState === '') {
	      setLabelDataClientTitle(language.getText("CallControlGUIContactDatatitlePreview"));
	    } else {
	      setLabelDataClientTitle(language.getText("CallControlGUIContactDatatitle"));
	    }
	  }, [userState]);
	
	  (0, _react.useEffect)(function () {
	    onChangeData && onChangeData({ newArray: tempArrayToSave, disabledUpdate: disabledUpdate });
	  }, [disabledUpdate, tempArrayToSave]);
	
	  (0, _react.useEffect)(function () {
	    setOriginalObj();
	    fnDisableUpdate();
	  }, [tempArrayToSave]);
	
	  (0, _react.useEffect)(function () {
	    fnDisableUpdate();
	  }, [data]);
	
	  (0, _react.useEffect)(function () {
	    if (data.length > 0 && headers.length > 0) {
	      setListData(data);
	      setListaHeaders(headers);
	      setTempArrayToSave(data);
	    }
	  }, [data]);
	
	  (0, _react.useEffect)(function () {
	    if (listData.length > 0) {
	      if (userState !== _constants.USER_STATE.DIALOG) {
	        setColumns();
	        setOriginalObj();
	        setShowData(true);
	      } else {
	        setColumns();
	        setOriginalObj();
	        setShowData(true);
	      }
	    }
	  }, [listData]);
	
	  (0, _react.useEffect)(function () {
	    if (showLog) {
	      setWidth('colN1_SimultaneousView');
	    } else {
	      setWidth(tempWidth);
	    }
	  }, [showLog]);
	
	  var setOriginalObj = function setOriginalObj() {
	    var originalObj = tempArrayToSave.map(function (dato, i) {
	      return { indice: i + 1, dato: dato };
	    });
	    setOriginal(originalObj);
	  };
	
	  var setColumns = function setColumns() {
	    var c = data.map(function (dato, i) {
	      return { dato: dato, header: listaHeaders[i], indice: i + 1 };
	    });
	    setDataObj(c);
	    defineNumberColumns();
	  };
	
	  var defineNumberColumns = function defineNumberColumns() {
	    var nData = data.length;
	    if (simultaneosRecs) {
	      widthForSimultaneousView(nData);
	    } else if (userState === _constants.USER_STATE.AGENT_PREVIEW || userState === _constants.USER_STATE.WRAPUP) {
	      widthForMax3columns(nData);
	    } else if (userState === _constants.USER_STATE.DIALOG) {
	      widthForMax4Columns(nData);
	    }
	  };
	
	  var widthForMax3columns = function widthForMax3columns(nData) {
	    if (nData >= 9 & nData <= 15) {
	      setWidth('colN3_max3Col');
	    } else if (nData > 1 & nData < 9) {
	      setWidth('colN2_max3Col');
	    } else {
	      setWidth('colN1_max3Col');
	    }
	  };
	  var widthForMax4Columns = function widthForMax4Columns(nData) {
	    if (nData === 1) {
	      setWidth('colN1_max4Col');
	    } else if (nData <= 8) {
	      setWidth('colN2_max4Col');
	    } else if (nData >= 9 & nData <= 11) {
	      setWidth('colN3_max4Col');
	    } else {
	      setWidth('colN4_max4Col');
	    }
	  };
	  var widthForSimultaneousView = function widthForSimultaneousView(nData) {
	    if (nData <= 5) {
	      setWidth('colN1_SimultaneousView-fiveOrLess');
	      setTempWidth('colN1_SimultaneousView-fiveOrLess');
	    } else {
	      setWidth('colN2_SimultaneousView');
	      setTempWidth('colN2_SimultaneousView');
	    }
	  };
	  var saveData = function saveData(dato, i) {
	    var tempObj = { indice: i, dato: dato };
	    var newArray = original.map(function (o) {
	      return o.indice === tempObj.indice ? tempObj.dato : o.dato;
	    });
	    setTempArrayToSave(newArray);
	  };
	
	  var sendData = function sendData() {
	    setDisabledUpdate(true);
	    var temp = [].concat(_toConsumableArray(tempArrayToSave));
	    while (temp.length < 15) {
	      temp.push('');
	    }
	
	    var dataPrev = {
	      callKey: recordPreview.callKey,
	      camID: recordPreview.camId,
	      newData: temp,
	      callOutId: recordPreview.callOutId
	    };
	    updateDataCallPreview(dataPrev);
	  };
	  var fnDisableUpdate = function fnDisableUpdate() {
	    var somethingChange = JSON.stringify(data) !== JSON.stringify(tempArrayToSave);
	    var isEqual = somethingChange === disabledUpdate;
	    somethingChange ? isEqual && setDisabledUpdate(false) : isEqual && setDisabledUpdate(true);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'cdp-infoContainer ' + (userState === _constants.USER_STATE.WRAPUP && !simultaneosRecs ? '_wrapup' : '') + '  ' + (simultaneosRecs ? 'simultaneousView' : '') + ' ' + (showLog ? 'showLog' : '') + ' ' + (showDataLogDisp === true ? 'showDataLogDisp' : '') + ' ' + (showOnlyData === true ? 'showOnlyData' : '') + ' ' },
	    _react2.default.createElement(
	      'div',
	      { className: 'cdp-recordInformation ' + (showLog ? 'showLog' : '') },
	      _react2.default.createElement(
	        'div',
	        { className: 'dataClientTitle ' + (simultaneosRecs && 'simultaneousView') },
	        labelDataClientTitle,
	        _react2.default.createElement(
	          'div',
	          { className: 'callKeyPreview ' + (simultaneosRecs ? 'simultaneosRecs' : '') },
	          _react2.default.createElement('img', { className: 'callKeyIcon', src: _Images.callIcon, alt: 'icon' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'callKeyValuePreview' },
	            callKey
	          )
	        )
	      ),
	      simultaneosRecs && !showLog && _react2.default.createElement(
	        'div',
	        { className: 'cdp-container-log' },
	        _react2.default.createElement('i', { className: 'gcl-icon history', id: 'cdp-btn-LogRec', onClick: function onClick() {
	            return setShowLog(!showLog);
	          } }),
	        _react2.default.createElement(
	          _reactstrap.UncontrolledTooltip,
	          { innerClassName: 'dal-tooltip-log', placement: 'top', target: 'cdp-btn-LogRec', boundariesElement: 'window' },
	          language.getText('GUIPreviewdialingLogBtn')
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'DataPreviewContainer ' + (simultaneosRecs ? 'simultaneousView' : '') + ' ' + (showLog ? 'showLog' : '') },
	      showData && dataObj.length > 0 && _react2.default.createElement(
	        'div',
	        { className: 'colN1 ' + width + ' ' + (showLog ? 'showLog' : '') },
	        dataObj.map(function (dato, index) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'alignLabelInput ' + width },
	            _react2.default.createElement(_globalComponentsLibrary.LabelInput, {
	              key: dato.indice,
	              label: dato.header,
	              focus: true, placeholder: dato.header,
	              value: dato.dato,
	              disabled: disableInput,
	              onChange: function onChange(e) {
	                return saveData(e, dato.indice);
	              },
	              multiline: true,
	              rows: 2,
	              maxRows: 2,
	              numberInput: dato.indice,
	              withNumber: true,
	              maxLength: 255
	            })
	          );
	        })
	      )
	    ),
	    userState === _constants.USER_STATE.DIALOG && recordPreview.simultaneosRecs === false && _react2.default.createElement(
	      'div',
	      { className: 'containerCenterButton' },
	      _react2.default.createElement(
	        _globalComponentsLibrary.AgentButton,
	        { type: 'primary', disabled: disabledUpdate, onClick: sendData },
	        language.getText("CallControlGUIContactDatabuttom")
	      )
	    ),
	    userState === _constants.USER_STATE.OTHER && showContainer && recordPreview.simultaneosRecs === false && _react2.default.createElement(
	      'div',
	      { className: 'containerCenterButton' },
	      _react2.default.createElement(
	        _globalComponentsLibrary.AgentButton,
	        { type: 'primary', disabled: disabledUpdate, onClick: sendData },
	        language.getText("CallControlGUIContactDatabuttom")
	      )
	    )
	  );
	};
	
	exports.default = ContainerDataPreview;

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _customCell = __webpack_require__(509);
	
	var _Singleton = __webpack_require__(21);
	
	var _Images = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TableComponent = function (_Component) {
	  _inherits(TableComponent, _Component);
	
	  // PROPS:
	  // customCell : Nombre de la celda que lo va a mapear, esta celda deber ir en customCell.js
	  // parameters : objecto con los parametros que se van a mapear en la celda
	  // dataSource : array de objetos a listar
	  // selectable : aparecera el cusror de seleccion en hover
	  // selectedStyle : estilo de la celda cuando sea seleccionda
	  // cellHover : estilo de la celda en hover
	  // selectSeveral : se pueden seleccionar varias celdas??
	  // searching : parametro a buscar
	  // searchingValue : propiedad del objeto donde se va a buscar
	  // onSelectItem : funcion que se ejecutara cuando se seleccione una celda
	  // onDoubleClick : funcion que se ejecutara cuando se de doble click una celda
	  // onActionInCell : funcion para poder hacer otra cosa en la celda
	  // orderBy : ordernar por propiedad
	  // orderForm : true : ascendente, false : descendente
	  function TableComponent(props) {
	    _classCallCheck(this, TableComponent);
	
	    var _this = _possibleConstructorReturn(this, (TableComponent.__proto__ || Object.getPrototypeOf(TableComponent)).call(this, props));
	
	    _this.language = new _Singleton.Singleton();
	    _this.state = {
	      searching: _this.props.searching || "",
	      searchingValue: _this.props.searchingValue || "",
	      orderBy: _this.props.orderBy || "",
	      orderForm: _this.props.orderForm,
	      selectedStyle: _this.props.selectedStyle || "defaultSelected",
	      cellHover: _this.props.cellHover || "hoverGray",
	      dataSource: [],
	      tamanio: 25,
	      pageIndex: 1,
	      pagination: _this.props.pagination
	
	      //this.selectedItem = false;
	    };_this.canDoubleClick = false;
	    _this.timerDoubleClick = null;
	    _this.pageSizes = [{
	      label: "25",
	      value: "25"
	    }, {
	      label: "50",
	      value: "50"
	    }, {
	      label: "75",
	      value: "75"
	    }, {
	      label: "100",
	      value: "100"
	    }];
	
	    _this.lastRecord = 0;
	    _this.dataInPage = [];
	    _this.totalRecords = 0;
	    _this.firstRecord = 1;
	    _this.pageCount = 0;
	    _this.canNextPage = true;
	    _this.canPreviousPage = false;
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.labelfirstRecord = 0, _this.labelTotalRecord = 0;
	    return _this;
	  }
	
	  _createClass(TableComponent, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.mapDataSource(this.props.dataSource);
	      if (this.props.onRef) {
	        this.props.onRef(this);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.props.onRef) {
	        this.props.onRef(null);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (JSON.stringify(nextProps) === JSON.stringify(this.props)) {
	        return;
	      }
	      this.setState({
	        searching: nextProps.searching,
	        searchingValue: typeof nextProps.searchingValue !== "undefined" ? nextProps.searchingValue : this.state.searchingValue,
	        orderBy: typeof nextProps.orderBy !== "undefined" ? nextProps.orderBy : this.state.orderBy,
	        orderForm: typeof nextProps.orderForm !== "undefined" ? nextProps.orderForm : this.state.orderForm
	      });
	      if (nextProps.dataSource !== this.props.dataSource) {
	        this.mapDataSource(nextProps.dataSource);
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevState) {
	
	      if (prevState.tamanio !== this.state.tamanio || prevState.pageIndex !== this.state.pageIndex) {
	        this.renderTableItems();
	      }
	    }
	  }, {
	    key: 'mapDataSource',
	    value: function mapDataSource(dataSourceMap) {
	      for (var i in dataSourceMap) {
	        dataSourceMap[i]["selectionActive"] = false;
	      }
	      this.setState({ dataSource: dataSourceMap });
	    }
	  }, {
	    key: 'selectItem',
	    value: function selectItem(item) {
	      if (this.props.selectedItem !== item) {
	        if (!this.props.selectSeveral) {
	          var arrayState = [].concat(_toConsumableArray(this.state.dataSource));
	          for (var i in arrayState) {
	            arrayState[i].selectionActive = JSON.stringify(this.state.dataSource[i]) === JSON.stringify(item);
	          }
	          this.setState({ dataSource: arrayState });
	        } else {
	          item["selectionActive"] = !item["selectionActive"];
	        }
	
	        if (this.props.onSelectItem) {
	          this.props.onSelectItem(item);
	        }
	      }
	    }
	  }, {
	    key: 'findElements',
	    value: function findElements(item) {
	      var _this2 = this;
	
	      var image = "";
	      for (var i in item) {
	        if (item[i] && item[i].toString().indexOf(".svg") !== -1) {
	          image = item[i];
	        }
	      }
	      var keysSearch = Object.keys(item).filter(function (key) {
	        return key.indexOf(_this2.state.searchingValue) !== -1;
	      });
	
	      var stringify = JSON.stringify(item, keysSearch);
	      for (var key in keysSearch) {
	        stringify = stringify.replace(keysSearch[key], '');
	      }
	      stringify = stringify.replace(image, '').replace(/[^a-zA-Z0-9]/g, "").replace('false', '').replace('true', '');
	
	      return stringify.toLowerCase().indexOf(this.state.searching.toLowerCase()) !== -1;
	    }
	  }, {
	    key: 'paginator',
	    value: function paginator() {
	      this.totalRecords = this.state.dataSource.length; //total de datos
	      this.pageCount = Math.ceil(this.state.dataSource.length / this.state.tamanio); //total de paginas
	
	      if (this.state.dataSource.length <= this.state.tamanio) {
	        //tamanio esrows per page
	
	        this.canNextPage = false;
	        this.canPreviousPage = false;
	        this.dataInPage = this.state.dataSource;
	        this.lastRecord = this.state.tamanio;
	      } else {
	        this.canNextPage = this.state.pageIndex < this.pageCount;
	        this.canPreviousPage = this.state.pageIndex > 1;
	
	        if (this.state.pageIndex === 1) {
	          this.dataInPage = this.state.dataSource.slice(0, this.state.tamanio);
	          this.firstRecord = 1;
	          this.lastRecord = this.state.tamanio;
	        } else {
	          var inicio = this.state.tamanio * (this.state.pageIndex - 1);
	          var fin = this.state.tamanio * this.state.pageIndex;
	          this.dataInPage = this.state.dataSource.slice(inicio, fin);
	          this.lastRecord = this.state.pageIndex * this.dataInPage.length;
	          this.firstRecord = this.state.tamanio * (this.state.pageIndex - 1) + 1;
	          this.lastRecord = this.state.tamanio * this.state.pageIndex;
	        }
	      }
	      this.labelfirstRecord = this.totalRecords === 0 ? 0 : this.firstRecord;
	      this.labelTotalRecord = this.totalRecords === 0 ? 0 : this.totalRecords < this.lastRecord ? this.state.dataSource.length : this.lastRecord;
	    }
	  }, {
	    key: 'renderTableItems',
	    value: function renderTableItems() {
	      var _this3 = this;
	
	      if (this.state.dataSource !== null && this.state.dataSource !== undefined) {
	        if (this.state.pagination) {
	          this.paginator();
	        }
	        var orderBy = this.state.orderBy;
	        if (orderBy) {
	          this.state.dataSource.sort(function (a, b) {
	            return _this3.state.orderForm ? a[_this3.state.orderBy].localeCompare(b[_this3.state.orderBy]) : b[_this3.state.orderBy].localeCompare(a[_this3.state.orderBy]);
	          });
	          if (this.state.pagination) {
	            this.paginator();
	          }
	        }
	        var dataSourceVar = this.state.pagination ? this.dataInPage : this.state.dataSource;
	        if (this.state.searching != null) {
	          dataSourceVar = dataSourceVar.filter(this.findElements.bind(this));
	        }
	        return dataSourceVar.map(function (item, i) {
	          return _customCell.CUSTOM_CELLS[_this3.props.customCell](item, _this3.props.parameters, (_this3.props.selectable ? "selectable " : "") + (item.selectionActive ? _this3.state.selectedStyle : _this3.state.cellHover), _this3.selectItem.bind(_this3), _this3.props.onActionInCell, _this3.props.onDoubleClick && function () {
	            return _this3.props.onDoubleClick(item);
	          }, i);
	        });
	      }
	    }
	  }, {
	    key: 'gotoPage',
	    value: function gotoPage(page) {
	      this.state.pageIndex = page;
	
	      this.setState({ pageIndex: page });
	    }
	  }, {
	    key: 'previousPage',
	    value: function previousPage() {
	      this.setState({ pageIndex: this.state.pageIndex - 1 });
	    }
	  }, {
	    key: 'nextPage',
	    value: function nextPage() {
	      this.setState({ pageIndex: this.state.pageIndex + 1 });
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(e) {
	      this.setState({ tamanio: e.target.value });
	      this.setState({ pageIndex: 1 });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: "tableComponent " + (this.props.disabled ? "disabled" : "") },
	        _react2.default.createElement(
	          'ul',
	          { className: 'listTable' },
	          this.renderTableItems()
	        ),
	        this.state.pagination && _react2.default.createElement(
	          'div',
	          { className: 'pagination', id: 'pagination' },
	          _react2.default.createElement(
	            'div',
	            { className: 'rowsPerPage' },
	            this.language.getText("GUICallHistoryrowsPerPage"),
	            ' ',
	            _react2.default.createElement(
	              'select',
	              { onChange: this.handleChange },
	              this.pageSizes.map(function (option) {
	                return _react2.default.createElement(
	                  'option',
	                  { value: option.value },
	                  option.label
	                );
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'pages' },
	            _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                this.labelfirstRecord,
	                ' - ',
	                this.labelTotalRecord,
	                ' ',
	                this.language.getText("GUICallHistoryof"),
	                ' ',
	                this.totalRecords
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'buttonsPagination' },
	            _react2.default.createElement(
	              'button',
	              { className: 'btnP', onClick: function onClick() {
	                  return _this4.gotoPage(1);
	                }, disabled: !this.canPreviousPage },
	              _react2.default.createElement('img', { src: _Images.firstPage, alt: 'First Page', className: "iconL " + (this.canPreviousPage ? "" : "btnDisabled") })
	            ),
	            ' ',
	            _react2.default.createElement(
	              'button',
	              { className: 'btnP', onClick: function onClick() {
	                  return _this4.previousPage();
	                }, disabled: !this.canPreviousPage },
	              _react2.default.createElement('img', { src: _Images.leftArrow, alt: 'Last Page', className: "iconS " + (this.canPreviousPage ? "" : "btnDisabled") })
	            ),
	            ' ',
	            _react2.default.createElement(
	              'button',
	              { className: 'btnP', onClick: function onClick() {
	                  return _this4.nextPage();
	                }, disabled: !this.canNextPage },
	              _react2.default.createElement('img', { src: _Images.rightArrow, alt: 'Next Page', className: "iconS " + (this.canNextPage ? "" : "btnDisabled") })
	            ),
	            ' ',
	            _react2.default.createElement(
	              'button',
	              { className: 'btnP', onClick: function onClick() {
	                  return _this4.gotoPage(_this4.pageCount);
	                }, disabled: !this.canNextPage },
	              _react2.default.createElement('img', { src: _Images.lastPage, alt: 'Last Page', className: "iconL " + (this.canNextPage ? "" : "btnDisabled") })
	            ),
	            ' '
	          )
	        )
	      );
	    }
	  }]);
	
	  return TableComponent;
	}(_react.Component);
	
	exports.default = TableComponent;

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.errorsMessagePreviewSR = exports.Strategies_Preview_RecState = undefined;
	exports.getCurrentTimeInSec = getCurrentTimeInSec;
	
	var _constants = __webpack_require__(10);
	
	var _Singleton = __webpack_require__(21);
	
	var _alertBodies = __webpack_require__(240);
	
	var Strategies_Preview_RecState = exports.Strategies_Preview_RecState = {
	    "Callout": function Callout(message, that) {
	        that.props.setCallId({ callOutId: message.CallOutId, callId: message.CallId, calloutMaxTime: message.CalloutMaxTime });
	    },
	    "Dialog": function Dialog(message, that) {
	        !that.props.preview.simultaneosRecs && previewProcess(that);
	
	        var timeInSec = getCurrentTimeInSec();
	
	        if (message.ActivePreview) {
	            that.props.changePreviewRecordStatus({ callOutId: message.CallOutId, status: _constants.RECORD_STATE.DIALOG });
	            that.props.setInitialDialogTime({ callOutId: message.CallOutId, timeOnDialog: timeInSec });
	            that.props.setSelectedRecord(message.CallOutId);
	        } else {
	            that.props.changePreviewRecordStatus({ callOutId: message.CallOutId, status: _constants.RECORD_STATE.HOLD });
	        }
	    },
	
	    "RingingListening": function RingingListening(message, that) {
	        that.props.changePreviewRecordStatus({ callOutId: message.CallOutId, status: _constants.RECORD_STATE.DIALING });
	    },
	
	    "ALERT": function ALERT(message, that) {
	        if (message.Code === "1508" && message.DialResultID === 13) {
	            that.props.changePreviewRecordStatus({ callOutId: message.CallOutId, status: _constants.RECORD_STATE.DEFAULT });
	        } else {
	            that.props.changePreviewRecordStatus({ callOutId: message.CallOutId, status: _constants.RECORD_STATE.ALERT, messageStatus: message.Code });
	        }
	    },
	
	    "Wrapup": function Wrapup(message, that) {
	        var lastSelectedRecord = that.props.preview.selectedRecord;
	        var recordToChange = that.props.preview.records.filter(function (r) {
	            return r.callOutId === message.CallOutId;
	        })[0];
	        if (recordToChange.status === _constants.RECORD_STATE.DIALOG || recordToChange.status === _constants.RECORD_STATE.WAITING_WRAPUP) {
	            that.props.changePreviewRecordStatus({ callOutId: message.CallOutId ? message.CallOutId : lastSelectedRecord.callOutId, status: _constants.RECORD_STATE.WRAPUP, messageStatus: message.Code });
	        } else if (recordToChange.status === _constants.RECORD_STATE.HOLD) {
	            if (message.AgentHangUp) {
	                that.props.changePreviewRecordStatus({ callOutId: message.CallOutId ? message.CallOutId : lastSelectedRecord.callOutId, status: _constants.RECORD_STATE.WRAPUP, messageStatus: message.Code });
	            } else {
	                that.props.changePreviewRecordStatus({ callOutId: message.CallOutId, status: _constants.RECORD_STATE.ABANDONED, messageStatus: '' });
	            }
	        }
	    },
	    "dialogTime": function dialogTime(message, that) {
	        if (Math.round(message.dialogTime) !== 0) {
	            that.props.setDialogTimeSimultaneousView({ callOutId: message.CallOutId, dialogTime: Math.round(message.dialogTime) });
	        }
	    },
	    "Hold": function Hold(message, that) {
	        that.props.changePreviewRecordStatus({ callOutId: message.CallOutId, status: _constants.RECORD_STATE.HOLD });
	    },
	    "NotReady": function NotReady(message, that) {
	        that.props.cleanData();
	    },
	    "BeforeWrapup": function BeforeWrapup(message, that) {
	        that.props.changePreviewRecordStatus({ callOutId: message.CallOutId, status: _constants.RECORD_STATE.WAITING_WRAPUP, messageStatus: '' });
	    },
	    "notReadyScheduled": function notReadyScheduled(message, that) {
	        that.props.setNDScheduled();
	    }
	};
	
	var previewProcess = function previewProcess(that) {
	    that.props.setDialogTime(undefined);
	    var previewTime = that.props.preview.totalPreviewTime;
	    that.props.actionPreviewRecord({
	        process: 7,
	        camId: that.props.preview.isSendProcess ? that.props.preview.camId : that.props.preview.tempPrevRecord.camId,
	        callOutId: that.props.preview.isSendProcess ? that.props.preview.callOutId : that.props.preview.tempPrevRecord.callOutId,
	        previewTime: that.props.preview.isSendProcess ? previewTime : that.props.preview.tempPrevRecord.previewTime,
	        callId: that.props.preview.isSendProcess ? that.state.dataCall.CallId : that.props.preview.tempPrevRecord.callId
	    });
	    that.props.setIsSendProcess(true);
	};
	
	function getCurrentTimeInSec() {
	    var currentTime = new Date();
	    var currentHourInSeconds = currentTime.getHours() * 3600;
	    var currentMinutesInSeconds = currentTime.getMinutes() * 60;
	    var currentSeconds = currentTime.getSeconds();
	    return currentHourInSeconds + currentMinutesInSeconds + currentSeconds;
	}
	
	var errorsMessagePreviewSR = exports.errorsMessagePreviewSR = function errorsMessagePreviewSR(errorCode) {
	    var phone = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	    var isSnackbar = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	    var language = new _Singleton.Singleton();
	    var textBody = '';
	    switch (errorCode) {
	        case '1500':
	            textBody = language.getText('GUIPreviewSimultaneousAlertsnotify-busy-line');
	            break;
	        case '1501':
	            textBody = language.getText('GUIPreviewSimultaneousAlertsnotify-not-answered');
	            break;
	        case '1502':
	            textBody = language.getText('GUIPreviewSimultaneousAlertsnotify-fax-modem');
	            break;
	        case '1503':
	            textBody = language.getText('GUIPreviewSimultaneousAlertsnotify-am-voicemail');
	            break;
	        case '1504':
	            textBody = language.getText('GUIPreviewSimultaneousAlertsnotify-no-dial-tone');
	            break;
	        case '1505':
	            textBody = language.getText('GUIPreviewSimultaneousAlertsnotify-busy-circuit');
	            break;
	        case '1506':
	            textBody = language.getText('GUIPreviewSimultaneousAlertsnotify-other');
	            break;
	        case '1507':
	            textBody = language.getText('GUIPreviewSimultaneousAlertsnotify-out-of-service');
	            break;
	        case '1508':
	            textBody = language.getText('GUIPreviewSimultaneousAlertsnotify-cancelled');
	            break;
	        case '1509':
	        case '1510':
	        case '1511':
	            textBody = language.getText('GUIPreviewSimultaneousAlertsnotify-not-answered');
	            break;
	        case '1512':
	            textBody = isSnackbar ? language.getText('GUIPreviewSimultaneousAlertscancelled-on-answer-mssg').replace('[n]', "[" + phone + "]") : language.getText('GUIDialResultCancelledByEngaged');
	            break;
	        default:
	            textBody = (0, _alertBodies.generalBody)(language.getText('alert-' + errorCode));
	            break;
	    }
	    return textBody;
	};

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.correctPhoneNumber = correctPhoneNumber;
	exports.recordingNotFound = recordingNotFound;
	exports.configurationErrorBody = configurationErrorBody;
	exports.generalBody = generalBody;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Singleton = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var language = new _Singleton.Singleton();
	
	function correctPhoneNumber(text, phoneNumber) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'bodyContainer' },
	    _react2.default.createElement(
	      'p',
	      { className: 'bodyText' },
	      text + " | " + phoneNumber
	    )
	  );
	}
	function recordingNotFound() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'bodyContainer' },
	    _react2.default.createElement(
	      'p',
	      { className: 'bodyText' },
	      language.getText('alert-2030')
	    )
	  );
	}
	function configurationErrorBody() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'bodyContainer' },
	    _react2.default.createElement(
	      'p',
	      { className: 'bodyText' },
	      language.getText('alert-2031')
	    )
	  );
	}
	function generalBody(text) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'bodyContainer' },
	    _react2.default.createElement(
	      'p',
	      { className: 'bodyText' },
	      text
	    )
	  );
	}

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.hideAdminModal = exports.showAdminModal = undefined;
	
	var _constants = __webpack_require__(10);
	
	var showAdminModal = exports.showAdminModal = function showAdminModal(payload) {
	    return {
	        type: _constants.ADMIN_MODAL_ACTIONS.SHOW_ADMIN_MODAL,
	        payload: payload
	    };
	};
	
	var hideAdminModal = exports.hideAdminModal = function hideAdminModal() {
	    return {
	        type: _constants.ADMIN_MODAL_ACTIONS.HIDE_ADMIN_MODAL
	    };
	};

/***/ },
/* 242 */
/***/ function(module, exports) {

	module.exports = true;


/***/ },
/* 243 */
[2662, 341],
/* 244 */
143,
/* 245 */
[2625, 79, 47, 142],
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(35);
	var $export = __webpack_require__(11);
	var redefine = __webpack_require__(68);
	var redefineAll = __webpack_require__(163);
	var meta = __webpack_require__(117);
	var forOf = __webpack_require__(249);
	var anInstance = __webpack_require__(161);
	var isObject = __webpack_require__(36);
	var fails = __webpack_require__(34);
	var $iterDetect = __webpack_require__(251);
	var setToStringTag = __webpack_require__(165);
	var inheritIfRequired = __webpack_require__(359);
	
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  var fixMethod = function (KEY) {
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function (a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a) {
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance = new C();
	    // early implementations not supports chaining
	    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
	    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
	    // most early implementations doesn't supports iterables, most modern - not close it correctly
	    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
	    // for early implementations -0 and +0 not the same
	    var BUGGY_ZERO = !IS_WEAK && fails(function () {
	      // V8 ~ Chromium 42- fails only with 5+ elements
	      var $instance = new C();
	      var index = 5;
	      while (index--) $instance[ADDER](index, index);
	      return !$instance.has(-0);
	    });
	    if (!ACCEPT_ITERABLES) {
	      C = wrapper(function (target, iterable) {
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base(), target, C);
	        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if (IS_WEAK && proto.clear) delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};


/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(590);
	var redefine = __webpack_require__(68);
	var hide = __webpack_require__(78);
	var fails = __webpack_require__(34);
	var defined = __webpack_require__(105);
	var wks = __webpack_require__(44);
	var regexpExec = __webpack_require__(365);
	
	var SPECIES = wks('species');
	
	var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
	  // #replace needs built-in support for named groups.
	  // #match works fine because it just return the exec results, even if it has
	  // a "grops" property.
	  var re = /./;
	  re.exec = function () {
	    var result = [];
	    result.groups = { a: '7' };
	    return result;
	  };
	  return ''.replace(re, '$<a>') !== '7';
	});
	
	var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
	  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
	  var re = /(?:)/;
	  var originalExec = re.exec;
	  re.exec = function () { return originalExec.apply(this, arguments); };
	  var result = 'ab'.split(re);
	  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
	})();
	
	module.exports = function (KEY, length, exec) {
	  var SYMBOL = wks(KEY);
	
	  var DELEGATES_TO_SYMBOL = !fails(function () {
	    // String methods call symbol-named RegEp methods
	    var O = {};
	    O[SYMBOL] = function () { return 7; };
	    return ''[KEY](O) != 7;
	  });
	
	  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
	    // Symbol-named RegExp methods call .exec
	    var execCalled = false;
	    var re = /a/;
	    re.exec = function () { execCalled = true; return null; };
	    if (KEY === 'split') {
	      // RegExp[@@split] doesn't call the regex's exec method, but first creates
	      // a new one. We need to return the patched regex when creating the new one.
	      re.constructor = {};
	      re.constructor[SPECIES] = function () { return re; };
	    }
	    re[SYMBOL]('');
	    return !execCalled;
	  }) : undefined;
	
	  if (
	    !DELEGATES_TO_SYMBOL ||
	    !DELEGATES_TO_EXEC ||
	    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
	    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
	  ) {
	    var nativeRegExpMethod = /./[SYMBOL];
	    var fns = exec(
	      defined,
	      SYMBOL,
	      ''[KEY],
	      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
	        if (regexp.exec === regexpExec) {
	          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
	            // The native String method already delegates to @@method (this
	            // polyfilled function), leasing to infinite recursion.
	            // We avoid it by directly calling the native @@method method.
	            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
	          }
	          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
	        }
	        return { done: false };
	      }
	    );
	    var strfn = fns[0];
	    var rxfn = fns[1];
	
	    redefine(String.prototype, KEY, strfn);
	    hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function (string, arg) { return rxfn.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function (string) { return rxfn.call(string, this); }
	    );
	  }
	};


/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 21.2.5.3 get RegExp.prototype.flags
	var anObject = __webpack_require__(33);
	module.exports = function () {
	  var that = anObject(this);
	  var result = '';
	  if (that.global) result += 'g';
	  if (that.ignoreCase) result += 'i';
	  if (that.multiline) result += 'm';
	  if (that.unicode) result += 'u';
	  if (that.sticky) result += 'y';
	  return result;
	};


/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(91);
	var call = __webpack_require__(542);
	var isArrayIter = __webpack_require__(360);
	var anObject = __webpack_require__(33);
	var toLength = __webpack_require__(47);
	var getIterFn = __webpack_require__(375);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ },
/* 250 */
[2637, 104],
/* 251 */
[2641, 44],
/* 252 */
/***/ function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var classof = __webpack_require__(201);
	var builtinExec = RegExp.prototype.exec;
	
	 // `RegExpExec` abstract operation
	// https://tc39.github.io/ecma262/#sec-regexpexec
	module.exports = function (R, S) {
	  var exec = R.exec;
	  if (typeof exec === 'function') {
	    var result = exec.call(R, S);
	    if (typeof result !== 'object') {
	      throw new TypeError('RegExp exec method returned something other than an Object or null');
	    }
	    return result;
	  }
	  if (classof(R) !== 'RegExp') {
	    throw new TypeError('RegExp#exec called on incompatible receiver');
	  }
	  return builtinExec.call(R, S);
	};


/***/ },
/* 254 */
[2657, 46, 35, 136],
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(35);
	var hide = __webpack_require__(78);
	var uid = __webpack_require__(143);
	var TYPED = uid('typed_array');
	var VIEW = uid('view');
	var ABV = !!(global.ArrayBuffer && global.DataView);
	var CONSTR = ABV;
	var i = 0;
	var l = 9;
	var Typed;
	
	var TypedArrayConstructors = (
	  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
	).split(',');
	
	while (i < l) {
	  if (Typed = global[TypedArrayConstructors[i++]]) {
	    hide(Typed.prototype, TYPED, true);
	    hide(Typed.prototype, VIEW, true);
	  } else CONSTR = false;
	}
	
	module.exports = {
	  ABV: ABV,
	  CONSTR: CONSTR,
	  TYPED: TYPED,
	  VIEW: VIEW
	};


/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(35);
	var navigator = global.navigator;
	
	module.exports = navigator && navigator.userAgent || '';


/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var _react = _interopRequireDefault(__webpack_require__(1));
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	__webpack_require__(2507);
	var _classnames = _interopRequireDefault(__webpack_require__(119));
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	var IconButton = function IconButton(_ref) {
	  var id = _ref.id,
	    icon = _ref.icon,
	    onClick = _ref.onClick,
	    disabled = _ref.disabled,
	    secondary = _ref.secondary,
	    large = _ref.large,
	    active = _ref.active;
	  var classes = (0, _classnames["default"])({
	    secondary: secondary,
	    active: active,
	    large: large
	  });
	  return /*#__PURE__*/_react["default"].createElement("button", {
	    id: id,
	    className: 'uin-icon-btn ' + classes,
	    onClick: onClick,
	    disabled: disabled
	  }, /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon ".concat(large ? 'large' : '', " ").concat(icon)
	  }));
	};
	IconButton.propTypes = {
	  id: _propTypes["default"].string,
	  icon: _propTypes["default"].string.isRequired,
	  onClick: _propTypes["default"].func,
	  disabled: _propTypes["default"].bool,
	  secondary: _propTypes["default"].bool,
	  active: _propTypes["default"].bool,
	  large: _propTypes["default"].bool
	};
	var _default = exports["default"] = IconButton;

/***/ },
/* 258 */
[2710, 205, 12],
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfUTCISOWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function startOfUTCISOWeek(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var weekStartsOn = 1;
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getUTCDay();
	  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
	  date.setUTCDate(date.getUTCDate() - diff);
	  date.setUTCHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfUTCWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	var _index3 = _interopRequireDefault(__webpack_require__(26));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function startOfUTCWeek(dirtyDate, dirtyOptions) {
	  (0, _index2.default)(1, arguments);
	  var options = dirtyOptions || {};
	  var locale = options.locale;
	  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
	  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, _index3.default)(localeWeekStartsOn);
	  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, _index3.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getUTCDay();
	  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
	  date.setUTCDate(date.getUTCDate() - diff);
	  date.setUTCHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addHours;
	
	var _index = _interopRequireDefault(__webpack_require__(26));
	
	var _index2 = _interopRequireDefault(__webpack_require__(208));
	
	var _index3 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_HOUR = 3600000;
	/**
	 * @name addHours
	 * @category Hour Helpers
	 * @summary Add the specified number of hours to the given date.
	 *
	 * @description
	 * Add the specified number of hours to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of hours to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the hours added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 2 hours to 10 July 2014 23:00:00:
	 * const result = addHours(new Date(2014, 6, 10, 23, 0), 2)
	 * //=> Fri Jul 11 2014 01:00:00
	 */
	
	function addHours(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, amount * MILLISECONDS_IN_HOUR);
	}
	
	module.exports = exports.default;

/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addMinutes;
	
	var _index = _interopRequireDefault(__webpack_require__(26));
	
	var _index2 = _interopRequireDefault(__webpack_require__(208));
	
	var _index3 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_MINUTE = 60000;
	/**
	 * @name addMinutes
	 * @category Minute Helpers
	 * @summary Add the specified number of minutes to the given date.
	 *
	 * @description
	 * Add the specified number of minutes to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of minutes to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the minutes added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 30 minutes to 10 July 2014 12:00:00:
	 * const result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
	 * //=> Thu Jul 10 2014 12:30:00
	 */
	
	function addMinutes(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, amount * MILLISECONDS_IN_MINUTE);
	}
	
	module.exports = exports.default;

/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInMilliseconds;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInMilliseconds
	 * @category Millisecond Helpers
	 * @summary Get the number of milliseconds between the given dates.
	 *
	 * @description
	 * Get the number of milliseconds between the given dates.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of milliseconds
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many milliseconds are between
	 * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
	 * const result = differenceInMilliseconds(
	 *   new Date(2014, 6, 2, 12, 30, 21, 700),
	 *   new Date(2014, 6, 2, 12, 30, 20, 600)
	 * )
	 * //=> 1100
	 */
	function differenceInMilliseconds(dateLeft, dateRight) {
	  (0, _index2.default)(2, arguments);
	  return (0, _index.default)(dateLeft).getTime() - (0, _index.default)(dateRight).getTime();
	}
	
	module.exports = exports.default;

/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInMonths;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(386));
	
	var _index3 = _interopRequireDefault(__webpack_require__(146));
	
	var _index4 = _interopRequireDefault(__webpack_require__(6));
	
	var _index5 = _interopRequireDefault(__webpack_require__(647));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInMonths
	 * @category Month Helpers
	 * @summary Get the number of full months between the given dates.
	 *
	 * @description
	 * Get the number of full months between the given dates using trunc as a default rounding method.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of full months
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many full months are between 31 January 2014 and 1 September 2014?
	 * const result = differenceInMonths(new Date(2014, 8, 1), new Date(2014, 0, 31))
	 * //=> 7
	 */
	function differenceInMonths(dirtyDateLeft, dirtyDateRight) {
	  (0, _index4.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  var sign = (0, _index3.default)(dateLeft, dateRight);
	  var difference = Math.abs((0, _index2.default)(dateLeft, dateRight));
	  var result; // Check for the difference of less than month
	
	  if (difference < 1) {
	    result = 0;
	  } else {
	    if (dateLeft.getMonth() === 1 && dateLeft.getDate() > 27) {
	      // This will check if the date is end of Feb and assign a higher end of month date
	      // to compare it with Jan
	      dateLeft.setDate(30);
	    }
	
	    dateLeft.setMonth(dateLeft.getMonth() - sign * difference); // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
	    // If so, result must be decreased by 1 in absolute value
	
	    var isLastMonthNotFull = (0, _index3.default)(dateLeft, dateRight) === -sign; // Check for cases of one full calendar month
	
	    if ((0, _index5.default)((0, _index.default)(dirtyDateLeft)) && difference === 1 && (0, _index3.default)(dirtyDateLeft, dateRight) === 1) {
	      isLastMonthNotFull = false;
	    }
	
	    result = sign * (difference - Number(isLastMonthNotFull));
	  } // Prevent negative zero
	
	
	  return result === 0 ? 0 : result;
	}
	
	module.exports = exports.default;

/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfDay;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name endOfDay
	 * @category Day Helpers
	 * @summary Return the end of a day for the given date.
	 *
	 * @description
	 * Return the end of a day for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of a day
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of a day for 2 September 2014 11:55:00:
	 * const result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 02 2014 23:59:59.999
	 */
	function endOfDay(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfMonth;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name endOfMonth
	 * @category Month Helpers
	 * @summary Return the end of a month for the given date.
	 *
	 * @description
	 * Return the end of a month for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of a month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of a month for 2 September 2014 11:55:00:
	 * const result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 30 2014 23:59:59.999
	 */
	function endOfMonth(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var month = date.getMonth();
	  date.setFullYear(date.getFullYear(), month + 1, 0);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isWeekend;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isWeekend
	 * @category Weekday Helpers
	 * @summary Does the given date fall on a weekend?
	 *
	 * @description
	 * Does the given date fall on a weekend?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date falls on a weekend
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Does 5 October 2014 fall on a weekend?
	 * const result = isWeekend(new Date(2014, 9, 5))
	 * //=> true
	 */
	function isWeekend(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getDay();
	  return day === 0 || day === 6;
	}
	
	module.exports = exports.default;

/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setMonth;
	
	var _index = _interopRequireDefault(__webpack_require__(26));
	
	var _index2 = _interopRequireDefault(__webpack_require__(9));
	
	var _index3 = _interopRequireDefault(__webpack_require__(635));
	
	var _index4 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setMonth
	 * @category Month Helpers
	 * @summary Set the month to the given date.
	 *
	 * @description
	 * Set the month to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} month - the month of the new date
	 * @returns {Date} the new date with the month set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set February to 1 September 2014:
	 * const result = setMonth(new Date(2014, 8, 1), 1)
	 * //=> Sat Feb 01 2014 00:00:00
	 */
	function setMonth(dirtyDate, dirtyMonth) {
	  (0, _index4.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var month = (0, _index.default)(dirtyMonth);
	  var year = date.getFullYear();
	  var day = date.getDate();
	  var dateWithDesiredMonth = new Date(0);
	  dateWithDesiredMonth.setFullYear(year, month, 15);
	  dateWithDesiredMonth.setHours(0, 0, 0, 0);
	  var daysInMonth = (0, _index3.default)(dateWithDesiredMonth); // Set the last day of the new month
	  // if the original date was the last day of the longer month
	
	  date.setMonth(month, Math.min(day, daysInMonth));
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfQuarter;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfQuarter
	 * @category Quarter Helpers
	 * @summary Return the start of a year quarter for the given date.
	 *
	 * @description
	 * Return the start of a year quarter for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of a quarter
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of a quarter for 2 September 2014 11:55:00:
	 * const result = startOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Jul 01 2014 00:00:00
	 */
	function startOfQuarter(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var currentMonth = date.getMonth();
	  var month = currentMonth - currentMonth % 3;
	  date.setMonth(month, 1);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfYear;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfYear
	 * @category Year Helpers
	 * @summary Return the start of a year for the given date.
	 *
	 * @description
	 * Return the start of a year for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of a year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of a year for 2 September 2014 11:55:00:
	 * const result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
	 * //=> Wed Jan 01 2014 00:00:00
	 */
	function startOfYear(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var cleanDate = (0, _index.default)(dirtyDate);
	  var date = new Date(0);
	  date.setFullYear(cleanDate.getFullYear(), 0, 1);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(123));
	
	var on = function on() {};
	
	if (_inDOM.default) {
	  on = function () {
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.addEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.attachEvent('on' + eventName, function (e) {
	        e = e || window.event;
	        e.target = e.target || e.srcElement;
	        e.currentTarget = node;
	        handler.call(node, e);
	      });
	    };
	  }();
	}
	
	var _default = on;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 272 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = getWindow;
	
	function getWindow(node) {
	  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
	}
	
	module.exports = exports["default"];

/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = style;
	
	var _camelizeStyle = _interopRequireDefault(__webpack_require__(679));
	
	var _hyphenateStyle = _interopRequireDefault(__webpack_require__(1705));
	
	var _getComputedStyle2 = _interopRequireDefault(__webpack_require__(1700));
	
	var _removeStyle = _interopRequireDefault(__webpack_require__(1701));
	
	var _properties = __webpack_require__(678);
	
	var _isTransform = _interopRequireDefault(__webpack_require__(1702));
	
	function style(node, property, value) {
	  var css = '';
	  var transforms = '';
	  var props = property;
	
	  if (typeof property === 'string') {
	    if (value === undefined) {
	      return node.style[(0, _camelizeStyle.default)(property)] || (0, _getComputedStyle2.default)(node).getPropertyValue((0, _hyphenateStyle.default)(property));
	    } else {
	      (props = {})[property] = value;
	    }
	  }
	
	  Object.keys(props).forEach(function (key) {
	    var value = props[key];
	
	    if (!value && value !== 0) {
	      (0, _removeStyle.default)(node, (0, _hyphenateStyle.default)(key));
	    } else if ((0, _isTransform.default)(key)) {
	      transforms += key + "(" + value + ") ";
	    } else {
	      css += (0, _hyphenateStyle.default)(key) + ": " + value + ";";
	    }
	  });
	
	  if (transforms) {
	    css += _properties.transform + ": " + transforms + ";";
	  }
	
	  node.style.cssText += ';' + css;
	}
	
	module.exports = exports["default"];

/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	__webpack_require__(1009);
	
	__webpack_require__(1010);
	
	var _classNames = _interopRequireDefault(__webpack_require__(61));
	
	var _CheckboxContext = __webpack_require__(423);
	
	var _reactstrap = __webpack_require__(48);
	
	var _hooks = __webpack_require__(110);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var ContextWrapper = function ContextWrapper() {
	  try {
	    var _useContext = (0, _react.useContext)(_CheckboxContext.Context),
	        _useContext2 = _slicedToArray(_useContext, 8),
	        onNewCheck = _useContext2[0],
	        onRemoveCheck = _useContext2[1],
	        notifyContext = _useContext2[2],
	        onReorderChecks = _useContext2[4],
	        checkedIds = _useContext2[6],
	        onDisabledCheck = _useContext2[7];
	
	    return [onNewCheck, onRemoveCheck, notifyContext, onReorderChecks, checkedIds, onDisabledCheck];
	  } catch (e) {
	    return [null, null, null, null, null, null];
	  }
	};
	
	var Checkbox = function Checkbox(props) {
	  var _useState = (0, _react.useState)(props.checked),
	      _useState2 = _slicedToArray(_useState, 2),
	      checked = _useState2[0],
	      setChecked = _useState2[1];
	
	  var classes = (0, _classNames["default"])({
	    disabled: props.disabled,
	    checked: checked
	  });
	
	  var _ContextWrapper = ContextWrapper(),
	      _ContextWrapper2 = _slicedToArray(_ContextWrapper, 6),
	      onNewCheck = _ContextWrapper2[0],
	      onRemoveCheck = _ContextWrapper2[1],
	      notifyContext = _ContextWrapper2[2],
	      onReorderChecks = _ContextWrapper2[3],
	      checkedIds = _ContextWrapper2[4],
	      onDisabledCheck = _ContextWrapper2[5];
	
	  var key = props.id + 'key';
	  (0, _react.useEffect)(function () {
	    onMountAddToContext();
	    return function () {
	      return onUnMountRemoveFromContext();
	    };
	  }, []);
	
	  var onMountAddToContext = function onMountAddToContext() {
	    onNewCheck && onNewCheck(key, contextSetChecked, props.id, props.checked, props.disabled);
	  };
	
	  var onUnMountRemoveFromContext = function onUnMountRemoveFromContext() {
	    onRemoveCheck && onRemoveCheck(key);
	  };
	
	  var contextSetChecked = function contextSetChecked(flag) {
	    props.onChange(flag);
	    setChecked(flag);
	  };
	
	  var onChange = function onChange(e) {
	    e.stopPropagation();
	
	    if (!props.disabled) {
	      props.onChange(!checked);
	      notifyContext && notifyContext(props.id, !checked, key);
	      setChecked(!checked);
	    }
	  };
	
	  (0, _react.useEffect)(function () {
	    onReorderChecks && onReorderChecks(props.id, key);
	  }, [props.id]);
	  (0, _react.useEffect)(function () {
	    if (checkedIds && checkedIds.includes(props.id) && !checked) {
	      notifyContext && notifyContext(props.id, true, key);
	      setChecked(true);
	    }
	  }, [checkedIds]);
	  (0, _hooks.useUpdateEffect)(function () {
	    notifyContext && notifyContext(props.id, props.checked, key);
	    setChecked(props.checked);
	  }, [props.checked]);
	  (0, _react.useEffect)(function () {
	    onDisabledCheck && onDisabledCheck(key, props.disabled);
	  }, [props.disabled]);
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    id: "checkbox-".concat(props.id),
	    className: "gcl-check ".concat(props.className, " ").concat(classes),
	    onClick: onChange,
	    tabIndex: 1
	  }, /*#__PURE__*/_react["default"].createElement("input", {
	    type: "checkbox",
	    disabled: props.disabled,
	    id: "check-id-".concat(props.id),
	    name: "check-".concat(props.id),
	    checked: checked,
	    onChange: props.onChange
	  }), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-check-item ".concat(props.captionPosition, " ").concat(props.assigned ? 'assigned' : '')
	  }, /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon checkbox".concat(checked ? '-checked' : '', " ").concat(props.assigned ? 'assigned' : '')
	  })), props.icon && /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon ".concat(props.icon, " ").concat(props.iconSize, " glc-check-icon")
	  }), /*#__PURE__*/_react["default"].createElement("span", null, props.caption), props.tooltip && /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
	    delay: {
	      show: 500,
	      hide: 100
	    },
	    placement: "top",
	    target: "checkbox-".concat(props.id),
	    boundariesElement: "window"
	  }, props.tooltip));
	};
	
	Checkbox.defaultProps = {
	  onChange: function onChange() {},
	  className: '',
	  captionPosition: 'right',
	  icon: '',
	  iconSize: '',
	  checked: false
	};
	Checkbox.propTypes = {
	  className: _propTypes["default"].string,
	  disabled: _propTypes["default"].bool,
	  onChange: _propTypes["default"].func.isRequired,
	  caption: _propTypes["default"].string,
	  captionPosition: _propTypes["default"].oneOf(['left', 'right']),
	  checked: _propTypes["default"].bool.isRequired,
	  id: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired,
	  icon: _propTypes["default"].string,
	  iconSize: _propTypes["default"].oneOf(['small', 'large', '']),
	  tooltip: _propTypes["default"].string
	};
	var _default = Checkbox;
	exports["default"] = _default;

/***/ },
/* 275 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CHANNEL_ICONS = exports.CAMPAIGN_ICONS = exports.AGENT_STATUS_TO_ICON = void 0;
	var AGENT_STATUS_TO_ICON_DICTIONARY = {
	  ready: 'agent',
	  dialog: 'call',
	  dialoginit: 'call',
	  xfer: 'xfer',
	  xferinit: 'xfer',
	  xferqueue: 'call',
	  callout: 'call',
	  notready: 'unavailable-agent',
	  wrapup: 'notes',
	  problem: 'warning',
	  other: 'transfer',
	  login: 'agent',
	  logout: 'agent',
	  ringing: 'call',
	  unknown: 'question',
	  chatting: 'chat',
	  assisted: 'assisted',
	  whatsappdialog: ['whatsapp', 'whatsapp-filled'],
	  preview: 'preview',
	  readypreview: 'readypreview',
	  inactive: 'inactive-agent',
	  emaildialog: 'mail'
	};
	var AGENT_STATUS_TO_ICON = new Proxy(AGENT_STATUS_TO_ICON_DICTIONARY, {
	  get: function get(object, property) {
	    return object.hasOwnProperty(property) ? object[property] : 'question';
	  }
	});
	exports.AGENT_STATUS_TO_ICON = AGENT_STATUS_TO_ICON;
	var CAMPAIGN_ICON_DICTIONARY = [{
	  id: 1,
	  icon: 'meeting'
	}, {
	  id: 2,
	  icon: 'globe'
	}, {
	  id: 3,
	  icon: 'call'
	}, {
	  id: 4,
	  icon: 'swim'
	}, {
	  id: 5,
	  icon: 'anchor'
	}, {
	  id: 6,
	  icon: 'health'
	}, {
	  id: 7,
	  icon: 'plus'
	}, {
	  id: 8,
	  icon: 'trip'
	}, {
	  id: 9,
	  icon: 'star'
	}, {
	  id: 10,
	  icon: 'tool'
	}, {
	  id: 11,
	  icon: 'cell'
	}, {
	  id: 12,
	  icon: 'basket'
	}, {
	  id: 13,
	  icon: 'musical-note'
	}, {
	  id: 14,
	  icon: 'heart'
	}, {
	  id: 15,
	  icon: 'home'
	}, {
	  id: 16,
	  icon: 'no-data'
	}, {
	  id: 17,
	  icon: 'talk'
	}, {
	  id: 18,
	  icon: 'skate'
	}, {
	  id: 19,
	  icon: 'hat'
	}, {
	  id: 20,
	  icon: 'shirt'
	}, {
	  id: 21,
	  icon: 'controller'
	}, {
	  id: 22,
	  icon: 'run'
	}, {
	  id: 23,
	  icon: 'swirl'
	}, {
	  id: 24,
	  icon: 'explosion'
	}, {
	  id: 25,
	  icon: 'nuxiba'
	}];
	var CAMPAIGN_ICONS = new Proxy(CAMPAIGN_ICON_DICTIONARY, {
	  get: function get(object, property) {
	    return object.hasOwnProperty(property) ? object[property] : {
	      id: 25,
	      icon: 'nuxiba'
	    };
	  }
	});
	exports.CAMPAIGN_ICONS = CAMPAIGN_ICONS;
	var CHANNEL_ICONS = {
	  0: 'call',
	  1: 'chat',
	  4: 'ia',
	  5: 'whatsapp',
	  6: 'preview',
	  7: 'sms'
	};
	exports.CHANNEL_ICONS = CHANNEL_ICONS;

/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.dropdownType = exports.contactType = void 0;
	
	var _propTypes = __webpack_require__(2);
	
	var dropdownType = (0, _propTypes.shape)({
	  id: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string]).isRequired,
	  text: _propTypes.string.isRequired
	});
	exports.dropdownType = dropdownType;
	var contactType = (0, _propTypes.shape)({
	  name: _propTypes.string,
	  account: _propTypes.string,
	  image: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.element])
	});
	exports.contactType = contactType;

/***/ },
/* 277 */
[2710, 220, 13],
/* 278 */
/***/ function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    if (superCtor) {
	      ctor.super_ = superCtor
	      ctor.prototype = Object.create(superCtor.prototype, {
	        constructor: {
	          value: ctor,
	          enumerable: false,
	          writable: true,
	          configurable: true
	        }
	      })
	    }
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    if (superCtor) {
	      ctor.super_ = superCtor
	      var TempCtor = function () {}
	      TempCtor.prototype = superCtor.prototype
	      ctor.prototype = new TempCtor()
	      ctor.prototype.constructor = ctor
	    }
	  }
	}


/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(2135),
	    listCacheDelete = __webpack_require__(2136),
	    listCacheGet = __webpack_require__(2137),
	    listCacheHas = __webpack_require__(2138),
	    listCacheSet = __webpack_require__(2139);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(289);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(734),
	    createBaseEach = __webpack_require__(2111);
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(182);
	
	/**
	 * The base implementation of methods like `_.max` and `_.min` which accepts a
	 * `comparator` to determine the extremum value.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The iteratee invoked per iteration.
	 * @param {Function} comparator The comparator used to compare values.
	 * @returns {*} Returns the extremum value.
	 */
	function baseExtremum(array, iteratee, comparator) {
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    var value = array[index],
	        current = iteratee(value);
	
	    if (current != null && (computed === undefined
	          ? (current === current && !isSymbol(current))
	          : comparator(current, computed)
	        )) {
	      var computed = current,
	          result = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseExtremum;


/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(284),
	    toKey = __webpack_require__(224);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(43),
	    isKey = __webpack_require__(446),
	    stringToPath = __webpack_require__(2160),
	    toString = __webpack_require__(2184);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(2133);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(2056),
	    Map = __webpack_require__(433),
	    Promise = __webpack_require__(2058),
	    Set = __webpack_require__(725),
	    WeakMap = __webpack_require__(2059),
	    baseGetTag = __webpack_require__(125),
	    toSource = __webpack_require__(751);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(289),
	    isArrayLike = __webpack_require__(150),
	    isIndex = __webpack_require__(445),
	    isObject = __webpack_require__(72);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(149);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ },
/* 289 */
/***/ function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	var isNumber = __webpack_require__(291);
	
	/**
	 * Checks if `value` is `NaN`.
	 *
	 * **Note:** This method is based on
	 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	 * `undefined` and other non-number values.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 * @example
	 *
	 * _.isNaN(NaN);
	 * // => true
	 *
	 * _.isNaN(new Number(NaN));
	 * // => true
	 *
	 * isNaN(undefined);
	 * // => true
	 *
	 * _.isNaN(undefined);
	 * // => false
	 */
	function isNaN(value) {
	  // An `NaN` primitive is the only value that is not equal to itself.
	  // Perform the `toStringTag` check first to avoid errors with some
	  // ActiveX objects in IE.
	  return isNumber(value) && value != +value;
	}
	
	module.exports = isNaN;


/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(125),
	    isObjectLike = __webpack_require__(85);
	
	/** `Object#toString` result references. */
	var numberTag = '[object Number]';
	
	/**
	 * Checks if `value` is classified as a `Number` primitive or object.
	 *
	 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	 * classified as numbers, use the `_.isFinite` method.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	 * @example
	 *
	 * _.isNumber(3);
	 * // => true
	 *
	 * _.isNumber(Number.MIN_VALUE);
	 * // => true
	 *
	 * _.isNumber(Infinity);
	 * // => true
	 *
	 * _.isNumber('3');
	 * // => false
	 */
	function isNumber(value) {
	  return typeof value == 'number' ||
	    (isObjectLike(value) && baseGetTag(value) == numberTag);
	}
	
	module.exports = isNumber;


/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(125),
	    isArray = __webpack_require__(43),
	    isObjectLike = __webpack_require__(85);
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	}
	
	module.exports = isString;


/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.17.21';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function',
	      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;
	
	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;
	
	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading whitespace. */
	  var reTrimStart = /^\s+/;
	
	  /** Used to match a single whitespace character. */
	  var reWhitespace = /\s/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /**
	   * Used to validate the `validate` option in `_.template` variable.
	   *
	   * Forbids characters which could potentially change the meaning of the function argument definition:
	   * - "()," (modification of function parameters)
	   * - "=" (default value)
	   * - "[]{}" (destructuring of function parameters)
	   * - "/" (beginning of a comment)
	   * - whitespace
	   */
	  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
	      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      // Use `util.types` for Node.js 10+.
	      var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	      if (types) {
	        return types;
	      }
	
	      // Legacy `process.binding('util')` for Node.js < 10.
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.trim`.
	   *
	   * @private
	   * @param {string} string The string to trim.
	   * @returns {string} Returns the trimmed string.
	   */
	  function baseTrim(string) {
	    return string
	      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
	      : string;
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
	   * character of `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the index of the last non-whitespace character.
	   */
	  function trimmedEndIndex(string) {
	    var index = string.length;
	
	    while (index-- && reWhitespace.test(string.charAt(index))) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
	        symIterator = Symbol ? Symbol.iterator : undefined,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;
	
	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values == null ? 0 : values.length;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);
	
	      this.size = data.size;
	      return result;
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }
	
	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;
	
	      while (++index < length) {
	        result[index] = skip ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      if (isSet(value)) {
	        value.forEach(function(subValue) {
	          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	        });
	      } else if (isMap(value)) {
	        value.forEach(function(subValue, key) {
	          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	        });
	      }
	
	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);
	
	      var props = isArr ? undefined : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);
	
	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;
	
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        stack || (stack = new Stack);
	        if (isObject(srcValue)) {
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = safeGet(object, key),
	          srcValue = safeGet(source, key),
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || isFunction(objValue)) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      if (iteratees.length) {
	        iteratees = arrayMap(iteratees, function(iteratee) {
	          if (isArray(iteratee)) {
	            return function(value) {
	              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
	            }
	          }
	          return iteratee;
	        });
	      } else {
	        iteratees = [identity];
	      }
	
	      var index = -1;
	      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};
	
	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);
	
	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }
	
	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
	          return object;
	        }
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };
	
	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      var low = 0,
	          high = array == null ? 0 : array.length;
	      if (high === 0) {
	        return 0;
	      }
	
	      value = iteratee(value);
	      var valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      return object == null || delete object[toKey(last(path))];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);
	
	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;
	
	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }
	
	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision && nativeIsFinite(number)) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined : value;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Check that cyclic values are equal.
	      var arrStacked = stack.get(array);
	      var othStacked = stack.get(other);
	      if (arrStacked && othStacked) {
	        return arrStacked == other && othStacked == array;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Check that cyclic values are equal.
	      var objStacked = stack.get(object);
	      var othStacked = stack.get(other);
	      if (objStacked && othStacked) {
	        return objStacked == other && othStacked == object;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];
	
	      try {
	        value[symToStringTag] = undefined;
	        var unmasked = true;
	      } catch (e) {}
	
	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : '';
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          result = false;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return new Ctor;
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return new Ctor;
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      var type = typeof value;
	      length = length == null ? MAX_SAFE_INTEGER : length;
	
	      return !!length &&
	        (type == 'number' ||
	          (type != 'symbol' && reIsUint.test(value))) &&
	            (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });
	
	      var cache = result.cache;
	      return result;
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }
	
	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the property to get.
	     * @returns {*} Returns the property value.
	     */
	    function safeGet(object, key) {
	      if (key === 'constructor' && typeof object[key] === 'function') {
	        return;
	      }
	
	      if (key == '__proto__') {
	        return;
	      }
	
	      return object[key];
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }
	
	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;
	
	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }
	
	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;
	
	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];
	
	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (string.charCodeAt(0) === 46 /* . */) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, subString) {
	        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     *
	     * // Combining several predicates using `_.overEvery` or `_.overSome`.
	     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
	     * // => objects for ['fred', 'barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 30 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            timeWaiting = wait - timeSinceLastCall;
	
	        return maxing
	          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	          : timeWaiting;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            clearTimeout(timerId);
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Expose `MapCache`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = baseTrim(value);
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(object, sources) {
	      object = Object(object);
	
	      var index = -1;
	      var length = sources.length;
	      var guard = length > 2 ? sources[2] : undefined;
	
	      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	        length = 1;
	      }
	
	      while (++index < length) {
	        var source = sources[index];
	        var props = keysIn(source);
	        var propsIndex = -1;
	        var propsLength = props.length;
	
	        while (++propsIndex < propsLength) {
	          var key = props[propsIndex];
	          var value = object[key];
	
	          if (value === undefined ||
	              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	            object[key] = source[key];
	          }
	        }
	      }
	
	      return object;
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, customDefaultsMerge);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);
	
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, customDefaultsAssignIn);
	
	      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      // The sourceURL gets injected into the source that's eval-ed, so be careful
	      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
	      // and escape the comment, thus injecting code that gets evaled.
	      var sourceURL = '//# sourceURL=' +
	        (hasOwnProperty.call(options, 'sourceURL')
	          ? (options.sourceURL + '').replace(/\s/g, ' ')
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Throw an error if a forbidden character was found in `variable`, to prevent
	      // potential command injection attacks.
	      else if (reForbiddenIdentifierChars.test(variable)) {
	        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
	      }
	
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return baseTrim(string);
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.slice(0, trimmedEndIndex(string) + 1);
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * **Note:** Multiple values can be checked by combining several matchers
	     * using `_.overSome`
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     *
	     * // Checking for several possible values
	     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
	     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * **Note:** Multiple values can be checked by combining several matchers
	     * using `_.overSome`
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     *
	     * // Checking for several possible values
	     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
	     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * Following shorthands are possible for providing predicates.
	     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
	     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * Following shorthands are possible for providing predicates.
	     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
	     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     *
	     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
	     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();
	
	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = lodashFunc.name + '';
	        if (!hasOwnProperty.call(realNames, key)) {
	          realNames[key] = [];
	        }
	        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(192)(module)))

/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createChainableTypeChecker = __webpack_require__(910);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function validate(props, propName, componentName, location, propFullName) {
	  var propValue = props[propName];
	  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);
	
	  if (_react2.default.isValidElement(propValue)) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement. You can usually obtain a ReactComponent or DOMElement ' + 'from a ReactElement by attaching a ref to it.');
	  }
	
	  if ((propType !== 'object' || typeof propValue.render !== 'function') && propValue.nodeType !== 1) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement.');
	  }
	
	  return null;
	}
	
	exports.default = (0, _createChainableTypeChecker2.default)(validate);
	module.exports = exports['default'];

/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _activeElement = __webpack_require__(674);
	
	var _activeElement2 = _interopRequireDefault(_activeElement);
	
	var _contains = __webpack_require__(174);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _keycode = __webpack_require__(432);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _all = __webpack_require__(302);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _elementType = __webpack_require__(42);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _isRequiredForA11y = __webpack_require__(303);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _uncontrollable = __webpack_require__(318);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _warning = __webpack_require__(100);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ButtonGroup = __webpack_require__(913);
	
	var _ButtonGroup2 = _interopRequireDefault(_ButtonGroup);
	
	var _DropdownMenu = __webpack_require__(2214);
	
	var _DropdownMenu2 = _interopRequireDefault(_DropdownMenu);
	
	var _DropdownToggle = __webpack_require__(916);
	
	var _DropdownToggle2 = _interopRequireDefault(_DropdownToggle);
	
	var _bootstrapUtils = __webpack_require__(24);
	
	var _createChainedFunction = __webpack_require__(62);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _PropTypes = __webpack_require__(2261);
	
	var _ValidComponentChildren = __webpack_require__(74);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var TOGGLE_ROLE = _DropdownToggle2['default'].defaultProps.bsRole;
	var MENU_ROLE = _DropdownMenu2['default'].defaultProps.bsRole;
	
	var propTypes = {
	  /**
	   * The menu will open above the dropdown button, instead of below it.
	   */
	  dropup: _propTypes2['default'].bool,
	
	  /**
	   * An html id attribute, necessary for assistive technologies, such as screen readers.
	   * @type {string|number}
	   * @required
	   */
	  id: (0, _isRequiredForA11y2['default'])(_propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number])),
	
	  componentClass: _elementType2['default'],
	
	  /**
	   * The children of a Dropdown may be a `<Dropdown.Toggle>` or a `<Dropdown.Menu>`.
	   * @type {node}
	   */
	  children: (0, _all2['default'])((0, _PropTypes.requiredRoles)(TOGGLE_ROLE, MENU_ROLE), (0, _PropTypes.exclusiveRoles)(MENU_ROLE)),
	
	  /**
	   * Whether or not component is disabled.
	   */
	  disabled: _propTypes2['default'].bool,
	
	  /**
	   * Align the menu to the right side of the Dropdown toggle
	   */
	  pullRight: _propTypes2['default'].bool,
	
	  /**
	   * Whether or not the Dropdown is visible.
	   *
	   * @controllable onToggle
	   */
	  open: _propTypes2['default'].bool,
	
	  /**
	   * A callback fired when the Dropdown wishes to change visibility. Called with the requested
	   * `open` value, the DOM event, and the source that fired it: `'click'`,`'keydown'`,`'rootClose'`, or `'select'`.
	   *
	   * ```js
	   * function(Boolean isOpen, Object event, { String source }) {}
	   * ```
	   * @controllable open
	   */
	  onToggle: _propTypes2['default'].func,
	
	  /**
	   * A callback fired when a menu item is selected.
	   *
	   * ```js
	   * (eventKey: any, event: Object) => any
	   * ```
	   */
	  onSelect: _propTypes2['default'].func,
	
	  /**
	   * If `'menuitem'`, causes the dropdown to behave like a menu item rather than
	   * a menu button.
	   */
	  role: _propTypes2['default'].string,
	
	  /**
	   * Which event when fired outside the component will cause it to be closed
	   */
	  rootCloseEvent: _propTypes2['default'].oneOf(['click', 'mousedown']),
	
	  /**
	   * @private
	   */
	  onMouseEnter: _propTypes2['default'].func,
	  /**
	   * @private
	   */
	  onMouseLeave: _propTypes2['default'].func
	};
	
	var defaultProps = {
	  componentClass: _ButtonGroup2['default']
	};
	
	var Dropdown = function (_React$Component) {
	  (0, _inherits3['default'])(Dropdown, _React$Component);
	
	  function Dropdown(props, context) {
	    (0, _classCallCheck3['default'])(this, Dropdown);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
	    _this.handleClose = _this.handleClose.bind(_this);
	
	    _this._focusInDropdown = false;
	    _this.lastOpenEventType = null;
	    return _this;
	  }
	
	  Dropdown.prototype.componentDidMount = function componentDidMount() {
	    this.focusNextOnOpen();
	  };
	
	  Dropdown.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
	    if (!nextProps.open && this.props.open) {
	      this._focusInDropdown = (0, _contains2['default'])(_reactDom2['default'].findDOMNode(this.menu), (0, _activeElement2['default'])(document));
	    }
	  };
	
	  Dropdown.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var open = this.props.open;
	
	    var prevOpen = prevProps.open;
	
	    if (open && !prevOpen) {
	      this.focusNextOnOpen();
	    }
	
	    if (!open && prevOpen) {
	      // if focus hasn't already moved from the menu lets return it
	      // to the toggle
	      if (this._focusInDropdown) {
	        this._focusInDropdown = false;
	        this.focus();
	      }
	    }
	  };
	
	  Dropdown.prototype.handleClick = function handleClick(event) {
	    if (this.props.disabled) {
	      return;
	    }
	
	    this.toggleOpen(event, { source: 'click' });
	  };
	
	  Dropdown.prototype.handleKeyDown = function handleKeyDown(event) {
	    if (this.props.disabled) {
	      return;
	    }
	
	    switch (event.keyCode) {
	      case _keycode2['default'].codes.down:
	        if (!this.props.open) {
	          this.toggleOpen(event, { source: 'keydown' });
	        } else if (this.menu.focusNext) {
	          this.menu.focusNext();
	        }
	        event.preventDefault();
	        break;
	      case _keycode2['default'].codes.esc:
	      case _keycode2['default'].codes.tab:
	        this.handleClose(event, { source: 'keydown' });
	        break;
	      default:
	    }
	  };
	
	  Dropdown.prototype.toggleOpen = function toggleOpen(event, eventDetails) {
	    var open = !this.props.open;
	
	    if (open) {
	      this.lastOpenEventType = eventDetails.source;
	    }
	
	    if (this.props.onToggle) {
	      this.props.onToggle(open, event, eventDetails);
	    }
	  };
	
	  Dropdown.prototype.handleClose = function handleClose(event, eventDetails) {
	    if (!this.props.open) {
	      return;
	    }
	
	    this.toggleOpen(event, eventDetails);
	  };
	
	  Dropdown.prototype.focusNextOnOpen = function focusNextOnOpen() {
	    var menu = this.menu;
	
	    if (!menu.focusNext) {
	      return;
	    }
	
	    if (this.lastOpenEventType === 'keydown' || this.props.role === 'menuitem') {
	      menu.focusNext();
	    }
	  };
	
	  Dropdown.prototype.focus = function focus() {
	    var toggle = _reactDom2['default'].findDOMNode(this.toggle);
	
	    if (toggle && toggle.focus) {
	      toggle.focus();
	    }
	  };
	
	  Dropdown.prototype.renderToggle = function renderToggle(child, props) {
	    var _this2 = this;
	
	    var ref = function ref(c) {
	      _this2.toggle = c;
	    };
	
	    if (typeof child.ref === 'string') {
	       false ? (0, _warning2['default'])(false, 'String refs are not supported on `<Dropdown.Toggle>` components. ' + 'To apply a ref to the component use the callback signature:\n\n ' + 'https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute') : void 0;
	    } else {
	      ref = (0, _createChainedFunction2['default'])(child.ref, ref);
	    }
	
	    return (0, _react.cloneElement)(child, (0, _extends3['default'])({}, props, {
	      ref: ref,
	      bsClass: (0, _bootstrapUtils.prefix)(props, 'toggle'),
	      onClick: (0, _createChainedFunction2['default'])(child.props.onClick, this.handleClick),
	      onKeyDown: (0, _createChainedFunction2['default'])(child.props.onKeyDown, this.handleKeyDown)
	    }));
	  };
	
	  Dropdown.prototype.renderMenu = function renderMenu(child, _ref) {
	    var _this3 = this;
	
	    var id = _ref.id,
	        onSelect = _ref.onSelect,
	        rootCloseEvent = _ref.rootCloseEvent,
	        props = (0, _objectWithoutProperties3['default'])(_ref, ['id', 'onSelect', 'rootCloseEvent']);
	
	    var ref = function ref(c) {
	      _this3.menu = c;
	    };
	
	    if (typeof child.ref === 'string') {
	       false ? (0, _warning2['default'])(false, 'String refs are not supported on `<Dropdown.Menu>` components. ' + 'To apply a ref to the component use the callback signature:\n\n ' + 'https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute') : void 0;
	    } else {
	      ref = (0, _createChainedFunction2['default'])(child.ref, ref);
	    }
	
	    return (0, _react.cloneElement)(child, (0, _extends3['default'])({}, props, {
	      ref: ref,
	      labelledBy: id,
	      bsClass: (0, _bootstrapUtils.prefix)(props, 'menu'),
	      onClose: (0, _createChainedFunction2['default'])(child.props.onClose, this.handleClose),
	      onSelect: (0, _createChainedFunction2['default'])(child.props.onSelect, onSelect, function (key, event) {
	        return _this3.handleClose(event, { source: 'select' });
	      }),
	      rootCloseEvent: rootCloseEvent
	    }));
	  };
	
	  Dropdown.prototype.render = function render() {
	    var _classes,
	        _this4 = this;
	
	    var _props = this.props,
	        Component = _props.componentClass,
	        id = _props.id,
	        dropup = _props.dropup,
	        disabled = _props.disabled,
	        pullRight = _props.pullRight,
	        open = _props.open,
	        onSelect = _props.onSelect,
	        role = _props.role,
	        bsClass = _props.bsClass,
	        className = _props.className,
	        rootCloseEvent = _props.rootCloseEvent,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'id', 'dropup', 'disabled', 'pullRight', 'open', 'onSelect', 'role', 'bsClass', 'className', 'rootCloseEvent', 'children']);
	
	
	    delete props.onToggle;
	
	    var classes = (_classes = {}, _classes[bsClass] = true, _classes.open = open, _classes.disabled = disabled, _classes);
	
	    if (dropup) {
	      classes[bsClass] = false;
	      classes.dropup = true;
	    }
	
	    // This intentionally forwards bsSize and bsStyle (if set) to the
	    // underlying component, to allow it to render size and style variants.
	
	    return _react2['default'].createElement(
	      Component,
	      (0, _extends3['default'])({}, props, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      _ValidComponentChildren2['default'].map(children, function (child) {
	        switch (child.props.bsRole) {
	          case TOGGLE_ROLE:
	            return _this4.renderToggle(child, {
	              id: id, disabled: disabled, open: open, role: role, bsClass: bsClass
	            });
	          case MENU_ROLE:
	            return _this4.renderMenu(child, {
	              id: id, open: open, pullRight: pullRight, bsClass: bsClass, onSelect: onSelect, rootCloseEvent: rootCloseEvent
	            });
	          default:
	            return child;
	        }
	      })
	    );
	  };
	
	  return Dropdown;
	}(_react2['default'].Component);
	
	Dropdown.propTypes = propTypes;
	Dropdown.defaultProps = defaultProps;
	
	(0, _bootstrapUtils.bsClass)('dropdown', Dropdown);
	
	var UncontrolledDropdown = (0, _uncontrollable2['default'])(Dropdown, { open: 'onToggle' });
	
	UncontrolledDropdown.Toggle = _DropdownToggle2['default'];
	UncontrolledDropdown.Menu = _DropdownMenu2['default'];
	
	exports['default'] = UncontrolledDropdown;
	module.exports = exports['default'];

/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Transition = __webpack_require__(943);
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Show the component; triggers the fade in or fade out animation
	   */
	  'in': _propTypes2['default'].bool,
	
	  /**
	   * Wait until the first "enter" transition to mount the component (add it to the DOM)
	   */
	  mountOnEnter: _propTypes2['default'].bool,
	
	  /**
	   * Unmount the component (remove it from the DOM) when it is faded out
	   */
	  unmountOnExit: _propTypes2['default'].bool,
	
	  /**
	   * Run the fade in animation when the component mounts, if it is initially
	   * shown
	   */
	  transitionAppear: _propTypes2['default'].bool,
	
	  /**
	   * Duration of the fade animation in milliseconds, to ensure that finishing
	   * callbacks are fired even if the original browser transition end events are
	   * canceled
	   */
	  timeout: _propTypes2['default'].number,
	
	  /**
	   * Callback fired before the component fades in
	   */
	  onEnter: _propTypes2['default'].func,
	  /**
	   * Callback fired after the component starts to fade in
	   */
	  onEntering: _propTypes2['default'].func,
	  /**
	   * Callback fired after the has component faded in
	   */
	  onEntered: _propTypes2['default'].func,
	  /**
	   * Callback fired before the component fades out
	   */
	  onExit: _propTypes2['default'].func,
	  /**
	   * Callback fired after the component starts to fade out
	   */
	  onExiting: _propTypes2['default'].func,
	  /**
	   * Callback fired after the component has faded out
	   */
	  onExited: _propTypes2['default'].func
	};
	
	var defaultProps = {
	  'in': false,
	  timeout: 300,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  transitionAppear: false
	};
	
	var Fade = function (_React$Component) {
	  (0, _inherits3['default'])(Fade, _React$Component);
	
	  function Fade() {
	    (0, _classCallCheck3['default'])(this, Fade);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Fade.prototype.render = function render() {
	    return _react2['default'].createElement(_Transition2['default'], (0, _extends3['default'])({}, this.props, {
	      className: (0, _classnames2['default'])(this.props.className, 'fade'),
	      enteredClassName: 'in',
	      enteringClassName: 'in'
	    }));
	  };
	
	  return Fade;
	}(_react2['default'].Component);
	
	Fade.propTypes = propTypes;
	Fade.defaultProps = defaultProps;
	
	exports['default'] = Fade;
	module.exports = exports['default'];

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _entries = __webpack_require__(517);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	exports["default"] = splitComponentProps;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function splitComponentProps(props, Component) {
	  var componentPropTypes = Component.propTypes;
	
	  var parentProps = {};
	  var childProps = {};
	
	  (0, _entries2["default"])(props).forEach(function (_ref) {
	    var propName = _ref[0],
	        propValue = _ref[1];
	
	    if (componentPropTypes[propName]) {
	      parentProps[propName] = propValue;
	    } else {
	      childProps[propName] = propValue;
	    }
	  });
	
	  return [parentProps, childProps];
	}
	module.exports = exports["default"];

/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _require = __webpack_require__(2272),
	    Draggable = _require.default,
	    DraggableCore = _require.DraggableCore; // Previous versions of this lib exported <Draggable> as the root export. As to no-// them, or TypeScript, we export *both* as the root and as 'default'.
	// See https://github.com/mzabriskie/react-draggable/pull/254
	// and https://github.com/mzabriskie/react-draggable/issues/266
	
	
	module.exports = Draggable;
	module.exports.default = Draggable;
	module.exports.DraggableCore = DraggableCore;

/***/ },
/* 299 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.dontSetMe = dontSetMe;
	exports.findInArray = findInArray;
	exports.int = int;
	exports.isFunction = isFunction;
	exports.isNum = isNum;
	
	// @credits https://gist.github.com/rogozhnikoff/a43cfed27c41e4e68cdc
	function findInArray(array
	/*: Array<any> | TouchList*/
	, callback
	/*: Function*/
	)
	/*: any*/
	{
	  for (var i = 0, length = array.length; i < length; i++) {
	    if (callback.apply(callback, [array[i], i, array])) return array[i];
	  }
	}
	
	function isFunction(func
	/*: any*/
	)
	/*: boolean %checks*/
	{
	  // $FlowIgnore[method-unbinding]
	  return typeof func === 'function' || Object.prototype.toString.call(func) === '[object Function]';
	}
	
	function isNum(num
	/*: any*/
	)
	/*: boolean %checks*/
	{
	  return typeof num === 'number' && !isNaN(num);
	}
	
	function int(a
	/*: string*/
	)
	/*: number*/
	{
	  return parseInt(a, 10);
	}
	
	function dontSetMe(props
	/*: Object*/
	, propName
	/*: string*/
	, componentName
	/*: string*/
	)
	/*: ?Error*/
	{
	  if (props[propName]) {
	    return new Error("Invalid prop ".concat(propName, " passed to ").concat(componentName, " - do not set this, set it on the child."));
	  }
	}

/***/ },
/* 300 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.warn = warn;
	exports.warnOnce = warnOnce;
	exports.loadNamespaces = loadNamespaces;
	exports.hasLoadedNamespace = hasLoadedNamespace;
	exports.getDisplayName = getDisplayName;
	
	function warn() {
	  if (console && console.warn) {
	    var _console;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    if (typeof args[0] === 'string') args[0] = "react-i18next:: ".concat(args[0]);
	
	    (_console = console).warn.apply(_console, args);
	  }
	}
	
	var alreadyWarned = {};
	
	function warnOnce() {
	  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	
	  if (typeof args[0] === 'string' && alreadyWarned[args[0]]) return;
	  if (typeof args[0] === 'string') alreadyWarned[args[0]] = new Date();
	  warn.apply(void 0, args);
	}
	
	function loadNamespaces(i18n, ns, cb) {
	  i18n.loadNamespaces(ns, function () {
	    if (i18n.isInitialized) {
	      cb();
	    } else {
	      var initialized = function initialized() {
	        setTimeout(function () {
	          i18n.off('initialized', initialized);
	        }, 0);
	        cb();
	      };
	
	      i18n.on('initialized', initialized);
	    }
	  });
	}
	
	function hasLoadedNamespace(ns, i18n) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  if (!i18n.languages || !i18n.languages.length) {
	    warnOnce('i18n.languages were undefined or empty', i18n.languages);
	    return true;
	  }
	
	  var lng = i18n.languages[0];
	  var fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
	  var lastLng = i18n.languages[i18n.languages.length - 1];
	  if (lng.toLowerCase() === 'cimode') return true;
	
	  var loadNotPending = function loadNotPending(l, n) {
	    var loadState = i18n.services.backendConnector.state["".concat(l, "|").concat(n)];
	    return loadState === -1 || loadState === 2;
	  };
	
	  if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
	  if (i18n.hasResourceBundle(lng, ns)) return true;
	  if (!i18n.services.backendConnector.backend) return true;
	  if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
	  return false;
	}
	
	function getDisplayName(Component) {
	  return Component.displayName || Component.name || (typeof Component === 'string' && Component.length > 0 ? Component : 'Unknown');
	}

/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getContainer;
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getContainer(container, defaultContainer) {
	  container = typeof container === 'function' ? container() : container;
	  return _reactDom2.default.findDOMNode(container) || defaultContainer;
	}
	module.exports = exports['default'];

/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = all;
	
	var _createChainableTypeChecker = __webpack_require__(467);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function all() {
	  for (var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++) {
	    validators[_key] = arguments[_key];
	  }
	
	  function allPropTypes() {
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    var error = null;
	
	    validators.forEach(function (validator) {
	      if (error != null) {
	        return;
	      }
	
	      var result = validator.apply(undefined, args);
	      if (result != null) {
	        error = result;
	      }
	    });
	
	    return error;
	  }
	
	  return (0, _createChainableTypeChecker2.default)(allPropTypes);
	}

/***/ },
/* 303 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = isRequiredForA11y;
	function isRequiredForA11y(validator) {
	  return function validate(props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] == null) {
	      return new Error('The ' + location + ' `' + propFullNameSafe + '` is required to make ' + ('`' + componentNameSafe + '` accessible for users of assistive ') + 'technologies such as screen readers.');
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
	      args[_key - 5] = arguments[_key];
	    }
	
	    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	  };
	}

/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.warn = exports.getTransitionVal = exports.compose = exports.translateStyle = exports.mapObject = exports.debugf = exports.debug = exports.log = exports.generatePrefixStyle = exports.getDashCase = exports.identity = exports.getIntersectionKeys = void 0;
	
	var _intersection2 = _interopRequireDefault(__webpack_require__(2169));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/* eslint no-console: 0 */
	var PREFIX_LIST = ['Webkit', 'Moz', 'O', 'ms'];
	var IN_LINE_PREFIX_LIST = ['-webkit-', '-moz-', '-o-', '-ms-'];
	var IN_COMPATIBLE_PROPERTY = ['transform', 'transformOrigin', 'transition'];
	
	var getIntersectionKeys = function getIntersectionKeys(preObj, nextObj) {
	  return (0, _intersection2.default)(Object.keys(preObj), Object.keys(nextObj));
	};
	
	exports.getIntersectionKeys = getIntersectionKeys;
	
	var identity = function identity(param) {
	  return param;
	};
	/*
	 * @description: convert camel case to dash case
	 * string => string
	 */
	
	
	exports.identity = identity;
	
	var getDashCase = function getDashCase(name) {
	  return name.replace(/([A-Z])/g, function (v) {
	    return "-".concat(v.toLowerCase());
	  });
	};
	/*
	 * @description: add compatible style prefix
	 * (string, string) => object
	 */
	
	
	exports.getDashCase = getDashCase;
	
	var generatePrefixStyle = function generatePrefixStyle(name, value) {
	  if (IN_COMPATIBLE_PROPERTY.indexOf(name) === -1) {
	    return _defineProperty({}, name, value);
	  }
	
	  var isTransition = name === 'transition';
	  var camelName = name.replace(/(\w)/, function (v) {
	    return v.toUpperCase();
	  });
	  var styleVal = value;
	  return PREFIX_LIST.reduce(function (result, property, i) {
	    if (isTransition) {
	      styleVal = value.replace(/(transform|transform-origin)/gim, "".concat(IN_LINE_PREFIX_LIST[i], "$1"));
	    }
	
	    return _objectSpread({}, result, _defineProperty({}, property + camelName, styleVal));
	  }, {});
	};
	
	exports.generatePrefixStyle = generatePrefixStyle;
	
	var log = function log() {
	  var _console;
	
	  (_console = console).log.apply(_console, arguments);
	};
	/*
	 * @description: log the value of a varible
	 * string => any => any
	 */
	
	
	exports.log = log;
	
	var debug = function debug(name) {
	  return function (item) {
	    log(name, item);
	    return item;
	  };
	};
	/*
	 * @description: log name, args, return value of a function
	 * function => function
	 */
	
	
	exports.debug = debug;
	
	var debugf = function debugf(tag, f) {
	  return function () {
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var res = f.apply(void 0, args);
	    var name = tag || f.name || 'anonymous function';
	    var argNames = "(".concat(args.map(JSON.stringify).join(', '), ")");
	    log("".concat(name, ": ").concat(argNames, " => ").concat(JSON.stringify(res)));
	    return res;
	  };
	};
	/*
	 * @description: map object on every element in this object.
	 * (function, object) => object
	 */
	
	
	exports.debugf = debugf;
	
	var mapObject = function mapObject(fn, obj) {
	  return Object.keys(obj).reduce(function (res, key) {
	    return _objectSpread({}, res, _defineProperty({}, key, fn(key, obj[key])));
	  }, {});
	};
	/*
	 * @description: add compatible prefix to style
	 * object => object
	 */
	
	
	exports.mapObject = mapObject;
	
	var translateStyle = function translateStyle(style) {
	  return Object.keys(style).reduce(function (res, key) {
	    return _objectSpread({}, res, generatePrefixStyle(key, res[key]));
	  }, style);
	};
	
	exports.translateStyle = translateStyle;
	
	var compose = function compose() {
	  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	
	  if (!args.length) {
	    return identity;
	  }
	
	  var fns = args.reverse(); // first function can receive multiply arguments
	
	  var firstFn = fns[0];
	  var tailsFn = fns.slice(1);
	  return function () {
	    return tailsFn.reduce(function (res, fn) {
	      return fn(res);
	    }, firstFn.apply(void 0, arguments));
	  };
	};
	
	exports.compose = compose;
	
	var getTransitionVal = function getTransitionVal(props, duration, easing) {
	  return props.map(function (prop) {
	    return "".concat(getDashCase(prop), " ").concat(duration, "ms ").concat(easing);
	  }).join(',');
	};
	
	exports.getTransitionVal = getTransitionVal;
	var isDev = ("production") !== 'production';
	
	var warn = function warn(condition, format, a, b, c, d, e, f) {
	  if (isDev && typeof console !== 'undefined' && console.warn) {
	    if (format === undefined) {
	      console.warn('LogUtils requires an error message argument');
	    }
	
	    if (!condition) {
	      if (format === undefined) {
	        console.warn('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	      } else {
	        var args = [a, b, c, d, e, f];
	        var argIndex = 0;
	        console.warn(format.replace(/%s/g, function () {
	          return args[argIndex++];
	        }));
	      }
	    }
	  }
	};
	
	exports.warn = warn;

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(20));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _reactPopper = __webpack_require__(75);
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _DropdownContext = __webpack_require__(228);
	
	var _utils = __webpack_require__(14);
	
	var _excluded = ["className", "cssModule", "direction", "isOpen", "group", "size", "nav", "setActiveFromChild", "active", "addonType", "tag", "menuRole"];
	var propTypes = {
	  a11y: _propTypes.default.bool,
	  disabled: _propTypes.default.bool,
	  direction: _propTypes.default.oneOf(['up', 'down', 'left', 'right']),
	  group: _propTypes.default.bool,
	  isOpen: _propTypes.default.bool,
	  nav: _propTypes.default.bool,
	  active: _propTypes.default.bool,
	  addonType: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.oneOf(['prepend', 'append'])]),
	  size: _propTypes.default.string,
	  tag: _utils.tagPropType,
	  toggle: _propTypes.default.func,
	  children: _propTypes.default.node,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  inNavbar: _propTypes.default.bool,
	  setActiveFromChild: _propTypes.default.bool,
	  menuRole: _propTypes.default.oneOf(['listbox', 'menu'])
	};
	var defaultProps = {
	  a11y: true,
	  isOpen: false,
	  direction: 'down',
	  nav: false,
	  active: false,
	  addonType: false,
	  inNavbar: false,
	  setActiveFromChild: false
	};
	var preventDefaultKeys = [_utils.keyCodes.space, _utils.keyCodes.enter, _utils.keyCodes.up, _utils.keyCodes.down, _utils.keyCodes.end, _utils.keyCodes.home];
	
	var Dropdown = /*#__PURE__*/function (_React$Component) {
	  (0, _inheritsLoose2.default)(Dropdown, _React$Component);
	
	  function Dropdown(props) {
	    var _this;
	
	    _this = _React$Component.call(this, props) || this;
	    _this.addEvents = _this.addEvents.bind((0, _assertThisInitialized2.default)(_this));
	    _this.handleDocumentClick = _this.handleDocumentClick.bind((0, _assertThisInitialized2.default)(_this));
	    _this.handleKeyDown = _this.handleKeyDown.bind((0, _assertThisInitialized2.default)(_this));
	    _this.removeEvents = _this.removeEvents.bind((0, _assertThisInitialized2.default)(_this));
	    _this.toggle = _this.toggle.bind((0, _assertThisInitialized2.default)(_this));
	    _this.handleMenuRef = _this.handleMenuRef.bind((0, _assertThisInitialized2.default)(_this));
	    _this.containerRef = /*#__PURE__*/_react.default.createRef();
	    _this.menuRef = /*#__PURE__*/_react.default.createRef();
	    return _this;
	  }
	
	  var _proto = Dropdown.prototype;
	
	  _proto.handleMenuRef = function handleMenuRef(menuRef) {
	    this.menuRef.current = menuRef;
	  };
	
	  _proto.getContextValue = function getContextValue() {
	    return {
	      toggle: this.toggle,
	      isOpen: this.props.isOpen,
	      direction: this.props.direction === 'down' && this.props.dropup ? 'up' : this.props.direction,
	      inNavbar: this.props.inNavbar,
	      disabled: this.props.disabled,
	      // Callback that should be called by DropdownMenu to provide a ref to
	      // a HTML tag that's used for the DropdownMenu
	      onMenuRef: this.handleMenuRef,
	      menuRole: this.props.menuRole
	    };
	  };
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.handleProps();
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (this.props.isOpen !== prevProps.isOpen) {
	      this.handleProps();
	    }
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.removeEvents();
	  };
	
	  _proto.getContainer = function getContainer() {
	    return this.containerRef.current;
	  };
	
	  _proto.getMenu = function getMenu() {
	    return this.menuRef.current;
	  };
	
	  _proto.getMenuCtrl = function getMenuCtrl() {
	    if (this._$menuCtrl) return this._$menuCtrl;
	    this._$menuCtrl = this.getContainer().querySelector('[aria-expanded]');
	    return this._$menuCtrl;
	  };
	
	  _proto.getItemType = function getItemType() {
	    if (this.context.menuRole === 'listbox') {
	      return 'option';
	    }
	
	    return 'menuitem';
	  };
	
	  _proto.getMenuItems = function getMenuItems() {
	    // In a real menu with a child DropdownMenu, `this.getMenu()` should never
	    // be null, but it is sometimes null in tests. To mitigate that, we just
	    // use `this.getContainer()` as the fallback `menuContainer`.
	    var menuContainer = this.getMenu() || this.getContainer();
	    return [].slice.call(menuContainer.querySelectorAll("[role=\"" + this.getItemType() + "\"]"));
	  };
	
	  _proto.addEvents = function addEvents() {
	    var _this2 = this;
	
	    ['click', 'touchstart', 'keyup'].forEach(function (event) {
	      return document.addEventListener(event, _this2.handleDocumentClick, true);
	    });
	  };
	
	  _proto.removeEvents = function removeEvents() {
	    var _this3 = this;
	
	    ['click', 'touchstart', 'keyup'].forEach(function (event) {
	      return document.removeEventListener(event, _this3.handleDocumentClick, true);
	    });
	  };
	
	  _proto.handleDocumentClick = function handleDocumentClick(e) {
	    if (e && (e.which === 3 || e.type === 'keyup' && e.which !== _utils.keyCodes.tab)) return;
	    var container = this.getContainer();
	    var menu = this.getMenu();
	    var clickIsInContainer = container.contains(e.target) && container !== e.target;
	    var clickIsInMenu = menu && menu.contains(e.target) && menu !== e.target;
	
	    if ((clickIsInContainer || clickIsInMenu) && (e.type !== 'keyup' || e.which === _utils.keyCodes.tab)) {
	      return;
	    }
	
	    this.toggle(e);
	  };
	
	  _proto.handleKeyDown = function handleKeyDown(e) {
	    var _this4 = this;
	
	    var isTargetMenuItem = e.target.getAttribute('role') === 'menuitem' || e.target.getAttribute('role') === 'option';
	    var isTargetMenuCtrl = this.getMenuCtrl() === e.target;
	    var isTab = _utils.keyCodes.tab === e.which;
	
	    if (/input|textarea/i.test(e.target.tagName) || isTab && !this.props.a11y || isTab && !(isTargetMenuItem || isTargetMenuCtrl)) {
	      return;
	    }
	
	    if (preventDefaultKeys.indexOf(e.which) !== -1 || e.which >= 48 && e.which <= 90) {
	      e.preventDefault();
	    }
	
	    if (this.props.disabled) return;
	
	    if (isTargetMenuCtrl) {
	      if ([_utils.keyCodes.space, _utils.keyCodes.enter, _utils.keyCodes.up, _utils.keyCodes.down].indexOf(e.which) > -1) {
	        // Open the menu (if not open) and focus the first menu item
	        if (!this.props.isOpen) {
	          this.toggle(e);
	        }
	
	        setTimeout(function () {
	          return _this4.getMenuItems()[0].focus();
	        });
	      } else if (this.props.isOpen && isTab) {
	        // Focus the first menu item if tabbing from an open menu. We need this
	        // for cases where the DropdownMenu sets a custom container, which may
	        // not be the natural next item to tab to from the DropdownToggle.
	        e.preventDefault();
	        this.getMenuItems()[0].focus();
	      } else if (this.props.isOpen && e.which === _utils.keyCodes.esc) {
	        this.toggle(e);
	      }
	    }
	
	    if (this.props.isOpen && isTargetMenuItem) {
	      if ([_utils.keyCodes.tab, _utils.keyCodes.esc].indexOf(e.which) > -1) {
	        this.toggle(e);
	        this.getMenuCtrl().focus();
	      } else if ([_utils.keyCodes.space, _utils.keyCodes.enter].indexOf(e.which) > -1) {
	        e.target.click();
	        this.getMenuCtrl().focus();
	      } else if ([_utils.keyCodes.down, _utils.keyCodes.up].indexOf(e.which) > -1 || [_utils.keyCodes.n, _utils.keyCodes.p].indexOf(e.which) > -1 && e.ctrlKey) {
	        var $menuitems = this.getMenuItems();
	        var index = $menuitems.indexOf(e.target);
	
	        if (_utils.keyCodes.up === e.which || _utils.keyCodes.p === e.which && e.ctrlKey) {
	          index = index !== 0 ? index - 1 : $menuitems.length - 1;
	        } else if (_utils.keyCodes.down === e.which || _utils.keyCodes.n === e.which && e.ctrlKey) {
	          index = index === $menuitems.length - 1 ? 0 : index + 1;
	        }
	
	        $menuitems[index].focus();
	      } else if (_utils.keyCodes.end === e.which) {
	        var _$menuitems = this.getMenuItems();
	
	        _$menuitems[_$menuitems.length - 1].focus();
	      } else if (_utils.keyCodes.home === e.which) {
	        var _$menuitems2 = this.getMenuItems();
	
	        _$menuitems2[0].focus();
	      } else if (e.which >= 48 && e.which <= 90) {
	        var _$menuitems3 = this.getMenuItems();
	
	        var charPressed = String.fromCharCode(e.which).toLowerCase();
	
	        for (var i = 0; i < _$menuitems3.length; i += 1) {
	          var firstLetter = _$menuitems3[i].textContent && _$menuitems3[i].textContent[0].toLowerCase();
	
	          if (firstLetter === charPressed) {
	            _$menuitems3[i].focus();
	
	            break;
	          }
	        }
	      }
	    }
	  };
	
	  _proto.handleProps = function handleProps() {
	    if (this.props.isOpen) {
	      this.addEvents();
	    } else {
	      this.removeEvents();
	    }
	  };
	
	  _proto.toggle = function toggle(e) {
	    if (this.props.disabled) {
	      return e && e.preventDefault();
	    }
	
	    return this.props.toggle(e);
	  };
	
	  _proto.render = function render() {
	    var _classNames, _ref;
	
	    var _omit = (0, _utils.omit)(this.props, ['toggle', 'disabled', 'inNavbar', 'a11y']),
	        className = _omit.className,
	        cssModule = _omit.cssModule,
	        direction = _omit.direction,
	        isOpen = _omit.isOpen,
	        group = _omit.group,
	        size = _omit.size,
	        nav = _omit.nav,
	        setActiveFromChild = _omit.setActiveFromChild,
	        active = _omit.active,
	        addonType = _omit.addonType,
	        tag = _omit.tag,
	        menuRole = _omit.menuRole,
	        attrs = (0, _objectWithoutPropertiesLoose2.default)(_omit, _excluded);
	
	    var Tag = tag || (nav ? 'li' : 'div');
	    var subItemIsActive = false;
	
	    if (setActiveFromChild) {
	      _react.default.Children.map(this.props.children[1].props.children, function (dropdownItem) {
	        if (dropdownItem && dropdownItem.props.active) subItemIsActive = true;
	      });
	    }
	
	    var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, direction !== 'down' && "drop" + direction, nav && active ? 'active' : false, setActiveFromChild && subItemIsActive ? 'active' : false, (_classNames = {}, _classNames["input-group-" + addonType] = addonType, _classNames['btn-group'] = group, _classNames["btn-group-" + size] = !!size, _classNames.dropdown = !group && !addonType, _classNames.show = isOpen, _classNames['nav-item'] = nav, _classNames)), cssModule);
	    return /*#__PURE__*/_react.default.createElement(_DropdownContext.DropdownContext.Provider, {
	      value: this.getContextValue()
	    }, /*#__PURE__*/_react.default.createElement(_reactPopper.Manager, null, /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attrs, (_ref = {}, _ref[typeof Tag === 'string' ? 'ref' : 'innerRef'] = this.containerRef, _ref), {
	      onKeyDown: this.handleKeyDown,
	      className: classes
	    }))));
	  };
	
	  return Dropdown;
	}(_react.default.Component);
	
	Dropdown.propTypes = propTypes;
	Dropdown.defaultProps = defaultProps;
	var _default = Dropdown;
	exports.default = _default;

/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = __webpack_require__(1);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var ZAxis =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(ZAxis, _PureComponent);
	
	  function ZAxis() {
	    _classCallCheck(this, ZAxis);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(ZAxis).apply(this, arguments));
	  }
	
	  _createClass(ZAxis, [{
	    key: "render",
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return ZAxis;
	}(_react.PureComponent);
	
	ZAxis.displayName = 'ZAxis';
	ZAxis.propTypes = {
	  type: _propTypes["default"].oneOf(['number', 'category']),
	  // The name of data displayed in the axis
	  name: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  // The unit of data displayed in the axis
	  unit: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  // The unique id of z-axis
	  zAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  // The key of data displayed in the axis
	  dataKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func]),
	  // The range of axis
	  range: _propTypes["default"].arrayOf(_propTypes["default"].number),
	  scale: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(['auto', 'linear', 'pow', 'sqrt', 'log', 'identity', 'time', 'band', 'point', 'ordinal', 'quantile', 'quantize', 'utc', 'sequential', 'threshold']), _propTypes["default"].func])
	};
	ZAxis.defaultProps = {
	  zAxisId: 0,
	  range: [64, 64],
	  scale: 'auto',
	  type: 'number'
	};
	var _default = ZAxis;
	exports["default"] = _default;

/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(71));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(38));
	
	var _uniqBy2 = _interopRequireDefault(__webpack_require__(764));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _reactSmooth = __webpack_require__(81);
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _DefaultTooltipContent = _interopRequireDefault(__webpack_require__(2428));
	
	var _ReactUtils = __webpack_require__(29);
	
	var _DataUtils = __webpack_require__(39);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var CLS_PREFIX = 'recharts-tooltip-wrapper';
	var EPS = 1;
	
	var defaultUniqBy = function defaultUniqBy(entry) {
	  return entry.dataKey;
	};
	
	var getUniqPaylod = function getUniqPaylod(option, payload) {
	  if (option === true) {
	    return (0, _uniqBy2["default"])(payload, defaultUniqBy);
	  }
	
	  if ((0, _isFunction2["default"])(option)) {
	    return (0, _uniqBy2["default"])(payload, option);
	  }
	
	  return payload;
	};
	
	var propTypes = {
	  allowEscapeViewBox: _propTypes["default"].shape({
	    x: _propTypes["default"]["boolean"],
	    y: _propTypes["default"]["boolean"]
	  }),
	  content: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].func]),
	  viewBox: _propTypes["default"].shape({
	    x: _propTypes["default"].number,
	    y: _propTypes["default"].number,
	    width: _propTypes["default"].number,
	    height: _propTypes["default"].number
	  }),
	  active: _propTypes["default"].bool,
	  separator: _propTypes["default"].string,
	  formatter: _propTypes["default"].func,
	  offset: _propTypes["default"].number,
	  itemStyle: _propTypes["default"].object,
	  labelStyle: _propTypes["default"].object,
	  wrapperStyle: _propTypes["default"].object,
	  contentStyle: _propTypes["default"].object,
	  cursor: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].element, _propTypes["default"].object]),
	  coordinate: _propTypes["default"].shape({
	    x: _propTypes["default"].number,
	    y: _propTypes["default"].number
	  }),
	  position: _propTypes["default"].shape({
	    x: _propTypes["default"].number,
	    y: _propTypes["default"].number
	  }),
	  label: _propTypes["default"].any,
	  payload: _propTypes["default"].arrayOf(_propTypes["default"].shape({
	    name: _propTypes["default"].any,
	    value: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string, _propTypes["default"].array]),
	    unit: _propTypes["default"].any,
	    type: _propTypes["default"].oneOf(_ReactUtils.TOOLTIP_TYPES)
	  })),
	  paylodUniqBy: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].bool]),
	  isAnimationActive: _propTypes["default"].bool,
	  animationDuration: _propTypes["default"].number,
	  animationEasing: _propTypes["default"].oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear']),
	  itemSorter: _propTypes["default"].func,
	  filterNull: _propTypes["default"].bool,
	  useTranslate3d: _propTypes["default"].bool
	};
	var defaultProps = {
	  active: false,
	  allowEscapeViewBox: {
	    x: false,
	    y: false
	  },
	  offset: 10,
	  viewBox: {
	    x1: 0,
	    x2: 0,
	    y1: 0,
	    y2: 0
	  },
	  coordinate: {
	    x: 0,
	    y: 0
	  },
	  cursorStyle: {},
	  separator: ' : ',
	  wrapperStyle: {},
	  contentStyle: {},
	  itemStyle: {},
	  labelStyle: {},
	  cursor: true,
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationEasing: 'ease',
	  animationDuration: 400,
	  filterNull: true,
	  useTranslate3d: false
	};
	
	var renderContent = function renderContent(content, props) {
	  if (_react["default"].isValidElement(content)) {
	    return _react["default"].cloneElement(content, props);
	  }
	
	  if ((0, _isFunction2["default"])(content)) {
	    return content(props);
	  }
	
	  return _react["default"].createElement(_DefaultTooltipContent["default"], props);
	};
	
	var Tooltip =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Tooltip, _PureComponent);
	
	  function Tooltip() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Tooltip);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Tooltip)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      boxWidth: -1,
	      boxHeight: -1
	    };
	
	    _this.getTranslate = function (_ref) {
	      var key = _ref.key,
	          tooltipDimension = _ref.tooltipDimension,
	          viewBoxDimension = _ref.viewBoxDimension;
	      var _this$props = _this.props,
	          allowEscapeViewBox = _this$props.allowEscapeViewBox,
	          coordinate = _this$props.coordinate,
	          offset = _this$props.offset,
	          position = _this$props.position,
	          viewBox = _this$props.viewBox;
	
	      if (position && (0, _DataUtils.isNumber)(position[key])) {
	        return position[key];
	      }
	
	      var restricted = coordinate[key] - tooltipDimension - offset;
	      var unrestricted = coordinate[key] + offset;
	
	      if (allowEscapeViewBox[key]) {
	        return unrestricted;
	      }
	
	      var tooltipBoundary = coordinate[key] + tooltipDimension + offset;
	      var viewBoxBoundary = viewBox[key] + viewBoxDimension;
	
	      if (tooltipBoundary > viewBoxBoundary) {
	        return Math.max(restricted, viewBox[key]);
	      }
	
	      return Math.max(unrestricted, viewBox[key]);
	    };
	
	    return _this;
	  }
	
	  _createClass(Tooltip, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.updateBBox();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      this.updateBBox();
	    }
	  }, {
	    key: "updateBBox",
	    value: function updateBBox() {
	      var _this$state = this.state,
	          boxWidth = _this$state.boxWidth,
	          boxHeight = _this$state.boxHeight;
	
	      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
	        var box = this.wrapperNode.getBoundingClientRect();
	
	        if (Math.abs(box.width - boxWidth) > EPS || Math.abs(box.height - boxHeight) > EPS) {
	          this.setState({
	            boxWidth: box.width,
	            boxHeight: box.height
	          });
	        }
	      } else if (boxWidth !== -1 || boxHeight !== -1) {
	        this.setState({
	          boxWidth: -1,
	          boxHeight: -1
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _classNames,
	          _this2 = this;
	
	      var _this$props2 = this.props,
	          payload = _this$props2.payload,
	          isAnimationActive = _this$props2.isAnimationActive,
	          animationDuration = _this$props2.animationDuration,
	          animationEasing = _this$props2.animationEasing,
	          filterNull = _this$props2.filterNull,
	          paylodUniqBy = _this$props2.paylodUniqBy;
	      var finalPayload = getUniqPaylod(paylodUniqBy, filterNull && payload && payload.length ? payload.filter(function (entry) {
	        return !(0, _isNil2["default"])(entry.value);
	      }) : payload);
	      var hasPayload = finalPayload && finalPayload.length;
	      var _this$props3 = this.props,
	          content = _this$props3.content,
	          viewBox = _this$props3.viewBox,
	          coordinate = _this$props3.coordinate,
	          position = _this$props3.position,
	          active = _this$props3.active,
	          wrapperStyle = _this$props3.wrapperStyle;
	
	      var outerStyle = _objectSpread({
	        pointerEvents: 'none',
	        visibility: active && hasPayload ? 'visible' : 'hidden',
	        position: 'absolute',
	        top: 0
	      }, wrapperStyle);
	
	      var translateX, translateY;
	
	      if (position && (0, _DataUtils.isNumber)(position.x) && (0, _DataUtils.isNumber)(position.y)) {
	        translateX = position.x;
	        translateY = position.y;
	      } else {
	        var _this$state2 = this.state,
	            boxWidth = _this$state2.boxWidth,
	            boxHeight = _this$state2.boxHeight;
	
	        if (boxWidth > 0 && boxHeight > 0 && coordinate) {
	          translateX = this.getTranslate({
	            key: 'x',
	            tooltipDimension: boxWidth,
	            viewBoxDimension: viewBox.width
	          });
	          translateY = this.getTranslate({
	            key: 'y',
	            tooltipDimension: boxHeight,
	            viewBoxDimension: viewBox.height
	          });
	        } else {
	          outerStyle.visibility = 'hidden';
	        }
	      }
	
	      outerStyle = _objectSpread({}, (0, _reactSmooth.translateStyle)({
	        transform: this.props.useTranslate3d ? "translate3d(".concat(translateX, "px, ").concat(translateY, "px, 0)") : "translate(".concat(translateX, "px, ").concat(translateY, "px)")
	      }), {}, outerStyle);
	
	      if (isAnimationActive && active) {
	        outerStyle = _objectSpread({}, (0, _reactSmooth.translateStyle)({
	          transition: "transform ".concat(animationDuration, "ms ").concat(animationEasing)
	        }), {}, outerStyle);
	      }
	
	      var cls = (0, _classnames["default"])(CLS_PREFIX, (_classNames = {}, _defineProperty(_classNames, "".concat(CLS_PREFIX, "-right"), (0, _DataUtils.isNumber)(translateX) && coordinate && (0, _DataUtils.isNumber)(coordinate.x) && translateX >= coordinate.x), _defineProperty(_classNames, "".concat(CLS_PREFIX, "-left"), (0, _DataUtils.isNumber)(translateX) && coordinate && (0, _DataUtils.isNumber)(coordinate.x) && translateX < coordinate.x), _defineProperty(_classNames, "".concat(CLS_PREFIX, "-bottom"), (0, _DataUtils.isNumber)(translateY) && coordinate && (0, _DataUtils.isNumber)(coordinate.y) && translateY >= coordinate.y), _defineProperty(_classNames, "".concat(CLS_PREFIX, "-top"), (0, _DataUtils.isNumber)(translateY) && coordinate && (0, _DataUtils.isNumber)(coordinate.y) && translateY < coordinate.y), _classNames));
	      return _react["default"].createElement("div", {
	        className: cls,
	        style: outerStyle,
	        ref: function ref(node) {
	          _this2.wrapperNode = node;
	        }
	      }, renderContent(content, _objectSpread({}, this.props, {
	        payload: finalPayload
	      })));
	    }
	  }]);
	
	  return Tooltip;
	}(_react.PureComponent);
	
	Tooltip.displayName = 'Tooltip';
	Tooltip.propTypes = propTypes;
	Tooltip.defaultProps = defaultProps;
	var _default = Tooltip;
	exports["default"] = _default;

/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(38));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _Layer = _interopRequireDefault(__webpack_require__(49));
	
	var _ReactUtils = __webpack_require__(29);
	
	var _Dot = _interopRequireDefault(__webpack_require__(153));
	
	var _Polygon = _interopRequireDefault(__webpack_require__(310));
	
	var _Text = _interopRequireDefault(__webpack_require__(152));
	
	var _PolarUtils = __webpack_require__(86);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var RADIAN = Math.PI / 180;
	var eps = 1e-5;
	
	var PolarAngleAxis =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(PolarAngleAxis, _PureComponent);
	
	  function PolarAngleAxis() {
	    _classCallCheck(this, PolarAngleAxis);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(PolarAngleAxis).apply(this, arguments));
	  }
	
	  _createClass(PolarAngleAxis, [{
	    key: "getTickLineCoord",
	
	    /**
	     * Calculate the coordinate of line endpoint
	     * @param  {Object} data The Data if ticks
	     * @return {Object} (x0, y0): The start point of text,
	     *                  (x1, y1): The end point close to text,
	     *                  (x2, y2): The end point close to axis
	     */
	    value: function getTickLineCoord(data) {
	      var _this$props = this.props,
	          cx = _this$props.cx,
	          cy = _this$props.cy,
	          radius = _this$props.radius,
	          orientation = _this$props.orientation,
	          tickLine = _this$props.tickLine;
	      var tickLineSize = tickLine && tickLine.size || 8;
	      var p1 = (0, _PolarUtils.polarToCartesian)(cx, cy, radius, data.coordinate);
	      var p2 = (0, _PolarUtils.polarToCartesian)(cx, cy, radius + (orientation === 'inner' ? -1 : 1) * tickLineSize, data.coordinate);
	      return {
	        x1: p1.x,
	        y1: p1.y,
	        x2: p2.x,
	        y2: p2.y
	      };
	    }
	    /**
	     * Get the text-anchor of each tick
	     * @param  {Object} data Data of ticks
	     * @return {String} text-anchor
	     */
	
	  }, {
	    key: "getTickTextAnchor",
	    value: function getTickTextAnchor(data) {
	      var orientation = this.props.orientation;
	      var cos = Math.cos(-data.coordinate * RADIAN);
	      var textAnchor;
	
	      if (cos > eps) {
	        textAnchor = orientation === 'outer' ? 'start' : 'end';
	      } else if (cos < -eps) {
	        textAnchor = orientation === 'outer' ? 'end' : 'start';
	      } else {
	        textAnchor = 'middle';
	      }
	
	      return textAnchor;
	    }
	  }, {
	    key: "renderAxisLine",
	    value: function renderAxisLine() {
	      var _this$props2 = this.props,
	          cx = _this$props2.cx,
	          cy = _this$props2.cy,
	          radius = _this$props2.radius,
	          axisLine = _this$props2.axisLine,
	          axisLineType = _this$props2.axisLineType;
	
	      var props = _objectSpread({}, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	        fill: 'none'
	      }, (0, _ReactUtils.getPresentationAttributes)(axisLine));
	
	      if (axisLineType === 'circle') {
	        return _react["default"].createElement(_Dot["default"], _extends({
	          className: "recharts-polar-angle-axis-line"
	        }, props, {
	          cx: cx,
	          cy: cy,
	          r: radius
	        }));
	      }
	
	      var ticks = this.props.ticks;
	      var points = ticks.map(function (entry) {
	        return (0, _PolarUtils.polarToCartesian)(cx, cy, radius, entry.coordinate);
	      });
	      return _react["default"].createElement(_Polygon["default"], _extends({
	        className: "recharts-polar-angle-axis-line"
	      }, props, {
	        points: points
	      }));
	    }
	  }, {
	    key: "renderTicks",
	    value: function renderTicks() {
	      var _this = this;
	
	      var _this$props3 = this.props,
	          ticks = _this$props3.ticks,
	          tick = _this$props3.tick,
	          tickLine = _this$props3.tickLine,
	          tickFormatter = _this$props3.tickFormatter,
	          stroke = _this$props3.stroke;
	      var axisProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customTickProps = (0, _ReactUtils.getPresentationAttributes)(tick);
	
	      var tickLineProps = _objectSpread({}, axisProps, {
	        fill: 'none'
	      }, (0, _ReactUtils.getPresentationAttributes)(tickLine));
	
	      var items = ticks.map(function (entry, i) {
	        var lineCoord = _this.getTickLineCoord(entry);
	
	        var textAnchor = _this.getTickTextAnchor(entry);
	
	        var tickProps = _objectSpread({
	          textAnchor: textAnchor
	        }, axisProps, {
	          stroke: 'none',
	          fill: stroke
	        }, customTickProps, {
	          index: i,
	          payload: entry,
	          x: lineCoord.x2,
	          y: lineCoord.y2
	        });
	
	        return _react["default"].createElement(_Layer["default"], _extends({
	          className: "recharts-polar-angle-axis-tick",
	          key: "tick-".concat(i) // eslint-disable-line react/no-array-index-key
	
	        }, (0, _ReactUtils.filterEventsOfChild)(_this.props, entry, i)), tickLine && _react["default"].createElement("line", _extends({
	          className: "recharts-polar-angle-axis-tick-line"
	        }, tickLineProps, lineCoord)), tick && _this.constructor.renderTickItem(tick, tickProps, tickFormatter ? tickFormatter(entry.value) : entry.value));
	      });
	      return _react["default"].createElement(_Layer["default"], {
	        className: "recharts-polar-angle-axis-ticks"
	      }, items);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props4 = this.props,
	          ticks = _this$props4.ticks,
	          radius = _this$props4.radius,
	          axisLine = _this$props4.axisLine;
	
	      if (radius <= 0 || !ticks || !ticks.length) {
	        return null;
	      }
	
	      return _react["default"].createElement(_Layer["default"], {
	        className: "recharts-polar-angle-axis"
	      }, axisLine && this.renderAxisLine(), this.renderTicks());
	    }
	  }], [{
	    key: "renderTickItem",
	    value: function renderTickItem(option, props, value) {
	      var tickItem;
	
	      if (_react["default"].isValidElement(option)) {
	        tickItem = _react["default"].cloneElement(option, props);
	      } else if ((0, _isFunction2["default"])(option)) {
	        tickItem = option(props);
	      } else {
	        tickItem = _react["default"].createElement(_Text["default"], _extends({}, props, {
	          className: "recharts-polar-angle-axis-tick-value"
	        }), value);
	      }
	
	      return tickItem;
	    }
	  }]);
	
	  return PolarAngleAxis;
	}(_react.PureComponent);
	
	PolarAngleAxis.displayName = 'PolarAngleAxis';
	PolarAngleAxis.axisType = 'angleAxis';
	PolarAngleAxis.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {}, _ReactUtils.EVENT_ATTRIBUTES, {
	  type: _propTypes["default"].oneOf(['number', 'category']),
	  angleAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  dataKey: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string, _propTypes["default"].func]),
	  cx: _propTypes["default"].number,
	  cy: _propTypes["default"].number,
	  radius: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  hide: _propTypes["default"].bool,
	  scale: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(_ReactUtils.SCALE_TYPES), _propTypes["default"].func]),
	  axisLine: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].object]),
	  axisLineType: _propTypes["default"].oneOf(['polygon', 'circle']),
	  tickLine: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].object]),
	  tick: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].func, _propTypes["default"].object, _propTypes["default"].element]),
	  ticks: _propTypes["default"].arrayOf(_propTypes["default"].shape({
	    value: _propTypes["default"].any,
	    coordinate: _propTypes["default"].number
	  })),
	  stroke: _propTypes["default"].string,
	  orientation: _propTypes["default"].oneOf(['inner', 'outer']),
	  tickFormatter: _propTypes["default"].func,
	  allowDuplicatedCategory: _propTypes["default"].bool
	});
	PolarAngleAxis.defaultProps = {
	  type: 'category',
	  angleAxisId: 0,
	  scale: 'auto',
	  cx: 0,
	  cy: 0,
	  domain: [0, 'auto'],
	  orientation: 'outer',
	  axisLine: true,
	  tickLine: true,
	  tick: true,
	  hide: false,
	  allowDuplicatedCategory: true
	};
	var _default = PolarAngleAxis;
	exports["default"] = _default;

/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(38));
	
	var _minBy2 = _interopRequireDefault(__webpack_require__(2176));
	
	var _maxBy2 = _interopRequireDefault(__webpack_require__(756));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _Text = _interopRequireDefault(__webpack_require__(152));
	
	var _Label = _interopRequireDefault(__webpack_require__(127));
	
	var _Layer = _interopRequireDefault(__webpack_require__(49));
	
	var _ReactUtils = __webpack_require__(29);
	
	var _PolarUtils = __webpack_require__(86);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var PolarRadiusAxis =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(PolarRadiusAxis, _PureComponent);
	
	  function PolarRadiusAxis() {
	    _classCallCheck(this, PolarRadiusAxis);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(PolarRadiusAxis).apply(this, arguments));
	  }
	
	  _createClass(PolarRadiusAxis, [{
	    key: "getTickValueCoord",
	
	    /**
	     * Calculate the coordinate of tick
	     * @param  {Number} coordinate The radius of tick
	     * @return {Object} (x, y)
	     */
	    value: function getTickValueCoord(_ref) {
	      var coordinate = _ref.coordinate;
	      var _this$props = this.props,
	          angle = _this$props.angle,
	          cx = _this$props.cx,
	          cy = _this$props.cy;
	      return (0, _PolarUtils.polarToCartesian)(cx, cy, coordinate, angle);
	    }
	  }, {
	    key: "getTickTextAnchor",
	    value: function getTickTextAnchor() {
	      var orientation = this.props.orientation;
	      var textAnchor;
	
	      switch (orientation) {
	        case 'left':
	          textAnchor = 'end';
	          break;
	
	        case 'right':
	          textAnchor = 'start';
	          break;
	
	        default:
	          textAnchor = 'middle';
	          break;
	      }
	
	      return textAnchor;
	    }
	  }, {
	    key: "getViewBox",
	    value: function getViewBox() {
	      var _this$props2 = this.props,
	          cx = _this$props2.cx,
	          cy = _this$props2.cy,
	          angle = _this$props2.angle,
	          ticks = _this$props2.ticks;
	      var maxRadiusTick = (0, _maxBy2["default"])(ticks, function (entry) {
	        return entry.coordinate || 0;
	      });
	      var minRadiusTick = (0, _minBy2["default"])(ticks, function (entry) {
	        return entry.coordinate || 0;
	      });
	      return {
	        cx: cx,
	        cy: cy,
	        startAngle: angle,
	        endAngle: angle,
	        innerRadius: minRadiusTick.coordinate || 0,
	        outerRadius: maxRadiusTick.coordinate || 0
	      };
	    }
	  }, {
	    key: "renderAxisLine",
	    value: function renderAxisLine() {
	      var _this$props3 = this.props,
	          cx = _this$props3.cx,
	          cy = _this$props3.cy,
	          angle = _this$props3.angle,
	          ticks = _this$props3.ticks,
	          axisLine = _this$props3.axisLine,
	          others = _objectWithoutProperties(_this$props3, ["cx", "cy", "angle", "ticks", "axisLine"]);
	
	      var extent = ticks.reduce(function (result, entry) {
	        return [Math.min(result[0], entry.coordinate), Math.max(result[1], entry.coordinate)];
	      }, [Infinity, -Infinity]);
	      var point0 = (0, _PolarUtils.polarToCartesian)(cx, cy, extent[0], angle);
	      var point1 = (0, _PolarUtils.polarToCartesian)(cx, cy, extent[1], angle);
	
	      var props = _objectSpread({}, (0, _ReactUtils.getPresentationAttributes)(others), {
	        fill: 'none'
	      }, (0, _ReactUtils.getPresentationAttributes)(axisLine), {
	        x1: point0.x,
	        y1: point0.y,
	        x2: point1.x,
	        y2: point1.y
	      });
	
	      return _react["default"].createElement("line", _extends({
	        className: "recharts-polar-radius-axis-line"
	      }, props));
	    }
	  }, {
	    key: "renderTicks",
	    value: function renderTicks() {
	      var _this = this;
	
	      var _this$props4 = this.props,
	          ticks = _this$props4.ticks,
	          tick = _this$props4.tick,
	          angle = _this$props4.angle,
	          tickFormatter = _this$props4.tickFormatter,
	          stroke = _this$props4.stroke,
	          others = _objectWithoutProperties(_this$props4, ["ticks", "tick", "angle", "tickFormatter", "stroke"]);
	
	      var textAnchor = this.getTickTextAnchor();
	      var axisProps = (0, _ReactUtils.getPresentationAttributes)(others);
	      var customTickProps = (0, _ReactUtils.getPresentationAttributes)(tick);
	      var items = ticks.map(function (entry, i) {
	        var coord = _this.getTickValueCoord(entry);
	
	        var tickProps = _objectSpread({
	          textAnchor: textAnchor,
	          transform: "rotate(".concat(90 - angle, ", ").concat(coord.x, ", ").concat(coord.y, ")")
	        }, axisProps, {
	          stroke: 'none',
	          fill: stroke
	        }, customTickProps, {
	          index: i
	        }, coord, {
	          payload: entry
	        });
	
	        return _react["default"].createElement(_Layer["default"], _extends({
	          className: "recharts-polar-radius-axis-tick",
	          key: "tick-".concat(i) // eslint-disable-line react/no-array-index-key
	
	        }, (0, _ReactUtils.filterEventsOfChild)(_this.props, entry, i)), _this.constructor.renderTickItem(tick, tickProps, tickFormatter ? tickFormatter(entry.value) : entry.value));
	      });
	      return _react["default"].createElement(_Layer["default"], {
	        className: "recharts-polar-radius-axis-ticks"
	      }, items);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props5 = this.props,
	          ticks = _this$props5.ticks,
	          axisLine = _this$props5.axisLine,
	          tick = _this$props5.tick;
	
	      if (!ticks || !ticks.length) {
	        return null;
	      }
	
	      return _react["default"].createElement(_Layer["default"], {
	        className: "recharts-polar-radius-axis"
	      }, axisLine && this.renderAxisLine(), tick && this.renderTicks(), _Label["default"].renderCallByParent(this.props, this.getViewBox()));
	    }
	  }], [{
	    key: "renderTickItem",
	    value: function renderTickItem(option, props, value) {
	      var tickItem;
	
	      if (_react["default"].isValidElement(option)) {
	        tickItem = _react["default"].cloneElement(option, props);
	      } else if ((0, _isFunction2["default"])(option)) {
	        tickItem = option(props);
	      } else {
	        tickItem = _react["default"].createElement(_Text["default"], _extends({}, props, {
	          className: "recharts-polar-radius-axis-tick-value"
	        }), value);
	      }
	
	      return tickItem;
	    }
	  }]);
	
	  return PolarRadiusAxis;
	}(_react.PureComponent);
	
	PolarRadiusAxis.displayName = 'PolarRadiusAxis';
	PolarRadiusAxis.axisType = 'radiusAxis';
	PolarRadiusAxis.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {}, _ReactUtils.EVENT_ATTRIBUTES, {
	  type: _propTypes["default"].oneOf(['number', 'category']),
	  cx: _propTypes["default"].number,
	  cy: _propTypes["default"].number,
	  hide: _propTypes["default"].bool,
	  radiusAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  angle: _propTypes["default"].number,
	  tickCount: _propTypes["default"].number,
	  ticks: _propTypes["default"].arrayOf(_propTypes["default"].shape({
	    value: _propTypes["default"].any,
	    coordinate: _propTypes["default"].number
	  })),
	  orientation: _propTypes["default"].oneOf(['left', 'right', 'middle']),
	  axisLine: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].object]),
	  tick: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].object, _propTypes["default"].element, _propTypes["default"].func]),
	  stroke: _propTypes["default"].string,
	  tickFormatter: _propTypes["default"].func,
	  domain: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].oneOf(['auto', 'dataMin', 'dataMax'])])),
	  scale: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(['auto', 'linear', 'pow', 'sqrt', 'log', 'identity', 'time', 'band', 'point', 'ordinal', 'quantile', 'quantize', 'utc', 'sequential', 'threshold']), _propTypes["default"].func]),
	  allowDataOverflow: _propTypes["default"].bool,
	  allowDuplicatedCategory: _propTypes["default"].bool
	});
	PolarRadiusAxis.defaultProps = {
	  type: 'number',
	  radiusAxisId: 0,
	  cx: 0,
	  cy: 0,
	  angle: 0,
	  orientation: 'right',
	  stroke: '#ccc',
	  axisLine: true,
	  tick: true,
	  tickCount: 5,
	  domain: [0, 'auto'],
	  allowDataOverflow: false,
	  scale: 'auto',
	  allowDuplicatedCategory: true
	};
	var _default = PolarRadiusAxis;
	exports["default"] = _default;

/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _ReactUtils = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var getPolygonPoints = function getPolygonPoints(points) {
	  return points.reduce(function (result, entry) {
	    if (entry.x === +entry.x && entry.y === +entry.y) {
	      result.push([entry.x, entry.y]);
	    }
	
	    return result;
	  }, []).join(' ');
	};
	
	var Polygon =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Polygon, _PureComponent);
	
	  function Polygon() {
	    _classCallCheck(this, Polygon);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(Polygon).apply(this, arguments));
	  }
	
	  _createClass(Polygon, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          points = _this$props.points,
	          className = _this$props.className;
	
	      if (!points || !points.length) {
	        return null;
	      }
	
	      var layerClass = (0, _classnames["default"])('recharts-polygon', className);
	      return _react["default"].createElement("polygon", _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), {
	        className: layerClass,
	        points: getPolygonPoints(points)
	      }));
	    }
	  }]);
	
	  return Polygon;
	}(_react.PureComponent);
	
	Polygon.displayName = 'Polygon';
	Polygon.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  className: _propTypes["default"].string,
	  points: _propTypes["default"].arrayOf(_propTypes["default"].shape({
	    x: _propTypes["default"].number,
	    y: _propTypes["default"].number
	  }))
	});
	var _default = Polygon;
	exports["default"] = _default;

/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _ReactUtils = __webpack_require__(29);
	
	var _PolarUtils = __webpack_require__(86);
	
	var _DataUtils = __webpack_require__(39);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
	  var sign = (0, _DataUtils.mathSign)(endAngle - startAngle);
	  var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 359.999);
	  return sign * deltaAngle;
	};
	
	var getTangentCircle = function getTangentCircle(_ref) {
	  var cx = _ref.cx,
	      cy = _ref.cy,
	      radius = _ref.radius,
	      angle = _ref.angle,
	      sign = _ref.sign,
	      isExternal = _ref.isExternal,
	      cornerRadius = _ref.cornerRadius,
	      cornerIsExternal = _ref.cornerIsExternal;
	  var centerRadius = cornerRadius * (isExternal ? 1 : -1) + radius;
	
	  var theta = Math.asin(cornerRadius / centerRadius) / _PolarUtils.RADIAN;
	
	  var centerAngle = cornerIsExternal ? angle : angle + sign * theta;
	  var center = (0, _PolarUtils.polarToCartesian)(cx, cy, centerRadius, centerAngle); // The coordinate of point which is tangent to the circle
	
	  var circleTangency = (0, _PolarUtils.polarToCartesian)(cx, cy, radius, centerAngle); // The coordinate of point which is tangent to the radius line
	
	  var lineTangencyAngle = cornerIsExternal ? angle - sign * theta : angle;
	  var lineTangency = (0, _PolarUtils.polarToCartesian)(cx, cy, centerRadius * Math.cos(theta * _PolarUtils.RADIAN), lineTangencyAngle);
	  return {
	    center: center,
	    circleTangency: circleTangency,
	    lineTangency: lineTangency,
	    theta: theta
	  };
	};
	
	var getSectorPath = function getSectorPath(_ref2) {
	  var cx = _ref2.cx,
	      cy = _ref2.cy,
	      innerRadius = _ref2.innerRadius,
	      outerRadius = _ref2.outerRadius,
	      startAngle = _ref2.startAngle,
	      endAngle = _ref2.endAngle;
	  var angle = getDeltaAngle(startAngle, endAngle); // When the angle of sector equals to 360, star point and end point coincide
	
	  var tempEndAngle = startAngle + angle;
	  var outerStartPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, outerRadius, startAngle);
	  var outerEndPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, outerRadius, tempEndAngle);
	  var path = "M ".concat(outerStartPoint.x, ",").concat(outerStartPoint.y, "\n    A ").concat(outerRadius, ",").concat(outerRadius, ",0,\n    ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle > tempEndAngle), ",\n    ").concat(outerEndPoint.x, ",").concat(outerEndPoint.y, "\n  ");
	
	  if (innerRadius > 0) {
	    var innerStartPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, innerRadius, startAngle);
	    var innerEndPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, innerRadius, tempEndAngle);
	    path += "L ".concat(innerEndPoint.x, ",").concat(innerEndPoint.y, "\n            A ").concat(innerRadius, ",").concat(innerRadius, ",0,\n            ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle <= tempEndAngle), ",\n            ").concat(innerStartPoint.x, ",").concat(innerStartPoint.y, " Z");
	  } else {
	    path += "L ".concat(cx, ",").concat(cy, " Z");
	  }
	
	  return path;
	};
	
	var getSectorWithCorner = function getSectorWithCorner(_ref3) {
	  var cx = _ref3.cx,
	      cy = _ref3.cy,
	      innerRadius = _ref3.innerRadius,
	      outerRadius = _ref3.outerRadius,
	      cornerRadius = _ref3.cornerRadius,
	      forceCornerRadius = _ref3.forceCornerRadius,
	      cornerIsExternal = _ref3.cornerIsExternal,
	      startAngle = _ref3.startAngle,
	      endAngle = _ref3.endAngle;
	  var sign = (0, _DataUtils.mathSign)(endAngle - startAngle);
	
	  var _getTangentCircle = getTangentCircle({
	    cx: cx,
	    cy: cy,
	    radius: outerRadius,
	    angle: startAngle,
	    sign: sign,
	    cornerRadius: cornerRadius,
	    cornerIsExternal: cornerIsExternal
	  }),
	      soct = _getTangentCircle.circleTangency,
	      solt = _getTangentCircle.lineTangency,
	      sot = _getTangentCircle.theta;
	
	  var _getTangentCircle2 = getTangentCircle({
	    cx: cx,
	    cy: cy,
	    radius: outerRadius,
	    angle: endAngle,
	    sign: -sign,
	    cornerRadius: cornerRadius,
	    cornerIsExternal: cornerIsExternal
	  }),
	      eoct = _getTangentCircle2.circleTangency,
	      eolt = _getTangentCircle2.lineTangency,
	      eot = _getTangentCircle2.theta;
	
	  var outerArcAngle = Math.abs(startAngle - endAngle) - sot - eot;
	
	  if (outerArcAngle < 0) {
	    if (forceCornerRadius) {
	      return "M ".concat(solt.x, ",").concat(solt.y, "\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(cornerRadius * 2, ",0\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(-cornerRadius * 2, ",0\n      ");
	    }
	
	    return getSectorPath({
	      cx: cx,
	      cy: cy,
	      innerRadius: innerRadius,
	      outerRadius: outerRadius,
	      startAngle: startAngle,
	      endAngle: endAngle
	    });
	  }
	
	  var path = "M ".concat(solt.x, ",").concat(solt.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(soct.x, ",").concat(soct.y, "\n    A").concat(outerRadius, ",").concat(outerRadius, ",0,").concat(+(outerArcAngle > 180), ",").concat(+(sign < 0), ",").concat(eoct.x, ",").concat(eoct.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(eolt.x, ",").concat(eolt.y, "\n  ");
	
	  if (innerRadius > 0) {
	    var _getTangentCircle3 = getTangentCircle({
	      cx: cx,
	      cy: cy,
	      radius: innerRadius,
	      angle: startAngle,
	      sign: sign,
	      isExternal: true,
	      cornerRadius: cornerRadius,
	      cornerIsExternal: cornerIsExternal
	    }),
	        sict = _getTangentCircle3.circleTangency,
	        silt = _getTangentCircle3.lineTangency,
	        sit = _getTangentCircle3.theta;
	
	    var _getTangentCircle4 = getTangentCircle({
	      cx: cx,
	      cy: cy,
	      radius: innerRadius,
	      angle: endAngle,
	      sign: -sign,
	      isExternal: true,
	      cornerRadius: cornerRadius,
	      cornerIsExternal: cornerIsExternal
	    }),
	        eict = _getTangentCircle4.circleTangency,
	        eilt = _getTangentCircle4.lineTangency,
	        eit = _getTangentCircle4.theta;
	
	    var innerArcAngle = Math.abs(startAngle - endAngle) - sit - eit;
	
	    if (innerArcAngle < 0) {
	      return "".concat(path, "L").concat(cx, ",").concat(cy, "Z");
	    }
	
	    path += "L".concat(eilt.x, ",").concat(eilt.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(eict.x, ",").concat(eict.y, "\n      A").concat(innerRadius, ",").concat(innerRadius, ",0,").concat(+(innerArcAngle > 180), ",").concat(+(sign > 0), ",").concat(sict.x, ",").concat(sict.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(silt.x, ",").concat(silt.y, "Z");
	  } else {
	    path += "L".concat(cx, ",").concat(cy, "Z");
	  }
	
	  return path;
	};
	
	var Sector =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Sector, _PureComponent);
	
	  function Sector() {
	    _classCallCheck(this, Sector);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(Sector).apply(this, arguments));
	  }
	
	  _createClass(Sector, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          cx = _this$props.cx,
	          cy = _this$props.cy,
	          innerRadius = _this$props.innerRadius,
	          outerRadius = _this$props.outerRadius,
	          cornerRadius = _this$props.cornerRadius,
	          forceCornerRadius = _this$props.forceCornerRadius,
	          cornerIsExternal = _this$props.cornerIsExternal,
	          startAngle = _this$props.startAngle,
	          endAngle = _this$props.endAngle,
	          className = _this$props.className;
	
	      if (outerRadius < innerRadius || startAngle === endAngle) {
	        return null;
	      }
	
	      var layerClass = (0, _classnames["default"])('recharts-sector', className);
	      var deltaRadius = outerRadius - innerRadius;
	      var cr = (0, _DataUtils.getPercentValue)(cornerRadius, deltaRadius, 0, true);
	      var path;
	
	      if (cr > 0 && Math.abs(startAngle - endAngle) < 360) {
	        path = getSectorWithCorner({
	          cx: cx,
	          cy: cy,
	          innerRadius: innerRadius,
	          outerRadius: outerRadius,
	          cornerRadius: Math.min(cr, deltaRadius / 2),
	          forceCornerRadius: forceCornerRadius,
	          cornerIsExternal: cornerIsExternal,
	          startAngle: startAngle,
	          endAngle: endAngle
	        });
	      } else {
	        path = getSectorPath({
	          cx: cx,
	          cy: cy,
	          innerRadius: innerRadius,
	          outerRadius: outerRadius,
	          startAngle: startAngle,
	          endAngle: endAngle
	        });
	      }
	
	      return _react["default"].createElement("path", _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), {
	        className: layerClass,
	        d: path
	      }));
	    }
	  }]);
	
	  return Sector;
	}(_react.PureComponent);
	
	Sector.displayName = 'Sector';
	Sector.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  className: _propTypes["default"].string,
	  cx: _propTypes["default"].number,
	  cy: _propTypes["default"].number,
	  innerRadius: _propTypes["default"].number,
	  outerRadius: _propTypes["default"].number,
	  startAngle: _propTypes["default"].number,
	  endAngle: _propTypes["default"].number,
	  cornerRadius: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  forceCornerRadius: _propTypes["default"].bool,
	  cornerIsExternal: _propTypes["default"].bool
	});
	Sector.defaultProps = {
	  cx: 0,
	  cy: 0,
	  innerRadius: 0,
	  outerRadius: 0,
	  startAngle: 0,
	  endAngle: 0,
	  cornerRadius: 0,
	  forceCornerRadius: false,
	  cornerIsExternal: false
	};
	var _default = Sector;
	exports["default"] = _default;

/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.calculateChartCoordinate = exports.getOffset = exports.getStringSize = exports.getStyleString = void 0;
	
	var _ReactUtils = __webpack_require__(29);
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	var stringCache = {
	  widthCache: {},
	  cacheCount: 0
	};
	var MAX_CACHE_NUM = 2000;
	var SPAN_STYLE = {
	  position: 'absolute',
	  top: '-20000px',
	  left: 0,
	  padding: 0,
	  margin: 0,
	  border: 'none',
	  whiteSpace: 'pre'
	};
	var STYLE_LIST = ['minWidth', 'maxWidth', 'width', 'minHeight', 'maxHeight', 'height', 'top', 'left', 'fontSize', 'lineHeight', 'padding', 'margin', 'paddingLeft', 'paddingRight', 'paddingTop', 'paddingBottom', 'marginLeft', 'marginRight', 'marginTop', 'marginBottom'];
	var MEASUREMENT_SPAN_ID = 'recharts_measurement_span';
	
	function autoCompleteStyle(name, value) {
	  if (STYLE_LIST.indexOf(name) >= 0 && value === +value) {
	    return "".concat(value, "px");
	  }
	
	  return value;
	}
	
	function camelToMiddleLine(text) {
	  var strs = text.split('');
	  var formatStrs = strs.reduce(function (result, entry) {
	    if (entry === entry.toUpperCase()) {
	      return [].concat(_toConsumableArray(result), ['-', entry.toLowerCase()]);
	    }
	
	    return [].concat(_toConsumableArray(result), [entry]);
	  }, []);
	  return formatStrs.join('');
	}
	
	var getStyleString = function getStyleString(style) {
	  return Object.keys(style).reduce(function (result, s) {
	    return "".concat(result).concat(camelToMiddleLine(s), ":").concat(autoCompleteStyle(s, style[s]), ";");
	  }, '');
	};
	
	exports.getStyleString = getStyleString;
	
	var getStringSize = function getStringSize(text) {
	  var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (text === undefined || text === null || (0, _ReactUtils.isSsr)()) {
	    return {
	      width: 0,
	      height: 0
	    };
	  }
	
	  var str = "".concat(text);
	  var styleString = getStyleString(style);
	  var cacheKey = "".concat(str, "-").concat(styleString);
	
	  if (stringCache.widthCache[cacheKey]) {
	    return stringCache.widthCache[cacheKey];
	  }
	
	  try {
	    var measurementSpan = document.getElementById(MEASUREMENT_SPAN_ID);
	
	    if (!measurementSpan) {
	      measurementSpan = document.createElement('span');
	      measurementSpan.setAttribute('id', MEASUREMENT_SPAN_ID);
	      document.body.appendChild(measurementSpan);
	    } // Need to use CSS Object Model (CSSOM) to be able to comply with Content Security Policy (CSP)
	    // https://en.wikipedia.org/wiki/Content_Security_Policy
	
	
	    var measurementSpanStyle = _objectSpread({}, SPAN_STYLE, {}, style);
	
	    Object.keys(measurementSpanStyle).map(function (styleKey) {
	      measurementSpan.style[styleKey] = measurementSpanStyle[styleKey];
	      return styleKey;
	    });
	    measurementSpan.textContent = str;
	    var rect = measurementSpan.getBoundingClientRect();
	    var result = {
	      width: rect.width,
	      height: rect.height
	    };
	    stringCache.widthCache[cacheKey] = result;
	
	    if (++stringCache.cacheCount > MAX_CACHE_NUM) {
	      stringCache.cacheCount = 0;
	      stringCache.widthCache = {};
	    }
	
	    return result;
	  } catch (e) {
	    return {
	      width: 0,
	      height: 0
	    };
	  }
	};
	
	exports.getStringSize = getStringSize;
	
	var getOffset = function getOffset(el) {
	  var html = el.ownerDocument.documentElement;
	  var box = {
	    top: 0,
	    left: 0
	  }; // If we don't have gBCR, just use 0,0 rather than error
	  // BlackBerry 5, iOS 3 (original iPhone)
	
	  if (typeof el.getBoundingClientRect !== 'undefined') {
	    box = el.getBoundingClientRect();
	  }
	
	  return {
	    top: box.top + window.pageYOffset - html.clientTop,
	    left: box.left + window.pageXOffset - html.clientLeft
	  };
	};
	/**
	 * Calculate coordinate of cursor in chart
	 * @param  {Object} event  Event object
	 * @param  {Object} offset The offset of main part in the svg element
	 * @return {Object}        {chartX, chartY}
	 */
	
	
	exports.getOffset = getOffset;
	
	var calculateChartCoordinate = function calculateChartCoordinate(event, offset) {
	  return {
	    chartX: Math.round(event.pageX - offset.left),
	    chartY: Math.round(event.pageY - offset.top)
	  };
	};
	
	exports.calculateChartCoordinate = calculateChartCoordinate;

/***/ },
/* 313 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ifOverflowMatches = void 0;
	
	var ifOverflowMatches = function ifOverflowMatches(props, value) {
	  var alwaysShow = props.alwaysShow;
	  var ifOverflow = props.ifOverflow;
	
	  if (alwaysShow) {
	    ifOverflow = 'extendDomain';
	  }
	
	  return ifOverflow === value;
	};
	
	exports.ifOverflowMatches = ifOverflowMatches;

/***/ },
/* 314 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.shallowEqual = shallowEqual;
	
	function shallowEqual(a, b) {
	  /* eslint-disable no-restricted-syntax */
	  for (var key in a) {
	    if ({}.hasOwnProperty.call(a, key) && (!{}.hasOwnProperty.call(b, key) || a[key] !== b[key])) {
	      return false;
	    }
	  }
	
	  for (var _key in b) {
	    if ({}.hasOwnProperty.call(b, _key) && !{}.hasOwnProperty.call(a, _key)) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ },
/* 315 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (value) {
	  return typeof value === 'function';
	};

/***/ },
/* 316 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (value) {
	  return value instanceof Map;
	};

/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function () { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function (t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function (t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function (e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function () { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function (e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function (t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function (t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function (t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function (t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function (e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var isPlainObject = __webpack_require__(2038);
	var immer = __webpack_require__(2034);
	function unwrapExports(x) {
	  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
	}
	function createCommonjsModule(fn, module) {
	  return module = {
	    exports: {}
	  }, fn(module, module.exports), module.exports;
	}
	var arrayLikeToArray = createCommonjsModule(function (module) {
	  function _arrayLikeToArray(arr, len) {
	    if (len == null || len > arr.length) len = arr.length;
	    for (var i = 0, arr2 = new Array(len); i < len; i++) {
	      arr2[i] = arr[i];
	    }
	    return arr2;
	  }
	  module.exports = _arrayLikeToArray;
	  module.exports["default"] = module.exports, module.exports.__esModule = true;
	});
	unwrapExports(arrayLikeToArray);
	var arrayWithoutHoles = createCommonjsModule(function (module) {
	  function _arrayWithoutHoles(arr) {
	    if (Array.isArray(arr)) return arrayLikeToArray(arr);
	  }
	  module.exports = _arrayWithoutHoles;
	  module.exports["default"] = module.exports, module.exports.__esModule = true;
	});
	unwrapExports(arrayWithoutHoles);
	var iterableToArray = createCommonjsModule(function (module) {
	  function _iterableToArray(iter) {
	    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
	  }
	  module.exports = _iterableToArray;
	  module.exports["default"] = module.exports, module.exports.__esModule = true;
	});
	unwrapExports(iterableToArray);
	var unsupportedIterableToArray = createCommonjsModule(function (module) {
	  function _unsupportedIterableToArray(o, minLen) {
	    if (!o) return;
	    if (typeof o === "string") return arrayLikeToArray(o, minLen);
	    var n = Object.prototype.toString.call(o).slice(8, -1);
	    if (n === "Object" && o.constructor) n = o.constructor.name;
	    if (n === "Map" || n === "Set") return Array.from(o);
	    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
	  }
	  module.exports = _unsupportedIterableToArray;
	  module.exports["default"] = module.exports, module.exports.__esModule = true;
	});
	unwrapExports(unsupportedIterableToArray);
	var nonIterableSpread = createCommonjsModule(function (module) {
	  function _nonIterableSpread() {
	    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	  }
	  module.exports = _nonIterableSpread;
	  module.exports["default"] = module.exports, module.exports.__esModule = true;
	});
	unwrapExports(nonIterableSpread);
	var toConsumableArray = createCommonjsModule(function (module) {
	  function _toConsumableArray(arr) {
	    return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
	  }
	  module.exports = _toConsumableArray;
	  module.exports["default"] = module.exports, module.exports.__esModule = true;
	});
	var _toConsumableArray = unwrapExports(toConsumableArray);
	var arrayWithHoles = createCommonjsModule(function (module) {
	  function _arrayWithHoles(arr) {
	    if (Array.isArray(arr)) return arr;
	  }
	  module.exports = _arrayWithHoles;
	  module.exports["default"] = module.exports, module.exports.__esModule = true;
	});
	unwrapExports(arrayWithHoles);
	var iterableToArrayLimit = createCommonjsModule(function (module) {
	  function _iterableToArrayLimit(arr, i) {
	    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
	    if (_i == null) return;
	    var _arr = [];
	    var _n = true;
	    var _d = false;
	    var _s, _e;
	    try {
	      for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);
	        if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;
	      _e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"] != null) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }
	    return _arr;
	  }
	  module.exports = _iterableToArrayLimit;
	  module.exports["default"] = module.exports, module.exports.__esModule = true;
	});
	unwrapExports(iterableToArrayLimit);
	var nonIterableRest = createCommonjsModule(function (module) {
	  function _nonIterableRest() {
	    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	  }
	  module.exports = _nonIterableRest;
	  module.exports["default"] = module.exports, module.exports.__esModule = true;
	});
	unwrapExports(nonIterableRest);
	var slicedToArray = createCommonjsModule(function (module) {
	  function _slicedToArray(arr, i) {
	    return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
	  }
	  module.exports = _slicedToArray;
	  module.exports["default"] = module.exports, module.exports.__esModule = true;
	});
	var _slicedToArray = unwrapExports(slicedToArray);
	var defineProperty = createCommonjsModule(function (module) {
	  function _defineProperty(obj, key, value) {
	    if (key in obj) {
	      Object.defineProperty(obj, key, {
	        value: value,
	        enumerable: true,
	        configurable: true,
	        writable: true
	      });
	    } else {
	      obj[key] = value;
	    }
	    return obj;
	  }
	  module.exports = _defineProperty;
	  module.exports["default"] = module.exports, module.exports.__esModule = true;
	});
	var _defineProperty = unwrapExports(defineProperty);
	var DIRTY_PATHS = new WeakMap();
	var DIRTY_PATH_KEYS = new WeakMap();
	var FLUSHING = new WeakMap();
	var NORMALIZING = new WeakMap();
	var PATH_REFS = new WeakMap();
	var POINT_REFS = new WeakMap();
	var RANGE_REFS = new WeakMap();
	function ownKeys$9(object, enumerableOnly) {
	  var keys = Object.keys(object);
	  if (Object.getOwnPropertySymbols) {
	    var symbols = Object.getOwnPropertySymbols(object);
	    if (enumerableOnly) {
	      symbols = symbols.filter(function (sym) {
	        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
	      });
	    }
	    keys.push.apply(keys, symbols);
	  }
	  return keys;
	}
	function _objectSpread$9(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? arguments[i] : {};
	    if (i % 2) {
	      ownKeys$9(Object(source), true).forEach(function (key) {
	        _defineProperty(target, key, source[key]);
	      });
	    } else if (Object.getOwnPropertyDescriptors) {
	      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
	    } else {
	      ownKeys$9(Object(source)).forEach(function (key) {
	        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
	      });
	    }
	  }
	  return target;
	}
	function _createForOfIteratorHelper$7(o, allowArrayLike) {
	  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
	  if (!it) {
	    if (Array.isArray(o) || (it = _unsupportedIterableToArray$7(o)) || allowArrayLike && o && typeof o.length === "number") {
	      if (it) o = it;
	      var i = 0;
	      var F = function F() {};
	      return {
	        s: F,
	        n: function n() {
	          if (i >= o.length) return {
	            done: true
	          };
	          return {
	            done: false,
	            value: o[i++]
	          };
	        },
	        e: function e(_e) {
	          throw _e;
	        },
	        f: F
	      };
	    }
	    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	  }
	  var normalCompletion = true,
	    didErr = false,
	    err;
	  return {
	    s: function s() {
	      it = it.call(o);
	    },
	    n: function n() {
	      var step = it.next();
	      normalCompletion = step.done;
	      return step;
	    },
	    e: function e(_e2) {
	      didErr = true;
	      err = _e2;
	    },
	    f: function f() {
	      try {
	        if (!normalCompletion && it["return"] != null) it["return"]();
	      } finally {
	        if (didErr) throw err;
	      }
	    }
	  };
	}
	function _unsupportedIterableToArray$7(o, minLen) {
	  if (!o) return;
	  if (typeof o === "string") return _arrayLikeToArray$7(o, minLen);
	  var n = Object.prototype.toString.call(o).slice(8, -1);
	  if (n === "Object" && o.constructor) n = o.constructor.name;
	  if (n === "Map" || n === "Set") return Array.from(o);
	  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$7(o, minLen);
	}
	function _arrayLikeToArray$7(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;
	  for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }
	  return arr2;
	}
	/**
	 * Create a new Slate `Editor` object.
	 */
	
	var createEditor = function createEditor() {
	  var editor = {
	    children: [],
	    operations: [],
	    selection: null,
	    marks: null,
	    isInline: function isInline() {
	      return false;
	    },
	    isVoid: function isVoid() {
	      return false;
	    },
	    onChange: function onChange() {},
	    apply: function apply(op) {
	      var _iterator = _createForOfIteratorHelper$7(Editor.pathRefs(editor)),
	        _step;
	      try {
	        for (_iterator.s(); !(_step = _iterator.n()).done;) {
	          var ref = _step.value;
	          PathRef.transform(ref, op);
	        }
	      } catch (err) {
	        _iterator.e(err);
	      } finally {
	        _iterator.f();
	      }
	      var _iterator2 = _createForOfIteratorHelper$7(Editor.pointRefs(editor)),
	        _step2;
	      try {
	        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
	          var _ref = _step2.value;
	          PointRef.transform(_ref, op);
	        }
	      } catch (err) {
	        _iterator2.e(err);
	      } finally {
	        _iterator2.f();
	      }
	      var _iterator3 = _createForOfIteratorHelper$7(Editor.rangeRefs(editor)),
	        _step3;
	      try {
	        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
	          var _ref2 = _step3.value;
	          RangeRef.transform(_ref2, op);
	        }
	      } catch (err) {
	        _iterator3.e(err);
	      } finally {
	        _iterator3.f();
	      }
	      var oldDirtyPaths = DIRTY_PATHS.get(editor) || [];
	      var oldDirtyPathKeys = DIRTY_PATH_KEYS.get(editor) || new Set();
	      var dirtyPaths;
	      var dirtyPathKeys;
	      var add = function add(path) {
	        if (path) {
	          var key = path.join(',');
	          if (!dirtyPathKeys.has(key)) {
	            dirtyPathKeys.add(key);
	            dirtyPaths.push(path);
	          }
	        }
	      };
	      if (Path.operationCanTransformPath(op)) {
	        dirtyPaths = [];
	        dirtyPathKeys = new Set();
	        var _iterator4 = _createForOfIteratorHelper$7(oldDirtyPaths),
	          _step4;
	        try {
	          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
	            var path = _step4.value;
	            var newPath = Path.transform(path, op);
	            add(newPath);
	          }
	        } catch (err) {
	          _iterator4.e(err);
	        } finally {
	          _iterator4.f();
	        }
	      } else {
	        dirtyPaths = oldDirtyPaths;
	        dirtyPathKeys = oldDirtyPathKeys;
	      }
	      var newDirtyPaths = getDirtyPaths(op);
	      var _iterator5 = _createForOfIteratorHelper$7(newDirtyPaths),
	        _step5;
	      try {
	        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
	          var _path = _step5.value;
	          add(_path);
	        }
	      } catch (err) {
	        _iterator5.e(err);
	      } finally {
	        _iterator5.f();
	      }
	      DIRTY_PATHS.set(editor, dirtyPaths);
	      DIRTY_PATH_KEYS.set(editor, dirtyPathKeys);
	      Transforms.transform(editor, op);
	      editor.operations.push(op);
	      Editor.normalize(editor); // Clear any formats applied to the cursor if the selection changes.
	
	      if (op.type === 'set_selection') {
	        editor.marks = null;
	      }
	      if (!FLUSHING.get(editor)) {
	        FLUSHING.set(editor, true);
	        Promise.resolve().then(function () {
	          FLUSHING.set(editor, false);
	          editor.onChange();
	          editor.operations = [];
	        });
	      }
	    },
	    addMark: function addMark(key, value) {
	      var selection = editor.selection;
	      if (selection) {
	        if (Range.isExpanded(selection)) {
	          Transforms.setNodes(editor, _defineProperty({}, key, value), {
	            match: Text.isText,
	            split: true
	          });
	        } else {
	          var marks = _objectSpread$9(_objectSpread$9({}, Editor.marks(editor) || {}), {}, _defineProperty({}, key, value));
	          editor.marks = marks;
	          if (!FLUSHING.get(editor)) {
	            editor.onChange();
	          }
	        }
	      }
	    },
	    deleteBackward: function deleteBackward(unit) {
	      var selection = editor.selection;
	      if (selection && Range.isCollapsed(selection)) {
	        Transforms["delete"](editor, {
	          unit: unit,
	          reverse: true
	        });
	      }
	    },
	    deleteForward: function deleteForward(unit) {
	      var selection = editor.selection;
	      if (selection && Range.isCollapsed(selection)) {
	        Transforms["delete"](editor, {
	          unit: unit
	        });
	      }
	    },
	    deleteFragment: function deleteFragment(direction) {
	      var selection = editor.selection;
	      if (selection && Range.isExpanded(selection)) {
	        Transforms["delete"](editor, {
	          reverse: direction === 'backward'
	        });
	      }
	    },
	    getFragment: function getFragment() {
	      var selection = editor.selection;
	      if (selection) {
	        return Node.fragment(editor, selection);
	      }
	      return [];
	    },
	    insertBreak: function insertBreak() {
	      Transforms.splitNodes(editor, {
	        always: true
	      });
	    },
	    insertSoftBreak: function insertSoftBreak() {
	      Transforms.splitNodes(editor, {
	        always: true
	      });
	    },
	    insertFragment: function insertFragment(fragment) {
	      Transforms.insertFragment(editor, fragment);
	    },
	    insertNode: function insertNode(node) {
	      Transforms.insertNodes(editor, node);
	    },
	    insertText: function insertText(text) {
	      var selection = editor.selection,
	        marks = editor.marks;
	      if (selection) {
	        if (marks) {
	          var node = _objectSpread$9({
	            text: text
	          }, marks);
	          Transforms.insertNodes(editor, node);
	        } else {
	          Transforms.insertText(editor, text);
	        }
	        editor.marks = null;
	      }
	    },
	    normalizeNode: function normalizeNode(entry) {
	      var _entry = _slicedToArray(entry, 2),
	        node = _entry[0],
	        path = _entry[1]; // There are no core normalizations for text nodes.
	
	      if (Text.isText(node)) {
	        return;
	      } // Ensure that block and inline nodes have at least one text child.
	
	      if (Element.isElement(node) && node.children.length === 0) {
	        var child = {
	          text: ''
	        };
	        Transforms.insertNodes(editor, child, {
	          at: path.concat(0),
	          voids: true
	        });
	        return;
	      } // Determine whether the node should have block or inline children.
	
	      var shouldHaveInlines = Editor.isEditor(node) ? false : Element.isElement(node) && (editor.isInline(node) || node.children.length === 0 || Text.isText(node.children[0]) || editor.isInline(node.children[0])); // Since we'll be applying operations while iterating, keep track of an
	      // index that accounts for any added/removed nodes.
	
	      var n = 0;
	      for (var i = 0; i < node.children.length; i++, n++) {
	        var currentNode = Node.get(editor, path);
	        if (Text.isText(currentNode)) continue;
	        var _child = node.children[i];
	        var prev = currentNode.children[n - 1];
	        var isLast = i === node.children.length - 1;
	        var isInlineOrText = Text.isText(_child) || Element.isElement(_child) && editor.isInline(_child); // Only allow block nodes in the top-level children and parent blocks
	        // that only contain block nodes. Similarly, only allow inline nodes in
	        // other inline nodes, or parent blocks that only contain inlines and
	        // text.
	
	        if (isInlineOrText !== shouldHaveInlines) {
	          Transforms.removeNodes(editor, {
	            at: path.concat(n),
	            voids: true
	          });
	          n--;
	        } else if (Element.isElement(_child)) {
	          // Ensure that inline nodes are surrounded by text nodes.
	          if (editor.isInline(_child)) {
	            if (prev == null || !Text.isText(prev)) {
	              var newChild = {
	                text: ''
	              };
	              Transforms.insertNodes(editor, newChild, {
	                at: path.concat(n),
	                voids: true
	              });
	              n++;
	            } else if (isLast) {
	              var _newChild = {
	                text: ''
	              };
	              Transforms.insertNodes(editor, _newChild, {
	                at: path.concat(n + 1),
	                voids: true
	              });
	              n++;
	            }
	          }
	        } else {
	          // Merge adjacent text nodes that are empty or match.
	          if (prev != null && Text.isText(prev)) {
	            if (Text.equals(_child, prev, {
	              loose: true
	            })) {
	              Transforms.mergeNodes(editor, {
	                at: path.concat(n),
	                voids: true
	              });
	              n--;
	            } else if (prev.text === '') {
	              Transforms.removeNodes(editor, {
	                at: path.concat(n - 1),
	                voids: true
	              });
	              n--;
	            } else if (_child.text === '') {
	              Transforms.removeNodes(editor, {
	                at: path.concat(n),
	                voids: true
	              });
	              n--;
	            }
	          }
	        }
	      }
	    },
	    removeMark: function removeMark(key) {
	      var selection = editor.selection;
	      if (selection) {
	        if (Range.isExpanded(selection)) {
	          Transforms.unsetNodes(editor, key, {
	            match: Text.isText,
	            split: true
	          });
	        } else {
	          var marks = _objectSpread$9({}, Editor.marks(editor) || {});
	          delete marks[key];
	          editor.marks = marks;
	          if (!FLUSHING.get(editor)) {
	            editor.onChange();
	          }
	        }
	      }
	    }
	  };
	  return editor;
	};
	/**
	 * Get the "dirty" paths generated from an operation.
	 */
	
	var getDirtyPaths = function getDirtyPaths(op) {
	  switch (op.type) {
	    case 'insert_text':
	    case 'remove_text':
	    case 'set_node':
	      {
	        var path = op.path;
	        return Path.levels(path);
	      }
	    case 'insert_node':
	      {
	        var node = op.node,
	          _path2 = op.path;
	        var levels = Path.levels(_path2);
	        var descendants = Text.isText(node) ? [] : Array.from(Node.nodes(node), function (_ref3) {
	          var _ref4 = _slicedToArray(_ref3, 2),
	            p = _ref4[1];
	          return _path2.concat(p);
	        });
	        return [].concat(_toConsumableArray(levels), _toConsumableArray(descendants));
	      }
	    case 'merge_node':
	      {
	        var _path3 = op.path;
	        var ancestors = Path.ancestors(_path3);
	        var previousPath = Path.previous(_path3);
	        return [].concat(_toConsumableArray(ancestors), [previousPath]);
	      }
	    case 'move_node':
	      {
	        var _path4 = op.path,
	          newPath = op.newPath;
	        if (Path.equals(_path4, newPath)) {
	          return [];
	        }
	        var oldAncestors = [];
	        var newAncestors = [];
	        var _iterator6 = _createForOfIteratorHelper$7(Path.ancestors(_path4)),
	          _step6;
	        try {
	          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
	            var ancestor = _step6.value;
	            var p = Path.transform(ancestor, op);
	            oldAncestors.push(p);
	          }
	        } catch (err) {
	          _iterator6.e(err);
	        } finally {
	          _iterator6.f();
	        }
	        var _iterator7 = _createForOfIteratorHelper$7(Path.ancestors(newPath)),
	          _step7;
	        try {
	          for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
	            var _ancestor = _step7.value;
	            var _p = Path.transform(_ancestor, op);
	            newAncestors.push(_p);
	          }
	        } catch (err) {
	          _iterator7.e(err);
	        } finally {
	          _iterator7.f();
	        }
	        var newParent = newAncestors[newAncestors.length - 1];
	        var newIndex = newPath[newPath.length - 1];
	        var resultPath = newParent.concat(newIndex);
	        return [].concat(oldAncestors, newAncestors, [resultPath]);
	      }
	    case 'remove_node':
	      {
	        var _path5 = op.path;
	        var _ancestors = Path.ancestors(_path5);
	        return _toConsumableArray(_ancestors);
	      }
	    case 'split_node':
	      {
	        var _path6 = op.path;
	        var _levels = Path.levels(_path6);
	        var nextPath = Path.next(_path6);
	        return [].concat(_toConsumableArray(_levels), [nextPath]);
	      }
	    default:
	      {
	        return [];
	      }
	  }
	};
	var objectWithoutPropertiesLoose = createCommonjsModule(function (module) {
	  function _objectWithoutPropertiesLoose(source, excluded) {
	    if (source == null) return {};
	    var target = {};
	    var sourceKeys = Object.keys(source);
	    var key, i;
	    for (i = 0; i < sourceKeys.length; i++) {
	      key = sourceKeys[i];
	      if (excluded.indexOf(key) >= 0) continue;
	      target[key] = source[key];
	    }
	    return target;
	  }
	  module.exports = _objectWithoutPropertiesLoose;
	  module.exports["default"] = module.exports, module.exports.__esModule = true;
	});
	unwrapExports(objectWithoutPropertiesLoose);
	var objectWithoutProperties = createCommonjsModule(function (module) {
	  function _objectWithoutProperties(source, excluded) {
	    if (source == null) return {};
	    var target = objectWithoutPropertiesLoose(source, excluded);
	    var key, i;
	    if (Object.getOwnPropertySymbols) {
	      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
	      for (i = 0; i < sourceSymbolKeys.length; i++) {
	        key = sourceSymbolKeys[i];
	        if (excluded.indexOf(key) >= 0) continue;
	        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
	        target[key] = source[key];
	      }
	    }
	    return target;
	  }
	  module.exports = _objectWithoutProperties;
	  module.exports["default"] = module.exports, module.exports.__esModule = true;
	});
	var _objectWithoutProperties = unwrapExports(objectWithoutProperties);
	function _createForOfIteratorHelper$6(o, allowArrayLike) {
	  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
	  if (!it) {
	    if (Array.isArray(o) || (it = _unsupportedIterableToArray$6(o)) || allowArrayLike && o && typeof o.length === "number") {
	      if (it) o = it;
	      var i = 0;
	      var F = function F() {};
	      return {
	        s: F,
	        n: function n() {
	          if (i >= o.length) return {
	            done: true
	          };
	          return {
	            done: false,
	            value: o[i++]
	          };
	        },
	        e: function e(_e) {
	          throw _e;
	        },
	        f: F
	      };
	    }
	    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	  }
	  var normalCompletion = true,
	    didErr = false,
	    err;
	  return {
	    s: function s() {
	      it = it.call(o);
	    },
	    n: function n() {
	      var step = it.next();
	      normalCompletion = step.done;
	      return step;
	    },
	    e: function e(_e2) {
	      didErr = true;
	      err = _e2;
	    },
	    f: function f() {
	      try {
	        if (!normalCompletion && it["return"] != null) it["return"]();
	      } finally {
	        if (didErr) throw err;
	      }
	    }
	  };
	}
	function _unsupportedIterableToArray$6(o, minLen) {
	  if (!o) return;
	  if (typeof o === "string") return _arrayLikeToArray$6(o, minLen);
	  var n = Object.prototype.toString.call(o).slice(8, -1);
	  if (n === "Object" && o.constructor) n = o.constructor.name;
	  if (n === "Map" || n === "Set") return Array.from(o);
	  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$6(o, minLen);
	}
	function _arrayLikeToArray$6(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;
	  for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }
	  return arr2;
	}
	
	// Character (grapheme cluster) boundaries are determined according to
	// the default grapheme cluster boundary specification, extended grapheme clusters variant[1].
	//
	// References:
	//
	// [1] https://www.unicode.org/reports/tr29/#Default_Grapheme_Cluster_Table
	// [2] https://www.unicode.org/Public/UCD/latest/ucd/auxiliary/GraphemeBreakProperty.txt
	// [3] https://www.unicode.org/Public/UCD/latest/ucd/auxiliary/GraphemeBreakTest.html
	// [4] https://www.unicode.org/Public/UCD/latest/ucd/auxiliary/GraphemeBreakTest.txt
	
	/**
	 * Get the distance to the end of the first character in a string of text.
	 */
	var getCharacterDistance = function getCharacterDistance(str) {
	  var isRTL = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	  var isLTR = !isRTL;
	  var codepoints = isRTL ? codepointsIteratorRTL(str) : str;
	  var left = CodepointType.None;
	  var right = CodepointType.None;
	  var distance = 0; // Evaluation of these conditions are deferred.
	
	  var gb11 = null; // Is GB11 applicable?
	
	  var gb12Or13 = null; // Is GB12 or GB13 applicable?
	
	  var _iterator = _createForOfIteratorHelper$6(codepoints),
	    _step;
	  try {
	    for (_iterator.s(); !(_step = _iterator.n()).done;) {
	      var _char = _step.value;
	      var code = _char.codePointAt(0);
	      if (!code) break;
	      var type = getCodepointType(_char, code);
	      var _ref = isLTR ? [right, type] : [type, left];
	      var _ref2 = _slicedToArray(_ref, 2);
	      left = _ref2[0];
	      right = _ref2[1];
	      if (intersects(left, CodepointType.ZWJ) && intersects(right, CodepointType.ExtPict)) {
	        if (isLTR) {
	          gb11 = endsWithEmojiZWJ(str.substring(0, distance));
	        } else {
	          gb11 = endsWithEmojiZWJ(str.substring(0, str.length - distance));
	        }
	        if (!gb11) break;
	      }
	      if (intersects(left, CodepointType.RI) && intersects(right, CodepointType.RI)) {
	        if (gb12Or13 !== null) {
	          gb12Or13 = !gb12Or13;
	        } else {
	          if (isLTR) {
	            gb12Or13 = true;
	          } else {
	            gb12Or13 = endsWithOddNumberOfRIs(str.substring(0, str.length - distance));
	          }
	        }
	        if (!gb12Or13) break;
	      }
	      if (left !== CodepointType.None && right !== CodepointType.None && isBoundaryPair(left, right)) {
	        break;
	      }
	      distance += _char.length;
	    }
	  } catch (err) {
	    _iterator.e(err);
	  } finally {
	    _iterator.f();
	  }
	  return distance || 1;
	};
	var SPACE = /\s/;
	var PUNCTUATION = /[\u0021-\u0023\u0025-\u002A\u002C-\u002F\u003A\u003B\u003F\u0040\u005B-\u005D\u005F\u007B\u007D\u00A1\u00A7\u00AB\u00B6\u00B7\u00BB\u00BF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E3B\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]/;
	var CHAMELEON = /['\u2018\u2019]/;
	/**
	 * Get the distance to the end of the first word in a string of text.
	 */
	
	var getWordDistance = function getWordDistance(text) {
	  var isRTL = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	  var dist = 0;
	  var started = false;
	  while (text.length > 0) {
	    var charDist = getCharacterDistance(text, isRTL);
	    var _splitByCharacterDist = splitByCharacterDistance(text, charDist, isRTL),
	      _splitByCharacterDist2 = _slicedToArray(_splitByCharacterDist, 2),
	      _char2 = _splitByCharacterDist2[0],
	      remaining = _splitByCharacterDist2[1];
	    if (isWordCharacter(_char2, remaining, isRTL)) {
	      started = true;
	      dist += charDist;
	    } else if (!started) {
	      dist += charDist;
	    } else {
	      break;
	    }
	    text = remaining;
	  }
	  return dist;
	};
	/**
	 * Split a string in two parts at a given distance starting from the end when
	 * `isRTL` is set to `true`.
	 */
	
	var splitByCharacterDistance = function splitByCharacterDistance(str, dist, isRTL) {
	  if (isRTL) {
	    var at = str.length - dist;
	    return [str.slice(at, str.length), str.slice(0, at)];
	  }
	  return [str.slice(0, dist), str.slice(dist)];
	};
	/**
	 * Check if a character is a word character. The `remaining` argument is used
	 * because sometimes you must read subsequent characters to truly determine it.
	 */
	
	var isWordCharacter = function isWordCharacter(_char3, remaining) {
	  var isRTL = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	  if (SPACE.test(_char3)) {
	    return false;
	  } // Chameleons count as word characters as long as they're in a word, so
	  // recurse to see if the next one is a word character or not.
	
	  if (CHAMELEON.test(_char3)) {
	    var charDist = getCharacterDistance(remaining, isRTL);
	    var _splitByCharacterDist3 = splitByCharacterDistance(remaining, charDist, isRTL),
	      _splitByCharacterDist4 = _slicedToArray(_splitByCharacterDist3, 2),
	      nextChar = _splitByCharacterDist4[0],
	      nextRemaining = _splitByCharacterDist4[1];
	    if (isWordCharacter(nextChar, nextRemaining, isRTL)) {
	      return true;
	    }
	  }
	  if (PUNCTUATION.test(_char3)) {
	    return false;
	  }
	  return true;
	};
	/**
	 * Iterate on codepoints from right to left.
	 */
	
	var codepointsIteratorRTL = /*#__PURE__*/_regeneratorRuntime().mark(function codepointsIteratorRTL(str) {
	  var end, i, char1, char2;
	  return _regeneratorRuntime().wrap(function codepointsIteratorRTL$(_context) {
	    while (1) switch (_context.prev = _context.next) {
	      case 0:
	        end = str.length - 1;
	        i = 0;
	      case 2:
	        if (!(i < str.length)) {
	          _context.next = 16;
	          break;
	        }
	        char1 = str.charAt(end - i);
	        if (!isLowSurrogate(char1.charCodeAt(0))) {
	          _context.next = 11;
	          break;
	        }
	        char2 = str.charAt(end - i - 1);
	        if (!isHighSurrogate(char2.charCodeAt(0))) {
	          _context.next = 11;
	          break;
	        }
	        _context.next = 9;
	        return char2 + char1;
	      case 9:
	        i++;
	        return _context.abrupt("continue", 13);
	      case 11:
	        _context.next = 13;
	        return char1;
	      case 13:
	        i++;
	        _context.next = 2;
	        break;
	      case 16:
	      case "end":
	        return _context.stop();
	    }
	  }, codepointsIteratorRTL);
	});
	/**
	 * Is `charCode` a high surrogate.
	 *
	 * https://en.wikipedia.org/wiki/Universal_Character_Set_characters#Surrogates
	 */
	
	var isHighSurrogate = function isHighSurrogate(charCode) {
	  return charCode >= 0xd800 && charCode <= 0xdbff;
	};
	/**
	 * Is `charCode` a low surrogate.
	 *
	 * https://en.wikipedia.org/wiki/Universal_Character_Set_characters#Surrogates
	 */
	
	var isLowSurrogate = function isLowSurrogate(charCode) {
	  return charCode >= 0xdc00 && charCode <= 0xdfff;
	};
	var CodepointType;
	(function (CodepointType) {
	  CodepointType[CodepointType["None"] = 0] = "None";
	  CodepointType[CodepointType["Extend"] = 1] = "Extend";
	  CodepointType[CodepointType["ZWJ"] = 2] = "ZWJ";
	  CodepointType[CodepointType["RI"] = 4] = "RI";
	  CodepointType[CodepointType["Prepend"] = 8] = "Prepend";
	  CodepointType[CodepointType["SpacingMark"] = 16] = "SpacingMark";
	  CodepointType[CodepointType["L"] = 32] = "L";
	  CodepointType[CodepointType["V"] = 64] = "V";
	  CodepointType[CodepointType["T"] = 128] = "T";
	  CodepointType[CodepointType["LV"] = 256] = "LV";
	  CodepointType[CodepointType["LVT"] = 512] = "LVT";
	  CodepointType[CodepointType["ExtPict"] = 1024] = "ExtPict";
	  CodepointType[CodepointType["Any"] = 2048] = "Any";
	})(CodepointType || (CodepointType = {}));
	var reExtend = /^(?:[\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09BE\u09C1-\u09C4\u09CD\u09D7\u09E2\u09E3\u09FE\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01\u0B3C\u0B3E\u0B3F\u0B41-\u0B44\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B82\u0BBE\u0BC0\u0BCD\u0BD7\u0C00\u0C04\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC2\u0CC6\u0CCC\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0D00\u0D01\u0D3B\u0D3C\u0D3E\u0D41-\u0D44\u0D4D\u0D57\u0D62\u0D63\u0D81\u0DCA\u0DCF\u0DD2-\u0DD4\u0DD6\u0DDF\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1AC0\u1B00-\u1B03\u1B34-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u200C\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA82C\uA8C4\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9BD\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFF9E\uFF9F]|\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD803[\uDD24-\uDD27\uDEAB\uDEAC\uDF46-\uDF50]|\uD804[\uDC01\uDC38-\uDC46\uDC7F-\uDC81\uDCB3-\uDCB6\uDCB9\uDCBA\uDD00-\uDD02\uDD27-\uDD2B\uDD2D-\uDD34\uDD73\uDD80\uDD81\uDDB6-\uDDBE\uDDC9-\uDDCC\uDDCF\uDE2F-\uDE31\uDE34\uDE36\uDE37\uDE3E\uDEDF\uDEE3-\uDEEA\uDF00\uDF01\uDF3B\uDF3C\uDF3E\uDF40\uDF57\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC38-\uDC3F\uDC42-\uDC44\uDC46\uDC5E\uDCB0\uDCB3-\uDCB8\uDCBA\uDCBD\uDCBF\uDCC0\uDCC2\uDCC3\uDDAF\uDDB2-\uDDB5\uDDBC\uDDBD\uDDBF\uDDC0\uDDDC\uDDDD\uDE33-\uDE3A\uDE3D\uDE3F\uDE40\uDEAB\uDEAD\uDEB0-\uDEB5\uDEB7\uDF1D-\uDF1F\uDF22-\uDF25\uDF27-\uDF2B]|\uD806[\uDC2F-\uDC37\uDC39\uDC3A\uDD30\uDD3B\uDD3C\uDD3E\uDD43\uDDD4-\uDDD7\uDDDA\uDDDB\uDDE0\uDE01-\uDE0A\uDE33-\uDE38\uDE3B-\uDE3E\uDE47\uDE51-\uDE56\uDE59-\uDE5B\uDE8A-\uDE96\uDE98\uDE99]|\uD807[\uDC30-\uDC36\uDC38-\uDC3D\uDC3F\uDC92-\uDCA7\uDCAA-\uDCB0\uDCB2\uDCB3\uDCB5\uDCB6\uDD31-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD45\uDD47\uDD90\uDD91\uDD95\uDD97\uDEF3\uDEF4]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF4F\uDF8F-\uDF92\uDFE4]|\uD82F[\uDC9D\uDC9E]|\uD834[\uDD65\uDD67-\uDD69\uDD6E-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDD30-\uDD36\uDEEC-\uDEEF]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uD83C[\uDFFB-\uDFFF]|\uDB40[\uDC20-\uDC7F\uDD00-\uDDEF])$/;
	var rePrepend = /^(?:[\u0600-\u0605\u06DD\u070F\u0890\u0891\u08E2\u0D4E]|\uD804[\uDCBD\uDCCD\uDDC2\uDDC3]|\uD806[\uDD3F\uDD41\uDE3A\uDE84-\uDE89]|\uD807\uDD46)$/;
	var reSpacingMark = /^(?:[\u0903\u093B\u093E-\u0940\u0949-\u094C\u094E\u094F\u0982\u0983\u09BF\u09C0\u09C7\u09C8\u09CB\u09CC\u0A03\u0A3E-\u0A40\u0A83\u0ABE-\u0AC0\u0AC9\u0ACB\u0ACC\u0B02\u0B03\u0B40\u0B47\u0B48\u0B4B\u0B4C\u0BBF\u0BC1\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCC\u0C01-\u0C03\u0C41-\u0C44\u0C82\u0C83\u0CBE\u0CC0\u0CC1\u0CC3\u0CC4\u0CC7\u0CC8\u0CCA\u0CCB\u0D02\u0D03\u0D3F\u0D40\u0D46-\u0D48\u0D4A-\u0D4C\u0D82\u0D83\u0DD0\u0DD1\u0DD8-\u0DDE\u0DF2\u0DF3\u0E33\u0EB3\u0F3E\u0F3F\u0F7F\u1031\u103B\u103C\u1056\u1057\u1084\u1715\u1734\u17B6\u17BE-\u17C5\u17C7\u17C8\u1923-\u1926\u1929-\u192B\u1930\u1931\u1933-\u1938\u1A19\u1A1A\u1A55\u1A57\u1A6D-\u1A72\u1B04\u1B3B\u1B3D-\u1B41\u1B43\u1B44\u1B82\u1BA1\u1BA6\u1BA7\u1BAA\u1BE7\u1BEA-\u1BEC\u1BEE\u1BF2\u1BF3\u1C24-\u1C2B\u1C34\u1C35\u1CE1\u1CF7\uA823\uA824\uA827\uA880\uA881\uA8B4-\uA8C3\uA952\uA953\uA983\uA9B4\uA9B5\uA9BA\uA9BB\uA9BE-\uA9C0\uAA2F\uAA30\uAA33\uAA34\uAA4D\uAAEB\uAAEE\uAAEF\uAAF5\uABE3\uABE4\uABE6\uABE7\uABE9\uABEA\uABEC]|\uD804[\uDC00\uDC02\uDC82\uDCB0-\uDCB2\uDCB7\uDCB8\uDD2C\uDD45\uDD46\uDD82\uDDB3-\uDDB5\uDDBF\uDDC0\uDDCE\uDE2C-\uDE2E\uDE32\uDE33\uDE35\uDEE0-\uDEE2\uDF02\uDF03\uDF3F\uDF41-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF62\uDF63]|\uD805[\uDC35-\uDC37\uDC40\uDC41\uDC45\uDCB1\uDCB2\uDCB9\uDCBB\uDCBC\uDCBE\uDCC1\uDDB0\uDDB1\uDDB8-\uDDBB\uDDBE\uDE30-\uDE32\uDE3B\uDE3C\uDE3E\uDEAC\uDEAE\uDEAF\uDEB6\uDF26]|\uD806[\uDC2C-\uDC2E\uDC38\uDD31-\uDD35\uDD37\uDD38\uDD3D\uDD40\uDD42\uDDD1-\uDDD3\uDDDC-\uDDDF\uDDE4\uDE39\uDE57\uDE58\uDE97]|\uD807[\uDC2F\uDC3E\uDCA9\uDCB1\uDCB4\uDD8A-\uDD8E\uDD93\uDD94\uDD96\uDEF5\uDEF6]|\uD81B[\uDF51-\uDF87\uDFF0\uDFF1]|\uD834[\uDD66\uDD6D])$/;
	var reL = /^[\u1100-\u115F\uA960-\uA97C]$/;
	var reV = /^[\u1160-\u11A7\uD7B0-\uD7C6]$/;
	var reT = /^[\u11A8-\u11FF\uD7CB-\uD7FB]$/;
	var reLV = /^[\uAC00\uAC1C\uAC38\uAC54\uAC70\uAC8C\uACA8\uACC4\uACE0\uACFC\uAD18\uAD34\uAD50\uAD6C\uAD88\uADA4\uADC0\uADDC\uADF8\uAE14\uAE30\uAE4C\uAE68\uAE84\uAEA0\uAEBC\uAED8\uAEF4\uAF10\uAF2C\uAF48\uAF64\uAF80\uAF9C\uAFB8\uAFD4\uAFF0\uB00C\uB028\uB044\uB060\uB07C\uB098\uB0B4\uB0D0\uB0EC\uB108\uB124\uB140\uB15C\uB178\uB194\uB1B0\uB1CC\uB1E8\uB204\uB220\uB23C\uB258\uB274\uB290\uB2AC\uB2C8\uB2E4\uB300\uB31C\uB338\uB354\uB370\uB38C\uB3A8\uB3C4\uB3E0\uB3FC\uB418\uB434\uB450\uB46C\uB488\uB4A4\uB4C0\uB4DC\uB4F8\uB514\uB530\uB54C\uB568\uB584\uB5A0\uB5BC\uB5D8\uB5F4\uB610\uB62C\uB648\uB664\uB680\uB69C\uB6B8\uB6D4\uB6F0\uB70C\uB728\uB744\uB760\uB77C\uB798\uB7B4\uB7D0\uB7EC\uB808\uB824\uB840\uB85C\uB878\uB894\uB8B0\uB8CC\uB8E8\uB904\uB920\uB93C\uB958\uB974\uB990\uB9AC\uB9C8\uB9E4\uBA00\uBA1C\uBA38\uBA54\uBA70\uBA8C\uBAA8\uBAC4\uBAE0\uBAFC\uBB18\uBB34\uBB50\uBB6C\uBB88\uBBA4\uBBC0\uBBDC\uBBF8\uBC14\uBC30\uBC4C\uBC68\uBC84\uBCA0\uBCBC\uBCD8\uBCF4\uBD10\uBD2C\uBD48\uBD64\uBD80\uBD9C\uBDB8\uBDD4\uBDF0\uBE0C\uBE28\uBE44\uBE60\uBE7C\uBE98\uBEB4\uBED0\uBEEC\uBF08\uBF24\uBF40\uBF5C\uBF78\uBF94\uBFB0\uBFCC\uBFE8\uC004\uC020\uC03C\uC058\uC074\uC090\uC0AC\uC0C8\uC0E4\uC100\uC11C\uC138\uC154\uC170\uC18C\uC1A8\uC1C4\uC1E0\uC1FC\uC218\uC234\uC250\uC26C\uC288\uC2A4\uC2C0\uC2DC\uC2F8\uC314\uC330\uC34C\uC368\uC384\uC3A0\uC3BC\uC3D8\uC3F4\uC410\uC42C\uC448\uC464\uC480\uC49C\uC4B8\uC4D4\uC4F0\uC50C\uC528\uC544\uC560\uC57C\uC598\uC5B4\uC5D0\uC5EC\uC608\uC624\uC640\uC65C\uC678\uC694\uC6B0\uC6CC\uC6E8\uC704\uC720\uC73C\uC758\uC774\uC790\uC7AC\uC7C8\uC7E4\uC800\uC81C\uC838\uC854\uC870\uC88C\uC8A8\uC8C4\uC8E0\uC8FC\uC918\uC934\uC950\uC96C\uC988\uC9A4\uC9C0\uC9DC\uC9F8\uCA14\uCA30\uCA4C\uCA68\uCA84\uCAA0\uCABC\uCAD8\uCAF4\uCB10\uCB2C\uCB48\uCB64\uCB80\uCB9C\uCBB8\uCBD4\uCBF0\uCC0C\uCC28\uCC44\uCC60\uCC7C\uCC98\uCCB4\uCCD0\uCCEC\uCD08\uCD24\uCD40\uCD5C\uCD78\uCD94\uCDB0\uCDCC\uCDE8\uCE04\uCE20\uCE3C\uCE58\uCE74\uCE90\uCEAC\uCEC8\uCEE4\uCF00\uCF1C\uCF38\uCF54\uCF70\uCF8C\uCFA8\uCFC4\uCFE0\uCFFC\uD018\uD034\uD050\uD06C\uD088\uD0A4\uD0C0\uD0DC\uD0F8\uD114\uD130\uD14C\uD168\uD184\uD1A0\uD1BC\uD1D8\uD1F4\uD210\uD22C\uD248\uD264\uD280\uD29C\uD2B8\uD2D4\uD2F0\uD30C\uD328\uD344\uD360\uD37C\uD398\uD3B4\uD3D0\uD3EC\uD408\uD424\uD440\uD45C\uD478\uD494\uD4B0\uD4CC\uD4E8\uD504\uD520\uD53C\uD558\uD574\uD590\uD5AC\uD5C8\uD5E4\uD600\uD61C\uD638\uD654\uD670\uD68C\uD6A8\uD6C4\uD6E0\uD6FC\uD718\uD734\uD750\uD76C\uD788]$/;
	var reLVT = /^[\uAC01-\uAC1B\uAC1D-\uAC37\uAC39-\uAC53\uAC55-\uAC6F\uAC71-\uAC8B\uAC8D-\uACA7\uACA9-\uACC3\uACC5-\uACDF\uACE1-\uACFB\uACFD-\uAD17\uAD19-\uAD33\uAD35-\uAD4F\uAD51-\uAD6B\uAD6D-\uAD87\uAD89-\uADA3\uADA5-\uADBF\uADC1-\uADDB\uADDD-\uADF7\uADF9-\uAE13\uAE15-\uAE2F\uAE31-\uAE4B\uAE4D-\uAE67\uAE69-\uAE83\uAE85-\uAE9F\uAEA1-\uAEBB\uAEBD-\uAED7\uAED9-\uAEF3\uAEF5-\uAF0F\uAF11-\uAF2B\uAF2D-\uAF47\uAF49-\uAF63\uAF65-\uAF7F\uAF81-\uAF9B\uAF9D-\uAFB7\uAFB9-\uAFD3\uAFD5-\uAFEF\uAFF1-\uB00B\uB00D-\uB027\uB029-\uB043\uB045-\uB05F\uB061-\uB07B\uB07D-\uB097\uB099-\uB0B3\uB0B5-\uB0CF\uB0D1-\uB0EB\uB0ED-\uB107\uB109-\uB123\uB125-\uB13F\uB141-\uB15B\uB15D-\uB177\uB179-\uB193\uB195-\uB1AF\uB1B1-\uB1CB\uB1CD-\uB1E7\uB1E9-\uB203\uB205-\uB21F\uB221-\uB23B\uB23D-\uB257\uB259-\uB273\uB275-\uB28F\uB291-\uB2AB\uB2AD-\uB2C7\uB2C9-\uB2E3\uB2E5-\uB2FF\uB301-\uB31B\uB31D-\uB337\uB339-\uB353\uB355-\uB36F\uB371-\uB38B\uB38D-\uB3A7\uB3A9-\uB3C3\uB3C5-\uB3DF\uB3E1-\uB3FB\uB3FD-\uB417\uB419-\uB433\uB435-\uB44F\uB451-\uB46B\uB46D-\uB487\uB489-\uB4A3\uB4A5-\uB4BF\uB4C1-\uB4DB\uB4DD-\uB4F7\uB4F9-\uB513\uB515-\uB52F\uB531-\uB54B\uB54D-\uB567\uB569-\uB583\uB585-\uB59F\uB5A1-\uB5BB\uB5BD-\uB5D7\uB5D9-\uB5F3\uB5F5-\uB60F\uB611-\uB62B\uB62D-\uB647\uB649-\uB663\uB665-\uB67F\uB681-\uB69B\uB69D-\uB6B7\uB6B9-\uB6D3\uB6D5-\uB6EF\uB6F1-\uB70B\uB70D-\uB727\uB729-\uB743\uB745-\uB75F\uB761-\uB77B\uB77D-\uB797\uB799-\uB7B3\uB7B5-\uB7CF\uB7D1-\uB7EB\uB7ED-\uB807\uB809-\uB823\uB825-\uB83F\uB841-\uB85B\uB85D-\uB877\uB879-\uB893\uB895-\uB8AF\uB8B1-\uB8CB\uB8CD-\uB8E7\uB8E9-\uB903\uB905-\uB91F\uB921-\uB93B\uB93D-\uB957\uB959-\uB973\uB975-\uB98F\uB991-\uB9AB\uB9AD-\uB9C7\uB9C9-\uB9E3\uB9E5-\uB9FF\uBA01-\uBA1B\uBA1D-\uBA37\uBA39-\uBA53\uBA55-\uBA6F\uBA71-\uBA8B\uBA8D-\uBAA7\uBAA9-\uBAC3\uBAC5-\uBADF\uBAE1-\uBAFB\uBAFD-\uBB17\uBB19-\uBB33\uBB35-\uBB4F\uBB51-\uBB6B\uBB6D-\uBB87\uBB89-\uBBA3\uBBA5-\uBBBF\uBBC1-\uBBDB\uBBDD-\uBBF7\uBBF9-\uBC13\uBC15-\uBC2F\uBC31-\uBC4B\uBC4D-\uBC67\uBC69-\uBC83\uBC85-\uBC9F\uBCA1-\uBCBB\uBCBD-\uBCD7\uBCD9-\uBCF3\uBCF5-\uBD0F\uBD11-\uBD2B\uBD2D-\uBD47\uBD49-\uBD63\uBD65-\uBD7F\uBD81-\uBD9B\uBD9D-\uBDB7\uBDB9-\uBDD3\uBDD5-\uBDEF\uBDF1-\uBE0B\uBE0D-\uBE27\uBE29-\uBE43\uBE45-\uBE5F\uBE61-\uBE7B\uBE7D-\uBE97\uBE99-\uBEB3\uBEB5-\uBECF\uBED1-\uBEEB\uBEED-\uBF07\uBF09-\uBF23\uBF25-\uBF3F\uBF41-\uBF5B\uBF5D-\uBF77\uBF79-\uBF93\uBF95-\uBFAF\uBFB1-\uBFCB\uBFCD-\uBFE7\uBFE9-\uC003\uC005-\uC01F\uC021-\uC03B\uC03D-\uC057\uC059-\uC073\uC075-\uC08F\uC091-\uC0AB\uC0AD-\uC0C7\uC0C9-\uC0E3\uC0E5-\uC0FF\uC101-\uC11B\uC11D-\uC137\uC139-\uC153\uC155-\uC16F\uC171-\uC18B\uC18D-\uC1A7\uC1A9-\uC1C3\uC1C5-\uC1DF\uC1E1-\uC1FB\uC1FD-\uC217\uC219-\uC233\uC235-\uC24F\uC251-\uC26B\uC26D-\uC287\uC289-\uC2A3\uC2A5-\uC2BF\uC2C1-\uC2DB\uC2DD-\uC2F7\uC2F9-\uC313\uC315-\uC32F\uC331-\uC34B\uC34D-\uC367\uC369-\uC383\uC385-\uC39F\uC3A1-\uC3BB\uC3BD-\uC3D7\uC3D9-\uC3F3\uC3F5-\uC40F\uC411-\uC42B\uC42D-\uC447\uC449-\uC463\uC465-\uC47F\uC481-\uC49B\uC49D-\uC4B7\uC4B9-\uC4D3\uC4D5-\uC4EF\uC4F1-\uC50B\uC50D-\uC527\uC529-\uC543\uC545-\uC55F\uC561-\uC57B\uC57D-\uC597\uC599-\uC5B3\uC5B5-\uC5CF\uC5D1-\uC5EB\uC5ED-\uC607\uC609-\uC623\uC625-\uC63F\uC641-\uC65B\uC65D-\uC677\uC679-\uC693\uC695-\uC6AF\uC6B1-\uC6CB\uC6CD-\uC6E7\uC6E9-\uC703\uC705-\uC71F\uC721-\uC73B\uC73D-\uC757\uC759-\uC773\uC775-\uC78F\uC791-\uC7AB\uC7AD-\uC7C7\uC7C9-\uC7E3\uC7E5-\uC7FF\uC801-\uC81B\uC81D-\uC837\uC839-\uC853\uC855-\uC86F\uC871-\uC88B\uC88D-\uC8A7\uC8A9-\uC8C3\uC8C5-\uC8DF\uC8E1-\uC8FB\uC8FD-\uC917\uC919-\uC933\uC935-\uC94F\uC951-\uC96B\uC96D-\uC987\uC989-\uC9A3\uC9A5-\uC9BF\uC9C1-\uC9DB\uC9DD-\uC9F7\uC9F9-\uCA13\uCA15-\uCA2F\uCA31-\uCA4B\uCA4D-\uCA67\uCA69-\uCA83\uCA85-\uCA9F\uCAA1-\uCABB\uCABD-\uCAD7\uCAD9-\uCAF3\uCAF5-\uCB0F\uCB11-\uCB2B\uCB2D-\uCB47\uCB49-\uCB63\uCB65-\uCB7F\uCB81-\uCB9B\uCB9D-\uCBB7\uCBB9-\uCBD3\uCBD5-\uCBEF\uCBF1-\uCC0B\uCC0D-\uCC27\uCC29-\uCC43\uCC45-\uCC5F\uCC61-\uCC7B\uCC7D-\uCC97\uCC99-\uCCB3\uCCB5-\uCCCF\uCCD1-\uCCEB\uCCED-\uCD07\uCD09-\uCD23\uCD25-\uCD3F\uCD41-\uCD5B\uCD5D-\uCD77\uCD79-\uCD93\uCD95-\uCDAF\uCDB1-\uCDCB\uCDCD-\uCDE7\uCDE9-\uCE03\uCE05-\uCE1F\uCE21-\uCE3B\uCE3D-\uCE57\uCE59-\uCE73\uCE75-\uCE8F\uCE91-\uCEAB\uCEAD-\uCEC7\uCEC9-\uCEE3\uCEE5-\uCEFF\uCF01-\uCF1B\uCF1D-\uCF37\uCF39-\uCF53\uCF55-\uCF6F\uCF71-\uCF8B\uCF8D-\uCFA7\uCFA9-\uCFC3\uCFC5-\uCFDF\uCFE1-\uCFFB\uCFFD-\uD017\uD019-\uD033\uD035-\uD04F\uD051-\uD06B\uD06D-\uD087\uD089-\uD0A3\uD0A5-\uD0BF\uD0C1-\uD0DB\uD0DD-\uD0F7\uD0F9-\uD113\uD115-\uD12F\uD131-\uD14B\uD14D-\uD167\uD169-\uD183\uD185-\uD19F\uD1A1-\uD1BB\uD1BD-\uD1D7\uD1D9-\uD1F3\uD1F5-\uD20F\uD211-\uD22B\uD22D-\uD247\uD249-\uD263\uD265-\uD27F\uD281-\uD29B\uD29D-\uD2B7\uD2B9-\uD2D3\uD2D5-\uD2EF\uD2F1-\uD30B\uD30D-\uD327\uD329-\uD343\uD345-\uD35F\uD361-\uD37B\uD37D-\uD397\uD399-\uD3B3\uD3B5-\uD3CF\uD3D1-\uD3EB\uD3ED-\uD407\uD409-\uD423\uD425-\uD43F\uD441-\uD45B\uD45D-\uD477\uD479-\uD493\uD495-\uD4AF\uD4B1-\uD4CB\uD4CD-\uD4E7\uD4E9-\uD503\uD505-\uD51F\uD521-\uD53B\uD53D-\uD557\uD559-\uD573\uD575-\uD58F\uD591-\uD5AB\uD5AD-\uD5C7\uD5C9-\uD5E3\uD5E5-\uD5FF\uD601-\uD61B\uD61D-\uD637\uD639-\uD653\uD655-\uD66F\uD671-\uD68B\uD68D-\uD6A7\uD6A9-\uD6C3\uD6C5-\uD6DF\uD6E1-\uD6FB\uD6FD-\uD717\uD719-\uD733\uD735-\uD74F\uD751-\uD76B\uD76D-\uD787\uD789-\uD7A3]$/;
	var reExtPict = /^(?:[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u2388\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2605\u2607-\u2612\u2614-\u2685\u2690-\u2705\u2708-\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763-\u2767\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC00-\uDCFF\uDD0D-\uDD0F\uDD2F\uDD6C-\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDAD-\uDDE5\uDE01-\uDE0F\uDE1A\uDE2F\uDE32-\uDE3A\uDE3C-\uDE3F\uDE49-\uDFFA]|\uD83D[\uDC00-\uDD3D\uDD46-\uDE4F\uDE80-\uDEFF\uDF74-\uDF7F\uDFD5-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE-\uDCFF\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDEFF]|\uD83F[\uDC00-\uDFFD])$/;
	var getCodepointType = function getCodepointType(_char4, code) {
	  var type = CodepointType.Any;
	  if (_char4.search(reExtend) !== -1) {
	    type |= CodepointType.Extend;
	  }
	  if (code === 0x200d) {
	    type |= CodepointType.ZWJ;
	  }
	  if (code >= 0x1f1e6 && code <= 0x1f1ff) {
	    type |= CodepointType.RI;
	  }
	  if (_char4.search(rePrepend) !== -1) {
	    type |= CodepointType.Prepend;
	  }
	  if (_char4.search(reSpacingMark) !== -1) {
	    type |= CodepointType.SpacingMark;
	  }
	  if (_char4.search(reL) !== -1) {
	    type |= CodepointType.L;
	  }
	  if (_char4.search(reV) !== -1) {
	    type |= CodepointType.V;
	  }
	  if (_char4.search(reT) !== -1) {
	    type |= CodepointType.T;
	  }
	  if (_char4.search(reLV) !== -1) {
	    type |= CodepointType.LV;
	  }
	  if (_char4.search(reLVT) !== -1) {
	    type |= CodepointType.LVT;
	  }
	  if (_char4.search(reExtPict) !== -1) {
	    type |= CodepointType.ExtPict;
	  }
	  return type;
	};
	function intersects(x, y) {
	  return (x & y) !== 0;
	}
	var NonBoundaryPairs = [
	// GB6
	[CodepointType.L, CodepointType.L | CodepointType.V | CodepointType.LV | CodepointType.LVT],
	// GB7
	[CodepointType.LV | CodepointType.V, CodepointType.V | CodepointType.T],
	// GB8
	[CodepointType.LVT | CodepointType.T, CodepointType.T],
	// GB9
	[CodepointType.Any, CodepointType.Extend | CodepointType.ZWJ],
	// GB9a
	[CodepointType.Any, CodepointType.SpacingMark],
	// GB9b
	[CodepointType.Prepend, CodepointType.Any],
	// GB11
	[CodepointType.ZWJ, CodepointType.ExtPict],
	// GB12 and GB13
	[CodepointType.RI, CodepointType.RI]];
	function isBoundaryPair(left, right) {
	  return NonBoundaryPairs.findIndex(function (r) {
	    return intersects(left, r[0]) && intersects(right, r[1]);
	  }) === -1;
	}
	var endingEmojiZWJ = /(?:[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u2388\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2605\u2607-\u2612\u2614-\u2685\u2690-\u2705\u2708-\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763-\u2767\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC00-\uDCFF\uDD0D-\uDD0F\uDD2F\uDD6C-\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDAD-\uDDE5\uDE01-\uDE0F\uDE1A\uDE2F\uDE32-\uDE3A\uDE3C-\uDE3F\uDE49-\uDFFA]|\uD83D[\uDC00-\uDD3D\uDD46-\uDE4F\uDE80-\uDEFF\uDF74-\uDF7F\uDFD5-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE-\uDCFF\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDEFF]|\uD83F[\uDC00-\uDFFD])(?:[\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09BE\u09C1-\u09C4\u09CD\u09D7\u09E2\u09E3\u09FE\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01\u0B3C\u0B3E\u0B3F\u0B41-\u0B44\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B82\u0BBE\u0BC0\u0BCD\u0BD7\u0C00\u0C04\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC2\u0CC6\u0CCC\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0D00\u0D01\u0D3B\u0D3C\u0D3E\u0D41-\u0D44\u0D4D\u0D57\u0D62\u0D63\u0D81\u0DCA\u0DCF\u0DD2-\u0DD4\u0DD6\u0DDF\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1AC0\u1B00-\u1B03\u1B34-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u200C\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA82C\uA8C4\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9BD\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFF9E\uFF9F]|\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD803[\uDD24-\uDD27\uDEAB\uDEAC\uDF46-\uDF50]|\uD804[\uDC01\uDC38-\uDC46\uDC7F-\uDC81\uDCB3-\uDCB6\uDCB9\uDCBA\uDD00-\uDD02\uDD27-\uDD2B\uDD2D-\uDD34\uDD73\uDD80\uDD81\uDDB6-\uDDBE\uDDC9-\uDDCC\uDDCF\uDE2F-\uDE31\uDE34\uDE36\uDE37\uDE3E\uDEDF\uDEE3-\uDEEA\uDF00\uDF01\uDF3B\uDF3C\uDF3E\uDF40\uDF57\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC38-\uDC3F\uDC42-\uDC44\uDC46\uDC5E\uDCB0\uDCB3-\uDCB8\uDCBA\uDCBD\uDCBF\uDCC0\uDCC2\uDCC3\uDDAF\uDDB2-\uDDB5\uDDBC\uDDBD\uDDBF\uDDC0\uDDDC\uDDDD\uDE33-\uDE3A\uDE3D\uDE3F\uDE40\uDEAB\uDEAD\uDEB0-\uDEB5\uDEB7\uDF1D-\uDF1F\uDF22-\uDF25\uDF27-\uDF2B]|\uD806[\uDC2F-\uDC37\uDC39\uDC3A\uDD30\uDD3B\uDD3C\uDD3E\uDD43\uDDD4-\uDDD7\uDDDA\uDDDB\uDDE0\uDE01-\uDE0A\uDE33-\uDE38\uDE3B-\uDE3E\uDE47\uDE51-\uDE56\uDE59-\uDE5B\uDE8A-\uDE96\uDE98\uDE99]|\uD807[\uDC30-\uDC36\uDC38-\uDC3D\uDC3F\uDC92-\uDCA7\uDCAA-\uDCB0\uDCB2\uDCB3\uDCB5\uDCB6\uDD31-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD45\uDD47\uDD90\uDD91\uDD95\uDD97\uDEF3\uDEF4]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF4F\uDF8F-\uDF92\uDFE4]|\uD82F[\uDC9D\uDC9E]|\uD834[\uDD65\uDD67-\uDD69\uDD6E-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDD30-\uDD36\uDEEC-\uDEEF]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uD83C[\uDFFB-\uDFFF]|\uDB40[\uDC20-\uDC7F\uDD00-\uDDEF])*\u200D$/;
	var endsWithEmojiZWJ = function endsWithEmojiZWJ(str) {
	  return str.search(endingEmojiZWJ) !== -1;
	};
	var endingRIs = /(?:\uD83C[\uDDE6-\uDDFF])+$/g;
	var endsWithOddNumberOfRIs = function endsWithOddNumberOfRIs(str) {
	  var match = str.match(endingRIs);
	  if (match === null) {
	    return false;
	  } else {
	    // A RI is represented by a surrogate pair.
	    var numRIs = match[0].length / 2;
	    return numRIs % 2 === 1;
	  }
	};
	
	/**
	 * Shared the function with isElementType utility
	 */
	
	var isElement = function isElement(value) {
	  return isPlainObject.isPlainObject(value) && Node.isNodeList(value.children) && !Editor.isEditor(value);
	};
	var Element = {
	  /**
	   * Check if a value implements the 'Ancestor' interface.
	   */
	  isAncestor: function isAncestor(value) {
	    return isPlainObject.isPlainObject(value) && Node.isNodeList(value.children);
	  },
	  /**
	   * Check if a value implements the `Element` interface.
	   */
	  isElement: isElement,
	  /**
	   * Check if a value is an array of `Element` objects.
	   */
	  isElementList: function isElementList(value) {
	    return Array.isArray(value) && value.every(function (val) {
	      return Element.isElement(val);
	    });
	  },
	  /**
	   * Check if a set of props is a partial of Element.
	   */
	  isElementProps: function isElementProps(props) {
	    return props.children !== undefined;
	  },
	  /**
	   * Check if a value implements the `Element` interface and has elementKey with selected value.
	   * Default it check to `type` key value
	   */
	  isElementType: function isElementType(value, elementVal) {
	    var elementKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'type';
	    return isElement(value) && value[elementKey] === elementVal;
	  },
	  /**
	   * Check if an element matches set of properties.
	   *
	   * Note: this checks custom properties, and it does not ensure that any
	   * children are equivalent.
	   */
	  matches: function matches(element, props) {
	    for (var key in props) {
	      if (key === 'children') {
	        continue;
	      }
	      if (element[key] !== props[key]) {
	        return false;
	      }
	    }
	    return true;
	  }
	};
	var _excluded$4 = ["text"],
	  _excluded2$3 = ["text"];
	function ownKeys$8(object, enumerableOnly) {
	  var keys = Object.keys(object);
	  if (Object.getOwnPropertySymbols) {
	    var symbols = Object.getOwnPropertySymbols(object);
	    if (enumerableOnly) {
	      symbols = symbols.filter(function (sym) {
	        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
	      });
	    }
	    keys.push.apply(keys, symbols);
	  }
	  return keys;
	}
	function _objectSpread$8(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? arguments[i] : {};
	    if (i % 2) {
	      ownKeys$8(Object(source), true).forEach(function (key) {
	        _defineProperty(target, key, source[key]);
	      });
	    } else if (Object.getOwnPropertyDescriptors) {
	      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
	    } else {
	      ownKeys$8(Object(source)).forEach(function (key) {
	        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
	      });
	    }
	  }
	  return target;
	}
	function _createForOfIteratorHelper$5(o, allowArrayLike) {
	  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
	  if (!it) {
	    if (Array.isArray(o) || (it = _unsupportedIterableToArray$5(o)) || allowArrayLike && o && typeof o.length === "number") {
	      if (it) o = it;
	      var i = 0;
	      var F = function F() {};
	      return {
	        s: F,
	        n: function n() {
	          if (i >= o.length) return {
	            done: true
	          };
	          return {
	            done: false,
	            value: o[i++]
	          };
	        },
	        e: function e(_e) {
	          throw _e;
	        },
	        f: F
	      };
	    }
	    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	  }
	  var normalCompletion = true,
	    didErr = false,
	    err;
	  return {
	    s: function s() {
	      it = it.call(o);
	    },
	    n: function n() {
	      var step = it.next();
	      normalCompletion = step.done;
	      return step;
	    },
	    e: function e(_e2) {
	      didErr = true;
	      err = _e2;
	    },
	    f: function f() {
	      try {
	        if (!normalCompletion && it["return"] != null) it["return"]();
	      } finally {
	        if (didErr) throw err;
	      }
	    }
	  };
	}
	function _unsupportedIterableToArray$5(o, minLen) {
	  if (!o) return;
	  if (typeof o === "string") return _arrayLikeToArray$5(o, minLen);
	  var n = Object.prototype.toString.call(o).slice(8, -1);
	  if (n === "Object" && o.constructor) n = o.constructor.name;
	  if (n === "Map" || n === "Set") return Array.from(o);
	  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$5(o, minLen);
	}
	function _arrayLikeToArray$5(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;
	  for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }
	  return arr2;
	}
	var IS_EDITOR_CACHE = new WeakMap();
	var Editor = {
	  /**
	   * Get the ancestor above a location in the document.
	   */
	  above: function above(editor) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var _options$voids = options.voids,
	      voids = _options$voids === void 0 ? false : _options$voids,
	      _options$mode = options.mode,
	      mode = _options$mode === void 0 ? 'lowest' : _options$mode,
	      _options$at = options.at,
	      at = _options$at === void 0 ? editor.selection : _options$at,
	      match = options.match;
	    if (!at) {
	      return;
	    }
	    var path = Editor.path(editor, at);
	    var reverse = mode === 'lowest';
	    var _iterator = _createForOfIteratorHelper$5(Editor.levels(editor, {
	        at: path,
	        voids: voids,
	        match: match,
	        reverse: reverse
	      })),
	      _step;
	    try {
	      for (_iterator.s(); !(_step = _iterator.n()).done;) {
	        var _step$value = _slicedToArray(_step.value, 2),
	          n = _step$value[0],
	          p = _step$value[1];
	        if (!Text.isText(n) && !Path.equals(path, p)) {
	          return [n, p];
	        }
	      }
	    } catch (err) {
	      _iterator.e(err);
	    } finally {
	      _iterator.f();
	    }
	  },
	  /**
	   * Add a custom property to the leaf text nodes in the current selection.
	   *
	   * If the selection is currently collapsed, the marks will be added to the
	   * `editor.marks` property instead, and applied when text is inserted next.
	   */
	  addMark: function addMark(editor, key, value) {
	    editor.addMark(key, value);
	  },
	  /**
	   * Get the point after a location.
	   */
	  after: function after(editor, at) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var anchor = Editor.point(editor, at, {
	      edge: 'end'
	    });
	    var focus = Editor.end(editor, []);
	    var range = {
	      anchor: anchor,
	      focus: focus
	    };
	    var _options$distance = options.distance,
	      distance = _options$distance === void 0 ? 1 : _options$distance;
	    var d = 0;
	    var target;
	    var _iterator2 = _createForOfIteratorHelper$5(Editor.positions(editor, _objectSpread$8(_objectSpread$8({}, options), {}, {
	        at: range
	      }))),
	      _step2;
	    try {
	      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
	        var p = _step2.value;
	        if (d > distance) {
	          break;
	        }
	        if (d !== 0) {
	          target = p;
	        }
	        d++;
	      }
	    } catch (err) {
	      _iterator2.e(err);
	    } finally {
	      _iterator2.f();
	    }
	    return target;
	  },
	  /**
	   * Get the point before a location.
	   */
	  before: function before(editor, at) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var anchor = Editor.start(editor, []);
	    var focus = Editor.point(editor, at, {
	      edge: 'start'
	    });
	    var range = {
	      anchor: anchor,
	      focus: focus
	    };
	    var _options$distance2 = options.distance,
	      distance = _options$distance2 === void 0 ? 1 : _options$distance2;
	    var d = 0;
	    var target;
	    var _iterator3 = _createForOfIteratorHelper$5(Editor.positions(editor, _objectSpread$8(_objectSpread$8({}, options), {}, {
	        at: range,
	        reverse: true
	      }))),
	      _step3;
	    try {
	      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
	        var p = _step3.value;
	        if (d > distance) {
	          break;
	        }
	        if (d !== 0) {
	          target = p;
	        }
	        d++;
	      }
	    } catch (err) {
	      _iterator3.e(err);
	    } finally {
	      _iterator3.f();
	    }
	    return target;
	  },
	  /**
	   * Delete content in the editor backward from the current selection.
	   */
	  deleteBackward: function deleteBackward(editor) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var _options$unit = options.unit,
	      unit = _options$unit === void 0 ? 'character' : _options$unit;
	    editor.deleteBackward(unit);
	  },
	  /**
	   * Delete content in the editor forward from the current selection.
	   */
	  deleteForward: function deleteForward(editor) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var _options$unit2 = options.unit,
	      unit = _options$unit2 === void 0 ? 'character' : _options$unit2;
	    editor.deleteForward(unit);
	  },
	  /**
	   * Delete the content in the current selection.
	   */
	  deleteFragment: function deleteFragment(editor) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var _options$direction = options.direction,
	      direction = _options$direction === void 0 ? 'forward' : _options$direction;
	    editor.deleteFragment(direction);
	  },
	  /**
	   * Get the start and end points of a location.
	   */
	  edges: function edges(editor, at) {
	    return [Editor.start(editor, at), Editor.end(editor, at)];
	  },
	  /**
	   * Get the end point of a location.
	   */
	  end: function end(editor, at) {
	    return Editor.point(editor, at, {
	      edge: 'end'
	    });
	  },
	  /**
	   * Get the first node at a location.
	   */
	  first: function first(editor, at) {
	    var path = Editor.path(editor, at, {
	      edge: 'start'
	    });
	    return Editor.node(editor, path);
	  },
	  /**
	   * Get the fragment at a location.
	   */
	  fragment: function fragment(editor, at) {
	    var range = Editor.range(editor, at);
	    var fragment = Node.fragment(editor, range);
	    return fragment;
	  },
	  /**
	   * Check if a node has block children.
	   */
	  hasBlocks: function hasBlocks(editor, element) {
	    return element.children.some(function (n) {
	      return Editor.isBlock(editor, n);
	    });
	  },
	  /**
	   * Check if a node has inline and text children.
	   */
	  hasInlines: function hasInlines(editor, element) {
	    return element.children.some(function (n) {
	      return Text.isText(n) || Editor.isInline(editor, n);
	    });
	  },
	  /**
	   * Check if a node has text children.
	   */
	  hasTexts: function hasTexts(editor, element) {
	    return element.children.every(function (n) {
	      return Text.isText(n);
	    });
	  },
	  /**
	   * Insert a block break at the current selection.
	   *
	   * If the selection is currently expanded, it will be deleted first.
	   */
	  insertBreak: function insertBreak(editor) {
	    editor.insertBreak();
	  },
	  /**
	   * Insert a soft break at the current selection.
	   *
	   * If the selection is currently expanded, it will be deleted first.
	   */
	  insertSoftBreak: function insertSoftBreak(editor) {
	    editor.insertSoftBreak();
	  },
	  /**
	   * Insert a fragment at the current selection.
	   *
	   * If the selection is currently expanded, it will be deleted first.
	   */
	  insertFragment: function insertFragment(editor, fragment) {
	    editor.insertFragment(fragment);
	  },
	  /**
	   * Insert a node at the current selection.
	   *
	   * If the selection is currently expanded, it will be deleted first.
	   */
	  insertNode: function insertNode(editor, node) {
	    editor.insertNode(node);
	  },
	  /**
	   * Insert text at the current selection.
	   *
	   * If the selection is currently expanded, it will be deleted first.
	   */
	  insertText: function insertText(editor, text) {
	    editor.insertText(text);
	  },
	  /**
	   * Check if a value is a block `Element` object.
	   */
	  isBlock: function isBlock(editor, value) {
	    return Element.isElement(value) && !editor.isInline(value);
	  },
	  /**
	   * Check if a value is an `Editor` object.
	   */
	  isEditor: function isEditor(value) {
	    if (!isPlainObject.isPlainObject(value)) return false;
	    var cachedIsEditor = IS_EDITOR_CACHE.get(value);
	    if (cachedIsEditor !== undefined) {
	      return cachedIsEditor;
	    }
	    var isEditor = typeof value.addMark === 'function' && typeof value.apply === 'function' && typeof value.deleteBackward === 'function' && typeof value.deleteForward === 'function' && typeof value.deleteFragment === 'function' && typeof value.insertBreak === 'function' && typeof value.insertSoftBreak === 'function' && typeof value.insertFragment === 'function' && typeof value.insertNode === 'function' && typeof value.insertText === 'function' && typeof value.isInline === 'function' && typeof value.isVoid === 'function' && typeof value.normalizeNode === 'function' && typeof value.onChange === 'function' && typeof value.removeMark === 'function' && (value.marks === null || isPlainObject.isPlainObject(value.marks)) && (value.selection === null || Range.isRange(value.selection)) && Node.isNodeList(value.children) && Operation.isOperationList(value.operations);
	    IS_EDITOR_CACHE.set(value, isEditor);
	    return isEditor;
	  },
	  /**
	   * Check if a point is the end point of a location.
	   */
	  isEnd: function isEnd(editor, point, at) {
	    var end = Editor.end(editor, at);
	    return Point.equals(point, end);
	  },
	  /**
	   * Check if a point is an edge of a location.
	   */
	  isEdge: function isEdge(editor, point, at) {
	    return Editor.isStart(editor, point, at) || Editor.isEnd(editor, point, at);
	  },
	  /**
	   * Check if an element is empty, accounting for void nodes.
	   */
	  isEmpty: function isEmpty(editor, element) {
	    var children = element.children;
	    var _children = _slicedToArray(children, 1),
	      first = _children[0];
	    return children.length === 0 || children.length === 1 && Text.isText(first) && first.text === '' && !editor.isVoid(element);
	  },
	  /**
	   * Check if a value is an inline `Element` object.
	   */
	  isInline: function isInline(editor, value) {
	    return Element.isElement(value) && editor.isInline(value);
	  },
	  /**
	   * Check if the editor is currently normalizing after each operation.
	   */
	  isNormalizing: function isNormalizing(editor) {
	    var isNormalizing = NORMALIZING.get(editor);
	    return isNormalizing === undefined ? true : isNormalizing;
	  },
	  /**
	   * Check if a point is the start point of a location.
	   */
	  isStart: function isStart(editor, point, at) {
	    // PERF: If the offset isn't `0` we know it's not the start.
	    if (point.offset !== 0) {
	      return false;
	    }
	    var start = Editor.start(editor, at);
	    return Point.equals(point, start);
	  },
	  /**
	   * Check if a value is a void `Element` object.
	   */
	  isVoid: function isVoid(editor, value) {
	    return Element.isElement(value) && editor.isVoid(value);
	  },
	  /**
	   * Get the last node at a location.
	   */
	  last: function last(editor, at) {
	    var path = Editor.path(editor, at, {
	      edge: 'end'
	    });
	    return Editor.node(editor, path);
	  },
	  /**
	   * Get the leaf text node at a location.
	   */
	  leaf: function leaf(editor, at) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var path = Editor.path(editor, at, options);
	    var node = Node.leaf(editor, path);
	    return [node, path];
	  },
	  /**
	   * Iterate through all of the levels at a location.
	   */
	  levels: /*#__PURE__*/_regeneratorRuntime().mark(function levels(editor) {
	    var options,
	      _options$at2,
	      at,
	      _options$reverse,
	      reverse,
	      _options$voids2,
	      voids,
	      match,
	      levels,
	      path,
	      _iterator4,
	      _step4,
	      _step4$value,
	      n,
	      p,
	      _args2 = arguments;
	    return _regeneratorRuntime().wrap(function levels$(_context2) {
	      while (1) switch (_context2.prev = _context2.next) {
	        case 0:
	          options = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
	          _options$at2 = options.at, at = _options$at2 === void 0 ? editor.selection : _options$at2, _options$reverse = options.reverse, reverse = _options$reverse === void 0 ? false : _options$reverse, _options$voids2 = options.voids, voids = _options$voids2 === void 0 ? false : _options$voids2;
	          match = options.match;
	          if (match == null) {
	            match = function match() {
	              return true;
	            };
	          }
	          if (at) {
	            _context2.next = 6;
	            break;
	          }
	          return _context2.abrupt("return");
	        case 6:
	          levels = [];
	          path = Editor.path(editor, at);
	          _iterator4 = _createForOfIteratorHelper$5(Node.levels(editor, path));
	          _context2.prev = 9;
	          _iterator4.s();
	        case 11:
	          if ((_step4 = _iterator4.n()).done) {
	            _context2.next = 20;
	            break;
	          }
	          _step4$value = _slicedToArray(_step4.value, 2), n = _step4$value[0], p = _step4$value[1];
	          if (match(n, p)) {
	            _context2.next = 15;
	            break;
	          }
	          return _context2.abrupt("continue", 18);
	        case 15:
	          levels.push([n, p]);
	          if (!(!voids && Editor.isVoid(editor, n))) {
	            _context2.next = 18;
	            break;
	          }
	          return _context2.abrupt("break", 20);
	        case 18:
	          _context2.next = 11;
	          break;
	        case 20:
	          _context2.next = 25;
	          break;
	        case 22:
	          _context2.prev = 22;
	          _context2.t0 = _context2["catch"](9);
	          _iterator4.e(_context2.t0);
	        case 25:
	          _context2.prev = 25;
	          _iterator4.f();
	          return _context2.finish(25);
	        case 28:
	          if (reverse) {
	            levels.reverse();
	          }
	          return _context2.delegateYield(levels, "t1", 30);
	        case 30:
	        case "end":
	          return _context2.stop();
	      }
	    }, levels, null, [[9, 22, 25, 28]]);
	  }),
	  /**
	   * Get the marks that would be added to text at the current selection.
	   */
	  marks: function marks(editor) {
	    var marks = editor.marks,
	      selection = editor.selection;
	    if (!selection) {
	      return null;
	    }
	    if (marks) {
	      return marks;
	    }
	    if (Range.isExpanded(selection)) {
	      var _Editor$nodes = Editor.nodes(editor, {
	          match: Text.isText
	        }),
	        _Editor$nodes2 = _slicedToArray(_Editor$nodes, 1),
	        match = _Editor$nodes2[0];
	      if (match) {
	        var _match = _slicedToArray(match, 1),
	          _node = _match[0];
	        _node.text;
	        var _rest = _objectWithoutProperties(_node, _excluded$4);
	        return _rest;
	      } else {
	        return {};
	      }
	    }
	    var anchor = selection.anchor;
	    var path = anchor.path;
	    var _Editor$leaf = Editor.leaf(editor, path),
	      _Editor$leaf2 = _slicedToArray(_Editor$leaf, 1),
	      node = _Editor$leaf2[0];
	    if (anchor.offset === 0) {
	      var prev = Editor.previous(editor, {
	        at: path,
	        match: Text.isText
	      });
	      var block = Editor.above(editor, {
	        match: function match(n) {
	          return Editor.isBlock(editor, n);
	        }
	      });
	      if (prev && block) {
	        var _prev = _slicedToArray(prev, 2),
	          prevNode = _prev[0],
	          prevPath = _prev[1];
	        var _block = _slicedToArray(block, 2),
	          blockPath = _block[1];
	        if (Path.isAncestor(blockPath, prevPath)) {
	          node = prevNode;
	        }
	      }
	    }
	    var _node2 = node;
	    _node2.text;
	    var rest = _objectWithoutProperties(_node2, _excluded2$3);
	    return rest;
	  },
	  /**
	   * Get the matching node in the branch of the document after a location.
	   */
	  next: function next(editor) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var _options$mode2 = options.mode,
	      mode = _options$mode2 === void 0 ? 'lowest' : _options$mode2,
	      _options$voids3 = options.voids,
	      voids = _options$voids3 === void 0 ? false : _options$voids3;
	    var match = options.match,
	      _options$at3 = options.at,
	      at = _options$at3 === void 0 ? editor.selection : _options$at3;
	    if (!at) {
	      return;
	    }
	    var pointAfterLocation = Editor.after(editor, at, {
	      voids: voids
	    });
	    if (!pointAfterLocation) return;
	    var _Editor$last = Editor.last(editor, []),
	      _Editor$last2 = _slicedToArray(_Editor$last, 2),
	      to = _Editor$last2[1];
	    var span = [pointAfterLocation.path, to];
	    if (Path.isPath(at) && at.length === 0) {
	      throw new Error("Cannot get the next node from the root node!");
	    }
	    if (match == null) {
	      if (Path.isPath(at)) {
	        var _Editor$parent = Editor.parent(editor, at),
	          _Editor$parent2 = _slicedToArray(_Editor$parent, 1),
	          parent = _Editor$parent2[0];
	        match = function match(n) {
	          return parent.children.includes(n);
	        };
	      } else {
	        match = function match() {
	          return true;
	        };
	      }
	    }
	    var _Editor$nodes3 = Editor.nodes(editor, {
	        at: span,
	        match: match,
	        mode: mode,
	        voids: voids
	      }),
	      _Editor$nodes4 = _slicedToArray(_Editor$nodes3, 1),
	      next = _Editor$nodes4[0];
	    return next;
	  },
	  /**
	   * Get the node at a location.
	   */
	  node: function node(editor, at) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var path = Editor.path(editor, at, options);
	    var node = Node.get(editor, path);
	    return [node, path];
	  },
	  /**
	   * Iterate through all of the nodes in the Editor.
	   */
	  nodes: /*#__PURE__*/_regeneratorRuntime().mark(function nodes(editor) {
	    var options,
	      _options$at4,
	      at,
	      _options$mode3,
	      mode,
	      _options$universal,
	      universal,
	      _options$reverse2,
	      reverse,
	      _options$voids4,
	      voids,
	      match,
	      from,
	      to,
	      first,
	      last,
	      nodeEntries,
	      matches,
	      hit,
	      _iterator5,
	      _step5,
	      _step5$value,
	      node,
	      path,
	      isLower,
	      emit,
	      _args3 = arguments;
	    return _regeneratorRuntime().wrap(function nodes$(_context3) {
	      while (1) switch (_context3.prev = _context3.next) {
	        case 0:
	          options = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};
	          _options$at4 = options.at, at = _options$at4 === void 0 ? editor.selection : _options$at4, _options$mode3 = options.mode, mode = _options$mode3 === void 0 ? 'all' : _options$mode3, _options$universal = options.universal, universal = _options$universal === void 0 ? false : _options$universal, _options$reverse2 = options.reverse, reverse = _options$reverse2 === void 0 ? false : _options$reverse2, _options$voids4 = options.voids, voids = _options$voids4 === void 0 ? false : _options$voids4;
	          match = options.match;
	          if (!match) {
	            match = function match() {
	              return true;
	            };
	          }
	          if (at) {
	            _context3.next = 6;
	            break;
	          }
	          return _context3.abrupt("return");
	        case 6:
	          if (Span.isSpan(at)) {
	            from = at[0];
	            to = at[1];
	          } else {
	            first = Editor.path(editor, at, {
	              edge: 'start'
	            });
	            last = Editor.path(editor, at, {
	              edge: 'end'
	            });
	            from = reverse ? last : first;
	            to = reverse ? first : last;
	          }
	          nodeEntries = Node.nodes(editor, {
	            reverse: reverse,
	            from: from,
	            to: to,
	            pass: function pass(_ref) {
	              var _ref2 = _slicedToArray(_ref, 1),
	                n = _ref2[0];
	              return voids ? false : Editor.isVoid(editor, n);
	            }
	          });
	          matches = [];
	          _iterator5 = _createForOfIteratorHelper$5(nodeEntries);
	          _context3.prev = 10;
	          _iterator5.s();
	        case 12:
	          if ((_step5 = _iterator5.n()).done) {
	            _context3.next = 37;
	            break;
	          }
	          _step5$value = _slicedToArray(_step5.value, 2), node = _step5$value[0], path = _step5$value[1];
	          isLower = hit && Path.compare(path, hit[1]) === 0; // In highest mode any node lower than the last hit is not a match.
	          if (!(mode === 'highest' && isLower)) {
	            _context3.next = 17;
	            break;
	          }
	          return _context3.abrupt("continue", 35);
	        case 17:
	          if (match(node, path)) {
	            _context3.next = 23;
	            break;
	          }
	          if (!(universal && !isLower && Text.isText(node))) {
	            _context3.next = 22;
	            break;
	          }
	          return _context3.abrupt("return");
	        case 22:
	          return _context3.abrupt("continue", 35);
	        case 23:
	          if (!(mode === 'lowest' && isLower)) {
	            _context3.next = 26;
	            break;
	          }
	          hit = [node, path];
	          return _context3.abrupt("continue", 35);
	        case 26:
	          // In lowest mode we emit the last hit, once it's guaranteed lowest.
	          emit = mode === 'lowest' ? hit : [node, path];
	          if (!emit) {
	            _context3.next = 34;
	            break;
	          }
	          if (!universal) {
	            _context3.next = 32;
	            break;
	          }
	          matches.push(emit);
	          _context3.next = 34;
	          break;
	        case 32:
	          _context3.next = 34;
	          return emit;
	        case 34:
	          hit = [node, path];
	        case 35:
	          _context3.next = 12;
	          break;
	        case 37:
	          _context3.next = 42;
	          break;
	        case 39:
	          _context3.prev = 39;
	          _context3.t0 = _context3["catch"](10);
	          _iterator5.e(_context3.t0);
	        case 42:
	          _context3.prev = 42;
	          _iterator5.f();
	          return _context3.finish(42);
	        case 45:
	          if (!(mode === 'lowest' && hit)) {
	            _context3.next = 52;
	            break;
	          }
	          if (!universal) {
	            _context3.next = 50;
	            break;
	          }
	          matches.push(hit);
	          _context3.next = 52;
	          break;
	        case 50:
	          _context3.next = 52;
	          return hit;
	        case 52:
	          if (!universal) {
	            _context3.next = 54;
	            break;
	          }
	          return _context3.delegateYield(matches, "t1", 54);
	        case 54:
	        case "end":
	          return _context3.stop();
	      }
	    }, nodes, null, [[10, 39, 42, 45]]);
	  }),
	  /**
	   * Normalize any dirty objects in the editor.
	   */
	  normalize: function normalize(editor) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var _options$force = options.force,
	      force = _options$force === void 0 ? false : _options$force;
	    var getDirtyPaths = function getDirtyPaths(editor) {
	      return DIRTY_PATHS.get(editor) || [];
	    };
	    var getDirtyPathKeys = function getDirtyPathKeys(editor) {
	      return DIRTY_PATH_KEYS.get(editor) || new Set();
	    };
	    var popDirtyPath = function popDirtyPath(editor) {
	      var path = getDirtyPaths(editor).pop();
	      var key = path.join(',');
	      getDirtyPathKeys(editor)["delete"](key);
	      return path;
	    };
	    if (!Editor.isNormalizing(editor)) {
	      return;
	    }
	    if (force) {
	      var allPaths = Array.from(Node.nodes(editor), function (_ref3) {
	        var _ref4 = _slicedToArray(_ref3, 2),
	          p = _ref4[1];
	        return p;
	      });
	      var allPathKeys = new Set(allPaths.map(function (p) {
	        return p.join(',');
	      }));
	      DIRTY_PATHS.set(editor, allPaths);
	      DIRTY_PATH_KEYS.set(editor, allPathKeys);
	    }
	    if (getDirtyPaths(editor).length === 0) {
	      return;
	    }
	    Editor.withoutNormalizing(editor, function () {
	      /*
	        Fix dirty elements with no children.
	        editor.normalizeNode() does fix this, but some normalization fixes also require it to work.
	        Running an initial pass avoids the catch-22 race condition.
	      */
	      var _iterator6 = _createForOfIteratorHelper$5(getDirtyPaths(editor)),
	        _step6;
	      try {
	        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
	          var _dirtyPath = _step6.value;
	          if (Node.has(editor, _dirtyPath)) {
	            var _entry = Editor.node(editor, _dirtyPath);
	            var _entry2 = _slicedToArray(_entry, 2),
	              node = _entry2[0],
	              _ = _entry2[1];
	            /*
	              The default normalizer inserts an empty text node in this scenario, but it can be customised.
	              So there is some risk here.
	                         As long as the normalizer only inserts child nodes for this case it is safe to do in any order;
	              by definition adding children to an empty node can't cause other paths to change.
	            */
	
	            if (Element.isElement(node) && node.children.length === 0) {
	              editor.normalizeNode(_entry);
	            }
	          }
	        }
	      } catch (err) {
	        _iterator6.e(err);
	      } finally {
	        _iterator6.f();
	      }
	      var max = getDirtyPaths(editor).length * 42; // HACK: better way?
	
	      var m = 0;
	      while (getDirtyPaths(editor).length !== 0) {
	        if (m > max) {
	          throw new Error("\n            Could not completely normalize the editor after ".concat(max, " iterations! This is usually due to incorrect normalization logic that leaves a node in an invalid state.\n          "));
	        }
	        var dirtyPath = popDirtyPath(editor); // If the node doesn't exist in the tree, it does not need to be normalized.
	
	        if (Node.has(editor, dirtyPath)) {
	          var entry = Editor.node(editor, dirtyPath);
	          editor.normalizeNode(entry);
	        }
	        m++;
	      }
	    });
	  },
	  /**
	   * Get the parent node of a location.
	   */
	  parent: function parent(editor, at) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var path = Editor.path(editor, at, options);
	    var parentPath = Path.parent(path);
	    var entry = Editor.node(editor, parentPath);
	    return entry;
	  },
	  /**
	   * Get the path of a location.
	   */
	  path: function path(editor, at) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var depth = options.depth,
	      edge = options.edge;
	    if (Path.isPath(at)) {
	      if (edge === 'start') {
	        var _Node$first = Node.first(editor, at),
	          _Node$first2 = _slicedToArray(_Node$first, 2),
	          firstPath = _Node$first2[1];
	        at = firstPath;
	      } else if (edge === 'end') {
	        var _Node$last = Node.last(editor, at),
	          _Node$last2 = _slicedToArray(_Node$last, 2),
	          lastPath = _Node$last2[1];
	        at = lastPath;
	      }
	    }
	    if (Range.isRange(at)) {
	      if (edge === 'start') {
	        at = Range.start(at);
	      } else if (edge === 'end') {
	        at = Range.end(at);
	      } else {
	        at = Path.common(at.anchor.path, at.focus.path);
	      }
	    }
	    if (Point.isPoint(at)) {
	      at = at.path;
	    }
	    if (depth != null) {
	      at = at.slice(0, depth);
	    }
	    return at;
	  },
	  hasPath: function hasPath(editor, path) {
	    return Node.has(editor, path);
	  },
	  /**
	   * Create a mutable ref for a `Path` object, which will stay in sync as new
	   * operations are applied to the editor.
	   */
	  pathRef: function pathRef(editor, path) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var _options$affinity = options.affinity,
	      affinity = _options$affinity === void 0 ? 'forward' : _options$affinity;
	    var ref = {
	      current: path,
	      affinity: affinity,
	      unref: function unref() {
	        var current = ref.current;
	        var pathRefs = Editor.pathRefs(editor);
	        pathRefs["delete"](ref);
	        ref.current = null;
	        return current;
	      }
	    };
	    var refs = Editor.pathRefs(editor);
	    refs.add(ref);
	    return ref;
	  },
	  /**
	   * Get the set of currently tracked path refs of the editor.
	   */
	  pathRefs: function pathRefs(editor) {
	    var refs = PATH_REFS.get(editor);
	    if (!refs) {
	      refs = new Set();
	      PATH_REFS.set(editor, refs);
	    }
	    return refs;
	  },
	  /**
	   * Get the start or end point of a location.
	   */
	  point: function point(editor, at) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var _options$edge = options.edge,
	      edge = _options$edge === void 0 ? 'start' : _options$edge;
	    if (Path.isPath(at)) {
	      var path;
	      if (edge === 'end') {
	        var _Node$last3 = Node.last(editor, at),
	          _Node$last4 = _slicedToArray(_Node$last3, 2),
	          lastPath = _Node$last4[1];
	        path = lastPath;
	      } else {
	        var _Node$first3 = Node.first(editor, at),
	          _Node$first4 = _slicedToArray(_Node$first3, 2),
	          firstPath = _Node$first4[1];
	        path = firstPath;
	      }
	      var node = Node.get(editor, path);
	      if (!Text.isText(node)) {
	        throw new Error("Cannot get the ".concat(edge, " point in the node at path [").concat(at, "] because it has no ").concat(edge, " text node."));
	      }
	      return {
	        path: path,
	        offset: edge === 'end' ? node.text.length : 0
	      };
	    }
	    if (Range.isRange(at)) {
	      var _Range$edges = Range.edges(at),
	        _Range$edges2 = _slicedToArray(_Range$edges, 2),
	        start = _Range$edges2[0],
	        end = _Range$edges2[1];
	      return edge === 'start' ? start : end;
	    }
	    return at;
	  },
	  /**
	   * Create a mutable ref for a `Point` object, which will stay in sync as new
	   * operations are applied to the editor.
	   */
	  pointRef: function pointRef(editor, point) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var _options$affinity2 = options.affinity,
	      affinity = _options$affinity2 === void 0 ? 'forward' : _options$affinity2;
	    var ref = {
	      current: point,
	      affinity: affinity,
	      unref: function unref() {
	        var current = ref.current;
	        var pointRefs = Editor.pointRefs(editor);
	        pointRefs["delete"](ref);
	        ref.current = null;
	        return current;
	      }
	    };
	    var refs = Editor.pointRefs(editor);
	    refs.add(ref);
	    return ref;
	  },
	  /**
	   * Get the set of currently tracked point refs of the editor.
	   */
	  pointRefs: function pointRefs(editor) {
	    var refs = POINT_REFS.get(editor);
	    if (!refs) {
	      refs = new Set();
	      POINT_REFS.set(editor, refs);
	    }
	    return refs;
	  },
	  /**
	   * Return all the positions in `at` range where a `Point` can be placed.
	   *
	   * By default, moves forward by individual offsets at a time, but
	   * the `unit` option can be used to to move by character, word, line, or block.
	   *
	   * The `reverse` option can be used to change iteration direction.
	   *
	   * Note: By default void nodes are treated as a single point and iteration
	   * will not happen inside their content unless you pass in true for the
	   * `voids` option, then iteration will occur.
	   */
	  positions: /*#__PURE__*/_regeneratorRuntime().mark(function positions(editor) {
	    var options,
	      _options$at5,
	      at,
	      _options$unit3,
	      unit,
	      _options$reverse3,
	      reverse,
	      _options$voids5,
	      voids,
	      range,
	      _Range$edges3,
	      _Range$edges4,
	      start,
	      end,
	      first,
	      isNewBlock,
	      blockText,
	      distance,
	      leafTextRemaining,
	      leafTextOffset,
	      _iterator7,
	      _step7,
	      _step7$value,
	      node,
	      path,
	      e,
	      s,
	      isFirst,
	      calcDistance,
	      _args4 = arguments;
	    return _regeneratorRuntime().wrap(function positions$(_context4) {
	      while (1) switch (_context4.prev = _context4.next) {
	        case 0:
	          calcDistance = function _calcDistance(text, unit, reverse) {
	            if (unit === 'character') {
	              return getCharacterDistance(text, reverse);
	            } else if (unit === 'word') {
	              return getWordDistance(text, reverse);
	            } else if (unit === 'line' || unit === 'block') {
	              return text.length;
	            }
	            return 1;
	          };
	          options = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : {};
	          _options$at5 = options.at, at = _options$at5 === void 0 ? editor.selection : _options$at5, _options$unit3 = options.unit, unit = _options$unit3 === void 0 ? 'offset' : _options$unit3, _options$reverse3 = options.reverse, reverse = _options$reverse3 === void 0 ? false : _options$reverse3, _options$voids5 = options.voids, voids = _options$voids5 === void 0 ? false : _options$voids5;
	          if (at) {
	            _context4.next = 5;
	            break;
	          }
	          return _context4.abrupt("return");
	        case 5:
	          /**
	           * Algorithm notes:
	           *
	           * Each step `distance` is dynamic depending on the underlying text
	           * and the `unit` specified.  Each step, e.g., a line or word, may
	           * span multiple text nodes, so we iterate through the text both on
	           * two levels in step-sync:
	           *
	           * `leafText` stores the text on a text leaf level, and is advanced
	           * through using the counters `leafTextOffset` and `leafTextRemaining`.
	           *
	           * `blockText` stores the text on a block level, and is shortened
	           * by `distance` every time it is advanced.
	           *
	           * We only maintain a window of one blockText and one leafText because
	           * a block node always appears before all of its leaf nodes.
	           */
	          range = Editor.range(editor, at);
	          _Range$edges3 = Range.edges(range), _Range$edges4 = _slicedToArray(_Range$edges3, 2), start = _Range$edges4[0], end = _Range$edges4[1];
	          first = reverse ? end : start;
	          isNewBlock = false;
	          blockText = '';
	          distance = 0; // Distance for leafText to catch up to blockText.
	          leafTextRemaining = 0;
	          leafTextOffset = 0; // Iterate through all nodes in range, grabbing entire textual content
	          // of block nodes in blockText, and text nodes in leafText.
	          // Exploits the fact that nodes are sequenced in such a way that we first
	          // encounter the block node, then all of its text nodes, so when iterating
	          // through the blockText and leafText we just need to remember a window of
	          // one block node and leaf node, respectively.
	          _iterator7 = _createForOfIteratorHelper$5(Editor.nodes(editor, {
	            at: at,
	            reverse: reverse,
	            voids: voids
	          }));
	          _context4.prev = 14;
	          _iterator7.s();
	        case 16:
	          if ((_step7 = _iterator7.n()).done) {
	            _context4.next = 52;
	            break;
	          }
	          _step7$value = _slicedToArray(_step7.value, 2), node = _step7$value[0], path = _step7$value[1];
	          /*
	           * ELEMENT NODE - Yield position(s) for voids, collect blockText for blocks
	           */
	          if (!Element.isElement(node)) {
	            _context4.next = 27;
	            break;
	          }
	          if (!(!voids && editor.isVoid(node))) {
	            _context4.next = 24;
	            break;
	          }
	          _context4.next = 22;
	          return Editor.start(editor, path);
	        case 22:
	          // It's possible the start of the range we're iterating over is in a void, in which case
	          // we want to make sure we don't incorrectly yield the start of a subsequent text node for unit !== 'offset'
	
	          isNewBlock = false;
	          return _context4.abrupt("continue", 50);
	        case 24:
	          if (!editor.isInline(node)) {
	            _context4.next = 26;
	            break;
	          }
	          return _context4.abrupt("continue", 50);
	        case 26:
	          // Block element node - set `blockText` to its text content.
	
	          if (Editor.hasInlines(editor, node)) {
	            // We always exhaust block nodes before encountering a new one:
	            //   console.assert(blockText === '',
	            //     `blockText='${blockText}' - `+
	            //     `not exhausted before new block node`, path)
	            // Ensure range considered is capped to `range`, in the
	            // start/end edge cases where block extends beyond range.
	            // Equivalent to this, but presumably more performant:
	            //   blockRange = Editor.range(editor, ...Editor.edges(editor, path))
	            //   blockRange = Range.intersection(range, blockRange) // intersect
	            //   blockText = Editor.string(editor, blockRange, { voids })
	            e = Path.isAncestor(path, end.path) ? end : Editor.end(editor, path);
	            s = Path.isAncestor(path, start.path) ? start : Editor.start(editor, path);
	            blockText = Editor.string(editor, {
	              anchor: s,
	              focus: e
	            }, {
	              voids: voids
	            });
	            isNewBlock = true;
	          }
	        case 27:
	          if (!Text.isText(node)) {
	            _context4.next = 50;
	            break;
	          }
	          isFirst = Path.equals(path, first.path); // Proof that we always exhaust text nodes before encountering a new one:
	          //   console.assert(leafTextRemaining <= 0,
	          //     `leafTextRemaining=${leafTextRemaining} - `+
	          //     `not exhausted before new leaf text node`, path)
	          // Reset `leafText` counters for new text node.
	          if (isFirst) {
	            leafTextRemaining = reverse ? first.offset : node.text.length - first.offset;
	            leafTextOffset = first.offset; // Works for reverse too.
	          } else {
	            leafTextRemaining = node.text.length;
	            leafTextOffset = reverse ? leafTextRemaining : 0;
	          } // Yield position at the start of node (potentially).
	          if (!(isFirst || isNewBlock || unit === 'offset')) {
	            _context4.next = 34;
	            break;
	          }
	          _context4.next = 33;
	          return {
	            path: path,
	            offset: leafTextOffset
	          };
	        case 33:
	          isNewBlock = false;
	        case 34:
	          if (false) {
	            _context4.next = 50;
	            break;
	          }
	          if (!(distance === 0)) {
	            _context4.next = 40;
	            break;
	          }
	          if (!(blockText === '')) {
	            _context4.next = 38;
	            break;
	          }
	          return _context4.abrupt("break", 50);
	        case 38:
	          distance = calcDistance(blockText, unit, reverse); // Split the string at the previously found distance and use the
	          // remaining string for the next iteration.
	
	          blockText = splitByCharacterDistance(blockText, distance, reverse)[1];
	        case 40:
	          // Advance `leafText` by the current `distance`.
	
	          leafTextOffset = reverse ? leafTextOffset - distance : leafTextOffset + distance;
	          leafTextRemaining = leafTextRemaining - distance; // If `leafText` is exhausted, break to get a new leaf node
	          // and set distance to the overflow amount, so we'll (maybe)
	          // catch up to blockText in the next leaf text node.
	          if (!(leafTextRemaining < 0)) {
	            _context4.next = 45;
	            break;
	          }
	          distance = -leafTextRemaining;
	          return _context4.abrupt("break", 50);
	        case 45:
	          // Successfully walked `distance` offsets through `leafText`
	          // to catch up with `blockText`, so we can reset `distance`
	          // and yield this position in this node.
	
	          distance = 0;
	          _context4.next = 48;
	          return {
	            path: path,
	            offset: leafTextOffset
	          };
	        case 48:
	          _context4.next = 34;
	          break;
	        case 50:
	          _context4.next = 16;
	          break;
	        case 52:
	          _context4.next = 57;
	          break;
	        case 54:
	          _context4.prev = 54;
	          _context4.t0 = _context4["catch"](14);
	          _iterator7.e(_context4.t0);
	        case 57:
	          _context4.prev = 57;
	          _iterator7.f();
	          return _context4.finish(57);
	        case 60:
	        case "end":
	          return _context4.stop();
	      }
	    }, positions, null, [[14, 54, 57, 60]]);
	  }),
	  /**
	   * Get the matching node in the branch of the document before a location.
	   */
	  previous: function previous(editor) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var _options$mode4 = options.mode,
	      mode = _options$mode4 === void 0 ? 'lowest' : _options$mode4,
	      _options$voids6 = options.voids,
	      voids = _options$voids6 === void 0 ? false : _options$voids6;
	    var match = options.match,
	      _options$at6 = options.at,
	      at = _options$at6 === void 0 ? editor.selection : _options$at6;
	    if (!at) {
	      return;
	    }
	    var pointBeforeLocation = Editor.before(editor, at, {
	      voids: voids
	    });
	    if (!pointBeforeLocation) {
	      return;
	    }
	    var _Editor$first = Editor.first(editor, []),
	      _Editor$first2 = _slicedToArray(_Editor$first, 2),
	      to = _Editor$first2[1]; // The search location is from the start of the document to the path of
	    // the point before the location passed in
	
	    var span = [pointBeforeLocation.path, to];
	    if (Path.isPath(at) && at.length === 0) {
	      throw new Error("Cannot get the previous node from the root node!");
	    }
	    if (match == null) {
	      if (Path.isPath(at)) {
	        var _Editor$parent3 = Editor.parent(editor, at),
	          _Editor$parent4 = _slicedToArray(_Editor$parent3, 1),
	          parent = _Editor$parent4[0];
	        match = function match(n) {
	          return parent.children.includes(n);
	        };
	      } else {
	        match = function match() {
	          return true;
	        };
	      }
	    }
	    var _Editor$nodes5 = Editor.nodes(editor, {
	        reverse: true,
	        at: span,
	        match: match,
	        mode: mode,
	        voids: voids
	      }),
	      _Editor$nodes6 = _slicedToArray(_Editor$nodes5, 1),
	      previous = _Editor$nodes6[0];
	    return previous;
	  },
	  /**
	   * Get a range of a location.
	   */
	  range: function range(editor, at, to) {
	    if (Range.isRange(at) && !to) {
	      return at;
	    }
	    var start = Editor.start(editor, at);
	    var end = Editor.end(editor, to || at);
	    return {
	      anchor: start,
	      focus: end
	    };
	  },
	  /**
	   * Create a mutable ref for a `Range` object, which will stay in sync as new
	   * operations are applied to the editor.
	   */
	  rangeRef: function rangeRef(editor, range) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var _options$affinity3 = options.affinity,
	      affinity = _options$affinity3 === void 0 ? 'forward' : _options$affinity3;
	    var ref = {
	      current: range,
	      affinity: affinity,
	      unref: function unref() {
	        var current = ref.current;
	        var rangeRefs = Editor.rangeRefs(editor);
	        rangeRefs["delete"](ref);
	        ref.current = null;
	        return current;
	      }
	    };
	    var refs = Editor.rangeRefs(editor);
	    refs.add(ref);
	    return ref;
	  },
	  /**
	   * Get the set of currently tracked range refs of the editor.
	   */
	  rangeRefs: function rangeRefs(editor) {
	    var refs = RANGE_REFS.get(editor);
	    if (!refs) {
	      refs = new Set();
	      RANGE_REFS.set(editor, refs);
	    }
	    return refs;
	  },
	  /**
	   * Remove a custom property from all of the leaf text nodes in the current
	   * selection.
	   *
	   * If the selection is currently collapsed, the removal will be stored on
	   * `editor.marks` and applied to the text inserted next.
	   */
	  removeMark: function removeMark(editor, key) {
	    editor.removeMark(key);
	  },
	  /**
	   * Manually set if the editor should currently be normalizing.
	   *
	   * Note: Using this incorrectly can leave the editor in an invalid state.
	   *
	   */
	  setNormalizing: function setNormalizing(editor, isNormalizing) {
	    NORMALIZING.set(editor, isNormalizing);
	  },
	  /**
	   * Get the start point of a location.
	   */
	  start: function start(editor, at) {
	    return Editor.point(editor, at, {
	      edge: 'start'
	    });
	  },
	  /**
	   * Get the text string content of a location.
	   *
	   * Note: by default the text of void nodes is considered to be an empty
	   * string, regardless of content, unless you pass in true for the voids option
	   */
	  string: function string(editor, at) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var _options$voids7 = options.voids,
	      voids = _options$voids7 === void 0 ? false : _options$voids7;
	    var range = Editor.range(editor, at);
	    var _Range$edges5 = Range.edges(range),
	      _Range$edges6 = _slicedToArray(_Range$edges5, 2),
	      start = _Range$edges6[0],
	      end = _Range$edges6[1];
	    var text = '';
	    var _iterator8 = _createForOfIteratorHelper$5(Editor.nodes(editor, {
	        at: range,
	        match: Text.isText,
	        voids: voids
	      })),
	      _step8;
	    try {
	      for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
	        var _step8$value = _slicedToArray(_step8.value, 2),
	          node = _step8$value[0],
	          path = _step8$value[1];
	        var t = node.text;
	        if (Path.equals(path, end.path)) {
	          t = t.slice(0, end.offset);
	        }
	        if (Path.equals(path, start.path)) {
	          t = t.slice(start.offset);
	        }
	        text += t;
	      }
	    } catch (err) {
	      _iterator8.e(err);
	    } finally {
	      _iterator8.f();
	    }
	    return text;
	  },
	  /**
	   * Convert a range into a non-hanging one.
	   */
	  unhangRange: function unhangRange(editor, range) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var _options$voids8 = options.voids,
	      voids = _options$voids8 === void 0 ? false : _options$voids8;
	    var _Range$edges7 = Range.edges(range),
	      _Range$edges8 = _slicedToArray(_Range$edges7, 2),
	      start = _Range$edges8[0],
	      end = _Range$edges8[1]; // PERF: exit early if we can guarantee that the range isn't hanging.
	
	    if (start.offset !== 0 || end.offset !== 0 || Range.isCollapsed(range)) {
	      return range;
	    }
	    var endBlock = Editor.above(editor, {
	      at: end,
	      match: function match(n) {
	        return Editor.isBlock(editor, n);
	      }
	    });
	    var blockPath = endBlock ? endBlock[1] : [];
	    var first = Editor.start(editor, start);
	    var before = {
	      anchor: first,
	      focus: end
	    };
	    var skip = true;
	    var _iterator9 = _createForOfIteratorHelper$5(Editor.nodes(editor, {
	        at: before,
	        match: Text.isText,
	        reverse: true,
	        voids: voids
	      })),
	      _step9;
	    try {
	      for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
	        var _step9$value = _slicedToArray(_step9.value, 2),
	          node = _step9$value[0],
	          path = _step9$value[1];
	        if (skip) {
	          skip = false;
	          continue;
	        }
	        if (node.text !== '' || Path.isBefore(path, blockPath)) {
	          end = {
	            path: path,
	            offset: node.text.length
	          };
	          break;
	        }
	      }
	    } catch (err) {
	      _iterator9.e(err);
	    } finally {
	      _iterator9.f();
	    }
	    return {
	      anchor: start,
	      focus: end
	    };
	  },
	  /**
	   * Match a void node in the current branch of the editor.
	   */
	  "void": function _void(editor) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    return Editor.above(editor, _objectSpread$8(_objectSpread$8({}, options), {}, {
	      match: function match(n) {
	        return Editor.isVoid(editor, n);
	      }
	    }));
	  },
	  /**
	   * Call a function, deferring normalization until after it completes.
	   */
	  withoutNormalizing: function withoutNormalizing(editor, fn) {
	    var value = Editor.isNormalizing(editor);
	    Editor.setNormalizing(editor, false);
	    try {
	      fn();
	    } finally {
	      Editor.setNormalizing(editor, value);
	    }
	    Editor.normalize(editor);
	  }
	};
	var Location = {
	  /**
	   * Check if a value implements the `Location` interface.
	   */
	  isLocation: function isLocation(value) {
	    return Path.isPath(value) || Point.isPoint(value) || Range.isRange(value);
	  }
	};
	var Span = {
	  /**
	   * Check if a value implements the `Span` interface.
	   */
	  isSpan: function isSpan(value) {
	    return Array.isArray(value) && value.length === 2 && value.every(Path.isPath);
	  }
	};
	var _excluded$3 = ["children"],
	  _excluded2$2 = ["text"];
	function _createForOfIteratorHelper$4(o, allowArrayLike) {
	  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
	  if (!it) {
	    if (Array.isArray(o) || (it = _unsupportedIterableToArray$4(o)) || allowArrayLike && o && typeof o.length === "number") {
	      if (it) o = it;
	      var i = 0;
	      var F = function F() {};
	      return {
	        s: F,
	        n: function n() {
	          if (i >= o.length) return {
	            done: true
	          };
	          return {
	            done: false,
	            value: o[i++]
	          };
	        },
	        e: function e(_e) {
	          throw _e;
	        },
	        f: F
	      };
	    }
	    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	  }
	  var normalCompletion = true,
	    didErr = false,
	    err;
	  return {
	    s: function s() {
	      it = it.call(o);
	    },
	    n: function n() {
	      var step = it.next();
	      normalCompletion = step.done;
	      return step;
	    },
	    e: function e(_e2) {
	      didErr = true;
	      err = _e2;
	    },
	    f: function f() {
	      try {
	        if (!normalCompletion && it["return"] != null) it["return"]();
	      } finally {
	        if (didErr) throw err;
	      }
	    }
	  };
	}
	function _unsupportedIterableToArray$4(o, minLen) {
	  if (!o) return;
	  if (typeof o === "string") return _arrayLikeToArray$4(o, minLen);
	  var n = Object.prototype.toString.call(o).slice(8, -1);
	  if (n === "Object" && o.constructor) n = o.constructor.name;
	  if (n === "Map" || n === "Set") return Array.from(o);
	  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$4(o, minLen);
	}
	function _arrayLikeToArray$4(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;
	  for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }
	  return arr2;
	}
	var IS_NODE_LIST_CACHE = new WeakMap();
	var Node = {
	  /**
	   * Get the node at a specific path, asserting that it's an ancestor node.
	   */
	  ancestor: function ancestor(root, path) {
	    var node = Node.get(root, path);
	    if (Text.isText(node)) {
	      throw new Error("Cannot get the ancestor node at path [".concat(path, "] because it refers to a text node instead: ").concat(node));
	    }
	    return node;
	  },
	  /**
	   * Return a generator of all the ancestor nodes above a specific path.
	   *
	   * By default the order is bottom-up, from lowest to highest ancestor in
	   * the tree, but you can pass the `reverse: true` option to go top-down.
	   */
	  ancestors: /*#__PURE__*/_regeneratorRuntime().mark(function ancestors(root, path) {
	    var options,
	      _iterator,
	      _step,
	      p,
	      n,
	      entry,
	      _args5 = arguments;
	    return _regeneratorRuntime().wrap(function ancestors$(_context5) {
	      while (1) switch (_context5.prev = _context5.next) {
	        case 0:
	          options = _args5.length > 2 && _args5[2] !== undefined ? _args5[2] : {};
	          _iterator = _createForOfIteratorHelper$4(Path.ancestors(path, options));
	          _context5.prev = 2;
	          _iterator.s();
	        case 4:
	          if ((_step = _iterator.n()).done) {
	            _context5.next = 12;
	            break;
	          }
	          p = _step.value;
	          n = Node.ancestor(root, p);
	          entry = [n, p];
	          _context5.next = 10;
	          return entry;
	        case 10:
	          _context5.next = 4;
	          break;
	        case 12:
	          _context5.next = 17;
	          break;
	        case 14:
	          _context5.prev = 14;
	          _context5.t0 = _context5["catch"](2);
	          _iterator.e(_context5.t0);
	        case 17:
	          _context5.prev = 17;
	          _iterator.f();
	          return _context5.finish(17);
	        case 20:
	        case "end":
	          return _context5.stop();
	      }
	    }, ancestors, null, [[2, 14, 17, 20]]);
	  }),
	  /**
	   * Get the child of a node at a specific index.
	   */
	  child: function child(root, index) {
	    if (Text.isText(root)) {
	      throw new Error("Cannot get the child of a text node: ".concat(JSON.stringify(root)));
	    }
	    var c = root.children[index];
	    if (c == null) {
	      throw new Error("Cannot get child at index `".concat(index, "` in node: ").concat(JSON.stringify(root)));
	    }
	    return c;
	  },
	  /**
	   * Iterate over the children of a node at a specific path.
	   */
	  children: /*#__PURE__*/_regeneratorRuntime().mark(function children(root, path) {
	    var options,
	      _options$reverse,
	      reverse,
	      ancestor,
	      children,
	      index,
	      child,
	      childPath,
	      _args6 = arguments;
	    return _regeneratorRuntime().wrap(function children$(_context6) {
	      while (1) switch (_context6.prev = _context6.next) {
	        case 0:
	          options = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
	          _options$reverse = options.reverse, reverse = _options$reverse === void 0 ? false : _options$reverse;
	          ancestor = Node.ancestor(root, path);
	          children = ancestor.children;
	          index = reverse ? children.length - 1 : 0;
	        case 5:
	          if (!(reverse ? index >= 0 : index < children.length)) {
	            _context6.next = 13;
	            break;
	          }
	          child = Node.child(ancestor, index);
	          childPath = path.concat(index);
	          _context6.next = 10;
	          return [child, childPath];
	        case 10:
	          index = reverse ? index - 1 : index + 1;
	          _context6.next = 5;
	          break;
	        case 13:
	        case "end":
	          return _context6.stop();
	      }
	    }, children);
	  }),
	  /**
	   * Get an entry for the common ancesetor node of two paths.
	   */
	  common: function common(root, path, another) {
	    var p = Path.common(path, another);
	    var n = Node.get(root, p);
	    return [n, p];
	  },
	  /**
	   * Get the node at a specific path, asserting that it's a descendant node.
	   */
	  descendant: function descendant(root, path) {
	    var node = Node.get(root, path);
	    if (Editor.isEditor(node)) {
	      throw new Error("Cannot get the descendant node at path [".concat(path, "] because it refers to the root editor node instead: ").concat(node));
	    }
	    return node;
	  },
	  /**
	   * Return a generator of all the descendant node entries inside a root node.
	   */
	  descendants: /*#__PURE__*/_regeneratorRuntime().mark(function descendants(root) {
	    var options,
	      _iterator2,
	      _step2,
	      _step2$value,
	      node,
	      path,
	      _args7 = arguments;
	    return _regeneratorRuntime().wrap(function descendants$(_context7) {
	      while (1) switch (_context7.prev = _context7.next) {
	        case 0:
	          options = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : {};
	          _iterator2 = _createForOfIteratorHelper$4(Node.nodes(root, options));
	          _context7.prev = 2;
	          _iterator2.s();
	        case 4:
	          if ((_step2 = _iterator2.n()).done) {
	            _context7.next = 11;
	            break;
	          }
	          _step2$value = _slicedToArray(_step2.value, 2), node = _step2$value[0], path = _step2$value[1];
	          if (!(path.length !== 0)) {
	            _context7.next = 9;
	            break;
	          }
	          _context7.next = 9;
	          return [node, path];
	        case 9:
	          _context7.next = 4;
	          break;
	        case 11:
	          _context7.next = 16;
	          break;
	        case 13:
	          _context7.prev = 13;
	          _context7.t0 = _context7["catch"](2);
	          _iterator2.e(_context7.t0);
	        case 16:
	          _context7.prev = 16;
	          _iterator2.f();
	          return _context7.finish(16);
	        case 19:
	        case "end":
	          return _context7.stop();
	      }
	    }, descendants, null, [[2, 13, 16, 19]]);
	  }),
	  /**
	   * Return a generator of all the element nodes inside a root node. Each iteration
	   * will return an `ElementEntry` tuple consisting of `[Element, Path]`. If the
	   * root node is an element it will be included in the iteration as well.
	   */
	  elements: /*#__PURE__*/_regeneratorRuntime().mark(function elements(root) {
	    var options,
	      _iterator3,
	      _step3,
	      _step3$value,
	      node,
	      path,
	      _args8 = arguments;
	    return _regeneratorRuntime().wrap(function elements$(_context8) {
	      while (1) switch (_context8.prev = _context8.next) {
	        case 0:
	          options = _args8.length > 1 && _args8[1] !== undefined ? _args8[1] : {};
	          _iterator3 = _createForOfIteratorHelper$4(Node.nodes(root, options));
	          _context8.prev = 2;
	          _iterator3.s();
	        case 4:
	          if ((_step3 = _iterator3.n()).done) {
	            _context8.next = 11;
	            break;
	          }
	          _step3$value = _slicedToArray(_step3.value, 2), node = _step3$value[0], path = _step3$value[1];
	          if (!Element.isElement(node)) {
	            _context8.next = 9;
	            break;
	          }
	          _context8.next = 9;
	          return [node, path];
	        case 9:
	          _context8.next = 4;
	          break;
	        case 11:
	          _context8.next = 16;
	          break;
	        case 13:
	          _context8.prev = 13;
	          _context8.t0 = _context8["catch"](2);
	          _iterator3.e(_context8.t0);
	        case 16:
	          _context8.prev = 16;
	          _iterator3.f();
	          return _context8.finish(16);
	        case 19:
	        case "end":
	          return _context8.stop();
	      }
	    }, elements, null, [[2, 13, 16, 19]]);
	  }),
	  /**
	   * Extract props from a Node.
	   */
	  extractProps: function extractProps(node) {
	    if (Element.isAncestor(node)) {
	      node.children;
	      var properties = _objectWithoutProperties(node, _excluded$3);
	      return properties;
	    } else {
	      node.text;
	      var _properties = _objectWithoutProperties(node, _excluded2$2);
	      return _properties;
	    }
	  },
	  /**
	   * Get the first node entry in a root node from a path.
	   */
	  first: function first(root, path) {
	    var p = path.slice();
	    var n = Node.get(root, p);
	    while (n) {
	      if (Text.isText(n) || n.children.length === 0) {
	        break;
	      } else {
	        n = n.children[0];
	        p.push(0);
	      }
	    }
	    return [n, p];
	  },
	  /**
	   * Get the sliced fragment represented by a range inside a root node.
	   */
	  fragment: function fragment(root, range) {
	    if (Text.isText(root)) {
	      throw new Error("Cannot get a fragment starting from a root text node: ".concat(JSON.stringify(root)));
	    }
	    var newRoot = immer.produce({
	      children: root.children
	    }, function (r) {
	      var _Range$edges = Range.edges(range),
	        _Range$edges2 = _slicedToArray(_Range$edges, 2),
	        start = _Range$edges2[0],
	        end = _Range$edges2[1];
	      var nodeEntries = Node.nodes(r, {
	        reverse: true,
	        pass: function pass(_ref) {
	          var _ref2 = _slicedToArray(_ref, 2),
	            path = _ref2[1];
	          return !Range.includes(range, path);
	        }
	      });
	      var _iterator4 = _createForOfIteratorHelper$4(nodeEntries),
	        _step4;
	      try {
	        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
	          var _step4$value = _slicedToArray(_step4.value, 2),
	            path = _step4$value[1];
	          if (!Range.includes(range, path)) {
	            var parent = Node.parent(r, path);
	            var index = path[path.length - 1];
	            parent.children.splice(index, 1);
	          }
	          if (Path.equals(path, end.path)) {
	            var leaf = Node.leaf(r, path);
	            leaf.text = leaf.text.slice(0, end.offset);
	          }
	          if (Path.equals(path, start.path)) {
	            var _leaf = Node.leaf(r, path);
	            _leaf.text = _leaf.text.slice(start.offset);
	          }
	        }
	      } catch (err) {
	        _iterator4.e(err);
	      } finally {
	        _iterator4.f();
	      }
	      if (Editor.isEditor(r)) {
	        r.selection = null;
	      }
	    });
	    return newRoot.children;
	  },
	  /**
	   * Get the descendant node referred to by a specific path. If the path is an
	   * empty array, it refers to the root node itself.
	   */
	  get: function get(root, path) {
	    var node = root;
	    for (var i = 0; i < path.length; i++) {
	      var p = path[i];
	      if (Text.isText(node) || !node.children[p]) {
	        throw new Error("Cannot find a descendant at path [".concat(path, "] in node: ").concat(JSON.stringify(root)));
	      }
	      node = node.children[p];
	    }
	    return node;
	  },
	  /**
	   * Check if a descendant node exists at a specific path.
	   */
	  has: function has(root, path) {
	    var node = root;
	    for (var i = 0; i < path.length; i++) {
	      var p = path[i];
	      if (Text.isText(node) || !node.children[p]) {
	        return false;
	      }
	      node = node.children[p];
	    }
	    return true;
	  },
	  /**
	   * Check if a value implements the `Node` interface.
	   */
	  isNode: function isNode(value) {
	    return Text.isText(value) || Element.isElement(value) || Editor.isEditor(value);
	  },
	  /**
	   * Check if a value is a list of `Node` objects.
	   */
	  isNodeList: function isNodeList(value) {
	    if (!Array.isArray(value)) {
	      return false;
	    }
	    var cachedResult = IS_NODE_LIST_CACHE.get(value);
	    if (cachedResult !== undefined) {
	      return cachedResult;
	    }
	    var isNodeList = value.every(function (val) {
	      return Node.isNode(val);
	    });
	    IS_NODE_LIST_CACHE.set(value, isNodeList);
	    return isNodeList;
	  },
	  /**
	   * Get the last node entry in a root node from a path.
	   */
	  last: function last(root, path) {
	    var p = path.slice();
	    var n = Node.get(root, p);
	    while (n) {
	      if (Text.isText(n) || n.children.length === 0) {
	        break;
	      } else {
	        var i = n.children.length - 1;
	        n = n.children[i];
	        p.push(i);
	      }
	    }
	    return [n, p];
	  },
	  /**
	   * Get the node at a specific path, ensuring it's a leaf text node.
	   */
	  leaf: function leaf(root, path) {
	    var node = Node.get(root, path);
	    if (!Text.isText(node)) {
	      throw new Error("Cannot get the leaf node at path [".concat(path, "] because it refers to a non-leaf node: ").concat(node));
	    }
	    return node;
	  },
	  /**
	   * Return a generator of the in a branch of the tree, from a specific path.
	   *
	   * By default the order is top-down, from lowest to highest node in the tree,
	   * but you can pass the `reverse: true` option to go bottom-up.
	   */
	  levels: /*#__PURE__*/_regeneratorRuntime().mark(function levels(root, path) {
	    var options,
	      _iterator5,
	      _step5,
	      p,
	      n,
	      _args9 = arguments;
	    return _regeneratorRuntime().wrap(function levels$(_context9) {
	      while (1) switch (_context9.prev = _context9.next) {
	        case 0:
	          options = _args9.length > 2 && _args9[2] !== undefined ? _args9[2] : {};
	          _iterator5 = _createForOfIteratorHelper$4(Path.levels(path, options));
	          _context9.prev = 2;
	          _iterator5.s();
	        case 4:
	          if ((_step5 = _iterator5.n()).done) {
	            _context9.next = 11;
	            break;
	          }
	          p = _step5.value;
	          n = Node.get(root, p);
	          _context9.next = 9;
	          return [n, p];
	        case 9:
	          _context9.next = 4;
	          break;
	        case 11:
	          _context9.next = 16;
	          break;
	        case 13:
	          _context9.prev = 13;
	          _context9.t0 = _context9["catch"](2);
	          _iterator5.e(_context9.t0);
	        case 16:
	          _context9.prev = 16;
	          _iterator5.f();
	          return _context9.finish(16);
	        case 19:
	        case "end":
	          return _context9.stop();
	      }
	    }, levels, null, [[2, 13, 16, 19]]);
	  }),
	  /**
	   * Check if a node matches a set of props.
	   */
	  matches: function matches(node, props) {
	    return Element.isElement(node) && Element.isElementProps(props) && Element.matches(node, props) || Text.isText(node) && Text.isTextProps(props) && Text.matches(node, props);
	  },
	  /**
	   * Return a generator of all the node entries of a root node. Each entry is
	   * returned as a `[Node, Path]` tuple, with the path referring to the node's
	   * position inside the root node.
	   */
	  nodes: /*#__PURE__*/_regeneratorRuntime().mark(function nodes(root) {
	    var options,
	      pass,
	      _options$reverse2,
	      reverse,
	      _options$from,
	      from,
	      to,
	      visited,
	      p,
	      n,
	      nextIndex,
	      newPath,
	      _newPath,
	      _args10 = arguments;
	    return _regeneratorRuntime().wrap(function nodes$(_context10) {
	      while (1) switch (_context10.prev = _context10.next) {
	        case 0:
	          options = _args10.length > 1 && _args10[1] !== undefined ? _args10[1] : {};
	          pass = options.pass, _options$reverse2 = options.reverse, reverse = _options$reverse2 === void 0 ? false : _options$reverse2;
	          _options$from = options.from, from = _options$from === void 0 ? [] : _options$from, to = options.to;
	          visited = new Set();
	          p = [];
	          n = root;
	        case 6:
	          if (false) {
	            _context10.next = 37;
	            break;
	          }
	          if (!(to && (reverse ? Path.isBefore(p, to) : Path.isAfter(p, to)))) {
	            _context10.next = 9;
	            break;
	          }
	          return _context10.abrupt("break", 37);
	        case 9:
	          if (visited.has(n)) {
	            _context10.next = 12;
	            break;
	          }
	          _context10.next = 12;
	          return [n, p];
	        case 12:
	          if (!(!visited.has(n) && !Text.isText(n) && n.children.length !== 0 && (pass == null || pass([n, p]) === false))) {
	            _context10.next = 19;
	            break;
	          }
	          visited.add(n);
	          nextIndex = reverse ? n.children.length - 1 : 0;
	          if (Path.isAncestor(p, from)) {
	            nextIndex = from[p.length];
	          }
	          p = p.concat(nextIndex);
	          n = Node.get(root, p);
	          return _context10.abrupt("continue", 6);
	        case 19:
	          if (!(p.length === 0)) {
	            _context10.next = 21;
	            break;
	          }
	          return _context10.abrupt("break", 37);
	        case 21:
	          if (reverse) {
	            _context10.next = 27;
	            break;
	          }
	          newPath = Path.next(p);
	          if (!Node.has(root, newPath)) {
	            _context10.next = 27;
	            break;
	          }
	          p = newPath;
	          n = Node.get(root, p);
	          return _context10.abrupt("continue", 6);
	        case 27:
	          if (!(reverse && p[p.length - 1] !== 0)) {
	            _context10.next = 32;
	            break;
	          }
	          _newPath = Path.previous(p);
	          p = _newPath;
	          n = Node.get(root, p);
	          return _context10.abrupt("continue", 6);
	        case 32:
	          // Otherwise we're going upward...
	
	          p = Path.parent(p);
	          n = Node.get(root, p);
	          visited.add(n);
	          _context10.next = 6;
	          break;
	        case 37:
	        case "end":
	          return _context10.stop();
	      }
	    }, nodes);
	  }),
	  /**
	   * Get the parent of a node at a specific path.
	   */
	  parent: function parent(root, path) {
	    var parentPath = Path.parent(path);
	    var p = Node.get(root, parentPath);
	    if (Text.isText(p)) {
	      throw new Error("Cannot get the parent of path [".concat(path, "] because it does not exist in the root."));
	    }
	    return p;
	  },
	  /**
	   * Get the concatenated text string of a node's content.
	   *
	   * Note that this will not include spaces or line breaks between block nodes.
	   * It is not a user-facing string, but a string for performing offset-related
	   * computations for a node.
	   */
	  string: function string(node) {
	    if (Text.isText(node)) {
	      return node.text;
	    } else {
	      return node.children.map(Node.string).join('');
	    }
	  },
	  /**
	   * Return a generator of all leaf text nodes in a root node.
	   */
	  texts: /*#__PURE__*/_regeneratorRuntime().mark(function texts(root) {
	    var options,
	      _iterator6,
	      _step6,
	      _step6$value,
	      node,
	      path,
	      _args11 = arguments;
	    return _regeneratorRuntime().wrap(function texts$(_context11) {
	      while (1) switch (_context11.prev = _context11.next) {
	        case 0:
	          options = _args11.length > 1 && _args11[1] !== undefined ? _args11[1] : {};
	          _iterator6 = _createForOfIteratorHelper$4(Node.nodes(root, options));
	          _context11.prev = 2;
	          _iterator6.s();
	        case 4:
	          if ((_step6 = _iterator6.n()).done) {
	            _context11.next = 11;
	            break;
	          }
	          _step6$value = _slicedToArray(_step6.value, 2), node = _step6$value[0], path = _step6$value[1];
	          if (!Text.isText(node)) {
	            _context11.next = 9;
	            break;
	          }
	          _context11.next = 9;
	          return [node, path];
	        case 9:
	          _context11.next = 4;
	          break;
	        case 11:
	          _context11.next = 16;
	          break;
	        case 13:
	          _context11.prev = 13;
	          _context11.t0 = _context11["catch"](2);
	          _iterator6.e(_context11.t0);
	        case 16:
	          _context11.prev = 16;
	          _iterator6.f();
	          return _context11.finish(16);
	        case 19:
	        case "end":
	          return _context11.stop();
	      }
	    }, texts, null, [[2, 13, 16, 19]]);
	  })
	};
	function ownKeys$7(object, enumerableOnly) {
	  var keys = Object.keys(object);
	  if (Object.getOwnPropertySymbols) {
	    var symbols = Object.getOwnPropertySymbols(object);
	    if (enumerableOnly) {
	      symbols = symbols.filter(function (sym) {
	        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
	      });
	    }
	    keys.push.apply(keys, symbols);
	  }
	  return keys;
	}
	function _objectSpread$7(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? arguments[i] : {};
	    if (i % 2) {
	      ownKeys$7(Object(source), true).forEach(function (key) {
	        _defineProperty(target, key, source[key]);
	      });
	    } else if (Object.getOwnPropertyDescriptors) {
	      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
	    } else {
	      ownKeys$7(Object(source)).forEach(function (key) {
	        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
	      });
	    }
	  }
	  return target;
	}
	var Operation = {
	  /**
	   * Check of a value is a `NodeOperation` object.
	   */
	  isNodeOperation: function isNodeOperation(value) {
	    return Operation.isOperation(value) && value.type.endsWith('_node');
	  },
	  /**
	   * Check of a value is an `Operation` object.
	   */
	  isOperation: function isOperation(value) {
	    if (!isPlainObject.isPlainObject(value)) {
	      return false;
	    }
	    switch (value.type) {
	      case 'insert_node':
	        return Path.isPath(value.path) && Node.isNode(value.node);
	      case 'insert_text':
	        return typeof value.offset === 'number' && typeof value.text === 'string' && Path.isPath(value.path);
	      case 'merge_node':
	        return typeof value.position === 'number' && Path.isPath(value.path) && isPlainObject.isPlainObject(value.properties);
	      case 'move_node':
	        return Path.isPath(value.path) && Path.isPath(value.newPath);
	      case 'remove_node':
	        return Path.isPath(value.path) && Node.isNode(value.node);
	      case 'remove_text':
	        return typeof value.offset === 'number' && typeof value.text === 'string' && Path.isPath(value.path);
	      case 'set_node':
	        return Path.isPath(value.path) && isPlainObject.isPlainObject(value.properties) && isPlainObject.isPlainObject(value.newProperties);
	      case 'set_selection':
	        return value.properties === null && Range.isRange(value.newProperties) || value.newProperties === null && Range.isRange(value.properties) || isPlainObject.isPlainObject(value.properties) && isPlainObject.isPlainObject(value.newProperties);
	      case 'split_node':
	        return Path.isPath(value.path) && typeof value.position === 'number' && isPlainObject.isPlainObject(value.properties);
	      default:
	        return false;
	    }
	  },
	  /**
	   * Check if a value is a list of `Operation` objects.
	   */
	  isOperationList: function isOperationList(value) {
	    return Array.isArray(value) && value.every(function (val) {
	      return Operation.isOperation(val);
	    });
	  },
	  /**
	   * Check of a value is a `SelectionOperation` object.
	   */
	  isSelectionOperation: function isSelectionOperation(value) {
	    return Operation.isOperation(value) && value.type.endsWith('_selection');
	  },
	  /**
	   * Check of a value is a `TextOperation` object.
	   */
	  isTextOperation: function isTextOperation(value) {
	    return Operation.isOperation(value) && value.type.endsWith('_text');
	  },
	  /**
	   * Invert an operation, returning a new operation that will exactly undo the
	   * original when applied.
	   */
	  inverse: function inverse(op) {
	    switch (op.type) {
	      case 'insert_node':
	        {
	          return _objectSpread$7(_objectSpread$7({}, op), {}, {
	            type: 'remove_node'
	          });
	        }
	      case 'insert_text':
	        {
	          return _objectSpread$7(_objectSpread$7({}, op), {}, {
	            type: 'remove_text'
	          });
	        }
	      case 'merge_node':
	        {
	          return _objectSpread$7(_objectSpread$7({}, op), {}, {
	            type: 'split_node',
	            path: Path.previous(op.path)
	          });
	        }
	      case 'move_node':
	        {
	          var newPath = op.newPath,
	            path = op.path; // PERF: in this case the move operation is a no-op anyways.
	
	          if (Path.equals(newPath, path)) {
	            return op;
	          } // If the move happens completely within a single parent the path and
	          // newPath are stable with respect to each other.
	
	          if (Path.isSibling(path, newPath)) {
	            return _objectSpread$7(_objectSpread$7({}, op), {}, {
	              path: newPath,
	              newPath: path
	            });
	          } // If the move does not happen within a single parent it is possible
	          // for the move to impact the true path to the location where the node
	          // was removed from and where it was inserted. We have to adjust for this
	          // and find the original path. We can accomplish this (only in non-sibling)
	          // moves by looking at the impact of the move operation on the node
	          // after the original move path.
	
	          var inversePath = Path.transform(path, op);
	          var inverseNewPath = Path.transform(Path.next(path), op);
	          return _objectSpread$7(_objectSpread$7({}, op), {}, {
	            path: inversePath,
	            newPath: inverseNewPath
	          });
	        }
	      case 'remove_node':
	        {
	          return _objectSpread$7(_objectSpread$7({}, op), {}, {
	            type: 'insert_node'
	          });
	        }
	      case 'remove_text':
	        {
	          return _objectSpread$7(_objectSpread$7({}, op), {}, {
	            type: 'insert_text'
	          });
	        }
	      case 'set_node':
	        {
	          var properties = op.properties,
	            newProperties = op.newProperties;
	          return _objectSpread$7(_objectSpread$7({}, op), {}, {
	            properties: newProperties,
	            newProperties: properties
	          });
	        }
	      case 'set_selection':
	        {
	          var _properties = op.properties,
	            _newProperties = op.newProperties;
	          if (_properties == null) {
	            return _objectSpread$7(_objectSpread$7({}, op), {}, {
	              properties: _newProperties,
	              newProperties: null
	            });
	          } else if (_newProperties == null) {
	            return _objectSpread$7(_objectSpread$7({}, op), {}, {
	              properties: null,
	              newProperties: _properties
	            });
	          } else {
	            return _objectSpread$7(_objectSpread$7({}, op), {}, {
	              properties: _newProperties,
	              newProperties: _properties
	            });
	          }
	        }
	      case 'split_node':
	        {
	          return _objectSpread$7(_objectSpread$7({}, op), {}, {
	            type: 'merge_node',
	            path: Path.next(op.path)
	          });
	        }
	    }
	  }
	};
	var Path = {
	  /**
	   * Get a list of ancestor paths for a given path.
	   *
	   * The paths are sorted from deepest to shallowest ancestor. However, if the
	   * `reverse: true` option is passed, they are reversed.
	   */
	  ancestors: function ancestors(path) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var _options$reverse = options.reverse,
	      reverse = _options$reverse === void 0 ? false : _options$reverse;
	    var paths = Path.levels(path, options);
	    if (reverse) {
	      paths = paths.slice(1);
	    } else {
	      paths = paths.slice(0, -1);
	    }
	    return paths;
	  },
	  /**
	   * Get the common ancestor path of two paths.
	   */
	  common: function common(path, another) {
	    var common = [];
	    for (var i = 0; i < path.length && i < another.length; i++) {
	      var av = path[i];
	      var bv = another[i];
	      if (av !== bv) {
	        break;
	      }
	      common.push(av);
	    }
	    return common;
	  },
	  /**
	   * Compare a path to another, returning an integer indicating whether the path
	   * was before, at, or after the other.
	   *
	   * Note: Two paths of unequal length can still receive a `0` result if one is
	   * directly above or below the other. If you want exact matching, use
	   * [[Path.equals]] instead.
	   */
	  compare: function compare(path, another) {
	    var min = Math.min(path.length, another.length);
	    for (var i = 0; i < min; i++) {
	      if (path[i] < another[i]) return -1;
	      if (path[i] > another[i]) return 1;
	    }
	    return 0;
	  },
	  /**
	   * Check if a path ends after one of the indexes in another.
	   */
	  endsAfter: function endsAfter(path, another) {
	    var i = path.length - 1;
	    var as = path.slice(0, i);
	    var bs = another.slice(0, i);
	    var av = path[i];
	    var bv = another[i];
	    return Path.equals(as, bs) && av > bv;
	  },
	  /**
	   * Check if a path ends at one of the indexes in another.
	   */
	  endsAt: function endsAt(path, another) {
	    var i = path.length;
	    var as = path.slice(0, i);
	    var bs = another.slice(0, i);
	    return Path.equals(as, bs);
	  },
	  /**
	   * Check if a path ends before one of the indexes in another.
	   */
	  endsBefore: function endsBefore(path, another) {
	    var i = path.length - 1;
	    var as = path.slice(0, i);
	    var bs = another.slice(0, i);
	    var av = path[i];
	    var bv = another[i];
	    return Path.equals(as, bs) && av < bv;
	  },
	  /**
	   * Check if a path is exactly equal to another.
	   */
	  equals: function equals(path, another) {
	    return path.length === another.length && path.every(function (n, i) {
	      return n === another[i];
	    });
	  },
	  /**
	   * Check if the path of previous sibling node exists
	   */
	  hasPrevious: function hasPrevious(path) {
	    return path[path.length - 1] > 0;
	  },
	  /**
	   * Check if a path is after another.
	   */
	  isAfter: function isAfter(path, another) {
	    return Path.compare(path, another) === 1;
	  },
	  /**
	   * Check if a path is an ancestor of another.
	   */
	  isAncestor: function isAncestor(path, another) {
	    return path.length < another.length && Path.compare(path, another) === 0;
	  },
	  /**
	   * Check if a path is before another.
	   */
	  isBefore: function isBefore(path, another) {
	    return Path.compare(path, another) === -1;
	  },
	  /**
	   * Check if a path is a child of another.
	   */
	  isChild: function isChild(path, another) {
	    return path.length === another.length + 1 && Path.compare(path, another) === 0;
	  },
	  /**
	   * Check if a path is equal to or an ancestor of another.
	   */
	  isCommon: function isCommon(path, another) {
	    return path.length <= another.length && Path.compare(path, another) === 0;
	  },
	  /**
	   * Check if a path is a descendant of another.
	   */
	  isDescendant: function isDescendant(path, another) {
	    return path.length > another.length && Path.compare(path, another) === 0;
	  },
	  /**
	   * Check if a path is the parent of another.
	   */
	  isParent: function isParent(path, another) {
	    return path.length + 1 === another.length && Path.compare(path, another) === 0;
	  },
	  /**
	   * Check is a value implements the `Path` interface.
	   */
	  isPath: function isPath(value) {
	    return Array.isArray(value) && (value.length === 0 || typeof value[0] === 'number');
	  },
	  /**
	   * Check if a path is a sibling of another.
	   */
	  isSibling: function isSibling(path, another) {
	    if (path.length !== another.length) {
	      return false;
	    }
	    var as = path.slice(0, -1);
	    var bs = another.slice(0, -1);
	    var al = path[path.length - 1];
	    var bl = another[another.length - 1];
	    return al !== bl && Path.equals(as, bs);
	  },
	  /**
	   * Get a list of paths at every level down to a path. Note: this is the same
	   * as `Path.ancestors`, but including the path itself.
	   *
	   * The paths are sorted from shallowest to deepest. However, if the `reverse:
	   * true` option is passed, they are reversed.
	   */
	  levels: function levels(path) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var _options$reverse2 = options.reverse,
	      reverse = _options$reverse2 === void 0 ? false : _options$reverse2;
	    var list = [];
	    for (var i = 0; i <= path.length; i++) {
	      list.push(path.slice(0, i));
	    }
	    if (reverse) {
	      list.reverse();
	    }
	    return list;
	  },
	  /**
	   * Given a path, get the path to the next sibling node.
	   */
	  next: function next(path) {
	    if (path.length === 0) {
	      throw new Error("Cannot get the next path of a root path [".concat(path, "], because it has no next index."));
	    }
	    var last = path[path.length - 1];
	    return path.slice(0, -1).concat(last + 1);
	  },
	  /**
	   * Returns whether this operation can affect paths or not. Used as an
	   * optimization when updating dirty paths during normalization
	   *
	   * NOTE: This *must* be kept in sync with the implementation of 'transform'
	   * below
	   */
	  operationCanTransformPath: function operationCanTransformPath(operation) {
	    switch (operation.type) {
	      case 'insert_node':
	      case 'remove_node':
	      case 'merge_node':
	      case 'split_node':
	      case 'move_node':
	        return true;
	      default:
	        return false;
	    }
	  },
	  /**
	   * Given a path, return a new path referring to the parent node above it.
	   */
	  parent: function parent(path) {
	    if (path.length === 0) {
	      throw new Error("Cannot get the parent path of the root path [".concat(path, "]."));
	    }
	    return path.slice(0, -1);
	  },
	  /**
	   * Given a path, get the path to the previous sibling node.
	   */
	  previous: function previous(path) {
	    if (path.length === 0) {
	      throw new Error("Cannot get the previous path of a root path [".concat(path, "], because it has no previous index."));
	    }
	    var last = path[path.length - 1];
	    if (last <= 0) {
	      throw new Error("Cannot get the previous path of a first child path [".concat(path, "] because it would result in a negative index."));
	    }
	    return path.slice(0, -1).concat(last - 1);
	  },
	  /**
	   * Get a path relative to an ancestor.
	   */
	  relative: function relative(path, ancestor) {
	    if (!Path.isAncestor(ancestor, path) && !Path.equals(path, ancestor)) {
	      throw new Error("Cannot get the relative path of [".concat(path, "] inside ancestor [").concat(ancestor, "], because it is not above or equal to the path."));
	    }
	    return path.slice(ancestor.length);
	  },
	  /**
	   * Transform a path by an operation.
	   */
	  transform: function transform(path, operation) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    return immer.produce(path, function (p) {
	      var _options$affinity = options.affinity,
	        affinity = _options$affinity === void 0 ? 'forward' : _options$affinity; // PERF: Exit early if the operation is guaranteed not to have an effect.
	
	      if (!path || (path === null || path === void 0 ? void 0 : path.length) === 0) {
	        return;
	      }
	      if (p === null) {
	        return null;
	      }
	      switch (operation.type) {
	        case 'insert_node':
	          {
	            var op = operation.path;
	            if (Path.equals(op, p) || Path.endsBefore(op, p) || Path.isAncestor(op, p)) {
	              p[op.length - 1] += 1;
	            }
	            break;
	          }
	        case 'remove_node':
	          {
	            var _op = operation.path;
	            if (Path.equals(_op, p) || Path.isAncestor(_op, p)) {
	              return null;
	            } else if (Path.endsBefore(_op, p)) {
	              p[_op.length - 1] -= 1;
	            }
	            break;
	          }
	        case 'merge_node':
	          {
	            var _op2 = operation.path,
	              position = operation.position;
	            if (Path.equals(_op2, p) || Path.endsBefore(_op2, p)) {
	              p[_op2.length - 1] -= 1;
	            } else if (Path.isAncestor(_op2, p)) {
	              p[_op2.length - 1] -= 1;
	              p[_op2.length] += position;
	            }
	            break;
	          }
	        case 'split_node':
	          {
	            var _op3 = operation.path,
	              _position = operation.position;
	            if (Path.equals(_op3, p)) {
	              if (affinity === 'forward') {
	                p[p.length - 1] += 1;
	              } else if (affinity === 'backward') ;else {
	                return null;
	              }
	            } else if (Path.endsBefore(_op3, p)) {
	              p[_op3.length - 1] += 1;
	            } else if (Path.isAncestor(_op3, p) && path[_op3.length] >= _position) {
	              p[_op3.length - 1] += 1;
	              p[_op3.length] -= _position;
	            }
	            break;
	          }
	        case 'move_node':
	          {
	            var _op4 = operation.path,
	              onp = operation.newPath; // If the old and new path are the same, it's a no-op.
	
	            if (Path.equals(_op4, onp)) {
	              return;
	            }
	            if (Path.isAncestor(_op4, p) || Path.equals(_op4, p)) {
	              var copy = onp.slice();
	              if (Path.endsBefore(_op4, onp) && _op4.length < onp.length) {
	                copy[_op4.length - 1] -= 1;
	              }
	              return copy.concat(p.slice(_op4.length));
	            } else if (Path.isSibling(_op4, onp) && (Path.isAncestor(onp, p) || Path.equals(onp, p))) {
	              if (Path.endsBefore(_op4, p)) {
	                p[_op4.length - 1] -= 1;
	              } else {
	                p[_op4.length - 1] += 1;
	              }
	            } else if (Path.endsBefore(onp, p) || Path.equals(onp, p) || Path.isAncestor(onp, p)) {
	              if (Path.endsBefore(_op4, p)) {
	                p[_op4.length - 1] -= 1;
	              }
	              p[onp.length - 1] += 1;
	            } else if (Path.endsBefore(_op4, p)) {
	              if (Path.equals(onp, p)) {
	                p[onp.length - 1] += 1;
	              }
	              p[_op4.length - 1] -= 1;
	            }
	            break;
	          }
	      }
	    });
	  }
	};
	var PathRef = {
	  /**
	   * Transform the path ref's current value by an operation.
	   */
	  transform: function transform(ref, op) {
	    var current = ref.current,
	      affinity = ref.affinity;
	    if (current == null) {
	      return;
	    }
	    var path = Path.transform(current, op, {
	      affinity: affinity
	    });
	    ref.current = path;
	    if (path == null) {
	      ref.unref();
	    }
	  }
	};
	function ownKeys$6(object, enumerableOnly) {
	  var keys = Object.keys(object);
	  if (Object.getOwnPropertySymbols) {
	    var symbols = Object.getOwnPropertySymbols(object);
	    if (enumerableOnly) {
	      symbols = symbols.filter(function (sym) {
	        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
	      });
	    }
	    keys.push.apply(keys, symbols);
	  }
	  return keys;
	}
	function _objectSpread$6(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? arguments[i] : {};
	    if (i % 2) {
	      ownKeys$6(Object(source), true).forEach(function (key) {
	        _defineProperty(target, key, source[key]);
	      });
	    } else if (Object.getOwnPropertyDescriptors) {
	      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
	    } else {
	      ownKeys$6(Object(source)).forEach(function (key) {
	        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
	      });
	    }
	  }
	  return target;
	}
	var Point = {
	  /**
	   * Compare a point to another, returning an integer indicating whether the
	   * point was before, at, or after the other.
	   */
	  compare: function compare(point, another) {
	    var result = Path.compare(point.path, another.path);
	    if (result === 0) {
	      if (point.offset < another.offset) return -1;
	      if (point.offset > another.offset) return 1;
	      return 0;
	    }
	    return result;
	  },
	  /**
	   * Check if a point is after another.
	   */
	  isAfter: function isAfter(point, another) {
	    return Point.compare(point, another) === 1;
	  },
	  /**
	   * Check if a point is before another.
	   */
	  isBefore: function isBefore(point, another) {
	    return Point.compare(point, another) === -1;
	  },
	  /**
	   * Check if a point is exactly equal to another.
	   */
	  equals: function equals(point, another) {
	    // PERF: ensure the offsets are equal first since they are cheaper to check.
	    return point.offset === another.offset && Path.equals(point.path, another.path);
	  },
	  /**
	   * Check if a value implements the `Point` interface.
	   */
	  isPoint: function isPoint(value) {
	    return isPlainObject.isPlainObject(value) && typeof value.offset === 'number' && Path.isPath(value.path);
	  },
	  /**
	   * Transform a point by an operation.
	   */
	  transform: function transform(point, op) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    return immer.produce(point, function (p) {
	      if (p === null) {
	        return null;
	      }
	      var _options$affinity = options.affinity,
	        affinity = _options$affinity === void 0 ? 'forward' : _options$affinity;
	      var path = p.path,
	        offset = p.offset;
	      switch (op.type) {
	        case 'insert_node':
	        case 'move_node':
	          {
	            p.path = Path.transform(path, op, options);
	            break;
	          }
	        case 'insert_text':
	          {
	            if (Path.equals(op.path, path) && (op.offset < offset || op.offset === offset && affinity === 'forward')) {
	              p.offset += op.text.length;
	            }
	            break;
	          }
	        case 'merge_node':
	          {
	            if (Path.equals(op.path, path)) {
	              p.offset += op.position;
	            }
	            p.path = Path.transform(path, op, options);
	            break;
	          }
	        case 'remove_text':
	          {
	            if (Path.equals(op.path, path) && op.offset <= offset) {
	              p.offset -= Math.min(offset - op.offset, op.text.length);
	            }
	            break;
	          }
	        case 'remove_node':
	          {
	            if (Path.equals(op.path, path) || Path.isAncestor(op.path, path)) {
	              return null;
	            }
	            p.path = Path.transform(path, op, options);
	            break;
	          }
	        case 'split_node':
	          {
	            if (Path.equals(op.path, path)) {
	              if (op.position === offset && affinity == null) {
	                return null;
	              } else if (op.position < offset || op.position === offset && affinity === 'forward') {
	                p.offset -= op.position;
	                p.path = Path.transform(path, op, _objectSpread$6(_objectSpread$6({}, options), {}, {
	                  affinity: 'forward'
	                }));
	              }
	            } else {
	              p.path = Path.transform(path, op, options);
	            }
	            break;
	          }
	      }
	    });
	  }
	};
	var PointRef = {
	  /**
	   * Transform the point ref's current value by an operation.
	   */
	  transform: function transform(ref, op) {
	    var current = ref.current,
	      affinity = ref.affinity;
	    if (current == null) {
	      return;
	    }
	    var point = Point.transform(current, op, {
	      affinity: affinity
	    });
	    ref.current = point;
	    if (point == null) {
	      ref.unref();
	    }
	  }
	};
	var _excluded$2 = ["anchor", "focus"];
	function ownKeys$5(object, enumerableOnly) {
	  var keys = Object.keys(object);
	  if (Object.getOwnPropertySymbols) {
	    var symbols = Object.getOwnPropertySymbols(object);
	    if (enumerableOnly) {
	      symbols = symbols.filter(function (sym) {
	        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
	      });
	    }
	    keys.push.apply(keys, symbols);
	  }
	  return keys;
	}
	function _objectSpread$5(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? arguments[i] : {};
	    if (i % 2) {
	      ownKeys$5(Object(source), true).forEach(function (key) {
	        _defineProperty(target, key, source[key]);
	      });
	    } else if (Object.getOwnPropertyDescriptors) {
	      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
	    } else {
	      ownKeys$5(Object(source)).forEach(function (key) {
	        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
	      });
	    }
	  }
	  return target;
	}
	var Range = {
	  /**
	   * Get the start and end points of a range, in the order in which they appear
	   * in the document.
	   */
	  edges: function edges(range) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var _options$reverse = options.reverse,
	      reverse = _options$reverse === void 0 ? false : _options$reverse;
	    var anchor = range.anchor,
	      focus = range.focus;
	    return Range.isBackward(range) === reverse ? [anchor, focus] : [focus, anchor];
	  },
	  /**
	   * Get the end point of a range.
	   */
	  end: function end(range) {
	    var _Range$edges = Range.edges(range),
	      _Range$edges2 = _slicedToArray(_Range$edges, 2),
	      end = _Range$edges2[1];
	    return end;
	  },
	  /**
	   * Check if a range is exactly equal to another.
	   */
	  equals: function equals(range, another) {
	    return Point.equals(range.anchor, another.anchor) && Point.equals(range.focus, another.focus);
	  },
	  /**
	   * Check if a range includes a path, a point or part of another range.
	   */
	  includes: function includes(range, target) {
	    if (Range.isRange(target)) {
	      if (Range.includes(range, target.anchor) || Range.includes(range, target.focus)) {
	        return true;
	      }
	      var _Range$edges3 = Range.edges(range),
	        _Range$edges4 = _slicedToArray(_Range$edges3, 2),
	        rs = _Range$edges4[0],
	        re = _Range$edges4[1];
	      var _Range$edges5 = Range.edges(target),
	        _Range$edges6 = _slicedToArray(_Range$edges5, 2),
	        ts = _Range$edges6[0],
	        te = _Range$edges6[1];
	      return Point.isBefore(rs, ts) && Point.isAfter(re, te);
	    }
	    var _Range$edges7 = Range.edges(range),
	      _Range$edges8 = _slicedToArray(_Range$edges7, 2),
	      start = _Range$edges8[0],
	      end = _Range$edges8[1];
	    var isAfterStart = false;
	    var isBeforeEnd = false;
	    if (Point.isPoint(target)) {
	      isAfterStart = Point.compare(target, start) >= 0;
	      isBeforeEnd = Point.compare(target, end) <= 0;
	    } else {
	      isAfterStart = Path.compare(target, start.path) >= 0;
	      isBeforeEnd = Path.compare(target, end.path) <= 0;
	    }
	    return isAfterStart && isBeforeEnd;
	  },
	  /**
	   * Get the intersection of a range with another.
	   */
	  intersection: function intersection(range, another) {
	    range.anchor;
	    range.focus;
	    var rest = _objectWithoutProperties(range, _excluded$2);
	    var _Range$edges9 = Range.edges(range),
	      _Range$edges10 = _slicedToArray(_Range$edges9, 2),
	      s1 = _Range$edges10[0],
	      e1 = _Range$edges10[1];
	    var _Range$edges11 = Range.edges(another),
	      _Range$edges12 = _slicedToArray(_Range$edges11, 2),
	      s2 = _Range$edges12[0],
	      e2 = _Range$edges12[1];
	    var start = Point.isBefore(s1, s2) ? s2 : s1;
	    var end = Point.isBefore(e1, e2) ? e1 : e2;
	    if (Point.isBefore(end, start)) {
	      return null;
	    } else {
	      return _objectSpread$5({
	        anchor: start,
	        focus: end
	      }, rest);
	    }
	  },
	  /**
	   * Check if a range is backward, meaning that its anchor point appears in the
	   * document _after_ its focus point.
	   */
	  isBackward: function isBackward(range) {
	    var anchor = range.anchor,
	      focus = range.focus;
	    return Point.isAfter(anchor, focus);
	  },
	  /**
	   * Check if a range is collapsed, meaning that both its anchor and focus
	   * points refer to the exact same position in the document.
	   */
	  isCollapsed: function isCollapsed(range) {
	    var anchor = range.anchor,
	      focus = range.focus;
	    return Point.equals(anchor, focus);
	  },
	  /**
	   * Check if a range is expanded.
	   *
	   * This is the opposite of [[Range.isCollapsed]] and is provided for legibility.
	   */
	  isExpanded: function isExpanded(range) {
	    return !Range.isCollapsed(range);
	  },
	  /**
	   * Check if a range is forward.
	   *
	   * This is the opposite of [[Range.isBackward]] and is provided for legibility.
	   */
	  isForward: function isForward(range) {
	    return !Range.isBackward(range);
	  },
	  /**
	   * Check if a value implements the [[Range]] interface.
	   */
	  isRange: function isRange(value) {
	    return isPlainObject.isPlainObject(value) && Point.isPoint(value.anchor) && Point.isPoint(value.focus);
	  },
	  /**
	   * Iterate through all of the point entries in a range.
	   */
	  points: /*#__PURE__*/_regeneratorRuntime().mark(function points(range) {
	    return _regeneratorRuntime().wrap(function points$(_context12) {
	      while (1) switch (_context12.prev = _context12.next) {
	        case 0:
	          _context12.next = 2;
	          return [range.anchor, 'anchor'];
	        case 2:
	          _context12.next = 4;
	          return [range.focus, 'focus'];
	        case 4:
	        case "end":
	          return _context12.stop();
	      }
	    }, points);
	  }),
	  /**
	   * Get the start point of a range.
	   */
	  start: function start(range) {
	    var _Range$edges13 = Range.edges(range),
	      _Range$edges14 = _slicedToArray(_Range$edges13, 1),
	      start = _Range$edges14[0];
	    return start;
	  },
	  /**
	   * Transform a range by an operation.
	   */
	  transform: function transform(range, op) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    return immer.produce(range, function (r) {
	      if (r === null) {
	        return null;
	      }
	      var _options$affinity = options.affinity,
	        affinity = _options$affinity === void 0 ? 'inward' : _options$affinity;
	      var affinityAnchor;
	      var affinityFocus;
	      if (affinity === 'inward') {
	        // If the range is collapsed, make sure to use the same affinity to
	        // avoid the two points passing each other and expanding in the opposite
	        // direction
	        var isCollapsed = Range.isCollapsed(r);
	        if (Range.isForward(r)) {
	          affinityAnchor = 'forward';
	          affinityFocus = isCollapsed ? affinityAnchor : 'backward';
	        } else {
	          affinityAnchor = 'backward';
	          affinityFocus = isCollapsed ? affinityAnchor : 'forward';
	        }
	      } else if (affinity === 'outward') {
	        if (Range.isForward(r)) {
	          affinityAnchor = 'backward';
	          affinityFocus = 'forward';
	        } else {
	          affinityAnchor = 'forward';
	          affinityFocus = 'backward';
	        }
	      } else {
	        affinityAnchor = affinity;
	        affinityFocus = affinity;
	      }
	      var anchor = Point.transform(r.anchor, op, {
	        affinity: affinityAnchor
	      });
	      var focus = Point.transform(r.focus, op, {
	        affinity: affinityFocus
	      });
	      if (!anchor || !focus) {
	        return null;
	      }
	      r.anchor = anchor;
	      r.focus = focus;
	    });
	  }
	};
	var RangeRef = {
	  /**
	   * Transform the range ref's current value by an operation.
	   */
	  transform: function transform(ref, op) {
	    var current = ref.current,
	      affinity = ref.affinity;
	    if (current == null) {
	      return;
	    }
	    var path = Range.transform(current, op, {
	      affinity: affinity
	    });
	    ref.current = path;
	    if (path == null) {
	      ref.unref();
	    }
	  }
	};
	
	/*
	  Custom deep equal comparison for Slate nodes.
	
	  We don't need general purpose deep equality;
	  Slate only supports plain values, Arrays, and nested objects.
	  Complex values nested inside Arrays are not supported.
	
	  Slate objects are designed to be serialised, so
	  missing keys are deliberately normalised to undefined.
	 */
	
	var isDeepEqual = function isDeepEqual(node, another) {
	  for (var key in node) {
	    var a = node[key];
	    var b = another[key];
	    if (isPlainObject.isPlainObject(a) && isPlainObject.isPlainObject(b)) {
	      if (!isDeepEqual(a, b)) return false;
	    } else if (Array.isArray(a) && Array.isArray(b)) {
	      if (a.length !== b.length) return false;
	      for (var i = 0; i < a.length; i++) {
	        if (a[i] !== b[i]) return false;
	      }
	    } else if (a !== b) {
	      return false;
	    }
	  }
	  /*
	    Deep object equality is only necessary in one direction; in the reverse direction
	    we are only looking for keys that are missing.
	    As above, undefined keys are normalised to missing.
	  */
	
	  for (var _key in another) {
	    if (node[_key] === undefined && another[_key] !== undefined) {
	      return false;
	    }
	  }
	  return true;
	};
	var _excluded$1 = ["text"],
	  _excluded2$1 = ["anchor", "focus"];
	function _createForOfIteratorHelper$3(o, allowArrayLike) {
	  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
	  if (!it) {
	    if (Array.isArray(o) || (it = _unsupportedIterableToArray$3(o)) || allowArrayLike && o && typeof o.length === "number") {
	      if (it) o = it;
	      var i = 0;
	      var F = function F() {};
	      return {
	        s: F,
	        n: function n() {
	          if (i >= o.length) return {
	            done: true
	          };
	          return {
	            done: false,
	            value: o[i++]
	          };
	        },
	        e: function e(_e) {
	          throw _e;
	        },
	        f: F
	      };
	    }
	    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	  }
	  var normalCompletion = true,
	    didErr = false,
	    err;
	  return {
	    s: function s() {
	      it = it.call(o);
	    },
	    n: function n() {
	      var step = it.next();
	      normalCompletion = step.done;
	      return step;
	    },
	    e: function e(_e2) {
	      didErr = true;
	      err = _e2;
	    },
	    f: function f() {
	      try {
	        if (!normalCompletion && it["return"] != null) it["return"]();
	      } finally {
	        if (didErr) throw err;
	      }
	    }
	  };
	}
	function _unsupportedIterableToArray$3(o, minLen) {
	  if (!o) return;
	  if (typeof o === "string") return _arrayLikeToArray$3(o, minLen);
	  var n = Object.prototype.toString.call(o).slice(8, -1);
	  if (n === "Object" && o.constructor) n = o.constructor.name;
	  if (n === "Map" || n === "Set") return Array.from(o);
	  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$3(o, minLen);
	}
	function _arrayLikeToArray$3(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;
	  for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }
	  return arr2;
	}
	function ownKeys$4(object, enumerableOnly) {
	  var keys = Object.keys(object);
	  if (Object.getOwnPropertySymbols) {
	    var symbols = Object.getOwnPropertySymbols(object);
	    if (enumerableOnly) {
	      symbols = symbols.filter(function (sym) {
	        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
	      });
	    }
	    keys.push.apply(keys, symbols);
	  }
	  return keys;
	}
	function _objectSpread$4(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? arguments[i] : {};
	    if (i % 2) {
	      ownKeys$4(Object(source), true).forEach(function (key) {
	        _defineProperty(target, key, source[key]);
	      });
	    } else if (Object.getOwnPropertyDescriptors) {
	      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
	    } else {
	      ownKeys$4(Object(source)).forEach(function (key) {
	        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
	      });
	    }
	  }
	  return target;
	}
	var Text = {
	  /**
	   * Check if two text nodes are equal.
	   *
	   * When loose is set, the text is not compared. This is
	   * used to check whether sibling text nodes can be merged.
	   */
	  equals: function equals(text, another) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var _options$loose = options.loose,
	      loose = _options$loose === void 0 ? false : _options$loose;
	    function omitText(obj) {
	      obj.text;
	      var rest = _objectWithoutProperties(obj, _excluded$1);
	      return rest;
	    }
	    return isDeepEqual(loose ? omitText(text) : text, loose ? omitText(another) : another);
	  },
	  /**
	   * Check if a value implements the `Text` interface.
	   */
	  isText: function isText(value) {
	    return isPlainObject.isPlainObject(value) && typeof value.text === 'string';
	  },
	  /**
	   * Check if a value is a list of `Text` objects.
	   */
	  isTextList: function isTextList(value) {
	    return Array.isArray(value) && value.every(function (val) {
	      return Text.isText(val);
	    });
	  },
	  /**
	   * Check if some props are a partial of Text.
	   */
	  isTextProps: function isTextProps(props) {
	    return props.text !== undefined;
	  },
	  /**
	   * Check if an text matches set of properties.
	   *
	   * Note: this is for matching custom properties, and it does not ensure that
	   * the `text` property are two nodes equal.
	   */
	  matches: function matches(text, props) {
	    for (var key in props) {
	      if (key === 'text') {
	        continue;
	      }
	      if (!text.hasOwnProperty(key) || text[key] !== props[key]) {
	        return false;
	      }
	    }
	    return true;
	  },
	  /**
	   * Get the leaves for a text node given decorations.
	   */
	  decorations: function decorations(node, _decorations) {
	    var leaves = [_objectSpread$4({}, node)];
	    var _iterator = _createForOfIteratorHelper$3(_decorations),
	      _step;
	    try {
	      for (_iterator.s(); !(_step = _iterator.n()).done;) {
	        var dec = _step.value;
	        var anchor = dec.anchor,
	          focus = dec.focus,
	          rest = _objectWithoutProperties(dec, _excluded2$1);
	        var _Range$edges = Range.edges(dec),
	          _Range$edges2 = _slicedToArray(_Range$edges, 2),
	          start = _Range$edges2[0],
	          end = _Range$edges2[1];
	        var next = [];
	        var o = 0;
	        var _iterator2 = _createForOfIteratorHelper$3(leaves),
	          _step2;
	        try {
	          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
	            var leaf = _step2.value;
	            var length = leaf.text.length;
	            var offset = o;
	            o += length; // If the range encompases the entire leaf, add the range.
	
	            if (start.offset <= offset && end.offset >= o) {
	              Object.assign(leaf, rest);
	              next.push(leaf);
	              continue;
	            } // If the range expanded and match the leaf, or starts after, or ends before it, continue.
	
	            if (start.offset !== end.offset && (start.offset === o || end.offset === offset) || start.offset > o || end.offset < offset || end.offset === offset && offset !== 0) {
	              next.push(leaf);
	              continue;
	            } // Otherwise we need to split the leaf, at the start, end, or both,
	            // and add the range to the middle intersecting section. Do the end
	            // split first since we don't need to update the offset that way.
	
	            var middle = leaf;
	            var before = void 0;
	            var after = void 0;
	            if (end.offset < o) {
	              var off = end.offset - offset;
	              after = _objectSpread$4(_objectSpread$4({}, middle), {}, {
	                text: middle.text.slice(off)
	              });
	              middle = _objectSpread$4(_objectSpread$4({}, middle), {}, {
	                text: middle.text.slice(0, off)
	              });
	            }
	            if (start.offset > offset) {
	              var _off = start.offset - offset;
	              before = _objectSpread$4(_objectSpread$4({}, middle), {}, {
	                text: middle.text.slice(0, _off)
	              });
	              middle = _objectSpread$4(_objectSpread$4({}, middle), {}, {
	                text: middle.text.slice(_off)
	              });
	            }
	            Object.assign(middle, rest);
	            if (before) {
	              next.push(before);
	            }
	            next.push(middle);
	            if (after) {
	              next.push(after);
	            }
	          }
	        } catch (err) {
	          _iterator2.e(err);
	        } finally {
	          _iterator2.f();
	        }
	        leaves = next;
	      }
	    } catch (err) {
	      _iterator.e(err);
	    } finally {
	      _iterator.f();
	    }
	    return leaves;
	  }
	};
	function ownKeys$3(object, enumerableOnly) {
	  var keys = Object.keys(object);
	  if (Object.getOwnPropertySymbols) {
	    var symbols = Object.getOwnPropertySymbols(object);
	    if (enumerableOnly) {
	      symbols = symbols.filter(function (sym) {
	        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
	      });
	    }
	    keys.push.apply(keys, symbols);
	  }
	  return keys;
	}
	function _objectSpread$3(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? arguments[i] : {};
	    if (i % 2) {
	      ownKeys$3(Object(source), true).forEach(function (key) {
	        _defineProperty(target, key, source[key]);
	      });
	    } else if (Object.getOwnPropertyDescriptors) {
	      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
	    } else {
	      ownKeys$3(Object(source)).forEach(function (key) {
	        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
	      });
	    }
	  }
	  return target;
	}
	function _createForOfIteratorHelper$2(o, allowArrayLike) {
	  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
	  if (!it) {
	    if (Array.isArray(o) || (it = _unsupportedIterableToArray$2(o)) || allowArrayLike && o && typeof o.length === "number") {
	      if (it) o = it;
	      var i = 0;
	      var F = function F() {};
	      return {
	        s: F,
	        n: function n() {
	          if (i >= o.length) return {
	            done: true
	          };
	          return {
	            done: false,
	            value: o[i++]
	          };
	        },
	        e: function e(_e) {
	          throw _e;
	        },
	        f: F
	      };
	    }
	    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	  }
	  var normalCompletion = true,
	    didErr = false,
	    err;
	  return {
	    s: function s() {
	      it = it.call(o);
	    },
	    n: function n() {
	      var step = it.next();
	      normalCompletion = step.done;
	      return step;
	    },
	    e: function e(_e2) {
	      didErr = true;
	      err = _e2;
	    },
	    f: function f() {
	      try {
	        if (!normalCompletion && it["return"] != null) it["return"]();
	      } finally {
	        if (didErr) throw err;
	      }
	    }
	  };
	}
	function _unsupportedIterableToArray$2(o, minLen) {
	  if (!o) return;
	  if (typeof o === "string") return _arrayLikeToArray$2(o, minLen);
	  var n = Object.prototype.toString.call(o).slice(8, -1);
	  if (n === "Object" && o.constructor) n = o.constructor.name;
	  if (n === "Map" || n === "Set") return Array.from(o);
	  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$2(o, minLen);
	}
	function _arrayLikeToArray$2(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;
	  for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }
	  return arr2;
	}
	var applyToDraft = function applyToDraft(editor, selection, op) {
	  switch (op.type) {
	    case 'insert_node':
	      {
	        var path = op.path,
	          node = op.node;
	        var parent = Node.parent(editor, path);
	        var index = path[path.length - 1];
	        if (index > parent.children.length) {
	          throw new Error("Cannot apply an \"insert_node\" operation at path [".concat(path, "] because the destination is past the end of the node."));
	        }
	        parent.children.splice(index, 0, node);
	        if (selection) {
	          var _iterator = _createForOfIteratorHelper$2(Range.points(selection)),
	            _step;
	          try {
	            for (_iterator.s(); !(_step = _iterator.n()).done;) {
	              var _step$value = _slicedToArray(_step.value, 2),
	                point = _step$value[0],
	                key = _step$value[1];
	              selection[key] = Point.transform(point, op);
	            }
	          } catch (err) {
	            _iterator.e(err);
	          } finally {
	            _iterator.f();
	          }
	        }
	        break;
	      }
	    case 'insert_text':
	      {
	        var _path = op.path,
	          offset = op.offset,
	          text = op.text;
	        if (text.length === 0) break;
	        var _node = Node.leaf(editor, _path);
	        var before = _node.text.slice(0, offset);
	        var after = _node.text.slice(offset);
	        _node.text = before + text + after;
	        if (selection) {
	          var _iterator2 = _createForOfIteratorHelper$2(Range.points(selection)),
	            _step2;
	          try {
	            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
	              var _step2$value = _slicedToArray(_step2.value, 2),
	                _point = _step2$value[0],
	                _key = _step2$value[1];
	              selection[_key] = Point.transform(_point, op);
	            }
	          } catch (err) {
	            _iterator2.e(err);
	          } finally {
	            _iterator2.f();
	          }
	        }
	        break;
	      }
	    case 'merge_node':
	      {
	        var _path2 = op.path;
	        var _node2 = Node.get(editor, _path2);
	        var prevPath = Path.previous(_path2);
	        var prev = Node.get(editor, prevPath);
	        var _parent = Node.parent(editor, _path2);
	        var _index = _path2[_path2.length - 1];
	        if (Text.isText(_node2) && Text.isText(prev)) {
	          prev.text += _node2.text;
	        } else if (!Text.isText(_node2) && !Text.isText(prev)) {
	          var _prev$children;
	          (_prev$children = prev.children).push.apply(_prev$children, _toConsumableArray(_node2.children));
	        } else {
	          throw new Error("Cannot apply a \"merge_node\" operation at path [".concat(_path2, "] to nodes of different interfaces: ").concat(_node2, " ").concat(prev));
	        }
	        _parent.children.splice(_index, 1);
	        if (selection) {
	          var _iterator3 = _createForOfIteratorHelper$2(Range.points(selection)),
	            _step3;
	          try {
	            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
	              var _step3$value = _slicedToArray(_step3.value, 2),
	                _point2 = _step3$value[0],
	                _key2 = _step3$value[1];
	              selection[_key2] = Point.transform(_point2, op);
	            }
	          } catch (err) {
	            _iterator3.e(err);
	          } finally {
	            _iterator3.f();
	          }
	        }
	        break;
	      }
	    case 'move_node':
	      {
	        var _path3 = op.path,
	          newPath = op.newPath;
	        if (Path.isAncestor(_path3, newPath)) {
	          throw new Error("Cannot move a path [".concat(_path3, "] to new path [").concat(newPath, "] because the destination is inside itself."));
	        }
	        var _node3 = Node.get(editor, _path3);
	        var _parent2 = Node.parent(editor, _path3);
	        var _index2 = _path3[_path3.length - 1]; // This is tricky, but since the `path` and `newPath` both refer to
	        // the same snapshot in time, there's a mismatch. After either
	        // removing the original position, the second step's path can be out
	        // of date. So instead of using the `op.newPath` directly, we
	        // transform `op.path` to ascertain what the `newPath` would be after
	        // the operation was applied.
	
	        _parent2.children.splice(_index2, 1);
	        var truePath = Path.transform(_path3, op);
	        var newParent = Node.get(editor, Path.parent(truePath));
	        var newIndex = truePath[truePath.length - 1];
	        newParent.children.splice(newIndex, 0, _node3);
	        if (selection) {
	          var _iterator4 = _createForOfIteratorHelper$2(Range.points(selection)),
	            _step4;
	          try {
	            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
	              var _step4$value = _slicedToArray(_step4.value, 2),
	                _point3 = _step4$value[0],
	                _key3 = _step4$value[1];
	              selection[_key3] = Point.transform(_point3, op);
	            }
	          } catch (err) {
	            _iterator4.e(err);
	          } finally {
	            _iterator4.f();
	          }
	        }
	        break;
	      }
	    case 'remove_node':
	      {
	        var _path4 = op.path;
	        var _index3 = _path4[_path4.length - 1];
	        var _parent3 = Node.parent(editor, _path4);
	        _parent3.children.splice(_index3, 1); // Transform all of the points in the value, but if the point was in the
	        // node that was removed we need to update the range or remove it.
	
	        if (selection) {
	          var _iterator5 = _createForOfIteratorHelper$2(Range.points(selection)),
	            _step5;
	          try {
	            for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
	              var _step5$value = _slicedToArray(_step5.value, 2),
	                _point4 = _step5$value[0],
	                _key4 = _step5$value[1];
	              var result = Point.transform(_point4, op);
	              if (selection != null && result != null) {
	                selection[_key4] = result;
	              } else {
	                var _prev = void 0;
	                var next = void 0;
	                var _iterator6 = _createForOfIteratorHelper$2(Node.texts(editor)),
	                  _step6;
	                try {
	                  for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
	                    var _step6$value = _slicedToArray(_step6.value, 2),
	                      n = _step6$value[0],
	                      p = _step6$value[1];
	                    if (Path.compare(p, _path4) === -1) {
	                      _prev = [n, p];
	                    } else {
	                      next = [n, p];
	                      break;
	                    }
	                  }
	                } catch (err) {
	                  _iterator6.e(err);
	                } finally {
	                  _iterator6.f();
	                }
	                var preferNext = false;
	                if (_prev && next) {
	                  if (Path.equals(next[1], _path4)) {
	                    preferNext = !Path.hasPrevious(next[1]);
	                  } else {
	                    preferNext = Path.common(_prev[1], _path4).length < Path.common(next[1], _path4).length;
	                  }
	                }
	                if (_prev && !preferNext) {
	                  _point4.path = _prev[1];
	                  _point4.offset = _prev[0].text.length;
	                } else if (next) {
	                  _point4.path = next[1];
	                  _point4.offset = 0;
	                } else {
	                  selection = null;
	                }
	              }
	            }
	          } catch (err) {
	            _iterator5.e(err);
	          } finally {
	            _iterator5.f();
	          }
	        }
	        break;
	      }
	    case 'remove_text':
	      {
	        var _path5 = op.path,
	          _offset = op.offset,
	          _text = op.text;
	        if (_text.length === 0) break;
	        var _node4 = Node.leaf(editor, _path5);
	        var _before = _node4.text.slice(0, _offset);
	        var _after = _node4.text.slice(_offset + _text.length);
	        _node4.text = _before + _after;
	        if (selection) {
	          var _iterator7 = _createForOfIteratorHelper$2(Range.points(selection)),
	            _step7;
	          try {
	            for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
	              var _step7$value = _slicedToArray(_step7.value, 2),
	                _point5 = _step7$value[0],
	                _key5 = _step7$value[1];
	              selection[_key5] = Point.transform(_point5, op);
	            }
	          } catch (err) {
	            _iterator7.e(err);
	          } finally {
	            _iterator7.f();
	          }
	        }
	        break;
	      }
	    case 'set_node':
	      {
	        var _path6 = op.path,
	          properties = op.properties,
	          newProperties = op.newProperties;
	        if (_path6.length === 0) {
	          throw new Error("Cannot set properties on the root node!");
	        }
	        var _node5 = Node.get(editor, _path6);
	        for (var _key6 in newProperties) {
	          if (_key6 === 'children' || _key6 === 'text') {
	            throw new Error("Cannot set the \"".concat(_key6, "\" property of nodes!"));
	          }
	          var value = newProperties[_key6];
	          if (value == null) {
	            delete _node5[_key6];
	          } else {
	            _node5[_key6] = value;
	          }
	        } // properties that were previously defined, but are now missing, must be deleted
	
	        for (var _key7 in properties) {
	          if (!newProperties.hasOwnProperty(_key7)) {
	            delete _node5[_key7];
	          }
	        }
	        break;
	      }
	    case 'set_selection':
	      {
	        var _newProperties = op.newProperties;
	        if (_newProperties == null) {
	          selection = _newProperties;
	        } else {
	          if (selection == null) {
	            if (!Range.isRange(_newProperties)) {
	              throw new Error("Cannot apply an incomplete \"set_selection\" operation properties ".concat(JSON.stringify(_newProperties), " when there is no current selection."));
	            }
	            selection = _objectSpread$3({}, _newProperties);
	          }
	          for (var _key8 in _newProperties) {
	            var _value = _newProperties[_key8];
	            if (_value == null) {
	              if (_key8 === 'anchor' || _key8 === 'focus') {
	                throw new Error("Cannot remove the \"".concat(_key8, "\" selection property"));
	              }
	              delete selection[_key8];
	            } else {
	              selection[_key8] = _value;
	            }
	          }
	        }
	        break;
	      }
	    case 'split_node':
	      {
	        var _path7 = op.path,
	          position = op.position,
	          _properties = op.properties;
	        if (_path7.length === 0) {
	          throw new Error("Cannot apply a \"split_node\" operation at path [".concat(_path7, "] because the root node cannot be split."));
	        }
	        var _node6 = Node.get(editor, _path7);
	        var _parent4 = Node.parent(editor, _path7);
	        var _index4 = _path7[_path7.length - 1];
	        var newNode;
	        if (Text.isText(_node6)) {
	          var _before2 = _node6.text.slice(0, position);
	          var _after2 = _node6.text.slice(position);
	          _node6.text = _before2;
	          newNode = _objectSpread$3(_objectSpread$3({}, _properties), {}, {
	            text: _after2
	          });
	        } else {
	          var _before3 = _node6.children.slice(0, position);
	          var _after3 = _node6.children.slice(position);
	          _node6.children = _before3;
	          newNode = _objectSpread$3(_objectSpread$3({}, _properties), {}, {
	            children: _after3
	          });
	        }
	        _parent4.children.splice(_index4 + 1, 0, newNode);
	        if (selection) {
	          var _iterator8 = _createForOfIteratorHelper$2(Range.points(selection)),
	            _step8;
	          try {
	            for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
	              var _step8$value = _slicedToArray(_step8.value, 2),
	                _point6 = _step8$value[0],
	                _key9 = _step8$value[1];
	              selection[_key9] = Point.transform(_point6, op);
	            }
	          } catch (err) {
	            _iterator8.e(err);
	          } finally {
	            _iterator8.f();
	          }
	        }
	        break;
	      }
	  }
	  return selection;
	};
	var GeneralTransforms = {
	  /**
	   * Transform the editor by an operation.
	   */
	  transform: function transform(editor, op) {
	    editor.children = immer.createDraft(editor.children);
	    var selection = editor.selection && immer.createDraft(editor.selection);
	    try {
	      selection = applyToDraft(editor, selection, op);
	    } finally {
	      editor.children = immer.finishDraft(editor.children);
	      if (selection) {
	        editor.selection = immer.isDraft(selection) ? immer.finishDraft(selection) : selection;
	      } else {
	        editor.selection = null;
	      }
	    }
	  }
	};
	var _excluded = ["text"],
	  _excluded2 = ["children"];
	function ownKeys$2(object, enumerableOnly) {
	  var keys = Object.keys(object);
	  if (Object.getOwnPropertySymbols) {
	    var symbols = Object.getOwnPropertySymbols(object);
	    if (enumerableOnly) {
	      symbols = symbols.filter(function (sym) {
	        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
	      });
	    }
	    keys.push.apply(keys, symbols);
	  }
	  return keys;
	}
	function _objectSpread$2(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? arguments[i] : {};
	    if (i % 2) {
	      ownKeys$2(Object(source), true).forEach(function (key) {
	        _defineProperty(target, key, source[key]);
	      });
	    } else if (Object.getOwnPropertyDescriptors) {
	      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
	    } else {
	      ownKeys$2(Object(source)).forEach(function (key) {
	        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
	      });
	    }
	  }
	  return target;
	}
	function _createForOfIteratorHelper$1(o, allowArrayLike) {
	  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
	  if (!it) {
	    if (Array.isArray(o) || (it = _unsupportedIterableToArray$1(o)) || allowArrayLike && o && typeof o.length === "number") {
	      if (it) o = it;
	      var i = 0;
	      var F = function F() {};
	      return {
	        s: F,
	        n: function n() {
	          if (i >= o.length) return {
	            done: true
	          };
	          return {
	            done: false,
	            value: o[i++]
	          };
	        },
	        e: function e(_e) {
	          throw _e;
	        },
	        f: F
	      };
	    }
	    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	  }
	  var normalCompletion = true,
	    didErr = false,
	    err;
	  return {
	    s: function s() {
	      it = it.call(o);
	    },
	    n: function n() {
	      var step = it.next();
	      normalCompletion = step.done;
	      return step;
	    },
	    e: function e(_e2) {
	      didErr = true;
	      err = _e2;
	    },
	    f: function f() {
	      try {
	        if (!normalCompletion && it["return"] != null) it["return"]();
	      } finally {
	        if (didErr) throw err;
	      }
	    }
	  };
	}
	function _unsupportedIterableToArray$1(o, minLen) {
	  if (!o) return;
	  if (typeof o === "string") return _arrayLikeToArray$1(o, minLen);
	  var n = Object.prototype.toString.call(o).slice(8, -1);
	  if (n === "Object" && o.constructor) n = o.constructor.name;
	  if (n === "Map" || n === "Set") return Array.from(o);
	  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen);
	}
	function _arrayLikeToArray$1(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;
	  for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }
	  return arr2;
	}
	var NodeTransforms = {
	  /**
	   * Insert nodes at a specific location in the Editor.
	   */
	  insertNodes: function insertNodes(editor, nodes) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    Editor.withoutNormalizing(editor, function () {
	      var _options$hanging = options.hanging,
	        hanging = _options$hanging === void 0 ? false : _options$hanging,
	        _options$voids = options.voids,
	        voids = _options$voids === void 0 ? false : _options$voids,
	        _options$mode = options.mode,
	        mode = _options$mode === void 0 ? 'lowest' : _options$mode;
	      var at = options.at,
	        match = options.match,
	        select = options.select;
	      if (Node.isNode(nodes)) {
	        nodes = [nodes];
	      }
	      if (nodes.length === 0) {
	        return;
	      }
	      var _nodes = nodes,
	        _nodes2 = _slicedToArray(_nodes, 1),
	        node = _nodes2[0]; // By default, use the selection as the target location. But if there is
	      // no selection, insert at the end of the document since that is such a
	      // common use case when inserting from a non-selected state.
	
	      if (!at) {
	        if (editor.selection) {
	          at = editor.selection;
	        } else if (editor.children.length > 0) {
	          at = Editor.end(editor, []);
	        } else {
	          at = [0];
	        }
	        select = true;
	      }
	      if (select == null) {
	        select = false;
	      }
	      if (Range.isRange(at)) {
	        if (!hanging) {
	          at = Editor.unhangRange(editor, at);
	        }
	        if (Range.isCollapsed(at)) {
	          at = at.anchor;
	        } else {
	          var _Range$edges = Range.edges(at),
	            _Range$edges2 = _slicedToArray(_Range$edges, 2),
	            end = _Range$edges2[1];
	          var pointRef = Editor.pointRef(editor, end);
	          Transforms["delete"](editor, {
	            at: at
	          });
	          at = pointRef.unref();
	        }
	      }
	      if (Point.isPoint(at)) {
	        if (match == null) {
	          if (Text.isText(node)) {
	            match = function match(n) {
	              return Text.isText(n);
	            };
	          } else if (editor.isInline(node)) {
	            match = function match(n) {
	              return Text.isText(n) || Editor.isInline(editor, n);
	            };
	          } else {
	            match = function match(n) {
	              return Editor.isBlock(editor, n);
	            };
	          }
	        }
	        var _Editor$nodes = Editor.nodes(editor, {
	            at: at.path,
	            match: match,
	            mode: mode,
	            voids: voids
	          }),
	          _Editor$nodes2 = _slicedToArray(_Editor$nodes, 1),
	          entry = _Editor$nodes2[0];
	        if (entry) {
	          var _entry = _slicedToArray(entry, 2),
	            _matchPath = _entry[1];
	          var pathRef = Editor.pathRef(editor, _matchPath);
	          var isAtEnd = Editor.isEnd(editor, at, _matchPath);
	          Transforms.splitNodes(editor, {
	            at: at,
	            match: match,
	            mode: mode,
	            voids: voids
	          });
	          var path = pathRef.unref();
	          at = isAtEnd ? Path.next(path) : path;
	        } else {
	          return;
	        }
	      }
	      var parentPath = Path.parent(at);
	      var index = at[at.length - 1];
	      if (!voids && Editor["void"](editor, {
	        at: parentPath
	      })) {
	        return;
	      }
	      var _iterator = _createForOfIteratorHelper$1(nodes),
	        _step;
	      try {
	        for (_iterator.s(); !(_step = _iterator.n()).done;) {
	          var _node = _step.value;
	          var _path = parentPath.concat(index);
	          index++;
	          editor.apply({
	            type: 'insert_node',
	            path: _path,
	            node: _node
	          });
	          at = Path.next(at);
	        }
	      } catch (err) {
	        _iterator.e(err);
	      } finally {
	        _iterator.f();
	      }
	      at = Path.previous(at);
	      if (select) {
	        var point = Editor.end(editor, at);
	        if (point) {
	          Transforms.select(editor, point);
	        }
	      }
	    });
	  },
	  /**
	   * Lift nodes at a specific location upwards in the document tree, splitting
	   * their parent in two if necessary.
	   */
	  liftNodes: function liftNodes(editor) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    Editor.withoutNormalizing(editor, function () {
	      var _options$at = options.at,
	        at = _options$at === void 0 ? editor.selection : _options$at,
	        _options$mode2 = options.mode,
	        mode = _options$mode2 === void 0 ? 'lowest' : _options$mode2,
	        _options$voids2 = options.voids,
	        voids = _options$voids2 === void 0 ? false : _options$voids2;
	      var match = options.match;
	      if (match == null) {
	        match = Path.isPath(at) ? matchPath(editor, at) : function (n) {
	          return Editor.isBlock(editor, n);
	        };
	      }
	      if (!at) {
	        return;
	      }
	      var matches = Editor.nodes(editor, {
	        at: at,
	        match: match,
	        mode: mode,
	        voids: voids
	      });
	      var pathRefs = Array.from(matches, function (_ref) {
	        var _ref2 = _slicedToArray(_ref, 2),
	          p = _ref2[1];
	        return Editor.pathRef(editor, p);
	      });
	      for (var _i = 0, _pathRefs = pathRefs; _i < _pathRefs.length; _i++) {
	        var pathRef = _pathRefs[_i];
	        var path = pathRef.unref();
	        if (path.length < 2) {
	          throw new Error("Cannot lift node at a path [".concat(path, "] because it has a depth of less than `2`."));
	        }
	        var parentNodeEntry = Editor.node(editor, Path.parent(path));
	        var _parentNodeEntry = _slicedToArray(parentNodeEntry, 2),
	          parent = _parentNodeEntry[0],
	          parentPath = _parentNodeEntry[1];
	        var index = path[path.length - 1];
	        var length = parent.children.length;
	        if (length === 1) {
	          var toPath = Path.next(parentPath);
	          Transforms.moveNodes(editor, {
	            at: path,
	            to: toPath,
	            voids: voids
	          });
	          Transforms.removeNodes(editor, {
	            at: parentPath,
	            voids: voids
	          });
	        } else if (index === 0) {
	          Transforms.moveNodes(editor, {
	            at: path,
	            to: parentPath,
	            voids: voids
	          });
	        } else if (index === length - 1) {
	          var _toPath = Path.next(parentPath);
	          Transforms.moveNodes(editor, {
	            at: path,
	            to: _toPath,
	            voids: voids
	          });
	        } else {
	          var splitPath = Path.next(path);
	          var _toPath2 = Path.next(parentPath);
	          Transforms.splitNodes(editor, {
	            at: splitPath,
	            voids: voids
	          });
	          Transforms.moveNodes(editor, {
	            at: path,
	            to: _toPath2,
	            voids: voids
	          });
	        }
	      }
	    });
	  },
	  /**
	   * Merge a node at a location with the previous node of the same depth,
	   * removing any empty containing nodes after the merge if necessary.
	   */
	  mergeNodes: function mergeNodes(editor) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    Editor.withoutNormalizing(editor, function () {
	      var match = options.match,
	        _options$at2 = options.at,
	        at = _options$at2 === void 0 ? editor.selection : _options$at2;
	      var _options$hanging2 = options.hanging,
	        hanging = _options$hanging2 === void 0 ? false : _options$hanging2,
	        _options$voids3 = options.voids,
	        voids = _options$voids3 === void 0 ? false : _options$voids3,
	        _options$mode3 = options.mode,
	        mode = _options$mode3 === void 0 ? 'lowest' : _options$mode3;
	      if (!at) {
	        return;
	      }
	      if (match == null) {
	        if (Path.isPath(at)) {
	          var _Editor$parent = Editor.parent(editor, at),
	            _Editor$parent2 = _slicedToArray(_Editor$parent, 1),
	            parent = _Editor$parent2[0];
	          match = function match(n) {
	            return parent.children.includes(n);
	          };
	        } else {
	          match = function match(n) {
	            return Editor.isBlock(editor, n);
	          };
	        }
	      }
	      if (!hanging && Range.isRange(at)) {
	        at = Editor.unhangRange(editor, at);
	      }
	      if (Range.isRange(at)) {
	        if (Range.isCollapsed(at)) {
	          at = at.anchor;
	        } else {
	          var _Range$edges3 = Range.edges(at),
	            _Range$edges4 = _slicedToArray(_Range$edges3, 2),
	            end = _Range$edges4[1];
	          var pointRef = Editor.pointRef(editor, end);
	          Transforms["delete"](editor, {
	            at: at
	          });
	          at = pointRef.unref();
	          if (options.at == null) {
	            Transforms.select(editor, at);
	          }
	        }
	      }
	      var _Editor$nodes3 = Editor.nodes(editor, {
	          at: at,
	          match: match,
	          voids: voids,
	          mode: mode
	        }),
	        _Editor$nodes4 = _slicedToArray(_Editor$nodes3, 1),
	        current = _Editor$nodes4[0];
	      var prev = Editor.previous(editor, {
	        at: at,
	        match: match,
	        voids: voids,
	        mode: mode
	      });
	      if (!current || !prev) {
	        return;
	      }
	      var _current = _slicedToArray(current, 2),
	        node = _current[0],
	        path = _current[1];
	      var _prev = _slicedToArray(prev, 2),
	        prevNode = _prev[0],
	        prevPath = _prev[1];
	      if (path.length === 0 || prevPath.length === 0) {
	        return;
	      }
	      var newPath = Path.next(prevPath);
	      var commonPath = Path.common(path, prevPath);
	      var isPreviousSibling = Path.isSibling(path, prevPath);
	      var levels = Array.from(Editor.levels(editor, {
	        at: path
	      }), function (_ref3) {
	        var _ref4 = _slicedToArray(_ref3, 1),
	          n = _ref4[0];
	        return n;
	      }).slice(commonPath.length).slice(0, -1); // Determine if the merge will leave an ancestor of the path empty as a
	      // result, in which case we'll want to remove it after merging.
	
	      var emptyAncestor = Editor.above(editor, {
	        at: path,
	        mode: 'highest',
	        match: function match(n) {
	          return levels.includes(n) && hasSingleChildNest(editor, n);
	        }
	      });
	      var emptyRef = emptyAncestor && Editor.pathRef(editor, emptyAncestor[1]);
	      var properties;
	      var position; // Ensure that the nodes are equivalent, and figure out what the position
	      // and extra properties of the merge will be.
	
	      if (Text.isText(node) && Text.isText(prevNode)) {
	        node.text;
	        var rest = _objectWithoutProperties(node, _excluded);
	        position = prevNode.text.length;
	        properties = rest;
	      } else if (Element.isElement(node) && Element.isElement(prevNode)) {
	        node.children;
	        var _rest = _objectWithoutProperties(node, _excluded2);
	        position = prevNode.children.length;
	        properties = _rest;
	      } else {
	        throw new Error("Cannot merge the node at path [".concat(path, "] with the previous sibling because it is not the same kind: ").concat(JSON.stringify(node), " ").concat(JSON.stringify(prevNode)));
	      } // If the node isn't already the next sibling of the previous node, move
	      // it so that it is before merging.
	
	      if (!isPreviousSibling) {
	        Transforms.moveNodes(editor, {
	          at: path,
	          to: newPath,
	          voids: voids
	        });
	      } // If there was going to be an empty ancestor of the node that was merged,
	      // we remove it from the tree.
	
	      if (emptyRef) {
	        Transforms.removeNodes(editor, {
	          at: emptyRef.current,
	          voids: voids
	        });
	      } // If the target node that we're merging with is empty, remove it instead
	      // of merging the two. This is a common rich text editor behavior to
	      // prevent losing formatting when deleting entire nodes when you have a
	      // hanging selection.
	      // if prevNode is first child in parent,don't remove it.
	
	      if (Element.isElement(prevNode) && Editor.isEmpty(editor, prevNode) || Text.isText(prevNode) && prevNode.text === '' && prevPath[prevPath.length - 1] !== 0) {
	        Transforms.removeNodes(editor, {
	          at: prevPath,
	          voids: voids
	        });
	      } else {
	        editor.apply({
	          type: 'merge_node',
	          path: newPath,
	          position: position,
	          properties: properties
	        });
	      }
	      if (emptyRef) {
	        emptyRef.unref();
	      }
	    });
	  },
	  /**
	   * Move the nodes at a location to a new location.
	   */
	  moveNodes: function moveNodes(editor, options) {
	    Editor.withoutNormalizing(editor, function () {
	      var to = options.to,
	        _options$at3 = options.at,
	        at = _options$at3 === void 0 ? editor.selection : _options$at3,
	        _options$mode4 = options.mode,
	        mode = _options$mode4 === void 0 ? 'lowest' : _options$mode4,
	        _options$voids4 = options.voids,
	        voids = _options$voids4 === void 0 ? false : _options$voids4;
	      var match = options.match;
	      if (!at) {
	        return;
	      }
	      if (match == null) {
	        match = Path.isPath(at) ? matchPath(editor, at) : function (n) {
	          return Editor.isBlock(editor, n);
	        };
	      }
	      var toRef = Editor.pathRef(editor, to);
	      var targets = Editor.nodes(editor, {
	        at: at,
	        match: match,
	        mode: mode,
	        voids: voids
	      });
	      var pathRefs = Array.from(targets, function (_ref5) {
	        var _ref6 = _slicedToArray(_ref5, 2),
	          p = _ref6[1];
	        return Editor.pathRef(editor, p);
	      });
	      for (var _i2 = 0, _pathRefs2 = pathRefs; _i2 < _pathRefs2.length; _i2++) {
	        var pathRef = _pathRefs2[_i2];
	        var path = pathRef.unref();
	        var newPath = toRef.current;
	        if (path.length !== 0) {
	          editor.apply({
	            type: 'move_node',
	            path: path,
	            newPath: newPath
	          });
	        }
	        if (toRef.current && Path.isSibling(newPath, path) && Path.isAfter(newPath, path)) {
	          // When performing a sibling move to a later index, the path at the destination is shifted
	          // to before the insertion point instead of after. To ensure our group of nodes are inserted
	          // in the correct order we increment toRef to account for that
	          toRef.current = Path.next(toRef.current);
	        }
	      }
	      toRef.unref();
	    });
	  },
	  /**
	   * Remove the nodes at a specific location in the document.
	   */
	  removeNodes: function removeNodes(editor) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    Editor.withoutNormalizing(editor, function () {
	      var _options$hanging3 = options.hanging,
	        hanging = _options$hanging3 === void 0 ? false : _options$hanging3,
	        _options$voids5 = options.voids,
	        voids = _options$voids5 === void 0 ? false : _options$voids5,
	        _options$mode5 = options.mode,
	        mode = _options$mode5 === void 0 ? 'lowest' : _options$mode5;
	      var _options$at4 = options.at,
	        at = _options$at4 === void 0 ? editor.selection : _options$at4,
	        match = options.match;
	      if (!at) {
	        return;
	      }
	      if (match == null) {
	        match = Path.isPath(at) ? matchPath(editor, at) : function (n) {
	          return Editor.isBlock(editor, n);
	        };
	      }
	      if (!hanging && Range.isRange(at)) {
	        at = Editor.unhangRange(editor, at);
	      }
	      var depths = Editor.nodes(editor, {
	        at: at,
	        match: match,
	        mode: mode,
	        voids: voids
	      });
	      var pathRefs = Array.from(depths, function (_ref7) {
	        var _ref8 = _slicedToArray(_ref7, 2),
	          p = _ref8[1];
	        return Editor.pathRef(editor, p);
	      });
	      for (var _i3 = 0, _pathRefs3 = pathRefs; _i3 < _pathRefs3.length; _i3++) {
	        var pathRef = _pathRefs3[_i3];
	        var path = pathRef.unref();
	        if (path) {
	          var _Editor$node = Editor.node(editor, path),
	            _Editor$node2 = _slicedToArray(_Editor$node, 1),
	            node = _Editor$node2[0];
	          editor.apply({
	            type: 'remove_node',
	            path: path,
	            node: node
	          });
	        }
	      }
	    });
	  },
	  /**
	   * Set new properties on the nodes at a location.
	   */
	  setNodes: function setNodes(editor, props) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    Editor.withoutNormalizing(editor, function () {
	      var match = options.match,
	        _options$at5 = options.at,
	        at = _options$at5 === void 0 ? editor.selection : _options$at5,
	        compare = options.compare,
	        merge = options.merge;
	      var _options$hanging4 = options.hanging,
	        hanging = _options$hanging4 === void 0 ? false : _options$hanging4,
	        _options$mode6 = options.mode,
	        mode = _options$mode6 === void 0 ? 'lowest' : _options$mode6,
	        _options$split = options.split,
	        split = _options$split === void 0 ? false : _options$split,
	        _options$voids6 = options.voids,
	        voids = _options$voids6 === void 0 ? false : _options$voids6;
	      if (!at) {
	        return;
	      }
	      if (match == null) {
	        match = Path.isPath(at) ? matchPath(editor, at) : function (n) {
	          return Editor.isBlock(editor, n);
	        };
	      }
	      if (!hanging && Range.isRange(at)) {
	        at = Editor.unhangRange(editor, at);
	      }
	      if (split && Range.isRange(at)) {
	        if (Range.isCollapsed(at) && Editor.leaf(editor, at.anchor)[0].text.length > 0) {
	          // If the range is collapsed in a non-empty node and 'split' is true, there's nothing to
	          // set that won't get normalized away
	          return;
	        }
	        var rangeRef = Editor.rangeRef(editor, at, {
	          affinity: 'inward'
	        });
	        var _Range$edges5 = Range.edges(at),
	          _Range$edges6 = _slicedToArray(_Range$edges5, 2),
	          start = _Range$edges6[0],
	          end = _Range$edges6[1];
	        var splitMode = mode === 'lowest' ? 'lowest' : 'highest';
	        var endAtEndOfNode = Editor.isEnd(editor, end, end.path);
	        Transforms.splitNodes(editor, {
	          at: end,
	          match: match,
	          mode: splitMode,
	          voids: voids,
	          always: !endAtEndOfNode
	        });
	        var startAtStartOfNode = Editor.isStart(editor, start, start.path);
	        Transforms.splitNodes(editor, {
	          at: start,
	          match: match,
	          mode: splitMode,
	          voids: voids,
	          always: !startAtStartOfNode
	        });
	        at = rangeRef.unref();
	        if (options.at == null) {
	          Transforms.select(editor, at);
	        }
	      }
	      if (!compare) {
	        compare = function compare(prop, nodeProp) {
	          return prop !== nodeProp;
	        };
	      }
	      var _iterator2 = _createForOfIteratorHelper$1(Editor.nodes(editor, {
	          at: at,
	          match: match,
	          mode: mode,
	          voids: voids
	        })),
	        _step2;
	      try {
	        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
	          var _step2$value = _slicedToArray(_step2.value, 2),
	            node = _step2$value[0],
	            path = _step2$value[1];
	          var properties = {};
	          var newProperties = {}; // You can't set properties on the editor node.
	
	          if (path.length === 0) {
	            continue;
	          }
	          var hasChanges = false;
	          for (var k in props) {
	            if (k === 'children' || k === 'text') {
	              continue;
	            }
	            if (compare(props[k], node[k])) {
	              hasChanges = true; // Omit new properties from the old properties list
	
	              if (node.hasOwnProperty(k)) properties[k] = node[k]; // Omit properties that have been removed from the new properties list
	
	              if (merge) {
	                if (props[k] != null) newProperties[k] = merge(node[k], props[k]);
	              } else {
	                if (props[k] != null) newProperties[k] = props[k];
	              }
	            }
	          }
	          if (hasChanges) {
	            editor.apply({
	              type: 'set_node',
	              path: path,
	              properties: properties,
	              newProperties: newProperties
	            });
	          }
	        }
	      } catch (err) {
	        _iterator2.e(err);
	      } finally {
	        _iterator2.f();
	      }
	    });
	  },
	  /**
	   * Split the nodes at a specific location.
	   */
	  splitNodes: function splitNodes(editor) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    Editor.withoutNormalizing(editor, function () {
	      var _options$mode7 = options.mode,
	        mode = _options$mode7 === void 0 ? 'lowest' : _options$mode7,
	        _options$voids7 = options.voids,
	        voids = _options$voids7 === void 0 ? false : _options$voids7;
	      var match = options.match,
	        _options$at6 = options.at,
	        at = _options$at6 === void 0 ? editor.selection : _options$at6,
	        _options$height = options.height,
	        height = _options$height === void 0 ? 0 : _options$height,
	        _options$always = options.always,
	        always = _options$always === void 0 ? false : _options$always;
	      if (match == null) {
	        match = function match(n) {
	          return Editor.isBlock(editor, n);
	        };
	      }
	      if (Range.isRange(at)) {
	        at = deleteRange(editor, at);
	      } // If the target is a path, the default height-skipping and position
	      // counters need to account for us potentially splitting at a non-leaf.
	
	      if (Path.isPath(at)) {
	        var path = at;
	        var point = Editor.point(editor, path);
	        var _Editor$parent3 = Editor.parent(editor, path),
	          _Editor$parent4 = _slicedToArray(_Editor$parent3, 1),
	          parent = _Editor$parent4[0];
	        match = function match(n) {
	          return n === parent;
	        };
	        height = point.path.length - path.length + 1;
	        at = point;
	        always = true;
	      }
	      if (!at) {
	        return;
	      }
	      var beforeRef = Editor.pointRef(editor, at, {
	        affinity: 'backward'
	      });
	      var afterRef;
	      try {
	        var _Editor$nodes5 = Editor.nodes(editor, {
	            at: at,
	            match: match,
	            mode: mode,
	            voids: voids
	          }),
	          _Editor$nodes6 = _slicedToArray(_Editor$nodes5, 1),
	          highest = _Editor$nodes6[0];
	        if (!highest) {
	          return;
	        }
	        var voidMatch = Editor["void"](editor, {
	          at: at,
	          mode: 'highest'
	        });
	        var nudge = 0;
	        if (!voids && voidMatch) {
	          var _voidMatch = _slicedToArray(voidMatch, 2),
	            voidNode = _voidMatch[0],
	            voidPath = _voidMatch[1];
	          if (Element.isElement(voidNode) && editor.isInline(voidNode)) {
	            var after = Editor.after(editor, voidPath);
	            if (!after) {
	              var text = {
	                text: ''
	              };
	              var afterPath = Path.next(voidPath);
	              Transforms.insertNodes(editor, text, {
	                at: afterPath,
	                voids: voids
	              });
	              after = Editor.point(editor, afterPath);
	            }
	            at = after;
	            always = true;
	          }
	          var siblingHeight = at.path.length - voidPath.length;
	          height = siblingHeight + 1;
	          always = true;
	        }
	        afterRef = Editor.pointRef(editor, at);
	        var depth = at.path.length - height;
	        var _highest = _slicedToArray(highest, 2),
	          highestPath = _highest[1];
	        var lowestPath = at.path.slice(0, depth);
	        var position = height === 0 ? at.offset : at.path[depth] + nudge;
	        var _iterator3 = _createForOfIteratorHelper$1(Editor.levels(editor, {
	            at: lowestPath,
	            reverse: true,
	            voids: voids
	          })),
	          _step3;
	        try {
	          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
	            var _step3$value = _slicedToArray(_step3.value, 2),
	              node = _step3$value[0],
	              _path2 = _step3$value[1];
	            var split = false;
	            if (_path2.length < highestPath.length || _path2.length === 0 || !voids && Editor.isVoid(editor, node)) {
	              break;
	            }
	            var _point2 = beforeRef.current;
	            var isEnd = Editor.isEnd(editor, _point2, _path2);
	            if (always || !beforeRef || !Editor.isEdge(editor, _point2, _path2)) {
	              split = true;
	              var properties = Node.extractProps(node);
	              editor.apply({
	                type: 'split_node',
	                path: _path2,
	                position: position,
	                properties: properties
	              });
	            }
	            position = _path2[_path2.length - 1] + (split || isEnd ? 1 : 0);
	          }
	        } catch (err) {
	          _iterator3.e(err);
	        } finally {
	          _iterator3.f();
	        }
	        if (options.at == null) {
	          var _point = afterRef.current || Editor.end(editor, []);
	          Transforms.select(editor, _point);
	        }
	      } finally {
	        var _afterRef;
	        beforeRef.unref();
	        (_afterRef = afterRef) === null || _afterRef === void 0 ? void 0 : _afterRef.unref();
	      }
	    });
	  },
	  /**
	   * Unset properties on the nodes at a location.
	   */
	  unsetNodes: function unsetNodes(editor, props) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    if (!Array.isArray(props)) {
	      props = [props];
	    }
	    var obj = {};
	    var _iterator4 = _createForOfIteratorHelper$1(props),
	      _step4;
	    try {
	      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
	        var key = _step4.value;
	        obj[key] = null;
	      }
	    } catch (err) {
	      _iterator4.e(err);
	    } finally {
	      _iterator4.f();
	    }
	    Transforms.setNodes(editor, obj, options);
	  },
	  /**
	   * Unwrap the nodes at a location from a parent node, splitting the parent if
	   * necessary to ensure that only the content in the range is unwrapped.
	   */
	  unwrapNodes: function unwrapNodes(editor) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    Editor.withoutNormalizing(editor, function () {
	      var _options$mode8 = options.mode,
	        mode = _options$mode8 === void 0 ? 'lowest' : _options$mode8,
	        _options$split2 = options.split,
	        split = _options$split2 === void 0 ? false : _options$split2,
	        _options$voids8 = options.voids,
	        voids = _options$voids8 === void 0 ? false : _options$voids8;
	      var _options$at7 = options.at,
	        at = _options$at7 === void 0 ? editor.selection : _options$at7,
	        match = options.match;
	      if (!at) {
	        return;
	      }
	      if (match == null) {
	        match = Path.isPath(at) ? matchPath(editor, at) : function (n) {
	          return Editor.isBlock(editor, n);
	        };
	      }
	      if (Path.isPath(at)) {
	        at = Editor.range(editor, at);
	      }
	      var rangeRef = Range.isRange(at) ? Editor.rangeRef(editor, at) : null;
	      var matches = Editor.nodes(editor, {
	        at: at,
	        match: match,
	        mode: mode,
	        voids: voids
	      });
	      var pathRefs = Array.from(matches, function (_ref9) {
	        var _ref10 = _slicedToArray(_ref9, 2),
	          p = _ref10[1];
	        return Editor.pathRef(editor, p);
	      } // unwrapNode will call liftNode which does not support splitting the node when nested.
	      // If we do not reverse the order and call it from top to the bottom, it will remove all blocks
	      // that wrap target node. So we reverse the order.
	      ).reverse();
	      var _iterator5 = _createForOfIteratorHelper$1(pathRefs),
	        _step5;
	      try {
	        var _loop = function _loop() {
	          var pathRef = _step5.value;
	          var path = pathRef.unref();
	          var _Editor$node3 = Editor.node(editor, path),
	            _Editor$node4 = _slicedToArray(_Editor$node3, 1),
	            node = _Editor$node4[0];
	          var range = Editor.range(editor, path);
	          if (split && rangeRef) {
	            range = Range.intersection(rangeRef.current, range);
	          }
	          Transforms.liftNodes(editor, {
	            at: range,
	            match: function match(n) {
	              return Element.isAncestor(node) && node.children.includes(n);
	            },
	            voids: voids
	          });
	        };
	        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
	          _loop();
	        }
	      } catch (err) {
	        _iterator5.e(err);
	      } finally {
	        _iterator5.f();
	      }
	      if (rangeRef) {
	        rangeRef.unref();
	      }
	    });
	  },
	  /**
	   * Wrap the nodes at a location in a new container node, splitting the edges
	   * of the range first to ensure that only the content in the range is wrapped.
	   */
	  wrapNodes: function wrapNodes(editor, element) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    Editor.withoutNormalizing(editor, function () {
	      var _options$mode9 = options.mode,
	        mode = _options$mode9 === void 0 ? 'lowest' : _options$mode9,
	        _options$split3 = options.split,
	        split = _options$split3 === void 0 ? false : _options$split3,
	        _options$voids9 = options.voids,
	        voids = _options$voids9 === void 0 ? false : _options$voids9;
	      var match = options.match,
	        _options$at8 = options.at,
	        at = _options$at8 === void 0 ? editor.selection : _options$at8;
	      if (!at) {
	        return;
	      }
	      if (match == null) {
	        if (Path.isPath(at)) {
	          match = matchPath(editor, at);
	        } else if (editor.isInline(element)) {
	          match = function match(n) {
	            return Editor.isInline(editor, n) || Text.isText(n);
	          };
	        } else {
	          match = function match(n) {
	            return Editor.isBlock(editor, n);
	          };
	        }
	      }
	      if (split && Range.isRange(at)) {
	        var _Range$edges7 = Range.edges(at),
	          _Range$edges8 = _slicedToArray(_Range$edges7, 2),
	          start = _Range$edges8[0],
	          end = _Range$edges8[1];
	        var rangeRef = Editor.rangeRef(editor, at, {
	          affinity: 'inward'
	        });
	        Transforms.splitNodes(editor, {
	          at: end,
	          match: match,
	          voids: voids
	        });
	        Transforms.splitNodes(editor, {
	          at: start,
	          match: match,
	          voids: voids
	        });
	        at = rangeRef.unref();
	        if (options.at == null) {
	          Transforms.select(editor, at);
	        }
	      }
	      var roots = Array.from(Editor.nodes(editor, {
	        at: at,
	        match: editor.isInline(element) ? function (n) {
	          return Editor.isBlock(editor, n);
	        } : function (n) {
	          return Editor.isEditor(n);
	        },
	        mode: 'lowest',
	        voids: voids
	      }));
	      for (var _i4 = 0, _roots = roots; _i4 < _roots.length; _i4++) {
	        var _roots$_i = _slicedToArray(_roots[_i4], 2),
	          rootPath = _roots$_i[1];
	        var a = Range.isRange(at) ? Range.intersection(at, Editor.range(editor, rootPath)) : at;
	        if (!a) {
	          continue;
	        }
	        var matches = Array.from(Editor.nodes(editor, {
	          at: a,
	          match: match,
	          mode: mode,
	          voids: voids
	        }));
	        if (matches.length > 0) {
	          var _ret = function () {
	            var _matches = _slicedToArray(matches, 1),
	              first = _matches[0];
	            var last = matches[matches.length - 1];
	            var _first = _slicedToArray(first, 2),
	              firstPath = _first[1];
	            var _last = _slicedToArray(last, 2),
	              lastPath = _last[1];
	            if (firstPath.length === 0 && lastPath.length === 0) {
	              // if there's no matching parent - usually means the node is an editor - don't do anything
	              return "continue";
	            }
	            var commonPath = Path.equals(firstPath, lastPath) ? Path.parent(firstPath) : Path.common(firstPath, lastPath);
	            var range = Editor.range(editor, firstPath, lastPath);
	            var commonNodeEntry = Editor.node(editor, commonPath);
	            var _commonNodeEntry = _slicedToArray(commonNodeEntry, 1),
	              commonNode = _commonNodeEntry[0];
	            var depth = commonPath.length + 1;
	            var wrapperPath = Path.next(lastPath.slice(0, depth));
	            var wrapper = _objectSpread$2(_objectSpread$2({}, element), {}, {
	              children: []
	            });
	            Transforms.insertNodes(editor, wrapper, {
	              at: wrapperPath,
	              voids: voids
	            });
	            Transforms.moveNodes(editor, {
	              at: range,
	              match: function match(n) {
	                return Element.isAncestor(commonNode) && commonNode.children.includes(n);
	              },
	              to: wrapperPath.concat(0),
	              voids: voids
	            });
	          }();
	          if (_ret === "continue") continue;
	        }
	      }
	    });
	  }
	};
	var hasSingleChildNest = function hasSingleChildNest(editor, node) {
	  if (Element.isElement(node)) {
	    var element = node;
	    if (Editor.isVoid(editor, node)) {
	      return true;
	    } else if (element.children.length === 1) {
	      return hasSingleChildNest(editor, element.children[0]);
	    } else {
	      return false;
	    }
	  } else if (Editor.isEditor(node)) {
	    return false;
	  } else {
	    return true;
	  }
	};
	/**
	 * Convert a range into a point by deleting it's content.
	 */
	
	var deleteRange = function deleteRange(editor, range) {
	  if (Range.isCollapsed(range)) {
	    return range.anchor;
	  } else {
	    var _Range$edges9 = Range.edges(range),
	      _Range$edges10 = _slicedToArray(_Range$edges9, 2),
	      end = _Range$edges10[1];
	    var pointRef = Editor.pointRef(editor, end);
	    Transforms["delete"](editor, {
	      at: range
	    });
	    return pointRef.unref();
	  }
	};
	var matchPath = function matchPath(editor, path) {
	  var _Editor$node5 = Editor.node(editor, path),
	    _Editor$node6 = _slicedToArray(_Editor$node5, 1),
	    node = _Editor$node6[0];
	  return function (n) {
	    return n === node;
	  };
	};
	function ownKeys$1(object, enumerableOnly) {
	  var keys = Object.keys(object);
	  if (Object.getOwnPropertySymbols) {
	    var symbols = Object.getOwnPropertySymbols(object);
	    if (enumerableOnly) {
	      symbols = symbols.filter(function (sym) {
	        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
	      });
	    }
	    keys.push.apply(keys, symbols);
	  }
	  return keys;
	}
	function _objectSpread$1(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? arguments[i] : {};
	    if (i % 2) {
	      ownKeys$1(Object(source), true).forEach(function (key) {
	        _defineProperty(target, key, source[key]);
	      });
	    } else if (Object.getOwnPropertyDescriptors) {
	      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
	    } else {
	      ownKeys$1(Object(source)).forEach(function (key) {
	        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
	      });
	    }
	  }
	  return target;
	}
	var SelectionTransforms = {
	  /**
	   * Collapse the selection.
	   */
	  collapse: function collapse(editor) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var _options$edge = options.edge,
	      edge = _options$edge === void 0 ? 'anchor' : _options$edge;
	    var selection = editor.selection;
	    if (!selection) {
	      return;
	    } else if (edge === 'anchor') {
	      Transforms.select(editor, selection.anchor);
	    } else if (edge === 'focus') {
	      Transforms.select(editor, selection.focus);
	    } else if (edge === 'start') {
	      var _Range$edges = Range.edges(selection),
	        _Range$edges2 = _slicedToArray(_Range$edges, 1),
	        start = _Range$edges2[0];
	      Transforms.select(editor, start);
	    } else if (edge === 'end') {
	      var _Range$edges3 = Range.edges(selection),
	        _Range$edges4 = _slicedToArray(_Range$edges3, 2),
	        end = _Range$edges4[1];
	      Transforms.select(editor, end);
	    }
	  },
	  /**
	   * Unset the selection.
	   */
	  deselect: function deselect(editor) {
	    var selection = editor.selection;
	    if (selection) {
	      editor.apply({
	        type: 'set_selection',
	        properties: selection,
	        newProperties: null
	      });
	    }
	  },
	  /**
	   * Move the selection's point forward or backward.
	   */
	  move: function move(editor) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var selection = editor.selection;
	    var _options$distance = options.distance,
	      distance = _options$distance === void 0 ? 1 : _options$distance,
	      _options$unit = options.unit,
	      unit = _options$unit === void 0 ? 'character' : _options$unit,
	      _options$reverse = options.reverse,
	      reverse = _options$reverse === void 0 ? false : _options$reverse;
	    var _options$edge2 = options.edge,
	      edge = _options$edge2 === void 0 ? null : _options$edge2;
	    if (!selection) {
	      return;
	    }
	    if (edge === 'start') {
	      edge = Range.isBackward(selection) ? 'focus' : 'anchor';
	    }
	    if (edge === 'end') {
	      edge = Range.isBackward(selection) ? 'anchor' : 'focus';
	    }
	    var anchor = selection.anchor,
	      focus = selection.focus;
	    var opts = {
	      distance: distance,
	      unit: unit
	    };
	    var props = {};
	    if (edge == null || edge === 'anchor') {
	      var point = reverse ? Editor.before(editor, anchor, opts) : Editor.after(editor, anchor, opts);
	      if (point) {
	        props.anchor = point;
	      }
	    }
	    if (edge == null || edge === 'focus') {
	      var _point = reverse ? Editor.before(editor, focus, opts) : Editor.after(editor, focus, opts);
	      if (_point) {
	        props.focus = _point;
	      }
	    }
	    Transforms.setSelection(editor, props);
	  },
	  /**
	   * Set the selection to a new value.
	   */
	  select: function select(editor, target) {
	    var selection = editor.selection;
	    target = Editor.range(editor, target);
	    if (selection) {
	      Transforms.setSelection(editor, target);
	      return;
	    }
	    if (!Range.isRange(target)) {
	      throw new Error("When setting the selection and the current selection is `null` you must provide at least an `anchor` and `focus`, but you passed: ".concat(JSON.stringify(target)));
	    }
	    editor.apply({
	      type: 'set_selection',
	      properties: selection,
	      newProperties: target
	    });
	  },
	  /**
	   * Set new properties on one of the selection's points.
	   */
	  setPoint: function setPoint(editor, props) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var selection = editor.selection;
	    var _options$edge3 = options.edge,
	      edge = _options$edge3 === void 0 ? 'both' : _options$edge3;
	    if (!selection) {
	      return;
	    }
	    if (edge === 'start') {
	      edge = Range.isBackward(selection) ? 'focus' : 'anchor';
	    }
	    if (edge === 'end') {
	      edge = Range.isBackward(selection) ? 'anchor' : 'focus';
	    }
	    var anchor = selection.anchor,
	      focus = selection.focus;
	    var point = edge === 'anchor' ? anchor : focus;
	    Transforms.setSelection(editor, _defineProperty({}, edge === 'anchor' ? 'anchor' : 'focus', _objectSpread$1(_objectSpread$1({}, point), props)));
	  },
	  /**
	   * Set new properties on the selection.
	   */
	  setSelection: function setSelection(editor, props) {
	    var selection = editor.selection;
	    var oldProps = {};
	    var newProps = {};
	    if (!selection) {
	      return;
	    }
	    for (var k in props) {
	      if (k === 'anchor' && props.anchor != null && !Point.equals(props.anchor, selection.anchor) || k === 'focus' && props.focus != null && !Point.equals(props.focus, selection.focus) || k !== 'anchor' && k !== 'focus' && props[k] !== selection[k]) {
	        oldProps[k] = selection[k];
	        newProps[k] = props[k];
	      }
	    }
	    if (Object.keys(oldProps).length > 0) {
	      editor.apply({
	        type: 'set_selection',
	        properties: oldProps,
	        newProperties: newProps
	      });
	    }
	  }
	};
	function _createForOfIteratorHelper(o, allowArrayLike) {
	  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
	  if (!it) {
	    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
	      if (it) o = it;
	      var i = 0;
	      var F = function F() {};
	      return {
	        s: F,
	        n: function n() {
	          if (i >= o.length) return {
	            done: true
	          };
	          return {
	            done: false,
	            value: o[i++]
	          };
	        },
	        e: function e(_e) {
	          throw _e;
	        },
	        f: F
	      };
	    }
	    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	  }
	  var normalCompletion = true,
	    didErr = false,
	    err;
	  return {
	    s: function s() {
	      it = it.call(o);
	    },
	    n: function n() {
	      var step = it.next();
	      normalCompletion = step.done;
	      return step;
	    },
	    e: function e(_e2) {
	      didErr = true;
	      err = _e2;
	    },
	    f: function f() {
	      try {
	        if (!normalCompletion && it["return"] != null) it["return"]();
	      } finally {
	        if (didErr) throw err;
	      }
	    }
	  };
	}
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;
	  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
	  var n = Object.prototype.toString.call(o).slice(8, -1);
	  if (n === "Object" && o.constructor) n = o.constructor.name;
	  if (n === "Map" || n === "Set") return Array.from(o);
	  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}
	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;
	  for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }
	  return arr2;
	}
	var TextTransforms = {
	  /**
	   * Delete content in the editor.
	   */
	  "delete": function _delete(editor) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    Editor.withoutNormalizing(editor, function () {
	      var _options$reverse = options.reverse,
	        reverse = _options$reverse === void 0 ? false : _options$reverse,
	        _options$unit = options.unit,
	        unit = _options$unit === void 0 ? 'character' : _options$unit,
	        _options$distance = options.distance,
	        distance = _options$distance === void 0 ? 1 : _options$distance,
	        _options$voids = options.voids,
	        voids = _options$voids === void 0 ? false : _options$voids;
	      var _options$at = options.at,
	        at = _options$at === void 0 ? editor.selection : _options$at,
	        _options$hanging = options.hanging,
	        hanging = _options$hanging === void 0 ? false : _options$hanging;
	      if (!at) {
	        return;
	      }
	      if (Range.isRange(at) && Range.isCollapsed(at)) {
	        at = at.anchor;
	      }
	      if (Point.isPoint(at)) {
	        var furthestVoid = Editor["void"](editor, {
	          at: at,
	          mode: 'highest'
	        });
	        if (!voids && furthestVoid) {
	          var _furthestVoid = _slicedToArray(furthestVoid, 2),
	            voidPath = _furthestVoid[1];
	          at = voidPath;
	        } else {
	          var opts = {
	            unit: unit,
	            distance: distance
	          };
	          var target = reverse ? Editor.before(editor, at, opts) || Editor.start(editor, []) : Editor.after(editor, at, opts) || Editor.end(editor, []);
	          at = {
	            anchor: at,
	            focus: target
	          };
	          hanging = true;
	        }
	      }
	      if (Path.isPath(at)) {
	        Transforms.removeNodes(editor, {
	          at: at,
	          voids: voids
	        });
	        return;
	      }
	      if (Range.isCollapsed(at)) {
	        return;
	      }
	      if (!hanging) {
	        var _Range$edges = Range.edges(at),
	          _Range$edges2 = _slicedToArray(_Range$edges, 2),
	          _end = _Range$edges2[1];
	        var endOfDoc = Editor.end(editor, []);
	        if (!Point.equals(_end, endOfDoc)) {
	          at = Editor.unhangRange(editor, at, {
	            voids: voids
	          });
	        }
	      }
	      var _Range$edges3 = Range.edges(at),
	        _Range$edges4 = _slicedToArray(_Range$edges3, 2),
	        start = _Range$edges4[0],
	        end = _Range$edges4[1];
	      var startBlock = Editor.above(editor, {
	        match: function match(n) {
	          return Editor.isBlock(editor, n);
	        },
	        at: start,
	        voids: voids
	      });
	      var endBlock = Editor.above(editor, {
	        match: function match(n) {
	          return Editor.isBlock(editor, n);
	        },
	        at: end,
	        voids: voids
	      });
	      var isAcrossBlocks = startBlock && endBlock && !Path.equals(startBlock[1], endBlock[1]);
	      var isSingleText = Path.equals(start.path, end.path);
	      var startVoid = voids ? null : Editor["void"](editor, {
	        at: start,
	        mode: 'highest'
	      });
	      var endVoid = voids ? null : Editor["void"](editor, {
	        at: end,
	        mode: 'highest'
	      }); // If the start or end points are inside an inline void, nudge them out.
	
	      if (startVoid) {
	        var before = Editor.before(editor, start);
	        if (before && startBlock && Path.isAncestor(startBlock[1], before.path)) {
	          start = before;
	        }
	      }
	      if (endVoid) {
	        var after = Editor.after(editor, end);
	        if (after && endBlock && Path.isAncestor(endBlock[1], after.path)) {
	          end = after;
	        }
	      } // Get the highest nodes that are completely inside the range, as well as
	      // the start and end nodes.
	
	      var matches = [];
	      var lastPath;
	      var _iterator = _createForOfIteratorHelper(Editor.nodes(editor, {
	          at: at,
	          voids: voids
	        })),
	        _step;
	      try {
	        for (_iterator.s(); !(_step = _iterator.n()).done;) {
	          var entry = _step.value;
	          var _entry = _slicedToArray(entry, 2),
	            _node2 = _entry[0],
	            _path3 = _entry[1];
	          if (lastPath && Path.compare(_path3, lastPath) === 0) {
	            continue;
	          }
	          if (!voids && Editor.isVoid(editor, _node2) || !Path.isCommon(_path3, start.path) && !Path.isCommon(_path3, end.path)) {
	            matches.push(entry);
	            lastPath = _path3;
	          }
	        }
	      } catch (err) {
	        _iterator.e(err);
	      } finally {
	        _iterator.f();
	      }
	      var pathRefs = Array.from(matches, function (_ref) {
	        var _ref2 = _slicedToArray(_ref, 2),
	          p = _ref2[1];
	        return Editor.pathRef(editor, p);
	      });
	      var startRef = Editor.pointRef(editor, start);
	      var endRef = Editor.pointRef(editor, end);
	      if (!isSingleText && !startVoid) {
	        var _point = startRef.current;
	        var _Editor$leaf = Editor.leaf(editor, _point),
	          _Editor$leaf2 = _slicedToArray(_Editor$leaf, 1),
	          node = _Editor$leaf2[0];
	        var path = _point.path;
	        var _start = start,
	          offset = _start.offset;
	        var text = node.text.slice(offset);
	        if (text.length > 0) editor.apply({
	          type: 'remove_text',
	          path: path,
	          offset: offset,
	          text: text
	        });
	      }
	      for (var _i = 0, _pathRefs = pathRefs; _i < _pathRefs.length; _i++) {
	        var pathRef = _pathRefs[_i];
	        var _path = pathRef.unref();
	        Transforms.removeNodes(editor, {
	          at: _path,
	          voids: voids
	        });
	      }
	      if (!endVoid) {
	        var _point2 = endRef.current;
	        var _Editor$leaf3 = Editor.leaf(editor, _point2),
	          _Editor$leaf4 = _slicedToArray(_Editor$leaf3, 1),
	          _node = _Editor$leaf4[0];
	        var _path2 = _point2.path;
	        var _offset = isSingleText ? start.offset : 0;
	        var _text = _node.text.slice(_offset, end.offset);
	        if (_text.length > 0) editor.apply({
	          type: 'remove_text',
	          path: _path2,
	          offset: _offset,
	          text: _text
	        });
	      }
	      if (!isSingleText && isAcrossBlocks && endRef.current && startRef.current) {
	        Transforms.mergeNodes(editor, {
	          at: endRef.current,
	          hanging: true,
	          voids: voids
	        });
	      }
	      var startUnref = startRef.unref();
	      var endUnref = endRef.unref();
	      var point = reverse ? startUnref || endUnref : endUnref || startUnref;
	      if (options.at == null && point) {
	        Transforms.select(editor, point);
	      }
	    });
	  },
	  /**
	   * Insert a fragment at a specific location in the editor.
	   */
	  insertFragment: function insertFragment(editor, fragment) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    Editor.withoutNormalizing(editor, function () {
	      var _options$hanging2 = options.hanging,
	        hanging = _options$hanging2 === void 0 ? false : _options$hanging2,
	        _options$voids2 = options.voids,
	        voids = _options$voids2 === void 0 ? false : _options$voids2;
	      var _options$at2 = options.at,
	        at = _options$at2 === void 0 ? editor.selection : _options$at2;
	      if (!fragment.length) {
	        return;
	      }
	      if (!at) {
	        return;
	      } else if (Range.isRange(at)) {
	        if (!hanging) {
	          at = Editor.unhangRange(editor, at);
	        }
	        if (Range.isCollapsed(at)) {
	          at = at.anchor;
	        } else {
	          var _Range$edges5 = Range.edges(at),
	            _Range$edges6 = _slicedToArray(_Range$edges5, 2),
	            end = _Range$edges6[1];
	          if (!voids && Editor["void"](editor, {
	            at: end
	          })) {
	            return;
	          }
	          var pointRef = Editor.pointRef(editor, end);
	          Transforms["delete"](editor, {
	            at: at
	          });
	          at = pointRef.unref();
	        }
	      } else if (Path.isPath(at)) {
	        at = Editor.start(editor, at);
	      }
	      if (!voids && Editor["void"](editor, {
	        at: at
	      })) {
	        return;
	      } // If the insert point is at the edge of an inline node, move it outside
	      // instead since it will need to be split otherwise.
	
	      var inlineElementMatch = Editor.above(editor, {
	        at: at,
	        match: function match(n) {
	          return Editor.isInline(editor, n);
	        },
	        mode: 'highest',
	        voids: voids
	      });
	      if (inlineElementMatch) {
	        var _inlineElementMatch = _slicedToArray(inlineElementMatch, 2),
	          _inlinePath = _inlineElementMatch[1];
	        if (Editor.isEnd(editor, at, _inlinePath)) {
	          var after = Editor.after(editor, _inlinePath);
	          at = after;
	        } else if (Editor.isStart(editor, at, _inlinePath)) {
	          var before = Editor.before(editor, _inlinePath);
	          at = before;
	        }
	      }
	      var blockMatch = Editor.above(editor, {
	        match: function match(n) {
	          return Editor.isBlock(editor, n);
	        },
	        at: at,
	        voids: voids
	      });
	      var _blockMatch = _slicedToArray(blockMatch, 2),
	        blockPath = _blockMatch[1];
	      var isBlockStart = Editor.isStart(editor, at, blockPath);
	      var isBlockEnd = Editor.isEnd(editor, at, blockPath);
	      var isBlockEmpty = isBlockStart && isBlockEnd;
	      var mergeStart = !isBlockStart || isBlockStart && isBlockEnd;
	      var mergeEnd = !isBlockEnd;
	      var _Node$first = Node.first({
	          children: fragment
	        }, []),
	        _Node$first2 = _slicedToArray(_Node$first, 2),
	        firstPath = _Node$first2[1];
	      var _Node$last = Node.last({
	          children: fragment
	        }, []),
	        _Node$last2 = _slicedToArray(_Node$last, 2),
	        lastPath = _Node$last2[1];
	      var matches = [];
	      var matcher = function matcher(_ref3) {
	        var _ref4 = _slicedToArray(_ref3, 2),
	          n = _ref4[0],
	          p = _ref4[1];
	        var isRoot = p.length === 0;
	        if (isRoot) {
	          return false;
	        }
	        if (isBlockEmpty) {
	          return true;
	        }
	        if (mergeStart && Path.isAncestor(p, firstPath) && Element.isElement(n) && !editor.isVoid(n) && !editor.isInline(n)) {
	          return false;
	        }
	        if (mergeEnd && Path.isAncestor(p, lastPath) && Element.isElement(n) && !editor.isVoid(n) && !editor.isInline(n)) {
	          return false;
	        }
	        return true;
	      };
	      var _iterator2 = _createForOfIteratorHelper(Node.nodes({
	          children: fragment
	        }, {
	          pass: matcher
	        })),
	        _step2;
	      try {
	        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
	          var entry = _step2.value;
	          if (matcher(entry)) {
	            matches.push(entry);
	          }
	        }
	      } catch (err) {
	        _iterator2.e(err);
	      } finally {
	        _iterator2.f();
	      }
	      var starts = [];
	      var middles = [];
	      var ends = [];
	      var starting = true;
	      var hasBlocks = false;
	      for (var _i2 = 0, _matches = matches; _i2 < _matches.length; _i2++) {
	        var _matches$_i = _slicedToArray(_matches[_i2], 1),
	          node = _matches$_i[0];
	        if (Element.isElement(node) && !editor.isInline(node)) {
	          starting = false;
	          hasBlocks = true;
	          middles.push(node);
	        } else if (starting) {
	          starts.push(node);
	        } else {
	          ends.push(node);
	        }
	      }
	      var _Editor$nodes = Editor.nodes(editor, {
	          at: at,
	          match: function match(n) {
	            return Text.isText(n) || Editor.isInline(editor, n);
	          },
	          mode: 'highest',
	          voids: voids
	        }),
	        _Editor$nodes2 = _slicedToArray(_Editor$nodes, 1),
	        inlineMatch = _Editor$nodes2[0];
	      var _inlineMatch = _slicedToArray(inlineMatch, 2),
	        inlinePath = _inlineMatch[1];
	      var isInlineStart = Editor.isStart(editor, at, inlinePath);
	      var isInlineEnd = Editor.isEnd(editor, at, inlinePath);
	      var middleRef = Editor.pathRef(editor, isBlockEnd ? Path.next(blockPath) : blockPath);
	      var endRef = Editor.pathRef(editor, isInlineEnd ? Path.next(inlinePath) : inlinePath);
	      var blockPathRef = Editor.pathRef(editor, blockPath);
	      Transforms.splitNodes(editor, {
	        at: at,
	        match: function match(n) {
	          return hasBlocks ? Editor.isBlock(editor, n) : Text.isText(n) || Editor.isInline(editor, n);
	        },
	        mode: hasBlocks ? 'lowest' : 'highest',
	        voids: voids
	      });
	      var startRef = Editor.pathRef(editor, !isInlineStart || isInlineStart && isInlineEnd ? Path.next(inlinePath) : inlinePath);
	      Transforms.insertNodes(editor, starts, {
	        at: startRef.current,
	        match: function match(n) {
	          return Text.isText(n) || Editor.isInline(editor, n);
	        },
	        mode: 'highest',
	        voids: voids
	      });
	      if (isBlockEmpty && middles.length) {
	        Transforms["delete"](editor, {
	          at: blockPathRef.unref(),
	          voids: voids
	        });
	      }
	      Transforms.insertNodes(editor, middles, {
	        at: middleRef.current,
	        match: function match(n) {
	          return Editor.isBlock(editor, n);
	        },
	        mode: 'lowest',
	        voids: voids
	      });
	      Transforms.insertNodes(editor, ends, {
	        at: endRef.current,
	        match: function match(n) {
	          return Text.isText(n) || Editor.isInline(editor, n);
	        },
	        mode: 'highest',
	        voids: voids
	      });
	      if (!options.at) {
	        var path;
	        if (ends.length > 0) {
	          path = Path.previous(endRef.current);
	        } else if (middles.length > 0) {
	          path = Path.previous(middleRef.current);
	        } else {
	          path = Path.previous(startRef.current);
	        }
	        var _end2 = Editor.end(editor, path);
	        Transforms.select(editor, _end2);
	      }
	      startRef.unref();
	      middleRef.unref();
	      endRef.unref();
	    });
	  },
	  /**
	   * Insert a string of text in the Editor.
	   */
	  insertText: function insertText(editor, text) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    Editor.withoutNormalizing(editor, function () {
	      var _options$voids3 = options.voids,
	        voids = _options$voids3 === void 0 ? false : _options$voids3;
	      var _options$at3 = options.at,
	        at = _options$at3 === void 0 ? editor.selection : _options$at3;
	      if (!at) {
	        return;
	      }
	      if (Path.isPath(at)) {
	        at = Editor.range(editor, at);
	      }
	      if (Range.isRange(at)) {
	        if (Range.isCollapsed(at)) {
	          at = at.anchor;
	        } else {
	          var end = Range.end(at);
	          if (!voids && Editor["void"](editor, {
	            at: end
	          })) {
	            return;
	          }
	          var pointRef = Editor.pointRef(editor, end);
	          Transforms["delete"](editor, {
	            at: at,
	            voids: voids
	          });
	          at = pointRef.unref();
	          Transforms.setSelection(editor, {
	            anchor: at,
	            focus: at
	          });
	        }
	      }
	      if (!voids && Editor["void"](editor, {
	        at: at
	      })) {
	        return;
	      }
	      var _at = at,
	        path = _at.path,
	        offset = _at.offset;
	      if (text.length > 0) editor.apply({
	        type: 'insert_text',
	        path: path,
	        offset: offset,
	        text: text
	      });
	    });
	  }
	};
	function ownKeys(object, enumerableOnly) {
	  var keys = Object.keys(object);
	  if (Object.getOwnPropertySymbols) {
	    var symbols = Object.getOwnPropertySymbols(object);
	    if (enumerableOnly) {
	      symbols = symbols.filter(function (sym) {
	        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
	      });
	    }
	    keys.push.apply(keys, symbols);
	  }
	  return keys;
	}
	function _objectSpread(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? arguments[i] : {};
	    if (i % 2) {
	      ownKeys(Object(source), true).forEach(function (key) {
	        _defineProperty(target, key, source[key]);
	      });
	    } else if (Object.getOwnPropertyDescriptors) {
	      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
	    } else {
	      ownKeys(Object(source)).forEach(function (key) {
	        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
	      });
	    }
	  }
	  return target;
	}
	var Transforms = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, GeneralTransforms), NodeTransforms), SelectionTransforms), TextTransforms);
	exports.Editor = Editor;
	exports.Element = Element;
	exports.Location = Location;
	exports.Node = Node;
	exports.Operation = Operation;
	exports.Path = Path;
	exports.PathRef = PathRef;
	exports.Point = Point;
	exports.PointRef = PointRef;
	exports.Range = Range;
	exports.RangeRef = RangeRef;
	exports.Span = Span;
	exports.Text = Text;
	exports.Transforms = Transforms;
	exports.createEditor = createEditor;


/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createUncontrollable = __webpack_require__(2470);
	
	var _createUncontrollable2 = _interopRequireDefault(_createUncontrollable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mixin = {
	  shouldComponentUpdate: function shouldComponentUpdate() {
	    //let the forceUpdate trigger the update
	    return !this._notifying;
	  }
	};
	
	function set(component, propName, handler, value, args) {
	  if (handler) {
	    component._notifying = true;
	    handler.call.apply(handler, [component, value].concat(args));
	    component._notifying = false;
	  }
	
	  component._values[propName] = value;
	
	  if (!component.unmounted) component.forceUpdate();
	}
	
	exports.default = (0, _createUncontrollable2.default)(mixin, set);
	module.exports = exports['default'];

/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var __DEV__ = ("production") !== 'production';
	
	var warning = function() {};
	
	if (__DEV__) {
	  var printWarning = function printWarning(format, args) {
	    var len = arguments.length;
	    args = new Array(len > 1 ? len - 1 : 0);
	    for (var key = 1; key < len; key++) {
	      args[key - 1] = arguments[key];
	    }
	    var argIndex = 0;
	    var message = 'Warning: ' +
	      format.replace(/%s/g, function() {
	        return args[argIndex++];
	      });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  }
	
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	          '`warning(condition, format, ...args)` requires a warning ' +
	          'message argument'
	      );
	    }
	    if (!condition) {
	      printWarning.apply(null, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	var arrayWithHoles = __webpack_require__(1046);
	var iterableToArrayLimit = __webpack_require__(1049);
	var unsupportedIterableToArray = __webpack_require__(1054);
	var nonIterableRest = __webpack_require__(1050);
	function _slicedToArray(arr, i) {
	  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
	}
	module.exports = _slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.exclamationMarkSVG = exports.alertSVG = exports.phoneIconGreenBorderless = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var phoneIconGreenBorderless = exports.phoneIconGreenBorderless = _react2.default.createElement(
		"svg",
		{ xmlns: "http://www.w3.org/2000/svg", viewBox: "4226.999 4347 16 16" },
		_react2.default.createElement("defs", null),
		_react2.default.createElement("path", { id: "Path_2571", "data-name": "Path 2571", className: "cls-1", d: "M261.9,14.1a13.459,13.459,0,0,0,5.9,5.9l2-2a.959.959,0,0,1,.9-.2,11.27,11.27,0,0,0,3.2.5.9.9,0,0,1,.9.9v3.1a.9.9,0,0,1-.9.9A15.151,15.151,0,0,1,258.8,8.1a.9.9,0,0,1,.9-.9h3.1a.9.9,0,0,1,.9.9,11.27,11.27,0,0,0,.5,3.2.959.959,0,0,1-.2.9Z", transform: "translate(3968.199 4339.8)" })
	);
	
	var alertSVG = exports.alertSVG = _react2.default.createElement(
		"svg",
		{ version: "1.1", id: "Capa_1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
			viewBox: "0 0 20 17.3", enableBackground: "new 0 0 20 17.3", xmlSpace: "preserve" },
		_react2.default.createElement("path", { id: "Path_2100", className: "st0", d: "M0,17.3h20L10,0L0,17.3z M10.9,14.5H9.1v-1.8h1.8L10.9,14.5z M10.9,10.9H9.1V7.3h1.8L10.9,10.9z\r " })
	);
	
	var exclamationMarkSVG = exports.exclamationMarkSVG = _react2.default.createElement(
		"svg",
		{ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 26 26" },
		_react2.default.createElement("path", { id: "Path_2577", "data-name": "Path 2577", d: "M13,0A13,13,0,1,0,26,13,13.038,13.038,0,0,0,13,0Zm1.3,19.5H11.7V11.7h2.6Zm0-10.4H11.7V6.5h2.6Z" })
	);

/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.callHistorySVG = exports.markSvg = exports.pause = exports.playRecord = exports.moveRecord = exports.markInCallSVG = exports.addSVG = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var addSVG = exports.addSVG = _react2.default.createElement(
		"svg",
		{ className: "addSVG", version: "1.1", id: "Capa_1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
			viewBox: "0 0 14 14", enableBackground: "new 0 0 14 14;", xmlSpace: "preserve" },
		_react2.default.createElement(
			"g",
			{ id: "Group_4485", transform: "translate(-4703 1786)" },
			_react2.default.createElement("path", { id: "Path_1521", className: "st0", d: "M4713.7-1778.1h-3v3.2h-1.5v-3.2h-3v-1.6h3v-3.2h1.5v3.2h3V-1778.1z" })
		)
	);
	
	var markInCallSVG = exports.markInCallSVG = _react2.default.createElement(
		"svg",
		{ version: "1.1", id: "Capa_1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
			viewBox: "0 0 8 16", enableBackground: "new 0 0 8 16;", xmlSpace: "preserve" },
		_react2.default.createElement(
			"g",
			{ id: "Group_2743", transform: "translate(2886.486 -140.956)" },
			_react2.default.createElement(
				"g",
				{ transform: "matrix(1, 0, 0, 1, -2886.49, 140.96)" },
				_react2.default.createElement("path", { id: "Path_634-2", className: "st0", d: "M8,7.2L4,12L0,7.2V0h8L8,7.2z" })
			)
		),
		_react2.default.createElement("rect", { id: "Rectangle_785", x: "3", y: "13", className: "st0", width: "2", height: "3" })
	);
	
	var moveRecord = exports.moveRecord = _react2.default.createElement(
		"svg",
		{ version: "1.1", id: "Capa_1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
			viewBox: "0 0 12 12", enableBackground: "new 0 0 12 12", xmlSpace: "preserve" },
		_react2.default.createElement(
			"g",
			{ id: "Group_2810", transform: "translate(7975 1320)" },
			_react2.default.createElement(
				"g",
				{ id: "Group_2680" },
				_react2.default.createElement("path", { id: "Path_1199", fill: "#FFFFFF", d: "M-7965-1317.9l-5.6,4l5.6,4V-1317.9z M-7972.9-1310h1.3v-8h-1.3V-1310z" })
			)
		)
	);
	
	var playRecord = exports.playRecord = _react2.default.createElement(
		"svg",
		{ version: "1.1", id: "Capa_1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
			xmlSpace: "preserve" },
		_react2.default.createElement(
			"g",
			{ className: "ButtonPlayCallLog", id: "Group_2675_2_" },
			_react2.default.createElement(
				"g",
				{ id: "Group_2674_2_" },
				_react2.default.createElement("path", { id: "Path_1194_2_", fill: "#FFFFFF", d: "M7,18.4l12-9l-12-9V18.4z" })
			)
		)
	);
	
	var pause = exports.pause = _react2.default.createElement(
		"svg",
		{ className: "ButtonPauseCallLog", version: "1.1", id: "Capa_1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
			xmlSpace: "preserve" },
		_react2.default.createElement("path", { fill: "#FFFFFF", d: "M3.6,16.4h4v-14h-4V16.4z M11.6,2.4v14h4v-14H11.6z" })
	);
	
	var markSvg = exports.markSvg = _react2.default.createElement(
		"svg",
		{ version: "1.1", className: "iconBarCall", id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", viewBox: "-4765 1782 22 22", enableBackground: "new 0 0 40 40" },
		_react2.default.createElement(
			"g",
			{ id: "Group_4484", "data-name": "Group 4484", transform: "translate(-8196 384.85)" },
			_react2.default.createElement("path", { id: "Path_634", "data-name": "Path 634", className: "cls-1", d: "M-7.924-7.964l-4.038,4.976L-16-7.964V-15.55h8.076Z", transform: "translate(3454.028 1415.7)" }),
			_react2.default.createElement("rect", { id: "Rectangle_258", "data-name": "Rectangle 258", className: "cls-1", width: "14", height: "2", transform: "translate(3435 1414.131)" })
		)
	);
	
	var callHistorySVG = exports.callHistorySVG = _react2.default.createElement(
		"svg",
		{ version: "1.1", id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
			width: "100%", height: "100%", viewBox: "0 0 40 40", enableBackground: "new 0 0 40 40", xmlSpace: "preserve" },
		_react2.default.createElement(
			"g",
			null,
			_react2.default.createElement(
				"linearGradient",
				{ id: "SVGID_1_", gradientUnits: "userSpaceOnUse", x1: "16.3633", y1: "34.4092", x2: "16.3633", y2: "5.6772" },
				_react2.default.createElement("stop", { offset: "0", style: { stopColor: "#F2F2F2" } }),
				_react2.default.createElement("stop", { offset: "1", style: { stopColor: "#FFFFFF" } })
			),
			_react2.default.createElement("path", { fill: "url(#SVGID_1_)", d: "M24.015,22.043c2.163-4.922,2.6-10.615,0.803-16.128c-0.228-0.702-0.995-1.09-1.701-0.863\r L18.61,6.495c-0.707,0.229-1.1,0.987-0.872,1.69l0.753,4.793c0.003,0.492,0.268,0.959,0.745,1.199l3.747,1.902\r c-0.678,4.206-2.703,8.113-5.742,11.133l-3.746-1.9c-0.459-0.233-1.012-0.183-1.412,0.112l-4.359,2.202\r c-0.706,0.227-1.098,0.987-0.87,1.689l1.451,4.458c0.229,0.7,0.996,1.091,1.702,0.863c4.332-1.388,7.957-3.935,10.653-7.177\r C20.922,25.192,22.192,23.234,24.015,22.043z" }),
			_react2.default.createElement(
				"radialGradient",
				{ id: "SVGID_2_", cx: "28.3506", cy: "28.7432", r: "9.5129", gradientUnits: "userSpaceOnUse" },
				_react2.default.createElement("stop", { offset: "0", style: { stopColor: "#00D6FF" } }),
				_react2.default.createElement("stop", { offset: "0.3193", style: { stopColor: "#00C1FF" } }),
				_react2.default.createElement("stop", { offset: "0.9782", style: { stopColor: "#008AFF" } }),
				_react2.default.createElement("stop", { offset: "1", style: { stopColor: "#0088FF" } })
			),
			_react2.default.createElement("path", { fill: "url(#SVGID_2_)", d: "M28.112,22.747c-3.082,0-5.578,2.501-5.578,5.582s2.496,5.583,5.578,5.583\r c3.087,0,5.587-2.502,5.587-5.583S31.199,22.747,28.112,22.747z" }),
			_react2.default.createElement("path", { fill: "#FFFFFF", d: "M28.427,25.491h-0.93v3.722l3.256,1.954l0.466-0.763l-2.792-1.656V25.491z" })
		)
	);

/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _regenerator = __webpack_require__(515);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _singletonSharedData = __webpack_require__(23);
	
	var _constants = __webpack_require__(10);
	
	var _A_messages_to_SM = __webpack_require__(32);
	
	var _reactRedux = __webpack_require__(25);
	
	var _Singleton = __webpack_require__(21);
	
	var _formats = __webpack_require__(54);
	
	var _A_preview = __webpack_require__(52);
	
	var _globalComponentsLibrary = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var language = new _Singleton.Singleton();
	
	var ChangeTypeCampaign = function ChangeTypeCampaign() {
		var dispatch = (0, _reactRedux.useDispatch)();
	
		var _useToasts = (0, _globalComponentsLibrary.useToasts)(),
		    addToast = _useToasts.addToast;
	
		var _useSelector = (0, _reactRedux.useSelector)(function (state) {
			return state.preview;
		}),
		    initialTimeSec = _useSelector.initialTimeSec,
		    totalPreviewTime = _useSelector.totalPreviewTime,
		    callOutId = _useSelector.callOutId,
		    selectedPreviewCampaign = _useSelector.selectedPreviewCampaign,
		    defaultDialingRate = _useSelector.defaultDialingRate;
	
		var isFirstRender = (0, _react.useRef)(true);
		var sharedData = new _singletonSharedData.SingletonSharedData();
		var defaultCampaign = { label: language.getText('GUIPreviewautomaticCamp'), text: language.getText('GUIPreviewautomaticCamp'), value: 0, id: 0, ID: 0 };
	
		(0, _react.useEffect)(function () {
			setTimeout(function () {
				dispatch((0, _A_messages_to_SM.messageApiRequest)(_constants.API_ENDPOINTS.CALL_OUT_CAMPAIGNS, '', true));
			}, 1000);
		}, []);
	
		var campaigns = (0, _react.useMemo)(function () {
	
			if (sharedData.callOutCampaigns) {
				var arrayObjs = Object.values(sharedData.callOutCampaigns);
				if (arrayObjs.length <= 0) return [];
	
				var defaultCampaignTemporal = Object.assign({}, defaultCampaign, { CountJobs: arrayObjs.reduce(function (acm, current) {
						return acm + current.CountJobs;
					}, 0) });
				var actualCampaign = selectedPreviewCampaign ? [defaultCampaignTemporal].concat(_toConsumableArray(arrayObjs)).find(function (item) {
					return item.ID === selectedPreviewCampaign.value;
				}) : defaultCampaignTemporal;
				if (actualCampaign['CountJobs'] <= 0 && !isFirstRender.current && !!selectedPreviewCampaign) {
					addToast(language.getText("GUIAlertMessagependingChange"), {
						group: 'icon',
						position: 'topRight',
						icon: 'warning',
						color: 'yellow',
						btnComponent: _react2.default.createElement(
							_globalComponentsLibrary.AgentButton,
							{ type: 'tertiary' },
							language.getText("GUIAlertMessageclose")
						),
						timeout: 5000
					});
				}
				return [defaultCampaign].concat(_toConsumableArray(arrayObjs.map(function (item) {
					return Object.assign({}, item, { value: item.ID, label: item.Description, text: item.Description, id: item.ID });
				})));
			}
			return [defaultCampaign];
		}, [sharedData.callOutCampaigns]);
	
		var selectCampaign = function () {
			var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(item) {
				return _regenerator2.default.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								if (!isFirstRender.current) {
									_context.next = 3;
									break;
								}
	
								isFirstRender.current = false;
								return _context.abrupt('return');
	
							case 3:
								if (!(item.value === 0 && !!!selectedPreviewCampaign)) {
									_context.next = 5;
									break;
								}
	
								return _context.abrupt('return');
	
							case 5:
								if (!selectedPreviewCampaign) {
									_context.next = 8;
									break;
								}
	
								if (!(item.value === selectedPreviewCampaign.value)) {
									_context.next = 8;
									break;
								}
	
								return _context.abrupt('return');
	
							case 8:
								//TODO: aquí va la definición del factor de marcación
								dispatch((0, _A_preview.setPreviewSelectedCampaign)({ value: item.value, label: item.label, text: item.text }));
								setTimeout(function () {
									var time = (0, _formats.getCurrentTimeInSec)();
									var previewTime = time - initialTimeSec + totalPreviewTime;
	
									dispatch((0, _A_messages_to_SM.actionPreviewRecord)({
										process: 10,
										camId: item.value,
										callOutId: callOutId != "" ? callOutId : 0,
										previewTime: previewTime,
										callId: 0,
										userid: sharedData.getUserData().User_id,
										callOutType: 1
									}));
								}, 500);
								dispatch((0, _A_messages_to_SM.messageApiRequest)(_constants.API_ENDPOINTS.CALL_OUT_CAMPAIGNS, '', true));
	
								addToast(language.getText("GUIAlertMessagenoRecords"), {
									group: 'icon',
									position: 'topRight',
									icon: '',
									color: 'blue',
									btnComponent: _react2.default.createElement(
										_globalComponentsLibrary.AgentButton,
										{ type: 'tertiary' },
										language.getText("GUIAlertMessageclose")
									),
									timeout: 5000
								});
	
							case 12:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, undefined);
			}));
	
			return function selectCampaign(_x) {
				return _ref.apply(this, arguments);
			};
		}();
	
		var getIndexSelectedCampaign = function getIndexSelectedCampaign() {
			if (selectedPreviewCampaign) {
				return campaigns.findIndex(function (item) {
					return item.value === selectedPreviewCampaign.value;
				});
			}
			return 0;
		};
	
		return _react2.default.createElement(
			'div',
			{ className: 'changeTypeCampaign' },
			_react2.default.createElement(_globalComponentsLibrary.SearchSelectionAgent, {
				ignoreCase: true,
				defaultIndex: getIndexSelectedCampaign(),
				options: campaigns.length > 0 ? campaigns : [defaultCampaign],
				filterBy: 'label',
				onSelected: selectCampaign })
		);
	};
	exports.default = ChangeTypeCampaign;

/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(25);
	
	var _Images = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AlertWindow = function (_Component) {
	  _inherits(AlertWindow, _Component);
	
	  // PROPS:
	  // title: Titulo de la ventana
	  // btnYesStyle : Clase con el estilo para boton si
	  // btnNoStyle : Clase con el estilo para boton no
	  // btnNo=Titulo para boton no
	  // btnYes=Titulo para boton si
	  // body: Cuerpo de la alerta
	  // onYes=Callback para clic en yes
	  // onNo=CallBack para clic en no
	  // isGlobe: True - vista de globo False - Vista normal
	  // isInfo: True - ícono de alerta | False - Vista ícono de información
	
	  function AlertWindow(props) {
	    _classCallCheck(this, AlertWindow);
	
	    var _this = _possibleConstructorReturn(this, (AlertWindow.__proto__ || Object.getPrototypeOf(AlertWindow)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(AlertWindow, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: this.props.isGlobe ? "alertGlobe" : "alertSquare" },
	        _react2.default.createElement(
	          'div',
	          { className: this.props.isGlobe ? "headerGlobe" : "headerSquare" },
	          this.props.isInfo ? _react2.default.createElement('i', { id: 'AW-icon-warning', className: 'gcl-icon warning' }) : _react2.default.createElement('img', { className: 'alertIcon', src: _Images.alert, alt: 'icon' }),
	          _react2.default.createElement(
	            'p',
	            { className: 'titleAlert' },
	            this.props.title
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'bodyAlert' },
	          this.props.body
	        ),
	        this.props.onYes && _react2.default.createElement(
	          'div',
	          { className: this.props.btnYesStyle ? this.props.btnYesStyle : "alertBtn btnYes", onClick: function onClick() {
	              return _this2.props.onYes();
	            } },
	          this.props.btnYes
	        ),
	        this.props.onNo && _react2.default.createElement(
	          'div',
	          { className: this.props.btnNoStyle ? this.props.btnNoStyle : "alertBtn btnNo", onClick: function onClick() {
	              return _this2.props.onNo();
	            } },
	          this.props.btnNo
	        )
	      );
	    }
	  }]);
	
	  return AlertWindow;
	}(_react.Component);
	
	exports.default = AlertWindow = (0, _reactRedux.connect)(null, null)(AlertWindow);

/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Images = __webpack_require__(30);
	
	var _SettingsSGV = __webpack_require__(491);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PasswordTextArea = function (_Component) {
	  _inherits(PasswordTextArea, _Component);
	
	  function PasswordTextArea(props) {
	    _classCallCheck(this, PasswordTextArea);
	
	    var _this = _possibleConstructorReturn(this, (PasswordTextArea.__proto__ || Object.getPrototypeOf(PasswordTextArea)).call(this, props));
	
	    _this.state = {
	      passVisible: false
	    };
	    return _this;
	  }
	
	  _createClass(PasswordTextArea, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.inputText = this.refs["inputTextPass"];
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      this.inputText.focus();
	    }
	  }, {
	    key: 'preventDragHandler',
	    value: function preventDragHandler(e) {
	      e.preventDefault();
	      this.setState({ passVisible: false });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: "passwordTextContainer " + (this.props.hasError ? " hasError" : ""), style: { height: this.props.height || 26, width: this.props.width || 158, marginLeft: this.props.marginLeft !== null ? this.props.marginLeft : 10 } },
	        this.props.image && _react2.default.createElement(
	          'div',
	          { className: 'iconForm' },
	          _SettingsSGV.passIcon
	        ),
	        _react2.default.createElement('input', { type: this.state.passVisible ? "text" : "password",
	          ref: 'inputTextPass',
	          className: "passwordLocked " + (this.props.image ? "withImage" : ""),
	          maxLength: '30',
	          value: this.props.value,
	          onChange: function onChange(event) {
	            return _this2.props.onChange(event.target.value);
	          },
	          onBlur: function onBlur() {
	            return _this2.props.onBlur && _this2.props.onBlur();
	          },
	          onKeyPress: function onKeyPress(event) {
	            event.key === 'Enter' && _this2.props.onEnterKey && _this2.props.onEnterKey();
	          } }),
	        this.state.passVisible ? _react2.default.createElement('img', { src: _Images.showPassword, alt: 'icon', draggable: 'false', className: "changePassImgItem " + (this.props.value && "visible"), onMouseUp: function onMouseUp() {
	            return _this2.setState({ passVisible: false });
	          }, onDragStart: function onDragStart(e) {
	            return _this2.preventDragHandler(e);
	          } }) : _react2.default.createElement('img', { src: _Images.hiddenPassword, alt: 'icon', draggable: 'false', className: "changePassImgItem " + (this.props.value && "visible"), onMouseDown: function onMouseDown() {
	            return _this2.setState({ passVisible: true });
	          }, onDragStart: function onDragStart(e) {
	            return _this2.preventDragHandler(e);
	          } })
	      );
	    }
	  }]);
	
	  return PasswordTextArea;
	}(_react.Component);
	
	exports.default = PasswordTextArea;

/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _formats = __webpack_require__(54);
	
	var _NoAvailableSVG = __webpack_require__(114);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TimerCountDown(_ref) {
	  var timeToRate = _ref.timeToRate,
	      lineWidth = _ref.lineWidth,
	      colorDown = _ref.colorDown,
	      colorUp = _ref.colorUp,
	      size = _ref.size,
	      showingTimer = _ref.showingTimer,
	      fontsize = _ref.fontsize,
	      _ref$onTimesUp = _ref.onTimesUp,
	      onTimesUp = _ref$onTimesUp === undefined ? function () {} : _ref$onTimesUp,
	      _ref$showInfinite = _ref.showInfinite,
	      showInfinite = _ref$showInfinite === undefined ? true : _ref$showInfinite,
	      _ref$waitingWrapUp = _ref.waitingWrapUp,
	      waitingWrapUp = _ref$waitingWrapUp === undefined ? false : _ref$waitingWrapUp,
	      onOneSecondRemaining = _ref.onOneSecondRemaining;
	
	  var _useState = (0, _react.useState)(timeToRate),
	      _useState2 = _slicedToArray(_useState, 2),
	      propTimeToRate = _useState2[0],
	      setTimeToRate = _useState2[1];
	
	  var initialTime = (0, _react.useRef)(timeToRate);
	  var startDate = (0, _react.useRef)(new Date());
	  var canvasRef = (0, _react.useRef)(null);
	  var contextCanvasRef = (0, _react.useRef)(null);
	  var timerRateRef = (0, _react.useRef)(null);
	
	  (0, _react.useEffect)(function () {
	    startTimer();
	  }, []);
	
	  (0, _react.useEffect)(function () {
	    startTimer();
	    return function () {
	      if (timerRateRef.current) {
	        clearInterval(timerRateRef.current);
	      }
	    };
	  }, [waitingWrapUp]);
	
	  function startTimer() {
	    var canvas = canvasRef.current;
	    if (canvas) {
	      var contextCanvas = canvas.getContext('2d');
	      contextCanvasRef.current = contextCanvas;
	      drawArc(-Math.PI / 2.0, Math.PI * 1.5);
	      if (!timerRateRef.current) {
	        if (propTimeToRate > 0) {
	          setTimer();
	        }
	        if (propTimeToRate <= 0 && !waitingWrapUp) {
	          setTimerUp();
	        }
	      }
	    }
	    return function () {
	      clearInterval(timerRateRef.current);
	      timerRateRef.current = null;
	    };
	  }
	
	  function setTimer() {
	    if (timerRateRef.current) {
	      clearInterval(timerRateRef.current);
	      timerRateRef.current = null;
	    }
	    timerRateRef.current = setInterval(timeRate, 1000);
	    function timeRate() {
	      var currentDate = new Date();
	      var seconds = (currentDate - startDate.current) / 1000;
	      var remainingSeconds = Math.round(initialTime.current - seconds);
	      setTimeToRate(remainingSeconds);
	      var startAngle = -Math.PI / 2.0;
	      var newAngle = startAngle + remainingSeconds / initialTime.current * (Math.PI * 2.0);
	      drawArc(startAngle, newAngle);
	      if (remainingSeconds <= 1) {
	        onOneSecondRemaining();
	      }
	      if (remainingSeconds <= 0) {
	        onTimesUp();
	        clearInterval(timerRateRef.current);
	      }
	    }
	  }
	
	  function setTimerUp() {
	    if (timerRateRef.current) {
	      clearInterval(timerRateRef.current);
	      timerRateRef.current = null;
	    }
	    timerRateRef.current = setInterval(timeRateUp, 1000);
	    function timeRateUp() {
	      var currentDate = new Date();
	      var seconds = (currentDate - startDate.current) / 1000;
	      setTimeToRate(seconds);
	    }
	  }
	
	  function drawArc(startAngle, endAngle) {
	    var contextCanvas = contextCanvasRef.current;
	    if (!contextCanvas) return;
	    if (canvasRef.current === null) return;
	    contextCanvas.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);
	    contextCanvas.strokeStyle = '#CDCCCC';
	    contextCanvas.fillStyle = 'transparent';
	    contextCanvas.lineWidth = lineWidth;
	    contextCanvas.beginPath();
	    var position = size / 2;
	    contextCanvas.arc(position, position, size / 2 - lineWidth / 2, 0, Math.PI * 2.0, false);
	    contextCanvas.fill();
	    contextCanvas.stroke();
	    var gradient = contextCanvas.createLinearGradient(0, 0, 0, 50);
	    gradient.addColorStop('0', colorDown);
	    gradient.addColorStop('1.0', colorUp);
	    contextCanvas.strokeStyle = gradient;
	    contextCanvas.fillStyle = 'transparent';
	    contextCanvas.lineWidth = lineWidth;
	    contextCanvas.beginPath();
	    contextCanvas.arc(position, position, size / 2 - lineWidth / 2, startAngle, endAngle, false);
	    contextCanvas.fill();
	    contextCanvas.stroke();
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'counterContainer', style: { width: size + 3 + 'px', height: size + 3 + 'px' } },
	    showingTimer && _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement('canvas', { ref: canvasRef, className: 'canvasCounter', width: size, height: size }),
	      propTimeToRate === 0 && showInfinite ? _react2.default.createElement(
	        'div',
	        { className: 'rateTime padding4' },
	        _NoAvailableSVG.infinito
	      ) : _react2.default.createElement(
	        'p',
	        { className: 'rateTime ' + fontsize, style: { width: size + 'px', height: size + 'px' } },
	        waitingWrapUp ? '00:00:00' : (0, _formats.secondsToFormat)(propTimeToRate, false)
	      )
	    )
	  );
	}
	
	TimerCountDown.propTypes = {
	  timeToRate: _propTypes2.default.number.isRequired,
	  lineWidth: _propTypes2.default.number.isRequired,
	  colorDown: _propTypes2.default.string.isRequired,
	  colorUp: _propTypes2.default.string.isRequired,
	  size: _propTypes2.default.number.isRequired,
	  showingTimer: _propTypes2.default.bool.isRequired,
	  fontsize: _propTypes2.default.string.isRequired,
	  onTimesUp: _propTypes2.default.func
	};
	
	exports.default = TimerCountDown;

/***/ },
/* 327 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getNoAvailableRecord = getNoAvailableRecord;
	exports.setNoAvailableRecord = setNoAvailableRecord;
	exports.observerRecordNAhistory = observerRecordNAhistory;
	exports.getNoAvailableList = getNoAvailableList;
	exports.setNoAvailableList = setNoAvailableList;
	exports.observerNoAvailableList = observerNoAvailableList;
	var NO_AVAILABLE_LIST = null;
	var NO_AVAILABLE_RECORD = null;
	var observerNAhistory = null;
	var observerNAList = null;
	
	function getNoAvailableRecord() {
	  return NO_AVAILABLE_RECORD;
	}
	function setNoAvailableRecord(record) {
	  if (!record) {
	    NO_AVAILABLE_RECORD = null;
	  } else {
	    NO_AVAILABLE_RECORD = [];
	    for (var i in record) {
	      NO_AVAILABLE_RECORD.push(record[i]);
	    }
	    if (observerNAhistory) {
	      observerNAhistory();
	    }
	  }
	}
	function observerRecordNAhistory(supervisorObserver) {
	  observerNAhistory = supervisorObserver;
	}
	
	function getNoAvailableList() {
	  return NO_AVAILABLE_LIST;
	}
	function setNoAvailableList(noAvailableList) {
	  NO_AVAILABLE_LIST = noAvailableList;
	  if (observerNAList) {
	    observerNAList();
	  }
	}
	function observerNoAvailableList(listObserver) {
	  observerNAList = listObserver;
	}

/***/ },
/* 328 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.setCookie = setCookie;
	exports.getCookie = getCookie;
	function setCookie(cname, cvalue) {
	    var d = new Date();
	    d.setTime(d.getTime() + 356 * 24 * 60 * 60 * 1000);
	    var expires = "expires=" + d.toUTCString();
	    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	}
	
	function getCookie(cname) {
	    var name = cname + "=";
	    var ca = document.cookie.split(';');
	    for (var i = 0; i < ca.length; i++) {
	        var c = ca[i];
	        while (c.charAt(0) === ' ') {
	            c = c.substring(1);
	        }
	        if (c.indexOf(name) === 0) {
	            return c.substring(name.length, c.length);
	        }
	    }
	    return "";
	}

/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.messageIntegration = messageIntegration;
	exports.changeIsIntegration = changeIsIntegration;
	
	var _constants = __webpack_require__(10);
	
	function messageIntegration(data) {
	  return {
	    type: _constants.ACTIONS_INTEGRATION.MESSAGE,
	    dataIntegration: data
	  };
	}
	
	function changeIsIntegration() {
	  return {
	    type: _constants.ACTIONS_INTEGRATION.CHANGE_IS_INTEGRATION
	  };
	}

/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	   value: true
	});
	exports.chatConversationRead = exports.updateConversationsPhoneChange = exports.deleteDraftMessage = exports.updateDraftAttachments = exports.updateDraftMessage = exports.createDraftMessage = exports.updatePermissions = exports.resetTimeout = exports.errorOnHistoricalConversation = exports.newHistoricalConversation = exports.fetchingConversation = exports.updateConvsDeletedByError = exports.endConversationsCampaignDeleted = exports.conversationTimeoutReached = exports.changeStateMultimediaAll = exports.changeStateMultimedia = exports.firstCallNewPreview = exports.setMultimediaDispositions = exports.selectConversation = exports.changeStateMessage = exports.changeStateExternalMessage = exports.newUnifiedInboxExternalNewMessage = exports.alertMessageErrorMMC = exports.newUnifiedInboxExternalMessage = exports.newUnifiedInboxMessage = exports.chatTakeover = exports.chatAnswersTemplates = exports.chatTyping = exports.newUnifiedInboxConversation = exports.endConversationClient = exports.endConversationChat = exports.showUnifiedMessagesWindow = undefined;
	
	var _constants = __webpack_require__(10);
	
	var _ = __webpack_require__(1011);
	
	var _2 = _interopRequireDefault(_);
	
	var _3 = __webpack_require__(1012);
	
	var _4 = _interopRequireDefault(_3);
	
	var _5 = __webpack_require__(1013);
	
	var _6 = _interopRequireDefault(_5);
	
	var _7 = __webpack_require__(1014);
	
	var _8 = _interopRequireDefault(_7);
	
	var _9 = __webpack_require__(1015);
	
	var _10 = _interopRequireDefault(_9);
	
	var _11 = __webpack_require__(1016);
	
	var _12 = _interopRequireDefault(_11);
	
	var _13 = __webpack_require__(1017);
	
	var _14 = _interopRequireDefault(_13);
	
	var _15 = __webpack_require__(1018);
	
	var _16 = _interopRequireDefault(_15);
	
	var _17 = __webpack_require__(1019);
	
	var _18 = _interopRequireDefault(_17);
	
	var _19 = __webpack_require__(1020);
	
	var _20 = _interopRequireDefault(_19);
	
	var _21 = __webpack_require__(1021);
	
	var _22 = _interopRequireDefault(_21);
	
	var _23 = __webpack_require__(1022);
	
	var _24 = _interopRequireDefault(_23);
	
	var _25 = __webpack_require__(1023);
	
	var _26 = _interopRequireDefault(_25);
	
	var _27 = __webpack_require__(1024);
	
	var _28 = _interopRequireDefault(_27);
	
	var _29 = __webpack_require__(1025);
	
	var _30 = _interopRequireDefault(_29);
	
	var _31 = __webpack_require__(1026);
	
	var _32 = _interopRequireDefault(_31);
	
	var _33 = __webpack_require__(1027);
	
	var _34 = _interopRequireDefault(_33);
	
	var _35 = __webpack_require__(1028);
	
	var _36 = _interopRequireDefault(_35);
	
	var _37 = __webpack_require__(1029);
	
	var _38 = _interopRequireDefault(_37);
	
	var _39 = __webpack_require__(1030);
	
	var _40 = _interopRequireDefault(_39);
	
	var _41 = __webpack_require__(1031);
	
	var _42 = _interopRequireDefault(_41);
	
	var _43 = __webpack_require__(1032);
	
	var _44 = _interopRequireDefault(_43);
	
	var _45 = __webpack_require__(1033);
	
	var _46 = _interopRequireDefault(_45);
	
	var _47 = __webpack_require__(1034);
	
	var _48 = _interopRequireDefault(_47);
	
	var _49 = __webpack_require__(1035);
	
	var _50 = _interopRequireDefault(_49);
	
	var _51 = __webpack_require__(1036);
	
	var _52 = _interopRequireDefault(_51);
	
	var _53 = __webpack_require__(1037);
	
	var _54 = _interopRequireDefault(_53);
	
	var _55 = __webpack_require__(1038);
	
	var _56 = _interopRequireDefault(_55);
	
	var _57 = __webpack_require__(1039);
	
	var _58 = _interopRequireDefault(_57);
	
	var _59 = __webpack_require__(1040);
	
	var _60 = _interopRequireDefault(_59);
	
	var _61 = __webpack_require__(1041);
	
	var _62 = _interopRequireDefault(_61);
	
	var _63 = __webpack_require__(1042);
	
	var _64 = _interopRequireDefault(_63);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ACDImageCatalog = {
	   1: _2.default,
	   2: _4.default,
	   3: _6.default,
	   4: _8.default,
	   5: _10.default,
	   6: _12.default,
	   7: _14.default,
	   8: _16.default,
	   9: _18.default,
	   10: _20.default,
	   11: _22.default,
	   12: _24.default,
	   13: _26.default,
	   14: _28.default,
	   15: _30.default,
	   16: _32.default,
	   17: _34.default,
	   18: _36.default,
	   19: _38.default,
	   20: _40.default,
	   21: _42.default,
	   22: _44.default,
	   23: _46.default,
	   24: _48.default,
	   25: _50.default,
	   26: _52.default,
	   27: _54.default,
	   28: _56.default,
	   29: _58.default,
	   30: _60.default,
	   31: _62.default,
	   32: _64.default
	
	};
	
	var showUnifiedMessagesWindow = exports.showUnifiedMessagesWindow = function showUnifiedMessagesWindow(show) {
	   return { type: _constants.ACTIONS_FROM_UNIFIED_INBOX.SHOW, show: show };
	};
	
	var endConversationChat = exports.endConversationChat = function endConversationChat(message) {
	   return { type: _constants.ACTIONS_FROM_UNIFIED_INBOX.CHAT_CUSTOMER_TERMINATION, conversationId: message.ConversationID, campType: message.CampType != null ? message.CampType : 0 };
	};
	var endConversationClient = exports.endConversationClient = function endConversationClient(message, clientTermination) {
	   return { type: _constants.ACTIONS_FROM_UNIFIED_INBOX.CHAT_CLIENT_DISCONNECT, conversationId: message.ConversationID, clientTermination: clientTermination, campType: message.CampType != null ? message.CampType : 0 };
	};
	
	var newUnifiedInboxConversation = exports.newUnifiedInboxConversation = function newUnifiedInboxConversation(message) {
	   return {
	      type: _constants.ACTIONS_FROM_UNIFIED_INBOX.NEW_CONVERSATION[message.ServiceType],
	      conversationId: message.ConversationId,
	      acdId: message.acdID,
	      acdName: message.ACDName,
	      image: ACDImageCatalog[message.ACDGraphicId],
	      name: message.ClientName,
	      accountMail: message.InboundEmail,
	      account: message.ServiceType === 3 ? '@' + message.ClientAddress : message.ClientAddress,
	      photo: undefined,
	      initialTime: new Date(),
	      showWrapUp: message.showWrapUp,
	      wrapUpTime: message.WrapUpTime,
	      content: message.EmailMessagesList,
	      timeoutWarning: message.AlertMessageTime,
	      timeout: message.AnswerTimeOut,
	      TwitterMessagesList: message.TwitterMessagesList,
	      senderName: message.SenderName,
	      IsAzure: message.IsAzure,
	      origin: message.origin,
	      campType: message.CampType
	   };
	};
	
	var chatTyping = exports.chatTyping = function chatTyping(message) {
	   return {
	      type: _constants.ACTIONS_FROM_UNIFIED_INBOX.TYPING,
	      conversationId: message.ConversationID,
	      campType: message.CampType != null ? message.CampType : 0,
	      typing: message.ShowAnimation
	   };
	};
	
	var chatAnswersTemplates = exports.chatAnswersTemplates = function chatAnswersTemplates(message) {
	   return {
	      type: _constants.ACTIONS_FROM_UNIFIED_INBOX.ANSWERS_TEMPLATES_CHAT,
	      conversationId: message.ConversationId,
	      answers: message.answers,
	      maxImgChat: message.maxImgChat,
	      campType: message.CampType != null ? message.CampType : 0
	   };
	};
	
	var chatTakeover = exports.chatTakeover = function chatTakeover(message) {
	   return {
	      type: _constants.ACTIONS_FROM_UNIFIED_INBOX.CHAT_TAKEOVER,
	      conversationId: message.ConversationID,
	      takeover: message.takeover,
	      campType: message.CampType != null ? message.CampType : 0
	   };
	};
	
	var newUnifiedInboxMessage = exports.newUnifiedInboxMessage = function newUnifiedInboxMessage(message) {
	   return {
	      type: _constants.ACTIONS_FROM_UNIFIED_INBOX.NEW_MESSAGE_INBOX[message.ServiceType],
	      conversationId: message.ConversationId,
	      content: message.Message,
	      origin: message.origin ? message.origin : 'AGENT',
	      date: new Date(),
	      subject: message.Subject,
	      media: message.Type ? message.Type : 'Text',
	      campType: message.CamType != null ? message.CamType : 0
	   };
	};
	var newUnifiedInboxExternalMessage = exports.newUnifiedInboxExternalMessage = function newUnifiedInboxExternalMessage(message) {
	   return {
	      type: _constants.ACTIONS_FROM_UNIFIED_INBOX.EXTERNAL_MESSAGING_CUSTOMER,
	      conversationId: message.externalMessagingCustomerDto.ConversationID,
	      name: message.externalMessagingCustomerDto.ClientId,
	      AgentId: message.externalMessagingCustomerDto.AgentId,
	      ConversationState: message.externalMessagingCustomerDto.ConversationState,
	      account: message.externalMessagingCustomerDto.To,
	      serviceType: message.externalMessagingCustomerDto.ServiceType,
	      campaign: message.externalMessagingCustomerDto.Campaign,
	      clientTermination: message.externalMessagingCustomerDto.ClientTermination,
	      initialTime: new Date(),
	      totalTime: 0,
	      content: message.externalMessagingCustomerDto.Messages,
	      image: ACDImageCatalog[message.externalMessagingCustomerDto.Campaign.ACDGraphicId],
	      showWrapUp: message.externalMessagingCustomerDto.Campaign.ShowCalifWnd,
	      to: message.externalMessagingCustomerDto.To,
	      from: message.externalMessagingCustomerDto.From,
	      SecTimeOutLastMessageAgent: message.externalMessagingCustomerDto.SecTimeOutLastMessageAgent,
	      allowUnassign: message.externalMessagingCustomerDto.AllowUnassign,
	      allowSpam: message.externalMessagingCustomerDto.AllowSpam,
	      lastConversations: message.externalMessagingCustomerDto.LastConversations
	   };
	};
	var alertMessageErrorMMC = exports.alertMessageErrorMMC = function alertMessageErrorMMC(message) {
	   return {
	      type: _constants.ACTIONS_FROM_UNIFIED_INBOX.MULTIMEDIA_MESSAGE_ERROR_MMC,
	      value: message.value
	   };
	};
	var newUnifiedInboxExternalNewMessage = exports.newUnifiedInboxExternalNewMessage = function newUnifiedInboxExternalNewMessage(message) {
	   return {
	      type: _constants.ACTIONS_FROM_UNIFIED_INBOX.EXTERNAL_NEW_MESSAGING,
	      conversationId: message.ConversationID,
	      origin: message.Origin,
	      content: message.Content,
	      date: message.Date ? message.Date : new Date(),
	      messageId: message.UIMessageId,
	      status: message.statusMesage ? message.statusMesage : '',
	      messagesList: message.messagesList,
	      MessageType: message.MessageType,
	      Attachments: message.Attachments,
	      campType: message.CampType != null ? message.CampType : message.CamType != null ? message.CamType : 0,
	      graphicId: message.GraphicId
	   };
	};
	var changeStateExternalMessage = exports.changeStateExternalMessage = function changeStateExternalMessage(message) {
	   return {
	      type: message.subAction,
	      conversationId: message.ConversationID,
	      unreadMessage: message.unreadMessage,
	      campType: message.campType
	   };
	};
	var changeStateMessage = exports.changeStateMessage = function changeStateMessage(message) {
	   return {
	      type: message.subAction,
	      conversationId: message.ConversationID,
	      messageId: message.messageUIID,
	      status: message.statusMessage === 'submitted' ? 'send' : message.statusMessage === 'rejected' || message.statusMessage === 'undeliverable' ? 'error' : message.statusMessage,
	      campType: message.CampType != null ? message.CampType : 0
	   };
	};
	var selectConversation = exports.selectConversation = function selectConversation(campType, selectedID) {
	   return {
	      type: _constants.ACTIONS_FROM_UNIFIED_INBOX.SELECT_CONVERSATION,
	      campType: campType,
	      selectedID: selectedID
	   };
	};
	
	var setMultimediaDispositions = exports.setMultimediaDispositions = function setMultimediaDispositions(message) {
	   return {
	      type: _constants.ACTIONS_FROM_UNIFIED_INBOX.MULTIMEDIA_DISPOSITION,
	      conversationId: message.ConversationId,
	      dispositions: message.DispositionList,
	      campType: message.CampType != null ? message.CampType : 0
	   };
	};
	var firstCallNewPreview = exports.firstCallNewPreview = function firstCallNewPreview(dataCall) {
	   return {
	      CamId: dataCall.CamId,
	      CallKey: dataCall.CallKey,
	      Phone: dataCall.Telephone,
	      Data: dataCall.Data,
	      ExistsCallout: 0,
	      CallMode: 2
	   };
	};
	
	var changeStateMultimedia = exports.changeStateMultimedia = function changeStateMultimedia(message) {
	   return { type: _constants.ACTIONS_FROM_UNIFIED_INBOX.CHANGE_STATE_MULTIMEDIA, data: message.data };
	};
	var changeStateMultimediaAll = exports.changeStateMultimediaAll = function changeStateMultimediaAll(message) {
	   return { type: _constants.ACTIONS_FROM_UNIFIED_INBOX.CHANGE_STATE_MULTIMEDIA_ALL, data: message.data };
	};
	
	var conversationTimeoutReached = exports.conversationTimeoutReached = function conversationTimeoutReached(message) {
	   return {
	      type: _constants.ACTIONS_FROM_UNIFIED_INBOX.CONVERSATION_TIMEOUT_REACHED,
	      conversationId: message.ConversationID,
	      campType: message.CampType != null ? message.CampType : 0
	   };
	};
	
	var endConversationsCampaignDeleted = exports.endConversationsCampaignDeleted = function endConversationsCampaignDeleted(message) {
	   return {
	      type: _constants.ACTIONS_FROM_UNIFIED_INBOX.END_CONVERSATIONS_CAMPAIGN_DELETED,
	      conversationIds: message.ConversationIDs,
	      campType: message.CampType
	   };
	};
	
	var updateConvsDeletedByError = exports.updateConvsDeletedByError = function updateConvsDeletedByError() {
	   return {
	      type: _constants.ACTIONS_FROM_UNIFIED_INBOX.UPDATE_CONVS_DELETED_BY_ERROR
	   };
	};
	
	var fetchingConversation = exports.fetchingConversation = function fetchingConversation(message) {
	   return {
	      type: _constants.ACTIONS_FROM_UNIFIED_INBOX.FETCHING_CONVERSATION,
	      conversationId: message.id,
	      fetching: message.fetching,
	      campType: message.campType
	   };
	};
	
	var newHistoricalConversation = exports.newHistoricalConversation = function newHistoricalConversation(message) {
	   return {
	      type: _constants.ACTIONS_FROM_UNIFIED_INBOX.NEW_HISTORICAL_CONVERSATION,
	      lastConversationId: message.Data.LastConversationId,
	      lastConversation: message.Data.LastConversation,
	      conversationId: message.Data.ConversationID,
	      campType: message.Data.CampType != null ? message.Data.CampType : 0
	   };
	};
	
	var errorOnHistoricalConversation = exports.errorOnHistoricalConversation = function errorOnHistoricalConversation(message) {
	   return {
	      type: _constants.ACTIONS_FROM_UNIFIED_INBOX.ERROR_HISTORICAL_CONVERSATION,
	      errorCode: message.Data.ResponseCode,
	      errorDescription: message.Data.ResponseCodeDescription,
	      lastConversationId: message.Data.LastConversationId,
	      conversationId: message.Data.ConversationID,
	      campType: message.Data.CampType,
	      isAllConversations: message.Data.IsAllConversations
	   };
	};
	
	var resetTimeout = exports.resetTimeout = function resetTimeout(data) {
	   return {
	      type: _constants.ACTIONS_FROM_UNIFIED_INBOX.RESET_TIMEOUT,
	      conversationId: data.conversationId,
	      campType: data.campType
	   };
	};
	
	var updatePermissions = exports.updatePermissions = function updatePermissions(permissionName, permissionValue) {
	   return {
	      type: _constants.ACTIONS_FROM_UNIFIED_INBOX.UPDATE_PERMISSION,
	      permissionName: permissionName,
	      permissionValue: permissionValue
	   };
	};
	
	var createDraftMessage = exports.createDraftMessage = function createDraftMessage(id) {
	   return {
	      type: _constants.ACTIONS_FROM_UNIFIED_INBOX.NEW_DRAFT_MESSAGE,
	      id: id
	   };
	};
	
	var updateDraftMessage = exports.updateDraftMessage = function updateDraftMessage(id, data) {
	   return {
	      type: _constants.ACTIONS_FROM_UNIFIED_INBOX.UPDATE_DRAFT_MESSAGE,
	      id: id,
	      data: data
	   };
	};
	
	var updateDraftAttachments = exports.updateDraftAttachments = function updateDraftAttachments(id, data) {
	   return {
	      type: _constants.ACTIONS_FROM_UNIFIED_INBOX.UPDATE_DRAFT_ATTACHMENTS,
	      id: id,
	      data: data
	   };
	};
	
	var deleteDraftMessage = exports.deleteDraftMessage = function deleteDraftMessage(id) {
	   return {
	      type: _constants.ACTIONS_FROM_UNIFIED_INBOX.DELETE_DRAFT_MESSAGE,
	      id: id
	   };
	};
	
	var updateConversationsPhoneChange = exports.updateConversationsPhoneChange = function updateConversationsPhoneChange(message) {
	   return {
	      type: _constants.ACTIONS_FROM_UNIFIED_INBOX.UPDATE_CONVERSATIONS_PHONE_CHANGE,
	      conversationIds: message.ConversationIDs,
	      campType: message.CampType
	   };
	};
	
	var chatConversationRead = exports.chatConversationRead = function chatConversationRead(campType, idConversation) {
	   return {
	      type: _constants.ACTIONS_FROM_UNIFIED_INBOX.CHAT_CONVERSATION_READ,
	      idConversation: idConversation,
	      campType: campType
	   };
	};

/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.setAllowPlayRecordsOnCallHistory = undefined;
	exports.setAllowChangeDialing = setAllowChangeDialing;
	
	var _constants = __webpack_require__(10);
	
	var setAllowPlayRecordsOnCallHistory = exports.setAllowPlayRecordsOnCallHistory = function setAllowPlayRecordsOnCallHistory(allowPlayRecordsOnCallHistory) {
	    return {
	        type: _constants.AGENT_PERMISSIONS_ACTIONS.ALLOW_PLAY_RECORDS_ON_CALL_HISTORY,
	        allowPlayRecordsOnCallHistory: allowPlayRecordsOnCallHistory
	    };
	};
	
	function setAllowChangeDialing(data) {
	    return {
	        type: _constants.AGENT_PERMISSIONS_ACTIONS.SET_ALLOW_CHANGE_DIALING,
	        payload: data
	    };
	}

/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.newAssistedTransferState = newAssistedTransferState;
	
	var _constants = __webpack_require__(10);
	
	function newAssistedTransferState(newState) {
	  return {
	    type: _constants.ASSISTED_TRANSFER.CHANGE_STATE,
	    currentState: newState
	  };
	}

/***/ },
/* 333 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var MANUAL_ACTIONS = exports.MANUAL_ACTIONS = {
	    SET_MESSAGE_STATUS: 'SET_MESSAGE_STATUS',
	    SET_MESSAGE_CONV_ID: 'SET_MESSAGE_CONV_ID',
	    MULTIMEDIA_MESSAGE_STATUS: "MULTIMEDIA_MESSAGE_STATUS"
	};
	
	var setMessageStatus = exports.setMessageStatus = function setMessageStatus(manualMessageStatus, phone) {
	    var convId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	    return {
	        type: MANUAL_ACTIONS.SET_MESSAGE_STATUS,
	        manualMessageStatus: manualMessageStatus,
	        phone: phone,
	        convId: convId
	    };
	};
	
	var setMessageConvId = exports.setMessageConvId = function setMessageConvId(convId) {
	    return {
	        type: MANUAL_ACTIONS.SET_MESSAGE_CONV_ID,
	        convId: convId
	    };
	};

/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reduxActions = __webpack_require__(995);
	
	var ONGOING_CALL_IVR_MODAL_SHOW = 'ONGOING_CALL_IVR_MODAL_SHOW';
	var ONGOING_CALL_IVR_MODAL_HIDE = 'ONGOING_CALL_IVR_MODAL_HIDE';
	
	var showModal = (0, _reduxActions.createAction)(ONGOING_CALL_IVR_MODAL_SHOW);
	var hideModal = (0, _reduxActions.createAction)(ONGOING_CALL_IVR_MODAL_HIDE);
	
	exports.default = {
	  types: {
	    ONGOING_CALL_IVR_MODAL_SHOW: ONGOING_CALL_IVR_MODAL_SHOW,
	    ONGOING_CALL_IVR_MODAL_HIDE: ONGOING_CALL_IVR_MODAL_HIDE
	  },
	  creators: {
	    showModal: showModal,
	    hideModal: hideModal
	  }
	};

/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.volumeSpeaker = volumeSpeaker;
	exports.volumeMicrophone = volumeMicrophone;
	
	var _constants = __webpack_require__(10);
	
	function volumeSpeaker(volume) {
	  return {
	    type: _constants.VOLUME.SPEAKER,
	    volume: volume
	  };
	}
	
	function volumeMicrophone(volume) {
	  return {
	    type: _constants.VOLUME.MICROPHONE,
	    volume: volume
	  };
	}

/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.setShowPswResetAlert = undefined;
	
	var _constants = __webpack_require__(10);
	
	var initialState = {
		type: '',
		showAlert: false
	};
	var setFlagShowAlert = function setFlagShowAlert() {
		var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
		var action = arguments[1];
	
		switch (action.type) {
			case _constants.USER_ACTIONS.SHOW_PSW_RESET:
				return Object.assign({}, state, {
					showAlert: action.action
				});
			default:
				return state;
		}
	};
	var setShowPswResetAlert = exports.setShowPswResetAlert = function setShowPswResetAlert(action) {
		return { type: _constants.USER_ACTIONS.SHOW_PSW_RESET, action: action };
	};
	
	exports.default = setFlagShowAlert;

/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(1202);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(1201);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(420);
	var GetIntrinsic = __webpack_require__(218);
	var setFunctionLength = __webpack_require__(2464);
	
	var $TypeError = __webpack_require__(175);
	var $apply = GetIntrinsic('%Function.prototype.apply%');
	var $call = GetIntrinsic('%Function.prototype.call%');
	var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);
	
	var $defineProperty = __webpack_require__(419);
	var $max = GetIntrinsic('%Math.max%');
	
	module.exports = function callBind(originalFunction) {
		if (typeof originalFunction !== 'function') {
			throw new $TypeError('a function is required');
		}
		var func = $reflectApply(bind, $call, arguments);
		return setFunctionLength(
			func,
			1 + $max(0, originalFunction.length - (arguments.length - 1)),
			true
		);
	};
	
	var applyBind = function applyBind() {
		return $reflectApply(bind, $apply, arguments);
	};
	
	if ($defineProperty) {
		$defineProperty(module.exports, 'apply', { value: applyBind });
	} else {
		module.exports.apply = applyBind;
	}


/***/ },
/* 339 */
104,
/* 340 */
[2628, 1230],
/* 341 */
105,
/* 342 */
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ },
/* 343 */
[2644, 158, 1245, 342, 346, 521, 1236],
/* 344 */
252,
/* 345 */
[2655, 133, 132, 88],
/* 346 */
[2656, 347, 244],
/* 347 */
[2657, 76, 103, 242],
/* 348 */
94,
/* 349 */
[2663, 160],
/* 350 */
[2664, 103, 76, 242, 351, 133],
/* 351 */
[2665, 88],
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var at = __webpack_require__(368)(true);
	
	 // `AdvanceStringIndex` abstract operation
	// https://tc39.github.io/ecma262/#sec-advancestringindex
	module.exports = function (S, index, unicode) {
	  return index + (unicode ? at(S, index).length : 1);
	};


/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(65);
	var toAbsoluteIndex = __webpack_require__(142);
	var toLength = __webpack_require__(47);
	module.exports = function fill(value /* , start = 0, end = @length */) {
	  var O = toObject(this);
	  var length = toLength(O.length);
	  var aLen = arguments.length;
	  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
	  var end = aLen > 2 ? arguments[2] : undefined;
	  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
	  while (endPos > index) O[index++] = value;
	  return O;
	};


/***/ },
/* 354 */
[2627, 57, 141],
/* 355 */
[2630, 36, 35],
/* 356 */
342,
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	var MATCH = __webpack_require__(44)('match');
	module.exports = function (KEY) {
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch (e) {
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch (f) { /* empty */ }
	  } return true;
	};


/***/ },
/* 358 */
[2633, 35],
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(36);
	var setPrototypeOf = __webpack_require__(366).set;
	module.exports = function (that, target, C) {
	  var S = target.constructor;
	  var P;
	  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
	    setPrototypeOf(that, P);
	  } return that;
	};


/***/ },
/* 360 */
[2636, 162, 44],
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(36);
	var cof = __webpack_require__(104);
	var MATCH = __webpack_require__(44)('match');
	module.exports = function (it) {
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};


/***/ },
/* 362 */
[2640, 136, 11, 68, 78, 162, 543, 165, 139, 44],
/* 363 */
/***/ function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x) {
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;


/***/ },
/* 364 */
/***/ function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};


/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var regexpFlags = __webpack_require__(248);
	
	var nativeExec = RegExp.prototype.exec;
	// This always refers to the native implementation, because the
	// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
	// which loads this file before patching the method.
	var nativeReplace = String.prototype.replace;
	
	var patchedExec = nativeExec;
	
	var LAST_INDEX = 'lastIndex';
	
	var UPDATES_LAST_INDEX_WRONG = (function () {
	  var re1 = /a/,
	      re2 = /b*/g;
	  nativeExec.call(re1, 'a');
	  nativeExec.call(re2, 'a');
	  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
	})();
	
	// nonparticipating capturing group, copied from es5-shim's String#split patch.
	var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;
	
	var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;
	
	if (PATCH) {
	  patchedExec = function exec(str) {
	    var re = this;
	    var lastIndex, reCopy, match, i;
	
	    if (NPCG_INCLUDED) {
	      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
	    }
	    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];
	
	    match = nativeExec.call(re, str);
	
	    if (UPDATES_LAST_INDEX_WRONG && match) {
	      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
	    }
	    if (NPCG_INCLUDED && match && match.length > 1) {
	      // Fix browsers whose `exec` methods don't consistently return `undefined`
	      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
	      // eslint-disable-next-line no-loop-func
	      nativeReplace.call(match[0], reCopy, function () {
	        for (i = 1; i < arguments.length - 2; i++) {
	          if (arguments[i] === undefined) match[i] = undefined;
	        }
	      });
	    }
	
	    return match;
	  };
	}
	
	module.exports = patchedExec;


/***/ },
/* 366 */
[2654, 36, 33, 91, 92],
/* 367 */
[2656, 254, 143],
/* 368 */
[2658, 94, 105],
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(361);
	var defined = __webpack_require__(105);
	
	module.exports = function (that, searchString, NAME) {
	  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};


/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var toInteger = __webpack_require__(94);
	var defined = __webpack_require__(105);
	
	module.exports = function repeat(count) {
	  var str = String(defined(this));
	  var res = '';
	  var n = toInteger(count);
	  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
	  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
	  return res;
	};


/***/ },
/* 371 */
/***/ function(module, exports) {

	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(91);
	var invoke = __webpack_require__(540);
	var html = __webpack_require__(358);
	var cel = __webpack_require__(355);
	var global = __webpack_require__(35);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(104)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(35);
	var DESCRIPTORS = __webpack_require__(56);
	var LIBRARY = __webpack_require__(136);
	var $typed = __webpack_require__(255);
	var hide = __webpack_require__(78);
	var redefineAll = __webpack_require__(163);
	var fails = __webpack_require__(34);
	var anInstance = __webpack_require__(161);
	var toInteger = __webpack_require__(94);
	var toLength = __webpack_require__(47);
	var toIndex = __webpack_require__(558);
	var gOPN = __webpack_require__(138).f;
	var dP = __webpack_require__(57).f;
	var arrayFill = __webpack_require__(353);
	var setToStringTag = __webpack_require__(165);
	var ARRAY_BUFFER = 'ArrayBuffer';
	var DATA_VIEW = 'DataView';
	var PROTOTYPE = 'prototype';
	var WRONG_LENGTH = 'Wrong length!';
	var WRONG_INDEX = 'Wrong index!';
	var $ArrayBuffer = global[ARRAY_BUFFER];
	var $DataView = global[DATA_VIEW];
	var Math = global.Math;
	var RangeError = global.RangeError;
	// eslint-disable-next-line no-shadow-restricted-names
	var Infinity = global.Infinity;
	var BaseBuffer = $ArrayBuffer;
	var abs = Math.abs;
	var pow = Math.pow;
	var floor = Math.floor;
	var log = Math.log;
	var LN2 = Math.LN2;
	var BUFFER = 'buffer';
	var BYTE_LENGTH = 'byteLength';
	var BYTE_OFFSET = 'byteOffset';
	var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
	var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
	var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;
	
	// IEEE754 conversions based on https://github.com/feross/ieee754
	function packIEEE754(value, mLen, nBytes) {
	  var buffer = new Array(nBytes);
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
	  var i = 0;
	  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
	  var e, m, c;
	  value = abs(value);
	  // eslint-disable-next-line no-self-compare
	  if (value != value || value === Infinity) {
	    // eslint-disable-next-line no-self-compare
	    m = value != value ? 1 : 0;
	    e = eMax;
	  } else {
	    e = floor(log(value) / LN2);
	    if (value * (c = pow(2, -e)) < 1) {
	      e--;
	      c *= 2;
	    }
	    if (e + eBias >= 1) {
	      value += rt / c;
	    } else {
	      value += rt * pow(2, 1 - eBias);
	    }
	    if (value * c >= 2) {
	      e++;
	      c /= 2;
	    }
	    if (e + eBias >= eMax) {
	      m = 0;
	      e = eMax;
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * pow(2, eBias - 1) * pow(2, mLen);
	      e = 0;
	    }
	  }
	  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
	  e = e << mLen | m;
	  eLen += mLen;
	  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
	  buffer[--i] |= s * 128;
	  return buffer;
	}
	function unpackIEEE754(buffer, mLen, nBytes) {
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var nBits = eLen - 7;
	  var i = nBytes - 1;
	  var s = buffer[i--];
	  var e = s & 127;
	  var m;
	  s >>= 7;
	  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
	  if (e === 0) {
	    e = 1 - eBias;
	  } else if (e === eMax) {
	    return m ? NaN : s ? -Infinity : Infinity;
	  } else {
	    m = m + pow(2, mLen);
	    e = e - eBias;
	  } return (s ? -1 : 1) * m * pow(2, e - mLen);
	}
	
	function unpackI32(bytes) {
	  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
	}
	function packI8(it) {
	  return [it & 0xff];
	}
	function packI16(it) {
	  return [it & 0xff, it >> 8 & 0xff];
	}
	function packI32(it) {
	  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
	}
	function packF64(it) {
	  return packIEEE754(it, 52, 8);
	}
	function packF32(it) {
	  return packIEEE754(it, 23, 4);
	}
	
	function addGetter(C, key, internal) {
	  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
	}
	
	function get(view, bytes, index, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = store.slice(start, start + bytes);
	  return isLittleEndian ? pack : pack.reverse();
	}
	function set(view, bytes, index, conversion, value, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = conversion(+value);
	  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
	}
	
	if (!$typed.ABV) {
	  $ArrayBuffer = function ArrayBuffer(length) {
	    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
	    var byteLength = toIndex(length);
	    this._b = arrayFill.call(new Array(byteLength), 0);
	    this[$LENGTH] = byteLength;
	  };
	
	  $DataView = function DataView(buffer, byteOffset, byteLength) {
	    anInstance(this, $DataView, DATA_VIEW);
	    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
	    var bufferLength = buffer[$LENGTH];
	    var offset = toInteger(byteOffset);
	    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
	    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
	    this[$BUFFER] = buffer;
	    this[$OFFSET] = offset;
	    this[$LENGTH] = byteLength;
	  };
	
	  if (DESCRIPTORS) {
	    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
	    addGetter($DataView, BUFFER, '_b');
	    addGetter($DataView, BYTE_LENGTH, '_l');
	    addGetter($DataView, BYTE_OFFSET, '_o');
	  }
	
	  redefineAll($DataView[PROTOTYPE], {
	    getInt8: function getInt8(byteOffset) {
	      return get(this, 1, byteOffset)[0] << 24 >> 24;
	    },
	    getUint8: function getUint8(byteOffset) {
	      return get(this, 1, byteOffset)[0];
	    },
	    getInt16: function getInt16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	    },
	    getUint16: function getUint16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return bytes[1] << 8 | bytes[0];
	    },
	    getInt32: function getInt32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1]));
	    },
	    getUint32: function getUint32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
	    },
	    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
	    },
	    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
	    },
	    setInt8: function setInt8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packF32, value, arguments[2]);
	    },
	    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
	      set(this, 8, byteOffset, packF64, value, arguments[2]);
	    }
	  });
	} else {
	  if (!fails(function () {
	    $ArrayBuffer(1);
	  }) || !fails(function () {
	    new $ArrayBuffer(-1); // eslint-disable-line no-new
	  }) || fails(function () {
	    new $ArrayBuffer(); // eslint-disable-line no-new
	    new $ArrayBuffer(1.5); // eslint-disable-line no-new
	    new $ArrayBuffer(NaN); // eslint-disable-line no-new
	    return $ArrayBuffer.name != ARRAY_BUFFER;
	  })) {
	    $ArrayBuffer = function ArrayBuffer(length) {
	      anInstance(this, $ArrayBuffer);
	      return new BaseBuffer(toIndex(length));
	    };
	    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
	    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
	      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
	    }
	    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
	  }
	  // iOS Safari 7.x bug
	  var view = new $DataView(new $ArrayBuffer(2));
	  var $setInt8 = $DataView[PROTOTYPE].setInt8;
	  view.setInt8(0, 2147483648);
	  view.setInt8(1, 2147483649);
	  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
	    setInt8: function setInt8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    }
	  }, true);
	}
	setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	setToStringTag($DataView, DATA_VIEW);
	hide($DataView[PROTOTYPE], $typed.VIEW, true);
	exports[ARRAY_BUFFER] = $ArrayBuffer;
	exports[DATA_VIEW] = $DataView;


/***/ },
/* 374 */
[2665, 44],
/* 375 */
[2667, 201, 44, 162, 46],
/* 376 */
[2669, 135, 544, 162, 79, 362],
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.withLinks = exports.withImages = exports.UINEditor = void 0;
	var _helpers = __webpack_require__(53);
	var _slate = __webpack_require__(317);
	var _constants = __webpack_require__(58);
	var _escapeHtml = _interopRequireDefault(__webpack_require__(1723));
	var _UINEditor;
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
	function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
	function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
	function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
	function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
	function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	var withLinks = exports.withLinks = function withLinks(editor) {
	  var insertData = editor.insertData,
	    insertText = editor.insertText,
	    isInline = editor.isInline;
	  editor.isInline = function (element) {
	    return element.type === 'link' ? true : isInline(element);
	  };
	  editor.insertText = function (text) {
	    if (text && (0, _helpers.isValidURL)(text)) {
	      UINEditor.wrapLink(editor, text);
	    } else {
	      insertText(text);
	    }
	  };
	  editor.insertData = function (data) {
	    var text = data.getData('text/plain');
	    if (text && (0, _helpers.isValidURL)(text)) {
	      UINEditor.wrapLink(editor, text);
	    } else {
	      insertData(data);
	    }
	  };
	  return editor;
	};
	var withImages = exports.withImages = function withImages(editor) {
	  var insertData = editor.insertData,
	    isVoid = editor.isVoid,
	    normalizeNode = editor.normalizeNode;
	  editor.normalizeNode = function (entry) {
	    var _entry = _slicedToArray(entry, 2),
	      node = _entry[0],
	      path = _entry[1];
	    if (_slate.Element.isElement(node) && node.type === 'image') {
	      if (path[0] === editor.children.length - 1) {
	        _slate.Transforms.insertNodes(editor, {
	          type: 'paragraph',
	          children: [{
	            text: '',
	            font: 'Arial',
	            size: '14px'
	          }]
	        });
	        return;
	      }
	    }
	    normalizeNode(entry);
	  };
	  editor.isVoid = function (element) {
	    return element.type === 'image' ? true : isVoid(element);
	  };
	  editor.insertData = function (data) {
	    var text = data.getData('text/plain');
	    var files = data.files;
	    if (files && files.length > 0) {
	      var _iterator = _createForOfIteratorHelper(files),
	        _step;
	      try {
	        var _loop = function _loop() {
	          var file = _step.value;
	          var reader = new FileReader();
	          var _file$type$split = file.type.split('/'),
	            _file$type$split2 = _slicedToArray(_file$type$split, 1),
	            mime = _file$type$split2[0];
	          if (mime === 'image') {
	            reader.addEventListener('load', function () {
	              var url = reader.result;
	              UINEditor.insertImage(editor, url);
	            });
	            reader.readAsDataURL(file);
	          }
	        };
	        for (_iterator.s(); !(_step = _iterator.n()).done;) {
	          _loop();
	        }
	      } catch (err) {
	        _iterator.e(err);
	      } finally {
	        _iterator.f();
	      }
	    } else if ((0, _helpers.isImageURL)(text)) {
	      UINEditor.insertImage(editor, text);
	    } else {
	      insertData(data);
	    }
	  };
	  return editor;
	};
	var UINEditor = exports.UINEditor = (_UINEditor = {
	  currentMark: function currentMark(editor, name) {
	    var marks = _slate.Editor.marks(editor);
	    return marks ? marks[name] : null;
	  },
	  isMarkActive: function isMarkActive(editor, name, value) {
	    var marks = _slate.Editor.marks(editor);
	    return marks ? marks[name] === value : false;
	  },
	  toggleMark: function toggleMark(editor, name, value) {
	    var isActive = UINEditor.isMarkActive(editor, name, value);
	    if (isActive) _slate.Editor.removeMark(editor, name);
	    _slate.Editor.addMark(editor, name, value);
	  },
	  activeAlign: function activeAlign(editor) {
	    var _Editor$nodes = _slate.Editor.nodes(editor, {
	        match: function match(n) {
	          return n.align;
	        }
	      }),
	      _Editor$nodes2 = _slicedToArray(_Editor$nodes, 1),
	      match = _Editor$nodes2[0];
	    return match ? match[0].align : null;
	  },
	  isAlignActive: function isAlignActive(editor, align) {
	    var _Editor$nodes3 = _slate.Editor.nodes(editor, {
	        match: function match(n) {
	          return n.align === align;
	        }
	      }),
	      _Editor$nodes4 = _slicedToArray(_Editor$nodes3, 1),
	      match = _Editor$nodes4[0];
	    return !!match;
	  },
	  toggleAlign: function toggleAlign(editor, align) {
	    var isActive = UINEditor.isAlignActive(editor, align);
	    _slate.Transforms.setNodes(editor, {
	      align: isActive ? undefined : align
	    });
	  },
	  isTypeActive: function isTypeActive(editor, type) {
	    var _Editor$nodes5 = _slate.Editor.nodes(editor, {
	        match: function match(n) {
	          return n.type === type;
	        }
	      }),
	      _Editor$nodes6 = _slicedToArray(_Editor$nodes5, 1),
	      match = _Editor$nodes6[0];
	    return !!match;
	  },
	  toggleType: function toggleType(editor, type) {
	    var isActive = UINEditor.isTypeActive(editor, type);
	    var isList = _constants.LIST_TYPES.includes(type);
	    _slate.Transforms.unwrapNodes(editor, {
	      match: function match(n) {
	        return _constants.LIST_TYPES.includes(n.type);
	      },
	      split: true
	    });
	    _slate.Transforms.setNodes(editor, {
	      type: isActive ? 'paragraph' : isList ? 'list-item' : type
	    });
	    if (!isActive && isList) {
	      var block = {
	        type: type,
	        children: []
	      };
	      _slate.Transforms.wrapNodes(editor, block);
	    }
	  },
	  wrapLinkUpdate: function wrapLinkUpdate(editor, url, text, prevurl, prevText) {
	    var point = UINEditor.getLinkNodePath(editor, prevurl, prevText);
	    _slate.Transforms.removeNodes(editor, {
	      at: point
	    });
	    UINEditor.wrapLink(editor, url, text, {
	      at: point
	    });
	  },
	  getLinkNodePath: function getLinkNodePath(editor, prevurl, prevText) {
	    for (var firstChild = 0; firstChild < editor.children.length; firstChild++) {
	      for (var secondChild = 0; secondChild < editor.children[firstChild].children.length; secondChild++) {
	        if (editor.children[firstChild].children[secondChild].type === "link" && editor.children[firstChild].children[secondChild].children[0].text === prevText && editor.children[firstChild].children[secondChild].url === prevurl) {
	          var point = [firstChild, secondChild];
	          return point;
	        }
	      }
	    }
	  },
	  unwrapLink: function unwrapLink(editor) {
	    _slate.Transforms.unwrapNodes(editor, {
	      match: function match(n) {
	        return n.type === 'link';
	      }
	    });
	  },
	  wrapLink: function wrapLink(editor, url, text, options) {
	    if (UINEditor.isTypeActive(editor, 'link')) {
	      UINEditor.unwrapLink(editor);
	    }
	    var selection = editor.selection;
	    var isCollapsed = selection && _slate.Range.isCollapsed(selection);
	    var link = {
	      type: 'link',
	      url: url,
	      children: !selection || isCollapsed ? [{
	        text: text || url
	      }] : []
	    };
	    if (!selection || isCollapsed) {
	      if (options) {
	        _slate.Transforms.insertNodes(editor, link, options);
	      } else {
	        _slate.Transforms.insertNodes(editor, link);
	      }
	    } else {
	      _slate.Transforms.wrapNodes(editor, link, {
	        split: true
	      });
	      _slate.Transforms.collapse(editor, {
	        edge: 'end'
	      });
	    }
	  },
	  changTypeLinkNode: function changTypeLinkNode(editor, url, text) {
	    var point = UINEditor.getLinkNodePath(editor, url, text);
	    var pointAux = _toConsumableArray(point);
	    pointAux[0] = editor.children.length;
	    pointAux[pointAux.length - 1] = pointAux[pointAux.length - 1] - 1;
	    _slate.Transforms.removeNodes(editor, {
	      at: point
	    });
	    _slate.Transforms.insertNodes(editor, {
	      type: 'paragraph',
	      children: [{
	        text: text,
	        font: 'Arial',
	        size: '14px'
	      }]
	    });
	    _slate.Transforms.moveNodes(editor, {
	      at: pointAux,
	      to: point
	    });
	  },
	  insertImage: function insertImage(editor, url) {
	    var image = {
	      type: 'image',
	      url: url,
	      children: [{
	        text: ''
	      }]
	    };
	    _slate.Transforms.insertNodes(editor, image);
	  }
	}, _defineProperty(_UINEditor, "insertImage", function insertImage(editor, url, name, isAzure) {
	  var image = {
	    type: 'image',
	    url: url,
	    name: name,
	    isAzure: isAzure,
	    children: [{
	      text: ''
	    }]
	  };
	  _slate.Transforms.insertNodes(editor, image);
	}), _defineProperty(_UINEditor, "deleteMark", function deleteMark(editor) {
	  _slate.Editor.removeMark(editor);
	}), _defineProperty(_UINEditor, "getNodeList", function getNodeList(editor, type) {
	  var auxedit = _objectSpread({}, editor);
	  for (var firstChild = 0; firstChild < auxedit.children.length; firstChild++) {
	    if (auxedit.children[firstChild].type === type) {
	      return firstChild;
	    }
	  }
	}), _defineProperty(_UINEditor, "serialize", function serialize(node) {
	  if (_constants.LIST_TYPES[0] === node.type) {
	    var data = node.children.map(function (n) {
	      return UINEditor.serialize(n);
	    }).join('');
	    var n = _slate.Node.get(node, [0, 0]);
	    return "<ol style=\"".concat(n.color ? "color: ".concat(n.color, "; ") : '').concat(n.font ? "font-family: ".concat(_constants.FONTS[n.font], "; ") : '').concat(n.size ? "font-size: ".concat(n.size, "; ") : '', "\"> ").concat(data, " </ol>");
	  }
	  if (_constants.LIST_TYPES[1] === node.type) {
	    var _data = node.children.map(function (n) {
	      return UINEditor.serialize(n);
	    }).join('');
	    var _n = _slate.Node.get(node, [0, 0]);
	    return "<ul style=\"".concat(_n.color ? "color: ".concat(_n.color, "; ") : '').concat(_n.font ? "font-family: ".concat(_constants.FONTS[_n.font], "; ") : '').concat(_n.size ? "font-size: ".concat(_n.size, "; ") : '', "\"> ").concat(_data, " </ul>");
	  }
	  if (node.type === 'list-item') {
	    var _data2 = node.children.map(function (n) {
	      return UINEditor.serialize(n);
	    }).join('');
	    return "<li> ".concat(_data2, " </li>");
	  }
	  if (_slate.Text.isText(node)) {
	    return "<span style=\"".concat(node.color ? "color: ".concat(node.color, "; ") : '').concat(node.font ? "font-family: ".concat(_constants.FONTS[node.font], "; ") : '').concat(node.size ? "font-size: ".concat(node.size, "; ") : '', "\">").concat((0, _escapeHtml["default"])(node.text), "</span>");
	  }
	  var children = node.children.map(function (n) {
	    return UINEditor.serialize(n);
	  }).join('');
	  switch (node.type) {
	    case 'paragraph':
	      return "<div".concat(node.align ? " style=\"text-align: ".concat(node.align, ";\"") : '', ">").concat(children, "</div>");
	    case 'link':
	      return "<a href=\"".concat((0, _escapeHtml["default"])(node.url), "\">").concat(children, "</a>");
	    case 'image':
	      if (node.isAzure) {
	        return "<div".concat(node.align ? " style=\"text-align: ".concat(node.align, ";\"") : '', "><div><img alt=\"\" src=\"cid:").concat(node.name, "\" /></div>").concat(children, "</div>");
	      } else {
	        return "<div".concat(node.align ? " style=\"text-align: ".concat(node.align, ";\"") : '', "><div><img alt=\"\" src=\"").concat((0, _escapeHtml["default"])(node.url), "\" /></div>").concat(children, "</div>");
	      }
	    default:
	      return children;
	  }
	}), _defineProperty(_UINEditor, "resetSelection", function resetSelection(editor) {
	  _slate.Transforms.select(editor, [0]);
	}), _UINEditor);

/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var _react = _interopRequireWildcard(__webpack_require__(1));
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	var _reactI18next = __webpack_require__(41);
	var _reactstrap = __webpack_require__(70);
	__webpack_require__(2488);
	var _types = __webpack_require__(60);
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
	function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	var MediaViewer = function MediaViewer(_ref) {
	  var show = _ref.show,
	    toggle = _ref.toggle,
	    multimediaFiles = _ref.multimediaFiles,
	    index = _ref.index,
	    withFooter = _ref.withFooter;
	  var _useTranslation = (0, _reactI18next.useTranslation)(['media-viewer']),
	    t = _useTranslation.t;
	  var _useState = (0, _react.useState)(false),
	    _useState2 = _slicedToArray(_useState, 2),
	    tooltipDownload = _useState2[0],
	    setTooltipDownload = _useState2[1];
	  var _useState3 = (0, _react.useState)(false),
	    _useState4 = _slicedToArray(_useState3, 2),
	    tooltipBack = _useState4[0],
	    setTooltipBack = _useState4[1];
	  var _useState5 = (0, _react.useState)(0),
	    _useState6 = _slicedToArray(_useState5, 2),
	    activeFile = _useState6[0],
	    setActiveFile = _useState6[1];
	  var _useState7 = (0, _react.useState)(false),
	    _useState8 = _slicedToArray(_useState7, 2),
	    multimedia = _useState8[0],
	    setMultimedia = _useState8[1];
	  var aRef = (0, _react.useRef)(null);
	  var download = function download() {
	    aRef.current.click();
	  };
	  (0, _react.useEffect)(function () {
	    return function () {
	      setTooltipBack(false);
	    };
	  }, [show]);
	  (0, _react.useEffect)(function () {
	    setActiveFile(index ? index : 0);
	  }, [index]);
	  (0, _react.useEffect)(function () {
	    if (multimediaFiles.length > 0) {
	      var arr = multimediaFiles.map(function (file) {
	        return {
	          media: file.url,
	          mediaType: file.mediaType,
	          mediaName: splitName(file.url)
	        };
	      });
	      setMultimedia(arr);
	    }
	  }, [multimediaFiles]);
	  var splitName = function splitName(url) {
	    if (url.indexOf('\\') > -1) {
	      var temp = url.split('\\');
	      return temp[temp.length - 1];
	    } else {
	      var _temp = url.split('/');
	      return _temp[_temp.length - 1];
	    }
	  };
	  var slide = function slide(direction) {
	    setActiveFile(direction === 'left' ? activeFile - 1 : activeFile + 1);
	  };
	  var _ref2 = multimedia && multimedia[activeFile],
	    media = _ref2.media,
	    mediaType = _ref2.mediaType,
	    mediaName = _ref2.mediaName;
	  return /*#__PURE__*/_react["default"].createElement(_reactstrap.Modal, {
	    className: "uin-media-viewer ".concat(withFooter ? 'withFooter' : ''),
	    isOpen: show,
	    toggle: toggle,
	    centered: true
	  }, /*#__PURE__*/_react["default"].createElement("a", {
	    ref: aRef,
	    href: media,
	    download: mediaName,
	    target: "_blank",
	    rel: "noopener noreferrer",
	    style: {
	      display: 'none'
	    }
	  }, mediaName), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-media-viewer__header"
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-media-viewer__back"
	  }, /*#__PURE__*/_react["default"].createElement("i", {
	    id: "uin-mv-icon-back",
	    className: "gcl-icon arrow",
	    onClick: toggle
	  }), /*#__PURE__*/_react["default"].createElement(_reactstrap.Tooltip, {
	    placement: "bottom",
	    isOpen: tooltipBack,
	    target: "uin-mv-icon-back",
	    toggle: function toggle() {
	      return setTooltipBack(!tooltipBack);
	    }
	  }, t('back'))), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-media-viewer__name"
	  }, mediaName), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-media-viewer__download"
	  }, /*#__PURE__*/_react["default"].createElement("i", {
	    id: "uin-mv-icon-download",
	    className: "gcl-icon download",
	    onClick: download
	  }), /*#__PURE__*/_react["default"].createElement(_reactstrap.Tooltip, {
	    placement: "bottom",
	    isOpen: tooltipDownload,
	    target: "uin-mv-icon-download",
	    toggle: function toggle() {
	      return setTooltipDownload(!tooltipDownload);
	    }
	  }, t('download')))), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-media-viewer__content ".concat(withFooter ? 'withFooter' : '')
	  }, withFooter && /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-previus-miniature ".concat(activeFile === 0 && 'disabled')
	  }, /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon clickable chevron-left",
	    disabled: activeFile === 0,
	    onClick: function onClick() {
	      return slide('left');
	    }
	  })), media && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, mediaType === 'image' && /*#__PURE__*/_react["default"].createElement("img", {
	    src: media,
	    alt: mediaName,
	    onClick: download
	  }), mediaType === 'video' && /*#__PURE__*/_react["default"].createElement("video", {
	    preload: "auto",
	    autoPlay: true,
	    controls: true,
	    src: media,
	    onClick: download
	  }), mediaType === 'audio' && /*#__PURE__*/_react["default"].createElement("audio", {
	    preload: "auto",
	    autoPlay: true,
	    controls: true,
	    src: media,
	    onClick: download
	  })), withFooter && /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-previus-miniature ".concat(activeFile === multimedia.length - 1 && 'disabled')
	  }, /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon clickable chevron-right",
	    disabled: activeFile === multimedia.length - 1,
	    onClick: function onClick() {
	      return slide('right');
	    }
	  }))), withFooter && /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-media-viewer__footer"
	  }, multimedia && multimedia.map(function (v, i) {
	    return /*#__PURE__*/_react["default"].createElement("div", {
	      key: i,
	      className: "uin-miniaturs ".concat(activeFile === i && 'active'),
	      onClick: function onClick() {
	        return setActiveFile(i);
	      }
	    }, v.mediaType === 'image' ? /*#__PURE__*/_react["default"].createElement("img", {
	      src: v.media,
	      alt: ""
	    }) : v.mediaType === 'audio' ? /*#__PURE__*/_react["default"].createElement("audio", {
	      src: v.media,
	      preload: "metadata"
	    }) : v.mediaType === 'video' ? /*#__PURE__*/_react["default"].createElement("video", {
	      src: v.media,
	      preload: "metadata"
	    }) : /*#__PURE__*/_react["default"].createElement("div", null, "otro tipo"));
	  })));
	};
	MediaViewer.propTypes = {
	  show: _propTypes["default"].bool.isRequired,
	  toggle: _propTypes["default"].func.isRequired,
	  multimediaFiles: _propTypes["default"].arrayOf(_types.arrayMultimedia).isRequired,
	  index: _propTypes["default"].number,
	  withFooter: _propTypes["default"].bool
	};
	MediaViewer.defaultProps = {
	  withFooter: false
	};
	var _default = exports["default"] = MediaViewer;

/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = processNodes;
	
	var _isEmptyTextNode = __webpack_require__(1449);
	
	var _isEmptyTextNode2 = _interopRequireDefault(_isEmptyTextNode);
	
	var _convertNodeToElement = __webpack_require__(596);
	
	var _convertNodeToElement2 = _interopRequireDefault(_convertNodeToElement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Processes the nodes generated by htmlparser2 and convert them all into React elements
	 *
	 * @param {Object[]} nodes List of nodes to process
	 * @param {Function} transform Transform function to optionally apply to nodes
	 * @returns {React.Element[]} The list of processed React elements
	 */
	function processNodes(nodes, transform) {
	
	  return nodes.filter(function (node) {
	    return !(0, _isEmptyTextNode2.default)(node);
	  }).map(function (node, index) {
	
	    // return the result of the transform function if applicable
	    var transformed = void 0;
	    if (typeof transform === 'function') {
	      transformed = transform(node, index);
	      if (transformed === null || !!transformed) {
	        return transformed;
	      }
	    }
	
	    // otherwise convert the node as standard
	    return (0, _convertNodeToElement2.default)(node, index, transform);
	  });
	}

/***/ },
/* 380 */
[2682, 12],
/* 381 */
[2704, 12],
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-shape/ v1.3.7 Copyright 2019 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports, __webpack_require__(1532)) :
	typeof define === 'function' && define.amd ? define(['exports', 'd3-path'], factory) :
	(global = global || self, factory(global.d3 = global.d3 || {}, global.d3));
	}(this, function (exports, d3Path) { 'use strict';
	
	function constant(x) {
	  return function constant() {
	    return x;
	  };
	}
	
	var abs = Math.abs;
	var atan2 = Math.atan2;
	var cos = Math.cos;
	var max = Math.max;
	var min = Math.min;
	var sin = Math.sin;
	var sqrt = Math.sqrt;
	
	var epsilon = 1e-12;
	var pi = Math.PI;
	var halfPi = pi / 2;
	var tau = 2 * pi;
	
	function acos(x) {
	  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
	}
	
	function asin(x) {
	  return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
	}
	
	function arcInnerRadius(d) {
	  return d.innerRadius;
	}
	
	function arcOuterRadius(d) {
	  return d.outerRadius;
	}
	
	function arcStartAngle(d) {
	  return d.startAngle;
	}
	
	function arcEndAngle(d) {
	  return d.endAngle;
	}
	
	function arcPadAngle(d) {
	  return d && d.padAngle; // Note: optional!
	}
	
	function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
	  var x10 = x1 - x0, y10 = y1 - y0,
	      x32 = x3 - x2, y32 = y3 - y2,
	      t = y32 * x10 - x32 * y10;
	  if (t * t < epsilon) return;
	  t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
	  return [x0 + t * x10, y0 + t * y10];
	}
	
	// Compute perpendicular offset line of length rc.
	// http://mathworld.wolfram.com/Circle-LineIntersection.html
	function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
	  var x01 = x0 - x1,
	      y01 = y0 - y1,
	      lo = (cw ? rc : -rc) / sqrt(x01 * x01 + y01 * y01),
	      ox = lo * y01,
	      oy = -lo * x01,
	      x11 = x0 + ox,
	      y11 = y0 + oy,
	      x10 = x1 + ox,
	      y10 = y1 + oy,
	      x00 = (x11 + x10) / 2,
	      y00 = (y11 + y10) / 2,
	      dx = x10 - x11,
	      dy = y10 - y11,
	      d2 = dx * dx + dy * dy,
	      r = r1 - rc,
	      D = x11 * y10 - x10 * y11,
	      d = (dy < 0 ? -1 : 1) * sqrt(max(0, r * r * d2 - D * D)),
	      cx0 = (D * dy - dx * d) / d2,
	      cy0 = (-D * dx - dy * d) / d2,
	      cx1 = (D * dy + dx * d) / d2,
	      cy1 = (-D * dx + dy * d) / d2,
	      dx0 = cx0 - x00,
	      dy0 = cy0 - y00,
	      dx1 = cx1 - x00,
	      dy1 = cy1 - y00;
	
	  // Pick the closer of the two intersection points.
	  // TODO Is there a faster way to determine which intersection to use?
	  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
	
	  return {
	    cx: cx0,
	    cy: cy0,
	    x01: -ox,
	    y01: -oy,
	    x11: cx0 * (r1 / r - 1),
	    y11: cy0 * (r1 / r - 1)
	  };
	}
	
	function arc() {
	  var innerRadius = arcInnerRadius,
	      outerRadius = arcOuterRadius,
	      cornerRadius = constant(0),
	      padRadius = null,
	      startAngle = arcStartAngle,
	      endAngle = arcEndAngle,
	      padAngle = arcPadAngle,
	      context = null;
	
	  function arc() {
	    var buffer,
	        r,
	        r0 = +innerRadius.apply(this, arguments),
	        r1 = +outerRadius.apply(this, arguments),
	        a0 = startAngle.apply(this, arguments) - halfPi,
	        a1 = endAngle.apply(this, arguments) - halfPi,
	        da = abs(a1 - a0),
	        cw = a1 > a0;
	
	    if (!context) context = buffer = d3Path.path();
	
	    // Ensure that the outer radius is always larger than the inner radius.
	    if (r1 < r0) r = r1, r1 = r0, r0 = r;
	
	    // Is it a point?
	    if (!(r1 > epsilon)) context.moveTo(0, 0);
	
	    // Or is it a circle or annulus?
	    else if (da > tau - epsilon) {
	      context.moveTo(r1 * cos(a0), r1 * sin(a0));
	      context.arc(0, 0, r1, a0, a1, !cw);
	      if (r0 > epsilon) {
	        context.moveTo(r0 * cos(a1), r0 * sin(a1));
	        context.arc(0, 0, r0, a1, a0, cw);
	      }
	    }
	
	    // Or is it a circular or annular sector?
	    else {
	      var a01 = a0,
	          a11 = a1,
	          a00 = a0,
	          a10 = a1,
	          da0 = da,
	          da1 = da,
	          ap = padAngle.apply(this, arguments) / 2,
	          rp = (ap > epsilon) && (padRadius ? +padRadius.apply(this, arguments) : sqrt(r0 * r0 + r1 * r1)),
	          rc = min(abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments)),
	          rc0 = rc,
	          rc1 = rc,
	          t0,
	          t1;
	
	      // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
	      if (rp > epsilon) {
	        var p0 = asin(rp / r0 * sin(ap)),
	            p1 = asin(rp / r1 * sin(ap));
	        if ((da0 -= p0 * 2) > epsilon) p0 *= (cw ? 1 : -1), a00 += p0, a10 -= p0;
	        else da0 = 0, a00 = a10 = (a0 + a1) / 2;
	        if ((da1 -= p1 * 2) > epsilon) p1 *= (cw ? 1 : -1), a01 += p1, a11 -= p1;
	        else da1 = 0, a01 = a11 = (a0 + a1) / 2;
	      }
	
	      var x01 = r1 * cos(a01),
	          y01 = r1 * sin(a01),
	          x10 = r0 * cos(a10),
	          y10 = r0 * sin(a10);
	
	      // Apply rounded corners?
	      if (rc > epsilon) {
	        var x11 = r1 * cos(a11),
	            y11 = r1 * sin(a11),
	            x00 = r0 * cos(a00),
	            y00 = r0 * sin(a00),
	            oc;
	
	        // Restrict the corner radius according to the sector angle.
	        if (da < pi && (oc = intersect(x01, y01, x00, y00, x11, y11, x10, y10))) {
	          var ax = x01 - oc[0],
	              ay = y01 - oc[1],
	              bx = x11 - oc[0],
	              by = y11 - oc[1],
	              kc = 1 / sin(acos((ax * bx + ay * by) / (sqrt(ax * ax + ay * ay) * sqrt(bx * bx + by * by))) / 2),
	              lc = sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
	          rc0 = min(rc, (r0 - lc) / (kc - 1));
	          rc1 = min(rc, (r1 - lc) / (kc + 1));
	        }
	      }
	
	      // Is the sector collapsed to a line?
	      if (!(da1 > epsilon)) context.moveTo(x01, y01);
	
	      // Does the sector’s outer ring have rounded corners?
	      else if (rc1 > epsilon) {
	        t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
	        t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
	
	        context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
	
	        // Have the corners merged?
	        if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);
	
	        // Otherwise, draw the two corners and the ring.
	        else {
	          context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
	          context.arc(0, 0, r1, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
	          context.arc(t1.cx, t1.cy, rc1, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
	        }
	      }
	
	      // Or is the outer ring just a circular arc?
	      else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
	
	      // Is there no inner ring, and it’s a circular sector?
	      // Or perhaps it’s an annular sector collapsed due to padding?
	      if (!(r0 > epsilon) || !(da0 > epsilon)) context.lineTo(x10, y10);
	
	      // Does the sector’s inner ring (or point) have rounded corners?
	      else if (rc0 > epsilon) {
	        t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
	        t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
	
	        context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
	
	        // Have the corners merged?
	        if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);
	
	        // Otherwise, draw the two corners and the ring.
	        else {
	          context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
	          context.arc(0, 0, r0, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), cw);
	          context.arc(t1.cx, t1.cy, rc0, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
	        }
	      }
	
	      // Or is the inner ring just a circular arc?
	      else context.arc(0, 0, r0, a10, a00, cw);
	    }
	
	    context.closePath();
	
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  arc.centroid = function() {
	    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
	        a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - pi / 2;
	    return [cos(a) * r, sin(a) * r];
	  };
	
	  arc.innerRadius = function(_) {
	    return arguments.length ? (innerRadius = typeof _ === "function" ? _ : constant(+_), arc) : innerRadius;
	  };
	
	  arc.outerRadius = function(_) {
	    return arguments.length ? (outerRadius = typeof _ === "function" ? _ : constant(+_), arc) : outerRadius;
	  };
	
	  arc.cornerRadius = function(_) {
	    return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : constant(+_), arc) : cornerRadius;
	  };
	
	  arc.padRadius = function(_) {
	    return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : constant(+_), arc) : padRadius;
	  };
	
	  arc.startAngle = function(_) {
	    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant(+_), arc) : startAngle;
	  };
	
	  arc.endAngle = function(_) {
	    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant(+_), arc) : endAngle;
	  };
	
	  arc.padAngle = function(_) {
	    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant(+_), arc) : padAngle;
	  };
	
	  arc.context = function(_) {
	    return arguments.length ? ((context = _ == null ? null : _), arc) : context;
	  };
	
	  return arc;
	}
	
	function Linear(context) {
	  this._context = context;
	}
	
	Linear.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; // proceed
	      default: this._context.lineTo(x, y); break;
	    }
	  }
	};
	
	function curveLinear(context) {
	  return new Linear(context);
	}
	
	function x(p) {
	  return p[0];
	}
	
	function y(p) {
	  return p[1];
	}
	
	function line() {
	  var x$1 = x,
	      y$1 = y,
	      defined = constant(true),
	      context = null,
	      curve = curveLinear,
	      output = null;
	
	  function line(data) {
	    var i,
	        n = data.length,
	        d,
	        defined0 = false,
	        buffer;
	
	    if (context == null) output = curve(buffer = d3Path.path());
	
	    for (i = 0; i <= n; ++i) {
	      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
	        if (defined0 = !defined0) output.lineStart();
	        else output.lineEnd();
	      }
	      if (defined0) output.point(+x$1(d, i, data), +y$1(d, i, data));
	    }
	
	    if (buffer) return output = null, buffer + "" || null;
	  }
	
	  line.x = function(_) {
	    return arguments.length ? (x$1 = typeof _ === "function" ? _ : constant(+_), line) : x$1;
	  };
	
	  line.y = function(_) {
	    return arguments.length ? (y$1 = typeof _ === "function" ? _ : constant(+_), line) : y$1;
	  };
	
	  line.defined = function(_) {
	    return arguments.length ? (defined = typeof _ === "function" ? _ : constant(!!_), line) : defined;
	  };
	
	  line.curve = function(_) {
	    return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
	  };
	
	  line.context = function(_) {
	    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
	  };
	
	  return line;
	}
	
	function area() {
	  var x0 = x,
	      x1 = null,
	      y0 = constant(0),
	      y1 = y,
	      defined = constant(true),
	      context = null,
	      curve = curveLinear,
	      output = null;
	
	  function area(data) {
	    var i,
	        j,
	        k,
	        n = data.length,
	        d,
	        defined0 = false,
	        buffer,
	        x0z = new Array(n),
	        y0z = new Array(n);
	
	    if (context == null) output = curve(buffer = d3Path.path());
	
	    for (i = 0; i <= n; ++i) {
	      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
	        if (defined0 = !defined0) {
	          j = i;
	          output.areaStart();
	          output.lineStart();
	        } else {
	          output.lineEnd();
	          output.lineStart();
	          for (k = i - 1; k >= j; --k) {
	            output.point(x0z[k], y0z[k]);
	          }
	          output.lineEnd();
	          output.areaEnd();
	        }
	      }
	      if (defined0) {
	        x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
	        output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
	      }
	    }
	
	    if (buffer) return output = null, buffer + "" || null;
	  }
	
	  function arealine() {
	    return line().defined(defined).curve(curve).context(context);
	  }
	
	  area.x = function(_) {
	    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant(+_), x1 = null, area) : x0;
	  };
	
	  area.x0 = function(_) {
	    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant(+_), area) : x0;
	  };
	
	  area.x1 = function(_) {
	    return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : constant(+_), area) : x1;
	  };
	
	  area.y = function(_) {
	    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant(+_), y1 = null, area) : y0;
	  };
	
	  area.y0 = function(_) {
	    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant(+_), area) : y0;
	  };
	
	  area.y1 = function(_) {
	    return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : constant(+_), area) : y1;
	  };
	
	  area.lineX0 =
	  area.lineY0 = function() {
	    return arealine().x(x0).y(y0);
	  };
	
	  area.lineY1 = function() {
	    return arealine().x(x0).y(y1);
	  };
	
	  area.lineX1 = function() {
	    return arealine().x(x1).y(y0);
	  };
	
	  area.defined = function(_) {
	    return arguments.length ? (defined = typeof _ === "function" ? _ : constant(!!_), area) : defined;
	  };
	
	  area.curve = function(_) {
	    return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
	  };
	
	  area.context = function(_) {
	    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
	  };
	
	  return area;
	}
	
	function descending(a, b) {
	  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	}
	
	function identity(d) {
	  return d;
	}
	
	function pie() {
	  var value = identity,
	      sortValues = descending,
	      sort = null,
	      startAngle = constant(0),
	      endAngle = constant(tau),
	      padAngle = constant(0);
	
	  function pie(data) {
	    var i,
	        n = data.length,
	        j,
	        k,
	        sum = 0,
	        index = new Array(n),
	        arcs = new Array(n),
	        a0 = +startAngle.apply(this, arguments),
	        da = Math.min(tau, Math.max(-tau, endAngle.apply(this, arguments) - a0)),
	        a1,
	        p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)),
	        pa = p * (da < 0 ? -1 : 1),
	        v;
	
	    for (i = 0; i < n; ++i) {
	      if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) {
	        sum += v;
	      }
	    }
	
	    // Optionally sort the arcs by previously-computed values or by data.
	    if (sortValues != null) index.sort(function(i, j) { return sortValues(arcs[i], arcs[j]); });
	    else if (sort != null) index.sort(function(i, j) { return sort(data[i], data[j]); });
	
	    // Compute the arcs! They are stored in the original data's order.
	    for (i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1) {
	      j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
	        data: data[j],
	        index: i,
	        value: v,
	        startAngle: a0,
	        endAngle: a1,
	        padAngle: p
	      };
	    }
	
	    return arcs;
	  }
	
	  pie.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant(+_), pie) : value;
	  };
	
	  pie.sortValues = function(_) {
	    return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
	  };
	
	  pie.sort = function(_) {
	    return arguments.length ? (sort = _, sortValues = null, pie) : sort;
	  };
	
	  pie.startAngle = function(_) {
	    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant(+_), pie) : startAngle;
	  };
	
	  pie.endAngle = function(_) {
	    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant(+_), pie) : endAngle;
	  };
	
	  pie.padAngle = function(_) {
	    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant(+_), pie) : padAngle;
	  };
	
	  return pie;
	}
	
	var curveRadialLinear = curveRadial(curveLinear);
	
	function Radial(curve) {
	  this._curve = curve;
	}
	
	Radial.prototype = {
	  areaStart: function() {
	    this._curve.areaStart();
	  },
	  areaEnd: function() {
	    this._curve.areaEnd();
	  },
	  lineStart: function() {
	    this._curve.lineStart();
	  },
	  lineEnd: function() {
	    this._curve.lineEnd();
	  },
	  point: function(a, r) {
	    this._curve.point(r * Math.sin(a), r * -Math.cos(a));
	  }
	};
	
	function curveRadial(curve) {
	
	  function radial(context) {
	    return new Radial(curve(context));
	  }
	
	  radial._curve = curve;
	
	  return radial;
	}
	
	function lineRadial(l) {
	  var c = l.curve;
	
	  l.angle = l.x, delete l.x;
	  l.radius = l.y, delete l.y;
	
	  l.curve = function(_) {
	    return arguments.length ? c(curveRadial(_)) : c()._curve;
	  };
	
	  return l;
	}
	
	function lineRadial$1() {
	  return lineRadial(line().curve(curveRadialLinear));
	}
	
	function areaRadial() {
	  var a = area().curve(curveRadialLinear),
	      c = a.curve,
	      x0 = a.lineX0,
	      x1 = a.lineX1,
	      y0 = a.lineY0,
	      y1 = a.lineY1;
	
	  a.angle = a.x, delete a.x;
	  a.startAngle = a.x0, delete a.x0;
	  a.endAngle = a.x1, delete a.x1;
	  a.radius = a.y, delete a.y;
	  a.innerRadius = a.y0, delete a.y0;
	  a.outerRadius = a.y1, delete a.y1;
	  a.lineStartAngle = function() { return lineRadial(x0()); }, delete a.lineX0;
	  a.lineEndAngle = function() { return lineRadial(x1()); }, delete a.lineX1;
	  a.lineInnerRadius = function() { return lineRadial(y0()); }, delete a.lineY0;
	  a.lineOuterRadius = function() { return lineRadial(y1()); }, delete a.lineY1;
	
	  a.curve = function(_) {
	    return arguments.length ? c(curveRadial(_)) : c()._curve;
	  };
	
	  return a;
	}
	
	function pointRadial(x, y) {
	  return [(y = +y) * Math.cos(x -= Math.PI / 2), y * Math.sin(x)];
	}
	
	var slice = Array.prototype.slice;
	
	function linkSource(d) {
	  return d.source;
	}
	
	function linkTarget(d) {
	  return d.target;
	}
	
	function link(curve) {
	  var source = linkSource,
	      target = linkTarget,
	      x$1 = x,
	      y$1 = y,
	      context = null;
	
	  function link() {
	    var buffer, argv = slice.call(arguments), s = source.apply(this, argv), t = target.apply(this, argv);
	    if (!context) context = buffer = d3Path.path();
	    curve(context, +x$1.apply(this, (argv[0] = s, argv)), +y$1.apply(this, argv), +x$1.apply(this, (argv[0] = t, argv)), +y$1.apply(this, argv));
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  link.source = function(_) {
	    return arguments.length ? (source = _, link) : source;
	  };
	
	  link.target = function(_) {
	    return arguments.length ? (target = _, link) : target;
	  };
	
	  link.x = function(_) {
	    return arguments.length ? (x$1 = typeof _ === "function" ? _ : constant(+_), link) : x$1;
	  };
	
	  link.y = function(_) {
	    return arguments.length ? (y$1 = typeof _ === "function" ? _ : constant(+_), link) : y$1;
	  };
	
	  link.context = function(_) {
	    return arguments.length ? ((context = _ == null ? null : _), link) : context;
	  };
	
	  return link;
	}
	
	function curveHorizontal(context, x0, y0, x1, y1) {
	  context.moveTo(x0, y0);
	  context.bezierCurveTo(x0 = (x0 + x1) / 2, y0, x0, y1, x1, y1);
	}
	
	function curveVertical(context, x0, y0, x1, y1) {
	  context.moveTo(x0, y0);
	  context.bezierCurveTo(x0, y0 = (y0 + y1) / 2, x1, y0, x1, y1);
	}
	
	function curveRadial$1(context, x0, y0, x1, y1) {
	  var p0 = pointRadial(x0, y0),
	      p1 = pointRadial(x0, y0 = (y0 + y1) / 2),
	      p2 = pointRadial(x1, y0),
	      p3 = pointRadial(x1, y1);
	  context.moveTo(p0[0], p0[1]);
	  context.bezierCurveTo(p1[0], p1[1], p2[0], p2[1], p3[0], p3[1]);
	}
	
	function linkHorizontal() {
	  return link(curveHorizontal);
	}
	
	function linkVertical() {
	  return link(curveVertical);
	}
	
	function linkRadial() {
	  var l = link(curveRadial$1);
	  l.angle = l.x, delete l.x;
	  l.radius = l.y, delete l.y;
	  return l;
	}
	
	var circle = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / pi);
	    context.moveTo(r, 0);
	    context.arc(0, 0, r, 0, tau);
	  }
	};
	
	var cross = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / 5) / 2;
	    context.moveTo(-3 * r, -r);
	    context.lineTo(-r, -r);
	    context.lineTo(-r, -3 * r);
	    context.lineTo(r, -3 * r);
	    context.lineTo(r, -r);
	    context.lineTo(3 * r, -r);
	    context.lineTo(3 * r, r);
	    context.lineTo(r, r);
	    context.lineTo(r, 3 * r);
	    context.lineTo(-r, 3 * r);
	    context.lineTo(-r, r);
	    context.lineTo(-3 * r, r);
	    context.closePath();
	  }
	};
	
	var tan30 = Math.sqrt(1 / 3),
	    tan30_2 = tan30 * 2;
	
	var diamond = {
	  draw: function(context, size) {
	    var y = Math.sqrt(size / tan30_2),
	        x = y * tan30;
	    context.moveTo(0, -y);
	    context.lineTo(x, 0);
	    context.lineTo(0, y);
	    context.lineTo(-x, 0);
	    context.closePath();
	  }
	};
	
	var ka = 0.89081309152928522810,
	    kr = Math.sin(pi / 10) / Math.sin(7 * pi / 10),
	    kx = Math.sin(tau / 10) * kr,
	    ky = -Math.cos(tau / 10) * kr;
	
	var star = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size * ka),
	        x = kx * r,
	        y = ky * r;
	    context.moveTo(0, -r);
	    context.lineTo(x, y);
	    for (var i = 1; i < 5; ++i) {
	      var a = tau * i / 5,
	          c = Math.cos(a),
	          s = Math.sin(a);
	      context.lineTo(s * r, -c * r);
	      context.lineTo(c * x - s * y, s * x + c * y);
	    }
	    context.closePath();
	  }
	};
	
	var square = {
	  draw: function(context, size) {
	    var w = Math.sqrt(size),
	        x = -w / 2;
	    context.rect(x, x, w, w);
	  }
	};
	
	var sqrt3 = Math.sqrt(3);
	
	var triangle = {
	  draw: function(context, size) {
	    var y = -Math.sqrt(size / (sqrt3 * 3));
	    context.moveTo(0, y * 2);
	    context.lineTo(-sqrt3 * y, -y);
	    context.lineTo(sqrt3 * y, -y);
	    context.closePath();
	  }
	};
	
	var c = -0.5,
	    s = Math.sqrt(3) / 2,
	    k = 1 / Math.sqrt(12),
	    a = (k / 2 + 1) * 3;
	
	var wye = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / a),
	        x0 = r / 2,
	        y0 = r * k,
	        x1 = x0,
	        y1 = r * k + r,
	        x2 = -x1,
	        y2 = y1;
	    context.moveTo(x0, y0);
	    context.lineTo(x1, y1);
	    context.lineTo(x2, y2);
	    context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
	    context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
	    context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
	    context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
	    context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
	    context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
	    context.closePath();
	  }
	};
	
	var symbols = [
	  circle,
	  cross,
	  diamond,
	  square,
	  star,
	  triangle,
	  wye
	];
	
	function symbol() {
	  var type = constant(circle),
	      size = constant(64),
	      context = null;
	
	  function symbol() {
	    var buffer;
	    if (!context) context = buffer = d3Path.path();
	    type.apply(this, arguments).draw(context, +size.apply(this, arguments));
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  symbol.type = function(_) {
	    return arguments.length ? (type = typeof _ === "function" ? _ : constant(_), symbol) : type;
	  };
	
	  symbol.size = function(_) {
	    return arguments.length ? (size = typeof _ === "function" ? _ : constant(+_), symbol) : size;
	  };
	
	  symbol.context = function(_) {
	    return arguments.length ? (context = _ == null ? null : _, symbol) : context;
	  };
	
	  return symbol;
	}
	
	function noop() {}
	
	function point(that, x, y) {
	  that._context.bezierCurveTo(
	    (2 * that._x0 + that._x1) / 3,
	    (2 * that._y0 + that._y1) / 3,
	    (that._x0 + 2 * that._x1) / 3,
	    (that._y0 + 2 * that._y1) / 3,
	    (that._x0 + 4 * that._x1 + x) / 6,
	    (that._y0 + 4 * that._y1 + y) / 6
	  );
	}
	
	function Basis(context) {
	  this._context = context;
	}
	
	Basis.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 3: point(this, this._x1, this._y1); // proceed
	      case 2: this._context.lineTo(this._x1, this._y1); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	function basis(context) {
	  return new Basis(context);
	}
	
	function BasisClosed(context) {
	  this._context = context;
	}
	
	BasisClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x2, this._y2);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
	        this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x2, this._y2);
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._x2 = x, this._y2 = y; break;
	      case 1: this._point = 2; this._x3 = x, this._y3 = y; break;
	      case 2: this._point = 3; this._x4 = x, this._y4 = y; this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6); break;
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	function basisClosed(context) {
	  return new BasisClosed(context);
	}
	
	function BasisOpen(context) {
	  this._context = context;
	}
	
	BasisOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6; this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0); break;
	      case 3: this._point = 4; // proceed
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	function basisOpen(context) {
	  return new BasisOpen(context);
	}
	
	function Bundle(context, beta) {
	  this._basis = new Basis(context);
	  this._beta = beta;
	}
	
	Bundle.prototype = {
	  lineStart: function() {
	    this._x = [];
	    this._y = [];
	    this._basis.lineStart();
	  },
	  lineEnd: function() {
	    var x = this._x,
	        y = this._y,
	        j = x.length - 1;
	
	    if (j > 0) {
	      var x0 = x[0],
	          y0 = y[0],
	          dx = x[j] - x0,
	          dy = y[j] - y0,
	          i = -1,
	          t;
	
	      while (++i <= j) {
	        t = i / j;
	        this._basis.point(
	          this._beta * x[i] + (1 - this._beta) * (x0 + t * dx),
	          this._beta * y[i] + (1 - this._beta) * (y0 + t * dy)
	        );
	      }
	    }
	
	    this._x = this._y = null;
	    this._basis.lineEnd();
	  },
	  point: function(x, y) {
	    this._x.push(+x);
	    this._y.push(+y);
	  }
	};
	
	var bundle = (function custom(beta) {
	
	  function bundle(context) {
	    return beta === 1 ? new Basis(context) : new Bundle(context, beta);
	  }
	
	  bundle.beta = function(beta) {
	    return custom(+beta);
	  };
	
	  return bundle;
	})(0.85);
	
	function point$1(that, x, y) {
	  that._context.bezierCurveTo(
	    that._x1 + that._k * (that._x2 - that._x0),
	    that._y1 + that._k * (that._y2 - that._y0),
	    that._x2 + that._k * (that._x1 - x),
	    that._y2 + that._k * (that._y1 - y),
	    that._x2,
	    that._y2
	  );
	}
	
	function Cardinal(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	Cardinal.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x2, this._y2); break;
	      case 3: point$1(this, this._x1, this._y1); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; this._x1 = x, this._y1 = y; break;
	      case 2: this._point = 3; // proceed
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinal = (function custom(tension) {
	
	  function cardinal(context) {
	    return new Cardinal(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	})(0);
	
	function CardinalClosed(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	CardinalClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.lineTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        this.point(this._x5, this._y5);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
	      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
	      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinalClosed = (function custom(tension) {
	
	  function cardinal(context) {
	    return new CardinalClosed(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	})(0);
	
	function CardinalOpen(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	CardinalOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
	      case 3: this._point = 4; // proceed
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinalOpen = (function custom(tension) {
	
	  function cardinal(context) {
	    return new CardinalOpen(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	})(0);
	
	function point$2(that, x, y) {
	  var x1 = that._x1,
	      y1 = that._y1,
	      x2 = that._x2,
	      y2 = that._y2;
	
	  if (that._l01_a > epsilon) {
	    var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a,
	        n = 3 * that._l01_a * (that._l01_a + that._l12_a);
	    x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
	    y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
	  }
	
	  if (that._l23_a > epsilon) {
	    var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a,
	        m = 3 * that._l23_a * (that._l23_a + that._l12_a);
	    x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
	    y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
	  }
	
	  that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
	}
	
	function CatmullRom(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRom.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x2, this._y2); break;
	      case 3: this.point(this._x2, this._y2); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; // proceed
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRom = (function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRom(context, alpha) : new Cardinal(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	})(0.5);
	
	function CatmullRomClosed(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRomClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.lineTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        this.point(this._x5, this._y5);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
	      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
	      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRomClosed = (function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRomClosed(context, alpha) : new CardinalClosed(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	})(0.5);
	
	function CatmullRomOpen(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRomOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
	      case 3: this._point = 4; // proceed
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRomOpen = (function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRomOpen(context, alpha) : new CardinalOpen(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	})(0.5);
	
	function LinearClosed(context) {
	  this._context = context;
	}
	
	LinearClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._point) this._context.closePath();
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    if (this._point) this._context.lineTo(x, y);
	    else this._point = 1, this._context.moveTo(x, y);
	  }
	};
	
	function linearClosed(context) {
	  return new LinearClosed(context);
	}
	
	function sign(x) {
	  return x < 0 ? -1 : 1;
	}
	
	// Calculate the slopes of the tangents (Hermite-type interpolation) based on
	// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
	// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
	// NOV(II), P. 443, 1990.
	function slope3(that, x2, y2) {
	  var h0 = that._x1 - that._x0,
	      h1 = x2 - that._x1,
	      s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0),
	      s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0),
	      p = (s0 * h1 + s1 * h0) / (h0 + h1);
	  return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
	}
	
	// Calculate a one-sided slope.
	function slope2(that, t) {
	  var h = that._x1 - that._x0;
	  return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
	}
	
	// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
	// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
	// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
	function point$3(that, t0, t1) {
	  var x0 = that._x0,
	      y0 = that._y0,
	      x1 = that._x1,
	      y1 = that._y1,
	      dx = (x1 - x0) / 3;
	  that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
	}
	
	function MonotoneX(context) {
	  this._context = context;
	}
	
	MonotoneX.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 =
	    this._t0 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x1, this._y1); break;
	      case 3: point$3(this, this._t0, slope2(this, this._t0)); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    var t1 = NaN;
	
	    x = +x, y = +y;
	    if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; point$3(this, slope2(this, t1 = slope3(this, x, y)), t1); break;
	      default: point$3(this, this._t0, t1 = slope3(this, x, y)); break;
	    }
	
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	    this._t0 = t1;
	  }
	};
	
	function MonotoneY(context) {
	  this._context = new ReflectContext(context);
	}
	
	(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
	  MonotoneX.prototype.point.call(this, y, x);
	};
	
	function ReflectContext(context) {
	  this._context = context;
	}
	
	ReflectContext.prototype = {
	  moveTo: function(x, y) { this._context.moveTo(y, x); },
	  closePath: function() { this._context.closePath(); },
	  lineTo: function(x, y) { this._context.lineTo(y, x); },
	  bezierCurveTo: function(x1, y1, x2, y2, x, y) { this._context.bezierCurveTo(y1, x1, y2, x2, y, x); }
	};
	
	function monotoneX(context) {
	  return new MonotoneX(context);
	}
	
	function monotoneY(context) {
	  return new MonotoneY(context);
	}
	
	function Natural(context) {
	  this._context = context;
	}
	
	Natural.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x = [];
	    this._y = [];
	  },
	  lineEnd: function() {
	    var x = this._x,
	        y = this._y,
	        n = x.length;
	
	    if (n) {
	      this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
	      if (n === 2) {
	        this._context.lineTo(x[1], y[1]);
	      } else {
	        var px = controlPoints(x),
	            py = controlPoints(y);
	        for (var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1) {
	          this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
	        }
	      }
	    }
	
	    if (this._line || (this._line !== 0 && n === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	    this._x = this._y = null;
	  },
	  point: function(x, y) {
	    this._x.push(+x);
	    this._y.push(+y);
	  }
	};
	
	// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
	function controlPoints(x) {
	  var i,
	      n = x.length - 1,
	      m,
	      a = new Array(n),
	      b = new Array(n),
	      r = new Array(n);
	  a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
	  for (i = 1; i < n - 1; ++i) a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
	  a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
	  for (i = 1; i < n; ++i) m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
	  a[n - 1] = r[n - 1] / b[n - 1];
	  for (i = n - 2; i >= 0; --i) a[i] = (r[i] - a[i + 1]) / b[i];
	  b[n - 1] = (x[n] + a[n - 1]) / 2;
	  for (i = 0; i < n - 1; ++i) b[i] = 2 * x[i + 1] - a[i + 1];
	  return [a, b];
	}
	
	function natural(context) {
	  return new Natural(context);
	}
	
	function Step(context, t) {
	  this._context = context;
	  this._t = t;
	}
	
	Step.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x = this._y = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; // proceed
	      default: {
	        if (this._t <= 0) {
	          this._context.lineTo(this._x, y);
	          this._context.lineTo(x, y);
	        } else {
	          var x1 = this._x * (1 - this._t) + x * this._t;
	          this._context.lineTo(x1, this._y);
	          this._context.lineTo(x1, y);
	        }
	        break;
	      }
	    }
	    this._x = x, this._y = y;
	  }
	};
	
	function step(context) {
	  return new Step(context, 0.5);
	}
	
	function stepBefore(context) {
	  return new Step(context, 0);
	}
	
	function stepAfter(context) {
	  return new Step(context, 1);
	}
	
	function none(series, order) {
	  if (!((n = series.length) > 1)) return;
	  for (var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i) {
	    s0 = s1, s1 = series[order[i]];
	    for (j = 0; j < m; ++j) {
	      s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
	    }
	  }
	}
	
	function none$1(series) {
	  var n = series.length, o = new Array(n);
	  while (--n >= 0) o[n] = n;
	  return o;
	}
	
	function stackValue(d, key) {
	  return d[key];
	}
	
	function stack() {
	  var keys = constant([]),
	      order = none$1,
	      offset = none,
	      value = stackValue;
	
	  function stack(data) {
	    var kz = keys.apply(this, arguments),
	        i,
	        m = data.length,
	        n = kz.length,
	        sz = new Array(n),
	        oz;
	
	    for (i = 0; i < n; ++i) {
	      for (var ki = kz[i], si = sz[i] = new Array(m), j = 0, sij; j < m; ++j) {
	        si[j] = sij = [0, +value(data[j], ki, j, data)];
	        sij.data = data[j];
	      }
	      si.key = ki;
	    }
	
	    for (i = 0, oz = order(sz); i < n; ++i) {
	      sz[oz[i]].index = i;
	    }
	
	    offset(sz, oz);
	    return sz;
	  }
	
	  stack.keys = function(_) {
	    return arguments.length ? (keys = typeof _ === "function" ? _ : constant(slice.call(_)), stack) : keys;
	  };
	
	  stack.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant(+_), stack) : value;
	  };
	
	  stack.order = function(_) {
	    return arguments.length ? (order = _ == null ? none$1 : typeof _ === "function" ? _ : constant(slice.call(_)), stack) : order;
	  };
	
	  stack.offset = function(_) {
	    return arguments.length ? (offset = _ == null ? none : _, stack) : offset;
	  };
	
	  return stack;
	}
	
	function expand(series, order) {
	  if (!((n = series.length) > 0)) return;
	  for (var i, n, j = 0, m = series[0].length, y; j < m; ++j) {
	    for (y = i = 0; i < n; ++i) y += series[i][j][1] || 0;
	    if (y) for (i = 0; i < n; ++i) series[i][j][1] /= y;
	  }
	  none(series, order);
	}
	
	function diverging(series, order) {
	  if (!((n = series.length) > 0)) return;
	  for (var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j) {
	    for (yp = yn = 0, i = 0; i < n; ++i) {
	      if ((dy = (d = series[order[i]][j])[1] - d[0]) > 0) {
	        d[0] = yp, d[1] = yp += dy;
	      } else if (dy < 0) {
	        d[1] = yn, d[0] = yn += dy;
	      } else {
	        d[0] = 0, d[1] = dy;
	      }
	    }
	  }
	}
	
	function silhouette(series, order) {
	  if (!((n = series.length) > 0)) return;
	  for (var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j) {
	    for (var i = 0, y = 0; i < n; ++i) y += series[i][j][1] || 0;
	    s0[j][1] += s0[j][0] = -y / 2;
	  }
	  none(series, order);
	}
	
	function wiggle(series, order) {
	  if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
	  for (var y = 0, j = 1, s0, m, n; j < m; ++j) {
	    for (var i = 0, s1 = 0, s2 = 0; i < n; ++i) {
	      var si = series[order[i]],
	          sij0 = si[j][1] || 0,
	          sij1 = si[j - 1][1] || 0,
	          s3 = (sij0 - sij1) / 2;
	      for (var k = 0; k < i; ++k) {
	        var sk = series[order[k]],
	            skj0 = sk[j][1] || 0,
	            skj1 = sk[j - 1][1] || 0;
	        s3 += skj0 - skj1;
	      }
	      s1 += sij0, s2 += s3 * sij0;
	    }
	    s0[j - 1][1] += s0[j - 1][0] = y;
	    if (s1) y -= s2 / s1;
	  }
	  s0[j - 1][1] += s0[j - 1][0] = y;
	  none(series, order);
	}
	
	function appearance(series) {
	  var peaks = series.map(peak);
	  return none$1(series).sort(function(a, b) { return peaks[a] - peaks[b]; });
	}
	
	function peak(series) {
	  var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
	  while (++i < n) if ((vi = +series[i][1]) > vj) vj = vi, j = i;
	  return j;
	}
	
	function ascending(series) {
	  var sums = series.map(sum);
	  return none$1(series).sort(function(a, b) { return sums[a] - sums[b]; });
	}
	
	function sum(series) {
	  var s = 0, i = -1, n = series.length, v;
	  while (++i < n) if (v = +series[i][1]) s += v;
	  return s;
	}
	
	function descending$1(series) {
	  return ascending(series).reverse();
	}
	
	function insideOut(series) {
	  var n = series.length,
	      i,
	      j,
	      sums = series.map(sum),
	      order = appearance(series),
	      top = 0,
	      bottom = 0,
	      tops = [],
	      bottoms = [];
	
	  for (i = 0; i < n; ++i) {
	    j = order[i];
	    if (top < bottom) {
	      top += sums[j];
	      tops.push(j);
	    } else {
	      bottom += sums[j];
	      bottoms.push(j);
	    }
	  }
	
	  return bottoms.reverse().concat(tops);
	}
	
	function reverse(series) {
	  return none$1(series).reverse();
	}
	
	exports.arc = arc;
	exports.area = area;
	exports.areaRadial = areaRadial;
	exports.curveBasis = basis;
	exports.curveBasisClosed = basisClosed;
	exports.curveBasisOpen = basisOpen;
	exports.curveBundle = bundle;
	exports.curveCardinal = cardinal;
	exports.curveCardinalClosed = cardinalClosed;
	exports.curveCardinalOpen = cardinalOpen;
	exports.curveCatmullRom = catmullRom;
	exports.curveCatmullRomClosed = catmullRomClosed;
	exports.curveCatmullRomOpen = catmullRomOpen;
	exports.curveLinear = curveLinear;
	exports.curveLinearClosed = linearClosed;
	exports.curveMonotoneX = monotoneX;
	exports.curveMonotoneY = monotoneY;
	exports.curveNatural = natural;
	exports.curveStep = step;
	exports.curveStepAfter = stepAfter;
	exports.curveStepBefore = stepBefore;
	exports.line = line;
	exports.lineRadial = lineRadial$1;
	exports.linkHorizontal = linkHorizontal;
	exports.linkRadial = linkRadial;
	exports.linkVertical = linkVertical;
	exports.pie = pie;
	exports.pointRadial = pointRadial;
	exports.radialArea = areaRadial;
	exports.radialLine = lineRadial$1;
	exports.stack = stack;
	exports.stackOffsetDiverging = diverging;
	exports.stackOffsetExpand = expand;
	exports.stackOffsetNone = none;
	exports.stackOffsetSilhouette = silhouette;
	exports.stackOffsetWiggle = wiggle;
	exports.stackOrderAppearance = appearance;
	exports.stackOrderAscending = ascending;
	exports.stackOrderDescending = descending$1;
	exports.stackOrderInsideOut = insideOut;
	exports.stackOrderNone = none$1;
	exports.stackOrderReverse = reverse;
	exports.symbol = symbol;
	exports.symbolCircle = circle;
	exports.symbolCross = cross;
	exports.symbolDiamond = diamond;
	exports.symbolSquare = square;
	exports.symbolStar = star;
	exports.symbolTriangle = triangle;
	exports.symbolWye = wye;
	exports.symbols = symbols;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	}));


/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUTCWeekYear;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	var _index3 = _interopRequireDefault(__webpack_require__(260));
	
	var _index4 = _interopRequireDefault(__webpack_require__(26));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function getUTCWeekYear(dirtyDate, dirtyOptions) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getUTCFullYear();
	  var options = dirtyOptions || {};
	  var locale = options.locale;
	  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
	  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, _index4.default)(localeFirstWeekContainsDate);
	  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, _index4.default)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
	
	  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
	    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
	  }
	
	  var firstWeekOfNextYear = new Date(0);
	  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
	  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
	  var startOfNextYear = (0, _index3.default)(firstWeekOfNextYear, dirtyOptions);
	  var firstWeekOfThisYear = new Date(0);
	  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
	  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
	  var startOfThisYear = (0, _index3.default)(firstWeekOfThisYear, dirtyOptions);
	
	  if (date.getTime() >= startOfNextYear.getTime()) {
	    return year + 1;
	  } else if (date.getTime() >= startOfThisYear.getTime()) {
	    return year;
	  } else {
	    return year - 1;
	  }
	}
	
	module.exports = exports.default;

/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addQuarters;
	
	var _index = _interopRequireDefault(__webpack_require__(26));
	
	var _index2 = _interopRequireDefault(__webpack_require__(170));
	
	var _index3 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name addQuarters
	 * @category Quarter Helpers
	 * @summary Add the specified number of year quarters to the given date.
	 *
	 * @description
	 * Add the specified number of year quarters to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of quarters to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the quarters added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 1 quarter to 1 September 2014:
	 * const result = addQuarters(new Date(2014, 8, 1), 1)
	 * //=> Mon Dec 01 2014 00:00:00
	 */
	function addQuarters(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  var months = amount * 3;
	  return (0, _index2.default)(dirtyDate, months);
	}
	
	module.exports = exports.default;

/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addYears;
	
	var _index = _interopRequireDefault(__webpack_require__(26));
	
	var _index2 = _interopRequireDefault(__webpack_require__(170));
	
	var _index3 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name addYears
	 * @category Year Helpers
	 * @summary Add the specified number of years to the given date.
	 *
	 * @description
	 * Add the specified number of years to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of years to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the years added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 5 years to 1 September 2014:
	 * const result = addYears(new Date(2014, 8, 1), 5)
	 * //=> Sun Sep 01 2019 00:00:00
	 */
	function addYears(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, amount * 12);
	}
	
	module.exports = exports.default;

/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInCalendarMonths;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInCalendarMonths
	 * @category Month Helpers
	 * @summary Get the number of calendar months between the given dates.
	 *
	 * @description
	 * Get the number of calendar months between the given dates.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of calendar months
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many calendar months are between 31 January 2014 and 1 September 2014?
	 * var result = differenceInCalendarMonths(
	 *   new Date(2014, 8, 1),
	 *   new Date(2014, 0, 31)
	 * )
	 * //=> 8
	 */
	function differenceInCalendarMonths(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
	  var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
	  return yearDiff * 12 + monthDiff;
	}
	
	module.exports = exports.default;

/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInCalendarWeeks;
	
	var _index = _interopRequireDefault(__webpack_require__(109));
	
	var _index2 = _interopRequireDefault(__webpack_require__(107));
	
	var _index3 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_WEEK = 604800000;
	/**
	 * @name differenceInCalendarWeeks
	 * @category Week Helpers
	 * @summary Get the number of calendar weeks between the given dates.
	 *
	 * @description
	 * Get the number of calendar weeks between the given dates.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Number} the number of calendar weeks
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // How many calendar weeks are between 5 July 2014 and 20 July 2014?
	 * const result = differenceInCalendarWeeks(
	 *   new Date(2014, 6, 20),
	 *   new Date(2014, 6, 5)
	 * )
	 * //=> 3
	 *
	 * @example
	 * // If the week starts on Monday,
	 * // how many calendar weeks are between 5 July 2014 and 20 July 2014?
	 * const result = differenceInCalendarWeeks(
	 *   new Date(2014, 6, 20),
	 *   new Date(2014, 6, 5),
	 *   { weekStartsOn: 1 }
	 * )
	 * //=> 2
	 */
	
	function differenceInCalendarWeeks(dirtyDateLeft, dirtyDateRight, dirtyOptions) {
	  (0, _index3.default)(2, arguments);
	  var startOfWeekLeft = (0, _index.default)(dirtyDateLeft, dirtyOptions);
	  var startOfWeekRight = (0, _index.default)(dirtyDateRight, dirtyOptions);
	  var timestampLeft = startOfWeekLeft.getTime() - (0, _index2.default)(startOfWeekLeft);
	  var timestampRight = startOfWeekRight.getTime() - (0, _index2.default)(startOfWeekRight); // Round the number of days to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	
	  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK);
	}
	
	module.exports = exports.default;

/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInCalendarYears;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInCalendarYears
	 * @category Year Helpers
	 * @summary Get the number of calendar years between the given dates.
	 *
	 * @description
	 * Get the number of calendar years between the given dates.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of calendar years
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many calendar years are between 31 December 2013 and 11 February 2015?
	 * const result = differenceInCalendarYears(
	 *   new Date(2015, 1, 11),
	 *   new Date(2013, 11, 31)
	 * )
	 * //=> 2
	 */
	function differenceInCalendarYears(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  return dateLeft.getFullYear() - dateRight.getFullYear();
	}
	
	module.exports = exports.default;

/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInDays;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(120));
	
	var _index3 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Like `compareAsc` but uses local time not UTC, which is needed
	// for accurate equality comparisons of UTC timestamps that end up
	// having the same representation in local time, e.g. one hour before
	// DST ends vs. the instant that DST ends.
	function compareLocalAsc(dateLeft, dateRight) {
	  var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
	
	  if (diff < 0) {
	    return -1;
	  } else if (diff > 0) {
	    return 1; // Return 0 if diff is 0; return NaN if diff is NaN
	  } else {
	    return diff;
	  }
	}
	/**
	 * @name differenceInDays
	 * @category Day Helpers
	 * @summary Get the number of full days between the given dates.
	 *
	 * @description
	 * Get the number of full day periods between two dates. Fractional days are
	 * truncated towards zero.
	 *
	 * One "full day" is the distance between a local time in one day to the same
	 * local time on the next or previous day. A full day can sometimes be less than
	 * or more than 24 hours if a daylight savings change happens between two dates.
	 *
	 * To ignore DST and only measure exact 24-hour periods, use this instead:
	 * `Math.floor(differenceInHours(dateLeft, dateRight)/24)|0`.
	 *
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of full days according to the local timezone
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many full days are between
	 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
	 * const result = differenceInDays(
	 *   new Date(2012, 6, 2, 0, 0),
	 *   new Date(2011, 6, 2, 23, 0)
	 * )
	 * //=> 365
	 * // How many full days are between
	 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
	 * const result = differenceInDays(
	 *   new Date(2011, 6, 3, 0, 1),
	 *   new Date(2011, 6, 2, 23, 59)
	 * )
	 * //=> 0
	 * // How many full days are between
	 * // 1 March 2020 0:00 and 1 June 2020 0:00 ?
	 * // Note: because local time is used, the
	 * // result will always be 92 days, even in
	 * // time zones where DST starts and the
	 * // period has only 92*24-1 hours.
	 * const result = differenceInDays(
	 *   new Date(2020, 5, 1),
	 *   new Date(2020, 2, 1)
	 * )
	//=> 92
	 */
	
	
	function differenceInDays(dirtyDateLeft, dirtyDateRight) {
	  (0, _index3.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  var sign = compareLocalAsc(dateLeft, dateRight);
	  var difference = Math.abs((0, _index2.default)(dateLeft, dateRight));
	  dateLeft.setDate(dateLeft.getDate() - sign * difference); // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
	  // If so, result must be decreased by 1 in absolute value
	
	  var isLastDayNotFull = Number(compareLocalAsc(dateLeft, dateRight) === -sign);
	  var result = sign * (difference - isLastDayNotFull); // Prevent negative zero
	
	  return result === 0 ? 0 : result;
	}
	
	module.exports = exports.default;

/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInSeconds;
	
	var _index = _interopRequireDefault(__webpack_require__(263));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	var _index3 = __webpack_require__(207);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInSeconds
	 * @category Second Helpers
	 * @summary Get the number of seconds between the given dates.
	 *
	 * @description
	 * Get the number of seconds between the given dates.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @param {Object} [options] - an object with options.
	 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
	 * @returns {Number} the number of seconds
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many seconds are between
	 * // 2 July 2014 12:30:07.999 and 2 July 2014 12:30:20.000?
	 * const result = differenceInSeconds(
	 *   new Date(2014, 6, 2, 12, 30, 20, 0),
	 *   new Date(2014, 6, 2, 12, 30, 7, 999)
	 * )
	 * //=> 12
	 */
	function differenceInSeconds(dateLeft, dateRight, options) {
	  (0, _index2.default)(2, arguments);
	  var diff = (0, _index.default)(dateLeft, dateRight) / 1000;
	  return (0, _index3.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
	}
	
	module.exports = exports.default;

/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = eachWeekendOfInterval;
	
	var _index = _interopRequireDefault(__webpack_require__(631));
	
	var _index2 = _interopRequireDefault(__webpack_require__(403));
	
	var _index3 = _interopRequireDefault(__webpack_require__(267));
	
	var _index4 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name eachWeekendOfInterval
	 * @category Interval Helpers
	 * @summary List all the Saturdays and Sundays in the given date interval.
	 *
	 * @description
	 * Get all the Saturdays and Sundays in the given date interval.
	 *
	 * @param {Interval} interval - the given interval. See [Interval]{@link https://date-fns.org/docs/Interval}
	 * @returns {Date[]} an array containing all the Saturdays and Sundays
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // Lists all Saturdays and Sundays in the given date interval
	 * const result = eachWeekendOfInterval({
	 *   start: new Date(2018, 8, 17),
	 *   end: new Date(2018, 8, 30)
	 * })
	 * //=> [
	 * //   Sat Sep 22 2018 00:00:00,
	 * //   Sun Sep 23 2018 00:00:00,
	 * //   Sat Sep 29 2018 00:00:00,
	 * //   Sun Sep 30 2018 00:00:00
	 * // ]
	 */
	function eachWeekendOfInterval(interval) {
	  (0, _index4.default)(1, arguments);
	  var dateInterval = (0, _index.default)(interval);
	  var weekends = [];
	  var index = 0;
	
	  while (index < dateInterval.length) {
	    var date = dateInterval[index++];
	
	    if ((0, _index3.default)(date)) {
	      weekends.push(date);
	      if ((0, _index2.default)(date)) index = index + 5;
	    }
	  }
	
	  return weekends;
	}
	
	module.exports = exports.default;

/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(26));
	
	var _index3 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name endOfWeek
	 * @category Week Helpers
	 * @summary Return the end of a week for the given date.
	 *
	 * @description
	 * Return the end of a week for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Date} the end of a week
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // The end of a week for 2 September 2014 11:55:00:
	 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Sat Sep 06 2014 23:59:59.999
	 *
	 * @example
	 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
	 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
	 * //=> Sun Sep 07 2014 23:59:59.999
	 */
	function endOfWeek(dirtyDate, dirtyOptions) {
	  (0, _index3.default)(1, arguments);
	  var options = dirtyOptions || {};
	  var locale = options.locale;
	  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
	  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, _index2.default)(localeWeekStartsOn);
	  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, _index2.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getDay();
	  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
	  date.setDate(date.getDate() + diff);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = format;
	
	var _index = _interopRequireDefault(__webpack_require__(96));
	
	var _index2 = _interopRequireDefault(__webpack_require__(108));
	
	var _index3 = _interopRequireDefault(__webpack_require__(215));
	
	var _index4 = _interopRequireDefault(__webpack_require__(9));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1534));
	
	var _index6 = _interopRequireDefault(__webpack_require__(619));
	
	var _index7 = _interopRequireDefault(__webpack_require__(107));
	
	var _index8 = __webpack_require__(623);
	
	var _index9 = _interopRequireDefault(__webpack_require__(26));
	
	var _index10 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This RegExp consists of three parts separated by `|`:
	// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
	//   (one of the certain letters followed by `o`)
	// - (\w)\1* matches any sequences of the same letter
	// - '' matches two quote characters in a row
	// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
	//   except a single quote symbol, which ends the sequence.
	//   Two quote characters do not end the sequence.
	//   If there is no matching single quote
	//   then the sequence will continue until the end of the string.
	// - . matches any single character unmatched by previous parts of the RegExps
	var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
	// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
	
	var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
	var escapedStringRegExp = /^'([^]*?)'?$/;
	var doubleQuoteRegExp = /''/g;
	var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
	/**
	 * @name format
	 * @category Common Helpers
	 * @summary Format the date.
	 *
	 * @description
	 * Return the formatted date string in the given format. The result may vary by locale.
	 *
	 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
	 * > See: https://git.io/fxCyr
	 *
	 * The characters wrapped between two single quotes characters (') are escaped.
	 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
	 * (see the last example)
	 *
	 * Format of the string is based on Unicode Technical Standard #35:
	 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
	 * with a few additions (see note 7 below the table).
	 *
	 * Accepted patterns:
	 * | Unit                            | Pattern | Result examples                   | Notes |
	 * |---------------------------------|---------|-----------------------------------|-------|
	 * | Era                             | G..GGG  | AD, BC                            |       |
	 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
	 * |                                 | GGGGG   | A, B                              |       |
	 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
	 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
	 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
	 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
	 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
	 * |                                 | yyyyy   | ...                               | 3,5   |
	 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
	 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
	 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
	 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
	 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
	 * |                                 | YYYYY   | ...                               | 3,5   |
	 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
	 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
	 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
	 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
	 * |                                 | RRRRR   | ...                               | 3,5,7 |
	 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
	 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
	 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
	 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
	 * |                                 | uuuuu   | ...                               | 3,5   |
	 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
	 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
	 * |                                 | QQ      | 01, 02, 03, 04                    |       |
	 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
	 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
	 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
	 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
	 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
	 * |                                 | qq      | 01, 02, 03, 04                    |       |
	 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
	 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
	 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
	 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
	 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
	 * |                                 | MM      | 01, 02, ..., 12                   |       |
	 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
	 * |                                 | MMMM    | January, February, ..., December  | 2     |
	 * |                                 | MMMMM   | J, F, ..., D                      |       |
	 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
	 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
	 * |                                 | LL      | 01, 02, ..., 12                   |       |
	 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
	 * |                                 | LLLL    | January, February, ..., December  | 2     |
	 * |                                 | LLLLL   | J, F, ..., D                      |       |
	 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
	 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
	 * |                                 | ww      | 01, 02, ..., 53                   |       |
	 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
	 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
	 * |                                 | II      | 01, 02, ..., 53                   | 7     |
	 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
	 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
	 * |                                 | dd      | 01, 02, ..., 31                   |       |
	 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
	 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
	 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
	 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
	 * |                                 | DDDD    | ...                               | 3     |
	 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
	 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
	 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
	 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
	 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
	 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
	 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
	 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
	 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
	 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
	 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
	 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
	 * |                                 | ee      | 02, 03, ..., 01                   |       |
	 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
	 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
	 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
	 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
	 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
	 * |                                 | cc      | 02, 03, ..., 01                   |       |
	 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
	 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
	 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
	 * | AM, PM                          | a..aa   | AM, PM                            |       |
	 * |                                 | aaa     | am, pm                            |       |
	 * |                                 | aaaa    | a.m., p.m.                        | 2     |
	 * |                                 | aaaaa   | a, p                              |       |
	 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
	 * |                                 | bbb     | am, pm, noon, midnight            |       |
	 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
	 * |                                 | bbbbb   | a, p, n, mi                       |       |
	 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
	 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
	 * |                                 | BBBBB   | at night, in the morning, ...     |       |
	 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
	 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
	 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
	 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
	 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
	 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
	 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
	 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
	 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
	 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
	 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
	 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
	 * | Minute                          | m       | 0, 1, ..., 59                     |       |
	 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
	 * |                                 | mm      | 00, 01, ..., 59                   |       |
	 * | Second                          | s       | 0, 1, ..., 59                     |       |
	 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
	 * |                                 | ss      | 00, 01, ..., 59                   |       |
	 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
	 * |                                 | SS      | 00, 01, ..., 99                   |       |
	 * |                                 | SSS     | 000, 001, ..., 999                |       |
	 * |                                 | SSSS    | ...                               | 3     |
	 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
	 * |                                 | XX      | -0800, +0530, Z                   |       |
	 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
	 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
	 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
	 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
	 * |                                 | xx      | -0800, +0530, +0000               |       |
	 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
	 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
	 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
	 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
	 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
	 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
	 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
	 * | Seconds timestamp               | t       | 512969520                         | 7     |
	 * |                                 | tt      | ...                               | 3,7   |
	 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
	 * |                                 | TT      | ...                               | 3,7   |
	 * | Long localized date             | P       | 04/29/1453                        | 7     |
	 * |                                 | PP      | Apr 29, 1453                      | 7     |
	 * |                                 | PPP     | April 29th, 1453                  | 7     |
	 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
	 * | Long localized time             | p       | 12:00 AM                          | 7     |
	 * |                                 | pp      | 12:00:00 AM                       | 7     |
	 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
	 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
	 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
	 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
	 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
	 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
	 * Notes:
	 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
	 *    are the same as "stand-alone" units, but are different in some languages.
	 *    "Formatting" units are declined according to the rules of the language
	 *    in the context of a date. "Stand-alone" units are always nominative singular:
	 *
	 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
	 *
	 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
	 *
	 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
	 *    the single quote characters (see below).
	 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
	 *    the output will be the same as default pattern for this unit, usually
	 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
	 *    are marked with "2" in the last column of the table.
	 *
	 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
	 *
	 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
	 *
	 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
	 *
	 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
	 *
	 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
	 *
	 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
	 *    The output will be padded with zeros to match the length of the pattern.
	 *
	 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
	 *
	 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
	 *    These tokens represent the shortest form of the quarter.
	 *
	 * 5. The main difference between `y` and `u` patterns are B.C. years:
	 *
	 *    | Year | `y` | `u` |
	 *    |------|-----|-----|
	 *    | AC 1 |   1 |   1 |
	 *    | BC 1 |   1 |   0 |
	 *    | BC 2 |   2 |  -1 |
	 *
	 *    Also `yy` always returns the last two digits of a year,
	 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
	 *
	 *    | Year | `yy` | `uu` |
	 *    |------|------|------|
	 *    | 1    |   01 |   01 |
	 *    | 14   |   14 |   14 |
	 *    | 376  |   76 |  376 |
	 *    | 1453 |   53 | 1453 |
	 *
	 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
	 *    except local week-numbering years are dependent on `options.weekStartsOn`
	 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
	 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
	 *
	 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
	 *    so right now these tokens fall back to GMT timezones.
	 *
	 * 7. These patterns are not in the Unicode Technical Standard #35:
	 *    - `i`: ISO day of week
	 *    - `I`: ISO week of year
	 *    - `R`: ISO week-numbering year
	 *    - `t`: seconds timestamp
	 *    - `T`: milliseconds timestamp
	 *    - `o`: ordinal number modifier
	 *    - `P`: long localized date
	 *    - `p`: long localized time
	 *
	 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
	 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
	 *
	 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
	 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The second argument is now required for the sake of explicitness.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *   format(new Date(2016, 0, 1))
	 *
	 *   // v2.0.0 onward
	 *   format(new Date(2016, 0, 1), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
	 *   ```
	 *
	 * - New format string API for `format` function
	 *   which is based on [Unicode Technical Standard #35](https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table).
	 *   See [this post](https://blog.date-fns.org/post/unicode-tokens-in-date-fns-v2-sreatyki91jg) for more details.
	 *
	 * - Characters are now escaped using single quote symbols (`'`) instead of square brackets.
	 *
	 * @param {Date|Number} date - the original date
	 * @param {String} format - the string of tokens
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
	 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
	 *   see: https://git.io/fxCyr
	 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
	 *   see: https://git.io/fxCyr
	 * @returns {String} the formatted date string
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `date` must not be Invalid Date
	 * @throws {RangeError} `options.locale` must contain `localize` property
	 * @throws {RangeError} `options.locale` must contain `formatLong` property
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
	 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
	 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
	 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
	 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
	 * @throws {RangeError} format string contains an unescaped latin alphabet character
	 *
	 * @example
	 * // Represent 11 February 2014 in middle-endian format:
	 * var result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
	 * //=> '02/11/2014'
	 *
	 * @example
	 * // Represent 2 July 2014 in Esperanto:
	 * import { eoLocale } from 'date-fns/locale/eo'
	 * var result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
	 *   locale: eoLocale
	 * })
	 * //=> '2-a de julio 2014'
	 *
	 * @example
	 * // Escape string by single quote characters:
	 * var result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
	 * //=> "3 o'clock"
	 */
	
	function format(dirtyDate, dirtyFormatStr, dirtyOptions) {
	  (0, _index10.default)(2, arguments);
	  var formatStr = String(dirtyFormatStr);
	  var options = dirtyOptions || {};
	  var locale = options.locale || _index2.default;
	  var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
	  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, _index9.default)(localeFirstWeekContainsDate);
	  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, _index9.default)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
	
	  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
	    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
	  }
	
	  var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
	  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, _index9.default)(localeWeekStartsOn);
	  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, _index9.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	
	  if (!locale.localize) {
	    throw new RangeError('locale must contain localize property');
	  }
	
	  if (!locale.formatLong) {
	    throw new RangeError('locale must contain formatLong property');
	  }
	
	  var originalDate = (0, _index4.default)(dirtyDate);
	
	  if (!(0, _index.default)(originalDate)) {
	    throw new RangeError('Invalid time value');
	  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
	  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
	  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
	
	
	  var timezoneOffset = (0, _index7.default)(originalDate);
	  var utcDate = (0, _index3.default)(originalDate, timezoneOffset);
	  var formatterOptions = {
	    firstWeekContainsDate: firstWeekContainsDate,
	    weekStartsOn: weekStartsOn,
	    locale: locale,
	    _originalDate: originalDate
	  };
	  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
	    var firstCharacter = substring[0];
	
	    if (firstCharacter === 'p' || firstCharacter === 'P') {
	      var longFormatter = _index6.default[firstCharacter];
	      return longFormatter(substring, locale.formatLong, formatterOptions);
	    }
	
	    return substring;
	  }).join('').match(formattingTokensRegExp).map(function (substring) {
	    // Replace two single quote characters with one single quote character
	    if (substring === "''") {
	      return "'";
	    }
	
	    var firstCharacter = substring[0];
	
	    if (firstCharacter === "'") {
	      return cleanEscapedString(substring);
	    }
	
	    var formatter = _index5.default[firstCharacter];
	
	    if (formatter) {
	      if (!options.useAdditionalWeekYearTokens && (0, _index8.isProtectedWeekYearToken)(substring)) {
	        (0, _index8.throwProtectedError)(substring, dirtyFormatStr, dirtyDate);
	      }
	
	      if (!options.useAdditionalDayOfYearTokens && (0, _index8.isProtectedDayOfYearToken)(substring)) {
	        (0, _index8.throwProtectedError)(substring, dirtyFormatStr, dirtyDate);
	      }
	
	      return formatter(utcDate, substring, locale.localize, formatterOptions);
	    }
	
	    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
	      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
	    }
	
	    return substring;
	  }).join('');
	  return result;
	}
	
	function cleanEscapedString(input) {
	  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
	}
	
	module.exports = exports.default;

/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDate;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getDate
	 * @category Day Helpers
	 * @summary Get the day of the month of the given date.
	 *
	 * @description
	 * Get the day of the month of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the day of month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which day of the month is 29 February 2012?
	 * const result = getDate(new Date(2012, 1, 29))
	 * //=> 29
	 */
	function getDate(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var dayOfMonth = date.getDate();
	  return dayOfMonth;
	}
	
	module.exports = exports.default;

/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getQuarter;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getQuarter
	 * @category Quarter Helpers
	 * @summary Get the year quarter of the given date.
	 *
	 * @description
	 * Get the year quarter of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the quarter
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which quarter is 2 July 2014?
	 * const result = getQuarter(new Date(2014, 6, 2))
	 * //=> 3
	 */
	function getQuarter(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var quarter = Math.floor(date.getMonth() / 3) + 1;
	  return quarter;
	}
	
	module.exports = exports.default;

/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getTime;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getTime
	 * @category Timestamp Helpers
	 * @summary Get the milliseconds timestamp of the given date.
	 *
	 * @description
	 * Get the milliseconds timestamp of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the timestamp
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Get the timestamp of 29 February 2012 11:45:05.123:
	 * const result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
	 * //=> 1330515905123
	 */
	function getTime(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var timestamp = date.getTime();
	  return timestamp;
	}
	
	module.exports = exports.default;

/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(109));
	
	var _index2 = _interopRequireDefault(__webpack_require__(413));
	
	var _index3 = _interopRequireDefault(__webpack_require__(9));
	
	var _index4 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_WEEK = 604800000;
	/**
	 * @name getWeek
	 * @category Week Helpers
	 * @summary Get the local week index of the given date.
	 *
	 * @description
	 * Get the local week index of the given date.
	 * The exact calculation depends on the values of
	 * `options.weekStartsOn` (which is the index of the first day of the week)
	 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
	 * the first week of the week-numbering year)
	 *
	 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
	 * @returns {Number} the week
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
	 *
	 * @example
	 * // Which week of the local week numbering year is 2 January 2005 with default options?
	 * const result = getWeek(new Date(2005, 0, 2))
	 * //=> 2
	 *
	 * // Which week of the local week numbering year is 2 January 2005,
	 * // if Monday is the first day of the week,
	 * // and the first week of the year always contains 4 January?
	 * const result = getWeek(new Date(2005, 0, 2), {
	 *   weekStartsOn: 1,
	 *   firstWeekContainsDate: 4
	 * })
	 * //=> 53
	 */
	
	function getWeek(dirtyDate, options) {
	  (0, _index4.default)(1, arguments);
	  var date = (0, _index3.default)(dirtyDate);
	  var diff = (0, _index.default)(date, options).getTime() - (0, _index2.default)(date, options).getTime(); // Round the number of days to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	
	  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
	}
	
	module.exports = exports.default;

/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isDate;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isDate
	 * @category Common Helpers
	 * @summary Is the given value a date?
	 *
	 * @description
	 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {*} value - the value to check
	 * @returns {boolean} true if the given value is a date
	 * @throws {TypeError} 1 arguments required
	 *
	 * @example
	 * // For a valid date:
	 * const result = isDate(new Date())
	 * //=> true
	 *
	 * @example
	 * // For an invalid date:
	 * const result = isDate(new Date(NaN))
	 * //=> true
	 *
	 * @example
	 * // For some value:
	 * const result = isDate('2014-02-31')
	 * //=> false
	 *
	 * @example
	 * // For an object:
	 * const result = isDate({})
	 * //=> false
	 */
	function isDate(value) {
	  (0, _index.default)(1, arguments);
	  return value instanceof Date || typeof value === 'object' && Object.prototype.toString.call(value) === '[object Date]';
	}
	
	module.exports = exports.default;

/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameMonth;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isSameMonth
	 * @category Month Helpers
	 * @summary Are the given dates in the same month (and year)?
	 *
	 * @description
	 * Are the given dates in the same month (and year)?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same month (and year)
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 2 September 2014 and 25 September 2014 in the same month?
	 * var result = isSameMonth(new Date(2014, 8, 2), new Date(2014, 8, 25))
	 * //=> true
	 *
	 * @example
	 * // Are 2 September 2014 and 25 September 2015 in the same month?
	 * var result = isSameMonth(new Date(2014, 8, 2), new Date(2015, 8, 25))
	 * //=> false
	 */
	function isSameMonth(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
	}
	
	module.exports = exports.default;

/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameQuarter;
	
	var _index = _interopRequireDefault(__webpack_require__(269));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isSameQuarter
	 * @category Quarter Helpers
	 * @summary Are the given dates in the same quarter (and year)?
	 *
	 * @description
	 * Are the given dates in the same quarter (and year)?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same quarter (and year)
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 1 January 2014 and 8 March 2014 in the same quarter?
	 * var result = isSameQuarter(new Date(2014, 0, 1), new Date(2014, 2, 8))
	 * //=> true
	 * 
	 * @example
	 * // Are 1 January 2014 and 1 January 2015 in the same quarter?
	 * var result = isSameQuarter(new Date(2014, 0, 1), new Date(2015, 0, 1))
	 * //=> false
	 */
	function isSameQuarter(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeftStartOfQuarter = (0, _index.default)(dirtyDateLeft);
	  var dateRightStartOfQuarter = (0, _index.default)(dirtyDateRight);
	  return dateLeftStartOfQuarter.getTime() === dateRightStartOfQuarter.getTime();
	}
	
	module.exports = exports.default;

/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(109));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isSameWeek
	 * @category Week Helpers
	 * @summary Are the given dates in the same week (and month and year)?
	 *
	 * @description
	 * Are the given dates in the same week (and month and year)?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Boolean} the dates are in the same week (and month and year)
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // Are 31 August 2014 and 4 September 2014 in the same week?
	 * var result = isSameWeek(new Date(2014, 7, 31), new Date(2014, 8, 4))
	 * //=> true
	 *
	 * @example
	 * // If week starts with Monday,
	 * // are 31 August 2014 and 4 September 2014 in the same week?
	 * var result = isSameWeek(new Date(2014, 7, 31), new Date(2014, 8, 4), {
	 *   weekStartsOn: 1
	 * })
	 * //=> false
	 * 
	 * @example
	 * // Are 1 January 2014 and 1 January 2015 in the same week?
	 * var result = isSameWeek(new Date(2014, 0, 1), new Date(2015, 0, 1))
	 * //=> false
	 */
	function isSameWeek(dirtyDateLeft, dirtyDateRight, dirtyOptions) {
	  (0, _index2.default)(2, arguments);
	  var dateLeftStartOfWeek = (0, _index.default)(dirtyDateLeft, dirtyOptions);
	  var dateRightStartOfWeek = (0, _index.default)(dirtyDateRight, dirtyOptions);
	  return dateLeftStartOfWeek.getTime() === dateRightStartOfWeek.getTime();
	}
	
	module.exports = exports.default;

/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameYear;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isSameYear
	 * @category Year Helpers
	 * @summary Are the given dates in the same year?
	 *
	 * @description
	 * Are the given dates in the same year?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same year
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 2 September 2014 and 25 September 2014 in the same year?
	 * var result = isSameYear(new Date(2014, 8, 2), new Date(2014, 8, 25))
	 * //=> true
	 */
	function isSameYear(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  return dateLeft.getFullYear() === dateRight.getFullYear();
	}
	
	module.exports = exports.default;

/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSunday;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isSunday
	 * @category Weekday Helpers
	 * @summary Is the given date Sunday?
	 *
	 * @description
	 * Is the given date Sunday?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is Sunday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Is 21 September 2014 Sunday?
	 * var result = isSunday(new Date(2014, 8, 21))
	 * //=> true
	 */
	function isSunday(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getDay() === 0;
	}
	
	module.exports = exports.default;

/***/ },
/* 404 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = buildFormatLongFn;
	
	function buildFormatLongFn(args) {
	  return function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    // TODO: Remove String()
	    var width = options.width ? String(options.width) : args.defaultWidth;
	    var format = args.formats[width] || args.formats[args.defaultWidth];
	    return format;
	  };
	}
	
	module.exports = exports.default;

/***/ },
/* 405 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = buildLocalizeFn;
	
	function buildLocalizeFn(args) {
	  return function (dirtyIndex, dirtyOptions) {
	    var options = dirtyOptions || {};
	    var context = options.context ? String(options.context) : 'standalone';
	    var valuesArray;
	
	    if (context === 'formatting' && args.formattingValues) {
	      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
	      var width = options.width ? String(options.width) : defaultWidth;
	      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
	    } else {
	      var _defaultWidth = args.defaultWidth;
	
	      var _width = options.width ? String(options.width) : args.defaultWidth;
	
	      valuesArray = args.values[_width] || args.values[_defaultWidth];
	    }
	
	    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex; // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
	
	    return valuesArray[index];
	  };
	}
	
	module.exports = exports.default;

/***/ },
/* 406 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = buildMatchFn;
	
	function buildMatchFn(args) {
	  return function (string) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var width = options.width;
	    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
	    var matchResult = string.match(matchPattern);
	
	    if (!matchResult) {
	      return null;
	    }
	
	    var matchedString = matchResult[0];
	    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
	    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
	      return pattern.test(matchedString);
	    }) : findKey(parsePatterns, function (pattern) {
	      return pattern.test(matchedString);
	    });
	    var value;
	    value = args.valueCallback ? args.valueCallback(key) : key;
	    value = options.valueCallback ? options.valueCallback(value) : value;
	    var rest = string.slice(matchedString.length);
	    return {
	      value: value,
	      rest: rest
	    };
	  };
	}
	
	function findKey(object, predicate) {
	  for (var key in object) {
	    if (object.hasOwnProperty(key) && predicate(object[key])) {
	      return key;
	    }
	  }
	
	  return undefined;
	}
	
	function findIndex(array, predicate) {
	  for (var key = 0; key < array.length; key++) {
	    if (predicate(array[key])) {
	      return key;
	    }
	  }
	
	  return undefined;
	}
	
	module.exports = exports.default;

/***/ },
/* 407 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = buildMatchPatternFn;
	
	function buildMatchPatternFn(args) {
	  return function (string) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var matchResult = string.match(args.matchPattern);
	    if (!matchResult) return null;
	    var matchedString = matchResult[0];
	    var parseResult = string.match(args.parsePattern);
	    if (!parseResult) return null;
	    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
	    value = options.valueCallback ? options.valueCallback(value) : value;
	    var rest = string.slice(matchedString.length);
	    return {
	      value: value,
	      rest: rest
	    };
	  };
	}
	
	module.exports = exports.default;

/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1630));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1631));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1632));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1633));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1634));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Spanish locale.
	 * @language Spanish
	 * @iso-639-2 spa
	 * @author Juan Angosto [@juanangosto]{@link https://github.com/juanangosto}
	 * @author Guillermo Grau [@guigrpa]{@link https://github.com/guigrpa}
	 * @author Fernando Agüero [@fjaguero]{@link https://github.com/fjaguero}
	 * @author Gastón Haro [@harogaston]{@link https://github.com/harogaston}
	 * @author Yago Carballo [@YagoCarballo]{@link https://github.com/YagoCarballo}
	 */
	var locale = {
	  code: 'es',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = max;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name max
	 * @category Common Helpers
	 * @summary Return the latest of the given dates.
	 *
	 * @description
	 * Return the latest of the given dates.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - `max` function now accepts an array of dates rather than spread arguments.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *   var date1 = new Date(1989, 6, 10)
	 *   var date2 = new Date(1987, 1, 11)
	 *   var maxDate = max(date1, date2)
	 *
	 *   // v2.0.0 onward:
	 *   var dates = [new Date(1989, 6, 10), new Date(1987, 1, 11)]
	 *   var maxDate = max(dates)
	 *   ```
	 *
	 * @param {Date[]|Number[]} datesArray - the dates to compare
	 * @returns {Date} the latest of the dates
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which of these dates is the latest?
	 * var result = max([
	 *   new Date(1989, 6, 10),
	 *   new Date(1987, 1, 11),
	 *   new Date(1995, 6, 2),
	 *   new Date(1990, 0, 1)
	 * ])
	 * //=> Sun Jul 02 1995 00:00:00
	 */
	function max(dirtyDatesArray) {
	  (0, _index2.default)(1, arguments);
	  var datesArray; // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
	
	  if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') {
	    datesArray = dirtyDatesArray; // If `dirtyDatesArray` is Array-like Object, convert to Array.
	  } else if (typeof dirtyDatesArray === 'object' && dirtyDatesArray !== null) {
	    datesArray = Array.prototype.slice.call(dirtyDatesArray);
	  } else {
	    // `dirtyDatesArray` is non-iterable, return Invalid Date
	    return new Date(NaN);
	  }
	
	  var result;
	  datesArray.forEach(function (dirtyDate) {
	    var currentDate = (0, _index.default)(dirtyDate);
	
	    if (result === undefined || result < currentDate || isNaN(Number(currentDate))) {
	      result = currentDate;
	    }
	  });
	  return result || new Date(NaN);
	}
	
	module.exports = exports.default;

/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = min;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name min
	 * @category Common Helpers
	 * @summary Returns the earliest of the given dates.
	 *
	 * @description
	 * Returns the earliest of the given dates.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - `min` function now accepts an array of dates rather than spread arguments.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *   const date1 = new Date(1989, 6, 10)
	 *   const date2 = new Date(1987, 1, 11)
	 *   const minDate = min(date1, date2)
	 *
	 *   // v2.0.0 onward:
	 *   const dates = [new Date(1989, 6, 10), new Date(1987, 1, 11)]
	 *   const minDate = min(dates)
	 *   ```
	 *
	 * @param {Date[]|Number[]} datesArray - the dates to compare
	 * @returns {Date} - the earliest of the dates
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which of these dates is the earliest?
	 * const result = min([
	 *   new Date(1989, 6, 10),
	 *   new Date(1987, 1, 11),
	 *   new Date(1995, 6, 2),
	 *   new Date(1990, 0, 1)
	 * ])
	 * //=> Wed Feb 11 1987 00:00:00
	 */
	function min(dirtyDatesArray) {
	  (0, _index2.default)(1, arguments);
	  var datesArray; // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
	
	  if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') {
	    datesArray = dirtyDatesArray; // If `dirtyDatesArray` is Array-like Object, convert to Array.
	  } else if (typeof dirtyDatesArray === 'object' && dirtyDatesArray !== null) {
	    datesArray = Array.prototype.slice.call(dirtyDatesArray);
	  } else {
	    // `dirtyDatesArray` is non-iterable, return Invalid Date
	    return new Date(NaN);
	  }
	
	  var result;
	  datesArray.forEach(function (dirtyDate) {
	    var currentDate = (0, _index.default)(dirtyDate);
	
	    if (result === undefined || result > currentDate || isNaN(currentDate.getDate())) {
	      result = currentDate;
	    }
	  });
	  return result || new Date(NaN);
	}
	
	module.exports = exports.default;

/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = parse;
	
	var _index = _interopRequireDefault(__webpack_require__(108));
	
	var _index2 = _interopRequireDefault(__webpack_require__(215));
	
	var _index3 = _interopRequireDefault(__webpack_require__(9));
	
	var _index4 = _interopRequireDefault(__webpack_require__(616));
	
	var _index5 = _interopRequireDefault(__webpack_require__(619));
	
	var _index6 = _interopRequireDefault(__webpack_require__(107));
	
	var _index7 = __webpack_require__(623);
	
	var _index8 = _interopRequireDefault(__webpack_require__(26));
	
	var _index9 = _interopRequireDefault(__webpack_require__(1657));
	
	var _index10 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TIMEZONE_UNIT_PRIORITY = 10; // This RegExp consists of three parts separated by `|`:
	// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
	//   (one of the certain letters followed by `o`)
	// - (\w)\1* matches any sequences of the same letter
	// - '' matches two quote characters in a row
	// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
	//   except a single quote symbol, which ends the sequence.
	//   Two quote characters do not end the sequence.
	//   If there is no matching single quote
	//   then the sequence will continue until the end of the string.
	// - . matches any single character unmatched by previous parts of the RegExps
	
	var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
	// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
	
	var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
	var escapedStringRegExp = /^'([^]*?)'?$/;
	var doubleQuoteRegExp = /''/g;
	var notWhitespaceRegExp = /\S/;
	var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
	/**
	 * @name parse
	 * @category Common Helpers
	 * @summary Parse the date.
	 *
	 * @description
	 * Return the date parsed from string using the given format string.
	 *
	 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
	 * > See: https://git.io/fxCyr
	 *
	 * The characters in the format string wrapped between two single quotes characters (') are escaped.
	 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
	 *
	 * Format of the format string is based on Unicode Technical Standard #35:
	 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
	 * with a few additions (see note 5 below the table).
	 *
	 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
	 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
	 *
	 * ```javascript
	 * parse('23 AM', 'HH a', new Date())
	 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
	 * ```
	 *
	 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
	 *
	 * Accepted format string patterns:
	 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
	 * |---------------------------------|-----|---------|-----------------------------------|-------|
	 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
	 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
	 * |                                 |     | GGGGG   | A, B                              |       |
	 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
	 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
	 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
	 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
	 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
	 * |                                 |     | yyyyy   | ...                               | 2,4   |
	 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
	 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
	 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
	 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
	 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
	 * |                                 |     | YYYYY   | ...                               | 2,4   |
	 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
	 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
	 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
	 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
	 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
	 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
	 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
	 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
	 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
	 * |                                 |     | uuuuu   | ...                               | 2,4   |
	 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
	 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
	 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
	 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
	 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
	 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
	 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
	 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
	 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
	 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
	 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
	 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
	 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
	 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
	 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
	 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
	 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
	 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
	 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
	 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
	 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
	 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
	 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
	 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
	 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
	 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
	 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
	 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
	 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
	 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
	 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
	 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
	 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
	 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
	 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
	 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
	 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
	 * |                                 |     | DDDD    | ...                               | 2     |
	 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
	 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
	 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
	 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
	 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
	 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
	 * |                                 |     | iii     | Mon, Tue, Wed, ..., Sun           | 5     |
	 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
	 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
	 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
	 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
	 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
	 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
	 * |                                 |     | eee     | Mon, Tue, Wed, ..., Sun           |       |
	 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
	 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
	 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
	 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
	 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
	 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Sun           |       |
	 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
	 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
	 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
	 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
	 * |                                 |     | aaaaa   | a, p                              |       |
	 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
	 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
	 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
	 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
	 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
	 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
	 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
	 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
	 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
	 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
	 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
	 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
	 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
	 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
	 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
	 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
	 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
	 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
	 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
	 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
	 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
	 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
	 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
	 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
	 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
	 * |                                 |     | tt      | ...                               | 2     |
	 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
	 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
	 * |                                 |     | SSS     | 000, 001, ..., 999                |       |
	 * |                                 |     | SSSS    | ...                               | 2     |
	 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
	 * |                                 |     | TT      | ...                               | 2     |
	 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
	 * |                                 |     | XX      | -0800, +0530, Z                   |       |
	 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
	 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
	 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
	 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
	 * |                                 |     | xx      | -0800, +0530, +0000               |       |
	 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
	 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
	 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
	 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
	 * |                                 |     | PP      | May 29, 1453                      |       |
	 * |                                 |     | PPP     | May 29th, 1453                    |       |
	 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
	 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
	 * |                                 |     | pp      | 12:00:00 AM                       |       |
	 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
	 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
	 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
	 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
	 * Notes:
	 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
	 *    are the same as "stand-alone" units, but are different in some languages.
	 *    "Formatting" units are declined according to the rules of the language
	 *    in the context of a date. "Stand-alone" units are always nominative singular.
	 *    In `format` function, they will produce different result:
	 *
	 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
	 *
	 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
	 *
	 *    `parse` will try to match both formatting and stand-alone units interchangably.
	 *
	 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
	 *    the single quote characters (see below).
	 *    If the sequence is longer than listed in table:
	 *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
	 *      as wide as the sequence
	 *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
	 *      These variations are marked with "2" in the last column of the table.
	 *
	 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
	 *    These tokens represent the shortest form of the quarter.
	 *
	 * 4. The main difference between `y` and `u` patterns are B.C. years:
	 *
	 *    | Year | `y` | `u` |
	 *    |------|-----|-----|
	 *    | AC 1 |   1 |   1 |
	 *    | BC 1 |   1 |   0 |
	 *    | BC 2 |   2 |  -1 |
	 *
	 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
	 *
	 *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
	 *
	 *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
	 *
	 *    while `uu` will just assign the year as is:
	 *
	 *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
	 *
	 *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
	 *
	 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
	 *    except local week-numbering years are dependent on `options.weekStartsOn`
	 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear]{@link https://date-fns.org/docs/setISOWeekYear}
	 *    and [setWeekYear]{@link https://date-fns.org/docs/setWeekYear}).
	 *
	 * 5. These patterns are not in the Unicode Technical Standard #35:
	 *    - `i`: ISO day of week
	 *    - `I`: ISO week of year
	 *    - `R`: ISO week-numbering year
	 *    - `o`: ordinal number modifier
	 *    - `P`: long localized date
	 *    - `p`: long localized time
	 *
	 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
	 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
	 *
	 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
	 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
	 *
	 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
	 *    on the given locale.
	 *
	 *    using `en-US` locale: `P` => `MM/dd/yyyy`
	 *    using `en-US` locale: `p` => `hh:mm a`
	 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
	 *    using `pt-BR` locale: `p` => `HH:mm`
	 *
	 * Values will be assigned to the date in the descending order of its unit's priority.
	 * Units of an equal priority overwrite each other in the order of appearance.
	 *
	 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
	 * the values will be taken from 3rd argument `referenceDate` which works as a context of parsing.
	 *
	 * `referenceDate` must be passed for correct work of the function.
	 * If you're not sure which `referenceDate` to supply, create a new instance of Date:
	 * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
	 * In this case parsing will be done in the context of the current date.
	 * If `referenceDate` is `Invalid Date` or a value not convertible to valid `Date`,
	 * then `Invalid Date` will be returned.
	 *
	 * The result may vary by locale.
	 *
	 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
	 *
	 * If parsing failed, `Invalid Date` will be returned.
	 * Invalid Date is a Date, whose time value is NaN.
	 * Time value of Date: http://es5.github.io/#x15.9.1.1
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - Old `parse` was renamed to `toDate`.
	 *   Now `parse` is a new function which parses a string using a provided format.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *   parse('2016-01-01')
	 *
	 *   // v2.0.0 onward (toDate no longer accepts a string)
	 *   toDate(1392098430000) // Unix to timestamp
	 *   toDate(new Date(2014, 1, 11, 11, 30, 30)) // Cloning the date
	 *   parse('2016-01-01', 'yyyy-MM-dd', new Date())
	 *   ```
	 *
	 * @param {String} dateString - the string to parse
	 * @param {String} formatString - the string of tokens
	 * @param {Date|Number} referenceDate - defines values missing from the parsed dateString
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
	 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
	 *   see: https://git.io/fxCyr
	 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
	 *   see: https://git.io/fxCyr
	 * @returns {Date} the parsed date
	 * @throws {TypeError} 3 arguments required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
	 * @throws {RangeError} `options.locale` must contain `match` property
	 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
	 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
	 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
	 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
	 * @throws {RangeError} format string contains an unescaped latin alphabet character
	 *
	 * @example
	 * // Parse 11 February 2014 from middle-endian format:
	 * var result = parse('02/11/2014', 'MM/dd/yyyy', new Date())
	 * //=> Tue Feb 11 2014 00:00:00
	 *
	 * @example
	 * // Parse 28th of February in Esperanto locale in the context of 2010 year:
	 * import eo from 'date-fns/locale/eo'
	 * var result = parse('28-a de februaro', "do 'de' MMMM", new Date(2010, 0, 1), {
	 *   locale: eo
	 * })
	 * //=> Sun Feb 28 2010 00:00:00
	 */
	
	function parse(dirtyDateString, dirtyFormatString, dirtyReferenceDate, dirtyOptions) {
	  (0, _index10.default)(3, arguments);
	  var dateString = String(dirtyDateString);
	  var formatString = String(dirtyFormatString);
	  var options = dirtyOptions || {};
	  var locale = options.locale || _index.default;
	
	  if (!locale.match) {
	    throw new RangeError('locale must contain match property');
	  }
	
	  var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
	  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, _index8.default)(localeFirstWeekContainsDate);
	  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, _index8.default)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
	
	  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
	    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
	  }
	
	  var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
	  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, _index8.default)(localeWeekStartsOn);
	  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, _index8.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	
	  if (formatString === '') {
	    if (dateString === '') {
	      return (0, _index3.default)(dirtyReferenceDate);
	    } else {
	      return new Date(NaN);
	    }
	  }
	
	  var subFnOptions = {
	    firstWeekContainsDate: firstWeekContainsDate,
	    weekStartsOn: weekStartsOn,
	    locale: locale
	  }; // If timezone isn't specified, it will be set to the system timezone
	
	  var setters = [{
	    priority: TIMEZONE_UNIT_PRIORITY,
	    subPriority: -1,
	    set: dateToSystemTimezone,
	    index: 0
	  }];
	  var i;
	  var tokens = formatString.match(longFormattingTokensRegExp).map(function (substring) {
	    var firstCharacter = substring[0];
	
	    if (firstCharacter === 'p' || firstCharacter === 'P') {
	      var longFormatter = _index5.default[firstCharacter];
	      return longFormatter(substring, locale.formatLong, subFnOptions);
	    }
	
	    return substring;
	  }).join('').match(formattingTokensRegExp);
	  var usedTokens = [];
	
	  for (i = 0; i < tokens.length; i++) {
	    var token = tokens[i];
	
	    if (!options.useAdditionalWeekYearTokens && (0, _index7.isProtectedWeekYearToken)(token)) {
	      (0, _index7.throwProtectedError)(token, formatString, dirtyDateString);
	    }
	
	    if (!options.useAdditionalDayOfYearTokens && (0, _index7.isProtectedDayOfYearToken)(token)) {
	      (0, _index7.throwProtectedError)(token, formatString, dirtyDateString);
	    }
	
	    var firstCharacter = token[0];
	    var parser = _index9.default[firstCharacter];
	
	    if (parser) {
	      var incompatibleTokens = parser.incompatibleTokens;
	
	      if (Array.isArray(incompatibleTokens)) {
	        var incompatibleToken = void 0;
	
	        for (var _i = 0; _i < usedTokens.length; _i++) {
	          var usedToken = usedTokens[_i].token;
	
	          if (incompatibleTokens.indexOf(usedToken) !== -1 || usedToken === firstCharacter) {
	            incompatibleToken = usedTokens[_i];
	            break;
	          }
	        }
	
	        if (incompatibleToken) {
	          throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
	        }
	      } else if (parser.incompatibleTokens === '*' && usedTokens.length) {
	        throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
	      }
	
	      usedTokens.push({
	        token: firstCharacter,
	        fullToken: token
	      });
	      var parseResult = parser.parse(dateString, token, locale.match, subFnOptions);
	
	      if (!parseResult) {
	        return new Date(NaN);
	      }
	
	      setters.push({
	        priority: parser.priority,
	        subPriority: parser.subPriority || 0,
	        set: parser.set,
	        validate: parser.validate,
	        value: parseResult.value,
	        index: setters.length
	      });
	      dateString = parseResult.rest;
	    } else {
	      if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
	        throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
	      } // Replace two single quote characters with one single quote character
	
	
	      if (token === "''") {
	        token = "'";
	      } else if (firstCharacter === "'") {
	        token = cleanEscapedString(token);
	      } // Cut token from string, or, if string doesn't match the token, return Invalid Date
	
	
	      if (dateString.indexOf(token) === 0) {
	        dateString = dateString.slice(token.length);
	      } else {
	        return new Date(NaN);
	      }
	    }
	  } // Check if the remaining input contains something other than whitespace
	
	
	  if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) {
	    return new Date(NaN);
	  }
	
	  var uniquePrioritySetters = setters.map(function (setter) {
	    return setter.priority;
	  }).sort(function (a, b) {
	    return b - a;
	  }).filter(function (priority, index, array) {
	    return array.indexOf(priority) === index;
	  }).map(function (priority) {
	    return setters.filter(function (setter) {
	      return setter.priority === priority;
	    }).sort(function (a, b) {
	      return b.subPriority - a.subPriority;
	    });
	  }).map(function (setterArray) {
	    return setterArray[0];
	  });
	  var date = (0, _index3.default)(dirtyReferenceDate);
	
	  if (isNaN(date)) {
	    return new Date(NaN);
	  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
	  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
	  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/37
	
	
	  var utcDate = (0, _index2.default)(date, (0, _index6.default)(date));
	  var flags = {};
	
	  for (i = 0; i < uniquePrioritySetters.length; i++) {
	    var setter = uniquePrioritySetters[i];
	
	    if (setter.validate && !setter.validate(utcDate, setter.value, subFnOptions)) {
	      return new Date(NaN);
	    }
	
	    var result = setter.set(utcDate, flags, setter.value, subFnOptions); // Result is tuple (date, flags)
	
	    if (result[0]) {
	      utcDate = result[0];
	      (0, _index4.default)(flags, result[1]); // Result is date
	    } else {
	      utcDate = result;
	    }
	  }
	
	  return utcDate;
	}
	
	function dateToSystemTimezone(date, flags) {
	  if (flags.timestampIsSet) {
	    return date;
	  }
	
	  var convertedDate = new Date(0);
	  convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
	  convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
	  return convertedDate;
	}
	
	function cleanEscapedString(input) {
	  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
	}
	
	module.exports = exports.default;

/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfMinute;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfMinute
	 * @category Minute Helpers
	 * @summary Return the start of a minute for the given date.
	 *
	 * @description
	 * Return the start of a minute for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of a minute
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of a minute for 1 December 2014 22:15:45.400:
	 * const result = startOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
	 * //=> Mon Dec 01 2014 22:15:00
	 */
	function startOfMinute(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setSeconds(0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfWeekYear;
	
	var _index = _interopRequireDefault(__webpack_require__(642));
	
	var _index2 = _interopRequireDefault(__webpack_require__(109));
	
	var _index3 = _interopRequireDefault(__webpack_require__(26));
	
	var _index4 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfWeekYear
	 * @category Week-Numbering Year Helpers
	 * @summary Return the start of a local week-numbering year for the given date.
	 *
	 * @description
	 * Return the start of a local week-numbering year.
	 * The exact calculation depends on the values of
	 * `options.weekStartsOn` (which is the index of the first day of the week)
	 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
	 * the first week of the week-numbering year)
	 *
	 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
	 * @returns {Date} the start of a week-numbering year
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
	 *
	 * @example
	 * // The start of an a week-numbering year for 2 July 2005 with default settings:
	 * const result = startOfWeekYear(new Date(2005, 6, 2))
	 * //=> Sun Dec 26 2004 00:00:00
	 *
	 * @example
	 * // The start of a week-numbering year for 2 July 2005
	 * // if Monday is the first day of week
	 * // and 4 January is always in the first week of the year:
	 * const result = startOfWeekYear(new Date(2005, 6, 2), {
	 *   weekStartsOn: 1,
	 *   firstWeekContainsDate: 4
	 * })
	 * //=> Mon Jan 03 2005 00:00:00
	 */
	function startOfWeekYear(dirtyDate, dirtyOptions) {
	  (0, _index4.default)(1, arguments);
	  var options = dirtyOptions || {};
	  var locale = options.locale;
	  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
	  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, _index3.default)(localeFirstWeekContainsDate);
	  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, _index3.default)(options.firstWeekContainsDate);
	  var year = (0, _index.default)(dirtyDate, dirtyOptions);
	  var firstWeek = new Date(0);
	  firstWeek.setFullYear(year, 0, firstWeekContainsDate);
	  firstWeek.setHours(0, 0, 0, 0);
	  var date = (0, _index2.default)(firstWeek, dirtyOptions);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subMonths;
	
	var _index = _interopRequireDefault(__webpack_require__(26));
	
	var _index2 = _interopRequireDefault(__webpack_require__(170));
	
	var _index3 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name subMonths
	 * @category Month Helpers
	 * @summary Subtract the specified number of months from the given date.
	 *
	 * @description
	 * Subtract the specified number of months from the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of months to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the months subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 5 months from 1 February 2015:
	 * const result = subMonths(new Date(2015, 1, 1), 5)
	 * //=> Mon Sep 01 2014 00:00:00
	 */
	function subMonths(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	
	module.exports = exports.default;

/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $defineProperty = __webpack_require__(419);
	
	var $SyntaxError = __webpack_require__(686);
	var $TypeError = __webpack_require__(175);
	
	var gopd = __webpack_require__(717);
	
	/** @type {import('.')} */
	module.exports = function defineDataProperty(
		obj,
		property,
		value
	) {
		if (!obj || (typeof obj !== 'object' && typeof obj !== 'function')) {
			throw new $TypeError('`obj` must be an object or a function`');
		}
		if (typeof property !== 'string' && typeof property !== 'symbol') {
			throw new $TypeError('`property` must be a string or a symbol`');
		}
		if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) {
			throw new $TypeError('`nonEnumerable`, if provided, must be a boolean or null');
		}
		if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) {
			throw new $TypeError('`nonWritable`, if provided, must be a boolean or null');
		}
		if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) {
			throw new $TypeError('`nonConfigurable`, if provided, must be a boolean or null');
		}
		if (arguments.length > 6 && typeof arguments[6] !== 'boolean') {
			throw new $TypeError('`loose`, if provided, must be a boolean');
		}
	
		var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
		var nonWritable = arguments.length > 4 ? arguments[4] : null;
		var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
		var loose = arguments.length > 6 ? arguments[6] : false;
	
		/* @type {false | TypedPropertyDescriptor<unknown>} */
		var desc = !!gopd && gopd(obj, property);
	
		if ($defineProperty) {
			$defineProperty(obj, property, {
				configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
				enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
				value: value,
				writable: nonWritable === null && desc ? desc.writable : !nonWritable
			});
		} else if (loose || (!nonEnumerable && !nonWritable && !nonConfigurable)) {
			// must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
			obj[property] = value; // eslint-disable-line no-param-reassign
		} else {
			throw new $SyntaxError('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
		}
	};


/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = addClass;
	
	var _hasClass = _interopRequireDefault(__webpack_require__(675));
	
	function addClass(element, className) {
	  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
	}
	
	module.exports = exports["default"];

/***/ },
/* 417 */
/***/ function(module, exports) {

	'use strict';
	
	function replaceClassName(origClass, classToRemove) {
	  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
	}
	
	module.exports = function removeClass(element, className) {
	  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
	};

/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(123));
	
	var off = function off() {};
	
	if (_inDOM.default) {
	  off = function () {
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.removeEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.detachEvent('on' + eventName, handler);
	    };
	  }();
	}
	
	var _default = off;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(218);
	
	/** @type {import('.')} */
	var $defineProperty = GetIntrinsic('%Object.defineProperty%', true) || false;
	if ($defineProperty) {
		try {
			$defineProperty({}, 'a', { value: 1 });
		} catch (e) {
			// IE 8 has a broken defineProperty
			$defineProperty = false;
		}
	}
	
	module.exports = $defineProperty;


/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(1877);
	
	module.exports = Function.prototype.bind || implementation;


/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _reactstrap = __webpack_require__(48);
	
	var _classNames2 = _interopRequireDefault(__webpack_require__(61));
	
	__webpack_require__(2523);
	
	__webpack_require__(2524);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var ButtonIcon = function ButtonIcon(props) {
	  var _classNames;
	
	  var classes = (0, _classNames2["default"])((_classNames = {
	    disabled: props.disabled
	  }, _defineProperty(_classNames, props.size, props.size), _defineProperty(_classNames, props.shape, true), _defineProperty(_classNames, props.color, true), _classNames));
	
	  var onClick = function onClick(e) {
	    !props.disabled && props.onClick(e);
	  };
	
	  var tooltipRef = (0, _react.useRef)();
	  return /*#__PURE__*/_react["default"].createElement("button", {
	    id: props.id,
	    className: 'gcl-btnIcon ' + classes,
	    onClick: onClick,
	    onMouseDown: function onMouseDown(e) {
	      return e.preventDefault();
	    }
	  }, /*#__PURE__*/_react["default"].createElement("i", {
	    className: 'gcl-icon ' + props.icon + ' ' + props.size,
	    ref: tooltipRef
	  }), props.tooltip != null && /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
	    target: tooltipRef,
	    delay: {
	      show: 300,
	      hide: 100
	    },
	    placement: "top",
	    trigger: "hover",
	    boundariesElement: "window"
	  }, props.tooltip));
	};
	
	ButtonIcon.propTypes = {
	  onClick: _propTypes["default"].func.isRequired,
	  disabled: _propTypes["default"].bool,
	  shape: _propTypes["default"].oneOf(['square', 'circle']),
	  size: _propTypes["default"].oneOf(['small', 'large', '']),
	  icon: _propTypes["default"].string,
	  id: _propTypes["default"].string,
	  color: _propTypes["default"].oneOf(['primary', 'secondary']),
	  tooltip: _propTypes["default"].string
	};
	ButtonIcon.defaultProps = {
	  onClick: function onClick() {
	    return console.warn('no function was assigned as prop');
	  },
	  disabled: false,
	  shape: 'square',
	  size: '',
	  color: 'secondary'
	};
	var _default = ButtonIcon;
	exports["default"] = _default;

/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.toState = exports.calculateSaturationChange = exports.calculateHueChange = void 0;
	
	var _tinycolor = _interopRequireDefault(__webpack_require__(2469));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var calculateHueChange = function calculateHueChange(e, direction, hsl, container) {
	  var containerWidth = container.clientWidth;
	  var containerHeight = container.clientHeight;
	  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
	  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
	  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
	  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
	
	  if (direction === 'vertical') {
	    var h;
	
	    if (top < 0) {
	      h = 359;
	    } else if (top > containerHeight) {
	      h = 0;
	    } else {
	      var percent = -(top * 100 / containerHeight) + 100;
	      h = 360 * percent / 100;
	    }
	
	    if (hsl.h !== h) {
	      return {
	        h: h,
	        s: hsl.s,
	        l: hsl.l,
	        a: hsl.a,
	        source: 'hsl'
	      };
	    }
	  } else {
	    var _h;
	
	    if (left < 0) {
	      _h = 0;
	    } else if (left > containerWidth) {
	      _h = 359;
	    } else {
	      var _percent = left * 100 / containerWidth;
	
	      _h = 360 * _percent / 100;
	    }
	
	    if (hsl.h !== _h) {
	      return {
	        h: _h,
	        s: hsl.s,
	        l: hsl.l,
	        a: hsl.a,
	        source: 'hsl'
	      };
	    }
	  }
	
	  return null;
	};
	
	exports.calculateHueChange = calculateHueChange;
	
	var calculateSaturationChange = function calculateSaturationChange(e, hsl, container) {
	  var _container$getBoundin = container.getBoundingClientRect(),
	      containerWidth = _container$getBoundin.width,
	      containerHeight = _container$getBoundin.height;
	
	  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
	  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
	  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
	  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
	
	  if (left < 0) {
	    left = 0;
	  } else if (left > containerWidth) {
	    left = containerWidth;
	  }
	
	  if (top < 0) {
	    top = 0;
	  } else if (top > containerHeight) {
	    top = containerHeight;
	  }
	
	  var saturation = left / containerWidth;
	  var bright = 1 - top / containerHeight;
	  return {
	    h: hsl.h,
	    s: saturation,
	    v: bright,
	    a: hsl.a,
	    source: 'hsv'
	  };
	};
	
	exports.calculateSaturationChange = calculateSaturationChange;
	
	var toState = function toState(data, oldHue) {
	  var color = data.hex ? (0, _tinycolor["default"])(data.hex) : (0, _tinycolor["default"])(data);
	  var hsl = color.toHsl();
	  var hsv = color.toHsv();
	  var rgb = color.toRgb();
	  var hex = color.toHex();
	
	  if (hsl.s === 0) {
	    hsl.h = oldHue || 0;
	    hsv.h = oldHue || 0;
	  }
	
	  var transparent = hex === '000000' && rgb.a === 0;
	  return {
	    hsl: hsl,
	    hex: transparent ? 'transparent' : "#".concat(hex),
	    rgb: rgb,
	    hsv: hsv,
	    oldHue: data.h || oldHue || hsl.h,
	    source: data.source
	  };
	};
	
	exports.toState = toState;

/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.Context = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _helpers = __webpack_require__(176);
	
	var _hooks = __webpack_require__(110);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var Context = /*#__PURE__*/(0, _react.createContext)();
	exports.Context = Context;
	
	var CheckboxContext = function CheckboxContext(_ref) {
	  var children = _ref.children,
	      onChange = _ref.onChange,
	      onChecked = _ref.onChecked,
	      onCheckedAll = _ref.onCheckedAll;
	
	  var _useState = (0, _react.useState)({}),
	      _useState2 = _slicedToArray(_useState, 2),
	      checkboxList = _useState2[0],
	      setCheckboxList = _useState2[1];
	
	  var checkboxIds = (0, _react.useRef)([]);
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      checkAllValue = _useState4[0],
	      setCheckAll = _useState4[1];
	
	  var _useState5 = (0, _react.useState)([]),
	      _useState6 = _slicedToArray(_useState5, 2),
	      checkedIds = _useState6[0],
	      setCheckedIds = _useState6[1];
	
	  var onNewCheck = function onNewCheck(key, setChecked, id, checked, disabled) {
	    setCheckboxList(function (prevList) {
	      return _objectSpread(_objectSpread({}, prevList), {}, _defineProperty({}, key, {
	        setChecked: setChecked,
	        id: id,
	        checked: checked,
	        disabled: disabled
	      }));
	    });
	
	    if (checked) {
	      if (!checkAllValue) setCheckAll(checked);
	      setCheckedIds(function (prevIds) {
	        if (!prevIds.includes(id)) {
	          return [].concat(_toConsumableArray(prevIds), [id]);
	        }
	
	        return prevIds;
	      });
	    }
	
	    checkboxIds.current.push(id);
	  };
	
	  var onRemoveCheck = function onRemoveCheck(key) {
	    setCheckboxList(function (prevList) {
	      checkboxIds.current = checkboxIds.current.filter(function (i) {
	        return i !== prevList[key].id;
	      });
	      return (0, _helpers.removeFromObject)(prevList, key);
	    });
	  };
	
	  var notifyContext = function notifyContext(id, checked, key) {
	    onChange && onChange({
	      id: id,
	      checked: checked,
	      index: key
	    });
	    setCheckboxList(function (prevList) {
	      var newList = _objectSpread(_objectSpread({}, prevList), {}, _defineProperty({}, key, _objectSpread(_objectSpread({}, prevList[key]), {}, {
	        checked: checked,
	        id: id
	      })));
	
	      var onlyCheckIds = Object.values(newList).filter(function (v) {
	        return v.checked;
	      }).map(function (v) {
	        return v.id;
	      });
	      setCheckAll(onlyCheckIds.length > 0);
	      setCheckedIds(onlyCheckIds);
	      return newList;
	    });
	  };
	
	  var onReorderChecks = function onReorderChecks(id, key) {
	    setCheckboxList(function (prevList) {
	      var checked = checkedIds.includes(id);
	
	      if (prevList[key] && prevList[key].setChecked) {
	        prevList[key].setChecked(checked);
	        return _objectSpread(_objectSpread({}, prevList), {}, _defineProperty({}, key, _objectSpread(_objectSpread({}, prevList[key]), {}, {
	          checked: checked,
	          id: id
	        })));
	      }
	
	      return _objectSpread({}, prevList);
	    });
	  };
	
	  var onCheckAll = function onCheckAll(flag) {
	    var copy = _objectSpread({}, checkboxList);
	
	    var onlyCheckIds = [];
	    setCheckAll(flag);
	    Object.keys(copy).forEach(function (key) {
	      if (!copy[key].disabled) {
	        copy[key].checked = flag;
	        copy[key].setChecked(flag);
	        flag && onlyCheckIds.push(copy[key].id);
	      } else {
	        copy[key].checked && onlyCheckIds.push(copy[key].id);
	      }
	    });
	    setCheckedIds(onlyCheckIds);
	    setCheckboxList(copy);
	    onCheckedAll && onCheckedAll(flag);
	  };
	
	  (0, _react.useEffect)(function () {
	    var onlyChecked = _toConsumableArray(checkedIds);
	
	    if (onlyChecked.length > 0) {
	      var checks = [];
	      Object.keys(checkboxList).forEach(function (key) {
	        checks.push(checkboxList[key].id);
	      });
	      onlyChecked = onlyChecked.filter(function (v) {
	        return checks.includes(v);
	      });
	      setCheckedIds(onlyChecked);
	      setCheckAll(onlyChecked.length > 0);
	    }
	  }, [Object.keys(checkboxList).length]);
	  (0, _hooks.useUpdateEffect)(function () {
	    onChecked && onChecked(checkedIds);
	  }, [checkedIds]);
	
	  var onDisabledCheck = function onDisabledCheck(key, disabled) {
	    if (disabled !== undefined) {
	      setCheckboxList(function (prevList) {
	        return _objectSpread(_objectSpread({}, prevList), {}, _defineProperty({}, key, _objectSpread(_objectSpread({}, prevList[key]), {}, {
	          disabled: disabled
	        })));
	      });
	    }
	  };
	
	  return /*#__PURE__*/_react["default"].createElement(Context.Provider, {
	    value: [onNewCheck, onRemoveCheck, notifyContext, onCheckAll, onReorderChecks, checkAllValue, checkedIds, onDisabledCheck, checkboxIds.current]
	  }, children);
	};
	
	CheckboxContext.propTypes = {
	  onChecked: _propTypes["default"].func,
	  // returns all checked=true items
	  //if onChange or onCheckedAll is define, u need to implement ur own logic. Storie name: custom
	  onChange: _propTypes["default"].func,
	  // return the last item checked true or false.
	  onCheckedAll: _propTypes["default"].func //dispatch when CheckAll component change
	
	};
	CheckboxContext.defaultProps = {
	  onChange: undefined,
	  onChecked: undefined,
	  onCheckedAll: undefined
	};
	var _default = CheckboxContext;
	exports["default"] = _default;

/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.useOpenAndDismiss = void 0;
	
	var _react = __webpack_require__(1);
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var useOpenAndDismiss = function useOpenAndDismiss(onClose, onDismiss, timeout) {
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      isOpen = _useState2[0],
	      setIsOpen = _useState2[1];
	
	  var close = (0, _react.useRef)(onClose);
	  (0, _react.useEffect)(function () {
	    close.current = onClose;
	  }, [onClose]);
	  var dismiss = (0, _react.useRef)(onDismiss);
	  (0, _react.useEffect)(function () {
	    dismiss.current = onDismiss;
	  }, [onDismiss]);
	  (0, _react.useEffect)(function () {
	    setIsOpen(true);
	  }, []);
	  (0, _react.useEffect)(function () {
	    var timer = setTimeout(dismissToast, timeout);
	    return function () {
	      clearTimeout(timer);
	    };
	  }, [timeout]);
	
	  var dismissToast = function dismissToast() {
	    setIsOpen(false);
	    if (close.current) setTimeout(close.current, 350);
	    if (dismiss.current) dismiss.current();
	  };
	
	  return [isOpen, dismissToast];
	};
	
	exports.useOpenAndDismiss = useOpenAndDismiss;

/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.Context = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var Context = /*#__PURE__*/(0, _react.createContext)();
	exports.Context = Context;
	
	var ItemSelectContext = function ItemSelectContext(_ref) {
	  var children = _ref.children,
	      onChange = _ref.onChange,
	      askForConfirmation = _ref.askForConfirmation,
	      beforeChange = _ref.beforeChange,
	      parentRef = _ref.parentRef;
	
	  var _useState = (0, _react.useState)(-1),
	      _useState2 = _slicedToArray(_useState, 2),
	      currentItem = _useState2[0],
	      setCurrentItem = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(-1),
	      _useState4 = _slicedToArray(_useState3, 2),
	      beforeState = _useState4[0],
	      setBeforeState = _useState4[1];
	
	  var _useState5 = (0, _react.useState)({}),
	      _useState6 = _slicedToArray(_useState5, 2),
	      common = _useState6[0],
	      setCommon = _useState6[1];
	
	  (0, _react.useEffect)(function () {
	    onChange(currentItem);
	  }, [currentItem]);
	  (0, _react.useEffect)(function () {
	    if (askForConfirmation && beforeState !== -1) {
	      setTimeout(function () {
	        return beforeChange(beforeState);
	      }, 150); //da tiempo de setear ref
	    }
	  }, [beforeState]);
	  (0, _react.useEffect)(function () {
	    if (parentRef) {
	      parentRef.current = {
	        allowChange: function allowChange() {
	          return setCurrentItem(beforeState);
	        },
	        denyChange: function denyChange() {
	          return setBeforeState(-1);
	        },
	        forceChange: function forceChange(item) {
	          return askForConfirmation ? setBeforeState(item) : setCurrentItem(item);
	        }
	      };
	      return function () {
	        parentRef.current = null;
	      };
	    }
	  });
	  return /*#__PURE__*/_react["default"].createElement(Context.Provider, {
	    value: [currentItem, setCurrentItem, askForConfirmation, setBeforeState, common, setCommon]
	  }, children);
	};
	
	ItemSelectContext.propTypes = {
	  onChange: _propTypes["default"].func.isRequired,
	  askForConfirmation: _propTypes["default"].bool,
	  beforeChange: _propTypes["default"].func,
	  parentRef: _propTypes["default"].any
	};
	ItemSelectContext.defaultProps = {
	  onChange: function onChange() {
	    return console.warn('no function was assigned as prop');
	  },
	  askForConfirmation: false,
	  beforeChange: function beforeChange() {},
	  parentRef: null
	};
	var _default = ItemSelectContext;
	exports["default"] = _default;

/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = __webpack_require__(1);
	
	var _ItemSelectContext = __webpack_require__(425);
	
	var _classNames = _interopRequireDefault(__webpack_require__(61));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var useItemSelect = function useItemSelect(props) {
	  var _useContext = (0, _react.useContext)(_ItemSelectContext.Context),
	      _useContext2 = _slicedToArray(_useContext, 4),
	      currentItem = _useContext2[0],
	      setCurrentItem = _useContext2[1],
	      askForConfirmation = _useContext2[2],
	      setBeforeState = _useContext2[3];
	
	  var _useState = (0, _react.useState)(props.checked),
	      _useState2 = _slicedToArray(_useState, 2),
	      checked = _useState2[0],
	      setChecked = _useState2[1];
	
	  var onClick = function onClick() {
	    if (!props.disabled && !checked) {
	      if (askForConfirmation) {
	        setBeforeState(props.id);
	      } else {
	        setChecked(true);
	      }
	    }
	  }; //para darle estilos a los items
	
	
	  var classes = (0, _classNames["default"])({
	    disabled: props.disabled,
	    active: props.disabled ? false : checked
	  });
	  (0, _react.useEffect)(function () {
	    //cada que el item cambia checar si es el activo
	    if (checked) {
	      currentItem !== props.id && setChecked(false);
	    } else {
	      currentItem === props.id && setChecked(true);
	    }
	  }, [currentItem]);
	  (0, _react.useEffect)(function () {
	    if (checked && currentItem !== props.id) {
	      setCurrentItem(props.id);
	    }
	  }, [checked]);
	  return [onClick, classes];
	};
	
	var _default = useItemSelect;
	exports["default"] = _default;

/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getSizeString = exports.formatTimeShort = exports.formatTime = exports.formatNumberQuantity = exports.formatDatetimeForRequest = exports.formatDateWithHour = exports.formatDateShortTwoDigits = exports.formatDateShort = exports.formatDateLongYear = exports.formatDateForRequest = void 0;
	
	var _dateFns = __webpack_require__(147);
	
	var _es = _interopRequireDefault(__webpack_require__(408));
	
	var _enUS = _interopRequireDefault(__webpack_require__(108));
	
	var _ptBR = _interopRequireDefault(__webpack_require__(657));
	
	var _helpers = __webpack_require__(176);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var locales = {
	  es: _es["default"],
	  en: _enUS["default"],
	  pt: _ptBR["default"]
	};
	var dateFormats = {
	  es: 'd/M/yy',
	  en: 'M/d/yy',
	  pt: 'd/M/yy'
	};
	var dateFormatsTwoDigits = {
	  es: 'dd/MM/yyyy',
	  en: 'MM/dd/yyyy',
	  pt: 'dd/MM/yyyy'
	};
	var dateFormatsWithHour = {
	  es: "dd/MM/yyyy 'a las' HH:mm",
	  en: "MM/dd/yyyy 'at' HH:mm",
	  pt: "dd/MM/yyyy 'às' HH:mm"
	};
	
	var formatTime = function formatTime(time) {
	  if (!isNaN(time)) {
	    var showWith0 = function showWith0(value) {
	      return value < 10 ? '0' + value : value;
	    };
	
	    var hours = Math.floor(time / 3600);
	    var minutes = Math.floor(time / 60 % 60);
	    var seconds = showWith0(Math.floor(time % 60));
	    return (hours > 0 ? hours + ':' + showWith0(minutes) : minutes) + ':' + seconds;
	  } else {
	    return '';
	  }
	};
	
	exports.formatTime = formatTime;
	
	var formatNumberQuantity = function formatNumberQuantity(n) {
	  return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	};
	
	exports.formatNumberQuantity = formatNumberQuantity;
	
	var formatDateShort = function formatDateShort(date) {
	  var lang = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'es';
	  return (0, _helpers.isValidDate)(date) && (0, _dateFns.format)(new Date(date), dateFormats[lang], {
	    locale: locales[lang]
	  });
	};
	
	exports.formatDateShort = formatDateShort;
	
	var formatDateShortTwoDigits = function formatDateShortTwoDigits(date) {
	  var lang = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'es';
	  return (0, _helpers.isValidDate)(date) && (0, _dateFns.format)(new Date(date), dateFormatsTwoDigits[lang], {
	    locale: locales[lang]
	  });
	};
	
	exports.formatDateShortTwoDigits = formatDateShortTwoDigits;
	
	var formatDateLongYear = function formatDateLongYear(date) {
	  var lang = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'es';
	  return (0, _helpers.isValidDate)(date) && (0, _dateFns.format)(new Date(date), 'PPP', {
	    locale: locales[lang]
	  });
	};
	
	exports.formatDateLongYear = formatDateLongYear;
	
	var formatDateForRequest = function formatDateForRequest(date) {
	  return (0, _helpers.isValidDate)(date) && (0, _dateFns.format)(new Date(date), 'yyyy-MM-dd');
	};
	
	exports.formatDateForRequest = formatDateForRequest;
	
	var formatDatetimeForRequest = function formatDatetimeForRequest(date) {
	  return (0, _helpers.isValidDate)(date) && (0, _dateFns.format)(new Date(date), "yyyy-MM-dd'T'HH:mm:ss");
	};
	
	exports.formatDatetimeForRequest = formatDatetimeForRequest;
	
	var formatDateWithHour = function formatDateWithHour(date) {
	  var lang = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'es';
	  return (0, _helpers.isValidDate)(date) && (0, _dateFns.format)(new Date(date), dateFormatsWithHour[lang]);
	};
	
	exports.formatDateWithHour = formatDateWithHour;
	
	var formatTimeShort = function formatTimeShort(date) {
	  return (0, _helpers.isValidDate)(date) && new Date(date).toLocaleTimeString([], {
	    hour: '2-digit',
	    minute: '2-digit',
	    second: '2-digit'
	  });
	};
	
	exports.formatTimeShort = formatTimeShort;
	
	var getSizeString = function getSizeString(sizeInKB) {
	  if (sizeInKB > 1000000) return "".concat((sizeInKB / 1000000).toFixed(2), " GB");
	  if (1000000 > sizeInKB && sizeInKB > 1000) return "".concat((sizeInKB / 1000).toFixed(2), " MB");
	  if (sizeInKB < 1000) return "".concat(sizeInKB.toFixed(2), " KB");
	};
	
	exports.getSizeString = getSizeString;

/***/ },
/* 428 */
[2682, 13],
/* 429 */
[2704, 13],
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $defineProperty = __webpack_require__(419);
	
	var hasPropertyDescriptors = function hasPropertyDescriptors() {
		return !!$defineProperty;
	};
	
	hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
		// node v0.6 has a bug where array lengths can be Set but not Defined
		if (!$defineProperty) {
			return null;
		}
		try {
			return $defineProperty([], 'length', { value: 1 }).length !== 1;
		} catch (e) {
			// In Firefox 4-22, defining length on an array throws an exception.
			return true;
		}
	};
	
	module.exports = hasPropertyDescriptors;


/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var hasSymbols = __webpack_require__(718);
	
	/** @type {import('.')} */
	module.exports = function hasToStringTagShams() {
		return hasSymbols() && !!Symbol.toStringTag;
	};


/***/ },
/* 432 */
/***/ function(module, exports) {

	// Source: http://jsfiddle.net/vWx8V/
	// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes
	
	/**
	 * Conenience method returns corresponding value for given keyName or keyCode.
	 *
	 * @param {Mixed} keyCode {Number} or keyName {String}
	 * @return {Mixed}
	 * @api public
	 */
	
	function keyCode(searchInput) {
	  // Keyboard Events
	  if (searchInput && 'object' === typeof searchInput) {
	    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
	    if (hasKeyCode) searchInput = hasKeyCode
	  }
	
	  // Numbers
	  if ('number' === typeof searchInput) return names[searchInput]
	
	  // Everything else (cast to string)
	  var search = String(searchInput)
	
	  // check codes
	  var foundNamedKey = codes[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // check aliases
	  var foundNamedKey = aliases[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // weird character?
	  if (search.length === 1) return search.charCodeAt(0)
	
	  return undefined
	}
	
	/**
	 * Compares a keyboard event with a given keyCode or keyName.
	 *
	 * @param {Event} event Keyboard event that should be tested
	 * @param {Mixed} keyCode {Number} or keyName {String}
	 * @return {Boolean}
	 * @api public
	 */
	keyCode.isEventKey = function isEventKey(event, nameOrCode) {
	  if (event && 'object' === typeof event) {
	    var keyCode = event.which || event.keyCode || event.charCode
	    if (keyCode === null || keyCode === undefined) { return false; }
	    if (typeof nameOrCode === 'string') {
	      // check codes
	      var foundNamedKey = codes[nameOrCode.toLowerCase()]
	      if (foundNamedKey) { return foundNamedKey === keyCode; }
	    
	      // check aliases
	      var foundNamedKey = aliases[nameOrCode.toLowerCase()]
	      if (foundNamedKey) { return foundNamedKey === keyCode; }
	    } else if (typeof nameOrCode === 'number') {
	      return nameOrCode === keyCode;
	    }
	    return false;
	  }
	}
	
	exports = module.exports = keyCode;
	
	/**
	 * Get by name
	 *
	 *   exports.code['enter'] // => 13
	 */
	
	var codes = exports.code = exports.codes = {
	  'backspace': 8,
	  'tab': 9,
	  'enter': 13,
	  'shift': 16,
	  'ctrl': 17,
	  'alt': 18,
	  'pause/break': 19,
	  'caps lock': 20,
	  'esc': 27,
	  'space': 32,
	  'page up': 33,
	  'page down': 34,
	  'end': 35,
	  'home': 36,
	  'left': 37,
	  'up': 38,
	  'right': 39,
	  'down': 40,
	  'insert': 45,
	  'delete': 46,
	  'command': 91,
	  'left command': 91,
	  'right command': 93,
	  'numpad *': 106,
	  'numpad +': 107,
	  'numpad -': 109,
	  'numpad .': 110,
	  'numpad /': 111,
	  'num lock': 144,
	  'scroll lock': 145,
	  'my computer': 182,
	  'my calculator': 183,
	  ';': 186,
	  '=': 187,
	  ',': 188,
	  '-': 189,
	  '.': 190,
	  '/': 191,
	  '`': 192,
	  '[': 219,
	  '\\': 220,
	  ']': 221,
	  "'": 222
	}
	
	// Helper aliases
	
	var aliases = exports.aliases = {
	  'windows': 91,
	  '⇧': 16,
	  '⌥': 18,
	  '⌃': 17,
	  '⌘': 91,
	  'ctl': 17,
	  'control': 17,
	  'option': 18,
	  'pause': 19,
	  'break': 19,
	  'caps': 20,
	  'return': 13,
	  'escape': 27,
	  'spc': 32,
	  'spacebar': 32,
	  'pgup': 33,
	  'pgdn': 34,
	  'ins': 45,
	  'del': 46,
	  'cmd': 91
	}
	
	/*!
	 * Programatically add the following
	 */
	
	// lower case chars
	for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32
	
	// numbers
	for (var i = 48; i < 58; i++) codes[i - 48] = i
	
	// function keys
	for (i = 1; i < 13; i++) codes['f'+i] = i + 111
	
	// numpad keys
	for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96
	
	/**
	 * Get by code
	 *
	 *   exports.name[13] // => 'Enter'
	 */
	
	var names = exports.names = exports.title = {} // title for backward compat
	
	// Create reverse mapping
	for (i in codes) names[codes[i]] = i
	
	// Add aliases
	for (var alias in aliases) {
	  codes[alias] = aliases[alias]
	}


/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(149),
	    root = __webpack_require__(84);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(2140),
	    mapCacheDelete = __webpack_require__(2141),
	    mapCacheGet = __webpack_require__(2142),
	    mapCacheHas = __webpack_require__(2143),
	    mapCacheSet = __webpack_require__(2144);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(434),
	    setCacheAdd = __webpack_require__(2151),
	    setCacheHas = __webpack_require__(2152);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(279),
	    stackClear = __webpack_require__(2154),
	    stackDelete = __webpack_require__(2155),
	    stackGet = __webpack_require__(2156),
	    stackHas = __webpack_require__(2157),
	    stackSet = __webpack_require__(2158);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ },
/* 437 */
/***/ function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(740);
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ },
/* 439 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(437),
	    isFlattenable = __webpack_require__(2132);
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(2074),
	    isObjectLike = __webpack_require__(85);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ },
/* 441 */
/***/ function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

	var Uint8Array = __webpack_require__(726);
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	module.exports = cloneArrayBuffer;


/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(748);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ },
/* 444 */
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(727),
	    stubArray = __webpack_require__(760);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ },
/* 445 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(43),
	    isSymbol = __webpack_require__(182);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ },
/* 447 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(742);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	    if (types) {
	      return types;
	    }
	
	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(192)(module)))

/***/ },
/* 449 */
/***/ function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(72),
	    now = __webpack_require__(2178),
	    toNumber = __webpack_require__(763);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        timeWaiting = wait - timeSinceLastCall;
	
	    return maxing
	      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	      : timeWaiting;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        clearTimeout(timerId);
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	module.exports = debounce;


/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(2073),
	    isObjectLike = __webpack_require__(85);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(84),
	    stubFalse = __webpack_require__(2181);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(192)(module)))

/***/ },
/* 453 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(730),
	    baseKeysIn = __webpack_require__(2082),
	    isArrayLike = __webpack_require__(150);
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	module.exports = keysIn;


/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(439),
	    baseOrderBy = __webpack_require__(2085),
	    baseRest = __webpack_require__(739),
	    isIterateeCall = __webpack_require__(287);
	
	/**
	 * Creates an array of elements, sorted in ascending order by the results of
	 * running each element in a collection thru each iteratee. This method
	 * performs a stable sort, that is, it preserves the original sort order of
	 * equal elements. The iteratees are invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {...(Function|Function[])} [iteratees=[_.identity]]
	 *  The iteratees to sort by.
	 * @returns {Array} Returns the new sorted array.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'fred',   'age': 48 },
	 *   { 'user': 'barney', 'age': 36 },
	 *   { 'user': 'fred',   'age': 30 },
	 *   { 'user': 'barney', 'age': 34 }
	 * ];
	 *
	 * _.sortBy(users, [function(o) { return o.user; }]);
	 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
	 *
	 * _.sortBy(users, ['user', 'age']);
	 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
	 */
	var sortBy = baseRest(function(collection, iteratees) {
	  if (collection == null) {
	    return [];
	  }
	  var length = iteratees.length;
	  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	    iteratees = [];
	  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	    iteratees = [iteratees[0]];
	  }
	  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	});
	
	module.exports = sortBy;


/***/ },
/* 456 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	exports.__esModule = true;
	var TextareaAutosize_1 = __webpack_require__(2201);
	exports["default"] = TextareaAutosize_1["default"];


/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _style = __webpack_require__(273);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Transition = __webpack_require__(943);
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	var _capitalize = __webpack_require__(931);
	
	var _capitalize2 = _interopRequireDefault(_capitalize);
	
	var _createChainedFunction = __webpack_require__(62);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var MARGINS = {
	  height: ['marginTop', 'marginBottom'],
	  width: ['marginLeft', 'marginRight']
	};
	
	// reading a dimension prop will cause the browser to recalculate,
	// which will let our animations work
	function triggerBrowserReflow(node) {
	  node.offsetHeight; // eslint-disable-line no-unused-expressions
	}
	
	function getDimensionValue(dimension, elem) {
	  var value = elem['offset' + (0, _capitalize2['default'])(dimension)];
	  var margins = MARGINS[dimension];
	
	  return value + parseInt((0, _style2['default'])(elem, margins[0]), 10) + parseInt((0, _style2['default'])(elem, margins[1]), 10);
	}
	
	var propTypes = {
	  /**
	   * Show the component; triggers the expand or collapse animation
	   */
	  'in': _propTypes2['default'].bool,
	
	  /**
	   * Wait until the first "enter" transition to mount the component (add it to the DOM)
	   */
	  mountOnEnter: _propTypes2['default'].bool,
	
	  /**
	   * Unmount the component (remove it from the DOM) when it is collapsed
	   */
	  unmountOnExit: _propTypes2['default'].bool,
	
	  /**
	   * Run the expand animation when the component mounts, if it is initially
	   * shown
	   */
	  transitionAppear: _propTypes2['default'].bool,
	
	  /**
	   * Duration of the collapse animation in milliseconds, to ensure that
	   * finishing callbacks are fired even if the original browser transition end
	   * events are canceled
	   */
	  timeout: _propTypes2['default'].number,
	
	  /**
	   * Callback fired before the component expands
	   */
	  onEnter: _propTypes2['default'].func,
	  /**
	   * Callback fired after the component starts to expand
	   */
	  onEntering: _propTypes2['default'].func,
	  /**
	   * Callback fired after the component has expanded
	   */
	  onEntered: _propTypes2['default'].func,
	  /**
	   * Callback fired before the component collapses
	   */
	  onExit: _propTypes2['default'].func,
	  /**
	   * Callback fired after the component starts to collapse
	   */
	  onExiting: _propTypes2['default'].func,
	  /**
	   * Callback fired after the component has collapsed
	   */
	  onExited: _propTypes2['default'].func,
	
	  /**
	   * The dimension used when collapsing, or a function that returns the
	   * dimension
	   *
	   * _Note: Bootstrap only partially supports 'width'!
	   * You will need to supply your own CSS animation for the `.width` CSS class._
	   */
	  dimension: _propTypes2['default'].oneOfType([_propTypes2['default'].oneOf(['height', 'width']), _propTypes2['default'].func]),
	
	  /**
	   * Function that returns the height or width of the animating DOM node
	   *
	   * Allows for providing some custom logic for how much the Collapse component
	   * should animate in its specified dimension. Called with the current
	   * dimension prop value and the DOM node.
	   */
	  getDimensionValue: _propTypes2['default'].func,
	
	  /**
	   * ARIA role of collapsible element
	   */
	  role: _propTypes2['default'].string
	};
	
	var defaultProps = {
	  'in': false,
	  timeout: 300,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  transitionAppear: false,
	
	  dimension: 'height',
	  getDimensionValue: getDimensionValue
	};
	
	var Collapse = function (_React$Component) {
	  (0, _inherits3['default'])(Collapse, _React$Component);
	
	  function Collapse(props, context) {
	    (0, _classCallCheck3['default'])(this, Collapse);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleEnter = _this.handleEnter.bind(_this);
	    _this.handleEntering = _this.handleEntering.bind(_this);
	    _this.handleEntered = _this.handleEntered.bind(_this);
	    _this.handleExit = _this.handleExit.bind(_this);
	    _this.handleExiting = _this.handleExiting.bind(_this);
	    return _this;
	  }
	
	  /* -- Expanding -- */
	
	
	  Collapse.prototype.handleEnter = function handleEnter(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = '0';
	  };
	
	  Collapse.prototype.handleEntering = function handleEntering(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = this._getScrollDimensionValue(elem, dimension);
	  };
	
	  Collapse.prototype.handleEntered = function handleEntered(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = null;
	  };
	
	  /* -- Collapsing -- */
	
	
	  Collapse.prototype.handleExit = function handleExit(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = this.props.getDimensionValue(dimension, elem) + 'px';
	    triggerBrowserReflow(elem);
	  };
	
	  Collapse.prototype.handleExiting = function handleExiting(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = '0';
	  };
	
	  Collapse.prototype._dimension = function _dimension() {
	    return typeof this.props.dimension === 'function' ? this.props.dimension() : this.props.dimension;
	  };
	
	  // for testing
	
	
	  Collapse.prototype._getScrollDimensionValue = function _getScrollDimensionValue(elem, dimension) {
	    return elem['scroll' + (0, _capitalize2['default'])(dimension)] + 'px';
	  };
	
	  Collapse.prototype.render = function render() {
	    var _props = this.props,
	        onEnter = _props.onEnter,
	        onEntering = _props.onEntering,
	        onEntered = _props.onEntered,
	        onExit = _props.onExit,
	        onExiting = _props.onExiting,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'className']);
	
	
	    delete props.dimension;
	    delete props.getDimensionValue;
	
	    var handleEnter = (0, _createChainedFunction2['default'])(this.handleEnter, onEnter);
	    var handleEntering = (0, _createChainedFunction2['default'])(this.handleEntering, onEntering);
	    var handleEntered = (0, _createChainedFunction2['default'])(this.handleEntered, onEntered);
	    var handleExit = (0, _createChainedFunction2['default'])(this.handleExit, onExit);
	    var handleExiting = (0, _createChainedFunction2['default'])(this.handleExiting, onExiting);
	
	    var classes = {
	      width: this._dimension() === 'width'
	    };
	
	    return _react2['default'].createElement(_Transition2['default'], (0, _extends3['default'])({}, props, {
	      'aria-expanded': props.role ? props['in'] : null,
	      className: (0, _classnames2['default'])(className, classes),
	      exitedClassName: 'collapse',
	      exitingClassName: 'collapsing',
	      enteredClassName: 'collapse in',
	      enteringClassName: 'collapsing',
	      onEnter: handleEnter,
	      onEntering: handleEntering,
	      onEntered: handleEntered,
	      onExit: handleExit,
	      onExiting: handleExiting
	    }));
	  };
	
	  return Collapse;
	}(_react2['default'].Component);
	
	Collapse.propTypes = propTypes;
	Collapse.defaultProps = defaultProps;
	
	exports['default'] = Collapse;
	module.exports = exports['default'];

/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(18);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * An icon name without "glyphicon-" prefix. See e.g. http://getbootstrap.com/components/#glyphicons
	   */
	  glyph: _propTypes2['default'].string.isRequired
	};
	
	var Glyphicon = function (_React$Component) {
	  (0, _inherits3['default'])(Glyphicon, _React$Component);
	
	  function Glyphicon() {
	    (0, _classCallCheck3['default'])(this, Glyphicon);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Glyphicon.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        glyph = _props.glyph,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['glyph', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, glyph)] = true, _extends2));
	
	    return _react2['default'].createElement('span', (0, _extends4['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Glyphicon;
	}(_react2['default'].Component);
	
	Glyphicon.propTypes = propTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('glyphicon', Glyphicon);
	module.exports = exports['default'];

/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(42);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _MediaBody = __webpack_require__(2228);
	
	var _MediaBody2 = _interopRequireDefault(_MediaBody);
	
	var _MediaHeading = __webpack_require__(2229);
	
	var _MediaHeading2 = _interopRequireDefault(_MediaHeading);
	
	var _MediaLeft = __webpack_require__(2230);
	
	var _MediaLeft2 = _interopRequireDefault(_MediaLeft);
	
	var _MediaList = __webpack_require__(2231);
	
	var _MediaList2 = _interopRequireDefault(_MediaList);
	
	var _MediaListItem = __webpack_require__(2232);
	
	var _MediaListItem2 = _interopRequireDefault(_MediaListItem);
	
	var _MediaRight = __webpack_require__(2233);
	
	var _MediaRight2 = _interopRequireDefault(_MediaRight);
	
	var _bootstrapUtils = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Media = function (_React$Component) {
	  (0, _inherits3['default'])(Media, _React$Component);
	
	  function Media() {
	    (0, _classCallCheck3['default'])(this, Media);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Media.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Media;
	}(_react2['default'].Component);
	
	Media.propTypes = propTypes;
	Media.defaultProps = defaultProps;
	
	Media.Heading = _MediaHeading2['default'];
	Media.Body = _MediaBody2['default'];
	Media.Left = _MediaLeft2['default'];
	Media.Right = _MediaRight2['default'];
	Media.List = _MediaList2['default'];
	Media.ListItem = _MediaListItem2['default'];
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('media', Media);
	module.exports = exports['default'];

/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _uncontrollable = __webpack_require__(318);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var TAB = 'tab';
	var PANE = 'pane';
	
	var idPropType = _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number]);
	
	var propTypes = {
	  /**
	   * HTML id attribute, required if no `generateChildId` prop
	   * is specified.
	   */
	  id: function id(props) {
	    var error = null;
	
	    if (!props.generateChildId) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      error = idPropType.apply(undefined, [props].concat(args));
	
	      if (!error && !props.id) {
	        error = new Error('In order to properly initialize Tabs in a way that is accessible ' + 'to assistive technologies (such as screen readers) an `id` or a ' + '`generateChildId` prop to TabContainer is required');
	      }
	    }
	
	    return error;
	  },
	
	
	  /**
	   * A function that takes an `eventKey` and `type` and returns a unique id for
	   * child tab `<NavItem>`s and `<TabPane>`s. The function _must_ be a pure
	   * function, meaning it should always return the _same_ id for the same set
	   * of inputs. The default value requires that an `id` to be set for the
	   * `<TabContainer>`.
	   *
	   * The `type` argument will either be `"tab"` or `"pane"`.
	   *
	   * @defaultValue (eventKey, type) => `${this.props.id}-${type}-${key}`
	   */
	  generateChildId: _propTypes2['default'].func,
	
	  /**
	   * A callback fired when a tab is selected.
	   *
	   * @controllable activeKey
	   */
	  onSelect: _propTypes2['default'].func,
	
	  /**
	   * The `eventKey` of the currently active tab.
	   *
	   * @controllable onSelect
	   */
	  activeKey: _propTypes2['default'].any
	};
	
	var childContextTypes = {
	  $bs_tabContainer: _propTypes2['default'].shape({
	    activeKey: _propTypes2['default'].any,
	    onSelect: _propTypes2['default'].func.isRequired,
	    getTabId: _propTypes2['default'].func.isRequired,
	    getPaneId: _propTypes2['default'].func.isRequired
	  })
	};
	
	var TabContainer = function (_React$Component) {
	  (0, _inherits3['default'])(TabContainer, _React$Component);
	
	  function TabContainer() {
	    (0, _classCallCheck3['default'])(this, TabContainer);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  TabContainer.prototype.getChildContext = function getChildContext() {
	    var _props = this.props,
	        activeKey = _props.activeKey,
	        onSelect = _props.onSelect,
	        generateChildId = _props.generateChildId,
	        id = _props.id;
	
	
	    var getId = generateChildId || function (key, type) {
	      return id ? id + '-' + type + '-' + key : null;
	    };
	
	    return {
	      $bs_tabContainer: {
	        activeKey: activeKey,
	        onSelect: onSelect,
	        getTabId: function getTabId(key) {
	          return getId(key, TAB);
	        },
	        getPaneId: function getPaneId(key) {
	          return getId(key, PANE);
	        }
	      }
	    };
	  };
	
	  TabContainer.prototype.render = function render() {
	    var _props2 = this.props,
	        children = _props2.children,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['children']);
	
	
	    delete props.generateChildId;
	    delete props.onSelect;
	    delete props.activeKey;
	
	    return _react2['default'].cloneElement(_react2['default'].Children.only(children), props);
	  };
	
	  return TabContainer;
	}(_react2['default'].Component);
	
	TabContainer.propTypes = propTypes;
	TabContainer.childContextTypes = childContextTypes;
	
	exports['default'] = (0, _uncontrollable2['default'])(TabContainer, { activeKey: 'onSelect' });
	module.exports = exports['default'];

/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(42);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default'],
	
	  /**
	   * Sets a default animation strategy for all children `<TabPane>`s. Use
	   * `false` to disable, `true` to enable the default `<Fade>` animation or any
	   * `<Transition>` component.
	   */
	  animation: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _elementType2['default']]),
	
	  /**
	   * Wait until the first "enter" transition to mount tabs (add them to the DOM)
	   */
	  mountOnEnter: _propTypes2['default'].bool,
	
	  /**
	   * Unmount tabs (remove it from the DOM) when they are no longer visible
	   */
	  unmountOnExit: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  componentClass: 'div',
	  animation: true,
	  mountOnEnter: false,
	  unmountOnExit: false
	};
	
	var contextTypes = {
	  $bs_tabContainer: _propTypes2['default'].shape({
	    activeKey: _propTypes2['default'].any
	  })
	};
	
	var childContextTypes = {
	  $bs_tabContent: _propTypes2['default'].shape({
	    bsClass: _propTypes2['default'].string,
	    animation: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _elementType2['default']]),
	    activeKey: _propTypes2['default'].any,
	    mountOnEnter: _propTypes2['default'].bool,
	    unmountOnExit: _propTypes2['default'].bool,
	    onPaneEnter: _propTypes2['default'].func.isRequired,
	    onPaneExited: _propTypes2['default'].func.isRequired,
	    exiting: _propTypes2['default'].bool.isRequired
	  })
	};
	
	var TabContent = function (_React$Component) {
	  (0, _inherits3['default'])(TabContent, _React$Component);
	
	  function TabContent(props, context) {
	    (0, _classCallCheck3['default'])(this, TabContent);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handlePaneEnter = _this.handlePaneEnter.bind(_this);
	    _this.handlePaneExited = _this.handlePaneExited.bind(_this);
	
	    // Active entries in state will be `null` unless `animation` is set. Need
	    // to track active child in case keys swap and the active child changes
	    // but the active key does not.
	    _this.state = {
	      activeKey: null,
	      activeChild: null
	    };
	    return _this;
	  }
	
	  TabContent.prototype.getChildContext = function getChildContext() {
	    var _props = this.props,
	        bsClass = _props.bsClass,
	        animation = _props.animation,
	        mountOnEnter = _props.mountOnEnter,
	        unmountOnExit = _props.unmountOnExit;
	
	
	    var stateActiveKey = this.state.activeKey;
	    var containerActiveKey = this.getContainerActiveKey();
	
	    var activeKey = stateActiveKey != null ? stateActiveKey : containerActiveKey;
	    var exiting = stateActiveKey != null && stateActiveKey !== containerActiveKey;
	
	    return {
	      $bs_tabContent: {
	        bsClass: bsClass,
	        animation: animation,
	        activeKey: activeKey,
	        mountOnEnter: mountOnEnter,
	        unmountOnExit: unmountOnExit,
	        onPaneEnter: this.handlePaneEnter,
	        onPaneExited: this.handlePaneExited,
	        exiting: exiting
	      }
	    };
	  };
	
	  TabContent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (!nextProps.animation && this.state.activeChild) {
	      this.setState({ activeKey: null, activeChild: null });
	    }
	  };
	
	  TabContent.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.isUnmounted = true;
	  };
	
	  TabContent.prototype.handlePaneEnter = function handlePaneEnter(child, childKey) {
	    if (!this.props.animation) {
	      return false;
	    }
	
	    // It's possible that this child should be transitioning out.
	    if (childKey !== this.getContainerActiveKey()) {
	      return false;
	    }
	
	    this.setState({
	      activeKey: childKey,
	      activeChild: child
	    });
	
	    return true;
	  };
	
	  TabContent.prototype.handlePaneExited = function handlePaneExited(child) {
	    // This might happen as everything is unmounting.
	    if (this.isUnmounted) {
	      return;
	    }
	
	    this.setState(function (_ref) {
	      var activeChild = _ref.activeChild;
	
	      if (activeChild !== child) {
	        return null;
	      }
	
	      return {
	        activeKey: null,
	        activeChild: null
	      };
	    });
	  };
	
	  TabContent.prototype.getContainerActiveKey = function getContainerActiveKey() {
	    var tabContainer = this.context.$bs_tabContainer;
	    return tabContainer && tabContainer.activeKey;
	  };
	
	  TabContent.prototype.render = function render() {
	    var _props2 = this.props,
	        Component = _props2.componentClass,
	        className = _props2.className,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['componentClass', 'className']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['animation', 'mountOnEnter', 'unmountOnExit']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, (0, _bootstrapUtils.prefix)(bsProps, 'content'))
	    }));
	  };
	
	  return TabContent;
	}(_react2['default'].Component);
	
	TabContent.propTypes = propTypes;
	TabContent.defaultProps = defaultProps;
	TabContent.contextTypes = contextTypes;
	TabContent.childContextTypes = childContextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('tab', TabContent);
	module.exports = exports['default'];

/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.addClassName = addClassName;
	exports.addEvent = addEvent;
	exports.addUserSelectStyles = addUserSelectStyles;
	exports.createCSSTransform = createCSSTransform;
	exports.createSVGTransform = createSVGTransform;
	exports.getTouch = getTouch;
	exports.getTouchIdentifier = getTouchIdentifier;
	exports.getTranslation = getTranslation;
	exports.innerHeight = innerHeight;
	exports.innerWidth = innerWidth;
	exports.matchesSelector = matchesSelector;
	exports.matchesSelectorAndParentsTo = matchesSelectorAndParentsTo;
	exports.offsetXYFromParent = offsetXYFromParent;
	exports.outerHeight = outerHeight;
	exports.outerWidth = outerWidth;
	exports.removeClassName = removeClassName;
	exports.removeEvent = removeEvent;
	exports.removeUserSelectStyles = removeUserSelectStyles;
	
	var _shims = __webpack_require__(299);
	
	var _getPrefix = _interopRequireWildcard(__webpack_require__(2274));
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var matchesSelectorFunc = '';
	
	function matchesSelector(el
	/*: Node*/
	, selector
	/*: string*/
	)
	/*: boolean*/
	{
	  if (!matchesSelectorFunc) {
	    matchesSelectorFunc = (0, _shims.findInArray)(['matches', 'webkitMatchesSelector', 'mozMatchesSelector', 'msMatchesSelector', 'oMatchesSelector'], function (method) {
	      // $FlowIgnore: Doesn't think elements are indexable
	      return (0, _shims.isFunction)(el[method]);
	    });
	  } // Might not be found entirely (not an Element?) - in that case, bail
	  // $FlowIgnore: Doesn't think elements are indexable
	
	
	  if (!(0, _shims.isFunction)(el[matchesSelectorFunc])) return false; // $FlowIgnore: Doesn't think elements are indexable
	
	  return el[matchesSelectorFunc](selector);
	} // Works up the tree to the draggable itself attempting to match selector.
	
	
	function matchesSelectorAndParentsTo(el
	/*: Node*/
	, selector
	/*: string*/
	, baseNode
	/*: Node*/
	)
	/*: boolean*/
	{
	  var node = el;
	
	  do {
	    if (matchesSelector(node, selector)) return true;
	    if (node === baseNode) return false;
	    node = node.parentNode;
	  } while (node);
	
	  return false;
	}
	
	function addEvent(el
	/*: ?Node*/
	, event
	/*: string*/
	, handler
	/*: Function*/
	, inputOptions
	/*: Object*/
	)
	/*: void*/
	{
	  if (!el) return;
	
	  var options = _objectSpread({
	    capture: true
	  }, inputOptions); // $FlowIgnore[method-unbinding]
	
	
	  if (el.addEventListener) {
	    el.addEventListener(event, handler, options);
	  } else if (el.attachEvent) {
	    el.attachEvent('on' + event, handler);
	  } else {
	    // $FlowIgnore: Doesn't think elements are indexable
	    el['on' + event] = handler;
	  }
	}
	
	function removeEvent(el
	/*: ?Node*/
	, event
	/*: string*/
	, handler
	/*: Function*/
	, inputOptions
	/*: Object*/
	)
	/*: void*/
	{
	  if (!el) return;
	
	  var options = _objectSpread({
	    capture: true
	  }, inputOptions); // $FlowIgnore[method-unbinding]
	
	
	  if (el.removeEventListener) {
	    el.removeEventListener(event, handler, options);
	  } else if (el.detachEvent) {
	    el.detachEvent('on' + event, handler);
	  } else {
	    // $FlowIgnore: Doesn't think elements are indexable
	    el['on' + event] = null;
	  }
	}
	
	function outerHeight(node
	/*: HTMLElement*/
	)
	/*: number*/
	{
	  // This is deliberately excluding margin for our calculations, since we are using
	  // offsetTop which is including margin. See getBoundPosition
	  var height = node.clientHeight;
	  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
	  height += (0, _shims.int)(computedStyle.borderTopWidth);
	  height += (0, _shims.int)(computedStyle.borderBottomWidth);
	  return height;
	}
	
	function outerWidth(node
	/*: HTMLElement*/
	)
	/*: number*/
	{
	  // This is deliberately excluding margin for our calculations, since we are using
	  // offsetLeft which is including margin. See getBoundPosition
	  var width = node.clientWidth;
	  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
	  width += (0, _shims.int)(computedStyle.borderLeftWidth);
	  width += (0, _shims.int)(computedStyle.borderRightWidth);
	  return width;
	}
	
	function innerHeight(node
	/*: HTMLElement*/
	)
	/*: number*/
	{
	  var height = node.clientHeight;
	  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
	  height -= (0, _shims.int)(computedStyle.paddingTop);
	  height -= (0, _shims.int)(computedStyle.paddingBottom);
	  return height;
	}
	
	function innerWidth(node
	/*: HTMLElement*/
	)
	/*: number*/
	{
	  var width = node.clientWidth;
	  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
	  width -= (0, _shims.int)(computedStyle.paddingLeft);
	  width -= (0, _shims.int)(computedStyle.paddingRight);
	  return width;
	}
	/*:: interface EventWithOffset {
	  clientX: number, clientY: number
	}*/
	
	
	// Get from offsetParent
	function offsetXYFromParent(evt
	/*: EventWithOffset*/
	, offsetParent
	/*: HTMLElement*/
	, scale
	/*: number*/
	)
	/*: ControlPosition*/
	{
	  var isBody = offsetParent === offsetParent.ownerDocument.body;
	  var offsetParentRect = isBody ? {
	    left: 0,
	    top: 0
	  } : offsetParent.getBoundingClientRect();
	  var x = (evt.clientX + offsetParent.scrollLeft - offsetParentRect.left) / scale;
	  var y = (evt.clientY + offsetParent.scrollTop - offsetParentRect.top) / scale;
	  return {
	    x: x,
	    y: y
	  };
	}
	
	function createCSSTransform(controlPos
	/*: ControlPosition*/
	, positionOffset
	/*: PositionOffsetControlPosition*/
	)
	/*: Object*/
	{
	  var translation = getTranslation(controlPos, positionOffset, 'px');
	  return _defineProperty({}, (0, _getPrefix.browserPrefixToKey)('transform', _getPrefix.default), translation);
	}
	
	function createSVGTransform(controlPos
	/*: ControlPosition*/
	, positionOffset
	/*: PositionOffsetControlPosition*/
	)
	/*: string*/
	{
	  var translation = getTranslation(controlPos, positionOffset, '');
	  return translation;
	}
	
	function getTranslation(_ref2, positionOffset
	/*: PositionOffsetControlPosition*/
	, unitSuffix
	/*: string*/
	)
	/*: string*/
	{
	  var x = _ref2.x,
	      y = _ref2.y;
	  var translation = "translate(".concat(x).concat(unitSuffix, ",").concat(y).concat(unitSuffix, ")");
	
	  if (positionOffset) {
	    var defaultX = "".concat(typeof positionOffset.x === 'string' ? positionOffset.x : positionOffset.x + unitSuffix);
	    var defaultY = "".concat(typeof positionOffset.y === 'string' ? positionOffset.y : positionOffset.y + unitSuffix);
	    translation = "translate(".concat(defaultX, ", ").concat(defaultY, ")") + translation;
	  }
	
	  return translation;
	}
	
	function getTouch(e
	/*: MouseTouchEvent*/
	, identifier
	/*: number*/
	)
	/*: ?{clientX: number, clientY: number}*/
	{
	  return e.targetTouches && (0, _shims.findInArray)(e.targetTouches, function (t) {
	    return identifier === t.identifier;
	  }) || e.changedTouches && (0, _shims.findInArray)(e.changedTouches, function (t) {
	    return identifier === t.identifier;
	  });
	}
	
	function getTouchIdentifier(e
	/*: MouseTouchEvent*/
	)
	/*: ?number*/
	{
	  if (e.targetTouches && e.targetTouches[0]) return e.targetTouches[0].identifier;
	  if (e.changedTouches && e.changedTouches[0]) return e.changedTouches[0].identifier;
	} // User-select Hacks:
	//
	// Useful for preventing blue highlights all over everything when dragging.
	// Note we're passing `document` b/c we could be iframed
	
	
	function addUserSelectStyles(doc
	/*: ?Document*/
	) {
	  if (!doc) return;
	  var styleEl = doc.getElementById('react-draggable-style-el');
	
	  if (!styleEl) {
	    styleEl = doc.createElement('style');
	    styleEl.type = 'text/css';
	    styleEl.id = 'react-draggable-style-el';
	    styleEl.innerHTML = '.react-draggable-transparent-selection *::-moz-selection {all: inherit;}\n';
	    styleEl.innerHTML += '.react-draggable-transparent-selection *::selection {all: inherit;}\n';
	    doc.getElementsByTagName('head')[0].appendChild(styleEl);
	  }
	
	  if (doc.body) addClassName(doc.body, 'react-draggable-transparent-selection');
	}
	
	function removeUserSelectStyles(doc
	/*: ?Document*/
	) {
	  if (!doc) return;
	
	  try {
	    if (doc.body) removeClassName(doc.body, 'react-draggable-transparent-selection'); // $FlowIgnore: IE
	
	    if (doc.selection) {
	      // $FlowIgnore: IE
	      doc.selection.empty();
	    } else {
	      // Remove selection caused by scroll, unless it's a focused input
	      // (we use doc.defaultView in case we're in an iframe)
	      var selection = (doc.defaultView || window).getSelection();
	
	      if (selection && selection.type !== 'Caret') {
	        selection.removeAllRanges();
	      }
	    }
	  } catch (e) {// probably IE
	  }
	}
	
	function addClassName(el
	/*: HTMLElement*/
	, className
	/*: string*/
	) {
	  if (el.classList) {
	    el.classList.add(className);
	  } else {
	    if (!el.className.match(new RegExp("(?:^|\\s)".concat(className, "(?!\\S)")))) {
	      el.className += " ".concat(className);
	    }
	  }
	}
	
	function removeClassName(el
	/*: HTMLElement*/
	, className
	/*: string*/
	) {
	  if (el.classList) {
	    el.classList.remove(className);
	  } else {
	    el.className = el.className.replace(new RegExp("(?:^|\\s)".concat(className, "(?!\\S)"), 'g'), '');
	  }
	}

/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.useTranslation = useTranslation;
	
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(320));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(27));
	
	var _react = __webpack_require__(1);
	
	var _context = __webpack_require__(184);
	
	var _utils = __webpack_require__(300);
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function useTranslation(ns) {
	  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var i18nFromProps = props.i18n;
	
	  var _ref = (0, _react.useContext)(_context.I18nContext) || {},
	      i18nFromContext = _ref.i18n,
	      defaultNSFromContext = _ref.defaultNS;
	
	  var i18n = i18nFromProps || i18nFromContext || (0, _context.getI18n)();
	  if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new _context.ReportNamespaces();
	
	  if (!i18n) {
	    (0, _utils.warnOnce)('You will need to pass in an i18next instance by using initReactI18next');
	
	    var notReadyT = function notReadyT(k) {
	      return Array.isArray(k) ? k[k.length - 1] : k;
	    };
	
	    var retNotReady = [notReadyT, {}, false];
	    retNotReady.t = notReadyT;
	    retNotReady.i18n = {};
	    retNotReady.ready = false;
	    return retNotReady;
	  }
	
	  if (i18n.options.react && i18n.options.react.wait !== undefined) (0, _utils.warnOnce)('It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.');
	
	  var i18nOptions = _objectSpread(_objectSpread(_objectSpread({}, (0, _context.getDefaults)()), i18n.options.react), props);
	
	  var useSuspense = i18nOptions.useSuspense,
	      keyPrefix = i18nOptions.keyPrefix;
	  var namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
	  namespaces = typeof namespaces === 'string' ? [namespaces] : namespaces || ['translation'];
	  if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
	  var ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every(function (n) {
	    return (0, _utils.hasLoadedNamespace)(n, i18n, i18nOptions);
	  });
	
	  function getT() {
	    return i18n.getFixedT(null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
	  }
	
	  var _useState = (0, _react.useState)(getT),
	      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
	      t = _useState2[0],
	      setT = _useState2[1];
	
	  var isMounted = (0, _react.useRef)(true);
	  (0, _react.useEffect)(function () {
	    var bindI18n = i18nOptions.bindI18n,
	        bindI18nStore = i18nOptions.bindI18nStore;
	    isMounted.current = true;
	
	    if (!ready && !useSuspense) {
	      (0, _utils.loadNamespaces)(i18n, namespaces, function () {
	        if (isMounted.current) setT(getT);
	      });
	    }
	
	    function boundReset() {
	      if (isMounted.current) setT(getT);
	    }
	
	    if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
	    if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
	    return function () {
	      isMounted.current = false;
	      if (bindI18n && i18n) bindI18n.split(' ').forEach(function (e) {
	        return i18n.off(e, boundReset);
	      });
	      if (bindI18nStore && i18n) bindI18nStore.split(' ').forEach(function (e) {
	        return i18n.store.off(e, boundReset);
	      });
	    };
	  }, [i18n, namespaces.join()]);
	  var isInitial = (0, _react.useRef)(true);
	  (0, _react.useEffect)(function () {
	    if (isMounted.current && !isInitial.current) {
	      setT(getT);
	    }
	
	    isInitial.current = false;
	  }, [i18n]);
	  var ret = [t, i18n, ready];
	  ret.t = t;
	  ret.i18n = i18n;
	  ret.ready = ready;
	  if (ready) return ret;
	  if (!ready && !useSuspense) return ret;
	  throw new Promise(function (resolve) {
	    (0, _utils.loadNamespaces)(i18n, namespaces, function () {
	      resolve();
	    });
	  });
	}

/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.canUseDOM = exports.SafeNodeList = exports.SafeHTMLCollection = undefined;
	
	var _exenv = __webpack_require__(1724);
	
	var _exenv2 = _interopRequireDefault(_exenv);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EE = _exenv2.default;
	
	var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};
	
	var SafeHTMLCollection = exports.SafeHTMLCollection = EE.canUseDOM ? window.HTMLCollection : {};
	
	var SafeNodeList = exports.SafeNodeList = EE.canUseDOM ? window.NodeList : {};
	
	var canUseDOM = exports.canUseDOM = EE.canUseDOM;
	
	exports.default = SafeHTMLElement;

/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(154);
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.ManagerReferenceNodeSetterContext = exports.ManagerReferenceNodeContext = void 0;
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(20));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(27));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _createReactContext = _interopRequireDefault(__webpack_require__(1056));
	
	var ManagerReferenceNodeContext = (0, _createReactContext.default)();
	exports.ManagerReferenceNodeContext = ManagerReferenceNodeContext;
	var ManagerReferenceNodeSetterContext = (0, _createReactContext.default)();
	exports.ManagerReferenceNodeSetterContext = ManagerReferenceNodeSetterContext;
	
	var Manager =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Manager, _React$Component);
	
	  function Manager() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "referenceNode", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "setReferenceNode", function (newReferenceNode) {
	      if (newReferenceNode && _this.referenceNode !== newReferenceNode) {
	        _this.referenceNode = newReferenceNode;
	
	        _this.forceUpdate();
	      }
	    });
	    return _this;
	  }
	
	  var _proto = Manager.prototype;
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.referenceNode = null;
	  };
	
	  _proto.render = function render() {
	    return React.createElement(ManagerReferenceNodeContext.Provider, {
	      value: this.referenceNode
	    }, React.createElement(ManagerReferenceNodeSetterContext.Provider, {
	      value: this.setReferenceNode
	    }, this.props.children));
	  };
	
	  return Manager;
	}(React.Component);
	
	exports.default = Manager;

/***/ },
/* 467 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createChainableTypeChecker;
	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	// Mostly taken from ReactPropTypes.
	
	function createChainableTypeChecker(validate) {
	  function checkType(isRequired, props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] == null) {
	      if (isRequired) {
	        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
	      }
	
	      return null;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
	      args[_key - 6] = arguments[_key];
	    }
	
	    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}

/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.createSubscription = createSubscription;
	
	var _batch = __webpack_require__(951);
	
	// encapsulates the subscription logic for connecting a component to the redux store, as
	// well as nesting subscriptions of descendant components, so that we can ensure the
	// ancestor components re-render before descendants
	function createListenerCollection() {
	  var batch = (0, _batch.getBatch)();
	  var first = null;
	  var last = null;
	  return {
	    clear: function clear() {
	      first = null;
	      last = null;
	    },
	    notify: function notify() {
	      batch(function () {
	        var listener = first;
	
	        while (listener) {
	          listener.callback();
	          listener = listener.next;
	        }
	      });
	    },
	    get: function get() {
	      var listeners = [];
	      var listener = first;
	
	      while (listener) {
	        listeners.push(listener);
	        listener = listener.next;
	      }
	
	      return listeners;
	    },
	    subscribe: function subscribe(callback) {
	      var isSubscribed = true;
	      var listener = last = {
	        callback: callback,
	        next: null,
	        prev: last
	      };
	
	      if (listener.prev) {
	        listener.prev.next = listener;
	      } else {
	        first = listener;
	      }
	
	      return function unsubscribe() {
	        if (!isSubscribed || first === null) return;
	        isSubscribed = false;
	
	        if (listener.next) {
	          listener.next.prev = listener.prev;
	        } else {
	          last = listener.prev;
	        }
	
	        if (listener.prev) {
	          listener.prev.next = listener.next;
	        } else {
	          first = listener.next;
	        }
	      };
	    }
	  };
	}
	
	var nullListeners = {
	  notify: function notify() {},
	  get: function get() {
	    return [];
	  }
	};
	
	function createSubscription(store, parentSub) {
	  var unsubscribe;
	  var listeners = nullListeners;
	
	  function addNestedSub(listener) {
	    trySubscribe();
	    return listeners.subscribe(listener);
	  }
	
	  function notifyNestedSubs() {
	    listeners.notify();
	  }
	
	  function handleChangeWrapper() {
	    if (subscription.onStateChange) {
	      subscription.onStateChange();
	    }
	  }
	
	  function isSubscribed() {
	    return Boolean(unsubscribe);
	  }
	
	  function trySubscribe() {
	    if (!unsubscribe) {
	      unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
	      listeners = createListenerCollection();
	    }
	  }
	
	  function tryUnsubscribe() {
	    if (unsubscribe) {
	      unsubscribe();
	      unsubscribe = undefined;
	      listeners.clear();
	      listeners = nullListeners;
	    }
	  }
	
	  var subscription = {
	    addNestedSub: addNestedSub,
	    notifyNestedSubs: notifyNestedSubs,
	    handleChangeWrapper: handleChangeWrapper,
	    isSubscribed: isSubscribed,
	    trySubscribe: trySubscribe,
	    tryUnsubscribe: tryUnsubscribe,
	    getListeners: function getListeners() {
	      return listeners;
	    }
	  };
	  return subscription;
	}

/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.useIsomorphicLayoutEffect = void 0;
	
	var _react = __webpack_require__(1);
	
	// React currently throws a warning when using useLayoutEffect on the server.
	// To get around it, we can conditionally useEffect on the server (no-op) and
	// useLayoutEffect in the browser. We need useLayoutEffect to ensure the store
	// subscription callback always has the selector from the latest render commit
	// available, otherwise a store update may happen between render and the effect,
	// which may cause missed updates; we also must ensure the store subscription
	// is created synchronously, otherwise a store update may occur before the
	// subscription is created and an inconsistent state may be observed
	var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? _react.useLayoutEffect : _react.useEffect;
	exports.useIsomorphicLayoutEffect = useIsomorphicLayoutEffect;

/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(20));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(14);
	
	var _excluded = ["active", "aria-label", "block", "className", "close", "cssModule", "color", "outline", "size", "tag", "innerRef"];
	var propTypes = {
	  active: _propTypes.default.bool,
	  'aria-label': _propTypes.default.string,
	  block: _propTypes.default.bool,
	  color: _propTypes.default.string,
	  disabled: _propTypes.default.bool,
	  outline: _propTypes.default.bool,
	  tag: _utils.tagPropType,
	  innerRef: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func, _propTypes.default.string]),
	  onClick: _propTypes.default.func,
	  size: _propTypes.default.string,
	  children: _propTypes.default.node,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  close: _propTypes.default.bool
	};
	var defaultProps = {
	  color: 'secondary',
	  tag: 'button'
	};
	
	var Button = /*#__PURE__*/function (_React$Component) {
	  (0, _inheritsLoose2.default)(Button, _React$Component);
	
	  function Button(props) {
	    var _this;
	
	    _this = _React$Component.call(this, props) || this;
	    _this.onClick = _this.onClick.bind((0, _assertThisInitialized2.default)(_this));
	    return _this;
	  }
	
	  var _proto = Button.prototype;
	
	  _proto.onClick = function onClick(e) {
	    if (this.props.disabled) {
	      e.preventDefault();
	      return;
	    }
	
	    if (this.props.onClick) {
	      return this.props.onClick(e);
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        active = _this$props.active,
	        ariaLabel = _this$props['aria-label'],
	        block = _this$props.block,
	        className = _this$props.className,
	        close = _this$props.close,
	        cssModule = _this$props.cssModule,
	        color = _this$props.color,
	        outline = _this$props.outline,
	        size = _this$props.size,
	        Tag = _this$props.tag,
	        innerRef = _this$props.innerRef,
	        attributes = (0, _objectWithoutPropertiesLoose2.default)(_this$props, _excluded);
	
	    if (close && typeof attributes.children === 'undefined') {
	      attributes.children = /*#__PURE__*/_react.default.createElement("span", {
	        "aria-hidden": true
	      }, "\xD7");
	    }
	
	    var btnOutlineColor = "btn" + (outline ? '-outline' : '') + "-" + color;
	    var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, {
	      close: close
	    }, close || 'btn', close || btnOutlineColor, size ? "btn-" + size : false, block ? 'btn-block' : false, {
	      active: active,
	      disabled: this.props.disabled
	    }), cssModule);
	
	    if (attributes.href && Tag === 'button') {
	      Tag = 'a';
	    }
	
	    var defaultAriaLabel = close ? 'Close' : null;
	    return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({
	      type: Tag === 'button' && attributes.onClick ? 'button' : undefined
	    }, attributes, {
	      className: classes,
	      ref: innerRef,
	      onClick: this.onClick,
	      "aria-label": ariaLabel || defaultAriaLabel
	    }));
	  };
	
	  return Button;
	}(_react.default.Component);
	
	Button.propTypes = propTypes;
	Button.defaultProps = defaultProps;
	var _default = Button;
	exports.default = _default;

/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(27));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(20));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _reactTransitionGroup = __webpack_require__(472);
	
	var _utils = __webpack_require__(14);
	
	var _excluded = ["in", "children", "cssModule", "slide", "tag", "className"];
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	var CarouselItem = /*#__PURE__*/function (_React$Component) {
	  (0, _inheritsLoose2.default)(CarouselItem, _React$Component);
	
	  function CarouselItem(props) {
	    var _this;
	
	    _this = _React$Component.call(this, props) || this;
	    _this.state = {
	      startAnimation: false
	    };
	    _this.onEnter = _this.onEnter.bind((0, _assertThisInitialized2.default)(_this));
	    _this.onEntering = _this.onEntering.bind((0, _assertThisInitialized2.default)(_this));
	    _this.onExit = _this.onExit.bind((0, _assertThisInitialized2.default)(_this));
	    _this.onExiting = _this.onExiting.bind((0, _assertThisInitialized2.default)(_this));
	    _this.onExited = _this.onExited.bind((0, _assertThisInitialized2.default)(_this));
	    return _this;
	  }
	
	  var _proto = CarouselItem.prototype;
	
	  _proto.onEnter = function onEnter(node, isAppearing) {
	    this.setState({
	      startAnimation: false
	    });
	    this.props.onEnter(node, isAppearing);
	  };
	
	  _proto.onEntering = function onEntering(node, isAppearing) {
	    // getting this variable triggers a reflow
	    var offsetHeight = node.offsetHeight;
	    this.setState({
	      startAnimation: true
	    });
	    this.props.onEntering(node, isAppearing);
	    return offsetHeight;
	  };
	
	  _proto.onExit = function onExit(node) {
	    this.setState({
	      startAnimation: false
	    });
	    this.props.onExit(node);
	  };
	
	  _proto.onExiting = function onExiting(node) {
	    this.setState({
	      startAnimation: true
	    });
	    node.dispatchEvent(new CustomEvent('slide.bs.carousel'));
	    this.props.onExiting(node);
	  };
	
	  _proto.onExited = function onExited(node) {
	    node.dispatchEvent(new CustomEvent('slid.bs.carousel'));
	    this.props.onExited(node);
	  };
	
	  _proto.render = function render() {
	    var _this2 = this;
	
	    var _this$props = this.props,
	        isIn = _this$props.in,
	        children = _this$props.children,
	        cssModule = _this$props.cssModule,
	        slide = _this$props.slide,
	        Tag = _this$props.tag,
	        className = _this$props.className,
	        transitionProps = (0, _objectWithoutPropertiesLoose2.default)(_this$props, _excluded);
	    return /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.Transition, (0, _extends2.default)({}, transitionProps, {
	      enter: slide,
	      exit: slide,
	      in: isIn,
	      onEnter: this.onEnter,
	      onEntering: this.onEntering,
	      onExit: this.onExit,
	      onExiting: this.onExiting,
	      onExited: this.onExited
	    }), function (status) {
	      var direction = _this2.context.direction;
	      var isActive = status === _utils.TransitionStatuses.ENTERED || status === _utils.TransitionStatuses.EXITING;
	      var directionClassName = (status === _utils.TransitionStatuses.ENTERING || status === _utils.TransitionStatuses.EXITING) && _this2.state.startAnimation && (direction === 'right' ? 'carousel-item-left' : 'carousel-item-right');
	      var orderClassName = status === _utils.TransitionStatuses.ENTERING && (direction === 'right' ? 'carousel-item-next' : 'carousel-item-prev');
	      var itemClasses = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'carousel-item', isActive && 'active', directionClassName, orderClassName), cssModule);
	      return /*#__PURE__*/_react.default.createElement(Tag, {
	        className: itemClasses
	      }, children);
	    });
	  };
	
	  return CarouselItem;
	}(_react.default.Component);
	
	CarouselItem.propTypes = _objectSpread(_objectSpread({}, _reactTransitionGroup.Transition.propTypes), {}, {
	  tag: _utils.tagPropType,
	  in: _propTypes.default.bool,
	  cssModule: _propTypes.default.object,
	  children: _propTypes.default.node,
	  slide: _propTypes.default.bool,
	  className: _propTypes.default.string
	});
	CarouselItem.defaultProps = _objectSpread(_objectSpread({}, _reactTransitionGroup.Transition.defaultProps), {}, {
	  tag: 'div',
	  timeout: _utils.TransitionTimeouts.Carousel,
	  slide: true
	});
	CarouselItem.contextTypes = {
	  direction: _propTypes.default.string
	};
	var _default = CarouselItem;
	exports.default = _default;

/***/ },
/* 472 */
[2774, 2408, 2409, 978, 977],
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isEqual2 = _interopRequireDefault(__webpack_require__(98));
	
	var _isNaN2 = _interopRequireDefault(__webpack_require__(290));
	
	var _max2 = _interopRequireDefault(__webpack_require__(755));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(38));
	
	var _get2 = _interopRequireDefault(__webpack_require__(180));
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(71));
	
	var _isArray2 = _interopRequireDefault(__webpack_require__(43));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _reactSmooth = _interopRequireDefault(__webpack_require__(81));
	
	var _Curve = _interopRequireDefault(__webpack_require__(189));
	
	var _Dot = _interopRequireDefault(__webpack_require__(153));
	
	var _Layer = _interopRequireDefault(__webpack_require__(49));
	
	var _LabelList = _interopRequireDefault(__webpack_require__(113));
	
	var _ReactUtils = __webpack_require__(29);
	
	var _DataUtils = __webpack_require__(39);
	
	var _ChartUtils = __webpack_require__(66);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var Area =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Area, _PureComponent);
	
	  function Area() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Area);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Area)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      isAnimationFinished: true
	    };
	    _this.id = (0, _DataUtils.uniqueId)('recharts-area-');
	
	    _this.cachePrevData = function (points, baseLine) {
	      _this.setState({
	        prevPoints: points,
	        prevBaseLine: baseLine
	      });
	    };
	
	    _this.handleAnimationEnd = function () {
	      var onAnimationEnd = _this.props.onAnimationEnd;
	
	      _this.setState({
	        isAnimationFinished: true
	      });
	
	      if ((0, _isFunction2["default"])(onAnimationEnd)) {
	        onAnimationEnd();
	      }
	    };
	
	    _this.handleAnimationStart = function () {
	      var onAnimationStart = _this.props.onAnimationStart;
	
	      _this.setState({
	        isAnimationFinished: false
	      });
	
	      if ((0, _isFunction2["default"])(onAnimationStart)) {
	        onAnimationStart();
	      }
	    };
	
	    return _this;
	  }
	
	  _createClass(Area, [{
	    key: "componentWillReceiveProps",
	    // eslint-disable-next-line camelcase
	    value: function componentWillReceiveProps(nextProps) {
	      var _this$props = this.props,
	          animationId = _this$props.animationId,
	          points = _this$props.points,
	          baseLine = _this$props.baseLine;
	
	      if (nextProps.animationId !== animationId) {
	        this.cachePrevData(points, baseLine);
	      }
	    }
	  }, {
	    key: "renderDots",
	    value: function renderDots(needClip, clipPathId) {
	      var _this2 = this;
	
	      var isAnimationActive = this.props.isAnimationActive;
	      var isAnimationFinished = this.state.isAnimationFinished;
	
	      if (isAnimationActive && !isAnimationFinished) {
	        return null;
	      }
	
	      var _this$props2 = this.props,
	          dot = _this$props2.dot,
	          points = _this$props2.points,
	          dataKey = _this$props2.dataKey;
	      var areaProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customDotProps = (0, _ReactUtils.getPresentationAttributes)(dot);
	      var dotEvents = (0, _ReactUtils.filterEventAttributes)(dot);
	      var dots = points.map(function (entry, i) {
	        var dotProps = _objectSpread({
	          key: "dot-".concat(i),
	          r: 3
	        }, areaProps, {}, customDotProps, {}, dotEvents, {
	          dataKey: dataKey,
	          cx: entry.x,
	          cy: entry.y,
	          index: i,
	          value: entry.value,
	          payload: entry.payload
	        });
	
	        return _this2.constructor.renderDotItem(dot, dotProps);
	      });
	      var dotsProps = {
	        clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
	      };
	      return _react["default"].createElement(_Layer["default"], _extends({
	        className: "recharts-area-dots"
	      }, dotsProps), dots);
	    }
	  }, {
	    key: "renderHorizontalRect",
	    value: function renderHorizontalRect(alpha) {
	      var _this$props3 = this.props,
	          baseLine = _this$props3.baseLine,
	          points = _this$props3.points,
	          strokeWidth = _this$props3.strokeWidth;
	      var startX = points[0].x;
	      var endX = points[points.length - 1].x;
	      var width = alpha * Math.abs(startX - endX);
	      var maxY = (0, _max2["default"])(points.map(function (entry) {
	        return entry.y || 0;
	      }));
	
	      if ((0, _DataUtils.isNumber)(baseLine)) {
	        maxY = Math.max(baseLine, maxY);
	      } else if (baseLine && (0, _isArray2["default"])(baseLine) && baseLine.length) {
	        maxY = Math.max((0, _max2["default"])(baseLine.map(function (entry) {
	          return entry.y || 0;
	        })), maxY);
	      }
	
	      if ((0, _DataUtils.isNumber)(maxY)) {
	        return _react["default"].createElement("rect", {
	          x: startX < endX ? startX : startX - width,
	          y: 0,
	          width: width,
	          height: parseInt(maxY + (strokeWidth || 1), 10)
	        });
	      }
	
	      return null;
	    }
	  }, {
	    key: "renderVerticalRect",
	    value: function renderVerticalRect(alpha) {
	      var _this$props4 = this.props,
	          baseLine = _this$props4.baseLine,
	          points = _this$props4.points,
	          strokeWidth = _this$props4.strokeWidth;
	      var startY = points[0].y;
	      var endY = points[points.length - 1].y;
	      var height = alpha * Math.abs(startY - endY);
	      var maxX = (0, _max2["default"])(points.map(function (entry) {
	        return entry.x || 0;
	      }));
	
	      if ((0, _DataUtils.isNumber)(baseLine)) {
	        maxX = Math.max(baseLine, maxX);
	      } else if (baseLine && (0, _isArray2["default"])(baseLine) && baseLine.length) {
	        maxX = Math.max((0, _max2["default"])(baseLine.map(function (entry) {
	          return entry.x || 0;
	        })), maxX);
	      }
	
	      if ((0, _DataUtils.isNumber)(maxX)) {
	        return _react["default"].createElement("rect", {
	          x: 0,
	          y: startY < endY ? startY : startY - height,
	          width: maxX + (strokeWidth || 1),
	          height: parseInt(height, 10)
	        });
	      }
	
	      return null;
	    }
	  }, {
	    key: "renderClipRect",
	    value: function renderClipRect(alpha) {
	      var layout = this.props.layout;
	
	      if (layout === 'vertical') {
	        return this.renderVerticalRect(alpha);
	      }
	
	      return this.renderHorizontalRect(alpha);
	    }
	  }, {
	    key: "renderAreaStatically",
	    value: function renderAreaStatically(points, baseLine, needClip, clipPathId) {
	      var _this$props5 = this.props,
	          layout = _this$props5.layout,
	          type = _this$props5.type,
	          stroke = _this$props5.stroke,
	          connectNulls = _this$props5.connectNulls,
	          isRange = _this$props5.isRange;
	      return _react["default"].createElement(_Layer["default"], {
	        clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
	      }, _react["default"].createElement(_Curve["default"], _extends({}, this.props, {
	        points: points,
	        baseLine: baseLine,
	        stroke: "none",
	        className: "recharts-area-area"
	      })), stroke !== 'none' && _react["default"].createElement(_Curve["default"], _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	        className: "recharts-area-curve",
	        layout: layout,
	        type: type,
	        connectNulls: connectNulls,
	        fill: "none",
	        points: points
	      })), stroke !== 'none' && isRange && _react["default"].createElement(_Curve["default"], _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	        className: "recharts-area-curve",
	        layout: layout,
	        type: type,
	        connectNulls: connectNulls,
	        fill: "none",
	        points: baseLine
	      })));
	    }
	  }, {
	    key: "renderAreaWithAnimation",
	    value: function renderAreaWithAnimation(needClip, clipPathId) {
	      var _this3 = this;
	
	      var _this$props6 = this.props,
	          points = _this$props6.points,
	          baseLine = _this$props6.baseLine,
	          isAnimationActive = _this$props6.isAnimationActive,
	          animationBegin = _this$props6.animationBegin,
	          animationDuration = _this$props6.animationDuration,
	          animationEasing = _this$props6.animationEasing,
	          animationId = _this$props6.animationId;
	      var _this$state = this.state,
	          prevPoints = _this$state.prevPoints,
	          prevBaseLine = _this$state.prevBaseLine; // const clipPathId = _.isNil(id) ? this.id : id;
	
	      return _react["default"].createElement(_reactSmooth["default"], {
	        begin: animationBegin,
	        duration: animationDuration,
	        isActive: isAnimationActive,
	        easing: animationEasing,
	        from: {
	          t: 0
	        },
	        to: {
	          t: 1
	        },
	        key: "area-".concat(animationId),
	        onAnimationEnd: this.handleAnimationEnd,
	        onAnimationStart: this.handleAnimationStart
	      }, function (_ref) {
	        var t = _ref.t;
	
	        if (prevPoints) {
	          var prevPointsDiffFactor = prevPoints.length / points.length; // update animtaion
	
	          var stepPoints = points.map(function (entry, index) {
	            var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
	
	            if (prevPoints[prevPointIndex]) {
	              var prev = prevPoints[prevPointIndex];
	              var interpolatorX = (0, _DataUtils.interpolateNumber)(prev.x, entry.x);
	              var interpolatorY = (0, _DataUtils.interpolateNumber)(prev.y, entry.y);
	              return _objectSpread({}, entry, {
	                x: interpolatorX(t),
	                y: interpolatorY(t)
	              });
	            }
	
	            return entry;
	          });
	          var stepBaseLine;
	
	          if ((0, _DataUtils.isNumber)(baseLine)) {
	            var interpolator = (0, _DataUtils.interpolateNumber)(prevBaseLine, baseLine);
	            stepBaseLine = interpolator(t);
	          } else if ((0, _isNil2["default"])(baseLine) || (0, _isNaN2["default"])(baseLine)) {
	            var _interpolator = (0, _DataUtils.interpolateNumber)(prevBaseLine, 0);
	
	            stepBaseLine = _interpolator(t);
	          } else {
	            stepBaseLine = baseLine.map(function (entry, index) {
	              var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
	
	              if (prevBaseLine[prevPointIndex]) {
	                var prev = prevBaseLine[prevPointIndex];
	                var interpolatorX = (0, _DataUtils.interpolateNumber)(prev.x, entry.x);
	                var interpolatorY = (0, _DataUtils.interpolateNumber)(prev.y, entry.y);
	                return _objectSpread({}, entry, {
	                  x: interpolatorX(t),
	                  y: interpolatorY(t)
	                });
	              }
	
	              return entry;
	            });
	          }
	
	          return _this3.renderAreaStatically(stepPoints, stepBaseLine, needClip, clipPathId);
	        }
	
	        return _react["default"].createElement(_Layer["default"], null, _react["default"].createElement("defs", null, _react["default"].createElement("clipPath", {
	          id: "animationClipPath-".concat(clipPathId)
	        }, _this3.renderClipRect(t))), _react["default"].createElement(_Layer["default"], {
	          clipPath: "url(#animationClipPath-".concat(clipPathId, ")")
	        }, _this3.renderAreaStatically(points, baseLine, needClip, clipPathId)));
	      });
	    }
	  }, {
	    key: "renderArea",
	    value: function renderArea(needClip, clipPathId) {
	      var _this$props7 = this.props,
	          points = _this$props7.points,
	          baseLine = _this$props7.baseLine,
	          isAnimationActive = _this$props7.isAnimationActive;
	      var _this$state2 = this.state,
	          prevPoints = _this$state2.prevPoints,
	          prevBaseLine = _this$state2.prevBaseLine,
	          totalLength = _this$state2.totalLength;
	
	      if (isAnimationActive && points && points.length && (!prevPoints && totalLength > 0 || !(0, _isEqual2["default"])(prevPoints, points) || !(0, _isEqual2["default"])(prevBaseLine, baseLine))) {
	        return this.renderAreaWithAnimation(needClip, clipPathId);
	      }
	
	      return this.renderAreaStatically(points, baseLine, needClip, clipPathId);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props8 = this.props,
	          hide = _this$props8.hide,
	          dot = _this$props8.dot,
	          points = _this$props8.points,
	          className = _this$props8.className,
	          top = _this$props8.top,
	          left = _this$props8.left,
	          xAxis = _this$props8.xAxis,
	          yAxis = _this$props8.yAxis,
	          width = _this$props8.width,
	          height = _this$props8.height,
	          isAnimationActive = _this$props8.isAnimationActive,
	          id = _this$props8.id;
	
	      if (hide || !points || !points.length) {
	        return null;
	      }
	
	      var isAnimationFinished = this.state.isAnimationFinished;
	      var hasSinglePoint = points.length === 1;
	      var layerClass = (0, _classnames["default"])('recharts-area', className);
	      var needClip = xAxis && xAxis.allowDataOverflow || yAxis && yAxis.allowDataOverflow;
	      var clipPathId = (0, _isNil2["default"])(id) ? this.id : id;
	      return _react["default"].createElement(_Layer["default"], {
	        className: layerClass
	      }, needClip ? _react["default"].createElement("defs", null, _react["default"].createElement("clipPath", {
	        id: "clipPath-".concat(clipPathId)
	      }, _react["default"].createElement("rect", {
	        x: left,
	        y: top,
	        width: width,
	        height: parseInt(height, 10)
	      }))) : null, !hasSinglePoint ? this.renderArea(needClip, clipPathId) : null, (dot || hasSinglePoint) && this.renderDots(needClip, clipPathId), (!isAnimationActive || isAnimationFinished) && _LabelList["default"].renderCallByParent(this.props, points));
	    }
	  }]);
	
	  return Area;
	}(_react.PureComponent);
	
	Area.displayName = 'Area';
	Area.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {}, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _propTypes["default"].string,
	  dataKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func]).isRequired,
	  type: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(['basis', 'basisClosed', 'basisOpen', 'linear', 'linearClosed', 'natural', 'monotoneX', 'monotoneY', 'monotone', 'step', 'stepBefore', 'stepAfter']), _propTypes["default"].func]),
	  unit: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  name: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  yAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  xAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  yAxis: _propTypes["default"].object,
	  xAxis: _propTypes["default"].object,
	  stackId: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  legendType: _propTypes["default"].oneOf(_ReactUtils.LEGEND_TYPES),
	  tooltipType: _propTypes["default"].oneOf(_ReactUtils.TOOLTIP_TYPES),
	  connectNulls: _propTypes["default"].bool,
	  activeDot: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].element, _propTypes["default"].func, _propTypes["default"].bool]),
	  // dot configuration
	  dot: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].element, _propTypes["default"].object, _propTypes["default"].bool]),
	  label: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].element, _propTypes["default"].object, _propTypes["default"].bool]),
	  hide: _propTypes["default"].bool,
	  // have curve configuration
	  layout: _propTypes["default"].oneOf(['horizontal', 'vertical']),
	  baseLine: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].array]),
	  isRange: _propTypes["default"].bool,
	  points: _propTypes["default"].arrayOf(_propTypes["default"].shape({
	    x: _propTypes["default"].number,
	    y: _propTypes["default"].number,
	    value: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].array])
	  })),
	  onAnimationStart: _propTypes["default"].func,
	  onAnimationEnd: _propTypes["default"].func,
	  animationId: _propTypes["default"].number,
	  isAnimationActive: _propTypes["default"].bool,
	  animationBegin: _propTypes["default"].number,
	  animationDuration: _propTypes["default"].number,
	  animationEasing: _propTypes["default"].oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear']),
	  id: _propTypes["default"].string
	});
	Area.defaultProps = {
	  stroke: '#3182bd',
	  fill: '#3182bd',
	  fillOpacity: 0.6,
	  xAxisId: 0,
	  yAxisId: 0,
	  legendType: 'line',
	  connectNulls: false,
	  // points of area
	  points: [],
	  dot: false,
	  activeDot: true,
	  hide: false,
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'ease'
	};
	
	Area.getBaseValue = function (props, xAxis, yAxis) {
	  var layout = props.layout,
	      baseValue = props.baseValue;
	
	  if ((0, _DataUtils.isNumber)(baseValue)) {
	    return baseValue;
	  }
	
	  var numericAxis = layout === 'horizontal' ? yAxis : xAxis;
	  var domain = numericAxis.scale.domain();
	
	  if (numericAxis.type === 'number') {
	    var max = Math.max(domain[0], domain[1]);
	    var min = Math.min(domain[0], domain[1]);
	
	    if (baseValue === 'dataMin') {
	      return min;
	    }
	
	    if (baseValue === 'dataMax') {
	      return max;
	    }
	
	    return max < 0 ? max : Math.max(Math.min(domain[0], domain[1]), 0);
	  }
	
	  if (baseValue === 'dataMin') {
	    return domain[0];
	  }
	
	  if (baseValue === 'dataMax') {
	    return domain[1];
	  }
	
	  return domain[0];
	};
	
	Area.getComposedData = function (_ref2) {
	  var props = _ref2.props,
	      xAxis = _ref2.xAxis,
	      yAxis = _ref2.yAxis,
	      xAxisTicks = _ref2.xAxisTicks,
	      yAxisTicks = _ref2.yAxisTicks,
	      bandSize = _ref2.bandSize,
	      dataKey = _ref2.dataKey,
	      stackedData = _ref2.stackedData,
	      dataStartIndex = _ref2.dataStartIndex,
	      displayedData = _ref2.displayedData,
	      offset = _ref2.offset;
	  var layout = props.layout;
	  var hasStack = stackedData && stackedData.length;
	  var baseValue = Area.getBaseValue(props, xAxis, yAxis);
	  var isRange = false;
	  var points = displayedData.map(function (entry, index) {
	    var value;
	
	    if (hasStack) {
	      value = stackedData[dataStartIndex + index];
	    } else {
	      value = (0, _ChartUtils.getValueByDataKey)(entry, dataKey);
	
	      if (!(0, _isArray2["default"])(value)) {
	        value = [baseValue, value];
	      } else {
	        isRange = true;
	      }
	    }
	
	    if (layout === 'horizontal') {
	      return {
	        x: (0, _ChartUtils.getCateCoordinateOfLine)({
	          axis: xAxis,
	          ticks: xAxisTicks,
	          bandSize: bandSize,
	          entry: entry,
	          index: index
	        }),
	        y: (0, _isNil2["default"])(value[1]) ? null : yAxis.scale(value[1]),
	        value: value,
	        payload: entry
	      };
	    }
	
	    return {
	      x: (0, _isNil2["default"])(value[1]) ? null : xAxis.scale(value[1]),
	      y: (0, _ChartUtils.getCateCoordinateOfLine)({
	        axis: yAxis,
	        ticks: yAxisTicks,
	        bandSize: bandSize,
	        entry: entry,
	        index: index
	      }),
	      value: value,
	      payload: entry
	    };
	  });
	  var baseLine;
	
	  if (hasStack || isRange) {
	    baseLine = points.map(function (entry) {
	      if (layout === 'horizontal') {
	        return {
	          x: entry.x,
	          y: !(0, _isNil2["default"])((0, _get2["default"])(entry, 'value[0]')) ? yAxis.scale((0, _get2["default"])(entry, 'value[0]')) : null
	        };
	      }
	
	      return {
	        x: !(0, _isNil2["default"])((0, _get2["default"])(entry, 'value[0]')) ? xAxis.scale((0, _get2["default"])(entry, 'value[0]')) : null,
	        y: entry.y
	      };
	    });
	  } else if (layout === 'horizontal') {
	    baseLine = yAxis.scale(baseValue);
	  } else {
	    baseLine = xAxis.scale(baseValue);
	  }
	
	  return _objectSpread({
	    points: points,
	    baseLine: baseLine,
	    layout: layout,
	    isRange: isRange
	  }, offset);
	};
	
	Area.renderDotItem = function (option, props) {
	  var dotItem;
	
	  if (_react["default"].isValidElement(option)) {
	    dotItem = _react["default"].cloneElement(option, props);
	  } else if ((0, _isFunction2["default"])(option)) {
	    dotItem = option(props);
	  } else {
	    dotItem = _react["default"].createElement(_Dot["default"], _extends({}, props, {
	      className: "recharts-area-dot"
	    }));
	  }
	
	  return dotItem;
	};
	
	var _default = Area;
	exports["default"] = _default;

/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(71));
	
	var _isEqual2 = _interopRequireDefault(__webpack_require__(98));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(38));
	
	var _isArray2 = _interopRequireDefault(__webpack_require__(43));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _reactSmooth = _interopRequireDefault(__webpack_require__(81));
	
	var _Rectangle = _interopRequireDefault(__webpack_require__(190));
	
	var _Layer = _interopRequireDefault(__webpack_require__(49));
	
	var _ErrorBar = _interopRequireDefault(__webpack_require__(230));
	
	var _Cell = _interopRequireDefault(__webpack_require__(188));
	
	var _LabelList = _interopRequireDefault(__webpack_require__(113));
	
	var _DataUtils = __webpack_require__(39);
	
	var _ReactUtils = __webpack_require__(29);
	
	var _ChartUtils = __webpack_require__(66);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var Bar =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Bar, _PureComponent);
	
	  function Bar() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Bar);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Bar)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      isAnimationFinished: false
	    };
	    _this.id = (0, _DataUtils.uniqueId)('recharts-bar-');
	
	    _this.cachePrevData = function (data) {
	      _this.setState({
	        prevData: data
	      });
	    };
	
	    _this.handleAnimationEnd = function () {
	      _this.setState({
	        isAnimationFinished: true
	      });
	
	      _this.props.onAnimationEnd();
	    };
	
	    _this.handleAnimationStart = function () {
	      _this.setState({
	        isAnimationFinished: false
	      });
	
	      _this.props.onAnimationStart();
	    };
	
	    return _this;
	  }
	
	  _createClass(Bar, [{
	    key: "componentWillReceiveProps",
	    // eslint-disable-next-line camelcase
	    value: function componentWillReceiveProps(nextProps) {
	      var _this$props = this.props,
	          animationId = _this$props.animationId,
	          data = _this$props.data;
	
	      if (nextProps.animationId !== animationId) {
	        this.cachePrevData(data);
	      }
	    }
	  }, {
	    key: "renderRectanglesStatically",
	    value: function renderRectanglesStatically(data) {
	      var _this2 = this;
	
	      var shape = this.props.shape;
	      var baseProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      return data && data.map(function (entry, i) {
	        var props = _objectSpread({}, baseProps, {}, entry, {
	          index: i
	        });
	
	        return _react["default"].createElement(_Layer["default"], _extends({
	          className: "recharts-bar-rectangle"
	        }, (0, _ReactUtils.filterEventsOfChild)(_this2.props, entry, i), {
	          key: "rectangle-".concat(i) // eslint-disable-line react/no-array-index-key
	
	        }), _this2.constructor.renderRectangle(shape, props));
	      });
	    }
	  }, {
	    key: "renderRectanglesWithAnimation",
	    value: function renderRectanglesWithAnimation() {
	      var _this3 = this;
	
	      var _this$props2 = this.props,
	          data = _this$props2.data,
	          layout = _this$props2.layout,
	          isAnimationActive = _this$props2.isAnimationActive,
	          animationBegin = _this$props2.animationBegin,
	          animationDuration = _this$props2.animationDuration,
	          animationEasing = _this$props2.animationEasing,
	          animationId = _this$props2.animationId;
	      var prevData = this.state.prevData;
	      return _react["default"].createElement(_reactSmooth["default"], {
	        begin: animationBegin,
	        duration: animationDuration,
	        isActive: isAnimationActive,
	        easing: animationEasing,
	        from: {
	          t: 0
	        },
	        to: {
	          t: 1
	        },
	        key: "bar-".concat(animationId),
	        onAnimationEnd: this.handleAnimationEnd,
	        onAnimationStart: this.handleAnimationStart
	      }, function (_ref) {
	        var t = _ref.t;
	        var stepData = data.map(function (entry, index) {
	          var prev = prevData && prevData[index];
	
	          if (prev) {
	            var interpolatorX = (0, _DataUtils.interpolateNumber)(prev.x, entry.x);
	            var interpolatorY = (0, _DataUtils.interpolateNumber)(prev.y, entry.y);
	            var interpolatorWidth = (0, _DataUtils.interpolateNumber)(prev.width, entry.width);
	            var interpolatorHeight = (0, _DataUtils.interpolateNumber)(prev.height, entry.height);
	            return _objectSpread({}, entry, {
	              x: interpolatorX(t),
	              y: interpolatorY(t),
	              width: interpolatorWidth(t),
	              height: interpolatorHeight(t)
	            });
	          }
	
	          if (layout === 'horizontal') {
	            var _interpolatorHeight = (0, _DataUtils.interpolateNumber)(0, entry.height);
	
	            var h = _interpolatorHeight(t);
	
	            return _objectSpread({}, entry, {
	              y: entry.y + entry.height - h,
	              height: h
	            });
	          }
	
	          var interpolator = (0, _DataUtils.interpolateNumber)(0, entry.width);
	          var w = interpolator(t);
	          return _objectSpread({}, entry, {
	            width: w
	          });
	        });
	        return _react["default"].createElement(_Layer["default"], null, _this3.renderRectanglesStatically(stepData));
	      });
	    }
	  }, {
	    key: "renderRectangles",
	    value: function renderRectangles() {
	      var _this$props3 = this.props,
	          data = _this$props3.data,
	          isAnimationActive = _this$props3.isAnimationActive;
	      var prevData = this.state.prevData;
	
	      if (isAnimationActive && data && data.length && (!prevData || !(0, _isEqual2["default"])(prevData, data))) {
	        return this.renderRectanglesWithAnimation();
	      }
	
	      return this.renderRectanglesStatically(data);
	    }
	  }, {
	    key: "renderBackground",
	    value: function renderBackground() {
	      var _this4 = this;
	
	      var data = this.props.data;
	      var backgroundProps = (0, _ReactUtils.getPresentationAttributes)(this.props.background);
	      return data.map(function (entry, i) {
	        // eslint-disable-next-line no-unused-vars
	        var value = entry.value,
	            background = entry.background,
	            rest = _objectWithoutProperties(entry, ["value", "background"]);
	
	        if (!background) {
	          return null;
	        }
	
	        var props = _objectSpread({}, rest, {
	          fill: '#eee'
	        }, background, {}, backgroundProps, {}, (0, _ReactUtils.filterEventsOfChild)(_this4.props, entry, i), {
	          index: i,
	          key: "background-bar-".concat(i),
	          className: 'recharts-bar-background-rectangle'
	        });
	
	        return _this4.constructor.renderRectangle(_this4.props.background, props);
	      });
	    }
	  }, {
	    key: "renderErrorBar",
	    value: function renderErrorBar() {
	      if (this.props.isAnimationActive && !this.state.isAnimationFinished) {
	        return null;
	      }
	
	      var _this$props4 = this.props,
	          data = _this$props4.data,
	          xAxis = _this$props4.xAxis,
	          yAxis = _this$props4.yAxis,
	          layout = _this$props4.layout,
	          children = _this$props4.children;
	      var errorBarItems = (0, _ReactUtils.findAllByType)(children, _ErrorBar["default"]);
	
	      if (!errorBarItems) {
	        return null;
	      }
	
	      var offset = layout === 'vertical' ? data[0].height / 2 : data[0].width / 2;
	
	      function dataPointFormatter(dataPoint, dataKey) {
	        return {
	          x: dataPoint.x,
	          y: dataPoint.y,
	          value: dataPoint.value,
	          errorVal: (0, _ChartUtils.getValueByDataKey)(dataPoint, dataKey)
	        };
	      }
	
	      return errorBarItems.map(function (item, i) {
	        return _react["default"].cloneElement(item, {
	          key: "error-bar-".concat(i),
	          // eslint-disable-line react/no-array-index-key
	          data: data,
	          xAxis: xAxis,
	          yAxis: yAxis,
	          layout: layout,
	          offset: offset,
	          dataPointFormatter: dataPointFormatter
	        });
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props5 = this.props,
	          hide = _this$props5.hide,
	          data = _this$props5.data,
	          className = _this$props5.className,
	          xAxis = _this$props5.xAxis,
	          yAxis = _this$props5.yAxis,
	          left = _this$props5.left,
	          top = _this$props5.top,
	          width = _this$props5.width,
	          height = _this$props5.height,
	          isAnimationActive = _this$props5.isAnimationActive,
	          background = _this$props5.background,
	          id = _this$props5.id;
	
	      if (hide || !data || !data.length) {
	        return null;
	      }
	
	      var isAnimationFinished = this.state.isAnimationFinished;
	      var layerClass = (0, _classnames["default"])('recharts-bar', className);
	      var needClip = xAxis && xAxis.allowDataOverflow || yAxis && yAxis.allowDataOverflow;
	      var clipPathId = (0, _isNil2["default"])(id) ? this.id : id;
	      return _react["default"].createElement(_Layer["default"], {
	        className: layerClass
	      }, needClip ? _react["default"].createElement("defs", null, _react["default"].createElement("clipPath", {
	        id: "clipPath-".concat(clipPathId)
	      }, _react["default"].createElement("rect", {
	        x: left,
	        y: top,
	        width: width,
	        height: height
	      }))) : null, _react["default"].createElement(_Layer["default"], {
	        className: "recharts-bar-rectangles",
	        clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
	      }, background ? this.renderBackground() : null, this.renderRectangles()), this.renderErrorBar(), (!isAnimationActive || isAnimationFinished) && _LabelList["default"].renderCallByParent(this.props, data));
	    }
	  }], [{
	    key: "renderRectangle",
	    value: function renderRectangle(option, props) {
	      var rectangle;
	
	      if (_react["default"].isValidElement(option)) {
	        rectangle = _react["default"].cloneElement(option, props);
	      } else if ((0, _isFunction2["default"])(option)) {
	        rectangle = option(props);
	      } else {
	        rectangle = _react["default"].createElement(_Rectangle["default"], props);
	      }
	
	      return rectangle;
	    }
	  }]);
	
	  return Bar;
	}(_react.PureComponent);
	
	Bar.displayName = 'Bar';
	Bar.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {}, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _propTypes["default"].string,
	  layout: _propTypes["default"].oneOf(['vertical', 'horizontal']),
	  xAxisId: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  yAxisId: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  yAxis: _propTypes["default"].object,
	  xAxis: _propTypes["default"].object,
	  stackId: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  barSize: _propTypes["default"].number,
	  unit: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  name: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  dataKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func]).isRequired,
	  legendType: _propTypes["default"].oneOf(_ReactUtils.LEGEND_TYPES),
	  tooltipType: _propTypes["default"].oneOf(_ReactUtils.TOOLTIP_TYPES),
	  minPointSize: _propTypes["default"].number,
	  maxBarSize: _propTypes["default"].number,
	  hide: _propTypes["default"].bool,
	  shape: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].element]),
	  data: _propTypes["default"].arrayOf(_propTypes["default"].shape({
	    x: _propTypes["default"].number,
	    y: _propTypes["default"].number,
	    width: _propTypes["default"].number,
	    height: _propTypes["default"].number,
	    radius: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].array]),
	    value: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string, _propTypes["default"].array])
	  })),
	  onAnimationStart: _propTypes["default"].func,
	  onAnimationEnd: _propTypes["default"].func,
	  animationId: _propTypes["default"].number,
	  isAnimationActive: _propTypes["default"].bool,
	  animationBegin: _propTypes["default"].number,
	  animationDuration: _propTypes["default"].number,
	  animationEasing: _propTypes["default"].oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear']),
	  id: _propTypes["default"].string
	});
	Bar.defaultProps = {
	  xAxisId: 0,
	  yAxisId: 0,
	  legendType: 'rect',
	  minPointSize: 0,
	  hide: false,
	  // data of bar
	  data: [],
	  layout: 'vertical',
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 400,
	  animationEasing: 'ease',
	  onAnimationStart: function onAnimationStart() {},
	  onAnimationEnd: function onAnimationEnd() {}
	};
	
	Bar.getComposedData = function (_ref2) {
	  var props = _ref2.props,
	      item = _ref2.item,
	      barPosition = _ref2.barPosition,
	      bandSize = _ref2.bandSize,
	      xAxis = _ref2.xAxis,
	      yAxis = _ref2.yAxis,
	      xAxisTicks = _ref2.xAxisTicks,
	      yAxisTicks = _ref2.yAxisTicks,
	      stackedData = _ref2.stackedData,
	      dataStartIndex = _ref2.dataStartIndex,
	      displayedData = _ref2.displayedData,
	      offset = _ref2.offset;
	  var pos = (0, _ChartUtils.findPositionOfBar)(barPosition, item);
	
	  if (!pos) {
	    return [];
	  }
	
	  var layout = props.layout;
	  var _item$props = item.props,
	      dataKey = _item$props.dataKey,
	      children = _item$props.children,
	      minPointSize = _item$props.minPointSize;
	  var numericAxis = layout === 'horizontal' ? yAxis : xAxis;
	  var stackedDomain = stackedData ? numericAxis.scale.domain() : null;
	  var baseValue = (0, _ChartUtils.getBaseValueOfBar)({
	    props: props,
	    numericAxis: numericAxis
	  });
	  var cells = (0, _ReactUtils.findAllByType)(children, _Cell["default"]);
	  var rects = displayedData.map(function (entry, index) {
	    var value, x, y, width, height, background;
	
	    if (stackedData) {
	      value = (0, _ChartUtils.truncateByDomain)(stackedData[dataStartIndex + index], stackedDomain);
	    } else {
	      value = (0, _ChartUtils.getValueByDataKey)(entry, dataKey);
	
	      if (!(0, _isArray2["default"])(value)) {
	        value = [baseValue, value];
	      }
	    }
	
	    if (layout === 'horizontal') {
	      x = (0, _ChartUtils.getCateCoordinateOfBar)({
	        axis: xAxis,
	        ticks: xAxisTicks,
	        bandSize: bandSize,
	        offset: pos.offset,
	        entry: entry,
	        index: index
	      });
	      y = yAxis.scale(value[1]);
	      width = pos.size;
	      height = yAxis.scale(value[0]) - yAxis.scale(value[1]);
	      background = {
	        x: x,
	        y: yAxis.y,
	        width: width,
	        height: yAxis.height
	      };
	
	      if (Math.abs(minPointSize) > 0 && Math.abs(height) < Math.abs(minPointSize)) {
	        var delta = (0, _DataUtils.mathSign)(height || minPointSize) * (Math.abs(minPointSize) - Math.abs(height));
	        y -= delta;
	        height += delta;
	      }
	    } else {
	      x = xAxis.scale(value[0]);
	      y = (0, _ChartUtils.getCateCoordinateOfBar)({
	        axis: yAxis,
	        ticks: yAxisTicks,
	        bandSize: bandSize,
	        offset: pos.offset,
	        entry: entry,
	        index: index
	      });
	      width = xAxis.scale(value[1]) - xAxis.scale(value[0]);
	      height = pos.size;
	      background = {
	        x: xAxis.x,
	        y: y,
	        width: xAxis.width,
	        height: height
	      };
	
	      if (Math.abs(minPointSize) > 0 && Math.abs(width) < Math.abs(minPointSize)) {
	        var _delta = (0, _DataUtils.mathSign)(width || minPointSize) * (Math.abs(minPointSize) - Math.abs(width));
	
	        width += _delta;
	      }
	    }
	
	    return _objectSpread({}, entry, {
	      x: x,
	      y: y,
	      width: width,
	      height: height,
	      value: stackedData ? value : value[1],
	      payload: entry,
	      background: background
	    }, cells && cells[index] && cells[index].props);
	  });
	  return _objectSpread({
	    data: rects,
	    layout: layout
	  }, offset);
	};
	
	var _default = Bar;
	exports["default"] = _default;

/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isEqual2 = _interopRequireDefault(__webpack_require__(98));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(38));
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(71));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _reactSmooth = _interopRequireDefault(__webpack_require__(81));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _Curve = _interopRequireDefault(__webpack_require__(189));
	
	var _Dot = _interopRequireDefault(__webpack_require__(153));
	
	var _Layer = _interopRequireDefault(__webpack_require__(49));
	
	var _LabelList = _interopRequireDefault(__webpack_require__(113));
	
	var _ErrorBar = _interopRequireDefault(__webpack_require__(230));
	
	var _DataUtils = __webpack_require__(39);
	
	var _ReactUtils = __webpack_require__(29);
	
	var _ChartUtils = __webpack_require__(66);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var Line =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Line, _PureComponent);
	
	  function Line() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Line);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Line)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      isAnimationFinished: true,
	      totalLength: 0
	    };
	    _this.id = (0, _DataUtils.uniqueId)('recharts-line-');
	
	    _this.cachePrevData = function (points) {
	      _this.setState({
	        prevPoints: points
	      });
	    };
	
	    _this.pathRef = function (node) {
	      _this.mainCurve = node;
	    };
	
	    _this.handleAnimationEnd = function () {
	      _this.setState({
	        isAnimationFinished: true
	      });
	
	      _this.props.onAnimationEnd();
	    };
	
	    _this.handleAnimationStart = function () {
	      _this.setState({
	        isAnimationFinished: false
	      });
	
	      _this.props.onAnimationStart();
	    };
	
	    return _this;
	  }
	
	  _createClass(Line, [{
	    key: "componentDidMount",
	
	    /* eslint-disable  react/no-did-mount-set-state */
	    value: function componentDidMount() {
	      if (!this.props.isAnimationActive) {
	        return;
	      }
	
	      var totalLength = this.getTotalLength();
	      this.setState({
	        totalLength: totalLength
	      });
	    } // eslint-disable-next-line camelcase
	
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _this$props = this.props,
	          animationId = _this$props.animationId,
	          points = _this$props.points;
	
	      if (nextProps.animationId !== animationId) {
	        this.cachePrevData(points);
	      }
	    }
	  }, {
	    key: "getTotalLength",
	    value: function getTotalLength() {
	      var curveDom = this.mainCurve;
	
	      try {
	        return curveDom && curveDom.getTotalLength && curveDom.getTotalLength() || 0;
	      } catch (err) {
	        return 0;
	      }
	    }
	  }, {
	    key: "getStrokeDasharray",
	    value: function getStrokeDasharray(length, totalLength, lines) {
	      var lineLength = lines.reduce(function (pre, next) {
	        return pre + next;
	      });
	      var count = parseInt(length / lineLength, 10);
	      var remainLength = length % lineLength;
	      var restLength = totalLength - length;
	      var remainLines = [];
	
	      for (var i = 0, sum = 0;; sum += lines[i], ++i) {
	        if (sum + lines[i] > remainLength) {
	          remainLines = [].concat(_toConsumableArray(lines.slice(0, i)), [remainLength - sum]);
	          break;
	        }
	      }
	
	      var emptyLines = remainLines.length % 2 === 0 ? [0, restLength] : [restLength];
	      return [].concat(_toConsumableArray(this.constructor.repeat(lines, count)), _toConsumableArray(remainLines), emptyLines).map(function (line) {
	        return "".concat(line, "px");
	      }).join(', ');
	    }
	  }, {
	    key: "renderErrorBar",
	    value: function renderErrorBar() {
	      if (this.props.isAnimationActive && !this.state.isAnimationFinished) {
	        return null;
	      }
	
	      var _this$props2 = this.props,
	          points = _this$props2.points,
	          xAxis = _this$props2.xAxis,
	          yAxis = _this$props2.yAxis,
	          layout = _this$props2.layout,
	          children = _this$props2.children;
	      var errorBarItems = (0, _ReactUtils.findAllByType)(children, _ErrorBar["default"]);
	
	      if (!errorBarItems) {
	        return null;
	      }
	
	      function dataPointFormatter(dataPoint, dataKey) {
	        return {
	          x: dataPoint.x,
	          y: dataPoint.y,
	          value: dataPoint.value,
	          errorVal: (0, _ChartUtils.getValueByDataKey)(dataPoint.payload, dataKey)
	        };
	      }
	
	      return errorBarItems.map(function (item, i) {
	        return _react["default"].cloneElement(item, {
	          key: i,
	          // eslint-disable-line react/no-array-index-key
	          data: points,
	          xAxis: xAxis,
	          yAxis: yAxis,
	          layout: layout,
	          dataPointFormatter: dataPointFormatter
	        });
	      });
	    }
	  }, {
	    key: "renderDots",
	    value: function renderDots(needClip, clipPathId) {
	      var _this2 = this;
	
	      var isAnimationActive = this.props.isAnimationActive;
	
	      if (isAnimationActive && !this.state.isAnimationFinished) {
	        return null;
	      }
	
	      var _this$props3 = this.props,
	          dot = _this$props3.dot,
	          points = _this$props3.points,
	          dataKey = _this$props3.dataKey;
	      var lineProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customDotProps = (0, _ReactUtils.getPresentationAttributes)(dot);
	      var dotEvents = (0, _ReactUtils.filterEventAttributes)(dot);
	      var dots = points.map(function (entry, i) {
	        var dotProps = _objectSpread({
	          key: "dot-".concat(i),
	          r: 3
	        }, lineProps, {}, customDotProps, {}, dotEvents, {
	          value: entry.value,
	          dataKey: dataKey,
	          cx: entry.x,
	          cy: entry.y,
	          index: i,
	          payload: entry.payload
	        });
	
	        return _this2.constructor.renderDotItem(dot, dotProps);
	      });
	      var dotsProps = {
	        clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
	      };
	      return _react["default"].createElement(_Layer["default"], _extends({
	        className: "recharts-line-dots",
	        key: "dots"
	      }, dotsProps), dots);
	    }
	  }, {
	    key: "renderCurveStatically",
	    value: function renderCurveStatically(points, needClip, clipPathId, props) {
	      var _this$props4 = this.props,
	          type = _this$props4.type,
	          layout = _this$props4.layout,
	          connectNulls = _this$props4.connectNulls;
	
	      var curveProps = _objectSpread({}, (0, _ReactUtils.getPresentationAttributes)(this.props), {}, (0, _ReactUtils.filterEventAttributes)(this.props), {
	        fill: 'none',
	        className: 'recharts-line-curve',
	        clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null,
	        points: points
	      }, props, {
	        type: type,
	        layout: layout,
	        connectNulls: connectNulls
	      });
	
	      return _react["default"].createElement(_Curve["default"], _extends({}, curveProps, {
	        pathRef: this.pathRef
	      }));
	    }
	  }, {
	    key: "renderCurveWithAnimation",
	    value: function renderCurveWithAnimation(needClip, clipPathId) {
	      var _this3 = this;
	
	      var _this$props5 = this.props,
	          points = _this$props5.points,
	          strokeDasharray = _this$props5.strokeDasharray,
	          isAnimationActive = _this$props5.isAnimationActive,
	          animationBegin = _this$props5.animationBegin,
	          animationDuration = _this$props5.animationDuration,
	          animationEasing = _this$props5.animationEasing,
	          animationId = _this$props5.animationId,
	          width = _this$props5.width,
	          height = _this$props5.height;
	      var _this$state = this.state,
	          prevPoints = _this$state.prevPoints,
	          totalLength = _this$state.totalLength;
	      return _react["default"].createElement(_reactSmooth["default"], {
	        begin: animationBegin,
	        duration: animationDuration,
	        isActive: isAnimationActive,
	        easing: animationEasing,
	        from: {
	          t: 0
	        },
	        to: {
	          t: 1
	        },
	        key: "line-".concat(animationId),
	        onAnimationEnd: this.handleAnimationEnd,
	        onAnimationStart: this.handleAnimationStart
	      }, function (_ref) {
	        var t = _ref.t;
	
	        if (prevPoints) {
	          var prevPointsDiffFactor = prevPoints.length / points.length;
	          var stepData = points.map(function (entry, index) {
	            var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
	
	            if (prevPoints[prevPointIndex]) {
	              var prev = prevPoints[prevPointIndex];
	              var interpolatorX = (0, _DataUtils.interpolateNumber)(prev.x, entry.x);
	              var interpolatorY = (0, _DataUtils.interpolateNumber)(prev.y, entry.y);
	              return _objectSpread({}, entry, {
	                x: interpolatorX(t),
	                y: interpolatorY(t)
	              });
	            } // magic number of faking previous x and y location
	
	
	            if (_this3.animateNewValues) {
	              var _interpolatorX = (0, _DataUtils.interpolateNumber)(width * 2, entry.x);
	
	              var _interpolatorY = (0, _DataUtils.interpolateNumber)(height / 2, entry.y);
	
	              return _objectSpread({}, entry, {
	                x: _interpolatorX(t),
	                y: _interpolatorY(t)
	              });
	            }
	
	            return _objectSpread({}, entry, {
	              x: entry.x,
	              y: entry.y
	            });
	          });
	          return _this3.renderCurveStatically(stepData, needClip, clipPathId);
	        }
	
	        var interpolator = (0, _DataUtils.interpolateNumber)(0, totalLength);
	        var curLength = interpolator(t);
	        var currentStrokeDasharray;
	
	        if (strokeDasharray) {
	          var lines = strokeDasharray.split(/[,\s]+/gim).map(function (num) {
	            return parseFloat(num);
	          });
	          currentStrokeDasharray = _this3.getStrokeDasharray(curLength, totalLength, lines);
	        } else {
	          currentStrokeDasharray = "".concat(curLength, "px ").concat(totalLength - curLength, "px");
	        }
	
	        return _this3.renderCurveStatically(points, needClip, clipPathId, {
	          strokeDasharray: currentStrokeDasharray
	        });
	      });
	    }
	  }, {
	    key: "renderCurve",
	    value: function renderCurve(needClip, clipPathId) {
	      var _this$props6 = this.props,
	          points = _this$props6.points,
	          isAnimationActive = _this$props6.isAnimationActive;
	      var _this$state2 = this.state,
	          prevPoints = _this$state2.prevPoints,
	          totalLength = _this$state2.totalLength;
	
	      if (isAnimationActive && points && points.length && (!prevPoints && totalLength > 0 || !(0, _isEqual2["default"])(prevPoints, points))) {
	        return this.renderCurveWithAnimation(needClip, clipPathId);
	      }
	
	      return this.renderCurveStatically(points, needClip, clipPathId);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props7 = this.props,
	          hide = _this$props7.hide,
	          dot = _this$props7.dot,
	          points = _this$props7.points,
	          className = _this$props7.className,
	          xAxis = _this$props7.xAxis,
	          yAxis = _this$props7.yAxis,
	          top = _this$props7.top,
	          left = _this$props7.left,
	          width = _this$props7.width,
	          height = _this$props7.height,
	          isAnimationActive = _this$props7.isAnimationActive,
	          id = _this$props7.id;
	
	      if (hide || !points || !points.length) {
	        return null;
	      }
	
	      var isAnimationFinished = this.state.isAnimationFinished;
	      var hasSinglePoint = points.length === 1;
	      var layerClass = (0, _classnames["default"])('recharts-line', className);
	      var needClip = xAxis && xAxis.allowDataOverflow || yAxis && yAxis.allowDataOverflow;
	      var clipPathId = (0, _isNil2["default"])(id) ? this.id : id;
	      return _react["default"].createElement(_Layer["default"], {
	        className: layerClass
	      }, needClip ? _react["default"].createElement("defs", null, _react["default"].createElement("clipPath", {
	        id: "clipPath-".concat(clipPathId)
	      }, _react["default"].createElement("rect", {
	        x: left,
	        y: top,
	        width: width,
	        height: height
	      }))) : null, !hasSinglePoint && this.renderCurve(needClip, clipPathId), this.renderErrorBar(), (hasSinglePoint || dot) && this.renderDots(needClip, clipPathId), (!isAnimationActive || isAnimationFinished) && _LabelList["default"].renderCallByParent(this.props, points));
	    }
	  }], [{
	    key: "repeat",
	    value: function repeat(lines, count) {
	      var linesUnit = lines.length % 2 !== 0 ? [].concat(_toConsumableArray(lines), [0]) : lines;
	      var result = [];
	
	      for (var i = 0; i < count; ++i) {
	        result = [].concat(_toConsumableArray(result), _toConsumableArray(linesUnit));
	      }
	
	      return result;
	    }
	  }, {
	    key: "renderDotItem",
	    value: function renderDotItem(option, props) {
	      var dotItem;
	
	      if (_react["default"].isValidElement(option)) {
	        dotItem = _react["default"].cloneElement(option, props);
	      } else if ((0, _isFunction2["default"])(option)) {
	        dotItem = option(props);
	      } else {
	        var className = (0, _classnames["default"])('recharts-line-dot', option ? option.className : '');
	        dotItem = _react["default"].createElement(_Dot["default"], _extends({}, props, {
	          className: className
	        }));
	      }
	
	      return dotItem;
	    }
	  }]);
	
	  return Line;
	}(_react.PureComponent);
	
	Line.displayName = 'Line';
	Line.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {}, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _propTypes["default"].string,
	  type: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(['basis', 'basisClosed', 'basisOpen', 'linear', 'linearClosed', 'natural', 'monotoneX', 'monotoneY', 'monotone', 'step', 'stepBefore', 'stepAfter']), _propTypes["default"].func]),
	  unit: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  name: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  yAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  xAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  yAxis: _propTypes["default"].object,
	  xAxis: _propTypes["default"].object,
	  legendType: _propTypes["default"].oneOf(_ReactUtils.LEGEND_TYPES),
	  tooltipType: _propTypes["default"].oneOf(_ReactUtils.TOOLTIP_TYPES),
	  layout: _propTypes["default"].oneOf(['horizontal', 'vertical']),
	  connectNulls: _propTypes["default"].bool,
	  hide: _propTypes["default"].bool,
	  // whether have dot in line
	  activeDot: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].element, _propTypes["default"].func, _propTypes["default"].bool]),
	  dot: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].element, _propTypes["default"].func, _propTypes["default"].bool]),
	  top: _propTypes["default"].number,
	  left: _propTypes["default"].number,
	  width: _propTypes["default"].number,
	  height: _propTypes["default"].number,
	  points: _propTypes["default"].arrayOf(_propTypes["default"].shape({
	    x: _propTypes["default"].number,
	    y: _propTypes["default"].number,
	    value: _propTypes["default"].value
	  })),
	  onAnimationStart: _propTypes["default"].func,
	  onAnimationEnd: _propTypes["default"].func,
	  isAnimationActive: _propTypes["default"].bool,
	  animateNewValues: _propTypes["default"].bool,
	  animationBegin: _propTypes["default"].number,
	  animationDuration: _propTypes["default"].number,
	  animationEasing: _propTypes["default"].oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear']),
	  animationId: _propTypes["default"].number,
	  id: _propTypes["default"].string
	});
	Line.defaultProps = {
	  xAxisId: 0,
	  yAxisId: 0,
	  connectNulls: false,
	  activeDot: true,
	  dot: true,
	  legendType: 'line',
	  stroke: '#3182bd',
	  strokeWidth: 1,
	  fill: '#fff',
	  points: [],
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animateNewValues: true,
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'ease',
	  hide: false,
	  onAnimationStart: function onAnimationStart() {},
	  onAnimationEnd: function onAnimationEnd() {}
	};
	
	Line.getComposedData = function (_ref2) {
	  var props = _ref2.props,
	      xAxis = _ref2.xAxis,
	      yAxis = _ref2.yAxis,
	      xAxisTicks = _ref2.xAxisTicks,
	      yAxisTicks = _ref2.yAxisTicks,
	      dataKey = _ref2.dataKey,
	      bandSize = _ref2.bandSize,
	      displayedData = _ref2.displayedData,
	      offset = _ref2.offset;
	  var layout = props.layout;
	  var points = displayedData.map(function (entry, index) {
	    var value = (0, _ChartUtils.getValueByDataKey)(entry, dataKey);
	
	    if (layout === 'horizontal') {
	      return {
	        x: (0, _ChartUtils.getCateCoordinateOfLine)({
	          axis: xAxis,
	          ticks: xAxisTicks,
	          bandSize: bandSize,
	          entry: entry,
	          index: index
	        }),
	        y: (0, _isNil2["default"])(value) ? null : yAxis.scale(value),
	        value: value,
	        payload: entry
	      };
	    }
	
	    return {
	      x: (0, _isNil2["default"])(value) ? null : xAxis.scale(value),
	      y: (0, _ChartUtils.getCateCoordinateOfLine)({
	        axis: yAxis,
	        ticks: yAxisTicks,
	        bandSize: bandSize,
	        entry: entry,
	        index: index
	      }),
	      value: value,
	      payload: entry
	    };
	  });
	  return _objectSpread({
	    points: points,
	    layout: layout
	  }, offset);
	};
	
	var _default = Line;
	exports["default"] = _default;

/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isEqual2 = _interopRequireDefault(__webpack_require__(98));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(38));
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(71));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _reactSmooth = _interopRequireDefault(__webpack_require__(81));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _Layer = _interopRequireDefault(__webpack_require__(49));
	
	var _LabelList = _interopRequireDefault(__webpack_require__(113));
	
	var _ReactUtils = __webpack_require__(29);
	
	var _ZAxis = _interopRequireDefault(__webpack_require__(306));
	
	var _Curve = _interopRequireDefault(__webpack_require__(189));
	
	var _Symbols = _interopRequireDefault(__webpack_require__(478));
	
	var _ErrorBar = _interopRequireDefault(__webpack_require__(230));
	
	var _Cell = _interopRequireDefault(__webpack_require__(188));
	
	var _DataUtils = __webpack_require__(39);
	
	var _ChartUtils = __webpack_require__(66);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var Scatter =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Scatter, _PureComponent);
	
	  function Scatter() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Scatter);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Scatter)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      isAnimationFinished: false
	    };
	
	    _this.cachePrevPoints = function (points) {
	      _this.setState({
	        prevPoints: points
	      });
	    };
	
	    _this.handleAnimationEnd = function () {
	      _this.setState({
	        isAnimationFinished: true
	      });
	    };
	
	    _this.handleAnimationStart = function () {
	      _this.setState({
	        isAnimationFinished: false
	      });
	    };
	
	    _this.id = (0, _DataUtils.uniqueId)('recharts-scatter-');
	    return _this;
	  }
	
	  _createClass(Scatter, [{
	    key: "componentWillReceiveProps",
	    // eslint-disable-next-line camelcase
	    value: function componentWillReceiveProps(nextProps) {
	      var _this$props = this.props,
	          animationId = _this$props.animationId,
	          points = _this$props.points;
	
	      if (nextProps.animationId !== animationId) {
	        this.cachePrevPoints(points);
	      }
	    }
	  }, {
	    key: "renderSymbolsStatically",
	    value: function renderSymbolsStatically(points) {
	      var _this2 = this;
	
	      var _this$props2 = this.props,
	          shape = _this$props2.shape,
	          activeShape = _this$props2.activeShape,
	          activeIndex = _this$props2.activeIndex;
	      var baseProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      return points.map(function (entry, i) {
	        var props = _objectSpread({
	          key: "symbol-".concat(i)
	        }, baseProps, {}, entry);
	
	        return _react["default"].createElement(_Layer["default"], _extends({
	          className: "recharts-scatter-symbol"
	        }, (0, _ReactUtils.filterEventsOfChild)(_this2.props, entry, i), {
	          key: "symbol-".concat(i) // eslint-disable-line react/no-array-index-key
	
	        }), _this2.constructor.renderSymbolItem(activeIndex === i ? activeShape : shape, props));
	      });
	    }
	  }, {
	    key: "renderSymbolsWithAnimation",
	    value: function renderSymbolsWithAnimation() {
	      var _this3 = this;
	
	      var _this$props3 = this.props,
	          points = _this$props3.points,
	          isAnimationActive = _this$props3.isAnimationActive,
	          animationBegin = _this$props3.animationBegin,
	          animationDuration = _this$props3.animationDuration,
	          animationEasing = _this$props3.animationEasing,
	          animationId = _this$props3.animationId;
	      var prevPoints = this.state.prevPoints;
	      return _react["default"].createElement(_reactSmooth["default"], {
	        begin: animationBegin,
	        duration: animationDuration,
	        isActive: isAnimationActive,
	        easing: animationEasing,
	        from: {
	          t: 0
	        },
	        to: {
	          t: 1
	        },
	        key: "pie-".concat(animationId),
	        onAnimationEnd: this.handleAnimationEnd,
	        onAnimationStart: this.handleAnimationStart
	      }, function (_ref) {
	        var t = _ref.t;
	        var stepData = points.map(function (entry, index) {
	          var prev = prevPoints && prevPoints[index];
	
	          if (prev) {
	            var interpolatorCx = (0, _DataUtils.interpolateNumber)(prev.cx, entry.cx);
	            var interpolatorCy = (0, _DataUtils.interpolateNumber)(prev.cy, entry.cy);
	            var interpolatorSize = (0, _DataUtils.interpolateNumber)(prev.size, entry.size);
	            return _objectSpread({}, entry, {
	              cx: interpolatorCx(t),
	              cy: interpolatorCy(t),
	              size: interpolatorSize(t)
	            });
	          }
	
	          var interpolator = (0, _DataUtils.interpolateNumber)(0, entry.size);
	          return _objectSpread({}, entry, {
	            size: interpolator(t)
	          });
	        });
	        return _react["default"].createElement(_Layer["default"], null, _this3.renderSymbolsStatically(stepData));
	      });
	    }
	  }, {
	    key: "renderSymbols",
	    value: function renderSymbols() {
	      var _this$props4 = this.props,
	          points = _this$props4.points,
	          isAnimationActive = _this$props4.isAnimationActive;
	      var prevPoints = this.state.prevPoints;
	
	      if (isAnimationActive && points && points.length && (!prevPoints || !(0, _isEqual2["default"])(prevPoints, points))) {
	        return this.renderSymbolsWithAnimation();
	      }
	
	      return this.renderSymbolsStatically(points);
	    }
	  }, {
	    key: "renderErrorBar",
	    value: function renderErrorBar() {
	      var isAnimationActive = this.props.isAnimationActive;
	
	      if (isAnimationActive && !this.state.isAnimationFinished) {
	        return null;
	      }
	
	      var _this$props5 = this.props,
	          points = _this$props5.points,
	          xAxis = _this$props5.xAxis,
	          yAxis = _this$props5.yAxis,
	          children = _this$props5.children;
	      var errorBarItems = (0, _ReactUtils.findAllByType)(children, _ErrorBar["default"]);
	
	      if (!errorBarItems) {
	        return null;
	      }
	
	      function dataPointFormatterY(dataPoint, dataKey) {
	        return {
	          x: dataPoint.cx,
	          y: dataPoint.cy,
	          value: dataPoint.node.y,
	          errorVal: (0, _ChartUtils.getValueByDataKey)(dataPoint, dataKey)
	        };
	      }
	
	      function dataPointFormatterX(dataPoint, dataKey) {
	        return {
	          x: dataPoint.cx,
	          y: dataPoint.cy,
	          value: dataPoint.node.x,
	          errorVal: (0, _ChartUtils.getValueByDataKey)(dataPoint, dataKey)
	        };
	      }
	
	      return errorBarItems.map(function (item, i) {
	        var direction = item.props.direction;
	        return _react["default"].cloneElement(item, {
	          key: i,
	          // eslint-disable-line react/no-array-index-key
	          data: points,
	          xAxis: xAxis,
	          yAxis: yAxis,
	          layout: direction === 'x' ? 'vertical' : 'horizontal',
	          dataPointFormatter: direction === 'x' ? dataPointFormatterX : dataPointFormatterY
	        });
	      });
	    }
	  }, {
	    key: "renderLine",
	    value: function renderLine() {
	      var _this$props6 = this.props,
	          points = _this$props6.points,
	          line = _this$props6.line,
	          lineType = _this$props6.lineType,
	          lineJointType = _this$props6.lineJointType;
	      var scatterProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customLineProps = (0, _ReactUtils.getPresentationAttributes)(line);
	      var linePoints, lineItem;
	
	      if (lineType === 'joint') {
	        linePoints = points.map(function (entry) {
	          return {
	            x: entry.cx,
	            y: entry.cy
	          };
	        });
	      } else if (lineType === 'fitting') {
	        var _getLinearRegression = (0, _DataUtils.getLinearRegression)(points),
	            xmin = _getLinearRegression.xmin,
	            xmax = _getLinearRegression.xmax,
	            a = _getLinearRegression.a,
	            b = _getLinearRegression.b;
	
	        var linearExp = function linearExp(x) {
	          return a * x + b;
	        };
	
	        linePoints = [{
	          x: xmin,
	          y: linearExp(xmin)
	        }, {
	          x: xmax,
	          y: linearExp(xmax)
	        }];
	      }
	
	      var lineProps = _objectSpread({}, scatterProps, {
	        fill: 'none',
	        stroke: scatterProps && scatterProps.fill
	      }, customLineProps, {
	        points: linePoints
	      });
	
	      if (_react["default"].isValidElement(line)) {
	        lineItem = _react["default"].cloneElement(line, lineProps);
	      } else if ((0, _isFunction2["default"])(line)) {
	        lineItem = line(lineProps);
	      } else {
	        lineItem = _react["default"].createElement(_Curve["default"], _extends({}, lineProps, {
	          type: lineJointType
	        }));
	      }
	
	      return _react["default"].createElement(_Layer["default"], {
	        className: "recharts-scatter-line",
	        key: "recharts-scatter-line"
	      }, lineItem);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props7 = this.props,
	          hide = _this$props7.hide,
	          points = _this$props7.points,
	          line = _this$props7.line,
	          className = _this$props7.className,
	          xAxis = _this$props7.xAxis,
	          yAxis = _this$props7.yAxis,
	          left = _this$props7.left,
	          top = _this$props7.top,
	          width = _this$props7.width,
	          height = _this$props7.height,
	          id = _this$props7.id;
	
	      if (hide || !points || !points.length) {
	        return null;
	      }
	
	      var _this$state = this.state,
	          isAnimationActive = _this$state.isAnimationActive,
	          isAnimationFinished = _this$state.isAnimationFinished;
	      var layerClass = (0, _classnames["default"])('recharts-scatter', className);
	      var needClip = xAxis && xAxis.allowDataOverflow || yAxis && yAxis.allowDataOverflow;
	      var clipPathId = (0, _isNil2["default"])(id) ? this.id : id;
	      return _react["default"].createElement(_Layer["default"], {
	        className: layerClass,
	        clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
	      }, needClip ? _react["default"].createElement("defs", null, _react["default"].createElement("clipPath", {
	        id: "clipPath-".concat(clipPathId)
	      }, _react["default"].createElement("rect", {
	        x: left,
	        y: top,
	        width: width,
	        height: height
	      }))) : null, line && this.renderLine(), this.renderErrorBar(), _react["default"].createElement(_Layer["default"], {
	        key: "recharts-scatter-symbols"
	      }, this.renderSymbols()), (!isAnimationActive || isAnimationFinished) && _LabelList["default"].renderCallByParent(this.props, points));
	    }
	  }], [{
	    key: "renderSymbolItem",
	    value: function renderSymbolItem(option, props) {
	      var symbol;
	
	      if (_react["default"].isValidElement(option)) {
	        symbol = _react["default"].cloneElement(option, props);
	      } else if ((0, _isFunction2["default"])(option)) {
	        symbol = option(props);
	      } else {
	        symbol = _react["default"].createElement(_Symbols["default"], _extends({}, props, {
	          type: option
	        }));
	      }
	
	      return symbol;
	    }
	  }]);
	
	  return Scatter;
	}(_react.PureComponent);
	
	Scatter.displayName = 'Scatter';
	Scatter.propTypes = _objectSpread({}, _ReactUtils.EVENT_ATTRIBUTES, {}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  xAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  yAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  zAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  line: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].object, _propTypes["default"].func, _propTypes["default"].element]),
	  lineType: _propTypes["default"].oneOf(['fitting', 'joint']),
	  lineJointType: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(['basis', 'basisClosed', 'basisOpen', 'linear', 'linearClosed', 'natural', 'monotoneX', 'monotoneY', 'monotone', 'step', 'stepBefore', 'stepAfter']), _propTypes["default"].func]),
	  legendType: _propTypes["default"].oneOf(_ReactUtils.LEGEND_TYPES),
	  tooltipType: _propTypes["default"].oneOf(_ReactUtils.TOOLTIP_TYPES),
	  className: _propTypes["default"].string,
	  name: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  activeIndex: _propTypes["default"].number,
	  activeShape: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].func, _propTypes["default"].element]),
	  shape: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(['circle', 'cross', 'diamond', 'square', 'star', 'triangle', 'wye']), _propTypes["default"].element, _propTypes["default"].func]),
	  points: _propTypes["default"].arrayOf(_propTypes["default"].shape({
	    cx: _propTypes["default"].number,
	    cy: _propTypes["default"].number,
	    size: _propTypes["default"].number,
	    node: _propTypes["default"].shape({
	      x: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	      y: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	      z: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
	    }),
	    payload: _propTypes["default"].any
	  })),
	  hide: _propTypes["default"].bool,
	  isAnimationActive: _propTypes["default"].bool,
	  animationId: _propTypes["default"].number,
	  animationBegin: _propTypes["default"].number,
	  animationDuration: _propTypes["default"].number,
	  animationEasing: _propTypes["default"].oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
	});
	Scatter.defaultProps = {
	  xAxisId: 0,
	  yAxisId: 0,
	  zAxisId: 0,
	  legendType: 'circle',
	  lineType: 'joint',
	  lineJointType: 'linear',
	  data: [],
	  shape: 'circle',
	  hide: false,
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 400,
	  animationEasing: 'linear'
	};
	
	Scatter.getComposedData = function (_ref2) {
	  var xAxis = _ref2.xAxis,
	      yAxis = _ref2.yAxis,
	      zAxis = _ref2.zAxis,
	      item = _ref2.item,
	      displayedData = _ref2.displayedData,
	      onItemMouseLeave = _ref2.onItemMouseLeave,
	      onItemMouseEnter = _ref2.onItemMouseEnter,
	      offset = _ref2.offset,
	      xAxisTicks = _ref2.xAxisTicks,
	      yAxisTicks = _ref2.yAxisTicks;
	  var tooltipType = item.props.tooltipType;
	  var cells = (0, _ReactUtils.findAllByType)(item.props.children, _Cell["default"]);
	  var xAxisDataKey = (0, _isNil2["default"])(xAxis.dataKey) ? item.props.dataKey : xAxis.dataKey;
	  var yAxisDataKey = (0, _isNil2["default"])(yAxis.dataKey) ? item.props.dataKey : yAxis.dataKey;
	  var zAxisDataKey = zAxis && zAxis.dataKey;
	  var defaultRangeZ = zAxis ? zAxis.range : _ZAxis["default"].defaultProps.range;
	  var defaultZ = defaultRangeZ && defaultRangeZ[0];
	  var xBandSize = xAxis.scale.bandwidth ? xAxis.scale.bandwidth() : 0;
	  var yBandSize = yAxis.scale.bandwidth ? yAxis.scale.bandwidth() : 0;
	  var points = displayedData.map(function (entry, index) {
	    var x = entry[xAxisDataKey];
	    var y = entry[yAxisDataKey];
	    var z = !(0, _isNil2["default"])(zAxisDataKey) && entry[zAxisDataKey] || '-';
	    var tooltipPayload = [{
	      name: xAxis.name || xAxis.dataKey,
	      unit: xAxis.unit || '',
	      value: x,
	      payload: entry,
	      dataKey: xAxisDataKey,
	      type: tooltipType
	    }, {
	      name: yAxis.name || yAxis.dataKey,
	      unit: yAxis.unit || '',
	      value: y,
	      payload: entry,
	      dataKey: yAxisDataKey,
	      type: tooltipType
	    }];
	
	    if (z !== '-') {
	      tooltipPayload.push({
	        name: zAxis.name || zAxis.dataKey,
	        unit: zAxis.unit || '',
	        value: z,
	        payload: entry,
	        dataKey: zAxisDataKey,
	        type: tooltipType
	      });
	    }
	
	    var cx = (0, _ChartUtils.getCateCoordinateOfLine)({
	      axis: xAxis,
	      ticks: xAxisTicks,
	      bandSize: xBandSize,
	      entry: entry,
	      index: index,
	      dataKey: xAxisDataKey
	    });
	    var cy = (0, _ChartUtils.getCateCoordinateOfLine)({
	      axis: yAxis,
	      ticks: yAxisTicks,
	      bandSize: yBandSize,
	      entry: entry,
	      index: index,
	      dataKey: yAxisDataKey
	    });
	    var size = z !== '-' ? zAxis.scale(z) : defaultZ;
	    var radius = Math.sqrt(Math.max(size, 0) / Math.PI);
	    return _objectSpread({}, entry, {
	      cx: cx,
	      cy: cy,
	      x: cx - radius,
	      y: cy - radius,
	      xAxis: xAxis,
	      yAxis: yAxis,
	      zAxis: zAxis,
	      width: 2 * radius,
	      height: 2 * radius,
	      size: size,
	      node: {
	        x: x,
	        y: y,
	        z: z
	      },
	      tooltipPayload: tooltipPayload,
	      tooltipPosition: {
	        x: cx,
	        y: cy
	      },
	      payload: entry
	    }, cells && cells[index] && cells[index].props);
	  });
	  return _objectSpread({
	    onMouseLeave: onItemMouseLeave,
	    onMouseEnter: onItemMouseEnter,
	    points: points
	  }, offset);
	};
	
	var _default = Scatter;
	exports["default"] = _default;

/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(38));
	
	var _uniqBy2 = _interopRequireDefault(__webpack_require__(764));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _DefaultLegendContent = _interopRequireDefault(__webpack_require__(2427));
	
	var _DataUtils = __webpack_require__(39);
	
	var _ReactUtils = __webpack_require__(29);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var defaultUniqBy = function defaultUniqBy(entry) {
	  return entry.value;
	};
	
	var getUniqPaylod = function getUniqPaylod(option, payload) {
	  if (option === true) {
	    return (0, _uniqBy2["default"])(payload, defaultUniqBy);
	  }
	
	  if ((0, _isFunction2["default"])(option)) {
	    return (0, _uniqBy2["default"])(payload, option);
	  }
	
	  return payload;
	};
	
	var renderContent = function renderContent(content, props) {
	  if (_react["default"].isValidElement(content)) {
	    return _react["default"].cloneElement(content, props);
	  }
	
	  if ((0, _isFunction2["default"])(content)) {
	    return content(props);
	  }
	
	  return _react["default"].createElement(_DefaultLegendContent["default"], props);
	};
	
	var EPS = 1;
	
	var ICON_TYPES = _ReactUtils.LEGEND_TYPES.filter(function (type) {
	  return type !== 'none';
	});
	
	var Legend =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Legend, _PureComponent);
	
	  function Legend() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Legend);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Legend)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      boxWidth: -1,
	      boxHeight: -1
	    };
	    return _this;
	  }
	
	  _createClass(Legend, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.updateBBox();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      this.updateBBox();
	    }
	  }, {
	    key: "getBBox",
	    value: function getBBox() {
	      var _this$state = this.state,
	          boxWidth = _this$state.boxWidth,
	          boxHeight = _this$state.boxHeight;
	
	      if (boxWidth >= 0 && boxHeight >= 0) {
	        return {
	          width: boxWidth,
	          height: boxHeight
	        };
	      }
	
	      return null;
	    }
	  }, {
	    key: "getDefaultPosition",
	    value: function getDefaultPosition(style) {
	      var _this$props = this.props,
	          layout = _this$props.layout,
	          align = _this$props.align,
	          verticalAlign = _this$props.verticalAlign,
	          margin = _this$props.margin,
	          chartWidth = _this$props.chartWidth,
	          chartHeight = _this$props.chartHeight;
	      var hPos, vPos;
	
	      if (!style || (style.left === undefined || style.left === null) && (style.right === undefined || style.right === null)) {
	        if (align === 'center' && layout === 'vertical') {
	          var box = this.getBBox() || {
	            width: 0
	          };
	          hPos = {
	            left: ((chartWidth || 0) - box.width) / 2
	          };
	        } else {
	          hPos = align === 'right' ? {
	            right: margin && margin.right || 0
	          } : {
	            left: margin && margin.left || 0
	          };
	        }
	      }
	
	      if (!style || (style.top === undefined || style.top === null) && (style.bottom === undefined || style.bottom === null)) {
	        if (verticalAlign === 'middle') {
	          var _box = this.getBBox() || {
	            height: 0
	          };
	
	          vPos = {
	            top: ((chartHeight || 0) - _box.height) / 2
	          };
	        } else {
	          vPos = verticalAlign === 'bottom' ? {
	            bottom: margin && margin.bottom || 0
	          } : {
	            top: margin && margin.top || 0
	          };
	        }
	      }
	
	      return _objectSpread({}, hPos, {}, vPos);
	    }
	  }, {
	    key: "updateBBox",
	    value: function updateBBox() {
	      var _this$state2 = this.state,
	          boxWidth = _this$state2.boxWidth,
	          boxHeight = _this$state2.boxHeight;
	      var onBBoxUpdate = this.props.onBBoxUpdate;
	
	      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
	        var box = this.wrapperNode.getBoundingClientRect();
	
	        if (Math.abs(box.width - boxWidth) > EPS || Math.abs(box.height - boxHeight) > EPS) {
	          this.setState({
	            boxWidth: box.width,
	            boxHeight: box.height
	          }, function () {
	            if (onBBoxUpdate) {
	              onBBoxUpdate(box);
	            }
	          });
	        }
	      } else if (boxWidth !== -1 || boxHeight !== -1) {
	        this.setState({
	          boxWidth: -1,
	          boxHeight: -1
	        }, function () {
	          if (onBBoxUpdate) {
	            onBBoxUpdate(null);
	          }
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _this$props2 = this.props,
	          content = _this$props2.content,
	          width = _this$props2.width,
	          height = _this$props2.height,
	          wrapperStyle = _this$props2.wrapperStyle,
	          paylodUniqBy = _this$props2.paylodUniqBy,
	          payload = _this$props2.payload;
	
	      var outerStyle = _objectSpread({
	        position: 'absolute',
	        width: width || 'auto',
	        height: height || 'auto'
	      }, this.getDefaultPosition(wrapperStyle), {}, wrapperStyle);
	
	      return _react["default"].createElement("div", {
	        className: "recharts-legend-wrapper",
	        style: outerStyle,
	        ref: function ref(node) {
	          _this2.wrapperNode = node;
	        }
	      }, renderContent(content, _objectSpread({}, this.props, {
	        payload: getUniqPaylod(paylodUniqBy, payload)
	      })));
	    }
	  }], [{
	    key: "getWithHeight",
	    value: function getWithHeight(item, chartWidth) {
	      var layout = item.props.layout;
	
	      if (layout === 'vertical' && (0, _DataUtils.isNumber)(item.props.height)) {
	        return {
	          height: item.props.height
	        };
	      }
	
	      if (layout === 'horizontal') {
	        return {
	          width: item.props.width || chartWidth
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return Legend;
	}(_react.PureComponent);
	
	Legend.displayName = 'Legend';
	Legend.propTypes = {
	  content: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].func]),
	  wrapperStyle: _propTypes["default"].object,
	  chartWidth: _propTypes["default"].number,
	  chartHeight: _propTypes["default"].number,
	  width: _propTypes["default"].number,
	  height: _propTypes["default"].number,
	  iconSize: _propTypes["default"].number,
	  iconType: _propTypes["default"].oneOf(ICON_TYPES),
	  layout: _propTypes["default"].oneOf(['horizontal', 'vertical']),
	  align: _propTypes["default"].oneOf(['center', 'left', 'right']),
	  verticalAlign: _propTypes["default"].oneOf(['top', 'bottom', 'middle']),
	  margin: _propTypes["default"].shape({
	    top: _propTypes["default"].number,
	    left: _propTypes["default"].number,
	    bottom: _propTypes["default"].number,
	    right: _propTypes["default"].number
	  }),
	  payload: _propTypes["default"].arrayOf(_propTypes["default"].shape({
	    value: _propTypes["default"].any,
	    id: _propTypes["default"].any,
	    type: _propTypes["default"].oneOf(_ReactUtils.LEGEND_TYPES)
	  })),
	  paylodUniqBy: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].bool]),
	  formatter: _propTypes["default"].func,
	  onMouseEnter: _propTypes["default"].func,
	  onMouseLeave: _propTypes["default"].func,
	  onClick: _propTypes["default"].func,
	  onBBoxUpdate: _propTypes["default"].func
	};
	Legend.defaultProps = {
	  iconSize: 14,
	  layout: 'horizontal',
	  align: 'center',
	  verticalAlign: 'bottom'
	};
	var _default = Legend;
	exports["default"] = _default;

/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _d3Shape = __webpack_require__(382);
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _ReactUtils = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var SYMBOL_FACTORIES = {
	  symbolCircle: _d3Shape.symbolCircle,
	  symbolCross: _d3Shape.symbolCross,
	  symbolDiamond: _d3Shape.symbolDiamond,
	  symbolSquare: _d3Shape.symbolSquare,
	  symbolStar: _d3Shape.symbolStar,
	  symbolTriangle: _d3Shape.symbolTriangle,
	  symbolWye: _d3Shape.symbolWye
	};
	var RADIAN = Math.PI / 180;
	
	var getSymbolFactory = function getSymbolFactory(type) {
	  var name = "symbol".concat(type.slice(0, 1).toUpperCase()).concat(type.slice(1));
	  return SYMBOL_FACTORIES[name] || _d3Shape.symbolCircle;
	};
	
	var calculateAreaSize = function calculateAreaSize(size, sizeType, type) {
	  if (sizeType === 'area') {
	    return size;
	  }
	
	  switch (type) {
	    case 'cross':
	      return 5 * size * size / 9;
	
	    case 'diamond':
	      return 0.5 * size * size / Math.sqrt(3);
	
	    case 'square':
	      return size * size;
	
	    case 'star':
	      {
	        var angle = 18 * RADIAN;
	        return 1.25 * size * size * (Math.tan(angle) - Math.tan(angle * 2) * Math.pow(Math.tan(angle), 2));
	      }
	
	    case 'triangle':
	      return Math.sqrt(3) * size * size / 4;
	
	    case 'wye':
	      return (21 - 10 * Math.sqrt(3)) * size * size / 8;
	
	    default:
	      return Math.PI * size * size / 4;
	  }
	};
	
	var Symbols =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Symbols, _PureComponent);
	
	  function Symbols() {
	    _classCallCheck(this, Symbols);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(Symbols).apply(this, arguments));
	  }
	
	  _createClass(Symbols, [{
	    key: "getPath",
	
	    /**
	     * Calculate the path of curve
	     * @return {String} path
	     */
	    value: function getPath() {
	      var _this$props = this.props,
	          size = _this$props.size,
	          sizeType = _this$props.sizeType,
	          type = _this$props.type;
	      var symbolFactory = getSymbolFactory(type);
	      var symbol = (0, _d3Shape.symbol)().type(symbolFactory).size(calculateAreaSize(size, sizeType, type));
	      return symbol();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          className = _this$props2.className,
	          cx = _this$props2.cx,
	          cy = _this$props2.cy,
	          size = _this$props2.size;
	
	      if (cx === +cx && cy === +cy && size === +size) {
	        return _react["default"].createElement("path", _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), {
	          className: (0, _classnames["default"])('recharts-symbols', className),
	          transform: "translate(".concat(cx, ", ").concat(cy, ")"),
	          d: this.getPath()
	        }));
	      }
	
	      return null;
	    }
	  }]);
	
	  return Symbols;
	}(_react.PureComponent);
	
	Symbols.displayName = 'Symbols';
	Symbols.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  className: _propTypes["default"].string,
	  type: _propTypes["default"].oneOf(['circle', 'cross', 'diamond', 'square', 'star', 'triangle', 'wye']),
	  cx: _propTypes["default"].number,
	  cy: _propTypes["default"].number,
	  size: _propTypes["default"].number,
	  sizeType: _propTypes["default"].oneOf(['area', 'diameter'])
	});
	Symbols.defaultProps = {
	  type: 'circle',
	  size: 64,
	  sizeType: 'area'
	};
	var _default = Symbols;
	exports["default"] = _default;

/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createAction;
	
	var _invariant = __webpack_require__(124);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _isFunction = __webpack_require__(315);
	
	var _isFunction2 = _interopRequireDefault(_isFunction);
	
	var _identity = __webpack_require__(480);
	
	var _identity2 = _interopRequireDefault(_identity);
	
	var _isNull = __webpack_require__(2450);
	
	var _isNull2 = _interopRequireDefault(_isNull);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createAction(type) {
	  var payloadCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _identity2.default;
	  var metaCreator = arguments[2];
	
	  (0, _invariant2.default)((0, _isFunction2.default)(payloadCreator) || (0, _isNull2.default)(payloadCreator), 'Expected payloadCreator to be a function, undefined or null');
	
	  var finalPayloadCreator = (0, _isNull2.default)(payloadCreator) || payloadCreator === _identity2.default ? _identity2.default : function (head) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return head instanceof Error ? head : payloadCreator.apply(undefined, [head].concat(args));
	  };
	
	  var hasMeta = (0, _isFunction2.default)(metaCreator);
	  var typeString = type.toString();
	
	  var actionCreator = function actionCreator() {
	    var payload = finalPayloadCreator.apply(undefined, arguments);
	    var action = { type: type };
	
	    if (payload instanceof Error) {
	      action.error = true;
	    }
	
	    if (payload !== undefined) {
	      action.payload = payload;
	    }
	
	    if (hasMeta) {
	      action.meta = metaCreator.apply(undefined, arguments);
	    }
	
	    return action;
	  };
	
	  actionCreator.toString = function () {
	    return typeString;
	  };
	
	  return actionCreator;
	}

/***/ },
/* 480 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (value) {
	  return value;
	};

/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ownKeys;
	
	var _isMap = __webpack_require__(316);
	
	var _isMap2 = _interopRequireDefault(_isMap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ownKeys(object) {
	  if ((0, _isMap2.default)(object)) {
	    return Array.from(object.keys());
	  }
	
	  if (typeof Reflect !== 'undefined' && typeof Reflect.ownKeys === 'function') {
	    return Reflect.ownKeys(object);
	  }
	
	  var keys = Object.getOwnPropertyNames(object);
	
	  if (typeof Object.getOwnPropertySymbols === 'function') {
	    keys = keys.concat(Object.getOwnPropertySymbols(object));
	  }
	
	  return keys;
	}

/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(1003);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(2456);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(2455);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(2454);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(1002);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(1004);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2['default'])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2['default'];
	exports.combineReducers = _combineReducers2['default'];
	exports.bindActionCreators = _bindActionCreators2['default'];
	exports.applyMiddleware = _applyMiddleware2['default'];
	exports.compose = _compose2['default'];

/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var React = __webpack_require__(1);
	var slate = __webpack_require__(317);
	var getDirection = __webpack_require__(1691);
	var debounce = __webpack_require__(450);
	var throttle = __webpack_require__(761);
	var scrollIntoView = __webpack_require__(2463);
	var isHotkey = __webpack_require__(2037);
	var ReactDOM = __webpack_require__(31);
	
	function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }
	
	var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
	var getDirection__default = /*#__PURE__*/_interopDefaultLegacy(getDirection);
	var debounce__default = /*#__PURE__*/_interopDefaultLegacy(debounce);
	var throttle__default = /*#__PURE__*/_interopDefaultLegacy(throttle);
	var scrollIntoView__default = /*#__PURE__*/_interopDefaultLegacy(scrollIntoView);
	var ReactDOM__default = /*#__PURE__*/_interopDefaultLegacy(ReactDOM);
	
	function unwrapExports (x) {
		return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
	}
	
	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}
	
	var defineProperty = createCommonjsModule(function (module) {
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	module.exports = _defineProperty;
	module.exports["default"] = module.exports, module.exports.__esModule = true;
	});
	
	var _defineProperty = unwrapExports(defineProperty);
	
	var arrayLikeToArray = createCommonjsModule(function (module) {
	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;
	
	  for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }
	
	  return arr2;
	}
	
	module.exports = _arrayLikeToArray;
	module.exports["default"] = module.exports, module.exports.__esModule = true;
	});
	
	unwrapExports(arrayLikeToArray);
	
	var arrayWithoutHoles = createCommonjsModule(function (module) {
	function _arrayWithoutHoles(arr) {
	  if (Array.isArray(arr)) return arrayLikeToArray(arr);
	}
	
	module.exports = _arrayWithoutHoles;
	module.exports["default"] = module.exports, module.exports.__esModule = true;
	});
	
	unwrapExports(arrayWithoutHoles);
	
	var iterableToArray = createCommonjsModule(function (module) {
	function _iterableToArray(iter) {
	  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
	}
	
	module.exports = _iterableToArray;
	module.exports["default"] = module.exports, module.exports.__esModule = true;
	});
	
	unwrapExports(iterableToArray);
	
	var unsupportedIterableToArray = createCommonjsModule(function (module) {
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;
	  if (typeof o === "string") return arrayLikeToArray(o, minLen);
	  var n = Object.prototype.toString.call(o).slice(8, -1);
	  if (n === "Object" && o.constructor) n = o.constructor.name;
	  if (n === "Map" || n === "Set") return Array.from(o);
	  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
	}
	
	module.exports = _unsupportedIterableToArray;
	module.exports["default"] = module.exports, module.exports.__esModule = true;
	});
	
	unwrapExports(unsupportedIterableToArray);
	
	var nonIterableSpread = createCommonjsModule(function (module) {
	function _nonIterableSpread() {
	  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	
	module.exports = _nonIterableSpread;
	module.exports["default"] = module.exports, module.exports.__esModule = true;
	});
	
	unwrapExports(nonIterableSpread);
	
	var toConsumableArray = createCommonjsModule(function (module) {
	function _toConsumableArray(arr) {
	  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
	}
	
	module.exports = _toConsumableArray;
	module.exports["default"] = module.exports, module.exports.__esModule = true;
	});
	
	var _toConsumableArray = unwrapExports(toConsumableArray);
	
	var arrayWithHoles = createCommonjsModule(function (module) {
	function _arrayWithHoles(arr) {
	  if (Array.isArray(arr)) return arr;
	}
	
	module.exports = _arrayWithHoles;
	module.exports["default"] = module.exports, module.exports.__esModule = true;
	});
	
	unwrapExports(arrayWithHoles);
	
	var iterableToArrayLimit = createCommonjsModule(function (module) {
	function _iterableToArrayLimit(arr, i) {
	  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
	
	  if (_i == null) return;
	  var _arr = [];
	  var _n = true;
	  var _d = false;
	
	  var _s, _e;
	
	  try {
	    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
	      _arr.push(_s.value);
	
	      if (i && _arr.length === i) break;
	    }
	  } catch (err) {
	    _d = true;
	    _e = err;
	  } finally {
	    try {
	      if (!_n && _i["return"] != null) _i["return"]();
	    } finally {
	      if (_d) throw _e;
	    }
	  }
	
	  return _arr;
	}
	
	module.exports = _iterableToArrayLimit;
	module.exports["default"] = module.exports, module.exports.__esModule = true;
	});
	
	unwrapExports(iterableToArrayLimit);
	
	var nonIterableRest = createCommonjsModule(function (module) {
	function _nonIterableRest() {
	  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	
	module.exports = _nonIterableRest;
	module.exports["default"] = module.exports, module.exports.__esModule = true;
	});
	
	unwrapExports(nonIterableRest);
	
	var slicedToArray = createCommonjsModule(function (module) {
	function _slicedToArray(arr, i) {
	  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
	}
	
	module.exports = _slicedToArray;
	module.exports["default"] = module.exports, module.exports.__esModule = true;
	});
	
	var _slicedToArray = unwrapExports(slicedToArray);
	
	var objectWithoutPropertiesLoose = createCommonjsModule(function (module) {
	function _objectWithoutPropertiesLoose(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  return target;
	}
	
	module.exports = _objectWithoutPropertiesLoose;
	module.exports["default"] = module.exports, module.exports.__esModule = true;
	});
	
	unwrapExports(objectWithoutPropertiesLoose);
	
	var objectWithoutProperties = createCommonjsModule(function (module) {
	function _objectWithoutProperties(source, excluded) {
	  if (source == null) return {};
	  var target = objectWithoutPropertiesLoose(source, excluded);
	  var key, i;
	
	  if (Object.getOwnPropertySymbols) {
	    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
	
	    for (i = 0; i < sourceSymbolKeys.length; i++) {
	      key = sourceSymbolKeys[i];
	      if (excluded.indexOf(key) >= 0) continue;
	      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
	      target[key] = source[key];
	    }
	  }
	
	  return target;
	}
	
	module.exports = _objectWithoutProperties;
	module.exports["default"] = module.exports, module.exports.__esModule = true;
	});
	
	var _objectWithoutProperties = unwrapExports(objectWithoutProperties);
	
	var IS_REACT_VERSION_17_OR_ABOVE = parseInt(React__default['default'].version.split('.')[0], 10) >= 17;
	var IS_IOS = typeof navigator !== 'undefined' && typeof window !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
	var IS_APPLE = typeof navigator !== 'undefined' && /Mac OS X/.test(navigator.userAgent);
	var IS_ANDROID = typeof navigator !== 'undefined' && /Android/.test(navigator.userAgent);
	var IS_FIREFOX = typeof navigator !== 'undefined' && /^(?!.*Seamonkey)(?=.*Firefox).*/i.test(navigator.userAgent);
	var IS_SAFARI = typeof navigator !== 'undefined' && /Version\/[\d\.]+.*Safari/.test(navigator.userAgent); // "modern" Edge was released at 79.x
	
	var IS_EDGE_LEGACY = typeof navigator !== 'undefined' && /Edge?\/(?:[0-6][0-9]|[0-7][0-8])(?:\.)/i.test(navigator.userAgent);
	var IS_CHROME = typeof navigator !== 'undefined' && /Chrome/i.test(navigator.userAgent); // Native `beforeInput` events don't work well with react on Chrome 75
	// and older, Chrome 76+ can use `beforeInput` though.
	
	var IS_CHROME_LEGACY = typeof navigator !== 'undefined' && /Chrome?\/(?:[0-7][0-5]|[0-6][0-9])(?:\.)/i.test(navigator.userAgent); // Firefox did not support `beforeInput` until `v87`.
	
	var IS_FIREFOX_LEGACY = typeof navigator !== 'undefined' && /^(?!.*Seamonkey)(?=.*Firefox\/(?:[0-7][0-9]|[0-8][0-6])(?:\.)).*/i.test(navigator.userAgent); // qq browser
	
	var IS_QQBROWSER = typeof navigator !== 'undefined' && /.*QQBrowser/.test(navigator.userAgent); // UC mobile browser
	
	var IS_UC_MOBILE = typeof navigator !== 'undefined' && /.*UCBrowser/.test(navigator.userAgent); // Wechat browser
	
	var IS_WECHATBROWSER = typeof navigator !== 'undefined' && /.*Wechat/.test(navigator.userAgent); // Check if DOM is available as React does internally.
	// https://github.com/facebook/react/blob/master/packages/shared/ExecutionEnvironment.js
	
	var CAN_USE_DOM = !!(typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined'); // COMPAT: Firefox/Edge Legacy don't support the `beforeinput` event
	// Chrome Legacy doesn't support `beforeinput` correctly
	
	var HAS_BEFORE_INPUT_SUPPORT = !IS_CHROME_LEGACY && !IS_EDGE_LEGACY && // globalThis is undefined in older browsers
	typeof globalThis !== 'undefined' && globalThis.InputEvent && // @ts-ignore The `getTargetRanges` property isn't recognized.
	typeof globalThis.InputEvent.prototype.getTargetRanges === 'function';
	
	/**
	 * Prevent warning on SSR by falling back to useEffect when DOM isn't available
	 */
	
	var useIsomorphicLayoutEffect = CAN_USE_DOM ? React.useLayoutEffect : React.useEffect;
	
	/**
	 * Leaf content strings.
	 */
	
	var String = function String(props) {
	  var isLast = props.isLast,
	      leaf = props.leaf,
	      parent = props.parent,
	      text = props.text;
	  var editor = useSlateStatic();
	  var path = ReactEditor.findPath(editor, text);
	  var parentPath = slate.Path.parent(path); // COMPAT: Render text inside void nodes with a zero-width space.
	  // So the node can contain selection but the text is not visible.
	
	  if (editor.isVoid(parent)) {
	    return /*#__PURE__*/React__default['default'].createElement(ZeroWidthString, {
	      length: slate.Node.string(parent).length
	    });
	  } // COMPAT: If this is the last text node in an empty block, render a zero-
	  // width space that will convert into a line break when copying and pasting
	  // to support expected plain text.
	
	
	  if (leaf.text === '' && parent.children[parent.children.length - 1] === text && !editor.isInline(parent) && slate.Editor.string(editor, parentPath) === '') {
	    return /*#__PURE__*/React__default['default'].createElement(ZeroWidthString, {
	      isLineBreak: true
	    });
	  } // COMPAT: If the text is empty, it's because it's on the edge of an inline
	  // node, so we render a zero-width space so that the selection can be
	  // inserted next to it still.
	
	
	  if (leaf.text === '') {
	    return /*#__PURE__*/React__default['default'].createElement(ZeroWidthString, null);
	  } // COMPAT: Browsers will collapse trailing new lines at the end of blocks,
	  // so we need to add an extra trailing new lines to prevent that.
	
	
	  if (isLast && leaf.text.slice(-1) === '\n') {
	    return /*#__PURE__*/React__default['default'].createElement(TextString, {
	      isTrailing: true,
	      text: leaf.text
	    });
	  }
	
	  return /*#__PURE__*/React__default['default'].createElement(TextString, {
	    text: leaf.text
	  });
	};
	/**
	 * Leaf strings with text in them.
	 */
	
	
	var TextString = function TextString(props) {
	  var text = props.text,
	      _props$isTrailing = props.isTrailing,
	      isTrailing = _props$isTrailing === void 0 ? false : _props$isTrailing;
	  var ref = React.useRef(null);
	
	  var getTextContent = function getTextContent() {
	    return "".concat(text !== null && text !== void 0 ? text : '').concat(isTrailing ? '\n' : '');
	  }; // This is the actual text rendering boundary where we interface with the DOM
	  // The text is not rendered as part of the virtual DOM, as since we handle basic character insertions natively,
	  // updating the DOM is not a one way dataflow anymore. What we need here is not reconciliation and diffing
	  // with previous version of the virtual DOM, but rather diffing with the actual DOM element, and replace the DOM <span> content
	  // exactly if and only if its current content does not match our current virtual DOM.
	  // Otherwise the DOM TextNode would always be replaced by React as the user types, which interferes with native text features,
	  // eg makes native spellcheck opt out from checking the text node.
	  // useLayoutEffect: updating our span before browser paint
	
	
	  useIsomorphicLayoutEffect(function () {
	    // null coalescing text to make sure we're not outputing "null" as a string in the extreme case it is nullish at runtime
	    var textWithTrailing = getTextContent();
	
	    if (ref.current && ref.current.textContent !== textWithTrailing) {
	      ref.current.textContent = textWithTrailing;
	    } // intentionally not specifying dependencies, so that this effect runs on every render
	    // as this effectively replaces "specifying the text in the virtual DOM under the <span> below" on each render
	
	  }); // Render text content immediately if it's the first-time render
	  // Ensure that text content is rendered on server-side rendering
	
	  if (!ref.current) {
	    return /*#__PURE__*/React__default['default'].createElement("span", {
	      "data-slate-string": true,
	      ref: ref
	    }, getTextContent());
	  } // the span is intentionally same on every render in virtual DOM, actual rendering happens in the layout effect above
	
	
	  return /*#__PURE__*/React__default['default'].createElement("span", {
	    "data-slate-string": true,
	    ref: ref
	  });
	};
	/**
	 * Leaf strings without text, render as zero-width strings.
	 */
	
	
	var ZeroWidthString = function ZeroWidthString(props) {
	  var _props$length = props.length,
	      length = _props$length === void 0 ? 0 : _props$length,
	      _props$isLineBreak = props.isLineBreak,
	      isLineBreak = _props$isLineBreak === void 0 ? false : _props$isLineBreak;
	  return /*#__PURE__*/React__default['default'].createElement("span", {
	    "data-slate-zero-width": isLineBreak ? 'n' : 'z',
	    "data-slate-length": length
	  }, "\uFEFF", isLineBreak ? /*#__PURE__*/React__default['default'].createElement("br", null) : null);
	};
	
	/**
	 * Two weak maps that allow us rebuild a path given a node. They are populated
	 * at render time such that after a render occurs we can always backtrack.
	 */
	var NODE_TO_INDEX = new WeakMap();
	var NODE_TO_PARENT = new WeakMap();
	/**
	 * Weak maps that allow us to go between Slate nodes and DOM nodes. These
	 * are used to resolve DOM event-related logic into Slate actions.
	 */
	
	var EDITOR_TO_WINDOW = new WeakMap();
	var EDITOR_TO_ELEMENT = new WeakMap();
	var ELEMENT_TO_NODE = new WeakMap();
	var NODE_TO_ELEMENT = new WeakMap();
	var NODE_TO_KEY = new WeakMap();
	var EDITOR_TO_KEY_TO_ELEMENT = new WeakMap();
	/**
	 * Weak maps for storing editor-related state.
	 */
	
	var IS_READ_ONLY = new WeakMap();
	var IS_FOCUSED = new WeakMap();
	var IS_COMPOSING = new WeakMap();
	var IS_ON_COMPOSITION_END = new WeakMap();
	var EDITOR_TO_USER_SELECTION = new WeakMap();
	/**
	 * Weak maps for saving text on composition stage.
	 */
	
	var EDITOR_ON_COMPOSITION_TEXT = new WeakMap();
	/**
	 * Weak map for associating the context `onChange` context with the plugin.
	 */
	
	var EDITOR_TO_ON_CHANGE = new WeakMap();
	var NODE_TO_RESTORE_DOM = new WeakMap();
	/**
	 * Symbols.
	 */
	
	var PLACEHOLDER_SYMBOL = Symbol('placeholder');
	
	/**
	 * Individual leaves in a text node with unique formatting.
	 */
	
	var Leaf = function Leaf(props) {
	  var leaf = props.leaf,
	      isLast = props.isLast,
	      text = props.text,
	      parent = props.parent,
	      renderPlaceholder = props.renderPlaceholder,
	      _props$renderLeaf = props.renderLeaf,
	      renderLeaf = _props$renderLeaf === void 0 ? function (props) {
	    return /*#__PURE__*/React__default['default'].createElement(DefaultLeaf, Object.assign({}, props));
	  } : _props$renderLeaf;
	  var placeholderRef = React.useRef(null);
	  React.useEffect(function () {
	    var placeholderEl = placeholderRef === null || placeholderRef === void 0 ? void 0 : placeholderRef.current;
	    var editorEl = document.querySelector('[data-slate-editor="true"]');
	
	    if (!placeholderEl || !editorEl) {
	      return;
	    }
	
	    editorEl.style.minHeight = "".concat(placeholderEl.clientHeight, "px");
	    return function () {
	      editorEl.style.minHeight = 'auto';
	    };
	  }, [placeholderRef, leaf]);
	  var children = /*#__PURE__*/React__default['default'].createElement(String, {
	    isLast: isLast,
	    leaf: leaf,
	    parent: parent,
	    text: text
	  });
	
	  if (leaf[PLACEHOLDER_SYMBOL]) {
	    var placeholderProps = {
	      children: leaf.placeholder,
	      attributes: {
	        'data-slate-placeholder': true,
	        style: {
	          position: 'absolute',
	          pointerEvents: 'none',
	          width: '100%',
	          maxWidth: '100%',
	          display: 'block',
	          opacity: '0.333',
	          userSelect: 'none',
	          textDecoration: 'none'
	        },
	        contentEditable: false,
	        ref: placeholderRef
	      }
	    };
	    children = /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, renderPlaceholder(placeholderProps), children);
	  } // COMPAT: Having the `data-` attributes on these leaf elements ensures that
	  // in certain misbehaving browsers they aren't weirdly cloned/destroyed by
	  // contenteditable behaviors. (2019/05/08)
	
	
	  var attributes = {
	    'data-slate-leaf': true
	  };
	  return renderLeaf({
	    attributes: attributes,
	    children: children,
	    leaf: leaf,
	    text: text
	  });
	};
	
	var MemoizedLeaf = /*#__PURE__*/React__default['default'].memo(Leaf, function (prev, next) {
	  return next.parent === prev.parent && next.isLast === prev.isLast && next.renderLeaf === prev.renderLeaf && next.renderPlaceholder === prev.renderPlaceholder && next.text === prev.text && slate.Text.equals(next.leaf, prev.leaf) && next.leaf[PLACEHOLDER_SYMBOL] === prev.leaf[PLACEHOLDER_SYMBOL];
	});
	var DefaultLeaf = function DefaultLeaf(props) {
	  var attributes = props.attributes,
	      children = props.children;
	  return /*#__PURE__*/React__default['default'].createElement("span", Object.assign({}, attributes), children);
	};
	
	var _excluded$3 = ["anchor", "focus"],
	    _excluded2 = ["anchor", "focus"];
	var shallowCompare = function shallowCompare(obj1, obj2) {
	  return Object.keys(obj1).length === Object.keys(obj2).length && Object.keys(obj1).every(function (key) {
	    return obj2.hasOwnProperty(key) && obj1[key] === obj2[key];
	  });
	};
	/**
	 * Check if a list of decorator ranges are equal to another.
	 *
	 * PERF: this requires the two lists to also have the ranges inside them in the
	 * same order, but this is an okay constraint for us since decorations are
	 * kept in order, and the odd case where they aren't is okay to re-render for.
	 */
	
	var isDecoratorRangeListEqual = function isDecoratorRangeListEqual(list, another) {
	  if (list.length !== another.length) {
	    return false;
	  }
	
	  for (var i = 0; i < list.length; i++) {
	    var range = list[i];
	    var other = another[i];
	
	    range.anchor;
	        range.focus;
	        var rangeOwnProps = _objectWithoutProperties(range, _excluded$3);
	
	    other.anchor;
	        other.focus;
	        var otherOwnProps = _objectWithoutProperties(other, _excluded2);
	
	    if (!slate.Range.equals(range, other) || range[PLACEHOLDER_SYMBOL] !== other[PLACEHOLDER_SYMBOL] || !shallowCompare(rangeOwnProps, otherOwnProps)) {
	      return false;
	    }
	  }
	
	  return true;
	};
	
	function useContentKey(node) {
	  var contentKeyRef = React.useRef(0);
	  var updateAnimationFrameRef = React.useRef(null);
	
	  var _useState = React.useState(0),
	      _useState2 = _slicedToArray(_useState, 2),
	      setForceRerenderCounter = _useState2[1];
	
	  React.useEffect(function () {
	    NODE_TO_RESTORE_DOM.set(node, function () {
	      // Update is already queued and node hasn't re-render yet
	      if (updateAnimationFrameRef.current) {
	        return;
	      }
	
	      updateAnimationFrameRef.current = requestAnimationFrame(function () {
	        setForceRerenderCounter(function (state) {
	          return state + 1;
	        });
	        updateAnimationFrameRef.current = null;
	      });
	      contentKeyRef.current++;
	    });
	    return function () {
	      NODE_TO_RESTORE_DOM["delete"](node);
	    };
	  }, [node]); // Node was restored => clear scheduled update
	
	  if (updateAnimationFrameRef.current) {
	    cancelAnimationFrame(updateAnimationFrameRef.current);
	    updateAnimationFrameRef.current = null;
	  }
	
	  return contentKeyRef.current;
	}
	
	/**
	 * Text.
	 */
	
	var Text = function Text(props) {
	  var decorations = props.decorations,
	      isLast = props.isLast,
	      parent = props.parent,
	      renderPlaceholder = props.renderPlaceholder,
	      renderLeaf = props.renderLeaf,
	      text = props.text;
	  var editor = useSlateStatic();
	  var ref = React.useRef(null);
	  var leaves = slate.Text.decorations(text, decorations);
	  var key = ReactEditor.findKey(editor, text);
	  var children = [];
	
	  for (var i = 0; i < leaves.length; i++) {
	    var leaf = leaves[i];
	    children.push( /*#__PURE__*/React__default['default'].createElement(MemoizedLeaf, {
	      isLast: isLast && i === leaves.length - 1,
	      key: "".concat(key.id, "-").concat(i),
	      renderPlaceholder: renderPlaceholder,
	      leaf: leaf,
	      text: text,
	      parent: parent,
	      renderLeaf: renderLeaf
	    }));
	  } // Update element-related weak maps with the DOM element ref.
	
	
	  useIsomorphicLayoutEffect(function () {
	    var KEY_TO_ELEMENT = EDITOR_TO_KEY_TO_ELEMENT.get(editor);
	
	    if (ref.current) {
	      KEY_TO_ELEMENT === null || KEY_TO_ELEMENT === void 0 ? void 0 : KEY_TO_ELEMENT.set(key, ref.current);
	      NODE_TO_ELEMENT.set(text, ref.current);
	      ELEMENT_TO_NODE.set(ref.current, text);
	    } else {
	      KEY_TO_ELEMENT === null || KEY_TO_ELEMENT === void 0 ? void 0 : KEY_TO_ELEMENT["delete"](key);
	      NODE_TO_ELEMENT["delete"](text);
	    }
	  });
	  var contentKey = IS_ANDROID ? useContentKey(text) : undefined;
	  return /*#__PURE__*/React__default['default'].createElement("span", {
	    "data-slate-node": "text",
	    ref: ref,
	    key: contentKey
	  }, children);
	};
	
	var MemoizedText = /*#__PURE__*/React__default['default'].memo(Text, function (prev, next) {
	  return next.parent === prev.parent && next.isLast === prev.isLast && next.renderLeaf === prev.renderLeaf && next.text === prev.text && isDecoratorRangeListEqual(next.decorations, prev.decorations);
	});
	
	/**
	 * Element.
	 */
	
	var Element = function Element(props) {
	  var decorations = props.decorations,
	      element = props.element,
	      _props$renderElement = props.renderElement,
	      renderElement = _props$renderElement === void 0 ? function (p) {
	    return /*#__PURE__*/React__default['default'].createElement(DefaultElement, Object.assign({}, p));
	  } : _props$renderElement,
	      renderPlaceholder = props.renderPlaceholder,
	      renderLeaf = props.renderLeaf,
	      selection = props.selection;
	  var ref = React.useRef(null);
	  var editor = useSlateStatic();
	  var readOnly = useReadOnly();
	  var isInline = editor.isInline(element);
	  var key = ReactEditor.findKey(editor, element);
	  var children = useChildren({
	    decorations: decorations,
	    node: element,
	    renderElement: renderElement,
	    renderPlaceholder: renderPlaceholder,
	    renderLeaf: renderLeaf,
	    selection: selection
	  }); // Attributes that the developer must mix into the element in their
	  // custom node renderer component.
	
	  var attributes = {
	    'data-slate-node': 'element',
	    ref: ref
	  };
	
	  if (isInline) {
	    attributes['data-slate-inline'] = true;
	  } // If it's a block node with inline children, add the proper `dir` attribute
	  // for text direction.
	
	
	  if (!isInline && slate.Editor.hasInlines(editor, element)) {
	    var text = slate.Node.string(element);
	    var dir = getDirection__default['default'](text);
	
	    if (dir === 'rtl') {
	      attributes.dir = dir;
	    }
	  } // If it's a void node, wrap the children in extra void-specific elements.
	
	
	  if (slate.Editor.isVoid(editor, element)) {
	    attributes['data-slate-void'] = true;
	
	    if (!readOnly && isInline) {
	      attributes.contentEditable = false;
	    }
	
	    var Tag = isInline ? 'span' : 'div';
	
	    var _Node$texts = slate.Node.texts(element),
	        _Node$texts2 = _slicedToArray(_Node$texts, 1),
	        _Node$texts2$ = _slicedToArray(_Node$texts2[0], 1),
	        _text = _Node$texts2$[0];
	
	    children = /*#__PURE__*/React__default['default'].createElement(Tag, {
	      "data-slate-spacer": true,
	      style: {
	        height: '0',
	        color: 'transparent',
	        outline: 'none',
	        position: 'absolute'
	      }
	    }, /*#__PURE__*/React__default['default'].createElement(MemoizedText, {
	      renderPlaceholder: renderPlaceholder,
	      decorations: [],
	      isLast: false,
	      parent: element,
	      text: _text
	    }));
	    NODE_TO_INDEX.set(_text, 0);
	    NODE_TO_PARENT.set(_text, element);
	  } // Update element-related weak maps with the DOM element ref.
	
	
	  useIsomorphicLayoutEffect(function () {
	    var KEY_TO_ELEMENT = EDITOR_TO_KEY_TO_ELEMENT.get(editor);
	
	    if (ref.current) {
	      KEY_TO_ELEMENT === null || KEY_TO_ELEMENT === void 0 ? void 0 : KEY_TO_ELEMENT.set(key, ref.current);
	      NODE_TO_ELEMENT.set(element, ref.current);
	      ELEMENT_TO_NODE.set(ref.current, element);
	    } else {
	      KEY_TO_ELEMENT === null || KEY_TO_ELEMENT === void 0 ? void 0 : KEY_TO_ELEMENT["delete"](key);
	      NODE_TO_ELEMENT["delete"](element);
	    }
	  });
	  var content = renderElement({
	    attributes: attributes,
	    children: children,
	    element: element
	  });
	
	  if (IS_ANDROID) {
	    var contentKey = useContentKey(element);
	    return /*#__PURE__*/React__default['default'].createElement(React.Fragment, {
	      key: contentKey
	    }, content);
	  }
	
	  return content;
	};
	
	var MemoizedElement = /*#__PURE__*/React__default['default'].memo(Element, function (prev, next) {
	  return prev.element === next.element && prev.renderElement === next.renderElement && prev.renderLeaf === next.renderLeaf && isDecoratorRangeListEqual(prev.decorations, next.decorations) && (prev.selection === next.selection || !!prev.selection && !!next.selection && slate.Range.equals(prev.selection, next.selection));
	});
	/**
	 * The default element renderer.
	 */
	
	var DefaultElement = function DefaultElement(props) {
	  var attributes = props.attributes,
	      children = props.children,
	      element = props.element;
	  var editor = useSlateStatic();
	  var Tag = editor.isInline(element) ? 'span' : 'div';
	  return /*#__PURE__*/React__default['default'].createElement(Tag, Object.assign({}, attributes, {
	    style: {
	      position: 'relative'
	    }
	  }), children);
	};
	
	/**
	 * A React context for sharing the editor object.
	 */
	
	var EditorContext = /*#__PURE__*/React.createContext(null);
	/**
	 * Get the current editor object from the React context.
	 */
	
	var useSlateStatic = function useSlateStatic() {
	  var editor = React.useContext(EditorContext);
	
	  if (!editor) {
	    throw new Error("The `useSlateStatic` hook must be used inside the <Slate> component's context.");
	  }
	
	  return editor;
	};
	
	/**
	 * A React context for sharing the `selected` state of an element.
	 */
	
	var SelectedContext = /*#__PURE__*/React.createContext(false);
	/**
	 * Get the current `selected` state of an element.
	 */
	
	var useSelected = function useSelected() {
	  return React.useContext(SelectedContext);
	};
	
	/**
	 * Children.
	 */
	
	var useChildren = function useChildren(props) {
	  var decorations = props.decorations,
	      node = props.node,
	      renderElement = props.renderElement,
	      renderPlaceholder = props.renderPlaceholder,
	      renderLeaf = props.renderLeaf,
	      selection = props.selection;
	  var editor = useSlateStatic();
	  var path = ReactEditor.findPath(editor, node);
	  var children = [];
	  var isLeafBlock = slate.Element.isElement(node) && !editor.isInline(node) && slate.Editor.hasInlines(editor, node);
	
	  var _loop = function _loop(i) {
	    var p = path.concat(i);
	    var n = node.children[i];
	    var key = ReactEditor.findKey(editor, n);
	    var range = slate.Editor.range(editor, p);
	    var sel = selection && slate.Range.intersection(range, selection);
	    var ds = decorations.reduce(function (acc, dec) {
	      var intersection = slate.Range.intersection(dec, range);
	      if (intersection) acc.push(intersection);
	      return acc;
	    }, []);
	
	    if (slate.Element.isElement(n)) {
	      children.push( /*#__PURE__*/React__default['default'].createElement(SelectedContext.Provider, {
	        key: "provider-".concat(key.id),
	        value: !!sel
	      }, /*#__PURE__*/React__default['default'].createElement(MemoizedElement, {
	        decorations: ds,
	        element: n,
	        key: key.id,
	        renderElement: renderElement,
	        renderPlaceholder: renderPlaceholder,
	        renderLeaf: renderLeaf,
	        selection: sel
	      })));
	    } else {
	      children.push( /*#__PURE__*/React__default['default'].createElement(MemoizedText, {
	        decorations: ds,
	        key: key.id,
	        isLast: isLeafBlock && i === node.children.length - 1,
	        parent: node,
	        renderPlaceholder: renderPlaceholder,
	        renderLeaf: renderLeaf,
	        text: n
	      }));
	    }
	
	    NODE_TO_INDEX.set(n, i);
	    NODE_TO_PARENT.set(n, node);
	  };
	
	  for (var i = 0; i < node.children.length; i++) {
	    _loop(i);
	  }
	
	  return children;
	};
	
	/**
	 * Hotkey mappings for each platform.
	 */
	
	var HOTKEYS = {
	  bold: 'mod+b',
	  compose: ['down', 'left', 'right', 'up', 'backspace', 'enter'],
	  moveBackward: 'left',
	  moveForward: 'right',
	  moveWordBackward: 'ctrl+left',
	  moveWordForward: 'ctrl+right',
	  deleteBackward: 'shift?+backspace',
	  deleteForward: 'shift?+delete',
	  extendBackward: 'shift+left',
	  extendForward: 'shift+right',
	  italic: 'mod+i',
	  insertSoftBreak: 'shift+enter',
	  splitBlock: 'enter',
	  undo: 'mod+z'
	};
	var APPLE_HOTKEYS = {
	  moveLineBackward: 'opt+up',
	  moveLineForward: 'opt+down',
	  moveWordBackward: 'opt+left',
	  moveWordForward: 'opt+right',
	  deleteBackward: ['ctrl+backspace', 'ctrl+h'],
	  deleteForward: ['ctrl+delete', 'ctrl+d'],
	  deleteLineBackward: 'cmd+shift?+backspace',
	  deleteLineForward: ['cmd+shift?+delete', 'ctrl+k'],
	  deleteWordBackward: 'opt+shift?+backspace',
	  deleteWordForward: 'opt+shift?+delete',
	  extendLineBackward: 'opt+shift+up',
	  extendLineForward: 'opt+shift+down',
	  redo: 'cmd+shift+z',
	  transposeCharacter: 'ctrl+t'
	};
	var WINDOWS_HOTKEYS = {
	  deleteWordBackward: 'ctrl+shift?+backspace',
	  deleteWordForward: 'ctrl+shift?+delete',
	  redo: ['ctrl+y', 'ctrl+shift+z']
	};
	/**
	 * Create a platform-aware hotkey checker.
	 */
	
	var create = function create(key) {
	  var generic = HOTKEYS[key];
	  var apple = APPLE_HOTKEYS[key];
	  var windows = WINDOWS_HOTKEYS[key];
	  var isGeneric = generic && isHotkey.isKeyHotkey(generic);
	  var isApple = apple && isHotkey.isKeyHotkey(apple);
	  var isWindows = windows && isHotkey.isKeyHotkey(windows);
	  return function (event) {
	    if (isGeneric && isGeneric(event)) return true;
	    if (IS_APPLE && isApple && isApple(event)) return true;
	    if (!IS_APPLE && isWindows && isWindows(event)) return true;
	    return false;
	  };
	};
	/**
	 * Hotkeys.
	 */
	
	
	var Hotkeys = {
	  isBold: create('bold'),
	  isCompose: create('compose'),
	  isMoveBackward: create('moveBackward'),
	  isMoveForward: create('moveForward'),
	  isDeleteBackward: create('deleteBackward'),
	  isDeleteForward: create('deleteForward'),
	  isDeleteLineBackward: create('deleteLineBackward'),
	  isDeleteLineForward: create('deleteLineForward'),
	  isDeleteWordBackward: create('deleteWordBackward'),
	  isDeleteWordForward: create('deleteWordForward'),
	  isExtendBackward: create('extendBackward'),
	  isExtendForward: create('extendForward'),
	  isExtendLineBackward: create('extendLineBackward'),
	  isExtendLineForward: create('extendLineForward'),
	  isItalic: create('italic'),
	  isMoveLineBackward: create('moveLineBackward'),
	  isMoveLineForward: create('moveLineForward'),
	  isMoveWordBackward: create('moveWordBackward'),
	  isMoveWordForward: create('moveWordForward'),
	  isRedo: create('redo'),
	  isSoftBreak: create('insertSoftBreak'),
	  isSplitBlock: create('splitBlock'),
	  isTransposeCharacter: create('transposeCharacter'),
	  isUndo: create('undo')
	};
	
	/**
	 * A React context for sharing the `readOnly` state of the editor.
	 */
	
	var ReadOnlyContext = /*#__PURE__*/React.createContext(false);
	/**
	 * Get the current `readOnly` state of the editor.
	 */
	
	var useReadOnly = function useReadOnly() {
	  return React.useContext(ReadOnlyContext);
	};
	
	/**
	 * A React context for sharing the editor object, in a way that re-renders the
	 * context whenever changes occur.
	 */
	
	var SlateContext = /*#__PURE__*/React.createContext(null);
	/**
	 * Get the current editor object from the React context.
	 */
	
	var useSlate = function useSlate() {
	  var context = React.useContext(SlateContext);
	
	  if (!context) {
	    throw new Error("The `useSlate` hook must be used inside the <Slate> component's context.");
	  }
	
	  var _context = _slicedToArray(context, 1),
	      editor = _context[0];
	
	  return editor;
	};
	
	/**
	 * A React context for sharing the `decorate` prop of the editable.
	 */
	
	var DecorateContext = /*#__PURE__*/React.createContext(function () {
	  return [];
	});
	
	/**
	 * Returns the host window of a DOM node
	 */
	
	var getDefaultView = function getDefaultView(value) {
	  return value && value.ownerDocument && value.ownerDocument.defaultView || null;
	};
	/**
	 * Check if a DOM node is a comment node.
	 */
	
	var isDOMComment = function isDOMComment(value) {
	  return isDOMNode(value) && value.nodeType === 8;
	};
	/**
	 * Check if a DOM node is an element node.
	 */
	
	var isDOMElement = function isDOMElement(value) {
	  return isDOMNode(value) && value.nodeType === 1;
	};
	/**
	 * Check if a value is a DOM node.
	 */
	
	var isDOMNode = function isDOMNode(value) {
	  var window = getDefaultView(value);
	  return !!window && value instanceof window.Node;
	};
	/**
	 * Check if a value is a DOM selection.
	 */
	
	var isDOMSelection = function isDOMSelection(value) {
	  var window = value && value.anchorNode && getDefaultView(value.anchorNode);
	  return !!window && value instanceof window.Selection;
	};
	/**
	 * Check if a DOM node is an element node.
	 */
	
	var isDOMText = function isDOMText(value) {
	  return isDOMNode(value) && value.nodeType === 3;
	};
	/**
	 * Checks whether a paste event is a plaintext-only event.
	 */
	
	var isPlainTextOnlyPaste = function isPlainTextOnlyPaste(event) {
	  return event.clipboardData && event.clipboardData.getData('text/plain') !== '' && event.clipboardData.types.length === 1;
	};
	/**
	 * Normalize a DOM point so that it always refers to a text node.
	 */
	
	var normalizeDOMPoint = function normalizeDOMPoint(domPoint) {
	  var _domPoint = _slicedToArray(domPoint, 2),
	      node = _domPoint[0],
	      offset = _domPoint[1]; // If it's an element node, its offset refers to the index of its children
	  // including comment nodes, so try to find the right text child node.
	
	
	  if (isDOMElement(node) && node.childNodes.length) {
	    var isLast = offset === node.childNodes.length;
	    var index = isLast ? offset - 1 : offset;
	
	    var _getEditableChildAndI = getEditableChildAndIndex(node, index, isLast ? 'backward' : 'forward');
	
	    var _getEditableChildAndI2 = _slicedToArray(_getEditableChildAndI, 2);
	
	    node = _getEditableChildAndI2[0];
	    index = _getEditableChildAndI2[1];
	    // If the editable child found is in front of input offset, we instead seek to its end
	    isLast = index < offset; // If the node has children, traverse until we have a leaf node. Leaf nodes
	    // can be either text nodes, or other void DOM nodes.
	
	    while (isDOMElement(node) && node.childNodes.length) {
	      var i = isLast ? node.childNodes.length - 1 : 0;
	      node = getEditableChild(node, i, isLast ? 'backward' : 'forward');
	    } // Determine the new offset inside the text node.
	
	
	    offset = isLast && node.textContent != null ? node.textContent.length : 0;
	  } // Return the node and offset.
	
	
	  return [node, offset];
	};
	/**
	 * Determines wether the active element is nested within a shadowRoot
	 */
	
	var hasShadowRoot = function hasShadowRoot() {
	  return !!(window.document.activeElement && window.document.activeElement.shadowRoot);
	};
	/**
	 * Get the nearest editable child and index at `index` in a `parent`, preferring
	 * `direction`.
	 */
	
	var getEditableChildAndIndex = function getEditableChildAndIndex(parent, index, direction) {
	  var childNodes = parent.childNodes;
	  var child = childNodes[index];
	  var i = index;
	  var triedForward = false;
	  var triedBackward = false; // While the child is a comment node, or an element node with no children,
	  // keep iterating to find a sibling non-void, non-comment node.
	
	  while (isDOMComment(child) || isDOMElement(child) && child.childNodes.length === 0 || isDOMElement(child) && child.getAttribute('contenteditable') === 'false') {
	    if (triedForward && triedBackward) {
	      break;
	    }
	
	    if (i >= childNodes.length) {
	      triedForward = true;
	      i = index - 1;
	      direction = 'backward';
	      continue;
	    }
	
	    if (i < 0) {
	      triedBackward = true;
	      i = index + 1;
	      direction = 'forward';
	      continue;
	    }
	
	    child = childNodes[i];
	    index = i;
	    i += direction === 'forward' ? 1 : -1;
	  }
	
	  return [child, index];
	};
	/**
	 * Get the nearest editable child at `index` in a `parent`, preferring
	 * `direction`.
	 */
	
	var getEditableChild = function getEditableChild(parent, index, direction) {
	  var _getEditableChildAndI3 = getEditableChildAndIndex(parent, index, direction),
	      _getEditableChildAndI4 = _slicedToArray(_getEditableChildAndI3, 1),
	      child = _getEditableChildAndI4[0];
	
	  return child;
	};
	/**
	 * Get a plaintext representation of the content of a node, accounting for block
	 * elements which get a newline appended.
	 *
	 * The domNode must be attached to the DOM.
	 */
	
	var getPlainText = function getPlainText(domNode) {
	  var text = '';
	
	  if (isDOMText(domNode) && domNode.nodeValue) {
	    return domNode.nodeValue;
	  }
	
	  if (isDOMElement(domNode)) {
	    for (var _i = 0, _Array$from = Array.from(domNode.childNodes); _i < _Array$from.length; _i++) {
	      var childNode = _Array$from[_i];
	      text += getPlainText(childNode);
	    }
	
	    var display = getComputedStyle(domNode).getPropertyValue('display');
	
	    if (display === 'block' || display === 'list' || domNode.tagName === 'BR') {
	      text += '\n';
	    }
	  }
	
	  return text;
	};
	/**
	 * Get x-slate-fragment attribute from data-slate-fragment
	 */
	
	var catchSlateFragment = /data-slate-fragment="(.+?)"/m;
	var getSlateFragmentAttribute = function getSlateFragmentAttribute(dataTransfer) {
	  var htmlData = dataTransfer.getData('text/html');
	
	  var _ref = htmlData.match(catchSlateFragment) || [],
	      _ref2 = _slicedToArray(_ref, 2),
	      fragment = _ref2[1];
	
	  return fragment;
	};
	/**
	 * Get the x-slate-fragment attribute that exist in text/html data
	 * and append it to the DataTransfer object
	 */
	
	var getClipboardData = function getClipboardData(dataTransfer) {
	  if (!dataTransfer.getData('application/x-slate-fragment')) {
	    var fragment = getSlateFragmentAttribute(dataTransfer);
	
	    if (fragment) {
	      var clipboardData = new DataTransfer();
	      dataTransfer.types.forEach(function (type) {
	        clipboardData.setData(type, dataTransfer.getData(type));
	      });
	      clipboardData.setData('application/x-slate-fragment', fragment);
	      return clipboardData;
	    }
	  }
	
	  return dataTransfer;
	};
	
	var TRIPLE_CLICK = 3;
	
	var _excluded$2 = ["autoFocus", "decorate", "onDOMBeforeInput", "placeholder", "readOnly", "renderElement", "renderLeaf", "renderPlaceholder", "scrollSelectionIntoView", "style", "as"];
	
	function _createForOfIteratorHelper$2(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$2(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
	
	function _unsupportedIterableToArray$2(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$2(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$2(o, minLen); }
	
	function _arrayLikeToArray$2(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	var Children = function Children(props) {
	  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, useChildren(props));
	};
	/**
	 * Editable.
	 */
	
	
	var Editable$1 = function Editable(props) {
	  var autoFocus = props.autoFocus,
	      _props$decorate = props.decorate,
	      decorate = _props$decorate === void 0 ? defaultDecorate : _props$decorate,
	      propsOnDOMBeforeInput = props.onDOMBeforeInput,
	      placeholder = props.placeholder,
	      _props$readOnly = props.readOnly,
	      readOnly = _props$readOnly === void 0 ? false : _props$readOnly,
	      renderElement = props.renderElement,
	      renderLeaf = props.renderLeaf,
	      _props$renderPlacehol = props.renderPlaceholder,
	      renderPlaceholder = _props$renderPlacehol === void 0 ? function (props) {
	    return /*#__PURE__*/React__default['default'].createElement(DefaultPlaceholder, Object.assign({}, props));
	  } : _props$renderPlacehol,
	      _props$scrollSelectio = props.scrollSelectionIntoView,
	      scrollSelectionIntoView = _props$scrollSelectio === void 0 ? defaultScrollSelectionIntoView : _props$scrollSelectio,
	      _props$style = props.style,
	      style = _props$style === void 0 ? {} : _props$style,
	      _props$as = props.as,
	      Component = _props$as === void 0 ? 'div' : _props$as,
	      attributes = _objectWithoutProperties(props, _excluded$2);
	
	  var editor = useSlate(); // Rerender editor when composition status changed
	
	  var _useState = React.useState(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      isComposing = _useState2[0],
	      setIsComposing = _useState2[1];
	
	  var ref = React.useRef(null);
	  var deferredOperations = React.useRef([]); // Update internal state on each render.
	
	  IS_READ_ONLY.set(editor, readOnly); // Keep track of some state for the event handler logic.
	
	  var state = React.useMemo(function () {
	    return {
	      hasInsertPrefixInCompositon: false,
	      isDraggingInternally: false,
	      isUpdatingSelection: false,
	      latestElement: null
	    };
	  }, []); // Whenever the editor updates...
	
	  useIsomorphicLayoutEffect(function () {
	    // Update element-related weak maps with the DOM element ref.
	    var window;
	
	    if (ref.current && (window = getDefaultView(ref.current))) {
	      EDITOR_TO_WINDOW.set(editor, window);
	      EDITOR_TO_ELEMENT.set(editor, ref.current);
	      NODE_TO_ELEMENT.set(editor, ref.current);
	      ELEMENT_TO_NODE.set(ref.current, editor);
	    } else {
	      NODE_TO_ELEMENT["delete"](editor);
	    } // Make sure the DOM selection state is in sync.
	
	
	    var selection = editor.selection;
	    var root = ReactEditor.findDocumentOrShadowRoot(editor);
	    var domSelection = root.getSelection();
	
	    if (ReactEditor.isComposing(editor) || !domSelection || !ReactEditor.isFocused(editor)) {
	      return;
	    }
	
	    var hasDomSelection = domSelection.type !== 'None'; // If the DOM selection is properly unset, we're done.
	
	    if (!selection && !hasDomSelection) {
	      return;
	    } // verify that the dom selection is in the editor
	
	
	    var editorElement = EDITOR_TO_ELEMENT.get(editor);
	    var hasDomSelectionInEditor = false;
	
	    if (editorElement.contains(domSelection.anchorNode) && editorElement.contains(domSelection.focusNode)) {
	      hasDomSelectionInEditor = true;
	    } // If the DOM selection is in the editor and the editor selection is already correct, we're done.
	
	
	    if (hasDomSelection && hasDomSelectionInEditor && selection) {
	      var slateRange = ReactEditor.toSlateRange(editor, domSelection, {
	        exactMatch: true,
	        // domSelection is not necessarily a valid Slate range
	        // (e.g. when clicking on contentEditable:false element)
	        suppressThrow: true
	      });
	
	      if (slateRange && slate.Range.equals(slateRange, selection)) {
	        return;
	      }
	    } // when <Editable/> is being controlled through external value
	    // then its children might just change - DOM responds to it on its own
	    // but Slate's value is not being updated through any operation
	    // and thus it doesn't transform selection on its own
	
	
	    if (selection && !ReactEditor.hasRange(editor, selection)) {
	      editor.selection = ReactEditor.toSlateRange(editor, domSelection, {
	        exactMatch: false,
	        suppressThrow: false
	      });
	      return;
	    } // Otherwise the DOM selection is out of sync, so update it.
	
	
	    state.isUpdatingSelection = true;
	    var newDomRange = selection && ReactEditor.toDOMRange(editor, selection);
	
	    if (newDomRange) {
	      if (slate.Range.isBackward(selection)) {
	        domSelection.setBaseAndExtent(newDomRange.endContainer, newDomRange.endOffset, newDomRange.startContainer, newDomRange.startOffset);
	      } else {
	        domSelection.setBaseAndExtent(newDomRange.startContainer, newDomRange.startOffset, newDomRange.endContainer, newDomRange.endOffset);
	      }
	
	      scrollSelectionIntoView(editor, newDomRange);
	    } else {
	      domSelection.removeAllRanges();
	    }
	
	    setTimeout(function () {
	      // COMPAT: In Firefox, it's not enough to create a range, you also need
	      // to focus the contenteditable element too. (2016/11/16)
	      if (newDomRange && IS_FIREFOX) {
	        var el = ReactEditor.toDOMNode(editor, editor);
	        el.focus();
	      }
	
	      state.isUpdatingSelection = false;
	    });
	  }); // The autoFocus TextareaHTMLAttribute doesn't do anything on a div, so it
	  // needs to be manually focused.
	
	  React.useEffect(function () {
	    if (ref.current && autoFocus) {
	      ref.current.focus();
	    }
	  }, [autoFocus]); // Listen on the native `selectionchange` event to be able to update any time
	  // the selection changes. This is required because React's `onSelect` is leaky
	  // and non-standard so it doesn't fire until after a selection has been
	  // released. This causes issues in situations where another change happens
	  // while a selection is being dragged.
	
	  var onDOMSelectionChange = React.useCallback(throttle__default['default'](function () {
	    if (!ReactEditor.isComposing(editor) && !state.isUpdatingSelection && !state.isDraggingInternally) {
	      var root = ReactEditor.findDocumentOrShadowRoot(editor);
	      var activeElement = root.activeElement;
	      var el = ReactEditor.toDOMNode(editor, editor);
	      var domSelection = root.getSelection();
	
	      if (activeElement === el) {
	        state.latestElement = activeElement;
	        IS_FOCUSED.set(editor, true);
	      } else {
	        IS_FOCUSED["delete"](editor);
	      }
	
	      if (!domSelection) {
	        return slate.Transforms.deselect(editor);
	      }
	
	      var anchorNode = domSelection.anchorNode,
	          focusNode = domSelection.focusNode;
	      var anchorNodeSelectable = hasEditableTarget(editor, anchorNode) || isTargetInsideNonReadonlyVoid(editor, anchorNode);
	      var focusNodeSelectable = hasEditableTarget(editor, focusNode) || isTargetInsideNonReadonlyVoid(editor, focusNode);
	
	      if (anchorNodeSelectable && focusNodeSelectable) {
	        var range = ReactEditor.toSlateRange(editor, domSelection, {
	          exactMatch: false,
	          suppressThrow: false
	        });
	        slate.Transforms.select(editor, range);
	      }
	    }
	  }, 100), [readOnly]);
	  var scheduleOnDOMSelectionChange = React.useMemo(function () {
	    return debounce__default['default'](onDOMSelectionChange, 0);
	  }, [onDOMSelectionChange]); // Listen on the native `beforeinput` event to get real "Level 2" events. This
	  // is required because React's `beforeinput` is fake and never really attaches
	  // to the real event sadly. (2019/11/01)
	  // https://github.com/facebook/react/issues/11211
	
	  var onDOMBeforeInput = React.useCallback(function (event) {
	    if (!readOnly && hasEditableTarget(editor, event.target) && !isDOMEventHandled(event, propsOnDOMBeforeInput)) {
	      var _EDITOR_TO_USER_SELEC;
	
	      // Some IMEs/Chrome extensions like e.g. Grammarly set the selection immediately before
	      // triggering a `beforeinput` expecting the change to be applied to the immediately before
	      // set selection.
	      scheduleOnDOMSelectionChange.flush();
	      onDOMSelectionChange.flush();
	      var selection = editor.selection;
	      var type = event.inputType;
	      var data = event.dataTransfer || event.data || undefined; // These two types occur while a user is composing text and can't be
	      // cancelled. Let them through and wait for the composition to end.
	
	      if (type === 'insertCompositionText' || type === 'deleteCompositionText') {
	        return;
	      }
	
	      var _native = false;
	
	      if (type === 'insertText' && selection && slate.Range.isCollapsed(selection) && // Only use native character insertion for single characters a-z or space for now.
	      // Long-press events (hold a + press 4 = ä) to choose a special character otherwise
	      // causes duplicate inserts.
	      event.data && event.data.length === 1 && /[a-z ]/i.test(event.data) && // Chrome has issues correctly editing the start of nodes: https://bugs.chromium.org/p/chromium/issues/detail?id=1249405
	      // When there is an inline element, e.g. a link, and you select
	      // right after it (the start of the next node).
	      selection.anchor.offset !== 0) {
	        var _node$parentElement;
	
	        _native = true; // Skip native if there are marks, as
	        // `insertText` will insert a node, not just text.
	
	        if (editor.marks) {
	          _native = false;
	        } // Chrome also has issues correctly editing the end of anchor elements: https://bugs.chromium.org/p/chromium/issues/detail?id=1259100
	        // Therefore we don't allow native events to insert text at the end of anchor nodes.
	
	
	        var anchor = selection.anchor;
	
	        var _ReactEditor$toDOMPoi = ReactEditor.toDOMPoint(editor, anchor),
	            _ReactEditor$toDOMPoi2 = _slicedToArray(_ReactEditor$toDOMPoi, 2),
	            node = _ReactEditor$toDOMPoi2[0],
	            offset = _ReactEditor$toDOMPoi2[1];
	
	        var anchorNode = (_node$parentElement = node.parentElement) === null || _node$parentElement === void 0 ? void 0 : _node$parentElement.closest('a');
	
	        if (anchorNode && ReactEditor.hasDOMNode(editor, anchorNode)) {
	          var _lastText$textContent;
	
	          var _ReactEditor$getWindo = ReactEditor.getWindow(editor),
	              document = _ReactEditor$getWindo.document; // Find the last text node inside the anchor.
	
	
	          var lastText = document.createTreeWalker(anchorNode, NodeFilter.SHOW_TEXT).lastChild();
	
	          if (lastText === node && ((_lastText$textContent = lastText.textContent) === null || _lastText$textContent === void 0 ? void 0 : _lastText$textContent.length) === offset) {
	            _native = false;
	          }
	        }
	      } // COMPAT: For the deleting forward/backward input types we don't want
	      // to change the selection because it is the range that will be deleted,
	      // and those commands determine that for themselves.
	
	
	      if (!type.startsWith('delete') || type.startsWith('deleteBy')) {
	        var _event$getTargetRange = event.getTargetRanges(),
	            _event$getTargetRange2 = _slicedToArray(_event$getTargetRange, 1),
	            targetRange = _event$getTargetRange2[0];
	
	        if (targetRange) {
	          var range = ReactEditor.toSlateRange(editor, targetRange, {
	            exactMatch: false,
	            suppressThrow: false
	          });
	
	          if (!selection || !slate.Range.equals(selection, range)) {
	            _native = false;
	            var selectionRef = editor.selection && slate.Editor.rangeRef(editor, editor.selection);
	            slate.Transforms.select(editor, range);
	
	            if (selectionRef) {
	              EDITOR_TO_USER_SELECTION.set(editor, selectionRef);
	            }
	          }
	        }
	      }
	
	      if (!_native) {
	        event.preventDefault();
	      } // COMPAT: If the selection is expanded, even if the command seems like
	      // a delete forward/backward command it should delete the selection.
	
	
	      if (selection && slate.Range.isExpanded(selection) && type.startsWith('delete')) {
	        var direction = type.endsWith('Backward') ? 'backward' : 'forward';
	        slate.Editor.deleteFragment(editor, {
	          direction: direction
	        });
	        return;
	      }
	
	      switch (type) {
	        case 'deleteByComposition':
	        case 'deleteByCut':
	        case 'deleteByDrag':
	          {
	            slate.Editor.deleteFragment(editor);
	            break;
	          }
	
	        case 'deleteContent':
	        case 'deleteContentForward':
	          {
	            slate.Editor.deleteForward(editor);
	            break;
	          }
	
	        case 'deleteContentBackward':
	          {
	            slate.Editor.deleteBackward(editor);
	            break;
	          }
	
	        case 'deleteEntireSoftLine':
	          {
	            slate.Editor.deleteBackward(editor, {
	              unit: 'line'
	            });
	            slate.Editor.deleteForward(editor, {
	              unit: 'line'
	            });
	            break;
	          }
	
	        case 'deleteHardLineBackward':
	          {
	            slate.Editor.deleteBackward(editor, {
	              unit: 'block'
	            });
	            break;
	          }
	
	        case 'deleteSoftLineBackward':
	          {
	            slate.Editor.deleteBackward(editor, {
	              unit: 'line'
	            });
	            break;
	          }
	
	        case 'deleteHardLineForward':
	          {
	            slate.Editor.deleteForward(editor, {
	              unit: 'block'
	            });
	            break;
	          }
	
	        case 'deleteSoftLineForward':
	          {
	            slate.Editor.deleteForward(editor, {
	              unit: 'line'
	            });
	            break;
	          }
	
	        case 'deleteWordBackward':
	          {
	            slate.Editor.deleteBackward(editor, {
	              unit: 'word'
	            });
	            break;
	          }
	
	        case 'deleteWordForward':
	          {
	            slate.Editor.deleteForward(editor, {
	              unit: 'word'
	            });
	            break;
	          }
	
	        case 'insertLineBreak':
	          slate.Editor.insertSoftBreak(editor);
	          break;
	
	        case 'insertParagraph':
	          {
	            slate.Editor.insertBreak(editor);
	            break;
	          }
	
	        case 'insertFromComposition':
	        case 'insertFromDrop':
	        case 'insertFromPaste':
	        case 'insertFromYank':
	        case 'insertReplacementText':
	        case 'insertText':
	          {
	            var _selection = editor.selection;
	
	            if (_selection) {
	              if (slate.Range.isExpanded(_selection)) {
	                slate.Editor.deleteFragment(editor);
	              }
	            }
	
	            if (type === 'insertFromComposition') {
	              // COMPAT: in Safari, `compositionend` is dispatched after the
	              // `beforeinput` for "insertFromComposition". But if we wait for it
	              // then we will abort because we're still composing and the selection
	              // won't be updated properly.
	              // https://www.w3.org/TR/input-events-2/
	              if (ReactEditor.isComposing(editor)) {
	                setIsComposing(false);
	                IS_COMPOSING.set(editor, false);
	              }
	            } // use a weak comparison instead of 'instanceof' to allow
	            // programmatic access of paste events coming from external windows
	            // like cypress where cy.window does not work realibly
	
	
	            if ((data === null || data === void 0 ? void 0 : data.constructor.name) === 'DataTransfer') {
	              ReactEditor.insertData(editor, data);
	            } else if (typeof data === 'string') {
	              // Only insertText operations use the native functionality, for now.
	              // Potentially expand to single character deletes, as well.
	              if (_native) {
	                deferredOperations.current.push(function () {
	                  return slate.Editor.insertText(editor, data);
	                });
	              } else {
	                slate.Editor.insertText(editor, data);
	              }
	            }
	
	            break;
	          }
	      } // Restore the actual user section if nothing manually set it.
	
	
	      var toRestore = (_EDITOR_TO_USER_SELEC = EDITOR_TO_USER_SELECTION.get(editor)) === null || _EDITOR_TO_USER_SELEC === void 0 ? void 0 : _EDITOR_TO_USER_SELEC.unref();
	      EDITOR_TO_USER_SELECTION["delete"](editor);
	
	      if (toRestore && (!editor.selection || !slate.Range.equals(editor.selection, toRestore))) {
	        slate.Transforms.select(editor, toRestore);
	      }
	    }
	  }, [readOnly, propsOnDOMBeforeInput]); // Attach a native DOM event handler for `beforeinput` events, because React's
	  // built-in `onBeforeInput` is actually a leaky polyfill that doesn't expose
	  // real `beforeinput` events sadly... (2019/11/04)
	  // https://github.com/facebook/react/issues/11211
	
	  useIsomorphicLayoutEffect(function () {
	    if (ref.current && HAS_BEFORE_INPUT_SUPPORT) {
	      // @ts-ignore The `beforeinput` event isn't recognized.
	      ref.current.addEventListener('beforeinput', onDOMBeforeInput);
	    }
	
	    return function () {
	      if (ref.current && HAS_BEFORE_INPUT_SUPPORT) {
	        // @ts-ignore The `beforeinput` event isn't recognized.
	        ref.current.removeEventListener('beforeinput', onDOMBeforeInput);
	      }
	    };
	  }, [onDOMBeforeInput]); // Attach a native DOM event handler for `selectionchange`, because React's
	  // built-in `onSelect` handler doesn't fire for all selection changes. It's a
	  // leaky polyfill that only fires on keypresses or clicks. Instead, we want to
	  // fire for any change to the selection inside the editor. (2019/11/04)
	  // https://github.com/facebook/react/issues/5785
	
	  useIsomorphicLayoutEffect(function () {
	    var window = ReactEditor.getWindow(editor);
	    window.document.addEventListener('selectionchange', scheduleOnDOMSelectionChange);
	    return function () {
	      window.document.removeEventListener('selectionchange', scheduleOnDOMSelectionChange);
	    };
	  }, [scheduleOnDOMSelectionChange]);
	
	  var decorations = _toConsumableArray(slate.Node.nodes(editor)).flatMap(function (_ref) {
	    var _ref2 = _slicedToArray(_ref, 2),
	        n = _ref2[0],
	        p = _ref2[1];
	
	    return decorate([n, p]);
	  });
	
	  if (placeholder && editor.children.length === 1 && Array.from(slate.Node.texts(editor)).length === 1 && slate.Node.string(editor) === '' && !isComposing) {
	    var _decorations$push;
	
	    var start = slate.Editor.start(editor, []);
	    decorations.push((_decorations$push = {}, _defineProperty(_decorations$push, PLACEHOLDER_SYMBOL, true), _defineProperty(_decorations$push, "placeholder", placeholder), _defineProperty(_decorations$push, "anchor", start), _defineProperty(_decorations$push, "focus", start), _decorations$push));
	  }
	
	  return /*#__PURE__*/React__default['default'].createElement(ReadOnlyContext.Provider, {
	    value: readOnly
	  }, /*#__PURE__*/React__default['default'].createElement(DecorateContext.Provider, {
	    value: decorate
	  }, /*#__PURE__*/React__default['default'].createElement(Component, Object.assign({
	    role: readOnly ? undefined : 'textbox'
	  }, attributes, {
	    // COMPAT: Certain browsers don't support the `beforeinput` event, so we'd
	    // have to use hacks to make these replacement-based features work.
	    // For SSR situations HAS_BEFORE_INPUT_SUPPORT is false and results in prop
	    // mismatch warning app moves to browser. Pass-through consumer props when
	    // not CAN_USE_DOM (SSR) and default to falsy value
	    spellCheck: HAS_BEFORE_INPUT_SUPPORT || !CAN_USE_DOM ? attributes.spellCheck : false,
	    autoCorrect: HAS_BEFORE_INPUT_SUPPORT || !CAN_USE_DOM ? attributes.autoCorrect : 'false',
	    autoCapitalize: HAS_BEFORE_INPUT_SUPPORT || !CAN_USE_DOM ? attributes.autoCapitalize : 'false',
	    "data-slate-editor": true,
	    "data-slate-node": "value",
	    // explicitly set this
	    contentEditable: !readOnly,
	    // in some cases, a decoration needs access to the range / selection to decorate a text node,
	    // then you will select the whole text node when you select part the of text
	    // this magic zIndex="-1" will fix it
	    zindex: -1,
	    suppressContentEditableWarning: true,
	    ref: ref,
	    style: _objectSpread$1({
	      // Allow positioning relative to the editable element.
	      position: 'relative',
	      // Prevent the default outline styles.
	      outline: 'none',
	      // Preserve adjacent whitespace and new lines.
	      whiteSpace: 'pre-wrap',
	      // Allow words to break if they are too long.
	      wordWrap: 'break-word'
	    }, style),
	    onBeforeInput: React.useCallback(function (event) {
	      // COMPAT: Certain browsers don't support the `beforeinput` event, so we
	      // fall back to React's leaky polyfill instead just for it. It
	      // only works for the `insertText` input type.
	      if (!HAS_BEFORE_INPUT_SUPPORT && !readOnly && !isEventHandled(event, attributes.onBeforeInput) && hasEditableTarget(editor, event.target)) {
	        event.preventDefault();
	
	        if (!ReactEditor.isComposing(editor)) {
	          var text = event.data;
	          slate.Editor.insertText(editor, text);
	        }
	      }
	    }, [readOnly]),
	    onInput: React.useCallback(function (event) {
	      // Flush native operations, as native events will have propogated
	      // and we can correctly compare DOM text values in components
	      // to stop rendering, so that browser functions like autocorrect
	      // and spellcheck work as expected.
	      var _iterator = _createForOfIteratorHelper$2(deferredOperations.current),
	          _step;
	
	      try {
	        for (_iterator.s(); !(_step = _iterator.n()).done;) {
	          var op = _step.value;
	          op();
	        }
	      } catch (err) {
	        _iterator.e(err);
	      } finally {
	        _iterator.f();
	      }
	
	      deferredOperations.current = [];
	    }, []),
	    onBlur: React.useCallback(function (event) {
	      if (readOnly || state.isUpdatingSelection || !hasEditableTarget(editor, event.target) || isEventHandled(event, attributes.onBlur)) {
	        return;
	      } // COMPAT: If the current `activeElement` is still the previous
	      // one, this is due to the window being blurred when the tab
	      // itself becomes unfocused, so we want to abort early to allow to
	      // editor to stay focused when the tab becomes focused again.
	
	
	      var root = ReactEditor.findDocumentOrShadowRoot(editor);
	
	      if (state.latestElement === root.activeElement) {
	        return;
	      }
	
	      var relatedTarget = event.relatedTarget;
	      var el = ReactEditor.toDOMNode(editor, editor); // COMPAT: The event should be ignored if the focus is returning
	      // to the editor from an embedded editable element (eg. an <input>
	      // element inside a void node).
	
	      if (relatedTarget === el) {
	        return;
	      } // COMPAT: The event should be ignored if the focus is moving from
	      // the editor to inside a void node's spacer element.
	
	
	      if (isDOMElement(relatedTarget) && relatedTarget.hasAttribute('data-slate-spacer')) {
	        return;
	      } // COMPAT: The event should be ignored if the focus is moving to a
	      // non- editable section of an element that isn't a void node (eg.
	      // a list item of the check list example).
	
	
	      if (relatedTarget != null && isDOMNode(relatedTarget) && ReactEditor.hasDOMNode(editor, relatedTarget)) {
	        var node = ReactEditor.toSlateNode(editor, relatedTarget);
	
	        if (slate.Element.isElement(node) && !editor.isVoid(node)) {
	          return;
	        }
	      } // COMPAT: Safari doesn't always remove the selection even if the content-
	      // editable element no longer has focus. Refer to:
	      // https://stackoverflow.com/questions/12353247/force-contenteditable-div-to-stop-accepting-input-after-it-loses-focus-under-web
	
	
	      if (IS_SAFARI) {
	        var domSelection = root.getSelection();
	        domSelection === null || domSelection === void 0 ? void 0 : domSelection.removeAllRanges();
	      }
	
	      IS_FOCUSED["delete"](editor);
	    }, [readOnly, attributes.onBlur]),
	    onClick: React.useCallback(function (event) {
	      if (hasTarget(editor, event.target) && !isEventHandled(event, attributes.onClick) && isDOMNode(event.target)) {
	        var node = ReactEditor.toSlateNode(editor, event.target);
	        var path = ReactEditor.findPath(editor, node); // At this time, the Slate document may be arbitrarily different,
	        // because onClick handlers can change the document before we get here.
	        // Therefore we must check that this path actually exists,
	        // and that it still refers to the same node.
	
	        if (!slate.Editor.hasPath(editor, path) || slate.Node.get(editor, path) !== node) {
	          return;
	        }
	
	        if (event.detail === TRIPLE_CLICK && path.length >= 1) {
	          var blockPath = path;
	
	          if (!slate.Editor.isBlock(editor, node)) {
	            var _block$;
	
	            var block = slate.Editor.above(editor, {
	              match: function match(n) {
	                return slate.Editor.isBlock(editor, n);
	              },
	              at: path
	            });
	            blockPath = (_block$ = block === null || block === void 0 ? void 0 : block[1]) !== null && _block$ !== void 0 ? _block$ : path.slice(0, 1);
	          }
	
	          var range = slate.Editor.range(editor, blockPath);
	          slate.Transforms.select(editor, range);
	          return;
	        }
	
	        if (readOnly) {
	          return;
	        }
	
	        var _start = slate.Editor.start(editor, path);
	
	        var end = slate.Editor.end(editor, path);
	        var startVoid = slate.Editor["void"](editor, {
	          at: _start
	        });
	        var endVoid = slate.Editor["void"](editor, {
	          at: end
	        });
	
	        if (startVoid && endVoid && slate.Path.equals(startVoid[1], endVoid[1])) {
	          var _range = slate.Editor.range(editor, _start);
	
	          slate.Transforms.select(editor, _range);
	        }
	      }
	    }, [readOnly, attributes.onClick]),
	    onCompositionEnd: React.useCallback(function (event) {
	      if (hasEditableTarget(editor, event.target) && !isEventHandled(event, attributes.onCompositionEnd)) {
	        if (ReactEditor.isComposing(editor)) {
	          setIsComposing(false);
	          IS_COMPOSING.set(editor, false);
	        } // COMPAT: In Chrome, `beforeinput` events for compositions
	        // aren't correct and never fire the "insertFromComposition"
	        // type that we need. So instead, insert whenever a composition
	        // ends since it will already have been committed to the DOM.
	
	
	        if (!IS_SAFARI && !IS_FIREFOX_LEGACY && !IS_IOS && !IS_QQBROWSER && !IS_WECHATBROWSER && !IS_UC_MOBILE && event.data) {
	          slate.Editor.insertText(editor, event.data);
	        }
	
	        if (editor.selection && slate.Range.isCollapsed(editor.selection)) {
	          var leafPath = editor.selection.anchor.path;
	          var currentTextNode = slate.Node.leaf(editor, leafPath);
	
	          if (state.hasInsertPrefixInCompositon) {
	            state.hasInsertPrefixInCompositon = false;
	            slate.Editor.withoutNormalizing(editor, function () {
	              // remove Unicode BOM prefix added in `onCompositionStart`
	              var text = currentTextNode.text.replace(/^\uFEFF/, '');
	              slate.Transforms["delete"](editor, {
	                distance: currentTextNode.text.length,
	                reverse: true
	              });
	              slate.Editor.insertText(editor, text);
	            });
	          }
	        }
	      }
	    }, [attributes.onCompositionEnd]),
	    onCompositionUpdate: React.useCallback(function (event) {
	      if (hasEditableTarget(editor, event.target) && !isEventHandled(event, attributes.onCompositionUpdate)) {
	        if (!ReactEditor.isComposing(editor)) {
	          setIsComposing(true);
	          IS_COMPOSING.set(editor, true);
	        }
	      }
	    }, [attributes.onCompositionUpdate]),
	    onCompositionStart: React.useCallback(function (event) {
	      if (hasEditableTarget(editor, event.target) && !isEventHandled(event, attributes.onCompositionStart)) {
	        var selection = editor.selection,
	            marks = editor.marks;
	
	        if (selection) {
	          if (slate.Range.isExpanded(selection)) {
	            slate.Editor.deleteFragment(editor);
	            return;
	          }
	
	          var inline = slate.Editor.above(editor, {
	            match: function match(n) {
	              return slate.Editor.isInline(editor, n);
	            },
	            mode: 'highest'
	          });
	
	          if (inline) {
	            var _inline = _slicedToArray(inline, 2),
	                inlinePath = _inline[1];
	
	            if (slate.Editor.isEnd(editor, selection.anchor, inlinePath)) {
	              var point = slate.Editor.after(editor, inlinePath);
	              slate.Transforms.setSelection(editor, {
	                anchor: point,
	                focus: point
	              });
	            }
	          } // insert new node in advance to ensure composition text will insert
	          // along with final input text
	          // add Unicode BOM prefix to avoid normalize removing this node
	
	
	          if (marks) {
	            state.hasInsertPrefixInCompositon = true;
	            slate.Transforms.insertNodes(editor, _objectSpread$1({
	              text: "\uFEFF"
	            }, marks), {
	              select: true
	            });
	          }
	        }
	      }
	    }, [attributes.onCompositionStart]),
	    onCopy: React.useCallback(function (event) {
	      if (hasEditableTarget(editor, event.target) && !isEventHandled(event, attributes.onCopy)) {
	        event.preventDefault();
	        ReactEditor.setFragmentData(editor, event.clipboardData, 'copy');
	      }
	    }, [attributes.onCopy]),
	    onCut: React.useCallback(function (event) {
	      if (!readOnly && hasEditableTarget(editor, event.target) && !isEventHandled(event, attributes.onCut)) {
	        event.preventDefault();
	        ReactEditor.setFragmentData(editor, event.clipboardData, 'cut');
	        var selection = editor.selection;
	
	        if (selection) {
	          if (slate.Range.isExpanded(selection)) {
	            slate.Editor.deleteFragment(editor);
	          } else {
	            var node = slate.Node.parent(editor, selection.anchor.path);
	
	            if (slate.Editor.isVoid(editor, node)) {
	              slate.Transforms["delete"](editor);
	            }
	          }
	        }
	      }
	    }, [readOnly, attributes.onCut]),
	    onDragOver: React.useCallback(function (event) {
	      if (hasTarget(editor, event.target) && !isEventHandled(event, attributes.onDragOver)) {
	        // Only when the target is void, call `preventDefault` to signal
	        // that drops are allowed. Editable content is droppable by
	        // default, and calling `preventDefault` hides the cursor.
	        var node = ReactEditor.toSlateNode(editor, event.target);
	
	        if (slate.Editor.isVoid(editor, node)) {
	          event.preventDefault();
	        }
	      }
	    }, [attributes.onDragOver]),
	    onDragStart: React.useCallback(function (event) {
	      if (!readOnly && hasTarget(editor, event.target) && !isEventHandled(event, attributes.onDragStart)) {
	        var node = ReactEditor.toSlateNode(editor, event.target);
	        var path = ReactEditor.findPath(editor, node);
	        var voidMatch = slate.Editor.isVoid(editor, node) || slate.Editor["void"](editor, {
	          at: path,
	          voids: true
	        }); // If starting a drag on a void node, make sure it is selected
	        // so that it shows up in the selection's fragment.
	
	        if (voidMatch) {
	          var range = slate.Editor.range(editor, path);
	          slate.Transforms.select(editor, range);
	        }
	
	        state.isDraggingInternally = true;
	        ReactEditor.setFragmentData(editor, event.dataTransfer, 'drag');
	      }
	    }, [readOnly, attributes.onDragStart]),
	    onDrop: React.useCallback(function (event) {
	      if (!readOnly && hasTarget(editor, event.target) && !isEventHandled(event, attributes.onDrop)) {
	        event.preventDefault(); // Keep a reference to the dragged range before updating selection
	
	        var draggedRange = editor.selection; // Find the range where the drop happened
	
	        var range = ReactEditor.findEventRange(editor, event);
	        var data = event.dataTransfer;
	        slate.Transforms.select(editor, range);
	
	        if (state.isDraggingInternally) {
	          if (draggedRange && !slate.Range.equals(draggedRange, range) && !slate.Editor["void"](editor, {
	            at: range,
	            voids: true
	          })) {
	            slate.Transforms["delete"](editor, {
	              at: draggedRange
	            });
	          }
	        }
	
	        ReactEditor.insertData(editor, data); // When dragging from another source into the editor, it's possible
	        // that the current editor does not have focus.
	
	        if (!ReactEditor.isFocused(editor)) {
	          ReactEditor.focus(editor);
	        }
	      }
	
	      state.isDraggingInternally = false;
	    }, [readOnly, attributes.onDrop]),
	    onDragEnd: React.useCallback(function (event) {
	      if (!readOnly && state.isDraggingInternally && attributes.onDragEnd && hasTarget(editor, event.target)) {
	        attributes.onDragEnd(event);
	      } // When dropping on a different droppable element than the current editor,
	      // `onDrop` is not called. So we need to clean up in `onDragEnd` instead.
	      // Note: `onDragEnd` is only called when `onDrop` is not called
	
	
	      state.isDraggingInternally = false;
	    }, [readOnly, attributes.onDragEnd]),
	    onFocus: React.useCallback(function (event) {
	      if (!readOnly && !state.isUpdatingSelection && hasEditableTarget(editor, event.target) && !isEventHandled(event, attributes.onFocus)) {
	        var el = ReactEditor.toDOMNode(editor, editor);
	        var root = ReactEditor.findDocumentOrShadowRoot(editor);
	        state.latestElement = root.activeElement; // COMPAT: If the editor has nested editable elements, the focus
	        // can go to them. In Firefox, this must be prevented because it
	        // results in issues with keyboard navigation. (2017/03/30)
	
	        if (IS_FIREFOX && event.target !== el) {
	          el.focus();
	          return;
	        }
	
	        IS_FOCUSED.set(editor, true);
	      }
	    }, [readOnly, attributes.onFocus]),
	    onKeyDown: React.useCallback(function (event) {
	      if (!readOnly && hasEditableTarget(editor, event.target)) {
	        var nativeEvent = event.nativeEvent; // COMPAT: The composition end event isn't fired reliably in all browsers,
	        // so we sometimes might end up stuck in a composition state even though we
	        // aren't composing any more.
	
	        if (ReactEditor.isComposing(editor) && nativeEvent.isComposing === false) {
	          IS_COMPOSING.set(editor, false);
	          setIsComposing(false);
	        }
	
	        if (isEventHandled(event, attributes.onKeyDown) || ReactEditor.isComposing(editor)) {
	          return;
	        }
	
	        var selection = editor.selection;
	        var element = editor.children[selection !== null ? selection.focus.path[0] : 0];
	        var isRTL = getDirection__default['default'](slate.Node.string(element)) === 'rtl'; // COMPAT: Since we prevent the default behavior on
	        // `beforeinput` events, the browser doesn't think there's ever
	        // any history stack to undo or redo, so we have to manage these
	        // hotkeys ourselves. (2019/11/06)
	
	        if (Hotkeys.isRedo(nativeEvent)) {
	          event.preventDefault();
	          var maybeHistoryEditor = editor;
	
	          if (typeof maybeHistoryEditor.redo === 'function') {
	            maybeHistoryEditor.redo();
	          }
	
	          return;
	        }
	
	        if (Hotkeys.isUndo(nativeEvent)) {
	          event.preventDefault();
	          var _maybeHistoryEditor = editor;
	
	          if (typeof _maybeHistoryEditor.undo === 'function') {
	            _maybeHistoryEditor.undo();
	          }
	
	          return;
	        } // COMPAT: Certain browsers don't handle the selection updates
	        // properly. In Chrome, the selection isn't properly extended.
	        // And in Firefox, the selection isn't properly collapsed.
	        // (2017/10/17)
	
	
	        if (Hotkeys.isMoveLineBackward(nativeEvent)) {
	          event.preventDefault();
	          slate.Transforms.move(editor, {
	            unit: 'line',
	            reverse: true
	          });
	          return;
	        }
	
	        if (Hotkeys.isMoveLineForward(nativeEvent)) {
	          event.preventDefault();
	          slate.Transforms.move(editor, {
	            unit: 'line'
	          });
	          return;
	        }
	
	        if (Hotkeys.isExtendLineBackward(nativeEvent)) {
	          event.preventDefault();
	          slate.Transforms.move(editor, {
	            unit: 'line',
	            edge: 'focus',
	            reverse: true
	          });
	          return;
	        }
	
	        if (Hotkeys.isExtendLineForward(nativeEvent)) {
	          event.preventDefault();
	          slate.Transforms.move(editor, {
	            unit: 'line',
	            edge: 'focus'
	          });
	          return;
	        } // COMPAT: If a void node is selected, or a zero-width text node
	        // adjacent to an inline is selected, we need to handle these
	        // hotkeys manually because browsers won't be able to skip over
	        // the void node with the zero-width space not being an empty
	        // string.
	
	
	        if (Hotkeys.isMoveBackward(nativeEvent)) {
	          event.preventDefault();
	
	          if (selection && slate.Range.isCollapsed(selection)) {
	            slate.Transforms.move(editor, {
	              reverse: !isRTL
	            });
	          } else {
	            slate.Transforms.collapse(editor, {
	              edge: 'start'
	            });
	          }
	
	          return;
	        }
	
	        if (Hotkeys.isMoveForward(nativeEvent)) {
	          event.preventDefault();
	
	          if (selection && slate.Range.isCollapsed(selection)) {
	            slate.Transforms.move(editor, {
	              reverse: isRTL
	            });
	          } else {
	            slate.Transforms.collapse(editor, {
	              edge: 'end'
	            });
	          }
	
	          return;
	        }
	
	        if (Hotkeys.isMoveWordBackward(nativeEvent)) {
	          event.preventDefault();
	
	          if (selection && slate.Range.isExpanded(selection)) {
	            slate.Transforms.collapse(editor, {
	              edge: 'focus'
	            });
	          }
	
	          slate.Transforms.move(editor, {
	            unit: 'word',
	            reverse: !isRTL
	          });
	          return;
	        }
	
	        if (Hotkeys.isMoveWordForward(nativeEvent)) {
	          event.preventDefault();
	
	          if (selection && slate.Range.isExpanded(selection)) {
	            slate.Transforms.collapse(editor, {
	              edge: 'focus'
	            });
	          }
	
	          slate.Transforms.move(editor, {
	            unit: 'word',
	            reverse: isRTL
	          });
	          return;
	        } // COMPAT: Certain browsers don't support the `beforeinput` event, so we
	        // fall back to guessing at the input intention for hotkeys.
	        // COMPAT: In iOS, some of these hotkeys are handled in the
	
	
	        if (!HAS_BEFORE_INPUT_SUPPORT) {
	          // We don't have a core behavior for these, but they change the
	          // DOM if we don't prevent them, so we have to.
	          if (Hotkeys.isBold(nativeEvent) || Hotkeys.isItalic(nativeEvent) || Hotkeys.isTransposeCharacter(nativeEvent)) {
	            event.preventDefault();
	            return;
	          }
	
	          if (Hotkeys.isSoftBreak(nativeEvent)) {
	            event.preventDefault();
	            slate.Editor.insertSoftBreak(editor);
	            return;
	          }
	
	          if (Hotkeys.isSplitBlock(nativeEvent)) {
	            event.preventDefault();
	            slate.Editor.insertBreak(editor);
	            return;
	          }
	
	          if (Hotkeys.isDeleteBackward(nativeEvent)) {
	            event.preventDefault();
	
	            if (selection && slate.Range.isExpanded(selection)) {
	              slate.Editor.deleteFragment(editor, {
	                direction: 'backward'
	              });
	            } else {
	              slate.Editor.deleteBackward(editor);
	            }
	
	            return;
	          }
	
	          if (Hotkeys.isDeleteForward(nativeEvent)) {
	            event.preventDefault();
	
	            if (selection && slate.Range.isExpanded(selection)) {
	              slate.Editor.deleteFragment(editor, {
	                direction: 'forward'
	              });
	            } else {
	              slate.Editor.deleteForward(editor);
	            }
	
	            return;
	          }
	
	          if (Hotkeys.isDeleteLineBackward(nativeEvent)) {
	            event.preventDefault();
	
	            if (selection && slate.Range.isExpanded(selection)) {
	              slate.Editor.deleteFragment(editor, {
	                direction: 'backward'
	              });
	            } else {
	              slate.Editor.deleteBackward(editor, {
	                unit: 'line'
	              });
	            }
	
	            return;
	          }
	
	          if (Hotkeys.isDeleteLineForward(nativeEvent)) {
	            event.preventDefault();
	
	            if (selection && slate.Range.isExpanded(selection)) {
	              slate.Editor.deleteFragment(editor, {
	                direction: 'forward'
	              });
	            } else {
	              slate.Editor.deleteForward(editor, {
	                unit: 'line'
	              });
	            }
	
	            return;
	          }
	
	          if (Hotkeys.isDeleteWordBackward(nativeEvent)) {
	            event.preventDefault();
	
	            if (selection && slate.Range.isExpanded(selection)) {
	              slate.Editor.deleteFragment(editor, {
	                direction: 'backward'
	              });
	            } else {
	              slate.Editor.deleteBackward(editor, {
	                unit: 'word'
	              });
	            }
	
	            return;
	          }
	
	          if (Hotkeys.isDeleteWordForward(nativeEvent)) {
	            event.preventDefault();
	
	            if (selection && slate.Range.isExpanded(selection)) {
	              slate.Editor.deleteFragment(editor, {
	                direction: 'forward'
	              });
	            } else {
	              slate.Editor.deleteForward(editor, {
	                unit: 'word'
	              });
	            }
	
	            return;
	          }
	        } else {
	          if (IS_CHROME || IS_SAFARI) {
	            // COMPAT: Chrome and Safari support `beforeinput` event but do not fire
	            // an event when deleting backwards in a selected void inline node
	            if (selection && (Hotkeys.isDeleteBackward(nativeEvent) || Hotkeys.isDeleteForward(nativeEvent)) && slate.Range.isCollapsed(selection)) {
	              var currentNode = slate.Node.parent(editor, selection.anchor.path);
	
	              if (slate.Element.isElement(currentNode) && slate.Editor.isVoid(editor, currentNode) && slate.Editor.isInline(editor, currentNode)) {
	                event.preventDefault();
	                slate.Editor.deleteBackward(editor, {
	                  unit: 'block'
	                });
	                return;
	              }
	            }
	          }
	        }
	      }
	    }, [readOnly, attributes.onKeyDown]),
	    onPaste: React.useCallback(function (event) {
	      if (!readOnly && hasEditableTarget(editor, event.target) && !isEventHandled(event, attributes.onPaste)) {
	        // COMPAT: Certain browsers don't support the `beforeinput` event, so we
	        // fall back to React's `onPaste` here instead.
	        // COMPAT: Firefox, Chrome and Safari don't emit `beforeinput` events
	        // when "paste without formatting" is used, so fallback. (2020/02/20)
	        if (!HAS_BEFORE_INPUT_SUPPORT || isPlainTextOnlyPaste(event.nativeEvent)) {
	          event.preventDefault();
	          ReactEditor.insertData(editor, event.clipboardData);
	        }
	      }
	    }, [readOnly, attributes.onPaste])
	  }), /*#__PURE__*/React__default['default'].createElement(Children, {
	    decorations: decorations,
	    node: editor,
	    renderElement: renderElement,
	    renderPlaceholder: renderPlaceholder,
	    renderLeaf: renderLeaf,
	    selection: editor.selection
	  }))));
	};
	/**
	 * The default placeholder element
	 */
	
	var DefaultPlaceholder = function DefaultPlaceholder(_ref3) {
	  var attributes = _ref3.attributes,
	      children = _ref3.children;
	  return /*#__PURE__*/React__default['default'].createElement("span", Object.assign({}, attributes), children);
	};
	/**
	 * A default memoized decorate function.
	 */
	
	var defaultDecorate = function defaultDecorate() {
	  return [];
	};
	/**
	 * A default implement to scroll dom range into view.
	 */
	
	var defaultScrollSelectionIntoView = function defaultScrollSelectionIntoView(editor, domRange) {
	  // This was affecting the selection of multiple blocks and dragging behavior,
	  // so enabled only if the selection has been collapsed.
	  if (!editor.selection || editor.selection && slate.Range.isCollapsed(editor.selection)) {
	    var leafEl = domRange.startContainer.parentElement;
	    leafEl.getBoundingClientRect = domRange.getBoundingClientRect.bind(domRange);
	    scrollIntoView__default['default'](leafEl, {
	      scrollMode: 'if-needed'
	    });
	    delete leafEl.getBoundingClientRect;
	  }
	};
	/**
	 * Check if the target is in the editor.
	 */
	
	
	var hasTarget = function hasTarget(editor, target) {
	  return isDOMNode(target) && ReactEditor.hasDOMNode(editor, target);
	};
	/**
	 * Check if the target is editable and in the editor.
	 */
	
	var hasEditableTarget = function hasEditableTarget(editor, target) {
	  return isDOMNode(target) && ReactEditor.hasDOMNode(editor, target, {
	    editable: true
	  });
	};
	/**
	 * Check if the target is inside void and in an non-readonly editor.
	 */
	
	var isTargetInsideNonReadonlyVoid = function isTargetInsideNonReadonlyVoid(editor, target) {
	  if (IS_READ_ONLY.get(editor)) return false;
	  var slateNode = hasTarget(editor, target) && ReactEditor.toSlateNode(editor, target);
	  return slate.Editor.isVoid(editor, slateNode);
	};
	/**
	 * Check if an event is overrided by a handler.
	 */
	
	var isEventHandled = function isEventHandled(event, handler) {
	  if (!handler) {
	    return false;
	  } // The custom event handler may return a boolean to specify whether the event
	  // shall be treated as being handled or not.
	
	
	  var shouldTreatEventAsHandled = handler(event);
	
	  if (shouldTreatEventAsHandled != null) {
	    return shouldTreatEventAsHandled;
	  }
	
	  return event.isDefaultPrevented() || event.isPropagationStopped();
	};
	/**
	 * Check if a DOM event is overrided by a handler.
	 */
	
	var isDOMEventHandled = function isDOMEventHandled(event, handler) {
	  if (!handler) {
	    return false;
	  } // The custom event handler may return a boolean to specify whether the event
	  // shall be treated as being handled or not.
	
	
	  var shouldTreatEventAsHandled = handler(event);
	
	  if (shouldTreatEventAsHandled != null) {
	    return shouldTreatEventAsHandled;
	  }
	
	  return event.defaultPrevented;
	};
	
	/**
	 * Returns the number of characters that are the same at the beginning of the
	 * String.
	 *
	 * @param prev  the previous text
	 * @param next  the next text
	 * @returns the offset of the start of the difference; null if there is no difference
	 */
	
	function getDiffStart(prev, next) {
	  var length = Math.min(prev.length, next.length);
	
	  for (var i = 0; i < length; i++) {
	    if (prev.charAt(i) !== next.charAt(i)) return i;
	  }
	
	  if (prev.length !== next.length) return length;
	  return null;
	}
	/**
	 * Returns the number of characters that are the same at the end of the String
	 * up to `max`. Max prevents double-counting characters when there are
	 * multiple duplicate characters around the diff area.
	 *
	 * @param prev  the previous text
	 * @param next  the next text
	 * @param max  the max length to test.
	 * @returns number of characters that are the same at the end of the string
	 */
	
	
	function getDiffEnd(prev, next, max) {
	  var prevLength = prev.length;
	  var nextLength = next.length;
	  var length = Math.min(prevLength, nextLength, max);
	
	  for (var i = 0; i < length; i++) {
	    var prevChar = prev.charAt(prevLength - i - 1);
	    var nextChar = next.charAt(nextLength - i - 1);
	    if (prevChar !== nextChar) return i;
	  }
	
	  if (prev.length !== next.length) return length;
	  return null;
	}
	/**
	 * Takes two strings and returns an object representing two offsets. The
	 * first, `start` represents the number of characters that are the same at
	 * the front of the String. The `end` represents the number of characters
	 * that are the same at the end of the String.
	 *
	 * Returns null if they are identical.
	 *
	 * @param prev  the previous text
	 * @param next  the next text
	 * @returns the difference text range; null if there are no differences.
	 */
	
	
	function getDiffOffsets(prev, next) {
	  if (prev === next) return null;
	  var start = getDiffStart(prev, next);
	  if (start === null) return null;
	  var maxEnd = Math.min(prev.length - start, next.length - start);
	  var end = getDiffEnd(prev, next, maxEnd);
	  if (end === null) return null;
	  return {
	    start: start,
	    end: end
	  };
	}
	/**
	 * Takes a text string and returns a slice from the string at the given text range
	 *
	 * @param text  the text
	 * @param offsets  the text range
	 * @returns the text slice at text range
	 */
	
	
	function sliceText(text, offsets) {
	  return text.slice(offsets.start, text.length - offsets.end);
	}
	/**
	 * Takes two strings and returns a smart diff that can be used to describe the
	 * change in a way that can be used as operations like inserting, removing or
	 * replacing text.
	 *
	 * @param prev the previous text
	 * @param next the next text
	 * @returns the text difference
	 */
	
	
	function diffText(prev, next) {
	  if (prev === undefined || next === undefined) return null;
	  var offsets = getDiffOffsets(prev, next);
	  if (offsets == null) return null;
	  var insertText = sliceText(next, offsets);
	  var removeText = sliceText(prev, offsets);
	  return {
	    start: offsets.start,
	    end: prev.length - offsets.end,
	    insertText: insertText,
	    removeText: removeText
	  };
	}
	function combineInsertedText(insertedText) {
	  return insertedText.reduce(function (acc, _ref) {
	    var text = _ref.text;
	    return "".concat(acc).concat(text.insertText);
	  }, '');
	}
	function getTextInsertion(editor, domNode) {
	  var node = ReactEditor.toSlateNode(editor, domNode);
	
	  if (!slate.Text.isText(node)) {
	    return undefined;
	  }
	
	  var prevText = node.text;
	  var nextText = domNode.textContent; // textContent will pad an extra \n when the textContent ends with an \n
	
	  if (nextText.endsWith('\n')) {
	    nextText = nextText.slice(0, nextText.length - 1);
	  } // If the text is no different, there is no diff.
	
	
	  if (nextText !== prevText) {
	    var textDiff = diffText(prevText, nextText);
	
	    if (textDiff !== null) {
	      var textPath = ReactEditor.findPath(editor, node);
	      return {
	        text: textDiff,
	        path: textPath
	      };
	    }
	  }
	
	  return undefined;
	}
	function normalizeTextInsertionRange(editor, range, _ref2) {
	  var path = _ref2.path,
	      text = _ref2.text;
	  var insertionRange = {
	    anchor: {
	      path: path,
	      offset: text.start
	    },
	    focus: {
	      path: path,
	      offset: text.end
	    }
	  };
	
	  if (!range || !slate.Range.isCollapsed(range)) {
	    return insertionRange;
	  }
	
	  var insertText = text.insertText,
	      removeText = text.removeText;
	  var isSingleCharacterInsertion = insertText.length === 1 || removeText.length === 1;
	  /**
	   * This code handles edge cases that arise from text diffing when the
	   * inserted or removed character is a single character, and the character
	   * right before or after the anchor is the same as the one being inserted or
	   * removed.
	   *
	   * Take this example: hello|o
	   *
	   * If another `o` is inserted at the selection's anchor in the example above,
	   * it should be inserted at the anchor, but using text diffing, we actually
	   * detect that the character was inserted after the second `o`:
	   *
	   * helloo[o]|
	   *
	   * Instead, in these very specific edge cases, we assume that the character
	   * needs to be inserted after the anchor rather than where the diff was found:
	   *
	   * hello[o]|o
	   */
	
	  if (isSingleCharacterInsertion && slate.Path.equals(range.anchor.path, path)) {
	    var _Array$from = Array.from(slate.Editor.nodes(editor, {
	      at: range,
	      match: slate.Text.isText
	    })),
	        _Array$from2 = _slicedToArray(_Array$from, 1),
	        _text = _Array$from2[0];
	
	    if (_text) {
	      var _text2 = _slicedToArray(_text, 1),
	          node = _text2[0];
	
	      var anchor = range.anchor;
	      var characterBeforeAnchor = node.text[anchor.offset - 1];
	      var characterAfterAnchor = node.text[anchor.offset];
	
	      if (insertText.length === 1 && insertText === characterAfterAnchor) {
	        // Assume text should be inserted at the anchor
	        return range;
	      }
	
	      if (removeText.length === 1 && removeText === characterBeforeAnchor) {
	        // Assume text should be removed right before the anchor
	        return {
	          anchor: {
	            path: path,
	            offset: anchor.offset - 1
	          },
	          focus: {
	            path: path,
	            offset: anchor.offset
	          }
	        };
	      }
	    }
	  }
	
	  return insertionRange;
	}
	
	var classCallCheck = createCommonjsModule(function (module) {
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	module.exports = _classCallCheck;
	module.exports["default"] = module.exports, module.exports.__esModule = true;
	});
	
	var _classCallCheck = unwrapExports(classCallCheck);
	
	/**
	 * An auto-incrementing identifier for keys.
	 */
	var n = 0;
	/**
	 * A class that keeps track of a key string. We use a full class here because we
	 * want to be able to use them as keys in `WeakMap` objects.
	 */
	
	var Key = function Key() {
	  _classCallCheck(this, Key);
	
	  this.id = "".concat(n++);
	};
	
	var ReactEditor = {
	  /**
	   * Check if the user is currently composing inside the editor.
	   */
	  isComposing: function isComposing(editor) {
	    return !!IS_COMPOSING.get(editor);
	  },
	
	  /**
	   * Return the host window of the current editor.
	   */
	  getWindow: function getWindow(editor) {
	    var window = EDITOR_TO_WINDOW.get(editor);
	
	    if (!window) {
	      throw new Error('Unable to find a host window element for this editor');
	    }
	
	    return window;
	  },
	
	  /**
	   * Find a key for a Slate node.
	   */
	  findKey: function findKey(editor, node) {
	    var key = NODE_TO_KEY.get(node);
	
	    if (!key) {
	      key = new Key();
	      NODE_TO_KEY.set(node, key);
	    }
	
	    return key;
	  },
	
	  /**
	   * Find the path of Slate node.
	   */
	  findPath: function findPath(editor, node) {
	    var path = [];
	    var child = node;
	
	    while (true) {
	      var parent = NODE_TO_PARENT.get(child);
	
	      if (parent == null) {
	        if (slate.Editor.isEditor(child)) {
	          return path;
	        } else {
	          break;
	        }
	      }
	
	      var i = NODE_TO_INDEX.get(child);
	
	      if (i == null) {
	        break;
	      }
	
	      path.unshift(i);
	      child = parent;
	    }
	
	    throw new Error("Unable to find the path for Slate node: ".concat(JSON.stringify(node)));
	  },
	
	  /**
	   * Find the DOM node that implements DocumentOrShadowRoot for the editor.
	   */
	  findDocumentOrShadowRoot: function findDocumentOrShadowRoot(editor) {
	    var el = ReactEditor.toDOMNode(editor, editor);
	    var root = el.getRootNode();
	
	    if ((root instanceof Document || root instanceof ShadowRoot) && root.getSelection != null) {
	      return root;
	    }
	
	    return el.ownerDocument;
	  },
	
	  /**
	   * Check if the editor is focused.
	   */
	  isFocused: function isFocused(editor) {
	    return !!IS_FOCUSED.get(editor);
	  },
	
	  /**
	   * Check if the editor is in read-only mode.
	   */
	  isReadOnly: function isReadOnly(editor) {
	    return !!IS_READ_ONLY.get(editor);
	  },
	
	  /**
	   * Blur the editor.
	   */
	  blur: function blur(editor) {
	    var el = ReactEditor.toDOMNode(editor, editor);
	    var root = ReactEditor.findDocumentOrShadowRoot(editor);
	    IS_FOCUSED.set(editor, false);
	
	    if (root.activeElement === el) {
	      el.blur();
	    }
	  },
	
	  /**
	   * Focus the editor.
	   */
	  focus: function focus(editor) {
	    var el = ReactEditor.toDOMNode(editor, editor);
	    var root = ReactEditor.findDocumentOrShadowRoot(editor);
	    IS_FOCUSED.set(editor, true);
	
	    if (root.activeElement !== el) {
	      el.focus({
	        preventScroll: true
	      });
	    }
	  },
	
	  /**
	   * Deselect the editor.
	   */
	  deselect: function deselect(editor) {
	    ReactEditor.toDOMNode(editor, editor);
	    var selection = editor.selection;
	    var root = ReactEditor.findDocumentOrShadowRoot(editor);
	    var domSelection = root.getSelection();
	
	    if (domSelection && domSelection.rangeCount > 0) {
	      domSelection.removeAllRanges();
	    }
	
	    if (selection) {
	      slate.Transforms.deselect(editor);
	    }
	  },
	
	  /**
	   * Check if a DOM node is within the editor.
	   */
	  hasDOMNode: function hasDOMNode(editor, target) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var _options$editable = options.editable,
	        editable = _options$editable === void 0 ? false : _options$editable;
	    var editorEl = ReactEditor.toDOMNode(editor, editor);
	    var targetEl; // COMPAT: In Firefox, reading `target.nodeType` will throw an error if
	    // target is originating from an internal "restricted" element (e.g. a
	    // stepper arrow on a number input). (2018/05/04)
	    // https://github.com/ianstormtaylor/slate/issues/1819
	
	    try {
	      targetEl = isDOMElement(target) ? target : target.parentElement;
	    } catch (err) {
	      if (!err.message.includes('Permission denied to access property "nodeType"')) {
	        throw err;
	      }
	    }
	
	    if (!targetEl) {
	      return false;
	    }
	
	    return targetEl.closest("[data-slate-editor]") === editorEl && (!editable || targetEl.isContentEditable ? true : typeof targetEl.isContentEditable === 'boolean' && // isContentEditable exists only on HTMLElement, and on other nodes it will be undefined
	    // this is the core logic that lets you know you got the right editor.selection instead of null when editor is contenteditable="false"(readOnly)
	    targetEl.closest('[contenteditable="false"]') === editorEl || !!targetEl.getAttribute('data-slate-zero-width'));
	  },
	
	  /**
	   * Insert data from a `DataTransfer` into the editor.
	   */
	  insertData: function insertData(editor, data) {
	    editor.insertData(data);
	  },
	
	  /**
	   * Insert fragment data from a `DataTransfer` into the editor.
	   */
	  insertFragmentData: function insertFragmentData(editor, data) {
	    return editor.insertFragmentData(data);
	  },
	
	  /**
	   * Insert text data from a `DataTransfer` into the editor.
	   */
	  insertTextData: function insertTextData(editor, data) {
	    return editor.insertTextData(data);
	  },
	
	  /**
	   * Sets data from the currently selected fragment on a `DataTransfer`.
	   */
	  setFragmentData: function setFragmentData(editor, data, originEvent) {
	    editor.setFragmentData(data, originEvent);
	  },
	
	  /**
	   * Find the native DOM element from a Slate node.
	   */
	  toDOMNode: function toDOMNode(editor, node) {
	    var KEY_TO_ELEMENT = EDITOR_TO_KEY_TO_ELEMENT.get(editor);
	    var domNode = slate.Editor.isEditor(node) ? EDITOR_TO_ELEMENT.get(editor) : KEY_TO_ELEMENT === null || KEY_TO_ELEMENT === void 0 ? void 0 : KEY_TO_ELEMENT.get(ReactEditor.findKey(editor, node));
	
	    if (!domNode) {
	      throw new Error("Cannot resolve a DOM node from Slate node: ".concat(JSON.stringify(node)));
	    }
	
	    return domNode;
	  },
	
	  /**
	   * Find a native DOM selection point from a Slate point.
	   */
	  toDOMPoint: function toDOMPoint(editor, point) {
	    var _Editor$node = slate.Editor.node(editor, point.path),
	        _Editor$node2 = _slicedToArray(_Editor$node, 1),
	        node = _Editor$node2[0];
	
	    var el = ReactEditor.toDOMNode(editor, node);
	    var domPoint; // If we're inside a void node, force the offset to 0, otherwise the zero
	    // width spacing character will result in an incorrect offset of 1
	
	    if (slate.Editor["void"](editor, {
	      at: point
	    })) {
	      point = {
	        path: point.path,
	        offset: 0
	      };
	    } // For each leaf, we need to isolate its content, which means filtering
	    // to its direct text and zero-width spans. (We have to filter out any
	    // other siblings that may have been rendered alongside them.)
	
	
	    var selector = "[data-slate-string], [data-slate-zero-width]";
	    var texts = Array.from(el.querySelectorAll(selector));
	    var start = 0;
	
	    for (var _i = 0, _texts = texts; _i < _texts.length; _i++) {
	      var text = _texts[_i];
	      var domNode = text.childNodes[0];
	
	      if (domNode == null || domNode.textContent == null) {
	        continue;
	      }
	
	      var length = domNode.textContent.length;
	      var attr = text.getAttribute('data-slate-length');
	      var trueLength = attr == null ? length : parseInt(attr, 10);
	      var end = start + trueLength;
	
	      if (point.offset <= end) {
	        var offset = Math.min(length, Math.max(0, point.offset - start));
	        domPoint = [domNode, offset];
	        break;
	      }
	
	      start = end;
	    }
	
	    if (!domPoint) {
	      throw new Error("Cannot resolve a DOM point from Slate point: ".concat(JSON.stringify(point)));
	    }
	
	    return domPoint;
	  },
	
	  /**
	   * Find a native DOM range from a Slate `range`.
	   *
	   * Notice: the returned range will always be ordinal regardless of the direction of Slate `range` due to DOM API limit.
	   *
	   * there is no way to create a reverse DOM Range using Range.setStart/setEnd
	   * according to https://dom.spec.whatwg.org/#concept-range-bp-set.
	   */
	  toDOMRange: function toDOMRange(editor, range) {
	    var anchor = range.anchor,
	        focus = range.focus;
	    var isBackward = slate.Range.isBackward(range);
	    var domAnchor = ReactEditor.toDOMPoint(editor, anchor);
	    var domFocus = slate.Range.isCollapsed(range) ? domAnchor : ReactEditor.toDOMPoint(editor, focus);
	    var window = ReactEditor.getWindow(editor);
	    var domRange = window.document.createRange();
	
	    var _ref = isBackward ? domFocus : domAnchor,
	        _ref2 = _slicedToArray(_ref, 2),
	        startNode = _ref2[0],
	        startOffset = _ref2[1];
	
	    var _ref3 = isBackward ? domAnchor : domFocus,
	        _ref4 = _slicedToArray(_ref3, 2),
	        endNode = _ref4[0],
	        endOffset = _ref4[1]; // A slate Point at zero-width Leaf always has an offset of 0 but a native DOM selection at
	    // zero-width node has an offset of 1 so we have to check if we are in a zero-width node and
	    // adjust the offset accordingly.
	
	
	    var startEl = isDOMElement(startNode) ? startNode : startNode.parentElement;
	    var isStartAtZeroWidth = !!startEl.getAttribute('data-slate-zero-width');
	    var endEl = isDOMElement(endNode) ? endNode : endNode.parentElement;
	    var isEndAtZeroWidth = !!endEl.getAttribute('data-slate-zero-width');
	    domRange.setStart(startNode, isStartAtZeroWidth ? 1 : startOffset);
	    domRange.setEnd(endNode, isEndAtZeroWidth ? 1 : endOffset);
	    return domRange;
	  },
	
	  /**
	   * Find a Slate node from a native DOM `element`.
	   */
	  toSlateNode: function toSlateNode(editor, domNode) {
	    var domEl = isDOMElement(domNode) ? domNode : domNode.parentElement;
	
	    if (domEl && !domEl.hasAttribute('data-slate-node')) {
	      domEl = domEl.closest("[data-slate-node]");
	    }
	
	    var node = domEl ? ELEMENT_TO_NODE.get(domEl) : null;
	
	    if (!node) {
	      throw new Error("Cannot resolve a Slate node from DOM node: ".concat(domEl));
	    }
	
	    return node;
	  },
	
	  /**
	   * Get the target range from a DOM `event`.
	   */
	  findEventRange: function findEventRange(editor, event) {
	    if ('nativeEvent' in event) {
	      event = event.nativeEvent;
	    }
	
	    var _event = event,
	        x = _event.clientX,
	        y = _event.clientY,
	        target = _event.target;
	
	    if (x == null || y == null) {
	      throw new Error("Cannot resolve a Slate range from a DOM event: ".concat(event));
	    }
	
	    var node = ReactEditor.toSlateNode(editor, event.target);
	    var path = ReactEditor.findPath(editor, node); // If the drop target is inside a void node, move it into either the
	    // next or previous node, depending on which side the `x` and `y`
	    // coordinates are closest to.
	
	    if (slate.Editor.isVoid(editor, node)) {
	      var rect = target.getBoundingClientRect();
	      var isPrev = editor.isInline(node) ? x - rect.left < rect.left + rect.width - x : y - rect.top < rect.top + rect.height - y;
	      var edge = slate.Editor.point(editor, path, {
	        edge: isPrev ? 'start' : 'end'
	      });
	      var point = isPrev ? slate.Editor.before(editor, edge) : slate.Editor.after(editor, edge);
	
	      if (point) {
	        var _range = slate.Editor.range(editor, point);
	
	        return _range;
	      }
	    } // Else resolve a range from the caret position where the drop occured.
	
	
	    var domRange;
	
	    var _ReactEditor$getWindo = ReactEditor.getWindow(editor),
	        document = _ReactEditor$getWindo.document; // COMPAT: In Firefox, `caretRangeFromPoint` doesn't exist. (2016/07/25)
	
	
	    if (document.caretRangeFromPoint) {
	      domRange = document.caretRangeFromPoint(x, y);
	    } else {
	      var position = document.caretPositionFromPoint(x, y);
	
	      if (position) {
	        domRange = document.createRange();
	        domRange.setStart(position.offsetNode, position.offset);
	        domRange.setEnd(position.offsetNode, position.offset);
	      }
	    }
	
	    if (!domRange) {
	      throw new Error("Cannot resolve a Slate range from a DOM event: ".concat(event));
	    } // Resolve a Slate range from the DOM range.
	
	
	    var range = ReactEditor.toSlateRange(editor, domRange, {
	      exactMatch: false,
	      suppressThrow: false
	    });
	    return range;
	  },
	
	  /**
	   * Find a Slate point from a DOM selection's `domNode` and `domOffset`.
	   */
	  toSlatePoint: function toSlatePoint(editor, domPoint, options) {
	    var exactMatch = options.exactMatch,
	        suppressThrow = options.suppressThrow;
	
	    var _ref5 = exactMatch ? domPoint : normalizeDOMPoint(domPoint),
	        _ref6 = _slicedToArray(_ref5, 2),
	        nearestNode = _ref6[0],
	        nearestOffset = _ref6[1];
	
	    var parentNode = nearestNode.parentNode;
	    var textNode = null;
	    var offset = 0;
	
	    if (parentNode) {
	      var _domNode$textContent;
	
	      var editorEl = ReactEditor.toDOMNode(editor, editor);
	      var potentialVoidNode = parentNode.closest('[data-slate-void="true"]'); // Need to ensure that the closest void node is actually a void node
	      // within this editor, and not a void node within some parent editor. This can happen
	      // if this editor is within a void node of another editor ("nested editors", like in
	      // the "Editable Voids" example on the docs site).
	
	      var voidNode = potentialVoidNode && editorEl.contains(potentialVoidNode) ? potentialVoidNode : null;
	      var leafNode = parentNode.closest('[data-slate-leaf]');
	      var domNode = null; // Calculate how far into the text node the `nearestNode` is, so that we
	      // can determine what the offset relative to the text node is.
	
	      if (leafNode) {
	        textNode = leafNode.closest('[data-slate-node="text"]');
	
	        if (textNode) {
	          var window = ReactEditor.getWindow(editor);
	          var range = window.document.createRange();
	          range.setStart(textNode, 0);
	          range.setEnd(nearestNode, nearestOffset);
	          var contents = range.cloneContents();
	          var removals = [].concat(_toConsumableArray(Array.prototype.slice.call(contents.querySelectorAll('[data-slate-zero-width]'))), _toConsumableArray(Array.prototype.slice.call(contents.querySelectorAll('[contenteditable=false]'))));
	          removals.forEach(function (el) {
	            el.parentNode.removeChild(el);
	          }); // COMPAT: Edge has a bug where Range.prototype.toString() will
	          // convert \n into \r\n. The bug causes a loop when slate-react
	          // attempts to reposition its cursor to match the native position. Use
	          // textContent.length instead.
	          // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/10291116/
	
	          offset = contents.textContent.length;
	          domNode = textNode;
	        }
	      } else if (voidNode) {
	        // For void nodes, the element with the offset key will be a cousin, not an
	        // ancestor, so find it by going down from the nearest void parent.
	        leafNode = voidNode.querySelector('[data-slate-leaf]'); // COMPAT: In read-only editors the leaf is not rendered.
	
	        if (!leafNode) {
	          offset = 1;
	        } else {
	          textNode = leafNode.closest('[data-slate-node="text"]');
	          domNode = leafNode;
	          offset = domNode.textContent.length;
	          domNode.querySelectorAll('[data-slate-zero-width]').forEach(function (el) {
	            offset -= el.textContent.length;
	          });
	        }
	      }
	
	      if (domNode && offset === domNode.textContent.length && (parentNode.hasAttribute('data-slate-zero-width') || IS_FIREFOX && (_domNode$textContent = domNode.textContent) !== null && _domNode$textContent !== void 0 && _domNode$textContent.endsWith('\n\n'))) {
	        offset--;
	      }
	    }
	
	    if (!textNode) {
	      if (suppressThrow) {
	        return null;
	      }
	
	      throw new Error("Cannot resolve a Slate point from DOM point: ".concat(domPoint));
	    } // COMPAT: If someone is clicking from one Slate editor into another,
	    // the select event fires twice, once for the old editor's `element`
	    // first, and then afterwards for the correct `element`. (2017/03/03)
	
	
	    var slateNode = ReactEditor.toSlateNode(editor, textNode);
	    var path = ReactEditor.findPath(editor, slateNode);
	    return {
	      path: path,
	      offset: offset
	    };
	  },
	
	  /**
	   * Find a Slate range from a DOM range or selection.
	   */
	  toSlateRange: function toSlateRange(editor, domRange, options) {
	    var exactMatch = options.exactMatch,
	        suppressThrow = options.suppressThrow;
	    var el = isDOMSelection(domRange) ? domRange.anchorNode : domRange.startContainer;
	    var anchorNode;
	    var anchorOffset;
	    var focusNode;
	    var focusOffset;
	    var isCollapsed;
	
	    if (el) {
	      if (isDOMSelection(domRange)) {
	        anchorNode = domRange.anchorNode;
	        anchorOffset = domRange.anchorOffset;
	        focusNode = domRange.focusNode;
	        focusOffset = domRange.focusOffset; // COMPAT: There's a bug in chrome that always returns `true` for
	        // `isCollapsed` for a Selection that comes from a ShadowRoot.
	        // (2020/08/08)
	        // https://bugs.chromium.org/p/chromium/issues/detail?id=447523
	
	        if (IS_CHROME && hasShadowRoot()) {
	          isCollapsed = domRange.anchorNode === domRange.focusNode && domRange.anchorOffset === domRange.focusOffset;
	        } else {
	          isCollapsed = domRange.isCollapsed;
	        }
	      } else {
	        anchorNode = domRange.startContainer;
	        anchorOffset = domRange.startOffset;
	        focusNode = domRange.endContainer;
	        focusOffset = domRange.endOffset;
	        isCollapsed = domRange.collapsed;
	      }
	    }
	
	    if (anchorNode == null || focusNode == null || anchorOffset == null || focusOffset == null) {
	      throw new Error("Cannot resolve a Slate range from DOM range: ".concat(domRange));
	    }
	
	    var anchor = ReactEditor.toSlatePoint(editor, [anchorNode, anchorOffset], {
	      exactMatch: exactMatch,
	      suppressThrow: suppressThrow
	    });
	
	    if (!anchor) {
	      return null;
	    }
	
	    var focus = isCollapsed ? anchor : ReactEditor.toSlatePoint(editor, [focusNode, focusOffset], {
	      exactMatch: exactMatch,
	      suppressThrow: suppressThrow
	    });
	
	    if (!focus) {
	      return null;
	    }
	
	    var range = {
	      anchor: anchor,
	      focus: focus
	    }; // if the selection is a hanging range that ends in a void
	    // and the DOM focus is an Element
	    // (meaning that the selection ends before the element)
	    // unhang the range to avoid mistakenly including the void
	
	    if (slate.Range.isExpanded(range) && slate.Range.isForward(range) && isDOMElement(focusNode) && slate.Editor["void"](editor, {
	      at: range.focus,
	      mode: 'highest'
	    })) {
	      range = slate.Editor.unhangRange(editor, range, {
	        voids: true
	      });
	    }
	
	    return range;
	  },
	  hasRange: function hasRange(editor, range) {
	    var anchor = range.anchor,
	        focus = range.focus;
	    return slate.Editor.hasPath(editor, anchor.path) && slate.Editor.hasPath(editor, focus.path);
	  }
	};
	
	function gatherMutationData(editor, mutations) {
	  var addedNodes = [];
	  var removedNodes = [];
	  var insertedText = [];
	  var characterDataMutations = [];
	  mutations.forEach(function (mutation) {
	    switch (mutation.type) {
	      case 'childList':
	        {
	          if (mutation.addedNodes.length) {
	            mutation.addedNodes.forEach(function (addedNode) {
	              addedNodes.push(addedNode);
	            });
	          }
	
	          mutation.removedNodes.forEach(function (removedNode) {
	            removedNodes.push(removedNode);
	          });
	          break;
	        }
	
	      case 'characterData':
	        {
	          characterDataMutations.push(mutation); // Changes to text nodes should consider the parent element
	
	          var parentNode = mutation.target.parentNode;
	
	          if (!parentNode) {
	            return;
	          }
	
	          var textInsertion = getTextInsertion(editor, parentNode);
	
	          if (!textInsertion) {
	            return;
	          } // If we've already detected a diff at that path, we can return early
	
	
	          if (insertedText.some(function (_ref) {
	            var path = _ref.path;
	            return slate.Path.equals(path, textInsertion.path);
	          })) {
	            return;
	          } // Add the text diff to the array of detected text insertions that need to be reconciled
	
	
	          insertedText.push(textInsertion);
	        }
	    }
	  });
	  return {
	    addedNodes: addedNodes,
	    removedNodes: removedNodes,
	    insertedText: insertedText,
	    characterDataMutations: characterDataMutations
	  };
	}
	/**
	 * In general, when a line break occurs, there will be more `addedNodes` than `removedNodes`.
	 *
	 * This isn't always the case however. In some cases, there will be more `removedNodes` than
	 * `addedNodes`.
	 *
	 * To account for these edge cases, the most reliable strategy to detect line break mutations
	 * is to check whether a new block was inserted of the same type as the current block.
	 */
	
	var isLineBreak = function isLineBreak(editor, _ref2) {
	  var addedNodes = _ref2.addedNodes;
	  var selection = editor.selection;
	  var parentNode = selection ? slate.Node.parent(editor, selection.anchor.path) : null;
	  var parentDOMNode = parentNode ? ReactEditor.toDOMNode(editor, parentNode) : null;
	
	  if (!parentDOMNode) {
	    return false;
	  }
	
	  return addedNodes.some(function (addedNode) {
	    return addedNode instanceof HTMLElement && addedNode.tagName === (parentDOMNode === null || parentDOMNode === void 0 ? void 0 : parentDOMNode.tagName);
	  });
	};
	/**
	 * So long as we check for line break mutations before deletion mutations,
	 * we can safely assume that a set of mutations was a deletion if there are
	 * removed nodes.
	 */
	
	var isDeletion = function isDeletion(_, _ref3) {
	  var removedNodes = _ref3.removedNodes;
	  return removedNodes.length > 0;
	};
	/**
	 * If the selection was expanded and there are removed nodes,
	 * the contents of the selection need to be replaced with the diff
	 */
	
	var isReplaceExpandedSelection = function isReplaceExpandedSelection(_ref4, _ref5) {
	  var selection = _ref4.selection;
	  var removedNodes = _ref5.removedNodes;
	  return selection ? slate.Range.isExpanded(selection) && removedNodes.length > 0 : false;
	};
	/**
	 * Plain text insertion
	 */
	
	var isTextInsertion = function isTextInsertion(_, _ref6) {
	  var insertedText = _ref6.insertedText;
	  return insertedText.length > 0;
	};
	/**
	 * Edge case. Detect mutations that remove leaf nodes and also update character data
	 */
	
	var isRemoveLeafNodes = function isRemoveLeafNodes(_, _ref7) {
	  var addedNodes = _ref7.addedNodes,
	      characterDataMutations = _ref7.characterDataMutations,
	      removedNodes = _ref7.removedNodes;
	  return removedNodes.length > 0 && addedNodes.length === 0 && characterDataMutations.length > 0;
	};
	
	function _createForOfIteratorHelper$1(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$1(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
	
	function _unsupportedIterableToArray$1(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen); }
	
	function _arrayLikeToArray$1(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	/**
	 * Based loosely on:
	 *
	 * https://github.com/facebook/draft-js/blob/master/src/component/handlers/composition/DOMObserver.js
	 * https://github.com/ProseMirror/prosemirror-view/blob/master/src/domobserver.js
	 *
	 * The input manager attempts to map observed mutations on the document to a
	 * set of operations in order to reconcile Slate's internal value with the DOM.
	 *
	 * Mutations are processed synchronously as they come in. Only mutations that occur
	 * during a user input loop are processed, as other mutations can occur within the
	 * document that were not initiated by user input.
	 *
	 * The mutation reconciliation process attempts to match mutations to the following
	 * patterns:
	 *
	 * - Text updates
	 * - Deletions
	 * - Line breaks
	 *
	 * @param editor
	 * @param restoreDOM
	 */
	
	
	var AndroidInputManager = function AndroidInputManager(editor, restoreDOM) {
	  var _this = this;
	
	  _classCallCheck(this, AndroidInputManager);
	
	  this.editor = editor;
	  this.restoreDOM = restoreDOM;
	  /**
	   * Handle MutationObserver flush
	   *
	   * @param mutations
	   */
	
	  this.flush = function (mutations) {
	
	    try {
	      _this.reconcileMutations(mutations);
	    } catch (err) {
	      // eslint-disable-next-line no-console
	      console.error(err); // Failed to reconcile mutations, restore DOM to its previous state
	
	      _this.restoreDOM();
	    }
	  };
	  /**
	   * Reconcile a batch of mutations
	   *
	   * @param mutations
	   */
	
	
	  this.reconcileMutations = function (mutations) {
	    var mutationData = gatherMutationData(_this.editor, mutations);
	    var insertedText = mutationData.insertedText,
	        removedNodes = mutationData.removedNodes;
	
	    if (isReplaceExpandedSelection(_this.editor, mutationData)) {
	      var text = combineInsertedText(insertedText);
	
	      _this.replaceExpandedSelection(text);
	    } else if (isLineBreak(_this.editor, mutationData)) {
	      _this.insertBreak();
	    } else if (isRemoveLeafNodes(_this.editor, mutationData)) {
	      _this.removeLeafNodes(removedNodes);
	    } else if (isDeletion(_this.editor, mutationData)) {
	      _this.deleteBackward();
	    } else if (isTextInsertion(_this.editor, mutationData)) {
	      _this.insertText(insertedText);
	    }
	  };
	  /**
	   * Apply text diff
	   */
	
	
	  this.insertText = function (insertedText) {
	    var selection = _this.editor.selection; // If it is in composing or after `onCompositionend`, set `EDITOR_ON_COMPOSITION_TEXT` and return.
	    // Text will be inserted on compositionend event.
	
	    if (ReactEditor.isComposing(_this.editor) || IS_ON_COMPOSITION_END.get(_this.editor)) {
	      EDITOR_ON_COMPOSITION_TEXT.set(_this.editor, insertedText);
	      IS_ON_COMPOSITION_END.set(_this.editor, false);
	      return;
	    } // Insert the batched text diffs
	
	
	    insertedText.forEach(function (insertion) {
	      var text = insertion.text.insertText;
	      var at = normalizeTextInsertionRange(_this.editor, selection, insertion);
	      slate.Transforms.setSelection(_this.editor, at);
	      slate.Editor.insertText(_this.editor, text);
	    });
	  };
	  /**
	   * Handle line breaks
	   */
	
	
	  this.insertBreak = function () {
	    var selection = _this.editor.selection;
	    slate.Editor.insertBreak(_this.editor);
	
	    _this.restoreDOM();
	
	    if (selection) {
	      // Compat: Move selection to the newly inserted block if it has not moved
	      setTimeout(function () {
	        if (_this.editor.selection && slate.Range.equals(selection, _this.editor.selection)) {
	          slate.Transforms.move(_this.editor);
	        }
	      }, 100);
	    }
	  };
	  /**
	   * Handle expanded selection being deleted or replaced by text
	   */
	
	
	  this.replaceExpandedSelection = function (text) {
	
	    slate.Editor.deleteFragment(_this.editor);
	
	    if (text.length) {
	      // Selection was replaced by text, insert the entire text diff
	      slate.Editor.insertText(_this.editor, text);
	    }
	
	    _this.restoreDOM();
	  };
	  /**
	   * Handle `backspace` that merges blocks
	   */
	
	
	  this.deleteBackward = function () {
	    slate.Editor.deleteBackward(_this.editor);
	    ReactEditor.focus(_this.editor);
	
	    _this.restoreDOM();
	  };
	  /**
	   * Handle mutations that remove specific leaves
	   */
	
	
	  this.removeLeafNodes = function (nodes) {
	    var _iterator = _createForOfIteratorHelper$1(nodes),
	        _step;
	
	    try {
	      for (_iterator.s(); !(_step = _iterator.n()).done;) {
	        var node = _step.value;
	        var slateNode = ReactEditor.toSlateNode(_this.editor, node);
	
	        if (slateNode) {
	          var path = ReactEditor.findPath(_this.editor, slateNode);
	          slate.Transforms["delete"](_this.editor, {
	            at: path
	          });
	
	          _this.restoreDOM();
	        }
	      }
	    } catch (err) {
	      _iterator.e(err);
	    } finally {
	      _iterator.f();
	    }
	  };
	
	  this.editor = editor;
	  this.restoreDOM = restoreDOM;
	};
	
	function useMutationObserver(node, callback, options) {
	  var _useState = React.useState(function () {
	    return new MutationObserver(callback);
	  }),
	      _useState2 = _slicedToArray(_useState, 1),
	      mutationObserver = _useState2[0];
	
	  useIsomorphicLayoutEffect(function () {
	    // Disconnect mutation observer during render phase
	    mutationObserver.disconnect();
	  });
	  React.useEffect(function () {
	    if (!node.current) {
	      throw new Error('Failed to attach MutationObserver, `node` is undefined');
	    } // Attach mutation observer after render phase has finished
	
	
	    mutationObserver.observe(node.current, options); // Clean up after effect
	
	    return mutationObserver.disconnect.bind(mutationObserver);
	  });
	}
	
	var MUTATION_OBSERVER_CONFIG$1 = {
	  childList: true,
	  characterData: true,
	  subtree: true
	};
	
	function findClosestKnowSlateNode(domNode) {
	  var _domEl;
	
	  var domEl = isDOMElement(domNode) ? domNode : domNode.parentElement;
	
	  if (domEl && !domEl.hasAttribute('data-slate-node')) {
	    domEl = domEl.closest("[data-slate-node]");
	  }
	
	  var slateNode = domEl && ELEMENT_TO_NODE.get(domEl);
	
	  if (slateNode) {
	    return slateNode;
	  } // Unknown dom element with a slate-slate-node attribute => the IME
	  // most likely duplicated the node so we have to restore the parent
	
	
	  return (_domEl = domEl) !== null && _domEl !== void 0 && _domEl.parentElement ? findClosestKnowSlateNode(domEl.parentElement) : null;
	}
	
	function useRestoreDom(node, receivedUserInput) {
	  var editor = useSlateStatic();
	  var mutatedNodes = React.useRef(new Set());
	  var handleDOMMutation = React.useCallback(function (mutations) {
	    if (!receivedUserInput.current) {
	      return;
	    }
	
	    mutations.forEach(function (_ref) {
	      var target = _ref.target;
	      var slateNode = findClosestKnowSlateNode(target);
	
	      if (!slateNode) {
	        return;
	      }
	
	      return mutatedNodes.current.add(slateNode);
	    });
	  }, []);
	  useMutationObserver(node, handleDOMMutation, MUTATION_OBSERVER_CONFIG$1); // Clear mutated nodes on every render
	
	  mutatedNodes.current.clear();
	  var restore = React.useCallback(function () {
	    var mutated = Array.from(mutatedNodes.current.values()); // Filter out child nodes of nodes that will be restored anyway
	
	    var nodesToRestore = mutated.filter(function (n) {
	      return !mutated.some(function (m) {
	        return slate.Path.isParent(ReactEditor.findPath(editor, m), ReactEditor.findPath(editor, n));
	      });
	    });
	    nodesToRestore.forEach(function (n) {
	      var _NODE_TO_RESTORE_DOM$;
	
	      (_NODE_TO_RESTORE_DOM$ = NODE_TO_RESTORE_DOM.get(n)) === null || _NODE_TO_RESTORE_DOM$ === void 0 ? void 0 : _NODE_TO_RESTORE_DOM$();
	    });
	    mutatedNodes.current.clear();
	  }, []);
	  return restore;
	}
	
	function useTrackUserInput() {
	  var editor = useSlateStatic();
	  var receivedUserInput = React.useRef(false);
	  var animationFrameRef = React.useRef(null);
	  var onUserInput = React.useCallback(function () {
	    if (receivedUserInput.current === false) {
	      var window = ReactEditor.getWindow(editor);
	      receivedUserInput.current = true;
	
	      if (animationFrameRef.current) {
	        window.cancelAnimationFrame(animationFrameRef.current);
	      }
	
	      animationFrameRef.current = window.requestAnimationFrame(function () {
	        receivedUserInput.current = false;
	        animationFrameRef.current = null;
	      });
	    }
	  }, []);
	  React.useEffect(function () {
	    // Reset user input tracking on every render
	    if (receivedUserInput.current) {
	      receivedUserInput.current = false;
	    }
	  });
	  return {
	    receivedUserInput: receivedUserInput,
	    onUserInput: onUserInput
	  };
	}
	
	var MUTATION_OBSERVER_CONFIG = {
	  childList: true,
	  characterData: true,
	  characterDataOldValue: true,
	  subtree: true
	};
	function useAndroidInputManager(node) {
	  var editor = useSlateStatic();
	
	  var _useTrackUserInput = useTrackUserInput(),
	      receivedUserInput = _useTrackUserInput.receivedUserInput,
	      onUserInput = _useTrackUserInput.onUserInput;
	
	  var restoreDom = useRestoreDom(node, receivedUserInput);
	  var inputManager = React.useMemo(function () {
	    return new AndroidInputManager(editor, restoreDom);
	  }, [restoreDom, editor]);
	  var timeoutId = React.useRef(null);
	  var isReconciling = React.useRef(false);
	  var flush = React.useCallback(function (mutations) {
	    if (!receivedUserInput.current) {
	      return;
	    }
	
	    isReconciling.current = true;
	    inputManager.flush(mutations);
	
	    if (timeoutId.current) {
	      clearTimeout(timeoutId.current);
	    }
	
	    timeoutId.current = setTimeout(function () {
	      isReconciling.current = false;
	      timeoutId.current = null;
	    }, 250);
	  }, []);
	  useMutationObserver(node, flush, MUTATION_OBSERVER_CONFIG);
	  return {
	    isReconciling: isReconciling,
	    onUserInput: onUserInput
	  };
	}
	
	var _excluded$1 = ["autoFocus", "decorate", "onDOMBeforeInput", "placeholder", "readOnly", "renderElement", "renderLeaf", "renderPlaceholder", "style", "as"];
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	/**
	 * Editable.
	 */
	// https://github.com/facebook/draft-js/blob/main/src/component/handlers/composition/DraftEditorCompositionHandler.js#L41
	// When using keyboard English association function, conpositionEnd triggered too fast, resulting in after `insertText` still maintain association state.
	
	var RESOLVE_DELAY = 20;
	var AndroidEditable = function AndroidEditable(props) {
	  var autoFocus = props.autoFocus,
	      _props$decorate = props.decorate,
	      decorate = _props$decorate === void 0 ? defaultDecorate : _props$decorate,
	      propsOnDOMBeforeInput = props.onDOMBeforeInput,
	      placeholder = props.placeholder,
	      _props$readOnly = props.readOnly,
	      readOnly = _props$readOnly === void 0 ? false : _props$readOnly,
	      renderElement = props.renderElement,
	      renderLeaf = props.renderLeaf,
	      _props$renderPlacehol = props.renderPlaceholder,
	      renderPlaceholder = _props$renderPlacehol === void 0 ? function (props) {
	    return /*#__PURE__*/React__default['default'].createElement(DefaultPlaceholder, Object.assign({}, props));
	  } : _props$renderPlacehol,
	      _props$style = props.style,
	      style = _props$style === void 0 ? {} : _props$style,
	      _props$as = props.as,
	      Component = _props$as === void 0 ? 'div' : _props$as,
	      attributes = _objectWithoutProperties(props, _excluded$1);
	
	  var editor = useSlate(); // Rerender editor when composition status changed
	
	  var _useState = React.useState(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      isComposing = _useState2[0],
	      setIsComposing = _useState2[1];
	
	  var ref = React.useRef(null);
	  var inputManager = useAndroidInputManager(ref); // Update internal state on each render.
	
	  IS_READ_ONLY.set(editor, readOnly); // Keep track of some state for the event handler logic.
	
	  var state = React.useMemo(function () {
	    return {
	      isComposing: false,
	      isUpdatingSelection: false,
	      latestElement: null
	    };
	  }, []);
	  var contentKey = useContentKey(editor); // Whenever the editor updates...
	
	  useIsomorphicLayoutEffect(function () {
	    // Update element-related weak maps with the DOM element ref.
	    var window;
	
	    if (ref.current && (window = getDefaultView(ref.current))) {
	      EDITOR_TO_WINDOW.set(editor, window);
	      EDITOR_TO_ELEMENT.set(editor, ref.current);
	      NODE_TO_ELEMENT.set(editor, ref.current);
	      ELEMENT_TO_NODE.set(ref.current, editor);
	    } else {
	      NODE_TO_ELEMENT["delete"](editor);
	    }
	
	    try {
	      // Make sure the DOM selection state is in sync.
	      var selection = editor.selection;
	      var root = ReactEditor.findDocumentOrShadowRoot(editor);
	      var domSelection = root.getSelection();
	
	      if (state.isComposing || !domSelection || !ReactEditor.isFocused(editor)) {
	        return;
	      }
	
	      var hasDomSelection = domSelection.type !== 'None'; // If the DOM selection is properly unset, we're done.
	
	      if (!selection && !hasDomSelection) {
	        return;
	      } // verify that the dom selection is in the editor
	
	
	      var editorElement = EDITOR_TO_ELEMENT.get(editor);
	      var hasDomSelectionInEditor = false;
	
	      if (editorElement.contains(domSelection.anchorNode) && editorElement.contains(domSelection.focusNode)) {
	        hasDomSelectionInEditor = true;
	      } // If the DOM selection is in the editor and the editor selection is already correct, we're done.
	
	
	      if (hasDomSelection && hasDomSelectionInEditor && selection) {
	        var slateRange = ReactEditor.toSlateRange(editor, domSelection, {
	          exactMatch: true,
	          suppressThrow: true
	        });
	
	        if (slateRange && slate.Range.equals(slateRange, selection)) {
	          return;
	        }
	      } // when <Editable/> is being controlled through external value
	      // then its children might just change - DOM responds to it on its own
	      // but Slate's value is not being updated through any operation
	      // and thus it doesn't transform selection on its own
	
	
	      if (selection && !ReactEditor.hasRange(editor, selection)) {
	        editor.selection = ReactEditor.toSlateRange(editor, domSelection, {
	          exactMatch: false,
	          suppressThrow: false
	        });
	        return;
	      } // Otherwise the DOM selection is out of sync, so update it.
	
	
	      var el = ReactEditor.toDOMNode(editor, editor);
	      state.isUpdatingSelection = true;
	      var newDomRange = selection && ReactEditor.toDOMRange(editor, selection);
	
	      if (newDomRange) {
	        if (slate.Range.isBackward(selection)) {
	          domSelection.setBaseAndExtent(newDomRange.endContainer, newDomRange.endOffset, newDomRange.startContainer, newDomRange.startOffset);
	        } else {
	          domSelection.setBaseAndExtent(newDomRange.startContainer, newDomRange.startOffset, newDomRange.endContainer, newDomRange.endOffset);
	        }
	
	        var leafEl = newDomRange.startContainer.parentElement;
	        leafEl.getBoundingClientRect = newDomRange.getBoundingClientRect.bind(newDomRange);
	        scrollIntoView__default['default'](leafEl, {
	          scrollMode: 'if-needed',
	          boundary: el
	        }); // @ts-ignore
	
	        delete leafEl.getBoundingClientRect;
	      } else {
	        domSelection.removeAllRanges();
	      }
	
	      setTimeout(function () {
	        state.isUpdatingSelection = false;
	      });
	    } catch (_unused) {
	      // Failed to update selection, likely due to reconciliation error
	      state.isUpdatingSelection = false;
	    }
	  }); // The autoFocus TextareaHTMLAttribute doesn't do anything on a div, so it
	  // needs to be manually focused.
	
	  React.useEffect(function () {
	    if (ref.current && autoFocus) {
	      ref.current.focus();
	    }
	  }, [autoFocus]); // Listen on the native `selectionchange` event to be able to update any time
	  // the selection changes. This is required because React's `onSelect` is leaky
	  // and non-standard so it doesn't fire until after a selection has been
	  // released. This causes issues in situations where another change happens
	  // while a selection is being dragged.
	
	  var onDOMSelectionChange = React.useCallback(throttle__default['default'](function () {
	    try {
	      if (!state.isComposing && !state.isUpdatingSelection && !inputManager.isReconciling.current) {
	        var root = ReactEditor.findDocumentOrShadowRoot(editor);
	        var activeElement = root.activeElement;
	        var el = ReactEditor.toDOMNode(editor, editor);
	        var domSelection = root.getSelection();
	
	        if (activeElement === el) {
	          state.latestElement = activeElement;
	          IS_FOCUSED.set(editor, true);
	        } else {
	          IS_FOCUSED["delete"](editor);
	        }
	
	        if (!domSelection) {
	          return slate.Transforms.deselect(editor);
	        }
	
	        var anchorNode = domSelection.anchorNode,
	            focusNode = domSelection.focusNode;
	        var anchorNodeSelectable = hasEditableTarget(editor, anchorNode) || isTargetInsideNonReadonlyVoid(editor, anchorNode);
	        var focusNodeSelectable = hasEditableTarget(editor, focusNode) || isTargetInsideNonReadonlyVoid(editor, focusNode);
	
	        if (anchorNodeSelectable && focusNodeSelectable) {
	          var range = ReactEditor.toSlateRange(editor, domSelection, {
	            exactMatch: false,
	            suppressThrow: false
	          });
	          slate.Transforms.select(editor, range);
	        } else {
	          slate.Transforms.deselect(editor);
	        }
	      }
	    } catch (_unused2) {// Failed to update selection, likely due to reconciliation error
	    }
	  }, 100), [readOnly]);
	  var scheduleOnDOMSelectionChange = React.useMemo(function () {
	    return debounce__default['default'](onDOMSelectionChange, 0);
	  }, [onDOMSelectionChange]); // Listen on the native `beforeinput` event to get real "Level 2" events. This
	  // is required because React's `beforeinput` is fake and never really attaches
	  // to the real event sadly. (2019/11/01)
	  // https://github.com/facebook/react/issues/11211
	
	  var onDOMBeforeInput = React.useCallback(function (event) {
	    if (!readOnly && hasEditableTarget(editor, event.target) && !isDOMEventHandled(event, propsOnDOMBeforeInput)) {
	      // Some IMEs/Chrome extensions like e.g. Grammarly set the selection immediately before
	      // triggering a `beforeinput` expecting the change to be applied to the immediately before
	      // set selection.
	      scheduleOnDOMSelectionChange.flush();
	      inputManager.onUserInput();
	    }
	  }, [readOnly, propsOnDOMBeforeInput]); // Attach a native DOM event handler for `beforeinput` events, because React's
	  // built-in `onBeforeInput` is actually a leaky polyfill that doesn't expose
	  // real `beforeinput` events sadly... (2019/11/04)
	
	  useIsomorphicLayoutEffect(function () {
	    var node = ref.current; // @ts-ignore The `beforeinput` event isn't recognized.
	
	    node === null || node === void 0 ? void 0 : node.addEventListener('beforeinput', onDOMBeforeInput); // @ts-ignore The `beforeinput` event isn't recognized.
	
	    return function () {
	      return node === null || node === void 0 ? void 0 : node.removeEventListener('beforeinput', onDOMBeforeInput);
	    };
	  }, [contentKey, propsOnDOMBeforeInput]); // Attach a native DOM event handler for `selectionchange`, because React's
	  // built-in `onSelect` handler doesn't fire for all selection changes. It's a
	  // leaky polyfill that only fires on keypresses or clicks. Instead, we want to
	  // fire for any change to the selection inside the editor. (2019/11/04)
	  // https://github.com/facebook/react/issues/5785
	
	  useIsomorphicLayoutEffect(function () {
	    var window = ReactEditor.getWindow(editor);
	    window.document.addEventListener('selectionchange', scheduleOnDOMSelectionChange);
	    return function () {
	      window.document.removeEventListener('selectionchange', scheduleOnDOMSelectionChange);
	    };
	  }, [scheduleOnDOMSelectionChange]);
	  var decorations = decorate([editor, []]);
	
	  if (placeholder && editor.children.length === 1 && Array.from(slate.Node.texts(editor)).length === 1 && slate.Node.string(editor) === '' && !isComposing) {
	    var _decorations$push;
	
	    var start = slate.Editor.start(editor, []);
	    decorations.push((_decorations$push = {}, _defineProperty(_decorations$push, PLACEHOLDER_SYMBOL, true), _defineProperty(_decorations$push, "placeholder", placeholder), _defineProperty(_decorations$push, "anchor", start), _defineProperty(_decorations$push, "focus", start), _decorations$push));
	  }
	
	  return /*#__PURE__*/React__default['default'].createElement(ReadOnlyContext.Provider, {
	    value: readOnly
	  }, /*#__PURE__*/React__default['default'].createElement(DecorateContext.Provider, {
	    value: decorate
	  }, /*#__PURE__*/React__default['default'].createElement(Component, Object.assign({
	    key: contentKey,
	    role: readOnly ? undefined : 'textbox'
	  }, attributes, {
	    spellCheck: attributes.spellCheck,
	    autoCorrect: attributes.autoCorrect,
	    autoCapitalize: attributes.autoCapitalize,
	    "data-slate-editor": true,
	    "data-slate-node": "value",
	    contentEditable: readOnly ? undefined : true,
	    suppressContentEditableWarning: true,
	    ref: ref,
	    style: _objectSpread({
	      // Allow positioning relative to the editable element.
	      position: 'relative',
	      // Prevent the default outline styles.
	      outline: 'none',
	      // Preserve adjacent whitespace and new lines.
	      whiteSpace: 'pre-wrap',
	      // Allow words to break if they are too long.
	      wordWrap: 'break-word'
	    }, style),
	    onCopy: React.useCallback(function (event) {
	      if (hasEditableTarget(editor, event.target) && !isEventHandled(event, attributes.onCopy)) {
	        event.preventDefault();
	        ReactEditor.setFragmentData(editor, event.clipboardData, 'copy');
	      }
	    }, [attributes.onCopy]),
	    onCut: React.useCallback(function (event) {
	      if (!readOnly && hasEditableTarget(editor, event.target) && !isEventHandled(event, attributes.onCut)) {
	        event.preventDefault();
	        ReactEditor.setFragmentData(editor, event.clipboardData, 'cut');
	        var selection = editor.selection;
	
	        if (selection) {
	          if (slate.Range.isExpanded(selection)) {
	            slate.Editor.deleteFragment(editor);
	          } else {
	            var node = slate.Node.parent(editor, selection.anchor.path);
	
	            if (slate.Editor.isVoid(editor, node)) {
	              slate.Transforms["delete"](editor);
	            }
	          }
	        }
	      }
	    }, [readOnly, attributes.onCut]),
	    onFocus: React.useCallback(function (event) {
	      if (!readOnly && !state.isUpdatingSelection && hasEditableTarget(editor, event.target) && !isEventHandled(event, attributes.onFocus)) {
	        var root = ReactEditor.findDocumentOrShadowRoot(editor);
	        state.latestElement = root.activeElement;
	        IS_FOCUSED.set(editor, true);
	      }
	    }, [readOnly, attributes.onFocus]),
	    onBlur: React.useCallback(function (event) {
	      if (readOnly || state.isUpdatingSelection || !hasEditableTarget(editor, event.target) || isEventHandled(event, attributes.onBlur)) {
	        return;
	      } // COMPAT: If the current `activeElement` is still the previous
	      // one, this is due to the window being blurred when the tab
	      // itself becomes unfocused, so we want to abort early to allow to
	      // editor to stay focused when the tab becomes focused again.
	
	
	      var root = ReactEditor.findDocumentOrShadowRoot(editor);
	
	      if (state.latestElement === root.activeElement) {
	        return;
	      }
	
	      var relatedTarget = event.relatedTarget;
	      var el = ReactEditor.toDOMNode(editor, editor); // COMPAT: The event should be ignored if the focus is returning
	      // to the editor from an embedded editable element (eg. an <input>
	      // element inside a void node).
	
	      if (relatedTarget === el) {
	        return;
	      } // COMPAT: The event should be ignored if the focus is moving from
	      // the editor to inside a void node's spacer element.
	
	
	      if (isDOMElement(relatedTarget) && relatedTarget.hasAttribute('data-slate-spacer')) {
	        return;
	      } // COMPAT: The event should be ignored if the focus is moving to a
	      // non- editable section of an element that isn't a void node (eg.
	      // a list item of the check list example).
	
	
	      if (relatedTarget != null && isDOMNode(relatedTarget) && ReactEditor.hasDOMNode(editor, relatedTarget)) {
	        var node = ReactEditor.toSlateNode(editor, relatedTarget);
	
	        if (slate.Element.isElement(node) && !editor.isVoid(node)) {
	          return;
	        }
	      }
	
	      IS_FOCUSED["delete"](editor);
	    }, [readOnly, attributes.onBlur]),
	    onClick: React.useCallback(function (event) {
	      if (!readOnly && hasTarget(editor, event.target) && !isEventHandled(event, attributes.onClick) && isDOMNode(event.target)) {
	        var node = ReactEditor.toSlateNode(editor, event.target);
	        var path = ReactEditor.findPath(editor, node); // At this time, the Slate document may be arbitrarily different,
	        // because onClick handlers can change the document before we get here.
	        // Therefore we must check that this path actually exists,
	        // and that it still refers to the same node.
	
	        if (slate.Editor.hasPath(editor, path)) {
	          var lookupNode = slate.Node.get(editor, path);
	
	          if (lookupNode === node) {
	            var _start = slate.Editor.start(editor, path);
	
	            var end = slate.Editor.end(editor, path);
	            var startVoid = slate.Editor["void"](editor, {
	              at: _start
	            });
	            var endVoid = slate.Editor["void"](editor, {
	              at: end
	            });
	
	            if (startVoid && endVoid && slate.Path.equals(startVoid[1], endVoid[1])) {
	              var range = slate.Editor.range(editor, _start);
	              slate.Transforms.select(editor, range);
	            }
	          }
	        }
	      }
	    }, [readOnly, attributes.onClick]),
	    onCompositionEnd: React.useCallback(function (event) {
	      if (hasEditableTarget(editor, event.target) && !isEventHandled(event, attributes.onCompositionEnd)) {
	        scheduleOnDOMSelectionChange.flush();
	        setTimeout(function () {
	          state.isComposing && setIsComposing(false);
	          state.isComposing = false;
	          IS_COMPOSING.set(editor, false);
	          IS_ON_COMPOSITION_END.set(editor, true);
	          var insertedText = EDITOR_ON_COMPOSITION_TEXT.get(editor) || []; // `insertedText` is set in `MutationObserver` constructor.
	          // If open phone keyboard association function, `CompositionEvent` will be triggered.
	
	          if (!insertedText.length) {
	            return;
	          }
	
	          EDITOR_ON_COMPOSITION_TEXT.set(editor, []);
	          var selection = editor.selection;
	          insertedText.forEach(function (insertion) {
	            var text = insertion.text.insertText;
	            var at = normalizeTextInsertionRange(editor, selection, insertion);
	            slate.Transforms.setSelection(editor, at);
	            slate.Editor.insertText(editor, text);
	          });
	        }, RESOLVE_DELAY);
	      }
	    }, [attributes.onCompositionEnd]),
	    onCompositionUpdate: React.useCallback(function (event) {
	      if (hasEditableTarget(editor, event.target) && !isEventHandled(event, attributes.onCompositionUpdate)) {
	        !state.isComposing && setIsComposing(true);
	        state.isComposing = true;
	        IS_COMPOSING.set(editor, true);
	      }
	    }, [attributes.onCompositionUpdate]),
	    onCompositionStart: React.useCallback(function (event) {
	      if (hasEditableTarget(editor, event.target) && !isEventHandled(event, attributes.onCompositionStart)) {
	        !state.isComposing && setIsComposing(true);
	        state.isComposing = true;
	        IS_COMPOSING.set(editor, true);
	      }
	    }, [attributes.onCompositionStart]),
	    onPaste: React.useCallback(function (event) {
	      // this will make application/x-slate-fragment exist when onPaste attributes is passed
	      event.clipboardData = getClipboardData(event.clipboardData); // This unfortunately needs to be handled with paste events instead.
	
	      if (hasEditableTarget(editor, event.target) && !isEventHandled(event, attributes.onPaste) && !readOnly) {
	        event.preventDefault();
	        ReactEditor.insertData(editor, event.clipboardData);
	      }
	    }, [readOnly, attributes.onPaste])
	  }), useChildren({
	    decorations: decorations,
	    node: editor,
	    renderElement: renderElement,
	    renderPlaceholder: renderPlaceholder,
	    renderLeaf: renderLeaf,
	    selection: editor.selection
	  }))));
	};
	
	/**
	 * A React context for sharing the `focused` state of the editor.
	 */
	
	var FocusedContext = /*#__PURE__*/React.createContext(false);
	/**
	 * Get the current `focused` state of the editor.
	 */
	
	var useFocused = function useFocused() {
	  return React.useContext(FocusedContext);
	};
	
	function isError(error) {
	  return error instanceof Error;
	}
	/**
	 * A React context for sharing the editor selector context in a way to control rerenders
	 */
	
	
	var SlateSelectorContext = /*#__PURE__*/React.createContext({});
	
	var refEquality = function refEquality(a, b) {
	  return a === b;
	};
	/**
	 * use redux style selectors to prevent rerendering on every keystroke.
	 * Bear in mind rerendering can only prevented if the returned value is a value type or for reference types (e.g. objects and arrays) add a custom equality function.
	 *
	 * Example:
	 * ```
	 *  const isSelectionActive = useSlateSelector(editor => Boolean(editor.selection));
	 * ```
	 */
	
	
	function useSlateSelector(selector) {
	  var equalityFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : refEquality;
	
	  var _useReducer = React.useReducer(function (s) {
	    return s + 1;
	  }, 0),
	      _useReducer2 = _slicedToArray(_useReducer, 2),
	      forceRender = _useReducer2[1];
	
	  var context = React.useContext(SlateSelectorContext);
	
	  if (!context) {
	    throw new Error("The `useSlateSelector` hook must be used inside the <Slate> component's context.");
	  }
	
	  var getSlate = context.getSlate,
	      addEventListener = context.addEventListener;
	  var latestSubscriptionCallbackError = React.useRef();
	  var latestSelector = React.useRef(function () {
	    return null;
	  });
	  var latestSelectedState = React.useRef(null);
	  var selectedState;
	
	  try {
	    if (selector !== latestSelector.current || latestSubscriptionCallbackError.current) {
	      selectedState = selector(getSlate());
	    } else {
	      selectedState = latestSelectedState.current;
	    }
	  } catch (err) {
	    if (latestSubscriptionCallbackError.current && isError(err)) {
	      err.message += "\nThe error may be correlated with this previous error:\n".concat(latestSubscriptionCallbackError.current.stack, "\n\n");
	    }
	
	    throw err;
	  }
	
	  useIsomorphicLayoutEffect(function () {
	    latestSelector.current = selector;
	    latestSelectedState.current = selectedState;
	    latestSubscriptionCallbackError.current = undefined;
	  });
	  useIsomorphicLayoutEffect(function () {
	    function checkForUpdates() {
	      try {
	        var newSelectedState = latestSelector.current(getSlate());
	
	        if (equalityFn(newSelectedState, latestSelectedState.current)) {
	          return;
	        }
	
	        latestSelectedState.current = newSelectedState;
	      } catch (err) {
	        // we ignore all errors here, since when the component
	        // is re-rendered, the selectors are called again, and
	        // will throw again, if neither props nor store state
	        // changed
	        latestSubscriptionCallbackError.current = err;
	      }
	
	      forceRender();
	    }
	
	    var unsubscribe = addEventListener(checkForUpdates);
	    checkForUpdates();
	    return function () {
	      return unsubscribe();
	    };
	  }, // don't rerender on equalityFn change since we want to be able to define it inline
	  [addEventListener, getSlate]);
	  return selectedState;
	}
	/**
	 * Create selector context with editor updating on every editor change
	 */
	
	function getSelectorContext(editor) {
	  var eventListeners = React.useRef([]).current;
	  var slateRef = React.useRef({
	    editor: editor
	  }).current;
	  var onChange = React.useCallback(function (editor) {
	    slateRef.editor = editor;
	    eventListeners.forEach(function (listener) {
	      return listener(editor);
	    });
	  }, []);
	  var selectorContext = React.useMemo(function () {
	    return {
	      getSlate: function getSlate() {
	        return slateRef.editor;
	      },
	      addEventListener: function addEventListener(callback) {
	        eventListeners.push(callback);
	        return function () {
	          eventListeners.splice(eventListeners.indexOf(callback), 1);
	        };
	      }
	    };
	  }, [eventListeners, slateRef]);
	  return {
	    selectorContext: selectorContext,
	    onChange: onChange
	  };
	}
	
	var _excluded = ["editor", "children", "onChange", "value"];
	/**
	 * A wrapper around the provider to handle `onChange` events, because the editor
	 * is a mutable singleton so it won't ever register as "changed" otherwise.
	 */
	
	var Slate = function Slate(props) {
	  var editor = props.editor,
	      children = props.children,
	      onChange = props.onChange,
	      value = props.value,
	      rest = _objectWithoutProperties(props, _excluded);
	
	  var unmountRef = React.useRef(false);
	
	  var _React$useState = React__default['default'].useState(function () {
	    if (!slate.Node.isNodeList(value)) {
	      throw new Error("[Slate] value is invalid! Expected a list of elements" + "but got: ".concat(JSON.stringify(value)));
	    }
	
	    if (!slate.Editor.isEditor(editor)) {
	      throw new Error("[Slate] editor is invalid! you passed:" + "".concat(JSON.stringify(editor)));
	    }
	
	    editor.children = value;
	    Object.assign(editor, rest);
	    return [editor];
	  }),
	      _React$useState2 = _slicedToArray(_React$useState, 2),
	      context = _React$useState2[0],
	      setContext = _React$useState2[1];
	
	  var _getSelectorContext = getSelectorContext(editor),
	      selectorContext = _getSelectorContext.selectorContext,
	      handleSelectorChange = _getSelectorContext.onChange;
	
	  var onContextChange = React.useCallback(function () {
	    if (onChange) {
	      onChange(editor.children);
	    }
	
	    setContext([editor]);
	    handleSelectorChange(editor);
	  }, [onChange]);
	  EDITOR_TO_ON_CHANGE.set(editor, onContextChange);
	  React.useEffect(function () {
	    return function () {
	      EDITOR_TO_ON_CHANGE.set(editor, function () {});
	      unmountRef.current = true;
	    };
	  }, []);
	
	  var _useState = React.useState(ReactEditor.isFocused(editor)),
	      _useState2 = _slicedToArray(_useState, 2),
	      isFocused = _useState2[0],
	      setIsFocused = _useState2[1];
	
	  React.useEffect(function () {
	    setIsFocused(ReactEditor.isFocused(editor));
	  });
	  useIsomorphicLayoutEffect(function () {
	    var fn = function fn() {
	      return setIsFocused(ReactEditor.isFocused(editor));
	    };
	
	    if (IS_REACT_VERSION_17_OR_ABOVE) {
	      // In React >= 17 onFocus and onBlur listen to the focusin and focusout events during the bubbling phase.
	      // Therefore in order for <Editable />'s handlers to run first, which is necessary for ReactEditor.isFocused(editor)
	      // to return the correct value, we have to listen to the focusin and focusout events without useCapture here.
	      document.addEventListener('focusin', fn);
	      document.addEventListener('focusout', fn);
	      return function () {
	        document.removeEventListener('focusin', fn);
	        document.removeEventListener('focusout', fn);
	      };
	    } else {
	      document.addEventListener('focus', fn, true);
	      document.addEventListener('blur', fn, true);
	      return function () {
	        document.removeEventListener('focus', fn, true);
	        document.removeEventListener('blur', fn, true);
	      };
	    }
	  }, []);
	  return /*#__PURE__*/React__default['default'].createElement(SlateSelectorContext.Provider, {
	    value: selectorContext
	  }, /*#__PURE__*/React__default['default'].createElement(SlateContext.Provider, {
	    value: context
	  }, /*#__PURE__*/React__default['default'].createElement(EditorContext.Provider, {
	    value: editor
	  }, /*#__PURE__*/React__default['default'].createElement(FocusedContext.Provider, {
	    value: isFocused
	  }, children))));
	};
	
	/**
	 * Get the current editor object from the React context.
	 * @deprecated Use useSlateStatic instead.
	 */
	
	var useEditor = function useEditor() {
	  var editor = React.useContext(EditorContext);
	
	  if (!editor) {
	    throw new Error("The `useEditor` hook must be used inside the <Slate> component's context.");
	  }
	
	  return editor;
	};
	
	/**
	 * Utilities for single-line deletion
	 */
	
	var doRectsIntersect = function doRectsIntersect(rect, compareRect) {
	  var middle = (compareRect.top + compareRect.bottom) / 2;
	  return rect.top <= middle && rect.bottom >= middle;
	};
	
	var areRangesSameLine = function areRangesSameLine(editor, range1, range2) {
	  var rect1 = ReactEditor.toDOMRange(editor, range1).getBoundingClientRect();
	  var rect2 = ReactEditor.toDOMRange(editor, range2).getBoundingClientRect();
	  return doRectsIntersect(rect1, rect2) && doRectsIntersect(rect2, rect1);
	};
	/**
	 * A helper utility that returns the end portion of a `Range`
	 * which is located on a single line.
	 *
	 * @param {Editor} editor The editor object to compare against
	 * @param {Range} parentRange The parent range to compare against
	 * @returns {Range} A valid portion of the parentRange which is one a single line
	 */
	
	
	var findCurrentLineRange = function findCurrentLineRange(editor, parentRange) {
	  var parentRangeBoundary = slate.Editor.range(editor, slate.Range.end(parentRange));
	  var positions = Array.from(slate.Editor.positions(editor, {
	    at: parentRange
	  }));
	  var left = 0;
	  var right = positions.length;
	  var middle = Math.floor(right / 2);
	
	  if (areRangesSameLine(editor, slate.Editor.range(editor, positions[left]), parentRangeBoundary)) {
	    return slate.Editor.range(editor, positions[left], parentRangeBoundary);
	  }
	
	  if (positions.length < 2) {
	    return slate.Editor.range(editor, positions[positions.length - 1], parentRangeBoundary);
	  }
	
	  while (middle !== positions.length && middle !== left) {
	    if (areRangesSameLine(editor, slate.Editor.range(editor, positions[middle]), parentRangeBoundary)) {
	      right = middle;
	    } else {
	      left = middle;
	    }
	
	    middle = Math.floor((left + right) / 2);
	  }
	
	  return slate.Editor.range(editor, positions[right], parentRangeBoundary);
	};
	
	function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	/**
	 * `withReact` adds React and DOM specific behaviors to the editor.
	 *
	 * If you are using TypeScript, you must extend Slate's CustomTypes to use
	 * this plugin.
	 *
	 * See https://docs.slatejs.org/concepts/11-typescript to learn how.
	 */
	
	var withReact = function withReact(editor) {
	  var e = editor;
	  var apply = e.apply,
	      onChange = e.onChange,
	      deleteBackward = e.deleteBackward; // The WeakMap which maps a key to a specific HTMLElement must be scoped to the editor instance to
	  // avoid collisions between editors in the DOM that share the same value.
	
	  EDITOR_TO_KEY_TO_ELEMENT.set(e, new WeakMap());
	
	  e.deleteBackward = function (unit) {
	    if (unit !== 'line') {
	      return deleteBackward(unit);
	    }
	
	    if (editor.selection && slate.Range.isCollapsed(editor.selection)) {
	      var parentBlockEntry = slate.Editor.above(editor, {
	        match: function match(n) {
	          return slate.Editor.isBlock(editor, n);
	        },
	        at: editor.selection
	      });
	
	      if (parentBlockEntry) {
	        var _parentBlockEntry = _slicedToArray(parentBlockEntry, 2),
	            parentBlockPath = _parentBlockEntry[1];
	
	        var parentElementRange = slate.Editor.range(editor, parentBlockPath, editor.selection.anchor);
	        var currentLineRange = findCurrentLineRange(e, parentElementRange);
	
	        if (!slate.Range.isCollapsed(currentLineRange)) {
	          slate.Transforms["delete"](editor, {
	            at: currentLineRange
	          });
	        }
	      }
	    }
	  }; // This attempts to reset the NODE_TO_KEY entry to the correct value
	  // as apply() changes the object reference and hence invalidates the NODE_TO_KEY entry
	
	
	  e.apply = function (op) {
	    var matches = [];
	
	    switch (op.type) {
	      case 'insert_text':
	      case 'remove_text':
	      case 'set_node':
	      case 'split_node':
	        {
	          matches.push.apply(matches, _toConsumableArray(getMatches(e, op.path)));
	          break;
	        }
	
	      case 'set_selection':
	        {
	          var _EDITOR_TO_USER_SELEC;
	
	          // Selection was manually set, don't restore the user selection after the change.
	          (_EDITOR_TO_USER_SELEC = EDITOR_TO_USER_SELECTION.get(editor)) === null || _EDITOR_TO_USER_SELEC === void 0 ? void 0 : _EDITOR_TO_USER_SELEC.unref();
	          EDITOR_TO_USER_SELECTION["delete"](editor);
	          break;
	        }
	
	      case 'insert_node':
	      case 'remove_node':
	        {
	          matches.push.apply(matches, _toConsumableArray(getMatches(e, slate.Path.parent(op.path))));
	          break;
	        }
	
	      case 'merge_node':
	        {
	          var prevPath = slate.Path.previous(op.path);
	          matches.push.apply(matches, _toConsumableArray(getMatches(e, prevPath)));
	          break;
	        }
	
	      case 'move_node':
	        {
	          var commonPath = slate.Path.common(slate.Path.parent(op.path), slate.Path.parent(op.newPath));
	          matches.push.apply(matches, _toConsumableArray(getMatches(e, commonPath)));
	          break;
	        }
	    }
	
	    apply(op);
	
	    for (var _i = 0, _matches = matches; _i < _matches.length; _i++) {
	      var _matches$_i = _slicedToArray(_matches[_i], 2),
	          path = _matches$_i[0],
	          key = _matches$_i[1];
	
	      var _Editor$node = slate.Editor.node(e, path),
	          _Editor$node2 = _slicedToArray(_Editor$node, 1),
	          node = _Editor$node2[0];
	
	      NODE_TO_KEY.set(node, key);
	    }
	  };
	
	  e.setFragmentData = function (data) {
	    var selection = e.selection;
	
	    if (!selection) {
	      return;
	    }
	
	    var _Range$edges = slate.Range.edges(selection),
	        _Range$edges2 = _slicedToArray(_Range$edges, 2),
	        start = _Range$edges2[0],
	        end = _Range$edges2[1];
	
	    var startVoid = slate.Editor["void"](e, {
	      at: start.path
	    });
	    var endVoid = slate.Editor["void"](e, {
	      at: end.path
	    });
	
	    if (slate.Range.isCollapsed(selection) && !startVoid) {
	      return;
	    } // Create a fake selection so that we can add a Base64-encoded copy of the
	    // fragment to the HTML, to decode on future pastes.
	
	
	    var domRange = ReactEditor.toDOMRange(e, selection);
	    var contents = domRange.cloneContents();
	    var attach = contents.childNodes[0]; // Make sure attach is non-empty, since empty nodes will not get copied.
	
	    contents.childNodes.forEach(function (node) {
	      if (node.textContent && node.textContent.trim() !== '') {
	        attach = node;
	      }
	    }); // COMPAT: If the end node is a void node, we need to move the end of the
	    // range from the void node's spacer span, to the end of the void node's
	    // content, since the spacer is before void's content in the DOM.
	
	    if (endVoid) {
	      var _endVoid = _slicedToArray(endVoid, 1),
	          voidNode = _endVoid[0];
	
	      var r = domRange.cloneRange();
	      var domNode = ReactEditor.toDOMNode(e, voidNode);
	      r.setEndAfter(domNode);
	      contents = r.cloneContents();
	    } // COMPAT: If the start node is a void node, we need to attach the encoded
	    // fragment to the void node's content node instead of the spacer, because
	    // attaching it to empty `<div>/<span>` nodes will end up having it erased by
	    // most browsers. (2018/04/27)
	
	
	    if (startVoid) {
	      attach = contents.querySelector('[data-slate-spacer]');
	    } // Remove any zero-width space spans from the cloned DOM so that they don't
	    // show up elsewhere when pasted.
	
	
	    Array.from(contents.querySelectorAll('[data-slate-zero-width]')).forEach(function (zw) {
	      var isNewline = zw.getAttribute('data-slate-zero-width') === 'n';
	      zw.textContent = isNewline ? '\n' : '';
	    }); // Set a `data-slate-fragment` attribute on a non-empty node, so it shows up
	    // in the HTML, and can be used for intra-Slate pasting. If it's a text
	    // node, wrap it in a `<span>` so we have something to set an attribute on.
	
	    if (isDOMText(attach)) {
	      var span = attach.ownerDocument.createElement('span'); // COMPAT: In Chrome and Safari, if we don't add the `white-space` style
	      // then leading and trailing spaces will be ignored. (2017/09/21)
	
	      span.style.whiteSpace = 'pre';
	      span.appendChild(attach);
	      contents.appendChild(span);
	      attach = span;
	    }
	
	    var fragment = e.getFragment();
	    var string = JSON.stringify(fragment);
	    var encoded = window.btoa(encodeURIComponent(string));
	    attach.setAttribute('data-slate-fragment', encoded);
	    data.setData('application/x-slate-fragment', encoded); // Add the content to a <div> so that we can get its inner HTML.
	
	    var div = contents.ownerDocument.createElement('div');
	    div.appendChild(contents);
	    div.setAttribute('hidden', 'true');
	    contents.ownerDocument.body.appendChild(div);
	    data.setData('text/html', div.innerHTML);
	    data.setData('text/plain', getPlainText(div));
	    contents.ownerDocument.body.removeChild(div);
	    return data;
	  };
	
	  e.insertData = function (data) {
	    if (!e.insertFragmentData(data)) {
	      e.insertTextData(data);
	    }
	  };
	
	  e.insertFragmentData = function (data) {
	    /**
	     * Checking copied fragment from application/x-slate-fragment or data-slate-fragment
	     */
	    var fragment = data.getData('application/x-slate-fragment') || getSlateFragmentAttribute(data);
	
	    if (fragment) {
	      var decoded = decodeURIComponent(window.atob(fragment));
	      var parsed = JSON.parse(decoded);
	      e.insertFragment(parsed);
	      return true;
	    }
	
	    return false;
	  };
	
	  e.insertTextData = function (data) {
	    var text = data.getData('text/plain');
	
	    if (text) {
	      var lines = text.split(/\r\n|\r|\n/);
	      var split = false;
	
	      var _iterator = _createForOfIteratorHelper(lines),
	          _step;
	
	      try {
	        for (_iterator.s(); !(_step = _iterator.n()).done;) {
	          var line = _step.value;
	
	          if (split) {
	            slate.Transforms.splitNodes(e, {
	              always: true
	            });
	          }
	
	          e.insertText(line);
	          split = true;
	        }
	      } catch (err) {
	        _iterator.e(err);
	      } finally {
	        _iterator.f();
	      }
	
	      return true;
	    }
	
	    return false;
	  };
	
	  e.onChange = function () {
	    // COMPAT: React doesn't batch `setState` hook calls, which means that the
	    // children and selection can get out of sync for one render pass. So we
	    // have to use this unstable API to ensure it batches them. (2019/12/03)
	    // https://github.com/facebook/react/issues/14259#issuecomment-439702367
	    ReactDOM__default['default'].unstable_batchedUpdates(function () {
	      var onContextChange = EDITOR_TO_ON_CHANGE.get(e);
	
	      if (onContextChange) {
	        onContextChange();
	      }
	
	      onChange();
	    });
	  };
	
	  return e;
	};
	
	var getMatches = function getMatches(e, path) {
	  var matches = [];
	
	  var _iterator2 = _createForOfIteratorHelper(slate.Editor.levels(e, {
	    at: path
	  })),
	      _step2;
	
	  try {
	    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
	      var _step2$value = _slicedToArray(_step2.value, 2),
	          n = _step2$value[0],
	          p = _step2$value[1];
	
	      var key = ReactEditor.findKey(e, n);
	      matches.push([p, key]);
	    }
	  } catch (err) {
	    _iterator2.e(err);
	  } finally {
	    _iterator2.f();
	  }
	
	  return matches;
	};
	
	// Components
	var Editable = IS_ANDROID ? AndroidEditable : Editable$1;
	
	exports.AndroidEditable = AndroidEditable;
	exports.DefaultEditable = Editable$1;
	exports.DefaultElement = DefaultElement;
	exports.DefaultLeaf = DefaultLeaf;
	exports.DefaultPlaceholder = DefaultPlaceholder;
	exports.Editable = Editable;
	exports.ReactEditor = ReactEditor;
	exports.Slate = Slate;
	exports.useEditor = useEditor;
	exports.useFocused = useFocused;
	exports.useReadOnly = useReadOnly;
	exports.useSelected = useSelected;
	exports.useSlate = useSlate;
	exports.useSlateSelector = useSlateSelector;
	exports.useSlateStatic = useSlateStatic;
	exports.withReact = withReact;
	//# sourceMappingURL=index.js.map


/***/ },
/* 484 */
/***/ function(module, exports) {

	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	var toPropertyKey = __webpack_require__(487);
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, toPropertyKey(descriptor.key), descriptor);
	  }
	}
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties(Constructor, staticProps);
	  Object.defineProperty(Constructor, "prototype", {
	    writable: false
	  });
	  return Constructor;
	}
	module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 486 */
/***/ function(module, exports) {

	function _setPrototypeOf(o, p) {
	  module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
	    o.__proto__ = p;
	    return o;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
	  return _setPrototypeOf(o, p);
	}
	module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(129)["default"];
	var toPrimitive = __webpack_require__(1053);
	function toPropertyKey(t) {
	  var i = toPrimitive(t, "string");
	  return "symbol" == _typeof(i) ? i : i + "";
	}
	module.exports = toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.EstadoAgenteMedios = exports.EstadoAgenteNoDisponibleAni = exports.EstadoAgenteTransferenciaAni = exports.EstadoAgenteError = exports.EstadoAgenteNotas = exports.EstadoAgenteDispLlamManual = exports.iconExlcusiveCallBackState = exports.DialingCall = exports.DialogCall = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DialogCall = exports.DialogCall = _react2.default.createElement(
		"svg",
		{ id: "wave", "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 50 38.05" },
		_react2.default.createElement(
			"title",
			null,
			"Audio Wave"
		),
		_react2.default.createElement("path", { id: "Line_1", "data-name": "Line 1", d: "M0.91,15L0.78,15A1,1,0,0,0,0,16v6a1,1,0,1,0,2,0s0,0,0,0V16a1,1,0,0,0-1-1H0.91Z" }),
		_react2.default.createElement("path", { id: "Line_2", "data-name": "Line 2", d: "M6.91,9L6.78,9A1,1,0,0,0,6,10V28a1,1,0,1,0,2,0s0,0,0,0V10A1,1,0,0,0,7,9H6.91Z" }),
		_react2.default.createElement("path", { id: "Line_3", "data-name": "Line 3", d: "M12.91,0L12.78,0A1,1,0,0,0,12,1V37a1,1,0,1,0,2,0s0,0,0,0V1a1,1,0,0,0-1-1H12.91Z" }),
		_react2.default.createElement("path", { id: "Line_4", "data-name": "Line 4", d: "M18.91,10l-0.12,0A1,1,0,0,0,18,11V27a1,1,0,1,0,2,0s0,0,0,0V11a1,1,0,0,0-1-1H18.91Z" }),
		_react2.default.createElement("path", { id: "Line_5", "data-name": "Line 5", d: "M24.91,15l-0.12,0A1,1,0,0,0,24,16v6a1,1,0,0,0,2,0s0,0,0,0V16a1,1,0,0,0-1-1H24.91Z" }),
		_react2.default.createElement("path", { id: "Line_6", "data-name": "Line 6", d: "M30.91,10l-0.12,0A1,1,0,0,0,30,11V27a1,1,0,1,0,2,0s0,0,0,0V11a1,1,0,0,0-1-1H30.91Z" }),
		_react2.default.createElement("path", { id: "Line_7", "data-name": "Line 7", d: "M36.91,0L36.78,0A1,1,0,0,0,36,1V37a1,1,0,1,0,2,0s0,0,0,0V1a1,1,0,0,0-1-1H36.91Z" }),
		_react2.default.createElement("path", { id: "Line_8", "data-name": "Line 8", d: "M42.91,9L42.78,9A1,1,0,0,0,42,10V28a1,1,0,1,0,2,0s0,0,0,0V10a1,1,0,0,0-1-1H42.91Z" }),
		_react2.default.createElement("path", { id: "Line_9", "data-name": "Line 9", d: "M48.91,15l-0.12,0A1,1,0,0,0,48,16v6a1,1,0,1,0,2,0s0,0,0,0V16a1,1,0,0,0-1-1H48.91Z" })
	);
	
	var DialingCall = exports.DialingCall = _react2.default.createElement(
		"svg",
		{ version: "1.1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", viewBox: "0 0 80 80", enableBackground: "new 0 0 80 80", xmlSpace: "preserve" },
		_react2.default.createElement(
			"g",
			{ id: "Dialing_Capa_2" },
			_react2.default.createElement(
				"g",
				{ id: "Dialing_Capa_1" },
				_react2.default.createElement("image", { style: { overflow: "visible", opacity: 0.45 }, width: "62", height: "62", xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD4AAAA+CAYAAABzwahEAAAACXBIWXMAAAsSAAALEgHS3X78AAAA\r GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABwdJREFUeNrUW4ly4kYQHaGDywRs\r x07iZLNJ/v+fkk02m8SJ19iwHLJAGVW9Lh7NjBCYtWdV1YWQBej1Nd2vx5GpPyJz3FGawI+o5lqk\r zg8BXKrz4I7EAbqSlpKoAXgBu1YSJPjEATrG9ZSEFeADLUCfSAorqxDBJw7QFdCulb6VHs4z/M1l\r ebF0BTC3Mrcys/IJ5yZE8GzxFt5XQEdWLqxcWvkKChDLc8wLELF0BfjRyp2Vjw7FBGnxFsD1Afh7\r yNdWBlbaHncXN19amVj5D8qLyOVXuCcoi0cO4BcA/YuVGytDKx1ydw28Araw8mDlA67PoYhPCAH5\r nTJEV08BcAhLV6DfwPW7DYDf45pY/laFSNDJLQPIARRQgT5vCFxAS15o4zdazyiGXnQ5S6GADgB3\r G7h6BPA9uj9T4fRFFDCxR1zAI4DPYOUORCwehxzjGnyduD4jy2GmvCTzKOxVj1MkHe0lbYDm4ic5\r oPR9VeClajSaKiB25IY2rgeV4Fo1gMsDFKDrfI7zLMTM3vLU3Fqagm85gLdpLQ/O1bmlXKHMzB3l\r ZtkQeOoAHodscemwFig553i/ot66SawnVAukobq6tnaOLmsG4EtYfn1EwjMOFw/C3bXFCwCdo7mQ\r nvqpprtixRW4dwnxhUsZUoxri1egpzjPAUqDZ9ACeIqe/AGvn3B9FSoRUVJiWwDAFA++UMBLx2fm\r APoRXdk/ICQeHZ8PBri23BygJ3jlJJd46KYK4L9W/rTyB/ryW1h+DuBBWtxQnIrFxV2ncNcCWVru\r zeERY4CuwL6z8puV9+jJJ/TZ4CyuC5glAEmsTijJZZQIZyAf/oal30Eqi/8Ft59RcgzmiNX6a1Sz\r 0QMZMSRyQZS1hFJuAfRXyO8EeqoSWzCurpczo5LVBG48JqvnlMFn+NstLP4e1r/D/cEltX1NisT5\r BK58D4BTXJdhQU6JkJewWYhxvY+IWKs4HyNJ3YF97SEs1lSfR456IEjArhg3Nfxbh8iFDq5FsOic\r VoAJFSxFyOBjD2gf+cjgM+LalggBru+L0Kq1JhbXCtCW7yrLc8W3oMaGu7pjFbCP7zu5q5cOy2eK\r TxMWNaKCRtra3FPmHsrjRarDO0mnFx94r8vqGX3PWpEYxRGJjhUtVFZCvJ1rbu9SRvRcVzc1Lq8Z\r Fi57CwV83RA0szhMYTF/xzx/U2UcbXGu6oQ/b5NoekmWtaIhfaU5uz6qxRFkYDYz+zZ+XxielBSS\r KFY3arqOm5r6XTowjnNJcn08HG8DKT0JShKfVqpY+Qxl8jleewBT0AoiRMeScssTKbt2Z0bSwMql\r IijGZndo0Dbbk9ZSgeaR1CM1PLLcCU/XgfKq+fw3Vr41m/l8YjbDSeEEZQldUDmde1gkw+CbAjdk\r 9Sm5Y5ckQ2XXhmtq0Cm554PZzM3X1BQNzGY8/aOVH6CAIT7P/T8TojO6tsB3P5ianRlJw9guVa8u\r 829OPBLjI4AbORIiJ6kUD1zgOXgnxk+QNwA+wP0lrRq5w/riARySzp0ZyYHJjRmaB7IgT0sMYlPA\r +8reLr7jCZ8dwbXfWvkZwG/gRX0y0krFMbu3uPg9lGWMZ2fGIcDZ5YV50eNjzqBi+aEDeA8J7B4P\r m0JZYu23Znf/Tay8b222pz2iiBm+25DlxSNbTbN6k3jXgLlDO8ePnpntEXIfirlTwL9DXN8Q6C5V\r h3q10ZsKCyipBOiB8WxXOxS4K96N46F4OTkH0C6VvT0AfwDwxGz23VzDvQdQWlJTb+gtpDFeuyqX\r 7HjkMcCNYmRda35O6+2CrJcCYBvFiSS3GA8rFFff7A4b66pLBh47KrudQuZY4HXgef7GbeqV2Wwb\r Ew8Y0QNn5vjRcuQplLx1+3OAa/B6GrOgNVYUcA2wfSp1E8r8qSo5X5R6ek7M8zlXUDKSmgD8Jazf\r dzQaLzJQTE70PaVqQrhBWSp6aoyi5ApJbEhre0nJqGzSZb02cL3U6U0GC2JimbW9QuIbIvn1HNnY\r tWc+qmmoGm1hSU7sQT7wuaqh71FDXwP4JXVi0n5yknO1mr6NhivVBjtJkOQzhA9v5S7Vur6gWBfa\r +hIi28RHUMCZ8oBsT6/N7XPdbP6zAXdZf62Snri+DBtlv+wF5JzAn5ntrWO+pU6suyCqWw82zEsA\r 57iLauJ+jNKVNw3zvE7A9xWvHztGYEJ4TjDK4vndFs+fmJc5tPVdGV82FfQBdEDnDJxr75ane5zh\r uz6Y3YltedLl4UDqmEkK5vFSKmw6qqOr2x8bOWiyCUDfmd3J7fo1dx9FDg69pSjllJibtnFvH4s8\r xdSSqKedIWYo+860F2hFxA0Z1FJR3JpwfFVXb6IA3XD4Jir7llPvP/+FBrzOE8yBpWtp3P/yab4E\r 4PumO4esKFvH/wIMAL0jMNdj6wkIAAAAAElFTkSuQmCC", transform: "matrix(1 0 0 1 11 11)" }),
				_react2.default.createElement(
					"g",
					null,
					_react2.default.createElement(
						"g",
						null,
						_react2.default.createElement(
							"g",
							null,
							_react2.default.createElement(
								"g",
								{ id: "Group_2778_10_", transform: "translate(361.8 194.8)" },
								_react2.default.createElement("path", { id: "Path_506_13_", className: "st0", d: "M-337.4-157.9c3.9,7.8,10.2,14.1,18,18l6.2-6.3c0.8-0.8,1.6-0.8,3.1-0.8\r c3.1,0.8,6.2,1.6,10.2,1.6c1.6,0,3.1,1.6,3.1,3.1v9.4c0,1.6-1.6,3.1-3.1,3.1c-25.8,0-46.9-21.1-46.9-46.9l0,0\r c0-1.6,1.6-3.1,3.1-3.1l0,0h9.4c1.6,0,3.1,1.6,3.1,3.1c0,3.1,0.8,7,1.6,10.2c0,0.8,0,2.3-0.8,3.1L-337.4-157.9z" })
							)
						)
					)
				)
			)
		)
	);
	
	var iconExlcusiveCallBackState = exports.iconExlcusiveCallBackState = _react2.default.createElement(
		"svg",
		{ version: "1.1", id: "Capa_1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
			viewBox: "0 0 24 24", enableBackground: "new 0 0 24 24", xmlSpace: "preserve" },
		_react2.default.createElement(
			"g",
			null,
			_react2.default.createElement("path", { className: "cbe_st0 cbe_linea", d: "M2.2,10.4c0.9-5.4,6-9.1,11.4-8.2c3,0.5,5.5,2.3,7,4.8" })
		),
		_react2.default.createElement(
			"g",
			{ className: "cbe_telefonos" },
			_react2.default.createElement("path", { className: "cbe_st1", d: "M14.1,13.2l-1.4,1.4c-0.7-0.3-1.4-0.8-1.9-1.4c-0.6-0.6-1-1.2-1.4-1.9l1.4-1.4L10.4,7H7.1c-0.3,1.9,0.1,3.8,1,5.6\r c0.4,0.7,0.9,1.3,1.4,1.9c0.6,0.6,1.2,1,1.9,1.4c1.7,1,3.7,1.3,5.6,1v-3.3L14.1,13.2z" }),
			_react2.default.createElement("path", { className: "cbe_st1_01", d: "M14.1,13.2l-1.4,1.4c-0.7-0.3-1.4-0.8-1.9-1.4c-0.6-0.6-1-1.2-1.4-1.9l1.4-1.4L10.4,7H7.1c-0.3,1.9,0.1,3.8,1,5.6\r c0.4,0.7,0.9,1.3,1.4,1.9c0.6,0.6,1.2,1,1.9,1.4c1.7,1,3.7,1.3,5.6,1v-3.3L14.1,13.2z" })
		),
		_react2.default.createElement(
			"g",
			{ className: "cbe_opacidad_triangulo" },
			_react2.default.createElement("polygon", { className: "cbe_st1 cbe_triangulo", points: "17.6,7.3 21.8,10.7 22.7,5.4 \t" })
		),
		_react2.default.createElement("circle", { className: "cbe_st1 cicle_trans_01", cx: "2.2", cy: "13.6", r: "1.1" }),
		_react2.default.createElement("circle", { className: "cbe_st1 cicle_trans_02", cx: "4.5", cy: "18.5", r: "1.1" }),
		_react2.default.createElement("circle", { className: "cbe_st1 cicle_trans_03", cx: "9", cy: "21.4", r: "1.1" }),
		_react2.default.createElement("circle", { className: "cbe_st1 cicle_trans_04", cx: "14.4", cy: "21.6", r: "1.1" }),
		_react2.default.createElement("circle", { className: "cbe_st1 cicle_trans_05", cx: "19.1", cy: "18.9", r: "1.1" }),
		_react2.default.createElement("circle", { className: "cbe_st1 cicle_trans_06", cx: "21.6", cy: "14.2", r: "1.1" })
	);
	
	var EstadoAgenteDispLlamManual = exports.EstadoAgenteDispLlamManual = _react2.default.createElement(
		"svg",
		{ version: "1.1", id: "headphones", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink",
			viewBox: "0 0 56 61.8", xmlSpace: "preserve" },
		_react2.default.createElement("path", { className: "audi_path audi_diadema", d: "M45.4,28.5c0,0,0-3,0-5s-1.4-6.6-3-9.6c-0.9,0-1.8-0.5-2.3-1.2c-6.3-8.9-21.9-8.9-28.2,0\r c-0.5,0.8-1.4,1.2-2.3,1.2c-1.6,2.9-2.7,6.3-3,9.3c-0.2,2.4,0,4.8,0,4.9c0,0,0,1.8-1.6,1.8s-1.6-1.8-1.6-1.8c0-0.3,0-2.2,0-2.5\r c0.2-4.6,1.4-9,3.6-13c-0.5-0.8-0.5-1.9,0.1-2.6c4.3-6.1,11.4-9.6,18.9-9.3c7.6,0.1,14.4,3,18.8,9.3c0.6,0.8,0.7,1.8,0.1,2.6\r c2.1,4,3.3,8.5,3.5,13v2.9c0,0-0.1,1.4-1.5,1.4S45.4,28.5,45.4,28.5z" }),
		_react2.default.createElement("path", { className: "audi_path", d: "M7.3,23.2h2.6c1,0,3.2,1.2,3.2,2.2v15.5c0,1-1.8,2.3-3.3,2.3c-1.2,0-3.3-0.1-4.2-2.7\r C3,40.2,1.1,38.2,1,35.7v-5.2c0-1.6,0.9-3.2,2.3-4C3.3,26.5,3.5,23.2,7.3,23.2z" }),
		_react2.default.createElement("path", { className: "audi_path audi_microfono", d: "M5.1,38.4c0.7,5.4,2.8,7.6,4.2,9.1c1.9,1.8,4.1,3.2,6.6,4c0.2,1.4,1.2,2.6,2.6,2.9l6.7,1.4\r c1.8,0.4,3.5-0.8,3.9-2.6l0.2-0.8c0.4-1.8-0.8-3.5-2.6-3.9L20,47.1c-1.3-0.3-2.7,0.3-3.5,1.5c-1.9-0.7-3.7-1.7-5.1-3.1\r c-2.9-2.6-3.2-7.1-3.2-7.1s-0.1-1.8-1.7-1.8S5.1,38.4,5.1,38.4z" }),
		_react2.default.createElement("path", { className: "audi_path", d: "M48.3,26c2.1,0.6,2.7,2.3,2.7,4.5v5.2c0,2.6,0,4.7-4,4.8v0.4c-0.2,1.2-1.1,2.1-2.3,2.3h-2.6\r c-1,0-3.1-1.3-3.1-2.3V25.3c0-1,2.1-2.2,3.1-2.2c0,0,3.8-0.4,5.1,0.7C48.2,24.6,48.3,26,48.3,26z" }),
		_react2.default.createElement("path", { className: "audi_st0", d: "M29.6,47.5c2.5,2.8,2.3,7.2-0.5,9.8" }),
		_react2.default.createElement("path", { className: "audi_st0", d: "M32.4,46c3.4,3.8,3.1,9.7-0.7,13.1" }),
		_react2.default.createElement("path", { className: "audi_st0", d: "M35.3,44.3c4.4,4.9,3.9,12.3-0.9,16.7" })
	);
	
	var EstadoAgenteNotas = exports.EstadoAgenteNotas = _react2.default.createElement(
		"svg",
		{ version: "1.1", id: "wrapupAnimation", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
			viewBox: "0 0 74.3 73.7", xmlSpace: "preserve" },
		_react2.default.createElement(
			"g",
			{ id: "todoNotas" },
			_react2.default.createElement(
				"g",
				null,
				_react2.default.createElement(
					"g",
					{ id: "Group_2498_1_" },
					_react2.default.createElement(
						"g",
						{ transform: "matrix(1, 0, 0, 1, -894.31, 2170.92)" },
						_react2.default.createElement("path", { id: "Path_1187-2_1_", className: "st0 path", d: "M912-2144.1v35c0,0.5,0.7,1,1.3,1h36.5c0.6,0,1.1-0.4,1.2-1v-49.8\r c-0.1-0.6-0.6-1.1-1.2-1.2h-21.9c-0.3,0-0.6,0.1-0.9,0.2v11.8c0,1.7-1.3,3-3,3h-11.8C912.1-2144.8,912-2144.4,912-2144.1" })
					)
				),
				_react2.default.createElement(
					"g",
					{ id: "Group_2499_1_" },
					_react2.default.createElement("path", { id: "Path_1188_1_", className: "st0", d: "M30.7,22.8V12.3L19.2,23.8h10.5C30.2,23.8,30.7,23.4,30.7,22.8" })
				)
			),
			_react2.default.createElement(
				"g",
				null,
				_react2.default.createElement("line", { className: "wrapupst1", x1: "23", y1: "30", x2: "50", y2: "30" }),
				_react2.default.createElement("line", { className: "wrapupst2", x1: "23", y1: "38", x2: "48", y2: "38" }),
				_react2.default.createElement("line", { className: "wrapupst3", x1: "23", y1: "46", x2: "40", y2: "46" }),
				_react2.default.createElement("line", { className: "wrapupst4", x1: "23", y1: "53", x2: "30", y2: "53" })
			)
		)
	);
	
	var EstadoAgenteError = exports.EstadoAgenteError = _react2.default.createElement(
		"svg",
		{ version: "1.1", id: "errorAnimation", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink",
			viewBox: "0 0 56 56", xmlSpace: "preserve" },
		_react2.default.createElement(
			"g",
			{ className: "todoError" },
			_react2.default.createElement("circle", { className: "errst0", cx: "28", cy: "28", r: "22.5" }),
			_react2.default.createElement(
				"g",
				{ className: "errsigno" },
				_react2.default.createElement("line", { className: "errst1", x1: "28.1", y1: "15.5", x2: "28.1", y2: "30.5" }),
				_react2.default.createElement("line", { className: "errst2", x1: "28.1", y1: "35.5", x2: "28.1", y2: "40.5" })
			)
		)
	);
	
	var EstadoAgenteTransferenciaAni = exports.EstadoAgenteTransferenciaAni = _react2.default.createElement(
		"svg",
		{ version: "1.1", id: "Transfer", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink",
			x: "0px", y: "0px", viewBox: "0 0 74.4 74.4", enableBackground: "new 0 0 74.4 74.4;", xmlSpace: "preserve" },
		_react2.default.createElement(
			"g",
			{ className: "tel" },
			_react2.default.createElement("path", { className: "transfer_st0 transfer_tel", d: "M9.1,47.1v9.8c0,1.5,1.3,2.8,2.8,2.8c26.3,0,47.5-21.3,47.5-47.5c0,0,0,0,0,0c0-1.5-1.3-2.8-2.8-2.8h-9.8\r c-1.5,0-2.8,1.3-2.8,2.8c0,3.4-0.5,6.8-1.6,10c-0.3,1-0.1,2.1,0.7,2.8l6.2,6.2c-4,7.9-10.5,14.4-18.4,18.4l-6.2-6.2\r c-0.8-0.7-1.8-1-2.9-0.7c-3.2,1.1-6.6,1.6-10,1.6C10.3,44.3,9.1,45.6,9.1,47.1" }),
			_react2.default.createElement("path", { className: "transfer_st0 transfer_tel_02", d: "M9.1,47.1v9.8c0,1.5,1.3,2.8,2.8,2.8c26.3,0,47.5-21.3,47.5-47.5c0,0,0,0,0,0c0-1.5-1.3-2.8-2.8-2.8h-9.8\r c-1.5,0-2.8,1.3-2.8,2.8c0,3.4-0.5,6.8-1.6,10c-0.3,1-0.1,2.1,0.7,2.8l6.2,6.2c-4,7.9-10.5,14.4-18.4,18.4l-6.2-6.2\r c-0.8-0.7-1.8-1-2.9-0.7c-3.2,1.1-6.6,1.6-10,1.6C10.3,44.3,9.1,45.6,9.1,47.1" })
		),
		_react2.default.createElement(
			"g",
			{ className: "fecha_content_01" },
			_react2.default.createElement("path", { className: "transfer_st0 flecha_01", d: "M33.1,17.7l-5.9-5.9L19.1,20L15.2,16v14.4H29L24.8,26L33.1,17.7z" })
		),
		_react2.default.createElement(
			"g",
			{ className: "fecha_content_01" },
			_react2.default.createElement("path", { className: "transfer_st0 flecha_03", d: "M33.1,17.7l-5.9-5.9L19.1,20L15.2,16v14.4H29L24.8,26L33.1,17.7z" })
		),
		_react2.default.createElement(
			"g",
			{ className: "fecha_content_01" },
			_react2.default.createElement("path", { className: "transfer_st0 flecha_02", d: "M65.3,47.4H51.2l4.1,3.9l-8.2,8.1l5.9,5.9l8.2-8.2l4,4V47.4z" })
		),
		_react2.default.createElement(
			"g",
			{ className: "fecha_content_01" },
			_react2.default.createElement("path", { className: "transfer_st0 flecha_04", d: "M65.3,47.4H51.2l4.1,3.9l-8.2,8.1l5.9,5.9l8.2-8.2l4,4V47.4z" })
		)
	);
	
	var EstadoAgenteNoDisponibleAni = exports.EstadoAgenteNoDisponibleAni = _react2.default.createElement(
		"svg",
		{ version: "1.1", id: "NoAvaiable", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
			viewBox: "0 0 58.4 60.6", enableBackground: "new 0 0 58.4 60.6;", xmlSpace: "preserve" },
		_react2.default.createElement(
			"g",
			{ transform: "matrix(1, 0, 0, 1, -1.12, -1.16)" },
			_react2.default.createElement("path", { id: "Path_3501-2", className: "NoAvaiablest0", d: "M28.5,50.3L21.8,49c-1.3-0.3-2.7,0.3-3.5,1.5c-2.1-0.7-3.8-1.3-5.1-2.7\r c-0.7-0.7-1.3-0.9-1.8-1.9h0.2c1,0,1.6-2.2,1.6-3.2V27.1c0-1-0.6-1.2-1.6-1.2H9c-0.3,0-0.6-0.2-0.8-0.1c0.3-3.5,1.4-6.9,3-10\r c0.9,0,1.8-0.5,2.3-1.3c6.3-8.9,21.9-9,28.3,0c0.5,0.8,1.4,1.2,2.3,1.2c1.7,3.1,2.7,6.5,3,10c-0.2-0.1-0.4,0.1-0.6,0.1H44\r c-1,0-3.8,0.2-3.8,1.2v5.7c1.1-0.2,2.2-0.3,3.3-0.4c3.2,0,6.3,1.1,8.7,3.3v-3.4c0-2.1-0.2-3.9-2.4-4.5c0-0.1,0.3-0.3,0.3-0.4\r c-0.1-4.6-1.3-9-3.4-13.1c0.5-0.8,0.5-1.9-0.1-2.6c-4.5-6.3-11.2-9.2-18.9-9.3c-7.5-0.3-14.6,3.2-18.9,9.3\r c-0.6,0.8-0.7,1.8-0.1,2.6c-2.2,4-3.4,8.5-3.6,13.1c0,0.3-0.3,0.6-0.3,0.9c-1.5,0.8-2.4,2.3-2.6,4v5.2c0,2.6,2.5,4.6,4.7,4.8\r c0,0.2,0.2,0.3,0.2,0.5c0,0.5,0.2,1,0.5,1.4c0.7,1.9,1.8,3.7,3.3,5.1c1.9,1.9,4.1,3.2,6.6,4c0.2,1.4,1.2,2.6,2.7,2.9l6.7,1.4\r c1.8,0.4,3.6-0.8,3.9-2.6l0.2-0.8C31.5,52.4,30.3,50.7,28.5,50.3" })
		),
		_react2.default.createElement(
			"g",
			null,
			_react2.default.createElement(
				"g",
				{ id: "Group_6176" },
				_react2.default.createElement(
					"g",
					{ id: "Path_3499-2", transform: "matrix(1, 0, 0, 1, -1.12, -1.16)" },
					_react2.default.createElement("path", { className: "NoAvaiablest1", d: "M35,45.1c0-5.6,4.5-10.1,10.1-10.1c5.6,0,10.1,4.5,10.1,10.1c0,5.6-4.5,10.1-10.1,10.1\r C39.6,55.2,35,50.7,35,45.1" }),
					_react2.default.createElement("path", { className: "NoAvaiablest0", d: "M39.4,50.9l-1.8-1.8l11.2-11.2l1.8,1.8L39.4,50.9z" })
				)
			)
		)
	);
	
	var EstadoAgenteMedios = exports.EstadoAgenteMedios = function EstadoAgenteMedios(props) {
		return _react2.default.createElement(
			"svg",
			{ version: "1.1", id: "Capa_1", xmlns: "http://www.w3.org/2000/svg", x: "0px", y: "0px", xmlnsXlink: "http://www.w3.org/1999/xlink",
				viewBox: "0 0 24 24", style: { enableBackground: 'new 0 0 24 24', fill: "#fff", height: props.height ? props.height : '2rem', width: '2rem' }, xmlSpace: "preserve" },
			_react2.default.createElement("path", { d: "M11.96,4.06c-4.42,0-8,3.58-8,8c0,2.03,0.76,3.88,2,5.29v4.71l3.57-2.38c0.77,0.24,1.58,0.38,2.43,0.38c4.42,0,8-3.58,8-8\r\nS16.38,4.06,11.96,4.06z" })
		);
	};

/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.integrationIcon = exports.powered = exports.btn3FooterSVG = exports.btn2FooterSVG = exports.btn1FooterSVG = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var btn1FooterSVG = exports.btn1FooterSVG = _react2.default.createElement(
	  "svg",
	  { id: "Group_7940", "data-name": "Group 7940", xmlns: "http://www.w3.org/2000/svg", x: "0px", y: "0px",
	    viewBox: "0 0 22 22", width: "100%", height: "100%", enableBackground: "new 0 0 22 22", xmlSpace: "preserve" },
	  _react2.default.createElement("path", { d: "M13.72,40.027c0-2.708-5.6-4.222-13.72-5.037v.059c7.221.773,12.093,2.137,12.093,4.473C12.093,41.938,7.422,44.11,0,45.6v1.354C8.371,45.321,13.72,42.824,13.72,40.027Z", transform: "translate(0 -32.997)" }),
	  _react2.default.createElement("path", { d: "M3.524,45.335c0-.773-1.3-1.368-3.524-1.825v4.069C2.252,46.906,3.524,46.143,3.524,45.335Z", transform: "translate(0 -40.96)" }),
	  _react2.default.createElement("path", { d: "M19.059,4.5H.941A.932.932,0,0,0,0,5.422v.906c10.254.884,17.66,2.737,17.66,6.4,0,3.772-7.023,7.091-17.66,9.019v1.422a.932.932,0,0,0,.941.922H19.059A.932.932,0,0,0,20,23.172V5.422A.932.932,0,0,0,19.059,4.5Z", transform: "translate(0 -4.5)" }),
	  _react2.default.createElement("path", { d: "M8.434,41.587c0-1.6-3.291-2.635-8.434-3.3v.081c4.262.608,6.922,1.513,6.922,2.841,0,1.382-2.581,2.657-6.922,3.676v1.04C5.254,44.766,8.434,43.247,8.434,41.587Z", transform: "translate(0 -36.082)" })
	);
	var btn2FooterSVG = exports.btn2FooterSVG = _react2.default.createElement(
	  "svg",
	  { version: "1.1", id: "Capa_1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
	    viewBox: "0 0 22 22", width: "100%", height: "100%", enableBackground: "new 0 0 22 22", xmlSpace: "preserve" },
	  _react2.default.createElement(
	    "g",
	    null,
	    _react2.default.createElement("path", { d: "M19.5,0h-17C1.1,0,0,1.1,0,2.5v17C0,20.9,1.1,22,2.5,22h17c1.4,0,2.5-1.1,2.5-2.5v-17C22,1.1,20.9,0,19.5,0z M12.3,18.7v-3\r H9.7v3C6,18.1,3.1,14.9,3.1,11S6,3.9,9.7,3.3v3h2.5v-3c3.8,0.6,6.6,3.8,6.6,7.7S16,18.1,12.3,18.7z" }),
	    _react2.default.createElement("circle", { cx: "15.1", cy: "11", r: "1.3" }),
	    _react2.default.createElement("circle", { cx: "6.9", cy: "11", r: "1.3" })
	  )
	);
	var btn3FooterSVG = exports.btn3FooterSVG = _react2.default.createElement(
	  "svg",
	  { version: "1.1", id: "Capa_1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
	    viewBox: "0 0 22 22", width: "100%", height: "100%", enableBackground: "new 0 0 22 22", xmlSpace: "preserve" },
	  _react2.default.createElement(
	    "g",
	    null,
	    _react2.default.createElement("path", { d: "M19.5,0h-17C1.1,0,0,1.1,0,2.5v17C0,20.9,1.1,22,2.5,22h17c1.4,0,2.5-1.1,2.5-2.5v-17C22,1.1,20.9,0,19.5,0z M20.4,19.5\r c0,0.5-0.5,0.9-0.9,0.9h-17c-0.5,0-0.9-0.5-0.9-0.9v-17C1.6,2,2,1.6,2.5,1.6h17c0.5,0,0.9,0.5,0.9,0.9V19.5z" }),
	    _react2.default.createElement("path", { d: "M9.4,15.7c0,0.9-0.3,1.3-0.9,1.3c-0.6,0-1.1-0.5-1.4-0.9L5.5,17c0.5,0.9,1.6,2,3.1,2c1.7,0,2.8-0.9,2.8-2.8V9.4h-2V15.7z"
	    }),
	    _react2.default.createElement("path", { d: "M16.3,13.2L15.9,13c-0.8-0.3-1.1-0.6-1.1-1.1s0.3-0.8,0.9-0.8c0.5,0,0.9,0.2,1.3,0.8l1.3-0.9c-0.6-1.1-1.4-1.6-2.7-1.6\r c-1.6,0-2.7,1.1-2.7,2.5c0,1.6,0.9,2.2,2.2,2.8l0.5,0.2c0.8,0.3,1.3,0.6,1.3,1.3c0,0.5-0.5,0.9-1.3,0.9c-0.9,0-1.4-0.6-1.7-1.3\r l-1.4,0.9c0.6,1.1,1.6,2,3.3,2s3.1-0.9,3.1-2.7C18.9,14.6,17.9,13.8,16.3,13.2z" })
	  )
	);
	var powered = exports.powered = _react2.default.createElement(
	  "svg",
	  { className: "powered", version: "1.1", id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
	    width: "88px", height: "24px", viewBox: "0 0 88 24", enableBackground: "new 0 0 88 24",
	    xmlSpace: "preserve" },
	  _react2.default.createElement(
	    "g",
	    { id: "Group_61", transform: "translate(0 0.35)" },
	    _react2.default.createElement("path", { id: "Path_159", fill: "#666", d: "M16.345,40.99c0-3.227-6.669-5.03-16.345-6v.07c8.6.92,14.407,2.545,14.407,5.328,0,2.879-5.565,5.466-14.407,7.247v1.613C9.972,47.3,16.345,44.322,16.345,40.99Z", transform: "translate(0 -32.616)" }),
	    _react2.default.createElement("path", { id: "Path_160", fill: "#666", d: "M4.2,45.685c0-.92-1.547-1.63-4.2-2.175v4.847C2.683,47.556,4.2,46.647,4.2,45.685Z", transform: "translate(0 -40.473)" }),
	    _react2.default.createElement("path", { id: "Path_161", fill: "#666", d: "M22.7,4.5H1.121A1.11,1.11,0,0,0,0,5.6V6.678c12.216,1.053,21.038,3.261,21.038,7.627,0,4.494-8.367,8.447-21.038,10.744v1.694a1.11,1.11,0,0,0,1.121,1.1H22.7a1.11,1.11,0,0,0,1.121-1.1V5.6A1.11,1.11,0,0,0,22.7,4.5Z", transform: "translate(0 -4.5)" }),
	    _react2.default.createElement("path", { id: "Path_162", fill: "#666", d: "M10.047,42.218c0-1.9-3.92-3.139-10.047-3.928v.1c5.077.725,8.246,1.8,8.246,3.385,0,1.647-3.075,3.165-8.246,4.38V47.39C6.258,46,10.047,44.2,10.047,42.218Z", transform: "translate(0 -35.659)" })
	  ),
	  _react2.default.createElement(
	    "g",
	    { id: "Group_69", transform: "translate(28.809)" },
	    _react2.default.createElement(
	      "g",
	      { id: "Group_67", transform: "translate(0 10.374)" },
	      _react2.default.createElement("path", { id: "Path_163", fill: "#d5010c", d: "M557.786,194.511c0,3.893-1.947,4.672-3.5,4.672C550,199.183,550,194.9,550,194.9v-5.45h2.336v5.45a1.816,1.816,0,0,0,1.947,1.947c.779,0,2.725-.389,2.725-2.336V189.45h2.336v9.343H557.4l-.389-4.282Z", transform: "translate(-536.464 -185.557)" }),
	      _react2.default.createElement("path", { id: "Path_164", fill: "#d5010c", d: "M875.061,142.954a3.035,3.035,0,0,0-2.725,1.3v-4.8H870v13.236h1.947l.117-1.4a3,3,0,0,0,3,1.791c3.5,0,4.282-2.725,4.282-5.061S878.565,142.954,875.061,142.954Zm-.389,7.786c-1.557,0-2.336-1.168-2.336-2.725s.779-2.725,2.336-2.725,2.336,1.168,2.336,2.725S876.229,150.74,874.672,150.74Z", transform: "translate(-832.4 -139.45)" }),
	      _react2.default.createElement(
	        "g",
	        { id: "Group_62", transform: "translate(33.982)" },
	        _react2.default.createElement("rect", { id: "Rectangle_20", fill: "#d5010c", width: "2.336", height: "9.343", transform: "translate(0 3.893)" }),
	        _react2.default.createElement("rect", { id: "Rectangle_21", fill: "#d5010c", width: "2.336", height: "2.336" })
	      ),
	      _react2.default.createElement("path", { id: "Path_165", fill: "#d5010c", d: "M1009.672,184.45c-2.336,0-4.282.779-4.282,3.5h2.336c0-.779.389-1.168,1.947-1.168,1.947,0,2.336.389,2.336,1.557v.649c-.624-.535-1.641-.649-3.114-.649-3.115,0-3.893,1.557-3.893,3.114s.779,3.114,3.893,3.114c1.366,0,2.732-.193,3.425-1.251l.079.862h1.947v-5.84C1014.343,184.839,1012.008,184.45,1009.672,184.45Zm0,8.175c-1.168,0-2.336,0-2.336-1.168s1.168-1.168,2.336-1.168,2.336,0,2.336,1.168S1010.84,192.625,1009.672,192.625Z", transform: "translate(-957.342 -180.946)" }),
	      _react2.default.createElement(
	        "g",
	        { id: "Group_66", transform: "translate(56.612)" },
	        _react2.default.createElement(
	          "g",
	          { id: "Group_64", transform: "translate(0.971 0.649)" },
	          _react2.default.createElement(
	            "g",
	            { id: "Group_63" },
	            _react2.default.createElement("path", { id: "Path_166", fill: "#d5010c", d: "M1132.47,147.79h.663a.665.665,0,0,1,.316.074.531.531,0,0,1,.214.2.578.578,0,0,1,.076.3.476.476,0,0,1-.11.311.635.635,0,0,1-.278.2l0,.018.487.7v.02h-.393l-.469-.683h-.16v.683h-.343V147.79Zm.66.819a.261.261,0,0,0,.19-.071.24.24,0,0,0,.074-.18.246.246,0,0,0-.259-.251h-.322v.5Z", transform: "translate(-1132.47 -147.79)" })
	          )
	        ),
	        _react2.default.createElement(
	          "g",
	          { id: "Group_65" },
	          _react2.default.createElement("path", { id: "Path_167", fill: "#d5010c", d: "M1121.557,142.564a1.557,1.557,0,1,1,1.557-1.557A1.559,1.559,0,0,1,1121.557,142.564Zm0-2.854a1.3,1.3,0,1,0,1.3,1.3A1.3,1.3,0,0,0,1121.557,139.71Z", transform: "translate(-1120 -139.45)" })
	        )
	      ),
	      _react2.default.createElement("path", { id: "Path_168", fill: "#d5010c", d: "M380.122,139.45v9.9l-6.936-9.9H370v13.236h2.336V142.372l6.936,10.314h3.186V139.45Z", transform: "translate(-370 -139.45)" }),
	      _react2.default.createElement("path", { id: "Path_169", fill: "#d5010c", d: "M694.343,189.45h-3.114l-1.557,3.114-1.557-3.114H685l3.114,4.672L685,198.793h3.114l1.557-3.114,1.557,3.114h3.114l-3.114-4.672Z", transform: "translate(-661.312 -185.557)" })
	    ),
	    _react2.default.createElement(
	      "g",
	      { id: "Group_68" },
	      _react2.default.createElement("path", { id: "Path_170", fill: "#666", d: "M370,5.77h2.185q2.193,0,2.193,2.032a2,2,0,0,1-.566,1.556,2.328,2.328,0,0,1-1.618.512h-1.133v2.193H370Zm2.068,3.209a1.354,1.354,0,0,0,.94-.283,1.13,1.13,0,0,0,.31-.877,1.131,1.131,0,0,0-.31-.881,1.4,1.4,0,0,0-.958-.279h-.989V8.979h1.007Z", transform: "translate(-370 -5.321)" }),
	      _react2.default.createElement("path", { id: "Path_171", fill: "#666", d: "M432.951,32.5a2.076,2.076,0,0,1-.786-.841,2.629,2.629,0,0,1,0-2.337,2.092,2.092,0,0,1,.786-.841,2.277,2.277,0,0,1,1.2-.31,2.3,2.3,0,0,1,1.214.31,2.051,2.051,0,0,1,.783.841,2.67,2.67,0,0,1,0,2.337,2.056,2.056,0,0,1-.783.841,2.514,2.514,0,0,1-2.418,0Zm2.118-.93a1.932,1.932,0,0,0,0-2.154,1.117,1.117,0,0,0-.913-.4,1.1,1.1,0,0,0-.908.4,1.952,1.952,0,0,0,0,2.154,1.107,1.107,0,0,0,.908.4A1.12,1.12,0,0,0,435.068,31.569Z", transform: "translate(-427.071 -25.977)" }),
	      _react2.default.createElement("path", { id: "Path_172", fill: "#666", d: "M495.28,29.33h1.034l.8,3.273L498,29.429h.9l.872,3.174.809-3.273h1.034L500.3,33.789h-.926l-.926-3.047-.927,3.047h-.926Z", transform: "translate(-485.526 -27.046)" }),
	      _react2.default.createElement("path", { id: "Path_173", fill: "#666", d: "M582.742,32.6a2.076,2.076,0,0,1-.823-.849,2.688,2.688,0,0,1-.023-2.337,1.978,1.978,0,0,1,.755-.823,2.2,2.2,0,0,1,1.173-.306,2.05,2.05,0,0,1,1.029.248,1.666,1.666,0,0,1,.665.679,2.077,2.077,0,0,1,.229.989,2.32,2.32,0,0,1-.063.548h-3a1.424,1.424,0,0,0,.481,1.007,1.554,1.554,0,0,0,.994.315,2.652,2.652,0,0,0,1.321-.332l.072.836a3.285,3.285,0,0,1-1.493.342A2.583,2.583,0,0,1,582.742,32.6Zm1.982-2.535a1,1,0,0,0-.225-.665.839.839,0,0,0-.683-.269,1.058,1.058,0,0,0-1.1.935h2Z", transform: "translate(-565.161 -26.078)" }),
	      _react2.default.createElement("path", { id: "Path_174", fill: "#666", d: "M645.61,28.26h.908l.054.566a2,2,0,0,1,.557-.477,1.3,1.3,0,0,1,.656-.18,1.241,1.241,0,0,1,.2.018l-.081,1.025a1.23,1.23,0,0,0-.9.094.89.89,0,0,0-.368.328v3.083H645.61Z", transform: "translate(-624.151 -25.977)" }),
	      _react2.default.createElement("path", { id: "Path_175", fill: "#666", d: "M680.772,32.6a2.076,2.076,0,0,1-.823-.849,2.688,2.688,0,0,1-.023-2.337,1.978,1.978,0,0,1,.755-.823,2.2,2.2,0,0,1,1.173-.306,2.049,2.049,0,0,1,1.029.248,1.666,1.666,0,0,1,.665.679,2.077,2.077,0,0,1,.229.989,2.32,2.32,0,0,1-.063.548h-3a1.424,1.424,0,0,0,.481,1.007,1.554,1.554,0,0,0,.993.315,2.654,2.654,0,0,0,1.321-.332l.072.836a3.285,3.285,0,0,1-1.493.342A2.583,2.583,0,0,1,680.772,32.6Zm1.982-2.535a1,1,0,0,0-.225-.665.839.839,0,0,0-.683-.269,1.058,1.058,0,0,0-1.1.935h2Z", transform: "translate(-655.559 -26.078)" }),
	      _react2.default.createElement("path", { id: "Path_176", fill: "#666", d: "M744.477,0V6.743h-.926l-.045-.378a1.811,1.811,0,0,1-1.268.467,1.924,1.924,0,0,1-1.088-.31,2.046,2.046,0,0,1-.719-.836,2.657,2.657,0,0,1-.251-1.164,2.711,2.711,0,0,1,.248-1.16,2.044,2.044,0,0,1,.71-.845,1.913,1.913,0,0,1,1.1-.315,1.829,1.829,0,0,1,1.232.431V0Zm-1.245,5.6a1.68,1.68,0,0,0,.31-1.079,1.69,1.69,0,0,0-.315-1.079,1.013,1.013,0,0,0-.836-.4,1.028,1.028,0,0,0-.863.409,1.7,1.7,0,0,0-.315,1.065,1.686,1.686,0,0,0,.315,1.057,1.029,1.029,0,0,0,.863.409A1.018,1.018,0,0,0,743.232,5.6Z", transform: "translate(-711.357)" }),
	      _react2.default.createElement("path", { id: "Path_177", fill: "#666", d: "M840.408,2.517a2.006,2.006,0,0,1,.692.841,2.767,2.767,0,0,1,.238,1.155,2.727,2.727,0,0,1-.248,1.169,2.039,2.039,0,0,1-.7.841,1.84,1.84,0,0,1-1.065.31,1.9,1.9,0,0,1-1.313-.467l-.045.378h-.926V0h1.007V2.67a1.931,1.931,0,0,1,1.277-.467A1.855,1.855,0,0,1,840.408,2.517ZM840,5.579a1.751,1.751,0,0,0,.3-1.065,1.73,1.73,0,0,0-.3-1.06.963.963,0,0,0-.814-.4,1.076,1.076,0,0,0-.881.386,1.662,1.662,0,0,0-.315,1.079,1.682,1.682,0,0,0,.315,1.088,1.073,1.073,0,0,0,.881.387A.961.961,0,0,0,840,5.579Z", transform: "translate(-800.676)" }),
	      _react2.default.createElement("path", { id: "Path_178", fill: "#666", d: "M897.691,33.528l-1.861-4.2h1.115l1.232,3.03,1.2-3.03H900.5l-2.778,6.635h-1.034Z", transform: "translate(-854.888 -27.046)" })
	    )
	  )
	);
	var integrationIcon = exports.integrationIcon = _react2.default.createElement(
	  "svg",
	  { version: "1.1", id: "Group_6886", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
	    viewBox: "0 0 22 22", enableBackground: "new 0 0 22 22", xmlSpace: "preserve" },
	  _react2.default.createElement("path", { id: "Path_3324", style: { opacity: 0.7 }, d: "M17.8,3.6L14.2,0v1.8c-0.7,0-1.3,0.1-1.9,0.2C11,2.5,9.8,3.2,8.8,4.2c0.8,0.7,1.6,1.5,2.2,2.3\r\nc0,0,0.1,0.1,0.1,0.1c1.8-1.7,3-1.4,3-1.4s0,0,0.1,0v1.9L17.8,3.6z" }),
	  _react2.default.createElement(
	    "g",
	    { id: "Group_6888", transform: "translate(0 9.129)", style: { opacity: 0.7 } },
	    _react2.default.createElement("path", { id: "Path_3325", d: "M5.7,2.1C5.1,1.3,4.4,0.6,3.6,0C2.5,0.7,1.3,1.3,0,1.7v3.4c2.2-0.5,4.2-1.4,6-2.6\r C5.9,2.4,5.8,2.2,5.7,2.1z" })
	  ),
	  _react2.default.createElement("path", { id: "Path_3326", d: "M17.8,12.4l-3.6-3.6v1.9c-0.1,0-0.1,0-0.1,0c0,0-1.8,0.3-4.5-3c-2.3-2.9-5.4-5-9-5.9L0,1.8v3.5\r\nc2.6,0.8,5.3,2.5,7,4.6c2.9,3.6,5.5,4.3,6.9,4.3c0.1,0,0.2,0,0.3,0V16L17.8,12.4z" })
	);

/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.Animated_phone = exports.twitterHeader = exports.mailHeader = exports.linkedinHeader = exports.facebookHeader = exports.mensajesHeader = exports.llamadasHeader = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var llamadasHeader = exports.llamadasHeader = _react2.default.createElement(
		"svg",
		{ version: "1.1", id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
			viewBox: "0 0 40 40", enableBackground: "new 0 0 40 40", xmlSpace: "preserve" },
		_react2.default.createElement(
			"g",
			null,
			_react2.default.createElement(
				"g",
				null,
				_react2.default.createElement("path", { className: "borderIconHeader", d: "M35.7,38.4c-13.1,0-23.8-10.7-23.8-23.8c0-1.5,1.3-2.8,2.8-2.8h4.6c1.5,0,2.8,1.3,2.8,2.8c0,1.5,0.2,2.9,0.7,4.2\r c0.3,1,0.1,2.1-0.7,2.9L20,23.8c1.6,2.7,3.9,5,6.6,6.6l2.1-2.1c0.5-0.5,1.2-0.8,2-0.8c0.3,0,0.6,0,0.9,0.1\r c1.3,0.4,2.8,0.7,4.2,0.7c1.5,0,2.8,1.3,2.8,2.8v4.6C38.5,37.2,37.3,38.4,35.7,38.4z" })
			)
		),
		_react2.default.createElement(
			"g",
			null,
			_react2.default.createElement(
				"g",
				null,
				_react2.default.createElement("path", { className: "iconHeader", d: "M18.1,23.5c1.9,3.7,4.9,6.8,8.7,8.7l2.9-2.9c0.4-0.4,0.9-0.5,1.3-0.3c1.5,0.5,3.1,0.8,4.7,0.8\r c0.7,0,1.3,0.6,1.3,1.3v4.6c0,0.7-0.6,1.3-1.3,1.3c-12.3,0-22.3-10-22.3-22.3c0-0.7,0.6-1.3,1.3-1.3h4.6c0.7,0,1.3,0.6,1.3,1.3\r c0,1.6,0.3,3.2,0.7,4.7c0.1,0.5,0,1-0.3,1.3L18.1,23.5z" })
			)
		)
	);
	
	var mensajesHeader = exports.mensajesHeader = _react2.default.createElement(
		"svg",
		{ version: "1.1", id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
			viewBox: "0 0 40 40", enableBackground: "new 0 0 40 40", xmlSpace: "preserve" },
		_react2.default.createElement(
			"g",
			null,
			_react2.default.createElement(
				"g",
				null,
				_react2.default.createElement(
					"g",
					null,
					_react2.default.createElement("path", { className: "borderIconHeader", d: "M39,29.7c0-2.2-1.3-4.3-3.6-5.7c0,0-0.1,0-0.1,0c0-0.2,0-0.4,0-0.6c0-5.9-6.3-10.7-14.1-10.7c-7.8,0-14.1,4.8-14.1,10.7\r c0,3.3,1.9,6.3,5.2,8.3c-0.2,0.3-0.4,0.7-0.8,1.2c-0.6,0.6-0.8,1.5-0.5,2.2c0.3,0.8,1,1.3,1.9,1.4c0.1,0,0.1,0,0.2,0\r c1.3,0,4.5-0.5,7.3-2.4c0.3,0,0.6,0,0.8,0c0.1,0,0.2,0,0.4,0c0.1,0.1,0.1,0.2,0.2,0.2c1.8,1.7,4.6,2.8,7.5,2.8c0.1,0,0.2,0,0.3,0\r c0.9,0.7,2.5,1.5,5.2,1.7c0,0,0.1,0,0.1,0c0.5,0,1-0.3,1.3-0.8c0.3-0.5,0.2-1.2-0.2-1.6c-0.2-0.2-0.4-0.5-0.7-1\r C37.7,34,39,31.9,39,29.7z" })
				)
			)
		),
		_react2.default.createElement(
			"g",
			null,
			_react2.default.createElement(
				"g",
				null,
				_react2.default.createElement("path", { className: "iconHeader", d: "M21.3,14.1c-7,0-12.6,4.1-12.6,9.3c0,3.2,2.2,6,5.6,7.7c-0.1,0.5-0.5,1.5-1.5,2.8c-0.3,0.3-0.4,1.1,0.4,1.2\r c0.9,0,4.1-0.4,6.9-2.5c0.4,0,0.8,0,1.3,0c7,0,12.6-4.2,12.6-9.3S28.3,14.1,21.3,14.1z" }),
				_react2.default.createElement(
					"g",
					null,
					_react2.default.createElement("path", { className: "iconHeader", d: "M37.6,29.7c0-1.8-1.1-3.4-2.9-4.5c-0.8,4.3-5.9,7.7-11.8,8c1.5,1.4,3.9,2.3,6.5,2.3c0.3,0,0.6,0,0.8,0\r c0.5,0.5,1.8,1.5,4.8,1.8c-0.3-0.4-1.1-1.3-1.3-2.6C36,33.6,37.6,31.8,37.6,29.7z" })
				)
			)
		)
	);
	
	var facebookHeader = exports.facebookHeader = _react2.default.createElement(
		"svg",
		{ version: "1.1", id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
			viewBox: "0 0 40 40", enableBackground: "new 0 0 40 40", xmlSpace: "preserve" },
		_react2.default.createElement(
			"g",
			null,
			_react2.default.createElement(
				"g",
				null,
				_react2.default.createElement("path", { className: "borderIconHeader", d: "M21.4,38.9c-0.9,0-1.9-0.6-1.9-1.5V28h-1.9c-0.9,0-1.2-1-1.2-1.8v-4.5c0-0.9,0.4-1.5,1.2-1.5h2.3c0,0,0-1.1,0-1.6\r c0-0.6,0-1.3,0.2-1.9c0.3-1.9,1.2-3.3,2.6-4.3c1.2-0.8,2.6-1.3,4.2-1.3h0.4c0.6,0,1.3,0,1.9,0.1h0.2c0.4,0,0.7,0.1,1,0.1h0.2\r c0.8,0.1,1.3,0.7,1.3,1.5v4c0,0.9-0.6,1.6-1.5,1.6h-1.6c-0.3,0-0.6,0-0.9,0c-0.2,0-0.3,0-0.4,0c0,0,0,0.1,0,0.2c0,0.4,0,1.6,0,1.6\r h2.8c0.4,0,0.9,0.2,1.2,0.5s0.4,0.8,0.4,1.2c-0.2,1.5-0.4,3.1-0.6,4.6c0,0.8-0.7,1.5-1.5,1.5h-2.6v9.4c0,0.9-0.3,1.5-1.2,1.5H21.4\r z" }),
				_react2.default.createElement("path", { className: "iconHeader", d: "M27.9,16.8c0.8,0,1.5,0,2.3,0c0.1,0,0.2,0,0.3,0v-4c-0.4,0-0.8-0.1-1.3-0.1c-0.8,0-1.6-0.1-2.4-0.1\r c-1.2,0-2.3,0.3-3.3,1c-1.1,0.8-1.8,2-2,3.3c-0.1,0.6-0.1,1.1-0.1,1.7c0,0.9,0,1.8,0,2.7v0.3h-3.8v4.5h3.8v11.2H26V26.2h3.8\r c0.2-1.5,0.4-3,0.6-4.5c-0.3,0-0.6,0-0.9,0c-1.1,0-3.5,0-3.5,0s0-2.2,0-3.2C26.1,17.3,26.9,16.8,27.9,16.8z" })
			)
		)
	);
	
	var linkedinHeader = exports.linkedinHeader = _react2.default.createElement(
		"svg",
		{ version: "1.1", id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
			viewBox: "0 0 40 40", enableBackground: "new 0 0 40 40", xmlSpace: "preserve" },
		_react2.default.createElement(
			"g",
			null,
			_react2.default.createElement(
				"g",
				null,
				_react2.default.createElement(
					"g",
					null,
					_react2.default.createElement("path", { className: "borderIconHeader", d: "M14.6,38.7c-0.8,0-1.8-0.5-1.8-1.3V21.9c0-0.8,0.8-1.4,1.6-1.4c-1.1-0.8-1.7-2-1.7-3.4c0-2.3,1.9-4.2,4.3-4.2\r s4.2,1.9,4.2,4.2c0,1.4-0.4,2.7-1.5,3.4c0.8,0,1.7,0.7,1.7,1.4v15.4c0,0.8-1.2,1.3-2,1.3H14.6z" }),
					_react2.default.createElement("path", { className: "iconHeader", d: "M14.6,21.9h4.8v15.4h-4.8V21.9z M17,14.2c1.5,0,2.8,1.2,2.8,2.8c0,1.5-1.2,2.8-2.8,2.8\r c-1.5,0-2.8-1.2-2.8-2.8C14.2,15.5,15.5,14.2,17,14.2" }),
					_react2.default.createElement("path", { className: "borderIconHeader", d: "M32.6,38.7c-0.8,0-1.1-0.5-1.1-1.3v-7.5c0-2.6-0.6-2.6-1.3-2.6c-0.7,0-1.6,0-1.6,2.5v7.6c0,0.8-0.6,1.3-1.4,1.3h-4.8\r c-0.8,0-2.4-0.5-2.4-1.3V21.9c0-0.8,0.2-2,1-2h6c0.4,0,0.8,0.5,1.1,0.8c0.9-0.5,2.1-0.8,3.5-0.8c7.2,0,7.2,6.5,7.2,8.9v8.5\r c0,0.8-0.6,1.3-1.4,1.3H32.6z" }),
					_react2.default.createElement("path", { className: "iconHeader", d: "M22.4,21.9H27V24h0.1c0.6-1.2,2.2-2.5,4.5-2.5c4.9,0,5.7,3.2,5.7,7.3v8.5h-4.8v-7.5c0-1.8,0-4.1-2.5-4.1\r c-2.5,0-2.9,1.9-2.9,4v7.6h-4.8L22.4,21.9L22.4,21.9z" })
				)
			)
		)
	);
	
	var mailHeader = exports.mailHeader = _react2.default.createElement(
		"svg",
		{ version: "1.1", id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
			viewBox: "0 0 40 40", enableBackground: "new 0 0 40 40", xmlSpace: "preserve" },
		_react2.default.createElement("path", { className: "borderIconHeader", d: "M13.4,38.5c-2.2,0-4-1.7-4-3.9l0-15.9c0-2.2,1.8-4,4-4h21.2c2.2,0,4,1.9,4,4.1v15.9c0,2.2-1.8,3.9-4,3.9H13.4z M33.3,33.2\r v-9.4l-8.6,5.4c-0.2,0.1-0.5,0.2-0.7,0.2c-0.2,0-0.5-0.1-0.7-0.2l-8.6-5.4v9.4H33.3z M24,23.7l6-3.7H18L24,23.7z" }),
		_react2.default.createElement("path", { className: "iconHeader", d: "M34.6,16H13.4c-1.5,0-2.6,1.2-2.6,2.6l0,15.9c0,1.5,1.2,2.6,2.6,2.6h21.2c1.5,0,2.6-1.2,2.6-2.6V18.7\r C37.2,17.2,36.1,16,34.6,16z M34.6,34.5H13.4V21.3L24,27.9l10.6-6.6V34.5z M24,25.3l-10.6-6.6h21.2L24,25.3z" })
	);
	
	var twitterHeader = exports.twitterHeader = _react2.default.createElement(
		"svg",
		{ version: "1.1", id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
			viewBox: "0 0 40 40", enableBackground: "new 0 0 40 40", xmlSpace: "preserve" },
		_react2.default.createElement(
			"g",
			null,
			_react2.default.createElement(
				"g",
				null,
				_react2.default.createElement("path", { className: "borderIconHeader", d: "M19,38.3c-3.2,0-6.2-0.9-8.9-2.5c-0.5-0.3-0.8-1-0.6-1.6c0.2-0.6,0.7-0.9,1.2-0.9c0,0,0.1,0,0.1,0c0.4,0,0.8,0.1,1.1,0.1\r c1.2,0,2.3-0.2,3.4-0.6c-1.6-0.9-2.6-2.4-3-3.8c-0.1-0.3-0.1-0.7,0.1-0.9c-0.4-0.4-0.7-0.8-1-1.3c-0.7-1.1-1-2.3-1-3.6\r c0-0.5,0.2-0.9,0.6-1.1c-0.2-0.4-0.3-0.8-0.4-1.2c-0.4-1.7-0.1-3.4,0.7-4.9c0.2-0.4,0.6-0.6,1-0.7c0,0,0.1,0,0.1,0\r c0.4,0,0.8,0.2,1,0.5c2.4,2.8,5.2,4.5,8.7,5c0-1.2,0.4-2.3,1-3.4c1.1-1.7,2.7-2.7,4.6-3.1C28.2,14,28.7,14,29,14\r c1.6,0,3,0.5,4.3,1.6c0.8-0.2,1.6-0.5,2.3-0.9c0,0,0.1-0.1,0.2-0.1c0,0,0.2-0.1,0.2-0.1v0c0,0,0.3-0.1,0.4-0.1\r c0.4,0,0.8,0.2,1.1,0.6c0.3,0.4,0.3,0.8,0.2,1.2c-0.1,0.1-0.1,0.3-0.2,0.4c0.3,0.1,0.5,0.2,0.7,0.5c0.4,0.5,0.4,1.2,0,1.7\r c0,0-0.5,0.7-0.6,0.8c-0.5,0.6-1.1,1.2-1.8,1.8c0,0.7,0,1.4-0.1,2c-0.2,1.8-0.7,3.6-1.5,5.2c-0.8,1.7-1.9,3.3-3.2,4.7\r c-2.2,2.3-5,3.8-8.2,4.6c-1,0.2-2.1,0.4-3.3,0.4C19.3,38.3,19.1,38.3,19,38.3z" })
			)
		),
		_react2.default.createElement("path", { className: "iconHeader", d: "M18.7,32.2c-2.8-0.1-4.6-2.1-5.1-3.8c0.8,0.2,1.6,0.1,2.3-0.1c0,0,0,0,0.1,0c-1.5-0.4-2.7-1.2-3.5-2.5\r C11.9,25,11.7,24,11.7,23c0.8,0.4,1.6,0.6,2.4,0.7c-1.2-0.8-1.9-1.9-2.2-3.3c-0.3-1.4-0.1-2.7,0.6-3.9c2.9,3.5,6.7,5.4,11.2,5.7\r c0-0.2-0.1-0.4-0.1-0.6c-0.1-1.3,0.1-2.5,0.8-3.6c0.9-1.4,2.1-2.2,3.7-2.5c1.8-0.3,3.4,0.2,4.8,1.5c0.1,0.1,0.2,0.1,0.3,0.1\r c1.1-0.2,2.2-0.6,3.2-1.2c0,0,0,0,0.1,0c0,0,0,0,0,0c-0.4,1.3-1.2,2.2-2.3,3c1.1-0.1,2.1-0.4,3-0.8c0,0,0,0,0,0\r c-0.2,0.3-0.4,0.6-0.6,0.8c-0.6,0.7-1.2,1.3-2,1.9c-0.1,0-0.1,0.1-0.1,0.2c0,0.8,0,1.6-0.1,2.4c-0.2,1.7-0.7,3.3-1.4,4.8\r c-0.7,1.6-1.7,3-2.9,4.3c-2.1,2.1-4.6,3.5-7.5,4.2c-1,0.2-2,0.3-3,0.4c-3.1,0.1-6-0.7-8.7-2.3c0,0-0.1,0-0.1-0.1\r c1.9,0.2,3.7,0,5.4-0.8C17,33.4,17.9,32.9,18.7,32.2z" })
	);
	
	var Animated_phone = exports.Animated_phone = _react2.default.createElement(
		"svg",
		{ version: "1.1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
			width: "72px", height: "72px", viewBox: "0 0 72 72", enableBackground: "new 0 0 72 72", xmlSpace: "preserve" },
		_react2.default.createElement("path", { fill: "#FFFFFF", d: "M27.033,33.983c2.4,4.716,6.267,8.565,10.983,10.983l3.667-3.668c0.449-0.449,1.117-0.598,1.699-0.399\r c1.867,0.618,3.883,0.95,5.951,0.95C50.25,41.85,51,42.6,51,43.516v5.818C51,50.25,50.25,51,49.334,51\r C33.683,51,21,38.318,21,22.667C21,21.75,21.75,21,22.667,21H28.5c0.916,0,1.667,0.75,1.667,1.667c0,2.083,0.333,4.083,0.949,5.95\r c0.184,0.583,0.051,1.233-0.417,1.7L27.033,33.983z" })
	);

/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.passIcon = exports.exitSVG = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var exitSVG = exports.exitSVG = _react2.default.createElement(
		"svg",
		{ className: "exitSVG", version: "1.1", id: "Capa_1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
			viewBox: "0 0 22 22", enableBackground: "new 0 0 22 22;", xmlSpace: "preserve" },
		_react2.default.createElement(
			"g",
			{ id: "Group_3982", transform: "translate(-19579 -18870)" },
			_react2.default.createElement(
				"g",
				{ id: "Group_1952", transform: "translate(7.353 6.367)" },
				_react2.default.createElement("path", { id: "Path_1000", className: "st0", d: "M19587.8,18871.3l2.4,2.4h-11.2v1.8h11l-2.3,2.3l1.3,1.3l4.6-4.6l-4.6-4.6L19587.8,18871.3z"
				})
			),
			_react2.default.createElement(
				"g",
				null,
				_react2.default.createElement(
					"defs",
					null,
					_react2.default.createElement("rect", { id: "SVGID_1_", x: "19579", y: "18870", width: "22", height: "22" })
				),
				_react2.default.createElement(
					"clipPath",
					{ id: "SVGID_2_" },
					_react2.default.createElement("use", { xlinkHref: "#SVGID_1_" })
				),
				_react2.default.createElement(
					"g",
					{ id: "Group_1954", transform: "translate(0 0)", className: "st1" },
					_react2.default.createElement(
						"g",
						{ id: "Group_1953", transform: "translate(0 0)" },
						_react2.default.createElement("path", { id: "Path_1001", className: "st0", d: "M19590,18890.2c-5.1,0-9.2-4.1-9.3-9.2c0-5.1,4.2-9.2,9.3-9.2c2.9,0,5.7,1.4,7.4,3.7\r l1.3-1.3c-2.1-2.7-5.3-4.2-8.7-4.2c-6.1,0-11,4.9-11,11c0,6.1,4.9,11,11,11c3.3,0,6.5-1.5,8.6-4.1l-1.3-1.3\r C19595.6,18888.9,19592.9,18890.2,19590,18890.2" })
					)
				)
			)
		)
	);
	
	var passIcon = exports.passIcon = _react2.default.createElement(
		"svg",
		{ version: "1.1", id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
			width: "18px", height: "18px", viewBox: "0 0 30 30", enableBackground: "new 0 0 30 30", xmlSpace: "preserve" },
		_react2.default.createElement(
			"g",
			null,
			_react2.default.createElement(
				"g",
				null,
				_react2.default.createElement("path", { d: "M8.104,12.259v2.074l2.033-0.701l0.37,1.028l-2.031,0.662l1.259,1.757l-0.924,0.66l-1.215-1.826\r L6.36,17.739l-0.951-0.66l1.277-1.757l-2.051-0.662l0.372-1.034l2.013,0.726v-2.094H8.104z" }),
				_react2.default.createElement("path", { d: "M15.53,12.259v2.074l2.036-0.701l0.371,1.028l-2.032,0.662l1.257,1.757l-0.922,0.66l-1.215-1.826\r l-1.236,1.826l-0.95-0.66l1.277-1.757l-2.051-0.662l0.373-1.034l2.014,0.726v-2.094H15.53z" }),
				_react2.default.createElement("path", { d: "M22.961,12.259v2.074l2.032-0.701l0.371,1.028l-2.029,0.662l1.258,1.757l-0.922,0.66l-1.218-1.826\r l-1.237,1.826l-0.949-0.66l1.277-1.757l-2.052-0.662l0.374-1.034l2.014,0.726v-2.094H22.961z" })
			),
			_react2.default.createElement(
				"g",
				null,
				_react2.default.createElement("path", { fill: "#DFDFDF", d: "M26.537,20.745H3.464C2.106,20.745,1,19.64,1,18.282v-6.565c0-1.356,1.107-2.461,2.465-2.461h23.073\r c1.357,0,2.463,1.105,2.463,2.461v6.565C29,19.64,27.895,20.745,26.537,20.745z M3.464,10.532c-0.653,0-1.188,0.531-1.188,1.185\r v6.565c0,0.652,0.534,1.186,1.188,1.186h23.073c0.652,0,1.188-0.533,1.188-1.186v-6.565c0-0.653-0.535-1.185-1.188-1.185H3.464z"
				})
			)
		)
	);

/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Singleton = __webpack_require__(21);
	
	var _CallSpaceHeaderSVG = __webpack_require__(67);
	
	var _reactBootstrap = __webpack_require__(73);
	
	var _busySound = __webpack_require__(2608);
	
	var _busySound2 = _interopRequireDefault(_busySound);
	
	var _otherCongestionNot_service = __webpack_require__(2610);
	
	var _otherCongestionNot_service2 = _interopRequireDefault(_otherCongestionNot_service);
	
	var _FaxMachineSound = __webpack_require__(2604);
	
	var _FaxMachineSound2 = _interopRequireDefault(_FaxMachineSound);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var language = new _Singleton.Singleton();
	
	function AlertManualCallWindow(props) {
		var _props$icon = props.icon,
		    icon = _props$icon === undefined ? true : _props$icon,
		    _props$buttonClose = props.buttonClose,
		    buttonClose = _props$buttonClose === undefined ? true : _props$buttonClose;
	
		var audioBusy = new Audio(_busySound2.default);
		var audioOther = new Audio(_otherCongestionNot_service2.default);
		var audioFaxMachine = new Audio(_FaxMachineSound2.default);
	
		(0, _react.useEffect)(function () {
			if (props.alertCode) {
				playAudio(3000);
			}
		}, [props.alertCode]);
	
		var getMessageAlert = function getMessageAlert() {
			var complete = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
			var message = props.alertCode === 'CUSTOM' ? props.message : language.getText('alert-' + props.alertCode);
			if (!complete && message && message.length > 100) {
				message = message.slice(0, 90) + '...';
			}
			return message;
		};
		var onClickHandler = function onClickHandler() {
			props.closeAlert(false);
	
			playAudio(0);
		};
		var playAudio = function playAudio(time) {
			if (!props.playStopAudio) return;
			switch (props.alertCode) {
				case '1500':
					//Ocupado -> Linea ocupada
					props.playStopAudio(audioBusy, time);
					break;
				case '1507':
				//sin servicio 1507 -> Número incorrecto/fuera de servicio
				case '1505':
				//Congestion 1505 -> Error de central telefónica
				case '1506':
					//Otro 1506 -> Error de central telefónica
					props.playStopAudio(audioOther, time);
					break;
				case '1502':
					//Fax/Modem 1502 -> Máquina de fax detectada
					props.playStopAudio(audioFaxMachine, time);
					break;
				default:
					break;
			}
		};
	
		return _react2.default.createElement(
			'div',
			{ className: 'alertWindowContainer ' + (props.className || '') },
			_react2.default.createElement(
				'div',
				{ className: 'alertWindow' },
				props.phoneNumber && _react2.default.createElement(
					'p',
					{ className: 'alertNumber' },
					props.phoneNumber
				),
				_react2.default.createElement(
					'div',
					{ className: 'alertInfoContainer' },
					icon && _react2.default.createElement(
						'div',
						{ className: 'iconAlert' },
						_CallSpaceHeaderSVG.hangUp
					),
					_react2.default.createElement(
						_reactBootstrap.OverlayTrigger,
						{
							key: 'tlt-alertManualCallWindow',
							placement: 'right',
							overlay: _react2.default.createElement(
								_reactBootstrap.Tooltip,
								{ className: 'workbar-tooltip show', id: 'tooltipId-tlt-alertManualCallWindow' },
								getMessageAlert(true)
							) },
						_react2.default.createElement(
							'p',
							{ className: 'alertText' },
							getMessageAlert()
						)
					)
				),
				buttonClose && _react2.default.createElement(
					'div',
					{ className: 'closeAlert', onClick: onClickHandler },
					language.getText('CallControlGUIAssistedCallTransferaccept')
				)
			)
		);
	}
	
	exports.default = AlertManualCallWindow;

/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _HeaderSVG = __webpack_require__(490);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AnimatedPhone = function (_Component) {
	    _inherits(AnimatedPhone, _Component);
	
	    function AnimatedPhone(props) {
	        _classCallCheck(this, AnimatedPhone);
	
	        return _possibleConstructorReturn(this, (AnimatedPhone.__proto__ || Object.getPrototypeOf(AnimatedPhone)).call(this, props));
	    }
	
	    _createClass(AnimatedPhone, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'Animation_Container ' + (this.props.isPreview && 'preview') },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'Layer_6' },
	                    _react2.default.createElement('div', { className: 'Layer_9' })
	                ),
	                _react2.default.createElement('div', { className: 'Layer_4' }),
	                _react2.default.createElement('div', { className: 'Layer_5' }),
	                _react2.default.createElement(
	                    'div',
	                    { id: 'Layer_3' },
	                    _HeaderSVG.Animated_phone
	                )
	            );
	        }
	    }]);
	
	    return AnimatedPhone;
	}(_react.Component);
	
	exports.default = AnimatedPhone;

/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(25);
	
	var _AnimatedPhone = __webpack_require__(493);
	
	var _AnimatedPhone2 = _interopRequireDefault(_AnimatedPhone);
	
	var _Singleton = __webpack_require__(21);
	
	var _CallSpaceHeaderSVG = __webpack_require__(67);
	
	var _A_messages_to_SM = __webpack_require__(32);
	
	var _formats = __webpack_require__(54);
	
	var _A_reducer_call_acd = __webpack_require__(156);
	
	var _constants = __webpack_require__(10);
	
	var _Logger = __webpack_require__(37);
	
	var _singletonSharedData = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CallOutContainer = function (_Component) {
	  _inherits(CallOutContainer, _Component);
	
	  function CallOutContainer(props) {
	    _classCallCheck(this, CallOutContainer);
	
	    var _this2 = _possibleConstructorReturn(this, (CallOutContainer.__proto__ || Object.getPrototypeOf(CallOutContainer)).call(this, props));
	
	    _this2.hangUp = function () {
	      _Logger.Logger.Debug("Hanging call ===>", _constants.HANG_UP_SUBACTIONS.MANUAL_CALL);
	      _this2.props.userHangedout();
	      _this2.props.messageHangUp(_constants.HANG_UP_SUBACTIONS.MANUAL_CALL, 0, _this2.props.time ? _this2.props.time : 30);
	    };
	
	    _this2.language = new _Singleton.Singleton();
	    var _this = _this2;
	    _this2.state = {
	      time: _this.props.time
	    };
	    _this2.timeRefreshTime = 0.2;
	    _this2.canvas = null;
	    _this2.contextCanvas = null;
	    _this2.timerRate = null;
	    _this2.sharedData = new _singletonSharedData.SingletonSharedData();
	    _this2.isHidePhone = _this2.sharedData.getGeneralPermissions()[223];
	    _this2.isPreview = _this2.sharedData.getDataPreviewPro().dialingMode === 1;
	    return _this2;
	  }
	
	  _createClass(CallOutContainer, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.messagesIntegrations.dataMessageIntegration && nextProps.messagesIntegrations.dataMessageIntegration.action === _constants.INTEGRATION.HANG_UP_MANUAL_DIAL) {
	        this.hangUp();
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.canvas = this.refs["canvasTime"];
	      this.contextCanvas = this.canvas.getContext("2d");
	      this.drawArc(-Math.PI / 2.0, Math.PI * 1.5, false);
	      this.setTimer();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearInterval(this.timerRate);
	    }
	  }, {
	    key: 'drawArc',
	    value: function drawArc(startAngle, endAngle) {
	      this.contextCanvas.clearRect(0, 0, this.canvas.width, this.canvas.height);
	      this.contextCanvas.strokeStyle = "#FFFFFF";
	      var position = 36.0;
	      this.contextCanvas.fillStyle = "transparent";
	      this.contextCanvas.globalAlpha = 0.8;
	      this.contextCanvas.lineWidth = 2;
	      this.contextCanvas.beginPath();
	      this.contextCanvas.arc(position, position, 35, startAngle, endAngle, false);
	      this.contextCanvas.fill();
	      this.contextCanvas.stroke();
	    }
	  }, {
	    key: 'setTimer',
	    value: function setTimer() {
	      var _this = this;
	      this.timerRate = setInterval(time, this.timeRefreshTime * 1000);
	      function time() {
	        var newTime = _this.state.time - _this.timeRefreshTime;
	        if (newTime > 0) {
	          _this.setState({ time: newTime });
	        }
	
	        var startAngle = -Math.PI / 2.0;
	        var newAngle = startAngle + newTime / _this.props.time * (Math.PI * 2.0);
	        _this.drawArc(startAngle, newAngle, false);
	
	        if (newTime <= 0) {
	          clearInterval(_this.timerRate);
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'CallOutContainer ' + (this.isPreview && 'previewCallOutContainer') },
	        _react2.default.createElement(
	          'div',
	          { className: ' ' + (this.isPreview && 'previewContainer') },
	          _react2.default.createElement(_AnimatedPhone2.default, { isPreview: this.isPreview }),
	          _react2.default.createElement('canvas', { ref: 'canvasTime', className: 'canvasCounterManualCall ' + (this.isPreview && 'preview'), width: '72px', height: '72px' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'Data ' + (this.isPreview && 'previewData') },
	            _react2.default.createElement(
	              'p',
	              { className: 'DataClient' },
	              (0, _formats.hidePhone)(this.isHidePhone, this.props.phone)
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'Timer' },
	              (0, _formats.secondsToFormat)(this.state.time, false)
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'Calling' },
	              this.language.getText("CallControlGUICallIOStatusmanualCall")
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'buttonHangUpCallManualCall', onClick: this.hangUp },
	              ' ',
	              _CallSpaceHeaderSVG.hangUp,
	              ' '
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return CallOutContainer;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    messagesIntegrations: state.messagesIntegrations
	  };
	}
	function mapDispatchToProps(dispatch) {
	  return {
	    messageHangUp: function messageHangUp(subaction, callOutId, maxTime) {
	      dispatch((0, _A_messages_to_SM.messageHangUp)(subaction, callOutId, maxTime));
	    },
	    callAction: function callAction(actionType, parameters) {
	      dispatch((0, _A_reducer_call_acd.callAction)(actionType, parameters));
	    }
	  };
	}
	exports.default = CallOutContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CallOutContainer);

/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _globalComponentsLibrary = __webpack_require__(28);
	
	var _react = __webpack_require__(1);
	
	var StopWatch = function StopWatch(_ref) {
	  var onChange = _ref.onChange,
	      hours = _ref.hours,
	      minutes = _ref.minutes,
	      secondsInitial = _ref.secondsInitial,
	      isAscending = _ref.isAscending;
	
	  var _useStopWatchCountDow = (0, _globalComponentsLibrary.useStopWatchCountDown)(hours, minutes, secondsInitial, 1000, isAscending),
	      start = _useStopWatchCountDow.start,
	      stop = _useStopWatchCountDow.stop,
	      fullFormat = _useStopWatchCountDow.fullFormat,
	      seconds = _useStopWatchCountDow.seconds;
	
	  var _useState = (0, _react.useState)("00:00:00"),
	      _useState2 = _slicedToArray(_useState, 2),
	      complete = _useState2[0],
	      setComplete = _useState2[1];
	
	  (0, _react.useEffect)(function () {
	    start();
	    return function () {
	      stop();
	    };
	  }, []);
	
	  (0, _react.useEffect)(function () {
	    var result = fullFormat();
	    onChange(result);
	    setComplete(result);
	  }, [seconds]);
	
	  return complete;
	};
	
	exports.default = StopWatch;

/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Singleton = __webpack_require__(21);
	
	var _Images = __webpack_require__(30);
	
	var _StopWatchPreview = __webpack_require__(1080);
	
	var _StopWatchPreview2 = _interopRequireDefault(_StopWatchPreview);
	
	var _globalComponentsLibrary = __webpack_require__(28);
	
	var _constants = __webpack_require__(10);
	
	var _SelectComponent = __webpack_require__(155);
	
	var _SelectComponent2 = _interopRequireDefault(_SelectComponent);
	
	var _A_preview = __webpack_require__(52);
	
	var _reactRedux = __webpack_require__(25);
	
	var _A_messages_to_SM = __webpack_require__(32);
	
	var _ChangeTypeCampaign = __webpack_require__(323);
	
	var _ChangeTypeCampaign2 = _interopRequireDefault(_ChangeTypeCampaign);
	
	var _singletonSharedData = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var language = new _Singleton.Singleton();
	
	var CallHeaderPreview = function CallHeaderPreview(_ref) {
	  var campaignName = _ref.campaignName,
	      iconCallFrame = _ref.iconCallFrame,
	      callKey = _ref.callKey,
	      seconds = _ref.seconds,
	      phones = _ref.phones,
	      isRunning = _ref.isRunning,
	      userState = _ref.userState,
	      setPhoneToCall = _ref.setPhoneToCall;
	
	  var _useState = (0, _react.useState)(Math.floor(seconds / 3600)),
	      _useState2 = _slicedToArray(_useState, 2),
	      hours = _useState2[0],
	      setHours = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(Math.floor(seconds / 60)),
	      _useState4 = _slicedToArray(_useState3, 2),
	      minutes = _useState4[0],
	      setMinutes = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(seconds % 60),
	      _useState6 = _slicedToArray(_useState5, 2),
	      sec = _useState6[0],
	      setSec = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(false),
	      _useState8 = _slicedToArray(_useState7, 2),
	      isSetTime = _useState8[0],
	      setIsSetTime = _useState8[1];
	
	  var _useToasts = (0, _globalComponentsLibrary.useToasts)(),
	      addToast = _useToasts.addToast;
	
	  var _useState9 = (0, _react.useState)([]),
	      _useState10 = _slicedToArray(_useState9, 2),
	      numbersList = _useState10[0],
	      setNumbersList = _useState10[1];
	
	  var _useState11 = (0, _react.useState)('1'),
	      _useState12 = _slicedToArray(_useState11, 2),
	      displayedComponent = _useState12[0],
	      setDisplayedComponent = _useState12[1];
	
	  var _useState13 = (0, _react.useState)([]),
	      _useState14 = _slicedToArray(_useState13, 2),
	      objectPhones = _useState14[0],
	      setObjectPhones = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(''),
	      _useState16 = _slicedToArray(_useState15, 2),
	      timerDesign = _useState16[0],
	      setTimerDesign = _useState16[1];
	
	  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
	    return state.preview;
	  }),
	      isTimeAscending = _useSelector.isTimeAscending,
	      phoneToCall = _useSelector.phoneToCall,
	      countRecords = _useSelector.countRecords,
	      camId = _useSelector.camId,
	      callOutId = _useSelector.callOutId,
	      initPreviewTime = _useSelector.initPreviewTime;
	
	  var _useSelector2 = (0, _reactRedux.useSelector)(function (state) {
	    return state.agentPermissions;
	  }),
	      allowChangeDialing = _useSelector2.allowChangeDialing;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	  var sharedData = new _singletonSharedData.SingletonSharedData();
	
	  (0, _react.useEffect)(function () {
	    var numbers = phones.map(function (dato, i) {
	      return { id: i, img: _Images.reprogramacion1, number: dato };
	    });
	    setObjectPhones(numbers);
	    timerDesignChange();
	  }, []);
	
	  (0, _react.useEffect)(function () {
	    if (objectPhones.length > 0 && numbersList.length === 0) {
	      setNumbersList(objectPhones);
	    }
	  }, [objectPhones]);
	
	  (0, _react.useEffect)(function () {
	    setIsSetTime(false);
	    if (seconds > 0) {
	      setHours(Math.floor(seconds / 3600));
	      setMinutes(Math.floor(seconds % 3600 / 60));
	      setSec(seconds % 60);
	      setIsSetTime(true);
	    } else {
	      setIsSetTime(true);
	    }
	  }, [isRunning, seconds]);
	
	  var timeIsOver = function timeIsOver(message) {
	    addToast(message, {
	      group: 'icon',
	      position: 'topRight',
	      icon: 'warning',
	      color: 'yellow',
	      btnComponent: _react2.default.createElement(
	        _globalComponentsLibrary.AgentButton,
	        { type: 'tertiary' },
	        language.getText("GUIAlertMessageok")
	      ),
	      timeout: 5000
	    });
	  };
	
	  var onTimeOver = function onTimeOver() {
	    if (userState !== _constants.USER_STATE.WRAPUP) {
	      dispatch((0, _A_messages_to_SM.actionPreviewRecord)({ process: 2, camId: camId, callOutId: callOutId, previewTime: initPreviewTime, callId: 0 }));
	      if (countRecords < 2) timeIsOver(language.getText('GUIAlertMessagepreviewTimeExpired'));
	      setTimeout(function () {
	        dispatch((0, _A_preview.incrementDiscardedRegisters)());
	      }, 100);
	    }
	  };
	
	  var selectPhone = function selectPhone(phone) {
	    setPhoneToCall(phone.number);
	  };
	
	  var timerDesignChange = function timerDesignChange() {
	    if (userState === _constants.USER_STATE.WRAPUP) {
	      setTimerDesign('wrapUpDesign');
	    } else if (userState === _constants.USER_STATE.AGENT_PREVIEW || userState === _constants.USER_STATE.CALL_OUT) {
	      setTimerDesign('previewDesign');
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'containerHeader' },
	    _react2.default.createElement(
	      'div',
	      { className: 'dataCallContainer' },
	      _react2.default.createElement(
	        'div',
	        { className: 'campInfo' },
	        _react2.default.createElement(
	          'div',
	          { className: 'campaingAssistedIcon' },
	          _react2.default.createElement('img', { className: 'iconCallImageA', src: _Images.outBoundCall, alt: 'icon' }),
	          _react2.default.createElement('img', { className: 'iconCallImageA iconPaddingA', src: iconCallFrame > 0 ? _Images.framesCamp[iconCallFrame] : '', alt: 'iconCallImage' })
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'campName' },
	          campaignName
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'clientInfo' },
	        userState !== _constants.USER_STATE.AGENT_PREVIEW ? _react2.default.createElement(
	          'div',
	          { className: 'telContainer' },
	          _react2.default.createElement(
	            'div',
	            { className: 'chp-conteinerPhoneCallKey' },
	            _react2.default.createElement(
	              'div',
	              { className: 'chp-containerPhoneNumber outboundDesign' },
	              _react2.default.createElement('img', { className: 'iconCampACD outBoundCall', src: _Images.phoneIcon, alt: 'icon' }),
	              _react2.default.createElement(
	                'p',
	                { className: 'phoneNumber' },
	                phoneToCall
	              )
	            )
	          )
	        ) : _react2.default.createElement(
	          'div',
	          { className: 'telContainer' },
	          numbersList.length > 0 && _react2.default.createElement(_SelectComponent2.default, {
	            bottomBox: 60,
	            defaultDiv: { item: "texSelection" },
	            displayer: "bigDisplayer",
	            customCell: "cellImageText",
	            parameters: { image: "img", text: "number" },
	            dataSource: numbersList,
	            closeOthers: true,
	            itemDefault: 0,
	            displayedList: displayedComponent,
	            onSelectItem: selectPhone })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'chp-callKeyContainer' },
	          _react2.default.createElement(
	            'p',
	            { className: 'chp-textCallKey' },
	            language.getText('GUICallSpacecallkey')
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'chp-numberCallKey' },
	            callKey
	          )
	        )
	      )
	    ),
	    allowChangeDialing && sharedData.getDataPreviewPro().dialingMode && _constants.STATES_TO_SHOW_CTC.includes(userState) && _react2.default.createElement(
	      'div',
	      { className: 'changeTypeCampaign_container' },
	      _react2.default.createElement(_ChangeTypeCampaign2.default, null)
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'chp-timerContainer' },
	      _react2.default.createElement(
	        'p',
	        { className: 'timeCallBold ' + timerDesign },
	        isSetTime && _react2.default.createElement(_StopWatchPreview2.default, {
	          onTimeOver: onTimeOver,
	          hours: hours,
	          minutes: minutes,
	          secondsInitial: sec,
	          isRunning: isRunning,
	          isTimeAscending: isTimeAscending,
	          userState: userState
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'chp-recordContainer' },
	        userState !== _constants.USER_STATE.WRAPUP && _react2.default.createElement(
	          'div',
	          { className: 'headerRecording on' },
	          _react2.default.createElement(
	            'p',
	            { className: 'labelTimePreview' },
	            language.getText('GUIPreviewtimePreviewMode')
	          )
	        )
	      )
	    )
	  );
	};
	exports.default = CallHeaderPreview;

/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Singleton = __webpack_require__(21);
	
	var _TimerCountDown = __webpack_require__(326);
	
	var _TimerCountDown2 = _interopRequireDefault(_TimerCountDown);
	
	var _globalComponentsLibrary = __webpack_require__(28);
	
	var _SelectReprogramPhone = __webpack_require__(1102);
	
	var _SelectReprogramPhone2 = _interopRequireDefault(_SelectReprogramPhone);
	
	var _DatePicker = __webpack_require__(1096);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	var _singletonSharedData = __webpack_require__(23);
	
	var _cwGalateaApiJsBundle = __webpack_require__(40);
	
	var _reactRedux = __webpack_require__(25);
	
	var _A_messages_to_SM = __webpack_require__(32);
	
	var _A_preview = __webpack_require__(52);
	
	var _A_Alert_Modal = __webpack_require__(63);
	
	var _A_Alert_Modal2 = _interopRequireDefault(_A_Alert_Modal);
	
	var _constants = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var language = new _Singleton.Singleton();
	var sharedData = new _singletonSharedData.SingletonSharedData();
	var APIFact = new _cwGalateaApiJsBundle.APIFactory();
	var apiCont = APIFact.buildClient();
	var hideAlertModal = _A_Alert_Modal2.default.creators.hideAlertModal;
	
	
	var Dispositions = function Dispositions(_ref) {
	  var type = _ref.type,
	      onChangeDisp = _ref.onChangeDisp,
	      endWraUpWithoutDisp = _ref.endWraUpWithoutDisp,
	      endWraUpWithDisp = _ref.endWraUpWithDisp,
	      onChangeReprogam = _ref.onChangeReprogam,
	      _ref$rateInDialog = _ref.rateInDialog,
	      rateInDialog = _ref$rateInDialog === undefined ? false : _ref$rateInDialog;
	
	  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
	    return state.preview;
	  }),
	      records = _useSelector.records,
	      fReplacementJob = _useSelector.fReplacementJob,
	      ndScheduled = _useSelector.ndScheduled,
	      _useSelector$selected = _useSelector.selectedRecord,
	      wrapUpTime = _useSelector$selected.wrapUpTime,
	      callOutId = _useSelector$selected.callOutId,
	      camId = _useSelector$selected.camId,
	      phoneToCall = _useSelector$selected.phoneToCall,
	      initPreviewTime = _useSelector$selected.initPreviewTime,
	      status = _useSelector$selected.status;
	
	  var _useState = (0, _react.useState)({ dispositionError: null, dispositionList: null }),
	      _useState2 = _slicedToArray(_useState, 2),
	      response = _useState2[0],
	      setResponse = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(null),
	      _useState4 = _slicedToArray(_useState3, 2),
	      dispositionSelected = _useState4[0],
	      setDispositionSelected = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(null),
	      _useState6 = _slicedToArray(_useState5, 2),
	      subDisposition = _useState6[0],
	      setSubDisposition = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(false),
	      _useState8 = _slicedToArray(_useState7, 2),
	      showDisposition = _useState8[0],
	      setShowDisposition = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(false),
	      _useState10 = _slicedToArray(_useState9, 2),
	      showSubDisposition = _useState10[0],
	      setShowSubDisposition = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(false),
	      _useState12 = _slicedToArray(_useState11, 2),
	      showCanReprogram = _useState12[0],
	      setShowCanReprogram = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(true),
	      _useState14 = _slicedToArray(_useState13, 2),
	      disableBtnSave = _useState14[0],
	      setDisableBtnSave = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(false),
	      _useState16 = _slicedToArray(_useState15, 2),
	      withDisposition = _useState16[0],
	      setWithDisposition = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(""),
	      _useState18 = _slicedToArray(_useState17, 2),
	      phoneReprogram = _useState18[0],
	      setPhoneReprogram = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(""),
	      _useState20 = _slicedToArray(_useState19, 2),
	      dateReprogram = _useState20[0],
	      setDateReprogram = _useState20[1];
	
	  var _useTimerDownUp = (0, _globalComponentsLibrary.useTimerDownUp)({ secondsInitial: wrapUpTime }),
	      timeLeft = _useTimerDownUp.timeLeft,
	      startTimer = _useTimerDownUp.startTimer,
	      stopTimer = _useTimerDownUp.stopTimer;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  (0, _react.useEffect)(function () {
	    var dataSend = {
	      CallOutId: callOutId,
	      Id: camId,
	      Type: type,
	      UserId: sharedData.getParameters().UserID,
	      CamId: camId
	    };
	    getDisposition(dataSend);
	  }, []);
	
	  (0, _react.useEffect)(function () {
	    if (phoneReprogram !== "" || dateReprogram !== "") {
	      onChangeReprogam({ phoneReprogram: phoneReprogram, dateReprogram: dateReprogram });
	    }
	  }, [phoneReprogram, dateReprogram]);
	
	  (0, _react.useEffect)(function () {
	    if (dispositionSelected != null) {
	      Object.keys(dispositionSelected.SubDisposition).length > 0 ? setShowSubDisposition(true) : setShowSubDisposition(false);
	      var canReprogam = dispositionSelected.CanReprogram || subDisposition != null && subDisposition.CanReprogram;
	      setShowCanReprogram(canReprogam);
	      onChangeDisp({ dispositionSelected: dispositionSelected, canReprogram: canReprogam, subDispositionSelected: subDisposition !== null ? subDisposition.Id : 0 });
	    }
	  }, [dispositionSelected, subDisposition]);
	
	  (0, _react.useEffect)(function () {
	    if (showCanReprogram) {
	      if (phoneReprogram !== "" && dateReprogram !== "") {
	        setDisableBtnSave(false);
	      } else setDisableBtnSave(true);
	    }
	  }, [showCanReprogram, phoneReprogram, dateReprogram]);
	  (0, _react.useEffect)(function () {
	    if (status !== _constants.RECORD_STATE.WAITING_WRAPUP) {
	      startTimer();
	    }
	  }, [status]);
	
	  (0, _react.useEffect)(function () {
	    if (!rateInDialog && wrapUpTime !== 0 && status !== _constants.RECORD_STATE.WAITING_WRAPUP) {
	      if (timeLeft === 0) {
	        stopTimer();
	        !ndScheduled && dispatch((0, _A_messages_to_SM.actionPreviewRecord)({ process: 12, camId: camId, callOutId: callOutId, previewTime: initPreviewTime, callId: 0, fMultipleJob: records.length === 1 ? 0 : 1, fReplacementJob: fReplacementJob }));
	        setTimeout(function () {
	          dispatch((0, _A_preview.incrementDiscardedRegisters)());
	        }, 100);
	        setTimeout(function () {
	          dispatch((0, _A_preview.removeRecord)(callOutId));
	        }, 200);
	      } else if (timeLeft < 3) {
	        dispatch(hideAlertModal());
	      }
	    }
	  }, [timeLeft]);
	
	  var disableBtnSaveDisp = function disableBtnSaveDisp() {
	    var hasSubDisp = Object.keys(dispositionSelected.SubDisposition).length > 0;
	    if (hasSubDisp && subDisposition !== null) {
	      setDisableBtnSave(false);
	    } else if (!hasSubDisp) {
	      setDisableBtnSave(false);
	    } else setDisableBtnSave(true);
	  };
	  (0, _react.useEffect)(function () {
	    dispositionSelected !== null && disableBtnSaveDisp();
	  }, [dispositionSelected, subDisposition]);
	
	  (0, _react.useEffect)(function () {
	    if (response.dispositionList !== null) {
	      Object.keys(response.dispositionList.Dispositions).length === 0 ? setWithDisposition(false) : setWithDisposition(true), setShowDisposition(true);
	    }
	  }, [response]);
	
	  var getDisposition = function getDisposition(data) {
	    var timeout = sharedData.getRequestTimeout();
	
	    var objectResponse = apiCont.getObjectResponse();
	
	    setShowDisposition(false);
	    apiCont.dispositionList(data, objectResponse, timeout);
	    objectResponse.onError = function (messageError) {
	      setResponse({ dispositionError: messageError, dispositionList: null });
	    };
	    objectResponse.onCatch = function (messageError) {};
	    objectResponse.onSuccess = function (objResponse) {
	      setResponse({ dispositionError: null, dispositionList: objResponse });
	    };
	  };
	  var setDisposition = function setDisposition(item) {
	    setSubDisposition(null);
	    setDispositionSelected(item);
	  };
	
	  var options = function options(dispositions) {
	    return Object.values(dispositions).sort(function (a, b) {
	      return a.Description.localeCompare(b.Description);
	    }).sort(function (a, b) {
	      return a.Orden - b.Orden;
	    });
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'disp-main-container' },
	    !rateInDialog && _react2.default.createElement(_TimerCountDown2.default, {
	      showInfinite: false,
	      showingTimer: true,
	      timeToRate: status === _constants.RECORD_STATE.WAITING_WRAPUP ? 0 : wrapUpTime,
	      lineWidth: 6,
	      colorDown: "#FFB427",
	      colorUp: "#BA5D00",
	      size: 60,
	      fontsize: "one",
	      waitingWrapUp: status === _constants.RECORD_STATE.WAITING_WRAPUP }),
	    withDisposition && _react2.default.createElement(
	      'p',
	      { className: 'disp-title-RateCall' },
	      language.getText("CallControlcallCalificationtitle")
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'disp-container' },
	      withDisposition && _react2.default.createElement(
	        'div',
	        { className: 'rcsp-disposition-container' },
	        showDisposition && _react2.default.createElement(_globalComponentsLibrary.SearchSelectionAgent, { options: options(response.dispositionList.Dispositions), noDefault: true, sort: true, ignoreCase: true, placeholder: language.getText("CallControlCRMxcontrolsselectAnOption"), filterBy: 'Description', onSelected: function onSelected(item) {
	            return setDisposition(item);
	          }, disabled: status === _constants.RECORD_STATE.WAITING_WRAPUP }),
	        showSubDisposition && _react2.default.createElement(_globalComponentsLibrary.SearchSelectionAgent, { noDefault: true, sort: true, ignoreCase: true, options: options(dispositionSelected.SubDisposition), placeholder: language.getText("CallControlCRMxcontrolsselectAnOption"), filterBy: 'Description', onSelected: function onSelected(item) {
	            return setSubDisposition(item);
	          }, disabled: status === _constants.RECORD_STATE.WAITING_WRAPUP }),
	        showCanReprogram && _react2.default.createElement(
	          'div',
	          { className: 'disp-rescheduleWindow' },
	          _react2.default.createElement(_SelectReprogramPhone2.default, {
	            numbers: response.dispositionList.Numbers,
	            setPhoneReprogram: setPhoneReprogram,
	            phoneCall: phoneToCall
	          }),
	          _react2.default.createElement(_DatePicker2.default, {
	            setDateReprogram: setDateReprogram,
	            callbackDays: response.dispositionList.CallbackDays })
	        ),
	        withDisposition && _react2.default.createElement(
	          'div',
	          { className: 'disp-btn-container' },
	          ' ',
	          _react2.default.createElement(
	            _globalComponentsLibrary.AgentButton,
	            { type: 'primary', color: 'blue', disabled: disableBtnSave, onClick: endWraUpWithDisp },
	            language.getText("GUIPreviewbtnSave")
	          )
	        )
	      ),
	      !rateInDialog && !withDisposition && _react2.default.createElement(
	        'div',
	        { className: 'disp-btn-container ' + (!withDisposition ? 'withOutDisposition' : '') },
	        ' ',
	        _react2.default.createElement(
	          _globalComponentsLibrary.AgentButton,
	          { type: 'primary', color: 'yellow', disabled: disableBtnSave, onClick: endWraUpWithoutDisp },
	          language.getText("CallControlcallCalificationfinishWrapup")
	        )
	      )
	    )
	  );
	};
	exports.default = Dispositions;

/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(25);
	
	var _Images = __webpack_require__(30);
	
	var _ChatSVG = __webpack_require__(235);
	
	var _GenericSVG = __webpack_require__(51);
	
	var _A_messages_to_SM = __webpack_require__(32);
	
	var _singletonSharedData = __webpack_require__(23);
	
	var _SingletonWebSocket = __webpack_require__(50);
	
	var _SingletonWebSocket2 = _interopRequireDefault(_SingletonWebSocket);
	
	var _Singleton = __webpack_require__(21);
	
	var _customComponents = __webpack_require__(59);
	
	var _reactAutosizeTextarea = __webpack_require__(457);
	
	var _reactAutosizeTextarea2 = _interopRequireDefault(_reactAutosizeTextarea);
	
	var _A_reducer_consulting = __webpack_require__(115);
	
	var _cwGalateaApiJsBundle = __webpack_require__(40);
	
	var _constants = __webpack_require__(10);
	
	var _A_actions_Integration = __webpack_require__(329);
	
	var _Logger = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SupervisorChat = function (_Component) {
	  _inherits(SupervisorChat, _Component);
	
	  function SupervisorChat(props) {
	    _classCallCheck(this, SupervisorChat);
	
	    var _this2 = _possibleConstructorReturn(this, (SupervisorChat.__proto__ || Object.getPrototypeOf(SupervisorChat)).call(this, props));
	
	    _this2.handleKeyUp = function (event) {
	      if (event.key === 'Enter') {
	        _this2.sendChat();
	      }
	    };
	
	    _this2.timmeropenChatFromNotification = null;
	    _this2.timmerSendChatToAdmin = null;
	    _this2.timmerFocusArea = null;
	    _this2.timerScrollToBottom = null;
	    _this2.isFirstOpenSupervisor = false;
	    _this2.sharedData = new _singletonSharedData.SingletonSharedData();
	    var supervisorName = _this2.props.objProps ? _this2.props.objProps.currentSupervisor : _this2.sharedData.currentSupervisor;
	    var screenChat = _this2.props.objProps ? _this2.props.objProps.screenChat : false;
	    _this2.state = {
	      screenSelectionChat: !screenChat,
	      currentSupervisor: supervisorName,
	      windowType: _this2.props.floating ? "floating" : "expanded",
	      textToSend: "",
	      arrayChat: _this2.sharedData.getChatList(supervisorName),
	      superVisorChatList: []
	    };
	    _this2.adminWithNotification = undefined;
	    _this2.NumberAdminWithNotification = 0;
	    _this2.language = new _Singleton.Singleton();
	    var APIFact = new _cwGalateaApiJsBundle.APIFactory();
	    _this2.apiCont = APIFact.buildClient();
	    _this2.isRender = false;
	    var _this = _this2;
	    if (!_this2.props.floating) {
	      _this2.sharedData.observerSupervisor(function (supervisorList) {
	        return _this.setState({ superVisorChatList: supervisorList });
	      });
	    }
	    _this2.indexChats = 0;
	    _this2.componentVisible = false;
	    _this2.OPEN_CHAT = {
	      "expanded": function expanded(that) {
	        if (that.NumberAdminWithNotification === 1) {
	          that.selectChat(that.adminWithNotification);
	          that.sharedData.setNewNotificationChat(that.adminWithNotification.Username, true);
	        }
	      },
	      "floating": function floating(that) {
	        if (that.NumberAdminWithNotification === 1) {
	          that.sharedData.setCurrentSuperVisor(that.adminWithNotification.Username);
	          that.openChatFromNotification();
	        }
	      }
	    };
	    _this2.resize = _this2.resize.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(SupervisorChat, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.isRender = true;
	      var objectResponse = this.apiCont.getObjectResponse();
	      var _this = this;
	
	      _Logger.Logger.Trace("[ChatComponent][componentDidMount] Search List Supervisor ===>>");
	      this.apiCont.getSupervisorList(this.sharedData.getParameters().UserID, objectResponse);
	      this.props.consultingApp();
	      objectResponse.onError = function (messageError) {
	        _Logger.Logger.Warn("ERROR List Supervisor ===>>", messageError);
	        _this.props.noConsultingApp();
	        if (_this.state.windowType === "floating") {
	          var errorMessage = _this.language.getText("error-" + messageError.InternalCode);
	          var errorObject = _SingletonWebSocket2.default.getJsonError(messageError.InternalCode, errorMessage);
	          _SingletonWebSocket2.default.send(_SingletonWebSocket2.default.getJson(_constants.INTEGRATION.CHAT, _constants.INTEGRATION_SUBACTION.ERROR_SUPERVISOR_LIST_EVENT, errorObject));
	        }
	      };
	      objectResponse.onSuccess = function (objResponse) {
	        _Logger.Logger.Trace("Admins List ", objResponse.Response);
	        if (_this.state.windowType === "floating") {
	          _SingletonWebSocket2.default.send(_SingletonWebSocket2.default.getJson(_constants.INTEGRATION.CHAT, _constants.INTEGRATION_SUBACTION.CHAT_SUPERVISORS, objResponse.Response));
	        }
	        if (_this.isRender) {
	          _this.setState({ superVisorChatList: objResponse.Response });
	        }
	
	        _this.sharedData.setSupervisorList(objResponse.Response);
	        var supervisorList = _this.sharedData.getSupervisorList();
	        _this.props.noConsultingApp();
	        _this.findAdminsWithNotification(supervisorList);
	        _this.OPEN_CHAT[_this.state.windowType](_this);
	      };
	      if (this.sharedData.getWindowChatOpen()) {
	        this.openChatFromNotification();
	      }
	      window.addEventListener('resize', this.resize);
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextstate) {
	      var objProps = nextProps.objProps;
	      if (objProps && objProps.regsMultiple) {
	        return true;
	      }
	      var isVisiable = nextProps.floating && window.innerWidth < 1300 || !nextProps.floating && window.innerWidth >= 1300;
	      if (!isVisiable || nextstate.superVisorChatList.length === 0) {
	        return false;
	      }
	      return true;
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this3 = this;
	
	      var _this = this;
	
	      var supervisor = nextProps.stateMachineActions.supervisor;
	      if (supervisor && supervisor === this.state.currentSupervisor) {
	        var arrayChat = _this.sharedData.getChatList(supervisor);
	        if (arrayChat.length !== _this.state.arrayChat.length) {
	          _this.setState({ arrayChat: arrayChat });
	        }
	      }
	      if (nextProps.messagesIntegrations && nextProps.messagesIntegrations.dataMessageIntegration && nextProps.messagesIntegrations.dataMessageIntegration.action === _constants.INTEGRATION.CHAT) {
	        var adminName = nextProps.messagesIntegrations.dataMessageIntegration.data.chatId;
	        var message = nextProps.messagesIntegrations.dataMessageIntegration.data.message;
	
	        var filter = this.state.superVisorChatList.filter(function (item) {
	          return item.Username === adminName;
	        });
	
	        if (filter) {
	          var elem = filter[0];
	          this.selectChat(elem);
	          if (this.state.windowType === "expanded") {
	            this.timmerSendChatToAdmin = setTimeout(function () {
	              _this3.sendChatToAdmin(elem.Username, message);
	            }, 10);
	          }
	        }
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.scrollToBottom();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.isRender = false;
	      window.removeEventListener('resize', this.resize);
	      clearTimeout(this.timmeropenChatFromNotification);
	      clearTimeout(this.timmerSendChatToAdmin);
	      clearTimeout(this.timmerFocusArea);
	      clearTimeout(this.timerScrollToBottom);
	      this.sharedData.observerSupervisor(null);
	    }
	  }, {
	    key: 'findAdminsWithNotification',
	    value: function findAdminsWithNotification(supervisorList) {
	      this.adminWithNotification = undefined;
	      this.NumberAdminWithNotification = 0;
	
	      for (var i in supervisorList) {
	        var item = supervisorList[i];
	        var numberNotification = this.sharedData.getNotificationChat(item.Username);
	        if (numberNotification && numberNotification > 0) {
	          this.adminWithNotification = item;
	          this.NumberAdminWithNotification++;
	        }
	      }
	    }
	  }, {
	    key: 'openChatFromNotification',
	    value: function openChatFromNotification() {
	      var _this = this;
	      var supervisor = this.sharedData.getCurrentSuperVisor();
	      this.selectChat({ Username: this.sharedData.getCurrentSuperVisor() });
	      this.timmeropenChatFromNotification = setTimeout(function () {
	        _this.setState({ arrayChat: _this.sharedData.getChatList(supervisor) });
	        _this.sharedData.setWindowChatOpen(false);
	        _this.sharedData.setStateWindow(_constants.DRAGGABLE_WINDOWS.SUPERVISOR_CHAT, true);
	        _this.sharedData.setWindowExpandedActive(_constants.DRAGGABLE_WINDOWS.SUPERVISOR_CHAT);
	      }, 10);
	    }
	  }, {
	    key: 'loadStates',
	    value: function loadStates() {
	      var supervisor = this.sharedData.getCurrentSuperVisor();
	      if (supervisor) {
	        this.setState({
	          screenSelectionChat: false,
	          currentSupervisor: supervisor,
	          textToSend: this.sharedData.getTextToSend(),
	          arrayChat: this.sharedData.getChatList(supervisor)
	        });
	      } else {
	        this.setState({
	          screenSelectionChat: true,
	          currentSupervisor: "",
	          textToSend: this.sharedData.getTextToSend()
	        });
	      }
	    }
	  }, {
	    key: 'resize',
	    value: function resize() {
	      if (this.props.floating) {
	        if (window.innerWidth < 1300) {
	          if (!this.componentVisible) {
	            this.componentVisible = true;
	            this.loadStates();
	          }
	        } else {
	          this.componentVisible = false;
	        }
	      } else {
	        if (window.innerWidth > 1300) {
	          if (!this.componentVisible) {
	            this.componentVisible = true;
	            this.loadStates();
	          }
	        } else {
	          this.componentVisible = false;
	        }
	      }
	    }
	  }, {
	    key: 'selectChat',
	    value: function selectChat(supervisor) {
	      var _this = this;
	      this.sharedData.setCurrentSuperVisor(supervisor.Username);
	      this.setState({
	        screenSelectionChat: false,
	        currentSupervisor: supervisor.Username,
	        arrayChat: this.sharedData.getChatList(supervisor.Username)
	      });
	
	      this.timmerFocusArea = setTimeout(function () {
	        _this.textarea.focus();
	      }, 200);
	    }
	  }, {
	    key: 'sendChatToAdmin',
	    value: function sendChatToAdmin(adminName, message) {
	      var currentTime = new Date().toLocaleTimeString();
	      var messageToList = { type: 2, text: message, user: this.sharedData.getUserData().Login, hour: currentTime };
	      this.sharedData.setObjectChat(messageToList, adminName);
	      this.props.messageToSupervisor(message, adminName);
	      var supervisor = this.sharedData.getCurrentSuperVisor();
	      this.setState({ arrayChat: this.sharedData.getChatList(supervisor) });
	    }
	  }, {
	    key: 'sendChat',
	    value: function sendChat() {
	      if (this.textarea.value !== "" && this.textarea.value !== "\n") {
	        this.sendChatToAdmin(this.state.currentSupervisor, this.textarea.value);
	      }
	      this.textarea.value = "";
	    }
	  }, {
	    key: 'backToSelect',
	    value: function backToSelect() {
	      this.setState({ screenSelectionChat: true });
	      this.sharedData.setNewNotificationChat(this.state.currentSupervisor, true);
	      this.sharedData.setCurrentSuperVisor("");
	    }
	  }, {
	    key: 'scrollToBottom',
	    value: function scrollToBottom() {
	      if (this.refs["ChatArea"]) {
	        var _this = this;
	        this.timerScrollToBottom = setTimeout(function () {
	          _this.refs["ChatArea"].scrollTop = _this.refs["ChatArea"].scrollHeight * 1000.0;
	        }, 10);
	      }
	    }
	  }, {
	    key: 'saveText',
	    value: function saveText(eventText) {
	      this.sharedData.setTextToSend(eventText);
	    }
	  }, {
	    key: 'GetListChat',
	    value: function GetListChat() {
	      var _this4 = this;
	
	      var listSupervisor = this.state.superVisorChatList.map(function (item) {
	        return _react2.default.createElement(
	          'div',
	          { className: "supervisorChatItem " + _this4.state.windowType, key: item.Username,
	            onClick: function onClick() {
	              _this4.selectChat(item);
	              _this4.sharedData.setNewNotificationChat(item.Username, true);
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: "iconSVGSuperVisor " + _this4.state.windowType },
	            _ChatSVG.supervisorChatSVG
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: "supervisorNameChat " + _this4.state.windowType },
	            item.Username
	          ),
	          _this4.sharedData.getNotificationChat(item.Username) > 0 && _react2.default.createElement(
	            'p',
	            { className: "notificationChatNumber " + (_this4.sharedData.getNotificationChat(item.Username) < 10 ? "circle" : _this4.sharedData.getNotificationChat(item.Username) < 100 ? "ovale" : "bigOvale") },
	            _this4.sharedData.getNotificationChat(item.Username)
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: "flechaChat " + _this4.state.windowType },
	            _GenericSVG.arrowBack
	          )
	        );
	      });
	
	      return listSupervisor;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: "chatComponent " + this.state.windowType },
	        _react2.default.createElement(
	          'div',
	          { className: "supervisorList " + (this.state.screenSelectionChat ? "showed" : "hidden") },
	          !this.props.floating && _customComponents.CUSTOM_COMPONENTS["sideBarHeader"](_ChatSVG.supervisorChatSimpleSVG, this.language.getText("GUIChatwindowTitle")),
	          this.GetListChat()
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: "chatScreen " + (this.state.screenSelectionChat ? "hidden" : "showed") },
	          _react2.default.createElement(
	            'div',
	            { className: "chatScreenHeader " + this.state.windowType },
	            _react2.default.createElement(
	              'div',
	              { className: "backArrow " + this.state.windowType, onClick: function onClick() {
	                  return _this5.backToSelect();
	                } },
	              ' ',
	              _GenericSVG.arrowBack,
	              ' '
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: "supervisorName " + this.state.windowType },
	              this.state.currentSupervisor
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: "supervisorChatImg " + this.state.windowType },
	              _ChatSVG.supervisorChatSimpleSVG
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: "chatSpace " + this.state.windowType },
	            _react2.default.createElement(
	              'div',
	              { className: 'chatText', ref: 'ChatArea' },
	              this.state.arrayChat.map(function (item) {
	                return _react2.default.createElement(
	                  'div',
	                  { className: "chatGlobeContainer " + (item.type === 2 ? "agent" : "supervisor"), key: _this5.indexChats++ },
	                  _react2.default.createElement('img', { src: item.type === 2 ? _Images.agentChat : _Images.supervisorChat, className: "iconGlobeChat " + (item.type === 2 ? "agent" : "supervisor"), alt: 'icon' }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: "chatGlobe " + (item.type === 2 ? "agent" : "supervisor") },
	                    _react2.default.createElement(
	                      'p',
	                      { className: "chatGlobeText " + (item.type === 2 ? "agent" : "supervisor") },
	                      item.text
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      { className: "chatGlobeHour " + (item.type === 2 ? "agent" : "supervisor") },
	                      item.hour.slice(0, -3)
	                    )
	                  )
	                );
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'writeArea' },
	              _react2.default.createElement(
	                'div',
	                { className: 'writeContainer' },
	                _react2.default.createElement(_reactAutosizeTextarea2.default, {
	                  id: 'txtMessageChatAdmin',
	                  innerRef: function innerRef(ref) {
	                    return _this5.textarea = ref;
	                  },
	                  className: "textChat " + (this.state.textToSend ? "" : "noText"),
	                  maxLength: 250,
	                  placeholder: this.language.getText("GUIChattoolTipWrite"),
	                  onChange: function onChange(event) {
	                    return _this5.saveText(event.target.value);
	                  },
	                  onKeyUp: function onKeyUp(event) {
	                    return _this5.handleKeyUp(event);
	                  }
	                }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'sendButtonChat', onClick: function onClick() {
	                      return _this5.sendChat();
	                    } },
	                  _GenericSVG.send
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return SupervisorChat;
	}(_react.Component);
	
	function mapDispatchToProps(dispatch) {
	  return {
	    messageToSupervisor: function messageToSupervisor(message, supervisor) {
	      dispatch((0, _A_messages_to_SM.messageToSupervisor)(message, supervisor));
	    },
	    consultingApp: function consultingApp() {
	      dispatch((0, _A_reducer_consulting.consultingApp)());
	    },
	    noConsultingApp: function noConsultingApp() {
	      dispatch((0, _A_reducer_consulting.noConsultingApp)());
	    },
	    changeIsIntegration: function changeIsIntegration() {
	      dispatch((0, _A_actions_Integration.changeIsIntegration)());
	    }
	  };
	}
	function mapStateToProps(state) {
	  return {
	    stateMachineActions: state.stateMachineActions,
	    messagesIntegrations: state.messagesIntegrations
	  };
	}
	exports.default = SupervisorChat = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SupervisorChat);

/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(25);
	
	var _A_messages_to_SM = __webpack_require__(32);
	
	var _A_workBar_selected = __webpack_require__(195);
	
	var _A_draggable_windows_controller = __webpack_require__(55);
	
	var _NoAvailableRecordSingleton = __webpack_require__(327);
	
	var _constants = __webpack_require__(10);
	
	var _NoAvailableSVG = __webpack_require__(114);
	
	var _GenericSVG = __webpack_require__(51);
	
	var _cwGalateaApiJsBundle = __webpack_require__(40);
	
	var _singletonSharedData = __webpack_require__(23);
	
	var _Singleton = __webpack_require__(21);
	
	var _alertQueryErrorBody = __webpack_require__(130);
	
	var _A_reducer_consulting = __webpack_require__(115);
	
	var _A_Alert_Modal = __webpack_require__(63);
	
	var _A_Alert_Modal2 = _interopRequireDefault(_A_Alert_Modal);
	
	var _formats = __webpack_require__(54);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NoAvailableComponent = function (_Component) {
	  _inherits(NoAvailableComponent, _Component);
	
	  function NoAvailableComponent(props) {
	    _classCallCheck(this, NoAvailableComponent);
	
	    var _this2 = _possibleConstructorReturn(this, (NoAvailableComponent.__proto__ || Object.getPrototypeOf(NoAvailableComponent)).call(this, props));
	
	    _this2.state = { noAvailableList: [], noAvailableRecord: [] };
	    _this2._isMounted = false;
	    _this2.language = new _Singleton.Singleton();
	    var APIFact = new _cwGalateaApiJsBundle.APIFactory();
	    _this2.apiCont = APIFact.buildClient();
	    _this2.sharedData = new _singletonSharedData.SingletonSharedData();
	    _this2.restricted = 0;
	    return _this2;
	  }
	
	  _createClass(NoAvailableComponent, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      this._isMounted = true;
	      if (this.props.floating) {
	        (0, _NoAvailableRecordSingleton.setNoAvailableList)(null);
	        (0, _NoAvailableRecordSingleton.observerNoAvailableList)(null);
	        (0, _NoAvailableRecordSingleton.setNoAvailableRecord)(null);
	        (0, _NoAvailableRecordSingleton.observerRecordNAhistory)(null);
	      }
	      var userId = this.sharedData.getParameters().UserID;
	      var _this = this;
	      var timeOut = this.sharedData.getRequestTimeout();
	      if (!this.props.floating) {
	        this.props.consultingApp();
	        var objectResponse = this.apiCont.getObjectResponse();
	        this.apiCont.getListNoAvailable(userId, objectResponse, timeOut);
	        objectResponse.onError = function (messageError) {
	          console.warn(messageError);
	          _this.props.noConsultingApp();
	        };
	        objectResponse.onCatch = function (messageError) {
	          console.warn(messageError);
	          _this.props.noConsultingApp();
	          _this.props.showAlertModal((0, _alertQueryErrorBody.alertQueryErrorBody)());
	        };
	        objectResponse.onSuccess = function (objResponse) {
	          _this.props.noConsultingApp();
	          if (objResponse.Response) {
	            (0, _NoAvailableRecordSingleton.setNoAvailableList)(objResponse.Response);
	            if (_this._isMounted) {
	              _this.setState({ noAvailableList: (0, _NoAvailableRecordSingleton.getNoAvailableList)() });
	            }
	          }
	        };
	      } else {
	        (0, _NoAvailableRecordSingleton.observerNoAvailableList)(function () {
	          _this3.setState({ noAvailableList: (0, _NoAvailableRecordSingleton.getNoAvailableList)() });
	        });
	      }
	      if (!(0, _NoAvailableRecordSingleton.getNoAvailableRecord)()) {
	        var _objectResponse = this.apiCont.getObjectResponse();
	        this.apiCont.getNotReadyHistory(userId, _objectResponse, timeOut);
	        this.props.consultingApp();
	        _objectResponse.onError = function (messageError) {
	          console.warn(messageError);
	          _this.props.noConsultingApp();
	        };
	        _objectResponse.onCatch = function (messageError) {
	          _this.props.showAlertModal((0, _alertQueryErrorBody.alertQueryErrorBody)());
	          console.warn(messageError);
	          _this.props.noConsultingApp();
	        };
	        _objectResponse.onSuccess = function (objResponse) {
	          (0, _NoAvailableRecordSingleton.setNoAvailableRecord)(objResponse.Response);
	          if (_this._isMounted) {
	            _this.setState({ noAvailableRecord: (0, _NoAvailableRecordSingleton.getNoAvailableRecord)() });
	          }
	          _this.props.noConsultingApp();
	        };
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._isMounted = false;
	      clearTimeout(this.timerMessageNoAvailable);
	      if (this.props.floating) {
	        (0, _NoAvailableRecordSingleton.setNoAvailableList)(null);
	        (0, _NoAvailableRecordSingleton.observerNoAvailableList)(null);
	        (0, _NoAvailableRecordSingleton.setNoAvailableRecord)(null);
	        (0, _NoAvailableRecordSingleton.observerRecordNAhistory)(null);
	      }
	    }
	  }, {
	    key: 'noAvailableSelection',
	    value: function noAvailableSelection(notReadyId) {
	      var _this4 = this;
	
	      var conversationID = null;
	      if (this.props.userState.currentState === _constants.USER_STATE.DIALOG_WHATSAPP && this.props.unifiedInboxState.selectedID !== null) {
	        conversationID = this.props.unifiedInboxState.selectedID;
	      }
	      var isPreview = this.sharedData.getDataPreviewPro().dialingMode === 1;
	      var timeInPreview = isPreview ? this.getPreviewTime() : 0;
	      this.props.sendMessageNoAvailable(this.sharedData.getUserData().Login, this.sharedData.getParameters().UserID, notReadyId, conversationID, timeInPreview);
	      this.timerMessageNoAvailable = setTimeout(function () {
	        _this4.closeNoAvailable();
	      }, 20);
	    }
	  }, {
	    key: 'getPreviewTime',
	    value: function getPreviewTime() {
	      var time = (0, _formats.getCurrentTimeInSec)();
	      var previewTime = time - this.props.preview.initialTimeSec + this.props.preview.totalPreviewTime;
	      return previewTime;
	    }
	  }, {
	    key: 'closeNoAvailable',
	    value: function closeNoAvailable() {
	      this.props.removeWorkAction(_constants.WORKBAR_ACTIONS.NO_AVAILABLE);
	      this.props.removeWindow(_constants.DRAGGABLE_WINDOWS.NO_AVAILABLE);
	    }
	  }, {
	    key: 'totalSelectionItem',
	    value: function totalSelectionItem(idItem) {
	      var items = [];
	      if (this.state.noAvailableRecord) {
	        items = this.state.noAvailableRecord.filter(function (item) {
	          return item.TypeNotReadyId === idItem;
	        });
	      }
	      if (items.length === 0) {
	        return 0;
	      }
	      return items[0].Count;
	    }
	  }, {
	    key: 'totalTimeItem',
	    value: function totalTimeItem(idItem) {
	      var items = this.state.noAvailableRecord.filter(function (item) {
	        return item.TypeNotReadyId === idItem;
	      });
	      if (items.length === 0) {
	        return "00:00:00";
	      }
	      return items[0].Time;
	    }
	  }, {
	    key: 'infoTimesNA',
	    value: function infoTimesNA(item, ITEM) {
	      var time = item.Max.split(':').reduce(function (acc, time) {
	        return 60 * acc + +time;
	      });
	      if (item.NumberOfEvents !== "n" && time > 0) {
	        //TIENE TIEMPO MAXIMO Y NUMERO DE EVENTOS
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'iconInfoNA ' + (this.props.preview.simultaneosRecs ? 'simultaneosRecs' : '') },
	            _GenericSVG.clockIcon
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'textInfoNA ' + (this.props.preview.simultaneosRecs ? 'simultaneosRecs' : '') },
	            item.Max
	          ),
	          !ITEM.length && _react2.default.createElement(
	            'p',
	            { className: 'textInfoNA right ' + (this.props.preview.simultaneosRecs ? 'simultaneosRecs' : '') },
	            this.totalSelectionItem(item.TypeNotReadyId) + "/" + item.NumberOfEvents
	          ),
	          ITEM.length === 1 && _react2.default.createElement(
	            'p',
	            { className: 'textInfoNA right ' + (this.props.preview.simultaneosRecs ? 'simultaneosRecs' : '') },
	            ITEM[0].Count + "/" + ITEM[0].Total
	          )
	        );
	      }
	      if (item.NumberOfEvents === "n" && time > 0) {
	        //NUMERO DE EVENTOS ILIMITADOS CON TIEMPO MAXIMO
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'iconInfoNA ' + (this.props.preview.simultaneosRecs ? 'simultaneosRecs' : '') },
	            _NoAvailableSVG.clock2
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'textInfoNA ' + (this.props.preview.simultaneosRecs ? 'simultaneosRecs' : '') },
	            this.totalTimeItem(item.TypeNotReadyId)
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'textInfoNA right ' + (this.props.preview.simultaneosRecs ? 'simultaneosRecs' : '') },
	            item.Max
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'iconInfoNA right' },
	            _GenericSVG.clockIcon
	          )
	        );
	      }
	      if (item.NumberOfEvents !== "n" && time === 0) {
	        //NUMERO DE EVENTOS ILIMITADOS CON TIEMPO MAXIMO
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'p',
	            { className: 'textInfoNA right ' + (this.props.preview.simultaneosRecs ? 'simultaneosRecs' : '') },
	            this.totalSelectionItem(item.TypeNotReadyId) + "/" + item.NumberOfEvents
	          )
	        );
	      }
	      if (item.NumberOfEvents === "n" && time === 0) {
	        //NUMERO DE EVENTOS ILIMITADOS CON TIEMPO ILIMITADO
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'iconInfoNA ' + (this.props.preview.simultaneosRecs ? 'simultaneosRecs' : '') },
	            _NoAvailableSVG.clock2
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'textInfoNA ' + (this.props.preview.simultaneosRecs ? 'simultaneosRecs' : '') },
	            this.totalTimeItem(item.TypeNotReadyId)
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'textInfoNA right ' + (this.props.preview.simultaneosRecs ? 'simultaneosRecs' : '') },
	            _GenericSVG.infinito
	          )
	        );
	      }
	    }
	  }, {
	    key: 'percentFullBar',
	    value: function percentFullBar(item, ITEM) {
	      var time = item.Max.split(':').reduce(function (acc, time) {
	        return 60 * acc + +time;
	      });
	      if (ITEM.length) {
	        var hoursInSeconds = parseInt(ITEM[0].Time.substring(0, 2) * 3600, 10);
	        var minutesInSeconds = parseInt(ITEM[0].Time.substring(3, 5) * 60, 10);
	        var seconds = parseInt(ITEM[0].Time.substring(6, 8), 10);
	        var time2 = hoursInSeconds + minutesInSeconds + seconds;
	        if (ITEM[0].Total !== "n") {
	          //TIENE NUMERO DE EVENTOS
	          var p1 = ITEM[0].Count * 100 / ITEM[0].Total;
	          var p2 = time2 * 100 / time;
	          p2 = p2 > 100 ? 100 : p2;
	          return p1 > p2 ? p1 : p2;
	        }
	        if (time > 0) {
	          //TIENE TIEMPO MAXIMO
	          var _p = time2 * 100 / time;
	          _p = _p > 100 ? 100 : _p;
	          return _p;
	        }
	      }
	      return 0;
	    }
	  }, {
	    key: 'renderNA2',
	    value: function renderNA2(item, i) {
	      var _this5 = this;
	
	      var ITEM = [];
	      if (this.state.noAvailableRecord !== null) {
	        ITEM = this.state.noAvailableRecord.filter(function (noAvailable) {
	          return noAvailable.Description === item.Description;
	        });
	      }
	      var percent = this.percentFullBar(item, ITEM);
	      return _react2.default.createElement(
	        'div',
	        { className: 'NoAvailableItem ' + (percent >= 100 ? "full" : "") + ' ' + (this.props.preview.simultaneosRecs ? 'simultaneosRecs' : ''),
	          key: "item" + i,
	          onClick: function onClick() {
	            return !_this5.restricted && _this5.noAvailableSelection(item.TypeNotReadyId);
	          } },
	        _react2.default.createElement(
	          'div',
	          { className: 'IconSVGNoAvailable  ' + (this.props.preview.simultaneosRecs ? 'simultaneosRecs' : '') },
	          this.sharedData.getIconNoAvailable(item.Frame)
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'containerInfoNA  ' + (this.props.preview.simultaneosRecs ? 'simultaneosRecs' : '') },
	          _react2.default.createElement(
	            'p',
	            { className: 'NoAvailableTxtItem  ' + (this.props.preview.simultaneosRecs ? 'simultaneosRecs' : '') },
	            item.Description
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'completeBar ' + (item.NumberOfEvents === "n" && item.Max === "00:00:00" ? "infinite" : "") + '  ' + (this.props.preview.simultaneosRecs ? 'simultaneosRecs' : '') },
	            _react2.default.createElement('div', { className: "percentageBar " + (percent >= 100 ? "full" : ""), style: { width: percent + "%" } })
	          ),
	          this.infoTimesNA(item, ITEM)
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      var unavailablesList = this.state.noAvailableList;
	      if (unavailablesList != null && unavailablesList.length) {
	        this.restricted = unavailablesList[0].NotReadyRestricted;
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'noAvailableScrollContainer01 ' + (this.props.preview.simultaneosRecs ? 'simultaneosRecs' : '') },
	        _react2.default.createElement(
	          'div',
	          { className: 'noAvailableScrollContainer ' + (this.restricted ? "blur" : "") + ' ' + (this.props.preview.simultaneosRecs ? 'simultaneosRecs' : '') + ' ' },
	          this.state.noAvailableList.map(function (item, i) {
	            return _this6.renderNA2(item, i);
	          })
	        ),
	        this.restricted ? _react2.default.createElement(
	          'div',
	          { className: 'NoAvailableRestricted' },
	          _react2.default.createElement(
	            'p',
	            { className: 'NoAvailableRestrictedMessage' },
	            this.language.getText("alert-1509")
	          )
	        ) : ""
	      );
	    }
	  }]);
	
	  return NoAvailableComponent;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    userState: state.userState,
	    unifiedInboxState: state.unifiedInboxState,
	    preview: state.preview
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  var _showAlertModal = _A_Alert_Modal2.default.creators.showAlertModal;
	
	  return {
	    sendMessageNoAvailable: function sendMessageNoAvailable(userName, userID, notReadyID, conversationID, timeInPreview) {
	      dispatch((0, _A_messages_to_SM.sendMessageNoAvailable)(userName, userID, notReadyID, conversationID, timeInPreview));
	    },
	    removeWindow: function removeWindow(iDdragComponent) {
	      dispatch((0, _A_draggable_windows_controller.removeWindow)(iDdragComponent));
	    },
	    removeWorkAction: function removeWorkAction(idRemove) {
	      dispatch((0, _A_workBar_selected.removeWorkAction)(idRemove));
	    },
	    consultingApp: function consultingApp() {
	      dispatch((0, _A_reducer_consulting.consultingApp)());
	    },
	    noConsultingApp: function noConsultingApp() {
	      dispatch((0, _A_reducer_consulting.noConsultingApp)());
	    },
	    showAlertModal: function showAlertModal(payload) {
	      dispatch(_showAlertModal(payload));
	    }
	  };
	}
	
	exports.default = NoAvailableComponent = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(NoAvailableComponent);

/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSimplePieChart = __webpack_require__(2321);
	
	var _reactSimplePieChart2 = _interopRequireDefault(_reactSimplePieChart);
	
	var _GenericSVG = __webpack_require__(51);
	
	var _reactRedux = __webpack_require__(25);
	
	var _ConvertHourToInt = __webpack_require__(1156);
	
	var _Singleton = __webpack_require__(21);
	
	var _singletonSharedData = __webpack_require__(23);
	
	var _cwGalateaApiJsBundle = __webpack_require__(40);
	
	var _NoAvailableRecordSingleton = __webpack_require__(327);
	
	var _A_reducer_consulting = __webpack_require__(115);
	
	var _A_Alert_Modal = __webpack_require__(63);
	
	var _A_Alert_Modal2 = _interopRequireDefault(_A_Alert_Modal);
	
	var _alertQueryErrorBody = __webpack_require__(130);
	
	var _A_draggable_windows_controller = __webpack_require__(55);
	
	var _constants = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NoAvailableRecordComponent = function (_Component) {
	  _inherits(NoAvailableRecordComponent, _Component);
	
	  function NoAvailableRecordComponent(props) {
	    _classCallCheck(this, NoAvailableRecordComponent);
	
	    var _this2 = _possibleConstructorReturn(this, (NoAvailableRecordComponent.__proto__ || Object.getPrototypeOf(NoAvailableRecordComponent)).call(this, props));
	
	    _this2.state = {
	      noAvailableList: [],
	      itemExpanded: -1
	    };
	    _this2.convertHourToInt = new _ConvertHourToInt.ConvertHourToInt();
	    _this2.language = new _Singleton.Singleton();
	    var APIFact = new _cwGalateaApiJsBundle.APIFactory();
	    _this2.apiCont = APIFact.buildClient();
	    _this2.sharedData = new _singletonSharedData.SingletonSharedData();
	    return _this2;
	  }
	
	  _createClass(NoAvailableRecordComponent, [{
	    key: 'UNSAFE_componentWillMount',
	    value: function UNSAFE_componentWillMount() {
	      var _this3 = this;
	
	      if (!this.props.floating) {
	
	        this.props.consultingApp();
	        var userId = this.sharedData.getParameters().UserID;
	        var objectResponse = this.apiCont.getObjectResponse();
	        this.apiCont.getNotReadyHistory(userId, objectResponse, this.sharedData.requestTimeout);
	
	        var _this = this;
	        objectResponse.onError = function (messageError) {
	          _this.props.noConsultingApp();
	        };
	        objectResponse.onSuccess = function (objResponse) {
	          _this.props.noConsultingApp();
	          (0, _NoAvailableRecordSingleton.setNoAvailableRecord)(objResponse.Response);
	          _this.setState({ noAvailableList: (0, _NoAvailableRecordSingleton.getNoAvailableRecord)() });
	          _this.props.noConsultingApp();
	        };
	        objectResponse.onCatch = function (messageError) {
	          _this.props.removeWindow(_constants.DRAGGABLE_WINDOWS.NO_AVAILABLE_RECORD);
	          _this.props.noConsultingApp();
	          _this.props.showAlertModal((0, _alertQueryErrorBody.alertQueryErrorBody)());
	        };
	      } else {
	        (0, _NoAvailableRecordSingleton.observerRecordNAhistory)(function () {
	          return _this3.setState({ noAvailableList: (0, _NoAvailableRecordSingleton.getNoAvailableRecord)() });
	        });
	      }
	    }
	  }, {
	    key: 'renderGrafica',
	    value: function renderGrafica(noAvailable) {
	      var tiempoMax = noAvailable.Max.split(":");
	      var tiempo = noAvailable.Time.split(":");
	      var porcentajeTiempoMax = this.convertHourToInt.Parse(tiempoMax);
	      var porcentajeTiempo = this.convertHourToInt.Parse(tiempo);
	      var porcentajeEventos = noAvailable.Count / noAvailable.Total * 100;
	
	      var porcentaje = parseInt(porcentajeTiempo, 10) * 100 / parseInt(porcentajeTiempoMax, 10);
	      porcentaje = porcentaje.toFixed(1);
	
	      if (noAvailable.Total > 0) {
	        porcentaje = parseInt(porcentaje > porcentajeEventos ? porcentaje : porcentajeEventos, 10);
	      }
	
	      var porcentajeGrafica = parseInt(porcentaje, 10);
	      if (porcentajeGrafica > 100) {
	        porcentajeGrafica = 100;
	      }
	
	      if (porcentajeTiempoMax > 0) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'expandedGralInfoTimesNA' },
	          _react2.default.createElement(
	            'div',
	            { className: 'graphContainer' },
	            _react2.default.createElement(_reactSimplePieChart2.default, { slices: [{ color: '#FF0000', value: porcentajeGrafica }, { color: '#00B0FF', value: 100 - porcentajeGrafica }] }),
	            _react2.default.createElement(
	              'div',
	              { className: 'circlePie ' + (porcentaje > 100 ? "red" : "") + ' ' + (this.props.simultaneosRecs ? 'simultaneosRecs' : '') },
	              porcentaje + "%"
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'expandedBarTimes' },
	            _react2.default.createElement(
	              'p',
	              { className: 'recordExpandedTxtItemNA ' + (this.props.simultaneosRecs ? 'simultaneosRecs' : '') },
	              this.language.getText('GUIDisableHistorytimeUsed') + ":"
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'recordExpandedTxtItemTimeNA' },
	              noAvailable.Time
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'recordExpandedTxtItemNA ' + (this.props.simultaneosRecs ? 'simultaneosRecs' : '') },
	              this.language.getText('GUIDisableHistorytimeLimit') + ":"
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'recordExpandedTxtItemMaxNA ' + (this.props.simultaneosRecs ? 'simultaneosRecs' : '') },
	              noAvailable.Max
	            )
	          )
	        );
	      } else {
	        return _react2.default.createElement(
	          'div',
	          { className: 'expandedGralInfoTimesNA timer' },
	          _react2.default.createElement(
	            'div',
	            { className: 'onlyTimesExpanded' },
	            _react2.default.createElement(
	              'p',
	              { className: 'recordExpandedTxtItemNA ' + (this.props.simultaneosRecs ? 'simultaneosRecs' : '') },
	              this.language.getText('GUIDisableHistorytimeUsed') + ":"
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'recordExpandedTxtItemTimeNA' },
	              noAvailable.Time
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'NoAvailableRecordContainer ' + (this.props.simultaneosRecs ? 'simultaneosRecs' : '') },
	        !this.state.noAvailableList.length ? _react2.default.createElement(
	          'div',
	          { className: 'NoAvailableRecordRestricted' },
	          _react2.default.createElement(
	            'p',
	            { className: 'NoAvailableRestrictedMessage' },
	            this.language.getText("alert-1510")
	          )
	        ) : _react2.default.createElement(
	          'div',
	          { className: 'containerWorkBar' },
	          this.state.noAvailableList.map(function (item) {
	            return _react2.default.createElement(
	              'div',
	              { className: 'expandedItemNA', key: item.TypeNotReadyId },
	              _react2.default.createElement(
	                'div',
	                { className: 'expandedGralInfoNA' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'expandedIconCountNA' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'iconItemNA' },
	                    _this4.sharedData.getIconNoAvailable(item.Frame)
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'expandedQuantityNA ' + (_this4.props.simultaneosRecs ? 'simultaneosRecs' : '') },
	                    item.Count,
	                    '/',
	                    item.Total
	                  )
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { className: 'expandedRecordTitleNA ' + (_this4.props.simultaneosRecs ? 'simultaneosRecs' : '') },
	                  item.Description
	                ),
	                _this4.renderGrafica(item),
	                _react2.default.createElement(
	                  'div',
	                  { className: "arrowExpandNA", onClick: function onClick() {
	                      return _this4.setState({ itemExpanded: item.TypeNotReadyId === _this4.state.itemExpanded ? -1 : item.TypeNotReadyId });
	                    } },
	                  _GenericSVG.arrowNDlogSVG
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: "expandedTableNA " + (_this4.state.itemExpanded === -1 ? "" : _this4.state.itemExpanded === item.TypeNotReadyId ? "expandedTableShow" : _this4.state.itemExpanded === item.TypeNotReadyId ? "expandedTableHidden" : "") },
	                _react2.default.createElement(
	                  'table',
	                  { className: 'timesTableExpandedBar' },
	                  _react2.default.createElement(
	                    'tbody',
	                    null,
	                    _react2.default.createElement(
	                      'tr',
	                      null,
	                      _react2.default.createElement(
	                        'td',
	                        { className: 'headersTableNA ' + (_this4.props.simultaneosRecs ? 'simultaneosRecs' : '') },
	                        _this4.language.getText("GUIDisableHistoryevent") + ":"
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        { className: 'headersTableNA ' + (_this4.props.simultaneosRecs ? 'simultaneosRecs' : '') },
	                        _this4.language.getText("GUIDisableHistoryselectedAt") + ":"
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        { className: 'headersTableNA ' + (_this4.props.simultaneosRecs ? 'simultaneosRecs' : '') },
	                        _this4.language.getText("GUIDisableHistoryduration") + ":"
	                      )
	                    ),
	                    item.Detail.map(function (item, i) {
	                      return _react2.default.createElement(
	                        'tr',
	                        { key: "item" + i },
	                        _react2.default.createElement(
	                          'td',
	                          null,
	                          ('0' + (i + 1)).slice(-2)
	                        ),
	                        _react2.default.createElement(
	                          'td',
	                          null,
	                          item.Hour
	                        ),
	                        _react2.default.createElement(
	                          'td',
	                          null,
	                          item.Time
	                        )
	                      );
	                    })
	                  )
	                )
	              )
	            );
	          })
	        )
	      );
	    }
	  }]);
	
	  return NoAvailableRecordComponent;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    simultaneosRecs: state.preview.simultaneosRecs
	  };
	}
	function mapDispatchToProps(dispatch) {
	  var _showAlertModal = _A_Alert_Modal2.default.creators.showAlertModal;
	
	  return {
	    consultingApp: function consultingApp() {
	      dispatch((0, _A_reducer_consulting.consultingApp)());
	    },
	    noConsultingApp: function noConsultingApp() {
	      dispatch((0, _A_reducer_consulting.noConsultingApp)());
	    },
	    showAlertModal: function showAlertModal(payload) {
	      dispatch(_showAlertModal(payload));
	    },
	    removeWindow: function removeWindow(iDdragComponent) {
	      dispatch((0, _A_draggable_windows_controller.removeWindow)(iDdragComponent));
	    }
	  };
	}
	exports.default = NoAvailableRecordComponent = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(NoAvailableRecordComponent);

/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDatepicker = __webpack_require__(2265);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _SelectComponent = __webpack_require__(155);
	
	var _SelectComponent2 = _interopRequireDefault(_SelectComponent);
	
	var _TableComponent = __webpack_require__(238);
	
	var _TableComponent2 = _interopRequireDefault(_TableComponent);
	
	var _Images = __webpack_require__(30);
	
	var _Singleton = __webpack_require__(21);
	
	var _singletonSharedData = __webpack_require__(23);
	
	var _cwGalateaApiJsBundle = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DateTimeSelection = function (_Component) {
	  _inherits(DateTimeSelection, _Component);
	
	  function DateTimeSelection(props) {
	    _classCallCheck(this, DateTimeSelection);
	
	    var _this2 = _possibleConstructorReturn(this, (DateTimeSelection.__proto__ || Object.getPrototypeOf(DateTimeSelection)).call(this, props));
	
	    _this2.language = new _Singleton.Singleton();
	    _this2.sharedData = new _singletonSharedData.SingletonSharedData();
	    _this2.callbackList = ["00:00 am", "01:00 am", "02:00 am", "03:00 am", "04:00 am", "05:00 am", "06:00 am", "07:00 am", "08:00 am", "09:00 am", "10:00 am", "11:00 am", "12:00 pm", "01:00 pm", "02:00 pm", "03:00 pm", "04:00 pm", "05:00 pm", "06:00 pm", "07:00 pm", "08:00 pm", "09:00 pm", "10:00 pm", "11:00 pm"];
	    var objCont = {};
	    for (var i in _this2.callbackList) {
	      objCont[_this2.callbackList[i]] = { array: [], expanded: true, totalCallback: 0 };
	    }
	    _this2.state = {
	      hourSelected: "02",
	      minuteSelected: "40",
	      timeSelected: "PM",
	      timeReturned: "14:40",
	      selectedDate: (0, _moment2.default)(),
	      dateReschedule: _this2.parseDate(new Date()),
	      timeArrays: objCont
	    };
	    _this2.dataSource = [];
	    for (var _i in _this2.props.dataSource) {
	      var item = (0, _moment2.default)(_this2.props.dataSource[_i].Day);
	      _this2.dataSource.push(item);
	    }
	    _this2.minutes = ["00", "01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31", "32", "33", "34", "35", "36", "37", "38", "39", "40", "41", "42", "43", "44", "45", "46", "47", "48", "49", "50", "51", "52", "53", "54", "55", "56", "57", "58", "59"];
	    _this2.hours = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
	    _this2.time = ["AM", "PM"];
	    _this2.timeScroll = "";
	    var APIFact = new _cwGalateaApiJsBundle.APIFactory();
	    _this2.apiCont = APIFact.buildClient();
	    _this2.currentFocus = 0;
	    _this2.canLoseFocus = false;
	    _this2.daysAllowedforCallBack = _this2.sharedData.getGeneralPermissions()[35];
	    return _this2;
	  }
	
	  _createClass(DateTimeSelection, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.focusableItems = [this.refs["hourComponent"], this.refs["minuteComponent"], this.refs["secondComponent"], this.refs["buttonReady"]];
	      var today = new Date();
	      this.getCallBackByDay(this.parseDate(today));
	    }
	  }, {
	    key: 'getCallBackByDay',
	    value: function getCallBackByDay(date) {
	      var _this = this;
	      var userId = this.sharedData.getParameters().UserID; //11;
	      var objectResponseCallIcon = this.apiCont.getObjectResponse();
	      this.apiCont.getDayCallBack(userId, date, objectResponseCallIcon);
	      objectResponseCallIcon.onError = function (messageError) {};
	      objectResponseCallIcon.onSuccess = function (objResponse) {
	        var newCallBacks = _this.state.timeArrays;
	        for (var obj in newCallBacks) {
	          var objCont = newCallBacks[obj];
	          objCont.array = [];
	          objCont.totalCallback = 0;
	          objCont.expanded = true;
	        }
	        for (var i in objResponse) {
	          var resp = objResponse[i];
	          var hour = parseInt(resp.Hour, 10);
	          hour = hour === 12 ? "12:00 pm" : hour < 12 ? ('0' + hour).slice(-2) + ":00 am" : ('0' + (hour - 12)).slice(-2) + ":00 pm";
	          newCallBacks[hour].totalCallback = resp.CallBacks;
	          for (var j in resp.Detail) {
	            var det = resp.Detail[j];
	            newCallBacks[hour].array.push({
	              time: hour.replace("00", ('0' + det.Minute.toString()).slice(-2)),
	              iconPhoneNumber: _Images.typeHome,
	              phoneNumber: det.Telephone,
	              campaign: det.Campaign
	            });
	          }
	        }
	        _this.setState({ timeArrays: newCallBacks });
	      };
	    }
	  }, {
	    key: 'selectHour',
	    value: function selectHour(hour) {
	      this.setState({ hourSelected: hour.text });
	      this.timeScroll = hour.text + ":00 " + this.state.timeSelected.toLowerCase();
	      this.scrollToTime();
	    }
	  }, {
	    key: 'selectMinute',
	    value: function selectMinute(minute) {
	      this.setState({ minuteSelected: minute.text });
	    }
	  }, {
	    key: 'selectTime',
	    value: function selectTime(time) {
	      this.setState({ timeSelected: time.text });
	      this.timeScroll = this.state.hourSelected + ":00 " + time.text.toLowerCase();
	      this.scrollToTime();
	    }
	  }, {
	    key: 'scrollToTime',
	    value: function scrollToTime() {
	      this.expandCallBack(this.timeScroll);
	      var tScroll = this.refs[this.timeScroll];
	      var _this = this;
	      if (tScroll && tScroll.offsetTop) {
	        setTimeout(function () {
	          _this.refs["tableCallBack"].scrollTop = tScroll.offsetTop - tScroll.offsetHeight;
	        }, 50);
	      }
	    }
	  }, {
	    key: 'readyDateTimeReschedule',
	    value: function readyDateTimeReschedule(evt) {
	      var hour24 = this.state.timeSelected === "PM" && this.state.hourSelected !== "12" ? parseInt(this.state.hourSelected, 10) + 12 : this.state.hourSelected;
	      if (this.state.timeSelected === "AM" && this.state.hourSelected === "12") {
	        hour24 = "00";
	      }
	      var dateToSend = this.state.selectedDate ? this.state.dateReschedule : this.parseDate(new Date());
	      var timeToSend = hour24 + ":" + this.state.minuteSelected;
	      this.props.onSelectDate(dateToSend, timeToSend);
	      evt.stopPropagation();
	    }
	  }, {
	    key: 'handleSelectDate',
	    value: function handleSelectDate(date) {
	      var dateS = new Date(date);
	      this.setState({
	        dateReschedule: this.parseDate(dateS),
	        selectedDate: date
	      });
	      this.getCallBackByDay(this.parseDate(dateS));
	    }
	  }, {
	    key: 'parseDate',
	    value: function parseDate(date) {
	      // var options = {"month":"2-digit","year":"numeric","day":"2-digit"};
	      // let dateLocale = date.toLocaleDateString("es-MX", options);
	      var year = date.getFullYear();
	      var month = ('0' + (date.getMonth() + 1)).slice(-2);
	      var day = ('0' + date.getDate()).slice(-2);
	      return year + "/" + month + "/" + day;
	    }
	  }, {
	    key: 'stopPropagation',
	    value: function stopPropagation(evt) {
	      this.canLoseFocus = true;
	      evt.stopPropagation();
	    }
	  }, {
	    key: 'focusItem',
	    value: function focusItem(item) {
	      this.currentFocus = item;
	    }
	  }, {
	    key: 'blurItem',
	    value: function blurItem(item) {
	      this.currentFocus = ++this.currentFocus < this.focusableItems.length ? this.currentFocus : 0;
	      this.focusableItems[this.currentFocus].focus();
	    }
	  }, {
	    key: 'expandCallBack',
	    value: function expandCallBack(itemExpanded) {
	      var array = this.state.timeArrays;
	      if (array[itemExpanded].array.length > 0) {
	        array[itemExpanded].expanded = !array[itemExpanded].expanded;
	        this.setState({ timeArrays: array });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'selectDateContainer', onClick: function onClick(e) {
	            return _this3.stopPropagation(e);
	          } },
	        _react2.default.createElement(
	          'div',
	          { className: 'dateContainer' },
	          _react2.default.createElement(
	            'div',
	            { className: 'calendarContainer' },
	            _react2.default.createElement(_reactDatepicker2.default, {
	              minDate: (0, _moment2.default)(),
	              maxDate: (0, _moment2.default)().add(this.daysAllowedforCallBack, "days"),
	              inline: true,
	              selected: this.state.selectedDate,
	              locale: this.language.getText("CallControlcallCalificationlocale"),
	              useWeekdaysShort: true,
	              onChange: this.handleSelectDate.bind(this),
	              highlightDates: this.dataSource
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'selectHourContainer' },
	            _react2.default.createElement(
	              'p',
	              { className: 'timeSelectionTitle' },
	              this.language.getText("CallControlcallCalificationhour") + ":"
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'containerSeletcTime' },
	              _react2.default.createElement(_SelectComponent2.default, {
	                name: "hora",
	                ref: "hourComponent",
	                tabIndex: '0',
	                bottomBox: 60,
	                itemDefault: 1,
	                stylesSelector: { height: 26, width: 20 },
	                displayer: "bigDisplayer",
	                customCell: "cellText",
	                dataSource: this.hours,
	                onSelectItem: this.selectHour.bind(this),
	                onFocus: function onFocus() {
	                  return _this3.focusItem(0);
	                } })
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              ':'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'containerSeletcTime' },
	              _react2.default.createElement(_SelectComponent2.default, {
	                name: "minuto",
	                ref: "minuteComponent",
	                tabIndex: '1',
	                bottomBox: 60,
	                itemDefault: 40,
	                stylesSelector: { height: 26, width: 20 },
	                displayer: "bigDisplayer",
	                customCell: "cellText",
	                dataSource: this.minutes,
	                onSelectItem: this.selectMinute.bind(this),
	                onFocus: function onFocus() {
	                  return _this3.focusItem(1);
	                } })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'containerSeletcTime' },
	              _react2.default.createElement(_SelectComponent2.default, {
	                name: "segundo",
	                ref: "secondComponent",
	                tabIndex: '2',
	                bottomBox: 60,
	                itemDefault: 1,
	                stylesSelector: { height: 26, width: 20 },
	                displayer: "bigDisplayer",
	                customCell: "cellText",
	                dataSource: this.time,
	                onSelectItem: this.selectTime.bind(this),
	                onFocus: function onFocus() {
	                  return _this3.focusItem(2);
	                } })
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'buttonTime',
	                onClick: function onClick(e) {
	                  return _this3.readyDateTimeReschedule(e);
	                },
	                ref: "buttonReady",
	                tabIndex: '3',
	                onKeyPress: function onKeyPress(event) {
	                  if (event.key === 'Enter') {
	                    _this3.readyDateTimeReschedule(event);
	                  }
	                },
	                onFocus: function onFocus() {
	                  return _this3.focusItem(3);
	                },
	                onBlur: function onBlur() {
	                  return _this3.blurItem(3);
	                } },
	              this.language.getText("CallControlcallCalificationready")
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'callBackList' },
	          _react2.default.createElement(
	            'p',
	            { className: 'titleCallBackList' },
	            this.language.getText("CallControlcallCalificationcallbackG")
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'tableCallBackList', ref: 'tableCallBack' },
	            this.callbackList.map(function (item, i) {
	              return _react2.default.createElement(
	                'div',
	                { className: 'containerCallBack', key: i + "time", ref: item },
	                _react2.default.createElement(
	                  'div',
	                  { className: "timeHeader " + (_this3.state.timeArrays[item].array.length > 0 ? "cursor" : ""), onClick: function onClick() {
	                      return _this3.expandCallBack(item);
	                    } },
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'timeHeaderText' },
	                    item
	                  ),
	                  _this3.state.timeArrays[item].totalCallback > 0 && _react2.default.createElement(
	                    'p',
	                    { className: 'timeHeaderCount' },
	                    _this3.state.timeArrays[item].totalCallback
	                  )
	                ),
	                _this3.state.timeArrays[item].expanded && _react2.default.createElement(
	                  'div',
	                  { className: 'tableContainer' },
	                  _react2.default.createElement(_TableComponent2.default, {
	                    customCell: "cellAssignedCallback",
	                    parameters: { time: "time", iconPhoneNumber: "iconPhoneNumber", phoneNumber: "phoneNumber", campaignName: "campaign" },
	                    dataSource: _this3.state.timeArrays[item].array,
	                    selectable: false,
	                    selectedStyle: "none",
	                    cellHover: "none",
	                    orderBy: "phoneNumber",
	                    orderForm: true,
	                    disabled: _this3.state.timeArrays[item].array.length > 0 ? false : true })
	                )
	              );
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return DateTimeSelection;
	}(_react.Component);
	
	exports.default = DateTimeSelection;

/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Singleton = __webpack_require__(21);
	
	var _cwGalateaApiJsBundle = __webpack_require__(40);
	
	var _globalComponentsLibrary = __webpack_require__(28);
	
	var _reactstrap = __webpack_require__(111);
	
	var _constants = __webpack_require__(10);
	
	var _singletonSharedData = __webpack_require__(23);
	
	var _reactRedux = __webpack_require__(25);
	
	var _A_preview = __webpack_require__(52);
	
	var _Logger = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var language = new _Singleton.Singleton();
	var APIFact = new _cwGalateaApiJsBundle.APIFactory();
	var apiCont = APIFact.buildClient();
	var sharedData = new _singletonSharedData.SingletonSharedData();
	
	var DialingLogPreview = function DialingLogPreview(_ref) {
	  var userId = _ref.userId,
	      _ref$showDataLogDisp = _ref.showDataLogDisp,
	      showDataLogDisp = _ref$showDataLogDisp === undefined ? false : _ref$showDataLogDisp,
	      callOutId = _ref.callOutId,
	      camId = _ref.camId,
	      status = _ref.status,
	      showOnlyData = _ref.showOnlyData;
	
	  var idLanguage = language.getLanguage();
	
	  var _useState = (0, _react.useState)([]),
	      _useState2 = _slicedToArray(_useState, 2),
	      dialingLog = _useState2[0],
	      setDialingLog = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(1),
	      _useState4 = _slicedToArray(_useState3, 2),
	      iRow = _useState4[0],
	      setIRow = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(6),
	      _useState6 = _slicedToArray(_useState5, 2),
	      fRow = _useState6[0],
	      setFRow = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(false),
	      _useState8 = _slicedToArray(_useState7, 2),
	      flag = _useState8[0],
	      setFlag = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(_constants.LANGUAGE[sharedData.generalPermissions[27]]),
	      _useState10 = _slicedToArray(_useState9, 2),
	      lang = _useState10[0],
	      setLang = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(''),
	      _useState12 = _slicedToArray(_useState11, 2),
	      rigthSideStyle = _useState12[0],
	      setRigthSideStyle = _useState12[1];
	
	  var wrapUpStyle = [_constants.RECORD_STATE.WRAPUP, _constants.RECORD_STATE.ABANDONED, _constants.RECORD_STATE.ALERT, _constants.RECORD_STATE.WAITING_WRAPUP];
	
	  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
	    return state.preview;
	  }),
	      simultaneosRecs = _useSelector.simultaneosRecs,
	      records = _useSelector.records,
	      selectedRecord = _useSelector.selectedRecord;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var _useInfiniteScrollWit = (0, _globalComponentsLibrary.useInfiniteScrollWithRefCallback)(fetchFunction, flag),
	      _useInfiniteScrollWit2 = _slicedToArray(_useInfiniteScrollWit, 3),
	      containerRef = _useInfiniteScrollWit2[0],
	      isFetchingPage = _useInfiniteScrollWit2[1],
	      setFetchingPage = _useInfiniteScrollWit2[2];
	
	  function fetchFunction() {
	    if (!simultaneosRecs) {
	      getHistory();
	    } else {
	      selectedRecord.flagLogDial ? getHistory() : setFetchingPage(false);
	    }
	  }
	
	  (0, _react.useEffect)(function () {
	    getLanguague();
	    checkIfthereAreLogDial();
	    setStyleSimultaneousRecs();
	  }, []);
	
	  (0, _react.useEffect)(function () {
	    setStyleSimultaneousRecs();
	  }, [showOnlyData]);
	
	  var checkIfthereAreLogDial = function checkIfthereAreLogDial() {
	    if (!simultaneosRecs) {
	      getHistory();
	    } else {
	      setLogPerRec();
	    }
	  };
	  var setLogPerRec = function setLogPerRec() {
	    var logDialPerRec = records.filter(function (r) {
	      return r.callOutId === callOutId;
	    });
	
	    if (logDialPerRec[0].logDial.length === 0) {
	      getHistory();
	    } else {
	      setDialingLog(logDialPerRec[0].logDial);
	    }
	  };
	
	  var getLanguague = function getLanguague() {
	    idLanguage !== '-1' && setLang(_constants.LANGUAGE[idLanguage]);
	  };
	  var getHistory = function getHistory() {
	    if (flag) {
	      setFetchingPage(false);
	    } else {
	      var dataSend = {
	        callOutId: callOutId,
	        camId: camId,
	        userId: userId,
	        initialRow: iRow,
	        finalRow: fRow
	      };
	      var objectResponse = apiCont.getObjectResponse();
	      apiCont.getPreviewHistory(dataSend, objectResponse);
	
	      objectResponse.onError = function (messageError) {
	        _Logger.Logger.Error('[DialingLogPreview][getHistory]', messageError);
	        setFetchingPage(false);
	      };
	      objectResponse.onSuccess = function (objResponse) {
	        setFetchingPage(false);
	        var arr = objResponse.Response;
	        if (simultaneosRecs && arr.length < fRow - iRow) {
	          dispatch((0, _A_preview.setFlagLogDial)(callOutId));
	        }
	        if (arr.length > 0) {
	          setIRow(fRow + 1);
	          setFRow(fRow + 30);
	          setDialingLog([].concat(_toConsumableArray(dialingLog), _toConsumableArray(arr)));
	          if (simultaneosRecs) {
	            selectedRecord.flagLogDial && dispatch((0, _A_preview.saveLogDial)({ callOutId: callOutId, logDial: [].concat(_toConsumableArray(dialingLog), _toConsumableArray(arr)) }));
	          }
	        } else {
	          setFlag(true);
	          simultaneosRecs && dispatch((0, _A_preview.setFlagLogDial)(callOutId));
	        }
	      };
	    }
	  };
	  var setStyleSimultaneousRecs = function setStyleSimultaneousRecs() {
	    if (simultaneosRecs) {
	      if (status === _constants.RECORD_STATE.DEFAULT || status === _constants.RECORD_STATE.DIALOG) {
	        setRigthSideStyle(status);
	      } else if (wrapUpStyle.includes(status)) {
	        showOnlyData ? setRigthSideStyle('') : setRigthSideStyle('WRAPUPWITHDISP');
	      }
	    }
	  };
	  return _react2.default.createElement(
	    'div',
	    { className: 'rightSide ' + rigthSideStyle + ' ' + (simultaneosRecs ? 'simultaneous' : '') },
	    !simultaneosRecs && _react2.default.createElement(
	      'div',
	      { className: 'dlp-title-record ' },
	      _react2.default.createElement(
	        'p',
	        { className: 'label-title-record' },
	        language.getText('GUIPreviewdialingLog')
	      ),
	      _react2.default.createElement('i', { className: 'gcl-icon history' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'container-cards ' + (simultaneosRecs ? 'designSimultaneous' : '') + ' ' + (simultaneosRecs && dialingLog.length === 0 ? 'simultaneosRecs' : ''), ref: containerRef },
	      dialingLog.length > 0 ? dialingLog.map(function (r, index) {
	        return _react2.default.createElement(CardData, { key: index, result: language.getText('GUIDialResult' + r.DialResult), disposition: r.Disposition, date: (0, _globalComponentsLibrary.formatDateWithHour)(r.Date, lang), simultaneosRecs: simultaneosRecs });
	      }) : _react2.default.createElement(MsgError, { label: language.getText('GUIPreviewmsgRecentCalls'), showDataLogDisp: showDataLogDisp, simultaneosRecs: simultaneosRecs }),
	      isFetchingPage && _react2.default.createElement(_reactstrap.Spinner, { size: 'sm', color: 'primary' })
	    )
	  );
	};
	var MsgError = function MsgError(_ref2) {
	  var label = _ref2.label,
	      showDataLogDisp = _ref2.showDataLogDisp,
	      simultaneosRecs = _ref2.simultaneosRecs;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'container-no-dialing-log ' + (showDataLogDisp ? 'showDataLogDisp' : '') + ' ' + (!simultaneosRecs ? "noSimultaneous" : '') },
	    _react2.default.createElement(
	      'div',
	      { className: 'icon-no-dialing-log' },
	      _react2.default.createElement('i', { id: 'icon-no-dialing', className: 'gcl-icon warning ' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'label-no-dialing-log' },
	      label
	    )
	  );
	};
	
	var CardData = function CardData(_ref3) {
	  var result = _ref3.result,
	      disposition = _ref3.disposition,
	      date = _ref3.date,
	      simultaneosRecs = _ref3.simultaneosRecs;
	
	  var newDisposition = disposition !== "" ? disposition : language.getText('GUIDialResultdoesNotApply');
	  return _react2.default.createElement(
	    'div',
	    { className: 'card-item ' + (!simultaneosRecs ? 'noSimultaneous' : '') },
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'p',
	        { className: 'subtitle-item-card' },
	        language.getText('GUIPreviewresult') + ': '
	      ),
	      '    ',
	      _react2.default.createElement(
	        'p',
	        { className: 'label-item-card' },
	        result
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'p',
	        { className: 'subtitle-item-card' },
	        language.getText('GUIPreviewdisposition') + ': ',
	        ' '
	      ),
	      ' ',
	      _react2.default.createElement(
	        'p',
	        { className: 'label-item-card' },
	        newDisposition
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'p',
	        { className: 'subtitle-item-card' },
	        language.getText('GUIPreviewdateAndTime') + ': ',
	        ' '
	      ),
	      ' ',
	      _react2.default.createElement(
	        'p',
	        { className: 'label-item-card' },
	        date
	      )
	    )
	  );
	};
	exports.default = DialingLogPreview;

/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _singletonSharedData = __webpack_require__(23);
	
	var _GenericSVG = __webpack_require__(51);
	
	var _Validations = __webpack_require__(131);
	
	var _animations = __webpack_require__(1153);
	
	var _ManualCallSVG = __webpack_require__(236);
	
	var _reactstrap = __webpack_require__(111);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Keyboard = function (_Component) {
	  _inherits(Keyboard, _Component);
	
	  function Keyboard(props) {
	    _classCallCheck(this, Keyboard);
	
	    var _this = _possibleConstructorReturn(this, (Keyboard.__proto__ || Object.getPrototypeOf(Keyboard)).call(this, props));
	
	    _this.sharedData = new _singletonSharedData.SingletonSharedData();
	    _this.keyboard = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "*", "0", "#"];
	    return _this;
	  }
	
	  _createClass(Keyboard, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(nextProps) {
	      if (nextProps.onFocus) {
	        this.focusTel();
	        this.sharedData.setFocusTel(false);
	      }
	    }
	  }, {
	    key: 'onCreateAnimation',
	    value: function onCreateAnimation(e) {
	      (0, _animations.animationCircle)(e.nativeEvent.layerX - 1, e.nativeEvent.layerY - 1, e.currentTarget, this.refs["pruebaRender"]);
	    }
	  }, {
	    key: 'addingNewNumber',
	    value: function addingNewNumber(e) {
	      if (e.key === 'Enter') {
	        if (this.props.onEnter) {
	          this.props.onEnter();
	        }
	      } else {
	        (0, _Validations.validateOnlyNumbers)(e);
	        var parent = this.refs["key-" + e.key];
	        if (parent) {
	          (0, _animations.animationCircle)(parent.clientWidth / 2.0, parent.clientHeight / 2.0, parent, this.refs["pruebaRender"]);
	        }
	      }
	    }
	  }, {
	    key: 'focusTel',
	    value: function focusTel() {
	      this.refs["inputTelephone"].focus();
	    }
	  }, {
	    key: 'blurTel',
	    value: function blurTel() {
	      this.refs["inputTelephone"].blur();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'keyboardContainer' },
	        _react2.default.createElement('div', { className: 'buttonAnimation hidden', ref: 'pruebaRender' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'numberContainerArea ' },
	          _react2.default.createElement(
	            'div',
	            { className: 'numberContainer ' + (this.props.isManualMessage && this.props.infoTooltip ? 'numberContainerMessage' : null) },
	            _react2.default.createElement(
	              'div',
	              { className: 'leftIcon' },
	              this.props.isManualMessage ? _ManualCallSVG.cellICon : _ManualCallSVG.phoneIcon
	            ),
	            _react2.default.createElement('input', { type: "text",
	              ref: 'inputTelephone',
	              maxLength: '15',
	              className: 'txtDataClientCellMC',
	              value: this.props.number,
	              onChange: function onChange(event) {
	                _this2.props.onChangeNumber(event.target.value);
	              },
	              onKeyPress: this.addingNewNumber.bind(this),
	              disabled: this.props.disabled
	            }),
	            this.props.number !== "" && _react2.default.createElement(
	              'div',
	              { className: 'cleanNumberKeyboard', onClick: this.props.onClean },
	              _GenericSVG.deleteNumber
	            )
	          ),
	          this.props.infoTooltip && _react2.default.createElement(
	            'div',
	            { className: 'keyboard-tooltip-message' },
	            _react2.default.createElement(
	              'i',
	              { className: 'gcl-icon info', id: 'keyboard-info-tooltip' },
	              _react2.default.createElement(
	                _reactstrap.UncontrolledTooltip,
	                { placement: 'top', target: 'keyboard-info-tooltip', hideArrow: true, innerClassName: 'keyboard-tooltip-info' },
	                this.props.infoTooltip
	              )
	            )
	          )
	        ),
	        this.keyboard.map(function (item) {
	          return _react2.default.createElement(
	            'div',
	            { key: item, ref: "key-" + item, className: 'keyKeyboard ' + (_this2.props.isManualMessage && (item === '#' || item === '*') ? 'disabled' : ''), onClick: _this2.props.disabled ? '' : _this2.onCreateAnimation.bind(_this2) },
	            _react2.default.createElement(
	              'p',
	              { className: 'keyNumber ' + (_this2.props.isManualMessage && (item === '#' || item === '*') ? 'disabled' : ''), onClick: function onClick() {
	                  _this2.props.disabled ? '' : _this2.props.onChangeNumber(_this2.props.number + item);
	                } },
	              ' ',
	              item
	            )
	          );
	        })
	      );
	    }
	  }]);
	
	  return Keyboard;
	}(_react.Component);
	
	exports.default = Keyboard;

/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(25);
	
	var _Images = __webpack_require__(30);
	
	var _reactSimpleRange = __webpack_require__(957);
	
	var _reactSimpleRange2 = _interopRequireDefault(_reactSimpleRange);
	
	var _A_volume = __webpack_require__(335);
	
	var _constants = __webpack_require__(10);
	
	var _singletonSharedData = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VolumeWindow = function (_Component) {
	  _inherits(VolumeWindow, _Component);
	
	  function VolumeWindow(props) {
	    _classCallCheck(this, VolumeWindow);
	
	    var _this2 = _possibleConstructorReturn(this, (VolumeWindow.__proto__ || Object.getPrototypeOf(VolumeWindow)).call(this, props));
	
	    _this2.state = {
	      speakerVolume: _this2.props.volSpeaker,
	      lastSpeakerVolume: _this2.props.volSpeaker,
	      microphoneVolume: _this2.props.muteMicrophone ? 0 : _this2.props.volMicrophone,
	      lastMicrophoneVolume: _this2.props.muteMicrophone ? 0 : _this2.props.volMicrophone,
	      muteMicrophone: _this2.props.muteMicrophone,
	      pointerVolume: 0,
	      disabledVolume: false
	    };
	    _this2.timerVol = {};
	    _this2.imageVolume = _Images.mediumVolume;
	    _this2.animVolume = [];
	    _this2.sharedData = new _singletonSharedData.SingletonSharedData();
	    return _this2;
	  }
	
	  _createClass(VolumeWindow, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.messagesIntegrations && nextProps.messagesIntegrations.dataMessageIntegration) {
	        var _this = this;
	        _this.volumenFromIntegratioin(nextProps.messagesIntegrations.dataMessageIntegration);
	      }
	
	      if (!this.state.muteMicrophone && nextProps.muteMicrophone) {
	        this.setState({
	          lastMicrophoneVolume: this.state.microphoneVolume,
	          microphoneVolume: 0,
	          muteMicrophone: true
	        });
	      }
	      if (this.state.muteMicrophone && !nextProps.muteMicrophone) {
	        var microVol = this.state.lastMicrophoneVolume === 0 ? 50 : this.state.lastMicrophoneVolume;
	        this.setState({
	          microphoneVolume: microVol,
	          muteMicrophone: false
	        });
	        this.props.onChangeVolumeMicro(microVol);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearInterval(this.timerVol);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (window.chrome && !!window.chrome.webstore && this.sharedData.currentSoftPhone === _constants.SOFTPHONES_KEY.WebRTC) {
	        this.props.alert(true);
	        this.imageVolume = _Images.noVolume;
	        this.setState({ disabledVolume: true });
	      }
	      this.animVolume = [5, 4, 3, 2, 1, 0];
	      this.timerVolume();
	      if (this.props.messagesIntegrations && this.props.messagesIntegrations.dataMessageIntegration) {
	        this.volumenFromIntegratioin(this.props.messagesIntegrations.dataMessageIntegration);
	      }
	    }
	  }, {
	    key: 'timerVolume',
	    value: function timerVolume() {
	      var _this = this;
	      this.timerVol = setInterval(function () {
	        var baseAnim = (Math.floor(_this.state.microphoneVolume / 33.4) + 1) * 2 - 1;
	        var rnd = Math.floor(Math.random() * 3) + 1 - 2;
	        _this.setState({ pointerVolume: baseAnim + rnd });
	      }, 250);
	    }
	  }, {
	    key: 'movingSpeaker',
	    value: function movingSpeaker(props) {
	      if (!this.state.disabledVolume) {
	        this.setState({ speakerVolume: props.value });
	        this.imageVolume = props.value > 50 ? _Images.heightVolume : props.value > 0 ? _Images.mediumVolume : _Images.noVolume;
	        this.props.volumeSpeaker(props.value);
	        this.props.onChangeVolumeSpeakers(props.value);
	      }
	    }
	  }, {
	    key: 'movingMicrophone',
	    value: function movingMicrophone(props) {
	      this.setState({
	        microphoneVolume: props.value,
	        muteMicrophone: props.value === 0
	      });
	      this.props.volumeMicrophone(props.value);
	      this.props.onChangeVolumeMicro(props.value);
	    }
	  }, {
	    key: 'volumenFromIntegratioin',
	    value: function volumenFromIntegratioin(dataMessageIntegration) {
	      var _this3 = this;
	
	      var _this = this;
	      if (dataMessageIntegration.device === _constants.INTEGRATION.SPEAKER) {
	        _this.movingSpeaker({ value: parseInt(dataMessageIntegration.vol, 10) });
	      } else if (dataMessageIntegration.device === _constants.INTEGRATION.MICROPHONE) {
	        _this.movingMicrophone({ value: parseInt(dataMessageIntegration.vol, 10) });
	      }
	      setTimeout(function () {
	        _this3.props.closeItem();
	      }, 1500);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'volumeWindow' },
	        _react2.default.createElement(
	          'div',
	          { className: 'volumeSpeaker' },
	          _react2.default.createElement('img', { src: this.imageVolume, className: "imgVolumeTop " + (this.state.disabledVolume ? "disabled" : ""), alt: 'icon' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'sliderContainer' },
	            _react2.default.createElement(
	              _reactSimpleRange2.default,
	              {
	                vertical: true,
	                value: this.state.disabledVolume ? 50 : this.state.speakerVolume,
	                sliderSize: 3,
	                sliderColor: 'rgba(255,255,255,0.22)',
	                trackColor: 'blue',
	                thumbColor: '#B71C1C',
	                verticalSliderHeight: '100%',
	                onChange: this.movingSpeaker.bind(this),
	                max: 100,
	                min: 0,
	                disableTrack: this.state.disabledVolume },
	              _react2.default.createElement('div', { className: "thumbCustom " + (this.state.disabledVolume ? "disabled" : "") })
	            )
	          ),
	          _react2.default.createElement('img', { src: _Images.noVolume, className: 'imgVolumeDown', alt: 'icon' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'volumeMicrophone' },
	          _react2.default.createElement('img', { src: _Images.microphone, className: 'imgVolumeTop', alt: 'icon' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'microPointsContainer' },
	            this.animVolume.map(function (item) {
	              return _react2.default.createElement('div', { key: item, className: "volumeAnimation " + (_this4.state.pointerVolume > parseInt(item, 10) && "volumeAnimationActive") });
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'sliderContainer' },
	            _react2.default.createElement(
	              _reactSimpleRange2.default,
	              { className: 'sliderVolume',
	                vertical: true,
	                sliderSize: 3,
	                value: this.state.microphoneVolume,
	                sliderColor: 'rgba(255,255,255,0.22)',
	                trackColor: 'blue',
	                thumbColor: '#B71C1C',
	                verticalSliderHeight: '100%',
	                onChange: this.movingMicrophone.bind(this)
	              },
	              _react2.default.createElement('div', { className: 'thumbCustom' })
	            )
	          ),
	          _react2.default.createElement('img', { src: _Images.noMircrophone, className: 'imgVolumeDown', alt: 'icon' })
	        )
	      );
	    }
	  }]);
	
	  return VolumeWindow;
	}(_react.Component);
	
	;
	
	function mapStateToProps(state) {
	  return {
	    messagesIntegrations: state.messagesIntegrations
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return {
	    volumeSpeaker: function volumeSpeaker(volume) {
	      dispatch((0, _A_volume.volumeSpeaker)(volume));
	    },
	    volumeMicrophone: function volumeMicrophone(volume) {
	      dispatch((0, _A_volume.volumeMicrophone)(volume));
	    }
	  };
	}
	
	exports.default = VolumeWindow = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(VolumeWindow);

/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Singleton = __webpack_require__(21);
	
	var _CallSpaceHeaderSVG = __webpack_require__(67);
	
	var _AnimatedPhone = __webpack_require__(493);
	
	var _AnimatedPhone2 = _interopRequireDefault(_AnimatedPhone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CallingAssitedTransfer = function (_Component) {
	    _inherits(CallingAssitedTransfer, _Component);
	
	    function CallingAssitedTransfer(props) {
	        _classCallCheck(this, CallingAssitedTransfer);
	
	        var _this = _possibleConstructorReturn(this, (CallingAssitedTransfer.__proto__ || Object.getPrototypeOf(CallingAssitedTransfer)).call(this, props));
	
	        _this.language = new _Singleton.Singleton();
	
	        return _this;
	    }
	
	    _createClass(CallingAssitedTransfer, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'transferringWindow' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'AnimationAssistedTransfer' },
	                    _react2.default.createElement(_AnimatedPhone2.default, null)
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'Data' },
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'assistedTransferNumber' },
	                        this.props.phoneNumberTransfer
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'assistedTransferCalling' },
	                        this.language.getText("CallControlGUICallIOStatusmanualCall")
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'hangUpAssistedTransfer', onClick: function onClick() {
	                                return _this2.props.hangUpTransfer();
	                            } },
	                        _CallSpaceHeaderSVG.hangUp
	                    )
	                )
	            );
	        }
	    }]);
	
	    return CallingAssitedTransfer;
	}(_react.Component);
	
	exports.default = CallingAssitedTransfer;

/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.supervisorChatExpanded = supervisorChatExpanded;
	exports.noAvailableRecordExpanded = noAvailableRecordExpanded;
	exports.noAvailableExpanded = noAvailableExpanded;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(10);
	
	var _SupervisorChatExpanded = __webpack_require__(1094);
	
	var _SupervisorChatExpanded2 = _interopRequireDefault(_SupervisorChatExpanded);
	
	var _NoAvailableRecordExpanded = __webpack_require__(1093);
	
	var _NoAvailableRecordExpanded2 = _interopRequireDefault(_NoAvailableRecordExpanded);
	
	var _NoAvailableExpanded = __webpack_require__(1092);
	
	var _NoAvailableExpanded2 = _interopRequireDefault(_NoAvailableExpanded);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function supervisorChatExpanded() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return {
	    idComponent: _constants.WORKBAR_ACTIONS.SUPERVISOR_CHAT,
	    componentProps: props,
	    component: _react2.default.createElement(_SupervisorChatExpanded2.default, { key: 'supervisorChatExpanded', id: _constants.WORKBAR_ACTIONS.SUPERVISOR_CHAT, objProps: props })
	  };
	}
	function noAvailableRecordExpanded() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return {
	    idComponent: _constants.WORKBAR_ACTIONS.NO_AVAILABLE_RECORD,
	    componentProps: props,
	    component: _react2.default.createElement(_NoAvailableRecordExpanded2.default, { key: 'noAvailableRecordExpanded', id: _constants.WORKBAR_ACTIONS.NO_AVAILABLE_RECORD, objProps: props })
	  };
	}
	function noAvailableExpanded() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return {
	    idComponent: _constants.WORKBAR_ACTIONS.NO_AVAILABLE,
	    componentProps: props,
	    component: _react2.default.createElement(_NoAvailableExpanded2.default, { key: 'noAvailableExpanded', id: _constants.WORKBAR_ACTIONS.NO_AVAILABLE, objProps: props })
	  };
	}

/***/ },
/* 507 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setTotalSelected = setTotalSelected;
	exports.getTotalSelected = getTotalSelected;
	exports.setCurrentPosition = setCurrentPosition;
	exports.getCurrentPosition = getCurrentPosition;
	exports.setCurrentSize = setCurrentSize;
	exports.getCurrentSize = getCurrentSize;
	exports.setParameters = setParameters;
	exports.getParameters = getParameters;
	exports.setTableOptions = setTableOptions;
	exports.getTableOptions = getTableOptions;
	var currentPosition = { xPosition: 0, yPosition: 0 };
	var currentSize = { widthWindow: 566, heightWindow: 326, minTableWidth: 566 };
	var parametersCell = null;
	var tableOptions = null;
	var totalSelected = 5;
	function setTotalSelected(tSelected) {
	  totalSelected = tSelected;
	}
	function getTotalSelected() {
	  return totalSelected;
	}
	function setCurrentPosition(position) {
	  currentPosition.xPosition += position.xPosition;
	  currentPosition.yPosition += position.yPosition;
	}
	function getCurrentPosition() {
	  return currentPosition;
	}
	function setCurrentSize(cSize) {
	  currentSize = cSize;
	}
	function getCurrentSize() {
	  return currentSize;
	}
	function setParameters(parameters) {
	  parametersCell = parameters;
	}
	function getParameters() {
	  return parametersCell;
	}
	function setTableOptions(tOptions) {
	  tableOptions = tOptions;
	}
	function getTableOptions() {
	  return tableOptions;
	}

/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.STRATEGIES_ERRORS = exports.STRATEGIES_ALERTS_CODE = exports.STRATEGIES_ALERTS = undefined;
	
	var _Singleton = __webpack_require__(21);
	
	var _alertBodies = __webpack_require__(240);
	
	var _SingletonWebSocket = __webpack_require__(50);
	
	var _SingletonWebSocket2 = _interopRequireDefault(_SingletonWebSocket);
	
	var _singletonSharedData = __webpack_require__(23);
	
	var _Logger = __webpack_require__(37);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _globalComponentsLibrary = __webpack_require__(28);
	
	var _draggableComponents = __webpack_require__(101);
	
	var _constants = __webpack_require__(10);
	
	var _Strategies_Preview_RecState = __webpack_require__(239);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var language = new _Singleton.Singleton();
	
	var STRATEGIES_ALERTS = exports.STRATEGIES_ALERTS = {
	  "MANUAL_CALL": function MANUAL_CALL(message, that) {
	    var callResult = { dialResult: message.DialResultID };
	    var integrationMessage = { client: "galatea", action: "ManualCall", subaction: "onDialResult", data: callResult };
	    _SingletonWebSocket2.default.send(integrationMessage);
	
	    var alertObject = {
	      module: message.Module,
	      code: message.Code,
	      message: message.Message,
	      title: "Centerware Kolob",
	      btnYes: language.getText("GUIAlertMessageok"),
	      body: (0, _alertBodies.generalBody)(language.getText('alert-' + message.Code)),
	      btnNo: message.Code === "1093" ? null : language.getText("CallControlCRMxcontrolscancelButton"),
	      onNo: function onNo() {},
	      isGlobe: false
	    };
	    if (that.props.preview.simultaneosRecs) {
	      var temp = that.props.preview.records.filter(function (r) {
	        return r.callOutId === message.CallOutId;
	      })[0].phoneToCall;
	      var textBody = (0, _Strategies_Preview_RecState.errorsMessagePreviewSR)(message.Code, temp, true);
	      alertObject = {
	        module: message.Module,
	        code: message.Code,
	        message: message.Message,
	        title: language.getText('GUIPreviewSimultaneousAlertsresult-notification').replace('(n)', '(' + that.props.preview.phoneToCall + ')'),
	        btnYes: language.getText("GUIAlertMessageok"),
	        body: textBody,
	        btnNo: message.Code === "1093" ? null : language.getText("CallControlCRMxcontrolscancelButton"),
	        onNo: function onNo() {},
	        isGlobe: false
	      };
	    }
	    var singletonSharedData = new _singletonSharedData.SingletonSharedData();
	    singletonSharedData.problemInManualCall = true;
	    if (message.DialResultID != 1) {
	      singletonSharedData.problemInManualCall = false;
	    }
	    if (singletonSharedData.getDataPreviewPro().dialingMode === 1 && message.DialResultID !== 13) {
	      ShowSnackBarError(alertObject.body, alertObject.title, that, alertObject.code);
	    }
	    if (message.Code == "1511") {
	      that.props.insertWindow((0, _draggableComponents.manualCallWindow)(null), false);
	    }
	    return alertObject;
	  },
	  "TRANSFER_CALL": function TRANSFER_CALL(message) {
	    var language = new _Singleton.Singleton();
	    var body = language.getText('alert-' + message.AlertCode);
	    if (message.AlertCode === "1501") body = language.getText('CallControlGUICallTransferno-answer-error');
	    var alertObject = {
	      module: "TRANSFER_CALL",
	      code: message.AlertCode,
	      title: "Centerware Kolob",
	      btnYes: language.getText("GUIAlertMessageok"),
	      body: body,
	      btnNo: language.getText("CallControlCRMxcontrolscancelButton"),
	      onNo: function onNo() {},
	      isGlobe: false,
	      error: {
	        Code: message.AlertCode,
	        Message: body
	      }
	    };
	    return alertObject;
	  }
	};
	
	var STRATEGIES_ALERTS_CODE = exports.STRATEGIES_ALERTS_CODE = {
	  "1091": function _(message, alertObject) {
	    var language = new _Singleton.Singleton();
	    alertObject.btnNo = language.getText("CallControlCRMxcontrolscancelButton");
	    alertObject.onNo = function () {};
	    _Logger.Logger.Warning("[Strategies_Alerts_And_Errors][STRATEGIES_ALERTS_CODE] Alert code 1091 ", alertObject);
	    return alertObject;
	  },
	  "1093": function _(message, alertObject) {
	    var language = new _Singleton.Singleton();
	    alertObject.btnNo = language.getText("CallControlCRMxcontrolscancelButton");
	    alertObject.onNo = function () {};
	    return alertObject;
	  }
	};
	var STRATEGIES_ERRORS = exports.STRATEGIES_ERRORS = {
	  "LOGIN": function LOGIN(message, that) {
	    that.setState({
	      consulting: that.state.consulting - 1,
	      loginError: message.Code
	    });
	  }
	};
	
	var ShowSnackBarError = function ShowSnackBarError(message) {
	  var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	  var that = arguments[2];
	  var code = arguments[3];
	
	  var tempTitle = title === '' ? that.language.getText("GUIPreviewdialResult") : title;
	  tempTitle = code === '1512' ? '' : tempTitle;
	  that.props.addToast(message, {
	    title: tempTitle,
	    group: 'icon',
	    position: 'topRight',
	    icon: 'call-out',
	    iconColor: 'red',
	    color: 'red',
	    btnComponent: _react2.default.createElement(
	      _globalComponentsLibrary.AgentButton,
	      { type: 'tertiary' },
	      that.language.getText("GUIAlertMessageok")
	    ),
	    timeout: 5000
	  });
	};

/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CUSTOM_CELLS = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Images = __webpack_require__(30);
	
	var _formats = __webpack_require__(54);
	
	var _singletonSharedData = __webpack_require__(23);
	
	var _reactBootstrap = __webpack_require__(73);
	
	var _reactstrap = __webpack_require__(111);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var index = 0;
	var CUSTOM_CELLS = exports.CUSTOM_CELLS = {
	  cellImageText: function cellImageText(item, parameters, cellStyles, selectCell, isHidePhone) {
	    return _react2.default.createElement(
	      'li',
	      { key: "key" + index++, className: "cellImageText " + cellStyles, onClick: function onClick() {
	          if (selectCell) {
	            selectCell(item);
	          }
	        } },
	      _react2.default.createElement('img', { className: 'cellImage', src: item[parameters["image"]], alt: 'icon' }),
	      _react2.default.createElement(
	        'p',
	        { className: 'cellText' },
	        (0, _formats.hidePhone)(isHidePhone, item[parameters["text"]])
	      )
	    );
	  },
	  cellText: function cellText(item, parameters, cellStyles, selectCell) {
	    return _react2.default.createElement(
	      'li',
	      { key: "key" + index++, className: "cellOnlyText " + cellStyles, onClick: function onClick() {
	          if (selectCell) {
	            selectCell(item);
	          }
	        } },
	      _react2.default.createElement(
	        'p',
	        { className: 'cellText' },
	        parameters ? item[parameters["text"]] : item
	      )
	    );
	  },
	  cellAssignedCallback: function cellAssignedCallback(item, parameters, cellStyles, selectCell) {
	    return _react2.default.createElement(
	      'li',
	      { key: "key" + index++, className: "cellAssignedCallback " + cellStyles, onClick: function onClick() {
	          return selectCell(item);
	        } },
	      _react2.default.createElement(
	        'p',
	        { className: 'timeAssignedCall' },
	        _react2.default.createElement(
	          'a',
	          { className: 'bulletBlue' },
	          '\u25CF'
	        ),
	        item[parameters["time"]]
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'phoneNumberContainer' },
	        _react2.default.createElement('img', { className: 'iconPhoneNumber', src: item[parameters["iconPhoneNumber"]], alt: 'icon' }),
	        _react2.default.createElement(
	          'p',
	          { className: 'textPhoneNumber' },
	          item[parameters["phoneNumber"]]
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'campaignName' },
	        item[parameters["campaignName"]]
	      )
	    );
	  },
	  cellMark: function cellMark(item, parameters, cellStyles, selectCell) {
	    return _react2.default.createElement(
	      'li',
	      { key: "key" + index++, className: "cellMark " + cellStyles, onClick: function onClick() {
	          return selectCell(item);
	        } },
	      _react2.default.createElement(
	        'p',
	        null,
	        item[parameters["tiempoX"]]
	      )
	    );
	  },
	  cellACDTransfer: function cellACDTransfer(item, parameters, cellStyles, selectCell) {
	    return _react2.default.createElement(
	      'li',
	      { className: "transferCell " + cellStyles, key: "transferCell" + index++, onClick: function onClick() {
	          return selectCell(item);
	        } },
	      _react2.default.createElement(
	        'p',
	        { className: item[parameters["id"]] !== -1 ? "orange" : "" },
	        item[parameters["name"]]
	      )
	    );
	  },
	  cellAgentTransfer: function cellAgentTransfer(item, parameters, cellStyles, selectCell) {
	    var namesAgent = item[parameters["name"]].split(' ');
	    return _react2.default.createElement(
	      'li',
	      { className: "transferCell " + cellStyles, key: "transferCell" + index++, onClick: function onClick() {
	          return selectCell(item);
	        } },
	      _react2.default.createElement(
	        'p',
	        null,
	        namesAgent[0] + " / ",
	        ' ',
	        _react2.default.createElement(
	          'span',
	          { className: 'black60' },
	          namesAgent[1]
	        )
	      )
	    );
	  },
	  cellPhoneTransfer: function cellPhoneTransfer(item, parameters, cellStyles, selectCell) {
	    var name = null;
	    if (parameters["name"] && item[parameters["name"]]) {
	      var names = item[parameters["name"]].split('|');
	      name = names[1];
	    }
	    name = name || item[parameters["phone"]];
	    return _react2.default.createElement(
	      'li',
	      { className: "transferCell " + cellStyles, key: "transferCell" + index++, onClick: function onClick() {
	          return selectCell(item);
	        } },
	      _react2.default.createElement(
	        'p',
	        null,
	        name
	      )
	    );
	  },
	
	  cellCampaings: function cellCampaings(item, parameters, cellStyles, selectCell, favCampaing) {
	    return _react2.default.createElement(
	      _reactBootstrap.OverlayTrigger,
	      {
	        key: 'tlt-notificationContainer-cellCampaing-' + index++,
	        placement: 'bottom',
	        overlay: _react2.default.createElement(
	          _reactBootstrap.Tooltip,
	          { className: 'notificationContainer-tooltip bottom show cellCampaing', key: 'notificationContainer-tooltip-cellCampaing-' + index++, id: 'notificationContainer-tooltip-cellCampaingId-' + index++ },
	          item[parameters['name']]
	        ) },
	      _react2.default.createElement(
	        'li',
	        { key: 'cellCampaing' + index++, className: 'campaingCell', onClick: function onClick() {
	            return selectCell(item);
	          } },
	        _react2.default.createElement('img', { className: 'iconCampaingCell', src: _Images.outBoundCall, alt: 'icon' }),
	        _react2.default.createElement('img', { className: 'iconCampaingCell iconCampaingPadding', src: item[parameters['imgCampaing']], alt: 'icon' }),
	        _react2.default.createElement(
	          'p',
	          { className: 'infoCampaingCell' },
	          item[parameters['name']]
	        )
	      )
	    );
	  },
	  cellDirectory: function cellDirectory(item, parameters, cellStyles, selectCell) {
	    return _react2.default.createElement(
	      'li',
	      { key: "cellCampaing" + index++, className: 'manualCallDataCell info', onClick: function onClick() {
	          return selectCell(item);
	        } },
	      _react2.default.createElement(
	        'p',
	        { className: 'manualCallCell' },
	        item[parameters["name"]]
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'manualCallCell' },
	        item[parameters["phone"]]
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'manualCallCell' },
	        item[parameters["callKey"]]
	      )
	    );
	  },
	  cellDirectoryByCallKey: function cellDirectoryByCallKey(item, parameters, cellStyles, selectCell) {
	    return _react2.default.createElement(
	      'li',
	      { key: "cellCampaing" + index++, className: 'manualCallDataCell info', onClick: function onClick() {
	          return selectCell(item);
	        } },
	      _react2.default.createElement(
	        'p',
	        { className: 'manualCallCell' },
	        item[parameters["callKey"]]
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'manualCallCell' },
	        item[parameters["name"]]
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'manualCallCell' },
	        item[parameters["phone"]]
	      )
	    );
	  },
	  cellRecordCall: function cellRecordCall(item, parameters, cellStyles, selectCell, _, onDoubleClick, ind) {
	    var sharedData = new _singletonSharedData.SingletonSharedData();
	    return _react2.default.createElement(
	      'li',
	      { key: "cellRecordCall" + index++, className: "cellRecordCall " + cellStyles, onClick: function onClick() {
	          return selectCell(item);
	        }, onDoubleClick: onDoubleClick },
	      parameters.Hour && _react2.default.createElement(
	        'p',
	        { className: 'itemRecordCall', style: { width: parameters.Hour.size } },
	        item.Hour
	      ),
	      parameters.Telephone && _react2.default.createElement(
	        'p',
	        { className: 'itemRecordCall', style: { width: parameters.Telephone.size } },
	        (0, _formats.hidePhone)(sharedData.getGeneralPermissions()[223], item.Telephone)
	      ),
	      parameters.Duration && _react2.default.createElement(
	        'p',
	        { className: 'itemRecordCall', style: { width: parameters.Duration.size } },
	        item.Duration
	      ),
	      parameters.CallKey && _react2.default.createElement(
	        'p',
	        { className: 'itemRecordCall simple', style: { width: parameters.CallKey.size } },
	        item.CallKey
	      ),
	      parameters.Description && _react2.default.createElement(
	        'div',
	        { className: 'itemRecordCall', style: { width: parameters.Description.size } },
	        _react2.default.createElement('img', { className: 'iconRecordCall', src: item["imageBackItem"], alt: 'icon' }),
	        _react2.default.createElement('img', { className: 'iconRecordCall iconRecordCallPadding', src: item["imageItem"], alt: 'icon' }),
	        _react2.default.createElement(
	          'p',
	          { className: 'descriptionRecordCall' },
	          item.Description
	        )
	      ),
	      parameters.Disposition && _react2.default.createElement(
	        'p',
	        { className: 'dispositionRecordCall', style: { width: parameters.Disposition.size }, id: 'record-calification-name-' + ind },
	        item.Disposition
	      ),
	      parameters.Disposition && item.Disposition.length > 20 && _react2.default.createElement(
	        _reactstrap.UncontrolledTooltip,
	        { delay: { show: 500, hide: 100 }, placement: 'top', target: 'record-calification-name-' + ind, boundariesElement: 'window', className: 'gcl-agent-info-tooltip' },
	        item.Disposition
	      )
	    );
	  }
	};

/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.helperLanguage = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _cwGalateaApiJsBundle = __webpack_require__(40);
	
	var _Singleton = __webpack_require__(21);
	
	var _cookies = __webpack_require__(328);
	
	var _constants = __webpack_require__(10);
	
	var _singletonSharedData = __webpack_require__(23);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var instance = null;
	
	var helperLanguage = exports.helperLanguage = function () {
	  function helperLanguage() {
	    _classCallCheck(this, helperLanguage);
	
	    if (!instance) {
	      instance = this;
	      var APIFact = new _cwGalateaApiJsBundle.APIFactory();
	      this.apiCont = APIFact.buildClient();
	      this.lagSingleton = new _Singleton.Singleton();
	      this.sharedData = new _singletonSharedData.SingletonSharedData();
	    }
	    return instance;
	  }
	
	  _createClass(helperLanguage, [{
	    key: 'setLanguage',
	    value: function setLanguage(lang, languageObject) {
	      var currLang = '';
	      if (lang === '') {
	        //GET THE LANGUAGE FROM COOKIE
	        currLang = (0, _cookies.getCookie)(_constants.CURRENT_LANGUAGE); //GET THE COOKIE LANGUAGE
	        if (currLang !== "") {
	          //SET THE CURRENT LANGUAGE TO THE SINGLETON
	          this.lagSingleton.setLanguage(currLang);
	        }
	      } else {
	        //SET THE LANGUAGE PASSED
	        currLang = lang;
	        (0, _cookies.setCookie)(_constants.CURRENT_LANGUAGE, lang);
	        this.lagSingleton.setLanguage(currLang);
	      }
	      this.getTags(currLang, languageObject);
	    }
	  }, {
	    key: 'getTags',
	    value: function getTags(currLang, languageObject) {
	      var objectResponse = this.apiCont.getObjectResponse();
	      this.apiCont.getLanguage(currLang, objectResponse);
	      var _this = this;
	      objectResponse.onSuccess = function (objResponse) {
	        _this.lagSingleton.setJsonLanguage(objResponse);
	        _this.sharedData.setSoftPhone(parseInt(objResponse.Response[3].softphone, 10));
	        _this.sharedData.setIntegrationConfiguration(objResponse.Response[3].integrationConnection);
	        _this.sharedData.setVersionAgent(objResponse.Response[3].version);
	        _this.sharedData.setCountry(objResponse.Response[3].idPais);
	        _this.sharedData.setIPfromAPI(objResponse.Response[4].Value);
	        _this.sharedData.setIPAddress(objResponse.Response[4].Value);
	        languageObject();
	      };
	      objectResponse.onError = function (messageError) {
	        console.error(messageError);
	      };
	    }
	  }]);

	  return helperLanguage;
	}();

/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.updateInfoWB = updateInfoWB;
	exports.callMark = callMark;
	exports.resetMarks = resetMarks;
	exports.deleteChatNotifications = deleteChatNotifications;
	
	var _constants = __webpack_require__(10);
	
	function updateInfoWB(workItem) {
	  return {
	    type: _constants.OTHER_ACTIONS.UPDATE_WB_INFO,
	    workBarAction: workItem
	  };
	}
	
	function callMark() {
	  return {
	    type: _constants.OTHER_ACTIONS.MARK_CALL
	  };
	}
	
	function resetMarks() {
	  return {
	    type: _constants.OTHER_ACTIONS.RESET_MARKS
	  };
	}
	function deleteChatNotifications() {
	  return {
	    type: _constants.OTHER_ACTIONS.DELETE_CHAT_NOTIFICATIONS
	  };
	}

/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.showDataTransferBySetting = exports.resetAssistedErrorTransfer = exports.assistedErrorTransfer = exports.resetTransfer = exports.bindTransfer = undefined;
	
	var _constants = __webpack_require__(10);
	
	var bindTransfer = exports.bindTransfer = function bindTransfer(payload) {
	    return {
	        type: _constants.TRANSFER_ACTIONS.BLIND_TRANSFER,
	        payload: payload
	    };
	};
	
	var resetTransfer = exports.resetTransfer = function resetTransfer() {
	    return {
	        type: _constants.TRANSFER_ACTIONS.RESET_BLIND_TRANSFER
	    };
	};
	
	var assistedErrorTransfer = exports.assistedErrorTransfer = function assistedErrorTransfer(payload) {
	    return {
	        type: _constants.TRANSFER_ACTIONS.ASSISTED_TRANSFER,
	        payload: payload
	    };
	};
	
	var resetAssistedErrorTransfer = exports.resetAssistedErrorTransfer = function resetAssistedErrorTransfer() {
	    return {
	        type: _constants.TRANSFER_ACTIONS.RESET_ASSISTED_TRANSFER
	    };
	};
	var showDataTransferBySetting = exports.showDataTransferBySetting = function showDataTransferBySetting(payload) {
	    return {
	        type: _constants.TRANSFER_ACTIONS.SHOW_DATA_TRANSGER_BY_SETTING,
	        payload: payload
	    };
	};

/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.changeState = changeState;
	
	var _constants = __webpack_require__(10);
	
	function changeState(newState) {
	  return {
	    type: _constants.USER_STATE.CHANGE_STATE,
	    currentState: newState
	  };
	}

/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.endConversation = undefined;
	
	var _constants = __webpack_require__(10);
	
	var _formats = __webpack_require__(54);
	
	var _globalComponentsLibrary = __webpack_require__(28);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initialUnifiedInboxState = {
		conversations: {
			0: {},
			1: {}
		},
		showWrapUp: false,
		wrapUpTime: 0,
		show: false,
		selected: { campType: undefined, convId: undefined },
		lastConversation: { campType: undefined, convId: 0 },
		selectedData: undefined,
		errorMMC: undefined,
		convsDeletedByError: [],
		campTypeConvsDeletedByError: undefined,
		draftMessages: {}
	};
	
	var getNewDictionary = function getNewDictionary(dictionary, campType, id, data, isNewMessage) {
		if (isNewMessage && campType != null && id || campType != null && id && dictionary[campType][id]) {
			return Object.assign({}, dictionary, _defineProperty({}, campType, Object.assign({}, dictionary[campType], _defineProperty({}, id, Object.assign({}, dictionary[campType][id], data)))));
		}
		return dictionary;
	};
	
	var removeConversation = function removeConversation(conversations, campType, id) {
		return Object.assign({}, conversations, _defineProperty({}, campType, (0, _globalComponentsLibrary.removeFromObject)(conversations[campType], id)));
	};
	
	var unifiedInboxState = function unifiedInboxState() {
		var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialUnifiedInboxState;
		var action = arguments[1];
	
		switch (action.type) {
			case _constants.ACTIONS_FROM_UNIFIED_INBOX.SHOW:
				return Object.assign({}, state, {
					show: action.show
				});
			case _constants.ACTIONS_FROM_UNIFIED_INBOX.NEW_CONVERSATION[0]:
			case _constants.ACTIONS_FROM_UNIFIED_INBOX.NEW_CONVERSATION[1]:
			case _constants.ACTIONS_FROM_UNIFIED_INBOX.NEW_CONVERSATION[2]:
			case _constants.ACTIONS_FROM_UNIFIED_INBOX.NEW_CONVERSATION[3]:
				var newConversation = {
					id: action.conversationId,
					type: action.type,
					totalTime: 0,
					initialTime: action.initialTime,
					messages: [],
					typing: false,
					takeover: false,
					clientTermination: false,
					IsAzure: action.IsAzure ? action.IsAzure : false,
					contact: {
						name: action.name,
						account: action.account,
						photo: action.photo
					},
					campaign: {
						id: action.acdId,
						name: action.acdName,
						graphicId: action.GraphicId,
						account: action.accountMail,
						timeoutWarning: action.timeoutWarning,
						timeout: action.timeout,
						senderName: action.senderName,
						type: action.campType,
						dispositions: [{ id: 1, text: 'exitoso' }, { id: 2, text: 'inconcluso' }, { id: 3, text: 'transferido' }],
						wrapUpTime: action.wrapUpTime * 1000
					},
					campType: action.campType
				};
	
				if (action.content) {
					newConversation.messages = action.content.map(function (i) {
						return {
							id: i.MessageID,
							content: i.Message,
							origin: action.origin,
							date: i.MsgTimestamp,
							subject: i.EmailSubject,
							media: action.media,
							seen: i.ExistedMessage,
							attachments: i.Attachments,
							campType: i.CampType,
							graphicId: i.GraphicId
						};
					});
				}
	
				if (action.TwitterMessagesList) {
					newConversation.campaign.image = action.TwitterMessagesList[0].CreatedByImage;
					newConversation.messages = action.TwitterMessagesList.map(function (tweet) {
						return {
							profileImage: tweet.CreatedByImage,
							content: tweet.Message,
							id: tweet.MessageID,
							media: tweet.Medias,
							date: new Date(tweet.CreatedAt)
						};
					});
				}
				return Object.assign({}, state, {
					showWrapUp: action.showWrapUp,
					wrapUpTime: action.wrapUpTime,
					conversations: getNewDictionary(state.conversations, action.campType, action.conversationId, newConversation, true)
				});
			case _constants.ACTIONS_FROM_UNIFIED_INBOX.EXTERNAL_MESSAGING_CUSTOMER:
				var newExternalMediaConversation = {
					id: action.conversationId,
					type: action.serviceType,
					totalTime: action.totalTime,
					initialTime: action.initialTime,
					messages: [],
					takeover: false,
					clientTermination: action.clientTermination,
					IsAzure: action.IsAzure ? action.IsAzure : false,
					exitWrapUpDisposition: action.campaign.ExitWrapUpDisposition,
					unreadMessage: true,
					statusConversation: action.SecTimeOutLastMessageAgent ? 'AGENT_READY' : 'NewConversation',
					SecTimeOutLastMessageAgent: action.SecTimeOutLastMessageAgent ? action.SecTimeOutLastMessageAgent : null,
					chatStarted: action.SecTimeOutLastMessageAgent || action.campaign.Type === 1 ? true : false,
					contact: {
						name: action.name,
						from: action.from ? action.from : '',
						to: action.to ? action.to : ''
						// account: action.account,
						// photo: action.photo
					},
					campaign: {
						id: action.campaign.ACDId ? action.campaign.ACDId : action.campaign.Id,
						name: action.campaign.ACDName ? action.campaign.ACDName : action.campaign.Name,
						graphicId: action.campaign.GraphicId,
						timeout: action.campaign.TimeOut * 60,
						timeoutWarning: action.campaign.TimeOut * 60 * (3 / 4),
						wrapUpTime: action.campaign.WrapUpTime * 1000,
						showWrapUp: action.showWrapUp,
						dispositions: [],
						type: action.campaign.Type
					},
					allowUnassign: action.allowUnassign,
					allowSpam: action.allowSpam,
					clientWithHistoricalChat: action.lastConversations.IsClientWithHistoricalChat,
					campType: action.campaign.Type,
					lastConversations: {
						lastIdSearched: action.lastConversations.LastConversationIdSearched,
						lastIdCampType: action.lastConversations.LastConversationIdCampType,
						conversationsDict: [].concat(_toConsumableArray(action.lastConversations.InboundConversationIds || []), _toConsumableArray(action.lastConversations.OutboundConversationIds || [])),
						isAllConversations: action.lastConversations.IsAllConversations,
						fetching: undefined
					}
				};
				if (action.content) {
					newExternalMediaConversation.messages = action.content.map(function (i) {
						return {
							id: i.Message_IdUI != null ? i.Message_IdUI : i.MessageId == null ? 1 : i.MessageId,
							messageId: i.MessageId != null ? i.MessageId : 1,
							conversationId: i.ConversationID ? i.ConversationID : 0,
							origin: i.OriginType === 1 ? 'ADMIN' : i.OriginType === 2 ? 'AGENT' : 'USER',
							originName: i.OriginName != null ? i.OriginName : null,
							fromAgent: i.FromAgent != null ? i.FromAgent : null,
							status: i.Status,
							date: i.Date ? i.Date : i.Timestamp ? new Date(i.Timestamp) : new Date(),
							content: i.Content,
							type: i.Type ? i.Type : 'text',
							attachments: {
								Caption: i.Attachments != null && i.Attachments.Caption != null ? i.Attachments.Caption : '',
								Url: i.Attachments != null && i.Attachments.Url != null ? i.Attachments.Url.replace(/\\/g, '/').replace(/ /g, '%20') : '',
								Name: i.Attachments ? i.Attachments.FileName : undefined,
								Size: i.Attachments ? i.Attachments.FileSize : undefined
							},
							location: i.Location != null ? i.Location : '',
							seen: false,
							campType: i.CampType,
							graphicId: i.GraphicId
						};
					});
				}
				if (action.campaign.Dispositions) {
					newExternalMediaConversation.campaign.dispositions = Object.values(action.campaign.Dispositions).map(function (disposition) {
						return {
							id: disposition.Id,
							text: disposition.Description,
							endConversation: disposition.EndConversation,
							subDispositions: Array.isArray(disposition.SubDisposition) ? disposition.SubDisposition.map(function (sub) {
								return Object.assign({}, sub, {
									id: sub.Id,
									text: sub.Description,
									endConversation: sub.EndConversation
								});
							}) : Object.keys(disposition.SubDisposition).length === 0 ? undefined : Object.values(disposition.SubDisposition).map(function (sub) {
								return Object.assign({}, sub, {
									id: sub.Id,
									text: sub.Description,
									endConversation: sub.EndConversation
								});
							})
						};
					});
				}
	
				return Object.assign({}, state, {
					showWrapUp: action.showWrapUp,
					wrapUpTime: action.campaign.WrapUpTime * 1000,
					conversations: getNewDictionary(state.conversations, newExternalMediaConversation.campType, action.conversationId, newExternalMediaConversation, true)
				});
			case _constants.ACTIONS_FROM_UNIFIED_INBOX.MULTIMEDIA_MESSAGE_ERROR_MMC:
				var attendedConversations = {};
				for (var campType in state.conversations) {
					for (var convId in state.conversations[campType]) {
						if (state.conversations[campType][convId].chatStarted || state.conversations[campType][convId].type !== "WHATSAPP") {
							attendedConversations[campType][convId] = state.conversations[campType][convId];
						}
					}
				}
				return Object.assign({}, state, {
					errorMMC: action.value,
					conversations: action.value ? attendedConversations : state.conversations
				});
			case _constants.ACTIONS_FROM_UNIFIED_INBOX.TYPING:
				if (state.conversations[action.campType][action.conversationId]) {
					return Object.assign({}, state, {
						conversations: getNewDictionary(state.conversations, action.campType, action.conversationId, { typing: action.typing })
					});
				} else {
					return state;
				}
			case _constants.ACTIONS_FROM_UNIFIED_INBOX.SELECT_CONVERSATION:
				return Object.assign({}, state, {
					selected: { campType: action.campType, convId: action.selectedID }
				});
			case _constants.ACTIONS_FROM_UNIFIED_INBOX.ACEPTED_CHAT:
				return Object.assign({}, state, {
					conversations: getNewDictionary(state.conversations, state.selected.campType, state.selected.convId, {
						chatStarted: true,
						initialTime: new Date()
					})
				});
			case _constants.ACTIONS_FROM_UNIFIED_INBOX.END_CONVERSATION:
				if (!action.data.ShowWrapUp && action.data.MediaType > 4) {
					return Object.assign({}, state, { conversations: removeConversation(state.conversations, action.data.CampType, action.data.ConversationId) });
				}
				if (state.lastConversation.campType != null && state.conversations[state.lastConversation.campType][state.lastConversation.convId]) {
					return Object.assign({}, state, { lastConversation: { campType: undefined, convId: 0 }, conversations: removeConversation(state.conversations, action.data.CampType, action.data.ConversationId) });
				}
				return Object.assign({}, state, { lastConversation: { campType: action.data.CampType, convId: action.data.ConversationId } });
	
			case _constants.ACTIONS_FROM_UNIFIED_INBOX.SPAM_CONVERSATION:
				return Object.assign({}, state, { lastConversation: { campType: undefined, convId: 0 }, conversations: removeConversation(state.conversations, action.data.campType, action.data.conversationId) });
	
			case _constants.ACTIONS_FROM_UNIFIED_INBOX.UNASSIGN_CONVERSATION:
				return Object.assign({}, state, { lastConversation: { campType: undefined, convId: 0 }, conversations: removeConversation(state.conversations, action.data.campType, action.data.conversationId) });
	
			case _constants.ACTIONS_FROM_UNIFIED_INBOX.DISCARD_CONVERSATION:
				return Object.assign({}, state, { conversations: removeConversation(state.conversations, action.data.campType, action.data.conversationId) });
	
			// case ACTIONS_FROM_UNIFIED_INBOX.SEND_UNIFIED_RESPONSE:
			// 	if (action.data.MediaType === 2) {
			// 		return { ...state, conversations: removeConversation(state.conversations, action.data.CamType, action.data.ConversationId) };
			// 	} else {
			// 		return state;
			// 	}
			// case MESSAGES_TO_SM.SEND_DISPOSITION:
			// 	if (action.data.closeModal) {
			// 		const currentconversation = state.conversations[action.data.conversationId];
			// 		if (currentconversation.type === 'CHAT') {
			// 			const { [action.data.conversationId]: temp6, ...newConversations6 } = state.conversations;
			// 			delete newConversations6[action.data.conversationId];
			// 			return { ...state, lastIdConversationEnd: 0, conversations: newConversations6 };
			// 		}
			// 	}
			// 	return { ...state }; 
	
			case _constants.ACTIONS_FROM_UNIFIED_INBOX.CHAT_CUSTOMER_TERMINATION:
				var conversation = state.conversations[action.campType][action.conversationId];
				if (conversation && !conversation.clientTermination) {
					return Object.assign({}, state, { conversations: removeConversation(state.conversations, action.campType, action.conversationId) });
				} else {
					return Object.assign({}, state);
				}
	
			case _constants.ACTIONS_FROM_UNIFIED_INBOX.NEW_MESSAGE_INBOX[0]:
			case _constants.ACTIONS_FROM_UNIFIED_INBOX.NEW_MESSAGE_INBOX[1]:
			case _constants.ACTIONS_FROM_UNIFIED_INBOX.NEW_MESSAGE_INBOX[2]:
			case _constants.ACTIONS_FROM_UNIFIED_INBOX.NEW_MESSAGE_INBOX[3]:
				{
					var _newMessage = {
						conversationId: action.conversationId,
						content: action.content,
						origin: action.origin,
						date: action.date,
						subject: action.subject,
						type: action.media.toLowerCase(),
						attachments: action.media.toLowerCase() !== "text" ? {
							Caption: '',
							Url: action.content.replace("\\", "/")
						} : null,
						seen: action.origin !== 'AGENT' && action.conversationId !== state.selected.convId ? false : true,
						campType: action.CampType,
						graphicId: action.GraphicId
					};
					return Object.assign({}, state, {
						conversations: getNewDictionary(state.conversations, action.campType, action.conversationId, { messages: [].concat(_toConsumableArray(state.conversations[action.campType][action.conversationId].messages), [_newMessage]) })
					});
				}
			case _constants.ACTIONS_FROM_UNIFIED_INBOX.EXTERNAL_NEW_MESSAGING:
				var newMessage = Array.isArray(action.messagesList) ? action.messagesList.map(function (e) {
					return {
						id: e.Message_IdUI,
						content: e.Content,
						date: new Date(),
						origin: e.OriginType === 1 ? 'ADMIN' : e.OriginType === 2 ? 'AGENT' : 'USER',
						originName: e.OriginName != null ? e.OriginName : null,
						fromAgent: e.FromAgent != null ? e.FromAgent : null,
						status: e.Status ? e.Status : 'send',
						type: e.Type ? e.Type : 'text',
						attachments: e.Attachments,
						location: e.Location,
						conversationId: e.ConversationID ? e.ConversationID : 0,
						campType: action.campType,
						graphicId: action.graphicId
					};
				})[0] : {
					id: action.messageId,
					content: action.content,
					date: action.date,
					origin: action.origin === 1 ? 'ADMIN' : action.origin === 2 ? 'AGENT' : 'USER',
					originName: action.OriginName != null ? action.OriginName : null,
					fromAgent: action.FromAgent != null ? action.FromAgent : null,
					status: action.status,
					type: action.MessageType,
					attachments: action.Attachments,
					conversationId: action.conversationId,
					campType: action.campType,
					graphicId: action.graphicId
				};
				return Object.assign({}, state, {
					conversations: getNewDictionary(state.conversations, action.campType, action.conversationId, {
						unreadMessage: action.conversationId === state.selected.convId || action.origin === 2 ? false : true,
						messages: [].concat(_toConsumableArray(state.conversations[action.campType][action.conversationId].messages), [newMessage])
					})
				});
			case 'CHANGE_STATE_EXTERL_MESSAGE':
				return Object.assign({}, state, {
					conversations: getNewDictionary(state.conversations, action.campType, action.conversationId, { unreadMessage: action.unreadMessage })
				});
			case _constants.ACTIONS_FROM_UNIFIED_INBOX.CHAT_TAKEOVER:
				if (state.conversations[action.conversationId]) {
					return Object.assign({}, state, {
						conversations: getNewDictionary(state.conversations, action.campType, action.conversationId, { takeover: action.takeover })
					});
				} else {
					return state;
				}
	
			case _constants.ACTIONS_FROM_UNIFIED_INBOX.ANSWERS_TEMPLATES_CHAT:
				var newTemplates = action.answers.map(function (answer) {
					return { title: (0, _formats.decodeUnescapedStr)(answer.description), text: (0, _formats.decodeUnescapedStr)(answer.message), id: answer.message_id };
				});
				return Object.assign({}, state, {
					conversations: getNewDictionary(state.conversations, action.campType, action.conversationId, { templates: newTemplates, maxImgChat: action.maxImgChat })
				});
			case _constants.ACTIONS_FROM_UNIFIED_INBOX.LOGOUT:
				state = initialUnifiedInboxState;
				return Object.assign({}, state);
			case _constants.ACTIONS_FROM_UNIFIED_INBOX.MULTIMEDIA_DISPOSITION:
				var dispositions = Object.values(action.dispositions).map(function (disposition) {
					return Object.assign({}, disposition, {
						id: disposition.Id,
						text: disposition.Description,
						endConversation: disposition.EndConversation,
						subDispositions: Object.keys(disposition.SubDisposition).length === 0 ? undefined : Object.values(disposition.SubDisposition).map(function (sub) {
							return Object.assign({}, sub, {
								id: sub.Id,
								text: sub.Description,
								endConversation: sub.EndConversation
							});
						})
					});
				});
				return Object.assign({}, state, {
					conversations: getNewDictionary(state.conversations, action.campType, action.conversationId, { campaign: Object.assign({}, state.conversations[action.campType][action.conversationId].campaign, { dispositions: dispositions }) })
				});
	
			case _constants.ACTIONS_FROM_UNIFIED_INBOX.CHAT_CLIENT_DISCONNECT:
				if (state.conversations[action.campType][action.conversationId]) {
					return Object.assign({}, state, {
						conversations: getNewDictionary(state.conversations, action.campType, action.conversationId, { clientTermination: action.clientTermination })
					});
				} else {
					return state;
				}
			case 'MULTIMEDIA_MESSAGE_STATUS':
				if (state.conversations[action.campType][action.conversationId]) {
					var messages = state.conversations[action.campType][action.conversationId].messages;
	
					var index = messages.findIndex(function (i) {
						return i.id === parseInt(action.messageId) && i.conversationId === action.conversationId;
					});
					var msg = messages[index];
					return Object.assign({}, state, {
						conversations: getNewDictionary(state.conversations, action.campType, action.conversationId, {
							messages: (0, _globalComponentsLibrary.updateArrayImmutably)(messages, index, Object.assign({}, msg, { status: msg.status !== 'read' ? action.status : 'read', messageId: action.messageId }))
						})
					});
				}
				return state;
			case _constants.ACTIONS_FROM_UNIFIED_INBOX.CHANGE_STATE_MULTIMEDIA:
				state.selectedData = action.data;
				if (action.data.onReady) {
					return Object.assign({}, state, {
						conversations: getNewDictionary(state.conversations, action.data.CamType, action.data.ConversationId, { statusConversation: 'AGENT_READY' })
					});
				} else return state;
			case _constants.ACTIONS_FROM_UNIFIED_INBOX.CHANGE_STATE_MULTIMEDIA_ALL:
				return Object.assign({}, state, {
					selectedData: action.data
				});
			case _constants.ACTIONS_FROM_UNIFIED_INBOX.CHANGE_STATE:
				if (state.conversations && state.selected.convId && state.selected.campType != null && state.conversations[state.selected.campType][state.selected.convId] && action.currentState) {
					return Object.assign({}, state, {
						conversations: getNewDictionary(state.conversations, state.selected.campType, state.selected.convId, { statusConversation: action.currentState })
					});
				} else return state;
			case _constants.ACTIONS_FROM_UNIFIED_INBOX.CONVERSATION_TIMEOUT_REACHED:
				if (state.conversations && state.conversations[action.campType][action.conversationId]) {
					return Object.assign({}, state, {
						conversations: getNewDictionary(state.conversations, action.campType, action.conversationId, { timeoutReached: true })
					});
				} else return state;
			case _constants.ACTIONS_FROM_UNIFIED_INBOX.END_CONVERSATIONS_CAMPAIGN_DELETED:
				if (state.conversations && action.conversationIds && action.campType != null) {
					var actionConvs = action.conversationIds.split(',');
					return Object.assign({}, state, { convsDeletedByError: actionConvs, campTypeConvsDeletedByError: action.campType });
				} else return state;
			case _constants.ACTIONS_FROM_UNIFIED_INBOX.UPDATE_CONVS_DELETED_BY_ERROR:
				if (state.convsDeletedByError && state.convsDeletedByError.length > 0 && state.campTypeConvsDeletedByError != null) {
					var newConversations = Object.assign({}, state.conversations);
					delete newConversations[state.campTypeConvsDeletedByError];
					newConversations[state.campTypeConvsDeletedByError] = {};
					for (var key in state.conversations[state.campTypeConvsDeletedByError]) {
						if (!state.convsDeletedByError.includes(key)) {
							newConversations[state.campTypeConvsDeletedByError] = Object.assign({}, newConversations[state.campTypeConvsDeletedByError], _defineProperty({}, key, state.conversations[state.campTypeConvsDeletedByError][key]));
						}
					}
					return Object.assign({}, state, { conversations: newConversations, convsDeletedByError: [], campTypeConvsDeletedByError: undefined });
				} else return state;
			case _constants.ACTIONS_FROM_UNIFIED_INBOX.NEW_HISTORICAL_CONVERSATION:
				if (state.conversations && state.conversations[action.campType][action.conversationId]) {
					var newHistoricalConversation = action.lastConversation.Messages.map(function (e) {
						return {
							id: e.Message_IdUI,
							conversationId: e.ConversationID ? e.ConversationID : 0,
							content: e.Content,
							date: e.Date ? e.Date : e.Timestamp ? Date.parse(e.Timestamp) : new Date(),
							origin: e.OriginType === 1 ? 'ADMIN' : e.OriginType === 2 ? 'AGENT' : 'USER',
							originName: e.OriginName != null ? e.OriginName : null,
							fromAgent: e.FromAgent != null ? e.FromAgent : null,
							status: e.Status ? e.Status : 'send',
							type: e.Type ? e.Type : 'text',
							attachments: {
								Caption: e.Attachments != null && e.Attachments.Caption != null ? e.Attachments.Caption : '',
								Url: e.Attachments != null && e.Attachments.Url != null ? e.Attachments.Url.replace(/\\/g, '/').replace(/ /g, '%20') : ''
							},
							location: e.Location != null ? e.Location : '',
							campType: e.campType,
							graphicId: e.graphicId
	
						};
					});
					return Object.assign({}, state, {
						// conversations: {
						// 	...state.conversations,
						// 	[action.conversationId]: {
						// 		...state.conversations[action.conversationId],
						// 		messages: [...newHistoricalConversation, ...state.conversations[action.conversationId].messages],
						// 		lastConversations: {
						// ...state.conversations[action.conversationId].lastConversations,
						// lastIdSearched: action.lastConversationId,
						// isAllConversations: action.lastConversationId === state.conversations[action.conversationId].lastConversations.conversationsDict[0].ConversationId ? true : false,
						// fetching: false
						// 		}
						// 	}
						// }
						conversations: getNewDictionary(state.conversations, action.campType, action.conversationId, {
							messages: [].concat(_toConsumableArray(newHistoricalConversation), _toConsumableArray(state.conversations[action.campType][action.conversationId].messages)),
							lastConversations: Object.assign({}, state.conversations[action.campType][action.conversationId].lastConversations, {
								lastIdSearched: action.lastConversationId,
								lastIdCampType: action.lastConversation.LastConversations.LastConversationIdCampType,
								isAllConversations: action.lastConversation.LastConversations.IsAllConversations,
								fetching: false
							})
						})
					});
				} else return state;
			case _constants.ACTIONS_FROM_UNIFIED_INBOX.ERROR_HISTORICAL_CONVERSATION:
				if (state.conversations && state.conversations[action.campType][action.conversationId]) {
					return Object.assign({}, state, {
						// conversations: {
						// 	...state.conversations,
						// 	[action.conversationId]: {
						// 		...state.conversations[action.conversationId],
						// 		lastConversations: {
						// 			...state.conversations[action.conversationId].lastConversations,
						// 			isAllConversations: action.lastConversationId === state.conversations[action.conversationId].lastConversations.conversationsDict[0].ConversationId ? true : false,
						// 			lastIdSearched: action.lastConversationId,
						// 			fetching: false
						// 		}
						// 	}
						// }
						conversations: getNewDictionary(state.conversations, action.campType, action.conversationId, {
							lastConversations: Object.assign({}, state.conversations[action.campType][action.conversationId].lastConversations, {
								isAllConversations: action.isAllConversations,
								lastIdSearched: action.lastConversationId,
								fetching: false
							})
						})
					});
				} else return state;
			case _constants.ACTIONS_FROM_UNIFIED_INBOX.FETCHING_CONVERSATION:
				if (state.conversations && state.conversations[action.campType][action.conversationId]) {
					return Object.assign({}, state, {
						// conversations: {
						// 	...state.conversations,
						// 	[action.conversationId]: {
						// 		...state.conversations[action.conversationId],
						// 		lastConversations: {
						// 			...state.conversations[action.conversationId].lastConversations,
						// 			fetching: action.fetching
						// 		}
						// 	}
						// }
						conversations: getNewDictionary(state.conversations, action.campType, action.conversationId, {
							lastConversations: Object.assign({}, state.conversations[action.campType][action.conversationId].lastConversations, {
								fetching: action.fetching
							})
						})
					});
				} else return state;
			case _constants.ACTIONS_FROM_UNIFIED_INBOX.RESET_TIMEOUT:
				if (state.conversations && state.conversations[action.campType][action.conversationId]) {
					return Object.assign({}, state, {
						conversations: getNewDictionary(state.conversations, action.campType, action.conversationId, {
							SecTimeOutLastMessageAgent: null
						})
					});
				} else return state;
			case _constants.ACTIONS_FROM_UNIFIED_INBOX.UPDATE_PERMISSION:
				if (state.conversations) {
					var convsTmp = {};
					for (var _campType in state.conversations) {
						for (var _convId in state.conversations[_campType]) {
							convsTmp[_campType][_convId] = Object.assign({}, state.conversations[_campType][_convId], {
								allowUnassign: action.permissionName === _constants.UNIFIED_INBOX_PERMISSIONS.AllowUnassign ? action.permissionValue : state.conversations[_campType][_convId].allowUnassign,
								allowSpam: action.permissionName === _constants.UNIFIED_INBOX_PERMISSIONS.AllowSpam ? action.permissionValue : state.conversations[_campType][_convId].allowSpam
							});
						}
					}
					return Object.assign({}, state, {
						conversations: convsTmp
					});
				}
				return state;
			case _constants.ACTIONS_FROM_UNIFIED_INBOX.NEW_DRAFT_MESSAGE:
				return Object.assign({}, state, {
					draftMessages: Object.assign({}, state.draftMessages, _defineProperty({}, action.id, {
						messageId: action.id,
						data: [{
							type: 'paragraph',
							children: [{ text: '', font: 'Arial', size: '14px' }]
						}],
						attachments: []
					}))
				});
			case _constants.ACTIONS_FROM_UNIFIED_INBOX.UPDATE_DRAFT_MESSAGE:
				return Object.assign({}, state, {
					draftMessages: Object.assign({}, state.draftMessages, _defineProperty({}, action.id, Object.assign({}, state.draftMessages[action.id], {
						data: action.data
					})))
				});
			case _constants.ACTIONS_FROM_UNIFIED_INBOX.UPDATE_DRAFT_ATTACHMENTS:
				return Object.assign({}, state, {
					draftMessages: Object.assign({}, state.draftMessages, _defineProperty({}, action.id, Object.assign({}, state.draftMessages[action.id], {
						attachments: action.data
					})))
				});
			case _constants.ACTIONS_FROM_UNIFIED_INBOX.DELETE_DRAFT_MESSAGE:
				return Object.assign({}, state, {
					draftMessages: Object.assign({}, state.draftMessages, _defineProperty({}, action.id, Object.assign({}, state.draftMessages[action.id], {
						data: [{
							type: 'paragraph',
							children: [{ text: '', font: 'Arial', size: '14px' }]
						}],
						attachments: []
					})))
				});
			case _constants.ACTIONS_FROM_UNIFIED_INBOX.UPDATE_CONVERSATIONS_PHONE_CHANGE:
				if (state.conversations && action.conversationIds && action.campType != null) {
					var _actionConvs = action.conversationIds.split(',');
					var newConvs = Object.assign({}, state.conversations);
					delete newConvs[action.campType];
					newConvs[action.campType] = {};
					for (var _key in state.conversations[action.campType]) {
						newConvs[action.campType][_key] = Object.assign({}, state.conversations[action.campType][_key], {
							disabledUnassign: _actionConvs.includes(_key)
						});
					}
					return Object.assign({}, state, { conversations: newConvs });
				} else return state;
			case _constants.ACTIONS_FROM_UNIFIED_INBOX.CHAT_CONVERSATION_READ:
				return Object.assign({}, state, {
					conversations: getNewDictionary(state.conversations, action.campType, action.id, {
						messages: state.conversations[action.campType][action.idConversation].messages.map(function (v) {
							return Object.assign({}, v, {
								seen: true
							});
						})
					})
				});
			default:
				return state;
		}
	};
	
	exports.default = unifiedInboxState;
	var endConversation = exports.endConversation = function endConversation(data) {
		return { type: _constants.ACTIONS_FROM_UNIFIED_INBOX.END_CONVERSATION, data: data };
	};

/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1196);


/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1223), __esModule: true };

/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1225), __esModule: true };

/***/ },
/* 518 */
/***/ function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function getLens (b64) {
	  var len = b64.length
	
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // Trim off extra bytes after placeholder bytes are found
	  // See: https://github.com/beatgammit/base64-js/issues/42
	  var validLen = b64.indexOf('=')
	  if (validLen === -1) validLen = len
	
	  var placeHoldersLen = validLen === len
	    ? 0
	    : 4 - (validLen % 4)
	
	  return [validLen, placeHoldersLen]
	}
	
	// base64 is 4/3 + up to two characters of the original data
	function byteLength (b64) {
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function _byteLength (b64, validLen, placeHoldersLen) {
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function toByteArray (b64) {
	  var tmp
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	
	  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))
	
	  var curByte = 0
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  var len = placeHoldersLen > 0
	    ? validLen - 4
	    : validLen
	
	  var i
	  for (i = 0; i < len; i += 4) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 18) |
	      (revLookup[b64.charCodeAt(i + 1)] << 12) |
	      (revLookup[b64.charCodeAt(i + 2)] << 6) |
	      revLookup[b64.charCodeAt(i + 3)]
	    arr[curByte++] = (tmp >> 16) & 0xFF
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 2) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 2) |
	      (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 1) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 10) |
	      (revLookup[b64.charCodeAt(i + 1)] << 4) |
	      (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] +
	    lookup[num >> 12 & 0x3F] +
	    lookup[num >> 6 & 0x3F] +
	    lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp =
	      ((uint8[i] << 16) & 0xFF0000) +
	      ((uint8[i + 1] << 8) & 0xFF00) +
	      (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 2] +
	      lookup[(tmp << 4) & 0x3F] +
	      '=='
	    )
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 10] +
	      lookup[(tmp >> 4) & 0x3F] +
	      lookup[(tmp << 2) & 0x3F] +
	      '='
	    )
	  }
	
	  return parts.join('')
	}


/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <https://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(518)
	var ieee754 = __webpack_require__(722)
	var customInspectSymbol =
	  (typeof Symbol === 'function' && typeof Symbol['for'] === 'function') // eslint-disable-line dot-notation
	    ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
	    : null
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	var K_MAX_LENGTH = 0x7fffffff
	exports.kMaxLength = K_MAX_LENGTH
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
	 *               implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * We report that the browser does not support typed arrays if the are not subclassable
	 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
	 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
	 * for __proto__ and has a buggy typed array implementation.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport()
	
	if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' &&
	    typeof console.error === 'function') {
	  console.error(
	    'This browser lacks typed array (Uint8Array) support which is required by ' +
	    '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.'
	  )
	}
	
	function typedArraySupport () {
	  // Can typed array instances can be augmented?
	  try {
	    var arr = new Uint8Array(1)
	    var proto = { foo: function () { return 42 } }
	    Object.setPrototypeOf(proto, Uint8Array.prototype)
	    Object.setPrototypeOf(arr, proto)
	    return arr.foo() === 42
	  } catch (e) {
	    return false
	  }
	}
	
	Object.defineProperty(Buffer.prototype, 'parent', {
	  enumerable: true,
	  get: function () {
	    if (!Buffer.isBuffer(this)) return undefined
	    return this.buffer
	  }
	})
	
	Object.defineProperty(Buffer.prototype, 'offset', {
	  enumerable: true,
	  get: function () {
	    if (!Buffer.isBuffer(this)) return undefined
	    return this.byteOffset
	  }
	})
	
	function createBuffer (length) {
	  if (length > K_MAX_LENGTH) {
	    throw new RangeError('The value "' + length + '" is invalid for option "size"')
	  }
	  // Return an augmented `Uint8Array` instance
	  var buf = new Uint8Array(length)
	  Object.setPrototypeOf(buf, Buffer.prototype)
	  return buf
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new TypeError(
	        'The "string" argument must be of type string. Received type number'
	      )
	    }
	    return allocUnsafe(arg)
	  }
	  return from(arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	function from (value, encodingOrOffset, length) {
	  if (typeof value === 'string') {
	    return fromString(value, encodingOrOffset)
	  }
	
	  if (ArrayBuffer.isView(value)) {
	    return fromArrayView(value)
	  }
	
	  if (value == null) {
	    throw new TypeError(
	      'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
	      'or Array-like Object. Received type ' + (typeof value)
	    )
	  }
	
	  if (isInstance(value, ArrayBuffer) ||
	      (value && isInstance(value.buffer, ArrayBuffer))) {
	    return fromArrayBuffer(value, encodingOrOffset, length)
	  }
	
	  if (typeof SharedArrayBuffer !== 'undefined' &&
	      (isInstance(value, SharedArrayBuffer) ||
	      (value && isInstance(value.buffer, SharedArrayBuffer)))) {
	    return fromArrayBuffer(value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'number') {
	    throw new TypeError(
	      'The "value" argument must not be of type number. Received type number'
	    )
	  }
	
	  var valueOf = value.valueOf && value.valueOf()
	  if (valueOf != null && valueOf !== value) {
	    return Buffer.from(valueOf, encodingOrOffset, length)
	  }
	
	  var b = fromObject(value)
	  if (b) return b
	
	  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null &&
	      typeof value[Symbol.toPrimitive] === 'function') {
	    return Buffer.from(
	      value[Symbol.toPrimitive]('string'), encodingOrOffset, length
	    )
	  }
	
	  throw new TypeError(
	    'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
	    'or Array-like Object. Received type ' + (typeof value)
	  )
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(value, encodingOrOffset, length)
	}
	
	// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
	// https://github.com/feross/buffer/pull/148
	Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype)
	Object.setPrototypeOf(Buffer, Uint8Array)
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be of type number')
	  } else if (size < 0) {
	    throw new RangeError('The value "' + size + '" is invalid for option "size"')
	  }
	}
	
	function alloc (size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpreted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(size).fill(fill, encoding)
	      : createBuffer(size).fill(fill)
	  }
	  return createBuffer(size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(size, fill, encoding)
	}
	
	function allocUnsafe (size) {
	  assertSize(size)
	  return createBuffer(size < 0 ? 0 : checked(size) | 0)
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(size)
	}
	
	function fromString (string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('Unknown encoding: ' + encoding)
	  }
	
	  var length = byteLength(string, encoding) | 0
	  var buf = createBuffer(length)
	
	  var actual = buf.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    buf = buf.slice(0, actual)
	  }
	
	  return buf
	}
	
	function fromArrayLike (array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  var buf = createBuffer(length)
	  for (var i = 0; i < length; i += 1) {
	    buf[i] = array[i] & 255
	  }
	  return buf
	}
	
	function fromArrayView (arrayView) {
	  if (isInstance(arrayView, Uint8Array)) {
	    var copy = new Uint8Array(arrayView)
	    return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength)
	  }
	  return fromArrayLike(arrayView)
	}
	
	function fromArrayBuffer (array, byteOffset, length) {
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('"offset" is outside of buffer bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('"length" is outside of buffer bounds')
	  }
	
	  var buf
	  if (byteOffset === undefined && length === undefined) {
	    buf = new Uint8Array(array)
	  } else if (length === undefined) {
	    buf = new Uint8Array(array, byteOffset)
	  } else {
	    buf = new Uint8Array(array, byteOffset, length)
	  }
	
	  // Return an augmented `Uint8Array` instance
	  Object.setPrototypeOf(buf, Buffer.prototype)
	
	  return buf
	}
	
	function fromObject (obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    var buf = createBuffer(len)
	
	    if (buf.length === 0) {
	      return buf
	    }
	
	    obj.copy(buf, 0, 0, len)
	    return buf
	  }
	
	  if (obj.length !== undefined) {
	    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
	      return createBuffer(0)
	    }
	    return fromArrayLike(obj)
	  }
	
	  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
	    return fromArrayLike(obj.data)
	  }
	}
	
	function checked (length) {
	  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= K_MAX_LENGTH) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return b != null && b._isBuffer === true &&
	    b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
	}
	
	Buffer.compare = function compare (a, b) {
	  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength)
	  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength)
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError(
	      'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
	    )
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!Array.isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (isInstance(buf, Uint8Array)) {
	      if (pos + buf.length > buffer.length) {
	        Buffer.from(buf).copy(buffer, pos)
	      } else {
	        Uint8Array.prototype.set.call(
	          buffer,
	          buf,
	          pos
	        )
	      }
	    } else if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    } else {
	      buf.copy(buffer, pos)
	    }
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    throw new TypeError(
	      'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
	      'Received type ' + typeof string
	    )
	  }
	
	  var len = string.length
	  var mustMatch = (arguments.length > 2 && arguments[2] === true)
	  if (!mustMatch && len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) {
	          return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
	        }
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
	// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
	// reliably in a browserify context because there could be multiple different
	// copies of the 'buffer' package in use. This method works even for Buffer
	// instances that were created from another copy of the `buffer` package.
	// See: https://github.com/feross/buffer/issues/154
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.toLocaleString = Buffer.prototype.toString
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim()
	  if (this.length > max) str += ' ... '
	  return '<Buffer ' + str + '>'
	}
	if (customInspectSymbol) {
	  Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (isInstance(target, Uint8Array)) {
	    target = Buffer.from(target, target.offset, target.byteLength)
	  }
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError(
	      'The "target" argument must be one of type Buffer or Uint8Array. ' +
	      'Received type ' + (typeof target)
	    )
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset // Coerce to Number.
	  if (numberIsNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  var strLen = string.length
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (numberIsNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset >>> 0
	    if (isFinite(length)) {
	      length = length >>> 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return asciiWrite(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF)
	      ? 4
	      : (firstByte > 0xDF)
	          ? 3
	          : (firstByte > 0xBF)
	              ? 2
	              : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += hexSliceLookupTable[buf[i]]
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
	  for (var i = 0; i < bytes.length - 1; i += 2) {
	    res += String.fromCharCode(bytes[i] + (bytes[i + 1] * 256))
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf = this.subarray(start, end)
	  // Return an augmented `Uint8Array` instance
	  Object.setPrototypeOf(newBuf, Buffer.prototype)
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUintLE =
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset >>> 0
	  byteLength = byteLength >>> 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUintBE =
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset >>> 0
	  byteLength = byteLength >>> 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUint8 =
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUint16LE =
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUint16BE =
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUint32LE =
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUint32BE =
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset >>> 0
	  byteLength = byteLength >>> 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset >>> 0
	  byteLength = byteLength >>> 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUintLE =
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  byteLength = byteLength >>> 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUintBE =
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  byteLength = byteLength >>> 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUint8 =
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeUint16LE =
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  this[offset] = (value & 0xff)
	  this[offset + 1] = (value >>> 8)
	  return offset + 2
	}
	
	Buffer.prototype.writeUint16BE =
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  this[offset] = (value >>> 8)
	  this[offset + 1] = (value & 0xff)
	  return offset + 2
	}
	
	Buffer.prototype.writeUint32LE =
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  this[offset + 3] = (value >>> 24)
	  this[offset + 2] = (value >>> 16)
	  this[offset + 1] = (value >>> 8)
	  this[offset] = (value & 0xff)
	  return offset + 4
	}
	
	Buffer.prototype.writeUint32BE =
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  this[offset] = (value >>> 24)
	  this[offset + 1] = (value >>> 16)
	  this[offset + 2] = (value >>> 8)
	  this[offset + 3] = (value & 0xff)
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) {
	    var limit = Math.pow(2, (8 * byteLength) - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) {
	    var limit = Math.pow(2, (8 * byteLength) - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  this[offset] = (value & 0xff)
	  this[offset + 1] = (value >>> 8)
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  this[offset] = (value >>> 8)
	  this[offset + 1] = (value & 0xff)
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  this[offset] = (value & 0xff)
	  this[offset + 1] = (value >>> 8)
	  this[offset + 2] = (value >>> 16)
	  this[offset + 3] = (value >>> 24)
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  this[offset] = (value >>> 24)
	  this[offset + 1] = (value >>> 16)
	  this[offset + 2] = (value >>> 8)
	  this[offset + 3] = (value & 0xff)
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer')
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('Index out of range')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	
	  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
	    // Use built-in when available, missing from IE11
	    this.copyWithin(targetStart, start, end)
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, end),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if ((encoding === 'utf8' && code < 128) ||
	          encoding === 'latin1') {
	        // Fast path: If `val` fits into a single byte, use that numeric value.
	        val = code
	      }
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  } else if (typeof val === 'boolean') {
	    val = Number(val)
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : Buffer.from(val, encoding)
	    var len = bytes.length
	    if (len === 0) {
	      throw new TypeError('The value "' + val +
	        '" is invalid for argument "value"')
	    }
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node takes equal signs as end of the Base64 encoding
	  str = str.split('=')[0]
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = str.trim().replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
	// the `instanceof` check but they should be treated as of that type.
	// See: https://github.com/feross/buffer/issues/166
	function isInstance (obj, type) {
	  return obj instanceof type ||
	    (obj != null && obj.constructor != null && obj.constructor.name != null &&
	      obj.constructor.name === type.name)
	}
	function numberIsNaN (obj) {
	  // For IE11 support
	  return obj !== obj // eslint-disable-line no-self-compare
	}
	
	// Create lookup table for `toString('hex')`
	// See: https://github.com/feross/buffer/issues/219
	var hexSliceLookupTable = (function () {
	  var alphabet = '0123456789abcdef'
	  var table = new Array(256)
	  for (var i = 0; i < 16; ++i) {
	    var i16 = i * 16
	    for (var j = 0; j < 16; ++j) {
	      table[i16 + j] = alphabet[i] + alphabet[j]
	    }
	  }
	  return table
	})()
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2191).Buffer))

/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(218);
	
	var callBind = __webpack_require__(338);
	
	var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));
	
	module.exports = function callBoundIntrinsic(name, allowMissing) {
		var intrinsic = GetIntrinsic(name, !!allowMissing);
		if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
			return callBind(intrinsic);
		}
		return intrinsic;
	};


/***/ },
/* 521 */
[2630, 160, 103],
/* 522 */
[2634, 116, 196, 521],
/* 523 */
[2635, 339],
/* 524 */
[2640, 242, 102, 529, 159, 197, 1240, 345, 1247, 88],
/* 525 */
[2647, 199, 200, 134, 349, 132, 522, 116],
/* 526 */
[2649, 527, 342],
/* 527 */
[2651, 132, 134, 1232, 346],
/* 528 */
[2653, 116, 198, 134, 199],
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(159);


/***/ },
/* 530 */
[2661, 348],
/* 531 */
[2673, 1249, 524],
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	var cof = __webpack_require__(104);
	module.exports = function (it, msg) {
	  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
	  return +it;
	};


/***/ },
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	var toObject = __webpack_require__(65);
	var toAbsoluteIndex = __webpack_require__(142);
	var toLength = __webpack_require__(47);
	
	module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
	  var O = toObject(this);
	  var len = toLength(O.length);
	  var to = toAbsoluteIndex(target, len);
	  var from = toAbsoluteIndex(start, len);
	  var end = arguments.length > 2 ? arguments[2] : undefined;
	  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
	  var inc = 1;
	  if (from < to && to < from + count) {
	    inc = -1;
	    from += count - 1;
	    to += count - 1;
	  }
	  while (count-- > 0) {
	    if (from in O) O[to] = O[from];
	    else delete O[to];
	    to += inc;
	    from += inc;
	  } return O;
	};


/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	var aFunction = __webpack_require__(89);
	var toObject = __webpack_require__(65);
	var IObject = __webpack_require__(202);
	var toLength = __webpack_require__(47);
	
	module.exports = function (that, callbackfn, aLen, memo, isRight) {
	  aFunction(callbackfn);
	  var O = toObject(that);
	  var self = IObject(O);
	  var length = toLength(O.length);
	  var index = isRight ? length - 1 : 0;
	  var i = isRight ? -1 : 1;
	  if (aLen < 2) for (;;) {
	    if (index in self) {
	      memo = self[index];
	      index += i;
	      break;
	    }
	    index += i;
	    if (isRight ? index < 0 : length <= index) {
	      throw TypeError('Reduce of empty array with no initial value');
	    }
	  }
	  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
	    memo = callbackfn(memo, self[index], index, O);
	  }
	  return memo;
	};


/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(1265);
	
	module.exports = function (original, length) {
	  return new (speciesConstructor(original))(length);
	};


/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var aFunction = __webpack_require__(89);
	var isObject = __webpack_require__(36);
	var invoke = __webpack_require__(540);
	var arraySlice = [].slice;
	var factories = {};
	
	var construct = function (F, len, args) {
	  if (!(len in factories)) {
	    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
	    // eslint-disable-next-line no-new-func
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  } return factories[len](F, args);
	};
	
	module.exports = Function.bind || function bind(that /* , ...args */) {
	  var fn = aFunction(this);
	  var partArgs = arraySlice.call(arguments, 1);
	  var bound = function (/* args... */) {
	    var args = partArgs.concat(arraySlice.call(arguments));
	    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	  };
	  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
	  return bound;
	};


/***/ },
/* 537 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var dP = __webpack_require__(57).f;
	var create = __webpack_require__(137);
	var redefineAll = __webpack_require__(163);
	var ctx = __webpack_require__(91);
	var anInstance = __webpack_require__(161);
	var forOf = __webpack_require__(249);
	var $iterDefine = __webpack_require__(362);
	var step = __webpack_require__(544);
	var setSpecies = __webpack_require__(164);
	var DESCRIPTORS = __webpack_require__(56);
	var fastKey = __webpack_require__(117).fastKey;
	var validate = __webpack_require__(144);
	var SIZE = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function (that, key) {
	  // fast case
	  var index = fastKey(key);
	  var entry;
	  if (index !== 'F') return that._i[index];
	  // frozen object case
	  for (entry = that._f; entry; entry = entry.n) {
	    if (entry.k == key) return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;         // collection type
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear() {
	        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
	          entry.r = true;
	          if (entry.p) entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function (key) {
	        var that = validate(this, NAME);
	        var entry = getEntry(that, key);
	        if (entry) {
	          var next = entry.n;
	          var prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if (prev) prev.n = next;
	          if (next) next.p = prev;
	          if (that._f == entry) that._f = next;
	          if (that._l == entry) that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /* , that = undefined */) {
	        validate(this, NAME);
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	        var entry;
	        while (entry = entry ? entry.n : this._f) {
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while (entry && entry.r) entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key) {
	        return !!getEntry(validate(this, NAME), key);
	      }
	    });
	    if (DESCRIPTORS) dP(C.prototype, 'size', {
	      get: function () {
	        return validate(this, NAME)[SIZE];
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var entry = getEntry(that, key);
	    var prev, index;
	    // change existing entry
	    if (entry) {
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if (!that._f) that._f = entry;
	      if (prev) prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if (index !== 'F') that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function (C, NAME, IS_MAP) {
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function (iterated, kind) {
	      this._t = validate(iterated, NAME); // target
	      this._k = kind;                     // kind
	      this._l = undefined;                // previous
	    }, function () {
	      var that = this;
	      var kind = that._k;
	      var entry = that._l;
	      // revert to the last existing entry
	      while (entry && entry.r) entry = entry.p;
	      // get next entry
	      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if (kind == 'keys') return step(0, entry.k);
	      if (kind == 'values') return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};


/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var redefineAll = __webpack_require__(163);
	var getWeak = __webpack_require__(117).getWeak;
	var anObject = __webpack_require__(33);
	var isObject = __webpack_require__(36);
	var anInstance = __webpack_require__(161);
	var forOf = __webpack_require__(249);
	var createArrayMethod = __webpack_require__(90);
	var $has = __webpack_require__(77);
	var validate = __webpack_require__(144);
	var arrayFind = createArrayMethod(5);
	var arrayFindIndex = createArrayMethod(6);
	var id = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function (that) {
	  return that._l || (that._l = new UncaughtFrozenStore());
	};
	var UncaughtFrozenStore = function () {
	  this.a = [];
	};
	var findUncaughtFrozen = function (store, key) {
	  return arrayFind(store.a, function (it) {
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function (key) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) return entry[1];
	  },
	  has: function (key) {
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function (key, value) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function (key) {
	    var index = arrayFindIndex(this.a, function (it) {
	      return it[0] === key;
	    });
	    if (~index) this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;      // collection type
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function (key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var data = getWeak(anObject(key), true);
	    if (data === true) uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};


/***/ },
/* 539 */
[2634, 56, 34, 355],
/* 540 */
/***/ function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(36);
	var floor = Math.floor;
	module.exports = function isInteger(it) {
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};


/***/ },
/* 542 */
[2638, 33],
/* 543 */
[2639, 137, 141, 165, 78, 44],
/* 544 */
/***/ function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ },
/* 545 */
/***/ function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x) {
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};


/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(89);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ },
/* 547 */
[2643, 56, 140, 252, 203, 65, 202, 34],
/* 548 */
[2646, 57, 33, 140, 56],
/* 549 */
[2648, 79, 138],
/* 550 */
[2651, 77, 79, 245, 367],
/* 551 */
[2653, 56, 140, 79, 203],
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	// all object keys, includes non-enumerable and symbols
	var gOPN = __webpack_require__(138);
	var gOPS = __webpack_require__(252);
	var anObject = __webpack_require__(33);
	var Reflect = __webpack_require__(35).Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
	  var keys = gOPN.f(anObject(it));
	  var getSymbols = gOPS.f;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};


/***/ },
/* 553 */
/***/ function(module, exports, __webpack_require__) {

	var $parseFloat = __webpack_require__(35).parseFloat;
	var $trim = __webpack_require__(166).trim;
	
	module.exports = 1 / $parseFloat(__webpack_require__(371) + '-0') !== -Infinity ? function parseFloat(str) {
	  var string = $trim(String(str), 3);
	  var result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;


/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	var $parseInt = __webpack_require__(35).parseInt;
	var $trim = __webpack_require__(166).trim;
	var ws = __webpack_require__(371);
	var hex = /^[-+]?0[xX]/;
	
	module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
	  var string = $trim(String(str), 3);
	  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
	} : $parseInt;


/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(33);
	var isObject = __webpack_require__(36);
	var newPromiseCapability = __webpack_require__(546);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ },
/* 556 */
/***/ function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y) {
	  // eslint-disable-next-line no-self-compare
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};


/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-string-pad-start-end
	var toLength = __webpack_require__(47);
	var repeat = __webpack_require__(370);
	var defined = __webpack_require__(105);
	
	module.exports = function (that, maxLength, fillString, left) {
	  var S = String(defined(that));
	  var stringLength = S.length;
	  var fillStr = fillString === undefined ? ' ' : String(fillString);
	  var intMaxLength = toLength(maxLength);
	  if (intMaxLength <= stringLength || fillStr == '') return S;
	  var fillLen = intMaxLength - stringLength;
	  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
	  return left ? stringFiller + S : S + stringFiller;
	};


/***/ },
/* 558 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/ecma262/#sec-toindex
	var toInteger = __webpack_require__(94);
	var toLength = __webpack_require__(47);
	module.exports = function (it) {
	  if (it === undefined) return 0;
	  var number = toInteger(it);
	  var length = toLength(number);
	  if (number !== length) throw RangeError('Wrong length!');
	  return length;
	};


/***/ },
/* 559 */
[2664, 35, 46, 136, 374, 57],
/* 560 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(11);
	var log1p = __webpack_require__(545);
	var sqrt = Math.sqrt;
	var $acosh = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x) {
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});


/***/ },
/* 561 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(11);
	var $asinh = Math.asinh;
	
	function asinh(x) {
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ },
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(11);
	var $atanh = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x) {
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});


/***/ },
/* 563 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(11);
	var sign = __webpack_require__(364);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x) {
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});


/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(11);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x) {
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});


/***/ },
/* 565 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(11);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x) {
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});


/***/ },
/* 566 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(11);
	var $expm1 = __webpack_require__(363);
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ },
/* 567 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export = __webpack_require__(11);
	
	$export($export.S, 'Math', { fround: __webpack_require__(1271) });


/***/ },
/* 568 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(11);
	var abs = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
	    var sum = 0;
	    var i = 0;
	    var aLen = arguments.length;
	    var larg = 0;
	    var arg, div;
	    while (i < aLen) {
	      arg = abs(arguments[i++]);
	      if (larg < arg) {
	        div = larg / arg;
	        sum = sum * div * div + 1;
	        larg = arg;
	      } else if (arg > 0) {
	        div = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});


/***/ },
/* 569 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(11);
	var $imul = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(34)(function () {
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y) {
	    var UINT16 = 0xffff;
	    var xn = +x;
	    var yn = +y;
	    var xl = UINT16 & xn;
	    var yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});


/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(11);
	
	$export($export.S, 'Math', {
	  log10: function log10(x) {
	    return Math.log(x) * Math.LOG10E;
	  }
	});


/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(11);
	
	$export($export.S, 'Math', { log1p: __webpack_require__(545) });


/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(11);
	
	$export($export.S, 'Math', {
	  log2: function log2(x) {
	    return Math.log(x) / Math.LN2;
	  }
	});


/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(11);
	
	$export($export.S, 'Math', { sign: __webpack_require__(364) });


/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(11);
	var expm1 = __webpack_require__(363);
	var exp = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(34)(function () {
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x) {
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});


/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(11);
	var expm1 = __webpack_require__(363);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x) {
	    var a = expm1(x = +x);
	    var b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});


/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(11);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it) {
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});


/***/ },
/* 577 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(35);
	var has = __webpack_require__(77);
	var cof = __webpack_require__(104);
	var inheritIfRequired = __webpack_require__(359);
	var toPrimitive = __webpack_require__(118);
	var fails = __webpack_require__(34);
	var gOPN = __webpack_require__(138).f;
	var gOPD = __webpack_require__(92).f;
	var dP = __webpack_require__(57).f;
	var $trim = __webpack_require__(166).trim;
	var NUMBER = 'Number';
	var $Number = global[NUMBER];
	var Base = $Number;
	var proto = $Number.prototype;
	// Opera ~12 has broken Object#toString
	var BROKEN_COF = cof(__webpack_require__(137)(proto)) == NUMBER;
	var TRIM = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function (argument) {
	  var it = toPrimitive(argument, false);
	  if (typeof it == 'string' && it.length > 2) {
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0);
	    var third, radix, maxCode;
	    if (first === 43 || first === 45) {
	      third = it.charCodeAt(2);
	      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if (first === 48) {
	      switch (it.charCodeAt(1)) {
	        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default: return +it;
	      }
	      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if (code < 48 || code > maxCode) return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
	  $Number = function Number(value) {
	    var it = arguments.length < 1 ? 0 : value;
	    var that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
	  };
	  for (var keys = __webpack_require__(56) ? gOPN(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), j = 0, key; keys.length > j; j++) {
	    if (has(Base, key = keys[j]) && !has($Number, key)) {
	      dP($Number, key, gOPD(Base, key));
	    }
	  }
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(68)(global, NUMBER, $Number);
	}


/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(11);
	
	$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export = __webpack_require__(11);
	var _isFinite = __webpack_require__(35).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it) {
	    return typeof it == 'number' && _isFinite(it);
	  }
	});


/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(11);
	
	$export($export.S, 'Number', { isInteger: __webpack_require__(541) });


/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(11);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number) {
	    // eslint-disable-next-line no-self-compare
	    return number != number;
	  }
	});


/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.5 Number.isSafeInteger(number)
	var $export = __webpack_require__(11);
	var isInteger = __webpack_require__(541);
	var abs = Math.abs;
	
	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number) {
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});


/***/ },
/* 583 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(11);
	
	$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(11);
	
	$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ },
/* 585 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(11);
	var $parseFloat = __webpack_require__(553);
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(11);
	var $parseInt = __webpack_require__(554);
	// 20.1.2.13 Number.parseInt(string, radix)
	$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ },
/* 587 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(11);
	var toInteger = __webpack_require__(94);
	var aNumberValue = __webpack_require__(532);
	var repeat = __webpack_require__(370);
	var $toFixed = 1.0.toFixed;
	var floor = Math.floor;
	var data = [0, 0, 0, 0, 0, 0];
	var ERROR = 'Number.toFixed: incorrect invocation!';
	var ZERO = '0';
	
	var multiply = function (n, c) {
	  var i = -1;
	  var c2 = c;
	  while (++i < 6) {
	    c2 += n * data[i];
	    data[i] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	var divide = function (n) {
	  var i = 6;
	  var c = 0;
	  while (--i >= 0) {
	    c += data[i];
	    data[i] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};
	var numToString = function () {
	  var i = 6;
	  var s = '';
	  while (--i >= 0) {
	    if (s !== '' || i === 0 || data[i] !== 0) {
	      var t = String(data[i]);
	      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
	    }
	  } return s;
	};
	var pow = function (x, n, acc) {
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	var log = function (x) {
	  var n = 0;
	  var x2 = x;
	  while (x2 >= 4096) {
	    n += 12;
	    x2 /= 4096;
	  }
	  while (x2 >= 2) {
	    n += 1;
	    x2 /= 2;
	  } return n;
	};
	
	$export($export.P + $export.F * (!!$toFixed && (
	  0.00008.toFixed(3) !== '0.000' ||
	  0.9.toFixed(0) !== '1' ||
	  1.255.toFixed(2) !== '1.25' ||
	  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
	) || !__webpack_require__(34)(function () {
	  // V8 ~ Android 4.3-
	  $toFixed.call({});
	})), 'Number', {
	  toFixed: function toFixed(fractionDigits) {
	    var x = aNumberValue(this, ERROR);
	    var f = toInteger(fractionDigits);
	    var s = '';
	    var m = ZERO;
	    var e, z, j, k;
	    if (f < 0 || f > 20) throw RangeError(ERROR);
	    // eslint-disable-next-line no-self-compare
	    if (x != x) return 'NaN';
	    if (x <= -1e21 || x >= 1e21) return String(x);
	    if (x < 0) {
	      s = '-';
	      x = -x;
	    }
	    if (x > 1e-21) {
	      e = log(x * pow(2, 69, 1)) - 69;
	      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if (e > 0) {
	        multiply(0, z);
	        j = f;
	        while (j >= 7) {
	          multiply(1e7, 0);
	          j -= 7;
	        }
	        multiply(pow(10, j, 1), 0);
	        j = e - 1;
	        while (j >= 23) {
	          divide(1 << 23);
	          j -= 23;
	        }
	        divide(1 << j);
	        multiply(1, 1);
	        divide(2);
	        m = numToString();
	      } else {
	        multiply(0, z);
	        multiply(1 << -e, 0);
	        m = numToString() + repeat.call(ZERO, f);
	      }
	    }
	    if (f > 0) {
	      k = m.length;
	      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
	    } else {
	      m = s + m;
	    } return m;
	  }
	});


/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(11);
	var $fails = __webpack_require__(34);
	var aNumberValue = __webpack_require__(532);
	var $toPrecision = 1.0.toPrecision;
	
	$export($export.P + $export.F * ($fails(function () {
	  // IE7-
	  return $toPrecision.call(1, undefined) !== '1';
	}) || !$fails(function () {
	  // V8 ~ Android 4.3-
	  $toPrecision.call({});
	})), 'Number', {
	  toPrecision: function toPrecision(precision) {
	    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
	    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
	  }
	});


/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(136);
	var global = __webpack_require__(35);
	var ctx = __webpack_require__(91);
	var classof = __webpack_require__(201);
	var $export = __webpack_require__(11);
	var isObject = __webpack_require__(36);
	var aFunction = __webpack_require__(89);
	var anInstance = __webpack_require__(161);
	var forOf = __webpack_require__(249);
	var speciesConstructor = __webpack_require__(204);
	var task = __webpack_require__(372).set;
	var microtask = __webpack_require__(1272)();
	var newPromiseCapabilityModule = __webpack_require__(546);
	var perform = __webpack_require__(1273);
	var userAgent = __webpack_require__(256);
	var promiseResolve = __webpack_require__(555);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var versions = process && process.versions;
	var v8 = versions && versions.v8 || '';
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(44)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function')
	      && promise.then(empty) instanceof FakePromise
	      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	      // we can't detect it synchronously, so just check versions
	      && v8.indexOf('6.6') !== 0
	      && userAgent.indexOf('Chrome/66') === -1;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(163)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(165)($Promise, PROMISE);
	__webpack_require__(164)(PROMISE);
	Wrapper = __webpack_require__(46)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(251)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var regexpExec = __webpack_require__(365);
	__webpack_require__(11)({
	  target: 'RegExp',
	  proto: true,
	  forced: regexpExec !== /./.exec
	}, {
	  exec: regexpExec
	});


/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	// 21.2.5.3 get RegExp.prototype.flags()
	if (__webpack_require__(56) && /./g.flags != 'g') __webpack_require__(57).f(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__(248)
	});


/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var _react = _interopRequireDefault(__webpack_require__(1));
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	var _classnames = _interopRequireDefault(__webpack_require__(119));
	__webpack_require__(2500);
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	var TypingIndicator = function TypingIndicator(_ref) {
	  var contained = _ref.contained,
	    small = _ref.small;
	  var classes = (0, _classnames["default"])({
	    contained: contained,
	    small: small
	  });
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-typing-indicator ".concat(classes)
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-ti-dot"
	  }), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-ti-dot"
	  }), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-ti-dot"
	  }));
	};
	TypingIndicator.propTypes = {
	  contained: _propTypes["default"].bool,
	  small: _propTypes["default"].bool
	};
	var _default = exports["default"] = TypingIndicator;

/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var _react = _interopRequireDefault(__webpack_require__(1));
	var _formatters = __webpack_require__(83);
	__webpack_require__(2504);
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	var ContactData = function ContactData(_ref) {
	  var image = _ref.image,
	    name = _ref.name,
	    account = _ref.account;
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-contact-data"
	  }, image, account ? /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-contact-account"
	  }, /*#__PURE__*/_react["default"].createElement("p", null, name), /*#__PURE__*/_react["default"].createElement("span", null, (0, _formatters.formatAccount)(account))) : name && /*#__PURE__*/_react["default"].createElement("h6", null, name));
	};
	var _default = exports["default"] = ContactData;

/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var _react = _interopRequireDefault(__webpack_require__(1));
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	var _classnames2 = _interopRequireDefault(__webpack_require__(119));
	__webpack_require__(2509);
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
	function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
	function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
	var InputChip = function InputChip(_ref) {
	  var _classnames;
	  var label = _ref.label,
	    color = _ref.color,
	    errorMessage = _ref.errorMessage,
	    interactive = _ref.interactive,
	    invalid = _ref.invalid,
	    onClick = _ref.onClick,
	    onDelete = _ref.onDelete;
	  var classes = (0, _classnames2["default"])((_classnames = {}, _defineProperty(_classnames, color, color != null), _defineProperty(_classnames, "interactive", interactive), _defineProperty(_classnames, "invalid", invalid), _classnames));
	  return /*#__PURE__*/_react["default"].createElement("span", {
	    className: 'uin-input-chip ' + classes,
	    onClick: onClick
	  }, label, errorMessage && /*#__PURE__*/_react["default"].createElement("span", {
	    className: "uin-chp-error"
	  }, errorMessage), /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon close",
	    onClick: onDelete
	  }));
	};
	InputChip.propTypes = {
	  label: _propTypes["default"].string.isRequired,
	  color: _propTypes["default"].oneOf(['blue', 'green']),
	  errorMessage: _propTypes["default"].string,
	  interactive: _propTypes["default"].bool,
	  invalid: _propTypes["default"].bool,
	  onClick: _propTypes["default"].func,
	  onDelete: _propTypes["default"].func.isRequired
	};
	var _default = exports["default"] = InputChip;

/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "MEDIATYPE", {
	  enumerable: true,
	  get: function get() {
	    return _constants.MEDIATYPE;
	  }
	});
	Object.defineProperty(exports, "REASSIGNED_TYPES", {
	  enumerable: true,
	  get: function get() {
	    return _constants.REASSIGNED_TYPES;
	  }
	});
	exports["default"] = void 0;
	var _UnifiedInbox = _interopRequireDefault(__webpack_require__(1428));
	__webpack_require__(1437);
	__webpack_require__(1726);
	var _constants = __webpack_require__(58);
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	var _default = exports["default"] = _UnifiedInbox["default"];

/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = convertNodeToElement;
	
	var _elementTypes = __webpack_require__(1446);
	
	var _elementTypes2 = _interopRequireDefault(_elementTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Converts a htmlparser2 node to a React element
	 *
	 * @param {Object} node The htmlparser2 node to convert
	 * @param {Number} index The index of the current node
	 * @param {Function} transform Transform function to apply to children of the node
	 * @returns {React.Element}
	 */
	function convertNodeToElement(node, index, transform) {
	  return _elementTypes2.default[node.type](node, index, transform);
	}

/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.htmlparser2 = exports.convertNodeToElement = exports.processNodes = undefined;
	
	var _processNodes = __webpack_require__(379);
	
	Object.defineProperty(exports, 'processNodes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_processNodes).default;
	  }
	});
	
	var _convertNodeToElement = __webpack_require__(596);
	
	Object.defineProperty(exports, 'convertNodeToElement', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_convertNodeToElement).default;
	  }
	});
	
	var _htmlparser = __webpack_require__(177);
	
	Object.defineProperty(exports, 'htmlparser2', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_htmlparser).default;
	  }
	});
	
	var _HtmlParser = __webpack_require__(1438);
	
	var _HtmlParser2 = _interopRequireDefault(_HtmlParser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _HtmlParser2.default;

/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = generatePropsFromAttributes;
	
	var _htmlAttributesToReact = __webpack_require__(1447);
	
	var _htmlAttributesToReact2 = _interopRequireDefault(_htmlAttributesToReact);
	
	var _inlineStyleToObject = __webpack_require__(1448);
	
	var _inlineStyleToObject2 = _interopRequireDefault(_inlineStyleToObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Generates props for a React element from an object of HTML attributes
	 *
	 * @param {Object} attributes The HTML attributes
	 * @param {String} key The key to give the react element
	 */
	function generatePropsFromAttributes(attributes, key) {
	
	  // generate props
	  var props = _extends({}, (0, _htmlAttributesToReact2.default)(attributes), { key: key });
	
	  // if there is an inline/string style prop then convert it to a React style object
	  // otherwise, it is invalid and omitted
	  if (typeof props.style === 'string' || props.style instanceof String) {
	    props.style = (0, _inlineStyleToObject2.default)(props.style);
	  } else {
	    delete props.style;
	  }
	
	  return props;
	}

/***/ },
/* 599 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isValidTagOrAttributeName;
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/;
	
	var nameCache = {};
	
	function isValidTagOrAttributeName(tagName) {
	  if (!nameCache.hasOwnProperty(tagName)) {
	    nameCache[tagName] = VALID_TAG_REGEX.test(tagName);
	  }
	  return nameCache[tagName];
	}

/***/ },
/* 600 */
[2678, 12, 206],
/* 601 */
[2683, 258],
/* 602 */
[2700, 381, 12],
/* 603 */
[2701, 12],
/* 604 */
[2702, 12],
/* 605 */
[2703, 12],
/* 606 */
[2706, 12],
/* 607 */
[2708, 12],
/* 608 */
[2723, 12],
/* 609 */
[2747, 613],
/* 610 */
[2750, 12, 206],
/* 611 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.TabContext = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	/**
	 * TabContext
	 * {
	 *  activeTabId: PropTypes.any
	 * }
	 */
	var TabContext = /*#__PURE__*/_react.default.createContext({});
	
	exports.TabContext = TabContext;

/***/ },
/* 612 */
[2762, 613],
/* 613 */
[2763, 610, 12],
/* 614 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-scale/ v2.2.2 Copyright 2019 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports, __webpack_require__(1528), __webpack_require__(1527), __webpack_require__(1531), __webpack_require__(1530), __webpack_require__(615), __webpack_require__(1533)) :
	typeof define === 'function' && define.amd ? define(['exports', 'd3-collection', 'd3-array', 'd3-interpolate', 'd3-format', 'd3-time', 'd3-time-format'], factory) :
	(factory((global.d3 = global.d3 || {}),global.d3,global.d3,global.d3,global.d3,global.d3,global.d3));
	}(this, (function (exports,d3Collection,d3Array,d3Interpolate,d3Format,d3Time,d3TimeFormat) { 'use strict';
	
	function initRange(domain, range) {
	  switch (arguments.length) {
	    case 0: break;
	    case 1: this.range(domain); break;
	    default: this.range(range).domain(domain); break;
	  }
	  return this;
	}
	
	function initInterpolator(domain, interpolator) {
	  switch (arguments.length) {
	    case 0: break;
	    case 1: this.interpolator(domain); break;
	    default: this.interpolator(interpolator).domain(domain); break;
	  }
	  return this;
	}
	
	var array = Array.prototype;
	
	var map = array.map;
	var slice = array.slice;
	
	var implicit = {name: "implicit"};
	
	function ordinal() {
	  var index = d3Collection.map(),
	      domain = [],
	      range = [],
	      unknown = implicit;
	
	  function scale(d) {
	    var key = d + "", i = index.get(key);
	    if (!i) {
	      if (unknown !== implicit) return unknown;
	      index.set(key, i = domain.push(d));
	    }
	    return range[(i - 1) % range.length];
	  }
	
	  scale.domain = function(_) {
	    if (!arguments.length) return domain.slice();
	    domain = [], index = d3Collection.map();
	    var i = -1, n = _.length, d, key;
	    while (++i < n) if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
	    return scale;
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range = slice.call(_), scale) : range.slice();
	  };
	
	  scale.unknown = function(_) {
	    return arguments.length ? (unknown = _, scale) : unknown;
	  };
	
	  scale.copy = function() {
	    return ordinal(domain, range).unknown(unknown);
	  };
	
	  initRange.apply(scale, arguments);
	
	  return scale;
	}
	
	function band() {
	  var scale = ordinal().unknown(undefined),
	      domain = scale.domain,
	      ordinalRange = scale.range,
	      range = [0, 1],
	      step,
	      bandwidth,
	      round = false,
	      paddingInner = 0,
	      paddingOuter = 0,
	      align = 0.5;
	
	  delete scale.unknown;
	
	  function rescale() {
	    var n = domain().length,
	        reverse = range[1] < range[0],
	        start = range[reverse - 0],
	        stop = range[1 - reverse];
	    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
	    if (round) step = Math.floor(step);
	    start += (stop - start - step * (n - paddingInner)) * align;
	    bandwidth = step * (1 - paddingInner);
	    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
	    var values = d3Array.range(n).map(function(i) { return start + step * i; });
	    return ordinalRange(reverse ? values.reverse() : values);
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain(_), rescale()) : domain();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range = [+_[0], +_[1]], rescale()) : range.slice();
	  };
	
	  scale.rangeRound = function(_) {
	    return range = [+_[0], +_[1]], round = true, rescale();
	  };
	
	  scale.bandwidth = function() {
	    return bandwidth;
	  };
	
	  scale.step = function() {
	    return step;
	  };
	
	  scale.round = function(_) {
	    return arguments.length ? (round = !!_, rescale()) : round;
	  };
	
	  scale.padding = function(_) {
	    return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
	  };
	
	  scale.paddingInner = function(_) {
	    return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
	  };
	
	  scale.paddingOuter = function(_) {
	    return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
	  };
	
	  scale.align = function(_) {
	    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
	  };
	
	  scale.copy = function() {
	    return band(domain(), range)
	        .round(round)
	        .paddingInner(paddingInner)
	        .paddingOuter(paddingOuter)
	        .align(align);
	  };
	
	  return initRange.apply(rescale(), arguments);
	}
	
	function pointish(scale) {
	  var copy = scale.copy;
	
	  scale.padding = scale.paddingOuter;
	  delete scale.paddingInner;
	  delete scale.paddingOuter;
	
	  scale.copy = function() {
	    return pointish(copy());
	  };
	
	  return scale;
	}
	
	function point() {
	  return pointish(band.apply(null, arguments).paddingInner(1));
	}
	
	function constant(x) {
	  return function() {
	    return x;
	  };
	}
	
	function number(x) {
	  return +x;
	}
	
	var unit = [0, 1];
	
	function identity(x) {
	  return x;
	}
	
	function normalize(a, b) {
	  return (b -= (a = +a))
	      ? function(x) { return (x - a) / b; }
	      : constant(isNaN(b) ? NaN : 0.5);
	}
	
	function clamper(domain) {
	  var a = domain[0], b = domain[domain.length - 1], t;
	  if (a > b) t = a, a = b, b = t;
	  return function(x) { return Math.max(a, Math.min(b, x)); };
	}
	
	// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
	// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
	function bimap(domain, range, interpolate) {
	  var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
	  if (d1 < d0) d0 = normalize(d1, d0), r0 = interpolate(r1, r0);
	  else d0 = normalize(d0, d1), r0 = interpolate(r0, r1);
	  return function(x) { return r0(d0(x)); };
	}
	
	function polymap(domain, range, interpolate) {
	  var j = Math.min(domain.length, range.length) - 1,
	      d = new Array(j),
	      r = new Array(j),
	      i = -1;
	
	  // Reverse descending domains.
	  if (domain[j] < domain[0]) {
	    domain = domain.slice().reverse();
	    range = range.slice().reverse();
	  }
	
	  while (++i < j) {
	    d[i] = normalize(domain[i], domain[i + 1]);
	    r[i] = interpolate(range[i], range[i + 1]);
	  }
	
	  return function(x) {
	    var i = d3Array.bisect(domain, x, 1, j) - 1;
	    return r[i](d[i](x));
	  };
	}
	
	function copy(source, target) {
	  return target
	      .domain(source.domain())
	      .range(source.range())
	      .interpolate(source.interpolate())
	      .clamp(source.clamp())
	      .unknown(source.unknown());
	}
	
	function transformer() {
	  var domain = unit,
	      range = unit,
	      interpolate = d3Interpolate.interpolate,
	      transform,
	      untransform,
	      unknown,
	      clamp = identity,
	      piecewise,
	      output,
	      input;
	
	  function rescale() {
	    piecewise = Math.min(domain.length, range.length) > 2 ? polymap : bimap;
	    output = input = null;
	    return scale;
	  }
	
	  function scale(x) {
	    return isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
	  }
	
	  scale.invert = function(y) {
	    return clamp(untransform((input || (input = piecewise(range, domain.map(transform), d3Interpolate.interpolateNumber)))(y)));
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain = map.call(_, number), clamp === identity || (clamp = clamper(domain)), rescale()) : domain.slice();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range = slice.call(_), rescale()) : range.slice();
	  };
	
	  scale.rangeRound = function(_) {
	    return range = slice.call(_), interpolate = d3Interpolate.interpolateRound, rescale();
	  };
	
	  scale.clamp = function(_) {
	    return arguments.length ? (clamp = _ ? clamper(domain) : identity, scale) : clamp !== identity;
	  };
	
	  scale.interpolate = function(_) {
	    return arguments.length ? (interpolate = _, rescale()) : interpolate;
	  };
	
	  scale.unknown = function(_) {
	    return arguments.length ? (unknown = _, scale) : unknown;
	  };
	
	  return function(t, u) {
	    transform = t, untransform = u;
	    return rescale();
	  };
	}
	
	function continuous(transform, untransform) {
	  return transformer()(transform, untransform);
	}
	
	function tickFormat(start, stop, count, specifier) {
	  var step = d3Array.tickStep(start, stop, count),
	      precision;
	  specifier = d3Format.formatSpecifier(specifier == null ? ",f" : specifier);
	  switch (specifier.type) {
	    case "s": {
	      var value = Math.max(Math.abs(start), Math.abs(stop));
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionPrefix(step, value))) specifier.precision = precision;
	      return d3Format.formatPrefix(specifier, value);
	    }
	    case "":
	    case "e":
	    case "g":
	    case "p":
	    case "r": {
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionRound(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
	      break;
	    }
	    case "f":
	    case "%": {
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionFixed(step))) specifier.precision = precision - (specifier.type === "%") * 2;
	      break;
	    }
	  }
	  return d3Format.format(specifier);
	}
	
	function linearish(scale) {
	  var domain = scale.domain;
	
	  scale.ticks = function(count) {
	    var d = domain();
	    return d3Array.ticks(d[0], d[d.length - 1], count == null ? 10 : count);
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    var d = domain();
	    return tickFormat(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
	  };
	
	  scale.nice = function(count) {
	    if (count == null) count = 10;
	
	    var d = domain(),
	        i0 = 0,
	        i1 = d.length - 1,
	        start = d[i0],
	        stop = d[i1],
	        step;
	
	    if (stop < start) {
	      step = start, start = stop, stop = step;
	      step = i0, i0 = i1, i1 = step;
	    }
	
	    step = d3Array.tickIncrement(start, stop, count);
	
	    if (step > 0) {
	      start = Math.floor(start / step) * step;
	      stop = Math.ceil(stop / step) * step;
	      step = d3Array.tickIncrement(start, stop, count);
	    } else if (step < 0) {
	      start = Math.ceil(start * step) / step;
	      stop = Math.floor(stop * step) / step;
	      step = d3Array.tickIncrement(start, stop, count);
	    }
	
	    if (step > 0) {
	      d[i0] = Math.floor(start / step) * step;
	      d[i1] = Math.ceil(stop / step) * step;
	      domain(d);
	    } else if (step < 0) {
	      d[i0] = Math.ceil(start * step) / step;
	      d[i1] = Math.floor(stop * step) / step;
	      domain(d);
	    }
	
	    return scale;
	  };
	
	  return scale;
	}
	
	function linear() {
	  var scale = continuous(identity, identity);
	
	  scale.copy = function() {
	    return copy(scale, linear());
	  };
	
	  initRange.apply(scale, arguments);
	
	  return linearish(scale);
	}
	
	function identity$1(domain) {
	  var unknown;
	
	  function scale(x) {
	    return isNaN(x = +x) ? unknown : x;
	  }
	
	  scale.invert = scale;
	
	  scale.domain = scale.range = function(_) {
	    return arguments.length ? (domain = map.call(_, number), scale) : domain.slice();
	  };
	
	  scale.unknown = function(_) {
	    return arguments.length ? (unknown = _, scale) : unknown;
	  };
	
	  scale.copy = function() {
	    return identity$1(domain).unknown(unknown);
	  };
	
	  domain = arguments.length ? map.call(domain, number) : [0, 1];
	
	  return linearish(scale);
	}
	
	function nice(domain, interval) {
	  domain = domain.slice();
	
	  var i0 = 0,
	      i1 = domain.length - 1,
	      x0 = domain[i0],
	      x1 = domain[i1],
	      t;
	
	  if (x1 < x0) {
	    t = i0, i0 = i1, i1 = t;
	    t = x0, x0 = x1, x1 = t;
	  }
	
	  domain[i0] = interval.floor(x0);
	  domain[i1] = interval.ceil(x1);
	  return domain;
	}
	
	function transformLog(x) {
	  return Math.log(x);
	}
	
	function transformExp(x) {
	  return Math.exp(x);
	}
	
	function transformLogn(x) {
	  return -Math.log(-x);
	}
	
	function transformExpn(x) {
	  return -Math.exp(-x);
	}
	
	function pow10(x) {
	  return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
	}
	
	function powp(base) {
	  return base === 10 ? pow10
	      : base === Math.E ? Math.exp
	      : function(x) { return Math.pow(base, x); };
	}
	
	function logp(base) {
	  return base === Math.E ? Math.log
	      : base === 10 && Math.log10
	      || base === 2 && Math.log2
	      || (base = Math.log(base), function(x) { return Math.log(x) / base; });
	}
	
	function reflect(f) {
	  return function(x) {
	    return -f(-x);
	  };
	}
	
	function loggish(transform) {
	  var scale = transform(transformLog, transformExp),
	      domain = scale.domain,
	      base = 10,
	      logs,
	      pows;
	
	  function rescale() {
	    logs = logp(base), pows = powp(base);
	    if (domain()[0] < 0) {
	      logs = reflect(logs), pows = reflect(pows);
	      transform(transformLogn, transformExpn);
	    } else {
	      transform(transformLog, transformExp);
	    }
	    return scale;
	  }
	
	  scale.base = function(_) {
	    return arguments.length ? (base = +_, rescale()) : base;
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain(_), rescale()) : domain();
	  };
	
	  scale.ticks = function(count) {
	    var d = domain(),
	        u = d[0],
	        v = d[d.length - 1],
	        r;
	
	    if (r = v < u) i = u, u = v, v = i;
	
	    var i = logs(u),
	        j = logs(v),
	        p,
	        k,
	        t,
	        n = count == null ? 10 : +count,
	        z = [];
	
	    if (!(base % 1) && j - i < n) {
	      i = Math.round(i) - 1, j = Math.round(j) + 1;
	      if (u > 0) for (; i < j; ++i) {
	        for (k = 1, p = pows(i); k < base; ++k) {
	          t = p * k;
	          if (t < u) continue;
	          if (t > v) break;
	          z.push(t);
	        }
	      } else for (; i < j; ++i) {
	        for (k = base - 1, p = pows(i); k >= 1; --k) {
	          t = p * k;
	          if (t < u) continue;
	          if (t > v) break;
	          z.push(t);
	        }
	      }
	    } else {
	      z = d3Array.ticks(i, j, Math.min(j - i, n)).map(pows);
	    }
	
	    return r ? z.reverse() : z;
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    if (specifier == null) specifier = base === 10 ? ".0e" : ",";
	    if (typeof specifier !== "function") specifier = d3Format.format(specifier);
	    if (count === Infinity) return specifier;
	    if (count == null) count = 10;
	    var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
	    return function(d) {
	      var i = d / pows(Math.round(logs(d)));
	      if (i * base < base - 0.5) i *= base;
	      return i <= k ? specifier(d) : "";
	    };
	  };
	
	  scale.nice = function() {
	    return domain(nice(domain(), {
	      floor: function(x) { return pows(Math.floor(logs(x))); },
	      ceil: function(x) { return pows(Math.ceil(logs(x))); }
	    }));
	  };
	
	  return scale;
	}
	
	function log() {
	  var scale = loggish(transformer()).domain([1, 10]);
	
	  scale.copy = function() {
	    return copy(scale, log()).base(scale.base());
	  };
	
	  initRange.apply(scale, arguments);
	
	  return scale;
	}
	
	function transformSymlog(c) {
	  return function(x) {
	    return Math.sign(x) * Math.log1p(Math.abs(x / c));
	  };
	}
	
	function transformSymexp(c) {
	  return function(x) {
	    return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
	  };
	}
	
	function symlogish(transform) {
	  var c = 1, scale = transform(transformSymlog(c), transformSymexp(c));
	
	  scale.constant = function(_) {
	    return arguments.length ? transform(transformSymlog(c = +_), transformSymexp(c)) : c;
	  };
	
	  return linearish(scale);
	}
	
	function symlog() {
	  var scale = symlogish(transformer());
	
	  scale.copy = function() {
	    return copy(scale, symlog()).constant(scale.constant());
	  };
	
	  return initRange.apply(scale, arguments);
	}
	
	function transformPow(exponent) {
	  return function(x) {
	    return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
	  };
	}
	
	function transformSqrt(x) {
	  return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
	}
	
	function transformSquare(x) {
	  return x < 0 ? -x * x : x * x;
	}
	
	function powish(transform) {
	  var scale = transform(identity, identity),
	      exponent = 1;
	
	  function rescale() {
	    return exponent === 1 ? transform(identity, identity)
	        : exponent === 0.5 ? transform(transformSqrt, transformSquare)
	        : transform(transformPow(exponent), transformPow(1 / exponent));
	  }
	
	  scale.exponent = function(_) {
	    return arguments.length ? (exponent = +_, rescale()) : exponent;
	  };
	
	  return linearish(scale);
	}
	
	function pow() {
	  var scale = powish(transformer());
	
	  scale.copy = function() {
	    return copy(scale, pow()).exponent(scale.exponent());
	  };
	
	  initRange.apply(scale, arguments);
	
	  return scale;
	}
	
	function sqrt() {
	  return pow.apply(null, arguments).exponent(0.5);
	}
	
	function quantile() {
	  var domain = [],
	      range = [],
	      thresholds = [],
	      unknown;
	
	  function rescale() {
	    var i = 0, n = Math.max(1, range.length);
	    thresholds = new Array(n - 1);
	    while (++i < n) thresholds[i - 1] = d3Array.quantile(domain, i / n);
	    return scale;
	  }
	
	  function scale(x) {
	    return isNaN(x = +x) ? unknown : range[d3Array.bisect(thresholds, x)];
	  }
	
	  scale.invertExtent = function(y) {
	    var i = range.indexOf(y);
	    return i < 0 ? [NaN, NaN] : [
	      i > 0 ? thresholds[i - 1] : domain[0],
	      i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
	    ];
	  };
	
	  scale.domain = function(_) {
	    if (!arguments.length) return domain.slice();
	    domain = [];
	    for (var i = 0, n = _.length, d; i < n; ++i) if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
	    domain.sort(d3Array.ascending);
	    return rescale();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range = slice.call(_), rescale()) : range.slice();
	  };
	
	  scale.unknown = function(_) {
	    return arguments.length ? (unknown = _, scale) : unknown;
	  };
	
	  scale.quantiles = function() {
	    return thresholds.slice();
	  };
	
	  scale.copy = function() {
	    return quantile()
	        .domain(domain)
	        .range(range)
	        .unknown(unknown);
	  };
	
	  return initRange.apply(scale, arguments);
	}
	
	function quantize() {
	  var x0 = 0,
	      x1 = 1,
	      n = 1,
	      domain = [0.5],
	      range = [0, 1],
	      unknown;
	
	  function scale(x) {
	    return x <= x ? range[d3Array.bisect(domain, x, 0, n)] : unknown;
	  }
	
	  function rescale() {
	    var i = -1;
	    domain = new Array(n);
	    while (++i < n) domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
	    return scale;
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [x0, x1];
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (n = (range = slice.call(_)).length - 1, rescale()) : range.slice();
	  };
	
	  scale.invertExtent = function(y) {
	    var i = range.indexOf(y);
	    return i < 0 ? [NaN, NaN]
	        : i < 1 ? [x0, domain[0]]
	        : i >= n ? [domain[n - 1], x1]
	        : [domain[i - 1], domain[i]];
	  };
	
	  scale.unknown = function(_) {
	    return arguments.length ? (unknown = _, scale) : scale;
	  };
	
	  scale.thresholds = function() {
	    return domain.slice();
	  };
	
	  scale.copy = function() {
	    return quantize()
	        .domain([x0, x1])
	        .range(range)
	        .unknown(unknown);
	  };
	
	  return initRange.apply(linearish(scale), arguments);
	}
	
	function threshold() {
	  var domain = [0.5],
	      range = [0, 1],
	      unknown,
	      n = 1;
	
	  function scale(x) {
	    return x <= x ? range[d3Array.bisect(domain, x, 0, n)] : unknown;
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain = slice.call(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range = slice.call(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
	  };
	
	  scale.invertExtent = function(y) {
	    var i = range.indexOf(y);
	    return [domain[i - 1], domain[i]];
	  };
	
	  scale.unknown = function(_) {
	    return arguments.length ? (unknown = _, scale) : unknown;
	  };
	
	  scale.copy = function() {
	    return threshold()
	        .domain(domain)
	        .range(range)
	        .unknown(unknown);
	  };
	
	  return initRange.apply(scale, arguments);
	}
	
	var durationSecond = 1000,
	    durationMinute = durationSecond * 60,
	    durationHour = durationMinute * 60,
	    durationDay = durationHour * 24,
	    durationWeek = durationDay * 7,
	    durationMonth = durationDay * 30,
	    durationYear = durationDay * 365;
	
	function date(t) {
	  return new Date(t);
	}
	
	function number$1(t) {
	  return t instanceof Date ? +t : +new Date(+t);
	}
	
	function calendar(year, month, week, day, hour, minute, second, millisecond, format) {
	  var scale = continuous(identity, identity),
	      invert = scale.invert,
	      domain = scale.domain;
	
	  var formatMillisecond = format(".%L"),
	      formatSecond = format(":%S"),
	      formatMinute = format("%I:%M"),
	      formatHour = format("%I %p"),
	      formatDay = format("%a %d"),
	      formatWeek = format("%b %d"),
	      formatMonth = format("%B"),
	      formatYear = format("%Y");
	
	  var tickIntervals = [
	    [second,  1,      durationSecond],
	    [second,  5,  5 * durationSecond],
	    [second, 15, 15 * durationSecond],
	    [second, 30, 30 * durationSecond],
	    [minute,  1,      durationMinute],
	    [minute,  5,  5 * durationMinute],
	    [minute, 15, 15 * durationMinute],
	    [minute, 30, 30 * durationMinute],
	    [  hour,  1,      durationHour  ],
	    [  hour,  3,  3 * durationHour  ],
	    [  hour,  6,  6 * durationHour  ],
	    [  hour, 12, 12 * durationHour  ],
	    [   day,  1,      durationDay   ],
	    [   day,  2,  2 * durationDay   ],
	    [  week,  1,      durationWeek  ],
	    [ month,  1,      durationMonth ],
	    [ month,  3,  3 * durationMonth ],
	    [  year,  1,      durationYear  ]
	  ];
	
	  function tickFormat(date) {
	    return (second(date) < date ? formatMillisecond
	        : minute(date) < date ? formatSecond
	        : hour(date) < date ? formatMinute
	        : day(date) < date ? formatHour
	        : month(date) < date ? (week(date) < date ? formatDay : formatWeek)
	        : year(date) < date ? formatMonth
	        : formatYear)(date);
	  }
	
	  function tickInterval(interval, start, stop, step) {
	    if (interval == null) interval = 10;
	
	    // If a desired tick count is specified, pick a reasonable tick interval
	    // based on the extent of the domain and a rough estimate of tick size.
	    // Otherwise, assume interval is already a time interval and use it.
	    if (typeof interval === "number") {
	      var target = Math.abs(stop - start) / interval,
	          i = d3Array.bisector(function(i) { return i[2]; }).right(tickIntervals, target);
	      if (i === tickIntervals.length) {
	        step = d3Array.tickStep(start / durationYear, stop / durationYear, interval);
	        interval = year;
	      } else if (i) {
	        i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
	        step = i[1];
	        interval = i[0];
	      } else {
	        step = Math.max(d3Array.tickStep(start, stop, interval), 1);
	        interval = millisecond;
	      }
	    }
	
	    return step == null ? interval : interval.every(step);
	  }
	
	  scale.invert = function(y) {
	    return new Date(invert(y));
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? domain(map.call(_, number$1)) : domain().map(date);
	  };
	
	  scale.ticks = function(interval, step) {
	    var d = domain(),
	        t0 = d[0],
	        t1 = d[d.length - 1],
	        r = t1 < t0,
	        t;
	    if (r) t = t0, t0 = t1, t1 = t;
	    t = tickInterval(interval, t0, t1, step);
	    t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
	    return r ? t.reverse() : t;
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    return specifier == null ? tickFormat : format(specifier);
	  };
	
	  scale.nice = function(interval, step) {
	    var d = domain();
	    return (interval = tickInterval(interval, d[0], d[d.length - 1], step))
	        ? domain(nice(d, interval))
	        : scale;
	  };
	
	  scale.copy = function() {
	    return copy(scale, calendar(year, month, week, day, hour, minute, second, millisecond, format));
	  };
	
	  return scale;
	}
	
	function time() {
	  return initRange.apply(calendar(d3Time.timeYear, d3Time.timeMonth, d3Time.timeWeek, d3Time.timeDay, d3Time.timeHour, d3Time.timeMinute, d3Time.timeSecond, d3Time.timeMillisecond, d3TimeFormat.timeFormat).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]), arguments);
	}
	
	function utcTime() {
	  return initRange.apply(calendar(d3Time.utcYear, d3Time.utcMonth, d3Time.utcWeek, d3Time.utcDay, d3Time.utcHour, d3Time.utcMinute, d3Time.utcSecond, d3Time.utcMillisecond, d3TimeFormat.utcFormat).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]), arguments);
	}
	
	function transformer$1() {
	  var x0 = 0,
	      x1 = 1,
	      t0,
	      t1,
	      k10,
	      transform,
	      interpolator = identity,
	      clamp = false,
	      unknown;
	
	  function scale(x) {
	    return isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (t0 = transform(x0 = +_[0]), t1 = transform(x1 = +_[1]), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [x0, x1];
	  };
	
	  scale.clamp = function(_) {
	    return arguments.length ? (clamp = !!_, scale) : clamp;
	  };
	
	  scale.interpolator = function(_) {
	    return arguments.length ? (interpolator = _, scale) : interpolator;
	  };
	
	  scale.unknown = function(_) {
	    return arguments.length ? (unknown = _, scale) : unknown;
	  };
	
	  return function(t) {
	    transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
	    return scale;
	  };
	}
	
	function copy$1(source, target) {
	  return target
	      .domain(source.domain())
	      .interpolator(source.interpolator())
	      .clamp(source.clamp())
	      .unknown(source.unknown());
	}
	
	function sequential() {
	  var scale = linearish(transformer$1()(identity));
	
	  scale.copy = function() {
	    return copy$1(scale, sequential());
	  };
	
	  return initInterpolator.apply(scale, arguments);
	}
	
	function sequentialLog() {
	  var scale = loggish(transformer$1()).domain([1, 10]);
	
	  scale.copy = function() {
	    return copy$1(scale, sequentialLog()).base(scale.base());
	  };
	
	  return initInterpolator.apply(scale, arguments);
	}
	
	function sequentialSymlog() {
	  var scale = symlogish(transformer$1());
	
	  scale.copy = function() {
	    return copy$1(scale, sequentialSymlog()).constant(scale.constant());
	  };
	
	  return initInterpolator.apply(scale, arguments);
	}
	
	function sequentialPow() {
	  var scale = powish(transformer$1());
	
	  scale.copy = function() {
	    return copy$1(scale, sequentialPow()).exponent(scale.exponent());
	  };
	
	  return initInterpolator.apply(scale, arguments);
	}
	
	function sequentialSqrt() {
	  return sequentialPow.apply(null, arguments).exponent(0.5);
	}
	
	function sequentialQuantile() {
	  var domain = [],
	      interpolator = identity;
	
	  function scale(x) {
	    if (!isNaN(x = +x)) return interpolator((d3Array.bisect(domain, x) - 1) / (domain.length - 1));
	  }
	
	  scale.domain = function(_) {
	    if (!arguments.length) return domain.slice();
	    domain = [];
	    for (var i = 0, n = _.length, d; i < n; ++i) if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
	    domain.sort(d3Array.ascending);
	    return scale;
	  };
	
	  scale.interpolator = function(_) {
	    return arguments.length ? (interpolator = _, scale) : interpolator;
	  };
	
	  scale.copy = function() {
	    return sequentialQuantile(interpolator).domain(domain);
	  };
	
	  return initInterpolator.apply(scale, arguments);
	}
	
	function transformer$2() {
	  var x0 = 0,
	      x1 = 0.5,
	      x2 = 1,
	      t0,
	      t1,
	      t2,
	      k10,
	      k21,
	      interpolator = identity,
	      transform,
	      clamp = false,
	      unknown;
	
	  function scale(x) {
	    return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (x < t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (t0 = transform(x0 = +_[0]), t1 = transform(x1 = +_[1]), t2 = transform(x2 = +_[2]), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), scale) : [x0, x1, x2];
	  };
	
	  scale.clamp = function(_) {
	    return arguments.length ? (clamp = !!_, scale) : clamp;
	  };
	
	  scale.interpolator = function(_) {
	    return arguments.length ? (interpolator = _, scale) : interpolator;
	  };
	
	  scale.unknown = function(_) {
	    return arguments.length ? (unknown = _, scale) : unknown;
	  };
	
	  return function(t) {
	    transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1);
	    return scale;
	  };
	}
	
	function diverging() {
	  var scale = linearish(transformer$2()(identity));
	
	  scale.copy = function() {
	    return copy$1(scale, diverging());
	  };
	
	  return initInterpolator.apply(scale, arguments);
	}
	
	function divergingLog() {
	  var scale = loggish(transformer$2()).domain([0.1, 1, 10]);
	
	  scale.copy = function() {
	    return copy$1(scale, divergingLog()).base(scale.base());
	  };
	
	  return initInterpolator.apply(scale, arguments);
	}
	
	function divergingSymlog() {
	  var scale = symlogish(transformer$2());
	
	  scale.copy = function() {
	    return copy$1(scale, divergingSymlog()).constant(scale.constant());
	  };
	
	  return initInterpolator.apply(scale, arguments);
	}
	
	function divergingPow() {
	  var scale = powish(transformer$2());
	
	  scale.copy = function() {
	    return copy$1(scale, divergingPow()).exponent(scale.exponent());
	  };
	
	  return initInterpolator.apply(scale, arguments);
	}
	
	function divergingSqrt() {
	  return divergingPow.apply(null, arguments).exponent(0.5);
	}
	
	exports.scaleBand = band;
	exports.scalePoint = point;
	exports.scaleIdentity = identity$1;
	exports.scaleLinear = linear;
	exports.scaleLog = log;
	exports.scaleSymlog = symlog;
	exports.scaleOrdinal = ordinal;
	exports.scaleImplicit = implicit;
	exports.scalePow = pow;
	exports.scaleSqrt = sqrt;
	exports.scaleQuantile = quantile;
	exports.scaleQuantize = quantize;
	exports.scaleThreshold = threshold;
	exports.scaleTime = time;
	exports.scaleUtc = utcTime;
	exports.scaleSequential = sequential;
	exports.scaleSequentialLog = sequentialLog;
	exports.scaleSequentialPow = sequentialPow;
	exports.scaleSequentialSqrt = sequentialSqrt;
	exports.scaleSequentialSymlog = sequentialSymlog;
	exports.scaleSequentialQuantile = sequentialQuantile;
	exports.scaleDiverging = diverging;
	exports.scaleDivergingLog = divergingLog;
	exports.scaleDivergingPow = divergingPow;
	exports.scaleDivergingSqrt = divergingSqrt;
	exports.scaleDivergingSymlog = divergingSymlog;
	exports.tickFormat = tickFormat;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 615 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-time/ v1.1.0 Copyright 2019 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(global = global || self, factory(global.d3 = global.d3 || {}));
	}(this, function (exports) { 'use strict';
	
	var t0 = new Date,
	    t1 = new Date;
	
	function newInterval(floori, offseti, count, field) {
	
	  function interval(date) {
	    return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
	  }
	
	  interval.floor = function(date) {
	    return floori(date = new Date(+date)), date;
	  };
	
	  interval.ceil = function(date) {
	    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
	  };
	
	  interval.round = function(date) {
	    var d0 = interval(date),
	        d1 = interval.ceil(date);
	    return date - d0 < d1 - date ? d0 : d1;
	  };
	
	  interval.offset = function(date, step) {
	    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
	  };
	
	  interval.range = function(start, stop, step) {
	    var range = [], previous;
	    start = interval.ceil(start);
	    step = step == null ? 1 : Math.floor(step);
	    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
	    do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
	    while (previous < start && start < stop);
	    return range;
	  };
	
	  interval.filter = function(test) {
	    return newInterval(function(date) {
	      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
	    }, function(date, step) {
	      if (date >= date) {
	        if (step < 0) while (++step <= 0) {
	          while (offseti(date, -1), !test(date)) {} // eslint-disable-line no-empty
	        } else while (--step >= 0) {
	          while (offseti(date, +1), !test(date)) {} // eslint-disable-line no-empty
	        }
	      }
	    });
	  };
	
	  if (count) {
	    interval.count = function(start, end) {
	      t0.setTime(+start), t1.setTime(+end);
	      floori(t0), floori(t1);
	      return Math.floor(count(t0, t1));
	    };
	
	    interval.every = function(step) {
	      step = Math.floor(step);
	      return !isFinite(step) || !(step > 0) ? null
	          : !(step > 1) ? interval
	          : interval.filter(field
	              ? function(d) { return field(d) % step === 0; }
	              : function(d) { return interval.count(0, d) % step === 0; });
	    };
	  }
	
	  return interval;
	}
	
	var millisecond = newInterval(function() {
	  // noop
	}, function(date, step) {
	  date.setTime(+date + step);
	}, function(start, end) {
	  return end - start;
	});
	
	// An optimized implementation for this simple case.
	millisecond.every = function(k) {
	  k = Math.floor(k);
	  if (!isFinite(k) || !(k > 0)) return null;
	  if (!(k > 1)) return millisecond;
	  return newInterval(function(date) {
	    date.setTime(Math.floor(date / k) * k);
	  }, function(date, step) {
	    date.setTime(+date + step * k);
	  }, function(start, end) {
	    return (end - start) / k;
	  });
	};
	var milliseconds = millisecond.range;
	
	var durationSecond = 1e3;
	var durationMinute = 6e4;
	var durationHour = 36e5;
	var durationDay = 864e5;
	var durationWeek = 6048e5;
	
	var second = newInterval(function(date) {
	  date.setTime(date - date.getMilliseconds());
	}, function(date, step) {
	  date.setTime(+date + step * durationSecond);
	}, function(start, end) {
	  return (end - start) / durationSecond;
	}, function(date) {
	  return date.getUTCSeconds();
	});
	var seconds = second.range;
	
	var minute = newInterval(function(date) {
	  date.setTime(date - date.getMilliseconds() - date.getSeconds() * durationSecond);
	}, function(date, step) {
	  date.setTime(+date + step * durationMinute);
	}, function(start, end) {
	  return (end - start) / durationMinute;
	}, function(date) {
	  return date.getMinutes();
	});
	var minutes = minute.range;
	
	var hour = newInterval(function(date) {
	  date.setTime(date - date.getMilliseconds() - date.getSeconds() * durationSecond - date.getMinutes() * durationMinute);
	}, function(date, step) {
	  date.setTime(+date + step * durationHour);
	}, function(start, end) {
	  return (end - start) / durationHour;
	}, function(date) {
	  return date.getHours();
	});
	var hours = hour.range;
	
	var day = newInterval(function(date) {
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setDate(date.getDate() + step);
	}, function(start, end) {
	  return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationDay;
	}, function(date) {
	  return date.getDate() - 1;
	});
	var days = day.range;
	
	function weekday(i) {
	  return newInterval(function(date) {
	    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
	    date.setHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setDate(date.getDate() + step * 7);
	  }, function(start, end) {
	    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationWeek;
	  });
	}
	
	var sunday = weekday(0);
	var monday = weekday(1);
	var tuesday = weekday(2);
	var wednesday = weekday(3);
	var thursday = weekday(4);
	var friday = weekday(5);
	var saturday = weekday(6);
	
	var sundays = sunday.range;
	var mondays = monday.range;
	var tuesdays = tuesday.range;
	var wednesdays = wednesday.range;
	var thursdays = thursday.range;
	var fridays = friday.range;
	var saturdays = saturday.range;
	
	var month = newInterval(function(date) {
	  date.setDate(1);
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setMonth(date.getMonth() + step);
	}, function(start, end) {
	  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
	}, function(date) {
	  return date.getMonth();
	});
	var months = month.range;
	
	var year = newInterval(function(date) {
	  date.setMonth(0, 1);
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setFullYear(date.getFullYear() + step);
	}, function(start, end) {
	  return end.getFullYear() - start.getFullYear();
	}, function(date) {
	  return date.getFullYear();
	});
	
	// An optimized implementation for this simple case.
	year.every = function(k) {
	  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
	    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
	    date.setMonth(0, 1);
	    date.setHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setFullYear(date.getFullYear() + step * k);
	  });
	};
	var years = year.range;
	
	var utcMinute = newInterval(function(date) {
	  date.setUTCSeconds(0, 0);
	}, function(date, step) {
	  date.setTime(+date + step * durationMinute);
	}, function(start, end) {
	  return (end - start) / durationMinute;
	}, function(date) {
	  return date.getUTCMinutes();
	});
	var utcMinutes = utcMinute.range;
	
	var utcHour = newInterval(function(date) {
	  date.setUTCMinutes(0, 0, 0);
	}, function(date, step) {
	  date.setTime(+date + step * durationHour);
	}, function(start, end) {
	  return (end - start) / durationHour;
	}, function(date) {
	  return date.getUTCHours();
	});
	var utcHours = utcHour.range;
	
	var utcDay = newInterval(function(date) {
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCDate(date.getUTCDate() + step);
	}, function(start, end) {
	  return (end - start) / durationDay;
	}, function(date) {
	  return date.getUTCDate() - 1;
	});
	var utcDays = utcDay.range;
	
	function utcWeekday(i) {
	  return newInterval(function(date) {
	    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
	    date.setUTCHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setUTCDate(date.getUTCDate() + step * 7);
	  }, function(start, end) {
	    return (end - start) / durationWeek;
	  });
	}
	
	var utcSunday = utcWeekday(0);
	var utcMonday = utcWeekday(1);
	var utcTuesday = utcWeekday(2);
	var utcWednesday = utcWeekday(3);
	var utcThursday = utcWeekday(4);
	var utcFriday = utcWeekday(5);
	var utcSaturday = utcWeekday(6);
	
	var utcSundays = utcSunday.range;
	var utcMondays = utcMonday.range;
	var utcTuesdays = utcTuesday.range;
	var utcWednesdays = utcWednesday.range;
	var utcThursdays = utcThursday.range;
	var utcFridays = utcFriday.range;
	var utcSaturdays = utcSaturday.range;
	
	var utcMonth = newInterval(function(date) {
	  date.setUTCDate(1);
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCMonth(date.getUTCMonth() + step);
	}, function(start, end) {
	  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
	}, function(date) {
	  return date.getUTCMonth();
	});
	var utcMonths = utcMonth.range;
	
	var utcYear = newInterval(function(date) {
	  date.setUTCMonth(0, 1);
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCFullYear(date.getUTCFullYear() + step);
	}, function(start, end) {
	  return end.getUTCFullYear() - start.getUTCFullYear();
	}, function(date) {
	  return date.getUTCFullYear();
	});
	
	// An optimized implementation for this simple case.
	utcYear.every = function(k) {
	  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
	    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
	    date.setUTCMonth(0, 1);
	    date.setUTCHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setUTCFullYear(date.getUTCFullYear() + step * k);
	  });
	};
	var utcYears = utcYear.range;
	
	exports.timeDay = day;
	exports.timeDays = days;
	exports.timeFriday = friday;
	exports.timeFridays = fridays;
	exports.timeHour = hour;
	exports.timeHours = hours;
	exports.timeInterval = newInterval;
	exports.timeMillisecond = millisecond;
	exports.timeMilliseconds = milliseconds;
	exports.timeMinute = minute;
	exports.timeMinutes = minutes;
	exports.timeMonday = monday;
	exports.timeMondays = mondays;
	exports.timeMonth = month;
	exports.timeMonths = months;
	exports.timeSaturday = saturday;
	exports.timeSaturdays = saturdays;
	exports.timeSecond = second;
	exports.timeSeconds = seconds;
	exports.timeSunday = sunday;
	exports.timeSundays = sundays;
	exports.timeThursday = thursday;
	exports.timeThursdays = thursdays;
	exports.timeTuesday = tuesday;
	exports.timeTuesdays = tuesdays;
	exports.timeWednesday = wednesday;
	exports.timeWednesdays = wednesdays;
	exports.timeWeek = sunday;
	exports.timeWeeks = sundays;
	exports.timeYear = year;
	exports.timeYears = years;
	exports.utcDay = utcDay;
	exports.utcDays = utcDays;
	exports.utcFriday = utcFriday;
	exports.utcFridays = utcFridays;
	exports.utcHour = utcHour;
	exports.utcHours = utcHours;
	exports.utcMillisecond = millisecond;
	exports.utcMilliseconds = milliseconds;
	exports.utcMinute = utcMinute;
	exports.utcMinutes = utcMinutes;
	exports.utcMonday = utcMonday;
	exports.utcMondays = utcMondays;
	exports.utcMonth = utcMonth;
	exports.utcMonths = utcMonths;
	exports.utcSaturday = utcSaturday;
	exports.utcSaturdays = utcSaturdays;
	exports.utcSecond = second;
	exports.utcSeconds = seconds;
	exports.utcSunday = utcSunday;
	exports.utcSundays = utcSundays;
	exports.utcThursday = utcThursday;
	exports.utcThursdays = utcThursdays;
	exports.utcTuesday = utcTuesday;
	exports.utcTuesdays = utcTuesdays;
	exports.utcWednesday = utcWednesday;
	exports.utcWednesdays = utcWednesdays;
	exports.utcWeek = utcSunday;
	exports.utcWeeks = utcSundays;
	exports.utcYear = utcYear;
	exports.utcYears = utcYears;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	}));


/***/ },
/* 616 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = assign;
	
	function assign(target, dirtyObject) {
	  if (target == null) {
	    throw new TypeError('assign requires that input parameter not be null or undefined');
	  }
	
	  dirtyObject = dirtyObject || {};
	
	  for (var property in dirtyObject) {
	    if (Object.prototype.hasOwnProperty.call(dirtyObject, property)) {
	      target[property] = dirtyObject[property];
	    }
	  }
	
	  return target;
	}
	
	module.exports = exports.default;

/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = cloneObject;
	
	var _index = _interopRequireDefault(__webpack_require__(616));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function cloneObject(dirtyObject) {
	  return (0, _index.default)({}, dirtyObject);
	}
	
	module.exports = exports.default;

/***/ },
/* 618 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(169));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * |     | Unit                           |     | Unit                           |
	 * |-----|--------------------------------|-----|--------------------------------|
	 * |  a  | AM, PM                         |  A* |                                |
	 * |  d  | Day of month                   |  D  |                                |
	 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
	 * |  m  | Minute                         |  M  | Month                          |
	 * |  s  | Second                         |  S  | Fraction of second             |
	 * |  y  | Year (abs)                     |  Y  |                                |
	 *
	 * Letters marked by * are not implemented but reserved by Unicode standard.
	 */
	var formatters = {
	  // Year
	  y: function (date, token) {
	    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
	    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
	    // |----------|-------|----|-------|-------|-------|
	    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
	    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
	    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
	    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
	    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
	    var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
	
	    var year = signedYear > 0 ? signedYear : 1 - signedYear;
	    return (0, _index.default)(token === 'yy' ? year % 100 : year, token.length);
	  },
	  // Month
	  M: function (date, token) {
	    var month = date.getUTCMonth();
	    return token === 'M' ? String(month + 1) : (0, _index.default)(month + 1, 2);
	  },
	  // Day of the month
	  d: function (date, token) {
	    return (0, _index.default)(date.getUTCDate(), token.length);
	  },
	  // AM or PM
	  a: function (date, token) {
	    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
	
	    switch (token) {
	      case 'a':
	      case 'aa':
	        return dayPeriodEnumValue.toUpperCase();
	
	      case 'aaa':
	        return dayPeriodEnumValue;
	
	      case 'aaaaa':
	        return dayPeriodEnumValue[0];
	
	      case 'aaaa':
	      default:
	        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
	    }
	  },
	  // Hour [1-12]
	  h: function (date, token) {
	    return (0, _index.default)(date.getUTCHours() % 12 || 12, token.length);
	  },
	  // Hour [0-23]
	  H: function (date, token) {
	    return (0, _index.default)(date.getUTCHours(), token.length);
	  },
	  // Minute
	  m: function (date, token) {
	    return (0, _index.default)(date.getUTCMinutes(), token.length);
	  },
	  // Second
	  s: function (date, token) {
	    return (0, _index.default)(date.getUTCSeconds(), token.length);
	  },
	  // Fraction of second
	  S: function (date, token) {
	    var numberOfDigits = token.length;
	    var milliseconds = date.getUTCMilliseconds();
	    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
	    return (0, _index.default)(fractionalSeconds, token.length);
	  }
	};
	var _default = formatters;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 619 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	function dateLongFormatter(pattern, formatLong) {
	  switch (pattern) {
	    case 'P':
	      return formatLong.date({
	        width: 'short'
	      });
	
	    case 'PP':
	      return formatLong.date({
	        width: 'medium'
	      });
	
	    case 'PPP':
	      return formatLong.date({
	        width: 'long'
	      });
	
	    case 'PPPP':
	    default:
	      return formatLong.date({
	        width: 'full'
	      });
	  }
	}
	
	function timeLongFormatter(pattern, formatLong) {
	  switch (pattern) {
	    case 'p':
	      return formatLong.time({
	        width: 'short'
	      });
	
	    case 'pp':
	      return formatLong.time({
	        width: 'medium'
	      });
	
	    case 'ppp':
	      return formatLong.time({
	        width: 'long'
	      });
	
	    case 'pppp':
	    default:
	      return formatLong.time({
	        width: 'full'
	      });
	  }
	}
	
	function dateTimeLongFormatter(pattern, formatLong) {
	  var matchResult = pattern.match(/(P+)(p+)?/) || [];
	  var datePattern = matchResult[1];
	  var timePattern = matchResult[2];
	
	  if (!timePattern) {
	    return dateLongFormatter(pattern, formatLong);
	  }
	
	  var dateTimeFormat;
	
	  switch (datePattern) {
	    case 'P':
	      dateTimeFormat = formatLong.dateTime({
	        width: 'short'
	      });
	      break;
	
	    case 'PP':
	      dateTimeFormat = formatLong.dateTime({
	        width: 'medium'
	      });
	      break;
	
	    case 'PPP':
	      dateTimeFormat = formatLong.dateTime({
	        width: 'long'
	      });
	      break;
	
	    case 'PPPP':
	    default:
	      dateTimeFormat = formatLong.dateTime({
	        width: 'full'
	      });
	      break;
	  }
	
	  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
	}
	
	var longFormatters = {
	  p: timeLongFormatter,
	  P: dateTimeLongFormatter
	};
	var _default = longFormatters;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 620 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUTCISOWeekYear;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	var _index3 = _interopRequireDefault(__webpack_require__(259));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function getUTCISOWeekYear(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getUTCFullYear();
	  var fourthOfJanuaryOfNextYear = new Date(0);
	  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
	  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
	  var startOfNextYear = (0, _index3.default)(fourthOfJanuaryOfNextYear);
	  var fourthOfJanuaryOfThisYear = new Date(0);
	  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
	  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
	  var startOfThisYear = (0, _index3.default)(fourthOfJanuaryOfThisYear);
	
	  if (date.getTime() >= startOfNextYear.getTime()) {
	    return year + 1;
	  } else if (date.getTime() >= startOfThisYear.getTime()) {
	    return year;
	  } else {
	    return year - 1;
	  }
	}
	
	module.exports = exports.default;

/***/ },
/* 621 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUTCISOWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(259));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1540));
	
	var _index4 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	
	function getUTCISOWeek(dirtyDate) {
	  (0, _index4.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var diff = (0, _index2.default)(date).getTime() - (0, _index3.default)(date).getTime(); // Round the number of days to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	
	  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
	}
	
	module.exports = exports.default;

/***/ },
/* 622 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUTCWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(260));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1541));
	
	var _index4 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	
	function getUTCWeek(dirtyDate, options) {
	  (0, _index4.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var diff = (0, _index2.default)(date, options).getTime() - (0, _index3.default)(date, options).getTime(); // Round the number of days to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	
	  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
	}
	
	module.exports = exports.default;

/***/ },
/* 623 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isProtectedDayOfYearToken = isProtectedDayOfYearToken;
	exports.isProtectedWeekYearToken = isProtectedWeekYearToken;
	exports.throwProtectedError = throwProtectedError;
	var protectedDayOfYearTokens = ['D', 'DD'];
	var protectedWeekYearTokens = ['YY', 'YYYY'];
	
	function isProtectedDayOfYearToken(token) {
	  return protectedDayOfYearTokens.indexOf(token) !== -1;
	}
	
	function isProtectedWeekYearToken(token) {
	  return protectedWeekYearTokens.indexOf(token) !== -1;
	}
	
	function throwProtectedError(token, format, input) {
	  if (token === 'YYYY') {
	    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
	  } else if (token === 'YY') {
	    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
	  } else if (token === 'D') {
	    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
	  } else if (token === 'DD') {
	    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
	  }
	}

/***/ },
/* 624 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addBusinessDays;
	
	var _index = _interopRequireDefault(__webpack_require__(267));
	
	var _index2 = _interopRequireDefault(__webpack_require__(9));
	
	var _index3 = _interopRequireDefault(__webpack_require__(26));
	
	var _index4 = _interopRequireDefault(__webpack_require__(6));
	
	var _index5 = _interopRequireDefault(__webpack_require__(403));
	
	var _index6 = _interopRequireDefault(__webpack_require__(653));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name addBusinessDays
	 * @category Day Helpers
	 * @summary Add the specified number of business days (mon - fri) to the given date.
	 *
	 * @description
	 * Add the specified number of business days (mon - fri) to the given date, ignoring weekends.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of business days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the business days added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 10 business days to 1 September 2014:
	 * const result = addBusinessDays(new Date(2014, 8, 1), 10)
	 * //=> Mon Sep 15 2014 00:00:00 (skipped weekend days)
	 */
	function addBusinessDays(dirtyDate, dirtyAmount) {
	  (0, _index4.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var startedOnWeekend = (0, _index.default)(date);
	  var amount = (0, _index3.default)(dirtyAmount);
	  if (isNaN(amount)) return new Date(NaN);
	  var hours = date.getHours();
	  var sign = amount < 0 ? -1 : 1;
	  var fullWeeks = (0, _index3.default)(amount / 5);
	  date.setDate(date.getDate() + fullWeeks * 7); // Get remaining days not part of a full week
	
	  var restDays = Math.abs(amount % 5); // Loops over remaining days
	
	  while (restDays > 0) {
	    date.setDate(date.getDate() + sign);
	    if (!(0, _index.default)(date)) restDays -= 1;
	  } // If the date is a weekend day and we reduce a dividable of
	  // 5 from it, we land on a weekend date.
	  // To counter this, we add days accordingly to land on the next business day
	
	
	  if (startedOnWeekend && (0, _index.default)(date) && amount !== 0) {
	    // If we're reducing days, we want to add days until we land on a weekday
	    // If we're adding days we want to reduce days until we land on a weekday
	    if ((0, _index6.default)(date)) date.setDate(date.getDate() + (sign < 0 ? 2 : -1));
	    if ((0, _index5.default)(date)) date.setDate(date.getDate() + (sign < 0 ? 1 : -2));
	  } // Restore hours to avoid DST lag
	
	
	  date.setHours(hours);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 625 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addISOWeekYears;
	
	var _index = _interopRequireDefault(__webpack_require__(26));
	
	var _index2 = _interopRequireDefault(__webpack_require__(171));
	
	var _index3 = _interopRequireDefault(__webpack_require__(660));
	
	var _index4 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name addISOWeekYears
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Add the specified number of ISO week-numbering years to the given date.
	 *
	 * @description
	 * Add the specified number of ISO week-numbering years to the given date.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `addISOYears` to `addISOWeekYears`.
	 *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
	 *   This change makes the name consistent with
	 *   locale-dependent week-numbering year helpers, e.g., `addWeekYears`.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of ISO week-numbering years to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the ISO week-numbering years added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 5 ISO week-numbering years to 2 July 2010:
	 * const result = addISOWeekYears(new Date(2010, 6, 2), 5)
	 * //=> Fri Jun 26 2015 00:00:00
	 */
	function addISOWeekYears(dirtyDate, dirtyAmount) {
	  (0, _index4.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index3.default)(dirtyDate, (0, _index2.default)(dirtyDate) + amount);
	}
	
	module.exports = exports.default;

/***/ },
/* 626 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addSeconds;
	
	var _index = _interopRequireDefault(__webpack_require__(26));
	
	var _index2 = _interopRequireDefault(__webpack_require__(208));
	
	var _index3 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name addSeconds
	 * @category Second Helpers
	 * @summary Add the specified number of seconds to the given date.
	 *
	 * @description
	 * Add the specified number of seconds to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of seconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the seconds added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 30 seconds to 10 July 2014 12:45:00:
	 * const result = addSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
	 * //=> Thu Jul 10 2014 12:45:30
	 */
	function addSeconds(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, amount * 1000);
	}
	
	module.exports = exports.default;

/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInCalendarISOWeekYears;
	
	var _index = _interopRequireDefault(__webpack_require__(171));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInCalendarISOWeekYears
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Get the number of calendar ISO week-numbering years between the given dates.
	 *
	 * @description
	 * Get the number of calendar ISO week-numbering years between the given dates.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `differenceInCalendarISOYears` to `differenceInCalendarISOWeekYears`.
	 *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
	 *   This change makes the name consistent with
	 *   locale-dependent week-numbering year helpers, e.g., `addWeekYears`.
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of calendar ISO week-numbering years
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many calendar ISO week-numbering years are 1 January 2010 and 1 January 2012?
	 * const result = differenceInCalendarISOWeekYears(
	 *   new Date(2012, 0, 1),
	 *   new Date(2010, 0, 1)
	 * )
	 * //=> 2
	 */
	function differenceInCalendarISOWeekYears(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  return (0, _index.default)(dirtyDateLeft) - (0, _index.default)(dirtyDateRight);
	}
	
	module.exports = exports.default;

/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInHours;
	
	var _index = __webpack_require__(45);
	
	var _index2 = _interopRequireDefault(__webpack_require__(263));
	
	var _index3 = _interopRequireDefault(__webpack_require__(6));
	
	var _index4 = __webpack_require__(207);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInHours
	 * @category Hour Helpers
	 * @summary Get the number of hours between the given dates.
	 *
	 * @description
	 * Get the number of hours between the given dates.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @param {Object} [options] - an object with options.
	 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
	 * @returns {Number} the number of hours
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many hours are between 2 July 2014 06:50:00 and 2 July 2014 19:00:00?
	 * const result = differenceInHours(
	 *   new Date(2014, 6, 2, 19, 0),
	 *   new Date(2014, 6, 2, 6, 50)
	 * )
	 * //=> 12
	 */
	function differenceInHours(dateLeft, dateRight, options) {
	  (0, _index3.default)(2, arguments);
	
	  var diff = (0, _index2.default)(dateLeft, dateRight) / _index.millisecondsInHour;
	
	  return (0, _index4.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
	}
	
	module.exports = exports.default;

/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInMinutes;
	
	var _index = __webpack_require__(45);
	
	var _index2 = _interopRequireDefault(__webpack_require__(263));
	
	var _index3 = _interopRequireDefault(__webpack_require__(6));
	
	var _index4 = __webpack_require__(207);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInMinutes
	 * @category Minute Helpers
	 * @summary Get the number of minutes between the given dates.
	 *
	 * @description
	 * Get the signed number of full (rounded towards 0) minutes between the given dates.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @param {Object} [options] - an object with options.
	 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
	 * @returns {Number} the number of minutes
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many minutes are between 2 July 2014 12:07:59 and 2 July 2014 12:20:00?
	 * const result = differenceInMinutes(
	 *   new Date(2014, 6, 2, 12, 20, 0),
	 *   new Date(2014, 6, 2, 12, 7, 59)
	 * )
	 * //=> 12
	 *
	 * @example
	 * // How many minutes are between 10:01:59 and 10:00:00
	 * const result = differenceInMinutes(
	 *   new Date(2000, 0, 1, 10, 0, 0),
	 *   new Date(2000, 0, 1, 10, 1, 59)
	 * )
	 * //=> -1
	 */
	function differenceInMinutes(dateLeft, dateRight, options) {
	  (0, _index3.default)(2, arguments);
	
	  var diff = (0, _index2.default)(dateLeft, dateRight) / _index.millisecondsInMinute;
	
	  return (0, _index4.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
	}
	
	module.exports = exports.default;

/***/ },
/* 630 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInYears;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(388));
	
	var _index3 = _interopRequireDefault(__webpack_require__(146));
	
	var _index4 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInYears
	 * @category Year Helpers
	 * @summary Get the number of full years between the given dates.
	 *
	 * @description
	 * Get the number of full years between the given dates.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of full years
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many full years are between 31 December 2013 and 11 February 2015?
	 * const result = differenceInYears(new Date(2015, 1, 11), new Date(2013, 11, 31))
	 * //=> 1
	 */
	function differenceInYears(dirtyDateLeft, dirtyDateRight) {
	  (0, _index4.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  var sign = (0, _index3.default)(dateLeft, dateRight);
	  var difference = Math.abs((0, _index2.default)(dateLeft, dateRight)); // Set both dates to a valid leap year for accurate comparison when dealing
	  // with leap days
	
	  dateLeft.setFullYear(1584);
	  dateRight.setFullYear(1584); // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
	  // If so, result must be decreased by 1 in absolute value
	
	  var isLastYearNotFull = (0, _index3.default)(dateLeft, dateRight) === -sign;
	  var result = sign * (difference - Number(isLastYearNotFull)); // Prevent negative zero
	
	  return result === 0 ? 0 : result;
	}
	
	module.exports = exports.default;

/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = eachDayOfInterval;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name eachDayOfInterval
	 * @category Interval Helpers
	 * @summary Return the array of dates within the specified time interval.
	 *
	 * @description
	 * Return the array of dates within the specified time interval.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `eachDay` to `eachDayOfInterval`.
	 *   This change was made to mirror the use of the word "interval" in standard ISO 8601:2004 terminology:
	 *
	 *   ```
	 *   2.1.3
	 *   time interval
	 *   part of the time axis limited by two instants
	 *   ```
	 *
	 *   Also, this function now accepts an object with `start` and `end` properties
	 *   instead of two arguments as an interval.
	 *   This function now throws `RangeError` if the start of the interval is after its end
	 *   or if any date in the interval is `Invalid Date`.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *
	 *   eachDay(new Date(2014, 0, 10), new Date(2014, 0, 20))
	 *
	 *   // v2.0.0 onward
	 *
	 *   eachDayOfInterval(
	 *     { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) }
	 *   )
	 *   ```
	 *
	 * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
	 * @param {Object} [options] - an object with options.
	 * @param {Number} [options.step=1] - the step to increment by. The value should be more than 1.
	 * @returns {Date[]} the array with starts of days from the day of the interval start to the day of the interval end
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.step` must be a number greater than 1
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // Each day between 6 October 2014 and 10 October 2014:
	 * const result = eachDayOfInterval({
	 *   start: new Date(2014, 9, 6),
	 *   end: new Date(2014, 9, 10)
	 * })
	 * //=> [
	 * //   Mon Oct 06 2014 00:00:00,
	 * //   Tue Oct 07 2014 00:00:00,
	 * //   Wed Oct 08 2014 00:00:00,
	 * //   Thu Oct 09 2014 00:00:00,
	 * //   Fri Oct 10 2014 00:00:00
	 * // ]
	 */
	function eachDayOfInterval(dirtyInterval, options) {
	  (0, _index2.default)(1, arguments);
	  var interval = dirtyInterval || {};
	  var startDate = (0, _index.default)(interval.start);
	  var endDate = (0, _index.default)(interval.end);
	  var endTime = endDate.getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`
	
	  if (!(startDate.getTime() <= endTime)) {
	    throw new RangeError('Invalid interval');
	  }
	
	  var dates = [];
	  var currentDate = startDate;
	  currentDate.setHours(0, 0, 0, 0);
	  var step = options && 'step' in options ? Number(options.step) : 1;
	  if (step < 1 || isNaN(step)) throw new RangeError('`options.step` must be a number greater than 1');
	
	  while (currentDate.getTime() <= endTime) {
	    dates.push((0, _index.default)(currentDate));
	    currentDate.setDate(currentDate.getDate() + step);
	    currentDate.setHours(0, 0, 0, 0);
	  }
	
	  return dates;
	}
	
	module.exports = exports.default;

/***/ },
/* 632 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfYear;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name endOfYear
	 * @category Year Helpers
	 * @summary Return the end of a year for the given date.
	 *
	 * @description
	 * Return the end of a year for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of a year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of a year for 2 September 2014 11:55:00:
	 * var result = endOfYear(new Date(2014, 8, 2, 11, 55, 00))
	 * //=> Wed Dec 31 2014 23:59:59.999
	 */
	function endOfYear(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  date.setFullYear(year + 1, 0, 0);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 633 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistanceStrict;
	
	var _index = _interopRequireDefault(__webpack_require__(107));
	
	var _index2 = _interopRequireDefault(__webpack_require__(146));
	
	var _index3 = _interopRequireDefault(__webpack_require__(9));
	
	var _index4 = _interopRequireDefault(__webpack_require__(617));
	
	var _index5 = _interopRequireDefault(__webpack_require__(108));
	
	var _index6 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_MINUTE = 1000 * 60;
	var MINUTES_IN_DAY = 60 * 24;
	var MINUTES_IN_MONTH = MINUTES_IN_DAY * 30;
	var MINUTES_IN_YEAR = MINUTES_IN_DAY * 365;
	/**
	 * @name formatDistanceStrict
	 * @category Common Helpers
	 * @summary Return the distance between the given dates in words.
	 *
	 * @description
	 * Return the distance between the given dates in words, using strict units.
	 * This is like `formatDistance`, but does not use helpers like 'almost', 'over',
	 * 'less than' and the like.
	 *
	 * | Distance between dates | Result              |
	 * |------------------------|---------------------|
	 * | 0 ... 59 secs          | [0..59] seconds     |
	 * | 1 ... 59 mins          | [1..59] minutes     |
	 * | 1 ... 23 hrs           | [1..23] hours       |
	 * | 1 ... 29 days          | [1..29] days        |
	 * | 1 ... 11 months        | [1..11] months      |
	 * | 1 ... N years          | [1..N]  years       |
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `distanceInWordsStrict` to `formatDistanceStrict`
	 *   to make its name consistent with `format` and `formatRelative`.
	 *
	 * - The order of arguments is swapped to make the function
	 *   consistent with `differenceIn...` functions.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *
	 *   distanceInWordsStrict(
	 *     new Date(2015, 0, 2),
	 *     new Date(2014, 6, 2)
	 *   ) //=> '6 months'
	 *
	 *   // v2.0.0 onward
	 *
	 *   formatDistanceStrict(
	 *     new Date(2014, 6, 2),
	 *     new Date(2015, 0, 2)
	 *   ) //=> '6 months'
	 *   ```
	 *
	 * - `partialMethod` option is renamed to `roundingMethod`.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *
	 *   distanceInWordsStrict(
	 *     new Date(1986, 3, 4, 10, 32, 0),
	 *     new Date(1986, 3, 4, 10, 33, 1),
	 *     { partialMethod: 'ceil' }
	 *   ) //=> '2 minutes'
	 *
	 *   // v2.0.0 onward
	 *
	 *   formatDistanceStrict(
	 *     new Date(1986, 3, 4, 10, 33, 1),
	 *     new Date(1986, 3, 4, 10, 32, 0),
	 *     { roundingMethod: 'ceil' }
	 *   ) //=> '2 minutes'
	 *   ```
	 *
	 * - If `roundingMethod` is not specified, it now defaults to `round` instead of `floor`.
	 *
	 * - `unit` option now accepts one of the strings:
	 *   'second', 'minute', 'hour', 'day', 'month' or 'year' instead of 's', 'm', 'h', 'd', 'M' or 'Y'
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *
	 *   distanceInWordsStrict(
	 *     new Date(1986, 3, 4, 10, 32, 0),
	 *     new Date(1986, 3, 4, 10, 33, 1),
	 *     { unit: 'm' }
	 *   )
	 *
	 *   // v2.0.0 onward
	 *
	 *   formatDistanceStrict(
	 *     new Date(1986, 3, 4, 10, 33, 1),
	 *     new Date(1986, 3, 4, 10, 32, 0),
	 *     { unit: 'minute' }
	 *   )
	 *   ```
	 *
	 * @param {Date|Number} date - the date
	 * @param {Date|Number} baseDate - the date to compare with
	 * @param {Object} [options] - an object with options.
	 * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
	 * @param {'second'|'minute'|'hour'|'day'|'month'|'year'} [options.unit] - if specified, will force a unit
	 * @param {'floor'|'ceil'|'round'} [options.roundingMethod='round'] - which way to round partial units
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @returns {String} the distance in words
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `date` must not be Invalid Date
	 * @throws {RangeError} `baseDate` must not be Invalid Date
	 * @throws {RangeError} `options.roundingMethod` must be 'floor', 'ceil' or 'round'
	 * @throws {RangeError} `options.unit` must be 'second', 'minute', 'hour', 'day', 'month' or 'year'
	 * @throws {RangeError} `options.locale` must contain `formatDistance` property
	 *
	 * @example
	 * // What is the distance between 2 July 2014 and 1 January 2015?
	 * const result = formatDistanceStrict(new Date(2014, 6, 2), new Date(2015, 0, 2))
	 * //=> '6 months'
	 *
	 * @example
	 * // What is the distance between 1 January 2015 00:00:15
	 * // and 1 January 2015 00:00:00?
	 * const result = formatDistanceStrict(
	 *   new Date(2015, 0, 1, 0, 0, 15),
	 *   new Date(2015, 0, 1, 0, 0, 0)
	 * )
	 * //=> '15 seconds'
	 *
	 * @example
	 * // What is the distance from 1 January 2016
	 * // to 1 January 2015, with a suffix?
	 * const result = formatDistanceStrict(new Date(2015, 0, 1), new Date(2016, 0, 1), {
	 *   addSuffix: true
	 * })
	 * //=> '1 year ago'
	 *
	 * @example
	 * // What is the distance from 1 January 2016
	 * // to 1 January 2015, in minutes?
	 * const result = formatDistanceStrict(new Date(2016, 0, 1), new Date(2015, 0, 1), {
	 *   unit: 'minute'
	 * })
	 * //=> '525600 minutes'
	 *
	 * @example
	 * // What is the distance from 1 January 2015
	 * // to 28 January 2015, in months, rounded up?
	 * const result = formatDistanceStrict(new Date(2015, 0, 28), new Date(2015, 0, 1), {
	 *   unit: 'month',
	 *   roundingMethod: 'ceil'
	 * })
	 * //=> '1 month'
	 *
	 * @example
	 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
	 * import { eoLocale } from 'date-fns/locale/eo'
	 * const result = formatDistanceStrict(new Date(2016, 7, 1), new Date(2015, 0, 1), {
	 *   locale: eoLocale
	 * })
	 * //=> '1 jaro'
	 */
	
	function formatDistanceStrict(dirtyDate, dirtyBaseDate) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  (0, _index6.default)(2, arguments);
	  var locale = options.locale || _index5.default;
	
	  if (!locale.formatDistance) {
	    throw new RangeError('locale must contain localize.formatDistance property');
	  }
	
	  var comparison = (0, _index2.default)(dirtyDate, dirtyBaseDate);
	
	  if (isNaN(comparison)) {
	    throw new RangeError('Invalid time value');
	  }
	
	  var localizeOptions = (0, _index4.default)(options);
	  localizeOptions.addSuffix = Boolean(options.addSuffix);
	  localizeOptions.comparison = comparison;
	  var dateLeft;
	  var dateRight;
	
	  if (comparison > 0) {
	    dateLeft = (0, _index3.default)(dirtyBaseDate);
	    dateRight = (0, _index3.default)(dirtyDate);
	  } else {
	    dateLeft = (0, _index3.default)(dirtyDate);
	    dateRight = (0, _index3.default)(dirtyBaseDate);
	  }
	
	  var roundingMethod = options.roundingMethod == null ? 'round' : String(options.roundingMethod);
	  var roundingMethodFn;
	
	  if (roundingMethod === 'floor') {
	    roundingMethodFn = Math.floor;
	  } else if (roundingMethod === 'ceil') {
	    roundingMethodFn = Math.ceil;
	  } else if (roundingMethod === 'round') {
	    roundingMethodFn = Math.round;
	  } else {
	    throw new RangeError("roundingMethod must be 'floor', 'ceil' or 'round'");
	  }
	
	  var milliseconds = dateRight.getTime() - dateLeft.getTime();
	  var minutes = milliseconds / MILLISECONDS_IN_MINUTE;
	  var timezoneOffset = (0, _index.default)(dateRight) - (0, _index.default)(dateLeft); // Use DST-normalized difference in minutes for years, months and days;
	  // use regular difference in minutes for hours, minutes and seconds.
	
	  var dstNormalizedMinutes = (milliseconds - timezoneOffset) / MILLISECONDS_IN_MINUTE;
	  var unit;
	
	  if (options.unit == null) {
	    if (minutes < 1) {
	      unit = 'second';
	    } else if (minutes < 60) {
	      unit = 'minute';
	    } else if (minutes < MINUTES_IN_DAY) {
	      unit = 'hour';
	    } else if (dstNormalizedMinutes < MINUTES_IN_MONTH) {
	      unit = 'day';
	    } else if (dstNormalizedMinutes < MINUTES_IN_YEAR) {
	      unit = 'month';
	    } else {
	      unit = 'year';
	    }
	  } else {
	    unit = String(options.unit);
	  } // 0 up to 60 seconds
	
	
	  if (unit === 'second') {
	    var seconds = roundingMethodFn(milliseconds / 1000);
	    return locale.formatDistance('xSeconds', seconds, localizeOptions); // 1 up to 60 mins
	  } else if (unit === 'minute') {
	    var roundedMinutes = roundingMethodFn(minutes);
	    return locale.formatDistance('xMinutes', roundedMinutes, localizeOptions); // 1 up to 24 hours
	  } else if (unit === 'hour') {
	    var hours = roundingMethodFn(minutes / 60);
	    return locale.formatDistance('xHours', hours, localizeOptions); // 1 up to 30 days
	  } else if (unit === 'day') {
	    var days = roundingMethodFn(dstNormalizedMinutes / MINUTES_IN_DAY);
	    return locale.formatDistance('xDays', days, localizeOptions); // 1 up to 12 months
	  } else if (unit === 'month') {
	    var months = roundingMethodFn(dstNormalizedMinutes / MINUTES_IN_MONTH);
	    return months === 12 && options.unit !== 'month' ? locale.formatDistance('xYears', 1, localizeOptions) : locale.formatDistance('xMonths', months, localizeOptions); // 1 year up to max Date
	  } else if (unit === 'year') {
	    var years = roundingMethodFn(dstNormalizedMinutes / MINUTES_IN_YEAR);
	    return locale.formatDistance('xYears', years, localizeOptions);
	  }
	
	  throw new RangeError("unit must be 'second', 'minute', 'hour', 'day', 'month' or 'year'");
	}
	
	module.exports = exports.default;

/***/ },
/* 634 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	
	var _index = _interopRequireDefault(__webpack_require__(146));
	
	var _index2 = _interopRequireDefault(__webpack_require__(264));
	
	var _index3 = _interopRequireDefault(__webpack_require__(390));
	
	var _index4 = _interopRequireDefault(__webpack_require__(108));
	
	var _index5 = _interopRequireDefault(__webpack_require__(9));
	
	var _index6 = _interopRequireDefault(__webpack_require__(617));
	
	var _index7 = _interopRequireDefault(__webpack_require__(107));
	
	var _index8 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MINUTES_IN_DAY = 1440;
	var MINUTES_IN_ALMOST_TWO_DAYS = 2520;
	var MINUTES_IN_MONTH = 43200;
	var MINUTES_IN_TWO_MONTHS = 86400;
	/**
	 * @name formatDistance
	 * @category Common Helpers
	 * @summary Return the distance between the given dates in words.
	 *
	 * @description
	 * Return the distance between the given dates in words.
	 *
	 * | Distance between dates                                            | Result              |
	 * |-------------------------------------------------------------------|---------------------|
	 * | 0 ... 30 secs                                                     | less than a minute  |
	 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
	 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
	 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
	 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
	 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
	 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
	 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
	 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
	 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
	 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
	 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
	 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
	 * | N yrs ... N yrs 3 months                                          | about N years       |
	 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
	 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
	 *
	 * With `options.includeSeconds == true`:
	 * | Distance between dates | Result               |
	 * |------------------------|----------------------|
	 * | 0 secs ... 5 secs      | less than 5 seconds  |
	 * | 5 secs ... 10 secs     | less than 10 seconds |
	 * | 10 secs ... 20 secs    | less than 20 seconds |
	 * | 20 secs ... 40 secs    | half a minute        |
	 * | 40 secs ... 60 secs    | less than a minute   |
	 * | 60 secs ... 90 secs    | 1 minute             |
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `distanceInWords ` to `formatDistance`
	 *   to make its name consistent with `format` and `formatRelative`.
	 *
	 * - The order of arguments is swapped to make the function
	 *   consistent with `differenceIn...` functions.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *
	 *   distanceInWords(
	 *     new Date(1986, 3, 4, 10, 32, 0),
	 *     new Date(1986, 3, 4, 11, 32, 0),
	 *     { addSuffix: true }
	 *   ) //=> 'in about 1 hour'
	 *
	 *   // v2.0.0 onward
	 *
	 *   formatDistance(
	 *     new Date(1986, 3, 4, 11, 32, 0),
	 *     new Date(1986, 3, 4, 10, 32, 0),
	 *     { addSuffix: true }
	 *   ) //=> 'in about 1 hour'
	 *   ```
	 *
	 * @param {Date|Number} date - the date
	 * @param {Date|Number} baseDate - the date to compare with
	 * @param {Object} [options] - an object with options.
	 * @param {Boolean} [options.includeSeconds=false] - distances less than a minute are more detailed
	 * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @returns {String} the distance in words
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `date` must not be Invalid Date
	 * @throws {RangeError} `baseDate` must not be Invalid Date
	 * @throws {RangeError} `options.locale` must contain `formatDistance` property
	 *
	 * @example
	 * // What is the distance between 2 July 2014 and 1 January 2015?
	 * const result = formatDistance(new Date(2014, 6, 2), new Date(2015, 0, 1))
	 * //=> '6 months'
	 *
	 * @example
	 * // What is the distance between 1 January 2015 00:00:15
	 * // and 1 January 2015 00:00:00, including seconds?
	 * const result = formatDistance(
	 *   new Date(2015, 0, 1, 0, 0, 15),
	 *   new Date(2015, 0, 1, 0, 0, 0),
	 *   { includeSeconds: true }
	 * )
	 * //=> 'less than 20 seconds'
	 *
	 * @example
	 * // What is the distance from 1 January 2016
	 * // to 1 January 2015, with a suffix?
	 * const result = formatDistance(new Date(2015, 0, 1), new Date(2016, 0, 1), {
	 *   addSuffix: true
	 * })
	 * //=> 'about 1 year ago'
	 *
	 * @example
	 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
	 * import { eoLocale } from 'date-fns/locale/eo'
	 * const result = formatDistance(new Date(2016, 7, 1), new Date(2015, 0, 1), {
	 *   locale: eoLocale
	 * })
	 * //=> 'pli ol 1 jaro'
	 */
	
	function formatDistance(dirtyDate, dirtyBaseDate) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  (0, _index8.default)(2, arguments);
	  var locale = options.locale || _index4.default;
	
	  if (!locale.formatDistance) {
	    throw new RangeError('locale must contain formatDistance property');
	  }
	
	  var comparison = (0, _index.default)(dirtyDate, dirtyBaseDate);
	
	  if (isNaN(comparison)) {
	    throw new RangeError('Invalid time value');
	  }
	
	  var localizeOptions = (0, _index6.default)(options);
	  localizeOptions.addSuffix = Boolean(options.addSuffix);
	  localizeOptions.comparison = comparison;
	  var dateLeft;
	  var dateRight;
	
	  if (comparison > 0) {
	    dateLeft = (0, _index5.default)(dirtyBaseDate);
	    dateRight = (0, _index5.default)(dirtyDate);
	  } else {
	    dateLeft = (0, _index5.default)(dirtyDate);
	    dateRight = (0, _index5.default)(dirtyBaseDate);
	  }
	
	  var seconds = (0, _index3.default)(dateRight, dateLeft);
	  var offsetInSeconds = ((0, _index7.default)(dateRight) - (0, _index7.default)(dateLeft)) / 1000;
	  var minutes = Math.round((seconds - offsetInSeconds) / 60);
	  var months; // 0 up to 2 mins
	
	  if (minutes < 2) {
	    if (options.includeSeconds) {
	      if (seconds < 5) {
	        return locale.formatDistance('lessThanXSeconds', 5, localizeOptions);
	      } else if (seconds < 10) {
	        return locale.formatDistance('lessThanXSeconds', 10, localizeOptions);
	      } else if (seconds < 20) {
	        return locale.formatDistance('lessThanXSeconds', 20, localizeOptions);
	      } else if (seconds < 40) {
	        return locale.formatDistance('halfAMinute', null, localizeOptions);
	      } else if (seconds < 60) {
	        return locale.formatDistance('lessThanXMinutes', 1, localizeOptions);
	      } else {
	        return locale.formatDistance('xMinutes', 1, localizeOptions);
	      }
	    } else {
	      if (minutes === 0) {
	        return locale.formatDistance('lessThanXMinutes', 1, localizeOptions);
	      } else {
	        return locale.formatDistance('xMinutes', minutes, localizeOptions);
	      }
	    } // 2 mins up to 0.75 hrs
	
	  } else if (minutes < 45) {
	    return locale.formatDistance('xMinutes', minutes, localizeOptions); // 0.75 hrs up to 1.5 hrs
	  } else if (minutes < 90) {
	    return locale.formatDistance('aboutXHours', 1, localizeOptions); // 1.5 hrs up to 24 hrs
	  } else if (minutes < MINUTES_IN_DAY) {
	    var hours = Math.round(minutes / 60);
	    return locale.formatDistance('aboutXHours', hours, localizeOptions); // 1 day up to 1.75 days
	  } else if (minutes < MINUTES_IN_ALMOST_TWO_DAYS) {
	    return locale.formatDistance('xDays', 1, localizeOptions); // 1.75 days up to 30 days
	  } else if (minutes < MINUTES_IN_MONTH) {
	    var days = Math.round(minutes / MINUTES_IN_DAY);
	    return locale.formatDistance('xDays', days, localizeOptions); // 1 month up to 2 months
	  } else if (minutes < MINUTES_IN_TWO_MONTHS) {
	    months = Math.round(minutes / MINUTES_IN_MONTH);
	    return locale.formatDistance('aboutXMonths', months, localizeOptions);
	  }
	
	  months = (0, _index2.default)(dateRight, dateLeft); // 2 months up to 12 months
	
	  if (months < 12) {
	    var nearestMonth = Math.round(minutes / MINUTES_IN_MONTH);
	    return locale.formatDistance('xMonths', nearestMonth, localizeOptions); // 1 year up to max Date
	  } else {
	    var monthsSinceStartOfYear = months % 12;
	    var years = Math.floor(months / 12); // N years up to 1 years 3 months
	
	    if (monthsSinceStartOfYear < 3) {
	      return locale.formatDistance('aboutXYears', years, localizeOptions); // N years 3 months up to N years 9 months
	    } else if (monthsSinceStartOfYear < 9) {
	      return locale.formatDistance('overXYears', years, localizeOptions); // N years 9 months up to N year 12 months
	    } else {
	      return locale.formatDistance('almostXYears', years + 1, localizeOptions);
	    }
	  }
	}
	
	module.exports = exports.default;

/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDaysInMonth;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getDaysInMonth
	 * @category Month Helpers
	 * @summary Get the number of days in a month of the given date.
	 *
	 * @description
	 * Get the number of days in a month of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the number of days in a month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // How many days are in February 2000?
	 * const result = getDaysInMonth(new Date(2000, 1))
	 * //=> 29
	 */
	function getDaysInMonth(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  var monthIndex = date.getMonth();
	  var lastDayOfMonth = new Date(0);
	  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
	  lastDayOfMonth.setHours(0, 0, 0, 0);
	  return lastDayOfMonth.getDate();
	}
	
	module.exports = exports.default;

/***/ },
/* 636 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getHours;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getHours
	 * @category Hour Helpers
	 * @summary Get the hours of the given date.
	 *
	 * @description
	 * Get the hours of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the hours
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Get the hours of 29 February 2012 11:45:00:
	 * const result = getHours(new Date(2012, 1, 29, 11, 45))
	 * //=> 11
	 */
	function getHours(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var hours = date.getHours();
	  return hours;
	}
	
	module.exports = exports.default;

/***/ },
/* 637 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getISODay;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getISODay
	 * @category Weekday Helpers
	 * @summary Get the day of the ISO week of the given date.
	 *
	 * @description
	 * Get the day of the ISO week of the given date,
	 * which is 7 for Sunday, 1 for Monday etc.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the day of ISO week
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which day of the ISO week is 26 February 2012?
	 * const result = getISODay(new Date(2012, 1, 26))
	 * //=> 7
	 */
	function getISODay(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getDay();
	
	  if (day === 0) {
	    day = 7;
	  }
	
	  return day;
	}
	
	module.exports = exports.default;

/***/ },
/* 638 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getISOWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(148));
	
	var _index3 = _interopRequireDefault(__webpack_require__(212));
	
	var _index4 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_WEEK = 604800000;
	/**
	 * @name getISOWeek
	 * @category ISO Week Helpers
	 * @summary Get the ISO week of the given date.
	 *
	 * @description
	 * Get the ISO week of the given date.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the ISO week
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which week of the ISO-week numbering year is 2 January 2005?
	 * const result = getISOWeek(new Date(2005, 0, 2))
	 * //=> 53
	 */
	
	function getISOWeek(dirtyDate) {
	  (0, _index4.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var diff = (0, _index2.default)(date).getTime() - (0, _index3.default)(date).getTime(); // Round the number of days to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	
	  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
	}
	
	module.exports = exports.default;

/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getMinutes;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getMinutes
	 * @category Minute Helpers
	 * @summary Get the minutes of the given date.
	 *
	 * @description
	 * Get the minutes of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the minutes
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Get the minutes of 29 February 2012 11:45:05:
	 * const result = getMinutes(new Date(2012, 1, 29, 11, 45, 5))
	 * //=> 45
	 */
	function getMinutes(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var minutes = date.getMinutes();
	  return minutes;
	}
	
	module.exports = exports.default;

/***/ },
/* 640 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getMonth;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getMonth
	 * @category Month Helpers
	 * @summary Get the month of the given date.
	 *
	 * @description
	 * Get the month of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which month is 29 February 2012?
	 * const result = getMonth(new Date(2012, 1, 29))
	 * //=> 1
	 */
	function getMonth(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var month = date.getMonth();
	  return month;
	}
	
	module.exports = exports.default;

/***/ },
/* 641 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getSeconds;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getSeconds
	 * @category Second Helpers
	 * @summary Get the seconds of the given date.
	 *
	 * @description
	 * Get the seconds of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the seconds
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Get the seconds of 29 February 2012 11:45:05.123:
	 * const result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
	 * //=> 5
	 */
	function getSeconds(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var seconds = date.getSeconds();
	  return seconds;
	}
	
	module.exports = exports.default;

/***/ },
/* 642 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getWeekYear;
	
	var _index = _interopRequireDefault(__webpack_require__(109));
	
	var _index2 = _interopRequireDefault(__webpack_require__(9));
	
	var _index3 = _interopRequireDefault(__webpack_require__(26));
	
	var _index4 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getWeekYear
	 * @category Week-Numbering Year Helpers
	 * @summary Get the local week-numbering year of the given date.
	 *
	 * @description
	 * Get the local week-numbering year of the given date.
	 * The exact calculation depends on the values of
	 * `options.weekStartsOn` (which is the index of the first day of the week)
	 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
	 * the first week of the week-numbering year)
	 *
	 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
	 * @returns {Number} the local week-numbering year
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
	 *
	 * @example
	 * // Which week numbering year is 26 December 2004 with the default settings?
	 * const result = getWeekYear(new Date(2004, 11, 26))
	 * //=> 2005
	 *
	 * @example
	 * // Which week numbering year is 26 December 2004 if week starts on Saturday?
	 * const result = getWeekYear(new Date(2004, 11, 26), { weekStartsOn: 6 })
	 * //=> 2004
	 *
	 * @example
	 * // Which week numbering year is 26 December 2004 if the first week contains 4 January?
	 * const result = getWeekYear(new Date(2004, 11, 26), { firstWeekContainsDate: 4 })
	 * //=> 2004
	 */
	function getWeekYear(dirtyDate, options) {
	  var _options$locale, _options$locale$optio;
	
	  (0, _index4.default)(1, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var year = date.getFullYear();
	  var localeFirstWeekContainsDate = options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate;
	  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, _index3.default)(localeFirstWeekContainsDate);
	  var firstWeekContainsDate = (options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) == null ? defaultFirstWeekContainsDate : (0, _index3.default)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
	
	  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
	    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
	  }
	
	  var firstWeekOfNextYear = new Date(0);
	  firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
	  firstWeekOfNextYear.setHours(0, 0, 0, 0);
	  var startOfNextYear = (0, _index.default)(firstWeekOfNextYear, options);
	  var firstWeekOfThisYear = new Date(0);
	  firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
	  firstWeekOfThisYear.setHours(0, 0, 0, 0);
	  var startOfThisYear = (0, _index.default)(firstWeekOfThisYear, options);
	
	  if (date.getTime() >= startOfNextYear.getTime()) {
	    return year + 1;
	  } else if (date.getTime() >= startOfThisYear.getTime()) {
	    return year;
	  } else {
	    return year - 1;
	  }
	}
	
	module.exports = exports.default;

/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getYear;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getYear
	 * @category Year Helpers
	 * @summary Get the year of the given date.
	 *
	 * @description
	 * Get the year of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which year is 2 July 2014?
	 * const result = getYear(new Date(2014, 6, 2))
	 * //=> 2014
	 */
	function getYear(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getFullYear();
	}
	
	module.exports = exports.default;

/***/ },
/* 644 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isAfter;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isAfter
	 * @category Common Helpers
	 * @summary Is the first date after the second one?
	 *
	 * @description
	 * Is the first date after the second one?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date that should be after the other one to return true
	 * @param {Date|Number} dateToCompare - the date to compare with
	 * @returns {Boolean} the first date is after the second date
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Is 10 July 1989 after 11 February 1987?
	 * var result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
	 * //=> true
	 */
	function isAfter(dirtyDate, dirtyDateToCompare) {
	  (0, _index2.default)(2, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var dateToCompare = (0, _index.default)(dirtyDateToCompare);
	  return date.getTime() > dateToCompare.getTime();
	}
	
	module.exports = exports.default;

/***/ },
/* 645 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isBefore;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isBefore
	 * @category Common Helpers
	 * @summary Is the first date before the second one?
	 *
	 * @description
	 * Is the first date before the second one?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date that should be before the other one to return true
	 * @param {Date|Number} dateToCompare - the date to compare with
	 * @returns {Boolean} the first date is before the second date
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Is 10 July 1989 before 11 February 1987?
	 * var result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
	 * //=> false
	 */
	function isBefore(dirtyDate, dirtyDateToCompare) {
	  (0, _index2.default)(2, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var dateToCompare = (0, _index.default)(dirtyDateToCompare);
	  return date.getTime() < dateToCompare.getTime();
	}
	
	module.exports = exports.default;

/***/ },
/* 646 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isEqual;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isEqual
	 * @category Common Helpers
	 * @summary Are the given dates equal?
	 *
	 * @description
	 * Are the given dates equal?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the first date to compare
	 * @param {Date|Number} dateRight - the second date to compare
	 * @returns {Boolean} the dates are equal
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
	 * var result = isEqual(
	 *   new Date(2014, 6, 2, 6, 30, 45, 0),
	 *   new Date(2014, 6, 2, 6, 30, 45, 500)
	 * )
	 * //=> false
	 */
	function isEqual(dirtyLeftDate, dirtyRightDate) {
	  (0, _index2.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyLeftDate);
	  var dateRight = (0, _index.default)(dirtyRightDate);
	  return dateLeft.getTime() === dateRight.getTime();
	}
	
	module.exports = exports.default;

/***/ },
/* 647 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isLastDayOfMonth;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(265));
	
	var _index3 = _interopRequireDefault(__webpack_require__(266));
	
	var _index4 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isLastDayOfMonth
	 * @category Month Helpers
	 * @summary Is the given date the last day of a month?
	 *
	 * @description
	 * Is the given date the last day of a month?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is the last day of a month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Is 28 February 2014 the last day of a month?
	 * var result = isLastDayOfMonth(new Date(2014, 1, 28))
	 * //=> true
	 */
	function isLastDayOfMonth(dirtyDate) {
	  (0, _index4.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  return (0, _index2.default)(date).getTime() === (0, _index3.default)(date).getTime();
	}
	
	module.exports = exports.default;

/***/ },
/* 648 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isLeapYear;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isLeapYear
	 * @category Year Helpers
	 * @summary Is the given date in the leap year?
	 *
	 * @description
	 * Is the given date in the leap year?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is in the leap year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Is 1 September 2012 in the leap year?
	 * var result = isLeapYear(new Date(2012, 8, 1))
	 * //=> true
	 */
	function isLeapYear(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
	}
	
	module.exports = exports.default;

/***/ },
/* 649 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameHour;
	
	var _index = _interopRequireDefault(__webpack_require__(665));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isSameHour
	 * @category Hour Helpers
	 * @summary Are the given dates in the same hour (and same day)?
	 *
	 * @description
	 * Are the given dates in the same hour (and same day)?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same hour (and same day)
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 4 September 2014 06:00:00 and 4 September 06:30:00 in the same hour?
	 * var result = isSameHour(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 6, 30))
	 * //=> true
	 * 
	 * @example
	 * // Are 4 September 2014 06:00:00 and 5 September 06:00:00 in the same hour?
	 * var result = isSameHour(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 5, 6, 0))
	 * //=> false
	 */
	function isSameHour(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeftStartOfHour = (0, _index.default)(dirtyDateLeft);
	  var dateRightStartOfHour = (0, _index.default)(dirtyDateRight);
	  return dateLeftStartOfHour.getTime() === dateRightStartOfHour.getTime();
	}
	
	module.exports = exports.default;

/***/ },
/* 650 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameISOWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(401));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isSameISOWeek
	 * @category ISO Week Helpers
	 * @summary Are the given dates in the same ISO week (and year)?
	 *
	 * @description
	 * Are the given dates in the same ISO week (and year)?
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same ISO week (and year)
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 1 September 2014 and 7 September 2014 in the same ISO week?
	 * var result = isSameISOWeek(new Date(2014, 8, 1), new Date(2014, 8, 7))
	 * //=> true
	 *
	 * @example
	 * // Are 1 September 2014 and 1 September 2015 in the same ISO week?
	 * var result = isSameISOWeek(new Date(2014, 8, 1), new Date(2015, 8, 1))
	 * //=> false
	 */
	function isSameISOWeek(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  return (0, _index.default)(dirtyDateLeft, dirtyDateRight, {
	    weekStartsOn: 1
	  });
	}
	
	module.exports = exports.default;

/***/ },
/* 651 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameMinute;
	
	var _index = _interopRequireDefault(__webpack_require__(412));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isSameMinute
	 * @category Minute Helpers
	 * @summary Are the given dates in the same minute (and hour and day)?
	 *
	 * @description
	 * Are the given dates in the same minute (and hour and day)?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same minute (and hour and day)
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 4 September 2014 06:30:00 and 4 September 2014 06:30:15 in the same minute?
	 * var result = isSameMinute(
	 *   new Date(2014, 8, 4, 6, 30),
	 *   new Date(2014, 8, 4, 6, 30, 15)
	 * )
	 * //=> true
	 * 
	 * @example
	 * // Are 4 September 2014 06:30:00 and 5 September 2014 06:30:00 in the same minute?
	 * var result = isSameMinute(
	 *   new Date(2014, 8, 4, 6, 30),
	 *   new Date(2014, 8, 5, 6, 30)
	 * )
	 * //=> false
	 */
	function isSameMinute(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeftStartOfMinute = (0, _index.default)(dirtyDateLeft);
	  var dateRightStartOfMinute = (0, _index.default)(dirtyDateRight);
	  return dateLeftStartOfMinute.getTime() === dateRightStartOfMinute.getTime();
	}
	
	module.exports = exports.default;

/***/ },
/* 652 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameSecond;
	
	var _index = _interopRequireDefault(__webpack_require__(666));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isSameSecond
	 * @category Second Helpers
	 * @summary Are the given dates in the same second (and hour and day)?
	 *
	 * @description
	 * Are the given dates in the same second (and hour and day)?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same second (and hour and day)
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 4 September 2014 06:30:15.000 and 4 September 2014 06:30.15.500 in the same second?
	 * var result = isSameSecond(
	 *   new Date(2014, 8, 4, 6, 30, 15),
	 *   new Date(2014, 8, 4, 6, 30, 15, 500)
	 * )
	 * //=> true
	 * 
	 * @example
	 * // Are 4 September 2014 06:00:15.000 and 4 September 2014 06:01.15.000 in the same second?
	 * var result = isSameSecond(
	 *   new Date(2014, 8, 4, 6, 0, 15),
	 *   new Date(2014, 8, 4, 6, 1, 15)
	 * )
	 * //=> false
	 * 
	 * @example
	 * // Are 4 September 2014 06:00:15.000 and 5 September 2014 06:00.15.000 in the same second?
	 * var result = isSameSecond(
	 *   new Date(2014, 8, 4, 6, 0, 15),
	 *   new Date(2014, 8, 5, 6, 0, 15)
	 * )
	 * //=> false
	 */
	function isSameSecond(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeftStartOfSecond = (0, _index.default)(dirtyDateLeft);
	  var dateRightStartOfSecond = (0, _index.default)(dirtyDateRight);
	  return dateLeftStartOfSecond.getTime() === dateRightStartOfSecond.getTime();
	}
	
	module.exports = exports.default;

/***/ },
/* 653 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSaturday;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isSaturday
	 * @category Weekday Helpers
	 * @summary Is the given date Saturday?
	 *
	 * @description
	 * Is the given date Saturday?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is Saturday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Is 27 September 2014 Saturday?
	 * var result = isSaturday(new Date(2014, 8, 27))
	 * //=> true
	 */
	function isSaturday(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getDay() === 6;
	}
	
	module.exports = exports.default;

/***/ },
/* 654 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isWithinInterval;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isWithinInterval
	 * @category Interval Helpers
	 * @summary Is the given date within the interval?
	 *
	 * @description
	 * Is the given date within the interval? (Including start and end.)
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `isWithinRange` to `isWithinInterval`.
	 *   This change was made to mirror the use of the word "interval" in standard ISO 8601:2004 terminology:
	 *
	 *   ```
	 *   2.1.3
	 *   time interval
	 *   part of the time axis limited by two instants
	 *   ```
	 *
	 *   Also, this function now accepts an object with `start` and `end` properties
	 *   instead of two arguments as an interval.
	 *   This function now throws `RangeError` if the start of the interval is after its end
	 *   or if any date in the interval is `Invalid Date`.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *
	 *   isWithinRange(
	 *     new Date(2014, 0, 3),
	 *     new Date(2014, 0, 1), new Date(2014, 0, 7)
	 *   )
	 *
	 *   // v2.0.0 onward
	 *
	 *   isWithinInterval(
	 *     new Date(2014, 0, 3),
	 *     { start: new Date(2014, 0, 1), end: new Date(2014, 0, 7) }
	 *   )
	 *   ```
	 *
	 * @param {Date|Number} date - the date to check
	 * @param {Interval} interval - the interval to check
	 * @returns {Boolean} the date is within the interval
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // For the date within the interval:
	 * isWithinInterval(new Date(2014, 0, 3), {
	 *   start: new Date(2014, 0, 1),
	 *   end: new Date(2014, 0, 7)
	 * })
	 * //=> true
	 *
	 * @example
	 * // For the date outside of the interval:
	 * isWithinInterval(new Date(2014, 0, 10), {
	 *   start: new Date(2014, 0, 1),
	 *   end: new Date(2014, 0, 7)
	 * })
	 * //=> false
	 *
	 * @example
	 * // For date equal to interval start:
	 * isWithinInterval(date, { start, end: date }) // => true
	 *
	 * @example
	 * // For date equal to interval end:
	 * isWithinInterval(date, { start: date, end }) // => true
	 */
	function isWithinInterval(dirtyDate, interval) {
	  (0, _index2.default)(2, arguments);
	  var time = (0, _index.default)(dirtyDate).getTime();
	  var startTime = (0, _index.default)(interval.start).getTime();
	  var endTime = (0, _index.default)(interval.end).getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`
	
	  if (!(startTime <= endTime)) {
	    throw new RangeError('Invalid interval');
	  }
	
	  return time >= startTime && time <= endTime;
	}
	
	module.exports = exports.default;

/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = lastDayOfMonth;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name lastDayOfMonth
	 * @category Month Helpers
	 * @summary Return the last day of a month for the given date.
	 *
	 * @description
	 * Return the last day of a month for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the last day of a month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The last day of a month for 2 September 2014 11:55:00:
	 * var result = lastDayOfMonth(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 30 2014 00:00:00
	 */
	function lastDayOfMonth(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var month = date.getMonth();
	  date.setFullYear(date.getFullYear(), month + 1, 0);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = lastDayOfWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(26));
	
	var _index3 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name lastDayOfWeek
	 * @category Week Helpers
	 * @summary Return the last day of a week for the given date.
	 *
	 * @description
	 * Return the last day of a week for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Date} the last day of a week
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // The last day of a week for 2 September 2014 11:55:00:
	 * var result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Sat Sep 06 2014 00:00:00
	 *
	 * @example
	 * // If the week starts on Monday, the last day of the week for 2 September 2014 11:55:00:
	 * var result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
	 * //=> Sun Sep 07 2014 00:00:00
	 */
	function lastDayOfWeek(dirtyDate, dirtyOptions) {
	  (0, _index3.default)(1, arguments);
	  var options = dirtyOptions || {};
	  var locale = options.locale;
	  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
	  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, _index2.default)(localeWeekStartsOn);
	  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, _index2.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6');
	  }
	
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getDay();
	  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
	  date.setHours(0, 0, 0, 0);
	  date.setDate(date.getDate() + diff);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1635));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1636));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1637));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1638));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1639));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Portuguese locale (Brazil).
	 * @language Portuguese
	 * @iso-639-2 por
	 * @author Lucas Duailibe [@duailibe]{@link https://github.com/duailibe}
	 * @author Yago Carballo [@yagocarballo]{@link https://github.com/YagoCarballo}
	 */
	var locale = {
	  code: 'pt-BR',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 0
	    /* Sunday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 658 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = parseISO;
	
	var _index = __webpack_require__(45);
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	var _index3 = _interopRequireDefault(__webpack_require__(26));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name parseISO
	 * @category Common Helpers
	 * @summary Parse ISO string
	 *
	 * @description
	 * Parse the given string in ISO 8601 format and return an instance of Date.
	 *
	 * Function accepts complete ISO 8601 formats as well as partial implementations.
	 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
	 *
	 * If the argument isn't a string, the function cannot parse the string or
	 * the values are invalid, it returns Invalid Date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The previous `parse` implementation was renamed to `parseISO`.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *   parse('2016-01-01')
	 *
	 *   // v2.0.0 onward
	 *   parseISO('2016-01-01')
	 *   ```
	 *
	 * - `parseISO` now validates separate date and time values in ISO-8601 strings
	 *   and returns `Invalid Date` if the date is invalid.
	 *
	 *   ```javascript
	 *   parseISO('2018-13-32')
	 *   //=> Invalid Date
	 *   ```
	 *
	 * - `parseISO` now doesn't fall back to `new Date` constructor
	 *   if it fails to parse a string argument. Instead, it returns `Invalid Date`.
	 *
	 * @param {String} argument - the value to convert
	 * @param {Object} [options] - an object with options.
	 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
	 * @returns {Date} the parsed date in the local time zone
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // Convert string '2014-02-11T11:30:30' to date:
	 * const result = parseISO('2014-02-11T11:30:30')
	 * //=> Tue Feb 11 2014 11:30:30
	 *
	 * @example
	 * // Convert string '+02014101' to date,
	 * // if the additional number of digits in the extended year format is 1:
	 * const result = parseISO('+02014101', { additionalDigits: 1 })
	 * //=> Fri Apr 11 2014 00:00:00
	 */
	function parseISO(argument, dirtyOptions) {
	  (0, _index2.default)(1, arguments);
	  var options = dirtyOptions || {};
	  var additionalDigits = options.additionalDigits == null ? 2 : (0, _index3.default)(options.additionalDigits);
	
	  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
	    throw new RangeError('additionalDigits must be 0, 1 or 2');
	  }
	
	  if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) {
	    return new Date(NaN);
	  }
	
	  var dateStrings = splitDateString(argument);
	  var date;
	
	  if (dateStrings.date) {
	    var parseYearResult = parseYear(dateStrings.date, additionalDigits);
	    date = parseDate(parseYearResult.restDateString, parseYearResult.year);
	  }
	
	  if (!date || isNaN(date.getTime())) {
	    return new Date(NaN);
	  }
	
	  var timestamp = date.getTime();
	  var time = 0;
	  var offset;
	
	  if (dateStrings.time) {
	    time = parseTime(dateStrings.time);
	
	    if (isNaN(time)) {
	      return new Date(NaN);
	    }
	  }
	
	  if (dateStrings.timezone) {
	    offset = parseTimezone(dateStrings.timezone);
	
	    if (isNaN(offset)) {
	      return new Date(NaN);
	    }
	  } else {
	    var dirtyDate = new Date(timestamp + time); // js parsed string assuming it's in UTC timezone
	    // but we need it to be parsed in our timezone
	    // so we use utc values to build date in our timezone.
	    // Year values from 0 to 99 map to the years 1900 to 1999
	    // so set year explicitly with setFullYear.
	
	    var result = new Date(0);
	    result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
	    result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
	    return result;
	  }
	
	  return new Date(timestamp + time + offset);
	}
	
	var patterns = {
	  dateTimeDelimiter: /[T ]/,
	  timeZoneDelimiter: /[Z ]/i,
	  timezone: /([Z+-].*)$/
	};
	var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
	var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
	var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
	
	function splitDateString(dateString) {
	  var dateStrings = {};
	  var array = dateString.split(patterns.dateTimeDelimiter);
	  var timeString; // The regex match should only return at maximum two array elements.
	  // [date], [time], or [date, time].
	
	  if (array.length > 2) {
	    return dateStrings;
	  }
	
	  if (/:/.test(array[0])) {
	    timeString = array[0];
	  } else {
	    dateStrings.date = array[0];
	    timeString = array[1];
	
	    if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
	      dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
	      timeString = dateString.substr(dateStrings.date.length, dateString.length);
	    }
	  }
	
	  if (timeString) {
	    var token = patterns.timezone.exec(timeString);
	
	    if (token) {
	      dateStrings.time = timeString.replace(token[1], '');
	      dateStrings.timezone = token[1];
	    } else {
	      dateStrings.time = timeString;
	    }
	  }
	
	  return dateStrings;
	}
	
	function parseYear(dateString, additionalDigits) {
	  var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
	  var captures = dateString.match(regex); // Invalid ISO-formatted year
	
	  if (!captures) return {
	    year: NaN,
	    restDateString: ''
	  };
	  var year = captures[1] ? parseInt(captures[1]) : null;
	  var century = captures[2] ? parseInt(captures[2]) : null; // either year or century is null, not both
	
	  return {
	    year: century === null ? year : century * 100,
	    restDateString: dateString.slice((captures[1] || captures[2]).length)
	  };
	}
	
	function parseDate(dateString, year) {
	  // Invalid ISO-formatted year
	  if (year === null) return new Date(NaN);
	  var captures = dateString.match(dateRegex); // Invalid ISO-formatted string
	
	  if (!captures) return new Date(NaN);
	  var isWeekDate = !!captures[4];
	  var dayOfYear = parseDateUnit(captures[1]);
	  var month = parseDateUnit(captures[2]) - 1;
	  var day = parseDateUnit(captures[3]);
	  var week = parseDateUnit(captures[4]);
	  var dayOfWeek = parseDateUnit(captures[5]) - 1;
	
	  if (isWeekDate) {
	    if (!validateWeekDate(year, week, dayOfWeek)) {
	      return new Date(NaN);
	    }
	
	    return dayOfISOWeekYear(year, week, dayOfWeek);
	  } else {
	    var date = new Date(0);
	
	    if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) {
	      return new Date(NaN);
	    }
	
	    date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
	    return date;
	  }
	}
	
	function parseDateUnit(value) {
	  return value ? parseInt(value) : 1;
	}
	
	function parseTime(timeString) {
	  var captures = timeString.match(timeRegex);
	  if (!captures) return NaN; // Invalid ISO-formatted time
	
	  var hours = parseTimeUnit(captures[1]);
	  var minutes = parseTimeUnit(captures[2]);
	  var seconds = parseTimeUnit(captures[3]);
	
	  if (!validateTime(hours, minutes, seconds)) {
	    return NaN;
	  }
	
	  return hours * _index.millisecondsInHour + minutes * _index.millisecondsInMinute + seconds * 1000;
	}
	
	function parseTimeUnit(value) {
	  return value && parseFloat(value.replace(',', '.')) || 0;
	}
	
	function parseTimezone(timezoneString) {
	  if (timezoneString === 'Z') return 0;
	  var captures = timezoneString.match(timezoneRegex);
	  if (!captures) return 0;
	  var sign = captures[1] === '+' ? -1 : 1;
	  var hours = parseInt(captures[2]);
	  var minutes = captures[3] && parseInt(captures[3]) || 0;
	
	  if (!validateTimezone(hours, minutes)) {
	    return NaN;
	  }
	
	  return sign * (hours * _index.millisecondsInHour + minutes * _index.millisecondsInMinute);
	}
	
	function dayOfISOWeekYear(isoWeekYear, week, day) {
	  var date = new Date(0);
	  date.setUTCFullYear(isoWeekYear, 0, 4);
	  var fourthOfJanuaryDay = date.getUTCDay() || 7;
	  var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
	  date.setUTCDate(date.getUTCDate() + diff);
	  return date;
	} // Validation functions
	// February is null to handle the leap year (using ||)
	
	
	var daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
	
	function isLeapYearIndex(year) {
	  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
	}
	
	function validateDate(year, month, date) {
	  return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
	}
	
	function validateDayOfYearDate(year, dayOfYear) {
	  return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
	}
	
	function validateWeekDate(_year, week, day) {
	  return week >= 1 && week <= 53 && day >= 0 && day <= 6;
	}
	
	function validateTime(hours, minutes, seconds) {
	  if (hours === 24) {
	    return minutes === 0 && seconds === 0;
	  }
	
	  return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
	}
	
	function validateTimezone(_hours, minutes) {
	  return minutes >= 0 && minutes <= 59;
	}
	
	module.exports = exports.default;

/***/ },
/* 659 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setHours;
	
	var _index = _interopRequireDefault(__webpack_require__(26));
	
	var _index2 = _interopRequireDefault(__webpack_require__(9));
	
	var _index3 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setHours
	 * @category Hour Helpers
	 * @summary Set the hours to the given date.
	 *
	 * @description
	 * Set the hours to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} hours - the hours of the new date
	 * @returns {Date} the new date with the hours set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set 4 hours to 1 September 2014 11:30:00:
	 * var result = setHours(new Date(2014, 8, 1, 11, 30), 4)
	 * //=> Mon Sep 01 2014 04:30:00
	 */
	function setHours(dirtyDate, dirtyHours) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var hours = (0, _index.default)(dirtyHours);
	  date.setHours(hours);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 660 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setISOWeekYear;
	
	var _index = _interopRequireDefault(__webpack_require__(26));
	
	var _index2 = _interopRequireDefault(__webpack_require__(9));
	
	var _index3 = _interopRequireDefault(__webpack_require__(212));
	
	var _index4 = _interopRequireDefault(__webpack_require__(120));
	
	var _index5 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setISOWeekYear
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Set the ISO week-numbering year to the given date.
	 *
	 * @description
	 * Set the ISO week-numbering year to the given date,
	 * saving the week number and the weekday number.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `setISOYear` to `setISOWeekYear`.
	 *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
	 *   This change makes the name consistent with
	 *   locale-dependent week-numbering year helpers, e.g., `setWeekYear`.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} isoWeekYear - the ISO week-numbering year of the new date
	 * @returns {Date} the new date with the ISO week-numbering year set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set ISO week-numbering year 2007 to 29 December 2008:
	 * const result = setISOWeekYear(new Date(2008, 11, 29), 2007)
	 * //=> Mon Jan 01 2007 00:00:00
	 */
	function setISOWeekYear(dirtyDate, dirtyISOWeekYear) {
	  (0, _index5.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var isoWeekYear = (0, _index.default)(dirtyISOWeekYear);
	  var diff = (0, _index4.default)(date, (0, _index3.default)(date));
	  var fourthOfJanuary = new Date(0);
	  fourthOfJanuary.setFullYear(isoWeekYear, 0, 4);
	  fourthOfJanuary.setHours(0, 0, 0, 0);
	  date = (0, _index3.default)(fourthOfJanuary);
	  date.setDate(date.getDate() + diff);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 661 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setMinutes;
	
	var _index = _interopRequireDefault(__webpack_require__(26));
	
	var _index2 = _interopRequireDefault(__webpack_require__(9));
	
	var _index3 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setMinutes
	 * @category Minute Helpers
	 * @summary Set the minutes to the given date.
	 *
	 * @description
	 * Set the minutes to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} minutes - the minutes of the new date
	 * @returns {Date} the new date with the minutes set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set 45 minutes to 1 September 2014 11:30:40:
	 * const result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
	 * //=> Mon Sep 01 2014 11:45:40
	 */
	function setMinutes(dirtyDate, dirtyMinutes) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var minutes = (0, _index.default)(dirtyMinutes);
	  date.setMinutes(minutes);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 662 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setQuarter;
	
	var _index = _interopRequireDefault(__webpack_require__(26));
	
	var _index2 = _interopRequireDefault(__webpack_require__(9));
	
	var _index3 = _interopRequireDefault(__webpack_require__(268));
	
	var _index4 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setQuarter
	 * @category Quarter Helpers
	 * @summary Set the year quarter to the given date.
	 *
	 * @description
	 * Set the year quarter to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} quarter - the quarter of the new date
	 * @returns {Date} the new date with the quarter set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set the 2nd quarter to 2 July 2014:
	 * const result = setQuarter(new Date(2014, 6, 2), 2)
	 * //=> Wed Apr 02 2014 00:00:00
	 */
	function setQuarter(dirtyDate, dirtyQuarter) {
	  (0, _index4.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var quarter = (0, _index.default)(dirtyQuarter);
	  var oldQuarter = Math.floor(date.getMonth() / 3) + 1;
	  var diff = quarter - oldQuarter;
	  return (0, _index3.default)(date, date.getMonth() + diff * 3);
	}
	
	module.exports = exports.default;

/***/ },
/* 663 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setSeconds;
	
	var _index = _interopRequireDefault(__webpack_require__(26));
	
	var _index2 = _interopRequireDefault(__webpack_require__(9));
	
	var _index3 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setSeconds
	 * @category Second Helpers
	 * @summary Set the seconds to the given date.
	 *
	 * @description
	 * Set the seconds to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} seconds - the seconds of the new date
	 * @returns {Date} the new date with the seconds set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set 45 seconds to 1 September 2014 11:30:40:
	 * const result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
	 * //=> Mon Sep 01 2014 11:30:45
	 */
	function setSeconds(dirtyDate, dirtySeconds) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var seconds = (0, _index.default)(dirtySeconds);
	  date.setSeconds(seconds);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 664 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setYear;
	
	var _index = _interopRequireDefault(__webpack_require__(26));
	
	var _index2 = _interopRequireDefault(__webpack_require__(9));
	
	var _index3 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setYear
	 * @category Year Helpers
	 * @summary Set the year to the given date.
	 *
	 * @description
	 * Set the year to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} year - the year of the new date
	 * @returns {Date} the new date with the year set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set year 2013 to 1 September 2014:
	 * const result = setYear(new Date(2014, 8, 1), 2013)
	 * //=> Sun Sep 01 2013 00:00:00
	 */
	function setYear(dirtyDate, dirtyYear) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var year = (0, _index.default)(dirtyYear); // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
	
	  if (isNaN(date.getTime())) {
	    return new Date(NaN);
	  }
	
	  date.setFullYear(year);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 665 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfHour;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfHour
	 * @category Hour Helpers
	 * @summary Return the start of an hour for the given date.
	 *
	 * @description
	 * Return the start of an hour for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of an hour
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of an hour for 2 September 2014 11:55:00:
	 * const result = startOfHour(new Date(2014, 8, 2, 11, 55))
	 * //=> Tue Sep 02 2014 11:00:00
	 */
	function startOfHour(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setMinutes(0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 666 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfSecond;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfSecond
	 * @category Second Helpers
	 * @summary Return the start of a second for the given date.
	 *
	 * @description
	 * Return the start of a second for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of a second
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of a second for 1 December 2014 22:15:45.400:
	 * const result = startOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
	 * //=> Mon Dec 01 2014 22:15:45.000
	 */
	function startOfSecond(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setMilliseconds(0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 667 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subHours;
	
	var _index = _interopRequireDefault(__webpack_require__(26));
	
	var _index2 = _interopRequireDefault(__webpack_require__(261));
	
	var _index3 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name subHours
	 * @category Hour Helpers
	 * @summary Subtract the specified number of hours from the given date.
	 *
	 * @description
	 * Subtract the specified number of hours from the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of hours to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the hours subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 2 hours from 11 July 2014 01:00:00:
	 * const result = subHours(new Date(2014, 6, 11, 1, 0), 2)
	 * //=> Thu Jul 10 2014 23:00:00
	 */
	function subHours(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	
	module.exports = exports.default;

/***/ },
/* 668 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subISOWeekYears;
	
	var _index = _interopRequireDefault(__webpack_require__(26));
	
	var _index2 = _interopRequireDefault(__webpack_require__(625));
	
	var _index3 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name subISOWeekYears
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Subtract the specified number of ISO week-numbering years from the given date.
	 *
	 * @description
	 * Subtract the specified number of ISO week-numbering years from the given date.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `subISOYears` to `subISOWeekYears`.
	 *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
	 *   This change makes the name consistent with
	 *   locale-dependent week-numbering year helpers, e.g., `setWeekYear`.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of ISO week-numbering years to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the ISO week-numbering years subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 5 ISO week-numbering years from 1 September 2014:
	 * const result = subISOWeekYears(new Date(2014, 8, 1), 5)
	 * //=> Mon Aug 31 2009 00:00:00
	 */
	function subISOWeekYears(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	
	module.exports = exports.default;

/***/ },
/* 669 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subMinutes;
	
	var _index = _interopRequireDefault(__webpack_require__(26));
	
	var _index2 = _interopRequireDefault(__webpack_require__(262));
	
	var _index3 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name subMinutes
	 * @category Minute Helpers
	 * @summary Subtract the specified number of minutes from the given date.
	 *
	 * @description
	 * Subtract the specified number of minutes from the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of minutes to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the minutes subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 30 minutes from 10 July 2014 12:00:00:
	 * const result = subMinutes(new Date(2014, 6, 10, 12, 0), 30)
	 * //=> Thu Jul 10 2014 11:30:00
	 */
	function subMinutes(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	
	module.exports = exports.default;

/***/ },
/* 670 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subWeeks;
	
	var _index = _interopRequireDefault(__webpack_require__(26));
	
	var _index2 = _interopRequireDefault(__webpack_require__(209));
	
	var _index3 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name subWeeks
	 * @category Week Helpers
	 * @summary Subtract the specified number of weeks from the given date.
	 *
	 * @description
	 * Subtract the specified number of weeks from the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of weeks to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the weeks subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 4 weeks from 1 September 2014:
	 * const result = subWeeks(new Date(2014, 8, 1), 4)
	 * //=> Mon Aug 04 2014 00:00:00
	 */
	function subWeeks(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	
	module.exports = exports.default;

/***/ },
/* 671 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subYears;
	
	var _index = _interopRequireDefault(__webpack_require__(26));
	
	var _index2 = _interopRequireDefault(__webpack_require__(385));
	
	var _index3 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name subYears
	 * @category Year Helpers
	 * @summary Subtract the specified number of years from the given date.
	 *
	 * @description
	 * Subtract the specified number of years from the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of years to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the years subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 5 years from 1 September 2014:
	 * const result = subYears(new Date(2014, 8, 1), 5)
	 * //=> Tue Sep 01 2009 00:00:00
	 */
	function subYears(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	
	module.exports = exports.default;

/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sub;
	
	var _index = _interopRequireDefault(__webpack_require__(214));
	
	var _index2 = _interopRequireDefault(__webpack_require__(414));
	
	var _index3 = _interopRequireDefault(__webpack_require__(6));
	
	var _index4 = _interopRequireDefault(__webpack_require__(26));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name sub
	 * @category Common Helpers
	 * @summary Subtract the specified years, months, weeks, days, hours, minutes and seconds from the given date.
	 *
	 * @description
	 * Subtract the specified years, months, weeks, days, hours, minutes and seconds from the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Duration} duration - the object with years, months, weeks, days, hours, minutes and seconds to be subtracted
	 *
	 * | Key     | Description                        |
	 * |---------|------------------------------------|
	 * | years   | Amount of years to be subtracted   |
	 * | months  | Amount of months to be subtracted  |
	 * | weeks   | Amount of weeks to be subtracted   |
	 * | days    | Amount of days to be subtracted    |
	 * | hours   | Amount of hours to be subtracted   |
	 * | minutes | Amount of minutes to be subtracted |
	 * | seconds | Amount of seconds to be subtracted |
	 *
	 * All values default to 0
	 *
	 * @returns {Date} the new date with the seconds subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract the following duration from 15 June 2017 15:29:20
	 * const result = sub(new Date(2017, 5, 15, 15, 29, 20), {
	 *   years: 2,
	 *   months: 9,
	 *   weeks: 1,
	 *   days: 7,
	 *   hours: 5,
	 *   minutes: 9,
	 *   seconds: 30
	 * })
	 * //=> Mon Sep 1 2014 10:19:50
	 */
	function sub(date, duration) {
	  (0, _index3.default)(2, arguments);
	  if (!duration || typeof duration !== 'object') return new Date(NaN);
	  var years = duration.years ? (0, _index4.default)(duration.years) : 0;
	  var months = duration.months ? (0, _index4.default)(duration.months) : 0;
	  var weeks = duration.weeks ? (0, _index4.default)(duration.weeks) : 0;
	  var days = duration.days ? (0, _index4.default)(duration.days) : 0;
	  var hours = duration.hours ? (0, _index4.default)(duration.hours) : 0;
	  var minutes = duration.minutes ? (0, _index4.default)(duration.minutes) : 0;
	  var seconds = duration.seconds ? (0, _index4.default)(duration.seconds) : 0; // Subtract years and months
	
	  var dateWithoutMonths = (0, _index2.default)(date, months + years * 12); // Subtract weeks and days
	
	  var dateWithoutDays = (0, _index.default)(dateWithoutMonths, days + weeks * 7); // Subtract hours, minutes and seconds
	
	  var minutestoSub = minutes + hours * 60;
	  var secondstoSub = seconds + minutestoSub * 60;
	  var mstoSub = secondstoSub * 1000;
	  var finalDate = new Date(dateWithoutDays.getTime() - mstoSub);
	  return finalDate;
	}
	
	module.exports = exports.default;

/***/ },
/* 673 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*! decimal.js-light v2.5.1 https://github.com/MikeMcl/decimal.js-light/LICENCE */
	;(function (globalScope) {
	  'use strict';
	
	
	  /*
	   *  decimal.js-light v2.5.1
	   *  An arbitrary-precision Decimal type for JavaScript.
	   *  https://github.com/MikeMcl/decimal.js-light
	   *  Copyright (c) 2020 Michael Mclaughlin <M8ch88l@gmail.com>
	   *  MIT Expat Licence
	   */
	
	
	  // -----------------------------------  EDITABLE DEFAULTS  ------------------------------------ //
	
	
	    // The limit on the value of `precision`, and on the value of the first argument to
	    // `toDecimalPlaces`, `toExponential`, `toFixed`, `toPrecision` and `toSignificantDigits`.
	  var MAX_DIGITS = 1e9,                        // 0 to 1e9
	
	
	    // The initial configuration properties of the Decimal constructor.
	    Decimal = {
	
	      // These values must be integers within the stated ranges (inclusive).
	      // Most of these values can be changed during run-time using `Decimal.config`.
	
	      // The maximum number of significant digits of the result of a calculation or base conversion.
	      // E.g. `Decimal.config({ precision: 20 });`
	      precision: 20,                         // 1 to MAX_DIGITS
	
	      // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
	      // `toFixed`, `toPrecision` and `toSignificantDigits`.
	      //
	      // ROUND_UP         0 Away from zero.
	      // ROUND_DOWN       1 Towards zero.
	      // ROUND_CEIL       2 Towards +Infinity.
	      // ROUND_FLOOR      3 Towards -Infinity.
	      // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
	      // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
	      // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
	      // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
	      // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
	      //
	      // E.g.
	      // `Decimal.rounding = 4;`
	      // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
	      rounding: 4,                           // 0 to 8
	
	      // The exponent value at and beneath which `toString` returns exponential notation.
	      // JavaScript numbers: -7
	      toExpNeg: -7,                          // 0 to -MAX_E
	
	      // The exponent value at and above which `toString` returns exponential notation.
	      // JavaScript numbers: 21
	      toExpPos:  21,                         // 0 to MAX_E
	
	      // The natural logarithm of 10.
	      // 115 digits
	      LN10: '2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286'
	    },
	
	
	  // ----------------------------------- END OF EDITABLE DEFAULTS ------------------------------- //
	
	
	    external = true,
	
	    decimalError = '[DecimalError] ',
	    invalidArgument = decimalError + 'Invalid argument: ',
	    exponentOutOfRange = decimalError + 'Exponent out of range: ',
	
	    mathfloor = Math.floor,
	    mathpow = Math.pow,
	
	    isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i,
	
	    ONE,
	    BASE = 1e7,
	    LOG_BASE = 7,
	    MAX_SAFE_INTEGER = 9007199254740991,
	    MAX_E = mathfloor(MAX_SAFE_INTEGER / LOG_BASE),    // 1286742750677284
	
	    // Decimal.prototype object
	    P = {};
	
	
	  // Decimal prototype methods
	
	
	  /*
	   *  absoluteValue                       abs
	   *  comparedTo                          cmp
	   *  decimalPlaces                       dp
	   *  dividedBy                           div
	   *  dividedToIntegerBy                  idiv
	   *  equals                              eq
	   *  exponent
	   *  greaterThan                         gt
	   *  greaterThanOrEqualTo                gte
	   *  isInteger                           isint
	   *  isNegative                          isneg
	   *  isPositive                          ispos
	   *  isZero
	   *  lessThan                            lt
	   *  lessThanOrEqualTo                   lte
	   *  logarithm                           log
	   *  minus                               sub
	   *  modulo                              mod
	   *  naturalExponential                  exp
	   *  naturalLogarithm                    ln
	   *  negated                             neg
	   *  plus                                add
	   *  precision                           sd
	   *  squareRoot                          sqrt
	   *  times                               mul
	   *  toDecimalPlaces                     todp
	   *  toExponential
	   *  toFixed
	   *  toInteger                           toint
	   *  toNumber
	   *  toPower                             pow
	   *  toPrecision
	   *  toSignificantDigits                 tosd
	   *  toString
	   *  valueOf                             val
	   */
	
	
	  /*
	   * Return a new Decimal whose value is the absolute value of this Decimal.
	   *
	   */
	  P.absoluteValue = P.abs = function () {
	    var x = new this.constructor(this);
	    if (x.s) x.s = 1;
	    return x;
	  };
	
	
	  /*
	   * Return
	   *   1    if the value of this Decimal is greater than the value of `y`,
	   *  -1    if the value of this Decimal is less than the value of `y`,
	   *   0    if they have the same value
	   *
	   */
	  P.comparedTo = P.cmp = function (y) {
	    var i, j, xdL, ydL,
	      x = this;
	
	    y = new x.constructor(y);
	
	    // Signs differ?
	    if (x.s !== y.s) return x.s || -y.s;
	
	    // Compare exponents.
	    if (x.e !== y.e) return x.e > y.e ^ x.s < 0 ? 1 : -1;
	
	    xdL = x.d.length;
	    ydL = y.d.length;
	
	    // Compare digit by digit.
	    for (i = 0, j = xdL < ydL ? xdL : ydL; i < j; ++i) {
	      if (x.d[i] !== y.d[i]) return x.d[i] > y.d[i] ^ x.s < 0 ? 1 : -1;
	    }
	
	    // Compare lengths.
	    return xdL === ydL ? 0 : xdL > ydL ^ x.s < 0 ? 1 : -1;
	  };
	
	
	  /*
	   * Return the number of decimal places of the value of this Decimal.
	   *
	   */
	  P.decimalPlaces = P.dp = function () {
	    var x = this,
	      w = x.d.length - 1,
	      dp = (w - x.e) * LOG_BASE;
	
	    // Subtract the number of trailing zeros of the last word.
	    w = x.d[w];
	    if (w) for (; w % 10 == 0; w /= 10) dp--;
	
	    return dp < 0 ? 0 : dp;
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the value of this Decimal divided by `y`, truncated to
	   * `precision` significant digits.
	   *
	   */
	  P.dividedBy = P.div = function (y) {
	    return divide(this, new this.constructor(y));
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the integer part of dividing the value of this Decimal
	   * by the value of `y`, truncated to `precision` significant digits.
	   *
	   */
	  P.dividedToIntegerBy = P.idiv = function (y) {
	    var x = this,
	      Ctor = x.constructor;
	    return round(divide(x, new Ctor(y), 0, 1), Ctor.precision);
	  };
	
	
	  /*
	   * Return true if the value of this Decimal is equal to the value of `y`, otherwise return false.
	   *
	   */
	  P.equals = P.eq = function (y) {
	    return !this.cmp(y);
	  };
	
	
	  /*
	   * Return the (base 10) exponent value of this Decimal (this.e is the base 10000000 exponent).
	   *
	   */
	  P.exponent = function () {
	    return getBase10Exponent(this);
	  };
	
	
	  /*
	   * Return true if the value of this Decimal is greater than the value of `y`, otherwise return
	   * false.
	   *
	   */
	  P.greaterThan = P.gt = function (y) {
	    return this.cmp(y) > 0;
	  };
	
	
	  /*
	   * Return true if the value of this Decimal is greater than or equal to the value of `y`,
	   * otherwise return false.
	   *
	   */
	  P.greaterThanOrEqualTo = P.gte = function (y) {
	    return this.cmp(y) >= 0;
	  };
	
	
	  /*
	   * Return true if the value of this Decimal is an integer, otherwise return false.
	   *
	   */
	  P.isInteger = P.isint = function () {
	    return this.e > this.d.length - 2;
	  };
	
	
	  /*
	   * Return true if the value of this Decimal is negative, otherwise return false.
	   *
	   */
	  P.isNegative = P.isneg = function () {
	    return this.s < 0;
	  };
	
	
	  /*
	   * Return true if the value of this Decimal is positive, otherwise return false.
	   *
	   */
	  P.isPositive = P.ispos = function () {
	    return this.s > 0;
	  };
	
	
	  /*
	   * Return true if the value of this Decimal is 0, otherwise return false.
	   *
	   */
	  P.isZero = function () {
	    return this.s === 0;
	  };
	
	
	  /*
	   * Return true if the value of this Decimal is less than `y`, otherwise return false.
	   *
	   */
	  P.lessThan = P.lt = function (y) {
	    return this.cmp(y) < 0;
	  };
	
	
	  /*
	   * Return true if the value of this Decimal is less than or equal to `y`, otherwise return false.
	   *
	   */
	  P.lessThanOrEqualTo = P.lte = function (y) {
	    return this.cmp(y) < 1;
	  };
	
	
	  /*
	   * Return the logarithm of the value of this Decimal to the specified base, truncated to
	   * `precision` significant digits.
	   *
	   * If no base is specified, return log[10](x).
	   *
	   * log[base](x) = ln(x) / ln(base)
	   *
	   * The maximum error of the result is 1 ulp (unit in the last place).
	   *
	   * [base] {number|string|Decimal} The base of the logarithm.
	   *
	   */
	  P.logarithm = P.log = function (base) {
	    var r,
	      x = this,
	      Ctor = x.constructor,
	      pr = Ctor.precision,
	      wpr = pr + 5;
	
	    // Default base is 10.
	    if (base === void 0) {
	      base = new Ctor(10);
	    } else {
	      base = new Ctor(base);
	
	      // log[-b](x) = NaN
	      // log[0](x)  = NaN
	      // log[1](x)  = NaN
	      if (base.s < 1 || base.eq(ONE)) throw Error(decimalError + 'NaN');
	    }
	
	    // log[b](-x) = NaN
	    // log[b](0) = -Infinity
	    if (x.s < 1) throw Error(decimalError + (x.s ? 'NaN' : '-Infinity'));
	
	    // log[b](1) = 0
	    if (x.eq(ONE)) return new Ctor(0);
	
	    external = false;
	    r = divide(ln(x, wpr), ln(base, wpr), wpr);
	    external = true;
	
	    return round(r, pr);
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the value of this Decimal minus `y`, truncated to
	   * `precision` significant digits.
	   *
	   */
	  P.minus = P.sub = function (y) {
	    var x = this;
	    y = new x.constructor(y);
	    return x.s == y.s ? subtract(x, y) : add(x, (y.s = -y.s, y));
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the value of this Decimal modulo `y`, truncated to
	   * `precision` significant digits.
	   *
	   */
	  P.modulo = P.mod = function (y) {
	    var q,
	      x = this,
	      Ctor = x.constructor,
	      pr = Ctor.precision;
	
	    y = new Ctor(y);
	
	    // x % 0 = NaN
	    if (!y.s) throw Error(decimalError + 'NaN');
	
	    // Return x if x is 0.
	    if (!x.s) return round(new Ctor(x), pr);
	
	    // Prevent rounding of intermediate calculations.
	    external = false;
	    q = divide(x, y, 0, 1).times(y);
	    external = true;
	
	    return x.minus(q);
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the natural exponential of the value of this Decimal,
	   * i.e. the base e raised to the power the value of this Decimal, truncated to `precision`
	   * significant digits.
	   *
	   */
	  P.naturalExponential = P.exp = function () {
	    return exp(this);
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the natural logarithm of the value of this Decimal,
	   * truncated to `precision` significant digits.
	   *
	   */
	  P.naturalLogarithm = P.ln = function () {
	    return ln(this);
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the value of this Decimal negated, i.e. as if multiplied by
	   * -1.
	   *
	   */
	  P.negated = P.neg = function () {
	    var x = new this.constructor(this);
	    x.s = -x.s || 0;
	    return x;
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the value of this Decimal plus `y`, truncated to
	   * `precision` significant digits.
	   *
	   */
	  P.plus = P.add = function (y) {
	    var x = this;
	    y = new x.constructor(y);
	    return x.s == y.s ? add(x, y) : subtract(x, (y.s = -y.s, y));
	  };
	
	
	  /*
	   * Return the number of significant digits of the value of this Decimal.
	   *
	   * [z] {boolean|number} Whether to count integer-part trailing zeros: true, false, 1 or 0.
	   *
	   */
	  P.precision = P.sd = function (z) {
	    var e, sd, w,
	      x = this;
	
	    if (z !== void 0 && z !== !!z && z !== 1 && z !== 0) throw Error(invalidArgument + z);
	
	    e = getBase10Exponent(x) + 1;
	    w = x.d.length - 1;
	    sd = w * LOG_BASE + 1;
	    w = x.d[w];
	
	    // If non-zero...
	    if (w) {
	
	      // Subtract the number of trailing zeros of the last word.
	      for (; w % 10 == 0; w /= 10) sd--;
	
	      // Add the number of digits of the first word.
	      for (w = x.d[0]; w >= 10; w /= 10) sd++;
	    }
	
	    return z && e > sd ? e : sd;
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the square root of this Decimal, truncated to `precision`
	   * significant digits.
	   *
	   */
	  P.squareRoot = P.sqrt = function () {
	    var e, n, pr, r, s, t, wpr,
	      x = this,
	      Ctor = x.constructor;
	
	    // Negative or zero?
	    if (x.s < 1) {
	      if (!x.s) return new Ctor(0);
	
	      // sqrt(-x) = NaN
	      throw Error(decimalError + 'NaN');
	    }
	
	    e = getBase10Exponent(x);
	    external = false;
	
	    // Initial estimate.
	    s = Math.sqrt(+x);
	
	    // Math.sqrt underflow/overflow?
	    // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
	    if (s == 0 || s == 1 / 0) {
	      n = digitsToString(x.d);
	      if ((n.length + e) % 2 == 0) n += '0';
	      s = Math.sqrt(n);
	      e = mathfloor((e + 1) / 2) - (e < 0 || e % 2);
	
	      if (s == 1 / 0) {
	        n = '5e' + e;
	      } else {
	        n = s.toExponential();
	        n = n.slice(0, n.indexOf('e') + 1) + e;
	      }
	
	      r = new Ctor(n);
	    } else {
	      r = new Ctor(s.toString());
	    }
	
	    pr = Ctor.precision;
	    s = wpr = pr + 3;
	
	    // Newton-Raphson iteration.
	    for (;;) {
	      t = r;
	      r = t.plus(divide(x, t, wpr + 2)).times(0.5);
	
	      if (digitsToString(t.d).slice(0, wpr) === (n = digitsToString(r.d)).slice(0, wpr)) {
	        n = n.slice(wpr - 3, wpr + 1);
	
	        // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or
	        // 4999, i.e. approaching a rounding boundary, continue the iteration.
	        if (s == wpr && n == '4999') {
	
	          // On the first iteration only, check to see if rounding up gives the exact result as the
	          // nines may infinitely repeat.
	          round(t, pr + 1, 0);
	
	          if (t.times(t).eq(x)) {
	            r = t;
	            break;
	          }
	        } else if (n != '9999') {
	          break;
	        }
	
	        wpr += 4;
	      }
	    }
	
	    external = true;
	
	    return round(r, pr);
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the value of this Decimal times `y`, truncated to
	   * `precision` significant digits.
	   *
	   */
	  P.times = P.mul = function (y) {
	    var carry, e, i, k, r, rL, t, xdL, ydL,
	      x = this,
	      Ctor = x.constructor,
	      xd = x.d,
	      yd = (y = new Ctor(y)).d;
	
	    // Return 0 if either is 0.
	    if (!x.s || !y.s) return new Ctor(0);
	
	    y.s *= x.s;
	    e = x.e + y.e;
	    xdL = xd.length;
	    ydL = yd.length;
	
	    // Ensure xd points to the longer array.
	    if (xdL < ydL) {
	      r = xd;
	      xd = yd;
	      yd = r;
	      rL = xdL;
	      xdL = ydL;
	      ydL = rL;
	    }
	
	    // Initialise the result array with zeros.
	    r = [];
	    rL = xdL + ydL;
	    for (i = rL; i--;) r.push(0);
	
	    // Multiply!
	    for (i = ydL; --i >= 0;) {
	      carry = 0;
	      for (k = xdL + i; k > i;) {
	        t = r[k] + yd[i] * xd[k - i - 1] + carry;
	        r[k--] = t % BASE | 0;
	        carry = t / BASE | 0;
	      }
	
	      r[k] = (r[k] + carry) % BASE | 0;
	    }
	
	    // Remove trailing zeros.
	    for (; !r[--rL];) r.pop();
	
	    if (carry) ++e;
	    else r.shift();
	
	    y.d = r;
	    y.e = e;
	
	    return external ? round(y, Ctor.precision) : y;
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `dp`
	   * decimal places using rounding mode `rm` or `rounding` if `rm` is omitted.
	   *
	   * If `dp` is omitted, return a new Decimal whose value is the value of this Decimal.
	   *
	   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
	   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
	   *
	   */
	  P.toDecimalPlaces = P.todp = function (dp, rm) {
	    var x = this,
	      Ctor = x.constructor;
	
	    x = new Ctor(x);
	    if (dp === void 0) return x;
	
	    checkInt32(dp, 0, MAX_DIGITS);
	
	    if (rm === void 0) rm = Ctor.rounding;
	    else checkInt32(rm, 0, 8);
	
	    return round(x, dp + getBase10Exponent(x) + 1, rm);
	  };
	
	
	  /*
	   * Return a string representing the value of this Decimal in exponential notation rounded to
	   * `dp` fixed decimal places using rounding mode `rounding`.
	   *
	   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
	   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
	   *
	   */
	  P.toExponential = function (dp, rm) {
	    var str,
	      x = this,
	      Ctor = x.constructor;
	
	    if (dp === void 0) {
	      str = toString(x, true);
	    } else {
	      checkInt32(dp, 0, MAX_DIGITS);
	
	      if (rm === void 0) rm = Ctor.rounding;
	      else checkInt32(rm, 0, 8);
	
	      x = round(new Ctor(x), dp + 1, rm);
	      str = toString(x, true, dp + 1);
	    }
	
	    return str;
	  };
	
	
	  /*
	   * Return a string representing the value of this Decimal in normal (fixed-point) notation to
	   * `dp` fixed decimal places and rounded using rounding mode `rm` or `rounding` if `rm` is
	   * omitted.
	   *
	   * As with JavaScript numbers, (-0).toFixed(0) is '0', but e.g. (-0.00001).toFixed(0) is '-0'.
	   *
	   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
	   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
	   *
	   * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
	   * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
	   * (-0).toFixed(3) is '0.000'.
	   * (-0.5).toFixed(0) is '-0'.
	   *
	   */
	  P.toFixed = function (dp, rm) {
	    var str, y,
	      x = this,
	      Ctor = x.constructor;
	
	    if (dp === void 0) return toString(x);
	
	    checkInt32(dp, 0, MAX_DIGITS);
	
	    if (rm === void 0) rm = Ctor.rounding;
	    else checkInt32(rm, 0, 8);
	
	    y = round(new Ctor(x), dp + getBase10Exponent(x) + 1, rm);
	    str = toString(y.abs(), false, dp + getBase10Exponent(y) + 1);
	
	    // To determine whether to add the minus sign look at the value before it was rounded,
	    // i.e. look at `x` rather than `y`.
	    return x.isneg() && !x.isZero() ? '-' + str : str;
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number using
	   * rounding mode `rounding`.
	   *
	   */
	  P.toInteger = P.toint = function () {
	    var x = this,
	      Ctor = x.constructor;
	    return round(new Ctor(x), getBase10Exponent(x) + 1, Ctor.rounding);
	  };
	
	
	  /*
	   * Return the value of this Decimal converted to a number primitive.
	   *
	   */
	  P.toNumber = function () {
	    return +this;
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the value of this Decimal raised to the power `y`,
	   * truncated to `precision` significant digits.
	   *
	   * For non-integer or very large exponents pow(x, y) is calculated using
	   *
	   *   x^y = exp(y*ln(x))
	   *
	   * The maximum error is 1 ulp (unit in last place).
	   *
	   * y {number|string|Decimal} The power to which to raise this Decimal.
	   *
	   */
	  P.toPower = P.pow = function (y) {
	    var e, k, pr, r, sign, yIsInt,
	      x = this,
	      Ctor = x.constructor,
	      guard = 12,
	      yn = +(y = new Ctor(y));
	
	    // pow(x, 0) = 1
	    if (!y.s) return new Ctor(ONE);
	
	    x = new Ctor(x);
	
	    // pow(0, y > 0) = 0
	    // pow(0, y < 0) = Infinity
	    if (!x.s) {
	      if (y.s < 1) throw Error(decimalError + 'Infinity');
	      return x;
	    }
	
	    // pow(1, y) = 1
	    if (x.eq(ONE)) return x;
	
	    pr = Ctor.precision;
	
	    // pow(x, 1) = x
	    if (y.eq(ONE)) return round(x, pr);
	
	    e = y.e;
	    k = y.d.length - 1;
	    yIsInt = e >= k;
	    sign = x.s;
	
	    if (!yIsInt) {
	
	      // pow(x < 0, y non-integer) = NaN
	      if (sign < 0) throw Error(decimalError + 'NaN');
	
	    // If y is a small integer use the 'exponentiation by squaring' algorithm.
	    } else if ((k = yn < 0 ? -yn : yn) <= MAX_SAFE_INTEGER) {
	      r = new Ctor(ONE);
	
	      // Max k of 9007199254740991 takes 53 loop iterations.
	      // Maximum digits array length; leaves [28, 34] guard digits.
	      e = Math.ceil(pr / LOG_BASE + 4);
	
	      external = false;
	
	      for (;;) {
	        if (k % 2) {
	          r = r.times(x);
	          truncate(r.d, e);
	        }
	
	        k = mathfloor(k / 2);
	        if (k === 0) break;
	
	        x = x.times(x);
	        truncate(x.d, e);
	      }
	
	      external = true;
	
	      return y.s < 0 ? new Ctor(ONE).div(r) : round(r, pr);
	    }
	
	    // Result is negative if x is negative and the last digit of integer y is odd.
	    sign = sign < 0 && y.d[Math.max(e, k)] & 1 ? -1 : 1;
	
	    x.s = 1;
	    external = false;
	    r = y.times(ln(x, pr + guard));
	    external = true;
	    r = exp(r);
	    r.s = sign;
	
	    return r;
	  };
	
	
	  /*
	   * Return a string representing the value of this Decimal rounded to `sd` significant digits
	   * using rounding mode `rounding`.
	   *
	   * Return exponential notation if `sd` is less than the number of digits necessary to represent
	   * the integer part of the value in normal notation.
	   *
	   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
	   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
	   *
	   */
	  P.toPrecision = function (sd, rm) {
	    var e, str,
	      x = this,
	      Ctor = x.constructor;
	
	    if (sd === void 0) {
	      e = getBase10Exponent(x);
	      str = toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
	    } else {
	      checkInt32(sd, 1, MAX_DIGITS);
	
	      if (rm === void 0) rm = Ctor.rounding;
	      else checkInt32(rm, 0, 8);
	
	      x = round(new Ctor(x), sd, rm);
	      e = getBase10Exponent(x);
	      str = toString(x, sd <= e || e <= Ctor.toExpNeg, sd);
	    }
	
	    return str;
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `sd`
	   * significant digits using rounding mode `rm`, or to `precision` and `rounding` respectively if
	   * omitted.
	   *
	   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
	   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
	   *
	   */
	  P.toSignificantDigits = P.tosd = function (sd, rm) {
	    var x = this,
	      Ctor = x.constructor;
	
	    if (sd === void 0) {
	      sd = Ctor.precision;
	      rm = Ctor.rounding;
	    } else {
	      checkInt32(sd, 1, MAX_DIGITS);
	
	      if (rm === void 0) rm = Ctor.rounding;
	      else checkInt32(rm, 0, 8);
	    }
	
	    return round(new Ctor(x), sd, rm);
	  };
	
	
	  /*
	   * Return a string representing the value of this Decimal.
	   *
	   * Return exponential notation if this Decimal has a positive exponent equal to or greater than
	   * `toExpPos`, or a negative exponent equal to or less than `toExpNeg`.
	   *
	   */
	  P.toString = P.valueOf = P.val = P.toJSON = function () {
	    var x = this,
	      e = getBase10Exponent(x),
	      Ctor = x.constructor;
	
	    return toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
	  };
	
	
	  // Helper functions for Decimal.prototype (P) and/or Decimal methods, and their callers.
	
	
	  /*
	   *  add                 P.minus, P.plus
	   *  checkInt32          P.todp, P.toExponential, P.toFixed, P.toPrecision, P.tosd
	   *  digitsToString      P.log, P.sqrt, P.pow, toString, exp, ln
	   *  divide              P.div, P.idiv, P.log, P.mod, P.sqrt, exp, ln
	   *  exp                 P.exp, P.pow
	   *  getBase10Exponent   P.exponent, P.sd, P.toint, P.sqrt, P.todp, P.toFixed, P.toPrecision,
	   *                      P.toString, divide, round, toString, exp, ln
	   *  getLn10             P.log, ln
	   *  getZeroString       digitsToString, toString
	   *  ln                  P.log, P.ln, P.pow, exp
	   *  parseDecimal        Decimal
	   *  round               P.abs, P.idiv, P.log, P.minus, P.mod, P.neg, P.plus, P.toint, P.sqrt,
	   *                      P.times, P.todp, P.toExponential, P.toFixed, P.pow, P.toPrecision, P.tosd,
	   *                      divide, getLn10, exp, ln
	   *  subtract            P.minus, P.plus
	   *  toString            P.toExponential, P.toFixed, P.toPrecision, P.toString, P.valueOf
	   *  truncate            P.pow
	   *
	   *  Throws:             P.log, P.mod, P.sd, P.sqrt, P.pow,  checkInt32, divide, round,
	   *                      getLn10, exp, ln, parseDecimal, Decimal, config
	   */
	
	
	  function add(x, y) {
	    var carry, d, e, i, k, len, xd, yd,
	      Ctor = x.constructor,
	      pr = Ctor.precision;
	
	    // If either is zero...
	    if (!x.s || !y.s) {
	
	      // Return x if y is zero.
	      // Return y if y is non-zero.
	      if (!y.s) y = new Ctor(x);
	      return external ? round(y, pr) : y;
	    }
	
	    xd = x.d;
	    yd = y.d;
	
	    // x and y are finite, non-zero numbers with the same sign.
	
	    k = x.e;
	    e = y.e;
	    xd = xd.slice();
	    i = k - e;
	
	    // If base 1e7 exponents differ...
	    if (i) {
	      if (i < 0) {
	        d = xd;
	        i = -i;
	        len = yd.length;
	      } else {
	        d = yd;
	        e = k;
	        len = xd.length;
	      }
	
	      // Limit number of zeros prepended to max(ceil(pr / LOG_BASE), len) + 1.
	      k = Math.ceil(pr / LOG_BASE);
	      len = k > len ? k + 1 : len + 1;
	
	      if (i > len) {
	        i = len;
	        d.length = 1;
	      }
	
	      // Prepend zeros to equalise exponents. Note: Faster to use reverse then do unshifts.
	      d.reverse();
	      for (; i--;) d.push(0);
	      d.reverse();
	    }
	
	    len = xd.length;
	    i = yd.length;
	
	    // If yd is longer than xd, swap xd and yd so xd points to the longer array.
	    if (len - i < 0) {
	      i = len;
	      d = yd;
	      yd = xd;
	      xd = d;
	    }
	
	    // Only start adding at yd.length - 1 as the further digits of xd can be left as they are.
	    for (carry = 0; i;) {
	      carry = (xd[--i] = xd[i] + yd[i] + carry) / BASE | 0;
	      xd[i] %= BASE;
	    }
	
	    if (carry) {
	      xd.unshift(carry);
	      ++e;
	    }
	
	    // Remove trailing zeros.
	    // No need to check for zero, as +x + +y != 0 && -x + -y != 0
	    for (len = xd.length; xd[--len] == 0;) xd.pop();
	
	    y.d = xd;
	    y.e = e;
	
	    return external ? round(y, pr) : y;
	  }
	
	
	  function checkInt32(i, min, max) {
	    if (i !== ~~i || i < min || i > max) {
	      throw Error(invalidArgument + i);
	    }
	  }
	
	
	  function digitsToString(d) {
	    var i, k, ws,
	      indexOfLastWord = d.length - 1,
	      str = '',
	      w = d[0];
	
	    if (indexOfLastWord > 0) {
	      str += w;
	      for (i = 1; i < indexOfLastWord; i++) {
	        ws = d[i] + '';
	        k = LOG_BASE - ws.length;
	        if (k) str += getZeroString(k);
	        str += ws;
	      }
	
	      w = d[i];
	      ws = w + '';
	      k = LOG_BASE - ws.length;
	      if (k) str += getZeroString(k);
	    } else if (w === 0) {
	      return '0';
	    }
	
	    // Remove trailing zeros of last w.
	    for (; w % 10 === 0;) w /= 10;
	
	    return str + w;
	  }
	
	
	  var divide = (function () {
	
	    // Assumes non-zero x and k, and hence non-zero result.
	    function multiplyInteger(x, k) {
	      var temp,
	        carry = 0,
	        i = x.length;
	
	      for (x = x.slice(); i--;) {
	        temp = x[i] * k + carry;
	        x[i] = temp % BASE | 0;
	        carry = temp / BASE | 0;
	      }
	
	      if (carry) x.unshift(carry);
	
	      return x;
	    }
	
	    function compare(a, b, aL, bL) {
	      var i, r;
	
	      if (aL != bL) {
	        r = aL > bL ? 1 : -1;
	      } else {
	        for (i = r = 0; i < aL; i++) {
	          if (a[i] != b[i]) {
	            r = a[i] > b[i] ? 1 : -1;
	            break;
	          }
	        }
	      }
	
	      return r;
	    }
	
	    function subtract(a, b, aL) {
	      var i = 0;
	
	      // Subtract b from a.
	      for (; aL--;) {
	        a[aL] -= i;
	        i = a[aL] < b[aL] ? 1 : 0;
	        a[aL] = i * BASE + a[aL] - b[aL];
	      }
	
	      // Remove leading zeros.
	      for (; !a[0] && a.length > 1;) a.shift();
	    }
	
	    return function (x, y, pr, dp) {
	      var cmp, e, i, k, prod, prodL, q, qd, rem, remL, rem0, sd, t, xi, xL, yd0, yL, yz,
	        Ctor = x.constructor,
	        sign = x.s == y.s ? 1 : -1,
	        xd = x.d,
	        yd = y.d;
	
	      // Either 0?
	      if (!x.s) return new Ctor(x);
	      if (!y.s) throw Error(decimalError + 'Division by zero');
	
	      e = x.e - y.e;
	      yL = yd.length;
	      xL = xd.length;
	      q = new Ctor(sign);
	      qd = q.d = [];
	
	      // Result exponent may be one less than e.
	      for (i = 0; yd[i] == (xd[i] || 0); ) ++i;
	      if (yd[i] > (xd[i] || 0)) --e;
	
	      if (pr == null) {
	        sd = pr = Ctor.precision;
	      } else if (dp) {
	        sd = pr + (getBase10Exponent(x) - getBase10Exponent(y)) + 1;
	      } else {
	        sd = pr;
	      }
	
	      if (sd < 0) return new Ctor(0);
	
	      // Convert precision in number of base 10 digits to base 1e7 digits.
	      sd = sd / LOG_BASE + 2 | 0;
	      i = 0;
	
	      // divisor < 1e7
	      if (yL == 1) {
	        k = 0;
	        yd = yd[0];
	        sd++;
	
	        // k is the carry.
	        for (; (i < xL || k) && sd--; i++) {
	          t = k * BASE + (xd[i] || 0);
	          qd[i] = t / yd | 0;
	          k = t % yd | 0;
	        }
	
	      // divisor >= 1e7
	      } else {
	
	        // Normalise xd and yd so highest order digit of yd is >= BASE/2
	        k = BASE / (yd[0] + 1) | 0;
	
	        if (k > 1) {
	          yd = multiplyInteger(yd, k);
	          xd = multiplyInteger(xd, k);
	          yL = yd.length;
	          xL = xd.length;
	        }
	
	        xi = yL;
	        rem = xd.slice(0, yL);
	        remL = rem.length;
	
	        // Add zeros to make remainder as long as divisor.
	        for (; remL < yL;) rem[remL++] = 0;
	
	        yz = yd.slice();
	        yz.unshift(0);
	        yd0 = yd[0];
	
	        if (yd[1] >= BASE / 2) ++yd0;
	
	        do {
	          k = 0;
	
	          // Compare divisor and remainder.
	          cmp = compare(yd, rem, yL, remL);
	
	          // If divisor < remainder.
	          if (cmp < 0) {
	
	            // Calculate trial digit, k.
	            rem0 = rem[0];
	            if (yL != remL) rem0 = rem0 * BASE + (rem[1] || 0);
	
	            // k will be how many times the divisor goes into the current remainder.
	            k = rem0 / yd0 | 0;
	
	            //  Algorithm:
	            //  1. product = divisor * trial digit (k)
	            //  2. if product > remainder: product -= divisor, k--
	            //  3. remainder -= product
	            //  4. if product was < remainder at 2:
	            //    5. compare new remainder and divisor
	            //    6. If remainder > divisor: remainder -= divisor, k++
	
	            if (k > 1) {
	              if (k >= BASE) k = BASE - 1;
	
	              // product = divisor * trial digit.
	              prod = multiplyInteger(yd, k);
	              prodL = prod.length;
	              remL = rem.length;
	
	              // Compare product and remainder.
	              cmp = compare(prod, rem, prodL, remL);
	
	              // product > remainder.
	              if (cmp == 1) {
	                k--;
	
	                // Subtract divisor from product.
	                subtract(prod, yL < prodL ? yz : yd, prodL);
	              }
	            } else {
	
	              // cmp is -1.
	              // If k is 0, there is no need to compare yd and rem again below, so change cmp to 1
	              // to avoid it. If k is 1 there is a need to compare yd and rem again below.
	              if (k == 0) cmp = k = 1;
	              prod = yd.slice();
	            }
	
	            prodL = prod.length;
	            if (prodL < remL) prod.unshift(0);
	
	            // Subtract product from remainder.
	            subtract(rem, prod, remL);
	
	            // If product was < previous remainder.
	            if (cmp == -1) {
	              remL = rem.length;
	
	              // Compare divisor and new remainder.
	              cmp = compare(yd, rem, yL, remL);
	
	              // If divisor < new remainder, subtract divisor from remainder.
	              if (cmp < 1) {
	                k++;
	
	                // Subtract divisor from remainder.
	                subtract(rem, yL < remL ? yz : yd, remL);
	              }
	            }
	
	            remL = rem.length;
	          } else if (cmp === 0) {
	            k++;
	            rem = [0];
	          }    // if cmp === 1, k will be 0
	
	          // Add the next digit, k, to the result array.
	          qd[i++] = k;
	
	          // Update the remainder.
	          if (cmp && rem[0]) {
	            rem[remL++] = xd[xi] || 0;
	          } else {
	            rem = [xd[xi]];
	            remL = 1;
	          }
	
	        } while ((xi++ < xL || rem[0] !== void 0) && sd--);
	      }
	
	      // Leading zero?
	      if (!qd[0]) qd.shift();
	
	      q.e = e;
	
	      return round(q, dp ? pr + getBase10Exponent(q) + 1 : pr);
	    };
	  })();
	
	
	  /*
	   * Return a new Decimal whose value is the natural exponential of `x` truncated to `sd`
	   * significant digits.
	   *
	   * Taylor/Maclaurin series.
	   *
	   * exp(x) = x^0/0! + x^1/1! + x^2/2! + x^3/3! + ...
	   *
	   * Argument reduction:
	   *   Repeat x = x / 32, k += 5, until |x| < 0.1
	   *   exp(x) = exp(x / 2^k)^(2^k)
	   *
	   * Previously, the argument was initially reduced by
	   * exp(x) = exp(r) * 10^k  where r = x - k * ln10, k = floor(x / ln10)
	   * to first put r in the range [0, ln10], before dividing by 32 until |x| < 0.1, but this was
	   * found to be slower than just dividing repeatedly by 32 as above.
	   *
	   * (Math object integer min/max: Math.exp(709) = 8.2e+307, Math.exp(-745) = 5e-324)
	   *
	   *  exp(x) is non-terminating for any finite, non-zero x.
	   *
	   */
	  function exp(x, sd) {
	    var denominator, guard, pow, sum, t, wpr,
	      i = 0,
	      k = 0,
	      Ctor = x.constructor,
	      pr = Ctor.precision;
	
	    if (getBase10Exponent(x) > 16) throw Error(exponentOutOfRange + getBase10Exponent(x));
	
	    // exp(0) = 1
	    if (!x.s) return new Ctor(ONE);
	
	    if (sd == null) {
	      external = false;
	      wpr = pr;
	    } else {
	      wpr = sd;
	    }
	
	    t = new Ctor(0.03125);
	
	    while (x.abs().gte(0.1)) {
	      x = x.times(t);    // x = x / 2^5
	      k += 5;
	    }
	
	    // Estimate the precision increase necessary to ensure the first 4 rounding digits are correct.
	    guard = Math.log(mathpow(2, k)) / Math.LN10 * 2 + 5 | 0;
	    wpr += guard;
	    denominator = pow = sum = new Ctor(ONE);
	    Ctor.precision = wpr;
	
	    for (;;) {
	      pow = round(pow.times(x), wpr);
	      denominator = denominator.times(++i);
	      t = sum.plus(divide(pow, denominator, wpr));
	
	      if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
	        while (k--) sum = round(sum.times(sum), wpr);
	        Ctor.precision = pr;
	        return sd == null ? (external = true, round(sum, pr)) : sum;
	      }
	
	      sum = t;
	    }
	  }
	
	
	  // Calculate the base 10 exponent from the base 1e7 exponent.
	  function getBase10Exponent(x) {
	    var e = x.e * LOG_BASE,
	      w = x.d[0];
	
	    // Add the number of digits of the first word of the digits array.
	    for (; w >= 10; w /= 10) e++;
	    return e;
	  }
	
	
	  function getLn10(Ctor, sd, pr) {
	
	    if (sd > Ctor.LN10.sd()) {
	
	
	      // Reset global state in case the exception is caught.
	      external = true;
	      if (pr) Ctor.precision = pr;
	      throw Error(decimalError + 'LN10 precision limit exceeded');
	    }
	
	    return round(new Ctor(Ctor.LN10), sd);
	  }
	
	
	  function getZeroString(k) {
	    var zs = '';
	    for (; k--;) zs += '0';
	    return zs;
	  }
	
	
	  /*
	   * Return a new Decimal whose value is the natural logarithm of `x` truncated to `sd` significant
	   * digits.
	   *
	   *  ln(n) is non-terminating (n != 1)
	   *
	   */
	  function ln(y, sd) {
	    var c, c0, denominator, e, numerator, sum, t, wpr, x2,
	      n = 1,
	      guard = 10,
	      x = y,
	      xd = x.d,
	      Ctor = x.constructor,
	      pr = Ctor.precision;
	
	    // ln(-x) = NaN
	    // ln(0) = -Infinity
	    if (x.s < 1) throw Error(decimalError + (x.s ? 'NaN' : '-Infinity'));
	
	    // ln(1) = 0
	    if (x.eq(ONE)) return new Ctor(0);
	
	    if (sd == null) {
	      external = false;
	      wpr = pr;
	    } else {
	      wpr = sd;
	    }
	
	    if (x.eq(10)) {
	      if (sd == null) external = true;
	      return getLn10(Ctor, wpr);
	    }
	
	    wpr += guard;
	    Ctor.precision = wpr;
	    c = digitsToString(xd);
	    c0 = c.charAt(0);
	    e = getBase10Exponent(x);
	
	    if (Math.abs(e) < 1.5e15) {
	
	      // Argument reduction.
	      // The series converges faster the closer the argument is to 1, so using
	      // ln(a^b) = b * ln(a),   ln(a) = ln(a^b) / b
	      // multiply the argument by itself until the leading digits of the significand are 7, 8, 9,
	      // 10, 11, 12 or 13, recording the number of multiplications so the sum of the series can
	      // later be divided by this number, then separate out the power of 10 using
	      // ln(a*10^b) = ln(a) + b*ln(10).
	
	      // max n is 21 (gives 0.9, 1.0 or 1.1) (9e15 / 21 = 4.2e14).
	      //while (c0 < 9 && c0 != 1 || c0 == 1 && c.charAt(1) > 1) {
	      // max n is 6 (gives 0.7 - 1.3)
	      while (c0 < 7 && c0 != 1 || c0 == 1 && c.charAt(1) > 3) {
	        x = x.times(y);
	        c = digitsToString(x.d);
	        c0 = c.charAt(0);
	        n++;
	      }
	
	      e = getBase10Exponent(x);
	
	      if (c0 > 1) {
	        x = new Ctor('0.' + c);
	        e++;
	      } else {
	        x = new Ctor(c0 + '.' + c.slice(1));
	      }
	    } else {
	
	      // The argument reduction method above may result in overflow if the argument y is a massive
	      // number with exponent >= 1500000000000000 (9e15 / 6 = 1.5e15), so instead recall this
	      // function using ln(x*10^e) = ln(x) + e*ln(10).
	      t = getLn10(Ctor, wpr + 2, pr).times(e + '');
	      x = ln(new Ctor(c0 + '.' + c.slice(1)), wpr - guard).plus(t);
	
	      Ctor.precision = pr;
	      return sd == null ? (external = true, round(x, pr)) : x;
	    }
	
	    // x is reduced to a value near 1.
	
	    // Taylor series.
	    // ln(y) = ln((1 + x)/(1 - x)) = 2(x + x^3/3 + x^5/5 + x^7/7 + ...)
	    // where x = (y - 1)/(y + 1)    (|x| < 1)
	    sum = numerator = x = divide(x.minus(ONE), x.plus(ONE), wpr);
	    x2 = round(x.times(x), wpr);
	    denominator = 3;
	
	    for (;;) {
	      numerator = round(numerator.times(x2), wpr);
	      t = sum.plus(divide(numerator, new Ctor(denominator), wpr));
	
	      if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
	        sum = sum.times(2);
	
	        // Reverse the argument reduction.
	        if (e !== 0) sum = sum.plus(getLn10(Ctor, wpr + 2, pr).times(e + ''));
	        sum = divide(sum, new Ctor(n), wpr);
	
	        Ctor.precision = pr;
	        return sd == null ? (external = true, round(sum, pr)) : sum;
	      }
	
	      sum = t;
	      denominator += 2;
	    }
	  }
	
	
	  /*
	   * Parse the value of a new Decimal `x` from string `str`.
	   */
	  function parseDecimal(x, str) {
	    var e, i, len;
	
	    // Decimal point?
	    if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');
	
	    // Exponential form?
	    if ((i = str.search(/e/i)) > 0) {
	
	      // Determine exponent.
	      if (e < 0) e = i;
	      e += +str.slice(i + 1);
	      str = str.substring(0, i);
	    } else if (e < 0) {
	
	      // Integer.
	      e = str.length;
	    }
	
	    // Determine leading zeros.
	    for (i = 0; str.charCodeAt(i) === 48;) ++i;
	
	    // Determine trailing zeros.
	    for (len = str.length; str.charCodeAt(len - 1) === 48;) --len;
	    str = str.slice(i, len);
	
	    if (str) {
	      len -= i;
	      e = e - i - 1;
	      x.e = mathfloor(e / LOG_BASE);
	      x.d = [];
	
	      // Transform base
	
	      // e is the base 10 exponent.
	      // i is where to slice str to get the first word of the digits array.
	      i = (e + 1) % LOG_BASE;
	      if (e < 0) i += LOG_BASE;
	
	      if (i < len) {
	        if (i) x.d.push(+str.slice(0, i));
	        for (len -= LOG_BASE; i < len;) x.d.push(+str.slice(i, i += LOG_BASE));
	        str = str.slice(i);
	        i = LOG_BASE - str.length;
	      } else {
	        i -= len;
	      }
	
	      for (; i--;) str += '0';
	      x.d.push(+str);
	
	      if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + e);
	    } else {
	
	      // Zero.
	      x.s = 0;
	      x.e = 0;
	      x.d = [0];
	    }
	
	    return x;
	  }
	
	
	  /*
	   * Round `x` to `sd` significant digits, using rounding mode `rm` if present (truncate otherwise).
	   */
	   function round(x, sd, rm) {
	    var i, j, k, n, rd, doRound, w, xdi,
	      xd = x.d;
	
	    // rd: the rounding digit, i.e. the digit after the digit that may be rounded up.
	    // w: the word of xd which contains the rounding digit, a base 1e7 number.
	    // xdi: the index of w within xd.
	    // n: the number of digits of w.
	    // i: what would be the index of rd within w if all the numbers were 7 digits long (i.e. if
	    // they had leading zeros)
	    // j: if > 0, the actual index of rd within w (if < 0, rd is a leading zero).
	
	    // Get the length of the first word of the digits array xd.
	    for (n = 1, k = xd[0]; k >= 10; k /= 10) n++;
	    i = sd - n;
	
	    // Is the rounding digit in the first word of xd?
	    if (i < 0) {
	      i += LOG_BASE;
	      j = sd;
	      w = xd[xdi = 0];
	    } else {
	      xdi = Math.ceil((i + 1) / LOG_BASE);
	      k = xd.length;
	      if (xdi >= k) return x;
	      w = k = xd[xdi];
	
	      // Get the number of digits of w.
	      for (n = 1; k >= 10; k /= 10) n++;
	
	      // Get the index of rd within w.
	      i %= LOG_BASE;
	
	      // Get the index of rd within w, adjusted for leading zeros.
	      // The number of leading zeros of w is given by LOG_BASE - n.
	      j = i - LOG_BASE + n;
	    }
	
	    if (rm !== void 0) {
	      k = mathpow(10, n - j - 1);
	
	      // Get the rounding digit at index j of w.
	      rd = w / k % 10 | 0;
	
	      // Are there any non-zero digits after the rounding digit?
	      doRound = sd < 0 || xd[xdi + 1] !== void 0 || w % k;
	
	      // The expression `w % mathpow(10, n - j - 1)` returns all the digits of w to the right of the
	      // digit at (left-to-right) index j, e.g. if w is 908714 and j is 2, the expression will give
	      // 714.
	
	      doRound = rm < 4
	        ? (rd || doRound) && (rm == 0 || rm == (x.s < 0 ? 3 : 2))
	        : rd > 5 || rd == 5 && (rm == 4 || doRound || rm == 6 &&
	
	          // Check whether the digit to the left of the rounding digit is odd.
	          ((i > 0 ? j > 0 ? w / mathpow(10, n - j) : 0 : xd[xdi - 1]) % 10) & 1 ||
	            rm == (x.s < 0 ? 8 : 7));
	    }
	
	    if (sd < 1 || !xd[0]) {
	      if (doRound) {
	        k = getBase10Exponent(x);
	        xd.length = 1;
	
	        // Convert sd to decimal places.
	        sd = sd - k - 1;
	
	        // 1, 0.1, 0.01, 0.001, 0.0001 etc.
	        xd[0] = mathpow(10, (LOG_BASE - sd % LOG_BASE) % LOG_BASE);
	        x.e = mathfloor(-sd / LOG_BASE) || 0;
	      } else {
	        xd.length = 1;
	
	        // Zero.
	        xd[0] = x.e = x.s = 0;
	      }
	
	      return x;
	    }
	
	    // Remove excess digits.
	    if (i == 0) {
	      xd.length = xdi;
	      k = 1;
	      xdi--;
	    } else {
	      xd.length = xdi + 1;
	      k = mathpow(10, LOG_BASE - i);
	
	      // E.g. 56700 becomes 56000 if 7 is the rounding digit.
	      // j > 0 means i > number of leading zeros of w.
	      xd[xdi] = j > 0 ? (w / mathpow(10, n - j) % mathpow(10, j) | 0) * k : 0;
	    }
	
	    if (doRound) {
	      for (;;) {
	
	        // Is the digit to be rounded up in the first word of xd?
	        if (xdi == 0) {
	          if ((xd[0] += k) == BASE) {
	            xd[0] = 1;
	            ++x.e;
	          }
	
	          break;
	        } else {
	          xd[xdi] += k;
	          if (xd[xdi] != BASE) break;
	          xd[xdi--] = 0;
	          k = 1;
	        }
	      }
	    }
	
	    // Remove trailing zeros.
	    for (i = xd.length; xd[--i] === 0;) xd.pop();
	
	    if (external && (x.e > MAX_E || x.e < -MAX_E)) {
	      throw Error(exponentOutOfRange + getBase10Exponent(x));
	    }
	
	    return x;
	  }
	
	
	  function subtract(x, y) {
	    var d, e, i, j, k, len, xd, xe, xLTy, yd,
	      Ctor = x.constructor,
	      pr = Ctor.precision;
	
	    // Return y negated if x is zero.
	    // Return x if y is zero and x is non-zero.
	    if (!x.s || !y.s) {
	      if (y.s) y.s = -y.s;
	      else y = new Ctor(x);
	      return external ? round(y, pr) : y;
	    }
	
	    xd = x.d;
	    yd = y.d;
	
	    // x and y are non-zero numbers with the same sign.
	
	    e = y.e;
	    xe = x.e;
	    xd = xd.slice();
	    k = xe - e;
	
	    // If exponents differ...
	    if (k) {
	      xLTy = k < 0;
	
	      if (xLTy) {
	        d = xd;
	        k = -k;
	        len = yd.length;
	      } else {
	        d = yd;
	        e = xe;
	        len = xd.length;
	      }
	
	      // Numbers with massively different exponents would result in a very high number of zeros
	      // needing to be prepended, but this can be avoided while still ensuring correct rounding by
	      // limiting the number of zeros to `Math.ceil(pr / LOG_BASE) + 2`.
	      i = Math.max(Math.ceil(pr / LOG_BASE), len) + 2;
	
	      if (k > i) {
	        k = i;
	        d.length = 1;
	      }
	
	      // Prepend zeros to equalise exponents.
	      d.reverse();
	      for (i = k; i--;) d.push(0);
	      d.reverse();
	
	    // Base 1e7 exponents equal.
	    } else {
	
	      // Check digits to determine which is the bigger number.
	
	      i = xd.length;
	      len = yd.length;
	      xLTy = i < len;
	      if (xLTy) len = i;
	
	      for (i = 0; i < len; i++) {
	        if (xd[i] != yd[i]) {
	          xLTy = xd[i] < yd[i];
	          break;
	        }
	      }
	
	      k = 0;
	    }
	
	    if (xLTy) {
	      d = xd;
	      xd = yd;
	      yd = d;
	      y.s = -y.s;
	    }
	
	    len = xd.length;
	
	    // Append zeros to xd if shorter.
	    // Don't add zeros to yd if shorter as subtraction only needs to start at yd length.
	    for (i = yd.length - len; i > 0; --i) xd[len++] = 0;
	
	    // Subtract yd from xd.
	    for (i = yd.length; i > k;) {
	      if (xd[--i] < yd[i]) {
	        for (j = i; j && xd[--j] === 0;) xd[j] = BASE - 1;
	        --xd[j];
	        xd[i] += BASE;
	      }
	
	      xd[i] -= yd[i];
	    }
	
	    // Remove trailing zeros.
	    for (; xd[--len] === 0;) xd.pop();
	
	    // Remove leading zeros and adjust exponent accordingly.
	    for (; xd[0] === 0; xd.shift()) --e;
	
	    // Zero?
	    if (!xd[0]) return new Ctor(0);
	
	    y.d = xd;
	    y.e = e;
	
	    //return external && xd.length >= pr / LOG_BASE ? round(y, pr) : y;
	    return external ? round(y, pr) : y;
	  }
	
	
	  function toString(x, isExp, sd) {
	    var k,
	      e = getBase10Exponent(x),
	      str = digitsToString(x.d),
	      len = str.length;
	
	    if (isExp) {
	      if (sd && (k = sd - len) > 0) {
	        str = str.charAt(0) + '.' + str.slice(1) + getZeroString(k);
	      } else if (len > 1) {
	        str = str.charAt(0) + '.' + str.slice(1);
	      }
	
	      str = str + (e < 0 ? 'e' : 'e+') + e;
	    } else if (e < 0) {
	      str = '0.' + getZeroString(-e - 1) + str;
	      if (sd && (k = sd - len) > 0) str += getZeroString(k);
	    } else if (e >= len) {
	      str += getZeroString(e + 1 - len);
	      if (sd && (k = sd - e - 1) > 0) str = str + '.' + getZeroString(k);
	    } else {
	      if ((k = e + 1) < len) str = str.slice(0, k) + '.' + str.slice(k);
	      if (sd && (k = sd - len) > 0) {
	        if (e + 1 === len) str += '.';
	        str += getZeroString(k);
	      }
	    }
	
	    return x.s < 0 ? '-' + str : str;
	  }
	
	
	  // Does not strip trailing zeros.
	  function truncate(arr, len) {
	    if (arr.length > len) {
	      arr.length = len;
	      return true;
	    }
	  }
	
	
	  // Decimal methods
	
	
	  /*
	   *  clone
	   *  config/set
	   */
	
	
	  /*
	   * Create and return a Decimal constructor with the same configuration properties as this Decimal
	   * constructor.
	   *
	   */
	  function clone(obj) {
	    var i, p, ps;
	
	    /*
	     * The Decimal constructor and exported function.
	     * Return a new Decimal instance.
	     *
	     * value {number|string|Decimal} A numeric value.
	     *
	     */
	    function Decimal(value) {
	      var x = this;
	
	      // Decimal called without new.
	      if (!(x instanceof Decimal)) return new Decimal(value);
	
	      // Retain a reference to this Decimal constructor, and shadow Decimal.prototype.constructor
	      // which points to Object.
	      x.constructor = Decimal;
	
	      // Duplicate.
	      if (value instanceof Decimal) {
	        x.s = value.s;
	        x.e = value.e;
	        x.d = (value = value.d) ? value.slice() : value;
	        return;
	      }
	
	      if (typeof value === 'number') {
	
	        // Reject Infinity/NaN.
	        if (value * 0 !== 0) {
	          throw Error(invalidArgument + value);
	        }
	
	        if (value > 0) {
	          x.s = 1;
	        } else if (value < 0) {
	          value = -value;
	          x.s = -1;
	        } else {
	          x.s = 0;
	          x.e = 0;
	          x.d = [0];
	          return;
	        }
	
	        // Fast path for small integers.
	        if (value === ~~value && value < 1e7) {
	          x.e = 0;
	          x.d = [value];
	          return;
	        }
	
	        return parseDecimal(x, value.toString());
	      } else if (typeof value !== 'string') {
	        throw Error(invalidArgument + value);
	      }
	
	      // Minus sign?
	      if (value.charCodeAt(0) === 45) {
	        value = value.slice(1);
	        x.s = -1;
	      } else {
	        x.s = 1;
	      }
	
	      if (isDecimal.test(value)) parseDecimal(x, value);
	      else throw Error(invalidArgument + value);
	    }
	
	    Decimal.prototype = P;
	
	    Decimal.ROUND_UP = 0;
	    Decimal.ROUND_DOWN = 1;
	    Decimal.ROUND_CEIL = 2;
	    Decimal.ROUND_FLOOR = 3;
	    Decimal.ROUND_HALF_UP = 4;
	    Decimal.ROUND_HALF_DOWN = 5;
	    Decimal.ROUND_HALF_EVEN = 6;
	    Decimal.ROUND_HALF_CEIL = 7;
	    Decimal.ROUND_HALF_FLOOR = 8;
	
	    Decimal.clone = clone;
	    Decimal.config = Decimal.set = config;
	
	    if (obj === void 0) obj = {};
	    if (obj) {
	      ps = ['precision', 'rounding', 'toExpNeg', 'toExpPos', 'LN10'];
	      for (i = 0; i < ps.length;) if (!obj.hasOwnProperty(p = ps[i++])) obj[p] = this[p];
	    }
	
	    Decimal.config(obj);
	
	    return Decimal;
	  }
	
	
	  /*
	   * Configure global settings for a Decimal constructor.
	   *
	   * `obj` is an object with one or more of the following properties,
	   *
	   *   precision  {number}
	   *   rounding   {number}
	   *   toExpNeg   {number}
	   *   toExpPos   {number}
	   *
	   * E.g. Decimal.config({ precision: 20, rounding: 4 })
	   *
	   */
	  function config(obj) {
	    if (!obj || typeof obj !== 'object') {
	      throw Error(decimalError + 'Object expected');
	    }
	    var i, p, v,
	      ps = [
	        'precision', 1, MAX_DIGITS,
	        'rounding', 0, 8,
	        'toExpNeg', -1 / 0, 0,
	        'toExpPos', 0, 1 / 0
	      ];
	
	    for (i = 0; i < ps.length; i += 3) {
	      if ((v = obj[p = ps[i]]) !== void 0) {
	        if (mathfloor(v) === v && v >= ps[i + 1] && v <= ps[i + 2]) this[p] = v;
	        else throw Error(invalidArgument + p + ': ' + v);
	      }
	    }
	
	    if ((v = obj[p = 'LN10']) !== void 0) {
	        if (v == Math.LN10) this[p] = new this(v);
	        else throw Error(invalidArgument + p + ': ' + v);
	    }
	
	    return this;
	  }
	
	
	  // Create and configure initial Decimal constructor.
	  Decimal = clone(Decimal);
	
	  Decimal['default'] = Decimal.Decimal = Decimal;
	
	  // Internal constant.
	  ONE = new Decimal(1);
	
	
	  // Export.
	
	
	  // AMD.
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return Decimal;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	  // Node and other environments that support module.exports.
	  } else if (typeof module != 'undefined' && module.exports) {
	    module.exports = Decimal;
	
	    // Browser.
	  } else {
	    if (!globalScope) {
	      globalScope = typeof self != 'undefined' && self && self.self == self
	        ? self : Function('return this')();
	    }
	
	    globalScope.Decimal = Decimal;
	  }
	})(this);


/***/ },
/* 674 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = activeElement;
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(173));
	
	function activeElement(doc) {
	  if (doc === void 0) {
	    doc = (0, _ownerDocument.default)();
	  }
	
	  try {
	    return doc.activeElement;
	  } catch (e) {
	    /* ie throws if no active element */
	  }
	}
	
	module.exports = exports["default"];

/***/ },
/* 675 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = hasClass;
	
	function hasClass(element, className) {
	  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
	}
	
	module.exports = exports["default"];

/***/ },
/* 676 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = offset;
	
	var _contains = _interopRequireDefault(__webpack_require__(174));
	
	var _isWindow = _interopRequireDefault(__webpack_require__(272));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(173));
	
	function offset(node) {
	  var doc = (0, _ownerDocument.default)(node),
	      win = (0, _isWindow.default)(doc),
	      docElem = doc && doc.documentElement,
	      box = {
	    top: 0,
	    left: 0,
	    height: 0,
	    width: 0
	  };
	  if (!doc) return; // Make sure it's not a disconnected DOM node
	
	  if (!(0, _contains.default)(docElem, node)) return box;
	  if (node.getBoundingClientRect !== undefined) box = node.getBoundingClientRect(); // IE8 getBoundingClientRect doesn't support width & height
	
	  box = {
	    top: box.top + (win.pageYOffset || docElem.scrollTop) - (docElem.clientTop || 0),
	    left: box.left + (win.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || 0),
	    width: (box.width == null ? node.offsetWidth : box.width) || 0,
	    height: (box.height == null ? node.offsetHeight : box.height) || 0
	  };
	  return box;
	}
	
	module.exports = exports["default"];

/***/ },
/* 677 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = scrollTop;
	
	var _isWindow = _interopRequireDefault(__webpack_require__(272));
	
	function scrollTop(node, val) {
	  var win = (0, _isWindow.default)(node);
	  if (val === undefined) return win ? 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop : node.scrollTop;
	  if (win) win.scrollTo('pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft, val);else node.scrollTop = val;
	}
	
	module.exports = exports["default"];

/***/ },
/* 678 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(123));
	
	var transform = 'transform';
	exports.transform = transform;
	var prefix, transitionEnd, animationEnd;
	exports.animationEnd = animationEnd;
	exports.transitionEnd = transitionEnd;
	var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
	exports.transitionDelay = transitionDelay;
	exports.transitionTiming = transitionTiming;
	exports.transitionDuration = transitionDuration;
	exports.transitionProperty = transitionProperty;
	var animationName, animationDuration, animationTiming, animationDelay;
	exports.animationDelay = animationDelay;
	exports.animationTiming = animationTiming;
	exports.animationDuration = animationDuration;
	exports.animationName = animationName;
	
	if (_inDOM.default) {
	  var _getTransitionPropert = getTransitionProperties();
	
	  prefix = _getTransitionPropert.prefix;
	  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
	  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
	  exports.transform = transform = prefix + "-" + transform;
	  exports.transitionProperty = transitionProperty = prefix + "-transition-property";
	  exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
	  exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
	  exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
	  exports.animationName = animationName = prefix + "-animation-name";
	  exports.animationDuration = animationDuration = prefix + "-animation-duration";
	  exports.animationTiming = animationTiming = prefix + "-animation-delay";
	  exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
	}
	
	var _default = {
	  transform: transform,
	  end: transitionEnd,
	  property: transitionProperty,
	  timing: transitionTiming,
	  delay: transitionDelay,
	  duration: transitionDuration
	};
	exports.default = _default;
	
	function getTransitionProperties() {
	  var style = document.createElement('div').style;
	  var vendorMap = {
	    O: function O(e) {
	      return "o" + e.toLowerCase();
	    },
	    Moz: function Moz(e) {
	      return e.toLowerCase();
	    },
	    Webkit: function Webkit(e) {
	      return "webkit" + e;
	    },
	    ms: function ms(e) {
	      return "MS" + e;
	    }
	  };
	  var vendors = Object.keys(vendorMap);
	  var transitionEnd, animationEnd;
	  var prefix = '';
	
	  for (var i = 0; i < vendors.length; i++) {
	    var vendor = vendors[i];
	
	    if (vendor + "TransitionProperty" in style) {
	      prefix = "-" + vendor.toLowerCase();
	      transitionEnd = vendorMap[vendor]('TransitionEnd');
	      animationEnd = vendorMap[vendor]('AnimationEnd');
	      break;
	    }
	  }
	
	  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
	  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
	  style = null;
	  return {
	    animationEnd: animationEnd,
	    transitionEnd: transitionEnd,
	    prefix: prefix
	  };
	}

/***/ },
/* 679 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = camelizeStyleName;
	
	var _camelize = _interopRequireDefault(__webpack_require__(1703));
	
	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
	 */
	var msPattern = /^-ms-/;
	
	function camelizeStyleName(string) {
	  return (0, _camelize.default)(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = exports["default"];

/***/ },
/* 680 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = scrollbarSize;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(123));
	
	var size;
	
	function scrollbarSize(recalc) {
	  if (!size && size !== 0 || recalc) {
	    if (_inDOM.default) {
	      var scrollDiv = document.createElement('div');
	      scrollDiv.style.position = 'absolute';
	      scrollDiv.style.top = '-9999px';
	      scrollDiv.style.width = '50px';
	      scrollDiv.style.height = '50px';
	      scrollDiv.style.overflow = 'scroll';
	      document.body.appendChild(scrollDiv);
	      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
	      document.body.removeChild(scrollDiv);
	    }
	  }
	
	  return size;
	}
	
	module.exports = exports["default"];

/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.decodeHTML = exports.decodeHTMLStrict = exports.decodeXML = void 0;
	var entities_json_1 = __importDefault(__webpack_require__(723));
	var legacy_json_1 = __importDefault(__webpack_require__(2045));
	var xml_json_1 = __importDefault(__webpack_require__(724));
	var decode_codepoint_1 = __importDefault(__webpack_require__(1708));
	var strictEntityRe = /&(?:[a-zA-Z0-9]+|#[xX][\da-fA-F]+|#\d+);/g;
	exports.decodeXML = getStrictDecoder(xml_json_1.default);
	exports.decodeHTMLStrict = getStrictDecoder(entities_json_1.default);
	function getStrictDecoder(map) {
	    var replace = getReplacer(map);
	    return function (str) { return String(str).replace(strictEntityRe, replace); };
	}
	var sorter = function (a, b) { return (a < b ? 1 : -1); };
	exports.decodeHTML = (function () {
	    var legacy = Object.keys(legacy_json_1.default).sort(sorter);
	    var keys = Object.keys(entities_json_1.default).sort(sorter);
	    for (var i = 0, j = 0; i < keys.length; i++) {
	        if (legacy[j] === keys[i]) {
	            keys[i] += ";?";
	            j++;
	        }
	        else {
	            keys[i] += ";";
	        }
	    }
	    var re = new RegExp("&(?:" + keys.join("|") + "|#[xX][\\da-fA-F]+;?|#\\d+;?)", "g");
	    var replace = getReplacer(entities_json_1.default);
	    function replacer(str) {
	        if (str.substr(-1) !== ";")
	            str += ";";
	        return replace(str);
	    }
	    // TODO consider creating a merged map
	    return function (str) { return String(str).replace(re, replacer); };
	})();
	function getReplacer(map) {
	    return function replace(str) {
	        if (str.charAt(1) === "#") {
	            var secondChar = str.charAt(2);
	            if (secondChar === "X" || secondChar === "x") {
	                return decode_codepoint_1.default(parseInt(str.substr(3), 16));
	            }
	            return decode_codepoint_1.default(parseInt(str.substr(2), 10));
	        }
	        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
	        return map[str.slice(1, -1)] || str;
	    };
	}


/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.escapeUTF8 = exports.escape = exports.encodeNonAsciiHTML = exports.encodeHTML = exports.encodeXML = void 0;
	var xml_json_1 = __importDefault(__webpack_require__(724));
	var inverseXML = getInverseObj(xml_json_1.default);
	var xmlReplacer = getInverseReplacer(inverseXML);
	/**
	 * Encodes all non-ASCII characters, as well as characters not valid in XML
	 * documents using XML entities.
	 *
	 * If a character has no equivalent entity, a
	 * numeric hexadecimal reference (eg. `&#xfc;`) will be used.
	 */
	exports.encodeXML = getASCIIEncoder(inverseXML);
	var entities_json_1 = __importDefault(__webpack_require__(723));
	var inverseHTML = getInverseObj(entities_json_1.default);
	var htmlReplacer = getInverseReplacer(inverseHTML);
	/**
	 * Encodes all entities and non-ASCII characters in the input.
	 *
	 * This includes characters that are valid ASCII characters in HTML documents.
	 * For example `#` will be encoded as `&num;`. To get a more compact output,
	 * consider using the `encodeNonAsciiHTML` function.
	 *
	 * If a character has no equivalent entity, a
	 * numeric hexadecimal reference (eg. `&#xfc;`) will be used.
	 */
	exports.encodeHTML = getInverse(inverseHTML, htmlReplacer);
	/**
	 * Encodes all non-ASCII characters, as well as characters not valid in HTML
	 * documents using HTML entities.
	 *
	 * If a character has no equivalent entity, a
	 * numeric hexadecimal reference (eg. `&#xfc;`) will be used.
	 */
	exports.encodeNonAsciiHTML = getASCIIEncoder(inverseHTML);
	function getInverseObj(obj) {
	    return Object.keys(obj)
	        .sort()
	        .reduce(function (inverse, name) {
	        inverse[obj[name]] = "&" + name + ";";
	        return inverse;
	    }, {});
	}
	function getInverseReplacer(inverse) {
	    var single = [];
	    var multiple = [];
	    for (var _i = 0, _a = Object.keys(inverse); _i < _a.length; _i++) {
	        var k = _a[_i];
	        if (k.length === 1) {
	            // Add value to single array
	            single.push("\\" + k);
	        }
	        else {
	            // Add value to multiple array
	            multiple.push(k);
	        }
	    }
	    // Add ranges to single characters.
	    single.sort();
	    for (var start = 0; start < single.length - 1; start++) {
	        // Find the end of a run of characters
	        var end = start;
	        while (end < single.length - 1 &&
	            single[end].charCodeAt(1) + 1 === single[end + 1].charCodeAt(1)) {
	            end += 1;
	        }
	        var count = 1 + end - start;
	        // We want to replace at least three characters
	        if (count < 3)
	            continue;
	        single.splice(start, count, single[start] + "-" + single[end]);
	    }
	    multiple.unshift("[" + single.join("") + "]");
	    return new RegExp(multiple.join("|"), "g");
	}
	// /[^\0-\x7F]/gu
	var reNonASCII = /(?:[\x80-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/g;
	var getCodePoint = 
	// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
	String.prototype.codePointAt != null
	    ? // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
	        function (str) { return str.codePointAt(0); }
	    : // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
	        function (c) {
	            return (c.charCodeAt(0) - 0xd800) * 0x400 +
	                c.charCodeAt(1) -
	                0xdc00 +
	                0x10000;
	        };
	function singleCharReplacer(c) {
	    return "&#x" + (c.length > 1 ? getCodePoint(c) : c.charCodeAt(0))
	        .toString(16)
	        .toUpperCase() + ";";
	}
	function getInverse(inverse, re) {
	    return function (data) {
	        return data
	            .replace(re, function (name) { return inverse[name]; })
	            .replace(reNonASCII, singleCharReplacer);
	    };
	}
	var reEscapeChars = new RegExp(xmlReplacer.source + "|" + reNonASCII.source, "g");
	/**
	 * Encodes all non-ASCII characters, as well as characters not valid in XML
	 * documents using numeric hexadecimal reference (eg. `&#xfc;`).
	 *
	 * Have a look at `escapeUTF8` if you want a more concise output at the expense
	 * of reduced transportability.
	 *
	 * @param data String to escape.
	 */
	function escape(data) {
	    return data.replace(reEscapeChars, singleCharReplacer);
	}
	exports.escape = escape;
	/**
	 * Encodes all characters not valid in XML documents using numeric hexadecimal
	 * reference (eg. `&#xfc;`).
	 *
	 * Note that the output will be character-set dependent.
	 *
	 * @param data String to escape.
	 */
	function escapeUTF8(data) {
	    return data.replace(xmlReplacer, singleCharReplacer);
	}
	exports.escapeUTF8 = escapeUTF8;
	function getASCIIEncoder(obj) {
	    return function (data) {
	        return data.replace(reEscapeChars, function (c) { return obj[c] || singleCharReplacer(c); });
	    };
	}


/***/ },
/* 683 */
/***/ function(module, exports, __webpack_require__) {

	var ElementType = __webpack_require__(217);
	
	var re_whitespace = /\s+/g;
	var NodePrototype = __webpack_require__(684);
	var ElementPrototype = __webpack_require__(1710);
	
	function DomHandler(callback, options, elementCB){
		if(typeof callback === "object"){
			elementCB = options;
			options = callback;
			callback = null;
		} else if(typeof options === "function"){
			elementCB = options;
			options = defaultOpts;
		}
		this._callback = callback;
		this._options = options || defaultOpts;
		this._elementCB = elementCB;
		this.dom = [];
		this._done = false;
		this._tagStack = [];
		this._parser = this._parser || null;
	}
	
	//default options
	var defaultOpts = {
		normalizeWhitespace: false, //Replace all whitespace with single spaces
		withStartIndices: false, //Add startIndex properties to nodes
		withEndIndices: false, //Add endIndex properties to nodes
	};
	
	DomHandler.prototype.onparserinit = function(parser){
		this._parser = parser;
	};
	
	//Resets the handler back to starting state
	DomHandler.prototype.onreset = function(){
		DomHandler.call(this, this._callback, this._options, this._elementCB);
	};
	
	//Signals the handler that parsing is done
	DomHandler.prototype.onend = function(){
		if(this._done) return;
		this._done = true;
		this._parser = null;
		this._handleCallback(null);
	};
	
	DomHandler.prototype._handleCallback =
	DomHandler.prototype.onerror = function(error){
		if(typeof this._callback === "function"){
			this._callback(error, this.dom);
		} else {
			if(error) throw error;
		}
	};
	
	DomHandler.prototype.onclosetag = function(){
		//if(this._tagStack.pop().name !== name) this._handleCallback(Error("Tagname didn't match!"));
		
		var elem = this._tagStack.pop();
	
		if(this._options.withEndIndices && elem){
			elem.endIndex = this._parser.endIndex;
		}
	
		if(this._elementCB) this._elementCB(elem);
	};
	
	DomHandler.prototype._createDomElement = function(properties){
		if (!this._options.withDomLvl1) return properties;
	
		var element;
		if (properties.type === "tag") {
			element = Object.create(ElementPrototype);
		} else {
			element = Object.create(NodePrototype);
		}
	
		for (var key in properties) {
			if (properties.hasOwnProperty(key)) {
				element[key] = properties[key];
			}
		}
	
		return element;
	};
	
	DomHandler.prototype._addDomElement = function(element){
		var parent = this._tagStack[this._tagStack.length - 1];
		var siblings = parent ? parent.children : this.dom;
		var previousSibling = siblings[siblings.length - 1];
	
		element.next = null;
	
		if(this._options.withStartIndices){
			element.startIndex = this._parser.startIndex;
		}
		if(this._options.withEndIndices){
			element.endIndex = this._parser.endIndex;
		}
	
		if(previousSibling){
			element.prev = previousSibling;
			previousSibling.next = element;
		} else {
			element.prev = null;
		}
	
		siblings.push(element);
		element.parent = parent || null;
	};
	
	DomHandler.prototype.onopentag = function(name, attribs){
		var properties = {
			type: name === "script" ? ElementType.Script : name === "style" ? ElementType.Style : ElementType.Tag,
			name: name,
			attribs: attribs,
			children: []
		};
	
		var element = this._createDomElement(properties);
	
		this._addDomElement(element);
	
		this._tagStack.push(element);
	};
	
	DomHandler.prototype.ontext = function(data){
		//the ignoreWhitespace is officially dropped, but for now,
		//it's an alias for normalizeWhitespace
		var normalize = this._options.normalizeWhitespace || this._options.ignoreWhitespace;
	
		var lastTag;
	
		if(!this._tagStack.length && this.dom.length && (lastTag = this.dom[this.dom.length-1]).type === ElementType.Text){
			if(normalize){
				lastTag.data = (lastTag.data + data).replace(re_whitespace, " ");
			} else {
				lastTag.data += data;
			}
		} else {
			if(
				this._tagStack.length &&
				(lastTag = this._tagStack[this._tagStack.length - 1]) &&
				(lastTag = lastTag.children[lastTag.children.length - 1]) &&
				lastTag.type === ElementType.Text
			){
				if(normalize){
					lastTag.data = (lastTag.data + data).replace(re_whitespace, " ");
				} else {
					lastTag.data += data;
				}
			} else {
				if(normalize){
					data = data.replace(re_whitespace, " ");
				}
	
				var element = this._createDomElement({
					data: data,
					type: ElementType.Text
				});
	
				this._addDomElement(element);
			}
		}
	};
	
	DomHandler.prototype.oncomment = function(data){
		var lastTag = this._tagStack[this._tagStack.length - 1];
	
		if(lastTag && lastTag.type === ElementType.Comment){
			lastTag.data += data;
			return;
		}
	
		var properties = {
			data: data,
			type: ElementType.Comment
		};
	
		var element = this._createDomElement(properties);
	
		this._addDomElement(element);
		this._tagStack.push(element);
	};
	
	DomHandler.prototype.oncdatastart = function(){
		var properties = {
			children: [{
				data: "",
				type: ElementType.Text
			}],
			type: ElementType.CDATA
		};
	
		var element = this._createDomElement(properties);
	
		this._addDomElement(element);
		this._tagStack.push(element);
	};
	
	DomHandler.prototype.oncommentend = DomHandler.prototype.oncdataend = function(){
		this._tagStack.pop();
	};
	
	DomHandler.prototype.onprocessinginstruction = function(name, data){
		var element = this._createDomElement({
			name: name,
			data: data,
			type: ElementType.Directive
		});
	
		this._addDomElement(element);
	};
	
	module.exports = DomHandler;


/***/ },
/* 684 */
/***/ function(module, exports) {

	// This object will be used as the prototype for Nodes when creating a
	// DOM-Level-1-compliant structure.
	var NodePrototype = module.exports = {
		get firstChild() {
			var children = this.children;
			return children && children[0] || null;
		},
		get lastChild() {
			var children = this.children;
			return children && children[children.length - 1] || null;
		},
		get nodeType() {
			return nodeTypes[this.type] || nodeTypes.element;
		}
	};
	
	var domLvl1 = {
		tagName: "name",
		childNodes: "children",
		parentNode: "parent",
		previousSibling: "prev",
		nextSibling: "next",
		nodeValue: "data"
	};
	
	var nodeTypes = {
		element: 1,
		text: 3,
		cdata: 4,
		comment: 8
	};
	
	Object.keys(domLvl1).forEach(function(key) {
		var shorthand = domLvl1[key];
		Object.defineProperty(NodePrototype, key, {
			get: function() {
				return this[shorthand] || null;
			},
			set: function(val) {
				this[shorthand] = val;
				return val;
			}
		});
	});


/***/ },
/* 685 */
/***/ function(module, exports, __webpack_require__) {

	var DomUtils = module.exports;
	
	[
		__webpack_require__(1715),
		__webpack_require__(1716),
		__webpack_require__(1713),
		__webpack_require__(1714),
		__webpack_require__(1712),
		__webpack_require__(1711)
	].forEach(function(ext){
		Object.keys(ext).forEach(function(key){
			DomUtils[key] = ext[key].bind(DomUtils);
		});
	});


/***/ },
/* 686 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./syntax')} */
	module.exports = SyntaxError;


/***/ },
/* 687 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      }
	      throw TypeError('Uncaught, unspecified "error" event.');
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        len = arguments.length;
	        args = new Array(len - 1);
	        for (i = 1; i < len; i++)
	          args[i - 1] = arguments[i];
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    len = arguments.length;
	    args = new Array(len - 1);
	    for (i = 1; i < len; i++)
	      args[i - 1] = arguments[i];
	
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    var m;
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  var ret;
	  if (!emitter._events || !emitter._events[type])
	    ret = 0;
	  else if (isFunction(emitter._events[type]))
	    ret = 1;
	  else
	    ret = emitter._events[type].length;
	  return ret;
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ },
/* 688 */
/***/ function(module, exports, __webpack_require__) {

	// [NUXIBA]  Version: 0.0.5 - 2022-09-27 10:00:42  
	 (function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define([], factory);
		else if(typeof exports === 'object')
			exports["EntryPoint"] = factory();
		else
			root["EntryPoint"] = factory();
	})(typeof self !== 'undefined' ? self : this, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.UtilityFactory = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ExternalLibrary = __webpack_require__(1);
	
	var _URLClient = __webpack_require__(4);
	
	var _URLWrapper = __webpack_require__(5);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var UtilityFactory = exports.UtilityFactory = function () {
		function UtilityFactory() {
			_classCallCheck(this, UtilityFactory);
		}
	
		_createClass(UtilityFactory, [{
			key: 'buildClient',
			value: function buildClient(document, route) {
				return new _ExternalLibrary.ExternalLibrary(document, route);
			}
		}, {
			key: 'buildURLClient',
			value: function buildURLClient() {
				var urlWrapper = new _URLWrapper.URLWrapper();
				return new _URLClient.URLClient(urlWrapper);
			}
		}]);
	
		return UtilityFactory;
	}();
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ExternalLibrary = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Logger = __webpack_require__(2);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ExternalLibrary = exports.ExternalLibrary = function () {
	  function ExternalLibrary(document, route) {
	    _classCallCheck(this, ExternalLibrary);
	
	    this.document = document;
	    if (route === undefined || route === '') {
	      _Logger.Logger.Error("Parameter route is empty");
	    } else {
	      this.loadLibrary(route);
	    }
	  }
	
	  _createClass(ExternalLibrary, [{
	    key: "loadLibrary",
	    value: function loadLibrary(route) {
	      _Logger.Logger.Debug("Loading js route:", route);
	      this.document.write('<script type="text/javascript" src="' + route + '"></script>');
	    }
	  }]);
	
	  return ExternalLibrary;
	}();
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.Logger = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _globalLoggerServicesJsBundle = __webpack_require__(3);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	_globalLoggerServicesJsBundle.LoggerInstance.setApplication('[Common-Utilities]');
	
	var Logger = exports.Logger = function () {
		function Logger() {
			_classCallCheck(this, Logger);
		}
	
		_createClass(Logger, [{
			key: 'setUserType',
			value: function setUserType(userType) {
				Logger.setUserType(userType);
			}
		}], [{
			key: 'setUserId',
			value: function setUserId(userId) {
				_globalLoggerServicesJsBundle.LoggerInstance.setUserId(userId);
			}
		}, {
			key: 'Trace',
			value: function Trace() {
				for (var _len = arguments.length, msg = Array(_len), _key = 0; _key < _len; _key++) {
					msg[_key] = arguments[_key];
				}
	
				_globalLoggerServicesJsBundle.LoggerInstance.Trace(['[Common-Utilities]'].concat(msg));
			}
		}, {
			key: 'Debug',
			value: function Debug() {
				for (var _len2 = arguments.length, msg = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
					msg[_key2] = arguments[_key2];
				}
	
				_globalLoggerServicesJsBundle.LoggerInstance.Debug(['[Common-Utilities]'].concat(msg));
			}
		}, {
			key: 'Warning',
			value: function Warning() {
				for (var _len3 = arguments.length, msg = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
					msg[_key3] = arguments[_key3];
				}
	
				_globalLoggerServicesJsBundle.LoggerInstance.Warning(['[Common-Utilities]'].concat(msg));
			}
		}, {
			key: 'Info',
			value: function Info() {
				for (var _len4 = arguments.length, msg = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
					msg[_key4] = arguments[_key4];
				}
	
				_globalLoggerServicesJsBundle.LoggerInstance.Info(['[Common-Utilities]'].concat(msg));
			}
		}, {
			key: 'Error',
			value: function Error() {
				for (var _len5 = arguments.length, msg = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
					msg[_key5] = arguments[_key5];
				}
	
				_globalLoggerServicesJsBundle.LoggerInstance.Error(['[Common-Utilities]'].concat(msg));
			}
		}]);
	
		return Logger;
	}();
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// [NUXIBA]  Version: 2021.4.2 - 2022-07-29 14:37:32  
	 (function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define([], factory);
		else if(typeof exports === 'object')
			exports["LoggerEntryPoint"] = factory();
		else
			root["LoggerEntryPoint"] = factory();
	})(typeof self !== 'undefined' ? self : this, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 3);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var bind = __webpack_require__(5);
	var isBuffer = __webpack_require__(15);
	
	/*global toString:true*/
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return toString.call(val) === '[object Array]';
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	function isArrayBuffer(val) {
	  return toString.call(val) === '[object ArrayBuffer]';
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(val) {
	  return (typeof FormData !== 'undefined') && (val instanceof FormData);
	}
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  var result;
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
	  }
	  return result;
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	function isDate(val) {
	  return toString.call(val) === '[object Date]';
	}
	
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	function isFile(val) {
	  return toString.call(val) === '[object File]';
	}
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	function isBlob(val) {
	  return toString.call(val) === '[object Blob]';
	}
	
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */
	function isFunction(val) {
	  return toString.call(val) === '[object Function]';
	}
	
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */
	function isStream(val) {
	  return isObject(val) && isFunction(val.pipe);
	}
	
	/**
	 * Determine if a value is a URLSearchParams object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	 */
	function isURLSearchParams(val) {
	  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
	}
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.replace(/^\s*/, '').replace(/\s*$/, '');
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  navigator.product -> 'ReactNative'
	 */
	function isStandardBrowserEnv() {
	  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
	    return false;
	  }
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object') {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }
	
	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (typeof result[key] === 'object' && typeof val === 'object') {
	      result[key] = merge(result[key], val);
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	/**
	 * Extends object a by mutably adding to it the properties of object b.
	 *
	 * @param {Object} a The object to be extended
	 * @param {Object} b The object to copy properties from
	 * @param {Object} thisArg The object to bind function to
	 * @return {Object} The resulting value of object a
	 */
	function extend(a, b, thisArg) {
	  forEach(b, function assignValue(val, key) {
	    if (thisArg && typeof val === 'function') {
	      a[key] = bind(val, thisArg);
	    } else {
	      a[key] = val;
	    }
	  });
	  return a;
	}
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isBuffer: isBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isFunction: isFunction,
	  isStream: isStream,
	  isURLSearchParams: isURLSearchParams,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  extend: extend,
	  trim: trim
	};
	
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var instance = null;
	
	var Constants = exports.Constants = function Constants() {
	    _classCallCheck(this, Constants);
	
	    if (!instance) {
	        instance = this;
	    }
	};
	
	Constants._LOGGER_VAR_WINDOW = "NuxibaLogger";
	Constants._LOGGER_CONFIGURATION_FILE_LOCALE = './logger.json';
	Constants._LOGGER_CONFIGURATION_FILE_REMOTE = 'logger.json';
	Constants._LOGGER_CONFIGURATION_FILE_ENCODE = 'utf8';
	Constants._LOGGER_CONFIGURATION_ASSIGNED = window[Constants._LOGGER_VAR_WINDOW] ? true : false;
	Constants._LOG_LEVELS = {
	    "TRACE": { logLevel: 0 },
	    "DEBUG": { logLevel: 1 },
	    "INFO": { logLevel: 2 },
	    "WARN": { logLevel: 3 },
	    "ERROR": { logLevel: 4 }
	};
	Constants._Log_CONSOLE = {
	    "TRACE": console.log,
	    "DEBUG": console.log,
	    "INFO": console.info,
	    "WARN": console.warn,
	    "ERROR": console.error
	};
	Constants._CONFIGURATIONS = {
	    "_ENABLE_DEFAULT": true,
	    "_ENABLE_AJAX": false,
	    "_USE_WINDOW_ORIGIN": true,
	    "_SERVER": "http://127.0.0.1",
	    "_DOMAIN": "/LoggerWS/api/Logger",
	    "_SEVERITY": "INFO",
	    "_SEVERITY_CONSOLE": "INFO",
	    "_NUMBER_ATTEMP_POST": 10,
	    "_FILTER_USER_POST": [],
	    "_FILTER_APP_POST": []
	};
	Constants._REST = {
	    _POST_METHOD: "POST",
	    _MODE: "cors",
	    _CONTENT_TYPE: "content-type",
	    _APPLICATION_JSON: "application/json"
	};
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(process) {
	
	var utils = __webpack_require__(0);
	var normalizeHeaderName = __webpack_require__(18);
	
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	function setContentTypeIfUnset(headers, value) {
	  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
	    headers['Content-Type'] = value;
	  }
	}
	
	function getDefaultAdapter() {
	  var adapter;
	  if (typeof XMLHttpRequest !== 'undefined') {
	    // For browsers use XHR adapter
	    adapter = __webpack_require__(6);
	  } else if (typeof process !== 'undefined') {
	    // For node use HTTP adapter
	    adapter = __webpack_require__(6);
	  }
	  return adapter;
	}
	
	var defaults = {
	  adapter: getDefaultAdapter(),
	
	  transformRequest: [function transformRequest(data, headers) {
	    normalizeHeaderName(headers, 'Content-Type');
	    if (utils.isFormData(data) ||
	      utils.isArrayBuffer(data) ||
	      utils.isBuffer(data) ||
	      utils.isStream(data) ||
	      utils.isFile(data) ||
	      utils.isBlob(data)
	    ) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isURLSearchParams(data)) {
	      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	      return data.toString();
	    }
	    if (utils.isObject(data)) {
	      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
	      return JSON.stringify(data);
	    }
	    return data;
	  }],
	
	  transformResponse: [function transformResponse(data) {
	    /*eslint no-param-reassign:0*/
	    if (typeof data === 'string') {
	      try {
	        data = JSON.parse(data);
	      } catch (e) { /* Ignore */ }
	    }
	    return data;
	  }],
	
	  /**
	   * A timeout in milliseconds to abort a request. If set to 0 (default) a
	   * timeout is not created.
	   */
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	
	  maxContentLength: -1,
	
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  }
	};
	
	defaults.headers = {
	  common: {
	    'Accept': 'application/json, text/plain, */*'
	  }
	};
	
	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  defaults.headers[method] = {};
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
	});
	
	module.exports = defaults;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17)))
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.LoggerInstance = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _LoggerDispatcher = __webpack_require__(12);
	
	var _Constants = __webpack_require__(1);
	
	var _LoggerLocal = __webpack_require__(11);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var usertype = 'AGENT';
	var userId = "";
	var application = "";
	
	var LoggerInstance = function () {
		function LoggerInstance() {
			_classCallCheck(this, LoggerInstance);
		}
	
		_createClass(LoggerInstance, null, [{
			key: 'setUsertype',
			value: function setUsertype(value) {
				usertype = value;
			}
		}, {
			key: 'setUserId',
			value: function setUserId(value) {
				userId = value;
			}
		}, {
			key: 'getUserId',
			value: function getUserId() {
				return userId;
			}
		}, {
			key: 'setApplication',
			value: function setApplication(value) {
				application = value;
			}
		}, {
			key: 'setLocalLogger',
			value: function setLocalLogger(value) {
				_LoggerLocal.LoggerLocal.setEnabled(value);
			}
		}, {
			key: 'setLocalStorageTime',
			value: function setLocalStorageTime(minutes) {
				_LoggerLocal.LoggerLocal.setStorageTimeMin(minutes);
			}
		}, {
			key: 'getApplication',
			value: function getApplication() {
				return application;
			}
		}, {
			key: 'SetUseServerWithLocation',
			value: function SetUseServerWithLocation(useWindowLocation) {
				window[_Constants.Constants._LOGGER_VAR_WINDOW]._USE_WINDOW_LOCATION = useWindowLocation;
			}
		}, {
			key: 'addUserId',
			value: function addUserId(msg) {
				if (userId) {
					var userIdPrint = '[UserId:' + userId + ']';
					msg.unshift(userIdPrint);
				}
			}
		}, {
			key: 'Group',
			value: function Group(label) {
				console.group(label);
			}
		}, {
			key: 'GroupEnd',
			value: function GroupEnd() {
				console.groupEnd();
			}
		}, {
			key: 'CleanLocalLog',
			value: function CleanLocalLog() {
				_LoggerLocal.LoggerLocal.Clean();
			}
		}, {
			key: 'Trace',
			value: function Trace() {
				for (var _len = arguments.length, msg = Array(_len), _key = 0; _key < _len; _key++) {
					msg[_key] = arguments[_key];
				}
	
				_LoggerDispatcher.LoggerDispatcher.Dispatch(usertype, 'Trace', ['[UserId:' + userId + ']'].concat(msg));
			}
		}, {
			key: 'Debug',
			value: function Debug() {
				for (var _len2 = arguments.length, msg = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
					msg[_key2] = arguments[_key2];
				}
	
				LoggerInstance.addUserId(msg);
				_LoggerDispatcher.LoggerDispatcher.Dispatch(usertype, 'Debug', ['[UserId:' + userId + ']'].concat(msg));
			}
		}, {
			key: 'Warning',
			value: function Warning() {
				for (var _len3 = arguments.length, msg = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
					msg[_key3] = arguments[_key3];
				}
	
				LoggerInstance.addUserId(msg);
				_LoggerDispatcher.LoggerDispatcher.Dispatch(usertype, 'Warn', ['[UserId:' + userId + ']'].concat(msg));
			}
		}, {
			key: 'Warn',
			value: function Warn() {
				for (var _len4 = arguments.length, msg = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
					msg[_key4] = arguments[_key4];
				}
	
				LoggerInstance.Warning(msg);
			}
		}, {
			key: 'Info',
			value: function Info() {
				for (var _len5 = arguments.length, msg = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
					msg[_key5] = arguments[_key5];
				}
	
				LoggerInstance.addUserId(msg);
				_LoggerDispatcher.LoggerDispatcher.Dispatch(usertype, 'Info', ['[UserId:' + userId + ']'].concat(msg));
			}
		}, {
			key: 'Error',
			value: function Error() {
				for (var _len6 = arguments.length, msg = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
					msg[_key6] = arguments[_key6];
				}
	
				LoggerInstance.addUserId(msg);
				_LoggerDispatcher.LoggerDispatcher.Dispatch(usertype, 'Error', ['[UserId:' + userId + ']'].concat(msg));
			}
		}, {
			key: 'JsWarning',
			value: function JsWarning() {
				for (var _len7 = arguments.length, msg = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
					msg[_key7] = arguments[_key7];
				}
	
				LoggerInstance.addUserId(msg);
				_LoggerDispatcher.LoggerDispatcher.Dispatch(usertype, 'Warn', ['[UserId:' + userId + ']'].concat(msg), true);
			}
		}, {
			key: 'JsError',
			value: function JsError() {
				for (var _len8 = arguments.length, msg = Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
					msg[_key8] = arguments[_key8];
				}
	
				LoggerInstance.addUserId(msg);
				_LoggerDispatcher.LoggerDispatcher.Dispatch(usertype, 'Error', ['[UserId:' + userId + ']'].concat(msg), true);
			}
		}, {
			key: 'LevelConsole',
			get: function get() {
				return window[_Constants.Constants._LOGGER_VAR_WINDOW]._SEVERITY_CONSOLE;
			}
		}]);
	
		return LoggerInstance;
	}();
	
	exports.LoggerInstance = LoggerInstance;
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __webpack_require__) {
	
	module.exports = __webpack_require__(14);
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	module.exports = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	    return fn.apply(thisArg, args);
	  };
	};
	
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var utils = __webpack_require__(0);
	var settle = __webpack_require__(19);
	var buildURL = __webpack_require__(21);
	var parseHeaders = __webpack_require__(22);
	var isURLSameOrigin = __webpack_require__(23);
	var createError = __webpack_require__(7);
	
	module.exports = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	
	    if (utils.isFormData(requestData)) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }
	
	    var request = new XMLHttpRequest();
	
	    // HTTP basic authentication
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password || '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }
	
	    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);
	
	    // Set the request timeout in MS
	    request.timeout = config.timeout;
	
	    // Listen for ready state
	    request.onreadystatechange = function handleLoad() {
	      if (!request || request.readyState !== 4) {
	        return;
	      }
	
	      // The request errored out and we didn't get a response, this will be
	      // handled by onerror instead
	      // With one exception: request that using file: protocol, most browsers
	      // will return status as 0 even though it's a successful request
	      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	        return;
	      }
	
	      // Prepare the response
	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
	      var response = {
	        data: responseData,
	        status: request.status,
	        statusText: request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };
	
	      settle(resolve, reject, response);
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle low level network errors
	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(createError('Network Error', config, null, request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle timeout
	    request.ontimeout = function handleTimeout() {
	      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
	        request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.
	    if (utils.isStandardBrowserEnv()) {
	      var cookies = __webpack_require__(24);
	
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
	          cookies.read(config.xsrfCookieName) :
	          undefined;
	
	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    }
	
	    // Add headers to the request
	    if ('setRequestHeader' in request) {
	      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    }
	
	    // Add withCredentials to request if needed
	    if (config.withCredentials) {
	      request.withCredentials = true;
	    }
	
	    // Add responseType to request if needed
	    if (config.responseType) {
	      try {
	        request.responseType = config.responseType;
	      } catch (e) {
	        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
	        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
	        if (config.responseType !== 'json') {
	          throw e;
	        }
	      }
	    }
	
	    // Handle progress if needed
	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    }
	
	    // Not all browsers support upload events
	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }
	
	    if (config.cancelToken) {
	      // Handle cancellation
	      config.cancelToken.promise.then(function onCanceled(cancel) {
	        if (!request) {
	          return;
	        }
	
	        request.abort();
	        reject(cancel);
	        // Clean up request
	        request = null;
	      });
	    }
	
	    if (requestData === undefined) {
	      requestData = null;
	    }
	
	    // Send the request
	    request.send(requestData);
	  });
	};
	
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var enhanceError = __webpack_require__(20);
	
	/**
	 * Create an Error with the specified message, config, error code, request and response.
	 *
	 * @param {string} message The error message.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */
	module.exports = function createError(message, config, code, request, response) {
	  var error = new Error(message);
	  return enhanceError(error, config, code, request, response);
	};
	
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	module.exports = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};
	
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	/**
	 * A `Cancel` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */
	function Cancel(message) {
	  this.message = message;
	}
	
	Cancel.prototype.toString = function toString() {
	  return 'Cancel' + (this.message ? ': ' + this.message : '');
	};
	
	Cancel.prototype.__CANCEL__ = true;
	
	module.exports = Cancel;
	
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LoggerUtils = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Constants = __webpack_require__(1);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LoggerUtils = function () {
	  function LoggerUtils() {
	    _classCallCheck(this, LoggerUtils);
	  }
	
	  _createClass(LoggerUtils, null, [{
	    key: "GetLogLevelBySeverity",
	    value: function GetLogLevelBySeverity(severity) {
	      var logLevel = 1;
	      severity = severity.toUpperCase();
	      if (_Constants.Constants._LOG_LEVELS[severity]) {
	        logLevel = _Constants.Constants._LOG_LEVELS[severity].logLevel;
	      }
	      return logLevel;
	    }
	  }, {
	    key: "IsAllowedRemoteToLogBySeverity",
	    value: function IsAllowedRemoteToLogBySeverity(severity) {
	      return LoggerUtils.GetLogLevelBySeverity(severity) >= LoggerUtils.GetCurrentRemoteSeverityLevelConfigured();
	    }
	  }, {
	    key: "GetCurrentRemoteSeverityLevelConfigured",
	    value: function GetCurrentRemoteSeverityLevelConfigured() {
	      return LoggerUtils.GetLogLevelBySeverity(window[_Constants.Constants._LOGGER_VAR_WINDOW]["_SEVERITY"]);
	    }
	  }, {
	    key: "IsAllowedConsoleToLogBySeverity",
	    value: function IsAllowedConsoleToLogBySeverity(severity) {
	      return LoggerUtils.GetLogLevelBySeverity(severity) >= LoggerUtils.GetCurrentConsoleSeverityLevelConfigured();
	    }
	  }, {
	    key: "GetCurrentConsoleSeverityLevelConfigured",
	    value: function GetCurrentConsoleSeverityLevelConfigured() {
	      return LoggerUtils.GetLogLevelBySeverity(window[_Constants.Constants._LOGGER_VAR_WINDOW]["_SEVERITY_CONSOLE"]);
	    }
	  }, {
	    key: "ToStringMessage",
	    value: function ToStringMessage() {
	      var messageString = "";
	
	      for (var _len = arguments.length, message = Array(_len), _key = 0; _key < _len; _key++) {
	        message[_key] = arguments[_key];
	      }
	
	      message.forEach(function (entry) {
	        messageString += LoggerUtils.ToStringObject(entry);
	      });
	      return messageString;
	    }
	  }, {
	    key: "ToStringObject",
	    value: function ToStringObject(entry) {
	      return LoggerUtils.IsObject(entry) ? '\n' + LoggerUtils.JsonToString(entry) : entry;
	    }
	  }, {
	    key: "IsObject",
	    value: function IsObject(value) {
	      return value && (typeof value === "undefined" ? "undefined" : _typeof(value)) === 'object' && value.constructor === Object;
	    }
	  }, {
	    key: "JsonToString",
	    value: function JsonToString(entry) {
	      var seen = [];
	      var jsonString = JSON.stringify(entry, function (key, val) {
	        if (val && (typeof val === "undefined" ? "undefined" : _typeof(val)) == "object") {
	          seen.push(val);
	        }
	        return val;
	      }, 2);
	
	      return jsonString;
	    }
	  }]);
	
	  return LoggerUtils;
	}();
	
	exports.LoggerUtils = LoggerUtils;
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ls = window.localStorage;
	var logKey = "LOG-" + new Date().getDate() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getFullYear();
	var logDateKey = "GalateaLoggerDate";
	var enabled = false;
	var storageTimeMin = 0;
	var firstLogTs = null;
	
	var LoggerLocal = function () {
	    function LoggerLocal() {
	        _classCallCheck(this, LoggerLocal);
	    }
	
	    _createClass(LoggerLocal, null, [{
	        key: "getKey",
	        value: function getKey() {
	            return logKey;
	        }
	    }, {
	        key: "setEnabled",
	        value: function setEnabled(value) {
	            enabled = value;
	        }
	    }, {
	        key: "setStorageTimeMin",
	        value: function setStorageTimeMin(minutes) {
	            storageTimeMin = minutes;
	        }
	    }, {
	        key: "Add",
	        value: function Add(message, usertype, severity) {
	            if (enabled) {
	                var ts = new Date();
	                var prevEntries = ls.getItem(logKey);
	                var newEntry = usertype + "-" + severity + " " + ts.getDate() + "-" + (ts.getMonth() + 1) + "-" + ts.getFullYear() + "-" + ts.getDate() + " " + ts.toLocaleTimeString() + " - MSG: " + message;
	                if (prevEntries) {
	                    if (!firstLogTs) {
	                        firstLogTs = new Date(JSON.parse(ls.getItem(logDateKey)));
	                    }
	                    if (storageTimeMin !== 0 && (ts - firstLogTs) / 60000 > storageTimeMin) {
	                        LoggerLocal.Clean();
	                        firstLogTs = ts;
	                        ls.setItem(logDateKey, JSON.stringify(ts));
	                    } else {
	                        newEntry = prevEntries + ";" + newEntry;
	                    }
	                    ls.setItem(logKey, "" + newEntry);
	                } else {
	                    firstLogTs = ts;
	                    ls.setItem(logKey, newEntry);
	                    ls.setItem(logDateKey, JSON.stringify(ts));
	                }
	            }
	        }
	    }, {
	        key: "getRawLogs",
	        value: function getRawLogs() {
	            return ls.getItem(logKey);
	        }
	    }, {
	        key: "getLogs",
	        value: function getLogs() {
	            return ls.getItem(logKey).replaceAll(';', '\n');
	        }
	    }, {
	        key: "Clean",
	        value: function Clean() {
	            console.log("Cleaning local storage ", logKey);
	            ls.removeItem(logKey);
	        }
	    }]);
	
	    return LoggerLocal;
	}();
	
	exports.LoggerLocal = LoggerLocal;
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.LoggerDispatcher = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _LoggerRestClient = __webpack_require__(13);
	
	var _Constants = __webpack_require__(1);
	
	var _LoggerUtils = __webpack_require__(10);
	
	var _LoggerConfigurator = __webpack_require__(32);
	
	var _LoggerInstance = __webpack_require__(3);
	
	var _LoggerLocal = __webpack_require__(11);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ls = window.localStorage;
	
	var LoggerDispatcher = function () {
		function LoggerDispatcher() {
			_classCallCheck(this, LoggerDispatcher);
		}
	
		_createClass(LoggerDispatcher, null, [{
			key: 'Dispatch',
			value: function Dispatch(usertype, severity, message, hideInConsole) {
				_LoggerLocal.LoggerLocal.Add(message, usertype, severity);
				_LoggerConfigurator.LoggerConfigurator.Init(function () {
					!hideInConsole && LoggerDispatcher.DefaultOutput.apply(LoggerDispatcher, [usertype, severity].concat(_toConsumableArray(message)));
					LoggerDispatcher.RemoteOutput.apply(LoggerDispatcher, [usertype, severity].concat(_toConsumableArray(message)));
				});
			}
		}, {
			key: 'RemoteOutput',
			value: function RemoteOutput(usertype, severity) {
				if (window[_Constants.Constants._LOGGER_VAR_WINDOW] && window[_Constants.Constants._LOGGER_VAR_WINDOW]['_ENABLE_AJAX'] && _LoggerUtils.LoggerUtils.IsAllowedRemoteToLogBySeverity(severity)) {
					for (var _len = arguments.length, message = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
						message[_key - 2] = arguments[_key];
					}
	
					if (severity.toUpperCase() === 'WARN' || severity.toUpperCase() === 'ERROR') {
						_LoggerRestClient.LoggerRestClient.log(usertype, severity, '[' + usertype + '] ' + message);
					} else {
						var isEmptyFilterUser = window[_Constants.Constants._LOGGER_VAR_WINDOW]._FILTER_USER_POST.length === 0;
						var isEmptyFilterApp = window[_Constants.Constants._LOGGER_VAR_WINDOW]._FILTER_APP_POST.length === 0;
	
						if (isEmptyFilterUser && isEmptyFilterApp) {
							_LoggerRestClient.LoggerRestClient.log.apply(_LoggerRestClient.LoggerRestClient, [usertype, severity].concat(message));
						} else {
							var containtUserId = true;
							var containtApp = true;
	
							if (!isEmptyFilterUser) {
								containtUserId = window[_Constants.Constants._LOGGER_VAR_WINDOW]._FILTER_USER_POST.find(function (ele) {
									return ele === _LoggerInstance.LoggerInstance.getUserId();
								});
							}
							if (!isEmptyFilterApp) {
								containtApp = window[_Constants.Constants._LOGGER_VAR_WINDOW]._FILTER_APP_POST.find(function (ele) {
									return ele === _LoggerInstance.LoggerInstance.getApplication();
								});
							}
	
							if (containtUserId && containtApp) {
								_LoggerRestClient.LoggerRestClient.log(usertype, severity, '[' + usertype + '] ' + message);
							}
						}
					}
				}
			}
		}, {
			key: 'DefaultOutput',
			value: function DefaultOutput(usertype, severity) {
				severity = severity.toUpperCase();
				if (window[_Constants.Constants._LOGGER_VAR_WINDOW] && window[_Constants.Constants._LOGGER_VAR_WINDOW]._ENABLE_DEFAULT && _LoggerUtils.LoggerUtils.IsAllowedConsoleToLogBySeverity(severity)) {
					var _consoleLogLevel;
	
					var consoleLogLevel = console.log;
					if (_Constants.Constants._Log_CONSOLE[severity]) {
						consoleLogLevel = _Constants.Constants._Log_CONSOLE[severity];
					}
					var time = new Date().toLocaleTimeString();
	
					for (var _len2 = arguments.length, message = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
						message[_key2 - 2] = arguments[_key2];
					}
	
					(_consoleLogLevel = consoleLogLevel).call.apply(_consoleLogLevel, [null, '[' + time + '][' + severity + '][' + usertype + ']'].concat(message));
				}
			}
		}]);
	
		return LoggerDispatcher;
	}();
	
	exports.LoggerDispatcher = LoggerDispatcher;
	
	/***/ }),
	/* 13 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LoggerRestClient = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _axios = __webpack_require__(4);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _Constants = __webpack_require__(1);
	
	var _LoggerUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var numberAttemp = 0;
	var numMessageWarn = true;
	
	var LoggerRestClient = function () {
	  function LoggerRestClient() {
	    _classCallCheck(this, LoggerRestClient);
	  }
	
	  _createClass(LoggerRestClient, null, [{
	    key: 'log',
	    value: function log(usertype, severity) {
	      if (window[_Constants.Constants._LOGGER_VAR_WINDOW]._ENABLE_AJAX) {
	        if (window[_Constants.Constants._LOGGER_VAR_WINDOW]._NUMBER_ATTEMP_POST === 0 || numberAttemp < window[_Constants.Constants._LOGGER_VAR_WINDOW]._NUMBER_ATTEMP_POST) {
	          try {
	            var serverUrl = new URL(window[_Constants.Constants._LOGGER_VAR_WINDOW]["_SERVER"]);
	            var server = new URL(window[_Constants.Constants._LOGGER_VAR_WINDOW]["_DOMAIN"], serverUrl);
	
	            for (var _len = arguments.length, message = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	              message[_key - 2] = arguments[_key];
	            }
	
	            var msg = _LoggerUtils.LoggerUtils.ToStringMessage(message);
	            _axios2.default.post(server, { UserType: usertype, Message: msg, Severity: severity }).then(function () {
	              numberAttemp = 0;
	            }).catch(function (error) {
	              numberAttemp++;
	              console.warn("It was not possible to send the message server:", server, error);
	            });
	          } catch (e) {
	            numberAttemp++;
	            console.error("it was not possible to send the log message because an error ocurred servidor:" + window[_Constants.Constants._LOGGER_VAR_WINDOW]["_SERVER"] + " error:" + e + " recommendation: you could check the logger configuration");
	          }
	        } else {
	          if (numMessageWarn) {
	            numMessageWarn = false;
	            console.warn("number of attempts to overcome Api web is necessary to check the configuration file for logger.json");
	          }
	        }
	      }
	    }
	  }]);
	
	  return LoggerRestClient;
	}();
	
	exports.LoggerRestClient = LoggerRestClient;
	
	/***/ }),
	/* 14 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var utils = __webpack_require__(0);
	var bind = __webpack_require__(5);
	var Axios = __webpack_require__(16);
	var defaults = __webpack_require__(2);
	
	/**
	 * Create an instance of Axios
	 *
	 * @param {Object} defaultConfig The default config for the instance
	 * @return {Axios} A new instance of Axios
	 */
	function createInstance(defaultConfig) {
	  var context = new Axios(defaultConfig);
	  var instance = bind(Axios.prototype.request, context);
	
	  // Copy axios.prototype to instance
	  utils.extend(instance, Axios.prototype, context);
	
	  // Copy context to instance
	  utils.extend(instance, context);
	
	  return instance;
	}
	
	// Create the default instance to be exported
	var axios = createInstance(defaults);
	
	// Expose Axios class to allow class inheritance
	axios.Axios = Axios;
	
	// Factory for creating new instances
	axios.create = function create(instanceConfig) {
	  return createInstance(utils.merge(defaults, instanceConfig));
	};
	
	// Expose Cancel & CancelToken
	axios.Cancel = __webpack_require__(9);
	axios.CancelToken = __webpack_require__(30);
	axios.isCancel = __webpack_require__(8);
	
	// Expose all/spread
	axios.all = function all(promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__(31);
	
	module.exports = axios;
	
	// Allow use of default import syntax in TypeScript
	module.exports.default = axios;
	
	
	/***/ }),
	/* 15 */
	/***/ (function(module, exports) {
	
	/*!
	 * Determine if an object is a Buffer
	 *
	 * @author   Feross Aboukhadijeh <https://feross.org>
	 * @license  MIT
	 */
	
	module.exports = function isBuffer (obj) {
	  return obj != null && obj.constructor != null &&
	    typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
	}
	
	
	/***/ }),
	/* 16 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var defaults = __webpack_require__(2);
	var utils = __webpack_require__(0);
	var InterceptorManager = __webpack_require__(25);
	var dispatchRequest = __webpack_require__(26);
	
	/**
	 * Create a new instance of Axios
	 *
	 * @param {Object} instanceConfig The default config for the instance
	 */
	function Axios(instanceConfig) {
	  this.defaults = instanceConfig;
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	
	/**
	 * Dispatch a request
	 *
	 * @param {Object} config The config specific for this request (merged with this.defaults)
	 */
	Axios.prototype.request = function request(config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof config === 'string') {
	    config = utils.merge({
	      url: arguments[0]
	    }, arguments[1]);
	  }
	
	  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
	  config.method = config.method.toLowerCase();
	
	  // Hook up interceptors middleware
	  var chain = [dispatchRequest, undefined];
	  var promise = Promise.resolve(config);
	
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    chain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    chain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  while (chain.length) {
	    promise = promise.then(chain.shift(), chain.shift());
	  }
	
	  return promise;
	};
	
	// Provide aliases for supported request methods
	utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url
	    }));
	  };
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, data, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	});
	
	module.exports = Axios;
	
	
	/***/ }),
	/* 17 */
	/***/ (function(module, exports) {
	
	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };
	
	
	/***/ }),
	/* 18 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var utils = __webpack_require__(0);
	
	module.exports = function normalizeHeaderName(headers, normalizedName) {
	  utils.forEach(headers, function processHeader(value, name) {
	    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	      headers[normalizedName] = value;
	      delete headers[name];
	    }
	  });
	};
	
	
	/***/ }),
	/* 19 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var createError = __webpack_require__(7);
	
	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	module.exports = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  // Note: status is not exposed by XDomainRequest
	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(createError(
	      'Request failed with status code ' + response.status,
	      response.config,
	      null,
	      response.request,
	      response
	    ));
	  }
	};
	
	
	/***/ }),
	/* 20 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	/**
	 * Update an Error with the specified config, error code, and response.
	 *
	 * @param {Error} error The error to update.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The error.
	 */
	module.exports = function enhanceError(error, config, code, request, response) {
	  error.config = config;
	  if (code) {
	    error.code = code;
	  }
	  error.request = request;
	  error.response = response;
	  return error;
	};
	
	
	/***/ }),
	/* 21 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var utils = __webpack_require__(0);
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%40/gi, '@').
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }
	
	  var serializedParams;
	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else if (utils.isURLSearchParams(params)) {
	    serializedParams = params.toString();
	  } else {
	    var parts = [];
	
	    utils.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }
	
	      if (utils.isArray(val)) {
	        key = key + '[]';
	      } else {
	        val = [val];
	      }
	
	      utils.forEach(val, function parseValue(v) {
	        if (utils.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils.isObject(v)) {
	          v = JSON.stringify(v);
	        }
	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	
	    serializedParams = parts.join('&');
	  }
	
	  if (serializedParams) {
	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }
	
	  return url;
	};
	
	
	/***/ }),
	/* 22 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var utils = __webpack_require__(0);
	
	// Headers whose duplicates are ignored by node
	// c.f. https://nodejs.org/api/http.html#http_message_headers
	var ignoreDuplicateOf = [
	  'age', 'authorization', 'content-length', 'content-type', 'etag',
	  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
	  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
	  'referer', 'retry-after', 'user-agent'
	];
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
	        return;
	      }
	      if (key === 'set-cookie') {
	        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
	      } else {
	        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	      }
	    }
	  });
	
	  return parsed;
	};
	
	
	/***/ }),
	/* 23 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var utils = __webpack_require__(0);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	  (function standardBrowserEnv() {
	    var msie = /(msie|trident)/i.test(navigator.userAgent);
	    var urlParsingNode = document.createElement('a');
	    var originURL;
	
	    /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	    function resolveURL(url) {
	      var href = url;
	
	      if (msie) {
	        // IE needs attribute set twice to normalize properties
	        urlParsingNode.setAttribute('href', href);
	        href = urlParsingNode.href;
	      }
	
	      urlParsingNode.setAttribute('href', href);
	
	      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	      return {
	        href: urlParsingNode.href,
	        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	        host: urlParsingNode.host,
	        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	        hostname: urlParsingNode.hostname,
	        port: urlParsingNode.port,
	        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	                  urlParsingNode.pathname :
	                  '/' + urlParsingNode.pathname
	      };
	    }
	
	    originURL = resolveURL(window.location.href);
	
	    /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	    return function isURLSameOrigin(requestURL) {
	      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	      return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	    };
	  })() :
	
	  // Non standard browser envs (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return function isURLSameOrigin() {
	      return true;
	    };
	  })()
	);
	
	
	/***/ }),
	/* 24 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var utils = __webpack_require__(0);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs support document.cookie
	  (function standardBrowserEnv() {
	    return {
	      write: function write(name, value, expires, path, domain, secure) {
	        var cookie = [];
	        cookie.push(name + '=' + encodeURIComponent(value));
	
	        if (utils.isNumber(expires)) {
	          cookie.push('expires=' + new Date(expires).toGMTString());
	        }
	
	        if (utils.isString(path)) {
	          cookie.push('path=' + path);
	        }
	
	        if (utils.isString(domain)) {
	          cookie.push('domain=' + domain);
	        }
	
	        if (secure === true) {
	          cookie.push('secure');
	        }
	
	        document.cookie = cookie.join('; ');
	      },
	
	      read: function read(name) {
	        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	        return (match ? decodeURIComponent(match[3]) : null);
	      },
	
	      remove: function remove(name) {
	        this.write(name, '', Date.now() - 86400000);
	      }
	    };
	  })() :
	
	  // Non standard browser env (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return {
	      write: function write() {},
	      read: function read() { return null; },
	      remove: function remove() {}
	    };
	  })()
	);
	
	
	/***/ }),
	/* 25 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var utils = __webpack_require__(0);
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function use(fulfilled, rejected) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;
	
	
	/***/ }),
	/* 26 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var utils = __webpack_require__(0);
	var transformData = __webpack_require__(27);
	var isCancel = __webpack_require__(8);
	var defaults = __webpack_require__(2);
	var isAbsoluteURL = __webpack_require__(28);
	var combineURLs = __webpack_require__(29);
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	function throwIfCancellationRequested(config) {
	  if (config.cancelToken) {
	    config.cancelToken.throwIfRequested();
	  }
	}
	
	/**
	 * Dispatch a request to the server using the configured adapter.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  throwIfCancellationRequested(config);
	
	  // Support baseURL config
	  if (config.baseURL && !isAbsoluteURL(config.url)) {
	    config.url = combineURLs(config.baseURL, config.url);
	  }
	
	  // Ensure headers exist
	  config.headers = config.headers || {};
	
	  // Transform request data
	  config.data = transformData(
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Flatten headers
	  config.headers = utils.merge(
	    config.headers.common || {},
	    config.headers[config.method] || {},
	    config.headers || {}
	  );
	
	  utils.forEach(
	    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
	    function cleanHeaderConfig(method) {
	      delete config.headers[method];
	    }
	  );
	
	  var adapter = config.adapter || defaults.adapter;
	
	  return adapter(config).then(function onAdapterResolution(response) {
	    throwIfCancellationRequested(config);
	
	    // Transform response data
	    response.data = transformData(
	      response.data,
	      response.headers,
	      config.transformResponse
	    );
	
	    return response;
	  }, function onAdapterRejection(reason) {
	    if (!isCancel(reason)) {
	      throwIfCancellationRequested(config);
	
	      // Transform response data
	      if (reason && reason.response) {
	        reason.response.data = transformData(
	          reason.response.data,
	          reason.response.headers,
	          config.transformResponse
	        );
	      }
	    }
	
	    return Promise.reject(reason);
	  });
	};
	
	
	/***/ }),
	/* 27 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var utils = __webpack_require__(0);
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  /*eslint no-param-reassign:0*/
	  utils.forEach(fns, function transform(fn) {
	    data = fn(data, headers);
	  });
	
	  return data;
	};
	
	
	/***/ }),
	/* 28 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	module.exports = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};
	
	
	/***/ }),
	/* 29 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	module.exports = function combineURLs(baseURL, relativeURL) {
	  return relativeURL
	    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
	    : baseURL;
	};
	
	
	/***/ }),
	/* 30 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var Cancel = __webpack_require__(9);
	
	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */
	function CancelToken(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }
	
	  var resolvePromise;
	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });
	
	  var token = this;
	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }
	
	    token.reason = new Cancel(message);
	    resolvePromise(token.reason);
	  });
	}
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};
	
	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */
	CancelToken.source = function source() {
	  var cancel;
	  var token = new CancelToken(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};
	
	module.exports = CancelToken;
	
	
	/***/ }),
	/* 31 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};
	
	
	/***/ }),
	/* 32 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.LoggerConfigurator = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Constants = __webpack_require__(1);
	
	var _axios = __webpack_require__(4);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _loadFirst = true;
	
	var LoggerConfigurator = function () {
		function LoggerConfigurator() {
			_classCallCheck(this, LoggerConfigurator);
		}
	
		_createClass(LoggerConfigurator, null, [{
			key: 'Init',
			value: function Init(callback) {
				if (_loadFirst && LoggerConfigurator.IsConfigurationNotAssigned()) {
					_loadFirst = false;
					LoggerConfigurator.GetByExecutionEnvironment(callback);
				} else {
					callback();
				}
			}
		}, {
			key: 'Setup',
			value: function Setup(configuration, callback) {
				console.info("Setup ", configuration);
				if (configuration) {
					window[_Constants.Constants._LOGGER_VAR_WINDOW] = {};
	
					var _iteratorNormalCompletion = true;
					var _didIteratorError = false;
					var _iteratorError = undefined;
	
					try {
						for (var _iterator = Object.entries(_Constants.Constants._CONFIGURATIONS)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
							var _step$value = _slicedToArray(_step.value, 2),
							    key = _step$value[0],
							    value = _step$value[1];
	
							setValueDefatult(configuration, key, value);
						}
					} catch (err) {
						_didIteratorError = true;
						_iteratorError = err;
					} finally {
						try {
							if (!_iteratorNormalCompletion && _iterator.return) {
								_iterator.return();
							}
						} finally {
							if (_didIteratorError) {
								throw _iteratorError;
							}
						}
					}
	
					Object.keys(configuration).forEach(function (key) {
						return window[_Constants.Constants._LOGGER_VAR_WINDOW][key] = configuration[key];
					});
	
					if (window[_Constants.Constants._LOGGER_VAR_WINDOW]._USE_WINDOW_ORIGIN) {
						LoggerConfigurator.SetConfigurationServer();
					}
				} else {
					window[_Constants.Constants._LOGGER_VAR_WINDOW] = _Constants.Constants._CONFIGURATIONS;
					console.info('Logger will use default configuration ... ', _Constants.Constants._CONFIGURATIONS);
				}
				callback();
			}
		}, {
			key: 'GetByExecutionEnvironment',
			value: function GetByExecutionEnvironment(callback) {
				if (LoggerConfigurator.IsBrowser()) {
					LoggerConfigurator.GetRemote(callback);
				} else {
					LoggerConfigurator.GetLocal(callback);
				}
			}
		}, {
			key: 'IsBrowser',
			value: function IsBrowser() {
				return window ? true : false;
			}
		}, {
			key: 'GetLocal',
			value: function GetLocal(callback) {
				LoggerConfigurator.Setup(null, callback);
			}
		}, {
			key: 'GetRemote',
			value: function GetRemote(callback) {
				var remoteLocation = window.location + "";
				var remoteSplit = remoteLocation.split('/');
				remoteLocation = remoteLocation.replace(remoteSplit[remoteSplit.length - 1], '');
				remoteLocation = remoteLocation + _Constants.Constants._LOGGER_CONFIGURATION_FILE_REMOTE;
	
				_axios2.default.get(remoteLocation, { responseType: 'json' }).then(function (response) {
					LoggerConfigurator.Setup(response.data, callback);
				}).catch(function (error) {
					console.error("It was not possible to get remote file configuration", error);
					LoggerConfigurator.Setup(null, callback);
				});
			}
		}, {
			key: 'SetConfigurationServer',
			value: function SetConfigurationServer() {
				if (window[_Constants.Constants._LOGGER_VAR_WINDOW]._USE_WINDOW_ORIGIN) {
					var hostname = window.location.hostname;
					if (hostname !== "127.0.0.1" && hostname !== "localhost") {
						var remoteLocation = window.location.origin;
						console.debug("SetConfigurationServer withLocation", remoteLocation);
						window[_Constants.Constants._LOGGER_VAR_WINDOW]["_SERVER"] = remoteLocation;
					}
				}
			}
		}, {
			key: 'ExistExternalConfiguration',
			value: function ExistExternalConfiguration(configuration) {
				return configuration ? true : false;
			}
		}, {
			key: 'IsConfigurationNotAssigned',
			value: function IsConfigurationNotAssigned() {
				return !_Constants.Constants._LOGGER_CONFIGURATION_ASSIGNED;
			}
		}]);
	
		return LoggerConfigurator;
	}();
	
	function setValueDefatult(configuration, property, valueDefault) {
		if (configuration[property] === undefined) {
			console.info("file logger.json does not contain field [%s] set value default [%s]", property, valueDefault);
			configuration[property] = valueDefault;
		}
	}
	
	exports.LoggerConfigurator = LoggerConfigurator;
	
	/***/ })
	/******/ ]);
	});
	//# sourceMappingURL=global-logger-services-js-bundle.js.map 
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var URLClient = exports.URLClient = function () {
	  function URLClient(urlWrapper) {
	    _classCallCheck(this, URLClient);
	
	    this.urlWrapper = urlWrapper;
	  }
	
	  _createClass(URLClient, [{
	    key: "getQueryVariable",
	    value: function getQueryVariable(variable) {
	      var query = this.urlWrapper.getURLQueryParameters();
	      var vars = query.split("&");
	      for (var i = 0; i < vars.length; i++) {
	        var pair = vars[i].split("=");
	        if (pair[0] == variable) {
	          return pair[1];
	        }
	      }
	      return false;
	    }
	  }, {
	    key: "updateQueryStringParameter",
	    value: function updateQueryStringParameter(key, value) {
	      var uri = this.urlWrapper.getURLString();
	      var newUri = "";
	      var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
	      var separator = uri.indexOf('?') !== -1 ? "&" : "?";
	      if (uri.match(re)) {
	        newUri = uri.replace(re, '$1' + key + "=" + value + '$2');
	      } else {
	        newUri = uri + separator + key + "=" + value;
	      }
	      this.urlWrapper.setURL(newUri);
	    }
	  }]);
	
	  return URLClient;
	}();
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var URLWrapper = exports.URLWrapper = function () {
	  function URLWrapper() {
	    _classCallCheck(this, URLWrapper);
	  }
	
	  _createClass(URLWrapper, [{
	    key: "getURL",
	    value: function getURL() {
	      return window.location;
	    }
	  }, {
	    key: "getURLString",
	    value: function getURLString() {
	      return this.getURL().href;
	    }
	  }, {
	    key: "getURLQueryParameters",
	    value: function getURLQueryParameters() {
	      return this.getURL().search.substring(1);
	    }
	  }, {
	    key: "setURL",
	    value: function setURL(url) {
	      window.location.href = url;
	    }
	  }]);
	
	  return URLWrapper;
	}();
	
	/***/ })
	/******/ ]);
	});
	//# sourceMappingURL=global-common-utilities-js-bundle.js.map 

/***/ },
/* 689 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _ListDropDown = _interopRequireWildcard(__webpack_require__(698));
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var ListInput = function ListInput(_ref, ref) {
	  var id = _ref.id,
	      value = _ref.value,
	      onChange = _ref.onChange,
	      onClick = _ref.onClick,
	      onSelect = _ref.onSelect,
	      onBlur = _ref.onBlur,
	      list = _ref.list,
	      adjustable = _ref.adjustable,
	      emptyListLabel = _ref.emptyListLabel;
	  var inputRef = (0, _react.useRef)();
	  (0, _react.useImperativeHandle)(ref, function () {
	    return {
	      focus: function focus() {
	        inputRef.current.focus();
	      }
	    };
	  });
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      isListOpen = _useState2[0],
	      setListOpen = _useState2[1];
	
	  var filteredList = (0, _react.useMemo)(function () {
	    return value === '' || list == null ? list : list.filter(function (c) {
	      return c.name.toLowerCase().includes(value.toLowerCase()) || c.account.toLowerCase().includes(value.toLowerCase());
	    });
	  }, [value, list]);
	
	  var _useState3 = (0, _react.useState)(0),
	      _useState4 = _slicedToArray(_useState3, 2),
	      focused = _useState4[0],
	      setFocused = _useState4[1];
	
	  (0, _react.useEffect)(function () {
	    if (filteredList && focused >= filteredList.length && filteredList.length > 0) {
	      setFocused(filteredList.length - 1);
	    }
	  }, [filteredList, focused]);
	
	  var handleKeyDown = function handleKeyDown(e) {
	    if (['Enter', 'Tab', ',', ';'].includes(e.key)) {
	      if (e.key === 'Tab' && value === '') return;
	      e.preventDefault();
	
	      if (isListOpen && filteredList != null && filteredList[focused] !== undefined) {
	        setListOpen(false);
	        onSelect(filteredList[focused]);
	      } else if (value !== '') {
	        setListOpen(false);
	        onSelect({
	          account: value
	        });
	      }
	    } else {
	      if (filteredList != null) {
	        if (!isListOpen) setListOpen(true);
	
	        if (['ArrowUp', 'ArrowDown'].includes(e.key)) {
	          e.preventDefault();
	          if (e.key === 'ArrowDown') setFocused(Math.min(focused + 1, filteredList.length - 1));else if (e.key === 'ArrowUp') setFocused(Math.max(0, focused - 1));
	        }
	      }
	    }
	  };
	
	  var selectRef = (0, _react.useRef)(onSelect);
	  (0, _react.useEffect)(function () {
	    selectRef.current = onSelect;
	  });
	  var blurCallback = (0, _react.useCallback)(function () {
	    if (value !== '') {
	      selectRef.current({
	        account: value
	      });
	    } else {
	      onBlur && onBlur();
	    }
	  }, [onBlur, value]);
	  var blurFlag = (0, _react.useRef)(false);
	
	  var handleBlur = function handleBlur() {
	    if (filteredList == null) {
	      blurCallback();
	    } else {
	      if (!(filteredList.length > 0 && isListOpen) && value !== '') {
	        onSelect({
	          account: value
	        });
	      }
	
	      blurFlag.current = true;
	    }
	  };
	
	  (0, _react.useEffect)(function () {
	    if (blurFlag.current && !isListOpen) {
	      blurCallback();
	      blurFlag.current = false;
	    }
	  }, [isListOpen, blurCallback]);
	
	  var handleItemClick = function handleItemClick(c) {
	    setListOpen(false);
	    onSelect(c);
	  };
	
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    id: id,
	    tabIndex: 1,
	    onBlur: handleBlur,
	    className: 'uin-ain-list-input' + (adjustable ? ' auto' : '')
	  }, /*#__PURE__*/_react["default"].createElement("input", {
	    ref: inputRef,
	    type: "mail",
	    style: adjustable ? {
	      width: value.length * 0.875 + 'rem'
	    } : undefined,
	    value: value,
	    onClick: onClick,
	    onChange: onChange,
	    onKeyDown: handleKeyDown,
	    autoComplete: "off"
	  }), filteredList && filteredList.length > 0 ? /*#__PURE__*/_react["default"].createElement(_ListDropDown["default"], {
	    target: id,
	    isOpen: isListOpen,
	    toggle: function toggle() {
	      return setListOpen(!isListOpen);
	    }
	  }, filteredList.map(function (c, i) {
	    return /*#__PURE__*/_react["default"].createElement(_ListDropDown.ListItem, {
	      key: i,
	      icon: "user",
	      username: c.name,
	      extraUserInfo: c.account,
	      onClick: function onClick() {
	        return handleItemClick(c);
	      },
	      focused: focused === i,
	      onFocus: function onFocus() {
	        return setFocused(i);
	      }
	    });
	  })) : (list == null || list.length === 0) && emptyListLabel && /*#__PURE__*/_react["default"].createElement(_ListDropDown["default"], {
	    target: id,
	    isOpen: isListOpen,
	    toggle: function toggle() {
	      return setListOpen(!isListOpen);
	    }
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "empty-dd"
	  }, emptyListLabel)));
	};
	
	var _default = /*#__PURE__*/(0, _react.forwardRef)(ListInput);
	
	exports["default"] = _default;

/***/ },
/* 690 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _constants = __webpack_require__(275);
	
	__webpack_require__(2529);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var CampaignIcon = function CampaignIcon(_ref) {
	  var type = _ref.type,
	      frame = _ref.frame,
	      size = _ref.size,
	      channel = _ref.channel;
	  return /*#__PURE__*/_react["default"].createElement("span", {
	    className: "gcl-camp-icon ".concat(type === 0 ? 'inbound' : 'outbound', " gcl-").concat(size, " ").concat(channel != null ? 'with-channel' : ''),
	    "data-camp-channel": _constants.CHANNEL_ICONS[channel]
	  }, /*#__PURE__*/_react["default"].createElement("i", {
	    className: 'gcl-icon ' + _constants.CAMPAIGN_ICONS[frame - 1].icon
	  }), channel != null && /*#__PURE__*/_react["default"].createElement("span", {
	    className: "gcl-ci-channel"
	  }, /*#__PURE__*/_react["default"].createElement("i", {
	    className: 'gcl-icon ' + _constants.CHANNEL_ICONS[channel]
	  })));
	};
	
	CampaignIcon.propTypes = {
	  type: _propTypes["default"].oneOf([0, 1]),
	  frame: _propTypes["default"].number,
	  size: _propTypes["default"].oneOf(['sm', 'md', 'lg']),
	  channel: _propTypes["default"].number
	};
	CampaignIcon.defaultProps = {
	  type: 0,
	  frame: 1,
	  size: 'md'
	};
	var _default = CampaignIcon;
	exports["default"] = _default;

/***/ },
/* 691 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _Hue = _interopRequireDefault(__webpack_require__(1895));
	
	var _Saturation = _interopRequireDefault(__webpack_require__(1896));
	
	var _utils = __webpack_require__(422);
	
	__webpack_require__(2539);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var ColorPicker = function ColorPicker(_ref) {
	  var color = _ref.color,
	      onChange = _ref.onChange;
	  (0, _react.useEffect)(function () {
	    var colors = (0, _utils.toState)(color, 0);
	    onChange(colors);
	  }, []);
	
	  var onSaturationChange = function onSaturationChange(val) {
	    var colors = (0, _utils.toState)(val, color.oldHue);
	    onChange(colors);
	  };
	
	  var onHueChange = function onHueChange(val) {
	    var colors = (0, _utils.toState)(val, val.h || color.oldHue);
	    onChange(colors);
	  };
	
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-color-picker"
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-cp-wrapper"
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-cp-sat-container"
	  }, /*#__PURE__*/_react["default"].createElement(_Saturation["default"], {
	    onChange: onSaturationChange,
	    hsl: color.hsl,
	    hsv: color.hsv
	  })), /*#__PURE__*/_react["default"].createElement(_Hue["default"], {
	    onChange: onHueChange,
	    hsl: color.hsl
	  })), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-cp-label"
	  }, color.hex));
	};
	
	ColorPicker.propTypes = {
	  color: _propTypes["default"].object.isRequired,
	  onChange: _propTypes["default"].func.isRequired
	};
	var _default = ColorPicker;
	exports["default"] = _default;

/***/ },
/* 692 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _Button = _interopRequireDefault(__webpack_require__(97));
	
	__webpack_require__(2543);
	
	__webpack_require__(2544);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var Counter = function Counter(_ref) {
	  var min = _ref.min,
	      max = _ref.max,
	      _ref$start = _ref.start,
	      start = _ref$start === void 0 ? 0 : _ref$start,
	      _ref$step = _ref.step,
	      step = _ref$step === void 0 ? 1 : _ref$step,
	      onChange = _ref.onChange,
	      disabled = _ref.disabled;
	
	  var _useState = (0, _react.useState)(start),
	      _useState2 = _slicedToArray(_useState, 2),
	      count = _useState2[0],
	      setCount = _useState2[1];
	
	  var isNumber = function isNumber(keyCode) {
	    return keyCode >= 48 && keyCode <= 57 || keyCode >= 96 && keyCode <= 105;
	  };
	
	  var isFunctionKey = function isFunctionKey(keyCode) {
	    return keyCode === 8 || keyCode === 46 || keyCode === 9 || keyCode >= 37 && keyCode <= 40;
	  };
	
	  var isSign = function isSign(keyCode) {
	    return keyCode === 173 || keyCode === 109 || keyCode === 110 || keyCode === 190;
	  };
	
	  var validateMaxMin = function validateMaxMin(counter) {
	    var set = max !== undefined ? counter <= max : true;
	    return set && min !== undefined ? counter >= min : set;
	  };
	
	  var handleKeyDown = function handleKeyDown(e) {
	    var keyCode = e.keyCode || e.charCode;
	    !isFunctionKey(keyCode) && !isNumber(keyCode) && !isSign(keyCode) && e.preventDefault();
	  };
	
	  var handleChange = function handleChange(e) {
	    var counter = parseFloat(e.target.value);
	    counter = counter ? counter : '';
	    validateMaxMin(counter) && setCounter(counter);
	  };
	
	  var onBlur = function onBlur() {
	    return count === '' ? setCounter(0) : count % step !== 0 && setCounter(fixCount(step * Math.round(count / step)));
	  };
	
	  var increment = function increment() {
	    var counter = fixCount(count === '' ? 0 + step : count + step);
	
	    if (validateMaxMin(counter)) {
	      setCounter(counter);
	    }
	  };
	
	  var decrement = function decrement() {
	    var counter = fixCount(count === '' ? 0 - step : count - step);
	
	    if (validateMaxMin(counter)) {
	      setCounter(counter);
	    }
	  };
	
	  var setCounter = function setCounter(count) {
	    setCount(count);
	    onChange(count);
	  };
	
	  var fixCount = function fixCount(count) {
	    return +count.toFixed(2);
	  };
	
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: 'gcl-counter'
	  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
	    onClick: decrement,
	    disabled: disabled ? true : min !== undefined ? count === min : false
	  }, /*#__PURE__*/_react["default"].createElement("i", {
	    "class": "gcl-icon minus"
	  })), /*#__PURE__*/_react["default"].createElement("input", {
	    className: 'gcl-counter-input ' + (disabled ? 'disabled' : ''),
	    type: "number",
	    onKeyDown: !disabled && handleKeyDown,
	    onChange: !disabled && handleChange,
	    onBlur: !disabled && onBlur,
	    value: count,
	    min: min,
	    max: max,
	    step: step,
	    disabled: disabled
	  }), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
	    onClick: increment,
	    disabled: disabled ? true : max !== undefined ? count === max : false
	  }, /*#__PURE__*/_react["default"].createElement("i", {
	    "class": "gcl-icon plus"
	  })));
	};
	
	Counter.propTypes = {
	  onChange: _propTypes["default"].func,
	  min: _propTypes["default"].number,
	  max: _propTypes["default"].number,
	  start: _propTypes["default"].number,
	  step: _propTypes["default"].number,
	  disabled: _propTypes["default"].bool
	};
	Counter.defaultProps = {
	  onChange: function onChange() {},
	  start: 0,
	  step: 1,
	  min: undefined,
	  max: undefined,
	  disabled: false
	};
	var _default = Counter;
	exports["default"] = _default;

/***/ },
/* 693 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.Option = exports.Header = exports.Content = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	__webpack_require__(2548);
	
	__webpack_require__(2549);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var DropDownMenu = function DropDownMenu(_ref) {
	  var id = _ref.id,
	      disabled = _ref.disabled,
	      keepMenuOpen = _ref.keepMenuOpen,
	      children = _ref.children,
	      iconName = _ref.iconName,
	      isUserMenu = _ref.isUserMenu;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      active = _useState2[0],
	      setActive = _useState2[1];
	
	  var wrapperRef = (0, _react.useRef)(null);
	  (0, _react.useEffect)(function () {
	    function handleClickOutside(event) {
	      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
	        setActive(false);
	      }
	    }
	
	    document.addEventListener('mousedown', handleClickOutside);
	    return function () {
	      document.removeEventListener('mousedown', handleClickOutside);
	    };
	  }, [wrapperRef]);
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: 'gcl-dd-container ' + (isUserMenu ? 'user-menu' : ''),
	    ref: wrapperRef,
	    id: id
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-dd-icon"
	  }, /*#__PURE__*/_react["default"].createElement("button", {
	    disabled: disabled,
	    onClick: function onClick() {
	      return setActive(!active);
	    },
	    className: "gcl-dd-button"
	  }, /*#__PURE__*/_react["default"].createElement("i", {
	    className: iconName
	  }))), active && /*#__PURE__*/_react["default"].createElement("div", {
	    className: 'gcl-dd-menu-container'
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-dd-menu-wrap",
	    onClick: function onClick() {
	      return keepMenuOpen ? " " : setActive(false);
	    }
	  }, children)));
	};
	
	var Option = function Option(_ref2) {
	  var onClick = _ref2.onClick,
	      children = _ref2.children;
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-dd-option",
	    onClick: onClick
	  }, children);
	};
	
	exports.Option = Option;
	
	var Header = function Header(_ref3) {
	  var title = _ref3.title,
	      subtitle = _ref3.subtitle,
	      _ref3$iconName = _ref3.iconName,
	      iconName = _ref3$iconName === void 0 ? 'gcl-icon account' : _ref3$iconName;
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-dd-header"
	  }, /*#__PURE__*/_react["default"].createElement("i", {
	    className: iconName
	  }), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "title"
	  }, title), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "subtitle"
	  }, subtitle));
	};
	
	exports.Header = Header;
	
	var Content = function Content(_ref4) {
	  var children = _ref4.children;
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-dd-content"
	  }, children);
	};
	
	exports.Content = Content;
	DropDownMenu.propTypes = {
	  id: _propTypes["default"].number,
	  disabled: _propTypes["default"].bool,
	  keepMenuOpen: _propTypes["default"].bool,
	  iconName: _propTypes["default"].string,
	  isUserMenu: _propTypes["default"].bool
	};
	DropDownMenu.defaultProps = {
	  iconName: 'gcl-icon more'
	};
	var _default = DropDownMenu;
	exports["default"] = _default;

/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	__webpack_require__(2553);
	
	__webpack_require__(2554);
	
	var _classNames = _interopRequireDefault(__webpack_require__(61));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var IconItem = function IconItem(props) {
	  var classes = (0, _classNames["default"])({
	    disabled: props.disabled,
	    active: props.disabled ? false : props.active
	  });
	
	  var onClick = function onClick() {
	    !props.disabled && props.onClick();
	  };
	
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: 'gcl-icon-item ' + classes,
	    tabindex: 'user' + props.id,
	    onClick: onClick
	  }, props.icon && /*#__PURE__*/_react["default"].createElement("i", {
	    className: 'gcl-icon ' + props.icon + ' ' + props.size
	  }), /*#__PURE__*/_react["default"].createElement("div", {
	    className: 'gcl-icon-item-text'
	  }, props.children));
	};
	
	IconItem.propTypes = {
	  onClick: _propTypes["default"].func.isRequired,
	  disabled: _propTypes["default"].bool,
	  active: _propTypes["default"].bool,
	  id: _propTypes["default"].string.isRequired,
	  children: _propTypes["default"].isRequired,
	  icon: _propTypes["default"].string.isRequired,
	  size: _propTypes["default"].oneOf(['small', 'large', ''])
	};
	IconItem.defaultProps = {
	  onClick: function onClick() {
	    return console.warn('no function was assigned as prop');
	  },
	  active: false,
	  disabled: false,
	  icon: '',
	  iconSize: ''
	};
	var _default = IconItem;
	exports["default"] = _default;

/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classNames = _interopRequireDefault(__webpack_require__(61));
	
	__webpack_require__(2555);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var InputChip = function InputChip(_ref) {
	  var _classnames;
	
	  var label = _ref.label,
	      tabIndex = _ref.tabIndex,
	      color = _ref.color,
	      message = _ref.message,
	      errorMessage = _ref.errorMessage,
	      interactive = _ref.interactive,
	      invalid = _ref.invalid,
	      onClick = _ref.onClick,
	      onDelete = _ref.onDelete;
	  var classes = (0, _classNames["default"])((_classnames = {}, _defineProperty(_classnames, color, color != null), _defineProperty(_classnames, "interactive", interactive), _defineProperty(_classnames, "invalid", invalid), _classnames));
	
	  var deleteHandler = function deleteHandler(e) {
	    e.stopPropagation();
	    onDelete(e);
	  };
	
	  return /*#__PURE__*/_react["default"].createElement("span", {
	    tabIndex: tabIndex,
	    className: 'uin-input-chip ' + classes,
	    onClick: onClick
	  }, label, errorMessage && /*#__PURE__*/_react["default"].createElement("span", {
	    className: "uin-chp-error"
	  }, errorMessage), message && /*#__PURE__*/_react["default"].createElement("span", {
	    className: "uin-chp-msg"
	  }, message), onDelete && /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon close-circle",
	    onClick: deleteHandler
	  }));
	};
	
	InputChip.propTypes = {
	  label: _propTypes["default"].string.isRequired,
	  tabIndex: _propTypes["default"].number,
	  color: _propTypes["default"].oneOf(['blue', 'green']),
	  message: _propTypes["default"].string,
	  errorMessage: _propTypes["default"].string,
	  interactive: _propTypes["default"].bool,
	  invalid: _propTypes["default"].bool,
	  onClick: _propTypes["default"].func,
	  onDelete: _propTypes["default"].func
	};
	var _default = InputChip;
	exports["default"] = _default;

/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	__webpack_require__(2556);
	
	__webpack_require__(2557);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var FilterInput = function FilterInput(props) {
	  var _useState = (0, _react.useState)(props.value),
	      _useState2 = _slicedToArray(_useState, 2),
	      value = _useState2[0],
	      setValue = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(props.value.length <= 0),
	      _useState4 = _slicedToArray(_useState3, 2),
	      isEmpty = _useState4[0],
	      setEmpty = _useState4[1];
	
	  var inputRef = (0, _react.useRef)();
	  var stringifiedData = JSON.stringify(props.data);
	  (0, _react.useEffect)(function () {
	    filterRef.current();
	  }, [value, stringifiedData]);
	
	  var setState = function setState(inputValue) {
	    if (!props.disabled) {
	      setValue(inputValue);
	      setEmpty(inputValue.length <= 0);
	    }
	  };
	
	  var filter = function filter() {
	    if (props.customFilter) {
	      props.onChange(value);
	    } else {
	      var data = Array.isArray(props.data) ? props.data : convertDicToArray(props.data);
	      var filteredData = data.filter(arrayFilter);
	      props.onChange(filteredData);
	    }
	  };
	
	  var filterRef = (0, _react.useRef)(filter);
	  filterRef.current = filter;
	
	  var convertDicToArray = function convertDicToArray(dic) {
	    return Object.keys(dic).map(function (key) {
	      var element = dic[key];
	      element[props.keyResult] = key;
	      return element;
	    });
	  };
	
	  var arrayFilter = function arrayFilter(data) {
	    if (_typeof(data) === 'object') {
	      if (Array.isArray(data)) {
	        // array de arrays
	        return data.filter(arrayFilter).some(function (x) {
	          return x;
	        });
	      } //array of objects
	      else if (props.filterBy) {
	          return searchByKeyIn(data);
	        }
	
	      throw new Error("filterBy value wasn't assigned as prop");
	    }
	
	    return valueIn(data); //array of string or integers
	  };
	
	  var searchByKeyIn = function searchByKeyIn(data) {
	    if (Array.isArray(props.filterBy)) {
	      return props.filterBy.some(function (element) {
	        return element in data ? valueIn(data[element]) : false;
	      });
	    }
	
	    return props.filterBy in data ? valueIn(data[props.filterBy]) : false;
	  };
	
	  var valueIn = function valueIn(data) {
	    var stringData = data.toString();
	    return props.ignoreCase ? stringData.toLowerCase().includes(value.toLowerCase()) : stringData.includes(value);
	  };
	
	  var onKeyDown = function onKeyDown(e) {
	    if (!['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(e.key) || value.length >= props.maxLength && !['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(e.key)) e.preventDefault();
	  };
	
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    tabIndex: 'glc-filter',
	    className: "gcl-filter-input ".concat(props.className, " ").concat(!isEmpty ? 'filled' : '', " ").concat(props.disabled ? 'disabled' : '')
	  }, /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon lupa"
	  }), /*#__PURE__*/_react["default"].createElement("input", {
	    ref: inputRef,
	    type: props.numeric ? 'number' : 'text',
	    onChange: function onChange(e) {
	      return setState(e.target.value);
	    },
	    value: value,
	    placeholder: props.placeholder,
	    disabled: props.disabled,
	    onKeyDown: props.numeric ? onKeyDown : undefined,
	    autoComplete: "new-password",
	    readOnly: props.readOnly,
	    maxlength: props.maxLength
	  }), /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon close-circle ".concat(isEmpty && !props.onClose ? 'hide' : ''),
	    onClick: function onClick() {
	      if (isEmpty) {
	        props.onClose();
	      }
	
	      inputRef.current.focus();
	      setState('');
	    }
	  }));
	};
	
	FilterInput.propTypes = {
	  disabled: _propTypes["default"].bool,
	  value: _propTypes["default"].string,
	  //initialInput Value
	  data: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].array]),
	  filterBy: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array]),
	  //nombre de la(s) propiedade(s) a buscar
	  customFilter: _propTypes["default"].bool,
	  //true &&  onchange = inputValue
	  ignoreCase: _propTypes["default"].bool,
	  keyResult: _propTypes["default"].string,
	  //solo cuando es diccionario
	  color: _propTypes["default"].oneOf(['primary', 'secondary', 'tertiary']),
	  className: _propTypes["default"].string,
	  placeholder: _propTypes["default"].string,
	  numeric: _propTypes["default"].bool,
	  readOnly: _propTypes["default"].bool,
	  maxLength: _propTypes["default"].number
	};
	FilterInput.defaultProps = {
	  disabled: false,
	  value: '',
	  data: [],
	  customFilter: false,
	  keyResult: 'key',
	  filterBy: '',
	  color: 'primary',
	  className: '',
	  placeholder: '',
	  maxLength: 255
	};
	var _default = FilterInput;
	exports["default"] = _default;

/***/ },
/* 697 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _OutsideClickWrapper = _interopRequireDefault(__webpack_require__(219));
	
	var _reactstrap = __webpack_require__(48);
	
	__webpack_require__(2559);
	
	__webpack_require__(2560);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var LabelInput = function LabelInput(props) {
	  var _useState = (0, _react.useState)(props.value),
	      _useState2 = _slicedToArray(_useState, 2),
	      value = _useState2[0],
	      setValue = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      focus = _useState4[0],
	      setOnFocus = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      removeErrorOnEmpty = _useState6[0],
	      setRemoveErrorOnEmpty = _useState6[1];
	
	  var inputRef = (0, _react.useRef)(null);
	
	  var _useState7 = (0, _react.useState)(false),
	      _useState8 = _slicedToArray(_useState7, 2),
	      showPassword = _useState8[0],
	      setShowPassword = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(props.rows),
	      _useState10 = _slicedToArray(_useState9, 2),
	      rows = _useState10[0],
	      setRows = _useState10[1];
	
	  (0, _react.useEffect)(function () {
	    if (props.value === '') {
	      setRemoveErrorOnEmpty(true);
	    } else {
	      setRemoveErrorOnEmpty(false);
	    }
	
	    setValue(props.value);
	  }, [props.value]);
	
	  var onChange = function onChange(e) {
	    props.focus && setOnFocus(true);
	    var inputValue = e.target.value;
	    inputValue === '' ? setRemoveErrorOnEmpty(true) : setRemoveErrorOnEmpty(false);
	
	    if (props.maxLength) {
	      if (e.target.value.length <= e.target.maxLength) {
	        setValue(inputValue);
	        props.onChange(inputValue);
	      }
	    } else {
	      setValue(inputValue);
	      props.onChange(inputValue);
	    }
	  };
	
	  var onAutosize = function onAutosize(e) {
	    var textareaLineHeight = props.withNumber ? 21 : 24;
	    var previousRows = e.target.rows;
	    e.target.rows = props.rows;
	    var currentRows = ~~(e.target.scrollHeight / textareaLineHeight);
	
	    if (currentRows === previousRows) {
	      e.target.rows = currentRows;
	    }
	
	    if (currentRows >= props.maxRows) {
	      e.target.rows = props.maxRows;
	      if (previousRows !== props.maxRows) e.target.scrollTop = e.target.scrollHeight;
	    }
	
	    setRows(currentRows < props.maxRows ? currentRows : props.maxRows);
	  };
	
	  var onChangeMultiline = function onChangeMultiline(e) {
	    props.focus && setOnFocus(true);
	    var inputValue = e.target.value;
	    inputValue === '' ? setRemoveErrorOnEmpty(true) : setRemoveErrorOnEmpty(false);
	
	    if (props.maxLength) {
	      if (e.target.value.length <= e.target.maxLength) {
	        setValue(inputValue);
	        props.onChange(inputValue);
	      }
	    } else {
	      setValue(inputValue);
	      props.onChange(inputValue);
	    }
	
	    onAutosize(e);
	  };
	
	  var onClick = function onClick() {
	    inputRef.current.focus(); // props.focus && setOnFocus(true);
	  };
	
	  var onValidate = function onValidate(e) {
	    setOnFocus(false);
	
	    if (props.onValidate) {
	      var inputValue = e.target.value;
	      props.onValidate(inputValue);
	    }
	  };
	
	  var onKeyDown = function onKeyDown(e) {
	    var regex = new RegExp('^[Ññíóáéú a-zA-Z 0-9_-]+$');
	
	    if (e.key.toUpperCase() === 'ENTER') {
	      props.onEnter();
	    }
	
	    if (props.onlyAlphanumeric && !regex.test(e.key)) e.preventDefault();
	    if (props.onlyNumbers && !['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(e.key)) e.preventDefault();
	  };
	
	  var tooltipRef = (0, _react.useRef)();
	  return /*#__PURE__*/_react["default"].createElement(_OutsideClickWrapper["default"], {
	    action: function action() {
	      return setOnFocus(false);
	    },
	    className: "gcl-label-input-wrapper"
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "glc-labelInput ".concat(props.disabled ? 'disabled' : '', " ").concat(value.length <= 0 ? 'empty' : '', " ").concat(focus ? 'focused' : '', " ").concat(props.error && !removeErrorOnEmpty ? 'error' : '', " ").concat(props.multiline ? 'multiline' : '', " ").concat(props.withNumber ? 'withNumber' : '', " ").concat(props.className),
	    onClick: onClick,
	    ref: tooltipRef
	  }, props.numberInput && /*#__PURE__*/_react["default"].createElement("div", {
	    className: "containerNumber"
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "inputNumberContainer"
	  }, props.numberInput), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "lineContainerNumber"
	  })), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "glc-labelInput-input-wrapper"
	  }, (value.length > 0 || value === 0 || value !== '' || focus) && /*#__PURE__*/_react["default"].createElement("div", {
	    className: "inputTitle ".concat(props.withNumber ? 'withNumber' : '')
	  }, /*#__PURE__*/_react["default"].createElement("span", null, props.label), props.required && /*#__PURE__*/_react["default"].createElement("span", {
	    className: "required"
	  }, "*")), props.multiline ? /*#__PURE__*/_react["default"].createElement("textarea", {
	    rows: rows,
	    type: props.password && !showPassword ? 'password' : props.onlyNumbers ? 'number' : 'text',
	    tabIndex: props.tabIndex,
	    ref: inputRef,
	    className: "".concat(props.focus ? 'gcl-labelInput-span-focus' : '', " ").concat(props.withNumber ? 'multiline-textareaWithNumber' : '', " multiline-textarea"),
	    placeholder: !props.required && !focus ? props.placeholder : undefined,
	    onChange: !props.disabled ? onChangeMultiline : undefined,
	    value: value,
	    required: props.required,
	    disabled: props.disabled,
	    min: props.minValue,
	    maxLength: props.maxLength,
	    onFocus: props.focus ? function () {
	      return setOnFocus(true);
	    } : undefined,
	    onBlur: function onBlur(e) {
	      return onValidate(e);
	    },
	    onKeyDown: props.onlyNumbers ? onKeyDown : undefined,
	    onClick: function onClick(e) {
	      return onAutosize(e);
	    }
	  }) : /*#__PURE__*/_react["default"].createElement("input", {
	    type: props.password && !showPassword ? 'password' : props.onlyNumbers ? 'number' : 'text',
	    autoComplete: props.noAutofill ? 'new-password' : undefined,
	    tabIndex: props.tabIndex,
	    ref: inputRef,
	    className: props.focus ? 'gcl-labelInput-span-focus' : '',
	    placeholder: !props.required && !focus ? props.placeholder : undefined,
	    onChange: !props.disabled && onChange,
	    value: value,
	    required: props.required,
	    disabled: props.disabled,
	    min: props.minValue,
	    maxLength: props.maxLength,
	    onFocus: props.focus ? function () {
	      return setOnFocus(true);
	    } : undefined,
	    onBlur: function onBlur(e) {
	      return onValidate(e);
	    },
	    onKeyDown: props.onlyNumbers || props.onlyAlphanumeric ? onKeyDown : undefined
	  }), props.required && !focus && value.length === 0 && /*#__PURE__*/_react["default"].createElement("label", {
	    className: 'labelRequired' + (props.password ? ' withPassword' : '')
	  }, props.placeholder, /*#__PURE__*/_react["default"].createElement("span", {
	    className: "required"
	  }, "*"))), props.error && !props.tooltipInfo && !props.password && !removeErrorOnEmpty && !props.customIcon && /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon close",
	    onClick: function onClick() {
	      setValue('');
	      setRemoveErrorOnEmpty(true);
	    }
	  }), props.tooltipInfo && /*#__PURE__*/_react["default"].createElement("i", {
	    className: props.error && !removeErrorOnEmpty ? "gcl-icon exclamation" : "gcl-icon info ".concat(value.length > 0 ? 'iconWithText' : ''),
	    id: props.idTooltip
	  }, /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
	    placement: "bottom-end",
	    target: props.idTooltip,
	    hideArrow: true,
	    className: "gcl-labelInput-tooltip"
	  }, props.tooltipInfoMessage)), props.customIcon && /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-labelInput__custom_icon gcl-icon ".concat(props.customIcon, " ").concat(value.length > 0 ? 'iconWithText' : '')
	  }), props.password && /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon ".concat(showPassword ? 'show' : 'not-show-pass', " ").concat(value.length > 0 ? 'iconWithText' : '', " ").concat(props.error && !removeErrorOnEmpty ? 'error' : ''),
	    onMouseDown: function onMouseDown() {
	      setShowPassword(!showPassword);
	    },
	    onMouseUp: function onMouseUp() {
	      setShowPassword(!showPassword);
	    },
	    onMouseOut: function onMouseOut() {
	      setShowPassword(false);
	    }
	  })), props.error && props.errorMessage && !removeErrorOnEmpty && /*#__PURE__*/_react["default"].createElement("span", {
	    className: "gcl-labelInput-error"
	  }, props.errorMessage), props.tooltip != null && /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
	    placement: "top",
	    target: tooltipRef,
	    trigger: 'hover',
	    boundariesElement: "window"
	  }, props.tooltip));
	};
	
	LabelInput.propTypes = {
	  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  //initialInput Value
	  className: _propTypes["default"].string,
	  placeholder: _propTypes["default"].string,
	  label: _propTypes["default"].string,
	  error: _propTypes["default"].bool,
	  errorMessage: _propTypes["default"].string,
	  idTooltip: _propTypes["default"].string,
	  tooltipInfo: _propTypes["default"].bool,
	  tooltipInfoMessage: _propTypes["default"].string,
	  tooltip: _propTypes["default"].string,
	  password: _propTypes["default"].bool,
	  focus: _propTypes["default"].bool,
	  onChange: _propTypes["default"].func.isRequired,
	  tabIndex: _propTypes["default"].number,
	  disabled: _propTypes["default"].bool,
	  onlyNumbers: _propTypes["default"].bool,
	  minValue: _propTypes["default"].string,
	  onkeydown: _propTypes["default"].string,
	  multiline: _propTypes["default"].bool,
	  rows: _propTypes["default"].number,
	  maxRows: _propTypes["default"].number,
	  maxLength: _propTypes["default"].number,
	  noAutofill: _propTypes["default"].bool,
	  withNumber: _propTypes["default"].bool,
	  numberInput: _propTypes["default"].number
	};
	LabelInput.defaultProps = {
	  value: '',
	  className: '',
	  placeholder: '',
	  label: '',
	  error: false,
	  idTooltip: 'idTooltipDefault',
	  tooltipInfo: false,
	  password: false,
	  focus: false,
	  disabled: false,
	  rows: 1,
	  maxRows: 5,
	  onChange: function onChange() {},
	  onValidate: function onValidate() {}
	};
	var _default = LabelInput;
	exports["default"] = _default;

/***/ },
/* 698 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.ListItem = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _reactstrap = __webpack_require__(48);
	
	__webpack_require__(2562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var ListDropDown = function ListDropDown(_ref) {
	  var target = _ref.target,
	      isOpen = _ref.isOpen,
	      toggle = _ref.toggle,
	      children = _ref.children;
	  return /*#__PURE__*/_react["default"].createElement(_reactstrap.Popover, {
	    target: target,
	    isOpen: isOpen,
	    toggle: toggle,
	    placement: "bottom-start",
	    hideArrow: true,
	    trigger: "legacy",
	    popperClassName: "gcl-list-dropdown"
	  }, /*#__PURE__*/_react["default"].createElement(_reactstrap.PopoverBody, {
	    className: "gcl-ldd-menu-container"
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-ldd-menu-wrap"
	  }, children)));
	};
	
	var ListItem = function ListItem(_ref2) {
	  var onClick = _ref2.onClick,
	      username = _ref2.username,
	      extraUserInfo = _ref2.extraUserInfo,
	      icon = _ref2.icon,
	      focused = _ref2.focused,
	      onFocus = _ref2.onFocus;
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: 'gcl-ldd-option' + (focused ? ' focused' : ''),
	    onClick: onClick,
	    onMouseOver: onFocus
	  }, icon && /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-ldd-icon-wrapper"
	  }, /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon ".concat(icon)
	  })), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-ldd-useinfo-wrapper"
	  }, username && /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-ldd-username"
	  }, username), extraUserInfo && /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-ldd-extraUserInfo"
	  }, extraUserInfo)));
	};
	
	exports.ListItem = ListItem;
	ListDropDown.propTypes = {
	  target: _propTypes["default"].string.isRequired,
	  isOpen: _propTypes["default"].bool.isRequired,
	  toggle: _propTypes["default"].func.isRequired
	};
	var _default = ListDropDown;
	exports["default"] = _default;

/***/ },
/* 699 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _reactstrap = __webpack_require__(48);
	
	__webpack_require__(2567);
	
	var _excluded = ["onChange"];
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var RadioButton = function RadioButton(_ref) {
	  var onChange = _ref.onChange,
	      props = _objectWithoutProperties(_ref, _excluded);
	
	  var changeHandler = function changeHandler(e) {
	    var val = e.target.value;
	    if (isNaN(val)) onChange(val);else onChange(parseInt(val, 10));
	  };
	
	  return /*#__PURE__*/_react["default"].createElement(_reactstrap.CustomInput, _extends({
	    className: "gcl-radio-btn",
	    type: "radio",
	    onChange: changeHandler
	  }, props));
	};
	
	RadioButton.propTypes = {
	  id: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired,
	  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired,
	  label: _propTypes["default"].string,
	  name: _propTypes["default"].string,
	  disabled: _propTypes["default"].bool,
	  onChange: _propTypes["default"].func.isRequired
	};
	var _default = RadioButton;
	exports["default"] = _default;

/***/ },
/* 700 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _helpers = __webpack_require__(176);
	
	var _classNames = _interopRequireDefault(__webpack_require__(61));
	
	__webpack_require__(2579);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var Slider = function Slider(_ref) {
	  var value = _ref.value,
	      onChange = _ref.onChange,
	      vertical = _ref.vertical,
	      min = _ref.min,
	      max = _ref.max,
	      disabled = _ref.disabled;
	
	  var range = function range() {
	    return Array.isArray(value);
	  };
	
	  var getMin = function getMin() {
	    return min || 0;
	  };
	
	  var getMax = function getMax() {
	    return max || 100;
	  };
	
	  var getRange = function getRange() {
	    return getMax() - getMin();
	  };
	
	  var _useState = (0, _react.useState)(range() ? Math.floor((value[0] + value[1]) / 2) : null),
	      _useState2 = _slicedToArray(_useState, 2),
	      pivot = _useState2[0],
	      setPivot = _useState2[1];
	
	  (0, _react.useEffect)(function () {
	    if (Array.isArray(value)) {
	      setPivot(Math.floor((value[0] + value[1]) / 2));
	    }
	  }, [value, min, max]);
	
	  var onChangeHandler = function onChangeHandler(e) {
	    return onChange(parseInt(e.currentTarget.value, 10));
	  };
	
	  var fillStyle = function fillStyle() {
	    if (range()) {
	      return {
	        left: (value[0] - getMin()) / getRange() * 100 + '%',
	        right: (getMax() - value[1]) / getRange() * 100 + '%'
	      };
	    } else {
	      if (vertical) return {
	        height: value + '%'
	      };else return {
	        width: value + '%'
	      };
	    }
	  };
	
	  var magic = function magic(_ref2) {
	    var target = _ref2.currentTarget;
	    var newValue = parseInt(target.value, 10);
	
	    if (target.name === 'a-slider') {
	      // setPivot(Math.min(Math.ceil((newValue + value[1]) / 2), value[1] - 1));
	      setPivot(Math.floor((value[0] + value[1]) / 2));
	      onChange((0, _helpers.updateArrayImmutably)(value, 0, newValue));
	    }
	
	    if (target.name === 'b-slider') {
	      // setPivot(Math.max(Math.floor((newValue + value[0]) / 2), value[0] + 1));
	      setPivot(Math.floor((value[0] + value[1]) / 2));
	      onChange((0, _helpers.updateArrayImmutably)(value, 1, newValue));
	    }
	  };
	
	  var classes = (0, _classNames["default"])({
	    vertical: vertical,
	    range: range(),
	    disabled: disabled
	  });
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: "sb-slider ".concat(classes)
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "bar"
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "fill",
	    style: fillStyle()
	  })), range() ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("input", {
	    disabled: disabled,
	    name: "a-slider",
	    type: "range",
	    min: getMin(),
	    max: pivot,
	    value: value[0],
	    style: {
	      width: (pivot - getMin()) / getRange() * 100 + '%'
	    },
	    onChange: magic
	  }), /*#__PURE__*/_react["default"].createElement("input", {
	    disabled: disabled,
	    name: "b-slider",
	    type: "range",
	    min: pivot,
	    max: getMax(),
	    value: value[1],
	    style: {
	      width: (getMax() - pivot) / getRange() * 100 + '%'
	    },
	    onChange: magic
	  })) : /*#__PURE__*/_react["default"].createElement("input", {
	    disabled: disabled,
	    type: "range",
	    min: getMin(),
	    max: getMax(),
	    value: value,
	    onChange: onChangeHandler
	  }));
	};
	
	Slider.propTypes = {
	  value: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].arrayOf(_propTypes["default"].number)]).isRequired,
	  onChange: _propTypes["default"].func.isRequired,
	  vertical: _propTypes["default"].bool,
	  min: _propTypes["default"].number,
	  max: _propTypes["default"].number,
	  disabled: _propTypes["default"].bool
	};
	var _default = Slider;
	exports["default"] = _default;

/***/ },
/* 701 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _dateFns = __webpack_require__(147);
	
	var _hooks = __webpack_require__(110);
	
	__webpack_require__(2588);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var showWith0 = function showWith0(value) {
	  return parseInt(value, 10) < 10 ? '0' + value : value.toString().slice(-2);
	};
	
	var LABELS = {
	  en: {
	    hours: 'Hours',
	    minutes: 'Minutes',
	    seconds: 'Seconds'
	  },
	  es: {
	    hours: 'Horas',
	    minutes: 'Minutos',
	    seconds: 'Segundos'
	  },
	  pt: {
	    hours: 'Horas',
	    minutes: 'Minutos',
	    seconds: 'Segundos'
	  }
	};
	
	var TimePicker = function TimePicker(_ref) {
	  var time = _ref.time,
	      onChange = _ref.onChange,
	      withSeconds = _ref.withSeconds,
	      label = _ref.label,
	      min = _ref.min,
	      max = _ref.max,
	      error = _ref.error,
	      lang = _ref.lang;
	
	  var _useState = (0, _react.useState)(null),
	      _useState2 = _slicedToArray(_useState, 2),
	      showHour = _useState2[0],
	      setShowHour = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(null),
	      _useState4 = _slicedToArray(_useState3, 2),
	      showMinute = _useState4[0],
	      setShowMinute = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(null),
	      _useState6 = _slicedToArray(_useState5, 2),
	      showSeconds = _useState6[0],
	      setShowSeconds = _useState6[1];
	
	  var formatHour = function formatHour(value) {
	    return showHour !== null ? '' + showHour : showWith0(value);
	  };
	
	  var formatMinutes = function formatMinutes(value) {
	    return showMinute !== null ? '' + showMinute : showWith0(value);
	  };
	
	  var formatSeconds = function formatSeconds(value) {
	    return showSeconds !== null ? '' + showSeconds : showWith0(value);
	  };
	
	  var showRealHour = function showRealHour() {
	    setShowHour(null);
	    setShowMinute(null);
	    setShowSeconds(null);
	    setFocused(null);
	  };
	
	  var _useState7 = (0, _react.useState)(null),
	      _useState8 = _slicedToArray(_useState7, 2),
	      focused = _useState8[0],
	      setFocused = _useState8[1];
	
	  var focusOnHours = function focusOnHours() {
	    return setFocused('HOURS');
	  };
	
	  var focusOnMinutes = function focusOnMinutes() {
	    return setFocused('MINUTES');
	  };
	
	  var focusOnSeconds = function focusOnSeconds() {
	    return setFocused('SECONDS');
	  };
	
	  var parentRef = (0, _react.useRef)(null);
	  (0, _hooks.useOutsideClick)(parentRef, function () {
	    return setFocused(null);
	  });
	
	  var limitedTime = function limitedTime(date) {
	    if (min && date < min) {
	      return setSecondsWrapper(min);
	    }
	
	    if (max && date > max) {
	      return setSecondsWrapper(max);
	    }
	
	    return setSecondsWrapper(date);
	  };
	
	  var setSecondsWrapper = function setSecondsWrapper(val) {
	    return withSeconds ? val : (0, _dateFns.setSeconds)(val, 0);
	  };
	
	  var hoursUp = function hoursUp() {
	    return onChange(limitedTime((0, _dateFns.addHours)(time || (0, _dateFns.startOfToday)(), 1)));
	  };
	
	  var hoursDown = function hoursDown() {
	    return onChange(limitedTime((0, _dateFns.subHours)(time || (0, _dateFns.startOfToday)(), 1)));
	  };
	
	  var minutesUp = function minutesUp() {
	    return onChange(limitedTime((0, _dateFns.addMinutes)(time || (0, _dateFns.startOfToday)(), 1)));
	  };
	
	  var minutesDown = function minutesDown() {
	    return onChange(limitedTime((0, _dateFns.subMinutes)(time || (0, _dateFns.startOfToday)(), 1)));
	  };
	
	  var secondsUp = function secondsUp() {
	    return onChange(limitedTime((0, _dateFns.addSeconds)(time || (0, _dateFns.startOfToday)(), 1)));
	  };
	
	  var secondsDown = function secondsDown() {
	    return onChange(limitedTime((0, _dateFns.subSeconds)(time || (0, _dateFns.startOfToday)(), 1)));
	  };
	
	  var handleHoursInputChange = function handleHoursInputChange(e) {
	    if (e.target.value) {
	      var value = parseInt(e.target.value, 10);
	      if (isNaN(value) || value < 0 || value > 23) return;
	      setShowHour(value <= 2 ? value : null);
	      onChange(limitedTime((0, _dateFns.setHours)(time || (0, _dateFns.startOfToday)(), value)));
	    } else {
	      setShowHour(0);
	      onChange(limitedTime(time ? (0, _dateFns.setHours)(time, 0) : (0, _dateFns.startOfToday)()));
	    }
	  };
	
	  var handleMinutesInputChange = function handleMinutesInputChange(e) {
	    if (e.target.value) {
	      var value = parseInt(e.target.value, 10);
	      if (isNaN(value) || value < 0 || value > 59) return;
	      var theTime = time || (0, _dateFns.startOfToday)();
	      setShowMinute(value === 0 || value === 1 || value <= 5 && Math.abs(theTime.getMinutes() - value) !== 1 ? value : null);
	      onChange(limitedTime((0, _dateFns.setMinutes)(theTime, value)));
	    } else {
	      setShowMinute(0);
	      onChange(limitedTime(time ? (0, _dateFns.setMinutes)(time, 0) : (0, _dateFns.startOfToday)()));
	    }
	  };
	
	  var handleSecondsInputChange = function handleSecondsInputChange(e) {
	    if (e.target.value) {
	      var value = parseInt(e.target.value, 10);
	      if (isNaN(value) || value < 0 || value > 59) return;
	      var theTime = time || (0, _dateFns.startOfToday)();
	      setShowSeconds(value === 0 || value === 1 || value <= 5 && Math.abs(theTime.getSeconds() - value) !== 1 ? value : null);
	      onChange(limitedTime((0, _dateFns.setSeconds)(theTime, value)));
	    } else {
	      setShowSeconds(0);
	      onChange(limitedTime(time ? (0, _dateFns.setSeconds)(time, 0) : (0, _dateFns.startOfToday)()));
	    }
	  };
	
	  var onHoursKeyDown = function onHoursKeyDown(e) {
	    if (e.keyCode === 38) {
	      //Arrow Up
	      hoursUp();
	      e.preventDefault();
	    } else if (e.keyCode === 40) {
	      //Arrow Down
	      hoursDown();
	      e.preventDefault();
	    }
	  };
	
	  var onMinutesKeyDown = function onMinutesKeyDown(e) {
	    if (e.keyCode === 38) {
	      //Arrow Up
	      minutesUp();
	      e.preventDefault();
	    } else if (e.keyCode === 40) {
	      //Arrow Down
	      minutesDown();
	      e.preventDefault();
	    }
	  };
	
	  var onSecondsKeyDown = function onSecondsKeyDown(e) {
	    if (e.keyCode === 38) {
	      //Arrow Up
	      secondsUp();
	      e.preventDefault();
	    } else if (e.keyCode === 40) {
	      //Arrow Down
	      secondsDown();
	      e.preventDefault();
	    }
	  };
	
	  var timeRef = (0, _hooks.useLatest)(time);
	  (0, _hooks.useUpdateEffect)(function () {
	    if (min && timeRef.current) {
	      if (timeRef.current < min) onChange(limitedTime(timeRef.current));
	    }
	  }, [min]);
	  (0, _hooks.useUpdateEffect)(function () {
	    if (max && timeRef.current) {
	      if (timeRef.current > max) onChange(limitedTime(timeRef.current));
	    }
	  }, [max]);
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: 'gcl-timepicker' + (error ? ' error' : ''),
	    ref: parentRef
	  }, label && /*#__PURE__*/_react["default"].createElement("span", {
	    className: "gcl-tp-label"
	  }, label), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-tp-container"
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: 'gcl-timepicker-select' + (focused === 'HOURS' ? ' focused' : '')
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-tp-input-container"
	  }, /*#__PURE__*/_react["default"].createElement("input", {
	    type: "text",
	    pattern: "[0-9]*",
	    className: "gcl-tp-input",
	    value: time ? formatHour(time.getHours()) : '00',
	    onChange: handleHoursInputChange,
	    onKeyDown: onHoursKeyDown,
	    onFocus: focusOnHours,
	    onBlur: showRealHour
	  }), /*#__PURE__*/_react["default"].createElement("span", null, LABELS[lang].hours)), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-tp-buttons"
	  }, /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon clickable chevron-up",
	    tabIndex: -1,
	    onClick: hoursUp,
	    onMouseDown: focusOnHours,
	    onFocus: focusOnHours,
	    onBlur: function onBlur() {
	      return setFocused(null);
	    }
	  }), /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon clickable chevron",
	    tabIndex: -1,
	    onClick: hoursDown,
	    onMouseDown: focusOnHours,
	    onFocus: focusOnHours,
	    onBlur: function onBlur() {
	      return setFocused(null);
	    }
	  }))), /*#__PURE__*/_react["default"].createElement("span", {
	    className: "gcl-tp-select-colon"
	  }, ":"), /*#__PURE__*/_react["default"].createElement("div", {
	    className: 'gcl-timepicker-select' + (focused === 'MINUTES' ? ' focused' : '')
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-tp-input-container"
	  }, /*#__PURE__*/_react["default"].createElement("input", {
	    type: "text",
	    pattern: "[0-9]*",
	    className: "gcl-tp-input",
	    value: time ? formatMinutes(time.getMinutes()) : '00',
	    onChange: handleMinutesInputChange,
	    onKeyDown: onMinutesKeyDown,
	    onFocus: focusOnMinutes,
	    onBlur: showRealHour
	  }), /*#__PURE__*/_react["default"].createElement("span", null, LABELS[lang].minutes)), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-tp-buttons"
	  }, /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon clickable chevron-up",
	    tabIndex: -1,
	    onClick: minutesUp,
	    onMouseDown: focusOnMinutes,
	    onFocus: focusOnMinutes,
	    onBlur: function onBlur() {
	      return setFocused(null);
	    }
	  }), /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon clickable chevron",
	    tabIndex: -1,
	    onClick: minutesDown,
	    onMouseDown: focusOnMinutes,
	    onFocus: focusOnMinutes,
	    onBlur: function onBlur() {
	      return setFocused(null);
	    }
	  }))), withSeconds && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
	    className: "gcl-tp-select-colon"
	  }, ":"), /*#__PURE__*/_react["default"].createElement("div", {
	    className: 'gcl-timepicker-select' + (focused === 'SECONDS' ? ' focused' : '')
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-tp-input-container"
	  }, /*#__PURE__*/_react["default"].createElement("input", {
	    type: "text",
	    pattern: "[0-9]*",
	    className: "gcl-tp-input",
	    value: time ? formatSeconds(time.getSeconds()) : '00',
	    onChange: handleSecondsInputChange,
	    onKeyDown: onSecondsKeyDown,
	    onFocus: focusOnSeconds,
	    onBlur: showRealHour
	  }), /*#__PURE__*/_react["default"].createElement("span", null, LABELS[lang].seconds)), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-tp-buttons"
	  }, /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon clickable chevron-up",
	    tabIndex: -1,
	    onClick: secondsUp,
	    onMouseDown: focusOnSeconds,
	    onFocus: focusOnSeconds,
	    onBlur: function onBlur() {
	      return setFocused(null);
	    }
	  }), /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon clickable chevron",
	    tabIndex: -1,
	    onClick: secondsDown,
	    onMouseDown: focusOnSeconds,
	    onFocus: focusOnSeconds,
	    onBlur: function onBlur() {
	      return setFocused(null);
	    }
	  }))))));
	};
	
	TimePicker.propTypes = {
	  time: _propTypes["default"].instanceOf(Date),
	  onChange: _propTypes["default"].func.isRequired,
	  withSeconds: _propTypes["default"].bool,
	  min: _propTypes["default"].instanceOf(Date),
	  max: _propTypes["default"].instanceOf(Date),
	  error: _propTypes["default"].bool,
	  lang: _propTypes["default"].oneOf(['en', 'es', 'pt']).isRequired
	};
	TimePicker.defaultProps = {
	  lang: 'en'
	};
	var _default = TimePicker;
	exports["default"] = _default;

/***/ },
/* 702 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _hooks = __webpack_require__(424);
	
	__webpack_require__(2591);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var Toast = function Toast(_ref) {
	  var type = _ref.type,
	      from = _ref.from,
	      account = _ref.account,
	      message = _ref.message,
	      onDismiss = _ref.onDismiss,
	      onClose = _ref.onClose,
	      timeout = _ref.timeout;
	
	  var _useOpenAndDismiss = (0, _hooks.useOpenAndDismiss)(onClose, onDismiss, timeout),
	      _useOpenAndDismiss2 = _slicedToArray(_useOpenAndDismiss, 1),
	      isOpen = _useOpenAndDismiss2[0];
	
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: 'gcl-toast-wrapper' + (isOpen ? ' open' : '')
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-toast"
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-toast-progress"
	  }), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-toast-icon"
	  }, /*#__PURE__*/_react["default"].createElement("i", {
	    className: 'gcl-icon new-' + type
	  })), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-toast-body"
	  }, /*#__PURE__*/_react["default"].createElement("p", {
	    className: "gcl-toast-title"
	  }, from), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-toast-info"
	  }, account && /*#__PURE__*/_react["default"].createElement("span", {
	    className: "gcl-toast-subtitle"
	  }, account), /*#__PURE__*/_react["default"].createElement("span", {
	    className: account ? undefined : 'multiline'
	  }, message)))));
	};
	
	Toast.propTypes = {
	  type: _propTypes["default"].oneOf(['tweet', 'chat', 'mail']).isRequired,
	  from: _propTypes["default"].string.isRequired,
	  account: _propTypes["default"].string,
	  message: _propTypes["default"].string.isRequired,
	  onDismiss: _propTypes["default"].func,
	  onClose: _propTypes["default"].func,
	  timeout: _propTypes["default"].number
	};
	Toast.defaultProps = {
	  timeout: 7500
	};
	var _default = Toast;
	exports["default"] = _default;

/***/ },
/* 703 */
[2678, 13, 221],
/* 704 */
[2683, 277],
/* 705 */
[2700, 429, 13],
/* 706 */
[2701, 13],
/* 707 */
[2702, 13],
/* 708 */
[2703, 13],
/* 709 */
[2706, 13],
/* 710 */
[2708, 13],
/* 711 */
[2723, 13],
/* 712 */
[2747, 716],
/* 713 */
[2750, 13, 221],
/* 714 */
611,
/* 715 */
[2762, 716],
/* 716 */
[2763, 713, 13],
/* 717 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(218);
	
	var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
	
	if ($gOPD) {
		try {
			$gOPD([], 'length');
		} catch (e) {
			// IE 8 has a broken gOPD
			$gOPD = null;
		}
	}
	
	module.exports = $gOPD;


/***/ },
/* 718 */
/***/ function(module, exports) {

	'use strict';
	
	/* eslint complexity: [2, 18], max-statements: [2, 33] */
	module.exports = function hasSymbols() {
		if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
		if (typeof Symbol.iterator === 'symbol') { return true; }
	
		var obj = {};
		var sym = Symbol('test');
		var symObj = Object(sym);
		if (typeof sym === 'string') { return false; }
	
		if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
		if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }
	
		// temp disabled per https://github.com/ljharb/object.assign/issues/17
		// if (sym instanceof Symbol) { return false; }
		// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
		// if (!(symObj instanceof Symbol)) { return false; }
	
		// if (typeof Symbol.prototype.toString !== 'function') { return false; }
		// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
	
		var symVal = 42;
		obj[sym] = symVal;
		for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
		if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }
	
		if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }
	
		var syms = Object.getOwnPropertySymbols(obj);
		if (syms.length !== 1 || syms[0] !== sym) { return false; }
	
		if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }
	
		if (typeof Object.getOwnPropertyDescriptor === 'function') {
			var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
			if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
		}
	
		return true;
	};


/***/ },
/* 719 */
/***/ function(module, exports, __webpack_require__) {

	var Tokenizer = __webpack_require__(720);
	
	/*
		Options:
	
		xmlMode: Disables the special behavior for script/style tags (false by default)
		lowerCaseAttributeNames: call .toLowerCase for each attribute name (true if xmlMode is `false`)
		lowerCaseTags: call .toLowerCase for each tag name (true if xmlMode is `false`)
	*/
	
	/*
		Callbacks:
	
		oncdataend,
		oncdatastart,
		onclosetag,
		oncomment,
		oncommentend,
		onerror,
		onopentag,
		onprocessinginstruction,
		onreset,
		ontext
	*/
	
	var formTags = {
	    input: true,
	    option: true,
	    optgroup: true,
	    select: true,
	    button: true,
	    datalist: true,
	    textarea: true
	};
	
	var openImpliesClose = {
	    tr: { tr: true, th: true, td: true },
	    th: { th: true },
	    td: { thead: true, th: true, td: true },
	    body: { head: true, link: true, script: true },
	    li: { li: true },
	    p: { p: true },
	    h1: { p: true },
	    h2: { p: true },
	    h3: { p: true },
	    h4: { p: true },
	    h5: { p: true },
	    h6: { p: true },
	    select: formTags,
	    input: formTags,
	    output: formTags,
	    button: formTags,
	    datalist: formTags,
	    textarea: formTags,
	    option: { option: true },
	    optgroup: { optgroup: true }
	};
	
	var voidElements = {
	    __proto__: null,
	    area: true,
	    base: true,
	    basefont: true,
	    br: true,
	    col: true,
	    command: true,
	    embed: true,
	    frame: true,
	    hr: true,
	    img: true,
	    input: true,
	    isindex: true,
	    keygen: true,
	    link: true,
	    meta: true,
	    param: true,
	    source: true,
	    track: true,
	    wbr: true
	};
	
	var foreignContextElements = {
	    __proto__: null,
	    math: true,
	    svg: true
	};
	var htmlIntegrationElements = {
	    __proto__: null,
	    mi: true,
	    mo: true,
	    mn: true,
	    ms: true,
	    mtext: true,
	    "annotation-xml": true,
	    foreignObject: true,
	    desc: true,
	    title: true
	};
	
	var re_nameEnd = /\s|\//;
	
	function Parser(cbs, options) {
	    this._options = options || {};
	    this._cbs = cbs || {};
	
	    this._tagname = "";
	    this._attribname = "";
	    this._attribvalue = "";
	    this._attribs = null;
	    this._stack = [];
	    this._foreignContext = [];
	
	    this.startIndex = 0;
	    this.endIndex = null;
	
	    this._lowerCaseTagNames =
	        "lowerCaseTags" in this._options
	            ? !!this._options.lowerCaseTags
	            : !this._options.xmlMode;
	    this._lowerCaseAttributeNames =
	        "lowerCaseAttributeNames" in this._options
	            ? !!this._options.lowerCaseAttributeNames
	            : !this._options.xmlMode;
	
	    if (this._options.Tokenizer) {
	        Tokenizer = this._options.Tokenizer;
	    }
	    this._tokenizer = new Tokenizer(this._options, this);
	
	    if (this._cbs.onparserinit) this._cbs.onparserinit(this);
	}
	
	__webpack_require__(278)(Parser, __webpack_require__(687).EventEmitter);
	
	Parser.prototype._updatePosition = function(initialOffset) {
	    if (this.endIndex === null) {
	        if (this._tokenizer._sectionStart <= initialOffset) {
	            this.startIndex = 0;
	        } else {
	            this.startIndex = this._tokenizer._sectionStart - initialOffset;
	        }
	    } else this.startIndex = this.endIndex + 1;
	    this.endIndex = this._tokenizer.getAbsoluteIndex();
	};
	
	//Tokenizer event handlers
	Parser.prototype.ontext = function(data) {
	    this._updatePosition(1);
	    this.endIndex--;
	
	    if (this._cbs.ontext) this._cbs.ontext(data);
	};
	
	Parser.prototype.onopentagname = function(name) {
	    if (this._lowerCaseTagNames) {
	        name = name.toLowerCase();
	    }
	
	    this._tagname = name;
	
	    if (!this._options.xmlMode && name in openImpliesClose) {
	        for (
	            var el;
	            (el = this._stack[this._stack.length - 1]) in
	            openImpliesClose[name];
	            this.onclosetag(el)
	        );
	    }
	
	    if (this._options.xmlMode || !(name in voidElements)) {
	        this._stack.push(name);
	        if (name in foreignContextElements) this._foreignContext.push(true);
	        else if (name in htmlIntegrationElements)
	            this._foreignContext.push(false);
	    }
	
	    if (this._cbs.onopentagname) this._cbs.onopentagname(name);
	    if (this._cbs.onopentag) this._attribs = {};
	};
	
	Parser.prototype.onopentagend = function() {
	    this._updatePosition(1);
	
	    if (this._attribs) {
	        if (this._cbs.onopentag)
	            this._cbs.onopentag(this._tagname, this._attribs);
	        this._attribs = null;
	    }
	
	    if (
	        !this._options.xmlMode &&
	        this._cbs.onclosetag &&
	        this._tagname in voidElements
	    ) {
	        this._cbs.onclosetag(this._tagname);
	    }
	
	    this._tagname = "";
	};
	
	Parser.prototype.onclosetag = function(name) {
	    this._updatePosition(1);
	
	    if (this._lowerCaseTagNames) {
	        name = name.toLowerCase();
	    }
	    
	    if (name in foreignContextElements || name in htmlIntegrationElements) {
	        this._foreignContext.pop();
	    }
	
	    if (
	        this._stack.length &&
	        (!(name in voidElements) || this._options.xmlMode)
	    ) {
	        var pos = this._stack.lastIndexOf(name);
	        if (pos !== -1) {
	            if (this._cbs.onclosetag) {
	                pos = this._stack.length - pos;
	                while (pos--) this._cbs.onclosetag(this._stack.pop());
	            } else this._stack.length = pos;
	        } else if (name === "p" && !this._options.xmlMode) {
	            this.onopentagname(name);
	            this._closeCurrentTag();
	        }
	    } else if (!this._options.xmlMode && (name === "br" || name === "p")) {
	        this.onopentagname(name);
	        this._closeCurrentTag();
	    }
	};
	
	Parser.prototype.onselfclosingtag = function() {
	    if (
	        this._options.xmlMode ||
	        this._options.recognizeSelfClosing ||
	        this._foreignContext[this._foreignContext.length - 1]
	    ) {
	        this._closeCurrentTag();
	    } else {
	        this.onopentagend();
	    }
	};
	
	Parser.prototype._closeCurrentTag = function() {
	    var name = this._tagname;
	
	    this.onopentagend();
	
	    //self-closing tags will be on the top of the stack
	    //(cheaper check than in onclosetag)
	    if (this._stack[this._stack.length - 1] === name) {
	        if (this._cbs.onclosetag) {
	            this._cbs.onclosetag(name);
	        }
	        this._stack.pop();
	        
	    }
	};
	
	Parser.prototype.onattribname = function(name) {
	    if (this._lowerCaseAttributeNames) {
	        name = name.toLowerCase();
	    }
	    this._attribname = name;
	};
	
	Parser.prototype.onattribdata = function(value) {
	    this._attribvalue += value;
	};
	
	Parser.prototype.onattribend = function() {
	    if (this._cbs.onattribute)
	        this._cbs.onattribute(this._attribname, this._attribvalue);
	    if (
	        this._attribs &&
	        !Object.prototype.hasOwnProperty.call(this._attribs, this._attribname)
	    ) {
	        this._attribs[this._attribname] = this._attribvalue;
	    }
	    this._attribname = "";
	    this._attribvalue = "";
	};
	
	Parser.prototype._getInstructionName = function(value) {
	    var idx = value.search(re_nameEnd),
	        name = idx < 0 ? value : value.substr(0, idx);
	
	    if (this._lowerCaseTagNames) {
	        name = name.toLowerCase();
	    }
	
	    return name;
	};
	
	Parser.prototype.ondeclaration = function(value) {
	    if (this._cbs.onprocessinginstruction) {
	        var name = this._getInstructionName(value);
	        this._cbs.onprocessinginstruction("!" + name, "!" + value);
	    }
	};
	
	Parser.prototype.onprocessinginstruction = function(value) {
	    if (this._cbs.onprocessinginstruction) {
	        var name = this._getInstructionName(value);
	        this._cbs.onprocessinginstruction("?" + name, "?" + value);
	    }
	};
	
	Parser.prototype.oncomment = function(value) {
	    this._updatePosition(4);
	
	    if (this._cbs.oncomment) this._cbs.oncomment(value);
	    if (this._cbs.oncommentend) this._cbs.oncommentend();
	};
	
	Parser.prototype.oncdata = function(value) {
	    this._updatePosition(1);
	
	    if (this._options.xmlMode || this._options.recognizeCDATA) {
	        if (this._cbs.oncdatastart) this._cbs.oncdatastart();
	        if (this._cbs.ontext) this._cbs.ontext(value);
	        if (this._cbs.oncdataend) this._cbs.oncdataend();
	    } else {
	        this.oncomment("[CDATA[" + value + "]]");
	    }
	};
	
	Parser.prototype.onerror = function(err) {
	    if (this._cbs.onerror) this._cbs.onerror(err);
	};
	
	Parser.prototype.onend = function() {
	    if (this._cbs.onclosetag) {
	        for (
	            var i = this._stack.length;
	            i > 0;
	            this._cbs.onclosetag(this._stack[--i])
	        );
	    }
	    if (this._cbs.onend) this._cbs.onend();
	};
	
	//Resets the parser to a blank state, ready to parse a new HTML document
	Parser.prototype.reset = function() {
	    if (this._cbs.onreset) this._cbs.onreset();
	    this._tokenizer.reset();
	
	    this._tagname = "";
	    this._attribname = "";
	    this._attribs = null;
	    this._stack = [];
	
	    if (this._cbs.onparserinit) this._cbs.onparserinit(this);
	};
	
	//Parses a complete HTML document and pushes it to the handler
	Parser.prototype.parseComplete = function(data) {
	    this.reset();
	    this.end(data);
	};
	
	Parser.prototype.write = function(chunk) {
	    this._tokenizer.write(chunk);
	};
	
	Parser.prototype.end = function(chunk) {
	    this._tokenizer.end(chunk);
	};
	
	Parser.prototype.pause = function() {
	    this._tokenizer.pause();
	};
	
	Parser.prototype.resume = function() {
	    this._tokenizer.resume();
	};
	
	//alias for backwards compat
	Parser.prototype.parseChunk = Parser.prototype.write;
	Parser.prototype.done = Parser.prototype.end;
	
	module.exports = Parser;


/***/ },
/* 720 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = Tokenizer;
	
	var decodeCodePoint = __webpack_require__(1717);
	var entityMap = __webpack_require__(2047);
	var legacyMap = __webpack_require__(2048);
	var xmlMap = __webpack_require__(2049);
	
	var i = 0;
	
	var TEXT = i++;
	var BEFORE_TAG_NAME = i++; //after <
	var IN_TAG_NAME = i++;
	var IN_SELF_CLOSING_TAG = i++;
	var BEFORE_CLOSING_TAG_NAME = i++;
	var IN_CLOSING_TAG_NAME = i++;
	var AFTER_CLOSING_TAG_NAME = i++;
	
	//attributes
	var BEFORE_ATTRIBUTE_NAME = i++;
	var IN_ATTRIBUTE_NAME = i++;
	var AFTER_ATTRIBUTE_NAME = i++;
	var BEFORE_ATTRIBUTE_VALUE = i++;
	var IN_ATTRIBUTE_VALUE_DQ = i++; // "
	var IN_ATTRIBUTE_VALUE_SQ = i++; // '
	var IN_ATTRIBUTE_VALUE_NQ = i++;
	
	//declarations
	var BEFORE_DECLARATION = i++; // !
	var IN_DECLARATION = i++;
	
	//processing instructions
	var IN_PROCESSING_INSTRUCTION = i++; // ?
	
	//comments
	var BEFORE_COMMENT = i++;
	var IN_COMMENT = i++;
	var AFTER_COMMENT_1 = i++;
	var AFTER_COMMENT_2 = i++;
	
	//cdata
	var BEFORE_CDATA_1 = i++; // [
	var BEFORE_CDATA_2 = i++; // C
	var BEFORE_CDATA_3 = i++; // D
	var BEFORE_CDATA_4 = i++; // A
	var BEFORE_CDATA_5 = i++; // T
	var BEFORE_CDATA_6 = i++; // A
	var IN_CDATA = i++; // [
	var AFTER_CDATA_1 = i++; // ]
	var AFTER_CDATA_2 = i++; // ]
	
	//special tags
	var BEFORE_SPECIAL = i++; //S
	var BEFORE_SPECIAL_END = i++; //S
	
	var BEFORE_SCRIPT_1 = i++; //C
	var BEFORE_SCRIPT_2 = i++; //R
	var BEFORE_SCRIPT_3 = i++; //I
	var BEFORE_SCRIPT_4 = i++; //P
	var BEFORE_SCRIPT_5 = i++; //T
	var AFTER_SCRIPT_1 = i++; //C
	var AFTER_SCRIPT_2 = i++; //R
	var AFTER_SCRIPT_3 = i++; //I
	var AFTER_SCRIPT_4 = i++; //P
	var AFTER_SCRIPT_5 = i++; //T
	
	var BEFORE_STYLE_1 = i++; //T
	var BEFORE_STYLE_2 = i++; //Y
	var BEFORE_STYLE_3 = i++; //L
	var BEFORE_STYLE_4 = i++; //E
	var AFTER_STYLE_1 = i++; //T
	var AFTER_STYLE_2 = i++; //Y
	var AFTER_STYLE_3 = i++; //L
	var AFTER_STYLE_4 = i++; //E
	
	var BEFORE_ENTITY = i++; //&
	var BEFORE_NUMERIC_ENTITY = i++; //#
	var IN_NAMED_ENTITY = i++;
	var IN_NUMERIC_ENTITY = i++;
	var IN_HEX_ENTITY = i++; //X
	
	var j = 0;
	
	var SPECIAL_NONE = j++;
	var SPECIAL_SCRIPT = j++;
	var SPECIAL_STYLE = j++;
	
	function whitespace(c) {
	    return c === " " || c === "\n" || c === "\t" || c === "\f" || c === "\r";
	}
	
	function ifElseState(upper, SUCCESS, FAILURE) {
	    var lower = upper.toLowerCase();
	
	    if (upper === lower) {
	        return function(c) {
	            if (c === lower) {
	                this._state = SUCCESS;
	            } else {
	                this._state = FAILURE;
	                this._index--;
	            }
	        };
	    } else {
	        return function(c) {
	            if (c === lower || c === upper) {
	                this._state = SUCCESS;
	            } else {
	                this._state = FAILURE;
	                this._index--;
	            }
	        };
	    }
	}
	
	function consumeSpecialNameChar(upper, NEXT_STATE) {
	    var lower = upper.toLowerCase();
	
	    return function(c) {
	        if (c === lower || c === upper) {
	            this._state = NEXT_STATE;
	        } else {
	            this._state = IN_TAG_NAME;
	            this._index--; //consume the token again
	        }
	    };
	}
	
	function Tokenizer(options, cbs) {
	    this._state = TEXT;
	    this._buffer = "";
	    this._sectionStart = 0;
	    this._index = 0;
	    this._bufferOffset = 0; //chars removed from _buffer
	    this._baseState = TEXT;
	    this._special = SPECIAL_NONE;
	    this._cbs = cbs;
	    this._running = true;
	    this._ended = false;
	    this._xmlMode = !!(options && options.xmlMode);
	    this._decodeEntities = !!(options && options.decodeEntities);
	}
	
	Tokenizer.prototype._stateText = function(c) {
	    if (c === "<") {
	        if (this._index > this._sectionStart) {
	            this._cbs.ontext(this._getSection());
	        }
	        this._state = BEFORE_TAG_NAME;
	        this._sectionStart = this._index;
	    } else if (
	        this._decodeEntities &&
	        this._special === SPECIAL_NONE &&
	        c === "&"
	    ) {
	        if (this._index > this._sectionStart) {
	            this._cbs.ontext(this._getSection());
	        }
	        this._baseState = TEXT;
	        this._state = BEFORE_ENTITY;
	        this._sectionStart = this._index;
	    }
	};
	
	Tokenizer.prototype._stateBeforeTagName = function(c) {
	    if (c === "/") {
	        this._state = BEFORE_CLOSING_TAG_NAME;
	    } else if (c === "<") {
	        this._cbs.ontext(this._getSection());
	        this._sectionStart = this._index;
	    } else if (c === ">" || this._special !== SPECIAL_NONE || whitespace(c)) {
	        this._state = TEXT;
	    } else if (c === "!") {
	        this._state = BEFORE_DECLARATION;
	        this._sectionStart = this._index + 1;
	    } else if (c === "?") {
	        this._state = IN_PROCESSING_INSTRUCTION;
	        this._sectionStart = this._index + 1;
	    } else {
	        this._state =
	            !this._xmlMode && (c === "s" || c === "S")
	                ? BEFORE_SPECIAL
	                : IN_TAG_NAME;
	        this._sectionStart = this._index;
	    }
	};
	
	Tokenizer.prototype._stateInTagName = function(c) {
	    if (c === "/" || c === ">" || whitespace(c)) {
	        this._emitToken("onopentagname");
	        this._state = BEFORE_ATTRIBUTE_NAME;
	        this._index--;
	    }
	};
	
	Tokenizer.prototype._stateBeforeCloseingTagName = function(c) {
	    if (whitespace(c));
	    else if (c === ">") {
	        this._state = TEXT;
	    } else if (this._special !== SPECIAL_NONE) {
	        if (c === "s" || c === "S") {
	            this._state = BEFORE_SPECIAL_END;
	        } else {
	            this._state = TEXT;
	            this._index--;
	        }
	    } else {
	        this._state = IN_CLOSING_TAG_NAME;
	        this._sectionStart = this._index;
	    }
	};
	
	Tokenizer.prototype._stateInCloseingTagName = function(c) {
	    if (c === ">" || whitespace(c)) {
	        this._emitToken("onclosetag");
	        this._state = AFTER_CLOSING_TAG_NAME;
	        this._index--;
	    }
	};
	
	Tokenizer.prototype._stateAfterCloseingTagName = function(c) {
	    //skip everything until ">"
	    if (c === ">") {
	        this._state = TEXT;
	        this._sectionStart = this._index + 1;
	    }
	};
	
	Tokenizer.prototype._stateBeforeAttributeName = function(c) {
	    if (c === ">") {
	        this._cbs.onopentagend();
	        this._state = TEXT;
	        this._sectionStart = this._index + 1;
	    } else if (c === "/") {
	        this._state = IN_SELF_CLOSING_TAG;
	    } else if (!whitespace(c)) {
	        this._state = IN_ATTRIBUTE_NAME;
	        this._sectionStart = this._index;
	    }
	};
	
	Tokenizer.prototype._stateInSelfClosingTag = function(c) {
	    if (c === ">") {
	        this._cbs.onselfclosingtag();
	        this._state = TEXT;
	        this._sectionStart = this._index + 1;
	    } else if (!whitespace(c)) {
	        this._state = BEFORE_ATTRIBUTE_NAME;
	        this._index--;
	    }
	};
	
	Tokenizer.prototype._stateInAttributeName = function(c) {
	    if (c === "=" || c === "/" || c === ">" || whitespace(c)) {
	        this._cbs.onattribname(this._getSection());
	        this._sectionStart = -1;
	        this._state = AFTER_ATTRIBUTE_NAME;
	        this._index--;
	    }
	};
	
	Tokenizer.prototype._stateAfterAttributeName = function(c) {
	    if (c === "=") {
	        this._state = BEFORE_ATTRIBUTE_VALUE;
	    } else if (c === "/" || c === ">") {
	        this._cbs.onattribend();
	        this._state = BEFORE_ATTRIBUTE_NAME;
	        this._index--;
	    } else if (!whitespace(c)) {
	        this._cbs.onattribend();
	        this._state = IN_ATTRIBUTE_NAME;
	        this._sectionStart = this._index;
	    }
	};
	
	Tokenizer.prototype._stateBeforeAttributeValue = function(c) {
	    if (c === '"') {
	        this._state = IN_ATTRIBUTE_VALUE_DQ;
	        this._sectionStart = this._index + 1;
	    } else if (c === "'") {
	        this._state = IN_ATTRIBUTE_VALUE_SQ;
	        this._sectionStart = this._index + 1;
	    } else if (!whitespace(c)) {
	        this._state = IN_ATTRIBUTE_VALUE_NQ;
	        this._sectionStart = this._index;
	        this._index--; //reconsume token
	    }
	};
	
	Tokenizer.prototype._stateInAttributeValueDoubleQuotes = function(c) {
	    if (c === '"') {
	        this._emitToken("onattribdata");
	        this._cbs.onattribend();
	        this._state = BEFORE_ATTRIBUTE_NAME;
	    } else if (this._decodeEntities && c === "&") {
	        this._emitToken("onattribdata");
	        this._baseState = this._state;
	        this._state = BEFORE_ENTITY;
	        this._sectionStart = this._index;
	    }
	};
	
	Tokenizer.prototype._stateInAttributeValueSingleQuotes = function(c) {
	    if (c === "'") {
	        this._emitToken("onattribdata");
	        this._cbs.onattribend();
	        this._state = BEFORE_ATTRIBUTE_NAME;
	    } else if (this._decodeEntities && c === "&") {
	        this._emitToken("onattribdata");
	        this._baseState = this._state;
	        this._state = BEFORE_ENTITY;
	        this._sectionStart = this._index;
	    }
	};
	
	Tokenizer.prototype._stateInAttributeValueNoQuotes = function(c) {
	    if (whitespace(c) || c === ">") {
	        this._emitToken("onattribdata");
	        this._cbs.onattribend();
	        this._state = BEFORE_ATTRIBUTE_NAME;
	        this._index--;
	    } else if (this._decodeEntities && c === "&") {
	        this._emitToken("onattribdata");
	        this._baseState = this._state;
	        this._state = BEFORE_ENTITY;
	        this._sectionStart = this._index;
	    }
	};
	
	Tokenizer.prototype._stateBeforeDeclaration = function(c) {
	    this._state =
	        c === "["
	            ? BEFORE_CDATA_1
	            : c === "-"
	                ? BEFORE_COMMENT
	                : IN_DECLARATION;
	};
	
	Tokenizer.prototype._stateInDeclaration = function(c) {
	    if (c === ">") {
	        this._cbs.ondeclaration(this._getSection());
	        this._state = TEXT;
	        this._sectionStart = this._index + 1;
	    }
	};
	
	Tokenizer.prototype._stateInProcessingInstruction = function(c) {
	    if (c === ">") {
	        this._cbs.onprocessinginstruction(this._getSection());
	        this._state = TEXT;
	        this._sectionStart = this._index + 1;
	    }
	};
	
	Tokenizer.prototype._stateBeforeComment = function(c) {
	    if (c === "-") {
	        this._state = IN_COMMENT;
	        this._sectionStart = this._index + 1;
	    } else {
	        this._state = IN_DECLARATION;
	    }
	};
	
	Tokenizer.prototype._stateInComment = function(c) {
	    if (c === "-") this._state = AFTER_COMMENT_1;
	};
	
	Tokenizer.prototype._stateAfterComment1 = function(c) {
	    if (c === "-") {
	        this._state = AFTER_COMMENT_2;
	    } else {
	        this._state = IN_COMMENT;
	    }
	};
	
	Tokenizer.prototype._stateAfterComment2 = function(c) {
	    if (c === ">") {
	        //remove 2 trailing chars
	        this._cbs.oncomment(
	            this._buffer.substring(this._sectionStart, this._index - 2)
	        );
	        this._state = TEXT;
	        this._sectionStart = this._index + 1;
	    } else if (c !== "-") {
	        this._state = IN_COMMENT;
	    }
	    // else: stay in AFTER_COMMENT_2 (`--->`)
	};
	
	Tokenizer.prototype._stateBeforeCdata1 = ifElseState(
	    "C",
	    BEFORE_CDATA_2,
	    IN_DECLARATION
	);
	Tokenizer.prototype._stateBeforeCdata2 = ifElseState(
	    "D",
	    BEFORE_CDATA_3,
	    IN_DECLARATION
	);
	Tokenizer.prototype._stateBeforeCdata3 = ifElseState(
	    "A",
	    BEFORE_CDATA_4,
	    IN_DECLARATION
	);
	Tokenizer.prototype._stateBeforeCdata4 = ifElseState(
	    "T",
	    BEFORE_CDATA_5,
	    IN_DECLARATION
	);
	Tokenizer.prototype._stateBeforeCdata5 = ifElseState(
	    "A",
	    BEFORE_CDATA_6,
	    IN_DECLARATION
	);
	
	Tokenizer.prototype._stateBeforeCdata6 = function(c) {
	    if (c === "[") {
	        this._state = IN_CDATA;
	        this._sectionStart = this._index + 1;
	    } else {
	        this._state = IN_DECLARATION;
	        this._index--;
	    }
	};
	
	Tokenizer.prototype._stateInCdata = function(c) {
	    if (c === "]") this._state = AFTER_CDATA_1;
	};
	
	Tokenizer.prototype._stateAfterCdata1 = function(c) {
	    if (c === "]") this._state = AFTER_CDATA_2;
	    else this._state = IN_CDATA;
	};
	
	Tokenizer.prototype._stateAfterCdata2 = function(c) {
	    if (c === ">") {
	        //remove 2 trailing chars
	        this._cbs.oncdata(
	            this._buffer.substring(this._sectionStart, this._index - 2)
	        );
	        this._state = TEXT;
	        this._sectionStart = this._index + 1;
	    } else if (c !== "]") {
	        this._state = IN_CDATA;
	    }
	    //else: stay in AFTER_CDATA_2 (`]]]>`)
	};
	
	Tokenizer.prototype._stateBeforeSpecial = function(c) {
	    if (c === "c" || c === "C") {
	        this._state = BEFORE_SCRIPT_1;
	    } else if (c === "t" || c === "T") {
	        this._state = BEFORE_STYLE_1;
	    } else {
	        this._state = IN_TAG_NAME;
	        this._index--; //consume the token again
	    }
	};
	
	Tokenizer.prototype._stateBeforeSpecialEnd = function(c) {
	    if (this._special === SPECIAL_SCRIPT && (c === "c" || c === "C")) {
	        this._state = AFTER_SCRIPT_1;
	    } else if (this._special === SPECIAL_STYLE && (c === "t" || c === "T")) {
	        this._state = AFTER_STYLE_1;
	    } else this._state = TEXT;
	};
	
	Tokenizer.prototype._stateBeforeScript1 = consumeSpecialNameChar(
	    "R",
	    BEFORE_SCRIPT_2
	);
	Tokenizer.prototype._stateBeforeScript2 = consumeSpecialNameChar(
	    "I",
	    BEFORE_SCRIPT_3
	);
	Tokenizer.prototype._stateBeforeScript3 = consumeSpecialNameChar(
	    "P",
	    BEFORE_SCRIPT_4
	);
	Tokenizer.prototype._stateBeforeScript4 = consumeSpecialNameChar(
	    "T",
	    BEFORE_SCRIPT_5
	);
	
	Tokenizer.prototype._stateBeforeScript5 = function(c) {
	    if (c === "/" || c === ">" || whitespace(c)) {
	        this._special = SPECIAL_SCRIPT;
	    }
	    this._state = IN_TAG_NAME;
	    this._index--; //consume the token again
	};
	
	Tokenizer.prototype._stateAfterScript1 = ifElseState("R", AFTER_SCRIPT_2, TEXT);
	Tokenizer.prototype._stateAfterScript2 = ifElseState("I", AFTER_SCRIPT_3, TEXT);
	Tokenizer.prototype._stateAfterScript3 = ifElseState("P", AFTER_SCRIPT_4, TEXT);
	Tokenizer.prototype._stateAfterScript4 = ifElseState("T", AFTER_SCRIPT_5, TEXT);
	
	Tokenizer.prototype._stateAfterScript5 = function(c) {
	    if (c === ">" || whitespace(c)) {
	        this._special = SPECIAL_NONE;
	        this._state = IN_CLOSING_TAG_NAME;
	        this._sectionStart = this._index - 6;
	        this._index--; //reconsume the token
	    } else this._state = TEXT;
	};
	
	Tokenizer.prototype._stateBeforeStyle1 = consumeSpecialNameChar(
	    "Y",
	    BEFORE_STYLE_2
	);
	Tokenizer.prototype._stateBeforeStyle2 = consumeSpecialNameChar(
	    "L",
	    BEFORE_STYLE_3
	);
	Tokenizer.prototype._stateBeforeStyle3 = consumeSpecialNameChar(
	    "E",
	    BEFORE_STYLE_4
	);
	
	Tokenizer.prototype._stateBeforeStyle4 = function(c) {
	    if (c === "/" || c === ">" || whitespace(c)) {
	        this._special = SPECIAL_STYLE;
	    }
	    this._state = IN_TAG_NAME;
	    this._index--; //consume the token again
	};
	
	Tokenizer.prototype._stateAfterStyle1 = ifElseState("Y", AFTER_STYLE_2, TEXT);
	Tokenizer.prototype._stateAfterStyle2 = ifElseState("L", AFTER_STYLE_3, TEXT);
	Tokenizer.prototype._stateAfterStyle3 = ifElseState("E", AFTER_STYLE_4, TEXT);
	
	Tokenizer.prototype._stateAfterStyle4 = function(c) {
	    if (c === ">" || whitespace(c)) {
	        this._special = SPECIAL_NONE;
	        this._state = IN_CLOSING_TAG_NAME;
	        this._sectionStart = this._index - 5;
	        this._index--; //reconsume the token
	    } else this._state = TEXT;
	};
	
	Tokenizer.prototype._stateBeforeEntity = ifElseState(
	    "#",
	    BEFORE_NUMERIC_ENTITY,
	    IN_NAMED_ENTITY
	);
	Tokenizer.prototype._stateBeforeNumericEntity = ifElseState(
	    "X",
	    IN_HEX_ENTITY,
	    IN_NUMERIC_ENTITY
	);
	
	//for entities terminated with a semicolon
	Tokenizer.prototype._parseNamedEntityStrict = function() {
	    //offset = 1
	    if (this._sectionStart + 1 < this._index) {
	        var entity = this._buffer.substring(
	                this._sectionStart + 1,
	                this._index
	            ),
	            map = this._xmlMode ? xmlMap : entityMap;
	
	        if (map.hasOwnProperty(entity)) {
	            this._emitPartial(map[entity]);
	            this._sectionStart = this._index + 1;
	        }
	    }
	};
	
	//parses legacy entities (without trailing semicolon)
	Tokenizer.prototype._parseLegacyEntity = function() {
	    var start = this._sectionStart + 1,
	        limit = this._index - start;
	
	    if (limit > 6) limit = 6; //the max length of legacy entities is 6
	
	    while (limit >= 2) {
	        //the min length of legacy entities is 2
	        var entity = this._buffer.substr(start, limit);
	
	        if (legacyMap.hasOwnProperty(entity)) {
	            this._emitPartial(legacyMap[entity]);
	            this._sectionStart += limit + 1;
	            return;
	        } else {
	            limit--;
	        }
	    }
	};
	
	Tokenizer.prototype._stateInNamedEntity = function(c) {
	    if (c === ";") {
	        this._parseNamedEntityStrict();
	        if (this._sectionStart + 1 < this._index && !this._xmlMode) {
	            this._parseLegacyEntity();
	        }
	        this._state = this._baseState;
	    } else if (
	        (c < "a" || c > "z") &&
	        (c < "A" || c > "Z") &&
	        (c < "0" || c > "9")
	    ) {
	        if (this._xmlMode);
	        else if (this._sectionStart + 1 === this._index);
	        else if (this._baseState !== TEXT) {
	            if (c !== "=") {
	                this._parseNamedEntityStrict();
	            }
	        } else {
	            this._parseLegacyEntity();
	        }
	
	        this._state = this._baseState;
	        this._index--;
	    }
	};
	
	Tokenizer.prototype._decodeNumericEntity = function(offset, base) {
	    var sectionStart = this._sectionStart + offset;
	
	    if (sectionStart !== this._index) {
	        //parse entity
	        var entity = this._buffer.substring(sectionStart, this._index);
	        var parsed = parseInt(entity, base);
	
	        this._emitPartial(decodeCodePoint(parsed));
	        this._sectionStart = this._index;
	    } else {
	        this._sectionStart--;
	    }
	
	    this._state = this._baseState;
	};
	
	Tokenizer.prototype._stateInNumericEntity = function(c) {
	    if (c === ";") {
	        this._decodeNumericEntity(2, 10);
	        this._sectionStart++;
	    } else if (c < "0" || c > "9") {
	        if (!this._xmlMode) {
	            this._decodeNumericEntity(2, 10);
	        } else {
	            this._state = this._baseState;
	        }
	        this._index--;
	    }
	};
	
	Tokenizer.prototype._stateInHexEntity = function(c) {
	    if (c === ";") {
	        this._decodeNumericEntity(3, 16);
	        this._sectionStart++;
	    } else if (
	        (c < "a" || c > "f") &&
	        (c < "A" || c > "F") &&
	        (c < "0" || c > "9")
	    ) {
	        if (!this._xmlMode) {
	            this._decodeNumericEntity(3, 16);
	        } else {
	            this._state = this._baseState;
	        }
	        this._index--;
	    }
	};
	
	Tokenizer.prototype._cleanup = function() {
	    if (this._sectionStart < 0) {
	        this._buffer = "";
	        this._bufferOffset += this._index;
	        this._index = 0;
	    } else if (this._running) {
	        if (this._state === TEXT) {
	            if (this._sectionStart !== this._index) {
	                this._cbs.ontext(this._buffer.substr(this._sectionStart));
	            }
	            this._buffer = "";
	            this._bufferOffset += this._index;
	            this._index = 0;
	        } else if (this._sectionStart === this._index) {
	            //the section just started
	            this._buffer = "";
	            this._bufferOffset += this._index;
	            this._index = 0;
	        } else {
	            //remove everything unnecessary
	            this._buffer = this._buffer.substr(this._sectionStart);
	            this._index -= this._sectionStart;
	            this._bufferOffset += this._sectionStart;
	        }
	
	        this._sectionStart = 0;
	    }
	};
	
	//TODO make events conditional
	Tokenizer.prototype.write = function(chunk) {
	    if (this._ended) this._cbs.onerror(Error(".write() after done!"));
	
	    this._buffer += chunk;
	    this._parse();
	};
	
	Tokenizer.prototype._parse = function() {
	    while (this._index < this._buffer.length && this._running) {
	        var c = this._buffer.charAt(this._index);
	        if (this._state === TEXT) {
	            this._stateText(c);
	        } else if (this._state === BEFORE_TAG_NAME) {
	            this._stateBeforeTagName(c);
	        } else if (this._state === IN_TAG_NAME) {
	            this._stateInTagName(c);
	        } else if (this._state === BEFORE_CLOSING_TAG_NAME) {
	            this._stateBeforeCloseingTagName(c);
	        } else if (this._state === IN_CLOSING_TAG_NAME) {
	            this._stateInCloseingTagName(c);
	        } else if (this._state === AFTER_CLOSING_TAG_NAME) {
	            this._stateAfterCloseingTagName(c);
	        } else if (this._state === IN_SELF_CLOSING_TAG) {
	            this._stateInSelfClosingTag(c);
	        } else if (this._state === BEFORE_ATTRIBUTE_NAME) {
	
	        /*
			*	attributes
			*/
	            this._stateBeforeAttributeName(c);
	        } else if (this._state === IN_ATTRIBUTE_NAME) {
	            this._stateInAttributeName(c);
	        } else if (this._state === AFTER_ATTRIBUTE_NAME) {
	            this._stateAfterAttributeName(c);
	        } else if (this._state === BEFORE_ATTRIBUTE_VALUE) {
	            this._stateBeforeAttributeValue(c);
	        } else if (this._state === IN_ATTRIBUTE_VALUE_DQ) {
	            this._stateInAttributeValueDoubleQuotes(c);
	        } else if (this._state === IN_ATTRIBUTE_VALUE_SQ) {
	            this._stateInAttributeValueSingleQuotes(c);
	        } else if (this._state === IN_ATTRIBUTE_VALUE_NQ) {
	            this._stateInAttributeValueNoQuotes(c);
	        } else if (this._state === BEFORE_DECLARATION) {
	
	        /*
			*	declarations
			*/
	            this._stateBeforeDeclaration(c);
	        } else if (this._state === IN_DECLARATION) {
	            this._stateInDeclaration(c);
	        } else if (this._state === IN_PROCESSING_INSTRUCTION) {
	
	        /*
			*	processing instructions
			*/
	            this._stateInProcessingInstruction(c);
	        } else if (this._state === BEFORE_COMMENT) {
	
	        /*
			*	comments
			*/
	            this._stateBeforeComment(c);
	        } else if (this._state === IN_COMMENT) {
	            this._stateInComment(c);
	        } else if (this._state === AFTER_COMMENT_1) {
	            this._stateAfterComment1(c);
	        } else if (this._state === AFTER_COMMENT_2) {
	            this._stateAfterComment2(c);
	        } else if (this._state === BEFORE_CDATA_1) {
	
	        /*
			*	cdata
			*/
	            this._stateBeforeCdata1(c);
	        } else if (this._state === BEFORE_CDATA_2) {
	            this._stateBeforeCdata2(c);
	        } else if (this._state === BEFORE_CDATA_3) {
	            this._stateBeforeCdata3(c);
	        } else if (this._state === BEFORE_CDATA_4) {
	            this._stateBeforeCdata4(c);
	        } else if (this._state === BEFORE_CDATA_5) {
	            this._stateBeforeCdata5(c);
	        } else if (this._state === BEFORE_CDATA_6) {
	            this._stateBeforeCdata6(c);
	        } else if (this._state === IN_CDATA) {
	            this._stateInCdata(c);
	        } else if (this._state === AFTER_CDATA_1) {
	            this._stateAfterCdata1(c);
	        } else if (this._state === AFTER_CDATA_2) {
	            this._stateAfterCdata2(c);
	        } else if (this._state === BEFORE_SPECIAL) {
	
	        /*
			* special tags
			*/
	            this._stateBeforeSpecial(c);
	        } else if (this._state === BEFORE_SPECIAL_END) {
	            this._stateBeforeSpecialEnd(c);
	        } else if (this._state === BEFORE_SCRIPT_1) {
	
	        /*
			* script
			*/
	            this._stateBeforeScript1(c);
	        } else if (this._state === BEFORE_SCRIPT_2) {
	            this._stateBeforeScript2(c);
	        } else if (this._state === BEFORE_SCRIPT_3) {
	            this._stateBeforeScript3(c);
	        } else if (this._state === BEFORE_SCRIPT_4) {
	            this._stateBeforeScript4(c);
	        } else if (this._state === BEFORE_SCRIPT_5) {
	            this._stateBeforeScript5(c);
	        } else if (this._state === AFTER_SCRIPT_1) {
	            this._stateAfterScript1(c);
	        } else if (this._state === AFTER_SCRIPT_2) {
	            this._stateAfterScript2(c);
	        } else if (this._state === AFTER_SCRIPT_3) {
	            this._stateAfterScript3(c);
	        } else if (this._state === AFTER_SCRIPT_4) {
	            this._stateAfterScript4(c);
	        } else if (this._state === AFTER_SCRIPT_5) {
	            this._stateAfterScript5(c);
	        } else if (this._state === BEFORE_STYLE_1) {
	
	        /*
			* style
			*/
	            this._stateBeforeStyle1(c);
	        } else if (this._state === BEFORE_STYLE_2) {
	            this._stateBeforeStyle2(c);
	        } else if (this._state === BEFORE_STYLE_3) {
	            this._stateBeforeStyle3(c);
	        } else if (this._state === BEFORE_STYLE_4) {
	            this._stateBeforeStyle4(c);
	        } else if (this._state === AFTER_STYLE_1) {
	            this._stateAfterStyle1(c);
	        } else if (this._state === AFTER_STYLE_2) {
	            this._stateAfterStyle2(c);
	        } else if (this._state === AFTER_STYLE_3) {
	            this._stateAfterStyle3(c);
	        } else if (this._state === AFTER_STYLE_4) {
	            this._stateAfterStyle4(c);
	        } else if (this._state === BEFORE_ENTITY) {
	
	        /*
			* entities
			*/
	            this._stateBeforeEntity(c);
	        } else if (this._state === BEFORE_NUMERIC_ENTITY) {
	            this._stateBeforeNumericEntity(c);
	        } else if (this._state === IN_NAMED_ENTITY) {
	            this._stateInNamedEntity(c);
	        } else if (this._state === IN_NUMERIC_ENTITY) {
	            this._stateInNumericEntity(c);
	        } else if (this._state === IN_HEX_ENTITY) {
	            this._stateInHexEntity(c);
	        } else {
	            this._cbs.onerror(Error("unknown _state"), this._state);
	        }
	
	        this._index++;
	    }
	
	    this._cleanup();
	};
	
	Tokenizer.prototype.pause = function() {
	    this._running = false;
	};
	Tokenizer.prototype.resume = function() {
	    this._running = true;
	
	    if (this._index < this._buffer.length) {
	        this._parse();
	    }
	    if (this._ended) {
	        this._finish();
	    }
	};
	
	Tokenizer.prototype.end = function(chunk) {
	    if (this._ended) this._cbs.onerror(Error(".end() after done!"));
	    if (chunk) this.write(chunk);
	
	    this._ended = true;
	
	    if (this._running) this._finish();
	};
	
	Tokenizer.prototype._finish = function() {
	    //if there is remaining data, emit it in a reasonable way
	    if (this._sectionStart < this._index) {
	        this._handleTrailingData();
	    }
	
	    this._cbs.onend();
	};
	
	Tokenizer.prototype._handleTrailingData = function() {
	    var data = this._buffer.substr(this._sectionStart);
	
	    if (
	        this._state === IN_CDATA ||
	        this._state === AFTER_CDATA_1 ||
	        this._state === AFTER_CDATA_2
	    ) {
	        this._cbs.oncdata(data);
	    } else if (
	        this._state === IN_COMMENT ||
	        this._state === AFTER_COMMENT_1 ||
	        this._state === AFTER_COMMENT_2
	    ) {
	        this._cbs.oncomment(data);
	    } else if (this._state === IN_NAMED_ENTITY && !this._xmlMode) {
	        this._parseLegacyEntity();
	        if (this._sectionStart < this._index) {
	            this._state = this._baseState;
	            this._handleTrailingData();
	        }
	    } else if (this._state === IN_NUMERIC_ENTITY && !this._xmlMode) {
	        this._decodeNumericEntity(2, 10);
	        if (this._sectionStart < this._index) {
	            this._state = this._baseState;
	            this._handleTrailingData();
	        }
	    } else if (this._state === IN_HEX_ENTITY && !this._xmlMode) {
	        this._decodeNumericEntity(3, 16);
	        if (this._sectionStart < this._index) {
	            this._state = this._baseState;
	            this._handleTrailingData();
	        }
	    } else if (
	        this._state !== IN_TAG_NAME &&
	        this._state !== BEFORE_ATTRIBUTE_NAME &&
	        this._state !== BEFORE_ATTRIBUTE_VALUE &&
	        this._state !== AFTER_ATTRIBUTE_NAME &&
	        this._state !== IN_ATTRIBUTE_NAME &&
	        this._state !== IN_ATTRIBUTE_VALUE_SQ &&
	        this._state !== IN_ATTRIBUTE_VALUE_DQ &&
	        this._state !== IN_ATTRIBUTE_VALUE_NQ &&
	        this._state !== IN_CLOSING_TAG_NAME
	    ) {
	        this._cbs.ontext(data);
	    }
	    //else, ignore remaining data
	    //TODO add a way to remove current tag
	};
	
	Tokenizer.prototype.reset = function() {
	    Tokenizer.call(
	        this,
	        { xmlMode: this._xmlMode, decodeEntities: this._decodeEntities },
	        this._cbs
	    );
	};
	
	Tokenizer.prototype.getAbsoluteIndex = function() {
	    return this._bufferOffset + this._index;
	};
	
	Tokenizer.prototype._getSection = function() {
	    return this._buffer.substring(this._sectionStart, this._index);
	};
	
	Tokenizer.prototype._emitToken = function(name) {
	    this._cbs[name](this._getSection());
	    this._sectionStart = -1;
	};
	
	Tokenizer.prototype._emitPartial = function(value) {
	    if (this._baseState !== TEXT) {
	        this._cbs.onattribdata(value); //TODO implement the new event
	    } else {
	        this._cbs.ontext(value);
	    }
	};


/***/ },
/* 721 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = Stream;
	
	var Parser = __webpack_require__(719);
	var WritableStream = __webpack_require__(2621).Writable;
	var StringDecoder = __webpack_require__(2466).StringDecoder;
	var Buffer = __webpack_require__(519).Buffer;
	
	function Stream(cbs, options) {
	    var parser = (this._parser = new Parser(cbs, options));
	    var decoder = (this._decoder = new StringDecoder());
	
	    WritableStream.call(this, { decodeStrings: false });
	
	    this.once("finish", function() {
	        parser.end(decoder.end());
	    });
	}
	
	__webpack_require__(278)(Stream, WritableStream);
	
	Stream.prototype._write = function(chunk, encoding, cb) {
	    if (chunk instanceof Buffer) chunk = this._decoder.write(chunk);
	    this._parser.write(chunk);
	    cb();
	};


/***/ },
/* 722 */
/***/ function(module, exports) {

	/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = ((value * c) - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ },
/* 723 */
/***/ function(module, exports) {

	module.exports = {
		"Aacute": "Á",
		"aacute": "á",
		"Abreve": "Ă",
		"abreve": "ă",
		"ac": "∾",
		"acd": "∿",
		"acE": "∾̳",
		"Acirc": "Â",
		"acirc": "â",
		"acute": "´",
		"Acy": "А",
		"acy": "а",
		"AElig": "Æ",
		"aelig": "æ",
		"af": "⁡",
		"Afr": "𝔄",
		"afr": "𝔞",
		"Agrave": "À",
		"agrave": "à",
		"alefsym": "ℵ",
		"aleph": "ℵ",
		"Alpha": "Α",
		"alpha": "α",
		"Amacr": "Ā",
		"amacr": "ā",
		"amalg": "⨿",
		"amp": "&",
		"AMP": "&",
		"andand": "⩕",
		"And": "⩓",
		"and": "∧",
		"andd": "⩜",
		"andslope": "⩘",
		"andv": "⩚",
		"ang": "∠",
		"ange": "⦤",
		"angle": "∠",
		"angmsdaa": "⦨",
		"angmsdab": "⦩",
		"angmsdac": "⦪",
		"angmsdad": "⦫",
		"angmsdae": "⦬",
		"angmsdaf": "⦭",
		"angmsdag": "⦮",
		"angmsdah": "⦯",
		"angmsd": "∡",
		"angrt": "∟",
		"angrtvb": "⊾",
		"angrtvbd": "⦝",
		"angsph": "∢",
		"angst": "Å",
		"angzarr": "⍼",
		"Aogon": "Ą",
		"aogon": "ą",
		"Aopf": "𝔸",
		"aopf": "𝕒",
		"apacir": "⩯",
		"ap": "≈",
		"apE": "⩰",
		"ape": "≊",
		"apid": "≋",
		"apos": "'",
		"ApplyFunction": "⁡",
		"approx": "≈",
		"approxeq": "≊",
		"Aring": "Å",
		"aring": "å",
		"Ascr": "𝒜",
		"ascr": "𝒶",
		"Assign": "≔",
		"ast": "*",
		"asymp": "≈",
		"asympeq": "≍",
		"Atilde": "Ã",
		"atilde": "ã",
		"Auml": "Ä",
		"auml": "ä",
		"awconint": "∳",
		"awint": "⨑",
		"backcong": "≌",
		"backepsilon": "϶",
		"backprime": "‵",
		"backsim": "∽",
		"backsimeq": "⋍",
		"Backslash": "∖",
		"Barv": "⫧",
		"barvee": "⊽",
		"barwed": "⌅",
		"Barwed": "⌆",
		"barwedge": "⌅",
		"bbrk": "⎵",
		"bbrktbrk": "⎶",
		"bcong": "≌",
		"Bcy": "Б",
		"bcy": "б",
		"bdquo": "„",
		"becaus": "∵",
		"because": "∵",
		"Because": "∵",
		"bemptyv": "⦰",
		"bepsi": "϶",
		"bernou": "ℬ",
		"Bernoullis": "ℬ",
		"Beta": "Β",
		"beta": "β",
		"beth": "ℶ",
		"between": "≬",
		"Bfr": "𝔅",
		"bfr": "𝔟",
		"bigcap": "⋂",
		"bigcirc": "◯",
		"bigcup": "⋃",
		"bigodot": "⨀",
		"bigoplus": "⨁",
		"bigotimes": "⨂",
		"bigsqcup": "⨆",
		"bigstar": "★",
		"bigtriangledown": "▽",
		"bigtriangleup": "△",
		"biguplus": "⨄",
		"bigvee": "⋁",
		"bigwedge": "⋀",
		"bkarow": "⤍",
		"blacklozenge": "⧫",
		"blacksquare": "▪",
		"blacktriangle": "▴",
		"blacktriangledown": "▾",
		"blacktriangleleft": "◂",
		"blacktriangleright": "▸",
		"blank": "␣",
		"blk12": "▒",
		"blk14": "░",
		"blk34": "▓",
		"block": "█",
		"bne": "=⃥",
		"bnequiv": "≡⃥",
		"bNot": "⫭",
		"bnot": "⌐",
		"Bopf": "𝔹",
		"bopf": "𝕓",
		"bot": "⊥",
		"bottom": "⊥",
		"bowtie": "⋈",
		"boxbox": "⧉",
		"boxdl": "┐",
		"boxdL": "╕",
		"boxDl": "╖",
		"boxDL": "╗",
		"boxdr": "┌",
		"boxdR": "╒",
		"boxDr": "╓",
		"boxDR": "╔",
		"boxh": "─",
		"boxH": "═",
		"boxhd": "┬",
		"boxHd": "╤",
		"boxhD": "╥",
		"boxHD": "╦",
		"boxhu": "┴",
		"boxHu": "╧",
		"boxhU": "╨",
		"boxHU": "╩",
		"boxminus": "⊟",
		"boxplus": "⊞",
		"boxtimes": "⊠",
		"boxul": "┘",
		"boxuL": "╛",
		"boxUl": "╜",
		"boxUL": "╝",
		"boxur": "└",
		"boxuR": "╘",
		"boxUr": "╙",
		"boxUR": "╚",
		"boxv": "│",
		"boxV": "║",
		"boxvh": "┼",
		"boxvH": "╪",
		"boxVh": "╫",
		"boxVH": "╬",
		"boxvl": "┤",
		"boxvL": "╡",
		"boxVl": "╢",
		"boxVL": "╣",
		"boxvr": "├",
		"boxvR": "╞",
		"boxVr": "╟",
		"boxVR": "╠",
		"bprime": "‵",
		"breve": "˘",
		"Breve": "˘",
		"brvbar": "¦",
		"bscr": "𝒷",
		"Bscr": "ℬ",
		"bsemi": "⁏",
		"bsim": "∽",
		"bsime": "⋍",
		"bsolb": "⧅",
		"bsol": "\\",
		"bsolhsub": "⟈",
		"bull": "•",
		"bullet": "•",
		"bump": "≎",
		"bumpE": "⪮",
		"bumpe": "≏",
		"Bumpeq": "≎",
		"bumpeq": "≏",
		"Cacute": "Ć",
		"cacute": "ć",
		"capand": "⩄",
		"capbrcup": "⩉",
		"capcap": "⩋",
		"cap": "∩",
		"Cap": "⋒",
		"capcup": "⩇",
		"capdot": "⩀",
		"CapitalDifferentialD": "ⅅ",
		"caps": "∩︀",
		"caret": "⁁",
		"caron": "ˇ",
		"Cayleys": "ℭ",
		"ccaps": "⩍",
		"Ccaron": "Č",
		"ccaron": "č",
		"Ccedil": "Ç",
		"ccedil": "ç",
		"Ccirc": "Ĉ",
		"ccirc": "ĉ",
		"Cconint": "∰",
		"ccups": "⩌",
		"ccupssm": "⩐",
		"Cdot": "Ċ",
		"cdot": "ċ",
		"cedil": "¸",
		"Cedilla": "¸",
		"cemptyv": "⦲",
		"cent": "¢",
		"centerdot": "·",
		"CenterDot": "·",
		"cfr": "𝔠",
		"Cfr": "ℭ",
		"CHcy": "Ч",
		"chcy": "ч",
		"check": "✓",
		"checkmark": "✓",
		"Chi": "Χ",
		"chi": "χ",
		"circ": "ˆ",
		"circeq": "≗",
		"circlearrowleft": "↺",
		"circlearrowright": "↻",
		"circledast": "⊛",
		"circledcirc": "⊚",
		"circleddash": "⊝",
		"CircleDot": "⊙",
		"circledR": "®",
		"circledS": "Ⓢ",
		"CircleMinus": "⊖",
		"CirclePlus": "⊕",
		"CircleTimes": "⊗",
		"cir": "○",
		"cirE": "⧃",
		"cire": "≗",
		"cirfnint": "⨐",
		"cirmid": "⫯",
		"cirscir": "⧂",
		"ClockwiseContourIntegral": "∲",
		"CloseCurlyDoubleQuote": "”",
		"CloseCurlyQuote": "’",
		"clubs": "♣",
		"clubsuit": "♣",
		"colon": ":",
		"Colon": "∷",
		"Colone": "⩴",
		"colone": "≔",
		"coloneq": "≔",
		"comma": ",",
		"commat": "@",
		"comp": "∁",
		"compfn": "∘",
		"complement": "∁",
		"complexes": "ℂ",
		"cong": "≅",
		"congdot": "⩭",
		"Congruent": "≡",
		"conint": "∮",
		"Conint": "∯",
		"ContourIntegral": "∮",
		"copf": "𝕔",
		"Copf": "ℂ",
		"coprod": "∐",
		"Coproduct": "∐",
		"copy": "©",
		"COPY": "©",
		"copysr": "℗",
		"CounterClockwiseContourIntegral": "∳",
		"crarr": "↵",
		"cross": "✗",
		"Cross": "⨯",
		"Cscr": "𝒞",
		"cscr": "𝒸",
		"csub": "⫏",
		"csube": "⫑",
		"csup": "⫐",
		"csupe": "⫒",
		"ctdot": "⋯",
		"cudarrl": "⤸",
		"cudarrr": "⤵",
		"cuepr": "⋞",
		"cuesc": "⋟",
		"cularr": "↶",
		"cularrp": "⤽",
		"cupbrcap": "⩈",
		"cupcap": "⩆",
		"CupCap": "≍",
		"cup": "∪",
		"Cup": "⋓",
		"cupcup": "⩊",
		"cupdot": "⊍",
		"cupor": "⩅",
		"cups": "∪︀",
		"curarr": "↷",
		"curarrm": "⤼",
		"curlyeqprec": "⋞",
		"curlyeqsucc": "⋟",
		"curlyvee": "⋎",
		"curlywedge": "⋏",
		"curren": "¤",
		"curvearrowleft": "↶",
		"curvearrowright": "↷",
		"cuvee": "⋎",
		"cuwed": "⋏",
		"cwconint": "∲",
		"cwint": "∱",
		"cylcty": "⌭",
		"dagger": "†",
		"Dagger": "‡",
		"daleth": "ℸ",
		"darr": "↓",
		"Darr": "↡",
		"dArr": "⇓",
		"dash": "‐",
		"Dashv": "⫤",
		"dashv": "⊣",
		"dbkarow": "⤏",
		"dblac": "˝",
		"Dcaron": "Ď",
		"dcaron": "ď",
		"Dcy": "Д",
		"dcy": "д",
		"ddagger": "‡",
		"ddarr": "⇊",
		"DD": "ⅅ",
		"dd": "ⅆ",
		"DDotrahd": "⤑",
		"ddotseq": "⩷",
		"deg": "°",
		"Del": "∇",
		"Delta": "Δ",
		"delta": "δ",
		"demptyv": "⦱",
		"dfisht": "⥿",
		"Dfr": "𝔇",
		"dfr": "𝔡",
		"dHar": "⥥",
		"dharl": "⇃",
		"dharr": "⇂",
		"DiacriticalAcute": "´",
		"DiacriticalDot": "˙",
		"DiacriticalDoubleAcute": "˝",
		"DiacriticalGrave": "`",
		"DiacriticalTilde": "˜",
		"diam": "⋄",
		"diamond": "⋄",
		"Diamond": "⋄",
		"diamondsuit": "♦",
		"diams": "♦",
		"die": "¨",
		"DifferentialD": "ⅆ",
		"digamma": "ϝ",
		"disin": "⋲",
		"div": "÷",
		"divide": "÷",
		"divideontimes": "⋇",
		"divonx": "⋇",
		"DJcy": "Ђ",
		"djcy": "ђ",
		"dlcorn": "⌞",
		"dlcrop": "⌍",
		"dollar": "$",
		"Dopf": "𝔻",
		"dopf": "𝕕",
		"Dot": "¨",
		"dot": "˙",
		"DotDot": "⃜",
		"doteq": "≐",
		"doteqdot": "≑",
		"DotEqual": "≐",
		"dotminus": "∸",
		"dotplus": "∔",
		"dotsquare": "⊡",
		"doublebarwedge": "⌆",
		"DoubleContourIntegral": "∯",
		"DoubleDot": "¨",
		"DoubleDownArrow": "⇓",
		"DoubleLeftArrow": "⇐",
		"DoubleLeftRightArrow": "⇔",
		"DoubleLeftTee": "⫤",
		"DoubleLongLeftArrow": "⟸",
		"DoubleLongLeftRightArrow": "⟺",
		"DoubleLongRightArrow": "⟹",
		"DoubleRightArrow": "⇒",
		"DoubleRightTee": "⊨",
		"DoubleUpArrow": "⇑",
		"DoubleUpDownArrow": "⇕",
		"DoubleVerticalBar": "∥",
		"DownArrowBar": "⤓",
		"downarrow": "↓",
		"DownArrow": "↓",
		"Downarrow": "⇓",
		"DownArrowUpArrow": "⇵",
		"DownBreve": "̑",
		"downdownarrows": "⇊",
		"downharpoonleft": "⇃",
		"downharpoonright": "⇂",
		"DownLeftRightVector": "⥐",
		"DownLeftTeeVector": "⥞",
		"DownLeftVectorBar": "⥖",
		"DownLeftVector": "↽",
		"DownRightTeeVector": "⥟",
		"DownRightVectorBar": "⥗",
		"DownRightVector": "⇁",
		"DownTeeArrow": "↧",
		"DownTee": "⊤",
		"drbkarow": "⤐",
		"drcorn": "⌟",
		"drcrop": "⌌",
		"Dscr": "𝒟",
		"dscr": "𝒹",
		"DScy": "Ѕ",
		"dscy": "ѕ",
		"dsol": "⧶",
		"Dstrok": "Đ",
		"dstrok": "đ",
		"dtdot": "⋱",
		"dtri": "▿",
		"dtrif": "▾",
		"duarr": "⇵",
		"duhar": "⥯",
		"dwangle": "⦦",
		"DZcy": "Џ",
		"dzcy": "џ",
		"dzigrarr": "⟿",
		"Eacute": "É",
		"eacute": "é",
		"easter": "⩮",
		"Ecaron": "Ě",
		"ecaron": "ě",
		"Ecirc": "Ê",
		"ecirc": "ê",
		"ecir": "≖",
		"ecolon": "≕",
		"Ecy": "Э",
		"ecy": "э",
		"eDDot": "⩷",
		"Edot": "Ė",
		"edot": "ė",
		"eDot": "≑",
		"ee": "ⅇ",
		"efDot": "≒",
		"Efr": "𝔈",
		"efr": "𝔢",
		"eg": "⪚",
		"Egrave": "È",
		"egrave": "è",
		"egs": "⪖",
		"egsdot": "⪘",
		"el": "⪙",
		"Element": "∈",
		"elinters": "⏧",
		"ell": "ℓ",
		"els": "⪕",
		"elsdot": "⪗",
		"Emacr": "Ē",
		"emacr": "ē",
		"empty": "∅",
		"emptyset": "∅",
		"EmptySmallSquare": "◻",
		"emptyv": "∅",
		"EmptyVerySmallSquare": "▫",
		"emsp13": " ",
		"emsp14": " ",
		"emsp": " ",
		"ENG": "Ŋ",
		"eng": "ŋ",
		"ensp": " ",
		"Eogon": "Ę",
		"eogon": "ę",
		"Eopf": "𝔼",
		"eopf": "𝕖",
		"epar": "⋕",
		"eparsl": "⧣",
		"eplus": "⩱",
		"epsi": "ε",
		"Epsilon": "Ε",
		"epsilon": "ε",
		"epsiv": "ϵ",
		"eqcirc": "≖",
		"eqcolon": "≕",
		"eqsim": "≂",
		"eqslantgtr": "⪖",
		"eqslantless": "⪕",
		"Equal": "⩵",
		"equals": "=",
		"EqualTilde": "≂",
		"equest": "≟",
		"Equilibrium": "⇌",
		"equiv": "≡",
		"equivDD": "⩸",
		"eqvparsl": "⧥",
		"erarr": "⥱",
		"erDot": "≓",
		"escr": "ℯ",
		"Escr": "ℰ",
		"esdot": "≐",
		"Esim": "⩳",
		"esim": "≂",
		"Eta": "Η",
		"eta": "η",
		"ETH": "Ð",
		"eth": "ð",
		"Euml": "Ë",
		"euml": "ë",
		"euro": "€",
		"excl": "!",
		"exist": "∃",
		"Exists": "∃",
		"expectation": "ℰ",
		"exponentiale": "ⅇ",
		"ExponentialE": "ⅇ",
		"fallingdotseq": "≒",
		"Fcy": "Ф",
		"fcy": "ф",
		"female": "♀",
		"ffilig": "ﬃ",
		"fflig": "ﬀ",
		"ffllig": "ﬄ",
		"Ffr": "𝔉",
		"ffr": "𝔣",
		"filig": "ﬁ",
		"FilledSmallSquare": "◼",
		"FilledVerySmallSquare": "▪",
		"fjlig": "fj",
		"flat": "♭",
		"fllig": "ﬂ",
		"fltns": "▱",
		"fnof": "ƒ",
		"Fopf": "𝔽",
		"fopf": "𝕗",
		"forall": "∀",
		"ForAll": "∀",
		"fork": "⋔",
		"forkv": "⫙",
		"Fouriertrf": "ℱ",
		"fpartint": "⨍",
		"frac12": "½",
		"frac13": "⅓",
		"frac14": "¼",
		"frac15": "⅕",
		"frac16": "⅙",
		"frac18": "⅛",
		"frac23": "⅔",
		"frac25": "⅖",
		"frac34": "¾",
		"frac35": "⅗",
		"frac38": "⅜",
		"frac45": "⅘",
		"frac56": "⅚",
		"frac58": "⅝",
		"frac78": "⅞",
		"frasl": "⁄",
		"frown": "⌢",
		"fscr": "𝒻",
		"Fscr": "ℱ",
		"gacute": "ǵ",
		"Gamma": "Γ",
		"gamma": "γ",
		"Gammad": "Ϝ",
		"gammad": "ϝ",
		"gap": "⪆",
		"Gbreve": "Ğ",
		"gbreve": "ğ",
		"Gcedil": "Ģ",
		"Gcirc": "Ĝ",
		"gcirc": "ĝ",
		"Gcy": "Г",
		"gcy": "г",
		"Gdot": "Ġ",
		"gdot": "ġ",
		"ge": "≥",
		"gE": "≧",
		"gEl": "⪌",
		"gel": "⋛",
		"geq": "≥",
		"geqq": "≧",
		"geqslant": "⩾",
		"gescc": "⪩",
		"ges": "⩾",
		"gesdot": "⪀",
		"gesdoto": "⪂",
		"gesdotol": "⪄",
		"gesl": "⋛︀",
		"gesles": "⪔",
		"Gfr": "𝔊",
		"gfr": "𝔤",
		"gg": "≫",
		"Gg": "⋙",
		"ggg": "⋙",
		"gimel": "ℷ",
		"GJcy": "Ѓ",
		"gjcy": "ѓ",
		"gla": "⪥",
		"gl": "≷",
		"glE": "⪒",
		"glj": "⪤",
		"gnap": "⪊",
		"gnapprox": "⪊",
		"gne": "⪈",
		"gnE": "≩",
		"gneq": "⪈",
		"gneqq": "≩",
		"gnsim": "⋧",
		"Gopf": "𝔾",
		"gopf": "𝕘",
		"grave": "`",
		"GreaterEqual": "≥",
		"GreaterEqualLess": "⋛",
		"GreaterFullEqual": "≧",
		"GreaterGreater": "⪢",
		"GreaterLess": "≷",
		"GreaterSlantEqual": "⩾",
		"GreaterTilde": "≳",
		"Gscr": "𝒢",
		"gscr": "ℊ",
		"gsim": "≳",
		"gsime": "⪎",
		"gsiml": "⪐",
		"gtcc": "⪧",
		"gtcir": "⩺",
		"gt": ">",
		"GT": ">",
		"Gt": "≫",
		"gtdot": "⋗",
		"gtlPar": "⦕",
		"gtquest": "⩼",
		"gtrapprox": "⪆",
		"gtrarr": "⥸",
		"gtrdot": "⋗",
		"gtreqless": "⋛",
		"gtreqqless": "⪌",
		"gtrless": "≷",
		"gtrsim": "≳",
		"gvertneqq": "≩︀",
		"gvnE": "≩︀",
		"Hacek": "ˇ",
		"hairsp": " ",
		"half": "½",
		"hamilt": "ℋ",
		"HARDcy": "Ъ",
		"hardcy": "ъ",
		"harrcir": "⥈",
		"harr": "↔",
		"hArr": "⇔",
		"harrw": "↭",
		"Hat": "^",
		"hbar": "ℏ",
		"Hcirc": "Ĥ",
		"hcirc": "ĥ",
		"hearts": "♥",
		"heartsuit": "♥",
		"hellip": "…",
		"hercon": "⊹",
		"hfr": "𝔥",
		"Hfr": "ℌ",
		"HilbertSpace": "ℋ",
		"hksearow": "⤥",
		"hkswarow": "⤦",
		"hoarr": "⇿",
		"homtht": "∻",
		"hookleftarrow": "↩",
		"hookrightarrow": "↪",
		"hopf": "𝕙",
		"Hopf": "ℍ",
		"horbar": "―",
		"HorizontalLine": "─",
		"hscr": "𝒽",
		"Hscr": "ℋ",
		"hslash": "ℏ",
		"Hstrok": "Ħ",
		"hstrok": "ħ",
		"HumpDownHump": "≎",
		"HumpEqual": "≏",
		"hybull": "⁃",
		"hyphen": "‐",
		"Iacute": "Í",
		"iacute": "í",
		"ic": "⁣",
		"Icirc": "Î",
		"icirc": "î",
		"Icy": "И",
		"icy": "и",
		"Idot": "İ",
		"IEcy": "Е",
		"iecy": "е",
		"iexcl": "¡",
		"iff": "⇔",
		"ifr": "𝔦",
		"Ifr": "ℑ",
		"Igrave": "Ì",
		"igrave": "ì",
		"ii": "ⅈ",
		"iiiint": "⨌",
		"iiint": "∭",
		"iinfin": "⧜",
		"iiota": "℩",
		"IJlig": "Ĳ",
		"ijlig": "ĳ",
		"Imacr": "Ī",
		"imacr": "ī",
		"image": "ℑ",
		"ImaginaryI": "ⅈ",
		"imagline": "ℐ",
		"imagpart": "ℑ",
		"imath": "ı",
		"Im": "ℑ",
		"imof": "⊷",
		"imped": "Ƶ",
		"Implies": "⇒",
		"incare": "℅",
		"in": "∈",
		"infin": "∞",
		"infintie": "⧝",
		"inodot": "ı",
		"intcal": "⊺",
		"int": "∫",
		"Int": "∬",
		"integers": "ℤ",
		"Integral": "∫",
		"intercal": "⊺",
		"Intersection": "⋂",
		"intlarhk": "⨗",
		"intprod": "⨼",
		"InvisibleComma": "⁣",
		"InvisibleTimes": "⁢",
		"IOcy": "Ё",
		"iocy": "ё",
		"Iogon": "Į",
		"iogon": "į",
		"Iopf": "𝕀",
		"iopf": "𝕚",
		"Iota": "Ι",
		"iota": "ι",
		"iprod": "⨼",
		"iquest": "¿",
		"iscr": "𝒾",
		"Iscr": "ℐ",
		"isin": "∈",
		"isindot": "⋵",
		"isinE": "⋹",
		"isins": "⋴",
		"isinsv": "⋳",
		"isinv": "∈",
		"it": "⁢",
		"Itilde": "Ĩ",
		"itilde": "ĩ",
		"Iukcy": "І",
		"iukcy": "і",
		"Iuml": "Ï",
		"iuml": "ï",
		"Jcirc": "Ĵ",
		"jcirc": "ĵ",
		"Jcy": "Й",
		"jcy": "й",
		"Jfr": "𝔍",
		"jfr": "𝔧",
		"jmath": "ȷ",
		"Jopf": "𝕁",
		"jopf": "𝕛",
		"Jscr": "𝒥",
		"jscr": "𝒿",
		"Jsercy": "Ј",
		"jsercy": "ј",
		"Jukcy": "Є",
		"jukcy": "є",
		"Kappa": "Κ",
		"kappa": "κ",
		"kappav": "ϰ",
		"Kcedil": "Ķ",
		"kcedil": "ķ",
		"Kcy": "К",
		"kcy": "к",
		"Kfr": "𝔎",
		"kfr": "𝔨",
		"kgreen": "ĸ",
		"KHcy": "Х",
		"khcy": "х",
		"KJcy": "Ќ",
		"kjcy": "ќ",
		"Kopf": "𝕂",
		"kopf": "𝕜",
		"Kscr": "𝒦",
		"kscr": "𝓀",
		"lAarr": "⇚",
		"Lacute": "Ĺ",
		"lacute": "ĺ",
		"laemptyv": "⦴",
		"lagran": "ℒ",
		"Lambda": "Λ",
		"lambda": "λ",
		"lang": "⟨",
		"Lang": "⟪",
		"langd": "⦑",
		"langle": "⟨",
		"lap": "⪅",
		"Laplacetrf": "ℒ",
		"laquo": "«",
		"larrb": "⇤",
		"larrbfs": "⤟",
		"larr": "←",
		"Larr": "↞",
		"lArr": "⇐",
		"larrfs": "⤝",
		"larrhk": "↩",
		"larrlp": "↫",
		"larrpl": "⤹",
		"larrsim": "⥳",
		"larrtl": "↢",
		"latail": "⤙",
		"lAtail": "⤛",
		"lat": "⪫",
		"late": "⪭",
		"lates": "⪭︀",
		"lbarr": "⤌",
		"lBarr": "⤎",
		"lbbrk": "❲",
		"lbrace": "{",
		"lbrack": "[",
		"lbrke": "⦋",
		"lbrksld": "⦏",
		"lbrkslu": "⦍",
		"Lcaron": "Ľ",
		"lcaron": "ľ",
		"Lcedil": "Ļ",
		"lcedil": "ļ",
		"lceil": "⌈",
		"lcub": "{",
		"Lcy": "Л",
		"lcy": "л",
		"ldca": "⤶",
		"ldquo": "“",
		"ldquor": "„",
		"ldrdhar": "⥧",
		"ldrushar": "⥋",
		"ldsh": "↲",
		"le": "≤",
		"lE": "≦",
		"LeftAngleBracket": "⟨",
		"LeftArrowBar": "⇤",
		"leftarrow": "←",
		"LeftArrow": "←",
		"Leftarrow": "⇐",
		"LeftArrowRightArrow": "⇆",
		"leftarrowtail": "↢",
		"LeftCeiling": "⌈",
		"LeftDoubleBracket": "⟦",
		"LeftDownTeeVector": "⥡",
		"LeftDownVectorBar": "⥙",
		"LeftDownVector": "⇃",
		"LeftFloor": "⌊",
		"leftharpoondown": "↽",
		"leftharpoonup": "↼",
		"leftleftarrows": "⇇",
		"leftrightarrow": "↔",
		"LeftRightArrow": "↔",
		"Leftrightarrow": "⇔",
		"leftrightarrows": "⇆",
		"leftrightharpoons": "⇋",
		"leftrightsquigarrow": "↭",
		"LeftRightVector": "⥎",
		"LeftTeeArrow": "↤",
		"LeftTee": "⊣",
		"LeftTeeVector": "⥚",
		"leftthreetimes": "⋋",
		"LeftTriangleBar": "⧏",
		"LeftTriangle": "⊲",
		"LeftTriangleEqual": "⊴",
		"LeftUpDownVector": "⥑",
		"LeftUpTeeVector": "⥠",
		"LeftUpVectorBar": "⥘",
		"LeftUpVector": "↿",
		"LeftVectorBar": "⥒",
		"LeftVector": "↼",
		"lEg": "⪋",
		"leg": "⋚",
		"leq": "≤",
		"leqq": "≦",
		"leqslant": "⩽",
		"lescc": "⪨",
		"les": "⩽",
		"lesdot": "⩿",
		"lesdoto": "⪁",
		"lesdotor": "⪃",
		"lesg": "⋚︀",
		"lesges": "⪓",
		"lessapprox": "⪅",
		"lessdot": "⋖",
		"lesseqgtr": "⋚",
		"lesseqqgtr": "⪋",
		"LessEqualGreater": "⋚",
		"LessFullEqual": "≦",
		"LessGreater": "≶",
		"lessgtr": "≶",
		"LessLess": "⪡",
		"lesssim": "≲",
		"LessSlantEqual": "⩽",
		"LessTilde": "≲",
		"lfisht": "⥼",
		"lfloor": "⌊",
		"Lfr": "𝔏",
		"lfr": "𝔩",
		"lg": "≶",
		"lgE": "⪑",
		"lHar": "⥢",
		"lhard": "↽",
		"lharu": "↼",
		"lharul": "⥪",
		"lhblk": "▄",
		"LJcy": "Љ",
		"ljcy": "љ",
		"llarr": "⇇",
		"ll": "≪",
		"Ll": "⋘",
		"llcorner": "⌞",
		"Lleftarrow": "⇚",
		"llhard": "⥫",
		"lltri": "◺",
		"Lmidot": "Ŀ",
		"lmidot": "ŀ",
		"lmoustache": "⎰",
		"lmoust": "⎰",
		"lnap": "⪉",
		"lnapprox": "⪉",
		"lne": "⪇",
		"lnE": "≨",
		"lneq": "⪇",
		"lneqq": "≨",
		"lnsim": "⋦",
		"loang": "⟬",
		"loarr": "⇽",
		"lobrk": "⟦",
		"longleftarrow": "⟵",
		"LongLeftArrow": "⟵",
		"Longleftarrow": "⟸",
		"longleftrightarrow": "⟷",
		"LongLeftRightArrow": "⟷",
		"Longleftrightarrow": "⟺",
		"longmapsto": "⟼",
		"longrightarrow": "⟶",
		"LongRightArrow": "⟶",
		"Longrightarrow": "⟹",
		"looparrowleft": "↫",
		"looparrowright": "↬",
		"lopar": "⦅",
		"Lopf": "𝕃",
		"lopf": "𝕝",
		"loplus": "⨭",
		"lotimes": "⨴",
		"lowast": "∗",
		"lowbar": "_",
		"LowerLeftArrow": "↙",
		"LowerRightArrow": "↘",
		"loz": "◊",
		"lozenge": "◊",
		"lozf": "⧫",
		"lpar": "(",
		"lparlt": "⦓",
		"lrarr": "⇆",
		"lrcorner": "⌟",
		"lrhar": "⇋",
		"lrhard": "⥭",
		"lrm": "‎",
		"lrtri": "⊿",
		"lsaquo": "‹",
		"lscr": "𝓁",
		"Lscr": "ℒ",
		"lsh": "↰",
		"Lsh": "↰",
		"lsim": "≲",
		"lsime": "⪍",
		"lsimg": "⪏",
		"lsqb": "[",
		"lsquo": "‘",
		"lsquor": "‚",
		"Lstrok": "Ł",
		"lstrok": "ł",
		"ltcc": "⪦",
		"ltcir": "⩹",
		"lt": "<",
		"LT": "<",
		"Lt": "≪",
		"ltdot": "⋖",
		"lthree": "⋋",
		"ltimes": "⋉",
		"ltlarr": "⥶",
		"ltquest": "⩻",
		"ltri": "◃",
		"ltrie": "⊴",
		"ltrif": "◂",
		"ltrPar": "⦖",
		"lurdshar": "⥊",
		"luruhar": "⥦",
		"lvertneqq": "≨︀",
		"lvnE": "≨︀",
		"macr": "¯",
		"male": "♂",
		"malt": "✠",
		"maltese": "✠",
		"Map": "⤅",
		"map": "↦",
		"mapsto": "↦",
		"mapstodown": "↧",
		"mapstoleft": "↤",
		"mapstoup": "↥",
		"marker": "▮",
		"mcomma": "⨩",
		"Mcy": "М",
		"mcy": "м",
		"mdash": "—",
		"mDDot": "∺",
		"measuredangle": "∡",
		"MediumSpace": " ",
		"Mellintrf": "ℳ",
		"Mfr": "𝔐",
		"mfr": "𝔪",
		"mho": "℧",
		"micro": "µ",
		"midast": "*",
		"midcir": "⫰",
		"mid": "∣",
		"middot": "·",
		"minusb": "⊟",
		"minus": "−",
		"minusd": "∸",
		"minusdu": "⨪",
		"MinusPlus": "∓",
		"mlcp": "⫛",
		"mldr": "…",
		"mnplus": "∓",
		"models": "⊧",
		"Mopf": "𝕄",
		"mopf": "𝕞",
		"mp": "∓",
		"mscr": "𝓂",
		"Mscr": "ℳ",
		"mstpos": "∾",
		"Mu": "Μ",
		"mu": "μ",
		"multimap": "⊸",
		"mumap": "⊸",
		"nabla": "∇",
		"Nacute": "Ń",
		"nacute": "ń",
		"nang": "∠⃒",
		"nap": "≉",
		"napE": "⩰̸",
		"napid": "≋̸",
		"napos": "ŉ",
		"napprox": "≉",
		"natural": "♮",
		"naturals": "ℕ",
		"natur": "♮",
		"nbsp": " ",
		"nbump": "≎̸",
		"nbumpe": "≏̸",
		"ncap": "⩃",
		"Ncaron": "Ň",
		"ncaron": "ň",
		"Ncedil": "Ņ",
		"ncedil": "ņ",
		"ncong": "≇",
		"ncongdot": "⩭̸",
		"ncup": "⩂",
		"Ncy": "Н",
		"ncy": "н",
		"ndash": "–",
		"nearhk": "⤤",
		"nearr": "↗",
		"neArr": "⇗",
		"nearrow": "↗",
		"ne": "≠",
		"nedot": "≐̸",
		"NegativeMediumSpace": "​",
		"NegativeThickSpace": "​",
		"NegativeThinSpace": "​",
		"NegativeVeryThinSpace": "​",
		"nequiv": "≢",
		"nesear": "⤨",
		"nesim": "≂̸",
		"NestedGreaterGreater": "≫",
		"NestedLessLess": "≪",
		"NewLine": "\n",
		"nexist": "∄",
		"nexists": "∄",
		"Nfr": "𝔑",
		"nfr": "𝔫",
		"ngE": "≧̸",
		"nge": "≱",
		"ngeq": "≱",
		"ngeqq": "≧̸",
		"ngeqslant": "⩾̸",
		"nges": "⩾̸",
		"nGg": "⋙̸",
		"ngsim": "≵",
		"nGt": "≫⃒",
		"ngt": "≯",
		"ngtr": "≯",
		"nGtv": "≫̸",
		"nharr": "↮",
		"nhArr": "⇎",
		"nhpar": "⫲",
		"ni": "∋",
		"nis": "⋼",
		"nisd": "⋺",
		"niv": "∋",
		"NJcy": "Њ",
		"njcy": "њ",
		"nlarr": "↚",
		"nlArr": "⇍",
		"nldr": "‥",
		"nlE": "≦̸",
		"nle": "≰",
		"nleftarrow": "↚",
		"nLeftarrow": "⇍",
		"nleftrightarrow": "↮",
		"nLeftrightarrow": "⇎",
		"nleq": "≰",
		"nleqq": "≦̸",
		"nleqslant": "⩽̸",
		"nles": "⩽̸",
		"nless": "≮",
		"nLl": "⋘̸",
		"nlsim": "≴",
		"nLt": "≪⃒",
		"nlt": "≮",
		"nltri": "⋪",
		"nltrie": "⋬",
		"nLtv": "≪̸",
		"nmid": "∤",
		"NoBreak": "⁠",
		"NonBreakingSpace": " ",
		"nopf": "𝕟",
		"Nopf": "ℕ",
		"Not": "⫬",
		"not": "¬",
		"NotCongruent": "≢",
		"NotCupCap": "≭",
		"NotDoubleVerticalBar": "∦",
		"NotElement": "∉",
		"NotEqual": "≠",
		"NotEqualTilde": "≂̸",
		"NotExists": "∄",
		"NotGreater": "≯",
		"NotGreaterEqual": "≱",
		"NotGreaterFullEqual": "≧̸",
		"NotGreaterGreater": "≫̸",
		"NotGreaterLess": "≹",
		"NotGreaterSlantEqual": "⩾̸",
		"NotGreaterTilde": "≵",
		"NotHumpDownHump": "≎̸",
		"NotHumpEqual": "≏̸",
		"notin": "∉",
		"notindot": "⋵̸",
		"notinE": "⋹̸",
		"notinva": "∉",
		"notinvb": "⋷",
		"notinvc": "⋶",
		"NotLeftTriangleBar": "⧏̸",
		"NotLeftTriangle": "⋪",
		"NotLeftTriangleEqual": "⋬",
		"NotLess": "≮",
		"NotLessEqual": "≰",
		"NotLessGreater": "≸",
		"NotLessLess": "≪̸",
		"NotLessSlantEqual": "⩽̸",
		"NotLessTilde": "≴",
		"NotNestedGreaterGreater": "⪢̸",
		"NotNestedLessLess": "⪡̸",
		"notni": "∌",
		"notniva": "∌",
		"notnivb": "⋾",
		"notnivc": "⋽",
		"NotPrecedes": "⊀",
		"NotPrecedesEqual": "⪯̸",
		"NotPrecedesSlantEqual": "⋠",
		"NotReverseElement": "∌",
		"NotRightTriangleBar": "⧐̸",
		"NotRightTriangle": "⋫",
		"NotRightTriangleEqual": "⋭",
		"NotSquareSubset": "⊏̸",
		"NotSquareSubsetEqual": "⋢",
		"NotSquareSuperset": "⊐̸",
		"NotSquareSupersetEqual": "⋣",
		"NotSubset": "⊂⃒",
		"NotSubsetEqual": "⊈",
		"NotSucceeds": "⊁",
		"NotSucceedsEqual": "⪰̸",
		"NotSucceedsSlantEqual": "⋡",
		"NotSucceedsTilde": "≿̸",
		"NotSuperset": "⊃⃒",
		"NotSupersetEqual": "⊉",
		"NotTilde": "≁",
		"NotTildeEqual": "≄",
		"NotTildeFullEqual": "≇",
		"NotTildeTilde": "≉",
		"NotVerticalBar": "∤",
		"nparallel": "∦",
		"npar": "∦",
		"nparsl": "⫽⃥",
		"npart": "∂̸",
		"npolint": "⨔",
		"npr": "⊀",
		"nprcue": "⋠",
		"nprec": "⊀",
		"npreceq": "⪯̸",
		"npre": "⪯̸",
		"nrarrc": "⤳̸",
		"nrarr": "↛",
		"nrArr": "⇏",
		"nrarrw": "↝̸",
		"nrightarrow": "↛",
		"nRightarrow": "⇏",
		"nrtri": "⋫",
		"nrtrie": "⋭",
		"nsc": "⊁",
		"nsccue": "⋡",
		"nsce": "⪰̸",
		"Nscr": "𝒩",
		"nscr": "𝓃",
		"nshortmid": "∤",
		"nshortparallel": "∦",
		"nsim": "≁",
		"nsime": "≄",
		"nsimeq": "≄",
		"nsmid": "∤",
		"nspar": "∦",
		"nsqsube": "⋢",
		"nsqsupe": "⋣",
		"nsub": "⊄",
		"nsubE": "⫅̸",
		"nsube": "⊈",
		"nsubset": "⊂⃒",
		"nsubseteq": "⊈",
		"nsubseteqq": "⫅̸",
		"nsucc": "⊁",
		"nsucceq": "⪰̸",
		"nsup": "⊅",
		"nsupE": "⫆̸",
		"nsupe": "⊉",
		"nsupset": "⊃⃒",
		"nsupseteq": "⊉",
		"nsupseteqq": "⫆̸",
		"ntgl": "≹",
		"Ntilde": "Ñ",
		"ntilde": "ñ",
		"ntlg": "≸",
		"ntriangleleft": "⋪",
		"ntrianglelefteq": "⋬",
		"ntriangleright": "⋫",
		"ntrianglerighteq": "⋭",
		"Nu": "Ν",
		"nu": "ν",
		"num": "#",
		"numero": "№",
		"numsp": " ",
		"nvap": "≍⃒",
		"nvdash": "⊬",
		"nvDash": "⊭",
		"nVdash": "⊮",
		"nVDash": "⊯",
		"nvge": "≥⃒",
		"nvgt": ">⃒",
		"nvHarr": "⤄",
		"nvinfin": "⧞",
		"nvlArr": "⤂",
		"nvle": "≤⃒",
		"nvlt": "<⃒",
		"nvltrie": "⊴⃒",
		"nvrArr": "⤃",
		"nvrtrie": "⊵⃒",
		"nvsim": "∼⃒",
		"nwarhk": "⤣",
		"nwarr": "↖",
		"nwArr": "⇖",
		"nwarrow": "↖",
		"nwnear": "⤧",
		"Oacute": "Ó",
		"oacute": "ó",
		"oast": "⊛",
		"Ocirc": "Ô",
		"ocirc": "ô",
		"ocir": "⊚",
		"Ocy": "О",
		"ocy": "о",
		"odash": "⊝",
		"Odblac": "Ő",
		"odblac": "ő",
		"odiv": "⨸",
		"odot": "⊙",
		"odsold": "⦼",
		"OElig": "Œ",
		"oelig": "œ",
		"ofcir": "⦿",
		"Ofr": "𝔒",
		"ofr": "𝔬",
		"ogon": "˛",
		"Ograve": "Ò",
		"ograve": "ò",
		"ogt": "⧁",
		"ohbar": "⦵",
		"ohm": "Ω",
		"oint": "∮",
		"olarr": "↺",
		"olcir": "⦾",
		"olcross": "⦻",
		"oline": "‾",
		"olt": "⧀",
		"Omacr": "Ō",
		"omacr": "ō",
		"Omega": "Ω",
		"omega": "ω",
		"Omicron": "Ο",
		"omicron": "ο",
		"omid": "⦶",
		"ominus": "⊖",
		"Oopf": "𝕆",
		"oopf": "𝕠",
		"opar": "⦷",
		"OpenCurlyDoubleQuote": "“",
		"OpenCurlyQuote": "‘",
		"operp": "⦹",
		"oplus": "⊕",
		"orarr": "↻",
		"Or": "⩔",
		"or": "∨",
		"ord": "⩝",
		"order": "ℴ",
		"orderof": "ℴ",
		"ordf": "ª",
		"ordm": "º",
		"origof": "⊶",
		"oror": "⩖",
		"orslope": "⩗",
		"orv": "⩛",
		"oS": "Ⓢ",
		"Oscr": "𝒪",
		"oscr": "ℴ",
		"Oslash": "Ø",
		"oslash": "ø",
		"osol": "⊘",
		"Otilde": "Õ",
		"otilde": "õ",
		"otimesas": "⨶",
		"Otimes": "⨷",
		"otimes": "⊗",
		"Ouml": "Ö",
		"ouml": "ö",
		"ovbar": "⌽",
		"OverBar": "‾",
		"OverBrace": "⏞",
		"OverBracket": "⎴",
		"OverParenthesis": "⏜",
		"para": "¶",
		"parallel": "∥",
		"par": "∥",
		"parsim": "⫳",
		"parsl": "⫽",
		"part": "∂",
		"PartialD": "∂",
		"Pcy": "П",
		"pcy": "п",
		"percnt": "%",
		"period": ".",
		"permil": "‰",
		"perp": "⊥",
		"pertenk": "‱",
		"Pfr": "𝔓",
		"pfr": "𝔭",
		"Phi": "Φ",
		"phi": "φ",
		"phiv": "ϕ",
		"phmmat": "ℳ",
		"phone": "☎",
		"Pi": "Π",
		"pi": "π",
		"pitchfork": "⋔",
		"piv": "ϖ",
		"planck": "ℏ",
		"planckh": "ℎ",
		"plankv": "ℏ",
		"plusacir": "⨣",
		"plusb": "⊞",
		"pluscir": "⨢",
		"plus": "+",
		"plusdo": "∔",
		"plusdu": "⨥",
		"pluse": "⩲",
		"PlusMinus": "±",
		"plusmn": "±",
		"plussim": "⨦",
		"plustwo": "⨧",
		"pm": "±",
		"Poincareplane": "ℌ",
		"pointint": "⨕",
		"popf": "𝕡",
		"Popf": "ℙ",
		"pound": "£",
		"prap": "⪷",
		"Pr": "⪻",
		"pr": "≺",
		"prcue": "≼",
		"precapprox": "⪷",
		"prec": "≺",
		"preccurlyeq": "≼",
		"Precedes": "≺",
		"PrecedesEqual": "⪯",
		"PrecedesSlantEqual": "≼",
		"PrecedesTilde": "≾",
		"preceq": "⪯",
		"precnapprox": "⪹",
		"precneqq": "⪵",
		"precnsim": "⋨",
		"pre": "⪯",
		"prE": "⪳",
		"precsim": "≾",
		"prime": "′",
		"Prime": "″",
		"primes": "ℙ",
		"prnap": "⪹",
		"prnE": "⪵",
		"prnsim": "⋨",
		"prod": "∏",
		"Product": "∏",
		"profalar": "⌮",
		"profline": "⌒",
		"profsurf": "⌓",
		"prop": "∝",
		"Proportional": "∝",
		"Proportion": "∷",
		"propto": "∝",
		"prsim": "≾",
		"prurel": "⊰",
		"Pscr": "𝒫",
		"pscr": "𝓅",
		"Psi": "Ψ",
		"psi": "ψ",
		"puncsp": " ",
		"Qfr": "𝔔",
		"qfr": "𝔮",
		"qint": "⨌",
		"qopf": "𝕢",
		"Qopf": "ℚ",
		"qprime": "⁗",
		"Qscr": "𝒬",
		"qscr": "𝓆",
		"quaternions": "ℍ",
		"quatint": "⨖",
		"quest": "?",
		"questeq": "≟",
		"quot": "\"",
		"QUOT": "\"",
		"rAarr": "⇛",
		"race": "∽̱",
		"Racute": "Ŕ",
		"racute": "ŕ",
		"radic": "√",
		"raemptyv": "⦳",
		"rang": "⟩",
		"Rang": "⟫",
		"rangd": "⦒",
		"range": "⦥",
		"rangle": "⟩",
		"raquo": "»",
		"rarrap": "⥵",
		"rarrb": "⇥",
		"rarrbfs": "⤠",
		"rarrc": "⤳",
		"rarr": "→",
		"Rarr": "↠",
		"rArr": "⇒",
		"rarrfs": "⤞",
		"rarrhk": "↪",
		"rarrlp": "↬",
		"rarrpl": "⥅",
		"rarrsim": "⥴",
		"Rarrtl": "⤖",
		"rarrtl": "↣",
		"rarrw": "↝",
		"ratail": "⤚",
		"rAtail": "⤜",
		"ratio": "∶",
		"rationals": "ℚ",
		"rbarr": "⤍",
		"rBarr": "⤏",
		"RBarr": "⤐",
		"rbbrk": "❳",
		"rbrace": "}",
		"rbrack": "]",
		"rbrke": "⦌",
		"rbrksld": "⦎",
		"rbrkslu": "⦐",
		"Rcaron": "Ř",
		"rcaron": "ř",
		"Rcedil": "Ŗ",
		"rcedil": "ŗ",
		"rceil": "⌉",
		"rcub": "}",
		"Rcy": "Р",
		"rcy": "р",
		"rdca": "⤷",
		"rdldhar": "⥩",
		"rdquo": "”",
		"rdquor": "”",
		"rdsh": "↳",
		"real": "ℜ",
		"realine": "ℛ",
		"realpart": "ℜ",
		"reals": "ℝ",
		"Re": "ℜ",
		"rect": "▭",
		"reg": "®",
		"REG": "®",
		"ReverseElement": "∋",
		"ReverseEquilibrium": "⇋",
		"ReverseUpEquilibrium": "⥯",
		"rfisht": "⥽",
		"rfloor": "⌋",
		"rfr": "𝔯",
		"Rfr": "ℜ",
		"rHar": "⥤",
		"rhard": "⇁",
		"rharu": "⇀",
		"rharul": "⥬",
		"Rho": "Ρ",
		"rho": "ρ",
		"rhov": "ϱ",
		"RightAngleBracket": "⟩",
		"RightArrowBar": "⇥",
		"rightarrow": "→",
		"RightArrow": "→",
		"Rightarrow": "⇒",
		"RightArrowLeftArrow": "⇄",
		"rightarrowtail": "↣",
		"RightCeiling": "⌉",
		"RightDoubleBracket": "⟧",
		"RightDownTeeVector": "⥝",
		"RightDownVectorBar": "⥕",
		"RightDownVector": "⇂",
		"RightFloor": "⌋",
		"rightharpoondown": "⇁",
		"rightharpoonup": "⇀",
		"rightleftarrows": "⇄",
		"rightleftharpoons": "⇌",
		"rightrightarrows": "⇉",
		"rightsquigarrow": "↝",
		"RightTeeArrow": "↦",
		"RightTee": "⊢",
		"RightTeeVector": "⥛",
		"rightthreetimes": "⋌",
		"RightTriangleBar": "⧐",
		"RightTriangle": "⊳",
		"RightTriangleEqual": "⊵",
		"RightUpDownVector": "⥏",
		"RightUpTeeVector": "⥜",
		"RightUpVectorBar": "⥔",
		"RightUpVector": "↾",
		"RightVectorBar": "⥓",
		"RightVector": "⇀",
		"ring": "˚",
		"risingdotseq": "≓",
		"rlarr": "⇄",
		"rlhar": "⇌",
		"rlm": "‏",
		"rmoustache": "⎱",
		"rmoust": "⎱",
		"rnmid": "⫮",
		"roang": "⟭",
		"roarr": "⇾",
		"robrk": "⟧",
		"ropar": "⦆",
		"ropf": "𝕣",
		"Ropf": "ℝ",
		"roplus": "⨮",
		"rotimes": "⨵",
		"RoundImplies": "⥰",
		"rpar": ")",
		"rpargt": "⦔",
		"rppolint": "⨒",
		"rrarr": "⇉",
		"Rrightarrow": "⇛",
		"rsaquo": "›",
		"rscr": "𝓇",
		"Rscr": "ℛ",
		"rsh": "↱",
		"Rsh": "↱",
		"rsqb": "]",
		"rsquo": "’",
		"rsquor": "’",
		"rthree": "⋌",
		"rtimes": "⋊",
		"rtri": "▹",
		"rtrie": "⊵",
		"rtrif": "▸",
		"rtriltri": "⧎",
		"RuleDelayed": "⧴",
		"ruluhar": "⥨",
		"rx": "℞",
		"Sacute": "Ś",
		"sacute": "ś",
		"sbquo": "‚",
		"scap": "⪸",
		"Scaron": "Š",
		"scaron": "š",
		"Sc": "⪼",
		"sc": "≻",
		"sccue": "≽",
		"sce": "⪰",
		"scE": "⪴",
		"Scedil": "Ş",
		"scedil": "ş",
		"Scirc": "Ŝ",
		"scirc": "ŝ",
		"scnap": "⪺",
		"scnE": "⪶",
		"scnsim": "⋩",
		"scpolint": "⨓",
		"scsim": "≿",
		"Scy": "С",
		"scy": "с",
		"sdotb": "⊡",
		"sdot": "⋅",
		"sdote": "⩦",
		"searhk": "⤥",
		"searr": "↘",
		"seArr": "⇘",
		"searrow": "↘",
		"sect": "§",
		"semi": ";",
		"seswar": "⤩",
		"setminus": "∖",
		"setmn": "∖",
		"sext": "✶",
		"Sfr": "𝔖",
		"sfr": "𝔰",
		"sfrown": "⌢",
		"sharp": "♯",
		"SHCHcy": "Щ",
		"shchcy": "щ",
		"SHcy": "Ш",
		"shcy": "ш",
		"ShortDownArrow": "↓",
		"ShortLeftArrow": "←",
		"shortmid": "∣",
		"shortparallel": "∥",
		"ShortRightArrow": "→",
		"ShortUpArrow": "↑",
		"shy": "­",
		"Sigma": "Σ",
		"sigma": "σ",
		"sigmaf": "ς",
		"sigmav": "ς",
		"sim": "∼",
		"simdot": "⩪",
		"sime": "≃",
		"simeq": "≃",
		"simg": "⪞",
		"simgE": "⪠",
		"siml": "⪝",
		"simlE": "⪟",
		"simne": "≆",
		"simplus": "⨤",
		"simrarr": "⥲",
		"slarr": "←",
		"SmallCircle": "∘",
		"smallsetminus": "∖",
		"smashp": "⨳",
		"smeparsl": "⧤",
		"smid": "∣",
		"smile": "⌣",
		"smt": "⪪",
		"smte": "⪬",
		"smtes": "⪬︀",
		"SOFTcy": "Ь",
		"softcy": "ь",
		"solbar": "⌿",
		"solb": "⧄",
		"sol": "/",
		"Sopf": "𝕊",
		"sopf": "𝕤",
		"spades": "♠",
		"spadesuit": "♠",
		"spar": "∥",
		"sqcap": "⊓",
		"sqcaps": "⊓︀",
		"sqcup": "⊔",
		"sqcups": "⊔︀",
		"Sqrt": "√",
		"sqsub": "⊏",
		"sqsube": "⊑",
		"sqsubset": "⊏",
		"sqsubseteq": "⊑",
		"sqsup": "⊐",
		"sqsupe": "⊒",
		"sqsupset": "⊐",
		"sqsupseteq": "⊒",
		"square": "□",
		"Square": "□",
		"SquareIntersection": "⊓",
		"SquareSubset": "⊏",
		"SquareSubsetEqual": "⊑",
		"SquareSuperset": "⊐",
		"SquareSupersetEqual": "⊒",
		"SquareUnion": "⊔",
		"squarf": "▪",
		"squ": "□",
		"squf": "▪",
		"srarr": "→",
		"Sscr": "𝒮",
		"sscr": "𝓈",
		"ssetmn": "∖",
		"ssmile": "⌣",
		"sstarf": "⋆",
		"Star": "⋆",
		"star": "☆",
		"starf": "★",
		"straightepsilon": "ϵ",
		"straightphi": "ϕ",
		"strns": "¯",
		"sub": "⊂",
		"Sub": "⋐",
		"subdot": "⪽",
		"subE": "⫅",
		"sube": "⊆",
		"subedot": "⫃",
		"submult": "⫁",
		"subnE": "⫋",
		"subne": "⊊",
		"subplus": "⪿",
		"subrarr": "⥹",
		"subset": "⊂",
		"Subset": "⋐",
		"subseteq": "⊆",
		"subseteqq": "⫅",
		"SubsetEqual": "⊆",
		"subsetneq": "⊊",
		"subsetneqq": "⫋",
		"subsim": "⫇",
		"subsub": "⫕",
		"subsup": "⫓",
		"succapprox": "⪸",
		"succ": "≻",
		"succcurlyeq": "≽",
		"Succeeds": "≻",
		"SucceedsEqual": "⪰",
		"SucceedsSlantEqual": "≽",
		"SucceedsTilde": "≿",
		"succeq": "⪰",
		"succnapprox": "⪺",
		"succneqq": "⪶",
		"succnsim": "⋩",
		"succsim": "≿",
		"SuchThat": "∋",
		"sum": "∑",
		"Sum": "∑",
		"sung": "♪",
		"sup1": "¹",
		"sup2": "²",
		"sup3": "³",
		"sup": "⊃",
		"Sup": "⋑",
		"supdot": "⪾",
		"supdsub": "⫘",
		"supE": "⫆",
		"supe": "⊇",
		"supedot": "⫄",
		"Superset": "⊃",
		"SupersetEqual": "⊇",
		"suphsol": "⟉",
		"suphsub": "⫗",
		"suplarr": "⥻",
		"supmult": "⫂",
		"supnE": "⫌",
		"supne": "⊋",
		"supplus": "⫀",
		"supset": "⊃",
		"Supset": "⋑",
		"supseteq": "⊇",
		"supseteqq": "⫆",
		"supsetneq": "⊋",
		"supsetneqq": "⫌",
		"supsim": "⫈",
		"supsub": "⫔",
		"supsup": "⫖",
		"swarhk": "⤦",
		"swarr": "↙",
		"swArr": "⇙",
		"swarrow": "↙",
		"swnwar": "⤪",
		"szlig": "ß",
		"Tab": "\t",
		"target": "⌖",
		"Tau": "Τ",
		"tau": "τ",
		"tbrk": "⎴",
		"Tcaron": "Ť",
		"tcaron": "ť",
		"Tcedil": "Ţ",
		"tcedil": "ţ",
		"Tcy": "Т",
		"tcy": "т",
		"tdot": "⃛",
		"telrec": "⌕",
		"Tfr": "𝔗",
		"tfr": "𝔱",
		"there4": "∴",
		"therefore": "∴",
		"Therefore": "∴",
		"Theta": "Θ",
		"theta": "θ",
		"thetasym": "ϑ",
		"thetav": "ϑ",
		"thickapprox": "≈",
		"thicksim": "∼",
		"ThickSpace": "  ",
		"ThinSpace": " ",
		"thinsp": " ",
		"thkap": "≈",
		"thksim": "∼",
		"THORN": "Þ",
		"thorn": "þ",
		"tilde": "˜",
		"Tilde": "∼",
		"TildeEqual": "≃",
		"TildeFullEqual": "≅",
		"TildeTilde": "≈",
		"timesbar": "⨱",
		"timesb": "⊠",
		"times": "×",
		"timesd": "⨰",
		"tint": "∭",
		"toea": "⤨",
		"topbot": "⌶",
		"topcir": "⫱",
		"top": "⊤",
		"Topf": "𝕋",
		"topf": "𝕥",
		"topfork": "⫚",
		"tosa": "⤩",
		"tprime": "‴",
		"trade": "™",
		"TRADE": "™",
		"triangle": "▵",
		"triangledown": "▿",
		"triangleleft": "◃",
		"trianglelefteq": "⊴",
		"triangleq": "≜",
		"triangleright": "▹",
		"trianglerighteq": "⊵",
		"tridot": "◬",
		"trie": "≜",
		"triminus": "⨺",
		"TripleDot": "⃛",
		"triplus": "⨹",
		"trisb": "⧍",
		"tritime": "⨻",
		"trpezium": "⏢",
		"Tscr": "𝒯",
		"tscr": "𝓉",
		"TScy": "Ц",
		"tscy": "ц",
		"TSHcy": "Ћ",
		"tshcy": "ћ",
		"Tstrok": "Ŧ",
		"tstrok": "ŧ",
		"twixt": "≬",
		"twoheadleftarrow": "↞",
		"twoheadrightarrow": "↠",
		"Uacute": "Ú",
		"uacute": "ú",
		"uarr": "↑",
		"Uarr": "↟",
		"uArr": "⇑",
		"Uarrocir": "⥉",
		"Ubrcy": "Ў",
		"ubrcy": "ў",
		"Ubreve": "Ŭ",
		"ubreve": "ŭ",
		"Ucirc": "Û",
		"ucirc": "û",
		"Ucy": "У",
		"ucy": "у",
		"udarr": "⇅",
		"Udblac": "Ű",
		"udblac": "ű",
		"udhar": "⥮",
		"ufisht": "⥾",
		"Ufr": "𝔘",
		"ufr": "𝔲",
		"Ugrave": "Ù",
		"ugrave": "ù",
		"uHar": "⥣",
		"uharl": "↿",
		"uharr": "↾",
		"uhblk": "▀",
		"ulcorn": "⌜",
		"ulcorner": "⌜",
		"ulcrop": "⌏",
		"ultri": "◸",
		"Umacr": "Ū",
		"umacr": "ū",
		"uml": "¨",
		"UnderBar": "_",
		"UnderBrace": "⏟",
		"UnderBracket": "⎵",
		"UnderParenthesis": "⏝",
		"Union": "⋃",
		"UnionPlus": "⊎",
		"Uogon": "Ų",
		"uogon": "ų",
		"Uopf": "𝕌",
		"uopf": "𝕦",
		"UpArrowBar": "⤒",
		"uparrow": "↑",
		"UpArrow": "↑",
		"Uparrow": "⇑",
		"UpArrowDownArrow": "⇅",
		"updownarrow": "↕",
		"UpDownArrow": "↕",
		"Updownarrow": "⇕",
		"UpEquilibrium": "⥮",
		"upharpoonleft": "↿",
		"upharpoonright": "↾",
		"uplus": "⊎",
		"UpperLeftArrow": "↖",
		"UpperRightArrow": "↗",
		"upsi": "υ",
		"Upsi": "ϒ",
		"upsih": "ϒ",
		"Upsilon": "Υ",
		"upsilon": "υ",
		"UpTeeArrow": "↥",
		"UpTee": "⊥",
		"upuparrows": "⇈",
		"urcorn": "⌝",
		"urcorner": "⌝",
		"urcrop": "⌎",
		"Uring": "Ů",
		"uring": "ů",
		"urtri": "◹",
		"Uscr": "𝒰",
		"uscr": "𝓊",
		"utdot": "⋰",
		"Utilde": "Ũ",
		"utilde": "ũ",
		"utri": "▵",
		"utrif": "▴",
		"uuarr": "⇈",
		"Uuml": "Ü",
		"uuml": "ü",
		"uwangle": "⦧",
		"vangrt": "⦜",
		"varepsilon": "ϵ",
		"varkappa": "ϰ",
		"varnothing": "∅",
		"varphi": "ϕ",
		"varpi": "ϖ",
		"varpropto": "∝",
		"varr": "↕",
		"vArr": "⇕",
		"varrho": "ϱ",
		"varsigma": "ς",
		"varsubsetneq": "⊊︀",
		"varsubsetneqq": "⫋︀",
		"varsupsetneq": "⊋︀",
		"varsupsetneqq": "⫌︀",
		"vartheta": "ϑ",
		"vartriangleleft": "⊲",
		"vartriangleright": "⊳",
		"vBar": "⫨",
		"Vbar": "⫫",
		"vBarv": "⫩",
		"Vcy": "В",
		"vcy": "в",
		"vdash": "⊢",
		"vDash": "⊨",
		"Vdash": "⊩",
		"VDash": "⊫",
		"Vdashl": "⫦",
		"veebar": "⊻",
		"vee": "∨",
		"Vee": "⋁",
		"veeeq": "≚",
		"vellip": "⋮",
		"verbar": "|",
		"Verbar": "‖",
		"vert": "|",
		"Vert": "‖",
		"VerticalBar": "∣",
		"VerticalLine": "|",
		"VerticalSeparator": "❘",
		"VerticalTilde": "≀",
		"VeryThinSpace": " ",
		"Vfr": "𝔙",
		"vfr": "𝔳",
		"vltri": "⊲",
		"vnsub": "⊂⃒",
		"vnsup": "⊃⃒",
		"Vopf": "𝕍",
		"vopf": "𝕧",
		"vprop": "∝",
		"vrtri": "⊳",
		"Vscr": "𝒱",
		"vscr": "𝓋",
		"vsubnE": "⫋︀",
		"vsubne": "⊊︀",
		"vsupnE": "⫌︀",
		"vsupne": "⊋︀",
		"Vvdash": "⊪",
		"vzigzag": "⦚",
		"Wcirc": "Ŵ",
		"wcirc": "ŵ",
		"wedbar": "⩟",
		"wedge": "∧",
		"Wedge": "⋀",
		"wedgeq": "≙",
		"weierp": "℘",
		"Wfr": "𝔚",
		"wfr": "𝔴",
		"Wopf": "𝕎",
		"wopf": "𝕨",
		"wp": "℘",
		"wr": "≀",
		"wreath": "≀",
		"Wscr": "𝒲",
		"wscr": "𝓌",
		"xcap": "⋂",
		"xcirc": "◯",
		"xcup": "⋃",
		"xdtri": "▽",
		"Xfr": "𝔛",
		"xfr": "𝔵",
		"xharr": "⟷",
		"xhArr": "⟺",
		"Xi": "Ξ",
		"xi": "ξ",
		"xlarr": "⟵",
		"xlArr": "⟸",
		"xmap": "⟼",
		"xnis": "⋻",
		"xodot": "⨀",
		"Xopf": "𝕏",
		"xopf": "𝕩",
		"xoplus": "⨁",
		"xotime": "⨂",
		"xrarr": "⟶",
		"xrArr": "⟹",
		"Xscr": "𝒳",
		"xscr": "𝓍",
		"xsqcup": "⨆",
		"xuplus": "⨄",
		"xutri": "△",
		"xvee": "⋁",
		"xwedge": "⋀",
		"Yacute": "Ý",
		"yacute": "ý",
		"YAcy": "Я",
		"yacy": "я",
		"Ycirc": "Ŷ",
		"ycirc": "ŷ",
		"Ycy": "Ы",
		"ycy": "ы",
		"yen": "¥",
		"Yfr": "𝔜",
		"yfr": "𝔶",
		"YIcy": "Ї",
		"yicy": "ї",
		"Yopf": "𝕐",
		"yopf": "𝕪",
		"Yscr": "𝒴",
		"yscr": "𝓎",
		"YUcy": "Ю",
		"yucy": "ю",
		"yuml": "ÿ",
		"Yuml": "Ÿ",
		"Zacute": "Ź",
		"zacute": "ź",
		"Zcaron": "Ž",
		"zcaron": "ž",
		"Zcy": "З",
		"zcy": "з",
		"Zdot": "Ż",
		"zdot": "ż",
		"zeetrf": "ℨ",
		"ZeroWidthSpace": "​",
		"Zeta": "Ζ",
		"zeta": "ζ",
		"zfr": "𝔷",
		"Zfr": "ℨ",
		"ZHcy": "Ж",
		"zhcy": "ж",
		"zigrarr": "⇝",
		"zopf": "𝕫",
		"Zopf": "ℤ",
		"Zscr": "𝒵",
		"zscr": "𝓏",
		"zwj": "‍",
		"zwnj": "‌"
	};

/***/ },
/* 724 */
/***/ function(module, exports) {

	module.exports = {
		"amp": "&",
		"apos": "'",
		"gt": ">",
		"lt": "<",
		"quot": "\""
	};

/***/ },
/* 725 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(149),
	    root = __webpack_require__(84);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ },
/* 726 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(84);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ },
/* 727 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ },
/* 728 */
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(2071);
	
	/**
	 * A specialized version of `_.includes` for arrays without support for
	 * specifying an index to search from.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludes(array, value) {
	  var length = array == null ? 0 : array.length;
	  return !!length && baseIndexOf(array, value, 0) > -1;
	}
	
	module.exports = arrayIncludes;


/***/ },
/* 729 */
/***/ function(module, exports) {

	/**
	 * This function is like `arrayIncludes` except that it accepts a comparator.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @param {Function} comparator The comparator invoked per element.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludesWith(array, value, comparator) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (comparator(value, array[index])) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arrayIncludesWith;


/***/ },
/* 730 */
/***/ function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(2094),
	    isArguments = __webpack_require__(451),
	    isArray = __webpack_require__(43),
	    isBuffer = __webpack_require__(452),
	    isIndex = __webpack_require__(445),
	    isTypedArray = __webpack_require__(753);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ },
/* 731 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ },
/* 732 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(438),
	    eq = __webpack_require__(289);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignValue;


/***/ },
/* 733 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseFindIndex;


/***/ },
/* 734 */
/***/ function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(2069),
	    keys = __webpack_require__(183);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ },
/* 735 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(437),
	    isArray = __webpack_require__(43);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ },
/* 736 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.gt` which doesn't coerce arguments.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if `value` is greater than `other`,
	 *  else `false`.
	 */
	function baseGt(value, other) {
	  return value > other;
	}
	
	module.exports = baseGt;


/***/ },
/* 737 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.lt` which doesn't coerce arguments.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if `value` is less than `other`,
	 *  else `false`.
	 */
	function baseLt(value, other) {
	  return value < other;
	}
	
	module.exports = baseLt;


/***/ },
/* 738 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(281),
	    isArrayLike = __webpack_require__(150);
	
	/**
	 * The base implementation of `_.map` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function baseMap(collection, iteratee) {
	  var index = -1,
	      result = isArrayLike(collection) ? Array(collection.length) : [];
	
	  baseEach(collection, function(value, key, collection) {
	    result[++index] = iteratee(value, key, collection);
	  });
	  return result;
	}
	
	module.exports = baseMap;


/***/ },
/* 739 */
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(181),
	    overRest = __webpack_require__(749),
	    setToString = __webpack_require__(750);
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	module.exports = baseRest;


/***/ },
/* 740 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(149);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ },
/* 741 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(435),
	    arraySome = __webpack_require__(731),
	    cacheHas = __webpack_require__(441);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Check that cyclic values are equal.
	  var arrStacked = stack.get(array);
	  var othStacked = stack.get(other);
	  if (arrStacked && othStacked) {
	    return arrStacked == other && othStacked == array;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ },
/* 742 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 743 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(735),
	    getSymbols = __webpack_require__(444),
	    keys = __webpack_require__(183);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ },
/* 744 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(735),
	    getSymbolsIn = __webpack_require__(745),
	    keysIn = __webpack_require__(454);
	
	/**
	 * Creates an array of own and inherited enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeysIn(object) {
	  return baseGetAllKeys(object, keysIn, getSymbolsIn);
	}
	
	module.exports = getAllKeysIn;


/***/ },
/* 745 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(437),
	    getPrototype = __webpack_require__(443),
	    getSymbols = __webpack_require__(444),
	    stubArray = __webpack_require__(760);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own and inherited enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	  var result = [];
	  while (object) {
	    arrayPush(result, getSymbols(object));
	    object = getPrototype(object);
	  }
	  return result;
	};
	
	module.exports = getSymbolsIn;


/***/ },
/* 746 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(72);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ },
/* 747 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ },
/* 748 */
/***/ function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ },
/* 749 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(2060);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ },
/* 750 */
/***/ function(module, exports, __webpack_require__) {

	var baseSetToString = __webpack_require__(2089),
	    shortOut = __webpack_require__(2153);
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ },
/* 751 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ },
/* 752 */
/***/ function(module, exports, __webpack_require__) {

	var arrayEvery = __webpack_require__(2062),
	    baseEvery = __webpack_require__(2067),
	    baseIteratee = __webpack_require__(80),
	    isArray = __webpack_require__(43),
	    isIterateeCall = __webpack_require__(287);
	
	/**
	 * Checks if `predicate` returns truthy for **all** elements of `collection`.
	 * Iteration is stopped once `predicate` returns falsey. The predicate is
	 * invoked with three arguments: (value, index|key, collection).
	 *
	 * **Note:** This method returns `true` for
	 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	 * elements of empty collections.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {boolean} Returns `true` if all elements pass the predicate check,
	 *  else `false`.
	 * @example
	 *
	 * _.every([true, 1, null, 'yes'], Boolean);
	 * // => false
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': false },
	 *   { 'user': 'fred',   'age': 40, 'active': false }
	 * ];
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.every(users, { 'user': 'barney', 'active': false });
	 * // => false
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.every(users, ['active', false]);
	 * // => true
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.every(users, 'active');
	 * // => false
	 */
	function every(collection, predicate, guard) {
	  var func = isArray(collection) ? arrayEvery : baseEvery;
	  if (guard && isIterateeCall(collection, predicate, guard)) {
	    predicate = undefined;
	  }
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = every;


/***/ },
/* 753 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(2080),
	    baseUnary = __webpack_require__(222),
	    nodeUtil = __webpack_require__(448);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ },
/* 754 */
/***/ function(module, exports) {

	/**
	 * Gets the last element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {*} Returns the last element of `array`.
	 * @example
	 *
	 * _.last([1, 2, 3]);
	 * // => 3
	 */
	function last(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? array[length - 1] : undefined;
	}
	
	module.exports = last;


/***/ },
/* 755 */
/***/ function(module, exports, __webpack_require__) {

	var baseExtremum = __webpack_require__(282),
	    baseGt = __webpack_require__(736),
	    identity = __webpack_require__(181);
	
	/**
	 * Computes the maximum value of `array`. If `array` is empty or falsey,
	 * `undefined` is returned.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @returns {*} Returns the maximum value.
	 * @example
	 *
	 * _.max([4, 2, 8, 6]);
	 * // => 8
	 *
	 * _.max([]);
	 * // => undefined
	 */
	function max(array) {
	  return (array && array.length)
	    ? baseExtremum(array, identity, baseGt)
	    : undefined;
	}
	
	module.exports = max;


/***/ },
/* 756 */
/***/ function(module, exports, __webpack_require__) {

	var baseExtremum = __webpack_require__(282),
	    baseGt = __webpack_require__(736),
	    baseIteratee = __webpack_require__(80);
	
	/**
	 * This method is like `_.max` except that it accepts `iteratee` which is
	 * invoked for each element in `array` to generate the criterion by which
	 * the value is ranked. The iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	 * @returns {*} Returns the maximum value.
	 * @example
	 *
	 * var objects = [{ 'n': 1 }, { 'n': 2 }];
	 *
	 * _.maxBy(objects, function(o) { return o.n; });
	 * // => { 'n': 2 }
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.maxBy(objects, 'n');
	 * // => { 'n': 2 }
	 */
	function maxBy(array, iteratee) {
	  return (array && array.length)
	    ? baseExtremum(array, baseIteratee(iteratee, 2), baseGt)
	    : undefined;
	}
	
	module.exports = maxBy;


/***/ },
/* 757 */
/***/ function(module, exports, __webpack_require__) {

	var baseExtremum = __webpack_require__(282),
	    baseLt = __webpack_require__(737),
	    identity = __webpack_require__(181);
	
	/**
	 * Computes the minimum value of `array`. If `array` is empty or falsey,
	 * `undefined` is returned.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @returns {*} Returns the minimum value.
	 * @example
	 *
	 * _.min([4, 2, 8, 6]);
	 * // => 2
	 *
	 * _.min([]);
	 * // => undefined
	 */
	function min(array) {
	  return (array && array.length)
	    ? baseExtremum(array, identity, baseLt)
	    : undefined;
	}
	
	module.exports = min;


/***/ },
/* 758 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(179),
	    baseClone = __webpack_require__(2065),
	    baseUnset = __webpack_require__(2098),
	    castPath = __webpack_require__(284),
	    copyObject = __webpack_require__(223),
	    customOmitClone = __webpack_require__(2116),
	    flatRest = __webpack_require__(2119),
	    getAllKeysIn = __webpack_require__(744);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_FLAT_FLAG = 2,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/**
	 * The opposite of `_.pick`; this method creates an object composed of the
	 * own and inherited enumerable property paths of `object` that are not omitted.
	 *
	 * **Note:** This method is considerably slower than `_.pick`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {...(string|string[])} [paths] The property paths to omit.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.omit(object, ['a', 'c']);
	 * // => { 'b': '2' }
	 */
	var omit = flatRest(function(object, paths) {
	  var result = {};
	  if (object == null) {
	    return result;
	  }
	  var isDeep = false;
	  paths = arrayMap(paths, function(path) {
	    path = castPath(path, object);
	    isDeep || (isDeep = path.length > 1);
	    return path;
	  });
	  copyObject(object, getAllKeysIn(object), result);
	  if (isDeep) {
	    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	  }
	  var length = paths.length;
	  while (length--) {
	    baseUnset(result, paths[length]);
	  }
	  return result;
	});
	
	module.exports = omit;


/***/ },
/* 759 */
/***/ function(module, exports, __webpack_require__) {

	var createRange = __webpack_require__(2114);
	
	/**
	 * Creates an array of numbers (positive and/or negative) progressing from
	 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	 * `start` is specified without an `end` or `step`. If `end` is not specified,
	 * it's set to `start` with `start` then set to `0`.
	 *
	 * **Note:** JavaScript follows the IEEE-754 standard for resolving
	 * floating-point values which can produce unexpected results.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {number} [start=0] The start of the range.
	 * @param {number} end The end of the range.
	 * @param {number} [step=1] The value to increment or decrement by.
	 * @returns {Array} Returns the range of numbers.
	 * @see _.inRange, _.rangeRight
	 * @example
	 *
	 * _.range(4);
	 * // => [0, 1, 2, 3]
	 *
	 * _.range(-4);
	 * // => [0, -1, -2, -3]
	 *
	 * _.range(1, 5);
	 * // => [1, 2, 3, 4]
	 *
	 * _.range(0, 20, 5);
	 * // => [0, 5, 10, 15]
	 *
	 * _.range(0, -4, -1);
	 * // => [0, -1, -2, -3]
	 *
	 * _.range(1, 4, 0);
	 * // => [1, 1, 1]
	 *
	 * _.range(0);
	 * // => []
	 */
	var range = createRange();
	
	module.exports = range;


/***/ },
/* 760 */
/***/ function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ },
/* 761 */
/***/ function(module, exports, __webpack_require__) {

	var debounce = __webpack_require__(450),
	    isObject = __webpack_require__(72);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a throttled function that only invokes `func` at most once per
	 * every `wait` milliseconds. The throttled function comes with a `cancel`
	 * method to cancel delayed `func` invocations and a `flush` method to
	 * immediately invoke them. Provide `options` to indicate whether `func`
	 * should be invoked on the leading and/or trailing edge of the `wait`
	 * timeout. The `func` is invoked with the last arguments provided to the
	 * throttled function. Subsequent calls to the throttled function return the
	 * result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the throttled function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.throttle` and `_.debounce`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to throttle.
	 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=true]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new throttled function.
	 * @example
	 *
	 * // Avoid excessively updating the position while scrolling.
	 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	 *
	 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	 * jQuery(element).on('click', throttled);
	 *
	 * // Cancel the trailing throttled invocation.
	 * jQuery(window).on('popstate', throttled.cancel);
	 */
	function throttle(func, wait, options) {
	  var leading = true,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  if (isObject(options)) {
	    leading = 'leading' in options ? !!options.leading : leading;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	  return debounce(func, wait, {
	    'leading': leading,
	    'maxWait': wait,
	    'trailing': trailing
	  });
	}
	
	module.exports = throttle;


/***/ },
/* 762 */
/***/ function(module, exports, __webpack_require__) {

	var toNumber = __webpack_require__(763);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308;
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	module.exports = toFinite;


/***/ },
/* 763 */
/***/ function(module, exports, __webpack_require__) {

	var baseTrim = __webpack_require__(2096),
	    isObject = __webpack_require__(72),
	    isSymbol = __webpack_require__(182);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = baseTrim(value);
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ },
/* 764 */
/***/ function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(80),
	    baseUniq = __webpack_require__(2097);
	
	/**
	 * This method is like `_.uniq` except that it accepts `iteratee` which is
	 * invoked for each element in `array` to generate the criterion by which
	 * uniqueness is computed. The order of result values is determined by the
	 * order they occur in the array. The iteratee is invoked with one argument:
	 * (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	 * @returns {Array} Returns the new duplicate free array.
	 * @example
	 *
	 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	 * // => [2.1, 1.2]
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	 * // => [{ 'x': 1 }, { 'x': 2 }]
	 */
	function uniqBy(array, iteratee) {
	  return (array && array.length) ? baseUniq(array, baseIteratee(iteratee, 2)) : [];
	}
	
	module.exports = uniqBy;


/***/ },
/* 765 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Afrikaans [af]
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var af = moment.defineLocale('af', {
	        months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split(
	            '_'
	        ),
	        weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	        weekdaysMin: 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	        meridiemParse: /vm|nm/i,
	        isPM: function (input) {
	            return /^nm$/i.test(input);
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'vm' : 'VM';
	            } else {
	                return isLower ? 'nm' : 'NM';
	            }
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Vandag om] LT',
	            nextDay: '[Môre om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[Gister om] LT',
	            lastWeek: '[Laas] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'oor %s',
	            past: '%s gelede',
	            s: "'n paar sekondes",
	            ss: '%d sekondes',
	            m: "'n minuut",
	            mm: '%d minute',
	            h: "'n uur",
	            hh: '%d ure',
	            d: "'n dag",
	            dd: '%d dae',
	            M: "'n maand",
	            MM: '%d maande',
	            y: "'n jaar",
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            ); // Thanks to Joris Röling : https://github.com/jjupiter
	        },
	        week: {
	            dow: 1, // Maandag is die eerste dag van die week.
	            doy: 4, // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	        },
	    });
	
	    return af;
	
	})));


/***/ },
/* 766 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Algeria) [ar-dz]
	//! author : Amine Roukh: https://github.com/Amine27
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	//! author : Noureddine LOUAHEDJ : https://github.com/noureddinem
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                  ? 1
	                  : n === 2
	                    ? 2
	                    : n % 100 >= 3 && n % 100 <= 10
	                      ? 3
	                      : n % 100 >= 11
	                        ? 4
	                        : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'جانفي',
	            'فيفري',
	            'مارس',
	            'أفريل',
	            'ماي',
	            'جوان',
	            'جويلية',
	            'أوت',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var arDz = moment.defineLocale('ar-dz', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arDz;
	
	})));


/***/ },
/* 767 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Kuwait) [ar-kw]
	//! author : Nusret Parlak: https://github.com/nusretparlak
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arKw = moment.defineLocale('ar-kw', {
	        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return arKw;
	
	})));


/***/ },
/* 768 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Libya) [ar-ly]
	//! author : Ali Hmer: https://github.com/kikoanis
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '1',
	            2: '2',
	            3: '3',
	            4: '4',
	            5: '5',
	            6: '6',
	            7: '7',
	            8: '8',
	            9: '9',
	            0: '0',
	        },
	        pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                  ? 1
	                  : n === 2
	                    ? 2
	                    : n % 100 >= 3 && n % 100 <= 10
	                      ? 3
	                      : n % 100 >= 11
	                        ? 4
	                        : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'يناير',
	            'فبراير',
	            'مارس',
	            'أبريل',
	            'مايو',
	            'يونيو',
	            'يوليو',
	            'أغسطس',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var arLy = moment.defineLocale('ar-ly', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return arLy;
	
	})));


/***/ },
/* 769 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Morocco) [ar-ma]
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arMa = moment.defineLocale('ar-ma', {
	        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arMa;
	
	})));


/***/ },
/* 770 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Palestine) [ar-ps]
	//! author : Majd Al-Shihabi : https://github.com/majdal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        };
	
	    var arPs = moment.defineLocale('ar-ps', {
	        months: 'كانون الثاني_شباط_آذار_نيسان_أيّار_حزيران_تمّوز_آب_أيلول_تشري الأوّل_تشرين الثاني_كانون الأوّل'.split(
	            '_'
	        ),
	        monthsShort:
	            'ك٢_شباط_آذار_نيسان_أيّار_حزيران_تمّوز_آب_أيلول_ت١_ت٢_ك١'.split('_'),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .split('') // reversed since negative lookbehind not supported everywhere
	                .reverse()
	                .join('')
	                .replace(/[١٢](?![\u062a\u0643])/g, function (match) {
	                    return numberMap[match];
	                })
	                .split('')
	                .reverse()
	                .join('')
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return arPs;
	
	})));


/***/ },
/* 771 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Saudi Arabia) [ar-sa]
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        };
	
	    var arSa = moment.defineLocale('ar-sa', {
	        months: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return arSa;
	
	})));


/***/ },
/* 772 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  :  Arabic (Tunisia) [ar-tn]
	//! author : Nader Toukabri : https://github.com/naderio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arTn = moment.defineLocale('ar-tn', {
	        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arTn;
	
	})));


/***/ },
/* 773 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic [ar]
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        },
	        pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                  ? 1
	                  : n === 2
	                    ? 2
	                    : n % 100 >= 3 && n % 100 <= 10
	                      ? 3
	                      : n % 100 >= 11
	                        ? 4
	                        : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'يناير',
	            'فبراير',
	            'مارس',
	            'أبريل',
	            'مايو',
	            'يونيو',
	            'يوليو',
	            'أغسطس',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var ar = moment.defineLocale('ar', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return ar;
	
	})));


/***/ },
/* 774 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Azerbaijani [az]
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: '-inci',
	        5: '-inci',
	        8: '-inci',
	        70: '-inci',
	        80: '-inci',
	        2: '-nci',
	        7: '-nci',
	        20: '-nci',
	        50: '-nci',
	        3: '-üncü',
	        4: '-üncü',
	        100: '-üncü',
	        6: '-ncı',
	        9: '-uncu',
	        10: '-uncu',
	        30: '-uncu',
	        60: '-ıncı',
	        90: '-ıncı',
	    };
	
	    var az = moment.defineLocale('az', {
	        months: 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	        weekdays:
	            'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split(
	                '_'
	            ),
	        weekdaysShort: 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	        weekdaysMin: 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün saat] LT',
	            nextDay: '[sabah saat] LT',
	            nextWeek: '[gələn həftə] dddd [saat] LT',
	            lastDay: '[dünən] LT',
	            lastWeek: '[keçən həftə] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s sonra',
	            past: '%s əvvəl',
	            s: 'bir neçə saniyə',
	            ss: '%d saniyə',
	            m: 'bir dəqiqə',
	            mm: '%d dəqiqə',
	            h: 'bir saat',
	            hh: '%d saat',
	            d: 'bir gün',
	            dd: '%d gün',
	            M: 'bir ay',
	            MM: '%d ay',
	            y: 'bir il',
	            yy: '%d il',
	        },
	        meridiemParse: /gecə|səhər|gündüz|axşam/,
	        isPM: function (input) {
	            return /^(gündüz|axşam)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'gecə';
	            } else if (hour < 12) {
	                return 'səhər';
	            } else if (hour < 17) {
	                return 'gündüz';
	            } else {
	                return 'axşam';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	        ordinal: function (number) {
	            if (number === 0) {
	                // special case for zero
	                return number + '-ıncı';
	            }
	            var a = number % 10,
	                b = (number % 100) - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return az;
	
	})));


/***/ },
/* 775 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Belarusian [be]
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	              ? forms[1]
	              : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            mm: withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	            hh: withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	            dd: 'дзень_дні_дзён',
	            MM: 'месяц_месяцы_месяцаў',
	            yy: 'год_гады_гадоў',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвіліна' : 'хвіліну';
	        } else if (key === 'h') {
	            return withoutSuffix ? 'гадзіна' : 'гадзіну';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	
	    var be = moment.defineLocale('be', {
	        months: {
	            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split(
	                '_'
	            ),
	            standalone:
	                'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split(
	                    '_'
	                ),
	        },
	        monthsShort:
	            'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	        weekdays: {
	            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split(
	                '_'
	            ),
	            standalone:
	                'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split(
	                    '_'
	                ),
	            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/,
	        },
	        weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        weekdaysMin: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY г.',
	            LLL: 'D MMMM YYYY г., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY г., HH:mm',
	        },
	        calendar: {
	            sameDay: '[Сёння ў] LT',
	            nextDay: '[Заўтра ў] LT',
	            lastDay: '[Учора ў] LT',
	            nextWeek: function () {
	                return '[У] dddd [ў] LT';
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[У мінулую] dddd [ў] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[У мінулы] dddd [ў] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'праз %s',
	            past: '%s таму',
	            s: 'некалькі секунд',
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: relativeTimeWithPlural,
	            hh: relativeTimeWithPlural,
	            d: 'дзень',
	            dd: relativeTimeWithPlural,
	            M: 'месяц',
	            MM: relativeTimeWithPlural,
	            y: 'год',
	            yy: relativeTimeWithPlural,
	        },
	        meridiemParse: /ночы|раніцы|дня|вечара/,
	        isPM: function (input) {
	            return /^(дня|вечара)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночы';
	            } else if (hour < 12) {
	                return 'раніцы';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечара';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return (number % 10 === 2 || number % 10 === 3) &&
	                        number % 100 !== 12 &&
	                        number % 100 !== 13
	                        ? number + '-і'
	                        : number + '-ы';
	                case 'D':
	                    return number + '-га';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return be;
	
	})));


/***/ },
/* 776 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bulgarian [bg]
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var bg = moment.defineLocale('bg', {
	        months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split(
	            '_'
	        ),
	        monthsShort: 'яну_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split(
	            '_'
	        ),
	        weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Днес в] LT',
	            nextDay: '[Утре в] LT',
	            nextWeek: 'dddd [в] LT',
	            lastDay: '[Вчера в] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Миналата] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Миналия] dddd [в] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'след %s',
	            past: 'преди %s',
	            s: 'няколко секунди',
	            ss: '%d секунди',
	            m: 'минута',
	            mm: '%d минути',
	            h: 'час',
	            hh: '%d часа',
	            d: 'ден',
	            dd: '%d дена',
	            w: 'седмица',
	            ww: '%d седмици',
	            M: 'месец',
	            MM: '%d месеца',
	            y: 'година',
	            yy: '%d години',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal: function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return bg;
	
	})));


/***/ },
/* 777 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bambara [bm]
	//! author : Estelle Comment : https://github.com/estellecomment
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var bm = moment.defineLocale('bm', {
	        months: 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split(
	            '_'
	        ),
	        monthsShort: 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
	        weekdays: 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
	        weekdaysShort: 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
	        weekdaysMin: 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'MMMM [tile] D [san] YYYY',
	            LLL: 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	            LLLL: 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	        },
	        calendar: {
	            sameDay: '[Bi lɛrɛ] LT',
	            nextDay: '[Sini lɛrɛ] LT',
	            nextWeek: 'dddd [don lɛrɛ] LT',
	            lastDay: '[Kunu lɛrɛ] LT',
	            lastWeek: 'dddd [tɛmɛnen lɛrɛ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s kɔnɔ',
	            past: 'a bɛ %s bɔ',
	            s: 'sanga dama dama',
	            ss: 'sekondi %d',
	            m: 'miniti kelen',
	            mm: 'miniti %d',
	            h: 'lɛrɛ kelen',
	            hh: 'lɛrɛ %d',
	            d: 'tile kelen',
	            dd: 'tile %d',
	            M: 'kalo kelen',
	            MM: 'kalo %d',
	            y: 'san kelen',
	            yy: 'san %d',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return bm;
	
	})));


/***/ },
/* 778 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali (Bangladesh) [bn-bd]
	//! author : Asraf Hossain Patoary : https://github.com/ashwoolford
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '১',
	            2: '২',
	            3: '৩',
	            4: '৪',
	            5: '৫',
	            6: '৬',
	            7: '৭',
	            8: '৮',
	            9: '৯',
	            0: '০',
	        },
	        numberMap = {
	            '১': '1',
	            '২': '2',
	            '৩': '3',
	            '৪': '4',
	            '৫': '5',
	            '৬': '6',
	            '৭': '7',
	            '৮': '8',
	            '৯': '9',
	            '০': '0',
	        };
	
	    var bnBd = moment.defineLocale('bn-bd', {
	        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
	            '_'
	        ),
	        monthsShort:
	            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
	                '_'
	            ),
	        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
	            '_'
	        ),
	        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm সময়',
	            LTS: 'A h:mm:ss সময়',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm সময়',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
	        },
	        calendar: {
	            sameDay: '[আজ] LT',
	            nextDay: '[আগামীকাল] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[গতকাল] LT',
	            lastWeek: '[গত] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s পরে',
	            past: '%s আগে',
	            s: 'কয়েক সেকেন্ড',
	            ss: '%d সেকেন্ড',
	            m: 'এক মিনিট',
	            mm: '%d মিনিট',
	            h: 'এক ঘন্টা',
	            hh: '%d ঘন্টা',
	            d: 'এক দিন',
	            dd: '%d দিন',
	            M: 'এক মাস',
	            MM: '%d মাস',
	            y: 'এক বছর',
	            yy: '%d বছর',
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	
	        meridiemParse: /রাত|ভোর|সকাল|দুপুর|বিকাল|সন্ধ্যা|রাত/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'রাত') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ভোর') {
	                return hour;
	            } else if (meridiem === 'সকাল') {
	                return hour;
	            } else if (meridiem === 'দুপুর') {
	                return hour >= 3 ? hour : hour + 12;
	            } else if (meridiem === 'বিকাল') {
	                return hour + 12;
	            } else if (meridiem === 'সন্ধ্যা') {
	                return hour + 12;
	            }
	        },
	
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 6) {
	                return 'ভোর';
	            } else if (hour < 12) {
	                return 'সকাল';
	            } else if (hour < 15) {
	                return 'দুপুর';
	            } else if (hour < 18) {
	                return 'বিকাল';
	            } else if (hour < 20) {
	                return 'সন্ধ্যা';
	            } else {
	                return 'রাত';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bnBd;
	
	})));


/***/ },
/* 779 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali [bn]
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '১',
	            2: '২',
	            3: '৩',
	            4: '৪',
	            5: '৫',
	            6: '৬',
	            7: '৭',
	            8: '৮',
	            9: '৯',
	            0: '০',
	        },
	        numberMap = {
	            '১': '1',
	            '২': '2',
	            '৩': '3',
	            '৪': '4',
	            '৫': '5',
	            '৬': '6',
	            '৭': '7',
	            '৮': '8',
	            '৯': '9',
	            '০': '0',
	        };
	
	    var bn = moment.defineLocale('bn', {
	        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
	            '_'
	        ),
	        monthsShort:
	            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
	                '_'
	            ),
	        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
	            '_'
	        ),
	        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm সময়',
	            LTS: 'A h:mm:ss সময়',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm সময়',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
	        },
	        calendar: {
	            sameDay: '[আজ] LT',
	            nextDay: '[আগামীকাল] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[গতকাল] LT',
	            lastWeek: '[গত] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s পরে',
	            past: '%s আগে',
	            s: 'কয়েক সেকেন্ড',
	            ss: '%d সেকেন্ড',
	            m: 'এক মিনিট',
	            mm: '%d মিনিট',
	            h: 'এক ঘন্টা',
	            hh: '%d ঘন্টা',
	            d: 'এক দিন',
	            dd: '%d দিন',
	            M: 'এক মাস',
	            MM: '%d মাস',
	            y: 'এক বছর',
	            yy: '%d বছর',
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'রাত' && hour >= 4) ||
	                (meridiem === 'দুপুর' && hour < 5) ||
	                meridiem === 'বিকাল'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 10) {
	                return 'সকাল';
	            } else if (hour < 17) {
	                return 'দুপুর';
	            } else if (hour < 20) {
	                return 'বিকাল';
	            } else {
	                return 'রাত';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bn;
	
	})));


/***/ },
/* 780 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tibetan [bo]
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '༡',
	            2: '༢',
	            3: '༣',
	            4: '༤',
	            5: '༥',
	            6: '༦',
	            7: '༧',
	            8: '༨',
	            9: '༩',
	            0: '༠',
	        },
	        numberMap = {
	            '༡': '1',
	            '༢': '2',
	            '༣': '3',
	            '༤': '4',
	            '༥': '5',
	            '༦': '6',
	            '༧': '7',
	            '༨': '8',
	            '༩': '9',
	            '༠': '0',
	        };
	
	    var bo = moment.defineLocale('bo', {
	        months: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ཟླ་1_ཟླ་2_ཟླ་3_ཟླ་4_ཟླ་5_ཟླ་6_ཟླ་7_ཟླ་8_ཟླ་9_ཟླ་10_ཟླ་11_ཟླ་12'.split(
	                '_'
	            ),
	        monthsShortRegex: /^(ཟླ་\d{1,2})/,
	        monthsParseExact: true,
	        weekdays:
	            'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split(
	                '_'
	            ),
	        weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split(
	            '_'
	        ),
	        weekdaysMin: 'ཉི_ཟླ_མིག_ལྷག_ཕུར_སངས_སྤེན'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[དི་རིང] LT',
	            nextDay: '[སང་ཉིན] LT',
	            nextWeek: '[བདུན་ཕྲག་རྗེས་མ], LT',
	            lastDay: '[ཁ་སང] LT',
	            lastWeek: '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ལ་',
	            past: '%s སྔན་ལ',
	            s: 'ལམ་སང',
	            ss: '%d སྐར་ཆ།',
	            m: 'སྐར་མ་གཅིག',
	            mm: '%d སྐར་མ',
	            h: 'ཆུ་ཚོད་གཅིག',
	            hh: '%d ཆུ་ཚོད',
	            d: 'ཉིན་གཅིག',
	            dd: '%d ཉིན་',
	            M: 'ཟླ་བ་གཅིག',
	            MM: '%d ཟླ་བ',
	            y: 'ལོ་གཅིག',
	            yy: '%d ལོ',
	        },
	        preparse: function (string) {
	            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'མཚན་མོ' && hour >= 4) ||
	                (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                meridiem === 'དགོང་དག'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'མཚན་མོ';
	            } else if (hour < 10) {
	                return 'ཞོགས་ཀས';
	            } else if (hour < 17) {
	                return 'ཉིན་གུང';
	            } else if (hour < 20) {
	                return 'དགོང་དག';
	            } else {
	                return 'མཚན་མོ';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bo;
	
	})));


/***/ },
/* 781 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Breton [br]
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function relativeTimeWithMutation(number, withoutSuffix, key) {
	        var format = {
	            mm: 'munutenn',
	            MM: 'miz',
	            dd: 'devezh',
	        };
	        return number + ' ' + mutation(format[key], number);
	    }
	    function specialMutationForYears(number) {
	        switch (lastNumber(number)) {
	            case 1:
	            case 3:
	            case 4:
	            case 5:
	            case 9:
	                return number + ' bloaz';
	            default:
	                return number + ' vloaz';
	        }
	    }
	    function lastNumber(number) {
	        if (number > 9) {
	            return lastNumber(number % 10);
	        }
	        return number;
	    }
	    function mutation(text, number) {
	        if (number === 2) {
	            return softMutation(text);
	        }
	        return text;
	    }
	    function softMutation(text) {
	        var mutationTable = {
	            m: 'v',
	            b: 'v',
	            d: 'z',
	        };
	        if (mutationTable[text.charAt(0)] === undefined) {
	            return text;
	        }
	        return mutationTable[text.charAt(0)] + text.substring(1);
	    }
	
	    var monthsParse = [
	            /^gen/i,
	            /^c[ʼ\']hwe/i,
	            /^meu/i,
	            /^ebr/i,
	            /^mae/i,
	            /^(mez|eve)/i,
	            /^gou/i,
	            /^eos/i,
	            /^gwe/i,
	            /^her/i,
	            /^du/i,
	            /^ker/i,
	        ],
	        monthsRegex =
	            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
	        monthsStrictRegex =
	            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,
	        monthsShortStrictRegex =
	            /^(gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
	        fullWeekdaysParse = [
	            /^sul/i,
	            /^lun/i,
	            /^meurzh/i,
	            /^merc[ʼ\']her/i,
	            /^yaou/i,
	            /^gwener/i,
	            /^sadorn/i,
	        ],
	        shortWeekdaysParse = [
	            /^Sul/i,
	            /^Lun/i,
	            /^Meu/i,
	            /^Mer/i,
	            /^Yao/i,
	            /^Gwe/i,
	            /^Sad/i,
	        ],
	        minWeekdaysParse = [
	            /^Su/i,
	            /^Lu/i,
	            /^Me([^r]|$)/i,
	            /^Mer/i,
	            /^Ya/i,
	            /^Gw/i,
	            /^Sa/i,
	        ];
	
	    var br = moment.defineLocale('br', {
	        months: 'Genver_Cʼhwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split(
	            '_'
	        ),
	        monthsShort: 'Gen_Cʼhwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	        weekdays: 'Sul_Lun_Meurzh_Mercʼher_Yaou_Gwener_Sadorn'.split('_'),
	        weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	        weekdaysParse: minWeekdaysParse,
	        fullWeekdaysParse: fullWeekdaysParse,
	        shortWeekdaysParse: shortWeekdaysParse,
	        minWeekdaysParse: minWeekdaysParse,
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: monthsStrictRegex,
	        monthsShortStrictRegex: monthsShortStrictRegex,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [a viz] MMMM YYYY',
	            LLL: 'D [a viz] MMMM YYYY HH:mm',
	            LLLL: 'dddd, D [a viz] MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hiziv da] LT',
	            nextDay: '[Warcʼhoazh da] LT',
	            nextWeek: 'dddd [da] LT',
	            lastDay: '[Decʼh da] LT',
	            lastWeek: 'dddd [paset da] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'a-benn %s',
	            past: '%s ʼzo',
	            s: 'un nebeud segondennoù',
	            ss: '%d eilenn',
	            m: 'ur vunutenn',
	            mm: relativeTimeWithMutation,
	            h: 'un eur',
	            hh: '%d eur',
	            d: 'un devezh',
	            dd: relativeTimeWithMutation,
	            M: 'ur miz',
	            MM: relativeTimeWithMutation,
	            y: 'ur bloaz',
	            yy: specialMutationForYears,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'añ' : 'vet';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        meridiemParse: /a.m.|g.m./, // goude merenn | a-raok merenn
	        isPM: function (token) {
	            return token === 'g.m.';
	        },
	        meridiem: function (hour, minute, isLower) {
	            return hour < 12 ? 'a.m.' : 'g.m.';
	        },
	    });
	
	    return br;
	
	})));


/***/ },
/* 782 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bosnian [bs]
	//! author : Nedim Cholich : https://github.com/frontyard
	//! author : Rasid Redzic : https://github.com/rasidre
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        switch (key) {
	            case 'm':
	                return withoutSuffix
	                    ? 'jedna minuta'
	                    : isFuture
	                      ? 'jednu minutu'
	                      : 'jedne minute';
	        }
	    }
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jedan sat';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var bs = moment.defineLocale('bs', {
	        months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[jučer u] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'par sekundi',
	            ss: translate,
	            m: processRelativeTime,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: 'dan',
	            dd: translate,
	            M: 'mjesec',
	            MM: translate,
	            y: 'godinu',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return bs;
	
	})));


/***/ },
/* 783 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ca = moment.defineLocale('ca', {
	        months: {
	            standalone:
	                'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split(
	                    '_'
	                ),
	            format: "de gener_de febrer_de març_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\s)+MMMM/,
	        },
	        monthsShort:
	            'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split(
	                '_'
	            ),
	        weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin: 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [de] YYYY',
	            ll: 'D MMM YYYY',
	            LLL: 'D MMMM [de] YYYY [a les] H:mm',
	            lll: 'D MMM YYYY, H:mm',
	            LLLL: 'dddd D MMMM [de] YYYY [a les] H:mm',
	            llll: 'ddd D MMM YYYY, H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[avui a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            nextDay: function () {
	                return '[demà a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            lastDay: function () {
	                return '[ahir a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [passat a ' +
	                    (this.hours() !== 1 ? 'les' : 'la') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: "d'aquí %s",
	            past: 'fa %s',
	            s: 'uns segons',
	            ss: '%d segons',
	            m: 'un minut',
	            mm: '%d minuts',
	            h: 'una hora',
	            hh: '%d hores',
	            d: 'un dia',
	            dd: '%d dies',
	            M: 'un mes',
	            MM: '%d mesos',
	            y: 'un any',
	            yy: '%d anys',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal: function (number, period) {
	            var output =
	                number === 1
	                    ? 'r'
	                    : number === 2
	                      ? 'n'
	                      : number === 3
	                        ? 'r'
	                        : number === 4
	                          ? 't'
	                          : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ca;
	
	})));


/***/ },
/* 784 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = {
	            standalone:
	                'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split(
	                    '_'
	                ),
	            format: 'ledna_února_března_dubna_května_června_července_srpna_září_října_listopadu_prosince'.split(
	                '_'
	            ),
	            isFormat: /DD?[o.]?(\[[^\[\]]*\]|\s)+MMMM/,
	        },
	        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_'),
	        monthsParse = [
	            /^led/i,
	            /^úno/i,
	            /^bře/i,
	            /^dub/i,
	            /^kvě/i,
	            /^(čvn|červen$|června)/i,
	            /^(čvc|červenec|července)/i,
	            /^srp/i,
	            /^zář/i,
	            /^říj/i,
	            /^lis/i,
	            /^pro/i,
	        ],
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsRegex =
	            /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;
	
	    function plural(n) {
	        return n > 1 && n < 5 && ~~(n / 10) !== 1;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's': // a few seconds / in a few seconds / a few seconds ago
	                return withoutSuffix || isFuture ? 'pár sekund' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekund');
	                } else {
	                    return result + 'sekundami';
	                }
	            case 'm': // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minuta' : isFuture ? 'minutu' : 'minutou';
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minuty' : 'minut');
	                } else {
	                    return result + 'minutami';
	                }
	            case 'h': // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodin');
	                } else {
	                    return result + 'hodinami';
	                }
	            case 'd': // a day / in a day / a day ago
	                return withoutSuffix || isFuture ? 'den' : 'dnem';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dny' : 'dní');
	                } else {
	                    return result + 'dny';
	                }
	            case 'M': // a month / in a month / a month ago
	                return withoutSuffix || isFuture ? 'měsíc' : 'měsícem';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'měsíce' : 'měsíců');
	                } else {
	                    return result + 'měsíci';
	                }
	            case 'y': // a year / in a year / a year ago
	                return withoutSuffix || isFuture ? 'rok' : 'rokem';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'let');
	                } else {
	                    return result + 'lety';
	                }
	        }
	    }
	
	    var cs = moment.defineLocale('cs', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsStrictRegex:
	            /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
	        monthsShortStrictRegex:
	            /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	        weekdaysShort: 'ne_po_út_st_čt_pá_so'.split('_'),
	        weekdaysMin: 'ne_po_út_st_čt_pá_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd D. MMMM YYYY H:mm',
	            l: 'D. M. YYYY',
	        },
	        calendar: {
	            sameDay: '[dnes v] LT',
	            nextDay: '[zítra v] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [v] LT';
	                    case 3:
	                        return '[ve středu v] LT';
	                    case 4:
	                        return '[ve čtvrtek v] LT';
	                    case 5:
	                        return '[v pátek v] LT';
	                    case 6:
	                        return '[v sobotu v] LT';
	                }
	            },
	            lastDay: '[včera v] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulou neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[minulé] dddd [v] LT';
	                    case 3:
	                        return '[minulou středu v] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [v] LT';
	                    case 6:
	                        return '[minulou sobotu v] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'před %s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return cs;
	
	})));


/***/ },
/* 785 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chuvash [cv]
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var cv = moment.defineLocale('cv', {
	        months: 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split(
	            '_'
	        ),
	        monthsShort: 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	        weekdays:
	            'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split(
	                '_'
	            ),
	        weekdaysShort: 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	        weekdaysMin: 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	            LLL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	            LLLL: 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	        },
	        calendar: {
	            sameDay: '[Паян] LT [сехетре]',
	            nextDay: '[Ыран] LT [сехетре]',
	            lastDay: '[Ӗнер] LT [сехетре]',
	            nextWeek: '[Ҫитес] dddd LT [сехетре]',
	            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (output) {
	                var affix = /сехет$/i.exec(output)
	                    ? 'рен'
	                    : /ҫул$/i.exec(output)
	                      ? 'тан'
	                      : 'ран';
	                return output + affix;
	            },
	            past: '%s каялла',
	            s: 'пӗр-ик ҫеккунт',
	            ss: '%d ҫеккунт',
	            m: 'пӗр минут',
	            mm: '%d минут',
	            h: 'пӗр сехет',
	            hh: '%d сехет',
	            d: 'пӗр кун',
	            dd: '%d кун',
	            M: 'пӗр уйӑх',
	            MM: '%d уйӑх',
	            y: 'пӗр ҫул',
	            yy: '%d ҫул',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	        ordinal: '%d-мӗш',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return cv;
	
	})));


/***/ },
/* 786 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh [cy]
	//! author : Robert Allen : https://github.com/robgallen
	//! author : https://github.com/ryangreaves
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var cy = moment.defineLocale('cy', {
	        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split(
	            '_'
	        ),
	        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split(
	            '_'
	        ),
	        weekdays:
	            'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split(
	                '_'
	            ),
	        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	        weekdaysParseExact: true,
	        // time formats are the same as en-gb
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Heddiw am] LT',
	            nextDay: '[Yfory am] LT',
	            nextWeek: 'dddd [am] LT',
	            lastDay: '[Ddoe am] LT',
	            lastWeek: 'dddd [diwethaf am] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'mewn %s',
	            past: '%s yn ôl',
	            s: 'ychydig eiliadau',
	            ss: '%d eiliad',
	            m: 'munud',
	            mm: '%d munud',
	            h: 'awr',
	            hh: '%d awr',
	            d: 'diwrnod',
	            dd: '%d diwrnod',
	            M: 'mis',
	            MM: '%d mis',
	            y: 'blwyddyn',
	            yy: '%d flynedd',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	        ordinal: function (number) {
	            var b = number,
	                output = '',
	                lookup = [
	                    '',
	                    'af',
	                    'il',
	                    'ydd',
	                    'ydd',
	                    'ed',
	                    'ed',
	                    'ed',
	                    'fed',
	                    'fed',
	                    'fed', // 1af to 10fed
	                    'eg',
	                    'fed',
	                    'eg',
	                    'eg',
	                    'fed',
	                    'eg',
	                    'eg',
	                    'fed',
	                    'eg',
	                    'fed', // 11eg to 20fed
	                ];
	            if (b > 20) {
	                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                    output = 'fed'; // not 30ain, 70ain or 90ain
	                } else {
	                    output = 'ain';
	                }
	            } else if (b > 0) {
	                output = lookup[b];
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return cy;
	
	})));


/***/ },
/* 787 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Danish [da]
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var da = moment.defineLocale('da', {
	        months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd [d.] D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'på dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[i] dddd[s kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s siden',
	            s: 'få sekunder',
	            ss: '%d sekunder',
	            m: 'et minut',
	            mm: '%d minutter',
	            h: 'en time',
	            hh: '%d timer',
	            d: 'en dag',
	            dd: '%d dage',
	            M: 'en måned',
	            MM: '%d måneder',
	            y: 'et år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return da;
	
	})));


/***/ },
/* 788 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deAt = moment.defineLocale('de-at', {
	        months: 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays:
	            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	                '_'
	            ),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return deAt;
	
	})));


/***/ },
/* 789 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Switzerland) [de-ch]
	//! author : sschueller : https://github.com/sschueller
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deCh = moment.defineLocale('de-ch', {
	        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays:
	            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	                '_'
	            ),
	        weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return deCh;
	
	})));


/***/ },
/* 790 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de = moment.defineLocale('de', {
	        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays:
	            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	                '_'
	            ),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return de;
	
	})));


/***/ },
/* 791 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maldivian [dv]
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'ޖެނުއަރީ',
	            'ފެބްރުއަރީ',
	            'މާރިޗު',
	            'އޭޕްރީލު',
	            'މޭ',
	            'ޖޫން',
	            'ޖުލައި',
	            'އޯގަސްޓު',
	            'ސެޕްޓެމްބަރު',
	            'އޮކްޓޯބަރު',
	            'ނޮވެމްބަރު',
	            'ޑިސެމްބަރު',
	        ],
	        weekdays = [
	            'އާދިއްތަ',
	            'ހޯމަ',
	            'އަންގާރަ',
	            'ބުދަ',
	            'ބުރާސްފަތި',
	            'ހުކުރު',
	            'ހޮނިހިރު',
	        ];
	
	    var dv = moment.defineLocale('dv', {
	        months: months,
	        monthsShort: months,
	        weekdays: weekdays,
	        weekdaysShort: weekdays,
	        weekdaysMin: 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/M/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /މކ|މފ/,
	        isPM: function (input) {
	            return 'މފ' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'މކ';
	            } else {
	                return 'މފ';
	            }
	        },
	        calendar: {
	            sameDay: '[މިއަދު] LT',
	            nextDay: '[މާދަމާ] LT',
	            nextWeek: 'dddd LT',
	            lastDay: '[އިއްޔެ] LT',
	            lastWeek: '[ފާއިތުވި] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ތެރޭގައި %s',
	            past: 'ކުރިން %s',
	            s: 'ސިކުންތުކޮޅެއް',
	            ss: 'd% ސިކުންތު',
	            m: 'މިނިޓެއް',
	            mm: 'މިނިޓު %d',
	            h: 'ގަޑިއިރެއް',
	            hh: 'ގަޑިއިރު %d',
	            d: 'ދުވަހެއް',
	            dd: 'ދުވަސް %d',
	            M: 'މަހެއް',
	            MM: 'މަސް %d',
	            y: 'އަހަރެއް',
	            yy: 'އަހަރު %d',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 7, // Sunday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return dv;
	
	})));


/***/ },
/* 792 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    var el = moment.defineLocale('el', {
	        monthsNominativeEl:
	            'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split(
	                '_'
	            ),
	        monthsGenitiveEl:
	            'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split(
	                '_'
	            ),
	        months: function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return this._monthsNominativeEl;
	            } else if (
	                typeof format === 'string' &&
	                /D/.test(format.substring(0, format.indexOf('MMMM')))
	            ) {
	                // if there is a day number before 'MMMM'
	                return this._monthsGenitiveEl[momentToFormat.month()];
	            } else {
	                return this._monthsNominativeEl[momentToFormat.month()];
	            }
	        },
	        monthsShort: 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	        weekdays: 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split(
	            '_'
	        ),
	        weekdaysShort: 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	        weekdaysMin: 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'μμ' : 'ΜΜ';
	            } else {
	                return isLower ? 'πμ' : 'ΠΜ';
	            }
	        },
	        isPM: function (input) {
	            return (input + '').toLowerCase()[0] === 'μ';
	        },
	        meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendarEl: {
	            sameDay: '[Σήμερα {}] LT',
	            nextDay: '[Αύριο {}] LT',
	            nextWeek: 'dddd [{}] LT',
	            lastDay: '[Χθες {}] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 6:
	                        return '[το προηγούμενο] dddd [{}] LT';
	                    default:
	                        return '[την προηγούμενη] dddd [{}] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        calendar: function (key, mom) {
	            var output = this._calendarEl[key],
	                hours = mom && mom.hours();
	            if (isFunction(output)) {
	                output = output.apply(mom);
	            }
	            return output.replace('{}', hours % 12 === 1 ? 'στη' : 'στις');
	        },
	        relativeTime: {
	            future: 'σε %s',
	            past: '%s πριν',
	            s: 'λίγα δευτερόλεπτα',
	            ss: '%d δευτερόλεπτα',
	            m: 'ένα λεπτό',
	            mm: '%d λεπτά',
	            h: 'μία ώρα',
	            hh: '%d ώρες',
	            d: 'μία μέρα',
	            dd: '%d μέρες',
	            M: 'ένας μήνας',
	            MM: '%d μήνες',
	            y: 'ένας χρόνος',
	            yy: '%d χρόνια',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}η/,
	        ordinal: '%dη',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4st is the first week of the year.
	        },
	    });
	
	    return el;
	
	})));


/***/ },
/* 793 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enAu = moment.defineLocale('en-au', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enAu;
	
	})));


/***/ },
/* 794 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enCa = moment.defineLocale('en-ca', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'YYYY-MM-DD',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY h:mm A',
	            LLLL: 'dddd, MMMM D, YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	    });
	
	    return enCa;
	
	})));


/***/ },
/* 795 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enGb = moment.defineLocale('en-gb', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enGb;
	
	})));


/***/ },
/* 796 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIe = moment.defineLocale('en-ie', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enIe;
	
	})));


/***/ },
/* 797 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Israel) [en-il]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIl = moment.defineLocale('en-il', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	    });
	
	    return enIl;
	
	})));


/***/ },
/* 798 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (India) [en-in]
	//! author : Jatin Agrawal : https://github.com/jatinag22
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIn = moment.defineLocale('en-in', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return enIn;
	
	})));


/***/ },
/* 799 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enNz = moment.defineLocale('en-nz', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enNz;
	
	})));


/***/ },
/* 800 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Singapore) [en-sg]
	//! author : Matthew Castrillon-Madrigal : https://github.com/techdimension
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enSg = moment.defineLocale('en-sg', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enSg;
	
	})));


/***/ },
/* 801 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Esperanto [eo]
	//! author : Colin Dean : https://github.com/colindean
	//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
	//! comment : miestasmia corrected the translation by colindean
	//! comment : Vivakvo corrected the translation by colindean and miestasmia
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var eo = moment.defineLocale('eo', {
	        months: 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mart_apr_maj_jun_jul_aŭg_sept_okt_nov_dec'.split('_'),
	        weekdays: 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	        weekdaysShort: 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: '[la] D[-an de] MMMM, YYYY',
	            LLL: '[la] D[-an de] MMMM, YYYY HH:mm',
	            LLLL: 'dddd[n], [la] D[-an de] MMMM, YYYY HH:mm',
	            llll: 'ddd, [la] D[-an de] MMM, YYYY HH:mm',
	        },
	        meridiemParse: /[ap]\.t\.m/i,
	        isPM: function (input) {
	            return input.charAt(0).toLowerCase() === 'p';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'p.t.m.' : 'P.T.M.';
	            } else {
	                return isLower ? 'a.t.m.' : 'A.T.M.';
	            }
	        },
	        calendar: {
	            sameDay: '[Hodiaŭ je] LT',
	            nextDay: '[Morgaŭ je] LT',
	            nextWeek: 'dddd[n je] LT',
	            lastDay: '[Hieraŭ je] LT',
	            lastWeek: '[pasintan] dddd[n je] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'post %s',
	            past: 'antaŭ %s',
	            s: 'kelkaj sekundoj',
	            ss: '%d sekundoj',
	            m: 'unu minuto',
	            mm: '%d minutoj',
	            h: 'unu horo',
	            hh: '%d horoj',
	            d: 'unu tago', //ne 'diurno', ĉar estas uzita por proksimumo
	            dd: '%d tagoj',
	            M: 'unu monato',
	            MM: '%d monatoj',
	            y: 'unu jaro',
	            yy: '%d jaroj',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}a/,
	        ordinal: '%da',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return eo;
	
	})));


/***/ },
/* 802 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esDo = moment.defineLocale('es-do', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return esDo;
	
	})));


/***/ },
/* 803 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Mexico) [es-mx]
	//! author : JC Franco : https://github.com/jcfranco
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esMx = moment.defineLocale('es-mx', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        invalidDate: 'Fecha inválida',
	    });
	
	    return esMx;
	
	})));


/***/ },
/* 804 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (United States) [es-us]
	//! author : bustta : https://github.com/bustta
	//! author : chrisrodz : https://github.com/chrisrodz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esUs = moment.defineLocale('es-us', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'MM/DD/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return esUs;
	
	})));


/***/ },
/* 805 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var es = moment.defineLocale('es', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        invalidDate: 'Fecha inválida',
	    });
	
	    return es;
	
	})));


/***/ },
/* 806 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Estonian [et]
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	            ss: [number + 'sekundi', number + 'sekundit'],
	            m: ['ühe minuti', 'üks minut'],
	            mm: [number + ' minuti', number + ' minutit'],
	            h: ['ühe tunni', 'tund aega', 'üks tund'],
	            hh: [number + ' tunni', number + ' tundi'],
	            d: ['ühe päeva', 'üks päev'],
	            M: ['kuu aja', 'kuu aega', 'üks kuu'],
	            MM: [number + ' kuu', number + ' kuud'],
	            y: ['ühe aasta', 'aasta', 'üks aasta'],
	            yy: [number + ' aasta', number + ' aastat'],
	        };
	        if (withoutSuffix) {
	            return format[key][2] ? format[key][2] : format[key][1];
	        }
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var et = moment.defineLocale('et', {
	        months: 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split(
	            '_'
	        ),
	        monthsShort:
	            'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	        weekdays:
	            'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split(
	                '_'
	            ),
	        weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
	        weekdaysMin: 'P_E_T_K_N_R_L'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Täna,] LT',
	            nextDay: '[Homme,] LT',
	            nextWeek: '[Järgmine] dddd LT',
	            lastDay: '[Eile,] LT',
	            lastWeek: '[Eelmine] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s pärast',
	            past: '%s tagasi',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: '%d päeva',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return et;
	
	})));


/***/ },
/* 807 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Basque [eu]
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var eu = moment.defineLocale('eu', {
	        months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split(
	            '_'
	        ),
	        monthsShort:
	            'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split(
	                '_'
	            ),
	        weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
	        weekdaysMin: 'ig_al_ar_az_og_ol_lr'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY[ko] MMMM[ren] D[a]',
	            LLL: 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	            LLLL: 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	            l: 'YYYY-M-D',
	            ll: 'YYYY[ko] MMM D[a]',
	            lll: 'YYYY[ko] MMM D[a] HH:mm',
	            llll: 'ddd, YYYY[ko] MMM D[a] HH:mm',
	        },
	        calendar: {
	            sameDay: '[gaur] LT[etan]',
	            nextDay: '[bihar] LT[etan]',
	            nextWeek: 'dddd LT[etan]',
	            lastDay: '[atzo] LT[etan]',
	            lastWeek: '[aurreko] dddd LT[etan]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s barru',
	            past: 'duela %s',
	            s: 'segundo batzuk',
	            ss: '%d segundo',
	            m: 'minutu bat',
	            mm: '%d minutu',
	            h: 'ordu bat',
	            hh: '%d ordu',
	            d: 'egun bat',
	            dd: '%d egun',
	            M: 'hilabete bat',
	            MM: '%d hilabete',
	            y: 'urte bat',
	            yy: '%d urte',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return eu;
	
	})));


/***/ },
/* 808 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian [fa]
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '۱',
	            2: '۲',
	            3: '۳',
	            4: '۴',
	            5: '۵',
	            6: '۶',
	            7: '۷',
	            8: '۸',
	            9: '۹',
	            0: '۰',
	        },
	        numberMap = {
	            '۱': '1',
	            '۲': '2',
	            '۳': '3',
	            '۴': '4',
	            '۵': '5',
	            '۶': '6',
	            '۷': '7',
	            '۸': '8',
	            '۹': '9',
	            '۰': '0',
	        };
	
	    var fa = moment.defineLocale('fa', {
	        months: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
	                '_'
	            ),
	        weekdays:
	            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
	                '_'
	            ),
	        weekdaysShort:
	            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
	                '_'
	            ),
	        weekdaysMin: 'ی_د_س_چ_پ_ج_ش'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /قبل از ظهر|بعد از ظهر/,
	        isPM: function (input) {
	            return /بعد از ظهر/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'قبل از ظهر';
	            } else {
	                return 'بعد از ظهر';
	            }
	        },
	        calendar: {
	            sameDay: '[امروز ساعت] LT',
	            nextDay: '[فردا ساعت] LT',
	            nextWeek: 'dddd [ساعت] LT',
	            lastDay: '[دیروز ساعت] LT',
	            lastWeek: 'dddd [پیش] [ساعت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'در %s',
	            past: '%s پیش',
	            s: 'چند ثانیه',
	            ss: '%d ثانیه',
	            m: 'یک دقیقه',
	            mm: '%d دقیقه',
	            h: 'یک ساعت',
	            hh: '%d ساعت',
	            d: 'یک روز',
	            dd: '%d روز',
	            M: 'یک ماه',
	            MM: '%d ماه',
	            y: 'یک سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[۰-۹]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}م/,
	        ordinal: '%dم',
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return fa;
	
	})));


/***/ },
/* 809 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Finnish [fi]
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var numbersPast =
	            'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(
	                ' '
	            ),
	        numbersFuture = [
	            'nolla',
	            'yhden',
	            'kahden',
	            'kolmen',
	            'neljän',
	            'viiden',
	            'kuuden',
	            numbersPast[7],
	            numbersPast[8],
	            numbersPast[9],
	        ];
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = '';
	        switch (key) {
	            case 's':
	                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	            case 'ss':
	                result = isFuture ? 'sekunnin' : 'sekuntia';
	                break;
	            case 'm':
	                return isFuture ? 'minuutin' : 'minuutti';
	            case 'mm':
	                result = isFuture ? 'minuutin' : 'minuuttia';
	                break;
	            case 'h':
	                return isFuture ? 'tunnin' : 'tunti';
	            case 'hh':
	                result = isFuture ? 'tunnin' : 'tuntia';
	                break;
	            case 'd':
	                return isFuture ? 'päivän' : 'päivä';
	            case 'dd':
	                result = isFuture ? 'päivän' : 'päivää';
	                break;
	            case 'M':
	                return isFuture ? 'kuukauden' : 'kuukausi';
	            case 'MM':
	                result = isFuture ? 'kuukauden' : 'kuukautta';
	                break;
	            case 'y':
	                return isFuture ? 'vuoden' : 'vuosi';
	            case 'yy':
	                result = isFuture ? 'vuoden' : 'vuotta';
	                break;
	        }
	        result = verbalNumber(number, isFuture) + ' ' + result;
	        return result;
	    }
	    function verbalNumber(number, isFuture) {
	        return number < 10
	            ? isFuture
	                ? numbersFuture[number]
	                : numbersPast[number]
	            : number;
	    }
	
	    var fi = moment.defineLocale('fi', {
	        months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split(
	            '_'
	        ),
	        monthsShort:
	            'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split(
	                '_'
	            ),
	        weekdays:
	            'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split(
	                '_'
	            ),
	        weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
	        weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM[ta] YYYY',
	            LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
	            LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	            l: 'D.M.YYYY',
	            ll: 'Do MMM YYYY',
	            lll: 'Do MMM YYYY, [klo] HH.mm',
	            llll: 'ddd, Do MMM YYYY, [klo] HH.mm',
	        },
	        calendar: {
	            sameDay: '[tänään] [klo] LT',
	            nextDay: '[huomenna] [klo] LT',
	            nextWeek: 'dddd [klo] LT',
	            lastDay: '[eilen] [klo] LT',
	            lastWeek: '[viime] dddd[na] [klo] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s päästä',
	            past: '%s sitten',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fi;
	
	})));


/***/ },
/* 810 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Filipino [fil]
	//! author : Dan Hagman : https://github.com/hagmandan
	//! author : Matthew Co : https://github.com/matthewdeeco
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var fil = moment.defineLocale('fil', {
	        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
	            '_'
	        ),
	        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'MM/D/YYYY',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY HH:mm',
	            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'sa loob ng %s',
	            past: '%s ang nakalipas',
	            s: 'ilang segundo',
	            ss: '%d segundo',
	            m: 'isang minuto',
	            mm: '%d minuto',
	            h: 'isang oras',
	            hh: '%d oras',
	            d: 'isang araw',
	            dd: '%d araw',
	            M: 'isang buwan',
	            MM: '%d buwan',
	            y: 'isang taon',
	            yy: '%d taon',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fil;
	
	})));


/***/ },
/* 811 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Faroese [fo]
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	//! author : Kristian Sakarisson : https://github.com/sakarisson
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var fo = moment.defineLocale('fo', {
	        months: 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays:
	            'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split(
	                '_'
	            ),
	        weekdaysShort: 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	        weekdaysMin: 'su_má_tý_mi_hó_fr_le'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D. MMMM, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Í dag kl.] LT',
	            nextDay: '[Í morgin kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[Í gjár kl.] LT',
	            lastWeek: '[síðstu] dddd [kl] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'um %s',
	            past: '%s síðani',
	            s: 'fá sekund',
	            ss: '%d sekundir',
	            m: 'ein minuttur',
	            mm: '%d minuttir',
	            h: 'ein tími',
	            hh: '%d tímar',
	            d: 'ein dagur',
	            dd: '%d dagar',
	            M: 'ein mánaður',
	            MM: '%d mánaðir',
	            y: 'eitt ár',
	            yy: '%d ár',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fo;
	
	})));


/***/ },
/* 812 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var frCa = moment.defineLocale('fr-ca', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort:
	            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	    });
	
	    return frCa;
	
	})));


/***/ },
/* 813 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var frCh = moment.defineLocale('fr-ch', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort:
	            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return frCh;
	
	})));


/***/ },
/* 814 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsStrictRegex =
	            /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
	        monthsShortStrictRegex =
	            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
	        monthsRegex =
	            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
	        monthsParse = [
	            /^janv/i,
	            /^févr/i,
	            /^mars/i,
	            /^avr/i,
	            /^mai/i,
	            /^juin/i,
	            /^juil/i,
	            /^août/i,
	            /^sept/i,
	            /^oct/i,
	            /^nov/i,
	            /^déc/i,
	        ];
	
	    var fr = moment.defineLocale('fr', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort:
	            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	                '_'
	            ),
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: monthsStrictRegex,
	        monthsShortStrictRegex: monthsShortStrictRegex,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            w: 'une semaine',
	            ww: '%d semaines',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // TODO: Return 'e' when day of month > 1. Move this case inside
	                // block for masculine words below.
	                // See https://github.com/moment/moment/issues/3375
	                case 'D':
	                    return number + (number === 1 ? 'er' : '');
	
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fr;
	
	})));


/***/ },
/* 815 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Frisian [fy]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots =
	            'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
	        monthsShortWithoutDots =
	            'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	    var fy = moment.defineLocale('fy', {
	        months: 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        monthsParseExact: true,
	        weekdays: 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split(
	            '_'
	        ),
	        weekdaysShort: 'si._mo._ti._wo._to._fr._so.'.split('_'),
	        weekdaysMin: 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[hjoed om] LT',
	            nextDay: '[moarn om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[juster om] LT',
	            lastWeek: '[ôfrûne] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'oer %s',
	            past: '%s lyn',
	            s: 'in pear sekonden',
	            ss: '%d sekonden',
	            m: 'ien minút',
	            mm: '%d minuten',
	            h: 'ien oere',
	            hh: '%d oeren',
	            d: 'ien dei',
	            dd: '%d dagen',
	            M: 'ien moanne',
	            MM: '%d moannen',
	            y: 'ien jier',
	            yy: '%d jierren',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fy;
	
	})));


/***/ },
/* 816 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Irish or Irish Gaelic [ga]
	//! author : André Silva : https://github.com/askpt
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'Eanáir',
	            'Feabhra',
	            'Márta',
	            'Aibreán',
	            'Bealtaine',
	            'Meitheamh',
	            'Iúil',
	            'Lúnasa',
	            'Meán Fómhair',
	            'Deireadh Fómhair',
	            'Samhain',
	            'Nollaig',
	        ],
	        monthsShort = [
	            'Ean',
	            'Feabh',
	            'Márt',
	            'Aib',
	            'Beal',
	            'Meith',
	            'Iúil',
	            'Lún',
	            'M.F.',
	            'D.F.',
	            'Samh',
	            'Noll',
	        ],
	        weekdays = [
	            'Dé Domhnaigh',
	            'Dé Luain',
	            'Dé Máirt',
	            'Dé Céadaoin',
	            'Déardaoin',
	            'Dé hAoine',
	            'Dé Sathairn',
	        ],
	        weekdaysShort = ['Domh', 'Luan', 'Máirt', 'Céad', 'Déar', 'Aoine', 'Sath'],
	        weekdaysMin = ['Do', 'Lu', 'Má', 'Cé', 'Dé', 'A', 'Sa'];
	
	    var ga = moment.defineLocale('ga', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Inniu ag] LT',
	            nextDay: '[Amárach ag] LT',
	            nextWeek: 'dddd [ag] LT',
	            lastDay: '[Inné ag] LT',
	            lastWeek: 'dddd [seo caite] [ag] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'i %s',
	            past: '%s ó shin',
	            s: 'cúpla soicind',
	            ss: '%d soicind',
	            m: 'nóiméad',
	            mm: '%d nóiméad',
	            h: 'uair an chloig',
	            hh: '%d uair an chloig',
	            d: 'lá',
	            dd: '%d lá',
	            M: 'mí',
	            MM: '%d míonna',
	            y: 'bliain',
	            yy: '%d bliain',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ga;
	
	})));


/***/ },
/* 817 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Scottish Gaelic [gd]
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'Am Faoilleach',
	            'An Gearran',
	            'Am Màrt',
	            'An Giblean',
	            'An Cèitean',
	            'An t-Ògmhios',
	            'An t-Iuchar',
	            'An Lùnastal',
	            'An t-Sultain',
	            'An Dàmhair',
	            'An t-Samhain',
	            'An Dùbhlachd',
	        ],
	        monthsShort = [
	            'Faoi',
	            'Gear',
	            'Màrt',
	            'Gibl',
	            'Cèit',
	            'Ògmh',
	            'Iuch',
	            'Lùn',
	            'Sult',
	            'Dàmh',
	            'Samh',
	            'Dùbh',
	        ],
	        weekdays = [
	            'Didòmhnaich',
	            'Diluain',
	            'Dimàirt',
	            'Diciadain',
	            'Diardaoin',
	            'Dihaoine',
	            'Disathairne',
	        ],
	        weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'],
	        weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	    var gd = moment.defineLocale('gd', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[An-diugh aig] LT',
	            nextDay: '[A-màireach aig] LT',
	            nextWeek: 'dddd [aig] LT',
	            lastDay: '[An-dè aig] LT',
	            lastWeek: 'dddd [seo chaidh] [aig] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ann an %s',
	            past: 'bho chionn %s',
	            s: 'beagan diogan',
	            ss: '%d diogan',
	            m: 'mionaid',
	            mm: '%d mionaidean',
	            h: 'uair',
	            hh: '%d uairean',
	            d: 'latha',
	            dd: '%d latha',
	            M: 'mìos',
	            MM: '%d mìosan',
	            y: 'bliadhna',
	            yy: '%d bliadhna',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return gd;
	
	})));


/***/ },
/* 818 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var gl = moment.defineLocale('gl', {
	        months: 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split(
	            '_'
	        ),
	        monthsShort:
	            'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoxe ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañá ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
	            },
	            lastDay: function () {
	                return '[onte ' + (this.hours() !== 1 ? 'á' : 'a') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[o] dddd [pasado ' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (str) {
	                if (str.indexOf('un') === 0) {
	                    return 'n' + str;
	                }
	                return 'en ' + str;
	            },
	            past: 'hai %s',
	            s: 'uns segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'unha hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return gl;
	
	})));


/***/ },
/* 819 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Devanagari script [gom-deva]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['थोडया सॅकंडांनी', 'थोडे सॅकंड'],
	            ss: [number + ' सॅकंडांनी', number + ' सॅकंड'],
	            m: ['एका मिणटान', 'एक मिनूट'],
	            mm: [number + ' मिणटांनी', number + ' मिणटां'],
	            h: ['एका वरान', 'एक वर'],
	            hh: [number + ' वरांनी', number + ' वरां'],
	            d: ['एका दिसान', 'एक दीस'],
	            dd: [number + ' दिसांनी', number + ' दीस'],
	            M: ['एका म्हयन्यान', 'एक म्हयनो'],
	            MM: [number + ' म्हयन्यानी', number + ' म्हयने'],
	            y: ['एका वर्सान', 'एक वर्स'],
	            yy: [number + ' वर्सांनी', number + ' वर्सां'],
	        };
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var gomDeva = moment.defineLocale('gom-deva', {
	        months: {
	            standalone:
	                'जानेवारी_फेब्रुवारी_मार्च_एप्रील_मे_जून_जुलय_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
	                    '_'
	                ),
	            format: 'जानेवारीच्या_फेब्रुवारीच्या_मार्चाच्या_एप्रीलाच्या_मेयाच्या_जूनाच्या_जुलयाच्या_ऑगस्टाच्या_सप्टेंबराच्या_ऑक्टोबराच्या_नोव्हेंबराच्या_डिसेंबराच्या'.split(
	                '_'
	            ),
	            isFormat: /MMMM(\s)+D[oD]?/,
	        },
	        monthsShort:
	            'जाने._फेब्रु._मार्च_एप्री._मे_जून_जुल._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'आयतार_सोमार_मंगळार_बुधवार_बिरेस्तार_सुक्रार_शेनवार'.split('_'),
	        weekdaysShort: 'आयत._सोम._मंगळ._बुध._ब्रेस्त._सुक्र._शेन.'.split('_'),
	        weekdaysMin: 'आ_सो_मं_बु_ब्रे_सु_शे'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'A h:mm [वाजतां]',
	            LTS: 'A h:mm:ss [वाजतां]',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY A h:mm [वाजतां]',
	            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [वाजतां]',
	            llll: 'ddd, D MMM YYYY, A h:mm [वाजतां]',
	        },
	        calendar: {
	            sameDay: '[आयज] LT',
	            nextDay: '[फाल्यां] LT',
	            nextWeek: '[फुडलो] dddd[,] LT',
	            lastDay: '[काल] LT',
	            lastWeek: '[फाटलो] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s',
	            past: '%s आदीं',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(वेर)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // the ordinal 'वेर' only applies to day of the month
	                case 'D':
	                    return number + 'वेर';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week
	            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
	        },
	        meridiemParse: /राती|सकाळीं|दनपारां|सांजे/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राती') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सकाळीं') {
	                return hour;
	            } else if (meridiem === 'दनपारां') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'सांजे') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'राती';
	            } else if (hour < 12) {
	                return 'सकाळीं';
	            } else if (hour < 16) {
	                return 'दनपारां';
	            } else if (hour < 20) {
	                return 'सांजे';
	            } else {
	                return 'राती';
	            }
	        },
	    });
	
	    return gomDeva;
	
	})));


/***/ },
/* 820 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Latin script [gom-latn]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['thoddea sekondamni', 'thodde sekond'],
	            ss: [number + ' sekondamni', number + ' sekond'],
	            m: ['eka mintan', 'ek minut'],
	            mm: [number + ' mintamni', number + ' mintam'],
	            h: ['eka voran', 'ek vor'],
	            hh: [number + ' voramni', number + ' voram'],
	            d: ['eka disan', 'ek dis'],
	            dd: [number + ' disamni', number + ' dis'],
	            M: ['eka mhoinean', 'ek mhoino'],
	            MM: [number + ' mhoineamni', number + ' mhoine'],
	            y: ['eka vorsan', 'ek voros'],
	            yy: [number + ' vorsamni', number + ' vorsam'],
	        };
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var gomLatn = moment.defineLocale('gom-latn', {
	        months: {
	            standalone:
	                'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split(
	                    '_'
	                ),
	            format: 'Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea'.split(
	                '_'
	            ),
	            isFormat: /MMMM(\s)+D[oD]?/,
	        },
	        monthsShort:
	            'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays: "Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split('_'),
	        weekdaysShort: 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	        weekdaysMin: 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'A h:mm [vazta]',
	            LTS: 'A h:mm:ss [vazta]',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY A h:mm [vazta]',
	            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [vazta]',
	            llll: 'ddd, D MMM YYYY, A h:mm [vazta]',
	        },
	        calendar: {
	            sameDay: '[Aiz] LT',
	            nextDay: '[Faleam] LT',
	            nextWeek: '[Fuddlo] dddd[,] LT',
	            lastDay: '[Kal] LT',
	            lastWeek: '[Fattlo] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s',
	            past: '%s adim',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // the ordinal 'er' only applies to day of the month
	                case 'D':
	                    return number + 'er';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week
	            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
	        },
	        meridiemParse: /rati|sokallim|donparam|sanje/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'rati') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'sokallim') {
	                return hour;
	            } else if (meridiem === 'donparam') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'sanje') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'rati';
	            } else if (hour < 12) {
	                return 'sokallim';
	            } else if (hour < 16) {
	                return 'donparam';
	            } else if (hour < 20) {
	                return 'sanje';
	            } else {
	                return 'rati';
	            }
	        },
	    });
	
	    return gomLatn;
	
	})));


/***/ },
/* 821 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Gujarati [gu]
	//! author : Kaushik Thanki : https://github.com/Kaushik1987
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '૧',
	            2: '૨',
	            3: '૩',
	            4: '૪',
	            5: '૫',
	            6: '૬',
	            7: '૭',
	            8: '૮',
	            9: '૯',
	            0: '૦',
	        },
	        numberMap = {
	            '૧': '1',
	            '૨': '2',
	            '૩': '3',
	            '૪': '4',
	            '૫': '5',
	            '૬': '6',
	            '૭': '7',
	            '૮': '8',
	            '૯': '9',
	            '૦': '0',
	        };
	
	    var gu = moment.defineLocale('gu', {
	        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split(
	            '_'
	        ),
	        monthsShort:
	            'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split(
	            '_'
	        ),
	        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
	        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm વાગ્યે',
	            LTS: 'A h:mm:ss વાગ્યે',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે',
	        },
	        calendar: {
	            sameDay: '[આજ] LT',
	            nextDay: '[કાલે] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ગઇકાલે] LT',
	            lastWeek: '[પાછલા] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s મા',
	            past: '%s પહેલા',
	            s: 'અમુક પળો',
	            ss: '%d સેકંડ',
	            m: 'એક મિનિટ',
	            mm: '%d મિનિટ',
	            h: 'એક કલાક',
	            hh: '%d કલાક',
	            d: 'એક દિવસ',
	            dd: '%d દિવસ',
	            M: 'એક મહિનો',
	            MM: '%d મહિનો',
	            y: 'એક વર્ષ',
	            yy: '%d વર્ષ',
	        },
	        preparse: function (string) {
	            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
	        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'રાત') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'સવાર') {
	                return hour;
	            } else if (meridiem === 'બપોર') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'સાંજ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'રાત';
	            } else if (hour < 10) {
	                return 'સવાર';
	            } else if (hour < 17) {
	                return 'બપોર';
	            } else if (hour < 20) {
	                return 'સાંજ';
	            } else {
	                return 'રાત';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return gu;
	
	})));


/***/ },
/* 822 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var he = moment.defineLocale('he', {
	        months: 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split(
	            '_'
	        ),
	        monthsShort:
	            'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	        weekdays: 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	        weekdaysShort: 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	        weekdaysMin: 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [ב]MMMM YYYY',
	            LLL: 'D [ב]MMMM YYYY HH:mm',
	            LLLL: 'dddd, D [ב]MMMM YYYY HH:mm',
	            l: 'D/M/YYYY',
	            ll: 'D MMM YYYY',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd, D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[היום ב־]LT',
	            nextDay: '[מחר ב־]LT',
	            nextWeek: 'dddd [בשעה] LT',
	            lastDay: '[אתמול ב־]LT',
	            lastWeek: '[ביום] dddd [האחרון בשעה] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'בעוד %s',
	            past: 'לפני %s',
	            s: 'מספר שניות',
	            ss: '%d שניות',
	            m: 'דקה',
	            mm: '%d דקות',
	            h: 'שעה',
	            hh: function (number) {
	                if (number === 2) {
	                    return 'שעתיים';
	                }
	                return number + ' שעות';
	            },
	            d: 'יום',
	            dd: function (number) {
	                if (number === 2) {
	                    return 'יומיים';
	                }
	                return number + ' ימים';
	            },
	            M: 'חודש',
	            MM: function (number) {
	                if (number === 2) {
	                    return 'חודשיים';
	                }
	                return number + ' חודשים';
	            },
	            y: 'שנה',
	            yy: function (number) {
	                if (number === 2) {
	                    return 'שנתיים';
	                } else if (number % 10 === 0 && number !== 10) {
	                    return number + ' שנה';
	                }
	                return number + ' שנים';
	            },
	        },
	        meridiemParse:
	            /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	        isPM: function (input) {
	            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 5) {
	                return 'לפנות בוקר';
	            } else if (hour < 10) {
	                return 'בבוקר';
	            } else if (hour < 12) {
	                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	            } else if (hour < 18) {
	                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	            } else {
	                return 'בערב';
	            }
	        },
	    });
	
	    return he;
	
	})));


/***/ },
/* 823 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        },
	        monthsParse = [
	            /^जन/i,
	            /^फ़र|फर/i,
	            /^मार्च/i,
	            /^अप्रै/i,
	            /^मई/i,
	            /^जून/i,
	            /^जुल/i,
	            /^अग/i,
	            /^सितं|सित/i,
	            /^अक्टू/i,
	            /^नव|नवं/i,
	            /^दिसं|दिस/i,
	        ],
	        shortMonthsParse = [
	            /^जन/i,
	            /^फ़र/i,
	            /^मार्च/i,
	            /^अप्रै/i,
	            /^मई/i,
	            /^जून/i,
	            /^जुल/i,
	            /^अग/i,
	            /^सित/i,
	            /^अक्टू/i,
	            /^नव/i,
	            /^दिस/i,
	        ];
	
	    var hi = moment.defineLocale('hi', {
	        months: {
	            format: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split(
	                '_'
	            ),
	            standalone:
	                'जनवरी_फरवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितंबर_अक्टूबर_नवंबर_दिसंबर'.split(
	                    '_'
	                ),
	        },
	        monthsShort:
	            'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	        weekdays: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort: 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm बजे',
	            LTS: 'A h:mm:ss बजे',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm बजे',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm बजे',
	        },
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: shortMonthsParse,
	
	        monthsRegex:
	            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
	
	        monthsShortRegex:
	            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
	
	        monthsStrictRegex:
	            /^(जनवरी?|फ़रवरी|फरवरी?|मार्च?|अप्रैल?|मई?|जून?|जुलाई?|अगस्त?|सितम्बर|सितंबर|सित?\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर?|दिसम्बर|दिसंबर?)/i,
	
	        monthsShortStrictRegex:
	            /^(जन\.?|फ़र\.?|मार्च?|अप्रै\.?|मई?|जून?|जुल\.?|अग\.?|सित\.?|अक्टू\.?|नव\.?|दिस\.?)/i,
	
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[कल] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[कल] LT',
	            lastWeek: '[पिछले] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s में',
	            past: '%s पहले',
	            s: 'कुछ ही क्षण',
	            ss: '%d सेकंड',
	            m: 'एक मिनट',
	            mm: '%d मिनट',
	            h: 'एक घंटा',
	            hh: '%d घंटे',
	            d: 'एक दिन',
	            dd: '%d दिन',
	            M: 'एक महीने',
	            MM: '%d महीने',
	            y: 'एक वर्ष',
	            yy: '%d वर्ष',
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	        meridiemParse: /रात|सुबह|दोपहर|शाम/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सुबह') {
	                return hour;
	            } else if (meridiem === 'दोपहर') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'शाम') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात';
	            } else if (hour < 10) {
	                return 'सुबह';
	            } else if (hour < 17) {
	                return 'दोपहर';
	            } else if (hour < 20) {
	                return 'शाम';
	            } else {
	                return 'रात';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return hi;
	
	})));


/***/ },
/* 824 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Croatian [hr]
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var hr = moment.defineLocale('hr', {
	        months: {
	            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split(
	                '_'
	            ),
	            standalone:
	                'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split(
	                    '_'
	                ),
	        },
	        monthsShort:
	            'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM YYYY',
	            LLL: 'Do MMMM YYYY H:mm',
	            LLLL: 'dddd, Do MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[jučer u] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prošlu] [nedjelju] [u] LT';
	                    case 3:
	                        return '[prošlu] [srijedu] [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'par sekundi',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: 'dan',
	            dd: translate,
	            M: 'mjesec',
	            MM: translate,
	            y: 'godinu',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return hr;
	
	})));


/***/ },
/* 825 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	//! author : Peter Viszt  : https://github.com/passatgt
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var weekEndings =
	        'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	    function translate(number, withoutSuffix, key, isFuture) {
	        var num = number;
	        switch (key) {
	            case 's':
	                return isFuture || withoutSuffix
	                    ? 'néhány másodperc'
	                    : 'néhány másodperce';
	            case 'ss':
	                return num + (isFuture || withoutSuffix)
	                    ? ' másodperc'
	                    : ' másodperce';
	            case 'm':
	                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'mm':
	                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'h':
	                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'hh':
	                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'd':
	                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'dd':
	                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'M':
	                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'MM':
	                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'y':
	                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	            case 'yy':
	                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	        }
	        return '';
	    }
	    function week(isFuture) {
	        return (
	            (isFuture ? '' : '[múlt] ') +
	            '[' +
	            weekEndings[this.day()] +
	            '] LT[-kor]'
	        );
	    }
	
	    var hu = moment.defineLocale('hu', {
	        months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._márc._ápr._máj._jún._júl._aug._szept._okt._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	        weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	        weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'YYYY.MM.DD.',
	            LL: 'YYYY. MMMM D.',
	            LLL: 'YYYY. MMMM D. H:mm',
	            LLLL: 'YYYY. MMMM D., dddd H:mm',
	        },
	        meridiemParse: /de|du/i,
	        isPM: function (input) {
	            return input.charAt(1).toLowerCase() === 'u';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower === true ? 'de' : 'DE';
	            } else {
	                return isLower === true ? 'du' : 'DU';
	            }
	        },
	        calendar: {
	            sameDay: '[ma] LT[-kor]',
	            nextDay: '[holnap] LT[-kor]',
	            nextWeek: function () {
	                return week.call(this, true);
	            },
	            lastDay: '[tegnap] LT[-kor]',
	            lastWeek: function () {
	                return week.call(this, false);
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s múlva',
	            past: '%s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return hu;
	
	})));


/***/ },
/* 826 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian [hy-am]
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var hyAm = moment.defineLocale('hy-am', {
	        months: {
	            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split(
	                '_'
	            ),
	            standalone:
	                'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split(
	                    '_'
	                ),
	        },
	        monthsShort: 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	        weekdays:
	            'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split(
	                '_'
	            ),
	        weekdaysShort: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        weekdaysMin: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY թ.',
	            LLL: 'D MMMM YYYY թ., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY թ., HH:mm',
	        },
	        calendar: {
	            sameDay: '[այսօր] LT',
	            nextDay: '[վաղը] LT',
	            lastDay: '[երեկ] LT',
	            nextWeek: function () {
	                return 'dddd [օրը ժամը] LT';
	            },
	            lastWeek: function () {
	                return '[անցած] dddd [օրը ժամը] LT';
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s հետո',
	            past: '%s առաջ',
	            s: 'մի քանի վայրկյան',
	            ss: '%d վայրկյան',
	            m: 'րոպե',
	            mm: '%d րոպե',
	            h: 'ժամ',
	            hh: '%d ժամ',
	            d: 'օր',
	            dd: '%d օր',
	            M: 'ամիս',
	            MM: '%d ամիս',
	            y: 'տարի',
	            yy: '%d տարի',
	        },
	        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	        isPM: function (input) {
	            return /^(ցերեկվա|երեկոյան)$/.test(input);
	        },
	        meridiem: function (hour) {
	            if (hour < 4) {
	                return 'գիշերվա';
	            } else if (hour < 12) {
	                return 'առավոտվա';
	            } else if (hour < 17) {
	                return 'ցերեկվա';
	            } else {
	                return 'երեկոյան';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'DDD':
	                case 'w':
	                case 'W':
	                case 'DDDo':
	                    if (number === 1) {
	                        return number + '-ին';
	                    }
	                    return number + '-րդ';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return hyAm;
	
	})));


/***/ },
/* 827 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Indonesian [id]
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var id = moment.defineLocale('id', {
	        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	        weekdaysShort: 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|siang|sore|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'siang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sore' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'siang';
	            } else if (hours < 19) {
	                return 'sore';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Besok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kemarin pukul] LT',
	            lastWeek: 'dddd [lalu pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lalu',
	            s: 'beberapa detik',
	            ss: '%d detik',
	            m: 'semenit',
	            mm: '%d menit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return id;
	
	})));


/***/ },
/* 828 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Icelandic [is]
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(n) {
	        if (n % 100 === 11) {
	            return true;
	        } else if (n % 10 === 1) {
	            return false;
	        }
	        return true;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture
	                    ? 'nokkrar sekúndur'
	                    : 'nokkrum sekúndum';
	            case 'ss':
	                if (plural(number)) {
	                    return (
	                        result +
	                        (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum')
	                    );
	                }
	                return result + 'sekúnda';
	            case 'm':
	                return withoutSuffix ? 'mínúta' : 'mínútu';
	            case 'mm':
	                if (plural(number)) {
	                    return (
	                        result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum')
	                    );
	                } else if (withoutSuffix) {
	                    return result + 'mínúta';
	                }
	                return result + 'mínútu';
	            case 'hh':
	                if (plural(number)) {
	                    return (
	                        result +
	                        (withoutSuffix || isFuture
	                            ? 'klukkustundir'
	                            : 'klukkustundum')
	                    );
	                }
	                return result + 'klukkustund';
	            case 'd':
	                if (withoutSuffix) {
	                    return 'dagur';
	                }
	                return isFuture ? 'dag' : 'degi';
	            case 'dd':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'dagar';
	                    }
	                    return result + (isFuture ? 'daga' : 'dögum');
	                } else if (withoutSuffix) {
	                    return result + 'dagur';
	                }
	                return result + (isFuture ? 'dag' : 'degi');
	            case 'M':
	                if (withoutSuffix) {
	                    return 'mánuður';
	                }
	                return isFuture ? 'mánuð' : 'mánuði';
	            case 'MM':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'mánuðir';
	                    }
	                    return result + (isFuture ? 'mánuði' : 'mánuðum');
	                } else if (withoutSuffix) {
	                    return result + 'mánuður';
	                }
	                return result + (isFuture ? 'mánuð' : 'mánuði');
	            case 'y':
	                return withoutSuffix || isFuture ? 'ár' : 'ári';
	            case 'yy':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	                }
	                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	        }
	    }
	
	    var is = moment.defineLocale('is', {
	        months: 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	        weekdays:
	            'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split(
	                '_'
	            ),
	        weekdaysShort: 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	        weekdaysMin: 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] H:mm',
	            LLLL: 'dddd, D. MMMM YYYY [kl.] H:mm',
	        },
	        calendar: {
	            sameDay: '[í dag kl.] LT',
	            nextDay: '[á morgun kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[í gær kl.] LT',
	            lastWeek: '[síðasta] dddd [kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'eftir %s',
	            past: 'fyrir %s síðan',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: 'klukkustund',
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return is;
	
	})));


/***/ },
/* 829 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian (Switzerland) [it-ch]
	//! author : xfh : https://github.com/xfh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var itCh = moment.defineLocale('it-ch', {
	        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
	            '_'
	        ),
	        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (s) {
	                return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past: '%s fa',
	            s: 'alcuni secondi',
	            ss: '%d secondi',
	            m: 'un minuto',
	            mm: '%d minuti',
	            h: "un'ora",
	            hh: '%d ore',
	            d: 'un giorno',
	            dd: '%d giorni',
	            M: 'un mese',
	            MM: '%d mesi',
	            y: 'un anno',
	            yy: '%d anni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return itCh;
	
	})));


/***/ },
/* 830 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	//! author: Marco : https://github.com/Manfre98
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var it = moment.defineLocale('it', {
	        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
	            '_'
	        ),
	        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return (
	                    '[Oggi a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            nextDay: function () {
	                return (
	                    '[Domani a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            nextWeek: function () {
	                return (
	                    'dddd [a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            lastDay: function () {
	                return (
	                    '[Ieri a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return (
	                            '[La scorsa] dddd [a' +
	                            (this.hours() > 1
	                                ? 'lle '
	                                : this.hours() === 0
	                                  ? ' '
	                                  : "ll'") +
	                            ']LT'
	                        );
	                    default:
	                        return (
	                            '[Lo scorso] dddd [a' +
	                            (this.hours() > 1
	                                ? 'lle '
	                                : this.hours() === 0
	                                  ? ' '
	                                  : "ll'") +
	                            ']LT'
	                        );
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'tra %s',
	            past: '%s fa',
	            s: 'alcuni secondi',
	            ss: '%d secondi',
	            m: 'un minuto',
	            mm: '%d minuti',
	            h: "un'ora",
	            hh: '%d ore',
	            d: 'un giorno',
	            dd: '%d giorni',
	            w: 'una settimana',
	            ww: '%d settimane',
	            M: 'un mese',
	            MM: '%d mesi',
	            y: 'un anno',
	            yy: '%d anni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return it;
	
	})));


/***/ },
/* 831 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Japanese [ja]
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ja = moment.defineLocale('ja', {
	        eras: [
	            {
	                since: '2019-05-01',
	                offset: 1,
	                name: '令和',
	                narrow: '㋿',
	                abbr: 'R',
	            },
	            {
	                since: '1989-01-08',
	                until: '2019-04-30',
	                offset: 1,
	                name: '平成',
	                narrow: '㍻',
	                abbr: 'H',
	            },
	            {
	                since: '1926-12-25',
	                until: '1989-01-07',
	                offset: 1,
	                name: '昭和',
	                narrow: '㍼',
	                abbr: 'S',
	            },
	            {
	                since: '1912-07-30',
	                until: '1926-12-24',
	                offset: 1,
	                name: '大正',
	                narrow: '㍽',
	                abbr: 'T',
	            },
	            {
	                since: '1873-01-01',
	                until: '1912-07-29',
	                offset: 6,
	                name: '明治',
	                narrow: '㍾',
	                abbr: 'M',
	            },
	            {
	                since: '0001-01-01',
	                until: '1873-12-31',
	                offset: 1,
	                name: '西暦',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: '紀元前',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        eraYearOrdinalRegex: /(元|\d+)年/,
	        eraYearOrdinalParse: function (input, match) {
	            return match[1] === '元' ? 1 : parseInt(match[1] || input, 10);
	        },
	        months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	        weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
	        weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日 dddd HH:mm',
	            l: 'YYYY/MM/DD',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日(ddd) HH:mm',
	        },
	        meridiemParse: /午前|午後/i,
	        isPM: function (input) {
	            return input === '午後';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return '午前';
	            } else {
	                return '午後';
	            }
	        },
	        calendar: {
	            sameDay: '[今日] LT',
	            nextDay: '[明日] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    return '[来週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            lastDay: '[昨日] LT',
	            lastWeek: function (now) {
	                if (this.week() !== now.week()) {
	                    return '[先週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}日/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'y':
	                    return number === 1 ? '元年' : number + '年';
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '数秒',
	            ss: '%d秒',
	            m: '1分',
	            mm: '%d分',
	            h: '1時間',
	            hh: '%d時間',
	            d: '1日',
	            dd: '%d日',
	            M: '1ヶ月',
	            MM: '%dヶ月',
	            y: '1年',
	            yy: '%d年',
	        },
	    });
	
	    return ja;
	
	})));


/***/ },
/* 832 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Javanese [jv]
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var jv = moment.defineLocale('jv', {
	        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	        weekdays: 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	        weekdaysShort: 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /enjing|siyang|sonten|ndalu/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'enjing') {
	                return hour;
	            } else if (meridiem === 'siyang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'enjing';
	            } else if (hours < 15) {
	                return 'siyang';
	            } else if (hours < 19) {
	                return 'sonten';
	            } else {
	                return 'ndalu';
	            }
	        },
	        calendar: {
	            sameDay: '[Dinten puniko pukul] LT',
	            nextDay: '[Mbenjang pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kala wingi pukul] LT',
	            lastWeek: 'dddd [kepengker pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'wonten ing %s',
	            past: '%s ingkang kepengker',
	            s: 'sawetawis detik',
	            ss: '%d detik',
	            m: 'setunggal menit',
	            mm: '%d menit',
	            h: 'setunggal jam',
	            hh: '%d jam',
	            d: 'sedinten',
	            dd: '%d dinten',
	            M: 'sewulan',
	            MM: '%d wulan',
	            y: 'setaun',
	            yy: '%d taun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return jv;
	
	})));


/***/ },
/* 833 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian [ka]
	//! author : Irakli Janiashvili : https://github.com/IrakliJani
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ka = moment.defineLocale('ka', {
	        months: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split(
	            '_'
	        ),
	        monthsShort: 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	        weekdays: {
	            standalone:
	                'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split(
	                    '_'
	                ),
	            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split(
	                '_'
	            ),
	            isFormat: /(წინა|შემდეგ)/,
	        },
	        weekdaysShort: 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	        weekdaysMin: 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[დღეს] LT[-ზე]',
	            nextDay: '[ხვალ] LT[-ზე]',
	            lastDay: '[გუშინ] LT[-ზე]',
	            nextWeek: '[შემდეგ] dddd LT[-ზე]',
	            lastWeek: '[წინა] dddd LT-ზე',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (s) {
	                return s.replace(
	                    /(წამ|წუთ|საათ|წელ|დღ|თვ)(ი|ე)/,
	                    function ($0, $1, $2) {
	                        return $2 === 'ი' ? $1 + 'ში' : $1 + $2 + 'ში';
	                    }
	                );
	            },
	            past: function (s) {
	                if (/(წამი|წუთი|საათი|დღე|თვე)/.test(s)) {
	                    return s.replace(/(ი|ე)$/, 'ის წინ');
	                }
	                if (/წელი/.test(s)) {
	                    return s.replace(/წელი$/, 'წლის წინ');
	                }
	                return s;
	            },
	            s: 'რამდენიმე წამი',
	            ss: '%d წამი',
	            m: 'წუთი',
	            mm: '%d წუთი',
	            h: 'საათი',
	            hh: '%d საათი',
	            d: 'დღე',
	            dd: '%d დღე',
	            M: 'თვე',
	            MM: '%d თვე',
	            y: 'წელი',
	            yy: '%d წელი',
	        },
	        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	        ordinal: function (number) {
	            if (number === 0) {
	                return number;
	            }
	            if (number === 1) {
	                return number + '-ლი';
	            }
	            if (
	                number < 20 ||
	                (number <= 100 && number % 20 === 0) ||
	                number % 100 === 0
	            ) {
	                return 'მე-' + number;
	            }
	            return number + '-ე';
	        },
	        week: {
	            dow: 1,
	            doy: 7,
	        },
	    });
	
	    return ka;
	
	})));


/***/ },
/* 834 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kazakh [kk]
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-ші',
	        1: '-ші',
	        2: '-ші',
	        3: '-ші',
	        4: '-ші',
	        5: '-ші',
	        6: '-шы',
	        7: '-ші',
	        8: '-ші',
	        9: '-шы',
	        10: '-шы',
	        20: '-шы',
	        30: '-шы',
	        40: '-шы',
	        50: '-ші',
	        60: '-шы',
	        70: '-ші',
	        80: '-ші',
	        90: '-шы',
	        100: '-ші',
	    };
	
	    var kk = moment.defineLocale('kk', {
	        months: 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split(
	            '_'
	        ),
	        monthsShort: 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	        weekdays: 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split(
	            '_'
	        ),
	        weekdaysShort: 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	        weekdaysMin: 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бүгін сағат] LT',
	            nextDay: '[Ертең сағат] LT',
	            nextWeek: 'dddd [сағат] LT',
	            lastDay: '[Кеше сағат] LT',
	            lastWeek: '[Өткен аптаның] dddd [сағат] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ішінде',
	            past: '%s бұрын',
	            s: 'бірнеше секунд',
	            ss: '%d секунд',
	            m: 'бір минут',
	            mm: '%d минут',
	            h: 'бір сағат',
	            hh: '%d сағат',
	            d: 'бір күн',
	            dd: '%d күн',
	            M: 'бір ай',
	            MM: '%d ай',
	            y: 'бір жыл',
	            yy: '%d жыл',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return kk;
	
	})));


/***/ },
/* 835 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Cambodian [km]
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '១',
	            2: '២',
	            3: '៣',
	            4: '៤',
	            5: '៥',
	            6: '៦',
	            7: '៧',
	            8: '៨',
	            9: '៩',
	            0: '០',
	        },
	        numberMap = {
	            '១': '1',
	            '២': '2',
	            '៣': '3',
	            '៤': '4',
	            '៥': '5',
	            '៦': '6',
	            '៧': '7',
	            '៨': '8',
	            '៩': '9',
	            '០': '0',
	        };
	
	    var km = moment.defineLocale('km', {
	        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        monthsShort:
	            'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	                '_'
	            ),
	        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ព្រឹក|ល្ងាច/,
	        isPM: function (input) {
	            return input === 'ល្ងាច';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ព្រឹក';
	            } else {
	                return 'ល្ងាច';
	            }
	        },
	        calendar: {
	            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	            nextDay: '[ស្អែក ម៉ោង] LT',
	            nextWeek: 'dddd [ម៉ោង] LT',
	            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sទៀត',
	            past: '%sមុន',
	            s: 'ប៉ុន្មានវិនាទី',
	            ss: '%d វិនាទី',
	            m: 'មួយនាទី',
	            mm: '%d នាទី',
	            h: 'មួយម៉ោង',
	            hh: '%d ម៉ោង',
	            d: 'មួយថ្ងៃ',
	            dd: '%d ថ្ងៃ',
	            M: 'មួយខែ',
	            MM: '%d ខែ',
	            y: 'មួយឆ្នាំ',
	            yy: '%d ឆ្នាំ',
	        },
	        dayOfMonthOrdinalParse: /ទី\d{1,2}/,
	        ordinal: 'ទី%d',
	        preparse: function (string) {
	            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return km;
	
	})));


/***/ },
/* 836 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kannada [kn]
	//! author : Rajeev Naik : https://github.com/rajeevnaikte
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '೧',
	            2: '೨',
	            3: '೩',
	            4: '೪',
	            5: '೫',
	            6: '೬',
	            7: '೭',
	            8: '೮',
	            9: '೯',
	            0: '೦',
	        },
	        numberMap = {
	            '೧': '1',
	            '೨': '2',
	            '೩': '3',
	            '೪': '4',
	            '೫': '5',
	            '೬': '6',
	            '೭': '7',
	            '೮': '8',
	            '೯': '9',
	            '೦': '0',
	        };
	
	    var kn = moment.defineLocale('kn', {
	        months: 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split(
	            '_'
	        ),
	        monthsShort:
	            'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split(
	            '_'
	        ),
	        weekdaysShort: 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	        weekdaysMin: 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[ಇಂದು] LT',
	            nextDay: '[ನಾಳೆ] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ನಿನ್ನೆ] LT',
	            lastWeek: '[ಕೊನೆಯ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ನಂತರ',
	            past: '%s ಹಿಂದೆ',
	            s: 'ಕೆಲವು ಕ್ಷಣಗಳು',
	            ss: '%d ಸೆಕೆಂಡುಗಳು',
	            m: 'ಒಂದು ನಿಮಿಷ',
	            mm: '%d ನಿಮಿಷ',
	            h: 'ಒಂದು ಗಂಟೆ',
	            hh: '%d ಗಂಟೆ',
	            d: 'ಒಂದು ದಿನ',
	            dd: '%d ದಿನ',
	            M: 'ಒಂದು ತಿಂಗಳು',
	            MM: '%d ತಿಂಗಳು',
	            y: 'ಒಂದು ವರ್ಷ',
	            yy: '%d ವರ್ಷ',
	        },
	        preparse: function (string) {
	            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ರಾತ್ರಿ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	                return hour;
	            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ಸಂಜೆ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ರಾತ್ರಿ';
	            } else if (hour < 10) {
	                return 'ಬೆಳಿಗ್ಗೆ';
	            } else if (hour < 17) {
	                return 'ಮಧ್ಯಾಹ್ನ';
	            } else if (hour < 20) {
	                return 'ಸಂಜೆ';
	            } else {
	                return 'ರಾತ್ರಿ';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	        ordinal: function (number) {
	            return number + 'ನೇ';
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return kn;
	
	})));


/***/ },
/* 837 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Korean [ko]
	//! author : Kyungwook, Park : https://github.com/kyungw00k
	//! author : Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ko = moment.defineLocale('ko', {
	        months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split(
	            '_'
	        ),
	        weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	        weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
	        weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'YYYY.MM.DD.',
	            LL: 'YYYY년 MMMM D일',
	            LLL: 'YYYY년 MMMM D일 A h:mm',
	            LLLL: 'YYYY년 MMMM D일 dddd A h:mm',
	            l: 'YYYY.MM.DD.',
	            ll: 'YYYY년 MMMM D일',
	            lll: 'YYYY년 MMMM D일 A h:mm',
	            llll: 'YYYY년 MMMM D일 dddd A h:mm',
	        },
	        calendar: {
	            sameDay: '오늘 LT',
	            nextDay: '내일 LT',
	            nextWeek: 'dddd LT',
	            lastDay: '어제 LT',
	            lastWeek: '지난주 dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s 후',
	            past: '%s 전',
	            s: '몇 초',
	            ss: '%d초',
	            m: '1분',
	            mm: '%d분',
	            h: '한 시간',
	            hh: '%d시간',
	            d: '하루',
	            dd: '%d일',
	            M: '한 달',
	            MM: '%d달',
	            y: '일 년',
	            yy: '%d년',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '일';
	                case 'M':
	                    return number + '월';
	                case 'w':
	                case 'W':
	                    return number + '주';
	                default:
	                    return number;
	            }
	        },
	        meridiemParse: /오전|오후/,
	        isPM: function (token) {
	            return token === '오후';
	        },
	        meridiem: function (hour, minute, isUpper) {
	            return hour < 12 ? '오전' : '오후';
	        },
	    });
	
	    return ko;
	
	})));


/***/ },
/* 838 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Kurdish [ku-kmr]
	//! authors : Mazlum Özdogan : https://github.com/mergehez
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(num, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['çend sanîye', 'çend sanîyeyan'],
	            ss: [num + ' sanîye', num + ' sanîyeyan'],
	            m: ['deqîqeyek', 'deqîqeyekê'],
	            mm: [num + ' deqîqe', num + ' deqîqeyan'],
	            h: ['saetek', 'saetekê'],
	            hh: [num + ' saet', num + ' saetan'],
	            d: ['rojek', 'rojekê'],
	            dd: [num + ' roj', num + ' rojan'],
	            w: ['hefteyek', 'hefteyekê'],
	            ww: [num + ' hefte', num + ' hefteyan'],
	            M: ['mehek', 'mehekê'],
	            MM: [num + ' meh', num + ' mehan'],
	            y: ['salek', 'salekê'],
	            yy: [num + ' sal', num + ' salan'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    // function obliqueNumSuffix(num) {
	    //     if(num.includes(':'))
	    //         num = parseInt(num.split(':')[0]);
	    //     else
	    //         num = parseInt(num);
	    //     return num == 0 || num % 10 == 1 ? 'ê'
	    //                         : (num > 10 && num % 10 == 0 ? 'î' : 'an');
	    // }
	    function ezafeNumSuffix(num) {
	        num = '' + num;
	        var l = num.substring(num.length - 1),
	            ll = num.length > 1 ? num.substring(num.length - 2) : '';
	        if (
	            !(ll == 12 || ll == 13) &&
	            (l == '2' || l == '3' || ll == '50' || l == '70' || l == '80')
	        )
	            return 'yê';
	        return 'ê';
	    }
	
	    var kuKmr = moment.defineLocale('ku-kmr', {
	        // According to the spelling rules defined by the work group of Weqfa Mezopotamyayê (Mesopotamia Foundation)
	        // this should be: 'Kanûna Paşîn_Sibat_Adar_Nîsan_Gulan_Hezîran_Tîrmeh_Tebax_Îlon_Çirîya Pêşîn_Çirîya Paşîn_Kanûna Pêşîn'
	        // But the names below are more well known and handy
	        months: 'Rêbendan_Sibat_Adar_Nîsan_Gulan_Hezîran_Tîrmeh_Tebax_Îlon_Cotmeh_Mijdar_Berfanbar'.split(
	            '_'
	        ),
	        monthsShort: 'Rêb_Sib_Ada_Nîs_Gul_Hez_Tîr_Teb_Îlo_Cot_Mij_Ber'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'Yekşem_Duşem_Sêşem_Çarşem_Pêncşem_În_Şemî'.split('_'),
	        weekdaysShort: 'Yek_Du_Sê_Çar_Pên_În_Şem'.split('_'),
	        weekdaysMin: 'Ye_Du_Sê_Ça_Pê_În_Şe'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'bn' : 'BN';
	            } else {
	                return isLower ? 'pn' : 'PN';
	            }
	        },
	        meridiemParse: /bn|BN|pn|PN/,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM[a] YYYY[an]',
	            LLL: 'Do MMMM[a] YYYY[an] HH:mm',
	            LLLL: 'dddd, Do MMMM[a] YYYY[an] HH:mm',
	            ll: 'Do MMM[.] YYYY[an]',
	            lll: 'Do MMM[.] YYYY[an] HH:mm',
	            llll: 'ddd[.], Do MMM[.] YYYY[an] HH:mm',
	        },
	        calendar: {
	            sameDay: '[Îro di saet] LT [de]',
	            nextDay: '[Sibê di saet] LT [de]',
	            nextWeek: 'dddd [di saet] LT [de]',
	            lastDay: '[Duh di saet] LT [de]',
	            lastWeek: 'dddd[a borî di saet] LT [de]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'di %s de',
	            past: 'berî %s',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(?:yê|ê|\.)/,
	        ordinal: function (num, period) {
	            var p = period.toLowerCase();
	            if (p.includes('w') || p.includes('m')) return num + '.';
	
	            return num + ezafeNumSuffix(num);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return kuKmr;
	
	})));


/***/ },
/* 839 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kurdish [ku]
	//! author : Shahram Mebashar : https://github.com/ShahramMebashar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        },
	        months = [
	            'کانونی دووەم',
	            'شوبات',
	            'ئازار',
	            'نیسان',
	            'ئایار',
	            'حوزەیران',
	            'تەمموز',
	            'ئاب',
	            'ئەیلوول',
	            'تشرینی یەكەم',
	            'تشرینی دووەم',
	            'كانونی یەکەم',
	        ];
	
	    var ku = moment.defineLocale('ku', {
	        months: months,
	        monthsShort: months,
	        weekdays:
	            'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split(
	                '_'
	            ),
	        weekdaysShort:
	            'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split('_'),
	        weekdaysMin: 'ی_د_س_چ_پ_ه_ش'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ئێواره‌|به‌یانی/,
	        isPM: function (input) {
	            return /ئێواره‌/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'به‌یانی';
	            } else {
	                return 'ئێواره‌';
	            }
	        },
	        calendar: {
	            sameDay: '[ئه‌مرۆ كاتژمێر] LT',
	            nextDay: '[به‌یانی كاتژمێر] LT',
	            nextWeek: 'dddd [كاتژمێر] LT',
	            lastDay: '[دوێنێ كاتژمێر] LT',
	            lastWeek: 'dddd [كاتژمێر] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'له‌ %s',
	            past: '%s',
	            s: 'چه‌ند چركه‌یه‌ك',
	            ss: 'چركه‌ %d',
	            m: 'یه‌ك خوله‌ك',
	            mm: '%d خوله‌ك',
	            h: 'یه‌ك كاتژمێر',
	            hh: '%d كاتژمێر',
	            d: 'یه‌ك ڕۆژ',
	            dd: '%d ڕۆژ',
	            M: 'یه‌ك مانگ',
	            MM: '%d مانگ',
	            y: 'یه‌ك ساڵ',
	            yy: '%d ساڵ',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return ku;
	
	})));


/***/ },
/* 840 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kyrgyz [ky]
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-чү',
	        1: '-чи',
	        2: '-чи',
	        3: '-чү',
	        4: '-чү',
	        5: '-чи',
	        6: '-чы',
	        7: '-чи',
	        8: '-чи',
	        9: '-чу',
	        10: '-чу',
	        20: '-чы',
	        30: '-чу',
	        40: '-чы',
	        50: '-чү',
	        60: '-чы',
	        70: '-чи',
	        80: '-чи',
	        90: '-чу',
	        100: '-чү',
	    };
	
	    var ky = moment.defineLocale('ky', {
	        months: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
	            '_'
	        ),
	        monthsShort: 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split(
	            '_'
	        ),
	        weekdays: 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split(
	            '_'
	        ),
	        weekdaysShort: 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	        weekdaysMin: 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бүгүн саат] LT',
	            nextDay: '[Эртең саат] LT',
	            nextWeek: 'dddd [саат] LT',
	            lastDay: '[Кечээ саат] LT',
	            lastWeek: '[Өткөн аптанын] dddd [күнү] [саат] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ичинде',
	            past: '%s мурун',
	            s: 'бирнече секунд',
	            ss: '%d секунд',
	            m: 'бир мүнөт',
	            mm: '%d мүнөт',
	            h: 'бир саат',
	            hh: '%d саат',
	            d: 'бир күн',
	            dd: '%d күн',
	            M: 'бир ай',
	            MM: '%d ай',
	            y: 'бир жыл',
	            yy: '%d жыл',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ky;
	
	})));


/***/ },
/* 841 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish [lb]
	//! author : mweimerskirch : https://github.com/mweimerskirch
	//! author : David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eng Minutt', 'enger Minutt'],
	            h: ['eng Stonn', 'enger Stonn'],
	            d: ['een Dag', 'engem Dag'],
	            M: ['ee Mount', 'engem Mount'],
	            y: ['ee Joer', 'engem Joer'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    function processFutureTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'a ' + string;
	        }
	        return 'an ' + string;
	    }
	    function processPastTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'viru ' + string;
	        }
	        return 'virun ' + string;
	    }
	    /**
	     * Returns true if the word before the given number loses the '-n' ending.
	     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	     *
	     * @param number {integer}
	     * @returns {boolean}
	     */
	    function eifelerRegelAppliesToNumber(number) {
	        number = parseInt(number, 10);
	        if (isNaN(number)) {
	            return false;
	        }
	        if (number < 0) {
	            // Negative Number --> always true
	            return true;
	        } else if (number < 10) {
	            // Only 1 digit
	            if (4 <= number && number <= 7) {
	                return true;
	            }
	            return false;
	        } else if (number < 100) {
	            // 2 digits
	            var lastDigit = number % 10,
	                firstDigit = number / 10;
	            if (lastDigit === 0) {
	                return eifelerRegelAppliesToNumber(firstDigit);
	            }
	            return eifelerRegelAppliesToNumber(lastDigit);
	        } else if (number < 10000) {
	            // 3 or 4 digits --> recursively check first digit
	            while (number >= 10) {
	                number = number / 10;
	            }
	            return eifelerRegelAppliesToNumber(number);
	        } else {
	            // Anything larger than 4 digits: recursively check first n-3 digits
	            number = number / 1000;
	            return eifelerRegelAppliesToNumber(number);
	        }
	    }
	
	    var lb = moment.defineLocale('lb', {
	        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split(
	                '_'
	            ),
	        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm [Auer]',
	            LTS: 'H:mm:ss [Auer]',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm [Auer]',
	            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]',
	        },
	        calendar: {
	            sameDay: '[Haut um] LT',
	            sameElse: 'L',
	            nextDay: '[Muer um] LT',
	            nextWeek: 'dddd [um] LT',
	            lastDay: '[Gëschter um] LT',
	            lastWeek: function () {
	                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	                switch (this.day()) {
	                    case 2:
	                    case 4:
	                        return '[Leschten] dddd [um] LT';
	                    default:
	                        return '[Leschte] dddd [um] LT';
	                }
	            },
	        },
	        relativeTime: {
	            future: processFutureTime,
	            past: processPastTime,
	            s: 'e puer Sekonnen',
	            ss: '%d Sekonnen',
	            m: processRelativeTime,
	            mm: '%d Minutten',
	            h: processRelativeTime,
	            hh: '%d Stonnen',
	            d: processRelativeTime,
	            dd: '%d Deeg',
	            M: processRelativeTime,
	            MM: '%d Méint',
	            y: processRelativeTime,
	            yy: '%d Joer',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lb;
	
	})));


/***/ },
/* 842 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lao [lo]
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var lo = moment.defineLocale('lo', {
	        months: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
	                '_'
	            ),
	        weekdays: 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysShort: 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysMin: 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'ວັນdddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	        isPM: function (input) {
	            return input === 'ຕອນແລງ';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ຕອນເຊົ້າ';
	            } else {
	                return 'ຕອນແລງ';
	            }
	        },
	        calendar: {
	            sameDay: '[ມື້ນີ້ເວລາ] LT',
	            nextDay: '[ມື້ອື່ນເວລາ] LT',
	            nextWeek: '[ວັນ]dddd[ໜ້າເວລາ] LT',
	            lastDay: '[ມື້ວານນີ້ເວລາ] LT',
	            lastWeek: '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ອີກ %s',
	            past: '%sຜ່ານມາ',
	            s: 'ບໍ່ເທົ່າໃດວິນາທີ',
	            ss: '%d ວິນາທີ',
	            m: '1 ນາທີ',
	            mm: '%d ນາທີ',
	            h: '1 ຊົ່ວໂມງ',
	            hh: '%d ຊົ່ວໂມງ',
	            d: '1 ມື້',
	            dd: '%d ມື້',
	            M: '1 ເດືອນ',
	            MM: '%d ເດືອນ',
	            y: '1 ປີ',
	            yy: '%d ປີ',
	        },
	        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	        ordinal: function (number) {
	            return 'ທີ່' + number;
	        },
	    });
	
	    return lo;
	
	})));


/***/ },
/* 843 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian [lt]
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var units = {
	        ss: 'sekundė_sekundžių_sekundes',
	        m: 'minutė_minutės_minutę',
	        mm: 'minutės_minučių_minutes',
	        h: 'valanda_valandos_valandą',
	        hh: 'valandos_valandų_valandas',
	        d: 'diena_dienos_dieną',
	        dd: 'dienos_dienų_dienas',
	        M: 'mėnuo_mėnesio_mėnesį',
	        MM: 'mėnesiai_mėnesių_mėnesius',
	        y: 'metai_metų_metus',
	        yy: 'metai_metų_metus',
	    };
	    function translateSeconds(number, withoutSuffix, key, isFuture) {
	        if (withoutSuffix) {
	            return 'kelios sekundės';
	        } else {
	            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	        }
	    }
	    function translateSingular(number, withoutSuffix, key, isFuture) {
	        return withoutSuffix
	            ? forms(key)[0]
	            : isFuture
	              ? forms(key)[1]
	              : forms(key)[2];
	    }
	    function special(number) {
	        return number % 10 === 0 || (number > 10 && number < 20);
	    }
	    function forms(key) {
	        return units[key].split('_');
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        if (number === 1) {
	            return (
	                result + translateSingular(number, withoutSuffix, key[0], isFuture)
	            );
	        } else if (withoutSuffix) {
	            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	        } else {
	            if (isFuture) {
	                return result + forms(key)[1];
	            } else {
	                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	            }
	        }
	    }
	    var lt = moment.defineLocale('lt', {
	        months: {
	            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split(
	                '_'
	            ),
	            standalone:
	                'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split(
	                    '_'
	                ),
	            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/,
	        },
	        monthsShort: 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	        weekdays: {
	            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split(
	                '_'
	            ),
	            standalone:
	                'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split(
	                    '_'
	                ),
	            isFormat: /dddd HH:mm/,
	        },
	        weekdaysShort: 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	        weekdaysMin: 'S_P_A_T_K_Pn_Š'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY [m.] MMMM D [d.]',
	            LLL: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            LLLL: 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	            l: 'YYYY-MM-DD',
	            ll: 'YYYY [m.] MMMM D [d.]',
	            lll: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            llll: 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]',
	        },
	        calendar: {
	            sameDay: '[Šiandien] LT',
	            nextDay: '[Rytoj] LT',
	            nextWeek: 'dddd LT',
	            lastDay: '[Vakar] LT',
	            lastWeek: '[Praėjusį] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'po %s',
	            past: 'prieš %s',
	            s: translateSeconds,
	            ss: translate,
	            m: translateSingular,
	            mm: translate,
	            h: translateSingular,
	            hh: translate,
	            d: translateSingular,
	            dd: translate,
	            M: translateSingular,
	            MM: translate,
	            y: translateSingular,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	        ordinal: function (number) {
	            return number + '-oji';
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lt;
	
	})));


/***/ },
/* 844 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Latvian [lv]
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var units = {
	        ss: 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
	        m: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        mm: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        h: 'stundas_stundām_stunda_stundas'.split('_'),
	        hh: 'stundas_stundām_stunda_stundas'.split('_'),
	        d: 'dienas_dienām_diena_dienas'.split('_'),
	        dd: 'dienas_dienām_diena_dienas'.split('_'),
	        M: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        MM: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        y: 'gada_gadiem_gads_gadi'.split('_'),
	        yy: 'gada_gadiem_gads_gadi'.split('_'),
	    };
	    /**
	     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	     */
	    function format(forms, number, withoutSuffix) {
	        if (withoutSuffix) {
	            // E.g. "21 minūte", "3 minūtes".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	        } else {
	            // E.g. "21 minūtes" as in "pēc 21 minūtes".
	            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	        }
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        return number + ' ' + format(units[key], number, withoutSuffix);
	    }
	    function relativeTimeWithSingular(number, withoutSuffix, key) {
	        return format(units[key], number, withoutSuffix);
	    }
	    function relativeSeconds(number, withoutSuffix) {
	        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	    }
	
	    var lv = moment.defineLocale('lv', {
	        months: 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	        weekdays:
	            'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split(
	                '_'
	            ),
	        weekdaysShort: 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysMin: 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY.',
	            LL: 'YYYY. [gada] D. MMMM',
	            LLL: 'YYYY. [gada] D. MMMM, HH:mm',
	            LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm',
	        },
	        calendar: {
	            sameDay: '[Šodien pulksten] LT',
	            nextDay: '[Rīt pulksten] LT',
	            nextWeek: 'dddd [pulksten] LT',
	            lastDay: '[Vakar pulksten] LT',
	            lastWeek: '[Pagājušā] dddd [pulksten] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'pēc %s',
	            past: 'pirms %s',
	            s: relativeSeconds,
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithSingular,
	            mm: relativeTimeWithPlural,
	            h: relativeTimeWithSingular,
	            hh: relativeTimeWithPlural,
	            d: relativeTimeWithSingular,
	            dd: relativeTimeWithPlural,
	            M: relativeTimeWithSingular,
	            MM: relativeTimeWithPlural,
	            y: relativeTimeWithSingular,
	            yy: relativeTimeWithPlural,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lv;
	
	})));


/***/ },
/* 845 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin [me]
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['sekund', 'sekunda', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mjesec', 'mjeseca', 'mjeseci'],
	            yy: ['godina', 'godine', 'godina'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1
	                ? wordKey[0]
	                : number >= 2 && number <= 4
	                  ? wordKey[1]
	                  : wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return (
	                    number +
	                    ' ' +
	                    translator.correctGrammaticalCase(number, wordKey)
	                );
	            }
	        },
	    };
	
	    var me = moment.defineLocale('me', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sjutra u] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[juče u] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[prošle] [nedjelje] [u] LT',
	                    '[prošlog] [ponedjeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srijede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'nekoliko sekundi',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: 'dan',
	            dd: translator.translate,
	            M: 'mjesec',
	            MM: translator.translate,
	            y: 'godinu',
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return me;
	
	})));


/***/ },
/* 846 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maori [mi]
	//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mi = moment.defineLocale('mi', {
	        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split(
	            '_'
	        ),
	        monthsShort:
	            'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split(
	                '_'
	            ),
	        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [i] HH:mm',
	            LLLL: 'dddd, D MMMM YYYY [i] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i teie mahana, i] LT',
	            nextDay: '[apopo i] LT',
	            nextWeek: 'dddd [i] LT',
	            lastDay: '[inanahi i] LT',
	            lastWeek: 'dddd [whakamutunga i] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'i roto i %s',
	            past: '%s i mua',
	            s: 'te hēkona ruarua',
	            ss: '%d hēkona',
	            m: 'he meneti',
	            mm: '%d meneti',
	            h: 'te haora',
	            hh: '%d haora',
	            d: 'he ra',
	            dd: '%d ra',
	            M: 'he marama',
	            MM: '%d marama',
	            y: 'he tau',
	            yy: '%d tau',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return mi;
	
	})));


/***/ },
/* 847 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Macedonian [mk]
	//! author : Borislav Mickov : https://github.com/B0k0
	//! author : Sashko Todorov : https://github.com/bkyceh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mk = moment.defineLocale('mk', {
	        months: 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split(
	            '_'
	        ),
	        monthsShort: 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays: 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split(
	            '_'
	        ),
	        weekdaysShort: 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	        weekdaysMin: 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Денес во] LT',
	            nextDay: '[Утре во] LT',
	            nextWeek: '[Во] dddd [во] LT',
	            lastDay: '[Вчера во] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Изминатата] dddd [во] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Изминатиот] dddd [во] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: 'пред %s',
	            s: 'неколку секунди',
	            ss: '%d секунди',
	            m: 'една минута',
	            mm: '%d минути',
	            h: 'еден час',
	            hh: '%d часа',
	            d: 'еден ден',
	            dd: '%d дена',
	            M: 'еден месец',
	            MM: '%d месеци',
	            y: 'една година',
	            yy: '%d години',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal: function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return mk;
	
	})));


/***/ },
/* 848 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malayalam [ml]
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ml = moment.defineLocale('ml', {
	        months: 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split(
	                '_'
	            ),
	        weekdaysShort: 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	        weekdaysMin: 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm -നു',
	            LTS: 'A h:mm:ss -നു',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm -നു',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm -നു',
	        },
	        calendar: {
	            sameDay: '[ഇന്ന്] LT',
	            nextDay: '[നാളെ] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ഇന്നലെ] LT',
	            lastWeek: '[കഴിഞ്ഞ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s കഴിഞ്ഞ്',
	            past: '%s മുൻപ്',
	            s: 'അൽപ നിമിഷങ്ങൾ',
	            ss: '%d സെക്കൻഡ്',
	            m: 'ഒരു മിനിറ്റ്',
	            mm: '%d മിനിറ്റ്',
	            h: 'ഒരു മണിക്കൂർ',
	            hh: '%d മണിക്കൂർ',
	            d: 'ഒരു ദിവസം',
	            dd: '%d ദിവസം',
	            M: 'ഒരു മാസം',
	            MM: '%d മാസം',
	            y: 'ഒരു വർഷം',
	            yy: '%d വർഷം',
	        },
	        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'രാത്രി' && hour >= 4) ||
	                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                meridiem === 'വൈകുന്നേരം'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'രാത്രി';
	            } else if (hour < 12) {
	                return 'രാവിലെ';
	            } else if (hour < 17) {
	                return 'ഉച്ച കഴിഞ്ഞ്';
	            } else if (hour < 20) {
	                return 'വൈകുന്നേരം';
	            } else {
	                return 'രാത്രി';
	            }
	        },
	    });
	
	    return ml;
	
	})));


/***/ },
/* 849 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Mongolian [mn]
	//! author : Javkhlantugs Nyamdorj : https://github.com/javkhaanj7
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key, isFuture) {
	        switch (key) {
	            case 's':
	                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
	            case 'ss':
	                return number + (withoutSuffix ? ' секунд' : ' секундын');
	            case 'm':
	            case 'mm':
	                return number + (withoutSuffix ? ' минут' : ' минутын');
	            case 'h':
	            case 'hh':
	                return number + (withoutSuffix ? ' цаг' : ' цагийн');
	            case 'd':
	            case 'dd':
	                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
	            case 'M':
	            case 'MM':
	                return number + (withoutSuffix ? ' сар' : ' сарын');
	            case 'y':
	            case 'yy':
	                return number + (withoutSuffix ? ' жил' : ' жилийн');
	            default:
	                return number;
	        }
	    }
	
	    var mn = moment.defineLocale('mn', {
	        months: 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split(
	            '_'
	        ),
	        monthsShort:
	            '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
	        weekdaysShort: 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
	        weekdaysMin: 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY оны MMMMын D',
	            LLL: 'YYYY оны MMMMын D HH:mm',
	            LLLL: 'dddd, YYYY оны MMMMын D HH:mm',
	        },
	        meridiemParse: /ҮӨ|ҮХ/i,
	        isPM: function (input) {
	            return input === 'ҮХ';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ҮӨ';
	            } else {
	                return 'ҮХ';
	            }
	        },
	        calendar: {
	            sameDay: '[Өнөөдөр] LT',
	            nextDay: '[Маргааш] LT',
	            nextWeek: '[Ирэх] dddd LT',
	            lastDay: '[Өчигдөр] LT',
	            lastWeek: '[Өнгөрсөн] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s дараа',
	            past: '%s өмнө',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + ' өдөр';
	                default:
	                    return number;
	            }
	        },
	    });
	
	    return mn;
	
	})));


/***/ },
/* 850 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi [mr]
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        };
	
	    function relativeTimeMr(number, withoutSuffix, string, isFuture) {
	        var output = '';
	        if (withoutSuffix) {
	            switch (string) {
	                case 's':
	                    output = 'काही सेकंद';
	                    break;
	                case 'ss':
	                    output = '%d सेकंद';
	                    break;
	                case 'm':
	                    output = 'एक मिनिट';
	                    break;
	                case 'mm':
	                    output = '%d मिनिटे';
	                    break;
	                case 'h':
	                    output = 'एक तास';
	                    break;
	                case 'hh':
	                    output = '%d तास';
	                    break;
	                case 'd':
	                    output = 'एक दिवस';
	                    break;
	                case 'dd':
	                    output = '%d दिवस';
	                    break;
	                case 'M':
	                    output = 'एक महिना';
	                    break;
	                case 'MM':
	                    output = '%d महिने';
	                    break;
	                case 'y':
	                    output = 'एक वर्ष';
	                    break;
	                case 'yy':
	                    output = '%d वर्षे';
	                    break;
	            }
	        } else {
	            switch (string) {
	                case 's':
	                    output = 'काही सेकंदां';
	                    break;
	                case 'ss':
	                    output = '%d सेकंदां';
	                    break;
	                case 'm':
	                    output = 'एका मिनिटा';
	                    break;
	                case 'mm':
	                    output = '%d मिनिटां';
	                    break;
	                case 'h':
	                    output = 'एका तासा';
	                    break;
	                case 'hh':
	                    output = '%d तासां';
	                    break;
	                case 'd':
	                    output = 'एका दिवसा';
	                    break;
	                case 'dd':
	                    output = '%d दिवसां';
	                    break;
	                case 'M':
	                    output = 'एका महिन्या';
	                    break;
	                case 'MM':
	                    output = '%d महिन्यां';
	                    break;
	                case 'y':
	                    output = 'एका वर्षा';
	                    break;
	                case 'yy':
	                    output = '%d वर्षां';
	                    break;
	            }
	        }
	        return output.replace(/%d/i, number);
	    }
	
	    var mr = moment.defineLocale('mr', {
	        months: 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
	            '_'
	        ),
	        monthsShort:
	            'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort: 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm वाजता',
	            LTS: 'A h:mm:ss वाजता',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm वाजता',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm वाजता',
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[उद्या] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[काल] LT',
	            lastWeek: '[मागील] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sमध्ये',
	            past: '%sपूर्वी',
	            s: relativeTimeMr,
	            ss: relativeTimeMr,
	            m: relativeTimeMr,
	            mm: relativeTimeMr,
	            h: relativeTimeMr,
	            hh: relativeTimeMr,
	            d: relativeTimeMr,
	            dd: relativeTimeMr,
	            M: relativeTimeMr,
	            MM: relativeTimeMr,
	            y: relativeTimeMr,
	            yy: relativeTimeMr,
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /पहाटे|सकाळी|दुपारी|सायंकाळी|रात्री/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'पहाटे' || meridiem === 'सकाळी') {
	                return hour;
	            } else if (
	                meridiem === 'दुपारी' ||
	                meridiem === 'सायंकाळी' ||
	                meridiem === 'रात्री'
	            ) {
	                return hour >= 12 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour >= 0 && hour < 6) {
	                return 'पहाटे';
	            } else if (hour < 12) {
	                return 'सकाळी';
	            } else if (hour < 17) {
	                return 'दुपारी';
	            } else if (hour < 20) {
	                return 'सायंकाळी';
	            } else {
	                return 'रात्री';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return mr;
	
	})));


/***/ },
/* 851 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms-my]
	//! note : DEPRECATED, the correct one is [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var msMy = moment.defineLocale('ms-my', {
	        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Esok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kelmarin pukul] LT',
	            lastWeek: 'dddd [lepas pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lepas',
	            s: 'beberapa saat',
	            ss: '%d saat',
	            m: 'seminit',
	            mm: '%d minit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return msMy;
	
	})));


/***/ },
/* 852 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ms = moment.defineLocale('ms', {
	        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Esok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kelmarin pukul] LT',
	            lastWeek: 'dddd [lepas pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lepas',
	            s: 'beberapa saat',
	            ss: '%d saat',
	            m: 'seminit',
	            mm: '%d minit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ms;
	
	})));


/***/ },
/* 853 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maltese (Malta) [mt]
	//! author : Alessandro Maruccia : https://github.com/alesma
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mt = moment.defineLocale('mt', {
	        months: 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
	        weekdays:
	            'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split(
	                '_'
	            ),
	        weekdaysShort: 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
	        weekdaysMin: 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Illum fil-]LT',
	            nextDay: '[Għada fil-]LT',
	            nextWeek: 'dddd [fil-]LT',
	            lastDay: '[Il-bieraħ fil-]LT',
	            lastWeek: 'dddd [li għadda] [fil-]LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'f’ %s',
	            past: '%s ilu',
	            s: 'ftit sekondi',
	            ss: '%d sekondi',
	            m: 'minuta',
	            mm: '%d minuti',
	            h: 'siegħa',
	            hh: '%d siegħat',
	            d: 'ġurnata',
	            dd: '%d ġranet',
	            M: 'xahar',
	            MM: '%d xhur',
	            y: 'sena',
	            yy: '%d sni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return mt;
	
	})));


/***/ },
/* 854 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Burmese [my]
	//! author : Squar team, mysquar.com
	//! author : David Rossellat : https://github.com/gholadr
	//! author : Tin Aung Lin : https://github.com/thanyawzinmin
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '၁',
	            2: '၂',
	            3: '၃',
	            4: '၄',
	            5: '၅',
	            6: '၆',
	            7: '၇',
	            8: '၈',
	            9: '၉',
	            0: '၀',
	        },
	        numberMap = {
	            '၁': '1',
	            '၂': '2',
	            '၃': '3',
	            '၄': '4',
	            '၅': '5',
	            '၆': '6',
	            '၇': '7',
	            '၈': '8',
	            '၉': '9',
	            '၀': '0',
	        };
	
	    var my = moment.defineLocale('my', {
	        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split(
	            '_'
	        ),
	        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split(
	            '_'
	        ),
	        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[ယနေ.] LT [မှာ]',
	            nextDay: '[မနက်ဖြန်] LT [မှာ]',
	            nextWeek: 'dddd LT [မှာ]',
	            lastDay: '[မနေ.က] LT [မှာ]',
	            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'လာမည့် %s မှာ',
	            past: 'လွန်ခဲ့သော %s က',
	            s: 'စက္ကန်.အနည်းငယ်',
	            ss: '%d စက္ကန့်',
	            m: 'တစ်မိနစ်',
	            mm: '%d မိနစ်',
	            h: 'တစ်နာရီ',
	            hh: '%d နာရီ',
	            d: 'တစ်ရက်',
	            dd: '%d ရက်',
	            M: 'တစ်လ',
	            MM: '%d လ',
	            y: 'တစ်နှစ်',
	            yy: '%d နှစ်',
	        },
	        preparse: function (string) {
	            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return my;
	
	})));


/***/ },
/* 855 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Norwegian Bokmål [nb]
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	//!           Stephen Ramthun : https://github.com/stephenramthun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var nb = moment.defineLocale('nb', {
	        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort: 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] HH:mm',
	            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[forrige] dddd [kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s siden',
	            s: 'noen sekunder',
	            ss: '%d sekunder',
	            m: 'ett minutt',
	            mm: '%d minutter',
	            h: 'én time',
	            hh: '%d timer',
	            d: 'én dag',
	            dd: '%d dager',
	            w: 'én uke',
	            ww: '%d uker',
	            M: 'én måned',
	            MM: '%d måneder',
	            y: 'ett år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nb;
	
	})));


/***/ },
/* 856 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nepalese [ne]
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        };
	
	    var ne = moment.defineLocale('ne', {
	        months: 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split(
	            '_'
	        ),
	        monthsShort:
	            'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split(
	            '_'
	        ),
	        weekdaysShort: 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	        weekdaysMin: 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'Aको h:mm बजे',
	            LTS: 'Aको h:mm:ss बजे',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, Aको h:mm बजे',
	            LLLL: 'dddd, D MMMM YYYY, Aको h:mm बजे',
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राति') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'बिहान') {
	                return hour;
	            } else if (meridiem === 'दिउँसो') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'साँझ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 3) {
	                return 'राति';
	            } else if (hour < 12) {
	                return 'बिहान';
	            } else if (hour < 16) {
	                return 'दिउँसो';
	            } else if (hour < 20) {
	                return 'साँझ';
	            } else {
	                return 'राति';
	            }
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[भोलि] LT',
	            nextWeek: '[आउँदो] dddd[,] LT',
	            lastDay: '[हिजो] LT',
	            lastWeek: '[गएको] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sमा',
	            past: '%s अगाडि',
	            s: 'केही क्षण',
	            ss: '%d सेकेण्ड',
	            m: 'एक मिनेट',
	            mm: '%d मिनेट',
	            h: 'एक घण्टा',
	            hh: '%d घण्टा',
	            d: 'एक दिन',
	            dd: '%d दिन',
	            M: 'एक महिना',
	            MM: '%d महिना',
	            y: 'एक बर्ष',
	            yy: '%d बर्ष',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return ne;
	
	})));


/***/ },
/* 857 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch (Belgium) [nl-be]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots =
	            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots =
	            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        monthsParse = [
	            /^jan/i,
	            /^feb/i,
	            /^(maart|mrt\.?)$/i,
	            /^apr/i,
	            /^mei$/i,
	            /^jun[i.]?$/i,
	            /^jul[i.]?$/i,
	            /^aug/i,
	            /^sep/i,
	            /^okt/i,
	            /^nov/i,
	            /^dec/i,
	        ],
	        monthsRegex =
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nlBe = moment.defineLocale('nl-be', {
	        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex:
	            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        weekdays:
	            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'over %s',
	            past: '%s geleden',
	            s: 'een paar seconden',
	            ss: '%d seconden',
	            m: 'één minuut',
	            mm: '%d minuten',
	            h: 'één uur',
	            hh: '%d uur',
	            d: 'één dag',
	            dd: '%d dagen',
	            M: 'één maand',
	            MM: '%d maanden',
	            y: 'één jaar',
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nlBe;
	
	})));


/***/ },
/* 858 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots =
	            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots =
	            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        monthsParse = [
	            /^jan/i,
	            /^feb/i,
	            /^(maart|mrt\.?)$/i,
	            /^apr/i,
	            /^mei$/i,
	            /^jun[i.]?$/i,
	            /^jul[i.]?$/i,
	            /^aug/i,
	            /^sep/i,
	            /^okt/i,
	            /^nov/i,
	            /^dec/i,
	        ],
	        monthsRegex =
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nl = moment.defineLocale('nl', {
	        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex:
	            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        weekdays:
	            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'over %s',
	            past: '%s geleden',
	            s: 'een paar seconden',
	            ss: '%d seconden',
	            m: 'één minuut',
	            mm: '%d minuten',
	            h: 'één uur',
	            hh: '%d uur',
	            d: 'één dag',
	            dd: '%d dagen',
	            w: 'één week',
	            ww: '%d weken',
	            M: 'één maand',
	            MM: '%d maanden',
	            y: 'één jaar',
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nl;
	
	})));


/***/ },
/* 859 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nynorsk [nn]
	//! authors : https://github.com/mechuwind
	//!           Stephen Ramthun : https://github.com/stephenramthun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var nn = moment.defineLocale('nn', {
	        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	        weekdaysShort: 'su._må._ty._on._to._fr._lau.'.split('_'),
	        weekdaysMin: 'su_må_ty_on_to_fr_la'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] H:mm',
	            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[I dag klokka] LT',
	            nextDay: '[I morgon klokka] LT',
	            nextWeek: 'dddd [klokka] LT',
	            lastDay: '[I går klokka] LT',
	            lastWeek: '[Føregåande] dddd [klokka] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s sidan',
	            s: 'nokre sekund',
	            ss: '%d sekund',
	            m: 'eit minutt',
	            mm: '%d minutt',
	            h: 'ein time',
	            hh: '%d timar',
	            d: 'ein dag',
	            dd: '%d dagar',
	            w: 'ei veke',
	            ww: '%d veker',
	            M: 'ein månad',
	            MM: '%d månader',
	            y: 'eit år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nn;
	
	})));


/***/ },
/* 860 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Occitan, lengadocian dialecte [oc-lnc]
	//! author : Quentin PAGÈS : https://github.com/Quenty31
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ocLnc = moment.defineLocale('oc-lnc', {
	        months: {
	            standalone:
	                'genièr_febrièr_març_abril_mai_junh_julhet_agost_setembre_octòbre_novembre_decembre'.split(
	                    '_'
	                ),
	            format: "de genièr_de febrièr_de març_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'octòbre_de novembre_de decembre".split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\s)+MMMM/,
	        },
	        monthsShort:
	            'gen._febr._març_abr._mai_junh_julh._ago._set._oct._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'dimenge_diluns_dimars_dimècres_dijòus_divendres_dissabte'.split(
	            '_'
	        ),
	        weekdaysShort: 'dg._dl._dm._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin: 'dg_dl_dm_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [de] YYYY',
	            ll: 'D MMM YYYY',
	            LLL: 'D MMMM [de] YYYY [a] H:mm',
	            lll: 'D MMM YYYY, H:mm',
	            LLLL: 'dddd D MMMM [de] YYYY [a] H:mm',
	            llll: 'ddd D MMM YYYY, H:mm',
	        },
	        calendar: {
	            sameDay: '[uèi a] LT',
	            nextDay: '[deman a] LT',
	            nextWeek: 'dddd [a] LT',
	            lastDay: '[ièr a] LT',
	            lastWeek: 'dddd [passat a] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: "d'aquí %s",
	            past: 'fa %s',
	            s: 'unas segondas',
	            ss: '%d segondas',
	            m: 'una minuta',
	            mm: '%d minutas',
	            h: 'una ora',
	            hh: '%d oras',
	            d: 'un jorn',
	            dd: '%d jorns',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal: function (number, period) {
	            var output =
	                number === 1
	                    ? 'r'
	                    : number === 2
	                      ? 'n'
	                      : number === 3
	                        ? 'r'
	                        : number === 4
	                          ? 't'
	                          : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4,
	        },
	    });
	
	    return ocLnc;
	
	})));


/***/ },
/* 861 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Punjabi (India) [pa-in]
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '੧',
	            2: '੨',
	            3: '੩',
	            4: '੪',
	            5: '੫',
	            6: '੬',
	            7: '੭',
	            8: '੮',
	            9: '੯',
	            0: '੦',
	        },
	        numberMap = {
	            '੧': '1',
	            '੨': '2',
	            '੩': '3',
	            '੪': '4',
	            '੫': '5',
	            '੬': '6',
	            '੭': '7',
	            '੮': '8',
	            '੯': '9',
	            '੦': '0',
	        };
	
	    var paIn = moment.defineLocale('pa-in', {
	        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
	        months: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
	                '_'
	            ),
	        weekdays: 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split(
	            '_'
	        ),
	        weekdaysShort: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        weekdaysMin: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm ਵਜੇ',
	            LTS: 'A h:mm:ss ਵਜੇ',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm ਵਜੇ',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm ਵਜੇ',
	        },
	        calendar: {
	            sameDay: '[ਅਜ] LT',
	            nextDay: '[ਕਲ] LT',
	            nextWeek: '[ਅਗਲਾ] dddd, LT',
	            lastDay: '[ਕਲ] LT',
	            lastWeek: '[ਪਿਛਲੇ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ਵਿੱਚ',
	            past: '%s ਪਿਛਲੇ',
	            s: 'ਕੁਝ ਸਕਿੰਟ',
	            ss: '%d ਸਕਿੰਟ',
	            m: 'ਇਕ ਮਿੰਟ',
	            mm: '%d ਮਿੰਟ',
	            h: 'ਇੱਕ ਘੰਟਾ',
	            hh: '%d ਘੰਟੇ',
	            d: 'ਇੱਕ ਦਿਨ',
	            dd: '%d ਦਿਨ',
	            M: 'ਇੱਕ ਮਹੀਨਾ',
	            MM: '%d ਮਹੀਨੇ',
	            y: 'ਇੱਕ ਸਾਲ',
	            yy: '%d ਸਾਲ',
	        },
	        preparse: function (string) {
	            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ਰਾਤ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ਸਵੇਰ') {
	                return hour;
	            } else if (meridiem === 'ਦੁਪਹਿਰ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ਸ਼ਾਮ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ਰਾਤ';
	            } else if (hour < 10) {
	                return 'ਸਵੇਰ';
	            } else if (hour < 17) {
	                return 'ਦੁਪਹਿਰ';
	            } else if (hour < 20) {
	                return 'ਸ਼ਾਮ';
	            } else {
	                return 'ਰਾਤ';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return paIn;
	
	})));


/***/ },
/* 862 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsNominative =
	            'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split(
	                '_'
	            ),
	        monthsSubjective =
	            'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split(
	                '_'
	            ),
	        monthsParse = [
	            /^sty/i,
	            /^lut/i,
	            /^mar/i,
	            /^kwi/i,
	            /^maj/i,
	            /^cze/i,
	            /^lip/i,
	            /^sie/i,
	            /^wrz/i,
	            /^paź/i,
	            /^lis/i,
	            /^gru/i,
	        ];
	    function plural(n) {
	        return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
	    }
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                return result + (plural(number) ? 'sekundy' : 'sekund');
	            case 'm':
	                return withoutSuffix ? 'minuta' : 'minutę';
	            case 'mm':
	                return result + (plural(number) ? 'minuty' : 'minut');
	            case 'h':
	                return withoutSuffix ? 'godzina' : 'godzinę';
	            case 'hh':
	                return result + (plural(number) ? 'godziny' : 'godzin');
	            case 'ww':
	                return result + (plural(number) ? 'tygodnie' : 'tygodni');
	            case 'MM':
	                return result + (plural(number) ? 'miesiące' : 'miesięcy');
	            case 'yy':
	                return result + (plural(number) ? 'lata' : 'lat');
	        }
	    }
	
	    var pl = moment.defineLocale('pl', {
	        months: function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return monthsNominative;
	            } else if (/D MMMM/.test(format)) {
	                return monthsSubjective[momentToFormat.month()];
	            } else {
	                return monthsNominative[momentToFormat.month()];
	            }
	        },
	        monthsShort: 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays:
	            'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	        weekdaysShort: 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	        weekdaysMin: 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Dziś o] LT',
	            nextDay: '[Jutro o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W niedzielę o] LT';
	
	                    case 2:
	                        return '[We wtorek o] LT';
	
	                    case 3:
	                        return '[W środę o] LT';
	
	                    case 6:
	                        return '[W sobotę o] LT';
	
	                    default:
	                        return '[W] dddd [o] LT';
	                }
	            },
	            lastDay: '[Wczoraj o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W zeszłą niedzielę o] LT';
	                    case 3:
	                        return '[W zeszłą środę o] LT';
	                    case 6:
	                        return '[W zeszłą sobotę o] LT';
	                    default:
	                        return '[W zeszły] dddd [o] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: '%s temu',
	            s: 'kilka sekund',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: '1 dzień',
	            dd: '%d dni',
	            w: 'tydzień',
	            ww: translate,
	            M: 'miesiąc',
	            MM: translate,
	            y: 'rok',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return pl;
	
	})));


/***/ },
/* 863 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ptBr = moment.defineLocale('pt-br', {
	        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays:
	            'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split(
	                '_'
	            ),
	        weekdaysShort: 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
	        weekdaysMin: 'do_2ª_3ª_4ª_5ª_6ª_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return this.day() === 0 || this.day() === 6
	                    ? '[Último] dddd [às] LT' // Saturday + Sunday
	                    : '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'em %s',
	            past: 'há %s',
	            s: 'poucos segundos',
	            ss: '%d segundos',
	            m: 'um minuto',
	            mm: '%d minutos',
	            h: 'uma hora',
	            hh: '%d horas',
	            d: 'um dia',
	            dd: '%d dias',
	            M: 'um mês',
	            MM: '%d meses',
	            y: 'um ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        invalidDate: 'Data inválida',
	    });
	
	    return ptBr;
	
	})));


/***/ },
/* 864 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var pt = moment.defineLocale('pt', {
	        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays:
	            'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split(
	                '_'
	            ),
	        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY HH:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return this.day() === 0 || this.day() === 6
	                    ? '[Último] dddd [às] LT' // Saturday + Sunday
	                    : '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'em %s',
	            past: 'há %s',
	            s: 'segundos',
	            ss: '%d segundos',
	            m: 'um minuto',
	            mm: '%d minutos',
	            h: 'uma hora',
	            hh: '%d horas',
	            d: 'um dia',
	            dd: '%d dias',
	            w: 'uma semana',
	            ww: '%d semanas',
	            M: 'um mês',
	            MM: '%d meses',
	            y: 'um ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return pt;
	
	})));


/***/ },
/* 865 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	//! author : Emanuel Cepoi : https://github.com/cepem
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	                ss: 'secunde',
	                mm: 'minute',
	                hh: 'ore',
	                dd: 'zile',
	                ww: 'săptămâni',
	                MM: 'luni',
	                yy: 'ani',
	            },
	            separator = ' ';
	        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	            separator = ' de ';
	        }
	        return number + separator + format[key];
	    }
	
	    var ro = moment.defineLocale('ro', {
	        months: 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split(
	            '_'
	        ),
	        monthsShort:
	            'ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	        weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	        weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[azi la] LT',
	            nextDay: '[mâine la] LT',
	            nextWeek: 'dddd [la] LT',
	            lastDay: '[ieri la] LT',
	            lastWeek: '[fosta] dddd [la] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'peste %s',
	            past: '%s în urmă',
	            s: 'câteva secunde',
	            ss: relativeTimeWithPlural,
	            m: 'un minut',
	            mm: relativeTimeWithPlural,
	            h: 'o oră',
	            hh: relativeTimeWithPlural,
	            d: 'o zi',
	            dd: relativeTimeWithPlural,
	            w: 'o săptămână',
	            ww: relativeTimeWithPlural,
	            M: 'o lună',
	            MM: relativeTimeWithPlural,
	            y: 'un an',
	            yy: relativeTimeWithPlural,
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ro;
	
	})));


/***/ },
/* 866 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	              ? forms[1]
	              : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            mm: withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            hh: 'час_часа_часов',
	            dd: 'день_дня_дней',
	            ww: 'неделя_недели_недель',
	            MM: 'месяц_месяца_месяцев',
	            yy: 'год_года_лет',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    var monthsParse = [
	        /^янв/i,
	        /^фев/i,
	        /^мар/i,
	        /^апр/i,
	        /^ма[йя]/i,
	        /^июн/i,
	        /^июл/i,
	        /^авг/i,
	        /^сен/i,
	        /^окт/i,
	        /^ноя/i,
	        /^дек/i,
	    ];
	
	    // http://new.gramota.ru/spravka/rules/139-prop : § 103
	    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	    var ru = moment.defineLocale('ru', {
	        months: {
	            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split(
	                '_'
	            ),
	            standalone:
	                'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
	                    '_'
	                ),
	        },
	        monthsShort: {
	            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку?
	            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split(
	                '_'
	            ),
	            standalone:
	                'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split(
	                    '_'
	                ),
	        },
	        weekdays: {
	            standalone:
	                'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split(
	                    '_'
	                ),
	            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split(
	                '_'
	            ),
	            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/,
	        },
	        weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	        monthsRegex:
	            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // копия предыдущего
	        monthsShortRegex:
	            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // полные названия с падежами
	        monthsStrictRegex:
	            /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	        // Выражение, которое соответствует только сокращённым формам
	        monthsShortStrictRegex:
	            /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY г.',
	            LLL: 'D MMMM YYYY г., H:mm',
	            LLLL: 'dddd, D MMMM YYYY г., H:mm',
	        },
	        calendar: {
	            sameDay: '[Сегодня, в] LT',
	            nextDay: '[Завтра, в] LT',
	            lastDay: '[Вчера, в] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В следующее] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В следующий] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В следующую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            lastWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В прошлое] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В прошлый] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В прошлую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'через %s',
	            past: '%s назад',
	            s: 'несколько секунд',
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: 'час',
	            hh: relativeTimeWithPlural,
	            d: 'день',
	            dd: relativeTimeWithPlural,
	            w: 'неделя',
	            ww: relativeTimeWithPlural,
	            M: 'месяц',
	            MM: relativeTimeWithPlural,
	            y: 'год',
	            yy: relativeTimeWithPlural,
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM: function (input) {
	            return /^(дня|вечера)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                case 'w':
	                case 'W':
	                    return number + '-я';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ru;
	
	})));


/***/ },
/* 867 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sindhi [sd]
	//! author : Narain Sagar : https://github.com/narainsagar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'جنوري',
	            'فيبروري',
	            'مارچ',
	            'اپريل',
	            'مئي',
	            'جون',
	            'جولاءِ',
	            'آگسٽ',
	            'سيپٽمبر',
	            'آڪٽوبر',
	            'نومبر',
	            'ڊسمبر',
	        ],
	        days = ['آچر', 'سومر', 'اڱارو', 'اربع', 'خميس', 'جمع', 'ڇنڇر'];
	
	    var sd = moment.defineLocale('sd', {
	        months: months,
	        monthsShort: months,
	        weekdays: days,
	        weekdaysShort: days,
	        weekdaysMin: days,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd، D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /صبح|شام/,
	        isPM: function (input) {
	            return 'شام' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar: {
	            sameDay: '[اڄ] LT',
	            nextDay: '[سڀاڻي] LT',
	            nextWeek: 'dddd [اڳين هفتي تي] LT',
	            lastDay: '[ڪالهه] LT',
	            lastWeek: '[گزريل هفتي] dddd [تي] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s پوء',
	            past: '%s اڳ',
	            s: 'چند سيڪنڊ',
	            ss: '%d سيڪنڊ',
	            m: 'هڪ منٽ',
	            mm: '%d منٽ',
	            h: 'هڪ ڪلاڪ',
	            hh: '%d ڪلاڪ',
	            d: 'هڪ ڏينهن',
	            dd: '%d ڏينهن',
	            M: 'هڪ مهينو',
	            MM: '%d مهينا',
	            y: 'هڪ سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sd;
	
	})));


/***/ },
/* 868 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Sami [se]
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var se = moment.defineLocale('se', {
	        months: 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split(
	            '_'
	        ),
	        monthsShort:
	            'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	        weekdays:
	            'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split(
	                '_'
	            ),
	        weekdaysShort: 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	        weekdaysMin: 's_v_m_g_d_b_L'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'MMMM D. [b.] YYYY',
	            LLL: 'MMMM D. [b.] YYYY [ti.] HH:mm',
	            LLLL: 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[otne ti] LT',
	            nextDay: '[ihttin ti] LT',
	            nextWeek: 'dddd [ti] LT',
	            lastDay: '[ikte ti] LT',
	            lastWeek: '[ovddit] dddd [ti] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s geažes',
	            past: 'maŋit %s',
	            s: 'moadde sekunddat',
	            ss: '%d sekunddat',
	            m: 'okta minuhta',
	            mm: '%d minuhtat',
	            h: 'okta diimmu',
	            hh: '%d diimmut',
	            d: 'okta beaivi',
	            dd: '%d beaivvit',
	            M: 'okta mánnu',
	            MM: '%d mánut',
	            y: 'okta jahki',
	            yy: '%d jagit',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return se;
	
	})));


/***/ },
/* 869 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese [si]
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    /*jshint -W100*/
	    var si = moment.defineLocale('si', {
	        months: 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split(
	            '_'
	        ),
	        monthsShort: 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split(
	            '_'
	        ),
	        weekdays:
	            'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split(
	                '_'
	            ),
	        weekdaysShort: 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	        weekdaysMin: 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'a h:mm',
	            LTS: 'a h:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY MMMM D',
	            LLL: 'YYYY MMMM D, a h:mm',
	            LLLL: 'YYYY MMMM D [වැනි] dddd, a h:mm:ss',
	        },
	        calendar: {
	            sameDay: '[අද] LT[ට]',
	            nextDay: '[හෙට] LT[ට]',
	            nextWeek: 'dddd LT[ට]',
	            lastDay: '[ඊයේ] LT[ට]',
	            lastWeek: '[පසුගිය] dddd LT[ට]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sකින්',
	            past: '%sකට පෙර',
	            s: 'තත්පර කිහිපය',
	            ss: 'තත්පර %d',
	            m: 'මිනිත්තුව',
	            mm: 'මිනිත්තු %d',
	            h: 'පැය',
	            hh: 'පැය %d',
	            d: 'දිනය',
	            dd: 'දින %d',
	            M: 'මාසය',
	            MM: 'මාස %d',
	            y: 'වසර',
	            yy: 'වසර %d',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	        ordinal: function (number) {
	            return number + ' වැනි';
	        },
	        meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	        isPM: function (input) {
	            return input === 'ප.ව.' || input === 'පස් වරු';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'ප.ව.' : 'පස් වරු';
	            } else {
	                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	            }
	        },
	    });
	
	    return si;
	
	})));


/***/ },
/* 870 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovak [sk]
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months =
	            'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split(
	                '_'
	            ),
	        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	    function plural(n) {
	        return n > 1 && n < 5;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's': // a few seconds / in a few seconds / a few seconds ago
	                return withoutSuffix || isFuture ? 'pár sekúnd' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
	                } else {
	                    return result + 'sekundami';
	                }
	            case 'm': // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minúta' : isFuture ? 'minútu' : 'minútou';
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minúty' : 'minút');
	                } else {
	                    return result + 'minútami';
	                }
	            case 'h': // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodín');
	                } else {
	                    return result + 'hodinami';
	                }
	            case 'd': // a day / in a day / a day ago
	                return withoutSuffix || isFuture ? 'deň' : 'dňom';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dni' : 'dní');
	                } else {
	                    return result + 'dňami';
	                }
	            case 'M': // a month / in a month / a month ago
	                return withoutSuffix || isFuture ? 'mesiac' : 'mesiacom';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
	                } else {
	                    return result + 'mesiacmi';
	                }
	            case 'y': // a year / in a year / a year ago
	                return withoutSuffix || isFuture ? 'rok' : 'rokom';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'rokov');
	                } else {
	                    return result + 'rokmi';
	                }
	        }
	    }
	
	    var sk = moment.defineLocale('sk', {
	        months: months,
	        monthsShort: monthsShort,
	        weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	        weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
	        weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[dnes o] LT',
	            nextDay: '[zajtra o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [o] LT';
	                    case 3:
	                        return '[v stredu o] LT';
	                    case 4:
	                        return '[vo štvrtok o] LT';
	                    case 5:
	                        return '[v piatok o] LT';
	                    case 6:
	                        return '[v sobotu o] LT';
	                }
	            },
	            lastDay: '[včera o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulú nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[minulý] dddd [o] LT';
	                    case 3:
	                        return '[minulú stredu o] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [o] LT';
	                    case 6:
	                        return '[minulú sobotu o] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'pred %s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sk;
	
	})));


/***/ },
/* 871 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture
	                    ? 'nekaj sekund'
	                    : 'nekaj sekundami';
	            case 'ss':
	                if (number === 1) {
	                    result += withoutSuffix ? 'sekundo' : 'sekundi';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
	                } else {
	                    result += 'sekund';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'ena minuta' : 'eno minuto';
	            case 'mm':
	                if (number === 1) {
	                    result += withoutSuffix ? 'minuta' : 'minuto';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'ena ura' : 'eno uro';
	            case 'hh':
	                if (number === 1) {
	                    result += withoutSuffix ? 'ura' : 'uro';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
	                }
	                return result;
	            case 'd':
	                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	            case 'dd':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	                } else {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	                }
	                return result;
	            case 'M':
	                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	            case 'MM':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	                } else {
	                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	                }
	                return result;
	            case 'y':
	                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	            case 'yy':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
	                } else {
	                    result += withoutSuffix || isFuture ? 'let' : 'leti';
	                }
	                return result;
	        }
	    }
	
	    var sl = moment.defineLocale('sl', {
	        months: 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	        weekdaysShort: 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	        weekdaysMin: 'ne_po_to_sr_če_pe_so'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD. MM. YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danes ob] LT',
	            nextDay: '[jutri ob] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[v] [sredo] [ob] LT';
	                    case 6:
	                        return '[v] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[v] dddd [ob] LT';
	                }
	            },
	            lastDay: '[včeraj ob] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prejšnjo] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[prejšnjo] [sredo] [ob] LT';
	                    case 6:
	                        return '[prejšnjo] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prejšnji] dddd [ob] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'čez %s',
	            past: 'pred %s',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sl;
	
	})));


/***/ },
/* 872 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Albanian [sq]
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Oerd Cukalla : https://github.com/oerd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sq = moment.defineLocale('sq', {
	        months: 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	        weekdays: 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split(
	            '_'
	        ),
	        weekdaysShort: 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	        weekdaysMin: 'D_H_Ma_Më_E_P_Sh'.split('_'),
	        weekdaysParseExact: true,
	        meridiemParse: /PD|MD/,
	        isPM: function (input) {
	            return input.charAt(0) === 'M';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            return hours < 12 ? 'PD' : 'MD';
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Sot në] LT',
	            nextDay: '[Nesër në] LT',
	            nextWeek: 'dddd [në] LT',
	            lastDay: '[Dje në] LT',
	            lastWeek: 'dddd [e kaluar në] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'në %s',
	            past: '%s më parë',
	            s: 'disa sekonda',
	            ss: '%d sekonda',
	            m: 'një minutë',
	            mm: '%d minuta',
	            h: 'një orë',
	            hh: '%d orë',
	            d: 'një ditë',
	            dd: '%d ditë',
	            M: 'një muaj',
	            MM: '%d muaj',
	            y: 'një vit',
	            yy: '%d vite',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sq;
	
	})));


/***/ },
/* 873 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian Cyrillic [sr-cyrl]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['секунда', 'секунде', 'секунди'],
	            m: ['један минут', 'једног минута'],
	            mm: ['минут', 'минута', 'минута'],
	            h: ['један сат', 'једног сата'],
	            hh: ['сат', 'сата', 'сати'],
	            d: ['један дан', 'једног дана'],
	            dd: ['дан', 'дана', 'дана'],
	            M: ['један месец', 'једног месеца'],
	            MM: ['месец', 'месеца', 'месеци'],
	            y: ['једну годину', 'једне године'],
	            yy: ['годину', 'године', 'година'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            if (
	                number % 10 >= 1 &&
	                number % 10 <= 4 &&
	                (number % 100 < 10 || number % 100 >= 20)
	            ) {
	                return number % 10 === 1 ? wordKey[0] : wordKey[1];
	            }
	            return wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key, isFuture) {
	            var wordKey = translator.words[key],
	                word;
	
	            if (key.length === 1) {
	                // Nominativ
	                if (key === 'y' && withoutSuffix) return 'једна година';
	                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
	            }
	
	            word = translator.correctGrammaticalCase(number, wordKey);
	            // Nominativ
	            if (key === 'yy' && withoutSuffix && word === 'годину') {
	                return number + ' година';
	            }
	
	            return number + ' ' + word;
	        },
	    };
	
	    var srCyrl = moment.defineLocale('sr-cyrl', {
	        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split(
	            '_'
	        ),
	        monthsShort:
	            'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D. M. YYYY.',
	            LL: 'D. MMMM YYYY.',
	            LLL: 'D. MMMM YYYY. H:mm',
	            LLLL: 'dddd, D. MMMM YYYY. H:mm',
	        },
	        calendar: {
	            sameDay: '[данас у] LT',
	            nextDay: '[сутра у] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[у] [недељу] [у] LT';
	                    case 3:
	                        return '[у] [среду] [у] LT';
	                    case 6:
	                        return '[у] [суботу] [у] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[у] dddd [у] LT';
	                }
	            },
	            lastDay: '[јуче у] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[прошле] [недеље] [у] LT',
	                    '[прошлог] [понедељка] [у] LT',
	                    '[прошлог] [уторка] [у] LT',
	                    '[прошле] [среде] [у] LT',
	                    '[прошлог] [четвртка] [у] LT',
	                    '[прошлог] [петка] [у] LT',
	                    '[прошле] [суботе] [у] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: 'пре %s',
	            s: 'неколико секунди',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: translator.translate,
	            dd: translator.translate,
	            M: translator.translate,
	            MM: translator.translate,
	            y: translator.translate,
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return srCyrl;
	
	})));


/***/ },
/* 874 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian [sr]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['sekunda', 'sekunde', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            d: ['jedan dan', 'jednog dana'],
	            dd: ['dan', 'dana', 'dana'],
	            M: ['jedan mesec', 'jednog meseca'],
	            MM: ['mesec', 'meseca', 'meseci'],
	            y: ['jednu godinu', 'jedne godine'],
	            yy: ['godinu', 'godine', 'godina'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            if (
	                number % 10 >= 1 &&
	                number % 10 <= 4 &&
	                (number % 100 < 10 || number % 100 >= 20)
	            ) {
	                return number % 10 === 1 ? wordKey[0] : wordKey[1];
	            }
	            return wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key, isFuture) {
	            var wordKey = translator.words[key],
	                word;
	
	            if (key.length === 1) {
	                // Nominativ
	                if (key === 'y' && withoutSuffix) return 'jedna godina';
	                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
	            }
	
	            word = translator.correctGrammaticalCase(number, wordKey);
	            // Nominativ
	            if (key === 'yy' && withoutSuffix && word === 'godinu') {
	                return number + ' godina';
	            }
	
	            return number + ' ' + word;
	        },
	    };
	
	    var sr = moment.defineLocale('sr', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D. M. YYYY.',
	            LL: 'D. MMMM YYYY.',
	            LLL: 'D. MMMM YYYY. H:mm',
	            LLLL: 'dddd, D. MMMM YYYY. H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedelju] [u] LT';
	                    case 3:
	                        return '[u] [sredu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[juče u] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[prošle] [nedelje] [u] LT',
	                    '[prošlog] [ponedeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'pre %s',
	            s: 'nekoliko sekundi',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: translator.translate,
	            dd: translator.translate,
	            M: translator.translate,
	            MM: translator.translate,
	            y: translator.translate,
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sr;
	
	})));


/***/ },
/* 875 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : siSwati [ss]
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ss = moment.defineLocale('ss', {
	        months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split(
	            '_'
	        ),
	        monthsShort: 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	        weekdays:
	            'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split(
	                '_'
	            ),
	        weekdaysShort: 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	        weekdaysMin: 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Namuhla nga] LT',
	            nextDay: '[Kusasa nga] LT',
	            nextWeek: 'dddd [nga] LT',
	            lastDay: '[Itolo nga] LT',
	            lastWeek: 'dddd [leliphelile] [nga] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'nga %s',
	            past: 'wenteka nga %s',
	            s: 'emizuzwana lomcane',
	            ss: '%d mzuzwana',
	            m: 'umzuzu',
	            mm: '%d emizuzu',
	            h: 'lihora',
	            hh: '%d emahora',
	            d: 'lilanga',
	            dd: '%d emalanga',
	            M: 'inyanga',
	            MM: '%d tinyanga',
	            y: 'umnyaka',
	            yy: '%d iminyaka',
	        },
	        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'ekuseni';
	            } else if (hours < 15) {
	                return 'emini';
	            } else if (hours < 19) {
	                return 'entsambama';
	            } else {
	                return 'ebusuku';
	            }
	        },
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ekuseni') {
	                return hour;
	            } else if (meridiem === 'emini') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	                if (hour === 0) {
	                    return 0;
	                }
	                return hour + 12;
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: '%d',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ss;
	
	})));


/***/ },
/* 876 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swedish [sv]
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sv = moment.defineLocale('sv', {
	        months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	        weekdaysShort: 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	        weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [kl.] HH:mm',
	            LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Idag] LT',
	            nextDay: '[Imorgon] LT',
	            lastDay: '[Igår] LT',
	            nextWeek: '[På] dddd LT',
	            lastWeek: '[I] dddd[s] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: 'för %s sedan',
	            s: 'några sekunder',
	            ss: '%d sekunder',
	            m: 'en minut',
	            mm: '%d minuter',
	            h: 'en timme',
	            hh: '%d timmar',
	            d: 'en dag',
	            dd: '%d dagar',
	            M: 'en månad',
	            MM: '%d månader',
	            y: 'ett år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? ':e'
	                        : b === 1
	                          ? ':a'
	                          : b === 2
	                            ? ':a'
	                            : b === 3
	                              ? ':e'
	                              : ':e';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sv;
	
	})));


/***/ },
/* 877 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swahili [sw]
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sw = moment.defineLocale('sw', {
	        months: 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	        weekdays:
	            'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split(
	                '_'
	            ),
	        weekdaysShort: 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	        weekdaysMin: 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'hh:mm A',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[leo saa] LT',
	            nextDay: '[kesho saa] LT',
	            nextWeek: '[wiki ijayo] dddd [saat] LT',
	            lastDay: '[jana] LT',
	            lastWeek: '[wiki iliyopita] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s baadaye',
	            past: 'tokea %s',
	            s: 'hivi punde',
	            ss: 'sekunde %d',
	            m: 'dakika moja',
	            mm: 'dakika %d',
	            h: 'saa limoja',
	            hh: 'masaa %d',
	            d: 'siku moja',
	            dd: 'siku %d',
	            M: 'mwezi mmoja',
	            MM: 'miezi %d',
	            y: 'mwaka mmoja',
	            yy: 'miaka %d',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sw;
	
	})));


/***/ },
/* 878 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tamil [ta]
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '௧',
	            2: '௨',
	            3: '௩',
	            4: '௪',
	            5: '௫',
	            6: '௬',
	            7: '௭',
	            8: '௮',
	            9: '௯',
	            0: '௦',
	        },
	        numberMap = {
	            '௧': '1',
	            '௨': '2',
	            '௩': '3',
	            '௪': '4',
	            '௫': '5',
	            '௬': '6',
	            '௭': '7',
	            '௮': '8',
	            '௯': '9',
	            '௦': '0',
	        };
	
	    var ta = moment.defineLocale('ta', {
	        months: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
	            '_'
	        ),
	        monthsShort:
	            'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
	                '_'
	            ),
	        weekdays:
	            'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split(
	                '_'
	            ),
	        weekdaysShort: 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split(
	            '_'
	        ),
	        weekdaysMin: 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, HH:mm',
	            LLLL: 'dddd, D MMMM YYYY, HH:mm',
	        },
	        calendar: {
	            sameDay: '[இன்று] LT',
	            nextDay: '[நாளை] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[நேற்று] LT',
	            lastWeek: '[கடந்த வாரம்] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s இல்',
	            past: '%s முன்',
	            s: 'ஒரு சில விநாடிகள்',
	            ss: '%d விநாடிகள்',
	            m: 'ஒரு நிமிடம்',
	            mm: '%d நிமிடங்கள்',
	            h: 'ஒரு மணி நேரம்',
	            hh: '%d மணி நேரம்',
	            d: 'ஒரு நாள்',
	            dd: '%d நாட்கள்',
	            M: 'ஒரு மாதம்',
	            MM: '%d மாதங்கள்',
	            y: 'ஒரு வருடம்',
	            yy: '%d ஆண்டுகள்',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}வது/,
	        ordinal: function (number) {
	            return number + 'வது';
	        },
	        preparse: function (string) {
	            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // refer http://ta.wikipedia.org/s/1er1
	        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 2) {
	                return ' யாமம்';
	            } else if (hour < 6) {
	                return ' வைகறை'; // வைகறை
	            } else if (hour < 10) {
	                return ' காலை'; // காலை
	            } else if (hour < 14) {
	                return ' நண்பகல்'; // நண்பகல்
	            } else if (hour < 18) {
	                return ' எற்பாடு'; // எற்பாடு
	            } else if (hour < 22) {
	                return ' மாலை'; // மாலை
	            } else {
	                return ' யாமம்';
	            }
	        },
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'யாமம்') {
	                return hour < 2 ? hour : hour + 12;
	            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	                return hour;
	            } else if (meridiem === 'நண்பகல்') {
	                return hour >= 10 ? hour : hour + 12;
	            } else {
	                return hour + 12;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return ta;
	
	})));


/***/ },
/* 879 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Telugu [te]
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var te = moment.defineLocale('te', {
	        months: 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split(
	            '_'
	        ),
	        monthsShort:
	            'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split(
	                '_'
	            ),
	        weekdaysShort: 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	        weekdaysMin: 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[నేడు] LT',
	            nextDay: '[రేపు] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[నిన్న] LT',
	            lastWeek: '[గత] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s లో',
	            past: '%s క్రితం',
	            s: 'కొన్ని క్షణాలు',
	            ss: '%d సెకన్లు',
	            m: 'ఒక నిమిషం',
	            mm: '%d నిమిషాలు',
	            h: 'ఒక గంట',
	            hh: '%d గంటలు',
	            d: 'ఒక రోజు',
	            dd: '%d రోజులు',
	            M: 'ఒక నెల',
	            MM: '%d నెలలు',
	            y: 'ఒక సంవత్సరం',
	            yy: '%d సంవత్సరాలు',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}వ/,
	        ordinal: '%dవ',
	        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'రాత్రి') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ఉదయం') {
	                return hour;
	            } else if (meridiem === 'మధ్యాహ్నం') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'సాయంత్రం') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'రాత్రి';
	            } else if (hour < 10) {
	                return 'ఉదయం';
	            } else if (hour < 17) {
	                return 'మధ్యాహ్నం';
	            } else if (hour < 20) {
	                return 'సాయంత్రం';
	            } else {
	                return 'రాత్రి';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return te;
	
	})));


/***/ },
/* 880 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tetun Dili (East Timor) [tet]
	//! author : Joshua Brooks : https://github.com/joshbrooks
	//! author : Onorio De J. Afonso : https://github.com/marobo
	//! author : Sonia Simoes : https://github.com/soniasimoes
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tet = moment.defineLocale('tet', {
	        months: 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays: 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
	        weekdaysShort: 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
	        weekdaysMin: 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Ohin iha] LT',
	            nextDay: '[Aban iha] LT',
	            nextWeek: 'dddd [iha] LT',
	            lastDay: '[Horiseik iha] LT',
	            lastWeek: 'dddd [semana kotuk] [iha] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'iha %s',
	            past: '%s liuba',
	            s: 'segundu balun',
	            ss: 'segundu %d',
	            m: 'minutu ida',
	            mm: 'minutu %d',
	            h: 'oras ida',
	            hh: 'oras %d',
	            d: 'loron ida',
	            dd: 'loron %d',
	            M: 'fulan ida',
	            MM: 'fulan %d',
	            y: 'tinan ida',
	            yy: 'tinan %d',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tet;
	
	})));


/***/ },
/* 881 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tajik [tg]
	//! author : Orif N. Jr. : https://github.com/orif-jr
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-ум',
	        1: '-ум',
	        2: '-юм',
	        3: '-юм',
	        4: '-ум',
	        5: '-ум',
	        6: '-ум',
	        7: '-ум',
	        8: '-ум',
	        9: '-ум',
	        10: '-ум',
	        12: '-ум',
	        13: '-ум',
	        20: '-ум',
	        30: '-юм',
	        40: '-ум',
	        50: '-ум',
	        60: '-ум',
	        70: '-ум',
	        80: '-ум',
	        90: '-ум',
	        100: '-ум',
	    };
	
	    var tg = moment.defineLocale('tg', {
	        months: {
	            format: 'январи_феврали_марти_апрели_майи_июни_июли_августи_сентябри_октябри_ноябри_декабри'.split(
	                '_'
	            ),
	            standalone:
	                'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
	                    '_'
	                ),
	        },
	        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays: 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split(
	            '_'
	        ),
	        weekdaysShort: 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
	        weekdaysMin: 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Имрӯз соати] LT',
	            nextDay: '[Фардо соати] LT',
	            lastDay: '[Дирӯз соати] LT',
	            nextWeek: 'dddd[и] [ҳафтаи оянда соати] LT',
	            lastWeek: 'dddd[и] [ҳафтаи гузашта соати] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'баъди %s',
	            past: '%s пеш',
	            s: 'якчанд сония',
	            m: 'як дақиқа',
	            mm: '%d дақиқа',
	            h: 'як соат',
	            hh: '%d соат',
	            d: 'як рӯз',
	            dd: '%d рӯз',
	            M: 'як моҳ',
	            MM: '%d моҳ',
	            y: 'як сол',
	            yy: '%d сол',
	        },
	        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'шаб') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'субҳ') {
	                return hour;
	            } else if (meridiem === 'рӯз') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'бегоҳ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'шаб';
	            } else if (hour < 11) {
	                return 'субҳ';
	            } else if (hour < 16) {
	                return 'рӯз';
	            } else if (hour < 19) {
	                return 'бегоҳ';
	            } else {
	                return 'шаб';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1th is the first week of the year.
	        },
	    });
	
	    return tg;
	
	})));


/***/ },
/* 882 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Thai [th]
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var th = moment.defineLocale('th', {
	        months: 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split(
	            '_'
	        ),
	        monthsShort:
	            'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	        weekdaysShort: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	        weekdaysMin: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY เวลา H:mm',
	            LLLL: 'วันddddที่ D MMMM YYYY เวลา H:mm',
	        },
	        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	        isPM: function (input) {
	            return input === 'หลังเที่ยง';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ก่อนเที่ยง';
	            } else {
	                return 'หลังเที่ยง';
	            }
	        },
	        calendar: {
	            sameDay: '[วันนี้ เวลา] LT',
	            nextDay: '[พรุ่งนี้ เวลา] LT',
	            nextWeek: 'dddd[หน้า เวลา] LT',
	            lastDay: '[เมื่อวานนี้ เวลา] LT',
	            lastWeek: '[วัน]dddd[ที่แล้ว เวลา] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'อีก %s',
	            past: '%sที่แล้ว',
	            s: 'ไม่กี่วินาที',
	            ss: '%d วินาที',
	            m: '1 นาที',
	            mm: '%d นาที',
	            h: '1 ชั่วโมง',
	            hh: '%d ชั่วโมง',
	            d: '1 วัน',
	            dd: '%d วัน',
	            w: '1 สัปดาห์',
	            ww: '%d สัปดาห์',
	            M: '1 เดือน',
	            MM: '%d เดือน',
	            y: '1 ปี',
	            yy: '%d ปี',
	        },
	    });
	
	    return th;
	
	})));


/***/ },
/* 883 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkmen [tk]
	//! author : Atamyrat Abdyrahmanov : https://github.com/atamyratabdy
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: "'inji",
	        5: "'inji",
	        8: "'inji",
	        70: "'inji",
	        80: "'inji",
	        2: "'nji",
	        7: "'nji",
	        20: "'nji",
	        50: "'nji",
	        3: "'ünji",
	        4: "'ünji",
	        100: "'ünji",
	        6: "'njy",
	        9: "'unjy",
	        10: "'unjy",
	        30: "'unjy",
	        60: "'ynjy",
	        90: "'ynjy",
	    };
	
	    var tk = moment.defineLocale('tk', {
	        months: 'Ýanwar_Fewral_Mart_Aprel_Maý_Iýun_Iýul_Awgust_Sentýabr_Oktýabr_Noýabr_Dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'Ýan_Few_Mar_Apr_Maý_Iýn_Iýl_Awg_Sen_Okt_Noý_Dek'.split('_'),
	        weekdays: 'Ýekşenbe_Duşenbe_Sişenbe_Çarşenbe_Penşenbe_Anna_Şenbe'.split(
	            '_'
	        ),
	        weekdaysShort: 'Ýek_Duş_Siş_Çar_Pen_Ann_Şen'.split('_'),
	        weekdaysMin: 'Ýk_Dş_Sş_Çr_Pn_An_Şn'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün sagat] LT',
	            nextDay: '[ertir sagat] LT',
	            nextWeek: '[indiki] dddd [sagat] LT',
	            lastDay: '[düýn] LT',
	            lastWeek: '[geçen] dddd [sagat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s soň',
	            past: '%s öň',
	            s: 'birnäçe sekunt',
	            m: 'bir minut',
	            mm: '%d minut',
	            h: 'bir sagat',
	            hh: '%d sagat',
	            d: 'bir gün',
	            dd: '%d gün',
	            M: 'bir aý',
	            MM: '%d aý',
	            y: 'bir ýyl',
	            yy: '%d ýyl',
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {
	                        // special case for zero
	                        return number + "'unjy";
	                    }
	                    var a = number % 10,
	                        b = (number % 100) - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return tk;
	
	})));


/***/ },
/* 884 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tagalog (Philippines) [tl-ph]
	//! author : Dan Hagman : https://github.com/hagmandan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tlPh = moment.defineLocale('tl-ph', {
	        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
	            '_'
	        ),
	        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'MM/D/YYYY',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY HH:mm',
	            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'sa loob ng %s',
	            past: '%s ang nakalipas',
	            s: 'ilang segundo',
	            ss: '%d segundo',
	            m: 'isang minuto',
	            mm: '%d minuto',
	            h: 'isang oras',
	            hh: '%d oras',
	            d: 'isang araw',
	            dd: '%d araw',
	            M: 'isang buwan',
	            MM: '%d buwan',
	            y: 'isang taon',
	            yy: '%d taon',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tlPh;
	
	})));


/***/ },
/* 885 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Klingon [tlh]
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	    function translateFuture(output) {
	        var time = output;
	        time =
	            output.indexOf('jaj') !== -1
	                ? time.slice(0, -3) + 'leS'
	                : output.indexOf('jar') !== -1
	                  ? time.slice(0, -3) + 'waQ'
	                  : output.indexOf('DIS') !== -1
	                    ? time.slice(0, -3) + 'nem'
	                    : time + ' pIq';
	        return time;
	    }
	
	    function translatePast(output) {
	        var time = output;
	        time =
	            output.indexOf('jaj') !== -1
	                ? time.slice(0, -3) + 'Hu’'
	                : output.indexOf('jar') !== -1
	                  ? time.slice(0, -3) + 'wen'
	                  : output.indexOf('DIS') !== -1
	                    ? time.slice(0, -3) + 'ben'
	                    : time + ' ret';
	        return time;
	    }
	
	    function translate(number, withoutSuffix, string, isFuture) {
	        var numberNoun = numberAsNoun(number);
	        switch (string) {
	            case 'ss':
	                return numberNoun + ' lup';
	            case 'mm':
	                return numberNoun + ' tup';
	            case 'hh':
	                return numberNoun + ' rep';
	            case 'dd':
	                return numberNoun + ' jaj';
	            case 'MM':
	                return numberNoun + ' jar';
	            case 'yy':
	                return numberNoun + ' DIS';
	        }
	    }
	
	    function numberAsNoun(number) {
	        var hundred = Math.floor((number % 1000) / 100),
	            ten = Math.floor((number % 100) / 10),
	            one = number % 10,
	            word = '';
	        if (hundred > 0) {
	            word += numbersNouns[hundred] + 'vatlh';
	        }
	        if (ten > 0) {
	            word += (word !== '' ? ' ' : '') + numbersNouns[ten] + 'maH';
	        }
	        if (one > 0) {
	            word += (word !== '' ? ' ' : '') + numbersNouns[one];
	        }
	        return word === '' ? 'pagh' : word;
	    }
	
	    var tlh = moment.defineLocale('tlh', {
	        months: 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split(
	            '_'
	        ),
	        monthsShort:
	            'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
	            '_'
	        ),
	        weekdaysShort:
	            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysMin:
	            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[DaHjaj] LT',
	            nextDay: '[wa’leS] LT',
	            nextWeek: 'LLL',
	            lastDay: '[wa’Hu’] LT',
	            lastWeek: 'LLL',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: translateFuture,
	            past: translatePast,
	            s: 'puS lup',
	            ss: translate,
	            m: 'wa’ tup',
	            mm: translate,
	            h: 'wa’ rep',
	            hh: translate,
	            d: 'wa’ jaj',
	            dd: translate,
	            M: 'wa’ jar',
	            MM: translate,
	            y: 'wa’ DIS',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tlh;
	
	})));


/***/ },
/* 886 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: "'inci",
	        5: "'inci",
	        8: "'inci",
	        70: "'inci",
	        80: "'inci",
	        2: "'nci",
	        7: "'nci",
	        20: "'nci",
	        50: "'nci",
	        3: "'üncü",
	        4: "'üncü",
	        100: "'üncü",
	        6: "'ncı",
	        9: "'uncu",
	        10: "'uncu",
	        30: "'uncu",
	        60: "'ıncı",
	        90: "'ıncı",
	    };
	
	    var tr = moment.defineLocale('tr', {
	        months: 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split(
	            '_'
	        ),
	        monthsShort: 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	        weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split(
	            '_'
	        ),
	        weekdaysShort: 'Paz_Pzt_Sal_Çar_Per_Cum_Cmt'.split('_'),
	        weekdaysMin: 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'öö' : 'ÖÖ';
	            } else {
	                return isLower ? 'ös' : 'ÖS';
	            }
	        },
	        meridiemParse: /öö|ÖÖ|ös|ÖS/,
	        isPM: function (input) {
	            return input === 'ös' || input === 'ÖS';
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün saat] LT',
	            nextDay: '[yarın saat] LT',
	            nextWeek: '[gelecek] dddd [saat] LT',
	            lastDay: '[dün] LT',
	            lastWeek: '[geçen] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s sonra',
	            past: '%s önce',
	            s: 'birkaç saniye',
	            ss: '%d saniye',
	            m: 'bir dakika',
	            mm: '%d dakika',
	            h: 'bir saat',
	            hh: '%d saat',
	            d: 'bir gün',
	            dd: '%d gün',
	            w: 'bir hafta',
	            ww: '%d hafta',
	            M: 'bir ay',
	            MM: '%d ay',
	            y: 'bir yıl',
	            yy: '%d yıl',
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {
	                        // special case for zero
	                        return number + "'ıncı";
	                    }
	                    var a = number % 10,
	                        b = (number % 100) - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return tr;
	
	})));


/***/ },
/* 887 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Talossan [tzl]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	//! author : Iustì Canun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	    // This is currently too difficult (maybe even impossible) to add.
	    var tzl = moment.defineLocale('tzl', {
	        months: 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	        weekdays: 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	        weekdaysShort: 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	        weekdaysMin: 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM [dallas] YYYY',
	            LLL: 'D. MMMM [dallas] YYYY HH.mm',
	            LLLL: 'dddd, [li] D. MMMM [dallas] YYYY HH.mm',
	        },
	        meridiemParse: /d\'o|d\'a/i,
	        isPM: function (input) {
	            return "d'o" === input.toLowerCase();
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? "d'o" : "D'O";
	            } else {
	                return isLower ? "d'a" : "D'A";
	            }
	        },
	        calendar: {
	            sameDay: '[oxhi à] LT',
	            nextDay: '[demà à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[ieiri à] LT',
	            lastWeek: '[sür el] dddd [lasteu à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'osprei %s',
	            past: 'ja%s',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['viensas secunds', "'iensas secunds"],
	            ss: [number + ' secunds', '' + number + ' secunds'],
	            m: ["'n míut", "'iens míut"],
	            mm: [number + ' míuts', '' + number + ' míuts'],
	            h: ["'n þora", "'iensa þora"],
	            hh: [number + ' þoras', '' + number + ' þoras'],
	            d: ["'n ziua", "'iensa ziua"],
	            dd: [number + ' ziuas', '' + number + ' ziuas'],
	            M: ["'n mes", "'iens mes"],
	            MM: [number + ' mesen', '' + number + ' mesen'],
	            y: ["'n ar", "'iens ar"],
	            yy: [number + ' ars', '' + number + ' ars'],
	        };
	        return isFuture
	            ? format[key][0]
	            : withoutSuffix
	              ? format[key][0]
	              : format[key][1];
	    }
	
	    return tzl;
	
	})));


/***/ },
/* 888 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight Latin [tzm-latn]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tzmLatn = moment.defineLocale('tzm-latn', {
	        months: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
	            '_'
	        ),
	        monthsShort:
	            'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
	                '_'
	            ),
	        weekdays: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysShort: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysMin: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[asdkh g] LT',
	            nextDay: '[aska g] LT',
	            nextWeek: 'dddd [g] LT',
	            lastDay: '[assant g] LT',
	            lastWeek: 'dddd [g] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dadkh s yan %s',
	            past: 'yan %s',
	            s: 'imik',
	            ss: '%d imik',
	            m: 'minuḍ',
	            mm: '%d minuḍ',
	            h: 'saɛa',
	            hh: '%d tassaɛin',
	            d: 'ass',
	            dd: '%d ossan',
	            M: 'ayowr',
	            MM: '%d iyyirn',
	            y: 'asgas',
	            yy: '%d isgasn',
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return tzmLatn;
	
	})));


/***/ },
/* 889 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight [tzm]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tzm = moment.defineLocale('tzm', {
	        months: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
	                '_'
	            ),
	        weekdays: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysShort: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysMin: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	            nextWeek: 'dddd [ⴴ] LT',
	            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	            lastWeek: 'dddd [ⴴ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	            past: 'ⵢⴰⵏ %s',
	            s: 'ⵉⵎⵉⴽ',
	            ss: '%d ⵉⵎⵉⴽ',
	            m: 'ⵎⵉⵏⵓⴺ',
	            mm: '%d ⵎⵉⵏⵓⴺ',
	            h: 'ⵙⴰⵄⴰ',
	            hh: '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	            d: 'ⴰⵙⵙ',
	            dd: '%d oⵙⵙⴰⵏ',
	            M: 'ⴰⵢoⵓⵔ',
	            MM: '%d ⵉⵢⵢⵉⵔⵏ',
	            y: 'ⴰⵙⴳⴰⵙ',
	            yy: '%d ⵉⵙⴳⴰⵙⵏ',
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return tzm;
	
	})));


/***/ },
/* 890 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uyghur (China) [ug-cn]
	//! author: boyaq : https://github.com/boyaq
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ugCn = moment.defineLocale('ug-cn', {
	        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	                '_'
	            ),
	        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
	            '_'
	        ),
	        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
	            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	        },
	        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                meridiem === 'يېرىم كېچە' ||
	                meridiem === 'سەھەر' ||
	                meridiem === 'چۈشتىن بۇرۇن'
	            ) {
	                return hour;
	            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
	                return hour + 12;
	            } else {
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return 'يېرىم كېچە';
	            } else if (hm < 900) {
	                return 'سەھەر';
	            } else if (hm < 1130) {
	                return 'چۈشتىن بۇرۇن';
	            } else if (hm < 1230) {
	                return 'چۈش';
	            } else if (hm < 1800) {
	                return 'چۈشتىن كېيىن';
	            } else {
	                return 'كەچ';
	            }
	        },
	        calendar: {
	            sameDay: '[بۈگۈن سائەت] LT',
	            nextDay: '[ئەتە سائەت] LT',
	            nextWeek: '[كېلەركى] dddd [سائەت] LT',
	            lastDay: '[تۆنۈگۈن] LT',
	            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s كېيىن',
	            past: '%s بۇرۇن',
	            s: 'نەچچە سېكونت',
	            ss: '%d سېكونت',
	            m: 'بىر مىنۇت',
	            mm: '%d مىنۇت',
	            h: 'بىر سائەت',
	            hh: '%d سائەت',
	            d: 'بىر كۈن',
	            dd: '%d كۈن',
	            M: 'بىر ئاي',
	            MM: '%d ئاي',
	            y: 'بىر يىل',
	            yy: '%d يىل',
	        },
	
	        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '-كۈنى';
	                case 'w':
	                case 'W':
	                    return number + '-ھەپتە';
	                default:
	                    return number;
	            }
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return ugCn;
	
	})));


/***/ },
/* 891 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Ukrainian [uk]
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	              ? forms[1]
	              : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
	            mm: withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	            hh: withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	            dd: 'день_дні_днів',
	            MM: 'місяць_місяці_місяців',
	            yy: 'рік_роки_років',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвилина' : 'хвилину';
	        } else if (key === 'h') {
	            return withoutSuffix ? 'година' : 'годину';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	                nominative:
	                    'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split(
	                        '_'
	                    ),
	                accusative:
	                    'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split(
	                        '_'
	                    ),
	                genitive:
	                    'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split(
	                        '_'
	                    ),
	            },
	            nounCase;
	
	        if (m === true) {
	            return weekdays['nominative']
	                .slice(1, 7)
	                .concat(weekdays['nominative'].slice(0, 1));
	        }
	        if (!m) {
	            return weekdays['nominative'];
	        }
	
	        nounCase = /(\[[ВвУу]\]) ?dddd/.test(format)
	            ? 'accusative'
	            : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(format)
	              ? 'genitive'
	              : 'nominative';
	        return weekdays[nounCase][m.day()];
	    }
	    function processHoursFunction(str) {
	        return function () {
	            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	        };
	    }
	
	    var uk = moment.defineLocale('uk', {
	        months: {
	            format: 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split(
	                '_'
	            ),
	            standalone:
	                'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split(
	                    '_'
	                ),
	        },
	        monthsShort: 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split(
	            '_'
	        ),
	        weekdays: weekdaysCaseReplace,
	        weekdaysShort: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY р.',
	            LLL: 'D MMMM YYYY р., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY р., HH:mm',
	        },
	        calendar: {
	            sameDay: processHoursFunction('[Сьогодні '),
	            nextDay: processHoursFunction('[Завтра '),
	            lastDay: processHoursFunction('[Вчора '),
	            nextWeek: processHoursFunction('[У] dddd ['),
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return processHoursFunction('[Минулої] dddd [').call(this);
	                    case 1:
	                    case 2:
	                    case 4:
	                        return processHoursFunction('[Минулого] dddd [').call(this);
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: '%s тому',
	            s: 'декілька секунд',
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: 'годину',
	            hh: relativeTimeWithPlural,
	            d: 'день',
	            dd: relativeTimeWithPlural,
	            M: 'місяць',
	            MM: relativeTimeWithPlural,
	            y: 'рік',
	            yy: relativeTimeWithPlural,
	        },
	        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	        meridiemParse: /ночі|ранку|дня|вечора/,
	        isPM: function (input) {
	            return /^(дня|вечора)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночі';
	            } else if (hour < 12) {
	                return 'ранку';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечора';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return uk;
	
	})));


/***/ },
/* 892 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Urdu [ur]
	//! author : Sawood Alam : https://github.com/ibnesayeed
	//! author : Zack : https://github.com/ZackVision
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'جنوری',
	            'فروری',
	            'مارچ',
	            'اپریل',
	            'مئی',
	            'جون',
	            'جولائی',
	            'اگست',
	            'ستمبر',
	            'اکتوبر',
	            'نومبر',
	            'دسمبر',
	        ],
	        days = ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'];
	
	    var ur = moment.defineLocale('ur', {
	        months: months,
	        monthsShort: months,
	        weekdays: days,
	        weekdaysShort: days,
	        weekdaysMin: days,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd، D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /صبح|شام/,
	        isPM: function (input) {
	            return 'شام' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar: {
	            sameDay: '[آج بوقت] LT',
	            nextDay: '[کل بوقت] LT',
	            nextWeek: 'dddd [بوقت] LT',
	            lastDay: '[گذشتہ روز بوقت] LT',
	            lastWeek: '[گذشتہ] dddd [بوقت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s بعد',
	            past: '%s قبل',
	            s: 'چند سیکنڈ',
	            ss: '%d سیکنڈ',
	            m: 'ایک منٹ',
	            mm: '%d منٹ',
	            h: 'ایک گھنٹہ',
	            hh: '%d گھنٹے',
	            d: 'ایک دن',
	            dd: '%d دن',
	            M: 'ایک ماہ',
	            MM: '%d ماہ',
	            y: 'ایک سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ur;
	
	})));


/***/ },
/* 893 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek Latin [uz-latn]
	//! author : Rasulbek Mirzayev : github.com/Rasulbeeek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var uzLatn = moment.defineLocale('uz-latn', {
	        months: 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	        weekdays:
	            'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split(
	                '_'
	            ),
	        weekdaysShort: 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	        weekdaysMin: 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'D MMMM YYYY, dddd HH:mm',
	        },
	        calendar: {
	            sameDay: '[Bugun soat] LT [da]',
	            nextDay: '[Ertaga] LT [da]',
	            nextWeek: 'dddd [kuni soat] LT [da]',
	            lastDay: '[Kecha soat] LT [da]',
	            lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'Yaqin %s ichida',
	            past: 'Bir necha %s oldin',
	            s: 'soniya',
	            ss: '%d soniya',
	            m: 'bir daqiqa',
	            mm: '%d daqiqa',
	            h: 'bir soat',
	            hh: '%d soat',
	            d: 'bir kun',
	            dd: '%d kun',
	            M: 'bir oy',
	            MM: '%d oy',
	            y: 'bir yil',
	            yy: '%d yil',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return uzLatn;
	
	})));


/***/ },
/* 894 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek [uz]
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var uz = moment.defineLocale('uz', {
	        months: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
	            '_'
	        ),
	        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays: 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	        weekdaysShort: 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	        weekdaysMin: 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'D MMMM YYYY, dddd HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бугун соат] LT [да]',
	            nextDay: '[Эртага] LT [да]',
	            nextWeek: 'dddd [куни соат] LT [да]',
	            lastDay: '[Кеча соат] LT [да]',
	            lastWeek: '[Утган] dddd [куни соат] LT [да]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'Якин %s ичида',
	            past: 'Бир неча %s олдин',
	            s: 'фурсат',
	            ss: '%d фурсат',
	            m: 'бир дакика',
	            mm: '%d дакика',
	            h: 'бир соат',
	            hh: '%d соат',
	            d: 'бир кун',
	            dd: '%d кун',
	            M: 'бир ой',
	            MM: '%d ой',
	            y: 'бир йил',
	            yy: '%d йил',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return uz;
	
	})));


/***/ },
/* 895 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Vietnamese [vi]
	//! author : Bang Nguyen : https://github.com/bangnk
	//! author : Chien Kira : https://github.com/chienkira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var vi = moment.defineLocale('vi', {
	        months: 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split(
	            '_'
	        ),
	        monthsShort:
	            'Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split(
	            '_'
	        ),
	        weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysParseExact: true,
	        meridiemParse: /sa|ch/i,
	        isPM: function (input) {
	            return /^ch$/i.test(input);
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'sa' : 'SA';
	            } else {
	                return isLower ? 'ch' : 'CH';
	            }
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [năm] YYYY',
	            LLL: 'D MMMM [năm] YYYY HH:mm',
	            LLLL: 'dddd, D MMMM [năm] YYYY HH:mm',
	            l: 'DD/M/YYYY',
	            ll: 'D MMM YYYY',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd, D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hôm nay lúc] LT',
	            nextDay: '[Ngày mai lúc] LT',
	            nextWeek: 'dddd [tuần tới lúc] LT',
	            lastDay: '[Hôm qua lúc] LT',
	            lastWeek: 'dddd [tuần trước lúc] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s tới',
	            past: '%s trước',
	            s: 'vài giây',
	            ss: '%d giây',
	            m: 'một phút',
	            mm: '%d phút',
	            h: 'một giờ',
	            hh: '%d giờ',
	            d: 'một ngày',
	            dd: '%d ngày',
	            w: 'một tuần',
	            ww: '%d tuần',
	            M: 'một tháng',
	            MM: '%d tháng',
	            y: 'một năm',
	            yy: '%d năm',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return vi;
	
	})));


/***/ },
/* 896 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Pseudo [x-pseudo]
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var xPseudo = moment.defineLocale('x-pseudo', {
	        months: 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split(
	            '_'
	        ),
	        monthsShort:
	            'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split(
	                '_'
	            ),
	        weekdaysShort: 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	        weekdaysMin: 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[T~ódá~ý át] LT',
	            nextDay: '[T~ómó~rró~w át] LT',
	            nextWeek: 'dddd [át] LT',
	            lastDay: '[Ý~ést~érdá~ý át] LT',
	            lastWeek: '[L~ást] dddd [át] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'í~ñ %s',
	            past: '%s á~gó',
	            s: 'á ~féw ~sécó~ñds',
	            ss: '%d s~écóñ~ds',
	            m: 'á ~míñ~úté',
	            mm: '%d m~íñú~tés',
	            h: 'á~ñ hó~úr',
	            hh: '%d h~óúrs',
	            d: 'á ~dáý',
	            dd: '%d d~áýs',
	            M: 'á ~móñ~th',
	            MM: '%d m~óñt~hs',
	            y: 'á ~ýéár',
	            yy: '%d ý~éárs',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return xPseudo;
	
	})));


/***/ },
/* 897 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Yoruba Nigeria [yo]
	//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var yo = moment.defineLocale('yo', {
	        months: 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split(
	            '_'
	        ),
	        monthsShort: 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	        weekdays: 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	        weekdaysShort: 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	        weekdaysMin: 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Ònì ni] LT',
	            nextDay: '[Ọ̀la ni] LT',
	            nextWeek: "dddd [Ọsẹ̀ tón'bọ] [ni] LT",
	            lastDay: '[Àna ni] LT',
	            lastWeek: 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ní %s',
	            past: '%s kọjá',
	            s: 'ìsẹjú aayá die',
	            ss: 'aayá %d',
	            m: 'ìsẹjú kan',
	            mm: 'ìsẹjú %d',
	            h: 'wákati kan',
	            hh: 'wákati %d',
	            d: 'ọjọ́ kan',
	            dd: 'ọjọ́ %d',
	            M: 'osù kan',
	            MM: 'osù %d',
	            y: 'ọdún kan',
	            yy: 'ọdún %d',
	        },
	        dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
	        ordinal: 'ọjọ́ %d',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return yo;
	
	})));


/***/ },
/* 898 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (China) [zh-cn]
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	//! author : uu109 : https://github.com/uu109
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhCn = moment.defineLocale('zh-cn', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日Ah点mm分',
	            LLLL: 'YYYY年M月D日ddddAh点mm分',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            } else {
	                // '中午'
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天]LT',
	            nextDay: '[明天]LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    return '[下]dddLT';
	                } else {
	                    return '[本]dddLT';
	                }
	            },
	            lastDay: '[昨天]LT',
	            lastWeek: function (now) {
	                if (this.week() !== now.week()) {
	                    return '[上]dddLT';
	                } else {
	                    return '[本]dddLT';
	                }
	            },
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '周';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s后',
	            past: '%s前',
	            s: '几秒',
	            ss: '%d 秒',
	            m: '1 分钟',
	            mm: '%d 分钟',
	            h: '1 小时',
	            hh: '%d 小时',
	            d: '1 天',
	            dd: '%d 天',
	            w: '1 周',
	            ww: '%d 周',
	            M: '1 个月',
	            MM: '%d 个月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return zhCn;
	
	})));


/***/ },
/* 899 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Hong Kong) [zh-hk]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Konstantin : https://github.com/skfd
	//! author : Anthony : https://github.com/anthonylau
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhHk = moment.defineLocale('zh-hk', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1200) {
	                return '上午';
	            } else if (hm === 1200) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天]LT',
	            nextDay: '[明天]LT',
	            nextWeek: '[下]ddddLT',
	            lastDay: '[昨天]LT',
	            lastWeek: '[上]ddddLT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhHk;
	
	})));


/***/ },
/* 900 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Macau) [zh-mo]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Tan Yuanhong : https://github.com/le0tan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhMo = moment.defineLocale('zh-mo', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'D/M/YYYY',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天] LT',
	            nextDay: '[明天] LT',
	            nextWeek: '[下]dddd LT',
	            lastDay: '[昨天] LT',
	            lastWeek: '[上]dddd LT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s內',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhMo;
	
	})));


/***/ },
/* 901 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Taiwan) [zh-tw]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhTw = moment.defineLocale('zh-tw', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天] LT',
	            nextDay: '[明天] LT',
	            nextWeek: '[下]dddd LT',
	            lastDay: '[昨天] LT',
	            lastWeek: '[上]dddd LT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhTw;
	
	})));


/***/ },
/* 902 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 903 */
/***/ function(module, exports) {

	'use strict';
	
	var numberIsNaN = function (value) {
		return value !== value;
	};
	
	module.exports = function is(a, b) {
		if (a === 0 && b === 0) {
			return 1 / a === 1 / b;
		}
		if (a === b) {
			return true;
		}
		if (numberIsNaN(a) && numberIsNaN(b)) {
			return true;
		}
		return false;
	};
	


/***/ },
/* 904 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(903);
	
	module.exports = function getPolyfill() {
		return typeof Object.is === 'function' ? Object.is : implementation;
	};


/***/ },
/* 905 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var slice = Array.prototype.slice;
	var isArgs = __webpack_require__(906);
	
	var origKeys = Object.keys;
	var keysShim = origKeys ? function keys(o) { return origKeys(o); } : __webpack_require__(2194);
	
	var originalKeys = Object.keys;
	
	keysShim.shim = function shimObjectKeys() {
		if (Object.keys) {
			var keysWorksWithArguments = (function () {
				// Safari 5.0 bug
				var args = Object.keys(arguments);
				return args && args.length === arguments.length;
			}(1, 2));
			if (!keysWorksWithArguments) {
				Object.keys = function keys(object) { // eslint-disable-line func-name-matching
					if (isArgs(object)) {
						return originalKeys(slice.call(object));
					}
					return originalKeys(object);
				};
			}
		} else {
			Object.keys = keysShim;
		}
		return Object.keys || keysShim;
	};
	
	module.exports = keysShim;


/***/ },
/* 906 */
/***/ function(module, exports) {

	'use strict';
	
	var toStr = Object.prototype.toString;
	
	module.exports = function isArguments(value) {
		var str = toStr.call(value);
		var isArgs = str === '[object Arguments]';
		if (!isArgs) {
			isArgs = str !== '[object Array]' &&
				value !== null &&
				typeof value === 'object' &&
				typeof value.length === 'number' &&
				value.length >= 0 &&
				toStr.call(value.callee) === '[object Function]';
		}
		return isArgs;
	};


/***/ },
/* 907 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**!
	 * @fileOverview Kickass library to create and place poppers near their reference elements.
	 * @version 1.16.1
	 * @license
	 * Copyright (c) 2016 Federico Zivolo and contributors
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all
	 * copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	 * SOFTWARE.
	 */
	(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.Popper = factory());
	}(this, (function () { 'use strict';
	
	var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';
	
	var timeoutDuration = function () {
	  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
	  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
	    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
	      return 1;
	    }
	  }
	  return 0;
	}();
	
	function microtaskDebounce(fn) {
	  var called = false;
	  return function () {
	    if (called) {
	      return;
	    }
	    called = true;
	    window.Promise.resolve().then(function () {
	      called = false;
	      fn();
	    });
	  };
	}
	
	function taskDebounce(fn) {
	  var scheduled = false;
	  return function () {
	    if (!scheduled) {
	      scheduled = true;
	      setTimeout(function () {
	        scheduled = false;
	        fn();
	      }, timeoutDuration);
	    }
	  };
	}
	
	var supportsMicroTasks = isBrowser && window.Promise;
	
	/**
	* Create a debounced version of a method, that's asynchronously deferred
	* but called in the minimum time possible.
	*
	* @method
	* @memberof Popper.Utils
	* @argument {Function} fn
	* @returns {Function}
	*/
	var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;
	
	/**
	 * Check if the given variable is a function
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Any} functionToCheck - variable to check
	 * @returns {Boolean} answer to: is a function?
	 */
	function isFunction(functionToCheck) {
	  var getType = {};
	  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
	}
	
	/**
	 * Get CSS computed property of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Eement} element
	 * @argument {String} property
	 */
	function getStyleComputedProperty(element, property) {
	  if (element.nodeType !== 1) {
	    return [];
	  }
	  // NOTE: 1 DOM access here
	  var window = element.ownerDocument.defaultView;
	  var css = window.getComputedStyle(element, null);
	  return property ? css[property] : css;
	}
	
	/**
	 * Returns the parentNode or the host of the element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} parent
	 */
	function getParentNode(element) {
	  if (element.nodeName === 'HTML') {
	    return element;
	  }
	  return element.parentNode || element.host;
	}
	
	/**
	 * Returns the scrolling parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} scroll parent
	 */
	function getScrollParent(element) {
	  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
	  if (!element) {
	    return document.body;
	  }
	
	  switch (element.nodeName) {
	    case 'HTML':
	    case 'BODY':
	      return element.ownerDocument.body;
	    case '#document':
	      return element.body;
	  }
	
	  // Firefox want us to check `-x` and `-y` variations as well
	
	  var _getStyleComputedProp = getStyleComputedProperty(element),
	      overflow = _getStyleComputedProp.overflow,
	      overflowX = _getStyleComputedProp.overflowX,
	      overflowY = _getStyleComputedProp.overflowY;
	
	  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
	    return element;
	  }
	
	  return getScrollParent(getParentNode(element));
	}
	
	/**
	 * Returns the reference node of the reference object, or the reference object itself.
	 * @method
	 * @memberof Popper.Utils
	 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
	 * @returns {Element} parent
	 */
	function getReferenceNode(reference) {
	  return reference && reference.referenceNode ? reference.referenceNode : reference;
	}
	
	var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
	var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);
	
	/**
	 * Determines if the browser is Internet Explorer
	 * @method
	 * @memberof Popper.Utils
	 * @param {Number} version to check
	 * @returns {Boolean} isIE
	 */
	function isIE(version) {
	  if (version === 11) {
	    return isIE11;
	  }
	  if (version === 10) {
	    return isIE10;
	  }
	  return isIE11 || isIE10;
	}
	
	/**
	 * Returns the offset parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} offset parent
	 */
	function getOffsetParent(element) {
	  if (!element) {
	    return document.documentElement;
	  }
	
	  var noOffsetParent = isIE(10) ? document.body : null;
	
	  // NOTE: 1 DOM access here
	  var offsetParent = element.offsetParent || null;
	  // Skip hidden elements which don't have an offsetParent
	  while (offsetParent === noOffsetParent && element.nextElementSibling) {
	    offsetParent = (element = element.nextElementSibling).offsetParent;
	  }
	
	  var nodeName = offsetParent && offsetParent.nodeName;
	
	  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
	    return element ? element.ownerDocument.documentElement : document.documentElement;
	  }
	
	  // .offsetParent will return the closest TH, TD or TABLE in case
	  // no offsetParent is present, I hate this job...
	  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
	    return getOffsetParent(offsetParent);
	  }
	
	  return offsetParent;
	}
	
	function isOffsetContainer(element) {
	  var nodeName = element.nodeName;
	
	  if (nodeName === 'BODY') {
	    return false;
	  }
	  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
	}
	
	/**
	 * Finds the root node (document, shadowDOM root) of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} node
	 * @returns {Element} root node
	 */
	function getRoot(node) {
	  if (node.parentNode !== null) {
	    return getRoot(node.parentNode);
	  }
	
	  return node;
	}
	
	/**
	 * Finds the offset parent common to the two provided nodes
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element1
	 * @argument {Element} element2
	 * @returns {Element} common offset parent
	 */
	function findCommonOffsetParent(element1, element2) {
	  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
	    return document.documentElement;
	  }
	
	  // Here we make sure to give as "start" the element that comes first in the DOM
	  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
	  var start = order ? element1 : element2;
	  var end = order ? element2 : element1;
	
	  // Get common ancestor container
	  var range = document.createRange();
	  range.setStart(start, 0);
	  range.setEnd(end, 0);
	  var commonAncestorContainer = range.commonAncestorContainer;
	
	  // Both nodes are inside #document
	
	  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
	    if (isOffsetContainer(commonAncestorContainer)) {
	      return commonAncestorContainer;
	    }
	
	    return getOffsetParent(commonAncestorContainer);
	  }
	
	  // one of the nodes is inside shadowDOM, find which one
	  var element1root = getRoot(element1);
	  if (element1root.host) {
	    return findCommonOffsetParent(element1root.host, element2);
	  } else {
	    return findCommonOffsetParent(element1, getRoot(element2).host);
	  }
	}
	
	/**
	 * Gets the scroll value of the given element in the given side (top and left)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {String} side `top` or `left`
	 * @returns {number} amount of scrolled pixels
	 */
	function getScroll(element) {
	  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
	
	  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
	  var nodeName = element.nodeName;
	
	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    var html = element.ownerDocument.documentElement;
	    var scrollingElement = element.ownerDocument.scrollingElement || html;
	    return scrollingElement[upperSide];
	  }
	
	  return element[upperSide];
	}
	
	/*
	 * Sum or subtract the element scroll values (left and top) from a given rect object
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} rect - Rect object you want to change
	 * @param {HTMLElement} element - The element from the function reads the scroll values
	 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
	 * @return {Object} rect - The modifier rect object
	 */
	function includeScroll(rect, element) {
	  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var scrollTop = getScroll(element, 'top');
	  var scrollLeft = getScroll(element, 'left');
	  var modifier = subtract ? -1 : 1;
	  rect.top += scrollTop * modifier;
	  rect.bottom += scrollTop * modifier;
	  rect.left += scrollLeft * modifier;
	  rect.right += scrollLeft * modifier;
	  return rect;
	}
	
	/*
	 * Helper to detect borders of a given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {CSSStyleDeclaration} styles
	 * Result of `getStyleComputedProperty` on the given element
	 * @param {String} axis - `x` or `y`
	 * @return {number} borders - The borders size of the given axis
	 */
	
	function getBordersSize(styles, axis) {
	  var sideA = axis === 'x' ? 'Left' : 'Top';
	  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';
	
	  return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
	}
	
	function getSize(axis, body, html, computedStyle) {
	  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
	}
	
	function getWindowSizes(document) {
	  var body = document.body;
	  var html = document.documentElement;
	  var computedStyle = isIE(10) && getComputedStyle(html);
	
	  return {
	    height: getSize('Height', body, html, computedStyle),
	    width: getSize('Width', body, html, computedStyle)
	  };
	}
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	
	
	
	
	var defineProperty = function (obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	/**
	 * Given element offsets, generate an output similar to getBoundingClientRect
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} offsets
	 * @returns {Object} ClientRect like output
	 */
	function getClientRect(offsets) {
	  return _extends({}, offsets, {
	    right: offsets.left + offsets.width,
	    bottom: offsets.top + offsets.height
	  });
	}
	
	/**
	 * Get bounding client rect of given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} element
	 * @return {Object} client rect
	 */
	function getBoundingClientRect(element) {
	  var rect = {};
	
	  // IE10 10 FIX: Please, don't ask, the element isn't
	  // considered in DOM in some circumstances...
	  // This isn't reproducible in IE10 compatibility mode of IE11
	  try {
	    if (isIE(10)) {
	      rect = element.getBoundingClientRect();
	      var scrollTop = getScroll(element, 'top');
	      var scrollLeft = getScroll(element, 'left');
	      rect.top += scrollTop;
	      rect.left += scrollLeft;
	      rect.bottom += scrollTop;
	      rect.right += scrollLeft;
	    } else {
	      rect = element.getBoundingClientRect();
	    }
	  } catch (e) {}
	
	  var result = {
	    left: rect.left,
	    top: rect.top,
	    width: rect.right - rect.left,
	    height: rect.bottom - rect.top
	  };
	
	  // subtract scrollbar size from sizes
	  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
	  var width = sizes.width || element.clientWidth || result.width;
	  var height = sizes.height || element.clientHeight || result.height;
	
	  var horizScrollbar = element.offsetWidth - width;
	  var vertScrollbar = element.offsetHeight - height;
	
	  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
	  // we make this check conditional for performance reasons
	  if (horizScrollbar || vertScrollbar) {
	    var styles = getStyleComputedProperty(element);
	    horizScrollbar -= getBordersSize(styles, 'x');
	    vertScrollbar -= getBordersSize(styles, 'y');
	
	    result.width -= horizScrollbar;
	    result.height -= vertScrollbar;
	  }
	
	  return getClientRect(result);
	}
	
	function getOffsetRectRelativeToArbitraryNode(children, parent) {
	  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var isIE10 = isIE(10);
	  var isHTML = parent.nodeName === 'HTML';
	  var childrenRect = getBoundingClientRect(children);
	  var parentRect = getBoundingClientRect(parent);
	  var scrollParent = getScrollParent(children);
	
	  var styles = getStyleComputedProperty(parent);
	  var borderTopWidth = parseFloat(styles.borderTopWidth);
	  var borderLeftWidth = parseFloat(styles.borderLeftWidth);
	
	  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
	  if (fixedPosition && isHTML) {
	    parentRect.top = Math.max(parentRect.top, 0);
	    parentRect.left = Math.max(parentRect.left, 0);
	  }
	  var offsets = getClientRect({
	    top: childrenRect.top - parentRect.top - borderTopWidth,
	    left: childrenRect.left - parentRect.left - borderLeftWidth,
	    width: childrenRect.width,
	    height: childrenRect.height
	  });
	  offsets.marginTop = 0;
	  offsets.marginLeft = 0;
	
	  // Subtract margins of documentElement in case it's being used as parent
	  // we do this only on HTML because it's the only element that behaves
	  // differently when margins are applied to it. The margins are included in
	  // the box of the documentElement, in the other cases not.
	  if (!isIE10 && isHTML) {
	    var marginTop = parseFloat(styles.marginTop);
	    var marginLeft = parseFloat(styles.marginLeft);
	
	    offsets.top -= borderTopWidth - marginTop;
	    offsets.bottom -= borderTopWidth - marginTop;
	    offsets.left -= borderLeftWidth - marginLeft;
	    offsets.right -= borderLeftWidth - marginLeft;
	
	    // Attach marginTop and marginLeft because in some circumstances we may need them
	    offsets.marginTop = marginTop;
	    offsets.marginLeft = marginLeft;
	  }
	
	  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
	    offsets = includeScroll(offsets, parent);
	  }
	
	  return offsets;
	}
	
	function getViewportOffsetRectRelativeToArtbitraryNode(element) {
	  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var html = element.ownerDocument.documentElement;
	  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
	  var width = Math.max(html.clientWidth, window.innerWidth || 0);
	  var height = Math.max(html.clientHeight, window.innerHeight || 0);
	
	  var scrollTop = !excludeScroll ? getScroll(html) : 0;
	  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;
	
	  var offset = {
	    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
	    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
	    width: width,
	    height: height
	  };
	
	  return getClientRect(offset);
	}
	
	/**
	 * Check if the given element is fixed or is inside a fixed parent
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {Element} customContainer
	 * @returns {Boolean} answer to "isFixed?"
	 */
	function isFixed(element) {
	  var nodeName = element.nodeName;
	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    return false;
	  }
	  if (getStyleComputedProperty(element, 'position') === 'fixed') {
	    return true;
	  }
	  var parentNode = getParentNode(element);
	  if (!parentNode) {
	    return false;
	  }
	  return isFixed(parentNode);
	}
	
	/**
	 * Finds the first parent of an element that has a transformed property defined
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} first transformed parent or documentElement
	 */
	
	function getFixedPositionOffsetParent(element) {
	  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	  if (!element || !element.parentElement || isIE()) {
	    return document.documentElement;
	  }
	  var el = element.parentElement;
	  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
	    el = el.parentElement;
	  }
	  return el || document.documentElement;
	}
	
	/**
	 * Computed the boundaries limits and return them
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} popper
	 * @param {HTMLElement} reference
	 * @param {number} padding
	 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
	 * @param {Boolean} fixedPosition - Is in fixed position mode
	 * @returns {Object} Coordinates of the boundaries
	 */
	function getBoundaries(popper, reference, padding, boundariesElement) {
	  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	
	  // NOTE: 1 DOM access here
	
	  var boundaries = { top: 0, left: 0 };
	  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
	
	  // Handle viewport case
	  if (boundariesElement === 'viewport') {
	    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
	  } else {
	    // Handle other cases based on DOM element used as boundaries
	    var boundariesNode = void 0;
	    if (boundariesElement === 'scrollParent') {
	      boundariesNode = getScrollParent(getParentNode(reference));
	      if (boundariesNode.nodeName === 'BODY') {
	        boundariesNode = popper.ownerDocument.documentElement;
	      }
	    } else if (boundariesElement === 'window') {
	      boundariesNode = popper.ownerDocument.documentElement;
	    } else {
	      boundariesNode = boundariesElement;
	    }
	
	    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);
	
	    // In case of HTML, we need a different computation
	    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
	      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
	          height = _getWindowSizes.height,
	          width = _getWindowSizes.width;
	
	      boundaries.top += offsets.top - offsets.marginTop;
	      boundaries.bottom = height + offsets.top;
	      boundaries.left += offsets.left - offsets.marginLeft;
	      boundaries.right = width + offsets.left;
	    } else {
	      // for all the other DOM elements, this one is good
	      boundaries = offsets;
	    }
	  }
	
	  // Add paddings
	  padding = padding || 0;
	  var isPaddingNumber = typeof padding === 'number';
	  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
	  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
	  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
	  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
	
	  return boundaries;
	}
	
	function getArea(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return width * height;
	}
	
	/**
	 * Utility used to transform the `auto` placement to the placement with more
	 * available space.
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
	  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
	
	  if (placement.indexOf('auto') === -1) {
	    return placement;
	  }
	
	  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);
	
	  var rects = {
	    top: {
	      width: boundaries.width,
	      height: refRect.top - boundaries.top
	    },
	    right: {
	      width: boundaries.right - refRect.right,
	      height: boundaries.height
	    },
	    bottom: {
	      width: boundaries.width,
	      height: boundaries.bottom - refRect.bottom
	    },
	    left: {
	      width: refRect.left - boundaries.left,
	      height: boundaries.height
	    }
	  };
	
	  var sortedAreas = Object.keys(rects).map(function (key) {
	    return _extends({
	      key: key
	    }, rects[key], {
	      area: getArea(rects[key])
	    });
	  }).sort(function (a, b) {
	    return b.area - a.area;
	  });
	
	  var filteredAreas = sortedAreas.filter(function (_ref2) {
	    var width = _ref2.width,
	        height = _ref2.height;
	    return width >= popper.clientWidth && height >= popper.clientHeight;
	  });
	
	  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
	
	  var variation = placement.split('-')[1];
	
	  return computedPlacement + (variation ? '-' + variation : '');
	}
	
	/**
	 * Get offsets to the reference element
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} state
	 * @param {Element} popper - the popper element
	 * @param {Element} reference - the reference element (the popper will be relative to this)
	 * @param {Element} fixedPosition - is in fixed position mode
	 * @returns {Object} An object containing the offsets which will be applied to the popper
	 */
	function getReferenceOffsets(state, popper, reference) {
	  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
	  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
	}
	
	/**
	 * Get the outer sizes of the given element (offset size + margins)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Object} object containing width and height properties
	 */
	function getOuterSizes(element) {
	  var window = element.ownerDocument.defaultView;
	  var styles = window.getComputedStyle(element);
	  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
	  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
	  var result = {
	    width: element.offsetWidth + y,
	    height: element.offsetHeight + x
	  };
	  return result;
	}
	
	/**
	 * Get the opposite placement of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement
	 * @returns {String} flipped placement
	 */
	function getOppositePlacement(placement) {
	  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
	  return placement.replace(/left|right|bottom|top/g, function (matched) {
	    return hash[matched];
	  });
	}
	
	/**
	 * Get offsets to the popper
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} position - CSS position the Popper will get applied
	 * @param {HTMLElement} popper - the popper element
	 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
	 * @param {String} placement - one of the valid placement options
	 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
	 */
	function getPopperOffsets(popper, referenceOffsets, placement) {
	  placement = placement.split('-')[0];
	
	  // Get popper node sizes
	  var popperRect = getOuterSizes(popper);
	
	  // Add position, width and height to our offsets object
	  var popperOffsets = {
	    width: popperRect.width,
	    height: popperRect.height
	  };
	
	  // depending by the popper placement we have to compute its offsets slightly differently
	  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
	  var mainSide = isHoriz ? 'top' : 'left';
	  var secondarySide = isHoriz ? 'left' : 'top';
	  var measurement = isHoriz ? 'height' : 'width';
	  var secondaryMeasurement = !isHoriz ? 'height' : 'width';
	
	  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
	  if (placement === secondarySide) {
	    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
	  } else {
	    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
	  }
	
	  return popperOffsets;
	}
	
	/**
	 * Mimics the `find` method of Array
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function find(arr, check) {
	  // use native find if supported
	  if (Array.prototype.find) {
	    return arr.find(check);
	  }
	
	  // use `filter` to obtain the same behavior of `find`
	  return arr.filter(check)[0];
	}
	
	/**
	 * Return the index of the matching object
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function findIndex(arr, prop, value) {
	  // use native findIndex if supported
	  if (Array.prototype.findIndex) {
	    return arr.findIndex(function (cur) {
	      return cur[prop] === value;
	    });
	  }
	
	  // use `find` + `indexOf` if `findIndex` isn't supported
	  var match = find(arr, function (obj) {
	    return obj[prop] === value;
	  });
	  return arr.indexOf(match);
	}
	
	/**
	 * Loop trough the list of modifiers and run them in order,
	 * each of them will then edit the data object.
	 * @method
	 * @memberof Popper.Utils
	 * @param {dataObject} data
	 * @param {Array} modifiers
	 * @param {String} ends - Optional modifier name used as stopper
	 * @returns {dataObject}
	 */
	function runModifiers(modifiers, data, ends) {
	  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));
	
	  modifiersToRun.forEach(function (modifier) {
	    if (modifier['function']) {
	      // eslint-disable-line dot-notation
	      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
	    }
	    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
	    if (modifier.enabled && isFunction(fn)) {
	      // Add properties to offsets to make them a complete clientRect object
	      // we do this before each modifier to make sure the previous one doesn't
	      // mess with these values
	      data.offsets.popper = getClientRect(data.offsets.popper);
	      data.offsets.reference = getClientRect(data.offsets.reference);
	
	      data = fn(data, modifier);
	    }
	  });
	
	  return data;
	}
	
	/**
	 * Updates the position of the popper, computing the new offsets and applying
	 * the new style.<br />
	 * Prefer `scheduleUpdate` over `update` because of performance reasons.
	 * @method
	 * @memberof Popper
	 */
	function update() {
	  // if popper is destroyed, don't perform any further update
	  if (this.state.isDestroyed) {
	    return;
	  }
	
	  var data = {
	    instance: this,
	    styles: {},
	    arrowStyles: {},
	    attributes: {},
	    flipped: false,
	    offsets: {}
	  };
	
	  // compute reference element offsets
	  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);
	
	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);
	
	  // store the computed placement inside `originalPlacement`
	  data.originalPlacement = data.placement;
	
	  data.positionFixed = this.options.positionFixed;
	
	  // compute the popper offsets
	  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);
	
	  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';
	
	  // run the modifiers
	  data = runModifiers(this.modifiers, data);
	
	  // the first `update` will call `onCreate` callback
	  // the other ones will call `onUpdate` callback
	  if (!this.state.isCreated) {
	    this.state.isCreated = true;
	    this.options.onCreate(data);
	  } else {
	    this.options.onUpdate(data);
	  }
	}
	
	/**
	 * Helper used to know if the given modifier is enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @returns {Boolean}
	 */
	function isModifierEnabled(modifiers, modifierName) {
	  return modifiers.some(function (_ref) {
	    var name = _ref.name,
	        enabled = _ref.enabled;
	    return enabled && name === modifierName;
	  });
	}
	
	/**
	 * Get the prefixed supported property name
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} property (camelCase)
	 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
	 */
	function getSupportedPropertyName(property) {
	  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
	  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
	
	  for (var i = 0; i < prefixes.length; i++) {
	    var prefix = prefixes[i];
	    var toCheck = prefix ? '' + prefix + upperProp : property;
	    if (typeof document.body.style[toCheck] !== 'undefined') {
	      return toCheck;
	    }
	  }
	  return null;
	}
	
	/**
	 * Destroys the popper.
	 * @method
	 * @memberof Popper
	 */
	function destroy() {
	  this.state.isDestroyed = true;
	
	  // touch DOM only if `applyStyle` modifier is enabled
	  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
	    this.popper.removeAttribute('x-placement');
	    this.popper.style.position = '';
	    this.popper.style.top = '';
	    this.popper.style.left = '';
	    this.popper.style.right = '';
	    this.popper.style.bottom = '';
	    this.popper.style.willChange = '';
	    this.popper.style[getSupportedPropertyName('transform')] = '';
	  }
	
	  this.disableEventListeners();
	
	  // remove the popper if user explicitly asked for the deletion on destroy
	  // do not use `remove` because IE11 doesn't support it
	  if (this.options.removeOnDestroy) {
	    this.popper.parentNode.removeChild(this.popper);
	  }
	  return this;
	}
	
	/**
	 * Get the window associated with the element
	 * @argument {Element} element
	 * @returns {Window}
	 */
	function getWindow(element) {
	  var ownerDocument = element.ownerDocument;
	  return ownerDocument ? ownerDocument.defaultView : window;
	}
	
	function attachToScrollParents(scrollParent, event, callback, scrollParents) {
	  var isBody = scrollParent.nodeName === 'BODY';
	  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
	  target.addEventListener(event, callback, { passive: true });
	
	  if (!isBody) {
	    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
	  }
	  scrollParents.push(target);
	}
	
	/**
	 * Setup needed event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function setupEventListeners(reference, options, state, updateBound) {
	  // Resize event listener on window
	  state.updateBound = updateBound;
	  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });
	
	  // Scroll event listener on scroll parents
	  var scrollElement = getScrollParent(reference);
	  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
	  state.scrollElement = scrollElement;
	  state.eventsEnabled = true;
	
	  return state;
	}
	
	/**
	 * It will add resize/scroll events and start recalculating
	 * position of the popper element when they are triggered.
	 * @method
	 * @memberof Popper
	 */
	function enableEventListeners() {
	  if (!this.state.eventsEnabled) {
	    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
	  }
	}
	
	/**
	 * Remove event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function removeEventListeners(reference, state) {
	  // Remove resize event listener on window
	  getWindow(reference).removeEventListener('resize', state.updateBound);
	
	  // Remove scroll event listener on scroll parents
	  state.scrollParents.forEach(function (target) {
	    target.removeEventListener('scroll', state.updateBound);
	  });
	
	  // Reset state
	  state.updateBound = null;
	  state.scrollParents = [];
	  state.scrollElement = null;
	  state.eventsEnabled = false;
	  return state;
	}
	
	/**
	 * It will remove resize/scroll events and won't recalculate popper position
	 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
	 * unless you call `update` method manually.
	 * @method
	 * @memberof Popper
	 */
	function disableEventListeners() {
	  if (this.state.eventsEnabled) {
	    cancelAnimationFrame(this.scheduleUpdate);
	    this.state = removeEventListeners(this.reference, this.state);
	  }
	}
	
	/**
	 * Tells if a given input is a number
	 * @method
	 * @memberof Popper.Utils
	 * @param {*} input to check
	 * @return {Boolean}
	 */
	function isNumeric(n) {
	  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
	}
	
	/**
	 * Set the style to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the style to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setStyles(element, styles) {
	  Object.keys(styles).forEach(function (prop) {
	    var unit = '';
	    // add unit if the value is numeric and is one of the following
	    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
	      unit = 'px';
	    }
	    element.style[prop] = styles[prop] + unit;
	  });
	}
	
	/**
	 * Set the attributes to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the attributes to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setAttributes(element, attributes) {
	  Object.keys(attributes).forEach(function (prop) {
	    var value = attributes[prop];
	    if (value !== false) {
	      element.setAttribute(prop, attributes[prop]);
	    } else {
	      element.removeAttribute(prop);
	    }
	  });
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} data.styles - List of style properties - values to apply to popper element
	 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The same data object
	 */
	function applyStyle(data) {
	  // any property present in `data.styles` will be applied to the popper,
	  // in this way we can make the 3rd party modifiers add custom styles to it
	  // Be aware, modifiers could override the properties defined in the previous
	  // lines of this modifier!
	  setStyles(data.instance.popper, data.styles);
	
	  // any property present in `data.attributes` will be applied to the popper,
	  // they will be set as HTML attributes of the element
	  setAttributes(data.instance.popper, data.attributes);
	
	  // if arrowElement is defined and arrowStyles has some properties
	  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
	    setStyles(data.arrowElement, data.arrowStyles);
	  }
	
	  return data;
	}
	
	/**
	 * Set the x-placement attribute before everything else because it could be used
	 * to add margins to the popper margins needs to be calculated to get the
	 * correct popper offsets.
	 * @method
	 * @memberof Popper.modifiers
	 * @param {HTMLElement} reference - The reference element used to position the popper
	 * @param {HTMLElement} popper - The HTML element used as popper
	 * @param {Object} options - Popper.js options
	 */
	function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
	  // compute reference element offsets
	  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);
	
	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
	
	  popper.setAttribute('x-placement', placement);
	
	  // Apply `position` to popper before anything else because
	  // without the position applied we can't guarantee correct computations
	  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });
	
	  return options;
	}
	
	/**
	 * @function
	 * @memberof Popper.Utils
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
	 * @returns {Object} The popper's position offsets rounded
	 *
	 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
	 * good as it can be within reason.
	 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
	 *
	 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
	 * as well on High DPI screens).
	 *
	 * Firefox prefers no rounding for positioning and does not have blurriness on
	 * high DPI screens.
	 *
	 * Only horizontal placement and left/right values need to be considered.
	 */
	function getRoundedOffsets(data, shouldRound) {
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	  var round = Math.round,
	      floor = Math.floor;
	
	  var noRound = function noRound(v) {
	    return v;
	  };
	
	  var referenceWidth = round(reference.width);
	  var popperWidth = round(popper.width);
	
	  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
	  var isVariation = data.placement.indexOf('-') !== -1;
	  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
	  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;
	
	  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
	  var verticalToInteger = !shouldRound ? noRound : round;
	
	  return {
	    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
	    top: verticalToInteger(popper.top),
	    bottom: verticalToInteger(popper.bottom),
	    right: horizontalToInteger(popper.right)
	  };
	}
	
	var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeStyle(data, options) {
	  var x = options.x,
	      y = options.y;
	  var popper = data.offsets.popper;
	
	  // Remove this legacy support in Popper.js v2
	
	  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'applyStyle';
	  }).gpuAcceleration;
	  if (legacyGpuAccelerationOption !== undefined) {
	    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
	  }
	  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
	
	  var offsetParent = getOffsetParent(data.instance.popper);
	  var offsetParentRect = getBoundingClientRect(offsetParent);
	
	  // Styles
	  var styles = {
	    position: popper.position
	  };
	
	  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);
	
	  var sideA = x === 'bottom' ? 'top' : 'bottom';
	  var sideB = y === 'right' ? 'left' : 'right';
	
	  // if gpuAcceleration is set to `true` and transform is supported,
	  //  we use `translate3d` to apply the position to the popper we
	  // automatically use the supported prefixed version if needed
	  var prefixedProperty = getSupportedPropertyName('transform');
	
	  // now, let's make a step back and look at this code closely (wtf?)
	  // If the content of the popper grows once it's been positioned, it
	  // may happen that the popper gets misplaced because of the new content
	  // overflowing its reference element
	  // To avoid this problem, we provide two options (x and y), which allow
	  // the consumer to define the offset origin.
	  // If we position a popper on top of a reference element, we can set
	  // `x` to `top` to make the popper grow towards its top instead of
	  // its bottom.
	  var left = void 0,
	      top = void 0;
	  if (sideA === 'bottom') {
	    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
	    // and not the bottom of the html element
	    if (offsetParent.nodeName === 'HTML') {
	      top = -offsetParent.clientHeight + offsets.bottom;
	    } else {
	      top = -offsetParentRect.height + offsets.bottom;
	    }
	  } else {
	    top = offsets.top;
	  }
	  if (sideB === 'right') {
	    if (offsetParent.nodeName === 'HTML') {
	      left = -offsetParent.clientWidth + offsets.right;
	    } else {
	      left = -offsetParentRect.width + offsets.right;
	    }
	  } else {
	    left = offsets.left;
	  }
	  if (gpuAcceleration && prefixedProperty) {
	    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
	    styles[sideA] = 0;
	    styles[sideB] = 0;
	    styles.willChange = 'transform';
	  } else {
	    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
	    var invertTop = sideA === 'bottom' ? -1 : 1;
	    var invertLeft = sideB === 'right' ? -1 : 1;
	    styles[sideA] = top * invertTop;
	    styles[sideB] = left * invertLeft;
	    styles.willChange = sideA + ', ' + sideB;
	  }
	
	  // Attributes
	  var attributes = {
	    'x-placement': data.placement
	  };
	
	  // Update `data` attributes, styles and arrowStyles
	  data.attributes = _extends({}, attributes, data.attributes);
	  data.styles = _extends({}, styles, data.styles);
	  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);
	
	  return data;
	}
	
	/**
	 * Helper used to know if the given modifier depends from another one.<br />
	 * It checks if the needed modifier is listed and enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @param {Array} modifiers - list of modifiers
	 * @param {String} requestingName - name of requesting modifier
	 * @param {String} requestedName - name of requested modifier
	 * @returns {Boolean}
	 */
	function isModifierRequired(modifiers, requestingName, requestedName) {
	  var requesting = find(modifiers, function (_ref) {
	    var name = _ref.name;
	    return name === requestingName;
	  });
	
	  var isRequired = !!requesting && modifiers.some(function (modifier) {
	    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
	  });
	
	  if (!isRequired) {
	    var _requesting = '`' + requestingName + '`';
	    var requested = '`' + requestedName + '`';
	    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
	  }
	  return isRequired;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function arrow(data, options) {
	  var _data$offsets$arrow;
	
	  // arrow depends on keepTogether in order to work
	  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
	    return data;
	  }
	
	  var arrowElement = options.element;
	
	  // if arrowElement is a string, suppose it's a CSS selector
	  if (typeof arrowElement === 'string') {
	    arrowElement = data.instance.popper.querySelector(arrowElement);
	
	    // if arrowElement is not found, don't run the modifier
	    if (!arrowElement) {
	      return data;
	    }
	  } else {
	    // if the arrowElement isn't a query selector we must check that the
	    // provided DOM node is child of its popper node
	    if (!data.instance.popper.contains(arrowElement)) {
	      console.warn('WARNING: `arrow.element` must be child of its popper element!');
	      return data;
	    }
	  }
	
	  var placement = data.placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var isVertical = ['left', 'right'].indexOf(placement) !== -1;
	
	  var len = isVertical ? 'height' : 'width';
	  var sideCapitalized = isVertical ? 'Top' : 'Left';
	  var side = sideCapitalized.toLowerCase();
	  var altSide = isVertical ? 'left' : 'top';
	  var opSide = isVertical ? 'bottom' : 'right';
	  var arrowElementSize = getOuterSizes(arrowElement)[len];
	
	  //
	  // extends keepTogether behavior making sure the popper and its
	  // reference have enough pixels in conjunction
	  //
	
	  // top/left side
	  if (reference[opSide] - arrowElementSize < popper[side]) {
	    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
	  }
	  // bottom/right side
	  if (reference[side] + arrowElementSize > popper[opSide]) {
	    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
	  }
	  data.offsets.popper = getClientRect(data.offsets.popper);
	
	  // compute center of the popper
	  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;
	
	  // Compute the sideValue using the updated popper offsets
	  // take popper margin in account because we don't have this info available
	  var css = getStyleComputedProperty(data.instance.popper);
	  var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
	  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
	  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;
	
	  // prevent arrowElement from being placed not contiguously to its popper
	  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
	
	  data.arrowElement = arrowElement;
	  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);
	
	  return data;
	}
	
	/**
	 * Get the opposite placement variation of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement variation
	 * @returns {String} flipped placement variation
	 */
	function getOppositeVariation(variation) {
	  if (variation === 'end') {
	    return 'start';
	  } else if (variation === 'start') {
	    return 'end';
	  }
	  return variation;
	}
	
	/**
	 * List of accepted placements to use as values of the `placement` option.<br />
	 * Valid placements are:
	 * - `auto`
	 * - `top`
	 * - `right`
	 * - `bottom`
	 * - `left`
	 *
	 * Each placement can have a variation from this list:
	 * - `-start`
	 * - `-end`
	 *
	 * Variations are interpreted easily if you think of them as the left to right
	 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
	 * is right.<br />
	 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
	 *
	 * Some valid examples are:
	 * - `top-end` (on top of reference, right aligned)
	 * - `right-start` (on right of reference, top aligned)
	 * - `bottom` (on bottom, centered)
	 * - `auto-end` (on the side with more space available, alignment depends by placement)
	 *
	 * @static
	 * @type {Array}
	 * @enum {String}
	 * @readonly
	 * @method placements
	 * @memberof Popper
	 */
	var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];
	
	// Get rid of `auto` `auto-start` and `auto-end`
	var validPlacements = placements.slice(3);
	
	/**
	 * Given an initial placement, returns all the subsequent placements
	 * clockwise (or counter-clockwise).
	 *
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement - A valid placement (it accepts variations)
	 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
	 * @returns {Array} placements including their variations
	 */
	function clockwise(placement) {
	  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var index = validPlacements.indexOf(placement);
	  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
	  return counter ? arr.reverse() : arr;
	}
	
	var BEHAVIORS = {
	  FLIP: 'flip',
	  CLOCKWISE: 'clockwise',
	  COUNTERCLOCKWISE: 'counterclockwise'
	};
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function flip(data, options) {
	  // if `inner` modifier is enabled, we can't use the `flip` modifier
	  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
	    return data;
	  }
	
	  if (data.flipped && data.placement === data.originalPlacement) {
	    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
	    return data;
	  }
	
	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
	
	  var placement = data.placement.split('-')[0];
	  var placementOpposite = getOppositePlacement(placement);
	  var variation = data.placement.split('-')[1] || '';
	
	  var flipOrder = [];
	
	  switch (options.behavior) {
	    case BEHAVIORS.FLIP:
	      flipOrder = [placement, placementOpposite];
	      break;
	    case BEHAVIORS.CLOCKWISE:
	      flipOrder = clockwise(placement);
	      break;
	    case BEHAVIORS.COUNTERCLOCKWISE:
	      flipOrder = clockwise(placement, true);
	      break;
	    default:
	      flipOrder = options.behavior;
	  }
	
	  flipOrder.forEach(function (step, index) {
	    if (placement !== step || flipOrder.length === index + 1) {
	      return data;
	    }
	
	    placement = data.placement.split('-')[0];
	    placementOpposite = getOppositePlacement(placement);
	
	    var popperOffsets = data.offsets.popper;
	    var refOffsets = data.offsets.reference;
	
	    // using floor because the reference offsets may contain decimals we are not going to consider here
	    var floor = Math.floor;
	    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);
	
	    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
	    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
	    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
	    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
	
	    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;
	
	    // flip the variation if required
	    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	
	    // flips variation if reference element overflows boundaries
	    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);
	
	    // flips variation if popper content overflows boundaries
	    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);
	
	    var flippedVariation = flippedVariationByRef || flippedVariationByContent;
	
	    if (overlapsRef || overflowsBoundaries || flippedVariation) {
	      // this boolean to detect any flip loop
	      data.flipped = true;
	
	      if (overlapsRef || overflowsBoundaries) {
	        placement = flipOrder[index + 1];
	      }
	
	      if (flippedVariation) {
	        variation = getOppositeVariation(variation);
	      }
	
	      data.placement = placement + (variation ? '-' + variation : '');
	
	      // this object contains `position`, we want to preserve it along with
	      // any additional property we may add in the future
	      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
	
	      data = runModifiers(data.instance.modifiers, data, 'flip');
	    }
	  });
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function keepTogether(data) {
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var placement = data.placement.split('-')[0];
	  var floor = Math.floor;
	  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	  var side = isVertical ? 'right' : 'bottom';
	  var opSide = isVertical ? 'left' : 'top';
	  var measurement = isVertical ? 'width' : 'height';
	
	  if (popper[side] < floor(reference[opSide])) {
	    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
	  }
	  if (popper[opSide] > floor(reference[side])) {
	    data.offsets.popper[opSide] = floor(reference[side]);
	  }
	
	  return data;
	}
	
	/**
	 * Converts a string containing value + unit into a px value number
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} str - Value + unit string
	 * @argument {String} measurement - `height` or `width`
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @returns {Number|String}
	 * Value in pixels, or original string if no values were extracted
	 */
	function toValue(str, measurement, popperOffsets, referenceOffsets) {
	  // separate value from unit
	  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
	  var value = +split[1];
	  var unit = split[2];
	
	  // If it's not a number it's an operator, I guess
	  if (!value) {
	    return str;
	  }
	
	  if (unit.indexOf('%') === 0) {
	    var element = void 0;
	    switch (unit) {
	      case '%p':
	        element = popperOffsets;
	        break;
	      case '%':
	      case '%r':
	      default:
	        element = referenceOffsets;
	    }
	
	    var rect = getClientRect(element);
	    return rect[measurement] / 100 * value;
	  } else if (unit === 'vh' || unit === 'vw') {
	    // if is a vh or vw, we calculate the size based on the viewport
	    var size = void 0;
	    if (unit === 'vh') {
	      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
	    } else {
	      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
	    }
	    return size / 100 * value;
	  } else {
	    // if is an explicit pixel unit, we get rid of the unit and keep the value
	    // if is an implicit unit, it's px, and we return just the value
	    return value;
	  }
	}
	
	/**
	 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} offset
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @argument {String} basePlacement
	 * @returns {Array} a two cells array with x and y offsets in numbers
	 */
	function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
	  var offsets = [0, 0];
	
	  // Use height if placement is left or right and index is 0 otherwise use width
	  // in this way the first offset will use an axis and the second one
	  // will use the other one
	  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;
	
	  // Split the offset string to obtain a list of values and operands
	  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
	  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
	    return frag.trim();
	  });
	
	  // Detect if the offset string contains a pair of values or a single one
	  // they could be separated by comma or space
	  var divider = fragments.indexOf(find(fragments, function (frag) {
	    return frag.search(/,|\s/) !== -1;
	  }));
	
	  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
	    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
	  }
	
	  // If divider is found, we divide the list of values and operands to divide
	  // them by ofset X and Y.
	  var splitRegex = /\s*,\s*|\s+/;
	  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];
	
	  // Convert the values with units to absolute pixels to allow our computations
	  ops = ops.map(function (op, index) {
	    // Most of the units rely on the orientation of the popper
	    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
	    var mergeWithPrevious = false;
	    return op
	    // This aggregates any `+` or `-` sign that aren't considered operators
	    // e.g.: 10 + +5 => [10, +, +5]
	    .reduce(function (a, b) {
	      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
	        a[a.length - 1] = b;
	        mergeWithPrevious = true;
	        return a;
	      } else if (mergeWithPrevious) {
	        a[a.length - 1] += b;
	        mergeWithPrevious = false;
	        return a;
	      } else {
	        return a.concat(b);
	      }
	    }, [])
	    // Here we convert the string values into number values (in px)
	    .map(function (str) {
	      return toValue(str, measurement, popperOffsets, referenceOffsets);
	    });
	  });
	
	  // Loop trough the offsets arrays and execute the operations
	  ops.forEach(function (op, index) {
	    op.forEach(function (frag, index2) {
	      if (isNumeric(frag)) {
	        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
	      }
	    });
	  });
	  return offsets;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @argument {Number|String} options.offset=0
	 * The offset value as described in the modifier description
	 * @returns {Object} The data object, properly modified
	 */
	function offset(data, _ref) {
	  var offset = _ref.offset;
	  var placement = data.placement,
	      _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var basePlacement = placement.split('-')[0];
	
	  var offsets = void 0;
	  if (isNumeric(+offset)) {
	    offsets = [+offset, 0];
	  } else {
	    offsets = parseOffset(offset, popper, reference, basePlacement);
	  }
	
	  if (basePlacement === 'left') {
	    popper.top += offsets[0];
	    popper.left -= offsets[1];
	  } else if (basePlacement === 'right') {
	    popper.top += offsets[0];
	    popper.left += offsets[1];
	  } else if (basePlacement === 'top') {
	    popper.left += offsets[0];
	    popper.top -= offsets[1];
	  } else if (basePlacement === 'bottom') {
	    popper.left += offsets[0];
	    popper.top += offsets[1];
	  }
	
	  data.popper = popper;
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function preventOverflow(data, options) {
	  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);
	
	  // If offsetParent is the reference element, we really want to
	  // go one step up and use the next offsetParent as reference to
	  // avoid to make this modifier completely useless and look like broken
	  if (data.instance.reference === boundariesElement) {
	    boundariesElement = getOffsetParent(boundariesElement);
	  }
	
	  // NOTE: DOM access here
	  // resets the popper's position so that the document size can be calculated excluding
	  // the size of the popper element itself
	  var transformProp = getSupportedPropertyName('transform');
	  var popperStyles = data.instance.popper.style; // assignment to help minification
	  var top = popperStyles.top,
	      left = popperStyles.left,
	      transform = popperStyles[transformProp];
	
	  popperStyles.top = '';
	  popperStyles.left = '';
	  popperStyles[transformProp] = '';
	
	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);
	
	  // NOTE: DOM access here
	  // restores the original style properties after the offsets have been computed
	  popperStyles.top = top;
	  popperStyles.left = left;
	  popperStyles[transformProp] = transform;
	
	  options.boundaries = boundaries;
	
	  var order = options.priority;
	  var popper = data.offsets.popper;
	
	  var check = {
	    primary: function primary(placement) {
	      var value = popper[placement];
	      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
	        value = Math.max(popper[placement], boundaries[placement]);
	      }
	      return defineProperty({}, placement, value);
	    },
	    secondary: function secondary(placement) {
	      var mainSide = placement === 'right' ? 'left' : 'top';
	      var value = popper[mainSide];
	      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
	        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
	      }
	      return defineProperty({}, mainSide, value);
	    }
	  };
	
	  order.forEach(function (placement) {
	    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
	    popper = _extends({}, popper, check[side](placement));
	  });
	
	  data.offsets.popper = popper;
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function shift(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var shiftvariation = placement.split('-')[1];
	
	  // if shift shiftvariation is specified, run the modifier
	  if (shiftvariation) {
	    var _data$offsets = data.offsets,
	        reference = _data$offsets.reference,
	        popper = _data$offsets.popper;
	
	    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
	    var side = isVertical ? 'left' : 'top';
	    var measurement = isVertical ? 'width' : 'height';
	
	    var shiftOffsets = {
	      start: defineProperty({}, side, reference[side]),
	      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
	    };
	
	    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
	  }
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function hide(data) {
	  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
	    return data;
	  }
	
	  var refRect = data.offsets.reference;
	  var bound = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'preventOverflow';
	  }).boundaries;
	
	  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === true) {
	      return data;
	    }
	
	    data.hide = true;
	    data.attributes['x-out-of-boundaries'] = '';
	  } else {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === false) {
	      return data;
	    }
	
	    data.hide = false;
	    data.attributes['x-out-of-boundaries'] = false;
	  }
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function inner(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;
	
	  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;
	
	  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);
	
	  data.placement = getOppositePlacement(placement);
	  data.offsets.popper = getClientRect(popper);
	
	  return data;
	}
	
	/**
	 * Modifier function, each modifier can have a function of this type assigned
	 * to its `fn` property.<br />
	 * These functions will be called on each update, this means that you must
	 * make sure they are performant enough to avoid performance bottlenecks.
	 *
	 * @function ModifierFn
	 * @argument {dataObject} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {dataObject} The data object, properly modified
	 */
	
	/**
	 * Modifiers are plugins used to alter the behavior of your poppers.<br />
	 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
	 * needed by the library.
	 *
	 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
	 * All the other properties are configurations that could be tweaked.
	 * @namespace modifiers
	 */
	var modifiers = {
	  /**
	   * Modifier used to shift the popper on the start or end of its reference
	   * element.<br />
	   * It will read the variation of the `placement` property.<br />
	   * It can be one either `-end` or `-start`.
	   * @memberof modifiers
	   * @inner
	   */
	  shift: {
	    /** @prop {number} order=100 - Index used to define the order of execution */
	    order: 100,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: shift
	  },
	
	  /**
	   * The `offset` modifier can shift your popper on both its axis.
	   *
	   * It accepts the following units:
	   * - `px` or unit-less, interpreted as pixels
	   * - `%` or `%r`, percentage relative to the length of the reference element
	   * - `%p`, percentage relative to the length of the popper element
	   * - `vw`, CSS viewport width unit
	   * - `vh`, CSS viewport height unit
	   *
	   * For length is intended the main axis relative to the placement of the popper.<br />
	   * This means that if the placement is `top` or `bottom`, the length will be the
	   * `width`. In case of `left` or `right`, it will be the `height`.
	   *
	   * You can provide a single value (as `Number` or `String`), or a pair of values
	   * as `String` divided by a comma or one (or more) white spaces.<br />
	   * The latter is a deprecated method because it leads to confusion and will be
	   * removed in v2.<br />
	   * Additionally, it accepts additions and subtractions between different units.
	   * Note that multiplications and divisions aren't supported.
	   *
	   * Valid examples are:
	   * ```
	   * 10
	   * '10%'
	   * '10, 10'
	   * '10%, 10'
	   * '10 + 10%'
	   * '10 - 5vh + 3%'
	   * '-10px + 5vh, 5px - 6%'
	   * ```
	   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
	   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
	   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  offset: {
	    /** @prop {number} order=200 - Index used to define the order of execution */
	    order: 200,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: offset,
	    /** @prop {Number|String} offset=0
	     * The offset value as described in the modifier description
	     */
	    offset: 0
	  },
	
	  /**
	   * Modifier used to prevent the popper from being positioned outside the boundary.
	   *
	   * A scenario exists where the reference itself is not within the boundaries.<br />
	   * We can say it has "escaped the boundaries" — or just "escaped".<br />
	   * In this case we need to decide whether the popper should either:
	   *
	   * - detach from the reference and remain "trapped" in the boundaries, or
	   * - if it should ignore the boundary and "escape with its reference"
	   *
	   * When `escapeWithReference` is set to`true` and reference is completely
	   * outside its boundaries, the popper will overflow (or completely leave)
	   * the boundaries in order to remain attached to the edge of the reference.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  preventOverflow: {
	    /** @prop {number} order=300 - Index used to define the order of execution */
	    order: 300,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: preventOverflow,
	    /**
	     * @prop {Array} [priority=['left','right','top','bottom']]
	     * Popper will try to prevent overflow following these priorities by default,
	     * then, it could overflow on the left and on top of the `boundariesElement`
	     */
	    priority: ['left', 'right', 'top', 'bottom'],
	    /**
	     * @prop {number} padding=5
	     * Amount of pixel used to define a minimum distance between the boundaries
	     * and the popper. This makes sure the popper always has a little padding
	     * between the edges of its container
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='scrollParent'
	     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
	     * `viewport` or any DOM element.
	     */
	    boundariesElement: 'scrollParent'
	  },
	
	  /**
	   * Modifier used to make sure the reference and its popper stay near each other
	   * without leaving any gap between the two. Especially useful when the arrow is
	   * enabled and you want to ensure that it points to its reference element.
	   * It cares only about the first axis. You can still have poppers with margin
	   * between the popper and its reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  keepTogether: {
	    /** @prop {number} order=400 - Index used to define the order of execution */
	    order: 400,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: keepTogether
	  },
	
	  /**
	   * This modifier is used to move the `arrowElement` of the popper to make
	   * sure it is positioned between the reference element and its popper element.
	   * It will read the outer size of the `arrowElement` node to detect how many
	   * pixels of conjunction are needed.
	   *
	   * It has no effect if no `arrowElement` is provided.
	   * @memberof modifiers
	   * @inner
	   */
	  arrow: {
	    /** @prop {number} order=500 - Index used to define the order of execution */
	    order: 500,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: arrow,
	    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
	    element: '[x-arrow]'
	  },
	
	  /**
	   * Modifier used to flip the popper's placement when it starts to overlap its
	   * reference element.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   *
	   * **NOTE:** this modifier will interrupt the current update cycle and will
	   * restart it if it detects the need to flip the placement.
	   * @memberof modifiers
	   * @inner
	   */
	  flip: {
	    /** @prop {number} order=600 - Index used to define the order of execution */
	    order: 600,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: flip,
	    /**
	     * @prop {String|Array} behavior='flip'
	     * The behavior used to change the popper's placement. It can be one of
	     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
	     * placements (with optional variations)
	     */
	    behavior: 'flip',
	    /**
	     * @prop {number} padding=5
	     * The popper will flip if it hits the edges of the `boundariesElement`
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='viewport'
	     * The element which will define the boundaries of the popper position.
	     * The popper will never be placed outside of the defined boundaries
	     * (except if `keepTogether` is enabled)
	     */
	    boundariesElement: 'viewport',
	    /**
	     * @prop {Boolean} flipVariations=false
	     * The popper will switch placement variation between `-start` and `-end` when
	     * the reference element overlaps its boundaries.
	     *
	     * The original placement should have a set variation.
	     */
	    flipVariations: false,
	    /**
	     * @prop {Boolean} flipVariationsByContent=false
	     * The popper will switch placement variation between `-start` and `-end` when
	     * the popper element overlaps its reference boundaries.
	     *
	     * The original placement should have a set variation.
	     */
	    flipVariationsByContent: false
	  },
	
	  /**
	   * Modifier used to make the popper flow toward the inner of the reference element.
	   * By default, when this modifier is disabled, the popper will be placed outside
	   * the reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  inner: {
	    /** @prop {number} order=700 - Index used to define the order of execution */
	    order: 700,
	    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
	    enabled: false,
	    /** @prop {ModifierFn} */
	    fn: inner
	  },
	
	  /**
	   * Modifier used to hide the popper when its reference element is outside of the
	   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
	   * be used to hide with a CSS selector the popper when its reference is
	   * out of boundaries.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   * @memberof modifiers
	   * @inner
	   */
	  hide: {
	    /** @prop {number} order=800 - Index used to define the order of execution */
	    order: 800,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: hide
	  },
	
	  /**
	   * Computes the style that will be applied to the popper element to gets
	   * properly positioned.
	   *
	   * Note that this modifier will not touch the DOM, it just prepares the styles
	   * so that `applyStyle` modifier can apply it. This separation is useful
	   * in case you need to replace `applyStyle` with a custom implementation.
	   *
	   * This modifier has `850` as `order` value to maintain backward compatibility
	   * with previous versions of Popper.js. Expect the modifiers ordering method
	   * to change in future major versions of the library.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  computeStyle: {
	    /** @prop {number} order=850 - Index used to define the order of execution */
	    order: 850,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: computeStyle,
	    /**
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3D transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties
	     */
	    gpuAcceleration: true,
	    /**
	     * @prop {string} [x='bottom']
	     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
	     * Change this if your popper should grow in a direction different from `bottom`
	     */
	    x: 'bottom',
	    /**
	     * @prop {string} [x='left']
	     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
	     * Change this if your popper should grow in a direction different from `right`
	     */
	    y: 'right'
	  },
	
	  /**
	   * Applies the computed styles to the popper element.
	   *
	   * All the DOM manipulations are limited to this modifier. This is useful in case
	   * you want to integrate Popper.js inside a framework or view library and you
	   * want to delegate all the DOM manipulations to it.
	   *
	   * Note that if you disable this modifier, you must make sure the popper element
	   * has its position set to `absolute` before Popper.js can do its work!
	   *
	   * Just disable this modifier and define your own to achieve the desired effect.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  applyStyle: {
	    /** @prop {number} order=900 - Index used to define the order of execution */
	    order: 900,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: applyStyle,
	    /** @prop {Function} */
	    onLoad: applyStyleOnLoad,
	    /**
	     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3D transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties
	     */
	    gpuAcceleration: undefined
	  }
	};
	
	/**
	 * The `dataObject` is an object containing all the information used by Popper.js.
	 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
	 * @name dataObject
	 * @property {Object} data.instance The Popper.js instance
	 * @property {String} data.placement Placement applied to popper
	 * @property {String} data.originalPlacement Placement originally defined on init
	 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
	 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
	 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
	 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
	 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
	 * @property {Object} data.boundaries Offsets of the popper boundaries
	 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
	 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
	 */
	
	/**
	 * Default options provided to Popper.js constructor.<br />
	 * These can be overridden using the `options` argument of Popper.js.<br />
	 * To override an option, simply pass an object with the same
	 * structure of the `options` object, as the 3rd argument. For example:
	 * ```
	 * new Popper(ref, pop, {
	 *   modifiers: {
	 *     preventOverflow: { enabled: false }
	 *   }
	 * })
	 * ```
	 * @type {Object}
	 * @static
	 * @memberof Popper
	 */
	var Defaults = {
	  /**
	   * Popper's placement.
	   * @prop {Popper.placements} placement='bottom'
	   */
	  placement: 'bottom',
	
	  /**
	   * Set this to true if you want popper to position it self in 'fixed' mode
	   * @prop {Boolean} positionFixed=false
	   */
	  positionFixed: false,
	
	  /**
	   * Whether events (resize, scroll) are initially enabled.
	   * @prop {Boolean} eventsEnabled=true
	   */
	  eventsEnabled: true,
	
	  /**
	   * Set to true if you want to automatically remove the popper when
	   * you call the `destroy` method.
	   * @prop {Boolean} removeOnDestroy=false
	   */
	  removeOnDestroy: false,
	
	  /**
	   * Callback called when the popper is created.<br />
	   * By default, it is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onCreate}
	   */
	  onCreate: function onCreate() {},
	
	  /**
	   * Callback called when the popper is updated. This callback is not called
	   * on the initialization/creation of the popper, but only on subsequent
	   * updates.<br />
	   * By default, it is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onUpdate}
	   */
	  onUpdate: function onUpdate() {},
	
	  /**
	   * List of modifiers used to modify the offsets before they are applied to the popper.
	   * They provide most of the functionalities of Popper.js.
	   * @prop {modifiers}
	   */
	  modifiers: modifiers
	};
	
	/**
	 * @callback onCreate
	 * @param {dataObject} data
	 */
	
	/**
	 * @callback onUpdate
	 * @param {dataObject} data
	 */
	
	// Utils
	// Methods
	var Popper = function () {
	  /**
	   * Creates a new Popper.js instance.
	   * @class Popper
	   * @param {Element|referenceObject} reference - The reference element used to position the popper
	   * @param {Element} popper - The HTML / XML element used as the popper
	   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
	   * @return {Object} instance - The generated Popper.js instance
	   */
	  function Popper(reference, popper) {
	    var _this = this;
	
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    classCallCheck(this, Popper);
	
	    this.scheduleUpdate = function () {
	      return requestAnimationFrame(_this.update);
	    };
	
	    // make update() debounced, so that it only runs at most once-per-tick
	    this.update = debounce(this.update.bind(this));
	
	    // with {} we create a new object with the options inside it
	    this.options = _extends({}, Popper.Defaults, options);
	
	    // init state
	    this.state = {
	      isDestroyed: false,
	      isCreated: false,
	      scrollParents: []
	    };
	
	    // get reference and popper elements (allow jQuery wrappers)
	    this.reference = reference && reference.jquery ? reference[0] : reference;
	    this.popper = popper && popper.jquery ? popper[0] : popper;
	
	    // Deep merge modifiers options
	    this.options.modifiers = {};
	    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
	      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
	    });
	
	    // Refactoring modifiers' list (Object => Array)
	    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
	      return _extends({
	        name: name
	      }, _this.options.modifiers[name]);
	    })
	    // sort the modifiers by order
	    .sort(function (a, b) {
	      return a.order - b.order;
	    });
	
	    // modifiers have the ability to execute arbitrary code when Popper.js get inited
	    // such code is executed in the same order of its modifier
	    // they could add new properties to their options configuration
	    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
	    this.modifiers.forEach(function (modifierOptions) {
	      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
	        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
	      }
	    });
	
	    // fire the first update to position the popper in the right place
	    this.update();
	
	    var eventsEnabled = this.options.eventsEnabled;
	    if (eventsEnabled) {
	      // setup event listeners, they will take care of update the position in specific situations
	      this.enableEventListeners();
	    }
	
	    this.state.eventsEnabled = eventsEnabled;
	  }
	
	  // We can't use class properties because they don't get listed in the
	  // class prototype and break stuff like Sinon stubs
	
	
	  createClass(Popper, [{
	    key: 'update',
	    value: function update$$1() {
	      return update.call(this);
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy$$1() {
	      return destroy.call(this);
	    }
	  }, {
	    key: 'enableEventListeners',
	    value: function enableEventListeners$$1() {
	      return enableEventListeners.call(this);
	    }
	  }, {
	    key: 'disableEventListeners',
	    value: function disableEventListeners$$1() {
	      return disableEventListeners.call(this);
	    }
	
	    /**
	     * Schedules an update. It will run on the next UI update available.
	     * @method scheduleUpdate
	     * @memberof Popper
	     */
	
	
	    /**
	     * Collection of utilities useful when writing custom modifiers.
	     * Starting from version 1.7, this method is available only if you
	     * include `popper-utils.js` before `popper.js`.
	     *
	     * **DEPRECATION**: This way to access PopperUtils is deprecated
	     * and will be removed in v2! Use the PopperUtils module directly instead.
	     * Due to the high instability of the methods contained in Utils, we can't
	     * guarantee them to follow semver. Use them at your own risk!
	     * @static
	     * @private
	     * @type {Object}
	     * @deprecated since version 1.8
	     * @member Utils
	     * @memberof Popper
	     */
	
	  }]);
	  return Popper;
	}();
	
	/**
	 * The `referenceObject` is an object that provides an interface compatible with Popper.js
	 * and lets you use it as replacement of a real DOM node.<br />
	 * You can use this method to position a popper relatively to a set of coordinates
	 * in case you don't have a DOM node to use as reference.
	 *
	 * ```
	 * new Popper(referenceObject, popperNode);
	 * ```
	 *
	 * NB: This feature isn't supported in Internet Explorer 10.
	 * @name referenceObject
	 * @property {Function} data.getBoundingClientRect
	 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
	 * @property {number} data.clientWidth
	 * An ES6 getter that will return the width of the virtual reference element.
	 * @property {number} data.clientHeight
	 * An ES6 getter that will return the height of the virtual reference element.
	 */
	
	
	Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
	Popper.placements = placements;
	Popper.Defaults = Defaults;
	
	return Popper;
	
	})));
	//# sourceMappingURL=popper.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 908 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(1057);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 909 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIs = __webpack_require__(935);
	
	var _createChainableTypeChecker = __webpack_require__(910);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function elementType(props, propName, componentName, location, propFullName) {
	  var propValue = props[propName];
	
	  if (_react2.default.isValidElement(propValue)) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`,expected an element type (a string ') + ', component class, or function component).');
	  }
	
	  if (!(0, _reactIs.isValidElementType)(propValue)) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + ', component class, or function component).');
	  }
	
	  return null;
	}
	
	exports.default = (0, _createChainableTypeChecker2.default)(elementType);
	module.exports = exports['default'];

/***/ },
/* 910 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createChainableTypeChecker;
	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	// Mostly taken from ReactPropTypes.
	
	function createChainableTypeChecker(validate) {
	  function checkType(isRequired, props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] == null) {
	      if (isRequired) {
	        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
	      }
	
	      return null;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
	      args[_key - 6] = arguments[_key];
	    }
	
	    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}
	module.exports = exports['default'];

/***/ },
/* 911 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(2195)
	  , root = typeof window === 'undefined' ? global : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = root['request' + suffix]
	  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
	
	for(var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix]
	  caf = root[vendors[i] + 'Cancel' + suffix]
	      || root[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn)
	}
	module.exports.cancel = function() {
	  caf.apply(root, arguments)
	}
	module.exports.polyfill = function(object) {
	  if (!object) {
	    object = root;
	  }
	  object.requestAnimationFrame = raf
	  object.cancelAnimationFrame = caf
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 912 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SafeAnchor = __webpack_require__(99);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * If set to true, renders `span` instead of `a`
	   */
	  active: _propTypes2['default'].bool,
	  /**
	   * `href` attribute for the inner `a` element
	   */
	  href: _propTypes2['default'].string,
	  /**
	   * `title` attribute for the inner `a` element
	   */
	  title: _propTypes2['default'].node,
	  /**
	   * `target` attribute for the inner `a` element
	   */
	  target: _propTypes2['default'].string
	};
	
	var defaultProps = {
	  active: false
	};
	
	var BreadcrumbItem = function (_React$Component) {
	  (0, _inherits3['default'])(BreadcrumbItem, _React$Component);
	
	  function BreadcrumbItem() {
	    (0, _classCallCheck3['default'])(this, BreadcrumbItem);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  BreadcrumbItem.prototype.render = function render() {
	    var _props = this.props,
	        active = _props.active,
	        href = _props.href,
	        title = _props.title,
	        target = _props.target,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['active', 'href', 'title', 'target', 'className']);
	
	    // Don't try to render these props on non-active <span>.
	
	    var linkProps = { href: href, title: title, target: target };
	
	    return _react2['default'].createElement(
	      'li',
	      { className: (0, _classnames2['default'])(className, { active: active }) },
	      active ? _react2['default'].createElement('span', props) : _react2['default'].createElement(_SafeAnchor2['default'], (0, _extends3['default'])({}, props, linkProps))
	    );
	  };
	
	  return BreadcrumbItem;
	}(_react2['default'].Component);
	
	BreadcrumbItem.propTypes = propTypes;
	BreadcrumbItem.defaultProps = defaultProps;
	
	exports['default'] = BreadcrumbItem;
	module.exports = exports['default'];

/***/ },
/* 913 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(18);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _all = __webpack_require__(302);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _Button = __webpack_require__(226);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _bootstrapUtils = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  vertical: _propTypes2['default'].bool,
	  justified: _propTypes2['default'].bool,
	
	  /**
	   * Display block buttons; only useful when used with the "vertical" prop.
	   * @type {bool}
	   */
	  block: (0, _all2['default'])(_propTypes2['default'].bool, function (_ref) {
	    var block = _ref.block,
	        vertical = _ref.vertical;
	    return block && !vertical ? new Error('`block` requires `vertical` to be set to have any effect') : null;
	  })
	};
	
	var defaultProps = {
	  block: false,
	  justified: false,
	  vertical: false
	};
	
	var ButtonGroup = function (_React$Component) {
	  (0, _inherits3['default'])(ButtonGroup, _React$Component);
	
	  function ButtonGroup() {
	    (0, _classCallCheck3['default'])(this, ButtonGroup);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ButtonGroup.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        block = _props.block,
	        justified = _props.justified,
	        vertical = _props.vertical,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['block', 'justified', 'vertical', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps)] = !vertical, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'vertical')] = vertical, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'justified')] = justified, _extends2[(0, _bootstrapUtils.prefix)(_Button2['default'].defaultProps, 'block')] = block, _extends2));
	
	    return _react2['default'].createElement('div', (0, _extends4['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return ButtonGroup;
	}(_react2['default'].Component);
	
	ButtonGroup.propTypes = propTypes;
	ButtonGroup.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('btn-group', ButtonGroup);
	module.exports = exports['default'];

/***/ },
/* 914 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _TransitionEvents = __webpack_require__(2262);
	
	var _TransitionEvents2 = _interopRequireDefault(_TransitionEvents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: This should use a timeout instead of TransitionEvents, or else just
	// not wait until transition end to trigger continuing animations.
	
	var propTypes = {
	  direction: _propTypes2['default'].oneOf(['prev', 'next']),
	  onAnimateOutEnd: _propTypes2['default'].func,
	  active: _propTypes2['default'].bool,
	  animateIn: _propTypes2['default'].bool,
	  animateOut: _propTypes2['default'].bool,
	  index: _propTypes2['default'].number
	};
	
	var defaultProps = {
	  active: false,
	  animateIn: false,
	  animateOut: false
	};
	
	var CarouselItem = function (_React$Component) {
	  (0, _inherits3['default'])(CarouselItem, _React$Component);
	
	  function CarouselItem(props, context) {
	    (0, _classCallCheck3['default'])(this, CarouselItem);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleAnimateOutEnd = _this.handleAnimateOutEnd.bind(_this);
	
	    _this.state = {
	      direction: null
	    };
	
	    _this.isUnmounted = false;
	    return _this;
	  }
	
	  CarouselItem.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.active !== nextProps.active) {
	      this.setState({ direction: null });
	    }
	  };
	
	  CarouselItem.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var _this2 = this;
	
	    var active = this.props.active;
	
	    var prevActive = prevProps.active;
	
	    if (!active && prevActive) {
	      _TransitionEvents2['default'].addEndEventListener(_reactDom2['default'].findDOMNode(this), this.handleAnimateOutEnd);
	    }
	
	    if (active !== prevActive) {
	      setTimeout(function () {
	        return _this2.startAnimation();
	      }, 20);
	    }
	  };
	
	  CarouselItem.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.isUnmounted = true;
	  };
	
	  CarouselItem.prototype.handleAnimateOutEnd = function handleAnimateOutEnd() {
	    if (this.isUnmounted) {
	      return;
	    }
	
	    if (this.props.onAnimateOutEnd) {
	      this.props.onAnimateOutEnd(this.props.index);
	    }
	  };
	
	  CarouselItem.prototype.startAnimation = function startAnimation() {
	    if (this.isUnmounted) {
	      return;
	    }
	
	    this.setState({
	      direction: this.props.direction === 'prev' ? 'right' : 'left'
	    });
	  };
	
	  CarouselItem.prototype.render = function render() {
	    var _props = this.props,
	        direction = _props.direction,
	        active = _props.active,
	        animateIn = _props.animateIn,
	        animateOut = _props.animateOut,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['direction', 'active', 'animateIn', 'animateOut', 'className']);
	
	
	    delete props.onAnimateOutEnd;
	    delete props.index;
	
	    var classes = {
	      item: true,
	      active: active && !animateIn || animateOut
	    };
	    if (direction && active && animateIn) {
	      classes[direction] = true;
	    }
	    if (this.state.direction && (animateIn || animateOut)) {
	      classes[this.state.direction] = true;
	    }
	
	    return _react2['default'].createElement('div', (0, _extends3['default'])({}, props, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return CarouselItem;
	}(_react2['default'].Component);
	
	CarouselItem.propTypes = propTypes;
	CarouselItem.defaultProps = defaultProps;
	
	exports['default'] = CarouselItem;
	module.exports = exports['default'];

/***/ },
/* 915 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  label: PropTypes.string.isRequired,
	  onClick: PropTypes.func
	};
	
	var CloseButton = function (_React$Component) {
	  (0, _inherits3['default'])(CloseButton, _React$Component);
	
	  function CloseButton() {
	    (0, _classCallCheck3['default'])(this, CloseButton);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  CloseButton.prototype.render = function render() {
	    var _props = this.props,
	        label = _props.label,
	        onClick = _props.onClick;
	
	    return _react2['default'].createElement(
	      'button',
	      {
	        type: 'button',
	        className: 'close',
	        onClick: onClick
	      },
	      _react2['default'].createElement(
	        'span',
	        { 'aria-hidden': 'true' },
	        '\xD7'
	      ),
	      _react2['default'].createElement(
	        'span',
	        { className: 'sr-only' },
	        label
	      )
	    );
	  };
	
	  return CloseButton;
	}(_react2['default'].Component);
	
	CloseButton.propTypes = propTypes;
	
	exports['default'] = CloseButton;
	module.exports = exports['default'];

/***/ },
/* 916 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Button = __webpack_require__(226);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _SafeAnchor = __webpack_require__(99);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _bootstrapUtils = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  noCaret: _propTypes2['default'].bool,
	  open: _propTypes2['default'].bool,
	  title: _propTypes2['default'].string,
	  useAnchor: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  open: false,
	  useAnchor: false,
	  bsRole: 'toggle'
	};
	
	var DropdownToggle = function (_React$Component) {
	  (0, _inherits3['default'])(DropdownToggle, _React$Component);
	
	  function DropdownToggle() {
	    (0, _classCallCheck3['default'])(this, DropdownToggle);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  DropdownToggle.prototype.render = function render() {
	    var _props = this.props,
	        noCaret = _props.noCaret,
	        open = _props.open,
	        useAnchor = _props.useAnchor,
	        bsClass = _props.bsClass,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['noCaret', 'open', 'useAnchor', 'bsClass', 'className', 'children']);
	
	
	    delete props.bsRole;
	
	    var Component = useAnchor ? _SafeAnchor2['default'] : _Button2['default'];
	    var useCaret = !noCaret;
	
	    // This intentionally forwards bsSize and bsStyle (if set) to the
	    // underlying component, to allow it to render size and style variants.
	
	    // FIXME: Should this really fall back to `title` as children?
	
	    return _react2['default'].createElement(
	      Component,
	      (0, _extends3['default'])({}, props, {
	        role: 'button',
	        className: (0, _classnames2['default'])(className, bsClass),
	        'aria-haspopup': true,
	        'aria-expanded': open
	      }),
	      children || props.title,
	      useCaret && ' ',
	      useCaret && _react2['default'].createElement('span', { className: 'caret' })
	    );
	  };
	
	  return DropdownToggle;
	}(_react2['default'].Component);
	
	DropdownToggle.propTypes = propTypes;
	DropdownToggle.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('dropdown-toggle', DropdownToggle);
	module.exports = exports['default'];

/***/ },
/* 917 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(42);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Turn any fixed-width grid layout into a full-width layout by this property.
	   *
	   * Adds `container-fluid` class.
	   */
	  fluid: _propTypes2['default'].bool,
	  /**
	   * You can use a custom element for this component
	   */
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div',
	  fluid: false
	};
	
	var Grid = function (_React$Component) {
	  (0, _inherits3['default'])(Grid, _React$Component);
	
	  function Grid() {
	    (0, _classCallCheck3['default'])(this, Grid);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Grid.prototype.render = function render() {
	    var _props = this.props,
	        fluid = _props.fluid,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['fluid', 'componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.prefix)(bsProps, fluid && 'fluid');
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Grid;
	}(_react2['default'].Component);
	
	Grid.propTypes = propTypes;
	Grid.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('container', Grid);
	module.exports = exports['default'];

/***/ },
/* 918 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(157);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(24);
	
	var _StyleConfig = __webpack_require__(64);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  active: _propTypes2['default'].any,
	  disabled: _propTypes2['default'].any,
	  header: _propTypes2['default'].node,
	  listItem: _propTypes2['default'].bool,
	  onClick: _propTypes2['default'].func,
	  href: _propTypes2['default'].string,
	  type: _propTypes2['default'].string
	};
	
	var defaultProps = {
	  listItem: false
	};
	
	var ListGroupItem = function (_React$Component) {
	  (0, _inherits3['default'])(ListGroupItem, _React$Component);
	
	  function ListGroupItem() {
	    (0, _classCallCheck3['default'])(this, ListGroupItem);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ListGroupItem.prototype.renderHeader = function renderHeader(header, headingClassName) {
	    if (_react2['default'].isValidElement(header)) {
	      return (0, _react.cloneElement)(header, {
	        className: (0, _classnames2['default'])(header.props.className, headingClassName)
	      });
	    }
	
	    return _react2['default'].createElement(
	      'h4',
	      { className: headingClassName },
	      header
	    );
	  };
	
	  ListGroupItem.prototype.render = function render() {
	    var _props = this.props,
	        active = _props.active,
	        disabled = _props.disabled,
	        className = _props.className,
	        header = _props.header,
	        listItem = _props.listItem,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['active', 'disabled', 'className', 'header', 'listItem', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      active: active,
	      disabled: disabled
	    });
	
	    var Component = void 0;
	
	    if (elementProps.href) {
	      Component = 'a';
	    } else if (elementProps.onClick) {
	      Component = 'button';
	      elementProps.type = elementProps.type || 'button';
	    } else if (listItem) {
	      Component = 'li';
	    } else {
	      Component = 'span';
	    }
	
	    elementProps.className = (0, _classnames2['default'])(className, classes);
	
	    // TODO: Deprecate `header` prop.
	    if (header) {
	      return _react2['default'].createElement(
	        Component,
	        elementProps,
	        this.renderHeader(header, (0, _bootstrapUtils.prefix)(bsProps, 'heading')),
	        _react2['default'].createElement(
	          'p',
	          { className: (0, _bootstrapUtils.prefix)(bsProps, 'text') },
	          children
	        )
	      );
	    }
	
	    return _react2['default'].createElement(
	      Component,
	      elementProps,
	      children
	    );
	  };
	
	  return ListGroupItem;
	}(_react2['default'].Component);
	
	ListGroupItem.propTypes = propTypes;
	ListGroupItem.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('list-group-item', (0, _bootstrapUtils.bsStyles)((0, _values2['default'])(_StyleConfig.State), ListGroupItem));
	module.exports = exports['default'];

/***/ },
/* 919 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(42);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var ModalBody = function (_React$Component) {
	  (0, _inherits3['default'])(ModalBody, _React$Component);
	
	  function ModalBody() {
	    (0, _classCallCheck3['default'])(this, ModalBody);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalBody.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return ModalBody;
	}(_react2['default'].Component);
	
	ModalBody.propTypes = propTypes;
	ModalBody.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('modal-body', ModalBody);
	module.exports = exports['default'];

/***/ },
/* 920 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(42);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var ModalFooter = function (_React$Component) {
	  (0, _inherits3['default'])(ModalFooter, _React$Component);
	
	  function ModalFooter() {
	    (0, _classCallCheck3['default'])(this, ModalFooter);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalFooter.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return ModalFooter;
	}(_react2['default'].Component);
	
	ModalFooter.propTypes = propTypes;
	ModalFooter.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('modal-footer', ModalFooter);
	module.exports = exports['default'];

/***/ },
/* 921 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(24);
	
	var _createChainedFunction = __webpack_require__(62);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _CloseButton = __webpack_require__(915);
	
	var _CloseButton2 = _interopRequireDefault(_CloseButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: `aria-label` should be `closeLabel`.
	
	var propTypes = {
	  /**
	   * Provides an accessible label for the close
	   * button. It is used for Assistive Technology when the label text is not
	   * readable.
	   */
	  closeLabel: _propTypes2['default'].string,
	
	  /**
	   * Specify whether the Component should contain a close button
	   */
	  closeButton: _propTypes2['default'].bool,
	
	  /**
	   * A Callback fired when the close button is clicked. If used directly inside
	   * a Modal component, the onHide will automatically be propagated up to the
	   * parent Modal `onHide`.
	   */
	  onHide: _propTypes2['default'].func
	};
	
	var defaultProps = {
	  closeLabel: 'Close',
	  closeButton: false
	};
	
	var contextTypes = {
	  $bs_modal: _propTypes2['default'].shape({
	    onHide: _propTypes2['default'].func
	  })
	};
	
	var ModalHeader = function (_React$Component) {
	  (0, _inherits3['default'])(ModalHeader, _React$Component);
	
	  function ModalHeader() {
	    (0, _classCallCheck3['default'])(this, ModalHeader);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalHeader.prototype.render = function render() {
	    var _props = this.props,
	        closeLabel = _props.closeLabel,
	        closeButton = _props.closeButton,
	        onHide = _props.onHide,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['closeLabel', 'closeButton', 'onHide', 'className', 'children']);
	
	
	    var modal = this.context.$bs_modal;
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      closeButton && _react2['default'].createElement(_CloseButton2['default'], {
	        label: closeLabel,
	        onClick: (0, _createChainedFunction2['default'])(modal && modal.onHide, onHide)
	      }),
	      children
	    );
	  };
	
	  return ModalHeader;
	}(_react2['default'].Component);
	
	ModalHeader.propTypes = propTypes;
	ModalHeader.defaultProps = defaultProps;
	ModalHeader.contextTypes = contextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('modal-header', ModalHeader);
	module.exports = exports['default'];

/***/ },
/* 922 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(42);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'h4'
	};
	
	var ModalTitle = function (_React$Component) {
	  (0, _inherits3['default'])(ModalTitle, _React$Component);
	
	  function ModalTitle() {
	    (0, _classCallCheck3['default'])(this, ModalTitle);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalTitle.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return ModalTitle;
	}(_react2['default'].Component);
	
	ModalTitle.propTypes = propTypes;
	ModalTitle.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('modal-title', ModalTitle);
	module.exports = exports['default'];

/***/ },
/* 923 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(18);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _keycode = __webpack_require__(432);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _all = __webpack_require__(302);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _warning = __webpack_require__(100);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(24);
	
	var _createChainedFunction = __webpack_require__(62);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _ValidComponentChildren = __webpack_require__(74);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: Should we expose `<NavItem>` as `<Nav.Item>`?
	
	// TODO: This `bsStyle` is very unlike the others. Should we rename it?
	
	// TODO: `pullRight` and `pullLeft` don't render right outside of `navbar`.
	// Consider renaming or replacing them.
	
	var propTypes = {
	  /**
	   * Marks the NavItem with a matching `eventKey` as active. Has a
	   * higher precedence over `activeHref`.
	   */
	  activeKey: _propTypes2['default'].any,
	
	  /**
	   * Marks the child NavItem with a matching `href` prop as active.
	   */
	  activeHref: _propTypes2['default'].string,
	
	  /**
	   * NavItems are be positioned vertically.
	   */
	  stacked: _propTypes2['default'].bool,
	
	  justified: (0, _all2['default'])(_propTypes2['default'].bool, function (_ref) {
	    var justified = _ref.justified,
	        navbar = _ref.navbar;
	    return justified && navbar ? Error('justified navbar `Nav`s are not supported') : null;
	  }),
	
	  /**
	   * A callback fired when a NavItem is selected.
	   *
	   * ```js
	   * function (
	   * 	Any eventKey,
	   * 	SyntheticEvent event?
	   * )
	   * ```
	   */
	  onSelect: _propTypes2['default'].func,
	
	  /**
	   * ARIA role for the Nav, in the context of a TabContainer, the default will
	   * be set to "tablist", but can be overridden by the Nav when set explicitly.
	   *
	   * When the role is set to "tablist" NavItem focus is managed according to
	   * the ARIA authoring practices for tabs:
	   * https://www.w3.org/TR/2013/WD-wai-aria-practices-20130307/#tabpanel
	   */
	  role: _propTypes2['default'].string,
	
	  /**
	   * Apply styling an alignment for use in a Navbar. This prop will be set
	   * automatically when the Nav is used inside a Navbar.
	   */
	  navbar: _propTypes2['default'].bool,
	
	  /**
	   * Float the Nav to the right. When `navbar` is `true` the appropriate
	   * contextual classes are added as well.
	   */
	  pullRight: _propTypes2['default'].bool,
	
	  /**
	   * Float the Nav to the left. When `navbar` is `true` the appropriate
	   * contextual classes are added as well.
	   */
	  pullLeft: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  justified: false,
	  pullRight: false,
	  pullLeft: false,
	  stacked: false
	};
	
	var contextTypes = {
	  $bs_navbar: _propTypes2['default'].shape({
	    bsClass: _propTypes2['default'].string,
	    onSelect: _propTypes2['default'].func
	  }),
	
	  $bs_tabContainer: _propTypes2['default'].shape({
	    activeKey: _propTypes2['default'].any,
	    onSelect: _propTypes2['default'].func.isRequired,
	    getTabId: _propTypes2['default'].func.isRequired,
	    getPaneId: _propTypes2['default'].func.isRequired
	  })
	};
	
	var Nav = function (_React$Component) {
	  (0, _inherits3['default'])(Nav, _React$Component);
	
	  function Nav() {
	    (0, _classCallCheck3['default'])(this, Nav);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Nav.prototype.componentDidUpdate = function componentDidUpdate() {
	    var _this2 = this;
	
	    if (!this._needsRefocus) {
	      return;
	    }
	
	    this._needsRefocus = false;
	
	    var children = this.props.children;
	
	    var _getActiveProps = this.getActiveProps(),
	        activeKey = _getActiveProps.activeKey,
	        activeHref = _getActiveProps.activeHref;
	
	    var activeChild = _ValidComponentChildren2['default'].find(children, function (child) {
	      return _this2.isActive(child, activeKey, activeHref);
	    });
	
	    var childrenArray = _ValidComponentChildren2['default'].toArray(children);
	    var activeChildIndex = childrenArray.indexOf(activeChild);
	
	    var childNodes = _reactDom2['default'].findDOMNode(this).children;
	    var activeNode = childNodes && childNodes[activeChildIndex];
	
	    if (!activeNode || !activeNode.firstChild) {
	      return;
	    }
	
	    activeNode.firstChild.focus();
	  };
	
	  Nav.prototype.handleTabKeyDown = function handleTabKeyDown(onSelect, event) {
	    var nextActiveChild = void 0;
	
	    switch (event.keyCode) {
	      case _keycode2['default'].codes.left:
	      case _keycode2['default'].codes.up:
	        nextActiveChild = this.getNextActiveChild(-1);
	        break;
	      case _keycode2['default'].codes.right:
	      case _keycode2['default'].codes.down:
	        nextActiveChild = this.getNextActiveChild(1);
	        break;
	      default:
	        // It was a different key; don't handle this keypress.
	        return;
	    }
	
	    event.preventDefault();
	
	    if (onSelect && nextActiveChild && nextActiveChild.props.eventKey != null) {
	      onSelect(nextActiveChild.props.eventKey);
	    }
	
	    this._needsRefocus = true;
	  };
	
	  Nav.prototype.getNextActiveChild = function getNextActiveChild(offset) {
	    var _this3 = this;
	
	    var children = this.props.children;
	
	    var validChildren = children.filter(function (child) {
	      return child.props.eventKey != null && !child.props.disabled;
	    });
	
	    var _getActiveProps2 = this.getActiveProps(),
	        activeKey = _getActiveProps2.activeKey,
	        activeHref = _getActiveProps2.activeHref;
	
	    var activeChild = _ValidComponentChildren2['default'].find(children, function (child) {
	      return _this3.isActive(child, activeKey, activeHref);
	    });
	
	    // This assumes the active child is not disabled.
	    var activeChildIndex = validChildren.indexOf(activeChild);
	    if (activeChildIndex === -1) {
	      // Something has gone wrong. Select the first valid child we can find.
	      return validChildren[0];
	    }
	
	    var nextIndex = activeChildIndex + offset;
	    var numValidChildren = validChildren.length;
	
	    if (nextIndex >= numValidChildren) {
	      nextIndex = 0;
	    } else if (nextIndex < 0) {
	      nextIndex = numValidChildren - 1;
	    }
	
	    return validChildren[nextIndex];
	  };
	
	  Nav.prototype.getActiveProps = function getActiveProps() {
	    var tabContainer = this.context.$bs_tabContainer;
	
	    if (tabContainer) {
	       false ? (0, _warning2['default'])(this.props.activeKey == null && !this.props.activeHref, 'Specifying a `<Nav>` `activeKey` or `activeHref` in the context of ' + 'a `<TabContainer>` is not supported. Instead use `<TabContainer ' + ('activeKey={' + this.props.activeKey + '} />`.')) : void 0;
	
	      return tabContainer;
	    }
	
	    return this.props;
	  };
	
	  Nav.prototype.isActive = function isActive(_ref2, activeKey, activeHref) {
	    var props = _ref2.props;
	
	    if (props.active || activeKey != null && props.eventKey === activeKey || activeHref && props.href === activeHref) {
	      return true;
	    }
	
	    return props.active;
	  };
	
	  Nav.prototype.getTabProps = function getTabProps(child, tabContainer, navRole, active, onSelect) {
	    var _this4 = this;
	
	    if (!tabContainer && navRole !== 'tablist') {
	      // No tab props here.
	      return null;
	    }
	
	    var _child$props = child.props,
	        id = _child$props.id,
	        controls = _child$props['aria-controls'],
	        eventKey = _child$props.eventKey,
	        role = _child$props.role,
	        onKeyDown = _child$props.onKeyDown,
	        tabIndex = _child$props.tabIndex;
	
	
	    if (tabContainer) {
	       false ? (0, _warning2['default'])(!id && !controls, 'In the context of a `<TabContainer>`, `<NavItem>`s are given ' + 'generated `id` and `aria-controls` attributes for the sake of ' + 'proper component accessibility. Any provided ones will be ignored. ' + 'To control these attributes directly, provide a `generateChildId` ' + 'prop to the parent `<TabContainer>`.') : void 0;
	
	      id = tabContainer.getTabId(eventKey);
	      controls = tabContainer.getPaneId(eventKey);
	    }
	
	    if (navRole === 'tablist') {
	      role = role || 'tab';
	      onKeyDown = (0, _createChainedFunction2['default'])(function (event) {
	        return _this4.handleTabKeyDown(onSelect, event);
	      }, onKeyDown);
	      tabIndex = active ? tabIndex : -1;
	    }
	
	    return {
	      id: id,
	      role: role,
	      onKeyDown: onKeyDown,
	      'aria-controls': controls,
	      tabIndex: tabIndex
	    };
	  };
	
	  Nav.prototype.render = function render() {
	    var _extends2,
	        _this5 = this;
	
	    var _props = this.props,
	        stacked = _props.stacked,
	        justified = _props.justified,
	        onSelect = _props.onSelect,
	        propsRole = _props.role,
	        propsNavbar = _props.navbar,
	        pullRight = _props.pullRight,
	        pullLeft = _props.pullLeft,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['stacked', 'justified', 'onSelect', 'role', 'navbar', 'pullRight', 'pullLeft', 'className', 'children']);
	
	
	    var tabContainer = this.context.$bs_tabContainer;
	    var role = propsRole || (tabContainer ? 'tablist' : null);
	
	    var _getActiveProps3 = this.getActiveProps(),
	        activeKey = _getActiveProps3.activeKey,
	        activeHref = _getActiveProps3.activeHref;
	
	    delete props.activeKey; // Accessed via this.getActiveProps().
	    delete props.activeHref; // Accessed via this.getActiveProps().
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'stacked')] = stacked, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'justified')] = justified, _extends2));
	
	    var navbar = propsNavbar != null ? propsNavbar : this.context.$bs_navbar;
	    var pullLeftClassName = void 0;
	    var pullRightClassName = void 0;
	
	    if (navbar) {
	      var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	      classes[(0, _bootstrapUtils.prefix)(navbarProps, 'nav')] = true;
	
	      pullRightClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'right');
	      pullLeftClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'left');
	    } else {
	      pullRightClassName = 'pull-right';
	      pullLeftClassName = 'pull-left';
	    }
	
	    classes[pullRightClassName] = pullRight;
	    classes[pullLeftClassName] = pullLeft;
	
	    return _react2['default'].createElement(
	      'ul',
	      (0, _extends4['default'])({}, elementProps, {
	        role: role,
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      _ValidComponentChildren2['default'].map(children, function (child) {
	        var active = _this5.isActive(child, activeKey, activeHref);
	        var childOnSelect = (0, _createChainedFunction2['default'])(child.props.onSelect, onSelect, navbar && navbar.onSelect, tabContainer && tabContainer.onSelect);
	
	        return (0, _react.cloneElement)(child, (0, _extends4['default'])({}, _this5.getTabProps(child, tabContainer, role, active, childOnSelect), {
	          active: active,
	          activeKey: activeKey,
	          activeHref: activeHref,
	          onSelect: childOnSelect
	        }));
	      })
	    );
	  };
	
	  return Nav;
	}(_react2['default'].Component);
	
	Nav.propTypes = propTypes;
	Nav.defaultProps = defaultProps;
	Nav.contextTypes = contextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('nav', (0, _bootstrapUtils.bsStyles)(['tabs', 'pills'], Nav));
	module.exports = exports['default'];

/***/ },
/* 924 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SafeAnchor = __webpack_require__(99);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _createChainedFunction = __webpack_require__(62);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  active: _propTypes2['default'].bool,
	  disabled: _propTypes2['default'].bool,
	  role: _propTypes2['default'].string,
	  href: _propTypes2['default'].string,
	  onClick: _propTypes2['default'].func,
	  onSelect: _propTypes2['default'].func,
	  eventKey: _propTypes2['default'].any
	};
	
	var defaultProps = {
	  active: false,
	  disabled: false
	};
	
	var NavItem = function (_React$Component) {
	  (0, _inherits3['default'])(NavItem, _React$Component);
	
	  function NavItem(props, context) {
	    (0, _classCallCheck3['default'])(this, NavItem);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  NavItem.prototype.handleClick = function handleClick(e) {
	    if (this.props.onSelect) {
	      e.preventDefault();
	
	      if (!this.props.disabled) {
	        this.props.onSelect(this.props.eventKey, e);
	      }
	    }
	  };
	
	  NavItem.prototype.render = function render() {
	    var _props = this.props,
	        active = _props.active,
	        disabled = _props.disabled,
	        onClick = _props.onClick,
	        className = _props.className,
	        style = _props.style,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['active', 'disabled', 'onClick', 'className', 'style']);
	
	
	    delete props.onSelect;
	    delete props.eventKey;
	
	    // These are injected down by `<Nav>` for building `<SubNav>`s.
	    delete props.activeKey;
	    delete props.activeHref;
	
	    if (!props.role) {
	      if (props.href === '#') {
	        props.role = 'button';
	      }
	    } else if (props.role === 'tab') {
	      props['aria-selected'] = active;
	    }
	
	    return _react2['default'].createElement(
	      'li',
	      {
	        role: 'presentation',
	        className: (0, _classnames2['default'])(className, { active: active, disabled: disabled }),
	        style: style
	      },
	      _react2['default'].createElement(_SafeAnchor2['default'], (0, _extends3['default'])({}, props, {
	        disabled: disabled,
	        onClick: (0, _createChainedFunction2['default'])(onClick, this.handleClick)
	      }))
	    );
	  };
	
	  return NavItem;
	}(_react2['default'].Component);
	
	NavItem.propTypes = propTypes;
	NavItem.defaultProps = defaultProps;
	
	exports['default'] = NavItem;
	module.exports = exports['default'];

/***/ },
/* 925 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var contextTypes = {
	  $bs_navbar: _propTypes2['default'].shape({
	    bsClass: _propTypes2['default'].string
	  })
	};
	
	var NavbarBrand = function (_React$Component) {
	  (0, _inherits3['default'])(NavbarBrand, _React$Component);
	
	  function NavbarBrand() {
	    (0, _classCallCheck3['default'])(this, NavbarBrand);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  NavbarBrand.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className', 'children']);
	
	    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	    var bsClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'brand');
	
	    if (_react2['default'].isValidElement(children)) {
	      return _react2['default'].cloneElement(children, {
	        className: (0, _classnames2['default'])(children.props.className, className, bsClassName)
	      });
	    }
	
	    return _react2['default'].createElement(
	      'span',
	      (0, _extends3['default'])({}, props, { className: (0, _classnames2['default'])(className, bsClassName) }),
	      children
	    );
	  };
	
	  return NavbarBrand;
	}(_react2['default'].Component);
	
	NavbarBrand.contextTypes = contextTypes;
	
	exports['default'] = NavbarBrand;
	module.exports = exports['default'];

/***/ },
/* 926 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Overlay = __webpack_require__(2290);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _elementType = __webpack_require__(42);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _Fade = __webpack_require__(296);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _extends3['default'])({}, _Overlay2['default'].propTypes, {
	
	  /**
	   * Set the visibility of the Overlay
	   */
	  show: _propTypes2['default'].bool,
	  /**
	   * Specify whether the overlay should trigger onHide when the user clicks outside the overlay
	   */
	  rootClose: _propTypes2['default'].bool,
	  /**
	   * A callback invoked by the overlay when it wishes to be hidden. Required if
	   * `rootClose` is specified.
	   */
	  onHide: _propTypes2['default'].func,
	
	  /**
	   * Use animation
	   */
	  animation: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _elementType2['default']]),
	
	  /**
	   * Callback fired before the Overlay transitions in
	   */
	  onEnter: _propTypes2['default'].func,
	
	  /**
	   * Callback fired as the Overlay begins to transition in
	   */
	  onEntering: _propTypes2['default'].func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning in
	   */
	  onEntered: _propTypes2['default'].func,
	
	  /**
	   * Callback fired right before the Overlay transitions out
	   */
	  onExit: _propTypes2['default'].func,
	
	  /**
	   * Callback fired as the Overlay begins to transition out
	   */
	  onExiting: _propTypes2['default'].func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning out
	   */
	  onExited: _propTypes2['default'].func,
	
	  /**
	   * Sets the direction of the Overlay.
	   */
	  placement: _propTypes2['default'].oneOf(['top', 'right', 'bottom', 'left'])
	});
	
	var defaultProps = {
	  animation: _Fade2['default'],
	  rootClose: false,
	  show: false,
	  placement: 'right'
	};
	
	var Overlay = function (_React$Component) {
	  (0, _inherits3['default'])(Overlay, _React$Component);
	
	  function Overlay() {
	    (0, _classCallCheck3['default'])(this, Overlay);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Overlay.prototype.render = function render() {
	    var _props = this.props,
	        animation = _props.animation,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['animation', 'children']);
	
	
	    var transition = animation === true ? _Fade2['default'] : animation || null;
	
	    var child = void 0;
	
	    if (!transition) {
	      child = (0, _react.cloneElement)(children, {
	        className: (0, _classnames2['default'])(children.props.className, 'in')
	      });
	    } else {
	      child = children;
	    }
	
	    return _react2['default'].createElement(
	      _Overlay2['default'],
	      (0, _extends3['default'])({}, props, {
	        transition: transition
	      }),
	      child
	    );
	  };
	
	  return Overlay;
	}(_react2['default'].Component);
	
	Overlay.propTypes = propTypes;
	Overlay.defaultProps = defaultProps;
	
	exports['default'] = Overlay;
	module.exports = exports['default'];

/***/ },
/* 927 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SafeAnchor = __webpack_require__(99);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _createChainedFunction = __webpack_require__(62);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  disabled: _propTypes2['default'].bool,
	  previous: _propTypes2['default'].bool,
	  next: _propTypes2['default'].bool,
	  onClick: _propTypes2['default'].func,
	  onSelect: _propTypes2['default'].func,
	  eventKey: _propTypes2['default'].any
	};
	
	var defaultProps = {
	  disabled: false,
	  previous: false,
	  next: false
	};
	
	var PagerItem = function (_React$Component) {
	  (0, _inherits3['default'])(PagerItem, _React$Component);
	
	  function PagerItem(props, context) {
	    (0, _classCallCheck3['default'])(this, PagerItem);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleSelect = _this.handleSelect.bind(_this);
	    return _this;
	  }
	
	  PagerItem.prototype.handleSelect = function handleSelect(e) {
	    var _props = this.props,
	        disabled = _props.disabled,
	        onSelect = _props.onSelect,
	        eventKey = _props.eventKey;
	
	
	    if (onSelect || disabled) {
	      e.preventDefault();
	    }
	
	    if (disabled) {
	      return;
	    }
	
	    if (onSelect) {
	      onSelect(eventKey, e);
	    }
	  };
	
	  PagerItem.prototype.render = function render() {
	    var _props2 = this.props,
	        disabled = _props2.disabled,
	        previous = _props2.previous,
	        next = _props2.next,
	        onClick = _props2.onClick,
	        className = _props2.className,
	        style = _props2.style,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['disabled', 'previous', 'next', 'onClick', 'className', 'style']);
	
	
	    delete props.onSelect;
	    delete props.eventKey;
	
	    return _react2['default'].createElement(
	      'li',
	      {
	        className: (0, _classnames2['default'])(className, { disabled: disabled, previous: previous, next: next }),
	        style: style
	      },
	      _react2['default'].createElement(_SafeAnchor2['default'], (0, _extends3['default'])({}, props, {
	        disabled: disabled,
	        onClick: (0, _createChainedFunction2['default'])(onClick, this.handleSelect)
	      }))
	    );
	  };
	
	  return PagerItem;
	}(_react2['default'].Component);
	
	PagerItem.propTypes = propTypes;
	PagerItem.defaultProps = defaultProps;
	
	exports['default'] = PagerItem;
	module.exports = exports['default'];

/***/ },
/* 928 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(42);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _SafeAnchor = __webpack_require__(99);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _createChainedFunction = __webpack_require__(62);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: This should be `<Pagination.Item>`.
	
	// TODO: This should use `componentClass` like other components.
	
	var propTypes = {
	  componentClass: _elementType2['default'],
	  className: _propTypes2['default'].string,
	  eventKey: _propTypes2['default'].any,
	  onSelect: _propTypes2['default'].func,
	  disabled: _propTypes2['default'].bool,
	  active: _propTypes2['default'].bool,
	  onClick: _propTypes2['default'].func
	};
	
	var defaultProps = {
	  componentClass: _SafeAnchor2['default'],
	  active: false,
	  disabled: false
	};
	
	var PaginationButton = function (_React$Component) {
	  (0, _inherits3['default'])(PaginationButton, _React$Component);
	
	  function PaginationButton(props, context) {
	    (0, _classCallCheck3['default'])(this, PaginationButton);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  PaginationButton.prototype.handleClick = function handleClick(event) {
	    var _props = this.props,
	        disabled = _props.disabled,
	        onSelect = _props.onSelect,
	        eventKey = _props.eventKey;
	
	
	    if (disabled) {
	      return;
	    }
	
	    if (onSelect) {
	      onSelect(eventKey, event);
	    }
	  };
	
	  PaginationButton.prototype.render = function render() {
	    var _props2 = this.props,
	        Component = _props2.componentClass,
	        active = _props2.active,
	        disabled = _props2.disabled,
	        onClick = _props2.onClick,
	        className = _props2.className,
	        style = _props2.style,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['componentClass', 'active', 'disabled', 'onClick', 'className', 'style']);
	
	
	    if (Component === _SafeAnchor2['default']) {
	      // Assume that custom components want `eventKey`.
	      delete props.eventKey;
	    }
	
	    delete props.onSelect;
	
	    return _react2['default'].createElement(
	      'li',
	      {
	        className: (0, _classnames2['default'])(className, { active: active, disabled: disabled }),
	        style: style
	      },
	      _react2['default'].createElement(Component, (0, _extends3['default'])({}, props, {
	        disabled: disabled,
	        onClick: (0, _createChainedFunction2['default'])(onClick, this.handleClick)
	      }))
	    );
	  };
	
	  return PaginationButton;
	}(_react2['default'].Component);
	
	PaginationButton.propTypes = propTypes;
	PaginationButton.defaultProps = defaultProps;
	
	exports['default'] = PaginationButton;
	module.exports = exports['default'];

/***/ },
/* 929 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _assign = __webpack_require__(516);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(24);
	
	var _createChainedFunction = __webpack_require__(62);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _ValidComponentChildren = __webpack_require__(74);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  accordion: _propTypes2['default'].bool,
	  activeKey: _propTypes2['default'].any,
	  defaultActiveKey: _propTypes2['default'].any,
	  onSelect: _propTypes2['default'].func,
	  role: _propTypes2['default'].string
	};
	
	var defaultProps = {
	  accordion: false
	};
	
	// TODO: Use uncontrollable.
	
	var PanelGroup = function (_React$Component) {
	  (0, _inherits3['default'])(PanelGroup, _React$Component);
	
	  function PanelGroup(props, context) {
	    (0, _classCallCheck3['default'])(this, PanelGroup);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleSelect = _this.handleSelect.bind(_this);
	
	    _this.state = {
	      activeKey: props.defaultActiveKey
	    };
	    return _this;
	  }
	
	  PanelGroup.prototype.handleSelect = function handleSelect(key, e) {
	    e.preventDefault();
	
	    if (this.props.onSelect) {
	      this.props.onSelect(key, e);
	    }
	
	    if (this.state.activeKey === key) {
	      key = null;
	    }
	
	    this.setState({ activeKey: key });
	  };
	
	  PanelGroup.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        accordion = _props.accordion,
	        propsActiveKey = _props.activeKey,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['accordion', 'activeKey', 'className', 'children']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['defaultActiveKey', 'onSelect']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var activeKey = void 0;
	    if (accordion) {
	      activeKey = propsActiveKey != null ? propsActiveKey : this.state.activeKey;
	      elementProps.role = elementProps.role || 'tablist';
	    }
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      _ValidComponentChildren2['default'].map(children, function (child) {
	        var childProps = {
	          bsStyle: child.props.bsStyle || bsProps.bsStyle
	        };
	
	        if (accordion) {
	          (0, _assign2['default'])(childProps, {
	            headerRole: 'tab',
	            panelRole: 'tabpanel',
	            collapsible: true,
	            expanded: child.props.eventKey === activeKey,
	            onSelect: (0, _createChainedFunction2['default'])(_this2.handleSelect, child.props.onSelect)
	          });
	        }
	
	        return (0, _react.cloneElement)(child, childProps);
	      })
	    );
	  };
	
	  return PanelGroup;
	}(_react2['default'].Component);
	
	PanelGroup.propTypes = propTypes;
	PanelGroup.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('panel-group', PanelGroup);
	module.exports = exports['default'];

/***/ },
/* 930 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(42);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _warning = __webpack_require__(100);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(24);
	
	var _createChainedFunction = __webpack_require__(62);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _Fade = __webpack_require__(296);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Uniquely identify the `<TabPane>` among its siblings.
	   */
	  eventKey: _propTypes2['default'].any,
	
	  /**
	   * Use animation when showing or hiding `<TabPane>`s. Use `false` to disable,
	   * `true` to enable the default `<Fade>` animation or any `<Transition>`
	   * component.
	   */
	  animation: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _elementType2['default']]),
	
	  /** @private **/
	  id: _propTypes2['default'].string,
	
	  /** @private **/
	  'aria-labelledby': _propTypes2['default'].string,
	
	  /**
	   * If not explicitly specified and rendered in the context of a
	   * `<TabContent>`, the `bsClass` of the `<TabContent>` suffixed by `-pane`.
	   * If otherwise not explicitly specified, `tab-pane`.
	   */
	  bsClass: _propTypes2['default'].string,
	
	  /**
	   * Transition onEnter callback when animation is not `false`
	   */
	  onEnter: _propTypes2['default'].func,
	
	  /**
	   * Transition onEntering callback when animation is not `false`
	   */
	  onEntering: _propTypes2['default'].func,
	
	  /**
	   * Transition onEntered callback when animation is not `false`
	   */
	  onEntered: _propTypes2['default'].func,
	
	  /**
	   * Transition onExit callback when animation is not `false`
	   */
	  onExit: _propTypes2['default'].func,
	
	  /**
	   * Transition onExiting callback when animation is not `false`
	   */
	  onExiting: _propTypes2['default'].func,
	
	  /**
	   * Transition onExited callback when animation is not `false`
	   */
	  onExited: _propTypes2['default'].func,
	
	  /**
	   * Wait until the first "enter" transition to mount the tab (add it to the DOM)
	   */
	  mountOnEnter: _propTypes2['default'].bool,
	
	  /**
	   * Unmount the tab (remove it from the DOM) when it is no longer visible
	   */
	  unmountOnExit: _propTypes2['default'].bool
	};
	
	var contextTypes = {
	  $bs_tabContainer: _propTypes2['default'].shape({
	    getTabId: _propTypes2['default'].func,
	    getPaneId: _propTypes2['default'].func
	  }),
	  $bs_tabContent: _propTypes2['default'].shape({
	    bsClass: _propTypes2['default'].string,
	    animation: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _elementType2['default']]),
	    activeKey: _propTypes2['default'].any,
	    mountOnEnter: _propTypes2['default'].bool,
	    unmountOnExit: _propTypes2['default'].bool,
	    onPaneEnter: _propTypes2['default'].func.isRequired,
	    onPaneExited: _propTypes2['default'].func.isRequired,
	    exiting: _propTypes2['default'].bool.isRequired
	  })
	};
	
	/**
	 * We override the `<TabContainer>` context so `<Nav>`s in `<TabPane>`s don't
	 * conflict with the top level one.
	 */
	var childContextTypes = {
	  $bs_tabContainer: _propTypes2['default'].oneOf([null])
	};
	
	var TabPane = function (_React$Component) {
	  (0, _inherits3['default'])(TabPane, _React$Component);
	
	  function TabPane(props, context) {
	    (0, _classCallCheck3['default'])(this, TabPane);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleEnter = _this.handleEnter.bind(_this);
	    _this.handleExited = _this.handleExited.bind(_this);
	
	    _this['in'] = false;
	    return _this;
	  }
	
	  TabPane.prototype.getChildContext = function getChildContext() {
	    return {
	      $bs_tabContainer: null
	    };
	  };
	
	  TabPane.prototype.componentDidMount = function componentDidMount() {
	    if (this.shouldBeIn()) {
	      // In lieu of the action event firing.
	      this.handleEnter();
	    }
	  };
	
	  TabPane.prototype.componentDidUpdate = function componentDidUpdate() {
	    if (this['in']) {
	      if (!this.shouldBeIn()) {
	        // We shouldn't be active any more. Notify the parent.
	        this.handleExited();
	      }
	    } else if (this.shouldBeIn()) {
	      // We are the active child. Notify the parent.
	      this.handleEnter();
	    }
	  };
	
	  TabPane.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this['in']) {
	      // In lieu of the action event firing.
	      this.handleExited();
	    }
	  };
	
	  TabPane.prototype.handleEnter = function handleEnter() {
	    var tabContent = this.context.$bs_tabContent;
	    if (!tabContent) {
	      return;
	    }
	
	    this['in'] = tabContent.onPaneEnter(this, this.props.eventKey);
	  };
	
	  TabPane.prototype.handleExited = function handleExited() {
	    var tabContent = this.context.$bs_tabContent;
	    if (!tabContent) {
	      return;
	    }
	
	    tabContent.onPaneExited(this);
	    this['in'] = false;
	  };
	
	  TabPane.prototype.getAnimation = function getAnimation() {
	    if (this.props.animation != null) {
	      return this.props.animation;
	    }
	
	    var tabContent = this.context.$bs_tabContent;
	    return tabContent && tabContent.animation;
	  };
	
	  TabPane.prototype.isActive = function isActive() {
	    var tabContent = this.context.$bs_tabContent;
	    var activeKey = tabContent && tabContent.activeKey;
	
	    return this.props.eventKey === activeKey;
	  };
	
	  TabPane.prototype.shouldBeIn = function shouldBeIn() {
	    return this.getAnimation() && this.isActive();
	  };
	
	  TabPane.prototype.render = function render() {
	    var _props = this.props,
	        eventKey = _props.eventKey,
	        className = _props.className,
	        onEnter = _props.onEnter,
	        onEntering = _props.onEntering,
	        onEntered = _props.onEntered,
	        onExit = _props.onExit,
	        onExiting = _props.onExiting,
	        onExited = _props.onExited,
	        propsMountOnEnter = _props.mountOnEnter,
	        propsUnmountOnExit = _props.unmountOnExit,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['eventKey', 'className', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited', 'mountOnEnter', 'unmountOnExit']);
	    var _context = this.context,
	        tabContent = _context.$bs_tabContent,
	        tabContainer = _context.$bs_tabContainer;
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['animation']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var active = this.isActive();
	    var animation = this.getAnimation();
	
	    var mountOnEnter = propsMountOnEnter != null ? propsMountOnEnter : tabContent && tabContent.mountOnEnter;
	    var unmountOnExit = propsUnmountOnExit != null ? propsUnmountOnExit : tabContent && tabContent.unmountOnExit;
	
	    if (!active && !animation && unmountOnExit) {
	      return null;
	    }
	
	    var Transition = animation === true ? _Fade2['default'] : animation || null;
	
	    if (tabContent) {
	      bsProps.bsClass = (0, _bootstrapUtils.prefix)(tabContent, 'pane');
	    }
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      active: active
	    });
	
	    if (tabContainer) {
	       false ? (0, _warning2['default'])(!elementProps.id && !elementProps['aria-labelledby'], 'In the context of a `<TabContainer>`, `<TabPanes>` are given ' + 'generated `id` and `aria-labelledby` attributes for the sake of ' + 'proper component accessibility. Any provided ones will be ignored. ' + 'To control these attributes directly provide a `generateChildId` ' + 'prop to the parent `<TabContainer>`.') : void 0;
	
	      elementProps.id = tabContainer.getPaneId(eventKey);
	      elementProps['aria-labelledby'] = tabContainer.getTabId(eventKey);
	    }
	
	    var pane = _react2['default'].createElement('div', (0, _extends3['default'])({}, elementProps, {
	      role: 'tabpanel',
	      'aria-hidden': !active,
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	
	    if (Transition) {
	      var exiting = tabContent && tabContent.exiting;
	
	      return _react2['default'].createElement(
	        Transition,
	        {
	          'in': active && !exiting,
	          onEnter: (0, _createChainedFunction2['default'])(this.handleEnter, onEnter),
	          onEntering: onEntering,
	          onEntered: onEntered,
	          onExit: onExit,
	          onExiting: onExiting,
	          onExited: (0, _createChainedFunction2['default'])(this.handleExited, onExited),
	          mountOnEnter: mountOnEnter,
	          unmountOnExit: unmountOnExit
	        },
	        pane
	      );
	    }
	
	    return pane;
	  };
	
	  return TabPane;
	}(_react2['default'].Component);
	
	TabPane.propTypes = propTypes;
	TabPane.contextTypes = contextTypes;
	TabPane.childContextTypes = childContextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('tab-pane', TabPane);
	module.exports = exports['default'];

/***/ },
/* 931 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = capitalize;
	function capitalize(string) {
	  return "" + string.charAt(0).toUpperCase() + string.slice(1);
	}
	module.exports = exports["default"];

/***/ },
/* 932 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = log;
	
	/*eslint no-console:0*/
	function log() {
	  var _console;
	
	  if (undefined) (_console = console).log.apply(_console, arguments);
	}

/***/ },
/* 933 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.canDragX = canDragX;
	exports.canDragY = canDragY;
	exports.createCoreData = createCoreData;
	exports.createDraggableData = createDraggableData;
	exports.getBoundPosition = getBoundPosition;
	exports.getControlPosition = getControlPosition;
	exports.snapToGrid = snapToGrid;
	
	var _shims = __webpack_require__(299);
	
	var _domFns = __webpack_require__(463);
	
	function getBoundPosition(draggable
	/*: Draggable*/
	, x
	/*: number*/
	, y
	/*: number*/
	)
	/*: [number, number]*/
	{
	  // If no bounds, short-circuit and move on
	  if (!draggable.props.bounds) return [x, y]; // Clone new bounds
	
	  var bounds = draggable.props.bounds;
	  bounds = typeof bounds === 'string' ? bounds : cloneBounds(bounds);
	  var node = findDOMNode(draggable);
	
	  if (typeof bounds === 'string') {
	    var ownerDocument = node.ownerDocument;
	    var ownerWindow = ownerDocument.defaultView;
	    var boundNode;
	
	    if (bounds === 'parent') {
	      boundNode = node.parentNode;
	    } else {
	      boundNode = ownerDocument.querySelector(bounds);
	    }
	
	    if (!(boundNode instanceof ownerWindow.HTMLElement)) {
	      throw new Error('Bounds selector "' + bounds + '" could not find an element.');
	    }
	
	    var boundNodeEl
	    /*: HTMLElement*/
	    = boundNode; // for Flow, can't seem to refine correctly
	
	    var nodeStyle = ownerWindow.getComputedStyle(node);
	    var boundNodeStyle = ownerWindow.getComputedStyle(boundNodeEl); // Compute bounds. This is a pain with padding and offsets but this gets it exactly right.
	
	    bounds = {
	      left: -node.offsetLeft + (0, _shims.int)(boundNodeStyle.paddingLeft) + (0, _shims.int)(nodeStyle.marginLeft),
	      top: -node.offsetTop + (0, _shims.int)(boundNodeStyle.paddingTop) + (0, _shims.int)(nodeStyle.marginTop),
	      right: (0, _domFns.innerWidth)(boundNodeEl) - (0, _domFns.outerWidth)(node) - node.offsetLeft + (0, _shims.int)(boundNodeStyle.paddingRight) - (0, _shims.int)(nodeStyle.marginRight),
	      bottom: (0, _domFns.innerHeight)(boundNodeEl) - (0, _domFns.outerHeight)(node) - node.offsetTop + (0, _shims.int)(boundNodeStyle.paddingBottom) - (0, _shims.int)(nodeStyle.marginBottom)
	    };
	  } // Keep x and y below right and bottom limits...
	
	
	  if ((0, _shims.isNum)(bounds.right)) x = Math.min(x, bounds.right);
	  if ((0, _shims.isNum)(bounds.bottom)) y = Math.min(y, bounds.bottom); // But above left and top limits.
	
	  if ((0, _shims.isNum)(bounds.left)) x = Math.max(x, bounds.left);
	  if ((0, _shims.isNum)(bounds.top)) y = Math.max(y, bounds.top);
	  return [x, y];
	}
	
	function snapToGrid(grid
	/*: [number, number]*/
	, pendingX
	/*: number*/
	, pendingY
	/*: number*/
	)
	/*: [number, number]*/
	{
	  var x = Math.round(pendingX / grid[0]) * grid[0];
	  var y = Math.round(pendingY / grid[1]) * grid[1];
	  return [x, y];
	}
	
	function canDragX(draggable
	/*: Draggable*/
	)
	/*: boolean*/
	{
	  return draggable.props.axis === 'both' || draggable.props.axis === 'x';
	}
	
	function canDragY(draggable
	/*: Draggable*/
	)
	/*: boolean*/
	{
	  return draggable.props.axis === 'both' || draggable.props.axis === 'y';
	} // Get {x, y} positions from event.
	
	
	function getControlPosition(e
	/*: MouseTouchEvent*/
	, touchIdentifier
	/*: ?number*/
	, draggableCore
	/*: DraggableCore*/
	)
	/*: ?ControlPosition*/
	{
	  var touchObj = typeof touchIdentifier === 'number' ? (0, _domFns.getTouch)(e, touchIdentifier) : null;
	  if (typeof touchIdentifier === 'number' && !touchObj) return null; // not the right touch
	
	  var node = findDOMNode(draggableCore); // User can provide an offsetParent if desired.
	
	  var offsetParent = draggableCore.props.offsetParent || node.offsetParent || node.ownerDocument.body;
	  return (0, _domFns.offsetXYFromParent)(touchObj || e, offsetParent, draggableCore.props.scale);
	} // Create an data object exposed by <DraggableCore>'s events
	
	
	function createCoreData(draggable
	/*: DraggableCore*/
	, x
	/*: number*/
	, y
	/*: number*/
	)
	/*: DraggableData*/
	{
	  var state = draggable.state;
	  var isStart = !(0, _shims.isNum)(state.lastX);
	  var node = findDOMNode(draggable);
	
	  if (isStart) {
	    // If this is our first move, use the x and y as last coords.
	    return {
	      node: node,
	      deltaX: 0,
	      deltaY: 0,
	      lastX: x,
	      lastY: y,
	      x: x,
	      y: y
	    };
	  } else {
	    // Otherwise calculate proper values.
	    return {
	      node: node,
	      deltaX: x - state.lastX,
	      deltaY: y - state.lastY,
	      lastX: state.lastX,
	      lastY: state.lastY,
	      x: x,
	      y: y
	    };
	  }
	} // Create an data exposed by <Draggable>'s events
	
	
	function createDraggableData(draggable
	/*: Draggable*/
	, coreData
	/*: DraggableData*/
	)
	/*: DraggableData*/
	{
	  var scale = draggable.props.scale;
	  return {
	    node: coreData.node,
	    x: draggable.state.x + coreData.deltaX / scale,
	    y: draggable.state.y + coreData.deltaY / scale,
	    deltaX: coreData.deltaX / scale,
	    deltaY: coreData.deltaY / scale,
	    lastX: draggable.state.x,
	    lastY: draggable.state.y
	  };
	} // A lot faster than stringify/parse
	
	
	function cloneBounds(bounds
	/*: Bounds*/
	)
	/*: Bounds*/
	{
	  return {
	    left: bounds.left,
	    top: bounds.top,
	    right: bounds.right,
	    bottom: bounds.bottom
	  };
	}
	
	function findDOMNode(draggable
	/*: Draggable | DraggableCore*/
	)
	/*: HTMLElement*/
	{
	  var node = draggable.findDOMNode();
	
	  if (!node) {
	    throw new Error('<DraggableCore>: Unmounted during event!');
	  } // $FlowIgnore we can't assert on HTMLElement due to tests... FIXME
	
	
	  return node;
	}

/***/ },
/* 934 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.useSSR = useSSR;
	
	var _react = __webpack_require__(1);
	
	var _context = __webpack_require__(184);
	
	function useSSR(initialI18nStore, initialLanguage) {
	  var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var i18nFromProps = props.i18n;
	
	  var _ref = (0, _react.useContext)(_context.I18nContext) || {},
	      i18nFromContext = _ref.i18n;
	
	  var i18n = i18nFromProps || i18nFromContext || (0, _context.getI18n)();
	  if (i18n.options && i18n.options.isClone) return;
	
	  if (initialI18nStore && !i18n.initializedStoreOnce) {
	    i18n.services.resourceStore.data = initialI18nStore;
	    i18n.options.ns = Object.values(initialI18nStore).reduce(function (mem, lngResources) {
	      Object.keys(lngResources).forEach(function (ns) {
	        if (mem.indexOf(ns) < 0) mem.push(ns);
	      });
	      return mem;
	    }, i18n.options.ns);
	    i18n.initializedStoreOnce = true;
	    i18n.isInitialized = true;
	  }
	
	  if (initialLanguage && !i18n.initializedLanguageOnce) {
	    i18n.changeLanguage(initialLanguage);
	    i18n.initializedLanguageOnce = true;
	  }
	}

/***/ },
/* 935 */
[2772, 2280],
/* 936 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.resetState = resetState;
	exports.log = log;
	exports.assertNodeList = assertNodeList;
	exports.setElement = setElement;
	exports.validateElement = validateElement;
	exports.hide = hide;
	exports.show = show;
	exports.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;
	
	var _warning = __webpack_require__(319);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _safeHTMLElement = __webpack_require__(465);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var globalElement = null;
	
	/* eslint-disable no-console */
	/* istanbul ignore next */
	function resetState() {
	  if (globalElement) {
	    if (globalElement.removeAttribute) {
	      globalElement.removeAttribute("aria-hidden");
	    } else if (globalElement.length != null) {
	      globalElement.forEach(function (element) {
	        return element.removeAttribute("aria-hidden");
	      });
	    } else {
	      document.querySelectorAll(globalElement).forEach(function (element) {
	        return element.removeAttribute("aria-hidden");
	      });
	    }
	  }
	  globalElement = null;
	}
	
	/* istanbul ignore next */
	function log() {
	  if (false) {
	    var check = globalElement || {};
	    console.log("ariaAppHider ----------");
	    console.log(check.nodeName, check.className, check.id);
	    console.log("end ariaAppHider ----------");
	  }
	}
	/* eslint-enable no-console */
	
	function assertNodeList(nodeList, selector) {
	  if (!nodeList || !nodeList.length) {
	    throw new Error("react-modal: No elements were found for selector " + selector + ".");
	  }
	}
	
	function setElement(element) {
	  var useElement = element;
	  if (typeof useElement === "string" && _safeHTMLElement.canUseDOM) {
	    var el = document.querySelectorAll(useElement);
	    assertNodeList(el, useElement);
	    useElement = el;
	  }
	  globalElement = useElement || globalElement;
	  return globalElement;
	}
	
	function validateElement(appElement) {
	  var el = appElement || globalElement;
	  if (el) {
	    return Array.isArray(el) || el instanceof HTMLCollection || el instanceof NodeList ? el : [el];
	  } else {
	    (0, _warning2.default)(false, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" "));
	
	    return [];
	  }
	}
	
	function hide(appElement) {
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = validateElement(appElement)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var el = _step.value;
	
	      el.setAttribute("aria-hidden", "true");
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	}
	
	function show(appElement) {
	  var _iteratorNormalCompletion2 = true;
	  var _didIteratorError2 = false;
	  var _iteratorError2 = undefined;
	
	  try {
	    for (var _iterator2 = validateElement(appElement)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	      var el = _step2.value;
	
	      el.removeAttribute("aria-hidden");
	    }
	  } catch (err) {
	    _didIteratorError2 = true;
	    _iteratorError2 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion2 && _iterator2.return) {
	        _iterator2.return();
	      }
	    } finally {
	      if (_didIteratorError2) {
	        throw _iteratorError2;
	      }
	    }
	  }
	}
	
	function documentNotReadyOrSSRTesting() {
	  globalElement = null;
	}

/***/ },
/* 937 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.log = log;
	exports.resetState = resetState;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// Tracks portals that are open and emits events to subscribers
	
	var PortalOpenInstances = function PortalOpenInstances() {
	  var _this = this;
	
	  _classCallCheck(this, PortalOpenInstances);
	
	  this.register = function (openInstance) {
	    if (_this.openInstances.indexOf(openInstance) !== -1) {
	      if (false) {
	        // eslint-disable-next-line no-console
	        console.warn("React-Modal: Cannot register modal instance that's already open");
	      }
	      return;
	    }
	    _this.openInstances.push(openInstance);
	    _this.emit("register");
	  };
	
	  this.deregister = function (openInstance) {
	    var index = _this.openInstances.indexOf(openInstance);
	    if (index === -1) {
	      if (false) {
	        // eslint-disable-next-line no-console
	        console.warn("React-Modal: Unable to deregister " + openInstance + " as " + "it was never registered");
	      }
	      return;
	    }
	    _this.openInstances.splice(index, 1);
	    _this.emit("deregister");
	  };
	
	  this.subscribe = function (callback) {
	    _this.subscribers.push(callback);
	  };
	
	  this.emit = function (eventType) {
	    _this.subscribers.forEach(function (subscriber) {
	      return subscriber(eventType,
	      // shallow copy to avoid accidental mutation
	      _this.openInstances.slice());
	    });
	  };
	
	  this.openInstances = [];
	  this.subscribers = [];
	};
	
	var portalOpenInstances = new PortalOpenInstances();
	
	/* eslint-disable no-console */
	/* istanbul ignore next */
	function log() {
	  console.log("portalOpenInstances ----------");
	  console.log(portalOpenInstances.openInstances.length);
	  portalOpenInstances.openInstances.forEach(function (p) {
	    return console.log(p);
	  });
	  console.log("end portalOpenInstances ----------");
	}
	
	/* istanbul ignore next */
	function resetState() {
	  portalOpenInstances = new PortalOpenInstances();
	}
	/* eslint-enable no-console */
	
	exports.default = portalOpenInstances;

/***/ },
/* 938 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = findTabbableDescendants;
	/*!
	 * Adapted from jQuery UI core
	 *
	 * http://jqueryui.com
	 *
	 * Copyright 2014 jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/category/ui-core/
	 */
	
	var tabbableNode = /input|select|textarea|button|object/;
	
	function hidesContents(element) {
	  var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;
	
	  // If the node is empty, this is good enough
	  if (zeroSize && !element.innerHTML) return true;
	
	  try {
	    // Otherwise we need to check some styles
	    var style = window.getComputedStyle(element);
	    return zeroSize ? style.getPropertyValue("overflow") !== "visible" ||
	    // if 'overflow: visible' set, check if there is actually any overflow
	    element.scrollWidth <= 0 && element.scrollHeight <= 0 : style.getPropertyValue("display") == "none";
	  } catch (exception) {
	    // eslint-disable-next-line no-console
	    console.warn("Failed to inspect element style");
	    return false;
	  }
	}
	
	function visible(element) {
	  var parentElement = element;
	  var rootNode = element.getRootNode && element.getRootNode();
	  while (parentElement) {
	    if (parentElement === document.body) break;
	
	    // if we are not hidden yet, skip to checking outside the Web Component
	    if (rootNode && parentElement === rootNode) parentElement = rootNode.host.parentNode;
	
	    if (hidesContents(parentElement)) return false;
	    parentElement = parentElement.parentNode;
	  }
	  return true;
	}
	
	function focusable(element, isTabIndexNotNaN) {
	  var nodeName = element.nodeName.toLowerCase();
	  var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
	  return res && visible(element);
	}
	
	function tabbable(element) {
	  var tabIndex = element.getAttribute("tabindex");
	  if (tabIndex === null) tabIndex = undefined;
	  var isTabIndexNaN = isNaN(tabIndex);
	  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
	}
	
	function findTabbableDescendants(element) {
	  var descendants = [].slice.call(element.querySelectorAll("*"), 0).reduce(function (finished, el) {
	    return finished.concat(!el.shadowRoot ? [el] : findTabbableDescendants(el.shadowRoot));
	  }, []);
	  return descendants.filter(tabbable);
	}
	module.exports = exports["default"];

/***/ },
/* 939 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Modal = __webpack_require__(2281);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Modal2.default;
	module.exports = exports["default"];

/***/ },
/* 940 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var react = __webpack_require__(1);
	var reactDom = __webpack_require__(31);
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	function _objectWithoutProperties(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  if (Object.getOwnPropertySymbols) {
	    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
	
	    for (i = 0; i < sourceSymbolKeys.length; i++) {
	      key = sourceSymbolKeys[i];
	      if (excluded.indexOf(key) >= 0) continue;
	      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
	      target[key] = source[key];
	    }
	  }
	
	  return target;
	}
	
	/**
	 * Check whether some DOM node is our Component's node.
	 */
	function isNodeFound(current, componentNode, ignoreClass) {
	  if (current === componentNode) {
	    return true;
	  } // SVG <use/> elements do not technically reside in the rendered DOM, so
	  // they do not have classList directly, but they offer a link to their
	  // corresponding element, which can have classList. This extra check is for
	  // that case.
	  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
	  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17
	
	
	  if (current.correspondingElement) {
	    return current.correspondingElement.classList.contains(ignoreClass);
	  }
	
	  return current.classList.contains(ignoreClass);
	}
	/**
	 * Try to find our node in a hierarchy of nodes, returning the document
	 * node as highest node if our node is not found in the path up.
	 */
	
	function findHighest(current, componentNode, ignoreClass) {
	  if (current === componentNode) {
	    return true;
	  } // If source=local then this event came from 'somewhere'
	  // inside and should be ignored. We could handle this with
	  // a layered approach, too, but that requires going back to
	  // thinking in terms of Dom node nesting, running counter
	  // to React's 'you shouldn't care about the DOM' philosophy.
	
	
	  while (current.parentNode) {
	    if (isNodeFound(current, componentNode, ignoreClass)) {
	      return true;
	    }
	
	    current = current.parentNode;
	  }
	
	  return current;
	}
	/**
	 * Check if the browser scrollbar was clicked
	 */
	
	function clickedScrollbar(evt) {
	  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
	}
	
	// ideally will get replaced with external dep
	// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
	var testPassiveEventSupport = function testPassiveEventSupport() {
	  if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
	    return;
	  }
	
	  var passive = false;
	  var options = Object.defineProperty({}, 'passive', {
	    get: function get() {
	      passive = true;
	    }
	  });
	
	  var noop = function noop() {};
	
	  window.addEventListener('testPassiveEventSupport', noop, options);
	  window.removeEventListener('testPassiveEventSupport', noop, options);
	  return passive;
	};
	
	function autoInc(seed) {
	  if (seed === void 0) {
	    seed = 0;
	  }
	
	  return function () {
	    return ++seed;
	  };
	}
	
	var uid = autoInc();
	
	var passiveEventSupport;
	var handlersMap = {};
	var enabledInstances = {};
	var touchEvents = ['touchstart', 'touchmove'];
	var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
	/**
	 * Options for addEventHandler and removeEventHandler
	 */
	
	function getEventHandlerOptions(instance, eventName) {
	  var handlerOptions = null;
	  var isTouchEvent = touchEvents.indexOf(eventName) !== -1;
	
	  if (isTouchEvent && passiveEventSupport) {
	    handlerOptions = {
	      passive: !instance.props.preventDefault
	    };
	  }
	
	  return handlerOptions;
	}
	/**
	 * This function generates the HOC function that you'll use
	 * in order to impart onOutsideClick listening to an
	 * arbitrary component. It gets called at the end of the
	 * bootstrapping code to yield an instance of the
	 * onClickOutsideHOC function defined inside setupHOC().
	 */
	
	
	function onClickOutsideHOC(WrappedComponent, config) {
	  var _class, _temp;
	
	  var componentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  return _temp = _class =
	  /*#__PURE__*/
	  function (_Component) {
	    _inheritsLoose(onClickOutside, _Component);
	
	    function onClickOutside(props) {
	      var _this;
	
	      _this = _Component.call(this, props) || this;
	
	      _this.__outsideClickHandler = function (event) {
	        if (typeof _this.__clickOutsideHandlerProp === 'function') {
	          _this.__clickOutsideHandlerProp(event);
	
	          return;
	        }
	
	        var instance = _this.getInstance();
	
	        if (typeof instance.props.handleClickOutside === 'function') {
	          instance.props.handleClickOutside(event);
	          return;
	        }
	
	        if (typeof instance.handleClickOutside === 'function') {
	          instance.handleClickOutside(event);
	          return;
	        }
	
	        throw new Error("WrappedComponent: " + componentName + " lacks a handleClickOutside(event) function for processing outside click events.");
	      };
	
	      _this.__getComponentNode = function () {
	        var instance = _this.getInstance();
	
	        if (config && typeof config.setClickOutsideRef === 'function') {
	          return config.setClickOutsideRef()(instance);
	        }
	
	        if (typeof instance.setClickOutsideRef === 'function') {
	          return instance.setClickOutsideRef();
	        }
	
	        return reactDom.findDOMNode(instance);
	      };
	
	      _this.enableOnClickOutside = function () {
	        if (typeof document === 'undefined' || enabledInstances[_this._uid]) {
	          return;
	        }
	
	        if (typeof passiveEventSupport === 'undefined') {
	          passiveEventSupport = testPassiveEventSupport();
	        }
	
	        enabledInstances[_this._uid] = true;
	        var events = _this.props.eventTypes;
	
	        if (!events.forEach) {
	          events = [events];
	        }
	
	        handlersMap[_this._uid] = function (event) {
	          if (_this.componentNode === null) return;
	
	          if (_this.props.preventDefault) {
	            event.preventDefault();
	          }
	
	          if (_this.props.stopPropagation) {
	            event.stopPropagation();
	          }
	
	          if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
	          var current = event.target;
	
	          if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
	            return;
	          }
	
	          _this.__outsideClickHandler(event);
	        };
	
	        events.forEach(function (eventName) {
	          document.addEventListener(eventName, handlersMap[_this._uid], getEventHandlerOptions(_this, eventName));
	        });
	      };
	
	      _this.disableOnClickOutside = function () {
	        delete enabledInstances[_this._uid];
	        var fn = handlersMap[_this._uid];
	
	        if (fn && typeof document !== 'undefined') {
	          var events = _this.props.eventTypes;
	
	          if (!events.forEach) {
	            events = [events];
	          }
	
	          events.forEach(function (eventName) {
	            return document.removeEventListener(eventName, fn, getEventHandlerOptions(_this, eventName));
	          });
	          delete handlersMap[_this._uid];
	        }
	      };
	
	      _this.getRef = function (ref) {
	        return _this.instanceRef = ref;
	      };
	
	      _this._uid = uid();
	      return _this;
	    }
	    /**
	     * Access the WrappedComponent's instance.
	     */
	
	
	    var _proto = onClickOutside.prototype;
	
	    _proto.getInstance = function getInstance() {
	      if (!WrappedComponent.prototype.isReactComponent) {
	        return this;
	      }
	
	      var ref = this.instanceRef;
	      return ref.getInstance ? ref.getInstance() : ref;
	    };
	
	    /**
	     * Add click listeners to the current document,
	     * linked to this component's state.
	     */
	    _proto.componentDidMount = function componentDidMount() {
	      // If we are in an environment without a DOM such
	      // as shallow rendering or snapshots then we exit
	      // early to prevent any unhandled errors being thrown.
	      if (typeof document === 'undefined' || !document.createElement) {
	        return;
	      }
	
	      var instance = this.getInstance();
	
	      if (config && typeof config.handleClickOutside === 'function') {
	        this.__clickOutsideHandlerProp = config.handleClickOutside(instance);
	
	        if (typeof this.__clickOutsideHandlerProp !== 'function') {
	          throw new Error("WrappedComponent: " + componentName + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
	        }
	      }
	
	      this.componentNode = this.__getComponentNode(); // return early so we dont initiate onClickOutside
	
	      if (this.props.disableOnClickOutside) return;
	      this.enableOnClickOutside();
	    };
	
	    _proto.componentDidUpdate = function componentDidUpdate() {
	      this.componentNode = this.__getComponentNode();
	    };
	    /**
	     * Remove all document's event listeners for this component
	     */
	
	
	    _proto.componentWillUnmount = function componentWillUnmount() {
	      this.disableOnClickOutside();
	    };
	    /**
	     * Can be called to explicitly enable event listening
	     * for clicks and touches outside of this element.
	     */
	
	
	    /**
	     * Pass-through render
	     */
	    _proto.render = function render() {
	      // eslint-disable-next-line no-unused-vars
	      var _props = this.props,
	          excludeScrollbar = _props.excludeScrollbar,
	          props = _objectWithoutProperties(_props, ["excludeScrollbar"]);
	
	      if (WrappedComponent.prototype.isReactComponent) {
	        props.ref = this.getRef;
	      } else {
	        props.wrappedRef = this.getRef;
	      }
	
	      props.disableOnClickOutside = this.disableOnClickOutside;
	      props.enableOnClickOutside = this.enableOnClickOutside;
	      return react.createElement(WrappedComponent, props);
	    };
	
	    return onClickOutside;
	  }(react.Component), _class.displayName = "OnClickOutside(" + componentName + ")", _class.defaultProps = {
	    eventTypes: ['mousedown', 'touchstart'],
	    excludeScrollbar: config && config.excludeScrollbar || false,
	    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
	    preventDefault: false,
	    stopPropagation: false
	  }, _class.getClass = function () {
	    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
	  }, _temp;
	}
	
	exports.IGNORE_CLASS_NAME = IGNORE_CLASS_NAME;
	exports['default'] = onClickOutsideHOC;


/***/ },
/* 941 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _componentOrElement = __webpack_require__(294);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _getContainer = __webpack_require__(301);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	var _ownerDocument = __webpack_require__(185);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	var _LegacyPortal = __webpack_require__(2287);
	
	var _LegacyPortal2 = _interopRequireDefault(_LegacyPortal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
	 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
	 * The children of `<Portal/>` component will be appended to the `container` specified.
	 */
	var Portal = function (_React$Component) {
	  _inherits(Portal, _React$Component);
	
	  function Portal() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Portal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.setContainer = function () {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;
	
	      _this._portalContainerNode = (0, _getContainer2.default)(props.container, (0, _ownerDocument2.default)(_this).body);
	    }, _this.getMountNode = function () {
	      return _this._portalContainerNode;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Portal.prototype.componentDidMount = function componentDidMount() {
	    this.setContainer();
	    this.forceUpdate(this.props.onRendered);
	  };
	
	  Portal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.container !== this.props.container) {
	      this.setContainer(nextProps);
	    }
	  };
	
	  Portal.prototype.componentWillUnmount = function componentWillUnmount() {
	    this._portalContainerNode = null;
	  };
	
	  Portal.prototype.render = function render() {
	    return this.props.children && this._portalContainerNode ? _reactDom2.default.createPortal(this.props.children, this._portalContainerNode) : null;
	  };
	
	  return Portal;
	}(_react2.default.Component);
	
	Portal.displayName = 'Portal';
	Portal.propTypes = {
	  /**
	   * A Node, Component instance, or function that returns either. The `container` will have the Portal children
	   * appended to it.
	   */
	  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
	
	  onRendered: _propTypes2.default.func
	};
	exports.default = _reactDom2.default.createPortal ? Portal : _LegacyPortal2.default;
	module.exports = exports['default'];

/***/ },
/* 942 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _contains = __webpack_require__(174);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _addEventListener = __webpack_require__(944);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _ownerDocument = __webpack_require__(185);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var escapeKeyCode = 27;
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	/**
	 * The `<RootCloseWrapper/>` component registers your callback on the document
	 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
	 * style behavior where your callback is triggered when the user tries to
	 * interact with the rest of the document or hits the `esc` key.
	 */
	
	var RootCloseWrapper = function (_React$Component) {
	  _inherits(RootCloseWrapper, _React$Component);
	
	  function RootCloseWrapper(props, context) {
	    _classCallCheck(this, RootCloseWrapper);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.addEventListeners = function () {
	      var event = _this.props.event;
	
	      var doc = (0, _ownerDocument2.default)(_this);
	
	      // Use capture for this listener so it fires before React's listener, to
	      // avoid false positives in the contains() check below if the target DOM
	      // element is removed in the React mouse callback.
	      _this.documentMouseCaptureListener = (0, _addEventListener2.default)(doc, event, _this.handleMouseCapture, true);
	
	      _this.documentMouseListener = (0, _addEventListener2.default)(doc, event, _this.handleMouse);
	
	      _this.documentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', _this.handleKeyUp);
	    };
	
	    _this.removeEventListeners = function () {
	      if (_this.documentMouseCaptureListener) {
	        _this.documentMouseCaptureListener.remove();
	      }
	
	      if (_this.documentMouseListener) {
	        _this.documentMouseListener.remove();
	      }
	
	      if (_this.documentKeyupListener) {
	        _this.documentKeyupListener.remove();
	      }
	    };
	
	    _this.handleMouseCapture = function (e) {
	      _this.preventMouseRootClose = isModifiedEvent(e) || !isLeftClickEvent(e) || (0, _contains2.default)(_reactDom2.default.findDOMNode(_this), e.target);
	    };
	
	    _this.handleMouse = function (e) {
	      if (!_this.preventMouseRootClose && _this.props.onRootClose) {
	        _this.props.onRootClose(e);
	      }
	    };
	
	    _this.handleKeyUp = function (e) {
	      if (e.keyCode === escapeKeyCode && _this.props.onRootClose) {
	        _this.props.onRootClose(e);
	      }
	    };
	
	    _this.preventMouseRootClose = false;
	    return _this;
	  }
	
	  RootCloseWrapper.prototype.componentDidMount = function componentDidMount() {
	    if (!this.props.disabled) {
	      this.addEventListeners();
	    }
	  };
	
	  RootCloseWrapper.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (!this.props.disabled && prevProps.disabled) {
	      this.addEventListeners();
	    } else if (this.props.disabled && !prevProps.disabled) {
	      this.removeEventListeners();
	    }
	  };
	
	  RootCloseWrapper.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (!this.props.disabled) {
	      this.removeEventListeners();
	    }
	  };
	
	  RootCloseWrapper.prototype.render = function render() {
	    return this.props.children;
	  };
	
	  return RootCloseWrapper;
	}(_react2.default.Component);
	
	RootCloseWrapper.displayName = 'RootCloseWrapper';
	
	RootCloseWrapper.propTypes = {
	  /**
	   * Callback fired after click or mousedown. Also triggers when user hits `esc`.
	   */
	  onRootClose: _propTypes2.default.func,
	  /**
	   * Children to render.
	   */
	  children: _propTypes2.default.element,
	  /**
	   * Disable the the RootCloseWrapper, preventing it from triggering `onRootClose`.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * Choose which document mouse event to bind to.
	   */
	  event: _propTypes2.default.oneOf(['click', 'mousedown'])
	};
	
	RootCloseWrapper.defaultProps = {
	  event: 'click'
	};
	
	exports.default = RootCloseWrapper;
	module.exports = exports['default'];

/***/ },
/* 943 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _on = __webpack_require__(271);
	
	var _on2 = _interopRequireDefault(_on);
	
	var _properties = __webpack_require__(678);
	
	var _properties2 = _interopRequireDefault(_properties);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var transitionEndEvent = _properties2.default.end;
	
	var UNMOUNTED = exports.UNMOUNTED = 0;
	var EXITED = exports.EXITED = 1;
	var ENTERING = exports.ENTERING = 2;
	var ENTERED = exports.ENTERED = 3;
	var EXITING = exports.EXITING = 4;
	
	/**
	 * The Transition component lets you define and run css transitions with a simple declarative api.
	 * It works similar to React's own [CSSTransitionGroup](http://facebook.github.io/react/docs/animation.html#high-level-api-reactcsstransitiongroup)
	 * but is specifically optimized for transitioning a single child "in" or "out".
	 *
	 * You don't even need to use class based css transitions if you don't want to (but it is easiest).
	 * The extensive set of lifecycle callbacks means you have control over
	 * the transitioning now at each step of the way.
	 */
	
	var Transition = function (_React$Component) {
	  _inherits(Transition, _React$Component);
	
	  function Transition(props, context) {
	    _classCallCheck(this, Transition);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.updateStatus = function () {
	      if (_this.nextStatus !== null) {
	        // nextStatus will always be ENTERING or EXITING.
	        _this.cancelNextCallback();
	        var node = _reactDom2.default.findDOMNode(_this);
	
	        if (_this.nextStatus === ENTERING) {
	          _this.props.onEnter(node);
	
	          _this.safeSetState({ status: ENTERING }, function () {
	            _this.props.onEntering(node);
	
	            _this.onTransitionEnd(node, function () {
	              _this.safeSetState({ status: ENTERED }, function () {
	                _this.props.onEntered(node);
	              });
	            });
	          });
	        } else {
	          _this.props.onExit(node);
	
	          _this.safeSetState({ status: EXITING }, function () {
	            _this.props.onExiting(node);
	
	            _this.onTransitionEnd(node, function () {
	              _this.safeSetState({ status: EXITED }, function () {
	                _this.props.onExited(node);
	              });
	            });
	          });
	        }
	
	        _this.nextStatus = null;
	      } else if (_this.props.unmountOnExit && _this.state.status === EXITED) {
	        _this.setState({ status: UNMOUNTED });
	      }
	    };
	
	    _this.cancelNextCallback = function () {
	      if (_this.nextCallback !== null) {
	        _this.nextCallback.cancel();
	        _this.nextCallback = null;
	      }
	    };
	
	    _this.safeSetState = function (nextState, callback) {
	      // This shouldn't be necessary, but there are weird race conditions with
	      // setState callbacks and unmounting in testing, so always make sure that
	      // we can cancel any pending setState callbacks after we unmount.
	      _this.setState(nextState, _this.setNextCallback(callback));
	    };
	
	    _this.setNextCallback = function (callback) {
	      var active = true;
	
	      _this.nextCallback = function (event) {
	        if (active) {
	          active = false;
	          _this.nextCallback = null;
	
	          callback(event);
	        }
	      };
	
	      _this.nextCallback.cancel = function () {
	        active = false;
	      };
	
	      return _this.nextCallback;
	    };
	
	    _this.onTransitionEnd = function (node, handler) {
	      _this.setNextCallback(handler);
	
	      if (node) {
	        (0, _on2.default)(node, transitionEndEvent, _this.nextCallback);
	        setTimeout(_this.nextCallback, _this.props.timeout);
	      } else {
	        setTimeout(_this.nextCallback, 0);
	      }
	    };
	
	    var initialStatus = void 0;
	    _this.nextStatus = null;
	
	    if (props.in) {
	      if (props.transitionAppear) {
	        initialStatus = EXITED;
	        _this.nextStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }
	
	    _this.state = { status: initialStatus };
	
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  Transition.prototype.componentDidMount = function componentDidMount() {
	    this.updateStatus();
	  };
	
	  Transition.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var status = this.state.status;
	
	
	    if (nextProps.in) {
	      if (status === UNMOUNTED) {
	        this.setState({ status: EXITED });
	      }
	      if (status !== ENTERING && status !== ENTERED) {
	        this.nextStatus = ENTERING;
	      }
	    } else {
	      if (status === ENTERING || status === ENTERED) {
	        this.nextStatus = EXITING;
	      }
	    }
	  };
	
	  Transition.prototype.componentDidUpdate = function componentDidUpdate() {
	    this.updateStatus();
	  };
	
	  Transition.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.cancelNextCallback();
	  };
	
	  Transition.prototype.render = function render() {
	    var status = this.state.status;
	    if (status === UNMOUNTED) {
	      return null;
	    }
	
	    var _props = this.props,
	        children = _props.children,
	        className = _props.className,
	        childProps = _objectWithoutProperties(_props, ['children', 'className']);
	
	    Object.keys(Transition.propTypes).forEach(function (key) {
	      return delete childProps[key];
	    });
	
	    var transitionClassName = void 0;
	    if (status === EXITED) {
	      transitionClassName = this.props.exitedClassName;
	    } else if (status === ENTERING) {
	      transitionClassName = this.props.enteringClassName;
	    } else if (status === ENTERED) {
	      transitionClassName = this.props.enteredClassName;
	    } else if (status === EXITING) {
	      transitionClassName = this.props.exitingClassName;
	    }
	
	    var child = _react2.default.Children.only(children);
	    return _react2.default.cloneElement(child, _extends({}, childProps, {
	      className: (0, _classnames2.default)(child.props.className, className, transitionClassName)
	    }));
	  };
	
	  return Transition;
	}(_react2.default.Component);
	
	Transition.propTypes = {
	  /**
	   * Show the component; triggers the enter or exit animation
	   */
	  in: _propTypes2.default.bool,
	
	  /**
	   * Wait until the first "enter" transition to mount the component (add it to the DOM)
	   */
	  mountOnEnter: _propTypes2.default.bool,
	
	  /**
	   * Unmount the component (remove it from the DOM) when it is not shown
	   */
	  unmountOnExit: _propTypes2.default.bool,
	
	  /**
	   * Run the enter animation when the component mounts, if it is initially
	   * shown
	   */
	  transitionAppear: _propTypes2.default.bool,
	
	  /**
	   * A Timeout for the animation, in milliseconds, to ensure that a node doesn't
	   * transition indefinately if the browser transitionEnd events are
	   * canceled or interrupted.
	   *
	   * By default this is set to a high number (5 seconds) as a failsafe. You should consider
	   * setting this to the duration of your animation (or a bit above it).
	   */
	  timeout: _propTypes2.default.number,
	
	  /**
	   * CSS class or classes applied when the component is exited
	   */
	  exitedClassName: _propTypes2.default.string,
	  /**
	   * CSS class or classes applied while the component is exiting
	   */
	  exitingClassName: _propTypes2.default.string,
	  /**
	   * CSS class or classes applied when the component is entered
	   */
	  enteredClassName: _propTypes2.default.string,
	  /**
	   * CSS class or classes applied while the component is entering
	   */
	  enteringClassName: _propTypes2.default.string,
	
	  /**
	   * Callback fired before the "entering" classes are applied
	   */
	  onEnter: _propTypes2.default.func,
	  /**
	   * Callback fired after the "entering" classes are applied
	   */
	  onEntering: _propTypes2.default.func,
	  /**
	   * Callback fired after the "enter" classes are applied
	   */
	  onEntered: _propTypes2.default.func,
	  /**
	   * Callback fired before the "exiting" classes are applied
	   */
	  onExit: _propTypes2.default.func,
	  /**
	   * Callback fired after the "exiting" classes are applied
	   */
	  onExiting: _propTypes2.default.func,
	  /**
	   * Callback fired after the "exited" classes are applied
	   */
	  onExited: _propTypes2.default.func
	};
	
	// Name the function so it is clearer in the documentation
	function noop() {}
	
	Transition.displayName = 'Transition';
	
	Transition.defaultProps = {
	  in: false,
	  unmountOnExit: false,
	  transitionAppear: false,
	
	  timeout: 5000,
	
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	
	exports.default = Transition;

/***/ },
/* 944 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (node, event, handler, capture) {
	  (0, _on2.default)(node, event, handler, capture);
	
	  return {
	    remove: function remove() {
	      (0, _off2.default)(node, event, handler, capture);
	    }
	  };
	};
	
	var _on = __webpack_require__(271);
	
	var _on2 = _interopRequireDefault(_on);
	
	var _off = __webpack_require__(418);
	
	var _off2 = _interopRequireDefault(_off);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports['default'];

/***/ },
/* 945 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = isOverflowing;
	
	var _isWindow = __webpack_require__(272);
	
	var _isWindow2 = _interopRequireDefault(_isWindow);
	
	var _ownerDocument = __webpack_require__(173);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isBody(node) {
	  return node && node.tagName.toLowerCase() === 'body';
	}
	
	function bodyIsOverflowing(node) {
	  var doc = (0, _ownerDocument2.default)(node);
	  var win = (0, _isWindow2.default)(doc);
	  var fullWidth = win.innerWidth;
	
	  // Support: ie8, no innerWidth
	  if (!fullWidth) {
	    var documentElementRect = doc.documentElement.getBoundingClientRect();
	    fullWidth = documentElementRect.right - Math.abs(documentElementRect.left);
	  }
	
	  return doc.body.clientWidth < fullWidth;
	}
	
	function isOverflowing(container) {
	  var win = (0, _isWindow2.default)(container);
	
	  return win || isBody(container) ? bodyIsOverflowing(container) : container.scrollHeight > container.clientHeight;
	}
	module.exports = exports['default'];

/***/ },
/* 946 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setRef = exports.shallowEqual = exports.safeInvoke = exports.unwrapArray = void 0;
	
	/**
	 * Takes an argument and if it's an array, returns the first item in the array,
	 * otherwise returns the argument. Used for Preact compatibility.
	 */
	var unwrapArray = function unwrapArray(arg) {
	  return Array.isArray(arg) ? arg[0] : arg;
	};
	/**
	 * Takes a maybe-undefined function and arbitrary args and invokes the function
	 * only if it is defined.
	 */
	
	
	exports.unwrapArray = unwrapArray;
	
	var safeInvoke = function safeInvoke(fn) {
	  if (typeof fn === "function") {
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return fn.apply(void 0, args);
	  }
	};
	/**
	 * Does a shallow equality check of two objects by comparing the reference
	 * equality of each value.
	 */
	
	
	exports.safeInvoke = safeInvoke;
	
	var shallowEqual = function shallowEqual(objA, objB) {
	  var aKeys = Object.keys(objA);
	  var bKeys = Object.keys(objB);
	
	  if (bKeys.length !== aKeys.length) {
	    return false;
	  }
	
	  for (var i = 0; i < bKeys.length; i++) {
	    var key = aKeys[i];
	
	    if (objA[key] !== objB[key]) {
	      return false;
	    }
	  }
	
	  return true;
	};
	/**
	 * Sets a ref using either a ref callback or a ref object
	 */
	
	
	exports.shallowEqual = shallowEqual;
	
	var setRef = function setRef(ref, node) {
	  // if its a function call it
	  if (typeof ref === "function") {
	    return safeInvoke(ref, node);
	  } // otherwise we should treat it as a ref object
	  else if (ref != null) {
	      ref.current = node;
	    }
	};
	
	exports.setRef = setRef;

/***/ },
/* 947 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4)["default"];
	
	var _interopRequireWildcard = __webpack_require__(154)["default"];
	
	exports.__esModule = true;
	exports["default"] = connectAdvanced;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(2025));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactIs = __webpack_require__(2313);
	
	var _Subscription = __webpack_require__(468);
	
	var _useIsomorphicLayoutEffect = __webpack_require__(469);
	
	var _Context = __webpack_require__(151);
	
	var _excluded = ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef", "forwardRef", "context"],
	    _excluded2 = ["reactReduxForwardedRef"];
	// Define some constant arrays just to avoid re-creating these
	var EMPTY_ARRAY = [];
	var NO_SUBSCRIPTION_ARRAY = [null, null];
	
	var stringifyComponent = function stringifyComponent(Comp) {
	  try {
	    return JSON.stringify(Comp);
	  } catch (err) {
	    return String(Comp);
	  }
	};
	
	function storeStateUpdatesReducer(state, action) {
	  var updateCount = state[1];
	  return [action.payload, updateCount + 1];
	}
	
	function useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
	  (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function () {
	    return effectFunc.apply(void 0, effectArgs);
	  }, dependencies);
	}
	
	function captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
	  // We want to capture the wrapper props and child props we used for later comparisons
	  lastWrapperProps.current = wrapperProps;
	  lastChildProps.current = actualChildProps;
	  renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
	
	  if (childPropsFromStoreUpdate.current) {
	    childPropsFromStoreUpdate.current = null;
	    notifyNestedSubs();
	  }
	}
	
	function subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
	  // If we're not subscribed to the store, nothing to do here
	  if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts
	
	  var didUnsubscribe = false;
	  var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
	
	  var checkForUpdates = function checkForUpdates() {
	    if (didUnsubscribe) {
	      // Don't run stale listeners.
	      // Redux doesn't guarantee unsubscriptions happen until next dispatch.
	      return;
	    }
	
	    var latestStoreState = store.getState();
	    var newChildProps, error;
	
	    try {
	      // Actually run the selector with the most recent store state and wrapper props
	      // to determine what the child props should be
	      newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
	    } catch (e) {
	      error = e;
	      lastThrownError = e;
	    }
	
	    if (!error) {
	      lastThrownError = null;
	    } // If the child props haven't changed, nothing to do here - cascade the subscription update
	
	
	    if (newChildProps === lastChildProps.current) {
	      if (!renderIsScheduled.current) {
	        notifyNestedSubs();
	      }
	    } else {
	      // Save references to the new child props.  Note that we track the "child props from store update"
	      // as a ref instead of a useState/useReducer because we need a way to determine if that value has
	      // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
	      // forcing another re-render, which we don't want.
	      lastChildProps.current = newChildProps;
	      childPropsFromStoreUpdate.current = newChildProps;
	      renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render
	
	      forceComponentUpdateDispatch({
	        type: 'STORE_UPDATED',
	        payload: {
	          error: error
	        }
	      });
	    }
	  }; // Actually subscribe to the nearest connected ancestor (or store)
	
	
	  subscription.onStateChange = checkForUpdates;
	  subscription.trySubscribe(); // Pull data from the store after first render in case the store has
	  // changed since we began.
	
	  checkForUpdates();
	
	  var unsubscribeWrapper = function unsubscribeWrapper() {
	    didUnsubscribe = true;
	    subscription.tryUnsubscribe();
	    subscription.onStateChange = null;
	
	    if (lastThrownError) {
	      // It's possible that we caught an error due to a bad mapState function, but the
	      // parent re-rendered without this component and we're about to unmount.
	      // This shouldn't happen as long as we do top-down subscriptions correctly, but
	      // if we ever do those wrong, this throw will surface the error in our tests.
	      // In that case, throw the error from here so it doesn't get lost.
	      throw lastThrownError;
	    }
	  };
	
	  return unsubscribeWrapper;
	}
	
	var initStateUpdates = function initStateUpdates() {
	  return [null, 0];
	};
	
	function connectAdvanced(
	/*
	  selectorFactory is a func that is responsible for returning the selector function used to
	  compute new props from state, props, and dispatch. For example:
	     export default connectAdvanced((dispatch, options) => (state, props) => ({
	      thing: state.things[props.thingId],
	      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
	    }))(YourComponent)
	   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
	  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
	  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
	   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
	  props. Do not use connectAdvanced directly without memoizing results between calls to your
	  selector, otherwise the Connect component will re-render on every state or props change.
	*/
	selectorFactory, // options object:
	_ref) {
	  if (_ref === void 0) {
	    _ref = {};
	  }
	
	  var _ref2 = _ref,
	      _ref2$getDisplayName = _ref2.getDisplayName,
	      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
	    return "ConnectAdvanced(" + name + ")";
	  } : _ref2$getDisplayName,
	      _ref2$methodName = _ref2.methodName,
	      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
	      _ref2$renderCountProp = _ref2.renderCountProp,
	      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
	      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
	      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
	      _ref2$storeKey = _ref2.storeKey,
	      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
	      _ref2$withRef = _ref2.withRef,
	      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
	      _ref2$forwardRef = _ref2.forwardRef,
	      forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef,
	      _ref2$context = _ref2.context,
	      context = _ref2$context === void 0 ? _Context.ReactReduxContext : _ref2$context,
	      connectOptions = (0, _objectWithoutPropertiesLoose2["default"])(_ref2, _excluded);
	
	  if (false) {
	    if (renderCountProp !== undefined) {
	      throw new Error("renderCountProp is removed. render counting is built into the latest React Dev Tools profiling extension");
	    }
	
	    if (withRef) {
	      throw new Error('withRef is removed. To access the wrapped instance, use a ref on the connected component');
	    }
	
	    var customStoreWarningMessage = 'To use a custom Redux store for specific components, create a custom React context with ' + "React.createContext(), and pass the context object to React Redux's Provider and specific components" + ' like: <Provider context={MyContext}><ConnectedComponent context={MyContext} /></Provider>. ' + 'You may also pass a {context : MyContext} option to connect';
	
	    if (storeKey !== 'store') {
	      throw new Error('storeKey has been removed and does not do anything. ' + customStoreWarningMessage);
	    }
	  }
	
	  var Context = context;
	  return function wrapWithConnect(WrappedComponent) {
	    if (false) {
	      throw new Error("You must pass a component to the function returned by " + (methodName + ". Instead received " + stringifyComponent(WrappedComponent)));
	    }
	
	    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	    var displayName = getDisplayName(wrappedComponentName);
	    var selectorFactoryOptions = (0, _extends2["default"])({}, connectOptions, {
	      getDisplayName: getDisplayName,
	      methodName: methodName,
	      renderCountProp: renderCountProp,
	      shouldHandleStateChanges: shouldHandleStateChanges,
	      storeKey: storeKey,
	      displayName: displayName,
	      wrappedComponentName: wrappedComponentName,
	      WrappedComponent: WrappedComponent
	    });
	    var pure = connectOptions.pure;
	
	    function createChildSelector(store) {
	      return selectorFactory(store.dispatch, selectorFactoryOptions);
	    } // If we aren't running in "pure" mode, we don't want to memoize values.
	    // To avoid conditionally calling hooks, we fall back to a tiny wrapper
	    // that just executes the given callback immediately.
	
	
	    var usePureOnlyMemo = pure ? _react.useMemo : function (callback) {
	      return callback();
	    };
	
	    function ConnectFunction(props) {
	      var _useMemo = (0, _react.useMemo)(function () {
	        // Distinguish between actual "data" props that were passed to the wrapper component,
	        // and values needed to control behavior (forwarded refs, alternate context instances).
	        // To maintain the wrapperProps object reference, memoize this destructuring.
	        var reactReduxForwardedRef = props.reactReduxForwardedRef,
	            wrapperProps = (0, _objectWithoutPropertiesLoose2["default"])(props, _excluded2);
	        return [props.context, reactReduxForwardedRef, wrapperProps];
	      }, [props]),
	          propsContext = _useMemo[0],
	          reactReduxForwardedRef = _useMemo[1],
	          wrapperProps = _useMemo[2];
	
	      var ContextToUse = (0, _react.useMemo)(function () {
	        // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
	        // Memoize the check that determines which context instance we should use.
	        return propsContext && propsContext.Consumer && (0, _reactIs.isContextConsumer)( /*#__PURE__*/_react["default"].createElement(propsContext.Consumer, null)) ? propsContext : Context;
	      }, [propsContext, Context]); // Retrieve the store and ancestor subscription via context, if available
	
	      var contextValue = (0, _react.useContext)(ContextToUse); // The store _must_ exist as either a prop or in context.
	      // We'll check to see if it _looks_ like a Redux store first.
	      // This allows us to pass through a `store` prop that is just a plain value.
	
	      var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
	      var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
	
	      if (false) {
	        throw new Error("Could not find \"store\" in the context of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + "or pass a custom React context provider to <Provider> and the corresponding " + ("React context consumer to " + displayName + " in connect options."));
	      } // Based on the previous check, one of these must be true
	
	
	      var store = didStoreComeFromProps ? props.store : contextValue.store;
	      var childPropsSelector = (0, _react.useMemo)(function () {
	        // The child props selector needs the store reference as an input.
	        // Re-create this selector whenever the store changes.
	        return createChildSelector(store);
	      }, [store]);
	
	      var _useMemo2 = (0, _react.useMemo)(function () {
	        if (!shouldHandleStateChanges) return NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
	        // connected to the store via props shouldn't use subscription from context, or vice versa.
	
	        // This Subscription's source should match where store came from: props vs. context. A component
	        // connected to the store via props shouldn't use subscription from context, or vice versa.
	        var subscription = (0, _Subscription.createSubscription)(store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
	        // the middle of the notification loop, where `subscription` will then be null. This can
	        // probably be avoided if Subscription's listeners logic is changed to not call listeners
	        // that have been unsubscribed in the  middle of the notification loop.
	
	        // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
	        // the middle of the notification loop, where `subscription` will then be null. This can
	        // probably be avoided if Subscription's listeners logic is changed to not call listeners
	        // that have been unsubscribed in the  middle of the notification loop.
	        var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
	        return [subscription, notifyNestedSubs];
	      }, [store, didStoreComeFromProps, contextValue]),
	          subscription = _useMemo2[0],
	          notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
	      // and memoize that value to avoid unnecessary context updates.
	
	
	      var overriddenContextValue = (0, _react.useMemo)(function () {
	        if (didStoreComeFromProps) {
	          // This component is directly subscribed to a store from props.
	          // We don't want descendants reading from this store - pass down whatever
	          // the existing context value is from the nearest connected ancestor.
	          return contextValue;
	        } // Otherwise, put this component's subscription instance into context, so that
	        // connected descendants won't update until after this component is done
	
	
	        return (0, _extends2["default"])({}, contextValue, {
	          subscription: subscription
	        });
	      }, [didStoreComeFromProps, contextValue, subscription]); // We need to force this wrapper component to re-render whenever a Redux store update
	      // causes a change to the calculated child component props (or we caught an error in mapState)
	
	      var _useReducer = (0, _react.useReducer)(storeStateUpdatesReducer, EMPTY_ARRAY, initStateUpdates),
	          _useReducer$ = _useReducer[0],
	          previousStateUpdateResult = _useReducer$[0],
	          forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards
	
	
	      if (previousStateUpdateResult && previousStateUpdateResult.error) {
	        throw previousStateUpdateResult.error;
	      } // Set up refs to coordinate values between the subscription effect and the render logic
	
	
	      var lastChildProps = (0, _react.useRef)();
	      var lastWrapperProps = (0, _react.useRef)(wrapperProps);
	      var childPropsFromStoreUpdate = (0, _react.useRef)();
	      var renderIsScheduled = (0, _react.useRef)(false);
	      var actualChildProps = usePureOnlyMemo(function () {
	        // Tricky logic here:
	        // - This render may have been triggered by a Redux store update that produced new child props
	        // - However, we may have gotten new wrapper props after that
	        // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
	        // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
	        // So, we'll use the child props from store update only if the wrapper props are the same as last time.
	        if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) {
	          return childPropsFromStoreUpdate.current;
	        } // TODO We're reading the store directly in render() here. Bad idea?
	        // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
	        // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
	        // to determine what the child props should be.
	
	
	        return childPropsSelector(store.getState(), wrapperProps);
	      }, [store, previousStateUpdateResult, wrapperProps]); // We need this to execute synchronously every time we re-render. However, React warns
	      // about useLayoutEffect in SSR, so we try to detect environment and fall back to
	      // just useEffect instead to avoid the warning, since neither will run anyway.
	
	      useIsomorphicLayoutEffectWithArgs(captureWrapperProps, [lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs]); // Our re-subscribe logic only runs when the store/subscription setup changes
	
	      useIsomorphicLayoutEffectWithArgs(subscribeUpdates, [shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch], [store, subscription, childPropsSelector]); // Now that all that's done, we can finally try to actually render the child component.
	      // We memoize the elements for the rendered child component as an optimization.
	
	      var renderedWrappedComponent = (0, _react.useMemo)(function () {
	        return /*#__PURE__*/_react["default"].createElement(WrappedComponent, (0, _extends2["default"])({}, actualChildProps, {
	          ref: reactReduxForwardedRef
	        }));
	      }, [reactReduxForwardedRef, WrappedComponent, actualChildProps]); // If React sees the exact same element reference as last time, it bails out of re-rendering
	      // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
	
	      var renderedChild = (0, _react.useMemo)(function () {
	        if (shouldHandleStateChanges) {
	          // If this component is subscribed to store updates, we need to pass its own
	          // subscription instance down to our descendants. That means rendering the same
	          // Context instance, and putting a different value into the context.
	          return /*#__PURE__*/_react["default"].createElement(ContextToUse.Provider, {
	            value: overriddenContextValue
	          }, renderedWrappedComponent);
	        }
	
	        return renderedWrappedComponent;
	      }, [ContextToUse, renderedWrappedComponent, overriddenContextValue]);
	      return renderedChild;
	    } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.
	
	
	    var Connect = pure ? _react["default"].memo(ConnectFunction) : ConnectFunction;
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.displayName = ConnectFunction.displayName = displayName;
	
	    if (forwardRef) {
	      var forwarded = _react["default"].forwardRef(function forwardConnectRef(props, ref) {
	        return /*#__PURE__*/_react["default"].createElement(Connect, (0, _extends2["default"])({}, props, {
	          reactReduxForwardedRef: ref
	        }));
	      });
	
	      forwarded.displayName = displayName;
	      forwarded.WrappedComponent = WrappedComponent;
	      return (0, _hoistNonReactStatics["default"])(forwarded, WrappedComponent);
	    }
	
	    return (0, _hoistNonReactStatics["default"])(Connect, WrappedComponent);
	  };
	}

/***/ },
/* 948 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4)["default"];
	
	exports.__esModule = true;
	exports.getDependsOnOwnProps = getDependsOnOwnProps;
	exports.wrapMapToPropsConstant = wrapMapToPropsConstant;
	exports.wrapMapToPropsFunc = wrapMapToPropsFunc;
	
	var _verifyPlainObject = _interopRequireDefault(__webpack_require__(953));
	
	function wrapMapToPropsConstant(getConstant) {
	  return function initConstantSelector(dispatch, options) {
	    var constant = getConstant(dispatch, options);
	
	    function constantSelector() {
	      return constant;
	    }
	
	    constantSelector.dependsOnOwnProps = false;
	    return constantSelector;
	  };
	} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
	// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
	// whether mapToProps needs to be invoked when props have changed.
	//
	// A length of one signals that mapToProps does not depend on props from the parent component.
	// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
	// therefore not reporting its length accurately..
	
	
	function getDependsOnOwnProps(mapToProps) {
	  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
	} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
	// this function wraps mapToProps in a proxy function which does several things:
	//
	//  * Detects whether the mapToProps function being called depends on props, which
	//    is used by selectorFactory to decide if it should reinvoke on props changes.
	//
	//  * On first call, handles mapToProps if returns another function, and treats that
	//    new function as the true mapToProps for subsequent calls.
	//
	//  * On first call, verifies the first result is a plain object, in order to warn
	//    the developer that their mapToProps function is not returning a valid result.
	//
	
	
	function wrapMapToPropsFunc(mapToProps, methodName) {
	  return function initProxySelector(dispatch, _ref) {
	    var displayName = _ref.displayName;
	
	    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
	      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
	    }; // allow detectFactoryAndVerify to get ownProps
	
	
	    proxy.dependsOnOwnProps = true;
	
	    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
	      proxy.mapToProps = mapToProps;
	      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
	      var props = proxy(stateOrDispatch, ownProps);
	
	      if (typeof props === 'function') {
	        proxy.mapToProps = props;
	        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
	        props = proxy(stateOrDispatch, ownProps);
	      }
	
	      if (false) (0, _verifyPlainObject["default"])(props, displayName, methodName);
	      return props;
	    };
	
	    return proxy;
	  };
	}

/***/ },
/* 949 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.useReduxContext = useReduxContext;
	
	var _react = __webpack_require__(1);
	
	var _Context = __webpack_require__(151);
	
	/**
	 * A hook to access the value of the `ReactReduxContext`. This is a low-level
	 * hook that you should usually not need to call directly.
	 *
	 * @returns {any} the value of the `ReactReduxContext`
	 *
	 * @example
	 *
	 * import React from 'react'
	 * import { useReduxContext } from 'react-redux'
	 *
	 * export const CounterComponent = ({ value }) => {
	 *   const { store } = useReduxContext()
	 *   return <div>{store.getState()}</div>
	 * }
	 */
	function useReduxContext() {
	  var contextValue = (0, _react.useContext)(_Context.ReactReduxContext);
	
	  if (false) {
	    throw new Error('could not find react-redux context value; please ensure the component is wrapped in a <Provider>');
	  }
	
	  return contextValue;
	}

/***/ },
/* 950 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.createStoreHook = createStoreHook;
	exports.useStore = void 0;
	
	var _react = __webpack_require__(1);
	
	var _Context = __webpack_require__(151);
	
	var _useReduxContext2 = __webpack_require__(949);
	
	/**
	 * Hook factory, which creates a `useStore` hook bound to a given context.
	 *
	 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
	 * @returns {Function} A `useStore` hook bound to the specified context.
	 */
	function createStoreHook(context) {
	  if (context === void 0) {
	    context = _Context.ReactReduxContext;
	  }
	
	  var useReduxContext = context === _Context.ReactReduxContext ? _useReduxContext2.useReduxContext : function () {
	    return (0, _react.useContext)(context);
	  };
	  return function useStore() {
	    var _useReduxContext = useReduxContext(),
	        store = _useReduxContext.store;
	
	    return store;
	  };
	}
	/**
	 * A hook to access the redux store.
	 *
	 * @returns {any} the redux store
	 *
	 * @example
	 *
	 * import React from 'react'
	 * import { useStore } from 'react-redux'
	 *
	 * export const ExampleComponent = () => {
	 *   const store = useStore()
	 *   return <div>{store.getState()}</div>
	 * }
	 */
	
	
	var useStore = /*#__PURE__*/createStoreHook();
	exports.useStore = useStore;

/***/ },
/* 951 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.setBatch = exports.getBatch = void 0;
	
	// Default to a dummy "batch" implementation that just runs the callback
	function defaultNoopBatch(callback) {
	  callback();
	}
	
	var batch = defaultNoopBatch; // Allow injecting another batching function later
	
	var setBatch = function setBatch(newBatch) {
	  return batch = newBatch;
	}; // Supply a getter just to skip dealing with ESM bindings
	
	
	exports.setBatch = setBatch;
	
	var getBatch = function getBatch() {
	  return batch;
	};
	
	exports.getBatch = getBatch;

/***/ },
/* 952 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = shallowEqual;
	
	function is(x, y) {
	  if (x === y) {
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) return true;
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	  if (keysA.length !== keysB.length) return false;
	
	  for (var i = 0; i < keysA.length; i++) {
	    if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ },
/* 953 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4)["default"];
	
	exports.__esModule = true;
	exports["default"] = verifyPlainObject;
	
	var _isPlainObject = _interopRequireDefault(__webpack_require__(2310));
	
	var _warning = _interopRequireDefault(__webpack_require__(954));
	
	function verifyPlainObject(value, displayName, methodName) {
	  if (!(0, _isPlainObject["default"])(value)) {
	    (0, _warning["default"])(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
	  }
	}

/***/ },
/* 954 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = warning;
	
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	
	
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	
	}

/***/ },
/* 955 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDraggable = __webpack_require__(298);
	
	var _utils = __webpack_require__(2315);
	
	var _propTypes = __webpack_require__(956);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var Resizable = /*#__PURE__*/function (_React$Component) {
	  _inheritsLoose(Resizable, _React$Component);
	
	  function Resizable() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	
	    _defineProperty(_assertThisInitialized(_this), "state", undefined);
	
	    _defineProperty(_assertThisInitialized(_this), "lastHandleRect", null);
	
	    _defineProperty(_assertThisInitialized(_this), "slack", null);
	
	    return _this;
	  }
	
	  var _proto = Resizable.prototype;
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.resetData();
	  };
	
	  _proto.lockAspectRatio = function lockAspectRatio(width, height, aspectRatio) {
	    height = width / aspectRatio;
	    width = height * aspectRatio;
	    return [width, height];
	  };
	
	  _proto.resetData = function resetData() {
	    this.lastHandleRect = this.slack = null;
	  } // Clamp width and height within provided constraints
	  ;
	
	  _proto.runConstraints = function runConstraints(width, height) {
	    var _ref = [this.props.minConstraints, this.props.maxConstraints],
	        min = _ref[0],
	        max = _ref[1];
	    if (!min && !max) return [width, height]; // If constraining to min and max, we need to also fit width and height to aspect ratio.
	
	    if (this.props.lockAspectRatio) {
	      var resizingHorizontally = height === this.props.height;
	
	      if (resizingHorizontally) {
	        var ratio = this.props.width / this.props.height;
	        height = width / ratio;
	        width = height * ratio;
	      } else {
	        // Take into account vertical resize with N/S handles on locked aspect
	        // ratio. Calculate the change height-first, instead of width-first
	        var _ratio = this.props.height / this.props.width;
	
	        width = height / _ratio;
	        height = width * _ratio;
	      }
	    }
	
	    var oldW = width,
	        oldH = height; // Add slack to the values used to calculate bound position. This will ensure that if
	    // we start removing slack, the element won't react to it right away until it's been
	    // completely removed.
	
	    var _ref2 = this.slack || [0, 0],
	        slackW = _ref2[0],
	        slackH = _ref2[1];
	
	    width += slackW;
	    height += slackH;
	
	    if (min) {
	      width = Math.max(min[0], width);
	      height = Math.max(min[1], height);
	    }
	
	    if (max) {
	      width = Math.min(max[0], width);
	      height = Math.min(max[1], height);
	    } // If the width or height changed, we must have introduced some slack. Record it for the next iteration.
	
	
	    this.slack = [slackW + (oldW - width), slackH + (oldH - height)];
	    return [width, height];
	  }
	  /**
	   * Wrapper around drag events to provide more useful data.
	   *
	   * @param  {String} handlerName Handler name to wrap.
	   * @return {Function}           Handler function.
	   */
	  ;
	
	  _proto.resizeHandler = function resizeHandler(handlerName, axis) {
	    var _this2 = this;
	
	    return function (e, _ref3) {
	      var node = _ref3.node,
	          deltaX = _ref3.deltaX,
	          deltaY = _ref3.deltaY;
	      // Reset data in case it was left over somehow (should not be possible)
	      if (handlerName === 'onResizeStart') _this2.resetData(); // Axis restrictions
	
	      var canDragX = (_this2.props.axis === 'both' || _this2.props.axis === 'x') && axis !== 'n' && axis !== 's';
	      var canDragY = (_this2.props.axis === 'both' || _this2.props.axis === 'y') && axis !== 'e' && axis !== 'w'; // No dragging possible.
	
	      if (!canDragX && !canDragY) return; // Decompose axis for later use
	
	      var axisV = axis[0];
	      var axisH = axis[axis.length - 1]; // intentionally not axis[1], so that this catches axis === 'w' for example
	      // Track the element being dragged to account for changes in position.
	      // If a handle's position is changed between callbacks, we need to factor this in to the next callback.
	      // Failure to do so will cause the element to "skip" when resized upwards or leftwards.
	
	      var handleRect = node.getBoundingClientRect();
	
	      if (_this2.lastHandleRect != null) {
	        // If the handle has repositioned on either axis since last render,
	        // we need to increase our callback values by this much.
	        // Only checking 'n', 'w' since resizing by 's', 'w' won't affect the overall position on page,
	        if (axisH === 'w') {
	          var deltaLeftSinceLast = handleRect.left - _this2.lastHandleRect.left;
	          deltaX += deltaLeftSinceLast;
	        }
	
	        if (axisV === 'n') {
	          var deltaTopSinceLast = handleRect.top - _this2.lastHandleRect.top;
	          deltaY += deltaTopSinceLast;
	        }
	      } // Storage of last rect so we know how much it has really moved.
	
	
	      _this2.lastHandleRect = handleRect; // Reverse delta if using top or left drag handles.
	
	      if (axisH === 'w') deltaX = -deltaX;
	      if (axisV === 'n') deltaY = -deltaY; // Update w/h by the deltas. Also factor in transformScale.
	
	      var width = _this2.props.width + (canDragX ? deltaX / _this2.props.transformScale : 0);
	      var height = _this2.props.height + (canDragY ? deltaY / _this2.props.transformScale : 0); // Run user-provided constraints.
	
	      var _this2$runConstraints = _this2.runConstraints(width, height);
	
	      width = _this2$runConstraints[0];
	      height = _this2$runConstraints[1];
	      var dimensionsChanged = width !== _this2.props.width || height !== _this2.props.height; // Call user-supplied callback if present.
	
	      var cb = typeof _this2.props[handlerName] === 'function' ? _this2.props[handlerName] : null; // Don't call 'onResize' if dimensions haven't changed.
	
	      var shouldSkipCb = handlerName === 'onResize' && !dimensionsChanged;
	
	      if (cb && !shouldSkipCb) {
	        if (typeof e.persist === 'function') e.persist();
	        cb(e, {
	          node: node,
	          size: {
	            width: width,
	            height: height
	          },
	          handle: axis
	        });
	      } // Reset internal data
	
	
	      if (handlerName === 'onResizeStop') _this2.resetData();
	    };
	  };
	
	  _proto.renderResizeHandle = function renderResizeHandle(resizeHandleAxis) {
	    var handle = this.props.handle;
	
	    if (handle) {
	      if (typeof handle === 'function') {
	        return handle(resizeHandleAxis);
	      }
	
	      return handle;
	    }
	
	    return /*#__PURE__*/_react.default.createElement("span", {
	      className: "react-resizable-handle react-resizable-handle-" + resizeHandleAxis
	    });
	  };
	
	  _proto.render = function render() {
	    var _this3 = this;
	
	    // Pass along only props not meant for the `<Resizable>`.`
	    // eslint-disable-next-line no-unused-vars
	    var _this$props = this.props,
	        children = _this$props.children,
	        className = _this$props.className,
	        draggableOpts = _this$props.draggableOpts,
	        width = _this$props.width,
	        height = _this$props.height,
	        handle = _this$props.handle,
	        handleSize = _this$props.handleSize,
	        lockAspectRatio = _this$props.lockAspectRatio,
	        axis = _this$props.axis,
	        minConstraints = _this$props.minConstraints,
	        maxConstraints = _this$props.maxConstraints,
	        onResize = _this$props.onResize,
	        onResizeStop = _this$props.onResizeStop,
	        onResizeStart = _this$props.onResizeStart,
	        resizeHandles = _this$props.resizeHandles,
	        transformScale = _this$props.transformScale,
	        p = _objectWithoutPropertiesLoose(_this$props, ["children", "className", "draggableOpts", "width", "height", "handle", "handleSize", "lockAspectRatio", "axis", "minConstraints", "maxConstraints", "onResize", "onResizeStop", "onResizeStart", "resizeHandles", "transformScale"]); // What we're doing here is getting the child of this element, and cloning it with this element's props.
	    // We are then defining its children as:
	    // Its original children (resizable's child's children), and
	    // One or more draggable handles.
	
	
	    return (0, _utils.cloneElement)(children, _objectSpread(_objectSpread({}, p), {}, {
	      className: (className ? className + " " : '') + "react-resizable",
	      children: [].concat(children.props.children, resizeHandles.map(function (handleAxis) {
	        return /*#__PURE__*/_react.default.createElement(_reactDraggable.DraggableCore, _extends({}, draggableOpts, {
	          key: "resizableHandle-" + handleAxis,
	          onStop: _this3.resizeHandler('onResizeStop', handleAxis),
	          onStart: _this3.resizeHandler('onResizeStart', handleAxis),
	          onDrag: _this3.resizeHandler('onResize', handleAxis)
	        }), _this3.renderResizeHandle(handleAxis));
	      }))
	    }));
	  };
	
	  return Resizable;
	}(_react.default.Component);
	
	exports.default = Resizable;
	
	_defineProperty(Resizable, "propTypes", _propTypes.resizableProps);
	
	_defineProperty(Resizable, "defaultProps", {
	  handleSize: [20, 20],
	  lockAspectRatio: false,
	  axis: 'both',
	  minConstraints: [20, 20],
	  maxConstraints: [Infinity, Infinity],
	  resizeHandles: ['se'],
	  transformScale: 1
	});

/***/ },
/* 956 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.resizableProps = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _reactDraggable = __webpack_require__(298);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var resizableProps = {
	  /*
	  * Restricts resizing to a particular axis (default: 'both')
	  * 'both' - allows resizing by width or height
	  * 'x' - only allows the width to be changed
	  * 'y' - only allows the height to be changed
	  * 'none' - disables resizing altogether
	  * */
	  axis: _propTypes.default.oneOf(['both', 'x', 'y', 'none']),
	  className: _propTypes.default.string,
	
	  /*
	  * Require that one and only one child be present.
	  * */
	  children: _propTypes.default.element.isRequired,
	
	  /*
	  * These will be passed wholesale to react-draggable's DraggableCore
	  * */
	  draggableOpts: _propTypes.default.shape({
	    allowAnyClick: _propTypes.default.bool,
	    cancel: _propTypes.default.string,
	    children: _propTypes.default.node,
	    disabled: _propTypes.default.bool,
	    enableUserSelectHack: _propTypes.default.bool,
	    offsetParent: _propTypes.default.node,
	    grid: _propTypes.default.arrayOf(_propTypes.default.number),
	    handle: _propTypes.default.string,
	    nodeRef: _propTypes.default.object,
	    onStart: _propTypes.default.func,
	    onDrag: _propTypes.default.func,
	    onStop: _propTypes.default.func,
	    onMouseDown: _propTypes.default.func,
	    scale: _propTypes.default.number
	  }),
	
	  /*
	  * Initial height
	  * */
	  height: _propTypes.default.number.isRequired,
	
	  /*
	  * Customize cursor resize handle
	  * */
	  handle: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),
	
	  /*
	  * If you change this, be sure to update your css
	  * */
	  handleSize: _propTypes.default.arrayOf(_propTypes.default.number),
	  lockAspectRatio: _propTypes.default.bool,
	
	  /*
	  * Max X & Y measure
	  * */
	  maxConstraints: _propTypes.default.arrayOf(_propTypes.default.number),
	
	  /*
	  * Min X & Y measure
	  * */
	  minConstraints: _propTypes.default.arrayOf(_propTypes.default.number),
	
	  /*
	  * Called on stop resize event
	  * */
	  onResizeStop: _propTypes.default.func,
	
	  /*
	  * Called on start resize event
	  * */
	  onResizeStart: _propTypes.default.func,
	
	  /*
	  * Called on resize event
	  * */
	  onResize: _propTypes.default.func,
	
	  /*
	  * Defines which resize handles should be rendered (default: 'se')
	  * 's' - South handle (bottom-center)
	  * 'w' - West handle (left-center)
	  * 'e' - East handle (right-center)
	  * 'n' - North handle (top-center)
	  * 'sw' - Southwest handle (bottom-left)
	  * 'nw' - Northwest handle (top-left)
	  * 'se' - Southeast handle (bottom-right)
	  * 'ne' - Northeast handle (top-center)
	  * */
	  resizeHandles: _propTypes.default.arrayOf(_propTypes.default.oneOf(['s', 'w', 'e', 'n', 'sw', 'nw', 'se', 'ne'])),
	
	  /*
	  * If `transform: scale(n)` is set on the parent, this should be set to `n`.
	  * */
	  transformScale: _propTypes.default.number,
	
	  /*
	   * Initial width
	   */
	  width: _propTypes.default.number.isRequired
	};
	exports.resizableProps = resizableProps;

/***/ },
/* 957 */
/***/ function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(1));
		else if(typeof define === 'function' && define.amd)
			define(["react"], factory);
		else {
			var a = typeof exports === 'object' ? factory(require("react")) : factory(root["react"]);
			for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
		}
	})(this, function(__WEBPACK_EXTERNAL_MODULE_2__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _Slider = __webpack_require__(1);
	
		var _Slider2 = _interopRequireDefault(_Slider);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = _Slider2.default;
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _propTypes = __webpack_require__(3);
	
		var _propTypes2 = _interopRequireDefault(_propTypes);
	
		var _SliderThumb = __webpack_require__(12);
	
		var _SliderThumb2 = _interopRequireDefault(_SliderThumb);
	
		var _SliderLabel = __webpack_require__(13);
	
		var _SliderLabel2 = _interopRequireDefault(_SliderLabel);
	
		var _SliderTrack = __webpack_require__(14);
	
		var _SliderTrack2 = _interopRequireDefault(_SliderTrack);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-console */
	
	
		function noOp() {}
	
		var Slider = function (_Component) {
		  _inherits(Slider, _Component);
	
		  function Slider(props) {
		    _classCallCheck(this, Slider);
	
		    var _this = _possibleConstructorReturn(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).call(this, props));
	
		    _this.state = {
		      drag: false
		    };
		    _this.onInteractionStart = _this.onInteractionStart.bind(_this);
		    _this.onMouseOrTouchMove = _this.onMouseOrTouchMove.bind(_this);
		    _this.onInteractionEnd = _this.onInteractionEnd.bind(_this);
		    return _this;
		  }
	
		  _createClass(Slider, [{
		    key: 'componentWillMount',
		    value: function componentWillMount() {
		      this.updateStateFromProps(this.props);
		    }
		  }, {
		    key: 'componentDidMount',
		    value: function componentDidMount() {
		      if (this.props.onChange.name === 'noOp') {
		        console.warn('A react-simple-range component was not provided an onChange prop.\n        \nRecommend passing down a function as onChange else this component is purely cosmetic');
		      }
		    }
		  }, {
		    key: 'componentWillReceiveProps',
		    value: function componentWillReceiveProps(nextProps) {
		      this.updateStateFromProps(nextProps);
		    }
		  }, {
		    key: 'onInteractionStart',
		    value: function onInteractionStart(e) {
		      var eventType = e.touches !== undefined ? 'touch' : 'mouse';
		      var leftMouseButton = 0;
		      if (eventType === 'mouse' && e.button !== leftMouseButton) return;
		      this.updateSliderValue(e, eventType);
		      this.setState({ drag: true, displayLabel: true });
		      this.addEvents(eventType);
		      e.preventDefault();
		    }
		  }, {
		    key: 'onInteractionEnd',
		    value: function onInteractionEnd() {
		      this.setState({
		        drag: false,
		        displayLabel: false
		      });
		      this.props.onChangeComplete(this.state);
		      this.removeEvents();
		    }
		  }, {
		    key: 'onMouseOrTouchMove',
		    value: function onMouseOrTouchMove(e) {
		      var eventType = e.touches !== undefined ? 'touch' : 'mouse';
		      if (!this.state.drag) return;
		      this.updateSliderValue(e, eventType);
		      e.stopPropagation();
		    }
		  }, {
		    key: 'getSliderInfo',
		    value: function getSliderInfo() {
		      var sl = this.refs.slider;
		      var sliderInfo = {
		        bounds: sl.getBoundingClientRect(),
		        length: sl.clientWidth,
		        height: sl.clientHeight
		      };
		      return sliderInfo;
		    }
		  }, {
		    key: 'addEvents',
		    value: function addEvents(type) {
		      switch (type) {
		        case 'mouse':
		          {
		            document.addEventListener('mousemove', this.onMouseOrTouchMove);
		            document.addEventListener('mouseup', this.onInteractionEnd);
		            break;
		          }
		        case 'touch':
		          {
		            document.addEventListener('touchmove', this.onMouseOrTouchMove);
		            document.addEventListener('touchend', this.onInteractionEnd);
		            break;
		          }
		        default: // nothing
		      }
		    }
		  }, {
		    key: 'removeEvents',
		    value: function removeEvents() {
		      document.removeEventListener('mousemove', this.onMouseOrTouchMove);
		      document.removeEventListener('mouseup', this.onInteractionEnd);
		      document.removeEventListener('touchmove', this.onMouseOrTouchMove);
		      document.removeEventListener('touchend', this.onInteractionEnd);
		    }
		  }, {
		    key: 'updateSliderValue',
		    value: function updateSliderValue(e, eventType) {
		      var _state = this.state,
		          max = _state.max,
		          min = _state.min;
		      var vertical = this.props.vertical;
		      var value = this.state.value;
	
		      var xCoords = (eventType !== 'touch' ? e.pageX : e.touches[0].pageX) - window.pageXOffset;
		      var yCoords = (eventType !== 'touch' ? e.pageY : e.touches[0].pageY) - window.pageYOffset;
		      // compare position to slider length to get percentage
		      var position = void 0;
		      var lengthOrHeight = void 0;
		      if (!vertical) {
		        position = xCoords - this.getSliderInfo().bounds.left;
		        lengthOrHeight = this.getSliderInfo().length;
		      } else {
		        lengthOrHeight = this.getSliderInfo().height;
		        position = lengthOrHeight - (yCoords - this.getSliderInfo().bounds.top);
		      }
		      var percent = this.clampValue(+(position / lengthOrHeight).toFixed(2), 0, 1);
		      // convert perc -> value then match value to notch as per props/state.step
		      var rawValue = this.valueFromPercent(percent);
		      value = this.calculateMatchingNotch(rawValue);
		      // avoid repeated updates of the same value
		      if (value === this.state.value) return;
		      // percentage of the range to render the track/thumb to
		      var ratio = (value - min) * 100 / (max - min);
		      this.setState({
		        percent: percent,
		        value: value,
		        ratio: ratio
		      }, this.handleChange);
		    }
		  }, {
		    key: 'handleChange',
		    value: function handleChange() {
		      this.props.onChange(this.state);
		    }
		  }, {
		    key: 'valueFromPercent',
		    value: function valueFromPercent(perc) {
		      var _state2 = this.state,
		          range = _state2.range,
		          min = _state2.min;
	
		      var val = range * perc + min;
		      return val;
		    }
		  }, {
		    key: 'calculateMatchingNotch',
		    value: function calculateMatchingNotch(value) {
		      var _state3 = this.state,
		          step = _state3.step,
		          max = _state3.max,
		          min = _state3.min;
	
		      var values = [];
		      for (var i = min; i <= max; i++) {
		        values.push(i);
		      }
		      var notches = [];
		      // find how many entries in values are divisible by step (+min,+max)
		      var _iteratorNormalCompletion = true;
		      var _didIteratorError = false;
		      var _iteratorError = undefined;
	
		      try {
		        for (var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
		          var s = _step.value;
	
		          if (s === min || s === max || s % step === 0) {
		            notches.push(s);
		          }
		        }
		        // reduce over the potential notches and find which is the closest
		      } catch (err) {
		        _didIteratorError = true;
		        _iteratorError = err;
		      } finally {
		        try {
		          if (!_iteratorNormalCompletion && _iterator.return) {
		            _iterator.return();
		          }
		        } finally {
		          if (_didIteratorError) {
		            throw _iteratorError;
		          }
		        }
		      }
	
		      var match = notches.reduce(function (prev, curr) {
		        if (Math.abs(curr - value) < Math.abs(prev - value)) {
		          return curr;
		        }
		        return prev;
		      });
		      return match;
		    }
		  }, {
		    key: 'clampValue',
		    value: function clampValue(val, min, max) {
		      return Math.max(min, Math.min(val, max));
		    }
		  }, {
		    key: 'updateStateFromProps',
		    value: function updateStateFromProps(props) {
		      var value = props.value,
		          thumbSize = props.thumbSize;
	
		      if (value === undefined) {
		        value = props.defaultValue !== undefined ? props.defaultValue : 0;
		      }
		      if (props.thumbSize === undefined) {
		        thumbSize = this.props.disableThumb ? 0 : props.sliderSize * 2;
		      }
		      var min = props.min,
		          max = props.max,
		          step = props.step,
		          id = props.id;
	
		      var range = max - min;
		      var ratio = Math.max(value - min, 0) * 100 / (max - min);
		      this.setState({
		        value: value,
		        min: min,
		        max: max,
		        range: range,
		        step: step,
		        ratio: ratio,
		        thumbSize: thumbSize,
		        id: id
		      });
		    }
		  }, {
		    key: 'render',
		    value: function render() {
		      var _props = this.props,
		          vertical = _props.vertical,
		          sliderSize = _props.sliderSize,
		          disableThumb = _props.disableThumb,
		          disableTrack = _props.disableTrack,
		          children = _props.children,
		          label = _props.label,
		          trackColor = _props.trackColor,
		          thumbColor = _props.thumbColor,
		          verticalSliderHeight = _props.verticalSliderHeight,
		          eventWrapperPadding = _props.eventWrapperPadding;
	
		      var eventWrapperStyle = {
		        height: '100%',
		        position: 'relative',
		        cursor: 'pointer',
		        margin: '0 auto',
		        get padding() {
		          return !vertical ? eventWrapperPadding + 'px 0' : '0 ' + eventWrapperPadding + 'px';
		        },
		        get width() {
		          return !vertical ? 'auto' : sliderSize + 'px';
		        }
		      };
		      var sliderStyle = {
		        backgroundColor: this.props.sliderColor,
		        position: 'relative',
		        overflow: 'visible',
		        get height() {
		          return !vertical ? sliderSize + 'px' : verticalSliderHeight;
		        },
		        get width() {
		          return !vertical ? '100%' : sliderSize + 'px';
		        }
		      };
		      return _react2.default.createElement(
		        'div',
		        {
		          style: eventWrapperStyle,
		          onMouseDown: this.onInteractionStart,
		          onTouchStart: this.onInteractionStart
		        },
		        _react2.default.createElement(
		          'div',
		          {
		            ref: 'slider',
		            style: sliderStyle
		          },
		          !disableTrack ? _react2.default.createElement(_SliderTrack2.default, {
		            trackLength: this.state.ratio,
		            color: trackColor,
		            vertical: vertical
		          }) : null,
		          label && this.state.displayLabel ? _react2.default.createElement(_SliderLabel2.default, {
		            position: this.state.ratio,
		            vertical: vertical,
		            color: trackColor,
		            value: this.state.value,
		            sliderSize: sliderSize,
		            thumbSize: this.state.thumbSize
		          }) : null,
		          _react2.default.createElement(_SliderThumb2.default, {
		            position: this.state.ratio,
		            vertical: vertical,
		            customThumb: children,
		            thumbSize: this.state.thumbSize,
		            sliderSize: sliderSize,
		            color: thumbColor,
		            disableThumb: disableThumb,
		            value: this.state.value
		          })
		        )
		      );
		    }
		  }]);
	
		  return Slider;
		}(_react.Component);
	
		Slider.propTypes = {
		  children: _propTypes2.default.element,
		  min: _propTypes2.default.number,
		  max: _propTypes2.default.number,
		  step: _propTypes2.default.number,
		  value: _propTypes2.default.number,
		  defaultValue: _propTypes2.default.number,
		  onChange: _propTypes2.default.func,
		  onChangeComplete: _propTypes2.default.func,
		  vertical: _propTypes2.default.bool,
		  verticalSliderHeight: _propTypes2.default.string,
		  eventWrapperPadding: _propTypes2.default.number,
		  label: _propTypes2.default.bool,
		  disableTrack: _propTypes2.default.bool,
		  disableThumb: _propTypes2.default.bool,
		  sliderColor: _propTypes2.default.string,
		  trackColor: _propTypes2.default.string,
		  thumbColor: _propTypes2.default.string,
		  sliderSize: _propTypes2.default.number,
		  thumbSize: _propTypes2.default.number,
		  id: _propTypes2.default.string
		};
		Slider.defaultProps = {
		  min: 0,
		  max: 100,
		  step: 1,
		  onChange: noOp,
		  onChangeComplete: noOp,
		  vertical: false,
		  verticalSliderHeight: '100px',
		  eventWrapperPadding: 8,
		  label: false,
		  disableTrack: false,
		  disableThumb: false,
		  sliderColor: '#B9B9B9',
		  trackColor: '#009688',
		  thumbColor: '#009688',
		  sliderSize: 4,
		  id: null
		};
		exports.default = Slider;
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_2__;
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 *
		 * This source code is licensed under the MIT license found in the
		 * LICENSE file in the root directory of this source tree.
		 */
	
		if ((undefined) !== 'production') {
		  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
		    Symbol.for &&
		    Symbol.for('react.element')) ||
		    0xeac7;
	
		  var isValidElement = function(object) {
		    return typeof object === 'object' &&
		      object !== null &&
		      object.$$typeof === REACT_ELEMENT_TYPE;
		  };
	
		  // By explicitly using `prop-types` you are opting into new development behavior.
		  // http://fb.me/prop-types-in-prod
		  var throwOnDirectAccess = true;
		  module.exports = __webpack_require__(4)(isValidElement, throwOnDirectAccess);
		} else {
		  // By explicitly using `prop-types` you are opting into new production behavior.
		  // http://fb.me/prop-types-in-prod
		  module.exports = __webpack_require__(11)();
		}
	
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 *
		 * This source code is licensed under the MIT license found in the
		 * LICENSE file in the root directory of this source tree.
		 */
	
		'use strict';
	
		var emptyFunction = __webpack_require__(5);
		var invariant = __webpack_require__(6);
		var warning = __webpack_require__(7);
		var assign = __webpack_require__(8);
	
		var ReactPropTypesSecret = __webpack_require__(9);
		var checkPropTypes = __webpack_require__(10);
	
		module.exports = function(isValidElement, throwOnDirectAccess) {
		  /* global Symbol */
		  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
		  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
		  /**
		   * Returns the iterator method function contained on the iterable object.
		   *
		   * Be sure to invoke the function with the iterable as context:
		   *
		   *     var iteratorFn = getIteratorFn(myIterable);
		   *     if (iteratorFn) {
		   *       var iterator = iteratorFn.call(myIterable);
		   *       ...
		   *     }
		   *
		   * @param {?object} maybeIterable
		   * @return {?function}
		   */
		  function getIteratorFn(maybeIterable) {
		    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
		    if (typeof iteratorFn === 'function') {
		      return iteratorFn;
		    }
		  }
	
		  /**
		   * Collection of methods that allow declaration and validation of props that are
		   * supplied to React components. Example usage:
		   *
		   *   var Props = require('ReactPropTypes');
		   *   var MyArticle = React.createClass({
		   *     propTypes: {
		   *       // An optional string prop named "description".
		   *       description: Props.string,
		   *
		   *       // A required enum prop named "category".
		   *       category: Props.oneOf(['News','Photos']).isRequired,
		   *
		   *       // A prop named "dialog" that requires an instance of Dialog.
		   *       dialog: Props.instanceOf(Dialog).isRequired
		   *     },
		   *     render: function() { ... }
		   *   });
		   *
		   * A more formal specification of how these methods are used:
		   *
		   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
		   *   decl := ReactPropTypes.{type}(.isRequired)?
		   *
		   * Each and every declaration produces a function with the same signature. This
		   * allows the creation of custom validation functions. For example:
		   *
		   *  var MyLink = React.createClass({
		   *    propTypes: {
		   *      // An optional string or URI prop named "href".
		   *      href: function(props, propName, componentName) {
		   *        var propValue = props[propName];
		   *        if (propValue != null && typeof propValue !== 'string' &&
		   *            !(propValue instanceof URI)) {
		   *          return new Error(
		   *            'Expected a string or an URI for ' + propName + ' in ' +
		   *            componentName
		   *          );
		   *        }
		   *      }
		   *    },
		   *    render: function() {...}
		   *  });
		   *
		   * @internal
		   */
	
		  var ANONYMOUS = '<<anonymous>>';
	
		  // Important!
		  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
		  var ReactPropTypes = {
		    array: createPrimitiveTypeChecker('array'),
		    bool: createPrimitiveTypeChecker('boolean'),
		    func: createPrimitiveTypeChecker('function'),
		    number: createPrimitiveTypeChecker('number'),
		    object: createPrimitiveTypeChecker('object'),
		    string: createPrimitiveTypeChecker('string'),
		    symbol: createPrimitiveTypeChecker('symbol'),
	
		    any: createAnyTypeChecker(),
		    arrayOf: createArrayOfTypeChecker,
		    element: createElementTypeChecker(),
		    instanceOf: createInstanceTypeChecker,
		    node: createNodeChecker(),
		    objectOf: createObjectOfTypeChecker,
		    oneOf: createEnumTypeChecker,
		    oneOfType: createUnionTypeChecker,
		    shape: createShapeTypeChecker,
		    exact: createStrictShapeTypeChecker,
		  };
	
		  /**
		   * inlined Object.is polyfill to avoid requiring consumers ship their own
		   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
		   */
		  /*eslint-disable no-self-compare*/
		  function is(x, y) {
		    // SameValue algorithm
		    if (x === y) {
		      // Steps 1-5, 7-10
		      // Steps 6.b-6.e: +0 != -0
		      return x !== 0 || 1 / x === 1 / y;
		    } else {
		      // Step 6.a: NaN == NaN
		      return x !== x && y !== y;
		    }
		  }
		  /*eslint-enable no-self-compare*/
	
		  /**
		   * We use an Error-like object for backward compatibility as people may call
		   * PropTypes directly and inspect their output. However, we don't use real
		   * Errors anymore. We don't inspect their stack anyway, and creating them
		   * is prohibitively expensive if they are created too often, such as what
		   * happens in oneOfType() for any type before the one that matched.
		   */
		  function PropTypeError(message) {
		    this.message = message;
		    this.stack = '';
		  }
		  // Make `instanceof Error` still work for returned errors.
		  PropTypeError.prototype = Error.prototype;
	
		  function createChainableTypeChecker(validate) {
		    if ((undefined) !== 'production') {
		      var manualPropTypeCallCache = {};
		      var manualPropTypeWarningCount = 0;
		    }
		    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
		      componentName = componentName || ANONYMOUS;
		      propFullName = propFullName || propName;
	
		      if (secret !== ReactPropTypesSecret) {
		        if (throwOnDirectAccess) {
		          // New behavior only for users of `prop-types` package
		          invariant(
		            false,
		            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
		            'Use `PropTypes.checkPropTypes()` to call them. ' +
		            'Read more at http://fb.me/use-check-prop-types'
		          );
		        } else if ((undefined) !== 'production' && typeof console !== 'undefined') {
		          // Old behavior for people using React.PropTypes
		          var cacheKey = componentName + ':' + propName;
		          if (
		            !manualPropTypeCallCache[cacheKey] &&
		            // Avoid spamming the console because they are often not actionable except for lib authors
		            manualPropTypeWarningCount < 3
		          ) {
		            warning(
		              false,
		              'You are manually calling a React.PropTypes validation ' +
		              'function for the `%s` prop on `%s`. This is deprecated ' +
		              'and will throw in the standalone `prop-types` package. ' +
		              'You may be seeing this warning due to a third-party PropTypes ' +
		              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
		              propFullName,
		              componentName
		            );
		            manualPropTypeCallCache[cacheKey] = true;
		            manualPropTypeWarningCount++;
		          }
		        }
		      }
		      if (props[propName] == null) {
		        if (isRequired) {
		          if (props[propName] === null) {
		            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
		          }
		          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
		        }
		        return null;
		      } else {
		        return validate(props, propName, componentName, location, propFullName);
		      }
		    }
	
		    var chainedCheckType = checkType.bind(null, false);
		    chainedCheckType.isRequired = checkType.bind(null, true);
	
		    return chainedCheckType;
		  }
	
		  function createPrimitiveTypeChecker(expectedType) {
		    function validate(props, propName, componentName, location, propFullName, secret) {
		      var propValue = props[propName];
		      var propType = getPropType(propValue);
		      if (propType !== expectedType) {
		        // `propValue` being instance of, say, date/regexp, pass the 'object'
		        // check, but we can offer a more precise error message here rather than
		        // 'of type `object`'.
		        var preciseType = getPreciseType(propValue);
	
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createAnyTypeChecker() {
		    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
		  }
	
		  function createArrayOfTypeChecker(typeChecker) {
		    function validate(props, propName, componentName, location, propFullName) {
		      if (typeof typeChecker !== 'function') {
		        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
		      }
		      var propValue = props[propName];
		      if (!Array.isArray(propValue)) {
		        var propType = getPropType(propValue);
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
		      }
		      for (var i = 0; i < propValue.length; i++) {
		        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
		        if (error instanceof Error) {
		          return error;
		        }
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createElementTypeChecker() {
		    function validate(props, propName, componentName, location, propFullName) {
		      var propValue = props[propName];
		      if (!isValidElement(propValue)) {
		        var propType = getPropType(propValue);
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createInstanceTypeChecker(expectedClass) {
		    function validate(props, propName, componentName, location, propFullName) {
		      if (!(props[propName] instanceof expectedClass)) {
		        var expectedClassName = expectedClass.name || ANONYMOUS;
		        var actualClassName = getClassName(props[propName]);
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createEnumTypeChecker(expectedValues) {
		    if (!Array.isArray(expectedValues)) {
		      (undefined) !== 'production' ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
		      return emptyFunction.thatReturnsNull;
		    }
	
		    function validate(props, propName, componentName, location, propFullName) {
		      var propValue = props[propName];
		      for (var i = 0; i < expectedValues.length; i++) {
		        if (is(propValue, expectedValues[i])) {
		          return null;
		        }
		      }
	
		      var valuesString = JSON.stringify(expectedValues);
		      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createObjectOfTypeChecker(typeChecker) {
		    function validate(props, propName, componentName, location, propFullName) {
		      if (typeof typeChecker !== 'function') {
		        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
		      }
		      var propValue = props[propName];
		      var propType = getPropType(propValue);
		      if (propType !== 'object') {
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
		      }
		      for (var key in propValue) {
		        if (propValue.hasOwnProperty(key)) {
		          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
		          if (error instanceof Error) {
		            return error;
		          }
		        }
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createUnionTypeChecker(arrayOfTypeCheckers) {
		    if (!Array.isArray(arrayOfTypeCheckers)) {
		      (undefined) !== 'production' ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
		      return emptyFunction.thatReturnsNull;
		    }
	
		    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
		      var checker = arrayOfTypeCheckers[i];
		      if (typeof checker !== 'function') {
		        warning(
		          false,
		          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
		          'received %s at index %s.',
		          getPostfixForTypeWarning(checker),
		          i
		        );
		        return emptyFunction.thatReturnsNull;
		      }
		    }
	
		    function validate(props, propName, componentName, location, propFullName) {
		      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
		        var checker = arrayOfTypeCheckers[i];
		        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
		          return null;
		        }
		      }
	
		      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createNodeChecker() {
		    function validate(props, propName, componentName, location, propFullName) {
		      if (!isNode(props[propName])) {
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createShapeTypeChecker(shapeTypes) {
		    function validate(props, propName, componentName, location, propFullName) {
		      var propValue = props[propName];
		      var propType = getPropType(propValue);
		      if (propType !== 'object') {
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
		      }
		      for (var key in shapeTypes) {
		        var checker = shapeTypes[key];
		        if (!checker) {
		          continue;
		        }
		        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
		        if (error) {
		          return error;
		        }
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createStrictShapeTypeChecker(shapeTypes) {
		    function validate(props, propName, componentName, location, propFullName) {
		      var propValue = props[propName];
		      var propType = getPropType(propValue);
		      if (propType !== 'object') {
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
		      }
		      // We need to check all keys in case some are required but missing from
		      // props.
		      var allKeys = assign({}, props[propName], shapeTypes);
		      for (var key in allKeys) {
		        var checker = shapeTypes[key];
		        if (!checker) {
		          return new PropTypeError(
		            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
		            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
		            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
		          );
		        }
		        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
		        if (error) {
		          return error;
		        }
		      }
		      return null;
		    }
	
		    return createChainableTypeChecker(validate);
		  }
	
		  function isNode(propValue) {
		    switch (typeof propValue) {
		      case 'number':
		      case 'string':
		      case 'undefined':
		        return true;
		      case 'boolean':
		        return !propValue;
		      case 'object':
		        if (Array.isArray(propValue)) {
		          return propValue.every(isNode);
		        }
		        if (propValue === null || isValidElement(propValue)) {
		          return true;
		        }
	
		        var iteratorFn = getIteratorFn(propValue);
		        if (iteratorFn) {
		          var iterator = iteratorFn.call(propValue);
		          var step;
		          if (iteratorFn !== propValue.entries) {
		            while (!(step = iterator.next()).done) {
		              if (!isNode(step.value)) {
		                return false;
		              }
		            }
		          } else {
		            // Iterator will provide entry [k,v] tuples rather than values.
		            while (!(step = iterator.next()).done) {
		              var entry = step.value;
		              if (entry) {
		                if (!isNode(entry[1])) {
		                  return false;
		                }
		              }
		            }
		          }
		        } else {
		          return false;
		        }
	
		        return true;
		      default:
		        return false;
		    }
		  }
	
		  function isSymbol(propType, propValue) {
		    // Native Symbol.
		    if (propType === 'symbol') {
		      return true;
		    }
	
		    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
		    if (propValue['@@toStringTag'] === 'Symbol') {
		      return true;
		    }
	
		    // Fallback for non-spec compliant Symbols which are polyfilled.
		    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
		      return true;
		    }
	
		    return false;
		  }
	
		  // Equivalent of `typeof` but with special handling for array and regexp.
		  function getPropType(propValue) {
		    var propType = typeof propValue;
		    if (Array.isArray(propValue)) {
		      return 'array';
		    }
		    if (propValue instanceof RegExp) {
		      // Old webkits (at least until Android 4.0) return 'function' rather than
		      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
		      // passes PropTypes.object.
		      return 'object';
		    }
		    if (isSymbol(propType, propValue)) {
		      return 'symbol';
		    }
		    return propType;
		  }
	
		  // This handles more types than `getPropType`. Only used for error messages.
		  // See `createPrimitiveTypeChecker`.
		  function getPreciseType(propValue) {
		    if (typeof propValue === 'undefined' || propValue === null) {
		      return '' + propValue;
		    }
		    var propType = getPropType(propValue);
		    if (propType === 'object') {
		      if (propValue instanceof Date) {
		        return 'date';
		      } else if (propValue instanceof RegExp) {
		        return 'regexp';
		      }
		    }
		    return propType;
		  }
	
		  // Returns a string that is postfixed to a warning about an invalid type.
		  // For example, "undefined" or "of type array"
		  function getPostfixForTypeWarning(value) {
		    var type = getPreciseType(value);
		    switch (type) {
		      case 'array':
		      case 'object':
		        return 'an ' + type;
		      case 'boolean':
		      case 'date':
		      case 'regexp':
		        return 'a ' + type;
		      default:
		        return type;
		    }
		  }
	
		  // Returns class name of the object, if any.
		  function getClassName(propValue) {
		    if (!propValue.constructor || !propValue.constructor.name) {
		      return ANONYMOUS;
		    }
		    return propValue.constructor.name;
		  }
	
		  ReactPropTypes.checkPropTypes = checkPropTypes;
		  ReactPropTypes.PropTypes = ReactPropTypes;
	
		  return ReactPropTypes;
		};
	
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 *
		 * This source code is licensed under the MIT license found in the
		 * LICENSE file in the root directory of this source tree.
		 *
		 * 
		 */
	
		function makeEmptyFunction(arg) {
		  return function () {
		    return arg;
		  };
		}
	
		/**
		 * This function accepts and discards inputs; it has no side effects. This is
		 * primarily useful idiomatically for overridable function endpoints which
		 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
		 */
		var emptyFunction = function emptyFunction() {};
	
		emptyFunction.thatReturns = makeEmptyFunction;
		emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
		emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
		emptyFunction.thatReturnsNull = makeEmptyFunction(null);
		emptyFunction.thatReturnsThis = function () {
		  return this;
		};
		emptyFunction.thatReturnsArgument = function (arg) {
		  return arg;
		};
	
		module.exports = emptyFunction;
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 *
		 * This source code is licensed under the MIT license found in the
		 * LICENSE file in the root directory of this source tree.
		 *
		 */
	
		'use strict';
	
		/**
		 * Use invariant() to assert state which your program assumes to be true.
		 *
		 * Provide sprintf-style format (only %s is supported) and arguments
		 * to provide information about what broke and what you were
		 * expecting.
		 *
		 * The invariant message will be stripped in production, but the invariant
		 * will remain to ensure logic does not differ in production.
		 */
	
		var validateFormat = function validateFormat(format) {};
	
		if ((undefined) !== 'production') {
		  validateFormat = function validateFormat(format) {
		    if (format === undefined) {
		      throw new Error('invariant requires an error message argument');
		    }
		  };
		}
	
		function invariant(condition, format, a, b, c, d, e, f) {
		  validateFormat(format);
	
		  if (!condition) {
		    var error;
		    if (format === undefined) {
		      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
		    } else {
		      var args = [a, b, c, d, e, f];
		      var argIndex = 0;
		      error = new Error(format.replace(/%s/g, function () {
		        return args[argIndex++];
		      }));
		      error.name = 'Invariant Violation';
		    }
	
		    error.framesToPop = 1; // we don't care about invariant's own frame
		    throw error;
		  }
		}
	
		module.exports = invariant;
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright (c) 2014-present, Facebook, Inc.
		 *
		 * This source code is licensed under the MIT license found in the
		 * LICENSE file in the root directory of this source tree.
		 *
		 */
	
		'use strict';
	
		var emptyFunction = __webpack_require__(5);
	
		/**
		 * Similar to invariant but only logs a warning if the condition is not met.
		 * This can be used to log issues in development environments in critical
		 * paths. Removing the logging code for production environments will keep the
		 * same logic and follow the same code paths.
		 */
	
		var warning = emptyFunction;
	
		if ((undefined) !== 'production') {
		  var printWarning = function printWarning(format) {
		    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
		      args[_key - 1] = arguments[_key];
		    }
	
		    var argIndex = 0;
		    var message = 'Warning: ' + format.replace(/%s/g, function () {
		      return args[argIndex++];
		    });
		    if (typeof console !== 'undefined') {
		      console.error(message);
		    }
		    try {
		      // --- Welcome to debugging React ---
		      // This error was thrown as a convenience so that you can use this stack
		      // to find the callsite that caused this warning to fire.
		      throw new Error(message);
		    } catch (x) {}
		  };
	
		  warning = function warning(condition, format) {
		    if (format === undefined) {
		      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
		    }
	
		    if (format.indexOf('Failed Composite propType: ') === 0) {
		      return; // Ignore CompositeComponent proptype check.
		    }
	
		    if (!condition) {
		      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
		        args[_key2 - 2] = arguments[_key2];
		      }
	
		      printWarning.apply(undefined, [format].concat(args));
		    }
		  };
		}
	
		module.exports = warning;
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports) {
	
		/*
		object-assign
		(c) Sindre Sorhus
		@license MIT
		*/
	
		'use strict';
		/* eslint-disable no-unused-vars */
		var getOwnPropertySymbols = Object.getOwnPropertySymbols;
		var hasOwnProperty = Object.prototype.hasOwnProperty;
		var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
		function toObject(val) {
			if (val === null || val === undefined) {
				throw new TypeError('Object.assign cannot be called with null or undefined');
			}
	
			return Object(val);
		}
	
		function shouldUseNative() {
			try {
				if (!Object.assign) {
					return false;
				}
	
				// Detect buggy property enumeration order in older V8 versions.
	
				// https://bugs.chromium.org/p/v8/issues/detail?id=4118
				var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
				test1[5] = 'de';
				if (Object.getOwnPropertyNames(test1)[0] === '5') {
					return false;
				}
	
				// https://bugs.chromium.org/p/v8/issues/detail?id=3056
				var test2 = {};
				for (var i = 0; i < 10; i++) {
					test2['_' + String.fromCharCode(i)] = i;
				}
				var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
					return test2[n];
				});
				if (order2.join('') !== '0123456789') {
					return false;
				}
	
				// https://bugs.chromium.org/p/v8/issues/detail?id=3056
				var test3 = {};
				'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
					test3[letter] = letter;
				});
				if (Object.keys(Object.assign({}, test3)).join('') !==
						'abcdefghijklmnopqrst') {
					return false;
				}
	
				return true;
			} catch (err) {
				// We don't expect any of the above to throw, but better to be safe.
				return false;
			}
		}
	
		module.exports = shouldUseNative() ? Object.assign : function (target, source) {
			var from;
			var to = toObject(target);
			var symbols;
	
			for (var s = 1; s < arguments.length; s++) {
				from = Object(arguments[s]);
	
				for (var key in from) {
					if (hasOwnProperty.call(from, key)) {
						to[key] = from[key];
					}
				}
	
				if (getOwnPropertySymbols) {
					symbols = getOwnPropertySymbols(from);
					for (var i = 0; i < symbols.length; i++) {
						if (propIsEnumerable.call(from, symbols[i])) {
							to[symbols[i]] = from[symbols[i]];
						}
					}
				}
			}
	
			return to;
		};
	
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports) {
	
		/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 *
		 * This source code is licensed under the MIT license found in the
		 * LICENSE file in the root directory of this source tree.
		 */
	
		'use strict';
	
		var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
		module.exports = ReactPropTypesSecret;
	
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 *
		 * This source code is licensed under the MIT license found in the
		 * LICENSE file in the root directory of this source tree.
		 */
	
		'use strict';
	
		if ((undefined) !== 'production') {
		  var invariant = __webpack_require__(6);
		  var warning = __webpack_require__(7);
		  var ReactPropTypesSecret = __webpack_require__(9);
		  var loggedTypeFailures = {};
		}
	
		/**
		 * Assert that the values match with the type specs.
		 * Error messages are memorized and will only be shown once.
		 *
		 * @param {object} typeSpecs Map of name to a ReactPropType
		 * @param {object} values Runtime values that need to be type-checked
		 * @param {string} location e.g. "prop", "context", "child context"
		 * @param {string} componentName Name of the component for error messages.
		 * @param {?Function} getStack Returns the component stack.
		 * @private
		 */
		function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
		  if ((undefined) !== 'production') {
		    for (var typeSpecName in typeSpecs) {
		      if (typeSpecs.hasOwnProperty(typeSpecName)) {
		        var error;
		        // Prop type validation may throw. In case they do, we don't want to
		        // fail the render phase where it didn't fail before. So we log it.
		        // After these have been cleaned up, we'll let them throw.
		        try {
		          // This is intentionally an invariant that gets caught. It's the same
		          // behavior as without this statement except with a better message.
		          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
		          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
		        } catch (ex) {
		          error = ex;
		        }
		        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
		        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
		          // Only monitor this failure once because there tends to be a lot of the
		          // same error.
		          loggedTypeFailures[error.message] = true;
	
		          var stack = getStack ? getStack() : '';
	
		          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
		        }
		      }
		    }
		  }
		}
	
		module.exports = checkPropTypes;
	
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 *
		 * This source code is licensed under the MIT license found in the
		 * LICENSE file in the root directory of this source tree.
		 */
	
		'use strict';
	
		var emptyFunction = __webpack_require__(5);
		var invariant = __webpack_require__(6);
		var ReactPropTypesSecret = __webpack_require__(9);
	
		module.exports = function() {
		  function shim(props, propName, componentName, location, propFullName, secret) {
		    if (secret === ReactPropTypesSecret) {
		      // It is still safe when called from React.
		      return;
		    }
		    invariant(
		      false,
		      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
		      'Use PropTypes.checkPropTypes() to call them. ' +
		      'Read more at http://fb.me/use-check-prop-types'
		    );
		  };
		  shim.isRequired = shim;
		  function getShim() {
		    return shim;
		  };
		  // Important!
		  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
		  var ReactPropTypes = {
		    array: shim,
		    bool: shim,
		    func: shim,
		    number: shim,
		    object: shim,
		    string: shim,
		    symbol: shim,
	
		    any: shim,
		    arrayOf: getShim,
		    element: shim,
		    instanceOf: getShim,
		    node: shim,
		    objectOf: getShim,
		    oneOf: getShim,
		    oneOfType: getShim,
		    shape: getShim,
		    exact: getShim
		  };
	
		  ReactPropTypes.checkPropTypes = emptyFunction;
		  ReactPropTypes.PropTypes = ReactPropTypes;
	
		  return ReactPropTypes;
		};
	
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _propTypes = __webpack_require__(3);
	
		var _propTypes2 = _interopRequireDefault(_propTypes);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var SliderThumb = function SliderThumb(_ref) {
		  var customThumb = _ref.customThumb,
		      disableThumb = _ref.disableThumb,
		      position = _ref.position,
		      thumbSize = _ref.thumbSize,
		      sliderSize = _ref.sliderSize,
		      color = _ref.color,
		      vertical = _ref.vertical;
	
		  var defaultThumb = void 0;
		  var thumbCentering = (sliderSize - thumbSize) * 0.5;
		  var thumbWrapperStyles = {
		    position: 'absolute',
		    get left() {
		      return !vertical ? position + '%' : undefined;
		    },
		    get top() {
		      return !vertical ? '0px' : undefined;
		    },
		    get bottom() {
		      return !vertical ? undefined : position + '%';
		    },
		    get marginTop() {
		      return !vertical ? thumbCentering + 'px' : undefined;
		    },
		    get marginLeft() {
		      return !vertical ? '-' + thumbSize * 0.5 + 'px' : thumbCentering + 'px';
		    },
		    get marginBottom() {
		      return !vertical ? undefined : '-' + thumbSize * 0.5 + 'px';
		    }
		  };
		  if (!customThumb) {
		    var defaultThumbStyles = {
		      backgroundColor: '' + color,
		      opacity: disableThumb ? '0' : '1',
		      borderRadius: '100%',
		      height: thumbSize + 'px',
		      width: thumbSize + 'px'
		    };
		    defaultThumb = _react2.default.createElement('div', { style: defaultThumbStyles });
		  }
		  return _react2.default.createElement(
		    'div',
		    { style: thumbWrapperStyles },
		    customThumb,
		    defaultThumb && defaultThumb
		  );
		};
		SliderThumb.propTypes = {
		  position: _propTypes2.default.number,
		  offsetTop: _propTypes2.default.number,
		  offsetLeft: _propTypes2.default.number,
		  sliderSize: _propTypes2.default.number,
		  thumbSize: _propTypes2.default.number,
		  color: _propTypes2.default.string,
		  vertical: _propTypes2.default.bool,
		  disableThumb: _propTypes2.default.bool,
		  customThumb: _propTypes2.default.node
		};
		exports.default = SliderThumb;
	
	/***/ }),
	/* 13 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _propTypes = __webpack_require__(3);
	
		var _propTypes2 = _interopRequireDefault(_propTypes);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var SliderLabel = function SliderLabel(_ref) {
		  var position = _ref.position,
		      color = _ref.color,
		      vertical = _ref.vertical,
		      value = _ref.value,
		      thumbSize = _ref.thumbSize,
		      sliderSize = _ref.sliderSize;
	
		  var labelCentering = -10 + sliderSize * 0.5;
		  var labelVerticalOffset = 6 + thumbSize * 0.6;
		  var labelWrapperStyles = {
		    position: 'absolute',
		    backgroundColor: color,
		    color: '#fff',
		    fontSize: '12px',
		    textAlign: 'center',
		    margin: '0',
		    zIndex: '5',
		    width: '20px',
		    height: '20px',
		    borderRadius: '2px',
		    get bottom() {
		      return !vertical ? undefined : position + '%';
		    },
		    get left() {
		      return !vertical ? position + '%' : undefined;
		    },
		    get top() {
		      return !vertical ? '-35px' : undefined;
		    },
		    get marginLeft() {
		      return !vertical ? '-10px' : labelCentering + 'px';
		    },
		    get marginBottom() {
		      return !vertical ? undefined : labelVerticalOffset + 'px';
		    }
		  };
		  var pointerStyles = {
		    position: 'absolute',
		    left: '50%',
		    marginLeft: '-4px',
		    bottom: '-4px',
		    borderColor: 'transparent',
		    borderStyle: 'solid',
		    width: '0',
		    height: '0',
		    borderWidth: '4px 4px 0 4px',
		    borderTopColor: color,
		    zIndex: '4'
		  };
		  return _react2.default.createElement(
		    'div',
		    { style: labelWrapperStyles },
		    _react2.default.createElement(
		      'span',
		      null,
		      value
		    ),
		    _react2.default.createElement('div', { style: pointerStyles })
		  );
		};
		SliderLabel.propTypes = {
		  position: _propTypes2.default.number,
		  color: _propTypes2.default.string,
		  vertical: _propTypes2.default.bool,
		  value: _propTypes2.default.number,
		  thumbSize: _propTypes2.default.number,
		  sliderSize: _propTypes2.default.number
		};
		exports.default = SliderLabel;
	
	/***/ }),
	/* 14 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _propTypes = __webpack_require__(3);
	
		var _propTypes2 = _interopRequireDefault(_propTypes);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var SliderTrack = function SliderTrack(_ref) {
		  var trackLength = _ref.trackLength,
		      color = _ref.color,
		      vertical = _ref.vertical;
	
		  var trackStyles = {
		    backgroundColor: color,
		    get width() {
		      return !vertical ? trackLength + '%' : '100%';
		    },
		    get height() {
		      return !vertical ? '100%' : trackLength + '%';
		    },
		    get position() {
		      return !vertical ? undefined : 'absolute';
		    },
		    get bottom() {
		      return !vertical ? undefined : '0';
		    }
		  };
		  return _react2.default.createElement('div', { style: trackStyles });
		};
		SliderTrack.propTypes = {
		  trackLength: _propTypes2.default.number,
		  color: _propTypes2.default.string,
		  vertical: _propTypes2.default.bool
		};
		exports.default = SliderTrack;
	
	/***/ })
	/******/ ])
	});
	;

/***/ },
/* 958 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _isEqual2 = _interopRequireDefault(__webpack_require__(98));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _AnimateManager = _interopRequireDefault(__webpack_require__(2324));
	
	var _easing = __webpack_require__(959);
	
	var _configUpdate = _interopRequireDefault(__webpack_require__(2325));
	
	var _util = __webpack_require__(304);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	var Animate =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Animate, _PureComponent);
	
	  function Animate(props, context) {
	    var _this;
	
	    _classCallCheck(this, Animate);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(Animate).call(this, props, context));
	    var _this$props = _this.props,
	        isActive = _this$props.isActive,
	        attributeName = _this$props.attributeName,
	        from = _this$props.from,
	        to = _this$props.to,
	        steps = _this$props.steps,
	        children = _this$props.children;
	    _this.handleStyleChange = _this.handleStyleChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.changeStyle = _this.changeStyle.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	
	    if (!isActive) {
	      _this.state = {
	        style: {}
	      }; // if children is a function and animation is not active, set style to 'to'
	
	      if (typeof children === 'function') {
	        _this.state = {
	          style: to
	        };
	      }
	
	      return _possibleConstructorReturn(_this);
	    }
	
	    if (steps && steps.length) {
	      _this.state = {
	        style: steps[0].style
	      };
	    } else if (from) {
	      if (typeof children === 'function') {
	        _this.state = {
	          style: from
	        };
	        return _possibleConstructorReturn(_this);
	      }
	
	      _this.state = {
	        style: attributeName ? _defineProperty({}, attributeName, from) : from
	      };
	    } else {
	      _this.state = {
	        style: {}
	      };
	    }
	
	    return _this;
	  }
	
	  _createClass(Animate, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this$props2 = this.props,
	          isActive = _this$props2.isActive,
	          canBegin = _this$props2.canBegin;
	      this.mounted = true;
	
	      if (!isActive || !canBegin) {
	        return;
	      }
	
	      this.runAnimation(this.props);
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var _this$props3 = this.props,
	          isActive = _this$props3.isActive,
	          canBegin = _this$props3.canBegin,
	          attributeName = _this$props3.attributeName,
	          shouldReAnimate = _this$props3.shouldReAnimate;
	
	      if (!canBegin) {
	        return;
	      }
	
	      if (!isActive) {
	        var newState = {
	          style: attributeName ? _defineProperty({}, attributeName, this.props.to) : this.props.to
	        };
	
	        if (this.state && this.state.style) {
	          if (attributeName && this.state.style[attributeName] !== this.props.to || !attributeName && this.state.style !== this.props.to) {
	            // eslint-disable-next-line react/no-did-update-set-state
	            this.setState(newState);
	          }
	        }
	
	        return;
	      }
	
	      if ((0, _isEqual2.default)(prevProps.to, this.props.to) && prevProps.canBegin && prevProps.isActive) {
	        return;
	      }
	
	      var isTriggered = !prevProps.canBegin || !prevProps.isActive;
	
	      if (this.manager) {
	        this.manager.stop();
	      }
	
	      if (this.stopJSAnimation) {
	        this.stopJSAnimation();
	      }
	
	      var from = isTriggered || shouldReAnimate ? this.props.from : prevProps.to;
	
	      if (this.state && this.state.style) {
	        var _newState = {
	          style: attributeName ? _defineProperty({}, attributeName, from) : from
	        };
	
	        if (attributeName && this.state.style[attributeName] !== from || !attributeName && this.state.style !== from) {
	          // eslint-disable-next-line react/no-did-update-set-state
	          this.setState(_newState);
	        }
	      }
	
	      this.runAnimation(_objectSpread({}, this.props, {
	        from: from,
	        begin: 0
	      }));
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.mounted = false;
	
	      if (this.unSubscribe) {
	        this.unSubscribe();
	      }
	
	      if (this.manager) {
	        this.manager.stop();
	        this.manager = null;
	      }
	
	      if (this.stopJSAnimation) {
	        this.stopJSAnimation();
	      }
	    }
	  }, {
	    key: "runJSAnimation",
	    value: function runJSAnimation(props) {
	      var _this2 = this;
	
	      var from = props.from,
	          to = props.to,
	          duration = props.duration,
	          easing = props.easing,
	          begin = props.begin,
	          onAnimationEnd = props.onAnimationEnd,
	          onAnimationStart = props.onAnimationStart;
	      var startAnimation = (0, _configUpdate.default)(from, to, (0, _easing.configEasing)(easing), duration, this.changeStyle);
	
	      var finalStartAnimation = function finalStartAnimation() {
	        _this2.stopJSAnimation = startAnimation();
	      };
	
	      this.manager.start([onAnimationStart, begin, finalStartAnimation, duration, onAnimationEnd]);
	    }
	  }, {
	    key: "runStepAnimation",
	    value: function runStepAnimation(props) {
	      var _this3 = this;
	
	      var steps = props.steps,
	          begin = props.begin,
	          onAnimationStart = props.onAnimationStart;
	      var _steps$ = steps[0],
	          initialStyle = _steps$.style,
	          _steps$$duration = _steps$.duration,
	          initialTime = _steps$$duration === void 0 ? 0 : _steps$$duration;
	
	      var addStyle = function addStyle(sequence, nextItem, index) {
	        if (index === 0) {
	          return sequence;
	        }
	
	        var duration = nextItem.duration,
	            _nextItem$easing = nextItem.easing,
	            easing = _nextItem$easing === void 0 ? 'ease' : _nextItem$easing,
	            style = nextItem.style,
	            nextProperties = nextItem.properties,
	            onAnimationEnd = nextItem.onAnimationEnd;
	        var preItem = index > 0 ? steps[index - 1] : nextItem;
	        var properties = nextProperties || Object.keys(style);
	
	        if (typeof easing === 'function' || easing === 'spring') {
	          return _toConsumableArray(sequence).concat([_this3.runJSAnimation.bind(_this3, {
	            from: preItem.style,
	            to: style,
	            duration: duration,
	            easing: easing
	          }), duration]);
	        }
	
	        var transition = (0, _util.getTransitionVal)(properties, duration, easing);
	
	        var newStyle = _objectSpread({}, preItem.style, style, {
	          transition: transition
	        });
	
	        return _toConsumableArray(sequence).concat([newStyle, duration, onAnimationEnd]).filter(_util.identity);
	      };
	
	      return this.manager.start([onAnimationStart].concat(_toConsumableArray(steps.reduce(addStyle, [initialStyle, Math.max(initialTime, begin)])), [props.onAnimationEnd]));
	    }
	  }, {
	    key: "runAnimation",
	    value: function runAnimation(props) {
	      if (!this.manager) {
	        this.manager = (0, _AnimateManager.default)();
	      }
	
	      var begin = props.begin,
	          duration = props.duration,
	          attributeName = props.attributeName,
	          propsTo = props.to,
	          easing = props.easing,
	          onAnimationStart = props.onAnimationStart,
	          onAnimationEnd = props.onAnimationEnd,
	          steps = props.steps,
	          children = props.children;
	      var manager = this.manager;
	      this.unSubscribe = manager.subscribe(this.handleStyleChange);
	
	      if (typeof easing === 'function' || typeof children === 'function' || easing === 'spring') {
	        this.runJSAnimation(props);
	        return;
	      }
	
	      if (steps.length > 1) {
	        this.runStepAnimation(props);
	        return;
	      }
	
	      var to = attributeName ? _defineProperty({}, attributeName, propsTo) : propsTo;
	      var transition = (0, _util.getTransitionVal)(Object.keys(to), duration, easing);
	      manager.start([onAnimationStart, begin, _objectSpread({}, to, {
	        transition: transition
	      }), duration, onAnimationEnd]);
	    }
	  }, {
	    key: "handleStyleChange",
	    value: function handleStyleChange(style) {
	      this.changeStyle(style);
	    }
	  }, {
	    key: "changeStyle",
	    value: function changeStyle(style) {
	      if (this.mounted) {
	        this.setState({
	          style: style
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props4 = this.props,
	          children = _this$props4.children,
	          begin = _this$props4.begin,
	          duration = _this$props4.duration,
	          attributeName = _this$props4.attributeName,
	          easing = _this$props4.easing,
	          isActive = _this$props4.isActive,
	          steps = _this$props4.steps,
	          from = _this$props4.from,
	          to = _this$props4.to,
	          canBegin = _this$props4.canBegin,
	          onAnimationEnd = _this$props4.onAnimationEnd,
	          shouldReAnimate = _this$props4.shouldReAnimate,
	          onAnimationReStart = _this$props4.onAnimationReStart,
	          others = _objectWithoutProperties(_this$props4, ["children", "begin", "duration", "attributeName", "easing", "isActive", "steps", "from", "to", "canBegin", "onAnimationEnd", "shouldReAnimate", "onAnimationReStart"]);
	
	      var count = _react.Children.count(children);
	
	      var stateStyle = (0, _util.translateStyle)(this.state.style);
	
	      if (typeof children === 'function') {
	        return children(stateStyle);
	      }
	
	      if (!isActive || count === 0) {
	        return children;
	      }
	
	      var cloneContainer = function cloneContainer(container) {
	        var _container$props = container.props,
	            _container$props$styl = _container$props.style,
	            style = _container$props$styl === void 0 ? {} : _container$props$styl,
	            className = _container$props.className;
	        var res = (0, _react.cloneElement)(container, _objectSpread({}, others, {
	          style: _objectSpread({}, style, stateStyle),
	          className: className
	        }));
	        return res;
	      };
	
	      if (count === 1) {
	        return cloneContainer(_react.Children.only(children));
	      }
	
	      return _react.default.createElement("div", null, _react.Children.map(children, function (child) {
	        return cloneContainer(child);
	      }));
	    }
	  }]);
	
	  return Animate;
	}(_react.PureComponent);
	
	Animate.displayName = 'Animate';
	Animate.propTypes = {
	  from: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string]),
	  to: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string]),
	  attributeName: _propTypes.default.string,
	  // animation duration
	  duration: _propTypes.default.number,
	  begin: _propTypes.default.number,
	  easing: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
	  steps: _propTypes.default.arrayOf(_propTypes.default.shape({
	    duration: _propTypes.default.number.isRequired,
	    style: _propTypes.default.object.isRequired,
	    easing: _propTypes.default.oneOfType([_propTypes.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear']), _propTypes.default.func]),
	    // transition css properties(dash case), optional
	    properties: _propTypes.default.arrayOf('string'),
	    onAnimationEnd: _propTypes.default.func
	  })),
	  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),
	  isActive: _propTypes.default.bool,
	  canBegin: _propTypes.default.bool,
	  onAnimationEnd: _propTypes.default.func,
	  // decide if it should reanimate with initial from style when props change
	  shouldReAnimate: _propTypes.default.bool,
	  onAnimationStart: _propTypes.default.func,
	  onAnimationReStart: _propTypes.default.func
	};
	Animate.defaultProps = {
	  begin: 0,
	  duration: 1000,
	  from: '',
	  to: '',
	  attributeName: '',
	  easing: 'ease',
	  isActive: true,
	  canBegin: true,
	  steps: [],
	  onAnimationEnd: function onAnimationEnd() {},
	  onAnimationStart: function onAnimationStart() {}
	};
	var _default = Animate;
	exports.default = _default;

/***/ },
/* 959 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.configEasing = exports.configSpring = exports.configBezier = void 0;
	
	var _util = __webpack_require__(304);
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	var ACCURACY = 1e-4;
	
	var cubicBezierFactor = function cubicBezierFactor(c1, c2) {
	  return [0, 3 * c1, 3 * c2 - 6 * c1, 3 * c1 - 3 * c2 + 1];
	};
	
	var multyTime = function multyTime(params, t) {
	  return params.map(function (param, i) {
	    return param * Math.pow(t, i);
	  }).reduce(function (pre, curr) {
	    return pre + curr;
	  });
	};
	
	var cubicBezier = function cubicBezier(c1, c2) {
	  return function (t) {
	    var params = cubicBezierFactor(c1, c2);
	    return multyTime(params, t);
	  };
	};
	
	var derivativeCubicBezier = function derivativeCubicBezier(c1, c2) {
	  return function (t) {
	    var params = cubicBezierFactor(c1, c2);
	
	    var newParams = _toConsumableArray(params.map(function (param, i) {
	      return param * i;
	    }).slice(1)).concat([0]);
	
	    return multyTime(newParams, t);
	  };
	}; // calculate cubic-bezier using Newton's method
	
	
	var configBezier = function configBezier() {
	  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  var x1 = args[0],
	      y1 = args[1],
	      x2 = args[2],
	      y2 = args[3];
	
	  if (args.length === 1) {
	    switch (args[0]) {
	      case 'linear':
	        x1 = 0.0;
	        y1 = 0.0;
	        x2 = 1.0;
	        y2 = 1.0;
	        break;
	
	      case 'ease':
	        x1 = 0.25;
	        y1 = 0.1;
	        x2 = 0.25;
	        y2 = 1.0;
	        break;
	
	      case 'ease-in':
	        x1 = 0.42;
	        y1 = 0.0;
	        x2 = 1.0;
	        y2 = 1.0;
	        break;
	
	      case 'ease-out':
	        x1 = 0.42;
	        y1 = 0.0;
	        x2 = 0.58;
	        y2 = 1.0;
	        break;
	
	      case 'ease-in-out':
	        x1 = 0.0;
	        y1 = 0.0;
	        x2 = 0.58;
	        y2 = 1.0;
	        break;
	
	      default:
	        {
	          var easing = args[0].split('(');
	
	          if (easing[0] === 'cubic-bezier' && easing[1].split(')')[0].split(',').length === 4) {
	            var _easing$1$split$0$spl = easing[1].split(')')[0].split(',').map(function (x) {
	              return parseFloat(x);
	            });
	
	            var _easing$1$split$0$spl2 = _slicedToArray(_easing$1$split$0$spl, 4);
	
	            x1 = _easing$1$split$0$spl2[0];
	            y1 = _easing$1$split$0$spl2[1];
	            x2 = _easing$1$split$0$spl2[2];
	            y2 = _easing$1$split$0$spl2[3];
	          } else {
	            (0, _util.warn)(false, '[configBezier]: arguments should be one of ' + 'oneOf \'linear\', \'ease\', \'ease-in\', \'ease-out\', ' + '\'ease-in-out\',\'cubic-bezier(x1,y1,x2,y2)\', instead received %s', args);
	          }
	        }
	    }
	  }
	
	  (0, _util.warn)([x1, x2, y1, y2].every(function (num) {
	    return typeof num === 'number' && num >= 0 && num <= 1;
	  }), '[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s', args);
	  var curveX = cubicBezier(x1, x2);
	  var curveY = cubicBezier(y1, y2);
	  var derCurveX = derivativeCubicBezier(x1, x2);
	
	  var rangeValue = function rangeValue(value) {
	    if (value > 1) {
	      return 1;
	    } else if (value < 0) {
	      return 0;
	    }
	
	    return value;
	  };
	
	  var bezier = function bezier(_t) {
	    var t = _t > 1 ? 1 : _t;
	    var x = t;
	
	    for (var i = 0; i < 8; ++i) {
	      var evalT = curveX(x) - t;
	      var derVal = derCurveX(x);
	
	      if (Math.abs(evalT - t) < ACCURACY || derVal < ACCURACY) {
	        return curveY(x);
	      }
	
	      x = rangeValue(x - evalT / derVal);
	    }
	
	    return curveY(x);
	  };
	
	  bezier.isStepper = false;
	  return bezier;
	};
	
	exports.configBezier = configBezier;
	
	var configSpring = function configSpring() {
	  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _config$stiff = config.stiff,
	      stiff = _config$stiff === void 0 ? 100 : _config$stiff,
	      _config$damping = config.damping,
	      damping = _config$damping === void 0 ? 8 : _config$damping,
	      _config$dt = config.dt,
	      dt = _config$dt === void 0 ? 17 : _config$dt;
	
	  var stepper = function stepper(currX, destX, currV) {
	    var FSpring = -(currX - destX) * stiff;
	    var FDamping = currV * damping;
	    var newV = currV + (FSpring - FDamping) * dt / 1000;
	    var newX = currV * dt / 1000 + currX;
	
	    if (Math.abs(newX - destX) < ACCURACY && Math.abs(newV) < ACCURACY) {
	      return [destX, 0];
	    }
	
	    return [newX, newV];
	  };
	
	  stepper.isStepper = true;
	  stepper.dt = dt;
	  return stepper;
	};
	
	exports.configSpring = configSpring;
	
	var configEasing = function configEasing() {
	  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	
	  var easing = args[0];
	
	  if (typeof easing === 'string') {
	    switch (easing) {
	      case 'ease':
	      case 'ease-in-out':
	      case 'ease-out':
	      case 'ease-in':
	      case 'linear':
	        return configBezier(easing);
	
	      case 'spring':
	        return configSpring();
	
	      default:
	        if (easing.split('(')[0] === 'cubic-bezier') {
	          return configBezier(easing);
	        }
	
	        (0, _util.warn)(false, '[configEasing]: first argument should be one of \'ease\', \'ease-in\', ' + '\'ease-out\', \'ease-in-out\',\'cubic-bezier(x1,y1,x2,y2)\', \'linear\' and \'spring\', instead  received %s', args);
	    }
	  }
	
	  if (typeof easing === 'function') {
	    return easing;
	  }
	
	  (0, _util.warn)(false, '[configEasing]: first argument type should be function or ' + 'string, instead received %s', args);
	  return null;
	};
	
	exports.configEasing = configEasing;

/***/ },
/* 960 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(2));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(31));
	
	var _reactLifecyclesCompat = __webpack_require__(227);
	
	var _PropTypes = __webpack_require__(962);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var UNMOUNTED = 'unmounted';
	exports.UNMOUNTED = UNMOUNTED;
	var EXITED = 'exited';
	exports.EXITED = EXITED;
	var ENTERING = 'entering';
	exports.ENTERING = ENTERING;
	var ENTERED = 'entered';
	exports.ENTERED = ENTERED;
	var EXITING = 'exiting';
	/**
	 * The Transition component lets you describe a transition from one component
	 * state to another _over time_ with a simple declarative API. Most commonly
	 * it's used to animate the mounting and unmounting of a component, but can also
	 * be used to describe in-place transition states as well.
	 *
	 * ---
	 *
	 * **Note**: `Transition` is a platform-agnostic base component. If you're using
	 * transitions in CSS, you'll probably want to use
	 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
	 * instead. It inherits all the features of `Transition`, but contains
	 * additional features necessary to play nice with CSS transitions (hence the
	 * name of the component).
	 *
	 * ---
	 *
	 * By default the `Transition` component does not alter the behavior of the
	 * component it renders, it only tracks "enter" and "exit" states for the
	 * components. It's up to you to give meaning and effect to those states. For
	 * example we can add styles to a component when it enters or exits:
	 *
	 * ```jsx
	 * import { Transition } from 'react-transition-group';
	 *
	 * const duration = 300;
	 *
	 * const defaultStyle = {
	 *   transition: `opacity ${duration}ms ease-in-out`,
	 *   opacity: 0,
	 * }
	 *
	 * const transitionStyles = {
	 *   entering: { opacity: 0 },
	 *   entered:  { opacity: 1 },
	 * };
	 *
	 * const Fade = ({ in: inProp }) => (
	 *   <Transition in={inProp} timeout={duration}>
	 *     {state => (
	 *       <div style={{
	 *         ...defaultStyle,
	 *         ...transitionStyles[state]
	 *       }}>
	 *         I'm a fade Transition!
	 *       </div>
	 *     )}
	 *   </Transition>
	 * );
	 * ```
	 *
	 * There are 4 main states a Transition can be in:
	 *  - `'entering'`
	 *  - `'entered'`
	 *  - `'exiting'`
	 *  - `'exited'`
	 *
	 * Transition state is toggled via the `in` prop. When `true` the component
	 * begins the "Enter" stage. During this stage, the component will shift from
	 * its current transition state, to `'entering'` for the duration of the
	 * transition and then to the `'entered'` stage once it's complete. Let's take
	 * the following example (we'll use the
	 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
	 *
	 * ```jsx
	 * function App() {
	 *   const [inProp, setInProp] = useState(false);
	 *   return (
	 *     <div>
	 *       <Transition in={inProp} timeout={500}>
	 *         {state => (
	 *           // ...
	 *         )}
	 *       </Transition>
	 *       <button onClick={() => setInProp(true)}>
	 *         Click to Enter
	 *       </button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the button is clicked the component will shift to the `'entering'` state
	 * and stay there for 500ms (the value of `timeout`) before it finally switches
	 * to `'entered'`.
	 *
	 * When `in` is `false` the same thing happens except the state moves from
	 * `'exiting'` to `'exited'`.
	 */
	
	exports.EXITING = EXITING;
	
	var Transition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(Transition, _React$Component);
	
	  function Transition(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears
	
	    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
	    var initialStatus;
	    _this.appearStatus = null;
	
	    if (props.in) {
	      if (appear) {
	        initialStatus = EXITED;
	        _this.appearStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }
	
	    _this.state = {
	      status: initialStatus
	    };
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  var _proto = Transition.prototype;
	
	  _proto.getChildContext = function getChildContext() {
	    return {
	      transitionGroup: null // allows for nested Transitions
	
	    };
	  };
	
	  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
	    var nextIn = _ref.in;
	
	    if (nextIn && prevState.status === UNMOUNTED) {
	      return {
	        status: EXITED
	      };
	    }
	
	    return null;
	  }; // getSnapshotBeforeUpdate(prevProps) {
	  //   let nextStatus = null
	  //   if (prevProps !== this.props) {
	  //     const { status } = this.state
	  //     if (this.props.in) {
	  //       if (status !== ENTERING && status !== ENTERED) {
	  //         nextStatus = ENTERING
	  //       }
	  //     } else {
	  //       if (status === ENTERING || status === ENTERED) {
	  //         nextStatus = EXITING
	  //       }
	  //     }
	  //   }
	  //   return { nextStatus }
	  // }
	
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.updateStatus(true, this.appearStatus);
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var nextStatus = null;
	
	    if (prevProps !== this.props) {
	      var status = this.state.status;
	
	      if (this.props.in) {
	        if (status !== ENTERING && status !== ENTERED) {
	          nextStatus = ENTERING;
	        }
	      } else {
	        if (status === ENTERING || status === ENTERED) {
	          nextStatus = EXITING;
	        }
	      }
	    }
	
	    this.updateStatus(false, nextStatus);
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.cancelNextCallback();
	  };
	
	  _proto.getTimeouts = function getTimeouts() {
	    var timeout = this.props.timeout;
	    var exit, enter, appear;
	    exit = enter = appear = timeout;
	
	    if (timeout != null && typeof timeout !== 'number') {
	      exit = timeout.exit;
	      enter = timeout.enter; // TODO: remove fallback for next major
	
	      appear = timeout.appear !== undefined ? timeout.appear : enter;
	    }
	
	    return {
	      exit: exit,
	      enter: enter,
	      appear: appear
	    };
	  };
	
	  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
	    if (mounting === void 0) {
	      mounting = false;
	    }
	
	    if (nextStatus !== null) {
	      // nextStatus will always be ENTERING or EXITING.
	      this.cancelNextCallback();
	
	      var node = _reactDom.default.findDOMNode(this);
	
	      if (nextStatus === ENTERING) {
	        this.performEnter(node, mounting);
	      } else {
	        this.performExit(node);
	      }
	    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
	      this.setState({
	        status: UNMOUNTED
	      });
	    }
	  };
	
	  _proto.performEnter = function performEnter(node, mounting) {
	    var _this2 = this;
	
	    var enter = this.props.enter;
	    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
	    var timeouts = this.getTimeouts();
	    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
	    // if we are mounting and running this it means appear _must_ be set
	
	    if (!mounting && !enter) {
	      this.safeSetState({
	        status: ENTERED
	      }, function () {
	        _this2.props.onEntered(node);
	      });
	      return;
	    }
	
	    this.props.onEnter(node, appearing);
	    this.safeSetState({
	      status: ENTERING
	    }, function () {
	      _this2.props.onEntering(node, appearing);
	
	      _this2.onTransitionEnd(node, enterTimeout, function () {
	        _this2.safeSetState({
	          status: ENTERED
	        }, function () {
	          _this2.props.onEntered(node, appearing);
	        });
	      });
	    });
	  };
	
	  _proto.performExit = function performExit(node) {
	    var _this3 = this;
	
	    var exit = this.props.exit;
	    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED
	
	    if (!exit) {
	      this.safeSetState({
	        status: EXITED
	      }, function () {
	        _this3.props.onExited(node);
	      });
	      return;
	    }
	
	    this.props.onExit(node);
	    this.safeSetState({
	      status: EXITING
	    }, function () {
	      _this3.props.onExiting(node);
	
	      _this3.onTransitionEnd(node, timeouts.exit, function () {
	        _this3.safeSetState({
	          status: EXITED
	        }, function () {
	          _this3.props.onExited(node);
	        });
	      });
	    });
	  };
	
	  _proto.cancelNextCallback = function cancelNextCallback() {
	    if (this.nextCallback !== null) {
	      this.nextCallback.cancel();
	      this.nextCallback = null;
	    }
	  };
	
	  _proto.safeSetState = function safeSetState(nextState, callback) {
	    // This shouldn't be necessary, but there are weird race conditions with
	    // setState callbacks and unmounting in testing, so always make sure that
	    // we can cancel any pending setState callbacks after we unmount.
	    callback = this.setNextCallback(callback);
	    this.setState(nextState, callback);
	  };
	
	  _proto.setNextCallback = function setNextCallback(callback) {
	    var _this4 = this;
	
	    var active = true;
	
	    this.nextCallback = function (event) {
	      if (active) {
	        active = false;
	        _this4.nextCallback = null;
	        callback(event);
	      }
	    };
	
	    this.nextCallback.cancel = function () {
	      active = false;
	    };
	
	    return this.nextCallback;
	  };
	
	  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
	    this.setNextCallback(handler);
	    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
	
	    if (!node || doesNotHaveTimeoutOrListener) {
	      setTimeout(this.nextCallback, 0);
	      return;
	    }
	
	    if (this.props.addEndListener) {
	      this.props.addEndListener(node, this.nextCallback);
	    }
	
	    if (timeout != null) {
	      setTimeout(this.nextCallback, timeout);
	    }
	  };
	
	  _proto.render = function render() {
	    var status = this.state.status;
	
	    if (status === UNMOUNTED) {
	      return null;
	    }
	
	    var _this$props = this.props,
	        children = _this$props.children,
	        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition
	
	
	    delete childProps.in;
	    delete childProps.mountOnEnter;
	    delete childProps.unmountOnExit;
	    delete childProps.appear;
	    delete childProps.enter;
	    delete childProps.exit;
	    delete childProps.timeout;
	    delete childProps.addEndListener;
	    delete childProps.onEnter;
	    delete childProps.onEntering;
	    delete childProps.onEntered;
	    delete childProps.onExit;
	    delete childProps.onExiting;
	    delete childProps.onExited;
	
	    if (typeof children === 'function') {
	      return children(status, childProps);
	    }
	
	    var child = _react.default.Children.only(children);
	
	    return _react.default.cloneElement(child, childProps);
	  };
	
	  return Transition;
	}(_react.default.Component);
	
	Transition.contextTypes = {
	  transitionGroup: PropTypes.object
	};
	Transition.childContextTypes = {
	  transitionGroup: function transitionGroup() {}
	};
	Transition.propTypes =  false ? {
	  /**
	   * A `function` child can be used instead of a React element. This function is
	   * called with the current transition status (`'entering'`, `'entered'`,
	   * `'exiting'`, `'exited'`, `'unmounted'`), which can be used to apply context
	   * specific props to a component.
	   *
	   * ```jsx
	   * <Transition in={this.state.in} timeout={150}>
	   *   {state => (
	   *     <MyComponent className={`fade fade-${state}`} />
	   *   )}
	   * </Transition>
	   * ```
	   */
	  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,
	
	  /**
	   * Show the component; triggers the enter or exit states
	   */
	  in: PropTypes.bool,
	
	  /**
	   * By default the child component is mounted immediately along with
	   * the parent `Transition` component. If you want to "lazy mount" the component on the
	   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
	   * mounted, even on "exited", unless you also specify `unmountOnExit`.
	   */
	  mountOnEnter: PropTypes.bool,
	
	  /**
	   * By default the child component stays mounted after it reaches the `'exited'` state.
	   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
	   */
	  unmountOnExit: PropTypes.bool,
	
	  /**
	   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
	   * If you want to transition on the first mount set `appear` to `true`, and the
	   * component will transition in as soon as the `<Transition>` mounts.
	   *
	   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
	   */
	  appear: PropTypes.bool,
	
	  /**
	   * Enable or disable enter transitions.
	   */
	  enter: PropTypes.bool,
	
	  /**
	   * Enable or disable exit transitions.
	   */
	  exit: PropTypes.bool,
	
	  /**
	   * The duration of the transition, in milliseconds.
	   * Required unless `addEndListener` is provided.
	   *
	   * You may specify a single timeout for all transitions:
	   *
	   * ```jsx
	   * timeout={500}
	   * ```
	   *
	   * or individually:
	   *
	   * ```jsx
	   * timeout={{
	   *  appear: 500,
	   *  enter: 300,
	   *  exit: 500,
	   * }}
	   * ```
	   *
	   * - `appear` defaults to the value of `enter`
	   * - `enter` defaults to `0`
	   * - `exit` defaults to `0`
	   *
	   * @type {number | { enter?: number, exit?: number, appear?: number }}
	   */
	  timeout: function timeout(props) {
	    var pt = _PropTypes.timeoutsShape;
	    if (!props.addEndListener) pt = pt.isRequired;
	
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return pt.apply(void 0, [props].concat(args));
	  },
	
	  /**
	   * Add a custom transition end trigger. Called with the transitioning
	   * DOM node and a `done` callback. Allows for more fine grained transition end
	   * logic. **Note:** Timeouts are still used as a fallback if provided.
	   *
	   * ```jsx
	   * addEndListener={(node, done) => {
	   *   // use the css transitionend event to mark the finish of a transition
	   *   node.addEventListener('transitionend', done, false);
	   * }}
	   * ```
	   */
	  addEndListener: PropTypes.func,
	
	  /**
	   * Callback fired before the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEnter: PropTypes.func,
	
	  /**
	   * Callback fired after the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,
	
	  /**
	   * Callback fired after the "entered" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEntered: PropTypes.func,
	
	  /**
	   * Callback fired before the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExit: PropTypes.func,
	
	  /**
	   * Callback fired after the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExiting: PropTypes.func,
	
	  /**
	   * Callback fired after the "exited" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExited: PropTypes.func // Name the function so it is clearer in the documentation
	
	} : {};
	
	function noop() {}
	
	Transition.defaultProps = {
	  in: false,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  appear: false,
	  enter: true,
	  exit: true,
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	Transition.UNMOUNTED = 0;
	Transition.EXITED = 1;
	Transition.ENTERING = 2;
	Transition.ENTERED = 3;
	Transition.EXITING = 4;
	
	var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);
	
	exports.default = _default;

/***/ },
/* 961 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactLifecyclesCompat = __webpack_require__(227);
	
	var _ChildMapping = __webpack_require__(2329);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	var values = Object.values || function (obj) {
	  return Object.keys(obj).map(function (k) {
	    return obj[k];
	  });
	};
	
	var defaultProps = {
	  component: 'div',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	  /**
	   * The `<TransitionGroup>` component manages a set of transition components
	   * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
	   * components, `<TransitionGroup>` is a state machine for managing the mounting
	   * and unmounting of components over time.
	   *
	   * Consider the example below. As items are removed or added to the TodoList the
	   * `in` prop is toggled automatically by the `<TransitionGroup>`.
	   *
	   * Note that `<TransitionGroup>`  does not define any animation behavior!
	   * Exactly _how_ a list item animates is up to the individual transition
	   * component. This means you can mix and match animations across different list
	   * items.
	   */
	
	};
	
	var TransitionGroup =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	
	    var handleExited = _this.handleExited.bind(_assertThisInitialized(_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear
	
	
	    _this.state = {
	      handleExited: handleExited,
	      firstRender: true
	    };
	    return _this;
	  }
	
	  var _proto = TransitionGroup.prototype;
	
	  _proto.getChildContext = function getChildContext() {
	    return {
	      transitionGroup: {
	        isMounting: !this.appeared
	      }
	    };
	  };
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.appeared = true;
	    this.mounted = true;
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.mounted = false;
	  };
	
	  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
	    var prevChildMapping = _ref.children,
	        handleExited = _ref.handleExited,
	        firstRender = _ref.firstRender;
	    return {
	      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
	      firstRender: false
	    };
	  };
	
	  _proto.handleExited = function handleExited(child, node) {
	    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
	    if (child.key in currentChildMapping) return;
	
	    if (child.props.onExited) {
	      child.props.onExited(node);
	    }
	
	    if (this.mounted) {
	      this.setState(function (state) {
	        var children = _extends({}, state.children);
	
	        delete children[child.key];
	        return {
	          children: children
	        };
	      });
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        Component = _this$props.component,
	        childFactory = _this$props.childFactory,
	        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);
	
	    var children = values(this.state.children).map(childFactory);
	    delete props.appear;
	    delete props.enter;
	    delete props.exit;
	
	    if (Component === null) {
	      return children;
	    }
	
	    return _react.default.createElement(Component, props, children);
	  };
	
	  return TransitionGroup;
	}(_react.default.Component);
	
	TransitionGroup.childContextTypes = {
	  transitionGroup: _propTypes.default.object.isRequired
	};
	TransitionGroup.propTypes =  false ? {
	  /**
	   * `<TransitionGroup>` renders a `<div>` by default. You can change this
	   * behavior by providing a `component` prop.
	   * If you use React v16+ and would like to avoid a wrapping `<div>` element
	   * you can pass in `component={null}`. This is useful if the wrapping div
	   * borks your css styles.
	   */
	  component: _propTypes.default.any,
	
	  /**
	   * A set of `<Transition>` components, that are toggled `in` and out as they
	   * leave. the `<TransitionGroup>` will inject specific transition props, so
	   * remember to spread them through if you are wrapping the `<Transition>` as
	   * with our `<Fade>` example.
	   *
	   * While this component is meant for multiple `Transition` or `CSSTransition`
	   * children, sometimes you may want to have a single transition child with
	   * content that you want to be transitioned out and in when you change it
	   * (e.g. routes, images etc.) In that case you can change the `key` prop of
	   * the transition child as you change its content, this will cause
	   * `TransitionGroup` to transition the child out and back in.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * A convenience prop that enables or disables appear animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  appear: _propTypes.default.bool,
	
	  /**
	   * A convenience prop that enables or disables enter animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  enter: _propTypes.default.bool,
	
	  /**
	   * A convenience prop that enables or disables exit animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  exit: _propTypes.default.bool,
	
	  /**
	   * You may need to apply reactive updates to a child as it is exiting.
	   * This is generally done by using `cloneElement` however in the case of an exiting
	   * child the element has already been removed and not accessible to the consumer.
	   *
	   * If you do need to update a child as it leaves you can provide a `childFactory`
	   * to wrap every child, even the ones that are leaving.
	   *
	   * @type Function(child: ReactElement) -> ReactElement
	   */
	  childFactory: _propTypes.default.func
	} : {};
	TransitionGroup.defaultProps = defaultProps;
	
	var _default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 962 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.classNamesShape = exports.timeoutsShape = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var timeoutsShape =  false ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	  enter: _propTypes.default.number,
	  exit: _propTypes.default.number,
	  appear: _propTypes.default.number
	}).isRequired]) : null;
	exports.timeoutsShape = timeoutsShape;
	var classNamesShape =  false ? _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
	  enter: _propTypes.default.string,
	  exit: _propTypes.default.string,
	  active: _propTypes.default.string
	}), _propTypes.default.shape({
	  enter: _propTypes.default.string,
	  enterDone: _propTypes.default.string,
	  enterActive: _propTypes.default.string,
	  exit: _propTypes.default.string,
	  exitDone: _propTypes.default.string,
	  exitActive: _propTypes.default.string
	})]) : null;
	exports.classNamesShape = classNamesShape;

/***/ },
/* 963 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(27));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(14);
	
	var _Fade = _interopRequireDefault(__webpack_require__(229));
	
	var _excluded = ["className", "closeClassName", "closeAriaLabel", "cssModule", "tag", "color", "isOpen", "toggle", "children", "transition", "fade", "innerRef"];
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	var propTypes = {
	  children: _propTypes.default.node,
	  className: _propTypes.default.string,
	  closeClassName: _propTypes.default.string,
	  closeAriaLabel: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  color: _propTypes.default.string,
	  fade: _propTypes.default.bool,
	  isOpen: _propTypes.default.bool,
	  toggle: _propTypes.default.func,
	  tag: _utils.tagPropType,
	  transition: _propTypes.default.shape(_Fade.default.propTypes),
	  innerRef: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string, _propTypes.default.func])
	};
	var defaultProps = {
	  color: 'success',
	  isOpen: true,
	  tag: 'div',
	  closeAriaLabel: 'Close',
	  fade: true,
	  transition: _objectSpread(_objectSpread({}, _Fade.default.defaultProps), {}, {
	    unmountOnExit: true
	  })
	};
	
	function Alert(props) {
	  var className = props.className,
	      closeClassName = props.closeClassName,
	      closeAriaLabel = props.closeAriaLabel,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      color = props.color,
	      isOpen = props.isOpen,
	      toggle = props.toggle,
	      children = props.children,
	      transition = props.transition,
	      fade = props.fade,
	      innerRef = props.innerRef,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'alert', "alert-" + color, {
	    'alert-dismissible': toggle
	  }), cssModule);
	  var closeClasses = (0, _utils.mapToCssModules)((0, _classnames.default)('close', closeClassName), cssModule);
	
	  var alertTransition = _objectSpread(_objectSpread(_objectSpread({}, _Fade.default.defaultProps), transition), {}, {
	    baseClass: fade ? transition.baseClass : '',
	    timeout: fade ? transition.timeout : 0
	  });
	
	  return /*#__PURE__*/_react.default.createElement(_Fade.default, (0, _extends2.default)({}, attributes, alertTransition, {
	    tag: Tag,
	    className: classes,
	    in: isOpen,
	    role: "alert",
	    innerRef: innerRef
	  }), toggle ? /*#__PURE__*/_react.default.createElement("button", {
	    type: "button",
	    className: closeClasses,
	    "aria-label": closeAriaLabel,
	    onClick: toggle
	  }, /*#__PURE__*/_react.default.createElement("span", {
	    "aria-hidden": "true"
	  }, "\xD7")) : null, children);
	}
	
	Alert.propTypes = propTypes;
	Alert.defaultProps = defaultProps;
	var _default = Alert;
	exports.default = _default;

/***/ },
/* 964 */
[2683, 305],
/* 965 */
[2700, 471, 14],
/* 966 */
[2701, 14],
/* 967 */
[2702, 14],
/* 968 */
[2703, 14],
/* 969 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(20));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(27));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _reactTransitionGroup = __webpack_require__(472);
	
	var _utils = __webpack_require__(14);
	
	var _excluded = ["tag", "isOpen", "className", "navbar", "cssModule", "children", "innerRef"];
	
	var _transitionStatusToCl;
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	var propTypes = _objectSpread(_objectSpread({}, _reactTransitionGroup.Transition.propTypes), {}, {
	  isOpen: _propTypes.default.bool,
	  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]),
	  tag: _utils.tagPropType,
	  className: _propTypes.default.node,
	  navbar: _propTypes.default.bool,
	  cssModule: _propTypes.default.object,
	  innerRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.string, _propTypes.default.object])
	});
	
	var defaultProps = _objectSpread(_objectSpread({}, _reactTransitionGroup.Transition.defaultProps), {}, {
	  isOpen: false,
	  appear: false,
	  enter: true,
	  exit: true,
	  tag: 'div',
	  timeout: _utils.TransitionTimeouts.Collapse
	});
	
	var transitionStatusToClassHash = (_transitionStatusToCl = {}, _transitionStatusToCl[_utils.TransitionStatuses.ENTERING] = 'collapsing', _transitionStatusToCl[_utils.TransitionStatuses.ENTERED] = 'collapse show', _transitionStatusToCl[_utils.TransitionStatuses.EXITING] = 'collapsing', _transitionStatusToCl[_utils.TransitionStatuses.EXITED] = 'collapse', _transitionStatusToCl);
	
	function getTransitionClass(status) {
	  return transitionStatusToClassHash[status] || 'collapse';
	}
	
	function getHeight(node) {
	  return node.scrollHeight;
	}
	
	var Collapse = /*#__PURE__*/function (_Component) {
	  (0, _inheritsLoose2.default)(Collapse, _Component);
	
	  function Collapse(props) {
	    var _this;
	
	    _this = _Component.call(this, props) || this;
	    _this.state = {
	      height: null
	    };
	    ['onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited'].forEach(function (name) {
	      _this[name] = _this[name].bind((0, _assertThisInitialized2.default)(_this));
	    });
	    return _this;
	  }
	
	  var _proto = Collapse.prototype;
	
	  _proto.onEntering = function onEntering(node, isAppearing) {
	    this.setState({
	      height: getHeight(node)
	    });
	    this.props.onEntering(node, isAppearing);
	  };
	
	  _proto.onEntered = function onEntered(node, isAppearing) {
	    this.setState({
	      height: null
	    });
	    this.props.onEntered(node, isAppearing);
	  };
	
	  _proto.onExit = function onExit(node) {
	    this.setState({
	      height: getHeight(node)
	    });
	    this.props.onExit(node);
	  };
	
	  _proto.onExiting = function onExiting(node) {
	    // getting this variable triggers a reflow
	    var _unused = node.offsetHeight; // eslint-disable-line no-unused-vars
	
	    this.setState({
	      height: 0
	    });
	    this.props.onExiting(node);
	  };
	
	  _proto.onExited = function onExited(node) {
	    this.setState({
	      height: null
	    });
	    this.props.onExited(node);
	  };
	
	  _proto.render = function render() {
	    var _this2 = this;
	
	    var _this$props = this.props,
	        Tag = _this$props.tag,
	        isOpen = _this$props.isOpen,
	        className = _this$props.className,
	        navbar = _this$props.navbar,
	        cssModule = _this$props.cssModule,
	        children = _this$props.children,
	        innerRef = _this$props.innerRef,
	        otherProps = (0, _objectWithoutPropertiesLoose2.default)(_this$props, _excluded);
	    var height = this.state.height;
	    var transitionProps = (0, _utils.pick)(otherProps, _utils.TransitionPropTypeKeys);
	    var childProps = (0, _utils.omit)(otherProps, _utils.TransitionPropTypeKeys);
	    return /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.Transition, (0, _extends2.default)({}, transitionProps, {
	      in: isOpen,
	      onEntering: this.onEntering,
	      onEntered: this.onEntered,
	      onExit: this.onExit,
	      onExiting: this.onExiting,
	      onExited: this.onExited
	    }), function (status) {
	      var collapseClass = getTransitionClass(status);
	      var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, collapseClass, navbar && 'navbar-collapse'), cssModule);
	      var style = height === null ? null : {
	        height: height
	      };
	      return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, childProps, {
	        style: _objectSpread(_objectSpread({}, childProps.style), style),
	        className: classes,
	        ref: _this2.props.innerRef
	      }), children);
	    });
	  };
	
	  return Collapse;
	}(_react.Component);
	
	Collapse.propTypes = propTypes;
	Collapse.defaultProps = defaultProps;
	var _default = Collapse;
	exports.default = _default;

/***/ },
/* 970 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(20));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(14);
	
	var _excluded = ["className", "label", "valid", "invalid", "cssModule", "children", "bsSize", "innerRef", "htmlFor", "type", "onChange", "dataBrowse", "hidden"];
	var propTypes = {
	  className: _propTypes.default.string,
	  id: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,
	  label: _propTypes.default.node,
	  valid: _propTypes.default.bool,
	  invalid: _propTypes.default.bool,
	  bsSize: _propTypes.default.string,
	  htmlFor: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  onChange: _propTypes.default.func,
	  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.array, _propTypes.default.func]),
	  innerRef: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string, _propTypes.default.func])
	};
	
	var CustomFileInput = /*#__PURE__*/function (_React$Component) {
	  (0, _inheritsLoose2.default)(CustomFileInput, _React$Component);
	
	  function CustomFileInput(props) {
	    var _this;
	
	    _this = _React$Component.call(this, props) || this;
	    _this.state = {
	      files: null
	    };
	    _this.onChange = _this.onChange.bind((0, _assertThisInitialized2.default)(_this));
	    return _this;
	  }
	
	  var _proto = CustomFileInput.prototype;
	
	  _proto.onChange = function onChange(e) {
	    var input = e.target;
	    var onChange = this.props.onChange;
	    var files = this.getSelectedFiles(input);
	
	    if (typeof onChange === "function") {
	      onChange.apply(void 0, arguments);
	    }
	
	    this.setState({
	      files: files
	    });
	  };
	
	  _proto.getSelectedFiles = function getSelectedFiles(input) {
	    var multiple = this.props.multiple;
	
	    if (multiple && input.files) {
	      var files = [].slice.call(input.files);
	      return files.map(function (file) {
	        return file.name;
	      }).join(", ");
	    }
	
	    if (input.value.indexOf("fakepath") !== -1) {
	      var parts = input.value.split("\\");
	      return parts[parts.length - 1];
	    }
	
	    return input.value;
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        className = _this$props.className,
	        label = _this$props.label,
	        valid = _this$props.valid,
	        invalid = _this$props.invalid,
	        cssModule = _this$props.cssModule,
	        children = _this$props.children,
	        bsSize = _this$props.bsSize,
	        innerRef = _this$props.innerRef,
	        htmlFor = _this$props.htmlFor,
	        type = _this$props.type,
	        onChange = _this$props.onChange,
	        dataBrowse = _this$props.dataBrowse,
	        hidden = _this$props.hidden,
	        attributes = (0, _objectWithoutPropertiesLoose2.default)(_this$props, _excluded);
	    var customClass = (0, _utils.mapToCssModules)((0, _classnames.default)(className, "custom-file"), cssModule);
	    var validationClassNames = (0, _utils.mapToCssModules)((0, _classnames.default)(invalid && "is-invalid", valid && "is-valid"), cssModule);
	    var labelHtmlFor = htmlFor || attributes.id;
	    var files = this.state.files;
	    return /*#__PURE__*/_react.default.createElement("div", {
	      className: customClass,
	      hidden: hidden || false
	    }, /*#__PURE__*/_react.default.createElement("input", (0, _extends2.default)({
	      type: "file"
	    }, attributes, {
	      ref: innerRef,
	      "aria-invalid": invalid,
	      className: (0, _classnames.default)(validationClassNames, (0, _utils.mapToCssModules)("custom-file-input", cssModule)),
	      onChange: this.onChange
	    })), /*#__PURE__*/_react.default.createElement("label", {
	      className: (0, _utils.mapToCssModules)("custom-file-label", cssModule),
	      htmlFor: labelHtmlFor,
	      "data-browse": dataBrowse
	    }, files || label || "Choose file"), children);
	  };
	
	  return CustomFileInput;
	}(_react.default.Component);
	
	CustomFileInput.propTypes = propTypes;
	var _default = CustomFileInput;
	exports.default = _default;

/***/ },
/* 971 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(14);
	
	var _excluded = ["className", "cssModule", "tag"];
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'span'
	};
	
	var InputGroupText = function InputGroupText(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'input-group-text'), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	InputGroupText.propTypes = propTypes;
	InputGroupText.defaultProps = defaultProps;
	var _default = InputGroupText;
	exports.default = _default;

/***/ },
/* 972 */
[2747, 976],
/* 973 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(20));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(27));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(31));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _reactPopper = __webpack_require__(75);
	
	var _utils = __webpack_require__(14);
	
	var _Fade = _interopRequireDefault(__webpack_require__(229));
	
	var _excluded = ["cssModule", "children", "isOpen", "flip", "target", "offset", "fallbackPlacement", "placementPrefix", "arrowClassName", "hideArrow", "popperClassName", "tag", "container", "modifiers", "positionFixed", "boundariesElement", "onClosed", "fade", "transition", "placement"];
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function noop() {}
	
	var propTypes = {
	  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]).isRequired,
	  popperClassName: _propTypes.default.string,
	  placement: _propTypes.default.string,
	  placementPrefix: _propTypes.default.string,
	  arrowClassName: _propTypes.default.string,
	  hideArrow: _propTypes.default.bool,
	  tag: _utils.tagPropType,
	  isOpen: _propTypes.default.bool.isRequired,
	  cssModule: _propTypes.default.object,
	  offset: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  fallbackPlacement: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.array]),
	  flip: _propTypes.default.bool,
	  container: _utils.targetPropType,
	  target: _utils.targetPropType.isRequired,
	  modifiers: _propTypes.default.object,
	  positionFixed: _propTypes.default.bool,
	  boundariesElement: _propTypes.default.oneOfType([_propTypes.default.string, _utils.DOMElement]),
	  onClosed: _propTypes.default.func,
	  fade: _propTypes.default.bool,
	  transition: _propTypes.default.shape(_Fade.default.propTypes)
	};
	var defaultProps = {
	  boundariesElement: 'scrollParent',
	  placement: 'auto',
	  hideArrow: false,
	  isOpen: false,
	  offset: 0,
	  fallbackPlacement: 'flip',
	  flip: true,
	  container: 'body',
	  modifiers: {},
	  onClosed: noop,
	  fade: true,
	  transition: _objectSpread({}, _Fade.default.defaultProps)
	};
	
	var PopperContent = /*#__PURE__*/function (_React$Component) {
	  (0, _inheritsLoose2.default)(PopperContent, _React$Component);
	
	  function PopperContent(props) {
	    var _this;
	
	    _this = _React$Component.call(this, props) || this;
	    _this.setTargetNode = _this.setTargetNode.bind((0, _assertThisInitialized2.default)(_this));
	    _this.getTargetNode = _this.getTargetNode.bind((0, _assertThisInitialized2.default)(_this));
	    _this.getRef = _this.getRef.bind((0, _assertThisInitialized2.default)(_this));
	    _this.onClosed = _this.onClosed.bind((0, _assertThisInitialized2.default)(_this));
	    _this.state = {
	      isOpen: props.isOpen
	    };
	    return _this;
	  }
	
	  PopperContent.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
	    if (props.isOpen && !state.isOpen) {
	      return {
	        isOpen: props.isOpen
	      };
	    } else return null;
	  };
	
	  var _proto = PopperContent.prototype;
	
	  _proto.componentDidUpdate = function componentDidUpdate() {
	    if (this._element && this._element.childNodes && this._element.childNodes[0] && this._element.childNodes[0].focus) {
	      this._element.childNodes[0].focus();
	    }
	  };
	
	  _proto.setTargetNode = function setTargetNode(node) {
	    this.targetNode = typeof node === 'string' ? (0, _utils.getTarget)(node) : node;
	  };
	
	  _proto.getTargetNode = function getTargetNode() {
	    return this.targetNode;
	  };
	
	  _proto.getContainerNode = function getContainerNode() {
	    return (0, _utils.getTarget)(this.props.container);
	  };
	
	  _proto.getRef = function getRef(ref) {
	    this._element = ref;
	  };
	
	  _proto.onClosed = function onClosed() {
	    this.props.onClosed();
	    this.setState({
	      isOpen: false
	    });
	  };
	
	  _proto.renderChildren = function renderChildren() {
	    var _this$props = this.props,
	        cssModule = _this$props.cssModule,
	        children = _this$props.children,
	        isOpen = _this$props.isOpen,
	        flip = _this$props.flip,
	        target = _this$props.target,
	        offset = _this$props.offset,
	        fallbackPlacement = _this$props.fallbackPlacement,
	        placementPrefix = _this$props.placementPrefix,
	        _arrowClassName = _this$props.arrowClassName,
	        hideArrow = _this$props.hideArrow,
	        _popperClassName = _this$props.popperClassName,
	        tag = _this$props.tag,
	        container = _this$props.container,
	        modifiers = _this$props.modifiers,
	        positionFixed = _this$props.positionFixed,
	        boundariesElement = _this$props.boundariesElement,
	        onClosed = _this$props.onClosed,
	        fade = _this$props.fade,
	        transition = _this$props.transition,
	        placement = _this$props.placement,
	        attrs = (0, _objectWithoutPropertiesLoose2.default)(_this$props, _excluded);
	    var arrowClassName = (0, _utils.mapToCssModules)((0, _classnames.default)('arrow', _arrowClassName), cssModule);
	    var popperClassName = (0, _utils.mapToCssModules)((0, _classnames.default)(_popperClassName, placementPrefix ? placementPrefix + "-auto" : ''), this.props.cssModule);
	
	    var extendedModifiers = _objectSpread({
	      offset: {
	        offset: offset
	      },
	      flip: {
	        enabled: flip,
	        behavior: fallbackPlacement
	      },
	      preventOverflow: {
	        boundariesElement: boundariesElement
	      }
	    }, modifiers);
	
	    var popperTransition = _objectSpread(_objectSpread(_objectSpread({}, _Fade.default.defaultProps), transition), {}, {
	      baseClass: fade ? transition.baseClass : '',
	      timeout: fade ? transition.timeout : 0
	    });
	
	    return /*#__PURE__*/_react.default.createElement(_Fade.default, (0, _extends2.default)({}, popperTransition, attrs, {
	      in: isOpen,
	      onExited: this.onClosed,
	      tag: tag
	    }), /*#__PURE__*/_react.default.createElement(_reactPopper.Popper, {
	      referenceElement: this.targetNode,
	      modifiers: extendedModifiers,
	      placement: placement,
	      positionFixed: positionFixed
	    }, function (_ref) {
	      var ref = _ref.ref,
	          style = _ref.style,
	          placement = _ref.placement,
	          outOfBoundaries = _ref.outOfBoundaries,
	          arrowProps = _ref.arrowProps,
	          scheduleUpdate = _ref.scheduleUpdate;
	      return /*#__PURE__*/_react.default.createElement("div", {
	        ref: ref,
	        style: style,
	        className: popperClassName,
	        "x-placement": placement,
	        "x-out-of-boundaries": outOfBoundaries ? 'true' : undefined
	      }, typeof children === 'function' ? children({
	        scheduleUpdate: scheduleUpdate
	      }) : children, !hideArrow && /*#__PURE__*/_react.default.createElement("span", {
	        ref: arrowProps.ref,
	        className: arrowClassName,
	        style: arrowProps.style
	      }));
	    }));
	  };
	
	  _proto.render = function render() {
	    this.setTargetNode(this.props.target);
	
	    if (this.state.isOpen) {
	      return this.props.container === 'inline' ? this.renderChildren() : /*#__PURE__*/_reactDom.default.createPortal( /*#__PURE__*/_react.default.createElement("div", {
	        ref: this.getRef
	      }, this.renderChildren()), this.getContainerNode());
	    }
	
	    return null;
	  };
	
	  return PopperContent;
	}(_react.default.Component);
	
	PopperContent.propTypes = propTypes;
	PopperContent.defaultProps = defaultProps;
	var _default = PopperContent;
	exports.default = _default;

/***/ },
/* 974 */
611,
/* 975 */
[2762, 976],
/* 976 */
[2763, 973, 14],
/* 977 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(2));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(31));
	
	var _reactLifecyclesCompat = __webpack_require__(227);
	
	var _PropTypes = __webpack_require__(980);
	
	var _TransitionGroupContext = _interopRequireDefault(__webpack_require__(979));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var UNMOUNTED = 'unmounted';
	exports.UNMOUNTED = UNMOUNTED;
	var EXITED = 'exited';
	exports.EXITED = EXITED;
	var ENTERING = 'entering';
	exports.ENTERING = ENTERING;
	var ENTERED = 'entered';
	exports.ENTERED = ENTERED;
	var EXITING = 'exiting';
	/**
	 * The Transition component lets you describe a transition from one component
	 * state to another _over time_ with a simple declarative API. Most commonly
	 * it's used to animate the mounting and unmounting of a component, but can also
	 * be used to describe in-place transition states as well.
	 *
	 * ---
	 *
	 * **Note**: `Transition` is a platform-agnostic base component. If you're using
	 * transitions in CSS, you'll probably want to use
	 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
	 * instead. It inherits all the features of `Transition`, but contains
	 * additional features necessary to play nice with CSS transitions (hence the
	 * name of the component).
	 *
	 * ---
	 *
	 * By default the `Transition` component does not alter the behavior of the
	 * component it renders, it only tracks "enter" and "exit" states for the
	 * components. It's up to you to give meaning and effect to those states. For
	 * example we can add styles to a component when it enters or exits:
	 *
	 * ```jsx
	 * import { Transition } from 'react-transition-group';
	 *
	 * const duration = 300;
	 *
	 * const defaultStyle = {
	 *   transition: `opacity ${duration}ms ease-in-out`,
	 *   opacity: 0,
	 * }
	 *
	 * const transitionStyles = {
	 *   entering: { opacity: 1 },
	 *   entered:  { opacity: 1 },
	 *   exiting:  { opacity: 0 },
	 *   exited:  { opacity: 0 },
	 * };
	 *
	 * const Fade = ({ in: inProp }) => (
	 *   <Transition in={inProp} timeout={duration}>
	 *     {state => (
	 *       <div style={{
	 *         ...defaultStyle,
	 *         ...transitionStyles[state]
	 *       }}>
	 *         I'm a fade Transition!
	 *       </div>
	 *     )}
	 *   </Transition>
	 * );
	 * ```
	 *
	 * There are 4 main states a Transition can be in:
	 *  - `'entering'`
	 *  - `'entered'`
	 *  - `'exiting'`
	 *  - `'exited'`
	 *
	 * Transition state is toggled via the `in` prop. When `true` the component
	 * begins the "Enter" stage. During this stage, the component will shift from
	 * its current transition state, to `'entering'` for the duration of the
	 * transition and then to the `'entered'` stage once it's complete. Let's take
	 * the following example (we'll use the
	 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
	 *
	 * ```jsx
	 * function App() {
	 *   const [inProp, setInProp] = useState(false);
	 *   return (
	 *     <div>
	 *       <Transition in={inProp} timeout={500}>
	 *         {state => (
	 *           // ...
	 *         )}
	 *       </Transition>
	 *       <button onClick={() => setInProp(true)}>
	 *         Click to Enter
	 *       </button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the button is clicked the component will shift to the `'entering'` state
	 * and stay there for 500ms (the value of `timeout`) before it finally switches
	 * to `'entered'`.
	 *
	 * When `in` is `false` the same thing happens except the state moves from
	 * `'exiting'` to `'exited'`.
	 */
	
	exports.EXITING = EXITING;
	
	var Transition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(Transition, _React$Component);
	
	  function Transition(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
	
	    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
	    var initialStatus;
	    _this.appearStatus = null;
	
	    if (props.in) {
	      if (appear) {
	        initialStatus = EXITED;
	        _this.appearStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }
	
	    _this.state = {
	      status: initialStatus
	    };
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
	    var nextIn = _ref.in;
	
	    if (nextIn && prevState.status === UNMOUNTED) {
	      return {
	        status: EXITED
	      };
	    }
	
	    return null;
	  }; // getSnapshotBeforeUpdate(prevProps) {
	  //   let nextStatus = null
	  //   if (prevProps !== this.props) {
	  //     const { status } = this.state
	  //     if (this.props.in) {
	  //       if (status !== ENTERING && status !== ENTERED) {
	  //         nextStatus = ENTERING
	  //       }
	  //     } else {
	  //       if (status === ENTERING || status === ENTERED) {
	  //         nextStatus = EXITING
	  //       }
	  //     }
	  //   }
	  //   return { nextStatus }
	  // }
	
	
	  var _proto = Transition.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.updateStatus(true, this.appearStatus);
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var nextStatus = null;
	
	    if (prevProps !== this.props) {
	      var status = this.state.status;
	
	      if (this.props.in) {
	        if (status !== ENTERING && status !== ENTERED) {
	          nextStatus = ENTERING;
	        }
	      } else {
	        if (status === ENTERING || status === ENTERED) {
	          nextStatus = EXITING;
	        }
	      }
	    }
	
	    this.updateStatus(false, nextStatus);
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.cancelNextCallback();
	  };
	
	  _proto.getTimeouts = function getTimeouts() {
	    var timeout = this.props.timeout;
	    var exit, enter, appear;
	    exit = enter = appear = timeout;
	
	    if (timeout != null && typeof timeout !== 'number') {
	      exit = timeout.exit;
	      enter = timeout.enter; // TODO: remove fallback for next major
	
	      appear = timeout.appear !== undefined ? timeout.appear : enter;
	    }
	
	    return {
	      exit: exit,
	      enter: enter,
	      appear: appear
	    };
	  };
	
	  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
	    if (mounting === void 0) {
	      mounting = false;
	    }
	
	    if (nextStatus !== null) {
	      // nextStatus will always be ENTERING or EXITING.
	      this.cancelNextCallback();
	
	      var node = _reactDom.default.findDOMNode(this);
	
	      if (nextStatus === ENTERING) {
	        this.performEnter(node, mounting);
	      } else {
	        this.performExit(node);
	      }
	    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
	      this.setState({
	        status: UNMOUNTED
	      });
	    }
	  };
	
	  _proto.performEnter = function performEnter(node, mounting) {
	    var _this2 = this;
	
	    var enter = this.props.enter;
	    var appearing = this.context ? this.context.isMounting : mounting;
	    var timeouts = this.getTimeouts();
	    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
	    // if we are mounting and running this it means appear _must_ be set
	
	    if (!mounting && !enter) {
	      this.safeSetState({
	        status: ENTERED
	      }, function () {
	        _this2.props.onEntered(node);
	      });
	      return;
	    }
	
	    this.props.onEnter(node, appearing);
	    this.safeSetState({
	      status: ENTERING
	    }, function () {
	      _this2.props.onEntering(node, appearing);
	
	      _this2.onTransitionEnd(node, enterTimeout, function () {
	        _this2.safeSetState({
	          status: ENTERED
	        }, function () {
	          _this2.props.onEntered(node, appearing);
	        });
	      });
	    });
	  };
	
	  _proto.performExit = function performExit(node) {
	    var _this3 = this;
	
	    var exit = this.props.exit;
	    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED
	
	    if (!exit) {
	      this.safeSetState({
	        status: EXITED
	      }, function () {
	        _this3.props.onExited(node);
	      });
	      return;
	    }
	
	    this.props.onExit(node);
	    this.safeSetState({
	      status: EXITING
	    }, function () {
	      _this3.props.onExiting(node);
	
	      _this3.onTransitionEnd(node, timeouts.exit, function () {
	        _this3.safeSetState({
	          status: EXITED
	        }, function () {
	          _this3.props.onExited(node);
	        });
	      });
	    });
	  };
	
	  _proto.cancelNextCallback = function cancelNextCallback() {
	    if (this.nextCallback !== null) {
	      this.nextCallback.cancel();
	      this.nextCallback = null;
	    }
	  };
	
	  _proto.safeSetState = function safeSetState(nextState, callback) {
	    // This shouldn't be necessary, but there are weird race conditions with
	    // setState callbacks and unmounting in testing, so always make sure that
	    // we can cancel any pending setState callbacks after we unmount.
	    callback = this.setNextCallback(callback);
	    this.setState(nextState, callback);
	  };
	
	  _proto.setNextCallback = function setNextCallback(callback) {
	    var _this4 = this;
	
	    var active = true;
	
	    this.nextCallback = function (event) {
	      if (active) {
	        active = false;
	        _this4.nextCallback = null;
	        callback(event);
	      }
	    };
	
	    this.nextCallback.cancel = function () {
	      active = false;
	    };
	
	    return this.nextCallback;
	  };
	
	  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
	    this.setNextCallback(handler);
	    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
	
	    if (!node || doesNotHaveTimeoutOrListener) {
	      setTimeout(this.nextCallback, 0);
	      return;
	    }
	
	    if (this.props.addEndListener) {
	      this.props.addEndListener(node, this.nextCallback);
	    }
	
	    if (timeout != null) {
	      setTimeout(this.nextCallback, timeout);
	    }
	  };
	
	  _proto.render = function render() {
	    var status = this.state.status;
	
	    if (status === UNMOUNTED) {
	      return null;
	    }
	
	    var _this$props = this.props,
	        children = _this$props.children,
	        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition
	
	
	    delete childProps.in;
	    delete childProps.mountOnEnter;
	    delete childProps.unmountOnExit;
	    delete childProps.appear;
	    delete childProps.enter;
	    delete childProps.exit;
	    delete childProps.timeout;
	    delete childProps.addEndListener;
	    delete childProps.onEnter;
	    delete childProps.onEntering;
	    delete childProps.onEntered;
	    delete childProps.onExit;
	    delete childProps.onExiting;
	    delete childProps.onExited;
	
	    if (typeof children === 'function') {
	      // allows for nested Transitions
	      return _react.default.createElement(_TransitionGroupContext.default.Provider, {
	        value: null
	      }, children(status, childProps));
	    }
	
	    var child = _react.default.Children.only(children);
	
	    return (// allows for nested Transitions
	      _react.default.createElement(_TransitionGroupContext.default.Provider, {
	        value: null
	      }, _react.default.cloneElement(child, childProps))
	    );
	  };
	
	  return Transition;
	}(_react.default.Component);
	
	Transition.contextType = _TransitionGroupContext.default;
	Transition.propTypes =  false ? {
	  /**
	   * A `function` child can be used instead of a React element. This function is
	   * called with the current transition status (`'entering'`, `'entered'`,
	   * `'exiting'`, `'exited'`, `'unmounted'`), which can be used to apply context
	   * specific props to a component.
	   *
	   * ```jsx
	   * <Transition in={this.state.in} timeout={150}>
	   *   {state => (
	   *     <MyComponent className={`fade fade-${state}`} />
	   *   )}
	   * </Transition>
	   * ```
	   */
	  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,
	
	  /**
	   * Show the component; triggers the enter or exit states
	   */
	  in: PropTypes.bool,
	
	  /**
	   * By default the child component is mounted immediately along with
	   * the parent `Transition` component. If you want to "lazy mount" the component on the
	   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
	   * mounted, even on "exited", unless you also specify `unmountOnExit`.
	   */
	  mountOnEnter: PropTypes.bool,
	
	  /**
	   * By default the child component stays mounted after it reaches the `'exited'` state.
	   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
	   */
	  unmountOnExit: PropTypes.bool,
	
	  /**
	   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
	   * If you want to transition on the first mount set `appear` to `true`, and the
	   * component will transition in as soon as the `<Transition>` mounts.
	   *
	   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
	   */
	  appear: PropTypes.bool,
	
	  /**
	   * Enable or disable enter transitions.
	   */
	  enter: PropTypes.bool,
	
	  /**
	   * Enable or disable exit transitions.
	   */
	  exit: PropTypes.bool,
	
	  /**
	   * The duration of the transition, in milliseconds.
	   * Required unless `addEndListener` is provided.
	   *
	   * You may specify a single timeout for all transitions:
	   *
	   * ```jsx
	   * timeout={500}
	   * ```
	   *
	   * or individually:
	   *
	   * ```jsx
	   * timeout={{
	   *  appear: 500,
	   *  enter: 300,
	   *  exit: 500,
	   * }}
	   * ```
	   *
	   * - `appear` defaults to the value of `enter`
	   * - `enter` defaults to `0`
	   * - `exit` defaults to `0`
	   *
	   * @type {number | { enter?: number, exit?: number, appear?: number }}
	   */
	  timeout: function timeout(props) {
	    var pt = _PropTypes.timeoutsShape;
	    if (!props.addEndListener) pt = pt.isRequired;
	
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return pt.apply(void 0, [props].concat(args));
	  },
	
	  /**
	   * Add a custom transition end trigger. Called with the transitioning
	   * DOM node and a `done` callback. Allows for more fine grained transition end
	   * logic. **Note:** Timeouts are still used as a fallback if provided.
	   *
	   * ```jsx
	   * addEndListener={(node, done) => {
	   *   // use the css transitionend event to mark the finish of a transition
	   *   node.addEventListener('transitionend', done, false);
	   * }}
	   * ```
	   */
	  addEndListener: PropTypes.func,
	
	  /**
	   * Callback fired before the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEnter: PropTypes.func,
	
	  /**
	   * Callback fired after the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,
	
	  /**
	   * Callback fired after the "entered" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEntered: PropTypes.func,
	
	  /**
	   * Callback fired before the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExit: PropTypes.func,
	
	  /**
	   * Callback fired after the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExiting: PropTypes.func,
	
	  /**
	   * Callback fired after the "exited" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExited: PropTypes.func // Name the function so it is clearer in the documentation
	
	} : {};
	
	function noop() {}
	
	Transition.defaultProps = {
	  in: false,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  appear: false,
	  enter: true,
	  exit: true,
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	Transition.UNMOUNTED = 0;
	Transition.EXITED = 1;
	Transition.ENTERING = 2;
	Transition.ENTERED = 3;
	Transition.EXITING = 4;
	
	var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);
	
	exports.default = _default;

/***/ },
/* 978 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactLifecyclesCompat = __webpack_require__(227);
	
	var _TransitionGroupContext = _interopRequireDefault(__webpack_require__(979));
	
	var _ChildMapping = __webpack_require__(2410);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	var values = Object.values || function (obj) {
	  return Object.keys(obj).map(function (k) {
	    return obj[k];
	  });
	};
	
	var defaultProps = {
	  component: 'div',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	  /**
	   * The `<TransitionGroup>` component manages a set of transition components
	   * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
	   * components, `<TransitionGroup>` is a state machine for managing the mounting
	   * and unmounting of components over time.
	   *
	   * Consider the example below. As items are removed or added to the TodoList the
	   * `in` prop is toggled automatically by the `<TransitionGroup>`.
	   *
	   * Note that `<TransitionGroup>`  does not define any animation behavior!
	   * Exactly _how_ a list item animates is up to the individual transition
	   * component. This means you can mix and match animations across different list
	   * items.
	   */
	
	};
	
	var TransitionGroup =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	
	    var handleExited = _this.handleExited.bind(_assertThisInitialized(_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear
	
	
	    _this.state = {
	      contextValue: {
	        isMounting: true
	      },
	      handleExited: handleExited,
	      firstRender: true
	    };
	    return _this;
	  }
	
	  var _proto = TransitionGroup.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.mounted = true;
	    this.setState({
	      contextValue: {
	        isMounting: false
	      }
	    });
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.mounted = false;
	  };
	
	  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
	    var prevChildMapping = _ref.children,
	        handleExited = _ref.handleExited,
	        firstRender = _ref.firstRender;
	    return {
	      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
	      firstRender: false
	    };
	  };
	
	  _proto.handleExited = function handleExited(child, node) {
	    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
	    if (child.key in currentChildMapping) return;
	
	    if (child.props.onExited) {
	      child.props.onExited(node);
	    }
	
	    if (this.mounted) {
	      this.setState(function (state) {
	        var children = _extends({}, state.children);
	
	        delete children[child.key];
	        return {
	          children: children
	        };
	      });
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        Component = _this$props.component,
	        childFactory = _this$props.childFactory,
	        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);
	
	    var contextValue = this.state.contextValue;
	    var children = values(this.state.children).map(childFactory);
	    delete props.appear;
	    delete props.enter;
	    delete props.exit;
	
	    if (Component === null) {
	      return _react.default.createElement(_TransitionGroupContext.default.Provider, {
	        value: contextValue
	      }, children);
	    }
	
	    return _react.default.createElement(_TransitionGroupContext.default.Provider, {
	      value: contextValue
	    }, _react.default.createElement(Component, props, children));
	  };
	
	  return TransitionGroup;
	}(_react.default.Component);
	
	TransitionGroup.propTypes =  false ? {
	  /**
	   * `<TransitionGroup>` renders a `<div>` by default. You can change this
	   * behavior by providing a `component` prop.
	   * If you use React v16+ and would like to avoid a wrapping `<div>` element
	   * you can pass in `component={null}`. This is useful if the wrapping div
	   * borks your css styles.
	   */
	  component: _propTypes.default.any,
	
	  /**
	   * A set of `<Transition>` components, that are toggled `in` and out as they
	   * leave. the `<TransitionGroup>` will inject specific transition props, so
	   * remember to spread them through if you are wrapping the `<Transition>` as
	   * with our `<Fade>` example.
	   *
	   * While this component is meant for multiple `Transition` or `CSSTransition`
	   * children, sometimes you may want to have a single transition child with
	   * content that you want to be transitioned out and in when you change it
	   * (e.g. routes, images etc.) In that case you can change the `key` prop of
	   * the transition child as you change its content, this will cause
	   * `TransitionGroup` to transition the child out and back in.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * A convenience prop that enables or disables appear animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  appear: _propTypes.default.bool,
	
	  /**
	   * A convenience prop that enables or disables enter animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  enter: _propTypes.default.bool,
	
	  /**
	   * A convenience prop that enables or disables exit animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  exit: _propTypes.default.bool,
	
	  /**
	   * You may need to apply reactive updates to a child as it is exiting.
	   * This is generally done by using `cloneElement` however in the case of an exiting
	   * child the element has already been removed and not accessible to the consumer.
	   *
	   * If you do need to update a child as it leaves you can provide a `childFactory`
	   * to wrap every child, even the ones that are leaving.
	   *
	   * @type Function(child: ReactElement) -> ReactElement
	   */
	  childFactory: _propTypes.default.func
	} : {};
	TransitionGroup.defaultProps = defaultProps;
	
	var _default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 979 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = _react.default.createContext(null);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 980 */
962,
/* 981 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.memoize = exports.reverse = exports.compose = exports.map = exports.range = exports.curry = exports.PLACE_HOLDER = void 0;
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	var identity = function identity(i) {
	  return i;
	};
	
	var PLACE_HOLDER = {
	  '@@functional/placeholder': true
	};
	exports.PLACE_HOLDER = PLACE_HOLDER;
	
	var isPlaceHolder = function isPlaceHolder(val) {
	  return val === PLACE_HOLDER;
	};
	
	var curry0 = function curry0(fn) {
	  return function _curried() {
	    if (arguments.length === 0 || arguments.length === 1 && isPlaceHolder(arguments.length <= 0 ? undefined : arguments[0])) {
	      return _curried;
	    }
	
	    return fn.apply(void 0, arguments);
	  };
	};
	
	var curryN = function curryN(n, fn) {
	  if (n === 1) {
	    return fn;
	  }
	
	  return curry0(function () {
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var argsLength = args.filter(function (arg) {
	      return arg !== PLACE_HOLDER;
	    }).length;
	
	    if (argsLength >= n) {
	      return fn.apply(void 0, args);
	    }
	
	    return curryN(n - argsLength, curry0(function () {
	      for (var _len2 = arguments.length, restArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        restArgs[_key2] = arguments[_key2];
	      }
	
	      var newArgs = args.map(function (arg) {
	        return isPlaceHolder(arg) ? restArgs.shift() : arg;
	      });
	      return fn.apply(void 0, _toConsumableArray(newArgs).concat(restArgs));
	    }));
	  });
	};
	
	var curry = function curry(fn) {
	  return curryN(fn.length, fn);
	};
	
	exports.curry = curry;
	
	var range = function range(begin, end) {
	  var arr = [];
	
	  for (var i = begin; i < end; ++i) {
	    arr[i - begin] = i;
	  }
	
	  return arr;
	};
	
	exports.range = range;
	var map = curry(function (fn, arr) {
	  if (Array.isArray(arr)) {
	    return arr.map(fn);
	  }
	
	  return Object.keys(arr).map(function (key) {
	    return arr[key];
	  }).map(fn);
	});
	exports.map = map;
	
	var compose = function compose() {
	  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	    args[_key3] = arguments[_key3];
	  }
	
	  if (!args.length) {
	    return identity;
	  }
	
	  var fns = args.reverse(); // first function can receive multiply arguments
	
	  var firstFn = fns[0];
	  var tailsFn = fns.slice(1);
	  return function () {
	    return tailsFn.reduce(function (res, fn) {
	      return fn(res);
	    }, firstFn.apply(void 0, arguments));
	  };
	};
	
	exports.compose = compose;
	
	var reverse = function reverse(arr) {
	  if (Array.isArray(arr)) {
	    return arr.reverse();
	  } // can be string
	
	
	  return arr.split('').reverse.join('');
	};
	
	exports.reverse = reverse;
	
	var memoize = function memoize(fn) {
	  var lastArgs = null;
	  var lastResult = null;
	  return function () {
	    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	      args[_key4] = arguments[_key4];
	    }
	
	    if (lastArgs && args.every(function (val, i) {
	      return val === lastArgs[i];
	    })) {
	      return lastResult;
	    }
	
	    lastArgs = args;
	    lastResult = fn.apply(void 0, args);
	    return lastResult;
	  };
	};
	
	exports.memoize = memoize;

/***/ },
/* 982 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _range2 = _interopRequireDefault(__webpack_require__(759));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(38));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _d3Scale = __webpack_require__(614);
	
	var _ChartUtils = __webpack_require__(66);
	
	var _Layer = _interopRequireDefault(__webpack_require__(49));
	
	var _Text = _interopRequireDefault(__webpack_require__(152));
	
	var _DataUtils = __webpack_require__(39);
	
	var _CssPrefixUtils = __webpack_require__(2433);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var Brush =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Brush, _PureComponent);
	
	  function Brush(props) {
	    var _this;
	
	    _classCallCheck(this, Brush);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(Brush).call(this, props));
	
	    _this.handleDrag = function (e) {
	      if (_this.leaveTimer) {
	        clearTimeout(_this.leaveTimer);
	        _this.leaveTimer = null;
	      }
	
	      if (_this.state.isTravellerMoving) {
	        _this.handleTravellerMove(e);
	      } else if (_this.state.isSlideMoving) {
	        _this.handleSlideDrag(e);
	      }
	    };
	
	    _this.handleTouchMove = function (e) {
	      if (e.changedTouches != null && e.changedTouches.length > 0) {
	        _this.handleDrag(e.changedTouches[0]);
	      }
	    };
	
	    _this.handleDragEnd = function () {
	      _this.setState({
	        isTravellerMoving: false,
	        isSlideMoving: false
	      });
	    };
	
	    _this.handleLeaveWrapper = function () {
	      if (_this.state.isTravellerMoving || _this.state.isSlideMoving) {
	        _this.leaveTimer = setTimeout(_this.handleDragEnd, _this.props.leaveTimeOut);
	      }
	    };
	
	    _this.handleEnterSlideOrTraveller = function () {
	      _this.setState({
	        isTextActive: true
	      });
	    };
	
	    _this.handleLeaveSlideOrTraveller = function () {
	      _this.setState({
	        isTextActive: false
	      });
	    };
	
	    _this.handleSlideDragStart = function (e) {
	      var event = e.changedTouches && e.changedTouches.length ? e.changedTouches[0] : e;
	
	      _this.setState({
	        isTravellerMoving: false,
	        isSlideMoving: true,
	        slideMoveStartX: event.pageX
	      });
	    };
	
	    _this.travellerDragStartHandlers = {
	      startX: _this.handleTravellerDragStart.bind(_assertThisInitialized(_this), 'startX'),
	      endX: _this.handleTravellerDragStart.bind(_assertThisInitialized(_this), 'endX')
	    };
	    _this.state = props.data && props.data.length ? _this.updateScale(props) : {};
	    return _this;
	  } // eslint-disable-next-line camelcase
	
	
	  _createClass(Brush, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      var _this$props = this.props,
	          data = _this$props.data,
	          width = _this$props.width,
	          x = _this$props.x,
	          travellerWidth = _this$props.travellerWidth,
	          updateId = _this$props.updateId;
	
	      if ((nextProps.data !== data || nextProps.updateId !== updateId) && nextProps.data && nextProps.data.length) {
	        this.setState(this.updateScale(nextProps));
	      } else if (nextProps.width !== width || nextProps.x !== x || nextProps.travellerWidth !== travellerWidth) {
	        this.scale.range([nextProps.x, nextProps.x + nextProps.width - nextProps.travellerWidth]);
	        this.scaleValues = this.scale.domain().map(function (entry) {
	          return _this2.scale(entry);
	        });
	        this.setState({
	          startX: this.scale(nextProps.startIndex),
	          endX: this.scale(nextProps.endIndex)
	        });
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.scale = null;
	      this.scaleValues = null;
	
	      if (this.leaveTimer) {
	        clearTimeout(this.leaveTimer);
	        this.leaveTimer = null;
	      }
	    }
	  }, {
	    key: "getIndex",
	    value: function getIndex(_ref) {
	      var startX = _ref.startX,
	          endX = _ref.endX;
	      var _this$props2 = this.props,
	          gap = _this$props2.gap,
	          data = _this$props2.data;
	      var lastIndex = data.length - 1;
	      var min = Math.min(startX, endX);
	      var max = Math.max(startX, endX);
	      var minIndex = this.constructor.getIndexInRange(this.scaleValues, min);
	      var maxIndex = this.constructor.getIndexInRange(this.scaleValues, max);
	      return {
	        startIndex: minIndex - minIndex % gap,
	        endIndex: maxIndex === lastIndex ? lastIndex : maxIndex - maxIndex % gap
	      };
	    }
	  }, {
	    key: "getTextOfTick",
	    value: function getTextOfTick(index) {
	      var _this$props3 = this.props,
	          data = _this$props3.data,
	          tickFormatter = _this$props3.tickFormatter,
	          dataKey = _this$props3.dataKey;
	      var text = (0, _ChartUtils.getValueByDataKey)(data[index], dataKey, index);
	      return (0, _isFunction2["default"])(tickFormatter) ? tickFormatter(text) : text;
	    }
	  }, {
	    key: "handleSlideDrag",
	    value: function handleSlideDrag(e) {
	      var _this$state = this.state,
	          slideMoveStartX = _this$state.slideMoveStartX,
	          startX = _this$state.startX,
	          endX = _this$state.endX;
	      var _this$props4 = this.props,
	          x = _this$props4.x,
	          width = _this$props4.width,
	          travellerWidth = _this$props4.travellerWidth,
	          startIndex = _this$props4.startIndex,
	          endIndex = _this$props4.endIndex,
	          onChange = _this$props4.onChange;
	      var delta = e.pageX - slideMoveStartX;
	
	      if (delta > 0) {
	        delta = Math.min(delta, x + width - travellerWidth - endX, x + width - travellerWidth - startX);
	      } else if (delta < 0) {
	        delta = Math.max(delta, x - startX, x - endX);
	      }
	
	      var newIndex = this.getIndex({
	        startX: startX + delta,
	        endX: endX + delta
	      });
	
	      if ((newIndex.startIndex !== startIndex || newIndex.endIndex !== endIndex) && onChange) {
	        onChange(newIndex);
	      }
	
	      this.setState({
	        startX: startX + delta,
	        endX: endX + delta,
	        slideMoveStartX: e.pageX
	      });
	    }
	  }, {
	    key: "handleTravellerDragStart",
	    value: function handleTravellerDragStart(id, e) {
	      var event = e.changedTouches && e.changedTouches.length ? e.changedTouches[0] : e;
	      this.setState({
	        isSlideMoving: false,
	        isTravellerMoving: true,
	        movingTravellerId: id,
	        brushMoveStartX: event.pageX
	      });
	    }
	  }, {
	    key: "handleTravellerMove",
	    value: function handleTravellerMove(e) {
	      var _this$setState;
	
	      var _this$state2 = this.state,
	          brushMoveStartX = _this$state2.brushMoveStartX,
	          movingTravellerId = _this$state2.movingTravellerId,
	          endX = _this$state2.endX,
	          startX = _this$state2.startX;
	      var prevValue = this.state[movingTravellerId];
	      var _this$props5 = this.props,
	          x = _this$props5.x,
	          width = _this$props5.width,
	          travellerWidth = _this$props5.travellerWidth,
	          onChange = _this$props5.onChange,
	          gap = _this$props5.gap,
	          data = _this$props5.data;
	      var params = {
	        startX: this.state.startX,
	        endX: this.state.endX
	      };
	      var delta = e.pageX - brushMoveStartX;
	
	      if (delta > 0) {
	        delta = Math.min(delta, x + width - travellerWidth - prevValue);
	      } else if (delta < 0) {
	        delta = Math.max(delta, x - prevValue);
	      }
	
	      params[movingTravellerId] = prevValue + delta;
	      var newIndex = this.getIndex(params);
	      var startIndex = newIndex.startIndex,
	          endIndex = newIndex.endIndex;
	
	      var isFullGap = function isFullGap() {
	        var lastIndex = data.length - 1;
	
	        if (movingTravellerId === 'startX' && (endX > startX ? startIndex % gap === 0 : endIndex % gap === 0) || endX < startX && endIndex === lastIndex || movingTravellerId === 'endX' && (endX > startX ? endIndex % gap === 0 : startIndex % gap === 0) || endX > startX && endIndex === lastIndex) {
	          return true;
	        }
	
	        return false;
	      };
	
	      this.setState((_this$setState = {}, _defineProperty(_this$setState, movingTravellerId, prevValue + delta), _defineProperty(_this$setState, "brushMoveStartX", e.pageX), _this$setState), function () {
	        if (onChange) {
	          if (isFullGap()) {
	            onChange(newIndex);
	          }
	        }
	      });
	    }
	  }, {
	    key: "updateScale",
	    value: function updateScale(props) {
	      var _this3 = this;
	
	      var data = props.data,
	          startIndex = props.startIndex,
	          endIndex = props.endIndex,
	          x = props.x,
	          width = props.width,
	          travellerWidth = props.travellerWidth;
	      var len = data.length;
	      this.scale = (0, _d3Scale.scalePoint)().domain((0, _range2["default"])(0, len)).range([x, x + width - travellerWidth]);
	      this.scaleValues = this.scale.domain().map(function (entry) {
	        return _this3.scale(entry);
	      });
	      return {
	        isTextActive: false,
	        isSlideMoving: false,
	        isTravellerMoving: false,
	        startX: this.scale(startIndex),
	        endX: this.scale(endIndex)
	      };
	    }
	  }, {
	    key: "renderBackground",
	    value: function renderBackground() {
	      var _this$props6 = this.props,
	          x = _this$props6.x,
	          y = _this$props6.y,
	          width = _this$props6.width,
	          height = _this$props6.height,
	          fill = _this$props6.fill,
	          stroke = _this$props6.stroke;
	      return _react["default"].createElement("rect", {
	        stroke: stroke,
	        fill: fill,
	        x: x,
	        y: y,
	        width: width,
	        height: height
	      });
	    }
	  }, {
	    key: "renderPanorama",
	    value: function renderPanorama() {
	      var _this$props7 = this.props,
	          x = _this$props7.x,
	          y = _this$props7.y,
	          width = _this$props7.width,
	          height = _this$props7.height,
	          data = _this$props7.data,
	          children = _this$props7.children,
	          padding = _this$props7.padding;
	
	      var chartElement = _react.Children.only(children);
	
	      if (!chartElement) {
	        return null;
	      }
	
	      return _react["default"].cloneElement(chartElement, {
	        x: x,
	        y: y,
	        width: width,
	        height: height,
	        margin: padding,
	        compact: true,
	        data: data
	      });
	    }
	  }, {
	    key: "renderTraveller",
	    value: function renderTraveller(travellerX, id) {
	      var _this$props8 = this.props,
	          y = _this$props8.y,
	          travellerWidth = _this$props8.travellerWidth,
	          height = _this$props8.height,
	          stroke = _this$props8.stroke;
	      var lineY = Math.floor(y + height / 2) - 1;
	      var x = Math.max(travellerX, this.props.x);
	      return _react["default"].createElement(_Layer["default"], {
	        className: "recharts-brush-traveller",
	        onMouseEnter: this.handleEnterSlideOrTraveller,
	        onMouseLeave: this.handleLeaveSlideOrTraveller,
	        onMouseDown: this.travellerDragStartHandlers[id],
	        onTouchStart: this.travellerDragStartHandlers[id],
	        style: {
	          cursor: 'col-resize'
	        }
	      }, _react["default"].createElement("rect", {
	        x: x,
	        y: y,
	        width: travellerWidth,
	        height: height,
	        fill: stroke,
	        stroke: "none"
	      }), _react["default"].createElement("line", {
	        x1: x + 1,
	        y1: lineY,
	        x2: x + travellerWidth - 1,
	        y2: lineY,
	        fill: "none",
	        stroke: "#fff"
	      }), _react["default"].createElement("line", {
	        x1: x + 1,
	        y1: lineY + 2,
	        x2: x + travellerWidth - 1,
	        y2: lineY + 2,
	        fill: "none",
	        stroke: "#fff"
	      }));
	    }
	  }, {
	    key: "renderSlide",
	    value: function renderSlide(startX, endX) {
	      var _this$props9 = this.props,
	          y = _this$props9.y,
	          height = _this$props9.height,
	          stroke = _this$props9.stroke;
	      return _react["default"].createElement("rect", {
	        className: "recharts-brush-slide",
	        onMouseEnter: this.handleEnterSlideOrTraveller,
	        onMouseLeave: this.handleLeaveSlideOrTraveller,
	        onMouseDown: this.handleSlideDragStart,
	        onTouchStart: this.handleSlideDragStart,
	        style: {
	          cursor: 'move'
	        },
	        stroke: "none",
	        fill: stroke,
	        fillOpacity: 0.2,
	        x: Math.min(startX, endX),
	        y: y,
	        width: Math.abs(endX - startX),
	        height: height
	      });
	    }
	  }, {
	    key: "renderText",
	    value: function renderText() {
	      var _this$props10 = this.props,
	          startIndex = _this$props10.startIndex,
	          endIndex = _this$props10.endIndex,
	          y = _this$props10.y,
	          height = _this$props10.height,
	          travellerWidth = _this$props10.travellerWidth,
	          stroke = _this$props10.stroke;
	      var _this$state3 = this.state,
	          startX = _this$state3.startX,
	          endX = _this$state3.endX;
	      var offset = 5;
	      var attrs = {
	        pointerEvents: 'none',
	        fill: stroke
	      };
	      return _react["default"].createElement(_Layer["default"], {
	        className: "recharts-brush-texts"
	      }, _react["default"].createElement(_Text["default"], _extends({
	        textAnchor: "end",
	        verticalAnchor: "middle",
	        x: Math.min(startX, endX) - offset,
	        y: y + height / 2
	      }, attrs), this.getTextOfTick(startIndex)), _react["default"].createElement(_Text["default"], _extends({
	        textAnchor: "start",
	        verticalAnchor: "middle",
	        x: Math.max(startX, endX) + travellerWidth + offset,
	        y: y + height / 2
	      }, attrs), this.getTextOfTick(endIndex)));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props11 = this.props,
	          data = _this$props11.data,
	          className = _this$props11.className,
	          children = _this$props11.children,
	          x = _this$props11.x,
	          y = _this$props11.y,
	          width = _this$props11.width,
	          height = _this$props11.height,
	          alwaysShowText = _this$props11.alwaysShowText;
	      var _this$state4 = this.state,
	          startX = _this$state4.startX,
	          endX = _this$state4.endX,
	          isTextActive = _this$state4.isTextActive,
	          isSlideMoving = _this$state4.isSlideMoving,
	          isTravellerMoving = _this$state4.isTravellerMoving;
	
	      if (!data || !data.length || !(0, _DataUtils.isNumber)(x) || !(0, _DataUtils.isNumber)(y) || !(0, _DataUtils.isNumber)(width) || !(0, _DataUtils.isNumber)(height) || width <= 0 || height <= 0) {
	        return null;
	      }
	
	      var layerClass = (0, _classnames["default"])('recharts-brush', className);
	      var isPanoramic = _react["default"].Children.count(children) === 1;
	      var style = (0, _CssPrefixUtils.generatePrefixStyle)('userSelect', 'none');
	      return _react["default"].createElement(_Layer["default"], {
	        className: layerClass,
	        onMouseMove: this.handleDrag,
	        onMouseLeave: this.handleLeaveWrapper,
	        onMouseUp: this.handleDragEnd,
	        onTouchEnd: this.handleDragEnd,
	        onTouchMove: this.handleTouchMove,
	        style: style
	      }, this.renderBackground(), isPanoramic && this.renderPanorama(), this.renderSlide(startX, endX), this.renderTraveller(startX, 'startX'), this.renderTraveller(endX, 'endX'), (isTextActive || isSlideMoving || isTravellerMoving || alwaysShowText) && this.renderText());
	    }
	  }], [{
	    key: "getIndexInRange",
	    value: function getIndexInRange(range, x) {
	      var len = range.length;
	      var start = 0;
	      var end = len - 1;
	
	      while (end - start > 1) {
	        var middle = Math.floor((start + end) / 2);
	
	        if (range[middle] > x) {
	          end = middle;
	        } else {
	          start = middle;
	        }
	      }
	
	      return x >= range[end] ? end : start;
	    }
	  }]);
	
	  return Brush;
	}(_react.PureComponent);
	
	Brush.displayName = 'Brush';
	Brush.propTypes = {
	  className: _propTypes["default"].string,
	  fill: _propTypes["default"].string,
	  stroke: _propTypes["default"].string,
	  x: _propTypes["default"].number,
	  y: _propTypes["default"].number,
	  width: _propTypes["default"].number,
	  height: _propTypes["default"].number.isRequired,
	  travellerWidth: _propTypes["default"].number,
	  gap: _propTypes["default"].number,
	  padding: _propTypes["default"].shape({
	    top: _propTypes["default"].number,
	    right: _propTypes["default"].number,
	    bottom: _propTypes["default"].number,
	    left: _propTypes["default"].number
	  }),
	  dataKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func]),
	  data: _propTypes["default"].array,
	  startIndex: _propTypes["default"].number,
	  endIndex: _propTypes["default"].number,
	  tickFormatter: _propTypes["default"].func,
	  children: _propTypes["default"].node,
	  onChange: _propTypes["default"].func,
	  updateId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  leaveTimeOut: _propTypes["default"].number,
	  alwaysShowText: _propTypes["default"].bool
	};
	Brush.defaultProps = {
	  height: 40,
	  travellerWidth: 5,
	  gap: 1,
	  fill: '#fff',
	  stroke: '#666',
	  padding: {
	    top: 1,
	    right: 1,
	    bottom: 1,
	    left: 1
	  },
	  leaveTimeOut: 1000,
	  alwaysShowText: false
	};
	var _default = Brush;
	exports["default"] = _default;

/***/ },
/* 983 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(38));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _ShallowEqual = __webpack_require__(314);
	
	var _DOMUtils = __webpack_require__(312);
	
	var _Layer = _interopRequireDefault(__webpack_require__(49));
	
	var _Text = _interopRequireDefault(__webpack_require__(152));
	
	var _Label = _interopRequireDefault(__webpack_require__(127));
	
	var _ReactUtils = __webpack_require__(29);
	
	var _DataUtils = __webpack_require__(39);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var CartesianAxis =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(CartesianAxis, _Component);
	
	  function CartesianAxis() {
	    _classCallCheck(this, CartesianAxis);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(CartesianAxis).apply(this, arguments));
	  }
	
	  _createClass(CartesianAxis, [{
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(_ref, state) {
	      var viewBox = _ref.viewBox,
	          restProps = _objectWithoutProperties(_ref, ["viewBox"]);
	
	      // props.viewBox is sometimes generated every time -
	      // check that specially as object equality is likely to fail
	      var _this$props = this.props,
	          viewBoxOld = _this$props.viewBox,
	          restPropsOld = _objectWithoutProperties(_this$props, ["viewBox"]);
	
	      return !(0, _ShallowEqual.shallowEqual)(viewBox, viewBoxOld) || !(0, _ShallowEqual.shallowEqual)(restProps, restPropsOld) || !(0, _ShallowEqual.shallowEqual)(state, this.state);
	    }
	    /**
	     * Calculate the coordinates of endpoints in ticks
	     * @param  {Object} data The data of a simple tick
	     * @return {Object} (x1, y1): The coordinate of endpoint close to tick text
	     *  (x2, y2): The coordinate of endpoint close to axis
	     */
	
	  }, {
	    key: "getTickLineCoord",
	    value: function getTickLineCoord(data) {
	      var _this$props2 = this.props,
	          x = _this$props2.x,
	          y = _this$props2.y,
	          width = _this$props2.width,
	          height = _this$props2.height,
	          orientation = _this$props2.orientation,
	          tickSize = _this$props2.tickSize,
	          mirror = _this$props2.mirror,
	          tickMargin = _this$props2.tickMargin;
	      var x1, x2, y1, y2, tx, ty;
	      var sign = mirror ? -1 : 1;
	      var finalTickSize = data.tickSize || tickSize;
	      var tickCoord = (0, _DataUtils.isNumber)(data.tickCoord) ? data.tickCoord : data.coordinate;
	
	      switch (orientation) {
	        case 'top':
	          x1 = x2 = data.coordinate;
	          y2 = y + !mirror * height;
	          y1 = y2 - sign * finalTickSize;
	          ty = y1 - sign * tickMargin;
	          tx = tickCoord;
	          break;
	
	        case 'left':
	          y1 = y2 = data.coordinate;
	          x2 = x + !mirror * width;
	          x1 = x2 - sign * finalTickSize;
	          tx = x1 - sign * tickMargin;
	          ty = tickCoord;
	          break;
	
	        case 'right':
	          y1 = y2 = data.coordinate;
	          x2 = x + mirror * width;
	          x1 = x2 + sign * finalTickSize;
	          tx = x1 + sign * tickMargin;
	          ty = tickCoord;
	          break;
	
	        default:
	          x1 = x2 = data.coordinate;
	          y2 = y + mirror * height;
	          y1 = y2 + sign * finalTickSize;
	          ty = y1 + sign * tickMargin;
	          tx = tickCoord;
	          break;
	      }
	
	      return {
	        line: {
	          x1: x1,
	          y1: y1,
	          x2: x2,
	          y2: y2
	        },
	        tick: {
	          x: tx,
	          y: ty
	        }
	      };
	    }
	  }, {
	    key: "getTickTextAnchor",
	    value: function getTickTextAnchor() {
	      var _this$props3 = this.props,
	          orientation = _this$props3.orientation,
	          mirror = _this$props3.mirror;
	      var textAnchor;
	
	      switch (orientation) {
	        case 'left':
	          textAnchor = mirror ? 'start' : 'end';
	          break;
	
	        case 'right':
	          textAnchor = mirror ? 'end' : 'start';
	          break;
	
	        default:
	          textAnchor = 'middle';
	          break;
	      }
	
	      return textAnchor;
	    }
	  }, {
	    key: "getTickVerticalAnchor",
	    value: function getTickVerticalAnchor() {
	      var _this$props4 = this.props,
	          orientation = _this$props4.orientation,
	          mirror = _this$props4.mirror;
	      var verticalAnchor = 'end';
	
	      switch (orientation) {
	        case 'left':
	        case 'right':
	          verticalAnchor = 'middle';
	          break;
	
	        case 'top':
	          verticalAnchor = mirror ? 'start' : 'end';
	          break;
	
	        default:
	          verticalAnchor = mirror ? 'end' : 'start';
	          break;
	      }
	
	      return verticalAnchor;
	    }
	  }, {
	    key: "renderAxisLine",
	    value: function renderAxisLine() {
	      var _this$props5 = this.props,
	          x = _this$props5.x,
	          y = _this$props5.y,
	          width = _this$props5.width,
	          height = _this$props5.height,
	          orientation = _this$props5.orientation,
	          axisLine = _this$props5.axisLine,
	          mirror = _this$props5.mirror;
	
	      var props = _objectSpread({}, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	        fill: 'none'
	      }, (0, _ReactUtils.getPresentationAttributes)(axisLine));
	
	      if (orientation === 'top' || orientation === 'bottom') {
	        var needHeight = orientation === 'top' && !mirror || orientation === 'bottom' && mirror;
	        props = _objectSpread({}, props, {
	          x1: x,
	          y1: y + needHeight * height,
	          x2: x + width,
	          y2: y + needHeight * height
	        });
	      } else {
	        var needWidth = orientation === 'left' && !mirror || orientation === 'right' && mirror;
	        props = _objectSpread({}, props, {
	          x1: x + needWidth * width,
	          y1: y,
	          x2: x + needWidth * width,
	          y2: y + height
	        });
	      }
	
	      return _react["default"].createElement("line", _extends({
	        className: "recharts-cartesian-axis-line"
	      }, props));
	    }
	  }, {
	    key: "renderTicks",
	
	    /**
	     * render the ticks
	     * @param {Array} ticks The ticks to actually render (overrides what was passed in props)
	     * @return {ReactComponent} renderedTicks
	     */
	    value: function renderTicks(ticks) {
	      var _this = this;
	
	      var _this$props6 = this.props,
	          tickLine = _this$props6.tickLine,
	          stroke = _this$props6.stroke,
	          tick = _this$props6.tick,
	          tickFormatter = _this$props6.tickFormatter,
	          unit = _this$props6.unit;
	      var finalTicks = CartesianAxis.getTicks(_objectSpread({}, this.props, {
	        ticks: ticks
	      }));
	      var textAnchor = this.getTickTextAnchor();
	      var verticalAnchor = this.getTickVerticalAnchor();
	      var axisProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customTickProps = (0, _ReactUtils.getPresentationAttributes)(tick);
	
	      var tickLineProps = _objectSpread({}, axisProps, {
	        fill: 'none'
	      }, (0, _ReactUtils.getPresentationAttributes)(tickLine));
	
	      var items = finalTicks.map(function (entry, i) {
	        var _this$getTickLineCoor = _this.getTickLineCoord(entry),
	            lineCoord = _this$getTickLineCoor.line,
	            tickCoord = _this$getTickLineCoor.tick;
	
	        var tickProps = _objectSpread({
	          textAnchor: textAnchor,
	          verticalAnchor: verticalAnchor
	        }, axisProps, {
	          stroke: 'none',
	          fill: stroke
	        }, customTickProps, {}, tickCoord, {
	          index: i,
	          payload: entry,
	          visibleTicksCount: finalTicks.length
	        });
	
	        return _react["default"].createElement(_Layer["default"], _extends({
	          className: "recharts-cartesian-axis-tick",
	          key: "tick-".concat(i) // eslint-disable-line react/no-array-index-key
	
	        }, (0, _ReactUtils.filterEventsOfChild)(_this.props, entry, i)), tickLine && _react["default"].createElement("line", _extends({
	          className: "recharts-cartesian-axis-tick-line"
	        }, tickLineProps, lineCoord)), tick && _this.constructor.renderTickItem(tick, tickProps, "".concat((0, _isFunction2["default"])(tickFormatter) ? tickFormatter(entry.value) : entry.value).concat(unit || '')));
	      });
	      return _react["default"].createElement("g", {
	        className: "recharts-cartesian-axis-ticks"
	      }, items);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props7 = this.props,
	          axisLine = _this$props7.axisLine,
	          width = _this$props7.width,
	          height = _this$props7.height,
	          ticksGenerator = _this$props7.ticksGenerator,
	          className = _this$props7.className,
	          hide = _this$props7.hide;
	
	      if (hide) {
	        return null;
	      }
	
	      var _this$props8 = this.props,
	          ticks = _this$props8.ticks,
	          noTicksProps = _objectWithoutProperties(_this$props8, ["ticks"]);
	
	      var finalTicks = ticks;
	
	      if ((0, _isFunction2["default"])(ticksGenerator)) {
	        finalTicks = ticks && ticks.length > 0 ? ticksGenerator(this.props) : ticksGenerator(noTicksProps);
	      }
	
	      if (width <= 0 || height <= 0 || !finalTicks || !finalTicks.length) {
	        return null;
	      }
	
	      return _react["default"].createElement(_Layer["default"], {
	        className: (0, _classnames["default"])('recharts-cartesian-axis', className)
	      }, axisLine && this.renderAxisLine(), this.renderTicks(finalTicks), _Label["default"].renderCallByParent(this.props));
	    }
	  }], [{
	    key: "getTicks",
	    value: function getTicks(props) {
	      var tick = props.tick,
	          ticks = props.ticks,
	          viewBox = props.viewBox,
	          minTickGap = props.minTickGap,
	          orientation = props.orientation,
	          interval = props.interval,
	          tickFormatter = props.tickFormatter,
	          unit = props.unit;
	
	      if (!ticks || !ticks.length || !tick) {
	        return [];
	      }
	
	      if ((0, _DataUtils.isNumber)(interval) || (0, _ReactUtils.isSsr)()) {
	        return CartesianAxis.getNumberIntervalTicks(ticks, (0, _DataUtils.isNumber)(interval) ? interval : 0);
	      }
	
	      if (interval === 'preserveStartEnd') {
	        return CartesianAxis.getTicksStart({
	          ticks: ticks,
	          tickFormatter: tickFormatter,
	          viewBox: viewBox,
	          orientation: orientation,
	          minTickGap: minTickGap,
	          unit: unit
	        }, true);
	      }
	
	      if (interval === 'preserveStart') {
	        return CartesianAxis.getTicksStart({
	          ticks: ticks,
	          tickFormatter: tickFormatter,
	          viewBox: viewBox,
	          orientation: orientation,
	          minTickGap: minTickGap,
	          unit: unit
	        });
	      }
	
	      return CartesianAxis.getTicksEnd({
	        ticks: ticks,
	        tickFormatter: tickFormatter,
	        viewBox: viewBox,
	        orientation: orientation,
	        minTickGap: minTickGap,
	        unit: unit
	      });
	    }
	  }, {
	    key: "getNumberIntervalTicks",
	    value: function getNumberIntervalTicks(ticks, interval) {
	      return ticks.filter(function (entry, i) {
	        return i % (interval + 1) === 0;
	      });
	    }
	  }, {
	    key: "getTicksStart",
	    value: function getTicksStart(_ref2, preserveEnd) {
	      var ticks = _ref2.ticks,
	          tickFormatter = _ref2.tickFormatter,
	          viewBox = _ref2.viewBox,
	          orientation = _ref2.orientation,
	          minTickGap = _ref2.minTickGap,
	          unit = _ref2.unit;
	      var x = viewBox.x,
	          y = viewBox.y,
	          width = viewBox.width,
	          height = viewBox.height;
	      var sizeKey = orientation === 'top' || orientation === 'bottom' ? 'width' : 'height';
	      var result = (ticks || []).slice(); // we need add the width of 'unit' only when sizeKey === 'width'
	
	      var unitSize = unit && sizeKey === 'width' ? (0, _DOMUtils.getStringSize)(unit)[sizeKey] : 0;
	      var len = result.length;
	      var sign = len >= 2 ? (0, _DataUtils.mathSign)(result[1].coordinate - result[0].coordinate) : 1;
	      var start, end;
	
	      if (sign === 1) {
	        start = sizeKey === 'width' ? x : y;
	        end = sizeKey === 'width' ? x + width : y + height;
	      } else {
	        start = sizeKey === 'width' ? x + width : y + height;
	        end = sizeKey === 'width' ? x : y;
	      }
	
	      if (preserveEnd) {
	        // Try to guarantee the tail to be displayed
	        var tail = ticks[len - 1];
	        var tailContent = (0, _isFunction2["default"])(tickFormatter) ? tickFormatter(tail.value) : tail.value;
	        var tailSize = (0, _DOMUtils.getStringSize)(tailContent)[sizeKey] + unitSize;
	        var tailGap = sign * (tail.coordinate + sign * tailSize / 2 - end);
	        result[len - 1] = tail = _objectSpread({}, tail, {
	          tickCoord: tailGap > 0 ? tail.coordinate - tailGap * sign : tail.coordinate
	        });
	        var isTailShow = sign * (tail.tickCoord - sign * tailSize / 2 - start) >= 0 && sign * (tail.tickCoord + sign * tailSize / 2 - end) <= 0;
	
	        if (isTailShow) {
	          end = tail.tickCoord - sign * (tailSize / 2 + minTickGap);
	          result[len - 1] = _objectSpread({}, tail, {
	            isShow: true
	          });
	        }
	      }
	
	      var count = preserveEnd ? len - 1 : len;
	
	      for (var _i = 0; _i < count; _i++) {
	        var entry = result[_i];
	        var content = (0, _isFunction2["default"])(tickFormatter) ? tickFormatter(entry.value) : entry.value;
	        var size = (0, _DOMUtils.getStringSize)(content)[sizeKey] + unitSize;
	
	        if (_i === 0) {
	          var gap = sign * (entry.coordinate - sign * size / 2 - start);
	          result[_i] = entry = _objectSpread({}, entry, {
	            tickCoord: gap < 0 ? entry.coordinate - gap * sign : entry.coordinate
	          });
	        } else {
	          result[_i] = entry = _objectSpread({}, entry, {
	            tickCoord: entry.coordinate
	          });
	        }
	
	        var isShow = sign * (entry.tickCoord - sign * size / 2 - start) >= 0 && sign * (entry.tickCoord + sign * size / 2 - end) <= 0;
	
	        if (isShow) {
	          start = entry.tickCoord + sign * (size / 2 + minTickGap);
	          result[_i] = _objectSpread({}, entry, {
	            isShow: true
	          });
	        }
	      }
	
	      return result.filter(function (entry) {
	        return entry.isShow;
	      });
	    }
	  }, {
	    key: "getTicksEnd",
	    value: function getTicksEnd(_ref3) {
	      var ticks = _ref3.ticks,
	          tickFormatter = _ref3.tickFormatter,
	          viewBox = _ref3.viewBox,
	          orientation = _ref3.orientation,
	          minTickGap = _ref3.minTickGap,
	          unit = _ref3.unit;
	      var x = viewBox.x,
	          y = viewBox.y,
	          width = viewBox.width,
	          height = viewBox.height;
	      var sizeKey = orientation === 'top' || orientation === 'bottom' ? 'width' : 'height'; // we need add the width of 'unit' only when sizeKey === 'width'
	
	      var unitSize = unit && sizeKey === 'width' ? (0, _DOMUtils.getStringSize)(unit)[sizeKey] : 0;
	      var result = (ticks || []).slice();
	      var len = result.length;
	      var sign = len >= 2 ? (0, _DataUtils.mathSign)(result[1].coordinate - result[0].coordinate) : 1;
	      var start, end;
	
	      if (sign === 1) {
	        start = sizeKey === 'width' ? x : y;
	        end = sizeKey === 'width' ? x + width : y + height;
	      } else {
	        start = sizeKey === 'width' ? x + width : y + height;
	        end = sizeKey === 'width' ? x : y;
	      }
	
	      for (var _i2 = len - 1; _i2 >= 0; _i2--) {
	        var entry = result[_i2];
	        var content = (0, _isFunction2["default"])(tickFormatter) ? tickFormatter(entry.value) : entry.value;
	        var size = (0, _DOMUtils.getStringSize)(content)[sizeKey] + unitSize;
	
	        if (_i2 === len - 1) {
	          var gap = sign * (entry.coordinate + sign * size / 2 - end);
	          result[_i2] = entry = _objectSpread({}, entry, {
	            tickCoord: gap > 0 ? entry.coordinate - gap * sign : entry.coordinate
	          });
	        } else {
	          result[_i2] = entry = _objectSpread({}, entry, {
	            tickCoord: entry.coordinate
	          });
	        }
	
	        var isShow = sign * (entry.tickCoord - sign * size / 2 - start) >= 0 && sign * (entry.tickCoord + sign * size / 2 - end) <= 0;
	
	        if (isShow) {
	          end = entry.tickCoord - sign * (size / 2 + minTickGap);
	          result[_i2] = _objectSpread({}, entry, {
	            isShow: true
	          });
	        }
	      }
	
	      return result.filter(function (entry) {
	        return entry.isShow;
	      });
	    }
	  }, {
	    key: "renderTickItem",
	    value: function renderTickItem(option, props, value) {
	      var tickItem;
	
	      if (_react["default"].isValidElement(option)) {
	        tickItem = _react["default"].cloneElement(option, props);
	      } else if ((0, _isFunction2["default"])(option)) {
	        tickItem = option(props);
	      } else {
	        tickItem = _react["default"].createElement(_Text["default"], _extends({}, props, {
	          className: "recharts-cartesian-axis-tick-value"
	        }), value);
	      }
	
	      return tickItem;
	    }
	  }]);
	
	  return CartesianAxis;
	}(_react.Component);
	
	CartesianAxis.displayName = 'CartesianAxis';
	CartesianAxis.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {}, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _propTypes["default"].string,
	  x: _propTypes["default"].number,
	  y: _propTypes["default"].number,
	  width: _propTypes["default"].number,
	  height: _propTypes["default"].number,
	  orientation: _propTypes["default"].oneOf(['top', 'bottom', 'left', 'right']),
	  // The viewBox of svg
	  viewBox: _propTypes["default"].shape({
	    x: _propTypes["default"].number,
	    y: _propTypes["default"].number,
	    width: _propTypes["default"].number,
	    height: _propTypes["default"].number
	  }),
	  tick: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].func, _propTypes["default"].object, _propTypes["default"].element]),
	  axisLine: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].object]),
	  tickLine: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].object]),
	  mirror: _propTypes["default"].bool,
	  tickMargin: _propTypes["default"].number.isRequired,
	  minTickGap: _propTypes["default"].number,
	  ticks: _propTypes["default"].array,
	  tickSize: _propTypes["default"].number,
	  stroke: _propTypes["default"].string,
	  tickFormatter: _propTypes["default"].func,
	  ticksGenerator: _propTypes["default"].func,
	  interval: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].oneOf(['preserveStart', 'preserveEnd', 'preserveStartEnd'])])
	});
	CartesianAxis.defaultProps = {
	  x: 0,
	  y: 0,
	  width: 0,
	  height: 0,
	  viewBox: {
	    x: 0,
	    y: 0,
	    width: 0,
	    height: 0
	  },
	  // The orientation of axis
	  orientation: 'bottom',
	  // The ticks
	  ticks: [],
	  stroke: '#666',
	  tickLine: true,
	  axisLine: true,
	  tick: true,
	  mirror: false,
	  minTickGap: 5,
	  // The width or height of tick
	  tickSize: 6,
	  tickMargin: 2,
	  interval: 'preserveEnd'
	};
	var _default = CartesianAxis;
	exports["default"] = _default;

/***/ },
/* 984 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(38));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _Layer = _interopRequireDefault(__webpack_require__(49));
	
	var _Label = _interopRequireDefault(__webpack_require__(127));
	
	var _CartesianUtils = __webpack_require__(128);
	
	var _IfOverflowMatches = __webpack_require__(313);
	
	var _DataUtils = __webpack_require__(39);
	
	var _LogUtils = __webpack_require__(191);
	
	var _ReactUtils = __webpack_require__(29);
	
	var _Rectangle = _interopRequireDefault(__webpack_require__(190));
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var ReferenceArea =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(ReferenceArea, _PureComponent);
	
	  function ReferenceArea() {
	    _classCallCheck(this, ReferenceArea);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(ReferenceArea).apply(this, arguments));
	  }
	
	  _createClass(ReferenceArea, [{
	    key: "getRect",
	    value: function getRect(hasX1, hasX2, hasY1, hasY2) {
	      var _this$props = this.props,
	          xValue1 = _this$props.x1,
	          xValue2 = _this$props.x2,
	          yValue1 = _this$props.y1,
	          yValue2 = _this$props.y2,
	          xAxis = _this$props.xAxis,
	          yAxis = _this$props.yAxis;
	
	      var scale = _CartesianUtils.LabeledScaleHelper.create({
	        x: xAxis.scale,
	        y: yAxis.scale
	      });
	
	      var p1 = {
	        x: hasX1 ? scale.x.apply(xValue1) : scale.x.rangeMin,
	        y: hasY1 ? scale.y.apply(yValue1) : scale.y.rangeMin
	      };
	      var p2 = {
	        x: hasX2 ? scale.x.apply(xValue2) : scale.x.rangeMax,
	        y: hasY2 ? scale.y.apply(yValue2) : scale.y.rangeMax
	      };
	
	      if ((0, _IfOverflowMatches.ifOverflowMatches)(this.props, 'discard') && (!scale.isInRange(p1) || !scale.isInRange(p2))) {
	        return null;
	      }
	
	      return (0, _CartesianUtils.rectWithPoints)(p1, p2);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          x1 = _this$props2.x1,
	          x2 = _this$props2.x2,
	          y1 = _this$props2.y1,
	          y2 = _this$props2.y2,
	          className = _this$props2.className,
	          alwaysShow = _this$props2.alwaysShow,
	          clipPathId = _this$props2.clipPathId;
	      (0, _LogUtils.warn)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
	      var hasX1 = (0, _DataUtils.isNumOrStr)(x1);
	      var hasX2 = (0, _DataUtils.isNumOrStr)(x2);
	      var hasY1 = (0, _DataUtils.isNumOrStr)(y1);
	      var hasY2 = (0, _DataUtils.isNumOrStr)(y2);
	      var shape = this.props.shape;
	
	      if (!hasX1 && !hasX2 && !hasY1 && !hasY2 && !shape) {
	        return null;
	      }
	
	      var rect = this.getRect(hasX1, hasX2, hasY1, hasY2);
	
	      if (!rect && !shape) {
	        return null;
	      }
	
	      var clipPath = (0, _IfOverflowMatches.ifOverflowMatches)(this.props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;
	      return _react["default"].createElement(_Layer["default"], {
	        className: (0, _classnames["default"])('recharts-reference-area', className)
	      }, this.constructor.renderRect(shape, _objectSpread({
	        clipPath: clipPath
	      }, this.props, {}, rect)), _Label["default"].renderCallByParent(this.props, rect));
	    }
	  }], [{
	    key: "renderRect",
	    value: function renderRect(option, props) {
	      var rect;
	
	      if (_react["default"].isValidElement(option)) {
	        rect = _react["default"].cloneElement(option, props);
	      } else if ((0, _isFunction2["default"])(option)) {
	        rect = option(props);
	      } else {
	        rect = _react["default"].createElement(_Rectangle["default"], _extends({}, props, {
	          className: "recharts-reference-area-rect"
	        }));
	      }
	
	      return rect;
	    }
	  }]);
	
	  return ReferenceArea;
	}(_react.PureComponent);
	
	ReferenceArea.displayName = 'ReferenceArea';
	ReferenceArea.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  viewBox: _propTypes["default"].shape({
	    x: _propTypes["default"].number,
	    y: _propTypes["default"].number,
	    width: _propTypes["default"].number,
	    height: _propTypes["default"].number
	  }),
	  xAxis: _propTypes["default"].object,
	  yAxis: _propTypes["default"].object,
	  isFront: _propTypes["default"].bool,
	  alwaysShow: _propTypes["default"].bool,
	  ifOverflow: _propTypes["default"].oneOf(['hidden', 'visible', 'discard', 'extendDomain']),
	  x1: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  x2: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  y1: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  y2: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  className: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  yAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  xAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  shape: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].element])
	});
	ReferenceArea.defaultProps = {
	  isFront: false,
	  ifOverflow: 'discard',
	  xAxisId: 0,
	  yAxisId: 0,
	  r: 10,
	  fill: '#ccc',
	  fillOpacity: 0.5,
	  stroke: 'none',
	  strokeWidth: 1
	};
	var _default = ReferenceArea;
	exports["default"] = _default;

/***/ },
/* 985 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(38));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _Layer = _interopRequireDefault(__webpack_require__(49));
	
	var _Dot = _interopRequireDefault(__webpack_require__(153));
	
	var _ReactUtils = __webpack_require__(29);
	
	var _Label = _interopRequireDefault(__webpack_require__(127));
	
	var _DataUtils = __webpack_require__(39);
	
	var _IfOverflowMatches = __webpack_require__(313);
	
	var _CartesianUtils = __webpack_require__(128);
	
	var _LogUtils = __webpack_require__(191);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var ReferenceDot =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(ReferenceDot, _PureComponent);
	
	  function ReferenceDot() {
	    _classCallCheck(this, ReferenceDot);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(ReferenceDot).apply(this, arguments));
	  }
	
	  _createClass(ReferenceDot, [{
	    key: "getCoordinate",
	    value: function getCoordinate() {
	      var _this$props = this.props,
	          x = _this$props.x,
	          y = _this$props.y,
	          xAxis = _this$props.xAxis,
	          yAxis = _this$props.yAxis;
	
	      var scales = _CartesianUtils.LabeledScaleHelper.create({
	        x: xAxis.scale,
	        y: yAxis.scale
	      });
	
	      var result = scales.apply({
	        x: x,
	        y: y
	      }, {
	        bandAware: true
	      });
	
	      if ((0, _IfOverflowMatches.ifOverflowMatches)(this.props, 'discard') && !scales.isInRange(result)) {
	        return null;
	      }
	
	      return result;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          x = _this$props2.x,
	          y = _this$props2.y,
	          r = _this$props2.r,
	          alwaysShow = _this$props2.alwaysShow,
	          clipPathId = _this$props2.clipPathId;
	      var isX = (0, _DataUtils.isNumOrStr)(x);
	      var isY = (0, _DataUtils.isNumOrStr)(y);
	      (0, _LogUtils.warn)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
	
	      if (!isX || !isY) {
	        return null;
	      }
	
	      var coordinate = this.getCoordinate();
	
	      if (!coordinate) {
	        return null;
	      }
	
	      var cx = coordinate.x,
	          cy = coordinate.y;
	      var _this$props3 = this.props,
	          shape = _this$props3.shape,
	          className = _this$props3.className;
	      var clipPath = (0, _IfOverflowMatches.ifOverflowMatches)(this.props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;
	
	      var dotProps = _objectSpread({
	        clipPath: clipPath
	      }, (0, _ReactUtils.getPresentationAttributes)(this.props), {}, (0, _ReactUtils.filterEventAttributes)(this.props), {
	        cx: cx,
	        cy: cy
	      });
	
	      return _react["default"].createElement(_Layer["default"], {
	        className: (0, _classnames["default"])('recharts-reference-dot', className)
	      }, this.constructor.renderDot(shape, dotProps), _Label["default"].renderCallByParent(this.props, {
	        x: cx - r,
	        y: cy - r,
	        width: 2 * r,
	        height: 2 * r
	      }));
	    }
	  }], [{
	    key: "renderDot",
	    value: function renderDot(option, props) {
	      var dot;
	
	      if (_react["default"].isValidElement(option)) {
	        dot = _react["default"].cloneElement(option, props);
	      } else if ((0, _isFunction2["default"])(option)) {
	        dot = option(props);
	      } else {
	        dot = _react["default"].createElement(_Dot["default"], _extends({}, props, {
	          cx: props.cx,
	          cy: props.cy,
	          className: "recharts-reference-dot-dot"
	        }));
	      }
	
	      return dot;
	    }
	  }]);
	
	  return ReferenceDot;
	}(_react.PureComponent);
	
	ReferenceDot.displayName = 'ReferenceDot';
	ReferenceDot.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {}, _ReactUtils.EVENT_ATTRIBUTES, {
	  r: _propTypes["default"].number,
	  xAxis: _propTypes["default"].shape({
	    scale: _propTypes["default"].func
	  }),
	  yAxis: _propTypes["default"].shape({
	    scale: _propTypes["default"].func
	  }),
	  isFront: _propTypes["default"].bool,
	  alwaysShow: _propTypes["default"].bool,
	  ifOverflow: _propTypes["default"].oneOf(['hidden', 'visible', 'discard', 'extendDomain']),
	  x: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  y: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  className: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  yAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  xAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  shape: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].element]),
	  clipPathId: _propTypes["default"].string
	});
	ReferenceDot.defaultProps = {
	  isFront: false,
	  ifOverflow: 'discard',
	  xAxisId: 0,
	  yAxisId: 0,
	  r: 10,
	  fill: '#fff',
	  stroke: '#ccc',
	  fillOpacity: 1,
	  strokeWidth: 1
	};
	var _default = ReferenceDot;
	exports["default"] = _default;

/***/ },
/* 986 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _some2 = _interopRequireDefault(__webpack_require__(2180));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(38));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _Layer = _interopRequireDefault(__webpack_require__(49));
	
	var _ReactUtils = __webpack_require__(29);
	
	var _Label = _interopRequireDefault(__webpack_require__(127));
	
	var _IfOverflowMatches = __webpack_require__(313);
	
	var _DataUtils = __webpack_require__(39);
	
	var _CartesianUtils = __webpack_require__(128);
	
	var _LogUtils = __webpack_require__(191);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var renderLine = function renderLine(option, props) {
	  var line;
	
	  if (_react["default"].isValidElement(option)) {
	    line = _react["default"].cloneElement(option, props);
	  } else if ((0, _isFunction2["default"])(option)) {
	    line = option(props);
	  } else {
	    line = _react["default"].createElement("line", _extends({}, props, {
	      className: "recharts-reference-line-line"
	    }));
	  }
	
	  return line;
	};
	
	var ReferenceLine =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(ReferenceLine, _PureComponent);
	
	  function ReferenceLine() {
	    _classCallCheck(this, ReferenceLine);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(ReferenceLine).apply(this, arguments));
	  }
	
	  _createClass(ReferenceLine, [{
	    key: "getEndPoints",
	    value: function getEndPoints(scales, isFixedX, isFixedY, isSegment) {
	      var _this$props = this.props,
	          _this$props$viewBox = _this$props.viewBox,
	          x = _this$props$viewBox.x,
	          y = _this$props$viewBox.y,
	          width = _this$props$viewBox.width,
	          height = _this$props$viewBox.height,
	          position = _this$props.position;
	
	      if (isFixedY) {
	        var _this$props2 = this.props,
	            yCoord = _this$props2.y,
	            orientation = _this$props2.yAxis.orientation;
	        var coord = scales.y.apply(yCoord, {
	          position: position
	        });
	
	        if ((0, _IfOverflowMatches.ifOverflowMatches)(this.props, 'discard') && !scales.y.isInRange(coord)) {
	          return null;
	        }
	
	        var points = [{
	          x: x + width,
	          y: coord
	        }, {
	          x: x,
	          y: coord
	        }];
	        return orientation === 'left' ? points.reverse() : points;
	      }
	
	      if (isFixedX) {
	        var _this$props3 = this.props,
	            xCoord = _this$props3.x,
	            _orientation = _this$props3.xAxis.orientation;
	
	        var _coord = scales.x.apply(xCoord, {
	          position: position
	        });
	
	        if ((0, _IfOverflowMatches.ifOverflowMatches)(this.props, 'discard') && !scales.x.isInRange(_coord)) {
	          return null;
	        }
	
	        var _points = [{
	          x: _coord,
	          y: y + height
	        }, {
	          x: _coord,
	          y: y
	        }];
	        return _orientation === 'top' ? _points.reverse() : _points;
	      }
	
	      if (isSegment) {
	        var segment = this.props.segment;
	
	        var _points2 = segment.map(function (p) {
	          return scales.apply(p, {
	            position: position
	          });
	        });
	
	        if ((0, _IfOverflowMatches.ifOverflowMatches)(this.props, 'discard') && (0, _some2["default"])(_points2, function (p) {
	          return !scales.isInRange(p);
	        })) {
	          return null;
	        }
	
	        return _points2;
	      }
	
	      return null;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props4 = this.props,
	          fixedX = _this$props4.x,
	          fixedY = _this$props4.y,
	          segment = _this$props4.segment,
	          xAxis = _this$props4.xAxis,
	          yAxis = _this$props4.yAxis,
	          shape = _this$props4.shape,
	          className = _this$props4.className,
	          alwaysShow = _this$props4.alwaysShow,
	          clipPathId = _this$props4.clipPathId;
	      (0, _LogUtils.warn)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
	
	      var scales = _CartesianUtils.LabeledScaleHelper.create({
	        x: xAxis.scale,
	        y: yAxis.scale
	      });
	
	      var isX = (0, _DataUtils.isNumOrStr)(fixedX);
	      var isY = (0, _DataUtils.isNumOrStr)(fixedY);
	      var isSegment = segment && segment.length === 2;
	      var endPoints = this.getEndPoints(scales, isX, isY, isSegment);
	
	      if (!endPoints) {
	        return null;
	      }
	
	      var _endPoints = _slicedToArray(endPoints, 2),
	          _endPoints$ = _endPoints[0],
	          x1 = _endPoints$.x,
	          y1 = _endPoints$.y,
	          _endPoints$2 = _endPoints[1],
	          x2 = _endPoints$2.x,
	          y2 = _endPoints$2.y;
	
	      var clipPath = (0, _IfOverflowMatches.ifOverflowMatches)(this.props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;
	
	      var props = _objectSpread({
	        clipPath: clipPath
	      }, (0, _ReactUtils.getPresentationAttributes)(this.props), {}, (0, _ReactUtils.filterEventAttributes)(this.props), {
	        x1: x1,
	        y1: y1,
	        x2: x2,
	        y2: y2
	      });
	
	      return _react["default"].createElement(_Layer["default"], {
	        className: (0, _classnames["default"])('recharts-reference-line', className)
	      }, renderLine(shape, props), _Label["default"].renderCallByParent(this.props, (0, _CartesianUtils.rectWithCoords)({
	        x1: x1,
	        y1: y1,
	        x2: x2,
	        y2: y2
	      })));
	    }
	  }]);
	
	  return ReferenceLine;
	}(_react.PureComponent);
	
	ReferenceLine.displayName = 'ReferenceLine';
	ReferenceLine.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  viewBox: _propTypes["default"].shape({
	    x: _propTypes["default"].number,
	    y: _propTypes["default"].number,
	    width: _propTypes["default"].number,
	    height: _propTypes["default"].number
	  }),
	  xAxis: _propTypes["default"].object,
	  yAxis: _propTypes["default"].object,
	  isFront: _propTypes["default"].bool,
	  alwaysShow: _propTypes["default"].bool,
	  ifOverflow: _propTypes["default"].oneOf(['hidden', 'visible', 'discard', 'extendDomain']),
	  x: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  y: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  segment: _propTypes["default"].arrayOf(_propTypes["default"].shape({
	    x: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	    y: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
	  })),
	  position: _propTypes["default"].oneOf(['middle', 'start', 'end']),
	  className: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  yAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  xAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  shape: _propTypes["default"].func
	});
	ReferenceLine.defaultProps = {
	  isFront: false,
	  ifOverflow: 'discard',
	  xAxisId: 0,
	  yAxisId: 0,
	  fill: 'none',
	  stroke: '#ccc',
	  fillOpacity: 1,
	  strokeWidth: 1,
	  position: 'middle'
	};
	var _default = ReferenceLine;
	exports["default"] = _default;

/***/ },
/* 987 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "Surface", {
	  enumerable: true,
	  get: function get() {
	    return _Surface2["default"];
	  }
	});
	Object.defineProperty(exports, "Layer", {
	  enumerable: true,
	  get: function get() {
	    return _Layer2["default"];
	  }
	});
	Object.defineProperty(exports, "Legend", {
	  enumerable: true,
	  get: function get() {
	    return _Legend2["default"];
	  }
	});
	Object.defineProperty(exports, "Tooltip", {
	  enumerable: true,
	  get: function get() {
	    return _Tooltip2["default"];
	  }
	});
	Object.defineProperty(exports, "ResponsiveContainer", {
	  enumerable: true,
	  get: function get() {
	    return _ResponsiveContainer2["default"];
	  }
	});
	Object.defineProperty(exports, "Cell", {
	  enumerable: true,
	  get: function get() {
	    return _Cell2["default"];
	  }
	});
	Object.defineProperty(exports, "Text", {
	  enumerable: true,
	  get: function get() {
	    return _Text2["default"];
	  }
	});
	Object.defineProperty(exports, "Label", {
	  enumerable: true,
	  get: function get() {
	    return _Label2["default"];
	  }
	});
	Object.defineProperty(exports, "LabelList", {
	  enumerable: true,
	  get: function get() {
	    return _LabelList2["default"];
	  }
	});
	Object.defineProperty(exports, "Customized", {
	  enumerable: true,
	  get: function get() {
	    return _Customized2["default"];
	  }
	});
	Object.defineProperty(exports, "Sector", {
	  enumerable: true,
	  get: function get() {
	    return _Sector2["default"];
	  }
	});
	Object.defineProperty(exports, "Curve", {
	  enumerable: true,
	  get: function get() {
	    return _Curve2["default"];
	  }
	});
	Object.defineProperty(exports, "Rectangle", {
	  enumerable: true,
	  get: function get() {
	    return _Rectangle2["default"];
	  }
	});
	Object.defineProperty(exports, "Polygon", {
	  enumerable: true,
	  get: function get() {
	    return _Polygon2["default"];
	  }
	});
	Object.defineProperty(exports, "Dot", {
	  enumerable: true,
	  get: function get() {
	    return _Dot2["default"];
	  }
	});
	Object.defineProperty(exports, "Cross", {
	  enumerable: true,
	  get: function get() {
	    return _Cross2["default"];
	  }
	});
	Object.defineProperty(exports, "Symbols", {
	  enumerable: true,
	  get: function get() {
	    return _Symbols2["default"];
	  }
	});
	Object.defineProperty(exports, "PolarGrid", {
	  enumerable: true,
	  get: function get() {
	    return _PolarGrid2["default"];
	  }
	});
	Object.defineProperty(exports, "PolarRadiusAxis", {
	  enumerable: true,
	  get: function get() {
	    return _PolarRadiusAxis2["default"];
	  }
	});
	Object.defineProperty(exports, "PolarAngleAxis", {
	  enumerable: true,
	  get: function get() {
	    return _PolarAngleAxis2["default"];
	  }
	});
	Object.defineProperty(exports, "Pie", {
	  enumerable: true,
	  get: function get() {
	    return _Pie2["default"];
	  }
	});
	Object.defineProperty(exports, "Radar", {
	  enumerable: true,
	  get: function get() {
	    return _Radar2["default"];
	  }
	});
	Object.defineProperty(exports, "RadialBar", {
	  enumerable: true,
	  get: function get() {
	    return _RadialBar2["default"];
	  }
	});
	Object.defineProperty(exports, "Brush", {
	  enumerable: true,
	  get: function get() {
	    return _Brush2["default"];
	  }
	});
	Object.defineProperty(exports, "ReferenceLine", {
	  enumerable: true,
	  get: function get() {
	    return _ReferenceLine2["default"];
	  }
	});
	Object.defineProperty(exports, "ReferenceDot", {
	  enumerable: true,
	  get: function get() {
	    return _ReferenceDot2["default"];
	  }
	});
	Object.defineProperty(exports, "ReferenceArea", {
	  enumerable: true,
	  get: function get() {
	    return _ReferenceArea2["default"];
	  }
	});
	Object.defineProperty(exports, "CartesianAxis", {
	  enumerable: true,
	  get: function get() {
	    return _CartesianAxis2["default"];
	  }
	});
	Object.defineProperty(exports, "CartesianGrid", {
	  enumerable: true,
	  get: function get() {
	    return _CartesianGrid2["default"];
	  }
	});
	Object.defineProperty(exports, "Line", {
	  enumerable: true,
	  get: function get() {
	    return _Line2["default"];
	  }
	});
	Object.defineProperty(exports, "Area", {
	  enumerable: true,
	  get: function get() {
	    return _Area2["default"];
	  }
	});
	Object.defineProperty(exports, "Bar", {
	  enumerable: true,
	  get: function get() {
	    return _Bar2["default"];
	  }
	});
	Object.defineProperty(exports, "Scatter", {
	  enumerable: true,
	  get: function get() {
	    return _Scatter2["default"];
	  }
	});
	Object.defineProperty(exports, "XAxis", {
	  enumerable: true,
	  get: function get() {
	    return _XAxis2["default"];
	  }
	});
	Object.defineProperty(exports, "YAxis", {
	  enumerable: true,
	  get: function get() {
	    return _YAxis2["default"];
	  }
	});
	Object.defineProperty(exports, "ZAxis", {
	  enumerable: true,
	  get: function get() {
	    return _ZAxis2["default"];
	  }
	});
	Object.defineProperty(exports, "ErrorBar", {
	  enumerable: true,
	  get: function get() {
	    return _ErrorBar2["default"];
	  }
	});
	Object.defineProperty(exports, "LineChart", {
	  enumerable: true,
	  get: function get() {
	    return _LineChart2["default"];
	  }
	});
	Object.defineProperty(exports, "BarChart", {
	  enumerable: true,
	  get: function get() {
	    return _BarChart2["default"];
	  }
	});
	Object.defineProperty(exports, "PieChart", {
	  enumerable: true,
	  get: function get() {
	    return _PieChart2["default"];
	  }
	});
	Object.defineProperty(exports, "Treemap", {
	  enumerable: true,
	  get: function get() {
	    return _Treemap2["default"];
	  }
	});
	Object.defineProperty(exports, "Sankey", {
	  enumerable: true,
	  get: function get() {
	    return _Sankey2["default"];
	  }
	});
	Object.defineProperty(exports, "RadarChart", {
	  enumerable: true,
	  get: function get() {
	    return _RadarChart2["default"];
	  }
	});
	Object.defineProperty(exports, "ScatterChart", {
	  enumerable: true,
	  get: function get() {
	    return _ScatterChart2["default"];
	  }
	});
	Object.defineProperty(exports, "AreaChart", {
	  enumerable: true,
	  get: function get() {
	    return _AreaChart2["default"];
	  }
	});
	Object.defineProperty(exports, "RadialBarChart", {
	  enumerable: true,
	  get: function get() {
	    return _RadialBarChart2["default"];
	  }
	});
	Object.defineProperty(exports, "ComposedChart", {
	  enumerable: true,
	  get: function get() {
	    return _ComposedChart2["default"];
	  }
	});
	Object.defineProperty(exports, "Funnel", {
	  enumerable: true,
	  get: function get() {
	    return _Funnel2["default"];
	  }
	});
	Object.defineProperty(exports, "FunnelChart", {
	  enumerable: true,
	  get: function get() {
	    return _FunnelChart2["default"];
	  }
	});
	Object.defineProperty(exports, "Trapezoid", {
	  enumerable: true,
	  get: function get() {
	    return _Trapezoid2["default"];
	  }
	});
	
	__webpack_require__(2431);
	
	var _Surface2 = _interopRequireDefault(__webpack_require__(231));
	
	var _Layer2 = _interopRequireDefault(__webpack_require__(49));
	
	var _Legend2 = _interopRequireDefault(__webpack_require__(477));
	
	var _Tooltip2 = _interopRequireDefault(__webpack_require__(307));
	
	var _ResponsiveContainer2 = _interopRequireDefault(__webpack_require__(2429));
	
	var _Cell2 = _interopRequireDefault(__webpack_require__(188));
	
	var _Text2 = _interopRequireDefault(__webpack_require__(152));
	
	var _Label2 = _interopRequireDefault(__webpack_require__(127));
	
	var _LabelList2 = _interopRequireDefault(__webpack_require__(113));
	
	var _Customized2 = _interopRequireDefault(__webpack_require__(2426));
	
	var _Sector2 = _interopRequireDefault(__webpack_require__(311));
	
	var _Curve2 = _interopRequireDefault(__webpack_require__(189));
	
	var _Rectangle2 = _interopRequireDefault(__webpack_require__(190));
	
	var _Polygon2 = _interopRequireDefault(__webpack_require__(310));
	
	var _Dot2 = _interopRequireDefault(__webpack_require__(153));
	
	var _Cross2 = _interopRequireDefault(__webpack_require__(992));
	
	var _Symbols2 = _interopRequireDefault(__webpack_require__(478));
	
	var _PolarGrid2 = _interopRequireDefault(__webpack_require__(2430));
	
	var _PolarRadiusAxis2 = _interopRequireDefault(__webpack_require__(309));
	
	var _PolarAngleAxis2 = _interopRequireDefault(__webpack_require__(308));
	
	var _Pie2 = _interopRequireDefault(__webpack_require__(989));
	
	var _Radar2 = _interopRequireDefault(__webpack_require__(990));
	
	var _RadialBar2 = _interopRequireDefault(__webpack_require__(991));
	
	var _Brush2 = _interopRequireDefault(__webpack_require__(982));
	
	var _ReferenceLine2 = _interopRequireDefault(__webpack_require__(986));
	
	var _ReferenceDot2 = _interopRequireDefault(__webpack_require__(985));
	
	var _ReferenceArea2 = _interopRequireDefault(__webpack_require__(984));
	
	var _CartesianAxis2 = _interopRequireDefault(__webpack_require__(983));
	
	var _CartesianGrid2 = _interopRequireDefault(__webpack_require__(2414));
	
	var _Line2 = _interopRequireDefault(__webpack_require__(475));
	
	var _Area2 = _interopRequireDefault(__webpack_require__(473));
	
	var _Bar2 = _interopRequireDefault(__webpack_require__(474));
	
	var _Scatter2 = _interopRequireDefault(__webpack_require__(476));
	
	var _XAxis2 = _interopRequireDefault(__webpack_require__(186));
	
	var _YAxis2 = _interopRequireDefault(__webpack_require__(187));
	
	var _ZAxis2 = _interopRequireDefault(__webpack_require__(306));
	
	var _ErrorBar2 = _interopRequireDefault(__webpack_require__(230));
	
	var _LineChart2 = _interopRequireDefault(__webpack_require__(2419));
	
	var _BarChart2 = _interopRequireDefault(__webpack_require__(2416));
	
	var _PieChart2 = _interopRequireDefault(__webpack_require__(2420));
	
	var _Treemap2 = _interopRequireDefault(__webpack_require__(2425));
	
	var _Sankey2 = _interopRequireDefault(__webpack_require__(2423));
	
	var _RadarChart2 = _interopRequireDefault(__webpack_require__(2421));
	
	var _ScatterChart2 = _interopRequireDefault(__webpack_require__(2424));
	
	var _AreaChart2 = _interopRequireDefault(__webpack_require__(2415));
	
	var _RadialBarChart2 = _interopRequireDefault(__webpack_require__(2422));
	
	var _ComposedChart2 = _interopRequireDefault(__webpack_require__(2417));
	
	var _Funnel2 = _interopRequireDefault(__webpack_require__(988));
	
	var _FunnelChart2 = _interopRequireDefault(__webpack_require__(2418));
	
	var _Trapezoid2 = _interopRequireDefault(__webpack_require__(993));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/***/ },
/* 988 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isEqual2 = _interopRequireDefault(__webpack_require__(98));
	
	var _isPlainObject2 = _interopRequireDefault(__webpack_require__(225));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(38));
	
	var _omit2 = _interopRequireDefault(__webpack_require__(758));
	
	var _isString2 = _interopRequireDefault(__webpack_require__(292));
	
	var _isNumber2 = _interopRequireDefault(__webpack_require__(291));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _reactSmooth = _interopRequireDefault(__webpack_require__(81));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _Layer = _interopRequireDefault(__webpack_require__(49));
	
	var _Trapezoid = _interopRequireDefault(__webpack_require__(993));
	
	var _LabelList = _interopRequireDefault(__webpack_require__(113));
	
	var _Cell = _interopRequireDefault(__webpack_require__(188));
	
	var _ReactUtils = __webpack_require__(29);
	
	var _DataUtils = __webpack_require__(39);
	
	var _ChartUtils = __webpack_require__(66);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var Funnel =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Funnel, _PureComponent);
	
	  function Funnel() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Funnel);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Funnel)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      isAnimationFinished: false
	    };
	
	    _this.cachePrevData = function (trapezoids) {
	      _this.setState({
	        prevTrapezoids: trapezoids
	      });
	    };
	
	    _this.handleAnimationEnd = function () {
	      var onAnimationEnd = _this.props.onAnimationEnd;
	
	      _this.setState({
	        isAnimationFinished: true
	      });
	
	      if ((0, _isFunction2["default"])(onAnimationEnd)) {
	        onAnimationEnd();
	      }
	    };
	
	    _this.handleAnimationStart = function () {
	      var onAnimationStart = _this.props.onAnimationStart;
	
	      _this.setState({
	        isAnimationFinished: false
	      });
	
	      if ((0, _isFunction2["default"])(onAnimationStart)) {
	        onAnimationStart();
	      }
	    };
	
	    return _this;
	  }
	
	  _createClass(Funnel, [{
	    key: "componentWillReceiveProps",
	    // eslint-disable-next-line camelcase
	    value: function componentWillReceiveProps(nextProps) {
	      var _this$props = this.props,
	          animationId = _this$props.animationId,
	          trapezoids = _this$props.trapezoids;
	
	      if (nextProps.isAnimationActive !== this.props.isAnimationActive) {
	        this.cachePrevData([]);
	      } else if (nextProps.animationId !== animationId) {
	        this.cachePrevData(trapezoids);
	      }
	    }
	  }, {
	    key: "isActiveIndex",
	    value: function isActiveIndex(i) {
	      var activeIndex = this.props.activeIndex;
	
	      if (Array.isArray(activeIndex)) {
	        return activeIndex.indexOf(i) !== -1;
	      }
	
	      return i === activeIndex;
	    }
	  }, {
	    key: "renderTrapezoidsStatically",
	    value: function renderTrapezoidsStatically(trapezoids) {
	      var _this2 = this;
	
	      var activeShape = this.props.activeShape;
	      return trapezoids.map(function (entry, i) {
	        var trapezoidOptions = _this2.isActiveIndex(i) ? activeShape : null;
	
	        var trapezoidProps = _objectSpread({}, entry, {
	          stroke: entry.stroke
	        });
	
	        return _react["default"].createElement(_Layer["default"], _extends({
	          className: "recharts-funnel-trapezoid"
	        }, (0, _ReactUtils.filterEventsOfChild)(_this2.props, entry, i), {
	          key: "trapezoid-".concat(i) // eslint-disable-line react/no-array-index-key
	
	        }), _this2.constructor.renderTrapezoidItem(trapezoidOptions, trapezoidProps));
	      });
	    }
	  }, {
	    key: "renderTrapezoidsWithAnimation",
	    value: function renderTrapezoidsWithAnimation() {
	      var _this3 = this;
	
	      var _this$props2 = this.props,
	          trapezoids = _this$props2.trapezoids,
	          isAnimationActive = _this$props2.isAnimationActive,
	          animationBegin = _this$props2.animationBegin,
	          animationDuration = _this$props2.animationDuration,
	          animationEasing = _this$props2.animationEasing,
	          animationId = _this$props2.animationId;
	      var prevTrapezoids = this.state.prevTrapezoids;
	      return _react["default"].createElement(_reactSmooth["default"], {
	        begin: animationBegin,
	        duration: animationDuration,
	        isActive: isAnimationActive,
	        easing: animationEasing,
	        from: {
	          t: 0
	        },
	        to: {
	          t: 1
	        },
	        key: "funnel-".concat(animationId),
	        onAnimationStart: this.handleAnimationStart,
	        onAnimationEnd: this.handleAnimationEnd
	      }, function (_ref) {
	        var t = _ref.t;
	        var stepData = trapezoids.map(function (entry, index) {
	          var prev = prevTrapezoids && prevTrapezoids[index];
	
	          if (prev) {
	            var _interpolatorX = (0, _DataUtils.interpolateNumber)(prev.x, entry.x);
	
	            var _interpolatorY = (0, _DataUtils.interpolateNumber)(prev.y, entry.y);
	
	            var _interpolatorUpperWidth = (0, _DataUtils.interpolateNumber)(prev.upperWidth, entry.upperWidth);
	
	            var _interpolatorLowerWidth = (0, _DataUtils.interpolateNumber)(prev.lowerWidth, entry.lowerWidth);
	
	            var _interpolatorHeight = (0, _DataUtils.interpolateNumber)(prev.height, entry.height);
	
	            return _objectSpread({}, entry, {
	              x: _interpolatorX(t),
	              y: _interpolatorY(t),
	              upperWidth: _interpolatorUpperWidth(t),
	              lowerWidth: _interpolatorLowerWidth(t),
	              height: _interpolatorHeight(t)
	            });
	          }
	
	          var interpolatorX = (0, _DataUtils.interpolateNumber)(entry.x + entry.upperWidth / 2, entry.x);
	          var interpolatorY = (0, _DataUtils.interpolateNumber)(entry.y + entry.height / 2, entry.y);
	          var interpolatorUpperWidth = (0, _DataUtils.interpolateNumber)(0, entry.upperWidth);
	          var interpolatorLowerWidth = (0, _DataUtils.interpolateNumber)(0, entry.lowerWidth);
	          var interpolatorHeight = (0, _DataUtils.interpolateNumber)(0, entry.height);
	          return _objectSpread({}, entry, {
	            x: interpolatorX(t),
	            y: interpolatorY(t),
	            upperWidth: interpolatorUpperWidth(t),
	            lowerWidth: interpolatorLowerWidth(t),
	            height: interpolatorHeight(t)
	          });
	        });
	        return _react["default"].createElement(_Layer["default"], null, _this3.renderTrapezoidsStatically(stepData));
	      });
	    }
	  }, {
	    key: "renderTrapezoids",
	    value: function renderTrapezoids() {
	      var _this$props3 = this.props,
	          trapezoids = _this$props3.trapezoids,
	          isAnimationActive = _this$props3.isAnimationActive;
	      var prevTrapezoids = this.state.prevTrapezoids;
	
	      if (isAnimationActive && trapezoids && trapezoids.length && (!prevTrapezoids || !(0, _isEqual2["default"])(prevTrapezoids, trapezoids))) {
	        return this.renderTrapezoidsWithAnimation();
	      }
	
	      return this.renderTrapezoidsStatically(trapezoids);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props4 = this.props,
	          hide = _this$props4.hide,
	          trapezoids = _this$props4.trapezoids,
	          className = _this$props4.className,
	          isAnimationActive = _this$props4.isAnimationActive;
	      var isAnimationFinished = this.state.isAnimationFinished;
	
	      if (hide || !trapezoids || !trapezoids.length) {
	        return null;
	      }
	
	      var layerClass = (0, _classnames["default"])('recharts-trapezoids', className);
	      return _react["default"].createElement(_Layer["default"], {
	        className: layerClass
	      }, this.renderTrapezoids(), (!isAnimationActive || isAnimationFinished) && _LabelList["default"].renderCallByParent(this.props, trapezoids));
	    }
	  }], [{
	    key: "renderTrapezoidItem",
	    value: function renderTrapezoidItem(option, props) {
	      if (_react["default"].isValidElement(option)) {
	        return _react["default"].cloneElement(option, props);
	      }
	
	      if ((0, _isFunction2["default"])(option)) {
	        return option(props);
	      }
	
	      if ((0, _isPlainObject2["default"])(option)) {
	        return _react["default"].createElement(_Trapezoid["default"], _extends({}, props, option));
	      }
	
	      return _react["default"].createElement(_Trapezoid["default"], props);
	    }
	  }]);
	
	  return Funnel;
	}(_react.PureComponent);
	
	Funnel.displayName = 'Funnel';
	Funnel.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {}, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _propTypes["default"].string,
	  animationId: _propTypes["default"].number,
	  dataKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func]).isRequired,
	  nameKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func]),
	  data: _propTypes["default"].arrayOf(_propTypes["default"].object),
	  trapezoids: _propTypes["default"].arrayOf(_propTypes["default"].object),
	  hide: _propTypes["default"].bool,
	  activeShape: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].func, _propTypes["default"].element]),
	  legendType: _propTypes["default"].oneOf(_ReactUtils.LEGEND_TYPES),
	  tooltipType: _propTypes["default"].oneOf(_ReactUtils.TOOLTIP_TYPES),
	  activeIndex: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].arrayOf(_propTypes["default"].number)]),
	  onAnimationStart: _propTypes["default"].func,
	  onAnimationEnd: _propTypes["default"].func,
	  isAnimationActive: _propTypes["default"].bool,
	  animationBegin: _propTypes["default"].number,
	  animationDuration: _propTypes["default"].number,
	  animationEasing: _propTypes["default"].oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'spring', 'linear'])
	});
	Funnel.defaultProps = {
	  stroke: '#fff',
	  fill: '#808080',
	  legendType: 'rect',
	  labelLine: true,
	  hide: false,
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 400,
	  animationDuration: 1500,
	  animationEasing: 'ease',
	  nameKey: 'name'
	};
	
	Funnel.getRealFunnelData = function (item) {
	  var _item$props = item.props,
	      data = _item$props.data,
	      children = _item$props.children;
	  var presentationProps = (0, _ReactUtils.getPresentationAttributes)(item.props);
	  var cells = (0, _ReactUtils.findAllByType)(children, _Cell["default"]);
	
	  if (data && data.length) {
	    return data.map(function (entry, index) {
	      return _objectSpread({
	        payload: entry
	      }, presentationProps, {}, entry, {}, cells && cells[index] && cells[index].props);
	    });
	  }
	
	  if (cells && cells.length) {
	    return cells.map(function (cell) {
	      return _objectSpread({}, presentationProps, {}, cell.props);
	    });
	  }
	
	  return [];
	};
	
	Funnel.getRealWidthHeight = function (item, offset) {
	  var customWidth = item.props.width;
	  var width = offset.width,
	      height = offset.height,
	      left = offset.left,
	      right = offset.right,
	      top = offset.top,
	      bottom = offset.bottom;
	  var realHeight = height;
	  var realWidth = width;
	
	  if ((0, _isNumber2["default"])(customWidth)) {
	    realWidth = customWidth;
	  } else if ((0, _isString2["default"])(customWidth)) {
	    realWidth = realWidth * parseFloat(customWidth) / 100;
	  }
	
	  return {
	    realWidth: realWidth - left - right - 50,
	    realHeight: realHeight - bottom - top,
	    offsetX: (width - realWidth) / 2,
	    offsetY: (height - realHeight) / 2
	  };
	};
	
	Funnel.getComposedData = function (_ref2) {
	  var item = _ref2.item,
	      offset = _ref2.offset,
	      onItemMouseLeave = _ref2.onItemMouseLeave,
	      onItemMouseEnter = _ref2.onItemMouseEnter;
	  var funnelData = Funnel.getRealFunnelData(item);
	  var _item$props2 = item.props,
	      dataKey = _item$props2.dataKey,
	      nameKey = _item$props2.nameKey,
	      tooltipType = _item$props2.tooltipType;
	  var left = offset.left,
	      top = offset.top;
	
	  var _Funnel$getRealWidthH = Funnel.getRealWidthHeight(item, offset),
	      realHeight = _Funnel$getRealWidthH.realHeight,
	      realWidth = _Funnel$getRealWidthH.realWidth,
	      offsetX = _Funnel$getRealWidthH.offsetX,
	      offsetY = _Funnel$getRealWidthH.offsetY;
	
	  var maxValue = (0, _ChartUtils.getValueByDataKey)(funnelData[0], dataKey, 0);
	  var len = funnelData.length;
	  var rowHeight = realHeight / len;
	  var trapezoids = funnelData.map(function (entry, i) {
	    var val = (0, _ChartUtils.getValueByDataKey)(entry, dataKey, 0);
	    var name = (0, _ChartUtils.getValueByDataKey)(entry, nameKey, i);
	    var nextVal = 0;
	
	    if (i !== len - 1) {
	      nextVal = (0, _ChartUtils.getValueByDataKey)(funnelData[i + 1], dataKey, 0);
	    }
	
	    var x = (maxValue - val) * realWidth / (2 * maxValue) + top + 25 + offsetX;
	    var y = realHeight / len * i + left + offsetY;
	    var upperWidth = val / maxValue * realWidth;
	    var lowerWidth = nextVal / maxValue * realWidth;
	    var tooltipPayload = [{
	      name: name,
	      value: val,
	      payload: entry,
	      dataKey: dataKey,
	      type: tooltipType
	    }];
	    var tooltipPosition = {
	      x: x + upperWidth / 2,
	      y: y + rowHeight / 2
	    };
	    return _objectSpread({
	      x: x,
	      y: y,
	      width: Math.max(upperWidth, lowerWidth),
	      upperWidth: upperWidth,
	      lowerWidth: lowerWidth,
	      height: rowHeight,
	      name: name,
	      val: val,
	      tooltipPayload: tooltipPayload,
	      tooltipPosition: tooltipPosition
	    }, (0, _omit2["default"])(entry, 'width'), {
	      payload: entry
	    });
	  });
	  return {
	    trapezoids: trapezoids,
	    data: funnelData,
	    onMouseLeave: onItemMouseLeave,
	    onMouseEnter: onItemMouseEnter
	  };
	};
	
	var _default = Funnel;
	exports["default"] = _default;

/***/ },
/* 989 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isEqual2 = _interopRequireDefault(__webpack_require__(98));
	
	var _get2 = _interopRequireDefault(__webpack_require__(180));
	
	var _isPlainObject2 = _interopRequireDefault(__webpack_require__(225));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(38));
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(71));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _reactSmooth = _interopRequireDefault(__webpack_require__(81));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _Layer = _interopRequireDefault(__webpack_require__(49));
	
	var _Sector = _interopRequireDefault(__webpack_require__(311));
	
	var _Curve = _interopRequireDefault(__webpack_require__(189));
	
	var _Text = _interopRequireDefault(__webpack_require__(152));
	
	var _Label = _interopRequireDefault(__webpack_require__(127));
	
	var _LabelList = _interopRequireDefault(__webpack_require__(113));
	
	var _Cell = _interopRequireDefault(__webpack_require__(188));
	
	var _ReactUtils = __webpack_require__(29);
	
	var _PolarUtils = __webpack_require__(86);
	
	var _DataUtils = __webpack_require__(39);
	
	var _ChartUtils = __webpack_require__(66);
	
	var _LogUtils = __webpack_require__(191);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var Pie =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Pie, _PureComponent);
	
	  function Pie() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Pie);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Pie)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      isAnimationFinished: false
	    };
	    _this.id = (0, _DataUtils.uniqueId)('recharts-pie-');
	
	    _this.cachePrevData = function (sectors) {
	      _this.setState({
	        prevSectors: sectors
	      });
	    };
	
	    _this.handleAnimationEnd = function () {
	      var onAnimationEnd = _this.props.onAnimationEnd;
	
	      _this.setState({
	        isAnimationFinished: true
	      });
	
	      if ((0, _isFunction2["default"])(onAnimationEnd)) {
	        onAnimationEnd();
	      }
	    };
	
	    _this.handleAnimationStart = function () {
	      var onAnimationStart = _this.props.onAnimationStart;
	
	      _this.setState({
	        isAnimationFinished: false
	      });
	
	      if ((0, _isFunction2["default"])(onAnimationStart)) {
	        onAnimationStart();
	      }
	    };
	
	    return _this;
	  }
	
	  _createClass(Pie, [{
	    key: "componentWillReceiveProps",
	    // eslint-disable-next-line camelcase
	    value: function componentWillReceiveProps(nextProps) {
	      var _this$props = this.props,
	          animationId = _this$props.animationId,
	          sectors = _this$props.sectors;
	
	      if (nextProps.isAnimationActive !== this.props.isAnimationActive) {
	        this.cachePrevData([]);
	      } else if (nextProps.animationId !== animationId) {
	        this.cachePrevData(sectors);
	      }
	    }
	  }, {
	    key: "isActiveIndex",
	    value: function isActiveIndex(i) {
	      var activeIndex = this.props.activeIndex;
	
	      if (Array.isArray(activeIndex)) {
	        return activeIndex.indexOf(i) !== -1;
	      }
	
	      return i === activeIndex;
	    }
	  }, {
	    key: "renderLabels",
	    value: function renderLabels(sectors) {
	      var _this2 = this;
	
	      var isAnimationActive = this.props.isAnimationActive;
	
	      if (isAnimationActive && !this.state.isAnimationFinished) {
	        return null;
	      }
	
	      var _this$props2 = this.props,
	          label = _this$props2.label,
	          labelLine = _this$props2.labelLine,
	          dataKey = _this$props2.dataKey,
	          valueKey = _this$props2.valueKey;
	      var pieProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customLabelProps = (0, _ReactUtils.getPresentationAttributes)(label);
	      var customLabelLineProps = (0, _ReactUtils.getPresentationAttributes)(labelLine);
	      var offsetRadius = label && label.offsetRadius || 20;
	      var labels = sectors.map(function (entry, i) {
	        var midAngle = (entry.startAngle + entry.endAngle) / 2;
	        var endPoint = (0, _PolarUtils.polarToCartesian)(entry.cx, entry.cy, entry.outerRadius + offsetRadius, midAngle);
	
	        var labelProps = _objectSpread({}, pieProps, {}, entry, {
	          stroke: 'none'
	        }, customLabelProps, {
	          index: i,
	          textAnchor: _this2.constructor.getTextAnchor(endPoint.x, entry.cx)
	        }, endPoint);
	
	        var lineProps = _objectSpread({}, pieProps, {}, entry, {
	          fill: 'none',
	          stroke: entry.fill
	        }, customLabelLineProps, {
	          index: i,
	          points: [(0, _PolarUtils.polarToCartesian)(entry.cx, entry.cy, entry.outerRadius, midAngle), endPoint],
	          key: 'line'
	        });
	
	        var realDataKey = dataKey; // TODO: compatible to lower versions
	
	        if ((0, _isNil2["default"])(dataKey) && (0, _isNil2["default"])(valueKey)) {
	          realDataKey = 'value';
	        } else if ((0, _isNil2["default"])(dataKey)) {
	          realDataKey = valueKey;
	        }
	
	        return (// eslint-disable-next-line react/no-array-index-key
	          _react["default"].createElement(_Layer["default"], {
	            key: "label-".concat(i)
	          }, labelLine && _this2.constructor.renderLabelLineItem(labelLine, lineProps), _this2.constructor.renderLabelItem(label, labelProps, (0, _ChartUtils.getValueByDataKey)(entry, realDataKey)))
	        );
	      });
	      return _react["default"].createElement(_Layer["default"], {
	        className: "recharts-pie-labels"
	      }, labels);
	    }
	  }, {
	    key: "renderSectorsStatically",
	    value: function renderSectorsStatically(sectors) {
	      var _this3 = this;
	
	      var _this$props3 = this.props,
	          activeShape = _this$props3.activeShape,
	          blendStroke = _this$props3.blendStroke;
	      return sectors.map(function (entry, i) {
	        var sectorOptions = _this3.isActiveIndex(i) ? activeShape : null;
	
	        var sectorProps = _objectSpread({}, entry, {
	          stroke: blendStroke ? entry.fill : entry.stroke
	        });
	
	        return _react["default"].createElement(_Layer["default"], _extends({
	          className: "recharts-pie-sector"
	        }, (0, _ReactUtils.filterEventsOfChild)(_this3.props, entry, i), {
	          key: "sector-".concat(i) // eslint-disable-line react/no-array-index-key
	
	        }), _this3.constructor.renderSectorItem(sectorOptions, sectorProps));
	      });
	    }
	  }, {
	    key: "renderSectorsWithAnimation",
	    value: function renderSectorsWithAnimation() {
	      var _this4 = this;
	
	      var _this$props4 = this.props,
	          sectors = _this$props4.sectors,
	          isAnimationActive = _this$props4.isAnimationActive,
	          animationBegin = _this$props4.animationBegin,
	          animationDuration = _this$props4.animationDuration,
	          animationEasing = _this$props4.animationEasing,
	          animationId = _this$props4.animationId;
	      var prevSectors = this.state.prevSectors;
	      return _react["default"].createElement(_reactSmooth["default"], {
	        begin: animationBegin,
	        duration: animationDuration,
	        isActive: isAnimationActive,
	        easing: animationEasing,
	        from: {
	          t: 0
	        },
	        to: {
	          t: 1
	        },
	        key: "pie-".concat(animationId),
	        onAnimationStart: this.handleAnimationStart,
	        onAnimationEnd: this.handleAnimationEnd
	      }, function (_ref) {
	        var t = _ref.t;
	        var stepData = [];
	        var first = sectors && sectors[0];
	        var curAngle = first.startAngle;
	        sectors.forEach(function (entry, index) {
	          var prev = prevSectors && prevSectors[index];
	          var paddingAngle = index > 0 ? (0, _get2["default"])(entry, 'paddingAngle', 0) : 0;
	
	          if (prev) {
	            var angleIp = (0, _DataUtils.interpolateNumber)(prev.endAngle - prev.startAngle, entry.endAngle - entry.startAngle);
	
	            var latest = _objectSpread({}, entry, {
	              startAngle: curAngle + paddingAngle,
	              endAngle: curAngle + angleIp(t) + paddingAngle
	            });
	
	            stepData.push(latest);
	            curAngle = latest.endAngle;
	          } else {
	            var endAngle = entry.endAngle,
	                startAngle = entry.startAngle;
	            var interpolatorAngle = (0, _DataUtils.interpolateNumber)(0, endAngle - startAngle);
	            var deltaAngle = interpolatorAngle(t);
	
	            var _latest = _objectSpread({}, entry, {
	              startAngle: curAngle + paddingAngle,
	              endAngle: curAngle + deltaAngle + paddingAngle
	            });
	
	            stepData.push(_latest);
	            curAngle = _latest.endAngle;
	          }
	        });
	        return _react["default"].createElement(_Layer["default"], null, _this4.renderSectorsStatically(stepData));
	      });
	    }
	  }, {
	    key: "renderSectors",
	    value: function renderSectors() {
	      var _this$props5 = this.props,
	          sectors = _this$props5.sectors,
	          isAnimationActive = _this$props5.isAnimationActive;
	      var prevSectors = this.state.prevSectors;
	
	      if (isAnimationActive && sectors && sectors.length && (!prevSectors || !(0, _isEqual2["default"])(prevSectors, sectors))) {
	        return this.renderSectorsWithAnimation();
	      }
	
	      return this.renderSectorsStatically(sectors);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props6 = this.props,
	          hide = _this$props6.hide,
	          sectors = _this$props6.sectors,
	          className = _this$props6.className,
	          label = _this$props6.label,
	          cx = _this$props6.cx,
	          cy = _this$props6.cy,
	          innerRadius = _this$props6.innerRadius,
	          outerRadius = _this$props6.outerRadius,
	          isAnimationActive = _this$props6.isAnimationActive,
	          prevSectors = _this$props6.prevSectors;
	
	      if (hide || !sectors || !sectors.length || !(0, _DataUtils.isNumber)(cx) || !(0, _DataUtils.isNumber)(cy) || !(0, _DataUtils.isNumber)(innerRadius) || !(0, _DataUtils.isNumber)(outerRadius)) {
	        return null;
	      }
	
	      var layerClass = (0, _classnames["default"])('recharts-pie', className);
	      return _react["default"].createElement(_Layer["default"], {
	        className: layerClass
	      }, this.renderSectors(), label && this.renderLabels(sectors), _Label["default"].renderCallByParent(this.props, null, false), (!isAnimationActive || prevSectors && (0, _isEqual2["default"])(prevSectors, sectors)) && _LabelList["default"].renderCallByParent(this.props, sectors, false));
	    }
	  }], [{
	    key: "getTextAnchor",
	    value: function getTextAnchor(x, cx) {
	      if (x > cx) {
	        return 'start';
	      }
	
	      if (x < cx) {
	        return 'end';
	      }
	
	      return 'middle';
	    }
	  }, {
	    key: "renderLabelLineItem",
	    value: function renderLabelLineItem(option, props) {
	      if (_react["default"].isValidElement(option)) {
	        return _react["default"].cloneElement(option, props);
	      }
	
	      if ((0, _isFunction2["default"])(option)) {
	        return option(props);
	      }
	
	      return _react["default"].createElement(_Curve["default"], _extends({}, props, {
	        type: "linear",
	        className: "recharts-pie-label-line"
	      }));
	    }
	  }, {
	    key: "renderLabelItem",
	    value: function renderLabelItem(option, props, value) {
	      if (_react["default"].isValidElement(option)) {
	        return _react["default"].cloneElement(option, props);
	      }
	
	      var label = value;
	
	      if ((0, _isFunction2["default"])(option)) {
	        label = option(props);
	
	        if (_react["default"].isValidElement(label)) {
	          return label;
	        }
	      }
	
	      return _react["default"].createElement(_Text["default"], _extends({}, props, {
	        alignmentBaseline: "middle",
	        className: "recharts-pie-label-text"
	      }), label);
	    }
	  }, {
	    key: "renderSectorItem",
	    value: function renderSectorItem(option, props) {
	      if (_react["default"].isValidElement(option)) {
	        return _react["default"].cloneElement(option, props);
	      }
	
	      if ((0, _isFunction2["default"])(option)) {
	        return option(props);
	      }
	
	      if ((0, _isPlainObject2["default"])(option)) {
	        return _react["default"].createElement(_Sector["default"], _extends({}, props, option));
	      }
	
	      return _react["default"].createElement(_Sector["default"], props);
	    }
	  }]);
	
	  return Pie;
	}(_react.PureComponent);
	
	Pie.displayName = 'Pie';
	Pie.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {}, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _propTypes["default"].string,
	  animationId: _propTypes["default"].number,
	  cx: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  cy: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  startAngle: _propTypes["default"].number,
	  endAngle: _propTypes["default"].number,
	  paddingAngle: _propTypes["default"].number,
	  innerRadius: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  outerRadius: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  cornerRadius: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  dataKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func]).isRequired,
	  nameKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func]),
	  valueKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func]),
	  data: _propTypes["default"].arrayOf(_propTypes["default"].object),
	  blendStroke: _propTypes["default"].bool,
	  minAngle: _propTypes["default"].number,
	  legendType: _propTypes["default"].oneOf(_ReactUtils.LEGEND_TYPES),
	  tooltipType: _propTypes["default"].oneOf(_ReactUtils.TOOLTIP_TYPES),
	  maxRadius: _propTypes["default"].number,
	  sectors: _propTypes["default"].arrayOf(_propTypes["default"].object),
	  hide: _propTypes["default"].bool,
	  labelLine: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].func, _propTypes["default"].element, _propTypes["default"].bool]),
	  label: _propTypes["default"].oneOfType([_propTypes["default"].shape({
	    offsetRadius: _propTypes["default"].number
	  }), _propTypes["default"].func, _propTypes["default"].element, _propTypes["default"].bool]),
	  activeShape: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].func, _propTypes["default"].element]),
	  activeIndex: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].arrayOf(_propTypes["default"].number)]),
	  onAnimationStart: _propTypes["default"].func,
	  onAnimationEnd: _propTypes["default"].func,
	  isAnimationActive: _propTypes["default"].bool,
	  animationBegin: _propTypes["default"].number,
	  animationDuration: _propTypes["default"].number,
	  animationEasing: _propTypes["default"].oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'spring', 'linear']),
	  id: _propTypes["default"].string
	});
	Pie.defaultProps = {
	  stroke: '#fff',
	  fill: '#808080',
	  legendType: 'rect',
	  // The abscissa of pole
	  cx: '50%',
	  // The ordinate of pole
	  cy: '50%',
	  // The start angle of first sector
	  startAngle: 0,
	  // The direction of drawing sectors
	  endAngle: 360,
	  // The inner radius of sectors
	  innerRadius: 0,
	  // The outer radius of sectors
	  outerRadius: '80%',
	  paddingAngle: 0,
	  labelLine: true,
	  hide: false,
	  minAngle: 0,
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 400,
	  animationDuration: 1500,
	  animationEasing: 'ease',
	  nameKey: 'name',
	  // Match each sector's stroke color to it's fill color
	  blendStroke: false
	};
	
	Pie.parseDeltaAngle = function (_ref2) {
	  var startAngle = _ref2.startAngle,
	      endAngle = _ref2.endAngle;
	  var sign = (0, _DataUtils.mathSign)(endAngle - startAngle);
	  var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
	  return sign * deltaAngle;
	};
	
	Pie.getRealPieData = function (item) {
	  var _item$props = item.props,
	      data = _item$props.data,
	      children = _item$props.children;
	  var presentationProps = (0, _ReactUtils.getPresentationAttributes)(item.props);
	  var cells = (0, _ReactUtils.findAllByType)(children, _Cell["default"]);
	
	  if (data && data.length) {
	    return data.map(function (entry, index) {
	      return _objectSpread({
	        payload: entry
	      }, presentationProps, {}, entry, {}, cells && cells[index] && cells[index].props);
	    });
	  }
	
	  if (cells && cells.length) {
	    return cells.map(function (cell) {
	      return _objectSpread({}, presentationProps, {}, cell.props);
	    });
	  }
	
	  return [];
	};
	
	Pie.parseCoordinateOfPie = function (item, offset) {
	  var top = offset.top,
	      left = offset.left,
	      width = offset.width,
	      height = offset.height;
	  var maxPieRadius = (0, _PolarUtils.getMaxRadius)(width, height);
	  var cx = left + (0, _DataUtils.getPercentValue)(item.props.cx, width, width / 2);
	  var cy = top + (0, _DataUtils.getPercentValue)(item.props.cy, height, height / 2);
	  var innerRadius = (0, _DataUtils.getPercentValue)(item.props.innerRadius, maxPieRadius, 0);
	  var outerRadius = (0, _DataUtils.getPercentValue)(item.props.outerRadius, maxPieRadius, maxPieRadius * 0.8);
	  var maxRadius = item.props.maxRadius || Math.sqrt(width * width + height * height) / 2;
	  return {
	    cx: cx,
	    cy: cy,
	    innerRadius: innerRadius,
	    outerRadius: outerRadius,
	    maxRadius: maxRadius
	  };
	};
	
	Pie.getComposedData = function (_ref3) {
	  var item = _ref3.item,
	      offset = _ref3.offset,
	      onItemMouseLeave = _ref3.onItemMouseLeave,
	      onItemMouseEnter = _ref3.onItemMouseEnter;
	  var pieData = Pie.getRealPieData(item);
	
	  if (!pieData || !pieData.length) {
	    return [];
	  }
	
	  var _item$props2 = item.props,
	      cornerRadius = _item$props2.cornerRadius,
	      startAngle = _item$props2.startAngle,
	      endAngle = _item$props2.endAngle,
	      paddingAngle = _item$props2.paddingAngle,
	      dataKey = _item$props2.dataKey,
	      nameKey = _item$props2.nameKey,
	      valueKey = _item$props2.valueKey,
	      tooltipType = _item$props2.tooltipType;
	  var minAngle = Math.abs(item.props.minAngle);
	  var coordinate = Pie.parseCoordinateOfPie(item, offset);
	  var len = pieData.length;
	  var deltaAngle = Pie.parseDeltaAngle({
	    startAngle: startAngle,
	    endAngle: endAngle
	  });
	  var absDeltaAngle = Math.abs(deltaAngle);
	  var totalPadingAngle = (absDeltaAngle >= 360 ? len : len - 1) * paddingAngle;
	  var realTotalAngle = absDeltaAngle - len * minAngle - totalPadingAngle;
	  var realDataKey = dataKey;
	
	  if ((0, _isNil2["default"])(dataKey) && (0, _isNil2["default"])(valueKey)) {
	    (0, _LogUtils.warn)(false, "Use \"dataKey\" to specify the value of pie,\n      the props \"valueKey\" will be deprecated in 1.1.0");
	    realDataKey = 'value';
	  } else if ((0, _isNil2["default"])(dataKey)) {
	    (0, _LogUtils.warn)(false, "Use \"dataKey\" to specify the value of pie,\n      the props \"valueKey\" will be deprecated in 1.1.0");
	    realDataKey = valueKey;
	  }
	
	  var sum = pieData.reduce(function (result, entry) {
	    var val = (0, _ChartUtils.getValueByDataKey)(entry, realDataKey, 0);
	    return result + ((0, _DataUtils.isNumber)(val) ? val : 0);
	  }, 0);
	  var sectors;
	
	  if (sum > 0) {
	    var prev;
	    sectors = pieData.map(function (entry, i) {
	      var val = (0, _ChartUtils.getValueByDataKey)(entry, realDataKey, 0);
	      var name = (0, _ChartUtils.getValueByDataKey)(entry, nameKey, i);
	      var percent = ((0, _DataUtils.isNumber)(val) ? val : 0) / sum;
	      var tempStartAngle;
	
	      if (i) {
	        tempStartAngle = prev.endAngle + (0, _DataUtils.mathSign)(deltaAngle) * paddingAngle;
	      } else {
	        tempStartAngle = startAngle;
	      }
	
	      var tempEndAngle = tempStartAngle + (0, _DataUtils.mathSign)(deltaAngle) * (minAngle + percent * realTotalAngle);
	      var midAngle = (tempStartAngle + tempEndAngle) / 2;
	      var middleRadius = (coordinate.innerRadius + coordinate.outerRadius) / 2;
	      var tooltipPayload = [{
	        name: name,
	        value: val,
	        payload: entry,
	        dataKey: realDataKey,
	        type: tooltipType
	      }];
	      var tooltipPosition = (0, _PolarUtils.polarToCartesian)(coordinate.cx, coordinate.cy, middleRadius, midAngle);
	      prev = _objectSpread({
	        percent: percent,
	        cornerRadius: cornerRadius,
	        name: name,
	        tooltipPayload: tooltipPayload,
	        midAngle: midAngle,
	        middleRadius: middleRadius,
	        tooltipPosition: tooltipPosition
	      }, entry, {}, coordinate, {
	        value: (0, _ChartUtils.getValueByDataKey)(entry, realDataKey),
	        startAngle: tempStartAngle,
	        endAngle: tempEndAngle,
	        payload: entry,
	        paddingAngle: (0, _DataUtils.mathSign)(deltaAngle) * paddingAngle
	      });
	      return prev;
	    });
	  }
	
	  return _objectSpread({}, coordinate, {
	    sectors: sectors,
	    data: pieData,
	    onMouseLeave: onItemMouseLeave,
	    onMouseEnter: onItemMouseEnter
	  });
	};
	
	var _default = Pie;
	exports["default"] = _default;

/***/ },
/* 990 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isEqual2 = _interopRequireDefault(__webpack_require__(98));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(38));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _reactSmooth = _interopRequireDefault(__webpack_require__(81));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _DataUtils = __webpack_require__(39);
	
	var _ReactUtils = __webpack_require__(29);
	
	var _PolarUtils = __webpack_require__(86);
	
	var _ChartUtils = __webpack_require__(66);
	
	var _Polygon = _interopRequireDefault(__webpack_require__(310));
	
	var _Dot = _interopRequireDefault(__webpack_require__(153));
	
	var _Layer = _interopRequireDefault(__webpack_require__(49));
	
	var _LabelList = _interopRequireDefault(__webpack_require__(113));
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var Radar =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Radar, _PureComponent);
	
	  function Radar() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Radar);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Radar)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      isAnimationFinished: false
	    };
	
	    _this.cachePrevData = function (points) {
	      _this.setState({
	        prevPoints: points
	      });
	    };
	
	    _this.handleAnimationEnd = function () {
	      var onAnimationEnd = _this.props.onAnimationEnd;
	
	      _this.setState({
	        isAnimationFinished: true
	      });
	
	      if ((0, _isFunction2["default"])(onAnimationEnd)) {
	        onAnimationEnd();
	      }
	    };
	
	    _this.handleAnimationStart = function () {
	      var onAnimationStart = _this.props.onAnimationStart;
	
	      _this.setState({
	        isAnimationFinished: false
	      });
	
	      if ((0, _isFunction2["default"])(onAnimationStart)) {
	        onAnimationStart();
	      }
	    };
	
	    _this.handleMouseEnter = function (e) {
	      var onMouseEnter = _this.props.onMouseEnter;
	
	      if (onMouseEnter) {
	        onMouseEnter(_this.props, e);
	      }
	    };
	
	    _this.handleMouseLeave = function (e) {
	      var onMouseLeave = _this.props.onMouseLeave;
	
	      if (onMouseLeave) {
	        onMouseLeave(_this.props, e);
	      }
	    };
	
	    return _this;
	  }
	
	  _createClass(Radar, [{
	    key: "componentWillReceiveProps",
	    // eslint-disable-next-line camelcase
	    value: function componentWillReceiveProps(nextProps) {
	      var _this$props = this.props,
	          animationId = _this$props.animationId,
	          points = _this$props.points;
	
	      if (nextProps.animationId !== animationId) {
	        this.cachePrevData(points);
	      }
	    }
	  }, {
	    key: "renderDots",
	    value: function renderDots(points) {
	      var _this2 = this;
	
	      var _this$props2 = this.props,
	          dot = _this$props2.dot,
	          dataKey = _this$props2.dataKey;
	      var baseProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customDotProps = (0, _ReactUtils.getPresentationAttributes)(dot);
	      var dots = points.map(function (entry, i) {
	        var dotProps = _objectSpread({
	          key: "dot-".concat(i),
	          r: 3
	        }, baseProps, {}, customDotProps, {
	          dataKey: dataKey,
	          cx: entry.x,
	          cy: entry.y,
	          index: i,
	          payload: entry
	        });
	
	        return _this2.constructor.renderDotItem(dot, dotProps);
	      });
	      return _react["default"].createElement(_Layer["default"], {
	        className: "recharts-radar-dots"
	      }, dots);
	    }
	  }, {
	    key: "renderPolygonStatically",
	    value: function renderPolygonStatically(points) {
	      var _this$props3 = this.props,
	          shape = _this$props3.shape,
	          dot = _this$props3.dot;
	      var radar;
	
	      if (_react["default"].isValidElement(shape)) {
	        radar = _react["default"].cloneElement(shape, _objectSpread({}, this.props, {
	          points: points
	        }));
	      } else if ((0, _isFunction2["default"])(shape)) {
	        radar = shape(_objectSpread({}, this.props, {
	          points: points
	        }));
	      } else {
	        radar = _react["default"].createElement(_Polygon["default"], _extends({}, (0, _ReactUtils.filterEventAttributes)(this.props), {
	          onMouseEnter: this.handleMouseEnter,
	          onMouseLeave: this.handleMouseLeave
	        }, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	          points: points
	        }));
	      }
	
	      return _react["default"].createElement(_Layer["default"], {
	        className: "recharts-radar-polygon"
	      }, radar, dot ? this.renderDots(points) : null);
	    }
	  }, {
	    key: "renderPolygonWithAnimation",
	    value: function renderPolygonWithAnimation() {
	      var _this3 = this;
	
	      var _this$props4 = this.props,
	          points = _this$props4.points,
	          isAnimationActive = _this$props4.isAnimationActive,
	          animationBegin = _this$props4.animationBegin,
	          animationDuration = _this$props4.animationDuration,
	          animationEasing = _this$props4.animationEasing,
	          animationId = _this$props4.animationId;
	      var prevPoints = this.state.prevPoints;
	      return _react["default"].createElement(_reactSmooth["default"], {
	        begin: animationBegin,
	        duration: animationDuration,
	        isActive: isAnimationActive,
	        easing: animationEasing,
	        from: {
	          t: 0
	        },
	        to: {
	          t: 1
	        },
	        key: "radar-".concat(animationId),
	        onAnimationEnd: this.handleAnimationEnd,
	        onAnimationStart: this.handleAnimationStart
	      }, function (_ref) {
	        var t = _ref.t;
	        var prevPointsDiffFactor = prevPoints && prevPoints.length / points.length;
	        var stepData = points.map(function (entry, index) {
	          var prev = prevPoints && prevPoints[Math.floor(index * prevPointsDiffFactor)];
	
	          if (prev) {
	            var _interpolatorX = (0, _DataUtils.interpolateNumber)(prev.x, entry.x);
	
	            var _interpolatorY = (0, _DataUtils.interpolateNumber)(prev.y, entry.y);
	
	            return _objectSpread({}, entry, {
	              x: _interpolatorX(t),
	              y: _interpolatorY(t)
	            });
	          }
	
	          var interpolatorX = (0, _DataUtils.interpolateNumber)(entry.cx, entry.x);
	          var interpolatorY = (0, _DataUtils.interpolateNumber)(entry.cy, entry.y);
	          return _objectSpread({}, entry, {
	            x: interpolatorX(t),
	            y: interpolatorY(t)
	          });
	        });
	        return _this3.renderPolygonStatically(stepData);
	      });
	    }
	  }, {
	    key: "renderPolygon",
	    value: function renderPolygon() {
	      var _this$props5 = this.props,
	          points = _this$props5.points,
	          isAnimationActive = _this$props5.isAnimationActive;
	      var prevPoints = this.state.prevPoints;
	
	      if (isAnimationActive && points && points.length && (!prevPoints || !(0, _isEqual2["default"])(prevPoints, points))) {
	        return this.renderPolygonWithAnimation();
	      }
	
	      return this.renderPolygonStatically(points);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props6 = this.props,
	          hide = _this$props6.hide,
	          className = _this$props6.className,
	          points = _this$props6.points,
	          isAnimationActive = _this$props6.isAnimationActive;
	
	      if (hide || !points || !points.length) {
	        return null;
	      }
	
	      var isAnimationFinished = this.state.isAnimationFinished;
	      var layerClass = (0, _classnames["default"])('recharts-radar', className);
	      return _react["default"].createElement(_Layer["default"], {
	        className: layerClass
	      }, this.renderPolygon(), (!isAnimationActive || isAnimationFinished) && _LabelList["default"].renderCallByParent(this.props, points));
	    }
	  }], [{
	    key: "renderDotItem",
	    value: function renderDotItem(option, props) {
	      var dotItem;
	
	      if (_react["default"].isValidElement(option)) {
	        dotItem = _react["default"].cloneElement(option, props);
	      } else if ((0, _isFunction2["default"])(option)) {
	        dotItem = option(props);
	      } else {
	        dotItem = _react["default"].createElement(_Dot["default"], _extends({}, props, {
	          className: "recharts-radar-dot"
	        }));
	      }
	
	      return dotItem;
	    }
	  }]);
	
	  return Radar;
	}(_react.PureComponent);
	
	Radar.displayName = 'Radar';
	Radar.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  className: _propTypes["default"].string,
	  dataKey: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string, _propTypes["default"].func]).isRequired,
	  angleAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  radiusAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  points: _propTypes["default"].arrayOf(_propTypes["default"].shape({
	    x: _propTypes["default"].number,
	    y: _propTypes["default"].number,
	    cx: _propTypes["default"].number,
	    cy: _propTypes["default"].number,
	    angle: _propTypes["default"].number,
	    radius: _propTypes["default"].number,
	    value: _propTypes["default"].number,
	    payload: _propTypes["default"].object
	  })),
	  shape: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].func]),
	  activeDot: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].element, _propTypes["default"].func, _propTypes["default"].bool]),
	  // whether have dot in poly line
	  dot: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].element, _propTypes["default"].func, _propTypes["default"].bool]),
	  label: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].func, _propTypes["default"].object, _propTypes["default"].bool]),
	  legendType: _propTypes["default"].oneOf(_ReactUtils.LEGEND_TYPES),
	  tooltipType: _propTypes["default"].oneOf(_ReactUtils.TOOLTIP_TYPES),
	  hide: _propTypes["default"].bool,
	  onAnimationStart: _propTypes["default"].func,
	  onAnimationEnd: _propTypes["default"].func,
	  onMouseEnter: _propTypes["default"].func,
	  onMouseLeave: _propTypes["default"].func,
	  onClick: _propTypes["default"].func,
	  isAnimationActive: _propTypes["default"].bool,
	  animationId: _propTypes["default"].number,
	  animationBegin: _propTypes["default"].number,
	  animationDuration: _propTypes["default"].number,
	  animationEasing: _propTypes["default"].oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
	});
	Radar.defaultProps = {
	  angleAxisId: 0,
	  radiusAxisId: 0,
	  hide: false,
	  activeDot: true,
	  dot: false,
	  legendType: 'rect',
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'ease'
	};
	
	Radar.getComposedData = function (_ref2) {
	  var radiusAxis = _ref2.radiusAxis,
	      angleAxis = _ref2.angleAxis,
	      displayedData = _ref2.displayedData,
	      dataKey = _ref2.dataKey,
	      bandSize = _ref2.bandSize;
	  var cx = angleAxis.cx,
	      cy = angleAxis.cy;
	  var points = displayedData.map(function (entry, i) {
	    var name = (0, _ChartUtils.getValueByDataKey)(entry, angleAxis.dataKey, i);
	    var value = (0, _ChartUtils.getValueByDataKey)(entry, dataKey, 0);
	    var angle = angleAxis.scale(name) + (bandSize || 0);
	    var radius = radiusAxis.scale(value);
	    return _objectSpread({}, (0, _PolarUtils.polarToCartesian)(cx, cy, radius, angle), {
	      name: name,
	      value: value,
	      cx: cx,
	      cy: cy,
	      radius: radius,
	      angle: angle,
	      payload: entry
	    });
	  });
	  return {
	    points: points
	  };
	};
	
	var _default = Radar;
	exports["default"] = _default;

/***/ },
/* 991 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isEqual2 = _interopRequireDefault(__webpack_require__(98));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(38));
	
	var _isArray2 = _interopRequireDefault(__webpack_require__(43));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _reactSmooth = _interopRequireDefault(__webpack_require__(81));
	
	var _Sector = _interopRequireDefault(__webpack_require__(311));
	
	var _Layer = _interopRequireDefault(__webpack_require__(49));
	
	var _ReactUtils = __webpack_require__(29);
	
	var _LabelList = _interopRequireDefault(__webpack_require__(113));
	
	var _Cell = _interopRequireDefault(__webpack_require__(188));
	
	var _DataUtils = __webpack_require__(39);
	
	var _ChartUtils = __webpack_require__(66);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var RadialBar =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(RadialBar, _PureComponent);
	
	  function RadialBar() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, RadialBar);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(RadialBar)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      isAnimationFinished: false
	    };
	
	    _this.cachePrevData = function (data) {
	      _this.setState({
	        prevData: data
	      });
	    };
	
	    _this.handleAnimationEnd = function () {
	      var onAnimationEnd = _this.props.onAnimationEnd;
	
	      _this.setState({
	        isAnimationFinished: true
	      });
	
	      if ((0, _isFunction2["default"])(onAnimationEnd)) {
	        onAnimationEnd();
	      }
	    };
	
	    _this.handleAnimationStart = function () {
	      var onAnimationStart = _this.props.onAnimationStart;
	
	      _this.setState({
	        isAnimationFinished: false
	      });
	
	      if ((0, _isFunction2["default"])(onAnimationStart)) {
	        onAnimationStart();
	      }
	    };
	
	    return _this;
	  }
	
	  _createClass(RadialBar, [{
	    key: "componentWillReceiveProps",
	    // eslint-disable-next-line camelcase
	    value: function componentWillReceiveProps(nextProps) {
	      var _this$props = this.props,
	          animationId = _this$props.animationId,
	          data = _this$props.data;
	
	      if (nextProps.animationId !== animationId) {
	        this.cachePrevData(data);
	      }
	    }
	  }, {
	    key: "getDeltaAngle",
	    value: function getDeltaAngle() {
	      var _this$props2 = this.props,
	          startAngle = _this$props2.startAngle,
	          endAngle = _this$props2.endAngle;
	      var sign = (0, _DataUtils.mathSign)(endAngle - startAngle);
	      var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
	      return sign * deltaAngle;
	    }
	  }, {
	    key: "renderSectorsStatically",
	    value: function renderSectorsStatically(sectors) {
	      var _this2 = this;
	
	      var _this$props3 = this.props,
	          shape = _this$props3.shape,
	          activeShape = _this$props3.activeShape,
	          activeIndex = _this$props3.activeIndex,
	          cornerRadius = _this$props3.cornerRadius,
	          others = _objectWithoutProperties(_this$props3, ["shape", "activeShape", "activeIndex", "cornerRadius"]);
	
	      var baseProps = (0, _ReactUtils.getPresentationAttributes)(others);
	      return sectors.map(function (entry, i) {
	        var props = _objectSpread({}, baseProps, {
	          cornerRadius: cornerRadius
	        }, entry, {}, (0, _ReactUtils.filterEventsOfChild)(_this2.props, entry, i), {
	          key: "sector-".concat(i),
	          className: 'recharts-radial-bar-sector',
	          forceCornerRadius: others.forceCornerRadius,
	          cornerIsExternal: others.cornerIsExternal
	        });
	
	        return _this2.constructor.renderSectorShape(i === activeIndex ? activeShape : shape, props);
	      });
	    }
	  }, {
	    key: "renderSectorsWithAnimation",
	    value: function renderSectorsWithAnimation() {
	      var _this3 = this;
	
	      var _this$props4 = this.props,
	          data = _this$props4.data,
	          isAnimationActive = _this$props4.isAnimationActive,
	          animationBegin = _this$props4.animationBegin,
	          animationDuration = _this$props4.animationDuration,
	          animationEasing = _this$props4.animationEasing,
	          animationId = _this$props4.animationId;
	      var prevData = this.state.prevData;
	      return _react["default"].createElement(_reactSmooth["default"], {
	        begin: animationBegin,
	        duration: animationDuration,
	        isActive: isAnimationActive,
	        easing: animationEasing,
	        from: {
	          t: 0
	        },
	        to: {
	          t: 1
	        },
	        key: "radialBar-".concat(animationId),
	        onAnimationStart: this.handleAnimationStart,
	        onAnimationEnd: this.handleAnimationEnd
	      }, function (_ref) {
	        var t = _ref.t;
	        var stepData = data.map(function (entry, index) {
	          var prev = prevData && prevData[index];
	
	          if (prev) {
	            var interpolatorStartAngle = (0, _DataUtils.interpolateNumber)(prev.startAngle, entry.startAngle);
	            var interpolatorEndAngle = (0, _DataUtils.interpolateNumber)(prev.endAngle, entry.endAngle);
	            return _objectSpread({}, entry, {
	              startAngle: interpolatorStartAngle(t),
	              endAngle: interpolatorEndAngle(t)
	            });
	          }
	
	          var endAngle = entry.endAngle,
	              startAngle = entry.startAngle;
	          var interpolator = (0, _DataUtils.interpolateNumber)(startAngle, endAngle);
	          return _objectSpread({}, entry, {
	            endAngle: interpolator(t)
	          });
	        });
	        return _react["default"].createElement(_Layer["default"], null, _this3.renderSectorsStatically(stepData));
	      });
	    }
	  }, {
	    key: "renderSectors",
	    value: function renderSectors() {
	      var _this$props5 = this.props,
	          data = _this$props5.data,
	          isAnimationActive = _this$props5.isAnimationActive;
	      var prevData = this.state.prevData;
	
	      if (isAnimationActive && data && data.length && (!prevData || !(0, _isEqual2["default"])(prevData, data))) {
	        return this.renderSectorsWithAnimation();
	      }
	
	      return this.renderSectorsStatically(data);
	    }
	  }, {
	    key: "renderBackground",
	    value: function renderBackground(sectors) {
	      var _this4 = this;
	
	      var cornerRadius = this.props.cornerRadius;
	      var backgroundProps = (0, _ReactUtils.getPresentationAttributes)(this.props.background);
	      return sectors.map(function (entry, i) {
	        // eslint-disable-next-line no-unused-vars
	        var value = entry.value,
	            background = entry.background,
	            rest = _objectWithoutProperties(entry, ["value", "background"]);
	
	        if (!background) {
	          return null;
	        }
	
	        var props = _objectSpread({
	          cornerRadius: cornerRadius
	        }, rest, {
	          fill: '#eee'
	        }, background, {}, backgroundProps, {}, (0, _ReactUtils.filterEventsOfChild)(_this4.props, entry, i), {
	          index: i,
	          key: "sector-".concat(i),
	          className: 'recharts-radial-bar-background-sector'
	        });
	
	        return _this4.constructor.renderSectorShape(background, props);
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props6 = this.props,
	          hide = _this$props6.hide,
	          data = _this$props6.data,
	          className = _this$props6.className,
	          background = _this$props6.background,
	          isAnimationActive = _this$props6.isAnimationActive;
	
	      if (hide || !data || !data.length) {
	        return null;
	      }
	
	      var isAnimationFinished = this.state.isAnimationFinished;
	      var layerClass = (0, _classnames["default"])('recharts-area', className);
	      return _react["default"].createElement(_Layer["default"], {
	        className: layerClass
	      }, background && _react["default"].createElement(_Layer["default"], {
	        className: "recharts-radial-bar-background"
	      }, this.renderBackground(data)), _react["default"].createElement(_Layer["default"], {
	        className: "recharts-radial-bar-sectors"
	      }, this.renderSectors(data)), (!isAnimationActive || isAnimationFinished) && _LabelList["default"].renderCallByParent(_objectSpread({}, this.props, {
	        clockWise: this.getDeltaAngle() < 0
	      }), data));
	    }
	  }], [{
	    key: "renderSectorShape",
	    value: function renderSectorShape(shape, props) {
	      var sectorShape;
	
	      if (_react["default"].isValidElement(shape)) {
	        sectorShape = _react["default"].cloneElement(shape, props);
	      } else if ((0, _isFunction2["default"])(shape)) {
	        sectorShape = shape(props);
	      } else {
	        sectorShape = _react["default"].createElement(_Sector["default"], props);
	      }
	
	      return sectorShape;
	    }
	  }]);
	
	  return RadialBar;
	}(_react.PureComponent);
	
	RadialBar.displayName = 'RadialBar';
	RadialBar.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  className: _propTypes["default"].string,
	  angleAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  radiusAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  shape: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].element]),
	  activeShape: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].func, _propTypes["default"].element]),
	  activeIndex: _propTypes["default"].number,
	  dataKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func]).isRequired,
	  cornerRadius: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  forceCornerRadius: _propTypes["default"].bool,
	  cornerIsExternal: _propTypes["default"].bool,
	  minPointSize: _propTypes["default"].number,
	  maxBarSize: _propTypes["default"].number,
	  data: _propTypes["default"].arrayOf(_propTypes["default"].shape({
	    cx: _propTypes["default"].number,
	    cy: _propTypes["default"].number,
	    innerRadius: _propTypes["default"].number,
	    outerRadius: _propTypes["default"].number,
	    value: _propTypes["default"].value
	  })),
	  legendType: _propTypes["default"].oneOf(_ReactUtils.LEGEND_TYPES),
	  tooltipType: _propTypes["default"].oneOf(_ReactUtils.TOOLTIP_TYPES),
	  label: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].func, _propTypes["default"].element, _propTypes["default"].object]),
	  background: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].func, _propTypes["default"].object, _propTypes["default"].element]),
	  hide: _propTypes["default"].bool,
	  onAnimationStart: _propTypes["default"].func,
	  onAnimationEnd: _propTypes["default"].func,
	  onMouseEnter: _propTypes["default"].func,
	  onMouseLeave: _propTypes["default"].func,
	  onClick: _propTypes["default"].func,
	  isAnimationActive: _propTypes["default"].bool,
	  animationBegin: _propTypes["default"].number,
	  animationDuration: _propTypes["default"].number,
	  animationEasing: _propTypes["default"].oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear', 'spring'])
	});
	RadialBar.defaultProps = {
	  angleAxisId: 0,
	  radiusAxisId: 0,
	  minPointSize: 0,
	  hide: false,
	  legendType: 'rect',
	  data: [],
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'ease',
	  forceCornerRadius: false,
	  cornerIsExternal: false
	};
	
	RadialBar.getComposedData = function (_ref2) {
	  var item = _ref2.item,
	      props = _ref2.props,
	      radiusAxis = _ref2.radiusAxis,
	      radiusAxisTicks = _ref2.radiusAxisTicks,
	      angleAxis = _ref2.angleAxis,
	      angleAxisTicks = _ref2.angleAxisTicks,
	      displayedData = _ref2.displayedData,
	      dataKey = _ref2.dataKey,
	      stackedData = _ref2.stackedData,
	      barPosition = _ref2.barPosition,
	      bandSize = _ref2.bandSize,
	      dataStartIndex = _ref2.dataStartIndex;
	  var pos = (0, _ChartUtils.findPositionOfBar)(barPosition, item);
	
	  if (!pos) {
	    return [];
	  }
	
	  var cx = angleAxis.cx,
	      cy = angleAxis.cy;
	  var layout = props.layout;
	  var _item$props = item.props,
	      children = _item$props.children,
	      minPointSize = _item$props.minPointSize;
	  var numericAxis = layout === 'radial' ? angleAxis : radiusAxis;
	  var stackedDomain = stackedData ? numericAxis.scale.domain() : null;
	  var baseValue = (0, _ChartUtils.getBaseValueOfBar)({
	    props: props,
	    numericAxis: numericAxis
	  });
	  var cells = (0, _ReactUtils.findAllByType)(children, _Cell["default"]);
	  var sectors = displayedData.map(function (entry, index) {
	    var value, innerRadius, outerRadius, startAngle, endAngle, backgroundSector;
	
	    if (stackedData) {
	      value = (0, _ChartUtils.truncateByDomain)(stackedData[dataStartIndex + index], stackedDomain);
	    } else {
	      value = (0, _ChartUtils.getValueByDataKey)(entry, dataKey);
	
	      if (!(0, _isArray2["default"])(value)) {
	        value = [baseValue, value];
	      }
	    }
	
	    if (layout === 'radial') {
	      innerRadius = (0, _ChartUtils.getCateCoordinateOfBar)({
	        axis: radiusAxis,
	        ticks: radiusAxisTicks,
	        bandSize: bandSize,
	        offset: pos.offset,
	        entry: entry,
	        index: index
	      });
	      endAngle = angleAxis.scale(value[1]);
	      startAngle = angleAxis.scale(value[0]);
	      outerRadius = innerRadius + pos.size;
	      var deltaAngle = endAngle - startAngle;
	
	      if (Math.abs(minPointSize) > 0 && Math.abs(deltaAngle) < Math.abs(minPointSize)) {
	        var delta = (0, _DataUtils.mathSign)(deltaAngle || minPointSize) * (Math.abs(minPointSize) - Math.abs(deltaAngle));
	        endAngle += delta;
	      }
	
	      backgroundSector = {
	        background: {
	          cx: cx,
	          cy: cy,
	          innerRadius: innerRadius,
	          outerRadius: outerRadius,
	          startAngle: props.startAngle,
	          endAngle: props.endAngle
	        }
	      };
	    } else {
	      innerRadius = radiusAxis.scale(value[0]);
	      outerRadius = radiusAxis.scale(value[1]);
	      startAngle = (0, _ChartUtils.getCateCoordinateOfBar)({
	        axis: angleAxis,
	        ticks: angleAxisTicks,
	        bandSize: bandSize,
	        offset: pos.offset,
	        entry: entry,
	        index: index
	      });
	      endAngle = startAngle + pos.size;
	      var deltaRadius = outerRadius - innerRadius;
	
	      if (Math.abs(minPointSize) > 0 && Math.abs(deltaRadius) < Math.abs(minPointSize)) {
	        var _delta = (0, _DataUtils.mathSign)(deltaRadius || minPointSize) * (Math.abs(minPointSize) - Math.abs(deltaRadius));
	
	        outerRadius += _delta;
	      }
	    }
	
	    return _objectSpread({}, entry, {}, backgroundSector, {
	      payload: entry,
	      value: stackedData ? value : value[1],
	      cx: cx,
	      cy: cy,
	      innerRadius: innerRadius,
	      outerRadius: outerRadius,
	      startAngle: startAngle,
	      endAngle: endAngle
	    }, cells && cells[index] && cells[index].props);
	  });
	  return {
	    data: sectors,
	    layout: layout
	  };
	};
	
	var _default = RadialBar;
	exports["default"] = _default;

/***/ },
/* 992 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _DataUtils = __webpack_require__(39);
	
	var _ReactUtils = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var Cross =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Cross, _PureComponent);
	
	  function Cross() {
	    _classCallCheck(this, Cross);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(Cross).apply(this, arguments));
	  }
	
	  _createClass(Cross, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          x = _this$props.x,
	          y = _this$props.y,
	          width = _this$props.width,
	          height = _this$props.height,
	          top = _this$props.top,
	          left = _this$props.left,
	          className = _this$props.className;
	
	      if (!(0, _DataUtils.isNumber)(x) || !(0, _DataUtils.isNumber)(y) || !(0, _DataUtils.isNumber)(width) || !(0, _DataUtils.isNumber)(height) || !(0, _DataUtils.isNumber)(top) || !(0, _DataUtils.isNumber)(left)) {
	        return null;
	      }
	
	      return _react["default"].createElement("path", _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	        className: (0, _classnames["default"])('recharts-cross', className),
	        d: this.constructor.getPath(x, y, width, height, top, left)
	      }));
	    }
	  }], [{
	    key: "getPath",
	    value: function getPath(x, y, width, height, top, left) {
	      return "M".concat(x, ",").concat(top, "v").concat(height, "M").concat(left, ",").concat(y, "h").concat(width);
	    }
	  }]);
	
	  return Cross;
	}(_react.PureComponent);
	
	Cross.displayName = 'Cross';
	Cross.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  x: _propTypes["default"].number,
	  y: _propTypes["default"].number,
	  width: _propTypes["default"].number,
	  height: _propTypes["default"].number,
	  top: _propTypes["default"].number,
	  left: _propTypes["default"].number,
	  className: _propTypes["default"].string
	});
	Cross.defaultProps = {
	  x: 0,
	  y: 0,
	  top: 0,
	  left: 0,
	  width: 0,
	  height: 0
	};
	var _default = Cross;
	exports["default"] = _default;

/***/ },
/* 993 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _reactSmooth = _interopRequireDefault(__webpack_require__(81));
	
	var _ReactUtils = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var getTrapezoidPath = function getTrapezoidPath(x, y, upperWidth, lowerWidth, height) {
	  var widthGap = upperWidth - lowerWidth;
	  var path;
	  path = "M ".concat(x, ",").concat(y);
	  path += "L ".concat(x + upperWidth, ",").concat(y);
	  path += "L ".concat(x + upperWidth - widthGap / 2, ",").concat(y + height);
	  path += "L ".concat(x + upperWidth - widthGap / 2 - lowerWidth, ",").concat(y + height);
	  path += "L ".concat(x, ",").concat(y, " Z");
	  return path;
	};
	
	var Trapezoid =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Trapezoid, _PureComponent);
	
	  function Trapezoid() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Trapezoid);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Trapezoid)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      totalLength: -1
	    };
	    return _this;
	  }
	
	  _createClass(Trapezoid, [{
	    key: "componentDidMount",
	
	    /* eslint-disable  react/no-did-mount-set-state */
	    value: function componentDidMount() {
	      if (this.node && this.node.getTotalLength) {
	        try {
	          var totalLength = this.node.getTotalLength();
	
	          if (totalLength) {
	            this.setState({
	              totalLength: totalLength
	            });
	          }
	        } catch (err) {// calculate total length error
	        }
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _this$props = this.props,
	          x = _this$props.x,
	          y = _this$props.y,
	          upperWidth = _this$props.upperWidth,
	          lowerWidth = _this$props.lowerWidth,
	          height = _this$props.height,
	          className = _this$props.className;
	      var totalLength = this.state.totalLength;
	      var _this$props2 = this.props,
	          animationEasing = _this$props2.animationEasing,
	          animationDuration = _this$props2.animationDuration,
	          animationBegin = _this$props2.animationBegin,
	          isUpdateAnimationActive = _this$props2.isUpdateAnimationActive;
	
	      if (x !== +x || y !== +y || upperWidth !== +upperWidth || lowerWidth !== +lowerWidth || height !== +height || upperWidth === 0 && lowerWidth === 0 || height === 0) {
	        return null;
	      }
	
	      var layerClass = (0, _classnames["default"])('recharts-trapezoid', className);
	
	      if (!isUpdateAnimationActive) {
	        return _react["default"].createElement("g", null, _react["default"].createElement("path", _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), {
	          className: layerClass,
	          d: getTrapezoidPath(x, y, upperWidth, lowerWidth, height)
	        })));
	      }
	
	      return _react["default"].createElement(_reactSmooth["default"], {
	        canBegin: totalLength > 0,
	        from: {
	          upperWidth: 0,
	          lowerWidth: 0,
	          height: height,
	          x: x,
	          y: y
	        },
	        to: {
	          upperWidth: upperWidth,
	          lowerWidth: lowerWidth,
	          height: height,
	          x: x,
	          y: y
	        },
	        duration: animationDuration,
	        animationEasing: animationEasing,
	        isActive: isUpdateAnimationActive
	      }, function (_ref) {
	        var currUpperWidth = _ref.upperWidth,
	            currLowerWidth = _ref.lowerWidth,
	            currHeight = _ref.height,
	            currX = _ref.x,
	            currY = _ref.y;
	        return _react["default"].createElement(_reactSmooth["default"], {
	          canBegin: totalLength > 0,
	          from: "0px ".concat(totalLength === -1 ? 1 : totalLength, "px"),
	          to: "".concat(totalLength, "px 0px"),
	          attributeName: "strokeDasharray",
	          begin: animationBegin,
	          duration: animationDuration,
	          easing: animationEasing
	        }, _react["default"].createElement("path", _extends({}, (0, _ReactUtils.getPresentationAttributes)(_this2.props), (0, _ReactUtils.filterEventAttributes)(_this2.props), {
	          className: layerClass,
	          d: getTrapezoidPath(currX, currY, currUpperWidth, currLowerWidth, currHeight),
	          ref: function ref(node) {
	            _this2.node = node;
	          }
	        })));
	      });
	    }
	  }]);
	
	  return Trapezoid;
	}(_react.PureComponent);
	
	Trapezoid.displayName = 'Trapezoid';
	Trapezoid.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {}, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _propTypes["default"].string,
	  x: _propTypes["default"].number,
	  y: _propTypes["default"].number,
	  upperWidth: _propTypes["default"].number,
	  lowerWidth: _propTypes["default"].number,
	  height: _propTypes["default"].number,
	  isUpdateAnimationActive: _propTypes["default"].bool,
	  animationBegin: _propTypes["default"].number,
	  animationDuration: _propTypes["default"].number,
	  animationEasing: _propTypes["default"].oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
	});
	Trapezoid.defaultProps = {
	  x: 0,
	  y: 0,
	  upperWidth: 0,
	  lowerWidth: 0,
	  height: 0,
	  isUpdateAnimationActive: false,
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'ease'
	};
	var _default = Trapezoid;
	exports["default"] = _default;

/***/ },
/* 994 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = handleAction;
	
	var _invariant = __webpack_require__(124);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _isFunction = __webpack_require__(315);
	
	var _isFunction2 = _interopRequireDefault(_isFunction);
	
	var _isPlainObject = __webpack_require__(233);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _identity = __webpack_require__(480);
	
	var _identity2 = _interopRequireDefault(_identity);
	
	var _isNil = __webpack_require__(999);
	
	var _isNil2 = _interopRequireDefault(_isNil);
	
	var _isUndefined = __webpack_require__(2452);
	
	var _isUndefined2 = _interopRequireDefault(_isUndefined);
	
	var _toString = __webpack_require__(1001);
	
	var _toString2 = _interopRequireDefault(_toString);
	
	var _constants = __webpack_require__(232);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function handleAction(type) {
	  var reducer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _identity2.default;
	  var defaultState = arguments[2];
	
	  var types = (0, _toString2.default)(type).split(_constants.ACTION_TYPE_DELIMITER);
	  (0, _invariant2.default)(!(0, _isUndefined2.default)(defaultState), 'defaultState for reducer handling ' + types.join(', ') + ' should be defined');
	  (0, _invariant2.default)((0, _isFunction2.default)(reducer) || (0, _isPlainObject2.default)(reducer), 'Expected reducer to be a function or object with next and throw reducers');
	
	  var _ref = (0, _isFunction2.default)(reducer) ? [reducer, reducer] : [reducer.next, reducer.throw].map(function (aReducer) {
	    return (0, _isNil2.default)(aReducer) ? _identity2.default : aReducer;
	  }),
	      _ref2 = _slicedToArray(_ref, 2),
	      nextReducer = _ref2[0],
	      throwReducer = _ref2[1];
	
	  return function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
	    var action = arguments[1];
	    var actionType = action.type;
	
	    if (!actionType || types.indexOf((0, _toString2.default)(actionType)) === -1) {
	      return state;
	    }
	
	    return (action.error === true ? throwReducer : nextReducer)(state, action);
	  };
	}

/***/ },
/* 995 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.handleActions = exports.handleAction = exports.createCurriedAction = exports.createActions = exports.createAction = exports.combineActions = undefined;
	
	var _combineActions = __webpack_require__(2440);
	
	var _combineActions2 = _interopRequireDefault(_combineActions);
	
	var _createAction = __webpack_require__(479);
	
	var _createAction2 = _interopRequireDefault(_createAction);
	
	var _createActions = __webpack_require__(2441);
	
	var _createActions2 = _interopRequireDefault(_createActions);
	
	var _createCurriedAction = __webpack_require__(2442);
	
	var _createCurriedAction2 = _interopRequireDefault(_createCurriedAction);
	
	var _handleAction = __webpack_require__(994);
	
	var _handleAction2 = _interopRequireDefault(_handleAction);
	
	var _handleActions = __webpack_require__(2443);
	
	var _handleActions2 = _interopRequireDefault(_handleActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.combineActions = _combineActions2.default;
	exports.createAction = _createAction2.default;
	exports.createActions = _createActions2.default;
	exports.createCurriedAction = _createCurriedAction2.default;
	exports.handleAction = _handleAction2.default;
	exports.handleActions = _handleActions2.default;

/***/ },
/* 996 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(2052);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var namespacer = '/';
	
	exports.default = function (type) {
	  return type.indexOf(namespacer) === -1 ? (0, _lodash2.default)(type) : type.split(namespacer).map(function (part) {
	    return (0, _lodash2.default)(part);
	  }).join(namespacer);
	};

/***/ },
/* 997 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _constants = __webpack_require__(232);
	
	var _isMap = __webpack_require__(316);
	
	var _isMap2 = _interopRequireDefault(_isMap);
	
	var _ownKeys = __webpack_require__(481);
	
	var _ownKeys2 = _interopRequireDefault(_ownKeys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function get(key, x) {
	  return (0, _isMap2.default)(x) ? x.get(key) : x[key];
	}
	
	exports.default = function (predicate) {
	  return function flatten(map) {
	    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	        _ref$namespace = _ref.namespace,
	        namespace = _ref$namespace === undefined ? _constants.DEFAULT_NAMESPACE : _ref$namespace,
	        prefix = _ref.prefix;
	
	    var partialFlatMap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var partialFlatActionType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
	
	    function connectNamespace(type) {
	      var _ref2;
	
	      if (!partialFlatActionType) return type;
	      var types = type.toString().split(_constants.ACTION_TYPE_DELIMITER);
	      var partials = partialFlatActionType.split(_constants.ACTION_TYPE_DELIMITER);
	      return (_ref2 = []).concat.apply(_ref2, _toConsumableArray(partials.map(function (p) {
	        return types.map(function (t) {
	          return '' + p + namespace + t;
	        });
	      }))).join(_constants.ACTION_TYPE_DELIMITER);
	    }
	
	    function connectPrefix(type) {
	      if (partialFlatActionType || !prefix) {
	        return type;
	      }
	
	      return '' + prefix + namespace + type;
	    }
	
	    (0, _ownKeys2.default)(map).forEach(function (type) {
	      var nextNamespace = connectPrefix(connectNamespace(type));
	      var mapValue = get(type, map);
	
	      if (predicate(mapValue)) {
	        flatten(mapValue, { namespace: namespace, prefix: prefix }, partialFlatMap, nextNamespace);
	      } else {
	        partialFlatMap[nextNamespace] = mapValue;
	      }
	    });
	
	    return partialFlatMap;
	  };
	};

/***/ },
/* 998 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (value) {
	  return value.length === 0;
	};

/***/ },
/* 999 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (value) {
	  return value === null || value === undefined;
	};

/***/ },
/* 1000 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (value) {
	  return typeof value === 'string';
	};

/***/ },
/* 1001 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (value) {
	  return value.toString();
	};

/***/ },
/* 1002 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  var last = funcs[funcs.length - 1];
	  var rest = funcs.slice(0, -1);
	  return function () {
	    return rest.reduceRight(function (composed, f) {
	      return f(composed);
	    }, last.apply(undefined, arguments));
	  };
	}

/***/ },
/* 1003 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports['default'] = createStore;
	
	var _isPlainObject = __webpack_require__(225);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(2467);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	};
	
	/**
	 * Creates a Redux store that holds the state tree.
	 * The only way to change the data in the store is to call `dispatch()` on it.
	 *
	 * There should only be a single store in your app. To specify how different
	 * parts of the state tree respond to actions, you may combine several reducers
	 * into a single reducer function by using `combineReducers`.
	 *
	 * @param {Function} reducer A function that returns the next state tree, given
	 * the current state tree and the action to handle.
	 *
	 * @param {any} [preloadedState] The initial state. You may optionally specify it
	 * to hydrate the state from the server in universal apps, or to restore a
	 * previously serialized user session.
	 * If you use `combineReducers` to produce the root reducer function, this must be
	 * an object with the same shape as `combineReducers` keys.
	 *
	 * @param {Function} enhancer The store enhancer. You may optionally specify it
	 * to enhance the store with third-party capabilities such as middleware,
	 * time travel, persistence, etc. The only store enhancer that ships with Redux
	 * is `applyMiddleware()`.
	 *
	 * @returns {Store} A Redux store that lets you read the state, dispatch actions
	 * and subscribe to changes.
	 */
	function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2['default'])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      listeners[i]();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/zenparsing/es-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2['default']] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
	}

/***/ },
/* 1004 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 1005 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	var runtime = (function (exports) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  function define(obj, key, value) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	    return obj[key];
	  }
	  try {
	    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
	    define({}, "");
	  } catch (err) {
	    define = function(obj, key, value) {
	      return obj[key] = value;
	    };
	  }
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  exports.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  define(IteratorPrototype, iteratorSymbol, function () {
	    return this;
	  });
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = GeneratorFunctionPrototype;
	  define(Gp, "constructor", GeneratorFunctionPrototype);
	  define(GeneratorFunctionPrototype, "constructor", GeneratorFunction);
	  GeneratorFunction.displayName = define(
	    GeneratorFunctionPrototype,
	    toStringTagSymbol,
	    "GeneratorFunction"
	  );
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      define(prototype, method, function(arg) {
	        return this._invoke(method, arg);
	      });
	    });
	  }
	
	  exports.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  exports.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      define(genFun, toStringTagSymbol, "GeneratorFunction");
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  exports.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator, PromiseImpl) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return PromiseImpl.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return PromiseImpl.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration.
	          result.value = unwrapped;
	          resolve(result);
	        }, function(error) {
	          // If a rejected Promise was yielded, throw the rejection back
	          // into the async generator function so it can be handled there.
	          return invoke("throw", error, resolve, reject);
	        });
	      }
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new PromiseImpl(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
	    return this;
	  });
	  exports.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
	    if (PromiseImpl === void 0) PromiseImpl = Promise;
	
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList),
	      PromiseImpl
	    );
	
	    return exports.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        // Note: ["return"] must be used for ES3 parsing compatibility.
	        if (delegate.iterator["return"]) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  define(Gp, toStringTagSymbol, "Generator");
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  define(Gp, iteratorSymbol, function() {
	    return this;
	  });
	
	  define(Gp, "toString", function() {
	    return "[object Generator]";
	  });
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  exports.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  exports.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	
	  // Regardless of whether this script is executing as a CommonJS module
	  // or not, return the runtime object so that we can declare the variable
	  // regeneratorRuntime in the outer scope, which allows this module to be
	  // injected easily by `bin/regenerator --include-runtime script.js`.
	  return exports;
	
	}(
	  // If this script is executing as a CommonJS module, use module.exports
	  // as the regeneratorRuntime namespace. Otherwise create a new empty
	  // object. Either way, the resulting object will be used to initialize
	  // the regeneratorRuntime variable at the top of this file.
	   true ? module.exports : {}
	));
	
	try {
	  regeneratorRuntime = runtime;
	} catch (accidentalStrictMode) {
	  // This module should not be running in strict mode, so the above
	  // assignment should always work unless something is misconfigured. Just
	  // in case runtime.js accidentally runs in strict mode, in modern engines
	  // we can explicitly access globalThis. In older engines we can escape
	  // strict mode using a global Function call. This could conceivably fail
	  // if a Content Security Policy forbids using Function, but in that case
	  // the proper solution is to fix the accidental strict mode problem. If
	  // you've misconfigured your bundler to force strict mode and applied a
	  // CSP to forbid Function, and you're not willing to fix either of those
	  // problems, please detail your unique predicament in a GitHub issue.
	  if (typeof globalThis === "object") {
	    globalThis.regeneratorRuntime = runtime;
	  } else {
	    Function("r", "regeneratorRuntime = r")(runtime);
	  }
	}


/***/ },
/* 1006 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var setFunctionName = __webpack_require__(2465);
	var $TypeError = __webpack_require__(175);
	
	var $Object = Object;
	
	module.exports = setFunctionName(function flags() {
		if (this == null || this !== $Object(this)) {
			throw new $TypeError('RegExp.prototype.flags getter called on non-object');
		}
		var result = '';
		if (this.hasIndices) {
			result += 'd';
		}
		if (this.global) {
			result += 'g';
		}
		if (this.ignoreCase) {
			result += 'i';
		}
		if (this.multiline) {
			result += 'm';
		}
		if (this.dotAll) {
			result += 's';
		}
		if (this.unicode) {
			result += 'u';
		}
		if (this.unicodeSets) {
			result += 'v';
		}
		if (this.sticky) {
			result += 'y';
		}
		return result;
	}, 'get flags', true);
	


/***/ },
/* 1007 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(1006);
	
	var supportsDescriptors = __webpack_require__(216).supportsDescriptors;
	var $gOPD = Object.getOwnPropertyDescriptor;
	
	module.exports = function getPolyfill() {
		if (supportsDescriptors && (/a/mig).flags === 'gim') {
			var descriptor = $gOPD(RegExp.prototype, 'flags');
			if (
				descriptor
				&& typeof descriptor.get === 'function'
				&& typeof RegExp.prototype.dotAll === 'boolean'
				&& typeof RegExp.prototype.hasIndices === 'boolean'
			) {
				/* eslint getter-return: 0 */
				var calls = '';
				var o = {};
				Object.defineProperty(o, 'hasIndices', {
					get: function () {
						calls += 'd';
					}
				});
				Object.defineProperty(o, 'sticky', {
					get: function () {
						calls += 'y';
					}
				});
				if (calls === 'dy') {
					return descriptor.get;
				}
			}
		}
		return implementation;
	};


/***/ },
/* 1008 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,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"

/***/ },
/* 1009 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,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"

/***/ },
/* 1010 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,QGltcG9ydCAnLi4vLi4vLi4vc3R5bGVzL3ZhcmlhYmxlcy5zY3NzJzsNCg0KLnRoZW1lLWRhcmsgLmdjbC1jaGVjayB7DQoJLmdjbC1jaGVjay1pdGVtIHsNCgkJaSB7DQoJCQliYWNrZ3JvdW5kLWNvbG9yOiAkZ3JleS0zMDA7DQoJCX0NCgkJJi5yaWdodC5hc3NpZ25lZCwgJi5sZWZ0LmFzc2lnbmVkew0KCQkJYmFja2dyb3VuZC1jb2xvcjogJGdyZWVuLTI0Ow0KCQkJaS5nY2wtaWNvbi5jaGVja2JveC5hc3NpZ25lZHsNCgkJCQliYWNrZ3JvdW5kLWNvbG9yOiAkZ3JlZW4tMzAwOw0KCQkJfQ0KCQl9DQoJfQ0KDQoJc3BhbiB7DQoJCWNvbG9yOiAkZ3JleS0zMDA7DQoJfQ0KDQoJLmdsYy1jaGVjay1pY29uIHsNCgkJYmFja2dyb3VuZC1jb2xvcjogJGdyZXktMzAwOw0KCX0NCg0KCSY6aG92ZXIgew0KCQkuZ2NsLWNoZWNrLWl0ZW0gPiBpLA0KCQkuZ2xjLWNoZWNrLWljb24gew0KCQkJYmFja2dyb3VuZC1jb2xvcjogJGdyZXktMjAwOw0KCQl9DQoJCXNwYW4gew0KCQkJY29sb3I6ICRncmV5LTIwMDsNCgkJfQ0KCX0NCg0KCSY6YWN0aXZlIHsNCgkJLmdjbC1jaGVjay1pdGVtID4gaSwNCgkJLmdsYy1jaGVjay1pY29uIHsNCgkJCWJhY2tncm91bmQtY29sb3I6ICRncmV5LTQwMDsNCgkJfQ0KCQlzcGFuIHsNCgkJCWNvbG9yOiAkZ3JleS00MDA7DQoJCX0NCgl9DQoJJjpmb2N1cyB7DQoJCS5nY2wtY2hlY2staXRlbSB7DQoJCQliYWNrZ3JvdW5kLWNvbG9yOiAkZ3JleS01MC0xNjsNCgkJfQ0KCX0NCg0KCS8vZXN0aWxvcyBwYXJhIGNoZWNrZWQNCgkmLmNoZWNrZWQgew0KCQkuZ2NsLWNoZWNrLWl0ZW0gPiBpLA0KCQkuZ2xjLWNoZWNrLWljb24gew0KCQkJYmFja2dyb3VuZC1jb2xvcjogJGdvbGQ7DQoJCX0NCgkJc3BhbiB7DQoJCQljb2xvcjogJGdvbGQ7DQoJCX0NCg0KCQkmOmhvdmVyIHsNCgkJCS5nY2wtY2hlY2staXRlbSA+IGksDQoJCQkuZ2xjLWNoZWNrLWljb24gew0KCQkJCWJhY2tncm91bmQtY29sb3I6ICRnb2xkLTQwMDsNCgkJCX0NCgkJCXNwYW4gew0KCQkJCWNvbG9yOiAkZ29sZC00MDA7DQoJCQl9DQoJCX0NCgkJJjphY3RpdmUgew0KCQkJLmdjbC1jaGVjay1pdGVtID4gaSwNCgkJCS5nbGMtY2hlY2staWNvbiB7DQoJCQkJYmFja2dyb3VuZC1jb2xvcjogJGdvbGQtMzAwOw0KCQkJfQ0KCQkJc3BhbiB7DQoJCQkJY29sb3I6ICRnb2xkLTMwMDsNCgkJCX0NCgkJfQ0KCQkmOmZvY3VzIHsNCgkJCS5nY2wtY2hlY2staXRlbSB7DQoJCQkJYmFja2dyb3VuZC1jb2xvcjogJGdvbGQtMjQ7DQoJCQl9DQoJCX0NCgl9DQoNCgkmLmRpc2FibGVkIHsNCgkJLmdjbC1jaGVjay1pdGVtID4gaSB7DQoJCQliYWNrZ3JvdW5kLWNvbG9yOiAkZ3JleS03MDA7DQoJCX0NCgkJc3BhbiB7DQoJCQljb2xvcjogJGdyZXktNzAwOw0KCQl9DQoJfQ0KfQ0K"

/***/ },
/* 1011 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAAA2CAYAAACWeYpTAAAACXBIWXMAAAsSAAALEgHS3X78AAADZElEQVRoBe1aK3DqQBTdvqkpFmRri0Vj0bXV1Zh2pggqakBCZzDUFkslWJClspUFWSpBAnLfHCbLbG72G0LfI5Mzs4KE/Zzdc8/eTXLCOWc+uLu745VKhV1eXm5rLZdLNplMWK1WO/FqKCYeHh54uVzeVl6v1+z9/Z11Oh173yDqWm5vb/n39zdX4e3tjfu0FaeMRqNIz6vVir+8vFj79uowIKOFS4dxS6vVMvbdaDSMfft2bMTHx8fBiAZta2Hr+zTJ+Dk7O3P633Q6DRlDsVi0xpitbdt9L6Iwnnw+r70/m80waGs7Lv+h2Gw21rGZ8MenM7jrPvf3wXQ6NdbGJBvhGys6Q/I0IgprHTg+HFaFYCdIznVFAamvr69d6Xa7vibkTRQFzrpYLEIVseVgEmx1nRMGJArn5+esUCgo43Q+n2/j5PHx0SVxoJ0a67TbbadB/vz86JMH20zU6/XtqrkC8nKYZeOKou5gMNBK1QaMl+6rVqnE7QxxYyBrJKrKgHwRSNyNKI0HXwQDDq2U2PgxgSLG6eQmhSCbMhMNXDSxWaV5MiUowiSuglSQTVK7j15cXLjEvxEwrV6vtzWSm5ubUJs0AYDZVatVlsvlQtdhcnGB042Alqg4hu2Lq6srNh6PealUCrU0Go1Cv+lEsGCgz8/PiYxD67QyIDnbyUXAlnxzxZEODksBCUvOGQtyjCpXlOai4/HYeeI+Pz+NeSekWC6Xd3sdpI1Vp3h9fXXdk52gJEplizzTNRFHXZDVkXx6etr9bjab/Pr6OvK/fr8PKSf7xEIlXdn54Jw+lo+6VPo8KkVt7qp5UpG8dDHLsvNhNX2MCXVRqFv2er2dFOGw9/f3SoeVZZ0kIkSpO7qeMWkbkJ9Mslqt7gggJqnDUlknDioTmteqZGiDKhkwSZHK+uDShaTk1YN7xkkc0AbaUt1TnUSwkkk6rAohovu4LYUurnGUkrcfOXYPie151PW8lxRgQlAKMh+XFK9Wq8XqGT4h2hcH718l+i/g9XAsI3oEyIimDeJJ/a+88tsDKrM8MVyPIJNu2pARTRsyomlDRjRtyIimDRnRtCEjmjZkRNOGjGjakBH9nyB/dCHD9kXn0RGlb9DFl570i0/T642jIIrvGQQJrO5wOIxcB8T1CBhjfwGq3E+lEWo0SgAAAABJRU5ErkJggg=="

/***/ },
/* 1012 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAAwCAYAAABE1blzAAAACXBIWXMAAAsSAAALEgHS3X78AAADfklEQVRogeVaLZPqMBTt7jxDLUjQ2GKxaP4D/wAEAgQGBAIEBg0SjQYJFiQgAVkkIPPmdFMe2ybp7QfbsO/MZIbZbZp7mptzb27ywRgzfjP+JM2t1+sxy7KMbDbrtEKhYJimqexzuVwM27aNw+Hg/N5ut8ZoNPpIxCDMYNw2mUzYZrNhScK2bbZYLFi322Vx7IvcsV6vs/l8zq7Xa6LERDgej2w8HkciGonYbDb7EWJegOhgMAhFNBQ5vByDpI3VasVarRaJKJkc1oNOgAdR3JYUJpbLJatUKmThggqeTidjv98b5/M5UBGhvFBbNFeBqRgOh0az2ZS/P+gLwB0ogIpCTbFG46oylBMeAyWlAONGclGK9OOZuFKuanBDClEZycgzh0GjSnfYRlVuEUnhYIhvQeSScMWwDSquIon/edXVNwiPM1IgTKRB7nl9qkjyMCYnqPJ37rapEHtumCUVSbizkCD3YSF2u50W5Cgzib+7XkaavecOOjXVhLiz+DCYK6IQYfO/n2zcs3xw1+LDGFlY8C5a3ZpKFLFWP92MplgsytI0ctqUBpCmYZMsAjg5BBuNBpPlf8grdYfMRuS2DsF8Pi98AAlzYqWDFwJJvQjg9aka9na76c7NgcpOJcHfgP+bYFC5TxfkcjmhJff7/YugbEcMFXoHyOyESD5mULZQh8Oh9qVvlDlEQHx8EERVWYRSqZSW3SSgniOL4U74cFMvnpz6wBNwbVO1oFz0MYOybABfZzqdaummWD6yFHO9Xn/9oHwNHbdLsIeyvfvWSZWZ8wqbNgRVRTFeUzJ8BFWzyDQqWajIeQtivs68xqktSdUuHvDWaIUvCSobQqFeWeyVNV4SlOLZNZUEg1yV8YWsKpm/qslOt2QaITUEfkw5KotzOJmki8ritfJlVJLs6cgZShwlpFDP+/i7hRAVxwKPz1DOwNFZtVoNFYSR6Ko2orLLCe6RG/qjdTod30ZgvV6zcrns64vgXi6Xvz1PvkaCbKZWq5GeTRpe0plMBjsg4Sjtdtvo9/v/SIZ1Ix2OsFXwKmmkhU49s0sDXrGJpWggGhRO0sCzqidylavdbju3m5DZQzyoZ+xeIULpIcz5vAzYGVmW5azDl9xVA2GKoaJSCVQb9Uz3Y4X5YB4bHLF5i8t4UUjjyKFSqbwHQRGCSMP1TdN8X4IieEkvFgvjLxWNg9z8YpRrAAAAAElFTkSuQmCC"

/***/ },
/* 1013 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAA0CAYAAADFeBvrAAAAAXNSR0IArs4c6QAAAAlwSFlzAAALEwAACxMBAJqcGAAAAVlpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IlhNUCBDb3JlIDUuNC4wIj4KICAgPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICAgICAgPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIKICAgICAgICAgICAgeG1sbnM6dGlmZj0iaHR0cDovL25zLmFkb2JlLmNvbS90aWZmLzEuMC8iPgogICAgICAgICA8dGlmZjpPcmllbnRhdGlvbj4xPC90aWZmOk9yaWVudGF0aW9uPgogICAgICA8L3JkZjpEZXNjcmlwdGlvbj4KICAgPC9yZGY6UkRGPgo8L3g6eG1wbWV0YT4KTMInWQAAAxRJREFUaAXtWi2TwjAQ7dycAQsWCxYLmh/CP0Bg0Fg0GotGYxkkSEACEgu2d68z21lybbJNmrTMXEw+Nh/vdTebTaZR9J/0X2AymcTX6zVGWiwWMXoj50k/g5v02234++j5fB5Pp9Oo2Wwmgna7neT3+/294yfUQOb5fHJFxJvNJtEQ8HMBac4Hr1I0tFqt4vF4rMX3er1SzWk7Ogq/HMdH6/U6l0y3202nv91uadlnwUlDu90uHg6HPvEVnttKQ/BkEjLkFICKO4Zer1cYqHSAlYbgyTqdjnGNVquV9sEeCpGsNCQho4KvNSEVrK4Odw55KKdQWEMEUEeCyxqNBq8mZe79/ggdGwoTKmo6FDVwp+CIufzh/NQ3lXm0gHJRDZePPmNGEwmSI0idzWZp+JMxVT2aCLAuRwRRD7QCFGoQyok9Ho9KtVLYKYCvzgXzw1TwbUrvYkXIhKLf75u6eJNbEbpcLlpAo9FIK/cptCJkOotgdj4vcboPYkVIt4dosaquFVaEJKc+9hGuGUSw9jncsynhah6aiJWGAFJidoPBIDSfyCsh3ExDhz7WhM7ns+jrV+nCRQB5J9Meghx7jY+pdflwOEg4xcvlMhgpa5PDl5aaXchQyInQ8XgUWRAO2Y85kyTnEewy1P3ISUNQz3a7FWtJ1NGxkzMhqdnhLa+W7wlZH/B0Oom8HZ6Ps8aX2easIYDZ7/ciTCG9nQiQrpPUOfgOWEvREIhKnYPvgLU0QjA7000WxKUBK4La0IEt8L0lvIxKEn9NfZvgt4IwiUIqPFSq8qB1RAO6NzsiqwtYf02XuiW5jnwQctj0koRHFJgU+kMjPJKg/xxonspNT+rxCDDldPAi5wnnXBBt5C2i/jnCwenKfM9AYzxxDeat67WdNjYHJSnzPcMjEOzNSk1P6iCySJLpqXN8tOnR/QlunKeQt99ME0ZAapPgvmlCPgdMj8iSPHiuumEpQXofBwHuOTnZ4GSwIPaE5MBViYIEaYM8J2+rhAwtqu4FFXxenWsDrpscBs1baa6eLXkk1HYyPQn4H/yh87xrZeEWAAAAAElFTkSuQmCC"

/***/ },
/* 1014 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAAWCAYAAACVIF9YAAAACXBIWXMAAAsSAAALEgHS3X78AAADMklEQVRYCb1YPU8qQRQdCwpoaQyRxgILGxsaGklsbCz8F7KNW2giDcuDggIKKcwmNlYmUGwDBQ2JvEJMLKSBBE1shE5IoAASLeblkN3Nus7OzkAeJ5kE2L137rlzv4YtSilZB6qqavv7+yQWi2V3d3fJ9vY2GQwGRNf1ZLFY/CujOpPJaPF4PBuNRsnOzo79+2KxWOrs9XrZl5eXlq7r4npBUHadn5/TSqVCPz4+qBeen5+pjN5cLuepy4nb21tNRq8UuVwup3U6HSFDvr6+qGm0r96LiwttNpsJ6e33+1KOE3rp5uaGPj4+Lo2WAYy+urryNeju7k6T0Sui05cgvNpsNuloNJIi5QbCGCHNM6LVaknpRHqIElwWmVQqdRiJRJJmcmdRKPb29kggEODm72g0IuPxGAWgFY1Gk5BhYTqdkvv7+6yiKH9Yz19fX6mXrMf7sG9LuMgUCgWhEPn8/KS1Wo0Wi0WmB8388ARkV5FzQyYPrRxjEkQOoajwSDkXQtGvWKBQueXMiisMpI4UQcMwbIIWKRQWmWplLdMRnkCxcss49xeBjG1WFVsmrmhZ550gTpt3iqz2USqVhAlOJhMpG1cm4yClVSqVB+SFaBvBe3Cooih2uKKB++UiyOm6/rARguhFZritDFaxQPixJiSkjV+7YS3pWTSdTtOTkxOSSCSk5LzQbreh61fJz+fzNBgMLj8Ph0NyfX0t1hbckPGGYRhrnZgXzDa1drqsHKKojLK9SgbmfLt5gv+bmBPrVnBhgmjE1WpVe3t72wgxC6isjUbjR2UVSRkUOoT42dnZoS9B3v1uUxAZzrHMacbG+/s7cwDgCq0CNHm/G4jfcysnWaeJ3/zupHASUgsDzA9h857F3RhCPOA5b1zDxjghHknnKeJ9hCEmJKxut8vd363j19HzCFiDMqYQ9zgGg50h4uXlcrmsWc5kkbQcYOnBZ7cuyMFOPENxcg8ccISlg9noS6USPT4+tu+DuPPV63Vcq+xmi4Z/cHBAQqEQmc/n5Onp6Uczvry81E5PT7PhcHj5HX8coakrimK/o6oqPTo6wh9WzOesxv/9/Y29xZo+IeQfM2zyJ/OAp7UAAAAASUVORK5CYII="

/***/ },
/* 1015 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAAyCAYAAAATIfj2AAAACXBIWXMAAAsSAAALEgHS3X78AAADUElEQVRoBe1aLbPqMBDtvXMNWDSW2vIb0Gh+BggECAwVCBAYsFSCBQsSLJUUSZFFAjJvDtPw+pE2oU0vnTucmcyQkiZ7srvJZtMvQojyl/CdFZfRaER2ux1mK1RM0yTT6TSbmYSGZJf1ek1EcDgcSLPZJDLHl05mNpsJkaHYbrf5JTQcDplCQxO0XK/X0P/L5VIaKamEILAXjuOETAr1/X7vaweSskxPGpl+vx+aefdZqC2EB1kv5vN5vgi5Agn7RtDXXK2llkPasl0sFn31y+US295xHF+9UChIkSOzfehdkEbItm1fXdO02PbVatVX52lUFNIIHY9HX71cLiuLxYIZDei6Tmq1mu9ZcEISQ+ayzYoQ3Ge+xSC4F+Vy2abL8el0Ym6uccjtxkpJsaKBKOQ69KEFGypPUyAtUzOZEqIF/hKMCFCHX3U6HelkMidEGPFdFlrxlj+3sUo5gluWRVRVlSIQZErz8if0yTs+hFhQVfXLtf1QsSzL98ZqtVKi2qb1H2mE8oQPobzjSajb7f6JnPAP/TEYDJTNZkPgtOPxOLVz/iZardb/AyMJJAhlR8FZx3KQnQbA6DvkQ8je1Ot1nPGJYRi5NUO4CJL+7XZbKZVKj2ePzBNh5NSC4b6rwdxoCH2wDpEY61th5NS8AHtkaGCnv66GAHBFY9s2gQVFykwZswDGaQ9isjQEOXhH+6eGKpUKk+z9fsfql4sVD3Louq6YphnbLnZjRbIwKrf2DoCUpmmh+DBECElBNDIMI9Sg0Wg8EoN5IQVZog6T4PGwz8lk8rRrN63kAzI4SROBMlc5Vt4PfuW9b2K+xHK+pPkzmYSCF2Xe/rC1gCzzRVdjkS+/gxDLclgp5JdmgyS4aUtLCAKzyABeV+ESikvpYgBRn0pDKC4DG7wE4BIinJAIA4mEREkIYbKiNnvCWaS4sxTXMdVWXDTxCiFKJJg+FiUjRIgIfkwBYiyNxRGCYPADPAu2YwHteKYu7Jx0WeSB7gsYnDXbEBzkX7lHQp/upHLlFCZEZ1T0Ox5Z4Jl0KkK0YAAM9MrF1qtA/1EfbsSV1Ml6BK+IrXi33iJAJE1L0ryG1A8AcQBDgAiCIh9SnM9n5Xa7PQj0er30xxRFUf4BqkSwJkegqXEAAAAASUVORK5CYII="

/***/ },
/* 1016 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAA0CAYAAADFeBvrAAAACXBIWXMAAAsSAAALEgHS3X78AAAA80lEQVRoge3asQ2DMBRF0Q/KGFCzA4t4DRfegYZFqL0DO7j2II4cpYggxceA8mK9I7lD2FfIAhKalJLUpJ3nORdVMUIIqa3q8uQrBLCGSzFIqdEM7/3fBP0Mg9AxCB2D0DEIHYPQMQgdg9A9tutblkVijKeW7ZxTHbeuq4QQiucZx/E1Pu2Ccoxzrime5YBpmk7N473f/WTFPYSOQegYhI5B6HY31r7v5f2PRDHtjdlam7quK55n+5Qg34KMMWdaDskx2sckLe4hdAxCxyB0DELHIHQMQscgdPW/4F0hf+alOc0d7163BA3DcMdpVbiHoInIE1S4Yd3zvdp7AAAAAElFTkSuQmCC"

/***/ },
/* 1017 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAYAAAAehFoBAAAACXBIWXMAAAsSAAALEgHS3X78AAAAs0lEQVRYhe3YsQ3DIBCF4XPkDdgBFqRhBraBHZgBhnBNeRFRBsAmz0mk90nuMPfLcoHYVFVWhRDUGDO1i/d+Wxo3gleflJKesDTvsfx5b8ZgNAajMRiNwWgMRmMwGoPhYoxnzrJfVWtV/hJoDEZjMBqD0f4ueD+OQ3LOS5tYa8U5N7W2lCJj5hWv9+6+qnofBXhV9bMYjMZgNAajMRiNwWgMRts/sf84p7bWptb23q8PEpEn2ybldqimc0oAAAAASUVORK5CYII="

/***/ },
/* 1018 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA2CAYAAACMRWrdAAAACXBIWXMAAAsSAAALEgHS3X78AAADbklEQVRoBe2aIWzyQBTHr18+xGZBYBBMDINAoFAkaDR2GrOJibGEwAcSBAaDwaJBgmUCg1u2yY1kYkyCICS3/FlLSqHtXXuvbF/4Jx2hg7v73b337t4rjHNOfrVaLf7x8cHX6zWfTCa8WCxWqPskh7q+vuaLxYKb1e/3OXW/fxixUqkUOz8/3+kkk8lQd0sPdnl5uXcvHA6zUqnEKfslB4vFYlL3VekE5kX1et3W3H412NnZmaf/qRC5KdopEon8n2CIjJQ6Ghhz8UG/IgWzbsxWUfoZKRh15HPSUU2RUiew3yYysJubG46TvZNIfVB1HlQulyvD4ZCvVisuotfXV97pdCqqk0+lUN1uVwjmkACIpPTHgY3HY89QhpBp12o1JXC+G8AsT6dT31BmOH3ljwcGKJgQhXq9ni84z1+EyczncxIoQ7p5BwfWaDT2Kk9Uenp68hRUpKH8RD6vgrnf3d1JwUlBjUajwKEMyUZM4SAhE86NyKYXRm2FgcLUZCQaMYWgRCMfgABj+AR80U56m1vzlvFZkUqya+QThYKZWp3cCUxfqZ0JlDF1t4jpCCUyi+jAxbGFwLxMptMxzHPkw8AEnfmg3MwJG7TIxGIvPTSOvQbdHB5AuokJBR672RfxE9GghQmwjmmnIadGMDNeznB2UU/myIRBi5ineXybP8iF7L7o91BqN1kyqy5jnnoA+s6go9HoXja7XC7ZYDBg9/f37OrqSvOayH5+fipIh79VKBQ0jOfh4cH2M7lcDtl79i8zpehvb2/s+fmZPT4+VvHabrf/5fN5X4N5f38/eH82m1W9tNdqtTaTXCqVKslkkqXT6erFxQULhULbz8TjcbZdYlUJnvXS2z0kZX1guzHnhP1+P6scxObakZ7uKO8Hfou2R6NR9ijlt/l8TtLu7e2tFg6HNbhRICtmDfl2pw6V11FWbDabkfcRCNjLy8vOe2wl1DqVuP0I+6NZG+cmViBg1seygTw3o45OdikQ1YHAuEihHE4dSsvZgYKJZOCqH0SQg4mWFSjhlEPhQCpbJfZTyg4EzM9DCiNB/JFgblBuxdF2u60MTtk+hmfO5v0JxyZsxMjCm80mbmmJRAJJoob3uG/duBOJhKrhMG2zbAqEnw8h2wYMzoblclmonIAJwa9QDahcLue5DLEVY+wL+NSElr3GvaUAAAAASUVORK5CYII="

/***/ },
/* 1019 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA0CAYAAADfRPtlAAAACXBIWXMAAAsSAAALEgHS3X78AAAC10lEQVRoBd1av5cBMRCOK7VaWlotLa2/hZLWlihpKdVqW9Jq1bSUtLk3LuvW2mwyyc748b2Xd965k/mSSeabbwkpJesYjUaScz5WctPpVB4OB1aCP4IR9XpdVCoVEQSB5JqVjWCv15PNZvP2OvrJATaCsHsRGo3G9xFstVr318ViUSwWC5Y0ZSE4GAwknL04uHaRhWC73X76Xa1WuxGnnpuFYPz8xcFx2ZATnM1mslQqpb73FQR1uwcA4rAApAFQqohutytN2O12pMqGdAezdi/+NyACqGIgJRivfVkgLRlUqdHv943pGeF0OpGlKdkOptU+HeCyGY/HJGlKRtDm/MVBVTJICGbVPh2oLhsSgtjdE0qAu/yfCQU4iDrAipbL5dR3QTxDUGnodDpOwZzPZ7HdbnMjd71e/wiGYShtr/RPwfF4FJPJ5L9MgF9yuVysr/Z3xnq9vpedp9qlTKGPBGzQfD5/qKmp+nGz2XwcPxALw+FQJvloFQCsxKekLAh2JeyfeGTKHFiRd0/Z1WolszhYtTyqpXkrQHbZuOTWonW5XL4NP8gqJeaNcaOUOaSsUv4vg7oArWNGtx+vTNlkCSAh+IqU1ZUAUoJSPQqjLiX7/V5bAsgJSmTn7gLby0Q3vNulpCWfN8AB94E3Qd8ATPDtEb0JVqtV348g/XwvgmlPjfIGNNU+7rcXQer0zGMeL4LU6RnB5xyy7yD4LliAQ+f6LNGZIHxTAmsNhmEIwRaCILh5Jhg47yKHVAO1A55PUtNinAPXp1DOBG0Ft6m1wZhdLpLNmaBNUHF3yyT3QHOakMwCMoJK2WuRlpI2Q9kPWmB7QWeCWYFgum3d4umaapfHbE5B6NLJZADZjqymGtsXugbxAFsDCDvSrEt1e9MRVGfrDt+G1DSSbjv265joCdXNmGtK2oz4uccsKHoiWEGqlDSNyCLBmE+oCWDlqFPSJgbrEiSl+AVM3S1piNwr2wAAAABJRU5ErkJggg=="

/***/ },
/* 1020 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAA0CAYAAADFeBvrAAAACXBIWXMAAAsSAAALEgHS3X78AAAC30lEQVRogd2aLbPqMBCGy52rsFjQWCz9D1j+BggECAwIBMMMBo1Fg6WSIkECEpBUUps7bye5U9KvtKRJznlnMufQpqVPk+xudqkQQqzfpD9FWEajEXEch/i+j7dBPM8jruua8WYwQqJtOBySy+VCknQ4HEie+5XRct2UPnCqdEPlmnK73c7yfT+1j23bltbpl/cNTCYT8n6/jR2pQhf1ej1yv9+NhCp8oSjUdrtVCvXVxfP5PBMI0xPwPwKItkyt12tlQIUcK1O/3xeyZrVa7ZuvyaX/QPD+aHkubrfbQv1c1y0RgRMbKrbARacH7Zcpel+1RmG1Wn08VxaUKAy02WzUA8WFNElQeWAgxH/KgZI8P/9288KcTielMAEQ9RGJwhpAhC3iRHmpNNes/a3X66lGo9FoFDY45/P5K4NVRMGOFRs02b4CUfnj8Qj+v91u1vV6tQaDQaV0IhJj5coQ1ikidSVGociCLyIVUB8ffgNU5MBPh4o9KAqFB4NTLrIGy4JKPJEGBYcZ9jH0wYyASk00IvputVpWtVoNPnueF/iW5XIZMb/I0bF+eQTzvlgsrPF4LMeky3ozNEzSPlJS52+R8Eg2lFQg0cRJmVBSgUyAkg6kG6oUIJ1QpQHpgioVSAdU6UCqoZSVJJGU7Ha7QbmliBBRHI/H4C8iFmwYZ7NZNLpQMULhJlI0ExViSj5vrhxINhSmYzhVpgVINhTWJxsprWV9lC5F1hRy41g3TNgB8NkorKlms1nRNkKiI0VrUJHraCHtQ7CE2oHSoLKqf/xPDPb7PfmqPiRLtm1X4koujuOkfgN/HklTI4AsCsUfi9sZhxX3EwNjgOKUVSGM2/IbBcRSx0ywZmnizz+fT7OAkAMPq9PpJI7SdDqNmHyYbiOsHGvw+Hyt6vV6RQJTJGT4fqz0aRRQkn8REfNXxgGl+aUkhZOeRgIRwXR03D7JWCA0PCyt00bWVWwUQYj1DzCJGY6XHX2DAAAAAElFTkSuQmCC"

/***/ },
/* 1021 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAAAXNSR0IArs4c6QAAAAlwSFlzAAALEwAACxMBAJqcGAAAAVlpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IlhNUCBDb3JlIDUuNC4wIj4KICAgPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICAgICAgPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIKICAgICAgICAgICAgeG1sbnM6dGlmZj0iaHR0cDovL25zLmFkb2JlLmNvbS90aWZmLzEuMC8iPgogICAgICAgICA8dGlmZjpPcmllbnRhdGlvbj4xPC90aWZmOk9yaWVudGF0aW9uPgogICAgICA8L3JkZjpEZXNjcmlwdGlvbj4KICAgPC9yZGY6UkRGPgo8L3g6eG1wbWV0YT4KTMInWQAAAptJREFUaAXtWqGSAjEM7d2cwqKxYNFYNB/BF2DRWBQCjUWjsWCxgAQkSEDu3bsZmB1od9pH2u5xzczOlVyb5CXdpN1WqUTJA9YeGA6H2Xq9vj+TySSzHvzXOvb7/ex8PmePBH6ZsHxKGdNqtVSlUnkSB36ZSAxwmUAV2ZIAF3nnHf737yL85TtqnU5HIXO76tlsNr9DTqeT2m63qtvtfrjK8NZ/PB5nx+PxsSKJ/kbJQ533BsJWMBYXISkqaCgPTYh0r9cLH2ko9T2NTc5cLBbhAc9mM5M9QfjskpUuS+122/Y199KPXbJSZWkwGGS6dfMN2XK5VCgnr1KtVlN4qtXqk6h6vf7E88YoSlbsVDMZa6oC2IaaxojzTYB9GaFLCqwu+h0W92IggQlwIEdHU5MiHM31gRSnCAdydDQ1KcLRXB9IcYpwIEdHUyMa4UajofB9SxLNdDoVlUfZZto86Bb5vnhp82AZOtEpbakzarcEOKr7AyhPEQ7gZBEV1+tVRI61EF/lxlYuvotbG5vrmKZ0zhmlbl4uF8o+OsL7/Z5SKDWI1U8DZj0sBZiVQwOWOEphjca4w+FADafOlqCJBYyZkZ+O2GExNBqNwl6BYHZMusNsRs5ut6NKEuPY+xgcmrkSwN0F5BquZ83s1jCnkmu6AjZpcY0yu+iAfjppYfDtahHaNmS6m1F01qyTy+YPyHoJsKviZrOps1+Z+NrOP8x80jP18cLH9yYX0t21YmR4AWMjlElccBCSDh5kW1eKcoMn74zVauVq80v9pa9U5LFYtXHBBVM1BM3nc21ZszJUspNrWWGcE30qPzoMoH1FunRgb+DxfrmumoqijauN0icZN1tF/wI43jcmC8MByOAoV6aFiqixSdibeeAboRSFIANTpvUAAAAASUVORK5CYII="

/***/ },
/* 1022 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAAyCAYAAAAJHRh4AAAACXBIWXMAAAsSAAALEgHS3X78AAADgklEQVRoge2aPU8qQRSGhxsrChtMkEQLGyhsqP0HFrTS3ttaKAWNBZGLxRZugQU2FtBCYyItFLdQSyzBhJCsJjRQgokWc/NOdsgw7Af7ge4SnmRFYObMvMyZOWdmN0IpJTc3N5epVKq4vb1NzBiPx8Wvry/y/v5Oer0eqVQqf00LBwkI7Pf71AmPj48oTcJwsT+fn5+OBIJSqRQKkb/gTHA9p6TT6VB4KBP49vb28z1ZEVsw22g0iul0umjURCwWI0dHR+FVaOfD19fXhnPw4eEhPHPQDZlMhv0+QbjG4zHt9Xr09vaWylJcCwwSmEapVIqcnp6Sq6urOZFrIVDk5ORk7v3aCcRIimy5NfT09MQukcPDQ3J8fMw+Qeip1+uGdff390k2m529V1XVsFw+n5/9D1tm4Uwst4Cfq2i1Wr3k33e7XdNV1sCmWfsz9Dq25WR7a+eiMhuBYWcjMOxsBIadjcCw4zpV+26Q3qmqSnd2dtjuIRqNkr29PdYLOf8UCZzAi4sLenBwQBKJBN9zMsTc1QocaYqCAyEQm1WMCEZJURRPtprN5vcIhCs1m022+Uwmk7PP4F5y9m/lYssynU5JrVaD7YhYhZ1sWwG/N9qO8O0S7zR+/Xg8zlxrlWDLBDGvr6+sFbjkx8cHKRQKEaNmXQtcJcPhkAwGA9wuYNdoNGK3DMrlsqEIK35sDlqNBLzAL09YmUB0HiLQabzykcCroigRuDQR5p+4YvqJZ4F8JOBCmqYxAZjoWBV553/ymN+1QCzHmUxmYSSCxiZVM0M42Q4cmOuY+/f3939sBWJOhQ3EZnB2dvbbNg4SPZUK6hyzYjqd/ltqDjYaDbZSho12u22fyYi0223KtyhBBwkEVnlHAu24u7uju7u7rBRG/Pn52VV6ZUUul6OIq8h/OciC5CR7hh83Gc/Pz/lR/RyTyYRWq1XfbpTCFmwagfbRD7mOLw23Wi3TpzHQIT+eyIANM3Eco8dbPIvTO2+JpmmeBeo2bKlUKnNtrXT0ROSGnVx63aWQf0zPqdqyqyrPWd3gpK5cdnMuaseyqZyXlM9JXbmsZ4F8R24FYuLLy4vrNlB32UxKvq3uS5gwioEifsRC3Ybtai3HQl8Ewmin01loEHHLy+opX7BlFgvRvlGg9zVVQ8jgqxj2Y3gyAucvvjWgn3xjLyqmanDhbDa72A4h5D/Rc3HfLP0RSAAAAABJRU5ErkJggg=="

/***/ },
/* 1023 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAsCAYAAAAacYo8AAAACXBIWXMAAAsSAAALEgHS3X78AAACQklEQVRYCe2ZoZOCQBTGl5srWjVqlarVbOV/wGrRQNBA0WDQYLETzVrNGjWqUY0Y1bg3357rnQoILCx3M3wzOyDDvv35ln0P3iqUUvIf9flXmXu9Hs1kMqRYLJJsNktKpRK7rqoq2W63JDGPt1otWigUGBTgcrkca/l8nh29FDu4l9dEJAwu4rUkwRNb1QD/SGpwUaXgspWCxyEswsPh4Gg58cwJsMvlQna7HTvi9/F4JKPRSEG8Hw6H1DCMl35SwE+nE7FtmwEBDp7EtX6/ryD+kxBJKTJw7i0AofFz0zQVnpg4nKZpwuNFBg5QVVWVqOy9UxpVZCsFl60UXLZScNlKwWUrBZetfwv+J0pw+FioVCoENRqu6/XK3jir1apzJ9RVQrYHbTYbGtROt9ul+/3+2dRbYSxPj/NKlZOcPqeCetk0zfAG3Dxx82AgL/j1dLvdpufzObCnf4/1YnQ6nYY25hd8tVqFhuZjPUQVy7JoFN+DXsLjVy6Xhe3cwfHM6boeE+6P3NZMUN3B6/V67NBRCaGSgaMAH2c9+7cMw1BQyhDRer3+BseugUwtl8vQoyEp6bquMHAUbkSF6fOr2WzmWhP0EmbKsqzvO3iIsm1bKESNx2Pf4RCt2WwGyhXIsOjD+98N3QYOpfl8Hgj6Odkhd7glJFy/5ZaHfg97QIvFgrq+1LgI065pWiSlN75Lx4XHD7VHx5uf/8lkMvGVjjF1g8EgtKdFm+uuW6fTobVa7SVhYCEjHDUaDWkFzhcRQr4AwkOIl0CB00YAAAAASUVORK5CYII="

/***/ },
/* 1024 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAAyCAYAAAATIfj2AAAACXBIWXMAAAsSAAALEgHS3X78AAACl0lEQVRoBe2aPbPBQBSGI/dWWtq0tFp+hl/gH1DS3dFqNEaZ1ihpozRKSpQopWRGde68O9ncIAmb7EaSue/M3o+Qc/bJnv06mwIRaXnS9yuWTqdD9Xpdq1arWqlU0gzDYNd3u537ndPpxP7f7/facDgsiDyfXq9HsF2pVJh9qFgsun6Ox6Nm2zazv1qtXttHC/mVbrdLy+WSRLXdbinIprfA/vl8FraPOuHeILu+FyeTCV0uF2FnXKhov98PdDoajWLZx72DwcDX/tMFy7IiO3p0aprmk1PnmhT52VfmjMvrVLZ9PLTHSHD/cD5QIoCoeFgcytunXKDD4aAMCE7j9JlX8g5EykItafFBQnnrJCXeSl+3242azWbm1wrlchmT9I9eq9VSUB05AouOZUdeBBadr5nyILAUKGfLbT0FdZCqf6C0K39A2BHmRWDRsb3NFZA3N5B1Iaeh40dehMZhaSzbtolnXLIqhJthGAU2ylmWlfk2WiwW7DcD2mw2n65PLF2v1z8GvnWNkoNLi2azGXEOd2Kdz+eMNIutw8ONyZsCckgzpcfc3N3SB6RZmmgxTLdarbtc9x0QEuGmaSZesaiaTqfPd/rlh2Wlg1UK+fe3k/UoTloolXJGZN96B24fxuNxKvsTVgSNRiP4jCjsDAf5bpUpXFHhmKbdbge2TmjIqTyRiCK/k4ZIQGmB8jsLigz0aah3YYSAPgUlAiMMlCRU2DmqVCAUOFI5+r07AEgDUgkVByYWEDnzlMzDMtgKewdBORAKJrr1eh0bBsuZV5NmIkC8xNnxOothKfWQBkTOCCjSr/BdvFUisw5SgUjgHR4Z/SURIHL6VdieCp/J6C+JAQWFoIoQSxQIBWGFzSKKihC7K0TaL7JejH/o/IQYAAAAAElFTkSuQmCC"

/***/ },
/* 1025 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAAyCAYAAAAX1CjLAAAACXBIWXMAAAsSAAALEgHS3X78AAACwklEQVRoge2aP6/5UBjHj+ZOXoGls3gJunoR1s4GlkpE0vRei6EGBtYaDCJhILEgP4vFwshgQWJgsDBYzs3TtL+4l56eU63bJv0m516Xq+f5nOfPeXqIYIyRl8rn80oymfxMJBJoNBp9ZrPZL9J0vV4Px2Ixy9cFQYhQmQtgXg1N0/DlcsH32m63OJfLYas5V6sVthGVvZ5AgeGz2czSPIBVVfUpnG/BSqWS7hUa9fv9B0N9CVav1x9Cz04Ach+avgMbj8dMQPeCxQBP+w6s2+06hrpXuVxWfAMGReB2u7kCdjgcaPLTezAj+d8tb8AkSVIA6Hg8UvNAeGmapmw2GzfWwH2wdrvNZMGz/cpJ5fQMDMrxYrFgmh1ypVAoPDUEnqfd6zwDg9A7nU5MMxul33axSN2JlTKZjOIK2Hw+p54UQgxCjSW8n/WTJE2nU6rru7aipNCzG7A5s0SFkevsYCz9ngnlBOj3QsI+RivIedJdwsMTrFXLaIeo4t5uVCoVhXpijHUvm60YEYy13wNPWV3Y6YDtgXVhIU+fgjkpv5B/pFB4NSxftQc23X+0vR6sDlQlt0LPbtRqNQWqMq195/MZD4dDLMuygmjbHLtk9XKwFjOoE6jValElrNWt/LsGbcNtNgfccrlE1+vV05Oqd2m326HBYKDPxqmq+tXpdB6m9jvsb/vg72aziarVqn48x8EPURQj4DlTk8kENRqNv7CXWsViUfeQKfCULMv/zxw58wHQwj/C71QqRXco+YcCz/A8HwEngFPS6fQPmz/MB6YLRVH0O9MPWTmBs35LsBWCBU0fbtq7Xq8dfXSz3+9dL1iugsXjcTcv95LCHAuaQrCgKQQLmkKwoCkEC5pCsKApvG3heR4+NCDelkiS5MiIaDRqe21BENguanXgaRyQ+lnEw9owx4ImUo4RvzDpayGEvgHqphiCHEsTYAAAAABJRU5ErkJggg=="

/***/ },
/* 1026 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAYAAAAehFoBAAAACXBIWXMAAAsSAAALEgHS3X78AAACRklEQVRYhe2YoZOCQBTGH3dXNFi0WrVa5X8gW8kUgwQJFo0aLJqJZslGtRrFasUoM6a9eYwwnMCyKLvCjb8ZZphhZ/dj+Xj73pMIIVAmvmhaZ7MZvk1ul+u6ZDKZvLRDVMF5U61WYTAYwCuif1gHXi4XcBznqUVQaLPZDO590aPRSMo8GXo46ZpOp8RnvV4T2liWeY7HI9lut9799Xol4/E485xCLYHIsiztdrtgp5fLZSZ7CBcMD6I1TQPTNJlFv0UwhEQjqqoyi36bYHhSNHOUyINGowGWZUVEua7r2cMXrapqYvQQKrher4OiKNQx3W6X+pwqGN86DzCGW5ZFncl/kdQ1k+LdPe7mEocZrwDHcchwOIxdL/GnS/t0PEHryLIcu0Ks4HvS81ZarRa74CJTOsFBAo/ZU6fT8f5S/Bx+duXzSrbGQrvd/jMKY/PpdILz+eytfTgcYD6fS96ft1gsSNHBTK/f75Pv2+1GDMPgtnN5gadkrVaDLwwhZQG1fqIEbyK5RNqZLxo88cK2jQhWFCV7YcgR27ZJWPDHw7yh5sOGYZCkrIkXeKo9XXGwVAh5Y9s2dcb/ZYkwWN36FS4PdF3PVzB6S9d1niGv+H2JZ4js8GazwT6udy86QkBM7yKiAfNh7CSmIbJqTmK1WhHPEqZpCt/JrGDl0ev1JM8SmqZJWCJhzK1UKsFU4Ua0KNCOKC4Mlkf7/R5LJDEN7SyWwFKoUA3tV/kI5g3zSYfxEJNpXnoe+xJJMAvGzK0IFXa5LAEAvyg2o+3wUIOtAAAAAElFTkSuQmCC"

/***/ },
/* 1027 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAA2CAYAAACFrsqnAAAACXBIWXMAAAsSAAALEgHS3X78AAAEUUlEQVRoBd1aLVAzMRDNffMZsCDBUosFW2w1Fl0DogJEDQgEFahaKimS2lYCskiKBGSRgLxvXuc2827vpxxccjffm8lwbUguL/t2s0kahGFo/gcEx8fH4e7u7oLK2traomh8fX2Z19dXW87Pz4Pacb+4uAiL4unpKby6ukIrU5fy5yfkG42GOTg4MJ+fn+FwOKyFNn9ERLC6umr29/cht7DX61VK6FdEBJubm6bT6ZgqyZRCRAAyg8GgEjKlEgHgO1WQKZ2Iicj4lpkTIkC73TZHR0feyDgjgojWarVcdZ+AMyJAs9k0JycnXqzilAiwt7dXWl+TyQSTsih6IXZOZHt7u7S+NjY27LOWrXMiSEJdyAs+2O/3bb/OiZiITBHMZjMrIQ7jz8/PsV7Y2l6IYPaKAEmpgH1sMpkgUa2OCHKxLGCtOTs7y5QeBivr0eXlZfD4+GjrMEHS1gsRbMbSANl0u12Dwn40Go0SZASwCmNra8t4I8JyYEA24j8sJy0hGSzQ7XaD9/d3+1ms7YUIv5ixsrJiP/GsQ0IPDw+JwQpYXjIBXojwbDM4CvGsA/f39/YZRDhvm06ntg4WRZ0XIlk5F0sIjsuhVkuIF8NOpxM7/ECdt3UkbW+vo5C2XF7dbDaL1XkhYiKrpK3wPFgtLx6sXove3t5idd6I4GVyfsZot9tWJuvr67E69iGWllGR0Ju0BEjr0yAzr1MZSE+etUXYWsZX1OLBpO0a2an1FlkGnJcdGN9EjFo7BFnrTBF4JYIBl3VurEOwNyJwzn6/X1p/OgI6J4JFr9frwT8CLHJF2+tIJtCB4e+vRrkEINFsNoOsaCXg9YPXB1NgU+bUIllZrwZHJA65vE/R4ZbDMXyvdCLYe+ClKN+JRhisDErvW/KsweTxntKlBSs0Go3FrGZlvQxe7TEgHiC3xyrPnzWR0i2Cl41Go2+fmvA+RFuEfUfLlInM53M3PoIEEZc/y85+kRGzfNgPEF55sJx3oY7bLQLET+4Qv4vT09PMe8bDw8Pw4+PD9hQ92/rxeKzfYuuur68T7ZxFLezw8tYNWI0jD6fzsOTOzk5qnUnxHeMq/ELPNzc3mfU4IdRrC29t4TdZJCEr9isrRxfSWnZ1zZIKo+vuPMnhO6m/vb2NtRX5OrEIokgeeLZhvcFgYD/DUlyP7IAXSbYkwq7I13sar4HDOMmIsRfRBxV8IIe7ySzJFZbW3d1diDbT6TTzf/KiFQraz+fzMJKJlRS+Y0SRK1VyAH5+IvWFieiXwx9ACjrH36i/wj/t0OEWg+aBat/AhHL7XxEps0QOn/oeENLW0BNWuY+kAU7MvoHrbu0ble0Ql0HOemUnKZEKeZtOPsfjcbK3ukgLBUGCA0X0HEMUZBJt/+JHZXrTkocyTjyyoFMafZEKaw2Hw/QL1jr9eEwXHany1FBLZxfwHgS5WKvVyj68qLNFUJCyv7y8xPKtRAlD8w/WQpqrr+UEAgAAAABJRU5ErkJggg=="

/***/ },
/* 1028 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAA2CAYAAAC4PKvBAAAACXBIWXMAAAsSAAALEgHS3X78AAACq0lEQVRogdVavbPpQBTf3HkNbZS0tGlp1fkf1GkoFFJoKBQUGlpKUdLSailFKUpKlHvnZMTNx+a9dzlnx/5mwliTk1/O7p7P1TjnTEX8iXPudru8UqmwfD7v/y6VSsLX8jyP3W63xPjhcPC/L5cLq9VqGplOQONwTSYTvt1uOSau1ytfLBY8eAbm5X/0+31UwmHs93sS4l9kU/nA/X4nkUtOHPYCBciJu65LRxwsgGoI23Eqg05iEsmXChWexKnWIjlx1db5kziV2aLCk/hut1OKeCQ69DyPFwoF9GdgC2Rxq6KS1iPEVbIsokQC2xHJcUDYy6XRaJB45ARx7OUSZFLYSBAPUq9PR4J4u93WRLnkq8hms3I0zpC1TuAXfAiJq2AWhcQx4xZd19FkhUEejytLnArkxKVuTkxINYdUWsKEkDi2lgaDAXq8ImVzUiwXKcQNw0CXKYU41Ntt20ZdLtLsuGVZqLG5NKsCMk3TRJMnJJ7JZNAeEEa1WmWO4+BoPV7pb7VaZN0JALRXOp3O212KxMCjZ0OK8/nM6/X6W+QTAyBUBt7tDUV+jEYjKaQDrFarl8lHNqfsGAU263Q6fW2zht/iMX3SMZvNfq35SCXLdV2e1kmmBhSiNpuNn6gPh8N/Vr/iJbiPaOxDzgsvEC+TQBIPDYher6d9JPG/AWbGMAz1iANs2/6xKtjRGyVgHz6PfbxTRggfAcnlcmQliQDFYhEnrHUcB7SgwaXrurZcLlEIpgEUg0K82WxGzJdpmhqYNgqAVVmv1z/ET6cTG4/H/uBvkNYfnc/nqDVIsCbAD2bUsiwt1TPB4RvwaBBPHI/HhDOF8BT+exzSEcqACFB07/8A7oMTS3BySRRJkh8mg1ZKuVz2E2aIhUQZf7C5A6cD2gUnkyqUMfYN9jzjkYC5b84AAAAASUVORK5CYII="

/***/ },
/* 1029 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAAiCAYAAAAKyxrjAAAACXBIWXMAAAsSAAALEgHS3X78AAACUUlEQVRYhe2ZvbPBQBTFb968hpaSllbLHyItJQ2FgiINpUZDq0UptRIlJUqUSUm7b04mMfH5skk2H2/emckkM8Tc395rd+9ZiTFGYWu73bJEInGLYjabkaIokh9hhQLYbDZZJpMxnpPJJNXr9bvPT6cToGm/31Or1fIEGggggIrFImWzWcrn85RKpRy/e71e6XA4GMCVSoUfFoAir8lkwvySpmlsPp+zRqPBnMYsDG48HrPj8egbnF2Xy4UNh0NHkL6D9ft9ttvthIA9CtkMDBAZQwkFrd8gPYO12+1QwOxaLpdvIT0Divqf8QpxvJp8PMGZ5REZvcqkp8kkiup2u3eQX9wLp6lSqeT2VaEql8veF3qz1iMrs7rcZ7BQKEQye5aq1ert2RVgLpfzOSR/hb3udDo1NtmuNtu6rjOeDXMY0nUdoBJ3BtEZRB2OzCx2Oh3GDWj1cXEQWjNuQLwUF6H/5AaMQ3laQrX9aUBys0yk02kxkQjSfwbjLi5ArIFx4sVi7xgQi2atVhMbkc8C4LeTn1RVlSmKYpi0cRKM41+b2rD9lndC9462Db7rB9vkNSCMpM1mEzrEO5lm8lPM8EpN28KKn54a2aj5LHYhU4+WxLsEWd+7tUuj0YjJsnxb53AAgnOBVwp6P4o4VFUlWZb5zyZAa3eikeJPo4Qsw+RFCcBCFynEZbcf3FwS0o7ZcbVa0WKxoMFgwDVKvV6PYdeOC5tb3N3OtsgUKme9Xht3P84IJYyQ1zO4R1nnfxbsJ4vjfD4bMJqmGc+8A/xRRPQDOjCxo/fLFroAAAAASUVORK5CYII="

/***/ },
/* 1030 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAA4CAYAAACGwxqMAAAACXBIWXMAAAsSAAALEgHS3X78AAADVElEQVRoge1aIZPyMBANN58BCxIstdVY/k0NCAQIDAgE6P4GNFgsWJAUCchWAjLfbIcwabtJkzZtuZl7M5k5pr3u68tms7tpjVJKfhP+5eG6Wq1or9cjzWaTNBoN0ul0Itc9zyOv14vYtl0zpUkuhYMgoEBWxU5mIzH85Pln3/dN8VBGLsKqGA6HxhZKKYRt2zb3MPDhLGM8HtPH40FVAPet12ua1RY/tBbdfD6n3W6XWJaVSbUgCMjhcAjHYrHItBClhF3XpRCqYABRCF2mcLvdyPP5JPf7PQx/juOovQAmO0y37/tK020Ku91OyWXQRQdTrhhfjaHf74cul/Y8lLDRVa0BFbsoYfDXKqBiN0EYpsXk4tJBq9XSJ1y278ZtTyYTqR8nCMczrrKRZr+UrVkHEKF+FeF2uy29niBc1YJj0FY47Q3LAFQyyoS/AbKF95WEZW75p7AJSGMxksKViuv1ipqDFFc5vSwLUIG4rotaE6pcpcIsacdqw/1+n0/h0+lkXPfj8Sh8tkhhJcKseDQNqOfIu75TJazkEufzmRbkLqHN2WyGXsQWXkJh7G0ZoLotAtPpFK2YMZUThKH0FoFNoSnwybqqW2iFNdPNP57Q5XJJXMdqPC3CMnfJAj6VxNwNSzUrLZF4BUVixFNNrQQ+LbnWBYjDWrHQa4PwmWYzQlil82IafPMEUznuxxHC9XpdSqeI8oknLPJjviEeIZzmv0WUT0CYEcIiBYmpHCEsUpA9SKUzkwVMCNhAsH2A9+MI4bSuT1FdIZ4QlgjxM6tEGN5aVsnmBT/lmFsIFRZNOazeIuMz74qi3ZRFMCWFIYcosmfMiwEnp9J7+GMCDO+jA1L0EcJgMKCyFHez2dBIeilSlwXzotuwaSGT+fmHsMx/03q2eQDPh0KUT12xLZrx+5zmyxQ2rS7saEAQyi6IvY7jRK7DwovbZL9TCcPbQljbbreh47PtG/4WbTRwP3MlFqbYpwhAEMIUDDg50kE408zR33UbhtzHrbrjXf4nsFwu6ceHqz4q4CEq02BGf/gf3w4QNSQsyoNlBWmRwKIEQ0hYlAebruFUIdqeQeEwSsjeqAqMRqOa53mJWQeen88P2A0QoFmIg1BkWZaxD4xygxDyH4fGeFdUvAAzAAAAAElFTkSuQmCC"

/***/ },
/* 1031 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAAkCAYAAADckvn+AAAACXBIWXMAAAsSAAALEgHS3X78AAADG0lEQVRYCe1ZPdPpQBRe92oYHSW1VktLq9b6BxQKijQUCsxoaClR0lLSRokSJSXKvfNkkkyy+dqsr7zv3GfmzCD2ZJ+czz0JUUoJL6rVKs1msySdTpNIJEKi0ShJpVLker2S0+lE9vs92W63pN1uh7iVMsA9MpkM0eR+vyu6gfP5TGRZJrVajV8/CHpJpVKh8/mc8mK9XtNOp0N5dGsyGAyoLMtcdzgej9z6Pf/QbDbp5XLhJmfEcrn03AQeHi8xEf2uLtpqtagkSaLepgDutVgsFFdjAVfP5/OKq4sCIZHJZJxd1s1yt9tN6Ml+GggJXy4KtxF1y29hMpnYkgzbWRXZKx6Pe7qe0e0SiYTnGh5AJ9wOgs/QWy6XPVcWCgX7C6LWY7OYnyzrBrvEoVrHE3ZW/MMSRp17hSVEsdlsLCtLpRJX3SsWi0odNf5mIYg/fROSJAk3CcjGyMqOBMfjMXVK2ehSjPJ4PEzX0c0Yr2vdh190u11L3ZpOp9R4H5QdTdjyA4ImKxr91SP2uLsSiBqjvoHShK5G0zMajUwqUL6M92GvUyYWTXXPAx8h6AbVAJZ7sYZBK2dJMrlcTsilPgm7BARcLhfTdxwAGo2G4qZ6HUTtCwIQU7PZTN80NlsqlfTPdrD7XecDM9brdd/u8q46aFfL1FZMARuDTjVyt9tRPQbtAtUL7yLoEtc6EGMgoMaaq66wm+mDCt794jSkJJlkMhkYKsPh0FIHUZ9FdCkPAmYM0rEIbmeMM4SC6P4QNtqBV+gJBR0oK39jsRj9CTVQBCg5lmb7t+E/wZ+OX08wzJ7rRKHNUdjGVwQYJ6KGvaQ/ZtugZ+vWK4V3FuMEtHNPEQQ5DKneQc7tQOuboNp5+wK6i3eTe7aRxzolyWDO4QcooL1ej/T7feEBkR8Ui8WQ02HXDXqhPxwO3IvwMEDumemXCHK5XGi1WvlaiaTHO49RgNnHp9zSSXgTjza/0RV5HR5xXT35f42cJjwktcmAvsjtbRLe333bcqxgtOi0X+NUzbQQJI0ZFQqc3toEQeBR7H6ROXVjUEr+AXCN1JwSxT5bAAAAAElFTkSuQmCC"

/***/ },
/* 1032 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA0CAYAAADBjcvWAAAACXBIWXMAAAsSAAALEgHS3X78AAAED0lEQVRogc1aP0jrQBi/Wl1c1UFQeLo4uHRxsNMDQRd11LWLi0s7ODjZPN1shyxVcKngYhcHM6iU0hasgotCLdiClaeCQuvgoINV7vGF5FFrWu+7u1z9wUFJky/55fv/XTyUUqIaKysrYb/frw0MDJDe3l7S19dHvF6v+RTPz8/k8fGRFAoF7ebmhpTLZRKLxf6gHxGIqVyrq6v07e2NsqJardKlpaUw9hmVk3p5eWEmZSOZTNIfSywWi6E0VY/393e6tbWFIqeEVDAY5CLUiOXlZWZyHSrixvj4uBQ5Pp+P+VwlxEZGRqTIwRBTEu5rtRrt6uqSJc7DdJKiPCbzJkzElJhisVhULkcJsaenJyly7u/vmc/ttH+EQqEwxjlZUS6XM4QQzefzad3d3dxyXl9fSTab1SYmJtgusON+LpeTkmsacX5+buaeeDwuJMe6HpegI5GIfEYWoNqwEjS5urriklGpVCi2KDB9bGZmRqb1fQKE+bm5OfPQ5uYmubu7Q8tIpVLoa7z9/f3pqampX+grERgcHCSXl5dapVLRDMPIgK8NDQ21vGetViP5fJ4cHh5quVxOm56e/ou6Ka958AJ8LhgMhqHu29/fN9uSRhwcHPw3X97lAR+QWBUwAfIRmKWu62ayhXbGjpgQ0u3jIvBQRaWHEy4uLswF3XIkEsF3ya3QzKLy+TxdXFxEd66lUknIVC3XEG6VHIlZdo8Wtru7K+yDsog5llTxeByt+VAoRN1MG2g0vjGeZCizcnFNY8lkMoN9ORC2/X5/WxTTDJ+IQaF5fHyMIra2thaenZ1V8aw41JsBttCEBdqSCelR8fb2lkvg9fX1jyRmmiKMlDc2NjSstvf29ujw8LA7piQKipzX2Uu0v3JbY4RHEBSoPKNqlcQ6CoUCWueQiEXafBXoOD09/Y25z/r6eph57tAEHx8f7lPDqvjs7EzI1MCEW0VSV2vFZoB6cHR0VOhFGoZhdsduoxMjH0xQxLdgvjg/P+8pFotNe0AYI7T6nxFZZtWKtiQPDw+QVsz+TsE4IsNECjbtRFGfK38EMeiinQYuGFj1JFFJ7NvgASVTT08Pt7FDoOCZCwrjO43B7EMER0dH6UaZKjTWMipGo1H4FEHo3aXT6czk5OSnYzzTYDRaaUvUt+wNiXaspj5mGAYV8S1AIpFwWy/N4fQ2d3Z2uL/JoFbZpOt627RFnb7zsJKoEHhGDLLXF1OEj7ZEUK1WSSAQEJ69i0L6HnSpVFJOwgmoIpgFY2Nj5OTkhMJGAzSxuq7L3WxgRaNtR6NRYR+rh1Vntt/HZGNhYYFsb28r36pynRhsKgYCAejFKFQybt/PxhcfgzF3qy9gYKMOmkGe5A1DoEQiQaHZ5HpaVhBC/gEKpKZso46GkQAAAABJRU5ErkJggg=="

/***/ },
/* 1033 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA2CAYAAACMRWrdAAAACXBIWXMAAAsSAAALEgHS3X78AAAFd0lEQVRogc1aPUgrSxQefU9QmxSKlRaCqI0gQgqtAklhY2OROrWNASNoEfSawkIFEUwjGEtjmTSCEXLFn0aIpYqVsbCIhaAGtNjLt+xe4jpn5sxm9b0P5t7Lze7MnDPnfHN+tsWyLOEX8/PzS/39/WJsbGx5YGBAhEIh0dbW9mW2t7c3e5ycnIjp6ekW3wuaAIKZjtnZWatSqVimWFhYsPys52cYv7SysmK9vr4aC3V/f/9jQhkLlsvljAVysb+//6OCtXKtNpPJWPF43LfJX1xcBOxEavzLeQhCzc3Nic7OTunvHx8fNjFUKhWRSqW+kEMymbQ2NzelpLG4uGj19fUJjMHBwU+/PTw8iFqtJm5vb0U6nTYjHc6xOv4hBfxtdXV1ycRMQD4wa9W8XtRqNatQKLAJSPsAJlMJBTIxEQrz+SGfxjUxB5TjWzC8rNrE9vY2Wyho2uSEdMAJqpSq3MzZ2Rk5falUYgu1trbW1Cmp4DC1mWDUZqCt/4NQlsIdyJAqm81aMzMz0t/29vZEIpHQshQYL51Ok2zq4unpSVxdXYmbmxs79HIxNDQkRkdHbcZUAe9sbGx8Zk5K046pSTXEPa3r62ultuFzlCl5T10XwsGKGgnFeFOO32mFciINEg7bstmUM2ej36smkoITGkFzjh9KwTklU0ty4d5z7JDKRbVa1T4Dv+jq6pL+dnx8zPJPCtFotOX8/Jz8PRaL2X8bC8bB1NSU9CkoBRtrdv6DgwObcGQYHx+3/5cUjHpRx3CAl91c5PN5MwkIIO4sFovk/tbX180Zjev03njQmc+XX1GD8mPs0dhJ/WwQFygoO2jBqD3iaiBfUiWVugDU70ilUkZZArVHKJ/0MUQCFKLRaCC+4kU8Hl+uVqtWPp9nVZiQq5FQaYS67RF9fEdhpjH6h//osgfHvKUnplzImViK7yjOvL+/S/2FMn0qElH6mEyLXnDDK85wInRSibIInlI8WFF7QavunomJCdxZVjKZXPLpVp/mooDoHpkGsoXGR2R3pYt/QqHQ0vPzc/n09BThTqRYLEZisdjvhgV/bW1tieHh4Uh7e/uXCbq7u8XIyEjk8PBQ7OzsRCYnJ39L1tHi8vISpxDp6emRPoqLNxwOi93d3eVwOPzL3VsymQTRle/u7sqPj4+Rl5cXYYdchUJhyXuUIAdvhgw71xV1gjJJXQmBcyeKo6Mj0k69D0M4qlzgMGgg/qZax2IGCWRdQ0W1uBi96X4zqQglnOrkdNUxkjxUjom0I5PJ2CmI+xwC3yCBQBclCAoqsrFBnRg3tsNFXS6XAz2txkHtT3ePGvnYfzFU95sqZm2t1+vLspPUVYb8oFgsWqh+oZbPfR2VJ8otent76RdzudwXuudoxHQ4seUnU8KVApLSreMnN2ylMmURcBTvLRfAIjB/IpHQvotuiylaVcUZLOwNY/wAbSiKxdA3o1pMTUF11FYAKb3qPuKmP1THR2WK9h9UXuMClOvH33RNeG5jg1K86kr6+w9dCRnaNalb6GI+b0laNaimBquNpKveuoACVBPiN1Wcx9F246ByLl3Q/WVT3JYPlAABYOcYMCtuY8+kt0aZoS7olmr8O/tZJlm3qjShC7qNmeynhFK1iTm5n3Jijq9w4DbEuULp+tWcubSLwMk5pEJB1wQ3dQUum7IWs5zk0sQ88azpZ0Yqn3LBZVPjz/oQHuELGhRxvNF1vV63E06EabIvdNz3Ozo6Pv0f4ka336wCElt2G8pEo0EMv4xrckUYmWIQQ5U0quCnnvItHU0KpskrEsxsNuuvtfuTJ6ZrjDcCEUczjY8fFYzDqgiVgmgSNvWxsylQPsfXBLIvCsCopVIJbFpueiEhxB/igQXFW7hY1QAAAABJRU5ErkJggg=="

/***/ },
/* 1034 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD0AAAA6CAYAAAADZ1FRAAAACXBIWXMAAAsSAAALEgHS3X78AAAD7klEQVRoBeVar0/rUBS+PILBDoFBEwIJQyBwJENgZhDsL8AUAQIxBHRAwkgYcoghEBgQMyAheTVgMZAwBCS0ji3ZSIAEc16+ZiXd0vXnve198CUnZbTp6bnnO/f8aPuIiP02/EnS3lKpROvr62rcehM12jAMpihKIW69idNb13W6ublhuVyuLy6diXoaeHx8ZNlsli0vL8dG88SNrtVqbHBwkI2Pj8emUwpPA+l0Or7YRkwnLbe3t/T5+UnFYlGN41mkMLpcLhPw/v5OKysrJFpf4vRmNoojthcXF8UrlMHTkGazSRb29/eFelsKTwONRuP771wuJ1SXlEaPjIyws7MzYVWTNEbruq7Zfy8sLLCjoyMhhktjtGEYHUYPDAywpaUlsynhrUsao+v1uuP/RcS3lDFtB+J7b2+Pb10uS8qCvLy8kBPOz8+5pjBpPM1sRUo3pqenueqRymh0XE4YHh7muqFJZfT9/X2h1Wo5nlMUhR0cHPCJbZliGtKOX0egIcnn85HjWypPMxeKs3ZDwiWFyebptrgiakMi5dy7VqvR6Ohoz/PI6alUKtQgcXV1laSjN3NJXRZSqRS7uLgI5S0MIaWkdz6fV70o/vX1RScnJ4FoXq1WSfhYJoo8PDx42W2ivUCeuqyRFCAlvZkPiluYmpryvAZxbN/1pTXaLXXZMTk56Tk6zmQy5j7wDZkp7ofeiG23gqV9rgPmid3dXSnj229cY24e5B4mvd/e3gqNRoOQH5EKREwrwsBvXKfTaceGZHNzU3XM9/ZVwRsG1L5WX/v8/EyaplG1WlUrlYqK82tra7G8hSCfqcsC6vJSqdTxbJqm/XW6tqdClHr2WXS3gsvLS9re3hYeFn4pTl0NCY6I90BGW57HjbwUIaZOT0+FLIJb1+UEK77bx+BGQ/Bu6erqyrdSLAIelEcLaDEuKLwWynfDsbOzQ3jP5NYIdAONAfItNiQci8Vi2K8N+G6sQVf++PiYvCjfC/V6PRQLXl9fQ+mL7Gk78KnEzMzM7Pz8/OzQ0FCoxf74+DCZAMHM2zCMwtPTk/m7XC5v2a9FfPopN/0icj99eHho1rUdZV5E6Lr+HRI4ZjKZQjab5felAo/NBptd0F02CHjTm2t6Qay6pQpZIGRchBQ3NzfH/b68IGxGhhoeLR0mmNKBN8W76X59ff076N0NfPQ6MTFhNvxjY2Osv78/Wd+L9LSTVCqVxD0du9EQNCZBuqcfYbQlUUra/9ZoCtHF/QijLbEG8b/KaMjGxoaKiUyvicePM1pRFDWunC7NW8u7uztCLo8Dib/hQGuK8XNcBptIis4oUZPK1YnEbtwpqgNE9A/Py2aJ3rE8sgAAAABJRU5ErkJggg=="

/***/ },
/* 1035 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAAAgCAYAAABD9mvVAAAACXBIWXMAAAsSAAALEgHS3X78AAAFJklEQVRYCc1Zz0syWxg+3q4QLoqyIEoRWpRhUUEbI7pFBEF/gIs2bVpUUC6MbGEzXwUjGOUia1fbNm1auSiwRQq1MLIiI/qllaESCdWixVyeuY6Yjnr80f2+Bw4x48w553nf93nf90wynufJ78bMzAyjVqtJdXU1W1dXR8rKysjr6ysbi8VINBolj4+PZGVl5VdR2wTRP204HA4+EonwyXh4eOD39vb4ra0tfnp6msl3zyXzqNFo5Juamsjt7S1rs9mKs34c6+vrvMFgIEql8tv9j48Psr+/T/x+PwkGg8Rut8tyzVXy0F1bW2Pa2tpYhUIhXAcCAVcwGHQ9Pz8TjuMKMsDq6irT39/PqlQqUlNTk/b73d0d8fl8JBQKsYFAgITDYdfGxsbBt4d+MmxtNhsfDoe/heD29jZCjy90ToT1+/s7nw0Ic6yd/N6P69NsNjOXl5dp28JmQNpsNudNGmRpAJ1D01REJyYmGEyMTeFvIYkAAwtm8sTh4WHehBcWFgRj0cDr9bqoNWo0GoUSAP1pNBoh7UejUfb6+ppgOByOnPqbnJxkBgcH+4aHh/vkcnna76FQiNzc3BC3282aTCYqPVutVmZ0dFQoS5ng9/sPBB2Jg1Y7eA5eSIbX603TRTGhh3Cn9bLJZGJyzOUiyRtGaHEcRx2aqGupcDgcVO+nGkoK0Bit8SGtbET/SnY3SkJFRQVVKJP/Skfavd7eXpbmXYR+LqB+jo+PU+3FYDDIss35t9PpZD0ej3CBQmyxWHJqAy2bXq9nR0ZGvt2PRCLE4/G4Wltbs74/Pz/PjI2NURHIpr1UYP3U5iKBfLPn8vIyk5o9pepWlmyZ9n4mYF5kV5p54+tn1igtQWhFqkS4XC6qjYjD5/NRkYzrn2pOJKNsxqMiirqJxJE8USHFHhanrXu7u7t5GS9XYgPRtDrKsizT0NBA1Go1i8RUVVWFI5NQMyF21MylpSWqGofa29PT0wdI9agivr6+yMnJiXAgQKNOkyeg846ODrajo4M0NjZmfVaoo+h8EJKog0jnsE4+NVVqYD6ptk8KWBdtYj7zb25uUs2d7FGheINYIT1n6sAcR0dHOReGMeNNQ97z09RfSaLFkhM9CM9kA6IFz3AcVwhBphCCSYal73VFzM7OChpGfVOpVGxLS4ugYxGoZTgMv729Cbq+v78nT09PJJ/D+NTU1D9arbYPeQL9tVarJeXl5dR7RB45PT1lsQ/0zna7/VdOomjEdTqdsCCEj7/JEE/76JIwOI7LedrPhLm5Ob67u5sMDAwQ8eBOCyQzcUh9cZAkKn4WaW5uJl1dXaSysjLxGzx1fn6eIGYymQomJsJqtfJDQ0OCIfMBjHx1dUWcTifCO+s+EkRFcrBo8oL4BHJxcZEgZrFYiiZG4t6DIbFWvgRh6IMDoWJQ70WGjItwVCgU7Ofnp6AxnAtR23CN+C6EiAjoTaPR9EHTSqVSOMvW19d/ixIpYH3U7bjmXfj2hH3hXiF7+pHvuouLi4nQ1+l0ROqQLQWQQNS43e68vEWDkhEVySH0UxNWNqATOj4+FsKxmESWC0URBTm9Xi+Qo82SYmYspd5pkJUoetXa2lqCuolznlwuZ6EvDKneFboSdYTsHIvFWNRQ9Mq4LvS7bsmJIvO2t7eTzs5OgjDM5SV4BaEHD4HcT4ZesZCh5xR1lfF0HicFMmdnZzhl/K9hVwrI0EOCqBQp0WOlaAp+N2Q7Ozs8ahyIgdTLy0vJ/kn0x4AQ8i+MRvdKvj7R8QAAAABJRU5ErkJggg=="

/***/ },
/* 1036 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAA3CAYAAACRvGMdAAAACXBIWXMAAAsSAAALEgHS3X78AAAD6ElEQVRoBe1Zv0sjQRgd7xTRxsLGRkQbCy002h9H/gP/DAWTQlFBmT2bBNKokBQptNDCxsaACPHHprAKRDEgKhpRIQhGSKOCUeZ4SyYs3u5kNjcT7yAPhoTM/niZme99b75pYoyRr8LExATt7+8nw8PDxsjICGlvbyelUolcXFyQs7Mz4+Hhgdzf36cISNa7jY+P0729Pfb8/Mw4zs/PWTQaZU5c6k4wEAiwbDbL7FhdXXUkx1vdpjsWi1G/32/09fURTGM6nTZubm5ILpcj0Wj0l/Bm3SMXiUSsqQQKhQJbW1sTjlrN0z07O8s2Nzetl/G2tbUlfBnW3fHxcWVSTdP0TE6K5Nzc3I/P68eOYrHIdnZ2GAjxe6ampujGxgbN5/PWn9ne3maLi4u0VoJVSdpHQgREKoiCEIdbpColiSl+e3uTIgkcHR1Zn3d3dxg5ZQSFJPlLZQHNUzl6UiTtQiuDZDKphSDaNzdpQoryAq/Xe4EryaenJ08PQs6tO8lUKuXpQbe3t4YKQk5wJTk2NtZUKBSkHvLy8kIymYwujmKdRJaRQS2pTkl0o2UyGSFFaCJys06CzMkFTU9P06GhITI6Ompks1nz8PDQ7OzsJHAv+OTI5/Pk9PS0uoNRPd3Iu9BHpDn4Pt0jVNN0Q5DrMX01kVxeXqbr6+t/7VZ0teZwOMzglCcnJ5u0r60a8X1wcJAsLS39/FcJAlX3OLFYjPn9fnJ5eWltNTkQ7QMDA2R/fx8uXO8syKwjiDVcuB2vr6/aRdwxukUNkgTx5ojH43VTgS+tYMjC1WA0SHrEf0GyWdQ5Pz9PPz4+SCgUcjQRwWCQtrW1kY6ODuwu9RkNUVTF43HKoxklEnsF4/r6uhLpMCRa06LoD5ycnFiuG5ss2DS7VeNAfyKRIBD8LxlJVi4S2PXRDtg61YWAmnUSaw9G2OfzGa2trdZvV1dXJhCJRLSb3oaYq0KDpCq4kkwkEpYVk3kPPOfu7q62xe2qk9DIhYUFfGXc7ML4crS0tJDe3l7S3d0N04tCvS6OYp08ODiQqmA8Pj4ywzC0beKqXlCtmFru1yrmUhehgutUVC3XyLUSlM44HOFwmGItAqi4ubkj1WhkHFWokAwGg0qHFKZE1bMqOlkqlYx0Os1QK8/lctZZc7FYNFdWVqTq0jMzM7Snp4d0dXWhcGD4fD6TEKJmzdqjyO7EWdkvIoKReZxKgfCS6OcHnHYXbz/KUypBgUCAej2/cYLq8uEfP6D8hzqllyM74P393Tpw0lE+dO3AVH6u/4igU9iFnaFQiGJ9icDXrS6CVUmW16kVOJ+Dg5PDRk0nQcYY+Q0MO2+HL7UnHgAAAABJRU5ErkJggg=="

/***/ },
/* 1037 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAAsCAYAAAAwwXuTAAAACXBIWXMAAAsSAAALEgHS3X78AAAD1UlEQVRoBe1ZPUgrQRDeiI22WlhoYWNaCy1Mq21q29RnEcEUSXEkzxQKWtjEQguv1MLGgJWCr1AbIZaehYUJKBhBEC1E2Me33Cx7e7sXg7z3OLkPDuPu7M/sfDN7M8d4DG5ubtDJbM/R0VHccL6xsRE7/rtPsL84nA2wH45UwaQjVTDp+PEKDvq+b+3sdDosm81a+5+fn1nc+ImJCdZsNrmt/+Ligq2trWVs/Z7n8ZGREev8w8PD1j6Jv3lPffee/MI913MPqQ8mHamCSUeqYNKRQSi26YB7cH5+Pvaempubsx7B9fV1z7tqamrK2of139/frf35fN66N4n/mQ/+i3wy9cGkI1Uw6UgVTDoyCKU/GSlFk45UwaQjVTDpSBVMOgZ3d3f52NiYKOIWCgVjAlmpVKq5XK6G36enp2xraysit76+zicnJ0WSayvmLi0tVWdnZ2tqMRcJ7eLiopCv1+t8enqajY+PRxLl29tbKbu8vMxnZmbY1dWVcS/b29scRWff93+zp6cnmWCWy2VjgtlqtaRMkKRGZB4eHkR/t9u1JqnHx8fGxHZvb49/sdArkuD9/X1rQlwsFvnb2xsl7GcDo6OjUvN8Pm8kpFpWMJUYNjc3BQsAWAelDF0Gp76wsGCcnywK68cBFiyVStJiuVwuIo0SClkfJY9IyWJnZyd0Kufn56F+vYzhOE4V1nt9feVkRfxFuyp3eHgo+l5eXrjrumKOUqlULZfLVV0Wbbb1aE3M8/HxEbIi5iPrgZnFYrHAFFoJQABmxoCAOtLkpgWJLqAxyQNBu5QLNiLnw8Gtrq4a6dxLQfXgVZc4OTmJ0F5E0W63K770sOCLDRxdpSwc3AaiyePjY4hiOn1ALerHGuh3XRfBjVcqlb5Tmk6nI4Ie6A0XQRvtG1SmteQ10Ww25WAopn66ur+/Ny6CqIdoBbTb7RoiGk2Mdn3jnufVcJBqKRBrOI4jfLQfBe/u7uRv+DaUVH1ZRleVBrYo1mg0jBTV/VOHTlONhiHqq9H5KxSFHxpcR0ClfuiiV61IwP0I65hOkShhg0pTWLter1fpf9yV7Xa7H6OF0Gg0fqkuQR9qMafrujLShhSEn0AhFeSbOkBhCsf0pZcemgM0hWIsoP3KykrN931OD9GbNtYv8NKhQ99v5FVNt6JNQdV6GJPNZjP0qHPAivBFyONAcNL00AHhUBzH6V2G1wBL6QdzeXkZVhCTiwsxAF7XYHq0Y6Og0ufnp7QOZBEQhoaGZJt+QdN4PJDDHJ7n4W0nJIdgc3BwIA5HbdfXiwP2SLL4HXp1Y4z9AeegkhOfj4hNAAAAAElFTkSuQmCC"

/***/ },
/* 1038 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAAAYCAYAAACr3+4VAAAACXBIWXMAAAsSAAALEgHS3X78AAAA2ElEQVRYhe2XsQ2DMBBFL1EaJmEG2IEdPAQNFU7NEOxgD+EV7CHcQkl0Ee2dLSVRpOOedNXnvvxB1hdwMDjnUARqlmXh1t+cz5Ae35jznBz2DhdBg0pDg0rjMkEf3ntSTCnBMAyknnMGbh9p2xZ9DkoPIVhjzJPz4PaRbduK5/hpv9V0nHNurvD5uKv1jkpDg0pDg0oDe5TsKOzRcRxvlD5N09H3ffGVoA9F0zTWe28pHbu66zrWf9/38mf59//ouq4ztx9jLHZkzegdlYYGlYYGlcY1ggLACzkEcysXFwqAAAAAAElFTkSuQmCC"

/***/ },
/* 1039 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAAAgCAYAAABD9mvVAAAACXBIWXMAAAsSAAALEgHS3X78AAADcUlEQVRYCb1Zv2sqQRDee8TG/yGdaBuLNGkiWNtqa51GCwstgqeNhVcYwfpEKwUbAyFFBFMkTQoNqCiIiJWggaTQQBD2Mffu5Izr3f7ifTB4d7pzOzs7M9+OCsYY1Wo17PP5kCj6/T7y+/3I6/UK63p9fUVXV1fCegDL5TKHwNCXlxcsitVqBRpQsVgU1vX09GToarfbwroA4/FY/SNlyRBCw+HQ+EylUgp4lhfb7Rbd398bozudjnEvA9IMfX9/V63rRqPBPcFms4lKpZIC1/BpLaAopBgKRk0mk/19oVBQwBus+Pr6QvF4XLEPGw6HKrMiAoQNhcmVy2W1Uqnk7M8fHx/V+XzOpKvT6XR/P3t7e+vaF5EbosnITD6IJLquZ2n1bDYbnEgksiQ9iUQCr9dr7jlCMhIy1BxHNNKcILWhZoY9qatSqXDNEYsaanrAcXK0JcL0lqMekPF4zG0od4xCCbCyo0vcoY+PD8ffQJamQbVa/b8x+vDwQOUBS25vb7MmoThCq9Vi0lUqlYzdxOpRZkMXiwXTxCxJp9NHuiwGxCqs8cq1dQeDAdfO+V1b7QyIFTc3N8p6vWYaxWzoaDTiLuBgmMWYaGP8FJhpJsvWpc2OTqLrOv78/BTWo2kadeli2rrL5RKUC9MxoHjNZvOIAbFiOp12n5+f6UfReBSynJlMhLxgsRw3osEivV5PnkchiUAyEfUCIBwOo8vLS5RMJrEMfdQnJTePyohLUonhLS0kcWNfVB7VdV3GwhuIx+P7a/BsJpOR4tVIJKK4sS9HQ+F4BB0DGZPRNA0HAoGDZ3bDReHqkFNbFyjbqWMTTyk4Rdu63a60LVyv1/FutyNu3ZOGsnJQp7h046ZuRzQWIZ1wHGO03+9LaWHEYjHX9ifEq6wsbO9d2UE0FGIzn8/nSN+xIJPJZC8uLlxHwEJEo1HR1xno9XrE50RDhc59NgSDQerfQrMaFkb0nYVCIUfiwQeGQuG9u7uTQg6SyWQ2FAoxbf/r6+uQ6HvRP0epR6csezICwi0rKfC0Z35+fqjaM7RiNdQOkhHE5e+eKi+gZvL8b+LxeIzEJAsHtdVa/Xw+L20lzS4EN2QdILBJ+vcenc1m0NeR4s1Go4HPz8+FdMhkTED6v7+/0RncyPp/AwA0T0ZnHXiwjKQIOjRNU/8CPJ8QrtGXDeUAAAAASUVORK5CYII="

/***/ },
/* 1040 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAAAWCAYAAACR1Y9lAAAACXBIWXMAAAsSAAALEgHS3X78AAADu0lEQVRYha1Yr08rQRDeezwDAgMCAQJDBaaChKQC+g+Ara2uaQUkrbgUqKiAJmcOASQgqcAUSxMMkIAohgSQgCABBCQUgVjylbtmezezu+17X7K53P6YnZlvZnbvnKOjIzk7OysofH19iWQy6VBju7u7cmFhgVwHnJ+fi6GhodP5+fl0dOzu7k4sLy+TchuNhkwkErH+7+9vsbe3t+Z53nqpVCovLi6mp6en0yMjI2J4eLg77+PjQ7y9vYmbm5u1q6sr4fv+emfg7OxM6uD7PkZFtL2+vmrXQWHf98vceD6fj8kN+kgEeor9/X3tviqgY7FY7Kz7w1ISgPJupVKRY2NjpqXi+fmZHZuZmbHqC3F9fS22trZkNps17hsCOuZyud83E6MBcz2ePzw8NHoTjGLu5+cnOX5ychKTG/TFEMgQDw8P1myq2NzcPDUyCq+USiWp9qVSKWuvggkKyWQy1kv1hTKgw9TUlPW+KhCVRkOjCvS7IWdo1IGFQqHMpQMKGze2vb2Nh1MoFES73SbnICX+2iir5inndQ65XM5pt9sS1TEKVdbExAQpARV0ZWXFQX5S46Fxnuc5zWZTTk5OxuY8PT2Zc1QqOdJPnoQ5isbt0Wq1unN2dnbICh3J5RhQQ1CJqSquNqvQBRvwKMJrkDyxyVOOUYStTg5CGpXYdV1xcHAAHUnmSW9TrMGz1Wo15nXuPFUZ1VXf8Jy+vLwk2VJlbGxsSE6OuiY4a82MIu5xq1AxNzeHpE5H57VaLZrGCJrNJtkfVnAqUo6Pj3veXdd1arXaGljmCk/I8Pv7e4ec1dXVMsvo7e0tzp5Y/8vLS8871gbMGRnV3XqovajzW23FYrEMPU1ABOTz+VPWUF24hUCI2BqKFhQfbr8eUBcKqsFJJoMbjYb+wnB/f68NR67I9DufumaqRUj8hjGKTKzh6EkkEk69Xmf3xTmqNRRfGRweHx87Z5etkaIPx+DsRD72IzuTyTicvsabkU4xE9sU4BgbY6NsisCxFAKmcbOS4+Pj5Bw4QGtotVp14F1u8SD434YuLS3hIT3PY6+JgPHCwCmGq51pbT/yQsAgODjajz7OWJs9jYZSzA3KprAIX4rNENxZrAPO24uLC7OhFHOD5KcKnaG6sWw26+gcEQWMrNVqcG7a6q4bZfBfGBUaY7iwVZFKpRzcmPAPSQc4pFKpdKu347quHB0d7VmCn2Jqecd3o/o9iLOLGwuBIqZTGr9j1J9aNmtU1Ot1mclkul1gD46CE9F65AghfgCpYV5kf2UyAQAAAABJRU5ErkJggg=="

/***/ },
/* 1041 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 1042 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 1043 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(1044);
	
	var _global = _interopRequireDefault(__webpack_require__(1222));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	if (_global["default"]._babelPolyfill && typeof console !== "undefined" && console.warn) {
	  console.warn("@babel/polyfill is loaded more than once on this page. This is probably not desirable/intended " + "and may have consequences if different versions of the polyfills are applied sequentially. " + "If you do need to load the polyfill more than once, use @babel/polyfill/noConflict " + "instead to bypass the warning.");
	}
	
	_global["default"]._babelPolyfill = true;

/***/ },
/* 1044 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(1207);
	
	__webpack_require__(1211);
	
	__webpack_require__(1210);
	
	__webpack_require__(1217);
	
	__webpack_require__(1216);
	
	__webpack_require__(1219);
	
	__webpack_require__(1218);
	
	__webpack_require__(1220);
	
	__webpack_require__(1213);
	
	__webpack_require__(1214);
	
	__webpack_require__(1212);
	
	__webpack_require__(1215);
	
	__webpack_require__(1393);
	
	__webpack_require__(1005);

/***/ },
/* 1045 */
/***/ function(module, exports) {

	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;
	  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
	  return arr2;
	}
	module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 1046 */
/***/ function(module, exports) {

	function _arrayWithHoles(arr) {
	  if (Array.isArray(arr)) return arr;
	}
	module.exports = _arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 1047 */
/***/ function(module, exports) {

	function _getPrototypeOf(o) {
	  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
	  return _getPrototypeOf(o);
	}
	module.exports = _getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 1048 */
/***/ function(module, exports, __webpack_require__) {

	var setPrototypeOf = __webpack_require__(486);
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      writable: true,
	      configurable: true
	    }
	  });
	  Object.defineProperty(subClass, "prototype", {
	    writable: false
	  });
	  if (superClass) setPrototypeOf(subClass, superClass);
	}
	module.exports = _inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 1049 */
/***/ function(module, exports) {

	function _iterableToArrayLimit(r, l) {
	  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
	  if (null != t) {
	    var e,
	      n,
	      i,
	      u,
	      a = [],
	      f = !0,
	      o = !1;
	    try {
	      if (i = (t = t.call(r)).next, 0 === l) {
	        if (Object(t) !== t) return;
	        f = !1;
	      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
	    } catch (r) {
	      o = !0, n = r;
	    } finally {
	      try {
	        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
	      } finally {
	        if (o) throw n;
	      }
	    }
	    return a;
	  }
	}
	module.exports = _iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 1050 */
/***/ function(module, exports) {

	function _nonIterableRest() {
	  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	module.exports = _nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 1051 */
/***/ function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(27);
	function _objectSpread(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? Object(arguments[i]) : {};
	    var ownKeys = Object.keys(source);
	    if (typeof Object.getOwnPropertySymbols === 'function') {
	      ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) {
	        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
	      }));
	    }
	    ownKeys.forEach(function (key) {
	      defineProperty(target, key, source[key]);
	    });
	  }
	  return target;
	}
	module.exports = _objectSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 1052 */
/***/ function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(129)["default"];
	var assertThisInitialized = __webpack_require__(22);
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  } else if (call !== void 0) {
	    throw new TypeError("Derived constructors may only return object or undefined");
	  }
	  return assertThisInitialized(self);
	}
	module.exports = _possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 1053 */
/***/ function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(129)["default"];
	function toPrimitive(t, r) {
	  if ("object" != _typeof(t) || !t) return t;
	  var e = t[Symbol.toPrimitive];
	  if (void 0 !== e) {
	    var i = e.call(t, r || "default");
	    if ("object" != _typeof(i)) return i;
	    throw new TypeError("@@toPrimitive must return a primitive value.");
	  }
	  return ("string" === r ? String : Number)(t);
	}
	module.exports = toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 1054 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeToArray = __webpack_require__(1045);
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;
	  if (typeof o === "string") return arrayLikeToArray(o, minLen);
	  var n = Object.prototype.toString.call(o).slice(8, -1);
	  if (n === "Object" && o.constructor) n = o.constructor.name;
	  if (n === "Map" || n === "Set") return Array.from(o);
	  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
	}
	module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 1055 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gud = __webpack_require__(2021);
	
	var _gud2 = _interopRequireDefault(_gud);
	
	var _warning = __webpack_require__(319);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MAX_SIGNED_31_BIT_INT = 1073741823;
	
	// Inlined Object.is polyfill.
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	function objectIs(x, y) {
	  if (x === y) {
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function createEventEmitter(value) {
	  var handlers = [];
	  return {
	    on: function on(handler) {
	      handlers.push(handler);
	    },
	    off: function off(handler) {
	      handlers = handlers.filter(function (h) {
	        return h !== handler;
	      });
	    },
	    get: function get() {
	      return value;
	    },
	    set: function set(newValue, changedBits) {
	      value = newValue;
	      handlers.forEach(function (handler) {
	        return handler(value, changedBits);
	      });
	    }
	  };
	}
	
	function onlyChild(children) {
	  return Array.isArray(children) ? children[0] : children;
	}
	
	function createReactContext(defaultValue, calculateChangedBits) {
	  var _Provider$childContex, _Consumer$contextType;
	
	  var contextProp = '__create-react-context-' + (0, _gud2.default)() + '__';
	
	  var Provider = function (_Component) {
	    _inherits(Provider, _Component);
	
	    function Provider() {
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, Provider);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.emitter = createEventEmitter(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    Provider.prototype.getChildContext = function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
	    };
	
	    Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      if (this.props.value !== nextProps.value) {
	        var oldValue = this.props.value;
	        var newValue = nextProps.value;
	        var changedBits = void 0;
	
	        if (objectIs(oldValue, newValue)) {
	          changedBits = 0; // No change
	        } else {
	          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
	          if (false) {
	            (0, _warning2.default)((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: %s', changedBits);
	          }
	
	          changedBits |= 0;
	
	          if (changedBits !== 0) {
	            this.emitter.set(nextProps.value, changedBits);
	          }
	        }
	      }
	    };
	
	    Provider.prototype.render = function render() {
	      return this.props.children;
	    };
	
	    return Provider;
	  }(_react.Component);
	
	  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = _propTypes2.default.object.isRequired, _Provider$childContex);
	
	  var Consumer = function (_Component2) {
	    _inherits(Consumer, _Component2);
	
	    function Consumer() {
	      var _temp2, _this2, _ret2;
	
	      _classCallCheck(this, Consumer);
	
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = {
	        value: _this2.getValue()
	      }, _this2.onUpdate = function (newValue, changedBits) {
	        var observedBits = _this2.observedBits | 0;
	        if ((observedBits & changedBits) !== 0) {
	          _this2.setState({ value: _this2.getValue() });
	        }
	      }, _temp2), _possibleConstructorReturn(_this2, _ret2);
	    }
	
	    Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      var observedBits = nextProps.observedBits;
	
	      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
	      : observedBits;
	    };
	
	    Consumer.prototype.componentDidMount = function componentDidMount() {
	      if (this.context[contextProp]) {
	        this.context[contextProp].on(this.onUpdate);
	      }
	      var observedBits = this.props.observedBits;
	
	      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
	      : observedBits;
	    };
	
	    Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
	      if (this.context[contextProp]) {
	        this.context[contextProp].off(this.onUpdate);
	      }
	    };
	
	    Consumer.prototype.getValue = function getValue() {
	      if (this.context[contextProp]) {
	        return this.context[contextProp].get();
	      } else {
	        return defaultValue;
	      }
	    };
	
	    Consumer.prototype.render = function render() {
	      return onlyChild(this.props.children)(this.state.value);
	    };
	
	    return Consumer;
	  }(_react.Component);
	
	  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = _propTypes2.default.object, _Consumer$contextType);
	
	
	  return {
	    Provider: Provider,
	    Consumer: Consumer
	  };
	}
	
	exports.default = createReactContext;
	module.exports = exports['default'];

/***/ },
/* 1056 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _implementation = __webpack_require__(1055);
	
	var _implementation2 = _interopRequireDefault(_implementation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _react2.default.createContext || _implementation2.default;
	module.exports = exports['default'];

/***/ },
/* 1057 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1058 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
		autosize 4.0.4
		license: MIT
		http://www.jacklmoore.com/autosize
	*/
	(function (global, factory) {
		if (true) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof exports !== "undefined") {
			factory(module, exports);
		} else {
			var mod = {
				exports: {}
			};
			factory(mod, mod.exports);
			global.autosize = mod.exports;
		}
	})(this, function (module, exports) {
		'use strict';
	
		var map = typeof Map === "function" ? new Map() : function () {
			var keys = [];
			var values = [];
	
			return {
				has: function has(key) {
					return keys.indexOf(key) > -1;
				},
				get: function get(key) {
					return values[keys.indexOf(key)];
				},
				set: function set(key, value) {
					if (keys.indexOf(key) === -1) {
						keys.push(key);
						values.push(value);
					}
				},
				delete: function _delete(key) {
					var index = keys.indexOf(key);
					if (index > -1) {
						keys.splice(index, 1);
						values.splice(index, 1);
					}
				}
			};
		}();
	
		var createEvent = function createEvent(name) {
			return new Event(name, { bubbles: true });
		};
		try {
			new Event('test');
		} catch (e) {
			// IE does not support `new Event()`
			createEvent = function createEvent(name) {
				var evt = document.createEvent('Event');
				evt.initEvent(name, true, false);
				return evt;
			};
		}
	
		function assign(ta) {
			if (!ta || !ta.nodeName || ta.nodeName !== 'TEXTAREA' || map.has(ta)) return;
	
			var heightOffset = null;
			var clientWidth = null;
			var cachedHeight = null;
	
			function init() {
				var style = window.getComputedStyle(ta, null);
	
				if (style.resize === 'vertical') {
					ta.style.resize = 'none';
				} else if (style.resize === 'both') {
					ta.style.resize = 'horizontal';
				}
	
				if (style.boxSizing === 'content-box') {
					heightOffset = -(parseFloat(style.paddingTop) + parseFloat(style.paddingBottom));
				} else {
					heightOffset = parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
				}
				// Fix when a textarea is not on document body and heightOffset is Not a Number
				if (isNaN(heightOffset)) {
					heightOffset = 0;
				}
	
				update();
			}
	
			function changeOverflow(value) {
				{
					// Chrome/Safari-specific fix:
					// When the textarea y-overflow is hidden, Chrome/Safari do not reflow the text to account for the space
					// made available by removing the scrollbar. The following forces the necessary text reflow.
					var width = ta.style.width;
					ta.style.width = '0px';
					// Force reflow:
					/* jshint ignore:start */
					ta.offsetWidth;
					/* jshint ignore:end */
					ta.style.width = width;
				}
	
				ta.style.overflowY = value;
			}
	
			function getParentOverflows(el) {
				var arr = [];
	
				while (el && el.parentNode && el.parentNode instanceof Element) {
					if (el.parentNode.scrollTop) {
						arr.push({
							node: el.parentNode,
							scrollTop: el.parentNode.scrollTop
						});
					}
					el = el.parentNode;
				}
	
				return arr;
			}
	
			function resize() {
				if (ta.scrollHeight === 0) {
					// If the scrollHeight is 0, then the element probably has display:none or is detached from the DOM.
					return;
				}
	
				var overflows = getParentOverflows(ta);
				var docTop = document.documentElement && document.documentElement.scrollTop; // Needed for Mobile IE (ticket #240)
	
				ta.style.height = '';
				ta.style.height = ta.scrollHeight + heightOffset + 'px';
	
				// used to check if an update is actually necessary on window.resize
				clientWidth = ta.clientWidth;
	
				// prevents scroll-position jumping
				overflows.forEach(function (el) {
					el.node.scrollTop = el.scrollTop;
				});
	
				if (docTop) {
					document.documentElement.scrollTop = docTop;
				}
			}
	
			function update() {
				resize();
	
				var styleHeight = Math.round(parseFloat(ta.style.height));
				var computed = window.getComputedStyle(ta, null);
	
				// Using offsetHeight as a replacement for computed.height in IE, because IE does not account use of border-box
				var actualHeight = computed.boxSizing === 'content-box' ? Math.round(parseFloat(computed.height)) : ta.offsetHeight;
	
				// The actual height not matching the style height (set via the resize method) indicates that 
				// the max-height has been exceeded, in which case the overflow should be allowed.
				if (actualHeight < styleHeight) {
					if (computed.overflowY === 'hidden') {
						changeOverflow('scroll');
						resize();
						actualHeight = computed.boxSizing === 'content-box' ? Math.round(parseFloat(window.getComputedStyle(ta, null).height)) : ta.offsetHeight;
					}
				} else {
					// Normally keep overflow set to hidden, to avoid flash of scrollbar as the textarea expands.
					if (computed.overflowY !== 'hidden') {
						changeOverflow('hidden');
						resize();
						actualHeight = computed.boxSizing === 'content-box' ? Math.round(parseFloat(window.getComputedStyle(ta, null).height)) : ta.offsetHeight;
					}
				}
	
				if (cachedHeight !== actualHeight) {
					cachedHeight = actualHeight;
					var evt = createEvent('autosize:resized');
					try {
						ta.dispatchEvent(evt);
					} catch (err) {
						// Firefox will throw an error on dispatchEvent for a detached element
						// https://bugzilla.mozilla.org/show_bug.cgi?id=889376
					}
				}
			}
	
			var pageResize = function pageResize() {
				if (ta.clientWidth !== clientWidth) {
					update();
				}
			};
	
			var destroy = function (style) {
				window.removeEventListener('resize', pageResize, false);
				ta.removeEventListener('input', update, false);
				ta.removeEventListener('keyup', update, false);
				ta.removeEventListener('autosize:destroy', destroy, false);
				ta.removeEventListener('autosize:update', update, false);
	
				Object.keys(style).forEach(function (key) {
					ta.style[key] = style[key];
				});
	
				map.delete(ta);
			}.bind(ta, {
				height: ta.style.height,
				resize: ta.style.resize,
				overflowY: ta.style.overflowY,
				overflowX: ta.style.overflowX,
				wordWrap: ta.style.wordWrap
			});
	
			ta.addEventListener('autosize:destroy', destroy, false);
	
			// IE9 does not fire onpropertychange or oninput for deletions,
			// so binding to onkeyup to catch most of those events.
			// There is no way that I know of to detect something like 'cut' in IE9.
			if ('onpropertychange' in ta && 'oninput' in ta) {
				ta.addEventListener('keyup', update, false);
			}
	
			window.addEventListener('resize', pageResize, false);
			ta.addEventListener('input', update, false);
			ta.addEventListener('autosize:update', update, false);
			ta.style.overflowX = 'hidden';
			ta.style.wordWrap = 'break-word';
	
			map.set(ta, {
				destroy: destroy,
				update: update
			});
	
			init();
		}
	
		function destroy(ta) {
			var methods = map.get(ta);
			if (methods) {
				methods.destroy();
			}
		}
	
		function update(ta) {
			var methods = map.get(ta);
			if (methods) {
				methods.update();
			}
		}
	
		var autosize = null;
	
		// Do nothing in Node.js environment and IE8 (or lower)
		if (typeof window === 'undefined' || typeof window.getComputedStyle !== 'function') {
			autosize = function autosize(el) {
				return el;
			};
			autosize.destroy = function (el) {
				return el;
			};
			autosize.update = function (el) {
				return el;
			};
		} else {
			autosize = function autosize(el, options) {
				if (el) {
					Array.prototype.forEach.call(el.length ? el : [el], function (x) {
						return assign(x, options);
					});
				}
				return el;
			};
			autosize.destroy = function (el) {
				if (el) {
					Array.prototype.forEach.call(el.length ? el : [el], destroy);
				}
				return el;
			};
			autosize.update = function (el) {
				if (el) {
					Array.prototype.forEach.call(el.length ? el : [el], update);
				}
				return el;
			};
		}
	
		exports.default = autosize;
		module.exports = exports['default'];
	});

/***/ },
/* 1059 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	   value: true
	});
	exports.ivrBlockingSVG = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ivrBlockingSVG = exports.ivrBlockingSVG = _react2.default.createElement(
	   "svg",
	   { version: "1.1", id: "Capa_1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
	      width: "24px", height: "24px", viewBox: "0 0 24 24", enableBackground: "new 0 0 24 24", xmlSpace: "preserve" },
	   _react2.default.createElement(
	      "g",
	      { className: "ivrSign" },
	      _react2.default.createElement(
	         "g",
	         null,
	         _react2.default.createElement("rect", { id: "cuadro1", x: "2.5", y: "16", width: "5", height: "5" }),
	         _react2.default.createElement("rect", { id: "cuadro2", x: "9.5", y: "16", width: "5", height: "5" }),
	         _react2.default.createElement("rect", { id: "cuadro3", x: "16.5", y: "16", width: "5", height: "5" })
	      ),
	      _react2.default.createElement("polygon", { points: "5.8,9.3 11.2,9.3 11.2,14 12.8,14 12.8,9.3 18.2,9.3 18.2,14 19.8,14 19.8,7.7 12.8,7.7 12.8,3 11.2,3 11.2,7.7 4.2,7.7 4.2,14 5.8,14 " })
	   )
	);

/***/ },
/* 1060 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.salud = exports.queja = exports.otro = exports.duda = exports.dinero = exports.conSupervisor = exports.sistemas = exports.junta = exports.conCliente = exports.comida = exports.cambio = exports.cafe = exports.naBreak = exports.banio = exports.agua = exports.aclaracion = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var aclaracion = exports.aclaracion = _react2.default.createElement(
		"svg",
		{ xmlns: "http://www.w3.org/2000/svg", viewBox: "4904 6612 120 120", className: "borderND purpleSoft" },
		_react2.default.createElement(
			"g",
			{ id: "Group_6326", "data-name": "Group 6326", transform: "translate(4904 6612)" },
			_react2.default.createElement("path", { id: "Path_3454", "data-name": "Path 3454", fill: "#7b76ea", className: "whiteIcon", d: "M113.182,120H6.818A6.838,6.838,0,0,1,0,113.182V6.818A6.838,6.838,0,0,1,6.818,0H113.182A6.838,6.838,0,0,1,120,6.818V113.182A6.838,6.838,0,0,1,113.182,120Z" }),
			_react2.default.createElement("path", { id: "Path_3455", "data-name": "Path 3455", fill: "#010101", opacity: "0.2", className: "transparentIconBlack", d: "M6.818,171.8H113.182A6.838,6.838,0,0,0,120,164.982V162.8a6.838,6.838,0,0,1-6.818,6.818H6.818A6.838,6.838,0,0,1,0,162.8v2.182A6.838,6.838,0,0,0,6.818,171.8Z", transform: "translate(0 -51.8)" }),
			_react2.default.createElement("path", { id: "Path_3456", "data-name": "Path 3456", fill: "#fff", opacity: "0.3", className: "transparentIconWhite", d: "M113.182,0H6.818A6.838,6.838,0,0,0,0,6.818V9A6.838,6.838,0,0,1,6.818,2.182H113.182A6.838,6.838,0,0,1,120,9V6.818A6.838,6.838,0,0,0,113.182,0Z" }),
			_react2.default.createElement("path", { id: "Path_3457", "data-name": "Path 3457", className: "blackIcon", fill: "#f3f3f3", d: "M62.282,36.5C41.214,36.5,24.1,49.045,24.1,64.523c0,9.682,6.682,18.2,16.841,23.25-.341,1.5-1.364,4.432-4.636,8.386a2.136,2.136,0,0,0,1.364,3.75,38.446,38.446,0,0,0,20.8-7.5c1.3.068,2.591.136,3.886.136,21.068,0,38.182-12.545,38.182-28.023C100.464,49.045,83.35,36.5,62.282,36.5Zm3.409,45.136H58.736V74.682h6.955Zm0-13.841H58.736V46.932h6.955Z", transform: "translate(-7.668 -11.614)" }),
			_react2.default.createElement("path", { id: "Path_3458", "data-name": "Path 3458", className: "blackIcon", fill: "#f3f3f3", d: "M135.732,102.986c0-5.045-2.932-9.614-7.636-12.886a34.112,34.112,0,0,1-12.614,16.773,49.492,49.492,0,0,1-21.682,8.8,29.757,29.757,0,0,0,17.318,5.114c.818,0,1.7,0,2.523-.068,1.5,1.568,5.386,4.432,14.523,5.318a18.429,18.429,0,0,1-4.091-7.909C131.1,114.986,135.732,109.327,135.732,102.986Z", transform: "translate(-29.845 -28.668)" }),
			_react2.default.createElement("rect", { id: "Rectangle_3348", "data-name": "Rectangle 3348", fill: "#e6e6e5", className: "blackIcon", width: "6.955", height: "1.364", transform: "translate(51.068 56.182)" }),
			_react2.default.createElement("rect", { id: "Rectangle_3349", "data-name": "Rectangle 3349", fill: "#e6e6e5", className: "blackIcon", width: "6.955", height: "1.364", transform: "translate(51.068 70.023)" }),
			_react2.default.createElement("rect", { id: "Rectangle_3350", "data-name": "Rectangle 3350", fill: "#fff", className: "blackIcon", width: "6.955", height: "1.364", transform: "translate(51.068 61.705)" }),
			_react2.default.createElement("rect", { id: "Rectangle_3351", "data-name": "Rectangle 3351", fill: "#fff", className: "blackIcon", width: "6.955", height: "1.364", transform: "translate(51.068 33.955)" }),
			_react2.default.createElement("path", { id: "Path_3459", "data-name": "Path 3459", fill: "#fff", className: "blackIcon", d: "M62.182,37.864c20.8,0,37.636,12.136,38.182,27.341v-.682c0-15.477-17.114-28.023-38.182-28.023S24,49.045,24,64.523v.818C24.409,50.136,41.318,37.864,62.182,37.864Z", transform: "translate(-7.636 -11.614)" }),
			_react2.default.createElement("path", { id: "Path_3460", "data-name": "Path 3460", fill: "#e6e6e5", className: "blackIcon", d: "M67.508,103.841c-1.3,0-2.591-.068-3.886-.136a38.281,38.281,0,0,1-20.8,7.5,2.229,2.229,0,0,1-1.977-1.3c-.341,1.091.068,2.455,1.977,2.659a38.446,38.446,0,0,0,20.8-7.5c1.3.068,2.591.136,3.886.136,21.068,0,38.182-12.545,38.182-28.023V76.5C105.213,91.7,88.3,103.841,67.508,103.841Z", transform: "translate(-12.963 -24.341)" })
		)
	);
	
	var agua = exports.agua = _react2.default.createElement(
		"svg",
		{ version: "1.1", id: "Capa_1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
			viewBox: "0 0 120.1 120", enableBackground: "new 0 0 120.1 120", xmlSpace: "preserve", className: "borderND skyblue" },
		_react2.default.createElement(
			"g",
			{ id: "Group_6053", transform: "translate(5378.832 7751.3)" },
			_react2.default.createElement(
				"g",
				{ id: "Group_6053-2", transform: "translate(30.2 22.7)" },
				_react2.default.createElement("path", { id: "Path_3210", fill: "#0FC8FF", className: "whiteIcon", d: "M-5295.9-7654h-106.4c-3.8,0-6.8-3.1-6.8-6.8v-106.4c0-3.8,3.1-6.8,6.8-6.8h106.4\r c3.8,0,6.8,3.1,6.8,6.8v106.4C-5289-7657.1-5292.1-7654-5295.9-7654C-5295.8-7654-5295.8-7654-5295.9-7654z" }),
				_react2.default.createElement("path", { id: "Path_3211", opacity: "0.2", fill: "#010101", className: "transparentIconBlack", d: "M-5402.2-7654h106.4c3.8,0,6.8-3.1,6.8-6.8v-2.2c0,3.8-3.1,6.8-6.8,6.8h-106.4\r c-3.8,0-6.8-3.1-6.8-6.8v2.2c0,3.7,3,6.8,6.7,6.8C-5402.3-7654-5402.3-7654-5402.2-7654z" }),
				_react2.default.createElement("path", { id: "Path_3212", opacity: "0.3", fill: "#FFFFFF", className: "transparentIconWhite", d: "M-5295.9-7774h-106.4c-3.8,0-6.8,3.1-6.8,6.8v2.2c0-3.8,3.1-6.8,6.8-6.8h106.4\r c3.8,0,6.8,3.1,6.8,6.8v-2.2C-5289-7770.9-5292.1-7774-5295.9-7774z" })
			),
			_react2.default.createElement(
				"g",
				{ id: "Group_6057", transform: "translate(66.064 48.336)" },
				_react2.default.createElement(
					"g",
					{ id: "Group_6056", transform: "translate(0.068 0)" },
					_react2.default.createElement("path", { id: "Path_3214", fill: "#F3F2F2", className: "blackIcon", d: "M-5385-7705.3c13.3,0,24.1-10.8,24.1-24.1c0,0,0,0,0,0c0-17.2-24.1-44.7-24.1-44.7\r s-24.1,27.5-24.1,44.7C-5409-7716.1-5398.3-7705.3-5385-7705.3C-5385-7705.3-5385-7705.3-5385-7705.3z M-5385-7721.4\r c5.3,0,9.7-4.3,9.7-9.7h6.4c0,8.9-7.2,16.1-16.1,16.1V-7721.4z" })
				),
				_react2.default.createElement("path", { id: "Path_3215", fill: "#FFFFFF", className: "blackIcon", d: "M-5384.9-7772.6c0,0,23.4,26.7,24,43.9v-0.6c0-17.2-24.1-44.7-24.1-44.7s-24.1,27.5-24.1,44.7\r v0.6C-5408.3-7745.9-5384.9-7772.6-5384.9-7772.6z" }),
				_react2.default.createElement("path", { id: "Path_3216", fill: "#FFFFFF", className: "blackIcon", d: "M-5368.8-7729.7L-5368.8-7729.7c-0.8,8.3-7.7,14.7-16.1,14.7v1.4c8.9,0,16.1-7.1,16.1-16\r C-5368.8-7729.6-5368.8-7729.6-5368.8-7729.7z" }),
				_react2.default.createElement("path", { id: "Path_3217", opacity: "0.12", className: "blackIcon", d: "M-5375.3-7732.4c0,5.3-4.3,9.7-9.7,9.7v1.4c5.3,0,9.7-4.3,9.7-9.7h6.4\r c0.1-0.5,0.1-0.9,0.1-1.4H-5375.3z" }),
				_react2.default.createElement("path", { id: "Path_3218", opacity: "0.12", className: "blackIcon", d: "M-5384.9-7706.6c-13.1,0-23.7-10.4-24-23.5v0.8c0,13.3,10.8,24.1,24.1,24.1\r c13.3,0,24.1-10.8,24.1-24.1v-0.8C-5361.2-7717.1-5371.9-7706.7-5384.9-7706.6z" })
			)
		)
	);
	
	var banio = exports.banio = _react2.default.createElement(
		"svg",
		{ version: "1.1", id: "Capa_1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
			viewBox: "0 0 120 120", enableBackground: "new 0 0 120 120", xmlSpace: "preserve", className: "borderND blue" },
		_react2.default.createElement(
			"g",
			{ id: "Group_5862", transform: "translate(4454 -1314)" },
			_react2.default.createElement(
				"g",
				{ id: "Group_5864", transform: "translate(955 6695)" },
				_react2.default.createElement("path", { id: "Path_2893", fill: "#0090FC", className: "whiteIcon", d: "M-5295.8-5261h-106.4c-3.8,0-6.8-3.1-6.8-6.8v-106.4c0-3.8,3.1-6.8,6.8-6.8h106.4\r c3.8,0,6.8,3.1,6.8,6.8v106.4C-5289-5264.1-5292.1-5261-5295.8-5261z" }),
				_react2.default.createElement("path", { id: "Path_2894", opacity: "0.2", className: "transparentIconBlack", d: "M-5402.2-5261h106.4c3.8,0,6.8-3.1,6.8-6.8v-2.2c0,3.8-3.1,6.8-6.8,6.8h-106.4\r c-3.8,0-6.8-3.1-6.8-6.8v2.2C-5409-5264.1-5405.9-5261-5402.2-5261z" }),
				_react2.default.createElement("path", { id: "Path_2895", fill: "#4DB1FC", opacity: "0.3", className: "transparentIconWhite", d: "M-5295.8-5381h-106.4c-3.8,0-6.8,3.1-6.8,6.8v2.2c0-3.8,3.1-6.8,6.8-6.8h106.4\r c3.8,0,6.8,3.1,6.8,6.8v-2.2C-5289-5377.9-5292.1-5381-5295.8-5381z" }),
				_react2.default.createElement("path", { id: "Path_2897", fill: "#F2F2F2", className: "blackIcon", d: "M-5372.5-5345.5c4.5,0,8.2-3.7,8.2-8.2c0-4.5-3.7-8.2-8.2-8.2c-4.5,0-8.2,3.7-8.2,8.2\r c0,0,0,0,0,0c0,4.5,3.6,8.1,8.1,8.2C-5372.5-5345.5-5372.5-5345.5-5372.5-5345.5z" }),
				_react2.default.createElement("path", { id: "Path_2898", fill: "#E6E6E5", className: "blackIcon", d: "M-5372.5-5346.2c-4.4,0-8-3.5-8.2-7.8v0.3c0,4.5,3.7,8.2,8.2,8.2c4.5,0,8.2-3.7,8.2-8.2v-0.3\r C-5364.5-5349.6-5368.1-5346.2-5372.5-5346.2z" }),
				_react2.default.createElement("path", { id: "Path_2899", fill: "#FFFFFF", className: "blackIcon", d: "M-5372.5-5361.3c4.4,0,8,3.5,8.2,7.8v-0.3c0-4.5-3.7-8.2-8.2-8.2c-4.5,0-8.2,3.7-8.2,8.2\r c0,0,0,0,0,0v0.3C-5380.5-5357.8-5376.9-5361.3-5372.5-5361.3z" }),
				_react2.default.createElement("path", { id: "Path_2900", fill: "#F2F2F2", className: "blackIcon", d: "M-5329.8-5280v-30.7h-6.1v-22.5c0-4.5,3.7-8.2,8.2-8.2h12.3c4.5,0,8.2,3.7,8.2,8.2v22.5h-6.1\r v30.7H-5329.8z" }),
				_react2.default.createElement("rect", { id: "Rectangle_2912", x: "-5313.5", y: "-5311.5", fill: "#E6E6E5", className: "blackIcon", width: "6.1", height: "0.8" }),
				_react2.default.createElement("rect", { id: "Rectangle_2913", x: "-5336", y: "-5311.5", className: "blackIcon", width: "6.1", height: "0.8" }),
				_react2.default.createElement("rect", { id: "Rectangle_2914", x: "-5329.8", y: "-5280.8", fill: "#E6E6E5", className: "blackIcon", width: "16.4", height: "0.8" }),
				_react2.default.createElement("path", { id: "Path_2901", fill: "#F2F2F2", className: "blackIcon", d: "M-5321.7-5345.5c4.5,0,8.2-3.7,8.2-8.2c0-4.5-3.7-8.2-8.2-8.2c-4.5,0-8.2,3.7-8.2,8.2\r c0,4.5,3.6,8.1,8.1,8.2C-5321.7-5345.5-5321.7-5345.5-5321.7-5345.5z" }),
				_react2.default.createElement("path", { id: "Path_2902", fill: "#F2F2F2", className: "blackIcon", d: "M-5366.4-5280v-24.5h12.3l-10.4-31.2c-1.1-3.3-4.3-5.6-7.8-5.6h-0.5c-3.5,0-6.7,2.2-7.8,5.6\r l-10.4,31.2h12.3v24.5L-5366.4-5280z" }),
				_react2.default.createElement("path", { id: "Path_2903", fill: "#E6E6E5", className: "blackIcon", d: "M-5390.7-5305.4l-0.3,0.8h12.3v-0.8H-5390.7z" }),
				_react2.default.createElement("rect", { id: "Rectangle_2915", x: "-5378.7", y: "-5280.8", fill: "#E6E6E5", className: "blackIcon", width: "12.3", height: "0.8" }),
				_react2.default.createElement("path", { id: "Path_2904", fill: "#E6E6E5", className: "blackIcon", d: "M-5366.4-5305.4v0.8h12.3l-0.3-0.8H-5366.4z" }),
				_react2.default.createElement("path", { id: "Path_2905", fill: "#FFFFFF", className: "blackIcon", d: "M-5321.7-5361.3c4.4,0,8,3.5,8.2,7.8v-0.3c0-4.5-3.7-8.2-8.2-8.2c-4.5,0-8.2,3.7-8.2,8.2\r c0,0,0,0,0,0v0.3C-5329.7-5357.8-5326-5361.3-5321.7-5361.3z" }),
				_react2.default.createElement("path", { id: "Path_2906", fill: "#E6E6E5", className: "blackIcon", d: "M-5321.7-5346.2c-4.4,0-8-3.5-8.2-7.8v0.3c0,4.5,3.7,8.2,8.2,8.2c4.5,0,8.2-3.7,8.2-8.2\r c0,0,0,0,0,0v-0.3C-5313.6-5349.6-5317.3-5346.1-5321.7-5346.2z" }),
				_react2.default.createElement("path", { id: "Path_2907", fill: "#FFFFFF", className: "blackIcon", d: "M-5372.8-5340.7h0.5c3.6,0,6.8,2.2,8,5.6l-0.3-0.8c-1.1-3.3-4.3-5.6-7.8-5.6h-0.5\r c-3.5,0-6.7,2.2-7.8,5.6l-0.3,0.8C-5379.6-5338.4-5376.4-5340.7-5372.8-5340.7z" }),
				_react2.default.createElement("path", { id: "Path_2908", fill: "#FFFFFF", className: "blackIcon", d: "M-5315.5-5341.5h-12.3c-4.5,0-8.2,3.7-8.2,8.2v0.8c0-4.5,3.7-8.2,8.2-8.2h12.3\r c4.5,0,8.2,3.7,8.2,8.2v-0.8c0-4.5-3.6-8.1-8.1-8.2C-5315.4-5341.5-5315.5-5341.5-5315.5-5341.5z" }),
				_react2.default.createElement("rect", { id: "Rectangle_2916", x: "-5350.2", y: "-5361.9", fill: "#F2F2F2", className: "blackIcon", width: "2.7", height: "81.8" }),
				_react2.default.createElement("rect", { id: "Rectangle_2917", x: "-5350.2", y: "-5361.9", fill: "#FFFFFF", className: "blackIcon", width: "2.7", height: "0.8" }),
				_react2.default.createElement("rect", { id: "Rectangle_2918", x: "-5350.2", y: "-5280.8", fill: "#E6E6E5", className: "blackIcon", width: "2.7", height: "0.8" })
			)
		)
	);
	
	var naBreak = exports.naBreak = _react2.default.createElement(
		"svg",
		{ version: "1.1", id: "Capa_1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
			viewBox: "0 0 120 120", enableBackground: "new 0 0 120 120", xmlSpace: "preserve", className: "borderND red" },
		_react2.default.createElement(
			"g",
			{ id: "Group_6142", transform: "translate(4873.5 5356.7)" },
			_react2.default.createElement(
				"g",
				{ id: "Group_6142-2", transform: "translate(30.5 24.3)" },
				_react2.default.createElement("path", { id: "Path_3343", fill: "#ED212C", className: "whiteIcon", d: "M-4790.8-5261h-106.4c-3.8,0-6.8-3.1-6.8-6.8v-106.4c0-3.8,3.1-6.8,6.8-6.8h106.4\r c3.8,0,6.8,3.1,6.8,6.8v106.4C-4784-5264.1-4787.1-5261-4790.8-5261z" }),
				_react2.default.createElement("path", { id: "Path_3344", className: "transparentIconBlack", d: "M-4897.2-5261h106.4c3.8,0,6.8-3.1,6.8-6.8v-2.2c0,3.8-3.1,6.8-6.8,6.8h-106.4\r c-3.8,0-6.8-3.1-6.8-6.8v2.2C-4904-5264.1-4901-5261-4897.2-5261z" }),
				_react2.default.createElement("path", { id: "Path_3345", className: "transparentIconWhite", d: "M-4790.8-5381h-106.4c-3.8,0-6.8,3.1-6.8,6.8v2.2c0-3.8,3.1-6.8,6.8-6.8h106.4\r c3.8,0,6.8,3.1,6.8,6.8v-2.2C-4784-5377.9-4787.1-5381-4790.8-5381z" })
			),
			_react2.default.createElement(
				"g",
				{ id: "Group_6145", transform: "translate(81.183 49.756)" },
				_react2.default.createElement("path", { id: "Path_3347", fill: "#F2F2F2", className: "blackIcon", d: "M-4894.1-5362.5c-1.3,0-2.4-1.1-2.4-2.4c0-9.7-5.8-11.4-5.8-11.4c-1.3-0.4-2-1.7-1.6-2.9\r c0.4-1.3,1.7-2,2.9-1.6c0.4,0.1,9.3,2.7,9.3,16C-4891.7-5363.6-4892.8-5362.6-4894.1-5362.5z" })
			),
			_react2.default.createElement("path", { id: "Path_3348", opacity: "0.12", className: "blackIcon", d: "M-4812.9-5314.2c-1.3,0-2.4-1.1-2.4-2.4c0-9.7-5.8-11.4-5.8-11.4c-0.8-0.2-1.4-0.8-1.6-1.6v0.1\r c-0.3,1.3,0.4,2.6,1.6,2.9c0.1,0,5.8,1.7,5.8,11.4c0,1.3,1.1,2.4,2.4,2.4c1.3,0,2.4-1.1,2.4-2.4v-1.2\r C-4810.6-5315.1-4811.7-5314.2-4812.9-5314.2z" }),
			_react2.default.createElement("path", { id: "Path_3349", fill: "#FFFFFF", className: "blackIcon", d: "M-4819.8-5329.8c0.3,0.1,8.8,2.6,9.3,14.9v-0.2c0-13.2-8.9-15.9-9.3-16\r c-1.3-0.3-2.6,0.4-2.9,1.6c-0.1,0.4-0.1,0.9,0,1.3C-4822.4-5329.5-4821.1-5330.1-4819.8-5329.8z" }),
			_react2.default.createElement("path", { id: "Path_3350", fill: "#F2F2F2", className: "blackIcon", d: "M-4789.9-5343.4c0,0,0.7,8.7-5.4,15.3c-4,4-8.8,6.3-16.7,6.9c0.6-4.6,1.4-11.6,7-16.4\r C-4802.4-5340.2-4797.3-5343-4789.9-5343.4z" }),
			_react2.default.createElement("path", { id: "Path_3351", fill: "#FFFFFF", className: "blackIcon", d: "M-4804.1-5336.7c3.8-3.8,8.8-6.2,14.2-6.8l0,0c-7.4,0.5-12.5,3.2-15.1,5.8\r c-5.5,4.8-6.3,11.7-7,16.4v-0.1C-4811.3-5326-4809.1-5332.2-4804.1-5336.7z" }),
			_react2.default.createElement("path", { id: "Path_3352", opacity: "0.12", className: "blackIcon", d: "M-4789.9-5343.4L-4789.9-5343.4c0,2.6-1.6,9.1-6.3,14.3c-3.8,3.8-8.4,7.2-15.6,7.8h-0.1\r c7.9-0.5,12.7-2.9,16.7-6.9C-4791.6-5332.4-4789.7-5337.8-4789.9-5343.4z" }),
			_react2.default.createElement("path", { id: "Path_3353", fill: "#F2F2F2", className: "blackIcon", d: "M-4812.9-5317c0,0-3.1,0-8.7-2.7c-2.8-1.4-18.8-5.2-26.4,8.4c0,0-6.6,11.2,0,29.8\r c4.6,12,10.8,25.9,23.3,28.3c3.3,0.2,6.5-0.3,9.6-1.4c1.8-0.8,2.8-1.4,7.6,0.6c4.8,2.1,17.8,2.4,26.2-20.5\r c3.8-10.2,12.4-37.1-8-44.2c-9.2-2.9-14-1.4-15.1-0.9C-4805.3-5319.1-4810.2-5316.7-4812.9-5317z" }),
			_react2.default.createElement("path", { id: "Path_3354", fill: "#FFFFFF", className: "blackIcon", d: "M-4847.9-5309.9c7.6-13.6,23.6-9.7,26.4-8.4c5.5,2.7,8.7,2.7,8.7,2.7c2.8,0.3,7.6-2.2,8.7-2.7\r c1-0.5,5.9-2,15.1,0.9c9.8,3.5,12.9,11.5,13.1,20c0.1-9-2.7-17.7-13.1-21.3c-9.2-2.9-14-1.4-15.1-0.9s-5.9,2.9-8.7,2.7\r c0,0-3.1,0-8.7-2.7c-2.8-1.4-18.8-5.2-26.4,8.4c0,0-3.1,5.3-2.9,14.5C-4850.7-5305.1-4847.9-5309.9-4847.9-5309.9z" }),
			_react2.default.createElement("path", { id: "Path_3355", opacity: "0.12", className: "blackIcon", d: "M-4781.3-5275.8c-8.3,22.9-21.3,22.6-26.2,20.5c-4.8-2.1-5.8-1.4-7.6-0.6\r c-3.1,1.1-6.3,1.6-9.6,1.4c-12.5-2.3-18.8-16.3-23.3-28.3c-1.8-4.9-2.8-10-2.9-15.2c0,5.7,1,11.3,2.9,16.6\r c4.6,12,10.8,25.9,23.3,28.3c3.3,0.2,6.5-0.2,9.6-1.4c1.8-0.8,2.8-1.4,7.6,0.6c4.8,2.1,17.8,2.4,26.2-20.5c2-5.2,5.2-15.1,5-24.3\r C-4776.3-5289.9-4779.3-5280.8-4781.3-5275.8z" })
		)
	);
	
	var cafe = exports.cafe = _react2.default.createElement(
		"svg",
		{ version: "1.1", id: "Capa_1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
			viewBox: "0 0 120 120", enableBackground: "new 0 0 120 120", xmlSpace: "preserve", className: "borderND brown" },
		_react2.default.createElement(
			"g",
			{ id: "Group_6030", transform: "translate(4873.8 7753.2)" },
			_react2.default.createElement(
				"g",
				{ id: "Group_6010", transform: "translate(29.2 20.8)" },
				_react2.default.createElement("path", { id: "Path_3171", fill: "#A76C42", className: "whiteIcon", d: "M-4789.8-7654h-106.4c-3.8,0-6.8-3.1-6.8-6.8v-106.4c0-3.8,3.1-6.8,6.8-6.8h106.4\r c3.8,0,6.8,3.1,6.8,6.8v106.4C-4783-7657.1-4786-7654-4789.8-7654C-4789.8-7654-4789.8-7654-4789.8-7654z" }),
				_react2.default.createElement("path", { id: "Path_3172", className: "transparentIconBlack", d: "M-4896.2-7654h106.4c3.8,0,6.8-3.1,6.8-6.8v-2.2c0,3.8-3.1,6.8-6.8,6.8h-106.4\r c-3.8,0-6.8-3.1-6.8-6.8v2.2C-4903-7657.1-4899.9-7654-4896.2-7654z" }),
				_react2.default.createElement("path", { id: "Path_3173", className: "transparentIconWhite", d: "M-4789.8-7774h-106.4c-3.8,0-6.8,3.1-6.8,6.8v2.2c0-3.8,3.1-6.8,6.8-6.8h106.4\r c3.8,0,6.8,3.1,6.8,6.8v-2.2C-4783-7770.9-4786-7774-4789.8-7774C-4789.8-7774-4789.8-7774-4789.8-7774z" })
			),
			_react2.default.createElement("rect", { id: "Rectangle_3054", x: "-4857.2", y: "-7661.8", className: "blackIcon", fill: "#F3F2F2", width: "87.3", height: "8.2" }),
			_react2.default.createElement("rect", { id: "Rectangle_3055", x: "-4857.2", y: "-7661.8", fill: "#FFFFFF", className: "blackIcon", width: "87.3", height: "1.3" }),
			_react2.default.createElement(
				"g",
				{ id: "Group_6015", transform: "translate(54.904 40.777)" },
				_react2.default.createElement(
					"g",
					{ id: "Group_6013", transform: "translate(60.136 6.75)" },
					_react2.default.createElement("path", { id: "Path_3175", fill: "#F3F2F2", className: "blackIcon", d: "M-4885.4-7753.6c0,7.1-4.8,18.4-17.6,18.4v-8.6c8.9,0,8.9-9.7,8.9-9.8v-11.7h-8.7v-8.7h8.7\r c4.8,0,8.6,3.8,8.7,8.6c0,0,0,0,0,0.1V-7753.6z" })
				),
				_react2.default.createElement(
					"g",
					{ id: "Group_6014", transform: "translate(60.136 14.045)", opacity: "0.12", className: "blackIcon" },
					_react2.default.createElement("path", { id: "Path_3176", d: "M-4903-7743.9v1.4c12.8,0,17.6-11.2,17.6-18.4v-1.4C-4885.4-7755.2-4890.2-7743.9-4903-7743.9z" }),
					_react2.default.createElement("path", { id: "Path_3177", d: "M-4902.7-7772.6h8.6v-1.4h-8.6" })
				),
				_react2.default.createElement("path", { id: "Path_3178", fill: "#FFFFFF", className: "blackIcon", d: "M-4842.5-7767.2h8.7c4.8,0,8.6,3.8,8.7,8.6c0,0,0,0,0,0.1v1.4c0-4.8-3.8-8.6-8.6-8.7\r c0,0,0,0-0.1,0h-8.7V-7767.2z" }),
				_react2.default.createElement("path", { id: "Path_3179", fill: "#F3F2F2", className: "blackIcon", d: "M-4842.5-7728.6c0,9.5-7.7,17.2-17.2,17.2c0,0,0,0,0,0h-25.9c-9.5,0-17.2-7.7-17.2-17.2\r c0,0,0,0,0,0v-45.4h60.5L-4842.5-7728.6L-4842.5-7728.6z" }),
				_react2.default.createElement("path", { id: "Path_3180", opacity: "0.12", className: "blackIcon", d: "M-4885.8-7711.3h25.9c9.5,0,17.2-7.7,17.2-17.2c0,0,0,0,0,0v-1.4c0,9.5-7.7,17.2-17.2,17.2\r c0,0,0,0,0,0h-25.9c-9.5,0-17.2-7.7-17.2-17.2c0,0,0,0,0,0v1.4C-4903-7719-4895.3-7711.3-4885.8-7711.3z" }),
				_react2.default.createElement("rect", { id: "Rectangle_3056", x: "-4903", y: "-7774", fill: "#FFFFFF", className: "blackIcon", width: "60.5", height: "1.4" })
			),
			_react2.default.createElement("rect", { id: "Rectangle_3057", x: "-4857.2", y: "-7654.8", opacity: "0.12", className: "blackIcon", width: "87.3", height: "1.3" })
		)
	);
	
	var cambio = exports.cambio = _react2.default.createElement(
		"svg",
		{ version: "1.1", id: "Capa_1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
			viewBox: "0 0 120 120", enableBackground: "new 0 0 120 120", xmlSpace: "preserve", className: "borderND purple" },
		_react2.default.createElement(
			"g",
			{ id: "Group_6124", transform: "translate(5380 8933.1)" },
			_react2.default.createElement(
				"g",
				{ id: "Group_6132", transform: "translate(29 23.9)" },
				_react2.default.createElement("path", { id: "Path_3319", fill: "#8D6BFD", className: "whiteIcon", d: "M-5295.8-8837h-106.4c-3.8,0-6.8-3.1-6.8-6.8v-106.4c0-3.8,3.1-6.8,6.8-6.8h106.4\r c3.8,0,6.8,3.1,6.8,6.8v106.4C-5289-8840.1-5292.1-8837-5295.8-8837z" }),
				_react2.default.createElement("path", { id: "Path_3320", className: "transparentIconBlack", d: "M-5402.2-8837h106.4c3.8,0,6.8-3.1,6.8-6.8v-2.2c0,3.8-3.1,6.8-6.8,6.8h-106.4\r c-3.8,0-6.8-3.1-6.8-6.8v2.2C-5409-8840.1-5406-8837-5402.2-8837C-5402.2-8837-5402.2-8837-5402.2-8837z" }),
				_react2.default.createElement("path", { id: "Path_3321", className: "transparentIconWhite", d: "M-5295.8-8957h-106.4c-3.8,0-6.8,3.1-6.8,6.8v2.2c0-3.8,3.1-6.8,6.8-6.8h106.4\r c3.8,0,6.8,3.1,6.8,6.8v-2.2C-5289-8953.9-5292-8957-5295.8-8957C-5295.8-8957-5295.8-8957-5295.8-8957z" })
			),
			_react2.default.createElement("path", { id: "Path_3323", fill: "#F3F2F2", className: "blackIcon", d: "M-5343-8901.8v14.1h7.9v-14.1l5,5.1l5.6-5.6l-14.6-14.7l-14.7,14.7l5.6,5.6L-5343-8901.8z" }),
			_react2.default.createElement("path", { id: "Path_3324", fill: "#F3F2F2", className: "blackIcon", d: "M-5286.3-8902l-5.6-5.6l-5.1,5.1v-14.2h-7.9v14.2l-5-5.1l-5.6,5.6l14.6,14.6L-5286.3-8902z" }),
			_react2.default.createElement("path", { id: "Path_3325", fill: "#F3F2F2", className: "blackIcon", d: "M-5286.1-8878.6h-67.8c-4.2,0-7.6,3.4-7.6,7.6c0,0,0,0,0,0v33.6c0,4.2,3.4,7.6,7.6,7.6\r c0,0,0,0,0,0h67.8c4.2,0,7.6-3.4,7.6-7.6c0,0,0,0,0,0v-33.6C-5278.5-8875.1-5281.9-8878.5-5286.1-8878.6\r C-5286.1-8878.6-5286.1-8878.6-5286.1-8878.6z M-5300.8-8869.1c4.2,0,7.6,3.4,7.6,7.6c0,4.2-3.4,7.6-7.6,7.6s-7.6-3.4-7.6-7.6\r C-5308.5-8865.7-5305.1-8869.1-5300.8-8869.1C-5300.9-8869.1-5300.8-8869.1-5300.8-8869.1z M-5339.2-8869.1c4.2,0,7.6,3.4,7.6,7.6\r c0,4.2-3.4,7.6-7.6,7.6s-7.6-3.4-7.6-7.6C-5346.9-8865.7-5343.5-8869.1-5339.2-8869.1C-5339.2-8869.1-5339.2-8869.1-5339.2-8869.1\r L-5339.2-8869.1z M-5352.5-8838.7c0-6.3,5.1-11.4,11.4-11.5c0,0,0,0,0,0h3.8c6.3,0,11.4,5.1,11.5,11.4c0,0,0,0,0,0H-5352.5z\r M-5314.1-8838.7c0-6.3,5.1-11.4,11.4-11.5c0,0,0,0,0,0h3.8c6.3,0,11.4,5.1,11.5,11.4c0,0,0,0,0,0H-5314.1z" }),
			_react2.default.createElement("path", { id: "Path_3326", className: "blackIcon", fill: "#FFFFFF", d: "M-5339.1-8915.6l13.9,14l0.7-0.7l-14.6-14.7l-14.7,14.7l0.7,0.7L-5339.1-8915.6z" }),
			_react2.default.createElement(
				"g",
				{ id: "Group_6135", transform: "translate(93.432 40.332)" },
				_react2.default.createElement("rect", { id: "Rectangle_3140", fill: "#FFFFFF", x: "-5398.3", y: "-8957", className: "blackIcon", width: "7.9", height: "1.4" }),
				_react2.default.createElement("path", { id: "Path_3327", fill: "#FFFFFF", className: "blackIcon", d: "M-5390.5-8941.5l5.1-5l4.9,4.8l0.7-0.7l-5.6-5.5l-5.1,5V-8941.5z" }),
				_react2.default.createElement("path", { id: "Path_3328", fill: "#FFFFFF", className: "blackIcon", d: "M-5403.4-8946.6l5.1,5v-1.4l-5.1-5l-5.6,5.5l0.7,0.7L-5403.4-8946.6z" })
			),
			_react2.default.createElement("path", { id: "Path_3329", fill: "#FFFFFF", className: "blackIcon", d: "M-5286.1-8878.6h-67.8c-4.2,0-7.6,3.4-7.6,7.6c0,0,0,0,0,0v1.4c0-4.2,3.4-7.6,7.6-7.6\r c0,0,0,0,0,0h67.8c4.2,0,7.6,3.4,7.6,7.6c0,0,0,0,0,0v-1.4C-5278.5-8875.1-5281.9-8878.5-5286.1-8878.6\r C-5286.1-8878.6-5286.1-8878.6-5286.1-8878.6z" }),
			_react2.default.createElement("path", { id: "Path_3330", fill: "#FFFFFF", className: "blackIcon", d: "M-5300.8-8869.1c3.9,0,7.2,3,7.6,7c0-0.2,0.1-0.5,0.1-0.7c0-4.2-3.4-7.6-7.6-7.6\r c-4.2,0-7.6,3.4-7.6,7.6c0,0.2,0,0.5,0.1,0.7C-5308.1-8866.1-5304.8-8869.1-5300.8-8869.1z" }),
			_react2.default.createElement(
				"g",
				{ id: "Group_6137", transform: "translate(47.477 53.832)", opacity: "0.12", className: "blackIcon" },
				_react2.default.createElement("path", { id: "Path_3331", d: "M-5386.7-8906.4c4.2,0,7.6-3.4,7.6-7.6c0,0,0,0,0,0c0-0.2,0-0.5-0.1-0.7c-0.4,4.2-4.1,7.3-8.3,6.9\r c-3.6-0.3-6.5-3.2-6.9-6.9c0,0.2-0.1,0.5-0.1,0.7C-5394.3-8909.8-5390.9-8906.5-5386.7-8906.4z" }),
				_react2.default.createElement("path", { id: "Path_3332", d: "M-5348.3-8906.4c4.2,0,7.6-3.4,7.6-7.6c0,0,0,0,0,0c0-0.2,0-0.5-0.1-0.7c-0.4,4.2-4.1,7.3-8.3,6.9\r c-3.6-0.3-6.5-3.2-6.9-6.9c0,0.2-0.1,0.5-0.1,0.7C-5355.9-8909.8-5352.5-8906.5-5348.3-8906.4z" }),
				_react2.default.createElement(
					"g",
					{ id: "Group_6136", transform: "translate(7.773 0)" },
					_react2.default.createElement("path", { id: "Path_3333", d: "M-5385.3-8951.9l-5-5.1v1.4l5,5.1l5.6-5.6l-0.7-0.7L-5385.3-8951.9z" }),
					_react2.default.createElement("path", { id: "Path_3334", d: "M-5398.3-8957l-5.1,5.1l-4.9-4.9l-0.7,0.7l5.6,5.6l5.1-5.1V-8957z" }),
					_react2.default.createElement("rect", { id: "Rectangle_3141", x: "-5398.3", y: "-8942.9", width: "7.9", height: "1.4" })
				),
				_react2.default.createElement("path", { id: "Path_3335", d: "M-5348.5-8942.6l-13.9-13.9l-0.7,0.7l14.6,14.6l14.7-14.6l-0.7-0.7L-5348.5-8942.6z" }),
				_react2.default.createElement("path", { id: "Path_3336", d: "M-5333.6-8884.9h-67.8c-4.2,0-7.6-3.4-7.6-7.6c0,0,0,0,0,0v1.4c0,4.2,3.4,7.6,7.6,7.6c0,0,0,0,0,0h67.8\r c4.2,0,7.6-3.4,7.6-7.6c0,0,0,0,0,0v-1.4C-5325.9-8888.3-5329.4-8884.9-5333.6-8884.9C-5333.6-8884.9-5333.6-8884.9-5333.6-8884.9\r z" }),
				_react2.default.createElement("rect", { id: "Rectangle_3142", x: "-5400", y: "-8892.5", fill: "#020202", className: "blackIcon", width: "26.7", height: "1.4" }),
				_react2.default.createElement("rect", { id: "Rectangle_3143", x: "-5361.6", y: "-8892.5", fill: "#020202", className: "blackIcon", width: "26.7", height: "1.4" })
			),
			_react2.default.createElement("path", { id: "Path_3337", fill: "#FFFFFF", className: "blackIcon", d: "M-5337.3-8851.5h-3.8c-6.3,0-11.4,5.1-11.5,11.4c0,0,0,0,0,0v1.4c0-0.5,0-0.9,0.1-1.4\r c0.7-5.7,5.5-10.1,11.3-10.1h3.8c5.8,0,10.7,4.3,11.3,10.1c0,0,0.1,0.8,0.1,1.4v-1.4c0.1-6.2-4.8-11.3-11-11.5\r C-5337.1-8851.5-5337.2-8851.5-5337.3-8851.5z" }),
			_react2.default.createElement("path", { id: "Path_3338", fill: "#FFFFFF", className: "blackIcon", d: "M-5339.2-8869.1c3.9,0,7.2,3,7.6,7c0-0.2,0.1-0.5,0.1-0.7c0-4.2-3.4-7.6-7.6-7.6\r c-4.2,0-7.6,3.4-7.6,7.6c0,0.2,0,0.5,0.1,0.7C-5346.4-8866.1-5343.2-8869.1-5339.2-8869.1z" }),
			_react2.default.createElement("path", { id: "Path_3339", fill: "#FFFFFF", className: "blackIcon", d: "M-5298.9-8851.5h-3.8c-6.3,0-11.4,5.1-11.5,11.4c0,0,0,0,0,0v1.4c0-0.5,0-0.9,0.1-1.4\r c0.7-5.7,5.5-10.1,11.3-10.1h3.8c5.8,0,10.7,4.3,11.3,10.1c0,0,0.1,0.8,0.1,1.4v-1.4c0.1-6.2-4.8-11.3-11-11.5\r C-5298.7-8851.5-5298.8-8851.5-5298.9-8851.5z" })
		)
	);
	
	var comida = exports.comida = _react2.default.createElement(
		"svg",
		{ version: "1.1", id: "Capa_1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
			viewBox: "0 0 120 120", enableBackground: "new 0 0 120 120", xmlSpace: "preserve", className: "borderND yellow" },
		_react2.default.createElement(
			"g",
			{ id: "Group_5988", transform: "translate(4873.2 7179.1)" },
			_react2.default.createElement(
				"g",
				{ id: "Group_5977", transform: "translate(30.8 23.9)" },
				_react2.default.createElement("path", { id: "Path_3116", fill: "#FFBA00", className: "whiteIcon", d: "M-4790.8-7083h-106.4c-3.8,0-6.8-3.1-6.8-6.8v-106.4c0-3.8,3.1-6.8,6.8-6.8h106.4\r c3.8,0,6.8,3.1,6.8,6.8v106.4C-4784-7086.1-4787.1-7083-4790.8-7083z" }),
				_react2.default.createElement("path", { id: "Path_3117", className: "transparentIconBlack", d: "M-4897.2-7083h106.4c3.8,0,6.8-3.1,6.8-6.8v-2.2c0,3.8-3.1,6.8-6.8,6.8h-106.4\r c-3.8,0-6.8-3.1-6.8-6.8v2.2C-4904-7086.1-4900.9-7083-4897.2-7083z" }),
				_react2.default.createElement("path", { id: "Path_3118", className: "transparentIconWhite", d: "M-4790.8-7203h-106.4c-3.8,0-6.8,3.1-6.8,6.8v2.2c0-3.8,3.1-6.8,6.8-6.8h106.4\r c3.8,0,6.8,3.1,6.8,6.8v-2.2C-4784-7199.9-4787.1-7203-4790.8-7203z" })
			),
			_react2.default.createElement(
				"g",
				{ id: "Group_5983", transform: "translate(40.115 36.241)" },
				_react2.default.createElement(
					"g",
					{ id: "Group_5981", transform: "translate(0 5.932)" },
					_react2.default.createElement("path", { id: "Path_3120", fill: "#F3F2F2", className: "blackIcon", d: "M-4898-7203c-7.9,7.8-8,20.5-0.2,28.5l21.5,21.5l7.2-7.2l48.5,48.5l7.2-7.2l-50.2-50.2l0,0\r L-4898-7203z" }),
					_react2.default.createElement(
						"g",
						{ id: "Group_5980", transform: "translate(0.008 0.068)" },
						_react2.default.createElement("rect", { id: "Rectangle_3046", fill: "#D9D8D8", x: "-4845.5", y: "-7170.8", transform: "matrix(0.7071 -0.7071 0.7071 0.7071 3627.3201 -5516.0059)", className: "blackIcon", width: "1.4", height: "68.5" }),
						_react2.default.createElement("path", { id: "Path_3121", opacity: "0.1", className: "blackIcon", d: "M-4898-7203L-4898-7203c-7.9,7.8-8,20.5-0.3,28.4l21.5,21.5l1-1l-21.5-21.5\r C-4904.6-7183.1-4905-7195.1-4898-7203z" })
					),
					_react2.default.createElement("path", { id: "Path_3122", opacity: "0.4", fill: "#FFFFFF", className: "blackIcon", d: "M-4865-7168.2L-4865-7168.2l50.2,50.2l1-1l-50.2-50.2l0,0l-34-33.9c-0.3,0.3-0.6,0.7-1,1\r L-4865-7168.2z" })
				),
				_react2.default.createElement(
					"g",
					{ id: "Group_5982", transform: "translate(5.413 0)" },
					_react2.default.createElement("path", { id: "Path_3123", fill: "#F3F2F2", className: "blackIcon", d: "M-4810.7-7187.2l-18.8,18.8l-4-4l18.8-18.8l-3.9-3.9l-18.8,18.8l-4-4l18.8-18.8l-3.9-3.9\r l-18.8,18.8l-3.7,3.7l-1.6,1.6c0,0-4.4,4.4-3.4,15.9l0,0l-49.9,49.9l7.2,7.2l49.9-49.9c11.5,1,15.9-3.4,15.9-3.4l1.8-1.8l3.5-3.5\r l18.8-18.8L-4810.7-7187.2z" }),
					_react2.default.createElement("path", { id: "Path_3124", opacity: "0.12", className: "blackIcon", d: "M-4830.2-7162l-1.8,1.8c0,0-4.4,4.4-15.9,3.4l-49.9,49.9l1,1l49.9-49.9\r c11.5,1,15.9-3.4,15.9-3.4l1.8-1.8l3.5-3.5l18.8-18.8l-1-1l-18.9,18.9L-4830.2-7162z" }),
					_react2.default.createElement("rect", { id: "Rectangle_3047", fill: "#F3F2F2", x: "-4840.9", y: "-7185.9", transform: "matrix(0.7071 -0.7071 0.7071 0.7071 3666.7456 -5518.0972)", className: "blackIcon", width: "26.6", height: "1.4" }),
					_react2.default.createElement("rect", { id: "Rectangle_3048", fill: "#F3F2F2", x: "-4832.9", y: "-7178", transform: "matrix(0.7071 -0.7071 0.7071 0.7071 3663.479 -5510.1875)", className: "blackIcon", width: "26.6", height: "1.4" }),
					_react2.default.createElement("rect", { id: "Rectangle_3049", fill: "#D9D8D8", x: "-4845.9", y: "-7190.9", transform: "matrix(0.7071 -0.7071 0.7071 0.7071 3668.8501 -5523.1226)", className: "blackIcon", width: "26.6", height: "1.4" }),
					_react2.default.createElement("rect", { id: "Rectangle_3050", fill: "#D9D8D8", x: "-4838", y: "-7183", transform: "matrix(0.7071 -0.7071 0.7071 0.7071 3665.5354 -5515.2329)", className: "blackIcon", width: "26.6", height: "1.4" }),
					_react2.default.createElement("path", { id: "Path_3125", opacity: "0.4", fill: "#FFFFFF", className: "transparentIcon", d: "M-4845.4-7184.2l-3.7,3.7l-1.6,1.6c0,0-4.4,4.4-3.4,15.9l-49.9,49.9l1,1l49.9-49.9\r c-1-11.5,3.4-15.9,3.4-15.9l1.6-1.6l3.7-3.7l18.8-18.8l-1-1L-4845.4-7184.2z" })
				)
			)
		)
	);
	
	var conCliente = exports.conCliente = _react2.default.createElement(
		"svg",
		{ version: "1.1", id: "Capa_1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
			viewBox: "0 0 120.1 120", enableBackground: "new 0 0 120.1 120", xmlSpace: "preserve", className: "borderND green" },
		_react2.default.createElement(
			"g",
			{ id: "Group_6214", transform: "translate(4874.332 5986.8)" },
			_react2.default.createElement("path", { id: "Path_3385", fill: "#33CC33", className: "whiteIcon", d: "M-4761.2-5866.8h-106.4c-3.8,0-6.8-3.1-6.8-6.8V-5980c0-3.8,3.1-6.8,6.8-6.8h106.4\r c3.8,0,6.8,3.1,6.8,6.8v106.4C-4754.3-5869.9-4757.4-5866.8-4761.2-5866.8C-4761.1-5866.8-4761.1-5866.8-4761.2-5866.8z" }),
			_react2.default.createElement("path", { id: "Path_3386", className: "transparentIconBlack", d: "M-4867.5-5866.8h106.4c3.8,0,6.8-3.1,6.8-6.8v-2.2c0,3.8-3.1,6.8-6.8,6.8h-106.4\r c-3.8,0-6.8-3.1-6.8-6.8v2.2C-4874.3-5869.9-4871.3-5866.8-4867.5-5866.8C-4867.5-5866.8-4867.5-5866.8-4867.5-5866.8z" }),
			_react2.default.createElement("path", { id: "Path_3387", className: "transparentIconWhite", d: "M-4761.2-5986.8h-106.4c-3.8,0-6.8,3.1-6.8,6.8v2.2c0-3.8,3.1-6.8,6.8-6.8h106.4\r c3.8,0,6.8,3.1,6.8,6.8v-2.2C-4754.3-5983.7-4757.4-5986.8-4761.2-5986.8z" }),
			_react2.default.createElement(
				"g",
				{ id: "Group_6217", transform: "translate(45.927 54.018)" },
				_react2.default.createElement("circle", { id: "Ellipse_320", fill: "#F2F2F2", className: "blackIcon", cx: "-4879.1", cy: "-5997.5", r: "12.5" }),
				_react2.default.createElement("path", { id: "Path_3389", fill: "#F2F2F2", className: "blackIcon", d: "M-4904-5964.2c0,0,0.8-12.9,25-12.9c21,0,25,9.4,25,12.8c0,0-7.3,12.9-25,13.4\r C-4896.6-5951.2-4904-5964.2-4904-5964.2z" }),
				_react2.default.createElement("circle", { id: "Ellipse_321", fill: "#F2F2F2", className: "blackIcon", cx: "-4845.7", cy: "-5997.5", r: "12.5" }),
				_react2.default.createElement("path", { id: "Path_3390", fill: "#F2F2F2", className: "blackIcon", d: "M-4845.7-5977.1c-2.6,0-5.2,0.2-7.8,0.5c5.9,5,6.3,10.6,6.3,12.3v1.8l-0.9,1.6\r c-2,3.2-4.5,6-7.4,8.3c3.2,1.1,6.5,1.6,9.8,1.7c17.7-0.5,25-13.4,25-13.4C-4820.7-5967.7-4824.7-5977.1-4845.7-5977.1z" }),
				_react2.default.createElement("path", { id: "Path_3391", fill: "#E6E6E5", className: "blackIcon", d: "M-4879.1-5986.4c-6.6,0-12.1-5.2-12.5-11.8c0,0.2-0.1,0.5-0.1,0.7c0,6.9,5.6,12.5,12.5,12.5\r s12.5-5.6,12.5-12.5c0-0.2,0-0.5-0.1-0.7C-4867-5991.6-4872.5-5986.4-4879.1-5986.4z" }),
				_react2.default.createElement("path", { id: "Path_3392", fill: "#E6E6E5", className: "blackIcon", d: "M-4879.1-5952.2c-15.9-0.3-23.5-11-24.8-13c-0.1,0.6-0.2,1-0.2,1s7.4,13,25,13.4\r c17.7-0.5,25-13.4,25-13.4c0-0.4-0.1-0.8-0.1-1.2C-4855.2-5963.8-4862.7-5952.7-4879.1-5952.2z" }),
				_react2.default.createElement("path", { id: "Path_3393", fill: "#E6E6E5", className: "blackIcon", d: "M-4845.7-5986.4c-6.6,0-12.1-5.2-12.5-11.8c0,0.2-0.1,0.5-0.1,0.7c0,6.9,5.6,12.5,12.5,12.5\r s12.5-5.6,12.5-12.5c0-0.2,0-0.5-0.1-0.7C-4833.7-5991.6-4839.1-5986.4-4845.7-5986.4z" }),
				_react2.default.createElement("path", { id: "Path_3394", fill: "#FFFFFF", className: "blackIcon", d: "M-4879.1-5975.7c19,0,24.1,7.7,24.9,11.7c0-0.1,0.1-0.1,0.1-0.2c0-3.4-4-12.8-25-12.8\r c-24.1,0-25,12.9-25,12.9c0.1,0.1,0.1,0.2,0.2,0.3C-4903.1-5967-4899.1-5975.7-4879.1-5975.7z" }),
				_react2.default.createElement("path", { id: "Path_3395", fill: "#FFFFFF", className: "blackIcon", d: "M-4879.1-6008.6c6.6,0,12.1,5.2,12.5,11.8c0-0.2,0.1-0.5,0.1-0.7c0-6.9-5.6-12.5-12.5-12.5\r s-12.5,5.6-12.5,12.5l0,0c0,0.2,0,0.5,0.1,0.7C-4891.2-6003.5-4885.7-6008.7-4879.1-6008.6z" }),
				_react2.default.createElement("path", { id: "Path_3396", fill: "#FFFFFF", className: "blackIcon", d: "M-4845.7-6008.6c6.6,0,12.1,5.2,12.5,11.8c0-0.2,0.1-0.5,0.1-0.7c0-6.9-5.6-12.5-12.5-12.5\r s-12.5,5.6-12.5,12.5l0,0c0,0.2,0,0.5,0.1,0.7C-4857.8-6003.5-4852.4-6008.7-4845.7-6008.6z" }),
				_react2.default.createElement(
					"g",
					{ id: "Group_6216", transform: "translate(50.455 32.932)" },
					_react2.default.createElement("path", { id: "Path_3397", fill: "#FFFFFF", className: "blackIcon", d: "M-4902.7-6008.3c2.2-0.2,4.4-0.3,6.5-0.3c19,0,24.1,7.7,24.9,11.7c0-0.1,0.1-0.1,0.1-0.2\r c0-3.4-4-12.8-25-12.8c-2.6,0-5.2,0.2-7.8,0.5C-4903.6-6009.1-4903.1-6008.7-4902.7-6008.3z" })
				)
			),
			_react2.default.createElement(
				"g",
				{ id: "Group_6218", transform: "translate(94.405 98.609)" },
				_react2.default.createElement("path", { id: "Path_3398", fill: "#E6E6E5", className: "blackIcon", d: "M-4894.2-5996.8c-2.9,0-5.9-0.5-8.7-1.4c-0.3,0.3-0.8,0.7-1.2,1c3.2,1.1,6.5,1.6,9.8,1.7\r c17.7-0.5,25-13.4,25-13.4c0-0.4-0.1-0.8-0.1-1.2C-4870.4-6008.4-4877.9-5997.3-4894.2-5996.8z" })
			)
		)
	);
	
	var junta = exports.junta = _react2.default.createElement(
		"svg",
		{ version: "1.1", id: "Capa_1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
			viewBox: "0 0 120 120", enableBackground: "new 0 0 120 120", xmlSpace: "preserve", className: "borderND darkblue" },
		_react2.default.createElement(
			"g",
			{ id: "Group_5938", transform: "translate(5380.8 6589.3)" },
			_react2.default.createElement(
				"g",
				{ id: "Group_5940", transform: "translate(28.3 22.7)" },
				_react2.default.createElement("path", { id: "Path_3069", fill: "#2376D8", className: "whiteIcon", d: "M-5295.9-6492h-106.3c-3.8,0-6.8-3.1-6.8-6.8v-106.3c0-3.8,3.1-6.8,6.8-6.8h106.3\r c3.8,0,6.8,3.1,6.8,6.8v106.3C-5289.1-6495.1-5292.2-6492-5295.9-6492z" }),
				_react2.default.createElement("path", { id: "Path_3070", className: "transparentIconBlack", d: "M-5402.3-6492h106.3c3.8,0,6.8-3.1,6.8-6.8v-2.2c0,3.8-3.1,6.8-6.8,6.8h-106.3\r c-3.8,0-6.8-3.1-6.8-6.8v2.2C-5409.1-6495.1-5406-6492-5402.3-6492z" }),
				_react2.default.createElement("path", { id: "Path_3071", className: "transparentIconWhite", d: "M-5295.9-6612h-106.3c-3.8,0-6.8,3.1-6.8,6.8v2.2c0-3.8,3.1-6.8,6.8-6.8h106.3\r c3.8,0,6.8,3.1,6.8,6.8v-2.2C-5289.1-6608.9-5292.2-6612-5295.9-6612z" })
			),
			_react2.default.createElement("path", { id: "Path_3073", fill: "#F3F2F2", className: "blackIcon", d: "M-5355.7-6529.7c6.5,0,9.7,8,9.7,9.6v4.8h-19.5v-4.8\r C-5365.5-6521.7-5362.2-6529.7-5355.7-6529.7z" }),
			_react2.default.createElement("path", { id: "Path_3074", fill: "#F3F2F2", className: "blackIcon", d: "M-5321-6529.7c-6.5,0-19.5,3.2-19.5,9.6v4.8h39v-4.8C-5301.5-6526.5-5314.5-6529.7-5321-6529.7\r z" }),
			_react2.default.createElement("path", { id: "Path_3075", fill: "#FFFFFF", className: "st4", d: "M-5321-6529.7c-6.5,0-19.5,3.2-19.5,9.6v0.8c0-6.4,13-9.6,19.5-9.6c6.5,0,19.5,3.2,19.5,9.6\r v-0.8C-5301.5-6526.5-5314.5-6529.7-5321-6529.7z" }),
			_react2.default.createElement("ellipse", { id: "Ellipse_311", fill: "#F3F2F2", className: "blackIcon", cx: "-5321", cy: "-6544.2", rx: "9.7", ry: "9.6" }),
			_react2.default.createElement("ellipse", { id: "Ellipse_312", fill: "#E40AEF", className: "blackIcon", cx: "-5355.7", cy: "-6544.2", rx: "9.7", ry: "9.6" }),
			_react2.default.createElement("path", { id: "Path_3076", fill: "#FFFFFF", className: "blackIcon", d: "M-5355.7-6529.7c-6.5,0-9.7,8-9.7,9.6v0.8c0-1.6,3.3-9.6,9.7-9.6s9.7,8,9.7,9.6v-0.8\r C-5346-6521.7-5349.2-6529.7-5355.7-6529.7z" }),
			_react2.default.createElement("ellipse", { id: "Ellipse_313", fill: "#F3F2F2", className: "blackIcon", cx: "-5285.7", cy: "-6544.2", rx: "9.7", ry: "9.6" }),
			_react2.default.createElement("path", { id: "Path_3077", fill: "#F3F2F2", className: "blackIcon", d: "M-5285.7-6529.7c6.5,0,9.7,8,9.7,9.6v4.8h-19.5v-4.8\r C-5295.5-6521.7-5292.3-6529.7-5285.7-6529.7z" }),
			_react2.default.createElement("rect", { id: "Rectangle_3006", x: "-5372.6", y: "-6509.4", fill: "#F3F2F2", className: "blackIcon", width: "103.6", height: "4.7" }),
			_react2.default.createElement("path", { id: "Path_3078", fill: "#FFFFFF", className: "blackIcon", d: "M-5330.8-6543.7c0.2-5.4,4.7-9.6,10.1-9.4c5.1,0.2,9.2,4.3,9.4,9.4l0,0v-0.5\r c-0.1-5.4-4.5-9.7-9.8-9.6c-5.3,0.1-9.6,4.3-9.6,9.6V-6543.7z" }),
			_react2.default.createElement("path", { id: "Path_3079", fill: "#E5E5E4", className: "blackIcon", d: "M-5311.2-6544.7c-0.2,5.4-4.7,9.6-10.1,9.4c-5.1-0.2-9.2-4.3-9.4-9.4l0,0v0.5\r c0.1,5.4,4.5,9.7,9.8,9.6c5.3-0.1,9.6-4.3,9.6-9.6V-6544.7z" }),
			_react2.default.createElement("path", { id: "Path_3080", fill: "#FFFFFF", className: "blackIcon", d: "M-5295.5-6543.7c0.2-5.4,4.7-9.6,10.1-9.4c5.1,0.2,9.2,4.3,9.4,9.4l0,0v-0.5\r c-0.1-5.4-4.5-9.7-9.8-9.6c-5.3,0.1-9.6,4.3-9.6,9.6V-6543.7z" }),
			_react2.default.createElement("path", { id: "Path_3081", fill: "#E5E5E4", className: "blackIcon", d: "M-5276-6544.7c-0.2,5.4-4.7,9.6-10.1,9.4c-5.1-0.2-9.2-4.3-9.4-9.4l0,0v0.5\r c0.1,5.4,4.5,9.7,9.8,9.6c5.3-0.1,9.6-4.3,9.6-9.6V-6544.7z" }),
			_react2.default.createElement("ellipse", { id: "Ellipse_314", fill: "#F3F2F2", className: "blackIcon", cx: "-5355.7", cy: "-6544.2", rx: "9.7", ry: "9.6" }),
			_react2.default.createElement("path", { id: "Path_3082", fill: "#FFFFFF", className: "blackIcon", d: "M-5365.5-6543.7c0.2-5.4,4.7-9.6,10.1-9.4c5.1,0.2,9.2,4.3,9.4,9.4l0,0v-0.5\r c-0.1-5.4-4.5-9.7-9.8-9.6c-5.3,0.1-9.6,4.3-9.6,9.6C-5365.5-6544.2-5365.5-6543.7-5365.5-6543.7z" }),
			_react2.default.createElement("path", { id: "Path_3083", fill: "#E5E5E4", className: "blackIcon", d: "M-5346-6544.7c-0.2,5.4-4.7,9.6-10.1,9.4c-5.1-0.2-9.2-4.3-9.4-9.4l0,0v0.5\r c0.1,5.4,4.5,9.7,9.8,9.6c5.3-0.1,9.6-4.3,9.6-9.6V-6544.7z" }),
			_react2.default.createElement("rect", { id: "Rectangle_3007", x: "-5340.5", y: "-6516", fill: "#E5E5E4", className: "blackIcon", width: "39", height: "0.8" }),
			_react2.default.createElement("rect", { id: "Rectangle_3008", x: "-5372.6", y: "-6509.4", fill: "#FFFFFF", className: "blackIcon", width: "103.6", height: "0.8" }),
			_react2.default.createElement("rect", { id: "Rectangle_3009", x: "-5372.6", y: "-6505.6", fill: "#E5E5E4", className: "blackIcon", width: "103.6", height: "0.8" }),
			_react2.default.createElement("rect", { id: "Rectangle_3010", x: "-5365.5", y: "-6516", fill: "#E5E5E4", className: "blackIcon", width: "19.5", height: "0.8" }),
			_react2.default.createElement("rect", { id: "Rectangle_3011", x: "-5295.5", y: "-6516", fill: "#E5E5E4", className: "blackIcon", width: "19.5", height: "0.8" }),
			_react2.default.createElement("path", { id: "Path_3084", fill: "#FFFFFF", className: "blackIcon", d: "M-5285.7-6529.7c-6.5,0-9.7,8-9.7,9.6v0.8c0-1.6,3.3-9.6,9.7-9.6c6.5,0,9.7,8,9.7,9.6v-0.8\r C-5276-6521.7-5279.3-6529.7-5285.7-6529.7z" })
		)
	);
	
	var sistemas = exports.sistemas = _react2.default.createElement(
		"svg",
		{ version: "1.1", id: "Capa_1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
			viewBox: "0 0 120.1 120", enableBackground: "new 0 0 120.1 120", xmlSpace: "preserve", className: "borderND blue" },
		_react2.default.createElement(
			"g",
			{ id: "Group_6031", transform: "translate(5377.832 7180.5)" },
			_react2.default.createElement(
				"g",
				{ id: "Group_6032", transform: "translate(31.2 22.5)" },
				_react2.default.createElement("path", { id: "Path_3181", fill: "#269CF5", className: "whiteIcon", d: "M-5295.9-7083h-106.4c-3.8,0-6.8-3.1-6.8-6.8v-106.4c0-3.8,3.1-6.8,6.8-6.8h106.4\r c3.8,0,6.8,3.1,6.8,6.8v106.4C-5289-7086.1-5292.1-7083-5295.9-7083z" }),
				_react2.default.createElement("path", { id: "Path_3182", className: "transparentIconBlack", d: "M-5402.2-7083h106.4c3.8,0,6.8-3.1,6.8-6.8v-2.2c0,3.8-3.1,6.8-6.8,6.8h-106.4\r c-3.8,0-6.8-3.1-6.8-6.8v2.2C-5409-7086.1-5406-7083-5402.2-7083C-5402.2-7083-5402.2-7083-5402.2-7083z" }),
				_react2.default.createElement("path", { id: "Path_3183", className: "transparentIconWhite", d: "M-5295.9-7203h-106.4c-3.8,0-6.8,3.1-6.8,6.8v2.2c0-3.8,3.1-6.8,6.8-6.8h106.4\r c3.8,0,6.8,3.1,6.8,6.8v-2.2C-5289-7199.9-5292.1-7203-5295.9-7203z" })
			),
			_react2.default.createElement(
				"g",
				{ id: "Group_6035", transform: "translate(39.382 50.591)" },
				_react2.default.createElement("path", { id: "Path_3185", fill: "#F3F2F2", className: "blackIcon", d: "M-5351.7-7149l0.5-0.4l-0.5-0.4c-1.7-1.3-2.8-3.3-3-5.5h-38.5v-39.8h63.6v17h7.2\r c0.3,0,0.5,0,0.8,0.1v-17c0-4.4-3.6-8-8-8h-63.6c-4.4,0-8,3.6-8,8v39.8c0,4.4,3.6,8,8,8h-15.9v8h55.2\r C-5355.5-7142.6-5354.6-7146.7-5351.7-7149z" })
			),
			_react2.default.createElement(
				"g",
				{ id: "Group_6036", transform: "translate(47.291 50.659)" },
				_react2.default.createElement("path", { id: "Path_3186", fill: "#FFFFFF", className: "blackIcon", d: "M-5337.4-7203h-63.6c-4.4,0-8,3.6-8,8v1.4c0-4.4,3.6-8,8-8h63.6c4.4,0,8,3.6,8,8v-1.4\r C-5329.4-7199.4-5333-7203-5337.4-7203C-5337.4-7203-5337.4-7203-5337.4-7203z" })
			),
			_react2.default.createElement(
				"g",
				{ id: "Group_6037", transform: "translate(55.268 98.386)", opacity: "0.3", className: "blackIcon" },
				_react2.default.createElement("path", { id: "Path_3187", fill: "#FFFFFF", className: "blackIcon", d: "M-5370.5-7203h-38.5v1.4h37.6c0.2,2,1.7,4,3.3,5.3c0.1-0.1,0.3-0.3,0.5-0.4l0.5-0.4l-0.5-0.4\r C-5369.3-7198.9-5370.3-7200.9-5370.5-7203z" })
			),
			_react2.default.createElement("path", { id: "Path_3188", fill: "#F3F2F2", className: "blackIcon", d: "M-5271.2-7096.7c0.2-1.4,0.2-2.8,0-4.2l4.6-3.6c0.4-0.3,0.5-0.9,0.3-1.4l-4.4-7.6\r c-0.2-0.5-0.8-0.7-1.3-0.5l-5.4,2.2c-1.1-0.9-2.4-1.6-3.7-2.1l-0.8-5.8c-0.1-0.5-0.6-0.9-1.1-0.9h-8.7c-0.5,0-1,0.4-1.1,0.9\r l-0.8,5.8c-1.3,0.6-2.5,1.3-3.7,2.1l-5.4-2.2c-0.5-0.2-1.1,0-1.3,0.5l-4.4,7.6c-0.3,0.5-0.2,1,0.3,1.4l4.6,3.6\r c-0.1,0.7-0.1,1.4-0.1,2.1s0.1,1.4,0.1,2.1l-4.6,3.6c-0.4,0.3-0.5,0.9-0.3,1.4l4.4,7.6c0.2,0.5,0.8,0.7,1.3,0.5l5.4-2.2\r c1.1,0.9,2.4,1.6,3.7,2.1l0.8,5.8c0.1,0.5,0.6,0.9,1.1,0.9h8.7c0.5,0,1-0.4,1.1-0.9l0.8-5.8c1.3-0.6,2.5-1.3,3.7-2.1l5.4,2.2\r c0.5,0.2,1.1,0,1.3-0.5l4.4-7.6c0.3-0.5,0.2-1-0.3-1.4L-5271.2-7096.7z M-5279.7-7098.8c0-0.2,0-0.5-0.1-0.7\r c-0.4,4.2-4.1,7.3-8.3,6.9c-3.6-0.3-6.5-3.2-6.9-6.9c0,0.2,0,0.5-0.1,0.7l0,0c0-4.2,3.4-7.6,7.6-7.6\r C-5283.1-7106.5-5279.7-7103-5279.7-7098.8L-5279.7-7098.8z" }),
			_react2.default.createElement(
				"g",
				{ id: "Group_6038", transform: "translate(116.018 82.432)" },
				_react2.default.createElement("path", { id: "Path_3189", fill: "#FFFFFF", className: "blackIcon", d: "M-5407.9-7201.7h9c0.5,0,1,0.4,1.1,0.9l-0.2-1.3c-0.1-0.5-0.6-0.9-1.1-0.9h-8.7\r c-0.5,0-1,0.4-1.1,0.9l-0.2,1.4C-5408.9-7201.3-5408.4-7201.7-5407.9-7201.7z" })
			),
			_react2.default.createElement("path", { id: "Path_3190", fill: "#FFFFFF", className: "blackIcon", d: "M-5281.1-7114l0.2,1.6c1.3,0.5,2.5,1.3,3.7,2.1c0.8-0.3,6.8-2.7,6.8-2.7l-0.3-0.5\r c-0.3-0.5-0.9-0.7-1.4-0.5l-5.4,2.2C-5278.6-7112.7-5279.8-7113.4-5281.1-7114z" }),
			_react2.default.createElement("path", { id: "Path_3191", fill: "#FFFFFF", className: "blackIcon", d: "M-5297.2-7111.8l-5.4-2.2c-0.5-0.2-1.1,0-1.4,0.5l-0.3,0.5c0,0,6,2.4,6.8,2.7\r c1.1-0.9,2.4-1.6,3.7-2.1l0.2-1.6C-5294.9-7113.4-5296.1-7112.7-5297.2-7111.8z" }),
			_react2.default.createElement("path", { id: "Path_3192", fill: "#FFFFFF", className: "blackIcon", d: "M-5271.2-7096.7c0,0.4-0.1,0.8-0.1,1.2c1,0.8,4.9,3.8,4.9,3.8c0.3-0.4,0.3-1.1-0.1-1.4\r C-5267-7093.4-5271.2-7096.7-5271.2-7096.7z" }),
			_react2.default.createElement("path", { id: "Path_3193", fill: "#FFFFFF", className: "blackIcon", d: "M-5303.4-7096.7c0,0.4,0.1,0.8,0.1,1.2c-1,0.8-4.9,3.8-4.9,3.8c-0.3-0.4-0.3-1.1,0.1-1.4\r C-5307.7-7093.4-5303.4-7096.7-5303.4-7096.7z" }),
			_react2.default.createElement(
				"g",
				{ id: "Group_6040", transform: "translate(39.382 57.205)" },
				_react2.default.createElement("rect", { id: "Rectangle_3075", x: "-5393.1", y: "-7203", opacity: "0.12", className: "blackIcon", width: "63.6", height: "1.4" }),
				_react2.default.createElement("path", { id: "Path_3194", fill: "#FFFFFF", className: "blackIcon", d: "M-5353.3-7153.9h-55.8v1.4h55C-5353.8-7153-5353.6-7153.5-5353.3-7153.9z" }),
				_react2.default.createElement("path", { id: "Path_3195", opacity: "0.12", className: "blackIcon", d: "M-5393.1-7147.3h-15.9v1.4h55.2c-0.2-0.4-0.4-0.9-0.5-1.4H-5393.1z" }),
				_react2.default.createElement("path", { id: "Path_3196", opacity: "0.12", className: "blackIcon", d: "M-5326.7-7148.4c4.2,0,7.6-3.4,7.6-7.6c0,0,0,0,0,0c0-0.2,0-0.5-0.1-0.7\r c-0.4,4.2-4.1,7.3-8.3,6.9c-3.6-0.3-6.5-3.2-6.9-6.9c0,0.2-0.1,0.5-0.1,0.7C-5334.3-7151.8-5330.9-7148.4-5326.7-7148.4z" }),
				_react2.default.createElement(
					"g",
					{ id: "Group_6039", transform: "translate(76.773 66.477)", opacity: "0.12", className: "blackIcon" },
					_react2.default.createElement("path", { id: "Path_3197", d: "M-5398.9-7202h-9c-0.5,0-1-0.4-1.1-0.9l0.2,1.3c0.1,0.5,0.6,0.9,1.1,0.9h8.7c0.5,0,1-0.4,1.1-0.9l0.2-1.4\r C-5397.9-7202.5-5398.4-7202.1-5398.9-7202z" })
				),
				_react2.default.createElement("path", { id: "Path_3198", opacity: "0.12", className: "blackIcon", d: "M-5332.9-7140.9l-0.2-1.6c-1.3-0.5-2.5-1.3-3.7-2.1c-0.8,0.3-6.8,2.7-6.8,2.7l0.3,0.5\r c0.3,0.5,0.9,0.7,1.4,0.5l5.4-2.2C-5335.5-7142.1-5334.3-7141.4-5332.9-7140.9z" }),
				_react2.default.createElement("path", { id: "Path_3199", opacity: "0.12", className: "blackIcon", d: "M-5316.8-7143l5.4,2.2c0.5,0.2,1.1,0,1.4-0.5l0.3-0.5c0,0-6-2.4-6.8-2.7\r c-1.1,0.9-2.4,1.6-3.7,2.1l-0.2,1.6C-5319.2-7141.4-5317.9-7142.2-5316.8-7143z" }),
				_react2.default.createElement("path", { id: "Path_3200", opacity: "0.12", className: "blackIcon", d: "M-5342.8-7158.1c0-0.4,0.1-0.8,0.1-1.2c-1-0.8-4.9-3.8-4.9-3.8c-0.3,0.4-0.3,1.1,0.1,1.4\r C-5347.1-7161.4-5342.8-7158.1-5342.8-7158.1z" }),
				_react2.default.createElement("path", { id: "Path_3201", opacity: "0.12", className: "blackIcon", d: "M-5310.6-7158.1c0-0.4-0.1-0.8-0.1-1.2c1-0.8,4.9-3.8,4.9-3.8c0.3,0.4,0.3,1.1-0.1,1.4\r C-5306.4-7161.4-5310.6-7158.1-5310.6-7158.1z" }),
				_react2.default.createElement("path", { id: "Path_3202", opacity: "0.12", className: "blackIcon", d: "M-5329.5-7184.7h7.2c0.3,0,0.5,0,0.8,0.1l0,0v-1.4h-8V-7184.7z" })
			)
		)
	);
	
	var conSupervisor = exports.conSupervisor = _react2.default.createElement(
		"svg",
		{ version: "1.1", id: "Capa_1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
			viewBox: "0 0 120 120", enableBackground: "new 0 0 120 120", xmlSpace: "preserve", className: "borderND orange" },
		_react2.default.createElement(
			"g",
			{ id: "Group_6198", transform: "translate(5379.4 5985.4)" },
			_react2.default.createElement("path", { id: "Path_3360", fill: "#FF6200", className: "whiteIcon", d: "M-5266.2-5865.4h-106.4c-3.8,0-6.8-3.1-6.8-6.8v-106.4c0-3.8,3.1-6.8,6.8-6.8h106.4\r c3.8,0,6.8,3.1,6.8,6.8v106.4C-5259.4-5868.5-5262.4-5865.4-5266.2-5865.4C-5266.2-5865.4-5266.2-5865.4-5266.2-5865.4z" }),
			_react2.default.createElement("path", { id: "Path_3361", className: "transparentIconBlack", d: "M-5372.6-5865.4h106.4c3.8,0,6.8-3.1,6.8-6.8v-2.2c0,3.8-3.1,6.8-6.8,6.8h-106.4\r c-3.8,0-6.8-3.1-6.8-6.8v2.2C-5379.4-5868.5-5376.3-5865.4-5372.6-5865.4z" }),
			_react2.default.createElement("path", { id: "Path_3362", className: "transparentIconWhite", d: "M-5266.2-5985.4h-106.4c-3.8,0-6.8,3.1-6.8,6.8v2.2c0-3.8,3.1-6.8,6.8-6.8h106.4\r c3.8,0,6.8,3.1,6.8,6.8v-2.2C-5259.4-5982.3-5262.4-5985.4-5266.2-5985.4C-5266.2-5985.4-5266.2-5985.4-5266.2-5985.4z" }),
			_react2.default.createElement(
				"g",
				{ id: "Group_6202", transform: "translate(50.6 40.623)" },
				_react2.default.createElement(
					"g",
					{ id: "Group_943_2_", transform: "translate(0.136 49.472)" },
					_react2.default.createElement("path", { id: "Path_550_2_", fill: "#F3F2F2", className: "blackIcon", d: "M-5357.2-6010c-1.2,22.8-12.9,33.3-12.9,33.3s-11.6-10.6-12.9-33.3\r c-12.4,2.8-25.9,9.1-26,18.5c14.1,21.5,43,27.5,64.5,13.3c5.3-3.5,9.9-8,13.3-13.3C-5331.3-6000.9-5344.8-6007.2-5357.2-6010" })
				),
				_react2.default.createElement(
					"g",
					{ id: "Group_944_2_", transform: "translate(21.058)" },
					_react2.default.createElement("path", { id: "Path_551_2_", fill: "#F3F2F2", className: "blackIcon", d: "M-5390.7-6010c10.1,0,18.3,8.2,18.3,18.3c0,10.1-8.2,18.3-18.3,18.3l0,0\r c-10.1,0-18.3-8.2-18.3-18.3C-5409.1-6001.8-5400.9-6010-5390.7-6010" })
				),
				_react2.default.createElement(
					"g",
					{ id: "Group_945_2_", transform: "translate(34.203 47.905)" },
					_react2.default.createElement("path", { id: "Path_552_2_", fill: "#F3F2F2", className: "blackIcon", d: "M-5405.5-6010l-3.5,4.7l2.5,3.8l-2.5,7l3.5,11l1.4,4l1.4-4l3.4-11l-2.5-7l2.5-3.8l-3.4-4.7\r H-5405.5z" })
				),
				_react2.default.createElement("path", { id: "Path_3364", fill: "#FFFFFF", className: "blackIcon", d: "M-5382.9-5959.2c1.3,22.7,12.9,33.3,12.9,33.3s11.7-10.4,12.9-33.3\r c11.8,2.7,24.7,8.5,25.9,17.2c0-0.1,0.1-0.1,0.1-0.1c-0.1-9.4-13.6-15.7-26-18.5c-1.2,22.8-12.9,33.3-12.9,33.3\r s-11.6-10.6-12.9-33.3c-12.4,2.8-25.9,9.1-26,18.5c0,0.1,0.1,0.1,0.1,0.1C-5407.6-5950.6-5394.7-5956.5-5382.9-5959.2z" }),
				_react2.default.createElement("path", { id: "Path_3365", fill: "#FFFFFF", className: "blackIcon", d: "M-5369.7-6008.6c9.9,0,17.9,7.8,18.3,17.7v-0.7c0.1-10.1-8-18.3-18.1-18.4\r c-10.1-0.1-18.3,8-18.4,18.1c0,0.1,0,0.2,0,0.3v0.7C-5387.6-6000.8-5379.5-6008.6-5369.7-6008.6z" }),
				_react2.default.createElement(
					"g",
					{ id: "Group_6200", transform: "translate(34.227 47.864)" },
					_react2.default.createElement("path", { id: "Path_3366", fill: "#FFFFFF", className: "blackIcon", d: "M-5405.6-6008.6h2.8l2.9,4l0.5-0.8l-3.4-4.7h-2.8l-3.4,4.7l0.5,0.8L-5405.6-6008.6z" })
				),
				_react2.default.createElement("path", { id: "Path_3367", fill: "#E5E5E4", className: "blackIcon", d: "M-5370-5922.5c-15.6,0-30.2-7.8-38.9-20.9c-0.1,0.4-0.1,0.8-0.1,1.2\r c14.1,21.5,43,27.5,64.5,13.3c5.3-3.5,9.9-8,13.3-13.3c0-0.4-0.1-0.8-0.1-1.2C-5339.8-5930.3-5354.4-5922.4-5370-5922.5z" }),
				_react2.default.createElement("path", { id: "Path_3368", fill: "#D9D8D8", className: "blackIcon", d: "M-5369.7-5974.7L-5369.7-5974.7c-9.9,0-17.9-7.8-18.3-17.7v0.7c0,10.1,8.1,18.3,18.2,18.3\r c0,0,0,0,0,0l0,0c10.1,0,18.3-8.2,18.3-18.3v-0.7C-5351.8-5982.5-5359.8-5974.7-5369.7-5974.7z" }),
				_react2.default.createElement(
					"g",
					{ id: "Group_6201", transform: "translate(34.227 52.636)" },
					_react2.default.createElement("path", { id: "Path_3369", fill: "#E5E5E4", className: "blackIcon", d: "M-5406.2-6007.2l-1.8-2.8l-0.5,0.7l2,3L-5406.2-6007.2z" }),
					_react2.default.createElement("path", { id: "Path_3370", fill: "#E5E5E4", className: "blackIcon", d: "M-5402.2-6007.2l1.8-2.8l0.5,0.7l-2,3L-5402.2-6007.2z" }),
					_react2.default.createElement("path", { id: "Path_3371", fill: "#E5E5E4", className: "blackIcon", d: "M-5402.9-5989.6l-1.4,4l-1.4-4l-3.2-10.3l-0.2,0.6l3.4,11l1.4,4l1.4-4l3.5-11l-0.2-0.6\r L-5402.9-5989.6z" })
				)
			)
		)
	);
	
	var dinero = exports.dinero = _react2.default.createElement(
		"svg",
		{ xmlns: "http://www.w3.org/2000/svg", viewBox: "5409 9578 120 120", className: "borderND greenSoft" },
		_react2.default.createElement(
			"g",
			{ id: "Group_6242", "data-name": "Group 6242", transform: "translate(5409 9578)" },
			_react2.default.createElement(
				"g",
				{ id: "Group_6242-2", "data-name": "Group 6242" },
				_react2.default.createElement("path", { id: "Path_3416", "data-name": "Path 3416", fill: "#06c332", className: "whiteIcon", d: "M113.182,120H6.818A6.838,6.838,0,0,1,0,113.182V6.818A6.838,6.838,0,0,1,6.818,0H113.182A6.838,6.838,0,0,1,120,6.818V113.182A6.838,6.838,0,0,1,113.182,120Z" }),
				_react2.default.createElement("path", { id: "Path_3417", "data-name": "Path 3417", className: "transparentIconBlack", d: "M6.818,171.8H113.182A6.838,6.838,0,0,0,120,164.982V162.8a6.838,6.838,0,0,1-6.818,6.818H6.818A6.838,6.838,0,0,1,0,162.8v2.182A6.838,6.838,0,0,0,6.818,171.8Z", transform: "translate(0 -51.8)" }),
				_react2.default.createElement("path", { id: "Path_3418", "data-name": "Path 3418", className: "transparentIconWhite", d: "M113.182,0H6.818A6.838,6.838,0,0,0,0,6.818V9A6.838,6.838,0,0,1,6.818,2.182H113.182A6.838,6.838,0,0,1,120,9V6.818A6.838,6.838,0,0,0,113.182,0Z" })
			),
			_react2.default.createElement(
				"g",
				{ id: "Group_6243", "data-name": "Group 6243", transform: "translate(16.364 16.364)" },
				_react2.default.createElement("path", { id: "Path_3419", "data-name": "Path 3419", fill: "#f3f2f2", className: "blackIcon", d: "M67.636,24a43.636,43.636,0,1,0,43.636,43.636A43.677,43.677,0,0,0,67.636,24Zm0,78.545a34.909,34.909,0,1,1,34.909-34.909A34.977,34.977,0,0,1,67.636,102.545Z", transform: "translate(-24 -24)" }),
				_react2.default.createElement("path", { id: "Path_3420", "data-name": "Path 3420", fill: "#f3f2f2", className: "blackIcon", d: "M82.618,72.577C76,70.873,73.891,69.1,73.891,66.3c0-3.2,2.932-5.386,7.841-5.386,5.182,0,7.091,2.455,7.3,6.136h6.409A11.679,11.679,0,0,0,86.1,55.941V49.6H77.436v6.273c-5.659,1.227-10.159,4.909-10.159,10.5,0,6.75,5.523,10.091,13.7,12,7.3,1.773,8.727,4.3,8.727,7.023,0,1.977-1.432,5.182-7.841,5.182-6,0-8.318-2.659-8.659-6.136H66.8c.341,6.341,5.114,9.955,10.7,11.114V101.9h8.727V95.623c5.659-1.091,10.159-4.364,10.159-10.3C96.323,77.145,89.232,74.282,82.618,72.577Z", transform: "translate(-37.618 -32.145)" }),
				_react2.default.createElement("path", { id: "Path_3421", "data-name": "Path 3421", fill: "#fff", className: "blackIcon", d: "M71.709,124.591a34.977,34.977,0,0,0,34.909-34.909V89A34.916,34.916,0,0,1,36.8,89v.682A34.977,34.977,0,0,0,71.709,124.591Z", transform: "translate(-28.073 -44.682)" }),
				_react2.default.createElement("path", { id: "Path_3422", "data-name": "Path 3422", fill: "#fff", className: "blackIcon", d: "M67.636,25.364a43.669,43.669,0,0,1,43.636,42.955v-.682a43.636,43.636,0,0,0-87.273,0v.682A43.669,43.669,0,0,1,67.636,25.364Z", transform: "translate(-24 -24)" }),
				_react2.default.createElement("path", { id: "Path_3423", "data-name": "Path 3423", fill: "#fff", className: "blackIcon", d: "M95.2,60.364a11.6,11.6,0,0,1,9.2,9.75h.136A11.679,11.679,0,0,0,95.2,59Z", transform: "translate(-46.655 -35.136)" }),
				_react2.default.createElement("path", { id: "Path_3424", "data-name": "Path 3424", fill: "#fff", className: "blackIcon", d: "M85.927,80.691c-6.068-1.568-8.318-3.2-8.659-5.591,0,.2-.068.477-.068.682,0,2.8,2.114,4.568,8.727,6.273,6.409,1.636,13.159,4.364,13.636,12v-.545C99.632,85.259,92.541,82.4,85.927,80.691Z", transform: "translate(-40.927 -40.259)" }),
				_react2.default.createElement("path", { id: "Path_3425", "data-name": "Path 3425", fill: "#fff", className: "blackIcon", d: "M77.659,60.164V58.8C72,60.027,67.5,63.709,67.5,69.3a2.32,2.32,0,0,0,.068.682C67.841,64.8,72.2,61.323,77.659,60.164Z", transform: "translate(-37.841 -35.073)" }),
				_react2.default.createElement("rect", { id: "Rectangle_3266", "data-name": "Rectangle 3266", fill: "#fff", className: "blackIcon", width: "8.727", height: "1.364", transform: "translate(39.818 17.455)" }),
				_react2.default.createElement("path", { id: "Path_3426", "data-name": "Path 3426", fill: "#fff", className: "blackIcon", d: "M73.077,102.164c.341,3.409,2.659,6.136,8.659,6.136,6.409,0,7.841-3.2,7.841-5.182a2.8,2.8,0,0,0-.068-.75c-.273,1.977-1.977,4.568-7.841,4.568-6,0-8.318-2.659-8.659-6.136H66.6a8.394,8.394,0,0,0,.136,1.364Z", transform: "translate(-37.555 -48.436)" }),
				_react2.default.createElement("path", { id: "Path_3427", "data-name": "Path 3427", opacity: "0.12", className: "blackIcon", d: "M71.709,34.8A34.977,34.977,0,0,0,36.8,69.709v.682a34.916,34.916,0,0,1,69.818,0v-.682A34.977,34.977,0,0,0,71.709,34.8Z", transform: "translate(-28.073 -27.436)" }),
				_react2.default.createElement("path", { id: "Path_3428", "data-name": "Path 3428", opacity: "0.12", className: "blackIcon", d: "M67.636,129.955A43.669,43.669,0,0,1,24,87v.682a43.636,43.636,0,1,0,87.273,0V87A43.669,43.669,0,0,1,67.636,129.955Z", transform: "translate(-24 -44.045)" }),
				_react2.default.createElement("path", { id: "Path_3429", "data-name": "Path 3429", opacity: "0.12", className: "blackIcon", d: "M77.2,69.586a2.319,2.319,0,0,0,.068.682c.409-2.8,3.273-4.7,7.773-4.7,5.182,0,7.091,2.455,7.3,6.136h6.409a9.241,9.241,0,0,0-.136-1.364H92.336c-.2-3.614-2.114-6.136-7.3-6.136C80.2,64.268,77.2,66.45,77.2,69.586Z", transform: "translate(-40.927 -36.791)" }),
				_react2.default.createElement("path", { id: "Path_3430", "data-name": "Path 3430", opacity: "0.12", className: "blackIcon", d: "M81.1,85.95c6.614,1.568,8.386,3.818,8.659,6.273,0-.2.068-.409.068-.614,0-2.727-1.432-5.25-8.727-7.023-7.841-1.909-13.3-5.114-13.636-11.386,0,.2-.068.477-.068.682C67.4,80.632,72.991,83.973,81.1,85.95Z", transform: "translate(-37.809 -39.655)" }),
				_react2.default.createElement("path", { id: "Path_3431", "data-name": "Path 3431", opacity: "0.12", className: "blackIcon", d: "M95.2,110.65v1.364c5.659-1.091,10.159-4.364,10.159-10.3V100.9C105.086,106.491,100.655,109.627,95.2,110.65Z", transform: "translate(-46.655 -48.468)" }),
				_react2.default.createElement("rect", { id: "Rectangle_3267", "data-name": "Rectangle 3267", opacity: "0.12", className: "blackIcon", width: "8.727", height: "1.364", transform: "translate(39.818 68.455)" }),
				_react2.default.createElement("path", { id: "Path_3432", "data-name": "Path 3432", opacity: "0.12", className: "blackIcon", d: "M77.4,110.65c-5.182-1.091-9.614-4.227-10.568-9.75H66.7c.341,6.341,5.114,9.955,10.7,11.114Z", transform: "translate(-37.586 -48.468)" })
			)
		)
	);
	
	var duda = exports.duda = _react2.default.createElement(
		"svg",
		{ version: "1.1", id: "Capa_1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
			viewBox: "0 0 120.1 120", enableBackground: "new 0 0 120.1 120", xmlSpace: "preserve", className: "borderND pink" },
		_react2.default.createElement(
			"g",
			{ id: "Group_6099", transform: "translate(5378.731 8339.6)" },
			_react2.default.createElement(
				"g",
				{ id: "Group_6080", transform: "translate(30.3 24.4)" },
				_react2.default.createElement("path", { id: "Path_3230", fill: "#FF5CAD", className: "whiteIcon", d: "M-5295.8-8244h-106.4c-3.8,0-6.8-3.1-6.8-6.8v-106.4c0-3.8,3.1-6.8,6.8-6.8h106.4\r c3.8,0,6.8,3.1,6.8,6.8v106.4C-5289-8247.1-5292.1-8244-5295.8-8244C-5295.8-8244-5295.8-8244-5295.8-8244z" }),
				_react2.default.createElement("path", { id: "Path_3231", className: "transparentIconBlack", d: "M-5402.2-8244h106.4c3.8,0,6.8-3.1,6.8-6.8v-2.2c0,3.8-3.1,6.8-6.8,6.8h-106.4\r c-3.8,0-6.8-3.1-6.8-6.8v2.2C-5409-8247.1-5406-8244-5402.2-8244C-5402.2-8244-5402.2-8244-5402.2-8244z" }),
				_react2.default.createElement("path", { id: "Path_3232", className: "transparentIconWhite", d: "M-5295.8-8364h-106.4c-3.8,0-6.8,3.1-6.8,6.8v2.2c0-3.8,3.1-6.8,6.8-6.8h106.4\r c3.8,0,6.8,3.1,6.8,6.8v-2.2C-5289-8360.9-5292.1-8364-5295.8-8364z" })
			),
			_react2.default.createElement(
				"g",
				{ id: "Group_6085", transform: "translate(46.732 40.764)" },
				_react2.default.createElement("path", { id: "Path_3234", fill: "#F3F2F2", className: "blackIcon", d: "M-5369.8-8294.2h8.7v-8.7h-8.7V-8294.2z M-5365.4-8364c-24.1,0-43.6,19.5-43.6,43.6\r c0,24.1,19.5,43.6,43.6,43.6c24.1,0,43.6-19.5,43.6-43.6C-5321.8-8344.5-5341.3-8364-5365.4-8364z M-5365.4-8285.5\r c-19.3,0-34.9-15.6-34.9-34.9c0-19.3,15.6-34.9,34.9-34.9c19.3,0,34.9,15.6,34.9,34.9l0,0\r C-5330.5-8301.1-5346.1-8285.5-5365.4-8285.5z M-5365.4-8346.5c-9.6,0-17.4,7.8-17.5,17.5h8.7c0-4.8,3.9-8.7,8.7-8.7\r c4.8,0,8.7,3.9,8.7,8.7c0,8.7-13.1,7.6-13.1,21.8h8.7c0-9.8,13.1-10.9,13.1-21.8C-5347.9-8338.7-5355.7-8346.5-5365.4-8346.5\r C-5365.4-8346.5-5365.4-8346.5-5365.4-8346.5z" }),
				_react2.default.createElement(
					"g",
					{ id: "Group_6083", transform: "translate(0 0)" },
					_react2.default.createElement("rect", { id: "Rectangle_3100", x: "-5369.8", y: "-8302.9", fill: "#FFFFFF", className: "blackIcon", width: "8.7", height: "1.4" }),
					_react2.default.createElement("path", { id: "Path_3235", fill: "#FFFFFF", className: "blackIcon", d: "M-5365.4-8362.6c23.8,0,43.2,19.1,43.6,43v-0.7c0.1-24.1-19.3-43.7-43.4-43.8\r c-24.1-0.1-43.7,19.3-43.8,43.4c0,0.1,0,0.3,0,0.4v0.7C-5408.7-8343.5-5389.2-8362.6-5365.4-8362.6z" }),
					_react2.default.createElement("path", { id: "Path_3236", fill: "#FFFFFF", className: "blackIcon", d: "M-5356.7-8327.7v-0.7c-0.7,8-13.1,7.3-13.1,21.1h0.1\r C-5368.9-8320-5356.7-8319.3-5356.7-8327.7z" }),
					_react2.default.createElement("path", { id: "Path_3237", fill: "#FFFFFF", className: "blackIcon", d: "M-5365.4-8346.5c-9.6,0-17.4,7.8-17.5,17.5h0.1c0.8-9.6,9.2-16.8,18.8-16\r c8.8,0.7,15.7,7.8,16.1,16.6v-0.5C-5347.9-8338.7-5355.7-8346.5-5365.4-8346.5C-5365.4-8346.5-5365.4-8346.5-5365.4-8346.5z" }),
					_react2.default.createElement("path", { id: "Path_3238", fill: "#FFFFFF", className: "blackIcon", d: "M-5365.4-8284.1c19.3,0,34.9-15.6,34.9-34.9v-0.7c-0.4,19.3-16.3,34.6-35.6,34.2\r c-18.7-0.4-33.8-15.5-34.2-34.2v0.7C-5400.3-8299.7-5384.7-8284.1-5365.4-8284.1z" })
				),
				_react2.default.createElement(
					"g",
					{ id: "Group_6084", transform: "translate(0 7.364)", opacity: "0.12", className: "blackIcon" },
					_react2.default.createElement("path", { id: "Path_3239", d: "M-5374.1-8336.5c0-4.8,3.9-8.7,8.7-8.7c4.6,0,8.4,3.5,8.7,8.1v-0.7c0-4.8-3.9-8.7-8.7-8.7\r c-4.8,0-8.7,3.9-8.7,8.7h-8.5c0,0.2-0.1,0.8-0.1,1.4H-5374.1z" }),
					_react2.default.createElement("rect", { id: "Rectangle_3101", x: "-5369.8", y: "-8302.9", width: "8.7", height: "1.4" }),
					_react2.default.createElement("path", { id: "Path_3240", d: "M-5361-8314.6c0-9.8,13.1-10.9,13.1-21.8v-0.8c-0.4,10.4-13.1,11.6-13.1,21.3h-8.5c0,0.2-0.1,0.9-0.1,1.4\r L-5361-8314.6z" }),
					_react2.default.createElement("path", { id: "Path_3241", d: "M-5365.4-8364c-19.3,0-34.9,15.6-34.9,34.9v0.7c0.4-19.3,16.3-34.6,35.6-34.2\r c18.7,0.4,33.8,15.5,34.2,34.2v-0.7C-5330.5-8348.4-5346.1-8364-5365.4-8364z" }),
					_react2.default.createElement("path", { id: "Path_3242", d: "M-5365.4-8285.5c-23.8,0-43.2-19.1-43.6-43v0.7c0.1,24.1,19.7,43.5,43.8,43.4\r c23.9-0.1,43.3-19.5,43.4-43.4v-0.7C-5322.2-8304.6-5341.6-8285.5-5365.4-8285.5z" })
				)
			)
		)
	);
	
	var otro = exports.otro = _react2.default.createElement(
		"svg",
		{ version: "1.1", id: "Capa_1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
			viewBox: "0 0 120.1 120", enableBackground: "new 0 0 120.1 120", xmlSpace: "preserve", className: "borderND gray" },
		_react2.default.createElement(
			"g",
			{ id: "Group_6095", transform: "translate(4873.232 8340.2)" },
			_react2.default.createElement(
				"g",
				{ id: "Group_6087", transform: "translate(29.8 23.8)" },
				_react2.default.createElement("path", { id: "Path_3243", fill: "#8F98AA", className: "whiteIcon", d: "M-4789.9-8244h-106.4c-3.8,0-6.8-3.1-6.8-6.8v-106.4c0-3.8,3.1-6.8,6.8-6.8h106.4\r c3.8,0,6.8,3.1,6.8,6.8v106.4C-4783-8247.1-4786.1-8244-4789.9-8244z" }),
				_react2.default.createElement("path", { id: "Path_3244", className: "transparentIconBlack", d: "M-4896.2-8244h106.4c3.8,0,6.8-3.1,6.8-6.8v-2.2c0,3.8-3.1,6.8-6.8,6.8h-106.4\r c-3.8,0-6.8-3.1-6.8-6.8v2.2C-4903-8247.1-4900-8244-4896.2-8244z" }),
				_react2.default.createElement("path", { id: "Path_3245", className: "transparentIconWhite", d: "M-4789.9-8364h-106.4c-3.8,0-6.8,3.1-6.8,6.8v2.2c0-3.8,3.1-6.8,6.8-6.8h106.4\r c3.8,0,6.8,3.1,6.8,6.8v-2.2C-4783-8360.9-4786.1-8364-4789.9-8364C-4789.8-8364-4789.8-8364-4789.9-8364z" })
			),
			_react2.default.createElement(
				"g",
				{ id: "Group_6090", transform: "translate(46.164 40.095)" },
				_react2.default.createElement("path", { id: "Path_3247", fill: "#F3F2F2", className: "blackIcon", d: "M-4859.5-8364c-24.1,0-43.6,19.6-43.6,43.7s19.6,43.6,43.7,43.6c24.1,0,43.6-19.6,43.6-43.6\r c0-24.1-19.5-43.6-43.6-43.6C-4859.4-8364-4859.4-8364-4859.5-8364z M-4859.4-8285.4c-19.3,0-34.9-15.6-34.9-34.9\r c0-19.3,15.6-34.9,34.9-34.9c19.3,0,34.9,15.6,34.9,34.9C-4824.5-8301-4840.1-8285.4-4859.4-8285.4\r C-4859.4-8285.4-4859.4-8285.4-4859.4-8285.4z" }),
				_react2.default.createElement("path", { id: "Path_3248", fill: "#F3F2F2", className: "blackIcon", d: "M-4857.2-8342.2h-6.5v26.2l22.9,13.8l3.3-5.4l-19.6-11.6L-4857.2-8342.2z" })
			),
			_react2.default.createElement(
				"g",
				{ id: "Group_6091", transform: "translate(46.095 40.164)" },
				_react2.default.createElement("path", { id: "Path_3249", fill: "#FFFFFF", className: "blackIcon", d: "M-4859.4-8362c23.7,0,43.1,18.9,43.6,42.6v-1c0-24.1-19.5-43.6-43.6-43.6\r c-24.1,0-43.6,19.5-43.6,43.6v1C-4902.4-8343-4883.1-8361.9-4859.4-8362z" }),
				_react2.default.createElement("path", { id: "Path_3250", fill: "#FFFFFF", className: "blackIcon", d: "M-4859.3-8283.4c19.3,0,34.9-15.6,34.9-34.9c0,0,0,0,0,0v-1c-0.6,19.3-16.7,34.5-35.9,33.9\r c-18.5-0.5-33.3-15.4-33.9-33.9v1C-4894.2-8299-4878.6-8283.4-4859.3-8283.4z" })
			),
			_react2.default.createElement(
				"g",
				{ id: "Group_6092", transform: "translate(85.436 61.982)" },
				_react2.default.createElement("path", { id: "Path_3251", fill: "#FFFFFF", className: "blackIcon", d: "M-4896.5-8341.1v2l18.7,11l1-1.5L-4896.5-8341.1z" }),
				_react2.default.createElement("rect", { id: "Rectangle_3103", fill: "#FFFFFF", x: "-4903", y: "-8364", className: "blackIcon", width: "6.5", height: "2" })
			),
			_react2.default.createElement(
				"g",
				{ id: "Group_6093", transform: "translate(46.164 46.845)", opacity: "0.12", className: "blackIcon" },
				_react2.default.createElement("path", { id: "Path_3252", d: "M-4859.4-8364c-19.3,0-34.9,15.6-34.9,34.9c0,0,0,0,0,0v1c0.6-19.3,16.7-34.5,35.9-33.9\r c18.5,0.5,33.3,15.4,33.9,33.9v-1C-4824.5-8348.4-4840.1-8364-4859.4-8364C-4859.4-8364-4859.4-8364-4859.4-8364z" }),
				_react2.default.createElement("path", { id: "Path_3253", d: "M-4859.5-8285.5c-23.7,0-43-18.9-43.6-42.6v1c0,24.1,19.5,43.6,43.6,43.6c24.1,0,43.6-19.5,43.6-43.6v-1\r C-4816.4-8304.4-4835.7-8285.4-4859.5-8285.5z" })
			),
			_react2.default.createElement("path", { id: "Path_3254", opacity: "0.12", className: "blackIcon", d: "M-4793.8-8263.6l-0.9,1.5l-22.9-13.7v-2L-4793.8-8263.6z" })
		)
	);
	
	var queja = exports.queja = _react2.default.createElement(
		"svg",
		{ version: "1.1", id: "Capa_1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
			viewBox: "0 0 120 120", enableBackground: "new 0 0 120 120", xmlSpace: "preserve", className: "borderND orangeSoft" },
		_react2.default.createElement(
			"g",
			{ id: "Group_6233", transform: "translate(4872.899 9554.1)" },
			_react2.default.createElement(
				"g",
				{ id: "Group_6233-2", transform: "translate(30.1 23.9)" },
				_react2.default.createElement("path", { id: "Path_3401", fill: "#FF6622", className: "whiteIcon", d: "M-4789.8-9458h-106.4c-3.8,0-6.8-3.1-6.8-6.8v-106.4c0-3.8,3.1-6.8,6.8-6.8h106.4\r c3.8,0,6.8,3.1,6.8,6.8v106.4C-4783-9461.1-4786.1-9458-4789.8-9458z" }),
				_react2.default.createElement("path", { id: "Path_3402", className: "transparentIconBlack", d: "M-4896.2-9458h106.4c3.8,0,6.8-3.1,6.8-6.8v-2.2c0,3.8-3.1,6.8-6.8,6.8h-106.4\r c-3.8,0-6.8-3.1-6.8-6.8v2.2C-4903-9461.1-4899.9-9458-4896.2-9458z" }),
				_react2.default.createElement("path", { id: "Path_3403", className: "transparentIconWhite", d: "M-4789.8-9578h-106.4c-3.8,0-6.8,3.1-6.8,6.8v2.2c0-3.8,3.1-6.8,6.8-6.8h106.4\r c3.8,0,6.8,3.1,6.8,6.8v-2.2C-4783-9574.9-4786-9578-4789.8-9578C-4789.8-9578-4789.8-9578-4789.8-9578z" })
			),
			_react2.default.createElement(
				"g",
				{ id: "Group_6236", transform: "translate(39.645 39.718)" },
				_react2.default.createElement("path", { id: "Path_3405", fill: "#F3F2F2", className: "blackIcon", d: "M-4830.9-9578c-16.6,0-30.2,9.9-30.2,22.1c0,7.6,5.2,14.4,13.3,18.3c-0.3,1.2-1.1,3.5-3.7,6.6\r c-0.7,0.6-0.8,1.6-0.2,2.3c0.3,0.4,0.8,0.6,1.3,0.6c5.9-0.3,11.6-2.4,16.4-5.9c1,0.1,2,0.1,3.1,0.1c16.6,0,30.1-9.9,30.1-22.2\r C-4800.7-9568.1-4814.2-9578-4830.9-9578z M-4828.2-9542.3h-5.5v-5.5h5.5V-9542.3z M-4828.2-9553.3h-5.5v-16.4h5.5V-9553.3z" }),
				_react2.default.createElement("circle", { id: "Ellipse_322", fill: "#F3F2F2", className: "blackIcon", cx: "-4874.8", cy: "-9539.6", r: "14.1" }),
				_react2.default.createElement("path", { id: "Path_3406", fill: "#F3F2F2", className: "blackIcon", d: "M-4903-9502c0,0,0.9-14.5,28.2-14.5c23.7,0,28.2,10.6,28.2,14.5c0,0-8.2,14.5-28.2,15.1\r C-4894.6-9487.4-4903-9502-4903-9502z" }),
				_react2.default.createElement("path", { id: "Path_3407", fill: "#FFFFFF", className: "blackIcon", d: "M-4830.9-9576.6c16.4,0,29.7,9.5,30.1,21.4v-0.7c0-12.2-13.5-22.1-30.1-22.1\r c-16.6,0-30.2,9.9-30.2,22.1v0.6C-4860.5-9567.2-4847.2-9576.6-4830.9-9576.6z" }),
				_react2.default.createElement("rect", { id: "Rectangle_3262", x: "-4833.7", y: "-9542.3", opacity: "0.12", className: "className", width: "5.5", height: "1.4" }),
				_react2.default.createElement("path", { id: "Path_3408", fill: "#FFFFFF", className: "blackIcon", d: "M-4847.2-9537.2c0,0-0.5-0.3-0.6-0.3c-0.7,2.4-2,4.7-3.7,6.6c-0.5,0.5-0.7,1.3-0.4,2\r c0.1-0.2,0.2-0.5,0.4-0.7C-4849.5-9531.8-4848.1-9534.4-4847.2-9537.2z" }),
				_react2.default.createElement("rect", { id: "Rectangle_3263", x: "-4833.7", y: "-9553.3", opacity: "0.12", className: "st5", width: "5.5", height: "1.4" }),
				_react2.default.createElement("path", { id: "Path_3409", fill: "#FFFFFF", className: "blackIcon", d: "M-4874.8-9552.3c7.5,0,13.7,5.9,14,13.4c0-0.2,0.1-0.5,0.1-0.7c0.1-7.8-6.2-14.2-14-14.2\r c-7.8-0.1-14.2,6.2-14.2,14c0,0.1,0,0.2,0,0.2c0,0.2,0,0.5,0.1,0.7C-4888.5-9546.4-4882.4-9552.3-4874.8-9552.3z" }),
				_react2.default.createElement("path", { id: "Path_3410", fill: "#FFFFFF", className: "blackIcon", d: "M-4874.8-9515.2c21.6,0,27.3,8.8,28.1,13.3c0-0.1,0.1-0.1,0.1-0.2c0-3.8-4.5-14.5-28.2-14.5\r c-27.3,0-28.2,14.5-28.2,14.5c0.1,0.1,0.1,0.2,0.2,0.3C-4902-9505-4897.6-9515.2-4874.8-9515.2z" }),
				_react2.default.createElement("rect", { id: "Rectangle_3264", x: "-4833.7", y: "-9549.2", fill: "#FFFFFF", className: "blackIcon", width: "5.5", height: "1.4" }),
				_react2.default.createElement("rect", { id: "Rectangle_3265", x: "-4833.7", y: "-9571.1", fill: "#FFFFFF", className: "blackIcon", width: "5.5", height: "1.4" }),
				_react2.default.createElement("path", { id: "Path_3411", opacity: "0.12", className: "blackIcon", d: "M-4830.9-9535.1c-1,0-2-0.1-3.1-0.1c-4.8,3.5-10.5,5.6-16.4,5.9c-0.6,0-1.2-0.3-1.5-0.9\r c-0.4,0.8-0.1,1.7,0.7,2.1c0.2,0.1,0.5,0.2,0.8,0.2c5.9-0.3,11.6-2.4,16.4-5.9c1,0.1,2,0.1,3.1,0.1c16.6,0,30.1-9.9,30.1-22.2\r v-0.7C-4801.3-9544.7-4814.6-9535.1-4830.9-9535.1z" }),
				_react2.default.createElement("path", { id: "Path_3412", opacity: "0.12", className: "blackIcon", d: "M-4874.8-9526.9c-7.5,0-13.7-5.9-14-13.4c0,0.2-0.1,0.5-0.1,0.7c0.1,7.8,6.4,14.1,14.2,14\r c7.7-0.1,13.9-6.3,14-14c0-0.2,0-0.5-0.1-0.7C-4861.1-9532.8-4867.3-9526.9-4874.8-9526.9z" }),
				_react2.default.createElement("path", { id: "Path_3413", opacity: "0.12", className: "blackIcon", d: "M-4874.8-9488.3c-18.1-0.4-26.7-12.7-28-14.7l-0.2,1c0,0,8.4,14.6,28.2,15.1\r c19.9-0.6,28.2-15.1,28.2-15.1c0-0.4-0.1-0.8-0.1-1.2C-4847.8-9501.5-4856.3-9488.9-4874.8-9488.3z" })
			)
		)
	);
	
	var salud = exports.salud = _react2.default.createElement(
		"svg",
		{ version: "1.1", id: "Capa_1", xmlns: "http://www.w3.org/2000/svg", xlinkHref: "http://www.w3.org/1999/xlink", x: "0px", y: "0px",
			viewBox: "0 0 120 120", enableBackground: "new 0 0 120 120", xmlSpace: "preserve", className: "borderND redSoft" },
		_react2.default.createElement(
			"g",
			{ id: "Group_6118", transform: "translate(4873.399 8932.1)" },
			_react2.default.createElement(
				"g",
				{ id: "Group_6119", transform: "translate(29.6 24.9)" },
				_react2.default.createElement("path", { id: "Path_3268", fill: "#ED1C24", className: "whiteIcon", d: "M-4789.8-8837h-106.4c-3.8,0-6.8-3.1-6.8-6.8v-106.4c0-3.8,3.1-6.8,6.8-6.8h106.4\r c3.8,0,6.8,3.1,6.8,6.8v106.4C-4783-8840.1-4786.1-8837-4789.8-8837z" }),
				_react2.default.createElement("path", { id: "Path_3269", className: "transparentIconBlack", d: "M-4896.2-8837h106.4c3.8,0,6.8-3.1,6.8-6.8v-2.2c0,3.8-3.1,6.8-6.8,6.8h-106.4\r c-3.8,0-6.8-3.1-6.8-6.8v2.2C-4903-8840.1-4899.9-8837-4896.2-8837z" }),
				_react2.default.createElement("path", { id: "Path_3270", className: "transparentIconWhite", d: "M-4789.8-8957h-106.4c-3.8,0-6.8,3.1-6.8,6.8v2.2c0-3.8,3.1-6.8,6.8-6.8h106.4\r c3.8,0,6.8,3.1,6.8,6.8v-2.2C-4783-8953.9-4786-8957-4789.8-8957C-4789.8-8957-4789.8-8957-4789.8-8957z" })
			),
			_react2.default.createElement("path", { id: "Path_3272", fill: "#F3F2F2", className: "blackIcon", d: "M-4783.9-8910.5h-59.7c-4.7,0-8.5,3.8-8.5,8.5c0,0,0,0,0,0l-0.1,59.7c0,4.7,3.8,8.5,8.5,8.5\r h59.7c4.7,0,8.5-3.8,8.5-8.5v-59.7C-4775.4-8906.7-4779.2-8910.5-4783.9-8910.5z M-4788.2-8863.6h-17v17h-17v-17h-17v-17h17v-17h17\r v17h17L-4788.2-8863.6z" }),
			_react2.default.createElement("rect", { id: "Rectangle_3127", x: "-4839.3", y: "-8882", fill: "#FFFFFF", className: "blackIcon", width: "17", height: "1.4" }),
			_react2.default.createElement("rect", { id: "Rectangle_3128", x: "-4822.3", y: "-8899", fill: "#FFFFFF", className: "blackIcon", width: "17", height: "1.4" }),
			_react2.default.createElement("rect", { id: "Rectangle_3129", x: "-4805.2", y: "-8882", fill: "#FFFFFF", className: "blackIcon", width: "17", height: "1.4" }),
			_react2.default.createElement("path", { id: "Path_3273", opacity: "0.12", className: "blackIcon", d: "M-4783.9-8835.1h-59.7c-4.7,0-8.5-3.8-8.5-8.5v1.4c0,4.7,3.8,8.5,8.5,8.5h59.7\r c4.7,0,8.5-3.8,8.5-8.5v-1.4C-4775.4-8839-4779.2-8835.1-4783.9-8835.1z" }),
			_react2.default.createElement("rect", { id: "Rectangle_3130", x: "-4805.2", y: "-8863.6", opacity: "0.12", className: "blackIcon", width: "17", height: "1.4" }),
			_react2.default.createElement("rect", { id: "Rectangle_3131", x: "-4822.3", y: "-8846.5", opacity: "0.12", className: "blackIcon", width: "17", height: "1.4" }),
			_react2.default.createElement("rect", { id: "Rectangle_3132", x: "-4839.3", y: "-8863.6", opacity: "0.12", className: "blackIcon", width: "17", height: "1.4" }),
			_react2.default.createElement("path", { id: "Path_3274", fill: "#FFFFFF", className: "blackIcon", d: "M-4843.6-8909.1h59.7c4.7,0,8.5,3.8,8.5,8.5v-1.4c0-4.7-3.8-8.5-8.5-8.5h-59.7\r c-4.7,0-8.5,3.8-8.5,8.5v1.4C-4852.1-8905.3-4848.3-8909.1-4843.6-8909.1z" })
		)
	);

/***/ },
/* 1061 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(25);
	
	var _globalComponentsLibrary = __webpack_require__(28);
	
	var _A_Admin_Alert_Modal = __webpack_require__(241);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AdminAlertModal = function AdminAlertModal(props) {
	    var _props$data = props.data,
	        title = _props$data.title,
	        content = _props$data.content,
	        accept = _props$data.accept,
	        cancel = _props$data.cancel,
	        onAccept = _props$data.onAccept,
	        onCancel = _props$data.onCancel;
	
	
	    var onAcceptHandler = function onAcceptHandler() {
	        props.onHideAdminAlertModal();
	        if (onAccept) {
	            onAccept();
	        }
	    };
	
	    var onCancelHandler = function onCancelHandler() {
	        props.onHideAdminAlertModal();
	        if (onCancel) {
	            onCancel();
	        }
	    };
	
	    return _react2.default.createElement(_globalComponentsLibrary.DialogBox, {
	        title: title,
	        content: content,
	        show: props.isModalOpen,
	        accept: accept,
	        cancel: cancel,
	        onAccept: accept && onAcceptHandler,
	        onCancel: cancel && onCancelHandler
	    });
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	    var _state$adminModal = state.adminModal,
	        isModalOpen = _state$adminModal.isModalOpen,
	        data = _state$adminModal.data;
	
	
	    return {
	        isModalOpen: isModalOpen,
	        data: data
	    };
	};
	
	var mapDispatchToProps = {
	    onHideAdminAlertModal: function onHideAdminAlertModal() {
	        return (0, _A_Admin_Alert_Modal.hideAdminModal)();
	    }
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AdminAlertModal);

/***/ },
/* 1062 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _singletonSharedData = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sharedData = new _singletonSharedData.SingletonSharedData();
	
	var AlertAudioFocusTab = function AlertAudioFocusTab() {
	
	    var onFocus = function onFocus() {
	        sharedData.setIsTabFocused(true);
	    };
	
	    // User has switched away from the tab (AKA tab is hidden)
	    var onBlur = function onBlur() {
	        sharedData.setIsTabFocused(false);
	    };
	
	    (0, _react.useEffect)(function () {
	        window.addEventListener("focus", onFocus);
	        window.addEventListener("blur", onBlur);
	        // Calls onFocus when the window first loads
	        onFocus();
	        // Specify how to clean up after this effect:
	        return function () {
	            window.removeEventListener("focus", onFocus);
	            window.removeEventListener("blur", onBlur);
	        };
	    }, []);
	
	    return null;
	};
	
	exports.default = AlertAudioFocusTab;

/***/ },
/* 1063 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Singleton = __webpack_require__(21);
	
	var _reactBootstrap = __webpack_require__(73);
	
	var _ManualCallSVG = __webpack_require__(236);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AlertManualMessageWindow = function (_Component) {
		_inherits(AlertManualMessageWindow, _Component);
	
		function AlertManualMessageWindow(props) {
			_classCallCheck(this, AlertManualMessageWindow);
	
			var _this = _possibleConstructorReturn(this, (AlertManualMessageWindow.__proto__ || Object.getPrototypeOf(AlertManualMessageWindow)).call(this, props));
	
			_this.getMessageAlert = function () {
				var complete = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
				var message = _this.props.alertCode === 'CUSTOM' ? _this.props.message : _this.language.getText('GUIManualMessageErrors' + _this.props.alertCode);
				if (!complete && message && message.length > 100) {
					message = message.slice(0, 90) + '...';
				}
				return message;
			};
	
			_this.onClickHandler = function () {
				_this.props.closeAlert(false);
			};
	
			_this.language = new _Singleton.Singleton();
	
			_this.state = {
				recievedAlert: true
			};
			return _this;
		}
	
		_createClass(AlertManualMessageWindow, [{
			key: 'render',
			value: function render() {
				var isSending = this.props.alertCode === 'CUSTOM';
				return _react2.default.createElement(
					'div',
					{ className: 'alertWindowContainer' },
					_react2.default.createElement(
						'div',
						{ className: 'alertWindow' },
						isSending ? null : _react2.default.createElement(
							'p',
							{ className: 'alertNumber' },
							this.props.phoneNumber
						),
						_react2.default.createElement(
							'div',
							{ className: 'alertInfoContainerManualMessage ' + (isSending ? 'alertInfoContainerSending' : '') },
							isSending ? _react2.default.createElement(
								'div',
								{ className: 'alertWindowSending' },
								_react2.default.createElement(_ManualCallSVG.SendMessageIcon, { width: '4.875rem', height: '4.625rem', fill: 'white' })
							) : _react2.default.createElement(
								'div',
								{ className: 'iconAlertManualMessage' },
								_react2.default.createElement(_ManualCallSVG.CellIConAlert, { opacity: 1, fill: 'rgba(255,255,255,1)', width: 40, height: 40 })
							),
							_react2.default.createElement(
								_reactBootstrap.OverlayTrigger,
								{
									key: 'tlt-alertManualCallWindow',
									placement: 'right',
									overlay: _react2.default.createElement(
										_reactBootstrap.Tooltip,
										{ className: 'workbar-tooltip show', id: 'tooltipId-tlt-alertManualCallWindow' },
										this.getMessageAlert(true)
									) },
								_react2.default.createElement(
									'div',
									null,
									isSending ? _react2.default.createElement(
										'p',
										{ className: 'alertNumber ' + (isSending ? 'alertNumberSending' : '') },
										this.props.phoneNumber
									) : null,
									_react2.default.createElement(
										'p',
										{ className: 'alertText ' + (isSending ? 'alertTextSending' : '') },
										this.getMessageAlert()
									)
								)
							)
						),
						isSending ? null : _react2.default.createElement(
							'div',
							{ className: 'closeAlert', onClick: this.onClickHandler },
							this.language.getText('GUIManualMessageclose-component')
						)
					)
				);
			}
		}]);
	
		return AlertManualMessageWindow;
	}(_react.Component);
	
	exports.default = AlertManualMessageWindow;

/***/ },
/* 1064 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(25);
	
	var _ChatSVG = __webpack_require__(235);
	
	var _GenericSVG = __webpack_require__(51);
	
	var _A_messages_to_SM = __webpack_require__(32);
	
	var _singletonSharedData = __webpack_require__(23);
	
	var _A_workBar_selected = __webpack_require__(195);
	
	var _Singleton = __webpack_require__(21);
	
	var _A_draggable_windows_controller = __webpack_require__(55);
	
	var _draggableComponents = __webpack_require__(101);
	
	var _ExpandedComponents = __webpack_require__(506);
	
	var _A_other_actions = __webpack_require__(511);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AlertMessageSupervisor = function (_Component) {
	  _inherits(AlertMessageSupervisor, _Component);
	
	  function AlertMessageSupervisor(props) {
	    _classCallCheck(this, AlertMessageSupervisor);
	
	    var _this2 = _possibleConstructorReturn(this, (AlertMessageSupervisor.__proto__ || Object.getPrototypeOf(AlertMessageSupervisor)).call(this, props));
	
	    _initialiseProps.call(_this2);
	
	    _this2.sharedData = new _singletonSharedData.SingletonSharedData();
	    _this2.state = {
	      hiddeAlert: false,
	      currentSupervisor: _this2.props.messageFrom,
	      messageArrived: _this2.props.message,
	      textToSend: "",
	      sendResponse: false,
	      canResponse: _this2.props.canResponse
	    };
	    _this2.language = new _Singleton.Singleton();
	    _this2.hiddeAlertTimer = null;
	    _this2.deleteAlertTimer = null;
	    return _this2;
	  }
	
	  _createClass(AlertMessageSupervisor, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this = this;
	      this.hiddeAlertTimer = setTimeout(function () {
	        _this.hideAlert();
	      }, 5000);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        canResponse: nextProps.canResponse
	      });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.hiddeAlertTimer);
	      clearTimeout(this.deleteAlertTimer);
	    }
	  }, {
	    key: 'sendChat',
	    value: function sendChat() {
	      var currentTime = new Date().toLocaleTimeString();
	      var messageToList = { type: 1, user: this.sharedData.getUserData().Login, text: this.state.textToSend, hour: currentTime };
	      this.sharedData.setObjectChat(messageToList, this.state.currentSupervisor);
	      this.props.messageToSupervisor(this.state.textToSend, this.state.currentSupervisor);
	      this.hideAlert();
	    }
	  }, {
	    key: 'responseMessage',
	    value: function responseMessage(e) {
	      this.setState({ sendResponse: true });
	      clearTimeout(this.hiddeAlertTimer);
	      e.stopPropagation();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: "alertChatComponent " + (this.state.sendResponse ? "onResponse " : "") + (this.state.hiddeAlert ? "hidden " : "") + (this.sharedData.getIsInactiveState() ? "disabled" : ""),
	          onClick: this.openChat },
	        _react2.default.createElement('div', { className: 'marginLeft' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'iconAlertMessage' },
	          _ChatSVG.supervisorChatSVG
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: "infoAlertMessage " + (this.state.sendResponse || !this.state.canResponse ? "onResponse " : "") },
	          _react2.default.createElement(
	            'p',
	            { className: 'titleAlertMessage' },
	            this.state.currentSupervisor
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: "textAlertMessage " + (this.state.sendResponse ? "onResponse " : "onNormal") },
	            this.state.messageArrived
	          )
	        ),
	        this.state.sendResponse && _react2.default.createElement(
	          'div',
	          { className: "closeAlertMessage", onClick: this.hideAlert },
	          _GenericSVG.closeSvg
	        )
	      );
	    }
	  }]);
	
	  return AlertMessageSupervisor;
	}(_react.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.hideAlert = function () {
	    _this3.setState({ hiddeAlert: true });
	    var _this = _this3;
	    _this3.deleteAlertTimer = setTimeout(function () {
	      _this.props.deleteAlert(_this.props.index);
	    }, 250);
	  };
	
	  this.openChat = function () {
	    _this3.sharedData.setWindowChatOpen(true);
	    _this3.sharedData.setNewNotificationChat(_this3.state.currentSupervisor, true);
	    _this3.sharedData.setCurrentSuperVisor(_this3.state.currentSupervisor);
	    _this3.setState({ hiddeAlert: true });
	    var props = { screenChat: true, currentSupervisor: _this3.state.currentSupervisor };
	    _this3.sharedData.setChatWindowOpen(true);
	    _this3.props.activateWorkAction((0, _ExpandedComponents.supervisorChatExpanded)(props));
	    _this3.props.insertWindow((0, _draggableComponents.supervisorChatFloating)(props), true);
	
	    setTimeout(function () {
	      _this3.props.deleteChatNotifications();
	    }, 200);
	    _this3.props.onOpenChat();
	    var _this = _this3;
	    _this.props.deleteAlert(_this.props.index);
	  };
	};
	
	function mapDispatchToProps(dispatch) {
	  return {
	    messageToSupervisor: function messageToSupervisor(message, supervisor) {
	      dispatch((0, _A_messages_to_SM.messageToSupervisor)(message, supervisor));
	    },
	    activateWorkAction: function activateWorkAction(action) {
	      dispatch((0, _A_workBar_selected.activateWorkAction)(action));
	    },
	    insertWindow: function insertWindow(dragWindow, closeComponentIfOpen) {
	      dispatch((0, _A_draggable_windows_controller.insertWindow)(dragWindow, closeComponentIfOpen));
	    },
	    deleteChatNotifications: function deleteChatNotifications() {
	      dispatch((0, _A_other_actions.deleteChatNotifications)());
	    }
	  };
	}
	exports.default = AlertMessageSupervisor = (0, _reactRedux.connect)(null, mapDispatchToProps)(AlertMessageSupervisor);

/***/ },
/* 1065 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Singleton = __webpack_require__(21);
	
	var _Images = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AlertMessageVolume = function (_Component) {
	  _inherits(AlertMessageVolume, _Component);
	
	  function AlertMessageVolume(props) {
	    _classCallCheck(this, AlertMessageVolume);
	
	    var _this2 = _possibleConstructorReturn(this, (AlertMessageVolume.__proto__ || Object.getPrototypeOf(AlertMessageVolume)).call(this, props));
	
	    _this2.language = new _Singleton.Singleton();
	    _this2.hiddeAlertTimer = null;
	    _this2.hideNotificationTimer = null;
	    _this2.state = {
	      hiddeAlert: false
	    };
	    return _this2;
	  }
	
	  _createClass(AlertMessageVolume, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.hideNotificationTimer);
	      clearTimeout(this.hiddeAlertTimer);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      var _this = this;
	      this.hiddeAlertTimer = setTimeout(function () {
	        _this3.setState({
	          hiddeAlert: true
	        });
	        _this.hideAlert();
	      }, 5000);
	    }
	  }, {
	    key: 'hideAlert',
	    value: function hideAlert() {
	      var _this = this;
	      this.hideNotificationTimer = setTimeout(function () {
	        _this.props.hideNotification();
	      }, 250);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: "alertChatComponent onResponse " + (this.state.hiddeAlert ? "hidden" : "") },
	        _react2.default.createElement('div', { className: 'marginLeft yellow' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'iconAlertMessage' },
	          _react2.default.createElement('img', { className: 'imgWarning', src: _Images.alert, alt: 'icon' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'infoAlertMessage onResponse' },
	          _react2.default.createElement(
	            'p',
	            { className: 'titleAlertMessage' },
	            this.language.getText("GUIAlertVolumewarning")
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'textAlertMessage onResponse' },
	            this.language.getText("GUIAlertVolumecontent")
	          )
	        )
	      );
	    }
	  }]);
	
	  return AlertMessageVolume;
	}(_react.Component);
	
	exports.default = AlertMessageVolume;

/***/ },
/* 1066 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AlertModal = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(482);
	
	var _reactRedux = __webpack_require__(25);
	
	var _reactModal = __webpack_require__(939);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _A_Alert_Modal = __webpack_require__(63);
	
	var _A_Alert_Modal2 = _interopRequireDefault(_A_Alert_Modal);
	
	var _AlertsSVG = __webpack_require__(321);
	
	var _globalComponentsLibrary = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_reactModal2.default.setAppElement('body');
	
	var customStyles = {
	  content: {
	    top: '50%',
	    left: '50%',
	    bottom: 'auto',
	    width: '404px',
	    height: 'auto',
	    overflow: 'hidden',
	    padding: '0',
	    transform: 'translate(-50%, -50%)'
	  }
	};
	
	var AlertModal = exports.AlertModal = function AlertModal(props) {
	  var isModalOpen = props.isModalOpen,
	      hideAlertModal = props.hideAlertModal,
	      data = props.data;
	  var type = data.type,
	      message = data.message,
	      boldMessage = data.boldMessage,
	      title = data.title,
	      button = data.button,
	      buttonFun = data.buttonFun,
	      secondButton = data.secondButton,
	      secondButtonFtn = data.secondButtonFtn,
	      timeout = data.timeout,
	      timeoutFun = data.timeoutFun;
	
	
	  var reloadPage = function reloadPage() {
	    hideAlertModal();
	    if (buttonFun) {
	      buttonFun();
	    }
	  };
	
	  var secondBut = function secondBut() {
	    hideAlertModal();
	    if (secondButtonFtn) {
	      secondButtonFtn();
	    }
	  };
	
	  var onTimeout = function onTimeout() {
	    hideAlertModal();
	    if (timeoutFun) {
	      timeoutFun();
	    }
	  };
	
	  var timeoutID = (0, _react.useRef)();
	  (0, _react.useEffect)(function () {
	    if (timeout != null && timeout > 0) {
	      timeoutID.current = setTimeout(onTimeout, timeout);
	    }
	    return function () {
	      clearTimeout(timeoutID.current);
	    };
	  }, [timeout]);
	
	  return _react2.default.createElement(
	    _reactModal2.default,
	    {
	      isOpen: isModalOpen,
	      style: customStyles },
	    _react2.default.createElement(
	      'div',
	      { className: 'AlertModalHeader' },
	      _react2.default.createElement(
	        'div',
	        { className: 'AlertModalIcon ' + type },
	        _AlertsSVG.exclamationMarkSVG
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: 'AlertModalHeaderLabel' },
	        title
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'AlertModalBody' },
	      _react2.default.createElement(
	        'p',
	        { className: 'AlertModalInformation' },
	        message + ' ',
	        _react2.default.createElement(
	          'strong',
	          null,
	          boldMessage
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'AlertModalFooter' },
	      _react2.default.createElement(
	        'div',
	        { className: 'btn-confirmation-modal' },
	        _react2.default.createElement(
	          _globalComponentsLibrary.AgentButton,
	          { type: 'tertiary', onClick: reloadPage },
	          button
	        )
	      ),
	      secondButton && _react2.default.createElement(
	        'div',
	        { className: 'btn-confirmation-modal' },
	        ' ',
	        _react2.default.createElement(
	          _globalComponentsLibrary.AgentButton,
	          { type: 'primary', color: 'blue', onClick: secondBut },
	          secondButton
	        )
	      )
	    )
	  );
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  var _state$isAlertModalOp = state.isAlertModalOpen,
	      isModalOpen = _state$isAlertModalOp.isModalOpen,
	      data = _state$isAlertModalOp.data;
	
	
	  return {
	    isModalOpen: isModalOpen,
	    data: data
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  var hideAlertModal = _A_Alert_Modal2.default.creators.hideAlertModal;
	
	
	  return (0, _redux.bindActionCreators)({
	    hideAlertModal: hideAlertModal
	  }, dispatch);
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AlertModal);

/***/ },
/* 1067 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(25);
	
	var _AlertMessageSupervisor = __webpack_require__(1064);
	
	var _AlertMessageSupervisor2 = _interopRequireDefault(_AlertMessageSupervisor);
	
	var _singletonSharedData = __webpack_require__(23);
	
	var _constants = __webpack_require__(10);
	
	var _ManualCallReprogrammed = __webpack_require__(1069);
	
	var _ManualCallReprogrammed2 = _interopRequireDefault(_ManualCallReprogrammed);
	
	var _CancelNoAvailableState = __webpack_require__(1068);
	
	var _CancelNoAvailableState2 = _interopRequireDefault(_CancelNoAvailableState);
	
	var _AlertMessageVolume = __webpack_require__(1065);
	
	var _AlertMessageVolume2 = _interopRequireDefault(_AlertMessageVolume);
	
	var _A_messages_to_SM = __webpack_require__(32);
	
	var _constants2 = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AlertsContainerMessage = function (_Component) {
	  _inherits(AlertsContainerMessage, _Component);
	
	  function AlertsContainerMessage(props) {
	    var _this$alertsActions;
	
	    _classCallCheck(this, AlertsContainerMessage);
	
	    var _this = _possibleConstructorReturn(this, (AlertsContainerMessage.__proto__ || Object.getPrototypeOf(AlertsContainerMessage)).call(this, props));
	
	    _this.removeAlertVolume = function () {
	      _this.removeAlert("volumeAlert");
	    };
	
	    _this.cancelManualCallReprogramed = function () {
	      var data = {
	        CamId: 0, CallKey: "", Phone: "",
	        Data: "", ExistsCallout: 0, CallMode: 0
	      };
	      _this.props.manualCall(data);
	      _this.removeAlert("manualCallAlert");
	    };
	
	    _this.openChat = function () {
	      _this.setState({ arrayAlerts: [] });
	    };
	
	    _this.state = {
	      arrayAlertsTop: [],
	      arrayAlerts: [],
	      messageAlert: null
	    };
	    _this.sharedData = new _singletonSharedData.SingletonSharedData();
	    _this.message = 0;
	    _this.arrayNormal = [];
	    _this.alertsActions = (_this$alertsActions = {}, _defineProperty(_this$alertsActions, _constants.ALERTS_SHOWED.INSERT_CALL_ALERT, function () {
	      return _this.insertAlert("manualCallAlert", function () {
	        return _react2.default.createElement(_ManualCallReprogrammed2.default, { onCancel: _this.cancelManualCallReprogramed });
	      });
	    }), _defineProperty(_this$alertsActions, _constants.ALERTS_SHOWED.REMOVE_CALL_ALERT, function () {
	      return _this.removeAlert("manualCallAlert");
	    }), _defineProperty(_this$alertsActions, _constants.ALERTS_SHOWED.INSERT_NO_AVAILABLE_ALERT, function () {
	      return _this.insertAlert("noAvailableAlert", function (message) {
	        return _react2.default.createElement(_CancelNoAvailableState2.default, { message: message, onCancel: function onCancel(idNoAvailable) {
	            return _this.cancelNoAvailableState(idNoAvailable);
	          } });
	      });
	    }), _defineProperty(_this$alertsActions, _constants.USER_STATE.NO_AVAILABLE, function () {
	      return _this.removeAlert("noAvailableAlert");
	    }), _defineProperty(_this$alertsActions, _constants.USER_STATE.CALL_OUT, function () {
	      return _this.removeAlert("manualCallAlert");
	    }), _defineProperty(_this$alertsActions, _constants.ALERTS_SHOWED.INSERT_VOLUME_ALERT, function () {
	      return _this.insertAlert("volumeAlert", function () {
	        return _react2.default.createElement(_AlertMessageVolume2.default, { hideNotification: _this.removeAlertVolume });
	      });
	    }), _this$alertsActions);
	    return _this;
	  }
	
	  _createClass(AlertsContainerMessage, [{
	    key: 'cancelNoAvailableState',
	    value: function cancelNoAvailableState(idNoAvailable) {
	      var obj = {
	        "action": "notReady", "username": this.sharedData.getUserData().Login,
	        "userID": this.sharedData.getParameters().UserID, "notReadyId": 0, "Sender": 2
	      };
	      this.props.messageToStateMachine(JSON.stringify(obj));
	      this.removeAlert("noAvailableAlert");
	    }
	  }, {
	    key: 'insertAlert',
	    value: function insertAlert(tag, component) {
	      var arrayAlertsTop = this.state.arrayAlertsTop;
	      var arrayfilter = arrayAlertsTop.filter(function (item) {
	        return item.tag === tag;
	      });
	      if (!arrayfilter.length) {
	        arrayAlertsTop.push({ tag: tag, drawComponent: component });
	      }
	      this.setState({ arrayAlertsTop: arrayAlertsTop });
	    }
	  }, {
	    key: 'removeAlert',
	    value: function removeAlert(tag) {
	      var arrayAlertsTop = this.state.arrayAlertsTop;
	      arrayAlertsTop = arrayAlertsTop.filter(function (item) {
	        return item.tag !== tag;
	      });
	      this.setState({ arrayAlertsTop: arrayAlertsTop });
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	
	      return nextProps.actionAlert || nextProps.stateMachineActions.actionType !== _constants2.ACTIONS_FROM_SM.NO_ACTION || this.state.arrayAlertsTop.length !== nextState.arrayAlertsTop.length;
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (nextProps.stateMachineActions.message && nextProps.stateMachineActions.actionType && nextProps.stateMachineActions.actionType !== "NO_AVAILABLE_INFO") {
	        this.deleteAlert(this.message - 1);
	        var currentTime = new Date().toLocaleTimeString();
	        var messageToList = { type: 1, user: nextProps.stateMachineActions.supervisor, text: nextProps.stateMachineActions.message, hour: currentTime };
	        this.sharedData.setObjectChat(messageToList, nextProps.stateMachineActions.supervisor);
	        this.sharedData.setNewNotificationChat(nextProps.stateMachineActions.supervisor);
	        if (!this.sharedData.getChatWindowOpen()) {
	          this.arrayNormal.splice(0, 0, {
	            index: this.message++,
	            drawComponent: function drawComponent(index) {
	              return _react2.default.createElement(_AlertMessageSupervisor2.default, {
	                messageFrom: nextProps.stateMachineActions.supervisor,
	                message: nextProps.stateMachineActions.message,
	                index: index,
	                canResponse: index === _this2.message - 1,
	                deleteAlert: function deleteAlert(index) {
	                  return _this2.deleteAlert(index);
	                },
	                onOpenChat: _this2.openChat });
	            }
	          });
	          this.setState({ arrayAlerts: this.arrayNormal });
	        }
	      }
	      if (this.state.messageAlert && this.state.messageAlert.action === "notReadyScheduled" && nextProps.userState && nextProps.userState.currentState === _constants.USER_STATE.AGENT_READY) {
	        this.removeAlert("noAvailableAlert");
	      }
	      this.setState({ messageAlert: nextProps.alertMessage });
	      if (this.alertsActions[nextProps.actionAlert]) {
	        this.alertsActions[nextProps.actionAlert]();
	      }
	      if (this.alertsActions[nextProps.userState.currentState]) {
	        this.alertsActions[nextProps.userState.currentState]();
	      }
	    }
	  }, {
	    key: 'validateTypeAlert',
	    value: function validateTypeAlert(tag) {
	      return tag === "onPreviewModeAlert" ? "PreviewMode" : "";
	    }
	  }, {
	    key: 'deleteAlert',
	    value: function deleteAlert(index) {
	      this.arrayNormal = this.arrayNormal.filter(function (item) {
	        return item.index !== index;
	      });
	      this.setState({ arrayAlerts: this.arrayNormal });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.state.arrayAlertsTop.map(function (item) {
	          return _react2.default.createElement(
	            'div',
	            { className: "messageAlertsContainer " + _this3.validateTypeAlert(item.tag) },
	            _react2.default.createElement(
	              'div',
	              { key: "alert" + item.tag },
	              item.drawComponent(_this3.state.messageAlert)
	            )
	          );
	        }),
	        this.state.arrayAlerts.map(function (item) {
	          return _react2.default.createElement(
	            'div',
	            { className: "messageAlertsContainer " + _this3.validateTypeAlert(item.tag) },
	            _react2.default.createElement(
	              'div',
	              { key: "alert" + item.index },
	              item.drawComponent(item.index)
	            )
	          );
	        })
	      );
	    }
	  }]);
	
	  return AlertsContainerMessage;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return { stateMachineActions: state.stateMachineActions, userState: state.userState };
	}
	
	function mapDispatchToProps(dispatch) {
	  return {
	    manualCall: function manualCall(data) {
	      dispatch((0, _A_messages_to_SM.manualCall)(data));
	    },
	    messageToStateMachine: function messageToStateMachine(message) {
	      dispatch((0, _A_messages_to_SM.messageToStateMachine)(message));
	    }
	  };
	}
	
	exports.default = AlertsContainerMessage = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AlertsContainerMessage);

/***/ },
/* 1068 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _singletonSharedData = __webpack_require__(23);
	
	var _Singleton = __webpack_require__(21);
	
	var _ChatSVG = __webpack_require__(235);
	
	var _GenericSVG = __webpack_require__(51);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CancelNoAvailableState = function (_Component) {
	  _inherits(CancelNoAvailableState, _Component);
	
	  function CancelNoAvailableState(props) {
	    _classCallCheck(this, CancelNoAvailableState);
	
	    var _this = _possibleConstructorReturn(this, (CancelNoAvailableState.__proto__ || Object.getPrototypeOf(CancelNoAvailableState)).call(this, props));
	
	    _this.onClickHandler = function () {
	      console.log("ONCLICK ");
	      _this.setState({ onHiddeAlert: true });
	      _this.props.onCancel(_this.state.noAvailableID);
	    };
	
	    _this.state = {
	      noAvailableName: _this.props.message.description,
	      noAvailableFrame: _this.props.message.frame,
	      noAvailableID: _this.props.message.notReadyId,
	      setByAdmin: _this.props.message.setByAdmin,
	      onHiddeAlert: false
	    };
	    _this.sharedData = new _singletonSharedData.SingletonSharedData();
	    _this.language = new _Singleton.Singleton();
	    return _this;
	  }
	
	  _createClass(CancelNoAvailableState, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.message.action === "notReadyScheduled") {
	        this.setState({
	          noAvailableName: nextProps.message.description,
	          noAvailableFrame: nextProps.message.frame,
	          noAvailableID: nextProps.message.notReadyId,
	          setByAdmin: nextProps.message.setByAdmin
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: "cancelNoAvailableStateContainer " + (this.state.onHiddeAlert ? "onHidde" : "") },
	        _react2.default.createElement(
	          'div',
	          { className: 'alertAbsolute' },
	          _react2.default.createElement(
	            'div',
	            { className: 'iconCancelNA' },
	            this.sharedData.getIconNoAvailable(this.state.noAvailableFrame)
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'infoCancelNA' },
	            _react2.default.createElement(
	              'p',
	              { className: 'titleCancelNA' },
	              this.language.getText("GUIDisableSelectorprogrammed")
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'nameCancelNA' },
	              this.state.noAvailableName
	            )
	          ),
	          this.state.setByAdmin ? _react2.default.createElement(
	            'div',
	            { className: 'icon16Grey' },
	            _ChatSVG.supervisorChatSimpleSVG
	          ) : _react2.default.createElement(
	            'div',
	            { className: 'divIconCNAS' },
	            _react2.default.createElement(
	              'div',
	              { className: 'tacheIconCNAS', onClick: this.onClickHandler },
	              _GenericSVG.tacheCirculo
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return CancelNoAvailableState;
	}(_react.Component);
	
	exports.default = CancelNoAvailableState;

/***/ },
/* 1069 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _singletonSharedData = __webpack_require__(23);
	
	var _Singleton = __webpack_require__(21);
	
	var _AlertsSVG = __webpack_require__(321);
	
	var _GenericSVG = __webpack_require__(51);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ManualCallReprogrammed = function (_Component) {
	  _inherits(ManualCallReprogrammed, _Component);
	
	  function ManualCallReprogrammed(props) {
	    _classCallCheck(this, ManualCallReprogrammed);
	
	    var _this = _possibleConstructorReturn(this, (ManualCallReprogrammed.__proto__ || Object.getPrototypeOf(ManualCallReprogrammed)).call(this, props));
	
	    _this.onClickHandler = function () {
	      _this.setState({ onHiddeAlert: true });
	      _this.props.onCancel();
	    };
	
	    _this.state = { onHiddeAlert: false };
	    _this.sharedData = new _singletonSharedData.SingletonSharedData();
	    _this.language = new _Singleton.Singleton();
	    return _this;
	  }
	
	  _createClass(ManualCallReprogrammed, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: "manualCallReprogrammingContainer " + (this.state.onHiddeAlert ? "onHidde" : "") },
	        _react2.default.createElement(
	          'div',
	          { className: 'alertAbsolute' },
	          _react2.default.createElement(
	            'div',
	            { className: 'titleReprogramAlert' },
	            _react2.default.createElement(
	              'div',
	              { className: 'phoneIconMCR' },
	              _AlertsSVG.phoneIconGreenBorderless
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'textMCR' },
	              this.language.getText("GUIManualCallReprogrammed")
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'phoneMCR' },
	            this.sharedData.getPhoneNumber()
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'tacheIconMCR', onClick: this.onClickHandler },
	            _GenericSVG.tacheCirculo
	          )
	        )
	      );
	    }
	  }]);
	
	  return ManualCallReprogrammed;
	}(_react.Component);
	
	exports.default = ManualCallReprogrammed;

/***/ },
/* 1070 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _regenerator = __webpack_require__(515);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(25);
	
	var _Header = __webpack_require__(1077);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(1073);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Login = __webpack_require__(1082);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	var _workSpace = __webpack_require__(1139);
	
	var _workSpace2 = _interopRequireDefault(_workSpace);
	
	var _Consulting = __webpack_require__(1120);
	
	var _Consulting2 = _interopRequireDefault(_Consulting);
	
	var _A_actions_from_SM = __webpack_require__(1158);
	
	var _A_user_states = __webpack_require__(513);
	
	var _A_no_available = __webpack_require__(1162);
	
	var _cwGalateaApiJsBundle = __webpack_require__(40);
	
	var _A_validating_telephony = __webpack_require__(1165);
	
	var _A_assisted_transfer = __webpack_require__(332);
	
	var _A_draggable_windows_controller = __webpack_require__(55);
	
	var _constants = __webpack_require__(10);
	
	var _cwGalateaAgentControllerJsBundleMin = __webpack_require__(1394);
	
	var _helperMessages = __webpack_require__(87);
	
	var _singletonSharedData = __webpack_require__(23);
	
	var _SingletonWebSocket = __webpack_require__(50);
	
	var _SingletonWebSocket2 = _interopRequireDefault(_SingletonWebSocket);
	
	var _StrategiesStates = __webpack_require__(1144);
	
	var _Strategies_Reducer_Integration = __webpack_require__(1150);
	
	var _Strategies_SM_To_Integration = __webpack_require__(1151);
	
	var _A_sip_client_actions = __webpack_require__(1164);
	
	var _A_other_actions = __webpack_require__(511);
	
	var _A_actions_UnifiedInbox = __webpack_require__(330);
	
	var _A_messages_to_SM = __webpack_require__(32);
	
	var _A_user_actions = __webpack_require__(194);
	
	var _helperLanguage = __webpack_require__(510);
	
	var _globalCommonUtilitiesJsBundle = __webpack_require__(688);
	
	var _Logger = __webpack_require__(37);
	
	var _Strategies_SoftPhone = __webpack_require__(1152);
	
	__webpack_require__(1729);
	
	__webpack_require__(1728);
	
	__webpack_require__(1730);
	
	var _Singleton = __webpack_require__(21);
	
	var _AlertModal = __webpack_require__(1066);
	
	var _AlertModal2 = _interopRequireDefault(_AlertModal);
	
	var _AlertAudioFocusTab = __webpack_require__(1062);
	
	var _AlertAudioFocusTab2 = _interopRequireDefault(_AlertAudioFocusTab);
	
	var _A_Alert_Modal = __webpack_require__(63);
	
	var _A_Alert_Modal2 = _interopRequireDefault(_A_Alert_Modal);
	
	var _A_actions_from_white_label = __webpack_require__(1159);
	
	var _A_queue_count = __webpack_require__(1163);
	
	var _ProcessMessage = __webpack_require__(1085);
	
	var _A_local_logging = __webpack_require__(1161);
	
	var _SMResponseHelper = __webpack_require__(1155);
	
	var _A_preview = __webpack_require__(52);
	
	var _A_preview_transfer = __webpack_require__(193);
	
	var _AdminAlertModal = __webpack_require__(1061);
	
	var _AdminAlertModal2 = _interopRequireDefault(_AdminAlertModal);
	
	var _A_Admin_Alert_Modal = __webpack_require__(241);
	
	var _globalComponentsLibrary = __webpack_require__(28);
	
	var _A_agent_permissions = __webpack_require__(331);
	
	var _A_manual_message = __webpack_require__(333);
	
	var _A_transfer = __webpack_require__(512);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SERVER_IP = '192.168.1.34';
	
	var INTEGRATION_IP = SERVER_IP;
	var parameterMizu = {};
	var parametersWebRTC = {};
	var rabbitMqTest = null;
	var networkMonitoringConfig = {};
	var integrationConfig = {};
	
	var App = function (_Component) {
		_inherits(App, _Component);
	
		function App(props) {
			var _this2$actionsCall;
	
			_classCallCheck(this, App);
	
			var _this2 = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this, props));
	
			_this2.state = {
				isLogged: false,
				consulting: 0,
				callType: 1,
				idChangeCount: -1,
				queueCount: 0,
				timeInQueue: 0,
				alert: null,
				newAlertCode: 0,
				newAlertMessage: null,
				dataCall: {},
				extraDataCall: {},
				loginError: 0,
				isInConference: false,
				loadedLanguaje: false,
				softPhoneLoaded: false,
				integrationAutorun: false,
				smReady: true,
				dialogShow: false,
				dialogContent: {}
			};
			_this2.handleUnload = _this2.handleUnload.bind(_this2);
			_this2.dateSendMessage = { date: new Date(), message: null };
			_this2.numerReconnect = 0;
			_this2.Engines = {};
			_this2.language = new _Singleton.Singleton();
			_this2.sharedData = new _singletonSharedData.SingletonSharedData();
			_this2.language = new _Singleton.Singleton();
			_this2.smResponseHelper = new _SMResponseHelper.SMResponseHelper();
			_this2.smResponseHelper.setThat(_this2);
			_this2.rabbitConnected = false;
			_this2.telephonyTime = 0;
			var APIFact = new _cwGalateaApiJsBundle.APIFactory();
			_this2.apiCont = APIFact.buildClient();
			_this2.callId = 0;
			var utilityFactory = new _globalCommonUtilitiesJsBundle.UtilityFactory();
			_this2.urlClient = utilityFactory.buildURLClient();
	
			var arrayPage = window.location.href.split('/');
			var pageIntegrationToken = null;
	
			if (false) {
				var isSSL = SERVER_IP.indexOf('.nuxiba.com') >= 0;
				_this2.apiCont.PathWS = 'http' + (isSSL ? 's' : '') + '://' + SERVER_IP + '/';
				_this2.sharedData.integrationServer = INTEGRATION_IP;
				pageIntegrationToken = _this2.apiCont.PathWS + 'AgentKolob';
			} else {
				_this2.apiCont.PathWS = window.location.origin + '/';
				_this2.sharedData.integrationServer = window.location.hostname;
				pageIntegrationToken = arrayPage.slice(0, arrayPage.length - 1).join('/');
			}
			_this2.sharedData.setSecureConnection(_this2.apiCont.PathWS.includes('https'));
	
			var helperFrame = document.createElement('iframe');
	
			helperFrame.src = pageIntegrationToken + '/IntegrationToken.html';
			helperFrame.id = 'helperFrame';
			helperFrame.style = 'display:none;';
			var body = document.getElementsByTagName('body')[0];
	
			body.appendChild(helperFrame);
	
			_this2.actionsCall = (_this2$actionsCall = {}, _defineProperty(_this2$actionsCall, _constants.ACTION_CALL_ACD.HANGUP, function () {
				return _this2.hangUp();
			}), _defineProperty(_this2$actionsCall, _constants.ACTION_CALL_ACD.MUTE, function (parameters) {
				return _this2.agentController.muteCall(parameters);
			}), _defineProperty(_this2$actionsCall, _constants.ACTION_CALL_ACD.HOLD, function (parameters, callOutId) {
				return _this2.hold(callOutId);
			}), _defineProperty(_this2$actionsCall, _constants.ACTION_CALL_ACD.DTMF, function (parameters) {
				return _this2.DTMF(parameters);
			}), _this2$actionsCall);
	
			_this2.userActionsApp = _defineProperty({}, _constants.USER_ACTIONS.LOGOUT, function () {
				_this2.logOut();
			});
			return _this2;
		}
	
		_createClass(App, [{
			key: 'checkSoftPhone',
			value: function checkSoftPhone() {
				var softphone = false;
				this.setState({
					loadedLanguaje: true,
					integrationAutorun: this.sharedData.getIntegrationAutorun()
				});
				if (this.urlClient.getQueryVariable(_constants.STR_SOFTPHONE)) {
					softphone = this.urlClient.getQueryVariable(_constants.STR_SOFTPHONE).toUpperCase();
				}
				if (!softphone || !_constants.SOFTPHONES_KEY[softphone]) {
					var defSoftphone = _constants.SOFTPHONES_DEFAULT[this.sharedData.getSoftPhone()];
					if (defSoftphone) {
						_Logger.Logger.Info('[App][checkSoftPhone] Setting default softphone [' + defSoftphone + ']');
						this.urlClient.updateQueryStringParameter(_constants.STR_SOFTPHONE, defSoftphone);
					} else {
						_Logger.Logger.Error('[App][checkSoftPhone] No valid softphone');
						this.setState({ softPhoneLoaded: true });
						this.setState({ loginError: 1044 });
						defSoftphone = _constants.SOFTPHONES_DEFAULT[5];
					}
				} else {
					_Logger.Logger.Info('[App][checkSoftPhone] Setting softphone [' + softphone + ']');
					var AgentFact = new _cwGalateaAgentControllerJsBundleMin.AgentControllerFactory();
	
					var softphoneKey = _constants.SOFTPHONES_KEY[softphone] ? _constants.SOFTPHONES_KEY[softphone] : _constants.SOFTPHONES_KEY.WEBRTC;
	
					this.sharedData.setSoftPhone(softphoneKey);
					try {
						_Logger.Logger.Debug('rabbitMqTest ', rabbitMqTest);
						if (!rabbitMqTest) {
							rabbitMqTest = { isWebStomp: true };
						}
						this.agentController = AgentFact.buildClient(softphoneKey, rabbitMqTest.isWebStomp);
					} catch (e) {
						_Logger.Logger.Error('AgentFact.buildClient', e);
					}
					this.loadAgentMethods();
					this.setState({ softPhoneLoaded: true });
				}
				console.log('Test sofphone', this.sharedData.getSoftPhone());
				var ip = this.manageIPAddress();
				this.setIP(ip);
			}
		}, {
			key: 'setIP',
			value: function setIP(ip) {
				if (this.sharedData.getSoftPhone() !== _constants.SOFTPHONES_KEY.MIZUJS) {
					this.sharedData.setIPAddress(ip);
					this.sharedData.setIPIntegration(ip);
				} else {
					this.sharedData.setIPIntegration(ip);
				}
			}
		}, {
			key: 'manageIPAddress',
			value: function manageIPAddress() {
				var ip = this.getIPAddress();
				return ip;
			}
		}, {
			key: 'getIPAddress',
			value: function getIPAddress() {
				var myIP = this.sharedData.getIPfromAPI();
				return myIP;
			}
		}, {
			key: 'loadAgentMethods',
			value: function loadAgentMethods() {
				var _this3 = this;
	
				var _this = this;
				this.agentController.AgentObject.onConnected = function () {
					_Logger.Logger.Trace('[App][loadAgentMethods] Connected to Rabbit!');
					_this.rabbitConnected = true;
					_this.agentController.subscribeTopics(_this.sharedData.getUserData().Login + '|');
					_this.sendToRabbit(_constants.SM_QUEUE_SERVER, (0, _helperMessages.messageLogin)(_this.agentController.getTimeStamp()));
					_this.getChatLog();
				};
	
				this.agentController.AgentObject.onDisconnected = function () {
					_this3.messageDisconnect();
					_this3.agentController.disconnectBroker();
					_this3.rabbitConnected = false;
				};
	
				this.agentController.AgentObject.onMessage = function (mensaje) {
					_Logger.Logger.Debug('[App][loadAgentMethods] Message received => ' + mensaje);
					try {
						_this.processMessage(JSON.parse(mensaje));
					} catch (err) {
						_Logger.Logger.Warn('[App][loadAgentMethods] Message not process => ' + mensaje, err);
					}
				};
	
				this.agentController.AgentObject.onReconnected = function () {
					_Logger.Logger.Debug('[App][loadAgentMethods] Reconnected');
					_this.setState({ smReady: false });
					_this.sendToRabbit(_constants.SM_QUEUE_SERVER, (0, _helperMessages.Reconnected)());
					setTimeout(function () {
						if (!_this.state.smReady) {
							_Logger.Logger.Debug("[App][loadAgentMethods] Didn't revice reconnected package ");
							_this3.messageDisconnect();
						}
					}, 7000);
				};
				//METODOS SIP SOBREESCRITOS
				_Strategies_SoftPhone.SOFTPHONE_CALLBACKS[this.sharedData.getSoftPhone()](this);
			}
		}, {
			key: 'messageDisconnect',
			value: function messageDisconnect() {
				var _this = this;
				_this.numerReconnect = 0;
				if (_this.timerKeepAlive) {
					clearInterval(_this.timerKeepAlive);
					_this.timerKeepAlive = null;
				}
				_Logger.Logger.Info('ONDISCONNECTED ');
				_this.rabbitConnected = false;
				this.props.showAlertModal({
					type: 'ModalError',
					title: 'CenterWare Kolob',
					message: this.language.getText('error-1'),
					button: this.language.getText('GUITelephonyValidatorreconnect'),
					secondButtonFtn: function secondButtonFtn() {},
					buttonFun: function buttonFun() {
						_this.logOut();
					}
				});
			}
		}, {
			key: 'logOut',
			value: function logOut() {
				this.numerReconnect = 0;
				if ((this.sharedData.getCurrentState() === 'Wrapup' || this.sharedData.getCurrentState() === 'Dialog') && !this.sharedData.getIsRated()) {
					_Logger.Logger.Trace('The call:' + this.callId + ' was not rated. Reason: Logout, LastState:' + this.sharedData.getCurrentState());
				}
				if (this.state.isLogged) {
					_Logger.Logger.Trace('[App][logOut] OnLogout');
					this.sendToRabbit(_constants.SM_QUEUE_SERVER, (0, _helperMessages.RequestedLogout)());
					this.setState({
						isLogged: false,
						idChangeCount: -1,
						queueCount: 0,
						timeInQueue: 0
					});
					clearInterval(this.timerKeepAlive);
					this.props.changeState(_constants.USER_STATE.LOGED_OUT);
					this.agentController.disconnectBroker();
					this.rabbitConnected = false;
					this.sharedData.setCurrentState('logout');
					var integrationMessage = { client: 'galatea', action: 'onLogOut' };
					_SingletonWebSocket2.default.send(integrationMessage);
					this.sharedData.clearChatList();
					setTimeout(function () {
						location.reload();
					}, 1500);
				}
			}
		}, {
			key: 'componentDidMount',
			value: function () {
				var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
					var publicLocation, whiteLabelConfig, helperFrame2, body, login, header, about, _login, _header, _about, ts, logKey, lastLogKey, prevEntries, _this, langHelper;
	
					return _regenerator2.default.wrap(function _callee$(_context) {
						while (1) {
							switch (_context.prev = _context.next) {
								case 0:
									window.addEventListener('beforeunload', this.handleUnload);
									publicLocation =  false ? '/' : window.location.pathname;
									_context.next = 4;
									return fetch(publicLocation + 'manifest.json?timeSPam=' + Math.random()).then(function (response) {
										return response.json();
									});
	
								case 4:
									whiteLabelConfig = _context.sent;
	
									parameterMizu = whiteLabelConfig.mizuJs;
									rabbitMqTest = whiteLabelConfig.rabbit;
									parametersWebRTC = whiteLabelConfig.webRTC;
									networkMonitoringConfig = whiteLabelConfig.networkMonitoring;
									integrationConfig = whiteLabelConfig.integration;
									if (integrationConfig && integrationConfig.hide) {
										helperFrame2 = document.createElement('iframe');
	
										helperFrame2.src = this.apiCont.PathWS + (integrationConfig.path ? integrationConfig.path : 'AgentKolob') + '/Integration/';
										helperFrame2.id = 'helperFrame2';
										helperFrame2.name = 'helperFrame2';
										helperFrame2.style = 'display:none;';
										body = document.getElementsByTagName('body')[0];
	
										body.appendChild(helperFrame2);
									}
									if (integrationConfig && integrationConfig.sendDataOncallout) {
										this.sharedData.setSendDataOncallout(integrationConfig.sendDataOncallout);
									}
	
									if (!(whiteLabelConfig.whiteLabelEnabled === true)) {
										_context.next = 38;
										break;
									}
	
									if (!(whiteLabelConfig.imageFormat === 'svg')) {
										_context.next = 27;
										break;
									}
	
									_context.next = 16;
									return fetch(publicLocation + 'logos/login.svg').then(function (response) {
										return response.text();
									});
	
								case 16:
									login = _context.sent;
									_context.next = 19;
									return fetch(publicLocation + 'logos/header.svg').then(function (response) {
										return response.text();
									});
	
								case 19:
									header = _context.sent;
									_context.next = 22;
									return fetch(publicLocation + 'logos/about.svg').then(function (response) {
										return response.text();
									});
	
								case 22:
									about = _context.sent;
									_context.next = 25;
									return this.props.setCustomImages(whiteLabelConfig.whiteLabelEnabled, 'svg', login, header, about);
	
								case 25:
									_context.next = 38;
									break;
	
								case 27:
									_context.next = 29;
									return fetch(publicLocation + 'logos/login.' + whiteLabelConfig.imageFormat).then(function (response) {
										return response.blob();
									}).then(function (img) {
										return URL.createObjectURL(img);
									});
	
								case 29:
									_login = _context.sent;
									_context.next = 32;
									return fetch(publicLocation + 'logos/header.' + whiteLabelConfig.imageFormat).then(function (response) {
										return response.blob();
									}).then(function (img) {
										return URL.createObjectURL(img);
									});
	
								case 32:
									_header = _context.sent;
									_context.next = 35;
									return fetch(publicLocation + 'logos/about.' + whiteLabelConfig.imageFormat).then(function (response) {
										return response.blob();
									}).then(function (img) {
										return URL.createObjectURL(img);
									});
	
								case 35:
									_about = _context.sent;
									_context.next = 38;
									return this.props.setCustomImages(whiteLabelConfig.whiteLabelEnabled, 'image', _login, _header, _about);
	
								case 38:
									ts = new Date();
									logKey = 'LOG-' + ts.getDate() + '-' + (ts.getMonth() + 1) + '-' + ts.getFullYear();
	
									ts.setDate(ts.getDate() - 1);
									lastLogKey = 'LOG-' + ts.getDate() + '-' + (ts.getMonth() + 1) + '-' + ts.getFullYear();
	
									window.localStorage.removeItem(lastLogKey);
									_Logger.Logger.EnableLocalLog(whiteLabelConfig.enableLocalLog, whiteLabelConfig.cleanLocalLogsMin);
									if (whiteLabelConfig.enableLocalLog) {
										this.props.toggleLocalLogging(true);
										prevEntries = window.localStorage.getItem(logKey);
										// window.localStorage.setItem(logKey, 'LOG START')
	
										prevEntries ? window.localStorage.setItem(logKey, prevEntries + ';LOG START') : window.localStorage.setItem(logKey, 'LOG START');
									} else {
										window.localStorage.removeItem(logKey);
									}
	
									_this = this;
									langHelper = new _helperLanguage.helperLanguage();
	
									langHelper.setLanguage('', function () {
										_this.checkSoftPhone();
									});
	
								case 48:
								case 'end':
									return _context.stop();
							}
						}
					}, _callee, this);
				}));
	
				function componentDidMount() {
					return _ref.apply(this, arguments);
				}
	
				return componentDidMount;
			}()
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				window.removeEventListener('beforeunload', this.handleUnload);
			}
		}, {
			key: 'handleUnload',
			value: function handleUnload(e) {
				_Logger.Logger.Trace('handleUnload Refresh', e);
				this.setState({
					consulting: this.state.consulting - 1
				});
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				this.setState({
					consulting: nextProps.consultingCounter.consulting
				});
	
				if (this.userActionsApp[nextProps.userActions.actionType]) {
					this.userActionsApp[nextProps.userActions.actionType]();
				}
				nextProps.messagesToSM.message !== this.props.messagesToSM.message && this.sendToRabbit(_constants.SM_QUEUE_SERVER, nextProps.messagesToSM.message);
				// nextProps.messagesToSM.message = "";
				if (this.actionsCall[nextProps.callActionsACD.callAction]) {
					this.actionsCall[nextProps.callActionsACD.callAction](nextProps.callActionsACD.parameters, nextProps.callActionsACD.callOutId);
					nextProps.callActionsACD.callAction = null;
				}
				if (nextProps.volumeControl && nextProps.volumeControl.changingVolume) {
					this.volume(nextProps.volumeControl.speakerVolume, nextProps.volumeControl.microphoneVolume);
				}
	
				if (nextProps.messagesIntegrations !== this.props.messagesIntegrations) {
					if (nextProps.messagesIntegrations.dataMessageIntegration) {
						if (_Strategies_Reducer_Integration.STRATEGIES_REDUCER_INTEGRATION[nextProps.messagesIntegrations.dataMessageIntegration.action]) {
							_Strategies_Reducer_Integration.STRATEGIES_REDUCER_INTEGRATION[nextProps.messagesIntegrations.dataMessageIntegration.action](this, nextProps.messagesIntegrations.dataMessageIntegration);
						}
					}
				}
			}
		}, {
			key: 'connectCall',
			value: function connectCall(message, userID) {
				_Strategies_SoftPhone.SOFTPHONE_MAKECALL[this.sharedData.getSoftPhone()](this, message, userID);
			}
		}, {
			key: 'parametersRabbit',
			value: function parametersRabbit() {
				_Logger.Logger.Trace('[App][parametersRabbit] Reading setting 199 for MessageQueue Configuration');
				var rabbitParametters = this.sharedData.getGeneralPermissions()[199];
				_Logger.Logger.Debug('[App][parametersRabbit] MessageQueue configuration: ', rabbitParametters);
				var settingRabbit = rabbitParametters.split('|');
				var secureConnection = this.sharedData.getSecureConnection();
				var port = !secureConnection ? '15674' : settingRabbit[2];
	
				if (rabbitMqTest && !rabbitMqTest.isWebStomp) {
					port = !secureConnection ? rabbitMqTest.port : rabbitMqTest.portSSL;
					_Logger.Logger.Debug('Port MqTT ', port);
				}
	
				this.agentController.AgentObject.mq_port = port;
				this.agentController.AgentObject.mq_vhost = settingRabbit[3];
				this.agentController.AgentObject.mq_username = settingRabbit[4];
				this.agentController.AgentObject.mq_password = settingRabbit[5];
				this.agentController.AgentObject.mq_consumer = this.sharedData.getUserData().Login;
				this.agentController.AgentObject.mq_expiration = settingRabbit[6];
				this.agentController.AgentObject.mq_secureConnection = secureConnection;
				this.agentController.AgentObject.heartbeat = {
					outgoing: 20000,
					incoming: 20000
				};
	
				if (false) {
					this.agentController.AgentObject.mq_server = SERVER_IP;
				} else {
					this.agentController.AgentObject.mq_server = window.location.hostname;
				}
			}
		}, {
			key: 'setParameters',
			value: function setParameters() {
				this.parametersRabbit();
				_Strategies_SoftPhone.SOFTPHONE_PARAMETERS[this.sharedData.getSoftPhone()](this, parameterMizu);
			}
		}, {
			key: 'parametersEngine',
			value: function parametersEngine() {
				_Logger.Logger.Trace('[App][parametersEngine] Reading setting 143 for Engine Configuration');
				var parameterEngine = this.sharedData.getGeneralPermissions()[143];
				_Logger.Logger.Trace('[App][parametersEngine] Engine configuration: ', parameterEngine);
				var enginesPosition = parameterEngine.split(',');
				for (var i = 0; i < enginesPosition.length; i++) {
					var position = enginesPosition[i].split('|');
					this.Engines[position[0]] = position[1];
				}
			}
		}, {
			key: 'setIpEngine',
			value: function setIpEngine(engineId, ipKamailio) {
				_Logger.Logger.Trace('[App][setIpEngine] Reading setting 131 for Mizu Configuration');
				var setting131 = this.sharedData.getGeneralPermissions()[131];
				_Logger.Logger.Trace('[App][setIpEngine] Mizu configuration: ', setting131);
				var datoPBX = setting131.split('|');
				var CNF = 'PBX' + engineId + '@' + datoPBX[7];
				_Logger.Logger.Trace('Destination: ' + CNF);
				CNF = this.apiCont.cypher.md5Encryption(CNF);
				_Logger.Logger.Trace('Destination: ' + CNF);
				this.agentController.AgentObject.SIP_CNF_XD = CNF;
				this.agentController.AgentObject.SIP_KAMAILIO = '@' + ipKamailio + ':5061';
				if (parametersWebRTC) {
					_Logger.Logger.Trace('[Strategies_SoftPhone][SOFTPHONE_PARAMETERS] Parameters to WebRTC manifest.json => ', parametersWebRTC);
					if (parametersWebRTC.SIP_iceCheckingTimeout) {
						this.agentController.AgentObject.SIP_iceCheckingTimeout = parametersWebRTC.SIP_iceCheckingTimeout;
					}
				}
				this.agentController.UpdateParametersSIP();
			}
		}, {
			key: 'tryMessageToIntegration',
			value: function tryMessageToIntegration(message) {
				if (_Strategies_SM_To_Integration.STRATEGIES_SM_TO_INTEGRATION[message.action]) {
					_Strategies_SM_To_Integration.STRATEGIES_SM_TO_INTEGRATION[message.action](this, message);
				}
			}
		}, {
			key: 'stateMachineDown',
			value: function stateMachineDown() {
				this.setState({
					consulting: this.state.consulting - 1,
					loginError: 1029
				});
				var message = {
					code: 1029,
					message: this.language.getText('error-' + 1029)
				};
				var integrationMessage = {
					client: 'galatea',
					data: message,
					action: 'remoteLoginError'
				};
				_SingletonWebSocket2.default.send(integrationMessage);
			}
		}, {
			key: 'callStateAction',
			value: function callStateAction(message) {
				if (_StrategiesStates.STRATEGIES_STATES[message.currentState]) {
					if (message.currentState !== 'Ready') {
						this.props.removeWindow(_constants.DRAGGABLE_WINDOWS.MANUAL_MESSAGE);
					}
					if (this.sharedData.getCurrentState() === 'Wrapup' && !this.sharedData.getIsRated()) {
						_Logger.Logger.Trace('The call:' + this.callId + ' was not rated CurrentState:' + message.currentState);
					}
					_StrategiesStates.STRATEGIES_STATES[message.currentState](message, this, document.getElementById('audio-call'));
					if (message.currentState === 'ERROR') {
						setTimeout(function () {
							location.reload();
						}, 2000);
					} else if (message.currentState !== 'ERROR' && message.currentState !== 'ALERT') {
						var integrationMessage = {
							client: 'galatea',
							data: message,
							action: 'agentStatusChange'
						};
						_SingletonWebSocket2.default.send(integrationMessage);
						this.sharedData.setCurrentState(message.currentState);
					}
				} else {
					_Logger.Logger.Warn('[App][callStateAction] State Not implement ', message.currentState);
				}
			}
		}, {
			key: 'processMessage',
			value: function processMessage(message) {
				if (this.state.alert) {
					this.setState({ alert: null });
				}
				this.smResponseHelper.clearTimer(message);
				(0, _ProcessMessage.ProcessMessage)(message, this);
			}
		}, {
			key: 'sendToRabbit',
			value: function sendToRabbit(topic, message) {
				if (message) {
					this.smResponseHelper.setTimer(message);
					delete message.ExpectsReponse;
					var obj = message;
					if (typeof message === 'string') {
						obj = JSON.parse(message);
					}
					obj.timeSpam = this.agentController.getTimeStamp();
					message = JSON.stringify(obj);
					_Logger.Logger.Debug('[App][sendToRabbit] Sending Message =>' + message + ' TOPIC => ' + topic);
					this.agentController.sendMessage(topic, message);
					this.dateSendMessage = new Date();
					this.props.resetMessageToSM();
				}
			}
		}, {
			key: 'getChatLog',
			value: function getChatLog() {
				var objectResponse = this.apiCont.getObjectResponse();
				var _this = this;
				this.apiCont.getChatLog(this.sharedData.getParameters().UserID, objectResponse);
				objectResponse.onError = function () {};
				objectResponse.onSuccess = function (objResponse) {
					for (var admin in objResponse) {
						var messages = objResponse[admin];
						for (var messageID in messages) {
							_this.sharedData.setObjectChat(messages[messageID], admin);
						}
					}
				};
			}
		}, {
			key: 'makeCall',
			value: function makeCall(callId) {
				var _this = this;
				setTimeout(function () {
					_this.agentController.makeCall(callId);
				}, 200);
			}
		}, {
			key: 'hangUp',
			value: function hangUp() {
				this.sendToRabbit(_constants.SM_QUEUE_SERVER, (0, _helperMessages.messageHangUp)(_constants.HANG_UP_SUBACTIONS.CALL, 0));
			}
		}, {
			key: 'hold',
			value: function hold(callOutId) {
				this.sendToRabbit(_constants.SM_QUEUE_SERVER, (0, _helperMessages.messageApiRequest)(_constants.API_ENDPOINTS.HOLD, '', false, callOutId));
			}
		}, {
			key: 'volume',
			value: function volume(speaker, microphone) {
				_Logger.Logger.Info('[App][volume] set volume speaker:' + speaker + ' microphone:' + microphone + '');
				this.agentController.volumeSpeaker(speaker);
				this.agentController.volumeMicrophone(microphone);
				_Logger.Logger.Info('[App][volume] get volume speaker:' + this.agentController.volumeSpeakerGet() + ' microphone:' + this.agentController.volumeMicrophoneGet() + '');
			}
		}, {
			key: 'DTMF',
			value: function DTMF(digit) {
				var _this4 = this;
	
				if (digit.length === 1) {
					setTimeout(function () {
						_this4.agentController.dtmf(digit);
					}, 20);
				} else {
					var _loop = function _loop(i) {
						setTimeout(function () {
							_this4.agentController.dtmf(digit[i]);
						}, 50 * (i + 1));
					};
	
					for (var i in digit) {
						_loop(i);
					}
				}
			}
		}, {
			key: 'deleteAlert',
			value: function deleteAlert() {
				this.setState({ alert: null });
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {
				if (this.state.alert) {
					this.deleteAlert();
				}
				if (this.state.newAlertCode !== 0) {
					this.setState({ newAlertCode: 0 });
				}
			}
		}, {
			key: 'actionsValitatingTelephony',
			value: function actionsValitatingTelephony() {
				_Strategies_SoftPhone.SOFTPHONE_VALIDATING[this.sharedData.getSoftPhone()](this);
			}
		}, {
			key: 'checkOtherState',
			value: function checkOtherState() {
				if (this.sharedData.getLogged()) {
					this.props.changeState(_constants.USER_STATE.OTHER);
				} else {
					_Strategies_SoftPhone.SOFTPHONE_HANGUP[this.sharedData.getSoftPhone()](this);
				}
			}
		}, {
			key: 'loginWebAgent',
			value: function loginWebAgent() {
				if (window['NuxibaLogger']['_SERVER'] !== window.location.origin && ("production") !== 'development') {
					window['NuxibaLogger']['_SERVER'] = window.location.origin;
				}
				if (!this.rabbitConnected) {
					this.setState({ consulting: this.state.consulting + 1 });
					this.setParameters();
					this.agentController.connectToRabbit();
				} else {
					this.setState({ consulting: this.state.consulting + 1 });
					this.sendToRabbit(_constants.SM_QUEUE_SERVER, (0, _helperMessages.messageLogin)(this.agentController.getTimeStamp()));
				}
			}
		}, {
			key: 'showDialogBox',
			value: function showDialogBox(data) {
				this.setState({
					dialogContent: Object.assign({}, data),
					dialogShow: !this.state.dialogShow
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _this5 = this;
	
				return _react2.default.createElement(
					'div',
					{ className: 'AgentContainer' },
					_react2.default.createElement('canvas', { className: 'canvas-overlay' }),
					this.state.isLogged ? _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(_Header2.default, { callType: this.state.callType, idChangeCount: this.state.idChangeCount, queueCount: this.state.queueCount, timeInQueue: this.state.timeInQueue }),
						_react2.default.createElement(_workSpace2.default, {
							alert: this.state.alert,
							newAlertCode: this.state.newAlertCode,
							newAlertMessage: this.state.newAlertMessage,
							dataCall: this.state.dataCall,
							extraDataCall: this.state.extraDataCall,
							networkMonitoring: networkMonitoringConfig
						}),
						_react2.default.createElement(_AlertModal2.default, null),
						_react2.default.createElement(_AlertAudioFocusTab2.default, null),
						_react2.default.createElement(_AdminAlertModal2.default, null),
						_react2.default.createElement(_globalComponentsLibrary.DialogBox, Object.assign({ show: this.state.dialogShow, toggle: function toggle() {
								return _this5.setState({ dialogShow: !_this5.state.dialogShow });
							} }, this.state.dialogContent))
					) : _react2.default.createElement(_Login2.default, { softPhoneLoaded: this.state.softPhoneLoaded, languageLoaded: this.state.loadedLanguaje, loginError: this.state.loginError, onLogin: function onLogin() {
							return _this5.loginWebAgent();
						} }),
					_react2.default.createElement(_Footer2.default, { isLogged: this.state.isLogged, integrationAutorun: this.state.integrationAutorun, integrationIconActived: this.sharedData.getintegrationIconActived() }),
					this.state.consulting > 0 && _react2.default.createElement(_Consulting2.default, null)
				);
			}
		}]);
	
		return App;
	}(_react.Component);
	
	function mapDispatchToProps(dispatch) {
		var _showAlertModal = _A_Alert_Modal2.default.creators.showAlertModal;
		var _hideAlertModal = _A_Alert_Modal2.default.creators.hideAlertModal;
	
		return {
			messageChangeState: function messageChangeState() {
				dispatch((0, _A_messages_to_SM.messageChangeState)());
			},
			sendMessageNoAvailable: function sendMessageNoAvailable(userName, userID, notReadyID, timeInPreview) {
				dispatch((0, _A_messages_to_SM.sendMessageNoAvailable)(userName, userID, notReadyID, timeInPreview));
			},
			logout: function logout() {
				dispatch((0, _A_user_actions.logout)());
			},
			changeState: function changeState(newState) {
				dispatch((0, _A_user_states.changeState)(newState));
			},
			noAvailableData: function noAvailableData(frameNA, timeNA, supervisorPassNA, descriptionNA) {
				dispatch((0, _A_no_available.noAvailableData)(frameNA, timeNA, supervisorPassNA, descriptionNA));
			},
			validatingState: function validatingState(stateV, timeV) {
				dispatch((0, _A_validating_telephony.validatingState)(stateV, timeV));
			},
			messageFromSupervisor: function messageFromSupervisor(message, supervisor) {
				dispatch((0, _A_actions_from_SM.messageFromSupervisor)(message, supervisor));
			},
			hangUpFromSip: function hangUpFromSip() {
				dispatch((0, _A_sip_client_actions.hangUpFromSip)());
			},
			streamFromSip: function streamFromSip(data) {
				dispatch((0, _A_sip_client_actions.streamFromSip)(data));
			},
			agentUnavailableOnTransfer: function agentUnavailableOnTransfer(message) {
				dispatch((0, _A_actions_from_SM.agentUnavailableOnTransfer)(message));
			},
			newAssistedTransferState: function newAssistedTransferState(message) {
				dispatch((0, _A_assisted_transfer.newAssistedTransferState)(message));
			},
			updateInfoWB: function updateInfoWB(workItem) {
				dispatch((0, _A_other_actions.updateInfoWB)(workItem));
			},
			messageTransferCall: function messageTransferCall(data) {
				dispatch((0, _A_messages_to_SM.messageTransferCall)(data));
			},
			showAlertModal: function showAlertModal(payload) {
				dispatch(_showAlertModal(payload));
			},
			hideAlertModal: function hideAlertModal(payload) {
				dispatch(_hideAlertModal(payload));
			},
			newUnifiedInboxConversation: function newUnifiedInboxConversation(message) {
				dispatch((0, _A_actions_UnifiedInbox.newUnifiedInboxConversation)(message));
			},
			newUnifiedInboxMessage: function newUnifiedInboxMessage(message) {
				dispatch((0, _A_actions_UnifiedInbox.newUnifiedInboxMessage)(message));
			},
			newUnifiedInboxExternalMessage: function newUnifiedInboxExternalMessage(message) {
				dispatch((0, _A_actions_UnifiedInbox.newUnifiedInboxExternalMessage)(message));
			},
			newUnifiedInboxExternalNewMessage: function newUnifiedInboxExternalNewMessage(message) {
				dispatch((0, _A_actions_UnifiedInbox.newUnifiedInboxExternalNewMessage)(message));
			},
			changeStateMessage: function changeStateMessage(message) {
				dispatch((0, _A_actions_UnifiedInbox.changeStateMessage)(message));
			},
			changeStateExternalMessage: function changeStateExternalMessage(message) {
				dispatch((0, _A_actions_UnifiedInbox.changeStateExternalMessage)(message));
			},
			showUnifiedMessagesWindow: function showUnifiedMessagesWindow(show) {
				dispatch((0, _A_actions_UnifiedInbox.showUnifiedMessagesWindow)(show));
			},
			chatTyping: function chatTyping(message) {
				dispatch((0, _A_actions_UnifiedInbox.chatTyping)(message));
			},
			chatTakeover: function chatTakeover(message) {
				dispatch((0, _A_actions_UnifiedInbox.chatTakeover)(message));
			},
			chatAnswersTemplates: function chatAnswersTemplates(message) {
				dispatch((0, _A_actions_UnifiedInbox.chatAnswersTemplates)(message));
			},
			endConversationChat: function endConversationChat(message) {
				dispatch((0, _A_actions_UnifiedInbox.endConversationChat)(message));
			},
			aceptedChat: function aceptedChat(message) {
				dispatch((0, _A_actions_UnifiedInbox.aceptedChat)(message));
			},
			endConversationClient: function endConversationClient(message, clientTermination) {
				dispatch((0, _A_actions_UnifiedInbox.endConversationClient)(message, clientTermination));
			},
			setCustomImages: function setCustomImages(whiteLabelEnabled, imageFormat, login, header, about) {
				return dispatch((0, _A_actions_from_white_label.setCustomImages)(whiteLabelEnabled, imageFormat, login, header, about));
			},
			setMultimediaDispositions: function setMultimediaDispositions(message) {
				dispatch((0, _A_actions_UnifiedInbox.setMultimediaDispositions)(message));
			},
			updateCount: function updateCount(itemQueue, countQueue, timeInQueue) {
				dispatch((0, _A_queue_count.updateCount)(itemQueue, countQueue, timeInQueue));
			},
			toggleLocalLogging: function toggleLocalLogging(enableLocalLog) {
				dispatch((0, _A_local_logging.toggleLocalLogging)(enableLocalLog));
			},
			removeWindow: function removeWindow(iDdragComponent) {
				dispatch((0, _A_draggable_windows_controller.removeWindow)(iDdragComponent));
			},
			manualCall: function manualCall(data) {
				dispatch((0, _A_messages_to_SM.manualCall)(data));
			},
			conversationTimeoutReached: function conversationTimeoutReached(data) {
				dispatch((0, _A_actions_UnifiedInbox.conversationTimeoutReached)(data));
			},
			endConversationsCampaignDeleted: function endConversationsCampaignDeleted(data) {
				dispatch((0, _A_actions_UnifiedInbox.endConversationsCampaignDeleted)(data));
			},
			newHistoricalConversation: function newHistoricalConversation(data) {
				dispatch((0, _A_actions_UnifiedInbox.newHistoricalConversation)(data));
			},
			errorOnHistoricalConversation: function errorOnHistoricalConversation(data) {
				dispatch((0, _A_actions_UnifiedInbox.errorOnHistoricalConversation)(data));
			},
			dataTransferPreview: function dataTransferPreview(previewAction, phoneList, acdList, agentList) {
				dispatch((0, _A_preview_transfer.dataTransferPreview)(previewAction, phoneList, acdList, agentList));
			},
			actionResponseTransfer: function actionResponseTransfer(agent, response) {
				dispatch((0, _A_messages_to_SM.actionResponseTransfer)(agent, response));
			},
			actionPreviewRecord: function actionPreviewRecord(data) {
				dispatch((0, _A_messages_to_SM.actionPreviewRecord)(data));
			},
			insertWindow: function insertWindow(dragWindow, closeComponentIfOpen) {
				dispatch((0, _A_draggable_windows_controller.insertWindow)(dragWindow, closeComponentIfOpen));
			},
			updatePermissions: function updatePermissions(permissionName, permissionValue) {
				dispatch((0, _A_actions_UnifiedInbox.updatePermissions)(permissionName, permissionValue));
			},
			showAdminModal: function showAdminModal(payload) {
				dispatch((0, _A_Admin_Alert_Modal.showAdminModal)(payload));
			},
			hideAdminModal: function hideAdminModal() {
				dispatch((0, _A_Admin_Alert_Modal.hideAdminModal)());
			},
			updateConversationsPhoneChange: function updateConversationsPhoneChange(data) {
				dispatch((0, _A_actions_UnifiedInbox.updateConversationsPhoneChange)(data));
			},
			savePreviewRecord: function savePreviewRecord(data) {
				dispatch((0, _A_preview.savePreviewRecord)(data));
			},
			onAcceptedTransfer: function onAcceptedTransfer(value) {
				dispatch((0, _A_preview_transfer.onAcceptedTransfer)(value));
			},
			updatePreviewRecord: function updatePreviewRecord(data) {
				dispatch((0, _A_preview.updatePreviewRecord)(data));
			},
			cleanData: function cleanData() {
				dispatch((0, _A_preview.cleanData)());
			},
			changeCampaignType: function changeCampaignType(flag) {
				dispatch((0, _A_preview.changeCampaignType)(flag));
			},
			isSuccessfullChangeCamp: function isSuccessfullChangeCamp(flag) {
				dispatch((0, _A_preview.isSuccessfullChangeCamp)(flag));
			},
			saveInitialTime: function saveInitialTime() {
				dispatch((0, _A_preview.saveInitialTime)());
			},
			alertMessageErrorMMC: function alertMessageErrorMMC(message) {
				dispatch((0, _A_actions_UnifiedInbox.alertMessageErrorMMC)(message));
			},
			showAlert: function showAlert() {
				dispatch((0, _A_preview_transfer.showAlert)());
			},
			showPreviewData: function showPreviewData(payload) {
				dispatch((0, _A_preview_transfer.showPreviewData)(payload));
			},
			saveDataFromTransfer: function saveDataFromTransfer(message) {
				dispatch((0, _A_preview.saveDataFromTransfer)(message));
			},
			setDialogTime: function setDialogTime(message) {
				dispatch((0, _A_preview.setDialogTime)(message));
			},
			setDialingMode: function setDialingMode(message) {
				dispatch((0, _A_preview.setDialingMode)(message));
			},
			setAllowPlayRecordsOnCallHistory: function setAllowPlayRecordsOnCallHistory(allowPlayRecordsOnCallHistory) {
				dispatch((0, _A_agent_permissions.setAllowPlayRecordsOnCallHistory)(allowPlayRecordsOnCallHistory));
			},
			setIsSendProcess: function setIsSendProcess(flag) {
				dispatch((0, _A_preview.setIsSendProcess)(flag));
			},
			setTempPrevRecord: function setTempPrevRecord(data) {
				dispatch((0, _A_preview.setTempPrevRecord)(data));
			},
			onSetMessageStatus: function onSetMessageStatus(messageStatus, phone) {
				dispatch((0, _A_manual_message.setMessageStatus)(messageStatus, phone));
			},
			setAllowChangeDialingMode: function setAllowChangeDialingMode(mode) {
				dispatch((0, _A_agent_permissions.setAllowChangeDialing)(mode));
			},
			setPreviewSelectedCampaign: function setPreviewSelectedCampaign(data) {
				dispatch((0, _A_preview.setPreviewSelectedCampaign)(data));
			},
			changePreviewRecordStatus: function changePreviewRecordStatus(data) {
				dispatch((0, _A_preview.changePreviewRecordStatus)(data));
			},
			setInitialDialogTime: function setInitialDialogTime(data) {
				dispatch((0, _A_preview.setInitialDialogTime)(data));
			},
			setCallId: function setCallId(data) {
				dispatch((0, _A_preview.setCallId)(data));
			},
			setDialogTimeSimultaneousView: function setDialogTimeSimultaneousView(data) {
				dispatch((0, _A_preview.setDialogTimeSimultaneousView)(data));
			},
			bindTransfer: function bindTransfer(data) {
				dispatch((0, _A_transfer.bindTransfer)(data));
			},
			resetTransfer: function resetTransfer() {
				dispatch((0, _A_transfer.resetTransfer)());
			},
			assistedErrorTransfer: function assistedErrorTransfer(data) {
				dispatch((0, _A_transfer.assistedErrorTransfer)(data));
			},
			resetAssistedErrorTransfer: function resetAssistedErrorTransfer() {
				dispatch((0, _A_transfer.resetAssistedErrorTransfer)());
			},
			setSelectedRecord: function setSelectedRecord(callOutId) {
				dispatch((0, _A_preview.setSelectedRecord)(callOutId));
			},
			setNDScheduled: function setNDScheduled() {
				dispatch((0, _A_preview.setNDScheduled)());
			},
			setTransferInProgress: function setTransferInProgress(flag) {
				dispatch((0, _A_preview_transfer.setTransferInProgress)(flag));
			},
			setUnnasignByXfer: function setUnnasignByXfer(flag) {
				dispatch((0, _A_preview_transfer.setUnnasignByXfer)(flag));
			},
			resetMessageToSM: function resetMessageToSM() {
				dispatch((0, _A_messages_to_SM.messageToStateMachine)(null));
			},
			showDataTransferBySetting: function showDataTransferBySetting(flag) {
				dispatch((0, _A_transfer.showDataTransferBySetting)(flag));
			}
		};
	}
	
	function mapStateToProps(state) {
		return {
			consultingCounter: state.consultingCounter,
			messagesToSM: state.messagesToSM,
			userActions: state.userActions,
			callActionsACD: state.callActionsACD,
			volumeControl: state.volumeControl,
			messagesIntegrations: state.messagesIntegrations,
			selectedConversarionID: state.unifiedInboxState.selectedID,
			preview: state.preview,
			userState: state.userState,
			transferReducer: state.transferReducer
		};
	}
	
	exports.default = App = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(App);

/***/ },
/* 1071 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _interopDefault(ex) {
	  return ex && (typeof ex === 'undefined' ? 'undefined' : _typeof(ex)) === 'object' && 'default' in ex ? ex['default'] : ex;
	}
	
	var React = _interopDefault(__webpack_require__(1));
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  return _extends.apply(this, arguments);
	}
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	// A type of promise-like that resolves synchronously and supports only one observer
	
	var _iteratorSymbol = /*#__PURE__*/typeof Symbol !== "undefined" ? Symbol.iterator || (Symbol.iterator = Symbol("Symbol.iterator")) : "@@iterator";
	
	var _asyncIteratorSymbol = /*#__PURE__*/typeof Symbol !== "undefined" ? Symbol.asyncIterator || (Symbol.asyncIterator = Symbol("Symbol.asyncIterator")) : "@@asyncIterator";
	
	// Asynchronously call a function and send errors to recovery continuation
	function _catch(body, recover) {
	  try {
	    var result = body();
	  } catch (e) {
	    return recover(e);
	  }
	  if (result && result.then) {
	    return result.then(void 0, recover);
	  }
	  return result;
	}
	
	function createErrorChecker(name, regexpForMesssage) {
	  return function (error) {
	    return error.name === name && Boolean(regexpForMesssage.exec(error.message));
	  };
	}
	var chunkFailedMessageRegex = /Loading chunk [\d]+ failed/;
	var syntaxErrorMessageRegex = /['"\s]<['"\s]/;
	var defaultErrorCheckers = [createErrorChecker('ChunkLoadError', chunkFailedMessageRegex), createErrorChecker('SyntaxError', syntaxErrorMessageRegex)];
	var storageKey = 'APP_VERSION';
	var filename = 'meta.json';
	var latestVersion = 'latest';
	var disabledVersion = 'disabled';
	var defaultProps = {
	  fallback: null,
	  errorCheckers: [],
	  auto: false,
	  storageKey: storageKey,
	  filename: filename,
	  storage: {
	    get: function get() {
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return window.localStorage.getItem.apply(window.localStorage, args);
	    },
	    set: function set() {
	      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      window.localStorage.setItem.apply(window.localStorage, args);
	    }
	  }
	};
	var ClearBrowserCacheCtx = React.createContext({});
	function useClearBrowserCache() {
	  return React.useContext(ClearBrowserCacheCtx);
	}
	function ClearBrowserCache(_ref) {
	  var children = _ref.children;
	  var ctx = useClearBrowserCache();
	  return children(ctx);
	}
	
	function createAppVersionStorage(storageKey, storage) {
	  return {
	    set: function set(version) {
	      try {
	        storage.set(storageKey, version);
	      } catch (error) {}
	    },
	    get: function get() {
	      try {
	        return storage.get(storageKey) || latestVersion;
	      } catch (error) {
	        return disabledVersion;
	      }
	    }
	  };
	}
	
	var ClearBrowserCacheBoundary = /*#__PURE__*/function (_React$Component) {
	  _inheritsLoose(ClearBrowserCacheBoundary, _React$Component);
	
	  function ClearBrowserCacheBoundary(props) {
	    var _this;
	
	    _this = _React$Component.call(this, props) || this;
	    _this.checkInterval = null;
	
	    _this.debug = function (error, errorInfo) {
	      var debug = _this.props.debug;
	
	      if (debug !== null && debug !== void 0 && debug.call) {
	        debug({
	          state: _this.state,
	          error: error,
	          errorInfo: errorInfo
	        });
	      }
	    };
	
	    _this.startVersionCheck = function () {
	      var _this$props = _this.props,
	          duration = _this$props.duration,
	          auto = _this$props.auto;
	      var disabled = _this.state.disabled;
	
	      if (!disabled && duration) {
	        _this.checkInterval = setInterval(function () {
	          return _this.checkVersion(auto, true);
	        }, duration);
	      }
	    };
	
	    _this.stopVersionCheck = function () {
	      if (_this.checkInterval) {
	        clearInterval(_this.checkInterval);
	      }
	    };
	
	    _this.fetchMeta = function () {
	      try {
	        var _filename = _this.props.filename;
	        var baseUrl = "/" + _filename + "?time=" + Date.now();
	        return Promise.resolve(fetch(baseUrl).then(function (r) {
	          return r.json();
	        }));
	      } catch (e) {
	        return Promise.reject(e);
	      }
	    };
	
	    _this.clearCacheAndReload = function (newVersion) {
	      try {
	        var _temp3 = function _temp3() {
	          _this.appVersionStorage.set(newVersion || _this.state.latestVersion);
	
	          window.location.reload(true);
	        };
	
	        var _temp4 = function () {
	          if ('caches' in window) {
	            return Promise.resolve(window.caches.keys()).then(function (cacheKeys) {
	              return Promise.resolve(Promise.all(cacheKeys.map(function (key) {
	                return window.caches["delete"](key);
	              }))).then(function () {});
	            });
	          }
	        }();
	
	        return Promise.resolve(_temp4 && _temp4.then ? _temp4.then(_temp3) : _temp3(_temp4));
	      } catch (e) {
	        return Promise.reject(e);
	      }
	    };
	
	    _this.checkVersion = function (auto, silent) {
	      if (auto === void 0) {
	        auto = false;
	      }
	
	      if (silent === void 0) {
	        silent = false;
	      }
	
	      try {
	        var _temp9 = _catch(function () {
	          var appVersion = _this.state.latestVersion;
	          return Promise.resolve(_this.fetchMeta()).then(function (meta) {
	            var day = new Date().getDay();
	            var newVersion = meta.version + '|' + day;
	            var isUpdated = newVersion === appVersion;
	
	            var _temp7 = function () {
	              if (!isUpdated) {
	                var _temp10 = function _temp10() {
	                  _this.appVersionStorage.set(newVersion);
	                };
	
	                var _temp11 = function () {
	                  if (auto) {
	                    return Promise.resolve(_this.clearCacheAndReload()).then(function () {});
	                  } else {
	                    _this.setState({
	                      latestVersion: newVersion,
	                      loading: false,
	                      isLatestVersion: false
	                    });
	                  }
	                }();
	
	                return _temp11 && _temp11.then ? _temp11.then(_temp10) : _temp10(_temp11);
	              } else if (!silent) {
	                _this.setState({
	                  loading: false,
	                  isLatestVersion: true
	                });
	              }
	            }();
	
	            if (_temp7 && _temp7.then) return _temp7.then(function () {});
	          });
	        }, function (error) {
	          _this.debug(error);
	
	          _this.setState({
	            loading: false
	          });
	        });
	
	        return Promise.resolve(_temp9 && _temp9.then ? _temp9.then(function () {}) : void 0);
	      } catch (e) {
	        return Promise.reject(e);
	      }
	    };
	
	    _this.errorCheckers = defaultErrorCheckers.concat(props.errorCheckers);
	    _this.appVersionStorage = createAppVersionStorage(props.storageKey, props.storage);
	
	    var latestVersion = _this.appVersionStorage.get();
	
	    var disabled = latestVersion === disabledVersion;
	    _this.state = {
	      loading: !disabled,
	      latestVersion: latestVersion,
	      disabled: disabled,
	      isLatestVersion: true
	    };
	    return _this;
	  }
	
	  var _proto = ClearBrowserCacheBoundary.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    var disabled = this.state.disabled;
	
	    if (!disabled) {
	      this.checkVersion(true);
	    }
	
	    window.addEventListener('focus', this.startVersionCheck);
	    window.addEventListener('blur', this.stopVersionCheck);
	    this.debug();
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate() {
	    var loading = this.state.loading;
	    this.stopVersionCheck();
	
	    if (!loading) {
	      this.startVersionCheck();
	    }
	
	    this.debug();
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.stopVersionCheck();
	    window.removeEventListener('focus', this.startVersionCheck);
	    window.removeEventListener('blur', this.stopVersionCheck);
	  };
	
	  _proto.componentDidCatch = function componentDidCatch(error, errorInfo) {
	    var _this2 = this;
	
	    var _this$state = this.state,
	        loading = _this$state.loading,
	        disabled = _this$state.disabled;
	
	    function throwError() {
	      throw error;
	    }
	
	    if (disabled) throwError();
	    if (loading) return;
	    var needCheckVersion = this.errorCheckers.some(function (checkError) {
	      return checkError(error);
	    });
	
	    if (needCheckVersion) {
	      this.setState({
	        loading: true
	      });
	      this.checkVersion(true, false).then(function () {
	        _this2.debug(error, errorInfo);
	
	        _this2.setState(throwError);
	      });
	    } else {
	      throwError();
	    }
	  };
	
	  _proto.render = function render() {
	    var _this3 = this;
	
	    var _this$props2 = this.props,
	        children = _this$props2.children,
	        fallback = _this$props2.fallback;
	    var loading = this.state.loading;
	
	    if (loading) {
	      return fallback;
	    }
	
	    return React.createElement(ClearBrowserCacheCtx.Provider, {
	      value: _extends({}, this.state, {
	        clearCacheAndReload: function clearCacheAndReload() {
	          return _this3.clearCacheAndReload();
	        }
	      })
	    }, children);
	  };
	
	  return ClearBrowserCacheBoundary;
	}(React.Component);
	ClearBrowserCacheBoundary.defaultProps = defaultProps;
	
	function lazyRetry(fn, retriesLeft, interval) {
	  if (retriesLeft === void 0) {
	    retriesLeft = 2;
	  }
	
	  if (interval === void 0) {
	    interval = 1000;
	  }
	
	  return new Promise(function (resolve, reject) {
	    fn().then(resolve)["catch"](function (error) {
	      setTimeout(function () {
	        if (retriesLeft === 1) {
	          reject(error);
	          return;
	        }
	
	        lazyRetry(fn, retriesLeft - 1, interval).then(resolve, reject);
	      }, interval);
	    });
	  });
	}
	
	exports.ClearBrowserCache = ClearBrowserCache;
	exports.ClearBrowserCacheBoundary = ClearBrowserCacheBoundary;
	exports.createErrorChecker = createErrorChecker;
	exports.lazyRetry = lazyRetry;
	exports.useClearBrowserCache = useClearBrowserCache;

/***/ },
/* 1072 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _Logger = __webpack_require__(37);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getError = function getError(e) {
		if (e.error && e.error.message && e.error.stack) {
			return e.error.message + ' ' + e.error.stack;
		} else if (e.message) {
			return e.message;
		} else if ((typeof e === 'undefined' ? 'undefined' : _typeof(e)) === 'object') {
			return JSON.stringify(e);
		}
		return e;
	};
	
	var ErrorHandler = function (_Component) {
		_inherits(ErrorHandler, _Component);
	
		function ErrorHandler(props) {
			_classCallCheck(this, ErrorHandler);
	
			var _this = _possibleConstructorReturn(this, (ErrorHandler.__proto__ || Object.getPrototypeOf(ErrorHandler)).call(this, props));
	
			_this.offlineTime = null;
			return _this;
		}
	
		_createClass(ErrorHandler, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.overwriteConsole();
				window.addEventListener('error', this.onErrorClient);
				window.addEventListener('offline', this.offline);
				window.addEventListener('online', this.online);
			}
		}, {
			key: 'offline',
			value: function offline(e) {
				this.offlineTime = new Date(e.timeStamp);
				_Logger.Logger.JsWarning('Network status: Offline');
			}
		}, {
			key: 'online',
			value: function online(e) {
				var online = new Date(e.timeStamp);
				if (this.offlineTime) {
					_Logger.Logger.Info('Network status: Reconnected , offline time in sec:  ', (online - this.offlineTime) / 1000);
				} else {
					_Logger.Logger.Info('Network status: Online');
				}
			}
		}, {
			key: 'onErrorClient',
			value: function onErrorClient(e) {
				_Logger.Logger.JsError('JS ErrorClient', getError(e));
			}
		}, {
			key: 'overwriteConsole',
			value: function overwriteConsole() {
				var console = function (oldCons) {
					return Object.assign({}, oldCons, {
						warn: function warn(text) {
							oldCons.warn(text);
							_Logger.Logger.JsWarning('JS Warning', getError(text));
						},
						error: function error(text) {
							oldCons.error(text);
							_Logger.Logger.JsError('JS Error', getError(text));
						}
					});
				}(window.console);
				window.console = console;
			}
		}, {
			key: 'componentDidCatch',
			value: function componentDidCatch(error) {
				_Logger.Logger.JsError('JS ErrorDidCatch', getError(error));
			}
		}, {
			key: 'render',
			value: function render() {
				return this.props.children;
			}
		}]);
	
		return ErrorHandler;
	}(_react.Component);
	
	exports.default = ErrorHandler;

/***/ },
/* 1073 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Singleton = __webpack_require__(21);
	
	var _FooterSVG = __webpack_require__(489);
	
	var _Integration = __webpack_require__(1122);
	
	var _Integration2 = _interopRequireDefault(_Integration);
	
	var _About = __webpack_require__(1115);
	
	var _About2 = _interopRequireDefault(_About);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Footer = function (_Component) {
	  _inherits(Footer, _Component);
	
	  function Footer(props) {
	    _classCallCheck(this, Footer);
	
	    var _this = _possibleConstructorReturn(this, (Footer.__proto__ || Object.getPrototypeOf(Footer)).call(this, props));
	
	    _this.onClickBtnDeploy = function () {
	      _this.setState({ isActive: !_this.state.isActive, jsIntegrationActive: false, aboutActive: false });
	    };
	
	    _this.onClickBtnFooter = function () {
	      _this.setState({ jsIntegrationActive: false, aboutActive: !_this.state.aboutActive });
	    };
	
	    _this.onCloseAboutWindow = function () {
	      _this.setState({ aboutActive: false });
	    };
	
	    _this.state = {
	      isActive: false,
	      jsIntegrationActive: false,
	      socketBoxIntegrationActive: false,
	      aboutActive: false
	    };
	    _this.timmerName = null;
	    _this.language = new _Singleton.Singleton();
	    _this.firstLoad = true;
	    return _this;
	  }
	
	  _createClass(Footer, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(next_props) {
	      if (!this.props.isLogged && this.props.integrationAutorun !== next_props.integrationAutorun) {
	        this.setState({
	          jsIntegrationActive: this.props.integrationAutorun,
	          isActive: this.props.integrationAutorun
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'footer',
	        { className: "footer " + (!this.props.isLogged ? "black" : "") },
	        _react2.default.createElement(
	          'div',
	          { className: 'btnDeploy ' + (!this.props.isLogged ? "white" : ""), onClick: this.onClickBtnDeploy },
	          _react2.default.createElement('div', { className: "squareFooter " + (!this.props.isLogged ? "white" : "") }),
	          _react2.default.createElement('div', { className: "squareFooter " + (this.state.isActive ? "active " : "hide ") + (!this.props.isLogged ? "white" : "") }),
	          _react2.default.createElement('div', { className: "squareFooter " + (!this.props.isLogged ? "white" : "") }),
	          _react2.default.createElement('div', { className: "squareFooter " + (!this.props.isLogged ? "white" : "") })
	        ),
	        _react2.default.createElement('div', { className: "btnsInfobar " + (this.state.isActive ? 'is-deployedBar' : 'menu-hiddenBar') }),
	        _react2.default.createElement(
	          'div',
	          { className: "btnsInfo " + (this.state.isActive ? this.props.integrationIconActived ? ' is-deployed ' : ' is-deployedNoIntegration ' : this.props.integrationIconActived ? ' menu-hidden ' : ' menu-hiddenNoIntegration ') },
	          _react2.default.createElement(
	            'div',
	            { className: 'btnsContainer' },
	            _react2.default.createElement(
	              'div',
	              { className: 'footerContainer deploy ' },
	              _react2.default.createElement(
	                'div',
	                { className: "btnFooter " + (!this.props.isLogged ? "white" : ""), onClick: this.onClickBtnFooter },
	                _FooterSVG.btn1FooterSVG
	              ),
	              this.state.aboutActive && this.state.isActive ? _react2.default.createElement(_About2.default, { closeAboutWindow: this.onCloseAboutWindow }) : ""
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: "footerContainer " + (this.props.integrationIconActived ? "deploy " : "") },
	              _react2.default.createElement(
	                'div',
	                { className: this.state.jsIntegrationActive ? "d-block" : "d-none" },
	                _react2.default.createElement(_Integration2.default, {
	                  IsIntegrationActive: this.state.jsIntegrationActive,
	                  buttonConnectTop: false,
	                  closeSocketBoxIntegration: function closeSocketBoxIntegration() {
	                    return _this2.setState({ jsIntegrationActive: false });
	                  },
	                  titleIntegration: this.language.getText("GUIIntegrationtitle"),
	                  integrationAutorun: this.props.integrationAutorun
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: "btnFooter " + (this.props.integrationIconActived ? "" : "undeploy ") + (!this.props.isLogged ? "white" : ""), onClick: function onClick() {
	                    return _this2.setState({ aboutActive: false, jsIntegrationActive: !_this2.state.jsIntegrationActive });
	                  } },
	                _FooterSVG.integrationIcon
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: "imgDiv " + (!this.props.isLogged ? "white" : "") },
	          ' ',
	          _FooterSVG.powered,
	          ' '
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: "txtCopyright " + (this.state.isActive ? this.props.integrationIconActived ? ' activeCopy ' : ' activeCopyNoIntegration ' : this.props.integrationIconActived ? ' inActiveCopy ' : ' inActiveCopyNoIntegration ') + (!this.props.isLogged ? "white" : "") },
	          this.language.getText("GUILogingalateaCopyright")
	        )
	      );
	    }
	  }]);
	
	  return Footer;
	}(_react.Component);
	
	exports.default = Footer;

/***/ },
/* 1074 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _customComponents = __webpack_require__(59);
	
	var _globalComponentsLibrary = __webpack_require__(28);
	
	var _Singleton = __webpack_require__(21);
	
	var _singletonSharedData = __webpack_require__(23);
	
	var _reactRedux = __webpack_require__(25);
	
	var _A_preview = __webpack_require__(52);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var language = new _Singleton.Singleton();
	var sharedData = new _singletonSharedData.SingletonSharedData();
	
	var CampaignType = function CampaignType(_ref) {
	  var onClose = _ref.onClose,
	      onClickSendChangesCampType = _ref.onClickSendChangesCampType;
	
	  var initialValue = (0, _react.useRef)(sharedData.getDataPreviewPro().dialingMode === 1 ? { previewCamp: 1, defaultCamp: 0 } : { previewCamp: 0, defaultCamp: 1 });
	
	  var _useState = (0, _react.useState)(initialValue.current),
	      _useState2 = _slicedToArray(_useState, 2),
	      selected = _useState2[0],
	      setSelected = _useState2[1];
	
	  var currentState = sharedData.getCurrentState().toUpperCase();
	
	  var _useState3 = (0, _react.useState)(true),
	      _useState4 = _slicedToArray(_useState3, 2),
	      disabled = _useState4[0],
	      setDisabled = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      isTryingToSave = _useState6[0],
	      setIsTryingToSave = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(),
	      _useState8 = _slicedToArray(_useState7, 2),
	      preState = _useState8[0],
	      setPreState = _useState8[1];
	
	  var _useState9 = (0, _react.useState)({ flag: false, isSaveChangesCorrect: false }),
	      _useState10 = _slicedToArray(_useState9, 2),
	      showMsg = _useState10[0],
	      setShowMsg = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(0),
	      _useState12 = _slicedToArray(_useState11, 2),
	      wichMsgShow = _useState12[0],
	      setWichMsgShow = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(''),
	      _useState14 = _slicedToArray(_useState13, 2),
	      msg = _useState14[0],
	      setMsg = _useState14[1];
	
	  var isTryingToSaveCampTyp = (0, _reactRedux.useSelector)(function (state) {
	    return state.preview.isTryingToChangeCamp;
	  });
	  var isSuccess = (0, _reactRedux.useSelector)(function (state) {
	    return state.preview.isChangeSuccess;
	  });
	  var nextCampType = (0, _reactRedux.useSelector)(function (state) {
	    return state.preview.nextCampType;
	  });
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  (0, _react.useEffect)(function () {
	    if (isTryingToSaveCampTyp && isSuccess) {
	      setWichMsgShow(2);
	    } else {
	      setWichMsgShow(1);
	    }
	  }, []);
	
	  (0, _react.useEffect)(function () {
	    IsScheduled();
	  }, [isSuccess]);
	
	  (0, _react.useEffect)(function () {
	
	    if (isTryingToSave && showMsg.flag === true && showMsg.isSaveChangesCorrect === true) {
	      setWichMsgShow(2);
	      setIsTryingToSave(false);
	    } else if (isTryingToSave && showMsg.flag === true && showMsg.isSaveChangesCorrect === false) {
	      setWichMsgShow(3);
	      setIsTryingToSave(false);
	    }
	  }, [showMsg]);
	
	  (0, _react.useEffect)(function () {
	    if (selected.previewCamp !== initialValue.current.previewCamp) {
	      setDisabled(false);
	    } else {
	      setDisabled(true);
	    }
	  }, [selected]);
	
	  (0, _react.useEffect)(function () {
	    setPreState(sharedData.getCurrentState().toUpperCase());
	  }, [isTryingToSave]);
	
	  (0, _react.useEffect)(function () {
	    if (isTryingToSave) {
	      if (selected.previewCamp === 1 && preState === 'READY' && currentState === 'READYPREVIEWPRO') {
	        //Cambios guardados Ready->ReadyPReview
	        setMsg(language.getText("GUIAlertMessagechangePreview"));
	        setShowMsg({ flag: true, isSaveChangesCorrect: true });
	      } else if (selected.previewCamp === 0 && preState === 'READYPREVIEWPRO' && currentState === 'READY') {
	        //Cambios guardados ReadyPReview->Ready
	        setMsg(language.getText("GUIAlertMessagechangeDefault"));
	        setShowMsg({ flag: true, isSaveChangesCorrect: true });
	        sharedData.setDataPreviewPro(0, sharedData.getDataPreviewPro().allowChangeDialMode);
	      } else {
	        //No se guardaron cambios
	        setShowMsg({ flag: true, isSaveChangesCorrect: false });
	      }
	    }
	  }, [currentState]);
	
	  var IsScheduled = function IsScheduled() {
	    if (isTryingToSaveCampTyp && isSuccess) {
	      var tempMsg = nextCampType === 3 ? language.getText("GUIAlertMessagechangeDefault") : language.getText("GUIAlertMessagechangePreview");
	      setMsg(tempMsg);
	      setShowMsg({ flag: true, isSaveChangesCorrect: true });
	    }
	  };
	  var saveChanges = function saveChanges(opc) {
	    if (opc.previewCamp !== selected.previewCamp) {
	      setSelected({ previewCamp: opc.previewCamp, defaultCamp: opc.defaultCamp });
	    }
	  };
	  var sendChanges = function sendChanges() {
	    dispatch((0, _A_preview.changeCampaignType)(true));
	    onClickSendChangesCampType(selected.previewCamp);
	    setIsTryingToSave(true);
	  };
	  return _react2.default.createElement(
	    'div',
	    { className: "configBar " },
	    _customComponents.CUSTOM_COMPONENTS["configCampaignType"](language.getText("GUIPreviewcampaign"), function () {
	      return onClose();
	    }),
	    wichMsgShow === 1 && _react2.default.createElement(
	      'div',
	      { className: 'CampaignTypeContainer' },
	      _react2.default.createElement(
	        'p',
	        { className: 'subTitleCampaignType' },
	        language.getText("GUIPreviewcampaignTypeSubtitle")
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'RadioBtnContainer' },
	        _react2.default.createElement(_globalComponentsLibrary.RadioButton, {
	          disabled: false,
	          checked: selected.defaultCamp,
	          value: 0,
	          onChange: function onChange() {
	            return saveChanges({ previewCamp: 0, defaultCamp: 1 });
	          },
	          id: 'normal-Campaign',
	          label: language.getText("GUIPreviewdefaultCamp"),
	          className: 'StyleRadioBtn'
	        }),
	        _react2.default.createElement(_globalComponentsLibrary.RadioButton, {
	          disabled: false,
	          checked: selected.previewCamp,
	          value: 1,
	          onChange: function onChange() {
	            return saveChanges({ previewCamp: 1, defaultCamp: 0 });
	          },
	          id: 'preview-Campaign',
	          label: language.getText("GUIPreviewpreviewCamp"),
	          className: 'StyleRadioBtn'
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'StyleBtnSave' },
	        _react2.default.createElement(
	          _globalComponentsLibrary.AgentButton,
	          { type: 'primary', color: 'blue', onClick: sendChanges, disabled: disabled },
	          language.getText("GUIPreviewbtnSave")
	        )
	      )
	    ),
	    wichMsgShow === 2 && _react2.default.createElement(
	      'div',
	      { className: 'CampaignTypeContainer' },
	      _react2.default.createElement(
	        'p',
	        { className: 'Msg' },
	        language.getText("GUIAlertMessagechangeCampType") + ' ' + msg
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'IconContainer' },
	        _react2.default.createElement('i', { id: 'Correct', className: 'gcl-icon selected' })
	      )
	    ),
	    wichMsgShow === 3 && _react2.default.createElement(
	      'div',
	      { className: 'CampaignTypeContainer' },
	      _react2.default.createElement(
	        'p',
	        { className: 'Msg' },
	        language.getText("GUIAlertMessageerrorchangeCampType")
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'IconContainer' },
	        _react2.default.createElement('i', { id: 'InCorrect', className: 'gcl-icon close-circle ' })
	      )
	    )
	  );
	};
	exports.default = CampaignType;

/***/ },
/* 1075 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(25);
	
	var _Singleton = __webpack_require__(21);
	
	var _Images = __webpack_require__(30);
	
	var _singletonSharedData = __webpack_require__(23);
	
	var _cwGalateaApiJsBundle = __webpack_require__(40);
	
	var _A_reducer_consulting = __webpack_require__(115);
	
	var _customComponents = __webpack_require__(59);
	
	var _PasswordTextArea = __webpack_require__(325);
	
	var _PasswordTextArea2 = _interopRequireDefault(_PasswordTextArea);
	
	var _SingletonWebSocket = __webpack_require__(50);
	
	var _SingletonWebSocket2 = _interopRequireDefault(_SingletonWebSocket);
	
	var _constants = __webpack_require__(10);
	
	var _Logger = __webpack_require__(37);
	
	var _A_Admin_Alert_Modal = __webpack_require__(241);
	
	var _A_Alert_Modal = __webpack_require__(63);
	
	var _A_Alert_Modal2 = _interopRequireDefault(_A_Alert_Modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ConfigBar = function (_Component) {
		_inherits(ConfigBar, _Component);
	
		function ConfigBar(props) {
			_classCallCheck(this, ConfigBar);
	
			var _this2 = _possibleConstructorReturn(this, (ConfigBar.__proto__ || Object.getPrototypeOf(ConfigBar)).call(this, props));
	
			_this2.changePassword = function () {
				var errorList = [];
				if (_this2.notEqualPassword() === 'error') {
					errorList.push({ id: 5003, description: _this2.language.getText('error-5003') });
				}
				if (_this2.more8Characters() === 'error') {
					errorList.push({ id: 5002, description: _this2.language.getText('error-5002') });
				}
				if (_this2.upperLowerNumber() === 'error') {
					errorList.push({ id: 5006, description: _this2.language.getText('error-5006') });
				}
				if (_this2.newPassEqualsConfirmation() === 'error') {
					errorList.push({ id: 5001, description: _this2.language.getText('error-5001') });
				}
	
				var integrationMessage = { client: 'galatea', action: 'onErrorPasswordUpdate', data: errorList };
				var integrationMessageErrorXion = void 0;
				var _this = _this2;
				var objectResponse = _this2.apiCont.getObjectResponse();
				_this2.props.consultingApp();
				_this2.apiCont.changePassword(_this2.sharedData.getParameters().UserID, _this2.state.password, _this2.state.confirmPassword, _this2.state.newPassword, objectResponse);
				objectResponse.onError = function (messageError) {
					_this.passAlredyExist(messageError);
					errorList.push({ id: messageError.InternalCode, description: messageError.Message });
					integrationMessageErrorXion = {
						client: 'galatea',
						action: 'errorOnPasswordChange',
						data: { id: messageError.InternalCode, description: messageError.Message }
					};
					_SingletonWebSocket2.default.send(integrationMessage);
					_SingletonWebSocket2.default.send(integrationMessageErrorXion);
					_this.setState({
						errorService: true
					});
					setTimeout(function () {
						return _this.setState({ errorService: false });
					}, 3000);
					_this.props.noConsultingApp();
				};
				objectResponse.onSuccess = function (objResponse) {
					_Logger.Logger.Trace('SUCCESS CHANGE PASS===>> ', objResponse);
					integrationMessage = { client: 'galatea', action: 'onPasswordUpdated', data: errorList };
					_SingletonWebSocket2.default.send(integrationMessage);
					_this.props.noConsultingApp();
					_this.setState({ passwordChanged: true });
					setTimeout(function () {
						_this.closeWindow();
						_this.props.onCloseSettingBar();
					}, 1000);
				};
			};
	
			_this2.state = {
				onExit: false,
				password: '',
				newPassword: '',
				confirmPassword: '',
				passwordChanged: false,
				errorService: false
			};
			_this2.language = new _Singleton.Singleton();
			_this2.sharedData = new _singletonSharedData.SingletonSharedData();
			var APIFact = new _cwGalateaApiJsBundle.APIFactory();
			_this2.apiCont = APIFact.buildClient();
			_this2.hasError = true;
			_this2.setting207 = _this2.sharedData.getGeneralPermissions()[207];
			return _this2;
		}
	
		_createClass(ConfigBar, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var _this3 = this;
	
				if (this.props.messagesIntegrations.dataMessageIntegration && this.props.messagesIntegrations.dataMessageIntegration.subaction === _constants.INTEGRATION.CHANGE_PASSWORD) {
					this.setState({
						password: this.props.messagesIntegrations.dataMessageIntegration.aCurrentPassword,
						newPassword: this.props.messagesIntegrations.dataMessageIntegration.aNewPassword,
						confirmPassword: this.props.messagesIntegrations.dataMessageIntegration.aNewPassword
					});
					setTimeout(function () {
						_this3.changePassword();
					}, 2000);
				}
			}
		}, {
			key: 'hasNumbers',
			value: function hasNumbers(str) {
				return (/\d/.test(str)
				);
			}
		}, {
			key: 'hasLowerCase',
			value: function hasLowerCase(str) {
				return str.toUpperCase() !== str;
			}
		}, {
			key: 'hasUpperCase',
			value: function hasUpperCase(str) {
				return str.toLowerCase() !== str;
			}
		}, {
			key: 'hasSpecialCharacter',
			value: function hasSpecialCharacter(str) {
				return (/\d/.test(str)
				);
			}
		}, {
			key: 'notEqualPassword',
			value: function notEqualPassword() {
				if (!this.state.newPassword || !this.state.password) {
					this.hasError = true;
					return '';
				}
				if (this.state.newPassword === this.state.password) {
					this.hasError = true;
					return 'error';
				}
				return 'right';
			}
		}, {
			key: 'more8Characters',
			value: function more8Characters() {
				if (!this.state.newPassword) {
					this.hasError = true;
					return '';
				}
				if (this.state.newPassword.length <= 7) {
					this.hasError = true;
					return 'error';
				}
				return 'right';
			}
		}, {
			key: 'upperLowerNumber',
			value: function upperLowerNumber() {
				if (!this.state.newPassword) {
					this.hasError = true;
					return '';
				}
				var pass = this.state.newPassword;
				if (!this.hasUpperCase(pass)) {
					this.hasError = true;
					return 'error';
				}
				if (!this.hasLowerCase(pass)) {
					this.hasError = true;
					return 'error';
				}
				if (!this.hasNumbers(pass)) {
					this.hasError = true;
					return 'error';
				}
				if (!this.hasSpecialCharacter(pass)) {
					this.hasError = true;
					return 'error';
				}
				return 'right';
			}
		}, {
			key: 'newPassEqualsConfirmation',
			value: function newPassEqualsConfirmation() {
				if (!this.state.confirmPassword) {
					this.hasError = true;
					return '';
				}
				if (this.state.newPassword !== this.state.confirmPassword) {
					this.hasError = true;
					return 'error';
				}
				return 'right';
			}
		}, {
			key: 'passAlredyExist',
			value: function passAlredyExist(messageError) {
				this.props.showAlertModal({
					type: 'ModalAlert',
					title: this.language.getText('GUIPassAlreadyExistpssw-error-title'),
					message: messageError === 9999 ? this.language.getText('GUIPswModalAlertpswErrorBody') : this.language.getText('GUIPassAlreadyExistpssw-error-mssg'),
					button: this.language.getText('GUIPassAlreadyExistpssw-error-close'),
					secondButtonFtn: function secondButtonFtn() {},
					buttonFun: function buttonFun() {}
				});
			}
		}, {
			key: 'closeWindow',
			value: function closeWindow() {
				this.props.onClose();
				this.setState({ onExit: true });
			}
		}, {
			key: 'UNSAFE_componentWillUpdate',
			value: function UNSAFE_componentWillUpdate() {
				this.hasError = false;
			}
		}, {
			key: 'render',
			value: function render() {
				var _this4 = this;
	
				return _react2.default.createElement(
					'div',
					{ className: 'configBar ' + (this.state.onExit && 'onExit') },
					_customComponents.CUSTOM_COMPONENTS['configBarHeader'](_Images.changePassIcon, this.language.getText('GUIPasswordChangetitle'), function () {
						return _this4.closeWindow();
					}, this.state.passwordChanged),
					this.state.passwordChanged ? _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'p',
							{ className: 'txtPassChanged' },
							this.language.getText('GUIPasswordChangesuccessChange')
						),
						_react2.default.createElement('img', { className: 'imgPassChanged', src: _Images.successChange, alt: 'icon' })
					) : _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'p',
							{ className: 'changePassText' },
							this.language.getText('GUIPasswordChangecurrentPassword')
						),
						_react2.default.createElement(_PasswordTextArea2.default, { value: this.state.password, onChange: function onChange(text) {
								return _this4.setState({ password: text });
							} }),
						this.state.errorService && _react2.default.createElement(
							'p',
							{ className: 'txtErrorFloat' },
							this.language.getText('GUIPasswordChangeincorrectPassword')
						),
						_react2.default.createElement(
							'p',
							{ className: 'changePassText' },
							this.language.getText('GUIPasswordChangenewPassword')
						),
						_react2.default.createElement(_PasswordTextArea2.default, { value: this.state.newPassword, onChange: function onChange(text) {
								return _this4.setState({ newPassword: text });
							} }),
						_react2.default.createElement(
							'p',
							{ className: 'passwordError ' + this.notEqualPassword() },
							'\u25CF ',
							this.language.getText('error-5003'),
							' '
						),
						' ',
						_react2.default.createElement(
							'p',
							{ className: 'passwordError ' + this.more8Characters() },
							'\u25CF ',
							this.language.getText('error-5002'),
							' '
						),
						_react2.default.createElement(
							'p',
							{ className: 'passwordError marginBottom10 ' + this.upperLowerNumber() },
							'\u25CF ',
							this.language.getText('error-5006'),
							' '
						),
						_react2.default.createElement(
							'p',
							{ className: 'changePassText' },
							this.language.getText('GUIPasswordChangeconfirmPassword')
						),
						_react2.default.createElement(_PasswordTextArea2.default, { value: this.state.confirmPassword, onChange: function onChange(text) {
								return _this4.setState({ confirmPassword: text });
							} }),
						_react2.default.createElement(
							'p',
							{ className: 'passwordError ' + this.newPassEqualsConfirmation() },
							'\u25CF ',
							this.language.getText('error-5001'),
							' '
						),
						_react2.default.createElement(
							'div',
							{ className: 'buttonChangePassword ' + (this.hasError && 'inactive'), onClick: this.changePassword },
							this.language.getText('GUIPasswordChangetitle')
						)
					)
				);
			}
		}]);
	
		return ConfigBar;
	}(_react.Component);
	
	function mapStateToProps(state) {
		return {
			messagesIntegrations: state.messagesIntegrations
		};
	}
	
	function mapDispatchToProps(dispatch) {
		var _showAlertModal = _A_Alert_Modal2.default.creators.showAlertModal;
	
		return {
			onShowAlertModal: function onShowAlertModal(payload) {
				return dispatch((0, _A_Admin_Alert_Modal.showAdminModal)(payload));
			},
			consultingApp: function consultingApp() {
				dispatch((0, _A_reducer_consulting.consultingApp)());
			},
			noConsultingApp: function noConsultingApp() {
				dispatch((0, _A_reducer_consulting.noConsultingApp)());
			},
			showAlertModal: function showAlertModal(payload) {
				dispatch(_showAlertModal(payload));
			}
		};
	}
	exports.default = ConfigBar = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ConfigBar);

/***/ },
/* 1076 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(25);
	
	var _A_user_actions = __webpack_require__(194);
	
	var _helperLanguage = __webpack_require__(510);
	
	var _Singleton = __webpack_require__(21);
	
	var _Images = __webpack_require__(30);
	
	var _singletonSharedData = __webpack_require__(23);
	
	var _customComponents = __webpack_require__(59);
	
	var _ToggleButton = __webpack_require__(1104);
	
	var _ToggleButton2 = _interopRequireDefault(_ToggleButton);
	
	var _cookies = __webpack_require__(328);
	
	var _constants = __webpack_require__(10);
	
	var _cwGalateaApiJsBundle = __webpack_require__(40);
	
	var _A_Alert_Modal = __webpack_require__(63);
	
	var _A_Alert_Modal2 = _interopRequireDefault(_A_Alert_Modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ConfigBar = function (_Component) {
	  _inherits(ConfigBar, _Component);
	
	  function ConfigBar(props) {
	    _classCallCheck(this, ConfigBar);
	
	    var _this2 = _possibleConstructorReturn(this, (ConfigBar.__proto__ || Object.getPrototypeOf(ConfigBar)).call(this, props));
	
	    _this2.changeSwitchOn = function () {
	      _this2.changeSwitch(true);
	    };
	
	    _this2.changeSwitchOff = function () {
	      _this2.changeSwitch(false);
	    };
	
	    var langArray = [{ idLanguage: '0', textLanguage: new _Singleton.Singleton().getText("GUIConfigurationLanguagespanish"), selected: new _Singleton.Singleton().getLanguage() === "0" }, { idLanguage: '1', textLanguage: new _Singleton.Singleton().getText("GUIConfigurationLanguageenglish"), selected: new _Singleton.Singleton().getLanguage() === "1" }, { idLanguage: '2', textLanguage: new _Singleton.Singleton().getText("GUIConfigurationLanguageportuguese"), selected: new _Singleton.Singleton().getLanguage() === "2" }];
	    _this2.state = {
	      onExit: false,
	      timeVisible: true,
	      languageArray: langArray
	    };
	    _this2.language = new _Singleton.Singleton();
	    _this2.sharedData = new _singletonSharedData.SingletonSharedData();
	    var APIFact = new _cwGalateaApiJsBundle.APIFactory();
	    _this2.apiCont = APIFact.buildClient();
	    return _this2;
	  }
	
	  _createClass(ConfigBar, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {
	      var array = this.state.languageArray;
	      for (var i in array) {
	        array[i].selected = array[i].selected;
	        var languageTags = array[i].idLanguage === '0' ? "spanish" : array[i].idLanguage === '1' ? "english" : "portuguese";
	        array[i].textLanguage = new _Singleton.Singleton().getText("GUIConfigurationLanguage" + languageTags);
	      }
	      this.setState({ languageArray: array });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (this.props.userActions !== prevProps.userActions) {
	        this.props.showAlertModal({
	          type: "",
	          title: this.language.getText("CallControlGUIStartStopRecordingwindowsTitle"),
	          message: this.language.getText("alert-1000"),
	          button: this.language.getText("CallControlGUIAssistedCallTransferaccept")
	        });
	        this.closeWindow();
	      }
	    }
	  }, {
	    key: 'changeSwitch',
	    value: function changeSwitch(visible) {
	      this.setState({ timeVisible: visible });
	      (0, _cookies.setCookie)(_constants.TIME_ALWAYS_VISIBLE, visible ? "0" : "1");
	      this.props.onChangeVisibility(!visible);
	    }
	  }, {
	    key: 'selectLanguage',
	    value: function selectLanguage(idLanguage) {
	      var array = this.state.languageArray;
	      for (var i in array) {
	        array[i].selected = array[i].idLanguage === idLanguage;
	      }
	      this.setState({ languageArray: array });
	
	      var _this = this;
	      var languageObject = function languageObject() {
	        return _this.props.change_language(_this.language.getLanguage());
	      };
	      var langHelper = new _helperLanguage.helperLanguage();
	      langHelper.setLanguage(idLanguage, languageObject);
	    }
	  }, {
	    key: 'closeWindow',
	    value: function closeWindow() {
	      this.props.onClose();
	      this.setState({ onExit: true });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: "configBar " + (this.state.onExit && "onExit") },
	        _customComponents.CUSTOM_COMPONENTS["configBarHeader"](_Images.iconConfig, this.language.getText("GUIConfigurationtitle"), function () {
	          return _this3.closeWindow();
	        }),
	        _react2.default.createElement(
	          'p',
	          { className: 'textChangeLanguage' },
	          this.language.getText("GUIConfigurationLanguagetitle")
	        ),
	        this.state.languageArray.map(function (item) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'containerSettingBar margin10', key: item.idLanguage },
	            _react2.default.createElement('img', { className: item.selected ? "itemSelected" : "itemNoSelected", src: _Images.tick, alt: "icon", onClick: function onClick() {
	                return _this3.selectLanguage(item.idLanguage);
	              } }),
	            _react2.default.createElement(
	              'p',
	              { className: 'txtSelectionOption widht60' },
	              item.textLanguage
	            )
	          );
	        }),
	        _react2.default.createElement('div', { className: 'separatorBarSettings' }),
	        _react2.default.createElement(
	          'p',
	          { className: 'textChangeLanguage' },
	          this.language.getText("GUIConfigurationQueueCalltitle")
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'containerSettingBar' },
	          _react2.default.createElement(
	            'p',
	            { className: 'txtSelectionOption' },
	            this.language.getText("GUIConfigurationQueueCallalwaysVisible")
	          ),
	          _react2.default.createElement(_ToggleButton2.default, { onOn: this.changeSwitchOn, onOff: this.changeSwitchOff, on: (0, _cookies.getCookie)(_constants.TIME_ALWAYS_VISIBLE) === "0"
	          })
	        )
	      );
	    }
	  }]);
	
	  return ConfigBar;
	}(_react.Component);
	
	function mapDispatchToProps(dispatch) {
	  var _showAlertModal = _A_Alert_Modal2.default.creators.showAlertModal;
	
	
	  return {
	    change_language: function change_language(c_language) {
	      dispatch((0, _A_user_actions.change_language)(c_language));
	    },
	    showAlertModal: function showAlertModal(payload) {
	      dispatch(_showAlertModal(payload));
	    }
	  };
	}
	
	function mapStateToProps(state) {
	  return {
	    userActions: state.userActions
	  };
	}
	
	exports.default = ConfigBar = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ConfigBar);

/***/ },
/* 1077 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(25);
	
	var _Singleton = __webpack_require__(21);
	
	var _Images = __webpack_require__(30);
	
	var _HeaderSVG = __webpack_require__(490);
	
	var _singletonSharedData = __webpack_require__(23);
	
	var _constants = __webpack_require__(10);
	
	var _formats = __webpack_require__(54);
	
	var _SettingsBar = __webpack_require__(1078);
	
	var _SettingsBar2 = _interopRequireDefault(_SettingsBar);
	
	var _cookies = __webpack_require__(328);
	
	var _Logger = __webpack_require__(37);
	
	var _reactBootstrap = __webpack_require__(73);
	
	var _StopWatch = __webpack_require__(495);
	
	var _StopWatch2 = _interopRequireDefault(_StopWatch);
	
	var _reducer_psw_reset = __webpack_require__(336);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Header = function (_Component) {
	  _inherits(Header, _Component);
	
	  function Header(props) {
	    _classCallCheck(this, Header);
	
	    var _this = _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).call(this, props));
	
	    _this.showHideSettingsBar = function () {
	      _this.props.setShowPswResetAlert(false);
	      if (_this.state.settingsBarShowed) {
	        _this.setState({ hideSettings: true, showConfigPsw: false });
	        clearTimeout(_this.stHideSettings);
	        _this.stHideSettings = setTimeout(function () {
	          _this.setState({ settingsBarShowed: !_this.state.settingsBarShowed });
	        }, 500);
	      } else {
	        _this.setState({ settingsBarShowed: !_this.state.settingsBarShowed });
	        _this.setState({ hideSettings: false });
	      }
	    };
	
	    _this.onChangeSesionTime = function (timeCounter) {
	      _this.setState({ timeCounter: timeCounter });
	    };
	
	    _this.sharedData = new _singletonSharedData.SingletonSharedData();
	    var arrayNotifications = {};
	    if (_this.sharedData.getGeneralPermissions()[192] === "1") {
	      arrayNotifications[_constants.QUEUE_COUNT.CALLS] = {
	        img: _HeaderSVG.llamadasHeader,
	        number: 0,
	        timeInQueue: 0,
	        showHours: false,
	        animationType: "textNotificacion"
	      };
	    }
	    if (_this.sharedData.hasUnifiedMessage) {
	      arrayNotifications[_constants.QUEUE_COUNT.MESSAGES] = {
	        img: _HeaderSVG.mensajesHeader,
	        number: 0,
	        timeInQueue: 0,
	        showHours: false,
	        animationType: "textNotificacion"
	      };
	      arrayNotifications[_constants.QUEUE_COUNT.FACEBOOK] = {
	        img: _HeaderSVG.facebookHeader,
	        number: 0,
	        timeInQueue: 0,
	        showHours: false,
	        animationType: "textNotificacion"
	      };
	      arrayNotifications[_constants.QUEUE_COUNT.LINKEDIN] = {
	        img: _HeaderSVG.linkedinHeader,
	        number: 0,
	        timeInQueue: 0,
	        showHours: false,
	        animationType: "textNotificacion"
	      };
	      arrayNotifications[_constants.QUEUE_COUNT.TWITTER] = {
	        img: _HeaderSVG.twitterHeader,
	        number: 0,
	        timeInQueue: 0,
	        showHours: true,
	        animationType: "textNotificacion"
	      };
	      arrayNotifications[_constants.QUEUE_COUNT.MAIL] = {
	        img: _HeaderSVG.mailHeader,
	        number: 0,
	        timeInQueue: 0,
	        showHours: true,
	        animationType: "textNotificacion"
	      };
	    }
	    _this.iconAgentArray = { 1: _Images.agentOutbound, 2: _Images.agentInbound, 3: _Images.agentBoth };
	
	    var cookie = (0, _cookies.getCookie)(_constants.TIME_ALWAYS_VISIBLE);
	    _Logger.Logger.Trace("COOKIE ==>> " + cookie);
	    var tempTime = _this.sharedData.getParameters().Sessiontime;
	
	    _this.state = {
	      timeCounter: "00:00:00",
	      callType: 1,
	      notifications: arrayNotifications,
	      userName: _this.sharedData.getUserData().Login,
	      macAddres: _this.sharedData.getParameters().ClientComp,
	      totalClass: "textNotificacion",
	      settingsBarShowed: false,
	      timeHidden: cookie === "" ? true : parseInt(cookie, 10),
	      hideSettings: false,
	      hours: Math.floor(tempTime / 3600),
	      minutes: Math.floor(tempTime % 3600 / 60),
	      seconds: tempTime % 60,
	      showConfigPsw: false
	    };
	    _this.language = new _Singleton.Singleton();
	    _this.totalNotifications = 0;
	    _this.secs = 0;
	    _this.intervalCallQueue = null;
	    _this.st = null;
	    _this.stHideSettings = null;
	    return _this;
	  }
	
	  _createClass(Header, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (this.props.whiteLabelEnabled && this.props.customLogoFormat === "svg") {
	        var container = document.getElementById("custom-logo-header");
	        container.innerHTML = this.props.customLogo;
	      }
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.callType === 1 || this.props.callType === 2 || this.props.callType === 3) {
	        this.setState({
	          callType: nextProps.callType
	        });
	      }
	      if (this.props.queueCount !== nextProps.queueCount || this.props.timeInQueue !== nextProps.timeInQueue) {
	        if (nextProps.idChangeCount !== -1) {
	          //TRAE NUEVO AVISO DE MENSAJES
	          var arrayNotifications = this.state.notifications;
	          if (arrayNotifications[nextProps.idChangeCount]) {
	            if (arrayNotifications[nextProps.idChangeCount].number === 0 && nextProps.queueCount !== 0) {
	              arrayNotifications[nextProps.idChangeCount].animationType = "textNotificacion appearNotification";
	            }
	            if (arrayNotifications[nextProps.idChangeCount].number > 0 && nextProps.queueCount === 0) {
	              arrayNotifications[nextProps.idChangeCount].animationType = "textNotificacion hiddeNotification";
	            }
	            if (arrayNotifications[nextProps.idChangeCount].number !== 0 && nextProps.queueCount !== 0) {
	              arrayNotifications[nextProps.idChangeCount].animationType = "textNotificacion newNotification";
	            }
	            arrayNotifications[nextProps.idChangeCount].number = nextProps.queueCount;
	            arrayNotifications[nextProps.idChangeCount].timeInQueue = nextProps.timeInQueue;
	            this.manageTimerCallQueue(nextProps.idChangeCount, nextProps.timeInQueue);
	            this.setState({
	              notifications: arrayNotifications,
	              totalClass: "textNotificacion newNotification"
	            });
	          }
	        }
	      }
	      if (nextProps.messagesIntegrations !== this.props.messagesIntegrations) {
	        if (nextProps.messagesIntegrations.dataMessageIntegration && nextProps.messagesIntegrations.dataMessageIntegration.action === _constants.INTEGRATION.SETTINGS) {
	          this.messagesIntegrations = nextProps.messagesIntegrations.dataMessageIntegration;
	          this.changeStateBarShow();
	        }
	      }
	    }
	  }, {
	    key: "manageTimerCallQueue",
	    value: function manageTimerCallQueue(idQueue, timeInQueue) {
	      var arrayNotifications = this.state.notifications;
	      if (this.intervalCallQueue !== null && arrayNotifications[idQueue].number <= 0) {
	        clearInterval(this.intervalCallQueue);
	        this.intervalCallQueue = null;
	      }
	      if (arrayNotifications[idQueue].number > 0 && this.intervalCallQueue == null) {
	        this.intervalCallQueue = setInterval(function () {
	          return (0, _formats.secondsToFormat)(++arrayNotifications[idQueue].timeInQueue, true);
	        }, 1000);
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      if (this.props.idChangeCount !== -1 && this.state.totalClass !== "textNotificacion") {
	        var indexNotification = this.props.idChangeCount;
	        clearTimeout(this.st);
	        this.st = setTimeout(function () {
	          var arrayNotifications = this.state.notifications;
	          if (arrayNotifications[indexNotification] && arrayNotifications[indexNotification].animationType !== "textNotificacion") {
	            arrayNotifications[indexNotification].animationType = "textNotificacion";
	            this.setState({ totalClass: "textNotificacion", notifications: arrayNotifications });
	          }
	        }.bind(this), 500);
	      }
	      this.openResetPsw();
	    }
	  }, {
	    key: "openResetPsw",
	    value: function openResetPsw() {
	      if (this.props.openConfig && !this.state.settingsBarShowed && !this.state.hideSettings) {
	        this.showHideSettingsBar();
	        this.setState({ showConfigPsw: true });
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.intervalCallQueue !== null) {
	        clearInterval(this.intervalCallQueue);
	      }
	      clearTimeout(this.st);
	      clearTimeout(this.stHideSettings);
	    }
	  }, {
	    key: "renderNotifications",
	    value: function renderNotifications(typeNotification) {
	      var notificationsRender = [];
	      this.totalNotifications = 0;
	      for (var i in this.state.notifications) {
	        var item = this.state.notifications[i];
	        this.totalNotifications += item.number;
	        notificationsRender.push(_react2.default.createElement(
	          _reactBootstrap.OverlayTrigger,
	          {
	            key: "tlt-notificationContainer-queue-" + i,
	            placement: "bottom",
	            overlay: _react2.default.createElement(
	              _reactBootstrap.Tooltip,
	              { className: "notificationContainer-tooltip bottom show", key: "notificationContainer-tooltip-header-" + i, id: "notificationContainer-tooltip-headerId-" + i },
	              this.language.getText("GUIHeaderCallQueue")
	            )
	          },
	          _react2.default.createElement(
	            "div",
	            { className: "notificationContainer " + typeNotification + " " + (this.state.timeHidden && " hiddenTime"), key: "item" + i },
	            _react2.default.createElement(
	              "p",
	              { className: item.animationType },
	              item.number
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "imageNotification" + (item.number > 0 ? " imageActive " : " imageInactive ") },
	              item.img
	            ),
	            _react2.default.createElement(
	              "p",
	              { className: "timeInQueue " + typeNotification + (this.state.timeHidden && " hiddenTime") },
	              (0, _formats.secondsToFormat)(item.timeInQueue, item.showHours)
	            )
	          )
	        ));
	      }
	      return notificationsRender;
	    }
	  }, {
	    key: "changeStateBarShow",
	    value: function changeStateBarShow() {
	      this.setState({ settingsBarShowed: !this.state.settingsBarShowed });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "header " + (this.state.settingsBarShowed ? "menuAgent" : "") },
	        _react2.default.createElement(
	          "div",
	          { className: "headerUserBox", onClick: this.showHideSettingsBar },
	          _react2.default.createElement("img", { alt: "icon", className: "imageHeader", src: this.iconAgentArray[this.state.callType] }),
	          _react2.default.createElement(
	            "div",
	            { className: "infoUserContainer" },
	            _react2.default.createElement(
	              _reactBootstrap.OverlayTrigger,
	              {
	                key: "tlt-userName1",
	                placement: "bottom",
	                overlay: _react2.default.createElement(
	                  _reactBootstrap.Tooltip,
	                  { className: "notificationContainer-tooltip bottom show name", id: "tooltipId-tlt-userName1" },
	                  this.state.userName
	                )
	              },
	              _react2.default.createElement(
	                "p",
	                { className: "nameUser" },
	                this.state.userName
	              )
	            ),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "p",
	              { className: "sessionTime" },
	              _react2.default.createElement(_StopWatch2.default, { onChange: this.onChangeSesionTime, hours: this.state.hours, minutes: this.state.minutes, secondsInitial: this.state.seconds, isAscending: true })
	            ),
	            _react2.default.createElement("img", { alt: "icon", className: "imageClock", src: _Images.clockHeader })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "notificationContainer normal generalCounter" },
	          this.sharedData.hasUnifiedMessage && _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "p",
	              { className: this.state.totalClass },
	              this.totalNotifications
	            ),
	            _react2.default.createElement("img", { alt: "icon", className: "imageNotification", src: _Images.queueMessages })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "smallNotificationHeader" },
	            this.renderNotifications("small")
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            className: "notificationHeader " + (this.sharedData.hasUnifiedMessage ? "hiddenHeaderIcons" : "")
	          },
	          this.renderNotifications("normal")
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "imagenLogo" },
	          this.props.whiteLabelEnabled ? _react2.default.createElement(
	            "div",
	            { id: "custom-logo-header" },
	            this.props.customLogoFormat === "image" && _react2.default.createElement("img", {
	              id: "custom-header-img",
	              alt: "",
	              src: this.props.customLogo
	            })
	          ) : _react2.default.createElement(
	            _react2.default.Fragment,
	            null,
	            _react2.default.createElement("img", { alt: "icon", className: "logoIcon", src: _Images.logoHeader }),
	            _react2.default.createElement("img", { alt: "icon", className: "logoText", src: _Images.logoHeaderTxt })
	          )
	        ),
	        this.state.settingsBarShowed && _react2.default.createElement(_SettingsBar2.default, {
	          callType: this.state.callType,
	          userName: this.state.userName,
	          macAddres: this.state.macAddres,
	          timeSession: this.state.timeCounter,
	          onChangeVisibility: function onChangeVisibility(visible) {
	            return _this2.setState({ timeHidden: visible });
	          },
	          onClick: this.showHideSettingsBar,
	          messagesIntegrations: this.messagesIntegrations,
	          hideSettings: this.state.hideSettings,
	          showConfigPsw: this.state.showConfigPsw
	        })
	      );
	    }
	  }]);
	
	  return Header;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    messagesIntegrations: state.messagesIntegrations,
	    whiteLabelEnabled: state.whiteLabelState.whiteLabelEnabled,
	    customLogo: state.whiteLabelState.header,
	    customLogoFormat: state.whiteLabelState.imageFormat,
	    queueCount: state.queueCount.count,
	    timeInQueue: state.queueCount.time,
	    idChangeCount: state.queueCount.countType,
	    openConfig: state.setFlagShowAlert.showAlert
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return {
	    setShowPswResetAlert: function setShowPswResetAlert(flag) {
	      dispatch((0, _reducer_psw_reset.setShowPswResetAlert)(flag));
	    }
	  };
	}
	exports.default = Header = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Header);

/***/ },
/* 1078 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(25);
	
	var _A_user_actions = __webpack_require__(194);
	
	var _Singleton = __webpack_require__(21);
	
	var _Images = __webpack_require__(30);
	
	var _SettingsSGV = __webpack_require__(491);
	
	var _GenericSVG = __webpack_require__(51);
	
	var _singletonSharedData = __webpack_require__(23);
	
	var _constants = __webpack_require__(10);
	
	var _ConfigBar = __webpack_require__(1076);
	
	var _ConfigBar2 = _interopRequireDefault(_ConfigBar);
	
	var _CampaignType = __webpack_require__(1074);
	
	var _CampaignType2 = _interopRequireDefault(_CampaignType);
	
	var _ChangePassBar = __webpack_require__(1075);
	
	var _ChangePassBar2 = _interopRequireDefault(_ChangePassBar);
	
	var _A_Alert_Modal = __webpack_require__(63);
	
	var _A_Alert_Modal2 = _interopRequireDefault(_A_Alert_Modal);
	
	var _reactBootstrap = __webpack_require__(73);
	
	var _A_messages_to_SM = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SettingsBar = function (_Component) {
	  _inherits(SettingsBar, _Component);
	
	  function SettingsBar(props) {
	    _classCallCheck(this, SettingsBar);
	
	    var _this2 = _possibleConstructorReturn(this, (SettingsBar.__proto__ || Object.getPrototypeOf(SettingsBar)).call(this, props));
	
	    _this2.closingWindow = function () {
	      _this2.setState({ stateBar: 2 });
	      var _this = _this2;
	      setTimeout(function () {
	        _this.setState({ configBarShowed: false, changePassBarShowed: false, showConfigCampaignType: false });
	      }, 500);
	    };
	
	    _this2.closeWindow = function () {
	      _this2.props.showAlertModal({
	        type: "ModalAlert",
	        title: "CenterWare Kolob",
	        message: _this2.language.getText("alert-1601"),
	        button: _this2.language.getText("CallControlcallCalificationyes"),
	        secondButton: _this2.language.getText("CallControlcallCalificationno"),
	        secondButtonFtn: function secondButtonFtn() {},
	        buttonFun: function buttonFun() {
	          _this2.props.logout();
	        }
	      });
	    };
	
	    _this2.showOptionCampaignType = function () {
	      _this2.setState({ showConfigCampaignType: true });
	    };
	
	    _this2.onClickShowSettingBar = function () {
	      _this2.setState({ configBarShowed: true, stateBar: 1 });
	    };
	
	    _this2.onClickShowChangePassBar = function () {
	      _this2.setState({ changePassBarShowed: true, stateBar: 1 });
	    };
	
	    _this2.onClickSendChangesCampType = function (data) {
	      _this2.props.sendChangeDialingMode(data);
	    };
	
	    _this2.sharedData = new _singletonSharedData.SingletonSharedData();
	    _this2.language = new _Singleton.Singleton();
	    _this2.iconAgentArray = { 1: _Images.agentOutboundInfo, 2: _Images.agentInboundInfo, 3: _Images.agentBothInfo };
	    _this2.state = {
	      configBarShowed: false,
	      changePassBarShowed: _this2.props.showConfigPsw ? true : false,
	      stateBar: 0,
	      showConfigCampaignType: false,
	      allowChangeDialingMode: _this2.sharedData.getDataPreviewPro().allowChangeDialMode,
	      dialingMode: _this2.sharedData.getDataPreviewPro().dialingMode,
	      firstSessionTime: _this2.sharedData.getParameters().Hourlogin.substring(11, 19)
	    };
	    return _this2;
	  }
	
	  _createClass(SettingsBar, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.messagesIntegrations.dataMessageIntegration && this.props.messagesIntegrations.dataMessageIntegration.subaction === _constants.INTEGRATION.CHANGE_PASSWORD) {
	        this.setState({ changePassBarShowed: true, stateBar: 1 });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var inactiveMode = this.sharedData.getIsInactiveState();
	      return _react2.default.createElement(
	        'div',
	        { className: 'backgroundHeaderBars' },
	        _react2.default.createElement(
	          'div',
	          { className: "barsContainer" + (this.props.hideSettings ? " hide" : "") },
	          _react2.default.createElement(
	            'div',
	            { className: "settingsBar " + (this.state.stateBar === 1 ? "moved" : this.state.stateBar === 2 ? "normal" : "") },
	            _react2.default.createElement('img', { className: 'imageHeaderSelection', src: this.iconAgentArray[this.props.callType], alt: "icon" }),
	            _react2.default.createElement(
	              _reactBootstrap.OverlayTrigger,
	              {
	                key: 'tlt-userName2',
	                placement: 'bottom',
	                overlay: _react2.default.createElement(
	                  _reactBootstrap.Tooltip,
	                  { className: 'notificationContainer-tooltip bottom show name2', id: 'tooltipId-tlt-userName2' },
	                  this.props.userName
	                )
	              },
	              _react2.default.createElement(
	                'p',
	                { className: 'userNameSettings' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  this.props.userName
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'containerSettingBar' },
	              _react2.default.createElement('img', { className: 'imgMacSetting', src: _Images.macHeader, alt: "icon" }),
	              _react2.default.createElement(
	                'p',
	                { className: 'txtMacSetting' },
	                this.props.macAddres
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'containerfirstLoginTime' },
	              _react2.default.createElement(
	                'p',
	                { className: 'firstLoginTime' },
	                ' ',
	                this.language.getText("GUIConfigurationfirstLoginTime")
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'containerSettingBarfirstLoginTime' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'imgTimeSettingFirst' },
	                  _GenericSVG.clockIcon
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { className: 'sessionTimeSettingBarFirstTime' },
	                  this.state.firstSessionTime
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'timeSettingBar' },
	              this.language.getText("GUIConfigurationtagTimeOnline")
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'containerSettingBar' },
	              _react2.default.createElement(
	                'div',
	                { className: 'imgTimeSetting' },
	                _GenericSVG.clockIcon
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'sessionTimeSettingBar' },
	                this.props.timeSession
	              )
	            ),
	            _react2.default.createElement('div', { className: 'separatorBarSettings' }),
	            !inactiveMode && _react2.default.createElement(
	              'div',
	              { className: 'selectionSettingBar', onClick: this.onClickShowSettingBar },
	              _react2.default.createElement('img', { className: 'imgSelectionOption', src: _Images.iconConfig, alt: "icon" }),
	              _react2.default.createElement(
	                'p',
	                { className: 'txtSelectionOption' },
	                this.language.getText("GUIConfigurationtitle")
	              )
	            ),
	            !inactiveMode && _react2.default.createElement(
	              'div',
	              { className: 'selectionSettingBar', onClick: this.onClickShowChangePassBar },
	              _react2.default.createElement('img', { className: 'imgSelectionOption', src: _Images.changePassIcon, alt: "icon" }),
	              _react2.default.createElement(
	                'p',
	                { className: 'txtSelectionOption' },
	                this.language.getText("GUIPasswordChangetitle")
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'selectionSettingBar exit', onClick: this.closeWindow },
	              _react2.default.createElement(
	                'div',
	                { className: 'imgSelectionOption' },
	                _SettingsSGV.exitSVG
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'txtSelectionOption' },
	                this.language.getText("GUIConfigurationsignOff")
	              )
	            ),
	            this.state.allowChangeDialingMode && !inactiveMode && _react2.default.createElement(
	              'div',
	              { className: 'selectionSettingBar', onClick: this.showOptionCampaignType },
	              _react2.default.createElement('img', { className: 'imgSelectionOption gcl-icon camps' }),
	              _react2.default.createElement(
	                'p',
	                { className: 'txtSelectionOption' },
	                this.language.getText("GUIPreviewcampaignType")
	              )
	            )
	          ),
	          this.state.configBarShowed && _react2.default.createElement(_ConfigBar2.default, { onClose: this.closingWindow, onChangeVisibility: function onChangeVisibility(visible) {
	              return _this3.props.onChangeVisibility(visible);
	            } }),
	          this.state.changePassBarShowed && _react2.default.createElement(_ChangePassBar2.default, { onClose: this.closingWindow, messagesIntegrations: this.props.messagesIntegrations, onCloseSettingBar: this.props.onClick }),
	          this.state.showConfigCampaignType && _react2.default.createElement(_CampaignType2.default, {
	            onClose: this.closingWindow,
	            onClickSendChangesCampType: this.onClickSendChangesCampType
	          })
	        ),
	        _react2.default.createElement('div', { className: 'backgroundHeaderBarsTransparent ' + (this.props.hideSettings ? "hideSettings" : ""), onClick: function onClick() {
	            return _this3.props.onClick();
	          } })
	      );
	    }
	  }]);
	
	  return SettingsBar;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    messagesIntegrations: state.messagesIntegrations,
	    openConfig: state.setFlagShowAlert.showAlert
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  var _showAlertModal = _A_Alert_Modal2.default.creators.showAlertModal;
	
	  return {
	    logout: function logout() {
	      dispatch((0, _A_user_actions.logout)());
	    },
	    sendChangeDialingMode: function sendChangeDialingMode(data) {
	      dispatch((0, _A_messages_to_SM.sendChangeDialingMode)(data));
	    },
	    showAlertModal: function showAlertModal(payload) {
	      dispatch(_showAlertModal(payload));
	    }
	
	  };
	}
	exports.default = SettingsBar = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SettingsBar);

/***/ },
/* 1079 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _globalComponentsLibrary = __webpack_require__(28);
	
	var _react = __webpack_require__(1);
	
	var StopWatchCountDown = function StopWatchCountDown(_ref) {
	  var _ref$hours = _ref.hours,
	      hours = _ref$hours === undefined ? 0 : _ref$hours,
	      _ref$minutes = _ref.minutes,
	      minutes = _ref$minutes === undefined ? 0 : _ref$minutes,
	      _ref$secondsInitial = _ref.secondsInitial,
	      secondsInitial = _ref$secondsInitial === undefined ? 0 : _ref$secondsInitial,
	      onChange = _ref.onChange;
	
	  var _useStopWatchCountDow = (0, _globalComponentsLibrary.useStopWatchCountDown)(hours, minutes, secondsInitial),
	      start = _useStopWatchCountDow.start,
	      stop = _useStopWatchCountDow.stop,
	      fullFormat = _useStopWatchCountDow.fullFormat,
	      seconds = _useStopWatchCountDow.seconds;
	
	  var _useState = (0, _react.useState)("00:00:00"),
	      _useState2 = _slicedToArray(_useState, 2),
	      complete = _useState2[0],
	      setComplete = _useState2[1];
	
	  (0, _react.useEffect)(function () {
	    start();
	    return function () {
	      stop();
	    };
	  }, []);
	
	  (0, _react.useEffect)(function () {
	    var result = fullFormat();
	    onChange(result);
	    setComplete(result);
	  }, [seconds]);
	
	  return complete;
	};
	
	exports.default = StopWatchCountDown;

/***/ },
/* 1080 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _globalComponentsLibrary = __webpack_require__(28);
	
	var _reactRedux = __webpack_require__(25);
	
	var _react = __webpack_require__(1);
	
	var _A_preview = __webpack_require__(52);
	
	var _constants = __webpack_require__(10);
	
	var StopWatchPreview = function StopWatchPreview(_ref) {
	  var hours = _ref.hours,
	      minutes = _ref.minutes,
	      secondsInitial = _ref.secondsInitial,
	      isRunning = _ref.isRunning,
	      onTimeOver = _ref.onTimeOver,
	      isTimeAscending = _ref.isTimeAscending,
	      _ref$userState = _ref.userState,
	      userState = _ref$userState === undefined ? _constants.USER_STATE.READY_PREVIEW : _ref$userState;
	
	  var _useStopWatchCountDow = (0, _globalComponentsLibrary.useStopWatchCountDown)(hours, minutes, secondsInitial, 1000, isTimeAscending),
	      start = _useStopWatchCountDow.start,
	      stop = _useStopWatchCountDow.stop,
	      fullFormat = _useStopWatchCountDow.fullFormat,
	      seconds = _useStopWatchCountDow.seconds;
	
	  var _useState = (0, _react.useState)("00:00:00"),
	      _useState2 = _slicedToArray(_useState, 2),
	      complete = _useState2[0],
	      setComplete = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      timeOver = _useState4[0],
	      setTimeOver = _useState4[1];
	
	  var isRunningClock = (0, _reactRedux.useSelector)(function (state) {
	    return state.preview.isRunningClock;
	  });
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var stringToSec = function stringToSec(result) {
	    var string = result.split(":");
	    var intMin = parseInt(string[1]);
	    var intSec = parseInt(string[2]);
	    var newTime = intMin * 60 + intSec;
	    dispatch((0, _A_preview.setNewPreviewTime)(newTime));
	  };
	
	  (0, _react.useEffect)(function () {
	    start();
	    if (timeOver || !isRunning) {
	      stop();
	    }
	    return function () {
	      stop();
	    };
	  }, [timeOver, isRunning]);
	
	  (0, _react.useEffect)(function () {
	    var result = fullFormat();
	    setComplete(result);
	    if (result === "00:00:00" && !isTimeAscending) {
	      onTimeOver();
	      dispatch((0, _A_preview.setNewPreviewTime)(0)); //Limpiar tiempo
	      setTimeOver(true);
	    }
	    !isRunningClock && userState !== _constants.USER_STATE.WRAPUP && stringToSec(result);
	  }, [seconds, isRunningClock]);
	
	  return complete;
	};
	
	exports.default = StopWatchPreview;

/***/ },
/* 1081 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.timerActions = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _globalComponentsLibrary = __webpack_require__(28);
	
	var _react = __webpack_require__(1);
	
	var StopWatchSimultaneousPreview = function StopWatchSimultaneousPreview(_ref) {
	  var secondsInitial = _ref.secondsInitial,
	      isTimeAscending = _ref.isTimeAscending,
	      onTimeOver = _ref.onTimeOver,
	      timerAction = _ref.timerAction,
	      secondsDialog = _ref.secondsDialog,
	      status = _ref.status,
	      id = _ref.id;
	
	  var _useState = (0, _react.useState)(secondsInitial),
	      _useState2 = _slicedToArray(_useState, 2),
	      secondsInitialStopWatch = _useState2[0],
	      setSecondsInitialStopWatch = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      stopTimerOut = _useState4[0],
	      setStopTimerOut = _useState4[1];
	
	  var _useTimerDownUp = (0, _globalComponentsLibrary.useTimerDownUp)({ secondsInitial: secondsInitialStopWatch, isAscending: isTimeAscending }),
	      timeLeft = _useTimerDownUp.timeLeft,
	      startTimer = _useTimerDownUp.startTimer,
	      stopTimer = _useTimerDownUp.stopTimer,
	      clear = _useTimerDownUp.clear,
	      fullFormat = _useTimerDownUp.fullFormat,
	      reset = _useTimerDownUp.reset,
	      setTimeLeft = _useTimerDownUp.setTimeLeft;
	
	  (0, _react.useEffect)(function () {
	    if (timeLeft <= 0 && !isTimeAscending) {
	      onTimeOver();
	    }
	  }, [timeLeft]);
	  (0, _react.useEffect)(function () {
	    if (secondsInitial !== secondsInitialStopWatch) {
	      setSecondsInitialStopWatch(secondsInitial);
	    }
	  }, [secondsInitial]);
	
	  (0, _react.useEffect)(function () {
	    if (stopTimerOut) {
	      stopTimer();
	      setStopTimerOut(false);
	    }
	  }, [stopTimerOut]);
	
	  (0, _react.useEffect)(function () {
	    switch (timerAction) {
	      case timerActions.start:
	        startTimer();
	        break;
	
	      case timerActions.stop:
	        stopTimer();
	        break;
	
	      case timerActions.restartFromZero:
	        setSecondsInitialStopWatch(0);
	        break;
	
	      case timerActions.stopInZero:
	        setSecondsInitialStopWatch(0);
	        setStopTimerOut(true);
	        break;
	
	      case timerActions.restartFromInitialSecAndStart:
	        setSecondsInitialStopWatch(secondsInitial);
	        break;
	
	      case timerActions.restartFromDialogAndStop:
	        setTimeLeft(secondsDialog);
	        setStopTimerOut(true);
	        break;
	
	      case timerActions.restartFromDialogAndStart:
	        setSecondsInitialStopWatch(secondsDialog);
	        break;
	
	      case timerActions.startByDialing:
	        if (secondsDialog !== secondsInitialStopWatch) setSecondsInitialStopWatch(secondsDialog);else setTimeLeft(secondsDialog);
	
	        break;
	
	      default:
	        startTimer();
	        break;
	
	    }
	  }, [timerAction]);
	
	  return timeLeft > 0 ? fullFormat() : '00:00:00';
	};
	
	var timerActions = exports.timerActions = {
	  "start": "start",
	  "stop": "stop",
	  "restartFromZero": "restartFromZero",
	  "stopInZero": "stopInZero",
	  "restartFromInitialSecAndStart": "restartFromInitialSecAndStart",
	  "restartFromDialogAndStop": "restartFromDialogAndStop",
	  "restartFromDialogAndStart": "restartFromDialogAndStart",
	  "startByDialing": "startByDialing"
	};
	
	exports.default = StopWatchSimultaneousPreview;

/***/ },
/* 1082 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Images = __webpack_require__(30);
	
	var _GenericSVG = __webpack_require__(51);
	
	var _AlertsSVG = __webpack_require__(321);
	
	var _cwGalateaApiJsBundle = __webpack_require__(40);
	
	var _reactRedux = __webpack_require__(25);
	
	var _A_user_actions = __webpack_require__(194);
	
	var _A_reducer_consulting = __webpack_require__(115);
	
	var _A_messages_to_SM = __webpack_require__(32);
	
	var _Logo = __webpack_require__(1083);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _Singleton = __webpack_require__(21);
	
	var _singletonSharedData = __webpack_require__(23);
	
	var _PasswordTextArea = __webpack_require__(325);
	
	var _PasswordTextArea2 = _interopRequireDefault(_PasswordTextArea);
	
	var _Logger = __webpack_require__(37);
	
	var _constants = __webpack_require__(10);
	
	var _SingletonWebSocket = __webpack_require__(50);
	
	var _SingletonWebSocket2 = _interopRequireDefault(_SingletonWebSocket);
	
	var _globalCommonUtilitiesJsBundle = __webpack_require__(688);
	
	var _A_preview = __webpack_require__(52);
	
	var _A_agent_permissions = __webpack_require__(331);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Login = function (_Component) {
	  _inherits(Login, _Component);
	
	  function Login(props) {
	    _classCallCheck(this, Login);
	
	    var _this2 = _possibleConstructorReturn(this, (Login.__proto__ || Object.getPrototypeOf(Login)).call(this, props));
	
	    _this2.onClickBtnLogin = function () {
	      _this2.login();
	    };
	
	    _this2.state = {
	      password: '',
	      userName: '',
	      isLoading: false,
	      messageError: '',
	      errorCode: 0
	
	    };
	    var APIFact = new _cwGalateaApiJsBundle.APIFactory();
	    _this2.apiCont = APIFact.buildClient();
	    _this2.language = new _Singleton.Singleton();
	    var utilityFactory = new _globalCommonUtilitiesJsBundle.UtilityFactory();
	    _this2.sharedData = new _singletonSharedData.SingletonSharedData();
	    _this2.urlClient = utilityFactory.buildURLClient();
	    _this2.disable = false;
	    return _this2;
	  }
	
	  _createClass(Login, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.refs["userText"].focus();
	      if (this.props.whiteLabelEnabled && this.props.customLogoFormat === 'svg') {
	        var container = document.getElementById("custom-logo-login");
	        container.innerHTML = this.props.customLogo;
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.whiteLabelEnabled !== this.props.whiteLabelEnabled && this.props.whiteLabelEnabled && this.props.customLogoFormat === 'svg') {
	        var container = document.getElementById("custom-logo-login");
	        container.innerHTML = this.props.customLogo;
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.loginError !== this.state.errorCode) {
	        var messageError = this.language.getText('error-' + nextProps.loginError);
	        this.setState({ isLoading: false, messageError: messageError, errorCode: nextProps.loginError });
	        this.props.logout();
	        var _this = this;
	        var message = {
	          code: this.state.errorCode,
	          message: messageError
	        };
	        var integrationMessage = { client: "galatea", data: message, action: "remoteLoginError" };
	        _SingletonWebSocket2.default.send(integrationMessage);
	        if (nextProps.loginError !== 1045) {
	          setTimeout(function () {
	            _this.setState({ messageError: '', errorCode: 0 });
	          }, 4000);
	        } else {
	          this.disable = true;
	        }
	      }
	      if (nextProps.languageLoaded) {
	        this.forceUpdate();
	      }
	      if (nextProps.messagesIntegrations) {
	        if (nextProps.messagesIntegrations.dataMessageIntegration && nextProps.messagesIntegrations.dataMessageIntegration.action === _constants.INTEGRATION.LOGIN) {
	          var data = nextProps.messagesIntegrations.dataMessageIntegration;
	          this.loginAgent(data.user, data.password);
	        }
	      }
	    }
	  }, {
	    key: 'loginAgent',
	    value: function loginAgent(user, password) {
	      var _this = this;
	      var objectResponse = this.apiCont.getObjectResponse();
	      this.setState({ isLoading: true });
	      _Logger.Logger.Trace("[Login][loginAgent] user => ", user, "[Login][loginAgent] password => *******");
	      var loginData = {
	        user: user, password: password, ipAddress: this.sharedData.getIPAddress(),
	        isRemote: _this.sharedData.getSoftPhone() !== _constants.SOFTPHONES_KEY.MIZUJS
	      };
	      this.apiCont.agentLogin(loginData, objectResponse);
	      this.props.consultingApp();
	      objectResponse.onError = function (messageError) {
	        _Logger.Logger.Warning("[Login][loginAgent] Error Login => ", messageError.InternalCode + " " + _this.language.getText('error-' + messageError.InternalCode));
	        _this.setState({ isLoading: false, messageError: _this.language.getText('error-' + messageError.InternalCode) });
	        _this.props.noConsultingApp();
	        var message = {
	          code: messageError.InternalCode,
	          message: _this.language.getText('error-' + messageError.InternalCode)
	        };
	        var integrationMessage = { client: "galatea", data: message, action: "remoteLoginError" };
	        _SingletonWebSocket2.default.send(integrationMessage);
	      };
	      objectResponse.onSuccess = function (objResponse) {
	        _Logger.Logger.Debug("[Login][loginAgent] Success Login => ", objResponse);
	        _this.setState({ isLoading: false });
	        _this.sharedData.setUserData(objResponse.Response.user);
	        _this.sharedData.setParameters(objResponse.Response.parameters);
	        _this.sharedData.setPermissions(objResponse.Response.permissions);
	        _this.sharedData.setGeneralPermissions(objResponse.Response.generalPermissions);
	        _this.sharedData.setAllowMarksPermission(objResponse.Response.permissions.AllowMarks);
	        _this.props.setAllowPlayRecordsOnCallHistory(objResponse.Response.permissions.AllowPlayRecordsOnCallHistory);
	        _this.props.setAllowChangeDialing(objResponse.Response.user.AllowSelectCamp);
	        _this.sharedData.setRequestTimeout(_this.sharedData.getGeneralPermissions()[226]);
	        _this.props.noConsultingApp();
	        _this.props.onLogin();
	        _this.props.setDialingMode(objResponse.Response.user.DialingMode);
	        _SingletonWebSocket2.default.setUserId(_Logger.Logger.getUserID());
	        var setting131 = _this.sharedData.getGeneralPermissions()[131];
	        var datoPBX = setting131.split("|");
	        _this.sharedData.setVolumeSpeaker(datoPBX[4]);
	        _Logger.Logger.Debug("[Login][loginAgent] setVolumeSpeaker => ", datoPBX[4]);
	        _this.sharedData.setVolumeMic(datoPBX[5]);
	        _Logger.Logger.Debug("[Login][loginAgent] setVolumeMic => ", datoPBX[5]);
	      };
	    }
	  }, {
	    key: 'login',
	    value: function login() {
	      if (!this.disable) {
	        this.loginAgent(this.state.userName, this.state.password);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'loginWindow' },
	        _react2.default.createElement(
	          'div',
	          { className: 'starsContainer' },
	          _react2.default.createElement(
	            'div',
	            { className: 'galaxy' },
	            _react2.default.createElement('div', { className: 'stars-back' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'loginContainer' },
	          _react2.default.createElement(
	            'div',
	            { className: 'loginBox' },
	            !this.props.whiteLabelEnabled ? _react2.default.createElement(_Logo2.default, { title: 'Kolob', subtitle: '' }) : _react2.default.createElement(
	              'div',
	              { id: 'custom-logo-login' },
	              this.props.customLogoFormat === 'image' && _react2.default.createElement('img', { id: 'custom-login-img', alt: '', src: this.props.customLogo })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'loginForm' },
	              _react2.default.createElement(
	                'div',
	                { className: "errorLogin " + (this.state.messageError ? "errorVisible" : "") },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'alertIconLogin' },
	                  _AlertsSVG.alertSVG
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { className: 'errorInfo' },
	                  this.state.messageError
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'loginFormContainer' },
	                _react2.default.createElement(
	                  'p',
	                  { className: 'labelLogin' },
	                  this.language.getText("GUILoginuser")
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'userForm' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'iconForm' },
	                    _GenericSVG.agentSVG
	                  ),
	                  _react2.default.createElement('input', { type: 'text',
	                    ref: 'userText',
	                    className: 'userText',
	                    maxLength: '40',
	                    value: this.state.userName,
	                    onChange: function onChange(event) {
	                      return _this3.setState({ userName: event.target.value });
	                    } })
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { className: 'labelLogin margin' },
	                  this.language.getText("GUILoginpsw")
	                ),
	                _react2.default.createElement(_PasswordTextArea2.default, {
	                  value: this.state.password,
	                  height: 35,
	                  width: "100%",
	                  margin: 0,
	                  onEnterKey: function onEnterKey() {
	                    return _this3.login();
	                  },
	                  image: _Images.changePassIcon,
	                  onChange: function onChange(text) {
	                    return _this3.setState({ password: text });
	                  } }),
	                _react2.default.createElement(
	                  'div',
	                  { className: "buttonLogin " + (!this.state.password || !this.state.userName || this.disable || !this.props.softPhoneLoaded ? "disabled" : ""),
	                    onClick: this.onClickBtnLogin },
	                  this.state.isLoading ? this.language.getText("GUILoginloading") : this.language.getText("GUILoginlogin")
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Login;
	}(_react.Component);
	
	function mapDispatchToProps(dispatch) {
	  return {
	    logout: function logout() {
	      dispatch((0, _A_user_actions.logout)());
	    },
	    loginAction: function loginAction(wLogged, ccsLogged) {
	      dispatch((0, _A_user_actions.loginAction)(wLogged, ccsLogged));
	    },
	    change_language: function change_language(c_language) {
	      dispatch((0, _A_user_actions.change_language)(c_language));
	    },
	    consultingApp: function consultingApp() {
	      dispatch((0, _A_reducer_consulting.consultingApp)());
	    },
	    noConsultingApp: function noConsultingApp() {
	      dispatch((0, _A_reducer_consulting.noConsultingApp)());
	    },
	    sendMessageAgentReady: function sendMessageAgentReady() {
	      dispatch((0, _A_messages_to_SM.sendMessageAgentReady)());
	    },
	    setDialingMode: function setDialingMode(data) {
	      dispatch((0, _A_preview.setDialingMode)(data));
	    },
	    setAllowPlayRecordsOnCallHistory: function setAllowPlayRecordsOnCallHistory(data) {
	      dispatch((0, _A_agent_permissions.setAllowPlayRecordsOnCallHistory)(data));
	    },
	    setAllowChangeDialing: function setAllowChangeDialing(data) {
	      dispatch((0, _A_agent_permissions.setAllowChangeDialing)(data));
	    }
	  };
	}
	function mapStateToProps(state) {
	  return {
	    stateMachineActions: state.stateMachineActions,
	    messagesIntegrations: state.messagesIntegrations,
	    whiteLabelEnabled: state.whiteLabelState.whiteLabelEnabled,
	    customLogo: state.whiteLabelState.login,
	    customLogoFormat: state.whiteLabelState.imageFormat
	  };
	}
	exports.default = Login = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Login);

/***/ },
/* 1083 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Recurso = __webpack_require__(2611);
	
	var _Recurso2 = _interopRequireDefault(_Recurso);
	
	var _Recurso3 = __webpack_require__(2612);
	
	var _Recurso4 = _interopRequireDefault(_Recurso3);
	
	var _Recurso5 = __webpack_require__(2613);
	
	var _Recurso6 = _interopRequireDefault(_Recurso5);
	
	var _Recurso7 = __webpack_require__(2614);
	
	var _Recurso8 = _interopRequireDefault(_Recurso7);
	
	var _Recurso9 = __webpack_require__(2615);
	
	var _Recurso10 = _interopRequireDefault(_Recurso9);
	
	var _Recurso11 = __webpack_require__(2616);
	
	var _Recurso12 = _interopRequireDefault(_Recurso11);
	
	__webpack_require__(2618);
	
	__webpack_require__(2617);
	
	var _Stars = __webpack_require__(1084);
	
	var _Stars2 = _interopRequireDefault(_Stars);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Logo = function Logo(_ref) {
	  var className = _ref.className,
	      title = _ref.title,
	      subtitle = _ref.subtitle;
	
	  return _react2.default.createElement(
	    "div",
	    { className: "glc-logo-container " + className },
	    _react2.default.createElement(
	      "div",
	      { className: "glc-logo-image" },
	      _react2.default.createElement(
	        "div",
	        { className: "glc-logo-galaxy" },
	        _react2.default.createElement("img", { className: "glc-logo-planet", src: _Recurso12.default, alt: "01" }),
	        _react2.default.createElement("div", { className: "glc-logo-shade" }),
	        _react2.default.createElement(
	          "div",
	          { className: "glc-logo-stars" },
	          _react2.default.createElement(_Stars2.default, null)
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "glc-logo-images" },
	          _react2.default.createElement("img", { className: "glc-logo-image5", src: _Recurso10.default, alt: "01" }),
	          _react2.default.createElement("img", { className: "glc-logo-image4", src: _Recurso8.default, alt: "01" }),
	          _react2.default.createElement("img", { className: "glc-logo-image3", src: _Recurso6.default, alt: "01" }),
	          _react2.default.createElement("img", { className: "glc-logo-image2", src: _Recurso4.default, alt: "01" }),
	          _react2.default.createElement("img", { className: "glc-logo-image1", src: _Recurso2.default, alt: "01" })
	        ),
	        _react2.default.createElement("div", { className: "glc-logo-dot" })
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "glc-logo-texto" },
	      _react2.default.createElement(
	        "p",
	        { className: "glc-logo-texto-CW" },
	        _react2.default.createElement(
	          "span",
	          null,
	          "C"
	        ),
	        _react2.default.createElement(
	          "span",
	          null,
	          "e"
	        ),
	        _react2.default.createElement(
	          "span",
	          null,
	          "n"
	        ),
	        _react2.default.createElement(
	          "span",
	          null,
	          "t"
	        ),
	        _react2.default.createElement(
	          "span",
	          null,
	          "e"
	        ),
	        _react2.default.createElement(
	          "span",
	          null,
	          "r"
	        ),
	        _react2.default.createElement(
	          "span",
	          null,
	          "W"
	        ),
	        _react2.default.createElement(
	          "span",
	          null,
	          "a"
	        ),
	        _react2.default.createElement(
	          "span",
	          null,
	          "r"
	        ),
	        _react2.default.createElement(
	          "span",
	          null,
	          "e"
	        )
	      ),
	      _react2.default.createElement(
	        "p",
	        { className: "glc-logo-texto-KB" },
	        title
	      ),
	      _react2.default.createElement(
	        "p",
	        { className: "glc-logo-texto-AGT" },
	        subtitle
	      )
	    )
	  );
	};
	
	Logo.propTypes = {
	  className: _propTypes2.default.string,
	  title: _propTypes2.default.string,
	  subtitle: _propTypes2.default.string
	};
	
	exports.default = Logo;

/***/ },
/* 1084 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Stars = function Stars() {
	  return _react2.default.createElement(
	    "svg",
	    {
	      version: "1.1",
	      id: "Capa_1",
	      xmlns: "http://www.w3.org/2000/svg",
	      x: "0px",
	      y: "0px",
	      viewBox: "0 0 100 100"
	    },
	    _react2.default.createElement(
	      "g",
	      null,
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "47.9", cy: "13.2", r: "0.1" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "39.7", cy: "17.8", r: "0.1" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "29.2", cy: "25.9", r: "0.2" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "19.9", cy: "41.6", r: "0.3" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "23.2", cy: "61.3", r: "0.2" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "39.9", cy: "77.6", r: "0.1" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "58", cy: "80.5", r: "0.1" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "76.4", cy: "63.7", r: "0.2" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "74.6", cy: "46.2", r: "0.2" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "59.6", cy: "39.6", r: "0.2" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "47.3", cy: "50.6", r: "0.2" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "50.4", cy: "60.4", r: "0.3" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "62.2", cy: "63.5", r: "0.1" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "76.1", cy: "57.7", r: "0.2" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "81.3", cy: "41.4", r: "0.1" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "77.6", cy: "27.7", r: "0.1" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "66.1", cy: "18.1", r: "0.2" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "49.7", cy: "14.8", r: "0.1" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "34.7", cy: "17", r: "0.1" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "17.4", cy: "29.4", r: "0.2" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "9.7", cy: "48.4", r: "0.2" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "10.4", cy: "68.2", r: "0.1" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "21.5", cy: "83.8", r: "0.2" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "38.6", cy: "91.8", r: "0.2" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "61.5", cy: "90.4", r: "0.2" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "78.2", cy: "77.8", r: "0.3" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "81.5", cy: "49.9", r: "0.1" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "70.7", cy: "30.5", r: "0.2" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "52", cy: "26.4", r: "0.2" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "36.6", cy: "45.4", r: "0.2" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "44.5", cy: "63", r: "0.2" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "59.3", cy: "55.7", r: "0.2" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "50.2", cy: "42.6", r: "0.2" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "43", cy: "44.7", r: "0.2" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "41.8", cy: "35.5", r: "0.3" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "49.3", cy: "24.5", r: "0.2" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "74.6", cy: "40.5", r: "0.1" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "67", cy: "67.8", r: "0.1" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "39.2", cy: "71.3", r: "0.2" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "26.6", cy: "44.8", r: "0.2" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "37.7", cy: "24.2", r: "0.1" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "77.4", cy: "83.3", r: "0.1" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "87.7", cy: "72.3", r: "0.2" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "92.7", cy: "52.3", r: "0.1" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "91.7", cy: "36", r: "0.2" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "85.7", cy: "22.8", r: "0.2" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "71.6", cy: "12.5", r: "0.3" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "51.9", cy: "8.2", r: "0.2" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "36.4", cy: "9.1", r: "0.2" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "24.1", cy: "14.5", r: "0.2" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "15.3", cy: "22.8", r: "0.2" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "10.2", cy: "32.6", r: "0.1" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "7.3", cy: "47.1", r: "0.2" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "12.4", cy: "65.9", r: "0.2" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "28.2", cy: "80.8", r: "0.2" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "48.6", cy: "82.7", r: "0.2" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "67.2", cy: "69.9", r: "0.1" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "34.5", cy: "57.7", r: "0.3" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "21.6", cy: "52.1", r: "0.3" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "25.8", cy: "71.2", r: "0.3" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "55", cy: "75.8", r: "0.2" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "67.9", cy: "52", r: "0.3" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "64.2", cy: "25.4", r: "0.3" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "54.4", cy: "33.4", r: "0.2" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "29.8", cy: "32.6", r: "0.2" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "60", cy: "11.1", r: "0.3" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "78", cy: "20", r: "0.2" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "84", cy: "35.9", r: "0.2" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "54.9", cy: "51.5", r: "0.2" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "35.1", cy: "88.3", r: "0.2" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "85.9", cy: "66.3", r: "0.2" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "10.4", cy: "37.1", r: "0.1" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "21.9", cy: "19.6", r: "0.3" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "71", cy: "37.3", r: "0.2" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "38.9", cy: "49.9", r: "0.2" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "45.8", cy: "36.5", r: "0.3" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "52.9", cy: "69.5", r: "0.3" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "84.8", cy: "56.4", r: "0.2" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "82.7", cy: "42.5", r: "0.1" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "84.8", cy: "47.6", r: "0.1" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "83.7", cy: "49.3", r: "0.1" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "80.3", cy: "54.4", r: "0.2" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "89.3", cy: "40.5", r: "0.1" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "89.3", cy: "51.7", r: "0.1" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "79", cy: "46.3", r: "0.2" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "88.8", cy: "43.5", r: "0.1" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "63.4", cy: "21.3", r: "0.3" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "41", cy: "23", r: "0.1" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "41.6", cy: "16.5", r: "0.1" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "45.7", cy: "19.4", r: "0.2" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "37.1", cy: "15.3", r: "0.1" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "43.8", cy: "13.9", r: "0.2" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "61.4", cy: "77.8", r: "0.2" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "62.6", cy: "69.6", r: "0.1" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "74.1", cy: "75.5", r: "0.1" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "67.1", cy: "73.5", r: "0.1" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "77.2", cy: "74.7", r: "0.1" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "68.3", cy: "77.4", r: "0.1" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "71", cy: "66.6", r: "0.1" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "73.9", cy: "77.8", r: "0.1" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "63.2", cy: "71.9", r: "0.1" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "76.6", cy: "72.7", r: "0.1" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "60.6", cy: "82.9", r: "0.2" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "75.8", cy: "70.3", r: "0.1" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "47.6", cy: "47.3", r: "0.2" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "37.9", cy: "39.2", r: "0.3" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "53.9", cy: "42.3", r: "0.2" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "30", cy: "58.9", r: "0.3" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "27.4", cy: "32.1", r: "0.2" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "63.9", cy: "50.2", r: "0.3" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "36.3", cy: "72.2", r: "0.2" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "27.3", cy: "39.1", r: "0.3" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "68", cy: "46", r: "0.4" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "35.3", cy: "75.2", r: "0.2" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "43.5", cy: "27.4", r: "0.1" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "65.5", cy: "57.8", r: "0.2" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "36.3", cy: "62.6", r: "0.2" })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("circle", { className: "st0_blanco", cx: "62.4", cy: "41.6", r: "0.2" })
	        )
	      )
	    )
	  );
	};
	
	exports.default = Stars;

/***/ },
/* 1085 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.ProcessMessage = ProcessMessage;
	
	var _StrategiesActions = __webpack_require__(1141);
	
	var _Logger = __webpack_require__(37);
	
	var _constants = __webpack_require__(10);
	
	var _beepChat = __webpack_require__(2607);
	
	var _beepChat2 = _interopRequireDefault(_beepChat);
	
	var _helperMail = __webpack_require__(1157);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ProcessMessage(message, that) {
		if (message.Sender === 2) {
			if (that.state.logged) {
				that.logOut();
			} else {
				that.stateMachineDown();
			}
			return;
		}
	
		that.tryMessageToIntegration(message);
		that.sharedData.setIsAssisted(false);
		var hasUnifiedMessage = that.sharedData.generalPermissions[220] === '1';
		switch (message.action) {
			case 'state':
				if (message.currentState === "Login") {
					message.agentData = {
						userName: that.sharedData.user.Login,
						userId: that.sharedData.user.User_id,
						userExt: that.sharedData.parameters.Extension
					};
				}
				if (message.currentState === "Assisted") {
					that.sharedData.setIsAssisted(true);
					that.props.changeState(_constants.USER_STATE.ASSISTED);
				}
				that.callStateAction(message);
				if (message.action === "InactivePreview") {
					that.props.changeState(_constants.USER_STATE.INACTIVE);
				}
				break;
			case 'TWITTER_CUSTOMER':
				if (hasUnifiedMessage) {
					that.props.addToast(that.language.getText('GUIUnifiedInboxnewTweet'), { type: 'twitter', from: that.language.getText('GUIUnifiedInboxnewConversation'), position: 'topRight', group: 'inbox' });
					that.props.showUnifiedMessagesWindow(true);
					that.props.newUnifiedInboxConversation(message);
				}
				break;
			case 'MAIL_CUSTOMER':
				if (hasUnifiedMessage) {
					that.props.addToast(that.language.getText('GUIUnifiedInboxnewMail'), {
						type: 'mail',
						from: that.language.getText('GUIUnifiedInboxnewConversation'),
						account: message.ClientAddress,
						position: 'topRight',
						group: 'inbox'
					});
	
					if (message.EmailMessagesList.length > 0) {
						if (message.EmailMessagesList[0].Message.includes('$domain$')) {
							var finalSource = (0, _helperMail.changeMessageSrc)(message.EmailMessagesList[0].Message);
							message.EmailMessagesList[0].Message = finalSource;
						}
	
						if (message.EmailMessagesList[0].Attachments.length > 0) {
							var attachments = (0, _helperMail.changeAttachmentsSrc)(message.EmailMessagesList[0].Attachments);
							message.EmailMessagesList[0].Attachments = attachments;
						}
					}
	
					that.props.showUnifiedMessagesWindow(true);
					that.props.newUnifiedInboxConversation(Object.assign({}, message, { origin: 'USER' }));
				}
				break;
			case 'CHAT_CUSTOMER_ANIMATION':
				if (hasUnifiedMessage) {
					that.props.chatTyping(message);
				}
				break;
			case 'CHAT_CUSTOMER':
				if (hasUnifiedMessage) {
					that.BeepChat2 = new Audio(_beepChat2.default);
					that.BeepChat2.play();
					that.props.addToast(that.language.getText('GUIUnifiedInboxnewChat'), {
						type: 'chat',
						from: that.language.getText('GUIUnifiedInboxnewConversation'),
						account: message.ClientAddress,
						position: 'topRight',
						group: 'inbox'
					});
					that.props.changeState(_constants.USER_STATE.CHATTING);
					that.props.showUnifiedMessagesWindow(true);
					that.props.newUnifiedInboxConversation(message);
				}
				break;
			case 'CHAT_ADMIN_MESSAGE':
				if (hasUnifiedMessage) {
					if (message.ConversationId !== that.props.selectedConversarionID) that.props.addToast(that.language.getText('GUIUnifiedInboxnewMessageChat'), { type: 'chat', from: message.From, position: 'topRight', group: 'inbox' });
					that.props.newUnifiedInboxMessage(Object.assign({}, message, { origin: 'ADMIN' }));
				}
				break;
			case 'CHAT_CUSTOMER_MESSAGE':
				if (hasUnifiedMessage) {
					that.BeepChat2 = new Audio(_beepChat2.default);
					that.BeepChat2.play();
					if (message.ConversationId !== that.props.selectedConversarionID) that.props.addToast(that.language.getText('GUIUnifiedInboxnewMessageChat'), { type: 'chat', from: message.From, position: 'topRight', group: 'inbox' });
					that.props.newUnifiedInboxMessage(Object.assign({}, message, { origin: 'USER' }));
				}
				break;
			case 'CHAT_CUSTOMER_TERMINATION':
				that.BeepChat2 = new Audio(_beepChat2.default);
				that.BeepChat2.play();
				that.props.endConversationClient(message, true);
				that.props.endConversationChat(message);
				that.props.changeState(_constants.USER_STATE.WRAPUP);
				//that.props.changeState(USER_STATE.AGENT_READY);
				break;
			case 'CHAT_TAKEOVER':
				that.props.chatTakeover(message);
				break;
			case 'MAIL_CUSTOMER_MESSAGE':
				if (hasUnifiedMessage) {
					if (message.ConversationId !== that.props.selectedConversarionID) that.props.addToast(that.language.getText('GUIUnifiedInboxnewMessageMail'), { type: 'mail', from: message.From, position: 'topRight', group: 'inbox' });
					that.props.newUnifiedInboxMessage(Object.assign({}, message, { origin: 'USER' }));
				}
				break;
			case 'TWITTER_CUSTOMER_MESSAGE':
				if (hasUnifiedMessage) {
					if (message.ConversationId !== that.props.selectedConversarionID) that.props.addToast(that.language.getText('GUIUnifiedInboxnewMessageTwitter'), { type: 'twitter', from: message.From, position: 'topRight', group: 'inbox' });
					that.props.newUnifiedInboxMessage(message);
				}
				break;
			case 'ALERT':
				that.sharedData.getDataPreviewPro().dialingMode === 1 && that.props.setNewPreviewTime(this.props.preview.initPreviewTime);
				if (message.Code === '2021') {
					that.props.agentUnavailableOnTransfer(message);
					if (_StrategiesActions.STRATEGIES_ACTIONS[message.Module]) {
						_StrategiesActions.STRATEGIES_ACTIONS[message.Module](message, that);
					}
				} else {
					_Logger.Logger.Warn('[App][processMessage] Alert Not implement ', message.action);
				}
				break;
			case 'UNIFIED_INBOX_AUTOMATIC_ANSWERS':
				that.props.chatAnswersTemplates(message);
				break;
			case 'MULTIMEDIA_DISPOSITION':
				that.props.setMultimediaDispositions(message);
				break;
			case 'DISCONNECT':
				_Logger.Logger.Warn('DISCONNECT State Machine is logout System in reconnect');
				that.messageDisconnect();
				break;
			case 'RECONNECTED':
				_Logger.Logger.Warn('State machine is up');
				that.setState({ smReady: true });
				break;
			case "NewPreviewCall":
				that.sharedData.setIsAssisted(true);
				that.sharedData.setDataAssistedCall(message);
				that.setState({ datacall: message });
				if (message.Port > 0) {
					that.props.changeState(_constants.USER_STATE.RINGING);
					_StrategiesActions.STRATEGIES_ACTIONS[message.action](message, that);
				} else {
					that.props.changeState(_constants.USER_STATE.ASSISTED);
				}
				break;
			case "PREVIEWPRO":
				if ([100, 101, 200, 201, 500].includes(message.DialingMode)) {
					_StrategiesActions.STRATEGIES_ACTIONS[message.action](message, that);
					return;
				};
				message.dialingMode === 0 ? that.props.changeState(_constants.USER_STATE.AGENT_READY) : that.props.changeState(_constants.USER_STATE.READY_PREVIEW);
				_StrategiesActions.STRATEGIES_ACTIONS[message.action](message, that);
				break;
			case "previewData":
				_StrategiesActions.STRATEGIES_ACTIONS[message.action](message, that);
				that.props.savePreviewRecord(message);
				break;
			case "UPDATE_DATA_CALL":
				_StrategiesActions.STRATEGIES_ACTIONS[message.action](message, that);
				break;
			case "ChangeDialingModeScheduled":
				_StrategiesActions.STRATEGIES_ACTIONS[message.action](message, that);
				break;
			case "ALLOW_MARKS_PERMISSION":
				that.sharedData.setAllowMarksPermission(message.PermissionValue);
				break;
			case "MANUAL_MESSAGE":
				var phone = message.code === 0 ? undefined : message.phone;
				that.props.onSetMessageStatus(_constants.MANUAL_MESSAGES_STATUS[_constants.MANUAL_MESSAGES_STATUS_CODE[message.code]], phone);
				if (message.code === 0) {
					that.props.removeWindow(_constants.DRAGGABLE_WINDOWS.MANUAL_MESSAGE);
				}
				break;
			case "Preview":
				_StrategiesActions.STRATEGIES_ACTIONS[message.action](message, that);
				break;
			case "RingingListening":
				_StrategiesActions.STRATEGIES_ACTIONS[message.action](message, that);
				break;
			case "NotifyCleanDisplay":
				_StrategiesActions.STRATEGIES_ACTIONS[message.action](message, that);
				break;
			default:
				if (_StrategiesActions.STRATEGIES_ACTIONS[message.action]) {
					_StrategiesActions.STRATEGIES_ACTIONS[message.action](message, that);
				} else {
					_Logger.Logger.Debug('[App][processMessage] Action Not implement ', message.action);
				}
				break;
		}
	}

/***/ },
/* 1086 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(10);
	
	var _Images = __webpack_require__(30);
	
	var _singletonSharedData = __webpack_require__(23);
	
	var _StopWatch = __webpack_require__(1091);
	
	var _StopWatch2 = _interopRequireDefault(_StopWatch);
	
	var _formats = __webpack_require__(54);
	
	var _Singleton = __webpack_require__(21);
	
	var _HeaderAssisted = __webpack_require__(1089);
	
	var _HeaderAssisted2 = _interopRequireDefault(_HeaderAssisted);
	
	var _reactRedux = __webpack_require__(25);
	
	var _reactstrap = __webpack_require__(111);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function usePrevious(value) {
		var ref = (0, _react.useRef)();
		(0, _react.useEffect)(function () {
			ref.current = value;
		});
		return ref.current;
	}
	
	var CallHeader = function CallHeader(props) {
		var language = new _Singleton.Singleton();
		var sharedData = new _singletonSharedData.SingletonSharedData();
		var isHidePhone = sharedData.getGeneralPermissions()[223];
	
		var receiveAmount = props;
		var prevAmount = usePrevious(receiveAmount);
	
		var _useState = (0, _react.useState)(''),
		    _useState2 = _slicedToArray(_useState, 2),
		    typeCall = _useState2[0],
		    setTypeCall = _useState2[1];
	
		var _useState3 = (0, _react.useState)(''),
		    _useState4 = _slicedToArray(_useState3, 2),
		    typeHeader = _useState4[0],
		    setTypeHeader = _useState4[1];
	
		var _useState5 = (0, _react.useState)(''),
		    _useState6 = _slicedToArray(_useState5, 2),
		    campaignName = _useState6[0],
		    setCampaignName = _useState6[1];
	
		var _useState7 = (0, _react.useState)(''),
		    _useState8 = _slicedToArray(_useState7, 2),
		    phoneNumber = _useState8[0],
		    setPhoneNumber = _useState8[1];
	
		var _useState9 = (0, _react.useState)(''),
		    _useState10 = _slicedToArray(_useState9, 2),
		    time = _useState10[0],
		    setTime = _useState10[1];
	
		var _useState11 = (0, _react.useState)(''),
		    _useState12 = _slicedToArray(_useState11, 2),
		    iconCallFrame = _useState12[0],
		    tetIconCallFrame = _useState12[1];
	
		var _useState13 = (0, _react.useState)(''),
		    _useState14 = _slicedToArray(_useState13, 2),
		    recordingEnabled = _useState14[0],
		    setRecordingEnabled = _useState14[1];
	
		var _useState15 = (0, _react.useState)(''),
		    _useState16 = _slicedToArray(_useState15, 2),
		    buttonRecordingActive = _useState16[0],
		    setButtonRecordingActive = _useState16[1];
	
		var _useState17 = (0, _react.useState)(''),
		    _useState18 = _slicedToArray(_useState17, 2),
		    callKey = _useState18[0],
		    setcallKey = _useState18[1];
	
		var showData = (0, _reactRedux.useSelector)(function (state) {
			return state.previewActions.showData;
		});
	
		(0, _react.useEffect)(function () {
			if (prevAmount !== undefined && prevAmount !== receiveAmount && props.currentState !== _constants.USER_STATE.ASSISTED) {
				setTypeCall(props.typeCall);
				setTypeHeader(props.typeHeader);
				setCampaignName(props.campaignName);
				setPhoneNumber(props.phoneNumber);
				tetIconCallFrame(props.iconCallFrame);
				setRecordingEnabled(props.recordingEnabled);
				setButtonRecordingActive(props.buttonRecordingActive);
				setcallKey(props.dataCall.CalKey ? props.dataCall.CalKey : props.dataCall.CallKey);
			} else if (props.currentState === _constants.USER_STATE.ASSISTED) {
				setCampaignName(props.dataCallAssisted.campaingName);
				tetIconCallFrame(props.dataCallAssisted.iconCampaing);
				setcallKey(props.dataCallAssisted.calKey);
			}
		});
		return _react2.default.createElement(
			'div',
			null,
			sharedData.setCurrentCallTime(time),
			props.currentState === _constants.USER_STATE.ASSISTED ? _react2.default.createElement(_HeaderAssisted2.default, { iconCallFrame: iconCallFrame, campaignName: campaignName, callKey: callKey }) : !props.problemInManualCall && _react2.default.createElement(
				'div',
				{ className: 'callWindowHeader' },
				_react2.default.createElement(
					'div',
					{ className: 'infoCallHeaderContainer' },
					_react2.default.createElement(
						'div',
						{ className: 'iconCallHeader' },
						_react2.default.createElement('img', { className: 'iconCallImage', src: typeCall === _constants.TYPE_CALL.INBOUND ? _Images.inboundCall : _Images.outBoundCall, alt: 'icon' }),
						_react2.default.createElement('img', { className: 'iconCallImage iconPadding', src: iconCallFrame > 0 ? _Images.framesCamp[iconCallFrame] : '', alt: 'iconCallImage' })
					),
					_react2.default.createElement(
						'div',
						{ className: 'conteinerCampData' },
						_react2.default.createElement(
							'p',
							{ className: 'campaignName', id: 'camp-name-current-call' },
							campaignName,
							campaignName.length > 16 && _react2.default.createElement(
								_reactstrap.UncontrolledTooltip,
								{ delay: { show: 500, hide: 500 }, placement: 'top', target: 'camp-name-current-call' },
								campaignName
							)
						),
						showData && _react2.default.createElement(
							'div',
							{ className: 'conteinerPhoneCallKey' },
							_react2.default.createElement(
								'div',
								{ className: 'containerPhoneNumber ' + typeHeader },
								_react2.default.createElement('img', { className: 'iconCampACD ' + typeHeader, src: _Images.phoneIcon, alt: 'icon' }),
								_react2.default.createElement(
									'p',
									{ className: 'phoneNumber' },
									(0, _formats.hidePhone)(isHidePhone, phoneNumber)
								)
							),
							(!props.startTimer && callKey !== '' || sharedData.getDataPreviewPro().dialingMode === 1 && props.currentState === _constants.USER_STATE.OTHER) && _react2.default.createElement(
								'div',
								{ className: 'callKey' },
								_react2.default.createElement(
									'p',
									{ className: 'callKeyTitle' },
									language.getText('GUICallSpacecallkey')
								),
								_react2.default.createElement(
									'div',
									{ className: 'callKeyBody' },
									callKey
								)
							)
						)
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'timeContainer' },
					_react2.default.createElement(
						'p',
						{ className: 'timeCall ' + typeHeader },
						_react2.default.createElement(_StopWatch2.default, {
							onChange: function onChange(time) {
								if (props.currentState !== _constants.USER_STATE.WRAPUP) setTime(time);
							},
							running: props.startTimer
						}),
						time.substr(0, 3),
						_react2.default.createElement(
							'span',
							{ className: 'timeCallBold ' + typeHeader },
							' ',
							time.substr(3, 5),
							' '
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'recordContainer' },
						_react2.default.createElement('div', { className: recordingEnabled && !buttonRecordingActive ? 'headerRecording on' : 'headerRecording off' })
					)
				)
			)
		);
	};
	exports.default = CallHeader;

/***/ },
/* 1087 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(25);
	
	var _constants = __webpack_require__(10);
	
	var _Images = __webpack_require__(30);
	
	var _A_messages_to_SM = __webpack_require__(32);
	
	var _singletonSharedData = __webpack_require__(23);
	
	var _reactAutosizeTextarea = __webpack_require__(457);
	
	var _reactAutosizeTextarea2 = _interopRequireDefault(_reactAutosizeTextarea);
	
	var _Singleton = __webpack_require__(21);
	
	var _Validations = __webpack_require__(131);
	
	var _globalComponentsLibrary = __webpack_require__(28);
	
	var _ContainerDataPreview = __webpack_require__(237);
	
	var _ContainerDataPreview2 = _interopRequireDefault(_ContainerDataPreview);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CallWindow = function (_Component) {
		_inherits(CallWindow, _Component);
	
		function CallWindow(props) {
			_classCallCheck(this, CallWindow);
	
			var _this = _possibleConstructorReturn(this, (CallWindow.__proto__ || Object.getPrototypeOf(CallWindow)).call(this, props));
	
			_this.updateInfo = function () {
				var dataCallObj = _this.state.dataCells.map(function (item) {
					return item.text ? item.text : '';
				});
				var callKey = _this.props.dataCall.CalKey;
				var camID = _this.props.iconCall.CamEspId;
				_this.props.updateInfoCall(callKey, camID, dataCallObj, 0);
				_this.updateInfoCell(dataCallObj, callKey);
			};
	
			_this.OnKeyPressEvent = function (index, e) {
				var r = /^(\s*[a-zA-Z0-9-ZÀ-ÿ\u00f1\u00d1\u002F\u005F\u0024\u0020\u002E\u003A\u0027\u002C]*)*[a-zA-Z0-9-ZÀ-ÿ\u00f1\u00d1\u002F\u005F\u0024\u0020\u002E\u003A\u0027\u002C]+$/;
				if (e.charCode !== 8) {
					if (!r.test(String.fromCharCode(e.charCode))) {
						e.preventDefault();
					}
				}
			};
	
			_this.focusElement = function (index) {
				if (index === -1) {
					_this.setState({ cellKeyFocus: true });
				} else {
					var tempArray = _this.state.dataCells;
					if (tempArray[index]) {
						tempArray[index].focus = true;
						_this.setState({ dataCells: tempArray });
					}
				}
			};
	
			_this.updateDataCallPreview = function (data) {
				_this.props.updateInfoCall(data.callKey, data.camID, data.newData, data.callOutId);
			};
	
			_this.OnKeyPressEventCallKey = function (e) {
				var r = /[!¡@#$%^&*()_+\-=\[\]{};':"\\|¬´°¨,.<>\/?]+$/;
				if (e.charCode !== 8) {
					if (r.test(String.fromCharCode(e.charCode))) {
						e.preventDefault();
					}
				}
			};
	
			_this.state = {
				callkey: props.dataCall.CalKey ? props.dataCall.CalKey : props.extraDataCall.CalKey,
				cellKeyFocus: false,
				dataCall: props.dataCall,
				extraDataCall: props.extraDataCall,
				userState: props.userState,
				dataCells: props.dataCells
			};
			_this.sharedData = new _singletonSharedData.SingletonSharedData();
			_this.language = new _Singleton.Singleton();
			_this.integrationData = null;
			return _this;
		}
	
		_createClass(CallWindow, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.setDataCells(this.props.dataCall.DataContact);
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				var _this2 = this;
	
				if (this.props.dataCall.CalKey !== nextProps.dataCall.CalKey) {
					this.setState({
						dataCells: nextProps.dataCells
					});
				}
				this.setState({
					dataCall: nextProps.dataCall,
					callkey: nextProps.dataCall.CalKey,
					userState: nextProps.userState,
					extraDataCall: nextProps.extraDataCall
				});
	
				if (nextProps.messagesIntegrations && nextProps.messagesIntegrations.dataMessageIntegration) {
					this.integrationData = nextProps.messagesIntegrations.dataMessageIntegration;
					switch (this.integrationData.action) {
						case _constants.INTEGRATION.CALL_ACTION:
							if (this.integrationData.callAction === _constants.INTEGRATION.UPDATE_DATA_CALL) {
								var tempArray = this.state.dataCells;
								tempArray.map(function (item, i) {
									item.text = _this2.integrationData.data[i];
								});
								this.setState({ dataCells: tempArray });
								this.updateInfo();
							}
							break;
						case _constants.INTEGRATION.EXIT_ASSISTED_MODE:
							this.exitAssistedMode();
							break;
						default:
							break;
					}
				}
	
				if (nextProps.sipClientActions.actionType === _constants.SIP_CLIENT_ACTIONS.HANGUP) {
					this.updateInfo();
				}
			}
		}, {
			key: 'setDataCells',
			value: function setDataCells(dataCellList) {
				if (dataCellList) {
					var tempArray = this.state.dataCells;
					tempArray.map(function (item) {
						return item.text === dataCellList[item.index] ? dataCellList[item.index] : item.text;
					});
					this.setState({ dataCells: tempArray, isChange: true });
				}
			}
		}, {
			key: 'updateCallKey',
			value: function updateCallKey(callkey) {
				this.props.dataCall.CalKey = callkey;
			}
		}, {
			key: 'getExtraClass',
			value: function getExtraClass(index) {
				var text = index >= 0 ? this.state.dataCells[index].text : this.state.callkey;
				var isFocus = index >= 0 ? this.state.dataCells[index].focus : this.state.cellKeyFocus;
				if (isFocus) {
					return index >= 0 ? ' cellFocus' : this.props.typeCall + 'Focus';
				}
				if (text) {
					return index >= 0 ? ' cellText' : this.props.typeCall + 'Text';
				}
				return index >= 0 ? ' cellNormal' : this.props.typeCall + 'Normal';
			}
		}, {
			key: 'renderInfoCells',
			value: function renderInfoCells() {
				var _this3 = this;
	
				var disableField = false;
	
				if (this.props.iconCall && this.props.iconCall.EditableContactData != null) {
					disableField = !this.props.iconCall.EditableContactData;
				} else {
					disableField = this.props.dataCall.CallType === 1 && this.props.iconCall && !this.props.iconCall.CanReprogram || this.state.userState.currentState === _constants.USER_STATE.OTHER;
				}
	
				return this.state.dataCells.map(function (item) {
					return _react2.default.createElement(
						'li',
						{ className: 'infoDataClientCell ' + (disableField ? 'infoDataClientCellDis' : '') + _this3.getExtraClass(item.index), key: 'cell' + item.index },
						_react2.default.createElement(
							'p',
							{ className: 'countCells' },
							item.index + 1
						),
						_react2.default.createElement(_reactAutosizeTextarea2.default, {
							disabled: disableField,
							className: 'txtDataClientCell ' + (disableField ? 'disabled' : ''),
							maxLength: 250,
							defaultValue: item.text,
							placeholder: _this3.language.getText('CallControlGUIContactDatanode') + ' ' + (item.index + 1),
							onFocus: function onFocus() {
								return _this3.focusElement(item.index);
							},
							onBlur: function onBlur(event) {
								return _this3.unFocusElement(item.index, event.target.value);
							},
							onKeyPress: function onKeyPress(event) {
								return _this3.OnKeyPressEvent(item.index, event);
							}
						})
					);
				});
			}
		}, {
			key: 'unFocusElement',
			value: function unFocusElement(index, dataValue) {
				var tempArray = this.state.dataCells;
				if (index >= 0) {
					tempArray[index].focus = false;
					tempArray[index].text = dataValue;
				}
			}
		}, {
			key: 'updateInfoCell',
			value: function updateInfoCell(dataCallArrary, callKey) {
				var dataCallObj = this.props.dataCall;
				dataCallObj.DataContact = dataCallArrary;
				dataCallObj.CalKey = callKey;
				this.props.saveDataCall(dataCallObj);
			}
		}, {
			key: 'addingCallKey',
			value: function addingCallKey(e) {
				(0, _Validations.validateCallKey)(e);
			}
		}, {
			key: 'exitAssistedMode',
			value: function exitAssistedMode() {
				this.props.messageChangeState();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this4 = this;
	
				var id = this.props.dataCall.CallId ? this.props.dataCall.CallId : this.props.extraDataCall.CallId;
				var extraClass = !this.props.editableCallKey ? 'disabled' : this.getExtraClass(-1);0;
				var showDataClient = (this.props.userState.currentState === _constants.USER_STATE.DIALOG || this.props.userState.currentState === _constants.USER_STATE.OTHER && this.props.showDataBySetting && this.props.extraDataCall.AgentXfer) && this.sharedData.getDataPreviewPro().dialingMode == 0;
				var callKey = this.props.userState.currentState === _constants.USER_STATE.OTHER ? this.props.extraDataCall.CalKey : this.state.callkey;
				return _react2.default.createElement(
					'div',
					{ className: 'callWindowContainer' },
					this.sharedData.getCurrentState().toUpperCase() !== _constants.USER_STATE.ASSISTED && _react2.default.createElement(
						'div',
						{ className: 'infoCallContainer' },
						_react2.default.createElement(
							'p',
							{ className: 'txtIdCall' },
							this.language.getText('CallControlid') + ':' + Math.abs(id)
						),
						_react2.default.createElement(
							'p',
							{ className: 'txtDNISCall' },
							_react2.default.createElement(
								'b',
								null,
								this.props.dataCall.CallType === 1 || this.props.dataCall.CallType === 1 && this.props.userState.currentState === _constants.USER_STATE.OTHER ? this.language.getText('CallControldnis') + ':' : ''
							),
							this.props.userState.currentState === _constants.USER_STATE.OTHER ? this.props.extraDataCall.DNIS : this.props.dataCall.DNIS
						)
					),
					this.sharedData.getDataPreviewPro().dialingMode === 1 && this.props.previewActions.showData && _react2.default.createElement(_ContainerDataPreview2.default, {
						data: this.props.preview.data,
						headers: this.state.userState.currentState === _constants.USER_STATE.OTHER ? this.props.preview.headers : this.props.preview.record.DataHeaders,
						updateDataCallPreview: this.updateDataCallPreview,
						userState: this.state.userState.currentState,
						callKey: this.props.preview.callKey,
						disableInput: !this.props.preview.permissionUpdate //{this.state.updatePvwData}
					}),
					showDataClient && _react2.default.createElement(
						'div',
						{ className: 'dataClient' },
						_react2.default.createElement(
							'div',
							{ className: 'dataClientTitle' },
							this.language.getText('CallControlGUIContactDatatitle')
						),
						_react2.default.createElement(
							'div',
							{ className: 'infoDataClientContainer ' + extraClass },
							_react2.default.createElement('img', { className: 'callKeyIcon', src: _Images.callIcon, alt: 'icon' }),
							_react2.default.createElement('div', { className: 'separatorIcon' }),
							_react2.default.createElement('input', {
								type: 'text',
								className: 'txtDataClient',
								defaultValue: callKey,
								placeholder: this.language.getText('GUICallSpacecallkey'),
								onFocus: function onFocus() {
									return _this4.focusElement(-1);
								},
								onBlur: function onBlur(event) {
									return _this4.unFocusElement(-1, event.target.value);
								},
								readOnly: !this.props.editableCallKey,
								maxLength: _constants.CALL_KEY_MAX_LENGHT,
								onKeyPress: this.OnKeyPressEventCallKey,
								onChange: function onChange(event) {
									_this4.updateCallKey(event.target.value);
								}
							})
						),
						_react2.default.createElement(
							'ul',
							{ className: 'infoDataClientScroll' },
							_react2.default.createElement(
								'div',
								null,
								this.renderInfoCells()
							)
						),
						_react2.default.createElement(
							'p',
							{ className: 'buttonChangeInfo ' + (this.props.iconCall && !this.props.iconCall.EditableContactData ? 'disabled' : ''), onClick: this.updateInfo },
							this.language.getText('CallControlGUIContactDatabuttom')
						)
					),
					this.state.userState.currentState === _constants.USER_STATE.ASSISTED && this.sharedData.getIsEnableBtnExitAssited() === true && _react2.default.createElement(
						'div',
						{ className: 'callWindowBtn' },
						_react2.default.createElement(
							'div',
							{ className: 'buttonExitAssited' },
							_react2.default.createElement(
								_globalComponentsLibrary.Button,
								{ id: 'BtnExitAssited', onClick: function onClick() {
										return _this4.exitAssistedMode();
									} },
								_react2.default.createElement('i', { id: 'IconAssistedNegation', className: 'gcl-icon assisted-negation' }),
								_react2.default.createElement(
									'p',
									null,
									this.language.getText('GUIAssistedCallexitAssisted')
								)
							)
						)
					)
				);
			}
		}]);
	
		return CallWindow;
	}(_react.Component);
	
	function mapStateToProps(state) {
		return {
			sipClientActions: state.sipClientActions,
			userState: state.userState,
			messagesIntegrations: state.messagesIntegrations,
			preview: state.preview,
			previewActions: state.previewActions,
			showDataBySetting: state.transferReducer.showDataBySetting
		};
	}
	
	function mapDispatchToProps(dispatch) {
		return {
			updateInfoCall: function updateInfoCall(callKey_A, camID_A, phoneNumber_A, dataUsers_A, callOutId_A) {
				dispatch((0, _A_messages_to_SM.updateInfoCall)(callKey_A, camID_A, phoneNumber_A, dataUsers_A, callOutId_A));
			},
			messageChangeState: function messageChangeState() {
				dispatch((0, _A_messages_to_SM.messageChangeState)());
			}
		};
	}
	
	exports.default = CallWindow = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CallWindow);

/***/ },
/* 1088 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CallHeaderPreview = __webpack_require__(496);
	
	var _CallHeaderPreview2 = _interopRequireDefault(_CallHeaderPreview);
	
	var _globalComponentsLibrary = __webpack_require__(28);
	
	var _Singleton = __webpack_require__(21);
	
	var _ContainerDataPreview = __webpack_require__(237);
	
	var _ContainerDataPreview2 = _interopRequireDefault(_ContainerDataPreview);
	
	var _constants = __webpack_require__(10);
	
	var _A_messages_to_SM = __webpack_require__(32);
	
	var _A_preview = __webpack_require__(52);
	
	var _reactRedux = __webpack_require__(25);
	
	var _formats = __webpack_require__(54);
	
	var _DialingLogPreview = __webpack_require__(502);
	
	var _DialingLogPreview2 = _interopRequireDefault(_DialingLogPreview);
	
	var _singletonSharedData = __webpack_require__(23);
	
	var _CallWindowSimultaneosPreview = __webpack_require__(1106);
	
	var _CallWindowSimultaneosPreview2 = _interopRequireDefault(_CallWindowSimultaneosPreview);
	
	var _cwGalateaApiJsBundle = __webpack_require__(40);
	
	var _Logger = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	;
	
	
	var language = new _Singleton.Singleton();
	var sharedData = new _singletonSharedData.SingletonSharedData();
	var APIFact = new _cwGalateaApiJsBundle.APIFactory();
	var apiCont = APIFact.buildClient();
	
	var CallWindowPreview = function CallWindowPreview(_ref) {
	  var userState = _ref.userState,
	      fillAlertPreviewModal = _ref.fillAlertPreviewModal,
	      dataCall = _ref.dataCall;
	
	  var _useState = (0, _react.useState)(true),
	      _useState2 = _slicedToArray(_useState, 2),
	      isRunning = _useState2[0],
	      setIsRunning = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(''),
	      _useState4 = _slicedToArray(_useState3, 2),
	      phoneToCall = _useState4[0],
	      setPhoneToCallS = _useState4[1];
	
	  var record = (0, _reactRedux.useSelector)(function (state) {
	    return state.preview;
	  });
	  var dataContact = (0, _reactRedux.useSelector)(function (state) {
	    return state.preview.data;
	  });
	  var totalPreviewTime = (0, _reactRedux.useSelector)(function (state) {
	    return state.preview.totalPreviewTime;
	  });
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
	    return state.preview;
	  }),
	      simultaneosRecs = _useSelector.simultaneosRecs;
	
	  (0, _react.useEffect)(function () {
	    setPhoneToCallS(record.phoneToCall);
	    dispatch((0, _A_preview.setIsRunningClock)(true));
	  }, []);
	
	  (0, _react.useEffect)(function () {
	    var run = userState !== _constants.USER_STATE.CALL_OUT;
	    isRunning !== run && setIsRunning(run);
	  }, [userState]);
	
	  var actionCall = function actionCall() {
	    dispatch((0, _A_preview.setIsRunningClock)(false));
	    callPreview(phoneToCall);
	  };
	
	  var callPreview = function callPreview(phoneToCall) {
	    var time = (0, _formats.getCurrentTimeInSec)();
	    dispatch((0, _A_preview.saveTotalPreviewTime)(time));
	    var data = {
	      CamId: record.camId, CallKey: record.callKey,
	      Phone: phoneToCall, Data: "", ExistsCallout: 0, CallMode: 0, integration: false
	    };
	    dispatch((0, _A_preview.setPhoneToCall)(phoneToCall));
	    dispatch((0, _A_messages_to_SM.manualCall)(data));
	  };
	  var discart = function discart() {
	    var timeout = sharedData.getRequestTimeout();
	    var userId = sharedData.getParameters().UserID;
	    var objectResponseTransfer = apiCont.getObjectResponse();
	
	    apiCont.transferCall(userId, null, objectResponseTransfer, timeout);
	    objectResponseTransfer.onError = function (messageError) {
	      _Logger.Logger.Error('[CallWindowPreview][discard]', messageError);
	    };
	    objectResponseTransfer.onSuccess = function (objectResponseTransfer) {
	
	      sharedData.setAgentList(objectResponseTransfer.AgentesList);
	    };
	    var time = (0, _formats.getCurrentTimeInSec)();
	    var previewTime = time - record.initialTimeSec + totalPreviewTime;
	    dispatch((0, _A_messages_to_SM.actionPreviewRecord)({ process: 0, camId: record.camId, callOutId: record.callOutId, previewTime: previewTime, callId: 0 }));
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'cwp-callSpacePreview' },
	    simultaneosRecs ? _react2.default.createElement(_CallWindowSimultaneosPreview2.default, {
	      userState: userState,
	      dataCall: dataCall
	    }) : _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_CallHeaderPreview2.default, {
	        campaignName: record.campaignName,
	        iconCallFrame: record.iconCampaing,
	        callKey: record.callKey,
	        seconds: record.previewTime,
	        phones: record.phones,
	        isRunning: isRunning,
	        userState: userState,
	        setPhoneToCall: setPhoneToCallS
	      }),
	      _react2.default.createElement('div', { className: 'cwp-divisorLine' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'cwp-containerInformation' },
	        _react2.default.createElement(
	          'div',
	          { className: 'cwp-leftSide' },
	          _react2.default.createElement(
	            'div',
	            { className: 'cwp-btnContainer' },
	            record.previewDiscard && _react2.default.createElement(
	              'div',
	              { className: 'cwp-styleBtns' },
	              _react2.default.createElement(
	                _globalComponentsLibrary.AgentButton,
	                { type: 'secondary', color: 'blue', icon: 'discart', onClick: discart },
	                language.getText('GUIPreviewdiscard')
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'cwp-styleBtns' },
	              _react2.default.createElement(
	                _globalComponentsLibrary.AgentButton,
	                { type: 'primary', color: 'green', icon: 'call', onClick: actionCall },
	                language.getText('GUIPreviewdial')
	              )
	            ),
	            record.permissionDelete && _react2.default.createElement(
	              'div',
	              { className: 'cwp-styleBtns' },
	              _react2.default.createElement(
	                _globalComponentsLibrary.AgentButton,
	                { type: 'secondary', color: 'red', icon: 'trash', onClick: function onClick() {
	                    return fillAlertPreviewModal();
	                  } },
	                language.getText('GUIPreviewdelete')
	              )
	            )
	          ),
	          _react2.default.createElement(_ContainerDataPreview2.default, {
	            userState: userState,
	            data: dataContact,
	            headers: record.headers,
	            callKey: record.callKey,
	            disableInput: true
	          })
	        ),
	        _react2.default.createElement(_DialingLogPreview2.default, { callOutId: record.callOutId, camId: record.camId, userId: sharedData.getParameters().UserID })
	      )
	    )
	  );
	};
	
	exports.default = CallWindowPreview;

/***/ },
/* 1089 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Singleton = __webpack_require__(21);
	
	var _Images = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HeaderAssisted = function HeaderAssisted(_ref) {
	    var campaignName = _ref.campaignName,
	        iconCallFrame = _ref.iconCallFrame,
	        callKey = _ref.callKey;
	
	    var language = new _Singleton.Singleton();
	    return _react2.default.createElement(
	        'div',
	        { className: 'callWindowHeaderAssisted' },
	        _react2.default.createElement(
	            'div',
	            { className: 'campaingAssistedIcon' },
	            _react2.default.createElement('img', { className: 'iconCallImageA', src: _Images.outBoundCall, alt: 'icon' }),
	            _react2.default.createElement('img', { className: 'iconCallImageA iconPaddingA', src: iconCallFrame > 0 ? _Images.framesCamp[iconCallFrame] : '', alt: 'iconCallImage' })
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'Info' },
	            _react2.default.createElement(
	                'div',
	                { className: 'campaingAssistedNameA' },
	                _react2.default.createElement(
	                    'p',
	                    { className: 'campaignNameA' },
	                    campaignName
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'callKeyA' },
	                _react2.default.createElement(
	                    'p',
	                    { className: 'callKeyTitleA' },
	                    language.getText('GUICallSpacecallkey')
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'callKeyBodyA' },
	                    callKey
	                )
	            )
	        )
	    );
	};
	exports.default = HeaderAssisted;

/***/ },
/* 1090 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(25);
	
	var _Images = __webpack_require__(30);
	
	var _GenericSVG = __webpack_require__(51);
	
	var _A_messages_to_SM = __webpack_require__(32);
	
	var _constants = __webpack_require__(10);
	
	var _Singleton = __webpack_require__(21);
	
	var _Logger = __webpack_require__(37);
	
	var _Validations = __webpack_require__(131);
	
	var _SelectComponent = __webpack_require__(155);
	
	var _SelectComponent2 = _interopRequireDefault(_SelectComponent);
	
	var _DateTimeSelection = __webpack_require__(501);
	
	var _DateTimeSelection2 = _interopRequireDefault(_DateTimeSelection);
	
	var _TimerCountDown = __webpack_require__(326);
	
	var _TimerCountDown2 = _interopRequireDefault(_TimerCountDown);
	
	var _cwGalateaApiJsBundle = __webpack_require__(40);
	
	var _helperMessages = __webpack_require__(87);
	
	var _SingletonWebSocket = __webpack_require__(50);
	
	var _SingletonWebSocket2 = _interopRequireDefault(_SingletonWebSocket);
	
	var _singletonSharedData = __webpack_require__(23);
	
	var _A_Alert_Modal = __webpack_require__(63);
	
	var _A_Alert_Modal2 = _interopRequireDefault(_A_Alert_Modal);
	
	var _ContainerDataPreview = __webpack_require__(237);
	
	var _ContainerDataPreview2 = _interopRequireDefault(_ContainerDataPreview);
	
	var _globalComponentsLibrary = __webpack_require__(28);
	
	var _reactstrap = __webpack_require__(111);
	
	var _A_preview = __webpack_require__(52);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RateCall = function (_Component) {
	  _inherits(RateCall, _Component);
	
	  function RateCall(props) {
	    _classCallCheck(this, RateCall);
	
	    var _this2 = _possibleConstructorReturn(this, (RateCall.__proto__ || Object.getPrototypeOf(RateCall)).call(this, props));
	
	    _this2.saveDisposition = function () {
	      var messagesIntegrations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	      _this2.setState({ isReadyToSave: false });
	      _this2.sharedData.setIsRated(true);
	      var now = new Date();
	      var dif = now.getTime() - _this2.date.getTime();
	      var dispositionId = parseInt(_this2.state.selectedDisposition !== 0 ? _this2.state.selectedDisposition : _this2.iSelectedDisposition);
	      var exitAssistedMode = _this2.state.isExitAssistedState;
	      var dispositionSelected = null;
	      var permissionShowCalif = _this2.sharedData.getGeneralPermissions()[99];
	      if (Object.keys(_this2.state.rateList).length > 0) {
	        dispositionSelected = _this2.state.rateList.find(function (e) {
	          return e.Id == dispositionId;
	        });
	      } else if (_this2.props.dispositionListInformation && _this2.props.dispositionListInformation.Dispositions) {
	        dispositionSelected = Object.values(_this2.props.dispositionListInformation.Dispositions).find(function (e) {
	          return e.Id == dispositionId;
	        });
	      }
	      if (dispositionSelected) {
	        exitAssistedMode = dispositionSelected.FinishPreview;
	      }
	      _Logger.Logger.Trace('[RateCall] onSaveDisposition CallId \xB4' + _this2.state.dataCall.CallId + '\xB4 before \xB4' + (dif > 1000) + '\xB4');
	      if (dif > 1000 || _this2.integrationAction || messagesIntegrations) {
	        var objectData = {
	          CallId: Math.abs(_this2.state.dataCall.CallId),
	          DispositionId: dispositionId,
	          Origin: '',
	          CallKey: _this2.state.dataCall.CalKey,
	          CallOutId: _this2.state.dataCall.CallOutId,
	          SubId: _this2.state.selectedSubdisposition !== 0 ? _this2.state.selectedSubdisposition : _this2.iSelectedSubDisposition,
	          CallType: _this2.state.dataCall.CallType,
	          IsExitAssisted: exitAssistedMode,
	          IsExitPreview: _this2.state.isExitPreview
	
	        };
	        _this2.props.messageApiRequest(_constants.API_ENDPOINTS.SAVE_DISPOSITION, objectData);
	        var integrationMessage = { client: "galatea", data: objectData, action: "Disposition" };
	        _SingletonWebSocket2.default.send(integrationMessage);
	        _Logger.Logger.Debug("The SaveDisposition button was clicked by the agent!");
	        _Logger.Logger.Debug("saveDisposition:", messagesIntegrations);
	        if (_this2.state.dateReturned !== "" || messagesIntegrations && messagesIntegrations.subaction === _constants.INTEGRATION.RESCHEDULE_CALL_ACD) {
	          _this2.rescheduleCall(messagesIntegrations);
	        }
	        _this2.stChangeState = setTimeout(function () {
	          _Logger.Logger.Trace("saveDisposition currentState:" + _this2.state.currentState);
	          if (_this2.state.currentState === _constants.USER_STATE.WRAPUP) {
	            permissionShowCalif !== '2' && _this2.props.messageChangeState();
	          } else {
	            _this2.props.messageToStateMachine((0, _helperMessages.messageNotifyAlreadyWrapUp)());
	          }
	        }, 1000);
	        setTimeout(function () {
	          _this2.setState({ isReadyToSave: true, isExitAssistedState: exitAssistedMode });
	        }, 3000);
	        _this2.props.onDispositionButton();
	      }
	    };
	
	    _this2.OnKeyPressEvent = function (e) {
	      var r = /[!¡@#$%^&*()_+\-=\[\]{};':"\\|¬´°¨,.<>\/?]+$/;
	      if (e.charCode !== 8) {
	        if (r.test(String.fromCharCode(e.charCode))) {
	          e.preventDefault();
	        }
	      }
	    };
	
	    _this2.updateDataCallPreview = function (data) {
	      _this2.props.updateInfoCall(data.callKey, data.camID, data.newData, data.callOutId);
	    };
	
	    _this2.language = new _Singleton.Singleton();
	    _this2.state = {
	      selectionReschedule: 1,
	      otherPhoneReschedule: "",
	      dateReturned: "",
	      timeReturned: "",
	      showWindowSelectDate: false,
	      isReadyToSave: false,
	      rateList: {},
	      numbersList: [],
	      subRateList: {},
	      callbackDays: {},
	      currentState: _this2.props.userState,
	      selectedDisposition: 0,
	      selectedSubdisposition: 0,
	      dataCall: props.dataCall,
	      canReprogram: false,
	      displayedComponent: -1,
	      selectedPhoneItem: null,
	      withOutDisposition: false,
	      isExitAssistedState: false,
	      disabledBtnSaveDataPreview: true,
	      isExitPreview: false,
	      newDataPreview: { disabledUpdate: true, newArray: [] },
	      isDisabled: false
	    };
	    _this2.selectDate = false;
	    _this2.iSelectedDisposition = 0;
	    _this2.iSelectedSubDisposition = 0;
	    _this2.CampaignCallBacks = [];
	    _this2.arrayDispositions = {};
	    _this2.arrayOnlyNums = {};
	    _this2.errorOnPhoneNumberList = false;
	    _this2.messageErrorNumberList = null;
	    _this2.arrayNumsId = {};
	    _this2.integrationAction = _this2.props.integrationAction;
	    var APIFact = new _cwGalateaApiJsBundle.APIFactory();
	    _this2.sharedData = new _singletonSharedData.SingletonSharedData();
	    _this2.apiCont = APIFact.buildClient();
	    _this2.date = new Date();
	    _this2.stChangeState = null;
	    _this2.attempts = 0;
	    _this2.isPreview = _this2.sharedData.getDataPreviewPro().dialingMode === 1;
	    _this2.integrationData = null;
	    return _this2;
	  }
	
	  _createClass(RateCall, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.setNewPreviewTime(this.props.preview.initPreviewTime);
	      if (this.props.dispositionListInformation) {
	        this.processInformation(this.props.dispositionListInformation);
	      } else if (this.props.dispositionListError) {
	        this.processError(this.props.dispositionListError);
	      }
	    }
	  }, {
	    key: 'processInformation',
	    value: function processInformation(objResponse) {
	      var _this3 = this;
	
	      _Logger.Logger.Trace("[RateCall] ProcessInformation Begin ");
	      this.errorOnPhoneNumberList = false;
	      this.arrayDispositions = Object.keys(objResponse.Dispositions).map(function (i) {
	        return objResponse.Dispositions[i];
	      });
	      this.arrayDispositions.sort(function (a, b) {
	        return a.Orden - b.Orden;
	      });
	
	      if (objResponse.CampaignCallBacks) {
	        this.CampaignCallBacks = objResponse.CampaignCallBacks;
	      }
	
	      var arraySub = this.arrayDispositions[0] ? Object.keys(this.arrayDispositions[0].SubDisposition).map(function (i) {
	        return _this3.arrayDispositions[0].SubDisposition[i];
	      }) : {};
	      var arrayDispositions = [];
	      for (var disposition in objResponse.Dispositions) {
	        arrayDispositions.push(objResponse.Dispositions[disposition]);
	      }
	      arrayDispositions.sort(function (a, b) {
	        return a.Orden - b.Orden;
	      });
	      this.setState({
	        rateList: this.arrayDispositions,
	        isReadyToSave: this.arrayDispositions.length === 1 && arraySub.length === 0,
	        withOutDisposition: this.arrayDispositions.length === 0
	      });
	      var arrayCallBackDays = Object.keys(objResponse.CallBacksDays).map(function (i) {
	        return objResponse.CallBacksDays[i];
	      });
	      this.setState({ callbackDays: arrayCallBackDays });
	
	      var arrayNums = Object.keys(objResponse.Numbers).map(function (i) {
	        return objResponse.Numbers[i];
	      });
	      this.arrayNumsId = {};
	      this.arrayOnlyNums = {};
	      this.arrayNumsId = arrayNums.map(function (item) {
	        return { number: item.Phone, id: item.Graphic };
	      });
	      if (arrayNums.length === 0) {
	        this.setState({
	          numbersList: [{ img: _Images.reprogramacion1, number: this.state.dataCall.Phone, id: 1 }],
	          selectedPhoneItem: { img: _Images.reprogramacion1, number: this.state.dataCall.Phone, id: 1 }
	        });
	        this.arrayOnlyNums = [this.state.dataCall.Phone];
	      } else {
	        this.arrayOnlyNums = Object.keys(arrayNums).map(function (i) {
	          return arrayNums[i].Phone;
	        });
	        var imagesNumber = { "1": _Images.reprogramacion1, "2": _Images.reprogramacion2, "3": _Images.reprogramacion3, "4": _Images.reprogramacion4, "5": _Images.reprogramacion5 };
	        arrayNums = arrayNums.map(function (item) {
	          return { img: imagesNumber[item.Graphic], number: item.Phone, id: item.Graphic };
	        });
	        arrayNums = arrayNums.filter(function (item) {
	          return item.number !== "";
	        });
	        this.setState({ numbersList: arrayNums, selectedPhoneItem: arrayNums[0] });
	      }
	      switch (this.integrationAction) {
	        case _constants.INTEGRATION.GET_DISPOSITIONS_AND_NUMBERS:
	          this.onDispositionsAndNumbers();
	          this.props.resetIntegrationAction();
	          this.props.onDispositionButton();
	          break;
	        case _constants.INTEGRATION.GET_PHONE_NUMBERS:
	          this.onNumbers();
	          this.props.resetIntegrationAction();
	          this.props.onDispositionButton();
	          break;
	        case _constants.INTEGRATION.GET_CAMPAIGN_DISPOSITIONS:
	        case _constants.INTEGRATION.GET_ACD_DISPOSITIONS:
	        case _constants.INTEGRATION.GET_DISPOSITIONS:
	          var integrationMessage = { client: "galatea", data: this.arrayDispositions, action: "Disposition", subaction: "onDispositions" };
	          _SingletonWebSocket2.default.send(integrationMessage);
	          this.props.resetIntegrationAction();
	          this.props.onDispositionButton();
	          break;
	        case _constants.INTEGRATION.DISPOSITION:
	        case _constants.INTEGRATION.SAVE_DISPOSITION:
	          this.saveDispositionFromIntegration(this.props.messagesIntegrations.dataMessageIntegration);
	          this.props.resetIntegrationAction();
	          break;
	        default:
	          break;
	      }
	      _Logger.Logger.Trace("[RateCall] ProcessInformation End");
	    }
	  }, {
	    key: 'processError',
	    value: function processError(messageError) {
	      var type = messageError.Type;
	      var code = messageError.InternalCode;
	      var error = this.language.getText(type.toLowerCase() + '-' + code);
	      this.errorOnPhoneNumberList = true;
	      var integrationMessage = { client: "galatea", data: { code: code, message: error }, action: "errorOnDispositionList" };
	      _SingletonWebSocket2.default.send(integrationMessage);
	      integrationMessage = { client: "galatea", data: { code: code, message: error }, action: "errorOnDispositionSelected" };
	      _SingletonWebSocket2.default.send(integrationMessage);
	      integrationMessage = { client: "galatea", data: { code: code, message: error }, action: "errorOnDispositionsPhonesList" };
	      _SingletonWebSocket2.default.send(integrationMessage);
	      this.messageErrorNumberList = { code: code, message: error };
	      if (this.integrationAction && this.integrationAction === _constants.INTEGRATION.GET_PHONE_NUMBERS) {
	        this.onNumbers();
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.dispositionListInformation && nextProps.dispositionListInformation !== this.props.dispositionListInformation) {
	        this.processInformation(nextProps.dispositionListInformation);
	      } else if (nextProps.dispositionListError && nextProps.dispositionListError !== this.props.dispositionListError) {
	        this.processError(nextProps.dispositionListError);
	      }
	      this.setState({
	        currentState: nextProps.userState,
	        dataCall: nextProps.dataCall
	      });
	      if (nextProps.messagesIntegrations.dataMessageIntegration) {
	        switch (nextProps.messagesIntegrations.dataMessageIntegration.action) {
	          case _constants.INTEGRATION.CALL_ACTION:
	            if (nextProps.messagesIntegrations.dataMessageIntegration.callAction === _constants.INTEGRATION.GET_DISPOSITIONS_AND_NUMBERS) {
	              this.onDispositionsAndNumbers();
	            } else if (nextProps.messagesIntegrations.dataMessageIntegration.callAction === _constants.INTEGRATION.GET_PHONE_NUMBERS) {
	              this.onNumbers();
	            }
	            break;
	          case _constants.INTEGRATION.GET_CAMPAIGN_DISPOSITIONS:
	          case _constants.INTEGRATION.GET_ACD_DISPOSITIONS:
	          case _constants.INTEGRATION.GET_DISPOSITIONS:
	            var integrationMessage = { client: "galatea", data: this.arrayDispositions, action: "Disposition", subaction: "onDispositions" };
	            _SingletonWebSocket2.default.send(integrationMessage);
	            break;
	          case _constants.INTEGRATION.DISPOSITION:
	          case _constants.INTEGRATION.SAVE_DISPOSITION:
	            this.saveDispositionFromIntegration(nextProps.messagesIntegrations.dataMessageIntegration);
	            this.props.resetIntegrationAction();
	            break;
	          default:
	            break;
	        }
	      }
	    }
	  }, {
	    key: 'selectReschedule',
	    value: function selectReschedule(selection) {
	      this.setState({
	        selectionReschedule: selection,
	        otherPhoneReschedule: selection === 1 ? "" : this.state.otherPhoneReschedule
	      });
	    }
	  }, {
	    key: 'showHideCalendar',
	    value: function showHideCalendar(evt, showedCalendar) {
	      this.setState({ showWindowSelectDate: showedCalendar });
	      evt.stopPropagation();
	    }
	  }, {
	    key: 'saveDispositionFromIntegration',
	    value: function saveDispositionFromIntegration(dataMessageIntegration) {
	      if (!isNaN(dataMessageIntegration.DispositionId)) {
	        var _this = this;
	        _Logger.Logger.Trace("receiving-----", dataMessageIntegration.DispositionId);
	        _this.iSelectedDisposition = dataMessageIntegration.DispositionId;
	        _this.iSelectedSubDisposition = dataMessageIntegration.SubId;
	        var dispositionExists = _this.iSelectedDisposition in this.props.dispositionListInformation.Dispositions;
	        var arraySubDisposition = dispositionExists ? this.props.dispositionListInformation.Dispositions[_this.iSelectedDisposition].SubDisposition : [];
	        var canReprogram = dispositionExists ? arraySubDisposition[_this.iSelectedSubDisposition] ? arraySubDisposition[_this.iSelectedSubDisposition].CanReprogram : this.props.dispositionListInformation.Dispositions[_this.iSelectedDisposition].CanReprogram : false;
	        if (!canReprogram) {
	          _this.saveDisposition();
	        } else {
	          if (dataMessageIntegration.subaction === _constants.INTEGRATION.RESCHEDULE_CALL_ACD) {
	            _this.onReprogramCall();
	            _this.saveDisposition(dataMessageIntegration);
	          }
	        }
	      }
	    }
	  }, {
	    key: 'rescheduleCall',
	    value: function rescheduleCall() {
	      var messagesIntegrations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	      var objCallBack = void 0;
	      if (messagesIntegrations && messagesIntegrations.subaction === _constants.INTEGRATION.RESCHEDULE_CALL_ACD) {
	        var arrayNums = this.arrayNumsId.filter(function (item) {
	          return item.number === messagesIntegrations.TelReprograma;
	        });
	        objCallBack = {
	          CamId: messagesIntegrations.CamId,
	          Phone: messagesIntegrations.TelReprograma,
	          TelReprograma: arrayNums[0] ? arrayNums[0].id =  true ? arrayNums[0].id : 0 : 0,
	          IsAuto: false,
	          DateDial: messagesIntegrations.DateDial
	        };
	      } else {
	        var date = this.state.dateReturned + " " + this.state.timeReturned;
	        var phone = this.state.selectionReschedule === 2 ? this.state.otherPhoneReschedule : this.state.selectedPhoneItem.number;
	        var telReprogram = this.state.dataCall.CallType === 1 ? 1 : this.state.selectionReschedule === 2 ? 0 : this.state.selectedPhoneItem.id;
	        objCallBack = {
	          CamId: this.state.dataCall.Id,
	          Phone: phone,
	          TelReprograma: telReprogram,
	          IsAuto: false,
	          DateDial: date
	        };
	      }
	      this.rescheduleCallRequest(objCallBack);
	    }
	  }, {
	    key: 'rescheduleCallRequest',
	    value: function rescheduleCallRequest(params) {
	      var _this = this;
	      setTimeout(function () {
	        _this.props.messageApiRequest(_constants.API_ENDPOINTS.CALL_BACK, params);
	      }, 500);
	      var integrationMessage = { client: "galatea", action: "Disposition", subaction: "onReprogramSuccess" };
	      _SingletonWebSocket2.default.send(integrationMessage);
	    }
	  }, {
	    key: 'selectRate',
	    value: function selectRate(item) {
	      var _this4 = this;
	
	      var index = this.state.rateList.findIndex(function (s) {
	        return s.Id === item.Id;
	      });
	      this.arraySubDisposition = Object.keys(this.state.rateList[index].SubDisposition).map(function (i) {
	        return _this4.state.rateList[index].SubDisposition[i];
	      });
	      this.arraySubDisposition.sort(function (a, b) {
	        return a.Orden - b.Orden;
	      });
	      var selectedSubdisposition = this.arraySubDisposition.length === 1 ? 0 : -1;
	      var canReprogram = this.arraySubDisposition[selectedSubdisposition] ? this.arraySubDisposition[selectedSubdisposition].CanReprogram : this.state.rateList[index].CanReprogram;
	      this.setState({
	        subRateList: this.arraySubDisposition,
	        selectedDisposition: item.Id,
	        selectedSubdisposition: this.arraySubDisposition.length === 1 ? 0 : -1,
	        canReprogram: canReprogram,
	        isReadyToSave: this.arraySubDisposition.length < 2,
	        isExitAssistedState: item.FinishPreview,
	        isExitPreview: item.FinishRecordPreview
	      });
	    }
	  }, {
	    key: 'selectSubRate',
	    value: function selectSubRate(item) {
	      this.setState({
	        selectedSubdisposition: item.Id,
	        canReprogram: item.CanReprogram,
	        isReadyToSave: true
	      });
	    }
	  }, {
	    key: 'displaying',
	    value: function displaying(compSelected) {
	      this.setState({ displayedComponent: compSelected });
	    }
	  }, {
	    key: 'dateSelected',
	    value: function dateSelected(date, time) {
	      this.setState({
	        showWindowSelectDate: false,
	        dateReturned: date,
	        timeReturned: time
	      });
	    }
	  }, {
	    key: 'onReprogramCall',
	    value: function onReprogramCall() {
	      var period = this.sharedData.getGeneralPermissions()[35];
	      var today = new Date();
	      var limit = new Date();
	      limit.setDate(limit.getDate() + parseInt(period, 10));
	      var callBacks = this.CampaignCallBacks.filter(function (data) {
	        return data.año == today.getFullYear() && data.mes == today.getMonth() + 1 && data.dia == today.getDate();
	      });
	      var message = {
	        callBacks: callBacks,
	        startDate: this.parseDate(today),
	        hasCallbacks: callBacks.length > 0 ? true : false
	      };
	      var integrationMessage = { client: "galatea", data: message, action: "Disposition", subaction: "onReprogramCall" };
	      _SingletonWebSocket2.default.send(integrationMessage);
	    }
	  }, {
	    key: 'parseDate',
	    value: function parseDate(date) {
	      var year = date.getFullYear();
	      var month = ('0' + (date.getMonth() + 1)).slice(-2);
	      var day = ('0' + date.getDate()).slice(-2);
	      return year + "/" + month + "/" + day;
	    }
	  }, {
	    key: 'parseTime',
	    value: function parseTime(time) {
	      var hours = time.getHours();
	      var minutes = ('0' + time.getMinutes()).slice(-2);
	      var seconds = ('0' + time.getSeconds()).slice(-2);
	      return hours + ":" + minutes + ":" + seconds;
	    }
	  }, {
	    key: 'onDispositionsAndNumbers',
	    value: function onDispositionsAndNumbers() {
	      var data = {
	        dispositions: this.arrayDispositions,
	        phoneNumbers: this.arrayOnlyNums
	      };
	      var integrationMessage = { client: "galatea", data: data, action: "Disposition", subaction: "onDispositionsAndNumbers" };
	      _SingletonWebSocket2.default.send(integrationMessage);
	    }
	  }, {
	    key: 'onNumbers',
	    value: function onNumbers() {
	      if (this.errorOnPhoneNumberList) {
	        var integrationMessage = { client: "galatea", data: this.messageErrorNumberList, action: "errorOnPhoneNumbersList" };
	        _SingletonWebSocket2.default.send(integrationMessage);
	      } else {
	        var _integrationMessage = { client: "galatea", data: this.arrayOnlyNums, action: "Disposition", subaction: "onPhoneNumbers" };
	        _SingletonWebSocket2.default.send(_integrationMessage);
	      }
	    }
	  }, {
	    key: 'onUpdateCallKey',
	    value: function onUpdateCallKey(callKey) {
	      if (callKey !== '' && this.props.dataCall.CalKey !== callKey) {
	
	        this.setState({ dataCall: Object.assign({}, this.state.dataCall, { CalKey: callKey }) });
	
	        var objectData = {
	          CallId: this.state.dataCall.CallId,
	          CallKey: callKey,
	          CallType: this.state.dataCall.CallType
	        };
	
	        this.props.messageApiRequest(_constants.API_ENDPOINTS.UPDATE_CALL_KEY, objectData);
	      }
	    }
	  }, {
	    key: 'getNormalWrapupWindow',
	    value: function getNormalWrapupWindow() {
	      var _this5 = this;
	
	      var styleForPreview = this.isPreview ? '_wrapup' : '';
	      var disabledOption = !this.props.editableCallKey ? 'disabled' : '';
	      return _react2.default.createElement(
	        'div',
	        { className: 'dataPreviewAndRate fullSize scroll' },
	        _react2.default.createElement(
	          'div',
	          { className: 'callWindowContainer ' + styleForPreview, onClick: function onClick(e) {
	              return _this5.showHideCalendar(e, false);
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'rateCallWindow' },
	            this.state.currentState === _constants.USER_STATE.WRAPUP && _react2.default.createElement(_TimerCountDown2.default, {
	              showingTimer: this.state.currentState === _constants.USER_STATE.WRAPUP,
	              timeToRate: this.props.dispositionTime,
	              lineWidth: 6,
	              colorDown: "#FFB427",
	              colorUp: "#BA5D00",
	              size: 60,
	              fontsize: "one",
	              onTimesUp: function onTimesUp() {
	                _this5.props.messageChangeState();
	              }
	            }),
	            _react2.default.createElement(
	              'p',
	              { className: 'titleRateCall' },
	              this.language.getText("CallControlcallCalificationtitle")
	            ),
	            Object.keys(this.state.rateList).length > 0 && _react2.default.createElement(
	              'div',
	              null,
	              !this.isPreview && _react2.default.createElement(
	                'div',
	                { className: 'rateCallFirstContainer' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'rateCallCallKeyOption ' + disabledOption },
	                  _react2.default.createElement('img', { className: 'callKeyIcon', src: _Images.callIcon, alt: 'icon' }),
	                  _react2.default.createElement('div', { className: 'separatorIcon' }),
	                  _react2.default.createElement('input', {
	                    type: 'text',
	                    className: 'txtDataClient',
	                    defaultValue: this.props.dataCall.CalKey,
	                    placeholder: this.language.getText('GUICallSpacecallkey'),
	                    readOnly: !this.props.editableCallKey,
	                    maxLength: 40,
	                    onKeyPress: this.OnKeyPressEvent,
	                    onBlur: function onBlur(event) {
	                      return _this5.onUpdateCallKey(event.target.value);
	                    }
	                  })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'rateCallIconInfo' },
	                  _react2.default.createElement('i', { 'class': 'gcl-icon info', id: 'idTooltip' }),
	                  _react2.default.createElement(
	                    _reactstrap.UncontrolledTooltip,
	                    { placement: 'top-start', target: 'idTooltip', hideArrow: true, className: 'gcl-labelInput-tooltip' },
	                    this.language.getText('CallControlcallCalificationcall-key-tooltip1') + '\n' + this.language.getText('CallControlcallCalificationcall-key-tooltip2')
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'rateCallContainer' },
	                _react2.default.createElement(_globalComponentsLibrary.SearchSelectionAgent, { options: this.state.rateList, noDefault: true, sort: true, ignoreCase: true, placeholder: this.language.getText("CallControlCRMxcontrolsselectAnOption"), filterBy: 'Description', onSelected: function onSelected(item) {
	                    return _this5.selectRate(item);
	                  } })
	              ),
	              Object.keys(this.state.subRateList).length > 0 && _react2.default.createElement(
	                'div',
	                { className: 'rateCallContainer' },
	                _react2.default.createElement(_globalComponentsLibrary.SearchSelectionAgent, { noDefault: true, sort: true, ignoreCase: true, options: this.state.subRateList, placeholder: this.language.getText("CallControlCRMxcontrolsselectAnOption"), filterBy: 'Description', onSelected: function onSelected(item) {
	                    return _this5.selectSubRate(item);
	                  } })
	              )
	            )
	          ),
	          this.state.canReprogram && _react2.default.createElement(
	            'div',
	            { className: 'rescheduleWindow' },
	            _react2.default.createElement(
	              'div',
	              { className: 'rescheduleSelector' },
	              _react2.default.createElement('div', { className: "rescheduleRadioButton" + (this.state.selectionReschedule === 1 ? " active" : " inactive"), onClick: function onClick() {
	                  return _this5.selectReschedule(1);
	                } }),
	              _react2.default.createElement(
	                'div',
	                { className: 'containerReschedule' },
	                _react2.default.createElement(_SelectComponent2.default, {
	                  disabled: this.state.selectionReschedule !== 1,
	                  bottomBox: 60,
	                  defaultDiv: { item: "texSelection" },
	                  displayer: "bigDisplayer",
	                  customCell: "cellImageText",
	                  parameters: { image: "img", text: "number" },
	                  dataSource: this.state.numbersList,
	                  closeOthers: true,
	                  itemDefault: 0,
	                  tag: "3",
	                  displayedList: this.state.displayedComponent,
	                  onDisplayList: function onDisplayList(compSelected) {
	                    return _this5.displaying(compSelected);
	                  },
	                  onSelectItem: function onSelectItem(itemSelected) {
	                    return _this5.setState({ selectedPhoneItem: itemSelected });
	                  } })
	              )
	            ),
	            _react2.default.createElement('div', { className: 'breakLine' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'rescheduleSelector' },
	              _react2.default.createElement('div', { className: "rescheduleRadioButton" + (this.state.selectionReschedule === 2 ? " active" : " inactive"), onClick: function onClick() {
	                  return _this5.selectReschedule(2);
	                } }),
	              _react2.default.createElement('input', { type: 'text',
	                placeholder: this.language.getText("GUISearchWindowphoneNum"),
	                disabled: this.state.selectionReschedule === 1,
	                className: "otherPhoneReschedule" + (this.state.selectionReschedule === 2 ? " active" : " inactive"),
	                value: this.state.otherPhoneReschedule,
	                onChange: function onChange(event) {
	                  _this5.setState({ otherPhoneReschedule: event.target.value });
	                },
	                onKeyPress: _Validations.validateOnlyNumbers })
	            ),
	            _react2.default.createElement('div', { className: 'breakLine' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'containerDate', onClick: function onClick(e) {
	                  return _this5.showHideCalendar(e, !_this5.state.showWindowSelectDate);
	                } },
	              _react2.default.createElement(
	                'div',
	                { className: 'timeReschedule dateReschedule' },
	                _react2.default.createElement('img', { className: 'iconDateReschedule', src: _Images.dateReschedule, alt: 'icon' }),
	                _react2.default.createElement(
	                  'p',
	                  { className: 'textDateReschedule' },
	                  this.state.dateReturned !== "" ? this.state.dateReturned : this.language.getText("CallControlcallCalificationdate")
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'timeReschedule' },
	                _react2.default.createElement('img', { className: 'iconDateReschedule', src: _Images.timeReschedule, alt: 'icon' }),
	                _react2.default.createElement(
	                  'p',
	                  { className: 'textDateReschedule' },
	                  this.state.timeReturned !== "" ? this.state.timeReturned : this.language.getText("CallControlcallCalificationhour")
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'arrowButton arrowOnly' },
	                _GenericSVG.triangle
	              )
	            )
	          ),
	          this.state.showWindowSelectDate && _react2.default.createElement(
	            'div',
	            { className: 'dateTimeContainer ' + (this.isPreview ? "preview" : "") },
	            _react2.default.createElement(_DateTimeSelection2.default, {
	              onSelectDate: function onSelectDate(date, time) {
	                return _this5.dateSelected(date, time);
	              },
	              dataSource: this.state.callbackDays
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'rescheduleWindow' },
	            this.isPreview ? _react2.default.createElement(
	              'div',
	              { className: 'containerBtnsPreview ' },
	              _react2.default.createElement(
	                _globalComponentsLibrary.AgentButton,
	                { type: 'secondary', disabled: this.state.newDataPreview.disabledUpdate, onClick: function onClick() {
	                    return _this5.SendDataPreview();
	                  } },
	                this.language.getText("CallControlGUIContactDatabuttom")
	              ),
	              _react2.default.createElement(
	                _globalComponentsLibrary.AgentButton,
	                { type: 'primary', disabled: !this.state.isReadyToSave, onClick: function onClick() {
	                    return _this5.endWraUpWithDisp();
	                  } },
	                this.language.getText("CallControlCRMxcontrolssaveAllButton")
	              )
	            ) : _react2.default.createElement(
	              'div',
	              {
	                className: "buttonSave " + (this.state.isReadyToSave ? "" : "disabled"),
	                tabIndex: '4',
	                onClick: this.saveDisposition,
	                disabled: !this.state.isReadyToSave },
	              this.language.getText("CallControlCRMxcontrolssaveAllButton")
	            )
	          )
	        ),
	        this.isPreview && _react2.default.createElement(_ContainerDataPreview2.default, {
	          data: this.props.preview.data,
	          headers: this.props.preview.headers,
	          updateDataCallPreview: this.updateDataCallPreview,
	          userState: this.state.currentState,
	          callKey: this.props.preview.callKey,
	          onChangeData: function onChangeData(r) {
	            return _this5.setState({ newDataPreview: r });
	          },
	          disableInput: !this.props.preview.permissionUpdate
	        })
	      );
	    }
	  }, {
	    key: 'SendDataPreview',
	    value: function SendDataPreview() {
	      var temp = [].concat(_toConsumableArray(this.state.newDataPreview.newArray));
	      while (temp.length < 15) {
	        temp.push('');
	      };
	      var dataPrev = {
	        callKey: this.state.dataCall.CalKey,
	        camID: this.state.dataCall.Id,
	        newData: temp,
	        callOutId: 0
	      };
	      this.updateDataCallPreview(dataPrev);
	    }
	  }, {
	    key: 'SendRateAndData',
	    value: function SendRateAndData() {
	      var _this6 = this;
	
	      this.SendDataPreview();
	      setTimeout(function () {
	        return _this6.saveDisposition();
	      }, 2000);
	    }
	  }, {
	    key: 'endWraUpWithoutDisp',
	    value: function endWraUpWithoutDisp() {
	      var _this7 = this;
	
	      if (!this.state.newDataPreview.disabledUpdate) {
	        this.props.showAlertModal({
	          type: "ModalAlert",
	          title: this.language.getText("CallControlcallCalificationfinishWrapup"),
	          message: this.language.getText("GUIAlertMessageexitWrapUpMsgConfirmation"),
	          button: this.language.getText("GUIAlertMessagefinish-and-update-btn"),
	          secondButton: this.language.getText("GUIAlertMessagefinish-only-btn"),
	          buttonFun: function buttonFun() {
	            return _this7.SendDataAndExitWrapUp();
	          },
	          secondButtonFtn: function secondButtonFtn() {
	            return _this7.finishProblemWrapupTime();
	          }
	        });
	      } else {
	        this.finishProblemWrapupTime();
	      }
	    }
	  }, {
	    key: 'endWraUpWithDisp',
	    value: function endWraUpWithDisp() {
	      var _this8 = this;
	
	      if (!this.state.newDataPreview.disabledUpdate) {
	        this.props.showAlertModal({
	          type: "ModalAlert",
	          title: this.language.getText("CallControlcallCalificationsave-disposition-title"),
	          message: this.language.getText("GUIAlertMessageexitWrapUpMsgConfirmation"),
	          button: this.language.getText("CallControlcallCalificationsave-and-update-btn"),
	          secondButton: this.language.getText("CallControlcallCalificationsave-only-btn"),
	          buttonFun: function buttonFun() {
	            return _this8.SendRateAndData();
	          },
	          secondButtonFtn: function secondButtonFtn() {
	            return _this8.saveDisposition();
	          }
	        });
	      } else {
	        this.saveDisposition();
	      }
	    }
	  }, {
	    key: 'SendDataAndExitWrapUp',
	    value: function SendDataAndExitWrapUp() {
	      var _this9 = this;
	
	      this.SendDataPreview();
	      setTimeout(function () {
	        return _this9.props.messageToStateMachine((0, _helperMessages.messageAgentRedy)());
	      }, 3000);
	    }
	  }, {
	    key: 'finishProblemWrapupTime',
	    value: function finishProblemWrapupTime() {
	      this.props.messageToStateMachine((0, _helperMessages.messageChangeStateHelper)());
	    }
	  }, {
	    key: 'getProblemWrapupWindow',
	    value: function getProblemWrapupWindow() {
	      var _this10 = this;
	
	      {
	        return this.sharedData.getDataPreviewPro().dialingMode === 0 ? _react2.default.createElement(
	          'div',
	          { className: "rateUnefectiveCallWindow" },
	          _react2.default.createElement(_TimerCountDown2.default, {
	            showingTimer: this.state.currentState === _constants.USER_STATE.WRAPUP,
	            timeToRate: this.props.dispositionTime,
	            lineWidth: 6,
	            colorDown: "#FFB427",
	            colorUp: "#BA5D00",
	            size: 90,
	            fontsize: "one",
	            onOneSecondRemaining: function onOneSecondRemaining() {
	              return _this10.setState({ isDisabled: true });
	            } }),
	          _react2.default.createElement('div', { className: 'breakLine' }),
	          this.state.withOutDisposition === false && _react2.default.createElement(
	            'p',
	            { className: "titleUnefectiveCall" },
	            this.language.getText("CallControlcallCalificationineffectiveCallTitle")
	          ),
	          this.state.withOutDisposition === false && _react2.default.createElement(
	            'div',
	            { className: "textUnefectiveCall" },
	            this.language.getText("CallControlcallCalificationineffectiveCallMessage"),
	            ' '
	          ),
	          _react2.default.createElement('br', null),
	          this.state.currentState !== _constants.USER_STATE.OTHER && _react2.default.createElement(
	            'button',
	            {
	              className: "buttonUnefectiveCall",
	              tabIndex: '4',
	              onClick: function onClick() {
	                return _this10.finishProblemWrapupTime();
	              },
	              disabled: this.state.isDisabled },
	            this.language.getText("CallControlcallCalificationineffectiveCallBtn")
	          )
	        ) : _react2.default.createElement(
	          'div',
	          { className: 'dataPreviewAndRate' },
	          _react2.default.createElement(
	            'div',
	            { className: "rateCallWindowPreview" },
	            _react2.default.createElement(_TimerCountDown2.default, {
	              showingTimer: this.state.currentState === _constants.USER_STATE.WRAPUP,
	              timeToRate: this.props.dispositionTime,
	              lineWidth: 6,
	              colorDown: "#FFB427",
	              colorUp: "#BA5D00",
	              size: 60,
	              fontsize: "one" }),
	            _react2.default.createElement(
	              'div',
	              { className: 'containerBtnsPreview' },
	              _react2.default.createElement(
	                _globalComponentsLibrary.AgentButton,
	                { type: 'secondary', disabled: this.state.newDataPreview.disabledUpdate, onClick: function onClick() {
	                    return _this10.SendDataPreview();
	                  } },
	                this.language.getText("CallControlGUIContactDatabuttom")
	              ),
	              _react2.default.createElement(
	                _globalComponentsLibrary.AgentButton,
	                { type: 'primary', color: 'yellow', onClick: function onClick() {
	                    return _this10.endWraUpWithoutDisp();
	                  } },
	                this.language.getText("CallControlcallCalificationfinishWrapup")
	              )
	            )
	          ),
	          _react2.default.createElement(_ContainerDataPreview2.default, {
	            data: this.props.preview.data,
	            headers: this.props.preview.headers,
	            updateDataCallPreview: this.updateDataCallPreview,
	            userState: this.state.currentState,
	            callKey: this.props.preview.callKey,
	            onChangeData: function onChangeData(r) {
	              return _this10.setState({ newDataPreview: r });
	            },
	            disableInput: !this.props.preview.permissionUpdate
	          })
	        );
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.stChangeState);
	      var _state = this.state,
	          rateList = _state.rateList,
	          subRateList = _state.subRateList,
	          canReprogram = _state.canReprogram,
	          showWindowSelectDate = _state.showWindowSelectDate,
	          isReadyToSave = _state.isReadyToSave,
	          dataCall = _state.dataCall;
	
	      _Logger.Logger.Trace("[RateCall] stateValues:", {
	        CallId: dataCall.CallId,
	        rateList: Object.values(rateList),
	        subRateList: Object.values(subRateList),
	        canReprogram: canReprogram,
	        showWindowSelectDate: showWindowSelectDate,
	        isReadyToSave: isReadyToSave
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'conteinerCallSpace containerDataPreviewAndRate' },
	        this.props.problemInManualCall || this.state.withOutDisposition ? this.getProblemWrapupWindow() : this.getNormalWrapupWindow()
	      );
	    }
	  }]);
	
	  return RateCall;
	}(_react.Component);
	
	;
	
	function mapStateToProps(state) {
	  return {
	    messagesIntegrations: state.messagesIntegrations,
	    preview: state.preview
	  };
	}
	function mapDispatchToProps(dispatch) {
	  var _showAlertModal = _A_Alert_Modal2.default.creators.showAlertModal;
	
	  return {
	    messageToStateMachine: function messageToStateMachine(message) {
	      dispatch((0, _A_messages_to_SM.messageToStateMachine)(message));
	    },
	    messageApiRequest: function messageApiRequest(subaction, json) {
	      dispatch((0, _A_messages_to_SM.messageApiRequest)(subaction, json));
	    },
	    messageChangeState: function messageChangeState() {
	      dispatch((0, _A_messages_to_SM.messageChangeState)());
	    },
	    showAlertModal: function showAlertModal(payload) {
	      dispatch(_showAlertModal(payload));
	    },
	    updateInfoCall: function updateInfoCall(callKey_A, camID_A, phoneNumber_A, dataUsers_A, callOutId_A) {
	      dispatch((0, _A_messages_to_SM.updateInfoCall)(callKey_A, camID_A, phoneNumber_A, dataUsers_A, callOutId_A));
	    },
	    setNewPreviewTime: function setNewPreviewTime(time) {
	      dispatch((0, _A_preview.setNewPreviewTime)(time));
	    }
	  };
	}
	exports.default = RateCall = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(RateCall);

/***/ },
/* 1091 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _globalComponentsLibrary = __webpack_require__(28);
	
	var _react = __webpack_require__(1);
	
	var StopWatch = function StopWatch(_ref) {
	  var onChange = _ref.onChange,
	      running = _ref.running;
	
	  var _useStopWatchBasic = (0, _globalComponentsLibrary.useStopWatchBasic)(),
	      start = _useStopWatchBasic.start,
	      stop = _useStopWatchBasic.stop,
	      fullFormat = _useStopWatchBasic.fullFormat,
	      seconds = _useStopWatchBasic.seconds;
	
	  (0, _react.useEffect)(function () {
	    if (running) {
	      start();
	    } else {
	      stop();
	    }
	    return function () {
	      stop();
	    };
	  }, [running]);
	
	  (0, _react.useEffect)(function () {
	    onChange(fullFormat());
	  }, [seconds]);
	
	  return "";
	};
	
	exports.default = StopWatch;

/***/ },
/* 1092 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _NoAvailableComponent = __webpack_require__(499);
	
	var _NoAvailableComponent2 = _interopRequireDefault(_NoAvailableComponent);
	
	var _NoAvailableSVG = __webpack_require__(114);
	
	var _Singleton = __webpack_require__(21);
	
	var _customComponents = __webpack_require__(59);
	
	var _singletonSharedData = __webpack_require__(23);
	
	var _constants = __webpack_require__(10);
	
	var _Logger = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NoAvailableExpanded = function (_Component) {
	  _inherits(NoAvailableExpanded, _Component);
	
	  function NoAvailableExpanded(props) {
	    _classCallCheck(this, NoAvailableExpanded);
	
	    var _this = _possibleConstructorReturn(this, (NoAvailableExpanded.__proto__ || Object.getPrototypeOf(NoAvailableExpanded)).call(this, props));
	
	    _this.language = new _Singleton.Singleton();
	    _this.sharedData = new _singletonSharedData.SingletonSharedData();
	    _Logger.Logger.Trace("[NoAvailableExpanded] No Available Constructor => ");
	    return _this;
	  }
	
	  _createClass(NoAvailableExpanded, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      _Logger.Logger.Trace("[NoAvailableExpanded][componentWillUnmount] Removing No Available => ");
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: "WorkBarExpanded " + (this.sharedData.getWindowExpandedActive() !== _constants.DRAGGABLE_WINDOWS.NO_AVAILABLE ? "height0" : ""),
	          key: 'noAvailableExpanded' },
	        _customComponents.CUSTOM_COMPONENTS["sideBarHeader"](_NoAvailableSVG.noAvailableSVG, this.language.getText("GUICommonMenudisable")),
	        _react2.default.createElement(_NoAvailableComponent2.default, { floating: false })
	      );
	    }
	  }]);
	
	  return NoAvailableExpanded;
	}(_react.Component);
	
	exports.default = NoAvailableExpanded;

/***/ },
/* 1093 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _NoAvailableSVG = __webpack_require__(114);
	
	var _Singleton = __webpack_require__(21);
	
	var _NoAvailableRecordComponent = __webpack_require__(500);
	
	var _NoAvailableRecordComponent2 = _interopRequireDefault(_NoAvailableRecordComponent);
	
	var _customComponents = __webpack_require__(59);
	
	var _singletonSharedData = __webpack_require__(23);
	
	var _constants = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NoAvailableRecordExpanded = function (_Component) {
	  _inherits(NoAvailableRecordExpanded, _Component);
	
	  function NoAvailableRecordExpanded(props) {
	    _classCallCheck(this, NoAvailableRecordExpanded);
	
	    var _this = _possibleConstructorReturn(this, (NoAvailableRecordExpanded.__proto__ || Object.getPrototypeOf(NoAvailableRecordExpanded)).call(this, props));
	
	    _this.sharedData = new _singletonSharedData.SingletonSharedData();
	    return _this;
	  }
	
	  _createClass(NoAvailableRecordExpanded, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: "fullSize " + (this.sharedData.getWindowExpandedActive() !== _constants.DRAGGABLE_WINDOWS.NO_AVAILABLE_RECORD ? "height0" : ""),
	          key: 'noAvailableExpandedRecord' },
	        _customComponents.CUSTOM_COMPONENTS["sideBarHeader"](_NoAvailableSVG.noAvailableRecordIcon, new _Singleton.Singleton().getText("GUICommonMenudisableHistory")),
	        _react2.default.createElement(_NoAvailableRecordComponent2.default, {
	          floating: false })
	      );
	    }
	  }]);
	
	  return NoAvailableRecordExpanded;
	}(_react.Component);
	
	exports.default = NoAvailableRecordExpanded;

/***/ },
/* 1094 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ChatComponent = __webpack_require__(498);
	
	var _ChatComponent2 = _interopRequireDefault(_ChatComponent);
	
	var _singletonSharedData = __webpack_require__(23);
	
	var _constants = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SupervisorChatExpanded = function (_Component) {
	  _inherits(SupervisorChatExpanded, _Component);
	
	  function SupervisorChatExpanded(props) {
	    _classCallCheck(this, SupervisorChatExpanded);
	
	    var _this = _possibleConstructorReturn(this, (SupervisorChatExpanded.__proto__ || Object.getPrototypeOf(SupervisorChatExpanded)).call(this, props));
	
	    _this.sharedData = new _singletonSharedData.SingletonSharedData();
	    return _this;
	  }
	
	  _createClass(SupervisorChatExpanded, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(next_props, next_state) {
	      return false;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        {
	          className: "fullSize " + (this.sharedData.getWindowExpandedActive() !== _constants.DRAGGABLE_WINDOWS.SUPERVISOR_CHAT ? "height0" : ""),
	          key: 'supervisorChatWindow' },
	        _react2.default.createElement(_ChatComponent2.default, { floating: false, objProps: this.props.objProps })
	      );
	    }
	  }]);
	
	  return SupervisorChatExpanded;
	}(_react.Component);
	
	exports.default = SupervisorChatExpanded;

/***/ },
/* 1095 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BlockingPanel = function (_Component) {
	  _inherits(BlockingPanel, _Component);
	
	  function BlockingPanel(props) {
	    _classCallCheck(this, BlockingPanel);
	
	    var _this = _possibleConstructorReturn(this, (BlockingPanel.__proto__ || Object.getPrototypeOf(BlockingPanel)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(BlockingPanel, [{
	    key: 'render',
	    value: function render() {
	      var zIndex = this.props.blockingPanelReducer.zIndex ? this.props.blockingPanelReducer.zIndex : "";
	      var txt = { "zIndex": zIndex };
	      return _react2.default.createElement('div', { className: 'blockingPanel', style: txt });
	    }
	  }]);
	
	  return BlockingPanel;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    blockingPanelReducer: state.blockingPanelReducer
	  };
	}
	
	exports.default = BlockingPanel = (0, _reactRedux.connect)(mapStateToProps, null)(BlockingPanel);

/***/ },
/* 1096 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Singleton = __webpack_require__(21);
	
	var _Images = __webpack_require__(30);
	
	var _GenericSVG = __webpack_require__(51);
	
	var _DateTimeSelection = __webpack_require__(501);
	
	var _DateTimeSelection2 = _interopRequireDefault(_DateTimeSelection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var language = new _Singleton.Singleton();
	
	var DatePicker = function DatePicker(_ref) {
	    var setDateReprogram = _ref.setDateReprogram,
	        callbackDays = _ref.callbackDays;
	
	    var _useState = (0, _react.useState)(false),
	        _useState2 = _slicedToArray(_useState, 2),
	        showCalendar = _useState2[0],
	        setShowCalendar = _useState2[1];
	
	    var toggleShowCalendar = function toggleShowCalendar() {
	        return setShowCalendar(function (o) {
	            return !o;
	        });
	    };
	
	    var _useState3 = (0, _react.useState)(""),
	        _useState4 = _slicedToArray(_useState3, 2),
	        dateReturned = _useState4[0],
	        setDateReturned = _useState4[1];
	
	    var _useState5 = (0, _react.useState)(""),
	        _useState6 = _slicedToArray(_useState5, 2),
	        timeReturned = _useState6[0],
	        setTimeReturned = _useState6[1];
	
	    var dateSelected = function dateSelected(date, time) {
	        setDateReturned(date);
	        setTimeReturned(time);
	        setShowCalendar(false);
	    };
	
	    (0, _react.useEffect)(function () {
	        if (dateReturned !== "" && timeReturned !== "") {
	            var d = dateReturned + " " + timeReturned;
	            setDateReprogram(d);
	        }
	    }, [showCalendar]);
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'dpa-container' },
	        _react2.default.createElement(
	            'div',
	            { className: 'containerDate', onClick: toggleShowCalendar },
	            _react2.default.createElement(
	                'div',
	                { className: 'timeReschedule dateReschedule' },
	                _react2.default.createElement('img', { className: 'iconDateReschedule', src: _Images.dateReschedule, alt: 'icon' }),
	                _react2.default.createElement(
	                    'p',
	                    { className: 'textDateReschedule' },
	                    dateReturned !== "" ? dateReturned : language.getText("CallControlcallCalificationdate")
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'timeReschedule' },
	                _react2.default.createElement('img', { className: 'iconDateReschedule', src: _Images.timeReschedule, alt: 'icon' }),
	                _react2.default.createElement(
	                    'p',
	                    { className: 'textDateReschedule' },
	                    timeReturned !== "" ? timeReturned : language.getText("CallControlcallCalificationhour")
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'arrowButton arrowOnly' },
	                _GenericSVG.triangle
	            )
	        ),
	        showCalendar && _react2.default.createElement(
	            'div',
	            { className: 'dpa-dateTimeContainer' },
	            _react2.default.createElement(_DateTimeSelection2.default, {
	                onSelectDate: function onSelectDate(date, time) {
	                    return dateSelected(date, time);
	                },
	                dataSource: callbackDays
	            })
	        )
	    );
	};
	
	exports.default = DatePicker;

/***/ },
/* 1097 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AgentStatusSVG = __webpack_require__(488);
	
	var _Singleton = __webpack_require__(21);
	
	var _singletonSharedData = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ExclusiveCallBack = function (_Component) {
	  _inherits(ExclusiveCallBack, _Component);
	
	  function ExclusiveCallBack(props) {
	    _classCallCheck(this, ExclusiveCallBack);
	
	    var _this = _possibleConstructorReturn(this, (ExclusiveCallBack.__proto__ || Object.getPrototypeOf(ExclusiveCallBack)).call(this, props));
	
	    _this.sharedData = new _singletonSharedData.SingletonSharedData();
	    _this.language = new _Singleton.Singleton();
	    return _this;
	  }
	
	  _createClass(ExclusiveCallBack, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'exclusiveCallBackContainer' },
	        _react2.default.createElement(
	          'div',
	          { className: 'exclusiveCallBackTop' },
	          _react2.default.createElement('div', { className: 'circle1' }),
	          _react2.default.createElement('div', { className: 'circle2' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'exclusiveCallBackAnimation' },
	            ' ',
	            _AgentStatusSVG.iconExlcusiveCallBackState
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'titleExclsiveCallBack' },
	          this.language.getText('GUIAgentStateexclusiveCallBack')
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'textExclusiveCallBack' },
	          this.sharedData.getPhoneCallBack()
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'textExclusiveCallBack' },
	          this.language.getText('GUIAgentStateconnectingCall')
	        )
	      );
	    }
	  }]);
	
	  return ExclusiveCallBack;
	}(_react.Component);
	
	exports.default = ExclusiveCallBack;

/***/ },
/* 1098 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _GenericSVG = __webpack_require__(51);
	
	var _Singleton = __webpack_require__(21);
	
	var _constants = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IntegrationConnectButton = function (_Component) {
	  _inherits(IntegrationConnectButton, _Component);
	
	  function IntegrationConnectButton(props) {
	    var _this2$state;
	
	    _classCallCheck(this, IntegrationConnectButton);
	
	    var _this2 = _possibleConstructorReturn(this, (IntegrationConnectButton.__proto__ || Object.getPrototypeOf(IntegrationConnectButton)).call(this, props));
	
	    _this2.language = new _Singleton.Singleton();
	    _this2.timmerName = null;
	    _this2.state = (_this2$state = {}, _defineProperty(_this2$state, _constants.STATES_INTEGRATION.connected, _this2.language.getText("GUIIntegrationdisconnect")), _defineProperty(_this2$state, _constants.STATES_INTEGRATION.connecting, _this2.language.getText("GUIIntegrationconnecting")), _defineProperty(_this2$state, _constants.STATES_INTEGRATION.disconnecting, _this2.language.getText("GUIIntegrationconnect")), _defineProperty(_this2$state, _constants.STATES_INTEGRATION.notFound, _this2.language.getText("GUIIntegrationretry")), _this2$state);
	    _this2.timmerTitile = null;
	    return _this2;
	  }
	
	  _createClass(IntegrationConnectButton, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      var _this = this;
	      this.timmerTitile = setInterval(function () {
	        var titleIntegration = _this.language.getText("GUIIntegrationdisconnect");
	        if (titleIntegration) {
	          var _this$setState;
	
	          clearInterval(_this.timmerTitile);
	          _this.setState((_this$setState = {}, _defineProperty(_this$setState, _constants.STATES_INTEGRATION.connected, _this3.language.getText("GUIIntegrationdisconnect")), _defineProperty(_this$setState, _constants.STATES_INTEGRATION.connecting, _this3.language.getText("GUIIntegrationconnecting")), _defineProperty(_this$setState, _constants.STATES_INTEGRATION.disconnecting, _this3.language.getText("GUIIntegrationconnect")), _defineProperty(_this$setState, _constants.STATES_INTEGRATION.notFound, _this3.language.getText("GUIIntegrationretry")), _this$setState));
	        }
	      }, 1000);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearInterval(this.timmerName);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'connectIntegrationComponent' },
	        this.props.stateIntegration === _constants.STATES_INTEGRATION.connecting ? _react2.default.createElement('div', { className: 'buttonConnectingIntegration' }) : _react2.default.createElement(
	          'div',
	          { className: 'buttonConnectIntegration', onClick: function onClick() {
	              return _this4.props.connectingAction();
	            } },
	          this.state[this.props.stateIntegration]
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'buttonCircleConnectIntegration rotate', onClick: function onClick() {
	              return _this4.props.sendToLog();
	            } },
	          _GenericSVG.arrowBack
	        )
	      );
	    }
	  }]);
	
	  return IntegrationConnectButton;
	}(_react.Component);
	
	exports.default = IntegrationConnectButton;

/***/ },
/* 1099 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Singleton = __webpack_require__(21);
	
	var _Images = __webpack_require__(30);
	
	var _constants = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IntegrationConnectWindow = function (_Component) {
	  _inherits(IntegrationConnectWindow, _Component);
	
	  function IntegrationConnectWindow(props) {
	    var _this$currentImage, _this$buttonTitle;
	
	    _classCallCheck(this, IntegrationConnectWindow);
	
	    var _this = _possibleConstructorReturn(this, (IntegrationConnectWindow.__proto__ || Object.getPrototypeOf(IntegrationConnectWindow)).call(this, props));
	
	    _this.language = new _Singleton.Singleton();
	    _this.currentImage = (_this$currentImage = {}, _defineProperty(_this$currentImage, _constants.STATES_INTEGRATION.connected, _Images.connectedIntegration), _defineProperty(_this$currentImage, _constants.STATES_INTEGRATION.connecting, _Images.connectingIntegration), _defineProperty(_this$currentImage, _constants.STATES_INTEGRATION.disconnecting, _Images.disconnectedIntegration), _defineProperty(_this$currentImage, _constants.STATES_INTEGRATION.notFound, _Images.notFoundIntegration), _this$currentImage);
	    _this.buttonTitle = (_this$buttonTitle = {}, _defineProperty(_this$buttonTitle, _constants.STATES_INTEGRATION.connected, _this.language.getText("GUIIntegrationconnected")), _defineProperty(_this$buttonTitle, _constants.STATES_INTEGRATION.connecting, _this.language.getText("GUIIntegrationconnecting")), _defineProperty(_this$buttonTitle, _constants.STATES_INTEGRATION.disconnecting, _this.language.getText("GUIIntegrationdisconnected")), _defineProperty(_this$buttonTitle, _constants.STATES_INTEGRATION.notFound, _this.language.getText("GUIIntegrationfail")), _this$buttonTitle);
	    return _this;
	  }
	
	  _createClass(IntegrationConnectWindow, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: "connectWindowIntegration " + this.props.stateIntegration },
	        _react2.default.createElement('div', { className: 'circle1' }),
	        _react2.default.createElement('div', { className: 'circle2' }),
	        _react2.default.createElement('img', { alt: "icon", className: 'iconIntegrationConnect', src: this.currentImage[this.props.stateIntegration] }),
	        _react2.default.createElement(
	          'p',
	          { className: 'stateIntegrationConnect' },
	          this.buttonTitle[this.props.stateIntegration]
	        )
	      );
	    }
	  }]);
	
	  return IntegrationConnectWindow;
	}(_react.Component);
	
	exports.default = IntegrationConnectWindow;

/***/ },
/* 1100 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Singleton = __webpack_require__(21);
	
	var _GenericSVG = __webpack_require__(51);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IntegrationInfoLog = function (_Component) {
	  _inherits(IntegrationInfoLog, _Component);
	
	  function IntegrationInfoLog(props) {
	    _classCallCheck(this, IntegrationInfoLog);
	
	    var _this = _possibleConstructorReturn(this, (IntegrationInfoLog.__proto__ || Object.getPrototypeOf(IntegrationInfoLog)).call(this, props));
	
	    _this.language = new _Singleton.Singleton();
	    return _this;
	  }
	
	  _createClass(IntegrationInfoLog, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'exclusiveCallBackContainer' },
	        _react2.default.createElement(
	          'div',
	          { className: 'headerLogIntegration' },
	          _react2.default.createElement(
	            'div',
	            { className: 'buttonCircleConnectIntegration', onClick: function onClick() {
	                return _this2.props.backToIntegration();
	              } },
	            _GenericSVG.arrowBack
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'titleLogIntegration' },
	            this.language.getText("GUIIntegrationLog")
	          )
	        ),
	        _react2.default.createElement(
	          'label',
	          { spellCheck: false, className: 'logContainer' },
	          this.props.integrationLog.map(function (item, index) {
	            return _react2.default.createElement(
	              'div',
	              { key: index },
	              item
	            );
	          })
	        )
	      );
	    }
	  }]);
	
	  return IntegrationInfoLog;
	}(_react.Component);
	
	exports.default = IntegrationInfoLog;

/***/ },
/* 1101 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CallRecordSVG = __webpack_require__(322);
	
	var _CallSpaceHeaderSVG = __webpack_require__(67);
	
	var _Singleton = __webpack_require__(21);
	
	var _reactSimpleRange = __webpack_require__(957);
	
	var _reactSimpleRange2 = _interopRequireDefault(_reactSimpleRange);
	
	var _cwGalateaApiJsBundle = __webpack_require__(40);
	
	var _globalAudioPlayerJsBundleMin = __webpack_require__(1879);
	
	var _constants = __webpack_require__(10);
	
	var _singletonSharedData = __webpack_require__(23);
	
	var _draggableComponents = __webpack_require__(101);
	
	var _formats = __webpack_require__(54);
	
	var _alertBodies = __webpack_require__(240);
	
	var _AlertWindow = __webpack_require__(324);
	
	var _AlertWindow2 = _interopRequireDefault(_AlertWindow);
	
	var _Logger = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PlayerReproductor = function (_Component) {
	  _inherits(PlayerReproductor, _Component);
	
	  function PlayerReproductor(props) {
	    _classCallCheck(this, PlayerReproductor);
	
	    var _this2 = _possibleConstructorReturn(this, (PlayerReproductor.__proto__ || Object.getPrototypeOf(PlayerReproductor)).call(this, props));
	
	    _this2.addMark = function () {
	      _this2.callMarks += '|' + (0, _formats.secondsToFormat)(_this2.state.currentTimeRecord, true);
	      var currentList = _this2.state.listMarks;
	      var validation = false;
	      var newMark = {
	        position: _this2.state.currentTimeRecord * _this2.getReproductionBarSize() / _this2.state.recordLength,
	        type: _constants.TYPE_MARKS.AGENT,
	        time: (0, _formats.secondsToFormat)(_this2.state.currentTimeRecord, true),
	        duration: _this2.state.recordLength
	      };
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = currentList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var _ref = _step.value;
	          var time = _ref.time;
	
	          if (time === newMark.time) validation = true;
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      if (!validation) {
	        currentList.push(newMark);
	        _this2.setState({ listMarks: currentList });
	      }
	    };
	
	    _this2.backwardRecording = function () {
	      _this2.audioPlayer.backwardRecording();
	      var backward = _this2.state.currentTimeRecord - _this2.skipLength < 0 ? 0 : _this2.state.currentTimeRecord - _this2.skipLength;
	      _this2.setState({ currentTimeRecord: backward });
	    };
	
	    _this2.forwardRecording = function () {
	      if (_this2.state.currentTimeRecord > 0 && _this2.state.currentTimeRecord + _this2.skipLength * _this2.state.callSpeed < _this2.state.recordLength) {
	        _this2.audioPlayer.forwardRecording();
	        var forward = _this2.state.currentTimeRecord + _this2.skipLength >= _this2.state.recordLength ? 0 : _this2.state.currentTimeRecord + _this2.skipLength;
	        _this2.setState({ currentTimeRecord: forward });
	      }
	    };
	
	    _this2.playRecord = function () {
	      _this2.setState({ playerIsPlaying: !_this2.state.playerIsPlaying, callSpeed: 1 });
	      _this2.audioPlayer.playPauseRecording();
	      clearInterval(_this2.timerPlayer);
	      _this2.audioPlayer.speed(1);
	      if (!_this2.state.playerIsPlaying) {
	        _this2.setTimer(1);
	      }
	    };
	
	    _this2.setCallSpeed = function () {
	      var currentSpeed = _this2.state.callSpeed + 0.5 > 2.0 ? 1 : _this2.state.callSpeed + 0.5;
	      _this2.setState({ callSpeed: currentSpeed });
	      _this2.audioPlayer.speed(currentSpeed);
	      _this2.setTimer(currentSpeed);
	    };
	
	    _this2.onClickBtnVolumen = function () {
	      _this2.setState({ volumeShowed: !_this2.state.volumeShowed });
	    };
	
	    _this2.language = new _Singleton.Singleton();
	    _this2.state = {
	      currentTimeRecord: 0,
	      recordLength: 0.1,
	      playerIsPlaying: false,
	      tableData: [],
	      callSpeed: 1,
	      currentSpeed: 1000,
	      currentVolume: 100,
	      volumeShowed: false,
	      recordingNotFound: false,
	      configurationError: false,
	      listMarks: [],
	      audioLoaded: false
	    };
	    _this2.sharedData = new _singletonSharedData.SingletonSharedData();
	    var APIFact = new _cwGalateaApiJsBundle.APIFactory();
	    _this2.apiCont = APIFact.buildClient();
	    _this2.callObj = { "userId": 0, "calId": 0, "type": "", "times": "" };
	    _this2.callMarks = "";
	    _this2.path = "";
	    _this2.skipLength = 2.0;
	    _this2.isIE = false;
	    _this2.resize = _this2.resize.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(PlayerReproductor, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.isIE = false || !!document.documentMode;
	      _Logger.Logger.Trace('[Player Reproductor][componentDidMount] Internet Explorer ' + this.isIE);
	      window.addEventListener('resize', this.resize);
	      if (!this.isIE) {
	        var plFactory = new _globalAudioPlayerJsBundleMin.PlayerFactory();
	        this.audioPlayer = plFactory.buildClient('#waveform');
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.resize);
	      this.saveMarks();
	      this.pausePlayer();
	      this.cleanPath("");
	    }
	  }, {
	    key: 'openManualCall',
	    value: function openManualCall(selected) {
	      var objProps = {
	        campaingName: selected.original.campaing,
	        campaingID: selected.original.idCampaing,
	        phoneNumber: selected.original.phoneNumber
	      };
	      this.props.insertWindow((0, _draggableComponents.manualCallWindow)(objProps), false);
	    }
	  }, {
	    key: 'resize',
	    value: function resize() {
	      var _this3 = this;
	
	      var currentList = this.state.listMarks;
	      this.setState({
	        listMarks: currentList.map(function (item) {
	          return {
	            time: item.time,
	            duration: item.duration,
	            position: item.time.split(':').reduce(function (acc, time) {
	              return 60 * acc + +time;
	            }) * _this3.getReproductionBarSize() / Math.round(item.duration),
	            type: _constants.TYPE_MARKS.AGENT
	          };
	        })
	      });
	    }
	  }, {
	    key: 'movingRecordCall',
	    value: function movingRecordCall(props) {
	      this.setState({ currentTimeRecord: props.value, callSpeed: 1, playerIsPlaying: true });
	      this.audioPlayer.playRecording(props.value);
	      this.setTimer(1);
	    }
	  }, {
	    key: 'volumecontrol',
	    value: function volumecontrol(props) {
	      this.setState({ currentVolume: props.value });
	      this.audioPlayer.setVolume(props.value / 100.0);
	    }
	  }, {
	    key: 'setCallObject',
	    value: function setCallObject(callObject) {
	      this.callObj = callObject;
	    }
	  }, {
	    key: 'saveMarks',
	    value: function saveMarks() {
	      this.callObj.times = this.callMarks.slice(1);
	      if (this.callMarks) {
	        this.apiCont.markCall(this.callObj, this.apiCont.getObjectResponse());
	        this.callMarks = "";
	      }
	    }
	  }, {
	    key: 'initLoading',
	    value: function initLoading() {
	      this.setState({ audioLoaded: false, listMarks: [] });
	    }
	  }, {
	    key: 'loadPath',
	    value: function loadPath(path, marks) {
	      var _this4 = this;
	
	      try {
	        var url = window.location.href;
	        this.validatePath(path);
	        this.validateUrlandBasePathSecurity(url, path);
	        var _this = this;
	        this.audioPlayer.loadRecording(path).then(function (duration) {
	          _this.setState({
	            recordLength: Math.round(duration),
	            currentTimeRecord: 0,
	            playerIsPlaying: false,
	            recordingNotFound: false,
	            configurationError: false,
	            audioLoaded: true,
	            listMarks: marks.map(function (item) {
	              return { position: item.split(':').reduce(function (acc, time) {
	                  return 60 * acc + +time;
	                }) * _this4.getReproductionBarSize() / Math.round(duration), type: _constants.TYPE_MARKS.AGENT, time: item, duration: duration };
	            })
	          });
	          _this4.path = path;
	          clearInterval(_this4.timerPlayer);
	        });
	      } catch (error) {
	        _Logger.Logger.Trace(error);
	        this.handleErrorOnAudio(error);
	        this.cleanPath();
	      }
	    }
	  }, {
	    key: 'validatePath',
	    value: function validatePath(path) {
	      if (!path) {
	        var error = new Error("Path is empty; No recording found");
	        error.code = "REC_NOT_FOUND";
	        throw error;
	      }
	    }
	  }, {
	    key: 'validateUrlandBasePathSecurity',
	    value: function validateUrlandBasePathSecurity(url, databasePath) {
	      var urlSecurity = url.split(":")[0];
	      var databasePathSecurity = databasePath.split(":")[0];
	      if (urlSecurity !== databasePathSecurity) {
	        var error = new Error("Security configuration of Url and database Path are different");
	        error.code = "CONFIG_ERROR";
	        throw error;
	      }
	    }
	  }, {
	    key: 'handleErrorOnAudio',
	    value: function handleErrorOnAudio(error) {
	      error.code === "CONFIG_ERROR" ? this.databaseConfigurationError() : this.recordNotFoundError();
	    }
	  }, {
	    key: 'getReproductionBarSize',
	    value: function getReproductionBarSize() {
	      if (window.innerWidth < 640) {
	        return 146;
	      } else {
	        return 232;
	      }
	    }
	  }, {
	    key: 'recordNotFoundError',
	    value: function recordNotFoundError() {
	      var _this = this;
	      this.setState({ recordingNotFound: true });
	      this.setState({ configurationError: false });
	      setTimeout(function () {
	        _this.setState({ recordingNotFound: false, configurationError: false });
	      }, 4000);
	    }
	  }, {
	    key: 'databaseConfigurationError',
	    value: function databaseConfigurationError() {
	      var _this = this;
	      this.setState({ recordingNotFound: true });
	      this.setState({ configurationError: true });
	      setTimeout(function () {
	        _this.setState({ recordingNotFound: false, configurationError: false });
	      }, 6000);
	    }
	  }, {
	    key: 'cleanPath',
	    value: function cleanPath() {
	      this.path = "";
	      this.setState({
	        recordLength: 0.1,
	        currentTimeRecord: 0,
	        playerIsPlaying: false
	      });
	      clearInterval(this.timerPlayer);
	      if (this.audioPlayer) {
	        this.audioPlayer.stopRecording();
	      }
	
	      this.initLoading();
	    }
	  }, {
	    key: 'pausePlayer',
	    value: function pausePlayer() {
	      if (this.state.playerIsPlaying) {
	        this.setState({ playerIsPlaying: false, callSpeed: 1 });
	        this.audioPlayer.playPauseRecording();
	        clearInterval(this.timerPlayer);
	        this.audioPlayer.speed(1);
	      }
	    }
	  }, {
	    key: 'setTimer',
	    value: function setTimer(speed) {
	      clearInterval(this.timerPlayer);
	      var _this = this;
	      this.timerPlayer = setInterval(playerMethod, 1000 / speed);
	      function playerMethod() {
	        _this.setState({
	          currentTimeRecord: _this.state.currentTimeRecord + 1
	        });
	        if (_this.state.currentTimeRecord >= _this.state.recordLength) {
	          _this.setState({
	            currentTimeRecord: 0,
	            playerIsPlaying: false
	          });
	          _this.audioPlayer.speed(1);
	          clearInterval(_this.timerPlayer);
	        }
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.disabled !== this.props.disabled && this.props.disabled) {
	        this.setState({ volumeShowed: false });
	      }
	    }
	  }, {
	    key: 'validateMarksPermission',
	    value: function validateMarksPermission() {
	      return this.sharedData.getAllowMarksPermission();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'playerRecordCall' },
	        _react2.default.createElement('div', { id: 'waveform', className: 'audioPlayerWaves' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'controlsContainer' },
	          _react2.default.createElement(
	            'div',
	            { className: "iconMoveRecord " + (this.state.audioLoaded && !this.props.disabled ? "" : "disabled"), onClick: this.props.disabled ? undefined : this.backwardRecording },
	            _CallRecordSVG.moveRecord
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: "iconPlayRecord " + (this.state.audioLoaded && !this.props.disabled ? "" : "disabled"), onClick: this.props.disabled ? undefined : this.playRecord },
	            this.state.playerIsPlaying && this.state.recordLength >= 1 ? _CallRecordSVG.pause : _CallRecordSVG.playRecord
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: "iconMoveRecord fordward " + (this.state.audioLoaded && !this.props.disabled ? "" : "disabled"), onClick: this.props.disabled ? undefined : this.forwardRecording },
	            _CallRecordSVG.moveRecord
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'playerContainer' },
	          !this.isIE && _react2.default.createElement(
	            'div',
	            { className: 'playerCall' },
	            _react2.default.createElement(
	              _reactSimpleRange2.default,
	              {
	                value: this.state.currentTimeRecord,
	                min: 0,
	                max: this.state.recordLength,
	                sliderSize: 3,
	                sliderColor: 'rgba(255,255,255,0.22)',
	                trackColor: '#17A2FF',
	                verticalSliderHeight: '100%',
	                onChange: this.movingRecordCall.bind(this) },
	              _react2.default.createElement('div', { className: 'thumbCustomPlayer' })
	            )
	          ),
	          this.state.listMarks.map(function (item) {
	            return _react2.default.createElement(
	              'div',
	              { className: "markInCall " + item.type, key: item.position, style: { left: item.position - 2 } },
	              _CallRecordSVG.markInCallSVG
	            );
	          }),
	          ';',
	          _react2.default.createElement(
	            'p',
	            { className: 'timePlayer beginTime' },
	            (0, _formats.secondsToFormat)(this.state.currentTimeRecord, false)
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'timePlayer endTime' },
	            (0, _formats.secondsToFormat)(this.state.recordLength, false)
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: "playerSpeed " + (this.state.audioLoaded && this.state.playerIsPlaying ? "" : "disabled"),
	            onClick: this.props.disabled ? undefined : this.setCallSpeed },
	          this.state.callSpeed + "x"
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'volumeContainerRecord ' + (this.props.disabled ? 'disabled' : '') },
	          this.state.volumeShowed && _react2.default.createElement(
	            'div',
	            { className: 'sliderContainer' },
	            _react2.default.createElement(
	              _reactSimpleRange2.default,
	              {
	                vertical: true,
	                value: this.state.currentVolume,
	                sliderSize: 3,
	                sliderColor: 'rgba(255,255,255,0.22)',
	                trackColor: 'blue',
	                thumbColor: '#B71C1C',
	                verticalSliderHeight: '80%',
	                onChange: this.volumecontrol.bind(this) },
	              _react2.default.createElement('div', { className: 'thumbCustom' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: "volumeButton " + (this.state.volumeShowed ? "active " : "") + (this.state.audioLoaded ? "" : "disabled"),
	              onClick: this.props.disabled ? undefined : this.onClickBtnVolumen },
	            this.state.currentVolume === 0.0 ? _CallSpaceHeaderSVG.noVolume : this.state.currentVolume > 0.5 ? _CallSpaceHeaderSVG.volume : _CallSpaceHeaderSVG.volumeMedium
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: "btnAddMark " + (this.state.audioLoaded && !this.props.disabled && this.validateMarksPermission() ? "" : "disabled"), onClick: this.props.disabled ? undefined : this.addMark },
	          _react2.default.createElement(
	            'div',
	            { className: 'container100' },
	            _CallSpaceHeaderSVG.resume
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'container100' },
	            _CallRecordSVG.addSVG
	          )
	        ),
	        this.state.recordingNotFound && _react2.default.createElement(
	          'div',
	          { className: 'alertContainerDisappear' },
	          _react2.default.createElement(_AlertWindow2.default, {
	            title: this.state.configurationError ? this.language.getText("GUIAlertMessageconfigurationError") : this.language.getText("GUIAlertMessagenotFound"),
	            body: this.state.configurationError ? (0, _alertBodies.configurationErrorBody)() : (0, _alertBodies.recordingNotFound)(),
	            isGlobe: true })
	        )
	      );
	    }
	  }]);
	
	  return PlayerReproductor;
	}(_react.Component);
	
	exports.default = PlayerReproductor;

/***/ },
/* 1102 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Validations = __webpack_require__(131);
	
	var _Singleton = __webpack_require__(21);
	
	var _SelectComponent = __webpack_require__(155);
	
	var _SelectComponent2 = _interopRequireDefault(_SelectComponent);
	
	var _Images = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var language = new _Singleton.Singleton();
	
	var SelectReprogramPhone = function SelectReprogramPhone(_ref) {
	    var setPhoneReprogram = _ref.setPhoneReprogram,
	        numbers = _ref.numbers,
	        phoneCall = _ref.phoneCall;
	
	    var _useState = (0, _react.useState)(1),
	        _useState2 = _slicedToArray(_useState, 2),
	        selectionReschedule = _useState2[0],
	        setSelectionReschedule = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(""),
	        _useState4 = _slicedToArray(_useState3, 2),
	        phone = _useState4[0],
	        setPhone = _useState4[1];
	
	    var imagesNumber = { "1": _Images.reprogramacion1, "2": _Images.reprogramacion2, "3": _Images.reprogramacion3, "4": _Images.reprogramacion4, "5": _Images.reprogramacion5 };
	
	    var _useState5 = (0, _react.useState)([{ img: _Images.reprogramacion1, number: phoneCall, id: 1 }]),
	        _useState6 = _slicedToArray(_useState5, 2),
	        arrayNums = _useState6[0],
	        setArrayNums = _useState6[1];
	
	    var _useState7 = (0, _react.useState)(-1),
	        _useState8 = _slicedToArray(_useState7, 2),
	        displayedComponent = _useState8[0],
	        setDisplayedComponent = _useState8[1];
	
	    var _useState9 = (0, _react.useState)(""),
	        _useState10 = _slicedToArray(_useState9, 2),
	        otherPhone = _useState10[0],
	        setOtherPhone = _useState10[1];
	
	    (0, _react.useEffect)(function () {
	        getListOfPhones();
	    }, [numbers]);
	
	    (0, _react.useEffect)(function () {
	        setPhoneReprogram({ selectionReschedule: selectionReschedule, phone: phone, otherPhone: otherPhone });
	    }, [phone, otherPhone]);
	
	    var getListOfPhones = function getListOfPhones() {
	        if (numbers !== undefined) {
	            if (Object.keys(numbers).length > 0) {
	                var _arrayNums = Object.keys(numbers).map(function (i) {
	                    return numbers[i];
	                });
	                var b = [].concat(_toConsumableArray(_arrayNums)).map(function (item) {
	                    return { img: imagesNumber[item.Graphic], number: item.Phone, id: item.Graphic };
	                });
	                var c = b.filter(function (item) {
	                    if (item.number !== "") {
	                        return item;
	                    }
	                });
	                setArrayNums(c);
	            } else {
	                setArrayNums([{ img: _Images.reprogramacion1, number: phoneCall, id: 1 }, { img: _Images.reprogramacion1, number: phoneCall, id: 1 }]);
	            }
	        }
	    };
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'rescheduleSelector' },
	            _react2.default.createElement('div', { className: "rescheduleRadioButton" + (selectionReschedule === 1 ? " active" : " inactive"), onClick: function onClick() {
	                    return setSelectionReschedule(1);
	                } }),
	            _react2.default.createElement(
	                'div',
	                { className: 'containerReschedule' },
	                _react2.default.createElement(_SelectComponent2.default, {
	                    bottomBox: 60,
	                    defaultDiv: { item: "texSelection" },
	                    displayer: "bigDisplayer",
	                    customCell: "cellImageText",
	                    parameters: { image: "img", text: "number" },
	                    dataSource: arrayNums,
	                    closeOthers: true,
	                    itemDefault: 0,
	                    displayedList: displayedComponent,
	                    onDisplayList: function onDisplayList(compSelected) {
	                        return setDisplayedComponent(compSelected);
	                    },
	                    onSelectItem: function onSelectItem(itemSelected) {
	                        return setPhone(itemSelected);
	                    } })
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'rescheduleSelector' },
	            _react2.default.createElement('div', { className: "rescheduleRadioButton" + (selectionReschedule === 2 ? " active" : " inactive"), onClick: function onClick() {
	                    return setSelectionReschedule(2);
	                } }),
	            _react2.default.createElement('input', { type: 'text',
	                placeholder: language.getText("GUISearchWindowphoneNum"),
	                disabled: selectionReschedule === 1,
	                className: "otherPhoneReschedule" + (selectionReschedule === 2 ? " active" : " inactive"),
	                value: otherPhone,
	                onChange: function onChange(event) {
	                    return setOtherPhone(event.target.value);
	                },
	                onKeyPress: _Validations.validateOnlyNumbers })
	        )
	    );
	};
	
	exports.default = SelectReprogramPhone;

/***/ },
/* 1103 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.SingleTable = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SingleTable = exports.SingleTable = function SingleTable(props) {
		return _react2.default.createElement(
			'div',
			{ className: 'singleTable-container', onClick: function onClick() {
					return props.onSelectANI(props.data);
				} },
			_react2.default.createElement(
				'div',
				{ className: 'singleTable-li' },
				props.data
			)
		);
	};

/***/ },
/* 1104 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ToggleButton = function (_Component) {
	  _inherits(ToggleButton, _Component);
	
	  function ToggleButton(props) {
	    _classCallCheck(this, ToggleButton);
	
	    var _this = _possibleConstructorReturn(this, (ToggleButton.__proto__ || Object.getPrototypeOf(ToggleButton)).call(this, props));
	
	    _this.switchOption = function () {
	      _this.setState({ on: !_this.state.on });
	      if (_this.state.on) {
	        _this.props.onOff();
	      } else {
	        _this.props.onOn();
	      }
	    };
	
	    _this.state = {
	      on: props.on ? true : false
	    };
	    return _this;
	  }
	
	  _createClass(ToggleButton, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        { className: "toggleContainer", onClick: this.switchOption },
	        _react2.default.createElement(
	          "div",
	          { className: "toggleLine " + (this.state.on ? "active" : "inActive") },
	          _react2.default.createElement(
	            "div",
	            { className: "wrapper" },
	            _react2.default.createElement("div", { className: "toggleThumb " + (this.state.on ? "active" : "inActive") }),
	            _react2.default.createElement("div", { className: "animation " + (this.state.on ? "active" : "inActive") })
	          )
	        )
	      );
	    }
	  }]);
	
	  return ToggleButton;
	}(_react.Component);
	
	exports.default = ToggleButton;

/***/ },
/* 1105 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(25);
	
	var _reactBootstrap = __webpack_require__(73);
	
	var _CallSpaceHeaderSVG = __webpack_require__(67);
	
	var _draggableComponents = __webpack_require__(101);
	
	var _A_draggable_windows_controller = __webpack_require__(55);
	
	var _constants = __webpack_require__(10);
	
	var _A_messages_to_SM = __webpack_require__(32);
	
	var _helperMessages = __webpack_require__(87);
	
	var _VolumeContainer = __webpack_require__(1112);
	
	var _VolumeContainer2 = _interopRequireDefault(_VolumeContainer);
	
	var _singletonSharedData = __webpack_require__(23);
	
	var _cwGalateaApiJsBundle = __webpack_require__(40);
	
	var _A_reducer_call_acd = __webpack_require__(156);
	
	var _Singleton = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sharedData = new _singletonSharedData.SingletonSharedData();
	var APIFact = new _cwGalateaApiJsBundle.APIFactory();
	var apiCont = APIFact.buildClient();
	var language = new _Singleton.Singleton();
	var markPermissionValue = sharedData.getAllowMarksPermission();
	
	var CallButtons = function CallButtons(_ref) {
		var initialDialogTime = _ref.initialDialogTime,
		    setIsRateInDialog = _ref.setIsRateInDialog;
	
		var _useSelector = (0, _reactRedux.useSelector)(function (state) {
			return state.preview;
		}),
		    _useSelector$selected = _useSelector.selectedRecord,
		    speakerVol = _useSelector$selected.volume.speakerVol,
		    callOutId = _useSelector$selected.callOutId,
		    camId = _useSelector$selected.camId,
		    phoneToCall = _useSelector$selected.phoneToCall;
	
		var _useSelector2 = (0, _reactRedux.useSelector)(function (state) {
			return state.preview;
		}),
		    selectedRecord = _useSelector2.selectedRecord,
		    records = _useSelector2.records;
	
		var dispatch = (0, _reactRedux.useDispatch)();
	
		var _useState = (0, _react.useState)(initialDialogTime),
		    _useState2 = _slicedToArray(_useState, 2),
		    initialTime = _useState2[0],
		    setInitialTime = _useState2[1];
	
		var _useState3 = (0, _react.useState)(false),
		    _useState4 = _slicedToArray(_useState3, 2),
		    isMute = _useState4[0],
		    setMute = _useState4[1];
	
		var _useState5 = (0, _react.useState)({}),
		    _useState6 = _slicedToArray(_useState5, 2),
		    showExtraBtns = _useState6[0],
		    setShowExtraBtns = _useState6[1];
	
		var ivrPermission = sharedData.getGeneralPermissions()[117];
		var renderButtons = [{
			idButton: 'disposition',
			image: _CallSpaceHeaderSVG.rateCallSvg,
			tooltip: 'Disposition',
			active: false,
			enabledState: true,
			showed: false,
			realSize: 52,
			className: 'buttonSmallCall',
			action: function action() {
				return handleDisposition();
			},
			hideAt: 590
		}, {
			idButton: 'transfer',
			image: _CallSpaceHeaderSVG.assistedTransfer,
			tooltip: 'Transfer',
			active: false,
			enabledState: true,
			showed: true,
			realSize: 52,
			className: 'buttonBigCall',
			action: function action() {
				return handleTransfer();
			},
			hideAt: 530
		}, {
			idButton: 'leaveMessage',
			image: _CallSpaceHeaderSVG.hangUpLeaveMessage,
			tooltip: 'LeaveMessage',
			active: false,
			enabledState: true,
			showed: false,
			realSize: 52,
			className: 'buttonBigCall',
			action: function action() {
				return handleHangUpAndLeaveMessage();
			},
			hideAt: 590
		}, {
			idButton: 'dtmf',
			image: _CallSpaceHeaderSVG.dtmfSVG,
			tooltip: 'DTMF',
			active: false,
			enabledState: true,
			showed: true,
			realSize: 52,
			className: 'buttonBigCall',
			action: function action() {
				return handleDTMF();
			},
			hideAt: 450
		}, {
			idButton: 'volume',
			image: _CallSpaceHeaderSVG.volumeMedium,
			tooltip: 'Volume',
			active: false,
			enabledState: true,
			showed: true,
			realSize: 52,
			className: 'buttonBigCall',
			action: function action() {
				return handleVolume();
			},
			hideAt: 0
		}, {
			idButton: 'mute',
			image: _CallSpaceHeaderSVG.mute,
			tooltip: 'Mute',
			active: false,
			showed: true,
			enabledState: true,
			realSize: 52,
			className: 'buttonBigCall',
			action: function action() {
				return handleMute();
			},
			hideAt: 0
		}, {
			idButton: 'marks',
			image: _CallSpaceHeaderSVG.resume,
			tooltip: 'Mark',
			active: false,
			showed: false,
			enabledState: true,
			realSize: 52,
			className: 'buttonBigCall',
			action: function action() {
				return handleMarkCall();
			},
			hideAt: 480
		}, {
			idButton: 'ivr',
			image: _CallSpaceHeaderSVG.ivr,
			tooltip: 'IVR',
			active: false,
			enabledState: true,
			showed: false,
			realSize: 52,
			className: 'buttonBigCall',
			action: function action() {
				return handleIVR();
			},
			hideAt: 600
		}, {
			idButton: 'record',
			image: _CallSpaceHeaderSVG.record,
			tooltip: 'Record',
			active: false,
			enabledState: true,
			showed: false,
			realSize: 52,
			className: 'buttonBigCall',
			action: function action() {
				return handlePauseRecord();
			},
			hideAt: 600
		}];
	
		var _useState7 = (0, _react.useState)(false),
		    _useState8 = _slicedToArray(_useState7, 2),
		    onTransferWindow = _useState8[0],
		    setOnTransferWindow = _useState8[1];
	
		var _useState9 = (0, _react.useState)(renderButtons),
		    _useState10 = _slicedToArray(_useState9, 2),
		    currentBtns = _useState10[0],
		    setCurrentBtns = _useState10[1];
	
		(0, _react.useEffect)(function () {
			getBtnPermissionToShow();
		}, []);
	
		(0, _react.useEffect)(function () {
			if (initialDialogTime !== undefined) {
				setInitialTime(initialTime);
			}
		}, [initialDialogTime]);
	
		(0, _react.useEffect)(function () {
			var temp = currentBtns.map(function (r) {
				if (r.idButton === 'volume') {
					r.image = speakerVol === 0 ? _CallSpaceHeaderSVG.noVolume : speakerVol < 60 ? _CallSpaceHeaderSVG.volumeMedium : _CallSpaceHeaderSVG.volume;
					return r;
				}
				return r;
			});
			setCurrentBtns(temp);
		}, [speakerVol]);
	
		var getBtnPermissionToShow = function getBtnPermissionToShow() {
			var objectResponse = apiCont.getObjectResponse();
			var objectData = {
				UserId: sharedData.getParameters().UserID,
				Id: camId,
				CallType: 2,
				CallOutId: callOutId,
				Phone: phoneToCall
			};
	
			apiCont.callIcon(objectData, objectResponse);
			objectResponse.onError = function (err) {};
			objectResponse.onSuccess = function (objResponse) {
	
				setShowExtraBtns(objResponse);
				showBtns(objResponse);
			};
			getRecordingStateButton();
		};
		var showBtns = function showBtns(objectResponse) {
			var temp = currentBtns.map(function (r) {
				switch (r.idButton) {
					case 'disposition':
						r.showed = objectResponse.ShowDisposition;
						return r;
					case 'record':
						r.showed = objectResponse.IsStartStopRecording;
						return r;
					case 'ivr':
						r.showed = Boolean(parseInt(ivrPermission, 10));
						return r;
					case 'leaveMessage':
						r.showed = objectResponse.LeaveRecMessage === 1;
					default:
						return r;
				}
			});
			setCurrentBtns(temp);
		};
		var getRecordingStateButton = function getRecordingStateButton() {
			var objectResponseRecordCall = apiCont.getObjectResponse();
			var objectDataRecord = {
				campId: camId,
				option: 2
			};
			apiCont.GetRecordCallPermission(objectDataRecord, objectResponseRecordCall);
			objectResponseRecordCall.onError = function (err) {};
			objectResponseRecordCall.onSuccess = function (objResponse) {
				showBtnMarks(objResponse);
			};
		};
	
		var showBtnMarks = function showBtnMarks(objResponse) {
			markPermissionValue = sharedData.getAllowMarksPermission();
			var temp = currentBtns.map(function (r) {
				if (r.idButton === 'marks') {
					r.showed = objResponse !== 3, r.className = markPermissionValue ? 'buttonBigCall' : 'buttonDisabled';
					return r;
				}
				return r;
			});
			setCurrentBtns(temp);
		};
	
		var checkIsActiveButton = function checkIsActiveButton(idSeleccion) {
			return currentBtns.filter(function (r) {
				return r.idButton === idSeleccion;
			})[0].active;
		};
	
		var selectButton = function selectButton(buttonId, isActive) {
			var temp = currentBtns.map(function (r) {
				if (r.idButton === buttonId) {
					r.active = isActive, r.className = isActive ? r.className += ' selected' : r.className.replace('selected', '');
					return r;
				}
				return r;
			});
			setCurrentBtns(temp);
		};
	
		var handleDisposition = function handleDisposition() {
			var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
			selectButton('disposition', !checkIsActiveButton('disposition'));
			setIsRateInDialog(true);
			dispatch((0, _A_draggable_windows_controller.insertWindow)((0, _draggableComponents.rateRecordWindow)(props, initialTime, callOutId, onCloseDispositionWindow), true));
		};
	
		var onCloseDispositionWindow = function onCloseDispositionWindow() {
			selectButton('disposition', false);
			setIsRateInDialog(false);
		};
	
		var handleTransfer = function handleTransfer() {
			var messageIntegration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
	
			var dataCall = {
				CamId: selectedRecord.camId, CallKey: selectedRecord.callKey,
				Phone: selectedRecord.phoneToCall, Data: "", ExistsCallout: selectedRecord.callOutId, CallMode: 0, integration: false
			};
			dispatch((0, _A_draggable_windows_controller.insertWindow)((0, _draggableComponents.transferCallWindow)({ dataCall: dataCall, messageIntegration: messageIntegration }), onTransferWindow ? false : true));
		};
	
		var handleDTMF = function handleDTMF() {
			selectButton('dtmf', !checkIsActiveButton('dtmf'));
			var isEdit = Object.keys(showExtraBtns).length > 0 ? showExtraBtns.IsEditDtmf : false;
			var dtmfOptions = Object.keys(showExtraBtns).length > 0 ? showExtraBtns.DtmfOptions : [];
			var dtmfWindow = (0, _draggableComponents.dtmfTonesWindow)({ isEditDtmf: isEdit, dtmfOptions: dtmfOptions, digit: null }, onCloseHandleDTMF);
			dispatch((0, _A_draggable_windows_controller.insertWindow)(dtmfWindow, true));
		};
	
		var handleIVR = function handleIVR() {
			var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
			selectButton('ivr', !checkIsActiveButton('ivr'));
			dispatch((0, _A_draggable_windows_controller.insertWindow)((0, _draggableComponents.ongoingCallIvrWindow)(props, onCloseIVR), true));
		};
	
		var handleMarkCall = function handleMarkCall() {
			var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
			if (markPermissionValue) {
				selectButton('marks', !checkIsActiveButton('marks'));
				dispatch((0, _A_draggable_windows_controller.insertWindow)((0, _draggableComponents.markCallWindow)(props, initialTime, callOutId, onCloseMarCallkWindow), true));
			}
		};
	
		var handleHangUpAndLeaveMessage = function handleHangUpAndLeaveMessage() {
			dispatch((0, _A_messages_to_SM.messageToStateMachine)((0, _helperMessages.messageHangUp)(_constants.HANG_UP_SUBACTIONS.LEAVE_MESSAGE, callOutId)));
		};
	
		var handlePauseRecord = function handlePauseRecord() {
			selectButton('record', !checkIsActiveButton('record'));
			dispatch((0, _A_messages_to_SM.messageToStateMachine)((0, _helperMessages.messageStartStopRecording)(!checkIsActiveButton('record'), callOutId)));
		};
	
		var handleMute = function handleMute() {
			var temp = !checkIsActiveButton('mute');
			selectButton('mute', temp);
			setMute(temp);
			dispatch((0, _A_reducer_call_acd.callAction)(_constants.ACTION_CALL_ACD.MUTE, temp));
		};
	
		var handleVolume = function handleVolume() {
			selectButton('volume', !checkIsActiveButton('volume'));
		};
		var onCloseMarCallkWindow = function onCloseMarCallkWindow() {
			selectButton('marks', false);
		};
		var onCloseHandleDTMF = function onCloseHandleDTMF() {
			selectButton('dtmf', false);
		};
		var onCloseIVR = function onCloseIVR() {
			selectButton('ivr', false);
		};
		return _react2.default.createElement(
			'div',
			{ className: 'barButtonsCall' },
			_react2.default.createElement(
				'div',
				{ className: 'buttonsContainer' },
				currentBtns.map(function (item, i) {
					return item.showed && item.enabledState && (item.idButton === 'volume' ? _react2.default.createElement(_VolumeContainer2.default, { item: item, selectButton: selectButton, mute: isMute, checkIsActiveButton: checkIsActiveButton }) : _react2.default.createElement(
						_reactBootstrap.OverlayTrigger,
						{
							key: 'tlt-buttonsContainer-' + i,
							placement: 'top',
							overlay: _react2.default.createElement(
								_reactBootstrap.Tooltip,
								{ id: 'tooltIpId-tlt-buttonsContainer-' + i, className: 'buttonsContainer-tooltip top show' },
								language.getText('GUICallSpace' + item.tooltip)
							) },
						_react2.default.createElement(
							'div',
							{ className: item.className, key: 'button' + i, onClick: item.action },
							item.image
						)
					));
				})
			)
		);
	};
	
	exports.default = CallButtons;

/***/ },
/* 1106 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Singleton = __webpack_require__(21);
	
	var _constants = __webpack_require__(10);
	
	var _reactRedux = __webpack_require__(25);
	
	var _singletonSharedData = __webpack_require__(23);
	
	var _CardPreviewRecord = __webpack_require__(1107);
	
	var _CardPreviewRecord2 = _interopRequireDefault(_CardPreviewRecord);
	
	var _reactstrap = __webpack_require__(111);
	
	var _ChangeTypeCampaign = __webpack_require__(323);
	
	var _ChangeTypeCampaign2 = _interopRequireDefault(_ChangeTypeCampaign);
	
	var _ContainerSimultaneousRec = __webpack_require__(1109);
	
	var _ContainerSimultaneousRec2 = _interopRequireDefault(_ContainerSimultaneousRec);
	
	var _A_messages_to_SM = __webpack_require__(32);
	
	var _A_preview_transfer = __webpack_require__(193);
	
	var _A_preview = __webpack_require__(52);
	
	var _helperMessages = __webpack_require__(87);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var language = new _Singleton.Singleton();
	var sharedData = new _singletonSharedData.SingletonSharedData();
	
	var CallWindowSimultaneosPreview = function CallWindowSimultaneosPreview() {
	  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
	    return state.preview;
	  }),
	      records = _useSelector.records,
	      defaultDialingRate = _useSelector.defaultDialingRate,
	      callOutId = _useSelector.selectedRecord.callOutId,
	      countRecordsDialing = _useSelector.countRecordsDialing,
	      previewType = _useSelector.previewType;
	
	  var _useSelector2 = (0, _reactRedux.useSelector)(function (state) {
	    return state.agentPermissions;
	  }),
	      allowChangeDialing = _useSelector2.allowChangeDialing;
	
	  var _useSelector3 = (0, _reactRedux.useSelector)(function (state) {
	    return state.previewActions;
	  }),
	      unnasignByXfer = _useSelector3.unnasignByXfer,
	      mainAgent = _useSelector3.mainAgent;
	
	  var _useSelector4 = (0, _reactRedux.useSelector)(function (state) {
	    return state;
	  }),
	      userState = _useSelector4.userState;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  (0, _react.useEffect)(function () {
	    if (unnasignByXfer && records.length === 0) {
	      dispatch((0, _A_preview.cleanData)());
	      setTimeout(function () {
	        dispatch((0, _A_preview_transfer.showPreviewData)(false));
	      }, 50);
	      setTimeout(function () {
	        dispatch((0, _A_messages_to_SM.actionResponseTransfer)(mainAgent, 1));
	      }, 50);
	      dispatch((0, _A_preview_transfer.setUnnasignByXfer)({ flag: false, mainAgent: '' }));
	    }
	  }, [unnasignByXfer, records.length]);
	  (0, _react.useEffect)(function () {
	    if (records.length === 0 && previewType === 2 && userState.currentState === _constants.USER_STATE.AGENT_PREVIEW) {
	      setTimeout(function () {
	        if (userState.currentState === _constants.USER_STATE.AGENT_PREVIEW) {
	          dispatch((0, _A_messages_to_SM.messageToStateMachine)((0, _helperMessages.messageAgentRedy)()));
	        }
	      }, 3500);
	    }
	  }, [records.length]);
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'cwsp-container' },
	    _react2.default.createElement(
	      'div',
	      { className: 'cwsp-containerRec' },
	      _react2.default.createElement(
	        'div',
	        { className: 'cwsp-container-information' },
	        _react2.default.createElement(
	          'div',
	          { className: 'cwsp-general-information' },
	          _react2.default.createElement(
	            'p',
	            { className: 'cwsp-label' },
	            language.getText('GUIPreviewsimultaneousView')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'cwsp-simultaneousRec', id: 'cwsp-simultaneousRec' },
	            defaultDialingRate - countRecordsDialing
	          ),
	          _react2.default.createElement(
	            _reactstrap.UncontrolledTooltip,
	            { innerClassName: 'cwsp-tooltip-dialing-rate', placement: 'top', target: 'cwsp-simultaneousRec', boundariesElement: 'window' },
	            language.getText('GUIPreviewcallsLimit')
	          )
	        ),
	        allowChangeDialing && sharedData.getDataPreviewPro().dialingMode && _constants.STATES_TO_SHOW_CTC.includes(userState.currentState) && _react2.default.createElement(
	          'div',
	          { className: 'cwsp-selection' },
	          _react2.default.createElement(_ChangeTypeCampaign2.default, null)
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'cwsp-records' },
	        records.map(function (r) {
	          return _react2.default.createElement(_CardPreviewRecord2.default, {
	            key: r.callOutId,
	            data1: r.data[0],
	            data2: r.data[1],
	            record: r,
	            defaultDialingRate: defaultDialingRate
	          });
	        })
	      )
	    ),
	    callOutId !== 0 && _react2.default.createElement(_ContainerSimultaneousRec2.default, null)
	  );
	};
	
	exports.default = CallWindowSimultaneosPreview;

/***/ },
/* 1107 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Images = __webpack_require__(30);
	
	var _SelectComponent = __webpack_require__(155);
	
	var _SelectComponent2 = _interopRequireDefault(_SelectComponent);
	
	var _globalComponentsLibrary = __webpack_require__(28);
	
	var _Singleton = __webpack_require__(21);
	
	var _reactRedux = __webpack_require__(25);
	
	var _A_preview = __webpack_require__(52);
	
	var _formats = __webpack_require__(54);
	
	var _A_messages_to_SM = __webpack_require__(32);
	
	var _A_Alert_Modal = __webpack_require__(63);
	
	var _A_Alert_Modal2 = _interopRequireDefault(_A_Alert_Modal);
	
	var _singletonSharedData = __webpack_require__(23);
	
	var _cwGalateaApiJsBundle = __webpack_require__(40);
	
	var _constants = __webpack_require__(10);
	
	var _TimerCardPreview = __webpack_require__(1108);
	
	var _TimerCardPreview2 = _interopRequireDefault(_TimerCardPreview);
	
	var _Strategies_Preview_RecState = __webpack_require__(239);
	
	var _A_reducer_call_acd = __webpack_require__(156);
	
	var _Logger = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var language = new _Singleton.Singleton();
	var showAlertModal = _A_Alert_Modal2.default.creators.showAlertModal;
	
	var sharedData = new _singletonSharedData.SingletonSharedData();
	var APIFact = new _cwGalateaApiJsBundle.APIFactory();
	var apiCont = APIFact.buildClient();
	
	var CardPreviewRecord = function CardPreviewRecord(_ref) {
	    var record = _ref.record,
	        data1 = _ref.data1,
	        data2 = _ref.data2,
	        defaultDialingRate = _ref.defaultDialingRate;
	    var phoneToCall = record.phoneToCall,
	        callKey = record.callKey,
	        campaignName = record.campaignName,
	        phones = record.phones,
	        camId = record.camId,
	        initialTimeSec = record.initialTimeSec,
	        previewTime = record.previewTime,
	        callOutId = record.callOutId,
	        status = record.status,
	        callId = record.callId,
	        maximumAssignments = record.maximumAssignments,
	        itWasSentTimeInPreview = record.itWasSentTimeInPreview,
	        dialogTime = record.dialogTime,
	        _record$dispositionDa = record.dispositionData,
	        alreadyRated = _record$dispositionDa.alreadyRated,
	        exitPreview = _record$dispositionDa.exitPreview,
	        remainingTime = record.remainingTime;
	
	    var _useSelector = (0, _reactRedux.useSelector)(function (state) {
	        return state.preview;
	    }),
	        records = _useSelector.records,
	        fReplacementJob = _useSelector.fReplacementJob,
	        selectedRecord = _useSelector.selectedRecord,
	        isSomeRecInDialog = _useSelector.isSomeRecInDialog,
	        countRecordsDialing = _useSelector.countRecordsDialing,
	        switchBetweenHold = _useSelector.switchBetweenHold,
	        switchBetweenWrapUp = _useSelector.switchBetweenWrapUp,
	        ndScheduled = _useSelector.ndScheduled;
	
	    var _useSelector2 = (0, _reactRedux.useSelector)(function (state) {
	        return state.previewActions;
	    }),
	        transferInProgress = _useSelector2.transferInProgress,
	        unnasignByXfer = _useSelector2.unnasignByXfer,
	        acceptedTransfer = _useSelector2.acceptedTransfer;
	
	    var _useState = (0, _react.useState)([]),
	        _useState2 = _slicedToArray(_useState, 2),
	        objectPhones = _useState2[0],
	        setObjectPhones = _useState2[1];
	
	    var _useState3 = (0, _react.useState)([]),
	        _useState4 = _slicedToArray(_useState3, 2),
	        numbersList = _useState4[0],
	        setNumbersList = _useState4[1];
	
	    var _useState5 = (0, _react.useState)('1'),
	        _useState6 = _slicedToArray(_useState5, 2),
	        displayedComponent = _useState6[0],
	        setDisplayedComponent = _useState6[1];
	
	    var _useState7 = (0, _react.useState)(phoneToCall),
	        _useState8 = _slicedToArray(_useState7, 2),
	        phone = _useState8[0],
	        setPhone = _useState8[1];
	
	    var _useState9 = (0, _react.useState)(''),
	        _useState10 = _slicedToArray(_useState9, 2),
	        borderColor = _useState10[0],
	        setBorderColor = _useState10[1];
	
	    var _useState11 = (0, _react.useState)(language.getText('GUIPreviewtimePreviewMode')),
	        _useState12 = _slicedToArray(_useState11, 2),
	        labelTimer = _useState12[0],
	        setLabelTimer = _useState12[1];
	
	    var _useState13 = (0, _react.useState)(false),
	        _useState14 = _slicedToArray(_useState13, 2),
	        disableBtns = _useState14[0],
	        setDisableBtns = _useState14[1];
	
	    var _useState15 = (0, _react.useState)(false),
	        _useState16 = _slicedToArray(_useState15, 2),
	        disableBtnCall = _useState16[0],
	        setDisableBtnCall = _useState16[1];
	
	    var _useState17 = (0, _react.useState)(false),
	        _useState18 = _slicedToArray(_useState17, 2),
	        disableBtnHoldAndResume = _useState18[0],
	        setDisableBtnHoldAndResume = _useState18[1];
	
	    var _useState19 = (0, _react.useState)(false),
	        _useState20 = _slicedToArray(_useState19, 2),
	        disableBtnHangUp = _useState20[0],
	        setDisableBtnHangUp = _useState20[1];
	
	    var _useState21 = (0, _react.useState)(record.previewDiscard),
	        _useState22 = _slicedToArray(_useState21, 2),
	        showBtnDiscart = _useState22[0],
	        setShowBtnDiscart = _useState22[1];
	
	    var _useState23 = (0, _react.useState)(record.permissionDelete),
	        _useState24 = _slicedToArray(_useState23, 2),
	        showBtnDelete = _useState24[0],
	        setShowBtnDelete = _useState24[1];
	
	    var _useState25 = (0, _react.useState)(true),
	        _useState26 = _slicedToArray(_useState25, 2),
	        showBtnCall = _useState26[0],
	        setShowBtnCall = _useState26[1];
	
	    var _useState27 = (0, _react.useState)(false),
	        _useState28 = _slicedToArray(_useState27, 2),
	        showBtnHangup = _useState28[0],
	        setShowBtnHangup = _useState28[1];
	
	    var _useState29 = (0, _react.useState)(false),
	        _useState30 = _slicedToArray(_useState29, 2),
	        showBtnHoldAndResume = _useState30[0],
	        setShowBtnHoldAndResume = _useState30[1];
	
	    var _useState31 = (0, _react.useState)(initialTimeSec),
	        _useState32 = _slicedToArray(_useState31, 2),
	        iTimeSec = _useState32[0],
	        setITimeSec = _useState32[1];
	
	    var _useState33 = (0, _react.useState)(0),
	        _useState34 = _slicedToArray(_useState33, 2),
	        timeInPreview = _useState34[0],
	        setTimeInPreview = _useState34[1];
	
	    var _useState35 = (0, _react.useState)(false),
	        _useState36 = _slicedToArray(_useState35, 2),
	        isSaveTimeInPreview = _useState36[0],
	        setIsSaveTimeInpreview = _useState36[1];
	    /////////-------------------newTimer
	
	
	    var _useState37 = (0, _react.useState)(false),
	        _useState38 = _slicedToArray(_useState37, 2),
	        resetTimerxDisp = _useState38[0],
	        setResetTimerxDisp = _useState38[1];
	
	    var wrapUp = [_constants.RECORD_STATE.WRAPUP, _constants.RECORD_STATE.ABANDONED, _constants.RECORD_STATE.ALERT];
	    var dispatch = (0, _reactRedux.useDispatch)();
	
	    var _useToasts = (0, _globalComponentsLibrary.useToasts)(),
	        addToast = _useToasts.addToast;
	
	    (0, _react.useEffect)(function () {
	        var numbers = phones.map(function (dato, i) {
	            return { id: i, img: _Images.reprogramacion1, number: dato };
	        });
	        setObjectPhones(numbers);
	        setTimeout(function () {
	            dispatch((0, _A_messages_to_SM.messageApiRequest)(_constants.API_ENDPOINTS.CALL_OUT_CAMPAIGNS, '', true));
	        }, 100);
	    }, []);
	
	    (0, _react.useEffect)(function () {
	        if (status !== _constants.RECORD_STATE.DIALOG) {
	            stopStartTimeWhileIsCalling();
	        }
	    }, [countRecordsDialing]);
	
	    (0, _react.useEffect)(function () {
	        if (objectPhones.length > 0 && numbersList.length === 0) {
	            setNumbersList(objectPhones);
	        }
	    }, [objectPhones]);
	
	    (0, _react.useEffect)(function () {
	        selectedRecord.callOutId === callOutId ? setBorderColor('cpr-selected') : setBorderColor('');
	    }, [selectedRecord.callOutId]);
	
	    (0, _react.useEffect)(function () {
	        if (isSomeRecInDialog || ndScheduled) {
	            setDisableBtnCall(true);
	        } else {
	            defaultDialingRate === countRecordsDialing ? setDisableBtnCall(true) : setDisableBtnCall(false);
	        }
	        resetRecordIfAlertisCancelled();
	    }, [countRecordsDialing, isSomeRecInDialog, ndScheduled]);
	
	    (0, _react.useEffect)(function () {
	
	        cardDesign();
	    }, [status]);
	
	    (0, _react.useEffect)(function () {
	        if (status === _constants.RECORD_STATE.DIALOG && dialogTime !== undefined) {
	            validateDisposition();
	        } else if (status === _constants.RECORD_STATE.DEFAULT && dialogTime !== undefined) {
	            dispatch((0, _A_preview.setDialogTimeSimultaneousView)({ callOutId: callOutId, dialogTime: undefined }));
	        }
	    }, [status, dialogTime]);
	
	    (0, _react.useEffect)(function () {
	        if (sharedData.callOutCampaigns) {
	            var campaigns = Object.values(sharedData.callOutCampaigns);
	            if (callOutId) {
	                if (maximumAssignments < 0) {
	                    var campaign = campaigns.find(function (campaign) {
	                        return campaign.ID === camId;
	                    });
	                    var maxAssign = campaign !== undefined && campaign.TimesPreview > 0 ? campaign.TimesPreview : 1;
	                    dispatch((0, _A_preview.setMaximumAssignmentPreview)({ callOutId: callOutId, maximumAssignments: maxAssign }));
	                }
	            }
	        }
	    }, [sharedData.callOutCampaigns]);
	
	    (0, _react.useEffect)(function () {
	        if (status === _constants.RECORD_STATE.DEFAULT && maximumAssignments === 0) {
	            dispatch((0, _A_messages_to_SM.actionPreviewRecord)({ process: 16, camId: camId, callOutId: callOutId, previewTime: 0, callId: 0, fMultipleJob: 1, fReplacementJob: 0 }));
	            dispatch((0, _A_preview.removeRecord)(callOutId));
	        }
	    }, [maximumAssignments, status]);
	
	    var cardDesign = function cardDesign() {
	        switch (status) {
	            case _constants.RECORD_STATE.TIME_OVER:
	                cardDesignOnTimeOver();
	                break;
	
	            case _constants.RECORD_STATE.DIALOG:
	                !itWasSentTimeInPreview && sendTime();
	                selectRecord();
	                cardDesignDialog();
	                break;
	
	            case _constants.RECORD_STATE.DIALING:
	                cardDesignDialing();
	                break;
	
	            case _constants.RECORD_STATE.WRAPUP:
	            case _constants.RECORD_STATE.WAITING_WRAPUP:
	                cardDesignWrapUp();
	                break;
	
	            case _constants.RECORD_STATE.HOLD:
	                cardDesignHold();
	                break;
	
	            case _constants.RECORD_STATE.ALERT:
	                sendTime();
	                cardDesignAlert();
	                break;
	
	            case _constants.RECORD_STATE.DEFAULT:
	                cardDesignDefault();
	                break;
	            case _constants.RECORD_STATE.ABANDONED:
	                cardDesingAbandoned();
	                break;
	            default:
	                dispatch((0, _A_preview.changePreviewRecordStatus)({ callOutId: callOutId, status: _constants.RECORD_STATE.DEFAULT }));
	                break;
	        };
	    };
	    (0, _react.useEffect)(function () {
	        if (status === _constants.RECORD_STATE.HOLD && disableBtnHoldAndResume !== transferInProgress) {
	            setDisableBtnHoldAndResume(transferInProgress);
	        }
	    }, [transferInProgress, status]);
	
	    (0, _react.useEffect)(function () {
	        if (unnasignByXfer) {
	            setTimeout(function () {
	                var time = (0, _formats.getCurrentTimeInSec)() - iTimeSec + timeInPreview;
	                dispatch((0, _A_messages_to_SM.actionPreviewRecord)({ process: 4, camId: camId, callOutId: callOutId, previewTime: time, callId: callId }));
	            }, 50);
	            dispatch((0, _A_preview.removeRecord)(callOutId));
	        }
	    }, [unnasignByXfer]);
	
	    var selectPhone = function selectPhone(p) {
	        setPhone(p.number);
	    };
	
	    var setTimeLeft = function setTimeLeft() {
	        var time = countRecordsDialing > 0 ? previewTime - timeInPreview : previewTime - ((0, _formats.getCurrentTimeInSec)() - iTimeSec + timeInPreview);
	        return time;
	    };
	
	    var cardDesignOnTimeOver = function cardDesignOnTimeOver() {
	        dispatch((0, _A_preview.changePreviewRecordStatus)({ callOutId: callOutId, status: _constants.RECORD_STATE.TIME_OVER }));
	    };
	    var cardDesignDialing = function cardDesignDialing() {
	        setLabelTimer(language.getText('GUIPreviewmax-dialing-time'));
	        setDisableBtns(true);
	        setShowBtnDiscart(false);
	        setShowBtnCall(true);
	        setShowBtnHangup(true);
	        setShowBtnHoldAndResume(false);
	        setShowBtnDelete(false);
	    };
	    var cardDesignHangUp = function cardDesignHangUp() {
	        setDisableBtnHangUp(true);
	    };
	    var cardDesignDialog = function cardDesignDialog() {
	        setLabelTimer(language.getText('GUIPreviewengagedTimer'));
	        setShowBtnDiscart(false);
	        setShowBtnDelete(false);
	        setShowBtnCall(false);
	        setShowBtnHangup(true);
	        setShowBtnHoldAndResume(true);
	    };
	    var cardDesignHold = function cardDesignHold() {
	        setLabelTimer(language.getText('GUIPreviewengagedTimer'));
	        setShowBtnCall(false);
	        setShowBtnDiscart(false);
	        setShowBtnDelete(false);
	        setShowBtnHangup(true);
	        setShowBtnHoldAndResume(true);
	    };
	    var cardDesignAlert = function cardDesignAlert() {
	        setDisableBtnCall(true);
	        setShowBtnHangup(false);
	    };
	
	    var cardDesignDefault = function cardDesignDefault() {
	        setDisableBtnHangUp(false);
	        setLabelTimer(language.getText('GUIPreviewtimePreviewMode'));
	        setDisableBtns(false);
	        setShowBtnDiscart(record.previewDiscard);
	        setShowBtnCall(true);
	        setShowBtnDelete(record.permissionDelete);
	        setShowBtnHangup(false);
	        setShowBtnHoldAndResume(false);
	        ndScheduled || isSomeRecInDialog ? setDisableBtnCall(true) : setDisableBtnCall(false);
	        setResetTimerxDisp(false);
	    };
	
	    var cardDesignWrapUp = function cardDesignWrapUp() {
	        setLabelTimer(language.getText('GUIPreviewengagedTimer'));
	        setDisableBtns(false);
	        setShowBtnDiscart(record.previewDiscard);
	        setShowBtnCall(true);
	        setShowBtnDelete(record.permissionDelete);
	        setShowBtnHangup(false);
	        setShowBtnHoldAndResume(false);
	        setDisableBtnCall(true);
	    };
	    var cardDesingAbandoned = function cardDesingAbandoned() {
	        setLabelTimer(language.getText('GUIPreviewengagedTimer'));
	        setDisableBtnHoldAndResume(true);
	        setDisableBtnHangUp(true);
	        setShowBtnHangup(true);
	        setShowBtnHoldAndResume(true);
	        abandonedRec(language.getText('GUIPreviewcallAbandonedMssg').replace('[n]', '[' + phoneToCall + ']'));
	    };
	
	    var actionCall = function actionCall() {
	        _Logger.Logger.Info("[CardPreviewRecord][actionCall] => ", JSON.stringify({ callKey: callKey, callId: callId, status: status, process: process, record: record }));
	
	        status === _constants.RECORD_STATE.DIALOG ? holdOrResume() : callPreview();
	    };
	
	    var holdOrResume = function holdOrResume() {
	        dispatch((0, _A_messages_to_SM.actionPreviewRecord)({ process: 11, camId: camId, callOutId: callOutId, previewTime: previewTime, callId: 0, fMultipleJob: records.length === 1 ? 0 : 1, fReplacementJob: fReplacementJob }));
	    };
	
	    var callPreview = function callPreview() {
	        var time = setTimeLeft();
	        dispatch((0, _A_preview.changePreviewRecordStatus)({ callOutId: callOutId, status: _constants.RECORD_STATE.DIALING, remainingTime: time }));
	        dispatch((0, _A_preview.setPhoneToCallPerRec)({ callOutId: callOutId, phone: phone }));
	
	        var data = {
	            CamId: camId, CallKey: callKey,
	            Phone: phone, Data: "", ExistsCallout: callOutId, CallMode: 0, integration: false
	        };
	        setTimeout(function () {
	            dispatch((0, _A_messages_to_SM.manualCall)(data));
	        }, 100);
	    };
	
	    var discard = function discard() {
	        _Logger.Logger.Info("[CardPreviewRecord][discard] => ", JSON.stringify({ callKey: callKey, callId: callId, status: status, process: process, record: record }));
	        var timeout = sharedData.getRequestTimeout();
	        var userId = sharedData.getParameters().UserID;
	        var acdId = 1;
	        var objectResponseTransfer = apiCont.getObjectResponse();
	
	        apiCont.transferCall(userId, acdId, objectResponseTransfer, timeout);
	        objectResponseTransfer.onError = function (messageError) {
	            _Logger.Logger.Error('[CardPreviewRecord][discard]', messageError);
	        };
	        objectResponseTransfer.onSuccess = function (objectResponseTransfer) {
	            dispatch(showAlertModal({
	                type: "ModalAlert",
	                title: language.getText('GUIPreviewunassignRecordTitle'),
	                message: language.getText('GUIPreviewunassignRecordBody'),
	                button: language.getText('GUIPreviewcancel'),
	                secondButton: language.getText('GUIPreviewconfirmUnassign'),
	                secondButtonFtn: function secondButtonFtn() {
	                    sharedData.setAgentList(objectResponseTransfer.AgentesList);
	                    processDeleteDiscard(0);
	                }
	            }));
	        };
	    };
	
	    var deleteRecord = function deleteRecord() {
	        dispatch(showAlertModal({
	            type: "ModalAlert",
	            title: language.getText('GUIAlertMessagedeletePreviewRecord'),
	            message: language.getText('GUIAlertMessagemsgDeletePreviewRecord'),
	            button: language.getText('GUIAlertMessagecancel'),
	            secondButton: language.getText('GUIPreviewdelete'),
	            secondButtonFtn: function secondButtonFtn() {
	                return processDeleteDiscard(1);
	            }
	        }));
	    };
	
	    var processDeleteDiscard = function processDeleteDiscard(process) {
	        _Logger.Logger.Info("[CardPreviewRecord][processDeleteDiscard] => ", JSON.stringify({ callKey: callKey, callId: callId, status: status, process: process, record: record }));
	
	        var time = (0, _formats.getCurrentTimeInSec)() - iTimeSec + timeInPreview;
	        setTimeout(function () {
	            dispatch((0, _A_messages_to_SM.actionPreviewRecord)({ process: process, camId: camId, callOutId: callOutId, previewTime: time, callId: 0, fMultipleJob: records.length === 1 ? 0 : 1, fReplacementJob: fReplacementJob }));
	        }, 100);
	        dispatch((0, _A_preview.removeRecord)(callOutId));
	    };
	    var resumeAndHold = function resumeAndHold() {
	        if (status === _constants.RECORD_STATE.DIALOG) {
	            dispatch((0, _A_reducer_call_acd.callAction)(_constants.ACTION_CALL_ACD.HOLD, {}, callOutId));
	            dispatch((0, _A_preview.changePreviewRecordStatus)({ callOutId: callOutId, status: _constants.RECORD_STATE.HOLD }));
	        } else if (status === _constants.RECORD_STATE.HOLD) {
	            hold();
	        }
	    };
	    var hold = function hold() {
	        _Logger.Logger.Info("[CardPreviewRecord][hold] => ", JSON.stringify({ callKey: callKey, callId: callId, status: status, process: process, record: record }));
	        var recordInDialog = records.find(function (r) {
	            return r.status === _constants.RECORD_STATE.DIALOG;
	        });
	        if (recordInDialog === undefined) {
	            dispatch((0, _A_reducer_call_acd.callAction)(_constants.ACTION_CALL_ACD.HOLD, {}, callOutId));
	        } else {
	            if (recordInDialog.callOutId === callOutId) {
	                dispatch((0, _A_reducer_call_acd.callAction)(_constants.ACTION_CALL_ACD.HOLD, {}, callOutId));
	            } else {
	                setTimeout(function () {
	                    dispatch((0, _A_messages_to_SM.actionPreviewRecord)({ process: 11, camId: camId, callOutId: callOutId, previewTime: 0, callId: callId }));
	                }, 50);
	            }
	        }
	        dispatch((0, _A_preview.changePreviewRecordStatus)({ callOutId: callOutId, status: _constants.RECORD_STATE.DIALOG }));
	    };
	
	    var hangup = function hangup() {
	        _Logger.Logger.Info("[CardPreviewRecord][hangup] => ", JSON.stringify({ callKey: callKey, callId: callId, status: status, record: record }));
	
	        cardDesignHangUp();
	        status === _constants.RECORD_STATE.DIALOG || status === _constants.RECORD_STATE.HOLD ? setTimeout(function () {
	            dispatch((0, _A_messages_to_SM.messageHangUp)(_constants.HANG_UP_SUBACTIONS.CALL, callOutId));
	        }, 100) : setTimeout(function () {
	            dispatch((0, _A_messages_to_SM.messageHangUp)(_constants.HANG_UP_SUBACTIONS.MANUAL_CALL, callOutId));
	        }, 100);
	        validateDisposition();
	    };
	    var validateDisposition = function validateDisposition() {
	        if (alreadyRated && exitPreview) {
	            dispatch((0, _A_preview.removeRecord)(selectedRecord.callOutId));
	        } else if (alreadyRated && !exitPreview) {
	            resetRecord();
	        }
	    };
	
	    var resetRecord = function resetRecord() {
	        _Logger.Logger.Info("[CardPreviewRecord][resetRecord] => ", JSON.stringify({ callKey: callKey, callId: callId, status: status, record: record }));
	
	        var temp = maximumAssignments - 1;
	        dispatch((0, _A_preview.setWasItwasSentPreviewTime)({ callOutId: callOutId, itWasSent: false }));
	        dispatch((0, _A_preview.setMaximumAssignmentPreview)({ callOutId: callOutId, maximumAssignments: temp }));
	        setTimeout(function () {
	            var replacement = temp === 0 ? fReplacementJob : 0;
	            dispatch((0, _A_messages_to_SM.actionPreviewRecord)({ process: 5, camId: record.camId, callOutId: callOutId, previewTime: previewTime, callId: 0, fMultipleJob: records.length === 1 ? 0 : 1, fReplacementJob: replacement }));
	        }, 100);
	        dispatch((0, _A_preview.resetRecordPreview)(callOutId));
	    };
	
	    var selectRecord = function selectRecord() {
	        dispatch((0, _A_preview.setSelectedRecord)(callOutId));
	    };
	
	    var sendTime = function sendTime() {
	        var time = (0, _formats.getCurrentTimeInSec)() - iTimeSec + timeInPreview;
	        if (status === _constants.RECORD_STATE.ALERT && record.messageStatus === '1512') {
	            setTimeout(function () {
	                dispatch((0, _A_messages_to_SM.actionPreviewRecord)({ process: 13, camId: camId, callOutId: callOutId, previewTime: time, callId: callId }));
	            }, 50);
	        } else if (status === _constants.RECORD_STATE.DIALOG && !itWasSentTimeInPreview) {
	            setTimeout(function () {
	                dispatch((0, _A_messages_to_SM.actionPreviewRecord)({ process: 7, camId: camId, callOutId: callOutId, previewTime: time, callId: callId }));
	            }, 50);
	        }
	        dispatch((0, _A_preview.setWasItwasSentPreviewTime)({ callOutId: callOutId, itWasSent: true }));
	    };
	
	    var stopStartTimeWhileIsCalling = function stopStartTimeWhileIsCalling() {
	        if (countRecordsDialing > 0 && !isSaveTimeInPreview) {
	            var tempT = (0, _formats.getCurrentTimeInSec)() - iTimeSec;
	            setTimeInPreview(tempT + timeInPreview);
	            setIsSaveTimeInpreview(true);
	        } else if (countRecordsDialing === 0) {
	            setIsSaveTimeInpreview(false);
	            setITimeSec((0, _formats.getCurrentTimeInSec)());
	        }
	    };
	    var resetRecordIfAlertisCancelled = function resetRecordIfAlertisCancelled() {
	        if (status === _constants.RECORD_STATE.ALERT && !isSomeRecInDialog && countRecordsDialing === 0 && (record.messageStatus === '1512' || record.messageStatus === '1508')) {
	            dispatch((0, _A_preview.resetRecordPreview)(callOutId));
	        }
	    };
	    var messageResponseCard = (0, _react.useMemo)(function () {
	        return (0, _Strategies_Preview_RecState.errorsMessagePreviewSR)(record.messageStatus);
	    }, [record.messageStatus]);
	
	    var abandonedRec = function abandonedRec(message) {
	        addToast(message, {
	            group: 'icon',
	            position: 'topRight',
	            icon: 'warning',
	            color: 'yellow',
	            btnComponent: _react2.default.createElement(
	                _globalComponentsLibrary.AgentButton,
	                { type: 'tertiary' },
	                language.getText("GUIAlertMessageclose")
	            ),
	            timeout: 5000
	        });
	    };
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'cpr-container ' + status + ' ' + borderColor, onClick: (!isSomeRecInDialog || switchBetweenHold && status === _constants.RECORD_STATE.HOLD || switchBetweenWrapUp && wrapUp.includes(status) && !wrapUp.includes(selectedRecord.status)) && selectRecord },
	        _react2.default.createElement(
	            'div',
	            { className: 'cpr-infoContainer' },
	            _react2.default.createElement(
	                'div',
	                { className: 'cpr-dataContainer' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'cpr-callKeyContainer' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'cpr-callKeyIcon' },
	                        _react2.default.createElement('img', { src: _Images.key, alt: 'icon' })
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'cpr-callKey' },
	                        callKey
	                    )
	                ),
	                _react2.default.createElement(
	                    'p',
	                    { className: 'cpr-campaingName' },
	                    campaignName
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'cpr-dataContainer' },
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'cpr-data' },
	                        data1
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'cpr-data' },
	                        data2
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'cpr-campInfoContainer' },
	                _react2.default.createElement(_TimerCardPreview2.default, {
	                    fReplacementJob: fReplacementJob,
	                    cardDesignOnTimeOver: cardDesignOnTimeOver,
	                    record: record,
	                    labelTimer: labelTimer,
	                    resetTimerxDisp: resetTimerxDisp
	                }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'cpr-selectPhoneContainer' },
	                    numbersList.length > 0 && _react2.default.createElement(_SelectComponent2.default, {
	
	                        bottomBox: 60,
	                        defaultDiv: { item: "texSelection" },
	                        displayer: "bigDisplayer",
	                        customCell: "cellImageText",
	                        parameters: { image: "img", text: "number" },
	                        dataSource: numbersList,
	                        closeOthers: true,
	                        itemDefault: 0,
	                        displayedList: displayedComponent,
	                        onSelectItem: selectPhone })
	                ),
	                messageResponseCard && _react2.default.createElement(
	                    'div',
	                    { className: 'cpr-status-call' },
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        messageResponseCard
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'cpr-btnContainer' },
	            showBtnDiscart && _react2.default.createElement(
	                'div',
	                { className: 'cpr-styleBtn' },
	                _react2.default.createElement(
	                    _globalComponentsLibrary.AgentButton,
	                    { type: 'secondary', color: 'blue', icon: 'discart', disabled: disableBtns, onClick: discard },
	                    language.getText('GUIPreviewdiscard')
	                )
	            ),
	            showBtnCall && _react2.default.createElement(
	                'div',
	                { className: 'cpr-styleBtn' },
	                _react2.default.createElement(
	                    _globalComponentsLibrary.AgentButton,
	                    { type: 'primary', color: 'green ' + (status === _constants.RECORD_STATE.DIALING ? 'v2' : ''), icon: '' + (status === _constants.RECORD_STATE.DIALING ? 'dialing' : 'call'), disabled: disableBtnCall || disableBtns, onClick: actionCall },
	                    status === _constants.RECORD_STATE.DIALING ? language.getText('GUIPreviewdialing') : language.getText('GUIPreviewdial')
	                )
	            ),
	            showBtnDelete && _react2.default.createElement(
	                'div',
	                { className: 'cpr-styleBtn' },
	                _react2.default.createElement(
	                    _globalComponentsLibrary.AgentButton,
	                    { type: 'secondary', color: 'red', icon: 'trash', disabled: disableBtns, onClick: deleteRecord },
	                    language.getText('GUIPreviewdelete')
	                )
	            ),
	            showBtnHoldAndResume && _react2.default.createElement(
	                'div',
	                { className: 'cpr-styleBtn' },
	                _react2.default.createElement(
	                    _globalComponentsLibrary.AgentButton,
	                    { type: 'primary', color: 'green', icon: '' + (status === _constants.RECORD_STATE.DIALOG ? 'hold' : 'resume'), disabled: disableBtnHoldAndResume, onClick: resumeAndHold },
	                    status === _constants.RECORD_STATE.DIALOG ? language.getText('GUIPreviewhold') : language.getText('GUIPreviewresume')
	                )
	            ),
	            showBtnHangup && _react2.default.createElement(
	                'div',
	                { className: 'cpr-styleBtn' },
	                _react2.default.createElement(
	                    _globalComponentsLibrary.AgentButton,
	                    { type: 'secondary', color: 'red', icon: 'call-out', disabled: disableBtnHangUp, onClick: hangup },
	                    language.getText('GUIPreviewhangup')
	                )
	            )
	        )
	    );
	};
	
	exports.default = CardPreviewRecord;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(902)))

/***/ },
/* 1108 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _globalComponentsLibrary = __webpack_require__(28);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(25);
	
	var _constants = __webpack_require__(10);
	
	var _A_messages_to_SM = __webpack_require__(32);
	
	var _A_preview = __webpack_require__(52);
	
	var _Singleton = __webpack_require__(21);
	
	var _StopWatchSimultaneousPreview = __webpack_require__(1081);
	
	var _StopWatchSimultaneousPreview2 = _interopRequireDefault(_StopWatchSimultaneousPreview);
	
	var _Logger = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var language = new _Singleton.Singleton();
	var TimerCardPreview = function TimerCardPreview(_ref) {
	    var fReplacementJob = _ref.fReplacementJob,
	        cardDesignOnTimeOver = _ref.cardDesignOnTimeOver,
	        record = _ref.record,
	        labelTimer = _ref.labelTimer;
	    var callKey = record.callKey,
	        isTimeAscending = record.isTimeAscending,
	        camId = record.camId,
	        previewTime = record.previewTime,
	        callOutId = record.callOutId,
	        initPreviewTime = record.initPreviewTime,
	        status = record.status,
	        dialogTime = record.dialogTime,
	        alreadyRated = record.dispositionData.alreadyRated,
	        calloutMaxTime = record.calloutMaxTime,
	        remainingTime = record.remainingTime;
	
	    var _useState = (0, _react.useState)(0),
	        _useState2 = _slicedToArray(_useState, 2),
	        secsDialog = _useState2[0],
	        setSecsDialog = _useState2[1];
	
	    var _useToasts = (0, _globalComponentsLibrary.useToasts)(),
	        addToast = _useToasts.addToast;
	
	    var _useSelector = (0, _reactRedux.useSelector)(function (state) {
	        return state.preview;
	    }),
	        records = _useSelector.records,
	        countRecords = _useSelector.countRecords,
	        isSomeRecInDialog = _useSelector.isSomeRecInDialog,
	        countRecordsDialing = _useSelector.countRecordsDialing;
	
	    var _useState3 = (0, _react.useState)(countRecordsDialing > 0 || isSomeRecInDialog ? _StopWatchSimultaneousPreview.timerActions.stop : _StopWatchSimultaneousPreview.timerActions.start),
	        _useState4 = _slicedToArray(_useState3, 2),
	        timerAction = _useState4[0],
	        setTimerAction = _useState4[1];
	
	    var prevStatus = (0, _react.useRef)(status);
	
	    var dispatch = (0, _reactRedux.useDispatch)();
	
	    (0, _react.useEffect)(function () {
	        //stop timer because is other record in dialog
	        if (status === _constants.RECORD_STATE.DEFAULT && dialogTime === undefined && !alreadyRated) {
	            isSomeRecInDialog ? setTimerAction(_StopWatchSimultaneousPreview.timerActions.stop) : setTimerAction(_StopWatchSimultaneousPreview.timerActions.start);
	        }
	        //stop timer because maximum numbers of simultaneous records was reached
	        if (status === _constants.RECORD_STATE.DEFAULT && dialogTime === undefined && !alreadyRated && !isSomeRecInDialog) {
	            countRecordsDialing > 0 ? setTimerAction(_StopWatchSimultaneousPreview.timerActions.stop) : setTimerAction(_StopWatchSimultaneousPreview.timerActions.start);
	        }
	    }, [isSomeRecInDialog, countRecordsDialing]);
	
	    (0, _react.useEffect)(function () {
	        switch (status) {
	            case _constants.RECORD_STATE.DIALING:
	                if (calloutMaxTime > 0) {
	                    setSecsDialog(calloutMaxTime);
	                    setTimerAction(_StopWatchSimultaneousPreview.timerActions.startByDialing);
	                }
	
	                break;
	
	            case _constants.RECORD_STATE.DIALOG:
	                if (dialogTime > 0) {
	                    setTimerAction(_StopWatchSimultaneousPreview.timerActions.stop);
	                } else {
	                    setTimerAction(_StopWatchSimultaneousPreview.timerActions.restartFromZero);
	                }
	                break;
	
	            case _constants.RECORD_STATE.HOLD:
	                setTimerAction(_StopWatchSimultaneousPreview.timerActions.restartFromZero);
	                break;
	
	            case _constants.RECORD_STATE.ALERT:
	                if (prevStatus.current === _constants.RECORD_STATE.DIALING) {
	                    setTimerAction(_StopWatchSimultaneousPreview.timerActions.stop);
	                } else {
	
	                    setTimerAction(_StopWatchSimultaneousPreview.timerActions.stopInZero);
	                }
	                break;
	
	            case _constants.RECORD_STATE.DEFAULT:
	                currentStatusDefaultActions();
	                break;
	
	            case _constants.RECORD_STATE.WRAPUP:
	                if (dialogTime > 0) {
	                    setSecsDialog(Math.round(dialogTime));
	                    setTimerAction(_StopWatchSimultaneousPreview.timerActions.restartFromDialogAndStop);
	                }
	                break;
	            case _constants.RECORD_STATE.WAITING_WRAPUP:
	                setTimerAction(_StopWatchSimultaneousPreview.timerActions.restartFromDialogAndStop);
	                break;
	            case _constants.RECORD_STATE.ABANDONED:
	                if (dialogTime > 0) {
	                    setSecsDialog(Math.round(dialogTime));
	                    setTimerAction(_StopWatchSimultaneousPreview.timerActions.restartFromDialogAndStop);
	                }
	            default:
	                break;
	        }
	        prevStatus.current = status;
	    }, [status, dialogTime, calloutMaxTime]);
	
	    var currentStatusDefaultActions = function currentStatusDefaultActions() {
	
	        var previousStatusValidate = [_constants.RECORD_STATE.ALERT, _constants.RECORD_STATE.WRAPUP, _constants.RECORD_STATE.DIALOG].includes(prevStatus.current);
	
	        var stopInRemainingTime = [_constants.RECORD_STATE.DIALING].includes(prevStatus.current);
	
	        var stopAfterDefault = [_constants.RECORD_STATE.DEFAULT].includes(prevStatus.current);
	
	        if (stopAfterDefault && isSomeRecInDialog) {
	            setTimerAction(_StopWatchSimultaneousPreview.timerActions.stop);
	        } else if (previousStatusValidate) {
	            setTimerAction(_StopWatchSimultaneousPreview.timerActions.restartFromInitialSecAndStart);
	        } else if (stopInRemainingTime) {
	
	            setSecsDialog(Math.round(remainingTime));
	            if (isSomeRecInDialog || countRecordsDialing > 0) {
	                setTimerAction(_StopWatchSimultaneousPreview.timerActions.restartFromDialogAndStop);
	            } else {
	                setTimerAction(_StopWatchSimultaneousPreview.timerActions.restartFromDialogAndStart);
	            }
	        }
	    };
	
	    var onTimeOver = function onTimeOver() {
	        if (status === _constants.RECORD_STATE.DEFAULT) {
	            _Logger.Logger.Info("[TimeCardPreview][onTimeOver] => ", JSON.stringify({ callKey: callKey, status: status, fReplacementJob: fReplacementJob, record: record }));
	            cardDesignOnTimeOver();
	            timeIsOver(language.getText('GUIAlertMessagesimultaneousViewTimeExpired').replace('[N]', '[' + callKey + ']'));
	            setTimeout(function () {
	                dispatch((0, _A_messages_to_SM.actionPreviewRecord)({ process: 2, camId: camId, callOutId: callOutId, previewTime: initPreviewTime, callId: 0, fMultipleJob: records.length === 1 ? 0 : 1, fReplacementJob: fReplacementJob }));
	            }, 100);
	            setTimeout(function () {
	                dispatch((0, _A_preview.incrementDiscardedRegisters)());
	            }, 100);
	            setTimeout(function () {
	                dispatch((0, _A_preview.removeRecord)(callOutId));
	            }, 100);
	        }
	    };
	
	    var timeIsOver = function timeIsOver(message) {
	        addToast(message, {
	            group: 'icon',
	            position: 'topRight',
	            icon: 'warning',
	            color: 'yellow',
	            btnComponent: _react2.default.createElement(
	                _globalComponentsLibrary.AgentButton,
	                { type: 'tertiary' },
	                language.getText("GUIAlertMessageclose")
	            ),
	            timeout: 5000
	        });
	    };
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'cpr-timerContainer' },
	        _react2.default.createElement(
	            'div',
	            { className: 'cpr-labelTime ' + status },
	            labelTimer
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'cpr-timerContainer' },
	            _react2.default.createElement(
	                'p',
	                { className: 'cpr-timeCallBold ' + status },
	                _react2.default.createElement(_StopWatchSimultaneousPreview2.default, {
	                    onTimeOver: onTimeOver,
	                    secondsInitial: remainingTime > 0 ? remainingTime : previewTime,
	                    secondsDialog: secsDialog,
	                    isTimeAscending: status === _constants.RECORD_STATE.DIALOG || status === _constants.RECORD_STATE.HOLD ? true : status === _constants.RECORD_STATE.DIALING ? false : isTimeAscending,
	                    timerAction: timerAction,
	                    status: status,
	                    id: callKey
	                })
	            )
	        )
	    );
	};
	
	exports.default = TimerCardPreview;

/***/ },
/* 1109 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RateCallSimultaneousPreview = __webpack_require__(1111);
	
	var _RateCallSimultaneousPreview2 = _interopRequireDefault(_RateCallSimultaneousPreview);
	
	var _constants = __webpack_require__(10);
	
	var _globalComponentsLibrary = __webpack_require__(28);
	
	var _Singleton = __webpack_require__(21);
	
	var _DataAndLog = __webpack_require__(1110);
	
	var _DataAndLog2 = _interopRequireDefault(_DataAndLog);
	
	var _A_messages_to_SM = __webpack_require__(32);
	
	var _reactRedux = __webpack_require__(25);
	
	var _CallButtons = __webpack_require__(1105);
	
	var _CallButtons2 = _interopRequireDefault(_CallButtons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var language = new _Singleton.Singleton();
	
	var ContainerSimultaneousRec = function ContainerSimultaneousRec() {
	  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
	    return state.preview;
	  }),
	      selectedRecord = _useSelector.selectedRecord;
	
	  var _useState = (0, _react.useState)(true),
	      _useState2 = _slicedToArray(_useState, 2),
	      showDataLogDisp = _useState2[0],
	      setShowDataLogDisp = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      showOnlyData = _useState4[0],
	      setShowOnlyData = _useState4[1];
	
	  var _useState5 = (0, _react.useState)({ disabledUpdate: true, newArray: [] }),
	      _useState6 = _slicedToArray(_useState5, 2),
	      newData = _useState6[0],
	      setNewData = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(false),
	      _useState8 = _slicedToArray(_useState7, 2),
	      showWrapUpView = _useState8[0],
	      setShowWrapUpView = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(false),
	      _useState10 = _slicedToArray(_useState9, 2),
	      showButtons = _useState10[0],
	      setShowButtons = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(false),
	      _useState12 = _slicedToArray(_useState11, 2),
	      isRateInDialog = _useState12[0],
	      setIsRateInDialog = _useState12[1];
	
	  (0, _react.useEffect)(function () {
	    if (selectedRecord.status === _constants.RECORD_STATE.WRAPUP || selectedRecord.status === _constants.RECORD_STATE.ALERT && selectedRecord.messageStatus !== '1512' && selectedRecord.messageStatus !== '1508' || selectedRecord.status === _constants.RECORD_STATE.ABANDONED || selectedRecord.status === _constants.RECORD_STATE.WAITING_WRAPUP) {
	      setShowWrapUpView(true);
	    } else {
	      setShowWrapUpView(false);
	    }
	  }, [selectedRecord.status, selectedRecord.messageStatus]);
	
	  (0, _react.useEffect)(function () {
	    if (showWrapUpView || selectedRecord.status === _constants.RECORD_STATE.DIALOG) {
	      setShowButtons(true);
	    } else {
	      setShowButtons(false);
	    }
	  }, [showWrapUpView, selectedRecord.status]);
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'csr-container ' + (showOnlyData ? 'onlyData' : '') },
	    _react2.default.createElement(
	      'div',
	      { className: 'csr-container-rate-data-log' },
	      isRateInDialog && _react2.default.createElement('div', { className: 'noAvailableLocked' }),
	      showOnlyData && showWrapUpView && _react2.default.createElement(
	        'div',
	        { className: 'csr-container-arrow', onClick: function onClick() {
	            return setShowOnlyData(function (o) {
	              return !o;
	            });
	          } },
	        _react2.default.createElement('i', { className: 'gcl-icon chevron' })
	      ),
	      !showOnlyData && showWrapUpView && _react2.default.createElement(_RateCallSimultaneousPreview2.default, {
	        setShowDataLogDisp: setShowDataLogDisp,
	        newData: newData }),
	      (showDataLogDisp || showOnlyData) && _react2.default.createElement(_DataAndLog2.default, {
	        showOnlyData: showOnlyData,
	        showDataLogDisp: showWrapUpView ? showDataLogDisp : false,
	        onChange: setNewData
	      })
	    ),
	    showButtons && _react2.default.createElement(ContainerBtns, {
	      showDataLogDisp: showDataLogDisp,
	      showOnlyData: showOnlyData,
	      setShowOnlyData: setShowOnlyData,
	      recordToShow: selectedRecord,
	      newData: newData,
	      status: selectedRecord.status,
	      isRateInDialog: isRateInDialog,
	      setIsRateInDialog: setIsRateInDialog })
	  );
	};
	
	var ContainerBtns = function ContainerBtns(_ref) {
	  var setShowOnlyData = _ref.setShowOnlyData,
	      showOnlyData = _ref.showOnlyData,
	      showDataLogDisp = _ref.showDataLogDisp,
	      recordToShow = _ref.recordToShow,
	      newData = _ref.newData,
	      status = _ref.status,
	      isRateInDialog = _ref.isRateInDialog,
	      setIsRateInDialog = _ref.setIsRateInDialog;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	  var sendData = function sendData() {
	    var temp = [].concat(_toConsumableArray(newData.newArray));
	    while (temp.length < 15) {
	      temp.push('');
	    }
	    dispatch((0, _A_messages_to_SM.updateInfoCall)(recordToShow.callKey, recordToShow.camId, temp, recordToShow.callOutId));
	  };
	  return _react2.default.createElement(
	    'div',
	    { className: 'csr-container-btns' },
	    _react2.default.createElement(
	      'div',
	      { className: 'csr-btn-main-container' },
	      !showDataLogDisp && !showOnlyData && _react2.default.createElement(
	        'div',
	        { className: 'csr-btn-container ' + (showDataLogDisp ? 'onlyData' : '') },
	        _react2.default.createElement(
	          'div',
	          { className: 'csr-container-arrow', onClick: function onClick() {
	              return setShowOnlyData(function (o) {
	                return !o;
	              });
	            } },
	          _react2.default.createElement('i', { className: 'gcl-icon chevron-up' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'csr-label-container' },
	          language.getText('CallControlGUIContactDatatitle')
	        )
	      ),
	      (showDataLogDisp || showOnlyData) && _react2.default.createElement(
	        'div',
	        { className: 'csr-btn-container' },
	        _react2.default.createElement(
	          _globalComponentsLibrary.AgentButton,
	          { type: 'primary', color: '' + (status === _constants.RECORD_STATE.DIALOG ? 'blue' : 'blue v2'), disabled: newData.disabledUpdate, onClick: sendData },
	          language.getText("CallControlGUIContactDatabuttom")
	        )
	      )
	    ),
	    status === _constants.RECORD_STATE.DIALOG && _react2.default.createElement(
	      'div',
	      { className: 'call-buttons-container' },
	      _react2.default.createElement(_CallButtons2.default, { initialDialogTime: recordToShow.timeOnDialog, recordToShow: recordToShow, isRateInDialog: isRateInDialog, setIsRateInDialog: setIsRateInDialog })
	    )
	  );
	};
	
	exports.default = ContainerSimultaneousRec;

/***/ },
/* 1110 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _singletonSharedData = __webpack_require__(23);
	
	var _Singleton = __webpack_require__(21);
	
	var _DialingLogPreview = __webpack_require__(502);
	
	var _DialingLogPreview2 = _interopRequireDefault(_DialingLogPreview);
	
	var _ContainerDataPreview = __webpack_require__(237);
	
	var _ContainerDataPreview2 = _interopRequireDefault(_ContainerDataPreview);
	
	var _reactstrap = __webpack_require__(111);
	
	var _constants = __webpack_require__(10);
	
	var _reactRedux = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sharedData = new _singletonSharedData.SingletonSharedData();
	var language = new _Singleton.Singleton();
	
	var DataAndLog = function DataAndLog(_ref) {
	  var showOnlyData = _ref.showOnlyData,
	      showDataLogDisp = _ref.showDataLogDisp,
	      onChange = _ref.onChange;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      showLog = _useState2[0],
	      setShowLog = _useState2[1];
	
	  var _useState3 = (0, _react.useState)({}),
	      _useState4 = _slicedToArray(_useState3, 2),
	      newData = _useState4[0],
	      setNewData = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      disableInput = _useState6[0],
	      setDisableInput = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(false),
	      _useState8 = _slicedToArray(_useState7, 2),
	      showInformation = _useState8[0],
	      setShowInformation = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(false),
	      _useState10 = _slicedToArray(_useState9, 2),
	      showContainerDataPreview = _useState10[0],
	      setShowContainerDataPreview = _useState10[1];
	
	  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
	    return state.preview;
	  }),
	      selectedRecord = _useSelector.selectedRecord,
	      permissionUpdate = _useSelector.permissionUpdate,
	      _useSelector$selected = _useSelector.selectedRecord,
	      data = _useSelector$selected.data,
	      headers = _useSelector$selected.headers,
	      callKey = _useSelector$selected.callKey,
	      callOutId = _useSelector$selected.callOutId,
	      camId = _useSelector$selected.camId,
	      status = _useSelector$selected.status;
	
	  (0, _react.useEffect)(function () {
	    if (Object.keys(newData).length > 0) {
	      onChange && onChange(newData);
	    }
	  }, [newData]);
	  (0, _react.useEffect)(function () {
	    setShowLog(false);
	  }, [selectedRecord]);
	
	  (0, _react.useEffect)(function () {
	    if ((status === _constants.RECORD_STATE.DIALOG || status === _constants.RECORD_STATE.WRAPUP || status === _constants.RECORD_STATE.ALERT || status === _constants.RECORD_STATE.ABANDONED) && permissionUpdate) {
	      setDisableInput(false);
	    } else {
	      setDisableInput(true);
	    }
	  }, [status]);
	
	  (0, _react.useEffect)(function () {
	    callOutId !== 0 ? setShowInformation(true) : setShowInformation(false);
	    showContainerDataP();
	  }, [callOutId, status]);
	
	  var showContainerDataP = function showContainerDataP() {
	    setShowContainerDataPreview(false);
	    setTimeout(function () {
	      setShowContainerDataPreview(true);
	    }, 1);
	  };
	  if (showInformation) {
	    return _react2.default.createElement(
	      'div',
	      { className: 'dal-container ' + (showOnlyData ? 'showOnlyData' : '') + ' ' + (showDataLogDisp ? 'showDataLogDisp' : '') + ' ' + (status === _constants.RECORD_STATE.DIALOG ? 'showButtonOnDialog' : '') },
	      showContainerDataPreview && _react2.default.createElement(_ContainerDataPreview2.default, {
	        showOnlyData: showOnlyData,
	        userState: status,
	        data: data,
	        headers: headers,
	        callKey: callKey,
	        callOutId: callOutId,
	        camId: camId,
	        showLog: showLog,
	        setShowLog: setShowLog,
	        onChangeData: setNewData,
	        disableInput: disableInput
	      }),
	      showLog && _react2.default.createElement(
	        'div',
	        { className: 'dal-containerLog' },
	        _react2.default.createElement(
	          'div',
	          { className: 'dal-container-log' },
	          _react2.default.createElement('i', { className: 'gcl-icon history', id: 'dal-btn-LogRec', onClick: function onClick() {
	              return setShowLog(!showLog);
	            } }),
	          _react2.default.createElement(
	            _reactstrap.UncontrolledTooltip,
	            { innerClassName: 'dal-tooltip-log', placement: 'top', target: 'dal-btn-LogRec', boundariesElement: 'window' },
	            language.getText('GUIPreviewdialingLogBtn')
	          )
	        ),
	        _react2.default.createElement(_DialingLogPreview2.default, {
	          callOutId: callOutId,
	          camId: camId,
	          userId: sharedData.getParameters().UserID,
	          showDataLogDisp: showDataLogDisp,
	          status: status,
	          showOnlyData: showOnlyData
	        })
	      )
	    );
	  }
	  return null;
	};
	
	exports.default = DataAndLog;

/***/ },
/* 1111 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Singleton = __webpack_require__(21);
	
	var _Dispositions = __webpack_require__(497);
	
	var _Dispositions2 = _interopRequireDefault(_Dispositions);
	
	var _reactRedux = __webpack_require__(25);
	
	var _A_Alert_Modal = __webpack_require__(63);
	
	var _A_Alert_Modal2 = _interopRequireDefault(_A_Alert_Modal);
	
	var _A_messages_to_SM = __webpack_require__(32);
	
	var _helperMessages = __webpack_require__(87);
	
	var _constants = __webpack_require__(10);
	
	var _A_preview = __webpack_require__(52);
	
	var _CallSpaceHeaderSVG = __webpack_require__(67);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var language = new _Singleton.Singleton();
	
	var showAlertModal = _A_Alert_Modal2.default.creators.showAlertModal;
	
	
	var RateCallSimultaneousPreview = function RateCallSimultaneousPreview(_ref) {
	  var setShowDataLogDisp = _ref.setShowDataLogDisp,
	      newData = _ref.newData;
	
	  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
	    return state.preview;
	  }),
	      selectedRecord = _useSelector.selectedRecord,
	      fReplacementJob = _useSelector.fReplacementJob,
	      records = _useSelector.records,
	      ndScheduled = _useSelector.ndScheduled;
	
	  var _useState = (0, _react.useState)(null),
	      _useState2 = _slicedToArray(_useState, 2),
	      dispositionSelected = _useState2[0],
	      setDispositionSelected = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(null),
	      _useState4 = _slicedToArray(_useState3, 2),
	      reprogram = _useState4[0],
	      setReprogram = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      showCanReprogram = _useState6[0],
	      setShowCanReprogram = _useState6[1];
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  (0, _react.useEffect)(function () {
	    if (dispositionSelected !== null) {
	      setShowCanReprogram(dispositionSelected.canReprogram);
	    }
	  }, [dispositionSelected]);
	
	  (0, _react.useEffect)(function () {
	    setShowDataLogDisp && setShowDataLogDisp(!showCanReprogram);
	    return function () {
	      setShowDataLogDisp && setShowDataLogDisp(true);
	    };
	  }, [showCanReprogram]);
	
	  var endWraUpWithoutDisp = function endWraUpWithoutDisp() {
	    if (!newData.disabledUpdate) {
	      dispatch(showAlertModal({
	        type: "ModalAlert",
	        title: language.getText("CallControlcallCalificationfinishWrapup"),
	        message: language.getText("GUIAlertMessageexitWrapUpMsgConfirmation"),
	        button: language.getText("GUIAlertMessagefinish-and-update-btn"),
	        secondButton: language.getText("GUIAlertMessagefinish-only-btn"),
	        buttonFun: function buttonFun() {
	          return sendDataAndRemoveRec();
	        },
	        secondButtonFtn: function secondButtonFtn() {
	          return removeRecAndFinishWrapUp();
	        }
	      }));
	    } else {
	      removeRecAndFinishWrapUp();
	    }
	  };
	
	  var endWraUpWithDisp = function endWraUpWithDisp() {
	    if (!newData.disabledUpdate) {
	      dispatch(showAlertModal({
	        type: "ModalAlert",
	        title: language.getText("CallControlcallCalificationsave-disposition-title"),
	        message: language.getText("GUIAlertMessageexitWrapUpMsgConfirmation"),
	        button: language.getText("CallControlcallCalificationsave-and-update-btn"),
	        secondButton: language.getText("CallControlcallCalificationsave-only-btn"),
	        buttonFun: function buttonFun() {
	          return sendDataAndRate();
	        },
	        secondButtonFtn: function secondButtonFtn() {
	          return saveDisposition();
	        }
	      }));
	    } else {
	      saveDisposition();
	    }
	  };
	
	  var saveDisposition = function saveDisposition() {
	    var objectData = {
	      CallId: selectedRecord.callId,
	      DispositionId: dispositionSelected.dispositionSelected.Id,
	      Origin: '',
	      CallKey: selectedRecord.callKey,
	      CallOutId: selectedRecord.callOutId,
	      SubId: dispositionSelected.subDispositionSelected,
	      CallType: 2,
	      IsExitAssisted: dispositionSelected.dispositionSelected.FinishPreview,
	      IsExitPreview: dispositionSelected.dispositionSelected.FinishRecordPreview
	
	    };
	    setTimeout(function () {
	      dispatch((0, _A_messages_to_SM.messageApiRequest)(_constants.API_ENDPOINTS.SAVE_DISPOSITION, objectData));
	    }, 100);
	    Rescheduled();
	  };
	  var Rescheduled = function Rescheduled() {
	    if (showCanReprogram) {
	      var objCallBack = {
	        CamId: selectedRecord.camId,
	        Phone: reprogram.phoneReprogram.selectionReschedule === 2 ? reprogram.phoneReprogram.otherPhone : reprogram.phoneReprogram.phone.number,
	        TelReprograma: 1, // type === 1 ? 1 : (reprogram.phoneReprogram.selectionReschedule === 2 ? 0 : reprogram.phoneReprogram.phone.id),
	        IsAuto: false,
	        DateDial: reprogram.dateReprogram
	      };
	      setTimeout(function () {
	        dispatch((0, _A_messages_to_SM.messageApiRequest)(_constants.API_ENDPOINTS.CALL_BACK, objCallBack));
	      }, 200);
	    }
	
	    if (dispositionSelected.dispositionSelected.FinishRecordPreview) {
	      removeRecAndFinishWrapUp();
	    } else {
	      resetRecordAndFinishWrapUp();
	    }
	  };
	
	  var sendData = function sendData() {
	    var temp = [].concat(_toConsumableArray(newData.newArray));
	    while (temp < 15) {
	      temp.push('');
	    }
	    var dataPrev = {
	      callKey: selectedRecord.callKey,
	      camID: selectedRecord.camId,
	      newData: temp
	    };
	    setTimeout(function () {
	      dispatch((0, _A_messages_to_SM.updateInfoCall)(selectedRecord.callKey, selectedRecord.camId, temp, selectedRecord.callOutId));
	    }, 50);
	    sendMessageAgentReady();
	  };
	
	  var sendDataAndRate = function sendDataAndRate() {
	    sendData();
	    saveDisposition();
	  };
	  var sendDataAndRemoveRec = function sendDataAndRemoveRec() {
	    sendData();
	    dispatch((0, _A_preview.removeRecord)(selectedRecord.callOutId));
	  };
	  var removeRecAndFinishWrapUp = function removeRecAndFinishWrapUp() {
	    dispatch((0, _A_preview.removeRecord)(selectedRecord.callOutId));
	    sendMessageAgentReady();
	  };
	
	  var resetRecordAndFinishWrapUp = function resetRecordAndFinishWrapUp() {
	    dispatch((0, _A_preview.setWasItwasSentPreviewTime)({ callOutId: selectedRecord.callOutId, itWasSent: false }));
	    dispatch((0, _A_preview.setMaximumAssignmentPreview)({ callOutId: selectedRecord.callOutId, maximumAssignments: selectedRecord.maximumAssignments - 1 }));
	    setTimeout(function () {
	      var replacement = selectedRecord.maximumAssignments - 1 === 0 ? fReplacementJob : 0;
	      dispatch((0, _A_messages_to_SM.actionPreviewRecord)({ process: 5, camId: selectedRecord.camId, callOutId: selectedRecord.callOutId, previewTime: selectedRecord.previewTime, callId: 0, fMultipleJob: records.length === 1 ? 0 : 1, fReplacementJob: replacement }));
	    }, 100);
	    setTimeout(function () {
	
	      dispatch((0, _A_preview.resetRecordPreview)(selectedRecord.callOutId));
	    }, 200);
	    sendMessageAgentReady();
	  };
	
	  var sendMessageAgentReady = function sendMessageAgentReady() {
	    var countRecordsInWrapUp = records.filter(function (r) {
	      return (r.status === _constants.RECORD_STATE.ALERT || r.status === _constants.RECORD_STATE.ABANDONED || r.status === _constants.RECORD_STATE.WRAPUP) && r.callOutId !== selectedRecord.callOutId;
	    });
	    if (!ndScheduled) {
	      setTimeout(function () {
	        dispatch((0, _A_messages_to_SM.messageToStateMachine)((0, _helperMessages.messageAgentRedy)()));
	      }, 100);
	    } else {
	      if (countRecordsInWrapUp.length === 0) {
	        setTimeout(function () {
	          dispatch((0, _A_messages_to_SM.messageToStateMachine)((0, _helperMessages.messageAgentRedy)()));
	        }, 100);
	      }
	    }
	  };
	  return _react2.default.createElement(
	    'div',
	    { className: 'rcsp-container' },
	    _react2.default.createElement(_Dispositions2.default, {
	      type: 1,
	      endWraUpWithoutDisp: endWraUpWithoutDisp,
	      endWraUpWithDisp: endWraUpWithDisp,
	      onChangeDisp: setDispositionSelected,
	      onChangeReprogam: setReprogram })
	  );
	};
	
	exports.default = RateCallSimultaneousPreview;

/***/ },
/* 1112 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(73);
	
	var _Volume = __webpack_require__(504);
	
	var _Volume2 = _interopRequireDefault(_Volume);
	
	var _Singleton = __webpack_require__(21);
	
	var _globalComponentsLibrary = __webpack_require__(28);
	
	var _reactRedux = __webpack_require__(25);
	
	var _A_volume = __webpack_require__(335);
	
	var _A_preview = __webpack_require__(52);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var language = new _Singleton.Singleton();
	
	var VolumeContainer = function VolumeContainer(_ref) {
	  var item = _ref.item,
	      selectButton = _ref.selectButton,
	      mute = _ref.mute,
	      checkIsActiveButton = _ref.checkIsActiveButton;
	
	  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
	    return state.preview;
	  }),
	      _useSelector$selected = _useSelector.selectedRecord,
	      callOutId = _useSelector$selected.callOutId,
	      _useSelector$selected2 = _useSelector$selected.volume,
	      microphoneVol = _useSelector$selected2.microphoneVol,
	      speakerVol = _useSelector$selected2.speakerVol;
	
	  var _useState = (0, _react.useState)(speakerVol),
	      _useState2 = _slicedToArray(_useState, 2),
	      volumeSpeak = _useState2[0],
	      setVolumeSpeak = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(microphoneVol),
	      _useState4 = _slicedToArray(_useState3, 2),
	      volumeMic = _useState4[0],
	      setVolumeMic = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(microphoneVol),
	      _useState6 = _slicedToArray(_useState5, 2),
	      newVolumeMic = _useState6[0],
	      setNewVolumeMic = _useState6[1];
	
	  var _useToasts = (0, _globalComponentsLibrary.useToasts)(),
	      addToast = _useToasts.addToast;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var alertError = function alertError() {
	    addToast(language.getText("GUIAlertVolumecontent"), {
	      title: language.getText("GUIAlertVolumewarning"),
	      group: 'icon',
	      position: 'topRight',
	      color: 'yellow',
	      btnComponent: _react2.default.createElement(
	        _globalComponentsLibrary.AgentButton,
	        { type: 'tertiary' },
	        language.getText("GUIAlertMessageok")
	      ),
	      timeout: 5000
	    });
	  };
	
	  (0, _react.useEffect)(function () {
	    var temp = checkIsActiveButton('mute');
	    setNewVolumeMic(volumeMic);
	    if (temp) {
	      setVolumeMic(0);
	    } else {
	      setVolumeMic(newVolumeMic);
	    }
	  }, [mute]);
	
	  (0, _react.useEffect)(function () {
	    setTimeout(function () {
	      dispatch((0, _A_preview.setVolume)({ callOutId: callOutId, micVol: volumeMic, speakVol: volumeSpeak }));
	      dispatch((0, _A_volume.volumeSpeaker)(volumeSpeak));
	      dispatch((0, _A_volume.volumeMicrophone)(volumeMic));
	    }, 50);
	    var temp = checkIsActiveButton('mute');
	    if (volumeMic > 0 && temp) {
	      selectButton("mute", false);
	    } else if (volumeMic === 0 && !temp) {
	      selectButton("mute", true);
	    }
	  }, [volumeMic]);
	
	  var onChangeVolSpeak = function onChangeVolSpeak(vol) {
	    setVolumeSpeak(vol);
	    dispatch((0, _A_preview.setVolume)({ callOutId: callOutId, micVol: volumeMic, speakVol: vol }));
	  };
	
	  var onChangeVolMic = function onChangeVolMic(vol) {
	    dispatch((0, _A_volume.volumeMicrophone)(vol));
	    dispatch((0, _A_preview.setVolume)({ callOutId: callOutId, micVol: vol, speakVol: volumeSpeak }));
	    setVolumeMic(vol);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'volumeContainer', key: "buttonVolume" },
	    _react2.default.createElement(
	      _reactBootstrap.OverlayTrigger,
	      {
	        id: 'tlt-buttonsContainer-volumme',
	        key: 'tlt-buttonsContainer-volumme',
	        placement: 'top',
	        overlay: _react2.default.createElement(
	          _reactBootstrap.Tooltip,
	          { className: 'buttonsContainer-tooltip top show', id: 'toolTiptlt-buttonsContainer-volumme' },
	          language.getText('GUICallSpace' + item.tooltip)
	        )
	      },
	      _react2.default.createElement(
	        'div',
	        { className: item.className, onClick: item.action },
	        item.image
	      )
	    ),
	    item.active && _react2.default.createElement(_Volume2.default, {
	      volSpeaker: volumeSpeak,
	      volMicrophone: volumeMic,
	      muteMicrophone: volumeMic === 0,
	      onChangeVolumeSpeakers: function onChangeVolumeSpeakers(vol) {
	        return onChangeVolSpeak(vol);
	      },
	      onChangeVolumeMicro: function onChangeVolumeMicro(volume) {
	        return onChangeVolMic(volume);
	      },
	      alert: function alert(e) {
	        return alertError();
	      },
	      closeItem: function closeItem() {
	        return selectButton("volume", false);
	      }
	    })
	  );
	};
	
	exports.default = VolumeContainer;

/***/ },
/* 1113 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(25);
	
	var _constants = __webpack_require__(10);
	
	var _Singleton = __webpack_require__(21);
	
	var _singletonSharedData = __webpack_require__(23);
	
	var _A_draggable_windows_controller = __webpack_require__(55);
	
	var _draggableComponents = __webpack_require__(101);
	
	var _customAgentState = __webpack_require__(1154);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AgentState = function (_Component) {
	  _inherits(AgentState, _Component);
	
	  function AgentState(props) {
	    var _this$states, _this$newStateAction, _this$oldStateAction;
	
	    _classCallCheck(this, AgentState);
	
	    var _this = _possibleConstructorReturn(this, (AgentState.__proto__ || Object.getPrototypeOf(AgentState)).call(this, props));
	
	    _this.state = {
	      current: _constants.USER_STATE.LOGED_OUT,
	      state1: _constants.USER_STATE.LOGED_OUT,
	      state2: _constants.USER_STATE.LOGED_OUT,
	      state1Design: "stateFront " + _constants.USER_STATE.LOGED_OUT,
	      state2Design: "stateBack " + _constants.USER_STATE.LOGED_OUT,
	      currtentFront: true
	    };
	    _this.language = new _Singleton.Singleton();
	    _this.sharedData = new _singletonSharedData.SingletonSharedData();
	    _this.states = (_this$states = {}, _defineProperty(_this$states, _constants.USER_STATE.LOGED_OUT, { image: _customAgentState.CUSTOM_AGENT_STATE[_constants.USER_STATE.LOGED_OUT], title: _this.language.getText('GUIAgentStateloggedOut') }), _defineProperty(_this$states, _constants.USER_STATE.LOGED_IN, { image: _customAgentState.CUSTOM_AGENT_STATE[_constants.USER_STATE.LOGED_IN], title: _this.language.getText('GUIAgentStateloggedIn') }), _defineProperty(_this$states, _constants.USER_STATE.AGENT_READY, { image: _customAgentState.CUSTOM_AGENT_STATE[_constants.USER_STATE.AGENT_READY], title: _this.language.getText('GUIAgentStateready') }), _defineProperty(_this$states, _constants.USER_STATE.NO_AVAILABLE, { image: _customAgentState.CUSTOM_AGENT_STATE[_constants.USER_STATE.NO_AVAILABLE], title: _this.language.getText('GUIAgentStatenotAvailable') }), _defineProperty(_this$states, _constants.USER_STATE.CHATTING, { image: _customAgentState.CUSTOM_AGENT_STATE[_constants.USER_STATE.CHATTING], title: _this.language.getText('GUIUnifiedInboxchatting') }), _defineProperty(_this$states, _constants.USER_STATE.CALL_OUT, { image: _customAgentState.CUSTOM_AGENT_STATE[_constants.USER_STATE.CALL_OUT], title: _this.language.getText('GUIAgentStatecallOut') }), _defineProperty(_this$states, _constants.USER_STATE.DIALOG, { image: _customAgentState.CUSTOM_AGENT_STATE[_constants.USER_STATE.DIALOG], title: _this.language.getText('GUIAgentStatedialog') }), _defineProperty(_this$states, _constants.USER_STATE.MANUAL_CALL, { image: _customAgentState.CUSTOM_AGENT_STATE[_constants.USER_STATE.MANUAL_CALL], title: _this.language.getText('GUIAgentStatemanualCall') }), _defineProperty(_this$states, _constants.USER_STATE.WAITING_TRANSFER, { image: _customAgentState.CUSTOM_AGENT_STATE[_constants.USER_STATE.WAITING_TRANSFER], title: _this.language.getText('GUIAgentStatewaitingTransfer') }), _defineProperty(_this$states, _constants.USER_STATE.ERROR, { image: _customAgentState.CUSTOM_AGENT_STATE[_constants.USER_STATE.ERROR], title: _this.language.getText('GUIAgentStateerror') }), _defineProperty(_this$states, _constants.USER_STATE.CALL_TRANSFER, { image: _customAgentState.CUSTOM_AGENT_STATE[_constants.USER_STATE.CALL_TRANSFER], title: _this.language.getText('GUIAgentStatecallTransfer') }), _defineProperty(_this$states, _constants.USER_STATE.RINGING, { image: _customAgentState.CUSTOM_AGENT_STATE[_constants.USER_STATE.RINGING], title: _this.language.getText('GUIAgentStateringing') }), _defineProperty(_this$states, _constants.USER_STATE.WRAPUP, { image: _customAgentState.CUSTOM_AGENT_STATE[_constants.USER_STATE.WRAPUP], title: _this.language.getText('GUIAgentStatewrapUp') }), _defineProperty(_this$states, _constants.USER_STATE.XFER, { image: _customAgentState.CUSTOM_AGENT_STATE[_constants.USER_STATE.XFER], title: _this.language.getText('GUIAgentStatexfer') }), _defineProperty(_this$states, _constants.USER_STATE.OTHER, { image: _customAgentState.CUSTOM_AGENT_STATE[_constants.USER_STATE.OTHER], title: _this.language.getText('GUIAgentStateother') }), _defineProperty(_this$states, _constants.USER_STATE.EXCLUSIVE_CALLBACK, { image: _customAgentState.CUSTOM_AGENT_STATE[_constants.USER_STATE.EXCLUSIVE_CALLBACK], title: _this.language.getText('GUIAgentStateexclusiveCallBack') }), _defineProperty(_this$states, _constants.USER_STATE.READY_PREVIEW, { image: _customAgentState.CUSTOM_AGENT_STATE[_constants.USER_STATE.AGENT_READY], title: _this.language.getText('GUIAgentStateready') }), _defineProperty(_this$states, _constants.USER_STATE.ASSISTED, { image: _customAgentState.CUSTOM_AGENT_STATE[_constants.USER_STATE.ASSISTED], title: _this.language.getText('GUIAgentStateassisted') }), _defineProperty(_this$states, _constants.USER_STATE.DIALOG_WHATSAPP, { image: _customAgentState.CUSTOM_AGENT_STATE[_constants.USER_STATE.DIALOG_WHATSAPP], title: _this.language.getText('GUIAgentStatedialog') }), _defineProperty(_this$states, _constants.USER_STATE.WHATSAPP, { image: _customAgentState.CUSTOM_AGENT_STATE[_constants.USER_STATE.WHATSAPP], title: 'WhatsApp' }), _defineProperty(_this$states, _constants.USER_STATE.AGENT_PREVIEW, { image: _customAgentState.CUSTOM_AGENT_STATE[_constants.USER_STATE.AGENT_PREVIEW], title: _this.language.getText('GUIAgentStatepreview') }), _defineProperty(_this$states, _constants.USER_STATE.INACTIVE, { image: _customAgentState.CUSTOM_AGENT_STATE[_constants.USER_STATE.INACTIVE], title: _this.language.getText('GUIAgentStateinactive') }), _defineProperty(_this$states, _constants.USER_STATE.DIALOG_EMAIL, { image: _customAgentState.CUSTOM_AGENT_STATE[_constants.USER_STATE.DIALOG_EMAIL], title: _this.language.getText('GUIAgentStatedialog') }), _this$states);
	
	    _this.newStateAction = (_this$newStateAction = {}, _defineProperty(_this$newStateAction, _constants.USER_STATE.NO_AVAILABLE, function () {
	      return _this.props.insertWindow((0, _draggableComponents.noAvailableLocked)(null), false);
	    }), _defineProperty(_this$newStateAction, _constants.USER_STATE.EXCLUSIVE_CALLBACK, function () {
	      return _this.props.insertWindow((0, _draggableComponents.callBackEsclusive)(null), false);
	    }), _defineProperty(_this$newStateAction, _constants.USER_STATE.XFER, function () {
	      return _this.sharedData.getGeneralPermissions()[96] === '0' && _this.sharedData.getOdbcExternalCall() === false ? _this.props.removeWindow(_constants.DRAGGABLE_WINDOWS.MANUAL_CALL) : null;
	    }), _defineProperty(_this$newStateAction, _constants.USER_STATE.DIALOG, function () {
	      return _this.props.removeWindow(_constants.DRAGGABLE_WINDOWS.EXCLUSIVE_CALLBACK);
	    }), _defineProperty(_this$newStateAction, _constants.USER_STATE.CHATTING, function () {
	      return _this.props.removeWindow(_constants.DRAGGABLE_WINDOWS.EXCLUSIVE_CALLBACK);
	    }), _defineProperty(_this$newStateAction, _constants.USER_STATE.CALL_OUT, function () {
	      return _this.sharedData.getDataPreviewPro().dialingMode === 1 && _this.props.removeWindow(_constants.DRAGGABLE_WINDOWS.MANUAL_CALL);
	    }), _defineProperty(_this$newStateAction, _constants.USER_STATE.READY_PREVIEW, function () {
	      return setTimeout(function () {
	        return _this.props.removeWindow(_constants.DRAGGABLE_WINDOWS.MANUAL_CALL);
	      }, 500);
	    }), _defineProperty(_this$newStateAction, _constants.USER_STATE.INACTIVE, function () {
	      return setTimeout(function () {
	        return _this.props.removeWindow(_constants.DRAGGABLE_WINDOWS.NO_AVAILABLE);
	      }, 500);
	    }), _this$newStateAction);
	    _this.oldStateAction = (_this$oldStateAction = {}, _defineProperty(_this$oldStateAction, _constants.USER_STATE.NO_AVAILABLE, function () {
	      return _this.props.removeWindow(_constants.DRAGGABLE_WINDOWS.NO_AVAILABLE_LOCKED);
	    }), _defineProperty(_this$oldStateAction, _constants.USER_STATE.EXCLUSIVE_CALLBACK, function () {
	      return _this.props.removeWindow(_constants.DRAGGABLE_WINDOWS.EXCLUSIVE_CALLBACK);
	    }), _defineProperty(_this$oldStateAction, _constants.USER_STATE.DIALOG, function () {
	      return _this.props.removeWindow(_constants.DRAGGABLE_WINDOWS.TRANSFER_CALL, _constants.DRAGGABLE_WINDOWS.DTMF_TONES, _constants.DRAGGABLE_WINDOWS.ONGOING_CALL_IVR, _constants.DRAGGABLE_WINDOWS.MARK_CALL);
	    }), _defineProperty(_this$oldStateAction, _constants.USER_STATE.CHATTING, function () {
	      return _this.props.removeWindow(_constants.DRAGGABLE_WINDOWS.TRANSFER_CALL, _constants.DRAGGABLE_WINDOWS.DTMF_TONES, _constants.DRAGGABLE_WINDOWS.ONGOING_CALL_IVR, _constants.DRAGGABLE_WINDOWS.MARK_CALL);
	    }), _this$oldStateAction);
	    return _this;
	  }
	
	  _createClass(AgentState, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.listenerActions) {
	        if (this.oldStateAction[this.state.current]) {
	          this.oldStateAction[this.state.current]();
	        }
	        if (this.newStateAction[nextProps.userState.currentState]) {
	          this.newStateAction[nextProps.userState.currentState]();
	        }
	      }
	      if (!this.state.currtentFront) {
	        this.setState({
	          current: nextProps.userState.currentState,
	          state1: nextProps.userState.currentState,
	          state2: this.state.current,
	          state1Design: "stateFront " + nextProps.userState.currentState,
	          state2Design: "stateBack " + this.state.current,
	          currtentFront: true
	        });
	      } else {
	        this.setState({
	          current: nextProps.userState.currentState,
	          state1: this.state.current,
	          state2: nextProps.userState.currentState,
	          state1Design: "stateBack " + this.state.current,
	          state2Design: "stateFront " + nextProps.userState.currentState,
	          currtentFront: false
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.setState({ current: _constants.USER_STATE.LOGED_OUT });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'agentStateContainer' },
	        _react2.default.createElement(
	          'div',
	          { className: this.state.state1Design },
	          _react2.default.createElement(
	            'div',
	            { className: "imageAgentState" },
	            this.states[this.state.state1].image
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: "agentStateTxt" },
	            this.states[this.state.state1].title
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: this.state.state2Design },
	          _react2.default.createElement(
	            'div',
	            { className: "imageAgentState" },
	            this.states[this.state.state2].image
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: "agentStateTxt" },
	            this.states[this.state.state2].title
	          )
	        )
	      );
	    }
	  }]);
	
	  return AgentState;
	}(_react.Component);
	
	;
	function mapStateToProps(state) {
	  return {
	    userState: state.userState
	  };
	}
	function mapDispatchToProps(dispatch) {
	  return {
	    insertWindow: function insertWindow(dragWindow, closeComponentIfOpen) {
	      dispatch((0, _A_draggable_windows_controller.insertWindow)(dragWindow, closeComponentIfOpen));
	    },
	    removeWindow: function removeWindow() {
	      for (var _len = arguments.length, iDdragComponents = Array(_len), _key = 0; _key < _len; _key++) {
	        iDdragComponents[_key] = arguments[_key];
	      }
	
	      dispatch((0, _A_draggable_windows_controller.removeWindow)(iDdragComponents));
	    }
	  };
	}
	exports.default = AgentState = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AgentState);

/***/ },
/* 1114 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(25);
	
	var _constants = __webpack_require__(10);
	
	var _CallSpaceHeaderSVG = __webpack_require__(67);
	
	var _A_reducer_call_acd = __webpack_require__(156);
	
	var _A_messages_to_SM = __webpack_require__(32);
	
	var _cwGalateaApiJsBundle = __webpack_require__(40);
	
	var _singletonSharedData = __webpack_require__(23);
	
	var _CallWindow = __webpack_require__(1087);
	
	var _CallWindow2 = _interopRequireDefault(_CallWindow);
	
	var _RateCall = __webpack_require__(1090);
	
	var _RateCall2 = _interopRequireDefault(_RateCall);
	
	var _Volume = __webpack_require__(504);
	
	var _Volume2 = _interopRequireDefault(_Volume);
	
	var _CallHeader = __webpack_require__(1086);
	
	var _CallHeader2 = _interopRequireDefault(_CallHeader);
	
	var _draggableComponents = __webpack_require__(101);
	
	var _A_draggable_windows_controller = __webpack_require__(55);
	
	var _helperMessages = __webpack_require__(87);
	
	var _A_ongoing_call_ivr_modal = __webpack_require__(334);
	
	var _A_ongoing_call_ivr_modal2 = _interopRequireDefault(_A_ongoing_call_ivr_modal);
	
	var _SingletonWebSocket = __webpack_require__(50);
	
	var _SingletonWebSocket2 = _interopRequireDefault(_SingletonWebSocket);
	
	var _XFerToneB = __webpack_require__(2606);
	
	var _XFerToneB2 = _interopRequireDefault(_XFerToneB);
	
	var _reactBootstrap = __webpack_require__(73);
	
	var _Singleton = __webpack_require__(21);
	
	var _A_volume = __webpack_require__(335);
	
	var _Logger = __webpack_require__(37);
	
	var _CallHeaderPreview = __webpack_require__(496);
	
	var _CallHeaderPreview2 = _interopRequireDefault(_CallHeaderPreview);
	
	var _A_preview = __webpack_require__(52);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CallSpace = function (_Component) {
	  _inherits(CallSpace, _Component);
	
	  function CallSpace(props) {
	    var _this2$closeWindowAct, _this2$disabledButton;
	
	    _classCallCheck(this, CallSpace);
	
	    var _this2 = _possibleConstructorReturn(this, (CallSpace.__proto__ || Object.getPrototypeOf(CallSpace)).call(this, props));
	
	    _this2.sharedData = new _singletonSharedData.SingletonSharedData();
	    _Logger.Logger.Info("[callspace][constructor] get volume speaker:" + _this2.sharedData.getVolumeSpeaker() + " microphone:" + _this2.sharedData.getVolumeMic() + "");
	    _this2.state = {
	      iconCall: null,
	      dataCall: props.dataCall,
	      extraDataCall: props.extraDataCall,
	      currentState: props.currentState,
	      volumeSpeaker: _this2.sharedData.getVolumeSpeaker(),
	      volumeMicrophone: _this2.sharedData.getVolumeMic(),
	      lastVolume: 50,
	      barSize: 600,
	      showingMoreOptions: false,
	      marginRight: 70,
	      marginLeft: 122,
	      onTransferWindow: false,
	      hangUpLeaveMessage: false,
	      disableHp: false,
	      dispositionListInformation: null,
	      dispositionListError: null,
	      dataIneffectiveCall: '',
	      existData: false,
	      setShowDataBySetting: false,
	      renderButtons: [{
	        idButton: "disposition",
	        image: _CallSpaceHeaderSVG.rateCallSvg,
	        tooltip: "Disposition",
	        active: false,
	        enabledState: true,
	        showed: true,
	        realSize: 52,
	        className: "buttonBigCall",
	        action: function action() {
	          return _this2.actionDisposition();
	        },
	        hideAt: 590
	      }, {
	        idButton: "leaveMessage",
	        image: _CallSpaceHeaderSVG.hangUpLeaveMessage,
	        tooltip: "LeaveMessage",
	        active: false,
	        enabledState: false,
	        showed: false,
	        realSize: 52,
	        className: "buttonBigCall",
	        action: function action() {
	          return _this2.actionHangUpAndLeaveMessage();
	        },
	        hideAt: 590
	      }, {
	        idButton: "transfer",
	        image: _CallSpaceHeaderSVG.assistedTransfer,
	        tooltip: "Transfer",
	        active: false,
	        enabledState: true,
	        showed: Boolean(parseInt(_this2.sharedData.getGeneralPermissions()[82], 10)),
	        realSize: 52,
	        className: "buttonBigCall",
	        action: function action() {
	          return _this2.actionTransfer();
	        },
	        hideAt: 530
	      }, {
	        idButton: "dtmf",
	        image: _CallSpaceHeaderSVG.dtmfSVG,
	        tooltip: "DTMF",
	        active: false,
	        showed: true,
	        enabledState: true,
	        realSize: 52,
	        className: "buttonBigCall",
	        action: function action() {
	          return _this2.actionDTMF();
	        },
	        hideAt: 450
	      }, {
	        idButton: "volume",
	        image: _CallSpaceHeaderSVG.volumeMedium,
	        tooltip: "Volume",
	        active: false,
	        enabledState: true,
	        showed: true,
	        realSize: 52,
	        className: "buttonBigCall",
	        action: function action() {
	          return _this2.actionVolume();
	        },
	        hideAt: 0
	      }, {
	        idButton: "mute",
	        image: _CallSpaceHeaderSVG.mute,
	        tooltip: "Mute",
	        active: false,
	        showed: true,
	        enabledState: true,
	        realSize: 52,
	        className: "buttonBigCall",
	        action: function action() {
	          return _this2.actionMute();
	        },
	        hideAt: 0
	      }, {
	        idButton: "hold",
	        image: _CallSpaceHeaderSVG.hold,
	        tooltip: "Hold",
	        active: false,
	        showed: false,
	        enabledState: true,
	        realSize: 52,
	        className: "buttonBigCall",
	        action: function action() {
	          return _this2.actionPauseCall();
	        },
	        hideAt: 280
	      }, {
	        idButton: "marks",
	        image: _CallSpaceHeaderSVG.resume,
	        tooltip: "Mark",
	        active: false,
	        showed: true,
	        enabledState: true,
	        realSize: 52,
	        className: "buttonBigCall",
	        action: function action() {
	          return _this2.actionMarkCall();
	        },
	        hideAt: 480
	      }, {
	        idButton: "ivr",
	        image: _CallSpaceHeaderSVG.ivr,
	        tooltip: "IVR",
	        active: false,
	        showed: false,
	        enabledState: true,
	        realSize: 52,
	        className: "buttonBigCall",
	        action: function action() {
	          return _this2.actionIVR();
	        },
	        hideAt: 600
	      }, {
	        idButton: "record",
	        image: _CallSpaceHeaderSVG.record,
	        tooltip: "Record",
	        active: false,
	        showed: false,
	        enabledState: true,
	        realSize: 52,
	        className: "buttonBigCall",
	        action: function action() {
	          return _this2.actionPauseRecord();
	        },
	        hideAt: 600
	      }],
	      rightButtons: [{
	        idButton: "hangUp",
	        image: _CallSpaceHeaderSVG.hangUp,
	        tooltip: "HangUp",
	        active: false,
	        showed: true,
	        enabledState: true,
	        realSize: 52,
	        className: "buttonHangUpCall",
	        action: function action() {
	          return _this2.actionHangUp();
	        },
	        showAt: 100000000000
	      }, {
	        idButton: "moreOptions",
	        image: _CallSpaceHeaderSVG.moreOptions,
	        tooltip: "More",
	        active: false,
	        enabledState: true,
	        realSize: 52,
	        className: "buttonBigCall",
	        action: function action() {
	          return _this2.showMoreOptions();
	        },
	        showAt: 600
	      }]
	    };
	    _this2.timerTime = {};
	    _this2.volume = 0;
	    _this2.iDigit = null;
	    var APIFact = new _cwGalateaApiJsBundle.APIFactory();
	    _this2.apiCont = APIFact.buildClient();
	    _this2.sizeBarWidht = 438;
	    _this2.sizeBarRightWidht = 52;
	    _this2.integrationAction = null;
	    _this2.integrationData = null;
	    _this2.language = new _Singleton.Singleton();
	    _this2.ivrPermission = _this2.sharedData.getGeneralPermissions()[117];
	    _this2.audio = new Audio(_XFerToneB2.default);
	    _this2.closeWindowActions = (_this2$closeWindowAct = {}, _defineProperty(_this2$closeWindowAct, _constants.DRAGGABLE_WINDOWS.TRANSFER_CALL, function () {
	      return _this2.selectObject("transfer", false);
	    }), _defineProperty(_this2$closeWindowAct, _constants.DRAGGABLE_WINDOWS.DTMF_TONES, function () {
	      return _this2.selectObject("dtmf", false);
	    }), _defineProperty(_this2$closeWindowAct, _constants.DRAGGABLE_WINDOWS.MARK_CALL, function () {
	      return _this2.selectObject("marks", false);
	    }), _defineProperty(_this2$closeWindowAct, _constants.DRAGGABLE_WINDOWS.ONGOING_CALL_IVR, function () {
	      return _this2.selectObject("ivr", false);
	    }), _this2$closeWindowAct);
	    _this2.disabledButtonsState = (_this2$disabledButton = {}, _defineProperty(_this2$disabledButton, _constants.USER_STATE.OTHER, { "disposition": false, "transfer": false, "dtmf": false, "volume": true, "mute": true, "hold": false, "marks": false, "ivr": false, "record": false }), _defineProperty(_this2$disabledButton, _constants.USER_STATE.OTHER_PREVIEW, { "disposition": false, "transfer": false, "dtmf": false, "volume": true, "mute": true, "hold": false, "marks": false, "ivr": false, "record": false }), _defineProperty(_this2$disabledButton, "OTHERTEMP", { "disposition": true, "transfer": false, "dtmf": true, "volume": true, "mute": true, "hold": true, "marks": true, "ivr": true, "record": true }), _this2$disabledButton);
	    _this2.problemInManualCall = _this2.sharedData.problemInManualCall;
	    _this2.resize = _this2.resize.bind(_this2);
	    _this2.isInCall = true;
	    return _this2;
	  }
	
	  _createClass(CallSpace, [{
	    key: 'resize',
	    value: function resize() {
	      var barButtons = this.refs["BarButtons"];
	      if (barButtons) {
	        var barSize = barButtons.offsetWidth;
	        this.sizeBarWidht = this.state.renderButtons.reduce(function (sum, cur) {
	          return sum + (cur.hideAt < barSize ? cur.realSize : 0);
	        }, 0);
	        this.sizeBarRightWidht = this.state.rightButtons.reduce(function (sum, cur) {
	          return sum + (cur.showAt > barSize ? cur.realSize : 0);
	        }, 0);
	        var rightMargin = (barButtons.offsetWidth - this.sizeBarWidht - this.sizeBarRightWidht * 2) / 2.0;
	        rightMargin = Math.min(70, rightMargin);
	        rightMargin = Math.max(0, rightMargin);
	        var leftMargin = rightMargin + this.sizeBarRightWidht;
	        leftMargin = Math.min(leftMargin, 0);
	        leftMargin = Math.max(leftMargin, 0);
	        this.setState({
	          barSize: barSize,
	          marginRight: rightMargin,
	          marginLeft: leftMargin
	        });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (!this.state.setShowDataBySetting && this.props.showDataBySetting && this.props.extraDataCall.AgentXfer) {
	        this.checkButtons("OTHERTEMP");
	        this.setState({ setShowDataBySetting: this.props.showDataBySetting });
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener("resize", this.resize);
	      this.checkButtons(this.state.currentState);
	      this.resize();
	      this.getCallIcon();
	      this.getRecordingStateButton();
	      this.getListDispositions();
	      this.audio.play();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.isInCall = false;
	      setTimeout(this.props.hideModal, 200);
	      window.removeEventListener('resize', this.resize);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.onCloseWindow && this.closeWindowActions[nextProps.onCloseWindow]) {
	        this.closeWindowActions[nextProps.onCloseWindow]();
	      }
	      if (this.state.dataCall.CallId && nextProps.dataCall && nextProps.dataCall.CallId && nextProps.dataCall.CallId > 0 && this.state.dataCall.CallId !== nextProps.dataCall.CallId && this.state.displayHeader) {
	        this.setState({ dataCall: nextProps.dataCall, extraDataCall: nextProps.extraDataCall });
	        this.getCallIcon();
	        this.getRecordingStateButton();
	        this.getListDispositions();
	      }
	      if (nextProps.dataCall.holdCall && !this.isActiveButton("hold")) {
	        this.setVisibleItem("hold", nextProps.dataCall.holdCall);
	      }
	      if (nextProps.extraDataCall.HoldCall && !this.isActiveButton("hold") && this.state.currentState === _constants.USER_STATE.OTHER) {
	        this.setVisibleItem("hold", nextProps.extraDataCall.HoldCall);
	      }
	      if (this.state.currentState !== nextProps.currentState) {
	        this.checkButtons(nextProps.currentState);
	        if (nextProps.currentState === _constants.USER_STATE.WRAPUP) {
	          setTimeout(this.props.hideModal, 200);
	          if (this.state.volumeMicrophone === 0) {
	            _Logger.Logger.Info("[callspace][componentWillReceiveProps] volumeMicrophone:", this.state.lastVolume);
	            this.props.volumeMicrophone(this.state.lastVolume);
	          }
	        }
	      }
	      switch (nextProps.assistedTransfer.currentState) {
	        case _constants.ASSISTED_TRANSFER.TRANSFERRING:
	          this.setState({ onTransferWindow: true });
	          break;
	        case _constants.ASSISTED_TRANSFER.SECOND_CALL_HANG_UP:
	          this.setState({ onTransferWindow: false });
	          break;
	        case _constants.ASSISTED_TRANSFER.IDDLE_END:
	          var integrationMessage = { client: "galatea", data: nextProps.extraDataCall.IvrPressed, action: "OngoingCallIvr", subaction: "onIdleEnd" };
	          _SingletonWebSocket2.default.send(integrationMessage);
	          this.props.hideModal();
	          break;
	        default:
	          break;
	      }
	      if (nextProps.messagesIntegrations.dataMessageIntegration) {
	        switch (nextProps.messagesIntegrations.dataMessageIntegration.action) {
	          case _constants.INTEGRATION.ASSISTED_DIAL_ACD:
	            this.assistedTransfer(nextProps.messagesIntegrations.dataMessageIntegration);
	            break;
	          case _constants.INTEGRATION.ASSISTED_DIAL_AGENT:
	            this.assistedTransfer(nextProps.messagesIntegrations.dataMessageIntegration);
	            break;
	          case _constants.INTEGRATION.ASSISTED_DIAL_NUMBER:
	            this.assistedTransfer(nextProps.messagesIntegrations.dataMessageIntegration);
	            break;
	          case _constants.INTEGRATION.CALL_ACTION:
	            this.callbarActionFromIntegration(nextProps.messagesIntegrations.dataMessageIntegration);
	            break;
	          case _constants.INTEGRATION.DISPOSITION:
	          case _constants.INTEGRATION.SAVE_DISPOSITION:
	            this.integrationAction = nextProps.messagesIntegrations.dataMessageIntegration.action;
	            this.openFromIntegration("Disposition");
	            break;
	          case _constants.INTEGRATION.GET_ACD_DISPOSITIONS:
	          case _constants.INTEGRATION.GET_CAMPAIGN_DISPOSITIONS:
	          case _constants.INTEGRATION.GET_DISPOSITIONS:
	            this.integrationAction = nextProps.messagesIntegrations.dataMessageIntegration.action;
	            this.openFromIntegration("Disposition");
	            break;
	          case _constants.INTEGRATION.GET_TRANSFER_DATA:
	            this.openFromIntegration("Transfer");
	            break;
	          case _constants.INTEGRATION.OPEN_WINDOW:
	            this.openFromIntegration(nextProps.messagesIntegrations.dataMessageIntegration.window);
	            break;
	          default:
	            break;
	        }
	      }
	    }
	  }, {
	    key: 'assistedTransfer',
	    value: function assistedTransfer(messageIntegration) {
	      if (!this.isActiveButton("transfer")) {
	        this.actionTransfer(messageIntegration);
	      }
	    }
	  }, {
	    key: 'callbarActionFromIntegration',
	    value: function callbarActionFromIntegration(message) {
	      var _this3 = this;
	
	      var _this = this;
	      switch (message.callAction) {
	        case _constants.ASSISTED_TRANSFER.SECOND_CALL_HANG_UP:
	          this.setState({ onTransferWindow: false });
	          break;
	        case _constants.INTEGRATION.DTMF:
	          _this.iDigit = message.digit;
	          if (!this.isActiveButton("dtmf")) {
	            this.actionDTMF();
	          }
	          break;
	        case _constants.INTEGRATION.GET_DISPOSITIONS_AND_NUMBERS:
	          if (!this.isActiveButton("disposition")) {
	            this.integrationAction = _constants.INTEGRATION.GET_DISPOSITIONS_AND_NUMBERS;
	            this.actionDisposition();
	          }
	          break;
	        case _constants.INTEGRATION.GET_IVR_LIST:
	          if (Boolean(parseInt(this.ivrPermission, 10)) && !this.isActiveButton("ivr")) {
	            var _props = { action: _constants.INTEGRATION.GET_IVR_LIST };
	            this.actionIVR(_props);
	          }
	          break;
	        case _constants.INTEGRATION.HANG_UP:
	          setTimeout(function () {
	            _this3.actionHangUp();
	          }, 500);
	          break;
	        case _constants.INTEGRATION.HANG_UP_AND_LEAVE_MESSAGE:
	          this.actionHangUpAndLeaveMessage();
	          break;
	        case _constants.INTEGRATION.HOLD:
	          this.actionPauseCall();
	          break;
	        case _constants.INTEGRATION.IDLE_START:
	          _this.integrationData = message.IVRId;
	          if (!this.isActiveButton("ivr")) {
	            var _props2 = {
	              action: _constants.INTEGRATION.IDLE_START,
	              IVRId: this.integrationData
	            };
	            this.actionIVR(_props2);
	          }
	          break;
	        case _constants.INTEGRATION.MARK_ADD:
	          var props = null;
	          var arrayMarks = this.sharedData.getCurrentCallMarks();
	          if (!this.isActiveButton("marks")) {
	            if (arrayMarks.length !== 0) {
	              props = { action: _constants.INTEGRATION.MARK_ADD };
	            }
	            this.actionMarkCall(props);
	          }
	          break;
	        case _constants.INTEGRATION.MUTE:
	          this.actionMute();
	          break;
	        case _constants.INTEGRATION.GET_PHONE_NUMBERS:
	          if (!this.isActiveButton("disposition")) {
	            this.integrationAction = _constants.INTEGRATION.GET_PHONE_NUMBERS;
	            this.actionDisposition();
	          }
	          break;
	        case _constants.INTEGRATION.RECORDING_STOP_START:
	          this.actionPauseRecord();
	          break;
	        case _constants.INTEGRATION.SET_VOLUME:
	          if (!this.isActiveButton("volume")) {
	            this.actionVolume();
	          }
	          break;
	        default:
	          break;
	      }
	    }
	  }, {
	    key: 'openFromIntegration',
	    value: function openFromIntegration(window) {
	      switch (window) {
	        case "Transfer":
	          if (!this.isActiveButton("transfer")) {
	            this.actionTransfer();
	          }
	          break;
	        case "Disposition":
	          if (!this.isActiveButton("disposition")) {
	            this.actionDisposition();
	          }
	          break;
	        default:
	          break;
	      };
	    }
	  }, {
	    key: 'checkButtons',
	    value: function checkButtons(state) {
	      var renderArray = this.state.renderButtons;
	      if (this.disabledButtonsState[state]) {
	
	        var objectDisabled = this.disabledButtonsState[state];
	
	        if (this.sharedData.getDataPreviewPro().dialingMode === 1) {
	          objectDisabled = this.disabledButtonsState[_constants.USER_STATE.OTHER_PREVIEW];
	        }
	        for (var obj in renderArray) {
	          renderArray[obj].enabledState = objectDisabled[renderArray[obj].idButton];
	        }
	      } else {
	        for (var _obj in renderArray) {
	          renderArray[_obj].enabledState = true;
	        }
	      }
	
	      renderArray = this.validateMarksPermission(renderArray);
	      if (Object.values(_constants.USER_STATE).includes(state)) {
	        this.setState({ renderButtons: renderArray, currentState: state });
	      }
	    }
	  }, {
	    key: 'validateMarksPermission',
	    value: function validateMarksPermission(renderButtonsArray) {
	      var markPermissionValue = this.sharedData.getAllowMarksPermission();
	
	      var newArray = renderButtonsArray;
	
	      for (var arr in newArray) {
	        if (newArray[arr].idButton === "marks") {
	          newArray[arr].className = markPermissionValue ? newArray[arr].className : 'buttonDisabled';
	          newArray[arr].action = markPermissionValue ? newArray[arr].action : null;
	        }
	      }
	
	      return newArray;
	    }
	  }, {
	    key: 'getCallIcon',
	    value: function getCallIcon() {
	      if (this.state.dataCall) {
	        var _this = this;
	        var callIcon = this.sharedData.getCallIcon();
	        if (callIcon) {
	          _this.showExtraButtons(callIcon);
	        } else {
	          var objectData = {
	            UserId: this.sharedData.getParameters().UserID,
	            Id: this.state.dataCall.Id ? this.state.dataCall.Id : this.state.extraDataCall.Id,
	            CallType: this.state.dataCall.CallType ? this.state.dataCall.CallType : this.state.extraDataCall.CallType,
	            CallOutId: this.state.dataCall.CallOutId ? this.state.dataCall.CallOutId : this.state.extraDataCall.CallOutId,
	            Phone: this.state.dataCall.Phone ? this.state.dataCall.Phone : this.state.extraDataCall.Phone
	          };
	          var objectResponseCallIcon = this.apiCont.getObjectResponse();
	          _Logger.Logger.Trace("apiCont.callIcon request");
	          this.apiCont.callIcon(objectData, objectResponseCallIcon);
	          objectResponseCallIcon.onError = function (err) {
	            _Logger.Logger.Warn("apiCont.callIcon objectData:", objectData, "error:", err);
	            _this.setState({ iconCall: null });
	          };
	          objectResponseCallIcon.onSuccess = function (objResponse) {
	            _Logger.Logger.Trace("apiCont.callIcon onSucces:", objResponse);
	            _this.showExtraButtons(objResponse);
	          };
	        }
	      }
	    }
	  }, {
	    key: 'getRecordingStateButton',
	    value: function getRecordingStateButton() {
	      var _this = this;
	      var objectResponseRecordCall = this.apiCont.getObjectResponse();
	      _Logger.Logger.Trace('apiCont.RecordCall request');
	      var objectDataRecord = {
	        campId: this.state.dataCall.Id ? this.state.dataCall.Id : this.state.extraDataCall.Id,
	        option: this.state.dataCall.CallType ? this.state.dataCall.CallType : this.state.extraDataCall.CallType
	      };
	      this.apiCont.GetRecordCallPermission(objectDataRecord, objectResponseRecordCall);
	      objectResponseRecordCall.onError = function (err) {
	        _Logger.Logger.Warn('apiCont.RecordCall objectData:', objectDataRecord, 'error:', err);
	      };
	      objectResponseRecordCall.onSuccess = function (objResponse) {
	        _Logger.Logger.Trace('apiCont.RecordCall onSucces:', objResponse);
	        _this.setVisibleItem("marks", objResponse !== 3);
	        if (objResponse === 4) {
	          _this.actionPauseRecord(true);
	        }
	      };
	    }
	  }, {
	    key: 'showExtraButtons',
	    value: function showExtraButtons(callIcon) {
	      var _this = this;
	      this.setState({ iconCall: callIcon });
	      if (callIcon.LeaveRecMessage === 1) {
	        var btns = _this.state.renderButtons;
	        btns.forEach(function (element) {
	          if (element.idButton === "leaveMessage") {
	            element.showed = true;
	            return;
	          }
	        });
	        _this.setState({ renderButtons: btns });
	      }
	      _this.setVisibleItem("disposition", callIcon.ShowDisposition);
	      _this.setVisibleItem("record", callIcon.IsStartStopRecording);
	      _this.setVisibleItem("ivr", Boolean(parseInt(_this.ivrPermission, 10)));
	      _this.setState({ recording: callIcon.IsStartStopRecording });
	    }
	  }, {
	    key: 'getListDispositions',
	    value: function getListDispositions() {
	      var dataSend = void 0;
	      var _this = this;
	      var objectResponse = this.apiCont.getObjectResponse();
	      var timeout = this.sharedData.getRequestTimeout();
	      _Logger.Logger.Debug("[CallSpace] disposition list request timeout:" + timeout);
	      if (this.props.preview.isSetPreviewRecord && this.sharedData.getDataPreviewPro().dialingMode === 1) {
	        dataSend = {
	          CallOutId: this.props.preview.callOutId,
	          Id: this.props.preview.camId,
	          Type: 1,
	          UserId: this.sharedData.getParameters().UserID,
	          CamId: this.props.preview.camId
	        };
	      } else if (this.state.dataCall) {
	        dataSend = {
	          CallOutId: this.state.dataCall.CallOutId,
	          Id: this.state.dataCall.Id,
	          Type: this.state.dataCall.CallType - 1,
	          UserId: this.sharedData.getParameters().UserID,
	          CamId: this.state.dataCall.Id
	        };
	      }
	      if (Object.keys(this.props.extraDataCall).length > 0 && this.state.currentState === _constants.USER_STATE.OTHER && this.sharedData.getDataPreviewPro().dialingMode === 0) {
	        dataSend = {
	          CallOutId: this.props.extraDataCall.CallOutId,
	          Id: this.props.extraDataCall.CamId,
	          Type: this.props.extraDataCall.CallType === 2 ? 1 : 0,
	          UserId: this.sharedData.getParameters().UserID,
	          CamId: this.props.extraDataCall.CamId
	        };
	      }
	      _Logger.Logger.Debug("[CallSpace] disposition list request CallOutId:" + dataSend.CallOutId + " CamId:" + dataSend.CamId + " Id:" + dataSend.Id + " Type:" + dataSend.Type + " UserId:" + dataSend.UserId);
	      this.apiCont.dispositionList(dataSend, objectResponse, timeout);
	      objectResponse.onError = function (messageError) {
	        _Logger.Logger.Warning("error consulting dispositionList in data base----->>", messageError);
	        _this.setState({ dispositionListError: messageError });
	      };
	      objectResponse.onCatch = function (messageError) {
	        _Logger.Logger.Warning("catch error consulting dispositionList in data base----->>", messageError);
	      };
	      objectResponse.onSuccess = function (objResponse) {
	        _Logger.Logger.Trace("[RateCall] API Response OK ");
	        _this.setState({ dispositionListInformation: objResponse });
	      };
	    }
	  }, {
	    key: 'showMoreOptions',
	    value: function showMoreOptions() {
	      this.selectObjectRight("moreOptions", !this.isActiveButton("moreOptions", this.state.rightButtons));
	      this.setState({ showingMoreOptions: !this.state.showingMoreOptions });
	    }
	  }, {
	    key: 'moreOptionsContainer',
	    value: function moreOptionsContainer(item) {
	      var _this4 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'moreOptionsContainer', key: "buttonMoreOptions" },
	        _react2.default.createElement(
	          'div',
	          { className: item.className, onClick: item.action },
	          ' ',
	          item.image,
	          ' '
	        ),
	        item.active && this.isActiveButton("moreOptions", this.state.rightButtons) && this.state.currentState !== _constants.USER_STATE.WRAPUP && _react2.default.createElement(
	          'div',
	          { className: 'barButtonsFloatCall' },
	          this.state.renderButtons.map(function (item, i) {
	            return item.showed && item.hideAt > _this4.state.barSize && _react2.default.createElement(
	              'div',
	              { className: item.className, key: "button" + i, onClick: item.action },
	              ' ',
	              item.image,
	              ' '
	            );
	          })
	        )
	      );
	    }
	  }, {
	    key: 'classNameHeader',
	    value: function classNameHeader() {
	      if (this.isActiveButton("disposition")) {
	        return _constants.TYPE_DESIGN_CALL.WRAPUP;
	      }
	
	      return this.state.dataCall.CallType ? this.state.dataCall.CallType === _constants.TYPE_CALL.INBOUND ? _constants.TYPE_DESIGN_CALL.INBOUND : _constants.TYPE_DESIGN_CALL.OUTBOUND : this.state.extraDataCall.CallType === _constants.TYPE_CALL.INBOUND ? _constants.TYPE_DESIGN_CALL.INBOUND : _constants.TYPE_DESIGN_CALL.OUTBOUND;
	    }
	  }, {
	    key: 'setVisibleItem',
	    value: function setVisibleItem(idSeleccion, visible) {
	      var renderButtons = this.state.renderButtons;
	      var index = -1;
	      for (var i = 0; i < renderButtons.length; ++i) {
	        if (renderButtons[i].idButton === idSeleccion) {
	          index = i;
	          break;
	        }
	      }
	      renderButtons[index].showed = visible;
	      this.setState({ renderButtons: renderButtons });
	    }
	  }, {
	    key: 'isActiveButton',
	    value: function isActiveButton(idSeleccion) {
	      var arraySearch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state.renderButtons;
	
	      var index = -1;
	      for (var i = 0; i < arraySearch.length; ++i) {
	        if (arraySearch[i].idButton === idSeleccion) {
	          index = i;
	          break;
	        }
	      }
	      return arraySearch[index].active;
	    }
	  }, {
	    key: 'selectObjectRight',
	    value: function selectObjectRight(idSeleccion) {
	      var rightButtons = this.state.rightButtons;
	      var index = -1;
	      for (var i = 0; i < rightButtons.length; ++i) {
	        if (rightButtons[i].idButton === idSeleccion) {
	          index = i;
	          break;
	        }
	      }
	
	      if (rightButtons[index].active) {
	        rightButtons[index].className = rightButtons[index].className.replace(" selectedMoreOption", "");
	      } else {
	        rightButtons[index].className += " selectedMoreOption";
	      }
	      rightButtons[index].active = !rightButtons[index].active;
	      this.setState({ rightButtons: rightButtons });
	    }
	  }, {
	    key: 'selectObject',
	    value: function selectObject(idSeleccion, active) {
	      var renderButtons = this.state.renderButtons;
	      var index = -1;
	      for (var i = 0; i < renderButtons.length; ++i) {
	        if (renderButtons[i].idButton === idSeleccion) {
	          index = i;
	          break;
	        }
	      }
	
	      if (active) {
	        renderButtons[index].className += " selected";
	      } else {
	        renderButtons[index].className = renderButtons[index].className.replace(" selected", "");
	      }
	      renderButtons[index].active = active;
	      this.setState({ renderButtons: renderButtons });
	    }
	  }, {
	    key: 'actionDisposition',
	    value: function actionDisposition() {
	      this.selectObject("disposition", !this.isActiveButton("disposition"));
	    }
	  }, {
	    key: 'actionTransfer',
	    value: function actionTransfer() {
	      var messageIntegration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
	
	      !this.state.onTransferWindow && this.selectObject("transfer", !this.isActiveButton("transfer"));
	      this.props.insertWindow((0, _draggableComponents.transferCallWindow)({ dataCall: this.state.dataCall, messageIntegration: messageIntegration }), this.state.onTransferWindow ? false : true);
	    }
	  }, {
	    key: 'actionDTMF',
	    value: function actionDTMF() {
	      this.selectObject("dtmf", !this.isActiveButton("dtmf"));
	      var isEdit = this.state.iconCall ? this.state.iconCall.IsEditDtmf : false;
	      var dtmfOptions = this.state.iconCall ? this.state.iconCall.DtmfOptions : [];
	      var dtmfWindow = (0, _draggableComponents.dtmfTonesWindow)({ isEditDtmf: isEdit, dtmfOptions: dtmfOptions, digit: this.iDigit });
	      this.props.insertWindow(dtmfWindow, true);
	      this.iDigit = null;
	    }
	  }, {
	    key: 'actionVolume',
	    value: function actionVolume() {
	      this.selectObject("volume", !this.isActiveButton("volume"));
	    }
	  }, {
	    key: 'actionMute',
	    value: function actionMute() {
	      var mutedCall = !this.isActiveButton("mute");
	      this.selectObject("mute", mutedCall);
	      this.props.callAction(_constants.ACTION_CALL_ACD.MUTE, mutedCall);
	
	      var prevVolume = mutedCall ? this.state.volumeMicrophone : this.state.lastVolume;
	      var newVolumne = mutedCall ? 0 : this.state.lastVolume;
	
	      this.setState({
	        lastVolume: prevVolume,
	        volumeMicrophone: newVolumne
	      });
	      _Logger.Logger.Info("[callspace][actionMute] volumeMicrophone:", newVolumne);
	      _Logger.Logger.Info("[callspace][actionMute] volumeSpeaker:", this.sharedData.getVolumeSpeaker());
	      this.props.volumeMicrophone(newVolumne);
	      this.props.volumeSpeaker(this.sharedData.getVolumeSpeaker());
	      var integrationMessage = { client: "galatea", action: "onCallBar", subaction: "onMute", data: mutedCall };
	      _SingletonWebSocket2.default.send(integrationMessage);
	    }
	  }, {
	    key: 'actionPauseCall',
	    value: function actionPauseCall() {
	      var holdCall = !this.isActiveButton("hold");
	      this.selectObject("hold", holdCall);
	      if (this.state.currentState === _constants.USER_STATE.OTHER) {
	        this.props.callAction(_constants.ACTION_CALL_ACD.HOLD, {}, this.state.extraDataCall.CallOutId);
	      } else {
	        this.props.callAction(_constants.ACTION_CALL_ACD.HOLD);
	      }
	
	      var integrationMessage = { client: "galatea", action: "onCallBar", subaction: "onHold", data: holdCall };
	      _SingletonWebSocket2.default.send(integrationMessage);
	    }
	  }, {
	    key: 'actionMarkCall',
	    value: function actionMarkCall() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	      this.selectObject("marks", !this.isActiveButton("marks"));
	      this.props.insertWindow((0, _draggableComponents.markCallWindow)(props), true);
	    }
	  }, {
	    key: 'actionIVR',
	    value: function actionIVR() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	      this.selectObject("ivr", !this.isActiveButton("ivr"));
	      this.props.insertWindow((0, _draggableComponents.ongoingCallIvrWindow)(props), true);
	    }
	  }, {
	    key: 'actionPauseRecord',
	    value: function actionPauseRecord() {
	      this.props.messageToStateMachine((0, _helperMessages.messageStartStopRecording)(!this.isActiveButton("record")));
	      this.selectObject("record", !this.isActiveButton("record"));
	    }
	  }, {
	    key: 'actionHangUp',
	    value: function actionHangUp() {
	      var _this5 = this;
	
	      this.props.preview.isSetPreviewRecord && this.acionHangUpPreview();
	      this.setState({ disableHp: true });
	      setTimeout(function () {
	        _this5.setState({ disableHp: false });
	      }, 3000);
	      var callOutId = this.sharedData.getDataPreviewPro().dialingMode === 1 ? this.state.extraDataCall.CallOutId : 0;
	      this.props.messageToStateMachine((0, _helperMessages.messageHangUp)(_constants.HANG_UP_SUBACTIONS.CALL, callOutId));
	      this.sharedData.setCurrentCallMarks([]);
	      this.sharedData.setCallIcon(null);
	    }
	  }, {
	    key: 'acionHangUpPreview',
	    value: function acionHangUpPreview() {
	      this.props.updatePreviewRecord({ IsSave: false, action: 'UPDATE_DATA_CALL' });
	    }
	  }, {
	    key: 'actionHangUpAndLeaveMessage',
	    value: function actionHangUpAndLeaveMessage() {
	      this.props.messageToStateMachine((0, _helperMessages.messageHangUp)(_constants.HANG_UP_SUBACTIONS.LEAVE_MESSAGE, 0));
	    }
	  }, {
	    key: 'setVolumeSpeaker',
	    value: function setVolumeSpeaker(vol) {
	      _Logger.Logger.Info("[callspace][setVolumeSpeaker] vol:", vol);
	      this.sharedData.setVolumeSpeaker(vol);
	      this.setState({ volumeSpeaker: vol });
	      var renderButtons = this.state.renderButtons;
	      var index = -1;
	      for (var i = 0; i < renderButtons.length; ++i) {
	        if (renderButtons[i].idButton === "volume") {
	          index = i;
	          break;
	        }
	      }
	      renderButtons[index].image = vol === 0 ? _CallSpaceHeaderSVG.noVolume : vol < 60 ? _CallSpaceHeaderSVG.volumeMedium : _CallSpaceHeaderSVG.volume;
	      this.setState({ renderButtons: renderButtons });
	    }
	  }, {
	    key: 'setVolumeMicrophone',
	    value: function setVolumeMicrophone(volume) {
	      _Logger.Logger.Info("[callspace][setVolumeMicrophone] vol:", volume);
	      this.sharedData.setVolumeMic(volume);
	      this.setState({ volumeMicrophone: volume, lastVolume: volume });
	      this.selectObject("mute", volume === 0);
	    }
	  }, {
	    key: 'volumeContainer',
	    value: function volumeContainer(item) {
	      var _this6 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'volumeContainer', key: "buttonVolume" },
	        _react2.default.createElement(
	          _reactBootstrap.OverlayTrigger,
	          {
	            id: 'tlt-buttonsContainer-volumme',
	            key: 'tlt-buttonsContainer-volumme',
	            placement: 'top',
	            overlay: _react2.default.createElement(
	              _reactBootstrap.Tooltip,
	              { className: 'buttonsContainer-tooltip top show', id: 'toolTiptlt-buttonsContainer-volumme' },
	              this.language.getText('GUICallSpace' + item.tooltip)
	            )
	          },
	          _react2.default.createElement(
	            'div',
	            { className: item.className, onClick: item.action },
	            item.image
	          )
	        ),
	        item.active && _react2.default.createElement(_Volume2.default, {
	          volSpeaker: this.state.volumeSpeaker,
	          volMicrophone: this.state.volumeMicrophone,
	          muteMicrophone: this.state.volumeMicrophone === 0,
	          onChangeVolumeSpeakers: function onChangeVolumeSpeakers(vol) {
	            return _this6.setVolumeSpeaker(vol);
	          },
	          onChangeVolumeMicro: function onChangeVolumeMicro(volume) {
	            return _this6.setVolumeMicrophone(volume);
	          },
	          alert: function alert(e) {
	            return _this6.props.alertVolume(e);
	          },
	          closeItem: function closeItem() {
	            return _this6.selectObject("volume", false);
	          }
	        })
	      );
	    }
	  }, {
	    key: 'fillDataCells',
	    value: function fillDataCells() {
	      if (this.state.dataCall && this.state.dataCall.DataContact && this.state.dataCall.DataContact.length !== 0) {
	        var array = [];
	        for (var i = 0; i < 5; ++i) {
	          array.push({ text: this.state.dataCall.DataContact[i], focus: false, index: i });
	        }
	        return array;
	      } else if (this.state.extraDataCall && this.state.extraDataCall.ContactData && this.state.extraDataCall.ContactData.length !== 0) {
	        var _array = [];
	        for (var _i = 0; _i < 5; ++_i) {
	          _array.push({ text: this.state.extraDataCall.ContactData[_i], focus: false, index: _i });
	        }
	        return _array;
	      } else {
	        var _array2 = [];
	        for (var _i2 = 0; _i2 < 5; ++_i2) {
	          _array2.push({ text: "", focus: false, index: _i2 });
	        }
	        return _array2;
	      }
	    }
	  }, {
	    key: 'resetIntegrationAction',
	    value: function resetIntegrationAction() {
	      this.integrationAction = null;
	    }
	  }, {
	    key: 'saveDataCall',
	    value: function saveDataCall(dataCall) {
	      this.setState({ dataCall: dataCall });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this7 = this;
	
	      var telephoneNumber = this.state.dataCall.Phone ? this.state.dataCall.Phone : this.state.extraDataCall.Phone;
	      var type = this.state.dataCall.CallType ? this.state.dataCall.CallType : this.state.extraDataCall.CallType;
	      var showHeader = this.sharedData.getDataPreviewPro().dialingMode === 0 && this.state.currentState !== _constants.USER_STATE.ASSISTED || this.sharedData.getDataPreviewPro().dialingMode === 1 && (this.state.currentState === _constants.USER_STATE.DIALOG || this.state.currentState === _constants.USER_STATE.OTHER);
	      var showHeaderPreview = this.sharedData.getDataPreviewPro().dialingMode === 1 && this.props.preview.dialogTime !== undefined && this.state.currentState === _constants.USER_STATE.WRAPUP;
	      return _react2.default.createElement(
	        'div',
	        { className: 'callSpace' },
	        showHeader && _react2.default.createElement(_CallHeader2.default, { campaignName: this.state.iconCall ? this.state.iconCall.Description : "",
	          phoneNumber: telephoneNumber,
	          typeCall: type,
	          typeHeader: this.classNameHeader(),
	          iconCallFrame: this.state.iconCall ? this.state.iconCall.Frame : -1,
	          startTimer: !this.problemInManualCall && (this.state.currentState === _constants.USER_STATE.DIALOG || this.state.currentState === _constants.USER_STATE.OTHER),
	          recordingEnabled: this.state.recording,
	          buttonRecordingActive: this.isActiveButton("record") // ? this.isActiveButton("record") : true}
	          , dataCall: this.state.dataCall,
	          currentState: this.state.currentState,
	          dataCallAssisted: this.sharedData.getDataAssistedCall()
	        }),
	        showHeaderPreview && _react2.default.createElement(_CallHeaderPreview2.default, {
	          campaignName: this.props.preview.campaignName ? this.props.preview.campaignName : this.state.iconCall ? this.state.iconCall.Description : "",
	          iconCallFrame: this.props.preview.iconCampaing ? this.props.preview.iconCampaing : this.state.iconCall ? this.state.iconCall.Frame : "",
	          callKey: this.props.preview.callKey,
	          seconds: this.props.preview.dialogTime,
	          phones: this.props.preview.phones,
	          isRunning: false,
	          userState: this.state.currentState
	        }),
	        this.isActiveButton("disposition") || this.state.currentState === _constants.USER_STATE.WRAPUP ? _react2.default.createElement(_RateCall2.default, {
	          phoneNumber: this.state.dataCall ? this.state.dataCall.Phone : "",
	          onDispositionButton: function onDispositionButton() {
	            return _this7.selectObject("disposition", false);
	          },
	          dataCall: this.props.userState.currentState === _constants.USER_STATE.OTHER ? this.state.extraDataCall : this.state.dataCall,
	          editableCallKey: this.state.iconCall ? this.state.iconCall.EditableCallKey : false,
	          userState: this.state.currentState,
	          dispositionTime: this.state.dataCall.WrapUpTime,
	          messagesIntegrations: this.props.messagesIntegrations,
	          integrationAction: this.integrationAction,
	          resetIntegrationAction: function resetIntegrationAction() {
	            _this7.resetIntegrationAction();
	          },
	          problemInManualCall: this.problemInManualCall,
	          dispositionListInformation: this.state.dispositionListInformation,
	          dispositionListError: this.state.dispositionListError,
	          actionPrevRecord: this.props.actionPrevRecord
	        }) : _react2.default.createElement(_CallWindow2.default, { typeCall: this.state.dataCall ? this.state.dataCall.CallType === _constants.TYPE_CALL.INBOUND ? _constants.TYPE_DESIGN_CALL.INBOUND : _constants.TYPE_DESIGN_CALL.OUTBOUND : _constants.TYPE_DESIGN_CALL.INBOUND,
	          editableCallKey: this.state.iconCall ? this.state.iconCall.EditableCallKey : false,
	          dataCall: this.state.dataCall,
	          iconCall: this.state.iconCall,
	          extraDataCall: this.state.extraDataCall,
	          dataCells: this.fillDataCells(),
	          saveDataCall: this.saveDataCall.bind(this)
	        }),
	        (this.state.currentState === _constants.USER_STATE.DIALOG || this.state.currentState === _constants.USER_STATE.OTHER) && _react2.default.createElement(
	          'div',
	          { className: 'barButtonsCall', ref: 'BarButtons' },
	          _react2.default.createElement(
	            'div',
	            { className: 'buttonsContainer', style: { width: this.sizeBarWidht, marginRight: this.state.marginRight, marginLeft: this.state.marginLeft } },
	            this.state.renderButtons.map(function (item, i) {
	              return item.showed && item.enabledState && item.hideAt <= _this7.state.barSize && (item.idButton === "volume" ? _this7.volumeContainer(item) : _react2.default.createElement(
	                _reactBootstrap.OverlayTrigger,
	                {
	                  key: 'tlt-buttonsContainer-' + i,
	                  placement: 'top',
	                  overlay: _react2.default.createElement(
	                    _reactBootstrap.Tooltip,
	                    { id: 'tooltIpId-tlt-buttonsContainer-' + i, className: 'buttonsContainer-tooltip top show' },
	                    _this7.language.getText('GUICallSpace' + item.tooltip)
	                  )
	                },
	                _react2.default.createElement(
	                  'div',
	                  { className: item.className, key: "button" + i, onClick: item.action },
	                  item.image
	                )
	              ));
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'rightButtons', style: { width: this.sizeBarRightWidht } },
	            this.state.rightButtons.map(function (item, i) {
	              return item.showAt >= _this7.state.barSize && item.enabledState && (item.idButton === "volume" ? _this7.volumeContainer(item) : _react2.default.createElement(
	                'div',
	                {
	                  className: item.className,
	                  key: "button" + i,
	                  onClick: item.action },
	                item.image
	              )) && (item.idButton === "moreOptions" ? _this7.moreOptionsContainer(item) : _react2.default.createElement(
	                _reactBootstrap.OverlayTrigger,
	                {
	                  key: 'tlt-buttonsContainer-hangup',
	                  placement: 'top',
	                  overlay: _react2.default.createElement(
	                    _reactBootstrap.Tooltip,
	                    { id: 'tooltIpId-tlt-buttonsContainer-hangup', className: 'buttonsContainer-tooltip top show' },
	                    _this7.language.getText('GUICallSpaceHangUp')
	                  ) },
	                _react2.default.createElement(
	                  'div',
	                  {
	                    className: item.className + (' ' + (item.idButton === "hangUp" && _this7.state.disableHp && "disabled")),
	                    key: "button" + i,
	                    onClick: item.idButton === "hangUp" && _this7.state.disableHp ? function () {} : item.action,
	                    id: "cs-tooltip-hangUp" },
	                  item.image
	                )
	              ));
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return CallSpace;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    assistedTransfer: state.assistedTransfer,
	    messagesIntegrations: state.messagesIntegrations,
	    preview: state.preview,
	    showDataBySetting: state.transferReducer.showDataBySetting,
	    userState: state.userState
	  };
	}
	function mapDispatchToProps(dispatch) {
	  var _hideModal = _A_ongoing_call_ivr_modal2.default.creators.hideModal;
	
	  return {
	    messageToStateMachine: function messageToStateMachine(message) {
	      dispatch((0, _A_messages_to_SM.messageToStateMachine)(message));
	    },
	    callAction: function callAction(actionType, parameters, callOutId) {
	      dispatch((0, _A_reducer_call_acd.callAction)(actionType, parameters, callOutId));
	    },
	    insertWindow: function insertWindow(dragWindow, closeComponentIfOpen) {
	      dispatch((0, _A_draggable_windows_controller.insertWindow)(dragWindow, closeComponentIfOpen));
	    },
	    removeWindow: function removeWindow(iDdragComponent) {
	      dispatch((0, _A_draggable_windows_controller.removeWindow)(iDdragComponent));
	    },
	    hideModal: function hideModal() {
	      dispatch(_hideModal());
	    },
	    volumeMicrophone: function volumeMicrophone(volume) {
	      dispatch((0, _A_volume.volumeMicrophone)(volume));
	    },
	    volumeSpeaker: function volumeSpeaker(volume) {
	      dispatch((0, _A_volume.volumeSpeaker)(volume));
	    },
	    updatePreviewRecord: function updatePreviewRecord(record) {
	      dispatch((0, _A_preview.updatePreviewRecord)(record));
	    }
	  };
	}
	exports.default = CallSpace = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CallSpace);

/***/ },
/* 1115 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.About = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(25);
	
	var _Singleton = __webpack_require__(21);
	
	var _Images = __webpack_require__(30);
	
	var _singletonSharedData = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var About = exports.About = function (_Component) {
	  _inherits(About, _Component);
	
	  function About(props) {
	    _classCallCheck(this, About);
	
	    var _this = _possibleConstructorReturn(this, (About.__proto__ || Object.getPrototypeOf(About)).call(this, props));
	
	    _this.language = new _Singleton.Singleton();
	    _this.sharedData = new _singletonSharedData.SingletonSharedData();
	    _this.state = {
	      phonesSchedulesTags: [],
	      pais: ""
	    };
	    return _this;
	  }
	
	  _createClass(About, [{
	    key: 'UNSAFE_componentWillMount',
	    value: function UNSAFE_componentWillMount() {
	      this.getTagsByCountry();
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.whiteLabelEnabled && this.props.customLogoFormat === 'svg') {
	        var container = document.getElementById("custom-logo-about");
	        container.innerHTML = this.props.customLogo;
	      }
	    }
	  }, {
	    key: 'getTagsByCountry',
	    value: function getTagsByCountry() {
	      var arrayTags = this.state.phonesSchedulesTags;
	      var pais = this.sharedData.getCountry();
	      switch (pais) {
	        case '1':
	          arrayTags.push({
	            phoneNumber: this.language.getText("GUIAboutphoneNumberMexico"),
	            ePhoneNumber: this.language.getText("GUIAboutphoneNumberMexico2"),
	            schedule: this.language.getText("GUIAboutscheduleMexico1"),
	            schedule2: this.language.getText("GUIAboutscheduleMexico2"),
	            schedule3: this.language.getText("GUIAboutscheduleMexico3"),
	            eSchedule: this.language.getText("GUIAboutemergencyScheduleMexico"),
	            eSchedule2: this.language.getText("GUIAboutemergencyScheduleMexico2"),
	            showLastTags: true
	          });
	          break;
	        case '2':
	          arrayTags.push({
	            phoneNumber: this.language.getText("GUIAboutphoneNumberSouthAmerica"),
	            schedule: this.language.getText("GUIAboutscheduleLatinAmerica"),
	            ePhoneNumber: this.language.getText("GUIAboutemergencyPhoneNumberSouthAmerica"),
	            eSchedule: this.language.getText("GUIAboutemergencyScheduleLatinAmerica"),
	            eSchedule2: this.language.getText("GUIAboutemergencyScheduleLatinAmerica2"),
	            showLastTags: false
	          });
	          break;
	        case '4':
	          arrayTags.push({
	            phoneNumber: this.language.getText("GUIAboutphoneNumberUsa"),
	            schedule: this.language.getText("GUIAboutscheduleUsa"),
	            ePhoneNumber: this.language.getText("GUIAboutemergencyPhoneNumberUsa"),
	            eSchedule: this.language.getText("GUIAboutemergencyScheduleUsa"),
	            eSchedule2: this.language.getText("GUIAboutemergencyScheduleUsa2"),
	            showLastTags: false
	          });
	          break;
	        case '5':
	          arrayTags.push({
	            phoneNumber: this.language.getText("GUIAboutNumberSouthAmerica"),
	            schedule: this.language.getText("GUIAboutscheduleLatinAmerica"),
	            ePhoneNumber: this.language.getText("GUIAboutemergencySouthAmerica"),
	            eSchedule: this.language.getText("GUIAboutemergencyScheduleLatinAmerica"),
	            eSchedule2: this.language.getText("GUIAboutemergencyScheduleLatinAmerica2"),
	            showLastTags: false
	          });
	          break;
	        default:
	          arrayTags.push({
	            phoneNumber: this.language.getText("GUIAboutphoneNumberMexico"),
	            ePhoneNumber: this.language.getText("GUIAboutphoneNumberMexico2"),
	            schedule: this.language.getText("GUIAboutscheduleMexico1"),
	            schedule2: this.language.getText("GUIAboutscheduleMexico2"),
	            schedule3: this.language.getText("GUIAboutscheduleMexico3"),
	            eSchedule: this.language.getText("GUIAboutemergencyScheduleMexico"),
	            eSchedule2: this.language.getText("GUIAboutemergencyScheduleMexico2"),
	            showLastTags: true
	          });
	          break;
	      }
	      this.setState({ phonesSchedulesTags: arrayTags, pais: this.sharedData.getCountry() });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'aboutContainer' },
	        _react2.default.createElement(
	          'div',
	          { className: 'aboutHeader' },
	          _react2.default.createElement(
	            'p',
	            { className: 'titleHeaderAbout' },
	            this.language.getText("GUIAboutabout")
	          ),
	          _react2.default.createElement('div', { className: 'minimizeAbout', onClick: function onClick() {
	              return _this2.props.closeAboutWindow();
	            } })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'aboutBody' },
	          _react2.default.createElement(
	            'div',
	            { className: 'centerwareInfo' },
	            this.props.whiteLabelEnabled ? _react2.default.createElement(
	              'div',
	              { id: 'custom-logo-about' },
	              this.props.customLogoFormat === 'image' && _react2.default.createElement('img', { id: 'custom-about-img', alt: '', src: this.props.customLogo })
	            ) : _react2.default.createElement('img', { className: 'logo', alt: '', src: _Images.logoKolobAgent }),
	            _react2.default.createElement(
	              'p',
	              { className: 'version' },
	              this.language.getText("GUIAboutversion") + " " + this.sharedData.getVersionAgent()
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mail' },
	              this.language.getText("GUIAboutsupport") + " " + this.language.getText("GUIAboutnuxibaMail")
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'contactInfo' },
	            _react2.default.createElement(
	              'div',
	              { className: 'containerInfo' },
	              _react2.default.createElement(
	                'h1',
	                null,
	                this.language.getText("GUIAboutscheduleOpening")
	              ),
	              _react2.default.createElement(
	                'h2',
	                null,
	                this.language.getText("GUIAboutmondayToFriday")
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                this.state.phonesSchedulesTags[0].schedule,
	                _react2.default.createElement('br', null),
	                ' ',
	                this.language.getText("GUIAboutphone") + " " + this.state.phonesSchedulesTags[0].phoneNumber
	              ),
	              this.state.phonesSchedulesTags[0].showLastTags && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'h2',
	                  null,
	                  this.language.getText("GUIAboutsaturday")
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  this.state.phonesSchedulesTags[0].schedule2,
	                  _react2.default.createElement('br', null),
	                  ' ',
	                  this.language.getText("GUIAboutphone") + " " + this.state.phonesSchedulesTags[0].phoneNumber
	                ),
	                _react2.default.createElement(
	                  'h2',
	                  null,
	                  this.language.getText("GUIAboutsunday")
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  this.state.phonesSchedulesTags[0].schedule3,
	                  _react2.default.createElement('br', null),
	                  ' ',
	                  this.language.getText("GUIAboutphone") + " " + this.state.phonesSchedulesTags[0].phoneNumber
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'containerInfo' },
	              _react2.default.createElement(
	                'h1',
	                null,
	                this.language.getText("GUIAboutemergencies")
	              ),
	              _react2.default.createElement(
	                'h2',
	                null,
	                this.language.getText("GUIAboutmondayToFriday")
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                this.state.phonesSchedulesTags[0].eSchedule,
	                _react2.default.createElement('br', null),
	                ' ',
	                this.language.getText("GUIAboutphone") + " " + this.state.phonesSchedulesTags[0].ePhoneNumber
	              ),
	              _react2.default.createElement(
	                'h2',
	                null,
	                this.language.getText("GUIAboutsaturdayAndMonday")
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                this.state.phonesSchedulesTags[0].eSchedule2,
	                _react2.default.createElement('br', null),
	                ' ',
	                this.language.getText("GUIAboutphone") + " " + this.state.phonesSchedulesTags[0].ePhoneNumber
	              )
	            ),
	            _react2.default.createElement('img', { className: 'logo', alt: '', src: _Images.poweredNuxiba })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'aboutFooter' },
	          this.language.getText("GUILogingalateaCopyright")
	        )
	      );
	    }
	  }]);
	
	  return About;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    whiteLabelEnabled: state.whiteLabelState.whiteLabelEnabled,
	    customLogo: state.whiteLabelState.about,
	    customLogoFormat: state.whiteLabelState.imageFormat
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(About);

/***/ },
/* 1116 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(25);
	
	var _Images = __webpack_require__(30);
	
	var _GenericSVG = __webpack_require__(51);
	
	var _CallSpaceHeaderSVG = __webpack_require__(67);
	
	var _Singleton = __webpack_require__(21);
	
	var _StrategiesAssistedTransfer = __webpack_require__(1142);
	
	var _StrategiesIntegrationAssistedTransfer = __webpack_require__(1143);
	
	var _singletonSharedData = __webpack_require__(23);
	
	var _Validations = __webpack_require__(131);
	
	var _A_messages_to_SM = __webpack_require__(32);
	
	var _A_assisted_transfer = __webpack_require__(332);
	
	var _constants = __webpack_require__(10);
	
	var _CallingAssistedTransfer = __webpack_require__(505);
	
	var _CallingAssistedTransfer2 = _interopRequireDefault(_CallingAssistedTransfer);
	
	var _SingletonWebSocket = __webpack_require__(50);
	
	var _SingletonWebSocket2 = _interopRequireDefault(_SingletonWebSocket);
	
	var _formats = __webpack_require__(54);
	
	var _A_preview = __webpack_require__(52);
	
	var _A_preview_transfer = __webpack_require__(193);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AssistedTransfer = function (_Component) {
	  _inherits(AssistedTransfer, _Component);
	
	  function AssistedTransfer(props) {
	    _classCallCheck(this, AssistedTransfer);
	
	    var _this2 = _possibleConstructorReturn(this, (AssistedTransfer.__proto__ || Object.getPrototypeOf(AssistedTransfer)).call(this, props));
	
	    _this2.state = {
	      newCallNumber: "",
	      isInConference: _this2.props.isInConference,
	      transferring: false
	    };
	    _this2.language = new _Singleton.Singleton();
	    _this2.sharedData = new _singletonSharedData.SingletonSharedData();
	    _this2.information = _this2.props.data;
	    _this2.data = {
	      sPhone: "",
	      reference: "",
	      callId: ""
	    };
	    return _this2;
	  }
	
	  _createClass(AssistedTransfer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.assistedTransfer.currentState === _constants.ASSISTED_TRANSFER.ON_CONFERENCE_CALL ? this.setState({ transferring: true }) : this.setState({ transferring: false });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (_StrategiesAssistedTransfer.STRATEGIES_ASSISTED_TRANSFER[nextProps.assistedTransfer.currentState]) {
	        _StrategiesAssistedTransfer.STRATEGIES_ASSISTED_TRANSFER[nextProps.assistedTransfer.currentState](this);
	      }
	      if (nextProps.messagesIntegrations.dataMessageIntegration && nextProps.messagesIntegrations !== this.props.messagesIntegrations) {
	        if (_StrategiesIntegrationAssistedTransfer.STRATEGIES_INTEGRATION_ASSISTED_TRANSFER[nextProps.messagesIntegrations.dataMessageIntegration.action]) {
	          _StrategiesIntegrationAssistedTransfer.STRATEGIES_INTEGRATION_ASSISTED_TRANSFER[nextProps.messagesIntegrations.dataMessageIntegration.action](this, nextProps.messagesIntegrations.dataMessageIntegration);
	        }
	      }
	    }
	  }, {
	    key: 'dialNumber',
	    value: function dialNumber(phone) {
	      if (!this.state.isInConference) {
	        this.sendintegrationErrorMessage("Invalid function at the current state, set up a conference to add more calls");
	      } else if (this.state.isInConference) {
	        this.setState({ newCallNumber: phone });
	        this.callNewNumber();
	      }
	    }
	  }, {
	    key: 'callNewNumber',
	    value: function callNewNumber() {
	      this.props.newAssistedTransferState(_constants.ASSISTED_TRANSFER.ON_CONFERENCE_CALL);
	    }
	  }, {
	    key: 'leaveTransfer',
	    value: function leaveTransfer() {
	      var _this3 = this;
	
	      var _this = this;
	      setTimeout(function () {
	        _this.props.actionPreviewRecord({
	          process: 15,
	          camId: _this3.props.previewReducer.selectedRecord.camId,
	          callOutId: _this3.props.previewReducer.selectedRecord.callOutId,
	          callId: _this3.props.previewReducer.selectedRecord.callId,
	          fReplacementJob: _this3.props.previewReducer.previewType === 1 ? 1 : 0,
	          fMultipleJob: 1
	        });
	      }, 101);
	      setTimeout(function () {
	        _this3.props.removeRecord(_this3.props.previewReducer.selectedRecord.callOutId);
	      }, 200);
	      this.props.setTransferInProgress(false);
	    }
	  }, {
	    key: 'mainCall',
	    value: function mainCall(CallIndex) {
	      if (this.information[CallIndex].active === false) {
	        this.data.reference = this.information[CallIndex].flag;
	        this.props.messageAssistedTransferCall(_constants.ASSISTED_TRANSFER_SUBACTION.ASSISTED, this.data);
	        if (this.information[CallIndex].title === this.language.getText("CallControlGUIAssistedCallTransfermainCall")) {
	          var _this = this;
	          setTimeout(function () {
	            _this.props.newAssistedTransferState(_constants.ASSISTED_TRANSFER.MAIN_CALL);
	          }, 100);
	        }
	      } else {
	        this.sendintegrationErrorMessage("Invalid function at the current state, you are currently on the selected call");
	      }
	    }
	  }, {
	    key: 'assistedTransferCall',
	    value: function assistedTransferCall() {
	      var _this4 = this;
	
	      if (this.information[0].active && !this.state.isInConference) {
	        this.data.reference = "transfer";
	        if (this.sharedData.getDataPreviewPro().dialingMode === 1) {
	          this.data.agentDest = this.props.previewTransfer.login;
	        }
	        setTimeout(function () {
	          _this4.props.messageAssistedTransferCall(_constants.ASSISTED_TRANSFER_SUBACTION.ASSISTED, _this4.data);
	        }, 50);
	        if (this.props.previewReducer.simultaneosRecs) {
	          this.leaveTransfer();
	        }
	      } else {
	        this.sendintegrationErrorMessage("Invalid function at the current state, you must return to the main call");
	      }
	    }
	  }, {
	    key: 'hangUpSecondCall',
	    value: function hangUpSecondCall() {
	      var _this5 = this;
	
	      this.data.reference = "hangup";
	      setTimeout(function () {
	        _this5.props.messageAssistedTransferCall(_constants.ASSISTED_TRANSFER_SUBACTION.ASSISTED, _this5.data);
	      }, 50);
	      this.props.setTransferInProgress(false);
	    }
	  }, {
	    key: 'startconference',
	    value: function startconference() {
	      if (this.information[0].active) {
	        this.props.newAssistedTransferState(_constants.ASSISTED_TRANSFER.ON_CONFERENCE);
	      } else {
	        this.sendintegrationErrorMessage("Invalid function at the current state, you must return to the main call");
	      }
	    }
	  }, {
	    key: 'sendintegrationErrorMessage',
	    value: function sendintegrationErrorMessage(messageToSend) {
	      var error = { code: 7, message: messageToSend };
	      var integrationMessage = { client: "galatea", data: error, action: "onError" };
	      _SingletonWebSocket2.default.send(integrationMessage);
	    }
	  }, {
	    key: 'leaveConference',
	    value: function leaveConference() {
	      if (this.state.isInConference) {
	        this.data.reference = "leave";
	        if (this.sharedData.getDataPreviewPro().dialingMode === 1) {
	          this.data.agentDest = this.props.previewTransfer.login;
	        }
	        this.props.messageAssistedTransferCall(_constants.ASSISTED_TRANSFER_SUBACTION.ASSISTED, this.data);
	        if (this.props.previewReducer.simultaneosRecs) {
	          this.leaveTransfer();
	        }
	      } else {
	        this.sendintegrationErrorMessage("Invalid function at the current state, you are not in a conference");
	      }
	    }
	  }, {
	    key: 'hangUpConference',
	    value: function hangUpConference() {
	      this.props.messageHangUp(_constants.HANG_UP_SUBACTIONS.CALL, 0);
	      this.sharedData.setCallConferencetoZero();
	    }
	  }, {
	    key: 'hangUpCallingConference',
	    value: function hangUpCallingConference() {
	      this.data.reference = "hangupOther";
	      this.data.callId = this.sharedData.getConferenceCallID();
	      this.props.messageAssistedTransferCall(_constants.ASSISTED_TRANSFER_SUBACTION.ASSISTED, this.data);
	    }
	  }, {
	    key: 'hangUpOther',
	    value: function hangUpOther(i) {
	      this.data.reference = "hangupOther";
	      this.data.callId = this.information[i].callId;
	      this.props.messageAssistedTransferCall(_constants.ASSISTED_TRANSFER_SUBACTION.ASSISTED, this.data);
	    }
	  }, {
	    key: 'hangupSecondCallConference',
	    value: function hangupSecondCallConference() {
	      this.data.reference = "hangupSecondCall";
	      this.data.callId = "";
	      this.props.messageAssistedTransferCall(_constants.ASSISTED_TRANSFER_SUBACTION.ASSISTED, this.data);
	    }
	  }, {
	    key: 'handelKeyPress',
	    value: function handelKeyPress(e) {
	      if (e.key === 'Enter') {
	        this.callNewNumber();
	      } else {
	        (0, _Validations.validateOnlyNumbers)(e);
	      }
	    }
	  }, {
	    key: 'renderListCalls',
	    value: function renderListCalls() {
	      var _this6 = this;
	
	      var isHidePhone = this.sharedData.getGeneralPermissions()[223];
	
	      return this.information.map(function (item, i) {
	        return _react2.default.createElement(
	          'div',
	          { className: "callItemTransfer " + (item.active ? "activeCall" : "waitingCall"), key: "callList" + i, onClick: function onClick() {
	              return _this6.mainCall(i);
	            } },
	          _react2.default.createElement('div', { className: 'circle1' }),
	          _react2.default.createElement('div', { className: 'circle2' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'callItemTitle' },
	            _react2.default.createElement('input', { type: 'text',
	              placeholder: item.title //{this.language.getText('searchForMatchesButton')}
	              , className: "titleCallTransfer " + (_this6.state.isInConference ? "onConf" : ""),
	              value: _this6.state.searchTransfer }),
	            _react2.default.createElement(
	              'p',
	              { className: 'waiting' },
	              !item.active ? _this6.language.getText("CallControlGUIAssistedCallTransferwaiting") : ""
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'callItemData' },
	            _react2.default.createElement('img', { className: 'imgSide', src: item.active ? _Images.phoneIconChange : _Images.pause, alt: 'icon' }),
	            _react2.default.createElement(
	              'p',
	              { className: 'textRight' },
	              (0, _formats.hidePhone)(isHidePhone, item.number)
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'buttonHangUpTransferCall',
	              onClick: function onClick() {
	                switch (i) {
	                  case 0:
	                    _this6.hangUpConference();
	                    break;
	                  case 1:
	                    _this6.state.isInConference ? _this6.hangupSecondCallConference() : _this6.hangUpSecondCall();
	                    break;
	                  default:
	                    _this6.hangUpOther(i);
	                }
	              } },
	            _CallSpaceHeaderSVG.hangUp
	          )
	        );
	      });
	    }
	  }, {
	    key: 'renderAddCall',
	    value: function renderAddCall() {
	      var _this7 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'addNumberTransfer' },
	        _react2.default.createElement('img', { className: 'addNumberIcon', src: _Images.agenda, alt: 'icon', onClick: function onClick() {
	            return _this7.props.onOpenAgenda();
	          } }),
	        _react2.default.createElement(
	          'div',
	          { className: "addNumberContainer " + (this.state.newCallNumber !== "" ? "active" : "") },
	          _react2.default.createElement('img', { className: "imgSide " + (this.state.newCallNumber !== "" ? "active" : ""), src: _Images.phoneIconChange, alt: 'icon' }),
	          _react2.default.createElement('input', { type: 'text',
	            placeholder: this.language.getText("CallControlGUIAssistedCallTransferenterNumber") //{this.language.getText('searchForMatchesButton')} 
	            , className: "textRight " + (this.state.newCallNumber !== "" ? "active" : ""),
	            value: this.state.newCallNumber,
	            onChange: function onChange(event) {
	              _this7.setState({ newCallNumber: event.target.value });
	            },
	            onKeyPress: this.handelKeyPress.bind(this) }),
	          this.state.newCallNumber !== "" ? _react2.default.createElement(
	            'div',
	            { className: 'buttonClearText', onClick: function onClick() {
	                return _this7.setState({ newCallNumber: "" });
	              } },
	            _GenericSVG.closeSvg
	          ) : ""
	        ),
	        _react2.default.createElement('img', { className: "addNumberCall " + (this.state.newCallNumber !== "" ? "active" : ""),
	          src: _Images.phoneIconChange, alt: 'icon',
	          onClick: function onClick() {
	            return _this7.callNewNumber();
	          } })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this8 = this;
	
	      var addCall = this.sharedData.getDataPreviewPro().dialingMode !== 1;
	      return _react2.default.createElement(
	        'div',
	        { className: 'transferAssistedContainer' },
	        _react2.default.createElement(
	          'div',
	          { className: "CallingAssitedTransfer" },
	          this.state.transferring && _react2.default.createElement(_CallingAssistedTransfer2.default, {
	            phoneNumberTransfer: this.sharedData.getConferenceNewNumber(),
	            hangUpTransfer: function hangUpTransfer() {
	              return _this8.hangUpCallingConference();
	            }
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: "transferSelectionContainer " + (this.state.transferring ? "active" : "") },
	          _react2.default.createElement(
	            'div',
	            { className: 'callsList' },
	            this.renderListCalls(),
	            this.state.isInConference && addCall && this.renderAddCall()
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'optionsTransfer' },
	            this.state.isInConference ? _react2.default.createElement(
	              'div',
	              { className: "optionTransfer blueColor " + (this.sharedData.getextraCallsConference() ? "disabled" : ""), onClick: function onClick() {
	                  return _this8.leaveConference();
	                } },
	              _react2.default.createElement('img', { className: 'imgSide', src: _Images.leaveConference, alt: 'icon' }),
	              _react2.default.createElement(
	                'p',
	                { className: 'textRight onConf' },
	                this.language.getText("CallControlGUIAssistedCallTransferleaveConference")
	              )
	            ) : _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: "optionTransfer greenColor " + (!this.information[0].active || !this.props.allowsConference ? "disabled" : ""), onClick: function onClick() {
	                    return _this8.startconference();
	                  } },
	                _react2.default.createElement('img', { className: 'imgSide', src: _Images.conference, alt: 'icon' }),
	                _react2.default.createElement(
	                  'p',
	                  { className: 'textRight' },
	                  this.language.getText("CallControlGUIAssistedCallTransferconference")
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: "optionTransfer blueColor " + (!this.information[0].active ? "disabled" : ""), onClick: function onClick() {
	                    return _this8.assistedTransferCall();
	                  } },
	                _react2.default.createElement('img', { className: 'imgSide', src: _Images.transferCall, alt: 'icon' }),
	                _react2.default.createElement(
	                  'p',
	                  { className: 'textRight' },
	                  this.language.getText("CallControlGUIAssistedCallTransfertransfer")
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'optionTransfer redColor', onClick: function onClick() {
	                  return _this8.state.isInConference ? _this8.hangUpConference() : _this8.hangUpSecondCall();
	                } },
	              _CallSpaceHeaderSVG.hangUp
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return AssistedTransfer;
	}(_react.Component);
	
	;
	function mapStateToProps(state) {
	  return {
	    assistedTransfer: state.assistedTransfer,
	    messagesIntegrations: state.messagesIntegrations,
	    previewReducer: state.preview
	  };
	}
	function mapDispatchToProps(dispatch) {
	  return {
	    messageAssistedTransferCall: function messageAssistedTransferCall(action, data) {
	      dispatch((0, _A_messages_to_SM.messageAssistedTransferCall)(action, data));
	    },
	    messageHangUp: function messageHangUp(subaction, callOutId) {
	      dispatch((0, _A_messages_to_SM.messageHangUp)(subaction, callOutId));
	    },
	    newAssistedTransferState: function newAssistedTransferState(message) {
	      dispatch((0, _A_assisted_transfer.newAssistedTransferState)(message));
	    },
	    removeRecord: function removeRecord(callOutId) {
	      dispatch((0, _A_preview.removeRecord)(callOutId));
	    },
	    changePreviewRecordStatus: function changePreviewRecordStatus(callOutId) {
	      dispatch((0, _A_preview.changePreviewRecordStatus)({ callOutId: callOutId, status: _constants.RECORD_STATE.DEFAULT, messageStatus: null }));
	    },
	    actionPreviewRecord: function actionPreviewRecord(data) {
	      dispatch((0, _A_messages_to_SM.actionPreviewRecord)(data));
	    },
	    setTransferInProgress: function setTransferInProgress(flag) {
	      dispatch((0, _A_preview_transfer.setTransferInProgress)(flag));
	    }
	  };
	}
	exports.default = AssistedTransfer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AssistedTransfer);

/***/ },
/* 1117 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(25);
	
	var _Singleton = __webpack_require__(21);
	
	var _singletonSharedData = __webpack_require__(23);
	
	var _A_messages_to_SM = __webpack_require__(32);
	
	var _A_draggable_windows_controller = __webpack_require__(55);
	
	var _constants = __webpack_require__(10);
	
	var _customComponents = __webpack_require__(59);
	
	var _CallRecordSVG = __webpack_require__(322);
	
	var _Images = __webpack_require__(30);
	
	var _MarkDetail = __webpack_require__(1124);
	
	var _MarkDetail2 = _interopRequireDefault(_MarkDetail);
	
	var _formats = __webpack_require__(54);
	
	var _A_preview = __webpack_require__(52);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CallMarks = function (_Component) {
	  _inherits(CallMarks, _Component);
	
	  function CallMarks(props) {
	    _classCallCheck(this, CallMarks);
	
	    var _this2 = _possibleConstructorReturn(this, (CallMarks.__proto__ || Object.getPrototypeOf(CallMarks)).call(this, props));
	
	    _this2.sharedData = new _singletonSharedData.SingletonSharedData();
	    _this2.language = new _Singleton.Singleton();
	    _this2.state = {
	      arrayMarks: _this2.props.simultaneosRecs ? _this2.props.selectedRecord.marks : _this2.sharedData.getCurrentCallMarks()
	    };
	    return _this2;
	  }
	
	  _createClass(CallMarks, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.messagesIntegrations) {
	        if (nextProps.messagesIntegrations.dataMessageIntegration && nextProps.messagesIntegrations.dataMessageIntegration.action === _constants.INTEGRATION.CALL_ACTION && nextProps.messagesIntegrations.dataMessageIntegration.callAction === _constants.INTEGRATION.MARK_ADD) {
	          var _this = this;
	          _this.onAddMark();
	        }
	      }
	    }
	  }, {
	    key: 'deleteMark',
	    value: function deleteMark(mark) {
	      var copyMark = this.state.arrayMarks;
	      this.remove(copyMark, mark);
	      this.updateStateMarks(copyMark);
	    }
	  }, {
	    key: 'remove',
	    value: function remove(array, element) {
	      var index = array.indexOf(element);
	      if (index !== -1) {
	        array.splice(index, 1);
	      }
	    }
	  }, {
	    key: 'sendMarks',
	    value: function sendMarks(currentMark) {
	      var temp = currentMark.length > 0 ? currentMark.map(function (m) {
	        return m.time;
	      }).toString().replace(',', '|') : '';
	      var callOutId = this.props.simultaneosRecs ? this.props.selectedRecord.callOutId : 0;
	      this.props.messageMarksCall(temp, callOutId);
	    }
	  }, {
	    key: 'onAddMark',
	    value: function onAddMark() {
	      var currentTimeInSeconds = !this.props.simultaneosRecs ? this.sharedData.getCurrentCallTime() : this.fullFormat((0, _formats.getCurrentTimeInSec)() - this.props.initialDialogTime);
	      this.updateStateMarks([].concat(_toConsumableArray(this.state.arrayMarks), [{ time: currentTimeInSeconds, index: new Date().getTime() }]));
	    }
	  }, {
	    key: 'updateStateMarks',
	    value: function updateStateMarks(currentMark) {
	      this.setState({ arrayMarks: currentMark });
	      this.sharedData.setCurrentCallMarks(currentMark);
	      this.sendMarks(currentMark);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (this.state.arrayMarks.length > 0 && this.state.arrayMarks.length > prevState.arrayMarks.length) {
	        var cur = "mark" + (this.state.arrayMarks.length - 1);
	        var objDiv = document.getElementById(cur);
	        objDiv.scrollIntoView({ block: 'end', behavior: 'smooth', inline: 'center' });
	      }
	      if (this.props.simultaneosRecs && this.state.arrayMarks.length !== prevState.arrayMarks.length) {
	        this.saveMarksPreviewSimultaneousRecs();
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.state.arrayMarks.length === 0) {
	        this.onAddMark();
	      } else {
	        if (this.props.objProps && this.props.objProps.action === _constants.INTEGRATION.MARK_ADD) {
	          this.onAddMark();
	        }
	      }
	    }
	  }, {
	    key: 'onCloseWindow',
	    value: function onCloseWindow() {
	      this.sharedData.setCurrentCallMarks(this.state.arrayMarks);
	      this.props.removeWindow(_constants.DRAGGABLE_WINDOWS.MARK_CALL);
	      this.props.simultaneosRecs && this.props.onCloseMarCallkWindow();
	    }
	  }, {
	    key: 'zeroPad',
	    value: function zeroPad(value) {
	      return value.toString().padStart(2, '0');
	    }
	  }, {
	    key: 'fullFormat',
	    value: function fullFormat(totalSeconds) {
	      var hours = Math.floor(totalSeconds / 3600);
	      var minutes = Math.floor(totalSeconds / 60 % 60);
	      var seconds = totalSeconds % 60;
	      return this.zeroPad(hours) + ':' + this.zeroPad(minutes) + ':' + this.zeroPad(seconds);
	    }
	  }, {
	    key: 'saveMarksPreviewSimultaneousRecs',
	    value: function saveMarksPreviewSimultaneousRecs() {
	      this.props.setMarks({ callOutId: this.props.selectedRecord.callOutId, marks: this.state.arrayMarks });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'markCallContainer', onClick: function onClick() {
	            return _this3.props.goTopZ(_this3.props.id);
	          } },
	        _customComponents.CUSTOM_COMPONENTS["draggableHeader"](_CallRecordSVG.markSvg, this.language.getText("CallControlGUICallMarktitle"), function () {
	          return _this3.onCloseWindow();
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'markContainer' },
	          _react2.default.createElement(
	            'div',
	            { className: 'markContainerAllCell' },
	            this.state.arrayMarks.map(function (mark, i) {
	              return _react2.default.createElement(
	                'div',
	                { id: "mark" + i },
	                _react2.default.createElement(_MarkDetail2.default, {
	                  key: "mark" + i,
	                  mark: mark,
	                  onDeleteMark: function onDeleteMark(mark) {
	                    return _this3.deleteMark(mark);
	                  }
	                })
	              );
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'markButton', onClick: function onClick() {
	                return _this3.onAddMark();
	              } },
	            _react2.default.createElement('img', { className: 'markIcon', src: _Images.mark, alt: 'icon' }),
	            _react2.default.createElement('img', { className: 'addMarkIcon', src: _Images.addMark, alt: 'icon' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return CallMarks;
	}(_react.Component);
	
	;
	
	function mapStateToProps(state) {
	  return {
	    messagesIntegrations: state.messagesIntegrations,
	    selectedRecord: state.preview.selectedRecord,
	    simultaneosRecs: state.preview.simultaneosRecs,
	    records: state.preview.records
	    //{(selectedRecord, simultaneosRecs)}=(state)
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return {
	    removeWindow: function removeWindow(iDdragComponent) {
	      dispatch((0, _A_draggable_windows_controller.removeWindow)(iDdragComponent));
	    },
	    messageMarksCall: function messageMarksCall(marks, callOutId) {
	      dispatch((0, _A_messages_to_SM.messageMarksCall)(marks, callOutId));
	    },
	    setMarks: function setMarks(marks) {
	      dispatch((0, _A_preview.setMarks)(marks));
	    }
	  };
	}
	
	exports.default = CallMarks = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CallMarks);

/***/ },
/* 1118 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Images = __webpack_require__(30);
	
	var _GenericSVG = __webpack_require__(51);
	
	var _CallRecordSVG = __webpack_require__(322);
	
	var _CallSpaceHeaderSVG = __webpack_require__(67);
	
	var _reactRedux = __webpack_require__(25);
	
	var _Singleton = __webpack_require__(21);
	
	var _SingletonWebSocket = __webpack_require__(50);
	
	var _SingletonWebSocket2 = _interopRequireDefault(_SingletonWebSocket);
	
	var _reactResizable = __webpack_require__(2316);
	
	var _cwGalateaApiJsBundle = __webpack_require__(40);
	
	var _constants = __webpack_require__(10);
	
	var _singletonSharedData = __webpack_require__(23);
	
	var _draggableComponents = __webpack_require__(101);
	
	var _A_draggable_windows_controller = __webpack_require__(55);
	
	var _PlayerReproductor = __webpack_require__(1101);
	
	var _PlayerReproductor2 = _interopRequireDefault(_PlayerReproductor);
	
	var _RecordCallSingleton = __webpack_require__(507);
	
	var _TableComponent = __webpack_require__(238);
	
	var _TableComponent2 = _interopRequireDefault(_TableComponent);
	
	var _customComponents = __webpack_require__(59);
	
	var _alertQueryErrorBody = __webpack_require__(130);
	
	var _A_Alert_Modal = __webpack_require__(63);
	
	var _A_Alert_Modal2 = _interopRequireDefault(_A_Alert_Modal);
	
	var _AlertWindow = __webpack_require__(324);
	
	var _AlertWindow2 = _interopRequireDefault(_AlertWindow);
	
	var _A_agent_permissions = __webpack_require__(331);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CallRecord = function (_Component) {
	  _inherits(CallRecord, _Component);
	
	  function CallRecord(props) {
	    var _this2$state;
	
	    _classCallCheck(this, CallRecord);
	
	    var _this2 = _possibleConstructorReturn(this, (CallRecord.__proto__ || Object.getPrototypeOf(CallRecord)).call(this, props));
	
	    _this2.onResize = function (event, _ref) {
	      var size = _ref.size;
	
	      var newArraySize = _this2.resizeElements(size.width - 210);
	      _this2.setState({
	        tableWidth: size.width,
	        tableHeight: size.height,
	        tableOptions: newArraySize,
	        parametersCell: _this2.resizeParameters(newArraySize)
	      });
	    };
	
	    _this2.language = new _Singleton.Singleton();
	    _this2.state = (_this2$state = {
	      selectedItem: null,
	      searchRecord: "",
	      moreOptionsShowed: false,
	      tableWidth: parseInt(_this2.props.objProps.sizeWindow.widthWindow, 10),
	      tableHeight: parseInt(_this2.props.objProps.sizeWindow.heightWindow, 10),
	      minTableWidth: parseInt(_this2.props.objProps.sizeWindow.minTableWidth, 10),
	      tableData: [],
	      orderBy: "",
	      orderFormat: true,
	      showInfo: false,
	      showAlertWindowNoInput: false,
	      parametersCell: _this2.props.objProps.paramsCell ? _this2.props.objProps.paramsCell : {
	        Hour: { name: "Hour", size: 140 },
	        Telephone: { name: "Telephone", size: 140 },
	        Duration: { name: "Duration", size: 70 },
	        CallKey: { name: "CallKey", size: 100 },
	        Description: { name: "Description", size: 116 }
	      },
	      tableOptions: _this2.props.objProps.tableOptions ? _this2.props.objProps.tableOptions : [{ key: "Hour", description: _this2.language.getText("GUICallHistoryhour"), showed: true, locked: true, canOrder: true, id: 0, sizeWidth: 140, normalWidth: 140, minSizeWidth: 140, resize: false }, { key: "Telephone", description: _this2.language.getText("GUICallHistoryphone"), showed: true, locked: true, canOrder: false, id: 1, sizeWidth: 140, normalWidth: 140, minSizeWidth: 90, resize: true }, { key: "Duration", description: _this2.language.getText("GUICallHistoryduration"), showed: true, locked: true, canOrder: false, id: 2, sizeWidth: 70, minSizeWidth: 70, normalWidth: 70, resize: false }, { key: "CallKey", description: _this2.language.getText("GUICallHistorycallKey"), showed: true, locked: false, canOrder: true, id: 3, sizeWidth: 100, minSizeWidth: 80, normalWidth: 100, resize: true }, { key: "Description", description: _this2.language.getText("GUICallHistorycampaign"), showed: true, locked: true, canOrder: true, id: 4, sizeWidth: 116, minSizeWidth: 90, normalWidth: 116, resize: true }, { key: "Disposition", description: _this2.language.getText("GUICallHistorydisposition"), showed: false, locked: false, canOrder: false, id: 5, sizeWidth: 140, minSizeWidth: 100, normalWidth: 140, resize: true }]
	    }, _defineProperty(_this2$state, 'selectedItem', null), _defineProperty(_this2$state, 'disabledPlayControl', false), _this2$state);
	    _this2.totalSelected = _this2.props.objProps.totalSelected;
	    _this2.sharedData = new _singletonSharedData.SingletonSharedData();
	    var APIFact = new _cwGalateaApiJsBundle.APIFactory();
	    _this2.apiCont = APIFact.buildClient();
	    _this2.isIE = false;
	    _this2.setting255 = "";
	    _this2.maxHours = "";
	    _this2.topRows = "";
	    _this2.setting255 = _this2.sharedData.getGeneralPermissions()[255];
	    _this2.loading = true;
	
	    return _this2;
	  }
	
	  _createClass(CallRecord, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.isIE = false || !!document.documentMode;
	      this.updateInfo();
	      this.audioPlayerComponent = this.refs["PlayerReproductor"];
	      this.maxHours = this.setting255.toString().slice(0, this.setting255.toString().indexOf('|'));
	      this.topRows = this.setting255.toString().slice(this.setting255.toString().indexOf('|') + 1);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (prevState.selectedItem !== this.state.selectedItem) {
	        this.setState({ disabledPlayControl: this.props.allowPlayRecordsOnCallHistory });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.userState.currentState === _constants.USER_STATE.DIALOG) {
	        this.audioPlayerComponent.pausePlayer();
	      }
	      if (nextProps.messagesIntegrations.dataMessageIntegration && nextProps.messagesIntegrations.dataMessageIntegration.action === _constants.INTEGRATION.OPEN_WINDOW && nextProps.messagesIntegrations.dataMessageIntegration.window === "CallRecord") {
	        this.updateInfo();
	      }
	    }
	  }, {
	    key: 'updateInfo',
	    value: function updateInfo() {
	      var _this = this;
	      var objectResponse = this.apiCont.getObjectResponse();
	      this.apiCont.callHistory(this.sharedData.getParameters().UserID, objectResponse, this.sharedData.requestTimeout);
	      objectResponse.onCatch = function (messageError) {
	        _this.onCloseActions();
	        _this.props.showAlertModal((0, _alertQueryErrorBody.alertQueryErrorBody)());
	      };
	      objectResponse.onError = function (messageError) {
	        _this.loading = false;
	        var type = messageError.Type;
	        var code = messageError.InternalCode;
	        var error = _this.language.getText(type.toLowerCase() + '-' + code);
	        var integrationMessage = { client: "galatea", data: { code: code, message: error }, action: "errorOnCallHistory" };
	        _SingletonWebSocket2.default.send(integrationMessage);
	      };
	      objectResponse.onSuccess = function (objResponse) {
	        _this.loading = false;
	        var array = objResponse.CallHistoryList.map(function (item) {
	          item["imageBackItem"] = item.CallType === "IN" ? _Images.inboundCall : _Images.outBoundCall;
	          item["imageItem"] = _Images.framesCamp[item.GraphicID];
	          return item;
	        });
	        var newArraySize = _this.resizeElements(_this.state.tableWidth - 210);
	        _this.setState({
	          tableOptions: newArraySize,
	          parametersCell: _this.resizeParameters(newArraySize),
	          tableData: array
	        });
	        if (array && array.length > 0 && array[0].AllowPlayRecordsOnCallHistory != null) {
	          _this.props.setAllowPlayRecordsOnCallHistory(array[0].AllowPlayRecordsOnCallHistory);
	        }
	        var sendArray = array.map(function (item) {
	          item.CallId, item.CallKey, item.Description, item.Disposition, item.Duration, item.HidePhone, item.Hour, item.IDCampEsp, item.Telephone, item.selectionActive, item.CamManualMode, item.SelectRotativeAniManualCall;
	          return item;
	        });
	        _SingletonWebSocket2.default.send(_SingletonWebSocket2.default.getJson(_constants.INTEGRATION.CALL_RECORD, '', sendArray));
	      };
	    }
	  }, {
	    key: 'selectOption',
	    value: function selectOption(idSelected) {
	      var arrayOptions = this.state.tableOptions;
	      var arrayParameters = this.state.parametersCell;
	      arrayOptions[idSelected].showed = !arrayOptions[idSelected].showed;
	      this.totalSelected += arrayOptions[idSelected].showed ? 1 : -1;
	      var minWidth = arrayOptions.reduce(function (a, b) {
	        return b.showed ? a + b.minSizeWidth : a;
	      }, 0);
	      minWidth = minWidth < 450 ? 450 : minWidth;
	      var totalWidth = arrayOptions.reduce(function (a, b) {
	        return b.showed ? a + b.normalWidth : a;
	      }, 0);
	      if (arrayOptions[idSelected].showed && totalWidth <= this.state.tableWidth) {
	        totalWidth = this.state.tableWidth;
	      }
	      arrayOptions = this.resizeElements(totalWidth - 210, arrayOptions);
	      if (arrayOptions[idSelected].showed) {
	        arrayParameters[arrayOptions[idSelected].key] = { name: arrayOptions[idSelected].key, size: arrayOptions[idSelected].sizeWidth };
	      } else {
	        delete arrayParameters[arrayOptions[idSelected].key];
	      }
	      this.setState({
	        tableOptions: arrayOptions,
	        tableWidth: totalWidth,
	        minTableWidth: minWidth,
	        parametersCell: this.resizeParameters(arrayOptions, arrayParameters)
	      });
	    }
	  }, {
	    key: 'resizeElements',
	    value: function resizeElements(currentWidth) {
	      var currentTableOption = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state.tableOptions;
	
	      var remindOptions = this.totalSelected - 2;
	      return currentTableOption.map(function (item) {
	        item.sizeWidth = item.resize ? Math.floor((currentWidth - 18) / remindOptions) : item.sizeWidth;return item;
	      });
	    }
	  }, {
	    key: 'resizeParameters',
	    value: function resizeParameters(arrayOptions) {
	      var newArrayParemeters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state.parametersCell;
	
	      var arrayParameters = newArrayParemeters;
	      for (var i in arrayOptions) {
	        var item = arrayOptions[i];
	        if (item.showed) {
	          arrayParameters[item.key] = { name: item.key, size: item.sizeWidth };
	        }
	      }
	      return arrayParameters;
	    }
	  }, {
	    key: 'selectCell',
	    value: function selectCell(itemSelected) {
	      this.setState({ selectedItem: itemSelected });
	      this.audioPlayerComponent.saveMarks();
	      this.audioPlayerComponent.initLoading();
	      var objectResponse = this.apiCont.getObjectResponse();
	      var userID = this.sharedData.getParameters().UserID;
	      var objSend = { "userId": userID, "calId": itemSelected.CallId, "type": itemSelected.CallType };
	      this.audioPlayerComponent.setCallObject(objSend);
	      this.apiCont.callAudio(objSend, objectResponse);
	      var _this = this;
	      objectResponse.onError = function () {
	        _this.audioPlayerComponent.cleanPath();
	        _this.audioPlayerComponent.recordNotFoundError();
	      };
	      objectResponse.onSuccess = function (objResponse) {
	        _this.audioPlayerComponent.loadPath(objResponse.path, objResponse.marks);
	      };
	    }
	  }, {
	    key: 'openManualCall',
	    value: function openManualCall(selected) {
	      var _this3 = this;
	
	      if (selected.CamManualMode === 3) {
	        this.setState({ showAlertWindowNoInput: true });
	        setTimeout(function () {
	          _this3.setState({ showAlertWindowNoInput: false });
	        }, 3000);
	      } else {
	        this.inserManualCallWindow(selected);
	      }
	    }
	  }, {
	    key: 'inserManualCallWindow',
	    value: function inserManualCallWindow(selected) {
	      this.sharedData.phoneNumber = '';
	      var objProps = null;
	      if (selected.CallType === 'IN') {
	        this.sharedData.phoneNumber = selected.Telephone;
	      } else {
	        objProps = {
	          campaingName: selected.Description,
	          campaingID: selected.IDCampEsp,
	          phoneNumber: selected.Telephone,
	          ManualCallAlwaysShow: true,
	          disableManualCall: true,
	          rotativeAniManualCall: selected.SelectRotativeAniManualCall
	        };
	      }
	      this.props.insertWindow((0, _draggableComponents.manualCallWindow)(objProps), false);
	    }
	  }, {
	    key: 'shoWMoreOptions',
	    value: function shoWMoreOptions(evt) {
	      this.setState({ moreOptionsShowed: !this.state.moreOptionsShowed });
	      evt.stopPropagation();
	    }
	  }, {
	    key: 'onCloseActions',
	    value: function onCloseActions() {
	      this.props.removeWindow(_constants.DRAGGABLE_WINDOWS.CALL_RECORD);
	      (0, _RecordCallSingleton.setCurrentSize)({ widthWindow: this.state.tableWidth, heightWindow: this.state.tableHeight, minTableWidth: this.state.minTableWidth });
	      (0, _RecordCallSingleton.setTableOptions)(this.state.tableOptions);
	      (0, _RecordCallSingleton.setParameters)(this.state.parametersCell);
	      (0, _RecordCallSingleton.setTotalSelected)(this.totalSelected);
	    }
	  }, {
	    key: 'orderTable',
	    value: function orderTable(item, Format) {
	      this.setState({
	        orderBy: item.key,
	        orderFormat: Format
	      });
	    }
	  }, {
	    key: 'showInfoDetail',
	    value: function showInfoDetail() {
	      this.setState({ showInfo: !this.state.showInfo });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      return _react2.default.createElement(
	        _reactResizable.ResizableBox,
	        { className: 'boxResize', onResize: this.onResize,
	          width: this.state.tableWidth, height: this.state.tableHeight, minConstraints: [this.state.minTableWidth, 326], maxConstraints: [900, 600] },
	        _react2.default.createElement(
	          'div',
	          { className: 'CallRecord', onClick: function onClick() {
	              return _this4.props.goTopZ(_this4.props.id);
	            } },
	          _customComponents.CUSTOM_COMPONENTS["draggableHeader"](_CallRecordSVG.callHistorySVG, this.language.getText("GUICallHistorytitle"), function () {
	            return _this4.onCloseActions();
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: 'recordCallContainer' },
	            _react2.default.createElement(
	              'div',
	              { className: "topBar " + (this.loading ? "tbloading" : "") },
	              _react2.default.createElement(
	                'p',
	                { className: "infoRecordCall " + (this.loading ? "loading" : "") },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'infoNumberRecordCall' },
	                  ' ',
	                  this.topRows,
	                  ' '
	                ),
	                ' ',
	                this.language.getText("GUICallHistorytotalCalls"),
	                ' ',
	                _react2.default.createElement(
	                  'span',
	                  { className: 'infoNumberRecordCall' },
	                  ' ',
	                  this.maxHours,
	                  ' '
	                ),
	                ' ',
	                this.language.getText("GUICallHistoryhrs"),
	                _react2.default.createElement(
	                  'button',
	                  { className: 'btnP', onClick: function onClick() {
	                      return _this4.showInfoDetail();
	                    } },
	                  _react2.default.createElement('img', { src: _Images.iconInfo, alt: 'Info' })
	                ),
	                ' '
	              ),
	              this.state.showInfo && _react2.default.createElement(
	                'div',
	                { className: 'CallHistoryinfo' },
	                _react2.default.createElement(_AlertWindow2.default, {
	                  title: this.language.getText("GUICallHistoryinfoTitle"),
	                  body: this.language.getText('GUICallHistoryinfoBody'),
	                  isGlobe: true,
	                  isInfo: true })
	              ),
	              this.state.showAlertWindowNoInput && _react2.default.createElement(
	                'div',
	                { className: 'alertContainerDisappear' },
	                _react2.default.createElement(_AlertWindow2.default, {
	                  title: this.language.getText('GUIManualCallmanualCall'),
	                  body: this.language.getText('GUIAlertMessagedialViaVataMsg'),
	                  isGlobe: true })
	              ),
	              _customComponents.CUSTOM_COMPONENTS["inputDelete"](this.state.searchRecord, function (e) {
	                _this4.setState({ searchRecord: e });
	              }, "searchContainer " + (this.loading ? "loading" : ""), "txtSearch", "cleanButton", _GenericSVG.closeSvg, false, _Images.search, "iconSearch", this.language.getText("CallControlCRMxcontrolssearchForMatchesButton"))
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'containerRecordCall' },
	              this.state.tableOptions.map(function (item) {
	                return item.showed && _react2.default.createElement(
	                  'div',
	                  { className: "itemHeaderCallRecord " + (_this4.loading ? "loading" : ""), style: { width: item.sizeWidth }, key: item.key },
	                  item.description,
	                  item.canOrder && _react2.default.createElement(
	                    'div',
	                    { className: 'orderContainer' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'orderContainerBox', onClick: function onClick() {
	                          return _this4.orderTable(item, true);
	                        } },
	                      _react2.default.createElement('div', { className: 'orderUp' })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'orderContainerBox', onClick: function onClick() {
	                          return _this4.orderTable(item, false);
	                        } },
	                      _react2.default.createElement('div', { className: 'orderDown' })
	                    )
	                  )
	                );
	              }),
	              _react2.default.createElement(
	                'div',
	                { className: "tableRecordCall " + (this.loading ? "loading" : "") },
	                _react2.default.createElement(_TableComponent2.default, {
	                  customCell: "cellRecordCall",
	                  parameters: this.state.parametersCell,
	                  dataSource: this.state.tableData,
	                  selectable: true,
	                  selectedStyle: "backgroundGray",
	                  onSelectItem: this.isIE ? undefined : this.selectCell.bind(this),
	                  selectedItem: this.state.selectedItem,
	                  onDoubleClick: function onDoubleClick(itemSelected) {
	                    return _this4.openManualCall(itemSelected);
	                  },
	                  searching: this.state.searchRecord,
	                  orderBy: this.state.orderBy,
	                  orderForm: this.state.orderFormat,
	                  pagination: true })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'btnMoreOptions', onClick: function onClick(e) {
	                    return _this4.shoWMoreOptions(e);
	                  } },
	                _CallSpaceHeaderSVG.moreOptions
	              ),
	              this.state.moreOptionsShowed && _react2.default.createElement(
	                'div',
	                { className: 'moreOptionsBackGround', onClick: function onClick() {
	                    return _this4.setState({ moreOptionsShowed: false });
	                  } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'moreOptions', onClick: function onClick(evt) {
	                      return evt.stopPropagation();
	                    } },
	                  this.state.tableOptions.map(function (item) {
	                    return _react2.default.createElement(
	                      'div',
	                      { className: 'optionTableSelection', key: item.key },
	                      _react2.default.createElement('img', { className: "optionTableSelected " + (item.showed ? "selected " + (item.locked ? "locked" : "") : ""), src: _Images.checked, alt: 'icon', onClick: function onClick() {
	                          return _this4.selectOption(item.id);
	                        } }),
	                      _react2.default.createElement(
	                        'p',
	                        { className: "optionTableTitle " + (item.locked ? "locked" : "") },
	                        item.description
	                      )
	                    );
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(_PlayerReproductor2.default, { ref: "PlayerReproductor", disabled: !this.state.disabledPlayControl })
	          ),
	          _react2.default.createElement('img', { className: 'resizeButton', src: _Images.resizeManual, alt: 'icon' })
	        )
	      );
	    }
	  }]);
	
	  return CallRecord;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    userState: state.userState,
	    messagesIntegrations: state.messagesIntegrations,
	    allowPlayRecordsOnCallHistory: state.agentPermissions.allowPlayRecordsOnCallHistory
	  };
	}
	function mapDispatchToProps(dispatch) {
	  var _showAlertModal = _A_Alert_Modal2.default.creators.showAlertModal;
	
	  return {
	    removeWindow: function removeWindow(iDdragComponent) {
	      dispatch((0, _A_draggable_windows_controller.removeWindow)(iDdragComponent));
	    },
	    insertWindow: function insertWindow(dragWindow, closeComponentIfOpen) {
	      dispatch((0, _A_draggable_windows_controller.insertWindow)(dragWindow, closeComponentIfOpen));
	    },
	    showAlertModal: function showAlertModal(payload) {
	      dispatch(_showAlertModal(payload));
	    },
	    setAllowPlayRecordsOnCallHistory: function setAllowPlayRecordsOnCallHistory(allowPlayRecordsOnCallHistory) {
	      return dispatch((0, _A_agent_permissions.setAllowPlayRecordsOnCallHistory)(allowPlayRecordsOnCallHistory));
	    }
	  };
	}
	exports.default = CallRecord = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CallRecord);

/***/ },
/* 1119 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(25);
	
	var _constants = __webpack_require__(10);
	
	var _Images = __webpack_require__(30);
	
	var _Singleton = __webpack_require__(21);
	
	var _GenericSVG = __webpack_require__(51);
	
	var _NoAvailableSVG = __webpack_require__(114);
	
	var _CallSpaceHeaderSVG = __webpack_require__(67);
	
	var _A_messages_to_SM = __webpack_require__(32);
	
	var _AssistedTransfer = __webpack_require__(1116);
	
	var _AssistedTransfer2 = _interopRequireDefault(_AssistedTransfer);
	
	var _CallingAssistedTransfer = __webpack_require__(505);
	
	var _CallingAssistedTransfer2 = _interopRequireDefault(_CallingAssistedTransfer);
	
	var _customComponents = __webpack_require__(59);
	
	var _TableComponent = __webpack_require__(238);
	
	var _TableComponent2 = _interopRequireDefault(_TableComponent);
	
	var _A_draggable_windows_controller = __webpack_require__(55);
	
	var _cwGalateaApiJsBundle = __webpack_require__(40);
	
	var _singletonSharedData = __webpack_require__(23);
	
	var _AlertManualCallWindow = __webpack_require__(492);
	
	var _AlertManualCallWindow2 = _interopRequireDefault(_AlertManualCallWindow);
	
	var _A_assisted_transfer = __webpack_require__(332);
	
	var _alertQueryErrorBody = __webpack_require__(130);
	
	var _A_Alert_Modal = __webpack_require__(63);
	
	var _A_Alert_Modal2 = _interopRequireDefault(_A_Alert_Modal);
	
	var _A_preview_transfer = __webpack_require__(193);
	
	var _A_transfer = __webpack_require__(512);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CallTransfer = function (_Component) {
	  _inherits(CallTransfer, _Component);
	
	  function CallTransfer(props) {
	    _classCallCheck(this, CallTransfer);
	
	    var _this2 = _possibleConstructorReturn(this, (CallTransfer.__proto__ || Object.getPrototypeOf(CallTransfer)).call(this, props));
	
	    _this2.language = new _Singleton.Singleton();
	    _this2.state = {
	      acdList: [],
	      phoneList: [],
	      agentList: [],
	      isManualCallActive: 0,
	      phoneNumberTransfer: "",
	      searchTransfer: "",
	      selectedTransfer: 2,
	      position: _this2.props.position,
	      transferring: false,
	      agentUnavailable: false,
	      onTransferWindow: false,
	      onlyAgenda: false,
	      recievedAlert: false,
	      alertCode: 0,
	      dataCall: _this2.props.objProps.propsData.dataCall,
	      isInConference: false,
	      transferOption: [{ title: _this2.language.getText("CallControlGUICallTransferagenda"), index: 0 }, { title: _this2.language.getText("CallControlGUICallTransferagents"), index: 1 }, { title: _this2.language.getText("CallControlGUICallTransferACD"), index: 2 }],
	      itemSelected: null,
	      isAgentSelected: false,
	      agentSelected: [],
	      allowsConference: true,
	      messageTransferBlindCall: _this2.language.getText("CallControlGUICallTransferBlindXferProcess"),
	      blindTransferError: false
	    };
	    _this2.data = {
	      acdID: 0,
	      callKey: "",
	      typeTransfer: -1,
	      array: "",
	      camId: 1,
	      sPhone: "",
	      dnis: "",
	      extId: 0,
	      name: "",
	      reference: "dial"
	    };
	    _this2.phoneNumber = _this2.props.objProps.propsData.dataCall.Phone;
	    _this2.initialTransferAssisted = [{ title: _this2.language.getText("CallControlGUIAssistedCallTransfermainCall"), active: false, flag: "main", number: _this2.phoneNumber, callId: "" }, { title: _this2.language.getText("CallControlGUIAssistedCallTransfersecondCall"), active: true, flag: "second", number: "", callId: "" }];
	    var APIFact = new _cwGalateaApiJsBundle.APIFactory();
	    _this2.apiCont = APIFact.buildClient();
	    _this2.sharedData = new _singletonSharedData.SingletonSharedData();
	    _this2.assitedTransPermission = _this2.sharedData.getGeneralPermissions()[76];
	    _this2.blindTransPermission = _this2.sharedData.getGeneralPermissions()[250];
	    _this2.AssitedTransferData = _this2.initialTransferAssisted;
	    return _this2;
	  }
	
	  _createClass(CallTransfer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      var _this = this;
	      var objectResponseTransfer = this.apiCont.getObjectResponse();
	      var timeout = this.sharedData.getRequestTimeout();
	      var userId = this.sharedData.getParameters().UserID;
	      var acdId = this.state.dataCall.CallType === 1 ? this.state.dataCall.Id : 0; //filtro para el caso si es una llamda de entrada no puede transferir al mismo acd
	      if (this.sharedData.getDataPreviewPro().dialingMode === 1) {
	        this.props.messageApiRequest(_constants.API_ENDPOINTS.TRANSFER_CALL_PREVIEW, "", true);
	      } else {
	        this.apiCont.transferCall(userId, acdId, objectResponseTransfer, timeout);
	        objectResponseTransfer.onError = function (messageError) {};
	        objectResponseTransfer.onCatch = function (messageError) {
	          console.warn(messageError);
	          _this.props.showAlertModal((0, _alertQueryErrorBody.alertQueryErrorBody)());
	          _this.cerrarVentana();
	        };
	        objectResponseTransfer.onSuccess = function (objResponse) {
	          _this.setState({
	            acdList: objResponse.AcdList,
	            phoneList: objResponse.TelefonosList,
	            agentList: objResponse.AgentesList,
	            isManualCallActive: objResponse.IsManualCallActive
	          });
	        };
	      }
	      switch (this.props.objProps.propsData.messageIntegration.action) {
	        case _constants.INTEGRATION.ASSISTED_DIAL_NUMBER:
	          this.setState({ selectedTransfer: 0 });
	          setTimeout(function () {
	            _this3.integrationAssistedDialNumber(_this3.props.objProps.propsData.messageIntegration);
	          }, 100);
	          break;
	        case _constants.INTEGRATION.ASSISTED_DIAL_AGENT:
	          this.setState({ selectedTransfer: 1 });
	          setTimeout(function () {
	            _this3.integrationAssistedDialAgent(_this3.props.objProps.propsData.messageIntegration);
	          }, 100);
	          break;
	        case _constants.INTEGRATION.ASSISTED_DIAL_ACD:
	          setTimeout(function () {
	            _this3.integrationAssistedDialACD(_this3.props.objProps.propsData.messageIntegration);
	          }, 100);
	          break;
	        default:
	          break;
	      }
	    }
	  }, {
	    key: 'renderCurrentList',
	    value: function renderCurrentList() {
	      var _this4 = this;
	
	      var listTransfer = [{ list: this.state.phoneList, cellName: "cellPhoneTransfer", parameters: { id: "id", name: "name", phone: "number" } }, { list: this.state.agentList, cellName: "cellAgentTransfer", parameters: { id: "extid", name: "name", login: "login" } }, { list: this.state.acdList, cellName: "cellACDTransfer", parameters: { id: "inbound_id", name: "name" } }];
	
	      var listDatos = listTransfer[this.state.selectedTransfer];
	      var component = _react2.default.createElement(
	        'div',
	        { className: 'transferListScroll' },
	        _react2.default.createElement(_TableComponent2.default, {
	          customCell: listDatos["cellName"],
	          parameters: listDatos["parameters"],
	          dataSource: listDatos["list"],
	          onSelectItem: this.selectItem.bind(this),
	          searching: this.state.searchTransfer,
	          onRef: function onRef(ref) {
	            return _this4.child = ref;
	          },
	          disabled: this.state.phoneNumberTransfer,
	          selectedItem: this.state.itemSelected })
	      );
	      return component;
	    }
	  }, {
	    key: 'integrationAssistedDialNumber',
	    value: function integrationAssistedDialNumber(message) {
	      if (!this.state.onTransferWindow) {
	        this.setState({ phoneNumberTransfer: message.phone });
	        this.assistedTransferCall();
	      }
	    }
	  }, {
	    key: 'integrationAssistedDialACD',
	    value: function integrationAssistedDialACD(message) {
	      if (!this.state.onTransferWindow) {
	        var campToTransfer = this.state.acdList.find(function (camp) {
	          return camp.inbound_id === parseInt(message.id);
	        });
	        this.selectItem(campToTransfer);
	        this.assistedTransferCall();
	      }
	    }
	  }, {
	    key: 'integrationAssistedDialAgent',
	    value: function integrationAssistedDialAgent(message) {
	      if (!this.state.onTransferWindow) {
	        var agentToTransfer = this.state.agentList.find(function (agent) {
	          return agent.extid === parseInt(message.id);
	        });
	        this.selectItem(agentToTransfer);
	        this.assistedTransferCall();
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this5 = this;
	
	      if (nextProps.stateMachineActions.actionType === "NO_AVAILABLE_INFO") {
	        this.setState({ transferring: false });
	        this.props.setTransferInProgress(false);
	        if (this.props.transferReducer.currentBlindTransfer) {
	          setTimeout(function () {
	            _this5.closeAddToast();
	          }, 100);
	        } else {
	          setTimeout(function () {
	            _this5.closeAssitedToast();
	          }, 100);
	        }
	      }
	      if (nextProps.previewActions.previewAction === _constants.PREVIEW_TRANSFER.DATA_CALL_PREVIEW) {
	        this.setState({ phoneList: nextProps.previewActions.phoneList, acdList: nextProps.previewActions.acdList, agentList: nextProps.previewActions.agentList });
	      }
	      if (nextProps.objProps.propsAlert) {
	        this.setState({ recievedAlert: true, alertCode: nextProps.objProps.propsAlert.alertCode });
	      }
	      if (nextProps.messagesIntegrations.dataMessageIntegration && nextProps.messagesIntegrations !== this.props.messagesIntegrations) {
	        switch (nextProps.messagesIntegrations.dataMessageIntegration.action) {
	          case _constants.INTEGRATION.ASSISTED_DIAL_NUMBER:
	            this.setState({ selectedTransfer: 0 });
	            setTimeout(function () {
	              _this5.integrationAssistedDialNumber(nextProps.messagesIntegrations.dataMessageIntegration);
	            }, 100);
	            break;
	          case _constants.INTEGRATION.ASSISTED_DIAL_AGENT:
	            this.setState({ selectedTransfer: 1 });
	            setTimeout(function () {
	              _this5.integrationAssistedDialAgent(nextProps.messagesIntegrations.dataMessageIntegration);
	            }, 100);
	            break;
	          case _constants.INTEGRATION.ASSISTED_DIAL_ACD:
	            this.setState({ selectedTransfer: 2 });
	            setTimeout(function () {
	              _this5.integrationAssistedDialACD(nextProps.messagesIntegrations.dataMessageIntegration);
	            }, 100);
	            break;
	          case _constants.INTEGRATION.ASSISTED_TRANSFER_CALL_HANGUP:
	            this.hangUpTransfer();
	            break;
	          default:
	            break;
	        }
	      }
	      if (this.props.previewActions.acceptedTransfer !== nextProps.previewActions.acceptedTransfer) {
	        if (nextProps.previewActions.acceptedTransfer) {
	          this.data.reference = "dial";
	          var _this = this;
	          setTimeout(function () {
	            _this.props.messageAssistedTransferCall(_constants.ASSISTED_TRANSFER_SUBACTION.PREVIEW, _this5.data);
	          }, 100);
	          setTimeout(function () {
	            _this.props.onAcceptedTransfer(null);
	          }, 100);
	        } else {
	          this.setState({ transferring: false });
	          this.props.onAcceptedTransfer(null);
	        }
	      }
	      switch (nextProps.assistedTransfer.currentState) {
	        case _constants.ASSISTED_TRANSFER.TRANSFERRING:
	          if (this.state.phoneNumberTransfer !== "") {
	            //TRANSFER FOR NUMBER
	            this.data.sPhone = this.state.phoneNumberTransfer;
	            this.data.typeTransfer = 0;
	            this.sharedData.setConferenceNewNumber(this.data.sPhone);
	            this.AssitedTransferData[1].number = this.data.sPhone;
	          } else {
	            switch (this.state.selectedTransfer) {
	              case 0:
	                this.sharedData.setConferenceNewNumber(this.data.sPhone);
	                this.AssitedTransferData[1].number = this.data.sPhone;
	                break;
	              case 1:
	                this.data.sPhone = this.data.extId;
	                this.sharedData.setConferenceNewNumber(this.data.name);
	                this.AssitedTransferData[1].number = this.data.name;
	                break;
	              case 2:
	                this.data.sPhone = this.data.acdID;
	                this.sharedData.setConferenceNewNumber(this.data.name);
	                this.AssitedTransferData[1].number = this.data.name;
	                break;
	              default:
	                break;
	            }
	          }
	          this.setState({ transferring: true, phoneNumberTransfer: "" });
	          var _this6 = this;
	          if (this.sharedData.getDataPreviewPro().dialingMode === 1 && this.state.isAgentSelected) {
	            setTimeout(function () {
	              _this6.props.actionPreviewTransfer(_constants.PREVIEW_TRANSFER_SUBACTION.TRANSFER_REQUEST, _this5.state.agentSelected.login, _this5.props.previewReducer.selectedRecord.callOutId);
	            }, 100);
	          } else {
	            this.data.reference = "dial";
	            setTimeout(function () {
	              _this6.props.messageAssistedTransferCall(_constants.ASSISTED_TRANSFER_SUBACTION.ASSISTED, _this5.data);
	            }, 100);
	          }
	          break;
	        case _constants.ASSISTED_TRANSFER.SECOND_CALL_CONNECTED:
	          this.setState({ onTransferWindow: true, transferring: false });
	          break;
	        case _constants.ASSISTED_TRANSFER.SECOND_CALL_HANG_UP:
	          this.setState({ onTransferWindow: false, transferring: false, isInConference: false });
	          this.AssitedTransferData = this.initialTransferAssisted;
	          this.sharedData.setCallConferencetoZero();
	          break;
	        case _constants.ASSISTED_TRANSFER.ON_CONFERENCE:
	          this.setState({ isInConference: true });
	          break;
	        case _constants.ASSISTED_TRANSFER.ON_CONFERENCE_CALL:
	          this.returnToConference();
	          break;
	        default:
	          break;
	      }
	    }
	  }, {
	    key: 'callNewNumber',
	    value: function callNewNumber() {
	      var _this7 = this;
	
	      this.props.newAssistedTransferState(_constants.ASSISTED_TRANSFER.ON_CONFERENCE_CALL);
	      this.sharedData.setConferenceNewNumber(this.data.sPhone);
	      this.data.reference = "next";
	      this.data.callId = Math.floor(Math.random() * 10000);
	      this.sharedData.setConferenceCallID(this.data.callId);
	      var _this = this;
	      setTimeout(function () {
	        _this.props.messageAssistedTransferCall(_constants.ASSISTED_TRANSFER_SUBACTION.ASSISTED, _this7.data);
	      }, 100);
	    }
	  }, {
	    key: 'closeAlert',
	    value: function closeAlert(e) {
	      this.setState({ recievedAlert: e });
	    }
	  }, {
	    key: 'selectItem',
	    value: function selectItem(item) {
	      this.setDatos(item);
	      this.setState({ itemSelected: item });
	      if (this.state.selectedTransfer === 1) {
	        var agent = this.props.previewActions.agentList.find(function (agent) {
	          return agent.extid == item.extid;
	        });
	        this.setState({ isAgentSelected: true, agentSelected: agent });
	      }
	    }
	  }, {
	    key: 'selectTransfer',
	    value: function selectTransfer(transfer) {
	      this.setState({
	        itemSelected: null,
	        selectedTransfer: transfer,
	        searchTransfer: ""
	      });
	    }
	  }, {
	    key: 'hangUpTransfer',
	    value: function hangUpTransfer() {
	      var _this8 = this;
	
	      if (this.state.transferring) this.setState({ transferring: false });
	      this.data.reference = "hangup";
	      setTimeout(function () {
	        _this8.props.messageAssistedTransferCall(_constants.ASSISTED_TRANSFER_SUBACTION.ASSISTED, _this8.data);
	      }, 50);
	      this.props.setTransferInProgress(false);
	    }
	  }, {
	    key: 'closeAgentUnavailable',
	    value: function closeAgentUnavailable() {
	      this.setState({ agentUnavailable: false });
	    }
	  }, {
	    key: 'openAgenda',
	    value: function openAgenda() {
	      this.setState({
	        onTransferWindow: false,
	        onlyAgenda: true,
	        selectedTransfer: 0
	      });
	    }
	  }, {
	    key: 'returnToConference',
	    value: function returnToConference() {
	      this.setState({
	        onTransferWindow: true,
	        onlyAgenda: false,
	        selectedTransfer: 2
	      });
	    }
	  }, {
	    key: 'setDatos',
	    value: function setDatos(item) {
	      switch (this.state.selectedTransfer) {
	        case 0:
	          this.data.acdID = this.state.dataCall.Id;
	          this.data.typeTransfer = this.state.selectedTransfer;
	          this.data.sPhone = item.number;
	          this.data.callKey = this.state.dataCall.CalKey;
	          this.data.name = item.name.split("|")[1].trim();
	          this.setState({ allowsConference: item.allowsConference });
	          break;
	        case 1:
	          this.data.acdID = this.state.dataCall.Id;
	          this.data.camId = this.state.dataCall.Id;
	          this.data.typeTransfer = this.state.selectedTransfer;
	          this.data.callKey = this.state.dataCall.CalKey;
	          this.data.sPhone = this.state.dataCall.Phone;
	          this.data.dnis = this.state.dataCall.DNIS;
	          this.data.extId = item.extid;
	          this.data.name = item.name.split(" ")[0];
	          this.setState({ allowsConference: true });
	          break;
	        case 2:
	          this.data.acdID = item.inbound_id;
	          this.data.typeTransfer = this.state.selectedTransfer;
	          this.data.callKey = this.state.dataCall.CalKey;
	          this.data.sPhone = this.state.dataCall.Phone;
	          this.data.name = item.name.split(" ")[0];
	          this.setState({ allowsConference: true });
	          break;
	        default:
	          break;
	      }
	      this.setState({ itemSelected: item.key });
	    }
	  }, {
	    key: 'cancelBlindTransfer',
	    value: function cancelBlindTransfer() {
	      this.setState({
	        messageTransferBlindCall: this.language.getText("CallControlGUICallTransferBlindXferError"),
	        blindTransferError: true
	      });
	    }
	  }, {
	    key: 'closeAddToast',
	    value: function closeAddToast(e) {
	      this.setState({
	        messageTransferBlindCall: this.language.getText("CallControlGUICallTransferBlindXferProcess"),
	        blindTransferError: false
	
	      });
	      this.props.resetTransfer();
	    }
	  }, {
	    key: 'closeAssitedToast',
	    value: function closeAssitedToast(e) {
	      this.props.resetAssistedErrorTransfer();
	    }
	  }, {
	    key: 'transferCall',
	    value: function transferCall() {
	
	      this.props.bindTransfer(true);
	
	      if (this.state.phoneNumberTransfer === "") {
	        //TRANSFER FOR SELECTION
	        this.props.messageTransferCall(this.data);
	      } else {
	        //TRANSFER FOR PHONE NUMBER
	        this.data.acdID = this.state.dataCall.Id;
	        this.data.typeTransfer = 0;
	        this.data.callKey = "";
	        this.data.sPhone = this.state.phoneNumberTransfer;
	        this.props.messageTransferCall(this.data);
	      }
	    }
	  }, {
	    key: 'assistedTransferCall',
	    value: function assistedTransferCall() {
	      var _this9 = this;
	
	      setTimeout(function () {
	        _this9.props.newAssistedTransferState(_constants.ASSISTED_TRANSFER.TRANSFERRING);
	      }, 50);
	      if (this.props.previewReducer.simultaneosRecs) {
	        this.props.setTransferInProgress(true);
	      }
	    }
	  }, {
	    key: 'cerrarVentana',
	    value: function cerrarVentana() {
	      this.props.removeWindow(_constants.DRAGGABLE_WINDOWS.TRANSFER_CALL);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.resetTransfer();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this10 = this;
	
	      var transferOption = this.state.transferOption;
	      if (this.state.onlyAgenda) {
	        transferOption = transferOption.filter(function (item) {
	          return item.index === 0;
	        });
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'transferContainer', onClick: function onClick() {
	            return _this10.props.goTopZ(_this10.props.id);
	          } },
	        _customComponents.CUSTOM_COMPONENTS["draggableHeader"](_CallSpaceHeaderSVG.assistedTransfer, this.language.getText("CallControlGUICallTransfertitle"), !(this.state.isInConference || this.state.onTransferWindow || this.state.transferring) && this.cerrarVentana.bind(this)),
	        this.state.onTransferWindow ? _react2.default.createElement(_AssistedTransfer2.default, {
	          data: this.AssitedTransferData,
	          onOpenAgenda: function onOpenAgenda() {
	            return _this10.openAgenda();
	          },
	          isInConference: this.state.isInConference,
	          allowsConference: this.state.allowsConference,
	          previewTransfer: this.state.agentSelected }) : _react2.default.createElement(
	          'div',
	          { className: 'transferOptionsContainer' },
	          _react2.default.createElement(
	            'div',
	            { className: 'blurContainer' },
	            _react2.default.createElement(
	              'div',
	              { className: "transferSelectionContainer " + (this.state.transferring || this.state.recievedAlert ? "active" : "") },
	              _react2.default.createElement(
	                'div',
	                { className: 'transferSelection' },
	                transferOption.map(function (item, i) {
	                  return _react2.default.createElement(
	                    'div',
	                    { className: "transferOptions", key: "item" + i, onClick: function onClick() {
	                        return _this10.selectTransfer(item.index);
	                      } },
	                    _react2.default.createElement('div', { className: "backOption " + (_this10.state.selectedTransfer === item.index ? "selectedOption" : "nonSeletedOption") }),
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'transferTitle' },
	                      item.title
	                    )
	                  );
	                }),
	                _react2.default.createElement(
	                  'div',
	                  { className: "backArrowAgenda " + (this.state.onlyAgenda ? "" : "hidden"), onClick: function onClick() {
	                      return _this10.returnToConference();
	                    } },
	                  ' ',
	                  _GenericSVG.arrowBack,
	                  ' '
	                ),
	                _react2.default.createElement('div', { className: "selectionFooter selected_" + this.state.selectedTransfer })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: "transferList " + (this.state.onlyAgenda && " onlyAgenda") },
	                _customComponents.CUSTOM_COMPONENTS["inputDelete"](this.state.searchTransfer, function (e) {
	                  _this10.setState({ searchTransfer: e });
	                }, "searchBarTransfer", "txtSearch", "buttonclearGray", _GenericSVG.btnClear, false, _Images.search, "iconSearch", this.language.getText("CallControlCRMxcontrolssearchForMatchesButton")),
	                this.renderCurrentList()
	              ),
	              this.state.onlyAgenda ? _react2.default.createElement(
	                'div',
	                { className: 'transferFooterOnlyAgenda', onClick: function onClick() {
	                    return _this10.callNewNumber();
	                  } },
	                _react2.default.createElement('img', { className: 'optionTransfer greenColor', src: _Images.phoneIconChange, alt: 'icon' })
	              ) : _react2.default.createElement(
	                'div',
	                { className: 'transferFooter' },
	                _customComponents.CUSTOM_COMPONENTS["inputDelete"](this.state.phoneNumberTransfer, function (e) {
	                  _this10.setState({ phoneNumberTransfer: e, allowsConference: true });
	                }, "phoneNumberTransfer" + (this.state.phoneNumberTransfer && " campActive"), "txtPhoneNumber", "buttonClearWhite", _GenericSVG.btnClear, true, _Images.phoneIcon, "iconPhoneNumber" + (this.state.phoneNumberTransfer && " campActive"), this.language.getText("CallControlGUIAssistedCallTransferenterNumber"), !this.state.isManualCallActive),
	                this.sharedData.getDataPreviewPro().dialingMode !== 1 && _react2.default.createElement(
	                  'div',
	                  { className: "transferButton " + (this.blindTransPermission === "1" ? !this.state.phoneNumberTransfer && !this.state.itemSelected ? "disabled" : "" : "disabled") + " " + ((this.state.phoneNumberTransfer || this.state.selectedTransfer === 0) && "small"),
	                    onClick: function onClick() {
	                      return _this10.transferCall();
	                    } },
	                  this.language.getText("CallControlGUIAssistedCallTransferblindtransfer")
	                ),
	                _react2.default.createElement(
	                  'div',
	                  {
	                    className: "transferButton2 " + (this.assitedTransPermission === "1" ? this.state.phoneNumberTransfer ? "" : !this.state.itemSelected ? "disabled" : this.state.selectedTransfer === 2 && this.state.itemSelected.inbound_id < 0 ? "disabled" : "" : "disabled"),
	                    onClick: function onClick() {
	                      return _this10.assistedTransferCall();
	                    } },
	                  this.language.getText("CallControlGUIAssistedCallTransfertitle")
	                )
	              )
	            ),
	            this.state.recievedAlert && _react2.default.createElement(_AlertManualCallWindow2.default, {
	              phoneNumber: this.phoneNumber,
	              alertCode: this.state.alertCode,
	              closeAlert: function closeAlert(e) {
	                return _this10.closeAlert(e);
	              }
	            }),
	            this.props.transferReducer.currentAssistedTransfer && _react2.default.createElement(_AlertManualCallWindow2.default, {
	              className: 'alertBlindTransfer alertBlindTransferError',
	              icon: true,
	              buttonClose: true,
	              message: this.language.getText("CallControlGUICallTransferno-answer-error"),
	              alertCode: 'CUSTOM',
	              closeAlert: function closeAlert(e) {
	                _this10.closeAssitedToast(e);
	              }
	            }),
	            this.props.transferReducer.currentBlindTransfer && _react2.default.createElement(_AlertManualCallWindow2.default, {
	              className: 'alertBlindTransfer ' + (this.state.blindTransferError && 'alertBlindTransferError'),
	              icon: this.state.blindTransferError,
	              buttonClose: this.state.blindTransferError,
	              message: this.state.messageTransferBlindCall,
	              alertCode: 'CUSTOM',
	              closeAlert: function closeAlert(e) {
	                _this10.closeAddToast(e);
	              }
	            })
	          ),
	          this.state.transferring && _react2.default.createElement(_CallingAssistedTransfer2.default, {
	            phoneNumberTransfer: this.sharedData.getConferenceNewNumber(),
	            hangUpTransfer: function hangUpTransfer() {
	              return _this10.hangUpTransfer();
	            }
	          }),
	          this.state.agentUnavailable && _react2.default.createElement(
	            'div',
	            { className: 'agentUnavailableWindowContainer' },
	            _react2.default.createElement(
	              'div',
	              { className: 'agentUnavailableWindow' },
	              _react2.default.createElement(
	                'p',
	                { className: 'agentUnavailableName' },
	                this.data.name
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'agentUnavailableInfoContainer' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'iconAgentUnavailable' },
	                  _NoAvailableSVG.noAvailableIcon
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { className: 'agentUnavailableText' },
	                  this.language.getText("GUIDisableModetitle")
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'closeAgentUnavailable', onClick: function onClick() {
	                    return _this10.closeAgentUnavailable();
	                  } },
	                this.language.getText("CallControlGUIAssistedCallTransferaccept")
	              )
	            ),
	            _react2.default.createElement('div', { className: 'transferringWindowBottom' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return CallTransfer;
	}(_react.Component);
	
	;
	
	function mapStateToProps(state) {
	  return {
	    stateMachineActions: state.stateMachineActions,
	    assistedTransfer: state.assistedTransfer,
	    messagesIntegrations: state.messagesIntegrations,
	    previewActions: state.previewActions,
	    transferReducer: state.transferReducer,
	    previewReducer: state.preview
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  var _showAlertModal = _A_Alert_Modal2.default.creators.showAlertModal;
	
	  return {
	    removeWindow: function removeWindow(iDdragComponent) {
	      dispatch((0, _A_draggable_windows_controller.removeWindow)(iDdragComponent));
	    },
	    messageTransferCall: function messageTransferCall(data) {
	      dispatch((0, _A_messages_to_SM.messageTransferCall)(data));
	    },
	    messageAssistedTransferCall: function messageAssistedTransferCall(action, data) {
	      dispatch((0, _A_messages_to_SM.messageAssistedTransferCall)(action, data));
	    },
	    newAssistedTransferState: function newAssistedTransferState(message) {
	      dispatch((0, _A_assisted_transfer.newAssistedTransferState)(message));
	    },
	    messageApiRequest: function messageApiRequest(subaction, json, expectsReponse) {
	      dispatch((0, _A_messages_to_SM.messageApiRequest)(subaction, json, expectsReponse));
	    },
	    actionPreviewTransfer: function actionPreviewTransfer(subaction, agentLogin, callOutId) {
	      dispatch((0, _A_messages_to_SM.actionPreviewTransfer)(subaction, agentLogin, callOutId));
	    },
	    onAcceptedTransfer: function onAcceptedTransfer(value) {
	      dispatch((0, _A_preview_transfer.onAcceptedTransfer)(value));
	    },
	    showAlertModal: function showAlertModal(payload) {
	      dispatch(_showAlertModal(payload));
	    },
	    bindTransfer: function bindTransfer(payload) {
	      dispatch((0, _A_transfer.bindTransfer)(payload));
	    },
	    resetTransfer: function resetTransfer(payload) {
	      dispatch((0, _A_transfer.resetTransfer)(payload));
	    },
	    resetAssistedErrorTransfer: function resetAssistedErrorTransfer() {
	      dispatch((0, _A_transfer.resetAssistedErrorTransfer)());
	    },
	    setTransferInProgress: function setTransferInProgress(flag) {
	      dispatch((0, _A_preview_transfer.setTransferInProgress)(flag));
	    }
	  };
	}
	
	exports.default = CallTransfer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CallTransfer);

/***/ },
/* 1120 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(73);
	
	var _Images = __webpack_require__(30);
	
	var _reactDraggable = __webpack_require__(298);
	
	var _reactDraggable2 = _interopRequireDefault(_reactDraggable);
	
	var _reactRedux = __webpack_require__(25);
	
	var _Singleton = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Consulting = function (_Component) {
	  _inherits(Consulting, _Component);
	
	  function Consulting(props) {
	    _classCallCheck(this, Consulting);
	
	    var _this = _possibleConstructorReturn(this, (Consulting.__proto__ || Object.getPrototypeOf(Consulting)).call(this, props));
	
	    _this.language = new _Singleton.Singleton();
	    return _this;
	  }
	
	  _createClass(Consulting, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'noAvailableLocked' },
	        _react2.default.createElement(
	          _reactDraggable2.default,
	          { bounds: 'parent' },
	          _react2.default.createElement(
	            'div',
	            { className: 'windowConsulting' },
	            _react2.default.createElement(
	              'p',
	              { className: 'consultingTitle' },
	              this.language.getText('CallControlIVRInputidleMsglabel')
	            ),
	            _react2.default.createElement(_reactBootstrap.Image, { className: 'consultingImage', src: _Images.loadingConsulting })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Consulting;
	}(_react.Component);
	
	exports.default = Consulting = (0, _reactRedux.connect)(null, null)(Consulting);

/***/ },
/* 1121 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(25);
	
	var _singletonSharedData = __webpack_require__(23);
	
	var _Singleton = __webpack_require__(21);
	
	var _constants = __webpack_require__(10);
	
	var _Images = __webpack_require__(30);
	
	var _GenericSVG = __webpack_require__(51);
	
	var _CallSpaceHeaderSVG = __webpack_require__(67);
	
	var _Validations = __webpack_require__(131);
	
	var _A_draggable_windows_controller = __webpack_require__(55);
	
	var _customComponents = __webpack_require__(59);
	
	var _Keyboard = __webpack_require__(503);
	
	var _Keyboard2 = _interopRequireDefault(_Keyboard);
	
	var _A_reducer_call_acd = __webpack_require__(156);
	
	var _DTMF_Click = __webpack_require__(2603);
	
	var _DTMF_Click2 = _interopRequireDefault(_DTMF_Click);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DTMFWindow = function (_Component) {
	  _inherits(DTMFWindow, _Component);
	
	  function DTMFWindow(props) {
	    _classCallCheck(this, DTMFWindow);
	
	    var _this2 = _possibleConstructorReturn(this, (DTMFWindow.__proto__ || Object.getPrototypeOf(DTMFWindow)).call(this, props));
	
	    _this2.sharedData = new _singletonSharedData.SingletonSharedData();
	    _this2.language = new _Singleton.Singleton();
	    _this2.audio = null;
	    _this2.state = {
	      toneNumber: "",
	      tonesSend: ""
	    };
	    return _this2;
	  }
	
	  _createClass(DTMFWindow, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.messagesIntegrations) {
	        if (nextProps.messagesIntegrations.dataMessageIntegration && nextProps.messagesIntegrations.dataMessageIntegration.action === _constants.INTEGRATION.CALL_ACTION && nextProps.messagesIntegrations.dataMessageIntegration.callAction === _constants.INTEGRATION.DTMF) {
	          var _this = this;
	          _this.pressDTMFTone(nextProps.messagesIntegrations.dataMessageIntegration.digit);
	          _this.setState({ toneNumber: this.state.toneNumber + nextProps.messagesIntegrations.dataMessageIntegration.digit });
	        }
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.objProps.digit) {
	        this.pressDTMFTone(this.props.objProps.digit);
	        this.setState({ toneNumber: this.state.toneNumber + this.props.objProps.digit });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (this.state.toneNumber !== prevState.toneNumber) {
	        if (this.state.toneNumber !== "") {
	          var number = this.state.toneNumber[this.state.toneNumber.length - 1];
	          this.pressDTMFTone(number);
	        }
	      }
	    }
	  }, {
	    key: 'pressDTMFTone',
	    value: function pressDTMFTone(tone) {
	      this.audio = new Audio(_DTMF_Click2.default);
	      this.audio.play();
	      this.props.callAction(_constants.ACTION_CALL_ACD.DTMF, tone);
	    }
	  }, {
	    key: 'sendDTMF',
	    value: function sendDTMF(tone) {
	      this.props.callAction(_constants.ACTION_CALL_ACD.DTMF, tone);
	    }
	  }, {
	    key: 'closeWindow',
	    value: function closeWindow() {
	      this.props.oncloseDtmfTonesWindow && this.props.oncloseDtmfTonesWindow();
	      this.props.removeWindow(_constants.DRAGGABLE_WINDOWS.DTMF_TONES);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var dtmfOptions = this.props.objProps.dtmfOptions;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'DTMFWindow', onClick: function onClick() {
	            return _this3.props.goTopZ(_this3.props.id);
	          } },
	        _customComponents.CUSTOM_COMPONENTS["draggableHeader"](_CallSpaceHeaderSVG.dtmfSVG, this.language.getText("CallControlGUIDTMFtitle"), function () {
	          return _this3.closeWindow();
	        }),
	        _react2.default.createElement(_Keyboard2.default, {
	          number: this.state.toneNumber,
	          onChangeNumber: function onChangeNumber(tone) {
	            return _this3.setState({ toneNumber: tone });
	          } //{(tone)=>this.pressDTMFTone(tone)}
	          , onClean: function onClean() {
	            return _this3.setState({ toneNumber: "" });
	          } }),
	        dtmfOptions.length > 0 && _react2.default.createElement(
	          'div',
	          { className: 'extraInfoDTMF' },
	          _react2.default.createElement(
	            'div',
	            { className: 'buttonsDTMF' },
	            dtmfOptions.map(function (item) {
	              return _react2.default.createElement(
	                'p',
	                { className: 'buttonDTMF', key: item.DTMF, onClick: function onClick() {
	                    return _this3.sendDTMF(item.DTMF);
	                  } },
	                item.Tag
	              );
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'sendContainer' },
	            _react2.default.createElement('img', { className: 'leftDTMF', src: _Images.digits, alt: 'icon' }),
	            _react2.default.createElement('div', { className: 'divSeparator' }),
	            _react2.default.createElement('input', { type: 'text',
	              placeholder: this.language.getText("CallControlGUIDTMFdigitsLbl") //
	              , maxLength: '20',
	              className: 'sendDTMF',
	              value: this.state.tonesSend,
	              onChange: function onChange(event) {
	                _this3.setState({ tonesSend: event.target.value });
	              },
	              onKeyPress: _Validations.validateOnlyNumbers }),
	            _react2.default.createElement(
	              'div',
	              { className: 'sendButton', onClick: function onClick() {
	                  return _this3.sendDTMF(_this3.state.tonesSend);
	                } },
	              _GenericSVG.send
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return DTMFWindow;
	}(_react.Component);
	
	;
	function mapStateToProps(state) {
	  return {
	    messagesIntegrations: state.messagesIntegrations
	  };
	}
	function mapDispatchToProps(dispatch) {
	  return {
	    removeWindow: function removeWindow(iDdragComponent) {
	      dispatch((0, _A_draggable_windows_controller.removeWindow)(iDdragComponent));
	    },
	    callAction: function callAction(actionType, parameters) {
	      dispatch((0, _A_reducer_call_acd.callAction)(actionType, parameters));
	    }
	  };
	}
	exports.default = DTMFWindow = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DTMFWindow);

/***/ },
/* 1122 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(25);
	
	var _Singleton = __webpack_require__(21);
	
	var _IntegrationConnectButton = __webpack_require__(1098);
	
	var _IntegrationConnectButton2 = _interopRequireDefault(_IntegrationConnectButton);
	
	var _IntegrationConnectWindow = __webpack_require__(1099);
	
	var _IntegrationConnectWindow2 = _interopRequireDefault(_IntegrationConnectWindow);
	
	var _IntegrationInfoLog = __webpack_require__(1100);
	
	var _IntegrationInfoLog2 = _interopRequireDefault(_IntegrationInfoLog);
	
	var _FooterSVG = __webpack_require__(489);
	
	var _constants = __webpack_require__(10);
	
	var _singletonSharedData = __webpack_require__(23);
	
	var _SingletonWebSocket = __webpack_require__(50);
	
	var _SingletonWebSocket2 = _interopRequireDefault(_SingletonWebSocket);
	
	var _A_actions_Integration = __webpack_require__(329);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Integration = function (_Component) {
	  _inherits(Integration, _Component);
	
	  function Integration(props) {
	    var _this$stateActions;
	
	    _classCallCheck(this, Integration);
	
	    var _this = _possibleConstructorReturn(this, (Integration.__proto__ || Object.getPrototypeOf(Integration)).call(this, props));
	
	    _this.language = new _Singleton.Singleton();
	    _this.sharedData = new _singletonSharedData.SingletonSharedData();
	    _SingletonWebSocket2.default.SetOnMessage(_this);
	    _this.state = {
	      stateConnection: _this.sharedData.getIntegrationConnectionStatus(),
	      showingLog: false,
	      integrationLog: _this.sharedData.getIntegrationLog()
	    };
	    _this.stateActions = (_this$stateActions = {}, _defineProperty(_this$stateActions, _constants.STATES_INTEGRATION.connected, function () {
	      return _this.disconnect();
	    }), _defineProperty(_this$stateActions, _constants.STATES_INTEGRATION.connecting, function () {
	      return _this.cancelConnect();
	    }), _defineProperty(_this$stateActions, _constants.STATES_INTEGRATION.disconnecting, function () {
	      return _this.connect();
	    }), _defineProperty(_this$stateActions, _constants.STATES_INTEGRATION.notFound, function () {
	      return _this.retryConnect();
	    }), _this$stateActions);
	    _this.isFirstConnect = true;
	    _this.recconectionTimeout = 4000;
	    _this.reconnectionTriggered = false;
	    return _this;
	  }
	
	  _createClass(Integration, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      if (this.props.integrationAutorun && this.state.stateConnection !== _constants.STATES_INTEGRATION.connected && this.isFirstConnect) {
	        this.isFirstConnect = false;
	        setTimeout(function () {
	          _this2.connect();
	        }, 2000);
	      }
	      this.setState({ integrationLog: this.sharedData.getIntegrationLog() });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(props) {
	      var _this3 = this;
	
	      if (props.integrationAutorun && this.state.stateConnection !== _constants.STATES_INTEGRATION.connected && this.isFirstConnect) {
	        this.isFirstConnect = false;
	        setTimeout(function () {
	          _this3.connect();
	        }, 2000);
	      }
	    }
	  }, {
	    key: 'disconnect',
	    value: function disconnect() {
	      _SingletonWebSocket2.default.close();
	      this.changeState(_constants.STATES_INTEGRATION.disconnecting);
	    }
	  }, {
	    key: 'cancelConnect',
	    value: function cancelConnect() {
	      this.addIntegrationLog("Status " + _constants.STATES_INTEGRATION.disconnecting);
	      _SingletonWebSocket2.default.close();
	    }
	  }, {
	    key: 'onIntegrationMessage',
	    value: function onIntegrationMessage(message) {
	      this.addIntegrationLog("Message Received", message);
	      if (message.action === "firstConnection" && message.client === "integration") {
	        var agentData = null;
	        if (this.sharedData.getCurrentState() !== 'Logout' && this.sharedData.user) {
	          agentData = {
	            userName: this.sharedData.user.Login,
	            userId: this.sharedData.user.User_id,
	            userExt: this.sharedData.parameters.Extension
	          };
	        }
	        var _message = { currentState: this.sharedData.getCurrentState(), agentData: agentData };
	        var integrationMessage = { client: "galatea", data: _message, action: "agentStatusChange" };
	        if (_message.currentState === "Dialog") {
	          var assistedMessage = this.sharedData.getAssistedTransferCurrentState();
	          integrationMessage.data.subaction = assistedMessage.subaction;
	        }
	        _SingletonWebSocket2.default.send(integrationMessage);
	        this.sharedData.setAssistedTransferCurrentState("");
	      } else {
	        this.props.messageIntegration(message);
	      }
	    }
	  }, {
	    key: 'onOpenIntegration',
	    value: function onOpenIntegration() {
	      var message = { currentState: this.sharedData.getCurrentState() };
	      var integrationMessage = { client: "galatea", data: message, action: "agentStatusChange" };
	      _SingletonWebSocket2.default.send(integrationMessage);
	      this.changeState(_constants.STATES_INTEGRATION.connected);
	    }
	  }, {
	    key: 'onCloseIntegration',
	    value: function onCloseIntegration() {
	      if (this.state.stateConnection !== _constants.STATES_INTEGRATION.notFound) {
	        this.changeState(_constants.STATES_INTEGRATION.disconnecting);
	      }
	    }
	  }, {
	    key: 'onError',
	    value: function onError(err) {
	      this.changeState(_constants.STATES_INTEGRATION.notFound);
	      this.addIntegrationLog("Error " + err);
	      if (this.sharedData.isLogged) {
	        this.setTimmedReconnection();
	      }
	    }
	  }, {
	    key: 'changeState',
	    value: function changeState(newState) {
	      this.addIntegrationLog("Status " + newState);
	      this.setState({ stateConnection: newState });
	      if (newState === _constants.STATES_INTEGRATION.notFound) {
	        this.setTimmedReconnection();
	      }
	      this.sharedData.setIntegrationConnectionStatus(newState);
	    }
	  }, {
	    key: 'connect',
	    value: function connect() {
	      this.changeState(_constants.STATES_INTEGRATION.connecting);
	      _SingletonWebSocket2.default.SetOnMessage(this);
	      _SingletonWebSocket2.default.setwsServer(this.sharedData.getIntegrationServer());
	      _SingletonWebSocket2.default.setPort(this.sharedData.getIntegrationPort());
	      _SingletonWebSocket2.default.connect(this.sharedData.getSecureConnection());
	    }
	  }, {
	    key: 'setTimmedReconnection',
	    value: function setTimmedReconnection() {
	      var _this4 = this;
	
	      if (!this.reconnectionTriggered) {
	        this.reconnectionTriggered = true;
	        setTimeout(function () {
	          _this4.connect();
	          _this4.reconnectionTriggered = false;
	          console.log("[Integration][changeState] Reconnecting");
	        }, this.recconectionTimeout);
	        console.log("[Integration][onError] Reconection Triggered ", this.recconectionTimeout);
	      }
	    }
	  }, {
	    key: 'retryConnect',
	    value: function retryConnect() {
	      this.connect();
	    }
	  }, {
	    key: 'connectAction',
	    value: function connectAction() {
	      this.stateActions[this.state.stateConnection]();
	    }
	  }, {
	    key: 'getCurrentTime',
	    value: function getCurrentTime() {
	      var date = new Date();
	      var seconds = date.getSeconds();
	      var minutes = date.getMinutes();
	      var hour = date.getHours();
	      return hour + ":" + minutes + ":" + seconds;
	    }
	  }, {
	    key: 'addIntegrationLog',
	    value: function addIntegrationLog(message) {
	      var json = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      var log = this.sharedData.getIntegrationLog();
	      var time = this.getCurrentTime();
	      log.push(time + " " + message);
	      if (json) {
	        log.push("Action: " + json.action);
	        var subaction = json.window ? json.window : json.subaction ? json.subaction : "";
	        log.push("Subaction: " + subaction);
	      }
	      this.sharedData.setIntegrationLog(log);
	      this.setState({ integrationLog: log });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'integrationContainer' },
	        _react2.default.createElement(
	          'div',
	          { className: 'integrationHeader' },
	          _react2.default.createElement(
	            'div',
	            { className: 'iconHeaderIntegration' },
	            _FooterSVG.integrationIcon
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'titleHeaderIntegration' },
	            this.props.titleIntegration
	          ),
	          _react2.default.createElement('div', { className: 'minimizeIntegration', onClick: function onClick() {
	              return _this5.props.closeSocketBoxIntegration();
	            } })
	        ),
	        !this.state.showingLog ? _react2.default.createElement(
	          'div',
	          { className: 'integrationBody' },
	          _react2.default.createElement(_IntegrationConnectWindow2.default, { stateIntegration: this.state.stateConnection }),
	          _react2.default.createElement(_IntegrationConnectButton2.default, {
	            stateIntegration: this.state.stateConnection,
	            connectingAction: function connectingAction() {
	              return _this5.connectAction();
	            },
	            sendToLog: function sendToLog() {
	              return _this5.setState({ showingLog: true });
	            }
	          })
	        ) : _react2.default.createElement(_IntegrationInfoLog2.default, {
	          backToIntegration: function backToIntegration() {
	            return _this5.setState({ showingLog: false });
	          },
	          integrationLog: this.state.integrationLog
	        })
	      );
	    }
	  }]);
	
	  return Integration;
	}(_react.Component);
	
	function mapDispatchToProps(dispatch) {
	  return {
	    messageIntegration: function messageIntegration(dataIntegration) {
	      dispatch((0, _A_actions_Integration.messageIntegration)(dataIntegration));
	    }
	  };
	}
	
	exports.default = Integration = (0, _reactRedux.connect)(null, mapDispatchToProps)(Integration);

/***/ },
/* 1123 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(111);
	
	var _reactRedux = __webpack_require__(25);
	
	var _singletonSharedData = __webpack_require__(23);
	
	var _Singleton = __webpack_require__(21);
	
	var _constants = __webpack_require__(10);
	
	var _A_messages_to_SM = __webpack_require__(32);
	
	var _Images = __webpack_require__(30);
	
	var _GenericSVG = __webpack_require__(51);
	
	var _ManualCallSVG = __webpack_require__(236);
	
	var _whatsappIcono = __webpack_require__(1876);
	
	var _whatsappIcono2 = _interopRequireDefault(_whatsappIcono);
	
	var _sendMessage = __webpack_require__(1875);
	
	var _sendMessage2 = _interopRequireDefault(_sendMessage);
	
	var _A_draggable_windows_controller = __webpack_require__(55);
	
	var _alertBodies = __webpack_require__(240);
	
	var _AlertWindow = __webpack_require__(324);
	
	var _AlertWindow2 = _interopRequireDefault(_AlertWindow);
	
	var _cwGalateaApiJsBundle = __webpack_require__(40);
	
	var _Keyboard = __webpack_require__(503);
	
	var _Keyboard2 = _interopRequireDefault(_Keyboard);
	
	var _customComponents = __webpack_require__(59);
	
	var _TableComponent = __webpack_require__(238);
	
	var _TableComponent2 = _interopRequireDefault(_TableComponent);
	
	var _SelectComponent = __webpack_require__(155);
	
	var _SelectComponent2 = _interopRequireDefault(_SelectComponent);
	
	var _CallOutContainer = __webpack_require__(494);
	
	var _CallOutContainer2 = _interopRequireDefault(_CallOutContainer);
	
	var _A_reducer_consulting = __webpack_require__(115);
	
	var _AlertManualCallWindow = __webpack_require__(492);
	
	var _AlertManualCallWindow2 = _interopRequireDefault(_AlertManualCallWindow);
	
	var _A_actions_Integration = __webpack_require__(329);
	
	var _SingletonWebSocket = __webpack_require__(50);
	
	var _SingletonWebSocket2 = _interopRequireDefault(_SingletonWebSocket);
	
	var _Logger = __webpack_require__(37);
	
	var _A_Alert_Modal = __webpack_require__(63);
	
	var _A_Alert_Modal2 = _interopRequireDefault(_A_Alert_Modal);
	
	var _alertQueryErrorBody = __webpack_require__(130);
	
	var _lodash = __webpack_require__(293);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _lib = __webpack_require__(457);
	
	var _lib2 = _interopRequireDefault(_lib);
	
	var _A_manual_message = __webpack_require__(333);
	
	var _AlertManualMessageWindow = __webpack_require__(1063);
	
	var _AlertManualMessageWindow2 = _interopRequireDefault(_AlertManualMessageWindow);
	
	var _cwUnifiedInbox = __webpack_require__(595);
	
	var _SingleTable = __webpack_require__(1103);
	
	var _draggableComponents = __webpack_require__(101);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MAX_LENGTH_MESSAGE = 4096;
	
	var MANUAL_INPUTS = {
		PHONE_NUMBER: 'PHONE_NUMBER',
		MESSAGE_AREA: 'MESSAGE_AREA'
	};
	
	var ManualCall = function (_Component) {
		_inherits(ManualCall, _Component);
	
		function ManualCall(props) {
			var _this2$validationsNum, _this2$alertCatalog, _this2$erorCatalog;
	
			_classCallCheck(this, ManualCall);
	
			var _this2 = _possibleConstructorReturn(this, (ManualCall.__proto__ || Object.getPrototypeOf(ManualCall)).call(this, props));
	
			_this2.cleanPhoneNumber = function () {
				var newPhone = _this2.state.phoneNumber.replace(/\D/g, '');
				_this2.setState({ phoneNumber: newPhone });
			};
	
			_this2.handleKeyUp = function (event) {
				if (event.key === 'Enter') {
					if (!event.shiftKey && _this2.state.campaingSelected && _this2.state.messageToSend.replace(/\n+$/, "").trim().length > 0) {
						_this2.validateWhatsAppPhoneNumber();
					}
				}
			};
	
			_this2.validateData = function (inputType) {
				if (_this2.state.isManualMessage) {
					switch (inputType) {
						case MANUAL_INPUTS.PHONE_NUMBER:
							return _this2.state.phoneNumber === '' || _this2.state.phoneNumber.length < 12;
						case MANUAL_INPUTS.MESSAGE_AREA:
							return !_this2.state.campaingSelected || _this2.state.messageToSend.replace(/\n+$/, "").trim().length < 1;
					}
				} else {
					return !_this2.state.campaingSelected || _this2.state.phoneNumber === '';
				}
			};
	
			_this2.validateDataPhone = function () {
				var disabled = _this2.state.phoneNumber === '' || _this2.state.phoneNumber.length < 12;
				if (disabled) {
					_this2.setState({
						phoneNumberNoValid: true, writeMessage: false
					});
					setTimeout(function () {
						_this2.setState({ phoneNumberNoValid: false });
					}, 5000);
				} else {
					_this2.setState({
						showPhoneNumber: true,
						writeMessage: true,
						step: 1
					});
				}
			};
	
			_this2.setTemplateWhatsApp = function (template) {
				_this2.setState({ templateWhatsapp: template, step: 2 });
			};
	
			_this2.conversationWAInavailable = function (userId, username, camDescription, date, time) {
				var message = _this2.availableWAConnections[_this2.objectData.UserID !== userId ? 0 : 1];
				var formatDate = ['[dd/mm/aa]', '[mm/dd/yyyy]', '[dd/mm/aaaa]'];
				if (_this2.objectData.UserID !== userId) {
					message = message.replace('[N]', username);
					message = message.replace('[N]', camDescription);
					message = message.replace(formatDate[_this2.lang], date);
					message = message.replace('[hh:mm]', time);
				} else {
					message = message.replace('[N]', camDescription);
					message = message.replace(formatDate[_this2.lang], date);
					message = message.replace('[hh:mm]', time);
				}
	
				_this2.props.showAlertModal({
					type: "ModalAlert",
					title: "CenterWare Kolob",
					message: message,
					button: _this2.language.getText('GUIErrorMessageclose'),
					buttonFun: function buttonFun() {}
				});
			};
	
			_this2.sendManualMessage = function (dataToSend) {
				var _this = _this2;
				var data = {
					UserID: dataToSend.UserID,
					ConversationId: dataToSend.conversationId,
					messageId: 0,
					AcdId: dataToSend.CampID,
					CamType: 1,
					Phone: _this.state.phoneNumber,
					MessageText: '' + _this.state.templateWhatsapp.TemplateName,
					MessageType: "template",
					MediaType: _cwUnifiedInbox.MEDIATYPE.WHATSAPP,
					ConvUiId: _this.state.campaingID + '|' + 1 + '|' + _this.state.phoneNumber
				};
	
				_this.props.onSendManualMessage(data);
			};
	
			_this2.closeManualMessageAlert = function () {
				_this2.props.onSetMessageStatus(_constants.MANUAL_MESSAGES_STATUS.SEND, _this2.props.manualMessagePhone);
			};
	
			_this2.language = new _Singleton.Singleton();
			_this2.sharedData = new _singletonSharedData.SingletonSharedData();
			_this2.availableWAConnections = [_this2.language.getText('GUIManualMessageErrorserror-whatsapp-body1'), _this2.language.getText('GUIManualMessageErrorserror-whatsapp-body2')];
			_this2.lang = _this2.language.getLanguage() === '-1' ? _this2.sharedData.generalPermissions[27] : _this2.language.getLanguage();
			_this2.searchOptions = [{ text: _this2.language.getText('GUIManualCallsearchByName'), searchingBy: _constants.SEARCH_OPTIONS.BY_NAME }, { text: _this2.language.getText('GUIManualCallsearchByPhone'), searchingBy: _constants.SEARCH_OPTIONS.BY_PHONE }];
	
			_this2.searchOdbcOptions = [{ text: _this2.language.getText('GUIManualCallsearchByName'), searchingBy: _constants.SEARCH_OPTIONS.BY_NAME }, { text: _this2.language.getText('GUIManualCallsearchByPhone'), searchingBy: _constants.SEARCH_OPTIONS.BY_PHONE }, { text: _this2.language.getText('GUICallSpacecallkey'), searchingBy: _constants.SEARCH_OPTIONS.BY_CALL_KEY }];
	
			_this2.state = {
				campaingSelected: _lodash2.default.get(_this2.props.objProps.propsData, 'campaingName', ''),
				campaingID: _lodash2.default.get(_this2.props.objProps.propsData, 'campaingID', 0),
				phoneNumber: _lodash2.default.get(_this2.props.objProps.propsData, 'phoneNumber', _this2.sharedData.phoneNumber ? _this2.sharedData.phoneNumber : ''),
				disableManualCall: _lodash2.default.get(_this2.props.objProps.propsData, 'disableManualCall', false),
				isManualMessage: _lodash2.default.get(_this2.props.objProps, 'isManualMessage', false),
				campaingImage: '',
				correctPhoneNumberShowed: false,
				externalDBNotConfiguredShowed: false,
				campaingsShowed: false,
				ANIListShowed: false,
				callKey: '',
				data1: '',
				searchDataBase: '',
				searchCampaing: '',
				currentSearch: _this2.searchOptions[0],
				dbSearchShowed: false,
				campaingOrder: true,
				campaingList: [],
				contactList: [],
				recievedAlert: false,
				alertCode: 0,
				message: '',
				currentState: _constants.USER_STATE.AGENT_READY,
				shortNumber: false,
				InvalidCampaingAlert: false,
				CallValidationAlert: false,
				NoCampaignsFoundAlert: false,
				messageError: '',
				odbcMessageError: false,
				odbcGeneralError: false,
				isSpinnerOn: false,
				contactByODBC: false,
				searchEmpty: false,
				noCampaignSelected: false,
				showNoInputMessage: false,
				writeMessage: false,
				messageToSend: '',
				isInvalidNumber: true,
				showPhoneNumber: false,
				phoneNumberNoValid: false,
				aniSelected: '',
				searchANI: '',
				aniOrder: false,
				aniList: [],
				rotativeAniManualCall: 0,
				noANIListSelected: false,
				loadAni: false,
				templateWhatsapp: {},
				step: 0,
				templatesList: []
			};
			_this2.objectData = {
				UserID: _this2.sharedData.getParameters().UserID,
				CampID: _lodash2.default.get(_this2.props.objProps.propsData, 'campaingID', 0),
				Ext: _this2.sharedData.getParameters().Extension,
				PhoneNumber: _lodash2.default.get(_this2.props.objProps.propsData, 'phoneNumber', ''),
				Name: '',
				CallOutChange: 0,
				Status: 0,
				CallKey: '',
				CallMode: 0
			};
			_this2.currentMessageError = null;
			_this2.ManualCallAlwaysShow = false;
			_this2.integration = false;
			_this2.step = _constants.STEP_MANUAL_CALL.FIRST_TRY;
			_this2.lastNumberTried = '';
			_this2.lastCampTried = '';
			_this2.validationsNumber = (_this2$validationsNum = {}, _defineProperty(_this2$validationsNum, _constants.STEP_MANUAL_CALL.BLACKLIST_OR_WRONG_CAMP, function () {
				return _this2.campHasChanged();
			}), _defineProperty(_this2$validationsNum, _constants.STEP_MANUAL_CALL.INCORRECT_NUMBER, function () {
				return _this2.numberHasChanged();
			}), _this2$validationsNum);
	
			_this2.alertCatalog = (_this2$alertCatalog = {}, _defineProperty(_this2$alertCatalog, _constants.ALERT_CATALOG.TIME_ZONE, function () {
				var data = { number: _this2.state.phoneNumber };
				_SingletonWebSocket2.default.send(_SingletonWebSocket2.default.getJson(_constants.INTEGRATION.MANUAL_CALL, _constants.INTEGRATION_SUBACTION.TIME_ZONE_NUMBER_EVENT, data));
				_this2.setTimerCallAlert();
			}), _defineProperty(_this2$alertCatalog, _constants.ALERT_CATALOG.NO_CAMPAINS, function () {
				_this2.setTimerCallAlert();
			}), _defineProperty(_this2$alertCatalog, _constants.ALERT_CATALOG.CHECK_NUMBER, function () {
				_this2.setState({ shortNumber: true });
				var _this = _this2;
				_this.canRequestCall = true;
				setTimeout(function () {
					_this.setState({ shortNumber: false });
				}, 5000);
				_this2.step = _constants.STEP_MANUAL_CALL.BLACKLIST_OR_WRONG_CAMP;
				var integrationMessage = { client: 'galatea', action: 'ManualCall', subaction: 'wrongNumber', data: _this2.state.phoneNumber };
				_SingletonWebSocket2.default.send(integrationMessage);
			}), _defineProperty(_this2$alertCatalog, _constants.ALERT_CATALOG.INCORRECT_NUMBER, function (message) {
				return _this2.incorrectNumber(message);
			}), _this2$alertCatalog);
	
			_this2.erorCatalog = (_this2$erorCatalog = {}, _defineProperty(_this2$erorCatalog, _constants.ERROR_CATALOG.ON_BLACKLIST, function (message) {
				_this2.blackListNumber(message);
				_this2.sendErrorToIntegration(message);
			}), _defineProperty(_this2$erorCatalog, _constants.ERROR_CATALOG.NO_LONG_DISTANCE, function (message) {
				_this2.sendErrorToIntegration(message);
				_this2.setTimerCallAlert();
			}), _defineProperty(_this2$erorCatalog, _constants.ERROR_CATALOG.NO_LOCAL_CALLS, function (message) {
				_this2.sendErrorToIntegration(message);
				_this2.setTimerCallAlert();
			}), _defineProperty(_this2$erorCatalog, _constants.ERROR_CATALOG.NO_CELLPHONE, function (message) {
				_this2.step = _constants.STEP_MANUAL_CALL.BLACKLIST_OR_WRONG_CAMP;
				_this2.sendErrorToIntegration(message);
				_this2.setTimerCallAlert();
			}), _defineProperty(_this2$erorCatalog, _constants.ERROR_CATALOG.USER_OUT_CAMP, function (message) {
				_this2.setTimerCallAlert();
				_this2.sendErrorToIntegration(message);
			}), _defineProperty(_this2$erorCatalog, _constants.ERROR_CATALOG.NO_CAMPAIGN, function () {
				_this2.setState({ InvalidCampaingAlert: true });
				_this2.setTimerCallAlert();
			}), _defineProperty(_this2$erorCatalog, _constants.ERROR_CATALOG.UNABLE_VERIFY_PHONE_NUMBER, function () {
				var integrationMessage = { client: 'galatea', action: 'ManualCall', subaction: 'wrongNumber', data: _this2.state.phoneNumber };
				_SingletonWebSocket2.default.send(integrationMessage);
				_this2.setTimerCallAlert();
			}), _defineProperty(_this2$erorCatalog, _constants.ERROR_CATALOG.NO_PORTS_ASSIGNED, function (message) {
				_this2.sendErrorToIntegration(message);
				_this2.setTimerCallAlert();
			}), _this2$erorCatalog);
			_this2.messagesCalatog = { ALERT: _this2.alertCatalog, ERROR: _this2.erorCatalog };
	
			var APIFact = new _cwGalateaApiJsBundle.APIFactory();
			_this2.apiCont = APIFact.buildClient();
			_this2.canRequestCall = true;
			_this2.userHangout = false;
			_this2.OdbcValue = parseInt(_this2.sharedData.getGeneralPermissions()[239], 10);
			_this2.externalParameters = { name: _constants.SEARCH_OPTIONS.BY_NAME, phone: _constants.SEARCH_OPTIONS.BY_PHONE };
			_this2.externalOdbcParameters = { name: _constants.SEARCH_OPTIONS.BY_NAME, phone: _constants.SEARCH_OPTIONS.BY_PHONE, callKey: _constants.SEARCH_OPTIONS.BY_CALL_KEY };
			_this2.customCell = _constants.CUSTOM_CELLS.BY_NAME;
			_this2.textArea = _react2.default.createRef();
			return _this2;
		}
	
		_createClass(ManualCall, [{
			key: 'setTimerCallAlert',
			value: function setTimerCallAlert() {
				var _this = this;
				this.setState({ CallValidationAlert: true });
				setTimeout(function () {
					_this.setState({ CallValidationAlert: false });
				}, 5000);
			}
		}, {
			key: 'sendErrorToIntegration',
			value: function sendErrorToIntegration(message) {
				var json = message.Json;
				var type = json.Type;
				var code = json.InternalCode;
				var error = this.language.getText(type.toLowerCase() + '-' + code);
				var integrationMessage = { client: 'galatea', data: { code: code, message: error }, action: 'errorOnDialProcess' };
				_SingletonWebSocket2.default.send(integrationMessage);
			}
			//VALIDATIONS FOR STEP NUMBER
	
		}, {
			key: 'campHasChanged',
			value: function campHasChanged() {
				if (this.state.campaingID !== this.lastCampTried) {
					this.step = 0;
				}
			}
		}, {
			key: 'numberHasChanged',
			value: function numberHasChanged() {
				if (this.state.phoneNumber !== this.lastNumberTried && this.state.phoneNumber !== this.state.fixedPhoneNumber) {
					this.step = 0;
				}
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (nextProps.userState.currentState !== this.state.currentState) {
					this.setState({ currentState: nextProps.userState.currentState });
				}
				if (nextProps.objProps.propsAlert) {
					this.setState({
						recievedAlert: true,
						alertCode: nextProps.objProps.propsAlert.alertCode,
						message: nextProps.objProps.propsAlert.message
					});
				}
				var dragComponent = nextProps.dragWindowController.dragComponent;
	
				if (dragComponent && dragComponent.idComponent === _constants.DRAGGABLE_WINDOWS.MANUAL_CALL) {
					this.setState({
						campaingSelected: dragComponent.componentProps ? dragComponent.componentProps.campaingName : this.state.campaingSelected,
						campaingID: dragComponent.componentProps ? dragComponent.componentProps.campaingID : this.state.campaingID,
						phoneNumber: dragComponent.componentProps ? dragComponent.componentProps.phoneNumber : this.state.phoneNumber
					});
					this.ManualCallAlwaysShow = dragComponent.componentProps ? dragComponent.componentProps.ManualCallAlwaysShow : this.ManualCallAlwaysShow;
					if (this.ManualCallAlwaysShow) {
						this.sharedData.setPhoneNumber(dragComponent.componentProps.phoneNumber);
						this.sharedData.setCampaingID(dragComponent.componentProps.campaingID);
						this.props.messageApiRequest(_constants.API_ENDPOINTS.CALL_OUT_CAMPAIGNS, '', true);
						_Logger.Logger.Trace('[Manual Call][ManualCallAlwaysShow] ObjProps:  ' + dragComponent.componentProps);
						var data = {
							CamId: dragComponent.componentProps.campaingID,
							CallKey: this.state.callKey,
							Phone: dragComponent.componentProps.phoneNumber,
							Data: this.state.data1,
							ExistsCallout: 0,
							CallMode: 0,
							ani: this.state.aniSelected
						};
						this.props.manualCall(data);
						this.ManualCallAlwaysShow = false;
					}
				}
	
				if (nextProps.otherActions.workBarUpdate === _constants.WORKBAR_ACTIONS.MANUAL_CALL && this.state.campaingList.length === 0) {
					var newObject = {};
					for (var key in this.sharedData.callOutCampaigns) {
						var whatsCondition = this.state.isManualMessage ? this.sharedData.callOutCampaigns[key].Camptype === _constants.OUTBOUND_CAMP_TYPES.WHATSAPP : this.sharedData.callOutCampaigns[key].Camptype !== _constants.OUTBOUND_CAMP_TYPES.WHATSAPP;
						if (whatsCondition) {
							newObject[key] = this.sharedData.callOutCampaigns[key];
						}
					}
					this.setCampaingObj(newObject);
				}
				if (this.sharedData.callOutCampaigns && this.sharedData.getIsIntegration()) {
					var integrationMessage = { client: 'galatea', data: this.sharedData.callOutCampaigns, action: 'onCampaigns' };
					_SingletonWebSocket2.default.send(integrationMessage);
					this.sharedData.setIsIntegration();
				}
				if (nextProps.messagesIntegrations !== this.props.messagesIntegrations) {
					if (nextProps.messagesIntegrations.dataMessageIntegration && nextProps.messagesIntegrations.dataMessageIntegration.action === _constants.INTEGRATION.MANUAL_CALL) {
						this.sharedData.setIsIntegrationManualCall();
						this.setState({
							campaingID: nextProps.messagesIntegrations.dataMessageIntegration.camId,
							phoneNumber: nextProps.messagesIntegrations.dataMessageIntegration.phoneNumber,
							callKey: nextProps.messagesIntegrations.dataMessageIntegration.callKey,
							data1: nextProps.messagesIntegrations.dataMessageIntegration.clientName,
							recievedAlert: false
						});
					}
				}
	
				if (nextProps.userState.currentState === _constants.USER_STATE.DIALOG) {
					this.setState({ phoneNumber: '', data1: '', callKey: '' });
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState) {
				var _this3 = this;
	
				if (this.sharedData.getIsIntegrationManualCall()) {
					this.sharedData.setIsIntegrationManualCall();
					var data = {
						CamId: this.state.campaingID,
						CallKey: this.state.callKey,
						Phone: this.state.phoneNumber,
						Data: this.state.data1,
						ExistsCallout: 0,
						CallMode: 0
					};
					this.integration = true;
					this.sharedData.setPhoneNumber(data.Phone);
					this.requestCall();
				}
	
				if (this.props.manualMessageStatus === _constants.MANUAL_MESSAGES_STATUS.SEND && this.props.manualMessageStatus !== this.props.prevManualMessageStatus && prevProps.manualMessageConvId === this.props.manualMessageConvId && this.props.manualMessagePhone === undefined) {
					setTimeout(function () {
						_this3.props.removeWindow(_constants.DRAGGABLE_WINDOWS.MANUAL_MESSAGE);
					}, 200);
					setTimeout(function () {
						_this3.props.onSetMessageStatus(_constants.MANUAL_MESSAGES_STATUS.SEND, undefined);
					}, 300);
				}
	
				if (this.state.phoneNumber !== prevState.phoneNumber && this.state.phoneNumber && this.state.isManualMessage) {
					this.cleanPhoneNumber();
				}
	
				if (this.state.writeMessage && this.state.writeMessage !== prevState.writeMessage) {
					setTimeout(function () {
						_this3.textArea.focus();
					}, 200);
				}
				if (this.sharedData.aniList.length > 0 && this.state.aniList !== this.sharedData.aniList) {
					this.setState({ loadAni: false, aniList: this.sharedData.aniList });
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.keyboard = this.refs['Keyboard'];
				this.props.messageApiRequest(_constants.API_ENDPOINTS.CALL_OUT_CAMPAIGNS, '', true);
				this.keyboard.focusTel();
				if (this.props.objProps.propsData) {
					_Logger.Logger.Trace('[Manual Call][componentDidMount] ObjProps:  ' + this.props.objProps.propsData);
					if (this.props.objProps.propsData.action === _constants.INTEGRATION.MANUAL_CALL) {
						this.setState({
							campaingID: this.props.objProps.propsData.callData.campaingID,
							phoneNumber: this.props.objProps.propsData.callData.phoneNumber,
							callKey: this.props.objProps.propsData.callData.callKey,
							data1: this.props.objProps.propsData.callData.data1,
							recievedAlert: this.props.objProps.propsData.callData.recievedAlert
						});
						this.sharedData.setIsIntegrationManualCall();
					} else {
						var data = {
							UserID: this.sharedData.getParameters().UserID,
							CampID: this.state.campaingID,
							Ext: this.sharedData.getParameters().Extension,
							PhoneNumber: this.state.phoneNumber,
							Name: this.state.data1,
							CallOutChange: 0,
							Status: this.step,
							CallKey: this.state.callKey,
							CallMode: 0,
							integration: this.integration
						};
	
						this.sharedData.setPhoneNumber(data.Phone);
						if (this.props.objProps.propsData.rotativeAniManualCall === 1) {
							this.setState({ rotativeAniManualCall: this.props.objProps.propsData.rotativeAniManualCall });
							this.props.messageApiRequestANIList(_constants.API_ENDPOINTS.SELECT_ANI_MANUAL_CALL, this.state.campaingID, true);
						} else {
							this.validatePhoneNumber(data);
						}
					}
				}
				this.sharedData.setStateWindow(_constants.DRAGGABLE_WINDOWS.MANUAL_CALL, true);
				this.sharedData.setFocusTel(false);
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.sharedData.setCallOutCampaigns('');
				this.sharedData.setStateWindow(_constants.DRAGGABLE_WINDOWS.MANUAL_CALL, false);
			}
		}, {
			key: 'setCampaingObj',
			value: function setCampaingObj(campaingList) {
				if (typeof campaingList === 'undefined' && (this.props.objProps.propsData === null || this.props.objProps.propsData.campaingID === 0)) {
					this.setState({ NoCampaignsFoundAlert: true });
				} else {
					this.setState({ NoCampaignsFoundAlert: false });
				}
				var campList = [];
				for (var i in campaingList) {
					var campaing = campaingList[i];
					campaing.isFav = false;
					campaing.imgCampaing = _Images.framesCamp[campaing.GraphicID];
					campaing.starFav = _GenericSVG.starFav;
					campList.push(campaing);
					if (campaing.Default) {
						this.selectCampaing(campaing);
					}
				}
				if (this.state.campaingList.length === 0) {
					this.setState({ campaingList: campList });
					this.props.noConsultingApp();
				}
			}
		}, {
			key: 'selectCampaing',
			value: function selectCampaing(campaing) {
				var _this4 = this;
	
				this.setState({
					campaingsShowed: false,
					campaingSelected: campaing.Description,
					campaingID: campaing.ID,
					campaingImage: campaing.imgCampaing,
					campaingManualMode: campaing.CampManualMode,
					rotativeAniManualCall: campaing.SelectRotativeAniManualCall,
					ANIListShowed: false,
					loadAni: true,
					aniSelected: '',
					aniList: []
				});
				this.sharedData.setANIListCampaign([]);
				this.props.messageApiRequestANIList(_constants.API_ENDPOINTS.SELECT_ANI_MANUAL_CALL, campaing.ID, true);
	
				setTimeout(function () {
					_this4.props.getRecordCallPermission(_constants.API_ENDPOINTS.GET_RECORD_CALL_PERMISSION, campaing.ID, true);
				}, 500);
			}
		}, {
			key: 'favCampaing',
			value: function favCampaing(evt, campaing) {
				var campaings = this.state.campaingList;
				var camp = campaings.filter(function (x) {
					return x.ID === campaing.ID;
				})[0];
				camp.isFav = !camp.isFav;
				this.setState({ campaingList: campaings });
				evt.stopPropagation();
			}
		}, {
			key: 'selectContact',
			value: function selectContact(item) {
				this.setState({
					phoneNumber: item[_constants.SEARCH_OPTIONS.BY_PHONE],
					callKey: this.OdbcValue === 2 && item[_constants.SEARCH_OPTIONS.BY_CALL_KEY] ? item[_constants.SEARCH_OPTIONS.BY_CALL_KEY] : '',
					contactByODBC: true,
					dbSearchShowed: false,
					isSpinnerOn: false
				});
			}
		}, {
			key: 'correctNumber',
			value: function correctNumber() {
				this.setState({
					correctPhoneNumberShowed: false,
					phoneNumber: this.state.fixedPhoneNumber
				});
			}
		}, {
			key: 'useNumber',
			value: function useNumber() {
				this.setState({
					correctPhoneNumberShowed: false,
					fixedPhoneNumber: ''
				});
			}
		}, {
			key: 'incorrectNumber',
			value: function incorrectNumber(message) {
				var callmode = this.sharedData.getGeneralPermissions()[206];
				var callCorrectionAutomatically = callmode === '2' || callmode === '1';
	
				var splited = message.Json.Message.split('|');
				var fixNumber = splited[1];
				if (!callCorrectionAutomatically) {
					this.step = _constants.STEP_MANUAL_CALL.INCORRECT_NUMBER;
					this.setState({
						fixedPhoneNumber: fixNumber,
						correctPhoneNumberShowed: true
					});
					var integrationMessage = { client: 'galatea', action: 'ManualCall', subaction: 'wrongNumber', data: fixNumber };
					_SingletonWebSocket2.default.send(integrationMessage);
				} else {
					this.setState({
						correctPhoneNumberShowed: false,
						phoneNumber: fixNumber
					});
					this.objectData.PhoneNumber = fixNumber;
					this.makeCall();
				}
			}
		}, {
			key: 'blackListNumber',
			value: function blackListNumber(message) {
				this.setTimerCallAlert();
				var integrationMessage = { client: 'galatea', data: message, action: 'ManualCall', subaction: 'numberOnDoNotCallList' };
				_SingletonWebSocket2.default.send(integrationMessage);
			}
		}, {
			key: 'handleErrors',
			value: function handleErrors(messageError) {
				this.currentMessageError = messageError;
				_Logger.Logger.Debug('[Manual Call][handleErrors]currentMessageError =>  ' + this.currentMessageError);
				if (messageError.Json) {
					_Logger.Logger.Debug('[Manual Call][handleErrors] MESSAGE ERROR  =>  ' + messageError.Json.Type + ' => ' + messageError.Json.Message);
					if (this.messagesCalatog[messageError.Json.Type] && this.messagesCalatog[messageError.Json.Type][messageError.Json.InternalCode]) {
						this.messagesCalatog[messageError.Json.Type][messageError.Json.InternalCode](messageError);
					}
				}
			}
		}, {
			key: 'requestCall',
			value: function requestCall() {
				this.setState({ correctPhoneNumberShowed: false });
				if (!this.state.recievedAlert && this.canRequestCall) {
					this.blockRequestCall();
					if (this.validationsNumber[this.step]) {
						this.validationsNumber[this.step]();
					}
					this.lastNumberTried = this.state.phoneNumber;
					this.lastCampTried = this.state.campaingID;
					var callKey = this.state.currentState == 'ASSISTED' ? this.sharedData.dataObject.calKey : this.state.callKey;
					if (this.state.currentState == 'WRAPUP' && !this.state.callKey && this.sharedData.dataObject.calKey) {
						callKey = this.sharedData.dataObject.calKey;
					}
					this.objectData = {
						UserID: this.sharedData.getParameters().UserID,
						CampID: this.ManualCallAlwaysShow ? this.sharedData.getCampaingID() : this.state.campaingID,
						Ext: this.sharedData.getParameters().Extension,
						PhoneNumber: this.ManualCallAlwaysShow ? this.sharedData.getPhoneNumber() : this.state.phoneNumber,
						Name: this.state.data1,
						CallOutChange: 0,
						Status: this.step,
						CallKey: callKey,
						CallMode: 0
					};
					this.validatePhoneNumber(this.objectData);
				}
				this.setState({ shortNumber: false });
			}
		}, {
			key: 'validatePhoneNumber',
			value: function validatePhoneNumber(objectData) {
				var objectResponse = this.apiCont.getObjectResponse();
				this.props.consultingApp();
				this.apiCont.validatePhoneNumber(objectData, objectResponse);
				var _this = this;
				objectResponse.onError = function (messageError) {
					_Logger.Logger.Debug('[Manual Call][validatePhoneNumber] validatePhoneNumber Api Controller ERROR  =>  ' + messageError);
					_this.handleErrors(messageError);
					_this.props.noConsultingApp();
				};
				objectResponse.onSuccess = function () {
					_this.props.noConsultingApp();
					_this.makeCall();
				};
			}
		}, {
			key: 'makeCall',
			value: function makeCall() {
				var _this = this;
	
				if (_this.state.contactByODBC && this.OdbcValue === 2) {
					_this.sharedData.setOdbcExternalCall(true);
					_this.setState({ dbSearchShowed: true });
				} else {
					_this.sharedData.setOdbcExternalCall(false);
				}
	
				var data = {
					CamId: this.objectData.CampID,
					CallKey: this.objectData.CallKey,
					Phone: this.objectData.PhoneNumber,
					Data: this.objectData.Name,
					ExistsCallout: 0,
					CallMode: 0,
					integration: _this.integration,
					Odbc: _this.state.contactByODBC && _this.OdbcValue > 0 ? 1 : 0,
					ani: this.state.aniSelected
				};
				_this.setState({ contactByODBC: false, callKey: '' });
				_this.sharedData.setPhoneNumber(this.objectData.PhoneNumber);
				_this.props.manualCall(data);
				_this.keyboard.blurTel();
			}
		}, {
			key: 'closeAlert',
			value: function closeAlert(e) {
				this.setState({ recievedAlert: e });
			}
		}, {
			key: 'searchOnDataBase',
			value: function searchOnDataBase() {
				switch (this.OdbcValue) {
					case 0:
						this.setState({ dbSearchShowed: false, externalDBNotConfiguredShowed: true });
						this.startTimeOut();
						break;
					case 1:
						this.getExternalContacts();
						break;
					case 2:
						if (this.state.campaingID === 0) {
							this.setState({ dbSearchShowed: false, noCampaignSelected: true });
							this.startTimeOut();
						} else {
							this.getExternalOdbcCampaign(this.state.campaingID);
						}
						break;
					default:
						break;
				}
			}
		}, {
			key: 'startTimeOut',
			value: function startTimeOut() {
				var _this5 = this;
	
				setTimeout(function () {
					_this5.accept();
				}, 5000);
			}
		}, {
			key: 'getExternalContacts',
			value: function getExternalContacts() {
				var objectResponse = this.apiCont.getObjectResponse();
				this.props.consultingApp();
				this.apiCont.externalContacts(objectResponse);
				var _this = this;
				objectResponse.onError = function (messageError) {
					_Logger.Logger.Debug('[Manual Call][getExternalContacts] ApiController ERROR  =>  ' + messageError);
					_this.props.noConsultingApp();
					_this.setState({ dbSearchShowed: false, externalDBNotConfiguredShowed: true });
					_this.startTimeOut();
				};
				objectResponse.onSuccess = function (objResponse) {
					_this.props.noConsultingApp();
					_this.setState({ contactList: objResponse });
					_this.setState({ dbSearchShowed: true, externalDBNotConfiguredShowed: false });
				};
			}
		}, {
			key: 'getExternalOdbcCampaign',
			value: function getExternalOdbcCampaign(campId) {
				var objectResponse = this.apiCont.getObjectResponse();
	
				var _this = this;
				_this.setState({ isSpinnerOn: true });
				this.apiCont.externalOdbcCampaign(campId, objectResponse);
				objectResponse.onError = function (messageError) {
					_Logger.Logger.Debug('[Manual Call][getExternalOdbcCampaign] ApiController ERROR  =>  ' + messageError);
	
					var messageSplited = messageError.split('-');
	
					_this.setState({ isSpinnerOn: false, odbcMessageError: true });
	
					messageSplited.length === 1 ? _this.setState({ messageError: messageSplited[0] }) : _this.setState({ messageError: messageSplited[1] });
	
					messageSplited.length > 1 && messageSplited[1] === '7' ? _this.setState({ dbSearchShowed: true, contactList: [] }) : null;
	
					_this.startTimeOut();
				};
				objectResponse.onCatch = function (messageError) {
					console.warn(messageError);
					_this.setState({ isSpinnerOn: false });
					_this.props.showAlertModal((0, _alertQueryErrorBody.alertQueryErrorBody)());
				};
				objectResponse.onSuccess = function (objResponse) {
					_this.setState({ isSpinnerOn: false });
					_this.setState({ contactList: objResponse, dbSearchShowed: true, externalDBNotConfiguredShowed: false });
				};
			}
		}, {
			key: 'accept',
			value: function accept() {
				this.setState({ externalDBNotConfiguredShowed: false });
				this.setState({ InvalidCampaingAlert: false });
				this.setState({ odbcMessageError: false });
				this.setState({ searchEmpty: false });
				this.setState({ noCampaignSelected: false });
				this.setState({ showNoInputMessage: false });
				this.setState({ noANIListSelected: false, loadAni: false });
			}
		}, {
			key: 'blockRequestCall',
			value: function blockRequestCall() {
				var _this6 = this;
	
				this.canRequestCall = false;
				setTimeout(function () {
					_this6.canRequestCall = true;
				}, 3000);
			}
		}, {
			key: 'userHangedout',
			value: function userHangedout() {
				this.userHangout = true;
			}
		}, {
			key: 'onAlertRecieved',
			value: function onAlertRecieved() {
				if (this.state.recievedAlert) {
					if (this.userHangout) {
						this.setState({ recievedAlert: false });
						this.userHangout = false;
						this.setState({ userHangout: false });
						return false;
					} else {
						return true;
					}
				} else {
					return false;
				}
			}
		}, {
			key: 'playStopAudio',
			value: function playStopAudio(audio, time) {
				if (audio === null) {
					return false;
				}
				if (time > 0) {
					audio.play();
				}
				setTimeout(function () {
					audio.pause();
				}, time);
			}
		}, {
			key: 'setFilterTypeHandler',
			value: function setFilterTypeHandler(item) {
				if (this.OdbcValue === 2) {
					if (item.searchingBy === 'callKey') {
						this.customCell = _constants.CUSTOM_CELLS.BY_CALL_KEY;
						this.searchOdbcOptions = this.searchOdbcOptions[0].searchingBy === 'callKey' ? this.searchOdbcOptions : [this.searchOdbcOptions[2], this.searchOdbcOptions[0], this.searchOdbcOptions[1]];
					} else if (item.searchingBy === 'name') {
						this.customCell = _constants.CUSTOM_CELLS.BY_NAME;
						this.searchOdbcOptions = this.searchOdbcOptions[0].searchingBy === 'name' ? this.searchOdbcOptions : [this.searchOdbcOptions[1], this.searchOdbcOptions[2], this.searchOdbcOptions[0]];
					}
				}
				this.setState({ currentSearch: item });
			}
		}, {
			key: 'validateFilter',
			value: function validateFilter(e) {
				this.setState({ searchDataBase: e });
	
				if (e === '') {
					this.setState({ searchEmpty: false });
				}
	
				var searchBy = this.state.currentSearch.searchingBy;
				var contacts = this.state.contactList;
				var result = 0;
	
				contacts.map(function (item) {
					if (item[searchBy].toLowerCase().indexOf(e.toLowerCase()) >= 0) {
						result = 1;
					}
				});
	
				if (result === 0) {
					this.setState({ searchEmpty: true });
					this.startTimeOut();
				}
			}
		}, {
			key: 'makeManualCall',
			value: function makeManualCall() {
				if (this.state.data1 === '' && this.state.campaingManualMode === 3 || this.sharedData.generalPermissions[115] === "1" && this.state.data1 === "") {
					this.setState({ showNoInputMessage: true });
				} else {
					this.setState({ showNoInputMessage: false });
					this.integration = false;
					this.requestCall();
				}
			}
		}, {
			key: 'onSelectANIListShowed',
			value: function onSelectANIListShowed() {
				this.setState({ ANIListShowed: !this.state.ANIListShowed });
				if (!this.state.ANIListShowed && this.sharedData.isANIListEmpty) {
					this.setState({ noANIListSelected: this.sharedData.isANIListEmpty });
					this.startTimeOut();
				}
			}
		}, {
			key: 'rendeTableANI',
			value: function rendeTableANI() {
				var _this7 = this;
	
				return this.state.aniList.filter(function (i) {
					return i.includes(_this7.state.searchANI);
				}).sort(function (a, b) {
					return _this7.state.aniOrder ? b - a : a - b;
				}).map(function (v, i) {
					return _react2.default.createElement(_SingleTable.SingleTable, {
						data: v,
						key: i,
						onSelectANI: function onSelectANI(ani) {
							return _this7.setState({
								ANIListShowed: false,
								aniSelected: ani
							});
						}
					});
				});
			}
		}, {
			key: 'getOutboundWhatsAppTemplates',
			value: function getOutboundWhatsAppTemplates() {
				var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
				var closedIfOpen = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
				var _this = this;
				var dataToSend = {
					UserID: _this.sharedData.getParameters().UserID,
					CampID: _this.state.campaingID,
					PhoneNumber: _this.state.phoneNumber
				};
	
				var objectResponse = this.apiCont.getObjectResponse();
				this.apiCont.getWhatsAppTemplates(dataToSend, objectResponse);
				objectResponse.onError = function (messageError) {
					_Logger.Logger.Debug('[Manual Call][templatesWhatsapp] templatesWhatsapp Api Controller ERROR  =>  ' + messageError);
					_this.handleErrors(messageError);
				};
				objectResponse.onSuccess = function (data) {
					var templatesList = _lodash2.default.get(data, 'Json.Response');
					_this.props.insertWindow((0, _draggableComponents.templatesWhatsappWindow)({ templatesList: templatesList }, _this.setTemplateWhatsApp), closedIfOpen);
				};
			}
		}, {
			key: 'validateWhatsAppPhoneNumber',
			value: function validateWhatsAppPhoneNumber() {
				var _this = this;
				var dataToSend = {
					UserID: _this.sharedData.getParameters().UserID,
					CampID: _this.state.campaingID,
					PhoneNumber: _this.state.phoneNumber
				};
	
				var objectResponse = this.apiCont.getObjectResponse();
				_this.props.onSetMessageStatus(_constants.MANUAL_MESSAGES_STATUS.SENDING, this.state.phoneNumber);
				this.apiCont.validateWhatsAppPhoneNumber(dataToSend, objectResponse);
				objectResponse.onError = function (messageError) {
					_Logger.Logger.Debug('[Manual Call][validateWhatsAppPhoneNumber] validateWhatsAppPhoneNumber Api Controller ERROR  =>  ' + messageError);
					_this.handleErrors(messageError);
				};
				objectResponse.onSuccess = function (data) {
					var conversationId = _lodash2.default.get(data, 'Json.Response.ConversationId');
					var camDescription = _lodash2.default.get(data, 'Json.Response.CamDescription');
					var requestDate = _lodash2.default.get(data, 'Json.Response.RequestDate');
					var userId = _lodash2.default.get(data, 'Json.Response.UserId');
					var username = _lodash2.default.get(data, 'Json.Response.Username');
					var date = new Date(requestDate);
					var localeString = ['en-GB', 'en-US', 'en-GB'];
					var localeStringOptions = ['2-digit', 'numeric', 'numeric'];
					var formatDate = '' + date.toLocaleDateString(localeString[_this.lang], { day: "numeric", month: "numeric", year: localeStringOptions[_this.lang], timeZone: 'UTC' });
					var formatTime = '' + date.toLocaleTimeString(localeString[_this.lang], { hour: "2-digit", minute: "2-digit" });
					if (conversationId && conversationId !== 0) {
						_this.props.onSetMessageConvId(conversationId);
						_this.sendManualMessage(Object.assign({}, dataToSend, {
							conversationId: conversationId
						}));
					} else {
						if (camDescription !== null) {
							_this.conversationWAInavailable(userId, username, camDescription, formatDate, formatTime);
						}
						setTimeout(function () {
							_this.props.onSetMessageStatus(_constants.MANUAL_MESSAGES_STATUS.NETWORK_ERROR, _this.state.phoneNumber);
						}, 300);
					}
				};
			}
		}, {
			key: 'render',
			value: function render() {
				var _this8 = this;
	
				var user_CallOut = this.state.currentState === _constants.USER_STATE.CALL_OUT;
				var recievedAlert = this.state.recievedAlert;
				return _react2.default.createElement(
					'div',
					{ className: 'manualCall', onClick: function onClick() {
							return _this8.props.goTopZ(_this8.props.id);
						} },
					_customComponents.CUSTOM_COMPONENTS['draggableHeader'](this.state.isManualMessage ? _react2.default.createElement('img', { src: _whatsappIcono2.default, width: 16, height: 16 }) : _ManualCallSVG.manualCallSvg, this.language.getText(this.state.isManualMessage ? 'GUIManualMessagemanual-msg-tool' : 'GUICommonMenumanualCall'), !user_CallOut ? function () {
						_this8.props.removeWindow(_this8.state.isManualMessage ? _constants.DRAGGABLE_WINDOWS.MANUAL_MESSAGE : _constants.DRAGGABLE_WINDOWS.MANUAL_CALL);
					} : null, {
						iconHeader: this.state.isManualMessage ? 'iconWhatsHeader' : ''
					}),
					user_CallOut && !this.state.isManualMessage && _react2.default.createElement(_CallOutContainer2.default, {
						time: this.sharedData.getManualCallTime(),
						phone: this.sharedData.phoneNumber !== this.state.phoneNumber ? this.sharedData.phoneNumber : this.state.phoneNumber,
						userHangedout: function userHangedout() {
							return _this8.userHangedout();
						}
					}),
					_react2.default.createElement(
						'div',
						{ className: 'visibleWindow ' + (user_CallOut || recievedAlert || this.state.isManualMessage && this.props.manualMessageStatus ? 'blur ' : '') + (this.state.step === 1 ? 'step-1' : '') },
						_react2.default.createElement(
							'div',
							{ className: 'selectCampaing ' + (this.state.campaingSelected ? 'campSelected' : ''), onClick: function onClick() {
									return _this8.setState({ campaingsShowed: !_this8.state.campaingsShowed });
								} },
							!(this.state.campaingSelected === '') && _react2.default.createElement('img', { className: 'iconCampaingSelected', src: _Images.outBoundCall, alt: 'outBoundCall' }),
							!(this.state.campaingSelected === '') && _react2.default.createElement('img', { className: 'iconCampaingSelected iconCampaingSelectedPadding', src: this.state.campaingImage, alt: ' ' }),
							_react2.default.createElement(
								'p',
								{ className: 'campaingSelected ' + (this.state.campaingSelected ? 'campSelected' : '') },
								this.state.campaingSelected === '' ? this.language.getText(this.state.isManualMessage ? 'GUIManualMessageselect-campaign' : 'GUIManualCallselect') : this.state.campaingSelected
							),
							_react2.default.createElement(
								'div',
								{ className: 'arrowSelectCampaing ' + (this.state.campaingsShowed ? 'rotated' : 'normal') },
								' ',
								_GenericSVG.arrowBack,
								' '
							)
						),
						!this.state.campaingsShowed && this.state.showPhoneNumber && this.state.isManualMessage && this.state.phoneNumber && this.state.writeMessage ? _react2.default.createElement(
							'div',
							{ className: 'manualMessageDetailPhoneArea ' + (this.state.showPhoneNumber ? 'campSelected' : ''), onClick: function onClick() {
									return _this8.setState({ writeMessage: false, step: 0 });
								} },
							_react2.default.createElement(
								'div',
								{ className: 'manualMessageDetailPhoneIcon' },
								_ManualCallSVG.cellICon
							),
							_react2.default.createElement(
								'div',
								{ className: 'manualMessageDetailPhone' },
								this.state.phoneNumber
							)
						) : null,
						this.state.rotativeAniManualCall === 1 && !this.state.isManualMessage && _react2.default.createElement(
							'div',
							{ className: 'selectAni ' + (this.state.ANIListShowed ? 'showed' : ''), onClick: function onClick() {
									return _this8.onSelectANIListShowed();
								} },
							_react2.default.createElement(
								'p',
								{ className: 'aniSelected ' + (this.state.aniSelected ? 'aniSelectedA' : '') },
								this.state.aniSelected === '' ? this.language.getText('GUIManualCallselectANI') : this.state.aniSelected
							),
							_react2.default.createElement(
								'div',
								{ className: 'arrowANISelected ' + (this.state.ANIListShowed ? 'rotated' : 'normal') },
								' ',
								_GenericSVG.arrowBack,
								' '
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'optionsManualCall ' + (this.state.isSpinnerOn ? 'spinnerOn' : '') + ' ' + (this.state.step === 2 ? 'step-2' : '') },
							_react2.default.createElement(
								'div',
								{ className: 'dataBaseSearch activeSearch', onClick: function onClick() {
										return _this8.searchOnDataBase();
									} },
								_react2.default.createElement('img', { className: 'iconDataBaseSearch', src: _Images.search, alt: 'search' }),
								_react2.default.createElement(
									'p',
									{ className: 'infoDataBaseSearch text' },
									this.language.getText(this.state.isManualMessage ? 'GUIManualMessagesearch-box' : 'GUIManualCallsearchInDataBase')
								)
							),
							this.state.isSpinnerOn ? _react2.default.createElement(
								'div',
								null,
								_react2.default.createElement(
									'div',
									{ className: 'spinnerDatabaseSearch' },
									_react2.default.createElement(
										'div',
										{ className: 'manualMessageDetailPhoneIcon' },
										_ManualCallSVG.cellICon
									),
									_react2.default.createElement(
										'div',
										{ className: 'manualMessageDetailPhone' },
										this.state.phoneNumber
									),
									_react2.default.createElement(_reactstrap.Spinner, { color: 'primary', style: { width: '2rem', height: '2rem' } })
								),
								_react2.default.createElement(
									'div',
									{ className: 'spinnerDatabaseSearchText' },
									_react2.default.createElement(
										'p',
										null,
										this.language.getText('GUILoginloading')
									)
								)
							) : _react2.default.createElement(
								'div',
								null,
								this.state.step === 0 && _react2.default.createElement(
									'div',
									{ className: this.state.writeMessage ? 'infoWriteMessage' : 'dataManualCall' },
									!this.state.isManualMessage ? _react2.default.createElement(
										'div',
										null,
										_react2.default.createElement(
											'p',
											{ className: 'divContainerSeparator textLeft' },
											'1'
										),
										_react2.default.createElement('input', {
											type: 'text',
											placeholder: this.language.getText('GUIManualCalldata1'),
											className: 'txtDataClientCellMC',
											value: this.state.data1,
											onChange: function onChange(event) {
												_this8.setState({ data1: event.target.value });
												event.target.value !== "" && _this8.setState({ showNoInputMessage: false });
											}
										})
									) : null
								),
								_react2.default.createElement(
									'div',
									{ className: 'manualCallNumber ' + (this.state.writeMessage ? 'manualCallNumberWrite' : ''), id: 'manualCallNumber' },
									this.state.writeMessage ? _react2.default.createElement(
										'div',
										{ className: 'manualMessage' },
										_react2.default.createElement(
											'div',
											{ className: 'manualMessageArea' },
											this.state.step === 1 ? _react2.default.createElement(
												'div',
												{ className: 'manualMessageButton ' + (this.state.campaingID === 0 ? 'disabled' : ''), onClick: function onClick() {
														return _this8.getOutboundWhatsAppTemplates();
													} },
												_react2.default.createElement(
													'div',
													{ className: 'manualMessageIconList' },
													_ManualCallSVG.iconList
												),
												_react2.default.createElement(
													'div',
													{ className: 'manualMessageTitleText' },
													this.language.getText('GUIManualMessageselect-template')
												)
											) : this.state.step === 2 ? _react2.default.createElement(
												'div',
												{ className: 'ManualMessageTextArea' },
												_react2.default.createElement(_lib2.default, { id: 'txtManualMessage', className: 'manualMessageAreaText', value: this.state.templateWhatsapp.Body, innerRef: function innerRef(ref) {
														return _this8.textArea = ref;
													} }),
												_react2.default.createElement('hr', { className: 'manualMessageLine' }),
												_react2.default.createElement(
													'div',
													{ className: 'manualMessageLength' },
													_react2.default.createElement(
														'div',
														{ className: 'manualMessageLengthSend', onClick: function onClick() {
																return _this8.validateWhatsAppPhoneNumber();
															} },
														_react2.default.createElement('img', { src: _sendMessage2.default, className: 'manualMessageLengthSendIcon' })
													)
												)
											) : null
										)
									) : _react2.default.createElement(
										'div',
										null,
										_react2.default.createElement(_Keyboard2.default, {
											ref: 'Keyboard',
											number: this.state.phoneNumber,
											onChangeNumber: function onChangeNumber(number) {
												return _this8.setState({ shortNumber: false, phoneNumber: number });
											},
											onEnter: function onEnter() {
												if (_this8.state.isManualMessage) {
													_this8.makeManualCall();
												} else {
													_this8.state.campaingSelected ? _this8.requestCall() : null;
												}
											},
											onClean: function onClean() {
												return _this8.setState({ phoneNumber: '' });
											},
											onFocus: this.sharedData.getFocusTel(),
											disabled: this.state.disableManualCall,
											isManualMessage: this.state.isManualMessage,
											infoTooltip: this.state.isManualMessage && this.language.getText('GUIManualMessagetooltip-one') + '\n' + this.language.getText('GUIManualMessagetooltip-two')
										}),
										_react2.default.createElement(
											'div',
											{
												className: 'makeManualCall ' + (this.validateData(MANUAL_INPUTS.PHONE_NUMBER) ? 'disabled' : ''),
												onClick: this.state.isManualMessage ? function () {
													return _this8.validateDataPhone();
												} : function () {
													return _this8.makeManualCall();
												} },
											this.state.isManualMessage ? _react2.default.createElement('img', { src: _whatsappIcono2.default }) : _ManualCallSVG.phoneIcon
										)
									)
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'listCampaings ' + (this.state.campaingsShowed ? 'showedLC' : 'hiddenLC') },
						_customComponents.CUSTOM_COMPONENTS['inputDelete'](this.state.searchCampaing, function (e) {
							_this8.setState({ searchCampaing: e });
						}, 'dataBaseSearch smallDBSearch', 'infoDataBaseSearch', 'manualCallCleanButton', _GenericSVG.btnClear, false, _Images.search, 'iconDataBaseSearch', this.language.getText('CallControlCRMxcontrolssearchForMatchesButton')),
						_react2.default.createElement(
							'div',
							{ className: 'btnOrder', onClick: function onClick() {
									return _this8.setState({ campaingOrder: !_this8.state.campaingOrder });
								} },
							this.state.campaingOrder ? _ManualCallSVG.ZtoA : _ManualCallSVG.AtoZ
						),
						_react2.default.createElement(
							'div',
							{ className: 'campaingList' },
							_react2.default.createElement(_TableComponent2.default, {
								customCell: 'cellCampaings',
								parameters: { name: 'Description', imgCampaing: 'imgCampaing', isFav: 'isFav', starFav: 'starFav' },
								dataSource: this.state.campaingList,
								orderBy: 'Description',
								orderForm: this.state.campaingOrder,
								searching: this.state.searchCampaing,
								searchingValue: 'Description',
								onSelectItem: function onSelectItem(item) {
									return _this8.selectCampaing(item);
								},
								onActionInCell: function onActionInCell(e, item) {
									return _this8.favCampaing(e, item);
								}
							})
						)
					),
					this.state.rotativeAniManualCall === 1 && _react2.default.createElement(
						'div',
						{ className: 'listANIs ' + (this.state.ANIListShowed ? 'showedLC' : 'hiddenLC') },
						_customComponents.CUSTOM_COMPONENTS['inputDelete'](this.state.searchANI, function (e) {
							_this8.setState({ searchANI: e });
						}, 'dataBaseSearch smallDBSearch', 'infoDataBaseSearch', 'manualCallCleanButton', _GenericSVG.btnClear, false, _Images.search, 'iconDataBaseSearch', this.language.getText('CallControlCRMxcontrolssearchForMatchesButton')),
						_react2.default.createElement(
							'div',
							{ className: 'btnOrder', onClick: function onClick() {
									return _this8.setState({ aniOrder: !_this8.state.aniOrder });
								} },
							this.state.aniOrder ? _ManualCallSVG.ZtoA : _ManualCallSVG.AtoZ
						),
						_react2.default.createElement(
							'div',
							{ className: 'aniList' },
							this.state.loadAni && !this.state.noANIListSelected ? _react2.default.createElement(
								'div',
								null,
								_react2.default.createElement(
									'div',
									{ className: 'spinnerDatabaseSearch' },
									_react2.default.createElement(_reactstrap.Spinner, { color: 'primary', style: { width: '2rem', height: '2rem' } })
								),
								_react2.default.createElement(
									'div',
									{ className: 'spinnerDatabaseSearchText' },
									_react2.default.createElement(
										'p',
										null,
										this.language.getText('GUILoginloading')
									)
								)
							) : this.rendeTableANI()
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'dataBaseSearchContainer ' + (this.state.dbSearchShowed ? 'dbSearchShowed' : 'dbSearchHidden'), onClick: function onClick() {
								return _this8.setState({ dbSearchOptions: false });
							} },
						_react2.default.createElement(
							'div',
							{ className: 'dataBaseSearchHeader' },
							_react2.default.createElement(
								'div',
								{ className: 'dataBaseSearchHeader-up' },
								_react2.default.createElement(
									'div',
									{ className: 'backDataBaseSearch', onClick: function onClick() {
											return _this8.setState({ dbSearchShowed: false });
										} },
									_GenericSVG.arrowBack
								),
								_customComponents.CUSTOM_COMPONENTS['inputDelete'](this.state.searchDataBase, function (e) {
									return _this8.validateFilter(e);
								}, 'dataBaseSearch smallDBSearch', 'infoDataBaseSearch', 'manualCallCleanButton', _GenericSVG.btnClear, false, _Images.search, 'iconDataBaseSearch', this.language.getText('CallControlCRMxcontrolssearchForMatchesButton'))
							),
							_react2.default.createElement(
								'div',
								{ className: 'dataBaseSearchHeader-down' },
								_react2.default.createElement(
									'p',
									{ className: 'searchText' },
									this.language.getText('GUIManualCallsearchBy')
								),
								_react2.default.createElement(
									'div',
									{ className: 'searchOptionSelection' },
									_react2.default.createElement(_SelectComponent2.default, {
										itemDefault: 0,
										displayer: 'displayBlack',
										parameters: { text: 'text' },
										customCell: 'cellText',
										styleContainer: 'selectSearch',
										dataSource: this.OdbcValue === 1 ? this.searchOptions : this.searchOdbcOptions,
										onSelectItem: function onSelectItem(item) {
											return _this8.setFilterTypeHandler(item);
										}
									})
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'manualCallDataContainers' },
							_react2.default.createElement(
								'div',
								{ className: 'manualCallDataCell' },
								this.OdbcValue === 1 ? this.searchOptions.map(function (item) {
									return _react2.default.createElement(
										'p',
										{ key: item.text, className: 'manualCallCell title' },
										item.text
									);
								}) : this.searchOdbcOptions.map(function (item) {
									return _react2.default.createElement(
										'p',
										{ key: item.text, className: 'manualCallCell title' },
										item.text
									);
								})
							),
							_react2.default.createElement(
								'div',
								{ className: 'directoryTableContainer' },
								_react2.default.createElement(_TableComponent2.default, {
									customCell: this.customCell,
									parameters: this.OdbcValue === 1 ? this.externalParameters : this.externalOdbcParameters,
									dataSource: this.state.contactList,
									searching: this.state.searchDataBase,
									searchingValue: this.state.currentSearch.searchingBy,
									onSelectItem: function onSelectItem(item) {
										return _this8.selectContact(item);
									}
								})
							)
						)
					),
					this.state.correctPhoneNumberShowed && _react2.default.createElement(
						'div',
						{ className: 'alertContainer' },
						_react2.default.createElement(_AlertWindow2.default, {
							title: this.language.getText('GUIManualCallautocorrectTitle'),
							btnNo: this.language.getText('GUIManualCalldoNotCorrect'),
							btnYes: this.language.getText('GUIManualCallcorrect'),
							body: (0, _alertBodies.correctPhoneNumber)(this.language.getText('alert-1092'), this.state.fixedPhoneNumber),
							onYes: function onYes() {
								return _this8.correctNumber();
							},
							onNo: function onNo() {
								return _this8.useNumber();
							},
							isGlobe: true
						})
					),
					this.state.externalDBNotConfiguredShowed && _react2.default.createElement(
						'div',
						{ className: 'alertExternalDB', onMouseDown: function onMouseDown() {
								return _this8.accept();
							} },
						_react2.default.createElement(_AlertWindow2.default, { title: this.language.getText('GUIManualCallconfiguration'), body: (0, _alertBodies.generalBody)(this.language.getText('alert-1098')), isGlobe: true })
					),
					this.state.odbcMessageError && _react2.default.createElement(
						'div',
						{ className: 'alertExternalDB', onMouseDown: function onMouseDown() {
								return _this8.accept();
							} },
						_react2.default.createElement(_AlertWindow2.default, {
							title: this.language.getText('GUIManualCallNoDataTitle'),
							body: (0, _alertBodies.generalBody)(this.state.messageError.length > 1 ? this.language.getText('GUIAlertTransferunexpectedError') : this.language.getText('alert-110' + this.state.messageError)),
							isGlobe: true
						})
					),
					this.state.noCampaignSelected && _react2.default.createElement(
						'div',
						{ className: 'alertExternalDB', onMouseDown: function onMouseDown() {
								return _this8.accept();
							} },
						_react2.default.createElement(_AlertWindow2.default, { title: this.language.getText('GUIManualCallconfiguration'), body: (0, _alertBodies.generalBody)(this.language.getText('GUIManualCallNoCampaignSelected')), isGlobe: true })
					),
					this.state.noANIListSelected && _react2.default.createElement(
						'div',
						{ className: 'alertExternalDB', onMouseDown: function onMouseDown() {
								return _this8.accept();
							} },
						_react2.default.createElement(_AlertWindow2.default, { title: this.language.getText('GUIManualCallconfiguration'), body: (0, _alertBodies.generalBody)(this.language.getText('GUIManualCallNoANIAvailable')), isGlobe: true })
					),
					this.state.searchEmpty && this.state.searchDataBase !== '' && _react2.default.createElement(
						'div',
						{ className: 'alertExternalDB', onMouseDown: function onMouseDown() {
								return _this8.accept();
							} },
						_react2.default.createElement(_AlertWindow2.default, { title: this.language.getText('GUIManualCallNoDataTitle'), body: (0, _alertBodies.generalBody)(this.language.getText('alert-1107')), isGlobe: true })
					),
					this.state.shortNumber && _react2.default.createElement(
						'div',
						{ className: 'alertContainer' },
						_react2.default.createElement(_AlertWindow2.default, {
							title: this.language.getText('GUIManualCallmanualCall'),
							body: (0, _alertBodies.generalBody)(this.language.getText('alert-1091')),
							btnYes: this.language.getText('GUIErrorMessageclose'),
							isGlobe: true,
							isInfo: true
						})
					),
					this.state.InvalidCampaingAlert && _react2.default.createElement(
						'div',
						{ className: 'alertContainer' },
						_react2.default.createElement(_AlertWindow2.default, {
							title: this.language.getText('GUIManualCallmanualCall'),
							body: (0, _alertBodies.generalBody)(this.language.getText('error-1099')),
							btnYes: this.language.getText('GUIErrorMessageclose'),
							isGlobe: true,
							isInfo: true,
							onYes: function onYes() {
								return _this8.accept();
							}
						})
					),
					this.state.NoCampaignsFoundAlert && _react2.default.createElement(
						'div',
						{ className: 'alertNoCampaignsFound' },
						_react2.default.createElement(_AlertWindow2.default, { title: this.language.getText('GUIManualCallconfiguration'), body: (0, _alertBodies.generalBody)(this.language.getText('error-1083')), isGlobe: true, isInfo: true })
					),
					this.state.CallValidationAlert && _react2.default.createElement(
						'div',
						{ className: 'alertContainer' },
						_react2.default.createElement(_AlertWindow2.default, {
							title: this.language.getText('GUIManualCallmanualCall'),
							body: (0, _alertBodies.generalBody)(this.language.getText(this.currentMessageError.Json.Type.toLowerCase() + '-' + this.currentMessageError.Json.InternalCode)),
							btnYes: this.language.getText('GUIErrorMessageclose'),
							isGlobe: true,
							isInfo: true
						})
					),
					this.onAlertRecieved() && _react2.default.createElement(_AlertManualCallWindow2.default, {
						playStopAudio: this.playStopAudio,
						phoneNumber: this.sharedData.phoneNumber !== this.state.phoneNumber ? this.sharedData.phoneNumber : this.state.phoneNumber,
						alertCode: this.state.alertCode,
						closeAlert: function closeAlert(e) {
							return _this8.closeAlert(e);
						},
						closeManualCall: this.closeManualCall,
						message: this.state.message
					}),
					this.state.isManualMessage && this.props.manualMessageStatus && _react2.default.createElement(_AlertManualMessageWindow2.default, {
						phoneNumber: this.state.phoneNumber,
						alertCode: this.props.manualMessageStatus === _constants.MANUAL_MESSAGES_STATUS.SENDING ? 'CUSTOM' : _constants.MANUAL_MESSAGES_STATUS_TAG[this.props.manualMessageStatus],
						closeAlert: function closeAlert(e) {
							return _this8.closeManualMessageAlert(e);
						},
						message: this.language.getText('GUIManualMessagesend-animation')
					}),
					this.state.showNoInputMessage && _react2.default.createElement(
						'div',
						{ className: 'alertContainerNoInputMessage' },
						_react2.default.createElement(_AlertWindow2.default, {
							title: this.language.getText('GUIManualCallmanualCall'),
							body: (0, _alertBodies.generalBody)(this.language.getText('GUIManualCallNoInputMsg')),
							btnYes: this.language.getText('GUIErrorMessageclose'),
							isGlobe: true,
							isInfo: true
						})
					),
					this.state.phoneNumberNoValid && _react2.default.createElement(
						'div',
						{ className: 'alertContainer' },
						_react2.default.createElement(_AlertWindow2.default, {
							title: this.language.getText('GUIManualMessageinvalid-error-title'),
							body: (0, _alertBodies.generalBody)(this.language.getText('GUIManualMessageinvalid-error-msg')),
							isGlobe: true,
							isInfo: true
						})
					)
				);
			}
		}]);
	
		return ManualCall;
	}(_react.Component);
	
	function mapStateToProps(state) {
		return {
			dragWindowController: state.dragWindowController,
			otherActions: state.otherActions,
			userState: state.userState,
			messagesIntegrations: state.messagesIntegrations,
			manualMessageStatus: state.manualMessageReducer.manualMessageStatus,
			prevManualMessageStatus: state.manualMessageReducer.prevManualMessageStatus,
			manualMessageConvId: state.manualMessageReducer.convId,
			manualMessagePhone: state.manualMessageReducer.phone
		};
	}
	function mapDispatchToProps(dispatch) {
		var _showAlertModal = _A_Alert_Modal2.default.creators.showAlertModal;
	
		return {
			insertWindow: function insertWindow(dragWindow, closeComponentIfOpen) {
				dispatch((0, _A_draggable_windows_controller.insertWindow)(dragWindow, closeComponentIfOpen));
			},
			removeWindow: function removeWindow(iDdragComponent) {
				dispatch((0, _A_draggable_windows_controller.removeWindow)(iDdragComponent));
			},
			manualCall: function manualCall(data) {
				dispatch((0, _A_messages_to_SM.manualCall)(data));
			},
			messageApiRequest: function messageApiRequest(subaction, json, expectsReponse) {
				dispatch((0, _A_messages_to_SM.messageApiRequest)(subaction, json, expectsReponse));
			},
			consultingApp: function consultingApp() {
				dispatch((0, _A_reducer_consulting.consultingApp)());
			},
			noConsultingApp: function noConsultingApp() {
				dispatch((0, _A_reducer_consulting.noConsultingApp)());
			},
			changeIsIntegration: function changeIsIntegration() {
				dispatch((0, _A_actions_Integration.changeIsIntegration)());
			},
			showAlertModal: function showAlertModal(payload) {
				dispatch(_showAlertModal(payload));
			},
			onSendManualMessage: function onSendManualMessage(data) {
				dispatch((0, _A_messages_to_SM.onSendUnifiedResponse)(data));
			},
			onSetMessageStatus: function onSetMessageStatus(messageStatus, phone) {
				dispatch((0, _A_manual_message.setMessageStatus)(messageStatus, phone));
			},
			onSetMessageConvId: function onSetMessageConvId(convId) {
				dispatch((0, _A_manual_message.setMessageConvId)(convId));
			},
			messageApiRequestANIList: function messageApiRequestANIList(subaction, camId, expectsReponse) {
				dispatch((0, _A_messages_to_SM.messageApiRequestANIList)(subaction, camId, expectsReponse));
			},
			getRecordCallPermission: function getRecordCallPermission(subaction, camId, expectsReponse) {
				dispatch((0, _A_messages_to_SM.getRecordCallPermission)(subaction, camId, expectsReponse));
			}
		};
	}
	exports.default = ManualCall = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ManualCall);

/***/ },
/* 1124 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Images = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MarkDetail = function (_Component) {
	  _inherits(MarkDetail, _Component);
	
	  function MarkDetail() {
	    _classCallCheck(this, MarkDetail);
	
	    return _possibleConstructorReturn(this, (MarkDetail.__proto__ || Object.getPrototypeOf(MarkDetail)).apply(this, arguments));
	  }
	
	  _createClass(MarkDetail, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'markContainerCell' },
	        _react2.default.createElement(
	          'div',
	          { className: 'markCell' },
	          _react2.default.createElement(
	            'div',
	            { className: 'markTimeCell' },
	            _react2.default.createElement('img', { className: 'clockIcon', src: _Images.clock, alt: 'icon' }),
	            _react2.default.createElement(
	              'p',
	              { className: 'markTimeLabel', key: this.props.mark.idx },
	              this.props.mark.time
	            ),
	            _react2.default.createElement('img', { className: 'closeIcon', onClick: function onClick(e) {
	                return _this2.props.onDeleteMark(_this2.props.mark);
	              }, src: _Images.cross, alt: 'icon' })
	          ),
	          _react2.default.createElement('div', { className: 'markCointainerDesc' })
	        )
	      );
	    }
	  }]);
	
	  return MarkDetail;
	}(_react.Component);
	
	exports.default = MarkDetail;

/***/ },
/* 1125 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(25);
	
	var _NoAvailableComponent = __webpack_require__(499);
	
	var _NoAvailableComponent2 = _interopRequireDefault(_NoAvailableComponent);
	
	var _customComponents = __webpack_require__(59);
	
	var _NoAvailableSVG = __webpack_require__(114);
	
	var _A_workBar_selected = __webpack_require__(195);
	
	var _A_draggable_windows_controller = __webpack_require__(55);
	
	var _constants = __webpack_require__(10);
	
	var _Singleton = __webpack_require__(21);
	
	var _singletonSharedData = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NoAvailableFloat = function (_Component) {
	  _inherits(NoAvailableFloat, _Component);
	
	  function NoAvailableFloat(props) {
	    _classCallCheck(this, NoAvailableFloat);
	
	    var _this = _possibleConstructorReturn(this, (NoAvailableFloat.__proto__ || Object.getPrototypeOf(NoAvailableFloat)).call(this, props));
	
	    _this.language = new _Singleton.Singleton();
	    _this.sharedData = new _singletonSharedData.SingletonSharedData();
	    return _this;
	  }
	
	  _createClass(NoAvailableFloat, [{
	    key: 'closeNoAvailable',
	    value: function closeNoAvailable() {
	      this.props.removeWorkAction(_constants.WORKBAR_ACTIONS.NO_AVAILABLE);
	      this.props.removeWindow(_constants.DRAGGABLE_WINDOWS.NO_AVAILABLE);
	      this.sharedData.setStateWindow(_constants.DRAGGABLE_WINDOWS.NO_AVAILABLE, false);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'noAvailableFloatingContainer ' + (!this.props.simultaneosRecs ? 'regsMultiple' : '') + ' ', onClick: function onClick() {
	            return _this2.props.goTopZ(_this2.props.id);
	          } },
	        _customComponents.CUSTOM_COMPONENTS["draggableHeader"](_NoAvailableSVG.noAvailableSVG, this.language.getText("GUIDisableSelectorwindowTitle"), function () {
	          return _this2.closeNoAvailable();
	        }),
	        _react2.default.createElement(_NoAvailableComponent2.default, { floating: false })
	      );
	    }
	  }]);
	
	  return NoAvailableFloat;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    simultaneosRecs: state.preview.simultaneosRecs
	  };
	}
	function mapDispatchToProps(dispatch) {
	  return {
	    removeWindow: function removeWindow(iDdragComponent) {
	      dispatch((0, _A_draggable_windows_controller.removeWindow)(iDdragComponent));
	    },
	    removeWorkAction: function removeWorkAction(idRemove) {
	      dispatch((0, _A_workBar_selected.removeWorkAction)(idRemove));
	    }
	  };
	}
	
	exports.default = NoAvailableFloat = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(NoAvailableFloat);

/***/ },
/* 1126 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(25);
	
	var _NoAvailableRecordComponent = __webpack_require__(500);
	
	var _NoAvailableRecordComponent2 = _interopRequireDefault(_NoAvailableRecordComponent);
	
	var _customComponents = __webpack_require__(59);
	
	var _constants = __webpack_require__(10);
	
	var _NoAvailableSVG = __webpack_require__(114);
	
	var _A_workBar_selected = __webpack_require__(195);
	
	var _A_draggable_windows_controller = __webpack_require__(55);
	
	var _Singleton = __webpack_require__(21);
	
	var _singletonSharedData = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NoAvailableRecordFloating = function (_Component) {
	  _inherits(NoAvailableRecordFloating, _Component);
	
	  function NoAvailableRecordFloating(props) {
	    _classCallCheck(this, NoAvailableRecordFloating);
	
	    var _this = _possibleConstructorReturn(this, (NoAvailableRecordFloating.__proto__ || Object.getPrototypeOf(NoAvailableRecordFloating)).call(this, props));
	
	    _this.language = new _Singleton.Singleton();
	    _this.sharedData = new _singletonSharedData.SingletonSharedData();
	    return _this;
	  }
	
	  _createClass(NoAvailableRecordFloating, [{
	    key: 'closeChat',
	    value: function closeChat() {
	      this.props.removeWorkAction(_constants.WORKBAR_ACTIONS.NO_AVAILABLE_RECORD);
	      this.props.removeWindow(_constants.DRAGGABLE_WINDOWS.NO_AVAILABLE_RECORD);
	      this.sharedData.setStateWindow(_constants.DRAGGABLE_WINDOWS.NO_AVAILABLE_RECORD, false);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'fullSize ' + (!this.props.simultaneosRecs ? 'regsMultiple' : '') + ' ', onClick: function onClick() {
	            return _this2.props.goTopZ(_this2.props.id);
	          } },
	        _customComponents.CUSTOM_COMPONENTS["draggableHeader"](_NoAvailableSVG.noAvailableRecordIcon, this.language.getText("GUICommonMenudisableHistory"), function () {
	          return _this2.closeChat();
	        }),
	        _react2.default.createElement(_NoAvailableRecordComponent2.default, {
	          floating: false })
	      );
	    }
	  }]);
	
	  return NoAvailableRecordFloating;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    simultaneosRecs: state.preview.simultaneosRecs
	  };
	}
	function mapDispatchToProps(dispatch) {
	  return {
	    removeWorkAction: function removeWorkAction(idRemove) {
	      dispatch((0, _A_workBar_selected.removeWorkAction)(idRemove));
	    },
	    removeWindow: function removeWindow(iDdragComponent) {
	      dispatch((0, _A_draggable_windows_controller.removeWindow)(iDdragComponent));
	    }
	  };
	}
	exports.default = NoAvailableRecordFloating = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(NoAvailableRecordFloating);

/***/ },
/* 1127 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.OngoingCallIvrModal = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(25);
	
	var _reactModal = __webpack_require__(939);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _IVRSVG = __webpack_require__(1059);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_reactModal2.default.setAppElement('body');
	
	var customStyles = {
	  content: {
	    top: '50%',
	    left: '50%',
	    bottom: 'auto',
	    width: '180px',
	    height: 'auto',
	    overflow: 'hidden',
	    padding: '0',
	
	    transform: 'translate(-50%, -50%)'
	  }
	};
	
	var OngoingCallIvrModal = exports.OngoingCallIvrModal = function OngoingCallIvrModal(props) {
	  var isModalOpen = props.isModalOpen,
	      data = props.data;
	
	
	  return _react2.default.createElement(
	    _reactModal2.default,
	    {
	      className: 'Ongoing',
	      isOpen: isModalOpen,
	      style: customStyles },
	    _react2.default.createElement(
	      'div',
	      { className: 'OngoingCallIvrModalHeader' },
	      _react2.default.createElement(
	        'div',
	        { className: 'ValidatingAnimation' },
	        _react2.default.createElement('div', { className: 'circle1' }),
	        _react2.default.createElement('div', { className: 'circle2' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'ivrAnimation' },
	          _IVRSVG.ivrBlockingSVG
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'OngoingCallIvrModalMessageContainer' },
	      _react2.default.createElement(
	        'div',
	        { className: 'OngoingCallIvrModalTitle' },
	        data.title
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'OngoingCallIvrModalMessage' },
	        data.message
	      )
	    )
	  );
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  var _state$isOngoingCallI = state.isOngoingCallIvrModalOpen,
	      isModalOpen = _state$isOngoingCallI.isModalOpen,
	      data = _state$isOngoingCallI.data;
	
	  return {
	    isModalOpen: isModalOpen,
	    data: data
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(OngoingCallIvrModal);

/***/ },
/* 1128 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(25);
	
	var _singletonSharedData = __webpack_require__(23);
	
	var _Singleton = __webpack_require__(21);
	
	var _constants = __webpack_require__(10);
	
	var _CallSpaceHeaderSVG = __webpack_require__(67);
	
	var _A_draggable_windows_controller = __webpack_require__(55);
	
	var _customComponents = __webpack_require__(59);
	
	var _A_reducer_call_acd = __webpack_require__(156);
	
	var _cwGalateaApiJsBundle = __webpack_require__(40);
	
	var _A_messages_to_SM = __webpack_require__(32);
	
	var _SingletonWebSocket = __webpack_require__(50);
	
	var _SingletonWebSocket2 = _interopRequireDefault(_SingletonWebSocket);
	
	var _A_ongoing_call_ivr_modal = __webpack_require__(334);
	
	var _A_ongoing_call_ivr_modal2 = _interopRequireDefault(_A_ongoing_call_ivr_modal);
	
	var _Logger = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OngoingCallIvrWindow = function (_Component) {
	  _inherits(OngoingCallIvrWindow, _Component);
	
	  function OngoingCallIvrWindow(props) {
	    _classCallCheck(this, OngoingCallIvrWindow);
	
	    var _this2 = _possibleConstructorReturn(this, (OngoingCallIvrWindow.__proto__ || Object.getPrototypeOf(OngoingCallIvrWindow)).call(this, props));
	
	    _this2.sharedData = new _singletonSharedData.SingletonSharedData();
	    _this2.language = new _Singleton.Singleton();
	    _this2.state = {
	      IvrArray: []
	    };
	    var APIFact = new _cwGalateaApiJsBundle.APIFactory();
	    _this2.apiCont = APIFact.buildClient();
	    return _this2;
	  }
	
	  _createClass(OngoingCallIvrWindow, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.assistedTransfer.currentState && nextProps.assistedTransfer.currentState === _constants.ASSISTED_TRANSFER.IDDLE_END) {
	        var integrationMessage = { client: "galatea", action: "OngoingCallIvr", subaction: "onIdleEnd" };
	        _SingletonWebSocket2.default.send(integrationMessage);
	        this.props.hideModal();
	      }
	      if (nextProps.messagesIntegrations && nextProps.messagesIntegrations.dataMessageIntegration) {
	        if (nextProps.messagesIntegrations.dataMessageIntegration.action === _constants.INTEGRATION.IDLE_START) {
	          var _this = this;
	          _this.sendToIvr(nextProps.messagesIntegrations.dataMessageIntegration.IVRId);
	        } else if (nextProps.messagesIntegrations.dataMessageIntegration.action === _constants.INTEGRATION.CALL_ACTION && nextProps.messagesIntegrations.dataMessageIntegration.callAction === _constants.INTEGRATION.GET_IVR_LIST) {
	          var _this3 = this;
	          var message = [];
	          for (var i in _this3.state.IvrArray) {
	            var item = _this3.state.IvrArray[i];
	            message.push({ name: item.Description, id: item.Id });
	          }
	          var _integrationMessage = { client: "galatea", data: message, action: "OngoingCallIvr", subaction: "onIVRList" };
	          _SingletonWebSocket2.default.send(_integrationMessage);
	        }
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var objectResponse = this.apiCont.getObjectResponse();
	      this.apiCont.ongoingCallIvr(objectResponse);
	      var _this = this;
	      objectResponse.onError = function (messageError) {
	        _Logger.Logger.Debug('[Ongoing Call Window][componentDidMount] Api Controller ERROR  =>  ' + messageError);
	      };
	      objectResponse.onSuccess = function (objResponse) {
	        _Logger.Logger.Trace('[Ongoing Call Window][componentDidMount] Api Controller On Going Call IVR Success');
	        var message = [];
	        for (var i in objResponse) {
	          var item = objResponse[i];
	          message.push({ name: item.Description, id: item.Id });
	        }
	
	        var integrationMessage = { client: "galatea", data: message, action: "OngoingCallIvr", subaction: "onIVRList" };
	        _SingletonWebSocket2.default.send(integrationMessage);
	        _this.setState({ IvrArray: objResponse });
	      };
	      if (_this.props.objProps && _this.props.objProps.action && _this.props.objProps.action === _constants.INTEGRATION.IDLE_START) {
	        _this.sendToIvr(_this.props.objProps.IVRId);
	      }
	    }
	  }, {
	    key: 'sendToIvr',
	    value: function sendToIvr(id) {
	      var _this4 = this;
	
	      this.props.messageOngoingCallIvr(id);
	      var integrationMessage = { client: "galatea", action: "OngoingCallIvr", data: id, subaction: "onIdleStart" };
	      _SingletonWebSocket2.default.send(integrationMessage);
	      var data = {
	        message: this.language.getText("CallControlIVRInputmessage"),
	        title: this.language.getText("CallControlIVRInputtitle")
	      };
	      setTimeout(function () {
	        _this4.props.showModal(data);
	      }, 200);
	      this.props.onCloseIVR && this.props.onCloseIVR();
	      setTimeout(function () {
	        _this4.props.removeWindow(_constants.DRAGGABLE_WINDOWS.ONGOING_CALL_IVR);
	      }, 400);
	    }
	  }, {
	    key: 'renderList',
	    value: function renderList(item, i) {
	      var _this5 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { key: i, className: 'OngoingCallIvrElement', onClick: function onClick() {
	            return _this5.sendToIvr(item.Id);
	          } },
	        item.Description
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'OngoingCallIvrWindow', onClick: function onClick() {
	            return _this6.props.goTopZ(_this6.props.id);
	          } },
	        _customComponents.CUSTOM_COMPONENTS["draggableHeader"](_CallSpaceHeaderSVG.ivr, this.language.getText("CallControlIVRInputheader"), function () {
	          _this6.props.onCloseIVR && _this6.props.onCloseIVR();
	          _this6.props.removeWindow(_constants.DRAGGABLE_WINDOWS.ONGOING_CALL_IVR);
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'OngoingCallIvrContainer' },
	          this.state.IvrArray.map(function (item, i) {
	            return _this6.renderList(item, i);
	          })
	        )
	      );
	    }
	  }]);
	
	  return OngoingCallIvrWindow;
	}(_react.Component);
	
	;
	function mapStateToProps(state) {
	  return {
	    messagesIntegrations: state.messagesIntegrations,
	    assistedTransfer: state.assistedTransfer
	  };
	}
	function mapDispatchToProps(dispatch) {
	  var _ModalActions$creator = _A_ongoing_call_ivr_modal2.default.creators,
	      _showModal = _ModalActions$creator.showModal,
	      _hideModal = _ModalActions$creator.hideModal;
	
	  return {
	    messageOngoingCallIvr: function messageOngoingCallIvr(data) {
	      dispatch((0, _A_messages_to_SM.messageOngoingCallIvr)(data));
	    },
	    removeWindow: function removeWindow(iDdragComponent) {
	      dispatch((0, _A_draggable_windows_controller.removeWindow)(iDdragComponent));
	    },
	    callAction: function callAction(actionType, parameters) {
	      dispatch((0, _A_reducer_call_acd.callAction)(actionType, parameters));
	    },
	    showModal: function showModal(data) {
	      dispatch(_showModal(data));
	    },
	    hideModal: function hideModal() {
	      dispatch(_hideModal());
	    }
	  };
	}
	exports.default = OngoingCallIvrWindow = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(OngoingCallIvrWindow);

/***/ },
/* 1129 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(25);
	
	var _Dispositions = __webpack_require__(497);
	
	var _Dispositions2 = _interopRequireDefault(_Dispositions);
	
	var _constants = __webpack_require__(10);
	
	var _A_draggable_windows_controller = __webpack_require__(55);
	
	var _A_messages_to_SM = __webpack_require__(32);
	
	var _A_preview = __webpack_require__(52);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RateRecord = function (_Component) {
	  _inherits(RateRecord, _Component);
	
	  function RateRecord(props) {
	    _classCallCheck(this, RateRecord);
	
	    var _this = _possibleConstructorReturn(this, (RateRecord.__proto__ || Object.getPrototypeOf(RateRecord)).call(this, props));
	
	    _this.state = {
	      ratedRecord: false,
	      dispositionSelected: null,
	      subDispositionSelected: null,
	      FinishRecordPreview: false,
	      showCanReprogram: false,
	      reprogram: null,
	      selectedRecord: _this.props.selectedRecord,
	      isActive: true
	    };
	    _this.data = {
	      callId: "",
	      reference: "",
	      calloutId: ""
	    };
	
	    return _this;
	  }
	
	  _createClass(RateRecord, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.selectedRecord.callId !== this.data.callId) {
	        this.data = { callId: nextProps.selectedRecord.callId, calloutId: nextProps.selectedRecord.calloutId };
	        this.setState({ selectedRecord: nextProps.selectedRecord });
	      }
	    }
	  }, {
	    key: "saveDisposition",
	    value: function saveDisposition() {
	      var _this2 = this;
	
	      var objectData = {
	        CallId: this.state.selectedRecord.callId,
	        DispositionId: this.state.dispositionSelected.Id,
	        Origin: '',
	        CallKey: this.state.selectedRecord.callKey,
	        CallOutId: this.state.selectedRecord.callOutId,
	        SubId: this.state.subDispositionSelected,
	        CallType: 2,
	        IsExitAssisted: this.state.dispositionSelected.FinishPreview,
	        IsExitPreview: this.state.dispositionSelected.FinishRecordPreview
	      };
	      setTimeout(function () {
	        _this2.props.messageApiRequest(_constants.API_ENDPOINTS.SAVE_DISPOSITION, objectData);
	      }, 100);
	      this.Rescheduled();
	      setTimeout(function () {
	        _this2.onClose();
	      }, 100);
	    }
	  }, {
	    key: "Rescheduled",
	    value: function Rescheduled() {
	      var _this3 = this;
	
	      if (this.state.dispositionSelected.CanReprogram || this.state.dispositionSelected.SubDisposition.CanReprogram) {
	        var objCallBack = {
	          CamId: this.state.selectedRecord.camId,
	          Phone: this.state.reprogram.phoneReprogram.selectionReschedule === 2 ? this.state.reprogram.phoneReprogram.otherPhone : this.state.reprogram.phoneReprogram.phone.number,
	          TelReprograma: 1, // type === 1 ? 1 : (reprogram.phoneReprogram.selectionReschedule === 2 ? 0 : reprogram.phoneReprogram.phone.id),
	          IsAuto: false,
	          DateDial: this.state.reprogram.dateReprogram
	        };
	        setTimeout(function () {
	          _this3.props.messageApiRequest(_constants.API_ENDPOINTS.CALL_BACK, objCallBack);
	        }, 200);
	      }
	      if (this.state.dispositionSelected.FinishRecordPreview) {
	        this.props.setDispositionData({ callOutId: this.state.selectedRecord.callOutId, alreadyRated: true, exitPreview: true });
	      } else {
	        this.props.setDispositionData({ callOutId: this.state.selectedRecord.callOutId, alreadyRated: true, exitPreview: false });
	      }
	    }
	  }, {
	    key: "onClose",
	    value: function onClose() {
	      this.props.removeWindow(_constants.DRAGGABLE_WINDOWS.RATE_RECORD);
	      var rated = this.state.dispositionSelected != null ? true : false;
	      this.setState({ isActive: false, ratedRecord: rated });
	      this.props.onCloseDispositionWindow(false);
	    }
	  }, {
	    key: "setDisposition",
	    value: function setDisposition(disposition) {
	      this.setState({ dispositionSelected: disposition.dispositionSelected, subDispositionSelected: disposition.subDispositionSelected });
	    }
	  }, {
	    key: "setReprogram",
	    value: function setReprogram(repro) {
	      this.setState({ reprogram: repro });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this4 = this;
	
	      var showSubDisposition = this.state.dispositionSelected != null && this.state.dispositionSelected.SubDisposition && this.state.dispositionSelected.SubDisposition.length > 0;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "rateContainer", onClick: function onClick() {
	            return _this4.props.goTopZ(_this4.props.id);
	          } },
	        _react2.default.createElement(
	          "div",
	          { className: "rateRecordHeader" },
	          _react2.default.createElement("i", { className: "gcl-icon close", title: "close", onClick: function onClick() {
	              return _this4.onClose();
	            } })
	        ),
	        _react2.default.createElement(_Dispositions2.default, {
	          type: 1,
	          endWraUpWithDisp: function endWraUpWithDisp() {
	            return _this4.saveDisposition();
	          },
	          onChangeDisp: function onChangeDisp(d) {
	            return _this4.setDisposition(d);
	          },
	          onChangeReprogam: function onChangeReprogam(r) {
	            return _this4.setReprogram(r);
	          },
	          rateInDialog: true
	        })
	      );
	    }
	  }]);
	
	  return RateRecord;
	}(_react.Component);
	
	;
	
	function mapStateToProps(state) {
	  return {
	    dragWindowController: state.dragWindowController,
	    selectedRecord: state.preview.selectedRecord,
	    simultaneosRecs: state.preview.simultaneosRecs,
	    records: state.preview.records
	  };
	}
	function mapDispatchToProps(dispatch) {
	  return {
	    messageApiRequest: function messageApiRequest(subaction, json, expectsReponse) {
	      dispatch((0, _A_messages_to_SM.messageApiRequest)(subaction, json, expectsReponse));
	    },
	    removeWindow: function removeWindow(iDdragComponent) {
	      dispatch((0, _A_draggable_windows_controller.removeWindow)(iDdragComponent));
	    },
	    setDispositionData: function setDispositionData(data) {
	      dispatch((0, _A_preview.setDispositionData)(data));
	    }
	  };
	}
	exports.default = RateRecord = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(RateRecord);

/***/ },
/* 1130 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(25);
	
	var _customComponents = __webpack_require__(59);
	
	var _ChatComponent = __webpack_require__(498);
	
	var _ChatComponent2 = _interopRequireDefault(_ChatComponent);
	
	var _ChatSVG = __webpack_require__(235);
	
	var _constants = __webpack_require__(10);
	
	var _A_workBar_selected = __webpack_require__(195);
	
	var _A_draggable_windows_controller = __webpack_require__(55);
	
	var _singletonSharedData = __webpack_require__(23);
	
	var _Singleton = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SuperVisorChatFloating = function (_Component) {
	  _inherits(SuperVisorChatFloating, _Component);
	
	  function SuperVisorChatFloating(props) {
	    _classCallCheck(this, SuperVisorChatFloating);
	
	    var _this = _possibleConstructorReturn(this, (SuperVisorChatFloating.__proto__ || Object.getPrototypeOf(SuperVisorChatFloating)).call(this, props));
	
	    _this.sharedData = new _singletonSharedData.SingletonSharedData();
	    _this.language = new _Singleton.Singleton();
	    return _this;
	  }
	
	  _createClass(SuperVisorChatFloating, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(next_props, next_state) {
	      return false;
	    }
	  }, {
	    key: 'closeChat',
	    value: function closeChat() {
	      this.props.removeWorkAction(_constants.WORKBAR_ACTIONS.SUPERVISOR_CHAT);
	      this.props.removeWindow(_constants.DRAGGABLE_WINDOWS.SUPERVISOR_CHAT);
	      this.sharedData.setChatWindowOpen(false);
	      this.sharedData.setStateWindow(_constants.DRAGGABLE_WINDOWS.SUPERVISOR_CHAT, false);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'fullSize', onClick: function onClick() {
	            return _this2.props.goTopZ(_this2.props.id);
	          } },
	        _customComponents.CUSTOM_COMPONENTS["draggableHeader"](_ChatSVG.supervisorChatSVG, this.language.getText("GUIChatwindowTitle"), function () {
	          return _this2.closeChat();
	        }),
	        _react2.default.createElement(_ChatComponent2.default, { floating: true, objProps: this.props.objProps })
	      );
	    }
	  }]);
	
	  return SuperVisorChatFloating;
	}(_react.Component);
	
	function mapDispatchToProps(dispatch) {
	  return {
	    removeWindow: function removeWindow(iDdragComponent) {
	      dispatch((0, _A_draggable_windows_controller.removeWindow)(iDdragComponent));
	    },
	    removeWorkAction: function removeWorkAction(idRemove) {
	      dispatch((0, _A_workBar_selected.removeWorkAction)(idRemove));
	    }
	  };
	}
	exports.default = SuperVisorChatFloating = (0, _reactRedux.connect)(null, mapDispatchToProps)(SuperVisorChatFloating);

/***/ },
/* 1131 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ManualCallSVG = __webpack_require__(236);
	
	var _Images = __webpack_require__(30);
	
	var _GenericSVG = __webpack_require__(51);
	
	var _reactRedux = __webpack_require__(25);
	
	var _Singleton = __webpack_require__(21);
	
	var _A_draggable_windows_controller = __webpack_require__(55);
	
	var _constants = __webpack_require__(10);
	
	var _customComponents = __webpack_require__(59);
	
	var _lodash = __webpack_require__(293);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TemplatesWhatsapp = function (_Component) {
		_inherits(TemplatesWhatsapp, _Component);
	
		function TemplatesWhatsapp(props) {
			_classCallCheck(this, TemplatesWhatsapp);
	
			var _this = _possibleConstructorReturn(this, (TemplatesWhatsapp.__proto__ || Object.getPrototypeOf(TemplatesWhatsapp)).call(this, props));
	
			_this.language = new _Singleton.Singleton();
			_this.state = {
				searchTemplate: '',
				templatesList: _lodash2.default.get(_this.props.objProps.propsData, 'templatesList', []),
				templatesFiltered: [],
				selectedTemplate: {}
			};
			_this.loading = false;
			_this.setTemplateWhatsapp = _lodash2.default.get(_this.props.objProps, 'setTemplateWhatsapp', false);
			return _this;
		}
	
		_createClass(TemplatesWhatsapp, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.setState({ templatesFiltered: this.state.templatesList });
			}
		}, {
			key: 'onSearchTemplates',
			value: function onSearchTemplates(e) {
				this.setState({ searchTemplate: e });
				var newTemplatesList = this.state.templatesList.filter(function (template) {
					return template.TemplateName.toLowerCase().startsWith(e.toLowerCase());
				});
				this.setState({ templatesFiltered: newTemplatesList });
			}
		}, {
			key: 'onSelectTemplate',
			value: function onSelectTemplate(template) {
				this.setState({ selectedTemplate: template });
			}
		}, {
			key: 'onSubmit',
			value: function onSubmit() {
				this.setTemplateWhatsapp(this.state.selectedTemplate);
				this.props.removeWindow(_constants.DRAGGABLE_WINDOWS.TEMPLATES_WHATSAPP);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				return _react2.default.createElement(
					'div',
					{ className: 'templatesWhatsapp', onClick: function onClick() {
							return _this2.props.goTopZ(_this2.props.id);
						} },
					_customComponents.CUSTOM_COMPONENTS['draggableHeader'](_ManualCallSVG.iconList, this.language.getText('GUIManualMessagetemplates-title'), function () {
						_this2.props.removeWindow(_constants.DRAGGABLE_WINDOWS.TEMPLATES_WHATSAPP);
					}, {
						iconHeader: 'iconListHeader'
					}),
					_react2.default.createElement(
						'div',
						{ className: 'visibleWindow' },
						_react2.default.createElement(
							'div',
							{ className: 'templatesWhatsappDetail' },
							_react2.default.createElement(
								'div',
								{ className: 'templatesList' },
								_customComponents.CUSTOM_COMPONENTS['inputDelete'](this.state.searchTemplate, function (e) {
									return _this2.onSearchTemplates(e);
								}, 'searchContainer ' + (this.loading ? 'loading' : ''), 'txtSearch', 'cleanButton', _GenericSVG.closeSvg, false, _Images.search, 'iconSearch', this.language.getText('GUIManualMessagesearch-template')),
								_react2.default.createElement(
									'div',
									{ className: 'templatesListItems' },
									this.state.templatesFiltered.map(function (template) {
										return _react2.default.createElement(
											'div',
											{ className: 'templateOption ' + (_this2.state.selectedTemplate.TemplateName === template.TemplateName ? 'selected' : ''), onClick: function onClick() {
													return _this2.onSelectTemplate({ TemplateName: template.TemplateName, Body: template.Body });
												}, key: template.TemplateId },
											_react2.default.createElement(
												'p',
												{ className: 'templateOptionTitle' },
												template.TemplateName
											),
											_react2.default.createElement(
												'p',
												{ className: 'templateOptionContent' },
												template.Body
											)
										);
									})
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'templatesView' },
								_react2.default.createElement(
									'p',
									{ className: 'templatesViewTitle' },
									this.language.getText('GUIManualMessagetemplate-preview')
								),
								_react2.default.createElement(
									'div',
									{ className: 'templatesViewContainer' },
									Object.keys(this.state.selectedTemplate).length !== 0 ? _react2.default.createElement(
										'div',
										{ className: 'templateSelectedView' },
										_react2.default.createElement(
											'p',
											{ className: 'templatesViewContent' },
											this.state.selectedTemplate.Body
										)
									) : null
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'templatesWhatsappFooter' },
							_react2.default.createElement(
								'div',
								{
									className: 'setTemplateWhatsapp ' + (Object.keys(this.state.selectedTemplate).length === 0 ? 'disabled' : ''),
									onClick: function onClick() {
										return _this2.onSubmit();
									} },
								this.language.getText('GUIManualMessageselect-commit')
							)
						)
					)
				);
			}
		}]);
	
		return TemplatesWhatsapp;
	}(_react.Component);
	
	function mapDispatchToProps(dispatch) {
		return {
			insertWindow: function insertWindow(dragWindow, closeComponentIfOpen) {
				dispatch((0, _A_draggable_windows_controller.insertWindow)(dragWindow, closeComponentIfOpen));
			},
			removeWindow: function removeWindow(iDdragComponent) {
				dispatch((0, _A_draggable_windows_controller.removeWindow)(iDdragComponent));
			}
		};
	}
	exports.default = TemplatesWhatsapp = (0, _reactRedux.connect)(null, mapDispatchToProps)(TemplatesWhatsapp);

/***/ },
/* 1132 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(25);
	
	var _constants = __webpack_require__(10);
	
	var _A_messages_to_SM = __webpack_require__(32);
	
	var _A_user_states = __webpack_require__(513);
	
	var _singletonSharedData = __webpack_require__(23);
	
	var _formats = __webpack_require__(54);
	
	var _Images = __webpack_require__(30);
	
	var _reactBootstrap = __webpack_require__(73);
	
	var _Singleton = __webpack_require__(21);
	
	var _TelValidationSound = __webpack_require__(2605);
	
	var _TelValidationSound2 = _interopRequireDefault(_TelValidationSound);
	
	var _Logger = __webpack_require__(37);
	
	var _SingletonWebSocket = __webpack_require__(50);
	
	var _SingletonWebSocket2 = _interopRequireDefault(_SingletonWebSocket);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ValidatingTelephonyLocked = function (_Component) {
	  _inherits(ValidatingTelephonyLocked, _Component);
	
	  function ValidatingTelephonyLocked(props) {
	    _classCallCheck(this, ValidatingTelephonyLocked);
	
	    var _this2 = _possibleConstructorReturn(this, (ValidatingTelephonyLocked.__proto__ || Object.getPrototypeOf(ValidatingTelephonyLocked)).call(this, props));
	
	    _this2.state = {
	      time: "",
	      timeOut: false,
	      validating: false,
	      telephonyValid: false
	    };
	    _this2.timerTime = {};
	    _this2.sharedData = new _singletonSharedData.SingletonSharedData();
	    _this2.language = new _Singleton.Singleton();
	    _this2.audio = new Audio(_TelValidationSound2.default);
	    return _this2;
	  }
	
	  _createClass(ValidatingTelephonyLocked, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      clearInterval(this.timerTime);
	      this.setState({
	        timeOut: false,
	        time: nextProps.validatingTelephonyState.time
	      });
	      var _this = this;
	      var telephonyState = null;
	      switch (nextProps.validatingTelephonyState.currentState) {
	        case _constants.VALIDATING_TELEPHONY.VALIDATING:
	          this.setTimer();
	          this.setState({
	            validating: true
	          });
	          telephonyState = "Validating";
	          break;
	        case _constants.VALIDATING_TELEPHONY.VALID:
	          this.audio.play();
	          this.setState({
	            telephonyValid: true
	          });
	          nextProps.setIsLogged(true);
	          telephonyState = "Valid";
	          break;
	        case _constants.VALIDATING_TELEPHONY.ERROR:
	          this.sharedData.setLogged(false);
	          _Logger.Logger.Debug("[validatingTelephony][VALIDATING_TELEPHONY.ERROR] setLogged False");
	          nextProps.setIsLogged(false);
	          this.setState({
	            timeOut: true,
	            telephonyValid: false
	          });
	          telephonyState = "Error";
	          break;
	        default:
	          break;
	      }
	      var integrationMessage = { client: "galatea", data: telephonyState, action: "onTelephonyStatus" };
	      _SingletonWebSocket2.default.send(integrationMessage);
	    }
	  }, {
	    key: 'setTimer',
	    value: function setTimer() {
	      var _this = this;
	      this.timerTime = setInterval(timeMethod, 1000);
	      function timeMethod() {
	        _this.setState({
	          time: _this.state.time - 1
	        });
	        if (_this.state.time <= 0) {
	          clearInterval(_this.timerTime);
	          _this.setState({ timeOut: true });
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearInterval(this.timerTime);
	    }
	  }, {
	    key: 'retry',
	    value: function retry() {
	      this.props.retryFirstCall(this.sharedData.getUserData().Login, this.sharedData.getParameters().UserID);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'noAvailableLocked' },
	        _react2.default.createElement(
	          'div',
	          { className: 'validatingTelephony', style: { position: 'absolute', bottom: 'calc(50% - 115px)', right: 'calc(50% - 90px)' } },
	          _react2.default.createElement(
	            'div',
	            { className: this.state.timeOut ? "NotValidAnimation" : this.state.telephonyValid ? "ValidAnimation" : "ValidatingAnimation" },
	            _react2.default.createElement('div', { className: 'circle1' }),
	            _react2.default.createElement('div', { className: 'circle2' }),
	            _react2.default.createElement(_reactBootstrap.Image, { src: this.state.timeOut ? _Images.invalidTelephony : this.state.telephonyValid ? _Images.validTelephony : _Images.validatingTelephony,
	              className: 'animationValidating' })
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: this.state.timeOut ? "TitleNotValid" : this.state.telephonyValid ? "TitleValid" : "TitleValidating" },
	            this.state.timeOut ? this.language.getText('GUITelephonyValidatorerrorValTitle') : this.state.telephonyValid ? this.language.getText('GUITelephonyValidatorvalidTitle') : this.language.getText('GUITelephonyValidatorvalTitle')
	          ),
	          this.state.timeOut ? _react2.default.createElement('input', { className: 'buttonValidating', type: 'submit', value: this.language.getText('GUITelephonyValidatorreconnect'), onClick: function onClick() {
	              return _this3.retry();
	            } }) : this.state.telephonyValid ? "" : _react2.default.createElement(
	            'p',
	            { className: "timeValidating " + (this.state.validating ? "" : "validating") },
	            this.state.validating ? (0, _formats.secondsToFormat)(this.state.time, false) : this.language.getText('GUITelephonyValidatorwaitingTitle')
	          )
	        )
	      );
	    }
	  }]);
	
	  return ValidatingTelephonyLocked;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    validatingTelephonyState: state.validatingTelephonyState,
	    messagesIntegrations: state.messagesIntegrations
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return {
	    retryFirstCall: function retryFirstCall(userName, userID) {
	      dispatch((0, _A_messages_to_SM.retryFirstCall)(userName, userID));
	    },
	    changeState: function changeState(newState) {
	      dispatch((0, _A_user_states.changeState)(newState));
	    }
	  };
	}
	
	exports.default = ValidatingTelephonyLocked = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ValidatingTelephonyLocked);

/***/ },
/* 1133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(25);
	
	var _Images = __webpack_require__(30);
	
	var _reactBootstrap = __webpack_require__(73);
	
	var _constants = __webpack_require__(10);
	
	var _singletonSharedData = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MessageBar = function (_Component) {
	  _inherits(MessageBar, _Component);
	
	  function MessageBar(props) {
	    _classCallCheck(this, MessageBar);
	
	    var _this = _possibleConstructorReturn(this, (MessageBar.__proto__ || Object.getPrototypeOf(MessageBar)).call(this, props));
	
	    _this.changeSizeBar = function () {
	      _this.setState({ barExpanded: !_this.state.barExpanded });
	    };
	
	    _this.state = {
	      barExpanded: true,
	      showAt500: false
	    };
	    _this.resize = function () {
	      return _this.forceUpdate();
	    };
	    _this.sharedData = new _singletonSharedData.SingletonSharedData();
	    return _this;
	  }
	
	  _createClass(MessageBar, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('resize', this.resize);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.resize);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.windowVisible500.windowVisible === _constants.WINDOW_AT_500.MESSAGE) {
	        this.setState({ showAt500: true });
	      } else {
	        this.setState({ showAt500: false });
	      }
	
	      this.setState({
	        currentState: nextProps.userState.currentState
	      });
	    }
	  }, {
	    key: 'renderContractedMessages',
	    value: function renderContractedMessages() {
	      var messages = [];
	      for (var i = 0; i < 10; i++) {
	        messages.push(_react2.default.createElement(
	          'div',
	          { className: 'MessageItemSmall', key: "item" + i },
	          _react2.default.createElement('div', { className: 'NoReadBar' }),
	          _react2.default.createElement(_reactBootstrap.Image, { src: _Images.userIconMessage, className: 'userIconMessageSmall' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'TimeMessageSmall' },
	            _react2.default.createElement(
	              'p',
	              { className: 'TimeTextMessageSmall' },
	              '00:00:05'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'TypeMessageInfoSmall' },
	            _react2.default.createElement(_reactBootstrap.Image, { src: _Images.mailIconMessage, className: 'iconTypeMessageSmall' }),
	            _react2.default.createElement(_reactBootstrap.Image, { src: _Images.attachedFileMessage, className: 'iconTypeMessageSmall' }),
	            _react2.default.createElement(_reactBootstrap.Image, { src: _Images.alertIconMessage, className: 'iconTypeMessageSmall' })
	          )
	        ));
	      }
	      return messages;
	    }
	  }, {
	    key: 'renderExpandedMessages',
	    value: function renderExpandedMessages() {
	      var messages = [];
	      for (var i = 0; i < 10; i++) {
	        messages.push(_react2.default.createElement(
	          'div',
	          { className: 'MessageItem', key: "item" + i },
	          _react2.default.createElement('div', { className: 'NoReadBar' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'GralInfoMessage' },
	            _react2.default.createElement(
	              'div',
	              { className: 'GralInfoMessageContainer' },
	              _react2.default.createElement(_reactBootstrap.Image, { src: _Images.userIconMessage, className: 'userIconMessage' }),
	              _react2.default.createElement(
	                'p',
	                { className: 'userNameMessage' },
	                'Nombre de usuario 0100000000'
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'subjectMessage' },
	                'Grupo ACD 01'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'TypeMessageInfo' },
	            _react2.default.createElement(_reactBootstrap.Image, { src: _Images.mailIconMessage, className: 'iconTypeMessage' }),
	            _react2.default.createElement(_reactBootstrap.Image, { src: _Images.attachedFileMessage, className: 'iconTypeMessage' }),
	            _react2.default.createElement(_reactBootstrap.Image, { src: _Images.alertIconMessage, className: 'iconTypeMessage' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'SubjectMessage' },
	            _react2.default.createElement(
	              'p',
	              { className: 'SubjectTextMessage' },
	              'Asunto del mail...'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'TimeMessage' },
	            _react2.default.createElement(
	              'p',
	              { className: 'TimeTextMessage' },
	              '00:00:05'
	            )
	          )
	        ));
	      }
	      return messages;
	    }
	  }, {
	    key: 'classNameMB',
	    value: function classNameMB() {
	      var str = "";
	      if (this.sharedData.isInCallState(this.state.currentState)) {
	        //IS IN CALL STATE
	        str = this.state.barExpanded ? "messageBarExpanded expandenInCall" : "messageBarContracted";
	        if (this.state.showAt500) {
	          str += " showMessage500";
	        } else {
	          str += " hidenMessage500";
	        }
	      } else {
	        //NOT CALL
	        str = this.state.barExpanded ? "messageBarExpanded" : "messageBarContracted";
	        if (this.state.showAt500) {
	          str += " showMessage500";
	        } else {
	          str += " hidenMessage500";
	        }
	      }
	      return str;
	    }
	  }, {
	    key: 'renderMessages',
	    value: function renderMessages() {
	      if (this.sharedData.isInCallState(this.state.currentState)) {
	        //IS IN CALL STATE
	        if (!this.state.barExpanded || window.innerWidth < 850) {
	          return this.renderContractedMessages();
	        } else {
	          return this.renderExpandedMessages();
	        }
	      } else {
	        //NOT CALL STATE
	        if (!this.state.barExpanded) {
	          return this.renderContractedMessages();
	        } else {
	          return this.renderExpandedMessages();
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: this.classNameMB() },
	        _react2.default.createElement(
	          'div',
	          { className: 'ExpandBar', onClick: this.changeSizeBar },
	          _react2.default.createElement(_reactBootstrap.Image, { src: _Images.deploBarMessage, className: 'deployBarMessage' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'MessageArea' },
	          this.renderMessages()
	        )
	      );
	    }
	  }]);
	
	  return MessageBar;
	}(_react.Component);
	
	;
	
	function mapStateToProps(state) {
	  return {
	    userState: state.userState,
	    windowVisible500: state.windowVisible500
	  };
	}
	
	exports.default = MessageBar = (0, _reactRedux.connect)(mapStateToProps, null)(MessageBar);

/***/ },
/* 1134 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(25);
	
	var _NoAvailableSVG = __webpack_require__(114);
	
	var _cwGalateaApiJsBundle = __webpack_require__(40);
	
	var _helperMessages = __webpack_require__(87);
	
	var _customComponents = __webpack_require__(59);
	
	var _PasswordTextArea = __webpack_require__(325);
	
	var _PasswordTextArea2 = _interopRequireDefault(_PasswordTextArea);
	
	var _A_messages_to_SM = __webpack_require__(32);
	
	var _Singleton = __webpack_require__(21);
	
	var _singletonSharedData = __webpack_require__(23);
	
	var _NoAvailableRecordSingleton = __webpack_require__(327);
	
	var _A_reducer_consulting = __webpack_require__(115);
	
	var _StopWatch = __webpack_require__(495);
	
	var _StopWatch2 = _interopRequireDefault(_StopWatch);
	
	var _StopWatchCountDown = __webpack_require__(1079);
	
	var _StopWatchCountDown2 = _interopRequireDefault(_StopWatchCountDown);
	
	var _constants = __webpack_require__(10);
	
	var _SingletonWebSocket = __webpack_require__(50);
	
	var _SingletonWebSocket2 = _interopRequireDefault(_SingletonWebSocket);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _this = null;
	
	var noAvailableLocked = function (_Component) {
	  _inherits(noAvailableLocked, _Component);
	
	  function noAvailableLocked(props) {
	    _classCallCheck(this, noAvailableLocked);
	
	    var _this2 = _possibleConstructorReturn(this, (noAvailableLocked.__proto__ || Object.getPrototypeOf(noAvailableLocked)).call(this, props));
	
	    _this = _this2;
	    _this2.state = {
	      frame: 0,
	      timeNoAvailable: "",
	      requireadminPass: true,
	      incremental: false,
	      extraTime: false,
	      agentPassword: "",
	      adminPassword: "",
	      agentPassError: false,
	      adminPassError: false,
	      timeIsEnd: false,
	      noAvailableRecord: [],
	      noAvailableList: [],
	      description: ''
	    };
	    _this2.isRenderCount = false;
	    _this2.secs = 0;
	    var APIFact = new _cwGalateaApiJsBundle.APIFactory();
	    _this2.apiCont = APIFact.buildClient();
	    _this2.language = new _Singleton.Singleton();
	    _this2.sharedData = new _singletonSharedData.SingletonSharedData();
	    _this2.integrationData = null;
	    return _this2;
	  }
	
	  _createClass(noAvailableLocked, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this = this;
	      if (!(0, _NoAvailableRecordSingleton.getNoAvailableList)()) {
	        var objectResponse = this.apiCont.getObjectResponse();
	        this.apiCont.getListNoAvailable(this.sharedData.getParameters().UserID, objectResponse);
	        objectResponse.onError = function (messageError) {
	          console.warn("Error", messageError);
	        };
	        objectResponse.onSuccess = function (objResponse) {
	          (0, _NoAvailableRecordSingleton.setNoAvailableList)(objResponse.Response);
	          _this.setState({ noAvailableList: (0, _NoAvailableRecordSingleton.getNoAvailableList)() });
	        };
	      }
	      if (!(0, _NoAvailableRecordSingleton.getNoAvailableRecord)()) {
	        var _objectResponse = this.apiCont.getObjectResponse();
	        this.apiCont.getNotReadyHistory(this.sharedData.getParameters().UserID, _objectResponse);
	        _objectResponse.onError = function (messageError) {
	          console.warn("Error", messageError);
	        };
	        _objectResponse.onSuccess = function (objResponse) {
	          (0, _NoAvailableRecordSingleton.setNoAvailableRecord)(objResponse.Response);
	          _this.setState({ noAvailableRecord: (0, _NoAvailableRecordSingleton.getNoAvailableRecord)() });
	        };
	      }
	      this.agentPass = this.refs["agentPass"];
	      this.adminPass = this.refs["adminPass"];
	      this.agentPass.focus();
	      this.isRenderCount = true;
	    }
	  }, {
	    key: 'processTimer',
	    value: function processTimer(time) {
	      if (time === "00:00:00") {
	        this.setState({ timeIsEnd: true });
	      }
	    }
	  }, {
	    key: 'putStateError',
	    value: function putStateError(agentError, AdminError) {
	      this.setState({
	        agentPassError: agentError,
	        adminPassError: AdminError,
	        agentPassword: "",
	        adminPassword: ""
	      });
	      this.props.noConsultingApp();
	      this.agentPass.focus();
	    }
	  }, {
	    key: 'noStateError',
	    value: function noStateError() {
	      this.setState({
	        agentPassError: false,
	        adminPassError: false
	      });
	    }
	  }, {
	    key: 'closeLocked',
	    value: function closeLocked() {
	      var _this = this;
	      var objectResponse = this.apiCont.getObjectResponse();
	      var validationData = (0, _helperMessages.messagePassToReady)(this.state.agentPassword, this.state.adminPassword, this.state.requireadminPass);
	      this.apiCont.validateNotAvailablePassword(validationData, objectResponse);
	      objectResponse.onError = function (messageError) {
	        _this.putStateError(true, true);
	        var integrationMessage = { client: "galatea", data: messageError, action: "errorOnAvailableStatus" };
	        _SingletonWebSocket2.default.send(integrationMessage);
	      };
	      objectResponse.onSuccess = function (objResponse) {
	        if (objResponse.Response.AgentOk && (!_this.state.requireadminPass || _this.state.requireadminPass && objResponse.Response.SupervisorOk)) {
	          _this.props.messageChangeState();
	          _this.props.noConsultingApp();
	          clearInterval(_this.timerTime);
	        } else {
	          _this.putStateError(!objResponse.Response.AgentOk, !objResponse.Response.SupervisorOk);
	        }
	      };
	      _this.integrationData = null;
	    }
	  }, {
	    key: 'enterAgent',
	    value: function enterAgent() {
	      if (!this.state.requireadminPass) {
	        this.props.consultingApp();
	        this.closeLocked();
	      } else {
	        this.adminPass.focus();
	      }
	    }
	  }, {
	    key: 'focusAgent',
	    value: function focusAgent() {
	      // let _this = this;
	      // setTimeout(()=> { _this.agentPass.focus() }, 100);
	    }
	  }, {
	    key: 'getHistory',
	    value: function getHistory() {
	      var _this3 = this;
	
	      var ITEM = this.state.noAvailableRecord.filter(function (noAvailable) {
	        return noAvailable.Description === _this3.props.noAvailableState.description;
	      });
	      var ITEM2 = this.state.noAvailableList.filter(function (noAvailable) {
	        return noAvailable.Description === _this3.props.noAvailableState.description;
	      });
	      var history = "";
	      if (ITEM.length) {
	        if (ITEM[0].Total === "n") {
	          return _NoAvailableSVG.infinito;
	        } else {
	          history = ITEM[0].Count + 1 + "/" + ITEM[0].Total;
	        }
	      } else if (ITEM2.length) {
	        if (ITEM2[0].NumberOfEvents === "n") {
	          return _NoAvailableSVG.infinito;
	        } else {
	          history = "1/" + ITEM2[0].NumberOfEvents;
	        }
	      }
	      return _react2.default.createElement(
	        'p',
	        { className: 'indexNoAvailable' },
	        history
	      );
	    }
	  }, {
	    key: 'renderTimmer',
	    value: function renderTimmer() {
	      var _this4 = this;
	
	      if (!this.isRenderCount) {
	        return "00:00:00";
	      }
	      return this.state.incremental ? _react2.default.createElement(_StopWatch2.default, { onChange: function onChange() {}, isAscending: true }) : _react2.default.createElement(_StopWatchCountDown2.default, {
	        key: this.state.description,
	        onChange: function onChange(timeCounter) {
	          return _this4.processTimer(timeCounter);
	        },
	        hours: Math.floor(this.secs / 3600),
	        minutes: Math.floor(this.secs % 3600 / 60),
	        secondsInitial: Math.floor(this.secs % 3600 % 60)
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'noAvailableLocked02' },
	        _react2.default.createElement('div', { className: 'noAvailableLockedBlackContainer' }),
	        _react2.default.createElement(
	          'div',
	          { className: "noAvailableLockedContainer " + (this.state.requireadminPass && "adminPass"), style: { zIndex: this.props.style }, onClick: function onClick() {
	              return _this5.props.goTopZ(_this5.props.id);
	            } },
	          _customComponents.CUSTOM_COMPONENTS["draggableHeader"](_NoAvailableSVG.noAvailableSVG, this.language.getText('GUIDisableModetitle'), null),
	          _react2.default.createElement(
	            'div',
	            { className: 'noAvailableIcon' },
	            this.sharedData.getIconNoAvailable(this.state.frame)
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'noAvailableInfo' },
	            _react2.default.createElement(
	              'div',
	              { className: 'container20' },
	              _react2.default.createElement(
	                'div',
	                { className: 'iconNoAvailable ' + (this.state.incremental && this.state.extraTime ? "redNoAvailable" : "") },
	                this.sharedData.getIconNoAvailable(this.state.frame)
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'titleNoAvailable ' + (this.state.incremental && this.state.extraTime ? "red" : "") },
	                this.props.noAvailableState.description
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'timerNoAvailableLocked' },
	              _react2.default.createElement(
	                'p',
	                { className: 'regular52 ' + (this.state.incremental && this.state.extraTime ? "red" : "") },
	                this.renderTimmer()
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'passwordTitle noTopMargin' },
	              this.language.getText('GUIDisableModeagentPassword')
	            ),
	            _react2.default.createElement(_PasswordTextArea2.default, { ref: 'agentPass',
	              tabindex: '1',
	              value: this.state.agentPassword,
	              onChange: function onChange(text) {
	                _this5.setState({ agentPassword: text });_this5.noStateError();
	              },
	              onEnterKey: function onEnterKey() {
	                return _this5.enterAgent();
	              },
	              onBlur: function onBlur() {
	                _this5.state.requireadminPass ? _this5.adminPass.focus() : _this5.focusAgent();
	              },
	              height: 30,
	              hasError: this.state.agentPassError,
	              width: 190 }),
	            this.state.agentPassError && _react2.default.createElement(
	              'p',
	              { className: 'errorPassword' },
	              _react2.default.createElement(
	                'span',
	                { className: 'margin-right' },
	                '\u25CF'
	              ),
	              '  ',
	              this.language.getText('GUIPasswordChangeincorrectPassword')
	            ),
	            this.state.requireadminPass && _react2.default.createElement(
	              'div',
	              { className: 'noMarginPadding' },
	              _react2.default.createElement(
	                'p',
	                { className: "passwordTitle " + (this.state.agentPassError && "noTopMargin") },
	                this.language.getText('GUIDisableModesupervisorPassword')
	              ),
	              _react2.default.createElement(_PasswordTextArea2.default, { ref: 'adminPass',
	                tabindex: '2',
	                value: this.state.adminPassword,
	                onChange: function onChange(text) {
	                  _this5.setState({ adminPassword: text });_this5.noStateError();
	                },
	                onEnterKey: function onEnterKey() {
	                  return _this5.closeLocked();
	                },
	                height: 30,
	                hasError: this.state.adminPassError,
	                onBlur: function onBlur() {
	                  return _this5.focusAgent();
	                },
	                width: 190 }),
	              this.state.adminPassError && _react2.default.createElement(
	                'p',
	                { className: 'errorPassword' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'margin-right' },
	                  '\u25CF'
	                ),
	                '  ',
	                this.language.getText('GUIPasswordChangeincorrectPassword')
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'NoAvailableLockedHistory' },
	              this.getHistory()
	            )
	          )
	        )
	      );
	    }
	  }], [{
	    key: 'getDerivedStateFromProps',
	    value: function getDerivedStateFromProps(nextProps, state) {
	      if (!_this.integrationData && nextProps.messagesIntegrations && nextProps.messagesIntegrations.dataMessageIntegration && nextProps.messagesIntegrations.dataMessageIntegration.action == _constants.INTEGRATION.READY_WITH_PASSWORD) {
	        if (_this.state.requireadminPass) {
	          _this.setState({
	            adminPassword: nextProps.messagesIntegrations.dataMessageIntegration.supervisorPwd,
	            agentPassword: nextProps.messagesIntegrations.dataMessageIntegration.agentPwd,
	            agentPassError: false,
	            adminPassError: false });
	          setTimeout(function () {
	            _this.closeLocked();
	          }, 1000);
	        } else {
	          _this.setState({
	            agentPassword: nextProps.messagesIntegrations.dataMessageIntegration.agentPwd,
	            agentPassError: false,
	            adminPassError: false });
	          setTimeout(function () {
	            _this.enterAgent();
	          }, 1000);
	        }
	        _this.integrationData = nextProps.messagesIntegrations.dataMessageIntegration;
	      }
	
	      _this.secs = nextProps.noAvailableState.time < 0 ? 0 : nextProps.noAvailableState.time;
	      return {
	        description: nextProps.noAvailableState.description,
	        frame: nextProps.noAvailableState.frame,
	        requireadminPass: nextProps.noAvailableState.supervisorPass,
	        incremental: state.timeIsEnd ? state.timeIsEnd : nextProps.noAvailableState.time <= 0,
	        extraTime: nextProps.noAvailableState.time !== 0
	      };
	    }
	  }]);
	
	  return noAvailableLocked;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    noAvailableState: state.noAvailableState,
	    messagesIntegrations: state.messagesIntegrations
	  };
	}
	function mapDispatchToProps(dispatch) {
	  return {
	    messageChangeState: function messageChangeState() {
	      dispatch((0, _A_messages_to_SM.messageChangeState)());
	    },
	    consultingApp: function consultingApp() {
	      dispatch((0, _A_reducer_consulting.consultingApp)());
	    },
	    noConsultingApp: function noConsultingApp() {
	      dispatch((0, _A_reducer_consulting.noConsultingApp)());
	    }
	  };
	}
	exports.default = noAvailableLocked = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(noAvailableLocked);

/***/ },
/* 1135 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.unifiedInboxContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(25);
	
	var _singletonSharedData = __webpack_require__(23);
	
	var _A_actions_UnifiedInbox = __webpack_require__(330);
	
	var _A_messages_to_SM = __webpack_require__(32);
	
	var _cwGalateaApiJsBundle = __webpack_require__(40);
	
	var _cwUnifiedInbox = __webpack_require__(595);
	
	var _cwUnifiedInbox2 = _interopRequireDefault(_cwUnifiedInbox);
	
	var _Singleton = __webpack_require__(21);
	
	var _A_Admin_Alert_Modal = __webpack_require__(241);
	
	var _globalComponentsLibrary = __webpack_require__(28);
	
	var _constants = __webpack_require__(10);
	
	var _reducer_unified_inbox = __webpack_require__(514);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var langCatalogue = {
		0: 'es',
		1: 'en',
		2: 'pt'
	};
	
	var unifiedInboxContainer = exports.unifiedInboxContainer = function (_Component) {
		_inherits(unifiedInboxContainer, _Component);
	
		function unifiedInboxContainer(props) {
			_classCallCheck(this, unifiedInboxContainer);
	
			var _this = _possibleConstructorReturn(this, (unifiedInboxContainer.__proto__ || Object.getPrototypeOf(unifiedInboxContainer)).call(this, props));
	
			_this.getAttachments = function (campType, id) {
				var objectResponse = _this.apiCont.getObjectResponse();
				var conversation = _this.props.conversations[campType][id];
				var data = {
					ConversationId: id,
					CampType: campType,
					MultimediaType: _cwUnifiedInbox.MEDIATYPE[conversation.type],
					UserId: _this.props.userId,
					InboundId: conversation.campaign.id
				};
				_this.apiCont.getAttachments(data, objectResponse);
				objectResponse.onError = function (error) {
					console.warn(error);
				};
				objectResponse.onSuccess = function (objResponse) {
					if (objResponse.Response.isDone) {
						var environment = window.location.href.split('/')[0];
						var hostname = environment + '//' + window.location.hostname + '/EmailFiles';
						var file_path = objResponse.Response.ResultInfo.split('$domain$').join(hostname);
						var a = document.createElement('A');
						a.href = file_path;
						a.download = file_path.substr(file_path);
						a.target = '_blank';
						a.rel = 'noopener noreferrer';
						document.body.appendChild(a);
						a.click();
						document.body.removeChild(a);
					} else {
						console.log(objResponse.Response.ResultInfo);
					}
				};
			};
	
			_this.uploadAttachments = function (campType, id, fileName, file) {
				var objectResponse = _this.apiCont.getObjectResponse();
				var conversation = _this.props.conversations[campType][id];
				var data = {
					MultimediaType: _cwUnifiedInbox.MEDIATYPE[conversation.type],
					UserId: _this.props.userId,
					InboundId: conversation.campaign.id,
					ConversationId: id,
					NewFileName: fileName,
					From: conversation.contact.from,
					To: conversation.contact.to,
					ClientName: conversation.contact.name,
					MediaType: file.preview ? file.preview.type : undefined,
					CampType: campType
				};
				if (_cwUnifiedInbox.MEDIATYPE[conversation.type] === 1) {
					_this.apiCont.uploadAttachmentsChats(file.currentFile, data, objectResponse);
					objectResponse.onError = function (error) {
						console.warn(error);
					};
					objectResponse.onSuccess = function (objResponse) {
						_this.setState({ caption: [{ campType: campType, id: id, name: fileName, url: objResponse.url, type: objResponse.type }] });
						console.log(objResponse);
					};
				} else if (_cwUnifiedInbox.MEDIATYPE[conversation.type] < 4) {
					_this.apiCont.updloadAttachments(file, data, objectResponse);
					objectResponse.onError = function (error) {
						console.warn(error);
					};
					objectResponse.onSuccess = function (objResponse) {
						console.log(objResponse);
					};
				} else {
					_this.apiCont.uploadUnifiedInboxAttachments(file, data, objectResponse);
					objectResponse.onError = function (error) {
						console.warn(error);
					};
					objectResponse.onSuccess = function (objResponse) {
						var newFile = { name: fileName, url: objResponse.data.File, size: objResponse.data.FileSize, type: objResponse.type };
						_this.setState(function (prev) {
							return { caption: Array.isArray(prev.caption) ? [].concat(_toConsumableArray(prev.caption), [newFile]) : [newFile], isUploadSuccessful: true };
						});
						console.log('upload success', objResponse);
					};
				}
			};
	
			_this.onShowAlertDisconexion = function () {
				_this.setState({ isConnectionLost: true });
			};
	
			_this.onChangeNumFiles = function (numFiles) {
				_this.setState({ numFiles: numFiles });
			};
	
			_this.deleteAttachment = function (campType, id, fileName) {
				var objectResponse = _this.apiCont.getObjectResponse();
				var conversation = _this.props.conversations[campType][id];
				var data = {
					MultimediaType: _cwUnifiedInbox.MEDIATYPE[conversation.type],
					UserId: _this.props.userId,
					InboundId: conversation.campaign.id,
					ConversationId: id,
					FileName: fileName,
					CampType: campType
				};
				if (_cwUnifiedInbox.MEDIATYPE[conversation.type] < 4) _this.apiCont.deleteAttachment(data, objectResponse);else _this.apiCont.deleteUnifiedInboxAttachment(data, objectResponse);
	
				objectResponse.onError = function (error) {
					console.warn(error);
				};
				objectResponse.onSuccess = function (objResponse) {
					console.log(objResponse);
				};
			};
	
			_this.onFinishHandler = function (campType, id, isReassigned) {
				var conversation = _this.props.conversations[campType][id];
				var data = {
					MediaType: _cwUnifiedInbox.MEDIATYPE[conversation.type],
					ConversationId: id,
					MessageId: 0,
					AcdId: conversation.campaign.id,
					ShowWrapUp: isReassigned ? false : conversation.campaign.showWrapUp,
					isReassigned: isReassigned,
					isSendDouble: false,
					IsReassignedByAgent: isReassigned && isReassigned === _cwUnifiedInbox.REASSIGNED_TYPES.BY_AGENT,
					CampType: campType
				};
				if (isReassigned === "byTimeout" && campType !== _constants.CAMP_TYPES.OUT) {
					_this.setState({ isAlertUnassignConversation: true });
				}
	
				if (campType != null && (_this.state.isFinishedConversation.id !== id || _this.state.isFinishedConversation.campType !== campType)) {
					_this.setState({ isFinishedConversation: { id: conversation.id, campType: campType } });
				} else {
					data = Object.assign({}, data, { isSendDouble: true
					});
				}
				if (_cwUnifiedInbox.MEDIATYPE[conversation.type] === 1 || _cwUnifiedInbox.MEDIATYPE[conversation.type] === 5) {
					_this.props.onFinish(data);
				}
				_this.props.endConversation(data);
			};
	
			_this.onSendResponseHandler = function (_ref) {
				var camptype = _ref.camptype,
				    id = _ref.id,
				    message = _ref.message,
				    messageId = _ref.messageId,
				    subject = _ref.subject,
				    attachments = _ref.attachments,
				    addresses = _ref.addresses,
				    IsAzure = _ref.IsAzure,
				    fileType = _ref.fileType;
	
				var conversation = _this.props.conversations[camptype][id];
				var idMessage = conversation.messages.length + 1;
				var data = {
					MediaType: _cwUnifiedInbox.MEDIATYPE[conversation.type],
					ConversationId: id,
					// MessageId: 0,
					AcdId: conversation.campaign.id,
					MessageText: message,
					messageId: _cwUnifiedInbox.MEDIATYPE[conversation.type] > 4 ? idMessage : messageId,
					subject: subject,
					attachments: attachments,
					addresses: addresses,
					senderName: conversation.campaign.senderName,
					IsAzure: IsAzure,
					MessageType: fileType ? fileType : 'text',
					CamType: camptype != null ? camptype : 0
				};
				if (conversation.type === 'CHAT') {
					_this.props.appendAgentMessage({
						ServiceType: 0,
						ConversationId: id,
						Message: attachments ? attachments.Url : message,
						Type: fileType ? fileType : 'text',
						origin: 'AGENT',
						CamType: camptype != null ? camptype : 0
					});
				} else if (_cwUnifiedInbox.MEDIATYPE[conversation.type] > 3) {
					var date = new Date();
					_this.props.appendAgentExternalMessage({
						ConversationID: id,
						Origin: 2,
						Content: message,
						Date: date,
						UIMessageId: idMessage,
						MessageType: fileType ? fileType : 'text',
						statusMesage: 'sending',
						Attachments: attachments,
						CamType: camptype != null ? camptype : 0
					});
					fileType !== 'text' ? _this.setState({ caption: {} }) : null;
				}
				_this.props.onSendResponse(data);
			};
	
			_this.onSpamHandler = function () {
				if (_this.state.spamData) {
					var conversation = _this.props.conversations[_this.state.spamData.campType][_this.state.spamData.id];
					var data = void 0;
					if (conversation) {
						data = {
							conversationId: _this.state.spamData.id,
							acdID: conversation.campaign.id,
							mediaType: _cwUnifiedInbox.MEDIATYPE[conversation.type] ? _cwUnifiedInbox.MEDIATYPE[conversation.type] : 3,
							messageId: _cwUnifiedInbox.MEDIATYPE[conversation.type] === 5 ? 0 : _this.state.spamData.message,
							campType: _this.state.spamData.campType
						};
					}
					_this.props.onSpam(data);
					_this.onCancelRequest();
				}
			};
	
			_this.handlerRequest = function (campType, id, message, type) {
				var conversation = _this.props.conversations[campType][id];
	
				var mediaType = !conversation ? null : _cwUnifiedInbox.MEDIATYPE[conversation.type] ? _cwUnifiedInbox.MEDIATYPE[conversation.type] : 3;
	
				switch (type) {
					case 'unassign':
						_this.setState({ unassignData: { campType: campType, id: id, message: message }, typeModal: type });
	
						if (mediaType && (mediaType === _cwUnifiedInbox.MEDIATYPE.MAIL || mediaType === _cwUnifiedInbox.MEDIATYPE.CHAT)) {
							_this.unAssignMailHandler(conversation, mediaType, message);
						} else {
							_this.props.onShowAlertModal({
								title: _this.language.getText("GUIUnifiedInboxunassingConversationDialogTitle"),
								content: _this.language.getText("GUIUnifiedInboxunassingConversationDialogContent"),
								accept: _this.language.getText("GUIUnifiedInboxCommonunassign"),
								cancel: _this.language.getText("GUIUnifiedInboxCommoncancel"),
								onCancel: function onCancel() {
									return _this.onCancelRequest();
								},
								onAccept: function onAccept() {
									return _this.onAcceptRequest();
								}
							});
						}
						break;
					case 'spam':
						_this.setState({ spamData: { campType: campType, id: id, message: message }, typeModal: type });
						_this.props.onShowAlertModal({
							title: _this.language.getText("GUIUnifiedInboxspamConversationDialogTitle"),
							content: _this.language.getText("GUIUnifiedInboxspamConversationDialogContent"),
							accept: _this.language.getText("GUIUnifiedInboxCommonmark"),
							cancel: _this.language.getText("GUIUnifiedInboxCommoncancel"),
							onCancel: function onCancel() {
								return _this.onCancelRequest();
							},
							onAccept: function onAccept() {
								return _this.onAcceptRequest();
							}
						});
						break;
					default:
						break;
				}
			};
	
			_this.onCancelRequest = function () {
				switch (_this.state.typeModal) {
					case 'unassign':
						_this.setState({ unassignData: null, typeModal: null });
						break;
					case 'spam':
						_this.setState({ spamData: null, typeModal: null });
						break;
					default:
						break;
				}
			};
	
			_this.onAcceptRequest = function () {
				switch (_this.state.typeModal) {
					case 'unassign':
						_this.unAssignHandler();
						break;
					case 'spam':
						_this.onSpamHandler();
						break;
					default:
						break;
				}
			};
	
			_this.unAssignMailHandler = function (conversation, mediaType, message) {
				var data = void 0;
	
				data = {
					conversationId: conversation.id,
					acdID: conversation.campaign.id,
					mediaType: mediaType,
					messageId: message,
					campType: conversation.campType
				};
				conversation.campType === _cwUnifiedInbox.MEDIATYPE.CHAT && _this.onReadyHandle(conversation.campType, conversation.id);
				_this.props.onUnassign(data);
			};
	
			_this.unAssignHandler = function () {
				if (_this.state.unassignData) {
					_this.onFinishHandler(_this.state.unassignData.campType, _this.state.unassignData.id, _cwUnifiedInbox.REASSIGNED_TYPES.BY_AGENT);
					_this.onCancelRequest();
				}
			};
	
			_this.onDiscardHandler = function (campType, id, message) {
				var conversation = _this.props.conversations[campType][id];
				var data = void 0;
				if (conversation) {
					data = {
						conversationId: id,
						acdID: conversation.campaign.id,
						mediaType: _cwUnifiedInbox.MEDIATYPE[conversation.type] ? _cwUnifiedInbox.MEDIATYPE[conversation.type] : 3,
						messageId: message,
						campType: conversation.campType
					};
				}
				if (_cwUnifiedInbox.MEDIATYPE[conversation.type]) {
					_this.props.onDiscard(data);
				}
			};
	
			_this.onSelectedMessageHandler = function (campType, id) {
				if (campType != null && id) {
					var conversation = _this.props.conversations[campType][id];
					if (conversation && conversation.messages && conversation.messages.length > 0 && _cwUnifiedInbox.MEDIATYPE[conversation.type] < 4) {
						var messageId = conversation.messages[conversation.messages.length - 1].id;
						if (_cwUnifiedInbox.MEDIATYPE[conversation.type] === _cwUnifiedInbox.MEDIATYPE.MAIL) {
							var draftExists = !!_this.props.draftMessages[messageId];
							if (!draftExists) {
								_this.props.onCreateDraftMessage(messageId);
							}
						}
						var data = {
							conversationId: id,
							acdID: conversation.campaign.id,
							mediaType: _cwUnifiedInbox.MEDIATYPE[conversation.type] ? _cwUnifiedInbox.MEDIATYPE[conversation.type] : 3,
							messageId: messageId,
							campType: campType
						};
						_this.props.onSelectedMessage(data);
						_this.props.onSelect(campType, id);
						if (_cwUnifiedInbox.MEDIATYPE[conversation.type] === _cwUnifiedInbox.MEDIATYPE.CHAT) {
							_this.props.onChatConversationRead(id);
						}
					} else {
						_this.props.onSelect(campType, id);
						_this.props.onChangeStateExternalMessage({ subAction: 'CHANGE_STATE_EXTERL_MESSAGE', ConversationID: id, unreadMessage: false, campType: campType });
					}
				}
			};
	
			_this.onAceptedChatHandler = function (campType, id) {
				var conversation = _this.props.conversations[campType][id];
				var data = {
					MediaType: _cwUnifiedInbox.MEDIATYPE[conversation.type],
					ConversationId: id,
					CampType: campType,
					MessageId: 0,
					AcdId: conversation.campaign.id,
					ChatStarted: true
				};
				_this.props.onAceptedChat(data);
			};
	
			_this.onAcceptChatSaveTimeHandler = function (campType, id) {
				var conversation = _this.props.conversations[campType][id];
				var data = {
					ConversationId: id,
					CamId: conversation.campaign.id,
					CampType: campType
				};
				_this.props.onAcceptChatSaveTime(data);
			};
	
			_this.getDataToSend = function (conversation) {
				if (conversation.type === _constants.CONVERSATION_TYPES.WHATSAPP) {
					return {
						ConversationId: conversation.id,
						Tel: conversation.contact.name,
						CamiId: conversation.campaign.id,
						CamType: conversation.campType,
						onReady: false
					};
				} else {
					return {
						ConversationId: conversation.id,
						MediaType: _constants.CONVERSATION_TYPES_IDS[conversation.type],
						CamiId: conversation.campaign.id,
						CamType: conversation.campType,
						ClientAccount: conversation.contact.account,
						AllowCalls: Number(_this.generalPermissions[240])
					};
				}
			};
	
			_this.sendPackage = function (conversation) {
				var data = _this.getDataToSend(conversation);
				if (conversation.type === _constants.CONVERSATION_TYPES.WHATSAPP) {
					_this.props.onChangeState(data);
				} else {
					_this.props.onChangeStateMultimediaAll(data);
				}
			};
	
			_this.onDialogHandle = function (campType, id) {
				var conversation = _this.props.conversations[campType][id];
				_this.sendPackage(conversation);
				_this.sharedData.setSelectedConversationId(id);
			};
	
			_this.onReadyHandle = function (campType, id, deleteConvs) {
				var conversation = _this.props.conversations[campType][id];
				_this.sendPackage(conversation);
				if (deleteConvs) {
					_this.removeConvsDeleted();
				}
			};
	
			_this.removeConvsDeleted = function () {
				setTimeout(function () {
					_this.props.onUpdateConvsDeletedByError();
				}, 300);
			};
	
			_this.closeDialogHandle = function () {
				if (_this.props.convsDeletedByError && _this.props.convsDeletedByError.length > 0 && _this.props.campTypeConvsDeletedByError != null) {
					if (_this.props.campTypeConvsDeletedByError === _this.props.selected.campType && _this.props.selected.convId && _this.props.convsDeletedByError.includes(_this.props.selected.convId.toString())) {
						_this.onReadyHandle(_this.props.selected.campType, _this.props.selected.convId, true);
					} else {
						_this.removeConvsDeleted();
					}
				}
			};
	
			_this.onLoadMessagesHandler = function (campType, id) {
				var conversation = _this.props.conversations[campType][id];
				var lastConversationIndex = conversation.lastConversations.conversationsDict.findIndex(function (c) {
					return c.ConversationId === conversation.lastConversations.lastIdSearched;
				});
				var idToSearch = conversation.lastConversations.conversationsDict[lastConversationIndex].ConversationId;
				var data = {
					MediaType: _cwUnifiedInbox.MEDIATYPE[conversation.type],
					LastConversationId: idToSearch,
					ConversationId: id,
					CampType: conversation.lastConversations.lastIdCampType
				};
				_this.props.onLoadMessages(data);
				setTimeout(function () {
					_this.props.onFetchingConversation({ campType: campType, id: id, fetching: true });
				}, 500);
			};
	
			_this.onResetTimeoutHandle = function (campType, id) {
				var data = {
					conversationId: id,
					campType: campType
				};
				_this.props.onResetTimeout(data);
			};
	
			_this.onWrapUp = function (camptype, id, disposition) {
				var dispositionData = Object.assign({}, disposition, {
					id: id,
					camptype: camptype
				});
				_this.props.onWrapUp(dispositionData);
			};
	
			_this.getUploadState = function () {
				return _this.state.isUploadSuccessful;
			};
	
			_this.language = new _Singleton.Singleton();
			_this.sharedData = new _singletonSharedData.SingletonSharedData();
			_this.agentData = _this.sharedData.getUserData();
			_this.generalPermissions = _this.sharedData.getGeneralPermissions();
			_this.state = {
				id: undefined,
				caption: {},
				unassignData: null,
				spamData: null,
				typeModal: null,
				isFinishedConversation: { id: -1, campType: null },
				isAlertUnassignConversation: false,
				isConnectionLost: false,
				numFiles: 1,
				isUploadSuccessful: false
			};
			var APIFact = new _cwGalateaApiJsBundle.APIFactory();
			_this.apiCont = APIFact.buildClient();
			return _this;
		}
	
		_createClass(unifiedInboxContainer, [{
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var _props = this.props,
				    conversations = _props.conversations,
				    showWrapUp = _props.showWrapUp,
				    wrapUpTime = _props.wrapUpTime,
				    draftMessages = _props.draftMessages;
				var _agentData = this.agentData,
				    Login = _agentData.Login,
				    Nombres = _agentData.Nombres,
				    ApellidoMaterno = _agentData.ApellidoMaterno,
				    ApellidoPaterno = _agentData.ApellidoPaterno;
	
				var titleTabBar = ['Home', 'Twitter', 'Mail', 'Chat', 'WhatsApp'];
				console.log("convs", [].concat(_toConsumableArray(Object.values(conversations[0])), _toConsumableArray(Object.values(conversations[1]))));
				return _react2.default.createElement(
					'div',
					{ id: 'unifiedInboxContainer' },
					_react2.default.createElement(_cwUnifiedInbox2.default, {
						titleTabBar: titleTabBar,
						agent: { name: Nombres + ' ' + ApellidoPaterno + ' ' + ApellidoMaterno, username: Login },
						conversations: [].concat(_toConsumableArray(Object.values(conversations[0])), _toConsumableArray(Object.values(conversations[1]))),
						draftMessages: draftMessages,
						showWrapUp: showWrapUp,
						wrapUpTime: wrapUpTime,
						lang: langCatalogue[this.props.lang],
						selected: this.props.selected,
						onSelect: this.onSelectedMessageHandler,
						onFinish: this.onFinishHandler,
						onWrapUp: this.onWrapUp,
						onSpam: function onSpam(campType, id, message) {
							return _this2.handlerRequest(campType, id, message, 'spam');
						},
						onUnassign: function onUnassign(campType, id, message) {
							return _this2.handlerRequest(campType, id, message, 'unassign');
						},
						onDiscard: this.onDiscardHandler,
						onSendResponse: this.onSendResponseHandler,
						onAttachments: this.getAttachments,
						onUploadAttachments: this.uploadAttachments,
						onDeleteAttachment: this.deleteAttachment,
						onShowAlertDisconexion: this.onShowAlertDisconexion,
						onAceptedChat: this.onAceptedChatHandler,
						onDialog: this.onDialogHandle,
						onReady: this.onReadyHandle,
						setTheUrlOfAttachments: this.state.caption,
						onAcceptChatSaveTime: this.onAcceptChatSaveTimeHandler,
						onResetAgentTimeout: this.onResetTimeoutHandle,
						onLoadMessages: this.onLoadMessagesHandler,
						disabledActions: this.props.errorMCS,
						onUpdateDraftMessage: this.props.onUpdateDraftMessage,
						onUpdateDraftAttachments: this.props.onUpdateDraftAttachments,
						onDeleteDraftMessage: this.props.onDeleteDraftMessage,
						setNumFiles: this.onChangeNumFiles,
						getUploadState: this.getUploadState
					}),
					_react2.default.createElement(_globalComponentsLibrary.DialogBox, {
						title: this.language.getText(this.state.numFiles > 1 ? 'GUIAttachamentstitleToFiles' : 'GUIAttachamentstitleToFile'),
						content: this.language.getText("error-9"),
						show: this.state.isConnectionLost,
						toggle: function toggle() {
							return _this2.setState({ isConnectionLost: !_this2.state.isConnectionLost });
						},
						accept: this.language.getText('GUIErrorMessageclose')
					}),
					_react2.default.createElement(_globalComponentsLibrary.DialogBox, {
						show: this.state.isAlertUnassignConversation,
						toggle: function toggle() {
							return _this2.setState({ isAlertUnassignConversation: !_this2.state.isAlertUnassignConversation });
						},
						title: this.language.getText("GUIUnifiedInboxTitleUnassignConversation"),
						content: this.language.getText("GUIUnifiedInboxBodyUnassignConversation"),
						accept: this.language.getText("GUIUnifiedInboxAceptUnassignConversation")
					}),
					_react2.default.createElement(_globalComponentsLibrary.DialogBox, { title: this.language.getText("GUIUnifiedInboxdeleteConversationsTitle"), content: this.language.getText("GUIUnifiedInboxdeleteConversationsContent"), show: this.props.convsDeletedByError && this.props.convsDeletedByError.length > 0, onAccept: function onAccept() {
							return _this2.closeDialogHandle();
						}, accept: this.language.getText("GUIUnifiedInboxCommonclose") })
				);
			}
		}]);
	
		return unifiedInboxContainer;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
		return {
			conversations: state.unifiedInboxState.conversations,
			showWrapUp: state.unifiedInboxState.showWrapUp,
			wrapUpTime: state.unifiedInboxState.wrapUpTime,
			selected: state.unifiedInboxState.selected,
			convsDeletedByError: state.unifiedInboxState.convsDeletedByError,
			campTypeConvsDeletedByError: state.unifiedInboxState.campTypeConvsDeletedByError,
			errorMCS: state.unifiedInboxState.errorMMC,
			draftMessages: state.unifiedInboxState.draftMessages
		};
	};
	
	var mapDispatchToProps = {
		onShowAlertModal: function onShowAlertModal(payload) {
			return (0, _A_Admin_Alert_Modal.showAdminModal)(payload);
		},
		onFinish: function onFinish(data) {
			return (0, _A_messages_to_SM.endConversationChat)(data);
		},
		onAceptedChat: function onAceptedChat(data) {
			return (0, _A_messages_to_SM.aceptedChat)(data);
		},
		onSelect: function onSelect(campType, id) {
			return (0, _A_actions_UnifiedInbox.selectConversation)(campType, id);
		},
		onSpam: function onSpam(data) {
			return (0, _A_messages_to_SM.spamConversation)(data);
		},
		onWrapUp: function onWrapUp(data) {
			return (0, _A_messages_to_SM.sendDispositionOnWrapUp)(data);
		},
		onSendResponse: function onSendResponse(data) {
			return (0, _A_messages_to_SM.onSendUnifiedResponse)(data);
		},
		onSendExternalResponse: function onSendExternalResponse(data) {
			return (0, _A_messages_to_SM.onSendExternalUnifiedResponse)(data);
		},
		onUnassign: function onUnassign(data) {
			return (0, _A_messages_to_SM.unassignConversation)(data);
		},
		onDiscard: function onDiscard(data) {
			return (0, _A_messages_to_SM.discardConversation)(data);
		},
		onSelectedMessage: function onSelectedMessage(data) {
			return (0, _A_messages_to_SM.selectedMessage)(data);
		},
		appendAgentMessage: function appendAgentMessage(data, agent) {
			return (0, _A_actions_UnifiedInbox.newUnifiedInboxMessage)(data, agent);
		},
		appendAgentExternalMessage: function appendAgentExternalMessage(data) {
			return (0, _A_actions_UnifiedInbox.newUnifiedInboxExternalNewMessage)(data);
		},
		onChangeStateExternalMessage: function onChangeStateExternalMessage(data) {
			return (0, _A_actions_UnifiedInbox.changeStateExternalMessage)(data);
		},
		onChangeState: function onChangeState(data) {
			return (0, _A_messages_to_SM.changeStateMultimedia)(data);
		},
		onChangeStateMultimediaAll: function onChangeStateMultimediaAll(data) {
			return (0, _A_messages_to_SM.changeStateMultimediaAll)(data);
		},
		onUpdateConvsDeletedByError: function onUpdateConvsDeletedByError() {
			return (0, _A_actions_UnifiedInbox.updateConvsDeletedByError)();
		},
		onLoadMessages: function onLoadMessages(data) {
			return (0, _A_messages_to_SM.getMoreMessages)(data);
		},
		onAcceptChatSaveTime: function onAcceptChatSaveTime(data) {
			return (0, _A_messages_to_SM.acceptChatSaveTime)(data);
		},
		onResetTimeout: function onResetTimeout(data) {
			return (0, _A_actions_UnifiedInbox.resetTimeout)(data);
		},
		onFetchingConversation: function onFetchingConversation(data) {
			return (0, _A_actions_UnifiedInbox.fetchingConversation)(data);
		},
		onCreateDraftMessage: function onCreateDraftMessage(id) {
			return (0, _A_actions_UnifiedInbox.createDraftMessage)(id);
		},
		onUpdateDraftMessage: function onUpdateDraftMessage(id, data) {
			return (0, _A_actions_UnifiedInbox.updateDraftMessage)(id, data);
		},
		onUpdateDraftAttachments: function onUpdateDraftAttachments(id, data) {
			return (0, _A_actions_UnifiedInbox.updateDraftAttachments)(id, data);
		},
		onDeleteDraftMessage: function onDeleteDraftMessage(id) {
			return (0, _A_actions_UnifiedInbox.deleteDraftMessage)(id);
		},
		onChatConversationRead: function onChatConversationRead(campType, id) {
			return (0, _A_actions_UnifiedInbox.chatConversationRead)(campType, id);
		},
		endConversation: function endConversation(data) {
			return (0, _reducer_unified_inbox.endConversation)(data);
		}
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(unifiedInboxContainer);

/***/ },
/* 1136 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(25);
	
	var _reactBootstrap = __webpack_require__(73);
	
	var _Images = __webpack_require__(30);
	
	var _constants = __webpack_require__(10);
	
	var _Singleton = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var unifiedMessaging = function (_Component) {
	  _inherits(unifiedMessaging, _Component);
	
	  function unifiedMessaging(props) {
	    _classCallCheck(this, unifiedMessaging);
	
	    var _this = _possibleConstructorReturn(this, (unifiedMessaging.__proto__ || Object.getPrototypeOf(unifiedMessaging)).call(this, props));
	
	    _this.state = {
	      showAt500: false
	    };
	    _this.language = new _Singleton.Singleton();
	    _this.objMessages = [];
	    _this.objMessages.push({ image: _Images.all, title: _this.language.getText('multimediaModetitleAll'), number: 99 });
	    _this.objMessages.push({ image: _Images.chat, title: _this.language.getText('multimediaModechatTitle'), number: 99 });
	    _this.objMessages.push({ image: _Images.facebook, title: _this.language.getText('multimediaModefacebookTitle'), number: 99 });
	    _this.objMessages.push({ image: _Images.linkedin, title: _this.language.getText('multimediaModelinkedinTitle'), number: 99 });
	    _this.objMessages.push({ image: _Images.twitter, title: _this.language.getText('multimediaModetwitterTitle'), number: 99 });
	    _this.objMessages.push({ image: _Images.mail, title: _this.language.getText('multimediaModeemailTitle'), number: 99 });
	    return _this;
	  }
	
	  _createClass(unifiedMessaging, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.windowVisible500.windowVisible === _constants.WINDOW_AT_500.MESSAGE) {
	        this.setState({ showAt500: true });
	      } else {
	        this.setState({ showAt500: false });
	      }
	    }
	  }, {
	    key: 'renderMessagesObject',
	    value: function renderMessagesObject() {
	      var objectsMessage = [];
	      for (var i in this.objMessages) {
	        objectsMessage.push(_react2.default.createElement(
	          'div',
	          { className: 'objectsUnifiedMessage', key: "not" + i },
	          _react2.default.createElement(_reactBootstrap.Image, { className: 'imageUnifiedMessage', src: this.objMessages[i].image }),
	          _react2.default.createElement(
	            'p',
	            { className: 'titleUnifiedMessage' },
	            this.objMessages[i].title
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'numberUnifiedMessage' },
	            this.objMessages[i].number
	          )
	        ));
	      }
	      return objectsMessage;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: this.state.showAt500 ? "UnifiedMessaging showMessage500" : "UnifiedMessaging hidenMessage500" },
	        _react2.default.createElement(
	          'div',
	          { className: 'messageContainer' },
	          this.renderMessagesObject()
	        )
	      );
	    }
	  }]);
	
	  return unifiedMessaging;
	}(_react.Component);
	
	;
	
	function mapStateToProps(state) {
	  return {
	    windowVisible500: state.windowVisible500
	  };
	}
	
	exports.default = unifiedMessaging = (0, _reactRedux.connect)(mapStateToProps, null)(unifiedMessaging);

/***/ },
/* 1137 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(25);
	
	var _Images = __webpack_require__(30);
	
	var _iconUnifiedMedia = __webpack_require__(1868);
	
	var _iconUnifiedMedia2 = _interopRequireDefault(_iconUnifiedMedia);
	
	var _iconChat = __webpack_require__(1864);
	
	var _iconChat2 = _interopRequireDefault(_iconChat);
	
	var _iconHistoryNotAvailable = __webpack_require__(1865);
	
	var _iconHistoryNotAvailable2 = _interopRequireDefault(_iconHistoryNotAvailable);
	
	var _iconCallHistory = __webpack_require__(1863);
	
	var _iconCallHistory2 = _interopRequireDefault(_iconCallHistory);
	
	var _iconNotAvailable = __webpack_require__(1867);
	
	var _iconNotAvailable2 = _interopRequireDefault(_iconNotAvailable);
	
	var _iconManualDial = __webpack_require__(1866);
	
	var _iconManualDial2 = _interopRequireDefault(_iconManualDial);
	
	var _iconWhatsapp = __webpack_require__(1869);
	
	var _iconWhatsapp2 = _interopRequireDefault(_iconWhatsapp);
	
	var _iconAgentLog = __webpack_require__(1862);
	
	var _iconAgentLog2 = _interopRequireDefault(_iconAgentLog);
	
	var _constants = __webpack_require__(10);
	
	var _A_window_visible = __webpack_require__(1166);
	
	var _reactBootstrap = __webpack_require__(73);
	
	var _A_draggable_windows_controller = __webpack_require__(55);
	
	var _draggableComponents = __webpack_require__(101);
	
	var _singletonSharedData = __webpack_require__(23);
	
	var _Singleton = __webpack_require__(21);
	
	var _A_actions_UnifiedInbox = __webpack_require__(330);
	
	var _RecordCallSingleton = __webpack_require__(507);
	
	var _A_messages_to_SM = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WorkBar = function (_Component) {
	  _inherits(WorkBar, _Component);
	
	  function WorkBar(props) {
	    _classCallCheck(this, WorkBar);
	
	    var _this2 = _possibleConstructorReturn(this, (WorkBar.__proto__ || Object.getPrototypeOf(WorkBar)).call(this, props));
	
	    _initialiseProps.call(_this2);
	
	    _this2.timmerAnimationChat = null;
	    _this2.timmerShowMessage = null;
	    _this2.timmerRemoveWindow = null;
	    _this2.sharedData = new _singletonSharedData.SingletonSharedData();
	    _this2.state = {
	      showMessage: true,
	      numberChats: 0,
	      onBigAnimationChat: false
	    };
	    _this2.chatOpen = false;
	    _this2.integrationAction = null;
	    _this2.integrationData = null;
	    _this2.actionTypeIntegration = null;
	    _this2.language = new _Singleton.Singleton();
	    return _this2;
	  }
	
	  _createClass(WorkBar, [{
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps, nexState) {
	      if (nextProps.stateMachineActions.actionType === _constants.ACTIONS_FROM_SM.MESSAGE_FROM_SUPERVISOR && !this.sharedData.getChatWindowOpen() || nextProps.messagesIntegrations && nextProps.messagesIntegrations.actionType !== _constants.ACTIONS_INTEGRATION.NONE && nextProps.messagesIntegrations.dataMessageIntegration || nextProps.otherActions.action === _constants.OTHER_ACTIONS.DELETE_CHAT_NOTIFICATIONS && this.state.numberChats === 0 || this.state.numberChats !== nexState.numberChats || nextProps.showUnifiedMessages !== this.props.showUnifiedMessages || this.props.userState.currentState !== nextProps.userState.currentState || this.props.dialingMode !== nextProps.dialingMode) {
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _this3 = this;
	
	      var _this = this;
	
	      if (!this.sharedData.getChatWindowOpen() && nextProps.stateMachineActions.actionType === _constants.ACTIONS_FROM_SM.MESSAGE_FROM_SUPERVISOR) {
	        this.setState({ numberChats: ++this.state.numberChats, onBigAnimationChat: true });
	        this.timmerAnimationChat = setTimeout(function () {
	          _this3.setState({ onBigAnimationChat: false });
	        }, 1000);
	      }
	
	      this.timmerShowMessage = setTimeout(function () {
	        _this.props.visibleWindow(!_this.sharedData.isInCallState() ? _constants.WINDOW_AT_500.CALL : _constants.WINDOW_AT_500.NONE);
	        if (!_this.state.showMessage) {
	          _this.setState({ showMessage: true });
	        }
	      }, 100);
	
	      if (nextProps.messagesIntegrations && nextProps.messagesIntegrations.actionType !== _constants.ACTIONS_INTEGRATION.NONE && nextProps.messagesIntegrations.dataMessageIntegration) {
	        if (nextProps.messagesIntegrations.dataMessageIntegration.action === _constants.INTEGRATION.OPEN_WINDOW) {
	          this.actionTypeIntegration = _constants.INTEGRATION.OPEN_WINDOW;
	          this.openFromIntegration(nextProps.messagesIntegrations.dataMessageIntegration.window);
	        } else if (nextProps.messagesIntegrations.dataMessageIntegration.action === _constants.INTEGRATION.MANUAL_CALL) {
	          this.integrationData = {
	            campaingID: nextProps.messagesIntegrations.dataMessageIntegration.camId,
	            phoneNumber: nextProps.messagesIntegrations.dataMessageIntegration.phoneNumber,
	            callKey: nextProps.messagesIntegrations.dataMessageIntegration.callKey,
	            data1: nextProps.messagesIntegrations.dataMessageIntegration.clientName,
	            recievedAlert: false
	          };
	          this.actionTypeIntegration = _constants.INTEGRATION.MANUAL_CALL;
	          this.openFromIntegration(_constants.INTEGRATION.MAKE_CALL);
	        }
	      }
	      if (nextProps.otherActions.action === _constants.OTHER_ACTIONS.DELETE_CHAT_NOTIFICATIONS && nextProps.otherActions !== this.props.otherActions) {
	        this.setState({ numberChats: 0 });
	      }
	      if (nextProps.keyPressed) {
	        this.handleKeyPress(nextProps.keyPressed);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      clearTimeout(this.timmerAnimationChat);
	      clearTimeout(this.timmerShowMessage);
	      clearTimeout(this.timmerRemoveWindow);
	    }
	  }, {
	    key: "openFromIntegration",
	    value: function openFromIntegration(window) {
	      var _this4 = this;
	
	      switch (window) {
	        case "MakeCall":
	          this.sharedData.setIsIntegration();
	          var props = null;
	          if (this.integrationData) {
	            props = {
	              action: _constants.INTEGRATION.MANUAL_CALL,
	              callData: this.integrationData
	            };
	          }
	          this.manualCall(props, false);
	          break;
	        case "ManualCall":
	          this.sharedData.setIsIntegration();
	          this.manualCall(undefined, false);
	          break;
	        case "AgentChat":
	          if (this.sharedData.getWindowExpandedActive() !== _constants.DRAGGABLE_WINDOWS.SUPERVISOR_CHAT) {
	            this.agentChat();
	          } else {
	            this.agentChat();
	            setTimeout(function () {
	              _this4.agentChat();
	            }, 1);
	          }
	          break;
	        case "CallRecord":
	          this.callRecord(false);
	          break;
	        default:
	          break;
	      }
	    }
	  }, {
	    key: "expandedComponent",
	    value: function expandedComponent(tagComponent, normalAction) {
	      var _this5 = this;
	
	      if (window.innerWidth > 1300 && !this.props.previewSimultaneousRecs) {
	        if (this.sharedData.getStateWindow(tagComponent)) {
	          //ESTA ABIERTO
	          if (this.sharedData.getWindowExpandedActive() === tagComponent) {
	            //ES LA VENTANA ACTIVA, SE CIERRA
	            this.props.removeWindow(tagComponent);
	            this.sharedData.setStateWindow(tagComponent, false);
	            this.sharedData.setChatWindowOpen(false);
	          } else {
	            this.sharedData.setWindowExpandedActive(tagComponent);
	            normalAction(false);
	            this.sharedData.setStateWindow(tagComponent, true);
	          }
	        } else {
	          //SE ABRIRA LA VENTANA
	          this.sharedData.setWindowExpandedActive(tagComponent);
	          var toclose = this.sharedData.getExpandedWindowsToClose(tagComponent);
	          this.timmerRemoveWindow = setTimeout(function () {
	            _this5.props.removeWindow(toclose);
	          }, 20);
	          var _this = this;
	          toclose.forEach(function (window) {
	            _this.sharedData.setStateWindow(window, false);
	          });
	          normalAction(false);
	          this.sharedData.setStateWindow(tagComponent, true);
	        }
	      } else {
	        if (this.sharedData.getStateWindow(tagComponent)) {
	          //ESTA ABIERTA, CERRAR
	          this.props.removeWindow(tagComponent);
	          this.sharedData.setStateWindow(tagComponent, false);
	          this.sharedData.setChatWindowOpen(false);
	        } else {
	          //CERRADA, ABRIR
	          this.sharedData.setWindowExpandedActive(tagComponent);
	          normalAction(false);
	          this.sharedData.setStateWindow(tagComponent);
	        }
	      }
	    }
	  }, {
	    key: "manualCall",
	    value: function manualCall() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	      var closedIfOpen = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	      var isManualMessage = arguments[2];
	
	      this.sharedData.phoneNumber = '';
	      this.props.insertWindow((0, _draggableComponents.manualCallWindow)(props, isManualMessage), closedIfOpen);
	    }
	  }, {
	    key: "showMessageUnified",
	    value: function showMessageUnified() {
	      if (!this.sharedData.isInCallState()) {
	        if (this.state.showMessage) {
	          this.props.visibleWindow(_constants.WINDOW_AT_500.MESSAGE);
	        } else {
	          this.props.visibleWindow(_constants.WINDOW_AT_500.CALL);
	        }
	        this.setState({ showMessage: !this.state.showMessage });
	      } else {
	        this.props.visibleWindow(_constants.WINDOW_AT_500.MESSAGE);
	        this.setState({ showMessage: true });
	      }
	    }
	  }, {
	    key: "handleKeyPress",
	    value: function handleKeyPress(key) {
	      var state = this.sharedData.getCurrentState();
	      if (state !== "firstCall") {
	        switch (key) {
	          case "N": //Open unavailable window
	          case "U":
	            if (state !== "NotReady") this.expandedComponent(_constants.DRAGGABLE_WINDOWS.NO_AVAILABLE, this.normalNoAvailableAction);
	            break;
	          case "T": //Focus cursor in phone field (Manual call Window)
	          case "P":
	            if (this.sharedData.getStateWindow(_constants.DRAGGABLE_WINDOWS.MANUAL_CALL)) {
	              this.sharedData.setFocusTel(true);
	              this.manualCall(null, false);
	            }
	            break;
	          case "C":
	            //Open chat with supervisor          
	            if (state !== "NotReady") this.expandedComponent(_constants.DRAGGABLE_WINDOWS.SUPERVISOR_CHAT, this.normalAgentChatAction);
	            break;
	          case "M":
	            //Open manual call window
	            this.manualCall(null, false);
	            break;
	          case "H":
	            //Open unavailable history window
	            if (state !== "NotReady") this.expandedComponent(_constants.DRAGGABLE_WINDOWS.NO_AVAILABLE_RECORD, this.normalNoAvailableRecordAction);
	            break;
	          case "L":
	            //Open open call history window
	            this.callRecord(false);
	            break;
	          default:
	            break;
	        }
	      }
	    }
	  }, {
	    key: "downloadLogs",
	    value: function downloadLogs() {
	      var ts = new Date();
	      var logKey = "LOG-" + ts.getDate() + "-" + (ts.getMonth() + 1) + "-" + ts.getFullYear();
	      var currentLog = window.localStorage.getItem(logKey).replaceAll(';', '\n');
	      var element = document.createElement('a');
	      element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(currentLog));
	      element.setAttribute('download', logKey);
	      element.style.display = 'none';
	      document.body.appendChild(element);
	      element.click();
	      document.body.removeChild(element);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this6 = this;
	
	      var inactiveMode = this.sharedData.getIsInactiveState();
	      return _react2.default.createElement(
	        "div",
	        { className: "workBarSide" },
	        this.sharedData.generalPermissions[220] === '1' && !this.sharedData.isInCallState(this.props.userState.currentState) && _react2.default.createElement(
	          _reactBootstrap.OverlayTrigger,
	          {
	            key: "tlt-mensajeria",
	            id: "tlt-mensajeria",
	            placement: "right",
	            overlay: _react2.default.createElement(
	              _reactBootstrap.Tooltip,
	              { id: "tooltip-tlt-mensajeria", className: "workbar-tooltip show" },
	              " ",
	              this.props.showUnifiedMessages ? this.language.getText("GUIWorkBarMainMenu") : this.language.getText("GUIWorkBarMessages"),
	              " "
	            )
	          },
	          _react2.default.createElement(
	            "div",
	            { className: "buttonWorkBarContainer  " + (this.sharedData.hasUnifiedMessage ? 'newMessage ' : '') + " " + (inactiveMode ? 'disabled' : ''),
	              onClick: this.onClickbuttonWorkBarContainer
	            },
	            _react2.default.createElement("img", { src: this.props.showUnifiedMessages ? _Images.phoneIconChange : _iconUnifiedMedia2.default,
	              className: "buttonWorkBar " + (this.props.showUnifiedMessages ? 'show-phone' : 'show-media'), alt: "Mensajeria"
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.OverlayTrigger,
	          {
	            key: "tlt-chat-agente",
	            id: "tlt-chat-agente",
	            placement: "right",
	            overlay: _react2.default.createElement(
	              _reactBootstrap.Tooltip,
	              { id: "tooltip-tlt-chat-agente", className: "workbar-tooltip show" },
	              this.language.getText("GUIWorkBarAgentChat")
	            )
	          },
	          _react2.default.createElement(
	            "div",
	            { className: "buttonWorkBarContainer " + (inactiveMode ? 'disabled' : ''), onClick: this.agentChat },
	            _react2.default.createElement("img", { src: _iconChat2.default, className: "buttonWorkBar " + (this.state.onBigAnimationChat ? "bigChatanimation " : "") + (this.props.userState.currentState === _constants.USER_STATE.NO_AVAILABLE ? "onTop" : ""), alt: "Chat Agente" }),
	            this.state.numberChats > 0 && _react2.default.createElement(
	              "p",
	              { className: "numberChatNotification " + (this.state.onBigAnimationChat ? "bigChatanimation " : "") + (this.props.userState.currentState === _constants.USER_STATE.NO_AVAILABLE ? "onTop" : "") },
	              this.state.numberChats
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.OverlayTrigger,
	          {
	            key: "tlt-no-disponible",
	            id: "tlt-no-disponible",
	            placement: "right",
	            overlay: _react2.default.createElement(
	              _reactBootstrap.Tooltip,
	              { id: "tooltip-tlt-no-disponible", className: "workbar-tooltip show" },
	              this.language.getText("GUIWorkBarUnavailable")
	            )
	          },
	          _react2.default.createElement(
	            "div",
	            { className: "buttonWorkBarContainer " + (inactiveMode ? 'disabled' : ''), onClick: this.notAvailable },
	            _react2.default.createElement("img", { src: _iconNotAvailable2.default, className: "buttonWorkBar", alt: "No Disponible" })
	          )
	        ),
	        this.props.dialingMode === 0 && _react2.default.createElement(
	          _reactBootstrap.OverlayTrigger,
	          {
	            key: "tlt-marcaciones-manuales",
	            id: "tlt-marcaciones-manuales",
	            placement: "right",
	            overlay: _react2.default.createElement(
	              _reactBootstrap.Tooltip,
	              { className: "workbar-tooltip show", id: "tooltipId-tlt-marcaciones-manuales" },
	              this.language.getText("GUIWorkBarManualCall")
	            )
	          },
	          _react2.default.createElement(
	            "div",
	            { className: "buttonWorkBarContainer " + (inactiveMode ? 'disabled' : ''), onClick: function onClick() {
	                return _this6.manualCall();
	              } },
	            _react2.default.createElement("img", { src: _iconManualDial2.default, className: "buttonWorkBar " + (this.props.userState.currentState === _constants.USER_STATE.NO_AVAILABLE ? "onTop" : ""), alt: "Marcacion Manual" })
	          )
	        ),
	        this.props.dialingMode === 0 && _react2.default.createElement(
	          _reactBootstrap.OverlayTrigger,
	          {
	            key: "tlt-mensajes-manuales",
	            id: "tlt-mensajes-manuales",
	            placement: "right",
	            overlay: _react2.default.createElement(
	              _reactBootstrap.Tooltip,
	              { className: "workbar-tooltip show", id: "tooltipId-tlt-mensajes-manuales" },
	              this.language.getText("GUIWorkBarManualMessage")
	            ) //TODO: Falta poner etiqueta
	
	          },
	          _react2.default.createElement(
	            "div",
	            { className: "buttonWorkBarContainer " + (inactiveMode || this.props.userState.currentState !== _constants.USER_STATE.AGENT_READY ? 'disabled' : ''), onClick: function onClick() {
	                return _this6.manualCall(null, true, true);
	              } },
	            _react2.default.createElement("img", { src: _iconWhatsapp2.default, className: "buttonWorkBar " + (this.props.userState.currentState !== _constants.USER_STATE.AGENT_READY ? "" : "onTop"), alt: "Mensajeria Manual", width: 40 })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.OverlayTrigger,
	          {
	            key: "tlt-no-disponibles",
	            id: "tlt-no-disponibles",
	            placement: "right",
	            overlay: _react2.default.createElement(
	              _reactBootstrap.Tooltip,
	              { className: "workbar-tooltip show", id: "tooltipId-tlt-no-disponibles" },
	              this.language.getText("GUIWorkBarUnavailableHistory")
	            )
	          },
	          _react2.default.createElement(
	            "div",
	            { className: "buttonWorkBarContainer " + (inactiveMode ? 'disabled' : ''), onClick: this.notAvailableRecord },
	            _react2.default.createElement("img", { src: _iconHistoryNotAvailable2.default, className: "buttonWorkBar", alt: "Historial No Disponible" })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.OverlayTrigger,
	          {
	            key: "tlt-historial",
	            id: "tlt-historial",
	            placement: "right",
	
	            overlay: _react2.default.createElement(
	              _reactBootstrap.Tooltip,
	              { className: "workbar-tooltip show", id: "tooltipId-tlt-historial" },
	              this.language.getText("GUIWorkBarCallHistory")
	            )
	          },
	          _react2.default.createElement(
	            "div",
	            { className: "buttonWorkBarContainer " + (inactiveMode ? 'disabled' : ''), onClick: this.callRecord },
	            _react2.default.createElement("img", { src: _iconCallHistory2.default, className: "buttonWorkBar " + (this.props.userState.currentState === _constants.USER_STATE.NO_AVAILABLE ? "onTop" : ""), alt: "Historial llamadas" })
	          )
	        ),
	        this.props.enableLocalLog && _react2.default.createElement(
	          _reactBootstrap.OverlayTrigger,
	          {
	            key: "tlt-locallog",
	            id: "tlt-locallog",
	            placement: "right",
	            overlay: _react2.default.createElement(
	              _reactBootstrap.Tooltip,
	              { className: "workbar-tooltip show", id: "tooltipId-tlt-locallog" },
	              'Download local logs'
	            )
	          },
	          _react2.default.createElement(
	            "div",
	            { className: "buttonWorkBarContainer " + (inactiveMode ? 'disabled' : ''), onClick: this.downloadLogs },
	            _react2.default.createElement("img", { src: _iconAgentLog2.default, className: "buttonWorkBar", alt: "Local Logs" })
	          )
	        )
	      );
	    }
	  }]);
	
	  return WorkBar;
	}(_react.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this7 = this;
	
	  this.normalAgentChatAction = function () {
	    var closedIfOpen = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	    _this7.props.insertWindow((0, _draggableComponents.supervisorChatFloating)({ regsMultiple: _this7.props.previewSimultaneousRecs }), closedIfOpen);
	    _this7.setState({ numberChats: 0 });
	    _this7.sharedData.setChatWindowOpen(!_this7.sharedData.getChatWindowOpen());
	  };
	
	  this.normalNoAvailableAction = function () {
	    var closedIfOpen = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	    _this7.props.insertWindow((0, _draggableComponents.noAvailableFloating)({ regsMultiple: _this7.props.previewSimultaneousRecs }), closedIfOpen);
	  };
	
	  this.normalNoAvailableRecordAction = function () {
	    var closedIfOpen = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	    _this7.props.insertWindow((0, _draggableComponents.noAvailableRecordDrag)({ regsMultiple: _this7.props.previewSimultaneousRecs }), closedIfOpen);
	  };
	
	  this.agentChat = function () {
	    _this7.expandedComponent(_constants.DRAGGABLE_WINDOWS.SUPERVISOR_CHAT, function (closeIfOpen) {
	      return _this7.normalAgentChatAction(closeIfOpen);
	    });
	  };
	
	  this.notAvailable = function () {
	    _this7.expandedComponent(_constants.DRAGGABLE_WINDOWS.NO_AVAILABLE, function (closeIfOpen) {
	      return _this7.normalNoAvailableAction(closeIfOpen);
	    });
	  };
	
	  this.notAvailableRecord = function () {
	    _this7.expandedComponent(_constants.DRAGGABLE_WINDOWS.NO_AVAILABLE_RECORD, function (closeIfOpen) {
	      return _this7.normalNoAvailableRecordAction(closeIfOpen);
	    });
	  };
	
	  this.callRecord = function () {
	    var closedIfOpen = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	    var props = {
	      dragFunc: function dragFunc(dragEvent) {
	        return (0, _RecordCallSingleton.setCurrentPosition)({
	          xPosition: dragEvent.movementX,
	          yPosition: dragEvent.movementY
	        });
	      },
	      position: (0, _RecordCallSingleton.getCurrentPosition)(),
	      sizeWindow: (0, _RecordCallSingleton.getCurrentSize)(),
	      paramsCell: (0, _RecordCallSingleton.getParameters)(),
	      tableOptions: (0, _RecordCallSingleton.getTableOptions)(),
	      totalSelected: (0, _RecordCallSingleton.getTotalSelected)()
	    };
	    _this7.props.insertWindow((0, _draggableComponents.callRecord)(props), closedIfOpen);
	  };
	
	  this.onClickbuttonWorkBarContainer = function () {
	    _this7.props.showUnifiedMessages ? _this7.props.showUnifiedMessagesWindow(false) : _this7.props.showUnifiedMessagesWindow(true);
	    _this7.props.showUnifiedMessages ? _this7.sharedData.setIsTabFocused(false) : _this7.sharedData.setIsTabFocused(true);
	    if (_this7.props.userState.currentState === _constants.USER_STATE.DIALOG_WHATSAPP) {
	      var data = _this7.props.selectedData;
	      data.onReady = true;
	      _this7.props.onChangeState(data);
	    }
	    if (_this7.props.userState.currentState === _constants.USER_STATE.DIALOG_EMAIL) {
	      var _data = _this7.props.selectedData;
	      _data.onReady = true;
	      _this7.props.onChangeStateUnified(_data);
	    }
	  };
	};
	
	function mapStateToProps(state) {
	  return {
	    stateMachineActions: state.stateMachineActions,
	    userState: state.userState,
	    messagesIntegrations: state.messagesIntegrations,
	    otherActions: state.otherActions,
	    showUnifiedMessages: state.unifiedInboxState.show,
	    enableLocalLog: state.localLogState.enableLocalLog,
	    selectedData: state.unifiedInboxState.selectedData,
	    dialingMode: state.preview.dialingMode,
	    previewSimultaneousRecs: state.preview.simultaneosRecs
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return {
	    visibleWindow: function visibleWindow(windowVisible) {
	      dispatch((0, _A_window_visible.visibleWindow)(windowVisible));
	    },
	    insertWindow: function insertWindow(dragWindow, closeComponentIfOpen) {
	      dispatch((0, _A_draggable_windows_controller.insertWindow)(dragWindow, closeComponentIfOpen));
	    },
	    removeWindow: function removeWindow(iDdragComponents) {
	      dispatch((0, _A_draggable_windows_controller.removeWindow)(iDdragComponents));
	    },
	    showUnifiedMessagesWindow: function showUnifiedMessagesWindow(show) {
	      dispatch((0, _A_actions_UnifiedInbox.showUnifiedMessagesWindow)(show));
	    },
	    onChangeState: function onChangeState(data) {
	      dispatch((0, _A_messages_to_SM.changeStateMultimedia)(data));
	    },
	    onChangeStateUnified: function onChangeStateUnified(data) {
	      dispatch((0, _A_messages_to_SM.changeStateMultimediaAll)(data));
	    }
	  };
	}
	
	exports.default = WorkBar = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(WorkBar);

/***/ },
/* 1138 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(10);
	
	var _ExpandedComponents = __webpack_require__(506);
	
	var _singletonSharedData = __webpack_require__(23);
	
	var _reactRedux = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WorkBarExpanded = function (_Component) {
	  _inherits(WorkBarExpanded, _Component);
	
	  function WorkBarExpanded(props) {
	    var _this$windows;
	
	    _classCallCheck(this, WorkBarExpanded);
	
	    var _this = _possibleConstructorReturn(this, (WorkBarExpanded.__proto__ || Object.getPrototypeOf(WorkBarExpanded)).call(this, props));
	
	    _this.state = {
	      expandedComponent: null,
	      barExpandedClass: "WBExpanded",
	      arrayComponents: []
	    };
	    _this.windows = (_this$windows = {}, _defineProperty(_this$windows, _constants.DRAGGABLE_WINDOWS.SUPERVISOR_CHAT, (0, _ExpandedComponents.supervisorChatExpanded)(null)), _defineProperty(_this$windows, _constants.DRAGGABLE_WINDOWS.NO_AVAILABLE, (0, _ExpandedComponents.noAvailableExpanded)(null)), _defineProperty(_this$windows, _constants.DRAGGABLE_WINDOWS.NO_AVAILABLE_RECORD, (0, _ExpandedComponents.noAvailableRecordExpanded)(null)), _this$windows);
	    _this.sharedData = new _singletonSharedData.SingletonSharedData();
	    return _this;
	  }
	
	  _createClass(WorkBarExpanded, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      var arrayComponents = [];
	      for (var comp in nextProps.windowsOpened) {
	        if (this.windows[nextProps.windowsOpened[comp].idComponent]) {
	          arrayComponents.push(nextProps.windowsOpened[comp]);
	        }
	      }
	
	      if (arrayComponents.length > 0) {
	        if (!nextProps.simultaneosRecs) {
	          this.setState({ barExpandedClass: "WBExpanded isShowed" });
	        } else {
	          this.setState({ barExpandedClass: "WBExpanded simultaneosRecs" });
	        }
	
	        var found = arrayComponents.filter(function (element) {
	          return element.idComponent === _this2.sharedData.getWindowExpandedActive();
	        })[0];
	        if (typeof found === "undefined") {
	          this.sharedData.setWindowExpandedActive(arrayComponents[0].idComponent);
	        }
	        this.setState({ arrayComponents: arrayComponents });
	      } else {
	        this.sharedData.setWindowExpandedActive(_constants.DRAGGABLE_WINDOWS.NONE);
	        this.setState({ barExpandedClass: "WBExpanded", arrayComponents: [] });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: this.state.barExpandedClass },
	        this.state.arrayComponents.map(function (item, i) {
	          return _this3.windows[item.idComponent].component;
	        })
	      );
	    }
	  }]);
	
	  return WorkBarExpanded;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    simultaneosRecs: state.preview.simultaneosRecs
	  };
	}
	
	exports.default = WorkBarExpanded = (0, _reactRedux.connect)(mapStateToProps, null)(WorkBarExpanded);

/***/ },
/* 1139 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(25);
	
	var _workBar = __webpack_require__(1137);
	
	var _workBar2 = _interopRequireDefault(_workBar);
	
	var _workBarExpanded = __webpack_require__(1138);
	
	var _workBarExpanded2 = _interopRequireDefault(_workBarExpanded);
	
	var _unifiedMessaging = __webpack_require__(1136);
	
	var _unifiedMessaging2 = _interopRequireDefault(_unifiedMessaging);
	
	var _messageBar = __webpack_require__(1133);
	
	var _messageBar2 = _interopRequireDefault(_messageBar);
	
	var _unifiedInboxContainer = __webpack_require__(1135);
	
	var _unifiedInboxContainer2 = _interopRequireDefault(_unifiedInboxContainer);
	
	var _callSpace = __webpack_require__(1114);
	
	var _callSpace2 = _interopRequireDefault(_callSpace);
	
	var _cwGalateaApiJsBundle = __webpack_require__(40);
	
	var _constants = __webpack_require__(10);
	
	var _validatingTelephony = __webpack_require__(1132);
	
	var _validatingTelephony2 = _interopRequireDefault(_validatingTelephony);
	
	var _singletonSharedData = __webpack_require__(23);
	
	var _A_blocking_panel = __webpack_require__(1160);
	
	var _A_reducer_consulting = __webpack_require__(115);
	
	var _agentState = __webpack_require__(1113);
	
	var _agentState2 = _interopRequireDefault(_agentState);
	
	var _constants2 = __webpack_require__(10);
	
	var _TimerCountDown = __webpack_require__(326);
	
	var _TimerCountDown2 = _interopRequireDefault(_TimerCountDown);
	
	var _Singleton = __webpack_require__(21);
	
	var _SingletonWebSocket = __webpack_require__(50);
	
	var _SingletonWebSocket2 = _interopRequireDefault(_SingletonWebSocket);
	
	var _OngoingCallIvrModal = __webpack_require__(1127);
	
	var _OngoingCallIvrModal2 = _interopRequireDefault(_OngoingCallIvrModal);
	
	var _Logger = __webpack_require__(37);
	
	var _A_messages_to_SM = __webpack_require__(32);
	
	var _A_Alert_Modal = __webpack_require__(63);
	
	var _A_Alert_Modal2 = _interopRequireDefault(_A_Alert_Modal);
	
	var _A_user_actions = __webpack_require__(194);
	
	var _CallWindowPreview = __webpack_require__(1088);
	
	var _CallWindowPreview2 = _interopRequireDefault(_CallWindowPreview);
	
	var _CallOutContainer = __webpack_require__(494);
	
	var _CallOutContainer2 = _interopRequireDefault(_CallOutContainer);
	
	var _A_preview = __webpack_require__(52);
	
	var _formats = __webpack_require__(54);
	
	var _reducer_psw_reset = __webpack_require__(336);
	
	var _BlockingPanel = __webpack_require__(1095);
	
	var _BlockingPanel2 = _interopRequireDefault(_BlockingPanel);
	
	var _AlertsContainerMessage = __webpack_require__(1067);
	
	var _AlertsContainerMessage2 = _interopRequireDefault(_AlertsContainerMessage);
	
	var _globalComponentsLibrary = __webpack_require__(28);
	
	var _iconWarning = __webpack_require__(1827);
	
	var _iconWarning2 = _interopRequireDefault(_iconWarning);
	
	var _ChangeTypeCampaign = __webpack_require__(323);
	
	var _ChangeTypeCampaign2 = _interopRequireDefault(_ChangeTypeCampaign);
	
	var _A_preview_transfer = __webpack_require__(193);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//FLOATING WINDOWS
	
	
	//Connection Alert
	
	
	var workSpace = function (_Component) {
	  _inherits(workSpace, _Component);
	
	  function workSpace(props) {
	    var _propsDraggables, _zIndexDraggableWindo, _this$alertStatregies, _this$removeAlertStra;
	
	    _classCallCheck(this, workSpace);
	
	    var _this = _possibleConstructorReturn(this, (workSpace.__proto__ || Object.getPrototypeOf(workSpace)).call(this, props));
	
	    _this.setIsLogged = function (isLogged) {
	      _this.setState({ isLogged: isLogged });
	    };
	
	    _this.isPressedUp = function (event) {
	      if (event.ctrlKey && event.altKey) {
	        _this.setState({ keyPressed: event.key.toUpperCase() });
	      }
	    };
	
	    _this.actionPrevRecord = function (opc) {
	      _this.props.actionPreviewRecord(opc);
	    };
	
	    _this.getMsgAlert = function () {
	      var objMsg = {
	        id: 'alert',
	        icon: 'call-out',
	        msg: _this.state.alertMessage.Message
	      };
	      return objMsg;
	    };
	
	    _this.fillAlertPreviewModal = function () {
	      var record = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      _this.props.showAlertModal({
	        type: "ModalAlert",
	        title: _this.language.getText('GUIAlertMessagedeletePreviewRecord'),
	        message: _this.language.getText('GUIAlertMessagemsgDeletePreviewRecord'),
	        button: _this.language.getText('GUIPreviewdelete'),
	        secondButton: _this.language.getText('GUIAlertMessagecancel'),
	        buttonFun: function buttonFun() {
	          return _this.setObjTimePreview();
	        }
	      });
	    };
	
	    _this.fillAlertPasswordExpiredModal = function () {
	      _this.props.showAlertModal({
	        type: "ModalAlert",
	        title: _this.language.getText('GUIErrorMessagetitle'),
	        message: _this.language.getText('GUIPasswordResetpswErrorBody'),
	        button: _this.language.getText('GUIPasswordResetchangePsw'),
	        secondButton: _this.language.getText('GUIPasswordResetclose'),
	        secondButtonFtn: function secondButtonFtn() {
	          return _this.setState({ showAlertPasswordExpired: false });
	        },
	        buttonFun: function buttonFun() {
	          return _this.openWindowToChangePsw();
	        }
	      });
	    };
	
	    _this.setObjTimePreview = function () {
	      var time = (0, _formats.getCurrentTimeInSec)();
	      var previewTime = time - _this.props.preview.initialTimeSec + _this.props.preview.totalPreviewTime;
	      _this.actionPrevRecord({ process: 1, camId: _this.props.preview.camId, callOutId: _this.props.preview.callOutId, previewTime: previewTime, callId: 0 });
	    };
	
	    _this.openWindowToChangePsw = function () {
	      _this.setState({ showAlertPasswordExpired: false });
	      _this.props.setShowPswResetAlert(true);
	    };
	
	    _this.sharedData = new _singletonSharedData.SingletonSharedData();
	    _this.state = {
	      isLogged: false,
	      typeBar: _constants.WORKBAR_ACTIONS.NONE,
	      agentState500: true,
	      draggableComponentList: [],
	      alert: _this.props.alert,
	      actionAlert: '',
	      closeWindow: '',
	      newAlertCode: 0,
	      newAlertMessage: null,
	      hasUnifiedMessage: false,
	      showCallWindowPreview: false,
	      showAlertPasswordExpired: _this.sharedData.getParameters().PswResetRequired,
	      propsDraggables: (_propsDraggables = {}, _defineProperty(_propsDraggables, _constants2.DRAGGABLE_WINDOWS.MANUAL_CALL, null), _defineProperty(_propsDraggables, _constants2.DRAGGABLE_WINDOWS.TRANSFER_CALL, null), _defineProperty(_propsDraggables, _constants2.DRAGGABLE_WINDOWS.DTMF_TONES, null), _defineProperty(_propsDraggables, _constants2.DRAGGABLE_WINDOWS.CALL_RECORD, null), _defineProperty(_propsDraggables, _constants2.DRAGGABLE_WINDOWS.MARK_CALL, null), _defineProperty(_propsDraggables, _constants2.DRAGGABLE_WINDOWS.NO_AVAILABLE_LOCKED, null), _defineProperty(_propsDraggables, _constants2.DRAGGABLE_WINDOWS.SUPERVISOR_CHAT, null), _defineProperty(_propsDraggables, _constants2.DRAGGABLE_WINDOWS.NO_AVAILABLE, null), _defineProperty(_propsDraggables, _constants2.DRAGGABLE_WINDOWS.NO_AVAILABLE_RECORD, null), _defineProperty(_propsDraggables, _constants2.DRAGGABLE_WINDOWS.ONGOING_CALL_IVR, 200), _propsDraggables),
	      zIndexDraggableWindows: (_zIndexDraggableWindo = {}, _defineProperty(_zIndexDraggableWindo, _constants2.DRAGGABLE_WINDOWS.MANUAL_CALL, 200), _defineProperty(_zIndexDraggableWindo, _constants2.DRAGGABLE_WINDOWS.TRANSFER_CALL, 200), _defineProperty(_zIndexDraggableWindo, _constants2.DRAGGABLE_WINDOWS.DTMF_TONES, 200), _defineProperty(_zIndexDraggableWindo, _constants2.DRAGGABLE_WINDOWS.CALL_RECORD, 200), _defineProperty(_zIndexDraggableWindo, _constants2.DRAGGABLE_WINDOWS.MARK_CALL, 200), _defineProperty(_zIndexDraggableWindo, _constants2.DRAGGABLE_WINDOWS.NO_AVAILABLE_LOCKED, 200), _defineProperty(_zIndexDraggableWindo, _constants2.DRAGGABLE_WINDOWS.SUPERVISOR_CHAT, 200), _defineProperty(_zIndexDraggableWindo, _constants2.DRAGGABLE_WINDOWS.NO_AVAILABLE, 200), _defineProperty(_zIndexDraggableWindo, _constants2.DRAGGABLE_WINDOWS.NO_AVAILABLE_RECORD, 200), _defineProperty(_zIndexDraggableWindo, _constants2.DRAGGABLE_WINDOWS.ONGOING_CALL_IVR, 200), _zIndexDraggableWindo),
	      alertConnection: false,
	      time: null
	    };
	    _this.userState = _this.props.userState.currentState;
	    var APIFact = new _cwGalateaApiJsBundle.APIFactory();
	    _this.apiCont = APIFact.buildClient();
	    _this.language = new _Singleton.Singleton();
	    _this.shortcut = [];
	    _this.alertStatregies = (_this$alertStatregies = {}, _defineProperty(_this$alertStatregies, _constants.ALERTS_SHOWED_CODE.REPROGRAM_CALL_DIALOG, function () {
	      return _this.setState({ actionAlert: _constants.ALERTS_SHOWED.INSERT_CALL_ALERT });
	    }), _defineProperty(_this$alertStatregies, _constants.ALERTS_SHOWED_CODE.REPROGRAM_CALL_NA, function () {
	      return _this.setState({ actionAlert: _constants.ALERTS_SHOWED.INSERT_CALL_ALERT });
	    }), _defineProperty(_this$alertStatregies, _constants.ALERTS_SHOWED_CODE.REPROGRAM_NA_STATE, function () {
	      return _this.setState({ actionAlert: _constants.ALERTS_SHOWED.INSERT_NO_AVAILABLE_ALERT });
	    }), _defineProperty(_this$alertStatregies, _constants.ALERTS_SHOWED_CODE.VOLUMEN_DISABLED, function () {
	      return _this.setState({ actionAlert: _constants.ALERTS_SHOWED.INSERT_VOLUME_ALERT });
	    }), _defineProperty(_this$alertStatregies, _constants.ALERTS_SHOWED_CODE.READY_PREVIEW_MODE, function () {
	      return _this.setState({ actionAlert: _constants.ALERTS_SHOWED.INSERT_PREVIEW_MODE_ALERT });
	    }), _this$alertStatregies);
	
	    _this.removeAlertStrategies = (_this$removeAlertStra = {}, _defineProperty(_this$removeAlertStra, _constants.ALERTS_SHOWED_CODE.REPROGRAM_CALL_DIALOG, function () {
	      return _this.cancelManualCallReprogramed();
	    }), _defineProperty(_this$removeAlertStra, _constants.ALERTS_SHOWED_CODE.REPROGRAM_CALL_NA, function () {
	      return _this.cancelManualCallReprogramed();
	    }), _this$removeAlertStra);
	    _this.tmpStramLevel = 0;
	    _this.messageConnection = '';
	    _this.suspendMonitoring = false;
	    _this.timerActive = false;
	    //Si no encuentra los parametros en el manifest.json asigna valores por default
	    _this.networkMonitoring = _this.props.networkMonitoring ? _this.props.networkMonitoring : {
	      "active": false,
	      "autoHide": 3000,
	      "suspendMonitoring": 7000,
	      "SndSuspendMonitoring": 10000
	    };
	    return _this;
	  }
	
	  _createClass(workSpace, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.setState({ hasUnifiedMessage: this.sharedData.hasUnifiedMessage });
	      window.addEventListener('beforeunload', function () {
	        _this2.props.logout();
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var prop = this.state.propsDraggables;
	      this.manageDragWindows(nextProps.dragWindowController);
	      this.setState({
	        agentState500: nextProps.windowVisible500.windowVisible === _constants.WINDOW_AT_500.NONE,
	        newAlertMessage: nextProps.newAlertMessage,
	        keyPressed: ''
	      });
	      this.userState = nextProps.userState.currentState;
	      if (this.alertStatregies[nextProps.newAlertCode]) {
	        this.alertStatregies[nextProps.newAlertCode]();
	      }
	      if (nextProps.alert) {
	        if (_constants2.BLOCKING_ALERTS[nextProps.alert.code]) {
	          this.setState({ alert: nextProps.alert });
	          this.props.moveBlockingPanel(350);
	        } else {
	          prop[_constants2.DRAGGABLE_WINDOWS[nextProps.alert.module]] = { alertCode: nextProps.alert.code, message: nextProps.alert.message };
	          this.setState({ propsDraggables: prop });
	          if (this.alertStatregies[nextProps.alert.code]) {
	            this.alertStatregies[nextProps.alert.code]();
	          }
	        }
	      } else {
	        prop[_constants2.DRAGGABLE_WINDOWS.MANUAL_CALL] = null;
	        prop[_constants2.DRAGGABLE_WINDOWS.TRANSFER_CALL] = null;
	        this.setState({ propsDraggables: prop });
	      }
	      if (nextProps.messagesIntegrations !== this.props.messagesIntegrations) {
	        if (nextProps.messagesIntegrations.dataMessageIntegration && nextProps.messagesIntegrations.dataMessageIntegration.action === _constants2.INTEGRATION.GET_TRANSFER_DATA) {
	          if (this.sharedData.isInCallState(this.userState)) {
	            var objectResponseTransfer = this.apiCont.getObjectResponse();
	            var userId = this.sharedData.getParameters().UserID;
	            var acdId = this.props.dataCall.CallType === 1 ? this.props.dataCall.Id : 0; //filtro para el caso si es una llamda de entrada no puede transferir al mismo acd
	            this.apiCont.transferCall(userId, acdId, objectResponseTransfer);
	            objectResponseTransfer.onError = function (messageError) {
	              _Logger.Logger.Error('[WorkSpace][TransferCall] Error consulting DataBase ', messageError);
	            };
	            objectResponseTransfer.onSuccess = function (objResponse) {
	              _Logger.Logger.Trace("[WorkSpace][TransferCall] Receiving transfer options ", objResponse.Response);
	              var data = [objResponse.AcdList, objResponse.TelefonosList, objResponse.AgentesList];
	              var message = { client: "galatea", data: data, action: "TransferOption", subaction: "getTransferOptions" };
	              _SingletonWebSocket2.default.send(message);
	            };
	          }
	        }
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.state.actionAlert !== '') {
	        this.setState({ actionAlert: '' });
	      }
	    }
	  }, {
	    key: 'manageDragWindows',
	    value: function manageDragWindows(dragWindowComponent) {
	      var arrayDrags = this.state.draggableComponentList;
	      if (dragWindowComponent.actionType === _constants.DRAGGABLE_WINDOWS_ACTIONS.INSERT_WINDOW) {
	        var arrayComponent = arrayDrags.filter(function (e) {
	          return e.idComponent === dragWindowComponent.dragComponent.idComponent;
	        });
	        if (arrayComponent.length === 0) {
	          arrayDrags.push(dragWindowComponent.dragComponent);
	        } else {
	          if (dragWindowComponent.closeIfOpen) {
	            arrayDrags = arrayDrags.filter(function (e) {
	              return e.idComponent !== dragWindowComponent.dragComponent.idComponent;
	            });
	          }
	        }
	        this.setState({
	          draggableComponentList: arrayDrags,
	          closeWindow: ''
	        });
	
	        this.sendToTop(dragWindowComponent.dragComponent.idComponent);
	      }
	      if (dragWindowComponent.actionType === _constants.DRAGGABLE_WINDOWS_ACTIONS.REMOVE_WINDOW) {
	        if (typeof dragWindowComponent.idDragComponents !== 'undefined' && dragWindowComponent.idDragComponents.length > 0 && dragWindowComponent.idDragComponents !== 'null') {
	          dragWindowComponent.idDragComponents.forEach(function (entry) {
	            arrayDrags = arrayDrags.filter(function (e) {
	              return e.idComponent !== entry;
	            });
	          });
	        }
	        this.setState({
	          draggableComponentList: arrayDrags,
	          closeWindow: dragWindowComponent.idDragComponents[0]
	        });
	      }
	    }
	  }, {
	    key: 'classNameAgent500',
	    value: function classNameAgent500() {
	      var str = 'agentStateDraggable showAt500';
	      if (this.state.agentState500) {
	        str += ' showAgentState500';
	      } else {
	        str += ' hideAgentState500';
	      }
	      return str;
	    }
	  }, {
	    key: 'onYes',
	    value: function onYes() {
	      this.props.moveBlockingPanel(-1);
	      if (this.alertStatregies[this.state.alert.code]) {
	        this.alertStatregies[this.state.alert.code]();
	      }
	      this.setState({ alert: null });
	    }
	  }, {
	    key: 'onNo',
	    value: function onNo() {
	      this.props.moveBlockingPanel(-1);
	      this.setState({ alert: null });
	      if (this.removeAlertStrategies[this.state.alert.code]) {
	        this.removeAlertStrategies[this.state.alert.code]();
	      }
	    }
	  }, {
	    key: 'cancelManualCallReprogramed',
	    value: function cancelManualCallReprogramed() {
	      _Logger.Logger.Trace('[WorkSpace][cancelManualCallReprogramed] Cancel manual call reprogramed');
	      var data = {
	        CamId: 0,
	        CallKey: '',
	        Phone: '',
	        Data: '',
	        ExistsCallout: 0,
	        CallMode: 0
	      };
	      this.props.manualCall(data);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.sharedData.setLogged(false);
	      _Logger.Logger.Debug('[WorkSpace][componentWillUnmount] setLogged False');
	    }
	  }, {
	    key: 'alertVolumeWebRTC',
	    value: function alertVolumeWebRTC() {
	      this.alertStatregies[_constants.ALERTS_SHOWED_CODE.VOLUMEN_DISABLED]();
	    }
	  }, {
	    key: 'getTagWaiting',
	    value: function getTagWaiting() {
	      if (this.userState === _constants.USER_STATE.INACTIVE) return this.language.getText('GUIAlertMessageinactiveMode');else if (this.userState === _constants.USER_STATE.READY_PREVIEW) return this.language.getText('CallControlGUICallIOStatusgettingRegisters');else return this.language.getText('CallControlGUICallIOStatusgettingCall');
	    }
	  }, {
	    key: 'renderCallSpace',
	    value: function renderCallSpace() {
	      var _this3 = this;
	
	      var showCallWindowPreview = (this.userState === _constants.USER_STATE.AGENT_PREVIEW || this.userState === _constants.USER_STATE.CALL_OUT) && this.props.preview.isSetPreviewRecord;
	      var showCallWindowSimultaneousPreview = this.props.preview.simultaneosRecs && this.props.preview.isSetPreviewRecord && this.userState !== _constants.USER_STATE.READY_PREVIEW && this.userState && _constants.USER_STATE.AGENT_READY && this.userState !== _constants.USER_STATE.INACTIVE;
	      if (this.sharedData.isInCallState(this.userState) && this.props.userState.prevState !== _constants.USER_STATE.DIALOG_EMAIL && this.props.userState.prevState !== _constants.USER_STATE.DIALOG_WHATSAPP && this.props.userState.prevState !== _constants.USER_STATE.CHATTING && !this.props.preview.simultaneosRecs) {
	        return _react2.default.createElement(_callSpace2.default, {
	          onCloseWindow: this.state.closeWindow,
	          currentState: this.userState,
	          dataCall: this.props.dataCall,
	          extraDataCall: this.props.extraDataCall,
	          alertVolume: function alertVolume(e) {
	            return _this3.alertVolumeWebRTC();
	          },
	          actionPrevRecord: this.actionPrevRecord
	        });
	      }
	      if (showCallWindowPreview || showCallWindowSimultaneousPreview) {
	        return _react2.default.createElement(_CallWindowPreview2.default, {
	          fillAlertPreviewModal: this.fillAlertPreviewModal,
	          userState: this.userState,
	          dataCall: this.props.dataCall
	        });
	      }
	
	      if (this.userState === _constants.USER_STATE.XFER) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'XferContainer' },
	          _react2.default.createElement(
	            'div',
	            { className: 'XferTimer' },
	            _react2.default.createElement(
	              'p',
	              { className: 'XferPhrase' },
	              this.language.getText('CallControlGUICallIOStatusmanualCall')
	            ),
	            _react2.default.createElement(_TimerCountDown2.default, { showingTimer: true, timeToRate: this.sharedData.getXferTime() + 1, lineWidth: 9, colorDown: '#007FFF', colorUp: '#033D76', size: 100, fontsize: 'two' })
	          )
	        );
	      }
	
	      if (this.props.showUnifiedMessages && this.sharedData.generalPermissions[220] === '1') {
	        return _react2.default.createElement(_unifiedInboxContainer2.default, { lang: this.sharedData.generalPermissions[27], userId: this.sharedData.user.User_id });
	      }
	
	      if (this.props.allowChangeDialing && this.sharedData.getDataPreviewPro().dialingMode && _constants.STATES_TO_SHOW_CTC.includes(this.userState)) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'waitingCallText ' + (this.props.allowChangeDialing ? 'changeCampaign' : '') },
	          _react2.default.createElement(
	            'div',
	            { className: 'container__changeCampaign' },
	            _react2.default.createElement(
	              'p',
	              { className: 'changeCampaign__p' },
	              this.language.getText('GUIPreviewselectCampaign')
	            ),
	            _react2.default.createElement(_ChangeTypeCampaign2.default, null)
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'waitingCallTextInfo' },
	            this.getTagWaiting()
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'waitingCallText' },
	        _react2.default.createElement(
	          'p',
	          { className: 'waitingCallTextInfo' },
	          this.getTagWaiting()
	        )
	      );
	    }
	  }, {
	    key: 'sendToTop',
	    value: function sendToTop(componentToTop) {
	      if (this.state.zIndexDraggableWindows[componentToTop] !== 300) {
	        var _initialValue;
	
	        var initialValue = (_initialValue = {}, _defineProperty(_initialValue, _constants2.DRAGGABLE_WINDOWS.MANUAL_CALL, 200), _defineProperty(_initialValue, _constants2.DRAGGABLE_WINDOWS.TRANSFER_CALL, 200), _defineProperty(_initialValue, _constants2.DRAGGABLE_WINDOWS.DTMF_TONES, 200), _defineProperty(_initialValue, _constants2.DRAGGABLE_WINDOWS.CALL_RECORD, 200), _defineProperty(_initialValue, _constants2.DRAGGABLE_WINDOWS.MARK_CALL, 200), _defineProperty(_initialValue, _constants2.DRAGGABLE_WINDOWS.NO_AVAILABLE_LOCKED, 200), _defineProperty(_initialValue, _constants2.DRAGGABLE_WINDOWS.SUPERVISOR_CHAT, 200), _defineProperty(_initialValue, _constants2.DRAGGABLE_WINDOWS.NO_AVAILABLE, 200), _defineProperty(_initialValue, _constants2.DRAGGABLE_WINDOWS.NO_AVAILABLE_RECORD, 200), _defineProperty(_initialValue, _constants2.DRAGGABLE_WINDOWS.ONGOING_CALL_IVR, 200), _initialValue);
	
	        initialValue[componentToTop] = 300;
	        this.setState({ zIndexDraggableWindows: initialValue });
	      }
	    }
	  }, {
	    key: 'onStreamAlert',
	    value: function onStreamAlert(streamLevel) {
	      if (this.networkMonitoring.active && !this.suspendMonitoring && !this.timerActive) {
	        if (this.tmpStramLevel !== streamLevel) {
	          this.tmpStramLevel = streamLevel;
	        }
	        if (this.tmpStramLevel > 1 && !this.state.alertConnection) {
	          this.autoHide(this.networkMonitoring.autoHide, this.networkMonitoring.suspendMonitoring);
	        }
	        this.messageAlert(streamLevel);
	      }
	    }
	  }, {
	    key: 'autoHide',
	    value: function autoHide(_autoHide, suspending) {
	      var _this4 = this;
	
	      this.setState({ alertConnection: true });
	      this.timerActive = true;
	      setTimeout(function () {
	        _this4.setState({ alertConnection: false });
	        _this4.suspendMonitoring = true;
	        setTimeout(function () {
	          _this4.suspendMonitoring = false;
	          _this4.timerActive = false;
	          if (_this4.tmpStramLevel === _this4.props.stramLevel) {
	            _this4.autoHide(_this4.networkMonitoring.autoHide, _this4.networkMonitoring.SndSuspendMonitoring);
	          }
	        }, suspending);
	      }, _autoHide);
	    }
	  }, {
	    key: 'getMessageByLangId',
	    value: function getMessageByLangId(langId) {
	      var message = "";
	
	      var messages = {
	        es: "La llamada se realizará al término del estado de diálogo.",
	        en: "The call will be dialed upon the end of the engaged status.",
	        pt: "A chamada será discada após o fim do status ‘em diálogo’."
	      };
	
	      switch (langId) {
	        case '0':
	          message = messages.es;
	          break;
	        case '1':
	          message = messages.en;
	          break;
	        case '2':
	          message = messages.pt;
	          break;
	      }
	
	      return message;
	    }
	  }, {
	    key: 'getMessageManualCallAfterWhatsApp',
	    value: function getMessageManualCallAfterWhatsApp() {
	      var message = "";
	
	      var userState = this.props.userState;
	
	      if (userState && this.state.alert.code && this.state.alert.code === '1093') {
	        if (userState.currentState && (userState.currentState === _constants.USER_STATE.DIALOG_WHATSAPP || userState.currentState === _constants.USER_STATE.DIALOG_EMAIL)) {
	
	          if (this.language.getLanguage() === '-1') {
	            message = this.getMessageByLangId(this.sharedData.generalPermissions[27]);
	          } else {
	            message = this.getMessageByLangId(this.language.getLanguage());
	          }
	        }
	      }
	      return message;
	    }
	  }, {
	    key: 'fillAlertModal',
	    value: function fillAlertModal() {
	      var _this5 = this;
	
	      var message = this.getMessageManualCallAfterWhatsApp();
	      this.props.showAlertModal({
	        type: "ModalAlert",
	        title: this.state.alert.title,
	        message: message ? message : this.language.getText('alert-' + this.state.alert.code),
	        button: this.state.alert.btnYes,
	        secondButton: this.state.alert.btnNo,
	        secondButtonFtn: function secondButtonFtn() {
	          if (_this5.state.alert.btnNo) {
	            _this5.onNo();
	          }
	        },
	        buttonFun: function buttonFun() {
	          _this5.onYes();
	        }
	      });
	    }
	  }, {
	    key: 'closeAlert',
	    value: function closeAlert() {
	      this.setState({ alertConnection: false });
	    }
	  }, {
	    key: 'messageAlert',
	    value: function messageAlert(streamLevel) {
	      if (streamLevel > 1) {
	        this.state.time = new Date();
	        var date = this.state.time.toTimeString();
	        switch (streamLevel) {
	          case 3:
	            this.messageConnection = this.language.getText('GUIConnectivitybadMessage') + ' ' + this.language.getText('GUIConnectivityTime') + ' ' + date.substring(0, date.lastIndexOf('('));
	            break;
	          case 2:
	            this.messageConnection = this.language.getText('GUIConnectivityunstableMessage') + ' ' + this.language.getText('GUIConnectivityTime') + ' ' + date.substring(0, date.lastIndexOf('('));
	            break;
	          default:
	            break;
	        }
	      }
	    }
	  }, {
	    key: 'userHangedout',
	    value: function userHangedout() {
	      this.userHangout = true;
	      this.props.saveInitialTime();
	      this.props.setIsRunningClock(true);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'workSpace', onKeyUp: this.isPressedUp, tabIndex: '0' },
	        this.userState === _constants.USER_STATE.CALL_OUT && this.sharedData.getDataPreviewPro().dialingMode === 1 && !this.props.preview.simultaneosRecs && _react2.default.createElement(_CallOutContainer2.default, {
	          time: this.sharedData.getManualCallTime(),
	          phone: this.props.preview.phoneToCall,
	          userHangedout: function userHangedout() {
	            return _this6.userHangedout();
	          },
	          actionPrevRecord: this.actionPrevRecord }),
	        this.state.draggableComponentList.map(function (item) {
	          return item.component(_this6.state.propsDraggables[item.idComponent], _this6.state.zIndexDraggableWindows[item.idComponent], function (component) {
	            return _this6.sendToTop(component);
	          });
	        }),
	        !this.state.isLogged && _react2.default.createElement(_validatingTelephony2.default, { setIsLogged: this.setIsLogged }),
	        this.state.isLogged && this.state.showAlertPasswordExpired && this.fillAlertPasswordExpiredModal(),
	        _react2.default.createElement(_BlockingPanel2.default, null),
	        _react2.default.createElement(_workBar2.default, { keyPressed: this.state.keyPressed }),
	        _react2.default.createElement(_workBarExpanded2.default, { windowsOpened: this.state.draggableComponentList }),
	        this.state.hasUnifiedMessage && _react2.default.createElement(_unifiedMessaging2.default, null),
	        _react2.default.createElement(
	          'div',
	          { className: 'informationSpace' },
	          _react2.default.createElement(_agentState2.default, { smallSize: false, listenerActions: true }),
	          _react2.default.createElement(
	            'div',
	            { className: 'connectionBanner ' + (this.state.alertConnection ? 'activeWorkSpace' : '') },
	            _react2.default.createElement(
	              'div',
	              { id: 'connectionInformation' },
	              _react2.default.createElement('img', { src: _iconWarning2.default, alt: '' }),
	              _react2.default.createElement(
	                'span',
	                null,
	                this.onStreamAlert(this.props.stramLevel),
	                this.messageConnection
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { id: 'boton' },
	              _react2.default.createElement(
	                _globalComponentsLibrary.Button,
	                {
	                  color: 'tertiary',
	                  onClick: function onClick() {
	                    _this6.closeAlert();
	                  } },
	                this.language.getText('GUIConnectivitybtnClose')
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'informationSpaceBottom' },
	            this.state.hasUnifiedMessage && _react2.default.createElement(_messageBar2.default, null),
	            this.renderCallSpace()
	          )
	        ),
	        this.state.alert && this.fillAlertModal(),
	        _react2.default.createElement(_AlertsContainerMessage2.default, { actionAlert: this.state.actionAlert, alertMessage: this.state.newAlertMessage }),
	        _react2.default.createElement(_OngoingCallIvrModal2.default, null)
	      );
	    }
	  }]);
	
	  return workSpace;
	}(_react.Component);
	
	function mapDispatchToProps(dispatch) {
	  var _showAlertModal = _A_Alert_Modal2.default.creators.showAlertModal;
	
	  return {
	    consultingApp: function consultingApp() {
	      dispatch((0, _A_reducer_consulting.consultingApp)());
	    },
	    noConsultingApp: function noConsultingApp() {
	      dispatch((0, _A_reducer_consulting.noConsultingApp)());
	    },
	    moveBlockingPanel: function moveBlockingPanel(newZIndex) {
	      dispatch((0, _A_blocking_panel.moveBlockingPanel)(newZIndex));
	    },
	    manualCall: function manualCall(data) {
	      dispatch((0, _A_messages_to_SM.manualCall)(data));
	    },
	    showAlertModal: function showAlertModal(payload) {
	      dispatch(_showAlertModal(payload));
	    },
	    logout: function logout() {
	      dispatch((0, _A_user_actions.logout)());
	    },
	    sendMessageAgentReady: function sendMessageAgentReady() {
	      dispatch((0, _A_user_actions.sendMessageAgentReady)());
	    },
	    actionPreviewRecord: function actionPreviewRecord(data) {
	      dispatch((0, _A_messages_to_SM.actionPreviewRecord)(data));
	    },
	    setIsRunningClock: function setIsRunningClock(data) {
	      dispatch((0, _A_preview.setIsRunningClock)(data));
	    },
	    saveInitialTime: function saveInitialTime() {
	      dispatch((0, _A_preview.saveInitialTime)());
	    },
	    setShowPswResetAlert: function setShowPswResetAlert(action) {
	      dispatch((0, _reducer_psw_reset.setShowPswResetAlert)(action));
	    },
	    removeRecord: function removeRecord(action) {
	      dispatch((0, _A_preview.removeRecord)(action));
	    },
	    setAgentList: function setAgentList(data) {
	      dispatch((0, _A_preview_transfer.setAgentList)(data));
	    }
	  };
	}
	
	function mapStateToProps(state) {
	  return {
	    userState: state.userState,
	    windowVisible500: state.windowVisible500,
	    dragWindowController: state.dragWindowController,
	    messagesIntegrations: state.messagesIntegrations,
	    showUnifiedMessages: state.unifiedInboxState.show,
	    stramLevel: state.sipClientActions.stream,
	    preview: state.preview,
	    allowChangeDialing: state.agentPermissions.allowChangeDialing,
	    previewSimultaneousRecs: state.preview.simultaneosRecs
	
	  };
	}
	
	exports.default = workSpace = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(workSpace);

/***/ },
/* 1140 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(1005);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	__webpack_require__(1725);
	
	var _App = __webpack_require__(1070);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _ErrorHandler = __webpack_require__(1072);
	
	var _ErrorHandler2 = _interopRequireDefault(_ErrorHandler);
	
	var _reactRedux = __webpack_require__(25);
	
	var _redux = __webpack_require__(482);
	
	var _globalComponentsLibrary = __webpack_require__(28);
	
	var _reducers = __webpack_require__(1167);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	var _ClearCache = __webpack_require__(1071);
	
	__webpack_require__(1043);
	
	var _package = __webpack_require__(2050);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var path = "AgentKolob/version.json";
	var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || _redux.compose;
	var store = null;
	if (false) {
	  store = (0, _redux.createStore)(_reducers2.default, {}, composeEnhancers());
	  path = "version.json";
	} else {
	  store = (0, _redux.createStore)(_reducers2.default);
	}
	console.log("Project data\nName:", _package.name, "\nVersion:", _package.version);
	
	_reactDom2.default.render(_react2.default.createElement(
	  _ClearCache.ClearBrowserCacheBoundary,
	  { filename: path },
	  _react2.default.createElement(
	    _reactRedux.Provider,
	    { store: store },
	    _react2.default.createElement(
	      _ErrorHandler2.default,
	      null,
	      _react2.default.createElement(
	        _globalComponentsLibrary.ToastProvider,
	        null,
	        _react2.default.createElement(
	          _globalComponentsLibrary.ToastConsumer,
	          null,
	          function (context) {
	            return _react2.default.createElement(_App2.default, context);
	          }
	        )
	      )
	    )
	  )
	), document.getElementById("root"));

/***/ },
/* 1141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.STRATEGIES_ACTIONS = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(10);
	
	var _helperMessages = __webpack_require__(87);
	
	var _Strategies_Api_Response = __webpack_require__(1146);
	
	var _Strategies_Alerts_And_Errors = __webpack_require__(508);
	
	var _SingletonWebSocket = __webpack_require__(50);
	
	var _SingletonWebSocket2 = _interopRequireDefault(_SingletonWebSocket);
	
	var _constants2 = __webpack_require__(10);
	
	var _Strategies_External_Messaging = __webpack_require__(1147);
	
	var _Logger = __webpack_require__(37);
	
	var _Strategies_Preview_Transfer = __webpack_require__(1149);
	
	var _globalComponentsLibrary = __webpack_require__(28);
	
	var _singletonSharedData = __webpack_require__(23);
	
	var _Strategies_Agent_Permissions = __webpack_require__(1145);
	
	var _cwGalateaApiJsBundle = __webpack_require__(40);
	
	var _formats = __webpack_require__(54);
	
	var _Strategies_Preview_ConnectCall = __webpack_require__(1148);
	
	var _Strategies_Preview_RecState = __webpack_require__(239);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sharedData = new _singletonSharedData.SingletonSharedData();
	var STRATEGIES_ACTIONS = exports.STRATEGIES_ACTIONS = {
	  "RingingListening": function RingingListening(message, that) {
	    STRATEGIES_ACTIONS["dataCall"](message, that);
	    _Strategies_Preview_ConnectCall.STRATEGIES_CONNECT_CALL["RingingListening"](message, that);
	  },
	  "CallTypeRecive": function CallTypeRecive(message, that) {
	    that.setState({ callType: message.callType });
	  },
	  "chatAdmin": function chatAdmin(message, that) {
	    that.props.messageFromSupervisor(message.Message, message.From);
	  },
	  "dataCall": function dataCall(message, that) {
	    var APIFact = new _cwGalateaApiJsBundle.APIFactory();
	    var apiCont = APIFact.buildClient();
	    if (message.CallId) {
	      that.callId = message.CallId;
	    }
	    if (message.CallOutId != that.callOutId) {
	      message.CallOutId = that.callOutId;
	    }
	    var speaker = that.sharedData.getVolumeSpeaker();
	    var microphone = that.sharedData.getVolumeMic();
	    if (speaker === 0) {
	      speaker = 70;
	      that.sharedData.setVolumeSpeaker(speaker);
	    }
	    if (microphone === 0) {
	      microphone = 70;
	      that.sharedData.setVolumeMic(microphone);
	    }
	    if (message.CallType === 1) {
	      var objectResponseRecordCall = apiCont.getObjectResponse();
	      _Logger.Logger.Trace('apiCont.RecordCall request');
	      var objectDataRecord = {
	        campId: message.Id,
	        option: message.CallType
	      };
	      apiCont.GetRecordCallPermission(objectDataRecord, objectResponseRecordCall);
	      objectResponseRecordCall.onError = function (err) {
	        _Logger.Logger.Warn('apiCont.RecordCall objectData:', objectDataRecord, 'error:', err);
	      };
	      objectResponseRecordCall.onSuccess = function (objResponse) {
	        _Logger.Logger.Trace('apiCont.RecordCall onSucces:', objResponse);
	        sharedData.setAllowMarksPermission(objResponse !== 3);
	      };
	    }
	    var objectData = {
	      UserId: that.sharedData.getParameters().UserID,
	      Id: message.Id,
	      CallType: message.CallType,
	      CallOutId: message.CallOutId,
	      Phone: message.Phone
	    };
	    var objectResponseCallIcon = apiCont.getObjectResponse();
	    _Logger.Logger.Trace("apiCont.callIcon request");
	    apiCont.callIcon(objectData, objectResponseCallIcon);
	    objectResponseCallIcon.onError = function (err) {
	      _Logger.Logger.Warn("apiCont.callIcon objectData:", objectData, "error:", err);
	      message.Description = "";
	      that.sharedData.setCallIcon(null);
	      if (message.action != "RingingListening") {
	        var integrationMessage = { client: "galatea", data: message, action: "CallFlow", subaction: "onCallRecieved" };
	        _SingletonWebSocket2.default.send(integrationMessage);
	      }
	    };
	    objectResponseCallIcon.onSuccess = function (objResponse) {
	      _Logger.Logger.Trace("apiCont.callIcon onSucces:", objResponse);
	      message.Description = objResponse.Description;
	      that.sharedData.setCallIcon(objResponse);
	      if (message.action != "RingingListening") {
	        var integrationMessage = { client: "galatea", data: message, action: "CallFlow", subaction: "onCallRecieved" };
	        _SingletonWebSocket2.default.send(integrationMessage);
	      }
	    };
	    _Logger.Logger.Info("[StrategiesAction][DataCall] get volume speaker:" + speaker + " microphone:" + microphone + "");
	    that.agentController.volumeSpeaker(speaker);
	    that.agentController.volumeMicrophone(microphone);
	    _Logger.Logger.Info("[StrategiesAction][DataCall] get volume controller speaker:" + that.agentController.volumeSpeakerGet() + " microphone:" + that.agentController.volumeMicrophoneGet() + "");
	    that.setState({ dataCall: message });
	    that.connectCall(message, that.sharedData.getParameters().UserID);
	  },
	  "extraDataCall": function extraDataCall(message, that) {
	    if (message.CallId) {
	      that.callId = message.CallId;
	    }
	    that.setState({ extraDataCall: message });
	
	    if (that.sharedData.getDataPreviewPro().dialingMode == 1 && message.Type == "ON_DATA") {
	      that.props.saveDataFromTransfer(message);
	      that.setState({ dataCall: message });
	    }
	
	    if (message.SrcUserId) {
	      that.connectCall(message, message.SrcUserId);
	      var integrationMessage = { client: "galatea", data: message, action: "CallFlow", subaction: "onCallRecieved" };
	      _SingletonWebSocket2.default.send(integrationMessage);
	    } else {
	      switch (message.Type) {
	        case _constants.ASSISTED_TRANSFER.SECOND_CALL_CONNECTED:
	          that.props.newAssistedTransferState(_constants.ASSISTED_TRANSFER.SECOND_CALL_CONNECTED);
	          var _integrationMessage = { client: "galatea", action: "AssistedTransfer", subaction: "onSecondCallConected" };
	          _SingletonWebSocket2.default.send(_integrationMessage);
	          break;
	        case _constants.ASSISTED_TRANSFER.ON_STATUS:
	          that.props.newAssistedTransferState(_constants.ASSISTED_TRANSFER.ON_STATUS);
	          break;
	        case _constants.ASSISTED_TRANSFER.SECOND_CALL_HANG_UP:
	          !that.sharedData.getextraCallsConference() && that.props.newAssistedTransferState(_constants.ASSISTED_TRANSFER.SECOND_CALL_HANG_UP);
	          var error = null;
	          if (message.AlertCode !== "0") {
	            if (message.AlertCode === "1517") {
	              that.props.showAlert();
	              var _msg = that.language.getText("GUIAlertTransferswitchedError");
	              var _titleAlert = that.language.getText("GUIAlertTransfertransferError");
	              that.props.addToast(_msg, {
	                group: 'icon',
	                position: 'topRight',
	                title: _titleAlert,
	                color: 'red',
	                btnComponent: _react2.default.createElement(
	                  _globalComponentsLibrary.AgentButton,
	                  { type: 'tertiary' },
	                  that.language.getText("GUIAlertTransferadmit")
	                ),
	                timeout: 5000,
	                onDismiss: that.props.showAlert()
	              });
	            } else {
	              var _that = that;
	              error = _Strategies_Alerts_And_Errors.STRATEGIES_ALERTS["TRANSFER_CALL"](message, that);
	              that.setState({ alert: error });
	            }
	          }
	          error = error ? error.error : "";
	          _integrationMessage = { client: "galatea", action: "AssistedTransfer", subaction: "onSecondCallHangUp", data: error };
	          _SingletonWebSocket2.default.send(_integrationMessage);
	          break;
	        case _constants.ASSISTED_TRANSFER.CONFERENCE_CALL_CONNECTED:
	          that.setState({ isInConference: true });
	          that.sharedData.setConferenceCallID(message.CallId);
	          that.props.newAssistedTransferState(_constants.ASSISTED_TRANSFER.CONFERENCE_CALL_CONNECTED);
	          break;
	        case _constants.ASSISTED_TRANSFER.CONFERENCE_CALL_HANG_UP:
	          that.sharedData.setConferenceHangUpOther(message.CallId);
	          that.props.newAssistedTransferState(_constants.ASSISTED_TRANSFER.CONFERENCE_CALL_HANG_UP);
	          break;
	        case _constants.ASSISTED_TRANSFER.NEW_SECOND_CALL_SET:
	          that.props.newAssistedTransferState(_constants.ASSISTED_TRANSFER.NEW_SECOND_CALL_SET);
	          break;
	        case _constants.ASSISTED_TRANSFER.IDDLE_END:
	          that.props.newAssistedTransferState(_constants.ASSISTED_TRANSFER.IDDLE_END);
	          break;
	        case _constants.BLIND_TRANSFER.BLIND_TRANSFER_HANG_UP:
	          var msg = void 0;
	          var titleAlert = that.language.getText('GUIAlertTransfertransferError');
	          if (message.AlertCode === "1501") msg = that.language.getText('CallControlGUICallTransferno-answer-error');else msg = that.language.getText('alert-' + message.AlertCode);
	
	          if (msg === "" || msg === undefined) {
	            titleAlert = "";
	            msg = that.language.getText("CallControlGUICallTransferBlindXferError");
	          }
	          that.props.showAlert();
	          that.props.addToast(msg, {
	            group: 'icon',
	            position: 'topRight',
	            title: titleAlert,
	            color: 'red',
	            btnComponent: _react2.default.createElement(
	              _globalComponentsLibrary.AgentButton,
	              { type: 'tertiary' },
	              that.language.getText("GUIAlertTransferadmit")
	            ),
	            timeout: 5000,
	            onDismiss: that.props.showAlert()
	          });
	          that.props.resetTransfer();
	        default:
	          break;
	      }
	    }
	  },
	  "dialogTime": function dialogTime(message, that) {
	    if (that.sharedData.getDataPreviewPro().dialingMode === 1) {
	      that.props.setDialogTime(Math.round(message.dialogTime));
	      _Strategies_Preview_RecState.Strategies_Preview_RecState[message.action](message, that);
	    }
	    var integrationMessage = { client: "galatea", data: message, action: "onCallEnds" };
	    _SingletonWebSocket2.default.send(integrationMessage);
	    var _that = that;
	    var isHangedUpByAgent = sharedData.getIsHangedUpByAgent();
	    if (isHangedUpByAgent === _constants.STATE_TO_PLAY_END_AUDIO.HANG_UP_CLIENT) {
	      var audioToPlay = sharedData.getAudioNotificationCallEnd();
	      if (audioToPlay) {
	        var audio = new Audio(audioToPlay);
	        audio.play();
	      }
	    }
	  },
	  "StartKeepAlive": function StartKeepAlive(message, that) {
	    if (!that.timerKeepAlive) {
	      var keepAlive = function keepAlive() {
	        var userName = _that.sharedData.getUserData().Login;
	        var timeStamp = _that.agentController.getTimeStamp();
	        var msgKeepAlive = (0, _helperMessages.messageKeepAlive)(userName, timeStamp);
	        // Logger.Trace("KeepAlive", msgKeepAlive);
	        _that.sendToRabbit(_constants2.SM_QUEUE_SERVER, msgKeepAlive);
	      };
	
	      that.timerKeepAlive = setInterval(keepAlive, 10000);
	      var _that = that;
	    }
	  },
	  "queueCall": function queueCall(message, that) {
	    var CallOnQueue = { acdID: message.IdACDReceived, nQueue: message.CountACDReceived, secondsOnQueue: message.SecondsACDReceived };
	    var integrationMessage = { client: "galatea", data: CallOnQueue, action: "onCallsOnQueue" };
	    _SingletonWebSocket2.default.send(integrationMessage);
	    that.props.updateCount(_constants.QUEUE_COUNT.CALLS, message.Count, message.Seconds);
	    //that.setState({ idChangeCount: QUEUE_COUNT.CALLS, queueCount: message.Count, timeInQueue: message.Seconds });
	  },
	  "ApiResponse": function ApiResponse(message, that) {
	    _Strategies_Api_Response.STRATEGIES_API_RESPONSE[message.Subaction](message, that);
	  },
	  "notReadyScheduled": function notReadyScheduled(message, that) {
	    that.setState({ newAlertCode: _constants.ALERTS_SHOWED_CODE.REPROGRAM_NA_STATE, newAlertMessage: message });
	    if (that.sharedData.getDataPreviewPro().dialingMode === 1) {
	      _Strategies_Preview_RecState.Strategies_Preview_RecState[message.action](message, that);
	    }
	  },
	  "EXTERNAL_MESSAGING": function EXTERNAL_MESSAGING(message, that) {
	    _Strategies_External_Messaging.STRATEGIES_EXTERNAL_MESSAGING[message.subAction](message, that);
	  },
	  "ERROR_MMC": function ERROR_MMC(message, that) {
	    _Strategies_External_Messaging.STRATEGIES_EXTERNAL_MESSAGING[message.subAction](message, that);
	  },
	  "NewPreviewCall": function NewPreviewCall(message, that) {
	    var data = {
	      CamId: message.CamId,
	      Id: message.CamId,
	      CallKey: message.CallKey,
	      CalKey: message.CallKey,
	      Phone: message.PhoneNumber,
	      Data: "",
	      ExistsCallout: 0,
	      CallMode: 2,
	      integration: false,
	      campaignName: message.CampaignName,
	      CallId: message.CallOutId
	    };
	    that.setState({ dataCall: data });
	    that.props.manualCall(data);
	    var integrationData = {
	      action: message.action,
	      CalKey: message.CallKey,
	      CallId: that.callId,
	      CallOutId: message.CallOutId,
	      CallType: 2,
	      DataContact: message.Data,
	      Description: message.CampaignName,
	      Id: message.CamId,
	      Phone: message.PhoneNumber,
	      Port: message.Port,
	      WrapUpTime: message.WrapUpTime
	    };
	    that.sharedData.setIntegrationCallData(integrationData);
	  },
	  "PREVIEWPRO": function PREVIEWPRO(message, that) {
	    if (message.DialingMode === 500) {
	      that.props.showAlert();
	      var msg = that.language.getText("GUIAlertTransferunexpectedError"); //"Ocurrió un problema inesperado";
	      var titleAlert = that.language.getText("GUIAlertTransfertransferError"); //"Error al realizar transferencia";
	      that.props.addToast(msg, {
	        title: titleAlert,
	        group: 'icon',
	        position: 'topRight',
	        color: 'red',
	        btnComponent: _react2.default.createElement(
	          _globalComponentsLibrary.AgentButton,
	          { type: 'tertiary' },
	          that.language.getText("GUIAlertTransferclose")
	        ),
	        timeout: 5000,
	        onDismiss: that.props.showAlert()
	      });
	    } else {
	      if ([100, 101, 200, 201].includes(message.DialingMode)) {
	        var isEnabled = message.DialingMode === 201 || message.DialingMode === 101;
	        that.props.setAllowChangeDialingMode(isEnabled);
	        if (that.sharedData.getDataPreviewPro().dialingMode === 1) {
	          var _msg3 = isEnabled ? that.language.getText("GUIAlertMessagecamEnable") : that.language.getText("GUIAlertMessagecamDisabled");
	          that.props.addToast(_msg3, {
	            group: 'icon',
	            position: 'topRight',
	            icon: 'camps',
	            btnComponent: _react2.default.createElement(
	              _globalComponentsLibrary.AgentButton,
	              { type: 'tertiary' },
	              that.language.getText("GUIAlertMessageclose")
	            ),
	            timeout: 5000
	          });
	        }
	        return;
	      }
	      that.sharedData.setDataPreviewPro(message.DialingMode, that.sharedData.getDataPreviewPro().allowChangeDialMode);
	      var _msg2 = message.DialingMode === 1 ? that.language.getText("GUIAlertMessagepreviewMode") : that.language.getText("GUIAlertMessagedefaultMode");
	      that.props.addToast(_msg2, {
	        group: 'icon',
	        position: 'topRight',
	        icon: 'camps',
	        btnComponent: _react2.default.createElement(
	          _globalComponentsLibrary.AgentButton,
	          { type: 'tertiary' },
	          that.language.getText("GUIAlertMessageok")
	        ),
	        timeout: 5000
	      });
	    }
	  },
	  "previewData": function previewData(message, that) {
	    that.sharedData.setDataCallPreview(message);
	    var msg = that.language.getText("GUIAlertMessagemsgAssignAgain");
	    message.IsReassigned && that.props.addToast(msg, {
	      group: 'snackbar',
	      btnComponent: _react2.default.createElement(
	        _globalComponentsLibrary.AgentButton,
	        { type: 'tertiary' },
	        that.language.getText("GUIAlertMessageclose")
	      ),
	      position: 'topRight',
	      type: 'light',
	      timeout: 5000
	    });
	  },
	  "previewScheduled": function previewScheduled(message, that) {
	    var msg = message.DialingMode === 1 ? that.language.getText("GUIAlertMessagepreviewMode") : that.language.getText("GUIAlertMessagedefaultMode");
	    var closeButton = _react2.default.createElement(
	      _globalComponentsLibrary.AgentButton,
	      { type: 'tertiary' },
	      that.language.getText("GUIAlertMessageok")
	    );
	    if ([100, 101, 200, 201].includes(message.DialingMode) && that.sharedData.getDataPreviewPro().dialingMode === 1) {
	      var isEnabled = message.DialingMode === 201 || message.DialingMode === 101;
	      msg = isEnabled ? that.language.getText("GUIAlertMessagecamEnable") : that.language.getText("GUIAlertMessagecamDisabled");
	      closeButton = _react2.default.createElement(
	        _globalComponentsLibrary.AgentButton,
	        { type: 'tertiary' },
	        that.language.getText("GUIAlertMessageclose")
	      );
	      that.props.setAllowChangeDialingMode(isEnabled);
	    }
	    that.props.addToast(msg, {
	      group: 'icon',
	      position: 'topRight',
	      icon: 'camps',
	      btnComponent: closeButton,
	      timeout: 5000
	    });
	  },
	  "previewChangeCampaign": function previewChangeCampaign(message, that) {
	    if (message.DialingMode === 3) {
	      that.sharedData.setDataPreviewPro(that.sharedData.getDataPreviewPro().dialingMode, true);
	    } else {
	      that.sharedData.setDataPreviewPro(that.sharedData.getDataPreviewPro().dialingMode, false);
	    }
	    var msg = message.DialingMode === 3 ? that.language.getText("GUIAlertMessageenableChangeCampaignType") : that.language.getText("GUIAlertMessagedisableChangeCampaignType");
	    that.props.addToast(msg, {
	      group: 'icon',
	      position: 'topRight',
	      icon: 'camps',
	      btnComponent: _react2.default.createElement(
	        _globalComponentsLibrary.AgentButton,
	        { type: 'tertiary' },
	        that.language.getText("GUIAlertMessageok")
	      ),
	      timeout: 5000
	    });
	  },
	  "dataCallPreview": function dataCallPreview(message, that) {
	    that.setState({ dataCall: message });
	    that.connectCall(message, that.sharedData.getParameters().UserID);
	    var integrationMessage = { client: "galatea", data: message, action: "CallFlow", subaction: "onCallRecieved" };
	    _SingletonWebSocket2.default.send(integrationMessage);
	  },
	  "AGENT_BUSY": function AGENT_BUSY(message, that) {
	    that.props.showAlert();
	    var msg = that.language.getText("GUIAlertTransferswitchedError");
	    var titleAlert = that.language.getText("GUIAlertTransfertransferError");
	
	    that.props.addToast(msg, {
	      group: 'icon',
	      position: 'topRight',
	      title: titleAlert,
	      color: 'red',
	      btnComponent: _react2.default.createElement(
	        _globalComponentsLibrary.AgentButton,
	        { type: 'tertiary' },
	        that.language.getText("GUIAlertTransferadmit")
	      ),
	      timeout: 5000,
	      onDismiss: that.props.showAlert()
	    });
	    that.props.resetTransfer();
	    var data = { agent: that.sharedData.getConferenceNewNumber(), error: message.Module };
	    var integrationMessage = { client: "galatea", action: "TransferOption", subaction: "onUnavailableAgent", data: data };
	    _SingletonWebSocket2.default.send(integrationMessage);
	  },
	  "TransferPreviewCall": function TransferPreviewCall(message, that) {
	    _Strategies_Preview_Transfer.STRATEGIES_PREVIEW_TRANSFER[message.subAction](message, that);
	  },
	  "showPreviewDataTransfer": function showPreviewDataTransfer(message, that) {
	    that.props.showPreviewData(message.showPreview);
	  },
	  "UPDATE_DATA_CALL": function UPDATE_DATA_CALL(message, that) {
	    that.sharedData.getDataPreviewPro().dialingMode === 1 && that.props.updatePreviewRecord(message);
	    var msg = message.IsSave ? that.language.getText("GUIAlertMessagesuccesUpdate") : that.language.getText("GUIAlertMessageunsuccesUpdate");
	    that.sharedData.getDataPreviewPro().dialingMode === 1 && that.props.addToast(msg, {
	      group: 'icon',
	      position: 'topRight',
	      color: message.IsSave ? 'green' : 'red',
	      btnComponent: _react2.default.createElement(
	        _globalComponentsLibrary.AgentButton,
	        { color: 'tertiary' },
	        that.language.getText("GUIAlertMessageClose")
	      ),
	      timeout: 5000
	    });
	    that.sharedData.getDataPreviewPro().dialingMode !== 1 && that.props.addToast(msg, {
	      group: 'icon',
	      position: 'topRight',
	      color: message.IsSave ? 'green' : 'red',
	      btnComponent: _react2.default.createElement(
	        _globalComponentsLibrary.AgentButton,
	        { color: 'tertiary' },
	        that.language.getText("GUIAlertMessageclose")
	      ),
	      timeout: 5000
	    });
	    var newData = {
	      CalKey: that.state.dataCall.CalKey,
	      IsSave: message.IsSave,
	      DataContact: message.DataContact
	    };
	    var integrationMessage = { client: "galatea", data: newData, action: "updatedCallData" };
	    _SingletonWebSocket2.default.send(integrationMessage);
	  },
	  "ChangeDialingModeScheduled": function ChangeDialingModeScheduled(message, that) {
	    var preCampType = that.sharedData.getDataPreviewPro().dialingMode;
	    if (preCampType === 1 && message.nextStatus === 3 || preCampType === 0 && message.nextStatus === 31) {
	      that.props.isSuccessfullChangeCamp({ flag: true, nextCampType: message.nextStatus });
	    } else {
	      that.props.isSuccessfullChangeCamp(false);
	    }
	  },
	  "AGENT_PERMISSIONS": function AGENT_PERMISSIONS(message, that) {
	    _Strategies_Agent_Permissions.STRATEGIES_AGENT_PERMISSIONS[message.subAction](message, that);
	  },
	  "Preview": function Preview(message, that) {
	    if (message.Process === 0) {
	      if (that.sharedData.getAgentList().length > 0) {
	        that.props.addToast(that.language.getText('GUIPreviewunassignSuccess'), {
	          group: 'icon',
	          position: 'topRight',
	          color: 'green',
	          btnComponent: _react2.default.createElement(
	            _globalComponentsLibrary.AgentButton,
	            { color: 'tertiary' },
	            that.language.getText("GUIAlertMessageok")
	          ),
	          timeout: 5000
	        });
	      } else {
	        that.props.addToast(that.language.getText('GUIPreviewunassignWarning'), {
	          group: 'icon',
	          position: 'topRight',
	          icon: 'warning',
	          color: 'yellow',
	          btnComponent: _react2.default.createElement(
	            _globalComponentsLibrary.AgentButton,
	            { color: 'tertiary' },
	            that.language.getText("GUIAlertMessageok")
	          ),
	          timeout: 5000
	        });
	      }
	    }
	    if (message.Process === 1) {
	      that.props.addToast(that.language.getText('GUIAlertMessagedeleteSuccess'), {
	        group: 'icon',
	        position: 'topRight',
	        color: 'green',
	        btnComponent: _react2.default.createElement(
	          _globalComponentsLibrary.AgentButton,
	          { color: 'tertiary' },
	          that.language.getText("GUIAlertMessageok")
	        ),
	        timeout: 5000
	      });
	    }
	  },
	  "NotifyCleanDisplay": function NotifyCleanDisplay(message, that) {
	    if (that.sharedData.getDataPreviewPro().dialingMode === 0) {
	      that.props.showDataTransferBySetting(true);
	    }
	  }
	};

/***/ },
/* 1142 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.STRATEGIES_ASSISTED_TRANSFER = undefined;
	
	var _constants = __webpack_require__(10);
	
	var _SingletonWebSocket = __webpack_require__(50);
	
	var _SingletonWebSocket2 = _interopRequireDefault(_SingletonWebSocket);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var STRATEGIES_ASSISTED_TRANSFER = exports.STRATEGIES_ASSISTED_TRANSFER = {
	    "MAIN_CALL": function MAIN_CALL(that) {
	        var integrationMessage = { client: "galatea", data: that.information[0].number, action: "AssistedTransfer", subaction: "onMainCall" };
	        _SingletonWebSocket2.default.send(integrationMessage);
	        that.sharedData.setAssistedTransferCurrentState(integrationMessage);
	        that.information[0].active = true;
	        that.information[1].active = false;
	    },
	    "ON_STATUS": function ON_STATUS(that) {
	        var integrationMessage = { client: "galatea", data: that.information[1].number, action: "AssistedTransfer", subaction: "onSecondCall" };
	        _SingletonWebSocket2.default.send(integrationMessage);
	        that.sharedData.setAssistedTransferCurrentState(integrationMessage);
	        that.information[0].active = false;
	        that.information[1].active = true;
	    },
	    "CONFERENCE_CALL_CONNECTED": function CONFERENCE_CALL_CONNECTED(that) {
	        var integrationMessage = { client: "galatea", data: that.sharedData.getConferenceNewNumber(), action: "AssistedTransfer", subaction: "onNextCall" };
	        _SingletonWebSocket2.default.send(integrationMessage);
	        that.sharedData.setAssistedTransferCurrentState(integrationMessage);
	        that.information.push({ title: that.language.getText("CallControlGUIAssistedCallTransfernewCall"), active: true, flag: "new", number: that.sharedData.getConferenceNewNumber(), callId: that.sharedData.getConferenceCallID() });
	        that.sharedData.addCallConference();
	        that.setState({ newCallNumber: "", transferring: false });
	        that.data.sPhone = "";
	    },
	    "CONFERENCE_CALL_HANG_UP": function CONFERENCE_CALL_HANG_UP(that) {
	        var callIdToErase = that.sharedData.getConferenceHangUpOther();
	        if (!that.state.transferring) {
	            that.sharedData.substractCallConference();
	        }
	        that.setState({ transferring: false });
	        that.information = that.information.filter(function (call) {
	            return call.callId !== callIdToErase;
	        });
	    },
	    "NEW_SECOND_CALL_SET": function NEW_SECOND_CALL_SET(that) {
	        that.information.splice(1, 1);
	        that.sharedData.substractCallConference();
	    },
	    "ON_CONFERENCE": function ON_CONFERENCE(that) {
	        that.setState({ isInConference: true });
	        that.information.map(function (item, i) {
	            return item.active = true;
	        });
	        that.data.reference = "conference";
	        var _that = that;
	        setTimeout(function () {
	            _that.props.messageAssistedTransferCall(_constants.ASSISTED_TRANSFER_SUBACTION.ASSISTED, that.data);
	        }, 100);
	        var integrationMessage = { client: "galatea", action: "AssistedTransfer", subaction: "onConference" };
	        _SingletonWebSocket2.default.send(integrationMessage);
	        that.sharedData.setAssistedTransferCurrentState(integrationMessage);
	    },
	    "ON_CONFERENCE_CALL": function ON_CONFERENCE_CALL(that) {
	        that.setState({ transferring: true });
	        that.data.sPhone = that.state.newCallNumber;
	        that.sharedData.setConferenceNewNumber(that.data.sPhone);
	        that.data.reference = "next";
	        that.data.callId = Math.floor(Math.random() * 10000);
	        that.sharedData.setConferenceCallID(that.data.callId);
	        var _that = that;
	        setTimeout(function () {
	            _that.props.messageAssistedTransferCall(_constants.ASSISTED_TRANSFER_SUBACTION.ASSISTED, that.data);
	        }, 100);
	    }
	
	};

/***/ },
/* 1143 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var STRATEGIES_INTEGRATION_ASSISTED_TRANSFER = exports.STRATEGIES_INTEGRATION_ASSISTED_TRANSFER = {
	    "UseMainCall": function UseMainCall(that) {
	        that.mainCall(0);
	    },
	    "UseSecondCall": function UseSecondCall(that) {
	        that.mainCall(1);
	    },
	    "TransferAssistedCall": function TransferAssistedCall(that) {
	        that.assistedTransferCall();
	    },
	    "DropSecondCall": function DropSecondCall(that) {
	        that.hangUpSecondCall();
	    },
	    "DropFirstCall": function DropFirstCall(that) {
	        that.hangUpConference();
	    },
	    "MakeConference": function MakeConference(that) {
	        that.startconference();
	    },
	    "LeaveConference": function LeaveConference(that) {
	        that.leaveConference();
	    },
	    "assistedDialNumber": function assistedDialNumber(that, message) {
	        that.dialNumber(message.phone);
	    }
	};

/***/ },
/* 1144 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.STRATEGIES_STATES = undefined;
	
	var _constants = __webpack_require__(10);
	
	var _Strategies_Alerts_And_Errors = __webpack_require__(508);
	
	var _SingletonWebSocket = __webpack_require__(50);
	
	var _SingletonWebSocket2 = _interopRequireDefault(_SingletonWebSocket);
	
	var _singletonSharedData = __webpack_require__(23);
	
	var _Strategies_Preview_RecState = __webpack_require__(239);
	
	var _globalComponentsLibrary = __webpack_require__(28);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * that app.jsx
	 */
	var STRATEGIES_STATES = exports.STRATEGIES_STATES = {
	    "Login": function Login(message, that) {
	        that.setState({ isLoged: true });
	        var myStorage = window.localStorage;
	        myStorage.setItem('AgentTimeSpam', that.sharedData.getUserData().Login + "|" + that.agentController.getTimeStamp());
	    },
	    "firstCall": function firstCall(message, that, renderTag) {
	        that.setState({ consulting: that.state.consulting - 1, isLogged: true });
	        that.props.changeState(_constants.USER_STATE.LOGED_IN);
	        that.agentController.conectSip(that.state.userLogin, renderTag);
	        that.telephonyTime = message.WaitingTime;
	        that.actionsValitatingTelephony();
	        var integrationMessage = { client: "galatea", action: "onLogin" };
	        _SingletonWebSocket2.default.send(integrationMessage);
	    },
	    "Ready": function Ready(message, that) {
	        if (that.props.transferReducer.currentBlindTransfer) {
	            that.props.resetTransfer();
	            that.props.addToast(that.language.getText("CallControlGUICallTransferBlindXferSuccess"), {
	                group: 'icon',
	                position: 'topRight',
	                icon: '',
	                color: '',
	                btnComponent: _react2.default.createElement(
	                    _globalComponentsLibrary.AgentButton,
	                    { type: 'tertiary' },
	                    that.language.getText("GUIAlertMessageok")
	                ),
	                timeout: 5000
	            });
	        }
	        that.props.changeCampaignType(false);
	        that.props.cleanData();
	        that.sharedData.setIsRated(false);
	        that.callId = 0;
	        that.agentController.hangUp();
	        that.props.changeState(_constants.USER_STATE.AGENT_READY);
	        that.setState({ consulting: that.state.consulting - 1, isLogged: true, extraDataCall: {}, dataCall: {} });
	        that.sharedData.setDataPreviewPro(0, that.sharedData.getDataPreviewPro().allowChangeDialMode);
	        that.props.setDialingMode(0);
	        if (that.sharedData.getIsPendingMessage()) {
	            that.props.showUnifiedMessagesWindow(true);
	            that.sharedData.setIsPendingMessage(false);
	        }
	        that.props.showDataTransferBySetting(false);
	        setTimeout(function () {
	            that.sharedData.setIsHangedUpByAgent(_constants.STATE_TO_PLAY_END_AUDIO.HANG_UP_CLIENT);
	        }, 2000);
	    },
	    "ReadyPreviewPro": function ReadyPreviewPro(message, that) {
	        that.props.cleanData();
	        that.props.changeCampaignType(false);
	        that.agentController.hangUp();
	        that.props.changeState(_constants.USER_STATE.READY_PREVIEW);
	        that.sharedData.setDataPreviewPro(1, that.sharedData.getDataPreviewPro().allowChangeDialMode);
	        that.props.setDialingMode(1);
	        that.setState({ consulting: that.state.consulting - 1, isLogged: true, extraDataCall: {}, dataCall: {} });
	        that.props.showDataTransferBySetting(false);
	    },
	    "OnValidatedTelephony": function OnValidatedTelephony(message, that) {
	        that.sharedData.setLogged(true);
	        that.props.validatingState(_constants.VALIDATING_TELEPHONY.VALID, 0);
	        that.setState({ consulting: that.state.consulting - 1, isLogged: true, extraDataCall: {}, dataCall: {} });
	        that.agentController.reconnectMic();
	    },
	    "NotReady": function NotReady(message, that) {
	        that.props.removeWindow(_constants.DRAGGABLE_WINDOWS.TRANSFER_CALL);
	        that.sharedData.getDataPreviewPro().dialingMode === 1 && _Strategies_Preview_RecState.Strategies_Preview_RecState[message.currentState](message, that);
	        that.props.changeState(_constants.USER_STATE.NO_AVAILABLE);
	        that.props.noAvailableData(message.frame, message.time, message.requieredPassAdmin, message.description);
	    },
	    "Callout": function Callout(message, that) {
	        that.callId = message.CallId;
	        that.callOutId = message.CallOutId;
	        that.camId = message.CamId;
	        that.sharedData.setManualCallTime(message.CalloutMaxTime);
	        that.props.changeState(_constants.USER_STATE.CALL_OUT);
	        var data = { call_id: message.CallId,
	            callout_id: message.CallOutId,
	            camID: message.CamId,
	            phoneNumber: message.PhoneNumber,
	            calloutMaxTime: message.CalloutMaxTime
	        };
	        var integrationMessage = { client: "galatea", data: data, action: "onDialingNumber" };
	        _SingletonWebSocket2.default.send(integrationMessage);
	        if (that.sharedData.getIntegrationCallData() && that.sharedData.getSendDataOncallout()) {
	            that.sharedData.integrationCallData.CallId = message.CallId;
	            var integrationMessage2 = { client: "galatea", data: that.sharedData.integrationCallData, action: "CallFlow", subaction: "onCallRecieved" };
	            _SingletonWebSocket2.default.send(integrationMessage2);
	        }
	        that.props.showUnifiedMessagesWindow(false);
	        that.sharedData.getDataPreviewPro().dialingMode === 1 && that.props.setTempPrevRecord(message);
	        that.sharedData.getDataPreviewPro().dialingMode === 1 && _Strategies_Preview_RecState.Strategies_Preview_RecState[message.currentState](message, that);
	    },
	    "Xfer": function Xfer(message, that) {
	        that.sharedData.setXferTime(message.MaxXferTime);
	        that.props.changeState(_constants.USER_STATE.XFER);
	        that.props.showUnifiedMessagesWindow(false);
	        var shared = new _singletonSharedData.SingletonSharedData();
	        if (message.AudioStart) {
	            shared.setAudioNotificationCallStart(window.location.protocol + '//' + shared.getIntegrationServer() + '/GalateaAdminWS/MsgAgentAutomatic/' + message.AudioStart);
	        } else {
	            shared.setAudioNotificationCallStart(null);
	        }
	        if (message.AudioEnd) {
	            shared.setAudioNotificationCallEnd(window.location.protocol + '//' + shared.getIntegrationServer() + '/GalateaAdminWS/MsgAgentAutomatic/' + message.AudioEnd);
	        } else {
	            shared.setAudioNotificationCallEnd(null);
	        }
	    },
	    "logout": function logout(message, that) {
	        that.props.logout();
	    },
	    "Dialog": function Dialog(message, that) {
	        that.props.setIsSendProcess(true);
	        var shared = new _singletonSharedData.SingletonSharedData();
	        shared.problemInManualCall = false;
	        var audio = shared.getAudioNotificationCallStart();
	        setTimeout(function () {
	            that.props.changeState(_constants.USER_STATE.DIALOG);
	            shared.setAudioNotificationCallStart(null);
	        }, audio ? 3000 : 0);
	        shared.getDataPreviewPro().dialingMode === 1 && _Strategies_Preview_RecState.Strategies_Preview_RecState[message.currentState](message, that);
	    },
	    "Ringing": function Ringing(message, that) {
	        var shared = new _singletonSharedData.SingletonSharedData();
	        that.props.changeState(_constants.USER_STATE.RINGING);
	        var audioToPlay = shared.getAudioNotificationCallStart();
	        if (audioToPlay) {
	            var audio = new Audio(audioToPlay);
	            audio.play();
	        }
	    },
	    "Wrapup": function Wrapup(message, that) {
	        if (that.props.transferReducer.currentBlindTransfer) {
	            that.props.resetTransfer();
	            that.props.addToast(that.language.getText("CallControlGUICallTransferBlindXferSuccess"), {
	                group: 'icon',
	                position: 'topRight',
	                icon: '',
	                color: '',
	                btnComponent: _react2.default.createElement(
	                    _globalComponentsLibrary.AgentButton,
	                    { type: 'tertiary' },
	                    that.language.getText("GUIAlertMessageok")
	                ),
	                timeout: 5000
	            });
	        }
	        if (message.WrapUpTime) {
	            var dataCall = {
	                WrapUpTime: message.WrapUpTime,
	                CallId: message.CallId,
	                CalKey: message.CallKey,
	                CallOutId: message.CallOutId,
	                CallType: message.CallType,
	                Id: message.CamId ? message.CamId : that.camId,
	                Phone: message.PhoneNumber ? message.PhoneNumber : that.sharedData.phoneNumber
	            };
	            that.setState({ dataCall: dataCall });
	        }
	        that.props.changeState(_constants.USER_STATE.WRAPUP);
	        if (that.sharedData.getIsHangedUpByAgent() === _constants.STATE_TO_PLAY_END_AUDIO.HANG_UP_CLIENT) {
	            setTimeout(function () {
	                that.sharedData.setIsHangedUpByAgent(_constants.STATE_TO_PLAY_END_AUDIO.HANG_UP_AGENT);
	            }, 3000);
	        }
	        that.sharedData.getDataPreviewPro().dialingMode === 1 && _Strategies_Preview_RecState.Strategies_Preview_RecState[message.currentState](message, that);
	    },
	    "ERROR": function ERROR(message, that) {
	        _Strategies_Alerts_And_Errors.STRATEGIES_ERRORS[message.Module](message, that);
	    },
	    "ALERT": function ALERT(message, that) {
	        that.setState({ alert: _Strategies_Alerts_And_Errors.STRATEGIES_ALERTS[message.Module](message, that) });
	        that.sharedData.getDataPreviewPro().dialingMode === 1 && _Strategies_Preview_RecState.Strategies_Preview_RecState[message.currentState](message, that);
	    },
	    "Reserved": function Reserved(message, that) {
	        that.sharedData.setPhoneCallBack(message.DialingNumber);
	        that.props.changeState(_constants.USER_STATE.EXCLUSIVE_CALLBACK);
	    },
	    "Other": function Other(message, that) {
	        that.checkOtherState();
	    },
	    "Problem": function Problem(message, that) {
	        that.props.showAlertModal({
	            type: "ModalError",
	            title: that.language.getText("GUIAlertMessageerror"),
	            message: that.language.getText("error-9997"),
	            boldMessage: that.language.getText("error-9998"),
	            button: that.language.getText("GUIAlertMessagerefresh"),
	            buttonFun: function buttonFun() {
	                history.go(0);
	            }
	        });
	    },
	    "Assisted": function Assisted(message, that) {
	        that.props.changeState(_constants.USER_STATE.ASSISTED);
	    }, "DialogWhatsApp": function DialogWhatsApp(message, that) {
	        that.props.changeState(_constants.USER_STATE.DIALOG_WHATSAPP);
	    }, "WhatsApp": function WhatsApp(message, that) {
	        that.props.changeState(_constants.USER_STATE.WHATSAPP);
	    },
	    "Preview": function Preview(message, that) {
	        that.props.changeState(_constants.USER_STATE.AGENT_PREVIEW);
	        that.props.saveInitialTime();
	    },
	    "InactivePreview": function InactivePreview(message, that) {
	        that.sharedData.setIsInactiveState(true);
	        that.props.changeState(_constants.USER_STATE.INACTIVE);
	    },
	    "DialogEmail": function DialogEmail(message, that) {
	        that.props.changeState(_constants.USER_STATE.DIALOG_EMAIL);
	    },
	    "RingingListening": function RingingListening(message, that) {
	        that.sharedData.getDataPreviewPro().dialingMode === 1 && _Strategies_Preview_RecState.Strategies_Preview_RecState[message.currentState](message, that);
	    },
	    "Hold": function Hold(message, that) {
	        that.sharedData.getDataPreviewPro().dialingMode === 1 && _Strategies_Preview_RecState.Strategies_Preview_RecState[message.currentState](message, that);
	    },
	    "BeforeWrapup": function BeforeWrapup(message, that) {
	        that.sharedData.getDataPreviewPro().dialingMode === 1 && _Strategies_Preview_RecState.Strategies_Preview_RecState[message.currentState](message, that);
	    }
	};

/***/ },
/* 1145 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.STRATEGIES_AGENT_PERMISSIONS = undefined;
	
	var _constants = __webpack_require__(10);
	
	var STRATEGIES_AGENT_PERMISSIONS = exports.STRATEGIES_AGENT_PERMISSIONS = {
	    "UPDATE_PERMISSION": function UPDATE_PERMISSION(message, that) {
	        switch (message.PermissionName) {
	            case _constants.AGENT_PERMISSIONS.AllowPlayRecordsOnCallHistory:
	                that.props.setAllowPlayRecordsOnCallHistory(message.PermissionValue);
	                break;
	            default:
	                break;
	        }
	    }
	};

/***/ },
/* 1146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.STRATEGIES_API_RESPONSE = undefined;
	
	var _constants = __webpack_require__(10);
	
	var _singletonSharedData = __webpack_require__(23);
	
	var _SingletonWebSocket = __webpack_require__(50);
	
	var _SingletonWebSocket2 = _interopRequireDefault(_SingletonWebSocket);
	
	var _Logger = __webpack_require__(37);
	
	var _alertQueryErrorBody = __webpack_require__(130);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sharedData = new _singletonSharedData.SingletonSharedData();
	
	var STRATEGIES_API_RESPONSE = exports.STRATEGIES_API_RESPONSE = {
	  "CallOutCampaigns": function CallOutCampaigns(message, that) {
	    var json = JSON.parse(message.Json);
	
	    sharedData.setCallOutCampaigns(json.Response);
	    if (message.StatusCode === 500) {
	      _Logger.Logger.Trace("[Strategies_Api_Response][CallOutCampaigns] Campaigns =>", message);
	      var type = json.Type;
	      var code = json.InternalCode;
	      var error = that.language.getText(type.toLowerCase() + '-' + code);
	      _Logger.Logger.Error("[Strategies_Api_Response][CallOutCampaigns] Error consulting data base =>", error);
	      var integrationMessage = { client: "galatea", data: { code: code, message: error }, action: "errorOnCampaignsRelated" };
	      _SingletonWebSocket2.default.send(integrationMessage);
	    }
	
	    that.props.updateInfoWB(_constants.WORKBAR_ACTIONS.MANUAL_CALL);
	  },
	  "SaveDispositionListACD": function SaveDispositionListACD(message, that) {
	    _Logger.Logger.Trace("[Strategies_Api_Response][SaveDispositionListACD] SaveDispositionListACD");
	    var json = JSON.parse(message.Json);
	    if (message.StatusCode === 500) {
	      _Logger.Logger.Warning("[Strategies_Api_Response][SaveDispositionListACD] Error saving Disposition List ACD");
	      var type = json.Type;
	      var code = json.InternalCode;
	      var error = that.language.getText(type.toLowerCase() + '-' + code);
	      var data = { code: code, message: error };
	      var integrationMessage = _SingletonWebSocket2.default.getJson("Disposition", "errorOnDispose", data);
	      _SingletonWebSocket2.default.send(integrationMessage);
	    } else {
	      _Logger.Logger.Trace("[Strategies_Api_Response][SaveDispositionListACD] Successed disposition");
	      var _integrationMessage = _SingletonWebSocket2.default.getJson("Disposition", "onDisposeApplied", "");
	      _SingletonWebSocket2.default.send(_integrationMessage);
	    }
	  },
	  "TransferCallData": function TransferCallData(message, that) {
	    _Logger.Logger.Trace("[Strategies_Api_Response][TransferCallData] TransferCallData");
	    var json = JSON.parse(message.Json);
	    if (message.StatusCode === 500) {
	      _Logger.Logger.Warning("[Strategies_Api_Response][TransferCallData] Error consulting data base");
	      that.props.showAlertModal((0, _alertQueryErrorBody.alertQueryErrorBody)());
	      this.props.removeWindow(_constants.DRAGGABLE_WINDOWS.TRANSFER_CALL);
	    } else {
	      _Logger.Logger.Trace("[Strategies_Api_Response][TransferCallData] Successed");
	      that.props.dataTransferPreview(_constants.PREVIEW_TRANSFER.DATA_CALL_PREVIEW, json.Response.TelefonosList, json.Response.AcdList, json.Response.AgentesList);
	    }
	  },
	  "UpdateCallKey": function UpdateCallKey(message, that) {
	    _Logger.Logger.Trace("[Strategies_Api_Response][UpdateCallKey] UpdateCallKey");
	    if (message.StatusCode === 500) {
	      _Logger.Logger.Warning("[Strategies_Api_Response][UpdateCallKey] Error consulting data base");
	    } else {
	      _Logger.Logger.Trace("[Strategies_Api_Response][UpdateCallKey] Successed");
	    }
	  },
	  "SelectAniManualCall": function SelectAniManualCall(message, that) {
	    var json = JSON.parse(message.Json);
	    if (message.StatusCode === 200) {
	      _Logger.Logger.Trace("[Strategies_Api_Response][SelectAniManualCall] ANIList =>", message);
	      sharedData.setANIListCampaign(json.Response);
	      sharedData.setIsANIListEmpty(false);
	    } else if (message.StatusCode === 204) {
	      _Logger.Logger.Trace("[Strategies_Api_Response][SelectAniManualCall] ANIList =>", message);
	      sharedData.setANIListCampaign([]);
	      sharedData.setIsANIListEmpty(true);
	    }
	  },
	  "GetRecordCallPermission": function GetRecordCallPermission(message, that) {
	    var json = JSON.parse(message.Json);
	    if (message.StatusCode === 200) {
	      _Logger.Logger.Trace("[Strategies_Api_Response][GetRecordCallPermission] GetRecordCallPermission =>", message);
	      sharedData.setAllowMarksPermission(json.Response !== 3);
	    }
	  }
	};

/***/ },
/* 1147 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.STRATEGIES_EXTERNAL_MESSAGING = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(10);
	
	var _singletonSharedData = __webpack_require__(23);
	
	var _dryPopUpNotification = __webpack_require__(2609);
	
	var _dryPopUpNotification2 = _interopRequireDefault(_dryPopUpNotification);
	
	var _globalComponentsLibrary = __webpack_require__(28);
	
	var _lodash = __webpack_require__(293);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _Singleton = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var audio = new Audio(_dryPopUpNotification2.default);
	
	
	var sharedData = new _singletonSharedData.SingletonSharedData();
	var language = new _Singleton.Singleton();
	
	var deleteConvsWhatsapp = function deleteConvsWhatsapp(message, that) {
		var hasUnifiedMessage = that.sharedData.generalPermissions[220] === '1';
		if (hasUnifiedMessage) {
			that.props.endConversationsCampaignDeleted(message);
		}
	};
	
	var STRATEGIES_EXTERNAL_MESSAGING = exports.STRATEGIES_EXTERNAL_MESSAGING = {
		"EXTERNAL_MESSAGING_CUSTOMER": function EXTERNAL_MESSAGING_CUSTOMER(message, that) {
			var hasUnifiedMessage = that.sharedData.generalPermissions[220] === '1';
			if (hasUnifiedMessage) {
				if (sharedData.currentState !== 'Dialog' && sharedData.currentState !== 'Wrapup' && sharedData.currentState !== 'Assisted' && sharedData.currentState !== 'Other') {
					that.props.showUnifiedMessagesWindow(true);
				} else {
					sharedData.setIsPendingMessage(true);
				}
				if (!sharedData.getIsTabFocused()) {
					audio.play();
				}
	
				if (_lodash2.default.has(message, 'externalMessagingCustomerDto.OldConversationID') && message.externalMessagingCustomerDto.OldConversationID !== 0 && _lodash2.default.has(message, 'externalMessagingCustomerDto.OldAgentId') && message.externalMessagingCustomerDto.OldAgentId === sharedData.user.User_id && message.externalMessagingCustomerDto.CampType !== _constants.CAMP_TYPES.OUT && message.externalMessagingCustomerDto.IsAgentLoggingOut === false) {
					that.props.showAdminModal({
						title: that.language.getText('GUIUnifiedInboxnoMoreAgentsAlertTitle'),
						content: that.language.getText('GUIUnifiedInboxnoMoreAgentsAlertMessage'),
						accept: that.language.getText('GUIUnifiedInboxCommonclose')
					});
				}
	
				that.props.newUnifiedInboxExternalMessage(message, that);
			}
		},
		"EXTERNAL_NEW_MESSAGING": function EXTERNAL_NEW_MESSAGING(message, that) {
			var hasUnifiedMessage = that.sharedData.generalPermissions[220] === '1';
			if (hasUnifiedMessage) {
				that.props.newUnifiedInboxExternalNewMessage(message);
	
				if (!sharedData.getIsTabFocused()) {
					audio.play();
				}
			}
		},
		"MULTIMEDIA_MESSAGE_STATUS": function MULTIMEDIA_MESSAGE_STATUS(message, that) {
			var hasUnifiedMessage = that.sharedData.generalPermissions[220] === '1';
			if (hasUnifiedMessage) {
				that.props.changeStateMessage(message);
			}
		},
		"MULTIMEDIA_MESSAGE_TIMEOUT_CLIENT": function MULTIMEDIA_MESSAGE_TIMEOUT_CLIENT(message, that) {
			var hasUnifiedMessage = that.sharedData.generalPermissions[220] === '1';
			if (hasUnifiedMessage) {
				that.props.conversationTimeoutReached(message);
			}
		},
		"MULTIMEDIA_MESSAGE_ERROR_MMC": function MULTIMEDIA_MESSAGE_ERROR_MMC(message, that) {
			var hasUnifiedMessage = that.sharedData.generalPermissions[220] === '1';
			if (hasUnifiedMessage) {
				that.props.alertMessageErrorMMC(message);
				if (message.value) {
					sharedData.setPrevNotificationError(message.value);
					that.showDialogBox({
						title: language.getText("GUIUnifiedInboxTitleAlertErrorMCS"),
						content: language.getText("GUIUnifiedInboxBodyAlertErrorMCS"),
						accept: language.getText("GUIUnifiedInboxAceptAlertErrorMCS")
					});
				} else {
					if (sharedData.getPrevNotificationError()) {
						sharedData.setPrevNotificationError(false);
						that.props.addToast(language.getText('GUIUnifiedInboxBodyAlertSuccessMCS'), {
							group: 'icon',
							position: 'topRight',
							icon: 'warning',
							color: 'yellow',
							btnComponent: _react2.default.createElement(
								_globalComponentsLibrary.AgentButton,
								{ type: 'tertiary' },
								language.getText("GUIUnifiedInboxAceptAlertSuccessMCS")
							),
							timeout: 5000
						});
					}
				}
			}
		},
		"DELETE_WA_CAMPAIGN": function DELETE_WA_CAMPAIGN(message, that) {
			deleteConvsWhatsapp(message, that);
		},
		"MULTIMEDIA_END_CONVERSATIONWA_ERROR": function MULTIMEDIA_END_CONVERSATIONWA_ERROR(message, that) {
			deleteConvsWhatsapp(message, that);
		},
		"MULTIMEDIA_MESSAGE_HISTORICAL_CHAT": function MULTIMEDIA_MESSAGE_HISTORICAL_CHAT(message, that) {
			var hasUnifiedMessage = that.sharedData.generalPermissions[220] === '1';
			if (hasUnifiedMessage) {
				if (message.Data.ResponseCode === 200) {
					that.props.newHistoricalConversation(message);
				} else {
					that.props.errorOnHistoricalConversation(message);
					that.showDialogBox({
						title: language.getText("GUIUnifiedInboxlastConversationErrorTitle"),
						content: language.getText("error-8003"),
						accept: language.getText("GUIUnifiedInboxlastConversationErrorCommit")
					});
				}
			}
		},
		"UPDATE_PERMISSION": function UPDATE_PERMISSION(message, that) {
			var hasUnifiedMessage = that.sharedData.generalPermissions[220] === '1';
			if (hasUnifiedMessage) {
				var permissionTitle = message.PermissionValue ? that.language.getText('GUIUnifiedInboxPermissionGrantedTitle') : that.language.getText('GUIUnifiedInboxPermissionRemovedTitle');
	
				//TODO: Faltan mensajes para permiso SPAM
				var permissionBody = '';
				if (message.PermissionName === _constants.UNIFIED_INBOX_PERMISSIONS.AllowUnassign) {
					permissionBody = message.PermissionValue ? that.language.getText('GUIUnifiedInboxPermissionGrantedBody') : that.language.getText('GUIUnifiedInboxPermissionRemovedBody');
				}
	
				if (permissionBody) {
					that.props.showAdminModal({
						title: permissionTitle,
						content: permissionBody,
						accept: that.language.getText('GUIUnifiedInboxPermissionMssgsCommit')
					});
				}
	
				that.props.updatePermissions(message.PermissionName, message.PermissionValue);
			}
		},
		"MULTIMEDIA_UPDATE_NUMBERWA_TO_CONVERSATIONS": function MULTIMEDIA_UPDATE_NUMBERWA_TO_CONVERSATIONS(message, that) {
			var hasUnifiedMessage = that.sharedData.generalPermissions[220] === '1';
			if (hasUnifiedMessage) {
				that.props.updateConversationsPhoneChange(message);
			}
		}
	};

/***/ },
/* 1148 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var STRATEGIES_CONNECT_CALL = exports.STRATEGIES_CONNECT_CALL = {
	    "RingingListening": function RingingListening(message, that) {
	        if (that.sharedData.getDataPreviewPro().dialingMode === 1 && that.sharedData.getDoConnectCall() && that.props.preview.simultaneosRecs) {
	            that.sharedData.setDoConnectCall(false);
	            that.connectCall(message, that.sharedData.getParameters().UserID);
	        } else {
	            that.connectCall(message, that.sharedData.getParameters().UserID);
	        }
	    }
	
	};

/***/ },
/* 1149 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.STRATEGIES_PREVIEW_TRANSFER = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _globalComponentsLibrary = __webpack_require__(28);
	
	var _constants = __webpack_require__(10);
	
	var _formats = __webpack_require__(54);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var STRATEGIES_PREVIEW_TRANSFER = exports.STRATEGIES_PREVIEW_TRANSFER = {
	    "GetAnswerTransfer": function GetAnswerTransfer(message, that) {
	        var maxTime = 30000;
	        var maxTimeMessage = maxTime + 100;
	        var clear = setTimeout(function () {
	            that.props.addToast(that.language.getText('CallControlGUICallTransfermissed-xfer-mssg').replace('[N]', message.mainAgent), {
	                title: that.language.getText('CallControlGUICallTransfermissed-xfer-title'),
	                group: 'icon',
	                position: 'topRight',
	                icon: '',
	                color: 'blue',
	                btnComponent: _react2.default.createElement(
	                    _globalComponentsLibrary.AgentButton,
	                    { type: 'tertiary' },
	                    that.language.getText("GUIAlertMessageok")
	                ),
	                timeout: 5000
	            });
	        }, maxTimeMessage);
	        that.props.showAlertModal({
	            type: "ModalAlert",
	            title: that.language.getText("GUIAlertTransfertitle"),
	            message: that.language.getText("GUIAlertTransfermessage").replace('[N]', message.mainAgent),
	            button: that.language.getText("GUIAlertTransferdeny"),
	            secondButton: that.language.getText("GUIAlertTransferadmit"),
	            timeout: maxTime,
	            timeoutFun: function timeoutFun() {
	                that.props.actionResponseTransfer(message.mainAgent, 0);
	            },
	            secondButtonFtn: function secondButtonFtn() {
	                if (!that.props.preview.simultaneosRecs) {
	                    var time = (0, _formats.getCurrentTimeInSec)();
	                    var previewTime = time - that.props.preview.initialTimeSec + that.props.preview.totalPreviewTime;
	                    if (that.props.userState.currentState === _constants.USER_STATE.AGENT_PREVIEW) {
	                        that.props.actionPreviewRecord({
	                            process: 4,
	                            camId: that.props.preview.camId,
	                            callOutId: that.props.preview.callOutId,
	                            previewTime: previewTime,
	                            callId: 0
	                        });
	                    }
	                } else {
	                    that.props.setUnnasignByXfer({ flag: true, mainAgent: message.mainAgent });
	                }
	                if (!that.props.preview.simultaneosRecs || that.props.preview.simultaneosRecs && that.props.preview.records.length === 0) {
	                    setTimeout(function () {
	                        that.props.cleanData();
	                    }, 100);
	                    setTimeout(function () {
	                        that.props.showPreviewData(false);
	                    }, 100);
	                    setTimeout(function () {
	                        that.props.actionResponseTransfer(message.mainAgent, 1);
	                    }, 100);
	                }
	                clearTimeout(clear);
	            },
	            buttonFun: function buttonFun() {
	                that.props.actionResponseTransfer(message.mainAgent, 0);
	                clearTimeout(clear);
	            }
	
	        });
	    },
	    "SendAnswerTransfer": function SendAnswerTransfer(message, that) {
	        var msg = '';
	        var titleAlert = '';
	        if (message.answerTransfer !== 1) {
	            that.props.showAlert();
	            switch (message.answerTransfer) {
	                case 0:
	                    msg = that.language.getText("GUIAlertTransferagentRejected").replace('[N]', message.username);
	                    titleAlert = that.language.getText("GUIAlertTransferrejectedTitle");
	                    that.props.assistedErrorTransfer(true);
	                    break;
	                case 2:
	                    msg = that.language.getText("GUIAlertTransferagentSwitchedError");
	                    titleAlert = that.language.getText("GUIAlertTransfertransferError");
	                    break;
	                case 4:
	                    msg = that.language.getText("GUIAlertTransferagentBusy");
	                    titleAlert = that.language.getText("GUIAlertTransfertransferError");
	                    break;
	                default:
	                    msg = that.language.getText("GUIAlertTransferunexpectedError");
	                    titleAlert = that.language.getText("GUIAlertTransfertransferError");
	                    break;
	            }
	
	            that.props.addToast(msg, {
	                group: 'icon',
	                position: 'topRight',
	                title: titleAlert,
	                color: 'red',
	                btnComponent: _react2.default.createElement(
	                    _globalComponentsLibrary.AgentButton,
	                    { type: 'tertiary' },
	                    that.language.getText("GUIAlertTransferclose")
	                ),
	                timeout: 5000,
	                onDismiss: that.props.showAlert()
	            });
	
	            that.props.onAcceptedTransfer(false);
	            that.props.setTransferInProgress(false);
	        } else {
	            that.props.onAcceptedTransfer(true);
	        }
	    }
	};

/***/ },
/* 1150 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.STRATEGIES_REDUCER_INTEGRATION = undefined;
	
	var _SingletonWebSocket = __webpack_require__(50);
	
	var _SingletonWebSocket2 = _interopRequireDefault(_SingletonWebSocket);
	
	var _cwGalateaApiJsBundle = __webpack_require__(40);
	
	var _constants = __webpack_require__(10);
	
	var _Logger = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var APIFact = new _cwGalateaApiJsBundle.APIFactory();
	var STRATEGIES_REDUCER_INTEGRATION = exports.STRATEGIES_REDUCER_INTEGRATION = {
	    "Logout": function Logout(that, message) {
	        _Logger.Logger.Trace("[Strategies_Reducer_Integration][Logout] Logout");
	        that.props.logout();
	    },
	    "getUnavailables": function getUnavailables(that, message) {
	        _Logger.Logger.Trace("[Strategies_Reducer_Integration][getUnavailables] getUnavailables");
	        var objectResponse = that.apiCont.getObjectResponse();
	        that.apiCont.getListNoAvailable(that.sharedData.getParameters().UserID, objectResponse, that.sharedData.getRequestTimeout());
	        objectResponse.onError = function (messageError) {
	            var type = messageError.Type;
	            var code = messageError.InternalCode;
	            var error = that.language.getText(type.toLowerCase() + '-' + code);
	            _Logger.Logger.Warning("[Strategies_Reducer_Integration][getUnavailables] Error consulting data base =>", error);
	            var integrationMessage = { client: "galatea", data: { code: code, message: error }, action: "errorOnUnavailableStatus" };
	            _SingletonWebSocket2.default.send(integrationMessage);
	        };
	        objectResponse.onSuccess = function (objResponse) {
	            _Logger.Logger.Trace("[Strategies_Reducer_Integration][getUnavailables] Sending unavailables to integration =>", objResponse.Response);
	            var message = { client: "galatea", data: objResponse.Response, action: "getUnavailables" };_SingletonWebSocket2.default.send(message);
	        };
	    },
	    "SupervisorsToChat": function SupervisorsToChat(that, message) {
	        _Logger.Logger.Trace("[Strategies_Reducer_Integration][SupervisorsToChat] SupervisorsToChat");
	        var apiCont = APIFact.buildClient();
	        var objectResponse = apiCont.getObjectResponse();
	        _Logger.Logger.Trace("[Strategies_Reducer_Integration][SupervisorsToChat] Looking for Supervisor List");
	        apiCont.getSupervisorList(message, objectResponse);
	        objectResponse.onError = function (messageError) {
	            _Logger.Logger.Warning("[Strategies_Reducer_Integration][SupervisorsToChat] Error Supervisor List =>", messageError);
	        };
	        objectResponse.onSuccess = function (objResponse) {
	            _Logger.Logger.Trace("[Strategies_Reducer_Integration][SupervisorsToChat] Supervisor List =>", objResponse);
	            _SingletonWebSocket2.default.send(_SingletonWebSocket2.default.getJson(_constants.INTEGRATION.CHAT, _constants.INTEGRATION_SUBACTION.CHAT_SUPERVISORS, objResponse));
	        };
	    },
	    "setUnavailable": function setUnavailable(that, message) {
	        _Logger.Logger.Trace("[Strategies_Reducer_Integration][setUnavailable] setUnavailable");
	        var _that = that;
	        that.props.sendMessageNoAvailable(_that.sharedData.getUserData().Login, _that.sharedData.getParameters().UserID, message.unavailableID, 0);
	    },
	    "setReady": function setReady(that, message) {
	        _Logger.Logger.Trace("[Strategies_Reducer_Integration][setReady] setReady");
	        that.props.messageChangeState();
	    },
	    "CallAction": function CallAction(that, message) {
	        _Logger.Logger.Trace("[Strategies_Reducer_Integration][CallAction] CallAction");
	        if (message.callAction === "UpdateDataCall") {
	            var obj = that.state.dataCall;
	            obj.DataContact = message.data;
	        }
	    },
	    "transferCallToACD": function transferCallToACD(that, message) {
	        _Logger.Logger.Trace("[Strategies_Reducer_Integration][transferCallToACD] transferCallToACD");
	        that.props.messageTransferCall(message.data);
	    },
	    "transferCallToAgent": function transferCallToAgent(that, message) {
	        _Logger.Logger.Trace("[Strategies_Reducer_Integration][transferCallToAgent] transferCallToAgent");
	        that.props.messageTransferCall(message.data);
	    },
	    "transferCallToPhoneNumber": function transferCallToPhoneNumber(that, message) {
	        _Logger.Logger.Trace("[Strategies_Reducer_Integration][transferCallToPhoneNumber] transferCallToPhoneNumber");
	        that.props.messageTransferCall(message.data);
	    },
	    "getUnavailableHistory": function getUnavailableHistory(that, message) {
	        _Logger.Logger.Trace("[Strategies_Reducer_Integration][getUnavailableHistory] getUnavailableHistory");
	        var objectResponse = that.apiCont.getObjectResponse();
	        that.apiCont.getNotReadyHistory(that.sharedData.getParameters().UserID, objectResponse);
	        objectResponse.onError = function (messageError) {
	            var type = messageError.Type;
	            var code = messageError.InternalCode;
	            var error = that.language.getText(type.toLowerCase() + '-' + code);
	            _Logger.Logger.Warning("[Strategies_Reducer_Integration][getUnavailableHistory] Error consulting data base =>", error);
	            var integrationMessage = { client: "galatea", data: { code: code, message: error }, action: "errorOnUnavailableStatusHistory" };
	            _SingletonWebSocket2.default.send(integrationMessage);
	        };
	        objectResponse.onSuccess = function (objResponse) {
	            _Logger.Logger.Trace("[Strategies_Reducer_Integration][getUnavailableHistory] Sending History to integration =>", objResponse.Response);
	            var message = { client: "galatea", data: objResponse.Response, action: "onUnavailableHistory" };
	            _SingletonWebSocket2.default.send(message);
	        };
	    },
	    "GetAgentID": function GetAgentID(that, message) {
	        _Logger.Logger.Trace("[Strategies_Reducer_Integration][GetAgentID] GetAgentID");
	        var messageAgentID = { client: "galatea", data: that.sharedData.getParameters().UserID, action: "GetAgentID" };
	        _SingletonWebSocket2.default.send(messageAgentID);
	    },
	    "GetUserName": function GetUserName(that, message) {
	        _Logger.Logger.Trace("[Strategies_Reducer_Integration][GetUserName] GetUserName");
	        var messageUserName = { client: "galatea", data: that.sharedData.getUserData().Login, action: "GetUserName" };
	        _SingletonWebSocket2.default.send(messageUserName);
	    },
	    "GetExtension": function GetExtension(that, message) {
	        _Logger.Logger.Trace("[Strategies_Reducer_Integration][GetExtension] GetExtension");
	        var messageExtension = { client: "galatea", data: that.sharedData.getParameters().Extension, action: "GetExtension" };
	        _SingletonWebSocket2.default.send(messageExtension);
	    }
	};

/***/ },
/* 1151 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.STRATEGIES_SM_TO_INTEGRATION = undefined;
	
	var _SingletonWebSocket = __webpack_require__(50);
	
	var _SingletonWebSocket2 = _interopRequireDefault(_SingletonWebSocket);
	
	var _constants = __webpack_require__(10);
	
	var _Logger = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var STRATEGIES_SM_TO_INTEGRATION = exports.STRATEGIES_SM_TO_INTEGRATION = {
	    "chatAdmin": function chatAdmin(that, message) {
	        _Logger.Logger.Trace("[Strategies_SM_To_Integration][chatAdmin] chatAdmin");
	        var data = {
	            administrator: message.From,
	            message: message.Message
	        };
	        _SingletonWebSocket2.default.send(_SingletonWebSocket2.default.getJson(_constants.INTEGRATION.CHAT, _constants.INTEGRATION_SUBACTION.CHAT_NEW_MESSAGE, data));
	    }
	};

/***/ },
/* 1152 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.SOFTPHONE_HANGUP = exports.SOFTPHONE_PARAMETERS = exports.SOFTPHONE_MAKECALL = exports.SOFTPHONE_VALIDATING = exports.SOFTPHONE_CALLBACKS = undefined;
	
	var _SOFTPHONE_CALLBACKS, _SOFTPHONE_VALIDATING, _SOFTPHONE_MAKECALL, _SOFTPHONE_PARAMETERS, _SOFTPHONE_HANGUP;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _constants = __webpack_require__(10);
	
	var _helperMessages = __webpack_require__(87);
	
	var _Logger = __webpack_require__(37);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var SOFTPHONE_CALLBACKS = exports.SOFTPHONE_CALLBACKS = (_SOFTPHONE_CALLBACKS = {}, _defineProperty(_SOFTPHONE_CALLBACKS, _constants.SOFTPHONES_KEY.WEBRTC, function (that) {
		_Logger.Logger.Trace('[Strategies_SoftPhone][SOFTPHONE_CALLBACKS] SIP method');
		var _that = that;
		that.agentController.AgentObject.onSipAccepted = function () {
			_Logger.Logger.Trace('[Strategies_SoftPhone][SOFTPHONE_CALLBACKS] SIP Accepted');
			if (!_that.sharedData.getLogged()) {
				_that.props.validatingState(_constants.VALIDATING_TELEPHONY.VALIDATING, _that.telephonyTime);
				_that.sendToRabbit(_constants.SM_QUEUE_SERVER, (0, _helperMessages.messageFirstCall)(_that.sharedData.getUserData().Login, _that.sharedData.getParameters().UserID));
				var sipID = 'sip:' + _that.sharedData.getParameters().Extension + '|' + _that.sharedData.getParameters().UserID + '|0';
				setTimeout(function () {
					_that.makeCall(sipID);
				}, 500);
			}
		};
		that.agentController.AgentObject.onSipRejected = function () {
			_Logger.Logger.Trace('[Strategies_SoftPhone][SOFTPHONE_CALLBACKS] SIP Rejected');
		};
		that.agentController.AgentObject.onCallEntry = function () {
			_Logger.Logger.Trace('[Strategies_SoftPhone][SOFTPHONE_CALLBACKS] Incoming Call');
		};
		that.agentController.AgentObject.uiCallTerminated = function () {
			_Logger.Logger.Trace('[Strategies_SoftPhone][SOFTPHONE_CALLBACKS] Call Finished');
		};
		that.agentController.AgentObject.onCallAnswered = function () {
			_Logger.Logger.Trace('[Strategies_SoftPhone][SOFTPHONE_CALLBACKS] Call Answered');
		};
		that.agentController.AgentObject.onCallRejected = function () {
			_Logger.Logger.Trace('[Strategies_SoftPhone][SOFTPHONE_CALLBACKS] Call Rejected');
		};
		that.agentController.AgentObject.onTransportDisconnected = function (parameter) {
			_Logger.Logger.Warn('TRANSPORT DISCONNECTED REASON:', parameter);
			if (that.rabbitConnected) {
				if (parameter.attempt < 50) {
					that.props.showAlertModal({
						type: 'ModalAlert',
						title: that.language.getText('GUIErrorMessagetitle'),
						message: that.language.getText('error-8001') + ' ' + parameter.attempt,
						button: that.language.getText('GUIErrorMessageclose')
					});
				} else {
					that.props.showAlertModal({
						type: 'ModalError',
						title: that.language.getText('GUIErrorMessagetitle'),
						message: that.language.getText('error-1'),
						button: that.language.getText('GUITelephonyValidatorreconnect'),
						secondButtonFtn: function secondButtonFtn() {},
						buttonFun: function buttonFun() {
							that.logOut();
						}
					});
				}
			}
		};
		that.agentController.AgentObject.onTransportConnected = function () {
			if (that.rabbitConnected) {
				_Logger.Logger.Info('TRANSPORT CONNECTED');
				that.props.hideAlertModal();
			}
		};
		that.agentController.AgentObject.onDataStreamInfo = function (streamLevel, message) {
			if (streamLevel > 1) {
				_Logger.Logger.Warn('[Strategies_SoftPhone][SOFTPHONE_CALLBACKS][Stream_Information]', message);
			}
			that.props.streamFromSip(streamLevel);
		};
	
		that.agentController.AgentObject.onChangeDeviceList = function (audioList) {
			_Logger.Logger.Warn('onChangeDeviceList', audioList);
			for (var i in audioList) {
				var device = audioList[i];
	
				var _device$kind$match = device.kind.match(/(\w+)(input|output)/i),
				    _device$kind$match2 = _slicedToArray(_device$kind$match, 1),
				    direction = _device$kind$match2[0];
	
				if (direction === 'audio') {
					console.log('onChangeDeviceList', { label: device.label, direction: direction });
				}
			}
		};
	
		that.agentController.AgentObject.onGetStreamMicFail = function () {
			_Logger.Logger.Warn('[Strategies_SoftPhone][SOFTPHONE_CALLBACKS] onGetStreamMicFail');
			that.props.showAlertModal({
				type: 'ModalError',
				title: that.language.getText('GUIErrorMessagetitle'),
				message: that.language.getText('error-8002'),
				button: that.language.getText('GUIErrorMessageclose'),
				secondButtonFtn: function secondButtonFtn() {},
				buttonFun: function buttonFun() {}
			});
		};
	}), _defineProperty(_SOFTPHONE_CALLBACKS, _constants.SOFTPHONES_KEY.MIZUJS, function () {
		_Logger.Logger.Trace('[Strategies_SoftPhone][SOFTPHONE_CALLBACKS] Mizu method');
	}), _SOFTPHONE_CALLBACKS);
	
	var SOFTPHONE_VALIDATING = exports.SOFTPHONE_VALIDATING = (_SOFTPHONE_VALIDATING = {}, _defineProperty(_SOFTPHONE_VALIDATING, _constants.SOFTPHONES_KEY.WEBRTC, function () {
		_Logger.Logger.Trace('[Strategies_SoftPhone][SOFTPHONE_VALIDATING] SIP method');
	}), _defineProperty(_SOFTPHONE_VALIDATING, _constants.SOFTPHONES_KEY.MIZUJS, function (that) {
		_Logger.Logger.Trace('[Strategies_SoftPhone][SOFTPHONE_VALIDATING] Mizu method');
		that.props.validatingState(_constants.VALIDATING_TELEPHONY.VALIDATING, that.telephonyTime);
		that.sendToRabbit(_constants.SM_QUEUE_SERVER, (0, _helperMessages.messageFirstCall)(that.sharedData.getUserData().Login, that.sharedData.getParameters().UserID));
	}), _SOFTPHONE_VALIDATING);
	
	var SOFTPHONE_MAKECALL = exports.SOFTPHONE_MAKECALL = (_SOFTPHONE_MAKECALL = {}, _defineProperty(_SOFTPHONE_MAKECALL, _constants.SOFTPHONES_KEY.WEBRTC, function (that, message, userID) {
		that.parametersEngine();
		that.setIpEngine(message.EngineId, that.Engines[message.EngineId]);
		var sipID = 'sip:' + that.sharedData.getParameters().Extension + '|' + userID + '|' + message.CallId;
		var _that = that;
		_Logger.Logger.Trace('SIP-URI updated:' + sipID);
		setTimeout(function () {
			_that.makeCall(sipID);
		}, 200);
	}), _defineProperty(_SOFTPHONE_MAKECALL, _constants.SOFTPHONES_KEY.MIZUJS, function () {}), _SOFTPHONE_MAKECALL);
	
	var SOFTPHONE_PARAMETERS = exports.SOFTPHONE_PARAMETERS = (_SOFTPHONE_PARAMETERS = {}, _defineProperty(_SOFTPHONE_PARAMETERS, _constants.SOFTPHONES_KEY.WEBRTC, function (that) {
		_Logger.Logger.Trace('[STRATEGIES_SOFTPHONE][WEB_RTC] Reading setting 183 for WebRTC Configuration');
		var SipParameters = that.sharedData.getGeneralPermissions()[183];
		_Logger.Logger.Debug('[STRATEGIES_SOFTPHONE][WEB_RTC] WebRTC configuration: ', SipParameters);
		var settingSIP = SipParameters.split('|');
	
		_Logger.Logger.Trace('[STRATEGIES_SOFTPHONE][WEB_RTC] Reading setting 143 for Engine Position');
		var setting143 = that.sharedData.getGeneralPermissions()[143];
		_Logger.Logger.Debug('[STRATEGIES_SOFTPHONE][WEB_RTC] Engine Position: ', setting143);
		if (!setting143) {
			_Logger.Logger.Warn('[STRATEGIES_SOFTPHONE][WEB_RTC] Not Config: ', setting143);
		}
	
		var ipKamailio = setting143.split('|');
	
		ipKamailio = ipKamailio[1].split(',');
		var stunServers = settingSIP[6].replace(/\\/g, '');
		try {
			stunServers = JSON.parse(stunServers);
		} catch (e) {
			_Logger.Logger.Error('[STRATEGIES_SOFTPHONE][WEB_RTC] invalid stun server', e);
		}
		that.agentController.AgentObject.SIP_wsServers = [settingSIP[1]];
		that.agentController.AgentObject.SIP_authorizationUser = settingSIP[2].replaceAll('#UserIP#', that.sharedData.getIPfromAPI());
		that.agentController.AgentObject.SIP_uri = settingSIP[3].replaceAll('#UserIP#', that.sharedData.getIPfromAPI());
		that.agentController.AgentObject.SIP_password = settingSIP[4];
		that.agentController.AgentObject.SIP_userAgentString = 'Nuxiba-WebRTC';
		that.agentController.AgentObject.SIP_stunServers = stunServers;
		that.agentController.AgentObject.SIP_register = false;
		that.agentController.AgentObject.SIP_iceCheckingTimeout = 750;
		that.agentController.setUserId(_Logger.Logger.getUserID());
		that.setIpEngine(0, ipKamailio[0]);
	}), _defineProperty(_SOFTPHONE_PARAMETERS, _constants.SOFTPHONES_KEY.MIZUJS, function (that, parameterMizu) {
		var MizuParameters = that.sharedData.getGeneralPermissions()[131];
		var encrpytionMode = parseInt(that.sharedData.getGeneralPermissions()[132], 10);
		var primaryServer = that.sharedData.getGeneralPermissions()[133];
		var secondaryServer = that.sharedData.getGeneralPermissions()[134];
	
		var encryptionServer = '';
		var useEncryption = true;
		switch (encrpytionMode) {
			case 1:
				encryptionServer = primaryServer;
				break;
			case 2:
				encryptionServer = secondaryServer;
				break;
			case 3:
				encryptionServer = Math.random() > 0.5 ? primaryServer : secondaryServer;
				break;
			default:
				encryptionServer = '';
				useEncryption = false;
				break;
		}
	
		var arrayMizuParameters = MizuParameters.split('|');
		var mizuCodecPriority = parseInt(arrayMizuParameters[0], 10);
		var mizuUseStun = arrayMizuParameters[1];
		var mizuUseRport = arrayMizuParameters[2];
		var mizuLogLevel = parseInt(arrayMizuParameters[3], 10);
		var mizuVolumeSpeaker = parseInt(arrayMizuParameters[4], 10);
		var mizuVolumePlayback = parseInt(arrayMizuParameters[5], 10);
		_Logger.Logger.Info('[Strategies_Softphone] mizuVolumeSpeaker', mizuVolumeSpeaker);
		_Logger.Logger.Info('[Strategies_Softphone] mizuVolumePlayback', mizuVolumePlayback);
		var mizuDtmfMode = arrayMizuParameters[6];
	
		mizuVolumePlayback = mizuVolumePlayback > 100 ? 100 : mizuVolumePlayback <= 0 ? 50 : mizuVolumePlayback;
		mizuLogLevel = mizuLogLevel === 0 ? 1 : mizuLogLevel;
	
		var prefCodec = 'pcmu';
	
		var mizuUseG711u = 2;
		var mizuUseG711a = 2;
		var mizuUseG729 = 2;
	
		switch (mizuCodecPriority) {
			case 1:
				prefCodec = 'pcmu';
				mizuUseG711u = 3;
				break;
			case 2:
				prefCodec = 'pcma';
				mizuUseG711a = 3;
				break;
			case 3:
				prefCodec = 'g729';
				mizuUseG729 = 3;
				break;
			default:
				break;
		}
	
		var remote = 0;
	
		var parameters = {
			serveraddress: '127.0.0.1',
			localip: that.sharedData.getParameters().ClientComp,
			username: 'Centerware',
			password: 'passwordless',
			realm: 'asterisk',
			register: '0', //0,1,2
			autoaccept: 'true',
			automute: '0',
			dtmfmode: mizuDtmfMode,
			signalingport: '5060',
			rtpport: '49000',
			ringtone: mizuVolumeSpeaker,
			volumein: mizuVolumeSpeaker,
			volumeout: mizuVolumePlayback,
			loglevel: mizuLogLevel,
			logtoconsole: mizuLogLevel === 5,
			prefcodec: prefCodec,
			checkvolumesettings: 2,
			video: 0,
			vad: 1,
			resetsettings: true,
			aec: 0,
			aec2: 0,
			agc: 0,
			denoise: 0,
			codec: '"' + prefCodec + '",use_pcmu=' + mizuUseG711u + ',use_pcma=' + mizuUseG711a + ',use_g729=' + mizuUseG729,
			beeponconnect: 0,
			beeponincoming: 0,
			ringincall: 0
		};
	
		if (remote === 1) {
			parameters.use_rport = mizuUseRport;
			parameters.use_fast_stun = mizuUseStun;
			if (useEncryption) {
				parameters.serveraddress = encryptionServer;
				parameters.autotransportdetect = true;
			}
		}
	
		if (parameterMizu) {
			_Logger.Logger.Trace('[Strategies_SoftPhone][SOFTPHONE_PARAMETERS] Parameters to MIZU manifest.json => ', parameterMizu);
			for (var i in parameterMizu) {
				parameters[i] = parameterMizu[i];
			}
		}
	
		_Logger.Logger.Debug('[Strategies_SoftPhone][SOFTPHONE_PARAMETERS] Parameters to MIZU => ', parameters);
		that.agentController.sipController.setParametersSofPhone(parameters);
	}), _SOFTPHONE_PARAMETERS);
	var SOFTPHONE_HANGUP = exports.SOFTPHONE_HANGUP = (_SOFTPHONE_HANGUP = {}, _defineProperty(_SOFTPHONE_HANGUP, _constants.SOFTPHONES_KEY.WEBRTC, function (that) {
		_Logger.Logger.Trace('[Strategies_SoftPhone][SOFTPHONE_HANGUP] Hangup WEBRTC');
		that.agentController.hangUp();
	}), _defineProperty(_SOFTPHONE_HANGUP, _constants.SOFTPHONES_KEY.MIZUJS, function (that) {
		_Logger.Logger.Trace('[Strategies_SoftPhone][SOFTPHONE_HANGUP] Hangup MIZU');
		that.sendToRabbit(_constants.SM_QUEUE_SERVER, (0, _helperMessages.messageHangUp)(_constants.HANG_UP_SUBACTIONS.FISRT_CALL, 0));
	}), _SOFTPHONE_HANGUP);

/***/ },
/* 1153 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.animationCircle = animationCircle;
	function animationCircle(posX, posY, parent, element) {
	  var divDin = element.cloneNode();
	  divDin.style.left = posX + "px";
	  divDin.style.top = posY + "px";
	  divDin.className = "buttonAnimation";
	  parent.appendChild(divDin);
	  setTimeout(function () {
	    divDin.parentNode.removeChild(divDin);
	  }, 1500);
	}

/***/ },
/* 1154 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.CUSTOM_AGENT_STATE = undefined;
	
	var _CUSTOM_AGENT_STATE;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(10);
	
	var _Images = __webpack_require__(30);
	
	var _AgentStatusSVG = __webpack_require__(488);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var CUSTOM_AGENT_STATE = exports.CUSTOM_AGENT_STATE = (_CUSTOM_AGENT_STATE = {}, _defineProperty(_CUSTOM_AGENT_STATE, _constants.USER_STATE.LOGED_OUT, _react2.default.createElement('img', { src: _Images.EstadoAgenteNoDisponible, alt: 'Agent State', width: '32', height: '32' })), _defineProperty(_CUSTOM_AGENT_STATE, _constants.USER_STATE.LOGED_IN, _react2.default.createElement('img', { src: _Images.EstadoAgenteNoDisponible, alt: 'Agent State', width: '32', height: '32' })), _defineProperty(_CUSTOM_AGENT_STATE, _constants.USER_STATE.RINGING, _react2.default.createElement(
	    'div',
	    { className: 'Icon' },
	    _react2.default.createElement(
	        'div',
	        { className: 'AgentReadyAnimation' },
	        ' ',
	        _AgentStatusSVG.EstadoAgenteDispLlamManual
	    )
	)), _defineProperty(_CUSTOM_AGENT_STATE, _constants.USER_STATE.NO_AVAILABLE, _react2.default.createElement(
	    'div',
	    { className: 'Icon' },
	    _react2.default.createElement(
	        'div',
	        { className: 'NoAvailableAnimation' },
	        ' ',
	        _AgentStatusSVG.EstadoAgenteNoDisponibleAni
	    )
	)), _defineProperty(_CUSTOM_AGENT_STATE, _constants.USER_STATE.MANUAL_CALL, _react2.default.createElement(
	    'div',
	    { className: 'Icon' },
	    _react2.default.createElement(
	        'div',
	        { className: 'XferAnimation rotated' },
	        ' ',
	        _AgentStatusSVG.DialingCall
	    )
	)), _defineProperty(_CUSTOM_AGENT_STATE, _constants.USER_STATE.WAITING_TRANSFER, _react2.default.createElement(
	    'div',
	    { className: 'Icon' },
	    _react2.default.createElement(
	        'div',
	        { className: 'WatingTransferAnimation' },
	        ' ',
	        _AgentStatusSVG.EstadoAgenteTransferenciaAni
	    )
	)), _defineProperty(_CUSTOM_AGENT_STATE, _constants.USER_STATE.CALL_TRANSFER, _react2.default.createElement(
	    'div',
	    { className: 'Icon' },
	    _react2.default.createElement(
	        'div',
	        { className: 'CallTransferAnimation' },
	        ' ',
	        _AgentStatusSVG.EstadoAgenteTransferenciaAni
	    )
	)), _defineProperty(_CUSTOM_AGENT_STATE, _constants.USER_STATE.OTHER, _react2.default.createElement(
	    'div',
	    { className: 'Icon' },
	    _react2.default.createElement(
	        'div',
	        { className: 'OtherAnimation' },
	        ' ',
	        _AgentStatusSVG.EstadoAgenteTransferenciaAni
	    )
	)), _defineProperty(_CUSTOM_AGENT_STATE, _constants.USER_STATE.WRAPUP, _react2.default.createElement(
	    'div',
	    { className: 'Icon' },
	    _react2.default.createElement(
	        'div',
	        { className: 'WrapupAnimation' },
	        ' ',
	        _AgentStatusSVG.EstadoAgenteNotas
	    )
	)), _defineProperty(_CUSTOM_AGENT_STATE, _constants.USER_STATE.AGENT_READY, _react2.default.createElement(
	    'div',
	    { className: 'Icon' },
	    _react2.default.createElement(
	        'div',
	        { className: 'AgentReadyAnimation' },
	        ' ',
	        _AgentStatusSVG.EstadoAgenteDispLlamManual
	    )
	)), _defineProperty(_CUSTOM_AGENT_STATE, _constants.USER_STATE.DIALOG, _react2.default.createElement(
	    'div',
	    { className: 'Icon' },
	    _react2.default.createElement(
	        'div',
	        { className: 'DialogAnimation' },
	        ' ',
	        _AgentStatusSVG.DialogCall
	    )
	)), _defineProperty(_CUSTOM_AGENT_STATE, _constants.USER_STATE.CALL_OUT, _react2.default.createElement(
	    'div',
	    { className: 'Icon' },
	    _react2.default.createElement(
	        'div',
	        { className: 'DialingAnimation' },
	        ' ',
	        _AgentStatusSVG.DialingCall
	    )
	)), _defineProperty(_CUSTOM_AGENT_STATE, _constants.USER_STATE.XFER, _react2.default.createElement(
	    'div',
	    { className: 'Icon' },
	    _react2.default.createElement(
	        'div',
	        { className: 'XferAnimation' },
	        ' ',
	        _AgentStatusSVG.DialingCall
	    )
	)), _defineProperty(_CUSTOM_AGENT_STATE, _constants.USER_STATE.EXCLUSIVE_CALLBACK, _react2.default.createElement(
	    'div',
	    { className: 'Icon' },
	    _react2.default.createElement(
	        'div',
	        { className: 'noneClass' },
	        ' ',
	        _AgentStatusSVG.iconExlcusiveCallBackState
	    )
	)), _defineProperty(_CUSTOM_AGENT_STATE, _constants.USER_STATE.ERROR, _react2.default.createElement(
	    'div',
	    { className: 'Icon' },
	    _react2.default.createElement(
	        'div',
	        { className: 'ErrorAnimation' },
	        ' ',
	        _AgentStatusSVG.EstadoAgenteError
	    )
	)), _defineProperty(_CUSTOM_AGENT_STATE, _constants.USER_STATE.CHATTING, _react2.default.createElement(
	    'div',
	    { className: 'Icon Chatting' },
	    _react2.default.createElement(
	        'div',
	        { className: 'ChattingAnimation' },
	        ' ',
	        _react2.default.createElement(_AgentStatusSVG.EstadoAgenteMedios, { height: '1.8rem' })
	    )
	)), _defineProperty(_CUSTOM_AGENT_STATE, _constants.USER_STATE.READY_PREVIEW, _react2.default.createElement(
	    'div',
	    { className: 'Icon' },
	    _react2.default.createElement(
	        'div',
	        { className: 'AgentReadyAnimation' },
	        ' ',
	        _AgentStatusSVG.EstadoAgenteDispLlamManual
	    )
	)), _defineProperty(_CUSTOM_AGENT_STATE, _constants.USER_STATE.ASSISTED, _react2.default.createElement(
	    'div',
	    { className: 'Icon' },
	    _react2.default.createElement('i', { className: 'gcl-icon assisted WhiteIcon' }),
	    ' '
	)), _defineProperty(_CUSTOM_AGENT_STATE, _constants.USER_STATE.DIALOG_WHATSAPP, _react2.default.createElement(
	    'div',
	    { className: 'Icon' },
	    _react2.default.createElement('i', { className: 'gcl-icon whatsapp WhiteIcon' }),
	    ' '
	)), _defineProperty(_CUSTOM_AGENT_STATE, _constants.USER_STATE.WHATSAPP, _react2.default.createElement(
	    'div',
	    { className: 'Icon' },
	    _react2.default.createElement('i', { className: 'gcl-icon whatsapp WhiteIcon' }),
	    ' '
	)), _defineProperty(_CUSTOM_AGENT_STATE, _constants.USER_STATE.AGENT_PREVIEW, _react2.default.createElement(
	    'div',
	    { className: 'Icon' },
	    _react2.default.createElement('i', { className: 'gcl-icon show WhiteIcon' }),
	    ' '
	)), _defineProperty(_CUSTOM_AGENT_STATE, _constants.USER_STATE.INACTIVE, _react2.default.createElement(
	    'div',
	    { className: 'Icon' },
	    _react2.default.createElement('i', { className: 'gcl-icon inactive-agent WhiteIcon' }),
	    ' '
	)), _defineProperty(_CUSTOM_AGENT_STATE, _constants.USER_STATE.DIALOG_EMAIL, _react2.default.createElement(
	    'div',
	    { className: 'Icon' },
	    _react2.default.createElement('i', { className: 'gcl-icon mail WhiteIcon' }),
	    ' '
	)), _CUSTOM_AGENT_STATE);

/***/ },
/* 1155 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SMResponseHelper = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _alertQueryErrorBody = __webpack_require__(130);
	
	var _constants = __webpack_require__(10);
	
	var _singletonSharedData = __webpack_require__(23);
	
	var _Logger = __webpack_require__(37);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var instance = null;
	
	var SMResponseHelper = exports.SMResponseHelper = function () {
	  function SMResponseHelper() {
	    _classCallCheck(this, SMResponseHelper);
	
	    if (!instance) {
	      instance = this;
	    }
	    this.timersSMResponse = [];
	    this.sharedData = new _singletonSharedData.SingletonSharedData();
	    this.that = null;
	    return instance;
	  }
	
	  _createClass(SMResponseHelper, [{
	    key: 'setThat',
	    value: function setThat(that) {
	      if (!this.that) {
	        this.that = that;
	      }
	    }
	  }, {
	    key: 'clearTimer',
	    value: function clearTimer(message) {
	      var key = message.Subaction;
	      if (this.timersSMResponse[key]) {
	        _Logger.Logger.Trace("SMResponseReceived CleaningTimer ", key);
	        var timer = this.timersSMResponse[key];
	        clearTimeout(timer);
	        delete this.timersSMResponse[key];
	      }
	    }
	  }, {
	    key: 'setTimer',
	    value: function setTimer(message) {
	      var _this = this;
	
	      var messageKey = message.Subaction;
	      if (message.ExpectsReponse && !this.timersSMResponse[messageKey]) {
	        _Logger.Logger.Trace("SMResponseExpected SetTimer ", message);
	        this.timersSMResponse[messageKey] = setTimeout(function () {
	          return _this.showNoResponseError(messageKey);
	        }, this.sharedData.requestTimeout);
	      }
	    }
	  }, {
	    key: 'showNoResponseError',
	    value: function showNoResponseError(key) {
	      delete this.timersSMResponse[key];
	      _Logger.Logger.Trace("SMResponseNotReceived ExecutingNotification ", key);
	      this.executeNoSMResponse(key);
	      this.that.props.showAlertModal((0, _alertQueryErrorBody.alertQueryErrorBody)());
	    }
	  }, {
	    key: 'executeNoSMResponse',
	    value: function executeNoSMResponse(key) {
	      switch (key) {
	        case _constants.API_ENDPOINTS.CALL_OUT_CAMPAIGNS:
	          this.that.props.removeWindow(_constants.DRAGGABLE_WINDOWS.MANUAL_CALL);
	          break;
	        default:
	          break;
	      }
	    }
	  }]);

	  return SMResponseHelper;
	}();

/***/ },
/* 1156 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ConvertHourToInt = exports.ConvertHourToInt = function () {
	  function ConvertHourToInt() {
	    _classCallCheck(this, ConvertHourToInt);
	  }
	
	  _createClass(ConvertHourToInt, [{
	    key: "Parse",
	    value: function Parse(time) {
	      return parseInt(time[0], 10) * 3600 + parseInt(time[1], 10) * 60 + parseInt(time[2], 10);
	    }
	  }]);

	  return ConvertHourToInt;
	}();

/***/ },
/* 1157 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.changeAttachmentsSrc = changeAttachmentsSrc;
	exports.changeMessageSrc = changeMessageSrc;
	
	var environment = window.location.href.split('/')[0];
	var hostname = environment + '//' + window.location.hostname + '/EmailFiles'; //window.location.hostname
	var stringDomain = '$domain$';
	
	function changeAttachmentsSrc(message) {
	    return message.map(function (element) {
	        return element.replace(stringDomain, hostname);
	    });
	}
	
	function changeMessageSrc(message) {
	    return message.replaceAll(stringDomain, hostname);
	}

/***/ },
/* 1158 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.callType = callType;
	exports.messageFromSupervisor = messageFromSupervisor;
	exports.agentUnavailableOnTransfer = agentUnavailableOnTransfer;
	
	var _constants = __webpack_require__(10);
	
	function callType(type) {
	  return {
	    type: _constants.ACTIONS_FROM_SM.CALL_TYPE,
	    callType: type
	  };
	}
	
	function messageFromSupervisor(message, supervisor) {
	  return {
	    type: _constants.ACTIONS_FROM_SM.MESSAGE_FROM_SUPERVISOR,
	    message: message,
	    supervisor: supervisor
	  };
	}
	
	function agentUnavailableOnTransfer(message) {
	  return {
	    type: _constants.ACTIONS_FROM_SM.NO_AVAILABLE_INFO,
	    message: message
	  };
	}

/***/ },
/* 1159 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	   value: true
	});
	exports.setCustomImages = undefined;
	
	var _constants = __webpack_require__(10);
	
	var setCustomImages = exports.setCustomImages = function setCustomImages(whiteLabelEnabled, imageFormat, login, header, about) {
	   return {
	      type: _constants.ACTIONS_FROM_WHITE_LABEL.SET_CUSTOM_IMAGES,
	      whiteLabelEnabled: whiteLabelEnabled,
	      imageFormat: imageFormat,
	      login: login,
	      header: header,
	      about: about
	   };
	};

/***/ },
/* 1160 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.moveBlockingPanel = moveBlockingPanel;
	
	var _constants = __webpack_require__(10);
	
	function moveBlockingPanel(newZIndex) {
	  return {
	    type: _constants.BLOCKING_PANEL.Z_INDEX,
	    zIndex: newZIndex
	  };
	}

/***/ },
/* 1161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.toggleLocalLogging = undefined;
	
	var _constants = __webpack_require__(10);
	
	var toggleLocalLogging = exports.toggleLocalLogging = function toggleLocalLogging(enableLocalLog) {
		return {
			type: _constants.ACTIONS_FROM_LOCAL_LOGGING.SET_LOCAL_LOGGING,
			enableLocalLog: enableLocalLog
		};
	};

/***/ },
/* 1162 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.noAvailableData = noAvailableData;
	
	var _constants = __webpack_require__(10);
	
	function noAvailableData(frameNA, timeNA, supervisorPassNA, descriptionNA) {
	  return {
	    type: _constants.ACTIONS_FROM_SM.NO_AVAILABLE_INFO,
	    frame: frameNA,
	    time: timeNA,
	    supervisorPass: supervisorPassNA,
	    description: descriptionNA
	  };
	}

/***/ },
/* 1163 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.updateCount = updateCount;
	function updateCount(itemQueue, countQueue, timeInQueue) {
	  return {
	    type: itemQueue,
	    count: countQueue,
	    time: timeInQueue
	  };
	}

/***/ },
/* 1164 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.hangUpFromSip = hangUpFromSip;
	exports.streamFromSip = streamFromSip;
	
	var _constants = __webpack_require__(10);
	
	function hangUpFromSip() {
		return {
			type: _constants.SIP_CLIENT_ACTIONS.HANGUP
		};
	}
	
	function streamFromSip(data) {
		return {
			type: _constants.SIP_CLIENT_ACTIONS.STREAM,
			data: data
		};
	}

/***/ },
/* 1165 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.validatingState = validatingState;
	function validatingState(stateV, timeV) {
	  return {
	    type: stateV,
	    time: timeV
	  };
	}

/***/ },
/* 1166 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.visibleWindow = visibleWindow;
	function visibleWindow(windowVisible) {
	  return {
	    type: windowVisible
	  };
	}

/***/ },
/* 1167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _redux = __webpack_require__(482);
	
	var _reducer_user_actions = __webpack_require__(1189);
	
	var _reducer_user_actions2 = _interopRequireDefault(_reducer_user_actions);
	
	var _reducer_user_states = __webpack_require__(1190);
	
	var _reducer_user_states2 = _interopRequireDefault(_reducer_user_states);
	
	var _reducer_workBar_selected = __webpack_require__(1195);
	
	var _reducer_workBar_selected2 = _interopRequireDefault(_reducer_workBar_selected);
	
	var _reducer_messages_to_SM = __webpack_require__(1180);
	
	var _reducer_messages_to_SM2 = _interopRequireDefault(_reducer_messages_to_SM);
	
	var _reducer_no_available = __webpack_require__(1181);
	
	var _reducer_no_available2 = _interopRequireDefault(_reducer_no_available);
	
	var _reducer_validating_telephony = __webpack_require__(1191);
	
	var _reducer_validating_telephony2 = _interopRequireDefault(_reducer_validating_telephony);
	
	var _reducer_other_actions = __webpack_require__(1183);
	
	var _reducer_other_actions2 = _interopRequireDefault(_reducer_other_actions);
	
	var _reducer_call_acd = __webpack_require__(1175);
	
	var _reducer_call_acd2 = _interopRequireDefault(_reducer_call_acd);
	
	var _reducer_consulting = __webpack_require__(1176);
	
	var _reducer_consulting2 = _interopRequireDefault(_reducer_consulting);
	
	var _reducer_actions_from_SM = __webpack_require__(1168);
	
	var _reducer_actions_from_SM2 = _interopRequireDefault(_reducer_actions_from_SM);
	
	var _reducer_window_visible = __webpack_require__(1194);
	
	var _reducer_window_visible2 = _interopRequireDefault(_reducer_window_visible);
	
	var _reducer_queue_count = __webpack_require__(1186);
	
	var _reducer_queue_count2 = _interopRequireDefault(_reducer_queue_count);
	
	var _reducer_sip_client_actions = __webpack_require__(1187);
	
	var _reducer_sip_client_actions2 = _interopRequireDefault(_reducer_sip_client_actions);
	
	var _reducer_draggable_windows_controller = __webpack_require__(1177);
	
	var _reducer_draggable_windows_controller2 = _interopRequireDefault(_reducer_draggable_windows_controller);
	
	var _reducer_blocking_panel = __webpack_require__(1174);
	
	var _reducer_blocking_panel2 = _interopRequireDefault(_reducer_blocking_panel);
	
	var _reducer_volume = __webpack_require__(1192);
	
	var _reducer_volume2 = _interopRequireDefault(_reducer_volume);
	
	var _reducer_assisted_transfer = __webpack_require__(1173);
	
	var _reducer_assisted_transfer2 = _interopRequireDefault(_reducer_assisted_transfer);
	
	var _reducer_actions_integration = __webpack_require__(1169);
	
	var _reducer_actions_integration2 = _interopRequireDefault(_reducer_actions_integration);
	
	var _reducer_alert_modal = __webpack_require__(1172);
	
	var _reducer_alert_modal2 = _interopRequireDefault(_reducer_alert_modal);
	
	var _reducer_ongoing_call_ivr_modal = __webpack_require__(1182);
	
	var _reducer_ongoing_call_ivr_modal2 = _interopRequireDefault(_reducer_ongoing_call_ivr_modal);
	
	var _reducer_unified_inbox = __webpack_require__(514);
	
	var _reducer_unified_inbox2 = _interopRequireDefault(_reducer_unified_inbox);
	
	var _reducer_white_label = __webpack_require__(1193);
	
	var _reducer_white_label2 = _interopRequireDefault(_reducer_white_label);
	
	var _reducer_localLogging = __webpack_require__(1178);
	
	var _reducer_localLogging2 = _interopRequireDefault(_reducer_localLogging);
	
	var _reducer_preview_transfer = __webpack_require__(1185);
	
	var _reducer_preview_transfer2 = _interopRequireDefault(_reducer_preview_transfer);
	
	var _reducer_preview = __webpack_require__(1184);
	
	var _reducer_preview2 = _interopRequireDefault(_reducer_preview);
	
	var _reducer_admin_alert_modal = __webpack_require__(1170);
	
	var _reducer_admin_alert_modal2 = _interopRequireDefault(_reducer_admin_alert_modal);
	
	var _reducer_agent_permissions = __webpack_require__(1171);
	
	var _reducer_agent_permissions2 = _interopRequireDefault(_reducer_agent_permissions);
	
	var _reducer_psw_reset = __webpack_require__(336);
	
	var _reducer_psw_reset2 = _interopRequireDefault(_reducer_psw_reset);
	
	var _reducer_manual_message = __webpack_require__(1179);
	
	var _reducer_manual_message2 = _interopRequireDefault(_reducer_manual_message);
	
	var _reducer_transfer = __webpack_require__(1188);
	
	var _reducer_transfer2 = _interopRequireDefault(_reducer_transfer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
		userActions: _reducer_user_actions2.default,
		userState: _reducer_user_states2.default,
		workBarSelected: _reducer_workBar_selected2.default,
		messagesToSM: _reducer_messages_to_SM2.default,
		noAvailableState: _reducer_no_available2.default,
		validatingTelephonyState: _reducer_validating_telephony2.default,
		otherActions: _reducer_other_actions2.default,
		callActionsACD: _reducer_call_acd2.default,
		consultingCounter: _reducer_consulting2.default,
		stateMachineActions: _reducer_actions_from_SM2.default,
		windowVisible500: _reducer_window_visible2.default,
		queueCount: _reducer_queue_count2.default,
		dragWindowController: _reducer_draggable_windows_controller2.default,
		sipClientActions: _reducer_sip_client_actions2.default,
		blockingPanelReducer: _reducer_blocking_panel2.default,
		volumeControl: _reducer_volume2.default,
		assistedTransfer: _reducer_assisted_transfer2.default,
		messagesIntegrations: _reducer_actions_integration2.default,
		isAlertModalOpen: _reducer_alert_modal2.default,
		isOngoingCallIvrModalOpen: _reducer_ongoing_call_ivr_modal2.default,
		unifiedInboxState: _reducer_unified_inbox2.default,
		whiteLabelState: _reducer_white_label2.default,
		localLogState: _reducer_localLogging2.default,
		previewActions: _reducer_preview_transfer2.default,
		preview: _reducer_preview2.default,
		adminModal: _reducer_admin_alert_modal2.default,
		agentPermissions: _reducer_agent_permissions2.default,
		setFlagShowAlert: _reducer_psw_reset2.default,
		manualMessageReducer: _reducer_manual_message2.default,
		transferReducer: _reducer_transfer2.default
	});

/***/ },
/* 1168 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _constants = __webpack_require__(10);
	
	var initialActionFromSM = {
	  reducer_type: _constants.REDUCERS.REDUCER_ACTIOS_FROM_SM,
	  actionType: _constants.ACTIONS_FROM_SM.NO_ACTION,
	  callType: 0,
	  message: null,
	  errorCode: null
	};
	
	var stateMachineActions = function stateMachineActions() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialActionFromSM;
	  var action = arguments[1];
	
	  state = initialActionFromSM;
	  switch (action.type) {
	    case _constants.ACTIONS_FROM_SM.CALL_TYPE:
	      return { actionType: _constants.ACTIONS_FROM_SM.CALL_TYPE, callType: action.callType, errorCode: null };
	    case _constants.ACTIONS_FROM_SM.MESSAGE_FROM_SUPERVISOR:
	      return { actionType: _constants.ACTIONS_FROM_SM.MESSAGE_FROM_SUPERVISOR, callType: state.callType, message: action.message, supervisor: action.supervisor };
	    case _constants.ACTIONS_FROM_SM.LOGOUT:
	      return { actionType: _constants.ACTIONS_FROM_SM.LOGED_OUT, callType: state.callType };
	    case _constants.ACTIONS_FROM_SM.NO_AVAILABLE_INFO:
	      return { actionType: _constants.ACTIONS_FROM_SM.NO_AVAILABLE_INFO, message: action.message };
	    default:
	      return state;
	  }
	};
	exports.default = stateMachineActions;

/***/ },
/* 1169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _constants = __webpack_require__(10);
	
	var initialMessagesIntegration = {
	  actionType: _constants.ACTIONS_INTEGRATION.NONE
	};
	
	var messagesIntegrations = function messagesIntegrations() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialMessagesIntegration;
	  var action = arguments[1];
	
	  state = initialMessagesIntegration;
	  switch (action.type) {
	    case _constants.ACTIONS_INTEGRATION.MESSAGE:
	      return { actionType: _constants.ACTIONS_INTEGRATION.MESSAGE,
	        dataMessageIntegration: action.dataIntegration };
	    default:
	      return state;
	  }
	};
	
	exports.default = messagesIntegrations;

/***/ },
/* 1170 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _constants = __webpack_require__(10);
	
	var initialState = {
	    isModalOpen: false,
	    data: { title: null, content: null }
	};
	
	var AdminModalState = function AdminModalState() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _constants.ADMIN_MODAL_ACTIONS.SHOW_ADMIN_MODAL:
	            return { isModalOpen: true, data: Object.assign({}, action.payload) };
	        case _constants.ADMIN_MODAL_ACTIONS.HIDE_ADMIN_MODAL:
	            return { isModalOpen: false, data: { title: null, content: null } };
	        default:
	            return state;
	    }
	};
	
	exports.default = AdminModalState;

/***/ },
/* 1171 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _constants = __webpack_require__(10);
	
	var initialState = {
	    allowPlayRecordsOnCallHistory: false,
	    allowChangeDialing: false
	};
	
	var stateAgentPermissions = function stateAgentPermissions() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _constants.AGENT_PERMISSIONS_ACTIONS.ALLOW_PLAY_RECORDS_ON_CALL_HISTORY:
	            return Object.assign({}, state, { allowPlayRecordsOnCallHistory: action.allowPlayRecordsOnCallHistory });
	        case _constants.AGENT_PERMISSIONS_ACTIONS.SET_ALLOW_CHANGE_DIALING:
	            return Object.assign({}, state, {
	                allowChangeDialing: action.payload
	            });
	            break;
	
	        default:
	            return state;
	    }
	};
	
	exports.default = stateAgentPermissions;

/***/ },
/* 1172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _A_Alert_Modal = __webpack_require__(63);
	
	var _A_Alert_Modal2 = _interopRequireDefault(_A_Alert_Modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initalState = {
	  isModalOpen: false,
	  data: { type: null, message: null, boldMessage: null }
	};
	
	var AlertModalReducer = function AlertModalReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initalState;
	  var action = arguments[1];
	  var type = action.type,
	      payload = action.payload;
	
	
	  switch (type) {
	    case _A_Alert_Modal2.default.types.ALERT_MODAL_SHOW:
	      return { isModalOpen: true, data: Object.assign({}, payload) };
	
	    case _A_Alert_Modal2.default.types.ALERT_MODAL_HIDE:
	      return { isModalOpen: false, data: { type: null, message: null, boldMessage: null } };
	
	    default:
	      return state;
	  }
	};
	
	exports.default = AlertModalReducer;

/***/ },
/* 1173 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _constants = __webpack_require__(10);
	
	var initialUserState = {
	  reducer_type: _constants.REDUCERS.REDUCER_ACTIOS_FROM_SM,
	  currentState: ""
	};
	
	var assistedTransfer = function assistedTransfer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialUserState;
	  var action = arguments[1];
	
	  state = initialUserState;
	  if (action.type === _constants.ASSISTED_TRANSFER.CHANGE_STATE) {
	    return { currentState: action.currentState };
	  } else {
	    return state;
	  }
	};
	
	exports.default = assistedTransfer;

/***/ },
/* 1174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _constants = __webpack_require__(10);
	
	var initialActionFromSM = {
	  reducer_type: _constants.BLOCKING_PANEL.Z_INDEX,
	  actionType: _constants.BLOCKING_PANEL.Z_INDEX,
	  zIndex: -1
	};
	
	var blockingPanelReducer = function blockingPanelReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialActionFromSM;
	  var action = arguments[1];
	
	  if (action.type === _constants.BLOCKING_PANEL.Z_INDEX) {
	    return { actionType: _constants.BLOCKING_PANEL.Z_INDEX, zIndex: action.zIndex };
	  } else {
	    return state;
	  }
	};
	
	exports.default = blockingPanelReducer;

/***/ },
/* 1175 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _constants = __webpack_require__(10);
	
	var initialActionCallACD = {
	  reducer_type: _constants.REDUCERS.REDUCER_ACTIOS_FROM_SM,
	  callAction: "",
	  parameters: {},
	  callOutId: 0
	};
	
	var callActionsACD = function callActionsACD() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialActionCallACD;
	  var action = arguments[1];
	
	  if (_constants.ACTION_CALL_ACD[action.type]) {
	    return { callAction: _constants.ACTION_CALL_ACD[action.type], parameters: action.parameters, callOutId: action.callOutId };
	  }
	  return state;
	};
	exports.default = callActionsACD;

/***/ },
/* 1176 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _constants = __webpack_require__(10);
	
	var initialConsulting = {
	  reducer_type: _constants.REDUCERS.REDUCER_ACTIOS_FROM_SM,
	  consulting: 0
	};
	
	var consultingCounter = function consultingCounter() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialConsulting;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _constants.CONSULTING_WINDOW.CONSULTING:
	      return { actionType: _constants.CONSULTING_WINDOW.CONSULTING, consulting: state.consulting + 1 };
	    case _constants.CONSULTING_WINDOW.NO_CONSULTING:
	      var consult = state.consulting - 1 >= 0 ? state.consulting - 1 : 0;
	      return { actionType: _constants.CONSULTING_WINDOW.NO_CONSULTING, consulting: consult };
	    default:
	      return state;
	  }
	};
	
	exports.default = consultingCounter;

/***/ },
/* 1177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _constants = __webpack_require__(10);
	
	var initialDragComponent = {
	  reducer_type: _constants.REDUCERS.DRAGGABLE_WINDOWS_CONTROLLER,
	  actionType: _constants.DRAGGABLE_WINDOWS_ACTIONS.NONE,
	  closeIfOpen: false,
	  dragComponent: null,
	  idDragComponent: -1
	};
	
	var dragWindowController = function dragWindowController() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialDragComponent;
	  var action = arguments[1];
	
	  state = initialDragComponent;
	  switch (action.type) {
	    case _constants.DRAGGABLE_WINDOWS_ACTIONS.INSERT_WINDOW:
	      return { actionType: _constants.DRAGGABLE_WINDOWS_ACTIONS.INSERT_WINDOW, closeIfOpen: action.closeIfOpen, dragComponent: action.draggableComponent };
	    case _constants.DRAGGABLE_WINDOWS_ACTIONS.REMOVE_WINDOW:
	      return { actionType: _constants.DRAGGABLE_WINDOWS_ACTIONS.REMOVE_WINDOW, idDragComponents: action.idComponents };
	    default:
	      return state;
	  }
	};
	
	exports.default = dragWindowController;

/***/ },
/* 1178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _constants = __webpack_require__(10);
	
	var initialWhiteLabelState = {
		enableLocalLog: false
	};
	
	var localLogState = function localLogState() {
		var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialWhiteLabelState;
		var action = arguments[1];
	
		switch (action.type) {
			case _constants.ACTIONS_FROM_LOCAL_LOGGING.SET_LOCAL_LOGGING:
				return Object.assign({}, state, {
					enableLocalLog: action.enableLocalLog
				});
			default:
				return state;
		}
	};
	
	exports.default = localLogState;

/***/ },
/* 1179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _constants = __webpack_require__(10);
	
	var _A_manual_message = __webpack_require__(333);
	
	var initialState = {
		prevManualMessageStatus: _constants.MANUAL_MESSAGES_STATUS.SEND,
		manualMessageStatus: _constants.MANUAL_MESSAGES_STATUS.SEND,
		phone: undefined,
		convId: 0
	};
	
	var manualMessageReducer = function manualMessageReducer() {
		var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
		var action = arguments[1];
	
		switch (action.type) {
			case _A_manual_message.MANUAL_ACTIONS.SET_MESSAGE_STATUS:
				return Object.assign({}, state, { prevManualMessageStatus: state.manualMessageStatus, manualMessageStatus: action.manualMessageStatus, phone: action.phone, convId: action.convId });
			case _A_manual_message.MANUAL_ACTIONS.SET_MESSAGE_CONV_ID:
				return Object.assign({}, state, { convId: action.convId });
			case _A_manual_message.MANUAL_ACTIONS.MULTIMEDIA_MESSAGE_STATUS:
				if (state.convId === action.conversationId) {
					var messageStatus = _constants.MANUAL_MESSAGES_STATUS.SYSTEM_ERROR;
					var newPhone = state.phone;
					switch (action.status) {
						case _constants.MESSAGE_STATUS.send:
						case _constants.MESSAGE_STATUS.delivered:
							messageStatus = _constants.MANUAL_MESSAGES_STATUS.SEND;
							newPhone = undefined;
							break;
						case _constants.MESSAGE_STATUS.error:
							messageStatus = _constants.MANUAL_MESSAGES_STATUS.INCORRECT_NUMBER;
							break;
					}
					return Object.assign({}, state, { prevManualMessageStatus: state.manualMessageStatus, manualMessageStatus: messageStatus, phone: newPhone });
				}
				return state;
			default:
				return state;
		}
	};
	
	exports.default = manualMessageReducer;

/***/ },
/* 1180 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _constants = __webpack_require__(10);
	
	var _helperMessages = __webpack_require__(87);
	
	var initialMessageState = {
		reducer_type: _constants.REDUCERS.REDUCER_ACTIOS_FROM_SM,
		message: null
	};
	
	var messagesToSM = function messagesToSM() {
		var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialMessageState;
		var action = arguments[1];
	
		switch (action.type) {
			case _constants.MESSAGES_TO_SM.MESSAGE_TO_SM:
				return { message: action.message };
			case _constants.MESSAGES_TO_SM.NO_AVAILABLE_EVENT:
				var messageNoAvailble = (0, _helperMessages.messageNoAvailable)(action.userName, action.userID, action.notReadyID, action.conversationID, action.TimePreview);
				return { message: messageNoAvailble };
			case _constants.MESSAGES_TO_SM.RETRY_FIRST_CALL:
				var messageRetry = (0, _helperMessages.messageRetryFirstCall)(action.userName, action.userID, action.notReadyID);
				return { message: messageRetry };
			case _constants.MESSAGES_TO_SM.AGENT_READY:
				var messageRedy = (0, _helperMessages.messageAgentRedy)();
				return { message: messageRedy };
			case _constants.MESSAGES_TO_SM.MESSAGE_TO_SUPERVISOR:
				var messageTosup = (0, _helperMessages.messageToSupervisor)(action.message, action.supervisor);
				return { message: messageTosup };
			case _constants.MESSAGES_TO_SM.CHANGE_STATE:
				var messageChangeState = (0, _helperMessages.messageChangeStateHelper)();
				return { message: messageChangeState };
			case _constants.MESSAGES_TO_SM.START_STOP_RECORDING:
				var messageStartStopRec = (0, _helperMessages.messageStartStopRecording)(action.isStop, action.callOutId);
				return { message: messageStartStopRec };
			case _constants.MESSAGES_TO_SM.MARKS_CALL:
				var messageSaveMarks = (0, _helperMessages.messageSaveMarksSM)(action.marks, action.callOutId);
				return { message: messageSaveMarks };
			case _constants.MESSAGES_TO_SM.API_REQUEST:
				var apiRequest = (0, _helperMessages.messageApiRequest)(action.subaction, action.json, action.expectsResponse, action.callOutId);
				return { message: apiRequest };
			case _constants.MESSAGES_TO_SM.UPDATE_DATA_CALL:
				var messageUpdate = (0, _helperMessages.updateInfoCall)(action.callKey, action.camId, action.dataCall, action.CallOutId);
				return { message: messageUpdate };
			case _constants.MESSAGES_TO_SM.TRANSFER_CALL:
				var messageTransfer = (0, _helperMessages.messageTransferCall)(action.data);
				return { message: messageTransfer };
			case _constants.MESSAGES_TO_SM.ASSISTED_TRANSFER_CALL:
				var messageAssistedTransfer = (0, _helperMessages.messageAssistedTransferCall)(action.process, action.data);
				return { message: messageAssistedTransfer };
			case _constants.MESSAGES_TO_SM.MANUAL_CALL:
				var manualCallaObject = (0, _helperMessages.manualCall)(action.data);
				return { message: manualCallaObject };
			case _constants.MESSAGES_TO_SM.HANG_UP:
				var hangUpObject = (0, _helperMessages.messageHangUp)(action.subaction, action.callOutId, action.calloutMaxTime);
				return { message: hangUpObject };
			case _constants.MESSAGES_TO_SM.ONGOING_CALL_IVR:
				var ongoingCallIvrObject = (0, _helperMessages.messageOngoingCallIvr)(action.id);
				return { message: ongoingCallIvrObject };
			case _constants.MESSAGES_TO_SM.END_CONVERSATION_CHAT:
				var endConversationObject = (0, _helperMessages.endConversationChat)(action.data);
				return { message: endConversationObject };
			case _constants.MESSAGES_TO_SM.ACEPTED_CHAT:
				var aceptedChatObject = (0, _helperMessages.aceptedChat)(action.data);
				return { message: aceptedChatObject };
			case _constants.MESSAGES_TO_SM.SPAM_CONVERSATION:
				var onSpamConversationObject = (0, _helperMessages.spamConversation)(action.data);
				return { message: onSpamConversationObject };
			case _constants.MESSAGES_TO_SM.UNASSIGN_CONVERSATION:
				var unassignConversationObject = (0, _helperMessages.unassignConversation)(action.data);
				return { message: unassignConversationObject };
			case _constants.MESSAGES_TO_SM.DISCARD_CONVERSATION:
				var discardConversationObject = (0, _helperMessages.discardConversation)(action.data);
				return { message: discardConversationObject };
			case _constants.MESSAGES_TO_SM.SELECTED_MESSAGE:
				var selectedMessageObject = (0, _helperMessages.selectedMessage)(action.data);
				return { message: selectedMessageObject };
			case _constants.MESSAGES_TO_SM.SEND_DISPOSITION:
				var sendDispositionObject = (0, _helperMessages.sendDisposition)(action.data);
				return { message: sendDispositionObject };
			case _constants.MESSAGES_TO_SM.SEND_UNIFIED_RESPONSE:
				var sendUnifiedResponseObject = (0, _helperMessages.sendUnifiedResponse)(action.data);
				return { message: sendUnifiedResponseObject };
			case _constants.MESSAGES_TO_SM.SEND_EXTERNAL_UNIFIED_RESPONSE:
				var sendExternalUnifiedResponseObject = (0, _helperMessages.sendMessageToExternalMU)(action.data);
				return { message: sendExternalUnifiedResponseObject };
			case _constants.MESSAGES_TO_SM.CHANGE_STATE_MULTIMEDIA:
				var changeStateObject = (0, _helperMessages.changeState)(action.data);
				return { message: changeStateObject };
			case _constants.MESSAGES_TO_SM.CHANGE_STATE_MULTIMEDIA_ALL:
				var changeStateObjectEmail = (0, _helperMessages.changeMultimediaState)(action.data);
				return { message: changeStateObjectEmail };
			case _constants.MESSAGES_TO_SM.CHANGE_DIALINGMODE_SCH:
				var setAgentDialingMode = (0, _helperMessages.SetAgentDialingMode)(action.data);
				return { message: setAgentDialingMode };
			case _constants.MESSAGES_TO_SM.PREVIEW_RECORD:
				var previewRecord = (0, _helperMessages.PreviewRecord)(action.data);
				return { message: previewRecord };
			case _constants.MESSAGES_TO_SM.PREVIEW_TRANSFER:
				var previewTransfer = (0, _helperMessages.messagePreviewTransfer)(action.subaction, action.agent, action.callOutId);
				return { message: previewTransfer };
			case _constants.MESSAGES_TO_SM.SEND_RESPONSE_TRANSFER:
				var responsepreviewTransfer = (0, _helperMessages.responsePreviewTransfer)(action.agent, action.response);
				return { message: responsepreviewTransfer };
			case _constants.MESSAGES_TO_SM.GET_MORE_MESSAGES:
				var getMoreMessagesObject = (0, _helperMessages.GetMoreMessages)(action.data);
				return { message: getMoreMessagesObject };
			case _constants.MESSAGES_TO_SM.ACCEPT_CHAT_SAVE_TIME:
				var acceptChatSaveTimeObj = (0, _helperMessages.acceptChatSaveTime)(action.data);
				return { message: acceptChatSaveTimeObj };
			case _constants.MESSAGES_TO_SM.API_REQUEST_ANI_LIST:
				var appiRequest = (0, _helperMessages.messageApiRequestANIList)(action.subaction, action.campId, action.expectsResponse);
				return { message: appiRequest };
			case _constants.MESSAGES_TO_SM.GET_RECORD_CALL_PERMISSION:
				var recordRequest = (0, _helperMessages.GetRecordCallPermission)(action.subaction, action.campId, action.expectsResponse);
				return { message: recordRequest };
			case _constants.MESSAGES_TO_SM.GET_PREVIEW_CAMPAIGNS:
				var previewCampaigns = (0, _helperMessages.messageGetPreviewCampaigns)('GetPreviewCampaigns');
				return { message: previewCampaigns };
			default:
				return state;
		}
	};
	
	exports.default = messagesToSM;

/***/ },
/* 1181 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _constants = __webpack_require__(10);
	
	var initialNoAvailableState = {
	  reducer_type: _constants.REDUCERS.REDUCER_ACTIOS_FROM_SM,
	  time: 0,
	  frame: 0,
	  description: "",
	  supervisorPass: false
	};
	
	var noAvailableState = function noAvailableState() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialNoAvailableState;
	  var action = arguments[1];
	
	  if (action.type === _constants.ACTIONS_FROM_SM.NO_AVAILABLE_INFO) {
	    return { frame: action.frame, time: action.time, supervisorPass: action.supervisorPass, description: action.description };
	  } else {
	    return state;
	  }
	};
	
	exports.default = noAvailableState;

/***/ },
/* 1182 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _A_ongoing_call_ivr_modal = __webpack_require__(334);
	
	var _A_ongoing_call_ivr_modal2 = _interopRequireDefault(_A_ongoing_call_ivr_modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initalState = {
	  isModalOpen: false,
	  data: {}
	};
	
	var OngoingCallIvrModalReducer = function OngoingCallIvrModalReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initalState;
	  var action = arguments[1];
	  var type = action.type,
	      payload = action.payload;
	
	
	  switch (type) {
	    case _A_ongoing_call_ivr_modal2.default.types.ONGOING_CALL_IVR_MODAL_SHOW:
	      return { isModalOpen: true, data: Object.assign({}, payload) };
	
	    case _A_ongoing_call_ivr_modal2.default.types.ONGOING_CALL_IVR_MODAL_HIDE:
	      return { isModalOpen: false, data: {} };
	
	    default:
	      return state;
	  }
	};
	
	exports.default = OngoingCallIvrModalReducer;

/***/ },
/* 1183 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _constants = __webpack_require__(10);
	
	var initialOtherActionState = {
	  reducer_type: _constants.REDUCERS.REDUCER_ACTIOS_FROM_SM,
	  action: _constants.OTHER_ACTIONS.NONE
	};
	
	var otherActions = function otherActions() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialOtherActionState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _constants.OTHER_ACTIONS.UPDATE_WB_INFO:
	      return { action: _constants.OTHER_ACTIONS.UPDATE_WB_INFO, workBarUpdate: action.workBarAction };
	    case _constants.OTHER_ACTIONS.MARK_CALL:
	      return { action: _constants.OTHER_ACTIONS.MARK_CALL };
	    case _constants.OTHER_ACTIONS.DELETE_CHAT_NOTIFICATIONS:
	      return { action: _constants.OTHER_ACTIONS.DELETE_CHAT_NOTIFICATIONS };
	    default:
	      return state;
	  }
	};
	
	exports.default = otherActions;

/***/ },
/* 1184 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CallSpaceHeaderSVG = __webpack_require__(67);
	
	var _constants = __webpack_require__(10);
	
	var _formats = __webpack_require__(54);
	
	var _singletonSharedData = __webpack_require__(23);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var sharedData = new _singletonSharedData.SingletonSharedData();
	
	var initialPreviewState = { //
	  countRecords: 0,
	  dialingMode: 0,
	  //--DataRecord--
	  isSetPreviewRecord: false,
	  record: {},
	  data: [],
	  previewTime: 0,
	  permissionDelete: false,
	  previewDiscard: false,
	  campaignName: '',
	  iconCampaing: '',
	  camId: '',
	  wrapUpTime: '',
	  callKey: '',
	  callOutId: '',
	  phones: [],
	  headers: [],
	  initialTimeSec: 0,
	  totalPreviewTime: 0,
	  initPreviewTime: 0,
	  isTimeAscending: false,
	  permissionUpdate: false,
	  //-- 
	  tempData: [],
	  phoneToCall: '',
	  isTryingToChangeCamp: false,
	  nextCampType: 0,
	  isChangeSuccess: false,
	  isRunningClock: true,
	  dialogTime: undefined,
	  isSendProcess: false,
	  tempPrevRecord: {},
	  selectedPreviewCampaign: null,
	  simultaneosRecs: false,
	  records: [],
	  campaignSelectedDialingRate: 0,
	  defaultDialingRate: 0,
	  previewType: 0,
	  fReplacementJob: 0,
	  selectedRecord: { callOutId: 0, data: [] },
	  messageCode: 0,
	  isSomeRecInDialog: false,
	  countRecordsDialing: 0,
	  countRecordsDialog: 0,
	  switchBetweenHold: false,
	  ndScheduled: false,
	  countRecordsToWrapUp: 0,
	  switchBetweenWrapUp: false
	
	};
	
	var preview = function preview() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialPreviewState;
	  var action = arguments[1];
	
	  var temp = void 0;
	
	  switch (action.type) {
	    case _constants.PREVIEW.INCREMENT_DISCARDED:
	      return Object.assign({}, state, {
	        countRecords: state.countRecords + 1
	      });
	    case _constants.PREVIEW.SET_PREVIEW_RECORD:
	      temp = action.payload.RegsMultiple ? action.payload.PreviewType : 0;
	      return Object.assign({}, state, {
	        record: action.payload,
	        data: action.payload.DataContact,
	        tempData: action.payload.DataContact,
	        phoneToCall: action.payload.Phone[0],
	        campaignName: action.payload.CampaignName,
	        iconCampaing: action.payload.GraphId,
	        camId: action.payload.Cam_id,
	        wrapUpTime: action.payload.WrapUpTime,
	        previewTime: action.payload.PreviewTime,
	        initPreviewTime: action.payload.PreviewTime,
	        callKey: action.payload.CallKey,
	        callOutId: action.payload.CallOut_id,
	        phones: action.payload.Phone,
	        headers: action.payload.DataHeaders,
	        isSetPreviewRecord: true,
	        initialTimeSec: (0, _formats.getCurrentTimeInSec)(),
	        permissionDelete: action.payload.PermissionDelete === undefined ? false : action.payload.PermissionDelete,
	        previewDiscard: action.payload.PreviewDiscard === undefined ? false : action.payload.PreviewDiscard,
	        isTimeAscending: action.payload.PreviewTime === 0 ? true : false,
	        isSendProcess: false,
	        simultaneosRecs: action.payload.RegsMultiple,
	        //-------simultaneosRecs
	        defaultDialingRate: action.payload.DialingRate,
	        previewType: temp, // 2 si setting 248 = 0, 1 si setting 248 = 1
	        fReplacementJob: temp === 2 ? 0 : 1,
	        permissionUpdate: action.payload.PermissionUpdate === undefined ? false : action.payload.PermissionUpdate,
	        records: [].concat(_toConsumableArray(state.records), [{
	          data: action.payload.DataContact,
	          tempData: action.payload.DataContact,
	          phoneToCall: action.payload.Phone[0],
	          campaignName: action.payload.CampaignName,
	          iconCampaing: action.payload.GraphId,
	          camId: action.payload.Cam_id,
	          wrapUpTime: action.payload.WrapUpTime,
	          previewTime: action.payload.PreviewTime,
	          initPreviewTime: action.payload.PreviewTime,
	          callKey: action.payload.CallKey,
	          callOutId: action.payload.CallOut_id,
	          phones: action.payload.Phone,
	          headers: action.payload.DataHeaders,
	          initialTimeSec: (0, _formats.getCurrentTimeInSec)(),
	          permissionDelete: action.payload.PermissionDelete == undefined ? false : action.payload.PermissionDelete,
	          isTimeAscending: action.payload.PreviewTime === 0 ? true : false,
	          totalPreviewTime: 0,
	          logDial: [],
	          previewDiscard: action.payload.PreviewDiscard !== undefined && action.payload.PreviewDiscard,
	          status: _constants.RECORD_STATE.DEFAULT,
	          messageStatus: null,
	          callId: 0,
	          dialogTime: undefined,
	          maximumAssignments: -1,
	          timeOnDialog: 0,
	          itWasSentTimeInPreview: false,
	          marks: [],
	          volume: { microphoneVol: sharedData.getVolumeMic(), speakerVol: sharedData.getVolumeSpeaker() },
	          dispositionData: { alreadyRated: false, exitPreview: undefined },
	          calloutMaxTime: 0,
	          remainingTime: 0,
	          agentHungUp: false,
	          flagLogDial: true,
	          permissionUpdate: action.payload.PermissionUpdate === undefined ? false : action.payload.PermissionUpdate
	        }])
	      });
	    case _constants.PREVIEW.UPDATE_PREVIEW_RECORD:
	      state.records.map(function (r) {
	        if (r.callOutId === action.payload.CallOutId) {
	          r.data = action.payload.DataContact.slice(0, r.headers.length);
	          return r;
	        } else {
	          r.data;
	        }
	      });
	      return Object.assign({}, state, {
	        data: action.payload.IsSave ? action.payload.DataContact.slice(0, state.headers.length) : state.data,
	        selectedRecord: state.records.find(function (r) {
	          return r.callOutId === action.payload.CallOutId;
	        })
	      });
	    case _constants.PREVIEW.SET_TEMP_DATA:
	      return Object.assign({}, state, {
	        tempData: action.payload
	      });
	    case _constants.PREVIEW.CLEAN_DATA:
	      return Object.assign({}, state, {
	        isSetPreviewRecord: false,
	        record: {},
	        data: [],
	        previewTime: 0,
	        callKey: '',
	        callOutId: '',
	        phones: [],
	        campaignName: '',
	        iconCampaing: '',
	        camId: '',
	        previewDiscard: false,
	        permissionDelete: false,
	        tempData: [],
	        initialTimeSec: 0,
	        totalPreviewTime: 0,
	        initPreviewTime: 0,
	        dialogTime: undefined,
	        isTimeAscending: false,
	        simultaneosRecs: false,
	        records: [],
	        isSomeRecInDialog: false,
	        countRecordsDialing: 0,
	        countRecordsDialog: 0,
	        switchBetweenHold: false,
	        ndScheduled: false,
	        countRecordsToWrapUp: 0,
	        switchBetweenWrapUp: false,
	        selectedRecord: { callOutId: 0, data: [] },
	        permissionUpdate: false
	      });
	    case _constants.PREVIEW.SET_PHONE_CALL:
	      return Object.assign({}, state, {
	        phoneToCall: action.payload,
	        messageCode: 0
	
	      });
	    case _constants.PREVIEW.CHANGE_CAMPAIGN_TYPE:
	      return Object.assign({}, state, {
	        isTryingToChangeCamp: action.payload,
	        isChangeSuccess: false
	      });
	    case _constants.PREVIEW.SUCCESSFUL_CHANGE:
	      return Object.assign({}, state, {
	        isChangeSuccess: action.payload.flag,
	        nextCampType: action.payload.nextCampType
	      });
	    case _constants.PREVIEW.SET_ISRUNNING_CLOCK:
	      return Object.assign({}, state, {
	        isRunningClock: action.payload
	      });
	    case _constants.PREVIEW.SET_NEWPREVIEW_TIME:
	      return Object.assign({}, state, {
	        previewTime: action.payload
	      });
	    case _constants.PREVIEW.SET_FINAL_TIME:
	      return Object.assign({}, state, {
	        totalPreviewTime: action.payload - state.initialTimeSec + state.totalPreviewTime
	      });
	    case _constants.PREVIEW.SET_INITIAL_TIME:
	      return Object.assign({}, state, {
	        initialTimeSec: action.payload
	      });
	    case _constants.PREVIEW.SET_DATA_TRANSFER:
	      return Object.assign({}, state, {
	        data: action.payload.ContactData,
	        tempData: action.payload.ContactData,
	        headers: action.payload.DataHeaders,
	        callKey: action.payload.CalKey,
	        callOutId: action.payload.CallId,
	        camId: action.payload.Id
	      });
	    case _constants.PREVIEW.SET_DIALOG_TIME:
	      return Object.assign({}, state, {
	        dialogTime: action.payload
	      });
	    case _constants.PREVIEW.SET_DIALINGMODE:
	      return Object.assign({}, state, {
	        dialingMode: action.payload
	      });
	    case _constants.PREVIEW.SET_IS_SEND_PROCESS:
	      return Object.assign({}, state, {
	        isSendProcess: action.payload
	      });
	    case _constants.PREVIEW.SET_TEMP_PREVIEW_RECORD:
	      return Object.assign({}, state, {
	        tempPrevRecord: {
	          camId: action.payload.CamId,
	          callOutId: action.payload.CallOutId,
	          previewTime: state.totalPreviewTime,
	          callId: action.payload.CallId }
	      });
	    case _constants.PREVIEW.SELECTED_PREVIEW_CAMPAIGN:
	      return Object.assign({}, state, {
	        selectedPreviewCampaign: action.payload
	      });
	    case _constants.PREVIEW_SIMULTANEOUS_REC.SET_TOTAL_TIME:
	      state.records.map(function (r) {
	        return r.callOutId === action.payload.callOutId ? r.previewTime = action.payload.time - r.initialTimeSec + r.totalPreviewTime : r.previewTime;
	      });
	      return Object.assign({}, state);
	    case _constants.PREVIEW_SIMULTANEOUS_REC.SET_PHONE_TO_CALL:
	      state.records.map(function (r) {
	        return r.callOutId === action.payload.callOutId ? r.phoneToCall = action.payload.phone : r.phoneToCall;
	      });
	      return Object.assign({}, state);
	    case _constants.PREVIEW_SIMULTANEOUS_REC.REMOVE_RECORD:
	      temp = state.records.filter(function (r) {
	        return r.callOutId !== action.payload;
	      });
	      return Object.assign({}, state, {
	        records: temp,
	        selectedRecord: state.selectedRecord.callOutId === action.payload ? { callOutId: 0, data: [] } : state.selectedRecord,
	        isSomeRecInDialog: temp.map(function (r) {
	          return r.status === _constants.RECORD_STATE.DIALOG || r.status === _constants.RECORD_STATE.HOLD || r.status === _constants.RECORD_STATE.WRAPUP || r.status === _constants.RECORD_STATE.ABANDONED;
	        }).includes(true)
	        //countRecordsToWrapUp: (temp.filter(r=>(r.status ===  RECORD_STATE.WRAPUP || r.status === RECORD_STATE.ABANDONED || r.status === RECORD_STATE.ALERT))).length
	      });
	    case _constants.PREVIEW_SIMULTANEOUS_REC.SAVE_LOG_DIAL:
	      state.records.map(function (r) {
	        return r.callOutId === action.payload.callOutId ? r.logDial = action.payload.logDial : r.logDial;
	      });
	      return Object.assign({}, state);
	    case _constants.PREVIEW_SIMULTANEOUS_REC.CHANGE_RECORD_STATE:
	      var temporalRecords = state.records.map(function (r) {
	        if (r.callOutId === action.payload.callOutId) {
	          return Object.assign({}, r, {
	            status: action.payload.status,
	            messageStatus: action.payload.messageStatus ? action.payload.messageStatus : r.messageStatus,
	            remainingTime: action.payload.status === _constants.RECORD_STATE.DIALING ? action.payload.remainingTime : r.remainingTime,
	            waitingWrapUp: action.payload.status === _constants.RECORD_STATE.WAITING_WRAPUP ? true : false
	          });
	        }
	        return r;
	      });
	
	      var temporalRecord = state.selectedRecord.callOutId === action.payload.callOutId ? action.payload : state.selectedRecord;
	      var tempRecordsDialing = temporalRecords.filter(function (r) {
	        return r.status === _constants.RECORD_STATE.DIALING;
	      }).length;
	      var tempRecordsDialog = temporalRecords.filter(function (r) {
	        return r.status === _constants.RECORD_STATE.DIALOG;
	      }).length;
	      var tempRecordsHold = temporalRecords.filter(function (r) {
	        return r.status === _constants.RECORD_STATE.HOLD;
	      }).length;
	      var tempRecordsToWrapUp = temporalRecords.filter(function (r) {
	        return r.status === _constants.RECORD_STATE.WRAPUP || r.status === _constants.RECORD_STATE.ABANDONED || r.status === _constants.RECORD_STATE.ALERT;
	      }).length;
	      return Object.assign({}, state, {
	        records: temporalRecords,
	        isSomeRecInDialog: temporalRecords.map(function (r) {
	          return r.status === _constants.RECORD_STATE.DIALOG || r.status === _constants.RECORD_STATE.HOLD || r.status === _constants.RECORD_STATE.WRAPUP || r.status === _constants.RECORD_STATE.ABANDONED;
	        }).includes(true),
	        countRecordsDialing: tempRecordsDialing,
	        countRecordsDialog: tempRecordsDialog,
	        selectedRecord: Object.assign({}, state.selectedRecord, temporalRecord),
	        switchBetweenHold: tempRecordsDialog === 0 && tempRecordsHold > 0 ? true : false,
	        // countRecordsToWrapUp: tempRecordsToWrapUp,
	        switchBetweenWrapUp: tempRecordsDialog === 0 && tempRecordsHold === 0 && tempRecordsToWrapUp > 0
	      });
	    case _constants.PREVIEW_SIMULTANEOUS_REC.SET_INITIAL_DIALOG_TIME:
	      var tempRecords = state.records.map(function (r) {
	        if (r.callOutId === action.payload.callOutId) {
	          return Object.assign({}, r, {
	            timeOnDialog: r.timeOnDialog === 0 && action.payload.timeOnDialog ? action.payload.timeOnDialog : r.timeOnDialog
	          });
	        }
	        return r;
	      });
	
	      var tempRecord = state.selectedRecord.callOutId === action.payload.callOutId ? action.payload : state.selectedRecord;
	
	      return Object.assign({}, state, {
	        records: tempRecords,
	        selectedRecord: Object.assign({}, state.selectedRecord, tempRecord)
	      });
	    case _constants.PREVIEW_SIMULTANEOUS_REC.SELECTED_RECORD:
	      return Object.assign({}, state, {
	        selectedRecord: state.records.find(function (r) {
	          return r.callOutId === action.payload;
	        })
	      });
	    case _constants.PREVIEW_SIMULTANEOUS_REC.MESSAGE_STATUS:
	      state.records.map(function (r) {
	        return r.callOutId === action.payload.callOutId ? r.messageStatus = action.payload.messageStatus : r.messageStatus;
	      });
	      return Object.assign({}, state);
	    case _constants.PREVIEW_SIMULTANEOUS_REC.SET_INITIAL_TIMESEC:
	      state.records.map(function (r) {
	        return r.callOutId === action.payload.callOutId ? r.initialTimeSec = action.payload.seconds : r.initialTimeSec;
	      });
	      return Object.assign({}, state);
	    case _constants.PREVIEW_SIMULTANEOUS_REC.RESET_RECORD:
	      var selectedRecordReset = Object.assign({}, state.records.find(function (r) {
	        return r.callOutId === action.payload;
	      }), {
	        previewTime: state.selectedRecord.initPreviewTime,
	        status: _constants.RECORD_STATE.DEFAULT,
	        messageStatus: null,
	        marks: [],
	        itWasSentTimeInPreview: false,
	        timeOnDialog: 0,
	        dialogTime: undefined,
	        volume: { microphoneVol: sharedData.getVolumeMic(), speakerVol: sharedData.getVolumeSpeaker() },
	        dispositionData: { alreadyRated: false, exitPreview: undefined },
	        isTimeAscending: state.selectedRecord.initPreviewTime === 0 ? true : false,
	        remainingTime: 0,
	        logDial: [],
	        agentHungUp: false,
	        initialTimeSec: (0, _formats.getCurrentTimeInSec)(),
	        flagLogDial: true
	      });
	      var tRecords = state.records.map(function (r) {
	        return r.callOutId === action.payload ? selectedRecordReset : r;
	      });
	      return Object.assign({}, state, {
	        records: tRecords,
	        selectedRecord: selectedRecordReset,
	        isSomeRecInDialog: tRecords.map(function (r) {
	          return r.status === _constants.RECORD_STATE.DIALOG || r.status === _constants.RECORD_STATE.HOLD || r.status === _constants.RECORD_STATE.WRAPUP || r.status === _constants.RECORD_STATE.ABANDONED;
	        }).includes(true)
	        //countRecordsToWrapUp: (tRecords.filter(r=>(r.status ===  RECORD_STATE.WRAPUP || r.status === RECORD_STATE.ABANDONED || r.status === RECORD_STATE.ALERT))).length
	
	      });
	    case _constants.PREVIEW_SIMULTANEOUS_REC.SET_CALL_ID:
	      state.records.map(function (r) {
	        return r.callOutId === action.payload.callOutId ? (r.callId = action.payload.callId, r.calloutMaxTime = action.payload.calloutMaxTime) : (r.callId, r.calloutMaxTime);
	      });
	      return Object.assign({}, state);
	    case _constants.PREVIEW_SIMULTANEOUS_REC.SET_DIALOG_TIME:
	      state.records.map(function (r) {
	        return r.callOutId === action.payload.callOutId ? r.dialogTime = action.payload.dialogTime : r.dialogTime;
	      });
	      return Object.assign({}, state);
	    case _constants.PREVIEW_SIMULTANEOUS_REC.SET_MAXIMUM_ASSIGNMENTS:
	      state.records.map(function (r) {
	        return r.callOutId === action.payload.callOutId ? r.maximumAssignments = action.payload.maximumAssignments : r.maximumAssignments;
	      });
	      return Object.assign({}, state, {
	        selectedRecord: state.records.find(function (r) {
	          return r.callOutId === state.selectedRecord.callOutId;
	        }) || state.selectedRecord
	      });
	    case _constants.PREVIEW_SIMULTANEOUS_REC.SET_IT_WAS_SENT_TIME:
	      state.records.map(function (r) {
	        return r.callOutId === action.payload.callOutId ? r.itWasSentTimeInPreview = action.payload.itWasSent : state.itWasSentTimeInPreview;
	      });
	      return Object.assign({}, state);
	    case _constants.PREVIEW_SIMULTANEOUS_REC.SET_VOLUME:
	      state.records.map(function (r) {
	        return r.callOutId === action.payload.callOutId ? r.volume = { microphoneVol: action.payload.micVol, speakerVol: action.payload.speakVol } : r.volume;
	      });
	      return Object.assign({}, state);
	    case _constants.PREVIEW_SIMULTANEOUS_REC.SET_DISPOSITION_DATA:
	      state.records.map(function (r) {
	        return r.callOutId === action.payload.callOutId ? r.dispositionData = { alreadyRated: action.payload.alreadyRated, exitPreview: action.payload.exitPreview } : r.dispositionData;
	      });
	      return Object.assign({}, state, {
	        selectedRecord: state.records.find(function (r) {
	          return r.callOutId === state.selectedRecord.callOutId;
	        }) || state.selectedRecord
	      });
	    case _constants.PREVIEW_SIMULTANEOUS_REC.SET_ND_SCHEDULED:
	      return Object.assign({}, state, {
	        ndScheduled: true
	      });
	    case _constants.PREVIEW_SIMULTANEOUS_REC.SET_FLAG_LOGDIAL:
	      var tempRecs = state.records.map(function (r) {
	        if (r.callOutId === action.payload) {
	          r.flagLogDial = false;
	        }
	        return r;
	      });
	      return Object.assign({}, state, {
	        records: tempRecs,
	        selectedRecord: tempRecs.find(function (r) {
	          return r.callOutId === action.payload;
	        })
	      });
	    default:
	      return state;
	  }
	};
	
	exports.default = preview;

/***/ },
/* 1185 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _constants = __webpack_require__(10);
	
	var initialActionState = {
	  reducer_type: _constants.REDUCERS.REDUCER_ACTIOS_FROM_SM,
	  acdList: [],
	  phoneList: [],
	  agentList: [],
	  acceptedTransfer: null,
	  showing: false,
	  showData: true,
	  transferInProgress: false,
	  unnasignByXfer: false,
	  mainAgent: ''
	};
	
	var previewActions = function previewActions() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialActionState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _constants.PREVIEW_TRANSFER.DATA_CALL_PREVIEW:
	      return Object.assign({}, state, {
	        previewAction: action.previewAction,
	        acdList: action.acdList,
	        phoneList: action.phoneList,
	        agentList: action.agentList
	      });
	    case _constants.PREVIEW_TRANSFER.ON_RESPONSE_TRANSFER:
	      return Object.assign({}, state, {
	        acceptedTransfer: action.isAccepted
	      });
	    case _constants.PREVIEW_TRANSFER.SHOW_ALERT:
	      return Object.assign({}, state, {
	        showing: !state.showing
	      });
	    case _constants.PREVIEW_TRANSFER.SHOW_PREVIEW_DATA:
	      return Object.assign({}, state, {
	        showData: action.show
	      });
	    case _constants.PREVIEW_TRANSFER.SET_AGENT_LIST:
	      return Object.assign({}, state, {
	        agentList: action.agentList
	      });
	    case _constants.PREVIEW_TRANSFER.TRANSFER_IN_PROGRESS:
	      return Object.assign({}, state, {
	        transferInProgress: action.flag
	      });
	    case _constants.PREVIEW_TRANSFER.UNNASIGN_BY_XFER:
	      return Object.assign({}, state, {
	        unnasignByXfer: action.flag.flag,
	        mainAgent: action.flag.mainAgent
	      });
	
	    default:
	      return state;
	  }
	};
	
	exports.default = previewActions;

/***/ },
/* 1186 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _constants = __webpack_require__(10);
	
	var initialCount = {
	  count: 0,
	  countType: -1,
	  time: 0
	};
	
	var queueCount = function queueCount() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialCount;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _constants.QUEUE_COUNT.CALLS:
	      return { countType: action.type, count: action.count, time: action.time };
	    case _constants.QUEUE_COUNT.MESSAGES:
	    case _constants.QUEUE_COUNT.FACEBOOK:
	    case _constants.QUEUE_COUNT.LINKEDIN:
	    case _constants.QUEUE_COUNT.TWITTER:
	    case _constants.QUEUE_COUNT.MAIL:
	      return { countType: action.type, count: action.count, time: action.time };
	    default:
	      return state;
	  }
	};
	
	exports.default = queueCount;

/***/ },
/* 1187 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _constants = __webpack_require__(10);
	
	var initialSipClientActions = {
		reducer_type: _constants.REDUCERS.SIP_CLIENT_ACTIONS,
		actionType: _constants.SIP_CLIENT_ACTIONS.NONE,
		stream: 0
	};
	
	var sipClientActions = function sipClientActions() {
		var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialSipClientActions;
		var action = arguments[1];
	
		state = initialSipClientActions;
		switch (action.type) {
			case _constants.SIP_CLIENT_ACTIONS.HANGUP:
				return { actionType: _constants.SIP_CLIENT_ACTIONS.HANGUP };
			case _constants.SIP_CLIENT_ACTIONS.STREAM:
				return {
					stream: action.data
				};
			default:
				return state;
		}
	};
	
	exports.default = sipClientActions;

/***/ },
/* 1188 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _constants = __webpack_require__(10);
	
	var initialState = {
	    currentAssistedTransfer: undefined,
	    currentBlindTransfer: undefined,
	    showDataBySetting: false
	};
	
	var transferReducer = function transferReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _constants.TRANSFER_ACTIONS.BLIND_TRANSFER:
	            return Object.assign({}, state, { currentBlindTransfer: action.payload });
	        case _constants.TRANSFER_ACTIONS.RESET_BLIND_TRANSFER:
	            return Object.assign({}, state, { currentBlindTransfer: undefined });
	        case _constants.TRANSFER_ACTIONS.ASSISTED_TRANSFER:
	            return Object.assign({}, state, { currentAssistedTransfer: action.payload });
	        case _constants.TRANSFER_ACTIONS.RESET_ASSISTED_TRANSFER:
	            return Object.assign({}, state, { currentAssistedTransfer: undefined });
	        case _constants.TRANSFER_ACTIONS.SHOW_DATA_TRANSGER_BY_SETTING:
	            return Object.assign({}, state, { showDataBySetting: action.payload });
	        default:
	            return state;
	    }
	};
	
	exports.default = transferReducer;

/***/ },
/* 1189 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _constants = __webpack_require__(10);
	
	var initialUserActions = {
	  reducer_type: _constants.REDUCERS.REDUCER_ACTIOS_FROM_SM,
	  actionType: _constants.USER_ACTIONS.NONE,
	  webLogged: false,
	  ccserverLogged: false,
	  language: '1' //ONLY FOR RENDER THE APP, THE CURRENT LANGUAGE IS IN THE SINGLETON
	};
	
	var userActions = function userActions() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialUserActions;
	  var action = arguments[1];
	
	  state = initialUserActions;
	  switch (action.type) {
	    case _constants.USER_ACTIONS.NONE:
	      return Object.assign({}, state, { actionType: _constants.USER_ACTIONS.NONE });
	    case _constants.USER_ACTIONS.LOGIN:
	      return Object.assign({}, state, { actionType: _constants.USER_ACTIONS.LOGIN, language: action.c_language, webLogged: action.webLogged, ccserverLogged: action.ccserverLogged });
	    case _constants.USER_ACTIONS.CHANGE_LANGUAGE:
	      return Object.assign({}, state, { actionType: _constants.USER_ACTIONS.CHANGE_LANGUAGE, language: action.c_language });
	    case _constants.USER_ACTIONS.LOGOUT:
	      return Object.assign({}, initialUserActions, { actionType: _constants.USER_ACTIONS.LOGOUT });
	    default:
	      return state;
	  }
	};
	
	exports.default = userActions;

/***/ },
/* 1190 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _constants = __webpack_require__(10);
	
	var initialUserState = {
	  reducer_type: _constants.REDUCERS.REDUCER_ACTIOS_FROM_SM,
	  currentState: _constants.USER_STATE.LOGED_OUT,
	  prevState: _constants.USER_STATE.LOGED_OUT
	};
	
	var userState = function userState() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialUserState;
	  var action = arguments[1];
	
	  if (action.type === _constants.USER_STATE.CHANGE_STATE) {
	    if (action.currentState === _constants.USER_STATE.WRAPUP) {
	      if ([_constants.USER_STATE.CALL_OUT, _constants.USER_STATE.DIALOG, _constants.USER_STATE.CHATTING, _constants.USER_STATE.DIALOG_WHATSAPP, _constants.USER_STATE.DIALOG_EMAIL, _constants.USER_STATE.OTHER].includes(state.currentState)) {
	        return { currentState: action.currentState, prevState: state.currentState };
	      }
	      return state;
	    } else {
	      return { currentState: action.currentState, prevState: state.currentState };
	    }
	  } else {
	    return state;
	  }
	};
	
	exports.default = userState;

/***/ },
/* 1191 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _constants = __webpack_require__(10);
	
	var validatingInitialState = {
	  reducer_type: _constants.REDUCERS.REDUCER_ACTIOS_FROM_SM,
	  currentState: _constants.VALIDATING_TELEPHONY.VALIDATING,
	  time: 0
	};
	
	var validatingTelephonyState = function validatingTelephonyState() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : validatingInitialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _constants.VALIDATING_TELEPHONY.VALIDATING:
	      return { currentState: _constants.VALIDATING_TELEPHONY.VALIDATING, time: action.time };
	    case _constants.VALIDATING_TELEPHONY.VALID:
	      return { currentState: _constants.VALIDATING_TELEPHONY.VALID, time: 0 };
	    case _constants.VALIDATING_TELEPHONY.ERROR:
	      return { currentState: _constants.VALIDATING_TELEPHONY.ERROR, time: 0 };
	    default:
	      return state;
	  }
	};
	
	exports.default = validatingTelephonyState;

/***/ },
/* 1192 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _constants = __webpack_require__(10);
	
	var initialVolume = {
	  reducer_type: _constants.REDUCERS.VOLUME,
	  changingVolume: false,
	  speakerVolume: 50,
	  microphoneVolume: 50
	};
	
	var volumeControl = function volumeControl() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialVolume;
	  var action = arguments[1];
	
	  state.changingVolume = false;
	  switch (action.type) {
	    case _constants.VOLUME.SPEAKER:
	      return Object.assign({}, state, { speakerVolume: action.volume, changingVolume: true });
	    case _constants.VOLUME.MICROPHONE:
	      return Object.assign({}, state, { microphoneVolume: action.volume, changingVolume: true });
	    default:
	      return state;
	  }
	};
	
	exports.default = volumeControl;

/***/ },
/* 1193 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	   value: true
	});
	
	var _constants = __webpack_require__(10);
	
	var initialWhiteLabelState = {
	   whiteLabelEnabled: false,
	   imageFormat: 'svg',
	   login: undefined,
	   header: undefined,
	   about: undefined
	};
	
	var whiteLabelState = function whiteLabelState() {
	   var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialWhiteLabelState;
	   var action = arguments[1];
	
	   switch (action.type) {
	      case _constants.ACTIONS_FROM_WHITE_LABEL.SET_CUSTOM_IMAGES:
	         return Object.assign({}, state, {
	            whiteLabelEnabled: action.whiteLabelEnabled,
	            imageFormat: action.imageFormat,
	            login: action.login,
	            header: action.header,
	            about: action.about
	         });
	      default:
	         return state;
	   }
	};
	
	exports.default = whiteLabelState;

/***/ },
/* 1194 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _constants = __webpack_require__(10);
	
	var initialWindowVisible = {
	  reducer_type: _constants.REDUCERS.WINDOW_VISIBLE,
	  windowVisible: _constants.WINDOW_AT_500.NONE
	};
	
	var windowVisible500 = function windowVisible500() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialWindowVisible;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _constants.WINDOW_AT_500.NONE:
	      return { windowVisible: _constants.WINDOW_AT_500.NONE };
	    case _constants.WINDOW_AT_500.MESSAGE:
	      if (state.windowVisible === _constants.WINDOW_AT_500.MESSAGE) {
	        return { windowVisible: _constants.WINDOW_AT_500.NONE };
	      }
	      return { windowVisible: _constants.WINDOW_AT_500.MESSAGE };
	    case _constants.WINDOW_AT_500.CALL:
	      if (state.windowVisible === _constants.WINDOW_AT_500.CALL) {
	        return { windowVisible: _constants.WINDOW_AT_500.NONE };
	      }
	      return { windowVisible: _constants.WINDOW_AT_500.CALL };
	    default:
	      return state;
	  }
	};
	exports.default = windowVisible500;

/***/ },
/* 1195 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _constants = __webpack_require__(10);
	
	var initialWorkBarState = {
	  workBarOpen: null,
	  workBarRemove: _constants.WORKBAR_ACTIONS.NONE,
	  workBarAction: _constants.WORKBAR_ACTIONS.NONE
	};
	
	var workBarSelected = function workBarSelected() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialWorkBarState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _constants.WORKBAR_ACTIONS.INSERT_WINDOW:
	      return { workBarOpen: action.componentOpen, workBarAction: _constants.WORKBAR_ACTIONS.INSERT_WINDOW };
	    case _constants.WORKBAR_ACTIONS.REMOVE_WINDOW:
	      return { workBarRemove: action.componentRemove, workBarAction: _constants.WORKBAR_ACTIONS.REMOVE_WINDOW };
	    default:
	      return state;
	  }
	};
	
	exports.default = workBarSelected;

/***/ },
/* 1196 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {// This method of obtaining a reference to the global object needs to be
	// kept identical to the way it is obtained in runtime.js
	var g =
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this;
	
	// Use `getOwnPropertyNames` because not all browsers support calling
	// `hasOwnProperty` on the global `self` object in a worker. See #183.
	var hadRuntime = g.regeneratorRuntime &&
	  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;
	
	// Save the old regeneratorRuntime in case it needs to be restored later.
	var oldRuntime = hadRuntime && g.regeneratorRuntime;
	
	// Force reevalutation of runtime.js.
	g.regeneratorRuntime = undefined;
	
	module.exports = __webpack_require__(1197);
	
	if (hadRuntime) {
	  // Restore the original runtime.
	  g.regeneratorRuntime = oldRuntime;
	} else {
	  // Remove the global property added by runtime.js.
	  try {
	    delete g.regeneratorRuntime;
	  } catch(e) {
	    g.regeneratorRuntime = undefined;
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1197 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof global.process === "object" && global.process.domain) {
	      invoke = global.process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1198 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1221), __esModule: true };

/***/ },
/* 1199 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1224), __esModule: true };

/***/ },
/* 1200 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1226), __esModule: true };

/***/ },
/* 1201 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1228), __esModule: true };

/***/ },
/* 1202 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1229), __esModule: true };

/***/ },
/* 1203 */
/***/ function(module, exports) {

	'use strict';
	module.exports = balanced;
	function balanced(a, b, str) {
	  if (a instanceof RegExp) a = maybeMatch(a, str);
	  if (b instanceof RegExp) b = maybeMatch(b, str);
	
	  var r = range(a, b, str);
	
	  return r && {
	    start: r[0],
	    end: r[1],
	    pre: str.slice(0, r[0]),
	    body: str.slice(r[0] + a.length, r[1]),
	    post: str.slice(r[1] + b.length)
	  };
	}
	
	function maybeMatch(reg, str) {
	  var m = str.match(reg);
	  return m ? m[0] : null;
	}
	
	balanced.range = range;
	function range(a, b, str) {
	  var begs, beg, left, right, result;
	  var ai = str.indexOf(a);
	  var bi = str.indexOf(b, ai + 1);
	  var i = ai;
	
	  if (ai >= 0 && bi > 0) {
	    if(a===b) {
	      return [ai, bi];
	    }
	    begs = [];
	    left = str.length;
	
	    while (i >= 0 && !result) {
	      if (i == ai) {
	        begs.push(i);
	        ai = str.indexOf(a, i + 1);
	      } else if (begs.length == 1) {
	        result = [ begs.pop(), bi ];
	      } else {
	        beg = begs.pop();
	        if (beg < left) {
	          left = beg;
	          right = bi;
	        }
	
	        bi = str.indexOf(b, i + 1);
	      }
	
	      i = ai < bi && ai >= 0 ? ai : bi;
	    }
	
	    if (begs.length) {
	      result = [ left, right ];
	    }
	  }
	
	  return result;
	}


/***/ },
/* 1204 */
/***/ function(module, exports) {

	function e(r){var o,t,f="";if("string"==typeof r||"number"==typeof r)f+=r;else if("object"==typeof r)if(Array.isArray(r))for(o=0;o<r.length;o++)r[o]&&(t=e(r[o]))&&(f&&(f+=" "),f+=t);else for(o in r)r[o]&&(f&&(f+=" "),f+=o);return f}function r(){for(var r,o,t=0,f="";t<arguments.length;)(r=arguments[t++])&&(o=e(r))&&(f&&(f+=" "),f+=o);return f}module.exports=r,module.exports.clsx=r;

/***/ },
/* 1205 */
/***/ function(module, exports) {

	function t(t){return"object"==typeof t&&null!=t&&1===t.nodeType}function e(t,e){return(!e||"hidden"!==t)&&"visible"!==t&&"clip"!==t}function n(t,n){if(t.clientHeight<t.scrollHeight||t.clientWidth<t.scrollWidth){var i=getComputedStyle(t,null);return e(i.overflowY,n)||e(i.overflowX,n)||function(t){var e=function(t){if(!t.ownerDocument||!t.ownerDocument.defaultView)return null;try{return t.ownerDocument.defaultView.frameElement}catch(t){return null}}(t);return!!e&&(e.clientHeight<t.scrollHeight||e.clientWidth<t.scrollWidth)}(t)}return!1}function i(t,e,n,i,r,o,l,d){return o<t&&l>e||o>t&&l<e?0:o<=t&&d<=n||l>=e&&d>=n?o-t-i:l>e&&d<n||o<t&&d>n?l-e+r:0}module.exports=function(e,r){var o=window,l=r.scrollMode,d=r.block,f=r.inline,h=r.boundary,u=r.skipOverflowHiddenElements,s="function"==typeof h?h:function(t){return t!==h};if(!t(e))throw new TypeError("Invalid target");for(var c,a,g=document.scrollingElement||document.documentElement,m=[],p=e;t(p)&&s(p);){if((p=null==(a=(c=p).parentElement)?c.getRootNode().host||null:a)===g){m.push(p);break}null!=p&&p===document.body&&n(p)&&!n(document.documentElement)||null!=p&&n(p,u)&&m.push(p)}for(var w=o.visualViewport?o.visualViewport.width:innerWidth,v=o.visualViewport?o.visualViewport.height:innerHeight,W=window.scrollX||pageXOffset,H=window.scrollY||pageYOffset,b=e.getBoundingClientRect(),y=b.height,E=b.width,M=b.top,V=b.right,x=b.bottom,I=b.left,C="start"===d||"nearest"===d?M:"end"===d?x:M+y/2,R="center"===f?I+E/2:"end"===f?V:I,T=[],k=0;k<m.length;k++){var B=m[k],D=B.getBoundingClientRect(),O=D.height,X=D.width,Y=D.top,L=D.right,S=D.bottom,j=D.left;if("if-needed"===l&&M>=0&&I>=0&&x<=v&&V<=w&&M>=Y&&x<=S&&I>=j&&V<=L)return T;var N=getComputedStyle(B),q=parseInt(N.borderLeftWidth,10),z=parseInt(N.borderTopWidth,10),A=parseInt(N.borderRightWidth,10),F=parseInt(N.borderBottomWidth,10),G=0,J=0,K="offsetWidth"in B?B.offsetWidth-B.clientWidth-q-A:0,P="offsetHeight"in B?B.offsetHeight-B.clientHeight-z-F:0,Q="offsetWidth"in B?0===B.offsetWidth?0:X/B.offsetWidth:0,U="offsetHeight"in B?0===B.offsetHeight?0:O/B.offsetHeight:0;if(g===B)G="start"===d?C:"end"===d?C-v:"nearest"===d?i(H,H+v,v,z,F,H+C,H+C+y,y):C-v/2,J="start"===f?R:"center"===f?R-w/2:"end"===f?R-w:i(W,W+w,w,q,A,W+R,W+R+E,E),G=Math.max(0,G+H),J=Math.max(0,J+W);else{G="start"===d?C-Y-z:"end"===d?C-S+F+P:"nearest"===d?i(Y,S,O,z,F+P,C,C+y,y):C-(Y+O/2)+P/2,J="start"===f?R-j-q:"center"===f?R-(j+X/2)+K/2:"end"===f?R-L+A+K:i(j,L,X,q,A+K,R,R+E,E);var Z=B.scrollLeft,$=B.scrollTop;C+=$-(G=Math.max(0,Math.min($+G/U,B.scrollHeight-O/U+P))),R+=Z-(J=Math.max(0,Math.min(Z+J/Q,B.scrollWidth-X/Q+K)))}T.push({el:B,top:G,left:J})}return T};
	//# sourceMappingURL=index.js.map


/***/ },
/* 1206 */
/***/ function(module, exports) {

	// This code has been refactored for 140 bytes
	// You can see the original here: https://github.com/twolfson/computedStyle/blob/04cd1da2e30fa45844f95f5cb1ac898e9b9ef050/lib/computedStyle.js
	var computedStyle = function (el, prop, getComputedStyle) {
	  getComputedStyle = window.getComputedStyle;
	
	  // In one fell swoop
	  return (
	    // If we have getComputedStyle
	    getComputedStyle ?
	      // Query it
	      // TODO: From CSS-Query notes, we might need (node, null) for FF
	      getComputedStyle(el) :
	
	    // Otherwise, we are in IE and use currentStyle
	      el.currentStyle
	  )[
	    // Switch to camelCase for CSSOM
	    // DEV: Grabbed from jQuery
	    // https://github.com/jquery/jquery/blob/1.9-stable/src/css.js#L191-L194
	    // https://github.com/jquery/jquery/blob/1.9-stable/src/core.js#L593-L597
	    prop.replace(/-(\w)/gi, function (word, letter) {
	      return letter.toUpperCase();
	    })
	  ];
	};
	
	module.exports = computedStyle;


/***/ },
/* 1207 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1365);
	__webpack_require__(1304);
	__webpack_require__(1306);
	__webpack_require__(1305);
	__webpack_require__(1308);
	__webpack_require__(1310);
	__webpack_require__(1315);
	__webpack_require__(1309);
	__webpack_require__(1307);
	__webpack_require__(1317);
	__webpack_require__(1316);
	__webpack_require__(1312);
	__webpack_require__(1313);
	__webpack_require__(1311);
	__webpack_require__(1303);
	__webpack_require__(1314);
	__webpack_require__(1318);
	__webpack_require__(1319);
	__webpack_require__(1299);
	__webpack_require__(1301);
	__webpack_require__(1300);
	__webpack_require__(1321);
	__webpack_require__(1320);
	__webpack_require__(577);
	__webpack_require__(587);
	__webpack_require__(588);
	__webpack_require__(578);
	__webpack_require__(579);
	__webpack_require__(580);
	__webpack_require__(581);
	__webpack_require__(582);
	__webpack_require__(583);
	__webpack_require__(584);
	__webpack_require__(585);
	__webpack_require__(586);
	__webpack_require__(560);
	__webpack_require__(561);
	__webpack_require__(562);
	__webpack_require__(563);
	__webpack_require__(564);
	__webpack_require__(565);
	__webpack_require__(566);
	__webpack_require__(567);
	__webpack_require__(568);
	__webpack_require__(569);
	__webpack_require__(570);
	__webpack_require__(571);
	__webpack_require__(572);
	__webpack_require__(573);
	__webpack_require__(574);
	__webpack_require__(575);
	__webpack_require__(576);
	__webpack_require__(1352);
	__webpack_require__(1357);
	__webpack_require__(1364);
	__webpack_require__(1355);
	__webpack_require__(1347);
	__webpack_require__(1348);
	__webpack_require__(1353);
	__webpack_require__(1358);
	__webpack_require__(1360);
	__webpack_require__(1343);
	__webpack_require__(1344);
	__webpack_require__(1345);
	__webpack_require__(1346);
	__webpack_require__(1349);
	__webpack_require__(1350);
	__webpack_require__(1351);
	__webpack_require__(1354);
	__webpack_require__(1356);
	__webpack_require__(1359);
	__webpack_require__(1361);
	__webpack_require__(1362);
	__webpack_require__(1363);
	__webpack_require__(1294);
	__webpack_require__(1296);
	__webpack_require__(1295);
	__webpack_require__(1298);
	__webpack_require__(1297);
	__webpack_require__(1283);
	__webpack_require__(1281);
	__webpack_require__(1287);
	__webpack_require__(1284);
	__webpack_require__(1290);
	__webpack_require__(1292);
	__webpack_require__(1280);
	__webpack_require__(1286);
	__webpack_require__(1277);
	__webpack_require__(1291);
	__webpack_require__(1275);
	__webpack_require__(1289);
	__webpack_require__(1288);
	__webpack_require__(1282);
	__webpack_require__(1285);
	__webpack_require__(1274);
	__webpack_require__(1276);
	__webpack_require__(1279);
	__webpack_require__(1278);
	__webpack_require__(1293);
	__webpack_require__(376);
	__webpack_require__(1336);
	__webpack_require__(590);
	__webpack_require__(1341);
	__webpack_require__(591);
	__webpack_require__(1337);
	__webpack_require__(1338);
	__webpack_require__(1339);
	__webpack_require__(1340);
	__webpack_require__(589);
	__webpack_require__(1302);
	__webpack_require__(1342);
	__webpack_require__(1377);
	__webpack_require__(1378);
	__webpack_require__(1366);
	__webpack_require__(1367);
	__webpack_require__(1372);
	__webpack_require__(1375);
	__webpack_require__(1376);
	__webpack_require__(1370);
	__webpack_require__(1373);
	__webpack_require__(1371);
	__webpack_require__(1374);
	__webpack_require__(1368);
	__webpack_require__(1369);
	__webpack_require__(1322);
	__webpack_require__(1323);
	__webpack_require__(1324);
	__webpack_require__(1325);
	__webpack_require__(1326);
	__webpack_require__(1329);
	__webpack_require__(1327);
	__webpack_require__(1328);
	__webpack_require__(1330);
	__webpack_require__(1331);
	__webpack_require__(1332);
	__webpack_require__(1333);
	__webpack_require__(1335);
	__webpack_require__(1334);
	module.exports = __webpack_require__(46);


/***/ },
/* 1208 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(560);
	__webpack_require__(561);
	__webpack_require__(562);
	__webpack_require__(563);
	__webpack_require__(564);
	__webpack_require__(565);
	__webpack_require__(566);
	__webpack_require__(567);
	__webpack_require__(568);
	__webpack_require__(569);
	__webpack_require__(570);
	__webpack_require__(571);
	__webpack_require__(572);
	__webpack_require__(573);
	__webpack_require__(574);
	__webpack_require__(575);
	__webpack_require__(576);
	module.exports = __webpack_require__(46).Math;


/***/ },
/* 1209 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(577);
	__webpack_require__(587);
	__webpack_require__(588);
	__webpack_require__(578);
	__webpack_require__(579);
	__webpack_require__(580);
	__webpack_require__(581);
	__webpack_require__(582);
	__webpack_require__(583);
	__webpack_require__(584);
	__webpack_require__(585);
	__webpack_require__(586);
	module.exports = __webpack_require__(46).Number;


/***/ },
/* 1210 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1379);
	module.exports = __webpack_require__(46).Array.flatMap;


/***/ },
/* 1211 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1380);
	module.exports = __webpack_require__(46).Array.includes;


/***/ },
/* 1212 */
[2622, 1381, 46],
/* 1213 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1382);
	module.exports = __webpack_require__(46).Object.getOwnPropertyDescriptors;


/***/ },
/* 1214 */
[2623, 1383, 46],
/* 1215 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(589);
	__webpack_require__(1384);
	module.exports = __webpack_require__(46).Promise['finally'];


/***/ },
/* 1216 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1385);
	module.exports = __webpack_require__(46).String.padEnd;


/***/ },
/* 1217 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1386);
	module.exports = __webpack_require__(46).String.padStart;


/***/ },
/* 1218 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1388);
	module.exports = __webpack_require__(46).String.trimRight;


/***/ },
/* 1219 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1387);
	module.exports = __webpack_require__(46).String.trimLeft;


/***/ },
/* 1220 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1389);
	module.exports = __webpack_require__(374).f('asyncIterator');


/***/ },
/* 1221 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(531);
	__webpack_require__(1252);
	module.exports = __webpack_require__(76).Array.from;


/***/ },
/* 1222 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1259);
	module.exports = __webpack_require__(76).global;


/***/ },
/* 1223 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1254);
	module.exports = __webpack_require__(76).Object.assign;


/***/ },
/* 1224 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1255);
	var $Object = __webpack_require__(76).Object;
	module.exports = function create(P, D) {
	  return $Object.create(P, D);
	};


/***/ },
/* 1225 */
[2622, 1260, 76],
/* 1226 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1256);
	module.exports = __webpack_require__(76).Object.setPrototypeOf;


/***/ },
/* 1227 */
[2623, 1261, 76],
/* 1228 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1258);
	__webpack_require__(1257);
	__webpack_require__(1262);
	__webpack_require__(1263);
	module.exports = __webpack_require__(76).Symbol;


/***/ },
/* 1229 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(531);
	__webpack_require__(1264);
	module.exports = __webpack_require__(351).f('iterator');


/***/ },
/* 1230 */
89,
/* 1231 */
/***/ function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ },
/* 1232 */
[2625, 134, 530, 1250],
/* 1233 */
[2626, 339, 88],
/* 1234 */
[2627, 133, 200],
/* 1235 */
[2631, 198, 344, 199],
/* 1236 */
[2633, 103],
/* 1237 */
[2636, 197, 88],
/* 1238 */
[2637, 339],
/* 1239 */
[2638, 158],
/* 1240 */
[2639, 343, 200, 345, 159, 88],
/* 1241 */
[2641, 88],
/* 1242 */
544,
/* 1243 */
[2642, 244, 160, 132, 133, 196],
/* 1244 */
[2643, 116, 198, 344, 199, 243, 523, 196],
/* 1245 */
[2646, 133, 158, 198, 116],
/* 1246 */
[2648, 134, 526],
/* 1247 */
[2650, 132, 243, 346],
/* 1248 */
[2654, 160, 158, 340, 525],
/* 1249 */
[2658, 348, 341],
/* 1250 */
[2659, 348],
/* 1251 */
[2667, 1233, 88, 197, 76],
/* 1252 */
[2668, 340, 102, 243, 1239, 1237, 530, 1234, 1251, 1241],
/* 1253 */
[2669, 1231, 1242, 197, 134, 524],
/* 1254 */
[2670, 102, 1244],
/* 1255 */
[2671, 102, 343],
/* 1256 */
[2672, 102, 1248],
/* 1257 */
/***/ function(module, exports) {



/***/ },
/* 1258 */
[2674, 103, 132, 116, 102, 529, 1243, 196, 347, 345, 244, 88, 351, 350, 1235, 1238, 158, 160, 243, 134, 349, 200, 343, 1246, 525, 344, 133, 198, 526, 199, 242, 159],
/* 1259 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(102);
	
	$export($export.G, { global: __webpack_require__(103) });


/***/ },
/* 1260 */
[2675, 102, 528],
/* 1261 */
[2676, 102, 528],
/* 1262 */
[2677, 350],
/* 1263 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(350)('observable');


/***/ },
/* 1264 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1253);
	var global = __webpack_require__(103);
	var hide = __webpack_require__(159);
	var Iterators = __webpack_require__(197);
	var TO_STRING_TAG = __webpack_require__(88)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ },
/* 1265 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(36);
	var isArray = __webpack_require__(250);
	var SPECIES = __webpack_require__(44)('species');
	
	module.exports = function (original) {
	  var C;
	  if (isArray(original)) {
	    C = original.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};


/***/ },
/* 1266 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var fails = __webpack_require__(34);
	var getTime = Date.prototype.getTime;
	var $toISOString = Date.prototype.toISOString;
	
	var lz = function (num) {
	  return num > 9 ? num : '0' + num;
	};
	
	// PhantomJS / old WebKit has a broken implementations
	module.exports = (fails(function () {
	  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
	}) || !fails(function () {
	  $toISOString.call(new Date(NaN));
	})) ? function toISOString() {
	  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
	  var d = this;
	  var y = d.getUTCFullYear();
	  var m = d.getUTCMilliseconds();
	  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
	  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
	    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
	    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
	    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	} : $toISOString;


/***/ },
/* 1267 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var anObject = __webpack_require__(33);
	var toPrimitive = __webpack_require__(118);
	var NUMBER = 'number';
	
	module.exports = function (hint) {
	  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
	  return toPrimitive(anObject(this), hint != NUMBER);
	};


/***/ },
/* 1268 */
[2631, 140, 252, 203],
/* 1269 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
	var isArray = __webpack_require__(250);
	var isObject = __webpack_require__(36);
	var toLength = __webpack_require__(47);
	var ctx = __webpack_require__(91);
	var IS_CONCAT_SPREADABLE = __webpack_require__(44)('isConcatSpreadable');
	
	function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
	  var targetIndex = start;
	  var sourceIndex = 0;
	  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
	  var element, spreadable;
	
	  while (sourceIndex < sourceLen) {
	    if (sourceIndex in source) {
	      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
	
	      spreadable = false;
	      if (isObject(element)) {
	        spreadable = element[IS_CONCAT_SPREADABLE];
	        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
	      }
	
	      if (spreadable && depth > 0) {
	        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
	      } else {
	        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
	        target[targetIndex] = element;
	      }
	
	      targetIndex++;
	    }
	    sourceIndex++;
	  }
	  return targetIndex;
	}
	
	module.exports = flattenIntoArray;


/***/ },
/* 1270 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(254)('native-function-to-string', Function.toString);


/***/ },
/* 1271 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var sign = __webpack_require__(364);
	var pow = Math.pow;
	var EPSILON = pow(2, -52);
	var EPSILON32 = pow(2, -23);
	var MAX32 = pow(2, 127) * (2 - EPSILON32);
	var MIN32 = pow(2, -126);
	
	var roundTiesToEven = function (n) {
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	module.exports = Math.fround || function fround(x) {
	  var $abs = Math.abs(x);
	  var $sign = sign(x);
	  var a, result;
	  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	  a = (1 + EPSILON32 / EPSILON) * $abs;
	  result = a - (a - $abs);
	  // eslint-disable-next-line no-self-compare
	  if (result > MAX32 || result != result) return $sign * Infinity;
	  return $sign * result;
	};


/***/ },
/* 1272 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(35);
	var macrotask = __webpack_require__(372).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(104)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    var promise = Promise.resolve(undefined);
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ },
/* 1273 */
/***/ function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ },
/* 1274 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(11);
	
	$export($export.P, 'Array', { copyWithin: __webpack_require__(533) });
	
	__webpack_require__(135)('copyWithin');


/***/ },
/* 1275 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(11);
	var $every = __webpack_require__(90)(4);
	
	$export($export.P + $export.F * !__webpack_require__(82)([].every, true), 'Array', {
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: function every(callbackfn /* , thisArg */) {
	    return $every(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 1276 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(11);
	
	$export($export.P, 'Array', { fill: __webpack_require__(353) });
	
	__webpack_require__(135)('fill');


/***/ },
/* 1277 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(11);
	var $filter = __webpack_require__(90)(2);
	
	$export($export.P + $export.F * !__webpack_require__(82)([].filter, true), 'Array', {
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: function filter(callbackfn /* , thisArg */) {
	    return $filter(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 1278 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(11);
	var $find = __webpack_require__(90)(6);
	var KEY = 'findIndex';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(135)(KEY);


/***/ },
/* 1279 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(11);
	var $find = __webpack_require__(90)(5);
	var KEY = 'find';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(135)(KEY);


/***/ },
/* 1280 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(11);
	var $forEach = __webpack_require__(90)(0);
	var STRICT = __webpack_require__(82)([].forEach, true);
	
	$export($export.P + $export.F * !STRICT, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: function forEach(callbackfn /* , thisArg */) {
	    return $forEach(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 1281 */
[2668, 91, 11, 65, 542, 360, 47, 354, 375, 251],
/* 1282 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(11);
	var $indexOf = __webpack_require__(245)(false);
	var $native = [].indexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(82)($native)), 'Array', {
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? $native.apply(this, arguments) || 0
	      : $indexOf(this, searchElement, arguments[1]);
	  }
	});


/***/ },
/* 1283 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	var $export = __webpack_require__(11);
	
	$export($export.S, 'Array', { isArray: __webpack_require__(250) });


/***/ },
/* 1284 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.13 Array.prototype.join(separator)
	var $export = __webpack_require__(11);
	var toIObject = __webpack_require__(79);
	var arrayJoin = [].join;
	
	// fallback for not array-like strings
	$export($export.P + $export.F * (__webpack_require__(202) != Object || !__webpack_require__(82)(arrayJoin)), 'Array', {
	  join: function join(separator) {
	    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
	  }
	});


/***/ },
/* 1285 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(11);
	var toIObject = __webpack_require__(79);
	var toInteger = __webpack_require__(94);
	var toLength = __webpack_require__(47);
	var $native = [].lastIndexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(82)($native)), 'Array', {
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
	    // convert -0 to +0
	    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
	    var O = toIObject(this);
	    var length = toLength(O.length);
	    var index = length - 1;
	    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
	    if (index < 0) index = length + index;
	    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
	    return -1;
	  }
	});


/***/ },
/* 1286 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(11);
	var $map = __webpack_require__(90)(1);
	
	$export($export.P + $export.F * !__webpack_require__(82)([].map, true), 'Array', {
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: function map(callbackfn /* , thisArg */) {
	    return $map(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 1287 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(11);
	var createProperty = __webpack_require__(354);
	
	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(34)(function () {
	  function F() { /* empty */ }
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */) {
	    var index = 0;
	    var aLen = arguments.length;
	    var result = new (typeof this == 'function' ? this : Array)(aLen);
	    while (aLen > index) createProperty(result, index, arguments[index++]);
	    result.length = aLen;
	    return result;
	  }
	});


/***/ },
/* 1288 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(11);
	var $reduce = __webpack_require__(534);
	
	$export($export.P + $export.F * !__webpack_require__(82)([].reduceRight, true), 'Array', {
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
	  }
	});


/***/ },
/* 1289 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(11);
	var $reduce = __webpack_require__(534);
	
	$export($export.P + $export.F * !__webpack_require__(82)([].reduce, true), 'Array', {
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: function reduce(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
	  }
	});


/***/ },
/* 1290 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(11);
	var html = __webpack_require__(358);
	var cof = __webpack_require__(104);
	var toAbsoluteIndex = __webpack_require__(142);
	var toLength = __webpack_require__(47);
	var arraySlice = [].slice;
	
	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * __webpack_require__(34)(function () {
	  if (html) arraySlice.call(html);
	}), 'Array', {
	  slice: function slice(begin, end) {
	    var len = toLength(this.length);
	    var klass = cof(this);
	    end = end === undefined ? len : end;
	    if (klass == 'Array') return arraySlice.call(this, begin, end);
	    var start = toAbsoluteIndex(begin, len);
	    var upTo = toAbsoluteIndex(end, len);
	    var size = toLength(upTo - start);
	    var cloned = new Array(size);
	    var i = 0;
	    for (; i < size; i++) cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});


/***/ },
/* 1291 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(11);
	var $some = __webpack_require__(90)(3);
	
	$export($export.P + $export.F * !__webpack_require__(82)([].some, true), 'Array', {
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: function some(callbackfn /* , thisArg */) {
	    return $some(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 1292 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(11);
	var aFunction = __webpack_require__(89);
	var toObject = __webpack_require__(65);
	var fails = __webpack_require__(34);
	var $sort = [].sort;
	var test = [1, 2, 3];
	
	$export($export.P + $export.F * (fails(function () {
	  // IE8-
	  test.sort(undefined);
	}) || !fails(function () {
	  // V8 bug
	  test.sort(null);
	  // Old WebKit
	}) || !__webpack_require__(82)($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn) {
	    return comparefn === undefined
	      ? $sort.call(toObject(this))
	      : $sort.call(toObject(this), aFunction(comparefn));
	  }
	});


/***/ },
/* 1293 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(164)('Array');


/***/ },
/* 1294 */
/***/ function(module, exports, __webpack_require__) {

	// 20.3.3.1 / 15.9.4.4 Date.now()
	var $export = __webpack_require__(11);
	
	$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ },
/* 1295 */
/***/ function(module, exports, __webpack_require__) {

	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var $export = __webpack_require__(11);
	var toISOString = __webpack_require__(1266);
	
	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
	  toISOString: toISOString
	});


/***/ },
/* 1296 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(11);
	var toObject = __webpack_require__(65);
	var toPrimitive = __webpack_require__(118);
	
	$export($export.P + $export.F * __webpack_require__(34)(function () {
	  return new Date(NaN).toJSON() !== null
	    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
	}), 'Date', {
	  // eslint-disable-next-line no-unused-vars
	  toJSON: function toJSON(key) {
	    var O = toObject(this);
	    var pv = toPrimitive(O);
	    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	  }
	});


/***/ },
/* 1297 */
/***/ function(module, exports, __webpack_require__) {

	var TO_PRIMITIVE = __webpack_require__(44)('toPrimitive');
	var proto = Date.prototype;
	
	if (!(TO_PRIMITIVE in proto)) __webpack_require__(78)(proto, TO_PRIMITIVE, __webpack_require__(1267));


/***/ },
/* 1298 */
/***/ function(module, exports, __webpack_require__) {

	var DateProto = Date.prototype;
	var INVALID_DATE = 'Invalid Date';
	var TO_STRING = 'toString';
	var $toString = DateProto[TO_STRING];
	var getTime = DateProto.getTime;
	if (new Date(NaN) + '' != INVALID_DATE) {
	  __webpack_require__(68)(DateProto, TO_STRING, function toString() {
	    var value = getTime.call(this);
	    // eslint-disable-next-line no-self-compare
	    return value === value ? $toString.call(this) : INVALID_DATE;
	  });
	}


/***/ },
/* 1299 */
/***/ function(module, exports, __webpack_require__) {

	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	var $export = __webpack_require__(11);
	
	$export($export.P, 'Function', { bind: __webpack_require__(536) });


/***/ },
/* 1300 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var isObject = __webpack_require__(36);
	var getPrototypeOf = __webpack_require__(139);
	var HAS_INSTANCE = __webpack_require__(44)('hasInstance');
	var FunctionProto = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(57).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
	  if (typeof this != 'function' || !isObject(O)) return false;
	  if (!isObject(this.prototype)) return O instanceof this;
	  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
	  return false;
	} });


/***/ },
/* 1301 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(57).f;
	var FProto = Function.prototype;
	var nameRE = /^\s*function ([^ (]*)/;
	var NAME = 'name';
	
	// 19.2.4.2 name
	NAME in FProto || __webpack_require__(56) && dP(FProto, NAME, {
	  configurable: true,
	  get: function () {
	    try {
	      return ('' + this).match(nameRE)[1];
	    } catch (e) {
	      return '';
	    }
	  }
	});


/***/ },
/* 1302 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(537);
	var validate = __webpack_require__(144);
	var MAP = 'Map';
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(246)(MAP, function (get) {
	  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key) {
	    var entry = strong.getEntry(validate(this, MAP), key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value) {
	    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
	  }
	}, strong, true);


/***/ },
/* 1303 */
[2670, 11, 547],
/* 1304 */
[2671, 11, 137],
/* 1305 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(11);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(56), 'Object', { defineProperties: __webpack_require__(548) });


/***/ },
/* 1306 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(11);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(56), 'Object', { defineProperty: __webpack_require__(57).f });


/***/ },
/* 1307 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(36);
	var meta = __webpack_require__(117).onFreeze;
	
	__webpack_require__(93)('freeze', function ($freeze) {
	  return function freeze(it) {
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});


/***/ },
/* 1308 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(79);
	var $getOwnPropertyDescriptor = __webpack_require__(92).f;
	
	__webpack_require__(93)('getOwnPropertyDescriptor', function () {
	  return function getOwnPropertyDescriptor(it, key) {
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});


/***/ },
/* 1309 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(93)('getOwnPropertyNames', function () {
	  return __webpack_require__(549).f;
	});


/***/ },
/* 1310 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(65);
	var $getPrototypeOf = __webpack_require__(139);
	
	__webpack_require__(93)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ },
/* 1311 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(36);
	
	__webpack_require__(93)('isExtensible', function ($isExtensible) {
	  return function isExtensible(it) {
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});


/***/ },
/* 1312 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(36);
	
	__webpack_require__(93)('isFrozen', function ($isFrozen) {
	  return function isFrozen(it) {
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});


/***/ },
/* 1313 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(36);
	
	__webpack_require__(93)('isSealed', function ($isSealed) {
	  return function isSealed(it) {
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});


/***/ },
/* 1314 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(11);
	$export($export.S, 'Object', { is: __webpack_require__(556) });


/***/ },
/* 1315 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(65);
	var $keys = __webpack_require__(140);
	
	__webpack_require__(93)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ },
/* 1316 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(36);
	var meta = __webpack_require__(117).onFreeze;
	
	__webpack_require__(93)('preventExtensions', function ($preventExtensions) {
	  return function preventExtensions(it) {
	    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
	  };
	});


/***/ },
/* 1317 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(36);
	var meta = __webpack_require__(117).onFreeze;
	
	__webpack_require__(93)('seal', function ($seal) {
	  return function seal(it) {
	    return $seal && isObject(it) ? $seal(meta(it)) : it;
	  };
	});


/***/ },
/* 1318 */
[2672, 11, 366],
/* 1319 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(201);
	var test = {};
	test[__webpack_require__(44)('toStringTag')] = 'z';
	if (test + '' != '[object z]') {
	  __webpack_require__(68)(Object.prototype, 'toString', function toString() {
	    return '[object ' + classof(this) + ']';
	  }, true);
	}


/***/ },
/* 1320 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(11);
	var $parseFloat = __webpack_require__(553);
	// 18.2.4 parseFloat(string)
	$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ },
/* 1321 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(11);
	var $parseInt = __webpack_require__(554);
	// 18.2.5 parseInt(string, radix)
	$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ },
/* 1322 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	var $export = __webpack_require__(11);
	var aFunction = __webpack_require__(89);
	var anObject = __webpack_require__(33);
	var rApply = (__webpack_require__(35).Reflect || {}).apply;
	var fApply = Function.apply;
	// MS Edge argumentsList argument is optional
	$export($export.S + $export.F * !__webpack_require__(34)(function () {
	  rApply(function () { /* empty */ });
	}), 'Reflect', {
	  apply: function apply(target, thisArgument, argumentsList) {
	    var T = aFunction(target);
	    var L = anObject(argumentsList);
	    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
	  }
	});


/***/ },
/* 1323 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	var $export = __webpack_require__(11);
	var create = __webpack_require__(137);
	var aFunction = __webpack_require__(89);
	var anObject = __webpack_require__(33);
	var isObject = __webpack_require__(36);
	var fails = __webpack_require__(34);
	var bind = __webpack_require__(536);
	var rConstruct = (__webpack_require__(35).Reflect || {}).construct;
	
	// MS Edge supports only 2 arguments and argumentsList argument is optional
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	var NEW_TARGET_BUG = fails(function () {
	  function F() { /* empty */ }
	  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
	});
	var ARGS_BUG = !fails(function () {
	  rConstruct(function () { /* empty */ });
	});
	
	$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
	  construct: function construct(Target, args /* , newTarget */) {
	    aFunction(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
	    if (Target == newTarget) {
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch (args.length) {
	        case 0: return new Target();
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      $args.push.apply($args, args);
	      return new (bind.apply(Target, $args))();
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto = newTarget.prototype;
	    var instance = create(isObject(proto) ? proto : Object.prototype);
	    var result = Function.apply.call(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});


/***/ },
/* 1324 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	var dP = __webpack_require__(57);
	var $export = __webpack_require__(11);
	var anObject = __webpack_require__(33);
	var toPrimitive = __webpack_require__(118);
	
	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	$export($export.S + $export.F * __webpack_require__(34)(function () {
	  // eslint-disable-next-line no-undef
	  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
	}), 'Reflect', {
	  defineProperty: function defineProperty(target, propertyKey, attributes) {
	    anObject(target);
	    propertyKey = toPrimitive(propertyKey, true);
	    anObject(attributes);
	    try {
	      dP.f(target, propertyKey, attributes);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ },
/* 1325 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export = __webpack_require__(11);
	var gOPD = __webpack_require__(92).f;
	var anObject = __webpack_require__(33);
	
	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey) {
	    var desc = gOPD(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});


/***/ },
/* 1326 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 26.1.5 Reflect.enumerate(target)
	var $export = __webpack_require__(11);
	var anObject = __webpack_require__(33);
	var Enumerate = function (iterated) {
	  this._t = anObject(iterated); // target
	  this._i = 0;                  // next index
	  var keys = this._k = [];      // keys
	  var key;
	  for (key in iterated) keys.push(key);
	};
	__webpack_require__(543)(Enumerate, 'Object', function () {
	  var that = this;
	  var keys = that._k;
	  var key;
	  do {
	    if (that._i >= keys.length) return { value: undefined, done: true };
	  } while (!((key = keys[that._i++]) in that._t));
	  return { value: key, done: false };
	});
	
	$export($export.S, 'Reflect', {
	  enumerate: function enumerate(target) {
	    return new Enumerate(target);
	  }
	});


/***/ },
/* 1327 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	var gOPD = __webpack_require__(92);
	var $export = __webpack_require__(11);
	var anObject = __webpack_require__(33);
	
	$export($export.S, 'Reflect', {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
	    return gOPD.f(anObject(target), propertyKey);
	  }
	});


/***/ },
/* 1328 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.8 Reflect.getPrototypeOf(target)
	var $export = __webpack_require__(11);
	var getProto = __webpack_require__(139);
	var anObject = __webpack_require__(33);
	
	$export($export.S, 'Reflect', {
	  getPrototypeOf: function getPrototypeOf(target) {
	    return getProto(anObject(target));
	  }
	});


/***/ },
/* 1329 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.6 Reflect.get(target, propertyKey [, receiver])
	var gOPD = __webpack_require__(92);
	var getPrototypeOf = __webpack_require__(139);
	var has = __webpack_require__(77);
	var $export = __webpack_require__(11);
	var isObject = __webpack_require__(36);
	var anObject = __webpack_require__(33);
	
	function get(target, propertyKey /* , receiver */) {
	  var receiver = arguments.length < 3 ? target : arguments[2];
	  var desc, proto;
	  if (anObject(target) === receiver) return target[propertyKey];
	  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
	    ? desc.value
	    : desc.get !== undefined
	      ? desc.get.call(receiver)
	      : undefined;
	  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
	}
	
	$export($export.S, 'Reflect', { get: get });


/***/ },
/* 1330 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.9 Reflect.has(target, propertyKey)
	var $export = __webpack_require__(11);
	
	$export($export.S, 'Reflect', {
	  has: function has(target, propertyKey) {
	    return propertyKey in target;
	  }
	});


/***/ },
/* 1331 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.10 Reflect.isExtensible(target)
	var $export = __webpack_require__(11);
	var anObject = __webpack_require__(33);
	var $isExtensible = Object.isExtensible;
	
	$export($export.S, 'Reflect', {
	  isExtensible: function isExtensible(target) {
	    anObject(target);
	    return $isExtensible ? $isExtensible(target) : true;
	  }
	});


/***/ },
/* 1332 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__(11);
	
	$export($export.S, 'Reflect', { ownKeys: __webpack_require__(552) });


/***/ },
/* 1333 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.12 Reflect.preventExtensions(target)
	var $export = __webpack_require__(11);
	var anObject = __webpack_require__(33);
	var $preventExtensions = Object.preventExtensions;
	
	$export($export.S, 'Reflect', {
	  preventExtensions: function preventExtensions(target) {
	    anObject(target);
	    try {
	      if ($preventExtensions) $preventExtensions(target);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ },
/* 1334 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	var $export = __webpack_require__(11);
	var setProto = __webpack_require__(366);
	
	if (setProto) $export($export.S, 'Reflect', {
	  setPrototypeOf: function setPrototypeOf(target, proto) {
	    setProto.check(target, proto);
	    try {
	      setProto.set(target, proto);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ },
/* 1335 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	var dP = __webpack_require__(57);
	var gOPD = __webpack_require__(92);
	var getPrototypeOf = __webpack_require__(139);
	var has = __webpack_require__(77);
	var $export = __webpack_require__(11);
	var createDesc = __webpack_require__(141);
	var anObject = __webpack_require__(33);
	var isObject = __webpack_require__(36);
	
	function set(target, propertyKey, V /* , receiver */) {
	  var receiver = arguments.length < 4 ? target : arguments[3];
	  var ownDesc = gOPD.f(anObject(target), propertyKey);
	  var existingDescriptor, proto;
	  if (!ownDesc) {
	    if (isObject(proto = getPrototypeOf(target))) {
	      return set(proto, propertyKey, V, receiver);
	    }
	    ownDesc = createDesc(0);
	  }
	  if (has(ownDesc, 'value')) {
	    if (ownDesc.writable === false || !isObject(receiver)) return false;
	    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
	      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
	      existingDescriptor.value = V;
	      dP.f(receiver, propertyKey, existingDescriptor);
	    } else dP.f(receiver, propertyKey, createDesc(0, V));
	    return true;
	  }
	  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	}
	
	$export($export.S, 'Reflect', { set: set });


/***/ },
/* 1336 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(35);
	var inheritIfRequired = __webpack_require__(359);
	var dP = __webpack_require__(57).f;
	var gOPN = __webpack_require__(138).f;
	var isRegExp = __webpack_require__(361);
	var $flags = __webpack_require__(248);
	var $RegExp = global.RegExp;
	var Base = $RegExp;
	var proto = $RegExp.prototype;
	var re1 = /a/g;
	var re2 = /a/g;
	// "new" creates a new object, old webkit buggy here
	var CORRECT_NEW = new $RegExp(re1) !== re1;
	
	if (__webpack_require__(56) && (!CORRECT_NEW || __webpack_require__(34)(function () {
	  re2[__webpack_require__(44)('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))) {
	  $RegExp = function RegExp(p, f) {
	    var tiRE = this instanceof $RegExp;
	    var piRE = isRegExp(p);
	    var fiU = f === undefined;
	    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
	      : inheritIfRequired(CORRECT_NEW
	        ? new Base(piRE && !fiU ? p.source : p, f)
	        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
	      , tiRE ? this : proto, $RegExp);
	  };
	  var proxy = function (key) {
	    key in $RegExp || dP($RegExp, key, {
	      configurable: true,
	      get: function () { return Base[key]; },
	      set: function (it) { Base[key] = it; }
	    });
	  };
	  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
	  proto.constructor = $RegExp;
	  $RegExp.prototype = proto;
	  __webpack_require__(68)(global, 'RegExp', $RegExp);
	}
	
	__webpack_require__(164)('RegExp');


/***/ },
/* 1337 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(33);
	var toLength = __webpack_require__(47);
	var advanceStringIndex = __webpack_require__(352);
	var regExpExec = __webpack_require__(253);
	
	// @@match logic
	__webpack_require__(247)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
	  return [
	    // `String.prototype.match` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.match
	    function match(regexp) {
	      var O = defined(this);
	      var fn = regexp == undefined ? undefined : regexp[MATCH];
	      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	    },
	    // `RegExp.prototype[@@match]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
	    function (regexp) {
	      var res = maybeCallNative($match, regexp, this);
	      if (res.done) return res.value;
	      var rx = anObject(regexp);
	      var S = String(this);
	      if (!rx.global) return regExpExec(rx, S);
	      var fullUnicode = rx.unicode;
	      rx.lastIndex = 0;
	      var A = [];
	      var n = 0;
	      var result;
	      while ((result = regExpExec(rx, S)) !== null) {
	        var matchStr = String(result[0]);
	        A[n] = matchStr;
	        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	        n++;
	      }
	      return n === 0 ? null : A;
	    }
	  ];
	});


/***/ },
/* 1338 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(33);
	var toObject = __webpack_require__(65);
	var toLength = __webpack_require__(47);
	var toInteger = __webpack_require__(94);
	var advanceStringIndex = __webpack_require__(352);
	var regExpExec = __webpack_require__(253);
	var max = Math.max;
	var min = Math.min;
	var floor = Math.floor;
	var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
	var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;
	
	var maybeToString = function (it) {
	  return it === undefined ? it : String(it);
	};
	
	// @@replace logic
	__webpack_require__(247)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
	  return [
	    // `String.prototype.replace` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
	    function replace(searchValue, replaceValue) {
	      var O = defined(this);
	      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	      return fn !== undefined
	        ? fn.call(searchValue, O, replaceValue)
	        : $replace.call(String(O), searchValue, replaceValue);
	    },
	    // `RegExp.prototype[@@replace]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
	    function (regexp, replaceValue) {
	      var res = maybeCallNative($replace, regexp, this, replaceValue);
	      if (res.done) return res.value;
	
	      var rx = anObject(regexp);
	      var S = String(this);
	      var functionalReplace = typeof replaceValue === 'function';
	      if (!functionalReplace) replaceValue = String(replaceValue);
	      var global = rx.global;
	      if (global) {
	        var fullUnicode = rx.unicode;
	        rx.lastIndex = 0;
	      }
	      var results = [];
	      while (true) {
	        var result = regExpExec(rx, S);
	        if (result === null) break;
	        results.push(result);
	        if (!global) break;
	        var matchStr = String(result[0]);
	        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	      }
	      var accumulatedResult = '';
	      var nextSourcePosition = 0;
	      for (var i = 0; i < results.length; i++) {
	        result = results[i];
	        var matched = String(result[0]);
	        var position = max(min(toInteger(result.index), S.length), 0);
	        var captures = [];
	        // NOTE: This is equivalent to
	        //   captures = result.slice(1).map(maybeToString)
	        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
	        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
	        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
	        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
	        var namedCaptures = result.groups;
	        if (functionalReplace) {
	          var replacerArgs = [matched].concat(captures, position, S);
	          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
	          var replacement = String(replaceValue.apply(undefined, replacerArgs));
	        } else {
	          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
	        }
	        if (position >= nextSourcePosition) {
	          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
	          nextSourcePosition = position + matched.length;
	        }
	      }
	      return accumulatedResult + S.slice(nextSourcePosition);
	    }
	  ];
	
	    // https://tc39.github.io/ecma262/#sec-getsubstitution
	  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
	    var tailPos = position + matched.length;
	    var m = captures.length;
	    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
	    if (namedCaptures !== undefined) {
	      namedCaptures = toObject(namedCaptures);
	      symbols = SUBSTITUTION_SYMBOLS;
	    }
	    return $replace.call(replacement, symbols, function (match, ch) {
	      var capture;
	      switch (ch.charAt(0)) {
	        case '$': return '$';
	        case '&': return matched;
	        case '`': return str.slice(0, position);
	        case "'": return str.slice(tailPos);
	        case '<':
	          capture = namedCaptures[ch.slice(1, -1)];
	          break;
	        default: // \d\d?
	          var n = +ch;
	          if (n === 0) return match;
	          if (n > m) {
	            var f = floor(n / 10);
	            if (f === 0) return match;
	            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
	            return match;
	          }
	          capture = captures[n - 1];
	      }
	      return capture === undefined ? '' : capture;
	    });
	  }
	});


/***/ },
/* 1339 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(33);
	var sameValue = __webpack_require__(556);
	var regExpExec = __webpack_require__(253);
	
	// @@search logic
	__webpack_require__(247)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
	  return [
	    // `String.prototype.search` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.search
	    function search(regexp) {
	      var O = defined(this);
	      var fn = regexp == undefined ? undefined : regexp[SEARCH];
	      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	    },
	    // `RegExp.prototype[@@search]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
	    function (regexp) {
	      var res = maybeCallNative($search, regexp, this);
	      if (res.done) return res.value;
	      var rx = anObject(regexp);
	      var S = String(this);
	      var previousLastIndex = rx.lastIndex;
	      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
	      var result = regExpExec(rx, S);
	      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
	      return result === null ? -1 : result.index;
	    }
	  ];
	});


/***/ },
/* 1340 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isRegExp = __webpack_require__(361);
	var anObject = __webpack_require__(33);
	var speciesConstructor = __webpack_require__(204);
	var advanceStringIndex = __webpack_require__(352);
	var toLength = __webpack_require__(47);
	var callRegExpExec = __webpack_require__(253);
	var regexpExec = __webpack_require__(365);
	var fails = __webpack_require__(34);
	var $min = Math.min;
	var $push = [].push;
	var $SPLIT = 'split';
	var LENGTH = 'length';
	var LAST_INDEX = 'lastIndex';
	var MAX_UINT32 = 0xffffffff;
	
	// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
	var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });
	
	// @@split logic
	__webpack_require__(247)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
	  var internalSplit;
	  if (
	    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
	    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
	    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
	    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
	    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
	    ''[$SPLIT](/.?/)[LENGTH]
	  ) {
	    // based on es5-shim implementation, need to rework it
	    internalSplit = function (separator, limit) {
	      var string = String(this);
	      if (separator === undefined && limit === 0) return [];
	      // If `separator` is not a regex, use native split
	      if (!isRegExp(separator)) return $split.call(string, separator, limit);
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') +
	                  (separator.multiline ? 'm' : '') +
	                  (separator.unicode ? 'u' : '') +
	                  (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var match, lastIndex, lastLength;
	      while (match = regexpExec.call(separatorCopy, string)) {
	        lastIndex = separatorCopy[LAST_INDEX];
	        if (lastIndex > lastLastIndex) {
	          output.push(string.slice(lastLastIndex, match.index));
	          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
	          lastLength = match[0][LENGTH];
	          lastLastIndex = lastIndex;
	          if (output[LENGTH] >= splitLimit) break;
	        }
	        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
	      }
	      if (lastLastIndex === string[LENGTH]) {
	        if (lastLength || !separatorCopy.test('')) output.push('');
	      } else output.push(string.slice(lastLastIndex));
	      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
	    };
	  // Chakra, V8
	  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
	    internalSplit = function (separator, limit) {
	      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
	    };
	  } else {
	    internalSplit = $split;
	  }
	
	  return [
	    // `String.prototype.split` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.split
	    function split(separator, limit) {
	      var O = defined(this);
	      var splitter = separator == undefined ? undefined : separator[SPLIT];
	      return splitter !== undefined
	        ? splitter.call(separator, O, limit)
	        : internalSplit.call(String(O), separator, limit);
	    },
	    // `RegExp.prototype[@@split]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
	    //
	    // NOTE: This cannot be properly polyfilled in engines that don't support
	    // the 'y' flag.
	    function (regexp, limit) {
	      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
	      if (res.done) return res.value;
	
	      var rx = anObject(regexp);
	      var S = String(this);
	      var C = speciesConstructor(rx, RegExp);
	
	      var unicodeMatching = rx.unicode;
	      var flags = (rx.ignoreCase ? 'i' : '') +
	                  (rx.multiline ? 'm' : '') +
	                  (rx.unicode ? 'u' : '') +
	                  (SUPPORTS_Y ? 'y' : 'g');
	
	      // ^(? + rx + ) is needed, in combination with some S slicing, to
	      // simulate the 'y' flag.
	      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
	      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      if (lim === 0) return [];
	      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
	      var p = 0;
	      var q = 0;
	      var A = [];
	      while (q < S.length) {
	        splitter.lastIndex = SUPPORTS_Y ? q : 0;
	        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
	        var e;
	        if (
	          z === null ||
	          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
	        ) {
	          q = advanceStringIndex(S, q, unicodeMatching);
	        } else {
	          A.push(S.slice(p, q));
	          if (A.length === lim) return A;
	          for (var i = 1; i <= z.length - 1; i++) {
	            A.push(z[i]);
	            if (A.length === lim) return A;
	          }
	          q = p = e;
	        }
	      }
	      A.push(S.slice(p));
	      return A;
	    }
	  ];
	});


/***/ },
/* 1341 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(591);
	var anObject = __webpack_require__(33);
	var $flags = __webpack_require__(248);
	var DESCRIPTORS = __webpack_require__(56);
	var TO_STRING = 'toString';
	var $toString = /./[TO_STRING];
	
	var define = function (fn) {
	  __webpack_require__(68)(RegExp.prototype, TO_STRING, fn, true);
	};
	
	// 21.2.5.14 RegExp.prototype.toString()
	if (__webpack_require__(34)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
	  define(function toString() {
	    var R = anObject(this);
	    return '/'.concat(R.source, '/',
	      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
	  });
	// FF44- RegExp#toString has a wrong name
	} else if ($toString.name != TO_STRING) {
	  define(function toString() {
	    return $toString.call(this);
	  });
	}


/***/ },
/* 1342 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(537);
	var validate = __webpack_require__(144);
	var SET = 'Set';
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(246)(SET, function (get) {
	  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value) {
	    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
	  }
	}, strong);


/***/ },
/* 1343 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.2 String.prototype.anchor(name)
	__webpack_require__(69)('anchor', function (createHTML) {
	  return function anchor(name) {
	    return createHTML(this, 'a', 'name', name);
	  };
	});


/***/ },
/* 1344 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.3 String.prototype.big()
	__webpack_require__(69)('big', function (createHTML) {
	  return function big() {
	    return createHTML(this, 'big', '', '');
	  };
	});


/***/ },
/* 1345 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.4 String.prototype.blink()
	__webpack_require__(69)('blink', function (createHTML) {
	  return function blink() {
	    return createHTML(this, 'blink', '', '');
	  };
	});


/***/ },
/* 1346 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.5 String.prototype.bold()
	__webpack_require__(69)('bold', function (createHTML) {
	  return function bold() {
	    return createHTML(this, 'b', '', '');
	  };
	});


/***/ },
/* 1347 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(11);
	var $at = __webpack_require__(368)(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos) {
	    return $at(this, pos);
	  }
	});


/***/ },
/* 1348 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	'use strict';
	var $export = __webpack_require__(11);
	var toLength = __webpack_require__(47);
	var context = __webpack_require__(369);
	var ENDS_WITH = 'endsWith';
	var $endsWith = ''[ENDS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(357)(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /* , endPosition = @length */) {
	    var that = context(this, searchString, ENDS_WITH);
	    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
	    var len = toLength(that.length);
	    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
	    var search = String(searchString);
	    return $endsWith
	      ? $endsWith.call(that, search, end)
	      : that.slice(end - search.length, end) === search;
	  }
	});


/***/ },
/* 1349 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.6 String.prototype.fixed()
	__webpack_require__(69)('fixed', function (createHTML) {
	  return function fixed() {
	    return createHTML(this, 'tt', '', '');
	  };
	});


/***/ },
/* 1350 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.7 String.prototype.fontcolor(color)
	__webpack_require__(69)('fontcolor', function (createHTML) {
	  return function fontcolor(color) {
	    return createHTML(this, 'font', 'color', color);
	  };
	});


/***/ },
/* 1351 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.8 String.prototype.fontsize(size)
	__webpack_require__(69)('fontsize', function (createHTML) {
	  return function fontsize(size) {
	    return createHTML(this, 'font', 'size', size);
	  };
	});


/***/ },
/* 1352 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(11);
	var toAbsoluteIndex = __webpack_require__(142);
	var fromCharCode = String.fromCharCode;
	var $fromCodePoint = String.fromCodePoint;
	
	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
	    var res = [];
	    var aLen = arguments.length;
	    var i = 0;
	    var code;
	    while (aLen > i) {
	      code = +arguments[i++];
	      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});


/***/ },
/* 1353 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	var $export = __webpack_require__(11);
	var context = __webpack_require__(369);
	var INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__(357)(INCLUDES), 'String', {
	  includes: function includes(searchString /* , position = 0 */) {
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ },
/* 1354 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.9 String.prototype.italics()
	__webpack_require__(69)('italics', function (createHTML) {
	  return function italics() {
	    return createHTML(this, 'i', '', '');
	  };
	});


/***/ },
/* 1355 */
[2673, 368, 362],
/* 1356 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.10 String.prototype.link(url)
	__webpack_require__(69)('link', function (createHTML) {
	  return function link(url) {
	    return createHTML(this, 'a', 'href', url);
	  };
	});


/***/ },
/* 1357 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(11);
	var toIObject = __webpack_require__(79);
	var toLength = __webpack_require__(47);
	
	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite) {
	    var tpl = toIObject(callSite.raw);
	    var len = toLength(tpl.length);
	    var aLen = arguments.length;
	    var res = [];
	    var i = 0;
	    while (len > i) {
	      res.push(String(tpl[i++]));
	      if (i < aLen) res.push(String(arguments[i]));
	    } return res.join('');
	  }
	});


/***/ },
/* 1358 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(11);
	
	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(370)
	});


/***/ },
/* 1359 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.11 String.prototype.small()
	__webpack_require__(69)('small', function (createHTML) {
	  return function small() {
	    return createHTML(this, 'small', '', '');
	  };
	});


/***/ },
/* 1360 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	var $export = __webpack_require__(11);
	var toLength = __webpack_require__(47);
	var context = __webpack_require__(369);
	var STARTS_WITH = 'startsWith';
	var $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(357)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /* , position = 0 */) {
	    var that = context(this, searchString, STARTS_WITH);
	    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
	    var search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});


/***/ },
/* 1361 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.12 String.prototype.strike()
	__webpack_require__(69)('strike', function (createHTML) {
	  return function strike() {
	    return createHTML(this, 'strike', '', '');
	  };
	});


/***/ },
/* 1362 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.13 String.prototype.sub()
	__webpack_require__(69)('sub', function (createHTML) {
	  return function sub() {
	    return createHTML(this, 'sub', '', '');
	  };
	});


/***/ },
/* 1363 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.14 String.prototype.sup()
	__webpack_require__(69)('sup', function (createHTML) {
	  return function sup() {
	    return createHTML(this, 'sup', '', '');
	  };
	});


/***/ },
/* 1364 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 21.1.3.25 String.prototype.trim()
	__webpack_require__(166)('trim', function ($trim) {
	  return function trim() {
	    return $trim(this, 3);
	  };
	});


/***/ },
/* 1365 */
[2674, 35, 77, 56, 11, 68, 117, 34, 254, 165, 143, 44, 374, 559, 1268, 250, 33, 36, 65, 79, 118, 141, 137, 549, 92, 252, 57, 140, 138, 203, 136, 78],
/* 1366 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(11);
	var $typed = __webpack_require__(255);
	var buffer = __webpack_require__(373);
	var anObject = __webpack_require__(33);
	var toAbsoluteIndex = __webpack_require__(142);
	var toLength = __webpack_require__(47);
	var isObject = __webpack_require__(36);
	var ArrayBuffer = __webpack_require__(35).ArrayBuffer;
	var speciesConstructor = __webpack_require__(204);
	var $ArrayBuffer = buffer.ArrayBuffer;
	var $DataView = buffer.DataView;
	var $isView = $typed.ABV && ArrayBuffer.isView;
	var $slice = $ArrayBuffer.prototype.slice;
	var VIEW = $typed.VIEW;
	var ARRAY_BUFFER = 'ArrayBuffer';
	
	$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });
	
	$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
	  // 24.1.3.1 ArrayBuffer.isView(arg)
	  isView: function isView(it) {
	    return $isView && $isView(it) || isObject(it) && VIEW in it;
	  }
	});
	
	$export($export.P + $export.U + $export.F * __webpack_require__(34)(function () {
	  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
	}), ARRAY_BUFFER, {
	  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
	  slice: function slice(start, end) {
	    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
	    var len = anObject(this).byteLength;
	    var first = toAbsoluteIndex(start, len);
	    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
	    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
	    var viewS = new $DataView(this);
	    var viewT = new $DataView(result);
	    var index = 0;
	    while (first < fin) {
	      viewT.setUint8(index++, viewS.getUint8(first++));
	    } return result;
	  }
	});
	
	__webpack_require__(164)(ARRAY_BUFFER);


/***/ },
/* 1367 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(11);
	$export($export.G + $export.W + $export.F * !__webpack_require__(255).ABV, {
	  DataView: __webpack_require__(373).DataView
	});


/***/ },
/* 1368 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(106)('Float32', 4, function (init) {
	  return function Float32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 1369 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(106)('Float64', 8, function (init) {
	  return function Float64Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 1370 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(106)('Int16', 2, function (init) {
	  return function Int16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 1371 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(106)('Int32', 4, function (init) {
	  return function Int32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 1372 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(106)('Int8', 1, function (init) {
	  return function Int8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 1373 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(106)('Uint16', 2, function (init) {
	  return function Uint16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 1374 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(106)('Uint32', 4, function (init) {
	  return function Uint32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 1375 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(106)('Uint8', 1, function (init) {
	  return function Uint8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 1376 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(106)('Uint8', 1, function (init) {
	  return function Uint8ClampedArray(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	}, true);


/***/ },
/* 1377 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(35);
	var each = __webpack_require__(90)(0);
	var redefine = __webpack_require__(68);
	var meta = __webpack_require__(117);
	var assign = __webpack_require__(547);
	var weak = __webpack_require__(538);
	var isObject = __webpack_require__(36);
	var validate = __webpack_require__(144);
	var NATIVE_WEAK_MAP = __webpack_require__(144);
	var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
	var WEAK_MAP = 'WeakMap';
	var getWeak = meta.getWeak;
	var isExtensible = Object.isExtensible;
	var uncaughtFrozenStore = weak.ufstore;
	var InternalMap;
	
	var wrapper = function (get) {
	  return function WeakMap() {
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key) {
	    if (isObject(key)) {
	      var data = getWeak(key);
	      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value) {
	    return weak.def(validate(this, WEAK_MAP), key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(246)(WEAK_MAP, wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if (NATIVE_WEAK_MAP && IS_IE11) {
	  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function (key) {
	    var proto = $WeakMap.prototype;
	    var method = proto[key];
	    redefine(proto, key, function (a, b) {
	      // store frozen objects on internal weakmap shim
	      if (isObject(a) && !isExtensible(a)) {
	        if (!this._f) this._f = new InternalMap();
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}


/***/ },
/* 1378 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var weak = __webpack_require__(538);
	var validate = __webpack_require__(144);
	var WEAK_SET = 'WeakSet';
	
	// 23.4 WeakSet Objects
	__webpack_require__(246)(WEAK_SET, function (get) {
	  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value) {
	    return weak.def(validate(this, WEAK_SET), value, true);
	  }
	}, weak, false, true);


/***/ },
/* 1379 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
	var $export = __webpack_require__(11);
	var flattenIntoArray = __webpack_require__(1269);
	var toObject = __webpack_require__(65);
	var toLength = __webpack_require__(47);
	var aFunction = __webpack_require__(89);
	var arraySpeciesCreate = __webpack_require__(535);
	
	$export($export.P, 'Array', {
	  flatMap: function flatMap(callbackfn /* , thisArg */) {
	    var O = toObject(this);
	    var sourceLen, A;
	    aFunction(callbackfn);
	    sourceLen = toLength(O.length);
	    A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
	    return A;
	  }
	});
	
	__webpack_require__(135)('flatMap');


/***/ },
/* 1380 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/Array.prototype.includes
	var $export = __webpack_require__(11);
	var $includes = __webpack_require__(245)(true);
	
	$export($export.P, 'Array', {
	  includes: function includes(el /* , fromIndex = 0 */) {
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(135)('includes');


/***/ },
/* 1381 */
[2675, 11, 551],
/* 1382 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-getownpropertydescriptors
	var $export = __webpack_require__(11);
	var ownKeys = __webpack_require__(552);
	var toIObject = __webpack_require__(79);
	var gOPD = __webpack_require__(92);
	var createProperty = __webpack_require__(354);
	
	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
	    var O = toIObject(object);
	    var getDesc = gOPD.f;
	    var keys = ownKeys(O);
	    var result = {};
	    var i = 0;
	    var key, desc;
	    while (keys.length > i) {
	      desc = getDesc(O, key = keys[i++]);
	      if (desc !== undefined) createProperty(result, key, desc);
	    }
	    return result;
	  }
	});


/***/ },
/* 1383 */
[2676, 11, 551],
/* 1384 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(11);
	var core = __webpack_require__(46);
	var global = __webpack_require__(35);
	var speciesConstructor = __webpack_require__(204);
	var promiseResolve = __webpack_require__(555);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ },
/* 1385 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(11);
	var $pad = __webpack_require__(557);
	var userAgent = __webpack_require__(256);
	
	// https://github.com/zloirock/core-js/issues/280
	var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);
	
	$export($export.P + $export.F * WEBKIT_BUG, 'String', {
	  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	  }
	});


/***/ },
/* 1386 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(11);
	var $pad = __webpack_require__(557);
	var userAgent = __webpack_require__(256);
	
	// https://github.com/zloirock/core-js/issues/280
	var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);
	
	$export($export.P + $export.F * WEBKIT_BUG, 'String', {
	  padStart: function padStart(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	  }
	});


/***/ },
/* 1387 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(166)('trimLeft', function ($trim) {
	  return function trimLeft() {
	    return $trim(this, 1);
	  };
	}, 'trimStart');


/***/ },
/* 1388 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(166)('trimRight', function ($trim) {
	  return function trimRight() {
	    return $trim(this, 2);
	  };
	}, 'trimEnd');


/***/ },
/* 1389 */
[2677, 559],
/* 1390 */
/***/ function(module, exports, __webpack_require__) {

	var $iterators = __webpack_require__(376);
	var getKeys = __webpack_require__(140);
	var redefine = __webpack_require__(68);
	var global = __webpack_require__(35);
	var hide = __webpack_require__(78);
	var Iterators = __webpack_require__(162);
	var wks = __webpack_require__(44);
	var ITERATOR = wks('iterator');
	var TO_STRING_TAG = wks('toStringTag');
	var ArrayValues = Iterators.Array;
	
	var DOMIterables = {
	  CSSRuleList: true, // TODO: Not spec compliant, should be false.
	  CSSStyleDeclaration: false,
	  CSSValueList: false,
	  ClientRectList: false,
	  DOMRectList: false,
	  DOMStringList: false,
	  DOMTokenList: true,
	  DataTransferItemList: false,
	  FileList: false,
	  HTMLAllCollection: false,
	  HTMLCollection: false,
	  HTMLFormElement: false,
	  HTMLSelectElement: false,
	  MediaList: true, // TODO: Not spec compliant, should be false.
	  MimeTypeArray: false,
	  NamedNodeMap: false,
	  NodeList: true,
	  PaintRequestList: false,
	  Plugin: false,
	  PluginArray: false,
	  SVGLengthList: false,
	  SVGNumberList: false,
	  SVGPathSegList: false,
	  SVGPointList: false,
	  SVGStringList: false,
	  SVGTransformList: false,
	  SourceBufferList: false,
	  StyleSheetList: true, // TODO: Not spec compliant, should be false.
	  TextTrackCueList: false,
	  TextTrackList: false,
	  TouchList: false
	};
	
	for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
	  var NAME = collections[i];
	  var explicit = DOMIterables[NAME];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  var key;
	  if (proto) {
	    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
	    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
	  }
	}


/***/ },
/* 1391 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(11);
	var $task = __webpack_require__(372);
	$export($export.G + $export.B, {
	  setImmediate: $task.set,
	  clearImmediate: $task.clear
	});


/***/ },
/* 1392 */
/***/ function(module, exports, __webpack_require__) {

	// ie9- setTimeout & setInterval additional parameters fix
	var global = __webpack_require__(35);
	var $export = __webpack_require__(11);
	var userAgent = __webpack_require__(256);
	var slice = [].slice;
	var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
	var wrap = function (set) {
	  return function (fn, time /* , ...args */) {
	    var boundArgs = arguments.length > 2;
	    var args = boundArgs ? slice.call(arguments, 2) : false;
	    return set(boundArgs ? function () {
	      // eslint-disable-next-line no-new-func
	      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
	    } : fn, time);
	  };
	};
	$export($export.G + $export.B + $export.F * MSIE, {
	  setTimeout: wrap(global.setTimeout),
	  setInterval: wrap(global.setInterval)
	});


/***/ },
/* 1393 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1392);
	__webpack_require__(1391);
	__webpack_require__(1390);
	module.exports = __webpack_require__(46);


/***/ },
/* 1394 */
/***/ function(module, exports, __webpack_require__) {

	// [NUXIBA]  Version: 2022.1.2 - 2023-05-26  
	 !function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.EntryPoint=t():e.EntryPoint=t()}("undefined"!=typeof self?self:this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var i=n[r]={i:r,l:!1,exports:{}};return e[r].call(i.exports,i,i.exports,t),i.l=!0,i.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=0)}([function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0}),t.AgentControllerFactory=void 0;var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),o=n(1),s=n(4),a=n(6);t.AgentControllerFactory=function(){function e(){r(this,e)}return i(e,[{key:"buildClient",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:4,t=!(arguments.length>1&&void 0!==arguments[1])||arguments[1],n=new s.MQWrapper,r=new a.SoftphoneWrapper;return new o.AgentController(n.getMQ(t),r.getSoftphone(e))}}]),e}()},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0}),t.AgentController=void 0;var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),o=n(2),s=null;t.AgentController=function(){function e(t,n){var i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:"AGENT";return r(this,e),s||(o.Logger.Trace("Init AgentController constructor"),this.connectedMQ=!1,this.mqController=t,this.sipController=n,this.timeStamp=0,s=this,this.init_MQ_Settings(),this.init_SIP_Settings(),this.bind_MQ_Callbacks(),o.Logger.setUserType(i)),s}return i(e,[{key:"setUserId",value:function(e){this.sipController.setUserId(e),this.mqController.setUserId(e),o.Logger.setUserId(e)}},{key:"setReconnectInterval",value:function(e){this.mqController.setReconnectInterval(e)}},{key:"setMaxAttemps",value:function(e){this.mqController.setMaxAttemps(e)}},{key:"init_MQ_Settings",value:function(){this.AgentObject={};var e={onDisconnected:function(){},onConnected:function(){},onMessage:function(){o.Logger.Trace("AgentController onMessage not implemented")},mq_username:"",mq_password:"",mq_vhost:"/",mq_server:"",mq_port:"",mq_consumer:"",mq_expiration:"",mq_secureConnection:!1};this.updateConfigurations(e)}},{key:"init_SIP_Settings",value:function(){this.updateConfigurations(this.sipController.SIPParameter)}},{key:"updateConfigurations",value:function(e){var t=this;e&&void 0!==e&&Object.keys(e).forEach(function(n){return t.AgentObject[n]=e[n]})}},{key:"bind_MQ_Callbacks",value:function(){this.mqController.MQParameter.onConnected=function(){s.AgentObject.onConnected()},this.mqController.MQParameter.onDisconnected=function(){s.AgentObject.onDisconnected()},this.mqController.MQParameter.onMessage=function(e){o.Logger.Trace("AgentController onMessage",e.body),s.AgentObject.onMessage(e.body)},this.mqController.MQParameter.onReconnected=function(){s.AgentObject.onReconnected()}}},{key:"UpdateBrokerConfiguration",value:function(){this.mqController.MQParameter.mq_username=this.AgentObject.mq_username,this.mqController.MQParameter.mq_password=this.AgentObject.mq_password,this.mqController.MQParameter.mq_server=this.AgentObject.mq_server,this.mqController.MQParameter.mq_port=this.AgentObject.mq_port,this.mqController.MQParameter.mq_consumer=this.AgentObject.mq_consumer,this.mqController.MQParameter.mq_expiration=this.AgentObject.mq_expiration,this.mqController.MQParameter.mq_secureConnection=this.AgentObject.mq_secureConnection,this.mqController.MQParameter.heartbeat=this.AgentObject.heartbeat,this.mqController.MQParameter.timeoutMqtt=this.AgentObject.timeoutMqtt,this.mqController.MQParameter.keepAliveMqtt=this.AgentObject.keepAliveMqtt}},{key:"UpdateParametersSIP",value:function(){var e=this;this.sipController.SIPParameter&&void 0!==this.sipController.SIPParameter&&Object.keys(this.sipController.SIPParameter).forEach(function(t){return e.sipController.SIPParameter[t]=e.AgentObject[t]})}},{key:"getTimeStamp",value:function(){return this.timeStamp}},{key:"connectToRabbit",value:function(){this.timeStamp=Date.now(),this.UpdateBrokerConfiguration(),this.mqController.connectToRabbit()}},{key:"subscribeTopics",value:function(e){this.mqController.MQParameter.mq_consumer=this.AgentObject.mq_consumer+"|"+this.timeStamp,e="all"===e?e:e+this.timeStamp;var t=[[e,this.mqController.MQParameter.onMessage,this.mqController.MQParameter.mq_consumer]];this.mqController.subscribeTopics(t)}},{key:"unsubscribeTopics",value:function(e){this.mqController.unsubscribeTopics(e+this.timeStamp)}},{key:"sendMessage",value:function(e,t){this.mqController.sendMessage(e,t)}},{key:"disconnectBroker",value:function(){this.mqController.disconnectBroker()}},{key:"conectSip",value:function(e,t){this.UpdateParametersSIP(),this.sipController.conectSip(e,t)}},{key:"reconnectMic",value:function(){this.sipController.reconnectMic()}},{key:"makeCall",value:function(e){this.sipController.makeCall(e)}},{key:"hangUp",value:function(){this.sipController.hangUp()}},{key:"muteCall",value:function(e){this.sipController.mute(e)}},{key:"holdCall",value:function(){this.sipController.hold()}},{key:"volumeSpeaker",value:function(e){this.sipController.volumeSpeaker(e)}},{key:"volumeSpeakerGet",value:function(){return this.sipController.volumeSpeakerGet()}},{key:"volumeMicrophone",value:function(e){this.sipController.volumeMicrophone(e)}},{key:"volumeMicrophoneGet",value:function(){return this.sipController.volumeMicrophoneGet()}},{key:"dtmf",value:function(e){this.sipController.dtmf(e)}}]),e}()},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0}),t.Logger=void 0;var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),o=n(3);o.LoggerInstance.setApplication("AgentController");t.Logger=function(){function e(){r(this,e)}return i(e,null,[{key:"setUserType",value:function(e){o.LoggerInstance.setUsertype(e)}},{key:"setUserId",value:function(e){o.LoggerInstance.setUserId(e)}},{key:"Group",value:function(e){o.LoggerInstance.Group(e)}},{key:"GroupEnd",value:function(){o.LoggerInstance.GroupEnd()}},{key:"Trace",value:function(){for(var e=arguments.length,t=Array(e),n=0;n<e;n++)t[n]=arguments[n];o.LoggerInstance.Trace(["[AgentController] "].concat(t))}},{key:"Debug",value:function(){for(var e=arguments.length,t=Array(e),n=0;n<e;n++)t[n]=arguments[n];o.LoggerInstance.Debug(["[AgentController] "].concat(t))}},{key:"Warning",value:function(){for(var e=arguments.length,t=Array(e),n=0;n<e;n++)t[n]=arguments[n];o.LoggerInstance.Warning(["[AgentController] "].concat(t))}},{key:"Warn",value:function(){for(var e=arguments.length,t=Array(e),n=0;n<e;n++)t[n]=arguments[n];o.LoggerInstance.Warning(["[AgentController] "].concat(t))}},{key:"Info",value:function(){for(var e=arguments.length,t=Array(e),n=0;n<e;n++)t[n]=arguments[n];o.LoggerInstance.Info(["[AgentController] "].concat(t))}},{key:"Error",value:function(){for(var e=arguments.length,t=Array(e),n=0;n<e;n++)t[n]=arguments[n];o.LoggerInstance.Error(["[AgentController] "].concat(t))}}]),e}()},function(e,t,n){!function(t,n){e.exports=n()}("undefined"!=typeof self&&self,function(){return function(e){function t(r){if(n[r])return n[r].exports;var i=n[r]={i:r,l:!1,exports:{}};return e[r].call(i.exports,i,i.exports,t),i.l=!0,i.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=3)}([function(e,t,n){"use strict";function r(e){return"[object Array]"===b.call(e)}function i(e){return"[object ArrayBuffer]"===b.call(e)}function o(e){return"undefined"!=typeof FormData&&e instanceof FormData}function s(e){return"undefined"!=typeof ArrayBuffer&&ArrayBuffer.isView?ArrayBuffer.isView(e):e&&e.buffer&&e.buffer instanceof ArrayBuffer}function a(e){return"string"==typeof e}function c(e){return"number"==typeof e}function u(e){return void 0===e}function l(e){return null!==e&&"object"==typeof e}function h(e){return"[object Date]"===b.call(e)}function d(e){return"[object File]"===b.call(e)}function f(e){return"[object Blob]"===b.call(e)}function p(e){return"[object Function]"===b.call(e)}function g(e){return l(e)&&p(e.pipe)}function m(e){return"undefined"!=typeof URLSearchParams&&e instanceof URLSearchParams}function v(e){return e.replace(/^\s*/,"").replace(/\s*$/,"")}function T(){return("undefined"==typeof navigator||"ReactNative"!==navigator.product)&&("undefined"!=typeof window&&"undefined"!=typeof document)}function y(e,t){if(null!==e&&void 0!==e)if("object"!=typeof e&&(e=[e]),r(e))for(var n=0,i=e.length;n<i;n++)t.call(null,e[n],n,e);else for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&t.call(null,e[o],o,e)}function _(){function e(e,n){"object"==typeof t[n]&&"object"==typeof e?t[n]=_(t[n],e):t[n]=e}for(var t={},n=0,r=arguments.length;n<r;n++)y(arguments[n],e);return t}function S(e,t,n){return y(t,function(t,r){e[r]=n&&"function"==typeof t?E(t,n):t}),e}var E=n(5),C=n(15),b=Object.prototype.toString;e.exports={isArray:r,isArrayBuffer:i,isBuffer:C,isFormData:o,isArrayBufferView:s,isString:a,isNumber:c,isObject:l,isUndefined:u,isDate:h,isFile:d,isBlob:f,isFunction:p,isStream:g,isURLSearchParams:m,isStandardBrowserEnv:T,forEach:y,merge:_,extend:S,trim:v}},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var i=null,o=t.Constants=function e(){r(this,e),i||(i=this)};o._LOGGER_VAR_WINDOW="NuxibaLogger",o._LOGGER_CONFIGURATION_FILE_LOCALE="./logger.json",o._LOGGER_CONFIGURATION_FILE_REMOTE="logger.json",o._LOGGER_CONFIGURATION_FILE_ENCODE="utf8",o._LOGGER_CONFIGURATION_ASSIGNED=!!window[o._LOGGER_VAR_WINDOW],o._LOG_LEVELS={TRACE:{logLevel:0},DEBUG:{logLevel:1},INFO:{logLevel:2},WARN:{logLevel:3},ERROR:{logLevel:4}},o._Log_CONSOLE={TRACE:console.log,DEBUG:console.log,INFO:console.info,WARN:console.warn,ERROR:console.error},o._CONFIGURATIONS={_ENABLE_DEFAULT:!0,_ENABLE_AJAX:!1,_USE_WINDOW_ORIGIN:!0,_SERVER:"http://127.0.0.1",_DOMAIN:"/LoggerWS/api/Logger",_SEVERITY:"INFO",_SEVERITY_CONSOLE:"INFO",_NUMBER_ATTEMP_POST:10,_FILTER_USER_POST:[],_FILTER_APP_POST:[]},o._REST={_POST_METHOD:"POST",_MODE:"cors",_CONTENT_TYPE:"content-type",_APPLICATION_JSON:"application/json"}},function(e,t,n){"use strict";(function(t){function r(e,t){!i.isUndefined(e)&&i.isUndefined(e["Content-Type"])&&(e["Content-Type"]=t)}var i=n(0),o=n(18),s={"Content-Type":"application/x-www-form-urlencoded"},a={adapter:function(){var e;return"undefined"!=typeof XMLHttpRequest?e=n(6):void 0!==t&&(e=n(6)),e}(),transformRequest:[function(e,t){return o(t,"Content-Type"),i.isFormData(e)||i.isArrayBuffer(e)||i.isBuffer(e)||i.isStream(e)||i.isFile(e)||i.isBlob(e)?e:i.isArrayBufferView(e)?e.buffer:i.isURLSearchParams(e)?(r(t,"application/x-www-form-urlencoded;charset=utf-8"),e.toString()):i.isObject(e)?(r(t,"application/json;charset=utf-8"),JSON.stringify(e)):e}],transformResponse:[function(e){if("string"==typeof e)try{e=JSON.parse(e)}catch(e){}return e}],timeout:0,xsrfCookieName:"XSRF-TOKEN",xsrfHeaderName:"X-XSRF-TOKEN",maxContentLength:-1,validateStatus:function(e){return e>=200&&e<300}};a.headers={common:{Accept:"application/json, text/plain, */*"}},i.forEach(["delete","get","head"],function(e){a.headers[e]={}}),i.forEach(["post","put","patch"],function(e){a.headers[e]=i.merge(s)}),e.exports=a}).call(t,n(17))},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0}),t.LoggerInstance=void 0;var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),o=n(12),s=n(1),a=n(11),c="AGENT",u="",l="",h=function(){function e(){r(this,e)}return i(e,null,[{key:"setUsertype",value:function(e){c=e}},{key:"setUserId",value:function(e){u=e}},{key:"getUserId",value:function(){return u}},{key:"setApplication",value:function(e){l=e}},{key:"setLocalLogger",value:function(e){a.LoggerLocal.setEnabled(e)}},{key:"setLocalStorageTime",value:function(e){a.LoggerLocal.setStorageTimeMin(e)}},{key:"getApplication",value:function(){return l}},{key:"SetUseServerWithLocation",value:function(e){window[s.Constants._LOGGER_VAR_WINDOW]._USE_WINDOW_LOCATION=e}},{key:"addUserId",value:function(e){if(u){var t="[UserId:"+u+"]";e.unshift(t)}}},{key:"Group",value:function(e){console.group(e)}},{key:"GroupEnd",value:function(){console.groupEnd()}},{key:"CleanLocalLog",value:function(){a.LoggerLocal.Clean()}},{key:"Trace",value:function(){for(var e=arguments.length,t=Array(e),n=0;n<e;n++)t[n]=arguments[n];o.LoggerDispatcher.Dispatch(c,"Trace",["[UserId:"+u+"]"].concat(t))}},{key:"Debug",value:function(){for(var t=arguments.length,n=Array(t),r=0;r<t;r++)n[r]=arguments[r];e.addUserId(n),o.LoggerDispatcher.Dispatch(c,"Debug",["[UserId:"+u+"]"].concat(n))}},{key:"Warning",value:function(){for(var t=arguments.length,n=Array(t),r=0;r<t;r++)n[r]=arguments[r];e.addUserId(n),o.LoggerDispatcher.Dispatch(c,"Warn",["[UserId:"+u+"]"].concat(n))}},{key:"Warn",value:function(){for(var t=arguments.length,n=Array(t),r=0;r<t;r++)n[r]=arguments[r];e.Warning(n)}},{key:"Info",value:function(){for(var t=arguments.length,n=Array(t),r=0;r<t;r++)n[r]=arguments[r];e.addUserId(n),o.LoggerDispatcher.Dispatch(c,"Info",["[UserId:"+u+"]"].concat(n))}},{key:"Error",value:function(){for(var t=arguments.length,n=Array(t),r=0;r<t;r++)n[r]=arguments[r];e.addUserId(n),o.LoggerDispatcher.Dispatch(c,"Error",["[UserId:"+u+"]"].concat(n))}},{key:"JsWarning",value:function(){for(var t=arguments.length,n=Array(t),r=0;r<t;r++)n[r]=arguments[r];e.addUserId(n),o.LoggerDispatcher.Dispatch(c,"Warn",["[UserId:"+u+"]"].concat(n),!0)}},{key:"JsError",value:function(){for(var t=arguments.length,n=Array(t),r=0;r<t;r++)n[r]=arguments[r];e.addUserId(n),o.LoggerDispatcher.Dispatch(c,"Error",["[UserId:"+u+"]"].concat(n),!0)}},{key:"LevelConsole",get:function(){return window[s.Constants._LOGGER_VAR_WINDOW]._SEVERITY_CONSOLE}}]),e}();t.LoggerInstance=h},function(e,t,n){e.exports=n(14)},function(e,t,n){"use strict";e.exports=function(e,t){return function(){for(var n=new Array(arguments.length),r=0;r<n.length;r++)n[r]=arguments[r];return e.apply(t,n)}}},function(e,t,n){"use strict";var r=n(0),i=n(19),o=n(21),s=n(22),a=n(23),c=n(7);e.exports=function(e){return new Promise(function(t,u){var l=e.data,h=e.headers;r.isFormData(l)&&delete h["Content-Type"];var d=new XMLHttpRequest;if(e.auth){var f=e.auth.username||"",p=e.auth.password||"";h.Authorization="Basic "+btoa(f+":"+p)}if(d.open(e.method.toUpperCase(),o(e.url,e.params,e.paramsSerializer),!0),d.timeout=e.timeout,d.onreadystatechange=function(){if(d&&4===d.readyState&&(0!==d.status||d.responseURL&&0===d.responseURL.indexOf("file:"))){var n="getAllResponseHeaders"in d?s(d.getAllResponseHeaders()):null,r=e.responseType&&"text"!==e.responseType?d.response:d.responseText,o={data:r,status:d.status,statusText:d.statusText,headers:n,config:e,request:d};i(t,u,o),d=null}},d.onerror=function(){u(c("Network Error",e,null,d)),d=null},d.ontimeout=function(){u(c("timeout of "+e.timeout+"ms exceeded",e,"ECONNABORTED",d)),d=null},r.isStandardBrowserEnv()){var g=n(24),m=(e.withCredentials||a(e.url))&&e.xsrfCookieName?g.read(e.xsrfCookieName):void 0;m&&(h[e.xsrfHeaderName]=m)}if("setRequestHeader"in d&&r.forEach(h,function(e,t){void 0===l&&"content-type"===t.toLowerCase()?delete h[t]:d.setRequestHeader(t,e)}),e.withCredentials&&(d.withCredentials=!0),e.responseType)try{d.responseType=e.responseType}catch(t){if("json"!==e.responseType)throw t}"function"==typeof e.onDownloadProgress&&d.addEventListener("progress",e.onDownloadProgress),"function"==typeof e.onUploadProgress&&d.upload&&d.upload.addEventListener("progress",e.onUploadProgress),e.cancelToken&&e.cancelToken.promise.then(function(e){d&&(d.abort(),u(e),d=null)}),void 0===l&&(l=null),d.send(l)})}},function(e,t,n){"use strict";var r=n(20);e.exports=function(e,t,n,i,o){var s=new Error(e);return r(s,t,n,i,o)}},function(e,t,n){"use strict";e.exports=function(e){return!(!e||!e.__CANCEL__)}},function(e,t,n){"use strict";function r(e){this.message=e}r.prototype.toString=function(){return"Cancel"+(this.message?": "+this.message:"")},r.prototype.__CANCEL__=!0,e.exports=r},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0}),t.LoggerUtils=void 0;var i="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},o=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),s=n(1),a=function(){function e(){r(this,e)}return o(e,null,[{key:"GetLogLevelBySeverity",value:function(e){var t=1;return e=e.toUpperCase(),s.Constants._LOG_LEVELS[e]&&(t=s.Constants._LOG_LEVELS[e].logLevel),t}},{key:"IsAllowedRemoteToLogBySeverity",value:function(t){return e.GetLogLevelBySeverity(t)>=e.GetCurrentRemoteSeverityLevelConfigured()}},{key:"GetCurrentRemoteSeverityLevelConfigured",value:function(){return e.GetLogLevelBySeverity(window[s.Constants._LOGGER_VAR_WINDOW]._SEVERITY)}},{key:"IsAllowedConsoleToLogBySeverity",value:function(t){return e.GetLogLevelBySeverity(t)>=e.GetCurrentConsoleSeverityLevelConfigured()}},{key:"GetCurrentConsoleSeverityLevelConfigured",value:function(){return e.GetLogLevelBySeverity(window[s.Constants._LOGGER_VAR_WINDOW]._SEVERITY_CONSOLE)}},{key:"ToStringMessage",value:function(){for(var t="",n=arguments.length,r=Array(n),i=0;i<n;i++)r[i]=arguments[i];return r.forEach(function(n){t+=e.ToStringObject(n)}),t}},{key:"ToStringObject",value:function(t){return e.IsObject(t)?"\n"+e.JsonToString(t):t}},{key:"IsObject",value:function(e){return e&&"object"===(void 0===e?"undefined":i(e))&&e.constructor===Object}},{key:"JsonToString",value:function(e){var t=[];return JSON.stringify(e,function(e,n){return n&&"object"==(void 0===n?"undefined":i(n))&&t.push(n),n},2)}}]),e}();t.LoggerUtils=a},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),o=window.localStorage,s="LOG-"+(new Date).getDate()+"-"+((new Date).getMonth()+1)+"-"+(new Date).getFullYear(),a=!1,c=0,u=null,l=function(){function e(){r(this,e)}return i(e,null,[{key:"getKey",value:function(){return s}},{key:"setEnabled",value:function(e){a=e}},{key:"setStorageTimeMin",value:function(e){c=e}},{key:"Add",value:function(t,n,r){if(a){var i=new Date,l=o.getItem(s),h=n+"-"+r+" "+i.getDate()+"-"+(i.getMonth()+1)+"-"+i.getFullYear()+"-"+i.getDate()+" "+i.toLocaleTimeString()+" - MSG: "+t;l?(u||(u=new Date(JSON.parse(o.getItem("GalateaLoggerDate")))),0!==c&&(i-u)/6e4>c?(e.Clean(),u=i,o.setItem("GalateaLoggerDate",JSON.stringify(i))):h=l+";"+h,o.setItem(s,""+h)):(u=i,o.setItem(s,h),o.setItem("GalateaLoggerDate",JSON.stringify(i)))}}},{key:"getRawLogs",value:function(){return o.getItem(s)}},{key:"getLogs",value:function(){return o.getItem(s).replaceAll(";","\n")}},{key:"Clean",value:function(){console.log("Cleaning local storage ",s),o.removeItem(s)}}]),e}();t.LoggerLocal=l},function(e,t,n){"use strict";function r(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0}),t.LoggerDispatcher=void 0;var o=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),s=n(13),a=n(1),c=n(10),u=n(32),l=n(3),h=n(11),d=(window.localStorage,function(){function e(){i(this,e)}return o(e,null,[{key:"Dispatch",value:function(t,n,i,o){h.LoggerLocal.Add(i,t,n),u.LoggerConfigurator.Init(function(){!o&&e.DefaultOutput.apply(e,[t,n].concat(r(i))),e.RemoteOutput.apply(e,[t,n].concat(r(i)))})}},{key:"RemoteOutput",value:function(e,t){if(window[a.Constants._LOGGER_VAR_WINDOW]&&window[a.Constants._LOGGER_VAR_WINDOW]._ENABLE_AJAX&&c.LoggerUtils.IsAllowedRemoteToLogBySeverity(t)){for(var n=arguments.length,r=Array(n>2?n-2:0),i=2;i<n;i++)r[i-2]=arguments[i];if("WARN"===t.toUpperCase()||"ERROR"===t.toUpperCase())s.LoggerRestClient.log(e,t,"["+e+"] "+r);else{var o=0===window[a.Constants._LOGGER_VAR_WINDOW]._FILTER_USER_POST.length,u=0===window[a.Constants._LOGGER_VAR_WINDOW]._FILTER_APP_POST.length;if(o&&u)s.LoggerRestClient.log.apply(s.LoggerRestClient,[e,t].concat(r));else{var h=!0,d=!0;o||(h=window[a.Constants._LOGGER_VAR_WINDOW]._FILTER_USER_POST.find(function(e){return e===l.LoggerInstance.getUserId()})),u||(d=window[a.Constants._LOGGER_VAR_WINDOW]._FILTER_APP_POST.find(function(e){return e===l.LoggerInstance.getApplication()})),h&&d&&s.LoggerRestClient.log(e,t,"["+e+"] "+r)}}}}},{key:"DefaultOutput",value:function(e,t){if(t=t.toUpperCase(),window[a.Constants._LOGGER_VAR_WINDOW]&&window[a.Constants._LOGGER_VAR_WINDOW]._ENABLE_DEFAULT&&c.LoggerUtils.IsAllowedConsoleToLogBySeverity(t)){var n,r=console.log;a.Constants._Log_CONSOLE[t]&&(r=a.Constants._Log_CONSOLE[t]);for(var i=(new Date).toLocaleTimeString(),o=arguments.length,s=Array(o>2?o-2:0),u=2;u<o;u++)s[u-2]=arguments[u];(n=r).call.apply(n,[null,"["+i+"]["+t+"]["+e+"]"].concat(s))}}}]),e}());t.LoggerDispatcher=d},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0}),t.LoggerRestClient=void 0;var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),o=n(4),s=function(e){return e&&e.__esModule?e:{default:e}}(o),a=n(1),c=n(10),u=0,l=!0,h=function(){function e(){r(this,e)}return i(e,null,[{key:"log",value:function(e,t){if(window[a.Constants._LOGGER_VAR_WINDOW]._ENABLE_AJAX)if(0===window[a.Constants._LOGGER_VAR_WINDOW]._NUMBER_ATTEMP_POST||u<window[a.Constants._LOGGER_VAR_WINDOW]._NUMBER_ATTEMP_POST)try{for(var n=new URL(window[a.Constants._LOGGER_VAR_WINDOW]._SERVER),r=new URL(window[a.Constants._LOGGER_VAR_WINDOW]._DOMAIN,n),i=arguments.length,o=Array(i>2?i-2:0),h=2;h<i;h++)o[h-2]=arguments[h];var d=c.LoggerUtils.ToStringMessage(o);s.default.post(r,{UserType:e,Message:d,Severity:t}).then(function(){u=0}).catch(function(e){u++,console.warn("It was not possible to send the message server:",r,e)})}catch(e){u++,console.error("it was not possible to send the log message because an error ocurred servidor:"+window[a.Constants._LOGGER_VAR_WINDOW]._SERVER+" error:"+e+" recommendation: you could check the logger configuration")}else l&&(l=!1,console.warn("number of attempts to overcome Api web is necessary to check the configuration file for logger.json"))}}]),e}();t.LoggerRestClient=h},function(e,t,n){"use strict";function r(e){var t=new s(e),n=o(s.prototype.request,t);return i.extend(n,s.prototype,t),i.extend(n,t),n}var i=n(0),o=n(5),s=n(16),a=n(2),c=r(a);c.Axios=s,c.create=function(e){return r(i.merge(a,e))},c.Cancel=n(9),c.CancelToken=n(30),c.isCancel=n(8),c.all=function(e){return Promise.all(e)},c.spread=n(31),e.exports=c,e.exports.default=c},function(e,t){/*!
	 * Determine if an object is a Buffer
	 *
	 * @author   Feross Aboukhadijeh <https://feross.org>
	 * @license  MIT
	 */
	e.exports=function(e){return null!=e&&null!=e.constructor&&"function"==typeof e.constructor.isBuffer&&e.constructor.isBuffer(e)}},function(e,t,n){"use strict";function r(e){this.defaults=e,this.interceptors={request:new s,response:new s}}var i=n(2),o=n(0),s=n(25),a=n(26);r.prototype.request=function(e){"string"==typeof e&&(e=o.merge({url:arguments[0]},arguments[1])),e=o.merge(i,{method:"get"},this.defaults,e),e.method=e.method.toLowerCase();var t=[a,void 0],n=Promise.resolve(e);for(this.interceptors.request.forEach(function(e){t.unshift(e.fulfilled,e.rejected)}),this.interceptors.response.forEach(function(e){t.push(e.fulfilled,e.rejected)});t.length;)n=n.then(t.shift(),t.shift());return n},o.forEach(["delete","get","head","options"],function(e){r.prototype[e]=function(t,n){return this.request(o.merge(n||{},{method:e,url:t}))}}),o.forEach(["post","put","patch"],function(e){r.prototype[e]=function(t,n,r){return this.request(o.merge(r||{},{method:e,url:t,data:n}))}}),e.exports=r},function(e,t){function n(){throw new Error("setTimeout has not been defined")}function r(){throw new Error("clearTimeout has not been defined")}function i(e){if(l===setTimeout)return setTimeout(e,0);if((l===n||!l)&&setTimeout)return l=setTimeout,setTimeout(e,0);try{return l(e,0)}catch(t){try{return l.call(null,e,0)}catch(t){return l.call(this,e,0)}}}function o(e){if(h===clearTimeout)return clearTimeout(e);if((h===r||!h)&&clearTimeout)return h=clearTimeout,clearTimeout(e);try{return h(e)}catch(t){try{return h.call(null,e)}catch(t){return h.call(this,e)}}}function s(){g&&f&&(g=!1,f.length?p=f.concat(p):m=-1,p.length&&a())}function a(){if(!g){var e=i(s);g=!0;for(var t=p.length;t;){for(f=p,p=[];++m<t;)f&&f[m].run();m=-1,t=p.length}f=null,g=!1,o(e)}}function c(e,t){this.fun=e,this.array=t}function u(){}var l,h,d=e.exports={};!function(){try{l="function"==typeof setTimeout?setTimeout:n}catch(e){l=n}try{h="function"==typeof clearTimeout?clearTimeout:r}catch(e){h=r}}();var f,p=[],g=!1,m=-1;d.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];p.push(new c(e,t)),1!==p.length||g||i(a)},c.prototype.run=function(){this.fun.apply(null,this.array)},d.title="browser",d.browser=!0,d.env={},d.argv=[],d.version="",d.versions={},d.on=u,d.addListener=u,d.once=u,d.off=u,d.removeListener=u,d.removeAllListeners=u,d.emit=u,d.prependListener=u,d.prependOnceListener=u,d.listeners=function(e){return[]},d.binding=function(e){throw new Error("process.binding is not supported")},d.cwd=function(){return"/"},d.chdir=function(e){throw new Error("process.chdir is not supported")},d.umask=function(){return 0}},function(e,t,n){"use strict";var r=n(0);e.exports=function(e,t){r.forEach(e,function(n,r){r!==t&&r.toUpperCase()===t.toUpperCase()&&(e[t]=n,delete e[r])})}},function(e,t,n){"use strict";var r=n(7);e.exports=function(e,t,n){var i=n.config.validateStatus;n.status&&i&&!i(n.status)?t(r("Request failed with status code "+n.status,n.config,null,n.request,n)):e(n)}},function(e,t,n){"use strict";e.exports=function(e,t,n,r,i){return e.config=t,n&&(e.code=n),e.request=r,e.response=i,e}},function(e,t,n){"use strict";function r(e){return encodeURIComponent(e).replace(/%40/gi,"@").replace(/%3A/gi,":").replace(/%24/g,"$").replace(/%2C/gi,",").replace(/%20/g,"+").replace(/%5B/gi,"[").replace(/%5D/gi,"]")}var i=n(0);e.exports=function(e,t,n){if(!t)return e;var o;if(n)o=n(t);else if(i.isURLSearchParams(t))o=t.toString();else{var s=[];i.forEach(t,function(e,t){null!==e&&void 0!==e&&(i.isArray(e)?t+="[]":e=[e],i.forEach(e,function(e){i.isDate(e)?e=e.toISOString():i.isObject(e)&&(e=JSON.stringify(e)),s.push(r(t)+"="+r(e))}))}),o=s.join("&")}return o&&(e+=(-1===e.indexOf("?")?"?":"&")+o),e}},function(e,t,n){"use strict";var r=n(0),i=["age","authorization","content-length","content-type","etag","expires","from","host","if-modified-since","if-unmodified-since","last-modified","location","max-forwards","proxy-authorization","referer","retry-after","user-agent"];e.exports=function(e){var t,n,o,s={};return e?(r.forEach(e.split("\n"),function(e){if(o=e.indexOf(":"),t=r.trim(e.substr(0,o)).toLowerCase(),n=r.trim(e.substr(o+1)),t){if(s[t]&&i.indexOf(t)>=0)return;s[t]="set-cookie"===t?(s[t]?s[t]:[]).concat([n]):s[t]?s[t]+", "+n:n}}),s):s}},function(e,t,n){"use strict";var r=n(0);e.exports=r.isStandardBrowserEnv()?function(){function e(e){var t=e;return n&&(i.setAttribute("href",t),t=i.href),i.setAttribute("href",t),{href:i.href,protocol:i.protocol?i.protocol.replace(/:$/,""):"",host:i.host,search:i.search?i.search.replace(/^\?/,""):"",hash:i.hash?i.hash.replace(/^#/,""):"",hostname:i.hostname,port:i.port,pathname:"/"===i.pathname.charAt(0)?i.pathname:"/"+i.pathname}}var t,n=/(msie|trident)/i.test(navigator.userAgent),i=document.createElement("a");return t=e(window.location.href),function(n){var i=r.isString(n)?e(n):n;return i.protocol===t.protocol&&i.host===t.host}}():function(){return function(){return!0}}()},function(e,t,n){"use strict";var r=n(0);e.exports=r.isStandardBrowserEnv()?function(){return{write:function(e,t,n,i,o,s){var a=[];a.push(e+"="+encodeURIComponent(t)),r.isNumber(n)&&a.push("expires="+new Date(n).toGMTString()),r.isString(i)&&a.push("path="+i),r.isString(o)&&a.push("domain="+o),!0===s&&a.push("secure"),document.cookie=a.join("; ")},read:function(e){var t=document.cookie.match(new RegExp("(^|;\\s*)("+e+")=([^;]*)"));return t?decodeURIComponent(t[3]):null},remove:function(e){this.write(e,"",Date.now()-864e5)}}}():function(){return{write:function(){},read:function(){return null},remove:function(){}}}()},function(e,t,n){"use strict";function r(){this.handlers=[]}var i=n(0);r.prototype.use=function(e,t){return this.handlers.push({fulfilled:e,rejected:t}),this.handlers.length-1},r.prototype.eject=function(e){this.handlers[e]&&(this.handlers[e]=null)},r.prototype.forEach=function(e){i.forEach(this.handlers,function(t){null!==t&&e(t)})},e.exports=r},function(e,t,n){"use strict";function r(e){e.cancelToken&&e.cancelToken.throwIfRequested()}var i=n(0),o=n(27),s=n(8),a=n(2),c=n(28),u=n(29);e.exports=function(e){return r(e),e.baseURL&&!c(e.url)&&(e.url=u(e.baseURL,e.url)),e.headers=e.headers||{},e.data=o(e.data,e.headers,e.transformRequest),e.headers=i.merge(e.headers.common||{},e.headers[e.method]||{},e.headers||{}),i.forEach(["delete","get","head","post","put","patch","common"],function(t){delete e.headers[t]}),(e.adapter||a.adapter)(e).then(function(t){return r(e),t.data=o(t.data,t.headers,e.transformResponse),t},function(t){return s(t)||(r(e),t&&t.response&&(t.response.data=o(t.response.data,t.response.headers,e.transformResponse))),Promise.reject(t)})}},function(e,t,n){"use strict";var r=n(0);e.exports=function(e,t,n){return r.forEach(n,function(n){e=n(e,t)}),e}},function(e,t,n){"use strict";e.exports=function(e){return/^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(e)}},function(e,t,n){"use strict";e.exports=function(e,t){return t?e.replace(/\/+$/,"")+"/"+t.replace(/^\/+/,""):e}},function(e,t,n){"use strict";function r(e){if("function"!=typeof e)throw new TypeError("executor must be a function.");var t;this.promise=new Promise(function(e){t=e});var n=this;e(function(e){n.reason||(n.reason=new i(e),t(n.reason))})}var i=n(9);r.prototype.throwIfRequested=function(){if(this.reason)throw this.reason},r.source=function(){var e;return{token:new r(function(t){e=t}),cancel:e}},e.exports=r},function(e,t,n){"use strict";e.exports=function(e){return function(t){return e.apply(null,t)}}},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t,n){void 0===e[t]&&(console.info("file logger.json does not contain field [%s] set value default [%s]",t,n),e[t]=n)}Object.defineProperty(t,"__esModule",{value:!0}),t.LoggerConfigurator=void 0;var o=function(){function e(e,t){var n=[],r=!0,i=!1,o=void 0;try{for(var s,a=e[Symbol.iterator]();!(r=(s=a.next()).done)&&(n.push(s.value),!t||n.length!==t);r=!0);}catch(e){i=!0,o=e}finally{try{!r&&a.return&&a.return()}finally{if(i)throw o}}return n}return function(t,n){if(Array.isArray(t))return t;if(Symbol.iterator in Object(t))return e(t,n);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}(),s=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),a=n(1),c=n(4),u=function(e){return e&&e.__esModule?e:{default:e}}(c),l=!0,h=function(){function e(){r(this,e)}return s(e,null,[{key:"Init",value:function(t){l&&e.IsConfigurationNotAssigned()?(l=!1,e.GetByExecutionEnvironment(t)):t()}},{key:"Setup",value:function(t,n){if(console.info("Setup ",t),t){window[a.Constants._LOGGER_VAR_WINDOW]={};var r=!0,s=!1,c=void 0;try{for(var u,l=Object.entries(a.Constants._CONFIGURATIONS)[Symbol.iterator]();!(r=(u=l.next()).done);r=!0){var h=o(u.value,2),d=h[0],f=h[1];i(t,d,f)}}catch(e){s=!0,c=e}finally{try{!r&&l.return&&l.return()}finally{if(s)throw c}}Object.keys(t).forEach(function(e){return window[a.Constants._LOGGER_VAR_WINDOW][e]=t[e]}),window[a.Constants._LOGGER_VAR_WINDOW]._USE_WINDOW_ORIGIN&&e.SetConfigurationServer()}else window[a.Constants._LOGGER_VAR_WINDOW]=a.Constants._CONFIGURATIONS,console.info("Logger will use default configuration ... ",a.Constants._CONFIGURATIONS);n()}},{key:"GetByExecutionEnvironment",value:function(t){e.IsBrowser()?e.GetRemote(t):e.GetLocal(t)}},{key:"IsBrowser",value:function(){return!!window}},{key:"GetLocal",value:function(t){e.Setup(null,t)}},{key:"GetRemote",value:function(t){var n=""+window.location.origin+window.location.pathname,r=n.split("/");console.log("Remove Last element ",r.pop()),n=r.join("/")+"/",n+=a.Constants._LOGGER_CONFIGURATION_FILE_REMOTE,u.default.get(n,{responseType:"json"}).then(function(n){e.Setup(n.data,t)}).catch(function(n){console.error("It was not possible to get remote file configuration",n),e.Setup(null,t)})}},{key:"SetConfigurationServer",value:function(){if(window[a.Constants._LOGGER_VAR_WINDOW]._USE_WINDOW_ORIGIN){var e=window.location.hostname;if("127.0.0.1"!==e&&"localhost"!==e){var t=window.location.origin;console.debug("SetConfigurationServer withLocation",t),window[a.Constants._LOGGER_VAR_WINDOW]._SERVER=t}}}},{key:"ExistExternalConfiguration",value:function(e){return!!e}},{key:"IsConfigurationNotAssigned",value:function(){return!a.Constants._LOGGER_CONFIGURATION_ASSIGNED}}]),e}();t.LoggerConfigurator=h}])})},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0}),t.MQWrapper=void 0;var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),o=n(5);t.MQWrapper=function(){function e(){r(this,e)}return i(e,[{key:"getMQ",value:function(){var e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];return(new o.MQFactory).buildClient(e)}}]),e}()},function(e,t,n){!function(t,n){e.exports=n()}("undefined"!=typeof self&&self,function(){return function(e){function t(r){if(n[r])return n[r].exports;var i=n[r]={i:r,l:!1,exports:{}};return e[r].call(i.exports,i,i.exports,t),i.l=!0,i.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=1)}([function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0}),t.Logger=void 0;var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),o=n(3);o.LoggerInstance.setApplication("MessageQueue"),t.Logger=function(){function e(){r(this,e)}return i(e,null,[{key:"setUserType",value:function(e){o.LoggerInstance.setUsertype(e)}},{key:"setUserId",value:function(e){o.LoggerInstance.setUserId(e)}},{key:"Trace",value:function(){for(var e=arguments.length,t=Array(e),n=0;n<e;n++)t[n]=arguments[n];o.LoggerInstance.Trace(["[MessageQueue]"].concat(t))}},{key:"Debug",value:function(){for(var e=arguments.length,t=Array(e),n=0;n<e;n++)t[n]=arguments[n];o.LoggerInstance.Debug(["[MessageQueue]"].concat(t))}},{key:"Warning",value:function(){for(var e=arguments.length,t=Array(e),n=0;n<e;n++)t[n]=arguments[n];o.LoggerInstance.Warning(["[MessageQueue]"].concat(t))}},{key:"Warn",value:function(){for(var e=arguments.length,t=Array(e),n=0;n<e;n++)t[n]=arguments[n];o.LoggerInstance.Warning(["[MessageQueue]"].concat(t))}},{key:"Info",value:function(){for(var e=arguments.length,t=Array(e),n=0;n<e;n++)t[n]=arguments[n];o.LoggerInstance.Info(["[MessageQueue]"].concat(t))}},{key:"Error",value:function(){for(var e=arguments.length,t=Array(e),n=0;n<e;n++)t[n]=arguments[n];o.LoggerInstance.Error(["[MessageQueue]"].concat(t))}}]),e}()},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0}),t.MQFactory=void 0;var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),o=n(2),s=n(4),a=n(9),c=n(0),u=n(12);t.MQFactory=function(){function e(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"AGENT";r(this,e),c.Logger.setUserType(t)}return i(e,[{key:"buildClient",value:function(){var e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];c.Logger.Info("Version ",u.version);var t=e?new s.RabbitStompWrapper:new a.RabbitMqttWrapper,n=t.getRabbit();return new o.MessageQueueClient(n)}}]),e}()},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0}),t.MessageQueueClient=void 0;var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),o=n(0),s=null;t.MessageQueueClient=function(){function e(t){return arguments.length>1&&void 0!==arguments[1]&&arguments[1],r(this,e),s||(o.Logger.Trace("Init MessageQueueClient constructor "),this.rabbitmq=t,s=this,this.MQParameter={onDisconnected:function(){console.log("Stack")},onConnected:function(){console.log("Stack")},onMessage:function(){console.log("Stack")},onReconnected:function(){console.log("Stack")},mq_username:"",mq_password:"",mq_vhost:"/",mq_server:"",mq_port:"",mq_consumer:"",mq_expiration:"",mq_secureConnection:!1}),s}return i(e,[{key:"setUserType",value:function(e){o.Logger.setUserType(e)}},{key:"setUserId",value:function(e){o.Logger.setUserId(e)}},{key:"setReconnectInterval",value:function(e){this.rabbitmq.setReconnectInterval(e)}},{key:"setMaxAttemps",value:function(e){this.rabbitmq.setMaxAttemps(e)}},{key:"connectToRabbit",value:function(){this.rabbitmq.setFunctions(this.MQParameter),this.rabbitmq.connectToRabbit()}},{key:"addTopics",value:function(e){for(var t in e)e.hasOwnProperty(t)&&this.rabbitmq.addTopics(e[t][0],e[t][1],e[t][2])}},{key:"subscribeTopics",value:function(e){for(var t in e)e.hasOwnProperty(t)&&(this.addTopics(e),this.rabbitmq.subscribeTopics(e[t][0],e[t][1],e[t][2]))}},{key:"unsubscribeTopics",value:function(e){this.rabbitmq.unsubscribeTopics(e)}},{key:"sendMessage",value:function(e,t){this.rabbitmq.sendMessage(e,t)}},{key:"disconnectBroker",value:function(){this.rabbitmq.disconnectToRabbit()}}]),e}()},function(e,t,n){!function(t,n){e.exports=function(){return function(e){function t(r){if(n[r])return n[r].exports;var i=n[r]={i:r,l:!1,exports:{}};return e[r].call(i.exports,i,i.exports,t),i.l=!0,i.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=3)}([function(e,t,n){"use strict";function r(e){return"[object Array]"===b.call(e)}function i(e){return"[object ArrayBuffer]"===b.call(e)}function o(e){return"undefined"!=typeof FormData&&e instanceof FormData}function s(e){return"undefined"!=typeof ArrayBuffer&&ArrayBuffer.isView?ArrayBuffer.isView(e):e&&e.buffer&&e.buffer instanceof ArrayBuffer}function a(e){return"string"==typeof e}function c(e){return"number"==typeof e}function u(e){return void 0===e}function l(e){return null!==e&&"object"==typeof e}function h(e){return"[object Date]"===b.call(e)}function d(e){return"[object File]"===b.call(e)}function f(e){return"[object Blob]"===b.call(e)}function p(e){return"[object Function]"===b.call(e)}function g(e){return l(e)&&p(e.pipe)}function m(e){return"undefined"!=typeof URLSearchParams&&e instanceof URLSearchParams}function v(e){return e.replace(/^\s*/,"").replace(/\s*$/,"")}function T(){return("undefined"==typeof navigator||"ReactNative"!==navigator.product)&&"undefined"!=typeof window&&"undefined"!=typeof document}function y(e,t){if(null!==e&&void 0!==e)if("object"!=typeof e&&(e=[e]),r(e))for(var n=0,i=e.length;n<i;n++)t.call(null,e[n],n,e);else for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&t.call(null,e[o],o,e)}function _(){function e(e,n){"object"==typeof t[n]&&"object"==typeof e?t[n]=_(t[n],e):t[n]=e}for(var t={},n=0,r=arguments.length;n<r;n++)y(arguments[n],e);return t}function S(e,t,n){return y(t,function(t,r){e[r]=n&&"function"==typeof t?E(t,n):t}),e}var E=n(5),C=n(15),b=Object.prototype.toString;e.exports={isArray:r,isArrayBuffer:i,isBuffer:C,isFormData:o,isArrayBufferView:s,isString:a,isNumber:c,isObject:l,isUndefined:u,isDate:h,isFile:d,isBlob:f,isFunction:p,isStream:g,isURLSearchParams:m,isStandardBrowserEnv:T,forEach:y,merge:_,extend:S,trim:v}},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var i=null,o=t.Constants=function e(){r(this,e),i||(i=this)};o._LOGGER_VAR_WINDOW="NuxibaLogger",o._LOGGER_CONFIGURATION_FILE_LOCALE="./logger.json",o._LOGGER_CONFIGURATION_FILE_REMOTE="logger.json",o._LOGGER_CONFIGURATION_FILE_ENCODE="utf8",o._LOGGER_CONFIGURATION_ASSIGNED=!!window[o._LOGGER_VAR_WINDOW],o._LOG_LEVELS={TRACE:{logLevel:0},DEBUG:{logLevel:1},INFO:{logLevel:2},WARN:{logLevel:3},ERROR:{logLevel:4}},o._Log_CONSOLE={TRACE:console.log,DEBUG:console.log,INFO:console.info,WARN:console.warn,ERROR:console.error},o._CONFIGURATIONS={_ENABLE_DEFAULT:!0,_ENABLE_AJAX:!1,_USE_WINDOW_ORIGIN:!0,_SERVER:"http://127.0.0.1",_DOMAIN:"/LoggerWS/api/Logger",_SEVERITY:"INFO",_SEVERITY_CONSOLE:"INFO",_NUMBER_ATTEMP_POST:10,_FILTER_USER_POST:[],_FILTER_APP_POST:[]},o._REST={_POST_METHOD:"POST",_MODE:"cors",_CONTENT_TYPE:"content-type",_APPLICATION_JSON:"application/json"}},function(e,t,n){"use strict";(function(t){function r(e,t){!i.isUndefined(e)&&i.isUndefined(e["Content-Type"])&&(e["Content-Type"]=t)}var i=n(0),o=n(18),s={"Content-Type":"application/x-www-form-urlencoded"},a={adapter:function(){var e;return"undefined"!=typeof XMLHttpRequest?e=n(6):void 0!==t&&(e=n(6)),e}(),transformRequest:[function(e,t){return o(t,"Content-Type"),i.isFormData(e)||i.isArrayBuffer(e)||i.isBuffer(e)||i.isStream(e)||i.isFile(e)||i.isBlob(e)?e:i.isArrayBufferView(e)?e.buffer:i.isURLSearchParams(e)?(r(t,"application/x-www-form-urlencoded;charset=utf-8"),e.toString()):i.isObject(e)?(r(t,"application/json;charset=utf-8"),JSON.stringify(e)):e}],transformResponse:[function(e){if("string"==typeof e)try{e=JSON.parse(e)}catch(e){}return e}],timeout:0,xsrfCookieName:"XSRF-TOKEN",xsrfHeaderName:"X-XSRF-TOKEN",maxContentLength:-1,validateStatus:function(e){return e>=200&&e<300}};a.headers={common:{Accept:"application/json, text/plain, */*"}},i.forEach(["delete","get","head"],function(e){a.headers[e]={}}),i.forEach(["post","put","patch"],function(e){a.headers[e]=i.merge(s)}),e.exports=a}).call(t,n(17))},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0}),t.LoggerInstance=void 0;var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),o=n(12),s=n(1),a=n(11),c="AGENT",u="",l="",h=function(){function e(){r(this,e)}return i(e,null,[{key:"setUsertype",value:function(e){c=e}},{key:"setUserId",value:function(e){u=e}},{key:"getUserId",value:function(){return u}},{key:"setApplication",value:function(e){l=e}},{key:"setLocalLogger",value:function(e){a.LoggerLocal.setEnabled(e)}},{key:"setLocalStorageTime",value:function(e){a.LoggerLocal.setStorageTimeMin(e)}},{key:"getApplication",value:function(){return l}},{key:"SetUseServerWithLocation",value:function(e){window[s.Constants._LOGGER_VAR_WINDOW]._USE_WINDOW_LOCATION=e}},{key:"addUserId",value:function(e){if(u){var t="[UserId:"+u+"]";e.unshift(t)}}},{key:"Group",value:function(e){console.group(e)}},{key:"GroupEnd",value:function(){console.groupEnd()}},{key:"CleanLocalLog",value:function(){a.LoggerLocal.Clean()}},{key:"Trace",value:function(){for(var e=arguments.length,t=Array(e),n=0;n<e;n++)t[n]=arguments[n];o.LoggerDispatcher.Dispatch(c,"Trace",["[UserId:"+u+"]"].concat(t))}},{key:"Debug",value:function(){for(var t=arguments.length,n=Array(t),r=0;r<t;r++)n[r]=arguments[r];e.addUserId(n),o.LoggerDispatcher.Dispatch(c,"Debug",["[UserId:"+u+"]"].concat(n))}},{key:"Warning",value:function(){for(var t=arguments.length,n=Array(t),r=0;r<t;r++)n[r]=arguments[r];e.addUserId(n),o.LoggerDispatcher.Dispatch(c,"Warn",["[UserId:"+u+"]"].concat(n))}},{key:"Warn",value:function(){for(var t=arguments.length,n=Array(t),r=0;r<t;r++)n[r]=arguments[r];e.Warning(n)}},{key:"Info",value:function(){for(var t=arguments.length,n=Array(t),r=0;r<t;r++)n[r]=arguments[r];e.addUserId(n),o.LoggerDispatcher.Dispatch(c,"Info",["[UserId:"+u+"]"].concat(n))}},{key:"Error",value:function(){for(var t=arguments.length,n=Array(t),r=0;r<t;r++)n[r]=arguments[r];e.addUserId(n),o.LoggerDispatcher.Dispatch(c,"Error",["[UserId:"+u+"]"].concat(n))}},{key:"JsWarning",value:function(){for(var t=arguments.length,n=Array(t),r=0;r<t;r++)n[r]=arguments[r];e.addUserId(n),o.LoggerDispatcher.Dispatch(c,"Warn",["[UserId:"+u+"]"].concat(n),!0)}},{key:"JsError",value:function(){for(var t=arguments.length,n=Array(t),r=0;r<t;r++)n[r]=arguments[r];e.addUserId(n),o.LoggerDispatcher.Dispatch(c,"Error",["[UserId:"+u+"]"].concat(n),!0)}},{key:"LevelConsole",get:function(){return window[s.Constants._LOGGER_VAR_WINDOW]._SEVERITY_CONSOLE}}]),e}();t.LoggerInstance=h},function(e,t,n){e.exports=n(14)},function(e,t,n){"use strict";e.exports=function(e,t){return function(){for(var n=new Array(arguments.length),r=0;r<n.length;r++)n[r]=arguments[r];return e.apply(t,n)}}},function(e,t,n){"use strict";var r=n(0),i=n(19),o=n(21),s=n(22),a=n(23),c=n(7);e.exports=function(e){return new Promise(function(t,u){var l=e.data,h=e.headers;r.isFormData(l)&&delete h["Content-Type"];var d=new XMLHttpRequest;if(e.auth){var f=e.auth.username||"",p=e.auth.password||"";h.Authorization="Basic "+btoa(f+":"+p)}if(d.open(e.method.toUpperCase(),o(e.url,e.params,e.paramsSerializer),!0),d.timeout=e.timeout,d.onreadystatechange=function(){if(d&&4===d.readyState&&(0!==d.status||d.responseURL&&0===d.responseURL.indexOf("file:"))){var n="getAllResponseHeaders"in d?s(d.getAllResponseHeaders()):null,r=e.responseType&&"text"!==e.responseType?d.response:d.responseText,o={data:r,status:d.status,statusText:d.statusText,headers:n,config:e,request:d};i(t,u,o),d=null}},d.onerror=function(){u(c("Network Error",e,null,d)),d=null},d.ontimeout=function(){u(c("timeout of "+e.timeout+"ms exceeded",e,"ECONNABORTED",d)),d=null},r.isStandardBrowserEnv()){var g=n(24),m=(e.withCredentials||a(e.url))&&e.xsrfCookieName?g.read(e.xsrfCookieName):void 0;m&&(h[e.xsrfHeaderName]=m)}if("setRequestHeader"in d&&r.forEach(h,function(e,t){void 0===l&&"content-type"===t.toLowerCase()?delete h[t]:d.setRequestHeader(t,e)}),e.withCredentials&&(d.withCredentials=!0),e.responseType)try{d.responseType=e.responseType}catch(t){if("json"!==e.responseType)throw t}"function"==typeof e.onDownloadProgress&&d.addEventListener("progress",e.onDownloadProgress),"function"==typeof e.onUploadProgress&&d.upload&&d.upload.addEventListener("progress",e.onUploadProgress),e.cancelToken&&e.cancelToken.promise.then(function(e){d&&(d.abort(),u(e),d=null)}),void 0===l&&(l=null),d.send(l)})}},function(e,t,n){"use strict";var r=n(20);e.exports=function(e,t,n,i,o){var s=new Error(e);return r(s,t,n,i,o)}},function(e,t,n){"use strict";e.exports=function(e){return!(!e||!e.__CANCEL__)}},function(e,t,n){"use strict";function r(e){this.message=e}r.prototype.toString=function(){return"Cancel"+(this.message?": "+this.message:"")},r.prototype.__CANCEL__=!0,e.exports=r},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0}),t.LoggerUtils=void 0;var i="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},o=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),s=n(1),a=function(){function e(){r(this,e)}return o(e,null,[{key:"GetLogLevelBySeverity",value:function(e){var t=1;return e=e.toUpperCase(),s.Constants._LOG_LEVELS[e]&&(t=s.Constants._LOG_LEVELS[e].logLevel),t}},{key:"IsAllowedRemoteToLogBySeverity",value:function(t){return e.GetLogLevelBySeverity(t)>=e.GetCurrentRemoteSeverityLevelConfigured()}},{key:"GetCurrentRemoteSeverityLevelConfigured",value:function(){return e.GetLogLevelBySeverity(window[s.Constants._LOGGER_VAR_WINDOW]._SEVERITY)}},{key:"IsAllowedConsoleToLogBySeverity",value:function(t){return e.GetLogLevelBySeverity(t)>=e.GetCurrentConsoleSeverityLevelConfigured()}},{key:"GetCurrentConsoleSeverityLevelConfigured",value:function(){return e.GetLogLevelBySeverity(window[s.Constants._LOGGER_VAR_WINDOW]._SEVERITY_CONSOLE)}},{key:"ToStringMessage",value:function(){for(var t="",n=arguments.length,r=Array(n),i=0;i<n;i++)r[i]=arguments[i];return r.forEach(function(n){t+=e.ToStringObject(n)}),t}},{key:"ToStringObject",value:function(t){return e.IsObject(t)?"\n"+e.JsonToString(t):t}},{key:"IsObject",value:function(e){return e&&"object"===(void 0===e?"undefined":i(e))&&e.constructor===Object}},{key:"JsonToString",value:function(e){var t=[];return JSON.stringify(e,function(e,n){return n&&"object"==(void 0===n?"undefined":i(n))&&t.push(n),n},2)}}]),e}();t.LoggerUtils=a},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),o=window.localStorage,s="LOG-"+(new Date).getDate()+"-"+((new Date).getMonth()+1)+"-"+(new Date).getFullYear(),a=!1,c=0,u=null,l=function(){function e(){r(this,e)}return i(e,null,[{key:"getKey",value:function(){return s}},{key:"setEnabled",value:function(e){a=e}},{key:"setStorageTimeMin",value:function(e){c=e}},{key:"Add",value:function(t,n,r){if(a){var i=new Date,l=o.getItem(s),h=n+"-"+r+" "+i.getDate()+"-"+(i.getMonth()+1)+"-"+i.getFullYear()+"-"+i.getDate()+" "+i.toLocaleTimeString()+" - MSG: "+t;l?(u||(u=new Date(JSON.parse(o.getItem("GalateaLoggerDate")))),0!==c&&(i-u)/6e4>c?(e.Clean(),u=i,o.setItem("GalateaLoggerDate",JSON.stringify(i))):h=l+";"+h,o.setItem(s,""+h)):(u=i,o.setItem(s,h),o.setItem("GalateaLoggerDate",JSON.stringify(i)))}}},{key:"getRawLogs",value:function(){return o.getItem(s)}},{key:"getLogs",value:function(){return o.getItem(s).replaceAll(";","\n")}},{key:"Clean",value:function(){console.log("Cleaning local storage ",s),o.removeItem(s)}}]),e}();t.LoggerLocal=l},function(e,t,n){"use strict";function r(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0}),t.LoggerDispatcher=void 0;var o=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),s=n(13),a=n(1),c=n(10),u=n(32),l=n(3),h=n(11),d=(window.localStorage,function(){function e(){i(this,e)}return o(e,null,[{key:"Dispatch",value:function(t,n,i,o){h.LoggerLocal.Add(i,t,n),u.LoggerConfigurator.Init(function(){!o&&e.DefaultOutput.apply(e,[t,n].concat(r(i))),e.RemoteOutput.apply(e,[t,n].concat(r(i)))})}},{key:"RemoteOutput",value:function(e,t){if(window[a.Constants._LOGGER_VAR_WINDOW]&&window[a.Constants._LOGGER_VAR_WINDOW]._ENABLE_AJAX&&c.LoggerUtils.IsAllowedRemoteToLogBySeverity(t)){for(var n=arguments.length,r=Array(n>2?n-2:0),i=2;i<n;i++)r[i-2]=arguments[i];if("WARN"===t.toUpperCase()||"ERROR"===t.toUpperCase())s.LoggerRestClient.log(e,t,"["+e+"] "+r);else{var o=0===window[a.Constants._LOGGER_VAR_WINDOW]._FILTER_USER_POST.length,u=0===window[a.Constants._LOGGER_VAR_WINDOW]._FILTER_APP_POST.length;if(o&&u)s.LoggerRestClient.log.apply(s.LoggerRestClient,[e,t].concat(r));else{var h=!0,d=!0;o||(h=window[a.Constants._LOGGER_VAR_WINDOW]._FILTER_USER_POST.find(function(e){return e===l.LoggerInstance.getUserId()})),u||(d=window[a.Constants._LOGGER_VAR_WINDOW]._FILTER_APP_POST.find(function(e){return e===l.LoggerInstance.getApplication()})),h&&d&&s.LoggerRestClient.log(e,t,"["+e+"] "+r)}}}}},{key:"DefaultOutput",value:function(e,t){if(t=t.toUpperCase(),window[a.Constants._LOGGER_VAR_WINDOW]&&window[a.Constants._LOGGER_VAR_WINDOW]._ENABLE_DEFAULT&&c.LoggerUtils.IsAllowedConsoleToLogBySeverity(t)){var n,r=console.log;a.Constants._Log_CONSOLE[t]&&(r=a.Constants._Log_CONSOLE[t]);for(var i=(new Date).toLocaleTimeString(),o=arguments.length,s=Array(o>2?o-2:0),u=2;u<o;u++)s[u-2]=arguments[u];(n=r).call.apply(n,[null,"["+i+"]["+t+"]["+e+"]"].concat(s))}}}]),e}());t.LoggerDispatcher=d},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0}),t.LoggerRestClient=void 0;var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),o=n(4),s=function(e){return e&&e.__esModule?e:{default:e}}(o),a=n(1),c=n(10),u=0,l=!0,h=function(){function e(){r(this,e)}return i(e,null,[{key:"log",value:function(e,t){if(window[a.Constants._LOGGER_VAR_WINDOW]._ENABLE_AJAX)if(0===window[a.Constants._LOGGER_VAR_WINDOW]._NUMBER_ATTEMP_POST||u<window[a.Constants._LOGGER_VAR_WINDOW]._NUMBER_ATTEMP_POST)try{for(var n=new URL(window[a.Constants._LOGGER_VAR_WINDOW]._SERVER),r=new URL(window[a.Constants._LOGGER_VAR_WINDOW]._DOMAIN,n),i=arguments.length,o=Array(i>2?i-2:0),h=2;h<i;h++)o[h-2]=arguments[h];var d=c.LoggerUtils.ToStringMessage(o);s.default.post(r,{UserType:e,Message:d,Severity:t}).then(function(){u=0}).catch(function(e){u++,console.warn("It was not possible to send the message server:",r,e)})}catch(e){u++,console.error("it was not possible to send the log message because an error ocurred servidor:"+window[a.Constants._LOGGER_VAR_WINDOW]._SERVER+" error:"+e+" recommendation: you could check the logger configuration")}else l&&(l=!1,console.warn("number of attempts to overcome Api web is necessary to check the configuration file for logger.json"))}}]),e}();t.LoggerRestClient=h},function(e,t,n){"use strict";function r(e){var t=new s(e),n=o(s.prototype.request,t);return i.extend(n,s.prototype,t),i.extend(n,t),n}var i=n(0),o=n(5),s=n(16),a=n(2),c=r(a);c.Axios=s,c.create=function(e){return r(i.merge(a,e))},c.Cancel=n(9),c.CancelToken=n(30),c.isCancel=n(8),c.all=function(e){return Promise.all(e)},c.spread=n(31),e.exports=c,e.exports.default=c},function(e,t){/*!
	 * Determine if an object is a Buffer
	 *
	 * @author   Feross Aboukhadijeh <https://feross.org>
	 * @license  MIT
	 */
	e.exports=function(e){return null!=e&&null!=e.constructor&&"function"==typeof e.constructor.isBuffer&&e.constructor.isBuffer(e)}},function(e,t,n){"use strict";function r(e){this.defaults=e,this.interceptors={request:new s,response:new s}}var i=n(2),o=n(0),s=n(25),a=n(26);r.prototype.request=function(e){"string"==typeof e&&(e=o.merge({url:arguments[0]},arguments[1])),e=o.merge(i,{method:"get"},this.defaults,e),e.method=e.method.toLowerCase();var t=[a,void 0],n=Promise.resolve(e);for(this.interceptors.request.forEach(function(e){t.unshift(e.fulfilled,e.rejected)}),this.interceptors.response.forEach(function(e){t.push(e.fulfilled,e.rejected)});t.length;)n=n.then(t.shift(),t.shift());return n},o.forEach(["delete","get","head","options"],function(e){r.prototype[e]=function(t,n){return this.request(o.merge(n||{},{method:e,url:t}))}}),o.forEach(["post","put","patch"],function(e){r.prototype[e]=function(t,n,r){return this.request(o.merge(r||{},{method:e,url:t,data:n}))}}),e.exports=r},function(e,t){function n(){throw new Error("setTimeout has not been defined")}function r(){throw new Error("clearTimeout has not been defined")}function i(e){if(l===setTimeout)return setTimeout(e,0);if((l===n||!l)&&setTimeout)return l=setTimeout,setTimeout(e,0);try{return l(e,0)}catch(t){try{return l.call(null,e,0)}catch(t){return l.call(this,e,0)}}}function o(e){if(h===clearTimeout)return clearTimeout(e);if((h===r||!h)&&clearTimeout)return h=clearTimeout,clearTimeout(e);try{return h(e)}catch(t){try{return h.call(null,e)}catch(t){return h.call(this,e)}}}function s(){g&&f&&(g=!1,f.length?p=f.concat(p):m=-1,p.length&&a())}function a(){if(!g){var e=i(s);g=!0;for(var t=p.length;t;){for(f=p,p=[];++m<t;)f&&f[m].run();m=-1,t=p.length}f=null,g=!1,o(e)}}function c(e,t){this.fun=e,this.array=t}function u(){}var l,h,d=e.exports={};!function(){try{l="function"==typeof setTimeout?setTimeout:n}catch(e){l=n}try{h="function"==typeof clearTimeout?clearTimeout:r}catch(e){h=r}}();var f,p=[],g=!1,m=-1;d.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];p.push(new c(e,t)),1!==p.length||g||i(a)},c.prototype.run=function(){this.fun.apply(null,this.array)},d.title="browser",d.browser=!0,d.env={},d.argv=[],d.version="",d.versions={},d.on=u,d.addListener=u,d.once=u,d.off=u,d.removeListener=u,d.removeAllListeners=u,d.emit=u,d.prependListener=u,d.prependOnceListener=u,d.listeners=function(e){return[]},d.binding=function(e){throw new Error("process.binding is not supported")},d.cwd=function(){return"/"},d.chdir=function(e){throw new Error("process.chdir is not supported")},d.umask=function(){return 0}},function(e,t,n){"use strict";var r=n(0);e.exports=function(e,t){r.forEach(e,function(n,r){r!==t&&r.toUpperCase()===t.toUpperCase()&&(e[t]=n,delete e[r])})}},function(e,t,n){"use strict";var r=n(7);e.exports=function(e,t,n){var i=n.config.validateStatus;n.status&&i&&!i(n.status)?t(r("Request failed with status code "+n.status,n.config,null,n.request,n)):e(n)}},function(e,t,n){"use strict";e.exports=function(e,t,n,r,i){return e.config=t,n&&(e.code=n),e.request=r,e.response=i,e}},function(e,t,n){"use strict";function r(e){return encodeURIComponent(e).replace(/%40/gi,"@").replace(/%3A/gi,":").replace(/%24/g,"$").replace(/%2C/gi,",").replace(/%20/g,"+").replace(/%5B/gi,"[").replace(/%5D/gi,"]")}var i=n(0);e.exports=function(e,t,n){if(!t)return e;var o;if(n)o=n(t);else if(i.isURLSearchParams(t))o=t.toString();else{var s=[];i.forEach(t,function(e,t){null!==e&&void 0!==e&&(i.isArray(e)?t+="[]":e=[e],i.forEach(e,function(e){i.isDate(e)?e=e.toISOString():i.isObject(e)&&(e=JSON.stringify(e)),s.push(r(t)+"="+r(e))}))}),o=s.join("&")}return o&&(e+=(-1===e.indexOf("?")?"?":"&")+o),e}},function(e,t,n){"use strict";var r=n(0),i=["age","authorization","content-length","content-type","etag","expires","from","host","if-modified-since","if-unmodified-since","last-modified","location","max-forwards","proxy-authorization","referer","retry-after","user-agent"];e.exports=function(e){var t,n,o,s={};return e?(r.forEach(e.split("\n"),function(e){if(o=e.indexOf(":"),t=r.trim(e.substr(0,o)).toLowerCase(),n=r.trim(e.substr(o+1)),t){if(s[t]&&i.indexOf(t)>=0)return;s[t]="set-cookie"===t?(s[t]?s[t]:[]).concat([n]):s[t]?s[t]+", "+n:n}}),s):s}},function(e,t,n){"use strict";var r=n(0);e.exports=r.isStandardBrowserEnv()?function(){function e(e){var t=e;return n&&(i.setAttribute("href",t),t=i.href),i.setAttribute("href",t),{href:i.href,protocol:i.protocol?i.protocol.replace(/:$/,""):"",host:i.host,search:i.search?i.search.replace(/^\?/,""):"",hash:i.hash?i.hash.replace(/^#/,""):"",hostname:i.hostname,port:i.port,pathname:"/"===i.pathname.charAt(0)?i.pathname:"/"+i.pathname}}var t,n=/(msie|trident)/i.test(navigator.userAgent),i=document.createElement("a");return t=e(window.location.href),function(n){var i=r.isString(n)?e(n):n;return i.protocol===t.protocol&&i.host===t.host}}():function(){return function(){return!0}}()},function(e,t,n){"use strict";var r=n(0);e.exports=r.isStandardBrowserEnv()?function(){return{write:function(e,t,n,i,o,s){var a=[];a.push(e+"="+encodeURIComponent(t)),r.isNumber(n)&&a.push("expires="+new Date(n).toGMTString()),r.isString(i)&&a.push("path="+i),r.isString(o)&&a.push("domain="+o),!0===s&&a.push("secure"),document.cookie=a.join("; ")},read:function(e){var t=document.cookie.match(new RegExp("(^|;\\s*)("+e+")=([^;]*)"));return t?decodeURIComponent(t[3]):null},remove:function(e){this.write(e,"",Date.now()-864e5)}}}():function(){return{write:function(){},read:function(){return null},remove:function(){}}}()},function(e,t,n){"use strict";function r(){this.handlers=[]}var i=n(0);r.prototype.use=function(e,t){return this.handlers.push({fulfilled:e,rejected:t}),this.handlers.length-1},r.prototype.eject=function(e){this.handlers[e]&&(this.handlers[e]=null)},r.prototype.forEach=function(e){i.forEach(this.handlers,function(t){null!==t&&e(t)})},e.exports=r},function(e,t,n){"use strict";function r(e){e.cancelToken&&e.cancelToken.throwIfRequested()}var i=n(0),o=n(27),s=n(8),a=n(2),c=n(28),u=n(29);e.exports=function(e){return r(e),e.baseURL&&!c(e.url)&&(e.url=u(e.baseURL,e.url)),e.headers=e.headers||{},e.data=o(e.data,e.headers,e.transformRequest),e.headers=i.merge(e.headers.common||{},e.headers[e.method]||{},e.headers||{}),i.forEach(["delete","get","head","post","put","patch","common"],function(t){delete e.headers[t]}),(e.adapter||a.adapter)(e).then(function(t){return r(e),t.data=o(t.data,t.headers,e.transformResponse),t},function(t){return s(t)||(r(e),t&&t.response&&(t.response.data=o(t.response.data,t.response.headers,e.transformResponse))),Promise.reject(t)})}},function(e,t,n){"use strict";var r=n(0);e.exports=function(e,t,n){return r.forEach(n,function(n){e=n(e,t)}),e}},function(e,t,n){"use strict";e.exports=function(e){return/^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(e)}},function(e,t,n){"use strict";e.exports=function(e,t){return t?e.replace(/\/+$/,"")+"/"+t.replace(/^\/+/,""):e}},function(e,t,n){"use strict";function r(e){if("function"!=typeof e)throw new TypeError("executor must be a function.");var t;this.promise=new Promise(function(e){t=e});var n=this;e(function(e){n.reason||(n.reason=new i(e),t(n.reason))})}var i=n(9);r.prototype.throwIfRequested=function(){if(this.reason)throw this.reason},r.source=function(){var e;return{token:new r(function(t){e=t}),cancel:e}},e.exports=r},function(e,t,n){"use strict";e.exports=function(e){return function(t){return e.apply(null,t)}}},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t,n){void 0===e[t]&&(console.info("file logger.json does not contain field [%s] set value default [%s]",t,n),e[t]=n)}Object.defineProperty(t,"__esModule",{value:!0}),t.LoggerConfigurator=void 0;var o=function(){function e(e,t){var n=[],r=!0,i=!1,o=void 0;try{for(var s,a=e[Symbol.iterator]();!(r=(s=a.next()).done)&&(n.push(s.value),!t||n.length!==t);r=!0);}catch(e){i=!0,o=e}finally{try{!r&&a.return&&a.return()}finally{if(i)throw o}}return n}return function(t,n){if(Array.isArray(t))return t;if(Symbol.iterator in Object(t))return e(t,n);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}(),s=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),a=n(1),c=n(4),u=function(e){return e&&e.__esModule?e:{default:e}}(c),l=!0,h=function(){function e(){r(this,e)}return s(e,null,[{key:"Init",value:function(t){l&&e.IsConfigurationNotAssigned()?(l=!1,e.GetByExecutionEnvironment(t)):t()}},{key:"Setup",value:function(t,n){if(console.info("Setup ",t),t){window[a.Constants._LOGGER_VAR_WINDOW]={};var r=!0,s=!1,c=void 0;try{for(var u,l=Object.entries(a.Constants._CONFIGURATIONS)[Symbol.iterator]();!(r=(u=l.next()).done);r=!0){var h=o(u.value,2),d=h[0],f=h[1];i(t,d,f)}}catch(e){s=!0,c=e}finally{try{!r&&l.return&&l.return()}finally{if(s)throw c}}Object.keys(t).forEach(function(e){return window[a.Constants._LOGGER_VAR_WINDOW][e]=t[e]}),window[a.Constants._LOGGER_VAR_WINDOW]._USE_WINDOW_ORIGIN&&e.SetConfigurationServer()}else window[a.Constants._LOGGER_VAR_WINDOW]=a.Constants._CONFIGURATIONS,console.info("Logger will use default configuration ... ",a.Constants._CONFIGURATIONS);n()}},{key:"GetByExecutionEnvironment",value:function(t){e.IsBrowser()?e.GetRemote(t):e.GetLocal(t)}},{key:"IsBrowser",value:function(){return!!window}},{key:"GetLocal",value:function(t){e.Setup(null,t)}},{key:"GetRemote",value:function(t){var n=""+window.location.origin+window.location.pathname,r=n.split("/");console.log("Remove Last element ",r.pop()),n=r.join("/")+"/",n+=a.Constants._LOGGER_CONFIGURATION_FILE_REMOTE,u.default.get(n,{responseType:"json"}).then(function(n){e.Setup(n.data,t)}).catch(function(n){console.error("It was not possible to get remote file configuration",n),e.Setup(null,t)})}},{key:"SetConfigurationServer",value:function(){if(window[a.Constants._LOGGER_VAR_WINDOW]._USE_WINDOW_ORIGIN){var e=window.location.hostname;if("127.0.0.1"!==e&&"localhost"!==e){var t=window.location.origin;console.debug("SetConfigurationServer withLocation",t),window[a.Constants._LOGGER_VAR_WINDOW]._SERVER=t}}}},{key:"ExistExternalConfiguration",value:function(e){return!!e}},{key:"IsConfigurationNotAssigned",value:function(){return!a.Constants._LOGGER_CONFIGURATION_ASSIGNED}}]),e}();t.LoggerConfigurator=h}])}()}("undefined"!=typeof self&&self)},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0}),t.RabbitStompWrapper=void 0;var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),o=n(5),s=n(7);t.RabbitStompWrapper=function(){function e(){r(this,e)}return i(e,[{key:"getRabbit",value:function(){var e=new s.StompWrapper;return new o.RabbitMQWebStomp(e)}}]),e}()},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(){return d&&o}Object.defineProperty(t,"__esModule",{value:!0}),t.RabbitMQWebStomp=void 0;var o,s,a,c=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),u=n(0),l=n(6),h=null,d=!1,f=1,p=3,g=5;t.RabbitMQWebStomp=function(){function e(t){return r(this,e),this.arrayTopics=[],s=t,h||(h=this,p=3,g=5),h}return c(e,[{key:"setFunctions",value:function(e){a=e}},{key:"setMaxAttemps",value:function(e){p=e}},{key:"setReconnectInterval",value:function(e){g=e}},{key:"connectToRabbit",value:function(){var e=this;if(!i()){if(this.arrayTopics&&this.arrayTopics.length>0)for(;this.arrayTopics.length>0;)this.arrayTopics.pop();o=s.getClient(a.mq_server,a.mq_port,a.mq_secureConnection,a.heartbeat),u.Logger.Info("Connecting to broker [  "+a.mq_server+" : "+a.mq_port+" ] "),o.connect(a.mq_username,a.mq_password,this.on_connect,function(t,n){return e.on_connect_error(t,n)},a.mq_vhost)}}},{key:"addTopics",value:function(e,t,n){if(i()&&this.verifiTopic(e,1)){var r=[e,t,n];this.arrayTopics.push(r)}}},{key:"subscribeTopics",value:function(e,t,n){if(i()&&this.verifiTopic(e,2)){var r=o.subscribe("/topic/"+e,t,{id:n});this.processTopicInfo(e,r),u.Logger.Debug("suscribe [ topic: "+e+", consumer: "+n+" ] ")}}},{key:"unsubscribeTopics",value:function(e){i()&&this.unsubscribeTopicsProcess(e)}},{key:"sendMessage",value:function(e,t){i()&&o.send("/topic/"+e,{"content-type":"text/plain",expiration:a.mq_expiration,priority:9},t)}},{key:"disconnectToRabbit",value:function(){if(i()){d=!1;var e=a.mq_server,t=a.mq_port;o.disconnect(function(){u.Logger.Info("Disconnecting from broker [  "+e+" : "+t+" ] ")})}}},{key:"processTopicInfo",value:function(e,t){for(var n in this.arrayTopics)this.arrayTopics.hasOwnProperty(n)&&this.arrayTopics[n][0]===e&&(this.arrayTopics[n][l.ARRAY_INDEX.OBJ_TOPIC]=t)}},{key:"verifiTopic",value:function(e,t){var n=!0;return this.arrayTopics.length>0&&(n=this.verifiTopicValidation(e,t)),n}},{key:"verifiTopicValidation",value:function(e,t){var n=!0;if(1===t)for(var r in this.arrayTopics)this.arrayTopics[r][l.ARRAY_INDEX.TOPIC]===e&&(n=!1);else for(var i in this.arrayTopics)if(this.arrayTopics[i][l.ARRAY_INDEX.TOPIC]===e&&this.arrayTopics[i][l.ARRAY_INDEX.OBJ_TOPIC]){n=!1;break}return n}},{key:"unsubscribeTopicsProcess",value:function(e){for(var t in this.arrayTopics)if(this.arrayTopics[t][l.ARRAY_INDEX.TOPIC]===e){this.arrayTopics[t][l.ARRAY_INDEX.OBJ_TOPIC]&&(this.arrayTopics[t][l.ARRAY_INDEX.OBJ_TOPIC].unsubscribe(),this.arrayTopics[t][l.ARRAY_INDEX.OBJ_TOPIC]=void 0,u.Logger.Debug("unsuscribe [ topic: "+e+" ] "));break}}},{key:"on_connect",value:function(){if(this.arrayTopics&&this.arrayTopics.length>0)for(var e in this.arrayTopics)this.arrayTopics.hasOwnProperty(e)&&this.subscribeTopics(this.arrayTopics[e][0],this.arrayTopics[e][1],this.arrayTopics[e][2]);d=!0,u.Logger.Debug("Connect",this.arrayTopics),f=1,a.onConnected()}},{key:"on_connect_error",value:function(e,t){u.Logger.Warn("on_connect_error",e,t),o.disconnect(function(){console.log("Disconnect")}),d&&this.tryingReconnection(),d=!1}},{key:"tryingReconnection",value:function(){var e=this;u.Logger.Debug("Reconnecting attempt",f),o=s.getClient(a.mq_server,a.mq_port,a.mq_secureConnection,a.heartbeat),o.connect(a.mq_username,a.mq_password,function(){if(!d){if(d=!0,f=1,e.arrayTopics&&e.arrayTopics.length>0)for(var t in e.arrayTopics)e.arrayTopics.hasOwnProperty(t)&&o.subscribe("/topic/"+e.arrayTopics[t][0],e.arrayTopics[t][1],{id:e.arrayTopics[t][2]});a.onReconnected()}},function(t,n){if(u.Logger.Info("tryingReconnection",t,n),f>p){if(o.disconnect(function(){u.Logger.Error("Disconnect Number Attemps",t,n)}),d=!1,a.onDisconnected(),e)for(;e.arrayTopics.length>0;)e.arrayTopics.pop()}else d||(f++,d=!0,f<=p&&u.Logger.Trace("Trying to reconnect in "+g+" sec..."),setTimeout(function(){return e.on_connect_error(t,n)},1e3*g))},a.mq_vhost,function(t,n){return e.on_connect_error(t,n)})}}]),e}()},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.ARRAY_INDEX={TOPIC:0,CALLBACK:1,CONSUMER:2,OBJ_TOPIC:3}},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0}),t.StompWrapper=void 0;var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),o=n(8);t.StompWrapper=function(){function e(){r(this,e)}return i(e,[{key:"getClient",value:function(e,t){var n=arguments.length>2&&void 0!==arguments[2]&&arguments[2],r=arguments.length>3&&void 0!==arguments[3]?arguments[3]:{outgoing:1e4,incoming:1e4},i=n?"wss":"ws",s=new WebSocket(i+"://"+e+":"+t+"/ws");return o.Stomp.over(s,r)}}]),e}()},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}();(function(){var e,n,o,s,a={}.hasOwnProperty,c=[].slice;e={LF:"\n",NULL:"\0"},o=function(){function t(e,t,n){this.command=e,this.headers=null!=t?t:{},this.body=null!=n?n:""}var n;return t.prototype.toString=function(){var n,r,i,o,s;n=[this.command],i=!1===this.headers["content-length"],i&&delete this.headers["content-length"],s=this.headers;for(r in s)a.call(s,r)&&(o=s[r],n.push(r+":"+o));return this.body&&!i&&n.push("content-length:"+t.sizeOfUTF8(this.body)),n.push(e.LF+this.body),n.join(e.LF)},t.sizeOfUTF8=function(e){return e?encodeURI(e).match(/%..|./g).length:0},n=function(n){var r,i,o,s,a,c,u,l,h,d,f,p,g,m,v,T,y;for(s=n.search(RegExp(""+e.LF+e.LF)),a=n.substring(0,s).split(e.LF),o=a.shift(),c={},p=function(e){return e.replace(/^\s+|\s+$/g,"")},T=a.reverse(),g=0,v=T.length;g<v;g++)d=T[g],l=d.indexOf(":"),c[p(d.substring(0,l))]=p(d.substring(l+1));if(r="",f=s+2,c["content-length"])h=parseInt(c["content-length"]),r=(""+n).substring(f,f+h);else for(i=null,u=m=f,y=n.length;(f<=y?m<y:m>y)&&(i=n.charAt(u))!==e.NULL;u=f<=y?++m:--m)r+=i;return new t(o,c,r)},t.unmarshall=function(t){var r,i,o,s;return i=t.split(RegExp(""+e.NULL+e.LF+"*")),s={frames:[],partial:""},s.frames=function(){var e,t,o,s;for(o=i.slice(0,-1),s=[],e=0,t=o.length;e<t;e++)r=o[e],s.push(n(r));return s}(),o=i.slice(-1)[0],o===e.LF||-1!==o.search(RegExp(""+e.NULL+e.LF+"*$"))?s.frames.push(n(o)):s.partial=o,s},t.marshall=function(n,r,i){var o;return o=new t(n,r,i),o.toString()+e.NULL},t}(),n=function(){var t,n=function(){function n(e,t){r(this,n),this.ws=e,this.ws.binaryType="arraybuffer",this.counter=0,this.connected=!1,this.heartbeat=t||{outgoing:1e4,incoming:1e4},this.maxWebSocketFrameSize=16384,this.subscriptions={},this.partialData=""}return i(n,[{key:"debug",value:function(e){var t;return"undefined"!=typeof window&&null!==window&&null!=(t=window.console)?t.log(e):void 0}},{key:"Warn",value:function(e){var t;return"undefined"!=typeof window&&null!==window&&null!=(t=window.console)?t.log(e):void 0}},{key:"_transmit",value:function(e,t,n){var r;for(r=o.marshall(e,t,n),"function"==typeof this.debug&&this.debug(">>> "+r.replace(/[^ -~]+/g,"   "));;){if(!(r.length>this.maxWebSocketFrameSize))return this.ws.send(r);this.ws.send(r.substring(0,this.maxWebSocketFrameSize)),r=r.substring(this.maxWebSocketFrameSize),"function"==typeof this.debug&&this.debug("remaining = "+r.length)}}},{key:"_setupHeartbeat",value:function(n){var r,i,o,a,c,u;if((c=n.version)===s.VERSIONS.V1_1||c===s.VERSIONS.V1_2)return u=function(){var e,t,r,i;for(r=n["heart-beat"].split(","),i=[],e=0,t=r.length;e<t;e++)a=r[e],i.push(parseInt(a));return i}(),i=u[0],r=u[1],0!==this.heartbeat.outgoing&&0!==r&&(o=Math.max(this.heartbeat.outgoing,r),"function"==typeof this.debug&&this.debug("send PING every "+o+"ms"),this.pinger=s.setInterval(o,function(t){return function(){return t.ws.send(e.LF),"function"==typeof t.debug?t.debug(">>> PING"):void 0}}(this))),0!==this.heartbeat.incoming&&0!==i?(o=Math.max(this.heartbeat.incoming,i),"function"==typeof this.debug&&this.debug("check PONG every "+o+"ms"),this.ponger=s.setInterval(o,function(e){return function(){var n;if((n=t()-e.serverActivity)>2*o)return"function"==typeof e.debug&&e.debug("did not receive server activity for the last "+n+"ms"),e.ws.close()}}(this))):void 0}},{key:"_parseConnect",value:function(){var e,t,n,r,i;switch(e=1<=arguments.length?c.call(arguments,0):[],r={},e.length){case 2:r=e[0],t=e[1];break;case 3:e[1]instanceof Function?(r=e[0],t=e[1],n=e[2]):(r.login=e[0],r.passcode=e[1],t=e[2]);break;case 4:r.login=e[0],r.passcode=e[1],t=e[2],n=e[3];break;case 5:r.login=e[0],r.passcode=e[1],t=e[2],n=e[3],r.host=e[4];default:r.login=e[0],r.passcode=e[1],t=e[2],n=e[3],r.host=e[4],i=e[5]}return[r,t,n,i]}},{key:"connect",value:function(){var n,r,i,a,u;return n=1<=arguments.length?c.call(arguments,0):[],a=this._parseConnect.apply(this,n),i=a[0],this.connectCallback=a[1],r=a[2],u=a[3],"function"==typeof this.debug&&this.debug("Opening Web Socket..."+this.ws),this.ws.onerror=function(e){return function(t){var n;return n="onerror "+e.ws.url+" code:"+t.code+", reason:"+t.reason,console.warn(n,t),"function"==typeof e.debug&&e.Warn(n,t),e._cleanUp(),"function"==typeof r?r(n,t):void 0}}(this),this.ws.onmessage=function(n){return function(i){var s,a,c,u,l,h,d,f,p,g,m,v,T;if(u="undefined"!=typeof ArrayBuffer&&i.data instanceof ArrayBuffer?(s=new Uint8Array(i.data),"function"==typeof n.debug&&n.debug("--- got data length: "+s.length),function(){var e,t,n;for(n=[],e=0,t=s.length;e<t;e++)a=s[e],n.push(String.fromCharCode(a));return n}().join("")):i.data,n.serverActivity=t(),u===e.LF)return void("function"==typeof n.debug&&n.debug("<<< PONG"));for("function"==typeof n.debug&&n.debug("<<< "+u.replace(/[^ -~]+/g,"   ")),p=o.unmarshall(n.partialData+u),n.partialData=p.partial,v=p.frames,T=[],g=0,m=v.length;g<m;g++)switch(l=v[g],l.command){case"CONNECTED":"function"==typeof n.debug&&(n.debug("connected to server "+l.headers.server),sessionStorage.setItem("connected","true")),n.connected=!0,n._setupHeartbeat(l.headers),T.push("function"==typeof n.connectCallback?n.connectCallback(l):void 0);break;case"MESSAGE":f=l.headers.subscription,d=n.subscriptions[f]||n.onreceive,d?(c=n,h=l.headers["message-id"],l.ack=function(e){return null==e&&(e={}),c.ack(h,f,e)},l.nack=function(e){return null==e&&(e={}),c.nack(h,f,e)},T.push(d(l))):T.push("function"==typeof n.debug?n.debug("Unhandled received MESSAGE: "+l):void 0);break;case"RECEIPT":T.push("function"==typeof n.onreceipt?n.onreceipt(l):void 0);break;case"ERROR":T.push("function"==typeof r?r(l):void 0);break;default:T.push("function"==typeof n.debug?n.debug("Unhandled frame: "+l):void 0)}return T}}(this),this.ws.onclose=function(e){return function(t){var n;return n="Whoops! Lost connection to "+e.ws.url+" code:"+t.code+", reason:"+t.reason,"function"==typeof e.debug&&e.Warn(n,t),e._cleanUp(),"function"==typeof r?r(n,t):void 0}}(this),this.ws.onopen=function(e){return function(){return r="function"==typeof u?u:r,"function"==typeof e.debug&&e.debug("Web Socket Opened..."),i["accept-version"]=s.VERSIONS.supportedVersions(),i["heart-beat"]=[e.heartbeat.outgoing,e.heartbeat.incoming].join(","),e._transmit("CONNECT",i)}}(this)}},{key:"disconnect",value:function(e,t){return null==t&&(t={}),this._transmit("DISCONNECT",t),this.ws.onclose=null,this.ws.close(),this._cleanUp(),"function"==typeof e?e():void 0}},{key:"_cleanUp",value:function(){if(this.connected=!1,this.pinger&&s.clearInterval(this.pinger),this.ponger)return s.clearInterval(this.ponger)}},{key:"send",value:function(e,t,n){return null==t&&(t={}),null==n&&(n=""),t.destination=e,this._transmit("SEND",t,n)}},{key:"subscribe",value:function(e,t,n){var r;return null==n&&(n={}),n.id||(n.id="sub-"+this.counter++),n.destination=e,this.subscriptions[n.id]=t,this._transmit("SUBSCRIBE",n),r=this,{id:n.id,unsubscribe:function(){return r.unsubscribe(n.id)}}}},{key:"unsubscribe",value:function(e){return delete this.subscriptions[e],this._transmit("UNSUBSCRIBE",{id:e})}},{key:"begin",value:function(e){var t,n;return n=e||"tx-"+this.counter++,this._transmit("BEGIN",{transaction:n}),t=this,{id:n,commit:function(){return t.commit(n)},abort:function(){return t.abort(n)}}}},{key:"commit",value:function(e){return this._transmit("COMMIT",{transaction:e})}},{key:"abort",value:function(e){return this._transmit("ABORT",{transaction:e})}},{key:"ack",value:function(e,t,n){return null==n&&(n={}),n["message-id"]=e,n.subscription=t,this._transmit("ACK",n)}},{key:"nack",value:function(e,t,n){return null==n&&(n={}),n["message-id"]=e,n.subscription=t,this._transmit("NACK",n)}}]),n}();return t=function(){return Date.now?Date.now():(new Date).valueOf},n}(),s={VERSIONS:{V1_0:"1.0",V1_1:"1.1",V1_2:"1.2",supportedVersions:function(){return"1.1,1.0"}},client:function(e,t){var r,i;return null==t&&(t=["v10.stomp","v11.stomp"]),r=s.WebSocketClass||WebSocket,i=new r(e,t),new n(i)},over:function(e,t){return new n(e,t)},Frame:o},void 0!==t&&null!==t&&(t.Stomp=s),"undefined"!=typeof window&&null!==window?(s.setInterval=function(e,t){return window.setInterval(t,e)},s.clearInterval=function(e){return window.clearInterval(e)},window.Stomp=s):t||(self.Stomp=s)}).call(void 0)},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0}),t.RabbitMqttWrapper=void 0;var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),o=n(10),s=n(11);t.RabbitMqttWrapper=function(){function e(){r(this,e)}return i(e,[{key:"getRabbit",value:function(){return new o.rabbitMQTT(new s.MqttWrapper)}}]),e}()},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(){return h&&c&&c.isConnected()}Object.defineProperty(t,"__esModule",{value:!0}),t.rabbitMQTT=void 0;var o=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),s=n(0),a=null,c=null,u=void 0,l=null,h=!1,d=0,f=3,p=5,g=!1,m=null;t.rabbitMQTT=function(){function e(t){return r(this,e),this.arrayTopics={},u=t,a||(a=this,f=3,p=5),a}return o(e,[{key:"setFunctions",value:function(e){l=e}},{key:"setMaxAttemps",value:function(e){f=e}},{key:"setReconnectInterval",value:function(e){p=e}},{key:"addTopics",value:function(e){this.arrayTopics&&!this.arrayTopics[e]&&(this.arrayTopics[e]=e)}},{key:"connectToRabbit",value:function(){i()?s.Logger.Info("Is Connected rabbit [  "+l.mq_server+" : "+l.mq_port+" ] "):(g||(this.arrayTopics=[]),d=0,this.createClient())}},{key:"subscribeTopics",value:function(e){i()&&this.verifiTopic(e)&&(c.subscribe(e,{qos:1}),this.processTopicInfo(e),s.Logger.Debug("suscribe [ topic: "+e+"]"))}},{key:"unsubscribeTopics",value:function(e){i()&&this.unsubscribeTopicsProcess(e)}},{key:"sendMessage",value:function(e,t){if(i()){var n=window.Paho.MQTT,r=new n.Message(t);r.destinationName=e,c.send(r)}}},{key:"disconnectToRabbit",value:function(){i()&&(h=!1,s.Logger.Info("Disconnect to broker [  "+l.mq_server+" : "+l.mq_port+" ] "),c.disconnect()),m&&clearTimeout(m),h=!1}},{key:"tryingReconnection",value:function(){s.Logger.Debug("Reconnecting attempt",d),a.createClient()}},{key:"processTopicInfo",value:function(e){this.addTopics(e)}},{key:"unsubscribeTopicsProcess",value:function(e){this.verifiTopic(e)&&(delete this.arrayTopics[e],c.unsubscribe(e),s.Logger.Debug("unsuscribe [ topic: "+e+" ] "))}},{key:"verifiTopic",value:function(e){return this.arrayTopics&&this.arrayTopics[e]}},{key:"createClient",value:function(){var e=this;c=u.getClient(l.mq_server,l.mq_port,l.mq_consumer),s.Logger.Info("Connecting to broker [  "+l.mq_server+" : "+l.mq_port+" ] attemptConnect:",d),c.onConnectionLost=this.on_connect_error,c.onMessageArrived=function(e){l.onMessage({topic:e.destinationName,body:e.payloadString})};var t={userName:l.mq_username,password:l.mq_password,timeout:l.timeoutMqtt||3,keepAliveInterval:l.keepAliveInterval||30,onSuccess:this.on_connect,onFailure:function(t){return e.on_connect_error(t)}};l.mq_secureConnection&&(t.useSSL=!0),c.connect(t)}},{key:"on_connect",value:function(){if(a.arrayTopics)for(var e in a.arrayTopics)a.subscribeTopics(e);h=!0,d=1,g?(s.Logger.Trace("onReconnected",a.arrayTopics),l.onReconnected()):(s.Logger.Debug("onConnected",a.arrayTopics),l.onConnected())}},{key:"on_connect_error",value:function(e){0!=e.errorCode?(s.Logger.Warn("on_connect_error",e),g=!0,d>f?(s.Logger.Error("Disconnect Number Attemps",e),l.onDisconnected(e),this.arrayTopics=[],h=!1,c=null,g=!1):c&&(d++,h=!0,s.Logger.Trace("Trying to reconnect in "+p+" sec..."),m=setTimeout(function(){return a.tryingReconnection()},1e3*p))):(h=!1,c=null,g=!1)}}]),e}()},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}();t.MqttWrapper=function(){function e(){r(this,e)}return i(e,[{key:"getClient",value:function(e,t,n){n||(n="clientName");var r=n+"_"+100*Math.random();return new window.Paho.MQTT.Client(e,t,"/ws",r)}}]),e}()},function(e,t){e.exports={name:"global-message-queue-client-js",version:"2022.0.1",description:"Exposes services that allows creation of Message Queue Clients over Javascript.",main:"index.js",scripts:{test:"jest --coverage",debug:"node --debug-brk --inspect ./node_modules/.bin/jest -i",sonarScanner:"node sonarqube-scanner.js Global_Cipher_Services_JS_DEV","sonarScanner:release":"node sonarqube-scanner.js Global_Cipher_Services_JS_RELEASE"},author:"Copyright © 2022 Nuxiba Technologies Inc. All Rights Reserved.",license:"ISC",devDependencies:{"babel-core":"^6.25.0","babel-jest":"^23.6.0","babel-loader":"^7.1.1","babel-preset-es2015":"^6.24.1","babel-preset-stage-0":"^6.24.1",jest:"^23.6.0","jest-html-reporter":"^2.6.0",webpack:"^3.12.0","webpack-auto-inject-version":"^1.2.2","sonarqube-scanner":"^2.8.2"},dependencies:{"global-logger-services-js":"git+ssh://git@bitbucket.org/nuxibatechnologies/global-logger-services-js.git","babel-plugin-transform-class-properties":"^6.24.1",mqtt:"^4.2.6"}}}])})},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0}),t.SoftphoneWrapper=void 0;var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),o=n(7);t.SoftphoneWrapper=function(){function e(){r(this,e)}return i(e,[{key:"getSoftphone",value:function(e){return(new o.SoftphoneFactory).buildClient(e)}}]),e}()},function(e,t,n){!function(t,n){e.exports=n()}("undefined"!=typeof self&&self,function(){return function(e){function t(r){if(n[r])return n[r].exports;var i=n[r]={i:r,l:!1,exports:{}};return e[r].call(i.exports,i,i.exports,t),i.l=!0,i.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=4)}([function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0}),t.Logger=void 0;var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),o=n(6);o.LoggerInstance.setApplication("SIP");var s=(t.Logger=function(){function e(){r(this,e)}return i(e,null,[{key:"setUserType",value:function(e){o.LoggerInstance.setUsertype(e)}},{key:"setUserId",value:function(e){o.LoggerInstance.setUserId(e)}},{key:"Group",value:function(e){o.LoggerInstance.Group(e)}},{key:"GroupEnd",value:function(){o.LoggerInstance.GroupEnd()}},{key:"Trace",value:function(){for(var e=arguments.length,t=Array(e),n=0;n<e;n++)t[n]=arguments[n];o.LoggerInstance.Trace(["[SIP]"].concat(t))}},{key:"Debug",value:function(){for(var e=arguments.length,t=Array(e),n=0;n<e;n++)t[n]=arguments[n];o.LoggerInstance.Debug(["[SIP]"].concat(t))}},{key:"Warning",value:function(){for(var e=arguments.length,t=Array(e),n=0;n<e;n++)t[n]=arguments[n];o.LoggerInstance.Warning(["[SIP]"].concat(t))}},{key:"Warn",value:function(){for(var e=arguments.length,t=Array(e),n=0;n<e;n++)t[n]=arguments[n];o.LoggerInstance.Warning(["[SIP]"].concat(t))}},{key:"Info",value:function(){for(var e=arguments.length,t=Array(e),n=0;n<e;n++)t[n]=arguments[n];o.LoggerInstance.Info(["[SIP]"].concat(t))}},{key:"Error",value:function(){for(var e=arguments.length,t=Array(e),n=0;n<e;n++)t[n]=arguments[n];o.LoggerInstance.Error(["[SIP]"].concat(t))}},{key:"setLocalLogger",value:function(e){o.LoggerInstance.setLocalLogger(e)}},{key:"setLocalStorageTime",value:function(e){o.LoggerInstance.setLocalStorageTime(e)}},{key:"LevelConsole",get:function(){var e=o.LoggerInstance.LevelConsole.toLowerCase();return console.log("SipJs",s[e],e),s.trace}}]),e}(),{trace:3,debug:2,info:1,warn:1,error:0})},function(e,t){var n;n=function(){return this}();try{n=n||Function("return this")()||(0,eval)("this")}catch(e){"object"==typeof window&&(n=window)}e.exports=n},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.DTMF_TONES_PATH="sounds/100ms/",t.DTMF_TONES_EXTENSION=".wav",t.DTMF_TONES_STAR="s",t.DTMF_TONES_POUND="p",t.SYMBOL_STAR="*",t.SYMBOL_POUND="#",t.DTMF_TYPE_RFC2833=1,t.DTMF_TYPE_SIPINFO=2,t.DTMF_TYPE_INBAND=4,t.DEFAULT_CALLTIMEOUT=13},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.MEDIA_CONSTRAINT={audio:!0,video:!1},t.FILTER_LOG=["sip.ua"," sip.registercontext"]},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0}),t.SoftphoneFactory=void 0;var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),o=n(5),s=n(7),a=n(8),c=n(51),u=n(0),l=n(53);t.SoftphoneFactory=function(){function e(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"AGENT";r(this,e),u.Logger.setUserType(t)}return i(e,[{key:"buildClient",value:function(e){if(u.Logger.Info("Version ",l.version),5===e){var t=new c.MizuJSWrapper;return new s.MizuJSClient(t.getSoftphone())}var n=new a.WebRTCWrapper;return new o.WebRTCClient(n.getSoftphone())}},{key:"setLocalLogger",value:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:120;u.Logger.setLocalLogger(e),u.Logger.setLocalStorageTime(t)}}]),e}()},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0}),t.WebRTCClient=void 0;var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),o=n(0),s=n(2),a=null;t.WebRTCClient=function(){function e(t){return r(this,e),a||(o.Logger.Trace("WebRTCClient Init SipClient constructor ..."),this.sipJS=t,a=this,this.initEvents(),this.initServerParameters(),this.initExtraParameters()),a}return i(e,[{key:"setUserId",value:function(e){o.Logger.setUserId(e)}},{key:"initEvents",value:function(){this.SIPParameter={};var e={onSipAccepted:function(){console.log("Stack")},onSipRejected:function(){console.log("Stack")},onCallEntry:function(){console.log("Stack")},uiCallTerminated:function(){console.log("Stack")},onCallAnswered:function(){console.log("Stack")},onCallRejected:function(){console.log("Stack")},onChangeDeviceList:function(){console.log("Stack")},onGetStreamMicFail:function(){console.log("Stack")},onTransportDisconnected:function(){console.log("Stack")},onTransportConnected:function(){console.log("Stack")},onDataStreamInfo:function(e,t){console.log("Stack",e,t)}};this.updateSipParameters(e)}},{key:"initServerParameters",value:function(){var e={SIP_uri:"",SIP_wsServers:"",SIP_wsServerMaxReconnection:"",SIP_wsServerReconnectionTimeout:"",SIP_authorizationUser:"",SIP_password:"",SIP_register:""};this.updateSipParameters(e)}},{key:"initExtraParameters",value:function(){var e={SIP_iceCheckingTimeout:"",SIP_stunServers:"",SIP_userAgentString:"",SIP_traceSip:"",SIP_builtinEnabled:"",SIP_level:"",SIP_CNF_XD:"",SIP_KAMAILIO:"",SIP_DTMF_Type:s.DTMF_TYPE_RFC2833,SIP_callTimeout:s.DEFAULT_CALLTIMEOUT};this.updateSipParameters(e)}},{key:"setParametersSofPhone",value:function(e){console.log("setParametersSofPhone",e)}},{key:"updateSipParameters",value:function(e){var t=this;Object.keys(e).forEach(function(n){return t.SIPParameter[n]=e[n]})}},{key:"setParamter",value:function(){this.sipJS.setParamter(this.SIPParameter)}},{key:"conectSip",value:function(e,t){this.setParamter(),this.sipJS.createSIPStack(e),this.sipJS.initSip(t)}},{key:"reconnectMic",value:function(){this.sipJS.startMic()}},{key:"makeCall",value:function(e){this.sipJS.sipCall(e)}},{key:"hangUp",value:function(){this.sipJS.sipHangUp()}},{key:"mute",value:function(e){this.sipJS.sipToggleMute(e)}},{key:"hold",value:function(){this.sipJS.sipToggleHoldResume()}},{key:"volumeSpeaker",value:function(e){this.sipJS.volumeSpeaker(e)}},{key:"volumeSpeakerGet",value:function(){return this.sipJS.getSpkrVol()}},{key:"volumeMicrophone",value:function(e){this.sipJS.volumeMicrophone(e)}},{key:"volumeMicrophoneGet",value:function(){return this.sipJS.getMicVol()}},{key:"dtmf",value:function(e){this.sipJS.sipDTMF(e)}}]),e}()},function(e,t,n){!function(t,n){e.exports=function(){return function(e){function t(r){if(n[r])return n[r].exports;var i=n[r]={i:r,l:!1,exports:{}};return e[r].call(i.exports,i,i.exports,t),i.l=!0,i.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=3)}([function(e,t,n){"use strict";function r(e){return"[object Array]"===b.call(e)}function i(e){return"[object ArrayBuffer]"===b.call(e)}function o(e){return"undefined"!=typeof FormData&&e instanceof FormData}function s(e){return"undefined"!=typeof ArrayBuffer&&ArrayBuffer.isView?ArrayBuffer.isView(e):e&&e.buffer&&e.buffer instanceof ArrayBuffer}function a(e){return"string"==typeof e}function c(e){return"number"==typeof e}function u(e){return void 0===e}function l(e){return null!==e&&"object"==typeof e}function h(e){return"[object Date]"===b.call(e)}function d(e){return"[object File]"===b.call(e)}function f(e){return"[object Blob]"===b.call(e)}function p(e){return"[object Function]"===b.call(e)}function g(e){return l(e)&&p(e.pipe)}function m(e){return"undefined"!=typeof URLSearchParams&&e instanceof URLSearchParams}function v(e){return e.replace(/^\s*/,"").replace(/\s*$/,"")}function T(){return("undefined"==typeof navigator||"ReactNative"!==navigator.product)&&"undefined"!=typeof window&&"undefined"!=typeof document}function y(e,t){if(null!==e&&void 0!==e)if("object"!=typeof e&&(e=[e]),r(e))for(var n=0,i=e.length;n<i;n++)t.call(null,e[n],n,e);else for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&t.call(null,e[o],o,e)}function _(){function e(e,n){"object"==typeof t[n]&&"object"==typeof e?t[n]=_(t[n],e):t[n]=e}for(var t={},n=0,r=arguments.length;n<r;n++)y(arguments[n],e);return t}function S(e,t,n){return y(t,function(t,r){e[r]=n&&"function"==typeof t?E(t,n):t}),e}var E=n(5),C=n(15),b=Object.prototype.toString;e.exports={isArray:r,isArrayBuffer:i,isBuffer:C,isFormData:o,isArrayBufferView:s,isString:a,isNumber:c,isObject:l,isUndefined:u,isDate:h,isFile:d,isBlob:f,isFunction:p,isStream:g,isURLSearchParams:m,isStandardBrowserEnv:T,forEach:y,merge:_,extend:S,trim:v}},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var i=null,o=t.Constants=function e(){r(this,e),i||(i=this)};o._LOGGER_VAR_WINDOW="NuxibaLogger",o._LOGGER_CONFIGURATION_FILE_LOCALE="./logger.json",o._LOGGER_CONFIGURATION_FILE_REMOTE="logger.json",o._LOGGER_CONFIGURATION_FILE_ENCODE="utf8",o._LOGGER_CONFIGURATION_ASSIGNED=!!window[o._LOGGER_VAR_WINDOW],o._LOG_LEVELS={TRACE:{logLevel:0},DEBUG:{logLevel:1},INFO:{logLevel:2},WARN:{logLevel:3},ERROR:{logLevel:4}},o._Log_CONSOLE={TRACE:console.log,DEBUG:console.log,INFO:console.info,WARN:console.warn,ERROR:console.error},o._CONFIGURATIONS={_ENABLE_DEFAULT:!0,_ENABLE_AJAX:!1,_USE_WINDOW_ORIGIN:!0,_SERVER:"http://127.0.0.1",_DOMAIN:"/LoggerWS/api/Logger",_SEVERITY:"INFO",_SEVERITY_CONSOLE:"INFO",_NUMBER_ATTEMP_POST:10,_FILTER_USER_POST:[],_FILTER_APP_POST:[]},o._REST={_POST_METHOD:"POST",_MODE:"cors",_CONTENT_TYPE:"content-type",_APPLICATION_JSON:"application/json"}},function(e,t,n){"use strict";(function(t){function r(e,t){!i.isUndefined(e)&&i.isUndefined(e["Content-Type"])&&(e["Content-Type"]=t)}var i=n(0),o=n(18),s={"Content-Type":"application/x-www-form-urlencoded"},a={adapter:function(){var e;return"undefined"!=typeof XMLHttpRequest?e=n(6):void 0!==t&&(e=n(6)),e}(),transformRequest:[function(e,t){return o(t,"Content-Type"),i.isFormData(e)||i.isArrayBuffer(e)||i.isBuffer(e)||i.isStream(e)||i.isFile(e)||i.isBlob(e)?e:i.isArrayBufferView(e)?e.buffer:i.isURLSearchParams(e)?(r(t,"application/x-www-form-urlencoded;charset=utf-8"),e.toString()):i.isObject(e)?(r(t,"application/json;charset=utf-8"),JSON.stringify(e)):e}],transformResponse:[function(e){if("string"==typeof e)try{e=JSON.parse(e)}catch(e){}return e}],timeout:0,xsrfCookieName:"XSRF-TOKEN",xsrfHeaderName:"X-XSRF-TOKEN",maxContentLength:-1,validateStatus:function(e){return e>=200&&e<300}};a.headers={common:{Accept:"application/json, text/plain, */*"}},i.forEach(["delete","get","head"],function(e){a.headers[e]={}}),i.forEach(["post","put","patch"],function(e){a.headers[e]=i.merge(s)}),e.exports=a}).call(t,n(17))},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0}),t.LoggerInstance=void 0;var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),o=n(12),s=n(1),a=n(11),c="AGENT",u="",l="",h=function(){function e(){r(this,e)}return i(e,null,[{key:"setUsertype",value:function(e){c=e}},{key:"setUserId",value:function(e){u=e}},{key:"getUserId",value:function(){return u}},{key:"setApplication",value:function(e){l=e}},{key:"setLocalLogger",value:function(e){a.LoggerLocal.setEnabled(e)}},{key:"setLocalStorageTime",value:function(e){a.LoggerLocal.setStorageTimeMin(e)}},{key:"getApplication",value:function(){return l}},{key:"SetUseServerWithLocation",value:function(e){window[s.Constants._LOGGER_VAR_WINDOW]._USE_WINDOW_LOCATION=e}},{key:"addUserId",value:function(e){if(u){var t="[UserId:"+u+"]";e.unshift(t)}}},{key:"Group",value:function(e){console.group(e)}},{key:"GroupEnd",value:function(){console.groupEnd()}},{key:"CleanLocalLog",value:function(){a.LoggerLocal.Clean()}},{key:"Trace",value:function(){for(var e=arguments.length,t=Array(e),n=0;n<e;n++)t[n]=arguments[n];o.LoggerDispatcher.Dispatch(c,"Trace",["[UserId:"+u+"]"].concat(t))}},{key:"Debug",value:function(){for(var t=arguments.length,n=Array(t),r=0;r<t;r++)n[r]=arguments[r];e.addUserId(n),o.LoggerDispatcher.Dispatch(c,"Debug",["[UserId:"+u+"]"].concat(n))}},{key:"Warning",value:function(){for(var t=arguments.length,n=Array(t),r=0;r<t;r++)n[r]=arguments[r];e.addUserId(n),o.LoggerDispatcher.Dispatch(c,"Warn",["[UserId:"+u+"]"].concat(n))}},{key:"Warn",value:function(){for(var t=arguments.length,n=Array(t),r=0;r<t;r++)n[r]=arguments[r];e.Warning(n)}},{key:"Info",value:function(){for(var t=arguments.length,n=Array(t),r=0;r<t;r++)n[r]=arguments[r];e.addUserId(n),o.LoggerDispatcher.Dispatch(c,"Info",["[UserId:"+u+"]"].concat(n))}},{key:"Error",value:function(){for(var t=arguments.length,n=Array(t),r=0;r<t;r++)n[r]=arguments[r];e.addUserId(n),o.LoggerDispatcher.Dispatch(c,"Error",["[UserId:"+u+"]"].concat(n))}},{key:"JsWarning",value:function(){for(var t=arguments.length,n=Array(t),r=0;r<t;r++)n[r]=arguments[r];e.addUserId(n),o.LoggerDispatcher.Dispatch(c,"Warn",["[UserId:"+u+"]"].concat(n),!0)}},{key:"JsError",value:function(){for(var t=arguments.length,n=Array(t),r=0;r<t;r++)n[r]=arguments[r];e.addUserId(n),o.LoggerDispatcher.Dispatch(c,"Error",["[UserId:"+u+"]"].concat(n),!0)}},{key:"LevelConsole",get:function(){return window[s.Constants._LOGGER_VAR_WINDOW]._SEVERITY_CONSOLE}}]),e}();t.LoggerInstance=h},function(e,t,n){e.exports=n(14)},function(e,t,n){"use strict";e.exports=function(e,t){return function(){for(var n=new Array(arguments.length),r=0;r<n.length;r++)n[r]=arguments[r];return e.apply(t,n)}}},function(e,t,n){"use strict";var r=n(0),i=n(19),o=n(21),s=n(22),a=n(23),c=n(7);e.exports=function(e){return new Promise(function(t,u){var l=e.data,h=e.headers;r.isFormData(l)&&delete h["Content-Type"];var d=new XMLHttpRequest;if(e.auth){var f=e.auth.username||"",p=e.auth.password||"";h.Authorization="Basic "+btoa(f+":"+p)}if(d.open(e.method.toUpperCase(),o(e.url,e.params,e.paramsSerializer),!0),d.timeout=e.timeout,d.onreadystatechange=function(){if(d&&4===d.readyState&&(0!==d.status||d.responseURL&&0===d.responseURL.indexOf("file:"))){var n="getAllResponseHeaders"in d?s(d.getAllResponseHeaders()):null,r=e.responseType&&"text"!==e.responseType?d.response:d.responseText,o={data:r,status:d.status,statusText:d.statusText,headers:n,config:e,request:d};i(t,u,o),d=null}},d.onerror=function(){u(c("Network Error",e,null,d)),d=null},d.ontimeout=function(){u(c("timeout of "+e.timeout+"ms exceeded",e,"ECONNABORTED",d)),d=null},r.isStandardBrowserEnv()){var g=n(24),m=(e.withCredentials||a(e.url))&&e.xsrfCookieName?g.read(e.xsrfCookieName):void 0;m&&(h[e.xsrfHeaderName]=m)}if("setRequestHeader"in d&&r.forEach(h,function(e,t){void 0===l&&"content-type"===t.toLowerCase()?delete h[t]:d.setRequestHeader(t,e)}),e.withCredentials&&(d.withCredentials=!0),e.responseType)try{d.responseType=e.responseType}catch(t){if("json"!==e.responseType)throw t}"function"==typeof e.onDownloadProgress&&d.addEventListener("progress",e.onDownloadProgress),"function"==typeof e.onUploadProgress&&d.upload&&d.upload.addEventListener("progress",e.onUploadProgress),e.cancelToken&&e.cancelToken.promise.then(function(e){d&&(d.abort(),u(e),d=null)}),void 0===l&&(l=null),d.send(l)})}},function(e,t,n){"use strict";var r=n(20);e.exports=function(e,t,n,i,o){var s=new Error(e);return r(s,t,n,i,o)}},function(e,t,n){"use strict";e.exports=function(e){return!(!e||!e.__CANCEL__)}},function(e,t,n){"use strict";function r(e){this.message=e}r.prototype.toString=function(){return"Cancel"+(this.message?": "+this.message:"")},r.prototype.__CANCEL__=!0,e.exports=r},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0}),t.LoggerUtils=void 0;var i="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},o=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),s=n(1),a=function(){function e(){r(this,e)}return o(e,null,[{key:"GetLogLevelBySeverity",value:function(e){var t=1;return e=e.toUpperCase(),s.Constants._LOG_LEVELS[e]&&(t=s.Constants._LOG_LEVELS[e].logLevel),t}},{key:"IsAllowedRemoteToLogBySeverity",value:function(t){return e.GetLogLevelBySeverity(t)>=e.GetCurrentRemoteSeverityLevelConfigured()}},{key:"GetCurrentRemoteSeverityLevelConfigured",value:function(){return e.GetLogLevelBySeverity(window[s.Constants._LOGGER_VAR_WINDOW]._SEVERITY)}},{key:"IsAllowedConsoleToLogBySeverity",value:function(t){return e.GetLogLevelBySeverity(t)>=e.GetCurrentConsoleSeverityLevelConfigured()}},{key:"GetCurrentConsoleSeverityLevelConfigured",value:function(){return e.GetLogLevelBySeverity(window[s.Constants._LOGGER_VAR_WINDOW]._SEVERITY_CONSOLE)}},{key:"ToStringMessage",value:function(){for(var t="",n=arguments.length,r=Array(n),i=0;i<n;i++)r[i]=arguments[i];return r.forEach(function(n){t+=e.ToStringObject(n)}),t}},{key:"ToStringObject",value:function(t){return e.IsObject(t)?"\n"+e.JsonToString(t):t}},{key:"IsObject",value:function(e){return e&&"object"===(void 0===e?"undefined":i(e))&&e.constructor===Object}},{key:"JsonToString",value:function(e){var t=[];return JSON.stringify(e,function(e,n){return n&&"object"==(void 0===n?"undefined":i(n))&&t.push(n),n},2)}}]),e}();t.LoggerUtils=a},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),o=window.localStorage,s="LOG-"+(new Date).getDate()+"-"+((new Date).getMonth()+1)+"-"+(new Date).getFullYear(),a=!1,c=0,u=null,l=function(){function e(){r(this,e)}return i(e,null,[{key:"getKey",value:function(){return s}},{key:"setEnabled",value:function(e){a=e}},{key:"setStorageTimeMin",value:function(e){c=e}},{key:"Add",value:function(t,n,r){if(a){var i=new Date,l=o.getItem(s),h=n+"-"+r+" "+i.getDate()+"-"+(i.getMonth()+1)+"-"+i.getFullYear()+"-"+i.getDate()+" "+i.toLocaleTimeString()+" - MSG: "+t;l?(u||(u=new Date(JSON.parse(o.getItem("GalateaLoggerDate")))),0!==c&&(i-u)/6e4>c?(e.Clean(),u=i,o.setItem("GalateaLoggerDate",JSON.stringify(i))):h=l+";"+h,o.setItem(s,""+h)):(u=i,o.setItem(s,h),o.setItem("GalateaLoggerDate",JSON.stringify(i)))}}},{key:"getRawLogs",value:function(){return o.getItem(s)}},{key:"getLogs",value:function(){return o.getItem(s).replaceAll(";","\n")}},{key:"Clean",value:function(){console.log("Cleaning local storage ",s),o.removeItem(s)}}]),e}();t.LoggerLocal=l},function(e,t,n){"use strict";function r(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0}),t.LoggerDispatcher=void 0;var o=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),s=n(13),a=n(1),c=n(10),u=n(32),l=n(3),h=n(11),d=(window.localStorage,function(){function e(){i(this,e)}return o(e,null,[{key:"Dispatch",value:function(t,n,i,o){h.LoggerLocal.Add(i,t,n),u.LoggerConfigurator.Init(function(){!o&&e.DefaultOutput.apply(e,[t,n].concat(r(i))),e.RemoteOutput.apply(e,[t,n].concat(r(i)))})}},{key:"RemoteOutput",value:function(e,t){if(window[a.Constants._LOGGER_VAR_WINDOW]&&window[a.Constants._LOGGER_VAR_WINDOW]._ENABLE_AJAX&&c.LoggerUtils.IsAllowedRemoteToLogBySeverity(t)){for(var n=arguments.length,r=Array(n>2?n-2:0),i=2;i<n;i++)r[i-2]=arguments[i];if("WARN"===t.toUpperCase()||"ERROR"===t.toUpperCase())s.LoggerRestClient.log(e,t,"["+e+"] "+r);else{var o=0===window[a.Constants._LOGGER_VAR_WINDOW]._FILTER_USER_POST.length,u=0===window[a.Constants._LOGGER_VAR_WINDOW]._FILTER_APP_POST.length;if(o&&u)s.LoggerRestClient.log.apply(s.LoggerRestClient,[e,t].concat(r));else{var h=!0,d=!0;o||(h=window[a.Constants._LOGGER_VAR_WINDOW]._FILTER_USER_POST.find(function(e){return e===l.LoggerInstance.getUserId()})),u||(d=window[a.Constants._LOGGER_VAR_WINDOW]._FILTER_APP_POST.find(function(e){return e===l.LoggerInstance.getApplication()})),h&&d&&s.LoggerRestClient.log(e,t,"["+e+"] "+r)}}}}},{key:"DefaultOutput",value:function(e,t){if(t=t.toUpperCase(),window[a.Constants._LOGGER_VAR_WINDOW]&&window[a.Constants._LOGGER_VAR_WINDOW]._ENABLE_DEFAULT&&c.LoggerUtils.IsAllowedConsoleToLogBySeverity(t)){var n,r=console.log;a.Constants._Log_CONSOLE[t]&&(r=a.Constants._Log_CONSOLE[t]);for(var i=(new Date).toLocaleTimeString(),o=arguments.length,s=Array(o>2?o-2:0),u=2;u<o;u++)s[u-2]=arguments[u];(n=r).call.apply(n,[null,"["+i+"]["+t+"]["+e+"]"].concat(s))}}}]),e}());t.LoggerDispatcher=d},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0}),t.LoggerRestClient=void 0;var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),o=n(4),s=function(e){return e&&e.__esModule?e:{default:e}}(o),a=n(1),c=n(10),u=0,l=!0,h=function(){function e(){r(this,e)}return i(e,null,[{key:"log",value:function(e,t){if(window[a.Constants._LOGGER_VAR_WINDOW]._ENABLE_AJAX)if(0===window[a.Constants._LOGGER_VAR_WINDOW]._NUMBER_ATTEMP_POST||u<window[a.Constants._LOGGER_VAR_WINDOW]._NUMBER_ATTEMP_POST)try{for(var n=new URL(window[a.Constants._LOGGER_VAR_WINDOW]._SERVER),r=new URL(window[a.Constants._LOGGER_VAR_WINDOW]._DOMAIN,n),i=arguments.length,o=Array(i>2?i-2:0),h=2;h<i;h++)o[h-2]=arguments[h];var d=c.LoggerUtils.ToStringMessage(o);s.default.post(r,{UserType:e,Message:d,Severity:t}).then(function(){u=0}).catch(function(e){u++,console.warn("It was not possible to send the message server:",r,e)})}catch(e){u++,console.error("it was not possible to send the log message because an error ocurred servidor:"+window[a.Constants._LOGGER_VAR_WINDOW]._SERVER+" error:"+e+" recommendation: you could check the logger configuration")}else l&&(l=!1,console.warn("number of attempts to overcome Api web is necessary to check the configuration file for logger.json"))}}]),e}();t.LoggerRestClient=h},function(e,t,n){"use strict";function r(e){var t=new s(e),n=o(s.prototype.request,t);return i.extend(n,s.prototype,t),i.extend(n,t),n}var i=n(0),o=n(5),s=n(16),a=n(2),c=r(a);c.Axios=s,c.create=function(e){return r(i.merge(a,e))},c.Cancel=n(9),c.CancelToken=n(30),c.isCancel=n(8),c.all=function(e){return Promise.all(e)},c.spread=n(31),e.exports=c,e.exports.default=c},function(e,t){/*!
	 * Determine if an object is a Buffer
	 *
	 * @author   Feross Aboukhadijeh <https://feross.org>
	 * @license  MIT
	 */
	e.exports=function(e){return null!=e&&null!=e.constructor&&"function"==typeof e.constructor.isBuffer&&e.constructor.isBuffer(e)}},function(e,t,n){"use strict";function r(e){this.defaults=e,this.interceptors={request:new s,response:new s}}var i=n(2),o=n(0),s=n(25),a=n(26);r.prototype.request=function(e){"string"==typeof e&&(e=o.merge({url:arguments[0]},arguments[1])),e=o.merge(i,{method:"get"},this.defaults,e),e.method=e.method.toLowerCase();var t=[a,void 0],n=Promise.resolve(e);for(this.interceptors.request.forEach(function(e){t.unshift(e.fulfilled,e.rejected)}),this.interceptors.response.forEach(function(e){t.push(e.fulfilled,e.rejected)});t.length;)n=n.then(t.shift(),t.shift());return n},o.forEach(["delete","get","head","options"],function(e){r.prototype[e]=function(t,n){return this.request(o.merge(n||{},{method:e,url:t}))}}),o.forEach(["post","put","patch"],function(e){r.prototype[e]=function(t,n,r){return this.request(o.merge(r||{},{method:e,url:t,data:n}))}}),e.exports=r},function(e,t){function n(){throw new Error("setTimeout has not been defined")}function r(){throw new Error("clearTimeout has not been defined")}function i(e){if(l===setTimeout)return setTimeout(e,0);if((l===n||!l)&&setTimeout)return l=setTimeout,setTimeout(e,0);try{return l(e,0)}catch(t){try{return l.call(null,e,0)}catch(t){return l.call(this,e,0)}}}function o(e){if(h===clearTimeout)return clearTimeout(e);if((h===r||!h)&&clearTimeout)return h=clearTimeout,clearTimeout(e);try{return h(e)}catch(t){try{return h.call(null,e)}catch(t){return h.call(this,e)}}}function s(){g&&f&&(g=!1,f.length?p=f.concat(p):m=-1,p.length&&a())}function a(){if(!g){var e=i(s);g=!0;for(var t=p.length;t;){for(f=p,p=[];++m<t;)f&&f[m].run();m=-1,t=p.length}f=null,g=!1,o(e)}}function c(e,t){this.fun=e,this.array=t}function u(){}var l,h,d=e.exports={};!function(){try{l="function"==typeof setTimeout?setTimeout:n}catch(e){l=n}try{h="function"==typeof clearTimeout?clearTimeout:r}catch(e){h=r}}();var f,p=[],g=!1,m=-1;d.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];p.push(new c(e,t)),1!==p.length||g||i(a)},c.prototype.run=function(){this.fun.apply(null,this.array)},d.title="browser",d.browser=!0,d.env={},d.argv=[],d.version="",d.versions={},d.on=u,d.addListener=u,d.once=u,d.off=u,d.removeListener=u,d.removeAllListeners=u,d.emit=u,d.prependListener=u,d.prependOnceListener=u,d.listeners=function(e){return[]},d.binding=function(e){throw new Error("process.binding is not supported")},d.cwd=function(){return"/"},d.chdir=function(e){throw new Error("process.chdir is not supported")},d.umask=function(){return 0}},function(e,t,n){"use strict";var r=n(0);e.exports=function(e,t){r.forEach(e,function(n,r){r!==t&&r.toUpperCase()===t.toUpperCase()&&(e[t]=n,delete e[r])})}},function(e,t,n){"use strict";var r=n(7);e.exports=function(e,t,n){var i=n.config.validateStatus;n.status&&i&&!i(n.status)?t(r("Request failed with status code "+n.status,n.config,null,n.request,n)):e(n)}},function(e,t,n){"use strict";e.exports=function(e,t,n,r,i){return e.config=t,n&&(e.code=n),e.request=r,e.response=i,e}},function(e,t,n){"use strict";function r(e){return encodeURIComponent(e).replace(/%40/gi,"@").replace(/%3A/gi,":").replace(/%24/g,"$").replace(/%2C/gi,",").replace(/%20/g,"+").replace(/%5B/gi,"[").replace(/%5D/gi,"]")}var i=n(0);e.exports=function(e,t,n){if(!t)return e;var o;if(n)o=n(t);else if(i.isURLSearchParams(t))o=t.toString();else{var s=[];i.forEach(t,function(e,t){null!==e&&void 0!==e&&(i.isArray(e)?t+="[]":e=[e],i.forEach(e,function(e){i.isDate(e)?e=e.toISOString():i.isObject(e)&&(e=JSON.stringify(e)),s.push(r(t)+"="+r(e))}))}),o=s.join("&")}return o&&(e+=(-1===e.indexOf("?")?"?":"&")+o),e}},function(e,t,n){"use strict";var r=n(0),i=["age","authorization","content-length","content-type","etag","expires","from","host","if-modified-since","if-unmodified-since","last-modified","location","max-forwards","proxy-authorization","referer","retry-after","user-agent"];e.exports=function(e){var t,n,o,s={};return e?(r.forEach(e.split("\n"),function(e){if(o=e.indexOf(":"),t=r.trim(e.substr(0,o)).toLowerCase(),n=r.trim(e.substr(o+1)),t){if(s[t]&&i.indexOf(t)>=0)return;s[t]="set-cookie"===t?(s[t]?s[t]:[]).concat([n]):s[t]?s[t]+", "+n:n}}),s):s}},function(e,t,n){"use strict";var r=n(0);e.exports=r.isStandardBrowserEnv()?function(){function e(e){var t=e;return n&&(i.setAttribute("href",t),t=i.href),i.setAttribute("href",t),{href:i.href,protocol:i.protocol?i.protocol.replace(/:$/,""):"",host:i.host,search:i.search?i.search.replace(/^\?/,""):"",hash:i.hash?i.hash.replace(/^#/,""):"",hostname:i.hostname,port:i.port,pathname:"/"===i.pathname.charAt(0)?i.pathname:"/"+i.pathname}}var t,n=/(msie|trident)/i.test(navigator.userAgent),i=document.createElement("a");return t=e(window.location.href),function(n){var i=r.isString(n)?e(n):n;return i.protocol===t.protocol&&i.host===t.host}}():function(){return function(){return!0}}()},function(e,t,n){"use strict";var r=n(0);e.exports=r.isStandardBrowserEnv()?function(){return{write:function(e,t,n,i,o,s){var a=[];a.push(e+"="+encodeURIComponent(t)),r.isNumber(n)&&a.push("expires="+new Date(n).toGMTString()),r.isString(i)&&a.push("path="+i),r.isString(o)&&a.push("domain="+o),!0===s&&a.push("secure"),document.cookie=a.join("; ")},read:function(e){var t=document.cookie.match(new RegExp("(^|;\\s*)("+e+")=([^;]*)"));return t?decodeURIComponent(t[3]):null},remove:function(e){this.write(e,"",Date.now()-864e5)}}}():function(){return{write:function(){},read:function(){return null},remove:function(){}}}()},function(e,t,n){"use strict";function r(){this.handlers=[]}var i=n(0);r.prototype.use=function(e,t){return this.handlers.push({fulfilled:e,rejected:t}),this.handlers.length-1},r.prototype.eject=function(e){this.handlers[e]&&(this.handlers[e]=null)},r.prototype.forEach=function(e){i.forEach(this.handlers,function(t){null!==t&&e(t)})},e.exports=r},function(e,t,n){"use strict";function r(e){e.cancelToken&&e.cancelToken.throwIfRequested()}var i=n(0),o=n(27),s=n(8),a=n(2),c=n(28),u=n(29);e.exports=function(e){return r(e),e.baseURL&&!c(e.url)&&(e.url=u(e.baseURL,e.url)),e.headers=e.headers||{},e.data=o(e.data,e.headers,e.transformRequest),e.headers=i.merge(e.headers.common||{},e.headers[e.method]||{},e.headers||{}),i.forEach(["delete","get","head","post","put","patch","common"],function(t){delete e.headers[t]}),(e.adapter||a.adapter)(e).then(function(t){return r(e),t.data=o(t.data,t.headers,e.transformResponse),t},function(t){return s(t)||(r(e),t&&t.response&&(t.response.data=o(t.response.data,t.response.headers,e.transformResponse))),Promise.reject(t)})}},function(e,t,n){"use strict";var r=n(0);e.exports=function(e,t,n){return r.forEach(n,function(n){e=n(e,t)}),e}},function(e,t,n){"use strict";e.exports=function(e){return/^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(e)}},function(e,t,n){"use strict";e.exports=function(e,t){return t?e.replace(/\/+$/,"")+"/"+t.replace(/^\/+/,""):e}},function(e,t,n){"use strict";function r(e){if("function"!=typeof e)throw new TypeError("executor must be a function.");var t;this.promise=new Promise(function(e){t=e});var n=this;e(function(e){n.reason||(n.reason=new i(e),t(n.reason))})}var i=n(9);r.prototype.throwIfRequested=function(){if(this.reason)throw this.reason},r.source=function(){var e;return{token:new r(function(t){e=t}),cancel:e}},e.exports=r},function(e,t,n){"use strict";e.exports=function(e){return function(t){return e.apply(null,t)}}},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t,n){void 0===e[t]&&(console.info("file logger.json does not contain field [%s] set value default [%s]",t,n),e[t]=n)}Object.defineProperty(t,"__esModule",{value:!0}),t.LoggerConfigurator=void 0;var o=function(){function e(e,t){var n=[],r=!0,i=!1,o=void 0;try{for(var s,a=e[Symbol.iterator]();!(r=(s=a.next()).done)&&(n.push(s.value),!t||n.length!==t);r=!0);}catch(e){i=!0,o=e}finally{try{!r&&a.return&&a.return()}finally{if(i)throw o}}return n}return function(t,n){if(Array.isArray(t))return t;if(Symbol.iterator in Object(t))return e(t,n);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}(),s=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),a=n(1),c=n(4),u=function(e){return e&&e.__esModule?e:{default:e}}(c),l=!0,h=function(){function e(){r(this,e)}return s(e,null,[{key:"Init",value:function(t){l&&e.IsConfigurationNotAssigned()?(l=!1,e.GetByExecutionEnvironment(t)):t()}},{key:"Setup",value:function(t,n){if(console.info("Setup ",t),t){window[a.Constants._LOGGER_VAR_WINDOW]={};var r=!0,s=!1,c=void 0;try{for(var u,l=Object.entries(a.Constants._CONFIGURATIONS)[Symbol.iterator]();!(r=(u=l.next()).done);r=!0){var h=o(u.value,2),d=h[0],f=h[1];i(t,d,f)}}catch(e){s=!0,c=e}finally{try{!r&&l.return&&l.return()}finally{if(s)throw c}}Object.keys(t).forEach(function(e){return window[a.Constants._LOGGER_VAR_WINDOW][e]=t[e]}),window[a.Constants._LOGGER_VAR_WINDOW]._USE_WINDOW_ORIGIN&&e.SetConfigurationServer()}else window[a.Constants._LOGGER_VAR_WINDOW]=a.Constants._CONFIGURATIONS,console.info("Logger will use default configuration ... ",a.Constants._CONFIGURATIONS);n()}},{key:"GetByExecutionEnvironment",value:function(t){e.IsBrowser()?e.GetRemote(t):e.GetLocal(t)}},{key:"IsBrowser",value:function(){return!!window}},{key:"GetLocal",value:function(t){e.Setup(null,t)}},{key:"GetRemote",value:function(t){var n=""+window.location.origin+window.location.pathname,r=n.split("/");console.log("Remove Last element ",r.pop()),n=r.join("/")+"/",n+=a.Constants._LOGGER_CONFIGURATION_FILE_REMOTE,u.default.get(n,{responseType:"json"}).then(function(n){e.Setup(n.data,t)}).catch(function(n){console.error("It was not possible to get remote file configuration",n),e.Setup(null,t)})}},{key:"SetConfigurationServer",value:function(){if(window[a.Constants._LOGGER_VAR_WINDOW]._USE_WINDOW_ORIGIN){var e=window.location.hostname;if("127.0.0.1"!==e&&"localhost"!==e){var t=window.location.origin;console.debug("SetConfigurationServer withLocation",t),window[a.Constants._LOGGER_VAR_WINDOW]._SERVER=t}}}},{key:"ExistExternalConfiguration",value:function(e){return!!e}},{key:"IsConfigurationNotAssigned",value:function(){return!a.Constants._LOGGER_CONFIGURATION_ASSIGNED}}]),e}();t.LoggerConfigurator=h}])}()}("undefined"!=typeof self&&self)},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0}),t.MizuJSClient=void 0;var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),o=n(0),s=null;t.MizuJSClient=function(){function e(t){return r(this,e),s||(o.Logger.Trace("MizuJSClient Init SipClient constructor ..."),this.mizuJs=t,s=this,this.initEvents(),this.initExtraParameters()),s}return i(e,[{key:"setUserId",value:function(e){o.Logger.setUserId(e)}},{key:"initEvents",value:function(){this.SIPParameter={};var e={onSipAccepted:function(){console.log("Stack")},onSipRejected:function(){console.log("Stack")},onCallEntry:function(){console.log("Stack")},uiCallTerminated:function(){console.log("Stack")},onCallAnswered:function(){console.log("Stack")},onCallRejected:function(){console.log("Stack")},onChangeDeviceList:function(){console.log("Stack")},onGetStreamMicFail:function(){console.log("Stack")},onTransportDisconnected:function(){console.log("Stack")},onTransportConnected:function(){console.log("Stack")}};this.updateSipParameters(e)}},{key:"setParametersSofPhone",value:function(e){this.mizuJs.setParameters(e)}},{key:"initExtraParameters",value:function(){var e={SIP_CNF_XD:"",SIP_KAMAILIO:""};this.updateSipParameters(e)}},{key:"updateSipParameters",value:function(e){var t=this;Object.keys(e).forEach(function(n){return t.SIPParameter[n]=e[n]})}},{key:"setParamter",value:function(){this.mizuJs.setParamter(this.SIPParameter)}},{key:"setParameter",value:function(e,t){this.mizuJs.setParameter(e,t)}},{key:"conectSip",value:function(e,t){this.setParamter(),this.mizuJs.initCallBacks()}},{key:"reconnectMic",value:function(){o.Logger.Debug("Not Implement reconnectMic")}},{key:"makeCall",value:function(e){this.mizuJs.MakeCall(e)}},{key:"hangUp",value:function(){this.mizuJs.hangup()}},{key:"mute",value:function(e){this.mizuJs.mute(e)}},{key:"hold",value:function(){console.log("Stack")}},{key:"volumeSpeaker",value:function(e){this.mizuJs.SpeakerVolume(e)}},{key:"volumeSpeakerGet",value:function(){return this.mizuJs.getSpkrVol()}},{key:"volumeMicrophone",value:function(e){this.mizuJs.MicrophoneVolume(e)}},{key:"volumeMicrophoneGet",value:function(){return this.mizuJs.getMicVol()}},{key:"dtmf",value:function(e){this.mizuJs.pushDTMF(e)}},{key:"start",value:function(){this.mizuJs.start()}},{key:"stop",value:function(){this.mizuJs.stop()}}]),e}()},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0}),t.WebRTCWrapper=void 0;var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),o=n(9),s=function(e){return e&&e.__esModule?e:{default:e}}(o),a=n(48);t.WebRTCWrapper=function(){function e(){r(this,e)}return i(e,[{key:"getSoftphone",value:function(){return new a.WebRTC(s.default)}}]),e}()},function(e,t,n){"use strict";e.exports=n(10)()},function(e,t,n){"use strict";e.exports=function(){var e=n(11),t=e.version,r=e.title,i=Object.defineProperties({},{version:{get:function(){return t}},name:{get:function(){return r}}});return n(12)(i),i.LoggerFactory=n(13)(),i.EventEmitter=n(14)(),i.C=n(16)(i.name,i.version),i.Exceptions=n(17),i.Timers=n(18)(),i.Transport=n(19)(i),n(20)(i),n(21)(i),n(22)(i),n(23)(i),n(24)(i),n(25)(i),n(27)(i),n(28)(i),i.SessionDescriptionHandler=n(29)(i.EventEmitter),n(30)(i),n(31)(i),n(32)(i),n(34)(i),n(35)(i),n(36)(i),n(40)(i),i.DigestAuthentication=n(41)(i.Utils),i.Grammar=n(44)(i),i.Web={Modifiers:n(46)(i),Simple:n(47)(i)},i}},function(e,t){e.exports={_args:[["sip.js@0.12.0","C:\\Users\\mexic\\OneDrive\\Documentos\\Nuxiba\\SourceTree\\Global\\global-sip-js"]],_from:"sip.js@0.12.0",_id:"sip.js@0.12.0",_inBundle:!1,_integrity:"sha512-mbbK7+5fZC0PhVjDgFGQAsKpBplzw4BA63tOI2pia+TmNau9OB7W0ol/rgytqbb/CSLalBoN/x3C21KA6HjZzg==",_location:"/sip.js",_phantomChildren:{},_requested:{type:"version",registry:!0,raw:"sip.js@0.12.0",name:"sip.js",escapedName:"sip.js",rawSpec:"0.12.0",saveSpec:null,fetchSpec:"0.12.0"},_requiredBy:["/"],_resolved:"https://registry.npmjs.org/sip.js/-/sip.js-0.12.0.tgz",_spec:"0.12.0",_where:"C:\\Users\\mexic\\OneDrive\\Documentos\\Nuxiba\\SourceTree\\Global\\global-sip-js",author:{name:"OnSIP",email:"developer@onsip.com",url:"https://sipjs.com/aboutus/"},bugs:{url:"https://github.com/onsip/SIP.js/issues"},contributors:[{url:"https://github.com/onsip/SIP.js/blob/master/THANKS.md"}],dependencies:{"crypto-js":"^3.1.9-1"},description:"A simple, intuitive, and powerful JavaScript signaling library",devDependencies:{"awesome-typescript-loader":"^5.2.1",eslint:"^5.10.0","jasmine-core":"^3.3.0",karma:"^3.1.3","karma-chrome-launcher":"^2.2.0","karma-cli":"^2.0.0","karma-jasmine":"^2.0.1","karma-jasmine-html-reporter":"^1.4.0","karma-mocha-reporter":"^2.2.5","karma-webpack":"^3.0.5",pegjs:"^0.10.0",typescript:"^3.2.2",webpack:"^4.27.1","webpack-cli":"^3.1.2"},engines:{node:">=6.0"},homepage:"https://sipjs.com",keywords:["sip","websocket","webrtc","library","javascript"],license:"MIT",main:"lib/index.js",name:"sip.js",repository:{type:"git",url:"git+https://github.com/onsip/SIP.js.git"},scripts:{browserTest:"sleep 2 && open http://0.0.0.0:9876/debug.html & karma start --reporters kjhtml --no-single-run",build:"npm run generate-grammar && npm run build-lib && npm run build-reg-bundle && npm run build-min-bundle && npm run copy-dist-files","build-bundles":"npm run build-reg-bundle && npm run build-min-bundle","build-lib":"tsc","build-min-bundle":"webpack --progress --config build/webpack.config.js --env.buildType min","build-reg-bundle":"webpack --progress --config build/webpack.config.js --env.buildType reg",buildAndBrowserTest:"npm run build && npm run browserTest",buildAndTest:"npm run build && npm run commandLineTest",commandLineTest:"karma start --reporters mocha --browsers ChromeHeadless --single-run","copy-dist-files":"cp dist/sip.js dist/sip-$npm_package_version.js && cp dist/sip.min.js  dist/sip-$npm_package_version.min.js","generate-grammar":"node build/grammarGenerator.js",prebuild:"eslint src/*.js src/**/*.js"},title:"SIP.js",types:"./types",version:"0.12.0"}},function(e,t,n){"use strict";e.exports=function(e){var t;t={defer:function(){var e={};return e.promise=new Promise(function(t,n){e.resolve=t,e.reject=n}),e},reducePromises:function(e,t){return e.reduce(function(e,t){return e=e.then(t)},Promise.resolve(t))},augment:function(e,t,n,r){var i,o;o=t.prototype;for(i in o)(r||void 0===e[i])&&(e[i]=o[i]);t.apply(e,n)},str_utf8_length:function(e){return encodeURIComponent(e).replace(/%[A-F\d]{2}/g,"U").length},generateFakeSDP:function(e){if(e){var t=e.indexOf("o="),n=e.indexOf("\r\n",t);return"v=0\r\n"+e.slice(t,n)+"\r\ns=-\r\nt=0 0\r\nc=IN IP4 0.0.0.0"}},isDecimal:function(e){return!isNaN(e)&&parseFloat(e)===parseInt(e,10)},createRandomToken:function(e,t){var n,r,i="";for(t=t||32,n=0;n<e;n++)r=Math.random()*t|0,i+=r.toString(t);return i},newTag:function(){return e.Utils.createRandomToken(e.UA.C.TAG_LENGTH)},newUUID:function(){return"xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g,function(e){var t=16*Math.random()|0;return("x"===e?t:3&t|8).toString(16)})},normalizeTarget:function(t,n){var r,i,o;if(t){if(t instanceof e.URI)return t;if("string"==typeof t){switch(r=t.split("@"),r.length){case 1:if(!n)return;i=t,o=n;break;case 2:i=r[0],o=r[1];break;default:i=r.slice(0,r.length-1).join("@"),o=r[r.length-1]}return i=i.replace(/^(sips?|tel):/i,""),/^[\-\.\(\)]*\+?[0-9\-\.\(\)]+$/.test(i)&&(i=i.replace(/[\-\.\(\)]/g,"")),t=e.C.SIP+":"+e.Utils.escapeUser(i)+"@"+o,e.URI.parse(t)}}},escapeUser:function(e){return encodeURIComponent(decodeURIComponent(e)).replace(/%3A/gi,":").replace(/%2B/gi,"+").replace(/%3F/gi,"?").replace(/%2F/gi,"/")},headerize:function(e){var t,n={"Call-Id":"Call-ID",Cseq:"CSeq","Min-Se":"Min-SE",Rack:"RAck",Rseq:"RSeq","Www-Authenticate":"WWW-Authenticate"},r=e.toLowerCase().replace(/_/g,"-").split("-"),i="",o=r.length;for(t=0;t<o;t++)0!==t&&(i+="-"),i+=r[t].charAt(0).toUpperCase()+r[t].substring(1);return n[i]&&(i=n[i]),i},sipErrorCause:function(t){var n;for(n in e.C.SIP_ERROR_CAUSES)if(-1!==e.C.SIP_ERROR_CAUSES[n].indexOf(t))return e.C.causes[n];return e.C.causes.SIP_FAILURE_CODE},getReasonPhrase:function(t,n){return n||e.C.REASON_PHRASE[t]||""},getReasonHeaderValue:function(t,n){return n=e.Utils.getReasonPhrase(t,n),"SIP;cause="+t+';text="'+n+'"'},getCancelReason:function(t,n){if(t&&t<200||t>699)throw new TypeError("Invalid status_code: "+t);if(t)return e.Utils.getReasonHeaderValue(t,n)},buildStatusLine:function(e,n){if(e=e||null,n=n||null,!e||e<100||e>699)throw new TypeError("Invalid status_code: "+e);if(n&&"string"!=typeof n&&!(n instanceof String))throw new TypeError("Invalid reason_phrase: "+n);return n=t.getReasonPhrase(e,n),"SIP/2.0 "+e+" "+n+"\r\n"}},e.Utils=t}},function(e,t,n){"use strict";var r={error:0,warn:1,log:2,debug:3};e.exports=function(){function e(e,t,n){this.logger=e,this.category=t,this.label=n}var t=function(){var e,t=2,n=!0,i=null;this.loggers={},e=this.getLogger("sip.loggerfactory"),Object.defineProperties(this,{builtinEnabled:{get:function(){return n},set:function(t){"boolean"==typeof t?n=t:e.error('invalid "builtinEnabled" parameter value: '+JSON.stringify(t))}},level:{get:function(){return t},set:function(n){n>=0&&n<=3?t=n:n>3?t=3:r.hasOwnProperty(n)?t=r[n]:e.error('invalid "level" parameter value: '+JSON.stringify(n))}},connector:{get:function(){return i},set:function(t){null===t||""===t||void 0===t?i=null:"function"==typeof t?i=t:e.error('invalid "connector" parameter value: '+JSON.stringify(t))}}})};return t.prototype.print=function(e,t,n,r){if("string"==typeof r){var i=[new Date,t];n&&i.push(n),r=i.concat(r).join(" | ")}e.call(console,r)},Object.keys(r).forEach(function(n){e.prototype[n]=function(e){this.logger[n](this.category,this.label,e)},t.prototype[n]=function(e,t,i){this.level>=r[n]&&(this.builtinEnabled&&this.print(console[n],e,t,i),this.connector&&this.connector(n,e,t,i))}}),t.prototype.getLogger=function(t,n){var r;return n&&3===this.level?new e(this,t,n):this.loggers[t]?this.loggers[t]:(r=new e(this,t),this.loggers[t]=r,r)},t}},function(e,t,n){"use strict";var r=n(15).EventEmitter;e.exports=function(){function e(){r.call(this)}return e.prototype=Object.create(r.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),e}},function(e,t,n){"use strict";function r(e){console&&console.warn&&console.warn(e)}function i(){i.init.call(this)}function o(e){if("function"!=typeof e)throw new TypeError('The "listener" argument must be of type Function. Received type '+typeof e)}function s(e){return void 0===e._maxListeners?i.defaultMaxListeners:e._maxListeners}function a(e,t,n,i){var a,c,u;if(o(n),c=e._events,void 0===c?(c=e._events=Object.create(null),e._eventsCount=0):(void 0!==c.newListener&&(e.emit("newListener",t,n.listener?n.listener:n),c=e._events),u=c[t]),void 0===u)u=c[t]=n,++e._eventsCount;else if("function"==typeof u?u=c[t]=i?[n,u]:[u,n]:i?u.unshift(n):u.push(n),(a=s(e))>0&&u.length>a&&!u.warned){u.warned=!0;var l=new Error("Possible EventEmitter memory leak detected. "+u.length+" "+String(t)+" listeners added. Use emitter.setMaxListeners() to increase limit");l.name="MaxListenersExceededWarning",l.emitter=e,l.type=t,l.count=u.length,r(l)}return e}function c(){if(!this.fired)return this.target.removeListener(this.type,this.wrapFn),this.fired=!0,0===arguments.length?this.listener.call(this.target):this.listener.apply(this.target,arguments)}function u(e,t,n){var r={fired:!1,wrapFn:void 0,target:e,type:t,listener:n},i=c.bind(r);return i.listener=n,r.wrapFn=i,i}function l(e,t,n){var r=e._events;if(void 0===r)return[];var i=r[t];return void 0===i?[]:"function"==typeof i?n?[i.listener||i]:[i]:n?p(i):d(i,i.length)}function h(e){var t=this._events;if(void 0!==t){var n=t[e];if("function"==typeof n)return 1;if(void 0!==n)return n.length}return 0}function d(e,t){for(var n=new Array(t),r=0;r<t;++r)n[r]=e[r];return n}function f(e,t){for(;t+1<e.length;t++)e[t]=e[t+1];e.pop()}function p(e){for(var t=new Array(e.length),n=0;n<t.length;++n)t[n]=e[n].listener||e[n];return t}function g(e,t){return new Promise(function(n,r){function i(n){e.removeListener(t,o),r(n)}function o(){"function"==typeof e.removeListener&&e.removeListener("error",i),n([].slice.call(arguments))}v(e,t,o,{once:!0}),"error"!==t&&m(e,i,{once:!0})})}function m(e,t,n){"function"==typeof e.on&&v(e,"error",t,n)}function v(e,t,n,r){if("function"==typeof e.on)r.once?e.once(t,n):e.on(t,n);else{if("function"!=typeof e.addEventListener)throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type '+typeof e);e.addEventListener(t,function i(o){r.once&&e.removeEventListener(t,i),n(o)})}}var T,y="object"==typeof Reflect?Reflect:null,_=y&&"function"==typeof y.apply?y.apply:function(e,t,n){return Function.prototype.apply.call(e,t,n)};T=y&&"function"==typeof y.ownKeys?y.ownKeys:Object.getOwnPropertySymbols?function(e){return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e))}:function(e){return Object.getOwnPropertyNames(e)};var S=Number.isNaN||function(e){return e!==e};e.exports=i,e.exports.once=g,i.EventEmitter=i,i.prototype._events=void 0,i.prototype._eventsCount=0,i.prototype._maxListeners=void 0;var E=10;Object.defineProperty(i,"defaultMaxListeners",{enumerable:!0,get:function(){return E},set:function(e){if("number"!=typeof e||e<0||S(e))throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received '+e+".");E=e}}),i.init=function(){void 0!==this._events&&this._events!==Object.getPrototypeOf(this)._events||(this._events=Object.create(null),this._eventsCount=0),this._maxListeners=this._maxListeners||void 0},i.prototype.setMaxListeners=function(e){if("number"!=typeof e||e<0||S(e))throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received '+e+".");return this._maxListeners=e,this},i.prototype.getMaxListeners=function(){return s(this)},i.prototype.emit=function(e){for(var t=[],n=1;n<arguments.length;n++)t.push(arguments[n]);var r="error"===e,i=this._events;if(void 0!==i)r=r&&void 0===i.error;else if(!r)return!1;if(r){var o;if(t.length>0&&(o=t[0]),o instanceof Error)throw o;var s=new Error("Unhandled error."+(o?" ("+o.message+")":""));throw s.context=o,s}var a=i[e];if(void 0===a)return!1;if("function"==typeof a)_(a,this,t);else for(var c=a.length,u=d(a,c),n=0;n<c;++n)_(u[n],this,t);return!0},i.prototype.addListener=function(e,t){return a(this,e,t,!1)},i.prototype.on=i.prototype.addListener,i.prototype.prependListener=function(e,t){return a(this,e,t,!0)},i.prototype.once=function(e,t){return o(t),this.on(e,u(this,e,t)),this},i.prototype.prependOnceListener=function(e,t){return o(t),this.prependListener(e,u(this,e,t)),this},i.prototype.removeListener=function(e,t){var n,r,i,s,a;if(o(t),void 0===(r=this._events))return this;if(void 0===(n=r[e]))return this;if(n===t||n.listener===t)0==--this._eventsCount?this._events=Object.create(null):(delete r[e],r.removeListener&&this.emit("removeListener",e,n.listener||t));else if("function"!=typeof n){for(i=-1,s=n.length-1;s>=0;s--)if(n[s]===t||n[s].listener===t){a=n[s].listener,i=s;break}if(i<0)return this;0===i?n.shift():f(n,i),1===n.length&&(r[e]=n[0]),void 0!==r.removeListener&&this.emit("removeListener",e,a||t)}return this},i.prototype.off=i.prototype.removeListener,i.prototype.removeAllListeners=function(e){var t,n,r;if(void 0===(n=this._events))return this;if(void 0===n.removeListener)return 0===arguments.length?(this._events=Object.create(null),this._eventsCount=0):void 0!==n[e]&&(0==--this._eventsCount?this._events=Object.create(null):delete n[e]),this;if(0===arguments.length){var i,o=Object.keys(n);for(r=0;r<o.length;++r)"removeListener"!==(i=o[r])&&this.removeAllListeners(i);return this.removeAllListeners("removeListener"),this._events=Object.create(null),this._eventsCount=0,this}if("function"==typeof(t=n[e]))this.removeListener(e,t);else if(void 0!==t)for(r=t.length-1;r>=0;r--)this.removeListener(e,t[r]);return this},i.prototype.listeners=function(e){return l(this,e,!0)},i.prototype.rawListeners=function(e){return l(this,e,!1)},i.listenerCount=function(e,t){return"function"==typeof e.listenerCount?e.listenerCount(t):h.call(e,t)},i.prototype.listenerCount=h,i.prototype.eventNames=function(){return this._eventsCount>0?T(this._events):[]}},function(e,t,n){"use strict";e.exports=function(e,t){return{USER_AGENT:e+"/"+t,SIP:"sip",SIPS:"sips",causes:{CONNECTION_ERROR:"Connection Error",REQUEST_TIMEOUT:"Request Timeout",SIP_FAILURE_CODE:"SIP Failure Code",INTERNAL_ERROR:"Internal Error",BUSY:"Busy",REJECTED:"Rejected",REDIRECTED:"Redirected",UNAVAILABLE:"Unavailable",NOT_FOUND:"Not Found",ADDRESS_INCOMPLETE:"Address Incomplete",INCOMPATIBLE_SDP:"Incompatible SDP",AUTHENTICATION_ERROR:"Authentication Error",DIALOG_ERROR:"Dialog Error",WEBRTC_NOT_SUPPORTED:"WebRTC Not Supported",WEBRTC_ERROR:"WebRTC Error",CANCELED:"Canceled",NO_ANSWER:"No Answer",EXPIRES:"Expires",NO_ACK:"No ACK",NO_PRACK:"No PRACK",USER_DENIED_MEDIA_ACCESS:"User Denied Media Access",BAD_MEDIA_DESCRIPTION:"Bad Media Description",RTP_TIMEOUT:"RTP Timeout"},supported:{UNSUPPORTED:"none",SUPPORTED:"supported",REQUIRED:"required"},SIP_ERROR_CAUSES:{REDIRECTED:[300,301,302,305,380],BUSY:[486,600],REJECTED:[403,603],NOT_FOUND:[404,604],UNAVAILABLE:[480,410,408,430],ADDRESS_INCOMPLETE:[484],INCOMPATIBLE_SDP:[488,606],AUTHENTICATION_ERROR:[401,407]},ACK:"ACK",BYE:"BYE",CANCEL:"CANCEL",INFO:"INFO",INVITE:"INVITE",MESSAGE:"MESSAGE",NOTIFY:"NOTIFY",OPTIONS:"OPTIONS",REGISTER:"REGISTER",UPDATE:"UPDATE",SUBSCRIBE:"SUBSCRIBE",PUBLISH:"PUBLISH",REFER:"REFER",PRACK:"PRACK",REASON_PHRASE:{100:"Trying",180:"Ringing",181:"Call Is Being Forwarded",182:"Queued",183:"Session Progress",199:"Early Dialog Terminated",200:"OK",202:"Accepted",204:"No Notification",300:"Multiple Choices",301:"Moved Permanently",302:"Moved Temporarily",305:"Use Proxy",380:"Alternative Service",400:"Bad Request",401:"Unauthorized",402:"Payment Required",403:"Forbidden",404:"Not Found",405:"Method Not Allowed",406:"Not Acceptable",407:"Proxy Authentication Required",408:"Request Timeout",410:"Gone",412:"Conditional Request Failed",413:"Request Entity Too Large",414:"Request-URI Too Long",415:"Unsupported Media Type",416:"Unsupported URI Scheme",417:"Unknown Resource-Priority",420:"Bad Extension",421:"Extension Required",422:"Session Interval Too Small",423:"Interval Too Brief",428:"Use Identity Header",429:"Provide Referrer Identity",430:"Flow Failed",433:"Anonymity Disallowed",436:"Bad Identity-Info",437:"Unsupported Certificate",438:"Invalid Identity Header",439:"First Hop Lacks Outbound Support",440:"Max-Breadth Exceeded",469:"Bad Info Package",470:"Consent Needed",478:"Unresolvable Destination",480:"Temporarily Unavailable",481:"Call/Transaction Does Not Exist",482:"Loop Detected",483:"Too Many Hops",484:"Address Incomplete",485:"Ambiguous",486:"Busy Here",487:"Request Terminated",488:"Not Acceptable Here",489:"Bad Event",491:"Request Pending",493:"Undecipherable",494:"Security Agreement Required",500:"Internal Server Error",501:"Not Implemented",502:"Bad Gateway",503:"Service Unavailable",504:"Server Time-out",505:"Version Not Supported",513:"Message Too Large",580:"Precondition Failure",600:"Busy Everywhere",603:"Decline",604:"Does Not Exist Anywhere",606:"Not Acceptable"},OPTION_TAGS:{"100rel":!0,199:!0,answermode:!0,"early-session":!0,eventlist:!0,explicitsub:!0,"from-change":!0,"geolocation-http":!0,"geolocation-sip":!0,gin:!0,gruu:!0,histinfo:!0,ice:!0,join:!0,"multiple-refer":!0,norefersub:!0,nosub:!0,outbound:!0,path:!0,policy:!0,precondition:!0,pref:!0,privacy:!0,"recipient-list-invite":!0,"recipient-list-message":!0,"recipient-list-subscribe":!0,replaces:!0,"resource-priority":!0,"sdp-anat":!0,"sec-agree":!0,tdialog:!0,timer:!0,uui:!0},dtmfType:{INFO:"info",RTP:"rtp"}}}},function(e,t,n){"use strict";e.exports={ConfigurationError:function(){var e=function(e,t){this.code=1,this.name="CONFIGURATION_ERROR",this.parameter=e,this.value=t,this.message=this.value?"Invalid value "+JSON.stringify(this.value)+' for parameter "'+this.parameter+'"':"Missing parameter: "+this.parameter};return e.prototype=new Error,e}(),InvalidStateError:function(){var e=function(e){this.code=2,this.name="INVALID_STATE_ERROR",this.status=e,this.message="Invalid status: "+e};return e.prototype=new Error,e}(),NotSupportedError:function(){var e=function(e){this.code=3,this.name="NOT_SUPPORTED_ERROR",this.message=e};return e.prototype=new Error,e}(),GetDescriptionError:function(){var e=function(e){this.code=4,this.name="GET_DESCRIPTION_ERROR",this.message=e};return e.prototype=new Error,e}(),RenegotiationError:function(){var e=function(e){this.code=5,this.name="RENEGOTIATION_ERROR",this.message=e};return e.prototype=new Error,e}(),MethodParameterError:function(){var e=function(e,t,n){this.code=6,this.name="METHOD_PARAMETER_ERROR",this.method=e,this.parameter=t,this.value=n,this.message=this.value?"Invalid value "+JSON.stringify(this.value)+' for parameter "'+this.parameter+'"':"Missing parameter: "+this.parameter};return e.prototype=new Error,e}(),TransportError:function(){var e=function(e){this.code=7,this.name="TRANSPORT_ERROR",this.message=e};return e.prototype=new Error,e}(),SessionDescriptionHandlerError:function(){var e=function(e,t,n){this.code=8,this.name="SESSION_DESCRIPTION_HANDLER_ERROR",this.method=e,this.error=t,this.message=n||"Error with Session Description Handler"};return e.prototype=new Error,e}()}},function(e,t,n){"use strict";e.exports=function(){return{T1:500,T2:4e3,T4:5e3,TIMER_B:32e3,TIMER_D:0,TIMER_F:32e3,TIMER_H:32e3,TIMER_I:0,TIMER_J:0,TIMER_K:0,TIMER_L:32e3,TIMER_M:32e3,TIMER_N:32e3,PROVISIONAL_RESPONSE_INTERVAL:6e4}}},function(e,t,n){"use strict";e.exports=function(e){var t=function(e,t){};return t.prototype=Object.create(e.EventEmitter.prototype,{connect:{writable:!0,value:function(e){return e=e||{},this.connectPromise(e).then(function(e){!e.overrideEvent&&this.emit("connected")}.bind(this))}},connectPromise:{writable:!0,value:function(e){}},isConnected:{writable:!0,value:function(){}},send:{writable:!0,value:function(e,t){return t=t||{},this.sendPromise(e).then(function(e){!e.overrideEvent&&this.emit("messageSent",e.msg)}.bind(this))}},sendPromise:{writable:!0,value:function(e,t){}},onMessage:{writable:!0,value:function(e){}},disconnect:{writable:!0,value:function(e){return e=e||{},this.disconnectPromise(e).then(function(e){!e.overrideEvent&&this.emit("disconnected")}.bind(this))}},disconnectPromise:{writable:!0,value:function(e){}},afterConnected:{writable:!0,value:function(e){this.isConnected()?e():this.once("connected",e)}},waitForConnected:{writable:!0,value:function(){return console.warn("DEPRECATION WARNING Transport.waitForConnected(): use afterConnected() instead"),new Promise(function(e){this.afterConnected(e)}.bind(this))}}}),t}},function(e,t,n){"use strict";e.exports=function(e){function t(e,t){var n=t,r=0,i=0;if(e.substring(n,n+2).match(/(^\r\n)/))return-2;for(;0===r;){if(-1===(i=e.indexOf("\r\n",n)))return i;!e.substring(i+2,i+4).match(/(^\r\n)/)&&e.charAt(i+2).match(/(^\s+)/)?n=i+2:r=i}return r}function n(t,n,r,i){var o,s,a,c,u=n.indexOf(":",r),l=n.substring(r,u).trim(),h=n.substring(u+1,i).trim();switch(l.toLowerCase()){case"via":case"v":t.addHeader("via",h),1===t.getHeaders("via").length?(c=t.parseHeader("Via"))&&(t.via=c,t.via_branch=c.branch):c=0;break;case"from":case"f":t.setHeader("from",h),(c=t.parseHeader("from"))&&(t.from=c,t.from_tag=c.getParam("tag"));break;case"to":case"t":t.setHeader("to",h),(c=t.parseHeader("to"))&&(t.to=c,t.to_tag=c.getParam("tag"));break;case"record-route":if(-1===(c=e.Grammar.parse(h,"Record_Route"))){c=void 0;break}for(a=c.length,s=0;s<a;s++)o=c[s],t.addHeader("record-route",h.substring(o.position,o.offset)),t.headers["Record-Route"][t.getHeaders("record-route").length-1].parsed=o.parsed;break;case"call-id":case"i":t.setHeader("call-id",h),(c=t.parseHeader("call-id"))&&(t.call_id=h);break;case"contact":case"m":if(-1===(c=e.Grammar.parse(h,"Contact"))){c=void 0;break}for(a=c.length,s=0;s<a;s++)o=c[s],t.addHeader("contact",h.substring(o.position,o.offset)),t.headers.Contact[t.getHeaders("contact").length-1].parsed=o.parsed;break;case"content-length":case"l":t.setHeader("content-length",h),c=t.parseHeader("content-length");break;case"content-type":case"c":t.setHeader("content-type",h),c=t.parseHeader("content-type");break;case"cseq":t.setHeader("cseq",h),c=t.parseHeader("cseq"),c&&(t.cseq=c.value),t instanceof e.IncomingResponse&&(t.method=c.method);break;case"max-forwards":t.setHeader("max-forwards",h),c=t.parseHeader("max-forwards");break;case"www-authenticate":t.setHeader("www-authenticate",h),c=t.parseHeader("www-authenticate");break;case"proxy-authenticate":t.setHeader("proxy-authenticate",h),c=t.parseHeader("proxy-authenticate");break;case"refer-to":case"r":t.setHeader("refer-to",h),(c=t.parseHeader("refer-to"))&&(t.refer_to=c);break;default:t.setHeader(l,h),c=0}return void 0!==c||{error:'error parsing header "'+l+'"'}}var r;r={},r.parseMessage=function(r,i){var o,s,a,c,u,l=0,h=r.indexOf("\r\n"),d=i.getLogger("sip.parser");if(-1===h)return void d.warn("no CRLF found, not a SIP message, discarded");if(s=r.substring(0,h),-1===(u=e.Grammar.parse(s,"Request_Response")))return void d.warn('error parsing first line of SIP message: "'+s+'"');for(u.status_code?(o=new e.IncomingResponse(i),o.status_code=u.status_code,o.reason_phrase=u.reason_phrase):(o=new e.IncomingRequest(i),o.method=u.method,o.ruri=u.uri),o.data=r,l=h+2;;){if(-2===(h=t(r,l))){c=l+2;break}if(-1===h)return void d.error("malformed message");if(!0!==(u=n(o,r,l,h)))return void d.error(u.error);l=h+2}return o.hasHeader("content-length")?(a=o.getHeader("content-length"),o.body=r.substr(c,a)):o.body=r.substring(c),o},e.Parser=r}},function(e,t,n){"use strict";e.exports=function(e){function t(t){var n=t.ua.configuration.hackAllowUnregisteredOptionTags,r=[],i={};return t.method===e.C.REGISTER?r.push("path","gruu"):t.method===e.C.INVITE&&(t.ua.contact.pub_gruu||t.ua.contact.temp_gruu)&&r.push("gruu"),t.ua.configuration.rel100===e.C.supported.SUPPORTED&&r.push("100rel"),t.ua.configuration.replaces===e.C.supported.SUPPORTED&&r.push("replaces"),r.push("outbound"),r=r.concat(t.ua.configuration.extraSupported),r=r.filter(function(t){var r=e.C.OPTION_TAGS[t],o=!i[t];return i[t]=!0,(r||n)&&o}),"Supported: "+r.join(", ")+"\r\n"}var n,r,i,o;n=function(t,n,r,i,o,s){var a,c,u,l,h,d;if(i=i||{},!t||!n||!r)return null;this.logger=r.getLogger("sip.sipmessage"),this.ua=r,this.headers={},this.method=t,this.ruri=n,this.body=s,this.extraHeaders=(o||[]).slice(),this.statusCode=i.status_code,this.reasonPhrase=i.reason_phrase,i.route_set?this.setHeader("route",i.route_set):r.configuration.usePreloadedRoute&&this.setHeader("route",r.transport.server.sip_uri),this.setHeader("via",""),this.setHeader("max-forwards",e.UA.C.MAX_FORWARDS),h=i.to_uri||n,a=i.to_displayName||0===i.to_displayName?'"'+i.to_displayName+'" ':"",a+="<"+(h&&h.toRaw?h.toRaw():h)+">",a+=i.to_tag?";tag="+i.to_tag:"",this.to=new e.NameAddrHeader.parse(a),this.setHeader("to",a),d=i.from_uri||r.configuration.uri,c=i.from_displayName||0===i.from_displayName?'"'+i.from_displayName+'" ':r.configuration.displayName?'"'+r.configuration.displayName+'" ':"",c+="<"+(d&&d.toRaw?d.toRaw():d)+">;tag=",c+=i.from_tag||e.Utils.newTag(),this.from=new e.NameAddrHeader.parse(c),this.setHeader("from",c),u=i.call_id||r.configuration.sipjsId+e.Utils.createRandomToken(15),this.call_id=u,this.setHeader("call-id",u),l=i.cseq||Math.floor(1e4*Math.random()),this.cseq=l,this.setHeader("cseq",l+" "+t)},n.prototype={setHeader:function(t,n){this.headers[e.Utils.headerize(t)]=n instanceof Array?n:[n]},getHeader:function(t){var n,r,i=this.extraHeaders.length,o=this.headers[e.Utils.headerize(t)];if(o){if(o[0])return o[0]}else for(n=new RegExp("^\\s*"+t+"\\s*:","i"),r=0;r<i;r++)if(o=this.extraHeaders[r],n.test(o))return o.substring(o.indexOf(":")+1).trim()},getHeaders:function(t){var n,r,i,o=this.headers[e.Utils.headerize(t)],s=[];if(o){for(r=o.length,n=0;n<r;n++)s.push(o[n]);return s}for(r=this.extraHeaders.length,i=new RegExp("^\\s*"+t+"\\s*:","i"),n=0;n<r;n++)o=this.extraHeaders[n],i.test(o)&&s.push(o.substring(o.indexOf(":")+1).trim());return s},hasHeader:function(t){var n,r,i=this.extraHeaders.length;if(this.headers[e.Utils.headerize(t)])return!0;for(n=new RegExp("^\\s*"+t+"\\s*:","i"),r=0;r<i;r++)if(n.test(this.extraHeaders[r]))return!0;return!1},toString:function(){var n,r,i,o="";o+=this.method+" "+(this.ruri.toRaw?this.ruri.toRaw():this.ruri)+" SIP/2.0\r\n";for(n in this.headers)for(r=this.headers[n].length,i=0;i<r;i++)o+=n+": "+this.headers[n][i]+"\r\n";for(r=this.extraHeaders.length,i=0;i<r;i++)o+=this.extraHeaders[i].trim()+"\r\n";return o+=t(this),o+="User-Agent: "+this.ua.configuration.userAgentString+"\r\n",this.body?"string"==typeof this.body?(r=e.Utils.str_utf8_length(this.body),o+="Content-Length: "+r+"\r\n\r\n",o+=this.body):this.body.body&&this.body.contentType?(r=e.Utils.str_utf8_length(this.body.body),o+="Content-Type: "+this.body.contentType+"\r\n",o+="Content-Length: "+r+"\r\n\r\n",o+=this.body.body):o+="Content-Length: 0\r\n\r\n":o+="Content-Length: 0\r\n\r\n",o}},r=function(){this.data=null,this.headers=null,this.method=null,this.via=null,this.via_branch=null,this.call_id=null,this.cseq=null,this.from=null,this.from_tag=null,this.to=null,this.to_tag=null,this.body=null},r.prototype={addHeader:function(t,n){var r={raw:n};t=e.Utils.headerize(t),this.headers[t]?this.headers[t].push(r):this.headers[t]=[r]},getHeader:function(t){var n=this.headers[e.Utils.headerize(t)];if(n)return n[0]?n[0].raw:void 0},getHeaders:function(t){var n,r,i=this.headers[e.Utils.headerize(t)],o=[];if(!i)return[];for(r=i.length,n=0;n<r;n++)o.push(i[n].raw);return o},hasHeader:function(t){return!!this.headers[e.Utils.headerize(t)]},parseHeader:function(t,n){var r,i,o;return t=e.Utils.headerize(t),n=n||0,this.headers[t]?n>=this.headers[t].length?void this.logger.log('not so many "'+t+'" headers present'):(r=this.headers[t][n],i=r.raw,r.parsed?r.parsed:(o=e.Grammar.parse(i,t.replace(/-/g,"_")),-1===o?(this.headers[t].splice(n,1),void this.logger.warn('error parsing "'+t+'" header field with value "'+i+'"')):(r.parsed=o,o))):void this.logger.log('header "'+t+'" not present')},s:function(e,t){return this.parseHeader(e,t)},setHeader:function(t,n){var r={raw:n};this.headers[e.Utils.headerize(t)]=[r]},toString:function(){return this.data}},i=function(e){this.logger=e.getLogger("sip.sipmessage"),this.ua=e,this.headers={},this.ruri=null,this.transport=null,this.server_transaction=null},i.prototype=new r,i.prototype.reply=function(n,r,i,o,s,a){var c,u,l,h,d,f=this.getHeader("To"),p=0,g=0;if(d=e.Utils.buildStatusLine(n,r),i=(i||[]).slice(),this.method===e.C.INVITE&&n>100&&n<=200)for(c=this.getHeaders("record-route"),l=c.length,p;p<l;p++)d+="Record-Route: "+c[p]+"\r\n";for(u=this.getHeaders("via"),l=u.length,g;g<l;g++)d+="Via: "+u[g]+"\r\n";for(!this.to_tag&&n>100?f+=";tag="+e.Utils.newTag():this.to_tag&&!this.s("to").hasParam("tag")&&(f+=";tag="+this.to_tag),d+="To: "+f+"\r\n",d+="From: "+this.getHeader("From")+"\r\n",d+="Call-ID: "+this.call_id+"\r\n",d+="CSeq: "+this.cseq+" "+this.method+"\r\n",l=i.length,h=0;h<l;h++)d+=i[h].trim()+"\r\n";return d+=t(this),d+="User-Agent: "+this.ua.configuration.userAgentString+"\r\n",o?"string"==typeof o?(l=e.Utils.str_utf8_length(o),d+="Content-Type: application/sdp\r\n",d+="Content-Length: "+l+"\r\n\r\n",d+=o):o.body&&o.contentType?(l=e.Utils.str_utf8_length(o.body),d+="Content-Type: "+o.contentType+"\r\n",d+="Content-Length: "+l+"\r\n\r\n",d+=o.body):d+="Content-Length: 0\r\n\r\n":d+="Content-Length: 0\r\n\r\n",this.server_transaction.receiveResponse(n,d).then(s,a),d},i.prototype.reply_sl=function(t,n){var r,i,o=0,s=this.getHeaders("via"),a=s.length;for(i=e.Utils.buildStatusLine(t,n),o;o<a;o++)i+="Via: "+s[o]+"\r\n";r=this.getHeader("To"),!this.to_tag&&t>100?r+=";tag="+e.Utils.newTag():this.to_tag&&!this.s("to").hasParam("tag")&&(r+=";tag="+this.to_tag),i+="To: "+r+"\r\n",i+="From: "+this.getHeader("From")+"\r\n",i+="Call-ID: "+this.call_id+"\r\n",i+="CSeq: "+this.cseq+" "+this.method+"\r\n",i+="User-Agent: "+this.ua.configuration.userAgentString+"\r\n",i+="Content-Length: 0\r\n\r\n",this.transport.send(i)},o=function(e){this.logger=e.getLogger("sip.sipmessage"),this.headers={},this.status_code=null,this.reason_phrase=null},o.prototype=new r,e.OutgoingRequest=n,e.IncomingRequest=i,e.IncomingResponse=o}},function(e,t,n){"use strict";e.exports=function(e){var t;t=function(t,n,r,i,o,s){var a,c,u,l;if(!r)throw new TypeError('missing or invalid "host" parameter');t=t||e.C.SIP,this.parameters={},this.headers={};for(a in o)this.setParam(a,o[a]);for(c in s)this.setHeader(c,s[c]);u={scheme:t,user:n,host:r,port:i},l={scheme:t.toLowerCase(),user:n,host:r.toLowerCase(),port:i},Object.defineProperties(this,{_normal:{get:function(){return l}},_raw:{get:function(){return u}},scheme:{get:function(){return l.scheme},set:function(e){u.scheme=e,l.scheme=e.toLowerCase()}},user:{get:function(){return l.user},set:function(e){l.user=u.user=e}},host:{get:function(){return l.host},set:function(e){u.host=e,l.host=e.toLowerCase()}},aor:{get:function(){return l.user+"@"+l.host}},port:{get:function(){return l.port},set:function(e){l.port=u.port=0===e?e:parseInt(e,10)||null}}})},t.prototype={setParam:function(e,t){e&&(this.parameters[e.toLowerCase()]=void 0===t||null===t?null:t.toString())},getParam:function(e){if(e)return this.parameters[e.toLowerCase()]},hasParam:function(e){if(e)return this.parameters.hasOwnProperty(e.toLowerCase())&&!0||!1},deleteParam:function(e){var t;if(e=e.toLowerCase(),this.parameters.hasOwnProperty(e))return t=this.parameters[e],delete this.parameters[e],t},clearParams:function(){this.parameters={}},setHeader:function(t,n){this.headers[e.Utils.headerize(t)]=n instanceof Array?n:[n]},getHeader:function(t){if(t)return this.headers[e.Utils.headerize(t)]},hasHeader:function(t){if(t)return this.headers.hasOwnProperty(e.Utils.headerize(t))&&!0||!1},deleteHeader:function(t){var n;if(t=e.Utils.headerize(t),this.headers.hasOwnProperty(t))return n=this.headers[t],delete this.headers[t],n},clearHeaders:function(){this.headers={}},clone:function(){return new t(this._raw.scheme,this._raw.user,this._raw.host,this._raw.port,JSON.parse(JSON.stringify(this.parameters)),JSON.parse(JSON.stringify(this.headers)))},toRaw:function(){return this._toString(this._raw)},toString:function(){return this._toString(this._normal)},_toString:function(t){var n,r,i,o,s=[];o=t.scheme+":",t.scheme.toLowerCase().match("^sips?$")||(o+="//"),t.user&&(o+=e.Utils.escapeUser(t.user)+"@"),o+=t.host,(t.port||0===t.port)&&(o+=":"+t.port);for(r in this.parameters)o+=";"+r,null!==this.parameters[r]&&(o+="="+this.parameters[r]);for(n in this.headers)for(i in this.headers[n])s.push(n+"="+this.headers[n][i]);return s.length>0&&(o+="?"+s.join("&")),o}},t.parse=function(t){return t=e.Grammar.parse(t,"SIP_URI"),-1!==t?t:void 0},e.URI=t}},function(e,t,n){"use strict";e.exports=function(e){var t;t=function(t,n,r){var i;if(!(t&&t instanceof e.URI))throw new TypeError('missing or invalid "uri" parameter');this.uri=t,this.parameters={};for(i in r)this.setParam(i,r[i]);Object.defineProperties(this,{friendlyName:{get:function(){return this.displayName||t.aor}},displayName:{get:function(){return n},set:function(e){n=0===e?"0":e}}})},t.prototype={setParam:function(e,t){e&&(this.parameters[e.toLowerCase()]=void 0===t||null===t?null:t.toString())},getParam:e.URI.prototype.getParam,hasParam:e.URI.prototype.hasParam,deleteParam:e.URI.prototype.deleteParam,clearParams:e.URI.prototype.clearParams,clone:function(){return new t(this.uri.clone(),this.displayName,JSON.parse(JSON.stringify(this.parameters)))},toString:function(){var e,t;e=this.displayName||0===this.displayName?'"'+this.displayName+'" ':"",e+="<"+this.uri.toString()+">";for(t in this.parameters)e+=";"+t,null!==this.parameters[t]&&(e+="="+this.parameters[t]);return e}},t.parse=function(t){return t=e.Grammar.parse(t,"Name_Addr_Header"),-1!==t?t:void 0},e.NameAddrHeader=t}},function(e,t,n){"use strict";e.exports=function(e){function t(e,t,n){var r;return r="SIP/2.0/"+(e.ua.configuration.hackViaTcp?"TCP":t.server.scheme),r+=" "+e.ua.configuration.viaHost+";branch="+n,e.ua.configuration.forceRport&&(r+=";rport"),r}var n={STATUS_TRYING:1,STATUS_PROCEEDING:2,STATUS_CALLING:3,STATUS_ACCEPTED:4,STATUS_COMPLETED:5,STATUS_TERMINATED:6,STATUS_CONFIRMED:7,NON_INVITE_CLIENT:"nict",NON_INVITE_SERVER:"nist",INVITE_CLIENT:"ict",INVITE_SERVER:"ist"},r=function(e,r,i){var o;this.type=n.NON_INVITE_CLIENT,this.transport=i,this.id="z9hG4bK"+Math.floor(1e7*Math.random()),this.request_sender=e,this.request=r,this.logger=e.ua.getLogger("sip.transaction.nict",this.id),o=t(e,i,this.id),this.request.setHeader("via",o),this.request_sender.ua.newTransaction(this)};r.prototype=Object.create(e.EventEmitter.prototype),r.prototype.stateChanged=function(e){this.state=e,this.emit("stateChanged")},r.prototype.send=function(){var t=this;this.stateChanged(n.STATUS_TRYING),this.F=setTimeout(t.timer_F.bind(t),e.Timers.TIMER_F),this.transport.send(this.request).catch(function(){this.onTransportError()}.bind(this))},r.prototype.onTransportError=function(){this.logger.log("transport error occurred, deleting non-INVITE client transaction "+this.id),clearTimeout(this.F),clearTimeout(this.K),this.stateChanged(n.STATUS_TERMINATED),this.request_sender.ua.destroyTransaction(this),this.request_sender.onTransportError()},r.prototype.timer_F=function(){this.logger.debug("Timer F expired for non-INVITE client transaction "+this.id),this.stateChanged(n.STATUS_TERMINATED),this.request_sender.ua.destroyTransaction(this),this.request_sender.onRequestTimeout()},r.prototype.timer_K=function(){this.stateChanged(n.STATUS_TERMINATED),this.request_sender.ua.destroyTransaction(this)},r.prototype.receiveResponse=function(t){var r=this,i=t.status_code;if(i<200)switch(this.state){case n.STATUS_TRYING:case n.STATUS_PROCEEDING:this.stateChanged(n.STATUS_PROCEEDING),this.request_sender.receiveResponse(t)}else switch(this.state){case n.STATUS_TRYING:case n.STATUS_PROCEEDING:this.stateChanged(n.STATUS_COMPLETED),clearTimeout(this.F),408===i?this.request_sender.onRequestTimeout():this.request_sender.receiveResponse(t),this.K=setTimeout(r.timer_K.bind(r),e.Timers.TIMER_K)}};var i=function(e,r,i){var o,s=this;this.type=n.INVITE_CLIENT,this.transport=i,this.id="z9hG4bK"+Math.floor(1e7*Math.random()),this.request_sender=e,this.request=r,this.logger=e.ua.getLogger("sip.transaction.ict",this.id),o=t(e,i,this.id),this.request.setHeader("via",o),this.request_sender.ua.newTransaction(this),this.request.cancel=function(e,t){t=(t||[]).slice();for(var n=t.length,r=null,i=0;i<n;i++)r=(r||"")+t[i].trim()+"\r\n";s.cancel_request(s,e,r)}};i.prototype=Object.create(e.EventEmitter.prototype),i.prototype.stateChanged=function(e){this.state=e,this.emit("stateChanged")},i.prototype.send=function(){var t=this;this.stateChanged(n.STATUS_CALLING),this.B=setTimeout(t.timer_B.bind(t),e.Timers.TIMER_B),this.transport.send(this.request).catch(function(){this.onTransportError()}.bind(this))},i.prototype.onTransportError=function(){this.logger.log("transport error occurred, deleting INVITE client transaction "+this.id),clearTimeout(this.B),clearTimeout(this.D),clearTimeout(this.M),this.stateChanged(n.STATUS_TERMINATED),this.request_sender.ua.destroyTransaction(this),this.state!==n.STATUS_ACCEPTED&&this.request_sender.onTransportError()},i.prototype.timer_M=function(){this.logger.debug("Timer M expired for INVITE client transaction "+this.id),this.state===n.STATUS_ACCEPTED&&(clearTimeout(this.B),this.stateChanged(n.STATUS_TERMINATED),this.request_sender.ua.destroyTransaction(this))},i.prototype.timer_B=function(){this.logger.debug("Timer B expired for INVITE client transaction "+this.id),this.state===n.STATUS_CALLING&&(this.stateChanged(n.STATUS_TERMINATED),this.request_sender.ua.destroyTransaction(this),this.request_sender.onRequestTimeout())},i.prototype.timer_D=function(){this.logger.debug("Timer D expired for INVITE client transaction "+this.id),clearTimeout(this.B),this.stateChanged(n.STATUS_TERMINATED),this.request_sender.ua.destroyTransaction(this)},i.prototype.sendACK=function(t){var n,r=this;t=t||{},n=this.response.getHeader("contact")?this.response.parseHeader("contact").uri:this.request.ruri;var i=new e.OutgoingRequest("ACK",n,this.request.ua,{cseq:this.response.cseq,call_id:this.response.call_id,from_uri:this.response.from.uri,from_tag:this.response.from_tag,to_uri:this.response.to.uri,to_tag:this.response.to_tag,route_set:this.response.getHeaders("record-route").reverse()},t.extraHeaders||[],t.body);return this.ackSender=new e.RequestSender({request:i,onRequestTimeout:this.request_sender.applicant.applicant?this.request_sender.applicant.applicant.onRequestTimeout:function(){r.logger.warn("ACK Request timed out")},onTransportError:this.request_sender.applicant.applicant?this.request_sender.applicant.applicant.onRequestTransportError:function(){r.logger.warn("ACK Request had a transport error")},receiveResponse:t.receiveResponse||function(){r.logger.warn("Received a response to an ACK which was unexpected. Dropping Response.")}},this.request.ua).send(),i},i.prototype.cancel_request=function(t,r,i){var o=t.request;this.cancel=e.C.CANCEL+" "+o.ruri+" SIP/2.0\r\n",this.cancel+="Via: "+o.headers.Via.toString()+"\r\n",this.request.headers.Route&&(this.cancel+="Route: "+o.headers.Route.toString()+"\r\n"),this.cancel+="To: "+o.headers.To.toString()+"\r\n",this.cancel+="From: "+o.headers.From.toString()+"\r\n",this.cancel+="Call-ID: "+o.headers["Call-ID"].toString()+"\r\n",this.cancel+="Max-Forwards: "+e.UA.C.MAX_FORWARDS+"\r\n",this.cancel+="CSeq: "+o.headers.CSeq.toString().split(" ")[0]+" CANCEL\r\n",r&&(this.cancel+="Reason: "+r+"\r\n"),i&&(this.cancel+=i),this.cancel+="Content-Length: 0\r\n\r\n",this.state===n.STATUS_PROCEEDING&&this.transport.send(this.cancel)},i.prototype.receiveResponse=function(t){var r=this,i=t.status_code;if(t.transaction=this,this.response&&this.response.status_code===t.status_code&&this.response.cseq===t.cseq)return this.logger.debug("ICT Received a retransmission for cseq: "+t.cseq),void(this.ackSender&&this.ackSender.send());if(this.response=t,i>=100&&i<=199)switch(this.state){case n.STATUS_CALLING:this.stateChanged(n.STATUS_PROCEEDING),this.request_sender.receiveResponse(t),this.cancel&&this.transport.send(this.cancel);break;case n.STATUS_PROCEEDING:this.request_sender.receiveResponse(t)}else if(i>=200&&i<=299)switch(this.state){case n.STATUS_CALLING:case n.STATUS_PROCEEDING:this.stateChanged(n.STATUS_ACCEPTED),this.M=setTimeout(r.timer_M.bind(r),e.Timers.TIMER_M),this.request_sender.receiveResponse(t);break;case n.STATUS_ACCEPTED:this.request_sender.receiveResponse(t)}else if(i>=300&&i<=699)switch(this.state){case n.STATUS_CALLING:case n.STATUS_PROCEEDING:this.stateChanged(n.STATUS_COMPLETED),this.sendACK(),this.request_sender.receiveResponse(t);break;case n.STATUS_COMPLETED:this.sendACK()}};var o=function(e,n,r){var i;this.transport=r,this.id="z9hG4bK"+Math.floor(1e7*Math.random()),this.request_sender=e,this.request=n,this.logger=e.ua.getLogger("sip.transaction.nict",this.id),i=t(e,r,this.id),this.request.setHeader("via",i)};o.prototype=Object.create(e.EventEmitter.prototype),o.prototype.send=function(){this.transport.send(this.request).catch(function(){this.onTransportError()}.bind(this))},o.prototype.onTransportError=function(){this.logger.log("transport error occurred, for an ACK client transaction "+this.id),this.request_sender.onTransportError()};var s=function(e,t){this.type=n.NON_INVITE_SERVER,this.id=e.via_branch,this.request=e,this.transport=t.transport,this.ua=t,this.last_response="",e.server_transaction=this,this.logger=t.getLogger("sip.transaction.nist",this.id),this.state=n.STATUS_TRYING,t.newTransaction(this)};s.prototype=Object.create(e.EventEmitter.prototype),s.prototype.stateChanged=function(e){this.state=e,this.emit("stateChanged")},s.prototype.onTransportError=function(){this.transportError||(this.transportError=!0,this.logger.log("transport error occurred, deleting non-INVITE server transaction "+this.id),clearTimeout(this.J),this.stateChanged(n.STATUS_TERMINATED),this.ua.destroyTransaction(this))},s.prototype.receiveResponse=function(t,r){var i=this;return new Promise(function(o,s){if(100===t)switch(i.state){case n.STATUS_TRYING:i.stateChanged(n.STATUS_PROCEEDING),i.transport.send(r).catch(i.onTransportError);break;case n.STATUS_PROCEEDING:i.last_response=r,i.transport.send(r).then(o).catch(function(){i.onTransportError(),s()})}else if(t>=200&&t<=699)switch(i.state){case n.STATUS_TRYING:case n.STATUS_PROCEEDING:i.stateChanged(n.STATUS_COMPLETED),i.last_response=r,i.J=setTimeout(function(){i.logger.debug("Timer J expired for non-INVITE server transaction "+i.id),i.stateChanged(n.STATUS_TERMINATED),i.ua.destroyTransaction(i)},e.Timers.TIMER_J),i.transport.send(r).then(o).catch(function(){i.onTransportError(),s()})}})};var a=function(e,t){this.type=n.INVITE_SERVER,this.id=e.via_branch,this.request=e,this.transport=t.transport,this.ua=t,this.last_response="",e.server_transaction=this,this.logger=t.getLogger("sip.transaction.ist",this.id),this.state=n.STATUS_PROCEEDING,t.newTransaction(this),this.resendProvisionalTimer=null,e.reply(100)};a.prototype=Object.create(e.EventEmitter.prototype),a.prototype.stateChanged=function(e){this.state=e,this.emit("stateChanged")},a.prototype.timer_H=function(){this.logger.debug("Timer H expired for INVITE server transaction "+this.id),this.state===n.STATUS_COMPLETED&&this.logger.warn("transactions","ACK for INVITE server transaction was never received, call will be terminated"),this.stateChanged(n.STATUS_TERMINATED),this.ua.destroyTransaction(this)},a.prototype.timer_I=function(){this.stateChanged(n.STATUS_TERMINATED),this.ua.destroyTransaction(this)},a.prototype.timer_L=function(){this.logger.debug("Timer L expired for INVITE server transaction "+this.id),this.state===n.STATUS_ACCEPTED&&(this.stateChanged(n.STATUS_TERMINATED),this.ua.destroyTransaction(this))},a.prototype.onTransportError=function(){this.transportError||(this.transportError=!0,this.logger.log("transport error occurred, deleting INVITE server transaction "+this.id),null!==this.resendProvisionalTimer&&(clearInterval(this.resendProvisionalTimer),this.resendProvisionalTimer=null),clearTimeout(this.L),clearTimeout(this.H),clearTimeout(this.I),this.stateChanged(n.STATUS_TERMINATED),this.ua.destroyTransaction(this))},a.prototype.receiveResponse=function(t,r){var i=this;return new Promise(function(o,s){if(t>=100&&t<=199&&i.state===n.STATUS_PROCEEDING)i.transport.send(r).catch(i.onTransportError),i.last_response=r,t>100&&null===i.resendProvisionalTimer&&(i.resendProvisionalTimer=setInterval(function(){i.transport.send(i.request).catch(function(){i.onTransportError()})},e.Timers.PROVISIONAL_RESPONSE_INTERVAL));else if(t>=200&&t<=299)switch(i.state){case n.STATUS_PROCEEDING:i.stateChanged(n.STATUS_ACCEPTED),i.last_response=r,i.L=setTimeout(i.timer_L,e.Timers.TIMER_L),null!==i.resendProvisionalTimer&&(clearInterval(i.resendProvisionalTimer),i.resendProvisionalTimer=null);case n.STATUS_ACCEPTED:i.transport.send(r).then(o).catch(function(e){i.logger.error(e),i.onTransportError(),s()})}else if(t>=300&&t<=699)switch(i.state){case n.STATUS_PROCEEDING:null!==i.resendProvisionalTimer&&(clearInterval(i.resendProvisionalTimer),i.resendProvisionalTimer=null),i.transport.send(r).then(function(){i.stateChanged(n.STATUS_COMPLETED),i.H=setTimeout(i.timer_H,e.Timers.TIMER_H),o()}).catch(function(e){i.logger.error(e),i.onTransportError(),s()})}})};var c=function(t,r){var i;switch(r.method){case e.C.INVITE:if(i=t.transactions.ist[r.via_branch]){switch(i.state){case n.STATUS_PROCEEDING:i.transport.send(i.last_response)}return!0}break;case e.C.ACK:if(!(i=t.transactions.ist[r.via_branch]))return!1;if(i.state===n.STATUS_ACCEPTED)return!1;if(i.state===n.STATUS_COMPLETED)return i.stateChanged(n.STATUS_CONFIRMED),i.I=setTimeout(i.timer_I.bind(i),e.Timers.TIMER_I),!0;break;case e.C.CANCEL:return i=t.transactions.ist[r.via_branch],i?(r.reply_sl(200),i.state!==n.STATUS_PROCEEDING):(r.reply_sl(481),!0);default:if(i=t.transactions.nist[r.via_branch]){switch(i.state){case n.STATUS_TRYING:break;case n.STATUS_PROCEEDING:case n.STATUS_COMPLETED:i.transport.send(i.last_response)}return!0}}};e.Transactions={C:n,checkTransaction:c,NonInviteClientTransaction:r,InviteClientTransaction:i,AckClientTransaction:o,NonInviteServerTransaction:s,InviteServerTransaction:a}}},function(e,t,n){"use strict";e.exports=function(e){var t,r=n(26)(e),i={STATUS_EARLY:1,STATUS_CONFIRMED:2};t=function(t,n,r,o){var s;if(this.uac_pending_reply=!1,this.uas_pending_reply=!1,!n.hasHeader("contact"))return{error:"unable to create a Dialog without Contact header field"};o=n instanceof e.IncomingResponse?n.status_code<200?i.STATUS_EARLY:i.STATUS_CONFIRMED:o||i.STATUS_CONFIRMED,s=n.parseHeader("contact"),"UAS"===r?(this.id={call_id:n.call_id,local_tag:n.to_tag,remote_tag:n.from_tag,toString:function(){return this.call_id+this.local_tag+this.remote_tag}},this.state=o,this.remote_seqnum=n.cseq,this.local_uri=n.parseHeader("to").uri,this.remote_uri=n.parseHeader("from").uri,this.remote_target=s.uri,this.route_set=n.getHeaders("record-route"),this.invite_seqnum=n.cseq,this.local_seqnum=n.cseq):"UAC"===r&&(this.id={call_id:n.call_id,local_tag:n.from_tag,remote_tag:n.to_tag,toString:function(){return this.call_id+this.local_tag+this.remote_tag}},this.state=o,this.invite_seqnum=n.cseq,this.local_seqnum=n.cseq,this.local_uri=n.parseHeader("from").uri,this.pracked=[],this.remote_uri=n.parseHeader("to").uri,this.remote_target=s.uri,this.route_set=n.getHeaders("record-route").reverse()),this.logger=t.ua.getLogger("sip.dialog",this.id.toString()),this.owner=t,t.ua.dialogs[this.id.toString()]=this,this.logger.log("new "+r+" dialog created with status "+(this.state===i.STATUS_EARLY?"EARLY":"CONFIRMED")),t.emit("dialog",this)},t.prototype={update:function(e,t){this.state=i.STATUS_CONFIRMED,this.logger.log("dialog "+this.id.toString()+"  changed to CONFIRMED state"),"UAC"===t&&(this.route_set=e.getHeaders("record-route").reverse())},terminate:function(){this.logger.log("dialog "+this.id.toString()+" deleted"),this.sessionDescriptionHandler&&this.state!==i.STATUS_CONFIRMED&&this.sessionDescriptionHandler.close(),delete this.owner.ua.dialogs[this.id.toString()]},createRequest:function(t,n,r){var i,o;return n=(n||[]).slice(),this.local_seqnum||(this.local_seqnum=Math.floor(1e4*Math.random())),i=t===e.C.CANCEL||t===e.C.ACK?this.invite_seqnum:this.local_seqnum+=1,o=new e.OutgoingRequest(t,this.remote_target,this.owner.ua,{cseq:i,call_id:this.id.call_id,from_uri:this.local_uri,from_tag:this.id.local_tag,to_uri:this.remote_uri,to_tag:this.id.remote_tag,route_set:this.route_set},n,r),o.dialog=this,o},checkInDialogRequest:function(t){var n=this;if(this.remote_seqnum){if(t.cseq<this.remote_seqnum)return t.method!==e.C.ACK&&t.reply(500),t.cseq===this.invite_seqnum}else this.remote_seqnum=t.cseq;switch(t.method){case e.C.INVITE:if(!0===this.uac_pending_reply)t.reply(491);else{if(!0===this.uas_pending_reply&&t.cseq>this.remote_seqnum){var r=1+(10*Math.random()|0);return t.reply(500,null,["Retry-After:"+r]),this.remote_seqnum=t.cseq,!1}this.uas_pending_reply=!0,t.server_transaction.on("stateChanged",function t(){this.state!==e.Transactions.C.STATUS_ACCEPTED&&this.state!==e.Transactions.C.STATUS_COMPLETED&&this.state!==e.Transactions.C.STATUS_TERMINATED||(this.removeListener("stateChanged",t),n.uas_pending_reply=!1)})}t.hasHeader("contact")&&t.server_transaction.on("stateChanged",function(){this.state===e.Transactions.C.STATUS_ACCEPTED&&(n.remote_target=t.parseHeader("contact").uri)});break;case e.C.NOTIFY:t.hasHeader("contact")&&t.server_transaction.on("stateChanged",function(){this.state===e.Transactions.C.STATUS_COMPLETED&&(n.remote_target=t.parseHeader("contact").uri)})}return t.cseq>this.remote_seqnum&&(this.remote_seqnum=t.cseq),!0},sendRequest:function(e,t,n){n=n||{};var i=(n.extraHeaders||[]).slice(),o=null;n.body&&(n.body.body?o=n.body:(o={},o.body=n.body,n.contentType&&(o.contentType=n.contentType)));var s=this.createRequest(t,i,o);return new r(this,e,s).send(),s},receiveRequest:function(e){this.checkInDialogRequest(e)&&this.owner.receiveRequest(e)}},t.C=i,e.Dialog=t}},function(e,t,n){"use strict";e.exports=function(e){var t;return t=function(e,t,n){this.dialog=e,this.applicant=t,this.request=n,this.reattempt=!1,this.reattemptTimer=null},t.prototype={send:function(){var t=this,n=new e.RequestSender(this,this.dialog.owner.ua);n.send(),this.request.method===e.C.INVITE&&n.clientTransaction.state!==e.Transactions.C.STATUS_TERMINATED&&(this.dialog.uac_pending_reply=!0,n.clientTransaction.on("stateChanged",function n(){this.state!==e.Transactions.C.STATUS_ACCEPTED&&this.state!==e.Transactions.C.STATUS_COMPLETED&&this.state!==e.Transactions.C.STATUS_TERMINATED||(this.removeListener("stateChanged",n),t.dialog.uac_pending_reply=!1)}))},onRequestTimeout:function(){this.applicant.onRequestTimeout()},onTransportError:function(){this.applicant.onTransportError()},receiveResponse:function(t){var n=this;408===t.status_code||481===t.status_code?this.applicant.onDialogError(t):t.method===e.C.INVITE&&491===t.status_code?this.reattempt?this.applicant.receiveResponse(t):(this.request.cseq.value=this.dialog.local_seqnum+=1,this.reattemptTimer=setTimeout(function(){n.applicant.owner.status!==e.Session.C.STATUS_TERMINATED&&(n.reattempt=!0,n.request_sender.send())},this.getReattemptTimeout())):this.applicant.receiveResponse(t)}},t}},function(e,t,n){"use strict";e.exports=function(e){var t;t=function(t,n){this.logger=n.getLogger("sip.requestsender"),this.ua=n,this.applicant=t,this.method=t.request.method,this.request=t.request,this.credentials=null,this.challenged=!1,this.staled=!1,n.status!==e.UA.C.STATUS_USER_CLOSED||this.method===e.C.BYE&&this.method===e.C.ACK||this.onTransportError()},t.prototype={send:function(){switch(this.method){case"INVITE":this.clientTransaction=new e.Transactions.InviteClientTransaction(this,this.request,this.ua.transport);break;case"ACK":this.clientTransaction=new e.Transactions.AckClientTransaction(this,this.request,this.ua.transport);break;default:this.clientTransaction=new e.Transactions.NonInviteClientTransaction(this,this.request,this.ua.transport)}return this.clientTransaction.send(),this.clientTransaction},onRequestTimeout:function(){this.applicant.onRequestTimeout()},onTransportError:function(){this.applicant.onTransportError()},receiveResponse:function(t){var n,r,i,o=t.status_code;if(401===o||407===o){if(401===t.status_code?(r=t.parseHeader("www-authenticate"),i="authorization"):(r=t.parseHeader("proxy-authenticate"),i="proxy-authorization"),!r)return this.logger.warn(t.status_code+" with wrong or missing challenge, cannot authenticate"),void this.applicant.receiveResponse(t);if(!this.challenged||!this.staled&&!0===r.stale){if(this.credentials||(this.credentials=this.ua.configuration.authenticationFactory(this.ua)),!this.credentials.authenticate(this.request,r))return void this.applicant.receiveResponse(t);this.challenged=!0,r.stale&&(this.staled=!0),t.method===e.C.REGISTER?n=this.applicant.cseq+=1:this.request.dialog?n=this.request.dialog.local_seqnum+=1:(n=this.request.cseq+1,this.request.cseq=n),this.request.setHeader("cseq",n+" "+this.method),this.request.setHeader(i,this.credentials.toString()),this.send()}else this.applicant.receiveResponse(t)}else this.applicant.receiveResponse(t)}},e.RequestSender=t}},function(e,t,n){"use strict";e.exports=function(e){var t;t=function(t,n){if(void 0===n&&(n={}),this.options={},this.logger=t.getLogger("sip.registercontext"),this.loadConfig(n),this.options.regId&&!this.options.instanceId?this.options.instanceId=e.Utils.newUUID():!this.options.regId&&this.options.instanceId&&(this.options.regId=1),this.options.params.to_uri=this.options.params.to_uri||t.configuration.uri,this.options.params.to_displayName=this.options.params.to_displayName||t.configuration.displayName,this.options.params.call_id=this.options.params.call_id||e.Utils.createRandomToken(22),this.options.params.cseq=this.options.params.cseq||Math.floor(1e4*Math.random()),!this.options.registrar){var r={};"object"==typeof t.configuration.uri?(r=t.configuration.uri.clone(),r.user=null):r=t.configuration.uri,this.options.registrar=r}this.expires=this.options.expires,this.cseq=this.options.params.cseq,this.contact=t.contact.toString(),e.Utils.augment(this,e.ClientContext,[t,"REGISTER",this.options.registrar,this.options]),this.registrationTimer=null,this.registrationExpiredTimer=null,this.registered=!1,t.on("transportCreated",function(e){e.on("disconnected",this.onTransportDisconnected.bind(this))}.bind(this))},t.prototype=Object.create({},{loadConfig:{writable:!0,value:function(t){var n,r,i,o={expires:600,extraContactHeaderParams:[],instanceId:null,params:{},regId:null,registrar:null},s=this.getConfigurationCheck();for(n in s.mandatory){if(!t.hasOwnProperty(n))throw new e.Exceptions.ConfigurationError(n);if(r=t[n],void 0===(i=s.mandatory[n](r)))throw new e.Exceptions.ConfigurationError(n,r);o[n]=i}for(n in s.optional)if(t.hasOwnProperty(n)){if((r=t[n])instanceof Array&&0===r.length)continue;if(null===r||""===r||void 0===r)continue;if("number"==typeof r&&isNaN(r))continue;if(void 0===(i=s.optional[n](r)))throw new e.Exceptions.ConfigurationError(n,r);o[n]=i}Object.assign(this.options,o),this.logger.log("configuration parameters for RegisterContext after validation:");for(n in o)this.logger.log("· "+n+": "+JSON.stringify(o[n]))}},getConfigurationCheck:{writable:!0,value:function(){return{mandatory:{},optional:{expires:function(t){if(e.Utils.isDecimal(t)){var n=Number(t);if(n>=0)return n}},extraContactHeaderParams:function(e){if(e instanceof Array)return e.filter(function(e){return"string"==typeof e})},instanceId:function(t){if("string"==typeof t)return/^uuid:/i.test(t)&&(t=t.substr(5)),-1===e.Grammar.parse(t,"uuid")?void 0:t},params:function(e){if("object"==typeof e)return e},regId:function(t){if(e.Utils.isDecimal(t)){var n=Number(t);if(n>=0)return n}},registrar:function(t){if("string"==typeof t){/^sip:/i.test(t)||(t=e.C.SIP+":"+t);var n=e.URI.parse(t);return n?n.user?void 0:n:void 0}}}}}},generateContactHeader:{writable:!0,value:function(e){void 0===e&&(e=0);var t=this.contact;return this.options.regId&&this.options.instanceId&&(t+=";reg-id="+this.options.regId,t+=';+sip.instance="<urn:uuid:'+this.options.instanceId+'>"'),this.options.extraContactHeaderParams&&this.options.extraContactHeaderParams.forEach(function(e){t+=";"+e}),t+=";expires="+e}},register:{writable:!0,value:function(t){void 0===t&&(t={}),this.options=Object.assign(this.options||{},t);var n=(this.options.extraHeaders||[]).slice();n.push("Contact: "+this.generateContactHeader(this.expires)),n.push("Allow: "+e.UA.C.ALLOWED_METHODS.toString()),this.closeHeaders=this.options.closeWithHeaders?(this.options.extraHeaders||[]).slice():[],this.receiveResponse=function(t){var n,r,i,o=this,s=t.getHeaders("contact").length;if(t.cseq===this.cseq)switch(null!==this.registrationTimer&&(clearTimeout(this.registrationTimer),this.registrationTimer=null),!0){case/^1[0-9]{2}$/.test(t.status_code):this.emit("progress",t);break;case/^2[0-9]{2}$/.test(t.status_code):if(this.emit("accepted",t),t.hasHeader("expires")&&(r=t.getHeader("expires")),null!==this.registrationExpiredTimer&&(clearTimeout(this.registrationExpiredTimer),this.registrationExpiredTimer=null),!s){this.logger.warn("no Contact header in response to REGISTER, response ignored");break}for(;s--;){if(n=t.parseHeader("contact",s),n.uri.user===this.ua.contact.uri.user){r=n.getParam("expires");break}n=null}if(!n){this.logger.warn("no Contact header pointing to us, response ignored");break}r||(r=this.expires),this.registrationTimer=setTimeout(function(){o.registrationTimer=null,o.register(o.options)},1e3*r-3e3),this.registrationExpiredTimer=setTimeout(function(){o.logger.warn("registration expired"),o.registered&&o.unregistered(null,e.C.causes.EXPIRES)},1e3*r),n.hasParam("temp-gruu")&&(this.ua.contact.temp_gruu=e.URI.parse(n.getParam("temp-gruu").replace(/"/g,""))),n.hasParam("pub-gruu")&&(this.ua.contact.pub_gruu=e.URI.parse(n.getParam("pub-gruu").replace(/"/g,""))),this.registered=!0,this.emit("registered",t||null);break;case/^423$/.test(t.status_code):t.hasHeader("min-expires")?(this.expires=t.getHeader("min-expires"),this.register(this.options)):(this.logger.warn("423 response received for REGISTER without Min-Expires"),this.registrationFailure(t,e.C.causes.SIP_FAILURE_CODE));break;default:i=e.Utils.sipErrorCause(t.status_code),this.registrationFailure(t,i)}},this.onRequestTimeout=function(){this.registrationFailure(null,e.C.causes.REQUEST_TIMEOUT)},this.onTransportError=function(){this.registrationFailure(null,e.C.causes.CONNECTION_ERROR)},this.cseq++,this.request.cseq=this.cseq,this.request.setHeader("cseq",this.cseq+" REGISTER"),this.request.extraHeaders=n,this.send()}},registrationFailure:{writable:!0,value:function(e,t){this.emit("failed",e||null,t||null)}},onTransportDisconnected:{writable:!0,value:function(){this.registered_before=this.registered,null!==this.registrationTimer&&(clearTimeout(this.registrationTimer),this.registrationTimer=null),null!==this.registrationExpiredTimer&&(clearTimeout(this.registrationExpiredTimer),this.registrationExpiredTimer=null),this.registered&&this.unregistered(null,e.C.causes.CONNECTION_ERROR)}},close:{writable:!0,value:function(){var e={all:!1,extraHeaders:this.closeHeaders};this.registered_before=this.registered,this.registered&&this.unregister(e)}},unregister:{writable:!0,value:function(t){var n;t=t||{},this.registered||t.all||this.logger.warn("Already unregistered, but sending an unregister anyways."),n=(t.extraHeaders||[]).slice(),this.registered=!1,null!==this.registrationTimer&&(clearTimeout(this.registrationTimer),this.registrationTimer=null),t.all?(n.push("Contact: *"),n.push("Expires: 0")):n.push("Contact: "+this.generateContactHeader(0)),this.receiveResponse=function(t){var n;switch(!0){case/^1[0-9]{2}$/.test(t.status_code):this.emit("progress",t);break;case/^2[0-9]{2}$/.test(t.status_code):this.emit("accepted",t),null!==this.registrationExpiredTimer&&(clearTimeout(this.registrationExpiredTimer),this.registrationExpiredTimer=null),this.unregistered(t);break;default:n=e.Utils.sipErrorCause(t.status_code),this.unregistered(t,n)}},this.onRequestTimeout=function(){},this.cseq++,this.request.cseq=this.cseq,this.request.setHeader("cseq",this.cseq+" REGISTER"),this.request.extraHeaders=n,this.send()}},unregistered:{writable:!0,value:function(e,t){this.registered=!1,this.emit("unregistered",e||null,t||null)}}}),e.RegisterContext=t}},function(e,t,n){"use strict";e.exports=function(e){var t=function(){};return t.prototype=Object.create(e.prototype,{close:{value:function(){}},getDescription:{value:function(e,t){}},hasDescription:{value:function(e){}},holdModifier:{value:function(e){}},setDescription:{value:function(e,t,n){}},sendDtmf:{value:function(e,t){}},getDirection:{value:function(){}}}),t}},function(e,t,n){"use strict";e.exports=function(e){var t;t=function(t,n,r,i){var o=r;if(void 0===r)throw new TypeError("Not enough arguments");if(this.ua=t,this.logger=t.getLogger("sip.clientcontext"),this.method=n,!(r=t.normalizeTarget(r)))throw new TypeError("Invalid target: "+o);i=Object.create(i||Object.prototype),i.extraHeaders=(i.extraHeaders||[]).slice(),this.request=new e.OutgoingRequest(this.method,r,this.ua,i.params,i.extraHeaders),i.body&&(this.body={},this.body.body=i.body,i.contentType&&(this.body.contentType=i.contentType),this.request.body=this.body),this.localIdentity=this.request.from,this.remoteIdentity=this.request.to,this.data={}},t.prototype=Object.create(e.EventEmitter.prototype),t.prototype.send=function(){return new e.RequestSender(this,this.ua).send(),this},t.prototype.cancel=function(t){t=t||{},t.extraHeaders=(t.extraHeaders||[]).slice();var n=e.Utils.getCancelReason(t.status_code,t.reason_phrase);this.request.cancel(n,t.extraHeaders),this.emit("cancel")},t.prototype.receiveResponse=function(t){var n=e.Utils.getReasonPhrase(t.status_code);switch(!0){case/^1[0-9]{2}$/.test(t.status_code):this.emit("progress",t,n);break;case/^2[0-9]{2}$/.test(t.status_code):this.ua.applicants[this]&&delete this.ua.applicants[this],this.emit("accepted",t,n);break;default:this.ua.applicants[this]&&delete this.ua.applicants[this],this.emit("rejected",t,n),this.emit("failed",t,n)}},t.prototype.onRequestTimeout=function(){this.emit("failed",null,e.C.causes.REQUEST_TIMEOUT)},t.prototype.onTransportError=function(){this.emit("failed",null,e.C.causes.CONNECTION_ERROR)},e.ClientContext=t}},function(e,t,n){"use strict";e.exports=function(e){var t;t=function(t,n){this.ua=t,this.logger=t.getLogger("sip.servercontext"),this.request=n,n.method===e.C.INVITE?this.transaction=new e.Transactions.InviteServerTransaction(n,t):this.transaction=new e.Transactions.NonInviteServerTransaction(n,t),n.body&&(this.body=n.body),n.hasHeader("Content-Type")&&(this.contentType=n.getHeader("Content-Type")),this.method=n.method,this.data={},this.localIdentity=n.to,this.remoteIdentity=n.from,n.hasHeader("P-Asserted-Identity")&&(this.assertedIdentity=new e.NameAddrHeader.parse(n.getHeader("P-Asserted-Identity")))},t.prototype=Object.create(e.EventEmitter.prototype),t.prototype.progress=function(e){return e=Object.create(e||Object.prototype),e.statusCode||(e.statusCode=180),e.minCode=100,e.maxCode=199,e.events=["progress"],this.reply(e)},t.prototype.accept=function(e){return e=Object.create(e||Object.prototype),e.statusCode||(e.statusCode=200),e.minCode=200,e.maxCode=299,e.events=["accepted"],this.reply(e)},t.prototype.reject=function(e){return e=Object.create(e||Object.prototype),e.statusCode||(e.statusCode=480),e.minCode=300,e.maxCode=699,e.events=["rejected","failed"],this.reply(e)},t.prototype.reply=function(t){t=t||{};var n,r=t.statusCode||100,i=t.minCode||100,o=t.maxCode||699,s=e.Utils.getReasonPhrase(r,t.reasonPhrase),a=t.extraHeaders||[],c=t.body,u=t.events||[];if(r<i||r>o)throw new TypeError("Invalid statusCode: "+r);return n=this.request.reply(r,s,a,c),u.forEach(function(e){this.emit(e,n,s)},this),this},t.prototype.onRequestTimeout=function(){this.emit("failed",null,e.C.causes.REQUEST_TIMEOUT)},t.prototype.onTransportError=function(){this.emit("failed",null,e.C.causes.CONNECTION_ERROR)},e.ServerContext=t}},function(e,t,n){"use strict";e.exports=function(e){var t,r,i,o,s,a=n(33)(e),c={STATUS_NULL:0,STATUS_INVITE_SENT:1,STATUS_1XX_RECEIVED:2,STATUS_INVITE_RECEIVED:3,STATUS_WAITING_FOR_ANSWER:4,STATUS_ANSWERED:5,STATUS_WAITING_FOR_PRACK:6,STATUS_WAITING_FOR_ACK:7,STATUS_CANCELED:8,STATUS_TERMINATED:9,STATUS_ANSWERED_WAITING_FOR_PRACK:10,STATUS_EARLY_MEDIA:11,STATUS_CONFIRMED:12};t=function(t){if(this.status=c.STATUS_NULL,this.dialog=null,this.pendingReinvite=!1,this.earlyDialogs={},!t)throw new e.Exceptions.SessionDescriptionHandlerMissing("A session description handler is required for the session to function");this.sessionDescriptionHandlerFactory=t,this.hasOffer=!1,this.hasAnswer=!1,this.timers={ackTimer:null,expiresTimer:null,invite2xxTimer:null,userNoAnswerTimer:null,rel1xxTimer:null,prackTimer:null},this.startTime=null,this.endTime=null,this.tones=null,this.local_hold=!1,this.early_sdp=null,this.rel100=e.C.supported.UNSUPPORTED},t.prototype={dtmf:function(t,n){var r=[],i=this,o=this.ua.configuration.dtmfType;if(n=n||{},void 0===t)throw new TypeError("Not enough arguments");if(this.status!==c.STATUS_CONFIRMED&&this.status!==c.STATUS_WAITING_FOR_ACK)throw new e.Exceptions.InvalidStateError(this.status);if("string"!=typeof t&&"number"!=typeof t||!t.toString().match(/^[0-9A-D#*,]+$/i))throw new TypeError("Invalid tones: "+t);var s=function(){var e,t;if(i.status===c.STATUS_TERMINATED||!i.tones||0===i.tones.length)return i.tones=null,this;e=i.tones.shift(),e.on("failed",function(){i.tones=null}),e.send(n),t=e.duration+e.interToneGap,setTimeout(s,t)};if(t=t.toString(),o===e.C.dtmfType.RTP&&(this.sessionDescriptionHandler.sendDtmf(t,n)||(this.logger.warn("Attempt to use dtmfType 'RTP' has failed, falling back to INFO packet method"),o=e.C.dtmfType.INFO)),o===e.C.dtmfType.INFO){for(t=t.split("");t.length>0;)r.push(new a(this,t.shift(),n));if(this.tones)return this.tones=this.tones.concat(r),this;this.tones=r,s()}return this},bye:function(t){t=Object.create(t||Object.prototype);var n=t.statusCode;if(this.status===c.STATUS_TERMINATED)return this.logger.error("Error: Attempted to send BYE in a terminated session."),this;if(this.logger.log("terminating Session"),n&&(n<200||n>=700))throw new TypeError("Invalid statusCode: "+n);return t.receiveResponse=function(){},this.sendRequest(e.C.BYE,t).terminated()},refer:function(t,n){if(n=n||{},this.status!==c.STATUS_CONFIRMED)throw new e.Exceptions.InvalidStateError(this.status);return this.referContext=new e.ReferClientContext(this.ua,this,t,n),this.emit("referRequested",this.referContext),this.referContext.refer(n),this.referContext},sendRequest:function(t,n){n=n||{};var r=this,i=new e.OutgoingRequest(t,this.dialog.remote_target,this.ua,{cseq:n.cseq||(this.dialog.local_seqnum+=1),call_id:this.dialog.id.call_id,from_uri:this.dialog.local_uri,from_tag:this.dialog.id.local_tag,to_uri:this.dialog.remote_uri,to_tag:this.dialog.id.remote_tag,route_set:this.dialog.route_set,statusCode:n.statusCode,reasonPhrase:n.reasonPhrase},n.extraHeaders||[],n.body);return new e.RequestSender({request:i,onRequestTimeout:function(){r.onRequestTimeout()},onTransportError:function(){r.onTransportError()},receiveResponse:n.receiveResponse||function(e){r.receiveNonInviteResponse(e)}},this.ua).send(),this.emit(t.toLowerCase(),i),this},close:function(){var e;if(this.status===c.STATUS_TERMINATED)return this;this.logger.log("closing INVITE session "+this.id),this.sessionDescriptionHandler&&this.sessionDescriptionHandler.close();for(e in this.timers)clearTimeout(this.timers[e]);this.dialog&&(this.dialog.terminate(),delete this.dialog);for(e in this.earlyDialogs)this.earlyDialogs[e].terminate(),delete this.earlyDialogs[e];return this.status=c.STATUS_TERMINATED,this.ua.transport.removeListener("transportError",this.errorListener),delete this.ua.sessions[this.id],this},createDialog:function(t,n,r){var i,o,s=t["UAS"===n?"to_tag":"from_tag"],a=t["UAS"===n?"from_tag":"to_tag"],c=t.call_id+s+a;if(o=this.earlyDialogs[c],r)return!!o||(o=new e.Dialog(this,t,n,e.Dialog.C.STATUS_EARLY),o.error?(this.logger.error(o.error),this.failed(t,e.C.causes.INTERNAL_ERROR),!1):(this.earlyDialogs[c]=o,!0));if(o){o.update(t,n),this.dialog=o,delete this.earlyDialogs[c];for(var u in this.earlyDialogs)this.earlyDialogs[u].terminate(),delete this.earlyDialogs[u];return!0}return i=new e.Dialog(this,t,n),i.error?(this.logger.error(i.error),this.failed(t,e.C.causes.INTERNAL_ERROR),!1):(this.to_tag=t.to_tag,this.dialog=i,!0)},hold:function(t,n){if(this.status!==c.STATUS_WAITING_FOR_ACK&&this.status!==c.STATUS_CONFIRMED)throw new e.Exceptions.InvalidStateError(this.status);if(this.local_hold)return void this.logger.log("Session is already on hold, cannot put it on hold again");t=t||{},t.modifiers=n||[],t.modifiers.push(this.sessionDescriptionHandler.holdModifier),this.local_hold=!0,this.sendReinvite(t)},unhold:function(t,n){if(this.status!==c.STATUS_WAITING_FOR_ACK&&this.status!==c.STATUS_CONFIRMED)throw new e.Exceptions.InvalidStateError(this.status);if(!this.local_hold)return void this.logger.log("Session is not on hold, cannot unhold it");t=t||{},n&&(t.modifiers=n),this.local_hold=!1,this.sendReinvite(t)},reinvite:function(e,t){return e=e||{},t&&(e.modifiers=t),this.sendReinvite(e)},receiveReinvite:function(t){var n,r=this;if(r.emit("reinvite",this),t.hasHeader("P-Asserted-Identity")&&(this.assertedIdentity=new e.NameAddrHeader.parse(t.getHeader("P-Asserted-Identity"))),"0"!==t.getHeader("Content-Length")||t.getHeader("Content-Type")){if(!this.sessionDescriptionHandler.hasDescription(t.getHeader("Content-Type")))return t.reply(415),void this.emit("reinviteFailed",r);n=this.sessionDescriptionHandler.setDescription(t.body,this.sessionDescriptionHandlerOptions,this.modifiers).then(this.sessionDescriptionHandler.getDescription.bind(this.sessionDescriptionHandler,this.sessionDescriptionHandlerOptions,this.modifiers))}else n=this.sessionDescriptionHandler.getDescription(this.sessionDescriptionHandlerOptions,this.modifiers);this.receiveRequest=function(t){t.method===e.C.ACK&&this.status===c.STATUS_WAITING_FOR_ACK?this.sessionDescriptionHandler.hasDescription(t.getHeader("Content-Type"))?(this.hasAnswer=!0,this.sessionDescriptionHandler.setDescription(t.body,this.sessionDescriptionHandlerOptions,this.modifiers).then(function(){clearTimeout(this.timers.ackTimer),clearTimeout(this.timers.invite2xxTimer),this.status=c.STATUS_CONFIRMED,this.emit("confirmed",t)}.bind(this))):(clearTimeout(this.timers.ackTimer),clearTimeout(this.timers.invite2xxTimer),this.status=c.STATUS_CONFIRMED,this.emit("confirmed",t)):e.Session.prototype.receiveRequest.apply(this,[t])}.bind(this),n.catch(function(n){var i;throw n instanceof e.Exceptions.SessionDescriptionHandlerError?i=500:n instanceof e.Exceptions.RenegotiationError?(r.emit("renegotiationError",n),r.logger.warn(n),i=488):(r.logger.error(n),i=488),t.reply(i),r.emit("reinviteFailed",r),n}).then(function(e){var n=["Contact: "+r.contact];t.reply(200,null,n,e,function(){r.status=c.STATUS_WAITING_FOR_ACK,r.setACKTimer(),r.emit("reinviteAccepted",r)})})},sendReinvite:function(t){if(this.pendingReinvite)return void this.logger.warn("Reinvite in progress. Please wait until complete, then try again.");this.pendingReinvite=!0,t=t||{},t.modifiers=t.modifiers||[];var n=this,r=(t.extraHeaders||[]).slice();r.push("Contact: "+this.contact),r.push("Allow: "+e.UA.C.ALLOWED_METHODS.toString()),this.sessionDescriptionHandler.getDescription(t.sessionDescriptionHandlerOptions,t.modifiers).then(function(t){n.sendRequest(e.C.INVITE,{extraHeaders:r,body:t,receiveResponse:n.receiveReinviteResponse.bind(n)})}).catch(function(t){if(t instanceof e.Exceptions.RenegotiationError)throw n.pendingReinvite=!1,n.emit("renegotiationError",t),n.logger.warn("Renegotiation Error"),n.logger.warn(t),t;throw n.logger.error("sessionDescriptionHandler error"),n.logger.error(t),t})},receiveRequest:function(t){switch(t.method){case e.C.BYE:t.reply(200),this.status===c.STATUS_CONFIRMED&&(this.emit("bye",t),this.terminated(t,e.C.causes.BYE));break;case e.C.INVITE:this.status===c.STATUS_CONFIRMED&&(this.logger.log("re-INVITE received"),this.receiveReinvite(t));break;case e.C.INFO:if(this.status===c.STATUS_CONFIRMED||this.status===c.STATUS_WAITING_FOR_ACK){if(this.onInfo)return this.onInfo(t);var n,r,i,o=t.getHeader("content-type"),s=/^(Signal\s*?=\s*?)([0-9A-D#*]{1})(\s)?.*/,u=/^(Duration\s?=\s?)([0-9]{1,4})(\s)?.*/;o&&(o.match(/^application\/dtmf-relay/i)?(t.body&&(n=t.body.split("\r\n",2),2===n.length&&(s.test(n[0])&&(r=n[0].replace(s,"$2")),u.test(n[1])&&(i=parseInt(n[1].replace(u,"$2"),10)))),new a(this,r,{duration:i}).init_incoming(t)):t.reply(415,null,["Accept: application/dtmf-relay"]))}break;case e.C.REFER:if(this.status===c.STATUS_CONFIRMED)if(this.logger.log("REFER received"),this.referContext=new e.ReferServerContext(this.ua,t),this.listeners("referRequested").length)this.emit("referRequested",this.referContext);else{this.logger.log("No referRequested listeners, automatically accepting and following the refer");var l={followRefer:!0};this.passedOptions&&(l.inviteOptions=this.passedOptions),this.referContext.accept(l,this.modifiers)}break;case e.C.NOTIFY:if(this.referContext&&this.referContext instanceof e.ReferClientContext&&t.hasHeader("event")&&/^refer(;.*)?$/.test(t.getHeader("event")))return void this.referContext.receiveNotify(t);t.reply(200,"OK"),this.emit("notify",t)}},receiveReinviteResponse:function(t){var n=this;if(this.status===c.STATUS_TERMINATED)return void this.logger.error("Received reinvite response, but in STATUS_TERMINATED");if(!this.pendingReinvite)return void this.logger.error("Received reinvite response, but have no pending reinvite");switch(!0){case/^1[0-9]{2}$/.test(t.status_code):break;case/^2[0-9]{2}$/.test(t.status_code):if(this.status=c.STATUS_CONFIRMED,this.emit("ack",t.transaction.sendACK()),this.pendingReinvite=!1,clearTimeout(n.timers.invite2xxTimer),!this.sessionDescriptionHandler.hasDescription(t.getHeader("Content-Type"))){this.logger.error("2XX response received to re-invite but did not have a description"),this.emit("reinviteFailed",n),this.emit("renegotiationError",new e.Exceptions.RenegotiationError("2XX response received to re-invite but did not have a description"));break}this.sessionDescriptionHandler.setDescription(t.body,this.sessionDescriptionHandlerOptions,this.modifiers).catch(function(t){throw n.logger.error("Could not set the description in 2XX response"),n.logger.error(t),n.emit("reinviteFailed",n),n.emit("renegotiationError",t),n.sendRequest(e.C.BYE,{extraHeaders:["Reason: "+e.Utils.getReasonHeaderValue(488,"Not Acceptable Here")]}),n.terminated(null,e.C.causes.INCOMPATIBLE_SDP),t}).then(function(){n.emit("reinviteAccepted",n)});break;default:this.pendingReinvite=!1,this.logger.log("Received a non 1XX or 2XX response to a re-invite"),this.emit("reinviteFailed",n),this.emit("renegotiationError",new e.Exceptions.RenegotiationError("Invalid response to a re-invite"))}},acceptAndTerminate:function(t,n,r){var i=[];return n&&i.push("Reason: "+e.Utils.getReasonHeaderValue(n,r)),(this.dialog||this.createDialog(t,"UAC"))&&(this.emit("ack",t.transaction.sendACK()),this.sendRequest(e.C.BYE,{extraHeaders:i})),this},setInvite2xxTimer:function(t,n){var r=this,i=e.Timers.T1;this.timers.invite2xxTimer=setTimeout(function o(){if(r.status===c.STATUS_WAITING_FOR_ACK){r.logger.log("no ACK received, attempting to retransmit OK");var s=["Contact: "+r.contact];t.reply(200,null,s,n),i=Math.min(2*i,e.Timers.T2),r.timers.invite2xxTimer=setTimeout(o,i)}},i)},setACKTimer:function(){var t=this;this.timers.ackTimer=setTimeout(function(){t.status===c.STATUS_WAITING_FOR_ACK&&(t.logger.log("no ACK received for an extended period of time, terminating the call"),clearTimeout(t.timers.invite2xxTimer),t.sendRequest(e.C.BYE),t.terminated(null,e.C.causes.NO_ACK))},e.Timers.TIMER_H)},onTransportError:function(){this.status!==c.STATUS_CONFIRMED&&this.status!==c.STATUS_TERMINATED&&this.failed(null,e.C.causes.CONNECTION_ERROR)},onRequestTimeout:function(){this.status===c.STATUS_CONFIRMED?this.terminated(null,e.C.causes.REQUEST_TIMEOUT):this.status!==c.STATUS_TERMINATED&&(this.failed(null,e.C.causes.REQUEST_TIMEOUT),this.terminated(null,e.C.causes.REQUEST_TIMEOUT))},onDialogError:function(t){this.status===c.STATUS_CONFIRMED?this.terminated(t,e.C.causes.DIALOG_ERROR):this.status!==c.STATUS_TERMINATED&&(this.failed(t,e.C.causes.DIALOG_ERROR),this.terminated(t,e.C.causes.DIALOG_ERROR))},failed:function(e,t){return this.status===c.STATUS_TERMINATED?this:(this.emit("failed",e||null,t||null),this)},rejected:function(e,t){return this.emit("rejected",e||null,t||null),this},canceled:function(){return this.sessionDescriptionHandler&&this.sessionDescriptionHandler.close(),this.emit("cancel"),this},accepted:function(t,n){return n=e.Utils.getReasonPhrase(t&&t.status_code,n),this.startTime=new Date,this.replacee&&(this.replacee.emit("replaced",this),this.replacee.terminate()),this.emit("accepted",t,n),this},terminated:function(e,t){return this.status===c.STATUS_TERMINATED?this:(this.endTime=new Date,this.close(),this.emit("terminated",e||null,t||null),this)},connecting:function(e){return this.emit("connecting",{request:e}),this}},t.C=c,e.Session=t,r=function(t,n){function r(e,t){n.hasHeader(e)&&n.getHeader(e).toLowerCase().indexOf("100rel")>=0&&(o.rel100=t)}var i,o=this,s=n.getHeader("Content-Type"),a=n.parseHeader("Content-Disposition");if(e.Utils.augment(this,e.ServerContext,[t,n]),e.Utils.augment(this,e.Session,[t.configuration.sessionDescriptionHandlerFactory]),a&&"render"===a.type&&(this.renderbody=n.body,this.rendertype=s),this.status=c.STATUS_INVITE_RECEIVED,this.from_tag=n.from_tag,this.id=n.call_id+this.from_tag,this.request=n,this.contact=this.ua.contact.toString(),this.receiveNonInviteResponse=function(){},this.logger=t.getLogger("sip.inviteservercontext",this.id),this.ua.sessions[this.id]=this,n.hasHeader("expires")&&(i=1e3*n.getHeader("expires")),r("require",e.C.supported.REQUIRED),r("supported",e.C.supported.SUPPORTED),n.to_tag=e.Utils.newTag(),!this.createDialog(n,"UAS",!0))return void n.reply(500,"Missing Contact header field");var u={extraHeaders:["Contact: "+o.contact]};o.rel100!==e.C.supported.REQUIRED&&o.progress(u),o.status=c.STATUS_WAITING_FOR_ANSWER,o.timers.userNoAnswerTimer=setTimeout(function(){n.reply(408),o.failed(n,e.C.causes.NO_ANSWER),o.terminated(n,e.C.causes.NO_ANSWER)},o.ua.configuration.noAnswerTimeout),i&&(o.timers.expiresTimer=setTimeout(function(){o.status===c.STATUS_WAITING_FOR_ANSWER&&(n.reply(487),o.failed(n,e.C.causes.EXPIRES),o.terminated(n,e.C.causes.EXPIRES))},i)),this.errorListener=this.onTransportError.bind(this),t.transport.on("transportError",this.errorListener)},r.prototype=Object.create({},{reject:{writable:!0,value:function(t){if(this.status===c.STATUS_TERMINATED)throw new e.Exceptions.InvalidStateError(this.status);return this.logger.log("rejecting RTCSession"),e.ServerContext.prototype.reject.call(this,t),this.terminated()}},terminate:{writable:!0,value:function(t){t=t||{};var n,r=(t.extraHeaders||[]).slice(),i=t.body,o=this;return this.status===c.STATUS_WAITING_FOR_ACK&&this.request.server_transaction.state!==e.Transactions.C.STATUS_TERMINATED?(n=this.dialog,this.receiveRequest=function(t){t.method===e.C.ACK&&(this.sendRequest(e.C.BYE,{extraHeaders:r}),n.terminate())},this.request.server_transaction.on("stateChanged",function(){this.state===e.Transactions.C.STATUS_TERMINATED&&this.dialog&&(this.request=new e.OutgoingRequest(e.C.BYE,this.dialog.remote_target,this.ua,{cseq:this.dialog.local_seqnum+=1,call_id:this.dialog.id.call_id,from_uri:this.dialog.local_uri,from_tag:this.dialog.id.local_tag,to_uri:this.dialog.remote_uri,to_tag:this.dialog.id.remote_tag,route_set:this.dialog.route_set},r,i),new e.RequestSender({request:this.request,onRequestTimeout:function(){o.onRequestTimeout()},onTransportError:function(){o.onTransportError()},receiveResponse:function(){}},this.ua).send(),n.terminate())}),this.emit("bye",this.request),this.terminated(),this.dialog=n,this.ua.dialogs[n.id.toString()]=n):this.status===c.STATUS_CONFIRMED?this.bye(t):this.reject(t),this}},progress:{writable:!0,value:function(t){function n(){o=t.statusCode||183,this.status=c.STATUS_WAITING_FOR_PRACK,a.push("Contact: "+this.contact),a.push("Require: 100rel"),a.push("RSeq: "+Math.floor(1e4*Math.random())),this.sessionDescriptionHandler.getDescription(t.sessionDescriptionHandlerOptions,t.modifiers).then(function(t){if(!this.isCanceled&&this.status!==c.STATUS_TERMINATED){this.early_sdp=t.body,this[this.hasOffer?"hasAnswer":"hasOffer"]=!0;var n=e.Timers.T1;this.timers.rel1xxTimer=setTimeout(function e(){this.request.reply(o,null,a,t),n*=2,this.timers.rel1xxTimer=setTimeout(e.bind(this),n)}.bind(this),n),this.timers.prackTimer=setTimeout(function(){this.status===c.STATUS_WAITING_FOR_PRACK&&(this.logger.log("no PRACK received, rejecting the call"),clearTimeout(this.timers.rel1xxTimer),this.request.reply(504),this.terminated(null,e.C.causes.NO_PRACK))}.bind(this),64*e.Timers.T1),i=this.request.reply(o,s,a,t),this.emit("progress",i,s)}}.bind(this),function(){this.request.reply(480),this.failed(null,e.C.causes.WEBRTC_ERROR),this.terminated(null,e.C.causes.WEBRTC_ERROR)}.bind(this))}function r(){i=this.request.reply(o,s,a,u),this.emit("progress",i,s)}t=t||{};var i,o=t.statusCode||180,s=t.reasonPhrase,a=(t.extraHeaders||[]).slice(),u=t.body;if(o<100||o>199)throw new TypeError("Invalid statusCode: "+o);return this.isCanceled||this.status===c.STATUS_TERMINATED?this:(100!==t.statusCode&&(this.rel100===e.C.supported.REQUIRED||this.rel100===e.C.supported.SUPPORTED&&t.rel100||this.rel100===e.C.supported.SUPPORTED&&this.ua.configuration.rel100===e.C.supported.REQUIRED)?(this.sessionDescriptionHandler=this.setupSessionDescriptionHandler(),this.emit("SessionDescriptionHandler-created",this.sessionDescriptionHandler),this.sessionDescriptionHandler.hasDescription(this.request.getHeader("Content-Type"))?(this.hasOffer=!0,this.sessionDescriptionHandler.setDescription(this.request.body,t.sessionDescriptionHandlerOptions,t.modifiers).then(n.apply(this)).catch(function(t){throw this.logger.warn("invalid description"),this.logger.warn(t),this.failed(null,e.C.causes.WEBRTC_ERROR),this.terminated(null,e.C.causes.WEBRTC_ERROR),t}.bind(this))):n.apply(this)):r.apply(this),this)}},accept:{writable:!0,value:function(t){t=t||{},this.onInfo=t.onInfo;var n=this,r=this.request,i=(t.extraHeaders||[]).slice(),o=function(t){var o,s=function(){n.status=c.STATUS_WAITING_FOR_ACK,n.setInvite2xxTimer(r,t),n.setACKTimer()},a=function(){n.failed(null,e.C.causes.CONNECTION_ERROR),n.terminated(null,e.C.causes.CONNECTION_ERROR)};i.push("Contact: "+n.contact),i.push("Allow: "+e.UA.C.ALLOWED_METHODS.toString()),n.hasOffer?n.hasAnswer=!0:n.hasOffer=!0,o=r.reply(200,null,i,t,s,a),n.status!==c.STATUS_TERMINATED&&n.accepted(o,e.Utils.getReasonPhrase(200))},s=function(t){throw t instanceof e.Exceptions.SessionDescriptionHandlerError&&(n.logger.log(t.message),n.logger.log(t.error)),n.request.reply(480),n.failed(null,e.C.causes.WEBRTC_ERROR),n.terminated(null,e.C.causes.WEBRTC_ERROR),t};if(this.status===c.STATUS_WAITING_FOR_PRACK)return this.status=c.STATUS_ANSWERED_WAITING_FOR_PRACK,this;if(this.status===c.STATUS_WAITING_FOR_ANSWER)this.status=c.STATUS_ANSWERED;else if(this.status!==c.STATUS_EARLY_MEDIA)throw new e.Exceptions.InvalidStateError(this.status);if(!this.createDialog(r,"UAS"))return r.reply(500,"Missing Contact header field"),this;if(clearTimeout(this.timers.userNoAnswerTimer),this.status===c.STATUS_EARLY_MEDIA)o({});else if(this.sessionDescriptionHandler=this.setupSessionDescriptionHandler(),this.emit("SessionDescriptionHandler-created",this.sessionDescriptionHandler),"0"!==this.request.getHeader("Content-Length")||this.request.getHeader("Content-Type")){if(!this.sessionDescriptionHandler.hasDescription(this.request.getHeader("Content-Type")))return void this.request.reply(415);this.hasOffer=!0,this.sessionDescriptionHandler.setDescription(this.request.body,t.sessionDescriptionHandlerOptions,t.modifiers).then(function(){return this.sessionDescriptionHandler.getDescription(t.sessionDescriptionHandlerOptions,t.modifiers)}.bind(this)).catch(s).then(o)}else this.sessionDescriptionHandler.getDescription(t.sessionDescriptionHandlerOptions,t.modifiers).catch(s).then(o);return this}},receiveRequest:{writable:!0,value:function(n){var r=this,i=function(){var e,t;clearTimeout(r.timers.ackTimer),clearTimeout(r.timers.invite2xxTimer),r.status=c.STATUS_CONFIRMED,e=n.getHeader("Content-Type"),t=n.getHeader("Content-Disposition"),t&&"render"===t.type&&(r.renderbody=n.body,r.rendertype=e),r.emit("confirmed",n)};switch(n.method){case e.C.CANCEL:this.status!==c.STATUS_WAITING_FOR_ANSWER&&this.status!==c.STATUS_WAITING_FOR_PRACK&&this.status!==c.STATUS_ANSWERED_WAITING_FOR_PRACK&&this.status!==c.STATUS_EARLY_MEDIA&&this.status!==c.STATUS_ANSWERED||(this.status=c.STATUS_CANCELED,this.request.reply(487),this.canceled(n),this.rejected(n,e.C.causes.CANCELED),this.failed(n,e.C.causes.CANCELED),this.terminated(n,e.C.causes.CANCELED));break;case e.C.ACK:this.status===c.STATUS_WAITING_FOR_ACK&&(this.status=c.STATUS_CONFIRMED,this.sessionDescriptionHandler.hasDescription(n.getHeader("Content-Type"))?(this.hasAnswer=!0,this.sessionDescriptionHandler.setDescription(n.body,this.sessionDescriptionHandlerOptions,this.modifiers).catch(function(t){throw r.logger.warn(t),r.terminate({statusCode:"488",reasonPhrase:"Bad Media Description"}),r.failed(n,e.C.causes.BAD_MEDIA_DESCRIPTION),r.terminated(n,e.C.causes.BAD_MEDIA_DESCRIPTION),t}).then(function(){return i()})):i());break;case e.C.PRACK:this.status===c.STATUS_WAITING_FOR_PRACK||this.status===c.STATUS_ANSWERED_WAITING_FOR_PRACK?this.hasAnswer?(clearTimeout(this.timers.rel1xxTimer),clearTimeout(this.timers.prackTimer),n.reply(200),this.status===c.STATUS_ANSWERED_WAITING_FOR_PRACK&&(this.status=c.STATUS_EARLY_MEDIA,this.accept()),this.status=c.STATUS_EARLY_MEDIA):(this.sessionDescriptionHandler=this.setupSessionDescriptionHandler(),this.emit("SessionDescriptionHandler-created",this.sessionDescriptionHandler),this.sessionDescriptionHandler.hasDescription(n.getHeader("Content-Type"))?(this.hasAnswer=!0,this.sessionDescriptionHandler.setDescription(n.body,this.sessionDescriptionHandlerOptions,this.modifiers).then(function(){clearTimeout(this.timers.rel1xxTimer),clearTimeout(this.timers.prackTimer),n.reply(200),this.status===c.STATUS_ANSWERED_WAITING_FOR_PRACK&&(this.status=c.STATUS_EARLY_MEDIA,this.accept()),this.status=c.STATUS_EARLY_MEDIA}.bind(this),function(t){this.logger.warn(t),this.terminate({statusCode:"488",reasonPhrase:"Bad Media Description"}),this.failed(n,e.C.causes.BAD_MEDIA_DESCRIPTION),this.terminated(n,e.C.causes.BAD_MEDIA_DESCRIPTION)}.bind(this))):(this.terminate({statusCode:"488",reasonPhrase:"Bad Media Description"}),this.failed(n,e.C.causes.BAD_MEDIA_DESCRIPTION),this.terminated(n,e.C.causes.BAD_MEDIA_DESCRIPTION))):this.status===c.STATUS_EARLY_MEDIA&&n.reply(200);break;default:t.prototype.receiveRequest.apply(this,[n])}}},setupSessionDescriptionHandler:{writable:!0,value:function(){return this.sessionDescriptionHandler?this.sessionDescriptionHandler:this.sessionDescriptionHandlerFactory(this,this.ua.configuration.sessionDescriptionHandlerFactoryOptions)}},onTransportError:{writable:!0,value:function(){this.status!==c.STATUS_CONFIRMED&&this.status!==c.STATUS_TERMINATED&&this.failed(null,e.C.causes.CONNECTION_ERROR)}},onRequestTimeout:{writable:!0,value:function(){this.status===c.STATUS_CONFIRMED?this.terminated(null,e.C.causes.REQUEST_TIMEOUT):this.status!==c.STATUS_TERMINATED&&(this.failed(null,e.C.causes.REQUEST_TIMEOUT),this.terminated(null,e.C.causes.REQUEST_TIMEOUT))}}}),e.InviteServerContext=r,i=function(t,n,r,i){r=r||{},this.passedOptions=r,r.params=Object.create(r.params||Object.prototype);var o=(r.extraHeaders||[]).slice(),s=t.configuration.sessionDescriptionHandlerFactory;if(this.sessionDescriptionHandlerFactoryOptions=t.configuration.sessionDescriptionHandlerFactoryOptions||{},this.sessionDescriptionHandlerOptions=r.sessionDescriptionHandlerOptions||{},this.modifiers=i,this.inviteWithoutSdp=r.inviteWithoutSdp||!1,this.anonymous=r.anonymous||!1,this.renderbody=r.renderbody||null,this.rendertype=r.rendertype||"text/plain",this.from_tag=e.Utils.newTag(),r.params.from_tag=this.from_tag,this.contact=t.contact.toString({anonymous:this.anonymous,outbound:this.anonymous?!t.contact.temp_gruu:!t.contact.pub_gruu}),this.anonymous&&(r.params.from_displayName="Anonymous",r.params.from_uri="sip:anonymous@anonymous.invalid",o.push("P-Preferred-Identity: "+t.configuration.uri.toString()),o.push("Privacy: id")),o.push("Contact: "+this.contact),o.push("Allow: "+e.UA.C.ALLOWED_METHODS.toString()),this.inviteWithoutSdp&&this.renderbody&&(o.push("Content-Type: "+this.rendertype),o.push("Content-Disposition: render;handling=optional")),t.configuration.rel100===e.C.supported.REQUIRED&&o.push("Require: 100rel"),t.configuration.replaces===e.C.supported.REQUIRED&&o.push("Require: replaces"),r.extraHeaders=o,e.Utils.augment(this,e.ClientContext,[t,e.C.INVITE,n,r]),e.Utils.augment(this,e.Session,[s]),this.status!==c.STATUS_NULL)throw new e.Exceptions.InvalidStateError(this.status);this.isCanceled=!1,this.received_100=!1,this.method=e.C.INVITE,this.receiveNonInviteResponse=this.receiveResponse,this.receiveResponse=this.receiveInviteResponse,this.logger=t.getLogger("sip.inviteclientcontext"),t.applicants[this]=this,this.id=this.request.call_id+this.from_tag,this.onInfo=r.onInfo,this.errorListener=this.onTransportError.bind(this),t.transport.on("transportError",this.errorListener)},i.prototype=Object.create({},{invite:{writable:!0,value:function(){var t=this;return this.ua.sessions[this.id]=this,Promise.resolve().then(function(){this.inviteWithoutSdp?(this.request.body=t.renderbody,this.status=c.STATUS_INVITE_SENT,this.send()):(this.sessionDescriptionHandler=this.sessionDescriptionHandlerFactory(this,this.sessionDescriptionHandlerFactoryOptions),this.emit("SessionDescriptionHandler-created",this.sessionDescriptionHandler),this.sessionDescriptionHandler.getDescription(this.sessionDescriptionHandlerOptions,this.modifiers).then(function(e){t.isCanceled||t.status===c.STATUS_TERMINATED||(t.hasOffer=!0,t.request.body=e,t.status=c.STATUS_INVITE_SENT,t.send())},function(n){n instanceof e.Exceptions.SessionDescriptionHandlerError&&(t.logger.log(n.message),t.logger.log(n.error)),t.status!==c.STATUS_TERMINATED&&(t.failed(null,e.C.causes.WEBRTC_ERROR),t.terminated(null,e.C.causes.WEBRTC_ERROR))}))}.bind(this)),this}},receiveInviteResponse:{writable:!0,value:function(t){var n,r=this,i=t.call_id+t.from_tag+t.to_tag,o=[],s={};if(this.status!==c.STATUS_TERMINATED&&t.method===e.C.INVITE){if(this.dialog&&t.status_code>=200&&t.status_code<=299){if(i!==this.dialog.id.toString()){if(!this.createDialog(t,"UAC",!0))return;return this.emit("ack",t.transaction.sendACK({body:e.Utils.generateFakeSDP(t.body)})),this.earlyDialogs[i].sendRequest(this,e.C.BYE),void(this.status!==c.STATUS_CONFIRMED&&(this.failed(t,e.C.causes.WEBRTC_ERROR),this.terminated(t,e.C.causes.WEBRTC_ERROR)))}if(this.status===c.STATUS_CONFIRMED)return void this.emit("ack",t.transaction.sendACK());if(!this.hasAnswer)return}if(this.dialog&&t.status_code<200){if(-1!==this.dialog.pracked.indexOf(t.getHeader("rseq"))||this.dialog.pracked[this.dialog.pracked.length-1]>=t.getHeader("rseq")&&this.dialog.pracked.length>0)return;if(!this.earlyDialogs[i]&&!this.createDialog(t,"UAC",!0))return;if(-1!==this.earlyDialogs[i].pracked.indexOf(t.getHeader("rseq"))||this.earlyDialogs[i].pracked[this.earlyDialogs[i].pracked.length-1]>=t.getHeader("rseq")&&this.earlyDialogs[i].pracked.length>0)return;return o.push("RAck: "+t.getHeader("rseq")+" "+t.getHeader("cseq")),this.earlyDialogs[i].pracked.push(t.getHeader("rseq")),void this.earlyDialogs[i].sendRequest(this,e.C.PRACK,{extraHeaders:o,body:e.Utils.generateFakeSDP(t.body)})}if(this.isCanceled)return void(t.status_code>=100&&t.status_code<200?(this.request.cancel(this.cancelReason,o),this.canceled(null)):t.status_code>=200&&t.status_code<299?(this.acceptAndTerminate(t),this.emit("bye",this.request)):t.status_code>=300&&(n=e.C.REASON_PHRASE[t.status_code]||e.C.causes.CANCELED,this.rejected(t,n),this.failed(t,n),this.terminated(t,n)));switch(!0){case/^100$/.test(t.status_code):this.received_100=!0,this.emit("progress",t);break;case/^1[0-9]{2}$/.test(t.status_code):if(!t.to_tag){this.logger.warn("1xx response received without to tag");break}if(t.hasHeader("contact")&&!this.createDialog(t,"UAC",!0))break;if(this.status=c.STATUS_1XX_RECEIVED,t.hasHeader("P-Asserted-Identity")&&(this.assertedIdentity=new e.NameAddrHeader.parse(t.getHeader("P-Asserted-Identity"))),t.hasHeader("require")&&-1!==t.getHeader("require").indexOf("100rel")){if(this.dialog||!this.earlyDialogs[i])break;if(-1!==this.earlyDialogs[i].pracked.indexOf(t.getHeader("rseq"))||this.earlyDialogs[i].pracked[this.earlyDialogs[i].pracked.length-1]>=t.getHeader("rseq")&&this.earlyDialogs[i].pracked.length>0)return;if(this.sessionDescriptionHandler=this.sessionDescriptionHandlerFactory(this,this.sessionDescriptionHandlerFactoryOptions),this.emit("SessionDescriptionHandler-created",this.sessionDescriptionHandler),this.sessionDescriptionHandler.hasDescription(t.getHeader("Content-Type")))if(this.hasOffer){if(!this.createDialog(t,"UAC"))break;this.hasAnswer=!0,this.dialog.pracked.push(t.getHeader("rseq")),this.sessionDescriptionHandler.setDescription(t.body,this.sessionDescriptionHandlerOptions,this.modifiers).then(function(){o.push("RAck: "+t.getHeader("rseq")+" "+t.getHeader("cseq")),r.sendRequest(e.C.PRACK,{extraHeaders:o,receiveResponse:function(){}}),r.status=c.STATUS_EARLY_MEDIA,r.emit("progress",t)},function(n){r.logger.warn(n),r.acceptAndTerminate(t,488,"Not Acceptable Here"),r.failed(t,e.C.causes.BAD_MEDIA_DESCRIPTION)})}else{var a=this.earlyDialogs[i],u=a.sessionDescriptionHandler=this.sessionDescriptionHandlerFactory(this,this.sessionDescriptionHandlerFactoryOptions);this.emit("SessionDescriptionHandler-created",u),a.pracked.push(t.getHeader("rseq")),u.setDescription(t.body,r.sessionDescriptionHandlerOptions,r.modifers).then(u.getDescription.bind(u,r.sessionDescriptionHandlerOptions,r.modifiers)).then(function(n){o.push("RAck: "+t.getHeader("rseq")+" "+t.getHeader("cseq")),a.sendRequest(r,e.C.PRACK,{extraHeaders:o,body:n}),r.status=c.STATUS_EARLY_MEDIA,r.emit("progress",t)}).catch(function(n){if(n instanceof e.Exceptions.SessionDescriptionHandlerError){if(a.pracked.push(t.getHeader("rseq")),r.status===c.STATUS_TERMINATED)return;r.failed(null,e.C.causes.WEBRTC_ERROR),r.terminated(null,e.C.causes.WEBRTC_ERROR)}else a.pracked.splice(a.pracked.indexOf(t.getHeader("rseq")),1),r.logger.warn("invalid description"),r.logger.warn(n)})}else o.push("RAck: "+t.getHeader("rseq")+" "+t.getHeader("cseq")),this.earlyDialogs[i].pracked.push(t.getHeader("rseq")),this.earlyDialogs[i].sendRequest(this,e.C.PRACK,{extraHeaders:o}),this.emit("progress",t)}else this.emit("progress",t);break;case/^2[0-9]{2}$/.test(t.status_code):if(this.request.cseq+" "+this.request.method!==t.getHeader("cseq"))break;if(t.hasHeader("P-Asserted-Identity")&&(this.assertedIdentity=new e.NameAddrHeader.parse(t.getHeader("P-Asserted-Identity"))),this.status===c.STATUS_EARLY_MEDIA&&this.dialog){this.status=c.STATUS_CONFIRMED,s={},this.renderbody&&(o.push("Content-Type: "+this.rendertype),s.extraHeaders=o,s.body=this.renderbody),this.emit("ack",t.transaction.sendACK(s)),this.accepted(t);break}if(this.dialog)break;if(this.hasOffer)if(this.hasAnswer)this.renderbody&&(o.push("Content-Type: "+r.rendertype),s.extraHeaders=o,s.body=this.renderbody),this.emit("ack",t.transaction.sendACK(s));else{if(!this.sessionDescriptionHandler.hasDescription(t.getHeader("Content-Type"))){this.acceptAndTerminate(t,400,"Missing session description"),this.failed(t,e.C.causes.BAD_MEDIA_DESCRIPTION);break}if(!this.createDialog(t,"UAC"))break;this.hasAnswer=!0,this.sessionDescriptionHandler.setDescription(t.body,this.sessionDescriptionHandlerOptions,this.modifiers).then(function(){var e={};r.status=c.STATUS_CONFIRMED,r.renderbody&&(o.push("Content-Type: "+r.rendertype),e.extraHeaders=o,e.body=r.renderbody),r.emit("ack",t.transaction.sendACK(e)),r.accepted(t)},function(n){r.logger.warn(n),r.acceptAndTerminate(t,488,"Not Acceptable Here"),r.failed(t,e.C.causes.BAD_MEDIA_DESCRIPTION)})}else if(this.earlyDialogs[i]&&this.earlyDialogs[i].sessionDescriptionHandler){if(this.hasOffer=!0,this.hasAnswer=!0,this.sessionDescriptionHandler=this.earlyDialogs[i].sessionDescriptionHandler,!this.createDialog(t,"UAC"))break;this.status=c.STATUS_CONFIRMED,this.emit("ack",t.transaction.sendACK()),this.accepted(t)}else{if(this.sessionDescriptionHandler=this.sessionDescriptionHandlerFactory(this,this.sessionDescriptionHandlerFactoryOptions),this.emit("SessionDescriptionHandler-created",this.sessionDescriptionHandler),!this.sessionDescriptionHandler.hasDescription(t.getHeader("Content-Type"))){this.acceptAndTerminate(t,400,"Missing session description"),this.failed(t,e.C.causes.BAD_MEDIA_DESCRIPTION);break}if(!this.createDialog(t,"UAC"))break;this.hasOffer=!0,this.sessionDescriptionHandler.setDescription(t.body,this.sessionDescriptionHandlerOptions,this.modifiers).then(this.sessionDescriptionHandler.getDescription.bind(this.sessionDescriptionHandler,this.sessionDescriptionHandlerOptions,this.modifiers)).then(function(e){r.isCanceled||r.status===c.STATUS_TERMINATED||(r.status=c.STATUS_CONFIRMED,r.hasAnswer=!0,r.emit("ack",t.transaction.sendACK({body:e})),r.accepted(t))}).catch(function(n){n instanceof e.Exceptions.SessionDescriptionHandlerError&&(r.logger.warn("invalid description"),r.logger.warn(n),r.acceptAndTerminate(t,488,"Invalid session description"),r.failed(t,e.C.causes.BAD_MEDIA_DESCRIPTION))})}break;default:n=e.Utils.sipErrorCause(t.status_code),this.rejected(t,n),this.failed(t,n),this.terminated(t,n)}}}},cancel:{writable:!0,value:function(t){if(t=t||{},t.extraHeaders=(t.extraHeaders||[]).slice(),this.isCanceled)throw new e.Exceptions.InvalidStateError("CANCELED");if(this.status===c.STATUS_TERMINATED||this.status===c.STATUS_CONFIRMED)throw new e.Exceptions.InvalidStateError(this.status);this.logger.log("canceling RTCSession"),this.isCanceled=!0;var n=e.Utils.getCancelReason(t.status_code,t.reason_phrase);return this.status===c.STATUS_NULL||this.status===c.STATUS_INVITE_SENT&&!this.received_100?this.cancelReason=n:this.status!==c.STATUS_INVITE_SENT&&this.status!==c.STATUS_1XX_RECEIVED&&this.status!==c.STATUS_EARLY_MEDIA||this.request.cancel(n,t.extraHeaders),this.canceled()}},terminate:{writable:!0,value:function(e){return this.status===c.STATUS_TERMINATED?this:(this.status===c.STATUS_WAITING_FOR_ACK||this.status===c.STATUS_CONFIRMED?this.bye(e):this.cancel(e),this)}},receiveRequest:{writable:!0,value:function(n){return n.method,e.C.CANCEL,n.method===e.C.ACK&&this.status===c.STATUS_WAITING_FOR_ACK&&(clearTimeout(this.timers.ackTimer),clearTimeout(this.timers.invite2xxTimer),this.status=c.STATUS_CONFIRMED,this.accepted()),t.prototype.receiveRequest.apply(this,[n])}},onTransportError:{writable:!0,value:function(){this.status!==c.STATUS_CONFIRMED&&this.status!==c.STATUS_TERMINATED&&this.failed(null,e.C.causes.CONNECTION_ERROR)}},onRequestTimeout:{writable:!0,value:function(){this.status===c.STATUS_CONFIRMED?this.terminated(null,e.C.causes.REQUEST_TIMEOUT):this.status!==c.STATUS_TERMINATED&&(this.failed(null,e.C.causes.REQUEST_TIMEOUT),this.terminated(null,e.C.causes.REQUEST_TIMEOUT))}}}),e.InviteClientContext=i,s=function(t,n,r,i){if(this.options=i||{},this.extraHeaders=(this.options.extraHeaders||[]).slice(),void 0===t||void 0===n||void 0===r)throw new TypeError("Not enough arguments");if(e.Utils.augment(this,e.ClientContext,[t,e.C.REFER,n.remoteIdentity.uri.toString(),this.options]),this.applicant=n,r instanceof e.InviteServerContext||r instanceof e.InviteClientContext)this.target='"'+r.remoteIdentity.friendlyName+'" <'+r.dialog.remote_target.toString()+"?Replaces="+r.dialog.id.call_id+"%3Bto-tag%3D"+r.dialog.id.remote_tag+"%3Bfrom-tag%3D"+r.dialog.id.local_tag+">";else{try{this.target=e.Grammar.parse(r,"Refer_To").uri||r}catch(e){this.logger.debug(".refer() cannot parse Refer_To from",r),this.logger.debug("...falling through to normalizeTarget()")}if(this.target=this.ua.normalizeTarget(this.target),!this.target)throw new TypeError("Invalid target: "+r)}this.ua&&this.extraHeaders.push("Referred-By: <"+this.ua.configuration.uri+">"),this.extraHeaders.push("Contact: "+n.contact),this.extraHeaders.push("Allow: "+e.UA.C.ALLOWED_METHODS.toString()),this.extraHeaders.push("Refer-To: "+this.target),this.errorListener=this.onTransportError.bind(this),t.transport.on("transportError",this.errorListener)},s.prototype=Object.create({},{refer:{writable:!0,value:function(t){t=t||{};var n=(this.extraHeaders||[]).slice();return t.extraHeaders&&n.concat(t.extraHeaders),this.applicant.sendRequest(e.C.REFER,{extraHeaders:this.extraHeaders,receiveResponse:function(e){/^1[0-9]{2}$/.test(e.status_code)?this.emit("referRequestProgress",this):/^2[0-9]{2}$/.test(e.status_code)?this.emit("referRequestAccepted",this):/^[4-6][0-9]{2}$/.test(e.status_code)&&this.emit("referRequestRejected",this),t.receiveResponse&&t.receiveResponse(e)}.bind(this)}),this}},receiveNotify:{writable:!0,value:function(t){if(t.hasHeader("Content-Type")&&-1!==t.getHeader("Content-Type").search(/^message\/sipfrag/)){var n=e.Grammar.parse(t.body,"sipfrag");if(-1===n)return void t.reply(489,"Bad Event");switch(!0){case/^1[0-9]{2}$/.test(n.status_code):this.emit("referProgress",this);break;case/^2[0-9]{2}$/.test(n.status_code):this.emit("referAccepted",this),!this.options.activeAfterTransfer&&this.applicant.terminate&&this.applicant.terminate();break;default:this.emit("referRejected",this)}return t.reply(200),void this.emit("notify",t)}t.reply(489,"Bad Event")}}}),e.ReferClientContext=s,o=function(t,n){if(e.Utils.augment(this,e.ServerContext,[t,n]),this.ua=t,this.status=c.STATUS_INVITE_RECEIVED,this.from_tag=n.from_tag,this.id=n.call_id+this.from_tag,this.request=n,this.contact=this.ua.contact.toString(),this.logger=t.getLogger("sip.referservercontext",this.id),!this.request.hasHeader("refer-to"))return this.logger.warn("Invalid REFER packet. A refer-to header is required. Rejecting refer."),void this.reject();this.referTo=this.request.parseHeader("refer-to"),this.referredSession=this.ua.findSession(n),this.cseq=Math.floor(1e4*Math.random()),this.call_id=this.request.call_id,this.from_uri=this.request.to.uri,this.from_tag=this.request.to.parameters.tag,this.remote_target=this.request.headers.Contact[0].parsed.uri,this.to_uri=this.request.from.uri,this.to_tag=this.request.from_tag,this.route_set=this.request.getHeaders("record-route"),this.receiveNonInviteResponse=function(){},this.request.hasHeader("referred-by")&&(this.referredBy=this.request.getHeader("referred-by")),this.referTo.uri.hasHeader("replaces")&&(this.replaces=this.referTo.uri.getHeader("replaces")),this.errorListener=this.onTransportError.bind(this),t.transport.on("transportError",this.errorListener),this.status=c.STATUS_WAITING_FOR_ANSWER},o.prototype=Object.create({},{progress:{writable:!0,value:function(){if(this.status!==c.STATUS_WAITING_FOR_ANSWER)throw new e.Exceptions.InvalidStateError(this.status);this.request.reply(100)}},reject:{writable:!0,value:function(t){if(this.status===c.STATUS_TERMINATED)throw new e.Exceptions.InvalidStateError(this.status);this.logger.log("Rejecting refer"),this.status=c.STATUS_TERMINATED,e.ServerContext.prototype.reject.call(this,t),this.emit("referRequestRejected",this)}},accept:{writable:!0,value:function(t,n){var r=this;if(t=t||{},this.status!==c.STATUS_WAITING_FOR_ANSWER)throw new e.Exceptions.InvalidStateError(this.status);if(this.status=c.STATUS_ANSWERED,this.request.reply(202,"Accepted"),this.emit("referRequestAccepted",this),t.followRefer){this.logger.log("Accepted refer, attempting to automatically follow it");var i=this.referTo.uri;if(!i.scheme.match("^sips?$"))return this.logger.error("SIP.js can only automatically follow SIP refer target"),void this.reject();var o=t.inviteOptions||{},s=(o.extraHeaders||[]).slice();this.replaces&&s.push("Replaces: "+decodeURIComponent(this.replaces)),this.referredBy&&s.push("Referred-By: "+this.referredBy),o.extraHeaders=s,i.clearHeaders(),this.targetSession=this.ua.invite(i,o,n),this.emit("referInviteSent",this),this.targetSession.once("progress",function(e){var t=e.status_code||100,n=e.reason_phrase;r.sendNotify(("SIP/2.0 "+t+" "+n).trim()),r.emit("referProgress",r),r.referredSession&&r.referredSession.emit("referProgress",r)}),this.targetSession.once("accepted",function(){r.logger.log("Successfully followed the refer"),r.sendNotify("SIP/2.0 200 OK"),r.emit("referAccepted",r),r.referredSession&&r.referredSession.emit("referAccepted",r)});var a=function(e){if(this.status!==c.STATUS_TERMINATED){if(this.logger.log("Refer was not successful. Resuming session"),e&&429===e.status_code)return this.logger.log("Alerting referrer that identity is required."),void this.sendNotify("SIP/2.0 429 Provide Referrer Identity");this.sendNotify("SIP/2.0 603 Declined"),this.status=c.STATUS_TERMINATED,this.emit("referRejected",this),this.referredSession&&this.referredSession.emit("referRejected")}};this.targetSession.once("rejected",a.bind(this)),this.targetSession.once("failed",a.bind(this))}else this.logger.log("Accepted refer, but did not automatically follow it"),this.sendNotify("SIP/2.0 200 OK"),this.emit("referAccepted",this),this.referredSession&&this.referredSession.emit("referAccepted",this)}},sendNotify:{writable:!0,value:function(t){if(this.status!==c.STATUS_ANSWERED)throw new e.Exceptions.InvalidStateError(this.status);if(-1===e.Grammar.parse(t,"sipfrag"))throw new Error("sipfrag body is required to send notify for refer");var n=new e.OutgoingRequest(e.C.NOTIFY,this.remote_target,this.ua,{cseq:this.cseq+=1,call_id:this.call_id,from_uri:this.from_uri,from_tag:this.from_tag,to_uri:this.to_uri,to_tag:this.to_tag,route_set:this.route_set},["Event: refer","Subscription-State: terminated","Content-Type: message/sipfrag"],t);new e.RequestSender({request:n,onRequestTimeout:function(){},onTransportError:function(){},receiveResponse:function(){}},this.ua).send()}}}),e.ReferServerContext=o}},function(e,t,n){"use strict";e.exports=function(e){var t,n={MIN_DURATION:70,MAX_DURATION:6e3,DEFAULT_DURATION:100,MIN_INTER_TONE_GAP:50,DEFAULT_INTER_TONE_GAP:500};return t=function(n,r,i){var o,s;if(void 0===r)throw new TypeError("Not enough arguments");if(this.logger=n.ua.getLogger("sip.invitecontext.dtmf",n.id),this.owner=n,this.direction=null,i=i||{},o=i.duration||null,s=i.interToneGap||null,"string"==typeof r)r=r.toUpperCase();else{if("number"!=typeof r)throw new TypeError("Invalid tone: "+r);r=r.toString()}if(!r.match(/^[0-9A-D#*]$/))throw new TypeError("Invalid tone: "+r);if(this.tone=r,o&&!e.Utils.isDecimal(o))throw new TypeError("Invalid tone duration: "+o);if(o?o<t.C.MIN_DURATION?(this.logger.warn('"duration" value is lower than the minimum allowed, setting it to '+t.C.MIN_DURATION+" milliseconds"),o=t.C.MIN_DURATION):o>t.C.MAX_DURATION?(this.logger.warn('"duration" value is greater than the maximum allowed, setting it to '+t.C.MAX_DURATION+" milliseconds"),o=t.C.MAX_DURATION):o=Math.abs(o):o=t.C.DEFAULT_DURATION,this.duration=o,s&&!e.Utils.isDecimal(s))throw new TypeError("Invalid interToneGap: "+s);s?s<t.C.MIN_INTER_TONE_GAP?(this.logger.warn('"interToneGap" value is lower than the minimum allowed, setting it to '+t.C.MIN_INTER_TONE_GAP+" milliseconds"),s=t.C.MIN_INTER_TONE_GAP):s=Math.abs(s):s=t.C.DEFAULT_INTER_TONE_GAP,this.interToneGap=s},t.prototype=Object.create(e.EventEmitter.prototype),t.prototype.send=function(t){var n,r={};if(this.direction="outgoing",this.owner.status!==e.Session.C.STATUS_CONFIRMED&&this.owner.status!==e.Session.C.STATUS_WAITING_FOR_ACK)throw new e.Exceptions.InvalidStateError(this.owner.status);t=t||{},n=t.extraHeaders?t.extraHeaders.slice():[],r.contentType="application/dtmf-relay",r.body="Signal= "+this.tone+"\r\n",r.body+="Duration= "+this.duration,this.request=this.owner.dialog.sendRequest(this,e.C.INFO,{extraHeaders:n,body:r}),this.owner.emit("dtmf",this.request,this)},t.prototype.receiveResponse=function(t){var n;switch(!0){case/^1[0-9]{2}$/.test(t.status_code):break;case/^2[0-9]{2}$/.test(t.status_code):this.emit("succeeded",{originator:"remote",response:t});break;default:n=e.Utils.sipErrorCause(t.status_code),this.emit("failed",t,n)}},t.prototype.onRequestTimeout=function(){this.emit("failed",null,e.C.causes.REQUEST_TIMEOUT),this.owner.onRequestTimeout()},t.prototype.onTransportError=function(){this.emit("failed",null,e.C.causes.CONNECTION_ERROR),this.owner.onTransportError()},t.prototype.onDialogError=function(t){this.emit("failed",t,e.C.causes.DIALOG_ERROR),this.owner.onDialogError(t)},t.prototype.init_incoming=function(e){this.direction="incoming",this.request=e,e.reply(200),this.tone&&this.duration?this.owner.emit("dtmf",e,this):this.logger.warn("invalid INFO DTMF received, discarded")},t.C=n,t}},function(e,t,n){"use strict";e.exports=function(e){e.Subscription=function(t,n,r,i){if(i=Object.create(i||Object.prototype),this.extraHeaders=i.extraHeaders=(i.extraHeaders||[]).slice(),this.id=null,this.state="init",!r)throw new TypeError("Event necessary to create a subscription.");this.event=r,"number"!=typeof i.expires?(t.logger.warn("expires must be a number. Using default of 3600."),this.expires=3600):this.expires=i.expires,this.requestedExpires=this.expires,i.extraHeaders.push("Event: "+this.event),i.extraHeaders.push("Expires: "+this.expires),i.body&&(this.body=i.body),this.contact=t.contact.toString(),i.extraHeaders.push("Contact: "+this.contact),i.extraHeaders.push("Allow: "+e.UA.C.ALLOWED_METHODS.toString()),e.Utils.augment(this,e.ClientContext,[t,e.C.SUBSCRIBE,n,i]),this.logger=t.getLogger("sip.subscription"),this.dialog=null,this.timers={N:null,sub_duration:null},this.errorCodes=[404,405,410,416,480,481,482,483,484,485,489,501,604]},e.Subscription.prototype={subscribe:function(){var t=this;return"active"===this.state?(this.refresh(),this):"notify_wait"===this.state?this:(clearTimeout(this.timers.sub_duration),clearTimeout(this.timers.N),this.timers.N=setTimeout(t.timer_fire.bind(t),e.Timers.TIMER_N),this.ua.earlySubscriptions[this.request.call_id+this.request.from.parameters.tag+this.event]=this,this.send(),this.state="notify_wait",this)},refresh:function(){"terminated"!==this.state&&"pending"!==this.state&&"notify_wait"!==this.state&&this.dialog.sendRequest(this,e.C.SUBSCRIBE,{extraHeaders:this.extraHeaders,body:this.body})},receiveResponse:function(t){var n,r=this,i=e.Utils.getReasonPhrase(t.status_code);"notify_wait"===this.state&&t.status_code>=300||"notify_wait"!==this.state&&-1!==this.errorCodes.indexOf(t.status_code)?this.failed(t,null):/^2[0-9]{2}$/.test(t.status_code)?(this.emit("accepted",t,i),n=t.getHeader("Expires"),n&&n<=this.requestedExpires?(this.expires=n,this.timers.sub_duration=setTimeout(r.refresh.bind(r),900*n)):n?(this.logger.warn("Expires header in a 200-class response to SUBSCRIBE with a higher value than the one in the request"),this.failed(t,e.C.INVALID_EXPIRES_HEADER)):(this.logger.warn("Expires header missing in a 200-class response to SUBSCRIBE"),this.failed(t,e.C.EXPIRES_HEADER_MISSING))):t.statusCode>300&&(this.emit("failed",t,i),this.emit("rejected",t,i))},unsubscribe:function(){var t=[],n=this;this.state="terminated",t.push("Event: "+this.event),t.push("Expires: 0"),t.push("Contact: "+this.contact),t.push("Allow: "+e.UA.C.ALLOWED_METHODS.toString()),this.receiveResponse=function(){},this.dialog.sendRequest(this,this.method,{extraHeaders:t,body:this.body}),clearTimeout(this.timers.sub_duration),clearTimeout(this.timers.N),this.timers.N=setTimeout(n.timer_fire.bind(n),e.Timers.TIMER_N),this.emit("terminated")},timer_fire:function(){"terminated"===this.state?(this.terminateDialog(),clearTimeout(this.timers.N),clearTimeout(this.timers.sub_duration),delete this.ua.subscriptions[this.id]):"notify_wait"===this.state||"pending"===this.state?this.close():this.refresh()},close:function(){"notify_wait"===this.state?(this.state="terminated",clearTimeout(this.timers.N),clearTimeout(this.timers.sub_duration),this.receiveResponse=function(){},delete this.ua.earlySubscriptions[this.request.call_id+this.request.from.parameters.tag+this.event],this.emit("terminated")):"terminated"!==this.state&&this.unsubscribe()},createConfirmedDialog:function(t,n){var r;return this.terminateDialog(),r=new e.Dialog(this,t,n),r.invite_seqnum=this.request.cseq,r.local_seqnum=this.request.cseq,!r.error&&(this.dialog=r,!0)},terminateDialog:function(){this.dialog&&(delete this.ua.subscriptions[this.id],this.dialog.terminate(),delete this.dialog)},receiveRequest:function(t){function n(){r.expires&&(clearTimeout(i.timers.sub_duration),r.expires=Math.min(i.expires,Math.max(r.expires,0)),i.timers.sub_duration=setTimeout(i.refresh.bind(i),900*r.expires))}var r,i=this;if(!this.matchEvent(t))return void t.reply(489);if(this.dialog||this.createConfirmedDialog(t,"UAS")&&(this.id=this.dialog.id.toString(),delete this.ua.earlySubscriptions[this.request.call_id+this.request.from.parameters.tag+this.event],this.ua.subscriptions[this.id]=this),r=t.parseHeader("Subscription-State"),t.reply(200,e.C.REASON_200),clearTimeout(this.timers.N),this.emit("notify",{request:t}),"terminated"===this.state)return void("terminated"===r.state&&(this.terminateDialog(),clearTimeout(this.timers.N),clearTimeout(this.timers.sub_duration),delete this.ua.subscriptions[this.id]));switch(r.state){case"active":this.state="active",n();break;case"pending":"notify_wait"===this.state&&n(),this.state="pending";break;case"terminated":if(clearTimeout(this.timers.sub_duration),r.reason)switch(this.logger.log("terminating subscription with reason "+r.reason),r.reason){case"deactivated":case"timeout":return void this.subscribe();case"probation":case"giveup":return void(r.params&&r.params["retry-after"]?this.timers.sub_duration=setTimeout(i.subscribe.bind(i),r.params["retry-after"]):this.subscribe())}this.close()}},failed:function(e,t){return this.close(),this.emit("failed",e,t),this.emit("rejected",e,t),this},onDialogError:function(t){this.failed(t,e.C.causes.DIALOG_ERROR)},matchEvent:function(e){var t;return e.hasHeader("Event")?e.hasHeader("Subscription-State")?(t=e.parseHeader("event").event,this.event===t||(this.logger.warn("event match failed"),e.reply(481,"Event Match Failed"),!1)):(this.logger.warn("missing Subscription-State header"),!1):(this.logger.warn("missing Event header"),!1)}}}},function(e,t,n){"use strict";e.exports=function(e){var t;t=function(t,n,r,i){if(this.options=i=i||{},this.options.extraHeaders=(i.extraHeaders||[]).slice(),this.options.contentType=i.contentType||"text/plain","number"!=typeof i.expires||i.expires%1!=0?this.options.expires=3600:this.options.expires=Number(i.expires),"boolean"!=typeof i.unpublishOnClose?this.options.unpublishOnClose=!0:this.options.unpublishOnClose=i.unpublishOnClose,void 0===n||null===n||""===n)throw new e.Exceptions.MethodParameterError("Publish","Target",n);if(this.target=t.normalizeTarget(n),void 0===r||null===r||""===r)throw new e.Exceptions.MethodParameterError("Publish","Event",r);this.event=r,e.ClientContext.call(this,t,e.C.PUBLISH,this.target,this.options),this.logger=this.ua.getLogger("sip.publish"),this.pubRequestBody=null,this.pubRequestExpires=this.options.expires,this.pubRequestEtag=null,this.publish_refresh_timer=null,t.on("transportCreated",function(e){e.on("transportError",this.onTransportError.bind(this))}.bind(this))},t.prototype=Object.create(e.ClientContext.prototype),t.prototype.constructor=t,t.prototype.publish=function(t){if(this.request=null,clearTimeout(this.publish_refresh_timer),void 0!==t&&null!==t&&""!==t)this.options.body=t,this.pubRequestBody=this.options.body,0===this.pubRequestExpires&&(this.pubRequestExpires=this.options.expires,this.pubRequestEtag=null),this.ua.publishers[this.target.toString()+":"+this.event]||(this.ua.publishers[this.target.toString()+":"+this.event]=this);else{if(this.pubRequestBody=null,null===this.pubRequestEtag)throw new e.Exceptions.MethodParameterError("Publish","Body",t);if(0===this.pubRequestExpires)throw new e.Exceptions.MethodParameterError("Publish","Expire",this.pubRequestExpires)}this.sendPublishRequest()},t.prototype.unpublish=function(){this.request=null,clearTimeout(this.publish_refresh_timer),this.pubRequestBody=null,this.pubRequestExpires=0,null!==this.pubRequestEtag&&this.sendPublishRequest()},t.prototype.close=function(){this.options.unpublishOnClose?this.unpublish():(this.request=null,clearTimeout(this.publish_refresh_timer),this.pubRequestBody=null,this.pubRequestExpires=0,this.pubRequestEtag=null),this.ua.publishers[this.target.toString()+":"+this.event]&&delete this.ua.publishers[this.target.toString()+":"+this.event]},t.prototype.sendPublishRequest=function(){var t;t=Object.create(this.options||Object.prototype),t.extraHeaders=(this.options.extraHeaders||[]).slice(),t.extraHeaders.push("Event: "+this.event),t.extraHeaders.push("Expires: "+this.pubRequestExpires),null!==this.pubRequestEtag&&t.extraHeaders.push("SIP-If-Match: "+this.pubRequestEtag),this.request=new e.OutgoingRequest(e.C.PUBLISH,this.target,this.ua,this.options.params,t.extraHeaders),null!==this.pubRequestBody&&(this.request.body={},this.request.body.body=this.pubRequestBody,this.request.body.contentType=this.options.contentType),this.send()},t.prototype.receiveResponse=function(t){var n,r,i=e.Utils.getReasonPhrase(t.status_code);switch(!0){case/^1[0-9]{2}$/.test(t.status_code):this.emit("progress",t,i);break;case/^2[0-9]{2}$/.test(t.status_code):t.hasHeader("SIP-ETag")?this.pubRequestEtag=t.getHeader("SIP-ETag"):this.logger.warn("SIP-ETag header missing in a 200-class response to PUBLISH"),t.hasHeader("Expires")?(n=Number(t.getHeader("Expires")),"number"==typeof n&&n>=0&&n<=this.pubRequestExpires?this.pubRequestExpires=n:this.logger.warn("Bad Expires header in a 200-class response to PUBLISH")):this.logger.warn("Expires header missing in a 200-class response to PUBLISH"),0!==this.pubRequestExpires?(this.publish_refresh_timer=setTimeout(this.publish.bind(this),900*this.pubRequestExpires),this.emit("published",t,i)):this.emit("unpublished",t,i);break;case/^412$/.test(t.status_code):null!==this.pubRequestEtag&&0!==this.pubRequestExpires?(this.logger.warn("412 response to PUBLISH, recovering"),this.pubRequestEtag=null,this.emit("progress",t,i),this.publish(this.options.body)):(this.logger.warn("412 response to PUBLISH, recovery failed"),this.pubRequestExpires=0,this.emit("failed",t,i),this.emit("unpublished",t,i));break;case/^423$/.test(t.status_code):0!==this.pubRequestExpires&&t.hasHeader("Min-Expires")?(r=Number(t.getHeader("Min-Expires")),"number"==typeof r||r>this.pubRequestExpires?(this.logger.warn("423 code in response to PUBLISH, adjusting the Expires value and trying to recover"),this.pubRequestExpires=r,this.emit("progress",t,i),this.publish(this.options.body)):(this.logger.warn("Bad 423 response Min-Expires header received for PUBLISH"),this.pubRequestExpires=0,this.emit("failed",t,i),this.emit("unpublished",t,i))):(this.logger.warn("423 response to PUBLISH, recovery failed"),this.pubRequestExpires=0,this.emit("failed",t,i),this.emit("unpublished",t,i));break;default:this.pubRequestExpires=0,this.emit("failed",t,i),this.emit("unpublished",t,i)}0===this.pubRequestExpires&&(clearTimeout(this.publish_refresh_timer),this.pubRequestBody=null,this.pubRequestEtag=null)},t.prototype.onRequestTimeout=function(){e.ClientContext.prototype.onRequestTimeout.call(this),this.emit("unpublished",null,e.C.causes.REQUEST_TIMEOUT)},t.prototype.onTransportError=function(){e.ClientContext.prototype.onTransportError.call(this),this.emit("unpublished",null,e.C.causes.CONNECTION_ERROR)},e.PublishContext=t}},function(e,t,n){"use strict";(function(t){var r=t.window||t;e.exports=function(e){function i(e){if(e instanceof Function)return e.initialize||(e.initialize=function(){return Promise.resolve()}),e}var o,s={STATUS_INIT:0,STATUS_STARTING:1,STATUS_READY:2,STATUS_USER_CLOSED:3,STATUS_NOT_READY:4,CONFIGURATION_ERROR:1,NETWORK_ERROR:2,ALLOWED_METHODS:["ACK","CANCEL","INVITE","MESSAGE","BYE","OPTIONS","INFO","NOTIFY","REFER"],ACCEPTED_BODY_TYPES:["application/sdp","application/dtmf-relay"],MAX_FORWARDS:70,TAG_LENGTH:10};o=function(t){function n(e){return r.emit.bind(r,e)}var r=this;s.ACCEPTED_BODY_TYPES=s.ACCEPTED_BODY_TYPES.toString(),this.log=new e.LoggerFactory,this.logger=this.getLogger("sip.ua"),this.cache={credentials:{}},this.configuration={},this.dialogs={},this.applicants={},this.data={},this.sessions={},this.subscriptions={},this.earlySubscriptions={},this.publishers={},this.transport=null,this.contact=null,this.status=s.STATUS_INIT,this.error=null,this.transactions={nist:{},nict:{},ist:{},ict:{}},Object.defineProperties(this,{transactionsCount:{get:function(){var e,t=["nist","nict","ist","ict"],n=0;for(e in t)n+=Object.keys(this.transactions[t[e]]).length;return n}},nictTransactionsCount:{get:function(){return Object.keys(this.transactions.nict).length}},nistTransactionsCount:{get:function(){return Object.keys(this.transactions.nist).length}},ictTransactionsCount:{get:function(){return Object.keys(this.transactions.ict).length}},istTransactionsCount:{get:function(){return Object.keys(this.transactions.ist).length}}}),void 0===t?t={}:("string"==typeof t||t instanceof String)&&(t={uri:t}),t.log&&(t.log.hasOwnProperty("builtinEnabled")&&(this.log.builtinEnabled=t.log.builtinEnabled),t.log.hasOwnProperty("level")&&(this.log.level=t.log.level),t.log.hasOwnProperty("connector")&&(this.log.connector=t.log.connector));try{this.loadConfig(t)}catch(e){throw this.status=s.STATUS_NOT_READY,this.error=s.CONFIGURATION_ERROR,e}this.registerContext=new e.RegisterContext(this,t.registerOptions),this.registerContext.on("failed",n("registrationFailed")),this.registerContext.on("registered",n("registered")),this.registerContext.on("unregistered",n("unregistered")),this.configuration.autostart&&this.start()},o.prototype=Object.create(e.EventEmitter.prototype),o.prototype.register=function(e){return void 0===e&&(e={}),e.register&&(this.configuration.register=!0),this.registerContext.register(e),this},o.prototype.unregister=function(e){this.configuration.register=!1;var t=this.registerContext;return this.transport.afterConnected(t.unregister.bind(t,e)),this},o.prototype.isRegistered=function(){return this.registerContext.registered},o.prototype.invite=function(t,n,r){var i=new e.InviteClientContext(this,t,n,r);return this.transport.afterConnected(function(){i.invite(),this.emit("inviteSent",i)}.bind(this)),i},o.prototype.subscribe=function(t,n,r){var i=new e.Subscription(this,t,n,r);return this.transport.afterConnected(i.subscribe.bind(i)),i},o.prototype.publish=function(t,n,r,i){var o=new e.PublishContext(this,t,n,i);return this.transport.afterConnected(o.publish.bind(o,r)),o},o.prototype.message=function(t,n,r){if(void 0===n)throw new TypeError("Not enough arguments");return r=Object.create(r||Object.prototype),r.contentType||(r.contentType="text/plain"),r.body=n,this.request(e.C.MESSAGE,t,r)},o.prototype.request=function(t,n,r){var i=new e.ClientContext(this,t,n,r);return this.transport.afterConnected(i.send.bind(i)),i},o.prototype.stop=function(){function e(){0===c.nistTransactionsCount&&0===c.nictTransactionsCount&&(c.removeListener("transactionDestroyed",e),c.transport.disconnect())}var n,i,o,a,c=this;if(this.logger.log("user requested closure..."),this.status===s.STATUS_USER_CLOSED)return this.logger.warn("UA already closed"),this;this.logger.log("closing registerContext"),this.registerContext.close();for(n in this.sessions)this.logger.log("closing session "+n),this.sessions[n].terminate();for(i in this.subscriptions)this.logger.log("unsubscribing from subscription "+i),this.subscriptions[i].close();for(i in this.earlySubscriptions)this.logger.log("unsubscribing from early subscription "+i),this.earlySubscriptions[i].close();for(a in this.publishers)this.logger.log("unpublish "+a),this.publishers[a].close();for(o in this.applicants)this.applicants[o].close();return this.status=s.STATUS_USER_CLOSED,0===this.nistTransactionsCount&&0===this.nictTransactionsCount?this.transport.disconnect():this.on("transactionDestroyed",e),"function"==typeof r.removeEventListener&&(t.chrome&&t.chrome.app&&t.chrome.app.runtime||r.removeEventListener("unload",this.environListener)),this},o.prototype.start=function(){if(this.logger.log("user requested startup..."),this.status===s.STATUS_INIT){if(this.status=s.STATUS_STARTING,!this.configuration.transportConstructor)throw new e.Exceptions.TransportError("Transport constructor not set");this.transport=new this.configuration.transportConstructor(this.getLogger("sip.transport"),this.configuration.transportOptions),this.setTransportListeners(),this.emit("transportCreated",this.transport),this.transport.connect()}else this.status===s.STATUS_USER_CLOSED?(this.logger.log("resuming"),this.status=s.STATUS_READY,this.transport.connect()):this.status===s.STATUS_STARTING?this.logger.log("UA is in STARTING status, not opening new connection"):this.status===s.STATUS_READY?this.logger.log("UA is in READY status, not resuming"):this.logger.error("Connection is down. Auto-Recovery system is trying to connect");return this.configuration.autostop&&"function"==typeof r.addEventListener&&(t.chrome&&t.chrome.app&&t.chrome.app.runtime||(this.environListener=this.stop.bind(this),r.addEventListener("unload",this.environListener))),this},o.prototype.normalizeTarget=function(t){return e.Utils.normalizeTarget(t,this.configuration.hostportParams)},o.prototype.saveCredentials=function(e){return this.cache.credentials[e.realm]=this.cache.credentials[e.realm]||{},this.cache.credentials[e.realm][e.uri]=e,this},o.prototype.getCredentials=function(e){var t,n;return t=e.ruri.host,this.cache.credentials[t]&&this.cache.credentials[t][e.ruri]&&(n=this.cache.credentials[t][e.ruri],n.method=e.method),n},o.prototype.getLogger=function(e,t){return this.log.getLogger(e,t)},o.prototype.onTransportError=function(){this.status!==s.STATUS_USER_CLOSED&&(this.error&&this.error===s.NETWORK_ERROR||(this.status=s.STATUS_NOT_READY,this.error=s.NETWORK_ERROR))},o.prototype.setTransportListeners=function(){this.transport.on("connected",this.onTransportConnected.bind(this)),this.transport.on("message",this.onTransportReceiveMsg.bind(this)),this.transport.on("transportError",this.onTransportError.bind(this))},o.prototype.onTransportConnected=function(){var e=this;this.configuration.register&&Promise.resolve().then(function(){return e.registerContext.register()})},o.prototype.onTransportReceiveMsg=function(t){var n;if(t=e.Parser.parseMessage(t,this),this.status===e.UA.C.STATUS_USER_CLOSED&&t instanceof e.IncomingRequest)return void this.logger.warn("UA received message when status = USER_CLOSED - aborting");if(e.sanityCheck(t,this,this.transport))if(t instanceof e.IncomingRequest)t.transport=this.transport,this.receiveRequest(t);else if(t instanceof e.IncomingResponse)switch(t.method){case e.C.INVITE:(n=this.transactions.ict[t.via_branch])&&n.receiveResponse(t);break;case e.C.ACK:break;default:(n=this.transactions.nict[t.via_branch])&&n.receiveResponse(t)}},o.prototype.newTransaction=function(e){this.transactions[e.type][e.id]=e,this.emit("newTransaction",{transaction:e})},o.prototype.destroyTransaction=function(e){delete this.transactions[e.type][e.id],this.emit("transactionDestroyed",{transaction:e})},o.prototype.receiveRequest=function(t){function n(e){return e&&e.user===t.ruri.user}var r,i,o,a,c,u,l=t.method,h=this;if(!(n(this.configuration.uri)||n(this.contact.uri)||n(this.contact.pub_gruu)||n(this.contact.temp_gruu)))return this.logger.warn("Request-URI does not point to us"),void(t.method!==e.C.ACK&&t.reply_sl(404));if(t.ruri.scheme===e.C.SIPS)return void t.reply_sl(416);if(!e.Transactions.checkTransaction(this,t))if(l===e.C.OPTIONS?(new e.Transactions.NonInviteServerTransaction(t,this),t.reply(200,null,["Allow: "+e.UA.C.ALLOWED_METHODS.toString(),"Accept: "+s.ACCEPTED_BODY_TYPES])):l===e.C.MESSAGE?(o=new e.ServerContext(this,t),o.body=t.body,o.content_type=t.getHeader("Content-Type")||"text/plain",t.reply(200,null),this.emit("message",o)):l!==e.C.INVITE&&l!==e.C.ACK&&new e.ServerContext(this,t),t.to_tag)r=this.findDialog(t),r?(l===e.C.INVITE&&new e.Transactions.InviteServerTransaction(t,this),r.receiveRequest(t)):l===e.C.NOTIFY?(i=this.findSession(t),a=this.findEarlySubscription(t),i?i.receiveRequest(t):a?a.receiveRequest(t):(this.logger.warn("received NOTIFY request for a non existent session or subscription"),t.reply(481,"Subscription does not exist"))):l!==e.C.ACK&&t.reply(481);else switch(l){case e.C.INVITE:if(c=this.configuration.replaces!==e.C.supported.UNSUPPORTED&&t.parseHeader("replaces")){if(!(u=this.dialogs[c.call_id+c.replaces_to_tag+c.replaces_from_tag]))return void t.reply_sl(481,null);if(u.owner.status===e.Session.C.STATUS_TERMINATED)return void t.reply_sl(603,null);if(u.state===e.Dialog.C.STATUS_CONFIRMED&&c.early_only)return void t.reply_sl(486,null)}i=new e.InviteServerContext(this,t),i.replacee=u&&u.owner,h.emit("invite",i);break;case e.C.BYE:t.reply(481);break;case e.C.CANCEL:i=this.findSession(t),i?i.receiveRequest(t):this.logger.warn("received CANCEL request for a non existent session");break;case e.C.ACK:break;case e.C.NOTIFY:this.configuration.allowLegacyNotifications&&this.listeners("notify").length>0?(t.reply(200,null),h.emit("notify",{request:t})):t.reply(481,"Subscription does not exist");break;case e.C.REFER:if(this.logger.log("Received an out of dialog refer"),this.configuration.allowOutOfDialogRefers){this.logger.log("Allow out of dialog refers is enabled on the UA");var d=new e.ReferServerContext(this,t),f=this.listeners("outOfDialogReferRequested").length;f?this.emit("outOfDialogReferRequested",d):(this.logger.log("No outOfDialogReferRequest listeners, automatically accepting and following the out of dialog refer"),d.accept({followRefer:!0}));break}t.reply(405);break;default:t.reply(405)}},o.prototype.findSession=function(e){return this.sessions[e.call_id+e.from_tag]||this.sessions[e.call_id+e.to_tag]||null},o.prototype.findDialog=function(e){return this.dialogs[e.call_id+e.from_tag+e.to_tag]||this.dialogs[e.call_id+e.to_tag+e.from_tag]||null},o.prototype.findEarlySubscription=function(e){return this.earlySubscriptions[e.call_id+e.to_tag+e.getHeader("event")]||null},o.prototype.loadConfig=function(t){var r,o,s,a,c={viaHost:e.Utils.createRandomToken(12)+".invalid",uri:new e.URI("sip","anonymous."+e.Utils.createRandomToken(6),"anonymous.invalid",null,null),custom:{},displayName:"",password:null,register:!0,registerOptions:{},transportConstructor:n(37)(e),transportOptions:{},userAgentString:e.C.USER_AGENT,noAnswerTimeout:60,hackViaTcp:!1,hackIpInContact:!1,hackWssInTransport:!1,hackAllowUnregisteredOptionTags:!1,sessionDescriptionHandlerFactoryOptions:{constraints:{},peerConnectionOptions:{}},contactName:e.Utils.createRandomToken(8),contactTransport:"ws",forceRport:!1,autostart:!0,autostop:!0,rel100:e.C.supported.UNSUPPORTED,dtmfType:e.C.dtmfType.INFO,replaces:e.C.supported.UNSUPPORTED,sessionDescriptionHandlerFactory:n(38)(e).defaultFactory,authenticationFactory:i(function(t){return new e.DigestAuthentication(t)}),allowLegacyNotifications:!1,allowOutOfDialogRefers:!1},u=this.getConfigurationCheck();for(r in u.mandatory){if(!t.hasOwnProperty(r))throw new e.Exceptions.ConfigurationError(r);if(o=t[r],void 0===(s=u.mandatory[r](o)))throw new e.Exceptions.ConfigurationError(r,o);c[r]=s}for(r in u.optional)if(t.hasOwnProperty(r)){if((o=t[r])instanceof Array&&0===o.length)continue;if(null===o||""===o||void 0===o)continue;if("number"==typeof o&&isNaN(o))continue;if(void 0===(s=u.optional[r](o)))throw new e.Exceptions.ConfigurationError(r,o);c[r]=s}if(0===c.displayName&&(c.displayName="0"),c.sipjsId=e.Utils.createRandomToken(5),a=c.uri.clone(),a.user=null,c.hostportParams=a.toRaw().replace(/^sip:/i,""),c.authorizationUser||(c.authorizationUser=c.uri.user),c.noAnswerTimeout=1e3*c.noAnswerTimeout,c.hackIpInContact)if("boolean"==typeof c.hackIpInContact){var l=Math.floor(254*Math.random()+1);c.viaHost="192.0.2."+l}else"string"==typeof c.hackIpInContact&&(c.viaHost=c.hackIpInContact);c.hackWssInTransport&&(c.contactTransport="wss"),this.contact={pub_gruu:null,temp_gruu:null,uri:new e.URI("sip",c.contactName,c.viaHost,null,{transport:c.contactTransport}),toString:function(e){e=e||{};var t=e.anonymous||null,n=e.outbound||null,r="<";return r+=t?(this.temp_gruu||"sip:anonymous@anonymous.invalid;transport="+c.contactTransport).toString():(this.pub_gruu||this.uri).toString(),n&&(r+=";ob"),r+=">"}};var h={};for(r in c)h[r]=c[r];Object.assign(this.configuration,h),this.logger.log("configuration parameters after validation:");for(r in c)switch(r){case"uri":case"sessionDescriptionHandlerFactory":this.logger.log("· "+r+": "+c[r]);break;case"password":this.logger.log("· "+r+": NOT SHOWN");break;case"transportConstructor":this.logger.log("· "+r+": "+c[r].name);break;default:this.logger.log("· "+r+": "+JSON.stringify(c[r]))}},o.prototype.getConfigurationCheck=function(){return{mandatory:{},optional:{uri:function(t){var n;return/^sip:/i.test(t)||(t=e.C.SIP+":"+t),n=e.URI.parse(t),n&&n.user?n:void 0},transportConstructor:function(e){if(e instanceof Function)return e},transportOptions:function(e){if("object"==typeof e)return e},authorizationUser:function(t){return-1===e.Grammar.parse('"'+t+'"',"quoted_string")?void 0:t},displayName:function(t){return-1===e.Grammar.parse('"'+t+'"',"displayName")?void 0:t},dtmfType:function(t){switch(t){case e.C.dtmfType.RTP:return e.C.dtmfType.RTP;case e.C.dtmfType.INFO:default:return e.C.dtmfType.INFO}},hackViaTcp:function(e){if("boolean"==typeof e)return e},hackIpInContact:function(t){return"boolean"==typeof t?t:"string"==typeof t&&-1!==e.Grammar.parse(t,"host")?t:void 0},hackWssInTransport:function(e){if("boolean"==typeof e)return e},hackAllowUnregisteredOptionTags:function(e){if("boolean"==typeof e)return e},contactTransport:function(e){if("string"==typeof e)return e},forceRport:function(e){if("boolean"==typeof e)return e},noAnswerTimeout:function(t){var n;if(e.Utils.isDecimal(t)&&(n=Number(t))>0)return n},password:function(e){return String(e)},rel100:function(t){return t===e.C.supported.REQUIRED?e.C.supported.REQUIRED:t===e.C.supported.SUPPORTED?e.C.supported.SUPPORTED:e.C.supported.UNSUPPORTED},replaces:function(t){return t===e.C.supported.REQUIRED?e.C.supported.REQUIRED:t===e.C.supported.SUPPORTED?e.C.supported.SUPPORTED:e.C.supported.UNSUPPORTED},register:function(e){if("boolean"==typeof e)return e},registerOptions:function(e){if("object"==typeof e)return e},userAgentString:function(e){if("string"==typeof e)return e},autostart:function(e){if("boolean"==typeof e)return e},autostop:function(e){if("boolean"==typeof e)return e},sessionDescriptionHandlerFactory:function(e){if(e instanceof Function)return e},sessionDescriptionHandlerFactoryOptions:function(e){if("object"==typeof e)return e},authenticationFactory:i,allowLegacyNotifications:function(e){if("boolean"==typeof e)return e},custom:function(e){if("object"==typeof e)return e},contactName:function(e){if("string"==typeof e)return e}}}},o.C=s,e.UA=o}}).call(t,n(1))},function(e,t,n){"use strict";(function(t){e.exports=function(e){function n(e){var t=.8*e;return 1e3*(Math.random()*(e-t)+t)}var r,i={STATUS_CONNECTING:0,STATUS_OPEN:1,STATUS_CLOSING:2,STATUS_CLOSED:3},o=(t.window||t).WebSocket;return r=function(e,t){t=t||{},this.logger=e,this.ws=null,this.server=null,this.connectionPromise=null,this.connectDeferredResolve=null,this.connectionTimeout=null,this.disconnectionPromise=null,this.disconnectDeferredResolve=null,this.boundOnOpen=null,this.boundOnMessage=null,this.boundOnClose=null,this.boundOnError=null,this.reconnectionAttempts=0,this.reconnectTimer=null,this.keepAliveInterval=null,this.keepAliveDebounceTimeout=null,this.status=i.STATUS_CONNECTING,this.configuration={},this.loadConfig(t)},r.prototype=Object.create(e.Transport.prototype,{isConnected:{writable:!0,value:function(){return this.status===i.STATUS_OPEN}},sendPromise:{writable:!0,value:function(e,t){if(t=t||{},!this.statusAssert(i.STATUS_OPEN,t.force))return this.onError("unable to send message - WebSocket not open"),Promise.reject();var n=e.toString();return this.ws?(!0===this.configuration.traceSip&&this.logger.log("sending WebSocket message:\n\n"+n+"\n"),this.ws.send(n),Promise.resolve({msg:n})):(this.onError("unable to send message - WebSocket does not exist"),Promise.reject())}},disconnectPromise:{writable:!0,value:function(e){var t=this;return this.disconnectionPromise?this.disconnectionPromise:(e=e||{},e.code=e.code||1e3,this.statusTransition(i.STATUS_CLOSING,e.force)?(this.emit("disconnecting"),this.disconnectionPromise=new Promise(function(n,r){t.disconnectDeferredResolve=n,t.reconnectTimer&&(clearTimeout(t.reconnectTimer),t.reconnectTimer=null),t.ws?(t.stopSendingKeepAlives(),t.logger.log("closing WebSocket "+t.server.ws_uri),t.ws.close(e.code,e.reason)):r("Attempted to disconnect but the websocket doesn't exist")}),this.disconnectionPromise):this.status===i.STATUS_CLOSED?Promise.resolve({overrideEvent:!0}):this.connectionPromise?this.connectionPromise.then(function(){return Promise.reject("The websocket did not disconnect")}).catch(function(){return Promise.resolve({overrideEvent:!0})}):Promise.reject("The websocket did not disconnect"))}},connectPromise:{writable:!0,value:function(e){return e=e||{},this.status!==i.STATUS_CLOSING||e.force?this.connectionPromise?this.connectionPromise:(this.server=this.server||this.getNextWsServer(e.force),this.connectionPromise=new Promise(function(t,n){var r=this;if((this.status===i.STATUS_OPEN||this.status===i.STATUS_CLOSING)&&!e.force)return this.logger.warn("WebSocket "+this.server.ws_uri+" is already connected"),void n("Failed status check - attempted to open a connection but already open/closing");this.connectDeferredResolve=t,this.status=i.STATUS_CONNECTING,this.emit("connecting"),this.logger.log("connecting to WebSocket "+this.server.ws_uri),this.disposeWs();try{this.ws=new o(this.server.ws_uri,"sip")}catch(e){return this.ws=null,this.status=i.STATUS_CLOSED,this.onError("error connecting to WebSocket "+this.server.ws_uri+":"+e),void n("Failed to create a websocket")}if(!this.ws)return void n("Unexpected instance websocket not set");this.connectionTimeout=setTimeout(function(){r.statusTransition(i.STATUS_CLOSED),r.logger.warn("took too long to connect - exceeded time set in configuration.connectionTimeout: "+r.configuration.connectionTimeout+"s"),r.emit("disconnected",{code:1e3}),r.connectionPromise=null,n("Connection timeout")},1e3*this.configuration.connectionTimeout),this.boundOnOpen=this.onOpen.bind(this),this.boundOnMessage=this.onMessage.bind(this),this.boundOnClose=this.onClose.bind(this),this.boundOnError=this.onWebsocketError.bind(this),this.ws.addEventListener("open",this.boundOnOpen),this.ws.addEventListener("message",this.boundOnMessage),this.ws.addEventListener("close",this.boundOnClose),this.ws.addEventListener("error",this.boundOnError)}.bind(this)),this.connectionPromise):Promise.reject("WebSocket "+this.server.ws_uri+" is closing")}},onOpen:{writable:!0,value:function(){if(this.status===i.STATUS_CLOSED){var e=this.ws;return this.disposeWs(),void e.close(1e3)}this.status=i.STATUS_OPEN,this.emit("connected"),clearTimeout(this.connectionTimeout),this.logger.log("WebSocket "+this.server.ws_uri+" connected"),null!==this.reconnectTimer&&(clearTimeout(this.reconnectTimer),this.reconnectTimer=null),this.reconnectionAttempts=0,this.disconnectionPromise=null,this.disconnectDeferredResolve=null,this.startSendingKeepAlives(),this.connectDeferredResolve?this.connectDeferredResolve({overrideEvent:!0}):this.logger.warn("Unexpected websocket.onOpen with no connectDeferredResolve")}},onClose:{writable:!0,value:function(e){if(this.logger.log("WebSocket disconnected (code: "+e.code+(e.reason?"| reason: "+e.reason:"")+")"),this.status!==i.STATUS_CLOSING&&(this.logger.warn("WebSocket closed without SIP.js requesting it"),this.emit("transportError")),this.stopSendingKeepAlives(),clearTimeout(this.connectionTimeout),this.connectionTimeout=null,this.connectionPromise=null,this.connectDeferredResolve=null,this.disconnectDeferredResolve)return this.disconnectDeferredResolve({overrideEvent:!0}),this.statusTransition(i.STATUS_CLOSED),void(this.disconnectDeferredResolve=null);this.status=i.STATUS_CLOSED,this.emit("disconnected",{code:e.code,reason:e.reason}),this.reconnect()}},disposeWs:{writable:!0,value:function(){this.ws&&(this.ws.removeEventListener("open",this.boundOnOpen),this.ws.removeEventListener("message",this.boundOnMessage),this.ws.removeEventListener("close",this.boundOnClose),this.ws.removeEventListener("error",this.boundOnError),this.boundOnOpen=null,this.boundOnMessage=null,this.boundOnClose=null,this.boundOnError=null,this.ws=null)}},onMessage:{writable:!0,value:function(e){var t=e.data;if(/^(\r\n)+$/.test(t))return this.clearKeepAliveTimeout(),void(!0===this.configuration.traceSip&&this.logger.log("received WebSocket message with CRLF Keep Alive response"));if(!t)return void this.logger.warn("received empty message, message discarded");if("string"!=typeof t){try{t=String.fromCharCode.apply(null,new Uint8Array(t))}catch(e){return void this.logger.warn("received WebSocket binary message failed to be converted into string, message discarded")}!0===this.configuration.traceSip&&this.logger.log("received WebSocket binary message:\n\n"+t+"\n")}else!0===this.configuration.traceSip&&this.logger.log("received WebSocket text message:\n\n"+t+"\n");this.emit("message",t)}},onError:{writable:!0,value:function(e){this.logger.warn("Transport error: "+e),this.emit("transportError")}},onWebsocketError:{writable:!1,value:function(){this.onError("The Websocket had an error")}},reconnect:{writable:!0,value:function(){if(this.reconnectionAttempts>0&&this.logger.log("Reconnection attempt "+this.reconnectionAttempts+" failed"),this.noAvailableServers())return this.logger.warn("no available ws servers left - going to closed state"),this.status=i.STATUS_CLOSED,this.emit("closed"),void this.resetServerErrorStatus();this.isConnected()&&(this.logger.warn("attempted to reconnect while connected - forcing disconnect"),this.disconnect({force:!0})),this.reconnectionAttempts+=1,this.reconnectionAttempts>this.configuration.maxReconnectionAttempts?(this.logger.warn("maximum reconnection attempts for WebSocket "+this.server.ws_uri),this.logger.log("transport "+this.server.ws_uri+" failed | connection state set to 'error'"),this.server.isError=!0,this.emit("transportError"),this.server=this.getNextWsServer(),this.reconnectionAttempts=0,this.reconnect()):(this.logger.log("trying to reconnect to WebSocket "+this.server.ws_uri+" (reconnection attempt "+this.reconnectionAttempts+")"),this.reconnectTimer=setTimeout(function(){this.connect(),this.reconnectTimer=null}.bind(this),1===this.reconnectionAttempts?0:1e3*this.configuration.reconnectionTimeout))}},resetServerErrorStatus:{writable:!0,value:function(){var e,t=this.configuration.wsServers.length;for(e=0;e<t;e++)this.configuration.wsServers[e].isError=!1}},getNextWsServer:{writable:!0,value:function(e){if(this.noAvailableServers())return void this.logger.warn("attempted to get next ws server but there are no available ws servers left");var t,n,r,i=[];for(n=this.configuration.wsServers.length,t=0;t<n;t++)r=this.configuration.wsServers[t],r.isError&&!e||(0===i.length?i.push(r):r.weight>i[0].weight?i=[r]:r.weight===i[0].weight&&i.push(r));return t=Math.floor(Math.random()*i.length),i[t]}},noAvailableServers:{writable:!0,value:function(){var e;for(e in this.configuration.wsServers)if(!this.configuration.wsServers[e].isError)return!1;return!0}},sendKeepAlive:{writable:!0,value:function(){if(!this.keepAliveDebounceTimeout)return this.keepAliveDebounceTimeout=setTimeout(function(){this.emit("keepAliveDebounceTimeout"),this.clearKeepAliveTimeout()}.bind(this),1e3*this.configuration.keepAliveDebounce),this.send("\r\n\r\n")}},clearKeepAliveTimeout:{writable:!0,value:function(){clearTimeout(this.keepAliveDebounceTimeout),this.keepAliveDebounceTimeout=null}},startSendingKeepAlives:{writable:!0,value:function(){this.configuration.keepAliveInterval&&!this.keepAliveInterval&&(this.keepAliveInterval=setInterval(function(){this.sendKeepAlive(),this.startSendingKeepAlives()}.bind(this),n(this.configuration.keepAliveInterval)))}},stopSendingKeepAlives:{writable:!0,value:function(){clearInterval(this.keepAliveInterval),clearTimeout(this.keepAliveDebounceTimeout),this.keepAliveInterval=null,this.keepAliveDebounceTimeout=null}},statusAssert:{writable:!0,value:function(e,t){return e===this.status||(t?(this.logger.warn("Attempted to assert "+Object.keys(i)[this.status]+" as "+Object.keys(i)[e]+"- continuing with option: 'force'"),!0):(this.logger.warn("Tried to assert "+Object.keys(i)[e]+" but is currently "+Object.keys(i)[this.status]),!1))}},statusTransition:{writable:!0,value:function(e,t){return this.logger.log("Attempting to transition status from "+Object.keys(i)[this.status]+" to "+Object.keys(i)[e]),e===i.STATUS_CONNECTING&&this.statusAssert(i.STATUS_CLOSED,t)||e===i.STATUS_OPEN&&this.statusAssert(i.STATUS_CONNECTING,t)||e===i.STATUS_CLOSING&&this.statusAssert(i.STATUS_OPEN,t)||e===i.STATUS_CLOSED?(this.status=e,!0):(this.logger.warn("Status transition failed - result: no-op - reason: either gave an nonexistent status or attempted illegal transition"),!1)}},loadConfig:{writable:!0,value:function(t){var n,r,i,o={wsServers:[{scheme:"WSS",sip_uri:"<sip:edge.sip.onsip.com;transport=ws;lr>",weight:0,ws_uri:"wss://edge.sip.onsip.com",isError:!1}],connectionTimeout:5,maxReconnectionAttempts:3,reconnectionTimeout:4,keepAliveInterval:0,keepAliveDebounce:10,traceSip:!1},s=this.getConfigurationCheck();for(n in s.mandatory){if(!t.hasOwnProperty(n))throw new e.Exceptions.ConfigurationError(n);if(r=t[n],void 0===(i=s.mandatory[n](r)))throw new e.Exceptions.ConfigurationError(n,r);o[n]=i}for(n in s.optional)if(t.hasOwnProperty(n)){if((r=t[n])instanceof Array&&0===r.length)continue;if(null===r||""===r||void 0===r)continue;if("number"==typeof r&&isNaN(r))continue;if(void 0===(i=s.optional[n](r)))throw new e.Exceptions.ConfigurationError(n,r);o[n]=i}var a={};for(n in o)a[n]={value:o[n]};Object.defineProperties(this.configuration,a),this.logger.log("configuration parameters after validation:");for(n in o)this.logger.log("· "+n+": "+JSON.stringify(o[n]))}},getConfigurationCheck:{writable:!0,value:function(){return{mandatory:{},optional:{wsServers:function(t){var n,r,i;if("string"==typeof t)t=[{ws_uri:t}];else{if(!(t instanceof Array))return;for(r=t.length,n=0;n<r;n++)"string"==typeof t[n]&&(t[n]={ws_uri:t[n]})}if(0===t.length)return!1;for(r=t.length,n=0;n<r;n++){if(!t[n].ws_uri)return;if(t[n].weight&&!Number(t[n].weight))return;if(-1===(i=e.Grammar.parse(t[n].ws_uri,"absoluteURI")))return;if(["wss","ws","udp"].indexOf(i.scheme)<0)return;t[n].sip_uri="<sip:"+i.host+(i.port?":"+i.port:"")+";transport="+i.scheme.replace(/^wss$/i,"ws")+";lr>",t[n].weight||(t[n].weight=0),t[n].isError=!1,t[n].scheme=i.scheme.toUpperCase()}return t},keepAliveInterval:function(t){var n;if(e.Utils.isDecimal(t)&&(n=Number(t))>0)return n},keepAliveDebounce:function(t){var n;if(e.Utils.isDecimal(t)&&(n=Number(t))>0)return n},traceSip:function(e){if("boolean"==typeof e)return e},connectionTimeout:function(t){var n;if(e.Utils.isDecimal(t)&&(n=Number(t))>0)return n},maxReconnectionAttempts:function(t){var n;if(e.Utils.isDecimal(t)&&(n=Number(t))>=0)return n},reconnectionTimeout:function(t){var n;if(e.Utils.isDecimal(t)&&(n=Number(t))>0)return n}}}}}}),r.C=i,e.Web.Transport=r,r}}).call(t,n(1))},function(e,t,n){"use strict";(function(t){e.exports=function(e){var r=function(e,n,r){this.options=r||{},this.logger=e,this.observer=n,this.dtmfSender=null,this.shouldAcquireMedia=!0,this.CONTENT_TYPE="application/sdp",this.C={},this.C.DIRECTION={NULL:null,SENDRECV:"sendrecv",SENDONLY:"sendonly",RECVONLY:"recvonly",INACTIVE:"inactive"},this.logger.log("SessionDescriptionHandlerOptions: "+JSON.stringify(this.options)),this.direction=this.C.DIRECTION.NULL,this.modifiers=this.options.modifiers||[],Array.isArray(this.modifiers)||(this.modifiers=[this.modifiers]);var i=t.window||t;this.WebRTC={MediaStream:i.MediaStream,getUserMedia:i.navigator.mediaDevices.getUserMedia.bind(i.navigator.mediaDevices),RTCPeerConnection:i.RTCPeerConnection},this.iceGatheringDeferred=null,this.iceGatheringTimeout=!1,this.iceGatheringTimer=null,this.initPeerConnection(this.options.peerConnectionOptions),this.constraints=this.checkAndDefaultConstraints(this.options.constraints)};return r.defaultFactory=function(e,t){var i=e.ua.getLogger("sip.invitecontext.sessionDescriptionHandler",e.id),o=n(39),s=new o(e,t);return new r(i,s,t)},r.prototype=Object.create(e.SessionDescriptionHandler.prototype,{close:{writable:!0,value:function(){this.logger.log("closing PeerConnection"),this.peerConnection&&"closed"!==this.peerConnection.signalingState&&(this.peerConnection.getSenders?this.peerConnection.getSenders().forEach(function(e){e.track&&e.track.stop()}):(this.logger.warn("Using getLocalStreams which is deprecated"),this.peerConnection.getLocalStreams().forEach(function(e){e.getTracks().forEach(function(e){e.stop()})})),this.peerConnection.getReceivers?this.peerConnection.getReceivers().forEach(function(e){e.track&&e.track.stop()}):(this.logger.warn("Using getRemoteStreams which is deprecated"),this.peerConnection.getRemoteStreams().forEach(function(e){e.getTracks().forEach(function(e){e.stop()})})),this.resetIceGatheringComplete(),this.peerConnection.close())}},getDescription:{writable:!0,value:function(e,t){var n=this;e=e||{},e.peerConnectionOptions&&this.initPeerConnection(e.peerConnectionOptions);var r=Object.assign({},this.constraints,e.constraints);return r=this.checkAndDefaultConstraints(r),JSON.stringify(r)!==JSON.stringify(this.constraints)&&(this.constraints=r,this.shouldAcquireMedia=!0),t=t||[],Array.isArray(t)||(t=[t]),t=t.concat(this.modifiers),Promise.resolve().then(function(){if(n.shouldAcquireMedia)return n.acquire(n.constraints).then(function(){n.shouldAcquireMedia=!1})}).then(function(){return n.createOfferOrAnswer(e.RTCOfferOptions,t)}).then(function(e){return n.emit("getDescription",e),{body:e.sdp,contentType:n.CONTENT_TYPE}})}},hasDescription:{writable:!0,value:function(e){return e===this.CONTENT_TYPE}},holdModifier:{writable:!0,value:function(e){return/a=(sendrecv|sendonly|recvonly|inactive)/.test(e.sdp)?(e.sdp=e.sdp.replace(/a=sendrecv\r\n/g,"a=sendonly\r\n"),e.sdp=e.sdp.replace(/a=recvonly\r\n/g,"a=inactive\r\n")):e.sdp=e.sdp.replace(/(m=[^\r]*\r\n)/g,"$1a=sendonly\r\n"),Promise.resolve(e)}},setDescription:{writable:!0,value:function(t,n,r){var i=this;n=n||{},n.peerConnectionOptions&&this.initPeerConnection(n.peerConnectionOptions),r=r||[],Array.isArray(r)||(r=[r]),r=r.concat(this.modifiers);var o={type:this.hasOffer("local")?"answer":"offer",sdp:t};return Promise.resolve().then(function(){if(i.shouldAcquireMedia&&i.options.alwaysAcquireMediaFirst)return i.acquire(i.constraints).then(function(){i.shouldAcquireMedia=!1})}).then(function(){return e.Utils.reducePromises(r,o)}).catch(function(t){if(t instanceof e.Exceptions.SessionDescriptionHandlerError)throw t;var n=new e.Exceptions.SessionDescriptionHandlerError("setDescription",t,"The modifiers did not resolve successfully");throw i.logger.error(n.message),i.emit("peerConnection-setRemoteDescriptionFailed",n),n}).then(function(e){return i.emit("setDescription",e),i.peerConnection.setRemoteDescription(e)}).catch(function(o){if(o instanceof e.Exceptions.SessionDescriptionHandlerError)throw o;if(/^m=video.+$/gm.test(t)&&!n.disableAudioFallback)return n.disableAudioFallback=!0,i.setDescription(t,n,[e.Web.Modifiers.stripVideo].concat(r));var s=new e.Exceptions.SessionDescriptionHandlerError("setDescription",o);throw i.logger.error(s.error),i.emit("peerConnection-setRemoteDescriptionFailed",s),s}).then(function(){i.peerConnection.getReceivers?i.emit("setRemoteDescription",i.peerConnection.getReceivers()):i.emit("setRemoteDescription",i.peerConnection.getRemoteStreams()),i.emit("confirmed",i)})}},sendDtmf:{writable:!0,value:function(e,t){if(!this.dtmfSender&&this.hasBrowserGetSenderSupport()){var n=this.peerConnection.getSenders();n.length>0&&(this.dtmfSender=n[0].dtmf)}if(!this.dtmfSender&&this.hasBrowserTrackSupport()){var r=this.peerConnection.getLocalStreams();if(r.length>0){var i=r[0].getAudioTracks();i.length>0&&(this.dtmfSender=this.peerConnection.createDTMFSender(i[0]))}}if(!this.dtmfSender)return!1;try{this.dtmfSender.insertDTMF(e,t.duration,t.interToneGap)}catch(e){if("InvalidStateError"===e.type||"InvalidCharacterError"===e.type)return this.logger.error(e),!1;throw e}return this.logger.log("DTMF sent via RTP: "+e.toString()),!0}},getDirection:{writable:!0,value:function(){return this.direction}},createOfferOrAnswer:{writable:!0,value:function(t,n){var r,i=this,o=this.peerConnection;return t=t||{},r=this.hasOffer("remote")?"createAnswer":"createOffer",this.logger.log(r),o[r](t).catch(function(t){if(t instanceof e.Exceptions.SessionDescriptionHandlerError)throw t;var n=new e.Exceptions.SessionDescriptionHandlerError("createOfferOrAnswer",t,"peerConnection-"+r+"Failed");throw i.emit("peerConnection-"+r+"Failed",n),n}).then(function(t){return e.Utils.reducePromises(n,i.createRTCSessionDescriptionInit(t))}).then(function(e){return i.resetIceGatheringComplete(),i.logger.log("Setting local sdp."),i.logger.log(e.sdp),o.setLocalDescription(e)}).catch(function(t){if(t instanceof e.Exceptions.SessionDescriptionHandlerError)throw t;var n=new e.Exceptions.SessionDescriptionHandlerError("createOfferOrAnswer",t,"peerConnection-SetLocalDescriptionFailed");throw i.emit("peerConnection-SetLocalDescriptionFailed",n),n}).then(function(){return i.waitForIceGatheringComplete()}).then(function(){var t=i.createRTCSessionDescriptionInit(i.peerConnection.localDescription);return e.Utils.reducePromises(n,t)}).then(function(e){return i.setDirection(e.sdp),e}).catch(function(t){if(t instanceof e.Exceptions.SessionDescriptionHandlerError)throw t;var n=new e.Exceptions.SessionDescriptionHandlerError("createOfferOrAnswer",t);throw i.logger.error(n),n})}},createRTCSessionDescriptionInit:{writable:!0,value:function(e){return{type:e.type,sdp:e.sdp}}},addDefaultIceCheckingTimeout:{writable:!0,value:function(e){return void 0===e.iceCheckingTimeout&&(e.iceCheckingTimeout=5e3),e}},addDefaultIceServers:{writable:!0,value:function(e){return e.iceServers||(e.iceServers=[{urls:"stun:stun.l.google.com:19302"}]),e}},checkAndDefaultConstraints:{writable:!0,value:function(e){var t={audio:!0,video:!this.options.alwaysAcquireMediaFirst};return e=e||t,0===Object.keys(e).length&&e.constructor===Object?t:e}},hasBrowserTrackSupport:{writable:!0,value:function(){return Boolean(this.peerConnection.addTrack)}},hasBrowserGetSenderSupport:{writable:!0,value:function(){return Boolean(this.peerConnection.getSenders)}},initPeerConnection:{writable:!0,value:function(e){var t=this;e=e||{},e=this.addDefaultIceCheckingTimeout(e),e.rtcConfiguration=e.rtcConfiguration||{},e.rtcConfiguration=this.addDefaultIceServers(e.rtcConfiguration),this.logger.log("initPeerConnection"),this.peerConnection&&(this.logger.log("Already have a peer connection for this session. Tearing down."),this.resetIceGatheringComplete(),this.peerConnection.close()),this.peerConnection=new this.WebRTC.RTCPeerConnection(e.rtcConfiguration),this.logger.log("New peer connection created"),"ontrack"in this.peerConnection?this.peerConnection.addEventListener("track",function(e){t.logger.log("track added"),t.observer.trackAdded(),t.emit("addTrack",e)}):(this.logger.warn("Using onaddstream which is deprecated"),this.peerConnection.onaddstream=function(e){t.logger.log("stream added"),t.emit("addStream",e)}),this.peerConnection.onicecandidate=function(e){t.emit("iceCandidate",e),e.candidate?t.logger.log("ICE candidate received: "+(null===e.candidate.candidate?null:e.candidate.candidate.trim())):null===e.candidate&&(t.logger.log("ICE candidate gathering complete"),t.triggerIceGatheringComplete())},this.peerConnection.onicegatheringstatechange=function(){switch(t.logger.log("RTCIceGatheringState changed: "+this.iceGatheringState),this.iceGatheringState){case"gathering":t.emit("iceGathering",this),!t.iceGatheringTimer&&e.iceCheckingTimeout&&(t.iceGatheringTimeout=!1,t.iceGatheringTimer=setTimeout(function(){t.logger.log("RTCIceChecking Timeout Triggered after "+e.iceCheckingTimeout+" milliseconds"),t.iceGatheringTimeout=!0,t.triggerIceGatheringComplete()},e.iceCheckingTimeout));break;case"complete":t.triggerIceGatheringComplete()}},this.peerConnection.oniceconnectionstatechange=function(){var e;switch(this.iceConnectionState){case"new":e="iceConnection";break;case"checking":e="iceConnectionChecking";break;case"connected":e="iceConnectionConnected";break;case"completed":e="iceConnectionCompleted";break;case"failed":e="iceConnectionFailed";break;case"disconnected":e="iceConnectionDisconnected";break;case"closed":e="iceConnectionClosed";break;default:return void t.logger.warn("Unknown iceConnection state:",this.iceConnectionState)}t.logger.log("ICE Connection State changed to "+e),t.emit(e,this)}}},acquire:{writable:!0,value:function(t){var n=this;return t=this.checkAndDefaultConstraints(t),new Promise(function(e,r){n.logger.log("acquiring local media"),n.emit("userMediaRequest",t),t.audio||t.video?n.WebRTC.getUserMedia(t).then(function(t){n.observer.trackAdded(),n.emit("userMedia",t),e(t)}).catch(function(e){n.emit("userMediaFailed",e),r(e)}):e([])}).catch(function(t){if(t instanceof e.Exceptions.SessionDescriptionHandlerError)throw t;var r=new e.Exceptions.SessionDescriptionHandlerError("acquire",t,"unable to acquire streams");throw n.logger.error(r.message),n.logger.error(r.error),r}).then(function(e){n.logger.log("acquired local media streams");try{return n.peerConnection.removeTrack&&n.peerConnection.getSenders().forEach(function(e){n.peerConnection.removeTrack(e)}),e}catch(e){return Promise.reject(e)}}).catch(function(t){if(t instanceof e.Exceptions.SessionDescriptionHandlerError)throw t;var r=new e.Exceptions.SessionDescriptionHandlerError("acquire",t,"error removing streams");throw n.logger.error(r.message),n.logger.error(r.error),r}).then(function(e){try{e=[].concat(e),e.forEach(function(e){n.peerConnection.addTrack?e.getTracks().forEach(function(t){n.peerConnection.addTrack(t,e)}):n.peerConnection.addStream(e)})}catch(e){return Promise.reject(e)}return Promise.resolve()}).catch(function(t){if(t instanceof e.Exceptions.SessionDescriptionHandlerError)throw t;var r=new e.Exceptions.SessionDescriptionHandlerError("acquire",t,"error adding stream");throw n.logger.error(r.message),n.logger.error(r.error),r})}},hasOffer:{writable:!0,value:function(e){var t="have-"+e+"-offer";return this.peerConnection.signalingState===t}},isIceGatheringComplete:{writable:!0,value:function(){return"complete"===this.peerConnection.iceGatheringState||this.iceGatheringTimeout}},resetIceGatheringComplete:{writable:!0,value:function(){this.iceGatheringTimeout=!1,this.logger.log("resetIceGatheringComplete"),this.iceGatheringTimer&&(clearTimeout(this.iceGatheringTimer),this.iceGatheringTimer=null),this.iceGatheringDeferred&&(this.iceGatheringDeferred.reject(),this.iceGatheringDeferred=null)}},setDirection:{writable:!0,value:function(e){var t=e.match(/a=(sendrecv|sendonly|recvonly|inactive)/);if(null===t)return this.direction=this.C.DIRECTION.NULL,void this.observer.directionChanged();var n=t[1];switch(n){case this.C.DIRECTION.SENDRECV:case this.C.DIRECTION.SENDONLY:case this.C.DIRECTION.RECVONLY:case this.C.DIRECTION.INACTIVE:this.direction=n;break;default:this.direction=this.C.DIRECTION.NULL}this.observer.directionChanged()}},triggerIceGatheringComplete:{writable:!0,value:function(){this.isIceGatheringComplete()&&(this.emit("iceGatheringComplete",this),this.iceGatheringTimer&&(clearTimeout(this.iceGatheringTimer),this.iceGatheringTimer=null),this.iceGatheringDeferred&&(this.iceGatheringDeferred.resolve(),this.iceGatheringDeferred=null))}},waitForIceGatheringComplete:{writable:!0,value:function(){return this.logger.log("waitForIceGatheringComplete"),this.isIceGatheringComplete()?(this.logger.log("ICE is already complete. Return resolved."),Promise.resolve()):(this.isIceGatheringDeferred||(this.iceGatheringDeferred=e.Utils.defer()),this.logger.log("ICE is not complete. Returning promise"),this.iceGatheringDeferred.promise)}}}),r}}).call(t,n(1))},function(e,t,n){"use strict";var r=function(e,t){this.session=e||{},this.options=t||{}};r.prototype={trackAdded:function(){this.session.emit("trackAdded")},directionChanged:function(){this.session.emit("directionChanged")}},e.exports=r},function(e,t,n){"use strict";e.exports=function(e){function t(t,n,r){var i,o=e.Utils.buildStatusLine(t),s=n.getHeaders("via"),a=s.length,c=0;for(c;c<a;c++)o+="Via: "+s[c]+"\r\n";i=n.getHeader("To"),n.to_tag||(i+=";tag="+e.Utils.newTag()),o+="To: "+i+"\r\n",o+="From: "+n.getHeader("From")+"\r\n",o+="Call-ID: "+n.call_id+"\r\n",o+="CSeq: "+n.cseq+" "+n.method+"\r\n",o+="\r\n",r.send(o)}function n(e,n,r){if(!e.ruri||"sip"!==e.ruri.scheme)return t(416,e,r),!1}function r(e,n,r){if(!e.to_tag&&e.call_id.substr(0,5)===n.configuration.sipjsId)return t(482,e,r),!1}function i(n,r,i){if(e.Utils.str_utf8_length(n.body)<n.getHeader("content-length"))return t(400,n,i),!1}function o(n,r,i){var o,s,a=n.from_tag,c=n.call_id,u=n.cseq;if(!n.to_tag)if(n.method===e.C.INVITE){if(o=r.transactions.ist[n.via_branch])return;for(s in r.transactions.ist)if(o=r.transactions.ist[s],o.request.from_tag===a&&o.request.call_id===c&&o.request.cseq===u)return t(482,n,i),!1}else{if(o=r.transactions.nist[n.via_branch])return;for(s in r.transactions.nist)if(o=r.transactions.nist[s],o.request.from_tag===a&&o.request.call_id===c&&o.request.cseq===u)return t(482,n,i),!1}}function s(e,t){if(e.getHeaders("via").length>1)return t.getLogger("sip.sanitycheck").warn("More than one Via header field present in the response. Dropping the response"),!1}function a(e,t){var n=t.configuration.viaHost;if(e.via.host!==n||void 0!==e.via.port)return t.getLogger("sip.sanitycheck").warn("Via sent-by in the response does not match UA Via host value. Dropping the response"),!1}function c(t,n){if(e.Utils.str_utf8_length(t.body)<t.getHeader("content-length"))return n.getLogger("sip.sanitycheck").warn("Message body length is lower than the value in Content-Length header field. Dropping the response"),!1}function u(e,t){for(var n=["from","to","call_id","cseq","via"],r=n.length;r--;)if(!e.hasHeader(n[r]))return t.getLogger("sip.sanitycheck").warn("Missing mandatory header field : "+n[r]+". Dropping the response"),!1}var l,h=[],d=[],f=[];h.push(n),h.push(r),h.push(i),h.push(o),d.push(s),d.push(a),d.push(c),f.push(u),l=function(t,n,r){var i;for(i=f.length;i--;)if(!1===f[i](t,n,r))return!1;if(t instanceof e.IncomingRequest){for(i=h.length;i--;)if(!1===h[i](t,n,r))return!1}else if(t instanceof e.IncomingResponse)for(i=d.length;i--;)if(!1===d[i](t,n,r))return!1;return!0},e.sanityCheck=l}},function(e,t,n){"use strict";var r=n(42);e.exports=function(e){var t;return t=function(e){this.logger=e.getLogger("sipjs.digestauthentication"),this.username=e.configuration.authorizationUser,this.password=e.configuration.password,this.cnonce=null,this.nc=0,this.ncHex="00000000",this.response=null},t.prototype.authenticate=function(t,n){if(this.algorithm=n.algorithm,this.realm=n.realm,this.nonce=n.nonce,this.opaque=n.opaque,this.stale=n.stale,this.algorithm){if("MD5"!==this.algorithm)return this.logger.warn('challenge with Digest algorithm different than "MD5", authentication aborted'),!1}else this.algorithm="MD5";if(!this.realm)return this.logger.warn("challenge without Digest realm, authentication aborted"),!1;if(!this.nonce)return this.logger.warn("challenge without Digest nonce, authentication aborted"),!1;if(n.qop)if(n.qop.indexOf("auth")>-1)this.qop="auth";else{if(!(n.qop.indexOf("auth-int")>-1))return this.logger.warn('challenge without Digest qop different than "auth" or "auth-int", authentication aborted'),!1;this.qop="auth-int"}else this.qop=null;return this.method=t.method,this.uri=t.ruri,this.cnonce=e.createRandomToken(12),this.nc+=1,this.updateNcHex(),4294967296===this.nc&&(this.nc=1,this.ncHex="00000001"),this.calculateResponse(),!0},t.prototype.calculateResponse=function(){var e,t;e=r(this.username+":"+this.realm+":"+this.password),"auth"===this.qop?(t=r(this.method+":"+this.uri),this.response=r(e+":"+this.nonce+":"+this.ncHex+":"+this.cnonce+":auth:"+t)):"auth-int"===this.qop?(t=r(this.method+":"+this.uri+":"+r(this.body?this.body:"")),this.response=r(e+":"+this.nonce+":"+this.ncHex+":"+this.cnonce+":auth-int:"+t)):null===this.qop&&(t=r(this.method+":"+this.uri),this.response=r(e+":"+this.nonce+":"+t))},t.prototype.toString=function(){var e=[];if(!this.response)throw new Error("response field does not exist, cannot generate Authorization header");return e.push("algorithm="+this.algorithm),e.push('username="'+this.username+'"'),e.push('realm="'+this.realm+'"'),e.push('nonce="'+this.nonce+'"'),e.push('uri="'+this.uri+'"'),e.push('response="'+this.response+'"'),this.opaque&&e.push('opaque="'+this.opaque+'"'),this.qop&&(e.push("qop="+this.qop),e.push('cnonce="'+this.cnonce+'"'),e.push("nc="+this.ncHex)),"Digest "+e.join(", ")},t.prototype.updateNcHex=function(){var e=Number(this.nc).toString(16);this.ncHex="00000000".substr(0,8-e.length)+e},t}},function(e,t,n){!function(r,i){e.exports=t=function(e){return function(t){function n(e,t,n,r,i,o,s){var a=e+(t&n|~t&r)+i+s;return(a<<o|a>>>32-o)+t}function r(e,t,n,r,i,o,s){var a=e+(t&r|n&~r)+i+s;return(a<<o|a>>>32-o)+t}function i(e,t,n,r,i,o,s){var a=e+(t^n^r)+i+s;return(a<<o|a>>>32-o)+t}function o(e,t,n,r,i,o,s){var a=e+(n^(t|~r))+i+s;return(a<<o|a>>>32-o)+t}var s=e,a=s.lib,c=a.WordArray,u=a.Hasher,l=s.algo,h=[];!function(){for(var e=0;e<64;e++)h[e]=4294967296*t.abs(t.sin(e+1))|0}();var d=l.MD5=u.extend({_doReset:function(){this._hash=new c.init([1732584193,4023233417,2562383102,271733878])},_doProcessBlock:function(e,t){for(var s=0;s<16;s++){var a=t+s,c=e[a];e[a]=16711935&(c<<8|c>>>24)|4278255360&(c<<24|c>>>8)}var u=this._hash.words,l=e[t+0],d=e[t+1],f=e[t+2],p=e[t+3],g=e[t+4],m=e[t+5],v=e[t+6],T=e[t+7],y=e[t+8],_=e[t+9],S=e[t+10],E=e[t+11],C=e[t+12],b=e[t+13],R=e[t+14],w=e[t+15],I=u[0],A=u[1],O=u[2],D=u[3];I=n(I,A,O,D,l,7,h[0]),D=n(D,I,A,O,d,12,h[1]),O=n(O,D,I,A,f,17,h[2]),A=n(A,O,D,I,p,22,h[3]),I=n(I,A,O,D,g,7,h[4]),D=n(D,I,A,O,m,12,h[5]),O=n(O,D,I,A,v,17,h[6]),A=n(A,O,D,I,T,22,h[7]),I=n(I,A,O,D,y,7,h[8]),D=n(D,I,A,O,_,12,h[9]),O=n(O,D,I,A,S,17,h[10]),A=n(A,O,D,I,E,22,h[11]),I=n(I,A,O,D,C,7,h[12]),D=n(D,I,A,O,b,12,h[13]),O=n(O,D,I,A,R,17,h[14]),A=n(A,O,D,I,w,22,h[15]),I=r(I,A,O,D,d,5,h[16]),D=r(D,I,A,O,v,9,h[17]),O=r(O,D,I,A,E,14,h[18]),A=r(A,O,D,I,l,20,h[19]),I=r(I,A,O,D,m,5,h[20]),D=r(D,I,A,O,S,9,h[21]),O=r(O,D,I,A,w,14,h[22]),A=r(A,O,D,I,g,20,h[23]),I=r(I,A,O,D,_,5,h[24]),D=r(D,I,A,O,R,9,h[25]),O=r(O,D,I,A,p,14,h[26]),A=r(A,O,D,I,y,20,h[27]),I=r(I,A,O,D,b,5,h[28]),D=r(D,I,A,O,f,9,h[29]),O=r(O,D,I,A,T,14,h[30]),A=r(A,O,D,I,C,20,h[31]),I=i(I,A,O,D,m,4,h[32]),D=i(D,I,A,O,y,11,h[33]),O=i(O,D,I,A,E,16,h[34]),A=i(A,O,D,I,R,23,h[35]),I=i(I,A,O,D,d,4,h[36]),D=i(D,I,A,O,g,11,h[37]),O=i(O,D,I,A,T,16,h[38]),A=i(A,O,D,I,S,23,h[39]),I=i(I,A,O,D,b,4,h[40]),D=i(D,I,A,O,l,11,h[41]),O=i(O,D,I,A,p,16,h[42]),A=i(A,O,D,I,v,23,h[43]),I=i(I,A,O,D,_,4,h[44]),D=i(D,I,A,O,C,11,h[45]),O=i(O,D,I,A,w,16,h[46]),A=i(A,O,D,I,f,23,h[47]),I=o(I,A,O,D,l,6,h[48]),D=o(D,I,A,O,T,10,h[49]),O=o(O,D,I,A,R,15,h[50]),A=o(A,O,D,I,m,21,h[51]),I=o(I,A,O,D,C,6,h[52]),D=o(D,I,A,O,p,10,h[53]),O=o(O,D,I,A,S,15,h[54]),A=o(A,O,D,I,d,21,h[55]),I=o(I,A,O,D,y,6,h[56]),D=o(D,I,A,O,w,10,h[57]),O=o(O,D,I,A,v,15,h[58]),A=o(A,O,D,I,b,21,h[59]),I=o(I,A,O,D,g,6,h[60]),D=o(D,I,A,O,E,10,h[61]),O=o(O,D,I,A,f,15,h[62]),A=o(A,O,D,I,_,21,h[63]),u[0]=u[0]+I|0,u[1]=u[1]+A|0,u[2]=u[2]+O|0,u[3]=u[3]+D|0},_doFinalize:function(){var e=this._data,n=e.words,r=8*this._nDataBytes,i=8*e.sigBytes;n[i>>>5]|=128<<24-i%32;var o=t.floor(r/4294967296),s=r;n[15+(i+64>>>9<<4)]=16711935&(o<<8|o>>>24)|4278255360&(o<<24|o>>>8),n[14+(i+64>>>9<<4)]=16711935&(s<<8|s>>>24)|4278255360&(s<<24|s>>>8),e.sigBytes=4*(n.length+1),this._process();for(var a=this._hash,c=a.words,u=0;u<4;u++){var l=c[u];c[u]=16711935&(l<<8|l>>>24)|4278255360&(l<<24|l>>>8)}return a},clone:function(){var e=u.clone.call(this);return e._hash=this._hash.clone(),e}});s.MD5=u._createHelper(d),s.HmacMD5=u._createHmacHelper(d)}(Math),e.MD5}(n(43))}()},function(e,t,n){!function(n,r){e.exports=t=function(){var e=e||function(e,t){var n=Object.create||function(){function e(){}return function(t){var n;return e.prototype=t,n=new e,e.prototype=null,n}}(),r={},i=r.lib={},o=i.Base=function(){return{extend:function(e){var t=n(this);return e&&t.mixIn(e),t.hasOwnProperty("init")&&this.init!==t.init||(t.init=function(){t.$super.init.apply(this,arguments)}),t.init.prototype=t,t.$super=this,t},create:function(){var e=this.extend();return e.init.apply(e,arguments),e},init:function(){},mixIn:function(e){for(var t in e)e.hasOwnProperty(t)&&(this[t]=e[t]);e.hasOwnProperty("toString")&&(this.toString=e.toString)},clone:function(){return this.init.prototype.extend(this)}}}(),s=i.WordArray=o.extend({init:function(e,t){e=this.words=e||[],this.sigBytes=void 0!=t?t:4*e.length},toString:function(e){return(e||c).stringify(this)},concat:function(e){var t=this.words,n=e.words,r=this.sigBytes,i=e.sigBytes;if(this.clamp(),r%4)for(var o=0;o<i;o++){var s=n[o>>>2]>>>24-o%4*8&255;t[r+o>>>2]|=s<<24-(r+o)%4*8}else for(var o=0;o<i;o+=4)t[r+o>>>2]=n[o>>>2];return this.sigBytes+=i,this},clamp:function(){var t=this.words,n=this.sigBytes;t[n>>>2]&=4294967295<<32-n%4*8,t.length=e.ceil(n/4)},clone:function(){var e=o.clone.call(this);return e.words=this.words.slice(0),e},random:function(t){for(var n,r=[],i=0;i<t;i+=4){var o=function(t){var t=t,n=987654321,r=4294967295;return function(){n=36969*(65535&n)+(n>>16)&r,t=18e3*(65535&t)+(t>>16)&r;var i=(n<<16)+t&r;return i/=4294967296,(i+=.5)*(e.random()>.5?1:-1)}}(4294967296*(n||e.random()));n=987654071*o(),r.push(4294967296*o()|0)}return new s.init(r,t)}}),a=r.enc={},c=a.Hex={stringify:function(e){for(var t=e.words,n=e.sigBytes,r=[],i=0;i<n;i++){var o=t[i>>>2]>>>24-i%4*8&255;r.push((o>>>4).toString(16)),r.push((15&o).toString(16))}return r.join("")},parse:function(e){for(var t=e.length,n=[],r=0;r<t;r+=2)n[r>>>3]|=parseInt(e.substr(r,2),16)<<24-r%8*4;return new s.init(n,t/2)}},u=a.Latin1={stringify:function(e){for(var t=e.words,n=e.sigBytes,r=[],i=0;i<n;i++){var o=t[i>>>2]>>>24-i%4*8&255;r.push(String.fromCharCode(o))}return r.join("")},parse:function(e){for(var t=e.length,n=[],r=0;r<t;r++)n[r>>>2]|=(255&e.charCodeAt(r))<<24-r%4*8;return new s.init(n,t)}},l=a.Utf8={stringify:function(e){try{return decodeURIComponent(escape(u.stringify(e)))}catch(e){throw new Error("Malformed UTF-8 data")}},parse:function(e){return u.parse(unescape(encodeURIComponent(e)))}},h=i.BufferedBlockAlgorithm=o.extend({reset:function(){this._data=new s.init,this._nDataBytes=0},_append:function(e){"string"==typeof e&&(e=l.parse(e)),this._data.concat(e),this._nDataBytes+=e.sigBytes},_process:function(t){var n=this._data,r=n.words,i=n.sigBytes,o=this.blockSize,a=4*o,c=i/a;c=t?e.ceil(c):e.max((0|c)-this._minBufferSize,0);var u=c*o,l=e.min(4*u,i);if(u){for(var h=0;h<u;h+=o)this._doProcessBlock(r,h);var d=r.splice(0,u);n.sigBytes-=l}return new s.init(d,l)},clone:function(){var e=o.clone.call(this);return e._data=this._data.clone(),e},_minBufferSize:0}),d=(i.Hasher=h.extend({cfg:o.extend(),init:function(e){this.cfg=this.cfg.extend(e),this.reset()},reset:function(){h.reset.call(this),this._doReset()},update:function(e){return this._append(e),this._process(),this},finalize:function(e){return e&&this._append(e),this._doFinalize()},blockSize:16,_createHelper:function(e){return function(t,n){return new e.init(n).finalize(t)}},_createHmacHelper:function(e){return function(t,n){return new d.HMAC.init(e,n).finalize(t)}}}),r.algo={});return r}(Math);return e}()}()},function(e,t,n){"use strict";var r=n(45);e.exports=function(e){return{parse:function(t,n){var i={startRule:n,SIP:e};try{r.parse(t,i)}catch(e){i.data=-1}return i.data}}}},function(e,t,n){var r,i,o;!function(n,s){i=[],r=s,void 0!==(o="function"==typeof r?r.apply(t,i):r)&&(e.exports=o)}(0,function(){"use strict";function e(t,n,r,i){this.message=t,this.expected=n,this.found=r,this.location=i,this.name="SyntaxError","function"==typeof Error.captureStackTrace&&Error.captureStackTrace(this,e)}function t(t,n){function r(){return t.substring(_,y)}function i(){return c(_,y)}function o(e,t){return{type:"literal",text:e,ignoreCase:t}}function s(e,t,n){return{type:"class",parts:e,inverted:t,ignoreCase:n}}function a(e){var n,r=S[e];if(r)return r;for(n=e-1;!S[n];)n--;for(r=S[n],r={line:r.line,column:r.column};n<e;)10===t.charCodeAt(n)?(r.line++,r.column=1):r.column++,n++;return S[e]=r,r}function c(e,t){var n=a(e),r=a(t);return{start:{offset:e,line:n.line,column:n.column},end:{offset:t,line:r.line,column:r.column}}}function u(e){y<E||(y>E&&(E=y,C=[]),C.push(e))}function l(e){var t,n=new Array(e.length);for(t=0;t<e.length;t++)n[t]=e.charCodeAt(t)-32;return n}function h(e){for(var n,r,i=T[e],o=0,s=[],a=i.length,c=[],l=[];;){for(;o<a;)switch(i[o]){case 0:l.push(v[i[o+1]]),o+=2;break;case 1:l.push(void 0),o++;break;case 2:l.push(null),o++;break;case 3:l.push(p),o++;break;case 4:l.push([]),o++;break;case 5:l.push(y),o++;break;case 6:l.pop(),o++;break;case 7:y=l.pop(),o++;break;case 8:l.length-=i[o+1],o+=2;break;case 9:l.splice(-2,1),o++;break;case 10:l[l.length-2].push(l.pop()),o++;break;case 11:l.push(l.splice(l.length-i[o+1],i[o+1])),o+=2;break;case 12:l.push(t.substring(l.pop(),y)),o++;break;case 13:c.push(a),s.push(o+3+i[o+1]+i[o+2]),l[l.length-1]?(a=o+3+i[o+1],o+=3):(a=o+3+i[o+1]+i[o+2],o+=3+i[o+1]);break;case 14:c.push(a),s.push(o+3+i[o+1]+i[o+2]),l[l.length-1]===p?(a=o+3+i[o+1],o+=3):(a=o+3+i[o+1]+i[o+2],o+=3+i[o+1]);break;case 15:c.push(a),s.push(o+3+i[o+1]+i[o+2]),l[l.length-1]!==p?(a=o+3+i[o+1],o+=3):(a=o+3+i[o+1]+i[o+2],o+=3+i[o+1]);break;case 16:l[l.length-1]!==p?(c.push(a),s.push(o),a=o+2+i[o+1],o+=2):o+=2+i[o+1];break;case 17:c.push(a),s.push(o+3+i[o+1]+i[o+2]),t.length>y?(a=o+3+i[o+1],o+=3):(a=o+3+i[o+1]+i[o+2],o+=3+i[o+1]);break;case 18:c.push(a),s.push(o+4+i[o+2]+i[o+3]),t.substr(y,v[i[o+1]].length)===v[i[o+1]]?(a=o+4+i[o+2],o+=4):(a=o+4+i[o+2]+i[o+3],o+=4+i[o+2]);break;case 19:c.push(a),s.push(o+4+i[o+2]+i[o+3]),t.substr(y,v[i[o+1]].length).toLowerCase()===v[i[o+1]]?(a=o+4+i[o+2],o+=4):(a=o+4+i[o+2]+i[o+3],o+=4+i[o+2]);break;case 20:c.push(a),s.push(o+4+i[o+2]+i[o+3]),v[i[o+1]].test(t.charAt(y))?(a=o+4+i[o+2],o+=4):(a=o+4+i[o+2]+i[o+3],o+=4+i[o+2]);break;case 21:l.push(t.substr(y,i[o+1])),y+=i[o+1],o+=2;break;case 22:l.push(v[i[o+1]]),y+=v[i[o+1]].length,o+=2;break;case 23:l.push(p),0===b&&u(v[i[o+1]]),o+=2;break;case 24:_=l[l.length-1-i[o+1]],o+=2;break;case 25:_=y,o++;break;case 26:for(n=i.slice(o+4,o+4+i[o+3]),r=0;r<i[o+3];r++)n[r]=l[l.length-1-n[r]];l.splice(l.length-i[o+2],i[o+2],v[i[o+1]].apply(null,n)),o+=4+i[o+3];break;case 27:l.push(h(i[o+1])),o+=2;break;case 28:b++,o++;break;case 29:b--,o++;break;default:throw new Error("Invalid opcode: "+i[o]+".")}if(!(c.length>0))break;a=c.pop(),o=s.pop()}return l[0]}function d(e,t){return[e].concat(t)}n=void 0!==n?n:{};var f,p={},g={Contact:119,Name_Addr_Header:156,Record_Route:176,Request_Response:81,SIP_URI:45,Subscription_State:186,Supported:191,Require:182,Via:194,absoluteURI:84,Call_ID:118,Content_Disposition:130,Content_Length:135,Content_Type:136,CSeq:146,displayName:122,Event:149,From:151,host:52,Max_Forwards:154,Min_SE:213,Proxy_Authenticate:157,quoted_string:40,Refer_To:178,Replaces:179,Session_Expires:210,stun_URI:217,To:192,turn_URI:223,uuid:226,WWW_Authenticate:209,challenge:158,sipfrag:230,Referred_By:231},m=119,v=["\r\n",o("\r\n",!1),/^[0-9]/,s([["0","9"]],!1,!1),/^[a-zA-Z]/,s([["a","z"],["A","Z"]],!1,!1),/^[0-9a-fA-F]/,s([["0","9"],["a","f"],["A","F"]],!1,!1),/^[\0-\xFF]/,s([["\0","ÿ"]],!1,!1),/^["]/,s(['"'],!1,!1)," ",o(" ",!1),"\t",o("\t",!1),/^[a-zA-Z0-9]/,s([["a","z"],["A","Z"],["0","9"]],!1,!1),";",o(";",!1),"/",o("/",!1),"?",o("?",!1),":",o(":",!1),"@",o("@",!1),"&",o("&",!1),"=",o("=",!1),"+",o("+",!1),"$",o("$",!1),",",o(",",!1),"-",o("-",!1),"_",o("_",!1),".",o(".",!1),"!",o("!",!1),"~",o("~",!1),"*",o("*",!1),"'",o("'",!1),"(",o("(",!1),")",o(")",!1),"%",o("%",!1),function(){return" "},function(){return":"},/^[!-~]/,s([["!","~"]],!1,!1),/^[\x80-\uFFFF]/,s([["","￿"]],!1,!1),/^[\x80-\xBF]/,s([["","¿"]],!1,!1),/^[a-f]/,s([["a","f"]],!1,!1),"`",o("`",!1),"<",o("<",!1),">",o(">",!1),"\\",o("\\",!1),"[",o("[",!1),"]",o("]",!1),"{",o("{",!1),"}",o("}",!1),function(){return"*"},function(){return"/"},function(){return"="},function(){return"("},function(){return")"},function(){return">"},function(){return"<"},function(){return","},function(){return";"},function(){return":"},function(){return'"'},/^[!-']/,s([["!","'"]],!1,!1),/^[*-[]/,s([["*","["]],!1,!1),/^[\]-~]/,s([["]","~"]],!1,!1),function(e){return e},/^[#-[]/,s([["#","["]],!1,!1),/^[\0-\t]/,s([["\0","\t"]],!1,!1),/^[\x0B-\f]/,s([["\v","\f"]],!1,!1),/^[\x0E-\x7F]/,s([["",""]],!1,!1),function(){n.data.uri=new n.SIP.URI(n.data.scheme,n.data.user,n.data.host,n.data.port),delete n.data.scheme,delete n.data.user,delete n.data.host,delete n.data.host_type,delete n.data.port},function(){n.data.uri=new n.SIP.URI(n.data.scheme,n.data.user,n.data.host,n.data.port,n.data.uri_params,n.data.uri_headers),delete n.data.scheme,delete n.data.user,delete n.data.host,delete n.data.host_type,delete n.data.port,delete n.data.uri_params,"SIP_URI"===n.startRule&&(n.data=n.data.uri)},"sips",o("sips",!0),"sip",o("sip",!0),function(e){n.data.scheme=e},function(){n.data.user=decodeURIComponent(r().slice(0,-1))},function(){n.data.password=r()},function(){return n.data.host=r(),n.data.host},function(){return n.data.host_type="domain",r()},/^[a-zA-Z0-9_\-]/,s([["a","z"],["A","Z"],["0","9"],"_","-"],!1,!1),/^[a-zA-Z0-9\-]/,s([["a","z"],["A","Z"],["0","9"],"-"],!1,!1),function(){return n.data.host_type="IPv6",r()},"::",o("::",!1),function(){return n.data.host_type="IPv6",r()},function(){return n.data.host_type="IPv4",r()},"25",o("25",!1),/^[0-5]/,s([["0","5"]],!1,!1),"2",o("2",!1),/^[0-4]/,s([["0","4"]],!1,!1),"1",o("1",!1),/^[1-9]/,s([["1","9"]],!1,!1),function(e){return e=parseInt(e.join("")),n.data.port=e,e},"transport=",o("transport=",!0),"udp",o("udp",!0),"tcp",o("tcp",!0),"sctp",o("sctp",!0),"tls",o("tls",!0),function(e){n.data.uri_params||(n.data.uri_params={}),n.data.uri_params.transport=e.toLowerCase()},"user=",o("user=",!0),"phone",o("phone",!0),"ip",o("ip",!0),function(e){n.data.uri_params||(n.data.uri_params={}),n.data.uri_params.user=e.toLowerCase()},"method=",o("method=",!0),function(e){n.data.uri_params||(n.data.uri_params={}),n.data.uri_params.method=e},"ttl=",o("ttl=",!0),function(e){n.data.params||(n.data.params={}),n.data.params.ttl=e},"maddr=",o("maddr=",!0),function(e){n.data.uri_params||(n.data.uri_params={}),n.data.uri_params.maddr=e},"lr",o("lr",!0),function(){n.data.uri_params||(n.data.uri_params={}),n.data.uri_params.lr=void 0},function(e,t){n.data.uri_params||(n.data.uri_params={}),t=null===t?void 0:t[1],n.data.uri_params[e.toLowerCase()]=t},function(e,t){e=e.join("").toLowerCase(),t=t.join(""),n.data.uri_headers||(n.data.uri_headers={}),n.data.uri_headers[e]?n.data.uri_headers[e].push(t):n.data.uri_headers[e]=[t]},function(){"Refer_To"===n.startRule&&(n.data.uri=new n.SIP.URI(n.data.scheme,n.data.user,n.data.host,n.data.port,n.data.uri_params,n.data.uri_headers),delete n.data.scheme,delete n.data.user,delete n.data.host,delete n.data.host_type,delete n.data.port,delete n.data.uri_params)},"//",o("//",!1),function(){n.data.scheme=r()},o("SIP",!0),function(){n.data.sip_version=r()},"INVITE",o("INVITE",!1),"ACK",o("ACK",!1),"VXACH",o("VXACH",!1),"OPTIONS",o("OPTIONS",!1),"BYE",o("BYE",!1),"CANCEL",o("CANCEL",!1),"REGISTER",o("REGISTER",!1),"SUBSCRIBE",o("SUBSCRIBE",!1),"NOTIFY",o("NOTIFY",!1),"REFER",o("REFER",!1),"PUBLISH",o("PUBLISH",!1),function(){return n.data.method=r(),n.data.method},function(e){n.data.status_code=parseInt(e.join(""))},function(){n.data.reason_phrase=r()},function(){n.data=r()},function(){var e,t;for(t=n.data.multi_header.length,e=0;e<t;e++)if(null===n.data.multi_header[e].parsed){n.data=null;break}null!==n.data?n.data=n.data.multi_header:n.data=-1},function(){var e;n.data.multi_header||(n.data.multi_header=[]);try{e=new n.SIP.NameAddrHeader(n.data.uri,n.data.displayName,n.data.params),delete n.data.uri,delete n.data.displayName,delete n.data.params}catch(t){e=null}n.data.multi_header.push({position:y,offset:i().start.offset,parsed:e})},function(e){e=r().trim(),'"'===e[0]&&(e=e.substring(1,e.length-1)),n.data.displayName=e},"q",o("q",!0),function(e){n.data.params||(n.data.params={}),n.data.params.q=e},"expires",o("expires",!0),function(e){n.data.params||(n.data.params={}),n.data.params.expires=e},function(e){return parseInt(e.join(""))},"0",o("0",!1),function(){return parseFloat(r())},function(e,t){n.data.params||(n.data.params={}),t=null===t?void 0:t[1],n.data.params[e.toLowerCase()]=t},"render",o("render",!0),"session",o("session",!0),"icon",o("icon",!0),"alert",o("alert",!0),function(){"Content_Disposition"===n.startRule&&(n.data.type=r().toLowerCase())},"handling",o("handling",!0),"optional",o("optional",!0),"required",o("required",!0),function(e){n.data=parseInt(e.join(""))},function(){n.data=r()},"text",o("text",!0),"image",o("image",!0),"audio",o("audio",!0),"video",o("video",!0),"application",o("application",!0),"message",o("message",!0),"multipart",o("multipart",!0),"x-",o("x-",!0),function(e){n.data.value=parseInt(e.join(""))},function(e){n.data=e},function(e){n.data.event=e.toLowerCase()},function(){var e=n.data.tag;n.data=new n.SIP.NameAddrHeader(n.data.uri,n.data.displayName,n.data.params),e&&n.data.setParam("tag",e)},"tag",o("tag",!0),function(e){n.data.tag=e},function(e){n.data=parseInt(e.join(""))},function(e){n.data=e},function(){n.data=new n.SIP.NameAddrHeader(n.data.uri,n.data.displayName,n.data.params)},"digest",o("Digest",!0),"realm",o("realm",!0),function(e){n.data.realm=e},"domain",o("domain",!0),"nonce",o("nonce",!0),function(e){n.data.nonce=e},"opaque",o("opaque",!0),function(e){n.data.opaque=e},"stale",o("stale",!0),"true",o("true",!0),function(){n.data.stale=!0},"false",o("false",!0),function(){n.data.stale=!1},"algorithm",o("algorithm",!0),"md5",o("MD5",!0),"md5-sess",o("MD5-sess",!0),function(e){n.data.algorithm=e.toUpperCase()},"qop",o("qop",!0),"auth-int",o("auth-int",!0),"auth",o("auth",!0),function(e){n.data.qop||(n.data.qop=[]),n.data.qop.push(e.toLowerCase())},function(e){n.data.value=parseInt(e.join(""))},function(){var e,t;for(t=n.data.multi_header.length,e=0;e<t;e++)if(null===n.data.multi_header[e].parsed){n.data=null;break}null!==n.data?n.data=n.data.multi_header:n.data=-1},function(){var e;n.data.multi_header||(n.data.multi_header=[]);try{e=new n.SIP.NameAddrHeader(n.data.uri,n.data.displayName,n.data.params),delete n.data.uri,delete n.data.displayName,delete n.data.params}catch(t){e=null}n.data.multi_header.push({position:y,offset:i().start.offset,parsed:e})},function(){n.data=new n.SIP.NameAddrHeader(n.data.uri,n.data.displayName,n.data.params)},function(){n.data.replaces_from_tag&&n.data.replaces_to_tag||(n.data=-1)},function(){n.data={call_id:n.data}},"from-tag",o("from-tag",!0),function(e){n.data.replaces_from_tag=e},"to-tag",o("to-tag",!0),function(e){n.data.replaces_to_tag=e},"early-only",o("early-only",!0),function(){n.data.early_only=!0},function(e,t){return t},function(e,t){return d(e,t)},function(e){"Require"===n.startRule&&(n.data=e||[])},function(e){n.data.value=parseInt(e.join(""))},"active",o("active",!0),"pending",o("pending",!0),"terminated",o("terminated",!0),function(){n.data.state=r()},"reason",o("reason",!0),function(e){void 0!==e&&(n.data.reason=e)},function(e){void 0!==e&&(n.data.expires=e)},"retry_after",o("retry_after",!0),function(e){void 0!==e&&(n.data.retry_after=e)},"deactivated",o("deactivated",!0),"probation",o("probation",!0),"rejected",o("rejected",!0),"timeout",o("timeout",!0),"giveup",o("giveup",!0),"noresource",o("noresource",!0),"invariant",o("invariant",!0),function(e){"Supported"===n.startRule&&(n.data=e||[])},function(){var e=n.data.tag;n.data=new n.SIP.NameAddrHeader(n.data.uri,n.data.displayName,n.data.params),e&&n.data.setParam("tag",e)},"ttl",o("ttl",!0),function(e){n.data.ttl=e},"maddr",o("maddr",!0),function(e){n.data.maddr=e},"received",o("received",!0),function(e){n.data.received=e},"branch",o("branch",!0),function(e){n.data.branch=e},"rport",o("rport",!0),function(){"undefined"!=typeof response_port&&(n.data.rport=response_port.join(""))},function(e){n.data.protocol=e},o("UDP",!0),o("TCP",!0),o("TLS",!0),o("SCTP",!0),function(e){n.data.transport=e},function(){n.data.host=r()},function(e){n.data.port=parseInt(e.join(""))},function(e){return parseInt(e.join(""))},function(e){"Session_Expires"===n.startRule&&(n.data.deltaSeconds=e)},"refresher",o("refresher",!1),"uas",o("uas",!1),"uac",o("uac",!1),function(e){"Session_Expires"===n.startRule&&(n.data.refresher=e)},function(e){"Min_SE"===n.startRule&&(n.data=e)},"stuns",o("stuns",!0),"stun",o("stun",!0),function(e){n.data.scheme=e},function(e){n.data.host=e},"?transport=",o("?transport=",!1),"turns",o("turns",!0),"turn",o("turn",!0),function(){n.data.transport=transport},function(){n.data=r()},"Referred-By",o("Referred-By",!1),"b",o("b",!1),"cid",o("cid",!1)],T=[l('2 ""6 7!'),l('4"""5!7#'),l('4$""5!7%'),l('4&""5!7\''),l(";'.# &;("),l('4(""5!7)'),l('4*""5!7+'),l('2,""6,7-'),l('2.""6.7/'),l('40""5!71'),l('22""6273. &24""6475.} &26""6677.q &28""6879.e &2:""6:7;.Y &2<""6<7=.M &2>""6>7?.A &2@""6@7A.5 &2B""6B7C.) &2D""6D7E'),l(";).# &;,"),l('2F""6F7G.} &2H""6H7I.q &2J""6J7K.e &2L""6L7M.Y &2N""6N7O.M &2P""6P7Q.A &2R""6R7S.5 &2T""6T7U.) &2V""6V7W'),l('%%2X""6X7Y/5#;#/,$;#/#$+#)(#\'#("\'#&\'#/"!&,)'),l('%%$;$0#*;$&/,#; /#$+")("\'#&\'#." &"/=#$;$/&#0#*;$&&&#/\'$8":Z" )("\'#&\'#'),l(';.." &"'),l("%$;'.# &;(0)*;'.# &;(&/?#28\"\"6879/0$;//'$8#:[# )(#'#(\"'#&'#"),l('%%$;2/&#0#*;2&&&#/g#$%$;.0#*;.&/,#;2/#$+")("\'#&\'#0=*%$;.0#*;.&/,#;2/#$+")("\'#&\'#&/#$+")("\'#&\'#/"!&,)'),l('4\\""5!7].# &;3'),l('4^""5!7_'),l('4`""5!7a'),l(';!.) &4b""5!7c'),l('%$;). &2F""6F7G. &2J""6J7K.} &2L""6L7M.q &2X""6X7Y.e &2P""6P7Q.Y &2H""6H7I.M &2@""6@7A.A &2d""6d7e.5 &2R""6R7S.) &2N""6N7O/#0*;). &2F""6F7G. &2J""6J7K.} &2L""6L7M.q &2X""6X7Y.e &2P""6P7Q.Y &2H""6H7I.M &2@""6@7A.A &2d""6d7e.5 &2R""6R7S.) &2N""6N7O&&&#/"!&,)'),l('%$;). &2F""6F7G.} &2L""6L7M.q &2X""6X7Y.e &2P""6P7Q.Y &2H""6H7I.M &2@""6@7A.A &2d""6d7e.5 &2R""6R7S.) &2N""6N7O/#0*;). &2F""6F7G.} &2L""6L7M.q &2X""6X7Y.e &2P""6P7Q.Y &2H""6H7I.M &2@""6@7A.A &2d""6d7e.5 &2R""6R7S.) &2N""6N7O&&&#/"!&,)'),l('2T""6T7U.ã &2V""6V7W.× &2f""6f7g.Ë &2h""6h7i.¿ &2:""6:7;.³ &2D""6D7E.§ &22""6273. &28""6879. &2j""6j7k. &;&.} &24""6475.q &2l""6l7m.e &2n""6n7o.Y &26""6677.M &2>""6>7?.A &2p""6p7q.5 &2r""6r7s.) &;\'.# &;('),l('%$;).ī &2F""6F7G.ğ &2J""6J7K.ē &2L""6L7M.ć &2X""6X7Y.û &2P""6P7Q.ï &2H""6H7I.ã &2@""6@7A.× &2d""6d7e.Ë &2R""6R7S.¿ &2N""6N7O.³ &2T""6T7U.§ &2V""6V7W. &2f""6f7g. &2h""6h7i. &28""6879.w &2j""6j7k.k &;&.e &24""6475.Y &2l""6l7m.M &2n""6n7o.A &26""6677.5 &2p""6p7q.) &2r""6r7s/Ĵ#0ı*;).ī &2F""6F7G.ğ &2J""6J7K.ē &2L""6L7M.ć &2X""6X7Y.û &2P""6P7Q.ï &2H""6H7I.ã &2@""6@7A.× &2d""6d7e.Ë &2R""6R7S.¿ &2N""6N7O.³ &2T""6T7U.§ &2V""6V7W. &2f""6f7g. &2h""6h7i. &28""6879.w &2j""6j7k.k &;&.e &24""6475.Y &2l""6l7m.M &2n""6n7o.A &26""6677.5 &2p""6p7q.) &2r""6r7s&&&#/"!&,)'),l("%;//?#2P\"\"6P7Q/0$;//'$8#:t# )(#'#(\"'#&'#"),l("%;//?#24\"\"6475/0$;//'$8#:u# )(#'#(\"'#&'#"),l("%;//?#2>\"\"6>7?/0$;//'$8#:v# )(#'#(\"'#&'#"),l("%;//?#2T\"\"6T7U/0$;//'$8#:w# )(#'#(\"'#&'#"),l("%;//?#2V\"\"6V7W/0$;//'$8#:x# )(#'#(\"'#&'#"),l('%2h""6h7i/0#;//\'$8":y" )("\'#&\'#'),l('%;//6#2f""6f7g/\'$8":z" )("\'#&\'#'),l("%;//?#2D\"\"6D7E/0$;//'$8#:{# )(#'#(\"'#&'#"),l("%;//?#22\"\"6273/0$;//'$8#:|# )(#'#(\"'#&'#"),l("%;//?#28\"\"6879/0$;//'$8#:}# )(#'#(\"'#&'#"),l("%;//0#;&/'$8\":~\" )(\"'#&'#"),l("%;&/0#;//'$8\":~\" )(\"'#&'#"),l("%;=/T#$;G.) &;K.# &;F0/*;G.) &;K.# &;F&/,$;>/#$+#)(#'#(\"'#&'#"),l('4""5!7.A &4""5!7.5 &4""5!7.) &;3.# &;.'),l("%%;//Q#;&/H$$;J.# &;K0)*;J.# &;K&/,$;&/#$+$)($'#(#'#(\"'#&'#/\"!&,)"),l("%;//]#;&/T$%$;J.# &;K0)*;J.# &;K&/\"!&,)/1$;&/($8$:$!!)($'#(#'#(\"'#&'#"),l(';..G &2L""6L7M.; &4""5!7./ &4""5!7.# &;3'),l('%2j""6j7k/J#4""5!7.5 &4""5!7.) &4""5!7/#$+")("\'#&\'#'),l("%;N/M#28\"\"6879/>$;O.\" &\"/0$;S/'$8$:$ )($'#(#'#(\"'#&'#"),l("%;N/d#28\"\"6879/U$;O.\" &\"/G$;S/>$;_/5$;l.\" &\"/'$8&:& )(&'#(%'#($'#(#'#(\"'#&'#"),l('%3""5$7.) &3""5#7/\' 8!:!! )'),l('%;P/]#%28""6879/,#;R/#$+")("\'#&\'#." &"/6$2:""6:7;/\'$8#:# )(#\'#("\'#&\'#'),l("$;+.) &;-.# &;Q/2#0/*;+.) &;-.# &;Q&&&#"),l('2<""6<7=.q &2>""6>7?.e &2@""6@7A.Y &2B""6B7C.M &2D""6D7E.A &22""6273.5 &26""6677.) &24""6475'),l('%$;+._ &;-.Y &2<""6<7=.M &2>""6>7?.A &2@""6@7A.5 &2B""6B7C.) &2D""6D7E0e*;+._ &;-.Y &2<""6<7=.M &2>""6>7?.A &2@""6@7A.5 &2B""6B7C.) &2D""6D7E&/& 8!:! )'),l('%;T/J#%28""6879/,#;^/#$+")("\'#&\'#." &"/#$+")("\'#&\'#'),l("%;U.) &;\\.# &;X/& 8!:! )"),l('%$%;V/2#2J""6J7K/#$+")("\'#&\'#0<*%;V/2#2J""6J7K/#$+")("\'#&\'#&/D#;W/;$2J""6J7K." &"/\'$8#:# )(#\'#("\'#&\'#'),l('$4""5!7/,#0)*4""5!7&&&#'),l('%4$""5!7%/?#$4""5!70)*4""5!7&/#$+")("\'#&\'#'),l('%2l""6l7m/?#;Y/6$2n""6n7o/\'$8#:# )(#\'#("\'#&\'#'),l('%%;Z/³#28""6879/¤$;Z/$28""6879/$;Z/$28""6879/t$;Z/k$28""6879/\\$;Z/S$28""6879/D$;Z/;$28""6879/,$;[/#$+-)(-\'#(,\'#(+\'#(*\'#()\'#((\'#(\'\'#(&\'#(%\'#($\'#(#\'#("\'#&\'#.ސ &%2""67/¤#;Z/$28""6879/$;Z/$28""6879/t$;Z/k$28""6879/\\$;Z/S$28""6879/D$;Z/;$28""6879/,$;[/#$+,)(,\'#(+\'#(*\'#()\'#((\'#(\'\'#(&\'#(%\'#($\'#(#\'#("\'#&\'#.۹ &%2""67/#;Z/$28""6879/t$;Z/k$28""6879/\\$;Z/S$28""6879/D$;Z/;$28""6879/,$;[/#$+*)(*\'#()\'#((\'#(\'\'#(&\'#(%\'#($\'#(#\'#("\'#&\'#.ٺ &%2""67/t#;Z/k$28""6879/\\$;Z/S$28""6879/D$;Z/;$28""6879/,$;[/#$+()((\'#(\'\'#(&\'#(%\'#($\'#(#\'#("\'#&\'#.ؓ &%2""67/\\#;Z/S$28""6879/D$;Z/;$28""6879/,$;[/#$+&)(&\'#(%\'#($\'#(#\'#("\'#&\'#.ׄ &%2""67/D#;Z/;$28""6879/,$;[/#$+$)($\'#(#\'#("\'#&\'#.֍ &%2""67/,#;[/#$+")("\'#&\'#.ծ &%2""67/,#;Z/#$+")("\'#&\'#.Տ &%;Z/#2""67/$;Z/$28""6879/t$;Z/k$28""6879/\\$;Z/S$28""6879/D$;Z/;$28""6879/,$;[/#$++)(+\'#(*\'#()\'#((\'#(\'\'#(&\'#(%\'#($\'#(#\'#("\'#&\'#.Ӈ &%;Z/ª#%28""6879/,#;Z/#$+")("\'#&\'#." &"/$2""67/t$;Z/k$28""6879/\\$;Z/S$28""6879/D$;Z/;$28""6879/,$;[/#$+*)(*\'#()\'#((\'#(\'\'#(&\'#(%\'#($\'#(#\'#("\'#&\'#.а &%;Z/¹#%28""6879/,#;Z/#$+")("\'#&\'#." &"/$%28""6879/,#;Z/#$+")("\'#&\'#." &"/k$2""67/\\$;Z/S$28""6879/D$;Z/;$28""6879/,$;[/#$+))()\'#((\'#(\'\'#(&\'#(%\'#($\'#(#\'#("\'#&\'#.Ί &%;Z/È#%28""6879/,#;Z/#$+")("\'#&\'#." &"/¡$%28""6879/,#;Z/#$+")("\'#&\'#." &"/z$%28""6879/,#;Z/#$+")("\'#&\'#." &"/S$2""67/D$;Z/;$28""6879/,$;[/#$+()((\'#(\'\'#(&\'#(%\'#($\'#(#\'#("\'#&\'#.˕ &%;Z/×#%28""6879/,#;Z/#$+")("\'#&\'#." &"/°$%28""6879/,#;Z/#$+")("\'#&\'#." &"/$%28""6879/,#;Z/#$+")("\'#&\'#." &"/b$%28""6879/,#;Z/#$+")("\'#&\'#." &"/;$2""67/,$;[/#$+\')(\'\'#(&\'#(%\'#($\'#(#\'#("\'#&\'#.ȑ &%;Z/þ#%28""6879/,#;Z/#$+")("\'#&\'#." &"/×$%28""6879/,#;Z/#$+")("\'#&\'#." &"/°$%28""6879/,#;Z/#$+")("\'#&\'#." &"/$%28""6879/,#;Z/#$+")("\'#&\'#." &"/b$%28""6879/,#;Z/#$+")("\'#&\'#." &"/;$2""67/,$;Z/#$+()((\'#(\'\'#(&\'#(%\'#($\'#(#\'#("\'#&\'#.Ħ &%;Z/Ĝ#%28""6879/,#;Z/#$+")("\'#&\'#." &"/õ$%28""6879/,#;Z/#$+")("\'#&\'#." &"/Î$%28""6879/,#;Z/#$+")("\'#&\'#." &"/§$%28""6879/,#;Z/#$+")("\'#&\'#." &"/$%28""6879/,#;Z/#$+")("\'#&\'#." &"/Y$%28""6879/,#;Z/#$+")("\'#&\'#." &"/2$2""67/#$+()((\'#(\'\'#(&\'#(%\'#($\'#(#\'#("\'#&\'#/& 8!: ! )'),l('%;#/M#;#." &"/?$;#." &"/1$;#." &"/#$+$)($\'#(#\'#("\'#&\'#'),l("%;Z/;#28\"\"6879/,$;Z/#$+#)(#'#(\"'#&'#.# &;\\"),l("%;]/o#2J\"\"6J7K/`$;]/W$2J\"\"6J7K/H$;]/?$2J\"\"6J7K/0$;]/'$8':¡' )(''#(&'#(%'#($'#(#'#(\"'#&'#"),l('%2¢""6¢7£/2#4¤""5!7¥/#$+")("\'#&\'#. &%2¦""6¦7§/;#4¨""5!7©/,$;!/#$+#)(#\'#("\'#&\'#.j &%2ª""6ª7«/5#;!/,$;!/#$+#)(#\'#("\'#&\'#.B &%4¬""5!7­/,#;!/#$+")("\'#&\'#.# &;!'),l('%%;!." &"/[#;!." &"/M$;!." &"/?$;!." &"/1$;!." &"/#$+%)(%\'#($\'#(#\'#("\'#&\'#/\' 8!:®!! )'),l('$%22""6273/,#;`/#$+")("\'#&\'#0<*%22""6273/,#;`/#$+")("\'#&\'#&'),l(";a.A &;b.; &;c.5 &;d./ &;e.) &;f.# &;g"),l('%3¯""5*7°/a#3±""5#7².G &3³""5#7´.; &3µ""5$7¶./ &3·""5#7¸.# &;6/($8":¹"! )("\'#&\'#'),l('%3º""5%7»/I#3¼""5%7½./ &3¾""5"7¿.# &;6/($8":À"! )("\'#&\'#'),l('%3Á""5\'7Â/1#;/($8":Ã"! )("\'#&\'#'),l('%3Ä""5$7Å/1#;ð/($8":Æ"! )("\'#&\'#'),l('%3Ç""5&7È/1#;T/($8":É"! )("\'#&\'#'),l('%3Ê""5"7Ë/N#%2>""6>7?/,#;6/#$+")("\'#&\'#." &"/\'$8":Ì" )("\'#&\'#'),l('%;h/P#%2>""6>7?/,#;i/#$+")("\'#&\'#." &"/)$8":Í""! )("\'#&\'#'),l('%$;j/&#0#*;j&&&#/"!&,)'),l('%$;j/&#0#*;j&&&#/"!&,)'),l(";k.) &;+.# &;-"),l('2l""6l7m.e &2n""6n7o.Y &24""6475.M &28""6879.A &2<""6<7=.5 &2@""6@7A.) &2B""6B7C'),l('%26""6677/n#;m/e$$%2<""6<7=/,#;m/#$+")("\'#&\'#0<*%2<""6<7=/,#;m/#$+")("\'#&\'#&/#$+#)(#\'#("\'#&\'#'),l('%;n/A#2>""6>7?/2$;o/)$8#:Î#"" )(#\'#("\'#&\'#'),l("$;p.) &;+.# &;-/2#0/*;p.) &;+.# &;-&&&#"),l("$;p.) &;+.# &;-0/*;p.) &;+.# &;-&"),l('2l""6l7m.e &2n""6n7o.Y &24""6475.M &26""6677.A &28""6879.5 &2@""6@7A.) &2B""6B7C'),l(";.# &;r"),l("%;/G#;'/>$;s/5$;'/,$;/#$+%)(%'#($'#(#'#(\"'#&'#"),l(";M.# &;t"),l("%;/E#28\"\"6879/6$;u.# &;x/'$8#:Ï# )(#'#(\"'#&'#"),l('%;v.# &;w/J#%26""6677/,#;/#$+")("\'#&\'#." &"/#$+")("\'#&\'#'),l('%2Ð""6Ð7Ñ/:#;/1$;w." &"/#$+#)(#\'#("\'#&\'#'),l('%24""6475/,#;{/#$+")("\'#&\'#'),l("%;z/3#$;y0#*;y&/#$+\")(\"'#&'#"),l(";*.) &;+.# &;-"),l(';+. &;-. &22""6273.} &26""6677.q &28""6879.e &2:""6:7;.Y &2<""6<7=.M &2>""6>7?.A &2@""6@7A.5 &2B""6B7C.) &2D""6D7E'),l('%;|/e#$%24""6475/,#;|/#$+")("\'#&\'#0<*%24""6475/,#;|/#$+")("\'#&\'#&/#$+")("\'#&\'#'),l('%$;~0#*;~&/e#$%22""6273/,#;}/#$+")("\'#&\'#0<*%22""6273/,#;}/#$+")("\'#&\'#&/#$+")("\'#&\'#'),l("$;~0#*;~&"),l(';+.w &;-.q &28""6879.e &2:""6:7;.Y &2<""6<7=.M &2>""6>7?.A &2@""6@7A.5 &2B""6B7C.) &2D""6D7E'),l('%%;"/#$;".G &;!.A &2@""6@7A.5 &2F""6F7G.) &2J""6J7K0M*;".G &;!.A &2@""6@7A.5 &2F""6F7G.) &2J""6J7K&/#$+")("\'#&\'#/& 8!:Ò! )'),l(";.# &;"),l('%%;O/2#2:""6:7;/#$+")("\'#&\'#." &"/,#;S/#$+")("\'#&\'#." &"'),l('$;+. &;-.} &2B""6B7C.q &2D""6D7E.e &22""6273.Y &28""6879.M &2:""6:7;.A &2<""6<7=.5 &2>""6>7?.) &2@""6@7A/#0*;+. &;-.} &2B""6B7C.q &2D""6D7E.e &22""6273.Y &28""6879.M &2:""6:7;.A &2<""6<7=.5 &2>""6>7?.) &2@""6@7A&&&#'),l("$;y0#*;y&"),l('%3""5#7Ó/q#24""6475/b$$;!/&#0#*;!&&&#/L$2J""6J7K/=$$;!/&#0#*;!&&&#/\'$8%:Ô% )(%\'#($\'#(#\'#("\'#&\'#'),l('2Õ""6Õ7Ö'),l('2×""6×7Ø'),l('2Ù""6Ù7Ú'),l('2Û""6Û7Ü'),l('2Ý""6Ý7Þ'),l('2ß""6ß7à'),l('2á""6á7â'),l('2ã""6ã7ä'),l('2å""6å7æ'),l('2ç""6ç7è'),l('2é""6é7ê'),l("%;.Y &;.S &;.M &;.G &;.A &;.; &;.5 &;./ &;.) &;.# &;6/& 8!:ë! )"),l("%;/G#;'/>$;/5$;'/,$;/#$+%)(%'#($'#(#'#(\"'#&'#"),l("%;/' 8!:ì!! )"),l("%;!/5#;!/,$;!/#$+#)(#'#(\"'#&'#"),l("%$;*.A &;+.; &;-.5 &;3./ &;4.) &;'.# &;(0G*;*.A &;+.; &;-.5 &;3./ &;4.) &;'.# &;(&/& 8!:í! )"),l("%;¶/Y#$%;A/,#;¶/#$+\")(\"'#&'#06*%;A/,#;¶/#$+\")(\"'#&'#&/#$+\")(\"'#&'#"),l('%;9/N#%2:""6:7;/,#;9/#$+")("\'#&\'#." &"/\'$8":î" )("\'#&\'#'),l("%;:.c &%;/Y#$%;A/,#;/#$+\")(\"'#&'#06*%;A/,#;/#$+\")(\"'#&'#&/#$+\")(\"'#&'#/& 8!:ï! )"),l("%;L.# &;/]#$%;B/,#;/#$+\")(\"'#&'#06*%;B/,#;/#$+\")(\"'#&'#&/'$8\":ð\" )(\"'#&'#"),l("%;.\" &\"/>#;@/5$;M/,$;?/#$+$)($'#(#'#(\"'#&'#"),l("%%;6/Y#$%;./,#;6/#$+\")(\"'#&'#06*%;./,#;6/#$+\")(\"'#&'#&/#$+\")(\"'#&'#.# &;H/' 8!:ñ!! )"),l(";.) &;.# &; "),l("%3ò\"\"5!7ó/:#;</1$;/($8#:ô#! )(#'#(\"'#&'#"),l("%3õ\"\"5'7ö/:#;</1$;/($8#:÷#! )(#'#(\"'#&'#"),l("%$;!/&#0#*;!&&&#/' 8!:ø!! )"),l('%2ù""6ù7ú/o#%2J""6J7K/M#;!." &"/?$;!." &"/1$;!." &"/#$+$)($\'#(#\'#("\'#&\'#." &"/\'$8":û" )("\'#&\'#'),l('%;6/J#%;</,#;¡/#$+")("\'#&\'#." &"/)$8":ü""! )("\'#&\'#'),l(";6.) &;T.# &;H"),l("%;£/Y#$%;B/,#;¤/#$+\")(\"'#&'#06*%;B/,#;¤/#$+\")(\"'#&'#&/#$+\")(\"'#&'#"),l('%3ý""5&7þ.G &3ÿ""5\'7Ā.; &3ā""5$7Ă./ &3ă""5%7Ą.# &;6/& 8!:ą! )'),l(";¥.# &; "),l('%3Ć""5(7ć/M#;</D$3Ĉ""5(7ĉ./ &3Ċ""5(7ċ.# &;6/#$+#)(#\'#("\'#&\'#'),l("%;6/Y#$%;A/,#;6/#$+\")(\"'#&'#06*%;A/,#;6/#$+\")(\"'#&'#&/#$+\")(\"'#&'#"),l("%$;!/&#0#*;!&&&#/' 8!:Č!! )"),l("%;©/& 8!:č! )"),l("%;ª/k#;;/b$;¯/Y$$%;B/,#;°/#$+\")(\"'#&'#06*%;B/,#;°/#$+\")(\"'#&'#&/#$+$)($'#(#'#(\"'#&'#"),l(";«.# &;¬"),l('3Ď""5$7ď.S &3Đ""5%7đ.G &3Ē""5%7ē.; &3Ĕ""5%7ĕ./ &3Ė""5+7ė.# &;­'),l('3Ę""5\'7ę./ &3Ě""5)7ě.# &;­'),l(";6.# &;®"),l('%3Ĝ""5"7ĝ/,#;6/#$+")("\'#&\'#'),l(";­.# &;6"),l("%;6/5#;</,$;±/#$+#)(#'#(\"'#&'#"),l(";6.# &;H"),l("%;³/5#;./,$;/#$+#)(#'#(\"'#&'#"),l("%$;!/&#0#*;!&&&#/' 8!:Ğ!! )"),l("%;/' 8!:ğ!! )"),l('%;¶/^#$%;B/,#; /#$+")("\'#&\'#06*%;B/,#; /#$+")("\'#&\'#&/($8":Ġ"!!)("\'#&\'#'),l('%%;7/e#$%2J""6J7K/,#;7/#$+")("\'#&\'#0<*%2J""6J7K/,#;7/#$+")("\'#&\'#&/#$+")("\'#&\'#/"!&,)'),l("%;L.# &;/]#$%;B/,#;¸/#$+\")(\"'#&'#06*%;B/,#;¸/#$+\")(\"'#&'#&/'$8\":ġ\" )(\"'#&'#"),l(";¹.# &; "),l("%3Ģ\"\"5#7ģ/:#;</1$;6/($8#:Ĥ#! )(#'#(\"'#&'#"),l("%$;!/&#0#*;!&&&#/' 8!:ĥ!! )"),l("%;/' 8!:Ħ!! )"),l("%$;0#*;&/x#;@/o$;M/f$;?/]$$%;B/,#; /#$+\")(\"'#&'#06*%;B/,#; /#$+\")(\"'#&'#&/'$8%:ħ% )(%'#($'#(#'#(\"'#&'#"),l(";¾"),l("%3Ĩ\"\"5&7ĩ/k#;./b$;Á/Y$$%;A/,#;Á/#$+\")(\"'#&'#06*%;A/,#;Á/#$+\")(\"'#&'#&/#$+$)($'#(#'#(\"'#&'#.# &;¿"),l("%;6/k#;./b$;À/Y$$%;A/,#;À/#$+\")(\"'#&'#06*%;A/,#;À/#$+\")(\"'#&'#&/#$+$)($'#(#'#(\"'#&'#"),l("%;6/;#;</2$;6.# &;H/#$+#)(#'#(\"'#&'#"),l(";Â.G &;Ä.A &;Æ.; &;È.5 &;É./ &;Ê.) &;Ë.# &;À"),l("%3Ī\"\"5%7ī/5#;</,$;Ã/#$+#)(#'#(\"'#&'#"),l("%;I/' 8!:Ĭ!! )"),l("%3ĭ\"\"5&7Į/#;</$;D/$;Å/|$$%$;'/&#0#*;'&&&#/,#;Å/#$+\")(\"'#&'#0C*%$;'/&#0#*;'&&&#/,#;Å/#$+\")(\"'#&'#&/,$;E/#$+&)(&'#(%'#($'#(#'#(\"'#&'#"),l(";t.# &;w"),l("%3į\"\"5%7İ/5#;</,$;Ç/#$+#)(#'#(\"'#&'#"),l("%;I/' 8!:ı!! )"),l("%3Ĳ\"\"5&7ĳ/:#;</1$;I/($8#:Ĵ#! )(#'#(\"'#&'#"),l('%3ĵ""5%7Ķ/]#;</T$%3ķ""5$7ĸ/& 8!:Ĺ! ).4 &%3ĺ""5%7Ļ/& 8!:ļ! )/#$+#)(#\'#("\'#&\'#'),l('%3Ľ""5)7ľ/R#;</I$3Ŀ""5#7ŀ./ &3Ł""5(7ł.# &;6/($8#:Ń#! )(#\'#("\'#&\'#'),l('%3ń""5#7Ņ/#;</$;D/$%;Ì/e#$%2D""6D7E/,#;Ì/#$+")("\'#&\'#0<*%2D""6D7E/,#;Ì/#$+")("\'#&\'#&/#$+")("\'#&\'#/,$;E/#$+%)(%\'#($\'#(#\'#("\'#&\'#'),l('%3ņ""5(7Ň./ &3ň""5$7ŉ.# &;6/\' 8!:Ŋ!! )'),l("%;6/Y#$%;A/,#;6/#$+\")(\"'#&'#06*%;A/,#;6/#$+\")(\"'#&'#&/#$+\")(\"'#&'#"),l("%;Ï/G#;./>$;Ï/5$;./,$;/#$+%)(%'#($'#(#'#(\"'#&'#"),l("%$;!/&#0#*;!&&&#/' 8!:ŋ!! )"),l("%;Ñ/]#$%;A/,#;Ñ/#$+\")(\"'#&'#06*%;A/,#;Ñ/#$+\")(\"'#&'#&/'$8\":Ō\" )(\"'#&'#"),l("%;/]#$%;B/,#; /#$+\")(\"'#&'#06*%;B/,#; /#$+\")(\"'#&'#&/'$8\":ō\" )(\"'#&'#"),l('%;L.O &;.I &%;@." &"/:#;t/1$;?." &"/#$+#)(#\'#("\'#&\'#/]#$%;B/,#; /#$+")("\'#&\'#06*%;B/,#; /#$+")("\'#&\'#&/\'$8":Ŏ" )("\'#&\'#'),l("%;Ô/]#$%;B/,#;Õ/#$+\")(\"'#&'#06*%;B/,#;Õ/#$+\")(\"'#&'#&/'$8\":ŏ\" )(\"'#&'#"),l("%;/& 8!:Ő! )"),l('%3ő""5(7Œ/:#;</1$;6/($8#:œ#! )(#\'#("\'#&\'#.g &%3Ŕ""5&7ŕ/:#;</1$;6/($8#:Ŗ#! )(#\'#("\'#&\'#.: &%3ŗ""5*7Ř/& 8!:ř! ).# &; '),l('%%;6/k#$%;A/2#;6/)$8":Ś""$ )("\'#&\'#0<*%;A/2#;6/)$8":Ś""$ )("\'#&\'#&/)$8":ś""! )("\'#&\'#." &"/\' 8!:Ŝ!! )'),l("%;Ø/Y#$%;A/,#;Ø/#$+\")(\"'#&'#06*%;A/,#;Ø/#$+\")(\"'#&'#&/#$+\")(\"'#&'#"),l("%;/Y#$%;B/,#; /#$+\")(\"'#&'#06*%;B/,#; /#$+\")(\"'#&'#&/#$+\")(\"'#&'#"),l("%$;!/&#0#*;!&&&#/' 8!:ŝ!! )"),l("%;Û/Y#$%;B/,#;Ü/#$+\")(\"'#&'#06*%;B/,#;Ü/#$+\")(\"'#&'#&/#$+\")(\"'#&'#"),l('%3Ş""5&7ş.; &3Š""5\'7š./ &3Ţ""5*7ţ.# &;6/& 8!:Ť! )'),l("%3ť\"\"5&7Ŧ/:#;</1$;Ý/($8#:ŧ#! )(#'#(\"'#&'#.} &%3õ\"\"5'7ö/:#;</1$;/($8#:Ũ#! )(#'#(\"'#&'#.P &%3ũ\"\"5+7Ū/:#;</1$;/($8#:ū#! )(#'#(\"'#&'#.# &; "),l('3Ŭ""5+7ŭ.k &3Ů""5)7ů._ &3Ű""5(7ű.S &3Ų""5\'7ų.G &3Ŵ""5&7ŵ.; &3Ŷ""5*7ŷ./ &3Ÿ""5)7Ź.# &;6'),l(';1." &"'),l('%%;6/k#$%;A/2#;6/)$8":Ś""$ )("\'#&\'#0<*%;A/2#;6/)$8":Ś""$ )("\'#&\'#&/)$8":ś""! )("\'#&\'#." &"/\' 8!:ź!! )'),l("%;L.# &;/]#$%;B/,#;á/#$+\")(\"'#&'#06*%;B/,#;á/#$+\")(\"'#&'#&/'$8\":Ż\" )(\"'#&'#"),l(";¹.# &; "),l("%;ã/Y#$%;A/,#;ã/#$+\")(\"'#&'#06*%;A/,#;ã/#$+\")(\"'#&'#&/#$+\")(\"'#&'#"),l("%;ê/k#;./b$;í/Y$$%;B/,#;ä/#$+\")(\"'#&'#06*%;B/,#;ä/#$+\")(\"'#&'#&/#$+$)($'#(#'#(\"'#&'#"),l(";å.; &;æ.5 &;ç./ &;è.) &;é.# &; "),l("%3ż\"\"5#7Ž/:#;</1$;ð/($8#:ž#! )(#'#(\"'#&'#"),l("%3ſ\"\"5%7ƀ/:#;</1$;T/($8#:Ɓ#! )(#'#(\"'#&'#"),l("%3Ƃ\"\"5(7ƃ/F#;</=$;\\.) &;Y.# &;X/($8#:Ƅ#! )(#'#(\"'#&'#"),l("%3ƅ\"\"5&7Ɔ/:#;</1$;6/($8#:Ƈ#! )(#'#(\"'#&'#"),l('%3ƈ""5%7Ɖ/O#%;</3#$;!0#*;!&/#$+")("\'#&\'#." &"/\'$8":Ɗ" )("\'#&\'#'),l("%;ë/G#;;/>$;6/5$;;/,$;ì/#$+%)(%'#($'#(#'#(\"'#&'#"),l('%3""5#7Ó.# &;6/\' 8!:Ƌ!! )'),l('%3±""5#7ƌ.G &3³""5#7ƍ.; &3·""5#7Ǝ./ &3µ""5$7Ə.# &;6/\' 8!:Ɛ!! )'),l('%;î/D#%;C/,#;ï/#$+")("\'#&\'#." &"/#$+")("\'#&\'#'),l("%;U.) &;\\.# &;X/& 8!:Ƒ! )"),l('%%;!." &"/[#;!." &"/M$;!." &"/?$;!." &"/1$;!." &"/#$+%)(%\'#($\'#(#\'#("\'#&\'#/\' 8!:ƒ!! )'),l('%%;!/?#;!." &"/1$;!." &"/#$+#)(#\'#("\'#&\'#/\' 8!:Ɠ!! )'),l(";¾"),l('%;/^#$%;B/,#;ó/#$+")("\'#&\'#06*%;B/,#;ó/#$+")("\'#&\'#&/($8":Ɣ"!!)("\'#&\'#'),l(";ô.# &; "),l('%2ƕ""6ƕ7Ɩ/L#;</C$2Ɨ""6Ɨ7Ƙ.) &2ƙ""6ƙ7ƚ/($8#:ƛ#! )(#\'#("\'#&\'#'),l('%;/^#$%;B/,#; /#$+")("\'#&\'#06*%;B/,#; /#$+")("\'#&\'#&/($8":Ɯ"!!)("\'#&\'#'),l("%;6/5#;0/,$;÷/#$+#)(#'#(\"'#&'#"),l("$;2.) &;4.# &;.0/*;2.) &;4.# &;.&"),l("$;%0#*;%&"),l("%;ú/;#28\"\"6879/,$;û/#$+#)(#'#(\"'#&'#"),l('%3Ɲ""5%7ƞ.) &3Ɵ""5$7Ơ/\' 8!:ơ!! )'),l('%;ü/J#%28""6879/,#;^/#$+")("\'#&\'#." &"/#$+")("\'#&\'#'),l("%;\\.) &;X.# &;/' 8!:Ƣ!! )"),l(';".S &;!.M &2F""6F7G.A &2J""6J7K.5 &2H""6H7I.) &2N""6N7O'),l('2L""6L7M. &2B""6B7C. &2<""6<7=.} &2R""6R7S.q &2T""6T7U.e &2V""6V7W.Y &2P""6P7Q.M &2@""6@7A.A &2D""6D7E.5 &22""6273.) &2>""6>7?'),l('%;Ā/b#28""6879/S$;û/J$%2ƣ""6ƣ7Ƥ/,#;ì/#$+")("\'#&\'#." &"/#$+$)($\'#(#\'#("\'#&\'#'),l('%3ƥ""5%7Ʀ.) &3Ƨ""5$7ƨ/\' 8!:ơ!! )'),l('%;ì/O#3±""5#7².6 &3³""5#7´.* &$;+0#*;+&/\'$8":Ʃ" )("\'#&\'#'),l("%;Ą/#2F\"\"6F7G/x$;ă/o$2F\"\"6F7G/`$;ă/W$2F\"\"6F7G/H$;ă/?$2F\"\"6F7G/0$;ą/'$8):ƪ) )()'#(('#(''#(&'#(%'#($'#(#'#(\"'#&'#"),l("%;#/>#;#/5$;#/,$;#/#$+$)($'#(#'#(\"'#&'#"),l("%;ă/,#;ă/#$+\")(\"'#&'#"),l("%;ă/5#;ă/,$;ă/#$+#)(#'#(\"'#&'#"),l("%;q/T#$;m0#*;m&/D$%; /,#;ø/#$+\")(\"'#&'#.\" &\"/#$+#)(#'#(\"'#&'#"),l('%2ƫ""6ƫ7Ƭ.) &2ƭ""6ƭ7Ʈ/w#;0/n$;Ĉ/e$$%;B/2#;ĉ.# &; /#$+")("\'#&\'#0<*%;B/2#;ĉ.# &; /#$+")("\'#&\'#&/#$+$)($\'#(#\'#("\'#&\'#'),l(";.# &;L"),l("%2Ư\"\"6Ư7ư/5#;</,$;Ċ/#$+#)(#'#(\"'#&'#"),l("%;D/S#;,/J$2:\"\"6:7;/;$;,.# &;T/,$;E/#$+%)(%'#($'#(#'#(\"'#&'#")],y=0,_=0,S=[{line:1,column:1}],E=0,C=[],b=0;if("startRule"in n){if(!(n.startRule in g))throw new Error("Can't start parsing from rule \""+n.startRule+'".');m=g[n.startRule]}if(n.data={},(f=h(m))!==p&&y===t.length)return f;throw f!==p&&y<t.length&&u(function(){return{type:"end"}}()),function(t,n,r){return new e(e.buildMessage(t,n),t,n,r)}(C,E<t.length?t.charAt(E):null,E<t.length?c(E,E+1):c(E,E))}return function(e,t){function n(){this.constructor=e}n.prototype=t.prototype,e.prototype=new n}(e,Error),e.buildMessage=function(e,t){function n(e){return e.charCodeAt(0).toString(16).toUpperCase()}function r(e){return e.replace(/\\/g,"\\\\").replace(/"/g,'\\"').replace(/\0/g,"\\0").replace(/\t/g,"\\t").replace(/\n/g,"\\n").replace(/\r/g,"\\r").replace(/[\x00-\x0F]/g,function(e){return"\\x0"+n(e)}).replace(/[\x10-\x1F\x7F-\x9F]/g,function(e){return"\\x"+n(e)})}function i(e){return e.replace(/\\/g,"\\\\").replace(/\]/g,"\\]").replace(/\^/g,"\\^").replace(/-/g,"\\-").replace(/\0/g,"\\0").replace(/\t/g,"\\t").replace(/\n/g,"\\n").replace(/\r/g,"\\r").replace(/[\x00-\x0F]/g,function(e){return"\\x0"+n(e)}).replace(/[\x10-\x1F\x7F-\x9F]/g,function(e){return"\\x"+n(e)})}function o(e){return s[e.type](e)}var s={literal:function(e){return'"'+r(e.text)+'"'},class:function(e){var t,n="";for(t=0;t<e.parts.length;t++)n+=e.parts[t]instanceof Array?i(e.parts[t][0])+"-"+i(e.parts[t][1]):i(e.parts[t]);return"["+(e.inverted?"^":"")+n+"]"},any:function(e){return"any character"},end:function(e){return"end of input"},other:function(e){return e.description}};return"Expected "+function(e){var t,n,r=new Array(e.length);for(t=0;t<e.length;t++)r[t]=o(e[t]);if(r.sort(),r.length>0){for(t=1,n=1;t<r.length;t++)r[t-1]!==r[t]&&(r[n]=r[t],n++);r.length=n}switch(r.length){case 1:return r[0];case 2:return r[0]+" or "+r[1];default:return r.slice(0,-1).join(", ")+", or "+r[r.length-1]}}(e)+" but "+function(e){return e?'"'+r(e)+'"':"end of input"}(t)+" found."},{SyntaxError:e,parse:t}})},function(e,t,n){"use strict";e.exports=function(){function e(e,t){var n,r,i=[],o=e.split(/\r\n/);for(n=0;n<o.length;){var s=o[n];if(/^m=(?:audio|video)/.test(s))r={index:n,stripped:[]},i.push(r);else if(r){var a=/^a=rtpmap:(\d+) ([^\/]+)\//.exec(s);if(a&&t===a[2]){o.splice(n,1),r.stripped.push(a[1]);continue}}n++}for(n=0;n<i.length;n++){for(var c=o[i[n].index].split(" "),u=3;u<c.length;)-1===i[n].stripped.indexOf(c[u])?u++:c.splice(u,1);o[i[n].index]=c.join(" ")}return o.join("\r\n")}function t(e,t){var n=new RegExp("m="+t+".*$","gm"),r=new RegExp("^a=group:.*$","gm");if(n.test(e)){var i;e=e.split(/^m=/gm).filter(function(e){return e.substr(0,t.length)!==t||(i=e.match(/^a=mid:.*$/gm),i&&(i=i[0].match(/:.+$/g)[0].substr(1)),!1)}).join("m=");var o=e.match(r);if(o&&1===o.length){o=o[0];var s=new RegExp(" *"+i+"[^ ]*","g");o=o.replace(s,""),e=e.split(r).join(o)}}return e}return{stripTcpCandidates:function(e){return e.sdp=e.sdp.replace(/^a=candidate:\d+ \d+ tcp .*?\r\n/gim,""),Promise.resolve(e)},stripTelephoneEvent:function(t){return t.sdp=e(t.sdp,"telephone-event"),Promise.resolve(t)},cleanJitsiSdpImageattr:function(e){return e.sdp=e.sdp.replace(/^(a=imageattr:.*?)(x|y)=\[0-/gm,"$1$2=[1:"),Promise.resolve(e)},stripG722:function(t){return t.sdp=e(t.sdp,"G722"),Promise.resolve(t)},stripRtpPayload:function(t){return function(n){return n.sdp=e(n.sdp,t),Promise.resolve(n)}},stripVideo:function(e){return e.sdp=t(e.sdp,"video"),Promise.resolve(e)},addMidLines:function(e){var t=e.sdp;if(-1===t.search(/^a=mid.*$/gm)){var n=t.match(/^m=.*$/gm);t=t.split(/^m=.*$/gm),n.forEach(function(e,t){n[t]=e+"\na=mid:"+t}),t.forEach(function(e,r){n[r]&&(t[r]=e+n[r])}),t=t.join(""),e.sdp=t}return Promise.resolve(e)}}}},function(e,t,n){"use strict";(function(t){e.exports=function(e){var n={STATUS_NULL:0,STATUS_NEW:1,STATUS_CONNECTING:2,STATUS_CONNECTED:3,STATUS_COMPLETED:4},r=function(r){if(r.media.remote.video?this.video=!0:this.video=!1,r.media.remote.audio?this.audio=!0:this.audio=!1,!this.audio&&!this.video)throw new Error("At least one remote audio or video element is required for Simple.");this.options=r;var i=t.navigator.userAgent.toLowerCase(),o=!1,s=!1;i.indexOf("safari")>-1&&i.indexOf("chrome")<0?o=!0:i.indexOf("firefox")>-1&&i.indexOf("chrome")<0&&(s=!0);var a={};return o&&(a.modifiers=[e.Web.Modifiers.stripG722]),s&&(a.alwaysAcquireMediaFirst=!0),this.options.ua.uri||(this.anonymous=!0),this.ua=new e.UA({uri:this.options.ua.uri,authorizationUser:this.options.ua.authorizationUser,password:this.options.ua.password,displayName:this.options.ua.displayName,userAgentString:this.options.ua.userAgentString,register:!0,sessionDescriptionHandlerFactoryOptions:a,transportOptions:{traceSip:this.options.ua.traceSip,wsServers:this.options.ua.wsServers}}),this.state=n.STATUS_NULL,this.logger=this.ua.getLogger("sip.simple"),this.ua.on("registered",function(){this.emit("registered",this.ua)}.bind(this)),this.ua.on("unregistered",function(){this.emit("unregistered",this.ua)}.bind(this)),this.ua.on("failed",function(){this.emit("unregistered",this.ua)}.bind(this)),this.ua.on("invite",function(e){if(this.state!==n.STATUS_NULL&&this.state!==n.STATUS_COMPLETED)return this.logger.warn("Rejecting incoming call. Simple only supports 1 call at a time"),void e.reject();this.session=e,this.setupSession(),this.emit("ringing",this.session)}.bind(this)),this.ua.on("message",function(e){this.emit("message",e)}.bind(this)),this};return r.prototype=Object.create(e.EventEmitter.prototype),r.C=n,r.prototype.call=function(e){return this.ua&&this.checkRegistration()?this.state!==n.STATUS_NULL&&this.state!==n.STATUS_COMPLETED?void this.logger.warn("Cannot make more than a single call with Simple"):(this.options.media.remote.audio&&(this.options.media.remote.audio.autoplay=!0),this.options.media.remote.video&&(this.options.media.remote.video.autoplay=!0),this.options.media.local&&this.options.media.local.video&&(this.options.media.local.video.autoplay=!0,this.options.media.local.video.volume=0),this.session=this.ua.invite(e,{sessionDescriptionHandlerOptions:{constraints:{audio:this.audio,video:this.video}}}),this.setupSession(),this.session):void this.logger.warn("A registered UA is required for calling")},r.prototype.answer=function(){return this.state!==n.STATUS_NEW&&this.state!==n.STATUS_CONNECTING?void this.logger.warn("No call to answer"):(this.options.media.remote.audio&&(this.options.media.remote.audio.autoplay=!0),this.options.media.remote.video&&(this.options.media.remote.video.autoplay=!0),this.session.accept({sessionDescriptionHandlerOptions:{constraints:{audio:this.audio,video:this.video}}}))},r.prototype.reject=function(){return this.state!==n.STATUS_NEW&&this.state!==n.STATUS_CONNECTING?void this.logger.warn("Call is already answered"):this.session.reject()},r.prototype.hangup=function(){return this.state!==n.STATUS_CONNECTED&&this.state!==n.STATUS_CONNECTING&&this.state!==n.STATUS_NEW?void this.logger.warn("No active call to hang up on"):this.state!==n.STATUS_CONNECTED?this.session.cancel():this.session.bye()},r.prototype.hold=function(){return this.state!==n.STATUS_CONNECTED||this.session.local_hold?void this.logger.warn("Cannot put call on hold"):(this.mute(),this.logger.log("Placing session on hold"),this.session.hold())},r.prototype.unhold=function(){return this.state===n.STATUS_CONNECTED&&this.session.local_hold?(this.unmute(),this.logger.log("Placing call off hold"),this.session.unhold()):void this.logger.warn("Cannot unhold a call that is not on hold")},r.prototype.mute=function(){if(this.state!==n.STATUS_CONNECTED)return void this.logger.warn("An acitve call is required to mute audio");this.logger.log("Muting Audio"),this.toggleMute(!0),this.emit("mute",this)},r.prototype.unmute=function(){if(this.state!==n.STATUS_CONNECTED)return void this.logger.warn("An active call is required to unmute audio");this.logger.log("Unmuting Audio"),this.toggleMute(!1),this.emit("unmute",this)},r.prototype.sendDTMF=function(e){if(this.state!==n.STATUS_CONNECTED)return void this.logger.warn("An active call is required to send a DTMF tone");this.logger.log("Sending DTMF tone: "+e),this.session.dtmf(e)},r.prototype.message=function(e,t){return this.ua&&this.checkRegistration()?e&&t?void this.ua.message(e,t):void this.logger.warn("A destination and message are required to send a message"):void this.logger.warn("A registered UA is required to send a message")},r.prototype.checkRegistration=function(){return this.anonymous||this.ua&&this.ua.isRegistered()},r.prototype.setupRemoteMedia=function(){var e,n=this.session.sessionDescriptionHandler.peerConnection;n.getReceivers?(e=new t.window.MediaStream,n.getReceivers().forEach(function(t){var n=t.track;n&&e.addTrack(n)})):e=n.getRemoteStreams()[0],this.video?(this.options.media.remote.video.srcObject=e,this.options.media.remote.video.play().catch(function(){this.logger.log("play was rejected")}.bind(this))):this.audio&&(this.options.media.remote.audio.srcObject=e,this.options.media.remote.audio.play().catch(function(){this.logger.log("play was rejected")}.bind(this)))},r.prototype.setupLocalMedia=function(){if(this.video&&this.options.media.local&&this.options.media.local.video){var e,n=this.session.sessionDescriptionHandler.peerConnection;n.getSenders?(e=new t.window.MediaStream,n.getSenders().forEach(function(t){var n=t.track;n&&"video"===n.kind&&e.addTrack(n)})):e=n.getLocalStreams()[0],this.options.media.local.video.srcObject=e,this.options.media.local.video.volume=0,this.options.media.local.video.play()}},r.prototype.cleanupMedia=function(){this.video&&(this.options.media.remote.video.srcObject=null,this.options.media.remote.video.pause(),this.options.media.local&&this.options.media.local.video&&(this.options.media.local.video.srcObject=null,this.options.media.local.video.pause())),this.audio&&(this.options.media.remote.audio.srcObject=null,this.options.media.remote.audio.pause())},r.prototype.setupSession=function(){this.state=n.STATUS_NEW,this.emit("new",this.session),this.session.on("progress",this.onProgress.bind(this)),this.session.on("accepted",this.onAccepted.bind(this)),this.session.on("rejected",this.onEnded.bind(this)),this.session.on("failed",this.onFailed.bind(this)),this.session.on("terminated",this.onEnded.bind(this))},r.prototype.destroyMedia=function(){this.session.sessionDescriptionHandler.close()},r.prototype.toggleMute=function(e){var t=this.session.sessionDescriptionHandler.peerConnection;t.getSenders?t.getSenders().forEach(function(t){t.track&&(t.track.enabled=!e)}):t.getLocalStreams().forEach(function(t){t.getAudioTracks().forEach(function(t){t.enabled=!e}),t.getVideoTracks().forEach(function(t){t.enabled=!e})})},r.prototype.onAccepted=function(){this.state=n.STATUS_CONNECTED,this.emit("connected",this.session),this.setupLocalMedia(),this.setupRemoteMedia(),this.session.sessionDescriptionHandler.on("addTrack",function(){this.logger.log("A track has been added, triggering new remoteMedia setup"),this.setupRemoteMedia()}.bind(this)),this.session.sessionDescriptionHandler.on("addStream",function(){this.logger.log("A stream has been added, trigger new remoteMedia setup"),this.setupRemoteMedia()}.bind(this)),this.session.on("hold",function(){this.emit("hold",this.session)}.bind(this)),this.session.on("unhold",function(){this.emit("unhold",this.session)}.bind(this)),this.session.on("dtmf",function(e){this.emit("dtmf",e)}.bind(this)),this.session.on("bye",this.onEnded.bind(this))},r.prototype.onProgress=function(){this.state=n.STATUS_CONNECTING,this.emit("connecting",this.session)},r.prototype.onFailed=function(){this.onEnded()},r.prototype.onEnded=function(){this.state=n.STATUS_COMPLETED,this.emit("ended",this.session),this.cleanupMedia()},r}}).call(t,n(1))},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0}),t.WebRTC=void 0;var i="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},o=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),s=n(0),a=n(49),c=n(3),u=n(50),l=n(2),h=void 0,d=void 0,f=void 0,p=void 0,g=null,m=0,v=null,T=null,y=void 0,_=!0,S=void 0,E=void 0,C=void 0,b=0,R=void 0,w=void 0,I=0,A=(t.WebRTC=function(){function e(t){return r(this,e),d=t,h||(this.isSupported=navigator.getUserMedia||(navigator.mediaDevices?navigator.mediaDevices.getUserMedia:null)||navigator.mozGetUserMedia||navigator.webkitGetUserMedia,window.AudioContext=window.AudioContext||window.webkitAudioContext,navigator.getUserMedia=navigator.getUserMedia||(navigator.mediaDevices?navigator.mediaDevices.getUserMedia:null)||navigator.mozGetUserMedia||navigator.webkitGetUserMedia,window.RTCPeerConnection=window.RTCPeerConnection||window.mozRTCPeerConnection||window.webkitRTCPeerConnection,window.RTCIceCandidate=window.RTCIceCandidate||window.mozRTCIceCandidate||window.webkitRTCIceCandidate,window.RTCSessionDescription=window.RTCSessionDescription||window.mozRTCSessionDescription||window.webkitRTCSessionDescription,h=this,this.webRTCMedia=new u.WebRTCMedia(h,E)),h}return o(e,[{key:"Oninvite",value:function(e){s.Logger.Trace("[session][Oninvite]",e),h.SIPParameter.onCallEntry()}},{key:"setParamter",value:function(e){this.SIPParameter=e}},{key:"initSip",value:function(e){var t=this;S=e,this.isSupported?(E=this.webRTCMedia.GetStreamMic(),navigator.mediaDevices.ondevicechange=function(){return t.webRTCMedia.UpdateDeviceList(h.SIPParameter.onChangeDeviceList)}):s.Logger.Error("WebRTC is not Supported")}},{key:"startMic",value:function(){this.webRTCMedia.startMic()}},{key:"sipAskPermission",value:function(){d.WebRTC.getUserMedia(c.MEDIA_CONSTRAINT,this.webRTCMedia.GetUserMediaSuccess,this.webRTCMedia.GetUserMediaFailure)}},{key:"createSIPStack",value:function(e){try{p||this.createSIPStackDetail(e)}catch(e){s.Logger.Warn("Exception creating SIP CLIENT ==>>",e)}}},{key:"LoggerTest",value:function(e,t,n,r){c.FILTER_LOG.find(function(e){return e===t})||("log"===e||"debug"===e?console.log("[SIP]["+e+"]["+t+"]"+n,r):s.Logger.Warning("["+e+"]["+t+"]"+n,r))}},{key:"stunFormat",value:function(){var e=this.SIPParameter.SIP_stunServers,t=[{urls:"stun:stun.l.google.com:19302"}];switch(void 0===e?"undefined":i(e)){case"string":var n=/.+:\d+/g.test(e);return e?[{urls:n?"stun:"+e:"stun:"+e+":19302"}]:[];case"object":return Array.isArray(e)?e:t;default:return t}}},{key:"createSIPStackDetail",value:function(e){var t=this.stunFormat(),n=t.length>0?{iceCheckingTimeout:this.validateIceCheckingTimeout(this.SIPParameter.SIP_iceCheckingTimeout),rtcConfiguration:{iceServers:t}}:{};p=new d.UA({uri:this.SIPParameter.SIP_uri,transportOptions:{wsServers:this.SIPParameter.SIP_wsServers,traceSip:!0,connectionTimeout:60,maxReconnectionAttempts:50,reconnectionTimeout:3},authorizationUser:this.SIPParameter.SIP_authorizationUser,password:this.SIPParameter.SIP_password,displayName:e,register:this.SIPParameter.SIP_register,userAgentString:this.SIPParameter.SIP_userAgentString,dtmfType:this.SIPParameter.SIP_DTMF_Type==l.DTMF_TYPE_RFC2833?d.C.dtmfType.RTP:d.C.dtmfType.INFO,log:{builtinEnabled:!0,level:s.Logger.LevelConsole,connector:this.LoggerTest},sessionDescriptionHandlerFactory:this.CreateSessionDescriptionHandlerNuxiba,sessionDescriptionHandlerFactoryOptions:{constraints:c.MEDIA_CONSTRAINT,peerConnectionOptions:n}}),p.on("invite",this.Oninvite),p.transport.on("disconnected",function(e){s.Logger.Warning("SIP transport disconnected, Error: "+e," attempt:"+b),h.SIPParameter.onTransportDisconnected({code:e.code,reason:e.reason,attempt:b}),b++}),p.transport.on("connected",function(){b=0,s.Logger.Info("SIP transport connected"),h.SIPParameter.onTransportConnected()})}},{key:"CreateSessionDescriptionHandlerNuxiba",value:function(e,t){var n=e.ua.getLogger("sip.invitecontext.SessionDescriptionHandlerNuxiba",e.id),r=new A(e,t);return new O(n,r,t)}},{key:"validateIceCheckingTimeout",value:function(e){return e<500&&(s.Logger.Warn("iceCheckinngTimeOut could not be lower than 500, iceCheckinngTimeOut=750"),e=750),e}},{key:"freeCallResources",value:function(){this.cancelCallTimeOut(),f=null,v=null,C=null}},{key:"cancelCallTimeOut",value:function(){g&&(clearTimeout(g),g=null)}},{key:"finishedDtmfLoading",value:function(e){try{E.playBuffer(e)}catch(e){s.Logger.Warn("finishedDtmfLoading.Error: "+e.message)}}},{key:"protocol",value:function(e){var t=e.sdp.match(/^m=audio.*$/gm);if(t){var n=t[0];n=n.split(" ");for(var r=3;r<n.length;r+=1)if("111"===n[r]){n.splice(r,1);var i=parseInt(n[1],10);i-=1,n[1]=i.toString()}n=n.join(" "),e.sdp=e.sdp.replace(/^m=audio.*$/gm,n),e.sdp=e.sdp=e.sdp.replace(/a=rtcp-fb:111 transport-cc\r\n/gim,""),e.sdp=e.sdp=e.sdp.replace(/a=rtpmap:111 opus\/\d+\/\d+\r\n/gim,""),e.sdp=e.sdp=e.sdp.replace(/a=fmtp:111 minptime=10;useinbandfec=1\r\n/gim,"")}return Promise.resolve(e)}},{key:"validateCallIdEqual",value:function(e){var t=(new Date).getTime();return!!(C===e&&v&&t-v<1500)&&(s.Logger.Warn("IsEqual callIdCW:",C),!0)}},{key:"checkIsDisableMicrophone",value:function(e){return!(!e||(E=this.webRTCMedia.GetStreamMic())&&E.streamMic&&E.streamMic.active||(s.Logger.Warn("Microphone disable"),h.SIPParameter.onGetStreamMicFail(),0))}},{key:"sipCall",value:function(e){if(!this.validateCallIdEqual(e)){v=(new Date).getTime(),C=e;var t=f?"Is Not Null":"Is Null";s.Logger.Info("SIP Calling To:"+e+this.SIPParameter.SIP_KAMAILIO+" Dest: "+this.SIPParameter.SIP_CNF_XD+" oSipSessionCall:"+t);var n=!E||!E.streamMic||!E.streamMic.active;s.Logger.Debug("Microphone status:",n),this.checkIsDisableMicrophone(n)||(p&&!f?(m=(new Date).getTime(),s.Logger.Trace("Call: "+e+" SIP CallTimeout => "+this.SIPParameter.SIP_callTimeout+" seconds left to hangup"),g=setTimeout(function(){s.Logger.Info("Call: "+e+" SIP CallTimeout - hanging up"),h.sipHangUp()},1e3*this.SIPParameter.SIP_callTimeout),"running"!==E.audioContext.state?(s.Logger.Trace("Resume AudioContext"),E.audioContext.resume().then(function(){s.Logger.Trace("Resumed AudioContext. Status:"+E.audioContext.state),this.sipInvite()}.bind(this)).catch(function(e){s.Logger.Trace("Cant make call, resume audio failed for AudioContext. Status:"+E.audioContext.state+" => "+e)})):this.sipInvite()):s.Logger.Info("Can not Make Sip Call: oSipSessionCall value:",f))}}},{key:"sipInvite",value:function(){var e=[this.protocol];try{f=p.invite(C+this.SIPParameter.SIP_KAMAILIO,{sessionDescriptionHandlerOptions:{constraints:c.MEDIA_CONSTRAINT},extraHeaders:["X-Destination: "+this.SIPParameter.SIP_CNF_XD]},e),s.Logger.Info("sipInvite callIdCW:",C," kamalio call_id:",f.request.call_id),this.sipCallProcess()}catch(e){s.Logger.Warning("SIP Calling To:"+C+" Error: "+e)}}},{key:"sipCallProcess",value:function(){T=f.request.call_id?f.request.call_id:0,s.Logger.Debug("New SIP Call ID ["+T+"] at "+m+" callIdCW: "+C),f.on("progress",function(e){h.cancelCallTimeOut();var t=(new Date).getTime();if((t=Math.max(0,h.SIPParameter.SIP_callTimeout-(t-m)/1e3))<=1)return s.Logger.Trace("SIP CallTimeout on progress - hanging up ["+T+"] callIdCW: "+C),void h.sipHangUp();s.Logger.Info("Call: ["+T+"] SIP CallTimeout => "+t+" seconds left to hangup callIdCW "+C),g=setTimeout(function(){s.Logger.Info("SIP CallTimeout ["+T+"]- hanging up callIdCW: "+C),h.sipHangUp()},1e3*t),s.Logger.Trace("SIP Progress for: "+e.call_id+" callIdCW: "+C)}),f.on("accepted",function(e){h.cancelCallTimeOut(),s.Logger.Trace("Date received on accepted ",e,"callIdCW:"+C),h.SIPParameter.onCallAnswered()}),f.on("iceConnectionFailed",function(e){s.Logger.Warning("SIP ICE Conenction Failed - hanging up","callIdCW:"+C),h.sipHangUp()}),f.on("failed",function(e,t){s.Logger.Warning("["+(new Date).getTime()+"] SIP call invite failed for call: "+e+" with cause: "+t,"callIdCW:"+C),h.freeCallResources()}),f.on("terminated",function(e,t){e||(e={call_id:0}),s.Logger.Trace("["+(new Date).getTime()+"] SIP call invite terminated for call: "+e.call_id+" with cause: "+t,"callIdCW:"+C),h.freeCallResources()}),f.on("bye",function(){s.Logger.Trace("["+(new Date).getTime()+"] SIP Bye for call: "+T,"callIdCW:"+C),h.SIPParameter.uiCallTerminated(),h.freeCallResources()}),f.on("rejected",function(e,t){s.Logger.Debug("["+(new Date).getTime()+"] SIP call invite rejected for call: "+e.call_id+" with cause: "+t,"callIdCW:"+C),h.SIPParameter.onCallRejected(t),h.freeCallResources()})}},{key:"sipTransfer",value:function(e){f.refer(e)}},{key:"sipToggleHoldResume",value:function(){if(f){var e;if(_?(e=f.unhold(),_=!_):(e=f.hold(),_=!_),0!==e)return}}},{key:"sipToggleMute",value:function(e){try{E.mute("1"===e)}catch(e){s.Logger.Warn("Error: ",e)}}},{key:"sipHangUp",value:function(){s.Logger.Info("Hangup callIdCW:"+C+" oSipSessionCall.request.call_id:",f?f.request.call_id:null),this.cancelCallTimeOut(),s.Logger.Trace("Cleaning callIdCW"),C=null,f&&(f.terminate(),f=null,v=null)}},{key:"volumeSpeaker",value:function(e){try{S.volume=e/100}catch(e){s.Logger.Warn("Error ",e)}I=0,s.Logger.Trace("lastGain",I),w&&(w.gain.value=0)}},{key:"volumeMicrophone",value:function(e){try{E.volume=e/100}catch(e){s.Logger.Warn("Error ",e)}}},{key:"getMicVol",value:function(){try{return 100*E.volume}catch(e){s.Logger.Warn("Error ",e)}return 0}},{key:"getSpkrVol",value:function(){try{return 100*S.volume}catch(e){s.Logger.Warn("Error ",e)}return 0}},{key:"sipDTMF",value:function(e){try{if(f&&e){var t=this.SIPParameter.SIP_DTMF_Type;switch(s.Logger.Trace("Sending DTMF: "+e+", Type: "+t),t){case l.DTMF_TYPE_RFC2833:case l.DTMF_TYPE_SIPINFO:f.dtmf(e);break;case l.DTMF_TYPE_INBAND:if(E.bDtmf)s.Logger.Trace("DTMF already in progress");else{switch(e){case l.SYMBOL_STAR:e=l.DTMF_TONES_STAR;break;case l.SYMBOL_POUND:e=l.DTMF_TONES_POUND}E.bDtmf=!0,y=new a.BufferLoader(E.audioContext,["sounds/100ms/"+e+".wav"],h.finishedDtmfLoading),y.load()}}}}catch(e){s.Logger.Warn("Error: "+e.message)}}}]),e}(),function(){function e(t,n){r(this,e),this.session=t||{},this.options=n||{}}return o(e,[{key:"trackAdded",value:function(){var e=f.sessionDescriptionHandler.peerConnection,t=new MediaStream;e.getReceivers().forEach(function(e){t.addTrack(e.track)}),S.srcObject=t,t.muted=!0,R=new AudioContext,w=R.createGain(),w.gain.value=I,R.createMediaStreamSource(t).connect(w),w.connect(R.destination),S.onloadedmetadata=function(){S.play()},e.getSenders()[0]}},{key:"directionChanged",value:function(){console.log("directionChanged")}}]),e}()),O=function e(t,n,i){r(this,e),this.options=i||{},this.logger=t,this.observer=n,this.dtmfSender=null,this.shouldAcquireMedia=!0,this.CONTENT_TYPE="application/sdp",this.C={},this.C.DIRECTION={NULL:null,SENDRECV:"sendrecv",SENDONLY:"sendonly",RECVONLY:"recvonly",INACTIVE:"inactive"},this.logger.log("SessionDescriptionHandlerOptions: "+JSON.stringify(this.options)),this.direction=this.C.DIRECTION.NULL,this.modifiers=this.options.modifiers||[],Array.isArray(this.modifiers)||(this.modifiers=[this.modifiers]);var o=window;this.WebRTC={MediaStream:o.MediaStream,getUserMedia:o.navigator.mediaDevices.getUserMedia.bind(o.navigator.mediaDevices),RTCPeerConnection:o.RTCPeerConnection},this.iceGatheringDeferred=null,this.iceGatheringTimeout=!1,this.iceGatheringTimer=null,this.initPeerConnection(this.options.peerConnectionOptions),this.constraints=this.checkAndDefaultConstraints(this.options.constraints)};O.prototype=Object.create(O.prototype,{close:{writable:!0,value:function(){this.peerConnection&&"closed"!==this.peerConnection.signalingState&&(this.peerConnection.getReceivers?this.peerConnection.getReceivers().forEach(function(e){e.track&&e.track.stop()}):(this.logger.warn("Using getRemoteStreams which is deprecated"),this.peerConnection.getRemoteStreams().forEach(function(e){e.getTracks().forEach(function(e){e.stop()})})),this.resetIceGatheringComplete(),this.peerConnection.close())}},getDescription:{writable:!0,value:function(e,t){var n=this;e=e||{},e.peerConnectionOptions&&this.initPeerConnection(e.peerConnectionOptions);var r=Object.assign({},this.constraints,e.constraints);return r=this.checkAndDefaultConstraints(r),JSON.stringify(r)!==JSON.stringify(this.constraints)&&(this.constraints=r,this.shouldAcquireMedia=!0),t=t||[],Array.isArray(t)||(t=[t]),t=t.concat(this.modifiers),Promise.resolve().then(function(){if(n.shouldAcquireMedia)return n.acquire(n.constraints).then(function(){n.shouldAcquireMedia=!1})}).then(function(){return n.createOfferOrAnswer(e.RTCOfferOptions,t)}).then(function(e){return{body:e.sdp,contentType:n.CONTENT_TYPE}})}},hasDescription:{writable:!0,value:function(e){return e===this.CONTENT_TYPE}},holdModifier:{writable:!0,value:function(e){return/a=(sendrecv|sendonly|recvonly|inactive)/.test(e.sdp)?(e.sdp=e.sdp.replace(/a=sendrecv\r\n/g,"a=sendonly\r\n"),e.sdp=e.sdp.replace(/a=recvonly\r\n/g,"a=inactive\r\n")):e.sdp=e.sdp.replace(/(m=[^\r]*\r\n)/g,"$1a=sendonly\r\n"),Promise.resolve(e)}},setDescription:{writable:!0,value:function(e,t,n){var r=this;t=t||{},t.peerConnectionOptions&&this.initPeerConnection(t.peerConnectionOptions),n=n||[],Array.isArray(n)||(n=[n]),n=n.concat(this.modifiers);var i={type:this.hasOffer("local")?"answer":"offer",sdp:e};return Promise.resolve().then(function(){if(r.shouldAcquireMedia&&r.options.alwaysAcquireMediaFirst)return r.acquire(r.constraints).then(function(){r.shouldAcquireMedia=!1})}).then(function(){return d.Utils.reducePromises(n,i)}).catch(function(e){if(e instanceof d.Exceptions.SessionDescriptionHandlerError)throw e;var t=new d.Exceptions.SessionDescriptionHandlerError("setDescription",e,"The modifiers did not resolve successfully");throw r.logger.error(t.message),t}).then(function(e){return r.peerConnection.setRemoteDescription(e)}).catch(function(i){if(i instanceof d.Exceptions.SessionDescriptionHandlerError)throw i;if(/^m=video.+$/gm.test(e)&&!t.disableAudioFallback)return t.disableAudioFallback=!0,r.setDescription(e,t,[d.Web.Modifiers.stripVideo].concat(n));var o=new d.Exceptions.SessionDescriptionHandlerError("setDescription",i);throw r.logger.error(o.error),o})}},sendDtmf:{writable:!0,value:function(e,t){if(!this.dtmfSender&&this.hasBrowserGetSenderSupport()){var n=this.peerConnection.getSenders();n.length>0&&(this.dtmfSender=n[0].dtmf)}if(!this.dtmfSender&&this.hasBrowserTrackSupport()){var r=this.peerConnection.getLocalStreams();if(r.length>0){var i=r[0].getAudioTracks();i.length>0&&(this.dtmfSender=this.peerConnection.createDTMFSender(i[0]))}}if(!this.dtmfSender)return!1;try{this.dtmfSender.insertDTMF(e,t.duration,t.interToneGap)}catch(e){if("InvalidStateError"===e.type||"InvalidCharacterError"===e.type)return this.logger.error(e),!1;throw e}return this.logger.log("DTMF sent via RTP: "+e.toString()),!0}},getDirection:{writable:!0,value:function(){return this.direction}},createOfferOrAnswer:{writable:!0,value:function(e,t){var n,r=this,i=this.peerConnection;return e=e||{},n=this.hasOffer("remote")?"createAnswer":"createOffer",this.logger.log(n),i[n](e).catch(function(e){if(e instanceof d.Exceptions.SessionDescriptionHandlerError)throw e;throw new d.Exceptions.SessionDescriptionHandlerError("createOfferOrAnswer",e,"peerConnection-"+n+"Failed")}).then(function(e){return d.Utils.reducePromises(t,r.createRTCSessionDescriptionInit(e))}).then(function(e){return r.resetIceGatheringComplete(),r.logger.log("Setting local sdp."),r.logger.log(e.sdp),i.setLocalDescription(e)}).catch(function(e){if(e instanceof d.Exceptions.SessionDescriptionHandlerError)throw e;throw new d.Exceptions.SessionDescriptionHandlerError("createOfferOrAnswer",e,"peerConnection-SetLocalDescriptionFailed")}).then(function(){return r.waitForIceGatheringComplete()}).then(function(){var e=r.createRTCSessionDescriptionInit(r.peerConnection.localDescription);return d.Utils.reducePromises(t,e)}).then(function(e){return r.setDirection(e.sdp),e}).catch(function(e){if(e instanceof d.Exceptions.SessionDescriptionHandlerError)throw e;var t=new d.Exceptions.SessionDescriptionHandlerError("createOfferOrAnswer",e);throw r.logger.error(t),t})}},createRTCSessionDescriptionInit:{writable:!0,value:function(e){return{type:e.type,sdp:e.sdp}}},addDefaultIceCheckingTimeout:{writable:!0,value:function(e){return void 0===e.iceCheckingTimeout&&(e.iceCheckingTimeout=5e3),e}},checkAndDefaultConstraints:{writable:!0,value:function(e){var t={audio:!0,video:!this.options.alwaysAcquireMediaFirst};return e=e||t,0===Object.keys(e).length&&e.constructor===Object?t:e}},hasBrowserTrackSupport:{writable:!0,value:function(){return Boolean(this.peerConnection.addTrack)}},hasBrowserGetSenderSupport:{writable:!0,value:function(){return Boolean(this.peerConnection.getSenders)}},initPeerConnection:{writable:!0,value:function(e){var t=this,n=this;e=e||{},e.rtcConfiguration=e.rtcConfiguration||{},this.logger.log("initPeerConnection"),this.peerConnection&&(this.logger.log("Already have a peer connection for this session. Tearing down."),this.resetIceGatheringComplete(),this.peerConnection.close()),this.peerConnection=new this.WebRTC.RTCPeerConnection(e.rtcConfiguration),this.logger.log("New peer connection created"),window.setInterval(function(){var e=t.peerConnection.getSenders()[0],n="";e&&e.getStats().then(function(e){e.forEach(function(e){"remote-inbound-rtp"===e.type&&(e.roundTripTime>.4?(n="Bad connection on call, Jitter:"+e.jitter+", Lost Packages: "+e.packetsLost+", RTT: "+e.roundTripTime,h.SIPParameter.onDataStreamInfo(3,n)):e.roundTripTime>.3&&e.roundTripTime<=.4?(n="Unstable connection on call, Jitter:"+e.jitter+", Lost Packages: "+e.packetsLost+", RTT: "+e.roundTripTime,h.SIPParameter.onDataStreamInfo(2,n)):e.roundTripTime>0&&e.roundTripTime<=.3&&h.SIPParameter.onDataStreamInfo(1,n))})})},1e3),"ontrack"in this.peerConnection?this.peerConnection.addEventListener("track",function(e){n.logger.log("track added"),n.observer.trackAdded()}):(this.logger.warn("Using onaddstream which is deprecated"),this.peerConnection.onaddstream=function(e){n.logger.log("stream added")}),this.peerConnection.onicecandidate=function(e){e.candidate?n.logger.log("ICE candidate received: "+(null===e.candidate.candidate?null:e.candidate.candidate.trim())):null===e.candidate&&(n.logger.log("ICE candidate gathering complete"),n.triggerIceGatheringComplete())},this.peerConnection.onicegatheringstatechange=function(){switch(n.logger.log("RTCIceGatheringState changed: "+this.iceGatheringState),this.iceGatheringState){case"gathering":!n.iceGatheringTimer&&e.iceCheckingTimeout&&(n.iceGatheringTimeout=!1,n.iceGatheringTimer=setTimeout(function(){n.logger.log("RTCIceChecking Timeout Triggered after "+e.iceCheckingTimeout+" milliseconds"),n.iceGatheringTimeout=!0,n.triggerIceGatheringComplete()},e.iceCheckingTimeout));break;case"complete":n.triggerIceGatheringComplete()}},this.peerConnection.oniceconnectionstatechange=function(){var e;switch(this.iceConnectionState){case"new":e="iceConnection";break;case"checking":e="iceConnectionChecking";break;case"connected":e="iceConnectionConnected";break;case"completed":e="iceConnectionCompleted";break;case"failed":e="iceConnectionFailed";break;case"disconnected":e="iceConnectionDisconnected";break;case"closed":e="iceConnectionClosed";break;default:return void n.logger.warn("Unknown iceConnection state:",this.iceConnectionState)}n.logger.log("ICE Connection State changed to "+e),f&&f.emit(e,this)}}},acquire:{writable:!0,value:function(e){var t=this;return e=this.checkAndDefaultConstraints(e),new Promise(function(n,r){e.audio||e.video?(t.logger.log("acquired local media: ",E.streamMic),n(E.destSource.stream)):n([])}).catch(function(e){if(e instanceof d.Exceptions.SessionDescriptionHandlerError)throw e;var n=new d.Exceptions.SessionDescriptionHandlerError("acquire",e,"unable to acquire streams");throw t.logger.error(n.message),t.logger.error(n.error),n}).then(function(e){t.logger.log("acquired local media streams");try{return t.peerConnection.removeTrack&&t.peerConnection.getSenders().forEach(function(e){t.peerConnection.removeTrack(e)}),e}catch(e){return Promise.reject(e)}}).catch(function(e){if(e instanceof d.Exceptions.SessionDescriptionHandlerError)throw e;var n=new d.Exceptions.SessionDescriptionHandlerError("acquire",e,"error removing streams");throw t.logger.error(n.message),t.logger.error(n.error),n}).then(function(e){try{e=[].concat(e),e.forEach(function(e){t.peerConnection.addTrack?e.getTracks().forEach(function(n){t.peerConnection.addTrack(n,e)}):t.peerConnection.addStream(e)})}catch(e){return Promise.reject(e)}return Promise.resolve()}).catch(function(e){if(e instanceof d.Exceptions.SessionDescriptionHandlerError)throw e;var n=new d.Exceptions.SessionDescriptionHandlerError("acquire",e,"error adding stream");throw t.logger.error(n.message),t.logger.error(n.error),n})}},hasOffer:{writable:!0,value:function(e){var t="have-"+e+"-offer";return this.peerConnection.signalingState===t}},isIceGatheringComplete:{writable:!0,value:function(){return"complete"===this.peerConnection.iceGatheringState||this.iceGatheringTimeout}},resetIceGatheringComplete:{writable:!0,value:function(){this.iceGatheringTimeout=!1,this.logger.log("resetIceGatheringComplete"),this.iceGatheringTimer&&(clearTimeout(this.iceGatheringTimer),this.iceGatheringTimer=null),this.iceGatheringDeferred&&(this.iceGatheringDeferred.reject(),this.iceGatheringDeferred=null)}},setDirection:{writable:!0,value:function(e){var t=e.match(/a=(sendrecv|sendonly|recvonly|inactive)/);if(null===t)return this.direction=this.C.DIRECTION.NULL,void this.observer.directionChanged();var n=t[1];switch(n){case this.C.DIRECTION.SENDRECV:case this.C.DIRECTION.SENDONLY:case this.C.DIRECTION.RECVONLY:case this.C.DIRECTION.INACTIVE:this.direction=n;break;default:this.direction=this.C.DIRECTION.NULL}this.observer.directionChanged()}},triggerIceGatheringComplete:{writable:!0,value:function(){this.isIceGatheringComplete()&&(this.iceGatheringTimer&&(clearTimeout(this.iceGatheringTimer),this.iceGatheringTimer=null),this.iceGatheringDeferred&&(this.iceGatheringDeferred.resolve(),this.iceGatheringDeferred=null))}},waitForIceGatheringComplete:{writable:!0,value:function(){return this.logger.log("waitForIceGatheringComplete"),this.isIceGatheringComplete()?(this.logger.log("ICE is already complete. Return resolved."),Promise.resolve()):(this.isIceGatheringDeferred||(this.iceGatheringDeferred=d.Utils.defer()),this.logger.log("ICE is not complete. Returning promise"),this.iceGatheringDeferred.promise)}}})},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0}),t.BufferLoader=void 0;var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),o=n(0);t.BufferLoader=function(){function e(t,n,i){r(this,e),o.Logger.Trace("Init BufferLoader constructor ..."),this.context=t,this.urlList=n,this.onload=i,this.bufferList=new Array,this.loadCount=0}return i(e,[{key:"loadBuffer",value:function(e,t){o.Logger.Trace("Buffering "+e);var n=new XMLHttpRequest;n.open("GET",e,!0),n.responseType="arraybuffer";var r=this;n.onload=function(){r.context.decodeAudioData(n.response,function(n){if(!n)return void o.Logger.Warning("error decoding file data: "+e);r.bufferList[t]=n,++r.loadCount==r.urlList.length&&r.onload(r.bufferList)})},n.onerror=function(e){o.Logger.Warning("BufferLoader: XHR error",e)},n.send()}},{key:"load",value:function(){for(var e=0;e<this.urlList.length;++e)this.loadBuffer(this.urlList[e],e)}}]),e}()},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0}),t.WebRTCMedia=void 0;var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),o=n(0),s=n(3),a=void 0,c=void 0;t.WebRTCMedia=function(){function e(t,n){r(this,e),a=t,c=n}return i(e,[{key:"UpdateDeviceList",value:function(e){var t=this;o.Logger.Info("updateDeviceList"),navigator.mediaDevices.enumerateDevices().then(function(t){e(t)}).catch(function(e){o.Logger.Warn("UpdateDeviceList",e)}),navigator.getUserMedia(s.MEDIA_CONSTRAINT,function(e){return t.onGetUserMediaSuccess(e,c)},function(e){return t.onGetUserMediaFailure(e)})}},{key:"GetUserMediaSuccess",value:function(){o.Logger.Trace("GetUserMediaSuccess")}},{key:"GetUserMediaFailure",value:function(e){o.Logger.Error("GetUserMediaFailure:",e),a.SIPParameter.onSipRejected()}},{key:"onGetUserMediaSuccess",value:function(e,t){o.Logger.Trace("onGetUserMediaSuccess",e),t.streamMic=e,t.source=c.audioContext.createMediaStreamSource(t.streamMic),t.source.connect(c.gain),a.SIPParameter.onSipAccepted()}},{key:"onGetUserMediaFailure",value:function(e){o.Logger.Warn("Not Permission user",e)}},{key:"GetStreamMic",value:function(){var e=this,t=new AudioContext;return c={audioContext:t,destSource:t.createMediaStreamDestination(),gain:t.createGain(),playableGain:t.createGain(),bDtmf:!1,bDtmfMute:!1,get volume(){return this.gain.gain.value},set volume(e){this.gain.gain.value=e}},c.volMic=c.gain.gain.value,c.mute=function(e){o.Logger.Trace("OnMute:"+e),e?(this.volMic=this.gain.gain.value,this.volume=0):this.volume=this.volMic},c.playableGain.connect(c.destSource),c.playBuffer=function(e){var n=t.createBufferSource();c.bDtmfMute=0==c.volume;var r=this;n.buffer=e[0],n.connect(c.playableGain),n.onended=function(){o.Logger.Warn("Disconnect onended"),r.mute(r.bDtmfMute),n.disconnect(r.playableGain),r.bDtmf=!1},this.mute(!0),n.start(0)},c.gain.connect(c.destSource),void 0===navigator.mediaDevices.getUserMedia?navigator.getUserMedia(s.MEDIA_CONSTRAINT,function(t){return e.onGetUserMediaSuccess(t,c)},function(t){return e.onGetUserMediaFailure(t)}):navigator.mediaDevices.getUserMedia(s.MEDIA_CONSTRAINT).then(function(t){return e.onGetUserMediaSuccess(t,c)}).catch(function(t){return e.onGetUserMediaFailure(t)}),c}},{key:"startMic",value:function(){"running"===c.audioContext.state&&c.audioContext.suspend().then(function(){console.log("audioContext suspend Success",c.audioContext.state)}).catch(function(e){console.warn("audioContext suspend Error",e,c.audioContext.state)}),"suspended"===c.audioContext.state&&c.audioContext.resume().then(function(){console.log("audioContext resume Success",c.audioContext.state)}).catch(function(e){console.warn("audioContext resume Error",e,c.audioContext.state)})}}]),e}()},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0}),t.MizuJSWrapper=void 0;var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),o=n(52);t.MizuJSWrapper=function(){function e(){r(this,e)}return i(e,[{key:"getSoftphone",value:function(){return new o.MizuJS(webphone_api)}}]),e}()},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0}),t.MizuJS=void 0;var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),o=n(2),s=n(0),a=void 0,c=void 0;t.MizuJS=function(){function e(t){return r(this,e),c=t,a||(a=this),a}return i(e,[{key:"setParameters",value:function(e){var t=this;Object.keys(e).forEach(function(t){return c.parameters[t]=e[t]}),Object.keys(e).forEach(function(n){return t.setParameter(n,e[n])}),this.start()}},{key:"getParameters",value:function(){return c.parameters}},{key:"checkdll",value:function(){console.log("Stack")}},{key:"activateSIP",value:function(){this.showLogin()}},{key:"hangup",value:function(){try{c.hangup()}catch(e){s.Logger.Error("[MizuJS]",e.message)}}},{key:"firstMute",value:function(e){s.Logger.Trace("First mute"+e)}},{key:"mute",value:function(e){try{c.mute(e,2)}catch(e){s.Logger.Warn("[MizuJS]",e.message)}}},{key:"pushDTMF",value:function(e){try{switch(e){case o.SYMBOL_STAR:e=o.DTMF_TONES_STAR;break;case o.SYMBOL_POUND:e=o.DTMF_TONES_POUND}c.dtmf(e)}catch(e){s.Logger.Warn("[MizuJS]",e.message)}}},{key:"showLogin",value:function(){console.log("Stack")}},{key:"initTester",value:function(){console.log("Stack")}},{key:"SetIvrMonitor",value:function(){console.log("Stack")}},{key:"MakeCallNew",value:function(e,t,n){try{e=e.replace(/\|/g,"#");var r=e+"@"+t+":"+n;c.call(r)}catch(e){s.Logger.Error("[MizuJS]",e.message)}}},{key:"MakeCall",value:function(e){try{if(c.isincall())s.Logger.Info("Can not Make Sip Call: Already in call");else{e=e.replace(/\|/g,"#"),s.Logger.Trace("[MizuJS]","Trying to call2:",a.SIPParameter);var t=e+a.SIPParameter.SIP_KAMAILIO;s.Logger.Info("SIP Calling To:"+t),c.call(t)}}catch(e){s.Logger.Warn("[MizuJS]",e.message)}}},{key:"getWebphoneStatus",value:function(){return c.isregistered()}},{key:"SpeakerVolume",value:function(e){try{c.setvolume(1,e),c.setvolume(2,e)}catch(e){s.Logger.Warn("[MizuJS]",e.message)}}},{key:"MicrophoneVolume",value:function(e){try{c.setvolume(0,e)}catch(e){s.Logger.Warn("[MizuJS]",e.message)}}},{key:"getMicVol",value:function(){try{return c.getvolume(0,50)}catch(e){s.Logger.Warn("[MizuJS]",e.message)}return 0}},{key:"getSpkrVol",value:function(){try{return c.getvolume(1,50)}catch(e){s.Logger.Warn("[MizuJS]",e.message)}return 0}},{key:"setParamter",value:function(e){this.SIPParameter=e}},{key:"setParameter",value:function(e,t){c.setparameter(e,t)}},{key:"initCallBacks",value:function(){console.log("[MizuJS] Init CallBacks"),c.onCallStateChange(function(e,t,n,r,i,o){console.log("[MizuJS] "+e),"connected"===e?(console.log("[MizuJS] SIP Call Connected"),a.SIPParameter.onCallAnswered()):" disconnected"===e&&(console.log("[MizuJS] SIP Call Disconnected"),a.SIPParameter.uiCallTerminated())})}},{key:"start",value:function(){s.Logger.Info("[MizuJS]","Start Webphone API"),c.start()}},{key:"stop",value:function(){c.stop()}}]),e}()},function(e,t){e.exports={name:"global-sip-js",version:"2022.1.3",description:"JS library that allows SIP connection using WebRTC",main:"index.js",scripts:{test:"jest --coverage",sonarScanner:"node sonarqube-scanner.js Global_Sip_JS_DEV","sonarScanner:release":"node sonarqube-scanner.js Global_Sip_JS_RELEASE"},author:"Copyright © 2022 Nuxiba Technologies Inc. All Rights Reserved.",license:"ISC",devDependencies:{jest:"^23.6.0","jest-html-reporter":"^2.6.0","babel-core":"^6.25.0","babel-loader":"^7.1.1","babel-preset-es2015":"^6.24.1","babel-preset-stage-0":"^6.24.1",jsdom:"13.0.0","jsdom-global":"3.0.2",webpack:"^3.12.0","webpack-auto-inject-version":"^1.2.2","webpack-cli":"^3.3.9",sinon:"^2.3.8","babel-plugin-transform-class-properties":"^6.24.1","sonarqube-scanner":"^2.8.2"},dependencies:{"sip.js":"0.12.0","global-logger-services-js":"git+ssh://git@bitbucket.org/nuxibatechnologies/global-logger-services-js.git"},jest:{testEnvironment:"node",testMatch:["**/dist/**/?(*.)(spec|test).js?(x)"],moduleFileExtensions:["ts","tsx","js","json"]}}}])})}])}); 

/***/ },
/* 1395 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var _react = _interopRequireWildcard(__webpack_require__(1));
	var _MediaViewer = _interopRequireDefault(__webpack_require__(378));
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	var _helpers = __webpack_require__(53);
	__webpack_require__(2472);
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
	function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	var ButtonAttached = function ButtonAttached(_ref) {
	  var media = _ref.media,
	    mediaName = _ref.mediaName;
	  var _useState = (0, _react.useState)(false),
	    _useState2 = _slicedToArray(_useState, 2),
	    openPreview = _useState2[0],
	    setOpenPreview = _useState2[1];
	  media = (0, _helpers.getLocation)(media, window.location.hostname, window.location.href);
	  var preview = (0, _helpers.isImageURL)(media);
	  var aRef = (0, _react.useRef)();
	  var download = function download() {
	    aRef.current.click();
	  };
	  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("a", {
	    ref: aRef,
	    href: media,
	    download: mediaName,
	    target: "_blank",
	    rel: "noopener noreferrer",
	    style: {
	      display: 'none'
	    }
	  }, mediaName), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-ba-wrapper"
	  }, preview && /*#__PURE__*/_react["default"].createElement("img", {
	    src: media,
	    alt: "preview",
	    className: "uin-ba-image"
	  }), !preview && /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon large sc"
	  }), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-ba-buttonwrapper"
	  }, /*#__PURE__*/_react["default"].createElement("button", {
	    className: "uin-ba-button download",
	    onClick: download
	  }, /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon download"
	  })), preview && /*#__PURE__*/_react["default"].createElement("button", {
	    className: "uin-ba-button preview",
	    onClick: function onClick() {
	      return setOpenPreview(function (o) {
	        return !o;
	      });
	    }
	  }, /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon show"
	  }))), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-ba-mediaName-wrapper"
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-ba-mediaName"
	  }, mediaName))), /*#__PURE__*/_react["default"].createElement(_MediaViewer["default"], {
	    show: openPreview,
	    toggle: function toggle() {
	      return setOpenPreview(function (o) {
	        return !o;
	      });
	    },
	    multimediaFiles: [{
	      url: media,
	      mediaType: 'image'
	    }],
	    index: 0
	  }));
	};
	ButtonAttached.propTypes = {
	  media: _propTypes["default"].string,
	  mediaName: _propTypes["default"].string
	};
	var _default = exports["default"] = ButtonAttached;

/***/ },
/* 1396 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var _react = _interopRequireDefault(__webpack_require__(1));
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	var _reactI18next = __webpack_require__(41);
	var _formatters = __webpack_require__(83);
	var _types = __webpack_require__(60);
	__webpack_require__(2473);
	var _ImageIcon = _interopRequireDefault(__webpack_require__(167));
	var _Stopwatch = _interopRequireDefault(__webpack_require__(145));
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	var ChatItem = function ChatItem(_ref) {
	  var id = _ref.id,
	    type = _ref.type,
	    user = _ref.user,
	    text = _ref.text,
	    unread = _ref.unread,
	    date = _ref.date,
	    campaign = _ref.campaign,
	    active = _ref.active,
	    timeUnattended = _ref.timeUnattended,
	    onClick = _ref.onClick,
	    typeMedia = _ref.typeMedia,
	    warning = _ref.warning,
	    disabledStopwatch = _ref.disabledStopwatch,
	    timeoutReached = _ref.timeoutReached;
	  var _useTranslation = (0, _reactI18next.useTranslation)('commons'),
	    t = _useTranslation.t,
	    i18n = _useTranslation.i18n;
	  var lang = i18n.language.slice(0, 2);
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    id: id,
	    className: "uin-list-item uin-chat-item ".concat(active ? 'active' : '', " ").concat(timeoutReached ? 'timeoutReached' : '', " "),
	    onClick: onClick
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-lic-bar"
	  }), unread > 0 && !active && /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-lic-dot"
	  }), /*#__PURE__*/_react["default"].createElement(_ImageIcon["default"], {
	    type: campaign.type,
	    name: campaign.name,
	    image: campaign.graphicId
	  }), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-ci-body"
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-ci-info"
	  }, /*#__PURE__*/_react["default"].createElement("p", {
	    className: "uin-ci-user c100"
	  }, user), timeUnattended !== null && /*#__PURE__*/_react["default"].createElement("div", {
	    className: 'uin-lic-timeout ' + (warning ? 'warning' : '')
	  }, /*#__PURE__*/_react["default"].createElement(_Stopwatch["default"], {
	    initialTime: timeUnattended,
	    disabled: disabledStopwatch
	  })), /*#__PURE__*/_react["default"].createElement("time", {
	    className: "c600",
	    dateTime: date
	  }, (0, _formatters.formatTimeShort)(date, lang)), /*#__PURE__*/_react["default"].createElement("div", {
	    className: 'uin-ci-unread' + (typeof unread === 'boolean' || unread <= 0 ? ' hidden' : '')
	  }, (unread > 9 ? '+' : '') + Math.min(unread, 9)), /*#__PURE__*/_react["default"].createElement("i", {
	    className: 'gcl-icon ' + type.toLowerCase() + ' uin-lic-icon'
	  })), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-ci-preview c500"
	  }, typeMedia !== 'text' && typeMedia !== 'template' ? typeMedia === 'unsupported' ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon warning"
	  }), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-ci-text"
	  }, t('whatsapp:unsupported'))) : typeMedia === 'image' ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon image"
	  }), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-ci-text"
	  }, t('whatsapp:image'))) : typeMedia === 'video' ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon video-camera"
	  }), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-ci-text"
	  }, t('whatsapp:video'))) : typeMedia === 'audio' ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon headset"
	  }), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-ci-text"
	  }, t('whatsapp:audio'))) : typeMedia === 'file' ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon document"
	  }), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-ci-text"
	  }, t('whatsapp:file'))) : /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-ci-text"
	  }, typeMedia) : text ? /*#__PURE__*/_react["default"].createElement("span", {
	    className: "uin-ci-text"
	  }, text) : /*#__PURE__*/_react["default"].createElement("em", {
	    className: "uin-lic-new-ph"
	  }, t('new-convo')))));
	};
	ChatItem.propTypes = {
	  id: _propTypes["default"].number,
	  user: _propTypes["default"].string.isRequired,
	  campaign: _types.campaignType.isRequired,
	  text: _propTypes["default"].string,
	  unread: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].number]),
	  date: _propTypes["default"].instanceOf(Date).isRequired,
	  active: _propTypes["default"].bool,
	  typing: _propTypes["default"].bool,
	  timeUnattended: _propTypes["default"].instanceOf(Date),
	  warning: _propTypes["default"].bool,
	  onClick: _propTypes["default"].func.isRequired,
	  timeoutReached: _propTypes["default"].bool,
	  disabledStopwatch: _propTypes["default"].bool
	};
	ChatItem.defaultProps = {
	  unread: false,
	  timeUnattended: null,
	  disabledStopwatch: false,
	  typeMedia: 'text'
	};
	var _default = exports["default"] = ChatItem;

/***/ },
/* 1397 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var _react = _interopRequireDefault(__webpack_require__(1));
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	var _reactI18next = __webpack_require__(41);
	var _formatters = __webpack_require__(83);
	var _types = __webpack_require__(60);
	var _ImageIcon = _interopRequireDefault(__webpack_require__(167));
	var _Stopwatch = _interopRequireDefault(__webpack_require__(145));
	var _TypingIndicator = _interopRequireDefault(__webpack_require__(592));
	__webpack_require__(2474);
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	var ChatListItem = function ChatListItem(_ref) {
	  var id = _ref.id,
	    user = _ref.user,
	    text = _ref.text,
	    unread = _ref.unread,
	    date = _ref.date,
	    campaign = _ref.campaign,
	    active = _ref.active,
	    typing = _ref.typing,
	    timeUnattended = _ref.timeUnattended,
	    warning = _ref.warning,
	    onClick = _ref.onClick,
	    typeMedia = _ref.typeMedia;
	  var _useTranslation = (0, _reactI18next.useTranslation)('commons'),
	    t = _useTranslation.t,
	    i18n = _useTranslation.i18n;
	  var lang = i18n.language.slice(0, 2);
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    id: id,
	    className: "uin-list-item uin-chat-list-item ".concat(active ? 'active' : '', " ").concat(warning ? 'warning' : ''),
	    onClick: onClick
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-lic-bar"
	  }), unread > 0 && !active && /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-lic-dot"
	  }), /*#__PURE__*/_react["default"].createElement(_ImageIcon["default"], {
	    name: campaign.name,
	    image: campaign.image
	  }), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-cli-body"
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-cli-info"
	  }, /*#__PURE__*/_react["default"].createElement("p", {
	    className: "uin-cli-user c100"
	  }, user), timeUnattended !== null && /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-lic-timeout"
	  }, /*#__PURE__*/_react["default"].createElement(_Stopwatch["default"], {
	    initialTime: timeUnattended
	  })), /*#__PURE__*/_react["default"].createElement("time", {
	    className: "c600",
	    dateTime: date
	  }, (0, _formatters.formatTimeOrDateShort)(date, lang)), /*#__PURE__*/_react["default"].createElement("div", {
	    className: 'uin-cli-unread' + (typeof unread === 'boolean' || unread <= 0 ? ' hidden' : '')
	  }, (unread > 9 ? '+' : '') + Math.min(unread, 9)), /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon chat uin-lic-icon"
	  })), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-cli-preview c500"
	  }, typing ? /*#__PURE__*/_react["default"].createElement(_TypingIndicator["default"], {
	    small: true
	  }) : typeMedia === 'image' ? /*#__PURE__*/_react["default"].createElement("div", {
	    className: "multimediaIcon"
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "chat-text-icon"
	  }, /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon image"
	  })), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "chat-text"
	  }, t('whatsapp:image'))) : text || /*#__PURE__*/_react["default"].createElement("em", {
	    className: "uin-lic-new-ph"
	  }, t('new-convo')))));
	};
	ChatListItem.propTypes = {
	  id: _propTypes["default"].number,
	  user: _propTypes["default"].string.isRequired,
	  campaign: _types.campaignType.isRequired,
	  text: _propTypes["default"].string,
	  unread: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].number]),
	  date: _propTypes["default"].instanceOf(Date).isRequired,
	  active: _propTypes["default"].bool,
	  typing: _propTypes["default"].bool,
	  timeUnattended: _propTypes["default"].instanceOf(Date),
	  warning: _propTypes["default"].bool,
	  onClick: _propTypes["default"].func.isRequired
	};
	ChatListItem.defaultProps = {
	  unread: false,
	  timeUnattended: null
	};
	var _default = exports["default"] = ChatListItem;

/***/ },
/* 1398 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var _react = _interopRequireWildcard(__webpack_require__(1));
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	var _reactI18next = __webpack_require__(41);
	var _globalComponentsLibrary = __webpack_require__(28);
	var _types = __webpack_require__(60);
	var _constants = __webpack_require__(58);
	var _Stopwatch = _interopRequireDefault(__webpack_require__(145));
	var _ContactData = _interopRequireDefault(__webpack_require__(593));
	var _helpers = __webpack_require__(53);
	__webpack_require__(2475);
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
	function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	var ConversationHeader = function ConversationHeader(_ref) {
	  var type = _ref.type,
	    _ref$contact = _ref.contact,
	    _ref$contact2 = _ref$contact === void 0 ? {} : _ref$contact,
	    image = _ref$contact2.image,
	    name = _ref$contact2.name,
	    account = _ref$contact2.account,
	    subject = _ref.subject,
	    initialTime = _ref.initialTime,
	    onViewContact = _ref.onViewContact,
	    onFinish = _ref.onFinish,
	    onUnassign = _ref.onUnassign,
	    onSpam = _ref.onSpam,
	    onDiscard = _ref.onDiscard,
	    chatStarted = _ref.chatStarted,
	    timeoutReached = _ref.timeoutReached,
	    onDialog = _ref.onDialog,
	    disabledActions = _ref.disabledActions;
	  var _useState = (0, _react.useState)(false),
	    _useState2 = _slicedToArray(_useState, 2),
	    isDialogOpen = _useState2[0],
	    setDialogOpen = _useState2[1];
	  var dialogData = (0, _react.useRef)({});
	  var _useTranslation = (0, _reactI18next.useTranslation)(['header', 'commons']),
	    t = _useTranslation.t;
	  (0, _react.useEffect)(function () {
	    if (timeoutReached && chatStarted) {
	      setTimeout(function () {
	        onDialog && onDialog();
	        setTimeout(function () {
	          onFinish();
	        }, 500);
	      }, 500);
	    }
	  }, [timeoutReached, chatStarted]);
	  var openDialog = function openDialog(action, type) {
	    dialogData.current = {
	      action: action,
	      type: type
	    };
	    setDialogOpen(true);
	  };
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-conv-header"
	  }, type === 'MAIL' ? /*#__PURE__*/_react["default"].createElement("h6", {
	    className: "uin-conv-subject"
	  }, subject) : /*#__PURE__*/_react["default"].createElement(_ContactData["default"], {
	    image: image,
	    name: name,
	    account: account
	  }), initialTime != null && /*#__PURE__*/_react["default"].createElement("span", {
	    className: "uin-conv-time"
	  }, t('time'), ":", (0, _helpers.isNewMedia)(type) && !chatStarted ? /*#__PURE__*/_react["default"].createElement("b", null, "00:00") : /*#__PURE__*/_react["default"].createElement("b", null, /*#__PURE__*/_react["default"].createElement(_Stopwatch["default"], {
	    initialTime: initialTime
	  }))), (!(0, _helpers.isNewMedia)(type) ? true : (0, _helpers.isNewMedia)(type) && chatStarted) && /*#__PURE__*/_react["default"].createElement(_globalComponentsLibrary.DropDownMenu, {
	    disabled: disabledActions
	  }, onViewContact && /*#__PURE__*/_react["default"].createElement(_globalComponentsLibrary.Option, {
	    onClick: onViewContact
	  }, t('view-contact.action')), onFinish && /*#__PURE__*/_react["default"].createElement(_globalComponentsLibrary.Option, {
	    onClick: function onClick() {
	      return openDialog(onFinish, 'finish');
	    }
	  }, t('finish.action')), onUnassign && /*#__PURE__*/_react["default"].createElement(_globalComponentsLibrary.Option, {
	    onClick: function onClick() {
	      return openDialog(onUnassign, 'unassign');
	    }
	  }, t('unassign.action')), onSpam && /*#__PURE__*/_react["default"].createElement(_globalComponentsLibrary.Option, {
	    onClick: function onClick() {
	      return openDialog(onSpam, 'spam');
	    }
	  }, t('spam.action')), onDiscard && /*#__PURE__*/_react["default"].createElement(_globalComponentsLibrary.Option, {
	    onClick: function onClick() {
	      return openDialog(onDiscard, 'discard');
	    }
	  }, t('discard.action'))), /*#__PURE__*/_react["default"].createElement(_globalComponentsLibrary.DialogBox, {
	    show: isDialogOpen,
	    toggle: function toggle() {
	      return setDialogOpen(!isDialogOpen);
	    },
	    onAccept: dialogData.current.action,
	    title: t(dialogData.current.type + '.title'),
	    content: t(dialogData.current.type + '.content'),
	    accept: t(dialogData.current.type + '.commit'),
	    cancel: t('commons:cancel')
	  }));
	};
	ConversationHeader.propTypes = {
	  conversationId: _propTypes["default"].number,
	  type: _propTypes["default"].oneOf(Object.values(_constants.TABS)),
	  contact: _propTypes["default"].shape({
	    image: _propTypes["default"].element,
	    name: _propTypes["default"].string,
	    account: _propTypes["default"].string
	  }),
	  subject: _propTypes["default"].string,
	  initialTime: _propTypes["default"].object,
	  onFinish: _propTypes["default"].func,
	  onUnassign: _propTypes["default"].func,
	  onSpam: _propTypes["default"].func,
	  onDiscard: _propTypes["default"].func
	};
	ConversationHeader.defaultProps = {
	  type: _constants.TABS.HOME
	};
	var _default = exports["default"] = ConversationHeader;

/***/ },
/* 1399 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var _react = _interopRequireWildcard(__webpack_require__(1));
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	var _reactI18next = __webpack_require__(41);
	var _types = __webpack_require__(60);
	var _constants = __webpack_require__(58);
	var _helpers = __webpack_require__(53);
	var _TwitterListItem = _interopRequireDefault(__webpack_require__(1427));
	var _ChatListItem = _interopRequireDefault(__webpack_require__(1397));
	var _ChatItem = _interopRequireDefault(__webpack_require__(1396));
	var _MailListItem = _interopRequireDefault(__webpack_require__(1415));
	var _emptyPlaceholder = _interopRequireDefault(__webpack_require__(2514));
	__webpack_require__(2476);
	var _excluded = ["showType", "conversations", "unattendedTimes", "warnings", "selected", "onSelect"],
	  _excluded2 = ["selected", "onSelect", "activeMessageId", "onSelectMessage", "type", "messages", "unreadMessage", "contact", "initialTime", "warning", "disabledActions"];
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
	function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	var ConversationList = function ConversationList(_ref) {
	  var showType = _ref.showType,
	    _ref$conversations = _ref.conversations,
	    conversations = _ref$conversations === void 0 ? [] : _ref$conversations,
	    unattendedTimes = _ref.unattendedTimes,
	    warnings = _ref.warnings,
	    selected = _ref.selected,
	    _onSelect = _ref.onSelect,
	    msgProps = _objectWithoutProperties(_ref, _excluded);
	  var _useTranslation = (0, _reactI18next.useTranslation)(['list', 'commons']),
	    t = _useTranslation.t;
	  var _useState = (0, _react.useState)(conversations),
	    _useState2 = _slicedToArray(_useState, 2),
	    filteredConversations = _useState2[0],
	    setFiltered = _useState2[1];
	  (0, _react.useEffect)(function () {
	    setFiltered(conversations.filter(function (conversation) {
	      return showType === _constants.TABS.HOME || conversation.type === showType;
	    }));
	  }, [conversations, showType]);
	  var emptyPlaceholder = function emptyPlaceholder() {
	    return /*#__PURE__*/_react["default"].createElement("div", {
	      className: "uin-empty"
	    }, /*#__PURE__*/_react["default"].createElement("div", {
	      className: "uin-empty-image"
	    }, /*#__PURE__*/_react["default"].createElement("img", {
	      src: _emptyPlaceholder["default"],
	      alt: "Empty placeholder"
	    })), /*#__PURE__*/_react["default"].createElement("p", {
	      className: "uin-empty-message"
	    }, t('no-conv')));
	  };
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-conv-list"
	  }, filteredConversations.length === 0 ? emptyPlaceholder() : filteredConversations.map(function (conversation) {
	    return /*#__PURE__*/_react["default"].createElement(ListItem, _extends({
	      key: conversation.campType + '-' + conversation.id,
	      selected: conversation.id === selected.convId && conversation.campType === selected.campType,
	      onSelect: function onSelect() {
	        return _onSelect(conversation.campType, conversation.id);
	      },
	      timeUnattended: unattendedTimes[conversation.campType][conversation.id],
	      warning: warnings[conversation.campType][conversation.id]
	    }, msgProps, conversation));
	  }));
	};
	var ListItem = function ListItem(_ref2) {
	  var selected = _ref2.selected,
	    onSelect = _ref2.onSelect,
	    activeMessageId = _ref2.activeMessageId,
	    onSelectMessage = _ref2.onSelectMessage,
	    type = _ref2.type,
	    _ref2$messages = _ref2.messages,
	    messages = _ref2$messages === void 0 ? [] : _ref2$messages,
	    unreadMessage = _ref2.unreadMessage,
	    contact = _ref2.contact,
	    initialTime = _ref2.initialTime,
	    warning = _ref2.warning,
	    disabledActions = _ref2.disabledActions,
	    props = _objectWithoutProperties(_ref2, _excluded2);
	  var isNewConversation = messages.length === 0;
	  var _ref3 = messages[0] || {},
	    media = _ref3.media,
	    subject = _ref3.subject,
	    fcontent = _ref3.content;
	  var _ref4 = messages[messages.length - 1] || {},
	    ldate = _ref4.date,
	    lcontent = _ref4.content;
	  var typeMedia = messages && messages[messages.length - 1] && messages[messages.length - 1].type ? messages[messages.length - 1].type : 'text';
	  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, type === _constants.TABS.TWITTER ? /*#__PURE__*/_react["default"].createElement(_TwitterListItem["default"], _extends({
	    active: selected,
	    contact: contact,
	    date: initialTime,
	    media: media,
	    text: fcontent,
	    unread: isNewConversation || (0, _helpers.hasUnread)(messages),
	    onClick: onSelect
	  }, props)) : type === _constants.TABS.MAIL ? /*#__PURE__*/_react["default"].createElement(_MailListItem["default"], _extends({
	    active: selected,
	    unread: isNewConversation || (0, _helpers.hasUnread)(messages),
	    contact: contact,
	    date: initialTime,
	    subject: subject,
	    mails: messages,
	    activeMail: activeMessageId,
	    onClick: onSelect,
	    onMailClick: onSelectMessage
	  }, props)) : type === _constants.TABS.CHAT ? /*#__PURE__*/_react["default"].createElement(_ChatListItem["default"], _extends({
	    active: selected,
	    user: contact.name,
	    date: ldate || initialTime,
	    text: lcontent,
	    unread: isNewConversation || (0, _helpers.countUnread)(messages),
	    onClick: onSelect,
	    typeMedia: typeMedia
	  }, props)) : /*#__PURE__*/_react["default"].createElement(_ChatItem["default"], _extends({
	    active: selected,
	    user: contact.name,
	    date: ldate || initialTime,
	    text: lcontent,
	    unread: isNewConversation || unreadMessage,
	    onClick: onSelect,
	    type: type,
	    typeMedia: typeMedia,
	    warning: warning,
	    disabledStopwatch: disabledActions
	  }, props)));
	};
	ConversationList.propTypes = {
	  showType: _propTypes["default"].string.isRequired,
	  conversations: _propTypes["default"].arrayOf(_types.conversationType),
	  unattendedTimes: _propTypes["default"].object,
	  warnings: _propTypes["default"].object,
	  selectedId: _propTypes["default"].number,
	  onSelect: _propTypes["default"].func,
	  activeMessageId: _propTypes["default"].number,
	  onSelectMessage: _propTypes["default"].func
	};
	ConversationList.defaultProps = {
	  unattendedTimes: {},
	  warnings: {}
	};
	var _default = exports["default"] = ConversationList;

/***/ },
/* 1400 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.TemplateItem = void 0;
	var _react = _interopRequireWildcard(__webpack_require__(1));
	var _reactstrap = __webpack_require__(70);
	var _reactI18next = __webpack_require__(41);
	var _globalComponentsLibrary = __webpack_require__(28);
	var _MessageInput = _interopRequireDefault(__webpack_require__(1434));
	var _IconButton = _interopRequireDefault(__webpack_require__(257));
	var _formatters = __webpack_require__(83);
	var _FileSlider = _interopRequireDefault(__webpack_require__(1417));
	var _RecordButton = _interopRequireDefault(__webpack_require__(1421));
	__webpack_require__(2477);
	var _hooks = __webpack_require__(168);
	var _lodash = __webpack_require__(293);
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
	function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
	function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
	function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
	function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
	function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
	var replaceTemplatesData = function replaceTemplatesData(templates, contact, t, agent) {
	  var date = new Date();
	  var currentHr = date.getHours();
	  var typeofGreeting = '';
	  if (currentHr < 12) {
	    typeofGreeting = 'morning';
	  } else if (currentHr < 18) {
	    typeofGreeting = 'afternoon';
	  } else {
	    typeofGreeting = 'night';
	  }
	  return templates ? templates.map(function (template) {
	    return _objectSpread(_objectSpread({}, template), {}, {
	      text: template.text.replace('%var1%', (0, _formatters.formatDateLong)(date)).replace('%var2%', t('time')).replace('%var3%', agent.username).replace('%var4%', agent.name).replace('%var5%', t("greetings.".concat(typeofGreeting))).replace('%var6%', contact.name)
	    });
	  }) : [];
	};
	var ChatFooter = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
	  var templates = _ref.templates,
	    disabled = _ref.disabled,
	    onSendResponse = _ref.onSendResponse,
	    contact = _ref.contact,
	    agent = _ref.agent,
	    media = _ref.media,
	    mediaType = _ref.mediaType,
	    selectedAttachment = _ref.selectedAttachment,
	    onSelectAttachment = _ref.onSelectAttachment,
	    onDeleteAttachment = _ref.onDeleteAttachment,
	    onUploadAttachments = _ref.onUploadAttachments,
	    onLoading = _ref.onLoading,
	    maxImgToSend = _ref.maxImgToSend,
	    onDialog = _ref.onDialog;
	  var _useTranslation = (0, _reactI18next.useTranslation)(['chat', 'mail-editor']),
	    t = _useTranslation.t;
	  var formattedTemplates = replaceTemplatesData(templates, contact, t, agent);
	  var _useState = (0, _react.useState)(''),
	    _useState2 = _slicedToArray(_useState, 2),
	    response = _useState2[0],
	    setResponse = _useState2[1];
	  var _useError = (0, _hooks.useError)(),
	    _useError2 = _slicedToArray(_useError, 3),
	    error = _useError2[0],
	    showError = _useError2[1],
	    toggleError = _useError2[2];
	  var areaRef = (0, _react.useRef)();
	  var inputRef = (0, _react.useRef)();
	  (0, _react.useImperativeHandle)(ref, function () {
	    return {
	      focus: function focus() {
	        areaRef.current.focus();
	      }
	    };
	  });
	  var handleSend = function handleSend() {
	    if (response.length > 0) {
	      onSendResponse(response);
	      setResponse('');
	    }
	    if (media.length > 0) {
	      onSendResponse(media);
	      // setAttachment([]);
	    }
	  };
	
	  (0, _react.useEffect)(function () {
	    if (response.includes('[Time]') || response.includes('[Hora]')) {
	      setResponse(response.replace('[Time]', (0, _formatters.formatTimeLong)(new Date())).replace('[Hora]', (0, _formatters.formatTimeLong)(new Date())));
	    }
	  }, [response]);
	  var _useState3 = (0, _react.useState)([]),
	    _useState4 = _slicedToArray(_useState3, 2),
	    filtered = _useState4[0],
	    setFiltered = _useState4[1];
	  var onDeleteAttachmentHandle = function onDeleteAttachmentHandle(current) {
	    onDeleteAttachment(current.url);
	  };
	  var getFiles = (0, _hooks.useFileHandler)(mediaType, maxImgToSend, showError);
	  var onAttachFile = function onAttachFile(e) {
	    if (e.target && (0, _lodash.size)(e.target.files) > 0) {
	      onLoading(true);
	      try {
	        onUploadAttachments(getFiles(e.target.files));
	        inputRef.current.value = '';
	      } catch (err) {
	        console.error(err);
	        onLoading(false);
	      }
	    }
	  };
	  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-chat-footer"
	  }, !media || media.length === 0 ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
	    icon: "list",
	    large: true,
	    id: "uin-templates-icon",
	    disabled: disabled
	  }), /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
	    target: "uin-templates-icon"
	  }, t('templates')), /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledPopover, {
	    disabled: disabled,
	    className: "uin-templates-popover",
	    target: "uin-templates-icon",
	    placement: "top-start",
	    fade: false,
	    trigger: "legacy"
	  }, /*#__PURE__*/_react["default"].createElement(_reactstrap.PopoverHeader, null, /*#__PURE__*/_react["default"].createElement("span", null, t('templates')), /*#__PURE__*/_react["default"].createElement(_globalComponentsLibrary.FilterInput, {
	    placeholder: t('search-placeholder'),
	    data: formattedTemplates,
	    filterBy: ['title', 'text'],
	    onChange: setFiltered,
	    ignoreCase: true
	  })), /*#__PURE__*/_react["default"].createElement(_reactstrap.PopoverBody, null, filtered.map(function (template, i) {
	    return /*#__PURE__*/_react["default"].createElement(TemplateItem, _extends({
	      key: i,
	      tabIndex: i + 1
	    }, template, {
	      onClick: function onClick() {
	        return setResponse(template.text);
	      }
	    }));
	  }))), /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
	    secondary: true,
	    large: true,
	    icon: "clip-right",
	    id: "uin-attach-btn",
	    disabled: disabled,
	    onClick: function onClick() {
	      inputRef.current.click();
	    }
	  }), /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
	    target: "uin-attach-btn",
	    innerClassName: "long"
	  }, /*#__PURE__*/_react["default"].createElement("p", null, t('mail-editor:attach'))), /*#__PURE__*/_react["default"].createElement("input", {
	    type: "file",
	    multiple: true,
	    className: "input",
	    ref: inputRef,
	    onChange: onAttachFile
	  }), /*#__PURE__*/_react["default"].createElement(_MessageInput["default"], {
	    onFocus: onDialog,
	    ref: areaRef,
	    disabled: disabled,
	    maxChars: 500,
	    value: response,
	    onChange: setResponse,
	    onEnter: handleSend,
	    placeholder: t('response-placeholder')
	  })) : /*#__PURE__*/_react["default"].createElement(_FileSlider["default"], {
	    media: media,
	    selected: selectedAttachment,
	    onSelect: onSelectAttachment,
	    onDeleteAttachment: onDeleteAttachmentHandle,
	    onUploadAttachments: onUploadAttachments,
	    mediaType: mediaType,
	    maxImgToSend: maxImgToSend
	  }), response.length > 0 || media.length > 0 ? /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
	    icon: "send",
	    large: true,
	    id: "uin-send-btn",
	    onClick: handleSend,
	    disabled: disabled
	  }) : /*#__PURE__*/_react["default"].createElement(_RecordButton["default"], {
	    disabled: disabled,
	    onAudioURL: onUploadAttachments
	  })), response.length > 0 && /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
	    target: "uin-send-btn",
	    innerClassName: "long"
	  }, /*#__PURE__*/_react["default"].createElement("p", null, t('send-enter')), /*#__PURE__*/_react["default"].createElement("p", null, t('newline-enter'))), /*#__PURE__*/_react["default"].createElement(_globalComponentsLibrary.DialogBox, _extends({}, error, {
	    toggle: toggleError,
	    accept: t('errorFormat.attachErrorCommit')
	  })));
	});
	var TemplateItem = exports.TemplateItem = function TemplateItem(_ref2) {
	  var title = _ref2.title,
	    text = _ref2.text,
	    onClick = _ref2.onClick,
	    tabIndex = _ref2.tabIndex;
	  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-template-item",
	    tabIndex: tabIndex,
	    onClick: onClick,
	    id: 'uin-template-item-' + tabIndex
	  }, /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon text"
	  }), /*#__PURE__*/_react["default"].createElement("section", {
	    className: "uin-template-content"
	  }, /*#__PURE__*/_react["default"].createElement("header", null, title), /*#__PURE__*/_react["default"].createElement("p", null, text))), text.length > 30 && /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
	    target: 'uin-template-item-' + tabIndex,
	    delay: {
	      show: 400,
	      hide: 50
	    },
	    boundariesElement: "window"
	  }, text));
	};
	ChatFooter.defaultProps = {
	  media: []
	};
	var _default = exports["default"] = ChatFooter;

/***/ },
/* 1401 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var _react = _interopRequireDefault(__webpack_require__(1));
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	var _reactI18next = __webpack_require__(41);
	var _helpers = __webpack_require__(53);
	var _constants = __webpack_require__(58);
	var _formatters = __webpack_require__(83);
	var _TypingIndicator = _interopRequireDefault(__webpack_require__(592));
	var _classnames = _interopRequireDefault(__webpack_require__(119));
	var _reactstrap = __webpack_require__(70);
	var _GroupingImages = _interopRequireDefault(__webpack_require__(1411));
	var _VideoMessage = _interopRequireDefault(__webpack_require__(1422));
	var _AudiosMessage = _interopRequireDefault(__webpack_require__(1419));
	var _FileMessage = _interopRequireDefault(__webpack_require__(1420));
	__webpack_require__(2478);
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
	var urlFormat = function urlFormat(url, source) {
	  url = Array.isArray(url) ? url.map(function (i) {
	    return (0, _helpers.urlFormatHelper)(i, source);
	  }) : (0, _helpers.urlFormatHelper)(url, source);
	  return url;
	};
	var WhatsAppIconStatus = function WhatsAppIconStatus(_ref) {
	  var status = _ref.status,
	    messageId = _ref.messageId;
	  var _useTranslation = (0, _reactI18next.useTranslation)(),
	    t = _useTranslation.t;
	  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
	    id: "t".concat(messageId),
	    className: 'uin-chat-content-icon ' + status
	  }, status !== 'sending' && /*#__PURE__*/_react["default"].createElement("i", {
	    className: 'gcl-icon ' + (status === 'error' || status === 'rejected' ? 'error' : (0, _helpers.cheksWhatsApp)(status))
	  })), messageId && status === 'rejected' && /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
	    target: "t".concat(messageId)
	  }, t('whatsapp:rejectedMessage')));
	};
	var ChatBubble = function ChatBubble(_ref2) {
	  var status = _ref2.status,
	    source = _ref2.source,
	    type = _ref2.type,
	    children = _ref2.children,
	    messageId = _ref2.messageId;
	  var showStatus = function showStatus() {
	    return (0, _helpers.isNewMedia)(type) && (source === _constants.MSG_SOURCE.AGENT || source === _constants.MSG_SOURCE.ADMIN);
	  };
	  var whatsAppStatus = function whatsAppStatus() {
	    return showStatus() && /*#__PURE__*/_react["default"].createElement("div", {
	      className: "uin-whatsapp-status"
	    }, /*#__PURE__*/_react["default"].createElement(WhatsAppIconStatus, {
	      status: status,
	      messageId: messageId
	    }));
	  };
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-chat-bubble"
	  }, status === 'sending' && showStatus() && /*#__PURE__*/_react["default"].createElement(_reactstrap.Spinner, {
	    size: "sm",
	    color: "primary",
	    className: "loadIcon"
	  }), children, whatsAppStatus());
	};
	var ImageGrouping = function ImageGrouping(_ref3) {
	  var status = _ref3.status,
	    source = _ref3.source,
	    type = _ref3.type,
	    attachments = _ref3.attachments,
	    messageIds = _ref3.messageIds;
	  var _useTranslation2 = (0, _reactI18next.useTranslation)(),
	    t = _useTranslation2.t;
	  return attachments.reduce(function (acc, att) {
	    if (!att.url) return [].concat(_toConsumableArray(acc), [{
	      unavailable: true
	    }]);else {
	      if (!acc[acc.length - 1] || !acc[acc.length - 1].attachments || att.caption) acc.push({
	        attachments: []
	      });
	      acc[acc.length - 1].attachments.push(att);
	      return acc;
	    }
	  }, []).map(function (group, i) {
	    return group.unavailable ? /*#__PURE__*/_react["default"].createElement(ChatBubble, {
	      key: i,
	      status: status,
	      source: source,
	      type: type,
	      messageId: messageIds[i]
	    }, /*#__PURE__*/_react["default"].createElement("div", {
	      className: "uin-chat-text error"
	    }, /*#__PURE__*/_react["default"].createElement("i", {
	      className: "gcl-icon warning"
	    }), /*#__PURE__*/_react["default"].createElement("div", {
	      className: "uin-chat-text-link"
	    }, t('whatsapp:notAvailable')))) : /*#__PURE__*/_react["default"].createElement(ChatBubble, {
	      key: i,
	      status: status,
	      source: source,
	      type: type,
	      messageId: messageIds[i]
	    }, /*#__PURE__*/_react["default"].createElement("div", {
	      className: "uin-chat-image"
	    }, /*#__PURE__*/_react["default"].createElement(_GroupingImages["default"], {
	      arr: urlFormat(group.attachments.map(function (a) {
	        return a.url;
	      }), source)
	    }), group.attachments[0].caption && /*#__PURE__*/_react["default"].createElement("span", {
	      className: "uin-chat-image-caption"
	    }, (0, _helpers.linebreaks)((0, _helpers.linkify)(group.attachments[0].caption)))));
	  });
	};
	var ChatMessage = function ChatMessage(_ref4) {
	  var source = _ref4.source,
	    image = _ref4.image,
	    typing = _ref4.typing,
	    content = _ref4.content,
	    status = _ref4.status,
	    date = _ref4.date,
	    disabled = _ref4.disabled,
	    type = _ref4.type,
	    speedSelected = _ref4.speedSelected,
	    changeSpeed = _ref4.changeSpeed,
	    setCurrentAudio = _ref4.setCurrentAudio,
	    currentAudio = _ref4.currentAudio,
	    fromAgent = _ref4.fromAgent,
	    isEnableHistoricalChat = _ref4.isEnableHistoricalChat;
	  var _useTranslation3 = (0, _reactI18next.useTranslation)(['commons', 'whatsapp']),
	    t = _useTranslation3.t;
	  var classes = (0, _classnames["default"])({
	    disabled: disabled,
	    response: source !== _constants.MSG_SOURCE.USER,
	    admin: source === _constants.MSG_SOURCE.ADMIN,
	    coaching: source === _constants.MSG_SOURCE.COACH
	  });
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: 'uin-chat-message ' + classes
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-chat-wrapper"
	  }, /*#__PURE__*/_react["default"].createElement("span", {
	    className: "uin-chat-time"
	  }, (source === _constants.MSG_SOURCE.ADMIN || source === _constants.MSG_SOURCE.COACH) && /*#__PURE__*/_react["default"].createElement("span", {
	    id: 'uin-chat-msg-vis-' + source.charAt(0),
	    className: "uin-chat-label"
	  }, t('admin')), isEnableHistoricalChat && source === _constants.MSG_SOURCE.AGENT && /*#__PURE__*/_react["default"].createElement("span", {
	    className: "uin-chat-label"
	  }, fromAgent), !typing && /*#__PURE__*/_react["default"].createElement("time", {
	    dateTime: date == null ? new Date() : date
	  }, (0, _formatters.formatTimeShort)(date == null ? new Date() : date))), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-chat-content"
	  }, source === _constants.MSG_SOURCE.USER && image, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-chat-body"
	  }, typing ? /*#__PURE__*/_react["default"].createElement(_TypingIndicator["default"], {
	    contained: true
	  }) : content.map(function (c, i) {
	    return c.type === 'text' || c.type === 'template' ? c.texts.map(function (text, j) {
	      return /*#__PURE__*/_react["default"].createElement(ChatBubble, {
	        id: i + '-' + j,
	        key: i + '-' + j,
	        status: c.status || status,
	        source: source,
	        type: type,
	        messageId: c.messageIds[j]
	      }, /*#__PURE__*/_react["default"].createElement("div", {
	        className: "uin-chat-text"
	      }, (0, _helpers.linebreaks)((0, _helpers.linkify)(text))));
	    }) : c.type === 'unsupported' ? /*#__PURE__*/_react["default"].createElement(ChatBubble, {
	      key: i,
	      status: c.status || status,
	      source: source,
	      type: type,
	      messageId: c.messageIds[i]
	    }, /*#__PURE__*/_react["default"].createElement("div", {
	      className: "uin-chat-text error"
	    }, /*#__PURE__*/_react["default"].createElement("i", {
	      className: "gcl-icon warning"
	    }), /*#__PURE__*/_react["default"].createElement("div", {
	      className: "uin-chat-text-link"
	    }, t('whatsapp:unsupported')))) : !c.attachments || !Array.isArray(c.attachments) || c.attachments.length === 0 ? /*#__PURE__*/_react["default"].createElement(ChatBubble, {
	      key: i,
	      status: c.status || status,
	      source: source,
	      type: type,
	      messageId: c.messageIds[i]
	    }, /*#__PURE__*/_react["default"].createElement("div", {
	      className: "uin-chat-text error"
	    }, /*#__PURE__*/_react["default"].createElement("i", {
	      className: "gcl-icon warning"
	    }), /*#__PURE__*/_react["default"].createElement("div", {
	      className: "uin-chat-text-link"
	    }, t('whatsapp:notAvailable')))) : c.type === 'image' ? /*#__PURE__*/_react["default"].createElement(ImageGrouping, {
	      key: i,
	      status: c.status || status,
	      source: source,
	      type: type,
	      attachments: c.attachments,
	      messageIds: c.messageIds
	    }) : c.attachments.map(function (_ref5, j) {
	      var url = _ref5.url,
	        name = _ref5.name,
	        size = _ref5.size,
	        caption = _ref5.caption;
	      return /*#__PURE__*/_react["default"].createElement(ChatBubble, {
	        key: i + '-' + j,
	        status: c.status || status,
	        source: source,
	        type: type,
	        messageId: c.messageIds[i]
	      }, !url || !(0, _helpers.isValidURL)(urlFormat(url, source)) ? /*#__PURE__*/_react["default"].createElement("div", {
	        className: "uin-chat-text error"
	      }, /*#__PURE__*/_react["default"].createElement("i", {
	        className: "gcl-icon warning"
	      }), /*#__PURE__*/_react["default"].createElement("div", {
	        className: "uin-chat-text-link"
	      }, t('whatsapp:' + (!url ? 'notAvailable' : 'unsupported')))) : c.type === 'location' ? /*#__PURE__*/_react["default"].createElement("div", {
	        className: "uin-chat-text"
	      }, (0, _helpers.linebreaks)((0, _helpers.linkify)(url))) : /*#__PURE__*/_react["default"].createElement("div", {
	        className: "uin-chat-image"
	      }, c.type === 'video' ? /*#__PURE__*/_react["default"].createElement(_VideoMessage["default"], {
	        url: urlFormat(url, source)
	      }) : c.type === 'file' ? /*#__PURE__*/_react["default"].createElement(_FileMessage["default"], {
	        url: urlFormat(url, source),
	        size: size,
	        name: name
	      }) : c.type === 'audio' ? /*#__PURE__*/_react["default"].createElement(_AudiosMessage["default"], {
	        url: urlFormat(url, source),
	        changeSpeed: changeSpeed,
	        speedSelected: speedSelected,
	        image: image,
	        source: source,
	        currentAudio: currentAudio,
	        setCurrentAudio: setCurrentAudio,
	        disabled: disabled
	      }) : null, caption && /*#__PURE__*/_react["default"].createElement("span", {
	        className: "uin-chat-image-caption"
	      }, (0, _helpers.linebreaks)((0, _helpers.linkify)(caption)))));
	    });
	  })), (source === _constants.MSG_SOURCE.AGENT || source === _constants.MSG_SOURCE.ADMIN) && !(0, _helpers.isNewMedia)(type) && (status === 'delivered' ? /*#__PURE__*/_react["default"].createElement("i", {
	    id: "uin-chat-msg-dlr",
	    className: "gcl-icon selected"
	  }) : /*#__PURE__*/_react["default"].cloneElement(image, {
	    id: 'uin-chat-msg-rd'
	  })))));
	};
	ChatMessage.propTypes = {
	  source: _propTypes["default"].oneOf(Object.values(_constants.MSG_SOURCE)),
	  typing: _propTypes["default"].bool,
	  content: _propTypes["default"].arrayOf(_propTypes["default"].object),
	  status: _propTypes["default"].string,
	  date: _propTypes["default"].instanceOf(Date),
	  disabled: _propTypes["default"].bool
	};
	ChatMessage.defaultProps = {
	  source: _constants.MSG_SOURCE.USER,
	  status: 'delivered'
	};
	var _default = exports["default"] = ChatMessage;

/***/ },
/* 1402 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var _react = _interopRequireWildcard(__webpack_require__(1));
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	var _reactstrap = __webpack_require__(70);
	var _reactI18next = __webpack_require__(41);
	var _dateFns = __webpack_require__(147);
	var _globalComponentsLibrary = __webpack_require__(28);
	var _types = __webpack_require__(60);
	var _constants = __webpack_require__(58);
	var _ChatMessage = _interopRequireDefault(__webpack_require__(1401));
	var _emptyChatPh = _interopRequireDefault(__webpack_require__(2513));
	var _NewMessageBar = _interopRequireDefault(__webpack_require__(1423));
	__webpack_require__(2479);
	var _helpers = __webpack_require__(53);
	var _ChatFooter = _interopRequireDefault(__webpack_require__(1400));
	var _DragAndDropFile = _interopRequireDefault(__webpack_require__(1410));
	var _MediaViewerAttachment = _interopRequireDefault(__webpack_require__(1416));
	var _hooks = __webpack_require__(168);
	var _DateDivider = _interopRequireDefault(__webpack_require__(1432));
	var _ReassignDivider = _interopRequireDefault(__webpack_require__(1435));
	var _ImageIcon = _interopRequireDefault(__webpack_require__(167));
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
	function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	var DisabledBanner = function DisabledBanner() {
	  var _useTranslation = (0, _reactI18next.useTranslation)(['chat', 'commons']),
	    t = _useTranslation.t;
	  var _useState = (0, _react.useState)(true),
	    _useState2 = _slicedToArray(_useState, 2),
	    open = _useState2[0],
	    setOpen = _useState2[1];
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: 'uin-chat-disabled-banner' + (open ? '' : ' hide')
	  }, /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon send-disabled large"
	  }), /*#__PURE__*/_react["default"].createElement("span", null, t('disabled')), /*#__PURE__*/_react["default"].createElement(_globalComponentsLibrary.Button, {
	    color: "tertiary",
	    onClick: function onClick() {
	      return setOpen(false);
	    }
	  }, t('commons:ok')));
	};
	var ChatView = function ChatView(_ref) {
	  var _ref$messages = _ref.messages,
	    messages = _ref$messages === void 0 ? [] : _ref$messages,
	    type = _ref.type,
	    userImage = _ref.userImage,
	    typing = _ref.typing,
	    templates = _ref.templates,
	    disabled = _ref.disabled,
	    disabledActions = _ref.disabledActions,
	    onSendResponse = _ref.onSendResponse,
	    lang = _ref.lang,
	    contact = _ref.contact,
	    agent = _ref.agent,
	    onAceptedChat = _ref.onAceptedChat,
	    onSpam = _ref.onSpam,
	    onUnassign = _ref.onUnassign,
	    onFinish = _ref.onFinish,
	    show = _ref.show,
	    onUploadAttachments = _ref.onUploadAttachments,
	    onDeleteAttachment = _ref.onDeleteAttachment,
	    setTheUrlOfAttachments = _ref.setTheUrlOfAttachments,
	    setStartConversation = _ref.setStartConversation,
	    startConversation = _ref.startConversation,
	    conversationId = _ref.conversationId,
	    onLoadMessages = _ref.onLoadMessages,
	    isEnableHistoricalChat = _ref.isEnableHistoricalChat,
	    isFetchingMessages = _ref.isFetchingMessages,
	    isAllConversations = _ref.isAllConversations,
	    lastConversations = _ref.lastConversations,
	    maxImgToSend = _ref.maxImgToSend,
	    onDialog = _ref.onDialog,
	    campType = _ref.campType,
	    onShowAlertDisconexion = _ref.onShowAlertDisconexion,
	    setNumFiles = _ref.setNumFiles,
	    getUploadState = _ref.getUploadState;
	  var _useTranslation2 = (0, _reactI18next.useTranslation)('chat'),
	    t = _useTranslation2.t;
	  var areaRef = (0, _react.useRef)();
	  var _useState3 = (0, _react.useState)(false),
	    _useState4 = _slicedToArray(_useState3, 2),
	    dragOver = _useState4[0],
	    setDragOver = _useState4[1];
	  var _useState5 = (0, _react.useState)([]),
	    _useState6 = _slicedToArray(_useState5, 2),
	    groupedMessages = _useState6[0],
	    setGroupedMessages = _useState6[1];
	  var _useState7 = (0, _react.useState)([]),
	    _useState8 = _slicedToArray(_useState7, 2),
	    attachmentPreview = _useState8[0],
	    setAttachmentPreview = _useState8[1];
	  var tempAttachments = (0, _react.useRef)([]);
	  var _useState9 = (0, _react.useState)(-1),
	    _useState10 = _slicedToArray(_useState9, 2),
	    selectedFile = _useState10[0],
	    setSelectedFile = _useState10[1];
	  var _useState11 = (0, _react.useState)(false),
	    _useState12 = _slicedToArray(_useState11, 2),
	    isLoading = _useState12[0],
	    setIsLoading = _useState12[1];
	  var _useState13 = (0, _react.useState)(0),
	    _useState14 = _slicedToArray(_useState13, 2),
	    speedSelected = _useState14[0],
	    setSpeedSelected = _useState14[1];
	  var _useState15 = (0, _react.useState)(null),
	    _useState16 = _slicedToArray(_useState15, 2),
	    currentAudio = _useState16[0],
	    setCurrentAudio = _useState16[1];
	  var refDates = (0, _react.useRef)([]);
	  var refDateSticky = (0, _react.useRef)();
	  var _useState17 = (0, _react.useState)(false),
	    _useState18 = _slicedToArray(_useState17, 2),
	    memoryScrollTop = _useState18[0],
	    setMemoryScrollTop = _useState18[1];
	  var _useState19 = (0, _react.useState)(0),
	    _useState20 = _slicedToArray(_useState19, 2),
	    memoryScrollHeight = _useState20[0],
	    setMemoryScrollHeight = _useState20[1];
	  var loadMessages = function loadMessages() {
	    onLoadMessages();
	    setTimeout(function () {
	      return setMemoryScrollTop(false);
	    }, 10500);
	  };
	  var _useInfiniteScrollWit = (0, _hooks.useInfiniteScrollWithRefCallback)(loadMessages, isEnableHistoricalChat && !isAllConversations, setMemoryScrollTop, setMemoryScrollHeight, refDates, refDateSticky),
	    _useInfiniteScrollWit2 = _slicedToArray(_useInfiniteScrollWit, 4),
	    setRefChatZone = _useInfiniteScrollWit2[0],
	    isFetching = _useInfiniteScrollWit2[1],
	    setIsFetching = _useInfiniteScrollWit2[2],
	    refChatZone = _useInfiniteScrollWit2[3];
	  (0, _react.useEffect)(function () {
	    if (!isFetchingMessages) {
	      setTimeout(function () {
	        return setIsFetching(false);
	      }, 1000);
	    }
	  }, [isFetchingMessages]);
	  (0, _globalComponentsLibrary.useUpdateEffect)(function () {
	    if (refChatZone != null) {
	      if (memoryScrollTop) {
	        refChatZone.scrollTop = Math.max(refChatZone.scrollHeight - memoryScrollHeight - 92, 100);
	      } else {
	        refChatZone.scrollTop = refChatZone.scrollHeight;
	      }
	    }
	  }, [groupedMessages]);
	  var changeSpeed = function changeSpeed() {
	    var speedTmp = speedSelected + 1;
	    if (speedTmp > 2) {
	      speedTmp = 0;
	    }
	    setSpeedSelected(speedTmp);
	  };
	  var groupem = function groupem() {
	    if (messages != null) {
	      if (messages.length > 0) {
	        var newObj = messages.reduce(function (acc, curr, i, arr) {
	          if (i === 0 || curr.origin !== arr[i - 1].origin || !(0, _dateFns.isSameMinute)(curr.date, arr[i - 1].date)) {
	            acc.index++;
	            acc.arr[acc.index] = {
	              source: curr.origin,
	              date: curr.date,
	              conversationId: curr.conversationId,
	              originName: curr.originName,
	              fromAgent: curr.fromAgent,
	              content: [{
	                type: curr.type ? curr.type : 'text',
	                status: curr.status,
	                texts: [],
	                attachments: [],
	                messageIds: []
	              }],
	              contentIndex: 0,
	              campType: curr.campType,
	              graphicId: curr.graphicId
	            };
	          } else if (arr[i - 1].type !== curr.type || arr[i - 1].status !== curr.status) {
	            acc.arr[acc.index].content.push({
	              type: curr.type ? curr.type : 'text',
	              status: curr.status,
	              texts: [],
	              attachments: [],
	              messageIds: []
	            });
	            acc.arr[acc.index].contentIndex++;
	          }
	          if (curr.type == null || curr.type === 'text' || curr.type === 'template') {
	            acc.arr[acc.index].content[acc.arr[acc.index].contentIndex].texts.push(curr.content);
	          } else if (curr.type === 'location') {
	            acc.arr[acc.index].content[acc.arr[acc.index].contentIndex].attachments.push({
	              url: curr.location.Url
	            });
	          } else if (curr.type !== 'unsupported') {
	            var indexUrl = curr.attachments.Url.indexOf('|');
	            var newUrl = curr.attachments.Url;
	            var fileName = curr.attachments.Name;
	            var fileSize = curr.attachments.Size;
	            if (indexUrl > -1) {
	              var elementSplit = curr.attachments.Url.split('|');
	              newUrl = elementSplit[0];
	              if (newUrl.indexOf('/v3/') > -1) {
	                newUrl = newUrl.split('/v3/')[0];
	              }
	              fileSize = elementSplit[1];
	              fileName = elementSplit[2];
	            }
	            acc.arr[acc.index].content[acc.arr[acc.index].contentIndex].attachments.push({
	              caption: curr.type === 'file' ? null : curr.attachments.Caption,
	              url: newUrl,
	              size: fileSize,
	              name: fileName
	            });
	          }
	          acc.arr[acc.index].status = (0, _helpers.isNewMedia)(type) ? curr.status : curr.seen ? 'read' : 'delivered';
	          acc.arr[acc.index].content[acc.arr[acc.index].contentIndex].messageIds.push(curr.messageId);
	          return acc;
	        }, {
	          arr: [],
	          index: -1
	        });
	        setGroupedMessages(newObj.arr);
	      } else if (groupedMessages.length > 0) {
	        setGroupedMessages([]);
	      }
	    }
	  };
	  (0, _react.useLayoutEffect)(groupem, [messages]);
	  var onAceptedChatHandler = function onAceptedChatHandler(isTimeOut) {
	    setStartConversation(function () {
	      return false;
	    });
	    onAceptedChat();
	    setTimeout(function () {
	      if (isTimeOut) {
	        setTimeout(function () {
	          onFinish();
	        }, 200);
	      }
	      areaRef.current.focus();
	    }, 500);
	  };
	  var onDragOver = function onDragOver(e) {
	    e.preventDefault();
	    if (!show) {
	      setDragOver(true);
	    }
	  };
	  (0, _react.useEffect)(function () {
	    if (startConversation) {
	      onAceptedChatHandler(true);
	    }
	  }, [startConversation]);
	  var timeoutRef = (0, _react.useRef)(null);
	  var onUploadAttachmentsHandler = function onUploadAttachmentsHandler(files) {
	    tempAttachments.current = files;
	    onUploadAttachments(files);
	    setNumFiles(files.length);
	    timeoutRef.current = setTimeout(function () {
	      console.log('onTimeout Response');
	      setIsLoading(false);
	      setDragOver(false);
	      if (!getUploadState()) {
	        onShowAlertDisconexion();
	      }
	    }, 10000);
	  };
	  var onDeleteAttachmentHandler = function onDeleteAttachmentHandler(url) {
	    onDeleteAttachment(url);
	    setAttachmentPreview(function (a) {
	      return a.filter(function (f) {
	        return f.url !== url;
	      });
	    });
	    setSelectedFile(function (s) {
	      return s - 1;
	    });
	  };
	  (0, _react.useEffect)(function () {
	    if (setTheUrlOfAttachments != null && setTheUrlOfAttachments.length > 0) {
	      if (setTheUrlOfAttachments.length === 1 && setTheUrlOfAttachments[0].name === 'audio.ogg') {
	        onSendResponseHandler([setTheUrlOfAttachments[0]]);
	      } else if (tempAttachments.current.length > 0) {
	        var filesToSet = tempAttachments.current.filter(function (f) {
	          return setTheUrlOfAttachments.some(function (g) {
	            return g.name === f.name;
	          });
	        });
	        setAttachmentPreview(function (a) {
	          return [].concat(_toConsumableArray(a), _toConsumableArray(filesToSet.map(function (f) {
	            var file = setTheUrlOfAttachments.find(function (g) {
	              return g.name === f.name;
	            });
	            return {
	              name: f.name,
	              url: (0, _helpers.urlFormatHelper)(file.url),
	              size: file.size,
	              type: file.type
	            };
	          })));
	        });
	        tempAttachments.current = tempAttachments.current.filter(function (f) {
	          return !filesToSet.some(function (g) {
	            return g.name === f.name;
	          });
	        });
	        setIsLoading(false);
	        setDragOver(false);
	        clearTimeout(timeoutRef.current);
	      }
	    }
	  }, [setTheUrlOfAttachments]);
	  (0, _react.useEffect)(function () {
	    setSelectedFile(attachmentPreview.length - 1);
	  }, [attachmentPreview]);
	  var onCloseModal = function onCloseModal() {
	    attachmentPreview.forEach(function (f) {
	      return onDeleteAttachment(f.url);
	    });
	    setAttachmentPreview([]);
	  };
	  var onSendResponseHandler = function onSendResponseHandler(val) {
	    if (_typeof(val) === 'object') {
	      val.forEach(function (v) {
	        var message = '';
	        var arr = {};
	        arr = {
	          Caption: message,
	          Url: v.url,
	          Size: v.size,
	          Name: v.name
	        };
	        setTimeout(function () {
	          onSendResponse('', arr, v.type);
	        }, 1000);
	      });
	      setAttachmentPreview([]);
	      return;
	    }
	    onSendResponse(val);
	  };
	  /* useEffect(() => {
	  	if (attach.length > 0) {
	  		onDragLeaveEndHandler();
	  		if (isLoading) setIsLoading(false);
	  	}
	  }, [attach]); */
	
	  var onDragLeaveEndHandler = function onDragLeaveEndHandler() {
	    if (dragOver) setDragOver(false);
	  };
	  (0, _react.useEffect)(function () {
	    setCurrentAudio(null);
	  }, [conversationId]);
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-chat-view",
	    onDragOver: onDragOver
	  }, dragOver && /*#__PURE__*/_react["default"].createElement(_DragAndDropFile["default"], {
	    onChange: onUploadAttachmentsHandler,
	    onDragLeaveEnd: onDragLeaveEndHandler,
	    mediaType: type,
	    maxImgToSend: maxImgToSend
	  }), isLoading && !dragOver && /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-chat-conversation-attaching"
	  }, /*#__PURE__*/_react["default"].createElement(_reactstrap.Spinner, {
	    color: "primary"
	  }), /*#__PURE__*/_react["default"].createElement("span", {
	    className: "uin-loading-label"
	  }, "".concat(t('loading'), "..."))), disabled && type === 'CHAT' && /*#__PURE__*/_react["default"].createElement(DisabledBanner, null), attachmentPreview.length > 0 && attachmentPreview[selectedFile] ? /*#__PURE__*/_react["default"].createElement(_MediaViewerAttachment["default"], {
	    toggle: onCloseModal,
	    media: attachmentPreview[selectedFile].url,
	    mediaType: attachmentPreview[selectedFile].type,
	    fileName: attachmentPreview[selectedFile].name,
	    fileSize: attachmentPreview[selectedFile].size
	  }) : messages.length === 0 ? /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-empty"
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-empty-image"
	  }, /*#__PURE__*/_react["default"].createElement("img", {
	    src: _emptyChatPh["default"],
	    alt: "Empty placeholder"
	  })), /*#__PURE__*/_react["default"].createElement("p", {
	    className: "uin-empty-message"
	  }, t('no-messages'))) : /*#__PURE__*/_react["default"].createElement("div", {
	    ref: setRefChatZone,
	    className: 'uin-chat-conversation' + (show ? ' uin-chat-not-started' : '')
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: 'uin-loading-conversation' + (isFetching ? ' show' : '')
	  }, /*#__PURE__*/_react["default"].createElement("span", {
	    className: "uin-loading-label"
	  }, "".concat(t('loading-messsages'), "...")), /*#__PURE__*/_react["default"].createElement(_reactstrap.Spinner, {
	    color: "primary"
	  })), isEnableHistoricalChat && /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-date-label-container"
	  }, /*#__PURE__*/_react["default"].createElement("span", {
	    ref: refDateSticky,
	    id: "uin-date-label"
	  })), groupedMessages.map(function (group, i) {
	    var prevConv = lastConversations.find(function (c) {
	      return c.ConversationId === group.conversationId;
	    });
	    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
	      key: i
	    }, isEnableHistoricalChat && (i === 0 || i > 0 && (0, _dateFns.isBefore)(new Date(groupedMessages[i - 1].date).setHours(0, 0, 0, 0), new Date(group.date).setHours(0, 0, 0, 0))) && /*#__PURE__*/_react["default"].createElement(_DateDivider["default"], {
	      index: i,
	      ref: refDates,
	      lang: lang,
	      date: group.date
	    }), isEnableHistoricalChat && i > 0 && groupedMessages[i - 1].conversationId !== group.conversationId && prevConv != null && prevConv.IsReassigned && /*#__PURE__*/_react["default"].createElement(_ReassignDivider["default"], {
	      userAgent: group.fromAgent
	    }), /*#__PURE__*/_react["default"].createElement(_ChatMessage["default"], _extends({
	      image: /*#__PURE__*/_react["default"].createElement(_ImageIcon["default"], {
	        image: group.graphicId,
	        type: group.campType,
	        showTooltip: false
	      })
	    }, group, {
	      disabled: type !== 'WHATSAPP' ? disabled : false,
	      type: type,
	      speedSelected: speedSelected,
	      changeSpeed: changeSpeed,
	      currentAudio: currentAudio,
	      setCurrentAudio: setCurrentAudio,
	      isEnableHistoricalChat: isEnableHistoricalChat
	    })));
	  }), typing && /*#__PURE__*/_react["default"].createElement(_ChatMessage["default"], {
	    image: userImage,
	    typing: true,
	    speedSelected: speedSelected,
	    changeSpeed: changeSpeed,
	    currentAudio: currentAudio,
	    setCurrentAudio: setCurrentAudio
	  })), show ? /*#__PURE__*/_react["default"].createElement(_NewMessageBar["default"], {
	    disabled: disabledActions,
	    onAceptedChat: function onAceptedChat() {
	      return onAceptedChatHandler();
	    },
	    onSpam: onSpam,
	    onUnassign: onUnassign
	  }) : '', /*#__PURE__*/_react["default"].createElement(_ChatFooter["default"], {
	    ref: areaRef,
	    templates: templates,
	    contact: contact,
	    agent: agent,
	    disabled: disabled || disabledActions,
	    mediaType: type,
	    media: attachmentPreview,
	    selectedAttachment: selectedFile,
	    onSelectAttachment: setSelectedFile,
	    onSendResponse: onSendResponseHandler,
	    onUploadAttachments: onUploadAttachmentsHandler,
	    onDeleteAttachment: onDeleteAttachmentHandler,
	    onLoading: setIsLoading,
	    maxImgToSend: maxImgToSend,
	    onDialog: onDialog
	  }), !(0, _helpers.isNewMedia)(type) && groupedMessages.some(function (g) {
	    return g.source !== _constants.MSG_SOURCE.USER && g.status === 'delivered';
	  }) && /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
	    target: "uin-chat-msg-dlr"
	  }, t('delivered')), !(0, _helpers.isNewMedia)(type) && groupedMessages.some(function (g) {
	    return g.source !== _constants.MSG_SOURCE.USER && g.status === 'read';
	  }) && /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
	    target: "uin-chat-msg-rd"
	  }, t('read')), !(0, _helpers.isNewMedia)(type) && groupedMessages.some(function (g) {
	    return g.source === _constants.MSG_SOURCE.ADMIN;
	  }) && /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
	    target: "uin-chat-msg-vis-A"
	  }, t('can-see')), !(0, _helpers.isNewMedia)(type) && groupedMessages.some(function (g) {
	    return g.source === _constants.MSG_SOURCE.COACH;
	  }) && /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
	    target: "uin-chat-msg-vis-C"
	  }, t('cant-see')));
	};
	ChatView.propTypes = {
	  messages: _propTypes["default"].arrayOf(_types.messageType),
	  userImage: _propTypes["default"].element,
	  typing: _propTypes["default"].bool,
	  templates: _propTypes["default"].arrayOf(_types.templateType),
	  disabled: _propTypes["default"].bool,
	  onSendResponse: _propTypes["default"].func.isRequired,
	  onSpam: _propTypes["default"].func,
	  onAceptedChat: _propTypes["default"].func,
	  onUnassign: _propTypes["default"].func,
	  startConversation: _propTypes["default"].bool,
	  setStartConversation: _propTypes["default"].func
	};
	ChatView.defaultProps = {
	  lastConversations: []
	};
	var _default = exports["default"] = ChatView;

/***/ },
/* 1403 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var _react = _interopRequireWildcard(__webpack_require__(1));
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	var _globalComponentsLibrary = __webpack_require__(28);
	var _reactI18next = __webpack_require__(41);
	__webpack_require__(2480);
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
	function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	var ContactInfo = function ContactInfo(_ref) {
	  var phoneNumber = _ref.phoneNumber,
	    data = _ref.data,
	    onClose = _ref.onClose,
	    onUnassign = _ref.onUnassign,
	    onFinish = _ref.onFinish;
	  var _useTranslation = (0, _reactI18next.useTranslation)(['contact-info', 'header', 'commons']),
	    t = _useTranslation.t;
	  var _useState = (0, _react.useState)(false),
	    _useState2 = _slicedToArray(_useState, 2),
	    isDialogOpen = _useState2[0],
	    setDialogOpen = _useState2[1];
	  var dialogData = (0, _react.useRef)({});
	  var openDialog = function openDialog(action, type) {
	    dialogData.current = {
	      action: action,
	      type: type
	    };
	    setDialogOpen(true);
	  };
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-conv-contact-info"
	  }, /*#__PURE__*/_react["default"].createElement("header", null, /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon clickable close",
	    onClick: onClose
	  }), t('title')), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-contact-body"
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-contact-title"
	  }, /*#__PURE__*/_react["default"].createElement("b", null, t('phone')), /*#__PURE__*/_react["default"].createElement("span", null, phoneNumber)), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-contact-info"
	  }, /*#__PURE__*/_react["default"].createElement("b", null, t('data')), data.map(function (d, i) {
	    return /*#__PURE__*/_react["default"].createElement("span", {
	      key: i
	    }, d);
	  })), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-contact-actions"
	  }, onUnassign && /*#__PURE__*/_react["default"].createElement(_globalComponentsLibrary.Button, {
	    onClick: function onClick() {
	      return openDialog(onUnassign, 'unassign');
	    }
	  }, t('unassign')), onFinish && /*#__PURE__*/_react["default"].createElement(_globalComponentsLibrary.Button, {
	    onClick: function onClick() {
	      return openDialog(onFinish, 'finish');
	    }
	  }, t('finish')))), /*#__PURE__*/_react["default"].createElement(_globalComponentsLibrary.DialogBox, {
	    show: isDialogOpen,
	    toggle: function toggle() {
	      return setDialogOpen(!isDialogOpen);
	    },
	    onAccept: dialogData.current.action,
	    title: t('header:' + dialogData.current.type + '.title'),
	    content: t('header:' + dialogData.current.type + '.content'),
	    accept: t('header:' + dialogData.current.type + '.commit'),
	    cancel: t('commons:cancel')
	  }));
	};
	ContactInfo.propTypes = {
	  phoneNumber: _propTypes["default"].string,
	  data: _propTypes["default"].array,
	  onClose: _propTypes["default"].func.isRequired,
	  onUnassign: _propTypes["default"].func,
	  onFinish: _propTypes["default"].func
	};
	ContactInfo.defaultProps = {
	  data: []
	};
	var _default = exports["default"] = ContactInfo;

/***/ },
/* 1404 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var _react = _interopRequireWildcard(__webpack_require__(1));
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	var _constants = __webpack_require__(58);
	var _types = __webpack_require__(60);
	var _ConversationHeader = _interopRequireDefault(__webpack_require__(1398));
	var _TwitterView = _interopRequireDefault(__webpack_require__(1409));
	var _ChatView = _interopRequireDefault(__webpack_require__(1402));
	var _MailsView = _interopRequireDefault(__webpack_require__(1407));
	var _ImageIcon = _interopRequireDefault(__webpack_require__(167));
	var _WrapUp = _interopRequireDefault(__webpack_require__(1429));
	var _ContactInfo = _interopRequireDefault(__webpack_require__(1403));
	__webpack_require__(2481);
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
	function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
	function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
	function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
	function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	var ConversationView = function ConversationView(_ref) {
	  var conversation = _ref.conversation,
	    _ref$conversation = _ref.conversation,
	    _ref$conversation2 = _ref$conversation === void 0 ? {} : _ref$conversation,
	    id = _ref$conversation2.id,
	    campType = _ref$conversation2.campType,
	    type = _ref$conversation2.type,
	    campaign = _ref$conversation2.campaign,
	    contact = _ref$conversation2.contact,
	    initialTime = _ref$conversation2.initialTime,
	    typing = _ref$conversation2.typing,
	    messages = _ref$conversation2.messages,
	    templates = _ref$conversation2.templates,
	    takeover = _ref$conversation2.takeover,
	    clientTermination = _ref$conversation2.clientTermination,
	    clientWithHistoricalChat = _ref$conversation2.clientWithHistoricalChat,
	    chatStarted = _ref$conversation2.chatStarted,
	    exitWrapUpDisposition = _ref$conversation2.exitWrapUpDisposition,
	    lastConversations = _ref$conversation2.lastConversations,
	    timeoutReached = _ref$conversation2.timeoutReached,
	    data = _ref$conversation2.data,
	    _ref$draftMessages = _ref.draftMessages,
	    draftMessages = _ref$draftMessages === void 0 ? {} : _ref$draftMessages,
	    openMessages = _ref.openMessages,
	    toggle = _ref.toggle,
	    _onFinish = _ref.onFinish,
	    onUnassign = _ref.onUnassign,
	    onSpam = _ref.onSpam,
	    onDiscard = _ref.onDiscard,
	    onWrapUp = _ref.onWrapUp,
	    _onSendResponse = _ref.onSendResponse,
	    lang = _ref.lang,
	    agent = _ref.agent,
	    onAttachments = _ref.onAttachments,
	    onUploadAttachments = _ref.onUploadAttachments,
	    onDeleteAttachment = _ref.onDeleteAttachment,
	    onShowAlertDisconexion = _ref.onShowAlertDisconexion,
	    onAceptedChat = _ref.onAceptedChat,
	    onDialog = _ref.onDialog,
	    onLoadMessages = _ref.onLoadMessages,
	    onUpdateDraftMessage = _ref.onUpdateDraftMessage,
	    onUpdateDraftAttachments = _ref.onUpdateDraftAttachments,
	    onDeleteDraftMessage = _ref.onDeleteDraftMessage,
	    openWrapup = _ref.openWrapup,
	    setTheUrlOfAttachments = _ref.setTheUrlOfAttachments,
	    startConversation = _ref.startConversation,
	    setStartConversation = _ref.setStartConversation,
	    disabledActions = _ref.disabledActions,
	    setNumFiles = _ref.setNumFiles,
	    getUploadState = _ref.getUploadState;
	  var _useState = (0, _react.useState)(false),
	    _useState2 = _slicedToArray(_useState, 2),
	    isWrapUpOpen = _useState2[0],
	    setWrapUpOpen = _useState2[1];
	  var _useState3 = (0, _react.useState)(false),
	    _useState4 = _slicedToArray(_useState3, 2),
	    endConversation = _useState4[0],
	    setEndConversation = _useState4[1];
	  var _useState5 = (0, _react.useState)(false),
	    _useState6 = _slicedToArray(_useState5, 2),
	    isContactInfoOpen = _useState6[0],
	    setContactInfoOpen = _useState6[1];
	  (0, _react.useEffect)(function () {
	    setContactInfoOpen(false);
	  }, [id]);
	  (0, _react.useEffect)(function () {
	    if (clientTermination && type === _constants.TABS.CHAT) {
	      _onFinish(campType, id);
	    }
	  }, [clientTermination]);
	  (0, _react.useEffect)(function () {
	    if (openWrapup) setWrapUpOpen(true);
	  }, [openWrapup]);
	  var mailResponseData = (0, _react.useRef)({});
	  if (conversation == null) return /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-conversation-view"
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-conv-view-wrapper"
	  }, /*#__PURE__*/_react["default"].createElement(_ConversationHeader["default"], null), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-conv-view empty"
	  })));
	  var onAttachmentsHandle = function onAttachmentsHandle() {
	    onAttachments(campType, id);
	  };
	  var onFinishHandler = function onFinishHandler() {
	    _onFinish(campType, id);
	    if (endConversation) {
	      setEndConversation(false);
	    }
	    if (type !== 'WHATSAPP' || campaign.showWrapUp === undefined || campaign.showWrapUp) {
	      setWrapUpOpen(true);
	    }
	  };
	  var onWrapUpHandler = function onWrapUpHandler(disposition, messageId) {
	    var obj = _objectSpread(_objectSpread({}, disposition), {}, {
	      messageId: messageId
	    });
	    onWrapUp(campType, id, obj);
	    if (exitWrapUpDisposition === undefined ? true : exitWrapUpDisposition) {
	      setWrapUpOpen(false);
	    }
	  };
	  var onUploadAttachmentsHandle = function onUploadAttachmentsHandle(files) {
	    files.forEach(function (f) {
	      return onUploadAttachments(campType, id, f.name, f);
	    });
	  };
	  var onDeleteAttachmentHandle = function onDeleteAttachmentHandle(url) {
	    onDeleteAttachment(campType, id, url);
	  };
	  var onAceptedChatHandle = function onAceptedChatHandle() {
	    onAceptedChat(campType, id);
	  };
	  var onLoadMessagesHandle = function onLoadMessagesHandle() {
	    onLoadMessages(campType, id);
	  };
	  var onHandleReply = function onHandleReply(messageId, subject, message, attachments, cc, bcc, IsAzure) {
	    _onFinish(campType, id);
	    setTimeout(function () {
	      _onSendResponse(campType, id, message, messageId, subject, attachments, campaign.account, contact.account, cc, bcc, IsAzure);
	    }, 500);
	    setWrapUpOpen(true);
	    mailResponseData.current = {
	      messageId: messageId,
	      subject: subject,
	      message: message,
	      attachments: attachments,
	      cc: cc,
	      bcc: bcc,
	      IsAzure: IsAzure
	    };
	  };
	  var onUnassignAndDeleteDraft = function onUnassignAndDeleteDraft() {
	    onUnassign(campType, id);
	    onDeleteDraftMessage(campType, id);
	  };
	  var messagesUser = messages.some(function (item) {
	    return item.origin === _constants.MSG_SOURCE.USER;
	  });
	  var disabled = type === _constants.TABS.CHAT ? takeover : type === _constants.TABS.WHATSAPP && campType === _constants.CAMPTYPE.OUTBOUND ? !messagesUser : !chatStarted;
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-conversation-view"
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-conv-view-wrapper"
	  }, /*#__PURE__*/_react["default"].createElement(_ConversationHeader["default"], {
	    type: type,
	    subject: messages && messages[0] && messages[0].subject,
	    contact: _objectSpread(_objectSpread({}, contact), {}, {
	      image: /*#__PURE__*/_react["default"].createElement(_ImageIcon["default"], {
	        id: "uin-conv-header-iic",
	        name: campaign.name,
	        image: campaign.graphicId,
	        type: campaign.type
	      })
	    }),
	    initialTime: initialTime,
	    onFinish: type === _constants.TABS.CHAT || type === _constants.TABS.WHATSAPP ? onFinishHandler : undefined,
	    onUnassign: type === _constants.TABS.WHATSAPP ? undefined : onUnassignAndDeleteDraft,
	    onSpam: type === _constants.TABS.MAIL ? function () {
	      return onSpam(campType, id);
	    } : undefined,
	    onDiscard: type === _constants.TABS.CHAT || type === _constants.TABS.WHATSAPP ? undefined : function () {
	      return onDiscard(campType, id);
	    },
	    onViewContact: type === _constants.TABS.WHATSAPP && campaign.type ? function () {
	      return setContactInfoOpen(true);
	    } : undefined,
	    wrapUpTime: campaign.wrapUpTime,
	    dispositions: campaign.dispositions,
	    setWrapUpOpen: setWrapUpOpen,
	    chatStarted: chatStarted,
	    showWrapUp: campaign.showWrapUp === undefined ? true : campaign.showWrapUp,
	    endConversation: endConversation,
	    setEndConversation: setEndConversation,
	    timeoutReached: timeoutReached,
	    onDialog: type === _constants.TABS.WHATSAPP ? onDialog : undefined,
	    disabledActions: disabledActions
	  }), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-conv-view"
	  }, type === _constants.TABS.TWITTER ? /*#__PURE__*/_react["default"].createElement(_TwitterView["default"], {
	    tweets: messages,
	    user: contact
	  }) : type === _constants.TABS.MAIL ? /*#__PURE__*/_react["default"].createElement(_MailsView["default"], {
	    contact: _objectSpread(_objectSpread({}, contact), {}, {
	      image: /*#__PURE__*/_react["default"].createElement(_ImageIcon["default"], {
	        name: campaign.name,
	        image: campaign.image,
	        showTooltip: false
	      })
	    }),
	    campaign: {
	      name: campaign.senderName || campaign.name,
	      account: campaign.account,
	      image: /*#__PURE__*/_react["default"].createElement(_ImageIcon["default"], {
	        icon: "user"
	      })
	    },
	    mails: messages,
	    draftMessages: draftMessages,
	    openMails: openMessages,
	    toggle: toggle,
	    setWrapUpOpen: setWrapUpOpen,
	    onReply: function onReply(messageId, subject, message, attachments, cc, bcc, IsAzure) {
	      onHandleReply(messageId, subject, message, attachments, cc, bcc, IsAzure);
	    },
	    onDialog: onDialog,
	    onUpdateDraftMessage: onUpdateDraftMessage,
	    onUpdateDraftAttachments: onUpdateDraftAttachments,
	    onAttachments: onAttachmentsHandle,
	    onUploadAttachments: onUploadAttachmentsHandle,
	    onDeleteAttachment: onDeleteAttachmentHandle,
	    onDeleteDraftMessage: onDeleteDraftMessage,
	    IsAzure: conversation.IsAzure ? conversation.IsAzure : false
	  }) : /*#__PURE__*/_react["default"].createElement(_ChatView["default"], {
	    lang: lang,
	    contact: contact,
	    agent: agent,
	    disabled: disabled,
	    disabledActions: disabledActions,
	    type: type,
	    userImage: /*#__PURE__*/_react["default"].createElement(_ImageIcon["default"], {
	      name: campaign.name,
	      image: campaign.image,
	      type: campaign.type,
	      showTooltip: false
	    }),
	    messages: messages,
	    typing: typing,
	    templates: templates,
	    onSendResponse: function onSendResponse(message, attachments, type) {
	      return _onSendResponse(campType, id, message, undefined, undefined, attachments, undefined, undefined, undefined, undefined, undefined, type);
	    },
	    onUnassign: onUnassign ? function () {
	      return onUnassign(campType, id);
	    } : undefined,
	    onSpam: onSpam && type === _constants.TABS.WHATSAPP ? function () {
	      return onSpam(campType, id);
	    } : undefined,
	    onFinish: onFinishHandler,
	    onAceptedChat: type === _constants.TABS.WHATSAPP ? onAceptedChatHandle : undefined,
	    show: type !== _constants.TABS.CHAT ? !chatStarted : false,
	    setNumFiles: setNumFiles,
	    onUploadAttachments: onUploadAttachmentsHandle,
	    onDeleteAttachment: onDeleteAttachmentHandle,
	    onShowAlertDisconexion: onShowAlertDisconexion,
	    setTheUrlOfAttachments: setTheUrlOfAttachments,
	    startConversation: startConversation,
	    setStartConversation: setStartConversation,
	    conversationId: id,
	    onLoadMessages: type === _constants.TABS.WHATSAPP ? onLoadMessagesHandle : undefined,
	    isEnableHistoricalChat: type === _constants.TABS.WHATSAPP ? clientWithHistoricalChat : false,
	    isFetchingMessages: type === _constants.TABS.WHATSAPP ? lastConversations.fetching : false,
	    isAllConversations: type === _constants.TABS.WHATSAPP ? lastConversations.isAllConversations : false,
	    lastConversations: type === _constants.TABS.WHATSAPP ? lastConversations.conversationsDict || undefined : undefined,
	    totalMessages: type === _constants.TABS.WHATSAPP ? messages.length : undefined,
	    maxImgToSend: type === _constants.TABS.CHAT ? conversation.maxImgChat : undefined,
	    onDialog: onDialog,
	    getUploadState: getUploadState,
	    campType: campaign.type
	  }))), /*#__PURE__*/_react["default"].createElement("div", {
	    className: 'uin-conv-contact-info-wrapper' + (isContactInfoOpen ? ' open' : '')
	  }, /*#__PURE__*/_react["default"].createElement(_ContactInfo["default"], {
	    phoneNumber: contact.name,
	    data: data,
	    onClose: function onClose() {
	      return setContactInfoOpen(false);
	    },
	    onFinish: onFinishHandler,
	    onUnassign: type === _constants.TABS.WHATSAPP ? undefined : onUnassign ? function () {
	      return onUnassign(campType, id);
	    } : undefined
	  })), /*#__PURE__*/_react["default"].createElement(_WrapUp["default"], {
	    acdId: conversation.campaign.id,
	    type: type,
	    conversationId: conversation.id,
	    show: isWrapUpOpen || clientTermination,
	    toggle: function toggle() {
	      return setWrapUpOpen(false);
	    },
	    onSelect: function onSelect(disposition) {
	      onWrapUpHandler(disposition, mailResponseData.current.messageId);
	      setTimeout(function () {
	        if (type === 'MAIL') {
	          _onSendResponse(campType, id, mailResponseData.current.message, mailResponseData.current.messageId, mailResponseData.current.subject, mailResponseData.current.attachments, conversation.campaign.account, conversation.contact.account, mailResponseData.current.cc, mailResponseData.current.bcc, mailResponseData.current.IsAzure);
	        }
	      }, 500);
	    },
	    time: conversation.campaign.wrapUpTime,
	    dispositions: conversation.campaign.dispositions,
	    closeModal: exitWrapUpDisposition === undefined ? true : exitWrapUpDisposition,
	    onFinish: function onFinish() {
	      return _onFinish(campType, id);
	    }
	  }));
	};
	ConversationView.propTypes = {
	  conversation: _types.conversationType,
	  openMessages: _propTypes["default"].arrayOf(_propTypes["default"].number),
	  toggle: _propTypes["default"].func,
	  onFinish: _propTypes["default"].func,
	  onUnassign: _propTypes["default"].func,
	  onSpam: _propTypes["default"].func,
	  onDiscard: _propTypes["default"].func,
	  onWrapUp: _propTypes["default"].func,
	  onSendResponse: _propTypes["default"].func,
	  onAceptedChat: _propTypes["default"].func,
	  startConversation: _propTypes["default"].bool,
	  setStartConversation: _propTypes["default"].func
	};
	var _default = exports["default"] = ConversationView;

/***/ },
/* 1405 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var _react = _interopRequireWildcard(__webpack_require__(1));
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	var _reactstrap = __webpack_require__(70);
	var _reactI18next = __webpack_require__(41);
	var _formatters = __webpack_require__(83);
	var _types = __webpack_require__(60);
	var _ContactData = _interopRequireDefault(__webpack_require__(593));
	var _MailEditor = _interopRequireDefault(__webpack_require__(1413));
	var _Mailcard = _interopRequireDefault(__webpack_require__(1406));
	var _ButtonAttached = _interopRequireDefault(__webpack_require__(1395));
	var _helpers = __webpack_require__(53);
	var _globalComponentsLibrary = __webpack_require__(28);
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
	function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	var getName = function getName(url) {
	  url = (0, _helpers.getLocation)(url, window.location.hostname, window.location.href);
	  return url.substring(url.lastIndexOf('\\') + 1);
	};
	var Mail = function Mail(_ref) {
	  var mail = _ref.mail,
	    contact = _ref.contact,
	    sender = _ref.sender,
	    isOpen = _ref.isOpen,
	    draft = _ref.draft,
	    toggle = _ref.toggle,
	    onReply = _ref.onReply,
	    onAttachments = _ref.onAttachments,
	    onUploadAttachments = _ref.onUploadAttachments,
	    onDeleteAttachment = _ref.onDeleteAttachment,
	    IsAzure = _ref.IsAzure,
	    onUpdateDraftMessage = _ref.onUpdateDraftMessage,
	    onUpdateDraftAttachments = _ref.onUpdateDraftAttachments,
	    onDeleteDraftMessage = _ref.onDeleteDraftMessage,
	    onDialog = _ref.onDialog;
	  var _useTranslation = (0, _reactI18next.useTranslation)('commons'),
	    t = _useTranslation.t,
	    i18n = _useTranslation.i18n;
	  var _useState = (0, _react.useState)(false),
	    _useState2 = _slicedToArray(_useState, 2),
	    editorOpen = _useState2[0],
	    setEditorOpen = _useState2[1];
	  var openEditor = function openEditor() {
	    if (!isOpen) toggle();
	    onDialog();
	    setEditorOpen(true);
	  };
	  var editorDivRef = (0, _react.useRef)();
	  (0, _react.useEffect)(function () {
	    if (editorOpen) {
	      var timer = setTimeout(function () {
	        editorDivRef.current.scrollIntoView({
	          behavior: 'smooth',
	          block: 'end',
	          inline: 'nearest'
	        });
	      }, 500);
	      return function () {
	        return clearTimeout(timer);
	      };
	    }
	  }, [editorOpen]);
	  (0, _react.useEffect)(function () {
	    setEditorOpen(false);
	  }, [mail.id]);
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-mail",
	    ref: editorDivRef
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-mail-header"
	  }, /*#__PURE__*/_react["default"].createElement(_ContactData["default"], contact), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-mail-info"
	  }, /*#__PURE__*/_react["default"].createElement("time", {
	    dateTime: mail.date
	  }, (0, _formatters.formatMailDate)(mail.date, i18n.language.slice(0, 2))), onReply && /*#__PURE__*/_react["default"].createElement("i", {
	    id: 'uin-mail-reply-' + mail.id,
	    className: "gcl-icon response",
	    onClick: openEditor
	  }), toggle && /*#__PURE__*/_react["default"].createElement("i", {
	    className: 'gcl-icon chevron' + (isOpen ? '-up' : ''),
	    onClick: toggle
	  }))), /*#__PURE__*/_react["default"].createElement(_reactstrap.Collapse, {
	    isOpen: isOpen,
	    className: "uin-mail-content"
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-mail-content-wrap"
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-mail-body"
	  }, /*#__PURE__*/_react["default"].createElement(_Mailcard["default"], {
	    contentHtml: mail.content
	  })), mail.attachments && /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-mail-attachments"
	  }, mail.attachments && mail.attachments.length > 1 && /*#__PURE__*/_react["default"].createElement(_globalComponentsLibrary.Button, {
	    color: "secondary",
	    onClick: onAttachments
	  }, /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon download"
	  }), t('downloadzip')), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-mail-attachments-wrapper"
	  }, mail.attachments.map(function (m) {
	    return /*#__PURE__*/_react["default"].createElement(_ButtonAttached["default"], {
	      media: m,
	      mediaName: getName(m)
	    });
	  }))), onReply && /*#__PURE__*/_react["default"].createElement(_reactstrap.Collapse, {
	    isOpen: editorOpen,
	    className: "uin-mail-editor-wrap"
	  }, /*#__PURE__*/_react["default"].createElement(_MailEditor["default"], {
	    key: mail.id,
	    id: mail.id,
	    to: {
	      name: contact.name,
	      account: contact.account
	    },
	    from: {
	      name: sender.name,
	      account: sender.account
	    },
	    originalMail: mail,
	    onSend: onReply,
	    onUpdateDraftMessage: onUpdateDraftMessage,
	    onUpdateDraftAttachments: onUpdateDraftAttachments,
	    draft: draft,
	    onDiscard: function onDiscard() {
	      return setEditorOpen(false);
	    },
	    onUploadAttachments: onUploadAttachments,
	    onDeleteAttachment: onDeleteAttachment,
	    onDeleteDraftMessage: onDeleteDraftMessage,
	    IsAzure: IsAzure
	  })))), onReply && /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
	    target: 'uin-mail-reply-' + mail.id
	  }, t('reply')));
	};
	Mail.propType = {
	  mail: _types.messageType,
	  contact: _types.contactType,
	  sender: _types.contactType,
	  isOpen: _propTypes["default"].bool,
	  toggle: _propTypes["default"].func,
	  onReply: _propTypes["default"].func
	};
	Mail.defaultProps = {
	  isOpen: true
	};
	var _default = exports["default"] = Mail;

/***/ },
/* 1406 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var _react = _interopRequireDefault(__webpack_require__(1));
	var _reactHtmlParser = _interopRequireWildcard(__webpack_require__(597));
	var _helpers = __webpack_require__(53);
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
	function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
	function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	var HtmlComponent = exports["default"] = /*#__PURE__*/function (_React$Component) {
	  _inherits(HtmlComponent, _React$Component);
	  var _super = _createSuper(HtmlComponent);
	  function HtmlComponent() {
	    _classCallCheck(this, HtmlComponent);
	    return _super.apply(this, arguments);
	  }
	  _createClass(HtmlComponent, [{
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/_react["default"].createElement("div", {
	        className: "uin-mli-content-div"
	      }, (0, _reactHtmlParser["default"])((0, _helpers.getLocation)(this.props.contentHtml, window.location.hostname, window.location.href)));
	    }
	  }]);
	  return HtmlComponent;
	}(_react["default"].Component);

/***/ },
/* 1407 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var _react = _interopRequireDefault(__webpack_require__(1));
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	var _types = __webpack_require__(60);
	var _Mail = _interopRequireDefault(__webpack_require__(1405));
	__webpack_require__(2482);
	var _constants = __webpack_require__(58);
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	var MailsView = function MailsView(_ref) {
	  var _ref$mails = _ref.mails,
	    mails = _ref$mails === void 0 ? [] : _ref$mails,
	    draftMessages = _ref.draftMessages,
	    _ref$openMails = _ref.openMails,
	    openMails = _ref$openMails === void 0 ? [] : _ref$openMails,
	    _toggle = _ref.toggle,
	    contact = _ref.contact,
	    campaign = _ref.campaign,
	    onReply = _ref.onReply,
	    onAttachments = _ref.onAttachments,
	    onUploadAttachments = _ref.onUploadAttachments,
	    onDeleteAttachment = _ref.onDeleteAttachment,
	    IsAzure = _ref.IsAzure,
	    onUpdateDraftMessage = _ref.onUpdateDraftMessage,
	    onUpdateDraftAttachments = _ref.onUpdateDraftAttachments,
	    onDeleteDraftMessage = _ref.onDeleteDraftMessage,
	    onDialog = _ref.onDialog;
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-mail-view"
	  }, mails.length === 1 ? /*#__PURE__*/_react["default"].createElement(_Mail["default"], {
	    mail: mails[0],
	    contact: mails[0].origin === _constants.MSG_SOURCE.USER ? contact : campaign,
	    sender: mails[0].origin === _constants.MSG_SOURCE.USER ? campaign : contact,
	    onReply: onReply,
	    draft: draftMessages[mails[0].id],
	    onUpdateDraftMessage: onUpdateDraftMessage,
	    onUpdateDraftAttachments: onUpdateDraftAttachments,
	    onAttachments: onAttachments,
	    onUploadAttachments: onUploadAttachments,
	    onDeleteAttachment: onDeleteAttachment,
	    IsAzure: IsAzure,
	    onDeleteDraftMessage: onDeleteDraftMessage,
	    onDialog: onDialog
	  }) : mails.map(function (mail, i) {
	    return /*#__PURE__*/_react["default"].createElement(_Mail["default"], {
	      key: i,
	      mail: mail,
	      contact: mail.origin === _constants.MSG_SOURCE.USER ? contact : campaign,
	      sender: mail.origin === _constants.MSG_SOURCE.USER ? campaign : contact,
	      isOpen: openMails.includes(mail.id),
	      toggle: function toggle() {
	        return _toggle(mail.id);
	      },
	      onReply: onReply,
	      draft: draftMessages[mail.id],
	      onUpdateDraftMessage: onUpdateDraftMessage,
	      onUpdateDraftAttachments: onUpdateDraftAttachments,
	      onAttachments: onAttachments,
	      onUploadAttachments: onUploadAttachments,
	      onDeleteAttachment: onDeleteAttachment,
	      onDeleteDraftMessage: onDeleteDraftMessage,
	      IsAzure: IsAzure,
	      onDialog: onDialog
	    });
	  }));
	};
	MailsView.propTypes = {
	  mails: _propTypes["default"].arrayOf(_types.messageType),
	  openMails: _propTypes["default"].arrayOf(_propTypes["default"].number),
	  toggle: _propTypes["default"].func,
	  userImage: _propTypes["default"].element,
	  contact: _types.contactType,
	  campaign: _types.contactType,
	  onReply: _propTypes["default"].func,
	  onAttachments: _propTypes["default"].func,
	  onUploadAttachments: _propTypes["default"].func
	};
	var _default = exports["default"] = MailsView;

/***/ },
/* 1408 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var _react = _interopRequireDefault(__webpack_require__(1));
	var _reactI18next = __webpack_require__(41);
	var _types = __webpack_require__(60);
	var _formatters = __webpack_require__(83);
	var _helpers = __webpack_require__(53);
	__webpack_require__(1008);
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	var Tweet = function Tweet(_ref) {
	  var _ref$tweet = _ref.tweet,
	    content = _ref$tweet.content,
	    media = _ref$tweet.media,
	    date = _ref$tweet.date,
	    profileImage = _ref$tweet.profileImage,
	    user = _ref.user;
	  var _useTranslation = (0, _reactI18next.useTranslation)(),
	    i18n = _useTranslation.i18n;
	  var lang = i18n.language.slice(0, 2);
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-tweet"
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-tweet-header"
	  }, /*#__PURE__*/_react["default"].createElement("span", {
	    className: "uin-image-icon"
	  }, profileImage ? /*#__PURE__*/_react["default"].createElement("img", {
	    src: profileImage,
	    alt: ""
	  }) : /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon anchor"
	  })), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-tweet-user"
	  }, /*#__PURE__*/_react["default"].createElement("p", null, user.name), /*#__PURE__*/_react["default"].createElement("span", null, user.account))), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-tweet-body"
	  }, /*#__PURE__*/_react["default"].createElement("p", {
	    className: "uin-tweet-text"
	  }, (0, _helpers.linkify)(content)), media && /*#__PURE__*/_react["default"].createElement("div", {
	    className: 'uin-tweet-media ' + (media.length > 1 ? 'contain' : '')
	  }, (0, _helpers.groupImages)(media))), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-tweet-info"
	  }, /*#__PURE__*/_react["default"].createElement("time", {
	    dateTime: date
	  }, (0, _formatters.formatTweetDate)(date, lang))));
	};
	Tweet.propTypes = {
	  tweet: _types.messageType.isRequired,
	  user: _types.contactType.isRequired
	};
	var _default = exports["default"] = Tweet;

/***/ },
/* 1409 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var _react = _interopRequireDefault(__webpack_require__(1));
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	var _types = __webpack_require__(60);
	var _Tweet = _interopRequireDefault(__webpack_require__(1408));
	__webpack_require__(1008);
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	var TwitterView = function TwitterView(_ref) {
	  var _ref$tweets = _ref.tweets,
	    tweets = _ref$tweets === void 0 ? [] : _ref$tweets,
	    user = _ref.user;
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-twitter-view"
	  }, tweets.map(function (tweet, i) {
	    return /*#__PURE__*/_react["default"].createElement(_Tweet["default"], {
	      key: i,
	      tweet: tweet,
	      user: user
	    });
	  }));
	};
	TwitterView.propTypes = {
	  tweets: _propTypes["default"].arrayOf(_types.messageType),
	  user: _types.contactType
	};
	var _default = exports["default"] = TwitterView;

/***/ },
/* 1410 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var _react = _interopRequireWildcard(__webpack_require__(1));
	var _reactstrap = __webpack_require__(70);
	var _reactI18next = __webpack_require__(41);
	var _hooks = __webpack_require__(168);
	var _globalComponentsLibrary = __webpack_require__(28);
	__webpack_require__(2483);
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
	function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	var DragAndDropFile = function DragAndDropFile(_ref) {
	  var className = _ref.className,
	    onChange = _ref.onChange,
	    onDragLeaveEnd = _ref.onDragLeaveEnd,
	    mediaType = _ref.mediaType,
	    maxImgToSend = _ref.maxImgToSend;
	  var _useTranslation = (0, _reactI18next.useTranslation)('chat'),
	    t = _useTranslation.t;
	  var _useError = (0, _hooks.useError)(),
	    _useError2 = _slicedToArray(_useError, 3),
	    error = _useError2[0],
	    showError = _useError2[1],
	    toggleError = _useError2[2];
	  var getFiles = (0, _hooks.useFileHandler)(mediaType, maxImgToSend, showError);
	  var _useState = (0, _react.useState)(false),
	    _useState2 = _slicedToArray(_useState, 2),
	    isLoad = _useState2[0],
	    setIsLoad = _useState2[1];
	  var _onDrop = function onDrop(e) {
	    e.preventDefault();
	    setIsLoad(true);
	    try {
	      onChange(getFiles(e.dataTransfer.files));
	    } catch (_unused) {
	      onDragLeaveEnd();
	      setIsLoad(false);
	    }
	  };
	  var _onDragLeave = function onDragLeave(e) {
	    e.preventDefault();
	    e.stopPropagation();
	    onDragLeaveEnd();
	  };
	  var onToggleError = function onToggleError() {
	    onDragLeaveEnd();
	    setIsLoad(false);
	    toggleError();
	  };
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: 'uin-drag-area' + (isLoad ? ' loading' : '')
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: 'image-upload-wrap ' + className,
	    onDrop: function onDrop(e) {
	      return _onDrop(e);
	    },
	    onDragLeave: function onDragLeave(e) {
	      return _onDragLeave(e);
	    }
	  }, isLoad && /*#__PURE__*/_react["default"].createElement(_reactstrap.Spinner, {
	    color: "primary"
	  }), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "text-information"
	  }, isLoad ? "".concat(t('loading'), "...") : t('drop-file'))), /*#__PURE__*/_react["default"].createElement(_globalComponentsLibrary.DialogBox, _extends({}, error, {
	    toggle: onToggleError,
	    accept: t('errorFormat.attachErrorCommit')
	  })));
	};
	DragAndDropFile.defaultProps = {
	  className: ''
	};
	var _default = exports["default"] = DragAndDropFile;

/***/ },
/* 1411 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var _react = _interopRequireWildcard(__webpack_require__(1));
	var _helpers = __webpack_require__(53);
	var _MediaViewer = _interopRequireDefault(__webpack_require__(378));
	__webpack_require__(2484);
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
	function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	var GroupingImages = function GroupingImages(_ref) {
	  var arr = _ref.arr;
	  var _useState = (0, _react.useState)(false),
	    _useState2 = _slicedToArray(_useState, 2),
	    isOpen = _useState2[0],
	    setOpen = _useState2[1];
	  var _useState3 = (0, _react.useState)(0),
	    _useState4 = _slicedToArray(_useState3, 2),
	    index = _useState4[0],
	    setIndex = _useState4[1];
	  var _useState5 = (0, _react.useState)([]),
	    _useState6 = _slicedToArray(_useState5, 2),
	    multimedia = _useState6[0],
	    setMultimedia = _useState6[1];
	  (0, _react.useEffect)(function () {
	    if (arr.length > 0) {
	      var arry = arr.map(function (file) {
	        return {
	          url: file,
	          mediaType: 'image'
	        };
	      });
	      setMultimedia(arry);
	    }
	  }, [arr]);
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: 'uin-group-image' + (arr.length > 1 ? ' contain' : '')
	  }, (0, _helpers.groupImages)(arr, function (i) {
	    setOpen(true);
	    setIndex(i);
	  }), /*#__PURE__*/_react["default"].createElement(_MediaViewer["default"], {
	    show: isOpen,
	    toggle: function toggle() {
	      return setOpen(function (o) {
	        return !o;
	      });
	    },
	    multimediaFiles: multimedia,
	    index: index,
	    withFooter: true
	  }));
	};
	var _default = exports["default"] = GroupingImages;

/***/ },
/* 1412 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var _react = _interopRequireWildcard(__webpack_require__(1));
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	var _reactI18next = __webpack_require__(41);
	var _globalComponentsLibrary = __webpack_require__(28);
	var _reactstrap = __webpack_require__(70);
	var _helpers = __webpack_require__(53);
	__webpack_require__(2485);
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
	function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	var LinksModal = function LinksModal(_ref) {
	  var isOpen = _ref.isOpen,
	    setOpen = _ref.setOpen,
	    onInsert = _ref.onInsert,
	    inittext = _ref.inittext,
	    initurl = _ref.initurl;
	  var _useTranslation = (0, _reactI18next.useTranslation)(['links-modal']),
	    t = _useTranslation.t;
	  var _useState = (0, _react.useState)(''),
	    _useState2 = _slicedToArray(_useState, 2),
	    text = _useState2[0],
	    setText = _useState2[1];
	  var _useState3 = (0, _react.useState)(''),
	    _useState4 = _slicedToArray(_useState3, 2),
	    url = _useState4[0],
	    setURL = _useState4[1];
	  var _useState5 = (0, _react.useState)(false),
	    _useState6 = _slicedToArray(_useState5, 2),
	    textError = _useState6[0],
	    setTextError = _useState6[1];
	  var _useState7 = (0, _react.useState)(false),
	    _useState8 = _slicedToArray(_useState7, 2),
	    urlError = _useState8[0],
	    setURLError = _useState8[1];
	  (0, _react.useEffect)(function () {
	    setTextError(false);
	    setURLError(false);
	  }, [text, url]);
	  (0, _react.useEffect)(function () {
	    if (inittext) setText(inittext);
	  }, [inittext]);
	  (0, _react.useEffect)(function () {
	    if (initurl) setURL(initurl);
	  }, [initurl]);
	  (0, _react.useEffect)(function () {
	    if (!isOpen) {
	      setText('');
	      setURL('');
	    }
	  }, [isOpen]);
	  var onInsertBtn = function onInsertBtn() {
	    if (text !== '' && url !== '' && (0, _helpers.isValidURL)(url)) {
	      onInsert({
	        text: text,
	        url: url
	      });
	      setOpen(false);
	    }
	    setTextError(text === '');
	    setURLError(url === '' || !(0, _helpers.isValidURL)(url));
	  };
	  return /*#__PURE__*/_react["default"].createElement(_reactstrap.Modal, {
	    className: "uin-links",
	    isOpen: isOpen,
	    toggle: function toggle() {
	      return setOpen(!isOpen);
	    },
	    centered: true
	  }, /*#__PURE__*/_react["default"].createElement(_reactstrap.ModalHeader, {
	    toggle: function toggle() {
	      return setOpen(!isOpen);
	    }
	  }, " ", t('title')), /*#__PURE__*/_react["default"].createElement(_reactstrap.ModalBody, null, /*#__PURE__*/_react["default"].createElement(_globalComponentsLibrary.LabelInput, {
	    value: text,
	    label: t('label-text'),
	    focus: true,
	    error: textError,
	    errorMessage: t('text-error'),
	    placeholder: t('label-text'),
	    onChange: setText
	  }), /*#__PURE__*/_react["default"].createElement(_globalComponentsLibrary.LabelInput, {
	    value: url,
	    label: t('label-url'),
	    focus: true,
	    error: urlError,
	    errorMessage: t('url-error'),
	    placeholder: t('label-url'),
	    onChange: setURL
	  })), /*#__PURE__*/_react["default"].createElement(_reactstrap.ModalFooter, null, /*#__PURE__*/_react["default"].createElement(_globalComponentsLibrary.Button, {
	    color: "primary",
	    onClick: onInsertBtn,
	    disabled: text === '' || url === ''
	  }, t('insert'))));
	};
	LinksModal.propTypes = {
	  isOpen: _propTypes["default"].bool.isRequired,
	  setOpen: _propTypes["default"].func.isRequired,
	  onInsert: _propTypes["default"].func.isRequired,
	  inittext: _propTypes["default"].string,
	  initurl: _propTypes["default"].string
	};
	var _default = exports["default"] = LinksModal;

/***/ },
/* 1413 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var _react = _interopRequireWildcard(__webpack_require__(1));
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	var _reactstrap = __webpack_require__(70);
	var _globalComponentsLibrary = __webpack_require__(28);
	var _reactI18next = __webpack_require__(41);
	var _slate = __webpack_require__(317);
	var _slateReact = __webpack_require__(483);
	var _ToggleChip = _interopRequireDefault(__webpack_require__(1436));
	var _AddressInput = _interopRequireDefault(__webpack_require__(1430));
	var _IconButton = _interopRequireDefault(__webpack_require__(257));
	var _types = __webpack_require__(60);
	var _helpers = __webpack_require__(53);
	var _LinksModal = _interopRequireDefault(__webpack_require__(1412));
	var _TextEditor = _interopRequireDefault(__webpack_require__(1414));
	var _SlateUtils = __webpack_require__(377);
	__webpack_require__(2486);
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
	function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	var MailEditor = function MailEditor(_ref) {
	  var id = _ref.id,
	    to = _ref.to,
	    from = _ref.from,
	    originalMail = _ref.originalMail,
	    addressList = _ref.addressList,
	    loading = _ref.loading,
	    onSend = _ref.onSend,
	    onDiscard = _ref.onDiscard,
	    onUploadAttachments = _ref.onUploadAttachments,
	    onDeleteAttachment = _ref.onDeleteAttachment,
	    IsAzure = _ref.IsAzure,
	    draft = _ref.draft,
	    onUpdateDraftMessage = _ref.onUpdateDraftMessage,
	    onUpdateDraftAttachments = _ref.onUpdateDraftAttachments,
	    onDeleteDraftMessage = _ref.onDeleteDraftMessage;
	  var _useTranslation = (0, _reactI18next.useTranslation)('mail-editor'),
	    t = _useTranslation.t;
	  var _useState = (0, _react.useState)(false),
	    _useState2 = _slicedToArray(_useState, 2),
	    ccOpen = _useState2[0],
	    setCCOpen = _useState2[1];
	  var _useState3 = (0, _react.useState)(false),
	    _useState4 = _slicedToArray(_useState3, 2),
	    bccOpen = _useState4[0],
	    setBCCOpen = _useState4[1];
	  var _useState5 = (0, _react.useState)([]),
	    _useState6 = _slicedToArray(_useState5, 2),
	    cc = _useState6[0],
	    setCC = _useState6[1];
	  var _useState7 = (0, _react.useState)([]),
	    _useState8 = _slicedToArray(_useState7, 2),
	    bcc = _useState8[0],
	    setBCC = _useState8[1];
	  var _useState9 = (0, _react.useState)(true),
	    _useState10 = _slicedToArray(_useState9, 2),
	    formatOpen = _useState10[0],
	    setFormatOpen = _useState10[1];
	  var _useState11 = (0, _react.useState)(false),
	    _useState12 = _slicedToArray(_useState11, 2),
	    linksModalOpen = _useState12[0],
	    setLinksModalOpen = _useState12[1];
	  var _useState13 = (0, _react.useState)(null),
	    _useState14 = _slicedToArray(_useState13, 2),
	    url = _useState14[0],
	    setUrl = _useState14[1];
	  var _useState15 = (0, _react.useState)(null),
	    _useState16 = _slicedToArray(_useState15, 2),
	    text = _useState16[0],
	    setText = _useState16[1];
	  var handleInsertLink = function handleInsertLink(link) {
	    if (text && url) {
	      _SlateUtils.UINEditor.wrapLinkUpdate(editor, link.url, link.text, url, text);
	    } else {
	      _SlateUtils.UINEditor.wrapLink(editor, link.url, link.text);
	    }
	  };
	  var handleDeleteLink = function handleDeleteLink(url, text) {
	    _SlateUtils.UINEditor.changTypeLinkNode(editor, url, text);
	  };
	  var fileInputRef = (0, _react.useRef)();
	  var _useState17 = (0, _react.useState)(draft.attachments),
	    _useState18 = _slicedToArray(_useState17, 2),
	    attachments = _useState18[0],
	    setAttachments = _useState18[1];
	  var handleAttachments = function handleAttachments(files) {
	    //upload files to server first
	    if (files.length === 1 && (0, _helpers.isImageType)(files[0])) {
	      var reader = new FileReader();
	      reader.addEventListener('load', function () {
	        var url = reader.result;
	        if (IsAzure) {
	          _SlateUtils.UINEditor.insertImage(editor, url, files[0].name, IsAzure);
	        } else {
	          _SlateUtils.UINEditor.insertImage(editor, url);
	        }
	      });
	      reader.readAsDataURL(files[0]);
	      if (IsAzure) {
	        var fileArr = _toConsumableArray(files);
	        setAttachments(function (atts) {
	          return [].concat(_toConsumableArray(atts), _toConsumableArray(fileArr.map(function (f) {
	            return {
	              name: f.name,
	              invalidSize: f.size > 10000000,
	              unsafeType: (0, _helpers.isUnsafeFile)(f),
	              IsInline: true
	            };
	          })));
	        });
	        fileArr.map(function (f) {
	          if (!(0, _helpers.isUnsafeFile)(f) && !(f.size > 10000000)) {
	            var temp = (0, _helpers.mimeTypeLeft)(f.type);
	            var type = temp !== 'image' && temp !== 'video' && temp !== 'audio' ? 'file' : temp;
	            var _url = window.URL.createObjectURL(f);
	            f.preview = {
	              type: type,
	              url: _url
	            };
	            f.urllocal = _url;
	            onUploadAttachments([f]);
	          }
	          return f;
	        });
	      }
	    } else {
	      var _fileArr = _toConsumableArray(files);
	      setAttachments(function (atts) {
	        return [].concat(_toConsumableArray(atts), _toConsumableArray(_fileArr.map(function (f) {
	          return {
	            name: f.name,
	            invalidSize: f.size > 10000000,
	            unsafeType: (0, _helpers.isUnsafeFile)(f),
	            IsInline: false
	          };
	        })));
	      });
	      _fileArr.map(function (f) {
	        if (!(0, _helpers.isUnsafeFile)(f) && !(f.size > 10000000)) {
	          var temp = (0, _helpers.mimeTypeLeft)(f.type);
	          var type = temp !== 'image' && temp !== 'video' && temp !== 'audio' ? 'file' : temp;
	          var _url2 = window.URL.createObjectURL(f);
	          f.preview = {
	            type: type,
	            url: _url2
	          };
	          f.urllocal = _url2;
	          onUploadAttachments([f]);
	        }
	      });
	    }
	  };
	  var onChangeHandler = function onChangeHandler(url, text) {
	    setUrl(url);
	    setText(text);
	    setLinksModalOpen(!linksModalOpen);
	  };
	  (0, _react.useEffect)(function () {
	    if (!linksModalOpen) {
	      setUrl(null);
	      setText(null);
	    }
	  }, [linksModalOpen]);
	  (0, _globalComponentsLibrary.useUpdateEffect)(function () {
	    onUpdateDraftAttachments(id, attachments);
	  }, [id, attachments]);
	  var _useState19 = (0, _react.useState)(false),
	    _useState20 = _slicedToArray(_useState19, 2),
	    quotedOpen = _useState20[0],
	    setQuotedOpen = _useState20[1];
	  var editor = (0, _react.useMemo)(function () {
	    return (0, _SlateUtils.withImages)((0, _SlateUtils.withLinks)((0, _slateReact.withReact)((0, _slate.createEditor)())));
	  }, []);
	  var _useState21 = (0, _react.useState)(draft.data),
	    _useState22 = _slicedToArray(_useState21, 2),
	    value = _useState22[0],
	    setValue = _useState22[1];
	  var handleSend = function handleSend() {
	    var htmlMessage = _SlateUtils.UINEditor.serialize(editor);
	    var dataAttachments = attachments.map(function (a) {
	      return [{
	        ContentId: a.name,
	        IsInline: a.IsInline
	      }];
	    });
	    dataAttachments = [].concat.apply([], dataAttachments);
	    onSend(id, 'Re: ' + originalMail.subject, htmlMessage, dataAttachments, cc.map(function (c) {
	      return c.account;
	    }), bcc.map(function (c) {
	      return c.account;
	    }), IsAzure);
	    setValue([{
	      type: 'paragraph',
	      children: [{
	        text: '',
	        font: 'Arial',
	        size: '14px'
	      }]
	    }]);
	    _SlateUtils.UINEditor.deleteMark(editor);
	  };
	  (0, _react.useEffect)(function () {
	    if (draft) {
	      setValue(draft.data);
	      setAttachments(draft.attachments);
	    } else {
	      handleDiscard();
	    }
	  }, [id]);
	  var onChangeEditor = function onChangeEditor(value) {
	    setValue(value);
	    onUpdateDraftMessage(id, value);
	  };
	  var handleDiscard = function handleDiscard() {
	    onDiscard();
	    setQuotedOpen(false);
	    setCCOpen(false);
	    setCC([]);
	    setBCCOpen(false);
	    setBCC([]);
	    setFormatOpen(true);
	    attachments.forEach(function (f) {
	      if (!f.unsafeType && !f.invalidSize) {
	        onDeleteAttachment(f.name);
	      }
	    });
	    setAttachments([]);
	    _SlateUtils.UINEditor.resetSelection(editor);
	    editor.selection = {
	      anchor: {
	        path: [0, 0],
	        offset: 0
	      },
	      focus: {
	        path: [0, 0],
	        offset: 0
	      }
	    };
	    setValue([{
	      type: 'paragraph',
	      children: [{
	        text: '',
	        font: 'Arial',
	        size: '14px'
	      }]
	    }]);
	    onDeleteDraftMessage(id);
	  };
	  var onDeleteAttachmentHandle = function onDeleteAttachmentHandle(a, i) {
	    if (!a.unsafeType && !a.invalidSize) {
	      onDeleteAttachment(a.name);
	    }
	    setAttachments(function (atts) {
	      return atts.filter(function (_, index) {
	        return index !== i;
	      });
	    });
	  };
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-mail-editor"
	  }, /*#__PURE__*/_react["default"].createElement(_globalComponentsLibrary.DragNDrop, {
	    placeholder: t('drop-files'),
	    onFileDrop: handleAttachments
	  }), /*#__PURE__*/_react["default"].createElement("header", null, /*#__PURE__*/_react["default"].createElement("span", {
	    className: "uin-med-to"
	  }, to.name, " (", to.account, ")"), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-med-chips"
	  }, /*#__PURE__*/_react["default"].createElement(_ToggleChip["default"], {
	    id: 'uin-med-cc-chip-' + id,
	    label: t('cc'),
	    tabIndex: 1,
	    active: ccOpen,
	    toggle: function toggle() {
	      return setCCOpen(!ccOpen);
	    }
	  }), /*#__PURE__*/_react["default"].createElement(_ToggleChip["default"], {
	    id: 'uin-med-bcc-chip-' + id,
	    label: t('bcc'),
	    tabIndex: 2,
	    active: bccOpen,
	    toggle: function toggle() {
	      return setBCCOpen(!bccOpen);
	    }
	  }))), /*#__PURE__*/_react["default"].createElement(_reactstrap.Collapse, {
	    isOpen: ccOpen,
	    className: "uin-med-addr"
	  }, /*#__PURE__*/_react["default"].createElement(_AddressInput["default"], {
	    label: t('cc'),
	    list: addressList,
	    selected: cc,
	    onSelect: function onSelect(c) {
	      return setCC(function (l) {
	        return [].concat(_toConsumableArray(l), [c]);
	      });
	    },
	    onEdit: function onEdit(index, contact) {
	      return setCC(function (l) {
	        return (0, _helpers.updateArrayImmutably)(l, index, contact);
	      });
	    },
	    onDelete: function onDelete(index) {
	      return setCC(function (l) {
	        return l.filter(function (_, i) {
	          return i !== index;
	        });
	      });
	    }
	  })), /*#__PURE__*/_react["default"].createElement(_reactstrap.Collapse, {
	    isOpen: bccOpen,
	    className: "uin-med-addr"
	  }, /*#__PURE__*/_react["default"].createElement(_AddressInput["default"], {
	    label: t('bcc'),
	    list: addressList,
	    selected: bcc,
	    onSelect: function onSelect(c) {
	      return setBCC(function (l) {
	        return [].concat(_toConsumableArray(l), [c]);
	      });
	    },
	    onEdit: function onEdit(index, contact) {
	      return setBCC(function (l) {
	        return (0, _helpers.updateArrayImmutably)(l, index, contact);
	      });
	    },
	    onDelete: function onDelete(index) {
	      return setBCC(function (l) {
	        return l.filter(function (_, i) {
	          return i !== index;
	        });
	      });
	    }
	  })), /*#__PURE__*/_react["default"].createElement(_slateReact.Slate, {
	    editor: editor,
	    value: value,
	    onChange: function onChange(value) {
	      return onChangeEditor(value);
	    }
	  }, /*#__PURE__*/_react["default"].createElement(_TextEditor["default"], {
	    id: id,
	    to: to,
	    from: from,
	    originalMail: originalMail,
	    formatOpen: formatOpen,
	    attachments: attachments,
	    quotedOpen: quotedOpen,
	    setQuotedOpen: setQuotedOpen,
	    disabled: loading,
	    onDeleteAttachment: onDeleteAttachmentHandle,
	    setLinksModalOpen: onChangeHandler,
	    handleDeleteLink: handleDeleteLink
	  })), /*#__PURE__*/_react["default"].createElement("footer", null, /*#__PURE__*/_react["default"].createElement(_globalComponentsLibrary.Button, {
	    color: "primary",
	    onClick: handleSend,
	    disabled: loading || attachments && attachments.some(function (i) {
	      return i.unsafeType === true || i.invalidSize;
	    })
	  }, t('send')), loading ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_reactstrap.Spinner, {
	    color: "primary"
	  }), /*#__PURE__*/_react["default"].createElement("span", {
	    className: "uin-med-loading-label"
	  }, t('sending'))) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
	    id: 'uin-med-format-icon-' + id,
	    icon: "text-edit",
	    secondary: true,
	    active: formatOpen,
	    onClick: function onClick() {
	      return setFormatOpen(!formatOpen);
	    }
	  }), /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
	    id: 'uin-med-attach-icon-' + id,
	    icon: "clip-right",
	    secondary: true,
	    onClick: function onClick() {
	      return fileInputRef.current.click();
	    }
	  }), /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
	    id: 'uin-med-link-icon-' + id,
	    icon: "link",
	    secondary: true,
	    onClick: function onClick() {
	      return setLinksModalOpen(!linksModalOpen);
	    }
	  })), /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
	    id: 'uin-med-discard-icon-' + id,
	    icon: "trash",
	    secondary: true,
	    disabled: loading,
	    onClick: handleDiscard
	  })), /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
	    target: 'uin-med-cc-chip-' + id,
	    offset: "0,4"
	  }, t('add-cc')), /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
	    target: 'uin-med-bcc-chip-' + id,
	    offset: "0,4"
	  }, t('add-bcc')), /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
	    target: 'uin-med-toggle-quote-' + id,
	    offset: "0,8"
	  }, t('show-quoted')), !loading && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
	    target: 'uin-med-format-icon-' + id,
	    offset: "0,4"
	  }, t('format')), /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
	    target: 'uin-med-attach-icon-' + id,
	    offset: "0,4"
	  }, t('attach')), /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
	    target: 'uin-med-link-icon-' + id,
	    offset: "0,4"
	  }, t('link'))), /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
	    target: 'uin-med-discard-icon-' + id,
	    offset: "0,4"
	  }, t('discard')), /*#__PURE__*/_react["default"].createElement(_LinksModal["default"], {
	    isOpen: linksModalOpen,
	    setOpen: setLinksModalOpen,
	    onInsert: handleInsertLink,
	    inittext: text,
	    initurl: url
	  }), /*#__PURE__*/_react["default"].createElement("input", {
	    type: "file",
	    hidden: true,
	    multiple: true,
	    ref: fileInputRef,
	    onChange: function onChange(e) {
	      return handleAttachments(e.currentTarget.files);
	    }
	  }));
	};
	MailEditor.propTypes = {
	  id: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired,
	  to: _types.contactType.isRequired,
	  from: _types.contactType.isRequired,
	  originalMail: _types.messageType,
	  addressList: _propTypes["default"].arrayOf(_types.contactType),
	  onDiscard: _propTypes["default"].func.isRequired
	};
	MailEditor.defaultProps = {
	  draft: {
	    data: [{
	      type: 'paragraph',
	      children: [{
	        text: '',
	        font: 'Arial',
	        size: '14px'
	      }]
	    }],
	    attachments: []
	  }
	};
	var _default = exports["default"] = MailEditor;

/***/ },
/* 1414 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var _react = _interopRequireWildcard(__webpack_require__(1));
	var _reactstrap = __webpack_require__(70);
	var _slateReact = __webpack_require__(483);
	var _slate = __webpack_require__(317);
	var _reactI18next = __webpack_require__(41);
	var _reactHtmlParser = _interopRequireDefault(__webpack_require__(597));
	var _InputChip = _interopRequireDefault(__webpack_require__(594));
	var _formatters = __webpack_require__(83);
	var _constants = __webpack_require__(58);
	var _StylesGallery = _interopRequireDefault(__webpack_require__(1424));
	var _SlateUtils = __webpack_require__(377);
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
	function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
	function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
	function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
	function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	var Element = function Element(_ref) {
	  var attributes = _ref.attributes,
	    element = _ref.element,
	    children = _ref.children,
	    setLinksModalOpen = _ref.setLinksModalOpen,
	    handleDeleteLink = _ref.handleDeleteLink,
	    setCancelList = _ref.setCancelList;
	  switch (element.type) {
	    case 'bulleted-list':
	      setCancelList(false);
	      var n = _slate.Node.get(element, [0, 0]);
	      return /*#__PURE__*/_react["default"].createElement("ul", _extends({}, attributes, {
	        style: {
	          color: n.color,
	          fontSize: n.size,
	          fontFamily: _constants.FONTS[n.font]
	        }
	      }), children);
	    case 'list-item':
	      if (children[0].props.text.text === '') {
	        setCancelList(true);
	      }
	      return /*#__PURE__*/_react["default"].createElement("li", attributes, children);
	    case 'numbered-list':
	      setCancelList(false);
	      var n1 = _slate.Node.get(element, [0, 0]);
	      return /*#__PURE__*/_react["default"].createElement("ol", _extends({}, attributes, {
	        style: {
	          color: n1.color,
	          fontSize: n1.size,
	          fontFamily: _constants.FONTS[n1.font]
	        }
	      }), children);
	    case 'link':
	      return /*#__PURE__*/_react["default"].createElement(LinkElement, {
	        attributes: attributes,
	        element: element,
	        children: children,
	        setLinksModalOpen: setLinksModalOpen,
	        handleDeleteLink: handleDeleteLink
	      });
	    case 'image':
	      return /*#__PURE__*/_react["default"].createElement(ImageElement, {
	        attributes: attributes,
	        element: element,
	        children: children
	      });
	    default:
	      return /*#__PURE__*/_react["default"].createElement("div", _extends({}, attributes, {
	        style: {
	          textAlign: element.align
	        }
	      }), children);
	  }
	};
	var ImageElement = function ImageElement(_ref2) {
	  var attributes = _ref2.attributes,
	    children = _ref2.children,
	    element = _ref2.element;
	  var selected = (0, _slateReact.useSelected)();
	  var focused = (0, _slateReact.useFocused)();
	  return /*#__PURE__*/_react["default"].createElement("div", _extends({}, attributes, {
	    style: {
	      textAlign: element.align
	    }
	  }), /*#__PURE__*/_react["default"].createElement("div", {
	    contentEditable: false
	  }, /*#__PURE__*/_react["default"].createElement("img", {
	    alt: "",
	    src: element.url,
	    style: {
	      boxShadow: selected && focused ? '0 0 0 3px #007fff52' : 'none'
	    }
	  })), children);
	};
	var LinkElement = function LinkElement(_ref3) {
	  var attributes = _ref3.attributes,
	    children = _ref3.children,
	    element = _ref3.element,
	    setLinksModalOpen = _ref3.setLinksModalOpen,
	    handleDeleteLink = _ref3.handleDeleteLink;
	  var _useTranslation = (0, _reactI18next.useTranslation)('mail-editor'),
	    t = _useTranslation.t;
	  var refTooltip = (0, _react.useRef)();
	  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("a", _extends({}, attributes, {
	    href: element.url,
	    ref: refTooltip
	  }), children), /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
	    placement: "top",
	    target: refTooltip,
	    autohide: true,
	    trigger: "legacy"
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-med-group-options"
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-med-open"
	  }, /*#__PURE__*/_react["default"].createElement("a", {
	    href: validateLink(element.url),
	    rel: "noopener noreferrer",
	    target: "_blank"
	  }, t('openlink'))), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-med-change",
	    onClick: function onClick() {
	      return setLinksModalOpen(element.url, element.children[0].text);
	    }
	  }, t('change')), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-med-remove",
	    onClick: function onClick() {
	      return handleDeleteLink(element.url, element.children[0].text);
	    }
	  }, t('delete')))));
	};
	var validateLink = function validateLink(url) {
	  var defaultProtocol = 'http://';
	  var protocol = 'https://';
	  return url.includes(defaultProtocol) || url.includes(protocol) ? url : defaultProtocol + url;
	};
	var Leaf = function Leaf(_ref4) {
	  var attributes = _ref4.attributes,
	    leaf = _ref4.leaf,
	    children = _ref4.children;
	  return /*#__PURE__*/_react["default"].createElement("span", _extends({}, attributes, {
	    style: {
	      color: leaf.color,
	      fontSize: leaf.size,
	      fontFamily: _constants.FONTS[leaf.font]
	    }
	  }), children);
	};
	var TextEditor = function TextEditor(_ref5) {
	  var id = _ref5.id,
	    to = _ref5.to,
	    from = _ref5.from,
	    originalMail = _ref5.originalMail,
	    quotedOpen = _ref5.quotedOpen,
	    setQuotedOpen = _ref5.setQuotedOpen,
	    formatOpen = _ref5.formatOpen,
	    _ref5$attachments = _ref5.attachments,
	    attachments = _ref5$attachments === void 0 ? [] : _ref5$attachments,
	    onDeleteAttachment = _ref5.onDeleteAttachment,
	    disabled = _ref5.disabled,
	    setLinksModalOpen = _ref5.setLinksModalOpen,
	    handleDeleteLink = _ref5.handleDeleteLink;
	  var _useTranslation2 = (0, _reactI18next.useTranslation)('mail-editor'),
	    t = _useTranslation2.t,
	    i18n = _useTranslation2.i18n;
	  var editor = (0, _slateReact.useSlate)();
	  var _useState = (0, _react.useState)(false),
	    _useState2 = _slicedToArray(_useState, 2),
	    cancelList = _useState2[0],
	    setCancelList = _useState2[1];
	  var renderElement = (0, _react.useCallback)(function (props) {
	    return /*#__PURE__*/_react["default"].createElement(Element, _extends({}, props, {
	      setLinksModalOpen: setLinksModalOpen,
	      handleDeleteLink: handleDeleteLink,
	      setCancelList: setCancelList
	    }));
	  }, [setLinksModalOpen, handleDeleteLink]);
	  var renderLeaf = (0, _react.useCallback)(function (props) {
	    return /*#__PURE__*/_react["default"].createElement(Leaf, props);
	  }, []);
	  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-med-content"
	  }, /*#__PURE__*/_react["default"].createElement(_slateReact.Editable, {
	    renderElement: renderElement,
	    renderLeaf: renderLeaf,
	    spellCheck: true,
	    readOnly: disabled,
	    onKeyDown: function onKeyDown(event) {
	      var auxedit = _objectSpread({}, editor);
	      var firstChild = _SlateUtils.UINEditor.getNodeList(auxedit, 'numbered-list') !== undefined ? _SlateUtils.UINEditor.getNodeList(auxedit, 'numbered-list') : _SlateUtils.UINEditor.getNodeList(auxedit, 'bulleted-list');
	      if (event.key === 'Backspace' && (_slate.Node.get(auxedit, [firstChild ? firstChild : 0]).type === 'bulleted-list' || _slate.Node.get(auxedit, [firstChild ? firstChild : 0]).type === 'numbered-list') && (_slate.Node.get(auxedit, [firstChild, 0, 0]).text === '' || cancelList)) {
	        event.preventDefault();
	        if (!_slateReact.ReactEditor.isFocused(editor)) _slateReact.ReactEditor.focus(editor);
	        _SlateUtils.UINEditor.toggleType(editor, _slate.Node.get(auxedit, [firstChild]).type);
	        setCancelList(false);
	      }
	    }
	  }), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-med-toggle-quote-wrap"
	  }, /*#__PURE__*/_react["default"].createElement("span", {
	    id: 'uin-med-toggle-quote-' + id,
	    className: "uin-med-quoted-btn",
	    onClick: function onClick() {
	      return setQuotedOpen(!quotedOpen);
	    }
	  }, /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon more-left"
	  }))), /*#__PURE__*/_react["default"].createElement("div", {
	    className: 'uin-med-quote' + (quotedOpen ? ' show' : ''),
	    contentEditable: true,
	    suppressContentEditableWarning: true
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-med-quote-details"
	  }, /*#__PURE__*/_react["default"].createElement("p", null, "".concat(t('from'), ": ").concat(to.name, " <").concat(to.account, ">")), /*#__PURE__*/_react["default"].createElement("p", null, t('sent'), ": ", (0, _formatters.formatMailDate)(originalMail.date, i18n.language.slice(0, 2))), /*#__PURE__*/_react["default"].createElement("p", null, t('to'), ": ", from.name, from.account ? " <".concat(from.account, ">") : ''), /*#__PURE__*/_react["default"].createElement("p", null, t('subject'), ": ", originalMail.subject)), /*#__PURE__*/_react["default"].createElement("blockquote", null, (0, _reactHtmlParser["default"])(originalMail.content)))), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-med-attachments"
	  }, attachments.map(function (a, i) {
	    if (!a.IsInline) return /*#__PURE__*/_react["default"].createElement(_InputChip["default"], {
	      key: i,
	      color: "blue",
	      label: a.name,
	      errorMessage: a.unsafeType ? t('unsafe-file') : a.invalidSize ? t('invalid-size') : undefined,
	      onDelete: function onDelete() {
	        return onDeleteAttachment(a, i);
	      }
	    });
	  })), /*#__PURE__*/_react["default"].createElement(_reactstrap.Collapse, {
	    isOpen: formatOpen,
	    className: "uin-med-format"
	  }, /*#__PURE__*/_react["default"].createElement(_StylesGallery["default"], {
	    id: id
	  })));
	};
	var _default = exports["default"] = TextEditor;

/***/ },
/* 1415 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var _react = _interopRequireWildcard(__webpack_require__(1));
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	var _reactI18next = __webpack_require__(41);
	var _formatters = __webpack_require__(83);
	var _types = __webpack_require__(60);
	var _ImageIcon = _interopRequireDefault(__webpack_require__(167));
	var _Stopwatch = _interopRequireDefault(__webpack_require__(145));
	__webpack_require__(2487);
	var _constants = __webpack_require__(58);
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
	function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	var MailListItem = function MailListItem(_ref) {
	  var id = _ref.id,
	    _ref$contact = _ref.contact,
	    user = _ref$contact.name,
	    account = _ref$contact.account,
	    subject = _ref.subject,
	    mails = _ref.mails,
	    campaign = _ref.campaign,
	    date = _ref.date,
	    unread = _ref.unread,
	    active = _ref.active,
	    timeUnattended = _ref.timeUnattended,
	    warning = _ref.warning,
	    onClick = _ref.onClick,
	    activeMail = _ref.activeMail,
	    onMailClick = _ref.onMailClick;
	  var _useState = (0, _react.useState)(false),
	    _useState2 = _slicedToArray(_useState, 2),
	    open = _useState2[0],
	    setOpen = _useState2[1];
	  var _useTranslation = (0, _reactI18next.useTranslation)('commons'),
	    t = _useTranslation.t,
	    i18n = _useTranslation.i18n;
	  var lang = i18n.language.slice(0, 2);
	  var multiple = mails.length > 1;
	  var hasAttachments = !multiple && mails[0] && mails[0].media && mails[0].media.length > 0;
	  var displaySubject = mails.length === 0 ? /*#__PURE__*/_react["default"].createElement("em", {
	    className: "uin-lic-new-ph"
	  }, t('new-convo')) : subject || t('no-subject');
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    id: id,
	    className: "uin-list-item uin-mail-list-item ".concat(open ? 'open' : '', " ").concat(active ? 'active' : '', " ").concat(warning ? 'warning' : ''),
	    onClick: onClick
	  }, !multiple && /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-lic-bar"
	  }), unread && !open && /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-lic-dot"
	  }), /*#__PURE__*/_react["default"].createElement("div", {
	    className: 'uin-mli-message' + (multiple ? ' multiple' : '')
	  }, /*#__PURE__*/_react["default"].createElement(_ImageIcon["default"], {
	    name: campaign.name,
	    image: campaign.image
	  }), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-mli-preview"
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-mli-row r1"
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-mli-col a1 c100"
	  }, user), !multiple && /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-mli-col a2 c600"
	  }, (0, _formatters.formatDateShort)(mails[0].date, lang), " ", (0, _formatters.formatTimeShort24hrs)(mails[0].date, lang), " ", lang == 'es' ? 'h' : 'hr'), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-mli-col a3"
	  }, multiple ? mails.length : '')), /*#__PURE__*/_react["default"].createElement("div", {
	    className: 'uin-mli-row r2 ' + (multiple ? 'c900' : 'c500')
	  }, displaySubject), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-mli-row r3 c600"
	  }, /*#__PURE__*/_react["default"].createElement("div", null, account), timeUnattended !== null && /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-lic-timeout"
	  }, /*#__PURE__*/_react["default"].createElement(_Stopwatch["default"], {
	    initialTime: timeUnattended,
	    currentDate: date
	  })))), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-mli-icons"
	  }, /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon mail uin-lic-icon"
	  }), hasAttachments && /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon clip"
	  })), multiple && /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-mli-chevron",
	    onClick: function onClick(e) {
	      e.stopPropagation();
	      setOpen(!open);
	    }
	  }, /*#__PURE__*/_react["default"].createElement("i", {
	    className: 'gcl-icon chevron' + (open ? '-up' : '')
	  }))), multiple && /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-mli-submessages",
	    style: {
	      height: open ? mails.length * 61 + 'px' : '0px'
	    }
	  }, mails.map(function (mail) {
	    return /*#__PURE__*/_react["default"].createElement("div", {
	      key: mail.id,
	      className: 'uin-mli-mails-accordion' + (activeMail === mail.id ? ' active' : ''),
	      onClick: function onClick() {
	        return onMailClick(mail.id);
	      }
	    }, /*#__PURE__*/_react["default"].createElement("div", {
	      className: "uin-lic-bar"
	    }), !mail.seen && /*#__PURE__*/_react["default"].createElement("div", {
	      className: "uin-lic-dot"
	    }), /*#__PURE__*/_react["default"].createElement("div", {
	      className: "uin-mli-row r1"
	    }, /*#__PURE__*/_react["default"].createElement("div", {
	      className: "uin-mli-col a1 c100"
	    }, mail.origin === _constants.MSG_SOURCE.USER ? user : 'AGENT'), /*#__PURE__*/_react["default"].createElement("div", {
	      className: "uin-mli-col a2"
	    }, (0, _formatters.formatDateShort)(mail.date, lang), " ", (0, _formatters.formatTimeShort24hrs)(date, lang), " ", lang == 'es' ? 'h' : 'hr')), /*#__PURE__*/_react["default"].createElement("div", {
	      className: "uin-mli-row r2"
	    }, /*#__PURE__*/_react["default"].createElement("div", {
	      className: "uin-mli-col b1"
	    }, mail.content), /*#__PURE__*/_react["default"].createElement("div", {
	      className: "uin-mli-col b2"
	    }, mail.media && mail.media.length > 0 && /*#__PURE__*/_react["default"].createElement("i", {
	      className: "gcl-icon clip"
	    }))));
	  })));
	};
	MailListItem.propTypes = {
	  id: _propTypes["default"].number,
	  contact: _types.contactType.isRequired,
	  campaign: _types.campaignType.isRequired,
	  subject: _propTypes["default"].string,
	  mails: _propTypes["default"].arrayOf(_types.messageType),
	  date: _propTypes["default"].instanceOf(Date).isRequired,
	  unread: _propTypes["default"].bool,
	  active: _propTypes["default"].bool,
	  activeMail: _propTypes["default"].number,
	  timeUnattended: _propTypes["default"].instanceOf(Date),
	  warning: _propTypes["default"].bool,
	  onClick: _propTypes["default"].func.isRequired,
	  onMailClick: _propTypes["default"].func
	};
	MailListItem.defaultProps = {
	  mails: [],
	  timeUnattended: null
	};
	var _default = exports["default"] = MailListItem;

/***/ },
/* 1416 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var _react = _interopRequireWildcard(__webpack_require__(1));
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	var _globalComponentsLibrary = __webpack_require__(28);
	var _reactI18next = __webpack_require__(41);
	var _filePreviewPh = _interopRequireDefault(__webpack_require__(1731));
	__webpack_require__(2489);
	var _helpers = __webpack_require__(53);
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	var MediaViewerAttachment = function MediaViewerAttachment(_ref) {
	  var toggle = _ref.toggle,
	    media = _ref.media,
	    mediaType = _ref.mediaType,
	    fileName = _ref.fileName,
	    fileSize = _ref.fileSize;
	  var _useTranslation = (0, _reactI18next.useTranslation)('media-viewer'),
	    t = _useTranslation.t;
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-media-viewer-attach"
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-media-viewer-header"
	  }, mediaType === 'file' && /*#__PURE__*/_react["default"].createElement("span", {
	    className: "uin-media-viewer-title"
	  }, fileName), /*#__PURE__*/_react["default"].createElement(_globalComponentsLibrary.ButtonIcon, {
	    icon: "close",
	    onClick: toggle
	  })), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-media-viewer-content"
	  }, {
	    image: /*#__PURE__*/_react["default"].createElement("img", {
	      src: media,
	      alt: fileName
	    }),
	    video: /*#__PURE__*/_react["default"].createElement("video", {
	      preload: "auto",
	      controls: true,
	      src: media
	    }),
	    audio: /*#__PURE__*/_react["default"].createElement("audio", {
	      preload: "auto",
	      controls: true,
	      src: media
	    }),
	    file: /*#__PURE__*/_react["default"].createElement("div", {
	      className: "uin-media-viewer-file"
	    }, /*#__PURE__*/_react["default"].createElement("img", {
	      src: _filePreviewPh["default"],
	      alt: "file"
	    }), /*#__PURE__*/_react["default"].createElement("span", {
	      className: "uin-media-viewer-label"
	    }, t('no-preview')), /*#__PURE__*/_react["default"].createElement("span", {
	      className: "uin-media-viewer-data"
	    }, typeof fileSize === 'number' ? (0, _helpers.fileSizeReadable)(fileSize) : fileSize, " - ", (0, _helpers.fileExtension)(fileName).toUpperCase()))
	  }[mediaType]));
	};
	MediaViewerAttachment.propTypes = {
	  toggle: _propTypes["default"].func.isRequired,
	  media: _propTypes["default"].string.isRequired,
	  fileName: _propTypes["default"].string,
	  fileSize: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  mediaType: _propTypes["default"].oneOf(['image', 'video', 'audio', 'file']).isRequired
	};
	MediaViewerAttachment.defaultProps = {
	  mediaType: 'file',
	  fileSize: '0 kB'
	};
	var _default = exports["default"] = MediaViewerAttachment;

/***/ },
/* 1417 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var _globalComponentsLibrary = __webpack_require__(28);
	var _react = _interopRequireWildcard(__webpack_require__(1));
	var _reactI18next = __webpack_require__(41);
	var _constants = __webpack_require__(58);
	var _helpers = __webpack_require__(53);
	var _hooks = __webpack_require__(168);
	__webpack_require__(2490);
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
	function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	var FileSlider = function FileSlider(_ref) {
	  var media = _ref.media,
	    selected = _ref.selected,
	    onSelect = _ref.onSelect,
	    onUploadAttachments = _ref.onUploadAttachments,
	    onDeleteAttachment = _ref.onDeleteAttachment,
	    mediaType = _ref.mediaType,
	    maxImgToSend = _ref.maxImgToSend;
	  var _useTranslation = (0, _reactI18next.useTranslation)(['chat']),
	    t = _useTranslation.t;
	  var sliderRef = (0, _react.useRef)(null);
	  var inputRef = (0, _react.useRef)(null);
	  var _useState = (0, _react.useState)(false),
	    _useState2 = _slicedToArray(_useState, 2),
	    isDown = _useState2[0],
	    setIsDown = _useState2[1];
	  var _useError = (0, _hooks.useError)(),
	    _useError2 = _slicedToArray(_useError, 3),
	    error = _useError2[0],
	    showError = _useError2[1],
	    toggleError = _useError2[2];
	  var _useState3 = (0, _react.useState)({
	      startX: 0,
	      scrollLeft: 0
	    }),
	    _useState4 = _slicedToArray(_useState3, 2),
	    position = _useState4[0],
	    setPosition = _useState4[1];
	  var onClickMiniature = function onClickMiniature(id) {
	    onSelect(id);
	  };
	  var mouseDown = function mouseDown(e) {
	    setIsDown(true);
	    setPosition({
	      startX: sliderRef.current.offsetLeft,
	      scrollLeft: sliderRef.current.offsetTop
	    });
	  };
	  var mouseUp = function mouseUp(e) {
	    setIsDown(false);
	    sliderRef.current.classList.remove('sliding');
	  };
	  var mouseMove = function mouseMove(e) {
	    if (!isDown) return;
	    e.preventDefault();
	    sliderRef.current.classList.add('sliding');
	    var eventPosition = e.pageX - sliderRef.current.offsetLef;
	    var slide = eventPosition - position.startX;
	    sliderRef.current.offsetLef = position.scrollLeft - slide;
	  };
	  var slide = function slide(direction) {
	    var slideAmount = calculateSlideAmount(direction);
	    var start = sliderRef.current.scrollLeft;
	    smoothHorizontalScroll(500, slideAmount, start);
	  };
	  var calculateSlideAmount = function calculateSlideAmount(direction) {
	    var _slider = sliderRef.current;
	    var currentView = direction === 'left' ? _slider.scrollLeft + _slider.offsetWidth : _slider.scrollLeft;
	    var childNodes = Array.from(_slider.children);
	    var nodeWidthSum = 0;
	    for (var _i = 0, _childNodes = childNodes; _i < _childNodes.length; _i++) {
	      var node = _childNodes[_i];
	      var nodeWidth = (0, _helpers.getOuterWidth)(node);
	      nodeWidthSum += nodeWidth;
	      if (nodeWidthSum >= currentView) {
	        var showingPart = direction === 'left' ? nodeWidthSum - currentView : nodeWidth;
	        return (_slider.offsetWidth - showingPart) * direction;
	      }
	    }
	    return _slider.offsetWidth;
	  };
	  var smoothHorizontalScroll = function smoothHorizontalScroll(time, amount, start) {
	    var curTime = 0;
	    for (var scrollCounter = 0; curTime <= time; scrollCounter++) {
	      window.setTimeout(smoothHorizontalScrollBehavior, curTime, scrollCounter * amount / 100 + start);
	      curTime += time / 100;
	    }
	  };
	  var smoothHorizontalScrollBehavior = function smoothHorizontalScrollBehavior(amount) {
	    sliderRef.current.scrollLeft = amount;
	  };
	  var getFiles = (0, _hooks.useFileHandler)(mediaType, maxImgToSend, showError);
	  var addAttachments = function addAttachments(e) {
	    try {
	      onUploadAttachments(getFiles(e.target.files));
	    } catch (err) {
	      console.log(err);
	    }
	  };
	  (0, _react.useEffect)(function () {
	    if (media.length > 0 && selected == null) {
	      onSelect(media.length - 1);
	    }
	  }, [media, selected]);
	  var onClickAttach = function onClickAttach() {
	    inputRef.current.click();
	  };
	  var onClose = function onClose(e, i) {
	    e.stopPropagation();
	    onDeleteAttachment(media[i]);
	  };
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-miniaturs-content"
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-miniaturs-wrapper",
	    ref: sliderRef,
	    onMouseDown: function onMouseDown(e) {
	      return mouseDown(e);
	    },
	    onMouseLeave: function onMouseLeave(e) {
	      return mouseUp(e);
	    },
	    onMouseUp: function onMouseUp(e) {
	      return mouseUp(e);
	    },
	    onMouseMove: function onMouseMove(e) {
	      return mouseMove(e);
	    }
	  }, media.map(function (val, i) {
	    return /*#__PURE__*/_react["default"].createElement("div", {
	      key: i,
	      className: 'uin-miniaturs' + (selected === i ? ' active' : ''),
	      onClick: function onClick() {
	        return onClickMiniature(i);
	      }
	    }, val.type === 'image' ? /*#__PURE__*/_react["default"].createElement("img", {
	      src: val.url,
	      alt: "preview"
	    }) : val.type === 'video' ? /*#__PURE__*/_react["default"].createElement("video", {
	      src: val.url,
	      preload: "metadata"
	    }) : val.type === 'audio' ? /*#__PURE__*/_react["default"].createElement("i", {
	      className: "gcl-icon large headset"
	    }) : /*#__PURE__*/_react["default"].createElement("i", {
	      className: 'gcl-icon large ' + _constants.FILE_ICONS[(0, _helpers.fileExtension)(val.name || val.url).toLowerCase()]
	    }), /*#__PURE__*/_react["default"].createElement("div", {
	      className: "uin-miniatur-header"
	    }, /*#__PURE__*/_react["default"].createElement("i", {
	      className: "gcl-icon close",
	      onClick: function onClick(e) {
	        return onClose(e, i);
	      }
	    })));
	  }), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-miniaturs attach",
	    onClick: onClickAttach
	  }, /*#__PURE__*/_react["default"].createElement("input", {
	    type: "file",
	    multiple: true,
	    className: "input",
	    ref: inputRef,
	    onChange: addAttachments
	  }), /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon plus"
	  }))), /*#__PURE__*/_react["default"].createElement(_globalComponentsLibrary.DialogBox, _extends({}, error, {
	    toggle: toggleError,
	    accept: t('errorFormat.attachErrorCommit')
	  })));
	};
	var _default = exports["default"] = FileSlider;

/***/ },
/* 1418 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var _react = __webpack_require__(1);
	function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
	function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
	function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
	function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	var useRecorder = function useRecorder() {
	  var _useState = (0, _react.useState)(null),
	    _useState2 = _slicedToArray(_useState, 2),
	    audioURL = _useState2[0],
	    setAudioURL = _useState2[1];
	  var _useState3 = (0, _react.useState)(false),
	    _useState4 = _slicedToArray(_useState3, 2),
	    isRecording = _useState4[0],
	    setIsRecording = _useState4[1];
	  var _useState5 = (0, _react.useState)(null),
	    _useState6 = _slicedToArray(_useState5, 2),
	    recorder = _useState6[0],
	    setRecorder = _useState6[1];
	
	  // Obtain the audio when ready.
	  var handleData = function handleData(e) {
	    var blob = new Blob([e.data], {
	      type: 'audio/ogg; codecs=opus'
	    });
	    setAudioURL({
	      data: blob,
	      url: URL.createObjectURL(blob)
	    });
	  };
	  (0, _react.useEffect)(function () {
	    if (recorder === null) {
	      if (isRecording) {
	        requestRecorder().then(function (r) {
	          r.addEventListener('dataavailable', handleData);
	          setRecorder(r);
	        }, console.error);
	      }
	      return;
	    }
	
	    // Manage recorder state.
	    if (isRecording) {
	      recorder.start();
	    } else {
	      recorder.stop();
	    }
	  }, [recorder, isRecording]);
	  var startRecording = function startRecording() {
	    setIsRecording(true);
	  };
	  var stopRecording = function stopRecording() {
	    setIsRecording(false);
	  };
	  return [audioURL, setAudioURL, isRecording, startRecording, stopRecording];
	};
	function requestRecorder() {
	  return _requestRecorder.apply(this, arguments);
	}
	function _requestRecorder() {
	  _requestRecorder = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
	    var stream;
	    return _regeneratorRuntime().wrap(function _callee$(_context) {
	      while (1) switch (_context.prev = _context.next) {
	        case 0:
	          if (!navigator.mediaDevices) {
	            _context.next = 7;
	            break;
	          }
	          _context.next = 3;
	          return navigator.mediaDevices.getUserMedia({
	            audio: true
	          });
	        case 3:
	          stream = _context.sent;
	          return _context.abrupt("return", new MediaRecorder(stream));
	        case 7:
	          console.warn('Media Devices will work only with SSL.....');
	        case 8:
	        case "end":
	          return _context.stop();
	      }
	    }, _callee);
	  }));
	  return _requestRecorder.apply(this, arguments);
	}
	var _default = exports["default"] = useRecorder;

/***/ },
/* 1419 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var _globalComponentsLibrary = __webpack_require__(28);
	var _react = _interopRequireWildcard(__webpack_require__(1));
	var _reactstrap = __webpack_require__(70);
	var _classnames = _interopRequireDefault(__webpack_require__(119));
	var _constants = __webpack_require__(58);
	__webpack_require__(2491);
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
	function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	var speeds = [1.0, 1.5, 2.0];
	var AudiosMessage = function AudiosMessage(_ref) {
	  var url = _ref.url,
	    source = _ref.source,
	    disabled = _ref.disabled,
	    _ref$speedSelected = _ref.speedSelected,
	    speedSelected = _ref$speedSelected === void 0 ? 0 : _ref$speedSelected,
	    changeSpeed = _ref.changeSpeed,
	    image = _ref.image,
	    setCurrentAudio = _ref.setCurrentAudio,
	    currentAudio = _ref.currentAudio;
	  var classes = (0, _classnames["default"])({
	    disabled: disabled,
	    response: source !== _constants.MSG_SOURCE.USER,
	    admin: source === _constants.MSG_SOURCE.ADMIN,
	    coaching: source === _constants.MSG_SOURCE.COACH
	  });
	  var _useState = (0, _react.useState)(false),
	    _useState2 = _slicedToArray(_useState, 2),
	    isListened = _useState2[0],
	    setIsListened = _useState2[1];
	  var _useState3 = (0, _react.useState)(),
	    _useState4 = _slicedToArray(_useState3, 2),
	    play = _useState4[0],
	    setPlay = _useState4[1];
	  var _useState5 = (0, _react.useState)(0),
	    _useState6 = _slicedToArray(_useState5, 2),
	    duration = _useState6[0],
	    setDuration = _useState6[1];
	  var _useState7 = (0, _react.useState)(0),
	    _useState8 = _slicedToArray(_useState7, 2),
	    currentTime = _useState8[0],
	    setCurrentTime = _useState8[1];
	  var _useState9 = (0, _react.useState)(false),
	    _useState10 = _slicedToArray(_useState9, 2),
	    loadingAudio = _useState10[0],
	    setLoadingAudio = _useState10[1];
	  var audioPlayer = (0, _react.useRef)();
	  var progressBar = (0, _react.useRef)();
	  var animationRef = (0, _react.useRef)();
	  var aRef = (0, _react.useRef)(null);
	  var download = function download() {
	    aRef.current.click();
	  };
	  (0, _react.useEffect)(function () {
	    if (play !== undefined && play) {
	      setIsListened(true);
	      setData();
	      audioPlayer.current.play();
	      animationRef.current = requestAnimationFrame(whilePlaying);
	    } else {
	      audioPlayer.current.pause();
	      cancelAnimationFrame(animationRef.current);
	    }
	  }, [play, duration]);
	  var whilePlaying = function whilePlaying() {
	    if (duration > 0 && duration !== Infinity && duration !== NaN) {
	      progressBar.current.value = audioPlayer.current.currentTime;
	      changePlayerCurrentTime();
	      animationRef.current = requestAnimationFrame(whilePlaying);
	    }
	  };
	  var changeRange = function changeRange() {
	    audioPlayer.current.currentTime = progressBar.current.value;
	    changePlayerCurrentTime();
	  };
	  var changePlayerCurrentTime = function changePlayerCurrentTime() {
	    progressBar.current.style.setProperty('--seek-before-width', "".concat(Math.floor(progressBar.current.value / duration * 100), "%"));
	    setCurrentTime(progressBar.current.value);
	    if (audioPlayer.current.currentTime === audioPlayer.current.duration) {
	      setPlay(false);
	      setDuration(0);
	      setCurrentTime(0);
	      progressBar.current.style.setProperty('--seek-before-width', "0%");
	      audioPlayer.current.currentTime = 0;
	      setCurrentAudio(null);
	    }
	  };
	  var calculateTime = function calculateTime(secs) {
	    var minutes = Math.floor(secs / 60);
	    var returnedMinutes = minutes < 10 ? "0".concat(minutes) : "".concat(minutes);
	    var seconds = Math.floor(secs % 60);
	    var returnedSeconds = seconds < 10 ? "0".concat(seconds) : "".concat(seconds);
	    return "".concat(returnedMinutes, ":").concat(returnedSeconds);
	  };
	  var setData = function setData() {
	    var seconds = Math.floor(audioPlayer.current.duration);
	    setDuration(seconds);
	    progressBar.current.max = seconds;
	    if (seconds === Infinity) {
	      setLoadingAudio(true);
	      audioPlayer.current.volume = 0.0;
	    }
	    audioPlayer.current.ondurationchange = function () {
	      if (this.duration !== Infinity) {
	        setLoadingAudio(false);
	        setDuration(Math.floor(this.duration));
	        progressBar.current.max = Math.floor(this.duration);
	        progressBar.current.style.setProperty('--seek-before-width', "0%");
	        setCurrentTime(0);
	        audioPlayer.current.pause();
	        audioPlayer.current.currentTime = 0;
	        setTimeout(function () {
	          audioPlayer.current.volume = 1.0;
	          audioPlayer.current.play();
	        }, 200);
	      }
	    };
	  };
	  (0, _react.useEffect)(function () {
	    if (audioPlayer && audioPlayer.current) {
	      audioPlayer.current.playbackRate = speeds[speedSelected];
	    }
	  }, [speedSelected]);
	  var resetAudio = function resetAudio() {
	    if (progressBar && audioPlayer) {
	      progressBar.current.value = 0;
	      progressBar.current.style.setProperty('--seek-before-width', "0%");
	      setDuration(0);
	      setCurrentTime(0);
	      audioPlayer.current.pause();
	      audioPlayer.current.currentTime = 0;
	      setCurrentAudio(null);
	    }
	  };
	  (0, _react.useEffect)(function () {
	    if (currentAudio != null) {
	      if (currentAudio.url === url) {
	        setPlay(currentAudio.play);
	      } else {
	        setPlay(false);
	        setLoadingAudio(false);
	        resetAudio();
	      }
	    }
	  }, [currentAudio]);
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: 'uin-audio-message ' + classes
	  }, /*#__PURE__*/_react["default"].createElement("a", {
	    ref: aRef,
	    href: url,
	    target: "_blank",
	    rel: "noreferrer",
	    type: "audio/mpeg",
	    style: {
	      display: 'none'
	    }
	  }, "audio"), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-audio-message-rep ".concat(classes)
	  }, /*#__PURE__*/_react["default"].createElement("audio", {
	    /* onLoadedMetadata={setData} */ref: audioPlayer,
	    src: url,
	    preload: "metadata"
	  }), loadingAudio ? /*#__PURE__*/_react["default"].createElement(_reactstrap.Spinner, {
	    className: "loadIconAudio ".concat(classes)
	  }) : /*#__PURE__*/_react["default"].createElement(_globalComponentsLibrary.ButtonIcon, {
	    icon: play ? 'pause' : 'play',
	    size: "large",
	    onClick: function onClick() {
	      return setCurrentAudio({
	        url: url,
	        play: !play
	      });
	    },
	    disabled: disabled
	  }), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-audio-message-progress"
	  }, /*#__PURE__*/_react["default"].createElement("input", {
	    className: "progressBar ".concat(isListened ? 'listened' : ''),
	    type: "range",
	    defaultValue: "0",
	    ref: progressBar,
	    onChange: changeRange
	  }), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-audio-time"
	  }, calculateTime(currentTime)))), !play ? /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-audio-message-icon"
	  }, source === _constants.MSG_SOURCE.USER && image ? image : /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-audio-message-agent"
	  }, /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon large headset"
	  }))) : /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-audio-message-speed",
	    onClick: changeSpeed
	  }, /*#__PURE__*/_react["default"].createElement("div", null, speeds[speedSelected])), /*#__PURE__*/_react["default"].createElement(_globalComponentsLibrary.ButtonIcon, {
	    icon: "download",
	    onClick: function onClick() {
	      return download();
	    }
	  }));
	};
	var _default = exports["default"] = AudiosMessage;

/***/ },
/* 1420 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var _react = _interopRequireWildcard(__webpack_require__(1));
	var _helpers = __webpack_require__(53);
	var _globalComponentsLibrary = __webpack_require__(28);
	var _constants = __webpack_require__(58);
	__webpack_require__(2492);
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	var FileMessage = function FileMessage(_ref) {
	  var url = _ref.url,
	    size = _ref.size,
	    name = _ref.name;
	  var aRef = (0, _react.useRef)(null);
	  var download = function download() {
	    aRef.current.click();
	  };
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-file-message"
	  }, /*#__PURE__*/_react["default"].createElement("a", {
	    ref: aRef,
	    href: url,
	    target: "_blank",
	    rel: "noreferrer",
	    style: {
	      display: 'none'
	    }
	  }, "file"), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-file-icon"
	  }, /*#__PURE__*/_react["default"].createElement("i", {
	    className: 'gcl-icon large ' + _constants.FILE_ICONS[(0, _helpers.fileExtension)(url)]
	  })), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-file-info"
	  }, /*#__PURE__*/_react["default"].createElement("span", {
	    className: "uin-file-name"
	  }, name != null ? name.replace(/%20/g, ' ').replace('FileName:', '') : (0, _helpers.getFilenameFromURL)(url)), /*#__PURE__*/_react["default"].createElement("span", {
	    className: "uin-file-data"
	  }, (0, _helpers.fileExtension)(url).toUpperCase(), " - ", size != null ? size.replace(/%20/g, ' ').replace('FileSize:', '') : '')), /*#__PURE__*/_react["default"].createElement(_globalComponentsLibrary.ButtonIcon, {
	    icon: "download",
	    onClick: function onClick() {
	      return download();
	    }
	  }));
	};
	var _default = exports["default"] = FileMessage;

/***/ },
/* 1421 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var _react = _interopRequireWildcard(__webpack_require__(1));
	var _Recorder = _interopRequireDefault(__webpack_require__(1418));
	var _Stopwatch = _interopRequireDefault(__webpack_require__(145));
	var _IconButton = _interopRequireDefault(__webpack_require__(257));
	__webpack_require__(2493);
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
	function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	var RecordButton = function RecordButton(_ref) {
	  var onAudioURL = _ref.onAudioURL,
	    disabled = _ref.disabled;
	  var _useRecorder = (0, _Recorder["default"])(),
	    _useRecorder2 = _slicedToArray(_useRecorder, 5),
	    audioURL = _useRecorder2[0],
	    setAudioURL = _useRecorder2[1],
	    isRecording = _useRecorder2[2],
	    startRecording = _useRecorder2[3],
	    stopRecording = _useRecorder2[4];
	  var send = (0, _react.useRef)(false);
	  var isHttps = window.location.protocol === 'https:';
	  var onAudioSend = function onAudioSend() {
	    send.current = true;
	    stopRecording();
	  };
	  (0, _react.useEffect)(function () {
	    if (send.current && audioURL) {
	      audioURL.data.name = 'audio.ogg';
	      audioURL.data.preview = {
	        type: 'audio',
	        urllocal: audioURL.url
	      };
	      onAudioURL([audioURL.data]);
	      send.current = false;
	      setAudioURL(null);
	    }
	  }, [audioURL]);
	  return isRecording ? /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-time-recording-wrapper"
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: 'uin-recording-icon',
	    onClick: function onClick() {
	      return stopRecording();
	    }
	  }, /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon close"
	  })), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-recording-timer"
	  }, /*#__PURE__*/_react["default"].createElement(_Stopwatch["default"], null), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-recording-timer-icon"
	  })), /*#__PURE__*/_react["default"].createElement("div", {
	    className: 'uin-recording-icon blue',
	    onClick: onAudioSend
	  }, /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon sent"
	  }))) : /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
	    icon: "microphone",
	    large: true,
	    disabled: disabled || !isHttps,
	    onClick: function onClick() {
	      return startRecording();
	    }
	  });
	};
	var _default = exports["default"] = RecordButton;

/***/ },
/* 1422 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var _react = _interopRequireWildcard(__webpack_require__(1));
	__webpack_require__(2494);
	var _MediaViewer = _interopRequireDefault(__webpack_require__(378));
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
	function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	var VideoMessage = function VideoMessage(_ref) {
	  var url = _ref.url;
	  var _useState = (0, _react.useState)(false),
	    _useState2 = _slicedToArray(_useState, 2),
	    isOpen = _useState2[0],
	    setOpen = _useState2[1];
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-video-container"
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-video-wraper",
	    onClick: function onClick() {
	      return setOpen(!isOpen);
	    }
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-video-icon"
	  }, /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon large play"
	  })), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-video-video"
	  }, /*#__PURE__*/_react["default"].createElement("video", {
	    className: "video",
	    preload: "metadata"
	  }, /*#__PURE__*/_react["default"].createElement("source", {
	    src: url
	  })))), /*#__PURE__*/_react["default"].createElement(_MediaViewer["default"], {
	    show: isOpen,
	    toggle: function toggle() {
	      return setOpen(function (o) {
	        return !o;
	      });
	    },
	    multimediaFiles: [{
	      url: url,
	      mediaType: 'video'
	    }]
	  }));
	};
	var _default = exports["default"] = VideoMessage;

/***/ },
/* 1423 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var _react = _interopRequireDefault(__webpack_require__(1));
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	__webpack_require__(2495);
	var _globalComponentsLibrary = __webpack_require__(28);
	var _reactI18next = __webpack_require__(41);
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	var NewMessageBar = function NewMessageBar(_ref) {
	  var onAceptedChat = _ref.onAceptedChat,
	    onSpam = _ref.onSpam,
	    onUnassign = _ref.onUnassign,
	    disabled = _ref.disabled;
	  var _useTranslation = (0, _reactI18next.useTranslation)(['new-message-bar']),
	    t = _useTranslation.t;
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-message-bar-conteiner"
	  }, onSpam && /*#__PURE__*/_react["default"].createElement(_globalComponentsLibrary.Button, {
	    disabled: disabled,
	    color: "secondary",
	    onClick: onSpam
	  }, t('spam')), /*#__PURE__*/_react["default"].createElement(_globalComponentsLibrary.Button, {
	    disabled: disabled,
	    color: "primary",
	    onClick: onAceptedChat
	  }, t('reply')), onUnassign && /*#__PURE__*/_react["default"].createElement(_globalComponentsLibrary.Button, {
	    disabled: disabled,
	    color: "secondary",
	    onClick: onUnassign
	  }, t('unassign')));
	};
	NewMessageBar.propTypes = {
	  onSpam: _propTypes["default"].func,
	  onAceptedChat: _propTypes["default"].func,
	  onUnassign: _propTypes["default"].func
	};
	var _default = exports["default"] = NewMessageBar;

/***/ },
/* 1424 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var _react = _interopRequireDefault(__webpack_require__(1));
	var _slateReact = __webpack_require__(483);
	var _DropUpMenu = _interopRequireWildcard(__webpack_require__(1433));
	var _SlateUtils = __webpack_require__(377);
	var _constants = __webpack_require__(58);
	__webpack_require__(2496);
	var _IconButton = _interopRequireDefault(__webpack_require__(257));
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
	function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	var StylesGallery = function StylesGallery(_ref) {
	  var id = _ref.id;
	  var editor = (0, _slateReact.useSlate)();
	  var onFontChange = function onFontChange(font) {
	    _SlateUtils.UINEditor.toggleMark(editor, 'font', font);
	  };
	  var onColorChange = function onColorChange(color) {
	    _SlateUtils.UINEditor.toggleMark(editor, 'color', color);
	  };
	  var onSizeChange = function onSizeChange(size) {
	    _SlateUtils.UINEditor.toggleMark(editor, 'size', size);
	  };
	  var onTextAlignChange = function onTextAlignChange(align) {
	    _SlateUtils.UINEditor.toggleAlign(editor, align);
	  };
	  var onToggleList = function onToggleList(type) {
	    if (!_slateReact.ReactEditor.isFocused(editor)) _slateReact.ReactEditor.focus(editor);
	    _SlateUtils.UINEditor.toggleType(editor, type);
	  };
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-sg-container"
	  }, /*#__PURE__*/_react["default"].createElement(_DropUpMenu["default"], {
	    orientation: "vertical",
	    text: _SlateUtils.UINEditor.currentMark(editor, 'font') || 'Arial',
	    id: 'uin-sg-font-' + id
	  }, Object.entries(_constants.FONTS).map(function (_ref2) {
	    var _ref3 = _slicedToArray(_ref2, 2),
	      name = _ref3[0],
	      val = _ref3[1];
	    return /*#__PURE__*/_react["default"].createElement(_DropUpMenu.Option, {
	      key: name,
	      selected: _SlateUtils.UINEditor.isMarkActive(editor, 'font', name),
	      style: {
	        fontFamily: val
	      },
	      onClick: function onClick() {
	        return onFontChange(name);
	      }
	    }, name);
	  })), /*#__PURE__*/_react["default"].createElement(_DropUpMenu["default"], {
	    orientation: "vertical",
	    icon: "font-size",
	    id: 'uin-sg-size-' + id
	  }, Object.entries(_constants.FONT_SIZES).map(function (_ref4) {
	    var _ref5 = _slicedToArray(_ref4, 2),
	      size = _ref5[0],
	      val = _ref5[1];
	    return /*#__PURE__*/_react["default"].createElement(_DropUpMenu.Option, {
	      key: size,
	      selected: _SlateUtils.UINEditor.isMarkActive(editor, 'size', val),
	      onClick: function onClick() {
	        return onSizeChange(val);
	      }
	    }, size);
	  })), /*#__PURE__*/_react["default"].createElement(_DropUpMenu["default"], {
	    orientation: "palette",
	    icon: "font-color",
	    iconData: _SlateUtils.UINEditor.currentMark(editor, 'color'),
	    id: 'uin-sg-color-' + id
	  }, Object.entries(_constants.COLORS).map(function (_ref6) {
	    var _ref7 = _slicedToArray(_ref6, 2),
	      name = _ref7[0],
	      val = _ref7[1];
	    return /*#__PURE__*/_react["default"].createElement(_DropUpMenu.Option, {
	      key: name,
	      selected: _SlateUtils.UINEditor.isMarkActive(editor, 'color', val),
	      style: {
	        backgroundColor: val
	      },
	      onClick: function onClick() {
	        return onColorChange(val);
	      }
	    });
	  })), /*#__PURE__*/_react["default"].createElement("span", {
	    className: "uin-sg-separator"
	  }), /*#__PURE__*/_react["default"].createElement(_DropUpMenu["default"], {
	    orientation: "horizontal",
	    icon: 'text-align-' + (_SlateUtils.UINEditor.activeAlign(editor) || 'left'),
	    id: 'uin-sg-align-' + id
	  }, Object.values(_constants.TEXT_ALIGN).map(function (align) {
	    return /*#__PURE__*/_react["default"].createElement(_DropUpMenu.Option, {
	      key: align,
	      icon: 'text-align-' + align,
	      selected: _SlateUtils.UINEditor.isAlignActive(editor, align),
	      onClick: function onClick() {
	        return onTextAlignChange(align);
	      }
	    });
	  })), /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
	    icon: "numbered-list",
	    secondary: true,
	    active: _SlateUtils.UINEditor.isTypeActive(editor, _constants.LIST_TYPES[0]),
	    onClick: function onClick() {
	      return onToggleList(_constants.LIST_TYPES[0]);
	    }
	  }), /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
	    icon: "list",
	    secondary: true,
	    active: _SlateUtils.UINEditor.isTypeActive(editor, _constants.LIST_TYPES[1]),
	    onClick: function onClick() {
	      return onToggleList(_constants.LIST_TYPES[1]);
	    }
	  }));
	};
	var _default = exports["default"] = StylesGallery;

/***/ },
/* 1425 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var _react = _interopRequireWildcard(__webpack_require__(1));
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	var _NewTab = _interopRequireDefault(__webpack_require__(1426));
	__webpack_require__(2497);
	var _reactI18next = __webpack_require__(41);
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
	function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	var TabBar = function TabBar(_ref) {
	  var tabs = _ref.tabs,
	    activeTab = _ref.activeTab,
	    setActiveTab = _ref.setActiveTab,
	    _ref$disabledTabs = _ref.disabledTabs,
	    disabledTabs = _ref$disabledTabs === void 0 ? [] : _ref$disabledTabs,
	    _ref$unreadCounts = _ref.unreadCounts,
	    unreadCounts = _ref$unreadCounts === void 0 ? {} : _ref$unreadCounts;
	  var _useState = (0, _react.useState)(false),
	    _useState2 = _slicedToArray(_useState, 2),
	    collapsed = _useState2[0],
	    setCollapsed = _useState2[1];
	  var _useTranslation = (0, _reactI18next.useTranslation)(['commons']),
	    t = _useTranslation.t;
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: 'uin-new-tab-bar' + (collapsed ? ' collapsed' : '')
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-new-tab-bar-title"
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-new-tab-bar-title-font"
	  }, t('media')), /*#__PURE__*/_react["default"].createElement("div", {
	    className: 'uin-new-tab-bar-title-icon',
	    onClick: function onClick() {
	      return setCollapsed(function (o) {
	        return !o;
	      });
	    }
	  }, /*#__PURE__*/_react["default"].createElement("i", {
	    className: 'gcl-icon clickable chevron-' + (collapsed ? 'right' : 'left')
	  }))), tabs.map(function (tab, i) {
	    return /*#__PURE__*/_react["default"].createElement(_NewTab["default"], {
	      key: i,
	      index: i + 1,
	      title: t('types.' + tab),
	      active: activeTab === tab,
	      disabled: disabledTabs.includes(tab),
	      unread: unreadCounts[tab],
	      onClick: function onClick() {
	        return setActiveTab(tab);
	      },
	      collapsed: collapsed
	    }, /*#__PURE__*/_react["default"].createElement("i", {
	      className: 'gcl-icon ' + tab.toLowerCase()
	    }));
	  }));
	};
	TabBar.propTypes = {
	  tabs: _propTypes["default"].arrayOf(_propTypes["default"].string).isRequired,
	  title: _propTypes["default"].objectOf(_propTypes["default"].string),
	  activeTab: _propTypes["default"].string.isRequired,
	  setActiveTab: _propTypes["default"].func.isRequired,
	  disabledTabs: _propTypes["default"].arrayOf(_propTypes["default"].string),
	  unreadCounts: _propTypes["default"].objectOf(_propTypes["default"].number)
	};
	var _default = exports["default"] = TabBar;

/***/ },
/* 1426 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var _react = _interopRequireDefault(__webpack_require__(1));
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	var _classnames = _interopRequireDefault(__webpack_require__(119));
	__webpack_require__(2498);
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	var NewTab = function NewTab(_ref) {
	  var index = _ref.index,
	    active = _ref.active,
	    disabled = _ref.disabled,
	    unread = _ref.unread,
	    onClick = _ref.onClick,
	    children = _ref.children,
	    title = _ref.title,
	    collapsed = _ref.collapsed;
	  var classes = (0, _classnames["default"])({
	    disabled: disabled,
	    active: !disabled && active
	    // warning: !disabled && !active && warning
	  });
	
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    tabIndex: index,
	    className: 'gcl-um ' + classes + (collapsed ? ' collapsed' : ''),
	    onClick: onClick
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: 'gcl-um-icon ' + classes
	  }, children), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-um-title"
	  }, title), unread > 0 && /*#__PURE__*/_react["default"].createElement("div", {
	    className: 'gcl-um-notification '
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-um-notification-icon"
	  }, (unread > 99 ? '+' : '') + Math.min(unread, 99))));
	};
	NewTab.propTypes = {
	  index: _propTypes["default"].number.isRequired,
	  active: _propTypes["default"].bool,
	  disabled: _propTypes["default"].bool,
	  unread: _propTypes["default"].number,
	  warning: _propTypes["default"].bool,
	  onClick: _propTypes["default"].func.isRequired,
	  title: _propTypes["default"].string
	};
	NewTab.defaultProps = {
	  active: false,
	  disabled: false,
	  unread: 0,
	  warning: false,
	  title: ''
	};
	var _default = exports["default"] = NewTab;

/***/ },
/* 1427 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var _react = _interopRequireDefault(__webpack_require__(1));
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	var _reactI18next = __webpack_require__(41);
	var _formatters = __webpack_require__(83);
	var _types = __webpack_require__(60);
	var _ImageIcon = _interopRequireDefault(__webpack_require__(167));
	var _Stopwatch = _interopRequireDefault(__webpack_require__(145));
	var _helpers = __webpack_require__(53);
	__webpack_require__(2499);
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	var TwitterListItem = function TwitterListItem(_ref) {
	  var id = _ref.id,
	    text = _ref.text,
	    media = _ref.media,
	    unread = _ref.unread,
	    date = _ref.date,
	    _ref$contact = _ref.contact,
	    user = _ref$contact.name,
	    handle = _ref$contact.account,
	    campaign = _ref.campaign,
	    active = _ref.active,
	    timeUnattended = _ref.timeUnattended,
	    warning = _ref.warning,
	    onClick = _ref.onClick;
	  var _useTranslation = (0, _reactI18next.useTranslation)('commons'),
	    t = _useTranslation.t,
	    i18n = _useTranslation.i18n;
	  var lang = i18n.language.slice(0, 2);
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    id: id,
	    className: "uin-list-item uin-tli-tweet-card ".concat(active ? 'active' : '', " ").concat(warning ? 'warning' : ''),
	    onClick: onClick
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-lic-bar"
	  }), unread && /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-lic-dot"
	  }), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-tli-tc-info"
	  }, /*#__PURE__*/_react["default"].createElement(_ImageIcon["default"], {
	    name: campaign.name,
	    image: campaign.image
	  }), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-tli-tc-contact"
	  }, /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement("span", {
	    className: "uin-tli-username"
	  }, user), /*#__PURE__*/_react["default"].createElement("span", {
	    className: "spacer"
	  }, '·'), /*#__PURE__*/_react["default"].createElement("time", {
	    dateTime: date
	  }, (0, _formatters.formatTimeShort)(date, lang))), /*#__PURE__*/_react["default"].createElement("span", null, handle)), timeUnattended !== null && /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-lic-timeout"
	  }, /*#__PURE__*/_react["default"].createElement(_Stopwatch["default"], {
	    initialTime: timeUnattended
	  })), /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon twitter uin-lic-icon"
	  })), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-tli-tc-content"
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-tli-tc-text"
	  }, text || /*#__PURE__*/_react["default"].createElement("em", {
	    className: "uin-lic-new-ph"
	  }, t('new-convo'))), media && /*#__PURE__*/_react["default"].createElement("div", {
	    className: 'uin-tli-tc-media' + (media.length > 1 ? ' contain' : '')
	  }, (0, _helpers.groupImages)(media))), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-tli-tc-footer"
	  }, /*#__PURE__*/_react["default"].createElement("span", {
	    className: "date"
	  }, (0, _formatters.formatDateLong)(date, lang))));
	};
	TwitterListItem.propTypes = {
	  id: _propTypes["default"].number,
	  date: _propTypes["default"].instanceOf(Date).isRequired,
	  text: _propTypes["default"].string,
	  media: _propTypes["default"].arrayOf(_propTypes["default"].string),
	  unread: _propTypes["default"].bool,
	  contact: _types.contactType.isRequired,
	  campaign: _types.campaignType.isRequired,
	  active: _propTypes["default"].bool,
	  timeUnattended: _propTypes["default"].instanceOf(Date),
	  warning: _propTypes["default"].bool,
	  onClick: _propTypes["default"].func.isRequired
	};
	TwitterListItem.defaultProps = {
	  timeUnattended: null
	};
	var _default = exports["default"] = TwitterListItem;

/***/ },
/* 1428 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var _react = _interopRequireWildcard(__webpack_require__(1));
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	var _reactI18next = __webpack_require__(41);
	var _dateFns = __webpack_require__(147);
	var _types = __webpack_require__(60);
	var _constants = __webpack_require__(58);
	var _NewTabBar = _interopRequireDefault(__webpack_require__(1425));
	var _helpers = __webpack_require__(53);
	var _hooks = __webpack_require__(168);
	var _ConversationList = _interopRequireDefault(__webpack_require__(1399));
	var _ConversationView = _interopRequireDefault(__webpack_require__(1404));
	var _package = __webpack_require__(2042);
	__webpack_require__(2501);
	var _excluded = ["titleTabBar", "conversations", "draftMessages", "selected", "setTheUrlOfAttachments", "setNumFiles", "onSelect", "lang", "agent", "disabledActions", "getUploadState"];
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
	function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
	function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
	function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
	function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
	console.log('Package data\nName:', _package.name, '\nVersion:', _package.version);
	var reduceConversations = function reduceConversations(acc, conv, val) {
	  return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, conv.campType, _objectSpread(_objectSpread({}, acc[conv.campType]), {}, _defineProperty({}, conv.id, val))));
	};
	var UnifiedInbox = function UnifiedInbox(_ref) {
	  var titleTabBar = _ref.titleTabBar,
	    conversations = _ref.conversations,
	    draftMessages = _ref.draftMessages,
	    selected = _ref.selected,
	    setTheUrlOfAttachments = _ref.setTheUrlOfAttachments,
	    setNumFiles = _ref.setNumFiles,
	    onSelect = _ref.onSelect,
	    lang = _ref.lang,
	    agent = _ref.agent,
	    disabledActions = _ref.disabledActions,
	    getUploadState = _ref.getUploadState,
	    actions = _objectWithoutProperties(_ref, _excluded);
	  var tabs = (0, _react.useMemo)(function () {
	    return titleTabBar.map(function (t) {
	      return t.toUpperCase();
	    });
	  }, [titleTabBar]);
	  var initialCounts = (0, _react.useMemo)(function () {
	    return tabs.reduce(function (a, v) {
	      return _objectSpread(_objectSpread({}, a), {}, _defineProperty({}, v, 0));
	    }, {});
	  }, [tabs]);
	  var _useState = (0, _react.useState)(_constants.TABS.HOME),
	    _useState2 = _slicedToArray(_useState, 2),
	    activeTab = _useState2[0],
	    setActiveTab = _useState2[1];
	  var _useState3 = (0, _react.useState)(initialCounts),
	    _useState4 = _slicedToArray(_useState3, 2),
	    unreadCounts = _useState4[0],
	    setUnreadCounts = _useState4[1];
	  var _useState5 = (0, _react.useState)(undefined),
	    _useState6 = _slicedToArray(_useState5, 2),
	    activeMessage = _useState6[0],
	    setActiveMessage = _useState6[1];
	  var _useState7 = (0, _react.useState)([]),
	    _useState8 = _slicedToArray(_useState7, 2),
	    openMessages = _useState8[0],
	    setOpenMessages = _useState8[1];
	  var prevSelected = (0, _react.useRef)(null);
	  var endConversations = (0, _react.useRef)([]);
	  var _useState9 = (0, _react.useState)(),
	    _useState10 = _slicedToArray(_useState9, 2),
	    openWrapup = _useState10[0],
	    setOpenWrapup = _useState10[1];
	  var _useState11 = (0, _react.useState)(false),
	    _useState12 = _slicedToArray(_useState11, 2),
	    startConversation = _useState12[0],
	    setStartConversation = _useState12[1];
	  var _useState13 = (0, _react.useState)(false),
	    _useState14 = _slicedToArray(_useState13, 2),
	    readyToUnassign = _useState14[0],
	    setReadyToUnassign = _useState14[1];
	  var _useTranslation = (0, _reactI18next.useTranslation)(),
	    i18n = _useTranslation.i18n;
	  (0, _react.useEffect)(function () {
	    i18n.changeLanguage(lang);
	  }, [i18n, lang]);
	  var selectedConversation = (0, _react.useMemo)(function () {
	    return conversations.find(function (c) {
	      return c.id === selected.convId && c.campType === selected.campType;
	    });
	  }, [conversations, selected.convId, selected.campType]);
	  (0, _react.useEffect)(function () {
	    if (selectedConversation) {
	      if (!selectedConversation.chatStarted && selectedConversation.timeoutReached) {
	        setStartConversation(true);
	      }
	      if ((0, _helpers.isNewMedia2)(selectedConversation.type) && selectedConversation && selectedConversation.statusConversation === _constants.USER_STATE.AGENT_READY && endConversations.current.some(function (i) {
	        return i.id === selectedConversation.id && i.camptype === selectedConversation.campType;
	      })) {
	        onDialog();
	      }
	    }
	  }, [selectedConversation]);
	  (0, _react.useEffect)(function () {
	    if (selectedConversation) {
	      if (activeMessage && !selectedConversation.messages.some(function (m) {
	        return m.id === activeMessage;
	      })) {
	        setActiveMessage(undefined);
	        setOpenMessages([]);
	      }
	      if (selectedConversation.type === _constants.TABS.MAIL) {
	        selectedConversation.messages.map(function (m) {
	          return m.seen = true;
	        });
	      }
	    }
	  }, [selectedConversation, activeMessage]);
	  var timeoutsByID = (0, _react.useRef)({
	    0: {},
	    1: {}
	  });
	  var _useState15 = (0, _react.useState)({
	      0: {},
	      1: {}
	    }),
	    _useState16 = _slicedToArray(_useState15, 2),
	    warnings = _useState16[0],
	    setWarnings = _useState16[1];
	  var prevConversations = (0, _hooks.usePrevious)(conversations);
	  (0, _react.useEffect)(function () {
	    setUnreadCounts(conversations.reduce(function (acc, _ref2) {
	      var _objectSpread5;
	      var messages = _ref2.messages,
	        type = _ref2.type,
	        unreadMessage = _ref2.unreadMessage;
	      return messages.length === 0 || (0, _helpers.hasUnread)(messages, type, unreadMessage) ? _objectSpread(_objectSpread({}, acc), {}, (_objectSpread5 = {}, _defineProperty(_objectSpread5, _constants.TABS.HOME, acc[_constants.TABS.HOME] + 1), _defineProperty(_objectSpread5, type, acc[type] + 1), _objectSpread5)) : acc;
	    }, initialCounts));
	    if (!prevConversations || conversations.length !== prevConversations.length) {
	      setWarnings(function (w) {
	        return conversations.reduce(function (acc, conv) {
	          return reduceConversations(acc, conv, w[conv.campType][conv.id] || false);
	        }, {
	          0: {},
	          1: {}
	        });
	      });
	      timeoutsByID.current = conversations.reduce(function (acc, conv) {
	        return reduceConversations(acc, conv, [conv.campaign.timeoutWarning, conv.campaign.timeout, conv.type]);
	      }, {
	        0: {},
	        1: {}
	      });
	    }
	  }, [conversations]);
	  var onResetAgentTimeout = function onResetAgentTimeout(camptype, id) {
	    if (actions.onResetAgentTimeout) actions.onResetAgentTimeout(camptype, id);
	  };
	  var getDateSetTimeout = function getDateSetTimeout(timer, conv, selected) {
	    if (conv.messages == null || conv.messages.length === 0) return null;else if ((0, _helpers.isUnattended)(conv, conv.id === selected.convId && conv.campType === selected.campType) || conv.messages[conv.messages.length - 1].origin !== 'AGENT') {
	      // Verifica si la conversacion tiene mensajes sin leer
	      if (conv.type === _constants.TABS.MAIL) {
	        //Verifica el tipo de media de la conversacion, Caso diferente a Whatsapp
	        return conv.initialTime;
	      } else {
	        // Caso de Whatsapp
	        if (timer) {
	          //Si ya existe un contador se deja
	          return timer;
	        } else if (conv.SecTimeOutLastMessageAgent) {
	          //Si viene la propiedad de timeout se establece como contador
	          onResetAgentTimeout(conv.campType, conv.id);
	          return new Date(new Date().getTime() - conv.SecTimeOutLastMessageAgent * 1000);
	        } else if (conv.messages[conv.messages.length - 1].origin !== 'AGENT') {
	          // Conversacion iniciada
	          return new Date();
	        }
	      }
	    }
	    return null;
	  };
	  var _useState17 = (0, _react.useState)({
	      0: {},
	      1: {}
	    }),
	    _useState18 = _slicedToArray(_useState17, 2),
	    unattendedTimes = _useState18[0],
	    setUnattendedTimes = _useState18[1];
	  var stoppedUnattendedTimes = (0, _react.useRef)({
	    0: {},
	    1: {}
	  });
	  var stoppedTime = (0, _react.useRef)(null);
	  (0, _react.useEffect)(function () {
	    if (prevSelected !== null) {
	      conversations.forEach(function (m) {
	        if (m.id === prevSelected.convId && m.campType === prevSelected.campType && m.type === _constants.TABS.MAIL) {
	          m.initialTime = new Date();
	        }
	      });
	    }
	    prevSelected.current = selected;
	  }, [selected]);
	  (0, _react.useEffect)(function () {
	    setUnattendedTimes(function (t) {
	      return (
	        // conversations.reduce((acc, conv) => ({ ...acc, [conv.id]: isUnattended(conv, conv.id === selectedID) ? (t[conv.id] || conv.type === TABS.MAIL ? conv.initialTime : new Date()) : null }), {})
	        conversations.reduce(function (acc, conv) {
	          return reduceConversations(acc, conv, getDateSetTimeout(t[conv.campType][conv.id], conv, selected));
	        }, {
	          0: {},
	          1: {}
	        }
	        // [conv.id]: isUnattended(conv, conv.id === selectedID) ? (t[conv.id] || conv.type === TABS.MAIL ? conv.initialTime : isChatStarted(conv) ? new Date() : null) : null
	        )
	      );
	    });
	  }, [conversations, selected]);
	  (0, _react.useEffect)(function () {
	    if (disabledActions) {
	      stoppedUnattendedTimes.current = _objectSpread({}, unattendedTimes);
	      stoppedTime.current = new Date();
	    } else {
	      var timesTmp = {};
	      var currentDate = new Date();
	      for (var camptype in stoppedUnattendedTimes.current) {
	        var aux = {};
	        for (var key in stoppedUnattendedTimes.current[camptype]) {
	          aux[key] = stoppedUnattendedTimes.current[camptype][key] ? new Date(currentDate - (stoppedTime.current - unattendedTimes[camptype][key])) : null;
	        }
	        timesTmp[camptype] = aux;
	      }
	      setUnattendedTimes(_objectSpread({}, timesTmp));
	      stoppedUnattendedTimes.current = {};
	      stoppedTime.current = null;
	    }
	  }, [disabledActions]);
	
	  /**Effect for setting timeout timers */
	  (0, _react.useEffect)(function () {
	    var setTimeouts = function setTimeouts(camptype, id, unattendedTime) {
	      if (timeoutsByID.current[camptype][id] == null) {
	        return [];
	      }
	      var _timeoutsByID$current = _slicedToArray(timeoutsByID.current[camptype][id], 3),
	        timeoutWarning = _timeoutsByID$current[0],
	        timeout = _timeoutsByID$current[1],
	        type = _timeoutsByID$current[2];
	      var timeoutIDs = [];
	      if (timeoutWarning > 0) {
	        var T = timeoutWarning * 1000 - (0, _dateFns.differenceInMilliseconds)(new Date(), unattendedTime);
	        if (T > 0) {
	          timeoutIDs.push(setTimeout(function () {
	            console.log('warning triggered', id);
	            setWarnings(function (w) {
	              return _objectSpread(_objectSpread({}, w), {}, _defineProperty({}, camptype, _objectSpread(_objectSpread({}, w[camptype]), {}, _defineProperty({}, id, true))));
	            });
	          }, T));
	        } else {
	          setWarnings(function (w) {
	            return _objectSpread(_objectSpread({}, w), {}, _defineProperty({}, camptype, _objectSpread(_objectSpread({}, w[camptype]), {}, _defineProperty({}, id, true))));
	          });
	        }
	      }
	      if (timeout > 0) {
	        var T2 = timeout * 1000 - (0, _dateFns.differenceInMilliseconds)(new Date(), unattendedTime);
	        if (T2 > 0) {
	          timeoutIDs.push(setTimeout(function () {
	            console.log('timeout triggered', camptype, id);
	            if (type === _constants.TABS.MAIL) {
	              unassignRef.current(camptype, id);
	            }
	            if ((0, _helpers.isNewMedia)(type)) {
	              endConversations.current.push({
	                camptype: camptype,
	                id: id,
	                isReassigned: _constants.REASSIGNED_TYPES.BY_TIMEOUT
	              });
	              setReadyToUnassign(true);
	            } else {
	              finishRef.current(camptype, id);
	            }
	          }, T2));
	        } else {
	          if (type === _constants.TABS.MAIL) {
	            unassignRef.current(camptype, id);
	          } else if (!(0, _helpers.isNewMedia)(type)) {
	            finishRef.current(camptype, id);
	          }
	        }
	      }
	      return timeoutIDs;
	    };
	    var timeouts = Object.entries(unattendedTimes).reduce(function (out, _ref3) {
	      var _ref4 = _slicedToArray(_ref3, 2),
	        camptype = _ref4[0],
	        convs = _ref4[1];
	      var arr = Object.entries(convs).reduce(function (acc, _ref5) {
	        var _ref6 = _slicedToArray(_ref5, 2),
	          id = _ref6[0],
	          time = _ref6[1];
	        if (time === null || disabledActions) return acc;
	        return [].concat(_toConsumableArray(acc), _toConsumableArray(setTimeouts(parseInt(camptype, 10), parseInt(id, 10), time)));
	      }, []);
	      return [].concat(_toConsumableArray(out), _toConsumableArray(arr));
	    }, []);
	    return function () {
	      return timeouts.map(function (t) {
	        return clearTimeout(t);
	      });
	    };
	  }, [unattendedTimes]);
	
	  /* const warnedTabs = useMemo(
	  	() =>
	  		Object.entries(warnings).reduce((acc, [key, val]) => {
	  			if (!val) return acc;
	  			const conv = conversations.find(c => c.id === parseInt(key, 10));
	  			if (!conv) return acc;
	  			acc.push(conv.type);
	  			return acc;
	  		}, []),
	  	[warnings, conversations]
	  ); */
	
	  var isOnDialog = function isOnDialog(statusConv) {
	    return statusConv === _constants.USER_STATE.DIALOG || statusConv === _constants.USER_STATE.DIALOG_EMAIL || statusConv === _constants.USER_STATE.DIALOG_WHATSAPP;
	  };
	  var onSelectConversation = function onSelectConversation(camptype, id) {
	    if (id !== undefined) {
	      setWarnings(function (w) {
	        return _objectSpread(_objectSpread({}, w), {}, _defineProperty({}, camptype, _objectSpread(_objectSpread({}, w[camptype]), {}, _defineProperty({}, id, false))));
	      });
	      if (selectedConversation && selectedConversation.id !== id && selectedConversation.campType !== camptype && isOnDialog(selectedConversation.statusConversation)) {
	        console.log('onReady', selectedConversation.campType, selectedConversation.id);
	        if (actions.onReady) actions.onReady(selectedConversation.campType, selectedConversation.id);
	      }
	      setTimeout(function () {
	        onSelect(camptype, id);
	      }, 100);
	    }
	  };
	  var onActiveMessage = function onActiveMessage(msgId) {
	    setActiveMessage(msgId);
	    setOpenMessages([msgId]);
	  };
	  var toggleOpenMessage = function toggleOpenMessage(msgId) {
	    if (openMessages.length === 0) setActiveMessage(msgId);
	    setOpenMessages(function (o) {
	      return o.includes(msgId) ? o.filter(function (id) {
	        return id !== msgId;
	      }) : [].concat(_toConsumableArray(o), [msgId]);
	    });
	  };
	  var onActiveTab = function onActiveTab(tab) {
	    if (tab !== _constants.TABS.HOME && (!selectedConversation || selectedConversation.type !== tab)) {
	      var filtrd = conversations.filter(function (conv) {
	        return conv.type === tab;
	      });
	      if (filtrd.length > 0) onSelectConversation(filtrd[0].campType, filtrd[0].id);
	    }
	    setActiveTab(tab);
	  };
	  var onFinish = function onFinish(camptype, id, isReassigned) {
	    console.log("onFinish(".concat(camptype, ", ").concat(id, ")"));
	    if (actions.onFinish) actions.onFinish(camptype, id, isReassigned);
	  };
	  var finishRef = (0, _react.useRef)(onFinish);
	  (0, _react.useEffect)(function () {
	    finishRef.current = onFinish;
	  });
	  var onAceptedChat = function onAceptedChat(camptype, id) {
	    console.log('onAceptedChat', camptype, id);
	    if (actions.onAceptedChat) actions.onAceptedChat(camptype, id);
	    if (actions.onDialog) actions.onDialog(camptype, id);
	    if (actions.onAcceptChatSaveTime) actions.onAcceptChatSaveTime(camptype, id);
	  };
	  var AceptedChatRef = (0, _react.useRef)(onAceptedChat);
	  (0, _react.useEffect)(function () {
	    AceptedChatRef.current = onAceptedChat;
	  });
	  var getMessageId = function getMessageId(conversation) {
	    return conversation.id === selected.convId && conversation.campType === selected.campType && activeMessage || (conversation.messages && conversation.messages.length > 0 ? conversation.messages[0].id : undefined);
	  };
	  var onUnassign = function onUnassign(camptype, id) {
	    if (actions.onUnassign) {
	      var messageId = getMessageId(conversations.find(function (c) {
	        return c.id === id && c.campType === camptype;
	      }));
	      console.log("onUnassign(camptype: ".concat(camptype, ", id: ").concat(id, ", message: ").concat(messageId, ")"));
	      actions.onUnassign(camptype, id, messageId);
	    }
	  };
	  var unassignRef = (0, _react.useRef)(onUnassign);
	  (0, _react.useEffect)(function () {
	    unassignRef.current = onUnassign;
	  });
	  var onSpam = function onSpam(camptype, id) {
	    if (actions.onSpam) {
	      var messageId = getMessageId(conversations.find(function (c) {
	        return c.id === id && c.campType === camptype;
	      }));
	      console.log("onSpam(camptype: ".concat(camptype, ", id: ").concat(id, ", message ").concat(messageId, ")"));
	      actions.onSpam(camptype, id, messageId);
	    }
	  };
	  var onDiscard = function onDiscard(camptype, id) {
	    if (actions.onDiscard) {
	      var messageId = getMessageId(conversations.find(function (c) {
	        return c.id === id && c.campType === camptype;
	      }));
	      console.log("onDiscard(camptype: ".concat(camptype, ", id:").concat(id, ", message:").concat(messageId, ")"));
	      actions.onDiscard(camptype, id, messageId);
	    }
	  };
	  var onWrapUp = function onWrapUp(camptype, id, disposition) {
	    console.log("onWrapUp(camptype: ".concat(camptype, ", id:").concat(id, ", disposition:").concat(disposition, ")"));
	    if (actions.onWrapUp) {
	      actions.onWrapUp(camptype, id, disposition);
	      setOpenWrapup(false);
	    }
	  };
	  var onSendResponse = function onSendResponse(camptype, id, message, messageId, subject, attachments, from, to, cc, bcc, IsAzure, fileType) {
	    console.log("onSendResponse(camptype: ".concat(camptype, ", id:").concat(id, ", message:").concat(message, ")"));
	    if (actions.onSendResponse) {
	      var addresses = from && to ? {
	        From: from,
	        To: [to],
	        CC: cc,
	        BCC: bcc
	      } : undefined;
	      actions.onSendResponse({
	        camptype: camptype,
	        id: id,
	        messageId: messageId,
	        subject: subject,
	        message: message,
	        addresses: addresses,
	        attachments: attachments,
	        IsAzure: IsAzure,
	        fileType: fileType
	      });
	    }
	  };
	  var onAttachments = function onAttachments(camptype, id) {
	    console.log("onAttachements(camptype: ".concat(camptype, ", id:").concat(id, ")"));
	    actions.onAttachments(camptype, id);
	  };
	  var onUploadAttachments = function onUploadAttachments(camptype, id, fileName, file) {
	    console.log("onUploadAttachments(".concat(camptype, ", ").concat(id, ", ").concat(fileName, ", ").concat(file, ")"));
	    actions.onUploadAttachments(camptype, id, fileName, file);
	  };
	  var onDeleteAttachment = function onDeleteAttachment(camptype, id, fileName) {
	    console.log("onDeleteAttachment(".concat(camptype, " ").concat(id, ", ").concat(fileName, ")"));
	    actions.onDeleteAttachment(camptype, id, fileName);
	  };
	  var onDialog = function onDialog() {
	    var dispatchDialog = false;
	    switch (selectedConversation.type) {
	      case _constants.TABS.WHATSAPP:
	        if (selectedConversation.statusConversation !== _constants.USER_STATE.DIALOG_WHATSAPP && selectedConversation.chatStarted) {
	          dispatchDialog = true;
	        }
	        break;
	      case _constants.TABS.MAIL:
	        if (selectedConversation.statusConversation !== _constants.USER_STATE.DIALOG_EMAIL) {
	          dispatchDialog = true;
	        }
	        break;
	      case _constants.TABS.CHAT:
	        dispatchDialog = true;
	        break;
	      default:
	        break;
	    }
	    if (dispatchDialog) {
	      console.log("onDialog(".concat(selectedConversation.campType, ", ").concat(selectedConversation.id, ")"));
	      if (actions.onDialog) actions.onDialog(selectedConversation.campType, selectedConversation.id);
	    }
	  };
	  (0, _react.useEffect)(function () {
	    /* if (selectedConversation.statusConversation === USER_STATE.AGENT_READY && endConversations.current.some(i => i.id === selectedConversation.id && i.camptype === selectedConversation.campType)) {
	    	onDialog();
	    } */
	    if (selectedConversation && endConversations.current.some(function (c) {
	      return c.id === selectedConversation.id && c.camptype === selectedConversation.campType;
	    })) {
	      var conv = endConversations.current.find(function (c) {
	        return c.id === selectedConversation.id && c.camptype === selectedConversation.campType;
	      });
	      finishRef.current(selectedConversation.campType, selectedConversation.id, conv.isReassigned);
	      if (!conv.isReassigned && selectedConversation.campaign.showWrapUp) {
	        setOpenWrapup(true);
	      }
	      if (readyToUnassign) {
	        setReadyToUnassign(false);
	      }
	      var i = endConversations.current.findIndex(function (c) {
	        return c.id === selectedConversation.id && c.camptype === selectedConversation.campType;
	      });
	      endConversations.current.splice(i, 1);
	    }
	  }, [selectedConversation, readyToUnassign]);
	  var onLoadMessages = function onLoadMessages(camptype, id) {
	    if (actions.onLoadMessages) {
	      console.log("onLoadMessages(camptype: ".concat(camptype, ", id:").concat(id, ")"));
	      actions.onLoadMessages(camptype, id);
	    }
	  };
	  var onUpdateDraftMessage = function onUpdateDraftMessage(msgId, data) {
	    if (actions.onUpdateDraftMessage) {
	      console.log("onUpdateDraftMessage(id:".concat(msgId, ")"));
	      actions.onUpdateDraftMessage(msgId, data);
	    }
	  };
	  var onDeleteDraftMessage = function onDeleteDraftMessage(msgId) {
	    if (actions.onDeleteDraftMessage) {
	      console.log("onDeleteDraftMessage(id:".concat(msgId, ")"));
	      actions.onDeleteDraftMessage(msgId);
	    }
	  };
	  var onUpdateDraftAttachments = function onUpdateDraftAttachments(msgId, data) {
	    if (actions.onUpdateDraftAttachments) {
	      console.log("onUpdateDraftAttachments(id:".concat(msgId, ")"));
	      actions.onUpdateDraftAttachments(msgId, data);
	    }
	  };
	  var getRequestFunc = function getRequestFunc(type) {
	    switch (type) {
	      case 'unassign':
	        if (selectedConversation && (selectedConversation.type === 'WHATSAPP' && selectedConversation.allowUnassign && !selectedConversation.disabledUnassign || selectedConversation.type !== 'WHATSAPP')) {
	          return onUnassign;
	        }
	        return undefined;
	      case 'spam':
	        if (selectedConversation && (selectedConversation.type === 'WHATSAPP' && selectedConversation.allowSpam || selectedConversation.type !== 'WHATSAPP')) {
	          return onSpam;
	        }
	        return undefined;
	      default:
	        return undefined;
	    }
	  };
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-container"
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-um-tabs"
	  }, /*#__PURE__*/_react["default"].createElement(_NewTabBar["default"], {
	    tabs: tabs,
	    unreadCounts: unreadCounts,
	    activeTab: activeTab,
	    setActiveTab: onActiveTab
	  })), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-wrapper-conversation"
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uim-conversation"
	  }, /*#__PURE__*/_react["default"].createElement(_ConversationList["default"], {
	    showType: activeTab,
	    conversations: conversations,
	    unattendedTimes: unattendedTimes,
	    warnings: warnings,
	    selected: selected,
	    onSelect: onSelectConversation,
	    activeMessageId: activeMessage,
	    onSelectMessage: onActiveMessage,
	    disabledActions: disabledActions
	  })), /*#__PURE__*/_react["default"].createElement(_ConversationView["default"], {
	    lang: lang,
	    agent: agent,
	    conversation: selectedConversation,
	    draftMessages: draftMessages,
	    openMessages: openMessages,
	    toggle: toggleOpenMessage,
	    openWrapup: openWrapup,
	    setTheUrlOfAttachments: setTheUrlOfAttachments,
	    startConversation: startConversation,
	    disabledActions: disabledActions,
	    setStartConversation: setStartConversation,
	    setNumFiles: setNumFiles,
	    onUnassign: getRequestFunc('unassign'),
	    onSpam: getRequestFunc('spam'),
	    onUpdateDraftMessage: onUpdateDraftMessage,
	    onUpdateDraftAttachments: onUpdateDraftAttachments,
	    onDeleteDraftMessage: onDeleteDraftMessage,
	    getUploadState: getUploadState,
	    onShowAlertDisconexion: actions.onShowAlertDisconexion,
	    onFinish: onFinish,
	    onDiscard: onDiscard,
	    onWrapUp: onWrapUp,
	    onSendResponse: onSendResponse,
	    onAttachments: onAttachments,
	    onUploadAttachments: onUploadAttachments,
	    onDeleteAttachment: onDeleteAttachment,
	    onAceptedChat: onAceptedChat,
	    onDialog: onDialog,
	    onLoadMessages: onLoadMessages
	  })));
	};
	UnifiedInbox.propTypes = {
	  conversations: _propTypes["default"].arrayOf(_types.conversationType).isRequired,
	  selectedID: _propTypes["default"].number,
	  onSelect: _propTypes["default"].func,
	  onFinish: _propTypes["default"].func,
	  onUnassign: _propTypes["default"].func,
	  onSpam: _propTypes["default"].func,
	  onDiscard: _propTypes["default"].func,
	  onWrapUp: _propTypes["default"].func,
	  onSendResponse: _propTypes["default"].func,
	  lang: _propTypes["default"].string,
	  onAceptedChat: _propTypes["default"].func,
	  onReady: _propTypes["default"].func,
	  onDialog: _propTypes["default"].func,
	  onResetAgentTimeout: _propTypes["default"].func,
	  onAcceptChatSaveTime: _propTypes["default"].func
	};
	UnifiedInbox.defaultProps = {
	  conversations: [],
	  selected: {},
	  lang: 'es'
	};
	var _default = exports["default"] = UnifiedInbox;

/***/ },
/* 1429 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var _react = _interopRequireWildcard(__webpack_require__(1));
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	var _constants = __webpack_require__(58);
	var _Stopwatch = _interopRequireDefault(__webpack_require__(145));
	var _types = __webpack_require__(60);
	var _globalComponentsLibrary = __webpack_require__(28);
	var _reactstrap = __webpack_require__(70);
	var _reactI18next = __webpack_require__(41);
	__webpack_require__(2502);
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
	function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	var WrapUp = function WrapUp(_ref) {
	  var onSelect = _ref.onSelect,
	    dispositions = _ref.dispositions,
	    show = _ref.show,
	    toggle = _ref.toggle,
	    acdId = _ref.acdId,
	    conversationId = _ref.conversationId,
	    type = _ref.type,
	    closeModal = _ref.closeModal,
	    _ref$time = _ref.time,
	    time = _ref$time === void 0 ? 60000 : _ref$time,
	    onFinish = _ref.onFinish;
	  var _useTranslation = (0, _reactI18next.useTranslation)(['wrapup']),
	    t = _useTranslation.t;
	  var _useState = (0, _react.useState)(undefined),
	    _useState2 = _slicedToArray(_useState, 2),
	    disposition = _useState2[0],
	    setDisposition = _useState2[1];
	  var _useState3 = (0, _react.useState)(undefined),
	    _useState4 = _slicedToArray(_useState3, 2),
	    subDisposition = _useState4[0],
	    setSubDisposition = _useState4[1];
	  var _useState5 = (0, _react.useState)(0),
	    _useState6 = _slicedToArray(_useState5, 2),
	    timeOnWrapUp = _useState6[0],
	    setTimeOnWrapUp = _useState6[1];
	  var _useState7 = (0, _react.useState)(false),
	    _useState8 = _slicedToArray(_useState7, 2),
	    disabled = _useState8[0],
	    setDisable = _useState8[1];
	  var _useState9 = (0, _react.useState)(false),
	    _useState10 = _slicedToArray(_useState9, 2),
	    onCloseOrTimeOut = _useState10[0],
	    setOnCloseOrTimeOut = _useState10[1];
	  var counterTimeOnWrapUp = null;
	  var onSend = function onSend(action) {
	    if (action === 'send') {
	      if (disposition === undefined) {
	        setDisposition(dispositions[0]);
	      }
	      setDisable(true);
	      select();
	      setDisposition(undefined);
	      setSubDisposition(undefined);
	      setTimeOnWrapUp(0);
	      if (closeModal) {
	        onToggle();
	        setTimeout(function () {
	          onFinish();
	        }, 500);
	      }
	    } else {
	      setOnCloseOrTimeOut(true);
	      onToggle();
	    }
	  };
	  (0, _react.useEffect)(function () {
	    if (dispositions && type === _constants.TABS.MAIL) {
	      dispositions.map(function (option) {
	        if (option.endConversation) {
	          option.icon = 'selected';
	          option.tooltiptext = t('endconversation');
	        }
	      });
	    }
	  }, [dispositions]);
	  (0, _react.useEffect)(function () {
	    if (disposition && disposition.subDispositions && type === _constants.TABS.MAIL) {
	      disposition.subDispositions.map(function (option) {
	        if (option.endConversation) {
	          option.icon = 'selected';
	          option.tooltiptext = t('endconversation');
	        }
	      });
	    }
	  }, [disposition]);
	  var select = function select() {
	    if (onCloseOrTimeOut) {
	      onSelect({
	        acdId: acdId,
	        conversationId: conversationId,
	        type: _constants.MEDIATYPE[type],
	        disposition: 0,
	        subDisposition: 0,
	        wrapUp: timeOnWrapUp,
	        closeModal: closeModal
	      });
	      return;
	    }
	    if (disposition && !subDisposition) {
	      onSelect({
	        acdId: acdId,
	        conversationId: conversationId,
	        type: _constants.MEDIATYPE[type],
	        disposition: disposition.id,
	        subDisposition: 0,
	        wrapUp: timeOnWrapUp,
	        closeModal: closeModal
	      });
	    }
	    if (disposition && subDisposition) {
	      onSelect({
	        acdId: acdId,
	        conversationId: conversationId,
	        type: _constants.MEDIATYPE[type],
	        disposition: disposition.id,
	        subDisposition: subDisposition.id,
	        wrapUp: timeOnWrapUp,
	        closeModal: closeModal
	      });
	    }
	    if (!disposition) {
	      onSelect({
	        acdId: acdId,
	        conversationId: conversationId,
	        type: _constants.MEDIATYPE[type],
	        disposition: 0,
	        subDisposition: 0,
	        wrapUp: timeOnWrapUp,
	        closeModal: closeModal
	      });
	    }
	  };
	  (0, _react.useEffect)(function () {
	    if (show === true) {
	      counterTimeOnWrapUp = setInterval(function () {
	        setTimeOnWrapUp(function (timeOnWrapUp) {
	          return timeOnWrapUp + 1;
	        });
	      }, 1000);
	    }
	    return function () {
	      clearInterval(counterTimeOnWrapUp);
	    };
	  }, [show]);
	  (0, _react.useEffect)(function () {
	    if (disposition === undefined) setDisposition(undefined);
	    setSubDisposition(undefined);
	  }, [disposition]);
	  var onToggle = function onToggle() {
	    toggle();
	    setDisable(false);
	  };
	  (0, _react.useEffect)(function () {
	    if (onCloseOrTimeOut) {
	      if (!disabled) select();
	      setDisposition(undefined);
	      setSubDisposition(undefined);
	      setTimeOnWrapUp(0);
	      setOnCloseOrTimeOut(false);
	      setTimeout(function () {
	        onFinish();
	      }, 500);
	    }
	  }, [onCloseOrTimeOut]);
	  return /*#__PURE__*/_react["default"].createElement(_reactstrap.Modal, {
	    isOpen: show,
	    toggle: toggle,
	    className: "uin-wrapup ".concat(dispositions ? '' : 'small'),
	    centered: true,
	    backdrop: "static"
	  }, /*#__PURE__*/_react["default"].createElement(_reactstrap.ModalHeader, {
	    className: "uin-wrapup-header ".concat(dispositions ? '' : 'small'),
	    toggle: closeModal ? function () {
	      return onSend('close');
	    } : undefined
	  }, t('title')), /*#__PURE__*/_react["default"].createElement(_reactstrap.ModalBody, {
	    className: "uin-wrapup-body ".concat(dispositions ? '' : 'small')
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-wrapup-countdown",
	    id: "uinw-countdown"
	  }, /*#__PURE__*/_react["default"].createElement(_Stopwatch["default"], {
	    countdown: true,
	    initialTime: time,
	    countdownAction: function countdownAction() {
	      setOnCloseOrTimeOut(true);
	      setTimeout(function () {
	        onToggle();
	      }, 10);
	    },
	    viewHours: true
	  })), dispositions && /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-wrapup-options"
	  }, /*#__PURE__*/_react["default"].createElement(_globalComponentsLibrary.SearchSelection, {
	    className: "uin-wrapup-dopdown",
	    options: dispositions,
	    placeholder: t('placeholder'),
	    onSelected: setDisposition,
	    filterBy: 'text',
	    defaultIndex: 0,
	    disabled: disabled,
	    ignoreCase: true,
	    swapStyles: true
	  })), disposition && disposition.subDispositions && /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-wrapup-sub-options"
	  }, /*#__PURE__*/_react["default"].createElement(_globalComponentsLibrary.SearchSelection, {
	    className: "uin-wrapup-dopdown",
	    options: disposition.subDispositions,
	    placeholder: t('placeholderSub'),
	    onSelected: setSubDisposition,
	    filterBy: 'text',
	    defaultIndex: 0,
	    disabled: disabled,
	    ignoreCase: true,
	    swapStyles: true
	  }))), /*#__PURE__*/_react["default"].createElement(_reactstrap.ModalFooter, {
	    className: "uin-wrapup-footer ".concat(dispositions ? '' : 'small')
	  }, /*#__PURE__*/_react["default"].createElement(_globalComponentsLibrary.Button, {
	    color: "primary",
	    onClick: function onClick() {
	      return onSend('send');
	    },
	    disabled: disabled
	  }, disposition || !closeModal ? t('select') : t('end'))));
	};
	WrapUp.propTypes = {
	  show: _propTypes["default"].bool.isRequired,
	  time: _propTypes["default"].number.isRequired,
	  toggle: _propTypes["default"].func.isRequired,
	  onFinish: _propTypes["default"].func.isRequired,
	  dispositions: _propTypes["default"].arrayOf(_types.dispositionType).isRequired
	};
	var _default = exports["default"] = WrapUp;

/***/ },
/* 1430 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var _react = _interopRequireWildcard(__webpack_require__(1));
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	var _helpers = __webpack_require__(53);
	var _ListInput = _interopRequireDefault(__webpack_require__(1431));
	__webpack_require__(2503);
	var _types = __webpack_require__(60);
	var _InputChip = _interopRequireDefault(__webpack_require__(594));
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
	function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
	function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
	function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
	function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	var AddressInput = function AddressInput(_ref) {
	  var label = _ref.label,
	    list = _ref.list,
	    selected = _ref.selected,
	    onSelect = _ref.onSelect,
	    onEdit = _ref.onEdit,
	    _onDelete = _ref.onDelete;
	  var _useState = (0, _react.useState)(''),
	    _useState2 = _slicedToArray(_useState, 2),
	    value = _useState2[0],
	    setValue = _useState2[1];
	  var inputRef = (0, _react.useRef)();
	  var editRef = (0, _react.useRef)();
	  var selectContact = function selectContact(contact) {
	    if ((0, _helpers.isValidMail)(contact.account)) {
	      onSelect(contact);
	    } else {
	      onSelect(_objectSpread(_objectSpread({}, contact), {}, {
	        invalid: true
	      }));
	    }
	    setValue('');
	  };
	  var _useState3 = (0, _react.useState)(null),
	    _useState4 = _slicedToArray(_useState3, 2),
	    editing = _useState4[0],
	    setEditing = _useState4[1];
	  (0, _react.useEffect)(function () {
	    if (editing !== null) editRef.current.focus();
	  }, [editing]);
	  var editContact = function editContact(i, c) {
	    onEdit(i, _objectSpread(_objectSpread({}, c), {}, {
	      invalid: !(0, _helpers.isValidMail)(c.account)
	    }));
	    setEditing(null);
	  };
	  var blurEditing = function blurEditing(i, c) {
	    if (c.account === '') {
	      _onDelete(i);
	      setEditing(null);
	    }
	  };
	  var propagationWrapper = function propagationWrapper(e, action) {
	    e.stopPropagation();
	    action();
	  };
	  var inputID = 'uin-ain-input-' + label.replace(/\s+/g, '');
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-address-input",
	    onClick: function onClick() {
	      return inputRef.current.focus();
	    }
	  }, /*#__PURE__*/_react["default"].createElement("span", {
	    className: "uin-ain-label"
	  }, label, ":"), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-ain-addresses"
	  }, selected.map(function (c, i) {
	    return editing === i ? /*#__PURE__*/_react["default"].createElement(_ListInput["default"], {
	      key: i,
	      id: inputID + i,
	      ref: editRef,
	      adjustable: true,
	      list: list,
	      value: c.account,
	      onClick: function onClick(e) {
	        return e.stopPropagation();
	      },
	      onChange: function onChange(e) {
	        return onEdit(i, _objectSpread(_objectSpread({}, c), {}, {
	          account: e.currentTarget.value
	        }));
	      },
	      onSelect: function onSelect(c) {
	        return editContact(i, c);
	      },
	      onBlur: function onBlur() {
	        return blurEditing(i, c);
	      }
	    }) : /*#__PURE__*/_react["default"].createElement(_InputChip["default"], {
	      key: i,
	      label: c.account,
	      interactive: true,
	      invalid: c.invalid,
	      onClick: function onClick(e) {
	        return propagationWrapper(e, function () {
	          return setEditing(i);
	        });
	      },
	      onDelete: function onDelete(e) {
	        return propagationWrapper(e, function () {
	          return _onDelete(i);
	        });
	      }
	    });
	  }), /*#__PURE__*/_react["default"].createElement(_ListInput["default"], {
	    id: inputID,
	    ref: inputRef,
	    list: list,
	    value: value,
	    onChange: function onChange(e) {
	      return setValue(e.currentTarget.value);
	    },
	    onSelect: selectContact
	  })));
	};
	AddressInput.propTypes = {
	  label: _propTypes["default"].string.isRequired,
	  selected: _propTypes["default"].arrayOf(_types.contactType),
	  list: _propTypes["default"].arrayOf(_types.contactType),
	  onSelect: _propTypes["default"].func.isRequired,
	  onEdit: _propTypes["default"].func.isRequired,
	  onDelete: _propTypes["default"].func.isRequired
	};
	AddressInput.defaultProps = {
	  selected: []
	};
	var _default = exports["default"] = AddressInput;

/***/ },
/* 1431 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var _react = _interopRequireWildcard(__webpack_require__(1));
	var _globalComponentsLibrary = __webpack_require__(28);
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
	function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	var ListInput = function ListInput(_ref, ref) {
	  var id = _ref.id,
	    value = _ref.value,
	    onChange = _ref.onChange,
	    onClick = _ref.onClick,
	    onSelect = _ref.onSelect,
	    onBlur = _ref.onBlur,
	    list = _ref.list,
	    adjustable = _ref.adjustable;
	  var inputRef = (0, _react.useRef)();
	  (0, _react.useImperativeHandle)(ref, function () {
	    return {
	      focus: function focus() {
	        inputRef.current.focus();
	      }
	    };
	  });
	  var _useState = (0, _react.useState)(false),
	    _useState2 = _slicedToArray(_useState, 2),
	    isListOpen = _useState2[0],
	    setListOpen = _useState2[1];
	  var filteredList = (0, _react.useMemo)(function () {
	    return value === '' || list == null ? list : list.filter(function (c) {
	      return c.name.toLowerCase().includes(value.toLowerCase()) || c.account.toLowerCase().includes(value.toLowerCase());
	    });
	  }, [value, list]);
	  var _useState3 = (0, _react.useState)(0),
	    _useState4 = _slicedToArray(_useState3, 2),
	    focused = _useState4[0],
	    setFocused = _useState4[1];
	  (0, _react.useEffect)(function () {
	    if (filteredList && focused >= filteredList.length && filteredList.length > 0) {
	      setFocused(filteredList.length - 1);
	    }
	  }, [filteredList, focused]);
	  var handleKeyDown = function handleKeyDown(e) {
	    if (['Enter', 'Tab', ',', ';'].includes(e.key)) {
	      if (e.key === 'Tab' && value === '') return;
	      e.preventDefault();
	      if (isListOpen && filteredList[focused] !== undefined) {
	        setListOpen(false);
	        onSelect(filteredList[focused]);
	      } else if (value !== '') {
	        setListOpen(false);
	        onSelect({
	          account: value
	        });
	      }
	    } else {
	      if (filteredList != null) {
	        if (!isListOpen) setListOpen(true);
	        if (['ArrowUp', 'ArrowDown'].includes(e.key)) {
	          e.preventDefault();
	          if (e.key === 'ArrowDown') setFocused(Math.min(focused + 1, filteredList.length - 1));else if (e.key === 'ArrowUp') setFocused(Math.max(0, focused - 1));
	        }
	      }
	    }
	  };
	  var selectRef = (0, _react.useRef)(onSelect);
	  (0, _react.useEffect)(function () {
	    selectRef.current = onSelect;
	  });
	  var blurCallback = (0, _react.useCallback)(function () {
	    if (value !== '') {
	      selectRef.current({
	        account: value
	      });
	    } else {
	      onBlur && onBlur();
	    }
	  }, [onBlur, value]);
	  var blurFlag = (0, _react.useRef)(false);
	  var handleBlur = function handleBlur() {
	    if (filteredList == null) {
	      blurCallback();
	    } else {
	      if (!(filteredList.length > 0 && isListOpen) && value !== '') {
	        onSelect({
	          account: value
	        });
	      }
	      blurFlag.current = true;
	    }
	  };
	  (0, _react.useEffect)(function () {
	    if (blurFlag.current && !isListOpen) {
	      blurCallback();
	      blurFlag.current = false;
	    }
	  }, [isListOpen, blurCallback]);
	  var handleItemClick = function handleItemClick(c) {
	    setListOpen(false);
	    onSelect(c);
	  };
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    id: id,
	    tabIndex: 1,
	    onBlur: handleBlur,
	    className: 'uin-ain-list-input' + (adjustable ? ' auto' : '')
	  }, /*#__PURE__*/_react["default"].createElement("input", {
	    ref: inputRef,
	    type: "mail",
	    style: adjustable ? {
	      width: value.length * 0.875 + 'rem'
	    } : undefined,
	    value: value,
	    onClick: onClick,
	    onChange: onChange,
	    onKeyDown: handleKeyDown,
	    autoComplete: "off"
	  }), filteredList && filteredList.length > 0 && /*#__PURE__*/_react["default"].createElement(_globalComponentsLibrary.ListDropDown, {
	    target: id,
	    isOpen: isListOpen,
	    toggle: function toggle() {
	      return setListOpen(!isListOpen);
	    }
	  }, filteredList.map(function (c, i) {
	    return /*#__PURE__*/_react["default"].createElement(_globalComponentsLibrary.ListItem, {
	      key: i,
	      icon: "user",
	      username: c.name,
	      extraUserInfo: c.account,
	      onClick: function onClick() {
	        return handleItemClick(c);
	      },
	      focused: focused === i,
	      onFocus: function onFocus() {
	        return setFocused(i);
	      }
	    });
	  })));
	};
	var _default = exports["default"] = /*#__PURE__*/(0, _react.forwardRef)(ListInput);

/***/ },
/* 1432 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var _react = _interopRequireWildcard(__webpack_require__(1));
	var _formatters = __webpack_require__(83);
	var _dateFns = __webpack_require__(147);
	var _reactI18next = __webpack_require__(41);
	__webpack_require__(2505);
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	var DateDivider = function DateDivider(_ref, _ref2) {
	  var index = _ref.index,
	    lang = _ref.lang,
	    date = _ref.date;
	  var _useTranslation = (0, _reactI18next.useTranslation)(['chat']),
	    t = _useTranslation.t;
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    ref: function ref(el) {
	      return _ref2.current[index] = el;
	    },
	    className: "uin-date-divider"
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-date-divider-container"
	  }, /*#__PURE__*/_react["default"].createElement("span", {
	    className: "uin-date-divider-span"
	  }, (0, _dateFns.isToday)(date) ? t("divider-today") : (0, _dateFns.isYesterday)(date) ? t("divider-yesterday") : (0, _formatters.formatDateWithDayOfWeek)(date, lang))));
	};
	var _default = exports["default"] = /*#__PURE__*/(0, _react.forwardRef)(DateDivider);

/***/ },
/* 1433 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.Option = void 0;
	var _react = _interopRequireWildcard(__webpack_require__(1));
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	var _reactstrap = __webpack_require__(70);
	var _classnames2 = _interopRequireDefault(__webpack_require__(119));
	__webpack_require__(2506);
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
	function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
	function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	var DropUpMenu = function DropUpMenu(_ref) {
	  var id = _ref.id,
	    orientation = _ref.orientation,
	    icon = _ref.icon,
	    iconData = _ref.iconData,
	    text = _ref.text,
	    children = _ref.children;
	  var _useState = (0, _react.useState)(false),
	    _useState2 = _slicedToArray(_useState, 2),
	    isOpen = _useState2[0],
	    setOpen = _useState2[1];
	  var handleClick = function handleClick(e) {
	    e.preventDefault();
	  };
	  var close = function close(e) {
	    if (e.button === 2) return;
	    e.preventDefault();
	    setOpen(false);
	  };
	  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("button", {
	    id: id,
	    className: "uin-ddms-button ".concat(isOpen ? 'open' : ''),
	    onMouseDown: handleClick
	  }, icon && /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon ".concat(icon),
	    "data-color": iconData,
	    style: {
	      '--data-color': iconData
	    }
	  }), text && /*#__PURE__*/_react["default"].createElement("span", {
	    className: "uin-ddms-text"
	  }, text), /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon tiny ".concat(isOpen ? 'arrow-action-up' : 'arrow-action')
	  })), /*#__PURE__*/_react["default"].createElement(_reactstrap.Popover, {
	    target: id,
	    toggle: function toggle() {
	      return setOpen(function (o) {
	        return !o;
	      });
	    },
	    isOpen: isOpen,
	    placement: "top-start",
	    hideArrow: true,
	    trigger: "legacy",
	    popperClassName: "uin-ddms-options-wrapper",
	    boundariesElement: "window",
	    onMouseDown: handleClick
	  }, /*#__PURE__*/_react["default"].createElement(_reactstrap.PopoverBody, {
	    className: "uin-ddms-options ".concat(orientation),
	    onMouseDown: close
	  }, children)));
	};
	var Option = exports.Option = function Option(_ref2) {
	  var _classnames;
	  var children = _ref2.children,
	    selected = _ref2.selected,
	    icon = _ref2.icon,
	    className = _ref2.className,
	    style = _ref2.style,
	    onClick = _ref2.onClick;
	  var classes = (0, _classnames2["default"])((_classnames = {}, _defineProperty(_classnames, className, className != null), _defineProperty(_classnames, "selected", selected), _classnames));
	  var handleClick = function handleClick(e) {
	    if (e.button === 2) return false;
	    e.preventDefault();
	    onClick();
	  };
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-ddms-option ".concat(classes),
	    style: style,
	    onMouseDown: handleClick
	  }, selected && /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon sent"
	  }), children && /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-ddms-text-option"
	  }, children), icon && /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon ".concat(icon)
	  }));
	};
	DropUpMenu.propTypes = {
	  orientation: _propTypes["default"].oneOf(['horizontal', 'vertical', 'palette']),
	  id: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired,
	  icon: _propTypes["default"].string,
	  text: _propTypes["default"].string
	};
	var _default = exports["default"] = DropUpMenu;

/***/ },
/* 1434 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var _react = _interopRequireWildcard(__webpack_require__(1));
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	__webpack_require__(2510);
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	var MessageInput = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
	  var _ref$value = _ref.value,
	    value = _ref$value === void 0 ? '' : _ref$value,
	    onChange = _ref.onChange,
	    onEnter = _ref.onEnter,
	    maxChars = _ref.maxChars,
	    disabled = _ref.disabled,
	    placeholder = _ref.placeholder,
	    onFocus = _ref.onFocus;
	  var areaRef = (0, _react.useRef)(null);
	  (0, _react.useImperativeHandle)(ref, function () {
	    return {
	      focus: function focus() {
	        areaRef.current.focus();
	      }
	    };
	  });
	  var handleChange = function handleChange(e) {
	    var newVal = e.currentTarget.value;
	    if (maxChars && newVal.length > maxChars) return;
	    onChange(newVal);
	  };
	  var calculateRows = function calculateRows() {
	    areaRef.current.rows = 1;
	    var newRows = Math.ceil((areaRef.current.scrollHeight - 44) / 20);
	    areaRef.current.rows = 1 + newRows;
	  };
	  (0, _react.useLayoutEffect)(calculateRows, [value]);
	  var handleKeyDown = function handleKeyDown(e) {
	    if (e.key === 'Enter') {
	      e.preventDefault();
	      if (!(e.shiftKey || e.ctrlKey || e.altKey)) {
	        onEnter && onEnter();
	      } else {
	        onChange(value + '\r\n');
	      }
	    }
	  };
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: 'uin-message-input' + (disabled ? ' disabled' : '')
	  }, /*#__PURE__*/_react["default"].createElement("textarea", {
	    onFocus: onFocus,
	    ref: areaRef,
	    value: value,
	    onChange: handleChange,
	    onKeyDown: handleKeyDown,
	    disabled: disabled,
	    placeholder: placeholder,
	    rows: 1,
	    spellCheck: "true"
	  }), maxChars && /*#__PURE__*/_react["default"].createElement("span", {
	    className: "uin-mi-counter"
	  }, /*#__PURE__*/_react["default"].createElement("span", {
	    className: value.length === maxChars ? 'uin-mi-alert' : undefined
	  }, value.length), "/", maxChars));
	});
	MessageInput.propTypes = {
	  value: _propTypes["default"].string.isRequired,
	  onChange: _propTypes["default"].func.isRequired,
	  onEnter: _propTypes["default"].func,
	  maxChars: _propTypes["default"].number,
	  disabled: _propTypes["default"].bool,
	  placeholder: _propTypes["default"].string
	};
	var _default = exports["default"] = MessageInput;

/***/ },
/* 1435 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var _react = _interopRequireDefault(__webpack_require__(1));
	__webpack_require__(2511);
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	var ReassignDivider = function ReassignDivider(_ref) {
	  var userAgent = _ref.userAgent;
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-reassign-divider"
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-reassign-divider-line"
	  }), /*#__PURE__*/_react["default"].createElement("span", {
	    className: "uin-reassign-divider-span"
	  }, userAgent));
	};
	var _default = exports["default"] = ReassignDivider;

/***/ },
/* 1436 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var _react = _interopRequireDefault(__webpack_require__(1));
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	__webpack_require__(2512);
	var _classnames = _interopRequireDefault(__webpack_require__(119));
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	var ToggleChip = function ToggleChip(_ref) {
	  var id = _ref.id,
	    label = _ref.label,
	    active = _ref.active,
	    toggle = _ref.toggle,
	    disabled = _ref.disabled,
	    tabIndex = _ref.tabIndex;
	  var classes = (0, _classnames["default"])({
	    active: active,
	    disabled: disabled
	  });
	  return /*#__PURE__*/_react["default"].createElement("button", {
	    id: id,
	    className: 'uin-toggle-chip ' + classes,
	    onClick: toggle,
	    tabIndex: tabIndex
	  }, /*#__PURE__*/_react["default"].createElement("span", {
	    className: "uin-chip-icon"
	  }, /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon sent"
	  })), /*#__PURE__*/_react["default"].createElement("span", {
	    className: "uin-chip-label"
	  }, label));
	};
	ToggleChip.propTypes = {
	  label: _propTypes["default"].string.isRequired,
	  active: _propTypes["default"].bool,
	  toggle: _propTypes["default"].func.isRequired,
	  disabled: _propTypes["default"].bool
	};
	var _default = exports["default"] = ToggleChip;

/***/ },
/* 1437 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var _i18next = _interopRequireDefault(__webpack_require__(2032));
	var _reactI18next = __webpack_require__(41);
	var _translations = _interopRequireDefault(__webpack_require__(2041));
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	_i18next["default"].use(_reactI18next.initReactI18next) // passes i18n down to react-i18next
	.init({
	  resources: _translations["default"],
	  lng: 'es',
	  debug: false,
	  interpolation: {
	    escapeValue: false // react already safes from xss
	  }
	});
	var _default = exports["default"] = _i18next["default"];

/***/ },
/* 1438 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = HtmlParser;
	
	var _htmlparser = __webpack_require__(177);
	
	var _htmlparser2 = _interopRequireDefault(_htmlparser);
	
	var _processNodes = __webpack_require__(379);
	
	var _processNodes2 = _interopRequireDefault(_processNodes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Parses a HTML string and returns a list of React components generated from it
	 *
	 * @param {String} html The HTML to convert into React component
	 * @param {Object} options Options to pass
	 * @returns {Array} List of top level React elements
	 */
	function HtmlParser(html) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$decodeEntities = _ref.decodeEntities,
	      decodeEntities = _ref$decodeEntities === undefined ? true : _ref$decodeEntities,
	      transform = _ref.transform,
	      _ref$preprocessNodes = _ref.preprocessNodes,
	      preprocessNodes = _ref$preprocessNodes === undefined ? function (nodes) {
	    return nodes;
	  } : _ref$preprocessNodes;
	
	  var nodes = preprocessNodes(_htmlparser2.default.parseDOM(html, { decodeEntities: decodeEntities }));
	  return (0, _processNodes2.default)(nodes, transform);
	}

/***/ },
/* 1439 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * List of boolean attributes
	 * These attributes should have their React attribute value set to be the same as their name
	 * E.g. <input disabled> = <input disabled>
	 *      <input disabled=""> = <input disabled>
	 *      <input disabled="disabled"> = <input disabled>
	 * @type {Array}
	 */
	exports.default = ['allowfullScreen', 'async', 'autoplay', 'capture', 'checked', 'controls', 'default', 'defer', 'disabled', 'formnovalidate', 'hidden', 'loop', 'multiple', 'muted', 'novalidate', 'open', 'playsinline', 'readonly', 'required', 'reversed', 'scoped', 'seamless', 'selected', 'itemscope'];

/***/ },
/* 1440 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Mapping of standard HTML attributes to their React counterparts
	 * List taken and reversed from react/src/renderers/dom/shared/HTMLDOMPropertyConfig.js
	 * https://github.com/facebook/react/blob/c9c3c339b757682f1154f1c915eb55e6a8766933/src/renderers/dom/shared/HTMLDOMPropertyConfig.js
	 * @type {Object}
	 */
	exports.default = {
	  /**
	   * Standard Properties
	   */
	  accept: 'accept',
	  'accept-charset': 'acceptCharset',
	  accesskey: 'accessKey',
	  action: 'action',
	  allowfullscreen: 'allowFullScreen',
	  allowtransparency: 'allowTransparency',
	  alt: 'alt',
	  as: 'as',
	  async: 'async',
	  autocomplete: 'autoComplete',
	  autoplay: 'autoPlay',
	  capture: 'capture',
	  cellpadding: 'cellPadding',
	  cellspacing: 'cellSpacing',
	  charset: 'charSet',
	  challenge: 'challenge',
	  checked: 'checked',
	  cite: 'cite',
	  classid: 'classID',
	  class: 'className',
	  cols: 'cols',
	  colspan: 'colSpan',
	  content: 'content',
	  contenteditable: 'contentEditable',
	  contextmenu: 'contextMenu',
	  controls: 'controls',
	  controlsList: 'controlsList',
	  coords: 'coords',
	  crossorigin: 'crossOrigin',
	  data: 'data',
	  datetime: 'dateTime',
	  default: 'default',
	  defer: 'defer',
	  dir: 'dir',
	  disabled: 'disabled',
	  download: 'download',
	  draggable: 'draggable',
	  enctype: 'encType',
	  form: 'form',
	  formaction: 'formAction',
	  formenctype: 'formEncType',
	  formmethod: 'formMethod',
	  formnovalidate: 'formNoValidate',
	  formtarget: 'formTarget',
	  frameborder: 'frameBorder',
	  headers: 'headers',
	  height: 'height',
	  hidden: 'hidden',
	  high: 'high',
	  href: 'href',
	  hreflang: 'hrefLang',
	  for: 'htmlFor',
	  'http-equiv': 'httpEquiv',
	  icon: 'icon',
	  id: 'id',
	  inputmode: 'inputMode',
	  integrity: 'integrity',
	  is: 'is',
	  keyparams: 'keyParams',
	  keytype: 'keyType',
	  kind: 'kind',
	  label: 'label',
	  lang: 'lang',
	  list: 'list',
	  loop: 'loop',
	  low: 'low',
	  manifest: 'manifest',
	  marginheight: 'marginHeight',
	  marginwidth: 'marginWidth',
	  max: 'max',
	  maxlength: 'maxLength',
	  media: 'media',
	  mediagroup: 'mediaGroup',
	  method: 'method',
	  min: 'min',
	  minlength: 'minLength',
	  multiple: 'multiple',
	  muted: 'muted',
	  name: 'name',
	  nonce: 'nonce',
	  novalidate: 'noValidate',
	  open: 'open',
	  optimum: 'optimum',
	  pattern: 'pattern',
	  placeholder: 'placeholder',
	  playsinline: 'playsInline',
	  poster: 'poster',
	  preload: 'preload',
	  profile: 'profile',
	  radiogroup: 'radioGroup',
	  readonly: 'readOnly',
	  referrerpolicy: 'referrerPolicy',
	  rel: 'rel',
	  required: 'required',
	  reversed: 'reversed',
	  role: 'role',
	  rows: 'rows',
	  rowspan: 'rowSpan',
	  sandbox: 'sandbox',
	  scope: 'scope',
	  scoped: 'scoped',
	  scrolling: 'scrolling',
	  seamless: 'seamless',
	  selected: 'selected',
	  shape: 'shape',
	  size: 'size',
	  sizes: 'sizes',
	  slot: 'slot',
	  span: 'span',
	  spellcheck: 'spellCheck',
	  src: 'src',
	  srcdoc: 'srcDoc',
	  srclang: 'srcLang',
	  srcset: 'srcSet',
	  start: 'start',
	  step: 'step',
	  style: 'style',
	  summary: 'summary',
	  tabindex: 'tabIndex',
	  target: 'target',
	  title: 'title',
	  type: 'type',
	  usemap: 'useMap',
	  value: 'value',
	  width: 'width',
	  wmode: 'wmode',
	  wrap: 'wrap',
	  /**
	   * RDFa Properties
	   */
	  about: 'about',
	  datatype: 'datatype',
	  inlist: 'inlist',
	  prefix: 'prefix',
	  property: 'property',
	  resource: 'resource',
	  typeof: 'typeof',
	  vocab: 'vocab',
	  /**
	   * Non-standard Properties
	   */
	  autocapitalize: 'autoCapitalize',
	  autocorrect: 'autoCorrect',
	  autosave: 'autoSave',
	  color: 'color',
	  itemprop: 'itemProp',
	  itemscope: 'itemScope',
	  itemtype: 'itemType',
	  itemid: 'itemID',
	  itemref: 'itemRef',
	  results: 'results',
	  security: 'security',
	  unselectable: 'unselectable'
	};

/***/ },
/* 1441 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * List of void elements
	 * These elements are not allowed to have children
	 * @type {Array}
	 */
	exports.default = ['area', 'base', 'br', 'col', 'command', 'embed', 'hr', 'img', 'input', 'keygen', 'link', 'meta', 'param', 'source', 'track', 'wbr'];

/***/ },
/* 1442 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = StyleElementType;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _generatePropsFromAttributes = __webpack_require__(598);
	
	var _generatePropsFromAttributes2 = _interopRequireDefault(_generatePropsFromAttributes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Converts a <style> element to a React element
	 *
	 * @param {Object} node The style node
	 * @param {String} index The index of the React element relative to it's parent
	 * @returns {React.Element} The React style element
	 */
	function StyleElementType(node, index) {
	
	  // The style element only ever has a single child which is the styles so try and find this to add as
	  // a child to the style element that will be created
	  var styles = void 0;
	  if (node.children.length > 0) {
	    styles = node.children[0].data;
	  }
	
	  // generate props
	  var props = (0, _generatePropsFromAttributes2.default)(node.attribs, index);
	
	  // create and return the element
	  return _react2.default.createElement('style', props, styles);
	}

/***/ },
/* 1443 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = TagElementType;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _processNodes = __webpack_require__(379);
	
	var _processNodes2 = _interopRequireDefault(_processNodes);
	
	var _generatePropsFromAttributes = __webpack_require__(598);
	
	var _generatePropsFromAttributes2 = _interopRequireDefault(_generatePropsFromAttributes);
	
	var _VoidElements = __webpack_require__(1441);
	
	var _VoidElements2 = _interopRequireDefault(_VoidElements);
	
	var _isValidTagOrAttributeName = __webpack_require__(599);
	
	var _isValidTagOrAttributeName2 = _interopRequireDefault(_isValidTagOrAttributeName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Converts any element (excluding style - see StyleElementType - and script) to a react element.
	 *
	 * @param {Object} node The tag node
	 * @param {String} index The index of the React element relative to it's parent
	 * @param {Function} transform The transform function to apply to all children
	 * @returns {React.Element} The React tag element
	 */
	function TagElementType(node, index, transform) {
	
	  var tagName = node.name;
	
	  // validate tag name
	  if (!(0, _isValidTagOrAttributeName2.default)(tagName)) {
	    return null;
	  }
	
	  // generate props
	  var props = (0, _generatePropsFromAttributes2.default)(node.attribs, index);
	
	  // If the node is not a void element and has children then process them
	  var children = null;
	  if (_VoidElements2.default.indexOf(tagName) === -1) {
	    children = (0, _processNodes2.default)(node.children, transform);
	  }
	
	  // create and return the element
	  return _react2.default.createElement(tagName, props, children);
	}

/***/ },
/* 1444 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = TextElementType;
	/**
	 * Converts a text node to a React text element
	 *
	 * @param {Object} node The text node
	 * @returns {String} The text
	 */
	function TextElementType(node) {
	
	  // React will accept plain text for rendering so just return the node data
	  return node.data;
	}

/***/ },
/* 1445 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = UnsupportedElementType;
	/**
	 * Handles an unsupported element type by returning null so nothing is rendered
	 * @returns {null}
	 */
	function UnsupportedElementType() {
	
	  // do nothing because the element type is unsupported
	  // comment, directive, script, cdata, doctype are all currently unsupported
	  return null;
	}

/***/ },
/* 1446 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ElementType$Text$Ele;
	
	var _htmlparser = __webpack_require__(177);
	
	var _TextElementType = __webpack_require__(1444);
	
	var _TextElementType2 = _interopRequireDefault(_TextElementType);
	
	var _TagElementType = __webpack_require__(1443);
	
	var _TagElementType2 = _interopRequireDefault(_TagElementType);
	
	var _StyleElementType = __webpack_require__(1442);
	
	var _StyleElementType2 = _interopRequireDefault(_StyleElementType);
	
	var _UnsupportedElementType = __webpack_require__(1445);
	
	var _UnsupportedElementType2 = _interopRequireDefault(_UnsupportedElementType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /*
	                                                                                                                                                                                                                   * Map each htmlparser2 element type to a function which will convert that element type to a React element
	                                                                                                                                                                                                                   * Not all of the element types are supported so the UnsupportedElementType is used for them which will not return any
	                                                                                                                                                                                                                   * value
	                                                                                                                                                                                                                   */
	
	exports.default = (_ElementType$Text$Ele = {}, _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.Text, _TextElementType2.default), _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.Tag, _TagElementType2.default), _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.Style, _StyleElementType2.default), _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.Directive, _UnsupportedElementType2.default), _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.Comment, _UnsupportedElementType2.default), _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.Script, _UnsupportedElementType2.default), _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.CDATA, _UnsupportedElementType2.default), _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.Doctype, _UnsupportedElementType2.default), _ElementType$Text$Ele);

/***/ },
/* 1447 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = htmlAttributesToReact;
	
	var _BooleanAttributes = __webpack_require__(1439);
	
	var _BooleanAttributes2 = _interopRequireDefault(_BooleanAttributes);
	
	var _ReactAttributes = __webpack_require__(1440);
	
	var _ReactAttributes2 = _interopRequireDefault(_ReactAttributes);
	
	var _isValidTagOrAttributeName = __webpack_require__(599);
	
	var _isValidTagOrAttributeName2 = _interopRequireDefault(_isValidTagOrAttributeName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Returns the parsed attribute value taking into account things like boolean attributes
	 *
	 * @param {String} attribute The name of the attribute
	 * @param {*} value The value of the attribute from the HTML
	 * @returns {*} The parsed attribute value
	 */
	var getParsedAttributeValue = function getParsedAttributeValue(attribute, value) {
	
	  // if the attribute if a boolean then it's value should be the same as it's name
	  // e.g. disabled="disabled"
	  var lowerBooleanAttributes = _BooleanAttributes2.default.map(function (attr) {
	    return attr.toLowerCase();
	  });
	  if (lowerBooleanAttributes.indexOf(attribute.toLowerCase()) >= 0) {
	    value = attribute;
	  }
	
	  return value;
	};
	
	/**
	 * Takes an object of standard HTML property names and converts them to their React counterpart. If the react
	 * version does not exist for an attribute then just use it as it is
	 *
	 * @param {Object} attributes The HTML attributes to convert
	 * @returns {Object} The React attributes
	 */
	function htmlAttributesToReact(attributes) {
	
	  return Object.keys(attributes).filter(function (attr) {
	    return (0, _isValidTagOrAttributeName2.default)(attr);
	  }).reduce(function (mappedAttributes, attribute) {
	
	    // lowercase the attribute name and find it in the react attribute map
	    var lowerCaseAttribute = attribute.toLowerCase();
	
	    // format the attribute name
	    var name = _ReactAttributes2.default[lowerCaseAttribute] || lowerCaseAttribute;
	
	    // add the parsed attribute value to the mapped attributes
	    mappedAttributes[name] = getParsedAttributeValue(name, attributes[attribute]);
	
	    return mappedAttributes;
	  }, {});
	}

/***/ },
/* 1448 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = InlineStyleToObject;
	/**
	 * Converts an inline style string into an object of React style properties
	 *
	 * @param {String} inlineStyle='' The inline style to convert
	 * @returns {Object} The converted style
	 */
	function InlineStyleToObject() {
	  var inlineStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	
	  // just return empty object if the inlineStyle is empty
	  if (inlineStyle === '') {
	    return {};
	  }
	
	  return inlineStyle.split(';').reduce(function (styleObject, stylePropertyValue) {
	
	    // extract the style property name and value
	    var _stylePropertyValue$s = stylePropertyValue.split(/^([^:]+):/).filter(function (val, i) {
	      return i > 0;
	    }).map(function (item) {
	      return item.trim().toLowerCase();
	    }),
	        _stylePropertyValue$s2 = _slicedToArray(_stylePropertyValue$s, 2),
	        property = _stylePropertyValue$s2[0],
	        value = _stylePropertyValue$s2[1];
	
	    // if there is no value (i.e. no : in the style) then ignore it
	
	
	    if (value === undefined) {
	      return styleObject;
	    }
	
	    // convert the property name into the correct React format
	    // remove all hyphens and convert the letter immediately after each hyphen to upper case
	    // additionally don't uppercase any -ms- prefix
	    // e.g. -ms-style-property = msStyleProperty
	    //      -webkit-style-property = WebkitStyleProperty
	    property = property.replace(/^-ms-/, 'ms-').replace(/-(.)/g, function (_, character) {
	      return character.toUpperCase();
	    });
	
	    // add the new style property and value to the style object
	    styleObject[property] = value;
	
	    return styleObject;
	  }, {});
	}

/***/ },
/* 1449 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isEmptyTextNode;
	/**
	 * Tests a htmlparser2 node and returns whether is it a text node at the start and end of the line containing only
	 * white space. This allows these node types to be excluded from the rendering because they are unnecessary.
	 *
	 * @param {Object} node The element object as created by htmlparser2
	 * @returns {boolean} Whether the node is an empty text node
	 */
	function isEmptyTextNode(node) {
	  return node.type === 'text' && /\r?\n/.test(node.data) && node.data.trim() === '';
	}

/***/ },
/* 1450 */
[2679, 12],
/* 1451 */
[2680, 12],
/* 1452 */
[2681, 12],
/* 1453 */
[2684, 12],
/* 1454 */
[2685, 380, 12],
/* 1455 */
[2686, 12],
/* 1456 */
[2687, 12],
/* 1457 */
[2688, 12],
/* 1458 */
[2689, 12],
/* 1459 */
[2690, 12],
/* 1460 */
[2691, 12],
/* 1461 */
[2692, 12],
/* 1462 */
[2693, 12],
/* 1463 */
[2694, 12],
/* 1464 */
[2695, 12],
/* 1465 */
[2696, 12],
/* 1466 */
[2697, 12],
/* 1467 */
[2698, 12],
/* 1468 */
[2699, 12],
/* 1469 */
[2705, 12],
/* 1470 */
[2707, 12],
/* 1471 */
[2709, 12, 607],
/* 1472 */
[2711, 205, 12],
/* 1473 */
[2712, 205, 12],
/* 1474 */
[2713, 205, 12, 380],
/* 1475 */
[2715, 12],
/* 1476 */
[2716, 12],
/* 1477 */
[2717, 12],
/* 1478 */
[2718, 12],
/* 1479 */
[2719, 12],
/* 1480 */
[2720, 12],
/* 1481 */
[2721, 12, 608],
/* 1482 */
[2722, 258],
/* 1483 */
[2724, 12],
/* 1484 */
[2725, 12],
/* 1485 */
[2726, 12],
/* 1486 */
[2727, 12],
/* 1487 */
[2728, 12],
/* 1488 */
[2729, 12],
/* 1489 */
[2730, 12],
/* 1490 */
[2731, 12],
/* 1491 */
[2732, 12],
/* 1492 */
[2733, 1509, 206, 12],
/* 1493 */
[2734, 12],
/* 1494 */
[2735, 12],
/* 1495 */
[2736, 12],
/* 1496 */
[2737, 12],
/* 1497 */
[2738, 12],
/* 1498 */
[2739, 12],
/* 1499 */
[2740, 12],
/* 1500 */
[2741, 12],
/* 1501 */
[2742, 12],
/* 1502 */
[2743, 12],
/* 1503 */
[2744, 12],
/* 1504 */
[2745, 12],
/* 1505 */
[2746, 12],
/* 1506 */
[2748, 12],
/* 1507 */
[2749, 12],
/* 1508 */
[2751, 12],
/* 1509 */
[2752, 12],
/* 1510 */
[2753, 12],
/* 1511 */
[2754, 12],
/* 1512 */
[2755, 12],
/* 1513 */
[2756, 611, 12],
/* 1514 */
[2757, 611, 12],
/* 1515 */
[2758, 12],
/* 1516 */
[2759, 12, 206],
/* 1517 */
[2760, 12],
/* 1518 */
[2761, 12],
/* 1519 */
[2764, 600],
/* 1520 */
[2765, 601, 12],
/* 1521 */
[2766, 602, 381, 604, 605, 603],
/* 1522 */
[2767, 606, 12],
/* 1523 */
[2768, 258, 12],
/* 1524 */
[2769, 609, 12],
/* 1525 */
[2770, 612, 12],
/* 1526 */
/***/ function(module, exports) {

	"use strict";
	
	(function () {
	  if (typeof window !== 'object' || typeof window.CustomEvent === 'function') return;
	
	  var CustomEvent = function CustomEvent(event, params) {
	    params = params || {
	      bubbles: false,
	      cancelable: false,
	      detail: null
	    };
	    var evt = document.createEvent('CustomEvent');
	    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
	    return evt;
	  };
	
	  window.CustomEvent = CustomEvent;
	})();
	
	(function () {
	  if (typeof Object.values === 'function') return;
	
	  var values = function values(O) {
	    return Object.keys(O).map(function (key) {
	      return O[key];
	    });
	  };
	
	  Object.values = values;
	})();

/***/ },
/* 1527 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-array/ v1.2.4 Copyright 2018 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	function ascending(a, b) {
	  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	}
	
	function bisector(compare) {
	  if (compare.length === 1) compare = ascendingComparator(compare);
	  return {
	    left: function(a, x, lo, hi) {
	      if (lo == null) lo = 0;
	      if (hi == null) hi = a.length;
	      while (lo < hi) {
	        var mid = lo + hi >>> 1;
	        if (compare(a[mid], x) < 0) lo = mid + 1;
	        else hi = mid;
	      }
	      return lo;
	    },
	    right: function(a, x, lo, hi) {
	      if (lo == null) lo = 0;
	      if (hi == null) hi = a.length;
	      while (lo < hi) {
	        var mid = lo + hi >>> 1;
	        if (compare(a[mid], x) > 0) hi = mid;
	        else lo = mid + 1;
	      }
	      return lo;
	    }
	  };
	}
	
	function ascendingComparator(f) {
	  return function(d, x) {
	    return ascending(f(d), x);
	  };
	}
	
	var ascendingBisect = bisector(ascending);
	var bisectRight = ascendingBisect.right;
	var bisectLeft = ascendingBisect.left;
	
	function pairs(array, f) {
	  if (f == null) f = pair;
	  var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
	  while (i < n) pairs[i] = f(p, p = array[++i]);
	  return pairs;
	}
	
	function pair(a, b) {
	  return [a, b];
	}
	
	function cross(values0, values1, reduce) {
	  var n0 = values0.length,
	      n1 = values1.length,
	      values = new Array(n0 * n1),
	      i0,
	      i1,
	      i,
	      value0;
	
	  if (reduce == null) reduce = pair;
	
	  for (i0 = i = 0; i0 < n0; ++i0) {
	    for (value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i) {
	      values[i] = reduce(value0, values1[i1]);
	    }
	  }
	
	  return values;
	}
	
	function descending(a, b) {
	  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	}
	
	function number(x) {
	  return x === null ? NaN : +x;
	}
	
	function variance(values, valueof) {
	  var n = values.length,
	      m = 0,
	      i = -1,
	      mean = 0,
	      value,
	      delta,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) {
	        delta = value - mean;
	        mean += delta / ++m;
	        sum += delta * (value - mean);
	      }
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) {
	        delta = value - mean;
	        mean += delta / ++m;
	        sum += delta * (value - mean);
	      }
	    }
	  }
	
	  if (m > 1) return sum / (m - 1);
	}
	
	function deviation(array, f) {
	  var v = variance(array, f);
	  return v ? Math.sqrt(v) : v;
	}
	
	function extent(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      min,
	      max;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        min = max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null) {
	            if (min > value) min = value;
	            if (max < value) max = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        min = max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null) {
	            if (min > value) min = value;
	            if (max < value) max = value;
	          }
	        }
	      }
	    }
	  }
	
	  return [min, max];
	}
	
	var array = Array.prototype;
	
	var slice = array.slice;
	var map = array.map;
	
	function constant(x) {
	  return function() {
	    return x;
	  };
	}
	
	function identity(x) {
	  return x;
	}
	
	function range(start, stop, step) {
	  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
	
	  var i = -1,
	      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
	      range = new Array(n);
	
	  while (++i < n) {
	    range[i] = start + i * step;
	  }
	
	  return range;
	}
	
	var e10 = Math.sqrt(50),
	    e5 = Math.sqrt(10),
	    e2 = Math.sqrt(2);
	
	function ticks(start, stop, count) {
	  var reverse,
	      i = -1,
	      n,
	      ticks,
	      step;
	
	  stop = +stop, start = +start, count = +count;
	  if (start === stop && count > 0) return [start];
	  if (reverse = stop < start) n = start, start = stop, stop = n;
	  if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];
	
	  if (step > 0) {
	    start = Math.ceil(start / step);
	    stop = Math.floor(stop / step);
	    ticks = new Array(n = Math.ceil(stop - start + 1));
	    while (++i < n) ticks[i] = (start + i) * step;
	  } else {
	    start = Math.floor(start * step);
	    stop = Math.ceil(stop * step);
	    ticks = new Array(n = Math.ceil(start - stop + 1));
	    while (++i < n) ticks[i] = (start - i) / step;
	  }
	
	  if (reverse) ticks.reverse();
	
	  return ticks;
	}
	
	function tickIncrement(start, stop, count) {
	  var step = (stop - start) / Math.max(0, count),
	      power = Math.floor(Math.log(step) / Math.LN10),
	      error = step / Math.pow(10, power);
	  return power >= 0
	      ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power)
	      : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
	}
	
	function tickStep(start, stop, count) {
	  var step0 = Math.abs(stop - start) / Math.max(0, count),
	      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
	      error = step0 / step1;
	  if (error >= e10) step1 *= 10;
	  else if (error >= e5) step1 *= 5;
	  else if (error >= e2) step1 *= 2;
	  return stop < start ? -step1 : step1;
	}
	
	function sturges(values) {
	  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
	}
	
	function histogram() {
	  var value = identity,
	      domain = extent,
	      threshold = sturges;
	
	  function histogram(data) {
	    var i,
	        n = data.length,
	        x,
	        values = new Array(n);
	
	    for (i = 0; i < n; ++i) {
	      values[i] = value(data[i], i, data);
	    }
	
	    var xz = domain(values),
	        x0 = xz[0],
	        x1 = xz[1],
	        tz = threshold(values, x0, x1);
	
	    // Convert number of thresholds into uniform thresholds.
	    if (!Array.isArray(tz)) {
	      tz = tickStep(x0, x1, tz);
	      tz = range(Math.ceil(x0 / tz) * tz, x1, tz); // exclusive
	    }
	
	    // Remove any thresholds outside the domain.
	    var m = tz.length;
	    while (tz[0] <= x0) tz.shift(), --m;
	    while (tz[m - 1] > x1) tz.pop(), --m;
	
	    var bins = new Array(m + 1),
	        bin;
	
	    // Initialize bins.
	    for (i = 0; i <= m; ++i) {
	      bin = bins[i] = [];
	      bin.x0 = i > 0 ? tz[i - 1] : x0;
	      bin.x1 = i < m ? tz[i] : x1;
	    }
	
	    // Assign data to bins by value, ignoring any outside the domain.
	    for (i = 0; i < n; ++i) {
	      x = values[i];
	      if (x0 <= x && x <= x1) {
	        bins[bisectRight(tz, x, 0, m)].push(data[i]);
	      }
	    }
	
	    return bins;
	  }
	
	  histogram.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant(_), histogram) : value;
	  };
	
	  histogram.domain = function(_) {
	    return arguments.length ? (domain = typeof _ === "function" ? _ : constant([_[0], _[1]]), histogram) : domain;
	  };
	
	  histogram.thresholds = function(_) {
	    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? constant(slice.call(_)) : constant(_), histogram) : threshold;
	  };
	
	  return histogram;
	}
	
	function quantile(values, p, valueof) {
	  if (valueof == null) valueof = number;
	  if (!(n = values.length)) return;
	  if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
	  if (p >= 1) return +valueof(values[n - 1], n - 1, values);
	  var n,
	      i = (n - 1) * p,
	      i0 = Math.floor(i),
	      value0 = +valueof(values[i0], i0, values),
	      value1 = +valueof(values[i0 + 1], i0 + 1, values);
	  return value0 + (value1 - value0) * (i - i0);
	}
	
	function freedmanDiaconis(values, min, max) {
	  values = map.call(values, number).sort(ascending);
	  return Math.ceil((max - min) / (2 * (quantile(values, 0.75) - quantile(values, 0.25)) * Math.pow(values.length, -1 / 3)));
	}
	
	function scott(values, min, max) {
	  return Math.ceil((max - min) / (3.5 * deviation(values) * Math.pow(values.length, -1 / 3)));
	}
	
	function max(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      max;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null && value > max) {
	            max = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null && value > max) {
	            max = value;
	          }
	        }
	      }
	    }
	  }
	
	  return max;
	}
	
	function mean(values, valueof) {
	  var n = values.length,
	      m = n,
	      i = -1,
	      value,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) sum += value;
	      else --m;
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) sum += value;
	      else --m;
	    }
	  }
	
	  if (m) return sum / m;
	}
	
	function median(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      numbers = [];
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) {
	        numbers.push(value);
	      }
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) {
	        numbers.push(value);
	      }
	    }
	  }
	
	  return quantile(numbers.sort(ascending), 0.5);
	}
	
	function merge(arrays) {
	  var n = arrays.length,
	      m,
	      i = -1,
	      j = 0,
	      merged,
	      array;
	
	  while (++i < n) j += arrays[i].length;
	  merged = new Array(j);
	
	  while (--n >= 0) {
	    array = arrays[n];
	    m = array.length;
	    while (--m >= 0) {
	      merged[--j] = array[m];
	    }
	  }
	
	  return merged;
	}
	
	function min(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      min;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        min = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null && min > value) {
	            min = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        min = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null && min > value) {
	            min = value;
	          }
	        }
	      }
	    }
	  }
	
	  return min;
	}
	
	function permute(array, indexes) {
	  var i = indexes.length, permutes = new Array(i);
	  while (i--) permutes[i] = array[indexes[i]];
	  return permutes;
	}
	
	function scan(values, compare) {
	  if (!(n = values.length)) return;
	  var n,
	      i = 0,
	      j = 0,
	      xi,
	      xj = values[j];
	
	  if (compare == null) compare = ascending;
	
	  while (++i < n) {
	    if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) {
	      xj = xi, j = i;
	    }
	  }
	
	  if (compare(xj, xj) === 0) return j;
	}
	
	function shuffle(array, i0, i1) {
	  var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0),
	      t,
	      i;
	
	  while (m) {
	    i = Math.random() * m-- | 0;
	    t = array[m + i0];
	    array[m + i0] = array[i + i0];
	    array[i + i0] = t;
	  }
	
	  return array;
	}
	
	function sum(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (value = +valueof(values[i], i, values)) sum += value;
	    }
	  }
	
	  return sum;
	}
	
	function transpose(matrix) {
	  if (!(n = matrix.length)) return [];
	  for (var i = -1, m = min(matrix, length), transpose = new Array(m); ++i < m;) {
	    for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
	      row[j] = matrix[j][i];
	    }
	  }
	  return transpose;
	}
	
	function length(d) {
	  return d.length;
	}
	
	function zip() {
	  return transpose(arguments);
	}
	
	exports.bisect = bisectRight;
	exports.bisectRight = bisectRight;
	exports.bisectLeft = bisectLeft;
	exports.ascending = ascending;
	exports.bisector = bisector;
	exports.cross = cross;
	exports.descending = descending;
	exports.deviation = deviation;
	exports.extent = extent;
	exports.histogram = histogram;
	exports.thresholdFreedmanDiaconis = freedmanDiaconis;
	exports.thresholdScott = scott;
	exports.thresholdSturges = sturges;
	exports.max = max;
	exports.mean = mean;
	exports.median = median;
	exports.merge = merge;
	exports.min = min;
	exports.pairs = pairs;
	exports.permute = permute;
	exports.quantile = quantile;
	exports.range = range;
	exports.scan = scan;
	exports.shuffle = shuffle;
	exports.sum = sum;
	exports.ticks = ticks;
	exports.tickIncrement = tickIncrement;
	exports.tickStep = tickStep;
	exports.transpose = transpose;
	exports.variance = variance;
	exports.zip = zip;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 1528 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-collection/ v1.0.7 Copyright 2018 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var prefix = "$";
	
	function Map() {}
	
	Map.prototype = map.prototype = {
	  constructor: Map,
	  has: function(key) {
	    return (prefix + key) in this;
	  },
	  get: function(key) {
	    return this[prefix + key];
	  },
	  set: function(key, value) {
	    this[prefix + key] = value;
	    return this;
	  },
	  remove: function(key) {
	    var property = prefix + key;
	    return property in this && delete this[property];
	  },
	  clear: function() {
	    for (var property in this) if (property[0] === prefix) delete this[property];
	  },
	  keys: function() {
	    var keys = [];
	    for (var property in this) if (property[0] === prefix) keys.push(property.slice(1));
	    return keys;
	  },
	  values: function() {
	    var values = [];
	    for (var property in this) if (property[0] === prefix) values.push(this[property]);
	    return values;
	  },
	  entries: function() {
	    var entries = [];
	    for (var property in this) if (property[0] === prefix) entries.push({key: property.slice(1), value: this[property]});
	    return entries;
	  },
	  size: function() {
	    var size = 0;
	    for (var property in this) if (property[0] === prefix) ++size;
	    return size;
	  },
	  empty: function() {
	    for (var property in this) if (property[0] === prefix) return false;
	    return true;
	  },
	  each: function(f) {
	    for (var property in this) if (property[0] === prefix) f(this[property], property.slice(1), this);
	  }
	};
	
	function map(object, f) {
	  var map = new Map;
	
	  // Copy constructor.
	  if (object instanceof Map) object.each(function(value, key) { map.set(key, value); });
	
	  // Index array by numeric index or specified key function.
	  else if (Array.isArray(object)) {
	    var i = -1,
	        n = object.length,
	        o;
	
	    if (f == null) while (++i < n) map.set(i, object[i]);
	    else while (++i < n) map.set(f(o = object[i], i, object), o);
	  }
	
	  // Convert object to map.
	  else if (object) for (var key in object) map.set(key, object[key]);
	
	  return map;
	}
	
	function nest() {
	  var keys = [],
	      sortKeys = [],
	      sortValues,
	      rollup,
	      nest;
	
	  function apply(array, depth, createResult, setResult) {
	    if (depth >= keys.length) {
	      if (sortValues != null) array.sort(sortValues);
	      return rollup != null ? rollup(array) : array;
	    }
	
	    var i = -1,
	        n = array.length,
	        key = keys[depth++],
	        keyValue,
	        value,
	        valuesByKey = map(),
	        values,
	        result = createResult();
	
	    while (++i < n) {
	      if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) {
	        values.push(value);
	      } else {
	        valuesByKey.set(keyValue, [value]);
	      }
	    }
	
	    valuesByKey.each(function(values, key) {
	      setResult(result, key, apply(values, depth, createResult, setResult));
	    });
	
	    return result;
	  }
	
	  function entries(map$$1, depth) {
	    if (++depth > keys.length) return map$$1;
	    var array, sortKey = sortKeys[depth - 1];
	    if (rollup != null && depth >= keys.length) array = map$$1.entries();
	    else array = [], map$$1.each(function(v, k) { array.push({key: k, values: entries(v, depth)}); });
	    return sortKey != null ? array.sort(function(a, b) { return sortKey(a.key, b.key); }) : array;
	  }
	
	  return nest = {
	    object: function(array) { return apply(array, 0, createObject, setObject); },
	    map: function(array) { return apply(array, 0, createMap, setMap); },
	    entries: function(array) { return entries(apply(array, 0, createMap, setMap), 0); },
	    key: function(d) { keys.push(d); return nest; },
	    sortKeys: function(order) { sortKeys[keys.length - 1] = order; return nest; },
	    sortValues: function(order) { sortValues = order; return nest; },
	    rollup: function(f) { rollup = f; return nest; }
	  };
	}
	
	function createObject() {
	  return {};
	}
	
	function setObject(object, key, value) {
	  object[key] = value;
	}
	
	function createMap() {
	  return map();
	}
	
	function setMap(map$$1, key, value) {
	  map$$1.set(key, value);
	}
	
	function Set() {}
	
	var proto = map.prototype;
	
	Set.prototype = set.prototype = {
	  constructor: Set,
	  has: proto.has,
	  add: function(value) {
	    value += "";
	    this[prefix + value] = value;
	    return this;
	  },
	  remove: proto.remove,
	  clear: proto.clear,
	  values: proto.keys,
	  size: proto.size,
	  empty: proto.empty,
	  each: proto.each
	};
	
	function set(object, f) {
	  var set = new Set;
	
	  // Copy constructor.
	  if (object instanceof Set) object.each(function(value) { set.add(value); });
	
	  // Otherwise, assume it’s an array.
	  else if (object) {
	    var i = -1, n = object.length;
	    if (f == null) while (++i < n) set.add(object[i]);
	    else while (++i < n) set.add(f(object[i], i, object));
	  }
	
	  return set;
	}
	
	function keys(map) {
	  var keys = [];
	  for (var key in map) keys.push(key);
	  return keys;
	}
	
	function values(map) {
	  var values = [];
	  for (var key in map) values.push(map[key]);
	  return values;
	}
	
	function entries(map) {
	  var entries = [];
	  for (var key in map) entries.push({key: key, value: map[key]});
	  return entries;
	}
	
	exports.nest = nest;
	exports.set = set;
	exports.map = map;
	exports.keys = keys;
	exports.values = values;
	exports.entries = entries;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 1529 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-color/ v1.4.1 Copyright 2020 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(global = global || self, factory(global.d3 = global.d3 || {}));
	}(this, function (exports) { 'use strict';
	
	function define(constructor, factory, prototype) {
	  constructor.prototype = factory.prototype = prototype;
	  prototype.constructor = constructor;
	}
	
	function extend(parent, definition) {
	  var prototype = Object.create(parent.prototype);
	  for (var key in definition) prototype[key] = definition[key];
	  return prototype;
	}
	
	function Color() {}
	
	var darker = 0.7;
	var brighter = 1 / darker;
	
	var reI = "\\s*([+-]?\\d+)\\s*",
	    reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
	    reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
	    reHex = /^#([0-9a-f]{3,8})$/,
	    reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$"),
	    reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$"),
	    reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$"),
	    reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$"),
	    reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$"),
	    reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");
	
	var named = {
	  aliceblue: 0xf0f8ff,
	  antiquewhite: 0xfaebd7,
	  aqua: 0x00ffff,
	  aquamarine: 0x7fffd4,
	  azure: 0xf0ffff,
	  beige: 0xf5f5dc,
	  bisque: 0xffe4c4,
	  black: 0x000000,
	  blanchedalmond: 0xffebcd,
	  blue: 0x0000ff,
	  blueviolet: 0x8a2be2,
	  brown: 0xa52a2a,
	  burlywood: 0xdeb887,
	  cadetblue: 0x5f9ea0,
	  chartreuse: 0x7fff00,
	  chocolate: 0xd2691e,
	  coral: 0xff7f50,
	  cornflowerblue: 0x6495ed,
	  cornsilk: 0xfff8dc,
	  crimson: 0xdc143c,
	  cyan: 0x00ffff,
	  darkblue: 0x00008b,
	  darkcyan: 0x008b8b,
	  darkgoldenrod: 0xb8860b,
	  darkgray: 0xa9a9a9,
	  darkgreen: 0x006400,
	  darkgrey: 0xa9a9a9,
	  darkkhaki: 0xbdb76b,
	  darkmagenta: 0x8b008b,
	  darkolivegreen: 0x556b2f,
	  darkorange: 0xff8c00,
	  darkorchid: 0x9932cc,
	  darkred: 0x8b0000,
	  darksalmon: 0xe9967a,
	  darkseagreen: 0x8fbc8f,
	  darkslateblue: 0x483d8b,
	  darkslategray: 0x2f4f4f,
	  darkslategrey: 0x2f4f4f,
	  darkturquoise: 0x00ced1,
	  darkviolet: 0x9400d3,
	  deeppink: 0xff1493,
	  deepskyblue: 0x00bfff,
	  dimgray: 0x696969,
	  dimgrey: 0x696969,
	  dodgerblue: 0x1e90ff,
	  firebrick: 0xb22222,
	  floralwhite: 0xfffaf0,
	  forestgreen: 0x228b22,
	  fuchsia: 0xff00ff,
	  gainsboro: 0xdcdcdc,
	  ghostwhite: 0xf8f8ff,
	  gold: 0xffd700,
	  goldenrod: 0xdaa520,
	  gray: 0x808080,
	  green: 0x008000,
	  greenyellow: 0xadff2f,
	  grey: 0x808080,
	  honeydew: 0xf0fff0,
	  hotpink: 0xff69b4,
	  indianred: 0xcd5c5c,
	  indigo: 0x4b0082,
	  ivory: 0xfffff0,
	  khaki: 0xf0e68c,
	  lavender: 0xe6e6fa,
	  lavenderblush: 0xfff0f5,
	  lawngreen: 0x7cfc00,
	  lemonchiffon: 0xfffacd,
	  lightblue: 0xadd8e6,
	  lightcoral: 0xf08080,
	  lightcyan: 0xe0ffff,
	  lightgoldenrodyellow: 0xfafad2,
	  lightgray: 0xd3d3d3,
	  lightgreen: 0x90ee90,
	  lightgrey: 0xd3d3d3,
	  lightpink: 0xffb6c1,
	  lightsalmon: 0xffa07a,
	  lightseagreen: 0x20b2aa,
	  lightskyblue: 0x87cefa,
	  lightslategray: 0x778899,
	  lightslategrey: 0x778899,
	  lightsteelblue: 0xb0c4de,
	  lightyellow: 0xffffe0,
	  lime: 0x00ff00,
	  limegreen: 0x32cd32,
	  linen: 0xfaf0e6,
	  magenta: 0xff00ff,
	  maroon: 0x800000,
	  mediumaquamarine: 0x66cdaa,
	  mediumblue: 0x0000cd,
	  mediumorchid: 0xba55d3,
	  mediumpurple: 0x9370db,
	  mediumseagreen: 0x3cb371,
	  mediumslateblue: 0x7b68ee,
	  mediumspringgreen: 0x00fa9a,
	  mediumturquoise: 0x48d1cc,
	  mediumvioletred: 0xc71585,
	  midnightblue: 0x191970,
	  mintcream: 0xf5fffa,
	  mistyrose: 0xffe4e1,
	  moccasin: 0xffe4b5,
	  navajowhite: 0xffdead,
	  navy: 0x000080,
	  oldlace: 0xfdf5e6,
	  olive: 0x808000,
	  olivedrab: 0x6b8e23,
	  orange: 0xffa500,
	  orangered: 0xff4500,
	  orchid: 0xda70d6,
	  palegoldenrod: 0xeee8aa,
	  palegreen: 0x98fb98,
	  paleturquoise: 0xafeeee,
	  palevioletred: 0xdb7093,
	  papayawhip: 0xffefd5,
	  peachpuff: 0xffdab9,
	  peru: 0xcd853f,
	  pink: 0xffc0cb,
	  plum: 0xdda0dd,
	  powderblue: 0xb0e0e6,
	  purple: 0x800080,
	  rebeccapurple: 0x663399,
	  red: 0xff0000,
	  rosybrown: 0xbc8f8f,
	  royalblue: 0x4169e1,
	  saddlebrown: 0x8b4513,
	  salmon: 0xfa8072,
	  sandybrown: 0xf4a460,
	  seagreen: 0x2e8b57,
	  seashell: 0xfff5ee,
	  sienna: 0xa0522d,
	  silver: 0xc0c0c0,
	  skyblue: 0x87ceeb,
	  slateblue: 0x6a5acd,
	  slategray: 0x708090,
	  slategrey: 0x708090,
	  snow: 0xfffafa,
	  springgreen: 0x00ff7f,
	  steelblue: 0x4682b4,
	  tan: 0xd2b48c,
	  teal: 0x008080,
	  thistle: 0xd8bfd8,
	  tomato: 0xff6347,
	  turquoise: 0x40e0d0,
	  violet: 0xee82ee,
	  wheat: 0xf5deb3,
	  white: 0xffffff,
	  whitesmoke: 0xf5f5f5,
	  yellow: 0xffff00,
	  yellowgreen: 0x9acd32
	};
	
	define(Color, color, {
	  copy: function(channels) {
	    return Object.assign(new this.constructor, this, channels);
	  },
	  displayable: function() {
	    return this.rgb().displayable();
	  },
	  hex: color_formatHex, // Deprecated! Use color.formatHex.
	  formatHex: color_formatHex,
	  formatHsl: color_formatHsl,
	  formatRgb: color_formatRgb,
	  toString: color_formatRgb
	});
	
	function color_formatHex() {
	  return this.rgb().formatHex();
	}
	
	function color_formatHsl() {
	  return hslConvert(this).formatHsl();
	}
	
	function color_formatRgb() {
	  return this.rgb().formatRgb();
	}
	
	function color(format) {
	  var m, l;
	  format = (format + "").trim().toLowerCase();
	  return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
	      : l === 3 ? new Rgb((m >> 8 & 0xf) | (m >> 4 & 0xf0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1) // #f00
	      : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
	      : l === 4 ? rgba((m >> 12 & 0xf) | (m >> 8 & 0xf0), (m >> 8 & 0xf) | (m >> 4 & 0xf0), (m >> 4 & 0xf) | (m & 0xf0), (((m & 0xf) << 4) | (m & 0xf)) / 0xff) // #f000
	      : null) // invalid hex
	      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
	      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
	      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
	      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
	      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
	      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
	      : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
	      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
	      : null;
	}
	
	function rgbn(n) {
	  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
	}
	
	function rgba(r, g, b, a) {
	  if (a <= 0) r = g = b = NaN;
	  return new Rgb(r, g, b, a);
	}
	
	function rgbConvert(o) {
	  if (!(o instanceof Color)) o = color(o);
	  if (!o) return new Rgb;
	  o = o.rgb();
	  return new Rgb(o.r, o.g, o.b, o.opacity);
	}
	
	function rgb(r, g, b, opacity) {
	  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
	}
	
	function Rgb(r, g, b, opacity) {
	  this.r = +r;
	  this.g = +g;
	  this.b = +b;
	  this.opacity = +opacity;
	}
	
	define(Rgb, rgb, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	  },
	  rgb: function() {
	    return this;
	  },
	  displayable: function() {
	    return (-0.5 <= this.r && this.r < 255.5)
	        && (-0.5 <= this.g && this.g < 255.5)
	        && (-0.5 <= this.b && this.b < 255.5)
	        && (0 <= this.opacity && this.opacity <= 1);
	  },
	  hex: rgb_formatHex, // Deprecated! Use color.formatHex.
	  formatHex: rgb_formatHex,
	  formatRgb: rgb_formatRgb,
	  toString: rgb_formatRgb
	}));
	
	function rgb_formatHex() {
	  return "#" + hex(this.r) + hex(this.g) + hex(this.b);
	}
	
	function rgb_formatRgb() {
	  var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
	  return (a === 1 ? "rgb(" : "rgba(")
	      + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
	      + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
	      + Math.max(0, Math.min(255, Math.round(this.b) || 0))
	      + (a === 1 ? ")" : ", " + a + ")");
	}
	
	function hex(value) {
	  value = Math.max(0, Math.min(255, Math.round(value) || 0));
	  return (value < 16 ? "0" : "") + value.toString(16);
	}
	
	function hsla(h, s, l, a) {
	  if (a <= 0) h = s = l = NaN;
	  else if (l <= 0 || l >= 1) h = s = NaN;
	  else if (s <= 0) h = NaN;
	  return new Hsl(h, s, l, a);
	}
	
	function hslConvert(o) {
	  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
	  if (!(o instanceof Color)) o = color(o);
	  if (!o) return new Hsl;
	  if (o instanceof Hsl) return o;
	  o = o.rgb();
	  var r = o.r / 255,
	      g = o.g / 255,
	      b = o.b / 255,
	      min = Math.min(r, g, b),
	      max = Math.max(r, g, b),
	      h = NaN,
	      s = max - min,
	      l = (max + min) / 2;
	  if (s) {
	    if (r === max) h = (g - b) / s + (g < b) * 6;
	    else if (g === max) h = (b - r) / s + 2;
	    else h = (r - g) / s + 4;
	    s /= l < 0.5 ? max + min : 2 - max - min;
	    h *= 60;
	  } else {
	    s = l > 0 && l < 1 ? 0 : h;
	  }
	  return new Hsl(h, s, l, o.opacity);
	}
	
	function hsl(h, s, l, opacity) {
	  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
	}
	
	function Hsl(h, s, l, opacity) {
	  this.h = +h;
	  this.s = +s;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Hsl, hsl, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Hsl(this.h, this.s, this.l * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Hsl(this.h, this.s, this.l * k, this.opacity);
	  },
	  rgb: function() {
	    var h = this.h % 360 + (this.h < 0) * 360,
	        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
	        l = this.l,
	        m2 = l + (l < 0.5 ? l : 1 - l) * s,
	        m1 = 2 * l - m2;
	    return new Rgb(
	      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
	      hsl2rgb(h, m1, m2),
	      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
	      this.opacity
	    );
	  },
	  displayable: function() {
	    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
	        && (0 <= this.l && this.l <= 1)
	        && (0 <= this.opacity && this.opacity <= 1);
	  },
	  formatHsl: function() {
	    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
	    return (a === 1 ? "hsl(" : "hsla(")
	        + (this.h || 0) + ", "
	        + (this.s || 0) * 100 + "%, "
	        + (this.l || 0) * 100 + "%"
	        + (a === 1 ? ")" : ", " + a + ")");
	  }
	}));
	
	/* From FvD 13.37, CSS Color Module Level 3 */
	function hsl2rgb(h, m1, m2) {
	  return (h < 60 ? m1 + (m2 - m1) * h / 60
	      : h < 180 ? m2
	      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
	      : m1) * 255;
	}
	
	var deg2rad = Math.PI / 180;
	var rad2deg = 180 / Math.PI;
	
	// https://observablehq.com/@mbostock/lab-and-rgb
	var K = 18,
	    Xn = 0.96422,
	    Yn = 1,
	    Zn = 0.82521,
	    t0 = 4 / 29,
	    t1 = 6 / 29,
	    t2 = 3 * t1 * t1,
	    t3 = t1 * t1 * t1;
	
	function labConvert(o) {
	  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
	  if (o instanceof Hcl) return hcl2lab(o);
	  if (!(o instanceof Rgb)) o = rgbConvert(o);
	  var r = rgb2lrgb(o.r),
	      g = rgb2lrgb(o.g),
	      b = rgb2lrgb(o.b),
	      y = xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / Yn), x, z;
	  if (r === g && g === b) x = z = y; else {
	    x = xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / Xn);
	    z = xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / Zn);
	  }
	  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
	}
	
	function gray(l, opacity) {
	  return new Lab(l, 0, 0, opacity == null ? 1 : opacity);
	}
	
	function lab(l, a, b, opacity) {
	  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
	}
	
	function Lab(l, a, b, opacity) {
	  this.l = +l;
	  this.a = +a;
	  this.b = +b;
	  this.opacity = +opacity;
	}
	
	define(Lab, lab, extend(Color, {
	  brighter: function(k) {
	    return new Lab(this.l + K * (k == null ? 1 : k), this.a, this.b, this.opacity);
	  },
	  darker: function(k) {
	    return new Lab(this.l - K * (k == null ? 1 : k), this.a, this.b, this.opacity);
	  },
	  rgb: function() {
	    var y = (this.l + 16) / 116,
	        x = isNaN(this.a) ? y : y + this.a / 500,
	        z = isNaN(this.b) ? y : y - this.b / 200;
	    x = Xn * lab2xyz(x);
	    y = Yn * lab2xyz(y);
	    z = Zn * lab2xyz(z);
	    return new Rgb(
	      lrgb2rgb( 3.1338561 * x - 1.6168667 * y - 0.4906146 * z),
	      lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z),
	      lrgb2rgb( 0.0719453 * x - 0.2289914 * y + 1.4052427 * z),
	      this.opacity
	    );
	  }
	}));
	
	function xyz2lab(t) {
	  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
	}
	
	function lab2xyz(t) {
	  return t > t1 ? t * t * t : t2 * (t - t0);
	}
	
	function lrgb2rgb(x) {
	  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
	}
	
	function rgb2lrgb(x) {
	  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
	}
	
	function hclConvert(o) {
	  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
	  if (!(o instanceof Lab)) o = labConvert(o);
	  if (o.a === 0 && o.b === 0) return new Hcl(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
	  var h = Math.atan2(o.b, o.a) * rad2deg;
	  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
	}
	
	function lch(l, c, h, opacity) {
	  return arguments.length === 1 ? hclConvert(l) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
	}
	
	function hcl(h, c, l, opacity) {
	  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
	}
	
	function Hcl(h, c, l, opacity) {
	  this.h = +h;
	  this.c = +c;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	function hcl2lab(o) {
	  if (isNaN(o.h)) return new Lab(o.l, 0, 0, o.opacity);
	  var h = o.h * deg2rad;
	  return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
	}
	
	define(Hcl, hcl, extend(Color, {
	  brighter: function(k) {
	    return new Hcl(this.h, this.c, this.l + K * (k == null ? 1 : k), this.opacity);
	  },
	  darker: function(k) {
	    return new Hcl(this.h, this.c, this.l - K * (k == null ? 1 : k), this.opacity);
	  },
	  rgb: function() {
	    return hcl2lab(this).rgb();
	  }
	}));
	
	var A = -0.14861,
	    B = +1.78277,
	    C = -0.29227,
	    D = -0.90649,
	    E = +1.97294,
	    ED = E * D,
	    EB = E * B,
	    BC_DA = B * C - D * A;
	
	function cubehelixConvert(o) {
	  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
	  if (!(o instanceof Rgb)) o = rgbConvert(o);
	  var r = o.r / 255,
	      g = o.g / 255,
	      b = o.b / 255,
	      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
	      bl = b - l,
	      k = (E * (g - l) - C * bl) / D,
	      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
	      h = s ? Math.atan2(k, bl) * rad2deg - 120 : NaN;
	  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
	}
	
	function cubehelix(h, s, l, opacity) {
	  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
	}
	
	function Cubehelix(h, s, l, opacity) {
	  this.h = +h;
	  this.s = +s;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Cubehelix, cubehelix, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	  },
	  rgb: function() {
	    var h = isNaN(this.h) ? 0 : (this.h + 120) * deg2rad,
	        l = +this.l,
	        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
	        cosh = Math.cos(h),
	        sinh = Math.sin(h);
	    return new Rgb(
	      255 * (l + a * (A * cosh + B * sinh)),
	      255 * (l + a * (C * cosh + D * sinh)),
	      255 * (l + a * (E * cosh)),
	      this.opacity
	    );
	  }
	}));
	
	exports.color = color;
	exports.cubehelix = cubehelix;
	exports.gray = gray;
	exports.hcl = hcl;
	exports.hsl = hsl;
	exports.lab = lab;
	exports.lch = lch;
	exports.rgb = rgb;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	}));


/***/ },
/* 1530 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-format/ v1.4.5 Copyright 2020 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.d3 = global.d3 || {}));
	}(this, (function (exports) { 'use strict';
	
	function formatDecimal(x) {
	  return Math.abs(x = Math.round(x)) >= 1e21
	      ? x.toLocaleString("en").replace(/,/g, "")
	      : x.toString(10);
	}
	
	// Computes the decimal coefficient and exponent of the specified number x with
	// significant digits p, where x is positive and p is in [1, 21] or undefined.
	// For example, formatDecimalParts(1.23) returns ["123", 0].
	function formatDecimalParts(x, p) {
	  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
	  var i, coefficient = x.slice(0, i);
	
	  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
	  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
	  return [
	    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
	    +x.slice(i + 1)
	  ];
	}
	
	function exponent(x) {
	  return x = formatDecimalParts(Math.abs(x)), x ? x[1] : NaN;
	}
	
	function formatGroup(grouping, thousands) {
	  return function(value, width) {
	    var i = value.length,
	        t = [],
	        j = 0,
	        g = grouping[0],
	        length = 0;
	
	    while (i > 0 && g > 0) {
	      if (length + g + 1 > width) g = Math.max(1, width - length);
	      t.push(value.substring(i -= g, i + g));
	      if ((length += g + 1) > width) break;
	      g = grouping[j = (j + 1) % grouping.length];
	    }
	
	    return t.reverse().join(thousands);
	  };
	}
	
	function formatNumerals(numerals) {
	  return function(value) {
	    return value.replace(/[0-9]/g, function(i) {
	      return numerals[+i];
	    });
	  };
	}
	
	// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
	var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
	
	function formatSpecifier(specifier) {
	  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
	  var match;
	  return new FormatSpecifier({
	    fill: match[1],
	    align: match[2],
	    sign: match[3],
	    symbol: match[4],
	    zero: match[5],
	    width: match[6],
	    comma: match[7],
	    precision: match[8] && match[8].slice(1),
	    trim: match[9],
	    type: match[10]
	  });
	}
	
	formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof
	
	function FormatSpecifier(specifier) {
	  this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
	  this.align = specifier.align === undefined ? ">" : specifier.align + "";
	  this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
	  this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
	  this.zero = !!specifier.zero;
	  this.width = specifier.width === undefined ? undefined : +specifier.width;
	  this.comma = !!specifier.comma;
	  this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
	  this.trim = !!specifier.trim;
	  this.type = specifier.type === undefined ? "" : specifier.type + "";
	}
	
	FormatSpecifier.prototype.toString = function() {
	  return this.fill
	      + this.align
	      + this.sign
	      + this.symbol
	      + (this.zero ? "0" : "")
	      + (this.width === undefined ? "" : Math.max(1, this.width | 0))
	      + (this.comma ? "," : "")
	      + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0))
	      + (this.trim ? "~" : "")
	      + this.type;
	};
	
	// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
	function formatTrim(s) {
	  out: for (var n = s.length, i = 1, i0 = -1, i1; i < n; ++i) {
	    switch (s[i]) {
	      case ".": i0 = i1 = i; break;
	      case "0": if (i0 === 0) i0 = i; i1 = i; break;
	      default: if (!+s[i]) break out; if (i0 > 0) i0 = 0; break;
	    }
	  }
	  return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
	}
	
	var prefixExponent;
	
	function formatPrefixAuto(x, p) {
	  var d = formatDecimalParts(x, p);
	  if (!d) return x + "";
	  var coefficient = d[0],
	      exponent = d[1],
	      i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
	      n = coefficient.length;
	  return i === n ? coefficient
	      : i > n ? coefficient + new Array(i - n + 1).join("0")
	      : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
	      : "0." + new Array(1 - i).join("0") + formatDecimalParts(x, Math.max(0, p + i - 1))[0]; // less than 1y!
	}
	
	function formatRounded(x, p) {
	  var d = formatDecimalParts(x, p);
	  if (!d) return x + "";
	  var coefficient = d[0],
	      exponent = d[1];
	  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
	      : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
	      : coefficient + new Array(exponent - coefficient.length + 2).join("0");
	}
	
	var formatTypes = {
	  "%": function(x, p) { return (x * 100).toFixed(p); },
	  "b": function(x) { return Math.round(x).toString(2); },
	  "c": function(x) { return x + ""; },
	  "d": formatDecimal,
	  "e": function(x, p) { return x.toExponential(p); },
	  "f": function(x, p) { return x.toFixed(p); },
	  "g": function(x, p) { return x.toPrecision(p); },
	  "o": function(x) { return Math.round(x).toString(8); },
	  "p": function(x, p) { return formatRounded(x * 100, p); },
	  "r": formatRounded,
	  "s": formatPrefixAuto,
	  "X": function(x) { return Math.round(x).toString(16).toUpperCase(); },
	  "x": function(x) { return Math.round(x).toString(16); }
	};
	
	function identity(x) {
	  return x;
	}
	
	var map = Array.prototype.map,
	    prefixes = ["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];
	
	function formatLocale(locale) {
	  var group = locale.grouping === undefined || locale.thousands === undefined ? identity : formatGroup(map.call(locale.grouping, Number), locale.thousands + ""),
	      currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "",
	      currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "",
	      decimal = locale.decimal === undefined ? "." : locale.decimal + "",
	      numerals = locale.numerals === undefined ? identity : formatNumerals(map.call(locale.numerals, String)),
	      percent = locale.percent === undefined ? "%" : locale.percent + "",
	      minus = locale.minus === undefined ? "-" : locale.minus + "",
	      nan = locale.nan === undefined ? "NaN" : locale.nan + "";
	
	  function newFormat(specifier) {
	    specifier = formatSpecifier(specifier);
	
	    var fill = specifier.fill,
	        align = specifier.align,
	        sign = specifier.sign,
	        symbol = specifier.symbol,
	        zero = specifier.zero,
	        width = specifier.width,
	        comma = specifier.comma,
	        precision = specifier.precision,
	        trim = specifier.trim,
	        type = specifier.type;
	
	    // The "n" type is an alias for ",g".
	    if (type === "n") comma = true, type = "g";
	
	    // The "" type, and any invalid type, is an alias for ".12~g".
	    else if (!formatTypes[type]) precision === undefined && (precision = 12), trim = true, type = "g";
	
	    // If zero fill is specified, padding goes after sign and before digits.
	    if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";
	
	    // Compute the prefix and suffix.
	    // For SI-prefix, the suffix is lazily computed.
	    var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
	        suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
	
	    // What format function should we use?
	    // Is this an integer type?
	    // Can this type generate exponential notation?
	    var formatType = formatTypes[type],
	        maybeSuffix = /[defgprs%]/.test(type);
	
	    // Set the default precision if not specified,
	    // or clamp the specified precision to the supported range.
	    // For significant precision, it must be in [1, 21].
	    // For fixed precision, it must be in [0, 20].
	    precision = precision === undefined ? 6
	        : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
	        : Math.max(0, Math.min(20, precision));
	
	    function format(value) {
	      var valuePrefix = prefix,
	          valueSuffix = suffix,
	          i, n, c;
	
	      if (type === "c") {
	        valueSuffix = formatType(value) + valueSuffix;
	        value = "";
	      } else {
	        value = +value;
	
	        // Determine the sign. -0 is not less than 0, but 1 / -0 is!
	        var valueNegative = value < 0 || 1 / value < 0;
	
	        // Perform the initial formatting.
	        value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
	
	        // Trim insignificant zeros.
	        if (trim) value = formatTrim(value);
	
	        // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
	        if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
	
	        // Compute the prefix and suffix.
	        valuePrefix = (valueNegative ? (sign === "(" ? sign : minus) : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
	        valueSuffix = (type === "s" ? prefixes[8 + prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
	
	        // Break the formatted value into the integer “value” part that can be
	        // grouped, and fractional or exponential “suffix” part that is not.
	        if (maybeSuffix) {
	          i = -1, n = value.length;
	          while (++i < n) {
	            if (c = value.charCodeAt(i), 48 > c || c > 57) {
	              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
	              value = value.slice(0, i);
	              break;
	            }
	          }
	        }
	      }
	
	      // If the fill character is not "0", grouping is applied before padding.
	      if (comma && !zero) value = group(value, Infinity);
	
	      // Compute the padding.
	      var length = valuePrefix.length + value.length + valueSuffix.length,
	          padding = length < width ? new Array(width - length + 1).join(fill) : "";
	
	      // If the fill character is "0", grouping is applied after padding.
	      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
	
	      // Reconstruct the final output based on the desired alignment.
	      switch (align) {
	        case "<": value = valuePrefix + value + valueSuffix + padding; break;
	        case "=": value = valuePrefix + padding + value + valueSuffix; break;
	        case "^": value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length); break;
	        default: value = padding + valuePrefix + value + valueSuffix; break;
	      }
	
	      return numerals(value);
	    }
	
	    format.toString = function() {
	      return specifier + "";
	    };
	
	    return format;
	  }
	
	  function formatPrefix(specifier, value) {
	    var f = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)),
	        e = Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3,
	        k = Math.pow(10, -e),
	        prefix = prefixes[8 + e / 3];
	    return function(value) {
	      return f(k * value) + prefix;
	    };
	  }
	
	  return {
	    format: newFormat,
	    formatPrefix: formatPrefix
	  };
	}
	
	var locale;
	
	defaultLocale({
	  decimal: ".",
	  thousands: ",",
	  grouping: [3],
	  currency: ["$", ""],
	  minus: "-"
	});
	
	function defaultLocale(definition) {
	  locale = formatLocale(definition);
	  exports.format = locale.format;
	  exports.formatPrefix = locale.formatPrefix;
	  return locale;
	}
	
	function precisionFixed(step) {
	  return Math.max(0, -exponent(Math.abs(step)));
	}
	
	function precisionPrefix(step, value) {
	  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3 - exponent(Math.abs(step)));
	}
	
	function precisionRound(step, max) {
	  step = Math.abs(step), max = Math.abs(max) - step;
	  return Math.max(0, exponent(max) - exponent(step)) + 1;
	}
	
	exports.FormatSpecifier = FormatSpecifier;
	exports.formatDefaultLocale = defaultLocale;
	exports.formatLocale = formatLocale;
	exports.formatSpecifier = formatSpecifier;
	exports.precisionFixed = precisionFixed;
	exports.precisionPrefix = precisionPrefix;
	exports.precisionRound = precisionRound;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 1531 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-interpolate/ v1.4.0 Copyright 2019 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports, __webpack_require__(1529)) :
	typeof define === 'function' && define.amd ? define(['exports', 'd3-color'], factory) :
	(global = global || self, factory(global.d3 = global.d3 || {}, global.d3));
	}(this, function (exports, d3Color) { 'use strict';
	
	function basis(t1, v0, v1, v2, v3) {
	  var t2 = t1 * t1, t3 = t2 * t1;
	  return ((1 - 3 * t1 + 3 * t2 - t3) * v0
	      + (4 - 6 * t2 + 3 * t3) * v1
	      + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
	      + t3 * v3) / 6;
	}
	
	function basis$1(values) {
	  var n = values.length - 1;
	  return function(t) {
	    var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
	        v1 = values[i],
	        v2 = values[i + 1],
	        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
	        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
	    return basis((t - i / n) * n, v0, v1, v2, v3);
	  };
	}
	
	function basisClosed(values) {
	  var n = values.length;
	  return function(t) {
	    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
	        v0 = values[(i + n - 1) % n],
	        v1 = values[i % n],
	        v2 = values[(i + 1) % n],
	        v3 = values[(i + 2) % n];
	    return basis((t - i / n) * n, v0, v1, v2, v3);
	  };
	}
	
	function constant(x) {
	  return function() {
	    return x;
	  };
	}
	
	function linear(a, d) {
	  return function(t) {
	    return a + t * d;
	  };
	}
	
	function exponential(a, b, y) {
	  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
	    return Math.pow(a + t * b, y);
	  };
	}
	
	function hue(a, b) {
	  var d = b - a;
	  return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : constant(isNaN(a) ? b : a);
	}
	
	function gamma(y) {
	  return (y = +y) === 1 ? nogamma : function(a, b) {
	    return b - a ? exponential(a, b, y) : constant(isNaN(a) ? b : a);
	  };
	}
	
	function nogamma(a, b) {
	  var d = b - a;
	  return d ? linear(a, d) : constant(isNaN(a) ? b : a);
	}
	
	var rgb = (function rgbGamma(y) {
	  var color = gamma(y);
	
	  function rgb(start, end) {
	    var r = color((start = d3Color.rgb(start)).r, (end = d3Color.rgb(end)).r),
	        g = color(start.g, end.g),
	        b = color(start.b, end.b),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.r = r(t);
	      start.g = g(t);
	      start.b = b(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	
	  rgb.gamma = rgbGamma;
	
	  return rgb;
	})(1);
	
	function rgbSpline(spline) {
	  return function(colors) {
	    var n = colors.length,
	        r = new Array(n),
	        g = new Array(n),
	        b = new Array(n),
	        i, color;
	    for (i = 0; i < n; ++i) {
	      color = d3Color.rgb(colors[i]);
	      r[i] = color.r || 0;
	      g[i] = color.g || 0;
	      b[i] = color.b || 0;
	    }
	    r = spline(r);
	    g = spline(g);
	    b = spline(b);
	    color.opacity = 1;
	    return function(t) {
	      color.r = r(t);
	      color.g = g(t);
	      color.b = b(t);
	      return color + "";
	    };
	  };
	}
	
	var rgbBasis = rgbSpline(basis$1);
	var rgbBasisClosed = rgbSpline(basisClosed);
	
	function numberArray(a, b) {
	  if (!b) b = [];
	  var n = a ? Math.min(b.length, a.length) : 0,
	      c = b.slice(),
	      i;
	  return function(t) {
	    for (i = 0; i < n; ++i) c[i] = a[i] * (1 - t) + b[i] * t;
	    return c;
	  };
	}
	
	function isNumberArray(x) {
	  return ArrayBuffer.isView(x) && !(x instanceof DataView);
	}
	
	function array(a, b) {
	  return (isNumberArray(b) ? numberArray : genericArray)(a, b);
	}
	
	function genericArray(a, b) {
	  var nb = b ? b.length : 0,
	      na = a ? Math.min(nb, a.length) : 0,
	      x = new Array(na),
	      c = new Array(nb),
	      i;
	
	  for (i = 0; i < na; ++i) x[i] = value(a[i], b[i]);
	  for (; i < nb; ++i) c[i] = b[i];
	
	  return function(t) {
	    for (i = 0; i < na; ++i) c[i] = x[i](t);
	    return c;
	  };
	}
	
	function date(a, b) {
	  var d = new Date;
	  return a = +a, b = +b, function(t) {
	    return d.setTime(a * (1 - t) + b * t), d;
	  };
	}
	
	function number(a, b) {
	  return a = +a, b = +b, function(t) {
	    return a * (1 - t) + b * t;
	  };
	}
	
	function object(a, b) {
	  var i = {},
	      c = {},
	      k;
	
	  if (a === null || typeof a !== "object") a = {};
	  if (b === null || typeof b !== "object") b = {};
	
	  for (k in b) {
	    if (k in a) {
	      i[k] = value(a[k], b[k]);
	    } else {
	      c[k] = b[k];
	    }
	  }
	
	  return function(t) {
	    for (k in i) c[k] = i[k](t);
	    return c;
	  };
	}
	
	var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
	    reB = new RegExp(reA.source, "g");
	
	function zero(b) {
	  return function() {
	    return b;
	  };
	}
	
	function one(b) {
	  return function(t) {
	    return b(t) + "";
	  };
	}
	
	function string(a, b) {
	  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
	      am, // current match in a
	      bm, // current match in b
	      bs, // string preceding current number in b, if any
	      i = -1, // index in s
	      s = [], // string constants and placeholders
	      q = []; // number interpolators
	
	  // Coerce inputs to strings.
	  a = a + "", b = b + "";
	
	  // Interpolate pairs of numbers in a & b.
	  while ((am = reA.exec(a))
	      && (bm = reB.exec(b))) {
	    if ((bs = bm.index) > bi) { // a string precedes the next number in b
	      bs = b.slice(bi, bs);
	      if (s[i]) s[i] += bs; // coalesce with previous string
	      else s[++i] = bs;
	    }
	    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
	      if (s[i]) s[i] += bm; // coalesce with previous string
	      else s[++i] = bm;
	    } else { // interpolate non-matching numbers
	      s[++i] = null;
	      q.push({i: i, x: number(am, bm)});
	    }
	    bi = reB.lastIndex;
	  }
	
	  // Add remains of b.
	  if (bi < b.length) {
	    bs = b.slice(bi);
	    if (s[i]) s[i] += bs; // coalesce with previous string
	    else s[++i] = bs;
	  }
	
	  // Special optimization for only a single match.
	  // Otherwise, interpolate each of the numbers and rejoin the string.
	  return s.length < 2 ? (q[0]
	      ? one(q[0].x)
	      : zero(b))
	      : (b = q.length, function(t) {
	          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
	          return s.join("");
	        });
	}
	
	function value(a, b) {
	  var t = typeof b, c;
	  return b == null || t === "boolean" ? constant(b)
	      : (t === "number" ? number
	      : t === "string" ? ((c = d3Color.color(b)) ? (b = c, rgb) : string)
	      : b instanceof d3Color.color ? rgb
	      : b instanceof Date ? date
	      : isNumberArray(b) ? numberArray
	      : Array.isArray(b) ? genericArray
	      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? object
	      : number)(a, b);
	}
	
	function discrete(range) {
	  var n = range.length;
	  return function(t) {
	    return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
	  };
	}
	
	function hue$1(a, b) {
	  var i = hue(+a, +b);
	  return function(t) {
	    var x = i(t);
	    return x - 360 * Math.floor(x / 360);
	  };
	}
	
	function round(a, b) {
	  return a = +a, b = +b, function(t) {
	    return Math.round(a * (1 - t) + b * t);
	  };
	}
	
	var degrees = 180 / Math.PI;
	
	var identity = {
	  translateX: 0,
	  translateY: 0,
	  rotate: 0,
	  skewX: 0,
	  scaleX: 1,
	  scaleY: 1
	};
	
	function decompose(a, b, c, d, e, f) {
	  var scaleX, scaleY, skewX;
	  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
	  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
	  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
	  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
	  return {
	    translateX: e,
	    translateY: f,
	    rotate: Math.atan2(b, a) * degrees,
	    skewX: Math.atan(skewX) * degrees,
	    scaleX: scaleX,
	    scaleY: scaleY
	  };
	}
	
	var cssNode,
	    cssRoot,
	    cssView,
	    svgNode;
	
	function parseCss(value) {
	  if (value === "none") return identity;
	  if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
	  cssNode.style.transform = value;
	  value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
	  cssRoot.removeChild(cssNode);
	  value = value.slice(7, -1).split(",");
	  return decompose(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
	}
	
	function parseSvg(value) {
	  if (value == null) return identity;
	  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
	  svgNode.setAttribute("transform", value);
	  if (!(value = svgNode.transform.baseVal.consolidate())) return identity;
	  value = value.matrix;
	  return decompose(value.a, value.b, value.c, value.d, value.e, value.f);
	}
	
	function interpolateTransform(parse, pxComma, pxParen, degParen) {
	
	  function pop(s) {
	    return s.length ? s.pop() + " " : "";
	  }
	
	  function translate(xa, ya, xb, yb, s, q) {
	    if (xa !== xb || ya !== yb) {
	      var i = s.push("translate(", null, pxComma, null, pxParen);
	      q.push({i: i - 4, x: number(xa, xb)}, {i: i - 2, x: number(ya, yb)});
	    } else if (xb || yb) {
	      s.push("translate(" + xb + pxComma + yb + pxParen);
	    }
	  }
	
	  function rotate(a, b, s, q) {
	    if (a !== b) {
	      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
	      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: number(a, b)});
	    } else if (b) {
	      s.push(pop(s) + "rotate(" + b + degParen);
	    }
	  }
	
	  function skewX(a, b, s, q) {
	    if (a !== b) {
	      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: number(a, b)});
	    } else if (b) {
	      s.push(pop(s) + "skewX(" + b + degParen);
	    }
	  }
	
	  function scale(xa, ya, xb, yb, s, q) {
	    if (xa !== xb || ya !== yb) {
	      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
	      q.push({i: i - 4, x: number(xa, xb)}, {i: i - 2, x: number(ya, yb)});
	    } else if (xb !== 1 || yb !== 1) {
	      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
	    }
	  }
	
	  return function(a, b) {
	    var s = [], // string constants and placeholders
	        q = []; // number interpolators
	    a = parse(a), b = parse(b);
	    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
	    rotate(a.rotate, b.rotate, s, q);
	    skewX(a.skewX, b.skewX, s, q);
	    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
	    a = b = null; // gc
	    return function(t) {
	      var i = -1, n = q.length, o;
	      while (++i < n) s[(o = q[i]).i] = o.x(t);
	      return s.join("");
	    };
	  };
	}
	
	var interpolateTransformCss = interpolateTransform(parseCss, "px, ", "px)", "deg)");
	var interpolateTransformSvg = interpolateTransform(parseSvg, ", ", ")", ")");
	
	var rho = Math.SQRT2,
	    rho2 = 2,
	    rho4 = 4,
	    epsilon2 = 1e-12;
	
	function cosh(x) {
	  return ((x = Math.exp(x)) + 1 / x) / 2;
	}
	
	function sinh(x) {
	  return ((x = Math.exp(x)) - 1 / x) / 2;
	}
	
	function tanh(x) {
	  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
	}
	
	// p0 = [ux0, uy0, w0]
	// p1 = [ux1, uy1, w1]
	function zoom(p0, p1) {
	  var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
	      ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
	      dx = ux1 - ux0,
	      dy = uy1 - uy0,
	      d2 = dx * dx + dy * dy,
	      i,
	      S;
	
	  // Special case for u0 ≅ u1.
	  if (d2 < epsilon2) {
	    S = Math.log(w1 / w0) / rho;
	    i = function(t) {
	      return [
	        ux0 + t * dx,
	        uy0 + t * dy,
	        w0 * Math.exp(rho * t * S)
	      ];
	    };
	  }
	
	  // General case.
	  else {
	    var d1 = Math.sqrt(d2),
	        b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
	        b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
	        r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
	        r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
	    S = (r1 - r0) / rho;
	    i = function(t) {
	      var s = t * S,
	          coshr0 = cosh(r0),
	          u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
	      return [
	        ux0 + u * dx,
	        uy0 + u * dy,
	        w0 * coshr0 / cosh(rho * s + r0)
	      ];
	    };
	  }
	
	  i.duration = S * 1000;
	
	  return i;
	}
	
	function hsl(hue) {
	  return function(start, end) {
	    var h = hue((start = d3Color.hsl(start)).h, (end = d3Color.hsl(end)).h),
	        s = nogamma(start.s, end.s),
	        l = nogamma(start.l, end.l),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.h = h(t);
	      start.s = s(t);
	      start.l = l(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	}
	
	var hsl$1 = hsl(hue);
	var hslLong = hsl(nogamma);
	
	function lab(start, end) {
	  var l = nogamma((start = d3Color.lab(start)).l, (end = d3Color.lab(end)).l),
	      a = nogamma(start.a, end.a),
	      b = nogamma(start.b, end.b),
	      opacity = nogamma(start.opacity, end.opacity);
	  return function(t) {
	    start.l = l(t);
	    start.a = a(t);
	    start.b = b(t);
	    start.opacity = opacity(t);
	    return start + "";
	  };
	}
	
	function hcl(hue) {
	  return function(start, end) {
	    var h = hue((start = d3Color.hcl(start)).h, (end = d3Color.hcl(end)).h),
	        c = nogamma(start.c, end.c),
	        l = nogamma(start.l, end.l),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.h = h(t);
	      start.c = c(t);
	      start.l = l(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	}
	
	var hcl$1 = hcl(hue);
	var hclLong = hcl(nogamma);
	
	function cubehelix(hue) {
	  return (function cubehelixGamma(y) {
	    y = +y;
	
	    function cubehelix(start, end) {
	      var h = hue((start = d3Color.cubehelix(start)).h, (end = d3Color.cubehelix(end)).h),
	          s = nogamma(start.s, end.s),
	          l = nogamma(start.l, end.l),
	          opacity = nogamma(start.opacity, end.opacity);
	      return function(t) {
	        start.h = h(t);
	        start.s = s(t);
	        start.l = l(Math.pow(t, y));
	        start.opacity = opacity(t);
	        return start + "";
	      };
	    }
	
	    cubehelix.gamma = cubehelixGamma;
	
	    return cubehelix;
	  })(1);
	}
	
	var cubehelix$1 = cubehelix(hue);
	var cubehelixLong = cubehelix(nogamma);
	
	function piecewise(interpolate, values) {
	  var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
	  while (i < n) I[i] = interpolate(v, v = values[++i]);
	  return function(t) {
	    var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
	    return I[i](t - i);
	  };
	}
	
	function quantize(interpolator, n) {
	  var samples = new Array(n);
	  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
	  return samples;
	}
	
	exports.interpolate = value;
	exports.interpolateArray = array;
	exports.interpolateBasis = basis$1;
	exports.interpolateBasisClosed = basisClosed;
	exports.interpolateCubehelix = cubehelix$1;
	exports.interpolateCubehelixLong = cubehelixLong;
	exports.interpolateDate = date;
	exports.interpolateDiscrete = discrete;
	exports.interpolateHcl = hcl$1;
	exports.interpolateHclLong = hclLong;
	exports.interpolateHsl = hsl$1;
	exports.interpolateHslLong = hslLong;
	exports.interpolateHue = hue$1;
	exports.interpolateLab = lab;
	exports.interpolateNumber = number;
	exports.interpolateNumberArray = numberArray;
	exports.interpolateObject = object;
	exports.interpolateRgb = rgb;
	exports.interpolateRgbBasis = rgbBasis;
	exports.interpolateRgbBasisClosed = rgbBasisClosed;
	exports.interpolateRound = round;
	exports.interpolateString = string;
	exports.interpolateTransformCss = interpolateTransformCss;
	exports.interpolateTransformSvg = interpolateTransformSvg;
	exports.interpolateZoom = zoom;
	exports.piecewise = piecewise;
	exports.quantize = quantize;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	}));


/***/ },
/* 1532 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-path/ v1.0.9 Copyright 2019 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(global = global || self, factory(global.d3 = global.d3 || {}));
	}(this, function (exports) { 'use strict';
	
	var pi = Math.PI,
	    tau = 2 * pi,
	    epsilon = 1e-6,
	    tauEpsilon = tau - epsilon;
	
	function Path() {
	  this._x0 = this._y0 = // start of current subpath
	  this._x1 = this._y1 = null; // end of current subpath
	  this._ = "";
	}
	
	function path() {
	  return new Path;
	}
	
	Path.prototype = path.prototype = {
	  constructor: Path,
	  moveTo: function(x, y) {
	    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
	  },
	  closePath: function() {
	    if (this._x1 !== null) {
	      this._x1 = this._x0, this._y1 = this._y0;
	      this._ += "Z";
	    }
	  },
	  lineTo: function(x, y) {
	    this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  quadraticCurveTo: function(x1, y1, x, y) {
	    this._ += "Q" + (+x1) + "," + (+y1) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  bezierCurveTo: function(x1, y1, x2, y2, x, y) {
	    this._ += "C" + (+x1) + "," + (+y1) + "," + (+x2) + "," + (+y2) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  arcTo: function(x1, y1, x2, y2, r) {
	    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
	    var x0 = this._x1,
	        y0 = this._y1,
	        x21 = x2 - x1,
	        y21 = y2 - y1,
	        x01 = x0 - x1,
	        y01 = y0 - y1,
	        l01_2 = x01 * x01 + y01 * y01;
	
	    // Is the radius negative? Error.
	    if (r < 0) throw new Error("negative radius: " + r);
	
	    // Is this path empty? Move to (x1,y1).
	    if (this._x1 === null) {
	      this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
	    }
	
	    // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
	    else if (!(l01_2 > epsilon));
	
	    // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
	    // Equivalently, is (x1,y1) coincident with (x2,y2)?
	    // Or, is the radius zero? Line to (x1,y1).
	    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) {
	      this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
	    }
	
	    // Otherwise, draw an arc!
	    else {
	      var x20 = x2 - x0,
	          y20 = y2 - y0,
	          l21_2 = x21 * x21 + y21 * y21,
	          l20_2 = x20 * x20 + y20 * y20,
	          l21 = Math.sqrt(l21_2),
	          l01 = Math.sqrt(l01_2),
	          l = r * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
	          t01 = l / l01,
	          t21 = l / l21;
	
	      // If the start tangent is not coincident with (x0,y0), line to.
	      if (Math.abs(t01 - 1) > epsilon) {
	        this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
	      }
	
	      this._ += "A" + r + "," + r + ",0,0," + (+(y01 * x20 > x01 * y20)) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
	    }
	  },
	  arc: function(x, y, r, a0, a1, ccw) {
	    x = +x, y = +y, r = +r, ccw = !!ccw;
	    var dx = r * Math.cos(a0),
	        dy = r * Math.sin(a0),
	        x0 = x + dx,
	        y0 = y + dy,
	        cw = 1 ^ ccw,
	        da = ccw ? a0 - a1 : a1 - a0;
	
	    // Is the radius negative? Error.
	    if (r < 0) throw new Error("negative radius: " + r);
	
	    // Is this path empty? Move to (x0,y0).
	    if (this._x1 === null) {
	      this._ += "M" + x0 + "," + y0;
	    }
	
	    // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
	    else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) {
	      this._ += "L" + x0 + "," + y0;
	    }
	
	    // Is this arc empty? We’re done.
	    if (!r) return;
	
	    // Does the angle go the wrong way? Flip the direction.
	    if (da < 0) da = da % tau + tau;
	
	    // Is this a complete circle? Draw two arcs to complete the circle.
	    if (da > tauEpsilon) {
	      this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
	    }
	
	    // Is this arc non-empty? Draw an arc!
	    else if (da > epsilon) {
	      this._ += "A" + r + "," + r + ",0," + (+(da >= pi)) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
	    }
	  },
	  rect: function(x, y, w, h) {
	    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + (+w) + "v" + (+h) + "h" + (-w) + "Z";
	  },
	  toString: function() {
	    return this._;
	  }
	};
	
	exports.path = path;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	}));


/***/ },
/* 1533 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-time-format/ v2.3.0 Copyright 2020 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports, __webpack_require__(615)) :
	typeof define === 'function' && define.amd ? define(['exports', 'd3-time'], factory) :
	(global = global || self, factory(global.d3 = global.d3 || {}, global.d3));
	}(this, function (exports, d3Time) { 'use strict';
	
	function localDate(d) {
	  if (0 <= d.y && d.y < 100) {
	    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
	    date.setFullYear(d.y);
	    return date;
	  }
	  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
	}
	
	function utcDate(d) {
	  if (0 <= d.y && d.y < 100) {
	    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
	    date.setUTCFullYear(d.y);
	    return date;
	  }
	  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
	}
	
	function newDate(y, m, d) {
	  return {y: y, m: m, d: d, H: 0, M: 0, S: 0, L: 0};
	}
	
	function formatLocale(locale) {
	  var locale_dateTime = locale.dateTime,
	      locale_date = locale.date,
	      locale_time = locale.time,
	      locale_periods = locale.periods,
	      locale_weekdays = locale.days,
	      locale_shortWeekdays = locale.shortDays,
	      locale_months = locale.months,
	      locale_shortMonths = locale.shortMonths;
	
	  var periodRe = formatRe(locale_periods),
	      periodLookup = formatLookup(locale_periods),
	      weekdayRe = formatRe(locale_weekdays),
	      weekdayLookup = formatLookup(locale_weekdays),
	      shortWeekdayRe = formatRe(locale_shortWeekdays),
	      shortWeekdayLookup = formatLookup(locale_shortWeekdays),
	      monthRe = formatRe(locale_months),
	      monthLookup = formatLookup(locale_months),
	      shortMonthRe = formatRe(locale_shortMonths),
	      shortMonthLookup = formatLookup(locale_shortMonths);
	
	  var formats = {
	    "a": formatShortWeekday,
	    "A": formatWeekday,
	    "b": formatShortMonth,
	    "B": formatMonth,
	    "c": null,
	    "d": formatDayOfMonth,
	    "e": formatDayOfMonth,
	    "f": formatMicroseconds,
	    "g": formatYearISO,
	    "G": formatFullYearISO,
	    "H": formatHour24,
	    "I": formatHour12,
	    "j": formatDayOfYear,
	    "L": formatMilliseconds,
	    "m": formatMonthNumber,
	    "M": formatMinutes,
	    "p": formatPeriod,
	    "q": formatQuarter,
	    "Q": formatUnixTimestamp,
	    "s": formatUnixTimestampSeconds,
	    "S": formatSeconds,
	    "u": formatWeekdayNumberMonday,
	    "U": formatWeekNumberSunday,
	    "V": formatWeekNumberISO,
	    "w": formatWeekdayNumberSunday,
	    "W": formatWeekNumberMonday,
	    "x": null,
	    "X": null,
	    "y": formatYear,
	    "Y": formatFullYear,
	    "Z": formatZone,
	    "%": formatLiteralPercent
	  };
	
	  var utcFormats = {
	    "a": formatUTCShortWeekday,
	    "A": formatUTCWeekday,
	    "b": formatUTCShortMonth,
	    "B": formatUTCMonth,
	    "c": null,
	    "d": formatUTCDayOfMonth,
	    "e": formatUTCDayOfMonth,
	    "f": formatUTCMicroseconds,
	    "g": formatUTCYearISO,
	    "G": formatUTCFullYearISO,
	    "H": formatUTCHour24,
	    "I": formatUTCHour12,
	    "j": formatUTCDayOfYear,
	    "L": formatUTCMilliseconds,
	    "m": formatUTCMonthNumber,
	    "M": formatUTCMinutes,
	    "p": formatUTCPeriod,
	    "q": formatUTCQuarter,
	    "Q": formatUnixTimestamp,
	    "s": formatUnixTimestampSeconds,
	    "S": formatUTCSeconds,
	    "u": formatUTCWeekdayNumberMonday,
	    "U": formatUTCWeekNumberSunday,
	    "V": formatUTCWeekNumberISO,
	    "w": formatUTCWeekdayNumberSunday,
	    "W": formatUTCWeekNumberMonday,
	    "x": null,
	    "X": null,
	    "y": formatUTCYear,
	    "Y": formatUTCFullYear,
	    "Z": formatUTCZone,
	    "%": formatLiteralPercent
	  };
	
	  var parses = {
	    "a": parseShortWeekday,
	    "A": parseWeekday,
	    "b": parseShortMonth,
	    "B": parseMonth,
	    "c": parseLocaleDateTime,
	    "d": parseDayOfMonth,
	    "e": parseDayOfMonth,
	    "f": parseMicroseconds,
	    "g": parseYear,
	    "G": parseFullYear,
	    "H": parseHour24,
	    "I": parseHour24,
	    "j": parseDayOfYear,
	    "L": parseMilliseconds,
	    "m": parseMonthNumber,
	    "M": parseMinutes,
	    "p": parsePeriod,
	    "q": parseQuarter,
	    "Q": parseUnixTimestamp,
	    "s": parseUnixTimestampSeconds,
	    "S": parseSeconds,
	    "u": parseWeekdayNumberMonday,
	    "U": parseWeekNumberSunday,
	    "V": parseWeekNumberISO,
	    "w": parseWeekdayNumberSunday,
	    "W": parseWeekNumberMonday,
	    "x": parseLocaleDate,
	    "X": parseLocaleTime,
	    "y": parseYear,
	    "Y": parseFullYear,
	    "Z": parseZone,
	    "%": parseLiteralPercent
	  };
	
	  // These recursive directive definitions must be deferred.
	  formats.x = newFormat(locale_date, formats);
	  formats.X = newFormat(locale_time, formats);
	  formats.c = newFormat(locale_dateTime, formats);
	  utcFormats.x = newFormat(locale_date, utcFormats);
	  utcFormats.X = newFormat(locale_time, utcFormats);
	  utcFormats.c = newFormat(locale_dateTime, utcFormats);
	
	  function newFormat(specifier, formats) {
	    return function(date) {
	      var string = [],
	          i = -1,
	          j = 0,
	          n = specifier.length,
	          c,
	          pad,
	          format;
	
	      if (!(date instanceof Date)) date = new Date(+date);
	
	      while (++i < n) {
	        if (specifier.charCodeAt(i) === 37) {
	          string.push(specifier.slice(j, i));
	          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
	          else pad = c === "e" ? " " : "0";
	          if (format = formats[c]) c = format(date, pad);
	          string.push(c);
	          j = i + 1;
	        }
	      }
	
	      string.push(specifier.slice(j, i));
	      return string.join("");
	    };
	  }
	
	  function newParse(specifier, Z) {
	    return function(string) {
	      var d = newDate(1900, undefined, 1),
	          i = parseSpecifier(d, specifier, string += "", 0),
	          week, day;
	      if (i != string.length) return null;
	
	      // If a UNIX timestamp is specified, return it.
	      if ("Q" in d) return new Date(d.Q);
	      if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));
	
	      // If this is utcParse, never use the local timezone.
	      if (Z && !("Z" in d)) d.Z = 0;
	
	      // The am-pm flag is 0 for AM, and 1 for PM.
	      if ("p" in d) d.H = d.H % 12 + d.p * 12;
	
	      // If the month was not specified, inherit from the quarter.
	      if (d.m === undefined) d.m = "q" in d ? d.q : 0;
	
	      // Convert day-of-week and week-of-year to day-of-year.
	      if ("V" in d) {
	        if (d.V < 1 || d.V > 53) return null;
	        if (!("w" in d)) d.w = 1;
	        if ("Z" in d) {
	          week = utcDate(newDate(d.y, 0, 1)), day = week.getUTCDay();
	          week = day > 4 || day === 0 ? d3Time.utcMonday.ceil(week) : d3Time.utcMonday(week);
	          week = d3Time.utcDay.offset(week, (d.V - 1) * 7);
	          d.y = week.getUTCFullYear();
	          d.m = week.getUTCMonth();
	          d.d = week.getUTCDate() + (d.w + 6) % 7;
	        } else {
	          week = localDate(newDate(d.y, 0, 1)), day = week.getDay();
	          week = day > 4 || day === 0 ? d3Time.timeMonday.ceil(week) : d3Time.timeMonday(week);
	          week = d3Time.timeDay.offset(week, (d.V - 1) * 7);
	          d.y = week.getFullYear();
	          d.m = week.getMonth();
	          d.d = week.getDate() + (d.w + 6) % 7;
	        }
	      } else if ("W" in d || "U" in d) {
	        if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
	        day = "Z" in d ? utcDate(newDate(d.y, 0, 1)).getUTCDay() : localDate(newDate(d.y, 0, 1)).getDay();
	        d.m = 0;
	        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
	      }
	
	      // If a time zone is specified, all fields are interpreted as UTC and then
	      // offset according to the specified time zone.
	      if ("Z" in d) {
	        d.H += d.Z / 100 | 0;
	        d.M += d.Z % 100;
	        return utcDate(d);
	      }
	
	      // Otherwise, all fields are in local time.
	      return localDate(d);
	    };
	  }
	
	  function parseSpecifier(d, specifier, string, j) {
	    var i = 0,
	        n = specifier.length,
	        m = string.length,
	        c,
	        parse;
	
	    while (i < n) {
	      if (j >= m) return -1;
	      c = specifier.charCodeAt(i++);
	      if (c === 37) {
	        c = specifier.charAt(i++);
	        parse = parses[c in pads ? specifier.charAt(i++) : c];
	        if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
	      } else if (c != string.charCodeAt(j++)) {
	        return -1;
	      }
	    }
	
	    return j;
	  }
	
	  function parsePeriod(d, string, i) {
	    var n = periodRe.exec(string.slice(i));
	    return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseShortWeekday(d, string, i) {
	    var n = shortWeekdayRe.exec(string.slice(i));
	    return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseWeekday(d, string, i) {
	    var n = weekdayRe.exec(string.slice(i));
	    return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseShortMonth(d, string, i) {
	    var n = shortMonthRe.exec(string.slice(i));
	    return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseMonth(d, string, i) {
	    var n = monthRe.exec(string.slice(i));
	    return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseLocaleDateTime(d, string, i) {
	    return parseSpecifier(d, locale_dateTime, string, i);
	  }
	
	  function parseLocaleDate(d, string, i) {
	    return parseSpecifier(d, locale_date, string, i);
	  }
	
	  function parseLocaleTime(d, string, i) {
	    return parseSpecifier(d, locale_time, string, i);
	  }
	
	  function formatShortWeekday(d) {
	    return locale_shortWeekdays[d.getDay()];
	  }
	
	  function formatWeekday(d) {
	    return locale_weekdays[d.getDay()];
	  }
	
	  function formatShortMonth(d) {
	    return locale_shortMonths[d.getMonth()];
	  }
	
	  function formatMonth(d) {
	    return locale_months[d.getMonth()];
	  }
	
	  function formatPeriod(d) {
	    return locale_periods[+(d.getHours() >= 12)];
	  }
	
	  function formatQuarter(d) {
	    return 1 + ~~(d.getMonth() / 3);
	  }
	
	  function formatUTCShortWeekday(d) {
	    return locale_shortWeekdays[d.getUTCDay()];
	  }
	
	  function formatUTCWeekday(d) {
	    return locale_weekdays[d.getUTCDay()];
	  }
	
	  function formatUTCShortMonth(d) {
	    return locale_shortMonths[d.getUTCMonth()];
	  }
	
	  function formatUTCMonth(d) {
	    return locale_months[d.getUTCMonth()];
	  }
	
	  function formatUTCPeriod(d) {
	    return locale_periods[+(d.getUTCHours() >= 12)];
	  }
	
	  function formatUTCQuarter(d) {
	    return 1 + ~~(d.getUTCMonth() / 3);
	  }
	
	  return {
	    format: function(specifier) {
	      var f = newFormat(specifier += "", formats);
	      f.toString = function() { return specifier; };
	      return f;
	    },
	    parse: function(specifier) {
	      var p = newParse(specifier += "", false);
	      p.toString = function() { return specifier; };
	      return p;
	    },
	    utcFormat: function(specifier) {
	      var f = newFormat(specifier += "", utcFormats);
	      f.toString = function() { return specifier; };
	      return f;
	    },
	    utcParse: function(specifier) {
	      var p = newParse(specifier += "", true);
	      p.toString = function() { return specifier; };
	      return p;
	    }
	  };
	}
	
	var pads = {"-": "", "_": " ", "0": "0"},
	    numberRe = /^\s*\d+/, // note: ignores next directive
	    percentRe = /^%/,
	    requoteRe = /[\\^$*+?|[\]().{}]/g;
	
	function pad(value, fill, width) {
	  var sign = value < 0 ? "-" : "",
	      string = (sign ? -value : value) + "",
	      length = string.length;
	  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
	}
	
	function requote(s) {
	  return s.replace(requoteRe, "\\$&");
	}
	
	function formatRe(names) {
	  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
	}
	
	function formatLookup(names) {
	  var map = {}, i = -1, n = names.length;
	  while (++i < n) map[names[i].toLowerCase()] = i;
	  return map;
	}
	
	function parseWeekdayNumberSunday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 1));
	  return n ? (d.w = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekdayNumberMonday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 1));
	  return n ? (d.u = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberSunday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.U = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberISO(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.V = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberMonday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.W = +n[0], i + n[0].length) : -1;
	}
	
	function parseFullYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 4));
	  return n ? (d.y = +n[0], i + n[0].length) : -1;
	}
	
	function parseYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
	}
	
	function parseZone(d, string, i) {
	  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
	  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
	}
	
	function parseQuarter(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 1));
	  return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
	}
	
	function parseMonthNumber(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
	}
	
	function parseDayOfMonth(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.d = +n[0], i + n[0].length) : -1;
	}
	
	function parseDayOfYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 3));
	  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
	}
	
	function parseHour24(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.H = +n[0], i + n[0].length) : -1;
	}
	
	function parseMinutes(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.M = +n[0], i + n[0].length) : -1;
	}
	
	function parseSeconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.S = +n[0], i + n[0].length) : -1;
	}
	
	function parseMilliseconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 3));
	  return n ? (d.L = +n[0], i + n[0].length) : -1;
	}
	
	function parseMicroseconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 6));
	  return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
	}
	
	function parseLiteralPercent(d, string, i) {
	  var n = percentRe.exec(string.slice(i, i + 1));
	  return n ? i + n[0].length : -1;
	}
	
	function parseUnixTimestamp(d, string, i) {
	  var n = numberRe.exec(string.slice(i));
	  return n ? (d.Q = +n[0], i + n[0].length) : -1;
	}
	
	function parseUnixTimestampSeconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i));
	  return n ? (d.s = +n[0], i + n[0].length) : -1;
	}
	
	function formatDayOfMonth(d, p) {
	  return pad(d.getDate(), p, 2);
	}
	
	function formatHour24(d, p) {
	  return pad(d.getHours(), p, 2);
	}
	
	function formatHour12(d, p) {
	  return pad(d.getHours() % 12 || 12, p, 2);
	}
	
	function formatDayOfYear(d, p) {
	  return pad(1 + d3Time.timeDay.count(d3Time.timeYear(d), d), p, 3);
	}
	
	function formatMilliseconds(d, p) {
	  return pad(d.getMilliseconds(), p, 3);
	}
	
	function formatMicroseconds(d, p) {
	  return formatMilliseconds(d, p) + "000";
	}
	
	function formatMonthNumber(d, p) {
	  return pad(d.getMonth() + 1, p, 2);
	}
	
	function formatMinutes(d, p) {
	  return pad(d.getMinutes(), p, 2);
	}
	
	function formatSeconds(d, p) {
	  return pad(d.getSeconds(), p, 2);
	}
	
	function formatWeekdayNumberMonday(d) {
	  var day = d.getDay();
	  return day === 0 ? 7 : day;
	}
	
	function formatWeekNumberSunday(d, p) {
	  return pad(d3Time.timeSunday.count(d3Time.timeYear(d) - 1, d), p, 2);
	}
	
	function dISO(d) {
	  var day = d.getDay();
	  return (day >= 4 || day === 0) ? d3Time.timeThursday(d) : d3Time.timeThursday.ceil(d);
	}
	
	function formatWeekNumberISO(d, p) {
	  d = dISO(d);
	  return pad(d3Time.timeThursday.count(d3Time.timeYear(d), d) + (d3Time.timeYear(d).getDay() === 4), p, 2);
	}
	
	function formatWeekdayNumberSunday(d) {
	  return d.getDay();
	}
	
	function formatWeekNumberMonday(d, p) {
	  return pad(d3Time.timeMonday.count(d3Time.timeYear(d) - 1, d), p, 2);
	}
	
	function formatYear(d, p) {
	  return pad(d.getFullYear() % 100, p, 2);
	}
	
	function formatYearISO(d, p) {
	  d = dISO(d);
	  return pad(d.getFullYear() % 100, p, 2);
	}
	
	function formatFullYear(d, p) {
	  return pad(d.getFullYear() % 10000, p, 4);
	}
	
	function formatFullYearISO(d, p) {
	  var day = d.getDay();
	  d = (day >= 4 || day === 0) ? d3Time.timeThursday(d) : d3Time.timeThursday.ceil(d);
	  return pad(d.getFullYear() % 10000, p, 4);
	}
	
	function formatZone(d) {
	  var z = d.getTimezoneOffset();
	  return (z > 0 ? "-" : (z *= -1, "+"))
	      + pad(z / 60 | 0, "0", 2)
	      + pad(z % 60, "0", 2);
	}
	
	function formatUTCDayOfMonth(d, p) {
	  return pad(d.getUTCDate(), p, 2);
	}
	
	function formatUTCHour24(d, p) {
	  return pad(d.getUTCHours(), p, 2);
	}
	
	function formatUTCHour12(d, p) {
	  return pad(d.getUTCHours() % 12 || 12, p, 2);
	}
	
	function formatUTCDayOfYear(d, p) {
	  return pad(1 + d3Time.utcDay.count(d3Time.utcYear(d), d), p, 3);
	}
	
	function formatUTCMilliseconds(d, p) {
	  return pad(d.getUTCMilliseconds(), p, 3);
	}
	
	function formatUTCMicroseconds(d, p) {
	  return formatUTCMilliseconds(d, p) + "000";
	}
	
	function formatUTCMonthNumber(d, p) {
	  return pad(d.getUTCMonth() + 1, p, 2);
	}
	
	function formatUTCMinutes(d, p) {
	  return pad(d.getUTCMinutes(), p, 2);
	}
	
	function formatUTCSeconds(d, p) {
	  return pad(d.getUTCSeconds(), p, 2);
	}
	
	function formatUTCWeekdayNumberMonday(d) {
	  var dow = d.getUTCDay();
	  return dow === 0 ? 7 : dow;
	}
	
	function formatUTCWeekNumberSunday(d, p) {
	  return pad(d3Time.utcSunday.count(d3Time.utcYear(d) - 1, d), p, 2);
	}
	
	function UTCdISO(d) {
	  var day = d.getUTCDay();
	  return (day >= 4 || day === 0) ? d3Time.utcThursday(d) : d3Time.utcThursday.ceil(d);
	}
	
	function formatUTCWeekNumberISO(d, p) {
	  d = UTCdISO(d);
	  return pad(d3Time.utcThursday.count(d3Time.utcYear(d), d) + (d3Time.utcYear(d).getUTCDay() === 4), p, 2);
	}
	
	function formatUTCWeekdayNumberSunday(d) {
	  return d.getUTCDay();
	}
	
	function formatUTCWeekNumberMonday(d, p) {
	  return pad(d3Time.utcMonday.count(d3Time.utcYear(d) - 1, d), p, 2);
	}
	
	function formatUTCYear(d, p) {
	  return pad(d.getUTCFullYear() % 100, p, 2);
	}
	
	function formatUTCYearISO(d, p) {
	  d = UTCdISO(d);
	  return pad(d.getUTCFullYear() % 100, p, 2);
	}
	
	function formatUTCFullYear(d, p) {
	  return pad(d.getUTCFullYear() % 10000, p, 4);
	}
	
	function formatUTCFullYearISO(d, p) {
	  var day = d.getUTCDay();
	  d = (day >= 4 || day === 0) ? d3Time.utcThursday(d) : d3Time.utcThursday.ceil(d);
	  return pad(d.getUTCFullYear() % 10000, p, 4);
	}
	
	function formatUTCZone() {
	  return "+0000";
	}
	
	function formatLiteralPercent() {
	  return "%";
	}
	
	function formatUnixTimestamp(d) {
	  return +d;
	}
	
	function formatUnixTimestampSeconds(d) {
	  return Math.floor(+d / 1000);
	}
	
	var locale;
	
	defaultLocale({
	  dateTime: "%x, %X",
	  date: "%-m/%-d/%Y",
	  time: "%-I:%M:%S %p",
	  periods: ["AM", "PM"],
	  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
	  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
	  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
	  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
	});
	
	function defaultLocale(definition) {
	  locale = formatLocale(definition);
	  exports.timeFormat = locale.format;
	  exports.timeParse = locale.parse;
	  exports.utcFormat = locale.utcFormat;
	  exports.utcParse = locale.utcParse;
	  return locale;
	}
	
	var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
	
	function formatIsoNative(date) {
	  return date.toISOString();
	}
	
	var formatIso = Date.prototype.toISOString
	    ? formatIsoNative
	    : exports.utcFormat(isoSpecifier);
	
	function parseIsoNative(string) {
	  var date = new Date(string);
	  return isNaN(date) ? null : date;
	}
	
	var parseIso = +new Date("2000-01-01T00:00:00.000Z")
	    ? parseIsoNative
	    : exports.utcParse(isoSpecifier);
	
	exports.isoFormat = formatIso;
	exports.isoParse = parseIso;
	exports.timeFormatDefaultLocale = defaultLocale;
	exports.timeFormatLocale = formatLocale;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	}));


/***/ },
/* 1534 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1535));
	
	var _index2 = _interopRequireDefault(__webpack_require__(621));
	
	var _index3 = _interopRequireDefault(__webpack_require__(620));
	
	var _index4 = _interopRequireDefault(__webpack_require__(622));
	
	var _index5 = _interopRequireDefault(__webpack_require__(383));
	
	var _index6 = _interopRequireDefault(__webpack_require__(169));
	
	var _index7 = _interopRequireDefault(__webpack_require__(618));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dayPeriodEnum = {
	  am: 'am',
	  pm: 'pm',
	  midnight: 'midnight',
	  noon: 'noon',
	  morning: 'morning',
	  afternoon: 'afternoon',
	  evening: 'evening',
	  night: 'night'
	};
	/*
	 * |     | Unit                           |     | Unit                           |
	 * |-----|--------------------------------|-----|--------------------------------|
	 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
	 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
	 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
	 * |  d  | Day of month                   |  D  | Day of year                    |
	 * |  e  | Local day of week              |  E  | Day of week                    |
	 * |  f  |                                |  F* | Day of week in month           |
	 * |  g* | Modified Julian day            |  G  | Era                            |
	 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
	 * |  i! | ISO day of week                |  I! | ISO week of year               |
	 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
	 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
	 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
	 * |  m  | Minute                         |  M  | Month                          |
	 * |  n  |                                |  N  |                                |
	 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
	 * |  p! | Long localized time            |  P! | Long localized date            |
	 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
	 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
	 * |  s  | Second                         |  S  | Fraction of second             |
	 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
	 * |  u  | Extended year                  |  U* | Cyclic year                    |
	 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
	 * |  w  | Local week of year             |  W* | Week of month                  |
	 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
	 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
	 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
	 *
	 * Letters marked by * are not implemented but reserved by Unicode standard.
	 *
	 * Letters marked by ! are non-standard, but implemented by date-fns:
	 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
	 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
	 *   i.e. 7 for Sunday, 1 for Monday, etc.
	 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
	 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
	 *   `R` is supposed to be used in conjunction with `I` and `i`
	 *   for universal ISO week-numbering date, whereas
	 *   `Y` is supposed to be used in conjunction with `w` and `e`
	 *   for week-numbering date specific to the locale.
	 * - `P` is long localized date format
	 * - `p` is long localized time format
	 */
	
	var formatters = {
	  // Era
	  G: function (date, token, localize) {
	    var era = date.getUTCFullYear() > 0 ? 1 : 0;
	
	    switch (token) {
	      // AD, BC
	      case 'G':
	      case 'GG':
	      case 'GGG':
	        return localize.era(era, {
	          width: 'abbreviated'
	        });
	      // A, B
	
	      case 'GGGGG':
	        return localize.era(era, {
	          width: 'narrow'
	        });
	      // Anno Domini, Before Christ
	
	      case 'GGGG':
	      default:
	        return localize.era(era, {
	          width: 'wide'
	        });
	    }
	  },
	  // Year
	  y: function (date, token, localize) {
	    // Ordinal number
	    if (token === 'yo') {
	      var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
	
	      var year = signedYear > 0 ? signedYear : 1 - signedYear;
	      return localize.ordinalNumber(year, {
	        unit: 'year'
	      });
	    }
	
	    return _index7.default.y(date, token);
	  },
	  // Local week-numbering year
	  Y: function (date, token, localize, options) {
	    var signedWeekYear = (0, _index5.default)(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)
	
	    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year
	
	    if (token === 'YY') {
	      var twoDigitYear = weekYear % 100;
	      return (0, _index6.default)(twoDigitYear, 2);
	    } // Ordinal number
	
	
	    if (token === 'Yo') {
	      return localize.ordinalNumber(weekYear, {
	        unit: 'year'
	      });
	    } // Padding
	
	
	    return (0, _index6.default)(weekYear, token.length);
	  },
	  // ISO week-numbering year
	  R: function (date, token) {
	    var isoWeekYear = (0, _index3.default)(date); // Padding
	
	    return (0, _index6.default)(isoWeekYear, token.length);
	  },
	  // Extended year. This is a single number designating the year of this calendar system.
	  // The main difference between `y` and `u` localizers are B.C. years:
	  // | Year | `y` | `u` |
	  // |------|-----|-----|
	  // | AC 1 |   1 |   1 |
	  // | BC 1 |   1 |   0 |
	  // | BC 2 |   2 |  -1 |
	  // Also `yy` always returns the last two digits of a year,
	  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
	  u: function (date, token) {
	    var year = date.getUTCFullYear();
	    return (0, _index6.default)(year, token.length);
	  },
	  // Quarter
	  Q: function (date, token, localize) {
	    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
	
	    switch (token) {
	      // 1, 2, 3, 4
	      case 'Q':
	        return String(quarter);
	      // 01, 02, 03, 04
	
	      case 'QQ':
	        return (0, _index6.default)(quarter, 2);
	      // 1st, 2nd, 3rd, 4th
	
	      case 'Qo':
	        return localize.ordinalNumber(quarter, {
	          unit: 'quarter'
	        });
	      // Q1, Q2, Q3, Q4
	
	      case 'QQQ':
	        return localize.quarter(quarter, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
	
	      case 'QQQQQ':
	        return localize.quarter(quarter, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      // 1st quarter, 2nd quarter, ...
	
	      case 'QQQQ':
	      default:
	        return localize.quarter(quarter, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // Stand-alone quarter
	  q: function (date, token, localize) {
	    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
	
	    switch (token) {
	      // 1, 2, 3, 4
	      case 'q':
	        return String(quarter);
	      // 01, 02, 03, 04
	
	      case 'qq':
	        return (0, _index6.default)(quarter, 2);
	      // 1st, 2nd, 3rd, 4th
	
	      case 'qo':
	        return localize.ordinalNumber(quarter, {
	          unit: 'quarter'
	        });
	      // Q1, Q2, Q3, Q4
	
	      case 'qqq':
	        return localize.quarter(quarter, {
	          width: 'abbreviated',
	          context: 'standalone'
	        });
	      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
	
	      case 'qqqqq':
	        return localize.quarter(quarter, {
	          width: 'narrow',
	          context: 'standalone'
	        });
	      // 1st quarter, 2nd quarter, ...
	
	      case 'qqqq':
	      default:
	        return localize.quarter(quarter, {
	          width: 'wide',
	          context: 'standalone'
	        });
	    }
	  },
	  // Month
	  M: function (date, token, localize) {
	    var month = date.getUTCMonth();
	
	    switch (token) {
	      case 'M':
	      case 'MM':
	        return _index7.default.M(date, token);
	      // 1st, 2nd, ..., 12th
	
	      case 'Mo':
	        return localize.ordinalNumber(month + 1, {
	          unit: 'month'
	        });
	      // Jan, Feb, ..., Dec
	
	      case 'MMM':
	        return localize.month(month, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      // J, F, ..., D
	
	      case 'MMMMM':
	        return localize.month(month, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      // January, February, ..., December
	
	      case 'MMMM':
	      default:
	        return localize.month(month, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // Stand-alone month
	  L: function (date, token, localize) {
	    var month = date.getUTCMonth();
	
	    switch (token) {
	      // 1, 2, ..., 12
	      case 'L':
	        return String(month + 1);
	      // 01, 02, ..., 12
	
	      case 'LL':
	        return (0, _index6.default)(month + 1, 2);
	      // 1st, 2nd, ..., 12th
	
	      case 'Lo':
	        return localize.ordinalNumber(month + 1, {
	          unit: 'month'
	        });
	      // Jan, Feb, ..., Dec
	
	      case 'LLL':
	        return localize.month(month, {
	          width: 'abbreviated',
	          context: 'standalone'
	        });
	      // J, F, ..., D
	
	      case 'LLLLL':
	        return localize.month(month, {
	          width: 'narrow',
	          context: 'standalone'
	        });
	      // January, February, ..., December
	
	      case 'LLLL':
	      default:
	        return localize.month(month, {
	          width: 'wide',
	          context: 'standalone'
	        });
	    }
	  },
	  // Local week of year
	  w: function (date, token, localize, options) {
	    var week = (0, _index4.default)(date, options);
	
	    if (token === 'wo') {
	      return localize.ordinalNumber(week, {
	        unit: 'week'
	      });
	    }
	
	    return (0, _index6.default)(week, token.length);
	  },
	  // ISO week of year
	  I: function (date, token, localize) {
	    var isoWeek = (0, _index2.default)(date);
	
	    if (token === 'Io') {
	      return localize.ordinalNumber(isoWeek, {
	        unit: 'week'
	      });
	    }
	
	    return (0, _index6.default)(isoWeek, token.length);
	  },
	  // Day of the month
	  d: function (date, token, localize) {
	    if (token === 'do') {
	      return localize.ordinalNumber(date.getUTCDate(), {
	        unit: 'date'
	      });
	    }
	
	    return _index7.default.d(date, token);
	  },
	  // Day of year
	  D: function (date, token, localize) {
	    var dayOfYear = (0, _index.default)(date);
	
	    if (token === 'Do') {
	      return localize.ordinalNumber(dayOfYear, {
	        unit: 'dayOfYear'
	      });
	    }
	
	    return (0, _index6.default)(dayOfYear, token.length);
	  },
	  // Day of week
	  E: function (date, token, localize) {
	    var dayOfWeek = date.getUTCDay();
	
	    switch (token) {
	      // Tue
	      case 'E':
	      case 'EE':
	      case 'EEE':
	        return localize.day(dayOfWeek, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      // T
	
	      case 'EEEEE':
	        return localize.day(dayOfWeek, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      // Tu
	
	      case 'EEEEEE':
	        return localize.day(dayOfWeek, {
	          width: 'short',
	          context: 'formatting'
	        });
	      // Tuesday
	
	      case 'EEEE':
	      default:
	        return localize.day(dayOfWeek, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // Local day of week
	  e: function (date, token, localize, options) {
	    var dayOfWeek = date.getUTCDay();
	    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
	
	    switch (token) {
	      // Numerical value (Nth day of week with current locale or weekStartsOn)
	      case 'e':
	        return String(localDayOfWeek);
	      // Padded numerical value
	
	      case 'ee':
	        return (0, _index6.default)(localDayOfWeek, 2);
	      // 1st, 2nd, ..., 7th
	
	      case 'eo':
	        return localize.ordinalNumber(localDayOfWeek, {
	          unit: 'day'
	        });
	
	      case 'eee':
	        return localize.day(dayOfWeek, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      // T
	
	      case 'eeeee':
	        return localize.day(dayOfWeek, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      // Tu
	
	      case 'eeeeee':
	        return localize.day(dayOfWeek, {
	          width: 'short',
	          context: 'formatting'
	        });
	      // Tuesday
	
	      case 'eeee':
	      default:
	        return localize.day(dayOfWeek, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // Stand-alone local day of week
	  c: function (date, token, localize, options) {
	    var dayOfWeek = date.getUTCDay();
	    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
	
	    switch (token) {
	      // Numerical value (same as in `e`)
	      case 'c':
	        return String(localDayOfWeek);
	      // Padded numerical value
	
	      case 'cc':
	        return (0, _index6.default)(localDayOfWeek, token.length);
	      // 1st, 2nd, ..., 7th
	
	      case 'co':
	        return localize.ordinalNumber(localDayOfWeek, {
	          unit: 'day'
	        });
	
	      case 'ccc':
	        return localize.day(dayOfWeek, {
	          width: 'abbreviated',
	          context: 'standalone'
	        });
	      // T
	
	      case 'ccccc':
	        return localize.day(dayOfWeek, {
	          width: 'narrow',
	          context: 'standalone'
	        });
	      // Tu
	
	      case 'cccccc':
	        return localize.day(dayOfWeek, {
	          width: 'short',
	          context: 'standalone'
	        });
	      // Tuesday
	
	      case 'cccc':
	      default:
	        return localize.day(dayOfWeek, {
	          width: 'wide',
	          context: 'standalone'
	        });
	    }
	  },
	  // ISO day of week
	  i: function (date, token, localize) {
	    var dayOfWeek = date.getUTCDay();
	    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
	
	    switch (token) {
	      // 2
	      case 'i':
	        return String(isoDayOfWeek);
	      // 02
	
	      case 'ii':
	        return (0, _index6.default)(isoDayOfWeek, token.length);
	      // 2nd
	
	      case 'io':
	        return localize.ordinalNumber(isoDayOfWeek, {
	          unit: 'day'
	        });
	      // Tue
	
	      case 'iii':
	        return localize.day(dayOfWeek, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      // T
	
	      case 'iiiii':
	        return localize.day(dayOfWeek, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      // Tu
	
	      case 'iiiiii':
	        return localize.day(dayOfWeek, {
	          width: 'short',
	          context: 'formatting'
	        });
	      // Tuesday
	
	      case 'iiii':
	      default:
	        return localize.day(dayOfWeek, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // AM or PM
	  a: function (date, token, localize) {
	    var hours = date.getUTCHours();
	    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
	
	    switch (token) {
	      case 'a':
	      case 'aa':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	
	      case 'aaa':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'abbreviated',
	          context: 'formatting'
	        }).toLowerCase();
	
	      case 'aaaaa':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	
	      case 'aaaa':
	      default:
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // AM, PM, midnight, noon
	  b: function (date, token, localize) {
	    var hours = date.getUTCHours();
	    var dayPeriodEnumValue;
	
	    if (hours === 12) {
	      dayPeriodEnumValue = dayPeriodEnum.noon;
	    } else if (hours === 0) {
	      dayPeriodEnumValue = dayPeriodEnum.midnight;
	    } else {
	      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
	    }
	
	    switch (token) {
	      case 'b':
	      case 'bb':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	
	      case 'bbb':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'abbreviated',
	          context: 'formatting'
	        }).toLowerCase();
	
	      case 'bbbbb':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	
	      case 'bbbb':
	      default:
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // in the morning, in the afternoon, in the evening, at night
	  B: function (date, token, localize) {
	    var hours = date.getUTCHours();
	    var dayPeriodEnumValue;
	
	    if (hours >= 17) {
	      dayPeriodEnumValue = dayPeriodEnum.evening;
	    } else if (hours >= 12) {
	      dayPeriodEnumValue = dayPeriodEnum.afternoon;
	    } else if (hours >= 4) {
	      dayPeriodEnumValue = dayPeriodEnum.morning;
	    } else {
	      dayPeriodEnumValue = dayPeriodEnum.night;
	    }
	
	    switch (token) {
	      case 'B':
	      case 'BB':
	      case 'BBB':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	
	      case 'BBBBB':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	
	      case 'BBBB':
	      default:
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // Hour [1-12]
	  h: function (date, token, localize) {
	    if (token === 'ho') {
	      var hours = date.getUTCHours() % 12;
	      if (hours === 0) hours = 12;
	      return localize.ordinalNumber(hours, {
	        unit: 'hour'
	      });
	    }
	
	    return _index7.default.h(date, token);
	  },
	  // Hour [0-23]
	  H: function (date, token, localize) {
	    if (token === 'Ho') {
	      return localize.ordinalNumber(date.getUTCHours(), {
	        unit: 'hour'
	      });
	    }
	
	    return _index7.default.H(date, token);
	  },
	  // Hour [0-11]
	  K: function (date, token, localize) {
	    var hours = date.getUTCHours() % 12;
	
	    if (token === 'Ko') {
	      return localize.ordinalNumber(hours, {
	        unit: 'hour'
	      });
	    }
	
	    return (0, _index6.default)(hours, token.length);
	  },
	  // Hour [1-24]
	  k: function (date, token, localize) {
	    var hours = date.getUTCHours();
	    if (hours === 0) hours = 24;
	
	    if (token === 'ko') {
	      return localize.ordinalNumber(hours, {
	        unit: 'hour'
	      });
	    }
	
	    return (0, _index6.default)(hours, token.length);
	  },
	  // Minute
	  m: function (date, token, localize) {
	    if (token === 'mo') {
	      return localize.ordinalNumber(date.getUTCMinutes(), {
	        unit: 'minute'
	      });
	    }
	
	    return _index7.default.m(date, token);
	  },
	  // Second
	  s: function (date, token, localize) {
	    if (token === 'so') {
	      return localize.ordinalNumber(date.getUTCSeconds(), {
	        unit: 'second'
	      });
	    }
	
	    return _index7.default.s(date, token);
	  },
	  // Fraction of second
	  S: function (date, token) {
	    return _index7.default.S(date, token);
	  },
	  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
	  X: function (date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timezoneOffset = originalDate.getTimezoneOffset();
	
	    if (timezoneOffset === 0) {
	      return 'Z';
	    }
	
	    switch (token) {
	      // Hours and optional minutes
	      case 'X':
	        return formatTimezoneWithOptionalMinutes(timezoneOffset);
	      // Hours, minutes and optional seconds without `:` delimiter
	      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
	      // so this token always has the same output as `XX`
	
	      case 'XXXX':
	      case 'XX':
	        // Hours and minutes without `:` delimiter
	        return formatTimezone(timezoneOffset);
	      // Hours, minutes and optional seconds with `:` delimiter
	      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
	      // so this token always has the same output as `XXX`
	
	      case 'XXXXX':
	      case 'XXX': // Hours and minutes with `:` delimiter
	
	      default:
	        return formatTimezone(timezoneOffset, ':');
	    }
	  },
	  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
	  x: function (date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timezoneOffset = originalDate.getTimezoneOffset();
	
	    switch (token) {
	      // Hours and optional minutes
	      case 'x':
	        return formatTimezoneWithOptionalMinutes(timezoneOffset);
	      // Hours, minutes and optional seconds without `:` delimiter
	      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
	      // so this token always has the same output as `xx`
	
	      case 'xxxx':
	      case 'xx':
	        // Hours and minutes without `:` delimiter
	        return formatTimezone(timezoneOffset);
	      // Hours, minutes and optional seconds with `:` delimiter
	      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
	      // so this token always has the same output as `xxx`
	
	      case 'xxxxx':
	      case 'xxx': // Hours and minutes with `:` delimiter
	
	      default:
	        return formatTimezone(timezoneOffset, ':');
	    }
	  },
	  // Timezone (GMT)
	  O: function (date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timezoneOffset = originalDate.getTimezoneOffset();
	
	    switch (token) {
	      // Short
	      case 'O':
	      case 'OO':
	      case 'OOO':
	        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
	      // Long
	
	      case 'OOOO':
	      default:
	        return 'GMT' + formatTimezone(timezoneOffset, ':');
	    }
	  },
	  // Timezone (specific non-location)
	  z: function (date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timezoneOffset = originalDate.getTimezoneOffset();
	
	    switch (token) {
	      // Short
	      case 'z':
	      case 'zz':
	      case 'zzz':
	        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
	      // Long
	
	      case 'zzzz':
	      default:
	        return 'GMT' + formatTimezone(timezoneOffset, ':');
	    }
	  },
	  // Seconds timestamp
	  t: function (date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timestamp = Math.floor(originalDate.getTime() / 1000);
	    return (0, _index6.default)(timestamp, token.length);
	  },
	  // Milliseconds timestamp
	  T: function (date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timestamp = originalDate.getTime();
	    return (0, _index6.default)(timestamp, token.length);
	  }
	};
	
	function formatTimezoneShort(offset, dirtyDelimiter) {
	  var sign = offset > 0 ? '-' : '+';
	  var absOffset = Math.abs(offset);
	  var hours = Math.floor(absOffset / 60);
	  var minutes = absOffset % 60;
	
	  if (minutes === 0) {
	    return sign + String(hours);
	  }
	
	  var delimiter = dirtyDelimiter || '';
	  return sign + String(hours) + delimiter + (0, _index6.default)(minutes, 2);
	}
	
	function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
	  if (offset % 60 === 0) {
	    var sign = offset > 0 ? '-' : '+';
	    return sign + (0, _index6.default)(Math.abs(offset) / 60, 2);
	  }
	
	  return formatTimezone(offset, dirtyDelimiter);
	}
	
	function formatTimezone(offset, dirtyDelimiter) {
	  var delimiter = dirtyDelimiter || '';
	  var sign = offset > 0 ? '-' : '+';
	  var absOffset = Math.abs(offset);
	  var hours = (0, _index6.default)(Math.floor(absOffset / 60), 2);
	  var minutes = (0, _index6.default)(absOffset % 60, 2);
	  return sign + hours + delimiter + minutes;
	}
	
	var _default = formatters;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1535 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUTCDayOfYear;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_DAY = 86400000; // This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	
	function getUTCDayOfYear(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var timestamp = date.getTime();
	  date.setUTCMonth(0, 1);
	  date.setUTCHours(0, 0, 0, 0);
	  var startOfYearTimestamp = date.getTime();
	  var difference = timestamp - startOfYearTimestamp;
	  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
	}
	
	module.exports = exports.default;

/***/ },
/* 1536 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setUTCDay;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	var _index3 = _interopRequireDefault(__webpack_require__(26));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function setUTCDay(dirtyDate, dirtyDay, dirtyOptions) {
	  (0, _index2.default)(2, arguments);
	  var options = dirtyOptions || {};
	  var locale = options.locale;
	  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
	  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, _index3.default)(localeWeekStartsOn);
	  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, _index3.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	
	  var date = (0, _index.default)(dirtyDate);
	  var day = (0, _index3.default)(dirtyDay);
	  var currentDay = date.getUTCDay();
	  var remainder = day % 7;
	  var dayIndex = (remainder + 7) % 7;
	  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
	  date.setUTCDate(date.getUTCDate() + diff);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 1537 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setUTCISODay;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	var _index3 = _interopRequireDefault(__webpack_require__(26));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function setUTCISODay(dirtyDate, dirtyDay) {
	  (0, _index2.default)(2, arguments);
	  var day = (0, _index3.default)(dirtyDay);
	
	  if (day % 7 === 0) {
	    day = day - 7;
	  }
	
	  var weekStartsOn = 1;
	  var date = (0, _index.default)(dirtyDate);
	  var currentDay = date.getUTCDay();
	  var remainder = day % 7;
	  var dayIndex = (remainder + 7) % 7;
	  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
	  date.setUTCDate(date.getUTCDate() + diff);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 1538 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setUTCISOWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(26));
	
	var _index2 = _interopRequireDefault(__webpack_require__(9));
	
	var _index3 = _interopRequireDefault(__webpack_require__(621));
	
	var _index4 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function setUTCISOWeek(dirtyDate, dirtyISOWeek) {
	  (0, _index4.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var isoWeek = (0, _index.default)(dirtyISOWeek);
	  var diff = (0, _index3.default)(date) - isoWeek;
	  date.setUTCDate(date.getUTCDate() - diff * 7);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 1539 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setUTCWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(26));
	
	var _index2 = _interopRequireDefault(__webpack_require__(9));
	
	var _index3 = _interopRequireDefault(__webpack_require__(622));
	
	var _index4 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function setUTCWeek(dirtyDate, dirtyWeek, options) {
	  (0, _index4.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var week = (0, _index.default)(dirtyWeek);
	  var diff = (0, _index3.default)(date, options) - week;
	  date.setUTCDate(date.getUTCDate() - diff * 7);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 1540 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfUTCISOWeekYear;
	
	var _index = _interopRequireDefault(__webpack_require__(620));
	
	var _index2 = _interopRequireDefault(__webpack_require__(259));
	
	var _index3 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function startOfUTCISOWeekYear(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  var year = (0, _index.default)(dirtyDate);
	  var fourthOfJanuary = new Date(0);
	  fourthOfJanuary.setUTCFullYear(year, 0, 4);
	  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
	  var date = (0, _index2.default)(fourthOfJanuary);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 1541 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfUTCWeekYear;
	
	var _index = _interopRequireDefault(__webpack_require__(383));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	var _index3 = _interopRequireDefault(__webpack_require__(260));
	
	var _index4 = _interopRequireDefault(__webpack_require__(26));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function startOfUTCWeekYear(dirtyDate, dirtyOptions) {
	  (0, _index2.default)(1, arguments);
	  var options = dirtyOptions || {};
	  var locale = options.locale;
	  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
	  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, _index4.default)(localeFirstWeekContainsDate);
	  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, _index4.default)(options.firstWeekContainsDate);
	  var year = (0, _index.default)(dirtyDate, dirtyOptions);
	  var firstWeek = new Date(0);
	  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
	  firstWeek.setUTCHours(0, 0, 0, 0);
	  var date = (0, _index3.default)(firstWeek, dirtyOptions);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 1542 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = add;
	
	var _index = _interopRequireDefault(__webpack_require__(95));
	
	var _index2 = _interopRequireDefault(__webpack_require__(170));
	
	var _index3 = _interopRequireDefault(__webpack_require__(9));
	
	var _index4 = _interopRequireDefault(__webpack_require__(6));
	
	var _index5 = _interopRequireDefault(__webpack_require__(26));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name add
	 * @category Common Helpers
	 * @summary Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
	 *
	 * @description
	 * Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Duration} duration - the object with years, months, weeks, days, hours, minutes and seconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 *
	 * | Key            | Description                        |
	 * |----------------|------------------------------------|
	 * | years          | Amount of years to be added        |
	 * | months         | Amount of months to be added       |
	 * | weeks          | Amount of weeks to be added        |
	 * | days           | Amount of days to be added         |
	 * | hours          | Amount of hours to be added        |
	 * | minutes        | Amount of minutes to be added      |
	 * | seconds        | Amount of seconds to be added      |
	 *
	 * All values default to 0
	 *
	 * @returns {Date} the new date with the seconds added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add the following duration to 1 September 2014, 10:19:50
	 * const result = add(new Date(2014, 8, 1, 10, 19, 50), {
	 *   years: 2,
	 *   months: 9,
	 *   weeks: 1,
	 *   days: 7,
	 *   hours: 5,
	 *   minutes: 9,
	 *   seconds: 30,
	 * })
	 * //=> Thu Jun 15 2017 15:29:20
	 */
	function add(dirtyDate, duration) {
	  (0, _index4.default)(2, arguments);
	  if (!duration || typeof duration !== 'object') return new Date(NaN);
	  var years = duration.years ? (0, _index5.default)(duration.years) : 0;
	  var months = duration.months ? (0, _index5.default)(duration.months) : 0;
	  var weeks = duration.weeks ? (0, _index5.default)(duration.weeks) : 0;
	  var days = duration.days ? (0, _index5.default)(duration.days) : 0;
	  var hours = duration.hours ? (0, _index5.default)(duration.hours) : 0;
	  var minutes = duration.minutes ? (0, _index5.default)(duration.minutes) : 0;
	  var seconds = duration.seconds ? (0, _index5.default)(duration.seconds) : 0; // Add years and months
	
	  var date = (0, _index3.default)(dirtyDate);
	  var dateWithMonths = months || years ? (0, _index2.default)(date, months + years * 12) : date; // Add weeks and days
	
	  var dateWithDays = days || weeks ? (0, _index.default)(dateWithMonths, days + weeks * 7) : dateWithMonths; // Add days, hours, minutes and seconds
	
	  var minutesToAdd = minutes + hours * 60;
	  var secondsToAdd = seconds + minutesToAdd * 60;
	  var msToAdd = secondsToAdd * 1000;
	  var finalDate = new Date(dateWithDays.getTime() + msToAdd);
	  return finalDate;
	}
	
	module.exports = exports.default;

/***/ },
/* 1543 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = areIntervalsOverlapping;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name areIntervalsOverlapping
	 * @category Interval Helpers
	 * @summary Is the given time interval overlapping with another time interval?
	 *
	 * @description
	 * Is the given time interval overlapping with another time interval? Adjacent intervals do not count as overlapping.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `areRangesOverlapping` to `areIntervalsOverlapping`.
	 *   This change was made to mirror the use of the word "interval" in standard ISO 8601:2004 terminology:
	 *
	 *   ```
	 *   2.1.3
	 *   time interval
	 *   part of the time axis limited by two instants
	 *   ```
	 *
	 *   Also, this function now accepts an object with `start` and `end` properties
	 *   instead of two arguments as an interval.
	 *   This function now throws `RangeError` if the start of the interval is after its end
	 *   or if any date in the interval is `Invalid Date`.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *
	 *   areRangesOverlapping(
	 *     new Date(2014, 0, 10), new Date(2014, 0, 20),
	 *     new Date(2014, 0, 17), new Date(2014, 0, 21)
	 *   )
	 *
	 *   // v2.0.0 onward
	 *
	 *   areIntervalsOverlapping(
	 *     { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
	 *     { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
	 *   )
	 *   ```
	 *
	 * @param {Interval} intervalLeft - the first interval to compare. See [Interval]{@link https://date-fns.org/docs/Interval}
	 * @param {Interval} intervalRight - the second interval to compare. See [Interval]{@link https://date-fns.org/docs/Interval}
	 * @param {Object} [options] - the object with options
	 * @param {Boolean} [options.inclusive=false] - whether the comparison is inclusive or not
	 * @returns {Boolean} whether the time intervals are overlapping
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // For overlapping time intervals:
	 * areIntervalsOverlapping(
	 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
	 *   { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
	 * )
	 * //=> true
	 *
	 * @example
	 * // For non-overlapping time intervals:
	 * areIntervalsOverlapping(
	 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
	 *   { start: new Date(2014, 0, 21), end: new Date(2014, 0, 22) }
	 * )
	 * //=> false
	 *
	 * @example
	 * // For adjacent time intervals:
	 * areIntervalsOverlapping(
	 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
	 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 30) }
	 * )
	 * //=> false
	 *
	 * @example
	 * // Using the inclusive option:
	 * areIntervalsOverlapping(
	 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
	 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 24) }
	 * )
	 * //=> false
	 * areIntervalsOverlapping(
	 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
	 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 24) },
	 *   { inclusive: true }
	 * )
	 * //=> true
	 */
	function areIntervalsOverlapping(dirtyIntervalLeft, dirtyIntervalRight) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
	    inclusive: false
	  };
	  (0, _index2.default)(2, arguments);
	  var intervalLeft = dirtyIntervalLeft || {};
	  var intervalRight = dirtyIntervalRight || {};
	  var leftStartTime = (0, _index.default)(intervalLeft.start).getTime();
	  var leftEndTime = (0, _index.default)(intervalLeft.end).getTime();
	  var rightStartTime = (0, _index.default)(intervalRight.start).getTime();
	  var rightEndTime = (0, _index.default)(intervalRight.end).getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`
	
	  if (!(leftStartTime <= leftEndTime && rightStartTime <= rightEndTime)) {
	    throw new RangeError('Invalid interval');
	  }
	
	  if (options.inclusive) {
	    return leftStartTime <= rightEndTime && rightStartTime <= leftEndTime;
	  }
	
	  return leftStartTime < rightEndTime && rightStartTime < leftEndTime;
	}
	
	module.exports = exports.default;

/***/ },
/* 1544 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = clamp;
	
	var _index = _interopRequireDefault(__webpack_require__(409));
	
	var _index2 = _interopRequireDefault(__webpack_require__(410));
	
	var _index3 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name clamp
	 * @category Interval Helpers
	 * @summary Return a date bounded by the start and the end of the given interval
	 *
	 * @description
	 * Clamps a date to the lower bound with the start of the interval and the upper
	 * bound with the end of the interval.
	 *
	 * - When the date is less than the start of the interval, the start is returned.
	 * - When the date is greater than the end of the interval, the end is returned.
	 * - Otherwise the date is returned.
	 *
	 * @example
	 * // What is Mar, 21, 2021 bounded to an interval starting at Mar, 22, 2021 and ending at Apr, 01, 2021
	 * const result = clamp(new Date(2021, 2, 21), {
	 *   start: new Date(2021, 2, 22),
	 *   end: new Date(2021, 3, 1),
	 * })
	 * //=> Mon Mar 22 2021 00:00:00
	 *
	 * @param {Date | Number} date - the date to be bounded
	 * @param {Interval} interval - the interval to bound to
	 * @returns {Date} the date bounded by the start and the end of the interval
	 * @throws {TypeError} 2 arguments required
	 */
	function clamp(date, _ref) {
	  var start = _ref.start,
	      end = _ref.end;
	  (0, _index3.default)(2, arguments);
	  return (0, _index2.default)([(0, _index.default)([date, start]), end]);
	}
	
	module.exports = exports.default;

/***/ },
/* 1545 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = closestIndexTo;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name closestIndexTo
	 * @category Common Helpers
	 * @summary Return an index of the closest date from the array comparing to the given date.
	 *
	 * @description
	 * Return an index of the closest date from the array comparing to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - Now, `closestIndexTo` doesn't throw an exception
	 *   when the second argument is not an array, and returns Invalid Date instead.
	 *
	 * @param {Date | Number} dateToCompare - the date to compare with
	 * @param {Array<Date> | Array<number>} datesArray - the array to search
	 * @returns {Number | undefined} an index of the date closest to the given date or undefined if no valid value is given
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Which date is closer to 6 September 2015?
	 * const dateToCompare = new Date(2015, 8, 6)
	 * const datesArray = [
	 *   new Date(2015, 0, 1),
	 *   new Date(2016, 0, 1),
	 *   new Date(2017, 0, 1)
	 * ]
	 * const result = closestIndexTo(dateToCompare, datesArray)
	 * //=> 1
	 */
	function closestIndexTo(dirtyDateToCompare, dirtyDatesArray) {
	  (0, _index2.default)(2, arguments);
	  var dateToCompare = (0, _index.default)(dirtyDateToCompare);
	  if (isNaN(Number(dateToCompare))) return NaN;
	  var timeToCompare = dateToCompare.getTime();
	  var datesArray; // `dirtyDatesArray` is undefined or null
	
	  if (dirtyDatesArray == null) {
	    datesArray = []; // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
	  } else if (typeof dirtyDatesArray.forEach === 'function') {
	    datesArray = dirtyDatesArray; // If `dirtyDatesArray` is Array-like Object, convert to Array. Otherwise, make it empty Array
	  } else {
	    datesArray = Array.prototype.slice.call(dirtyDatesArray);
	  }
	
	  var result;
	  var minDistance;
	  datesArray.forEach(function (dirtyDate, index) {
	    var currentDate = (0, _index.default)(dirtyDate);
	
	    if (isNaN(Number(currentDate))) {
	      result = NaN;
	      minDistance = NaN;
	      return;
	    }
	
	    var distance = Math.abs(timeToCompare - currentDate.getTime());
	
	    if (result == null || distance < Number(minDistance)) {
	      result = index;
	      minDistance = distance;
	    }
	  });
	  return result;
	}
	
	module.exports = exports.default;

/***/ },
/* 1546 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = closestTo;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name closestTo
	 * @category Common Helpers
	 * @summary Return a date from the array closest to the given date.
	 *
	 * @description
	 * Return a date from the array closest to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - Now, `closestTo` doesn't throw an exception
	 *   when the second argument is not an array, and returns Invalid Date instead.
	 *
	 * @param {Date | Number} dateToCompare - the date to compare with
	 * @param {Array<Date> | Array<number>} datesArray - the array to search
	 * @returns {Date | undefined} the date from the array closest to the given date or undefined if no valid value is given
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Which date is closer to 6 September 2015: 1 January 2000 or 1 January 2030?
	 * const dateToCompare = new Date(2015, 8, 6)
	 * const result = closestTo(dateToCompare, [
	 *   new Date(2000, 0, 1),
	 *   new Date(2030, 0, 1)
	 * ])
	 * //=> Tue Jan 01 2030 00:00:00
	 */
	function closestTo(dirtyDateToCompare, dirtyDatesArray) {
	  (0, _index2.default)(2, arguments);
	  var dateToCompare = (0, _index.default)(dirtyDateToCompare);
	  if (isNaN(Number(dateToCompare))) return new Date(NaN);
	  var timeToCompare = dateToCompare.getTime();
	  var datesArray; // `dirtyDatesArray` is undefined or null
	
	  if (dirtyDatesArray == null) {
	    datesArray = []; // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
	  } else if (typeof dirtyDatesArray.forEach === 'function') {
	    datesArray = dirtyDatesArray; // If `dirtyDatesArray` is Array-like Object, convert to Array. Otherwise, make it empty Array
	  } else {
	    datesArray = Array.prototype.slice.call(dirtyDatesArray);
	  }
	
	  var result;
	  var minDistance;
	  datesArray.forEach(function (dirtyDate) {
	    var currentDate = (0, _index.default)(dirtyDate);
	
	    if (isNaN(Number(currentDate))) {
	      result = new Date(NaN);
	      minDistance = NaN;
	      return;
	    }
	
	    var distance = Math.abs(timeToCompare - currentDate.getTime());
	
	    if (result == null || distance < Number(minDistance)) {
	      result = currentDate;
	      minDistance = distance;
	    }
	  });
	  return result;
	}
	
	module.exports = exports.default;

/***/ },
/* 1547 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = compareDesc;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name compareDesc
	 * @category Common Helpers
	 * @summary Compare the two dates reverse chronologically and return -1, 0 or 1.
	 *
	 * @description
	 * Compare the two dates and return -1 if the first date is after the second,
	 * 1 if the first date is before the second or 0 if dates are equal.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the first date to compare
	 * @param {Date|Number} dateRight - the second date to compare
	 * @returns {Number} the result of the comparison
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Compare 11 February 1987 and 10 July 1989 reverse chronologically:
	 * const result = compareDesc(new Date(1987, 1, 11), new Date(1989, 6, 10))
	 * //=> 1
	 *
	 * @example
	 * // Sort the array of dates in reverse chronological order:
	 * const result = [
	 *   new Date(1995, 6, 2),
	 *   new Date(1987, 1, 11),
	 *   new Date(1989, 6, 10)
	 * ].sort(compareDesc)
	 * //=> [
	 * //   Sun Jul 02 1995 00:00:00,
	 * //   Mon Jul 10 1989 00:00:00,
	 * //   Wed Feb 11 1987 00:00:00
	 * // ]
	 */
	function compareDesc(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  var diff = dateLeft.getTime() - dateRight.getTime();
	
	  if (diff > 0) {
	    return -1;
	  } else if (diff < 0) {
	    return 1; // Return 0 if diff is 0; return NaN if diff is NaN
	  } else {
	    return diff;
	  }
	}
	
	module.exports = exports.default;

/***/ },
/* 1548 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = daysToWeeks;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	var _index2 = __webpack_require__(45);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name daysToWeeks
	 * @category Conversion Helpers
	 * @summary Convert days to weeks.
	 *
	 * @description
	 * Convert a number of days to a full number of weeks.
	 *
	 * @param {number} days - number of days to be converted
	 *
	 * @returns {number} the number of days converted in weeks
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 14 days to weeks:
	 * const result = daysToWeeks(14)
	 * //=> 2
	 *
	 * @example
	 * // It uses floor rounding:
	 * const result = daysToWeeks(13)
	 * //=> 1
	 */
	function daysToWeeks(days) {
	  (0, _index.default)(1, arguments);
	  var weeks = days / _index2.daysInWeek;
	  return Math.floor(weeks);
	}
	
	module.exports = exports.default;

/***/ },
/* 1549 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInBusinessDays;
	
	var _index = _interopRequireDefault(__webpack_require__(95));
	
	var _index2 = _interopRequireDefault(__webpack_require__(120));
	
	var _index3 = _interopRequireDefault(__webpack_require__(172));
	
	var _index4 = _interopRequireDefault(__webpack_require__(96));
	
	var _index5 = _interopRequireDefault(__webpack_require__(267));
	
	var _index6 = _interopRequireDefault(__webpack_require__(9));
	
	var _index7 = _interopRequireDefault(__webpack_require__(6));
	
	var _index8 = _interopRequireDefault(__webpack_require__(26));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInBusinessDays
	 * @category Day Helpers
	 * @summary Get the number of business days between the given dates.
	 *
	 * @description
	 * Get the number of business day periods between the given dates.
	 * Business days being days that arent in the weekend.
	 * Like `differenceInCalendarDays`, the function removes the times from
	 * the dates before calculating the difference.
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of business days
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many business days are between
	 * // 10 January 2014 and 20 July 2014?
	 * const result = differenceInBusinessDays(
	 *   new Date(2014, 6, 20),
	 *   new Date(2014, 0, 10)
	 * )
	 * //=> 136
	 *
	 * // How many business days are between
	 * // 1 November 2021 and 30 November 2021?
	 * const result = differenceInBusinessDays(
	 *   new Date(2021, 10, 1),
	 *   new Date(2021, 10, 30)
	 * )
	 * //=> 21
	 *
	 * // How many business days are between
	 * // 1 November 2021 and 1 December 2021?
	 * const result = differenceInBusinessDays(
	 *   new Date(2021, 10, 1),
	 *   new Date(2021, 11, 1)
	 * )
	 * //=> 22
	 *
	 * // How many business days are between
	 * // 1 November 2021 and 1 November 2021 ?
	 * const result = differenceInBusinessDays(
	 *   new Date(2021, 10, 1),
	 *   new Date(2021, 10, 1)
	 * )
	 * //=> 0
	 */
	function differenceInBusinessDays(dirtyDateLeft, dirtyDateRight) {
	  (0, _index7.default)(2, arguments);
	  var dateLeft = (0, _index6.default)(dirtyDateLeft);
	  var dateRight = (0, _index6.default)(dirtyDateRight);
	  if (!(0, _index4.default)(dateLeft) || !(0, _index4.default)(dateRight)) return NaN;
	  var calendarDifference = (0, _index2.default)(dateLeft, dateRight);
	  var sign = calendarDifference < 0 ? -1 : 1;
	  var weeks = (0, _index8.default)(calendarDifference / 7);
	  var result = weeks * 5;
	  dateRight = (0, _index.default)(dateRight, weeks * 7); // the loop below will run at most 6 times to account for the remaining days that don't makeup a full week
	
	  while (!(0, _index3.default)(dateLeft, dateRight)) {
	    // sign is used to account for both negative and positive differences
	    result += (0, _index5.default)(dateRight) ? 0 : sign;
	    dateRight = (0, _index.default)(dateRight, sign);
	  }
	
	  return result === 0 ? 0 : result;
	}
	
	module.exports = exports.default;

/***/ },
/* 1550 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInCalendarISOWeeks;
	
	var _index = _interopRequireDefault(__webpack_require__(107));
	
	var _index2 = _interopRequireDefault(__webpack_require__(148));
	
	var _index3 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_WEEK = 604800000;
	/**
	 * @name differenceInCalendarISOWeeks
	 * @category ISO Week Helpers
	 * @summary Get the number of calendar ISO weeks between the given dates.
	 *
	 * @description
	 * Get the number of calendar ISO weeks between the given dates.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of calendar ISO weeks
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many calendar ISO weeks are between 6 July 2014 and 21 July 2014?
	 * const result = differenceInCalendarISOWeeks(
	 *   new Date(2014, 6, 21),
	 *   new Date(2014, 6, 6)
	 * )
	 * //=> 3
	 */
	
	function differenceInCalendarISOWeeks(dirtyDateLeft, dirtyDateRight) {
	  (0, _index3.default)(2, arguments);
	  var startOfISOWeekLeft = (0, _index2.default)(dirtyDateLeft);
	  var startOfISOWeekRight = (0, _index2.default)(dirtyDateRight);
	  var timestampLeft = startOfISOWeekLeft.getTime() - (0, _index.default)(startOfISOWeekLeft);
	  var timestampRight = startOfISOWeekRight.getTime() - (0, _index.default)(startOfISOWeekRight); // Round the number of days to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	
	  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK);
	}
	
	module.exports = exports.default;

/***/ },
/* 1551 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInCalendarQuarters;
	
	var _index = _interopRequireDefault(__webpack_require__(395));
	
	var _index2 = _interopRequireDefault(__webpack_require__(9));
	
	var _index3 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInCalendarQuarters
	 * @category Quarter Helpers
	 * @summary Get the number of calendar quarters between the given dates.
	 *
	 * @description
	 * Get the number of calendar quarters between the given dates.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of calendar quarters
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many calendar quarters are between 31 December 2013 and 2 July 2014?
	 * var result = differenceInCalendarQuarters(
	 *   new Date(2014, 6, 2),
	 *   new Date(2013, 11, 31)
	 * )
	 * //=> 3
	 */
	function differenceInCalendarQuarters(dirtyDateLeft, dirtyDateRight) {
	  (0, _index3.default)(2, arguments);
	  var dateLeft = (0, _index2.default)(dirtyDateLeft);
	  var dateRight = (0, _index2.default)(dirtyDateRight);
	  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
	  var quarterDiff = (0, _index.default)(dateLeft) - (0, _index.default)(dateRight);
	  return yearDiff * 4 + quarterDiff;
	}
	
	module.exports = exports.default;

/***/ },
/* 1552 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInISOWeekYears;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(627));
	
	var _index3 = _interopRequireDefault(__webpack_require__(146));
	
	var _index4 = _interopRequireDefault(__webpack_require__(668));
	
	var _index5 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInISOWeekYears
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Get the number of full ISO week-numbering years between the given dates.
	 *
	 * @description
	 * Get the number of full ISO week-numbering years between the given dates.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `differenceInISOYears` to `differenceInISOWeekYears`.
	 *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
	 *   This change makes the name consistent with
	 *   locale-dependent week-numbering year helpers, e.g., `addWeekYears`.
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of full ISO week-numbering years
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many full ISO week-numbering years are between 1 January 2010 and 1 January 2012?
	 * var result = differenceInISOWeekYears(
	 *   new Date(2012, 0, 1),
	 *   new Date(2010, 0, 1)
	 * )
	 * //=> 1
	 */
	function differenceInISOWeekYears(dirtyDateLeft, dirtyDateRight) {
	  (0, _index5.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  var sign = (0, _index3.default)(dateLeft, dateRight);
	  var difference = Math.abs((0, _index2.default)(dateLeft, dateRight));
	  dateLeft = (0, _index4.default)(dateLeft, sign * difference); // Math.abs(diff in full ISO years - diff in calendar ISO years) === 1
	  // if last calendar ISO year is not full
	  // If so, result must be decreased by 1 in absolute value
	
	  var isLastISOWeekYearNotFull = Number((0, _index3.default)(dateLeft, dateRight) === -sign);
	  var result = sign * (difference - isLastISOWeekYearNotFull); // Prevent negative zero
	
	  return result === 0 ? 0 : result;
	}
	
	module.exports = exports.default;

/***/ },
/* 1553 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInQuarters;
	
	var _index = _interopRequireDefault(__webpack_require__(264));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	var _index3 = __webpack_require__(207);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInQuarters
	 * @category Quarter Helpers
	 * @summary Get the number of quarters between the given dates.
	 *
	 * @description
	 * Get the number of quarters between the given dates.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @param {Object} [options] - an object with options.
	 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
	 * @returns {Number} the number of full quarters
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many full quarters are between 31 December 2013 and 2 July 2014?
	 * const result = differenceInQuarters(new Date(2014, 6, 2), new Date(2013, 11, 31))
	 * //=> 2
	 */
	function differenceInQuarters(dateLeft, dateRight, options) {
	  (0, _index2.default)(2, arguments);
	  var diff = (0, _index.default)(dateLeft, dateRight) / 3;
	  return (0, _index3.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
	}
	
	module.exports = exports.default;

/***/ },
/* 1554 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInWeeks;
	
	var _index = _interopRequireDefault(__webpack_require__(389));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	var _index3 = __webpack_require__(207);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInWeeks
	 * @category Week Helpers
	 * @summary Get the number of full weeks between the given dates.
	 *
	 * @description
	 * Get the number of full weeks between two dates. Fractional weeks are
	 * truncated towards zero by default.
	 *
	 * One "full week" is the distance between a local time in one day to the same
	 * local time 7 days earlier or later. A full week can sometimes be less than
	 * or more than 7*24 hours if a daylight savings change happens between two dates.
	 *
	 * To ignore DST and only measure exact 7*24-hour periods, use this instead:
	 * `Math.floor(differenceInHours(dateLeft, dateRight)/(7*24))|0`.
	 *
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @param {Object} [options] - an object with options.
	 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
	 * @returns {Number} the number of full weeks
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many full weeks are between 5 July 2014 and 20 July 2014?
	 * const result = differenceInWeeks(new Date(2014, 6, 20), new Date(2014, 6, 5))
	 * //=> 2
	 *
	 * // How many full weeks are between
	 * // 1 March 2020 0:00 and 6 June 2020 0:00 ?
	 * // Note: because local time is used, the
	 * // result will always be 8 weeks (54 days),
	 * // even if DST starts and the period has
	 * // only 54*24-1 hours.
	 * const result = differenceInWeeks(
	 *   new Date(2020, 5, 1),
	 *   new Date(2020, 2, 6)
	 * )
	 * //=> 8
	 */
	function differenceInWeeks(dateLeft, dateRight, options) {
	  (0, _index2.default)(2, arguments);
	  var diff = (0, _index.default)(dateLeft, dateRight) / 7;
	  return (0, _index3.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
	}
	
	module.exports = exports.default;

/***/ },
/* 1555 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = eachHourOfInterval;
	
	var _index = _interopRequireDefault(__webpack_require__(261));
	
	var _index2 = _interopRequireDefault(__webpack_require__(9));
	
	var _index3 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name eachHourOfInterval
	 * @category Interval Helpers
	 * @summary Return the array of hours within the specified time interval.
	 *
	 * @description
	 * Return the array of hours within the specified time interval.
	 *
	 * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
	 * @param {Object} [options] - an object with options.
	 * @param {Number} [options.step=1] - the step to increment by. The value should be more than 1.
	 * @returns {Date[]} the array with starts of hours from the hour of the interval start to the hour of the interval end
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.step` must be a number greater than 1
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // Each hour between 6 October 2014, 12:00 and 6 October 2014, 15:00
	 * var result = eachHourOfInterval({
	 *   start: new Date(2014, 9, 6, 12),
	 *   end: new Date(2014, 9, 6, 15)
	 * })
	 * //=> [
	 * //   Mon Oct 06 2014 12:00:00,
	 * //   Mon Oct 06 2014 13:00:00,
	 * //   Mon Oct 06 2014 14:00:00,
	 * //   Mon Oct 06 2014 15:00:00
	 * // ]
	 */
	function eachHourOfInterval(dirtyInterval, options) {
	  (0, _index3.default)(1, arguments);
	  var interval = dirtyInterval || {};
	  var startDate = (0, _index2.default)(interval.start);
	  var endDate = (0, _index2.default)(interval.end);
	  var startTime = startDate.getTime();
	  var endTime = endDate.getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`
	
	  if (!(startTime <= endTime)) {
	    throw new RangeError('Invalid interval');
	  }
	
	  var dates = [];
	  var currentDate = startDate;
	  currentDate.setMinutes(0, 0, 0);
	  var step = options && 'step' in options ? Number(options.step) : 1;
	  if (step < 1 || isNaN(step)) throw new RangeError('`options.step` must be a number greater than 1');
	
	  while (currentDate.getTime() <= endTime) {
	    dates.push((0, _index2.default)(currentDate));
	    currentDate = (0, _index.default)(currentDate, step);
	  }
	
	  return dates;
	}
	
	module.exports = exports.default;

/***/ },
/* 1556 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = eachMinuteOfInterval;
	
	var _index = _interopRequireDefault(__webpack_require__(262));
	
	var _index2 = _interopRequireDefault(__webpack_require__(9));
	
	var _index3 = _interopRequireDefault(__webpack_require__(412));
	
	var _index4 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name eachMinuteOfInterval
	 * @category Interval Helpers
	 * @summary Return the array of minutes within the specified time interval.
	 *
	 * @description
	 * Returns the array of minutes within the specified time interval.
	 *
	 * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
	 * @param {Object} [options] - an object with options.
	 * @param {Number} [options.step=1] - the step to increment by. The starts of minutes from the hour of the interval start to the hour of the interval end
	 * @throws {TypeError} 1 argument requie value should be more than 1.
	 * @returns {Date[]} the array withred
	 * @throws {RangeError} `options.step` must be a number equal or greater than 1
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // Each minute between 14 October 2020, 13:00 and 14 October 2020, 13:03
	 * const result = eachMinuteOfInterval({
	 *   start: new Date(2014, 9, 14, 13),
	 *   end: new Date(2014, 9, 14, 13, 3)
	 * })
	 * //=> [
	 * //   Wed Oct 14 2014 13:00:00,
	 * //   Wed Oct 14 2014 13:01:00,
	 * //   Wed Oct 14 2014 13:02:00,
	 * //   Wed Oct 14 2014 13:03:00
	 * // ]
	 */
	function eachMinuteOfInterval(interval, options) {
	  (0, _index4.default)(1, arguments);
	  var startDate = (0, _index3.default)((0, _index2.default)(interval.start));
	  var endDate = (0, _index2.default)(interval.end);
	  var startTime = startDate.getTime();
	  var endTime = endDate.getTime();
	
	  if (startTime >= endTime) {
	    throw new RangeError('Invalid interval');
	  }
	
	  var dates = [];
	  var currentDate = startDate;
	  var step = options && 'step' in options ? Number(options.step) : 1;
	  if (step < 1 || isNaN(step)) throw new RangeError('`options.step` must be a number equal or greater than 1');
	
	  while (currentDate.getTime() <= endTime) {
	    dates.push((0, _index2.default)(currentDate));
	    currentDate = (0, _index.default)(currentDate, step);
	  }
	
	  return dates;
	}
	
	module.exports = exports.default;

/***/ },
/* 1557 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = eachMonthOfInterval;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name eachMonthOfInterval
	 * @category Interval Helpers
	 * @summary Return the array of months within the specified time interval.
	 *
	 * @description
	 * Return the array of months within the specified time interval.
	 *
	 * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
	 * @returns {Date[]} the array with starts of months from the month of the interval start to the month of the interval end
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // Each month between 6 February 2014 and 10 August 2014:
	 * var result = eachMonthOfInterval({
	 *   start: new Date(2014, 1, 6),
	 *   end: new Date(2014, 7, 10)
	 * })
	 * //=> [
	 * //   Sat Feb 01 2014 00:00:00,
	 * //   Sat Mar 01 2014 00:00:00,
	 * //   Tue Apr 01 2014 00:00:00,
	 * //   Thu May 01 2014 00:00:00,
	 * //   Sun Jun 01 2014 00:00:00,
	 * //   Tue Jul 01 2014 00:00:00,
	 * //   Fri Aug 01 2014 00:00:00
	 * // ]
	 */
	function eachMonthOfInterval(dirtyInterval) {
	  (0, _index2.default)(1, arguments);
	  var interval = dirtyInterval || {};
	  var startDate = (0, _index.default)(interval.start);
	  var endDate = (0, _index.default)(interval.end);
	  var endTime = endDate.getTime();
	  var dates = []; // Throw an exception if start date is after end date or if any date is `Invalid Date`
	
	  if (!(startDate.getTime() <= endTime)) {
	    throw new RangeError('Invalid interval');
	  }
	
	  var currentDate = startDate;
	  currentDate.setHours(0, 0, 0, 0);
	  currentDate.setDate(1);
	
	  while (currentDate.getTime() <= endTime) {
	    dates.push((0, _index.default)(currentDate));
	    currentDate.setMonth(currentDate.getMonth() + 1);
	  }
	
	  return dates;
	}
	
	module.exports = exports.default;

/***/ },
/* 1558 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = eachQuarterOfInterval;
	
	var _index = _interopRequireDefault(__webpack_require__(384));
	
	var _index2 = _interopRequireDefault(__webpack_require__(269));
	
	var _index3 = _interopRequireDefault(__webpack_require__(9));
	
	var _index4 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name eachQuarterOfInterval
	 * @category Interval Helpers
	 * @summary Return the array of quarters within the specified time interval.
	 *
	 * @description
	 * Return the array of quarters within the specified time interval.
	 *
	 * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
	 * @returns {Date[]} the array with starts of quarters from the quarter of the interval start to the quarter of the interval end
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // Each quarter within interval 6 February 2014 - 10 August 2014:
	 * var result = eachQuarterOfInterval({
	 *   start: new Date(2014, 1, 6),
	 *   end: new Date(2014, 7, 10)
	 * })
	 * //=> [
	 * //   Wed Jan 01 2014 00:00:00,
	 * //   Tue Apr 01 2014 00:00:00,
	 * //   Tue Jul 01 2014 00:00:00,
	 * // ]
	 */
	function eachQuarterOfInterval(dirtyInterval) {
	  (0, _index4.default)(1, arguments);
	  var interval = dirtyInterval || {};
	  var startDate = (0, _index3.default)(interval.start);
	  var endDate = (0, _index3.default)(interval.end);
	  var endTime = endDate.getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`
	
	  if (!(startDate.getTime() <= endTime)) {
	    throw new RangeError('Invalid interval');
	  }
	
	  var startDateQuarter = (0, _index2.default)(startDate);
	  var endDateQuarter = (0, _index2.default)(endDate);
	  endTime = endDateQuarter.getTime();
	  var quarters = [];
	  var currentQuarter = startDateQuarter;
	
	  while (currentQuarter.getTime() <= endTime) {
	    quarters.push((0, _index3.default)(currentQuarter));
	    currentQuarter = (0, _index.default)(currentQuarter, 1);
	  }
	
	  return quarters;
	}
	
	module.exports = exports.default;

/***/ },
/* 1559 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = eachWeekOfInterval;
	
	var _index = _interopRequireDefault(__webpack_require__(209));
	
	var _index2 = _interopRequireDefault(__webpack_require__(109));
	
	var _index3 = _interopRequireDefault(__webpack_require__(9));
	
	var _index4 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name eachWeekOfInterval
	 * @category Interval Helpers
	 * @summary Return the array of weeks within the specified time interval.
	 *
	 * @description
	 * Return the array of weeks within the specified time interval.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Date[]} the array with starts of weeks from the week of the interval start to the week of the interval end
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be 0, 1, ..., 6
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // Each week within interval 6 October 2014 - 23 November 2014:
	 * var result = eachWeekOfInterval({
	 *   start: new Date(2014, 9, 6),
	 *   end: new Date(2014, 10, 23)
	 * })
	 * //=> [
	 * //   Sun Oct 05 2014 00:00:00,
	 * //   Sun Oct 12 2014 00:00:00,
	 * //   Sun Oct 19 2014 00:00:00,
	 * //   Sun Oct 26 2014 00:00:00,
	 * //   Sun Nov 02 2014 00:00:00,
	 * //   Sun Nov 09 2014 00:00:00,
	 * //   Sun Nov 16 2014 00:00:00,
	 * //   Sun Nov 23 2014 00:00:00
	 * // ]
	 */
	function eachWeekOfInterval(dirtyInterval, options) {
	  (0, _index4.default)(1, arguments);
	  var interval = dirtyInterval || {};
	  var startDate = (0, _index3.default)(interval.start);
	  var endDate = (0, _index3.default)(interval.end);
	  var endTime = endDate.getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`
	
	  if (!(startDate.getTime() <= endTime)) {
	    throw new RangeError('Invalid interval');
	  }
	
	  var startDateWeek = (0, _index2.default)(startDate, options);
	  var endDateWeek = (0, _index2.default)(endDate, options); // Some timezones switch DST at midnight, making start of day unreliable in these timezones, 3pm is a safe bet
	
	  startDateWeek.setHours(15);
	  endDateWeek.setHours(15);
	  endTime = endDateWeek.getTime();
	  var weeks = [];
	  var currentWeek = startDateWeek;
	
	  while (currentWeek.getTime() <= endTime) {
	    currentWeek.setHours(0);
	    weeks.push((0, _index3.default)(currentWeek));
	    currentWeek = (0, _index.default)(currentWeek, 1);
	    currentWeek.setHours(15);
	  }
	
	  return weeks;
	}
	
	module.exports = exports.default;

/***/ },
/* 1560 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = eachWeekendOfMonth;
	
	var _index = _interopRequireDefault(__webpack_require__(391));
	
	var _index2 = _interopRequireDefault(__webpack_require__(213));
	
	var _index3 = _interopRequireDefault(__webpack_require__(266));
	
	var _index4 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name eachWeekendOfMonth
	 * @category Month Helpers
	 * @summary List all the Saturdays and Sundays in the given month.
	 *
	 * @description
	 * Get all the Saturdays and Sundays in the given month.
	 *
	 * @param {Date|Number} date - the given month
	 * @returns {Date[]} an array containing all the Saturdays and Sundays
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} The passed date is invalid
	 *
	 * @example
	 * // Lists all Saturdays and Sundays in the given month
	 * const result = eachWeekendOfMonth(new Date(2022, 1, 1))
	 * //=> [
	 * //   Sat Feb 05 2022 00:00:00,
	 * //   Sun Feb 06 2022 00:00:00,
	 * //   Sat Feb 12 2022 00:00:00,
	 * //   Sun Feb 13 2022 00:00:00,
	 * //   Sat Feb 19 2022 00:00:00,
	 * //   Sun Feb 20 2022 00:00:00,
	 * //   Sat Feb 26 2022 00:00:00,
	 * //   Sun Feb 27 2022 00:00:00
	 * // ]
	 */
	function eachWeekendOfMonth(dirtyDate) {
	  (0, _index4.default)(1, arguments);
	  var startDate = (0, _index2.default)(dirtyDate);
	  if (isNaN(startDate.getTime())) throw new RangeError('The passed date is invalid');
	  var endDate = (0, _index3.default)(dirtyDate);
	  return (0, _index.default)({
	    start: startDate,
	    end: endDate
	  });
	}
	
	module.exports = exports.default;

/***/ },
/* 1561 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = eachWeekendOfYear;
	
	var _index = _interopRequireDefault(__webpack_require__(391));
	
	var _index2 = _interopRequireDefault(__webpack_require__(270));
	
	var _index3 = _interopRequireDefault(__webpack_require__(632));
	
	var _index4 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name eachWeekendOfYear
	 * @category Year Helpers
	 * @summary List all the Saturdays and Sundays in the year.
	 *
	 * @description
	 * Get all the Saturdays and Sundays in the year.
	 *
	 * @param {Date|Number} date - the given year
	 * @returns {Date[]} an array containing all the Saturdays and Sundays
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} The passed date is invalid
	 *
	 * @example
	 * // Lists all Saturdays and Sundays in the year
	 * var result = eachWeekendOfYear(new Date(2020, 1, 1))
	 * //=> [
	 * //   Sat Jan 03 2020 00:00:00,
	 * //   Sun Jan 04 2020 00:00:00,
	 * //   ...
	 * //   Sun Dec 27 2020 00:00:00
	 * // ]
	 * ]
	 */
	function eachWeekendOfYear(dirtyDate) {
	  (0, _index4.default)(1, arguments);
	  var startDate = (0, _index2.default)(dirtyDate);
	  if (isNaN(startDate)) throw new RangeError('The passed date is invalid');
	  var endDate = (0, _index3.default)(dirtyDate);
	  return (0, _index.default)({
	    start: startDate,
	    end: endDate
	  });
	}
	
	module.exports = exports.default;

/***/ },
/* 1562 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = eachYearOfInterval;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name eachYearOfInterval
	 * @category Interval Helpers
	 * @summary Return the array of yearly timestamps within the specified time interval.
	 *
	 * @description
	 * Return the array of yearly timestamps within the specified time interval.
	 *
	 * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
	 * @returns {Date[]} the array with starts of yearly timestamps from the month of the interval start to the month of the interval end
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // Each year between 6 February 2014 and 10 August 2017:
	 * const result = eachYearOfInterval({
	 *   start: new Date(2014, 1, 6),
	 *   end: new Date(2017, 7, 10)
	 * })
	 * //=> [
	 * //   Wed Jan 01 2014 00:00:00,
	 * //   Thu Jan 01 2015 00:00:00,
	 * //   Fri Jan 01 2016 00:00:00,
	 * //   Sun Jan 01 2017 00:00:00
	 * // ]
	 */
	function eachYearOfInterval(dirtyInterval) {
	  (0, _index2.default)(1, arguments);
	  var interval = dirtyInterval || {};
	  var startDate = (0, _index.default)(interval.start);
	  var endDate = (0, _index.default)(interval.end);
	  var endTime = endDate.getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`
	
	  if (!(startDate.getTime() <= endTime)) {
	    throw new RangeError('Invalid interval');
	  }
	
	  var dates = [];
	  var currentDate = startDate;
	  currentDate.setHours(0, 0, 0, 0);
	  currentDate.setMonth(0, 1);
	
	  while (currentDate.getTime() <= endTime) {
	    dates.push((0, _index.default)(currentDate));
	    currentDate.setFullYear(currentDate.getFullYear() + 1);
	  }
	
	  return dates;
	}
	
	module.exports = exports.default;

/***/ },
/* 1563 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfDecade;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name endOfDecade
	 * @category Decade Helpers
	 * @summary Return the end of a decade for the given date.
	 *
	 * @description
	 * Return the end of a decade for the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of a decade
	 * @param {Object} [options] - an object with options.
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // The end of a decade for 12 May 1984 00:00:00:
	 * const result = endOfDecade(new Date(1984, 4, 12, 00, 00, 00))
	 * //=> Dec 31 1989 23:59:59.999
	 */
	function endOfDecade(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  var decade = 9 + Math.floor(year / 10) * 10;
	  date.setFullYear(decade, 11, 31);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 1564 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfHour;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name endOfHour
	 * @category Hour Helpers
	 * @summary Return the end of an hour for the given date.
	 *
	 * @description
	 * Return the end of an hour for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of an hour
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of an hour for 2 September 2014 11:55:00:
	 * const result = endOfHour(new Date(2014, 8, 2, 11, 55))
	 * //=> Tue Sep 02 2014 11:59:59.999
	 */
	function endOfHour(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setMinutes(59, 59, 999);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 1565 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfISOWeekYear;
	
	var _index = _interopRequireDefault(__webpack_require__(171));
	
	var _index2 = _interopRequireDefault(__webpack_require__(148));
	
	var _index3 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name endOfISOWeekYear
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Return the end of an ISO week-numbering year for the given date.
	 *
	 * @description
	 * Return the end of an ISO week-numbering year,
	 * which always starts 3 days before the year's first Thursday.
	 * The result will be in the local timezone.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `endOfISOYear` to `endOfISOWeekYear`.
	 *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
	 *   This change makes the name consistent with
	 *   locale-dependent week-numbering year helpers, e.g., `addWeekYears`.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of an ISO week-numbering year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of an ISO week-numbering year for 2 July 2005:
	 * const result = endOfISOWeekYear(new Date(2005, 6, 2))
	 * //=> Sun Jan 01 2006 23:59:59.999
	 */
	function endOfISOWeekYear(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  var year = (0, _index.default)(dirtyDate);
	  var fourthOfJanuaryOfNextYear = new Date(0);
	  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
	  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
	  var date = (0, _index2.default)(fourthOfJanuaryOfNextYear);
	  date.setMilliseconds(date.getMilliseconds() - 1);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 1566 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfISOWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(392));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name endOfISOWeek
	 * @category ISO Week Helpers
	 * @summary Return the end of an ISO week for the given date.
	 *
	 * @description
	 * Return the end of an ISO week for the given date.
	 * The result will be in the local timezone.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of an ISO week
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of an ISO week for 2 September 2014 11:55:00:
	 * var result = endOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Sun Sep 07 2014 23:59:59.999
	 */
	function endOfISOWeek(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, {
	    weekStartsOn: 1
	  });
	}
	
	module.exports = exports.default;

/***/ },
/* 1567 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfMinute;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name endOfMinute
	 * @category Minute Helpers
	 * @summary Return the end of a minute for the given date.
	 *
	 * @description
	 * Return the end of a minute for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of a minute
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of a minute for 1 December 2014 22:15:45.400:
	 * const result = endOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
	 * //=> Mon Dec 01 2014 22:15:59.999
	 */
	function endOfMinute(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setSeconds(59, 999);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 1568 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfQuarter;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name endOfQuarter
	 * @category Quarter Helpers
	 * @summary Return the end of a year quarter for the given date.
	 *
	 * @description
	 * Return the end of a year quarter for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of a quarter
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of a quarter for 2 September 2014 11:55:00:
	 * const result = endOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 30 2014 23:59:59.999
	 */
	function endOfQuarter(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var currentMonth = date.getMonth();
	  var month = currentMonth - currentMonth % 3 + 3;
	  date.setMonth(month, 0);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 1569 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfSecond;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name endOfSecond
	 * @category Second Helpers
	 * @summary Return the end of a second for the given date.
	 *
	 * @description
	 * Return the end of a second for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of a second
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of a second for 1 December 2014 22:15:45.400:
	 * const result = endOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
	 * //=> Mon Dec 01 2014 22:15:45.999
	 */
	function endOfSecond(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setMilliseconds(999);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 1570 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfToday;
	
	var _index = _interopRequireDefault(__webpack_require__(265));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name endOfToday
	 * @category Day Helpers
	 * @summary Return the end of today.
	 * @pure false
	 *
	 * @description
	 * Return the end of today.
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @returns {Date} the end of today
	 *
	 * @example
	 * // If today is 6 October 2014:
	 * var result = endOfToday()
	 * //=> Mon Oct 6 2014 23:59:59.999
	 */
	function endOfToday() {
	  return (0, _index.default)(Date.now());
	}
	
	module.exports = exports.default;

/***/ },
/* 1571 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfTomorrow;
	
	/**
	 * @name endOfTomorrow
	 * @category Day Helpers
	 * @summary Return the end of tomorrow.
	 * @pure false
	 *
	 * @description
	 * Return the end of tomorrow.
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `new Date()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @returns {Date} the end of tomorrow
	 *
	 * @example
	 * // If today is 6 October 2014:
	 * const result = endOfTomorrow()
	 * //=> Tue Oct 7 2014 23:59:59.999
	 */
	function endOfTomorrow() {
	  var now = new Date();
	  var year = now.getFullYear();
	  var month = now.getMonth();
	  var day = now.getDate();
	  var date = new Date(0);
	  date.setFullYear(year, month, day + 1);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 1572 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfYesterday;
	
	/**
	 * @name endOfYesterday
	 * @category Day Helpers
	 * @summary Return the end of yesterday.
	 * @pure false
	 *
	 * @description
	 * Return the end of yesterday.
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `new Date()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @returns {Date} the end of yesterday
	 *
	 * @example
	 * // If today is 6 October 2014:
	 * const result = endOfYesterday()
	 * //=> Sun Oct 5 2014 23:59:59.999
	 */
	function endOfYesterday() {
	  var now = new Date();
	  var year = now.getFullYear();
	  var month = now.getMonth();
	  var day = now.getDate();
	  var date = new Date(0);
	  date.setFullYear(year, month, day - 1);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 1573 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistanceToNowStrict;
	
	var _index = _interopRequireDefault(__webpack_require__(633));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name formatDistanceToNowStrict
	 * @category Common Helpers
	 * @summary Return the distance between the given date and now in words.
	 * @pure false
	 *
	 * @description
	 * Return the distance between the given dates in words, using strict units.
	 * This is like `formatDistance`, but does not use helpers like 'almost', 'over',
	 * 'less than' and the like.
	 *
	 * | Distance between dates | Result              |
	 * |------------------------|---------------------|
	 * | 0 ... 59 secs          | [0..59] seconds     |
	 * | 1 ... 59 mins          | [1..59] minutes     |
	 * | 1 ... 23 hrs           | [1..23] hours       |
	 * | 1 ... 29 days          | [1..29] days        |
	 * | 1 ... 11 months        | [1..11] months      |
	 * | 1 ... N years          | [1..N]  years       |
	 *
	 * @param {Date|Number} date - the given date
	 * @param {Object} [options] - an object with options.
	 * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
	 * @param {'second'|'minute'|'hour'|'day'|'month'|'year'} [options.unit] - if specified, will force a unit
	 * @param {'floor'|'ceil'|'round'} [options.roundingMethod='round'] - which way to round partial units
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @returns {String} the distance in words
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `date` must not be Invalid Date
	 * @throws {RangeError} `options.locale` must contain `formatDistance` property
	 *
	 * @example
	 * // If today is 1 January 2015, what is the distance to 2 July 2014?
	 * var result = formatDistanceToNowStrict(
	 *   new Date(2014, 6, 2)
	 * )
	 * //=> '6 months'
	 *
	 * @example
	 * // If now is 1 January 2015 00:00:00,
	 * // what is the distance to 1 January 2015 00:00:15, including seconds?
	 * var result = formatDistanceToNowStrict(
	 *   new Date(2015, 0, 1, 0, 0, 15)
	 * )
	 * //=> '20 seconds'
	 *
	 * @example
	 * // If today is 1 January 2015,
	 * // what is the distance to 1 January 2016, with a suffix?
	 * var result = formatDistanceToNowStrict(
	 *   new Date(2016, 0, 1),
	 *   {addSuffix: true}
	 * )
	 * //=> 'in 1 year'
	 *
	 * @example
	 * // If today is 28 January 2015,
	 * // what is the distance to 1 January 2015, in months, rounded up??
	 * var result = formatDistanceToNowStrict(new Date(2015, 0, 1), {
	 *   unit: 'month',
	 *   roundingMethod: 'ceil'
	 * })
	 * //=> '1 month'
	 *
	 * @example
	 * // If today is 1 January 2015,
	 * // what is the distance to 1 August 2016 in Esperanto?
	 * var eoLocale = require('date-fns/locale/eo')
	 * var result = formatDistanceToNowStrict(
	 *   new Date(2016, 7, 1),
	 *   {locale: eoLocale}
	 * )
	 * //=> '1 jaro'
	 */
	function formatDistanceToNowStrict(dirtyDate, dirtyOptions) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, Date.now(), dirtyOptions);
	}
	
	module.exports = exports.default;

/***/ },
/* 1574 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistanceToNow;
	
	var _index = _interopRequireDefault(__webpack_require__(634));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name formatDistanceToNow
	 * @category Common Helpers
	 * @summary Return the distance between the given date and now in words.
	 * @pure false
	 *
	 * @description
	 * Return the distance between the given date and now in words.
	 *
	 * | Distance to now                                                   | Result              |
	 * |-------------------------------------------------------------------|---------------------|
	 * | 0 ... 30 secs                                                     | less than a minute  |
	 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
	 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
	 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
	 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
	 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
	 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
	 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
	 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
	 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
	 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
	 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
	 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
	 * | N yrs ... N yrs 3 months                                          | about N years       |
	 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
	 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
	 *
	 * With `options.includeSeconds == true`:
	 * | Distance to now     | Result               |
	 * |---------------------|----------------------|
	 * | 0 secs ... 5 secs   | less than 5 seconds  |
	 * | 5 secs ... 10 secs  | less than 10 seconds |
	 * | 10 secs ... 20 secs | less than 20 seconds |
	 * | 20 secs ... 40 secs | half a minute        |
	 * | 40 secs ... 60 secs | less than a minute   |
	 * | 60 secs ... 90 secs | 1 minute             |
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `distanceInWordsToNow ` to `formatDistanceToNow`
	 *   to make its name consistent with `format` and `formatRelative`.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *
	 *   distanceInWordsToNow(new Date(2014, 6, 2), { addSuffix: true })
	 *   //=> 'in 6 months'
	 *
	 *   // v2.0.0 onward
	 *
	 *   formatDistanceToNow(new Date(2014, 6, 2), { addSuffix: true })
	 *   //=> 'in 6 months'
	 *   ```
	 *
	 * @param {Date|Number} date - the given date
	 * @param {Object} [options] - the object with options
	 * @param {Boolean} [options.includeSeconds=false] - distances less than a minute are more detailed
	 * @param {Boolean} [options.addSuffix=false] - result specifies if now is earlier or later than the passed date
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @returns {String} the distance in words
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `date` must not be Invalid Date
	 * @throws {RangeError} `options.locale` must contain `formatDistance` property
	 *
	 * @example
	 * // If today is 1 January 2015, what is the distance to 2 July 2014?
	 * var result = formatDistanceToNow(
	 *   new Date(2014, 6, 2)
	 * )
	 * //=> '6 months'
	 *
	 * @example
	 * // If now is 1 January 2015 00:00:00,
	 * // what is the distance to 1 January 2015 00:00:15, including seconds?
	 * var result = formatDistanceToNow(
	 *   new Date(2015, 0, 1, 0, 0, 15),
	 *   {includeSeconds: true}
	 * )
	 * //=> 'less than 20 seconds'
	 *
	 * @example
	 * // If today is 1 January 2015,
	 * // what is the distance to 1 January 2016, with a suffix?
	 * var result = formatDistanceToNow(
	 *   new Date(2016, 0, 1),
	 *   {addSuffix: true}
	 * )
	 * //=> 'in about 1 year'
	 *
	 * @example
	 * // If today is 1 January 2015,
	 * // what is the distance to 1 August 2016 in Esperanto?
	 * var eoLocale = require('date-fns/locale/eo')
	 * var result = formatDistanceToNow(
	 *   new Date(2016, 7, 1),
	 *   {locale: eoLocale}
	 * )
	 * //=> 'pli ol 1 jaro'
	 */
	function formatDistanceToNow(dirtyDate, dirtyOptions) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, Date.now(), dirtyOptions);
	}
	
	module.exports = exports.default;

/***/ },
/* 1575 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDuration;
	
	var _index = _interopRequireDefault(__webpack_require__(108));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultFormat = ['years', 'months', 'weeks', 'days', 'hours', 'minutes', 'seconds'];
	
	/**
	 * @name formatDuration
	 * @category Common Helpers
	 * @summary Formats a duration in human-readable format
	 *
	 * @description
	 * Return human-readable duration string i.e. "9 months 2 days"
	 *
	 * @param {Duration} duration - the duration to format
	 * @param {Object} [options] - an object with options.
	 * @param {string[]} [options.format=['years', 'months', 'weeks', 'days', 'hours', 'minutes', 'seconds']] - the array of units to format
	 * @param {boolean} [options.zero=false] - should zeros be included in the output?
	 * @param {string} [options.delimiter=' '] - delimiter string
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @returns {string} the formatted date string
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Format full duration
	 * formatDuration({
	 *   years: 2,
	 *   months: 9,
	 *   weeks: 1,
	 *   days: 7,
	 *   hours: 5,
	 *   minutes: 9,
	 *   seconds: 30
	 * })
	 * //=> '2 years 9 months 1 week 7 days 5 hours 9 minutes 30 seconds'
	 *
	 * @example
	 * // Format partial duration
	 * formatDuration({ months: 9, days: 2 })
	 * //=> '9 months 2 days'
	 *
	 * @example
	 * // Customize the format
	 * formatDuration(
	 *   {
	 *     years: 2,
	 *     months: 9,
	 *     weeks: 1,
	 *     days: 7,
	 *     hours: 5,
	 *     minutes: 9,
	 *     seconds: 30
	 *   },
	 *   { format: ['months', 'weeks'] }
	 * ) === '9 months 1 week'
	 *
	 * @example
	 * // Customize the zeros presence
	 * formatDuration({ years: 0, months: 9 })
	 * //=> '9 months'
	 * formatDuration({ years: 0, months: 9 }, { zero: true })
	 * //=> '0 years 9 months'
	 *
	 * @example
	 * // Customize the delimiter
	 * formatDuration({ years: 2, months: 9, weeks: 3 }, { delimiter: ', ' })
	 * //=> '2 years, 9 months, 3 weeks'
	 */
	function formatDuration(duration) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (arguments.length < 1) {
	    throw new TypeError("1 argument required, but only ".concat(arguments.length, " present"));
	  }
	
	  var format = (options === null || options === void 0 ? void 0 : options.format) || defaultFormat;
	  var locale = (options === null || options === void 0 ? void 0 : options.locale) || _index.default;
	  var zero = (options === null || options === void 0 ? void 0 : options.zero) || false;
	  var delimiter = (options === null || options === void 0 ? void 0 : options.delimiter) || ' ';
	  var result = format.reduce(function (acc, unit) {
	    var token = "x".concat(unit.replace(/(^.)/, function (m) {
	      return m.toUpperCase();
	    }));
	    var addChunk = typeof duration[unit] === 'number' && (zero || duration[unit]);
	    return addChunk && locale.formatDistance ? acc.concat(locale.formatDistance(token, duration[unit])) : acc;
	  }, []).join(delimiter);
	  return result;
	}
	
	module.exports = exports.default;

/***/ },
/* 1576 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatISO9075;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(96));
	
	var _index3 = _interopRequireDefault(__webpack_require__(169));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name formatISO9075
	 * @category Common Helpers
	 * @summary Format the date according to the ISO 9075 standard (https://dev.mysql.com/doc/refman/5.7/en/date-and-time-functions.html#function_get-format).
	 *
	 * @description
	 * Return the formatted date string in ISO 9075 format. Options may be passed to control the parts and notations of the date.
	 *
	 * @param {Date|Number} date - the original date
	 * @param {Object} [options] - an object with options.
	 * @param {'extended'|'basic'} [options.format='extended'] - if 'basic', hide delimiters between date and time values.
	 * @param {'complete'|'date'|'time'} [options.representation='complete'] - format date, time, or both.
	 * @returns {String} the formatted date string
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `date` must not be Invalid Date
	 * @throws {RangeError} `options.format` must be 'extended' or 'basic'
	 * @throws {RangeError} `options.represenation` must be 'date', 'time' or 'complete'
	 *
	 * @example
	 * // Represent 18 September 2019 in ISO 9075 format:
	 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52))
	 * //=> '2019-09-18 19:00:52'
	 *
	 * @example
	 * // Represent 18 September 2019 in ISO 9075, short format:
	 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { format: 'basic' })
	 * //=> '20190918 190052'
	 *
	 * @example
	 * // Represent 18 September 2019 in ISO 9075 format, date only:
	 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { representation: 'date' })
	 * //=> '2019-09-18'
	 *
	 * @example
	 * // Represent 18 September 2019 in ISO 9075 format, time only:
	 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { representation: 'time' })
	 * //=> '19:00:52'
	 */
	function formatISO9075(dirtyDate, dirtyOptions) {
	  if (arguments.length < 1) {
	    throw new TypeError("1 argument required, but only ".concat(arguments.length, " present"));
	  }
	
	  var originalDate = (0, _index.default)(dirtyDate);
	
	  if (!(0, _index2.default)(originalDate)) {
	    throw new RangeError('Invalid time value');
	  }
	
	  var options = dirtyOptions || {};
	  var format = options.format == null ? 'extended' : String(options.format);
	  var representation = options.representation == null ? 'complete' : String(options.representation);
	
	  if (format !== 'extended' && format !== 'basic') {
	    throw new RangeError("format must be 'extended' or 'basic'");
	  }
	
	  if (representation !== 'date' && representation !== 'time' && representation !== 'complete') {
	    throw new RangeError("representation must be 'date', 'time', or 'complete'");
	  }
	
	  var result = '';
	  var dateDelimiter = format === 'extended' ? '-' : '';
	  var timeDelimiter = format === 'extended' ? ':' : ''; // Representation is either 'date' or 'complete'
	
	  if (representation !== 'time') {
	    var day = (0, _index3.default)(originalDate.getDate(), 2);
	    var month = (0, _index3.default)(originalDate.getMonth() + 1, 2);
	    var year = (0, _index3.default)(originalDate.getFullYear(), 4); // yyyyMMdd or yyyy-MM-dd.
	
	    result = "".concat(year).concat(dateDelimiter).concat(month).concat(dateDelimiter).concat(day);
	  } // Representation is either 'time' or 'complete'
	
	
	  if (representation !== 'date') {
	    var hour = (0, _index3.default)(originalDate.getHours(), 2);
	    var minute = (0, _index3.default)(originalDate.getMinutes(), 2);
	    var second = (0, _index3.default)(originalDate.getSeconds(), 2); // If there's also date, separate it with time with a space
	
	    var separator = result === '' ? '' : ' '; // HHmmss or HH:mm:ss.
	
	    result = "".concat(result).concat(separator).concat(hour).concat(timeDelimiter).concat(minute).concat(timeDelimiter).concat(second);
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ },
/* 1577 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatISODuration;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name formatISODuration
	 * @category Common Helpers
	 * @summary Format a duration object according as ISO 8601 duration string
	 *
	 * @description
	 * Format a duration object according to the ISO 8601 duration standard (https://www.digi.com/resources/documentation/digidocs/90001437-13/reference/r_iso_8601_duration_format.htm)
	 *
	 * @param {Duration} duration - the duration to format
	 *
	 * @returns {String} The ISO 8601 duration string
	 * @throws {TypeError} Requires 1 argument
	 * @throws {Error} Argument must be an object
	 *
	 * @example
	 * // Format the given duration as ISO 8601 string
	 * const result = formatISODuration({
	 *   years: 39,
	 *   months: 2,
	 *   days: 20,
	 *   hours: 7,
	 *   minutes: 5,
	 *   seconds: 0
	 * })
	 * //=> 'P39Y2M20DT0H0M0S'
	 */
	function formatISODuration(duration) {
	  (0, _index.default)(1, arguments);
	  if (typeof duration !== 'object') throw new Error('Duration must be an object');
	  var _duration$years = duration.years,
	      years = _duration$years === void 0 ? 0 : _duration$years,
	      _duration$months = duration.months,
	      months = _duration$months === void 0 ? 0 : _duration$months,
	      _duration$days = duration.days,
	      days = _duration$days === void 0 ? 0 : _duration$days,
	      _duration$hours = duration.hours,
	      hours = _duration$hours === void 0 ? 0 : _duration$hours,
	      _duration$minutes = duration.minutes,
	      minutes = _duration$minutes === void 0 ? 0 : _duration$minutes,
	      _duration$seconds = duration.seconds,
	      seconds = _duration$seconds === void 0 ? 0 : _duration$seconds;
	  return "P".concat(years, "Y").concat(months, "M").concat(days, "DT").concat(hours, "H").concat(minutes, "M").concat(seconds, "S");
	}
	
	module.exports = exports.default;

/***/ },
/* 1578 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatISO;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(169));
	
	var _index3 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name formatISO
	 * @category Common Helpers
	 * @summary Format the date according to the ISO 8601 standard (https://support.sas.com/documentation/cdl/en/lrdict/64316/HTML/default/viewer.htm#a003169814.htm).
	 *
	 * @description
	 * Return the formatted date string in ISO 8601 format. Options may be passed to control the parts and notations of the date.
	 *
	 * @param {Date|Number} date - the original date
	 * @param {Object} [options] - an object with options.
	 * @param {'extended'|'basic'} [options.format='extended'] - if 'basic', hide delimiters between date and time values.
	 * @param {'complete'|'date'|'time'} [options.representation='complete'] - format date, time with local time zone, or both.
	 * @returns {String} the formatted date string (in local time zone)
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `date` must not be Invalid Date
	 * @throws {RangeError} `options.format` must be 'extended' or 'basic'
	 * @throws {RangeError} `options.represenation` must be 'date', 'time' or 'complete'
	 *
	 * @example
	 * // Represent 18 September 2019 in ISO 8601 format (local time zone is UTC):
	 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52))
	 * //=> '2019-09-18T19:00:52Z'
	 *
	 * @example
	 * // Represent 18 September 2019 in ISO 8601, short format (local time zone is UTC):
	 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { format: 'basic' })
	 * //=> '20190918T190052'
	 *
	 * @example
	 * // Represent 18 September 2019 in ISO 8601 format, date only:
	 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { representation: 'date' })
	 * //=> '2019-09-18'
	 *
	 * @example
	 * // Represent 18 September 2019 in ISO 8601 format, time only (local time zone is UTC):
	 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { representation: 'time' })
	 * //=> '19:00:52Z'
	 */
	function formatISO(date, options) {
	  (0, _index3.default)(1, arguments);
	  var originalDate = (0, _index.default)(date);
	
	  if (isNaN(originalDate.getTime())) {
	    throw new RangeError('Invalid time value');
	  }
	
	  var format = !(options !== null && options !== void 0 && options.format) ? 'extended' : String(options.format);
	  var representation = !(options !== null && options !== void 0 && options.representation) ? 'complete' : String(options.representation);
	
	  if (format !== 'extended' && format !== 'basic') {
	    throw new RangeError("format must be 'extended' or 'basic'");
	  }
	
	  if (representation !== 'date' && representation !== 'time' && representation !== 'complete') {
	    throw new RangeError("representation must be 'date', 'time', or 'complete'");
	  }
	
	  var result = '';
	  var tzOffset = '';
	  var dateDelimiter = format === 'extended' ? '-' : '';
	  var timeDelimiter = format === 'extended' ? ':' : ''; // Representation is either 'date' or 'complete'
	
	  if (representation !== 'time') {
	    var day = (0, _index2.default)(originalDate.getDate(), 2);
	    var month = (0, _index2.default)(originalDate.getMonth() + 1, 2);
	    var year = (0, _index2.default)(originalDate.getFullYear(), 4); // yyyyMMdd or yyyy-MM-dd.
	
	    result = "".concat(year).concat(dateDelimiter).concat(month).concat(dateDelimiter).concat(day);
	  } // Representation is either 'time' or 'complete'
	
	
	  if (representation !== 'date') {
	    // Add the timezone.
	    var offset = originalDate.getTimezoneOffset();
	
	    if (offset !== 0) {
	      var absoluteOffset = Math.abs(offset);
	      var hourOffset = (0, _index2.default)(Math.floor(absoluteOffset / 60), 2);
	      var minuteOffset = (0, _index2.default)(absoluteOffset % 60, 2); // If less than 0, the sign is +, because it is ahead of time.
	
	      var sign = offset < 0 ? '+' : '-';
	      tzOffset = "".concat(sign).concat(hourOffset, ":").concat(minuteOffset);
	    } else {
	      tzOffset = 'Z';
	    }
	
	    var hour = (0, _index2.default)(originalDate.getHours(), 2);
	    var minute = (0, _index2.default)(originalDate.getMinutes(), 2);
	    var second = (0, _index2.default)(originalDate.getSeconds(), 2); // If there's also date, separate it with time with 'T'
	
	    var separator = result === '' ? '' : 'T'; // Creates a time string consisting of hour, minute, and second, separated by delimiters, if defined.
	
	    var time = [hour, minute, second].join(timeDelimiter); // HHmmss or HH:mm:ss.
	
	    result = "".concat(result).concat(separator).concat(time).concat(tzOffset);
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ },
/* 1579 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRFC3339;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(96));
	
	var _index3 = _interopRequireDefault(__webpack_require__(169));
	
	var _index4 = _interopRequireDefault(__webpack_require__(26));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name formatRFC3339
	 * @category Common Helpers
	 * @summary Format the date according to the RFC 3339 standard (https://tools.ietf.org/html/rfc3339#section-5.6).
	 *
	 * @description
	 * Return the formatted date string in RFC 3339 format. Options may be passed to control the parts and notations of the date.
	 *
	 * @param {Date|Number} date - the original date
	 * @param {Object} [options] - an object with options.
	 * @param {0|1|2|3} [options.fractionDigits=0] - number of digits after the decimal point after seconds
	 * @returns {String} the formatted date string
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `date` must not be Invalid Date
	 * @throws {RangeError} `options.fractionDigits` must be between 0 and 3
	 *
	 * @example
	 * // Represent 18 September 2019 in RFC 3339 format:
	 * const result = formatRFC3339(new Date(2019, 8, 18, 19, 0, 52))
	 * //=> '2019-09-18T19:00:52Z'
	 *
	 * @example
	 * // Represent 18 September 2019 in RFC 3339 format, 2 digits of second fraction:
	 * const result = formatRFC3339(new Date(2019, 8, 18, 19, 0, 52, 234), { fractionDigits: 2 })
	 * //=> '2019-09-18T19:00:52.23Z'
	 *
	 * @example
	 * // Represent 18 September 2019 in RFC 3339 format, 3 digits of second fraction
	 * const result = formatRFC3339(new Date(2019, 8, 18, 19, 0, 52, 234), { fractionDigits: 3 })
	 * //=> '2019-09-18T19:00:52.234Z'
	 */
	function formatRFC3339(dirtyDate, dirtyOptions) {
	  if (arguments.length < 1) {
	    throw new TypeError("1 arguments required, but only ".concat(arguments.length, " present"));
	  }
	
	  var originalDate = (0, _index.default)(dirtyDate);
	
	  if (!(0, _index2.default)(originalDate)) {
	    throw new RangeError('Invalid time value');
	  }
	
	  var _ref = dirtyOptions || {},
	      _ref$fractionDigits = _ref.fractionDigits,
	      fractionDigits = _ref$fractionDigits === void 0 ? 0 : _ref$fractionDigits; // Test if fractionDigits is between 0 and 3 _and_ is not NaN
	
	
	  if (!(fractionDigits >= 0 && fractionDigits <= 3)) {
	    throw new RangeError('fractionDigits must be between 0 and 3 inclusively');
	  }
	
	  var day = (0, _index3.default)(originalDate.getDate(), 2);
	  var month = (0, _index3.default)(originalDate.getMonth() + 1, 2);
	  var year = originalDate.getFullYear();
	  var hour = (0, _index3.default)(originalDate.getHours(), 2);
	  var minute = (0, _index3.default)(originalDate.getMinutes(), 2);
	  var second = (0, _index3.default)(originalDate.getSeconds(), 2);
	  var fractionalSecond = '';
	
	  if (fractionDigits > 0) {
	    var milliseconds = originalDate.getMilliseconds();
	    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, fractionDigits - 3));
	    fractionalSecond = '.' + (0, _index3.default)(fractionalSeconds, fractionDigits);
	  }
	
	  var offset = '';
	  var tzOffset = originalDate.getTimezoneOffset();
	
	  if (tzOffset !== 0) {
	    var absoluteOffset = Math.abs(tzOffset);
	    var hourOffset = (0, _index3.default)((0, _index4.default)(absoluteOffset / 60), 2);
	    var minuteOffset = (0, _index3.default)(absoluteOffset % 60, 2); // If less than 0, the sign is +, because it is ahead of time.
	
	    var sign = tzOffset < 0 ? '+' : '-';
	    offset = "".concat(sign).concat(hourOffset, ":").concat(minuteOffset);
	  } else {
	    offset = 'Z';
	  }
	
	  return "".concat(year, "-").concat(month, "-").concat(day, "T").concat(hour, ":").concat(minute, ":").concat(second).concat(fractionalSecond).concat(offset);
	}
	
	module.exports = exports.default;

/***/ },
/* 1580 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRFC7231;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(96));
	
	var _index3 = _interopRequireDefault(__webpack_require__(169));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	/**
	 * @name formatRFC7231
	 * @category Common Helpers
	 * @summary Format the date according to the RFC 7231 standard (https://tools.ietf.org/html/rfc7231#section-7.1.1.1).
	 *
	 * @description
	 * Return the formatted date string in RFC 7231 format.
	 * The result will always be in UTC timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {String} the formatted date string
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `date` must not be Invalid Date
	 *
	 * @example
	 * // Represent 18 September 2019 in RFC 7231 format:
	 * const result = formatRFC7231(new Date(2019, 8, 18, 19, 0, 52))
	 * //=> 'Wed, 18 Sep 2019 19:00:52 GMT'
	 */
	
	function formatRFC7231(dirtyDate) {
	  if (arguments.length < 1) {
	    throw new TypeError("1 arguments required, but only ".concat(arguments.length, " present"));
	  }
	
	  var originalDate = (0, _index.default)(dirtyDate);
	
	  if (!(0, _index2.default)(originalDate)) {
	    throw new RangeError('Invalid time value');
	  }
	
	  var dayName = days[originalDate.getUTCDay()];
	  var dayOfMonth = (0, _index3.default)(originalDate.getUTCDate(), 2);
	  var monthName = months[originalDate.getUTCMonth()];
	  var year = originalDate.getUTCFullYear();
	  var hour = (0, _index3.default)(originalDate.getUTCHours(), 2);
	  var minute = (0, _index3.default)(originalDate.getUTCMinutes(), 2);
	  var second = (0, _index3.default)(originalDate.getUTCSeconds(), 2); // Result variables.
	
	  return "".concat(dayName, ", ").concat(dayOfMonth, " ").concat(monthName, " ").concat(year, " ").concat(hour, ":").concat(minute, ":").concat(second, " GMT");
	}
	
	module.exports = exports.default;

/***/ },
/* 1581 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	
	var _index = _interopRequireDefault(__webpack_require__(120));
	
	var _index2 = _interopRequireDefault(__webpack_require__(393));
	
	var _index3 = _interopRequireDefault(__webpack_require__(108));
	
	var _index4 = _interopRequireDefault(__webpack_require__(215));
	
	var _index5 = _interopRequireDefault(__webpack_require__(9));
	
	var _index6 = _interopRequireDefault(__webpack_require__(107));
	
	var _index7 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name formatRelative
	 * @category Common Helpers
	 * @summary Represent the date in words relative to the given base date.
	 *
	 * @description
	 * Represent the date in words relative to the given base date.
	 *
	 * | Distance to the base date | Result                    |
	 * |---------------------------|---------------------------|
	 * | Previous 6 days           | last Sunday at 04:30 AM   |
	 * | Last day                  | yesterday at 04:30 AM     |
	 * | Same day                  | today at 04:30 AM         |
	 * | Next day                  | tomorrow at 04:30 AM      |
	 * | Next 6 days               | Sunday at 04:30 AM        |
	 * | Other                     | 12/31/2017                |
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to format
	 * @param {Date|Number} baseDate - the date to compare with
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {String} the date in words
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `date` must not be Invalid Date
	 * @throws {RangeError} `baseDate` must not be Invalid Date
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.locale` must contain `localize` property
	 * @throws {RangeError} `options.locale` must contain `formatLong` property
	 * @throws {RangeError} `options.locale` must contain `formatRelative` property
	 *
	 * @example
	 * // Represent the date of 6 days ago in words relative to the given base date. In this example, today is Wednesday
	 * const result = formatRelative(addDays(new Date(), -6), new Date())
	 * //=> "last Thursday at 12:45 AM"
	 */
	function formatRelative(dirtyDate, dirtyBaseDate, dirtyOptions) {
	  (0, _index7.default)(2, arguments);
	  var date = (0, _index5.default)(dirtyDate);
	  var baseDate = (0, _index5.default)(dirtyBaseDate);
	
	  var _ref = dirtyOptions || {},
	      _ref$locale = _ref.locale,
	      locale = _ref$locale === void 0 ? _index3.default : _ref$locale,
	      _ref$weekStartsOn = _ref.weekStartsOn,
	      weekStartsOn = _ref$weekStartsOn === void 0 ? 0 : _ref$weekStartsOn;
	
	  if (!locale.localize) {
	    throw new RangeError('locale must contain localize property');
	  }
	
	  if (!locale.formatLong) {
	    throw new RangeError('locale must contain formatLong property');
	  }
	
	  if (!locale.formatRelative) {
	    throw new RangeError('locale must contain formatRelative property');
	  }
	
	  var diff = (0, _index.default)(date, baseDate);
	
	  if (isNaN(diff)) {
	    throw new RangeError('Invalid time value');
	  }
	
	  var token;
	
	  if (diff < -6) {
	    token = 'other';
	  } else if (diff < -1) {
	    token = 'lastWeek';
	  } else if (diff < 0) {
	    token = 'yesterday';
	  } else if (diff < 1) {
	    token = 'today';
	  } else if (diff < 2) {
	    token = 'tomorrow';
	  } else if (diff < 7) {
	    token = 'nextWeek';
	  } else {
	    token = 'other';
	  }
	
	  var utcDate = (0, _index4.default)(date, (0, _index6.default)(date));
	  var utcBaseDate = (0, _index4.default)(baseDate, (0, _index6.default)(baseDate));
	  var formatStr = locale.formatRelative(token, utcDate, utcBaseDate, {
	    locale: locale,
	    weekStartsOn: weekStartsOn
	  });
	  return (0, _index2.default)(date, formatStr, {
	    locale: locale,
	    weekStartsOn: weekStartsOn
	  });
	}
	
	module.exports = exports.default;

/***/ },
/* 1582 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = fromUnixTime;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(26));
	
	var _index3 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name fromUnixTime
	 * @category Timestamp Helpers
	 * @summary Create a date from a Unix timestamp.
	 *
	 * @description
	 * Create a date from a Unix timestamp (in seconds). Decimal values will be discarded.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Number} unixTime - the given Unix timestamp (in seconds)
	 * @returns {Date} the date
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Create the date 29 February 2012 11:45:05:
	 * const result = fromUnixTime(1330515905)
	 * //=> Wed Feb 29 2012 11:45:05
	 */
	function fromUnixTime(dirtyUnixTime) {
	  (0, _index3.default)(1, arguments);
	  var unixTime = (0, _index2.default)(dirtyUnixTime);
	  return (0, _index.default)(unixTime * 1000);
	}
	
	module.exports = exports.default;

/***/ },
/* 1583 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDayOfYear;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(270));
	
	var _index3 = _interopRequireDefault(__webpack_require__(120));
	
	var _index4 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getDayOfYear
	 * @category Day Helpers
	 * @summary Get the day of the year of the given date.
	 *
	 * @description
	 * Get the day of the year of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the day of year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which day of the year is 2 July 2014?
	 * const result = getDayOfYear(new Date(2014, 6, 2))
	 * //=> 183
	 */
	function getDayOfYear(dirtyDate) {
	  (0, _index4.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var diff = (0, _index3.default)(date, (0, _index2.default)(date));
	  var dayOfYear = diff + 1;
	  return dayOfYear;
	}
	
	module.exports = exports.default;

/***/ },
/* 1584 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDaysInYear;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(648));
	
	var _index3 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getDaysInYear
	 * @category Year Helpers
	 * @summary Get the number of days in a year of the given date.
	 *
	 * @description
	 * Get the number of days in a year of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the number of days in a year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // How many days are in 2012?
	 * const result = getDaysInYear(new Date(2012, 0, 1))
	 * //=> 366
	 */
	function getDaysInYear(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	
	  if (String(new Date(date)) === 'Invalid Date') {
	    return NaN;
	  }
	
	  return (0, _index2.default)(date) ? 366 : 365;
	}
	
	module.exports = exports.default;

/***/ },
/* 1585 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDecade;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getDecade
	 * @category Decade Helpers
	 * @summary Get the decade of the given date.
	 *
	 * @description
	 * Get the decade of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the year of decade
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which decade belongs 27 November 1942?
	 * const result = getDecade(new Date(1942, 10, 27))
	 * //=> 1940
	 */
	function getDecade(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  var decade = Math.floor(year / 10) * 10;
	  return decade;
	}
	
	module.exports = exports.default;

/***/ },
/* 1586 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getISOWeeksInYear;
	
	var _index = _interopRequireDefault(__webpack_require__(212));
	
	var _index2 = _interopRequireDefault(__webpack_require__(209));
	
	var _index3 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_WEEK = 604800000;
	/**
	 * @name getISOWeeksInYear
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Get the number of weeks in an ISO week-numbering year of the given date.
	 *
	 * @description
	 * Get the number of weeks in an ISO week-numbering year of the given date.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the number of ISO weeks in a year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // How many weeks are in ISO week-numbering year 2015?
	 * const result = getISOWeeksInYear(new Date(2015, 1, 11))
	 * //=> 53
	 */
	
	function getISOWeeksInYear(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  var thisYear = (0, _index.default)(dirtyDate);
	  var nextYear = (0, _index.default)((0, _index2.default)(thisYear, 60));
	  var diff = nextYear.valueOf() - thisYear.valueOf(); // Round the number of weeks to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	
	  return Math.round(diff / MILLISECONDS_IN_WEEK);
	}
	
	module.exports = exports.default;

/***/ },
/* 1587 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getMilliseconds;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getMilliseconds
	 * @category Millisecond Helpers
	 * @summary Get the milliseconds of the given date.
	 *
	 * @description
	 * Get the milliseconds of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the milliseconds
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Get the milliseconds of 29 February 2012 11:45:05.123:
	 * const result = getMilliseconds(new Date(2012, 1, 29, 11, 45, 5, 123))
	 * //=> 123
	 */
	function getMilliseconds(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var milliseconds = date.getMilliseconds();
	  return milliseconds;
	}
	
	module.exports = exports.default;

/***/ },
/* 1588 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getOverlappingDaysInIntervals;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_DAY = 24 * 60 * 60 * 1000;
	/**
	 * @name getOverlappingDaysInIntervals
	 * @category Interval Helpers
	 * @summary Get the number of days that overlap in two time intervals
	 *
	 * @description
	 * Get the number of days that overlap in two time intervals
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `getOverlappingDaysInRanges` to `getOverlappingDaysInIntervals`.
	 *   This change was made to mirror the use of the word "interval" in standard ISO 8601:2004 terminology:
	 *
	 *   ```
	 *   2.1.3
	 *   time interval
	 *   part of the time axis limited by two instants
	 *   ```
	 *
	 *   Also, this function now accepts an object with `start` and `end` properties
	 *   instead of two arguments as an interval.
	 *   This function now throws `RangeError` if the start of the interval is after its end
	 *   or if any date in the interval is `Invalid Date`.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *
	 *   getOverlappingDaysInRanges(
	 *     new Date(2014, 0, 10), new Date(2014, 0, 20),
	 *     new Date(2014, 0, 17), new Date(2014, 0, 21)
	 *   )
	 *
	 *   // v2.0.0 onward
	 *
	 *   getOverlappingDaysInIntervals(
	 *     { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
	 *     { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
	 *   )
	 *   ```
	 *
	 * @param {Interval} intervalLeft - the first interval to compare. See [Interval]{@link docs/Interval}
	 * @param {Interval} intervalRight - the second interval to compare. See [Interval]{@link docs/Interval}
	 * @returns {Number} the number of days that overlap in two time intervals
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // For overlapping time intervals adds 1 for each started overlapping day:
	 * getOverlappingDaysInIntervals(
	 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
	 *   { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
	 * )
	 * //=> 3
	 *
	 * @example
	 * // For non-overlapping time intervals returns 0:
	 * getOverlappingDaysInIntervals(
	 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
	 *   { start: new Date(2014, 0, 21), end: new Date(2014, 0, 22) }
	 * )
	 * //=> 0
	 */
	
	function getOverlappingDaysInIntervals(dirtyIntervalLeft, dirtyIntervalRight) {
	  (0, _index2.default)(2, arguments);
	  var intervalLeft = dirtyIntervalLeft || {};
	  var intervalRight = dirtyIntervalRight || {};
	  var leftStartTime = (0, _index.default)(intervalLeft.start).getTime();
	  var leftEndTime = (0, _index.default)(intervalLeft.end).getTime();
	  var rightStartTime = (0, _index.default)(intervalRight.start).getTime();
	  var rightEndTime = (0, _index.default)(intervalRight.end).getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`
	
	  if (!(leftStartTime <= leftEndTime && rightStartTime <= rightEndTime)) {
	    throw new RangeError('Invalid interval');
	  }
	
	  var isOverlapping = leftStartTime < rightEndTime && rightStartTime < leftEndTime;
	
	  if (!isOverlapping) {
	    return 0;
	  }
	
	  var overlapStartDate = rightStartTime < leftStartTime ? leftStartTime : rightStartTime;
	  var overlapEndDate = rightEndTime > leftEndTime ? leftEndTime : rightEndTime;
	  var differenceInMs = overlapEndDate - overlapStartDate;
	  return Math.ceil(differenceInMs / MILLISECONDS_IN_DAY);
	}
	
	module.exports = exports.default;

/***/ },
/* 1589 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUnixTime;
	
	var _index = _interopRequireDefault(__webpack_require__(396));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getUnixTime
	 * @category Timestamp Helpers
	 * @summary Get the seconds timestamp of the given date.
	 *
	 * @description
	 * Get the seconds timestamp of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the timestamp
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Get the timestamp of 29 February 2012 11:45:05 CET:
	 * const result = getUnixTime(new Date(2012, 1, 29, 11, 45, 5))
	 * //=> 1330512305
	 */
	function getUnixTime(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return Math.floor((0, _index.default)(dirtyDate) / 1000);
	}
	
	module.exports = exports.default;

/***/ },
/* 1590 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getWeekOfMonth;
	
	var _index = _interopRequireDefault(__webpack_require__(394));
	
	var _index2 = _interopRequireDefault(__webpack_require__(210));
	
	var _index3 = _interopRequireDefault(__webpack_require__(213));
	
	var _index4 = _interopRequireDefault(__webpack_require__(6));
	
	var _index5 = _interopRequireDefault(__webpack_require__(26));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getWeekOfMonth
	 * @category Week Helpers
	 * @summary Get the week of the month of the given date.
	 *
	 * @description
	 * Get the week of the month of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Number} the week of month
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6 inclusively
	 *
	 * @example
	 * // Which week of the month is 9 November 2017?
	 * const result = getWeekOfMonth(new Date(2017, 10, 9))
	 * //=> 2
	 */
	function getWeekOfMonth(date, options) {
	  var _options$locale, _options$locale$optio;
	
	  (0, _index4.default)(1, arguments);
	  var defaultWeekStartsOn = (options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) || 0;
	  var weekStartsOn = (options === null || options === void 0 ? void 0 : options.weekStartsOn) == null ? (0, _index5.default)(defaultWeekStartsOn) : (0, _index5.default)(options.weekStartsOn);
	
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	
	  var currentDayOfMonth = (0, _index.default)(date);
	  if (isNaN(currentDayOfMonth)) return NaN;
	  var startWeekDay = (0, _index2.default)((0, _index3.default)(date));
	  var lastDayOfFirstWeek = weekStartsOn - startWeekDay;
	  if (lastDayOfFirstWeek <= 0) lastDayOfFirstWeek += 7;
	  var remainingDaysAfterFirstWeek = currentDayOfMonth - lastDayOfFirstWeek;
	  return Math.ceil(remainingDaysAfterFirstWeek / 7) + 1;
	}
	
	module.exports = exports.default;

/***/ },
/* 1591 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getWeeksInMonth;
	
	var _index = _interopRequireDefault(__webpack_require__(387));
	
	var _index2 = _interopRequireDefault(__webpack_require__(655));
	
	var _index3 = _interopRequireDefault(__webpack_require__(213));
	
	var _index4 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getWeeksInMonth
	 * @category Week Helpers
	 * @summary Get the number of calendar weeks a month spans.
	 *
	 * @description
	 * Get the number of calendar weeks the month in the given date spans.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Number} the number of calendar weeks
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // How many calendar weeks does February 2015 span?
	 * const result = getWeeksInMonth(new Date(2015, 1, 8))
	 * //=> 4
	 *
	 * @example
	 * // If the week starts on Monday,
	 * // how many calendar weeks does July 2017 span?
	 * const result = getWeeksInMonth(new Date(2017, 6, 5), { weekStartsOn: 1 })
	 * //=> 6
	 */
	function getWeeksInMonth(date, options) {
	  (0, _index4.default)(1, arguments);
	  return (0, _index.default)((0, _index2.default)(date), (0, _index3.default)(date), options) + 1;
	}
	
	module.exports = exports.default;

/***/ },
/* 1592 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = hoursToMilliseconds;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	var _index2 = __webpack_require__(45);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name hoursToMilliseconds
	 * @category  Conversion Helpers
	 * @summary Convert hours to milliseconds.
	 *
	 * @description
	 * Convert a number of hours to a full number of milliseconds.
	 *
	 * @param {number} hours - number of hours to be converted
	 *
	 * @returns {number} the number of hours converted to milliseconds
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 2 hours to milliseconds:
	 * const result = hoursToMilliseconds(2)
	 * //=> 7200000
	 */
	function hoursToMilliseconds(hours) {
	  (0, _index.default)(1, arguments);
	  return Math.floor(hours * _index2.millisecondsInHour);
	}
	
	module.exports = exports.default;

/***/ },
/* 1593 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = hoursToMinutes;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	var _index2 = __webpack_require__(45);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name hoursToMinutes
	 * @category Conversion Helpers
	 * @summary Convert hours to minutes.
	 *
	 * @description
	 * Convert a number of hours to a full number of minutes.
	 *
	 * @param {number} hours - number of hours to be converted
	 *
	 * @returns {number} the number of hours converted in minutes
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 2 hours to minutes:
	 * const result = hoursToMinutes(2)
	 * //=> 120
	 */
	function hoursToMinutes(hours) {
	  (0, _index.default)(1, arguments);
	  return Math.floor(hours * _index2.minutesInHour);
	}
	
	module.exports = exports.default;

/***/ },
/* 1594 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = hoursToSeconds;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	var _index2 = __webpack_require__(45);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name hoursToSeconds
	 * @category Conversion Helpers
	 * @summary Convert hours to seconds.
	 *
	 * @description
	 * Convert a number of hours to a full number of seconds.
	 *
	 * @param {number} hours - number of hours to be converted
	 *
	 * @returns {number} the number of hours converted in seconds
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 2 hours to seconds:
	 * const result = hoursToSeconds(2)
	 * //=> 7200
	 */
	function hoursToSeconds(hours) {
	  (0, _index.default)(1, arguments);
	  return Math.floor(hours * _index2.secondsInHour);
	}
	
	module.exports = exports.default;

/***/ },
/* 1595 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = intervalToDuration;
	
	var _index = _interopRequireDefault(__webpack_require__(146));
	
	var _index2 = _interopRequireDefault(__webpack_require__(630));
	
	var _index3 = _interopRequireDefault(__webpack_require__(264));
	
	var _index4 = _interopRequireDefault(__webpack_require__(389));
	
	var _index5 = _interopRequireDefault(__webpack_require__(628));
	
	var _index6 = _interopRequireDefault(__webpack_require__(629));
	
	var _index7 = _interopRequireDefault(__webpack_require__(390));
	
	var _index8 = _interopRequireDefault(__webpack_require__(96));
	
	var _index9 = _interopRequireDefault(__webpack_require__(6));
	
	var _index10 = _interopRequireDefault(__webpack_require__(9));
	
	var _index11 = _interopRequireDefault(__webpack_require__(672));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name intervalToDuration
	 * @category Common Helpers
	 * @summary Convert interval to duration
	 *
	 * @description
	 * Convert a interval object to a duration object.
	 *
	 * @param {Interval} interval - the interval to convert to duration
	 *
	 * @returns {Duration} The duration Object
	 * @throws {TypeError} Requires 2 arguments
	 * @throws {RangeError} `start` must not be Invalid Date
	 * @throws {RangeError} `end` must not be Invalid Date
	 *
	 * @example
	 * // Get the duration between January 15, 1929 and April 4, 1968.
	 * intervalToDuration({
	 *   start: new Date(1929, 0, 15, 12, 0, 0),
	 *   end: new Date(1968, 3, 4, 19, 5, 0)
	 * })
	 * // => { years: 39, months: 2, days: 20, hours: 7, minutes: 5, seconds: 0 }
	 */
	function intervalToDuration(_ref) {
	  var start = _ref.start,
	      end = _ref.end;
	  (0, _index9.default)(1, arguments);
	  var dateLeft = (0, _index10.default)(start);
	  var dateRight = (0, _index10.default)(end);
	
	  if (!(0, _index8.default)(dateLeft)) {
	    throw new RangeError('Start Date is invalid');
	  }
	
	  if (!(0, _index8.default)(dateRight)) {
	    throw new RangeError('End Date is invalid');
	  }
	
	  var duration = {
	    years: 0,
	    months: 0,
	    days: 0,
	    hours: 0,
	    minutes: 0,
	    seconds: 0
	  };
	  var sign = (0, _index.default)(dateLeft, dateRight);
	  duration.years = Math.abs((0, _index2.default)(dateLeft, dateRight));
	  var remainingMonths = (0, _index11.default)(dateLeft, {
	    years: sign * duration.years
	  });
	  duration.months = Math.abs((0, _index3.default)(remainingMonths, dateRight));
	  var remainingDays = (0, _index11.default)(remainingMonths, {
	    months: sign * duration.months
	  });
	  duration.days = Math.abs((0, _index4.default)(remainingDays, dateRight));
	  var remainingHours = (0, _index11.default)(remainingDays, {
	    days: sign * duration.days
	  });
	  duration.hours = Math.abs((0, _index5.default)(remainingHours, dateRight));
	  var remainingMinutes = (0, _index11.default)(remainingHours, {
	    hours: sign * duration.hours
	  });
	  duration.minutes = Math.abs((0, _index6.default)(remainingMinutes, dateRight));
	  var remainingSeconds = (0, _index11.default)(remainingMinutes, {
	    minutes: sign * duration.minutes
	  });
	  duration.seconds = Math.abs((0, _index7.default)(remainingSeconds, dateRight));
	  return duration;
	}
	
	module.exports = exports.default;

/***/ },
/* 1596 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = intlFormat;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name intlFormat
	 * @category Common Helpers
	 * @summary  Format the date with Intl.DateTimeFormat (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat).
	 *
	 * @description
	 * Return the formatted date string in the given format.
	 * The method uses [`Intl.DateTimeFormat`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat) inside.
	 * formatOptions are the same as [`Intl.DateTimeFormat` options](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat#using_options)
	 *
	 * > ⚠️ Please note that before Node version 13.0.0, only the locale data for en-US is available by default.
	 *
	 * @param {Date|Number} argument - the original date.
	 * @param {Object} [formatOptions] - an object with options.
	 * @param {'lookup'|'best fit'} [formatOptions.localeMatcher='best fit'] - locale selection algorithm.
	 * @param {'narrow'|'short'|'long'} [formatOptions.weekday] - representation the days of the week.
	 * @param {'narrow'|'short'|'long'} [formatOptions.era] - representation of eras.
	 * @param {'numeric'|'2-digit'} [formatOptions.year] - representation of years.
	 * @param {'numeric'|'2-digit'|'narrow'|'short'|'long'} [formatOptions.month='numeric'] - representation of month.
	 * @param {'numeric'|'2-digit'} [formatOptions.day='numeric'] - representation of day.
	 * @param {'numeric'|'2-digit'} [formatOptions.hour='numeric'] - representation of hours.
	 * @param {'numeric'|'2-digit'} [formatOptions.minute] - representation of minutes.
	 * @param {'numeric'|'2-digit'} [formatOptions.second] - representation of seconds.
	 * @param {'short'|'long'} [formatOptions.timeZoneName] - representation of names of time zones.
	 * @param {'basic'|'best fit'} [formatOptions.formatMatcher='best fit'] - format selection algorithm.
	 * @param {Boolean} [formatOptions.hour12] - determines whether to use 12-hour time format.
	 * @param {String} [formatOptions.timeZone] - the time zone to use.
	 * @param {Object} [localeOptions] - an object with locale.
	 * @param {String|String[]} [localeOptions.locale] - the locale code
	 * @returns {String} the formatted date string.
	 * @throws {TypeError} 1 argument required.
	 * @throws {RangeError} `date` must not be Invalid Date
	 *
	 * @example
	 * // Represent 10 October 2019 in German.
	 * // Convert the date with format's options and locale's options.
	 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456), {
	 *      weekday: 'long',
	 *      year: 'numeric',
	 *      month: 'long',
	 *      day: 'numeric',
	 *    }, {
	 *      locale: 'de-DE',
	 *  })
	 * //=> Freitag, 4. Oktober 2019
	 *
	 * @example
	 * // Represent 10 October 2019.
	 * // Convert the date with format's options.
	 * const result = intlFormat.default(new Date(2019, 9, 4, 12, 30, 13, 456), {
	 *      year: 'numeric',
	 *      month: 'numeric',
	 *      day: 'numeric',
	 *      hour: 'numeric',
	 *  })
	 * //=> 10/4/2019, 12 PM
	 *
	 * @example
	 * // Represent 10 October 2019 in Korean.
	 * // Convert the date with locale's options.
	 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456), {
	 *      locale: 'ko-KR',
	 *  })
	 * //=> 2019. 10. 4.
	 *
	 * @example
	 * // Represent 10 October 2019 in middle-endian format:
	 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456))
	 * //=> 10/4/2019
	 */
	function intlFormat(date, formatOrLocale, localeOptions) {
	  var _localeOptions;
	
	  (0, _index.default)(1, arguments);
	  var formatOptions;
	
	  if (isFormatOptions(formatOrLocale)) {
	    formatOptions = formatOrLocale;
	  } else {
	    localeOptions = formatOrLocale;
	  }
	
	  return new Intl.DateTimeFormat((_localeOptions = localeOptions) === null || _localeOptions === void 0 ? void 0 : _localeOptions.locale, formatOptions).format(date);
	}
	
	function isFormatOptions(opts) {
	  return opts !== undefined && !('locale' in opts);
	}
	
	module.exports = exports.default;

/***/ },
/* 1597 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isExists;
	
	/**
	 * @name isExists
	 * @category Common Helpers
	 * @summary Is the given date exists?
	 *
	 * @description
	 * Checks if the given arguments convert to an existing date.
	 *
	 * @param {Number} year of the date to check
	 * @param {Number} month of the date to check
	 * @param {Number} day of the date to check
	 * @returns {Boolean} the date exists
	 * @throws {TypeError} 3 arguments required
	 *
	 * @example
	 * // For the valid date:
	 * var result = isExists(2018, 0, 31)
	 * //=> true
	 *
	 * @example
	 * // For the invalid date:
	 * var result = isExists(2018, 1, 31)
	 * //=> false
	 */
	function isExists(year, month, day) {
	  if (arguments.length < 3) {
	    throw new TypeError('3 argument required, but only ' + arguments.length + ' present');
	  }
	
	  var date = new Date(year, month, day);
	  return date.getFullYear() === year && date.getMonth() === month && date.getDate() === day;
	}
	
	module.exports = exports.default;

/***/ },
/* 1598 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isFirstDayOfMonth;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isFirstDayOfMonth
	 * @category Month Helpers
	 * @summary Is the given date the first day of a month?
	 *
	 * @description
	 * Is the given date the first day of a month?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is the first day of a month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Is 1 September 2014 the first day of a month?
	 * var result = isFirstDayOfMonth(new Date(2014, 8, 1))
	 * //=> true
	 */
	function isFirstDayOfMonth(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getDate() === 1;
	}
	
	module.exports = exports.default;

/***/ },
/* 1599 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isFriday;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isFriday
	 * @category Weekday Helpers
	 * @summary Is the given date Friday?
	 *
	 * @description
	 * Is the given date Friday?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is Friday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Is 26 September 2014 Friday?
	 * var result = isFriday(new Date(2014, 8, 26))
	 * //=> true
	 */
	function isFriday(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getDay() === 5;
	}
	
	module.exports = exports.default;

/***/ },
/* 1600 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isFuture;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isFuture
	 * @category Common Helpers
	 * @summary Is the given date in the future?
	 * @pure false
	 *
	 * @description
	 * Is the given date in the future?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is in the future
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If today is 6 October 2014, is 31 December 2014 in the future?
	 * var result = isFuture(new Date(2014, 11, 31))
	 * //=> true
	 */
	function isFuture(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getTime() > Date.now();
	}
	
	module.exports = exports.default;

/***/ },
/* 1601 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isMatch;
	
	var _index = _interopRequireDefault(__webpack_require__(411));
	
	var _index2 = _interopRequireDefault(__webpack_require__(96));
	
	var _index3 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isMatch
	 * @category Common Helpers
	 * @summary validates the date string against given formats
	 *
	 * @description
	 * Return the true if given date is string correct against the given format else
	 * will return false.
	 *
	 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
	 * > See: https://git.io/fxCyr
	 *
	 * The characters in the format string wrapped between two single quotes characters (') are escaped.
	 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
	 *
	 * Format of the format string is based on Unicode Technical Standard #35:
	 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
	 * with a few additions (see note 5 below the table).
	 *
	 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
	 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
	 *
	 * ```javascript
	 * isMatch('23 AM', 'HH a')
	 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
	 * ```
	 *
	 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
	 *
	 * Accepted format string patterns:
	 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
	 * |---------------------------------|-----|---------|-----------------------------------|-------|
	 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
	 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
	 * |                                 |     | GGGGG   | A, B                              |       |
	 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
	 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
	 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
	 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
	 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
	 * |                                 |     | yyyyy   | ...                               | 2,4   |
	 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
	 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
	 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
	 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
	 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
	 * |                                 |     | YYYYY   | ...                               | 2,4   |
	 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
	 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
	 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
	 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
	 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
	 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
	 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
	 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
	 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
	 * |                                 |     | uuuuu   | ...                               | 2,4   |
	 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
	 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
	 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
	 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
	 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
	 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
	 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
	 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
	 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
	 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
	 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
	 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
	 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
	 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
	 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
	 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
	 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
	 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
	 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
	 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
	 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
	 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
	 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
	 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
	 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
	 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
	 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
	 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
	 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
	 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
	 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
	 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
	 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
	 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
	 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
	 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
	 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
	 * |                                 |     | DDDD    | ...                               | 2     |
	 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Su            |       |
	 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
	 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
	 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
	 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
	 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
	 * |                                 |     | iii     | Mon, Tue, Wed, ..., Su            | 5     |
	 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
	 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
	 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
	 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
	 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
	 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
	 * |                                 |     | eee     | Mon, Tue, Wed, ..., Su            |       |
	 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
	 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
	 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
	 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
	 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
	 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Su            |       |
	 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
	 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
	 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
	 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
	 * |                                 |     | aaaaa   | a, p                              |       |
	 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
	 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
	 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
	 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
	 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
	 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
	 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
	 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
	 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
	 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
	 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
	 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
	 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
	 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
	 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
	 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
	 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
	 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
	 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
	 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
	 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
	 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
	 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
	 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
	 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
	 * |                                 |     | tt      | ...                               | 2     |
	 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
	 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
	 * |                                 |     | SSS     | 000, 001, ..., 999                |       |
	 * |                                 |     | SSSS    | ...                               | 2     |
	 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
	 * |                                 |     | TT      | ...                               | 2     |
	 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
	 * |                                 |     | XX      | -0800, +0530, Z                   |       |
	 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
	 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
	 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
	 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
	 * |                                 |     | xx      | -0800, +0530, +0000               |       |
	 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
	 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
	 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
	 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
	 * |                                 |     | PP      | May 29, 1453                      |       |
	 * |                                 |     | PPP     | May 29th, 1453                    |       |
	 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
	 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
	 * |                                 |     | pp      | 12:00:00 AM                       |       |
	 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
	 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
	 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
	 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
	 * Notes:
	 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
	 *    are the same as "stand-alone" units, but are different in some languages.
	 *    "Formatting" units are declined according to the rules of the language
	 *    in the context of a date. "Stand-alone" units are always nominative singular.
	 *    In `format` function, they will produce different result:
	 *
	 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
	 *
	 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
	 *
	 *    `isMatch` will try to match both formatting and stand-alone units interchangably.
	 *
	 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
	 *    the single quote characters (see below).
	 *    If the sequence is longer than listed in table:
	 *    - for numerical units (`yyyyyyyy`) `isMatch` will try to match a number
	 *      as wide as the sequence
	 *    - for text units (`MMMMMMMM`) `isMatch` will try to match the widest variation of the unit.
	 *      These variations are marked with "2" in the last column of the table.
	 *
	 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
	 *    These tokens represent the shortest form of the quarter.
	 *
	 * 4. The main difference between `y` and `u` patterns are B.C. years:
	 *
	 *    | Year | `y` | `u` |
	 *    |------|-----|-----|
	 *    | AC 1 |   1 |   1 |
	 *    | BC 1 |   1 |   0 |
	 *    | BC 2 |   2 |  -1 |
	 *
	 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
	 *
	 *    `isMatch('50', 'yy') //=> true`
	 *
	 *    `isMatch('75', 'yy') //=> true`
	 *
	 *    while `uu` will use the year as is:
	 *
	 *    `isMatch('50', 'uu') //=> true`
	 *
	 *    `isMatch('75', 'uu') //=> true`
	 *
	 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
	 *    except local week-numbering years are dependent on `options.weekStartsOn`
	 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear]{@link https://date-fns.org/docs/setISOWeekYear}
	 *    and [setWeekYear]{@link https://date-fns.org/docs/setWeekYear}).
	 *
	 * 5. These patterns are not in the Unicode Technical Standard #35:
	 *    - `i`: ISO day of week
	 *    - `I`: ISO week of year
	 *    - `R`: ISO week-numbering year
	 *    - `o`: ordinal number modifier
	 *    - `P`: long localized date
	 *    - `p`: long localized time
	 *
	 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
	 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
	 *
	 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
	 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
	 *
	 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
	 *    on the given locale.
	 *
	 *    using `en-US` locale: `P` => `MM/dd/yyyy`
	 *    using `en-US` locale: `p` => `hh:mm a`
	 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
	 *    using `pt-BR` locale: `p` => `HH:mm`
	 *
	 * Values will be checked in the descending order of its unit's priority.
	 * Units of an equal priority overwrite each other in the order of appearance.
	 *
	 * If no values of higher priority are matched (e.g. when matching string 'January 1st' without a year),
	 * the values will be taken from today's using `new Date()` date which works as a context of parsing.
	 *
	 * The result may vary by locale.
	 *
	 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
	 *
	 *
	 *
	 * @param {String} dateString - the date string to verify
	 * @param {String} formatString - the string of tokens
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
	 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
	 *   see: https://git.io/fxCyr
	 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
	 *   see: https://git.io/fxCyr
	 * @returns {Boolean}
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
	 * @throws {RangeError} `options.locale` must contain `match` property
	 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years; see: https://git.io/fxCyr
	 * @throws {RangeError} use `yy` instead of `YY` for formatting years; see: https://git.io/fxCyr
	 * @throws {RangeError} use `d` instead of `D` for formatting days of the month; see: https://git.io/fxCyr
	 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month; see: https://git.io/fxCyr
	 * @throws {RangeError} format string contains an unescaped latin alphabet character
	 *
	 * @example
	 * // Match 11 February 2014 from middle-endian format:
	 * var result = isMatch('02/11/2014', 'MM/dd/yyyy')
	 * //=> true
	 *
	 * @example
	 * // Match 28th of February in Esperanto locale in the context of 2010 year:
	 * import eo from 'date-fns/locale/eo'
	 * var result = isMatch('28-a de februaro', "do 'de' MMMM", {
	 *   locale: eo
	 * })
	 * //=> true
	 */
	function isMatch(dateString, formatString, options) {
	  (0, _index3.default)(2, arguments);
	  return (0, _index2.default)((0, _index.default)(dateString, formatString, new Date(), options));
	}
	
	module.exports = exports.default;

/***/ },
/* 1602 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isMonday;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isMonday
	 * @category Weekday Helpers
	 * @summary Is the given date Monday?
	 *
	 * @description
	 * Is the given date Monday?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is Monday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Is 22 September 2014 Monday?
	 * var result = isMonday(new Date(2014, 8, 22))
	 * //=> true
	 */
	function isMonday(date) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(date).getDay() === 1;
	}
	
	module.exports = exports.default;

/***/ },
/* 1603 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isPast;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isPast
	 * @category Common Helpers
	 * @summary Is the given date in the past?
	 * @pure false
	 *
	 * @description
	 * Is the given date in the past?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is in the past
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If today is 6 October 2014, is 2 July 2014 in the past?
	 * var result = isPast(new Date(2014, 6, 2))
	 * //=> true
	 */
	function isPast(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getTime() < Date.now();
	}
	
	module.exports = exports.default;

/***/ },
/* 1604 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameISOWeekYear;
	
	var _index = _interopRequireDefault(__webpack_require__(212));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isSameISOWeekYear
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Are the given dates in the same ISO week-numbering year?
	 *
	 * @description
	 * Are the given dates in the same ISO week-numbering year?
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `isSameISOYear` to `isSameISOWeekYear`.
	 *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
	 *   This change makes the name consistent with
	 *   locale-dependent week-numbering year helpers, e.g., `getWeekYear`.
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same ISO week-numbering year
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 29 December 2003 and 2 January 2005 in the same ISO week-numbering year?
	 * var result = isSameISOWeekYear(new Date(2003, 11, 29), new Date(2005, 0, 2))
	 * //=> true
	 */
	function isSameISOWeekYear(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeftStartOfYear = (0, _index.default)(dirtyDateLeft);
	  var dateRightStartOfYear = (0, _index.default)(dirtyDateRight);
	  return dateLeftStartOfYear.getTime() === dateRightStartOfYear.getTime();
	}
	
	module.exports = exports.default;

/***/ },
/* 1605 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isThisHour;
	
	var _index = _interopRequireDefault(__webpack_require__(649));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isThisHour
	 * @category Hour Helpers
	 * @summary Is the given date in the same hour as the current date?
	 * @pure false
	 *
	 * @description
	 * Is the given date in the same hour as the current date?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is in this hour
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If now is 25 September 2014 18:30:15.500,
	 * // is 25 September 2014 18:00:00 in this hour?
	 * var result = isThisHour(new Date(2014, 8, 25, 18))
	 * //=> true
	 */
	function isThisHour(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(Date.now(), dirtyDate);
	}
	
	module.exports = exports.default;

/***/ },
/* 1606 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isThisISOWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(650));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isThisISOWeek
	 * @category ISO Week Helpers
	 * @summary Is the given date in the same ISO week as the current date?
	 * @pure false
	 *
	 * @description
	 * Is the given date in the same ISO week as the current date?
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is in this ISO week
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If today is 25 September 2014, is 22 September 2014 in this ISO week?
	 * var result = isThisISOWeek(new Date(2014, 8, 22))
	 * //=> true
	 */
	function isThisISOWeek(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, Date.now());
	}
	
	module.exports = exports.default;

/***/ },
/* 1607 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isThisMinute;
	
	var _index = _interopRequireDefault(__webpack_require__(651));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isThisMinute
	 * @category Minute Helpers
	 * @summary Is the given date in the same minute as the current date?
	 * @pure false
	 *
	 * @description
	 * Is the given date in the same minute as the current date?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is in this minute
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If now is 25 September 2014 18:30:15.500,
	 * // is 25 September 2014 18:30:00 in this minute?
	 * var result = isThisMinute(new Date(2014, 8, 25, 18, 30))
	 * //=> true
	 */
	function isThisMinute(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(Date.now(), dirtyDate);
	}
	
	module.exports = exports.default;

/***/ },
/* 1608 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isThisMonth;
	
	var _index = _interopRequireDefault(__webpack_require__(399));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isThisMonth
	 * @category Month Helpers
	 * @summary Is the given date in the same month as the current date?
	 * @pure false
	 *
	 * @description
	 * Is the given date in the same month as the current date?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is in this month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If today is 25 September 2014, is 15 September 2014 in this month?
	 * var result = isThisMonth(new Date(2014, 8, 15))
	 * //=> true
	 */
	function isThisMonth(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(Date.now(), dirtyDate);
	}
	
	module.exports = exports.default;

/***/ },
/* 1609 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isThisQuarter;
	
	var _index = _interopRequireDefault(__webpack_require__(400));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isThisQuarter
	 * @category Quarter Helpers
	 * @summary Is the given date in the same quarter as the current date?
	 * @pure false
	 *
	 * @description
	 * Is the given date in the same quarter as the current date?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is in this quarter
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If today is 25 September 2014, is 2 July 2014 in this quarter?
	 * var result = isThisQuarter(new Date(2014, 6, 2))
	 * //=> true
	 */
	function isThisQuarter(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(Date.now(), dirtyDate);
	}
	
	module.exports = exports.default;

/***/ },
/* 1610 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isThisSecond;
	
	var _index = _interopRequireDefault(__webpack_require__(652));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isThisSecond
	 * @category Second Helpers
	 * @summary Is the given date in the same second as the current date?
	 * @pure false
	 *
	 * @description
	 * Is the given date in the same second as the current date?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is in this second
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If now is 25 September 2014 18:30:15.500,
	 * // is 25 September 2014 18:30:15.000 in this second?
	 * var result = isThisSecond(new Date(2014, 8, 25, 18, 30, 15))
	 * //=> true
	 */
	function isThisSecond(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(Date.now(), dirtyDate);
	}
	
	module.exports = exports.default;

/***/ },
/* 1611 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isThisWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(401));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isThisWeek
	 * @category Week Helpers
	 * @summary Is the given date in the same week as the current date?
	 * @pure false
	 *
	 * @description
	 * Is the given date in the same week as the current date?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @param {Object} [options] - the object with options
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Boolean} the date is in this week
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // If today is 25 September 2014, is 21 September 2014 in this week?
	 * var result = isThisWeek(new Date(2014, 8, 21))
	 * //=> true
	 *
	 * @example
	 * // If today is 25 September 2014 and week starts with Monday
	 * // is 21 September 2014 in this week?
	 * var result = isThisWeek(new Date(2014, 8, 21), { weekStartsOn: 1 })
	 * //=> false
	 */
	function isThisWeek(dirtyDate, options) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, Date.now(), options);
	}
	
	module.exports = exports.default;

/***/ },
/* 1612 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isThisYear;
	
	var _index = _interopRequireDefault(__webpack_require__(402));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isThisYear
	 * @category Year Helpers
	 * @summary Is the given date in the same year as the current date?
	 * @pure false
	 *
	 * @description
	 * Is the given date in the same year as the current date?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is in this year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If today is 25 September 2014, is 2 July 2014 in this year?
	 * var result = isThisYear(new Date(2014, 6, 2))
	 * //=> true
	 */
	function isThisYear(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, Date.now());
	}
	
	module.exports = exports.default;

/***/ },
/* 1613 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isThursday;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isThursday
	 * @category Weekday Helpers
	 * @summary Is the given date Thursday?
	 *
	 * @description
	 * Is the given date Thursday?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is Thursday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Is 25 September 2014 Thursday?
	 * var result = isThursday(new Date(2014, 8, 25))
	 * //=> true
	 */
	function isThursday(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getDay() === 4;
	}
	
	module.exports = exports.default;

/***/ },
/* 1614 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isToday;
	
	var _index = _interopRequireDefault(__webpack_require__(172));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isToday
	 * @category Day Helpers
	 * @summary Is the given date today?
	 * @pure false
	 *
	 * @description
	 * Is the given date today?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is today
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If today is 6 October 2014, is 6 October 14:00:00 today?
	 * var result = isToday(new Date(2014, 9, 6, 14, 0))
	 * //=> true
	 */
	function isToday(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, Date.now());
	}
	
	module.exports = exports.default;

/***/ },
/* 1615 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isTomorrow;
	
	var _index = _interopRequireDefault(__webpack_require__(95));
	
	var _index2 = _interopRequireDefault(__webpack_require__(172));
	
	var _index3 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isTomorrow
	 * @category Day Helpers
	 * @summary Is the given date tomorrow?
	 * @pure false
	 *
	 * @description
	 * Is the given date tomorrow?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is tomorrow
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If today is 6 October 2014, is 7 October 14:00:00 tomorrow?
	 * var result = isTomorrow(new Date(2014, 9, 7, 14, 0))
	 * //=> true
	 */
	function isTomorrow(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  return (0, _index2.default)(dirtyDate, (0, _index.default)(Date.now(), 1));
	}
	
	module.exports = exports.default;

/***/ },
/* 1616 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isTuesday;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isTuesday
	 * @category Weekday Helpers
	 * @summary Is the given date Tuesday?
	 *
	 * @description
	 * Is the given date Tuesday?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is Tuesday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Is 23 September 2014 Tuesday?
	 * var result = isTuesday(new Date(2014, 8, 23))
	 * //=> true
	 */
	function isTuesday(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getDay() === 2;
	}
	
	module.exports = exports.default;

/***/ },
/* 1617 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isWednesday;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isWednesday
	 * @category Weekday Helpers
	 * @summary Is the given date Wednesday?
	 *
	 * @description
	 * Is the given date Wednesday?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is Wednesday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Is 24 September 2014 Wednesday?
	 * const result = isWednesday(new Date(2014, 8, 24))
	 * //=> true
	 */
	function isWednesday(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getDay() === 3;
	}
	
	module.exports = exports.default;

/***/ },
/* 1618 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isYesterday;
	
	var _index = _interopRequireDefault(__webpack_require__(172));
	
	var _index2 = _interopRequireDefault(__webpack_require__(214));
	
	var _index3 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isYesterday
	 * @category Day Helpers
	 * @summary Is the given date yesterday?
	 * @pure false
	 *
	 * @description
	 * Is the given date yesterday?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is yesterday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If today is 6 October 2014, is 5 October 14:00:00 yesterday?
	 * var result = isYesterday(new Date(2014, 9, 5, 14, 0))
	 * //=> true
	 */
	function isYesterday(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, (0, _index2.default)(Date.now(), 1));
	}
	
	module.exports = exports.default;

/***/ },
/* 1619 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = lastDayOfDecade;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name lastDayOfDecade
	 * @category Decade Helpers
	 * @summary Return the last day of a decade for the given date.
	 *
	 * @description
	 * Return the last day of a decade for the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the last day of a decade
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The last day of a decade for 21 December 2012 21:12:00:
	 * var result = lastDayOfDecade(new Date(2012, 11, 21, 21, 12, 00))
	 * //=> Wed Dec 31 2019 00:00:00
	 */
	function lastDayOfDecade(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  var decade = 9 + Math.floor(year / 10) * 10;
	  date.setFullYear(decade + 1, 0, 0);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 1620 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = lastDayOfISOWeekYear;
	
	var _index = _interopRequireDefault(__webpack_require__(171));
	
	var _index2 = _interopRequireDefault(__webpack_require__(148));
	
	var _index3 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name lastDayOfISOWeekYear
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Return the last day of an ISO week-numbering year for the given date.
	 *
	 * @description
	 * Return the last day of an ISO week-numbering year,
	 * which always starts 3 days before the year's first Thursday.
	 * The result will be in the local timezone.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `lastDayOfISOYear` to `lastDayOfISOWeekYear`.
	 *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
	 *   This change makes the name consistent with
	 *   locale-dependent week-numbering year helpers, e.g., `getWeekYear`.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of an ISO week-numbering year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The last day of an ISO week-numbering year for 2 July 2005:
	 * var result = lastDayOfISOWeekYear(new Date(2005, 6, 2))
	 * //=> Sun Jan 01 2006 00:00:00
	 */
	function lastDayOfISOWeekYear(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  var year = (0, _index.default)(dirtyDate);
	  var fourthOfJanuary = new Date(0);
	  fourthOfJanuary.setFullYear(year + 1, 0, 4);
	  fourthOfJanuary.setHours(0, 0, 0, 0);
	  var date = (0, _index2.default)(fourthOfJanuary);
	  date.setDate(date.getDate() - 1);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 1621 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = lastDayOfISOWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(656));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name lastDayOfISOWeek
	 * @category ISO Week Helpers
	 * @summary Return the last day of an ISO week for the given date.
	 *
	 * @description
	 * Return the last day of an ISO week for the given date.
	 * The result will be in the local timezone.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the last day of an ISO week
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The last day of an ISO week for 2 September 2014 11:55:00:
	 * var result = lastDayOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Sun Sep 07 2014 00:00:00
	 */
	function lastDayOfISOWeek(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, {
	    weekStartsOn: 1
	  });
	}
	
	module.exports = exports.default;

/***/ },
/* 1622 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = lastDayOfQuarter;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name lastDayOfQuarter
	 * @category Quarter Helpers
	 * @summary Return the last day of a year quarter for the given date.
	 *
	 * @description
	 * Return the last day of a year quarter for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @param {Object} [options] - an object with options.
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Date} the last day of a quarter
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // The last day of a quarter for 2 September 2014 11:55:00:
	 * var result = lastDayOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 30 2014 00:00:00
	 */
	function lastDayOfQuarter(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var currentMonth = date.getMonth();
	  var month = currentMonth - currentMonth % 3 + 3;
	  date.setMonth(month, 0);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 1623 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = lastDayOfYear;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name lastDayOfYear
	 * @category Year Helpers
	 * @summary Return the last day of a year for the given date.
	 *
	 * @description
	 * Return the last day of a year for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the last day of a year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The last day of a year for 2 September 2014 11:55:00:
	 * var result = lastDayOfYear(new Date(2014, 8, 2, 11, 55, 00))
	 * //=> Wed Dec 31 2014 00:00:00
	 */
	function lastDayOfYear(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  date.setFullYear(year + 1, 0, 0);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 1624 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = lightFormat;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(618));
	
	var _index3 = _interopRequireDefault(__webpack_require__(107));
	
	var _index4 = _interopRequireDefault(__webpack_require__(96));
	
	var _index5 = _interopRequireDefault(__webpack_require__(215));
	
	var _index6 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This RegExp consists of three parts separated by `|`:
	// - (\w)\1* matches any sequences of the same letter
	// - '' matches two quote characters in a row
	// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
	//   except a single quote symbol, which ends the sequence.
	//   Two quote characters do not end the sequence.
	//   If there is no matching single quote
	//   then the sequence will continue until the end of the string.
	// - . matches any single character unmatched by previous parts of the RegExps
	var formattingTokensRegExp = /(\w)\1*|''|'(''|[^'])+('|$)|./g;
	var escapedStringRegExp = /^'([^]*?)'?$/;
	var doubleQuoteRegExp = /''/g;
	var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
	/**
	 * @name lightFormat
	 * @category Common Helpers
	 * @summary Format the date.
	 *
	 * @description
	 * Return the formatted date string in the given format. Unlike `format`,
	 * `lightFormat` doesn't use locales and outputs date using the most popular tokens.
	 *
	 * > ⚠️ Please note that the `lightFormat` tokens differ from Moment.js and other libraries.
	 * > See: https://git.io/fxCyr
	 *
	 * The characters wrapped between two single quotes characters (') are escaped.
	 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
	 *
	 * Format of the string is based on Unicode Technical Standard #35:
	 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
	 *
	 * Accepted patterns:
	 * | Unit                            | Pattern | Result examples                   |
	 * |---------------------------------|---------|-----------------------------------|
	 * | AM, PM                          | a..aaa  | AM, PM                            |
	 * |                                 | aaaa    | a.m., p.m.                        |
	 * |                                 | aaaaa   | a, p                              |
	 * | Calendar year                   | y       | 44, 1, 1900, 2017                 |
	 * |                                 | yy      | 44, 01, 00, 17                    |
	 * |                                 | yyy     | 044, 001, 000, 017                |
	 * |                                 | yyyy    | 0044, 0001, 1900, 2017            |
	 * | Month (formatting)              | M       | 1, 2, ..., 12                     |
	 * |                                 | MM      | 01, 02, ..., 12                   |
	 * | Day of month                    | d       | 1, 2, ..., 31                     |
	 * |                                 | dd      | 01, 02, ..., 31                   |
	 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |
	 * |                                 | hh      | 01, 02, ..., 11, 12               |
	 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |
	 * |                                 | HH      | 00, 01, 02, ..., 23               |
	 * | Minute                          | m       | 0, 1, ..., 59                     |
	 * |                                 | mm      | 00, 01, ..., 59                   |
	 * | Second                          | s       | 0, 1, ..., 59                     |
	 * |                                 | ss      | 00, 01, ..., 59                   |
	 * | Fraction of second              | S       | 0, 1, ..., 9                      |
	 * |                                 | SS      | 00, 01, ..., 99                   |
	 * |                                 | SSS     | 000, 001, ..., 999                |
	 * |                                 | SSSS    | ...                               |
	 *
	 * @param {Date|Number} date - the original date
	 * @param {String} format - the string of tokens
	 * @returns {String} the formatted date string
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} format string contains an unescaped latin alphabet character
	 *
	 * @example
	 * const result = lightFormat(new Date(2014, 1, 11), 'yyyy-MM-dd')
	 * //=> '2014-02-11'
	 */
	
	function lightFormat(dirtyDate, formatStr) {
	  (0, _index6.default)(2, arguments);
	  var originalDate = (0, _index.default)(dirtyDate);
	
	  if (!(0, _index4.default)(originalDate)) {
	    throw new RangeError('Invalid time value');
	  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
	  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
	  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
	
	
	  var timezoneOffset = (0, _index3.default)(originalDate);
	  var utcDate = (0, _index5.default)(originalDate, timezoneOffset);
	  var tokens = formatStr.match(formattingTokensRegExp); // The only case when formattingTokensRegExp doesn't match the string is when it's empty
	
	  if (!tokens) return '';
	  var result = tokens.map(function (substring) {
	    // Replace two single quote characters with one single quote character
	    if (substring === "''") {
	      return "'";
	    }
	
	    var firstCharacter = substring[0];
	
	    if (firstCharacter === "'") {
	      return cleanEscapedString(substring);
	    }
	
	    var formatter = _index2.default[firstCharacter];
	
	    if (formatter) {
	      return formatter(utcDate, substring);
	    }
	
	    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
	      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
	    }
	
	    return substring;
	  }).join('');
	  return result;
	}
	
	function cleanEscapedString(input) {
	  var matches = input.match(escapedStringRegExp);
	
	  if (!matches) {
	    return input;
	  }
	
	  return matches[1].replace(doubleQuoteRegExp, "'");
	}
	
	module.exports = exports.default;

/***/ },
/* 1625 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'less than a second',
	    other: 'less than {{count}} seconds'
	  },
	  xSeconds: {
	    one: '1 second',
	    other: '{{count}} seconds'
	  },
	  halfAMinute: 'half a minute',
	  lessThanXMinutes: {
	    one: 'less than a minute',
	    other: 'less than {{count}} minutes'
	  },
	  xMinutes: {
	    one: '1 minute',
	    other: '{{count}} minutes'
	  },
	  aboutXHours: {
	    one: 'about 1 hour',
	    other: 'about {{count}} hours'
	  },
	  xHours: {
	    one: '1 hour',
	    other: '{{count}} hours'
	  },
	  xDays: {
	    one: '1 day',
	    other: '{{count}} days'
	  },
	  aboutXWeeks: {
	    one: 'about 1 week',
	    other: 'about {{count}} weeks'
	  },
	  xWeeks: {
	    one: '1 week',
	    other: '{{count}} weeks'
	  },
	  aboutXMonths: {
	    one: 'about 1 month',
	    other: 'about {{count}} months'
	  },
	  xMonths: {
	    one: '1 month',
	    other: '{{count}} months'
	  },
	  aboutXYears: {
	    one: 'about 1 year',
	    other: 'about {{count}} years'
	  },
	  xYears: {
	    one: '1 year',
	    other: '{{count}} years'
	  },
	  overXYears: {
	    one: 'over 1 year',
	    other: 'over {{count}} years'
	  },
	  almostXYears: {
	    one: 'almost 1 year',
	    other: 'almost {{count}} years'
	  }
	};
	
	var formatDistance = function (token, count, options) {
	  var result;
	  var tokenValue = formatDistanceLocale[token];
	
	  if (typeof tokenValue === 'string') {
	    result = tokenValue;
	  } else if (count === 1) {
	    result = tokenValue.one;
	  } else {
	    result = tokenValue.other.replace('{{count}}', count.toString());
	  }
	
	  if (options !== null && options !== void 0 && options.addSuffix) {
	    if (options.comparison && options.comparison > 0) {
	      return 'in ' + result;
	    } else {
	      return result + ' ago';
	    }
	  }
	
	  return result;
	};
	
	var _default = formatDistance;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1626 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(404));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE, MMMM do, y',
	  long: 'MMMM do, y',
	  medium: 'MMM d, y',
	  short: 'MM/dd/yyyy'
	};
	var timeFormats = {
	  full: 'h:mm:ss a zzzz',
	  long: 'h:mm:ss a z',
	  medium: 'h:mm:ss a',
	  short: 'h:mm a'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'at' {{time}}",
	  long: "{{date}} 'at' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1627 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var formatRelativeLocale = {
	  lastWeek: "'last' eeee 'at' p",
	  yesterday: "'yesterday at' p",
	  today: "'today at' p",
	  tomorrow: "'tomorrow at' p",
	  nextWeek: "eeee 'at' p",
	  other: 'P'
	};
	
	var formatRelative = function (token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	};
	
	var _default = formatRelative;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1628 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(405));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['B', 'A'],
	  abbreviated: ['BC', 'AD'],
	  wide: ['Before Christ', 'Anno Domini']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
	  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
	}; // Note: in English, the names of days of the week and months are capitalized.
	// If you are making a new locale based on this one, check if the same is true for the language you're working on.
	// Generally, formatted dates should look like they are in the middle of a sentence,
	// e.g. in Spanish language the weekdays and months should be in the lowercase.
	
	var monthValues = {
	  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
	  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
	  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
	};
	var dayValues = {
	  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
	  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
	  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
	  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'mi',
	    noon: 'n',
	    morning: 'morning',
	    afternoon: 'afternoon',
	    evening: 'evening',
	    night: 'night'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'midnight',
	    noon: 'noon',
	    morning: 'morning',
	    afternoon: 'afternoon',
	    evening: 'evening',
	    night: 'night'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'midnight',
	    noon: 'noon',
	    morning: 'morning',
	    afternoon: 'afternoon',
	    evening: 'evening',
	    night: 'night'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'mi',
	    noon: 'n',
	    morning: 'in the morning',
	    afternoon: 'in the afternoon',
	    evening: 'in the evening',
	    night: 'at night'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'midnight',
	    noon: 'noon',
	    morning: 'in the morning',
	    afternoon: 'in the afternoon',
	    evening: 'in the evening',
	    night: 'at night'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'midnight',
	    noon: 'noon',
	    morning: 'in the morning',
	    afternoon: 'in the afternoon',
	    evening: 'in the evening',
	    night: 'at night'
	  }
	};
	
	var ordinalNumber = function (dirtyNumber, _options) {
	  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
	  // if they are different for different grammatical genders,
	  // use `options.unit`.
	  //
	  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
	  // 'day', 'hour', 'minute', 'second'.
	
	  var rem100 = number % 100;
	
	  if (rem100 > 20 || rem100 < 10) {
	    switch (rem100 % 10) {
	      case 1:
	        return number + 'st';
	
	      case 2:
	        return number + 'nd';
	
	      case 3:
	        return number + 'rd';
	    }
	  }
	
	  return number + 'th';
	};
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return quarter - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1629 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(406));
	
	var _index2 = _interopRequireDefault(__webpack_require__(407));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(b|a)/i,
	  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
	  wide: /^(before christ|before common era|anno domini|common era)/i
	};
	var parseEraPatterns = {
	  any: [/^b/i, /^(a|c)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^q[1234]/i,
	  wide: /^[1234](th|st|nd|rd)? quarter/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[jfmasond]/i,
	  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
	  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
	  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
	};
	var matchDayPatterns = {
	  narrow: /^[smtwf]/i,
	  short: /^(su|mo|tu|we|th|fr|sa)/i,
	  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
	  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
	};
	var parseDayPatterns = {
	  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
	  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
	  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a/i,
	    pm: /^p/i,
	    midnight: /^mi/i,
	    noon: /^no/i,
	    morning: /morning/i,
	    afternoon: /afternoon/i,
	    evening: /evening/i,
	    night: /night/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index2.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1630 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'menos de un segundo',
	    other: 'menos de {{count}} segundos'
	  },
	  xSeconds: {
	    one: '1 segundo',
	    other: '{{count}} segundos'
	  },
	  halfAMinute: 'medio minuto',
	  lessThanXMinutes: {
	    one: 'menos de un minuto',
	    other: 'menos de {{count}} minutos'
	  },
	  xMinutes: {
	    one: '1 minuto',
	    other: '{{count}} minutos'
	  },
	  aboutXHours: {
	    one: 'alrededor de 1 hora',
	    other: 'alrededor de {{count}} horas'
	  },
	  xHours: {
	    one: '1 hora',
	    other: '{{count}} horas'
	  },
	  xDays: {
	    one: '1 día',
	    other: '{{count}} días'
	  },
	  aboutXWeeks: {
	    one: 'alrededor de 1 semana',
	    other: 'alrededor de {{count}} semanas'
	  },
	  xWeeks: {
	    one: '1 semana',
	    other: '{{count}} semanas'
	  },
	  aboutXMonths: {
	    one: 'alrededor de 1 mes',
	    other: 'alrededor de {{count}} meses'
	  },
	  xMonths: {
	    one: '1 mes',
	    other: '{{count}} meses'
	  },
	  aboutXYears: {
	    one: 'alrededor de 1 año',
	    other: 'alrededor de {{count}} años'
	  },
	  xYears: {
	    one: '1 año',
	    other: '{{count}} años'
	  },
	  overXYears: {
	    one: 'más de 1 año',
	    other: 'más de {{count}} años'
	  },
	  almostXYears: {
	    one: 'casi 1 año',
	    other: 'casi {{count}} años'
	  }
	};
	
	var formatDistance = function (token, count, options) {
	  var result;
	  var tokenValue = formatDistanceLocale[token];
	
	  if (typeof tokenValue === 'string') {
	    result = tokenValue;
	  } else if (count === 1) {
	    result = tokenValue.one;
	  } else {
	    result = tokenValue.other.replace('{{count}}', count.toString());
	  }
	
	  if (options !== null && options !== void 0 && options.addSuffix) {
	    if (options.comparison && options.comparison > 0) {
	      return 'en ' + result;
	    } else {
	      return 'hace ' + result;
	    }
	  }
	
	  return result;
	};
	
	var _default = formatDistance;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1631 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(404));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: "EEEE, d 'de' MMMM 'de' y",
	  long: "d 'de' MMMM 'de' y",
	  medium: 'd MMM y',
	  short: 'dd/MM/y'
	};
	var timeFormats = {
	  full: 'HH:mm:ss zzzz',
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'a las' {{time}}",
	  long: "{{date}} 'a las' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1632 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var formatRelativeLocale = {
	  lastWeek: "'el' eeee 'pasado a la' p",
	  yesterday: "'ayer a la' p",
	  today: "'hoy a la' p",
	  tomorrow: "'mañana a la' p",
	  nextWeek: "eeee 'a la' p",
	  other: 'P'
	};
	var formatRelativeLocalePlural = {
	  lastWeek: "'el' eeee 'pasado a las' p",
	  yesterday: "'ayer a las' p",
	  today: "'hoy a las' p",
	  tomorrow: "'mañana a las' p",
	  nextWeek: "eeee 'a las' p",
	  other: 'P'
	};
	
	var formatRelative = function (token, date, _baseDate, _options) {
	  if (date.getUTCHours() !== 1) {
	    return formatRelativeLocalePlural[token];
	  } else {
	    return formatRelativeLocale[token];
	  }
	};
	
	var _default = formatRelative;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1633 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(405));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['AC', 'DC'],
	  abbreviated: ['AC', 'DC'],
	  wide: ['antes de cristo', 'después de cristo']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['T1', 'T2', 'T3', 'T4'],
	  wide: ['1º trimestre', '2º trimestre', '3º trimestre', '4º trimestre']
	};
	var monthValues = {
	  narrow: ['e', 'f', 'm', 'a', 'm', 'j', 'j', 'a', 's', 'o', 'n', 'd'],
	  abbreviated: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
	  wide: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre']
	};
	var dayValues = {
	  narrow: ['d', 'l', 'm', 'm', 'j', 'v', 's'],
	  short: ['do', 'lu', 'ma', 'mi', 'ju', 'vi', 'sá'],
	  abbreviated: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
	  wide: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'mn',
	    noon: 'md',
	    morning: 'mañana',
	    afternoon: 'tarde',
	    evening: 'tarde',
	    night: 'noche'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'medianoche',
	    noon: 'mediodia',
	    morning: 'mañana',
	    afternoon: 'tarde',
	    evening: 'tarde',
	    night: 'noche'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'medianoche',
	    noon: 'mediodia',
	    morning: 'mañana',
	    afternoon: 'tarde',
	    evening: 'tarde',
	    night: 'noche'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'mn',
	    noon: 'md',
	    morning: 'de la mañana',
	    afternoon: 'de la tarde',
	    evening: 'de la tarde',
	    night: 'de la noche'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'medianoche',
	    noon: 'mediodia',
	    morning: 'de la mañana',
	    afternoon: 'de la tarde',
	    evening: 'de la tarde',
	    night: 'de la noche'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'medianoche',
	    noon: 'mediodia',
	    morning: 'de la mañana',
	    afternoon: 'de la tarde',
	    evening: 'de la tarde',
	    night: 'de la noche'
	  }
	};
	
	var ordinalNumber = function (dirtyNumber, _options) {
	  var number = Number(dirtyNumber);
	  return number + 'º';
	};
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1634 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(407));
	
	var _index2 = _interopRequireDefault(__webpack_require__(406));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(º)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(ac|dc|a|d)/i,
	  abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
	  wide: /^(antes de cristo|antes de la era com[uú]n|despu[eé]s de cristo|era com[uú]n)/i
	};
	var parseEraPatterns = {
	  any: [/^ac/i, /^dc/i],
	  wide: [/^(antes de cristo|antes de la era com[uú]n)/i, /^(despu[eé]s de cristo|era com[uú]n)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^T[1234]/i,
	  wide: /^[1234](º)? trimestre/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[efmajsond]/i,
	  abbreviated: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)/i,
	  wide: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^e/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
	  any: [/^en/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i]
	};
	var matchDayPatterns = {
	  narrow: /^[dlmjvs]/i,
	  short: /^(do|lu|ma|mi|ju|vi|s[áa])/i,
	  abbreviated: /^(dom|lun|mar|mi[ée]|jue|vie|s[áa]b)/i,
	  wide: /^(domingo|lunes|martes|mi[ée]rcoles|jueves|viernes|s[áa]bado)/i
	};
	var parseDayPatterns = {
	  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
	  any: [/^do/i, /^lu/i, /^ma/i, /^mi/i, /^ju/i, /^vi/i, /^sa/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(a|p|mn|md|(de la|a las) (mañana|tarde|noche))/i,
	  any: /^([ap]\.?\s?m\.?|medianoche|mediodia|(de la|a las) (mañana|tarde|noche))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a/i,
	    pm: /^p/i,
	    midnight: /^mn/i,
	    noon: /^md/i,
	    morning: /mañana/i,
	    afternoon: /tarde/i,
	    evening: /tarde/i,
	    night: /noche/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1635 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'menos de um segundo',
	    other: 'menos de {{count}} segundos'
	  },
	  xSeconds: {
	    one: '1 segundo',
	    other: '{{count}} segundos'
	  },
	  halfAMinute: 'meio minuto',
	  lessThanXMinutes: {
	    one: 'menos de um minuto',
	    other: 'menos de {{count}} minutos'
	  },
	  xMinutes: {
	    one: '1 minuto',
	    other: '{{count}} minutos'
	  },
	  aboutXHours: {
	    one: 'cerca de 1 hora',
	    other: 'cerca de {{count}} horas'
	  },
	  xHours: {
	    one: '1 hora',
	    other: '{{count}} horas'
	  },
	  xDays: {
	    one: '1 dia',
	    other: '{{count}} dias'
	  },
	  aboutXWeeks: {
	    one: 'cerca de 1 semana',
	    other: 'cerca de {{count}} semanas'
	  },
	  xWeeks: {
	    one: '1 semana',
	    other: '{{count}} semanas'
	  },
	  aboutXMonths: {
	    one: 'cerca de 1 mês',
	    other: 'cerca de {{count}} meses'
	  },
	  xMonths: {
	    one: '1 mês',
	    other: '{{count}} meses'
	  },
	  aboutXYears: {
	    one: 'cerca de 1 ano',
	    other: 'cerca de {{count}} anos'
	  },
	  xYears: {
	    one: '1 ano',
	    other: '{{count}} anos'
	  },
	  overXYears: {
	    one: 'mais de 1 ano',
	    other: 'mais de {{count}} anos'
	  },
	  almostXYears: {
	    one: 'quase 1 ano',
	    other: 'quase {{count}} anos'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'em ' + result;
	    } else {
	      return 'há ' + result;
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ },
/* 1636 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(404));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: "EEEE, d 'de' MMMM 'de' y",
	  long: "d 'de' MMMM 'de' y",
	  medium: 'd MMM y',
	  short: 'dd/MM/yyyy'
	};
	var timeFormats = {
	  full: 'HH:mm:ss zzzz',
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'às' {{time}}",
	  long: "{{date}} 'às' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1637 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: function (date, _baseDate, _options) {
	    var weekday = date.getUTCDay();
	    var last = weekday === 0 || weekday === 6 ? 'último' : 'última';
	    return "'" + last + "' eeee 'às' p";
	  },
	  yesterday: "'ontem às' p",
	  today: "'hoje às' p",
	  tomorrow: "'amanhã às' p",
	  nextWeek: "eeee 'às' p",
	  other: 'P'
	};
	
	function formatRelative(token, date, baseDate, options) {
	  var format = formatRelativeLocale[token];
	
	  if (typeof format === 'function') {
	    return format(date, baseDate, options);
	  }
	
	  return format;
	}
	
	module.exports = exports.default;

/***/ },
/* 1638 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(405));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['AC', 'DC'],
	  abbreviated: ['AC', 'DC'],
	  wide: ['antes de cristo', 'depois de cristo']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['T1', 'T2', 'T3', 'T4'],
	  wide: ['1º trimestre', '2º trimestre', '3º trimestre', '4º trimestre']
	};
	var monthValues = {
	  narrow: ['j', 'f', 'm', 'a', 'm', 'j', 'j', 'a', 's', 'o', 'n', 'd'],
	  abbreviated: ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
	  wide: ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro']
	};
	var dayValues = {
	  narrow: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
	  short: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sab'],
	  abbreviated: ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado'],
	  wide: ['domingo', 'segunda-feira', 'terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sábado']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'mn',
	    noon: 'md',
	    morning: 'manhã',
	    afternoon: 'tarde',
	    evening: 'tarde',
	    night: 'noite'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'meia-noite',
	    noon: 'meio-dia',
	    morning: 'manhã',
	    afternoon: 'tarde',
	    evening: 'tarde',
	    night: 'noite'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'meia-noite',
	    noon: 'meio-dia',
	    morning: 'manhã',
	    afternoon: 'tarde',
	    evening: 'tarde',
	    night: 'noite'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'mn',
	    noon: 'md',
	    morning: 'da manhã',
	    afternoon: 'da tarde',
	    evening: 'da tarde',
	    night: 'da noite'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'meia-noite',
	    noon: 'meio-dia',
	    morning: 'da manhã',
	    afternoon: 'da tarde',
	    evening: 'da tarde',
	    night: 'da noite'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'meia-noite',
	    noon: 'meio-dia',
	    morning: 'da manhã',
	    afternoon: 'da tarde',
	    evening: 'da tarde',
	    night: 'da noite'
	  }
	};
	
	function ordinalNumber(dirtyNumber, dirtyOptions) {
	  var number = Number(dirtyNumber);
	  var options = dirtyOptions || {};
	  var unit = String(options.unit);
	
	  if (unit === 'week' || unit === 'isoWeek') {
	    return number + 'ª';
	  }
	
	  return number + 'º';
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1639 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(406));
	
	var _index2 = _interopRequireDefault(__webpack_require__(407));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)[ºªo]?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(ac|dc|a|d)/i,
	  abbreviated: /^(a\.?\s?c\.?|d\.?\s?c\.?)/i,
	  wide: /^(antes de cristo|depois de cristo)/i
	};
	var parseEraPatterns = {
	  any: [/^ac/i, /^dc/i],
	  wide: [/^antes de cristo/i, /^depois de cristo/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^T[1234]/i,
	  wide: /^[1234](º)? trimestre/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[jfmajsond]/i,
	  abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
	  wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
	  any: [/^ja/i, /^fev/i, /^mar/i, /^abr/i, /^mai/i, /^jun/i, /^jul/i, /^ago/i, /^set/i, /^out/i, /^nov/i, /^dez/i]
	};
	var matchDayPatterns = {
	  narrow: /^(dom|[23456]ª?|s[aá]b)/i,
	  short: /^(dom|[23456]ª?|s[aá]b)/i,
	  abbreviated: /^(dom|seg|ter|qua|qui|sex|s[aá]b)/i,
	  wide: /^(domingo|(segunda|ter[cç]a|quarta|quinta|sexta)([- ]feira)?|s[aá]bado)/i
	};
	var parseDayPatterns = {
	  short: [/^d/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^s[aá]/i],
	  narrow: [/^d/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^s[aá]/i],
	  any: [/^d/i, /^seg/i, /^t/i, /^qua/i, /^qui/i, /^sex/i, /^s[aá]b/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(a|p|mn|md|(da) (manhã|tarde|noite))/i,
	  any: /^([ap]\.?\s?m\.?|meia[-\s]noite|meio[-\s]dia|(da) (manhã|tarde|noite))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a/i,
	    pm: /^p/i,
	    midnight: /^mn|^meia[-\s]noite/i,
	    noon: /^md|^meio[-\s]dia/i,
	    morning: /manhã/i,
	    afternoon: /tarde/i,
	    evening: /tarde/i,
	    night: /noite/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index2.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1640 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = millisecondsToHours;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	var _index2 = __webpack_require__(45);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name millisecondsToHours
	 * @category Conversion Helpers
	 * @summary Convert milliseconds to hours.
	 *
	 * @description
	 * Convert a number of milliseconds to a full number of hours.
	 *
	 * @param {number} milliseconds - number of milliseconds to be converted
	 *
	 * @returns {number} the number of milliseconds converted in hours
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 7200000 milliseconds to hours:
	 * const result = millisecondsToHours(7200000)
	 * //=> 2
	 *
	 * @example
	 * // It uses floor rounding:
	 * const result = millisecondsToHours(7199999)
	 * //=> 1
	 */
	function millisecondsToHours(milliseconds) {
	  (0, _index.default)(1, arguments);
	  var hours = milliseconds / _index2.millisecondsInHour;
	  return Math.floor(hours);
	}
	
	module.exports = exports.default;

/***/ },
/* 1641 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = millisecondsToMinutes;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	var _index2 = __webpack_require__(45);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name millisecondsToMinutes
	 * @category Conversion Helpers
	 * @summary Convert milliseconds to minutes.
	 *
	 * @description
	 * Convert a number of milliseconds to a full number of minutes.
	 *
	 * @param {number} milliseconds - number of milliseconds to be converted.
	 *
	 * @returns {number} the number of milliseconds converted in minutes
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 60000 milliseconds to minutes:
	 * const result = millisecondsToMinutes(60000)
	 * //=> 1
	 *
	 * @example
	 * // It uses floor rounding:
	 * const result = millisecondsToMinutes(119999)
	 * //=> 1
	 */
	function millisecondsToMinutes(milliseconds) {
	  (0, _index.default)(1, arguments);
	  var minutes = milliseconds / _index2.millisecondsInMinute;
	  return Math.floor(minutes);
	}
	
	module.exports = exports.default;

/***/ },
/* 1642 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = millisecondsToSeconds;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	var _index2 = __webpack_require__(45);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name millisecondsToSeconds
	 * @category Conversion Helpers
	 * @summary Convert milliseconds to seconds.
	 *
	 * @description
	 * Convert a number of milliseconds to a full number of seconds.
	 *
	 * @param {number} milliseconds - number of milliseconds to be converted
	 *
	 * @returns {number} the number of milliseconds converted in seconds
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 1000 miliseconds to seconds:
	 * const result = millisecondsToSeconds(1000)
	 * //=> 1
	 *
	 * @example
	 * // It uses floor rounding:
	 * const result = millisecondsToSeconds(1999)
	 * //=> 1
	 */
	function millisecondsToSeconds(milliseconds) {
	  (0, _index.default)(1, arguments);
	  var seconds = milliseconds / _index2.millisecondsInSecond;
	  return Math.floor(seconds);
	}
	
	module.exports = exports.default;

/***/ },
/* 1643 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = milliseconds;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
	// 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
	var daysInYear = 365.2425;
	/**
	 * @name milliseconds
	 * @category Millisecond Helpers
	 * @summary
	 * Returns the number of milliseconds in the specified, years, months, weeks, days, hours, minutes and seconds.
	 *
	 * @description
	 * Returns the number of milliseconds in the specified, years, months, weeks, days, hours, minutes and seconds.
	 *
	 * One years equals 365.2425 days according to the formula:
	 *
	 * > Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
	 * > 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
	 *
	 * One month is a year divided by 12.
	 *
	 * @param {Duration} duration - the object with years, months, weeks, days, hours, minutes and seconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {number} the milliseconds
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // 1 year in milliseconds
	 * milliseconds({ years: 1 })
	 * //=> 31556952000
	 *
	 * // 3 months in milliseconds
	 * milliseconds({ months: 3 })
	 * //=> 7889238000
	 */
	
	function milliseconds(_ref) {
	  var years = _ref.years,
	      months = _ref.months,
	      weeks = _ref.weeks,
	      days = _ref.days,
	      hours = _ref.hours,
	      minutes = _ref.minutes,
	      seconds = _ref.seconds;
	  (0, _index.default)(1, arguments);
	  var totalDays = 0;
	  if (years) totalDays += years * daysInYear;
	  if (months) totalDays += months * (daysInYear / 12);
	  if (weeks) totalDays += weeks * 7;
	  if (days) totalDays += days;
	  var totalSeconds = totalDays * 24 * 60 * 60;
	  if (hours) totalSeconds += hours * 60 * 60;
	  if (minutes) totalSeconds += minutes * 60;
	  if (seconds) totalSeconds += seconds;
	  return Math.round(totalSeconds * 1000);
	}
	
	module.exports = exports.default;

/***/ },
/* 1644 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = minutesToHours;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	var _index2 = __webpack_require__(45);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name minutesToHours
	 * @category Conversion Helpers
	 * @summary Convert minutes to hours.
	 *
	 * @description
	 * Convert a number of minutes to a full number of hours.
	 *
	 * @param {number} minutes - number of minutes to be converted
	 *
	 * @returns {number} the number of minutes converted in hours
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 140 minutes to hours:
	 * const result = minutesToHours(120)
	 * //=> 2
	 *
	 * @example
	 * // It uses floor rounding:
	 * const result = minutesToHours(179)
	 * //=> 2
	 */
	function minutesToHours(minutes) {
	  (0, _index.default)(1, arguments);
	  var hours = minutes / _index2.minutesInHour;
	  return Math.floor(hours);
	}
	
	module.exports = exports.default;

/***/ },
/* 1645 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = minutesToMilliseconds;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	var _index2 = __webpack_require__(45);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name minutesToMilliseconds
	 * @category Conversion Helpers
	 * @summary Convert minutes to milliseconds.
	 *
	 * @description
	 * Convert a number of minutes to a full number of milliseconds.
	 *
	 * @param {number} minutes - number of minutes to be converted
	 *
	 * @returns {number} the number of minutes converted in milliseconds
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 2 minutes to milliseconds
	 * const result = minutesToMilliseconds(2)
	 * //=> 120000
	 */
	function minutesToMilliseconds(minutes) {
	  (0, _index.default)(1, arguments);
	  return Math.floor(minutes * _index2.millisecondsInMinute);
	}
	
	module.exports = exports.default;

/***/ },
/* 1646 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = minutesToSeconds;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	var _index2 = __webpack_require__(45);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name minutesToSeconds
	 * @category Conversion Helpers
	 * @summary Convert minutes to seconds.
	 *
	 * @description
	 * Convert a number of minutes to a full number of seconds.
	 *
	 * @param { number } minutes - number of minutes to be converted
	 *
	 * @returns {number} the number of minutes converted in seconds
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 2 minutes to seconds
	 * const result = minutesToSeconds(2)
	 * //=> 120
	 */
	function minutesToSeconds(minutes) {
	  (0, _index.default)(1, arguments);
	  return Math.floor(minutes * _index2.secondsInMinute);
	}
	
	module.exports = exports.default;

/***/ },
/* 1647 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = monthsToQuarters;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	var _index2 = __webpack_require__(45);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name monthsToQuarters
	 * @category Conversion Helpers
	 * @summary Convert number of months to quarters.
	 *
	 * @description
	 * Convert a number of months to a full number of quarters.
	 *
	 * @param {number} months - number of months to be converted.
	 *
	 * @returns {number} the number of months converted in quarters
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 6 months to quarters:
	 * const result = monthsToQuarters(6)
	 * //=> 2
	 *
	 * @example
	 * // It uses floor rounding:
	 * const result = monthsToQuarters(7)
	 * //=> 2
	 */
	function monthsToQuarters(months) {
	  (0, _index.default)(1, arguments);
	  var quarters = months / _index2.monthsInQuarter;
	  return Math.floor(quarters);
	}
	
	module.exports = exports.default;

/***/ },
/* 1648 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = monthsToYears;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	var _index2 = __webpack_require__(45);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name monthsToYears
	 * @category Conversion Helpers
	 * @summary Convert number of months to years.
	 *
	 * @description
	 * Convert a number of months to a full number of years.
	 *
	 * @param {number} months - number of months to be converted
	 *
	 * @returns {number} the number of months converted in years
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 36 months to years:
	 * const result = monthsToYears(36)
	 * //=> 3
	 *
	 * // It uses floor rounding:
	 * const result = monthsToYears(40)
	 * //=> 3
	 */
	function monthsToYears(months) {
	  (0, _index.default)(1, arguments);
	  var years = months / _index2.monthsInYear;
	  return Math.floor(years);
	}
	
	module.exports = exports.default;

/***/ },
/* 1649 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = nextFriday;
	
	var _index = _interopRequireDefault(__webpack_require__(121));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name nextFriday
	 * @category Weekday Helpers
	 * @summary When is the next Friday?
	 *
	 * @description
	 * When is the next Friday?
	 *
	 * @param {Date | number} date - the date to start counting from
	 * @returns {Date} the next Friday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // When is the next Friday after Mar, 22, 2020?
	 * const result = nextFriday(new Date(2020, 2, 22))
	 * //=> Fri Mar 27 2020 00:00:00
	 */
	function nextFriday(date) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(date, 5);
	}
	
	module.exports = exports.default;

/***/ },
/* 1650 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = nextMonday;
	
	var _index = _interopRequireDefault(__webpack_require__(121));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name nextMonday
	 * @category Weekday Helpers
	 * @summary When is the next Monday?
	 *
	 * @description
	 * When is the next Monday?
	 *
	 * @param {Date | number} date - the date to start counting from
	 * @returns {Date} the next Monday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // When is the next Monday after Mar, 22, 2020?
	 * const result = nextMonday(new Date(2020, 2, 22))
	 * //=> Mon Mar 23 2020 00:00:00
	 */
	function nextMonday(date) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(date, 1);
	}
	
	module.exports = exports.default;

/***/ },
/* 1651 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = nextSaturday;
	
	var _index = _interopRequireDefault(__webpack_require__(121));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name nextSaturday
	 * @category Weekday Helpers
	 * @summary When is the next Saturday?
	 *
	 * @description
	 * When is the next Saturday?
	 *
	 * @param {Date | number} date - the date to start counting from
	 * @returns {Date} the next Saturday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // When is the next Saturday after Mar, 22, 2020?
	 * const result = nextSaturday(new Date(2020, 2, 22))
	 * //=> Sat Mar 28 2020 00:00:00
	 */
	function nextSaturday(date) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(date, 6);
	}
	
	module.exports = exports.default;

/***/ },
/* 1652 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = nextSunday;
	
	var _index = _interopRequireDefault(__webpack_require__(121));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name nextSunday
	 * @category Weekday Helpers
	 * @summary When is the next Sunday?
	 *
	 * @description
	 * When is the next Sunday?
	 *
	 * @param {Date | number} date - the date to start counting from
	 * @returns {Date} the next Sunday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // When is the next Sunday after Mar, 22, 2020?
	 * const result = nextSunday(new Date(2020, 2, 22))
	 * //=> Sun Mar 29 2020 00:00:00
	 */
	function nextSunday(date) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(date, 0);
	}
	
	module.exports = exports.default;

/***/ },
/* 1653 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = nextThursday;
	
	var _index = _interopRequireDefault(__webpack_require__(121));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name nextThursday
	 * @category Weekday Helpers
	 * @summary When is the next Thursday?
	 *
	 * @description
	 * When is the next Thursday?
	 *
	 * @param {Date | number} date - the date to start counting from
	 * @returns {Date} the next Thursday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // When is the next Thursday after Mar, 22, 2020?
	 * const result = nextThursday(new Date(2020, 2, 22))
	 * //=> Thur Mar 26 2020 00:00:00
	 */
	function nextThursday(date) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(date, 4);
	}
	
	module.exports = exports.default;

/***/ },
/* 1654 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = nextTuesday;
	
	var _index = _interopRequireDefault(__webpack_require__(121));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name nextTuesday
	 * @category Weekday Helpers
	 * @summary When is the next Tuesday?
	 *
	 * @description
	 * When is the next Tuesday?
	 *
	 * @param {Date | number} date - the date to start counting from
	 * @returns {Date} the next Tuesday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // When is the next Tuesday after Mar, 22, 2020?
	 * const result = nextTuesday(new Date(2020, 2, 22))
	 * //=> Tue Mar 24 2020 00:00:00
	 */
	function nextTuesday(date) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(date, 2);
	}
	
	module.exports = exports.default;

/***/ },
/* 1655 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = nextWednesday;
	
	var _index = _interopRequireDefault(__webpack_require__(121));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name nextWednesday
	 * @category Weekday Helpers
	 * @summary When is the next Wednesday?
	 *
	 * @description
	 * When is the next Wednesday?
	 *
	 * @param {Date | number} date - the date to start counting from
	 * @returns {Date} the next Wednesday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // When is the next Wednesday after Mar, 22, 2020?
	 * const result = nextWednesday(new Date(2020, 2, 22))
	 * //=> Wed Mar 25 2020 00:00:00
	 */
	function nextWednesday(date) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(date, 3);
	}
	
	module.exports = exports.default;

/***/ },
/* 1656 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = parseJSON;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name parseJSON
	 * @category Common Helpers
	 * @summary Parse a JSON date string
	 *
	 * @description
	 * Converts a complete ISO date string in UTC time, the typical format for transmitting
	 * a date in JSON, to a JavaScript `Date` instance.
	 *
	 * This is a minimal implementation for converting dates retrieved from a JSON API to
	 * a `Date` instance which can be used with other functions in the `date-fns` library.
	 * The following formats are supported:
	 *
	 * - `2000-03-15T05:20:10.123Z`: The output of `.toISOString()` and `JSON.stringify(new Date())`
	 * - `2000-03-15T05:20:10Z`: Without milliseconds
	 * - `2000-03-15T05:20:10+00:00`: With a zero offset, the default JSON encoded format in some other languages
	 * - `2000-03-15T05:20:10+05:45`: With a positive or negative offset, the default JSON encoded format in some other languages
	 * - `2000-03-15T05:20:10+0000`: With a zero offset without a colon
	 * - `2000-03-15T05:20:10`: Without a trailing 'Z' symbol
	 * - `2000-03-15T05:20:10.1234567`: Up to 7 digits in milliseconds field. Only first 3 are taken into account since JS does not allow fractional milliseconds
	 * - `2000-03-15 05:20:10`: With a space instead of a 'T' separator for APIs returning a SQL date without reformatting
	 *
	 * For convenience and ease of use these other input types are also supported
	 * via [toDate]{@link https://date-fns.org/docs/toDate}:
	 *
	 * - A `Date` instance will be cloned
	 * - A `number` will be treated as a timestamp
	 *
	 * Any other input type or invalid date strings will return an `Invalid Date`.
	 *
	 * @param {String|Number|Date} argument A fully formed ISO8601 date string to convert
	 * @returns {Date} the parsed date in the local time zone
	 * @throws {TypeError} 1 argument required
	 */
	function parseJSON(argument) {
	  (0, _index2.default)(1, arguments);
	
	  if (typeof argument === 'string') {
	    var parts = argument.match(/(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(?:\.(\d{0,7}))?(?:Z|(.)(\d{2}):?(\d{2})?)?/);
	
	    if (parts) {
	      // Group 8 matches the sign
	      return new Date(Date.UTC(+parts[1], +parts[2] - 1, +parts[3], +parts[4] - (+parts[9] || 0) * (parts[8] == '-' ? -1 : 1), +parts[5] - (+parts[10] || 0) * (parts[8] == '-' ? -1 : 1), +parts[6], +((parts[7] || '0') + '00').substring(0, 3)));
	    }
	
	    return new Date(NaN);
	  }
	
	  return (0, _index.default)(argument);
	}
	
	module.exports = exports.default;

/***/ },
/* 1657 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(383));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1536));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1537));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1538));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1539));
	
	var _index6 = _interopRequireDefault(__webpack_require__(259));
	
	var _index7 = _interopRequireDefault(__webpack_require__(260));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_HOUR = 3600000;
	var MILLISECONDS_IN_MINUTE = 60000;
	var MILLISECONDS_IN_SECOND = 1000;
	var numericPatterns = {
	  month: /^(1[0-2]|0?\d)/,
	  // 0 to 12
	  date: /^(3[0-1]|[0-2]?\d)/,
	  // 0 to 31
	  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
	  // 0 to 366
	  week: /^(5[0-3]|[0-4]?\d)/,
	  // 0 to 53
	  hour23h: /^(2[0-3]|[0-1]?\d)/,
	  // 0 to 23
	  hour24h: /^(2[0-4]|[0-1]?\d)/,
	  // 0 to 24
	  hour11h: /^(1[0-1]|0?\d)/,
	  // 0 to 11
	  hour12h: /^(1[0-2]|0?\d)/,
	  // 0 to 12
	  minute: /^[0-5]?\d/,
	  // 0 to 59
	  second: /^[0-5]?\d/,
	  // 0 to 59
	  singleDigit: /^\d/,
	  // 0 to 9
	  twoDigits: /^\d{1,2}/,
	  // 0 to 99
	  threeDigits: /^\d{1,3}/,
	  // 0 to 999
	  fourDigits: /^\d{1,4}/,
	  // 0 to 9999
	  anyDigitsSigned: /^-?\d+/,
	  singleDigitSigned: /^-?\d/,
	  // 0 to 9, -0 to -9
	  twoDigitsSigned: /^-?\d{1,2}/,
	  // 0 to 99, -0 to -99
	  threeDigitsSigned: /^-?\d{1,3}/,
	  // 0 to 999, -0 to -999
	  fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
	
	};
	var timezonePatterns = {
	  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
	  basic: /^([+-])(\d{2})(\d{2})|Z/,
	  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
	  extended: /^([+-])(\d{2}):(\d{2})|Z/,
	  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
	};
	
	function parseNumericPattern(pattern, string, valueCallback) {
	  var matchResult = string.match(pattern);
	
	  if (!matchResult) {
	    return null;
	  }
	
	  var value = parseInt(matchResult[0], 10);
	  return {
	    value: valueCallback ? valueCallback(value) : value,
	    rest: string.slice(matchResult[0].length)
	  };
	}
	
	function parseTimezonePattern(pattern, string) {
	  var matchResult = string.match(pattern);
	
	  if (!matchResult) {
	    return null;
	  } // Input is 'Z'
	
	
	  if (matchResult[0] === 'Z') {
	    return {
	      value: 0,
	      rest: string.slice(1)
	    };
	  }
	
	  var sign = matchResult[1] === '+' ? 1 : -1;
	  var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
	  var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
	  var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
	  return {
	    value: sign * (hours * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE + seconds * MILLISECONDS_IN_SECOND),
	    rest: string.slice(matchResult[0].length)
	  };
	}
	
	function parseAnyDigitsSigned(string, valueCallback) {
	  return parseNumericPattern(numericPatterns.anyDigitsSigned, string, valueCallback);
	}
	
	function parseNDigits(n, string, valueCallback) {
	  switch (n) {
	    case 1:
	      return parseNumericPattern(numericPatterns.singleDigit, string, valueCallback);
	
	    case 2:
	      return parseNumericPattern(numericPatterns.twoDigits, string, valueCallback);
	
	    case 3:
	      return parseNumericPattern(numericPatterns.threeDigits, string, valueCallback);
	
	    case 4:
	      return parseNumericPattern(numericPatterns.fourDigits, string, valueCallback);
	
	    default:
	      return parseNumericPattern(new RegExp('^\\d{1,' + n + '}'), string, valueCallback);
	  }
	}
	
	function parseNDigitsSigned(n, string, valueCallback) {
	  switch (n) {
	    case 1:
	      return parseNumericPattern(numericPatterns.singleDigitSigned, string, valueCallback);
	
	    case 2:
	      return parseNumericPattern(numericPatterns.twoDigitsSigned, string, valueCallback);
	
	    case 3:
	      return parseNumericPattern(numericPatterns.threeDigitsSigned, string, valueCallback);
	
	    case 4:
	      return parseNumericPattern(numericPatterns.fourDigitsSigned, string, valueCallback);
	
	    default:
	      return parseNumericPattern(new RegExp('^-?\\d{1,' + n + '}'), string, valueCallback);
	  }
	}
	
	function dayPeriodEnumToHours(enumValue) {
	  switch (enumValue) {
	    case 'morning':
	      return 4;
	
	    case 'evening':
	      return 17;
	
	    case 'pm':
	    case 'noon':
	    case 'afternoon':
	      return 12;
	
	    case 'am':
	    case 'midnight':
	    case 'night':
	    default:
	      return 0;
	  }
	}
	
	function normalizeTwoDigitYear(twoDigitYear, currentYear) {
	  var isCommonEra = currentYear > 0; // Absolute number of the current year:
	  // 1 -> 1 AC
	  // 0 -> 1 BC
	  // -1 -> 2 BC
	
	  var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
	  var result;
	
	  if (absCurrentYear <= 50) {
	    result = twoDigitYear || 100;
	  } else {
	    var rangeEnd = absCurrentYear + 50;
	    var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
	    var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
	    result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
	  }
	
	  return isCommonEra ? result : 1 - result;
	}
	
	var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
	var DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]; // User for validation
	
	function isLeapYearIndex(year) {
	  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
	}
	/*
	 * |     | Unit                           |     | Unit                           |
	 * |-----|--------------------------------|-----|--------------------------------|
	 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
	 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
	 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
	 * |  d  | Day of month                   |  D  | Day of year                    |
	 * |  e  | Local day of week              |  E  | Day of week                    |
	 * |  f  |                                |  F* | Day of week in month           |
	 * |  g* | Modified Julian day            |  G  | Era                            |
	 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
	 * |  i! | ISO day of week                |  I! | ISO week of year               |
	 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
	 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
	 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
	 * |  m  | Minute                         |  M  | Month                          |
	 * |  n  |                                |  N  |                                |
	 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
	 * |  p  |                                |  P  |                                |
	 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
	 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
	 * |  s  | Second                         |  S  | Fraction of second             |
	 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
	 * |  u  | Extended year                  |  U* | Cyclic year                    |
	 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
	 * |  w  | Local week of year             |  W* | Week of month                  |
	 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
	 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
	 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
	 *
	 * Letters marked by * are not implemented but reserved by Unicode standard.
	 *
	 * Letters marked by ! are non-standard, but implemented by date-fns:
	 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
	 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
	 *   i.e. 7 for Sunday, 1 for Monday, etc.
	 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
	 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
	 *   `R` is supposed to be used in conjunction with `I` and `i`
	 *   for universal ISO week-numbering date, whereas
	 *   `Y` is supposed to be used in conjunction with `w` and `e`
	 *   for week-numbering date specific to the locale.
	 */
	
	
	var parsers = {
	  // Era
	  G: {
	    priority: 140,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        // AD, BC
	        case 'G':
	        case 'GG':
	        case 'GGG':
	          return match.era(string, {
	            width: 'abbreviated'
	          }) || match.era(string, {
	            width: 'narrow'
	          });
	        // A, B
	
	        case 'GGGGG':
	          return match.era(string, {
	            width: 'narrow'
	          });
	        // Anno Domini, Before Christ
	
	        case 'GGGG':
	        default:
	          return match.era(string, {
	            width: 'wide'
	          }) || match.era(string, {
	            width: 'abbreviated'
	          }) || match.era(string, {
	            width: 'narrow'
	          });
	      }
	    },
	    set: function (date, flags, value, _options) {
	      flags.era = value;
	      date.setUTCFullYear(value, 0, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['R', 'u', 't', 'T']
	  },
	  // Year
	  y: {
	    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
	    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
	    // |----------|-------|----|-------|-------|-------|
	    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
	    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
	    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
	    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
	    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
	    priority: 130,
	    parse: function (string, token, match, _options) {
	      var valueCallback = function (year) {
	        return {
	          year: year,
	          isTwoDigitYear: token === 'yy'
	        };
	      };
	
	      switch (token) {
	        case 'y':
	          return parseNDigits(4, string, valueCallback);
	
	        case 'yo':
	          return match.ordinalNumber(string, {
	            unit: 'year',
	            valueCallback: valueCallback
	          });
	
	        default:
	          return parseNDigits(token.length, string, valueCallback);
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value.isTwoDigitYear || value.year > 0;
	    },
	    set: function (date, flags, value, _options) {
	      var currentYear = date.getUTCFullYear();
	
	      if (value.isTwoDigitYear) {
	        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
	        date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
	        date.setUTCHours(0, 0, 0, 0);
	        return date;
	      }
	
	      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
	      date.setUTCFullYear(year, 0, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['Y', 'R', 'u', 'w', 'I', 'i', 'e', 'c', 't', 'T']
	  },
	  // Local week-numbering year
	  Y: {
	    priority: 130,
	    parse: function (string, token, match, _options) {
	      var valueCallback = function (year) {
	        return {
	          year: year,
	          isTwoDigitYear: token === 'YY'
	        };
	      };
	
	      switch (token) {
	        case 'Y':
	          return parseNDigits(4, string, valueCallback);
	
	        case 'Yo':
	          return match.ordinalNumber(string, {
	            unit: 'year',
	            valueCallback: valueCallback
	          });
	
	        default:
	          return parseNDigits(token.length, string, valueCallback);
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value.isTwoDigitYear || value.year > 0;
	    },
	    set: function (date, flags, value, options) {
	      var currentYear = (0, _index.default)(date, options);
	
	      if (value.isTwoDigitYear) {
	        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
	        date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
	        date.setUTCHours(0, 0, 0, 0);
	        return (0, _index7.default)(date, options);
	      }
	
	      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
	      date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
	      date.setUTCHours(0, 0, 0, 0);
	      return (0, _index7.default)(date, options);
	    },
	    incompatibleTokens: ['y', 'R', 'u', 'Q', 'q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']
	  },
	  // ISO week-numbering year
	  R: {
	    priority: 130,
	    parse: function (string, token, _match, _options) {
	      if (token === 'R') {
	        return parseNDigitsSigned(4, string);
	      }
	
	      return parseNDigitsSigned(token.length, string);
	    },
	    set: function (_date, _flags, value, _options) {
	      var firstWeekOfYear = new Date(0);
	      firstWeekOfYear.setUTCFullYear(value, 0, 4);
	      firstWeekOfYear.setUTCHours(0, 0, 0, 0);
	      return (0, _index6.default)(firstWeekOfYear);
	    },
	    incompatibleTokens: ['G', 'y', 'Y', 'u', 'Q', 'q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']
	  },
	  // Extended year
	  u: {
	    priority: 130,
	    parse: function (string, token, _match, _options) {
	      if (token === 'u') {
	        return parseNDigitsSigned(4, string);
	      }
	
	      return parseNDigitsSigned(token.length, string);
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCFullYear(value, 0, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['G', 'y', 'Y', 'R', 'w', 'I', 'i', 'e', 'c', 't', 'T']
	  },
	  // Quarter
	  Q: {
	    priority: 120,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        // 1, 2, 3, 4
	        case 'Q':
	        case 'QQ':
	          // 01, 02, 03, 04
	          return parseNDigits(token.length, string);
	        // 1st, 2nd, 3rd, 4th
	
	        case 'Qo':
	          return match.ordinalNumber(string, {
	            unit: 'quarter'
	          });
	        // Q1, Q2, Q3, Q4
	
	        case 'QQQ':
	          return match.quarter(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.quarter(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
	
	        case 'QQQQQ':
	          return match.quarter(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // 1st quarter, 2nd quarter, ...
	
	        case 'QQQQ':
	        default:
	          return match.quarter(string, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.quarter(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.quarter(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 1 && value <= 4;
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCMonth((value - 1) * 3, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['Y', 'R', 'q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']
	  },
	  // Stand-alone quarter
	  q: {
	    priority: 120,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        // 1, 2, 3, 4
	        case 'q':
	        case 'qq':
	          // 01, 02, 03, 04
	          return parseNDigits(token.length, string);
	        // 1st, 2nd, 3rd, 4th
	
	        case 'qo':
	          return match.ordinalNumber(string, {
	            unit: 'quarter'
	          });
	        // Q1, Q2, Q3, Q4
	
	        case 'qqq':
	          return match.quarter(string, {
	            width: 'abbreviated',
	            context: 'standalone'
	          }) || match.quarter(string, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
	
	        case 'qqqqq':
	          return match.quarter(string, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // 1st quarter, 2nd quarter, ...
	
	        case 'qqqq':
	        default:
	          return match.quarter(string, {
	            width: 'wide',
	            context: 'standalone'
	          }) || match.quarter(string, {
	            width: 'abbreviated',
	            context: 'standalone'
	          }) || match.quarter(string, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 1 && value <= 4;
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCMonth((value - 1) * 3, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['Y', 'R', 'Q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']
	  },
	  // Month
	  M: {
	    priority: 110,
	    parse: function (string, token, match, _options) {
	      var valueCallback = function (value) {
	        return value - 1;
	      };
	
	      switch (token) {
	        // 1, 2, ..., 12
	        case 'M':
	          return parseNumericPattern(numericPatterns.month, string, valueCallback);
	        // 01, 02, ..., 12
	
	        case 'MM':
	          return parseNDigits(2, string, valueCallback);
	        // 1st, 2nd, ..., 12th
	
	        case 'Mo':
	          return match.ordinalNumber(string, {
	            unit: 'month',
	            valueCallback: valueCallback
	          });
	        // Jan, Feb, ..., Dec
	
	        case 'MMM':
	          return match.month(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.month(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // J, F, ..., D
	
	        case 'MMMMM':
	          return match.month(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // January, February, ..., December
	
	        case 'MMMM':
	        default:
	          return match.month(string, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.month(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.month(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 0 && value <= 11;
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCMonth(value, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'L', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
	  },
	  // Stand-alone month
	  L: {
	    priority: 110,
	    parse: function (string, token, match, _options) {
	      var valueCallback = function (value) {
	        return value - 1;
	      };
	
	      switch (token) {
	        // 1, 2, ..., 12
	        case 'L':
	          return parseNumericPattern(numericPatterns.month, string, valueCallback);
	        // 01, 02, ..., 12
	
	        case 'LL':
	          return parseNDigits(2, string, valueCallback);
	        // 1st, 2nd, ..., 12th
	
	        case 'Lo':
	          return match.ordinalNumber(string, {
	            unit: 'month',
	            valueCallback: valueCallback
	          });
	        // Jan, Feb, ..., Dec
	
	        case 'LLL':
	          return match.month(string, {
	            width: 'abbreviated',
	            context: 'standalone'
	          }) || match.month(string, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // J, F, ..., D
	
	        case 'LLLLL':
	          return match.month(string, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // January, February, ..., December
	
	        case 'LLLL':
	        default:
	          return match.month(string, {
	            width: 'wide',
	            context: 'standalone'
	          }) || match.month(string, {
	            width: 'abbreviated',
	            context: 'standalone'
	          }) || match.month(string, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 0 && value <= 11;
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCMonth(value, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'M', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
	  },
	  // Local week of year
	  w: {
	    priority: 100,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'w':
	          return parseNumericPattern(numericPatterns.week, string);
	
	        case 'wo':
	          return match.ordinalNumber(string, {
	            unit: 'week'
	          });
	
	        default:
	          return parseNDigits(token.length, string);
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 1 && value <= 53;
	    },
	    set: function (date, _flags, value, options) {
	      return (0, _index7.default)((0, _index5.default)(date, value, options), options);
	    },
	    incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']
	  },
	  // ISO week of year
	  I: {
	    priority: 100,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'I':
	          return parseNumericPattern(numericPatterns.week, string);
	
	        case 'Io':
	          return match.ordinalNumber(string, {
	            unit: 'week'
	          });
	
	        default:
	          return parseNDigits(token.length, string);
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 1 && value <= 53;
	    },
	    set: function (date, _flags, value, options) {
	      return (0, _index6.default)((0, _index4.default)(date, value, options), options);
	    },
	    incompatibleTokens: ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']
	  },
	  // Day of the month
	  d: {
	    priority: 90,
	    subPriority: 1,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'd':
	          return parseNumericPattern(numericPatterns.date, string);
	
	        case 'do':
	          return match.ordinalNumber(string, {
	            unit: 'date'
	          });
	
	        default:
	          return parseNDigits(token.length, string);
	      }
	    },
	    validate: function (date, value, _options) {
	      var year = date.getUTCFullYear();
	      var isLeapYear = isLeapYearIndex(year);
	      var month = date.getUTCMonth();
	
	      if (isLeapYear) {
	        return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
	      } else {
	        return value >= 1 && value <= DAYS_IN_MONTH[month];
	      }
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCDate(value);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
	  },
	  // Day of year
	  D: {
	    priority: 90,
	    subPriority: 1,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'D':
	        case 'DD':
	          return parseNumericPattern(numericPatterns.dayOfYear, string);
	
	        case 'Do':
	          return match.ordinalNumber(string, {
	            unit: 'date'
	          });
	
	        default:
	          return parseNDigits(token.length, string);
	      }
	    },
	    validate: function (date, value, _options) {
	      var year = date.getUTCFullYear();
	      var isLeapYear = isLeapYearIndex(year);
	
	      if (isLeapYear) {
	        return value >= 1 && value <= 366;
	      } else {
	        return value >= 1 && value <= 365;
	      }
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCMonth(0, value);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'M', 'L', 'w', 'I', 'd', 'E', 'i', 'e', 'c', 't', 'T']
	  },
	  // Day of week
	  E: {
	    priority: 90,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        // Tue
	        case 'E':
	        case 'EE':
	        case 'EEE':
	          return match.day(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // T
	
	        case 'EEEEE':
	          return match.day(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // Tu
	
	        case 'EEEEEE':
	          return match.day(string, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // Tuesday
	
	        case 'EEEE':
	        default:
	          return match.day(string, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 0 && value <= 6;
	    },
	    set: function (date, _flags, value, options) {
	      date = (0, _index2.default)(date, value, options);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['D', 'i', 'e', 'c', 't', 'T']
	  },
	  // Local day of week
	  e: {
	    priority: 90,
	    parse: function (string, token, match, options) {
	      var valueCallback = function (value) {
	        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
	        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
	      };
	
	      switch (token) {
	        // 3
	        case 'e':
	        case 'ee':
	          // 03
	          return parseNDigits(token.length, string, valueCallback);
	        // 3rd
	
	        case 'eo':
	          return match.ordinalNumber(string, {
	            unit: 'day',
	            valueCallback: valueCallback
	          });
	        // Tue
	
	        case 'eee':
	          return match.day(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // T
	
	        case 'eeeee':
	          return match.day(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // Tu
	
	        case 'eeeeee':
	          return match.day(string, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // Tuesday
	
	        case 'eeee':
	        default:
	          return match.day(string, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 0 && value <= 6;
	    },
	    set: function (date, _flags, value, options) {
	      date = (0, _index2.default)(date, value, options);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'c', 't', 'T']
	  },
	  // Stand-alone local day of week
	  c: {
	    priority: 90,
	    parse: function (string, token, match, options) {
	      var valueCallback = function (value) {
	        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
	        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
	      };
	
	      switch (token) {
	        // 3
	        case 'c':
	        case 'cc':
	          // 03
	          return parseNDigits(token.length, string, valueCallback);
	        // 3rd
	
	        case 'co':
	          return match.ordinalNumber(string, {
	            unit: 'day',
	            valueCallback: valueCallback
	          });
	        // Tue
	
	        case 'ccc':
	          return match.day(string, {
	            width: 'abbreviated',
	            context: 'standalone'
	          }) || match.day(string, {
	            width: 'short',
	            context: 'standalone'
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // T
	
	        case 'ccccc':
	          return match.day(string, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // Tu
	
	        case 'cccccc':
	          return match.day(string, {
	            width: 'short',
	            context: 'standalone'
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // Tuesday
	
	        case 'cccc':
	        default:
	          return match.day(string, {
	            width: 'wide',
	            context: 'standalone'
	          }) || match.day(string, {
	            width: 'abbreviated',
	            context: 'standalone'
	          }) || match.day(string, {
	            width: 'short',
	            context: 'standalone'
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 0 && value <= 6;
	    },
	    set: function (date, _flags, value, options) {
	      date = (0, _index2.default)(date, value, options);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'e', 't', 'T']
	  },
	  // ISO day of week
	  i: {
	    priority: 90,
	    parse: function (string, token, match, _options) {
	      var valueCallback = function (value) {
	        if (value === 0) {
	          return 7;
	        }
	
	        return value;
	      };
	
	      switch (token) {
	        // 2
	        case 'i':
	        case 'ii':
	          // 02
	          return parseNDigits(token.length, string);
	        // 2nd
	
	        case 'io':
	          return match.ordinalNumber(string, {
	            unit: 'day'
	          });
	        // Tue
	
	        case 'iii':
	          return match.day(string, {
	            width: 'abbreviated',
	            context: 'formatting',
	            valueCallback: valueCallback
	          }) || match.day(string, {
	            width: 'short',
	            context: 'formatting',
	            valueCallback: valueCallback
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'formatting',
	            valueCallback: valueCallback
	          });
	        // T
	
	        case 'iiiii':
	          return match.day(string, {
	            width: 'narrow',
	            context: 'formatting',
	            valueCallback: valueCallback
	          });
	        // Tu
	
	        case 'iiiiii':
	          return match.day(string, {
	            width: 'short',
	            context: 'formatting',
	            valueCallback: valueCallback
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'formatting',
	            valueCallback: valueCallback
	          });
	        // Tuesday
	
	        case 'iiii':
	        default:
	          return match.day(string, {
	            width: 'wide',
	            context: 'formatting',
	            valueCallback: valueCallback
	          }) || match.day(string, {
	            width: 'abbreviated',
	            context: 'formatting',
	            valueCallback: valueCallback
	          }) || match.day(string, {
	            width: 'short',
	            context: 'formatting',
	            valueCallback: valueCallback
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'formatting',
	            valueCallback: valueCallback
	          });
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 1 && value <= 7;
	    },
	    set: function (date, _flags, value, options) {
	      date = (0, _index3.default)(date, value, options);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'E', 'e', 'c', 't', 'T']
	  },
	  // AM or PM
	  a: {
	    priority: 80,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'a':
	        case 'aa':
	        case 'aaa':
	          return match.dayPeriod(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.dayPeriod(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	
	        case 'aaaaa':
	          return match.dayPeriod(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	
	        case 'aaaa':
	        default:
	          return match.dayPeriod(string, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.dayPeriod(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.dayPeriod(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['b', 'B', 'H', 'k', 't', 'T']
	  },
	  // AM, PM, midnight
	  b: {
	    priority: 80,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'b':
	        case 'bb':
	        case 'bbb':
	          return match.dayPeriod(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.dayPeriod(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	
	        case 'bbbbb':
	          return match.dayPeriod(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	
	        case 'bbbb':
	        default:
	          return match.dayPeriod(string, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.dayPeriod(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.dayPeriod(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['a', 'B', 'H', 'k', 't', 'T']
	  },
	  // in the morning, in the afternoon, in the evening, at night
	  B: {
	    priority: 80,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'B':
	        case 'BB':
	        case 'BBB':
	          return match.dayPeriod(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.dayPeriod(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	
	        case 'BBBBB':
	          return match.dayPeriod(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	
	        case 'BBBB':
	        default:
	          return match.dayPeriod(string, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.dayPeriod(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.dayPeriod(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['a', 'b', 't', 'T']
	  },
	  // Hour [1-12]
	  h: {
	    priority: 70,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'h':
	          return parseNumericPattern(numericPatterns.hour12h, string);
	
	        case 'ho':
	          return match.ordinalNumber(string, {
	            unit: 'hour'
	          });
	
	        default:
	          return parseNDigits(token.length, string);
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 1 && value <= 12;
	    },
	    set: function (date, _flags, value, _options) {
	      var isPM = date.getUTCHours() >= 12;
	
	      if (isPM && value < 12) {
	        date.setUTCHours(value + 12, 0, 0, 0);
	      } else if (!isPM && value === 12) {
	        date.setUTCHours(0, 0, 0, 0);
	      } else {
	        date.setUTCHours(value, 0, 0, 0);
	      }
	
	      return date;
	    },
	    incompatibleTokens: ['H', 'K', 'k', 't', 'T']
	  },
	  // Hour [0-23]
	  H: {
	    priority: 70,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'H':
	          return parseNumericPattern(numericPatterns.hour23h, string);
	
	        case 'Ho':
	          return match.ordinalNumber(string, {
	            unit: 'hour'
	          });
	
	        default:
	          return parseNDigits(token.length, string);
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 0 && value <= 23;
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCHours(value, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['a', 'b', 'h', 'K', 'k', 't', 'T']
	  },
	  // Hour [0-11]
	  K: {
	    priority: 70,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'K':
	          return parseNumericPattern(numericPatterns.hour11h, string);
	
	        case 'Ko':
	          return match.ordinalNumber(string, {
	            unit: 'hour'
	          });
	
	        default:
	          return parseNDigits(token.length, string);
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 0 && value <= 11;
	    },
	    set: function (date, _flags, value, _options) {
	      var isPM = date.getUTCHours() >= 12;
	
	      if (isPM && value < 12) {
	        date.setUTCHours(value + 12, 0, 0, 0);
	      } else {
	        date.setUTCHours(value, 0, 0, 0);
	      }
	
	      return date;
	    },
	    incompatibleTokens: ['h', 'H', 'k', 't', 'T']
	  },
	  // Hour [1-24]
	  k: {
	    priority: 70,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'k':
	          return parseNumericPattern(numericPatterns.hour24h, string);
	
	        case 'ko':
	          return match.ordinalNumber(string, {
	            unit: 'hour'
	          });
	
	        default:
	          return parseNDigits(token.length, string);
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 1 && value <= 24;
	    },
	    set: function (date, _flags, value, _options) {
	      var hours = value <= 24 ? value % 24 : value;
	      date.setUTCHours(hours, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['a', 'b', 'h', 'H', 'K', 't', 'T']
	  },
	  // Minute
	  m: {
	    priority: 60,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'm':
	          return parseNumericPattern(numericPatterns.minute, string);
	
	        case 'mo':
	          return match.ordinalNumber(string, {
	            unit: 'minute'
	          });
	
	        default:
	          return parseNDigits(token.length, string);
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 0 && value <= 59;
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCMinutes(value, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['t', 'T']
	  },
	  // Second
	  s: {
	    priority: 50,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 's':
	          return parseNumericPattern(numericPatterns.second, string);
	
	        case 'so':
	          return match.ordinalNumber(string, {
	            unit: 'second'
	          });
	
	        default:
	          return parseNDigits(token.length, string);
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 0 && value <= 59;
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCSeconds(value, 0);
	      return date;
	    },
	    incompatibleTokens: ['t', 'T']
	  },
	  // Fraction of second
	  S: {
	    priority: 30,
	    parse: function (string, token, _match, _options) {
	      var valueCallback = function (value) {
	        return Math.floor(value * Math.pow(10, -token.length + 3));
	      };
	
	      return parseNDigits(token.length, string, valueCallback);
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCMilliseconds(value);
	      return date;
	    },
	    incompatibleTokens: ['t', 'T']
	  },
	  // Timezone (ISO-8601. +00:00 is `'Z'`)
	  X: {
	    priority: 10,
	    parse: function (string, token, _match, _options) {
	      switch (token) {
	        case 'X':
	          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, string);
	
	        case 'XX':
	          return parseTimezonePattern(timezonePatterns.basic, string);
	
	        case 'XXXX':
	          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, string);
	
	        case 'XXXXX':
	          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, string);
	
	        case 'XXX':
	        default:
	          return parseTimezonePattern(timezonePatterns.extended, string);
	      }
	    },
	    set: function (date, flags, value, _options) {
	      if (flags.timestampIsSet) {
	        return date;
	      }
	
	      return new Date(date.getTime() - value);
	    },
	    incompatibleTokens: ['t', 'T', 'x']
	  },
	  // Timezone (ISO-8601)
	  x: {
	    priority: 10,
	    parse: function (string, token, _match, _options) {
	      switch (token) {
	        case 'x':
	          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, string);
	
	        case 'xx':
	          return parseTimezonePattern(timezonePatterns.basic, string);
	
	        case 'xxxx':
	          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, string);
	
	        case 'xxxxx':
	          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, string);
	
	        case 'xxx':
	        default:
	          return parseTimezonePattern(timezonePatterns.extended, string);
	      }
	    },
	    set: function (date, flags, value, _options) {
	      if (flags.timestampIsSet) {
	        return date;
	      }
	
	      return new Date(date.getTime() - value);
	    },
	    incompatibleTokens: ['t', 'T', 'X']
	  },
	  // Seconds timestamp
	  t: {
	    priority: 40,
	    parse: function (string, _token, _match, _options) {
	      return parseAnyDigitsSigned(string);
	    },
	    set: function (_date, _flags, value, _options) {
	      return [new Date(value * 1000), {
	        timestampIsSet: true
	      }];
	    },
	    incompatibleTokens: '*'
	  },
	  // Milliseconds timestamp
	  T: {
	    priority: 20,
	    parse: function (string, _token, _match, _options) {
	      return parseAnyDigitsSigned(string);
	    },
	    set: function (_date, _flags, value, _options) {
	      return [new Date(value), {
	        timestampIsSet: true
	      }];
	    },
	    incompatibleTokens: '*'
	  }
	};
	var _default = parsers;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1658 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = previousFriday;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	var _index2 = _interopRequireDefault(__webpack_require__(122));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name previousFriday
	 * @category Weekday Helpers
	 * @summary When is the previous Friday?
	 *
	 * @description
	 * When is the previous Friday?
	 *
	 * @param {Date | number} date - the date to start counting from
	 * @returns {Date} the previous Friday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // When is the previous Friday before Jun, 19, 2021?
	 * const result = previousFriday(new Date(2021, 5, 19))
	 * //=> Fri June 18 2021 00:00:00
	 */
	function previousFriday(date) {
	  (0, _index.default)(1, arguments);
	  return (0, _index2.default)(date, 5);
	}
	
	module.exports = exports.default;

/***/ },
/* 1659 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = previousMonday;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	var _index2 = _interopRequireDefault(__webpack_require__(122));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name previousMonday
	 * @category Weekday Helpers
	 * @summary When is the previous Monday?
	 *
	 * @description
	 * When is the previous Monday?
	 *
	 * @param {Date | number} date - the date to start counting from
	 * @returns {Date} the previous Monday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // When is the previous Monday before Jun, 18, 2021?
	 * const result = previousMonday(new Date(2021, 5, 18))
	 * //=> Mon June 14 2021 00:00:00
	 */
	function previousMonday(date) {
	  (0, _index.default)(1, arguments);
	  return (0, _index2.default)(date, 1);
	}
	
	module.exports = exports.default;

/***/ },
/* 1660 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = previousSaturday;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	var _index2 = _interopRequireDefault(__webpack_require__(122));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name previousSaturday
	 * @category Weekday Helpers
	 * @summary When is the previous Saturday?
	 *
	 * @description
	 * When is the previous Saturday?
	 *
	 * @param {Date | number} date - the date to start counting from
	 * @returns {Date} the previous Saturday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // When is the previous Saturday before Jun, 20, 2021?
	 * const result = previousSaturday(new Date(2021, 5, 20))
	 * //=> Sat June 19 2021 00:00:00
	 */
	function previousSaturday(date) {
	  (0, _index.default)(1, arguments);
	  return (0, _index2.default)(date, 6);
	}
	
	module.exports = exports.default;

/***/ },
/* 1661 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = previousSunday;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	var _index2 = _interopRequireDefault(__webpack_require__(122));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name previousSunday
	 * @category Weekday Helpers
	 * @summary When is the previous Sunday?
	 *
	 * @description
	 * When is the previous Sunday?
	 *
	 * @param {Date | number} date - the date to start counting from
	 * @returns {Date} the previous Sunday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // When is the previous Sunday before Jun, 21, 2021?
	 * const result = previousSunday(new Date(2021, 5, 21))
	 * //=> Sun June 20 2021 00:00:00
	 */
	function previousSunday(date) {
	  (0, _index.default)(1, arguments);
	  return (0, _index2.default)(date, 0);
	}
	
	module.exports = exports.default;

/***/ },
/* 1662 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = previousThursday;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	var _index2 = _interopRequireDefault(__webpack_require__(122));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name previousThursday
	 * @category Weekday Helpers
	 * @summary When is the previous Thursday?
	 *
	 * @description
	 * When is the previous Thursday?
	 *
	 * @param {Date | number} date - the date to start counting from
	 * @returns {Date} the previous Thursday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // When is the previous Thursday before Jun, 18, 2021?
	 * const result = previousThursday(new Date(2021, 5, 18))
	 * //=> Thu June 17 2021 00:00:00
	 */
	function previousThursday(date) {
	  (0, _index.default)(1, arguments);
	  return (0, _index2.default)(date, 4);
	}
	
	module.exports = exports.default;

/***/ },
/* 1663 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = previousTuesday;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	var _index2 = _interopRequireDefault(__webpack_require__(122));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name previousTuesday
	 * @category Weekday Helpers
	 * @summary When is the previous Tuesday?
	 *
	 * @description
	 * When is the previous Tuesday?
	 *
	 * @param {Date | number} date - the date to start counting from
	 * @returns {Date} the previous Tuesday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // When is the previous Tuesday before Jun, 18, 2021?
	 * const result = previousTuesday(new Date(2021, 5, 18))
	 * //=> Tue June 15 2021 00:00:00
	 */
	function previousTuesday(date) {
	  (0, _index.default)(1, arguments);
	  return (0, _index2.default)(date, 2);
	}
	
	module.exports = exports.default;

/***/ },
/* 1664 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = previousWednesday;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	var _index2 = _interopRequireDefault(__webpack_require__(122));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name previousWednesday
	 * @category Weekday Helpers
	 * @summary When is the previous Wednesday?
	 *
	 * @description
	 * When is the previous Wednesday?
	 *
	 * @param {Date | number} date - the date to start counting from
	 * @returns {Date} the previous Wednesday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // When is the previous Wednesday before Jun, 18, 2021?
	 * const result = previousWednesday(new Date(2021, 5, 18))
	 * //=> Wed June 16 2021 00:00:00
	 */
	function previousWednesday(date) {
	  (0, _index.default)(1, arguments);
	  return (0, _index2.default)(date, 3);
	}
	
	module.exports = exports.default;

/***/ },
/* 1665 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = quartersToMonths;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	var _index2 = __webpack_require__(45);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name quartersToMonths
	 * @category Conversion Helpers
	 * @summary Convert number of quarters to months.
	 *
	 * @description
	 * Convert a number of quarters to a full number of months.
	 *
	 * @param {number} quarters - number of quarters to be converted
	 *
	 * @returns {number} the number of quarters converted in months
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 2 quarters to months
	 * const result = quartersToMonths(2)
	 * //=> 6
	 */
	function quartersToMonths(quarters) {
	  (0, _index.default)(1, arguments);
	  return Math.floor(quarters * _index2.monthsInQuarter);
	}
	
	module.exports = exports.default;

/***/ },
/* 1666 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = quartersToYears;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	var _index2 = __webpack_require__(45);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name quartersToYears
	 * @category Conversion Helpers
	 * @summary Convert number of quarters to years.
	 *
	 * @description
	 * Convert a number of quarters to a full number of years.
	 *
	 * @param {number} quarters - number of quarters to be converted
	 *
	 * @returns {number} the number of quarters converted in years
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 8 quarters to years
	 * const result = quartersToYears(8)
	 * //=> 2
	 *
	 * @example
	 * // It uses floor rounding:
	 * const result = quartersToYears(11)
	 * //=> 2
	 */
	function quartersToYears(quarters) {
	  (0, _index.default)(1, arguments);
	  var years = quarters / _index2.quartersInYear;
	  return Math.floor(years);
	}
	
	module.exports = exports.default;

/***/ },
/* 1667 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = roundToNearestMinutes;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(26));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name roundToNearestMinutes
	 * @category Minute Helpers
	 * @summary Rounds the given date to the nearest minute
	 *
	 * @description
	 * Rounds the given date to the nearest minute (or number of minutes).
	 * Rounds up when the given date is exactly between the nearest round minutes.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to round
	 * @param {Object} [options] - an object with options.
	 * @param {Number} [options.nearestTo=1] - nearest number of minutes to round to. E.g. `15` to round to quarter hours.
	 * @returns {Date} the new date rounded to the closest minute
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.nearestTo` must be between 1 and 30
	 *
	 * @example
	 * // Round 10 July 2014 12:12:34 to nearest minute:
	 * var result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34))
	 * //=> Thu Jul 10 2014 12:13:00
	 *
	 * @example
	 * // Round 10 July 2014 12:07:30 to nearest quarter hour:
	 * var result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34), { nearestTo: 15 })
	 * // rounds up because given date is exactly between 12:00:00 and 12:15:00
	 * //=> Thu Jul 10 2014 12:15:00
	 */
	function roundToNearestMinutes(dirtyDate, options) {
	  if (arguments.length < 1) {
	    throw new TypeError('1 argument required, but only none provided present');
	  }
	
	  var nearestTo = options && 'nearestTo' in options ? (0, _index2.default)(options.nearestTo) : 1;
	
	  if (nearestTo < 1 || nearestTo > 30) {
	    throw new RangeError('`options.nearestTo` must be between 1 and 30');
	  }
	
	  var date = (0, _index.default)(dirtyDate);
	  var seconds = date.getSeconds(); // relevant if nearestTo is 1, which is the default case
	
	  var minutes = date.getMinutes() + seconds / 60;
	  var roundedMinutes = Math.floor(minutes / nearestTo) * nearestTo;
	  var remainderMinutes = minutes % nearestTo;
	  var addedMinutes = Math.round(remainderMinutes / nearestTo) * nearestTo;
	  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), roundedMinutes + addedMinutes);
	}
	
	module.exports = exports.default;

/***/ },
/* 1668 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = secondsToHours;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	var _index2 = __webpack_require__(45);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name secondsToHours
	 * @category Conversion Helpers
	 * @summary Convert seconds to hours.
	 *
	 * @description
	 * Convert a number of seconds to a full number of hours.
	 *
	 * @param {number} seconds - number of seconds to be converted
	 *
	 * @returns {number} the number of seconds converted in hours
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 7200 seconds into hours
	 * const result = secondsToHours(7200)
	 * //=> 2
	 *
	 * @example
	 * // It uses floor rounding:
	 * const result = secondsToHours(7199)
	 * //=> 1
	 */
	function secondsToHours(seconds) {
	  (0, _index.default)(1, arguments);
	  var hours = seconds / _index2.secondsInHour;
	  return Math.floor(hours);
	}
	
	module.exports = exports.default;

/***/ },
/* 1669 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = secondsToMilliseconds;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	var _index2 = __webpack_require__(45);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name secondsToMilliseconds
	 * @category Conversion Helpers
	 * @summary Convert seconds to milliseconds.
	 *
	 * @description
	 * Convert a number of seconds to a full number of milliseconds.
	 *
	 * @param {number} seconds - number of seconds to be converted
	 *
	 * @returns {number} the number of seconds converted in milliseconds
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 2 seconds into milliseconds
	 * const result = secondsToMilliseconds(2)
	 * //=> 2000
	 */
	function secondsToMilliseconds(seconds) {
	  (0, _index.default)(1, arguments);
	  return seconds * _index2.millisecondsInSecond;
	}
	
	module.exports = exports.default;

/***/ },
/* 1670 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = secondsToMinutes;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	var _index2 = __webpack_require__(45);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name secondsToMinutes
	 * @category Conversion Helpers
	 * @summary Convert seconds to minutes.
	 *
	 * @description
	 * Convert a number of seconds to a full number of minutes.
	 *
	 * @param {number} seconds - number of seconds to be converted
	 *
	 * @returns {number} the number of seconds converted in minutes
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 120 seconds into minutes
	 * const result = secondsToMinutes(120)
	 * //=> 2
	 *
	 * @example
	 * // It uses floor rounding:
	 * const result = secondsToMinutes(119)
	 * //=> 1
	 */
	function secondsToMinutes(seconds) {
	  (0, _index.default)(1, arguments);
	  var minutes = seconds / _index2.secondsInMinute;
	  return Math.floor(minutes);
	}
	
	module.exports = exports.default;

/***/ },
/* 1671 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setDate;
	
	var _index = _interopRequireDefault(__webpack_require__(26));
	
	var _index2 = _interopRequireDefault(__webpack_require__(9));
	
	var _index3 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setDate
	 * @category Day Helpers
	 * @summary Set the day of the month to the given date.
	 *
	 * @description
	 * Set the day of the month to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} dayOfMonth - the day of the month of the new date
	 * @returns {Date} the new date with the day of the month set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set the 30th day of the month to 1 September 2014:
	 * var result = setDate(new Date(2014, 8, 1), 30)
	 * //=> Tue Sep 30 2014 00:00:00
	 */
	function setDate(dirtyDate, dirtyDayOfMonth) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var dayOfMonth = (0, _index.default)(dirtyDayOfMonth);
	  date.setDate(dayOfMonth);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 1672 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setDayOfYear;
	
	var _index = _interopRequireDefault(__webpack_require__(26));
	
	var _index2 = _interopRequireDefault(__webpack_require__(9));
	
	var _index3 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setDayOfYear
	 * @category Day Helpers
	 * @summary Set the day of the year to the given date.
	 *
	 * @description
	 * Set the day of the year to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} dayOfYear - the day of the year of the new date
	 * @returns {Date} the new date with the day of the year set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set the 2nd day of the year to 2 July 2014:
	 * var result = setDayOfYear(new Date(2014, 6, 2), 2)
	 * //=> Thu Jan 02 2014 00:00:00
	 */
	function setDayOfYear(dirtyDate, dirtyDayOfYear) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var dayOfYear = (0, _index.default)(dirtyDayOfYear);
	  date.setMonth(0);
	  date.setDate(dayOfYear);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 1673 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setDay;
	
	var _index = _interopRequireDefault(__webpack_require__(95));
	
	var _index2 = _interopRequireDefault(__webpack_require__(9));
	
	var _index3 = _interopRequireDefault(__webpack_require__(26));
	
	var _index4 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setDay
	 * @category Weekday Helpers
	 * @summary Set the day of the week to the given date.
	 *
	 * @description
	 * Set the day of the week to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} day - the day of the week of the new date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Date} the new date with the day of the week set
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // Set week day to Sunday, with the default weekStartsOn of Sunday:
	 * var result = setDay(new Date(2014, 8, 1), 0)
	 * //=> Sun Aug 31 2014 00:00:00
	 *
	 * @example
	 * // Set week day to Sunday, with a weekStartsOn of Monday:
	 * var result = setDay(new Date(2014, 8, 1), 0, { weekStartsOn: 1 })
	 * //=> Sun Sep 07 2014 00:00:00
	 */
	function setDay(dirtyDate, dirtyDay, dirtyOptions) {
	  (0, _index4.default)(2, arguments);
	  var options = dirtyOptions || {};
	  var locale = options.locale;
	  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
	  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, _index3.default)(localeWeekStartsOn);
	  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, _index3.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	
	  var date = (0, _index2.default)(dirtyDate);
	  var day = (0, _index3.default)(dirtyDay);
	  var currentDay = date.getDay();
	  var remainder = day % 7;
	  var dayIndex = (remainder + 7) % 7;
	  var delta = 7 - weekStartsOn;
	  var diff = day < 0 || day > 6 ? day - (currentDay + delta) % 7 : (dayIndex + delta) % 7 - (currentDay + delta) % 7;
	  return (0, _index.default)(date, diff);
	}
	
	module.exports = exports.default;

/***/ },
/* 1674 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setISODay;
	
	var _index = _interopRequireDefault(__webpack_require__(26));
	
	var _index2 = _interopRequireDefault(__webpack_require__(9));
	
	var _index3 = _interopRequireDefault(__webpack_require__(95));
	
	var _index4 = _interopRequireDefault(__webpack_require__(637));
	
	var _index5 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setISODay
	 * @category Weekday Helpers
	 * @summary Set the day of the ISO week to the given date.
	 *
	 * @description
	 * Set the day of the ISO week to the given date.
	 * ISO week starts with Monday.
	 * 7 is the index of Sunday, 1 is the index of Monday etc.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} day - the day of the ISO week of the new date
	 * @returns {Date} the new date with the day of the ISO week set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set Sunday to 1 September 2014:
	 * const result = setISODay(new Date(2014, 8, 1), 7)
	 * //=> Sun Sep 07 2014 00:00:00
	 */
	function setISODay(dirtyDate, dirtyDay) {
	  (0, _index5.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var day = (0, _index.default)(dirtyDay);
	  var currentDay = (0, _index4.default)(date);
	  var diff = day - currentDay;
	  return (0, _index3.default)(date, diff);
	}
	
	module.exports = exports.default;

/***/ },
/* 1675 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setISOWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(26));
	
	var _index2 = _interopRequireDefault(__webpack_require__(9));
	
	var _index3 = _interopRequireDefault(__webpack_require__(638));
	
	var _index4 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setISOWeek
	 * @category ISO Week Helpers
	 * @summary Set the ISO week to the given date.
	 *
	 * @description
	 * Set the ISO week to the given date, saving the weekday number.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} isoWeek - the ISO week of the new date
	 * @returns {Date} the new date with the ISO week set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set the 53rd ISO week to 7 August 2004:
	 * const result = setISOWeek(new Date(2004, 7, 7), 53)
	 * //=> Sat Jan 01 2005 00:00:00
	 */
	function setISOWeek(dirtyDate, dirtyISOWeek) {
	  (0, _index4.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var isoWeek = (0, _index.default)(dirtyISOWeek);
	  var diff = (0, _index3.default)(date) - isoWeek;
	  date.setDate(date.getDate() - diff * 7);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 1676 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setMilliseconds;
	
	var _index = _interopRequireDefault(__webpack_require__(26));
	
	var _index2 = _interopRequireDefault(__webpack_require__(9));
	
	var _index3 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setMilliseconds
	 * @category Millisecond Helpers
	 * @summary Set the milliseconds to the given date.
	 *
	 * @description
	 * Set the milliseconds to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} milliseconds - the milliseconds of the new date
	 * @returns {Date} the new date with the milliseconds set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set 300 milliseconds to 1 September 2014 11:30:40.500:
	 * const result = setMilliseconds(new Date(2014, 8, 1, 11, 30, 40, 500), 300)
	 * //=> Mon Sep 01 2014 11:30:40.300
	 */
	function setMilliseconds(dirtyDate, dirtyMilliseconds) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var milliseconds = (0, _index.default)(dirtyMilliseconds);
	  date.setMilliseconds(milliseconds);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 1677 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setWeekYear;
	
	var _index = _interopRequireDefault(__webpack_require__(120));
	
	var _index2 = _interopRequireDefault(__webpack_require__(413));
	
	var _index3 = _interopRequireDefault(__webpack_require__(9));
	
	var _index4 = _interopRequireDefault(__webpack_require__(26));
	
	var _index5 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setWeekYear
	 * @category Week-Numbering Year Helpers
	 * @summary Set the local week-numbering year to the given date.
	 *
	 * @description
	 * Set the local week-numbering year to the given date,
	 * saving the week number and the weekday number.
	 * The exact calculation depends on the values of
	 * `options.weekStartsOn` (which is the index of the first day of the week)
	 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
	 * the first week of the week-numbering year)
	 *
	 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} weekYear - the local week-numbering year of the new date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
	 * @returns {Date} the new date with the local week-numbering year set
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
	 *
	 * @example
	 * // Set the local week-numbering year 2004 to 2 January 2010 with default options:
	 * var result = setWeekYear(new Date(2010, 0, 2), 2004)
	 * //=> Sat Jan 03 2004 00:00:00
	 *
	 * @example
	 * // Set the local week-numbering year 2004 to 2 January 2010,
	 * // if Monday is the first day of week
	 * // and 4 January is always in the first week of the year:
	 * var result = setWeekYear(new Date(2010, 0, 2), 2004, {
	 *   weekStartsOn: 1,
	 *   firstWeekContainsDate: 4
	 * })
	 * //=> Sat Jan 01 2005 00:00:00
	 */
	function setWeekYear(dirtyDate, dirtyWeekYear) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  (0, _index5.default)(2, arguments);
	  var locale = options.locale;
	  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
	  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, _index4.default)(localeFirstWeekContainsDate);
	  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, _index4.default)(options.firstWeekContainsDate);
	  var date = (0, _index3.default)(dirtyDate);
	  var weekYear = (0, _index4.default)(dirtyWeekYear);
	  var diff = (0, _index.default)(date, (0, _index2.default)(date, options));
	  var firstWeek = new Date(0);
	  firstWeek.setFullYear(weekYear, 0, firstWeekContainsDate);
	  firstWeek.setHours(0, 0, 0, 0);
	  date = (0, _index2.default)(firstWeek, options);
	  date.setDate(date.getDate() + diff);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 1678 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(397));
	
	var _index2 = _interopRequireDefault(__webpack_require__(9));
	
	var _index3 = _interopRequireDefault(__webpack_require__(26));
	
	var _index4 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setWeek
	 * @category Week Helpers
	 * @summary Set the local week to the given date.
	 *
	 * @description
	 * Set the local week to the given date, saving the weekday number.
	 * The exact calculation depends on the values of
	 * `options.weekStartsOn` (which is the index of the first day of the week)
	 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
	 * the first week of the week-numbering year)
	 *
	 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} week - the week of the new date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
	 * @returns {Date} the new date with the local week set
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
	 *
	 * @example
	 * // Set the 1st week to 2 January 2005 with default options:
	 * var result = setWeek(new Date(2005, 0, 2), 1)
	 * //=> Sun Dec 26 2004 00:00:00
	 *
	 * @example
	 * // Set the 1st week to 2 January 2005,
	 * // if Monday is the first day of the week,
	 * // and the first week of the year always contains 4 January:
	 * var result = setWeek(new Date(2005, 0, 2), 1, {
	 *   weekStartsOn: 1,
	 *   firstWeekContainsDate: 4
	 * })
	 * //=> Sun Jan 4 2004 00:00:00
	 */
	function setWeek(dirtyDate, dirtyWeek, options) {
	  (0, _index4.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var week = (0, _index3.default)(dirtyWeek);
	  var diff = (0, _index.default)(date, options) - week;
	  date.setDate(date.getDate() - diff * 7);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 1679 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = set;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(268));
	
	var _index3 = _interopRequireDefault(__webpack_require__(26));
	
	var _index4 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name set
	 * @category Common Helpers
	 * @summary Set date values to a given date.
	 *
	 * @description
	 * Set date values to a given date.
	 *
	 * Sets time values to date from object `values`.
	 * A value is not set if it is undefined or null or doesn't exist in `values`.
	 *
	 * Note about bundle size: `set` does not internally use `setX` functions from date-fns but instead opts
	 * to use native `Date#setX` methods. If you use this function, you may not want to include the
	 * other `setX` functions that date-fns provides if you are concerned about the bundle size.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Object} values - an object with options
	 * @param {Number} [values.year] - the number of years to be set
	 * @param {Number} [values.month] - the number of months to be set
	 * @param {Number} [values.date] - the number of days to be set
	 * @param {Number} [values.hours] - the number of hours to be set
	 * @param {Number} [values.minutes] - the number of minutes to be set
	 * @param {Number} [values.seconds] - the number of seconds to be set
	 * @param {Number} [values.milliseconds] - the number of milliseconds to be set
	 * @returns {Date} the new date with options set
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `values` must be an object
	 *
	 * @example
	 * // Transform 1 September 2014 into 20 October 2015 in a single line:
	 * var result = set(new Date(2014, 8, 20), { year: 2015, month: 9, date: 20 })
	 * //=> Tue Oct 20 2015 00:00:00
	 *
	 * @example
	 * // Set 12 PM to 1 September 2014 01:23:45 to 1 September 2014 12:00:00:
	 * var result = set(new Date(2014, 8, 1, 1, 23, 45), { hours: 12 })
	 * //=> Mon Sep 01 2014 12:23:45
	 */
	function set(dirtyDate, values) {
	  (0, _index4.default)(2, arguments);
	
	  if (typeof values !== 'object' || values === null) {
	    throw new RangeError('values parameter must be an object');
	  }
	
	  var date = (0, _index.default)(dirtyDate); // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
	
	  if (isNaN(date.getTime())) {
	    return new Date(NaN);
	  }
	
	  if (values.year != null) {
	    date.setFullYear(values.year);
	  }
	
	  if (values.month != null) {
	    date = (0, _index2.default)(date, values.month);
	  }
	
	  if (values.date != null) {
	    date.setDate((0, _index3.default)(values.date));
	  }
	
	  if (values.hours != null) {
	    date.setHours((0, _index3.default)(values.hours));
	  }
	
	  if (values.minutes != null) {
	    date.setMinutes((0, _index3.default)(values.minutes));
	  }
	
	  if (values.seconds != null) {
	    date.setSeconds((0, _index3.default)(values.seconds));
	  }
	
	  if (values.milliseconds != null) {
	    date.setMilliseconds((0, _index3.default)(values.milliseconds));
	  }
	
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 1680 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfDecade;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfDecade
	 * @category Decade Helpers
	 * @summary Return the start of a decade for the given date.
	 *
	 * @description
	 * Return the start of a decade for the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of a decade
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of a decade for 21 October 2015 00:00:00:
	 * const result = startOfDecade(new Date(2015, 9, 21, 00, 00, 00))
	 * //=> Jan 01 2010 00:00:00
	 */
	function startOfDecade(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  var decade = Math.floor(year / 10) * 10;
	  date.setFullYear(decade, 0, 1);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 1681 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfToday;
	
	var _index = _interopRequireDefault(__webpack_require__(211));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfToday
	 * @category Day Helpers
	 * @summary Return the start of today.
	 * @pure false
	 *
	 * @description
	 * Return the start of today.
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @returns {Date} the start of today
	 *
	 * @example
	 * // If today is 6 October 2014:
	 * var result = startOfToday()
	 * //=> Mon Oct 6 2014 00:00:00
	 */
	function startOfToday() {
	  return (0, _index.default)(Date.now());
	}
	
	module.exports = exports.default;

/***/ },
/* 1682 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfTomorrow;
	
	/**
	 * @name startOfTomorrow
	 * @category Day Helpers
	 * @summary Return the start of tomorrow.
	 * @pure false
	 *
	 * @description
	 * Return the start of tomorrow.
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `new Date()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @returns {Date} the start of tomorrow
	 *
	 * @example
	 * // If today is 6 October 2014:
	 * const result = startOfTomorrow()
	 * //=> Tue Oct 7 2014 00:00:00
	 */
	function startOfTomorrow() {
	  var now = new Date();
	  var year = now.getFullYear();
	  var month = now.getMonth();
	  var day = now.getDate();
	  var date = new Date(0);
	  date.setFullYear(year, month, day + 1);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 1683 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfYesterday;
	
	/**
	 * @name startOfYesterday
	 * @category Day Helpers
	 * @summary Return the start of yesterday.
	 * @pure false
	 *
	 * @description
	 * Return the start of yesterday.
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `new Date()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @returns {Date} the start of yesterday
	 *
	 * @example
	 * // If today is 6 October 2014:
	 * const result = startOfYesterday()
	 * //=> Sun Oct 5 2014 00:00:00
	 */
	function startOfYesterday() {
	  var now = new Date();
	  var year = now.getFullYear();
	  var month = now.getMonth();
	  var day = now.getDate();
	  var date = new Date(0);
	  date.setFullYear(year, month, day - 1);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 1684 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subBusinessDays;
	
	var _index = _interopRequireDefault(__webpack_require__(624));
	
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	
	var _index3 = _interopRequireDefault(__webpack_require__(26));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name subBusinessDays
	 * @category Day Helpers
	 * @summary Substract the specified number of business days (mon - fri) to the given date.
	 *
	 * @description
	 * Substract the specified number of business days (mon - fri) to the given date, ignoring weekends.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of business days to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the business days subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Substract 10 business days from 1 September 2014:
	 * const result = subBusinessDays(new Date(2014, 8, 1), 10)
	 * //=> Mon Aug 18 2014 00:00:00 (skipped weekend days)
	 */
	function subBusinessDays(dirtyDate, dirtyAmount) {
	  (0, _index2.default)(2, arguments);
	  var amount = (0, _index3.default)(dirtyAmount);
	  return (0, _index.default)(dirtyDate, -amount);
	}
	
	module.exports = exports.default;

/***/ },
/* 1685 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subQuarters;
	
	var _index = _interopRequireDefault(__webpack_require__(26));
	
	var _index2 = _interopRequireDefault(__webpack_require__(384));
	
	var _index3 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name subQuarters
	 * @category Quarter Helpers
	 * @summary Subtract the specified number of year quarters from the given date.
	 *
	 * @description
	 * Subtract the specified number of year quarters from the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of quarters to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the quarters subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 3 quarters from 1 September 2014:
	 * const result = subQuarters(new Date(2014, 8, 1), 3)
	 * //=> Sun Dec 01 2013 00:00:00
	 */
	function subQuarters(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	
	module.exports = exports.default;

/***/ },
/* 1686 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subSeconds;
	
	var _index = _interopRequireDefault(__webpack_require__(26));
	
	var _index2 = _interopRequireDefault(__webpack_require__(626));
	
	var _index3 = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name subSeconds
	 * @category Second Helpers
	 * @summary Subtract the specified number of seconds from the given date.
	 *
	 * @description
	 * Subtract the specified number of seconds from the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of seconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the seconds subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 30 seconds from 10 July 2014 12:45:00:
	 * const result = subSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
	 * //=> Thu Jul 10 2014 12:44:30
	 */
	function subSeconds(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	
	module.exports = exports.default;

/***/ },
/* 1687 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = weeksToDays;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	var _index2 = __webpack_require__(45);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name weeksToDays
	 * @category Conversion Helpers
	 * @summary Convert weeks to days.
	 *
	 * @description
	 * Convert a number of weeks to a full number of days.
	 *
	 * @param {number} weeks - number of weeks to be converted
	 *
	 * @returns {number} the number of weeks converted in days
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 2 weeks into days
	 * const result = weeksToDays(2)
	 * //=> 14
	 */
	function weeksToDays(weeks) {
	  (0, _index.default)(1, arguments);
	  return Math.floor(weeks * _index2.daysInWeek);
	}
	
	module.exports = exports.default;

/***/ },
/* 1688 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = yearsToMonths;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	var _index2 = __webpack_require__(45);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name yearsToMonths
	 * @category Conversion Helpers
	 * @summary Convert years to months.
	 *
	 * @description
	 * Convert a number of years to a full number of months.
	 *
	 * @param {number} years - number of years to be converted
	 *
	 * @returns {number} the number of years converted in months
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 2 years into months
	 * const result = yearsToMonths(2)
	 * //=> 24
	 */
	function yearsToMonths(years) {
	  (0, _index.default)(1, arguments);
	  return Math.floor(years * _index2.monthsInYear);
	}
	
	module.exports = exports.default;

/***/ },
/* 1689 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = yearsToQuarters;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	var _index2 = __webpack_require__(45);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name yearsToQuarters
	 * @category Conversion Helpers
	 * @summary Convert years to quarters.
	 *
	 * @description
	 * Convert a number of years to a full number of quarters.
	 *
	 * @param {number} years - number of years to be converted
	 *
	 * @returns {number} the number of years converted in quarters
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 2 years to quarters
	 * const result = yearsToQuarters(2)
	 * //=> 8
	 */
	function yearsToQuarters(years) {
	  (0, _index.default)(1, arguments);
	  return Math.floor(years * _index2.quartersInYear);
	}
	
	module.exports = exports.default;

/***/ },
/* 1690 */
/***/ function(module, exports, __webpack_require__) {

	var objectKeys = __webpack_require__(905);
	var isArguments = __webpack_require__(2035);
	var is = __webpack_require__(2192);
	var isRegex = __webpack_require__(2039);
	var flags = __webpack_require__(2457);
	var isDate = __webpack_require__(2036);
	
	var getTime = Date.prototype.getTime;
	
	function deepEqual(actual, expected, options) {
	  var opts = options || {};
	
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (opts.strict ? is(actual, expected) : actual === expected) {
	    return true;
	  }
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
	  if (!actual || !expected || (typeof actual !== 'object' && typeof expected !== 'object')) {
	    return opts.strict ? is(actual, expected) : actual == expected;
	  }
	
	  /*
	   * 7.4. For all other Object pairs, including Array objects, equivalence is
	   * determined by having the same number of owned properties (as verified
	   * with Object.prototype.hasOwnProperty.call), the same set of keys
	   * (although not necessarily the same order), equivalent values for every
	   * corresponding key, and an identical 'prototype' property. Note: this
	   * accounts for both named and indexed properties on Arrays.
	   */
	  // eslint-disable-next-line no-use-before-define
	  return objEquiv(actual, expected, opts);
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer(x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') {
	    return false;
	  }
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') {
	    return false;
	  }
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  /* eslint max-statements: [2, 50] */
	  var i, key;
	  if (typeof a !== typeof b) { return false; }
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b)) { return false; }
	
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) { return false; }
	
	  if (isArguments(a) !== isArguments(b)) { return false; }
	
	  var aIsRegex = isRegex(a);
	  var bIsRegex = isRegex(b);
	  if (aIsRegex !== bIsRegex) { return false; }
	  if (aIsRegex || bIsRegex) {
	    return a.source === b.source && flags(a) === flags(b);
	  }
	
	  if (isDate(a) && isDate(b)) {
	    return getTime.call(a) === getTime.call(b);
	  }
	
	  var aIsBuffer = isBuffer(a);
	  var bIsBuffer = isBuffer(b);
	  if (aIsBuffer !== bIsBuffer) { return false; }
	  if (aIsBuffer || bIsBuffer) { // && would work too, because both are true or both false here
	    if (a.length !== b.length) { return false; }
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) { return false; }
	    }
	    return true;
	  }
	
	  if (typeof a !== typeof b) { return false; }
	
	  try {
	    var ka = objectKeys(a);
	    var kb = objectKeys(b);
	  } catch (e) { // happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates hasOwnProperty)
	  if (ka.length !== kb.length) { return false; }
	
	  // the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  // ~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i]) { return false; }
	  }
	  // equivalent values for every corresponding key, and ~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) { return false; }
	  }
	
	  return true;
	}
	
	module.exports = deepEqual;


/***/ },
/* 1691 */
/***/ function(module, exports) {

	'use strict'
	
	module.exports = direction
	
	var RTL = '\u0591-\u07FF\uFB1D-\uFDFD\uFE70-\uFEFC'
	var LTR =
	  'A-Za-z\u00C0-\u00D6\u00D8-\u00F6' +
	  '\u00F8-\u02B8\u0300-\u0590\u0800-\u1FFF\u200E\u2C00-\uFB1C' +
	  '\uFE00-\uFE6F\uFEFD-\uFFFF'
	
	var rtl = new RegExp('^[^' + LTR + ']*[' + RTL + ']')
	var ltr = new RegExp('^[^' + RTL + ']*[' + LTR + ']')
	
	function direction(value) {
	  value = String(value || '')
	
	  if (rtl.test(value)) {
	    return 'rtl'
	  }
	
	  if (ltr.test(value)) {
	    return 'ltr'
	  }
	
	  return 'neutral'
	}


/***/ },
/* 1692 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _addClass = _interopRequireDefault(__webpack_require__(416));
	
	exports.addClass = _addClass.default;
	
	var _removeClass = _interopRequireDefault(__webpack_require__(417));
	
	exports.removeClass = _removeClass.default;
	
	var _hasClass = _interopRequireDefault(__webpack_require__(675));
	
	exports.hasClass = _hasClass.default;
	var _default = {
	  addClass: _addClass.default,
	  removeClass: _removeClass.default,
	  hasClass: _hasClass.default
	};
	exports.default = _default;

/***/ },
/* 1693 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = filterEvents;
	
	var _contains = _interopRequireDefault(__webpack_require__(174));
	
	var _querySelectorAll = _interopRequireDefault(__webpack_require__(1698));
	
	function filterEvents(selector, handler) {
	  return function filterHandler(e) {
	    var top = e.currentTarget,
	        target = e.target,
	        matches = (0, _querySelectorAll.default)(top, selector);
	    if (matches.some(function (match) {
	      return (0, _contains.default)(match, target);
	    })) handler.call(this, e);
	  };
	}
	
	module.exports = exports["default"];

/***/ },
/* 1694 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _on = _interopRequireDefault(__webpack_require__(271));
	
	exports.on = _on.default;
	
	var _off = _interopRequireDefault(__webpack_require__(418));
	
	exports.off = _off.default;
	
	var _filter = _interopRequireDefault(__webpack_require__(1693));
	
	exports.filter = _filter.default;
	
	var _listen = _interopRequireDefault(__webpack_require__(1695));
	
	exports.listen = _listen.default;
	var _default = {
	  on: _on.default,
	  off: _off.default,
	  filter: _filter.default,
	  listen: _listen.default
	};
	exports.default = _default;

/***/ },
/* 1695 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(123));
	
	var _on = _interopRequireDefault(__webpack_require__(271));
	
	var _off = _interopRequireDefault(__webpack_require__(418));
	
	var listen = function listen() {};
	
	if (_inDOM.default) {
	  listen = function listen(node, eventName, handler, capture) {
	    (0, _on.default)(node, eventName, handler, capture);
	    return function () {
	      (0, _off.default)(node, eventName, handler, capture);
	    };
	  };
	}
	
	var _default = listen;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1696 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = offsetParent;
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(173));
	
	var _style = _interopRequireDefault(__webpack_require__(273));
	
	function nodeName(node) {
	  return node.nodeName && node.nodeName.toLowerCase();
	}
	
	function offsetParent(node) {
	  var doc = (0, _ownerDocument.default)(node),
	      offsetParent = node && node.offsetParent;
	
	  while (offsetParent && nodeName(node) !== 'html' && (0, _style.default)(offsetParent, 'position') === 'static') {
	    offsetParent = offsetParent.offsetParent;
	  }
	
	  return offsetParent || doc.documentElement;
	}
	
	module.exports = exports["default"];

/***/ },
/* 1697 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = position;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _offset = _interopRequireDefault(__webpack_require__(676));
	
	var _offsetParent = _interopRequireDefault(__webpack_require__(1696));
	
	var _scrollTop = _interopRequireDefault(__webpack_require__(677));
	
	var _scrollLeft = _interopRequireDefault(__webpack_require__(1699));
	
	var _style = _interopRequireDefault(__webpack_require__(273));
	
	function nodeName(node) {
	  return node.nodeName && node.nodeName.toLowerCase();
	}
	
	function position(node, offsetParent) {
	  var parentOffset = {
	    top: 0,
	    left: 0
	  },
	      offset; // Fixed elements are offset from window (parentOffset = {top:0, left: 0},
	  // because it is its only offset parent
	
	  if ((0, _style.default)(node, 'position') === 'fixed') {
	    offset = node.getBoundingClientRect();
	  } else {
	    offsetParent = offsetParent || (0, _offsetParent.default)(node);
	    offset = (0, _offset.default)(node);
	    if (nodeName(offsetParent) !== 'html') parentOffset = (0, _offset.default)(offsetParent);
	    parentOffset.top += parseInt((0, _style.default)(offsetParent, 'borderTopWidth'), 10) - (0, _scrollTop.default)(offsetParent) || 0;
	    parentOffset.left += parseInt((0, _style.default)(offsetParent, 'borderLeftWidth'), 10) - (0, _scrollLeft.default)(offsetParent) || 0;
	  } // Subtract parent offsets and node margins
	
	
	  return (0, _extends2.default)({}, offset, {
	    top: offset.top - parentOffset.top - (parseInt((0, _style.default)(node, 'marginTop'), 10) || 0),
	    left: offset.left - parentOffset.left - (parseInt((0, _style.default)(node, 'marginLeft'), 10) || 0)
	  });
	}
	
	module.exports = exports["default"];

/***/ },
/* 1698 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = qsa;
	// Zepto.js
	// (c) 2010-2015 Thomas Fuchs
	// Zepto.js may be freely distributed under the MIT license.
	var simpleSelectorRE = /^[\w-]*$/;
	var toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
	
	function qsa(element, selector) {
	  var maybeID = selector[0] === '#',
	      maybeClass = selector[0] === '.',
	      nameOnly = maybeID || maybeClass ? selector.slice(1) : selector,
	      isSimple = simpleSelectorRE.test(nameOnly),
	      found;
	
	  if (isSimple) {
	    if (maybeID) {
	      element = element.getElementById ? element : document;
	      return (found = element.getElementById(nameOnly)) ? [found] : [];
	    }
	
	    if (element.getElementsByClassName && maybeClass) return toArray(element.getElementsByClassName(nameOnly));
	    return toArray(element.getElementsByTagName(selector));
	  }
	
	  return toArray(element.querySelectorAll(selector));
	}
	
	module.exports = exports["default"];

/***/ },
/* 1699 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = scrollTop;
	
	var _isWindow = _interopRequireDefault(__webpack_require__(272));
	
	function scrollTop(node, val) {
	  var win = (0, _isWindow.default)(node);
	  if (val === undefined) return win ? 'pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft : node.scrollLeft;
	  if (win) win.scrollTo(val, 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop);else node.scrollLeft = val;
	}
	
	module.exports = exports["default"];

/***/ },
/* 1700 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = _getComputedStyle;
	
	var _camelizeStyle = _interopRequireDefault(__webpack_require__(679));
	
	var rposition = /^(top|right|bottom|left)$/;
	var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;
	
	function _getComputedStyle(node) {
	  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
	  var doc = node.ownerDocument;
	  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : {
	    //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
	    getPropertyValue: function getPropertyValue(prop) {
	      var style = node.style;
	      prop = (0, _camelizeStyle.default)(prop);
	      if (prop == 'float') prop = 'styleFloat';
	      var current = node.currentStyle[prop] || null;
	      if (current == null && style && style[prop]) current = style[prop];
	
	      if (rnumnonpx.test(current) && !rposition.test(prop)) {
	        // Remember the original values
	        var left = style.left;
	        var runStyle = node.runtimeStyle;
	        var rsLeft = runStyle && runStyle.left; // Put in the new values to get a computed value out
	
	        if (rsLeft) runStyle.left = node.currentStyle.left;
	        style.left = prop === 'fontSize' ? '1em' : current;
	        current = style.pixelLeft + 'px'; // Revert the changed values
	
	        style.left = left;
	        if (rsLeft) runStyle.left = rsLeft;
	      }
	
	      return current;
	    }
	  };
	}
	
	module.exports = exports["default"];

/***/ },
/* 1701 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = removeStyle;
	
	function removeStyle(node, key) {
	  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
	}
	
	module.exports = exports["default"];

/***/ },
/* 1702 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = isTransform;
	var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
	
	function isTransform(property) {
	  return !!(property && supportedTransforms.test(property));
	}
	
	module.exports = exports["default"];

/***/ },
/* 1703 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = camelize;
	var rHyphen = /-(.)/g;
	
	function camelize(string) {
	  return string.replace(rHyphen, function (_, chr) {
	    return chr.toUpperCase();
	  });
	}
	
	module.exports = exports["default"];

/***/ },
/* 1704 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = hyphenate;
	var rUpper = /([A-Z])/g;
	
	function hyphenate(string) {
	  return string.replace(rUpper, '-$1').toLowerCase();
	}
	
	module.exports = exports["default"];

/***/ },
/* 1705 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = hyphenateStyleName;
	
	var _hyphenate = _interopRequireDefault(__webpack_require__(1704));
	
	/**
	 * Copyright 2013-2014, Facebook, Inc.
	 * All rights reserved.
	 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
	 */
	var msPattern = /^ms-/;
	
	function hyphenateStyleName(string) {
	  return (0, _hyphenate.default)(string).replace(msPattern, '-ms-');
	}
	
	module.exports = exports["default"];

/***/ },
/* 1706 */
/***/ function(module, exports, __webpack_require__) {

	/*
	  Module dependencies
	*/
	var ElementType = __webpack_require__(1707);
	var entities = __webpack_require__(1709);
	
	/* mixed-case SVG and MathML tags & attributes
	   recognized by the HTML parser, see
	   https://html.spec.whatwg.org/multipage/parsing.html#parsing-main-inforeign
	*/
	var foreignNames = __webpack_require__(2043);
	foreignNames.elementNames.__proto__ = null; /* use as a simple dictionary */
	foreignNames.attributeNames.__proto__ = null;
	
	var unencodedElements = {
	  __proto__: null,
	  style: true,
	  script: true,
	  xmp: true,
	  iframe: true,
	  noembed: true,
	  noframes: true,
	  plaintext: true,
	  noscript: true
	};
	
	/*
	  Format attributes
	*/
	function formatAttrs(attributes, opts) {
	  if (!attributes) return;
	
	  var output = '';
	  var value;
	
	  // Loop through the attributes
	  for (var key in attributes) {
	    value = attributes[key];
	    if (output) {
	      output += ' ';
	    }
	
	    if (opts.xmlMode === 'foreign') {
	      /* fix up mixed-case attribute names */
	      key = foreignNames.attributeNames[key] || key;
	    }
	    output += key;
	    if ((value !== null && value !== '') || opts.xmlMode) {
	      output +=
	        '="' +
	        (opts.decodeEntities
	          ? entities.encodeXML(value)
	          : value.replace(/\"/g, '&quot;')) +
	        '"';
	    }
	  }
	
	  return output;
	}
	
	/*
	  Self-enclosing tags (stolen from node-htmlparser)
	*/
	var singleTag = {
	  __proto__: null,
	  area: true,
	  base: true,
	  basefont: true,
	  br: true,
	  col: true,
	  command: true,
	  embed: true,
	  frame: true,
	  hr: true,
	  img: true,
	  input: true,
	  isindex: true,
	  keygen: true,
	  link: true,
	  meta: true,
	  param: true,
	  source: true,
	  track: true,
	  wbr: true
	};
	
	var render = (module.exports = function(dom, opts) {
	  if (!Array.isArray(dom) && !dom.cheerio) dom = [dom];
	  opts = opts || {};
	
	  var output = '';
	
	  for (var i = 0; i < dom.length; i++) {
	    var elem = dom[i];
	
	    if (elem.type === 'root') output += render(elem.children, opts);
	    else if (ElementType.isTag(elem)) output += renderTag(elem, opts);
	    else if (elem.type === ElementType.Directive)
	      output += renderDirective(elem);
	    else if (elem.type === ElementType.Comment) output += renderComment(elem);
	    else if (elem.type === ElementType.CDATA) output += renderCdata(elem);
	    else output += renderText(elem, opts);
	  }
	
	  return output;
	});
	
	var foreignModeIntegrationPoints = [
	  'mi',
	  'mo',
	  'mn',
	  'ms',
	  'mtext',
	  'annotation-xml',
	  'foreignObject',
	  'desc',
	  'title'
	];
	
	function renderTag(elem, opts) {
	  // Handle SVG / MathML in HTML
	  if (opts.xmlMode === 'foreign') {
	    /* fix up mixed-case element names */
	    elem.name = foreignNames.elementNames[elem.name] || elem.name;
	    /* exit foreign mode at integration points */
	    if (
	      elem.parent &&
	      foreignModeIntegrationPoints.indexOf(elem.parent.name) >= 0
	    )
	      opts = Object.assign({}, opts, { xmlMode: false });
	  }
	  if (!opts.xmlMode && ['svg', 'math'].indexOf(elem.name) >= 0) {
	    opts = Object.assign({}, opts, { xmlMode: 'foreign' });
	  }
	
	  var tag = '<' + elem.name;
	  var attribs = formatAttrs(elem.attribs, opts);
	
	  if (attribs) {
	    tag += ' ' + attribs;
	  }
	
	  if (opts.xmlMode && (!elem.children || elem.children.length === 0)) {
	    tag += '/>';
	  } else {
	    tag += '>';
	    if (elem.children) {
	      tag += render(elem.children, opts);
	    }
	
	    if (!singleTag[elem.name] || opts.xmlMode) {
	      tag += '</' + elem.name + '>';
	    }
	  }
	
	  return tag;
	}
	
	function renderDirective(elem) {
	  return '<' + elem.data + '>';
	}
	
	function renderText(elem, opts) {
	  var data = elem.data || '';
	
	  // if entities weren't decoded, no need to encode them back
	  if (
	    opts.decodeEntities &&
	    !(elem.parent && elem.parent.name in unencodedElements)
	  ) {
	    data = entities.encodeXML(data);
	  }
	
	  return data;
	}
	
	function renderCdata(elem) {
	  return '<![CDATA[' + elem.children[0].data + ']]>';
	}
	
	function renderComment(elem) {
	  return '<!--' + elem.data + '-->';
	}


/***/ },
/* 1707 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Doctype = exports.CDATA = exports.Tag = exports.Style = exports.Script = exports.Comment = exports.Directive = exports.Text = exports.Root = exports.isTag = exports.ElementType = void 0;
	/** Types of elements found in htmlparser2's DOM */
	var ElementType;
	(function (ElementType) {
	    /** Type for the root element of a document */
	    ElementType["Root"] = "root";
	    /** Type for Text */
	    ElementType["Text"] = "text";
	    /** Type for <? ... ?> */
	    ElementType["Directive"] = "directive";
	    /** Type for <!-- ... --> */
	    ElementType["Comment"] = "comment";
	    /** Type for <script> tags */
	    ElementType["Script"] = "script";
	    /** Type for <style> tags */
	    ElementType["Style"] = "style";
	    /** Type for Any tag */
	    ElementType["Tag"] = "tag";
	    /** Type for <![CDATA[ ... ]]> */
	    ElementType["CDATA"] = "cdata";
	    /** Type for <!doctype ...> */
	    ElementType["Doctype"] = "doctype";
	})(ElementType = exports.ElementType || (exports.ElementType = {}));
	/**
	 * Tests whether an element is a tag or not.
	 *
	 * @param elem Element to test
	 */
	function isTag(elem) {
	    return (elem.type === ElementType.Tag ||
	        elem.type === ElementType.Script ||
	        elem.type === ElementType.Style);
	}
	exports.isTag = isTag;
	// Exports for backwards compatibility
	/** Type for the root element of a document */
	exports.Root = ElementType.Root;
	/** Type for Text */
	exports.Text = ElementType.Text;
	/** Type for <? ... ?> */
	exports.Directive = ElementType.Directive;
	/** Type for <!-- ... --> */
	exports.Comment = ElementType.Comment;
	/** Type for <script> tags */
	exports.Script = ElementType.Script;
	/** Type for <style> tags */
	exports.Style = ElementType.Style;
	/** Type for Any tag */
	exports.Tag = ElementType.Tag;
	/** Type for <![CDATA[ ... ]]> */
	exports.CDATA = ElementType.CDATA;
	/** Type for <!doctype ...> */
	exports.Doctype = ElementType.Doctype;


/***/ },
/* 1708 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var decode_json_1 = __importDefault(__webpack_require__(2044));
	// Adapted from https://github.com/mathiasbynens/he/blob/master/src/he.js#L94-L119
	var fromCodePoint = 
	// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
	String.fromCodePoint ||
	    function (codePoint) {
	        var output = "";
	        if (codePoint > 0xffff) {
	            codePoint -= 0x10000;
	            output += String.fromCharCode(((codePoint >>> 10) & 0x3ff) | 0xd800);
	            codePoint = 0xdc00 | (codePoint & 0x3ff);
	        }
	        output += String.fromCharCode(codePoint);
	        return output;
	    };
	function decodeCodePoint(codePoint) {
	    if ((codePoint >= 0xd800 && codePoint <= 0xdfff) || codePoint > 0x10ffff) {
	        return "\uFFFD";
	    }
	    if (codePoint in decode_json_1.default) {
	        codePoint = decode_json_1.default[codePoint];
	    }
	    return fromCodePoint(codePoint);
	}
	exports.default = decodeCodePoint;


/***/ },
/* 1709 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.decodeXMLStrict = exports.decodeHTML5Strict = exports.decodeHTML4Strict = exports.decodeHTML5 = exports.decodeHTML4 = exports.decodeHTMLStrict = exports.decodeHTML = exports.decodeXML = exports.encodeHTML5 = exports.encodeHTML4 = exports.escapeUTF8 = exports.escape = exports.encodeNonAsciiHTML = exports.encodeHTML = exports.encodeXML = exports.encode = exports.decodeStrict = exports.decode = void 0;
	var decode_1 = __webpack_require__(681);
	var encode_1 = __webpack_require__(682);
	/**
	 * Decodes a string with entities.
	 *
	 * @param data String to decode.
	 * @param level Optional level to decode at. 0 = XML, 1 = HTML. Default is 0.
	 * @deprecated Use `decodeXML` or `decodeHTML` directly.
	 */
	function decode(data, level) {
	    return (!level || level <= 0 ? decode_1.decodeXML : decode_1.decodeHTML)(data);
	}
	exports.decode = decode;
	/**
	 * Decodes a string with entities. Does not allow missing trailing semicolons for entities.
	 *
	 * @param data String to decode.
	 * @param level Optional level to decode at. 0 = XML, 1 = HTML. Default is 0.
	 * @deprecated Use `decodeHTMLStrict` or `decodeXML` directly.
	 */
	function decodeStrict(data, level) {
	    return (!level || level <= 0 ? decode_1.decodeXML : decode_1.decodeHTMLStrict)(data);
	}
	exports.decodeStrict = decodeStrict;
	/**
	 * Encodes a string with entities.
	 *
	 * @param data String to encode.
	 * @param level Optional level to encode at. 0 = XML, 1 = HTML. Default is 0.
	 * @deprecated Use `encodeHTML`, `encodeXML` or `encodeNonAsciiHTML` directly.
	 */
	function encode(data, level) {
	    return (!level || level <= 0 ? encode_1.encodeXML : encode_1.encodeHTML)(data);
	}
	exports.encode = encode;
	var encode_2 = __webpack_require__(682);
	Object.defineProperty(exports, "encodeXML", { enumerable: true, get: function () { return encode_2.encodeXML; } });
	Object.defineProperty(exports, "encodeHTML", { enumerable: true, get: function () { return encode_2.encodeHTML; } });
	Object.defineProperty(exports, "encodeNonAsciiHTML", { enumerable: true, get: function () { return encode_2.encodeNonAsciiHTML; } });
	Object.defineProperty(exports, "escape", { enumerable: true, get: function () { return encode_2.escape; } });
	Object.defineProperty(exports, "escapeUTF8", { enumerable: true, get: function () { return encode_2.escapeUTF8; } });
	// Legacy aliases (deprecated)
	Object.defineProperty(exports, "encodeHTML4", { enumerable: true, get: function () { return encode_2.encodeHTML; } });
	Object.defineProperty(exports, "encodeHTML5", { enumerable: true, get: function () { return encode_2.encodeHTML; } });
	var decode_2 = __webpack_require__(681);
	Object.defineProperty(exports, "decodeXML", { enumerable: true, get: function () { return decode_2.decodeXML; } });
	Object.defineProperty(exports, "decodeHTML", { enumerable: true, get: function () { return decode_2.decodeHTML; } });
	Object.defineProperty(exports, "decodeHTMLStrict", { enumerable: true, get: function () { return decode_2.decodeHTMLStrict; } });
	// Legacy aliases (deprecated)
	Object.defineProperty(exports, "decodeHTML4", { enumerable: true, get: function () { return decode_2.decodeHTML; } });
	Object.defineProperty(exports, "decodeHTML5", { enumerable: true, get: function () { return decode_2.decodeHTML; } });
	Object.defineProperty(exports, "decodeHTML4Strict", { enumerable: true, get: function () { return decode_2.decodeHTMLStrict; } });
	Object.defineProperty(exports, "decodeHTML5Strict", { enumerable: true, get: function () { return decode_2.decodeHTMLStrict; } });
	Object.defineProperty(exports, "decodeXMLStrict", { enumerable: true, get: function () { return decode_2.decodeXML; } });


/***/ },
/* 1710 */
/***/ function(module, exports, __webpack_require__) {

	// DOM-Level-1-compliant structure
	var NodePrototype = __webpack_require__(684);
	var ElementPrototype = module.exports = Object.create(NodePrototype);
	
	var domLvl1 = {
		tagName: "name"
	};
	
	Object.keys(domLvl1).forEach(function(key) {
		var shorthand = domLvl1[key];
		Object.defineProperty(ElementPrototype, key, {
			get: function() {
				return this[shorthand] || null;
			},
			set: function(val) {
				this[shorthand] = val;
				return val;
			}
		});
	});


/***/ },
/* 1711 */
/***/ function(module, exports) {

	// removeSubsets
	// Given an array of nodes, remove any member that is contained by another.
	exports.removeSubsets = function(nodes) {
		var idx = nodes.length, node, ancestor, replace;
	
		// Check if each node (or one of its ancestors) is already contained in the
		// array.
		while (--idx > -1) {
			node = ancestor = nodes[idx];
	
			// Temporarily remove the node under consideration
			nodes[idx] = null;
			replace = true;
	
			while (ancestor) {
				if (nodes.indexOf(ancestor) > -1) {
					replace = false;
					nodes.splice(idx, 1);
					break;
				}
				ancestor = ancestor.parent;
			}
	
			// If the node has been found to be unique, re-insert it.
			if (replace) {
				nodes[idx] = node;
			}
		}
	
		return nodes;
	};
	
	// Source: http://dom.spec.whatwg.org/#dom-node-comparedocumentposition
	var POSITION = {
		DISCONNECTED: 1,
		PRECEDING: 2,
		FOLLOWING: 4,
		CONTAINS: 8,
		CONTAINED_BY: 16
	};
	
	// Compare the position of one node against another node in any other document.
	// The return value is a bitmask with the following values:
	//
	// document order:
	// > There is an ordering, document order, defined on all the nodes in the
	// > document corresponding to the order in which the first character of the
	// > XML representation of each node occurs in the XML representation of the
	// > document after expansion of general entities. Thus, the document element
	// > node will be the first node. Element nodes occur before their children.
	// > Thus, document order orders element nodes in order of the occurrence of
	// > their start-tag in the XML (after expansion of entities). The attribute
	// > nodes of an element occur after the element and before its children. The
	// > relative order of attribute nodes is implementation-dependent./
	// Source:
	// http://www.w3.org/TR/DOM-Level-3-Core/glossary.html#dt-document-order
	//
	// @argument {Node} nodaA The first node to use in the comparison
	// @argument {Node} nodeB The second node to use in the comparison
	//
	// @return {Number} A bitmask describing the input nodes' relative position.
	//         See http://dom.spec.whatwg.org/#dom-node-comparedocumentposition for
	//         a description of these values.
	var comparePos = exports.compareDocumentPosition = function(nodeA, nodeB) {
		var aParents = [];
		var bParents = [];
		var current, sharedParent, siblings, aSibling, bSibling, idx;
	
		if (nodeA === nodeB) {
			return 0;
		}
	
		current = nodeA;
		while (current) {
			aParents.unshift(current);
			current = current.parent;
		}
		current = nodeB;
		while (current) {
			bParents.unshift(current);
			current = current.parent;
		}
	
		idx = 0;
		while (aParents[idx] === bParents[idx]) {
			idx++;
		}
	
		if (idx === 0) {
			return POSITION.DISCONNECTED;
		}
	
		sharedParent = aParents[idx - 1];
		siblings = sharedParent.children;
		aSibling = aParents[idx];
		bSibling = bParents[idx];
	
		if (siblings.indexOf(aSibling) > siblings.indexOf(bSibling)) {
			if (sharedParent === nodeB) {
				return POSITION.FOLLOWING | POSITION.CONTAINED_BY;
			}
			return POSITION.FOLLOWING;
		} else {
			if (sharedParent === nodeA) {
				return POSITION.PRECEDING | POSITION.CONTAINS;
			}
			return POSITION.PRECEDING;
		}
	};
	
	// Sort an array of nodes based on their relative position in the document and
	// remove any duplicate nodes. If the array contains nodes that do not belong
	// to the same document, sort order is unspecified.
	//
	// @argument {Array} nodes Array of DOM nodes
	//
	// @returns {Array} collection of unique nodes, sorted in document order
	exports.uniqueSort = function(nodes) {
		var idx = nodes.length, node, position;
	
		nodes = nodes.slice();
	
		while (--idx > -1) {
			node = nodes[idx];
			position = nodes.indexOf(node);
			if (position > -1 && position < idx) {
				nodes.splice(idx, 1);
			}
		}
		nodes.sort(function(a, b) {
			var relative = comparePos(a, b);
			if (relative & POSITION.PRECEDING) {
				return -1;
			} else if (relative & POSITION.FOLLOWING) {
				return 1;
			}
			return 0;
		});
	
		return nodes;
	};


/***/ },
/* 1712 */
/***/ function(module, exports, __webpack_require__) {

	var ElementType = __webpack_require__(217);
	var isTag = exports.isTag = ElementType.isTag;
	
	exports.testElement = function(options, element){
		for(var key in options){
			if(!options.hasOwnProperty(key));
			else if(key === "tag_name"){
				if(!isTag(element) || !options.tag_name(element.name)){
					return false;
				}
			} else if(key === "tag_type"){
				if(!options.tag_type(element.type)) return false;
			} else if(key === "tag_contains"){
				if(isTag(element) || !options.tag_contains(element.data)){
					return false;
				}
			} else if(!element.attribs || !options[key](element.attribs[key])){
				return false;
			}
		}
		return true;
	};
	
	var Checks = {
		tag_name: function(name){
			if(typeof name === "function"){
				return function(elem){ return isTag(elem) && name(elem.name); };
			} else if(name === "*"){
				return isTag;
			} else {
				return function(elem){ return isTag(elem) && elem.name === name; };
			}
		},
		tag_type: function(type){
			if(typeof type === "function"){
				return function(elem){ return type(elem.type); };
			} else {
				return function(elem){ return elem.type === type; };
			}
		},
		tag_contains: function(data){
			if(typeof data === "function"){
				return function(elem){ return !isTag(elem) && data(elem.data); };
			} else {
				return function(elem){ return !isTag(elem) && elem.data === data; };
			}
		}
	};
	
	function getAttribCheck(attrib, value){
		if(typeof value === "function"){
			return function(elem){ return elem.attribs && value(elem.attribs[attrib]); };
		} else {
			return function(elem){ return elem.attribs && elem.attribs[attrib] === value; };
		}
	}
	
	function combineFuncs(a, b){
		return function(elem){
			return a(elem) || b(elem);
		};
	}
	
	exports.getElements = function(options, element, recurse, limit){
		var funcs = Object.keys(options).map(function(key){
			var value = options[key];
			return key in Checks ? Checks[key](value) : getAttribCheck(key, value);
		});
	
		return funcs.length === 0 ? [] : this.filter(
			funcs.reduce(combineFuncs),
			element, recurse, limit
		);
	};
	
	exports.getElementById = function(id, element, recurse){
		if(!Array.isArray(element)) element = [element];
		return this.findOne(getAttribCheck("id", id), element, recurse !== false);
	};
	
	exports.getElementsByTagName = function(name, element, recurse, limit){
		return this.filter(Checks.tag_name(name), element, recurse, limit);
	};
	
	exports.getElementsByTagType = function(type, element, recurse, limit){
		return this.filter(Checks.tag_type(type), element, recurse, limit);
	};


/***/ },
/* 1713 */
/***/ function(module, exports) {

	exports.removeElement = function(elem){
		if(elem.prev) elem.prev.next = elem.next;
		if(elem.next) elem.next.prev = elem.prev;
	
		if(elem.parent){
			var childs = elem.parent.children;
			childs.splice(childs.lastIndexOf(elem), 1);
		}
	};
	
	exports.replaceElement = function(elem, replacement){
		var prev = replacement.prev = elem.prev;
		if(prev){
			prev.next = replacement;
		}
	
		var next = replacement.next = elem.next;
		if(next){
			next.prev = replacement;
		}
	
		var parent = replacement.parent = elem.parent;
		if(parent){
			var childs = parent.children;
			childs[childs.lastIndexOf(elem)] = replacement;
		}
	};
	
	exports.appendChild = function(elem, child){
		child.parent = elem;
	
		if(elem.children.push(child) !== 1){
			var sibling = elem.children[elem.children.length - 2];
			sibling.next = child;
			child.prev = sibling;
			child.next = null;
		}
	};
	
	exports.append = function(elem, next){
		var parent = elem.parent,
			currNext = elem.next;
	
		next.next = currNext;
		next.prev = elem;
		elem.next = next;
		next.parent = parent;
	
		if(currNext){
			currNext.prev = next;
			if(parent){
				var childs = parent.children;
				childs.splice(childs.lastIndexOf(currNext), 0, next);
			}
		} else if(parent){
			parent.children.push(next);
		}
	};
	
	exports.prepend = function(elem, prev){
		var parent = elem.parent;
		if(parent){
			var childs = parent.children;
			childs.splice(childs.lastIndexOf(elem), 0, prev);
		}
	
		if(elem.prev){
			elem.prev.next = prev;
		}
		
		prev.parent = parent;
		prev.prev = elem.prev;
		prev.next = elem;
		elem.prev = prev;
	};
	
	


/***/ },
/* 1714 */
/***/ function(module, exports, __webpack_require__) {

	var isTag = __webpack_require__(217).isTag;
	
	module.exports = {
		filter: filter,
		find: find,
		findOneChild: findOneChild,
		findOne: findOne,
		existsOne: existsOne,
		findAll: findAll
	};
	
	function filter(test, element, recurse, limit){
		if(!Array.isArray(element)) element = [element];
	
		if(typeof limit !== "number" || !isFinite(limit)){
			limit = Infinity;
		}
		return find(test, element, recurse !== false, limit);
	}
	
	function find(test, elems, recurse, limit){
		var result = [], childs;
	
		for(var i = 0, j = elems.length; i < j; i++){
			if(test(elems[i])){
				result.push(elems[i]);
				if(--limit <= 0) break;
			}
	
			childs = elems[i].children;
			if(recurse && childs && childs.length > 0){
				childs = find(test, childs, recurse, limit);
				result = result.concat(childs);
				limit -= childs.length;
				if(limit <= 0) break;
			}
		}
	
		return result;
	}
	
	function findOneChild(test, elems){
		for(var i = 0, l = elems.length; i < l; i++){
			if(test(elems[i])) return elems[i];
		}
	
		return null;
	}
	
	function findOne(test, elems){
		var elem = null;
	
		for(var i = 0, l = elems.length; i < l && !elem; i++){
			if(!isTag(elems[i])){
				continue;
			} else if(test(elems[i])){
				elem = elems[i];
			} else if(elems[i].children.length > 0){
				elem = findOne(test, elems[i].children);
			}
		}
	
		return elem;
	}
	
	function existsOne(test, elems){
		for(var i = 0, l = elems.length; i < l; i++){
			if(
				isTag(elems[i]) && (
					test(elems[i]) || (
						elems[i].children.length > 0 &&
						existsOne(test, elems[i].children)
					)
				)
			){
				return true;
			}
		}
	
		return false;
	}
	
	function findAll(test, rootElems){
		var result = [];
		var stack = rootElems.slice();
		while(stack.length){
			var elem = stack.shift();
			if(!isTag(elem)) continue;
			if (elem.children && elem.children.length > 0) {
				stack.unshift.apply(stack, elem.children);
			}
			if(test(elem)) result.push(elem);
		}
		return result;
	}


/***/ },
/* 1715 */
/***/ function(module, exports, __webpack_require__) {

	var ElementType = __webpack_require__(217),
	    getOuterHTML = __webpack_require__(1706),
	    isTag = ElementType.isTag;
	
	module.exports = {
		getInnerHTML: getInnerHTML,
		getOuterHTML: getOuterHTML,
		getText: getText
	};
	
	function getInnerHTML(elem, opts){
		return elem.children ? elem.children.map(function(elem){
			return getOuterHTML(elem, opts);
		}).join("") : "";
	}
	
	function getText(elem){
		if(Array.isArray(elem)) return elem.map(getText).join("");
		if(isTag(elem)) return elem.name === "br" ? "\n" : getText(elem.children);
		if(elem.type === ElementType.CDATA) return getText(elem.children);
		if(elem.type === ElementType.Text) return elem.data;
		return "";
	}


/***/ },
/* 1716 */
/***/ function(module, exports) {

	var getChildren = exports.getChildren = function(elem){
		return elem.children;
	};
	
	var getParent = exports.getParent = function(elem){
		return elem.parent;
	};
	
	exports.getSiblings = function(elem){
		var parent = getParent(elem);
		return parent ? getChildren(parent) : [elem];
	};
	
	exports.getAttributeValue = function(elem, name){
		return elem.attribs && elem.attribs[name];
	};
	
	exports.hasAttrib = function(elem, name){
		return !!elem.attribs && hasOwnProperty.call(elem.attribs, name);
	};
	
	exports.getName = function(elem){
		return elem.name;
	};


/***/ },
/* 1717 */
/***/ function(module, exports, __webpack_require__) {

	var decodeMap = __webpack_require__(2046);
	
	module.exports = decodeCodePoint;
	
	// modified version of https://github.com/mathiasbynens/he/blob/master/src/he.js#L94-L119
	function decodeCodePoint(codePoint) {
	    if ((codePoint >= 0xd800 && codePoint <= 0xdfff) || codePoint > 0x10ffff) {
	        return "\uFFFD";
	    }
	
	    if (codePoint in decodeMap) {
	        codePoint = decodeMap[codePoint];
	    }
	
	    var output = "";
	
	    if (codePoint > 0xffff) {
	        codePoint -= 0x10000;
	        output += String.fromCharCode(((codePoint >>> 10) & 0x3ff) | 0xd800);
	        codePoint = 0xdc00 | (codePoint & 0x3ff);
	    }
	
	    output += String.fromCharCode(codePoint);
	    return output;
	}


/***/ },
/* 1718 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./eval')} */
	module.exports = EvalError;


/***/ },
/* 1719 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('.')} */
	module.exports = Error;


/***/ },
/* 1720 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./range')} */
	module.exports = RangeError;


/***/ },
/* 1721 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./ref')} */
	module.exports = ReferenceError;


/***/ },
/* 1722 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./uri')} */
	module.exports = URIError;


/***/ },
/* 1723 */
/***/ function(module, exports) {

	/*!
	 * escape-html
	 * Copyright(c) 2012-2013 TJ Holowaychuk
	 * Copyright(c) 2015 Andreas Lubbe
	 * Copyright(c) 2015 Tiancheng "Timothy" Gu
	 * MIT Licensed
	 */
	
	'use strict';
	
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Module exports.
	 * @public
	 */
	
	module.exports = escapeHtml;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34: // "
	        escape = '&quot;';
	        break;
	      case 38: // &
	        escape = '&amp;';
	        break;
	      case 39: // '
	        escape = '&#39;';
	        break;
	      case 60: // <
	        escape = '&lt;';
	        break;
	      case 62: // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index
	    ? html + str.substring(lastIndex, index)
	    : html;
	}


/***/ },
/* 1724 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ },
/* 1725 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1726 */
1725,
/* 1727 */
1725,
/* 1728 */
1725,
/* 1729 */
1725,
/* 1730 */
1725,
/* 1731 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/file-preview-ph.475f8c8f.svg";

/***/ },
/* 1732 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/Icon_info.5989e345.svg";

/***/ },
/* 1733 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/Play.acf60c3d.svg";

/***/ },
/* 1734 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/agrandar_manualmente_ventana.2c0380a9.svg";

/***/ },
/* 1735 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/campana_entrada_blanco.b09b95c6.svg";

/***/ },
/* 1736 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/campana_salida_blanco.73199557.svg";

/***/ },
/* 1737 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/check_on.66cf4bc3.svg";

/***/ },
/* 1738 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/first_page.5d39b0a6.svg";

/***/ },
/* 1739 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/last_page.51833618.svg";

/***/ },
/* 1740 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/left-arrow.2e1be646.svg";

/***/ },
/* 1741 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/llamada_entrada.8073065a.svg";

/***/ },
/* 1742 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/llamada_salida.dcb8cd61.svg";

/***/ },
/* 1743 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/marca.dc08c91a.svg";

/***/ },
/* 1744 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/marca_admin.f9c4d1ef.svg";

/***/ },
/* 1745 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ordenar_columna.26db00b3.svg";

/***/ },
/* 1746 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/pista_anterior.f48b1f5f.svg";

/***/ },
/* 1747 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/right-arrow.7384017c.svg";

/***/ },
/* 1748 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/call_key_icon.0bdde35b.svg";

/***/ },
/* 1749 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/cambioLlamada.5466475c.svg";

/***/ },
/* 1750 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/gris_numero_celular.8cc3642f.svg";

/***/ },
/* 1751 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/gris_numero_de_casa.b13d46db.svg";

/***/ },
/* 1752 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/gris_numero_determinado.fd3e4fd5.svg";

/***/ },
/* 1753 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/gris_numero_oficina.1dc9bce7.svg";

/***/ },
/* 1754 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/gris_numero_principal.9fad2f45.svg";

/***/ },
/* 1755 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icono_campana_entrada.a917ece8.svg";

/***/ },
/* 1756 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icono_campana_salida.84a21446.svg";

/***/ },
/* 1757 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icono_campana_telefono.fb9516be.svg";

/***/ },
/* 1758 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/key.c4ae9258.svg";

/***/ },
/* 1759 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/numero_celular.58615425.svg";

/***/ },
/* 1760 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/numero_de_casa.ba13a395.svg";

/***/ },
/* 1761 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/numero_determinado.7dc1a475.svg";

/***/ },
/* 1762 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/numero_oficina.921aeba0.svg";

/***/ },
/* 1763 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/numero_principal.6619f283.svg";

/***/ },
/* 1764 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/digitos.915edcc0.svg";

/***/ },
/* 1765 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/send.fe4f1a84.svg";

/***/ },
/* 1766 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/AgentStateTransfer.93347940.svg";

/***/ },
/* 1767 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/EstadoAgenteDipsLLamMan.7afcbb7e.svg";

/***/ },
/* 1768 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/EstadoAgenteError.873f1fa1.svg";

/***/ },
/* 1769 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/EstadoAgenteNoDisp.5703cf4a.svg";

/***/ },
/* 1770 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/EstadoAgenteNotas.9c64f96b.svg";

/***/ },
/* 1771 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/EstadoAgenteTransfer.cf233047.svg";

/***/ },
/* 1772 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/overFooter.35eda311.svg";

/***/ },
/* 1773 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/poweredNuxiba.079c887e.svg";

/***/ },
/* 1774 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/Agente_in_info.2f5d48a3.svg";

/***/ },
/* 1775 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/Agente_out_in_info.201bb411.svg";

/***/ },
/* 1776 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/Agente_out_info.8aefe6a5.svg";

/***/ },
/* 1777 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/agente_icon.b26d849d.svg";

/***/ },
/* 1778 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/agente_inbound_icon.b6967283.svg";

/***/ },
/* 1779 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/agente_outbound_icon.a19ca630.svg";

/***/ },
/* 1780 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/agente_outbound_inbound_icon.ea562506.svg";

/***/ },
/* 1781 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/arrow.77bf6783.svg";

/***/ },
/* 1782 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/arrow_HistorialND.490415df.svg";

/***/ },
/* 1783 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/cambio_exitoso.942a9c16.svg";

/***/ },
/* 1784 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/cerrar_sesion.5d5f226e.svg";

/***/ },
/* 1785 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/config_icon.fc301699.svg";

/***/ },
/* 1786 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/contrasena_oculta.e682f9a9.svg";

/***/ },
/* 1787 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/contrasena_visible.29dd71cc.svg";

/***/ },
/* 1788 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/facebook.d189caeb.svg";

/***/ },
/* 1789 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/kolob.cef07239.svg";

/***/ },
/* 1790 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/kolob_texto.3e4f4c0e.svg";

/***/ },
/* 1791 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/linkedin.1a81bfff.svg";

/***/ },
/* 1792 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/llamadas.b8755f69.svg";

/***/ },
/* 1793 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/mac_adress.3c4804f5.svg";

/***/ },
/* 1794 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/mail.463b80a6.svg";

/***/ },
/* 1795 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/mensajes.979e4c3c.svg";

/***/ },
/* 1796 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/mensajes_en_cola_icon.d0509ba7.svg";

/***/ },
/* 1797 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/palomita_solita.3a6f6818.svg";

/***/ },
/* 1798 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/password_icon.972424e8.svg";

/***/ },
/* 1799 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/relojHeader.cff1dccb.svg";

/***/ },
/* 1800 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/twitter.5985dccb.svg";

/***/ },
/* 1801 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/conectado_icon.fb52bf4a.svg";

/***/ },
/* 1802 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/conectando_icon.783a9f3c.svg";

/***/ },
/* 1803 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/desconectado.985395bc.svg";

/***/ },
/* 1804 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/not_found_icon.3bbcac7d.svg";

/***/ },
/* 1805 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/info_ad.9fb55e37.svg";

/***/ },
/* 1806 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/anadir_marca.9a081b71.svg";

/***/ },
/* 1807 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/marca.91f10e00.svg";

/***/ },
/* 1808 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/reloj.2f01017b.svg";

/***/ },
/* 1809 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/tache.6c824138.svg";

/***/ },
/* 1810 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/AlertIcon.011449bf.svg";

/***/ },
/* 1811 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ArchivoAdjuntoIcon.bcea36d3.svg";

/***/ },
/* 1812 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/barraDesplegar.8d27b590.svg";

/***/ },
/* 1813 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/chatIcon.f879ca19.svg";

/***/ },
/* 1814 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/mailSmallIcon.eb62e780.svg";

/***/ },
/* 1815 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/twitterSmallIcon.6a9e7428.svg";

/***/ },
/* 1816 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/userIconMessageBig.cdc4ea42.svg";

/***/ },
/* 1817 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/HistorialNoDisponibleHeader.4f6b5f41.svg";

/***/ },
/* 1818 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/Manzana.006210f9.svg";

/***/ },
/* 1819 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/NoDisponibleHeader.21c684f2.svg";

/***/ },
/* 1820 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/NoDisponibleSinDefinir.cda61c9b.svg";

/***/ },
/* 1821 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/Otro.35246d1e.svg";

/***/ },
/* 1822 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/Sanitarios.415a053e.svg";

/***/ },
/* 1823 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/TipoDeNoDisponibleSeleccionado.b108d06e.svg";

/***/ },
/* 1824 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/alerta.9fffdcfd.svg";

/***/ },
/* 1825 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/buscar.2584704d.svg";

/***/ },
/* 1826 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/hold.dec14a51.svg";

/***/ },
/* 1827 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-warning.e3ef32a7.svg";

/***/ },
/* 1828 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/fecha.88c61c63.svg";

/***/ },
/* 1829 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/hora.11984bce.svg";

/***/ },
/* 1830 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/Enviar.d9f26174.svg";

/***/ },
/* 1831 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/Flecha.31dfdb66.svg";

/***/ },
/* 1832 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/Grupodetrabajo.7bd6deba.svg";

/***/ },
/* 1833 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/agente_chat.61566fd1.svg";

/***/ },
/* 1834 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/chat_supervisor.f90e0b29.svg";

/***/ },
/* 1835 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/chatconsupervisorseleccionado.c8f0f598.svg";

/***/ },
/* 1836 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/grupodetrabajoseleccionado.86e76cbf.svg";

/***/ },
/* 1837 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/regresar.066e9bb2.svg";

/***/ },
/* 1838 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/regresar_seleccionado.352a3ddd.svg";

/***/ },
/* 1839 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/supervisorchat.bf5c206c.svg";

/***/ },
/* 1840 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/Abandonar_conferencia.6bfb5571.svg";

/***/ },
/* 1841 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/agenda.f0b6220e.svg";

/***/ },
/* 1842 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/conferencia_icon.f9b9cf14.svg";

/***/ },
/* 1843 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/persona_transferencia_asistida.37bf5089.svg";

/***/ },
/* 1844 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/trasferir_llamada.20117cae.svg";

/***/ },
/* 1845 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/Linkedin.becd3ceb.svg";

/***/ },
/* 1846 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/all.3f447109.svg";

/***/ },
/* 1847 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/chat.7ad054ab.svg";

/***/ },
/* 1848 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/facebook.58b47089.svg";

/***/ },
/* 1849 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/mail.ae658411.svg";

/***/ },
/* 1850 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/twitter.02d41092.svg";

/***/ },
/* 1851 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/telefonia_no_valida.bb9b72b3.svg";

/***/ },
/* 1852 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/telefonia_valida.4d5adbc8.svg";

/***/ },
/* 1853 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/Volumen_alto.1a659570.svg";

/***/ },
/* 1854 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/Volumen_medio.8e704da7.svg";

/***/ },
/* 1855 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/microfono.6a06397f.svg";

/***/ },
/* 1856 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/mute_microfono.76f6fb00.svg";

/***/ },
/* 1857 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/sin_volumen.3f8c6c38.svg";

/***/ },
/* 1858 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/Chat_agente.508697d4.svg";

/***/ },
/* 1859 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/Historial_de_llamadas.d04f8790.svg";

/***/ },
/* 1860 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/Historial_no_disponibles.94993525.svg";

/***/ },
/* 1861 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/No_disponible.e5028c5c.svg";

/***/ },
/* 1862 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-agent-log.4dfdfd59.svg";

/***/ },
/* 1863 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-call-history.2f5ff5d8.svg";

/***/ },
/* 1864 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-chat.407f1506.svg";

/***/ },
/* 1865 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-history-not-available.60cb7e6a.svg";

/***/ },
/* 1866 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-manual-dial.d5b2a963.svg";

/***/ },
/* 1867 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-not-available.1b32d556.svg";

/***/ },
/* 1868 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-unified-media.d5c51cfa.svg";

/***/ },
/* 1869 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-whatsapp.4f536b7b.svg";

/***/ },
/* 1870 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/marcacion_manual.5164d534.svg";

/***/ },
/* 1871 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/mensajeria_unificada_icon.d38a8ced.svg";

/***/ },
/* 1872 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/cerraGray.4bd6a55a.svg";

/***/ },
/* 1873 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/cerrar.24f0cb6d.svg";

/***/ },
/* 1874 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/cerrarBlack.476c018c.svg";

/***/ },
/* 1875 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/send-message.6b6b1c5e.svg";

/***/ },
/* 1876 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/whatsapp-icono.c8d28410.svg";

/***/ },
/* 1877 */
/***/ function(module, exports) {

	'use strict';
	
	/* eslint no-invalid-this: 1 */
	
	var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
	var toStr = Object.prototype.toString;
	var max = Math.max;
	var funcType = '[object Function]';
	
	var concatty = function concatty(a, b) {
	    var arr = [];
	
	    for (var i = 0; i < a.length; i += 1) {
	        arr[i] = a[i];
	    }
	    for (var j = 0; j < b.length; j += 1) {
	        arr[j + a.length] = b[j];
	    }
	
	    return arr;
	};
	
	var slicy = function slicy(arrLike, offset) {
	    var arr = [];
	    for (var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1) {
	        arr[j] = arrLike[i];
	    }
	    return arr;
	};
	
	var joiny = function (arr, joiner) {
	    var str = '';
	    for (var i = 0; i < arr.length; i += 1) {
	        str += arr[i];
	        if (i + 1 < arr.length) {
	            str += joiner;
	        }
	    }
	    return str;
	};
	
	module.exports = function bind(that) {
	    var target = this;
	    if (typeof target !== 'function' || toStr.apply(target) !== funcType) {
	        throw new TypeError(ERROR_MESSAGE + target);
	    }
	    var args = slicy(arguments, 1);
	
	    var bound;
	    var binder = function () {
	        if (this instanceof bound) {
	            var result = target.apply(
	                this,
	                concatty(args, arguments)
	            );
	            if (Object(result) === result) {
	                return result;
	            }
	            return this;
	        }
	        return target.apply(
	            that,
	            concatty(args, arguments)
	        );
	
	    };
	
	    var boundLength = max(0, target.length - args.length);
	    var boundArgs = [];
	    for (var i = 0; i < boundLength; i++) {
	        boundArgs[i] = '$' + i;
	    }
	
	    bound = Function('binder', 'return function (' + joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
	
	    if (target.prototype) {
	        var Empty = function Empty() {};
	        Empty.prototype = target.prototype;
	        bound.prototype = new Empty();
	        Empty.prototype = null;
	    }
	
	    return bound;
	};


/***/ },
/* 1878 */
/***/ function(module, exports) {

	'use strict';
	
	var functionsHaveNames = function functionsHaveNames() {
		return typeof function f() {}.name === 'string';
	};
	
	var gOPD = Object.getOwnPropertyDescriptor;
	if (gOPD) {
		try {
			gOPD([], 'length');
		} catch (e) {
			// IE 8 has a broken gOPD
			gOPD = null;
		}
	}
	
	functionsHaveNames.functionsHaveConfigurableNames = function functionsHaveConfigurableNames() {
		if (!functionsHaveNames() || !gOPD) {
			return false;
		}
		var desc = gOPD(function () {}, 'name');
		return !!desc && !!desc.configurable;
	};
	
	var $bind = Function.prototype.bind;
	
	functionsHaveNames.boundFunctionsHaveNames = function boundFunctionsHaveNames() {
		return functionsHaveNames() && typeof $bind === 'function' && function f() {}.bind().name !== '';
	};
	
	module.exports = functionsHaveNames;


/***/ },
/* 1879 */
/***/ function(module, exports, __webpack_require__) {

	// [NUXIBA]  Version: 2021.1.1 - 2022-08-29 11:23:20  
	 !function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.EntryPoint=t():e.EntryPoint=t()}("undefined"!=typeof self?self:this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var i=n[r]={i:r,l:!1,exports:{}};return e[r].call(i.exports,i,i.exports,t),i.l=!0,i.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=1)}([function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0}),t.Logger=void 0;var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),a=n(3);t.Logger=function(){function e(){r(this,e)}return i(e,null,[{key:"Trace",value:function(){for(var e=arguments.length,t=Array(e),n=0;n<e;n++)t[n]=arguments[n];a.LoggerInstance.Trace.apply(a.LoggerInstance,["[Audio-Player] "].concat(t))}},{key:"Debug",value:function(){for(var e=arguments.length,t=Array(e),n=0;n<e;n++)t[n]=arguments[n];a.LoggerInstance.Debug.apply(a.LoggerInstance,["[Audio-Player] "].concat(t))}},{key:"Warning",value:function(){for(var e=arguments.length,t=Array(e),n=0;n<e;n++)t[n]=arguments[n];a.LoggerInstance.Warning.apply(a.LoggerInstance,["[Audio-Player] "].concat(t))}},{key:"Info",value:function(){for(var e=arguments.length,t=Array(e),n=0;n<e;n++)t[n]=arguments[n];a.LoggerInstance.Info.apply(a.LoggerInstance,["[Audio-Player] "].concat(t))}},{key:"Error",value:function(){for(var e=arguments.length,t=Array(e),n=0;n<e;n++)t[n]=arguments[n];a.LoggerInstance.Error.apply(a.LoggerInstance,["[Audio-Player] "].concat(t))}}]),e}()},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0}),t.PlayerFactory=void 0;var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),a=n(2),o=n(4);t.PlayerFactory=function(){function e(){r(this,e)}return i(e,[{key:"buildClient",value:function(e){var t=new o.WaveSurferWrapper;return new a.StrategyPlayer(t.getWaveSurferPlayer(e))}}]),e}()},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0}),t.StrategyPlayer=void 0;var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),a=n(0);t.StrategyPlayer=function(){function e(t){r(this,e),a.Logger.Debug("StrategyPlayer init constructor ... "),this.PLAYER=t}return i(e,[{key:"setStrategy",value:function(e){this.PLAYER=e,a.Logger.Debug(this.PLAYER)}},{key:"setRecordingPath",value:function(e){this.PLAYER.setRecordingPath(e)}},{key:"playPauseRecording",value:function(){this.PLAYER.playPauseRecording()}},{key:"playRecording",value:function(e){this.PLAYER.playRecording(e)}},{key:"stopRecording",value:function(){this.PLAYER.stopRecording()}},{key:"forwardRecording",value:function(){this.PLAYER.forwardRecording()}},{key:"backwardRecording",value:function(){this.PLAYER.backwardRecording()}},{key:"speed",value:function(e){this.PLAYER.speed(e)}},{key:"setVolume",value:function(e){this.PLAYER.setVolume(e)}},{key:"muteRecording",value:function(){this.PLAYER.muteRecording()}},{key:"loadRecording",value:function(e){var t=this;return new Promise(function(n){t.PLAYER.loadRecording(e).then(function(e){n(e)}).catch(function(e){a.Logger.Error(e)})})}}]),e}()},function(e,t,n){!function(t,n){e.exports=n()}("undefined"!=typeof self&&self,function(){return function(e){function t(r){if(n[r])return n[r].exports;var i=n[r]={i:r,l:!1,exports:{}};return e[r].call(i.exports,i,i.exports,t),i.l=!0,i.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=3)}([function(e,t,n){"use strict";function r(e){return"[object Array]"===_.call(e)}function i(e){return"[object ArrayBuffer]"===_.call(e)}function a(e){return"undefined"!=typeof FormData&&e instanceof FormData}function o(e){return"undefined"!=typeof ArrayBuffer&&ArrayBuffer.isView?ArrayBuffer.isView(e):e&&e.buffer&&e.buffer instanceof ArrayBuffer}function s(e){return"string"==typeof e}function u(e){return"number"==typeof e}function c(e){return void 0===e}function l(e){return null!==e&&"object"==typeof e}function f(e){return"[object Date]"===_.call(e)}function h(e){return"[object File]"===_.call(e)}function d(e){return"[object Blob]"===_.call(e)}function p(e){return"[object Function]"===_.call(e)}function v(e){return l(e)&&p(e.pipe)}function y(e){return"undefined"!=typeof URLSearchParams&&e instanceof URLSearchParams}function g(e){return e.replace(/^\s*/,"").replace(/\s*$/,"")}function m(){return("undefined"==typeof navigator||"ReactNative"!==navigator.product)&&("undefined"!=typeof window&&"undefined"!=typeof document)}function w(e,t){if(null!==e&&void 0!==e)if("object"!=typeof e&&(e=[e]),r(e))for(var n=0,i=e.length;n<i;n++)t.call(null,e[n],n,e);else for(var a in e)Object.prototype.hasOwnProperty.call(e,a)&&t.call(null,e[a],a,e)}function b(){function e(e,n){"object"==typeof t[n]&&"object"==typeof e?t[n]=b(t[n],e):t[n]=e}for(var t={},n=0,r=arguments.length;n<r;n++)w(arguments[n],e);return t}function k(e,t,n){return w(t,function(t,r){e[r]=n&&"function"==typeof t?E(t,n):t}),e}var E=n(5),P=n(15),_=Object.prototype.toString;e.exports={isArray:r,isArrayBuffer:i,isBuffer:P,isFormData:a,isArrayBufferView:o,isString:s,isNumber:u,isObject:l,isUndefined:c,isDate:f,isFile:h,isBlob:d,isFunction:p,isStream:v,isURLSearchParams:y,isStandardBrowserEnv:m,forEach:w,merge:b,extend:k,trim:g}},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var i=null,a=t.Constants=function e(){r(this,e),i||(i=this)};a._LOGGER_VAR_WINDOW="NuxibaLogger",a._LOGGER_CONFIGURATION_FILE_LOCALE="./logger.json",a._LOGGER_CONFIGURATION_FILE_REMOTE="logger.json",a._LOGGER_CONFIGURATION_FILE_ENCODE="utf8",a._LOGGER_CONFIGURATION_ASSIGNED=!!window[a._LOGGER_VAR_WINDOW],a._LOG_LEVELS={TRACE:{logLevel:0},DEBUG:{logLevel:1},INFO:{logLevel:2},WARN:{logLevel:3},ERROR:{logLevel:4}},a._Log_CONSOLE={TRACE:console.log,DEBUG:console.log,INFO:console.info,WARN:console.warn,ERROR:console.error},a._CONFIGURATIONS={_ENABLE_DEFAULT:!0,_ENABLE_AJAX:!1,_USE_WINDOW_ORIGIN:!0,_SERVER:"http://127.0.0.1",_DOMAIN:"/LoggerWS/api/Logger",_SEVERITY:"INFO",_SEVERITY_CONSOLE:"INFO",_NUMBER_ATTEMP_POST:10,_FILTER_USER_POST:[],_FILTER_APP_POST:[]},a._REST={_POST_METHOD:"POST",_MODE:"cors",_CONTENT_TYPE:"content-type",_APPLICATION_JSON:"application/json"}},function(e,t,n){"use strict";(function(t){function r(e,t){!i.isUndefined(e)&&i.isUndefined(e["Content-Type"])&&(e["Content-Type"]=t)}var i=n(0),a=n(18),o={"Content-Type":"application/x-www-form-urlencoded"},s={adapter:function(){var e;return"undefined"!=typeof XMLHttpRequest?e=n(6):void 0!==t&&(e=n(6)),e}(),transformRequest:[function(e,t){return a(t,"Content-Type"),i.isFormData(e)||i.isArrayBuffer(e)||i.isBuffer(e)||i.isStream(e)||i.isFile(e)||i.isBlob(e)?e:i.isArrayBufferView(e)?e.buffer:i.isURLSearchParams(e)?(r(t,"application/x-www-form-urlencoded;charset=utf-8"),e.toString()):i.isObject(e)?(r(t,"application/json;charset=utf-8"),JSON.stringify(e)):e}],transformResponse:[function(e){if("string"==typeof e)try{e=JSON.parse(e)}catch(e){}return e}],timeout:0,xsrfCookieName:"XSRF-TOKEN",xsrfHeaderName:"X-XSRF-TOKEN",maxContentLength:-1,validateStatus:function(e){return e>=200&&e<300}};s.headers={common:{Accept:"application/json, text/plain, */*"}},i.forEach(["delete","get","head"],function(e){s.headers[e]={}}),i.forEach(["post","put","patch"],function(e){s.headers[e]=i.merge(o)}),e.exports=s}).call(t,n(17))},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0}),t.LoggerInstance=void 0;var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),a=n(12),o=n(1),s=n(11),u="AGENT",c="",l="",f=function(){function e(){r(this,e)}return i(e,null,[{key:"setUsertype",value:function(e){u=e}},{key:"setUserId",value:function(e){c=e}},{key:"getUserId",value:function(){return c}},{key:"setApplication",value:function(e){l=e}},{key:"setLocalLogger",value:function(e){s.LoggerLocal.setEnabled(e)}},{key:"setLocalStorageTime",value:function(e){s.LoggerLocal.setStorageTimeMin(e)}},{key:"getApplication",value:function(){return l}},{key:"SetUseServerWithLocation",value:function(e){window[o.Constants._LOGGER_VAR_WINDOW]._USE_WINDOW_LOCATION=e}},{key:"addUserId",value:function(e){if(c){var t="[UserId:"+c+"]";e.unshift(t)}}},{key:"Group",value:function(e){console.group(e)}},{key:"GroupEnd",value:function(){console.groupEnd()}},{key:"CleanLocalLog",value:function(){s.LoggerLocal.Clean()}},{key:"Trace",value:function(){for(var e=arguments.length,t=Array(e),n=0;n<e;n++)t[n]=arguments[n];a.LoggerDispatcher.Dispatch(u,"Trace",["[UserId:"+c+"]"].concat(t))}},{key:"Debug",value:function(){for(var t=arguments.length,n=Array(t),r=0;r<t;r++)n[r]=arguments[r];e.addUserId(n),a.LoggerDispatcher.Dispatch(u,"Debug",["[UserId:"+c+"]"].concat(n))}},{key:"Warning",value:function(){for(var t=arguments.length,n=Array(t),r=0;r<t;r++)n[r]=arguments[r];e.addUserId(n),a.LoggerDispatcher.Dispatch(u,"Warn",["[UserId:"+c+"]"].concat(n))}},{key:"Warn",value:function(){for(var t=arguments.length,n=Array(t),r=0;r<t;r++)n[r]=arguments[r];e.Warning(n)}},{key:"Info",value:function(){for(var t=arguments.length,n=Array(t),r=0;r<t;r++)n[r]=arguments[r];e.addUserId(n),a.LoggerDispatcher.Dispatch(u,"Info",["[UserId:"+c+"]"].concat(n))}},{key:"Error",value:function(){for(var t=arguments.length,n=Array(t),r=0;r<t;r++)n[r]=arguments[r];e.addUserId(n),a.LoggerDispatcher.Dispatch(u,"Error",["[UserId:"+c+"]"].concat(n))}},{key:"JsWarning",value:function(){for(var t=arguments.length,n=Array(t),r=0;r<t;r++)n[r]=arguments[r];e.addUserId(n),a.LoggerDispatcher.Dispatch(u,"Warn",["[UserId:"+c+"]"].concat(n),!0)}},{key:"JsError",value:function(){for(var t=arguments.length,n=Array(t),r=0;r<t;r++)n[r]=arguments[r];e.addUserId(n),a.LoggerDispatcher.Dispatch(u,"Error",["[UserId:"+c+"]"].concat(n),!0)}},{key:"LevelConsole",get:function(){return window[o.Constants._LOGGER_VAR_WINDOW]._SEVERITY_CONSOLE}}]),e}();t.LoggerInstance=f},function(e,t,n){e.exports=n(14)},function(e,t,n){"use strict";e.exports=function(e,t){return function(){for(var n=new Array(arguments.length),r=0;r<n.length;r++)n[r]=arguments[r];return e.apply(t,n)}}},function(e,t,n){"use strict";var r=n(0),i=n(19),a=n(21),o=n(22),s=n(23),u=n(7);e.exports=function(e){return new Promise(function(t,c){var l=e.data,f=e.headers;r.isFormData(l)&&delete f["Content-Type"];var h=new XMLHttpRequest;if(e.auth){var d=e.auth.username||"",p=e.auth.password||"";f.Authorization="Basic "+btoa(d+":"+p)}if(h.open(e.method.toUpperCase(),a(e.url,e.params,e.paramsSerializer),!0),h.timeout=e.timeout,h.onreadystatechange=function(){if(h&&4===h.readyState&&(0!==h.status||h.responseURL&&0===h.responseURL.indexOf("file:"))){var n="getAllResponseHeaders"in h?o(h.getAllResponseHeaders()):null,r=e.responseType&&"text"!==e.responseType?h.response:h.responseText,a={data:r,status:h.status,statusText:h.statusText,headers:n,config:e,request:h};i(t,c,a),h=null}},h.onerror=function(){c(u("Network Error",e,null,h)),h=null},h.ontimeout=function(){c(u("timeout of "+e.timeout+"ms exceeded",e,"ECONNABORTED",h)),h=null},r.isStandardBrowserEnv()){var v=n(24),y=(e.withCredentials||s(e.url))&&e.xsrfCookieName?v.read(e.xsrfCookieName):void 0;y&&(f[e.xsrfHeaderName]=y)}if("setRequestHeader"in h&&r.forEach(f,function(e,t){void 0===l&&"content-type"===t.toLowerCase()?delete f[t]:h.setRequestHeader(t,e)}),e.withCredentials&&(h.withCredentials=!0),e.responseType)try{h.responseType=e.responseType}catch(t){if("json"!==e.responseType)throw t}"function"==typeof e.onDownloadProgress&&h.addEventListener("progress",e.onDownloadProgress),"function"==typeof e.onUploadProgress&&h.upload&&h.upload.addEventListener("progress",e.onUploadProgress),e.cancelToken&&e.cancelToken.promise.then(function(e){h&&(h.abort(),c(e),h=null)}),void 0===l&&(l=null),h.send(l)})}},function(e,t,n){"use strict";var r=n(20);e.exports=function(e,t,n,i,a){var o=new Error(e);return r(o,t,n,i,a)}},function(e,t,n){"use strict";e.exports=function(e){return!(!e||!e.__CANCEL__)}},function(e,t,n){"use strict";function r(e){this.message=e}r.prototype.toString=function(){return"Cancel"+(this.message?": "+this.message:"")},r.prototype.__CANCEL__=!0,e.exports=r},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0}),t.LoggerUtils=void 0;var i="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},a=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),o=n(1),s=function(){function e(){r(this,e)}return a(e,null,[{key:"GetLogLevelBySeverity",value:function(e){var t=1;return e=e.toUpperCase(),o.Constants._LOG_LEVELS[e]&&(t=o.Constants._LOG_LEVELS[e].logLevel),t}},{key:"IsAllowedRemoteToLogBySeverity",value:function(t){return e.GetLogLevelBySeverity(t)>=e.GetCurrentRemoteSeverityLevelConfigured()}},{key:"GetCurrentRemoteSeverityLevelConfigured",value:function(){return e.GetLogLevelBySeverity(window[o.Constants._LOGGER_VAR_WINDOW]._SEVERITY)}},{key:"IsAllowedConsoleToLogBySeverity",value:function(t){return e.GetLogLevelBySeverity(t)>=e.GetCurrentConsoleSeverityLevelConfigured()}},{key:"GetCurrentConsoleSeverityLevelConfigured",value:function(){return e.GetLogLevelBySeverity(window[o.Constants._LOGGER_VAR_WINDOW]._SEVERITY_CONSOLE)}},{key:"ToStringMessage",value:function(){for(var t="",n=arguments.length,r=Array(n),i=0;i<n;i++)r[i]=arguments[i];return r.forEach(function(n){t+=e.ToStringObject(n)}),t}},{key:"ToStringObject",value:function(t){return e.IsObject(t)?"\n"+e.JsonToString(t):t}},{key:"IsObject",value:function(e){return e&&"object"===(void 0===e?"undefined":i(e))&&e.constructor===Object}},{key:"JsonToString",value:function(e){var t=[];return JSON.stringify(e,function(e,n){return n&&"object"==(void 0===n?"undefined":i(n))&&t.push(n),n},2)}}]),e}();t.LoggerUtils=s},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),a=window.localStorage,o="LOG-"+(new Date).getDate()+"-"+((new Date).getMonth()+1)+"-"+(new Date).getFullYear(),s=!1,u=0,c=null,l=function(){function e(){r(this,e)}return i(e,null,[{key:"getKey",value:function(){return o}},{key:"setEnabled",value:function(e){s=e}},{key:"setStorageTimeMin",value:function(e){u=e}},{key:"Add",value:function(t,n,r){if(s){var i=new Date,l=a.getItem(o),f=n+"-"+r+" "+i.getDate()+"-"+(i.getMonth()+1)+"-"+i.getFullYear()+"-"+i.getDate()+" "+i.toLocaleTimeString()+" - MSG: "+t;l?(c||(c=new Date(JSON.parse(a.getItem("GalateaLoggerDate")))),0!==u&&(i-c)/6e4>u?(e.Clean(),c=i,a.setItem("GalateaLoggerDate",JSON.stringify(i))):f=l+";"+f,a.setItem(o,""+f)):(c=i,a.setItem(o,f),a.setItem("GalateaLoggerDate",JSON.stringify(i)))}}},{key:"getRawLogs",value:function(){return a.getItem(o)}},{key:"getLogs",value:function(){return a.getItem(o).replaceAll(";","\n")}},{key:"Clean",value:function(){console.log("Cleaning local storage ",o),a.removeItem(o)}}]),e}();t.LoggerLocal=l},function(e,t,n){"use strict";function r(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0}),t.LoggerDispatcher=void 0;var a=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),o=n(13),s=n(1),u=n(10),c=n(32),l=n(3),f=n(11),h=(window.localStorage,function(){function e(){i(this,e)}return a(e,null,[{key:"Dispatch",value:function(t,n,i,a){f.LoggerLocal.Add(i,t,n),c.LoggerConfigurator.Init(function(){!a&&e.DefaultOutput.apply(e,[t,n].concat(r(i))),e.RemoteOutput.apply(e,[t,n].concat(r(i)))})}},{key:"RemoteOutput",value:function(e,t){if(window[s.Constants._LOGGER_VAR_WINDOW]&&window[s.Constants._LOGGER_VAR_WINDOW]._ENABLE_AJAX&&u.LoggerUtils.IsAllowedRemoteToLogBySeverity(t)){for(var n=arguments.length,r=Array(n>2?n-2:0),i=2;i<n;i++)r[i-2]=arguments[i];if("WARN"===t.toUpperCase()||"ERROR"===t.toUpperCase())o.LoggerRestClient.log(e,t,"["+e+"] "+r);else{var a=0===window[s.Constants._LOGGER_VAR_WINDOW]._FILTER_USER_POST.length,c=0===window[s.Constants._LOGGER_VAR_WINDOW]._FILTER_APP_POST.length;if(a&&c)o.LoggerRestClient.log.apply(o.LoggerRestClient,[e,t].concat(r));else{var f=!0,h=!0;a||(f=window[s.Constants._LOGGER_VAR_WINDOW]._FILTER_USER_POST.find(function(e){return e===l.LoggerInstance.getUserId()})),c||(h=window[s.Constants._LOGGER_VAR_WINDOW]._FILTER_APP_POST.find(function(e){return e===l.LoggerInstance.getApplication()})),f&&h&&o.LoggerRestClient.log(e,t,"["+e+"] "+r)}}}}},{key:"DefaultOutput",value:function(e,t){if(t=t.toUpperCase(),window[s.Constants._LOGGER_VAR_WINDOW]&&window[s.Constants._LOGGER_VAR_WINDOW]._ENABLE_DEFAULT&&u.LoggerUtils.IsAllowedConsoleToLogBySeverity(t)){var n,r=console.log;s.Constants._Log_CONSOLE[t]&&(r=s.Constants._Log_CONSOLE[t]);for(var i=(new Date).toLocaleTimeString(),a=arguments.length,o=Array(a>2?a-2:0),c=2;c<a;c++)o[c-2]=arguments[c];(n=r).call.apply(n,[null,"["+i+"]["+t+"]["+e+"]"].concat(o))}}}]),e}());t.LoggerDispatcher=h},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0}),t.LoggerRestClient=void 0;var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),a=n(4),o=function(e){return e&&e.__esModule?e:{default:e}}(a),s=n(1),u=n(10),c=0,l=!0,f=function(){function e(){r(this,e)}return i(e,null,[{key:"log",value:function(e,t){if(window[s.Constants._LOGGER_VAR_WINDOW]._ENABLE_AJAX)if(0===window[s.Constants._LOGGER_VAR_WINDOW]._NUMBER_ATTEMP_POST||c<window[s.Constants._LOGGER_VAR_WINDOW]._NUMBER_ATTEMP_POST)try{for(var n=new URL(window[s.Constants._LOGGER_VAR_WINDOW]._SERVER),r=new URL(window[s.Constants._LOGGER_VAR_WINDOW]._DOMAIN,n),i=arguments.length,a=Array(i>2?i-2:0),f=2;f<i;f++)a[f-2]=arguments[f];var h=u.LoggerUtils.ToStringMessage(a);o.default.post(r,{UserType:e,Message:h,Severity:t}).then(function(){c=0}).catch(function(e){c++,console.warn("It was not possible to send the message server:",r,e)})}catch(e){c++,console.error("it was not possible to send the log message because an error ocurred servidor:"+window[s.Constants._LOGGER_VAR_WINDOW]._SERVER+" error:"+e+" recommendation: you could check the logger configuration")}else l&&(l=!1,console.warn("number of attempts to overcome Api web is necessary to check the configuration file for logger.json"))}}]),e}();t.LoggerRestClient=f},function(e,t,n){"use strict";function r(e){var t=new o(e),n=a(o.prototype.request,t);return i.extend(n,o.prototype,t),i.extend(n,t),n}var i=n(0),a=n(5),o=n(16),s=n(2),u=r(s);u.Axios=o,u.create=function(e){return r(i.merge(s,e))},u.Cancel=n(9),u.CancelToken=n(30),u.isCancel=n(8),u.all=function(e){return Promise.all(e)},u.spread=n(31),e.exports=u,e.exports.default=u},function(e,t){/*!
	 * Determine if an object is a Buffer
	 *
	 * @author   Feross Aboukhadijeh <https://feross.org>
	 * @license  MIT
	 */
	e.exports=function(e){return null!=e&&null!=e.constructor&&"function"==typeof e.constructor.isBuffer&&e.constructor.isBuffer(e)}},function(e,t,n){"use strict";function r(e){this.defaults=e,this.interceptors={request:new o,response:new o}}var i=n(2),a=n(0),o=n(25),s=n(26);r.prototype.request=function(e){"string"==typeof e&&(e=a.merge({url:arguments[0]},arguments[1])),e=a.merge(i,{method:"get"},this.defaults,e),e.method=e.method.toLowerCase();var t=[s,void 0],n=Promise.resolve(e);for(this.interceptors.request.forEach(function(e){t.unshift(e.fulfilled,e.rejected)}),this.interceptors.response.forEach(function(e){t.push(e.fulfilled,e.rejected)});t.length;)n=n.then(t.shift(),t.shift());return n},a.forEach(["delete","get","head","options"],function(e){r.prototype[e]=function(t,n){return this.request(a.merge(n||{},{method:e,url:t}))}}),a.forEach(["post","put","patch"],function(e){r.prototype[e]=function(t,n,r){return this.request(a.merge(r||{},{method:e,url:t,data:n}))}}),e.exports=r},function(e,t){function n(){throw new Error("setTimeout has not been defined")}function r(){throw new Error("clearTimeout has not been defined")}function i(e){if(l===setTimeout)return setTimeout(e,0);if((l===n||!l)&&setTimeout)return l=setTimeout,setTimeout(e,0);try{return l(e,0)}catch(t){try{return l.call(null,e,0)}catch(t){return l.call(this,e,0)}}}function a(e){if(f===clearTimeout)return clearTimeout(e);if((f===r||!f)&&clearTimeout)return f=clearTimeout,clearTimeout(e);try{return f(e)}catch(t){try{return f.call(null,e)}catch(t){return f.call(this,e)}}}function o(){v&&d&&(v=!1,d.length?p=d.concat(p):y=-1,p.length&&s())}function s(){if(!v){var e=i(o);v=!0;for(var t=p.length;t;){for(d=p,p=[];++y<t;)d&&d[y].run();y=-1,t=p.length}d=null,v=!1,a(e)}}function u(e,t){this.fun=e,this.array=t}function c(){}var l,f,h=e.exports={};!function(){try{l="function"==typeof setTimeout?setTimeout:n}catch(e){l=n}try{f="function"==typeof clearTimeout?clearTimeout:r}catch(e){f=r}}();var d,p=[],v=!1,y=-1;h.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];p.push(new u(e,t)),1!==p.length||v||i(s)},u.prototype.run=function(){this.fun.apply(null,this.array)},h.title="browser",h.browser=!0,h.env={},h.argv=[],h.version="",h.versions={},h.on=c,h.addListener=c,h.once=c,h.off=c,h.removeListener=c,h.removeAllListeners=c,h.emit=c,h.prependListener=c,h.prependOnceListener=c,h.listeners=function(e){return[]},h.binding=function(e){throw new Error("process.binding is not supported")},h.cwd=function(){return"/"},h.chdir=function(e){throw new Error("process.chdir is not supported")},h.umask=function(){return 0}},function(e,t,n){"use strict";var r=n(0);e.exports=function(e,t){r.forEach(e,function(n,r){r!==t&&r.toUpperCase()===t.toUpperCase()&&(e[t]=n,delete e[r])})}},function(e,t,n){"use strict";var r=n(7);e.exports=function(e,t,n){var i=n.config.validateStatus;n.status&&i&&!i(n.status)?t(r("Request failed with status code "+n.status,n.config,null,n.request,n)):e(n)}},function(e,t,n){"use strict";e.exports=function(e,t,n,r,i){return e.config=t,n&&(e.code=n),e.request=r,e.response=i,e}},function(e,t,n){"use strict";function r(e){return encodeURIComponent(e).replace(/%40/gi,"@").replace(/%3A/gi,":").replace(/%24/g,"$").replace(/%2C/gi,",").replace(/%20/g,"+").replace(/%5B/gi,"[").replace(/%5D/gi,"]")}var i=n(0);e.exports=function(e,t,n){if(!t)return e;var a;if(n)a=n(t);else if(i.isURLSearchParams(t))a=t.toString();else{var o=[];i.forEach(t,function(e,t){null!==e&&void 0!==e&&(i.isArray(e)?t+="[]":e=[e],i.forEach(e,function(e){i.isDate(e)?e=e.toISOString():i.isObject(e)&&(e=JSON.stringify(e)),o.push(r(t)+"="+r(e))}))}),a=o.join("&")}return a&&(e+=(-1===e.indexOf("?")?"?":"&")+a),e}},function(e,t,n){"use strict";var r=n(0),i=["age","authorization","content-length","content-type","etag","expires","from","host","if-modified-since","if-unmodified-since","last-modified","location","max-forwards","proxy-authorization","referer","retry-after","user-agent"];e.exports=function(e){var t,n,a,o={};return e?(r.forEach(e.split("\n"),function(e){if(a=e.indexOf(":"),t=r.trim(e.substr(0,a)).toLowerCase(),n=r.trim(e.substr(a+1)),t){if(o[t]&&i.indexOf(t)>=0)return;o[t]="set-cookie"===t?(o[t]?o[t]:[]).concat([n]):o[t]?o[t]+", "+n:n}}),o):o}},function(e,t,n){"use strict";var r=n(0);e.exports=r.isStandardBrowserEnv()?function(){function e(e){var t=e;return n&&(i.setAttribute("href",t),t=i.href),i.setAttribute("href",t),{href:i.href,protocol:i.protocol?i.protocol.replace(/:$/,""):"",host:i.host,search:i.search?i.search.replace(/^\?/,""):"",hash:i.hash?i.hash.replace(/^#/,""):"",hostname:i.hostname,port:i.port,pathname:"/"===i.pathname.charAt(0)?i.pathname:"/"+i.pathname}}var t,n=/(msie|trident)/i.test(navigator.userAgent),i=document.createElement("a");return t=e(window.location.href),function(n){var i=r.isString(n)?e(n):n;return i.protocol===t.protocol&&i.host===t.host}}():function(){return function(){return!0}}()},function(e,t,n){"use strict";var r=n(0);e.exports=r.isStandardBrowserEnv()?function(){return{write:function(e,t,n,i,a,o){var s=[];s.push(e+"="+encodeURIComponent(t)),r.isNumber(n)&&s.push("expires="+new Date(n).toGMTString()),r.isString(i)&&s.push("path="+i),r.isString(a)&&s.push("domain="+a),!0===o&&s.push("secure"),document.cookie=s.join("; ")},read:function(e){var t=document.cookie.match(new RegExp("(^|;\\s*)("+e+")=([^;]*)"));return t?decodeURIComponent(t[3]):null},remove:function(e){this.write(e,"",Date.now()-864e5)}}}():function(){return{write:function(){},read:function(){return null},remove:function(){}}}()},function(e,t,n){"use strict";function r(){this.handlers=[]}var i=n(0);r.prototype.use=function(e,t){return this.handlers.push({fulfilled:e,rejected:t}),this.handlers.length-1},r.prototype.eject=function(e){this.handlers[e]&&(this.handlers[e]=null)},r.prototype.forEach=function(e){i.forEach(this.handlers,function(t){null!==t&&e(t)})},e.exports=r},function(e,t,n){"use strict";function r(e){e.cancelToken&&e.cancelToken.throwIfRequested()}var i=n(0),a=n(27),o=n(8),s=n(2),u=n(28),c=n(29);e.exports=function(e){return r(e),e.baseURL&&!u(e.url)&&(e.url=c(e.baseURL,e.url)),e.headers=e.headers||{},e.data=a(e.data,e.headers,e.transformRequest),e.headers=i.merge(e.headers.common||{},e.headers[e.method]||{},e.headers||{}),i.forEach(["delete","get","head","post","put","patch","common"],function(t){delete e.headers[t]}),(e.adapter||s.adapter)(e).then(function(t){return r(e),t.data=a(t.data,t.headers,e.transformResponse),t},function(t){return o(t)||(r(e),t&&t.response&&(t.response.data=a(t.response.data,t.response.headers,e.transformResponse))),Promise.reject(t)})}},function(e,t,n){"use strict";var r=n(0);e.exports=function(e,t,n){return r.forEach(n,function(n){e=n(e,t)}),e}},function(e,t,n){"use strict";e.exports=function(e){return/^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(e)}},function(e,t,n){"use strict";e.exports=function(e,t){return t?e.replace(/\/+$/,"")+"/"+t.replace(/^\/+/,""):e}},function(e,t,n){"use strict";function r(e){if("function"!=typeof e)throw new TypeError("executor must be a function.");var t;this.promise=new Promise(function(e){t=e});var n=this;e(function(e){n.reason||(n.reason=new i(e),t(n.reason))})}var i=n(9);r.prototype.throwIfRequested=function(){if(this.reason)throw this.reason},r.source=function(){var e;return{token:new r(function(t){e=t}),cancel:e}},e.exports=r},function(e,t,n){"use strict";e.exports=function(e){return function(t){return e.apply(null,t)}}},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t,n){void 0===e[t]&&(console.info("file logger.json does not contain field [%s] set value default [%s]",t,n),e[t]=n)}Object.defineProperty(t,"__esModule",{value:!0}),t.LoggerConfigurator=void 0;var a=function(){function e(e,t){var n=[],r=!0,i=!1,a=void 0;try{for(var o,s=e[Symbol.iterator]();!(r=(o=s.next()).done)&&(n.push(o.value),!t||n.length!==t);r=!0);}catch(e){i=!0,a=e}finally{try{!r&&s.return&&s.return()}finally{if(i)throw a}}return n}return function(t,n){if(Array.isArray(t))return t;if(Symbol.iterator in Object(t))return e(t,n);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}(),o=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),s=n(1),u=n(4),c=function(e){return e&&e.__esModule?e:{default:e}}(u),l=!0,f=function(){function e(){r(this,e)}return o(e,null,[{key:"Init",value:function(t){l&&e.IsConfigurationNotAssigned()?(l=!1,e.GetByExecutionEnvironment(t)):t()}},{key:"Setup",value:function(t,n){if(console.info("Setup ",t),t){window[s.Constants._LOGGER_VAR_WINDOW]={};var r=!0,o=!1,u=void 0;try{for(var c,l=Object.entries(s.Constants._CONFIGURATIONS)[Symbol.iterator]();!(r=(c=l.next()).done);r=!0){var f=a(c.value,2),h=f[0],d=f[1];i(t,h,d)}}catch(e){o=!0,u=e}finally{try{!r&&l.return&&l.return()}finally{if(o)throw u}}Object.keys(t).forEach(function(e){return window[s.Constants._LOGGER_VAR_WINDOW][e]=t[e]}),window[s.Constants._LOGGER_VAR_WINDOW]._USE_WINDOW_ORIGIN&&e.SetConfigurationServer()}else window[s.Constants._LOGGER_VAR_WINDOW]=s.Constants._CONFIGURATIONS,console.info("Logger will use default configuration ... ",s.Constants._CONFIGURATIONS);n()}},{key:"GetByExecutionEnvironment",value:function(t){e.IsBrowser()?e.GetRemote(t):e.GetLocal(t)}},{key:"IsBrowser",value:function(){return!!window}},{key:"GetLocal",value:function(t){e.Setup(null,t)}},{key:"GetRemote",value:function(t){var n=window.location+"",r=n.split("/");n=n.replace(r[r.length-1],""),n+=s.Constants._LOGGER_CONFIGURATION_FILE_REMOTE,c.default.get(n,{responseType:"json"}).then(function(n){e.Setup(n.data,t)}).catch(function(n){console.error("It was not possible to get remote file configuration",n),e.Setup(null,t)})}},{key:"SetConfigurationServer",value:function(){if(window[s.Constants._LOGGER_VAR_WINDOW]._USE_WINDOW_ORIGIN){var e=window.location.hostname;if("127.0.0.1"!==e&&"localhost"!==e){var t=window.location.origin;console.debug("SetConfigurationServer withLocation",t),window[s.Constants._LOGGER_VAR_WINDOW]._SERVER=t}}}},{key:"ExistExternalConfiguration",value:function(e){return!!e}},{key:"IsConfigurationNotAssigned",value:function(){return!s.Constants._LOGGER_CONFIGURATION_ASSIGNED}}]),e}();t.LoggerConfigurator=f}])})},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0}),t.WaveSurferWrapper=void 0;var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),a=n(5),o=function(e){return e&&e.__esModule?e:{default:e}}(a),s=n(6);t.WaveSurferWrapper=function(){function e(){r(this,e)}return i(e,[{key:"getWaveSurferPlayer",value:function(e){var t=o.default.create({container:document.querySelector(e)});return new s.WaveSurferPlayer(t)}}]),e}()},function(e,t,n){/*!
	 * wavesurfer.js 2.0.0-beta02 (Fri Sep 22 2017 11:28:06 GMT+0200 (CEST))
	 * https://github.com/katspaugh/wavesurfer.js
	 * @license BSD-3-Clause
	 */
	!function(t,n){e.exports=n()}(0,function(){return function(e){function t(r){if(n[r])return n[r].exports;var i=n[r]={i:r,l:!1,exports:{}};return e[r].call(i.exports,i,i.exports,t),i.l=!0,i.exports}var n={};return t.m=e,t.c=n,t.i=function(e){return e},t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="localhost:8080/dist/",t(t.s=15)}([function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(8);Object.defineProperty(t,"ajax",{enumerable:!0,get:function(){return r(i).default}});var a=n(11);Object.defineProperty(t,"getId",{enumerable:!0,get:function(){return r(a).default}});var o=n(12);Object.defineProperty(t,"max",{enumerable:!0,get:function(){return r(o).default}});var s=n(13);Object.defineProperty(t,"min",{enumerable:!0,get:function(){return r(s).default}});var u=n(2);Object.defineProperty(t,"Observer",{enumerable:!0,get:function(){return r(u).default}});var c=n(9);Object.defineProperty(t,"extend",{enumerable:!0,get:function(){return r(c).default}});var l=n(14);Object.defineProperty(t,"style",{enumerable:!0,get:function(){return r(l).default}});var f=n(3);Object.defineProperty(t,"requestAnimationFrame",{enumerable:!0,get:function(){return r(f).default}});var h=n(10);Object.defineProperty(t,"frame",{enumerable:!0,get:function(){return r(h).default}});var d=n(16);Object.defineProperty(t,"debounce",{enumerable:!0,get:function(){return r(d).default}})},function(e,t,n){"use strict";function r(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),u=n(0),c=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t.default=e,t}(u),l="playing",f="paused",h="finished",d=function(e){function t(e){var n,o;i(this,t);var s=a(this,(t.__proto__||Object.getPrototypeOf(t)).call(this));return s.audioContext=null,s.offlineAudioContext=null,s.stateBehaviors=(n={},r(n,l,{init:function(){this.addOnAudioProcess()},getPlayedPercents:function(){var e=this.getDuration();return this.getCurrentTime()/e||0},getCurrentTime:function(){return this.startPosition+this.getPlayedTime()}}),r(n,f,{init:function(){this.removeOnAudioProcess()},getPlayedPercents:function(){var e=this.getDuration();return this.getCurrentTime()/e||0},getCurrentTime:function(){return this.startPosition}}),r(n,h,{init:function(){this.removeOnAudioProcess(),this.fireEvent("finish")},getPlayedPercents:function(){return 1},getCurrentTime:function(){return this.getDuration()}}),n),s.params=e,s.ac=e.audioContext||s.getAudioContext(),s.lastPlay=s.ac.currentTime,s.startPosition=0,s.scheduledPause=null,s.states=(o={},r(o,l,Object.create(s.stateBehaviors[l])),r(o,f,Object.create(s.stateBehaviors[f])),r(o,h,Object.create(s.stateBehaviors[h])),o),s.analyser=null,s.buffer=null,s.filters=[],s.gainNode=null,s.mergedPeaks=null,s.offlineAc=null,s.peaks=null,s.playbackRate=1,s.analyser=null,s.scriptNode=null,s.source=null,s.splitPeaks=[],s.state=null,s}return o(t,e),s(t,[{key:"supportsWebAudio",value:function(){return!(!window.AudioContext&&!window.webkitAudioContext)}},{key:"getAudioContext",value:function(){return window.WaveSurferAudioContext||(window.WaveSurferAudioContext=new(window.AudioContext||window.webkitAudioContext)),window.WaveSurferAudioContext}},{key:"getOfflineAudioContext",value:function(e){return window.WaveSurferOfflineAudioContext||(window.WaveSurferOfflineAudioContext=new(window.OfflineAudioContext||window.webkitOfflineAudioContext)(1,2,e)),window.WaveSurferOfflineAudioContext}}]),s(t,[{key:"init",value:function(){this.createVolumeNode(),this.createScriptNode(),this.createAnalyserNode(),this.setState(f),this.setPlaybackRate(this.params.audioRate),this.setLength(0)}},{key:"disconnectFilters",value:function(){this.filters&&(this.filters.forEach(function(e){e&&e.disconnect()}),this.filters=null,this.analyser.connect(this.gainNode))}},{key:"setState",value:function(e){this.state!==this.states[e]&&(this.state=this.states[e],this.state.init.call(this))}},{key:"setFilter",value:function(){for(var e=arguments.length,t=Array(e),n=0;n<e;n++)t[n]=arguments[n];this.setFilters(t)}},{key:"setFilters",value:function(e){this.disconnectFilters(),e&&e.length&&(this.filters=e,this.analyser.disconnect(),e.reduce(function(e,t){return e.connect(t),t},this.analyser).connect(this.gainNode))}},{key:"createScriptNode",value:function(){this.ac.createScriptProcessor?this.scriptNode=this.ac.createScriptProcessor(t.scriptBufferSize):this.scriptNode=this.ac.createJavaScriptNode(t.scriptBufferSize),this.scriptNode.connect(this.ac.destination)}},{key:"addOnAudioProcess",value:function(){var e=this;this.scriptNode.onaudioprocess=function(){var t=e.getCurrentTime();t>=e.getDuration()?(e.setState(h),e.fireEvent("pause")):t>=e.scheduledPause?e.pause():e.state===e.states[l]&&e.fireEvent("audioprocess",t)}}},{key:"removeOnAudioProcess",value:function(){this.scriptNode.onaudioprocess=null}},{key:"createAnalyserNode",value:function(){this.analyser=this.ac.createAnalyser(),this.analyser.connect(this.gainNode)}},{key:"createVolumeNode",value:function(){this.ac.createGain?this.gainNode=this.ac.createGain():this.gainNode=this.ac.createGainNode(),this.gainNode.connect(this.ac.destination)}},{key:"setVolume",value:function(e){this.gainNode.gain.value=e}},{key:"getVolume",value:function(){return this.gainNode.gain.value}},{key:"decodeArrayBuffer",value:function(e,t,n){this.offlineAc||(this.offlineAc=this.getOfflineAudioContext(this.ac?this.ac.sampleRate:44100)),this.offlineAc.decodeAudioData(e,function(e){return t(e)},n)}},{key:"setPeaks",value:function(e){this.peaks=e}},{key:"setLength",value:function(e){if(!this.mergedPeaks||e!=2*this.mergedPeaks.length-1+2){this.splitPeaks=[],this.mergedPeaks=[];var t=this.buffer?this.buffer.numberOfChannels:1,n=void 0;for(n=0;n<t;n++)this.splitPeaks[n]=[],this.splitPeaks[n][2*(e-1)]=0,this.splitPeaks[n][2*(e-1)+1]=0;this.mergedPeaks[2*(e-1)]=0,this.mergedPeaks[2*(e-1)+1]=0}}},{key:"getPeaks",value:function(e,t,n){if(this.peaks)return this.peaks;if(t=t||0,n=n||e-1,this.setLength(e),!this.buffer.length){var r=this.createBuffer(1,4096,this.sampleRate);this.buffer=r.buffer}var i=this.buffer.length/e,a=~~(i/10)||1,o=this.buffer.numberOfChannels,s=void 0;for(s=0;s<o;s++){var u=this.splitPeaks[s],c=this.buffer.getChannelData(s),l=void 0;for(l=t;l<=n;l++){var f=~~(l*i),h=~~(f+i),d=0,p=0,v=void 0;for(v=f;v<h;v+=a){var y=c[v];y>p&&(p=y),y<d&&(d=y)}u[2*l]=p,u[2*l+1]=d,(0==s||p>this.mergedPeaks[2*l])&&(this.mergedPeaks[2*l]=p),(0==s||d<this.mergedPeaks[2*l+1])&&(this.mergedPeaks[2*l+1]=d)}}return this.params.splitChannels?this.splitPeaks:this.mergedPeaks}},{key:"getPlayedPercents",value:function(){return this.state.getPlayedPercents.call(this)}},{key:"disconnectSource",value:function(){this.source&&this.source.disconnect()}},{key:"destroy",value:function(){this.isPaused()||this.pause(),this.unAll(),this.buffer=null,this.disconnectFilters(),this.disconnectSource(),this.gainNode.disconnect(),this.scriptNode.disconnect(),this.analyser.disconnect(),this.params.closeAudioContext&&("function"==typeof this.ac.close&&"closed"!=this.ac.state&&this.ac.close(),this.ac=null,this.params.audioContext?this.params.audioContext=null:window.WaveSurferAudioContext=null,window.WaveSurferOfflineAudioContext=null)}},{key:"load",value:function(e){this.startPosition=0,this.lastPlay=this.ac.currentTime,this.buffer=e,this.createSource()}},{key:"createSource",value:function(){this.disconnectSource(),this.source=this.ac.createBufferSource(),this.source.start=this.source.start||this.source.noteGrainOn,this.source.stop=this.source.stop||this.source.noteOff,this.source.playbackRate.value=this.playbackRate,this.source.buffer=this.buffer,this.source.connect(this.analyser)}},{key:"isPaused",value:function(){return this.state!==this.states[l]}},{key:"getDuration",value:function(){return this.buffer?this.buffer.duration:0}},{key:"seekTo",value:function(e,t){if(this.buffer)return this.scheduledPause=null,null==e&&(e=this.getCurrentTime())>=this.getDuration()&&(e=0),null==t&&(t=this.getDuration()),this.startPosition=e,this.lastPlay=this.ac.currentTime,this.state===this.states[h]&&this.setState(f),{start:e,end:t}}},{key:"getPlayedTime",value:function(){return(this.ac.currentTime-this.lastPlay)*this.playbackRate}},{key:"play",value:function(e,t){if(this.buffer){this.createSource();var n=this.seekTo(e,t);e=n.start,t=n.end,this.scheduledPause=t,this.source.start(0,e,t-e),"suspended"==this.ac.state&&this.ac.resume&&this.ac.resume(),this.setState(l),this.fireEvent("play")}}},{key:"pause",value:function(){this.scheduledPause=null,this.startPosition+=this.getPlayedTime(),this.source&&this.source.stop(0),this.setState(f),this.fireEvent("pause")}},{key:"getCurrentTime",value:function(){return this.state.getCurrentTime.call(this)}},{key:"getPlaybackRate",value:function(){return this.playbackRate}},{key:"setPlaybackRate",value:function(e){e=e||1,this.isPaused()?this.playbackRate=e:(this.pause(),this.playbackRate=e,this.play())}}]),t}(c.Observer);d.scriptBufferSize=256,t.default=d,e.exports=t.default},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),a=function(){function e(){r(this,e),this.handlers=null}return i(e,[{key:"on",value:function(e,t){var n=this;this.handlers||(this.handlers={});var r=this.handlers[e];return r||(r=this.handlers[e]=[]),r.push(t),{name:e,callback:t,un:function(e,t){return n.un(e,t)}}}},{key:"un",value:function(e,t){if(this.handlers){var n=this.handlers[e],r=void 0;if(n)if(t)for(r=n.length-1;r>=0;r--)n[r]==t&&n.splice(r,1);else n.length=0}}},{key:"unAll",value:function(){this.handlers=null}},{key:"once",value:function(e,t){var n=this,r=function r(){for(var i=arguments.length,a=Array(i),o=0;o<i;o++)a[o]=arguments[o];t.apply(n,a),setTimeout(function(){n.un(e,r)},0)};return this.on(e,r)}},{key:"fireEvent",value:function(e){for(var t=arguments.length,n=Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];if(this.handlers){var i=this.handlers[e];i&&i.forEach(function(e){e.apply(void 0,n)})}}}]),e}();t.default=a,e.exports=t.default},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=(window.requestAnimationFrame||window.webkitRequestAnimationFrame||window.mozRequestAnimationFrame||window.oRequestAnimationFrame||window.msRequestAnimationFrame||function(e,t){return setTimeout(e,1e3/60)}).bind(window),e.exports=t.default},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function a(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var o=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),s=n(7),u=function(e){return e&&e.__esModule?e:{default:e}}(s),c=n(0),l=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t.default=e,t}(c),f=function(e){function t(e,n){r(this,t);var a=i(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e,n));return a.maxCanvasWidth=n.maxCanvasWidth,a.maxCanvasElementWidth=Math.round(n.maxCanvasWidth/n.pixelRatio),a.hasProgressCanvas=n.waveColor!=n.progressColor,a.halfPixel=.5/n.pixelRatio,a.canvases=[],a.progressWave=null,a}return a(t,e),o(t,[{key:"init",value:function(){this.createWrapper(),this.createElements()}},{key:"createElements",value:function(){this.progressWave=this.wrapper.appendChild(this.style(document.createElement("wave"),{position:"absolute",zIndex:3,left:0,top:0,bottom:0,overflow:"hidden",width:"0",display:"none",boxSizing:"border-box",borderRightStyle:"solid",borderRightWidth:this.params.cursorWidth+"px",borderRightColor:this.params.cursorColor,pointerEvents:"none"})),this.addCanvas()}},{key:"updateSize",value:function(){for(var e=this,t=Math.round(this.width/this.params.pixelRatio),n=Math.ceil(t/this.maxCanvasElementWidth);this.canvases.length<n;)this.addCanvas();for(;this.canvases.length>n;)this.removeCanvas();this.canvases.forEach(function(t,n){var r=e.maxCanvasWidth+2*Math.ceil(e.params.pixelRatio/2);n==e.canvases.length-1&&(r=e.width-e.maxCanvasWidth*(e.canvases.length-1)),e.updateDimensions(t,r,e.height),e.clearWaveForEntry(t)})}},{key:"addCanvas",value:function(){var e={},t=this.maxCanvasElementWidth*this.canvases.length;e.wave=this.wrapper.appendChild(this.style(document.createElement("canvas"),{position:"absolute",zIndex:2,left:t+"px",top:0,bottom:0,height:"100%",pointerEvents:"none"})),e.waveCtx=e.wave.getContext("2d"),this.hasProgressCanvas&&(e.progress=this.progressWave.appendChild(this.style(document.createElement("canvas"),{position:"absolute",left:t+"px",top:0,bottom:0,height:"100%"})),e.progressCtx=e.progress.getContext("2d")),this.canvases.push(e)}},{key:"removeCanvas",value:function(){var e=this.canvases.pop();e.wave.parentElement.removeChild(e.wave),this.hasProgressCanvas&&e.progress.parentElement.removeChild(e.progress)}},{key:"updateDimensions",value:function(e,t,n){var r=Math.round(t/this.params.pixelRatio),i=Math.round(this.width/this.params.pixelRatio);e.start=e.waveCtx.canvas.offsetLeft/i||0,e.end=e.start+r/i,e.waveCtx.canvas.width=t,e.waveCtx.canvas.height=n,this.style(e.waveCtx.canvas,{width:r+"px"}),this.style(this.progressWave,{display:"block"}),this.hasProgressCanvas&&(e.progressCtx.canvas.width=t,e.progressCtx.canvas.height=n,this.style(e.progressCtx.canvas,{width:r+"px"}))}},{key:"clearWave",value:function(){var e=this;this.canvases.forEach(function(t){return e.clearWaveForEntry(t)})}},{key:"clearWaveForEntry",value:function(e){e.waveCtx.clearRect(0,0,e.waveCtx.canvas.width,e.waveCtx.canvas.height),this.hasProgressCanvas&&e.progressCtx.clearRect(0,0,e.progressCtx.canvas.width,e.progressCtx.canvas.height)}},{key:"drawBars",value:function(e,t,n,r){var i=this;return this.prepareDraw(e,t,n,r,function(t){var a=t.absmax,o=t.hasMinVals,s=(t.height,t.offsetY),u=t.halfH;if(void 0!==n){var c=o?2:1,l=e.length/c,f=i.params.barWidth*i.params.pixelRatio,h=Math.max(i.params.pixelRatio,~~(f/2)),d=f+h,p=l/i.width,v=n,y=r,g=void 0;for(g=v;g<y;g+=d){var m=e[Math.floor(g*p*c)]||0,w=Math.round(m/a*u);i.fillRect(g+i.halfPixel,u-w+s,f+i.halfPixel,2*w)}}})}},{key:"drawWave",value:function(e,t,n,r){var i=this;return this.prepareDraw(e,t,n,r,function(t){var a=t.absmax,o=t.hasMinVals,s=(t.height,t.offsetY),u=t.halfH;if(!o){var c=[],l=e.length,f=void 0;for(f=0;f<l;f++)c[2*f]=e[f],c[2*f+1]=-e[f];e=c}void 0!==n&&i.drawLine(e,a,u,s,n,r),i.fillRect(0,u+s-i.halfPixel,i.width,i.halfPixel)})}},{key:"drawLine",value:function(e,t,n,r,i,a){var o=this;this.canvases.forEach(function(s){o.setFillStyles(s),o.drawLineToContext(s,s.waveCtx,e,t,n,r,i,a),o.drawLineToContext(s,s.progressCtx,e,t,n,r,i,a)})}},{key:"drawLineToContext",value:function(e,t,n,r,i,a,o,s){if(t){var u=n.length/2,c=this.params.fillParent&&this.width!=u?this.width/u:1,l=Math.round(u*e.start),f=Math.round(u*e.end)+1;if(!(l>s||f<o)){var h=Math.min(l,o),d=Math.max(f,s),p=void 0,v=void 0;for(t.beginPath(),t.moveTo((h-l)*c+this.halfPixel,i+a),p=h;p<d;p++){var y=n[2*p]||0,g=Math.round(y/r*i);t.lineTo((p-l)*c+this.halfPixel,i-g+a)}for(v=d-1;v>=h;v--){var m=n[2*v+1]||0,w=Math.round(m/r*i);t.lineTo((v-l)*c+this.halfPixel,i-w+a)}t.closePath(),t.fill()}}}},{key:"fillRect",value:function(e,t,n,r){var i=Math.floor(e/this.maxCanvasWidth),a=Math.min(Math.ceil((e+n)/this.maxCanvasWidth)+1,this.canvases.length),o=void 0;for(o=i;o<a;o++){var s=this.canvases[o],u=o*this.maxCanvasWidth,c={x1:Math.max(e,o*this.maxCanvasWidth),y1:t,x2:Math.min(e+n,o*this.maxCanvasWidth+s.waveCtx.canvas.width),y2:t+r};c.x1<c.x2&&(this.setFillStyles(s),this.fillRectToContext(s.waveCtx,c.x1-u,c.y1,c.x2-c.x1,c.y2-c.y1),this.fillRectToContext(s.progressCtx,c.x1-u,c.y1,c.x2-c.x1,c.y2-c.y1))}}},{key:"prepareDraw",value:function(e,t,n,r,i){var a=this;return l.frame(function(){if(e[0]instanceof Array){var o=e;if(a.params.splitChannels)return a.setHeight(o.length*a.params.height*a.params.pixelRatio),void o.forEach(function(e,t){return a.prepareDraw(e,t,n,r,i)});e=o[0]}var s=1/a.params.barHeight;if(a.params.normalize){var u=l.max(e),c=l.min(e);s=-c>u?-c:u}var f=[].some.call(e,function(e){return e<0}),h=a.params.height*a.params.pixelRatio;return i({absmax:s,hasMinVals:f,height:h,offsetY:h*t||0,halfH:h/2})})()}},{key:"fillRectToContext",value:function(e,t,n,r,i){e&&e.fillRect(t,n,r,i)}},{key:"setFillStyles",value:function(e){e.waveCtx.fillStyle=this.params.waveColor,this.hasProgressCanvas&&(e.progressCtx.fillStyle=this.params.progressColor)}},{key:"getImage",value:function(e,t){var n=this.canvases.map(function(n){return n.wave.toDataURL(e,t)});return n.length>1?n:n[0]}},{key:"updateProgress",value:function(e){this.style(this.progressWave,{width:e+"px"})}}]),t}(u.default);t.default=f,e.exports=t.default},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function a(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var o=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),s=function e(t,n,r){null===t&&(t=Function.prototype);var i=Object.getOwnPropertyDescriptor(t,n);if(void 0===i){var a=Object.getPrototypeOf(t);return null===a?void 0:e(a,n,r)}if("value"in i)return i.value;var o=i.get;return void 0!==o?o.call(r):void 0},u=n(1),c=function(e){return e&&e.__esModule?e:{default:e}}(u),l=n(0),f=(function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n]);t.default=e}(l),function(e){function t(e){r(this,t);var n=i(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.params=e,n.media={currentTime:0,duration:0,paused:!0,playbackRate:1,play:function(){},pause:function(){}},n.mediaType=e.mediaType.toLowerCase(),n.elementPosition=e.elementPosition,n.peaks=null,n.playbackRate=1,n.buffer=null,n.onPlayEnd=null,n}return a(t,e),o(t,[{key:"init",value:function(){this.setPlaybackRate(this.params.audioRate),this.createTimer()}},{key:"createTimer",value:function(){var e=this,t=function t(){e.isPaused()||(e.fireEvent("audioprocess",e.getCurrentTime()),(window.requestAnimationFrame||window.webkitRequestAnimationFrame)(t))};this.on("play",t)}},{key:"load",value:function(e,t,n,r){var i=document.createElement(this.mediaType);i.controls=this.params.mediaControls,i.autoplay=this.params.autoplay||!1,i.preload=null==r?"auto":r,i.src=e,i.style.width="100%";var a=t.querySelector(this.mediaType);a&&t.removeChild(a),t.appendChild(i),this._load(i,n)}},{key:"loadElt",value:function(e,t){e.controls=this.params.mediaControls,e.autoplay=this.params.autoplay||!1,this._load(e,t)}},{key:"_load",value:function(e,t){var n=this;"function"==typeof e.load&&e.load(),e.addEventListener("error",function(){n.fireEvent("error","Error loading media element")}),e.addEventListener("canplay",function(){n.fireEvent("canplay")}),e.addEventListener("ended",function(){n.fireEvent("finish")}),e.addEventListener("play",function(){n.fireEvent("play")}),e.addEventListener("pause",function(){n.fireEvent("pause")}),this.media=e,this.peaks=t,this.onPlayEnd=null,this.buffer=null,this.setPlaybackRate(this.playbackRate)}},{key:"isPaused",value:function(){return!this.media||this.media.paused}},{key:"getDuration",value:function(){var e=(this.buffer||this.media).duration;return e>=1/0&&(e=this.media.seekable.end(0)),e}},{key:"getCurrentTime",value:function(){return this.media&&this.media.currentTime}},{key:"getPlayedPercents",value:function(){return this.getCurrentTime()/this.getDuration()||0}},{key:"getPlaybackRate",value:function(){return this.playbackRate||this.media.playbackRate}},{key:"setPlaybackRate",value:function(e){this.playbackRate=e||1,this.media.playbackRate=this.playbackRate}},{key:"seekTo",value:function(e){null!=e&&(this.media.currentTime=e),this.clearPlayEnd()}},{key:"play",value:function(e,t){this.seekTo(e),this.media.play(),t&&this.setPlayEnd(t)}},{key:"pause",value:function(){this.media&&this.media.pause(),this.clearPlayEnd()}},{key:"setPlayEnd",value:function(e){var t=this;this._onPlayEnd=function(n){n>=e&&(t.pause(),t.seekTo(e))},this.on("audioprocess",this._onPlayEnd)}},{key:"clearPlayEnd",value:function(){this._onPlayEnd&&(this.un("audioprocess",this._onPlayEnd),this._onPlayEnd=null)}},{key:"getPeaks",value:function(e,n,r){return this.buffer?s(t.prototype.__proto__||Object.getPrototypeOf(t.prototype),"getPeaks",this).call(this,e,n,r):this.peaks||[]}},{key:"getVolume",value:function(){return this.media.volume}},{key:"setVolume",value:function(e){this.media.volume=e}},{key:"destroy",value:function(){this.pause(),this.unAll(),this.media&&this.media.parentNode&&this.media.parentNode.removeChild(this.media),this.media=null}}]),t}(c.default));t.default=f,e.exports=t.default},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),a=function(){function e(){r(this,e),this.clearPeakCache()}return i(e,[{key:"clearPeakCache",value:function(){this.peakCacheRanges=[],this.peakCacheLength=-1}},{key:"addRangeToPeakCache",value:function(e,t,n){e!=this.peakCacheLength&&(this.clearPeakCache(),this.peakCacheLength=e);for(var r=[],i=0;i<this.peakCacheRanges.length&&this.peakCacheRanges[i]<t;)i++;for(i%2==0&&r.push(t);i<this.peakCacheRanges.length&&this.peakCacheRanges[i]<=n;)r.push(this.peakCacheRanges[i]),i++;i%2==0&&r.push(n),r=r.filter(function(e,t,n){return 0==t?e!=n[t+1]:t==n.length-1?e!=n[t-1]:e!=n[t-1]&&e!=n[t+1]}),this.peakCacheRanges=this.peakCacheRanges.concat(r),this.peakCacheRanges=this.peakCacheRanges.sort(function(e,t){return e-t}).filter(function(e,t,n){return 0==t?e!=n[t+1]:t==n.length-1?e!=n[t-1]:e!=n[t-1]&&e!=n[t+1]});var a=[];for(i=0;i<r.length;i+=2)a.push([r[i],r[i+1]]);return a}},{key:"getCacheRanges",value:function(){var e=[],t=void 0;for(t=0;t<this.peakCacheRanges.length;t+=2)e.push([this.peakCacheRanges[t],this.peakCacheRanges[t+1]]);return e}}]),e}();t.default=a,e.exports=t.default},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function a(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var o=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),s=n(0),u=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t.default=e,t}(s),c=function(e){function t(e,n){r(this,t);var a=i(this,(t.__proto__||Object.getPrototypeOf(t)).call(this));return a.container=e,a.params=n,a.width=0,a.height=n.height*a.params.pixelRatio,a.lastPos=0,a.wrapper=null,a}return a(t,e),o(t,[{key:"style",value:function(e,t){return u.style(e,t)}},{key:"createWrapper",value:function(){this.wrapper=this.container.appendChild(document.createElement("wave")),this.style(this.wrapper,{display:"block",position:"relative",userSelect:"none",webkitUserSelect:"none",height:this.params.height+"px"}),(this.params.fillParent||this.params.scrollParent)&&this.style(this.wrapper,{width:"100%",overflowX:this.params.hideScrollbar?"hidden":"auto",overflowY:"hidden"}),this.setupWrapperEvents()}},{key:"handleEvent",value:function(e,t){!t&&e.preventDefault();var n=e.targetTouches?e.targetTouches[0].clientX:e.clientX,r=this.wrapper.getBoundingClientRect(),i=this.width,a=this.getWidth(),o=void 0;return!this.params.fillParent&&i<a?(o=(n-r.left)*this.params.pixelRatio/i||0)>1&&(o=1):o=(n-r.left+this.wrapper.scrollLeft)/this.wrapper.scrollWidth||0,o}},{key:"setupWrapperEvents",value:function(){var e=this;this.wrapper.addEventListener("click",function(t){var n=e.wrapper.offsetHeight-e.wrapper.clientHeight;if(0!=n){var r=e.wrapper.getBoundingClientRect();if(t.clientY>=r.bottom-n)return}e.params.interact&&e.fireEvent("click",t,e.handleEvent(t))}),this.wrapper.addEventListener("scroll",function(t){return e.fireEvent("scroll",t)})}},{key:"drawPeaks",value:function(e,t,n,r){this.setWidth(t)||this.clearWave(),this.params.barWidth?this.drawBars(e,0,n,r):this.drawWave(e,0,n,r)}},{key:"resetScroll",value:function(){null!==this.wrapper&&(this.wrapper.scrollLeft=0)}},{key:"recenter",value:function(e){var t=this.wrapper.scrollWidth*e;this.recenterOnPosition(t,!0)}},{key:"recenterOnPosition",value:function(e,t){var n=this.wrapper.scrollLeft,r=~~(this.wrapper.clientWidth/2),i=this.wrapper.scrollWidth-this.wrapper.clientWidth,a=e-r,o=a-n;0!=i&&(!t&&-r<=o&&o<r&&(o=Math.max(-5,Math.min(5,o)),a=n+o),(a=Math.max(0,Math.min(i,a)))!=n&&(this.wrapper.scrollLeft=a))}},{key:"getScrollX",value:function(){return Math.round(this.wrapper.scrollLeft*this.params.pixelRatio)}},{key:"getWidth",value:function(){return Math.round(this.container.clientWidth*this.params.pixelRatio)}},{key:"setWidth",value:function(e){return this.width!=e&&(this.width=e,this.params.fillParent||this.params.scrollParent?this.style(this.wrapper,{width:""}):this.style(this.wrapper,{width:~~(this.width/this.params.pixelRatio)+"px"}),this.updateSize(),!0)}},{key:"setHeight",value:function(e){return e!=this.height&&(this.height=e,this.style(this.wrapper,{height:~~(this.height/this.params.pixelRatio)+"px"}),this.updateSize(),!0)}},{key:"progress",value:function(e){var t=1/this.params.pixelRatio,n=Math.round(e*this.width)*t;if(n<this.lastPos||n-this.lastPos>=t){if(this.lastPos=n,this.params.scrollParent&&this.params.autoCenter){var r=~~(this.wrapper.scrollWidth*e);this.recenterOnPosition(r)}this.updateProgress(n)}}},{key:"destroy",value:function(){this.unAll(),this.wrapper&&(this.wrapper.parentNode==this.container&&this.container.removeChild(this.wrapper),this.wrapper=null)}},{key:"updateSize",value:function(){}},{key:"drawBars",value:function(e,t,n,r){}},{key:"drawWave",value:function(e,t,n,r){}},{key:"clearWave",value:function(){}},{key:"updateProgress",value:function(e){}}]),t}(u.Observer);t.default=c,e.exports=t.default},function(e,t,n){"use strict";function r(e){var t=new a.default,n=new XMLHttpRequest,r=!1;return n.open(e.method||"GET",e.url,!0),n.responseType=e.responseType||"json",n.addEventListener("progress",function(e){t.fireEvent("progress",e),e.lengthComputable&&e.loaded==e.total&&(r=!0)}),n.addEventListener("load",function(e){r||t.fireEvent("progress",e),t.fireEvent("load",e),200==n.status||206==n.status?t.fireEvent("success",n.response,e):t.fireEvent("error",e)}),n.addEventListener("error",function(e){return t.fireEvent("error",e)}),n.send(),t.xhr=n,t}Object.defineProperty(t,"__esModule",{value:!0}),t.default=r;var i=n(2),a=function(e){return e&&e.__esModule?e:{default:e}}(i);e.exports=t.default},function(e,t,n){"use strict";function r(e){for(var t=arguments.length,n=Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];return n.forEach(function(t){Object.keys(t).forEach(function(n){e[n]=t[n]})}),e}Object.defineProperty(t,"__esModule",{value:!0}),t.default=r,e.exports=t.default},function(e,t,n){"use strict";function r(e){return function(){for(var t=arguments.length,n=Array(t),r=0;r<t;r++)n[r]=arguments[r];return(0,a.default)(function(){return e.apply(void 0,n)})}}Object.defineProperty(t,"__esModule",{value:!0}),t.default=r;var i=n(3),a=function(e){return e&&e.__esModule?e:{default:e}}(i);e.exports=t.default},function(e,t,n){"use strict";function r(){return"wavesurfer_"+Math.random().toString(32).substring(2)}Object.defineProperty(t,"__esModule",{value:!0}),t.default=r,e.exports=t.default},function(e,t,n){"use strict";function r(e){var t=-1/0;return Object.keys(e).forEach(function(n){e[n]>t&&(t=e[n])}),t}Object.defineProperty(t,"__esModule",{value:!0}),t.default=r,e.exports=t.default},function(e,t,n){"use strict";function r(e){var t=Number(1/0);return Object.keys(e).forEach(function(n){e[n]<t&&(t=e[n])}),t}Object.defineProperty(t,"__esModule",{value:!0}),t.default=r,e.exports=t.default},function(e,t,n){"use strict";function r(e,t){return Object.keys(t).forEach(function(n){e.style[n]!==t[n]&&(e.style[n]=t[n])}),e}Object.defineProperty(t,"__esModule",{value:!0}),t.default=r,e.exports=t.default},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function a(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),u=n(0),c=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t.default=e,t}(u),l=n(4),f=r(l),h=n(1),d=r(h),p=n(5),v=r(p),y=n(6),g=r(y),m=(function(){function e(t,n){o(this,e)}s(e,[{key:"create",value:function(e){}}]),s(e,[{key:"init",value:function(){}},{key:"destroy",value:function(){}}])}(),function(e){function t(e){var n;o(this,t);var r=i(this,(t.__proto__||Object.getPrototypeOf(t)).call(this));if(r.defaultParams={audioContext:null,audioRate:1,autoCenter:!0,backend:"WebAudio",barHeight:1,container:null,cursorColor:"#333",cursorWidth:1,dragSelection:!0,fillParent:!0,forceDecode:!1,height:128,hideScrollbar:!1,interact:!0,loopSelection:!0,maxCanvasWidth:4e3,mediaContainer:null,mediaControls:!1,mediaType:"audio",minPxPerSec:20,normalize:!1,partialRender:!1,pixelRatio:window.devicePixelRatio||screen.deviceXDPI/screen.logicalXDPI,plugins:[],progressColor:"#555",renderer:f.default,responsive:!1,scrollParent:!1,skipLength:2,splitChannels:!1,waveColor:"#999"},r.backends={MediaElement:v.default,WebAudio:d.default},r.util=c,r.params=c.extend({},r.defaultParams,e),r.container="string"==typeof e.container?document.querySelector(r.params.container):r.params.container,!r.container)throw new Error("Container element not found");if(null==r.params.mediaContainer?r.mediaContainer=r.container:"string"==typeof r.params.mediaContainer?r.mediaContainer=document.querySelector(r.params.mediaContainer):r.mediaContainer=r.params.mediaContainer,!r.mediaContainer)throw new Error("Media Container element not found");if(r.params.maxCanvasWidth<=1)throw new Error("maxCanvasWidth must be greater than 1");if(r.params.maxCanvasWidth%2==1)throw new Error("maxCanvasWidth must be an even number");if(r.savedVolume=0,r.isMuted=!1,r.tmpEvents=[],r.currentAjax=null,r.arraybuffer=null,r.drawer=null,r.backend=null,r.peakCache=null,"function"!=typeof r.params.renderer)throw new Error("Renderer parameter is invalid");r.Drawer=r.params.renderer,r.Backend=r.backends[r.params.backend],r.initialisedPluginList={},r.isDestroyed=!1,r.isReady=!1;var a=0;return r._onResize=c.debounce(function(){a!=r.drawer.wrapper.clientWidth&&(a=r.drawer.wrapper.clientWidth,r.drawBuffer())},"number"==typeof r.params.responsive?r.params.responsive:100),n=r,i(r,n)}return a(t,e),s(t,null,[{key:"create",value:function(e){return new t(e).init()}}]),s(t,[{key:"init",value:function(){return this.registerPlugins(this.params.plugins),this.createDrawer(),this.createBackend(),this.createPeakCache(),this}},{key:"registerPlugins",value:function(e){var t=this;return e.forEach(function(e){return t.addPlugin(e)}),e.forEach(function(e){e.deferInit||t.initPlugin(e.name)}),this.fireEvent("plugins-registered",e),this}},{key:"addPlugin",value:function(e){var t=this;if(!e.name)throw new Error("Plugin does not have a name!");if(!e.instance)throw new Error("Plugin "+e.name+" does not have an instance property!");e.staticProps&&Object.keys(e.staticProps).forEach(function(n){t[n]=e.staticProps[n]});var n=e.instance;return Object.getOwnPropertyNames(c.Observer.prototype).forEach(function(e){n.prototype[e]=c.Observer.prototype[e]}),this[e.name]=new n(e.params||{},this),this.fireEvent("plugin-added",e.name),this}},{key:"initPlugin",value:function(e){if(!this[e])throw new Error("Plugin "+e+" has not been added yet!");return this.initialisedPluginList[e]&&this.destroyPlugin(e),this[e].init(),this.initialisedPluginList[e]=!0,this.fireEvent("plugin-initialised",e),this}},{key:"destroyPlugin",value:function(e){if(!this[e])throw new Error("Plugin "+e+" has not been added yet and cannot be destroyed!");if(!this.initialisedPluginList[e])throw new Error("Plugin "+e+" is not active and cannot be destroyed!");if("function"!=typeof this[e].destroy)throw new Error("Plugin "+e+" does not have a destroy function!");return this[e].destroy(),delete this.initialisedPluginList[e],this.fireEvent("plugin-destroyed",e),this}},{key:"destroyAllPlugins",value:function(){var e=this;Object.keys(this.initialisedPluginList).forEach(function(t){return e.destroyPlugin(t)})}},{key:"createDrawer",value:function(){var e=this;this.drawer=new this.Drawer(this.container,this.params),this.drawer.init(),this.fireEvent("drawer-created",this.drawer),this.params.responsive&&window.addEventListener("resize",this._onResize,!0),this.drawer.on("redraw",function(){e.drawBuffer(),e.drawer.progress(e.backend.getPlayedPercents())}),this.drawer.on("click",function(t,n){setTimeout(function(){return e.seekTo(n)},0)}),this.drawer.on("scroll",function(t){e.params.partialRender&&e.drawBuffer(),e.fireEvent("scroll",t)})}},{key:"createBackend",value:function(){var e=this;this.backend&&this.backend.destroy(),"AudioElement"==this.params.backend&&(this.params.backend="MediaElement"),"WebAudio"!=this.params.backend||this.Backend.prototype.supportsWebAudio.call(null)||(this.params.backend="MediaElement"),this.backend=new this.Backend(this.params),this.backend.init(),this.fireEvent("backend-created",this.backend),this.backend.on("finish",function(){return e.fireEvent("finish")}),this.backend.on("play",function(){return e.fireEvent("play")}),this.backend.on("pause",function(){return e.fireEvent("pause")}),this.backend.on("audioprocess",function(t){e.drawer.progress(e.backend.getPlayedPercents()),e.fireEvent("audioprocess",t)})}},{key:"createPeakCache",value:function(){this.params.partialRender&&(this.peakCache=new g.default)}},{key:"getDuration",value:function(){return this.backend.getDuration()}},{key:"getCurrentTime",value:function(){return this.backend.getCurrentTime()}},{key:"setCurrentTime",value:function(e){this.getDuration()>=e?this.seekTo(1):this.seekTo(e/this.getDuration())}},{key:"play",value:function(e,t){var n=this;this.fireEvent("interaction",function(){return n.play(e,t)}),this.backend.play(e,t)}},{key:"pause",value:function(){this.backend.isPaused()||this.backend.pause()}},{key:"playPause",value:function(){this.backend.isPaused()?this.play():this.pause()}},{key:"isPlaying",value:function(){return!this.backend.isPaused()}},{key:"skipBackward",value:function(e){this.skip(-e||-this.params.skipLength)}},{key:"skipForward",value:function(e){this.skip(e||this.params.skipLength)}},{key:"skip",value:function(e){var t=this.getDuration()||1,n=this.getCurrentTime()||0;n=Math.max(0,Math.min(t,n+(e||0))),this.seekAndCenter(n/t)}},{key:"seekAndCenter",value:function(e){this.seekTo(e),this.drawer.recenter(e)}},{key:"seekTo",value:function(e){var t=this;this.fireEvent("interaction",function(){return t.seekTo(e)});var n=this.backend.isPaused();n||this.backend.pause();var r=this.params.scrollParent;this.params.scrollParent=!1,this.backend.seekTo(e*this.getDuration()),this.drawer.progress(this.backend.getPlayedPercents()),n||this.backend.play(),this.params.scrollParent=r,this.fireEvent("seek",e)}},{key:"stop",value:function(){this.pause(),this.seekTo(0),this.drawer.progress(0)}},{key:"setVolume",value:function(e){this.backend.setVolume(e)}},{key:"getVolume",value:function(){return this.backend.getVolume()}},{key:"setPlaybackRate",value:function(e){this.backend.setPlaybackRate(e)}},{key:"getPlaybackRate",value:function(){return this.backend.getPlaybackRate()}},{key:"toggleMute",value:function(){this.setMute(!this.isMuted)}},{key:"setMute",value:function(e){e!==this.isMuted&&(e?(this.savedVolume=this.backend.getVolume(),this.backend.setVolume(0),this.isMuted=!0):(this.backend.setVolume(this.savedVolume),this.isMuted=!1))}},{key:"getMute",value:function(){return this.isMuted}},{key:"getFilters",value:function(){return this.backend.filters||[]}},{key:"toggleScroll",value:function(){this.params.scrollParent=!this.params.scrollParent,this.drawBuffer()}},{key:"toggleInteraction",value:function(){this.params.interact=!this.params.interact}},{key:"drawBuffer",value:function(){var e=Math.round(this.getDuration()*this.params.minPxPerSec*this.params.pixelRatio),t=this.drawer.getWidth(),n=e,r=this.drawer.getScrollX(),i=Math.max(r+t,n);this.params.fillParent&&(!this.params.scrollParent||e<t)&&(n=t,r=0,i=n);var a=void 0;if(this.params.partialRender){var o=this.peakCache.addRangeToPeakCache(n,r,i),s=void 0;for(s=0;s<o.length;s++)a=this.backend.getPeaks(n,o[s][0],o[s][1]),this.drawer.drawPeaks(a,n,o[s][0],o[s][1])}else a=this.backend.getPeaks(n,r,i),this.drawer.drawPeaks(a,n,r,i);this.fireEvent("redraw",a,n)}},{key:"zoom",value:function(e){e?(this.params.minPxPerSec=e,this.params.scrollParent=!0):(this.params.minPxPerSec=this.defaultParams.minPxPerSec,this.params.scrollParent=!1),this.drawBuffer(),this.drawer.progress(this.backend.getPlayedPercents()),this.drawer.recenter(this.getCurrentTime()/this.getDuration()),this.fireEvent("zoom",e)}},{key:"loadArrayBuffer",value:function(e){var t=this;this.decodeArrayBuffer(e,function(e){t.isDestroyed||t.loadDecodedBuffer(e)})}},{key:"loadDecodedBuffer",value:function(e){this.backend.load(e),this.drawBuffer(),this.fireEvent("ready"),this.isReady=!0}},{key:"loadBlob",value:function(e){var t=this,n=new FileReader;n.addEventListener("progress",function(e){return t.onProgress(e)}),n.addEventListener("load",function(e){return t.loadArrayBuffer(e.target.result)}),n.addEventListener("error",function(){return t.fireEvent("error","Error reading file")}),n.readAsArrayBuffer(e),this.empty()}},{key:"load",value:function(e,t,n){switch(this.empty(),this.isMuted=!1,this.params.backend){case"WebAudio":return this.loadBuffer(e,t);case"MediaElement":return this.loadMediaElement(e,t,n)}}},{key:"loadBuffer",value:function(e,t){var n=this,r=function(t){return t&&n.tmpEvents.push(n.once("ready",t)),n.getArrayBuffer(e,function(e){return n.loadArrayBuffer(e)})};if(!t)return r();this.backend.setPeaks(t),this.drawBuffer(),this.tmpEvents.push(this.once("interaction",r))}},{key:"loadMediaElement",value:function(e,t,n){var r=this,i=e;if("string"==typeof e)this.backend.load(i,this.mediaContainer,t,n);else{var a=e;this.backend.loadElt(a,t),i=a.src}this.tmpEvents.push(this.backend.once("canplay",function(){r.drawBuffer(),r.fireEvent("ready"),r.isReady=!0}),this.backend.once("error",function(e){return r.fireEvent("error",e)})),t&&this.backend.setPeaks(t),t&&!this.params.forceDecode||!this.backend.supportsWebAudio()||this.getArrayBuffer(i,function(e){r.decodeArrayBuffer(e,function(e){r.backend.buffer=e,r.backend.setPeaks(null),r.drawBuffer(),r.fireEvent("waveform-ready")})})}},{key:"decodeArrayBuffer",value:function(e,t){var n=this;this.arraybuffer=e,this.backend.decodeArrayBuffer(e,function(r){n.isDestroyed||n.arraybuffer!=e||(t(r),n.arraybuffer=null)},function(){return n.fireEvent("error","Error decoding audiobuffer")})}},{key:"getArrayBuffer",value:function(e,t){var n=this,r=c.ajax({url:e,responseType:"arraybuffer"});return this.currentAjax=r,this.tmpEvents.push(r.on("progress",function(e){n.onProgress(e)}),r.on("success",function(e,r){t(e),n.currentAjax=null}),r.on("error",function(e){n.fireEvent("error","XHR error: "+e.target.statusText),n.currentAjax=null})),r}},{key:"onProgress",value:function(e){var t=void 0;t=e.lengthComputable?e.loaded/e.total:e.loaded/(e.loaded+1e6),this.fireEvent("loading",Math.round(100*t),e.target)}},{key:"exportPCM",value:function(e,t,n,r){e=e||1024,r=r||0,t=t||1e4,n=n||!1;var i=this.backend.getPeaks(e,r),a=[].map.call(i,function(e){return Math.round(e*t)/t}),o=JSON.stringify(a);return n||window.open("data:application/json;charset=utf-8,"+encodeURIComponent(o)),o}},{key:"exportImage",value:function(e,t){return e||(e="image/png"),t||(t=1),this.drawer.getImage(e,t)}},{key:"cancelAjax",value:function(){this.currentAjax&&(this.currentAjax.xhr.abort(),this.currentAjax=null)}},{key:"clearTmpEvents",value:function(){this.tmpEvents.forEach(function(e){return e.un()})}},{key:"empty",value:function(){this.backend.isPaused()||(this.stop(),this.backend.disconnectSource()),this.cancelAjax(),this.clearTmpEvents(),this.drawer.progress(0),this.drawer.setWidth(0),this.drawer.drawPeaks({length:this.drawer.getWidth()},0)}},{key:"destroy",value:function(){this.destroyAllPlugins(),this.fireEvent("destroy"),this.cancelAjax(),this.clearTmpEvents(),this.unAll(),this.params.responsive&&window.removeEventListener("resize",this._onResize,!0),this.backend.destroy(),this.drawer.destroy(),this.isDestroyed=!0,this.arraybuffer=null}}]),t}(c.Observer));m.util=c,t.default=m,e.exports=t.default},function(e,t){e.exports=function(e,t,n){function r(){var c=Date.now()-s;c<t&&c>=0?i=setTimeout(r,t-c):(i=null,n||(u=e.apply(o,a),o=a=null))}var i,a,o,s,u;null==t&&(t=100);var c=function(){o=this,a=arguments,s=Date.now();var c=n&&!i;return i||(i=setTimeout(r,t)),c&&(u=e.apply(o,a),o=a=null),u};return c.clear=function(){i&&(clearTimeout(i),i=null)},c}}])})},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0}),t.WaveSurferPlayer=void 0;var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),a=n(0);t.WaveSurferPlayer=function(){function e(t){r(this,e),this.WAVE_SURFER=t,this.RECORDING_PATH=""}return i(e,[{key:"setRecordingPath",value:function(e){a.Logger.Debug("setRecordingPath:",e),this.RECORDING_PATH=e}},{key:"playPauseRecording",value:function(){a.Logger.Debug("PlayPauseRecording"),this.WAVE_SURFER.playPause()}},{key:"playRecording",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0;a.Logger.Debug("PlayRecording(seconds) "+e),this.speed(1),this.WAVE_SURFER.play(e)}},{key:"stopRecording",value:function(){a.Logger.Debug("Stop Recording"),this.WAVE_SURFER.stop(),this.speed(1)}},{key:"forwardRecording",value:function(){a.Logger.Debug("Forward Recording"),this.WAVE_SURFER.skipForward()}},{key:"backwardRecording",value:function(){a.Logger.Debug("Backward Recording"),this.WAVE_SURFER.skipBackward()}},{key:"speed",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:1;a.Logger.Debug("Speed:",e),this.WAVE_SURFER.setPlaybackRate(e)}},{key:"setVolume",value:function(e){e<0?e=0:e>1&&(e=1),a.Logger.Debug("setVolume : "+e),this.WAVE_SURFER.setVolume(e)}},{key:"muteRecording",value:function(){this.WAVE_SURFER.toggleMute()}},{key:"loadRecording",value:function(e){var t=this;this.RECORDING_PATH=e,a.Logger.Debug("Load Recording",this.RECORDING_PATH),this.WAVE_SURFER.empty(),this.WAVE_SURFER.load(this.RECORDING_PATH);var n=this;return new Promise(function(e,r){t.WAVE_SURFER.on("ready",function(){e(n.WAVE_SURFER.getDuration())}),t.WAVE_SURFER.on("error",function(){n.WAVE_SURFER.backend.buffer=null,r()})})}}]),e}()}])}); 

/***/ },
/* 1880 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _helpers = __webpack_require__(176);
	
	var _types = __webpack_require__(276);
	
	var _InputChip = _interopRequireDefault(__webpack_require__(695));
	
	var _ListInput = _interopRequireDefault(__webpack_require__(689));
	
	__webpack_require__(2515);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var AddressInput = function AddressInput(_ref) {
	  var label = _ref.label,
	      list = _ref.list,
	      selected = _ref.selected,
	      onSelect = _ref.onSelect,
	      onEdit = _ref.onEdit,
	      _onDelete = _ref.onDelete,
	      emptyListLabel = _ref.emptyListLabel;
	
	  var _useState = (0, _react.useState)(''),
	      _useState2 = _slicedToArray(_useState, 2),
	      value = _useState2[0],
	      setValue = _useState2[1];
	
	  var inputRef = (0, _react.useRef)();
	  var editRef = (0, _react.useRef)();
	
	  var selectContact = function selectContact(contact) {
	    if ((0, _helpers.isValidMail)(contact.account)) {
	      onSelect(contact);
	    } else {
	      onSelect(_objectSpread(_objectSpread({}, contact), {}, {
	        invalid: true
	      }));
	    }
	
	    setValue('');
	  };
	
	  var _useState3 = (0, _react.useState)(null),
	      _useState4 = _slicedToArray(_useState3, 2),
	      editing = _useState4[0],
	      setEditing = _useState4[1];
	
	  (0, _react.useEffect)(function () {
	    if (editing !== null) editRef.current.focus();
	  }, [editing]);
	
	  var editContact = function editContact(i, c) {
	    onEdit(i, _objectSpread(_objectSpread({}, c), {}, {
	      invalid: !(0, _helpers.isValidMail)(c.account)
	    }));
	    setEditing(null);
	  };
	
	  var blurEditing = function blurEditing(i, c) {
	    if (c.account === '') {
	      _onDelete(i);
	
	      setEditing(null);
	    }
	  };
	
	  var propagationWrapper = function propagationWrapper(e, action) {
	    e.stopPropagation();
	    action();
	  };
	
	  var inputID = 'uin-ain-input-' + label.replace(/\s+/g, '');
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-address-input",
	    onClick: function onClick() {
	      return inputRef.current.focus();
	    }
	  }, /*#__PURE__*/_react["default"].createElement("span", {
	    className: "uin-ain-label"
	  }, label, ":"), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "uin-ain-addresses"
	  }, selected.map(function (c, i) {
	    return editing === i ? /*#__PURE__*/_react["default"].createElement(_ListInput["default"], {
	      key: i,
	      id: inputID + i,
	      ref: editRef,
	      adjustable: true,
	      list: list,
	      value: c.account,
	      onClick: function onClick(e) {
	        return e.stopPropagation();
	      },
	      onChange: function onChange(e) {
	        return onEdit(i, _objectSpread(_objectSpread({}, c), {}, {
	          account: e.currentTarget.value
	        }));
	      },
	      onSelect: function onSelect(c) {
	        return editContact(i, c);
	      },
	      onBlur: function onBlur() {
	        return blurEditing(i, c);
	      },
	      emptyListLabel: emptyListLabel
	    }) : /*#__PURE__*/_react["default"].createElement(_InputChip["default"], {
	      key: i,
	      label: c.account,
	      interactive: true,
	      invalid: c.invalid,
	      onClick: function onClick(e) {
	        return propagationWrapper(e, function () {
	          return setEditing(i);
	        });
	      },
	      onDelete: function onDelete(e) {
	        return propagationWrapper(e, function () {
	          return _onDelete(i);
	        });
	      }
	    });
	  }), /*#__PURE__*/_react["default"].createElement(_ListInput["default"], {
	    id: inputID,
	    ref: inputRef,
	    list: list,
	    value: value,
	    onChange: function onChange(e) {
	      return setValue(e.currentTarget.value);
	    },
	    onSelect: selectContact,
	    emptyListLabel: emptyListLabel
	  })));
	};
	
	AddressInput.propTypes = {
	  label: _propTypes["default"].string.isRequired,
	  selected: _propTypes["default"].arrayOf(_types.contactType),
	  list: _propTypes["default"].arrayOf(_types.contactType),
	  onSelect: _propTypes["default"].func.isRequired,
	  onEdit: _propTypes["default"].func.isRequired,
	  onDelete: _propTypes["default"].func.isRequired
	};
	AddressInput.defaultProps = {
	  selected: []
	};
	var _default = AddressInput;
	exports["default"] = _default;

/***/ },
/* 1881 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _reactstrap = __webpack_require__(48);
	
	var _classNames2 = _interopRequireDefault(__webpack_require__(61));
	
	var _Button = _interopRequireDefault(__webpack_require__(97));
	
	__webpack_require__(2516);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var AdminModal = function AdminModal(_ref) {
	  var isOpen = _ref.isOpen,
	      toggle = _ref.toggle,
	      size = _ref.size,
	      title = _ref.title,
	      subtitle = _ref.subtitle,
	      bordered = _ref.bordered,
	      borderedFooter = _ref.borderedFooter,
	      largeHeader = _ref.largeHeader,
	      locked = _ref.locked,
	      className = _ref.className,
	      onConfirm = _ref.onConfirm,
	      confirmLabel = _ref.confirmLabel,
	      disabledConfirm = _ref.disabledConfirm,
	      onCancel = _ref.onCancel,
	      cancelLabel = _ref.cancelLabel,
	      onClose = _ref.onClose,
	      loading = _ref.loading,
	      children = _ref.children;
	  var classes = (0, _classNames2["default"])(_defineProperty({
	    'gcl-bordered': bordered
	  }, 'gcl-' + size, true));
	  return /*#__PURE__*/_react["default"].createElement(_reactstrap.Modal, {
	    isOpen: isOpen,
	    toggle: locked ? undefined : toggle,
	    className: "".concat(classes, " ").concat(className),
	    onClosed: onClose,
	    centered: true,
	    scrollable: true
	  }, /*#__PURE__*/_react["default"].createElement(_reactstrap.ModalHeader, {
	    className: largeHeader ? 'gcl-large' : '',
	    close: /*#__PURE__*/_react["default"].createElement("i", {
	      className: "gcl-icon close",
	      onClick: toggle
	    })
	  }, title, subtitle != null && /*#__PURE__*/_react["default"].createElement("h6", {
	    className: "gcl-subtitle"
	  }, subtitle)), /*#__PURE__*/_react["default"].createElement(_reactstrap.ModalBody, null, children), (onCancel || onConfirm) && /*#__PURE__*/_react["default"].createElement(_reactstrap.ModalFooter, {
	    className: borderedFooter ? 'gcl-bordered' : ''
	  }, onCancel && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
	    onClick: onCancel,
	    disabled: loading
	  }, cancelLabel), onConfirm && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
	    color: "primary",
	    onClick: onConfirm,
	    disabled: disabledConfirm,
	    loading: loading
	  }, confirmLabel)));
	};
	
	AdminModal.propTypes = {
	  isOpen: _propTypes["default"].bool.isRequired,
	  toggle: _propTypes["default"].func.isRequired,
	  size: _propTypes["default"].oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
	  title: _propTypes["default"].string.isRequired,
	  subtitle: _propTypes["default"].string,
	  bordered: _propTypes["default"].bool,
	  borderedFooter: _propTypes["default"].bool,
	  largeHeader: _propTypes["default"].bool,
	  locked: _propTypes["default"].bool,
	  className: _propTypes["default"].string,
	  onConfirm: _propTypes["default"].func,
	  confirmLabel: _propTypes["default"].string,
	  disabledConfirm: _propTypes["default"].bool,
	  onCancel: _propTypes["default"].func,
	  cancelLabel: _propTypes["default"].string,
	  onClose: _propTypes["default"].func
	};
	AdminModal.defaultProps = {
	  size: 'md',
	  bordered: false,
	  locked: false,
	  disabledConfirm: false,
	  className: ''
	};
	var _default = AdminModal;
	exports["default"] = _default;

/***/ },
/* 1882 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	__webpack_require__(2517);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var AgentButton = function AgentButton(_ref) {
	  var icon = _ref.icon,
	      id = _ref.id,
	      type = _ref.type,
	      disabled = _ref.disabled,
	      onClick = _ref.onClick,
	      children = _ref.children,
	      color = _ref.color;
	  return /*#__PURE__*/_react["default"].createElement("button", {
	    id: id,
	    onClick: onClick,
	    className: "gcl-agent-btn ".concat(type, " ").concat(color),
	    disabled: disabled
	  }, icon && /*#__PURE__*/_react["default"].createElement("div", {
	    className: 'gcl-agent-icon'
	  }, /*#__PURE__*/_react["default"].createElement("i", {
	    className: 'gcl-icon ' + icon
	  })), children);
	};
	
	AgentButton.propTypes = {
	  icon: _propTypes["default"].string,
	  id: _propTypes["default"].string,
	  type: _propTypes["default"].oneOf(['primary', 'secondary', 'tertiary']),
	  onClick: _propTypes["default"].func.isRequired,
	  disabled: _propTypes["default"].bool,
	  color: _propTypes["default"].oneOf(['blue', 'red', 'yellow', 'green', 'green v2', 'blue v2'])
	};
	AgentButton.defaultProps = {
	  type: 'primary',
	  onClick: function onClick() {
	    return console.warn('no function was assigned as prop');
	  },
	  color: 'blue'
	};
	var _default = AgentButton;
	exports["default"] = _default;

/***/ },
/* 1883 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _reactstrap = __webpack_require__(48);
	
	var _constants = __webpack_require__(275);
	
	__webpack_require__(2518);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var AgentState = function AgentState(_ref) {
	  var state = _ref.state,
	      label = _ref.label,
	      id = _ref.id;
	  var status = _constants.AGENT_STATUS_TO_ICON[state];
	  var icon = state === 'whatsappdialog' ? status[0] : status;
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: "glc-agentState ".concat(state),
	    "data-agent-status": state,
	    id: 'glc-agentState' + id
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "glc-agentState-icon"
	  }, /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon ".concat(icon, " small")
	  })), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "glc-agentState-label "
	  }, /*#__PURE__*/_react["default"].createElement("span", {
	    className: 'dots'
	  }, label)), label.length > 7 && /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
	    delay: {
	      show: 500,
	      hide: 100
	    },
	    placement: "top",
	    target: 'glc-agentState' + id,
	    boundariesElement: "window"
	  }, label));
	};
	
	AgentState.propTypes = {
	  id: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired,
	  label: _propTypes["default"].string,
	  state: _propTypes["default"].string
	};
	AgentState.defaultProps = {
	  label: ''
	};
	var _default = AgentState;
	exports["default"] = _default;

/***/ },
/* 1884 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	__webpack_require__(2519);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var AreasItem = function AreasItem(_ref) {
	  var type = _ref.type,
	      icon = _ref.icon,
	      title = _ref.title,
	      counter = _ref.counter;
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-areas-item"
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-areas-item-wraper"
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-areas-item-head"
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: 'gcl-areas-item-icon ' + type
	  }, icon)), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-areas-item-body"
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-title-areas"
	  }, title), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-content-counter-areas"
	  }, counter))));
	};
	
	AreasItem.propTypes = {
	  type: _propTypes["default"].oneOf(['agent', 'admin', 'inbound', 'outbound']),
	  icon: _propTypes["default"].string,
	  title: _propTypes["default"].string,
	  counter: _propTypes["default"].string
	};
	var _default = AreasItem;
	exports["default"] = _default;

/***/ },
/* 1885 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	__webpack_require__(2520);
	
	__webpack_require__(2521);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var AreasItemCounter = function AreasItemCounter(_ref) {
	  var type = _ref.type,
	      icon = _ref.icon,
	      title = _ref.title,
	      counter = _ref.counter;
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-areas-counter-item"
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-areas-counter-item-wraper"
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-areas-counter-item-head"
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: 'gcl-areas-counter-item-icon ' + type
	  }, icon)), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-areas-counter-item-body"
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-title-areas"
	  }, title)), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-areas-counter-item-counter"
	  }, counter)));
	};
	
	AreasItemCounter.propTypes = {
	  type: _propTypes["default"].oneOf(['msn', 'email', 'twitter']),
	  icon: _propTypes["default"].string,
	  title: _propTypes["default"].string,
	  counter: _propTypes["default"].string
	};
	var _default = AreasItemCounter;
	exports["default"] = _default;

/***/ },
/* 1886 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	__webpack_require__(2522);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var AudioIcon = function AudioIcon(props) {
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-audio-icon"
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-bar"
	  }), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-bar"
	  }), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-bar"
	  }), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-bar"
	  }));
	};
	
	AudioIcon.propTypes = {};
	var _default = AudioIcon;
	exports["default"] = _default;

/***/ },
/* 1887 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	__webpack_require__(2525);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var ButtonSwitch = function ButtonSwitch(_ref) {
	  var options = _ref.options,
	      selected = _ref.selected,
	      disabled = _ref.disabled,
	      onChange = _ref.onChange;
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-button-switch ".concat(disabled ? 'disabled' : '')
	  }, options.map(function (option, key) {
	    return /*#__PURE__*/_react["default"].createElement("div", {
	      tabIndex: key,
	      className: " gcl-button-switch-option ".concat(selected && selected.value === option.value ? 'selected' : '', "  ").concat(disabled ? 'disabled' : ''),
	      key: option.value,
	      onClick: function onClick() {
	        return !disabled ? onChange(option) : null;
	      }
	    }, option.label);
	  }));
	};
	
	ButtonSwitch.propTypes = {
	  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
	    label: _propTypes["default"].string,
	    value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
	  })),
	  selected: _propTypes["default"].shape({
	    label: _propTypes["default"].string,
	    value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
	  }),
	  onChange: _propTypes["default"].func.isRequired,
	  disabled: _propTypes["default"].bool
	};
	ButtonSwitch.defaultProps = {
	  options: [],
	  disabled: false
	};
	var _default = ButtonSwitch;
	exports["default"] = _default;

/***/ },
/* 1888 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	__webpack_require__(2528);
	
	var _excluded = ["onChange"];
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var CampaignIconOption = function CampaignIconOption(_ref) {
	  var onChange = _ref.onChange,
	      props = _objectWithoutProperties(_ref, _excluded);
	
	  var _useState = (0, _react.useState)(props.checked),
	      _useState2 = _slicedToArray(_useState, 2),
	      _checked = _useState2[0],
	      setChecked = _useState2[1];
	
	  (0, _react.useEffect)(function () {
	    _checked !== props.checked && setChecked(props.checked);
	  }, [props.checked]);
	
	  var changeHandler = function changeHandler(e) {
	    var val = e.target.value;
	    if (isNaN(val)) onChange(val);else onChange(parseInt(val, 10));
	  };
	
	  return /*#__PURE__*/_react["default"].createElement("label", {
	    "class": "campaign-icon-option ".concat(_checked ? 'checked' : '', " ").concat(props.campaignType)
	  }, /*#__PURE__*/_react["default"].createElement("input", {
	    type: "radio",
	    name: "rad1",
	    value: props.value,
	    checked: _checked,
	    onChange: changeHandler
	  }), /*#__PURE__*/_react["default"].createElement("i", {
	    className: 'gcl-icon ' + props.icon
	  }));
	};
	
	CampaignIconOption.propTypes = {
	  id: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired,
	  label: _propTypes["default"].string,
	  name: _propTypes["default"].string,
	  disabled: _propTypes["default"].bool,
	  onChange: _propTypes["default"].func.isRequired,
	  checked: _propTypes["default"].bool,
	  campaignType: _propTypes["default"].string,
	  icon: _propTypes["default"].string
	};
	var _default = CampaignIconOption;
	exports["default"] = _default;

/***/ },
/* 1889 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	__webpack_require__(2530);
	
	var _excluded = ["onChange", "onClick", "checked", "hover"];
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var CampaignItemOption = function CampaignItemOption(_ref) {
	  var onChange = _ref.onChange,
	      onClick = _ref.onClick,
	      checked = _ref.checked,
	      hover = _ref.hover,
	      props = _objectWithoutProperties(_ref, _excluded);
	
	  var changeHandler = function changeHandler(e) {
	    var val = e.target.value;
	    if (isNaN(val)) onChange(val);else onChange(parseInt(val, 10));
	  };
	
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: 'campaign-item-options ' + (hover ? 'hover_on' : ''),
	    onClick: onClick ? function () {
	      return onClick(props.value);
	    } : undefined
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "campaign-item-options__container ".concat(props.campaignType === 'associate' ? 'double_icon' : '')
	  }, /*#__PURE__*/_react["default"].createElement("label", {
	    className: "campaign-item-option ".concat(checked ? 'checked' : '', " ").concat(props.campaignType)
	  }, onChange && /*#__PURE__*/_react["default"].createElement("input", {
	    type: "radio",
	    name: "rad1",
	    value: props.value,
	    checked: checked,
	    onChange: changeHandler
	  }), /*#__PURE__*/_react["default"].createElement("i", {
	    className: props.campaignType === 'inbound' ? 'gcl-icon arrow-in' : 'gcl-icon arrow-out'
	  }), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "campaign-item-option-checked"
	  }, /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon selected"
	  }))), props.campaignType === 'associate' && /*#__PURE__*/_react["default"].createElement("label", {
	    className: "campaign-item-option ".concat(checked ? 'checked' : '', " inbound")
	  }, /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon arrow-in"
	  }), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "campaign-item-option-checked"
	  }, /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon selected"
	  })))), props.label && /*#__PURE__*/_react["default"].createElement("p", {
	    className: "campaign-item__label"
	  }, props.label));
	};
	
	CampaignItemOption.propTypes = {
	  id: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired,
	  label: _propTypes["default"].string,
	  name: _propTypes["default"].string,
	  disabled: _propTypes["default"].bool,
	  onChange: _propTypes["default"].func,
	  onClick: _propTypes["default"].func,
	  checked: _propTypes["default"].bool,
	  hover: _propTypes["default"].bool,
	  campaignType: _propTypes["default"].string
	};
	var _default = CampaignItemOption;
	exports["default"] = _default;

/***/ },
/* 1890 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _reactstrap = __webpack_require__(48);
	
	var _CampaignIcon = _interopRequireDefault(__webpack_require__(690));
	
	var _ButtonIcon = _interopRequireDefault(__webpack_require__(421));
	
	__webpack_require__(2531);
	
	__webpack_require__(2532);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var CampaignItem = function CampaignItem(props) {
	  var onPin = function onPin(e) {
	    e.stopPropagation();
	    props.onPin(!props.pin);
	  };
	
	  var onLoad = function onLoad(e) {
	    e.stopPropagation();
	    props.onLoad();
	  };
	
	  var onCancel = function onCancel(e) {
	    e.stopPropagation();
	    props.onCancel();
	  };
	
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-campitem ".concat(props.active ? 'active' : '', " ").concat(props.pin ? 'pin' : 'no-pin'),
	    onClick: props.onActive
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "glc-campitem-line ".concat(props.campaignType ? 'outbound' : 'inbound')
	  }), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "glc-campitem-body"
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "glc-campitem-dot ".concat(props.powerOn)
	  }), /*#__PURE__*/_react["default"].createElement(_CampaignIcon["default"], {
	    size: "sm",
	    type: props.campaignType,
	    frame: props.frame,
	    channel: props.channel
	  }), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "glc-campitem-data"
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-campitem-name"
	  }, props.label), props.showMessage && /*#__PURE__*/_react["default"].createElement("div", {
	    className: "glc-campitem-message"
	  }, props.message), props.showProgress && /*#__PURE__*/_react["default"].createElement("div", {
	    className: "glc-campitem-progress"
	  }, /*#__PURE__*/_react["default"].createElement(_ButtonIcon["default"], {
	    icon: "close-circle",
	    size: "small",
	    onClick: onCancel
	  }), /*#__PURE__*/_react["default"].createElement(_reactstrap.Progress, {
	    color: "secondary",
	    striped: true,
	    value: props.progress
	  })))), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "glc-campitem-pin"
	  }, /*#__PURE__*/_react["default"].createElement(_ButtonIcon["default"], {
	    icon: props.pin ? 'pin-in' : 'pin',
	    color: props.pin ? 'primary' : 'secondary',
	    onClick: onPin,
	    tooltip: props.pinTooltip
	  })), props.showLoadBtn && props.campaignType > 0 && /*#__PURE__*/_react["default"].createElement("div", {
	    className: "glc-campitem-load"
	  }, /*#__PURE__*/_react["default"].createElement(_ButtonIcon["default"], {
	    icon: "sc",
	    onClick: onLoad,
	    tooltip: props.loadTooltip
	  })));
	};
	
	CampaignItem.propTypes = {
	  active: _propTypes["default"].bool,
	  campaignType: _propTypes["default"].oneOf([0, 1]),
	  powerOn: _propTypes["default"].bool,
	  pin: _propTypes["default"].bool,
	  label: _propTypes["default"].string.isRequired,
	  message: _propTypes["default"].string,
	  showMessage: _propTypes["default"].bool,
	  showProgress: _propTypes["default"].bool,
	  progress: _propTypes["default"].number,
	  onActive: _propTypes["default"].func.isRequired,
	  onPin: _propTypes["default"].func.isRequired,
	  frame: _propTypes["default"].number,
	  showLoadBtn: _propTypes["default"].bool,
	  onCancel: _propTypes["default"].func.isRequired,
	  onLoad: _propTypes["default"].func.isRequired,
	  channel: _propTypes["default"].number,
	  pinTooltip: _propTypes["default"].string,
	  loadTooltip: _propTypes["default"].string
	};
	CampaignItem.defaultProps = {
	  active: false,
	  campaignType: 0,
	  powerOn: false,
	  pin: false,
	  label: '',
	  onActive: function onActive() {},
	  onPin: function onPin() {},
	  message: '',
	  showMessage: false,
	  showProgress: false,
	  progress: 0,
	  showLoadBtn: false,
	  onCancel: function onCancel() {},
	  onLoad: function onLoad() {},
	  channel: 0
	};
	var _default = CampaignItem;
	exports["default"] = _default;

/***/ },
/* 1891 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _Button = _interopRequireDefault(__webpack_require__(97));
	
	var _reactstrap = __webpack_require__(48);
	
	__webpack_require__(2533);
	
	__webpack_require__(2534);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var CardFormat = function CardFormat(props) {
	  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
	    id: props.id,
	    className: 'gcl-cards-format'
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-cards-wraper-format ".concat(props.check ? 'checked' : '')
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-head-cards-format"
	  }, props.title, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
	    className: "gcl-button-format",
	    color: "tertiary"
	  }, props.btnRigth)), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-cards-body-format gcl-cards-body-color ".concat(props.check ? 'checked' : '')
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    id: 'glc-content' + props.id,
	    className: "gcl-title-cards-format"
	  }, props.content), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-content-date-cards-format"
	  }, props.date), /*#__PURE__*/_react["default"].createElement("div", {
	    id: 'glc-body' + props.id,
	    className: "gcl-description-cards-format"
	  }, props.body)))), /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
	    className: "gcl-tooltip-format-card",
	    placement: "top",
	    target: 'glc-content' + props.id,
	    boundariesElement: "window"
	  }, props.content), /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
	    className: "gcl-tooltip-format-card",
	    placement: "top",
	    target: 'glc-body' + props.id,
	    boundariesElement: "window"
	  }, props.body));
	};
	
	CardFormat.defaultProps = {
	  id: '1',
	  tittle: '',
	  content: '',
	  btnRigth: '',
	  date: '',
	  body: '',
	  check: false,
	  iconActive: false,
	  icon: 'home',
	  iconLabel: ''
	};
	CardFormat.propTypes = {
	  id: _propTypes["default"].string,
	  title: _propTypes["default"].string,
	  icon: _propTypes["default"].string,
	  content: _propTypes["default"].string,
	  btnRigth: _propTypes["default"].object,
	  date: _propTypes["default"].string,
	  check: _propTypes["default"].bool,
	  iconActive: _propTypes["default"].bool,
	  iconLabel: _propTypes["default"].string,
	  body: _propTypes["default"].string
	};
	var _default = CardFormat;
	exports["default"] = _default;

/***/ },
/* 1892 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _Button = _interopRequireDefault(__webpack_require__(97));
	
	__webpack_require__(2535);
	
	__webpack_require__(2536);
	
	var _reactstrap = __webpack_require__(48);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var Cards = function Cards(props) {
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    id: props.id,
	    className: 'gcl-cards'
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-cards-wraper ".concat(props.check ? 'checked' : '')
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-head-cards"
	  }, props.title, props.iconActive && /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-head-cards-icon",
	    id: 'gcl-head-cards-icon-' + props.id
	  }, /*#__PURE__*/_react["default"].createElement("i", {
	    "class": 'gcl-icon ' + props.icon
	  }), /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
	    target: 'gcl-head-cards-icon-' + props.id,
	    placement: "top",
	    autohide: false,
	    trigger: 'hover'
	  }, props.iconLabel))), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-cards-body gcl-cards-body-color ".concat(props.check ? 'checked' : '')
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-title-cards"
	  }, props.content), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-content-date-cards"
	  }, props.date)), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-footer-cards"
	  }, props.btnLeft, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
	    color: "tertiary"
	  }, props.btnRigth))));
	};
	
	Cards.defaultProps = {
	  id: '1',
	  tittle: '',
	  content: '',
	  btnLeft: '',
	  btnRigth: '',
	  date: '',
	  check: false,
	  iconActive: false,
	  icon: 'home',
	  iconLabel: ''
	};
	Cards.propTypes = {
	  id: _propTypes["default"].string,
	  title: _propTypes["default"].string,
	  icon: _propTypes["default"].string,
	  content: _propTypes["default"].string,
	  btnLeft: _propTypes["default"].string,
	  btnRigth: _propTypes["default"].object,
	  date: _propTypes["default"].string,
	  check: _propTypes["default"].bool,
	  iconActive: _propTypes["default"].bool,
	  iconLabel: _propTypes["default"].string
	};
	var _default = Cards;
	exports["default"] = _default;

/***/ },
/* 1893 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	__webpack_require__(2537);
	
	__webpack_require__(2538);
	
	var _classNames = _interopRequireDefault(__webpack_require__(61));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var Chips = function Chips(props) {
	  var _useState = (0, _react.useState)(props.checked),
	      _useState2 = _slicedToArray(_useState, 2),
	      checked = _useState2[0],
	      setCheck = _useState2[1];
	
	  (0, _react.useEffect)(function () {
	    props.onChange(checked);
	  }, [checked]);
	  (0, _react.useEffect)(function () {
	    setCheck(props.checked);
	  }, [props.checked]);
	  var classes = (0, _classNames["default"])({
	    disabled: props.disabled,
	    checked: props.disabled ? false : props.checked
	  });
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: "glc-chips ".concat(classes, " ").concat(props.children[0].type === 'i' ? 'left' : ''),
	    onClick: function onClick() {
	      return !props.disabled && setCheck(!checked);
	    }
	  }, props.children);
	};
	
	Chips.propTypes = {
	  onChange: _propTypes["default"].func.isRequired,
	  disabled: _propTypes["default"].bool,
	  checked: _propTypes["default"].bool
	};
	Chips.defaultProps = {
	  onChange: function onChange() {
	    return console.warn('no function was assigned as prop');
	  }
	};
	var _default = Chips;
	exports["default"] = _default;

/***/ },
/* 1894 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _ColorPicker = _interopRequireDefault(__webpack_require__(691));
	
	var _hooks = __webpack_require__(110);
	
	__webpack_require__(2540);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var ColorPickerPopover = function ColorPickerPopover(_ref) {
	  var color = _ref.color,
	      _ref$color$rgb = _ref.color.rgb,
	      rgb = _ref$color$rgb === void 0 ? {} : _ref$color$rgb,
	      onChange = _ref.onChange,
	      label = _ref.label,
	      required = _ref.required;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      isOpen = _useState2[0],
	      setOpen = _useState2[1];
	
	  var wrapperRef = (0, _react.useRef)(null);
	  (0, _hooks.useOutsideClick)(wrapperRef, function () {
	    return setOpen(false);
	  });
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-color-picker-popover",
	    ref: wrapperRef
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-cp-container",
	    onClick: function onClick() {
	      return setOpen(function (o) {
	        return !o;
	      });
	    }
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: 'gcl-cp-toggle' + (isOpen ? ' open' : '')
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-color-swatch",
	    style: {
	      background: "rgb(".concat(rgb.r, ", ").concat(rgb.g, ", ").concat(rgb.b, ")")
	    }
	  }), /*#__PURE__*/_react["default"].createElement("i", {
	    className: 'gcl-icon ' + (isOpen ? 'chevron-up' : 'chevron')
	  })), /*#__PURE__*/_react["default"].createElement("span", {
	    className: "gcl-cp-label"
	  }, label, required && /*#__PURE__*/_react["default"].createElement("span", {
	    className: "required"
	  }, "*"))), /*#__PURE__*/_react["default"].createElement("div", {
	    className: 'gcl-fader' + (isOpen ? ' show' : '')
	  }, /*#__PURE__*/_react["default"].createElement(_ColorPicker["default"], {
	    color: color,
	    onChange: onChange
	  })));
	};
	
	ColorPickerPopover.propTypes = {
	  color: _propTypes["default"].object.isRequired,
	  onChange: _propTypes["default"].func.isRequired,
	  label: _propTypes["default"].string,
	  required: _propTypes["default"].bool
	};
	var _default = ColorPickerPopover;
	exports["default"] = _default;

/***/ },
/* 1895 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _utils = __webpack_require__(422);
	
	__webpack_require__(2541);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var Hue = function Hue(_ref) {
	  var onChange = _ref.onChange,
	      _ref$hsl = _ref.hsl,
	      hsl = _ref$hsl === void 0 ? {} : _ref$hsl;
	  (0, _react.useEffect)(function () {
	    return function () {
	      return unbindEventListeners();
	    };
	  }, []);
	  var container = (0, _react.useRef)(null);
	
	  var handleChange = function handleChange(e) {
	    var change = (0, _utils.calculateHueChange)(e, 'vertical', hsl, container.current);
	    change && typeof onChange === 'function' && onChange(change, e);
	  };
	
	  var handleMouseDown = function handleMouseDown(e) {
	    handleChange(e);
	    window.addEventListener('mousemove', handleChange);
	    window.addEventListener('mouseup', handleMouseUp);
	  };
	
	  var handleMouseUp = function handleMouseUp() {
	    unbindEventListeners();
	  };
	
	  function unbindEventListeners() {
	    window.removeEventListener('mousemove', handleChange);
	    window.removeEventListener('mouseup', handleMouseUp);
	  }
	
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-cp-hue"
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-cph-container",
	    ref: container,
	    onMouseDown: handleMouseDown,
	    onTouchMove: handleChange,
	    onTouchStart: handleChange
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-cph-pointer",
	    style: {
	      top: "".concat(-(hsl.h * 100 / 360) + 100, "%")
	    }
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-cph-slider",
	    style: {
	      backgroundColor: "hsl(".concat(hsl.h, ", 100%, 50%)")
	    }
	  }))));
	};
	
	var _default = Hue;
	exports["default"] = _default;

/***/ },
/* 1896 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _utils = __webpack_require__(422);
	
	__webpack_require__(2542);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var Saturation = function Saturation(_ref) {
	  var _ref$hsl = _ref.hsl,
	      hsl = _ref$hsl === void 0 ? {} : _ref$hsl,
	      _ref$hsv = _ref.hsv,
	      hsv = _ref$hsv === void 0 ? {} : _ref$hsv,
	      onChange = _ref.onChange;
	  var container = (0, _react.useRef)(null);
	  (0, _react.useEffect)(function () {
	    return function () {
	      return unbindEventListeners();
	    };
	  }, []);
	
	  function getContainerRenderWindow() {
	    var renderWindow = window;
	
	    while (!renderWindow.document.contains(container.current) && renderWindow.parent !== renderWindow) {
	      renderWindow = renderWindow.parent;
	    }
	
	    return renderWindow;
	  }
	
	  var handleChange = function handleChange(e) {
	    typeof onChange === 'function' && onChange((0, _utils.calculateSaturationChange)(e, hsl, container.current), e);
	  };
	
	  var handleMouseDown = function handleMouseDown(e) {
	    handleChange(e);
	    var renderWindow = getContainerRenderWindow();
	    renderWindow.addEventListener('mousemove', handleChange);
	    renderWindow.addEventListener('mouseup', handleMouseUp);
	  };
	
	  var handleMouseUp = function handleMouseUp() {
	    unbindEventListeners();
	  };
	
	  function unbindEventListeners() {
	    var renderWindow = getContainerRenderWindow();
	    renderWindow.removeEventListener('mousemove', handleChange);
	    renderWindow.removeEventListener('mouseup', handleMouseUp);
	  }
	
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-cp-saturation",
	    ref: container,
	    onMouseDown: handleMouseDown,
	    onTouchMove: handleChange,
	    onTouchStart: handleChange,
	    style: {
	      background: "hsl(".concat(hsl.h, ",100%, 50%)")
	    }
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "saturation-white"
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "saturation-black"
	  }), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-cps-pointer",
	    style: {
	      top: "".concat(-(hsv.v * 100) + 100, "%"),
	      left: "".concat(hsv.s * 100, "%")
	    }
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-cps-circle",
	    style: {
	      backgroundColor: "hsl(".concat(hsl.h, ", ").concat(hsl.s * 100, "%, ").concat(hsl.l * 100, "%)")
	    }
	  }))));
	};
	
	var _default = Saturation;
	exports["default"] = _default;

/***/ },
/* 1897 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.DatePicker = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _reactDatepicker = _interopRequireDefault(__webpack_require__(1941));
	
	var _dateFns = __webpack_require__(147);
	
	var _es = _interopRequireDefault(__webpack_require__(408));
	
	var _enUS = _interopRequireDefault(__webpack_require__(108));
	
	var _ptBR = _interopRequireDefault(__webpack_require__(657));
	
	var _Button = _interopRequireDefault(__webpack_require__(97));
	
	var _TimePicker = _interopRequireDefault(__webpack_require__(701));
	
	var _classNames2 = _interopRequireDefault(__webpack_require__(61));
	
	__webpack_require__(2598);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var locales = {
	  es: {
	    locale: _es["default"],
	    format: "d 'de' MMM",
	    formatWithTime: "d 'de' MMM, HH:mm",
	    formatWithYear: "d 'de' MMM 'de' yyyy",
	    formatWithYearAndTime: "d 'de' MMM 'de' yyyy, HH:mm"
	  },
	  en: {
	    locale: _enUS["default"],
	    format: 'MMM d',
	    formatWithTime: 'MMM d, HH:mm',
	    formatWithYear: 'MMM d, yyyy',
	    formatWithYearAndTime: 'MMM d yyyy, HH:mm'
	  },
	  pt: {
	    locale: _ptBR["default"],
	    format: "d 'de' MMM",
	    formatWithTime: "d 'de' MMM, HH:mm",
	    formatWithYear: "d 'de' MMM 'de' yyyy",
	    formatWithYearAndTime: "d 'de' MMM 'de' yyyy, HH:mm"
	  }
	};
	
	var formatToStringHelper = function formatToStringHelper(date, withTime, lang) {
	  return (0, _dateFns.isThisYear)(date) ? formatToString(date, withTime, lang) : formatToStringWithYear(date, withTime, lang);
	};
	
	var formatToString = function formatToString(date, withTime, lang) {
	  return (0, _dateFns.format)(date, withTime ? locales[lang].formatWithTime : locales[lang].format, {
	    locale: locales[lang].locale
	  });
	};
	
	var formatToStringWithYear = function formatToStringWithYear(date, withTime, lang) {
	  return (0, _dateFns.format)(date, withTime ? locales[lang].formatWithYearAndTime : locales[lang].formatWithYear, {
	    locale: locales[lang].locale
	  });
	};
	
	var DatePicker = function DatePicker(_ref) {
	  var startDate = _ref.startDate,
	      setStartDate = _ref.setStartDate,
	      selectRange = _ref.selectRange,
	      endDate = _ref.endDate,
	      setEndDate = _ref.setEndDate,
	      minDate = _ref.minDate,
	      maxDate = _ref.maxDate,
	      selectTime = _ref.selectTime,
	      _ref$monthsShown = _ref.monthsShown,
	      monthsShown = _ref$monthsShown === void 0 ? 2 : _ref$monthsShown,
	      labels = _ref.labels,
	      _ref$lang = _ref.lang,
	      lang = _ref$lang === void 0 ? 'es' : _ref$lang;
	
	  var setDate = function setDate(dates) {
	    if (selectRange) {
	      var _dates = _slicedToArray(dates, 2),
	          start = _dates[0],
	          end = _dates[1];
	
	      setStartDate(start ? (0, _dateFns.startOfDay)(start) : start);
	      setEndDate(end ? (0, _dateFns.endOfDay)(end) : end);
	    } else {
	      setStartDate(minDate ? (0, _dateFns.max)([minDate, dates]) : dates);
	    }
	  };
	
	  var endDateHandler = function endDateHandler(date) {
	    if (endDate == null) {
	      //which means user hasn't explicitly selected an end date
	      var newEnd = (0, _dateFns.set)(startDate, {
	        hours: (0, _dateFns.getHours)(date),
	        minutes: (0, _dateFns.getMinutes)(date)
	      });
	      if (newEnd < startDate) setEndDate(startDate);else setEndDate(newEnd);
	    } else {
	      setEndDate(date);
	    }
	  };
	
	  return /*#__PURE__*/_react["default"].createElement(_reactDatepicker["default"], {
	    inline: true,
	    calendarClassName: "inline",
	    locale: locales[lang].locale,
	    monthsShown: monthsShown,
	    selected: startDate,
	    startDate: startDate,
	    endDate: endDate,
	    selectsRange: selectRange,
	    minDate: minDate,
	    maxDate: maxDate,
	    onChange: setDate,
	    formatWeekDay: function formatWeekDay(weekday) {
	      return weekday.charAt(0).toUpperCase();
	    }
	  }, selectTime && /*#__PURE__*/_react["default"].createElement("div", {
	    className: "datepicker-timepicker"
	  }, /*#__PURE__*/_react["default"].createElement(_TimePicker["default"], {
	    label: labels.startTime,
	    time: startDate,
	    onChange: setStartDate,
	    min: minDate,
	    max: maxDate,
	    lang: lang
	  }), selectRange && /*#__PURE__*/_react["default"].createElement(_TimePicker["default"], {
	    label: labels.endTime,
	    time: endDate,
	    onChange: endDateHandler,
	    min: startDate,
	    max: maxDate,
	    lang: lang
	  })));
	};
	
	exports.DatePicker = DatePicker;
	
	var DatePickerHolder = function DatePickerHolder(_ref2) {
	  var _classNames;
	
	  var startDate = _ref2.startDate,
	      endDate = _ref2.endDate,
	      onClick = _ref2.onClick,
	      className = _ref2.className,
	      lang = _ref2.lang,
	      connector = _ref2.connector,
	      placeholder = _ref2.placeholder,
	      withTime = _ref2.withTime;
	
	  var dateLabel = function dateLabel() {
	    if (startDate === null) return placeholder;
	    if (endDate === null || (0, _dateFns.isSameDay)(startDate, endDate) && !withTime) return formatToStringHelper(startDate, withTime, lang);
	    if ((0, _dateFns.isSameYear)(startDate, endDate)) return "".concat(formatToString(startDate, withTime, lang), " ").concat(connector, " ").concat(formatToStringHelper(endDate, withTime, lang));
	    return "".concat(formatToStringWithYear(startDate, withTime, lang), " ").concat(connector, " ").concat(formatToStringWithYear(endDate, withTime, lang));
	  };
	
	  var classes = (0, _classNames2["default"])((_classNames = {}, _defineProperty(_classNames, className, className), _defineProperty(_classNames, "empty", startDate === null), _classNames));
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: 'sb-filter-toggle ' + classes,
	    onClick: onClick
	  }, dateLabel());
	};
	
	var DatePickerInput = function DatePickerInput(_ref3) {
	  var startDate = _ref3.startDate,
	      endDate = _ref3.endDate,
	      setStartDate = _ref3.setStartDate,
	      setEndDate = _ref3.setEndDate,
	      maxDate = _ref3.maxDate,
	      onClose = _ref3.onClose,
	      selectTime = _ref3.selectTime,
	      noButtons = _ref3.noButtons,
	      _ref3$lang = _ref3.lang,
	      lang = _ref3$lang === void 0 ? 'es' : _ref3$lang,
	      labels = _ref3.labels,
	      minDate = _ref3.minDate,
	      error = _ref3.error,
	      CustomInput = _ref3.CustomInput,
	      commitRequired = _ref3.commitRequired,
	      onCalendarClose = _ref3.onCalendarClose;
	  var dpRef = (0, _react.useRef)(null);
	  var disabledCommit = commitRequired && (error || endDate == null || startDate == null);
	
	  var setDate = function setDate(dates) {
	    var _dates2 = _slicedToArray(dates, 2),
	        start = _dates2[0],
	        end = _dates2[1];
	
	    setStartDate(start ? (0, _dateFns.startOfDay)(start) : start);
	    setEndDate(end ? (0, _dateFns.endOfDay)(end) : end);
	  };
	
	  var endDateHandler = function endDateHandler(date) {
	    if (endDate == null) {
	      //which means user hasn't explicitly selected an end date
	      var newEnd = (0, _dateFns.set)(startDate || (0, _dateFns.startOfToday)(), {
	        hours: (0, _dateFns.getHours)(date),
	        minutes: (0, _dateFns.getMinutes)(date)
	      });
	      if (newEnd < startDate) setEndDate(startDate);else setEndDate(newEnd);
	    } else {
	      setEndDate(date);
	    }
	  };
	
	  var clear = function clear() {
	    setStartDate(null);
	    setEndDate(null);
	  };
	
	  var close = function close() {
	    dpRef.current.setOpen(false);
	    onClose && onClose();
	  };
	
	  return /*#__PURE__*/_react["default"].createElement(_reactDatepicker["default"], {
	    ref: dpRef,
	    showPopperArrow: false,
	    locale: locales[lang].locale,
	    onCalendarClose: onCalendarClose,
	    monthsShown: 2 // showPreviousMonths={startDate == null}
	    ,
	    customInput: CustomInput ? /*#__PURE__*/_react["default"].createElement(CustomInput, {
	      startDate: startDate,
	      endDate: endDate,
	      lang: lang,
	      label: labels.label,
	      error: error,
	      connector: labels.connector,
	      withTime: selectTime
	    }) : /*#__PURE__*/_react["default"].createElement(DatePickerHolder, {
	      startDate: startDate,
	      endDate: endDate,
	      lang: lang,
	      connector: labels.connector,
	      withTime: selectTime
	    }),
	    selected: startDate,
	    startDate: startDate,
	    endDate: endDate,
	    placeholderText: labels.placeholder // selectsStart={startDate === null}
	    // selectsEnd={startDate !== null}
	    ,
	    selectsRange: true,
	    shouldCloseOnSelect: false,
	    maxDate: maxDate ? maxDate : (0, _dateFns.endOfToday)(),
	    minDate: minDate ? minDate : undefined,
	    onChange: setDate,
	    formatWeekDay: function formatWeekDay(weekday) {
	      return weekday.charAt(0).toUpperCase();
	    },
	    popperModifiers: {
	      preventOverflow: {
	        enabled: true
	      }
	    }
	  }, selectTime && /*#__PURE__*/_react["default"].createElement("div", {
	    className: "datepicker-timepicker ".concat(error ? 'datepicker-error_timepicker' : '')
	  }, /*#__PURE__*/_react["default"].createElement(_TimePicker["default"], {
	    error: error,
	    label: labels.startTime,
	    time: startDate,
	    onChange: setStartDate,
	    lang: lang
	  }), /*#__PURE__*/_react["default"].createElement(_TimePicker["default"], {
	    error: error,
	    label: labels.endTime,
	    time: endDate,
	    onChange: endDateHandler,
	    min: startDate,
	    max: maxDate ? maxDate : (0, _dateFns.endOfToday)(),
	    lang: lang
	  })), error && /*#__PURE__*/_react["default"].createElement("p", {
	    className: "datepicker-error_label"
	  }, labels.error), !noButtons && /*#__PURE__*/_react["default"].createElement("div", {
	    className: "datepicker-footer"
	  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
	    onClick: clear
	  }, labels.clear), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
	    color: "primary",
	    onClick: close,
	    disabled: disabledCommit
	  }, labels.save)));
	};
	
	DatePickerInput.propTypes = {
	  startDate: _propTypes["default"].instanceOf(Date),
	  endDate: _propTypes["default"].instanceOf(Date),
	  setStartDate: _propTypes["default"].func,
	  setEndDate: _propTypes["default"].func,
	  maxDate: _propTypes["default"].instanceOf(Date),
	  minDate: _propTypes["default"].instanceOf(Date),
	  onClose: _propTypes["default"].func,
	  selectTime: _propTypes["default"].bool,
	  noButtons: _propTypes["default"].bool,
	  lang: _propTypes["default"].string,
	  CustomInput: _propTypes["default"].any,
	  error: _propTypes["default"].any,
	  commitRequired: _propTypes["default"].bool,
	  labels: _propTypes["default"].shape({
	    placeholder: _propTypes["default"].string,
	    clear: _propTypes["default"].string,
	    save: _propTypes["default"].string,
	    connector: _propTypes["default"].string,
	    startTime: _propTypes["default"].string,
	    endTime: _propTypes["default"].string,
	    label: _propTypes["default"].string,
	    error: _propTypes["default"].string
	  })
	};
	var _default = DatePickerInput;
	exports["default"] = _default;

/***/ },
/* 1898 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _reactstrap = __webpack_require__(48);
	
	var _Button = _interopRequireDefault(__webpack_require__(97));
	
	__webpack_require__(2545);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var DialogBox = function DialogBox(_ref) {
	  var show = _ref.show,
	      id = _ref.id,
	      onCancel = _ref.onCancel,
	      onAccept = _ref.onAccept,
	      title = _ref.title,
	      content = _ref.content,
	      accept = _ref.accept,
	      cancel = _ref.cancel,
	      toggle = _ref.toggle;
	
	  var handleAccept = function handleAccept(e) {
	    if (onAccept) onAccept(e);
	    toggle && toggle();
	  };
	
	  var handleCancel = function handleCancel(e) {
	    if (onCancel) onCancel(e);
	    toggle && toggle();
	  };
	
	  return /*#__PURE__*/_react["default"].createElement(_reactstrap.Modal, {
	    id: id,
	    className: "gcl-dialog-box",
	    isOpen: show,
	    centered: true
	  }, /*#__PURE__*/_react["default"].createElement(_reactstrap.ModalBody, {
	    className: "gcl-dialog-box-wrapper"
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-dialog-box-body"
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-title-dialog-box"
	  }, title), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-content-dialog-box"
	  }, content))), /*#__PURE__*/_react["default"].createElement(_reactstrap.ModalFooter, null, cancel && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
	    color: "tertiary",
	    onClick: handleCancel
	  }, cancel), accept && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
	    color: "tertiary",
	    onClick: handleAccept
	  }, accept)));
	};
	
	DialogBox.propTypes = {
	  id: _propTypes["default"].string,
	  onCancel: _propTypes["default"].func,
	  onAccept: _propTypes["default"].func,
	  title: _propTypes["default"].string,
	  content: _propTypes["default"].string,
	  accept: _propTypes["default"].string,
	  cancel: _propTypes["default"].string,
	  show: _propTypes["default"].bool,
	  toggle: _propTypes["default"].func
	};
	var _default = DialogBox;
	exports["default"] = _default;

/***/ },
/* 1899 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	__webpack_require__(2546);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var DragNDropWrapper = function DragNDropWrapper(_ref) {
	  var children = _ref.children,
	      disabled = _ref.disabled,
	      relative = _ref.relative,
	      absolute = _ref.absolute,
	      onFileDrop = _ref.onFileDrop,
	      error = _ref.error,
	      errorMessage = _ref.errorMessage,
	      accept = _ref.accept;
	  var refDnd = (0, _react.useRef)(null);
	  var refInput = (0, _react.useRef)(null);
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      dragging = _useState2[0],
	      setDragging = _useState2[1];
	
	  var dragCounter = 0;
	
	  var openFileDialog = function openFileDialog(e) {
	    e.stopPropagation();
	    if (disabled) return;
	    refInput.current.click();
	  };
	
	  var handleDrag = function handleDrag(e) {
	    e.preventDefault();
	    e.stopPropagation();
	  };
	
	  var handleDragIn = function handleDragIn(e) {
	    e.preventDefault();
	    e.stopPropagation();
	    if (disabled) return;
	    dragCounter++;
	
	    if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
	      setDragging(true);
	    }
	  };
	
	  var handleDragOut = function handleDragOut(e) {
	    e.preventDefault();
	    e.stopPropagation();
	    if (disabled) return;
	    dragCounter--;
	    if (dragCounter > 0) return;
	    setDragging(false);
	  };
	
	  var handleDrop = function handleDrop(e) {
	    e.preventDefault();
	    e.stopPropagation();
	    if (disabled) return;
	    setDragging(false);
	
	    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
	      onFileDrop(e.dataTransfer.files);
	      e.dataTransfer.clearData();
	      dragCounter = 0;
	    }
	  };
	
	  (0, _react.useEffect)(function () {
	    var div = refDnd.current;
	    div.addEventListener('dragenter', handleDragIn);
	    div.addEventListener('dragleave', handleDragOut);
	    div.addEventListener('dragover', handleDrag);
	    div.addEventListener('drop', handleDrop);
	    dragCounter = 0;
	    return function () {
	      var div = refDnd.current;
	      div.removeEventListener('dragenter', handleDragIn);
	      div.removeEventListener('dragleave', handleDragOut);
	      div.removeEventListener('dragover', handleDrag);
	      div.removeEventListener('drop', handleDrop);
	    };
	  }, []);
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    ref: refDnd,
	    className: "gcl-dnd ".concat(relative ? 'relative' : '', " ").concat(absolute ? 'absolute' : '')
	  }, /*#__PURE__*/_react["default"].createElement("input", {
	    type: "file",
	    ref: refInput,
	    onChange: function onChange(e) {
	      return onFileDrop(e.target.files);
	    },
	    accept: accept
	  }), /*#__PURE__*/_react["default"].cloneElement(children, {
	    error: error,
	    errorMessage: errorMessage,
	    dragging: dragging,
	    openFileDialog: openFileDialog,
	    disabled: disabled
	  }));
	};
	
	DragNDropWrapper.propTypes = {
	  onFileDrop: _propTypes["default"].func.isRequired,
	  absolute: _propTypes["default"].bool,
	  relative: _propTypes["default"].bool,
	  error: _propTypes["default"].bool,
	  children: _propTypes["default"].object,
	  errorMessage: _propTypes["default"].string,
	  accept: _propTypes["default"].string,
	  disabled: _propTypes["default"].bool
	};
	var _default = DragNDropWrapper;
	exports["default"] = _default;

/***/ },
/* 1900 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactstrap = __webpack_require__(48);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	__webpack_require__(2547);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var DragNDrop = function DragNDrop(_ref) {
	  var disabled = _ref.disabled,
	      onFileDrop = _ref.onFileDrop,
	      onDragging = _ref.onDragging,
	      placeholder = _ref.placeholder,
	      loading = _ref.loading,
	      loadingMessage = _ref.loadingMessage;
	  var refDnd = (0, _react.useRef)(null);
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      dragging = _useState2[0],
	      setDragging = _useState2[1];
	
	  var dragCounter = 0;
	  (0, _react.useEffect)(function () {
	    onDragging && onDragging(dragging);
	  }, [dragging]);
	
	  var handleDrag = function handleDrag(e) {
	    e.preventDefault();
	    e.stopPropagation();
	    e.dataTransfer.effectAllowed = 'none';
	    e.dataTransfer.dropEffect = 'none';
	  };
	
	  var handleDragIn = function handleDragIn(e) {
	    e.preventDefault();
	    e.stopPropagation();
	    if (disabled || loading) return;
	    dragCounter++;
	
	    if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
	      setDragging(true);
	    }
	  };
	
	  var handleDragOut = function handleDragOut(e) {
	    e.preventDefault();
	    e.stopPropagation();
	    if (disabled || loading) return;
	    dragCounter--;
	    if (dragCounter > 0) return;
	    setDragging(false);
	  };
	
	  var handleDrop = function handleDrop(e) {
	    e.preventDefault();
	    e.stopPropagation();
	    if (disabled || loading) return;
	    setDragging(false);
	
	    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
	      onFileDrop(e.dataTransfer.files);
	      e.dataTransfer.clearData();
	      dragCounter = 0;
	    }
	  };
	
	  var handleWindowDrop = function handleWindowDrop(e) {
	    e.preventDefault();
	    e.stopPropagation();
	    setDragging(false);
	  };
	
	  var handleDivDrag = function handleDivDrag(e) {
	    e.preventDefault();
	    e.stopPropagation();
	
	    if (loading) {
	      e.dataTransfer.effectAllowed = 'none';
	      e.dataTransfer.dropEffect = 'none';
	    } else {
	      e.dataTransfer.effectAllowed = 'copy';
	      e.dataTransfer.dropEffect = 'copy';
	    }
	  };
	
	  (0, _react.useEffect)(function () {
	    window.addEventListener('dragenter', handleDragIn, {
	      passive: false
	    });
	    window.addEventListener('dragleave', handleDragOut, {
	      passive: false
	    });
	    window.addEventListener('dragover', handleDrag, {
	      passive: false
	    });
	    window.addEventListener('drop', handleWindowDrop, {
	      passive: false
	    });
	    var div = refDnd.current;
	    div.addEventListener('drop', handleDrop);
	    div.addEventListener('dragover', handleDivDrag);
	    dragCounter = 0;
	    return function () {
	      window.removeEventListener('dragenter', handleDragIn);
	      window.removeEventListener('dragleave', handleDragOut);
	      window.removeEventListener('dragover', handleDrag);
	      window.removeEventListener('drop', handleWindowDrop);
	      var div = refDnd.current;
	      div.removeEventListener('drop', handleDrop);
	      div.removeEventListener('dragover', handleDivDrag);
	    };
	  }, []);
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    ref: refDnd,
	    className: "gcl-dnd-main ".concat(dragging ? 'dragging' : '', " ").concat(loading ? 'loading' : '')
	  }, placeholder && !loading && placeholder, loading && /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-dnd-main-loader"
	  }, /*#__PURE__*/_react["default"].createElement(_reactstrap.Spinner, {
	    color: "primary"
	  }), loadingMessage && /*#__PURE__*/_react["default"].createElement("span", null, loadingMessage)));
	};
	
	DragNDrop.propTypes = {
	  onFileDrop: _propTypes["default"].func.isRequired,
	  onDragging: _propTypes["default"].func,
	  disabled: _propTypes["default"].bool,
	  placeholder: _propTypes["default"].string,
	  loading: _propTypes["default"].bool,
	  loadingMessage: _propTypes["default"].string
	};
	var _default = DragNDrop;
	exports["default"] = _default;

/***/ },
/* 1901 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _reactstrap = __webpack_require__(48);
	
	var _types = __webpack_require__(276);
	
	var _hooks = __webpack_require__(110);
	
	var _OutsideClickWrapper = _interopRequireDefault(__webpack_require__(219));
	
	__webpack_require__(2550);
	
	__webpack_require__(2551);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var Option = function Option(_ref) {
	  var option = _ref.option,
	      selection = _ref.selection,
	      setSelection = _ref.setSelection,
	      setOpen = _ref.setOpen,
	      tooltipInText = _ref.tooltipInText;
	  var refTooltip = (0, _react.useRef)();
	  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("li", {
	    className: "gcl-dropdown-item ".concat(option === selection ? '--selected' : ''),
	    key: option.id,
	    onClick: function onClick() {
	      setSelection(option);
	      setOpen(false);
	    }
	  }, tooltipInText ? /*#__PURE__*/_react["default"].createElement("span", {
	    className: "tooltipInText",
	    ref: option.tooltiptext ? refTooltip : null
	  }, option.text) : /*#__PURE__*/_react["default"].createElement("span", null, option.text), option.icon && /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon ".concat(option.icon),
	    ref: refTooltip
	  })), option.tooltiptext && /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
	    placement: "top",
	    target: refTooltip,
	    autohide: false,
	    trigger: 'hover'
	  }, option.tooltiptext));
	};
	
	var DropDown = function DropDown(_ref2) {
	  var options = _ref2.options,
	      onSelect = _ref2.onSelect,
	      title = _ref2.title,
	      tabIndex = _ref2.tabIndex,
	      error = _ref2.error,
	      errorMessage = _ref2.errorMessage,
	      autoTrigger = _ref2.autoTrigger,
	      defaultIndex = _ref2.defaultIndex,
	      disabled = _ref2.disabled,
	      noDefault = _ref2.noDefault,
	      required = _ref2.required,
	      _ref2$indexWillChange = _ref2.indexWillChange,
	      indexWillChange = _ref2$indexWillChange === void 0 ? false : _ref2$indexWillChange,
	      overflow = _ref2.overflow,
	      tooltipInText = _ref2.tooltipInText;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      isOpen = _useState2[0],
	      setOpen = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(autoTrigger),
	      _useState4 = _slicedToArray(_useState3, 2),
	      trigger = _useState4[0],
	      setTrigger = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(undefined),
	      _useState6 = _slicedToArray(_useState5, 2),
	      selection = _useState6[0],
	      setSelection = _useState6[1];
	
	  var toggle = function toggle() {
	    return setOpen(!isOpen);
	  };
	
	  (0, _react.useEffect)(function () {
	    trigger && onSelect(selection);
	  }, [selection]);
	  (0, _react.useEffect)(function () {
	    if (noDefault) return;
	    var selected = defaultIndex && options[defaultIndex] ? options[defaultIndex] : options[0];
	    setSelection(selected);
	  }, [JSON.stringify(options)]);
	  (0, _react.useEffect)(function () {
	    if (noDefault) return;
	
	    if (indexWillChange) {
	      var selected = defaultIndex && options[defaultIndex] ? options[defaultIndex] : options[0];
	      setSelection(selected);
	      setTrigger(false);
	    }
	  }, [defaultIndex]);
	  /* const ref = useRef();
	  useEffect(() => {
	  	if (overflow) {
	  		const onScroll = (event) => {
	  			console.log('scroll', ref.current, ref.current.refs)
	  			if (ref.current && !ref.current.contains(event.target)) {
	  				setOpen(false);
	  			}
	  		}
	  		document.addEventListener('scroll', onScroll, true);
	  		return () => document.removeEventListener('scroll', onScroll, true);
	  	}
	  }, [overflow]); */
	
	  return /*#__PURE__*/_react["default"].createElement(_reactstrap.Dropdown, {
	    isOpen: isOpen,
	    toggle: toggle,
	    disabled: disabled,
	    className: "gcl-dropdown ".concat(disabled ? '--disabled' : '', " ").concat(error ? '--error' : '', " ").concat(isOpen ? '--focus' : '')
	  }, /*#__PURE__*/_react["default"].createElement(_reactstrap.DropdownToggle, {
	    tabIndex: tabIndex,
	    className: "gcl-dropdown-header",
	    tag: "div",
	    onClick: function onClick() {
	      toggle();
	      setTrigger(true);
	    }
	  }, title ? /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-dropdown-header__title"
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-dropdown-header__placeholder ".concat(selection || isOpen ? '--selected' : '', " ").concat(error ? '--error' : '')
	  }, title, required && /*#__PURE__*/_react["default"].createElement("span", {
	    className: "required"
	  }, "*")), selection && /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-dropdown-header__selected ".concat(error ? '--error' : '')
	  }, selection.text)) : /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-dropdown-header__value ".concat(error ? '--error' : '')
	  }, selection && selection.text), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-dropdown-header__icon ".concat(selection && title ? '--selected' : '', " ").concat(error ? '--error' : '')
	  }, isOpen ? /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon chevron-up"
	  }) : /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon chevron"
	  }))), /*#__PURE__*/_react["default"].createElement(_reactstrap.DropdownMenu, {
	    className: 'gcl-dropdown-list gcl-fader' + (overflow ? ' fixed' : ''),
	    flip: false,
	    positionFixed: overflow,
	    modifiers: overflow ? {
	      preventOverflow: {
	        boundariesElement: 'window'
	      }
	    } : {
	      preventOverflow: {
	        enabled: false
	      },
	      hide: {
	        enabled: false
	      }
	    }
	  }, options.map(function (option, i) {
	    return /*#__PURE__*/_react["default"].createElement(Option, {
	      key: i,
	      option: option,
	      selection: selection,
	      setSelection: setSelection,
	      setOpen: setOpen,
	      tooltipInText: tooltipInText
	    });
	  })), error && errorMessage && /*#__PURE__*/_react["default"].createElement("span", {
	    className: "gcl-dropdown-error"
	  }, errorMessage));
	};
	
	DropDown.propTypes = {
	  options: _propTypes["default"].arrayOf(_types.dropdownType).isRequired,
	  onSelect: _propTypes["default"].func.isRequired,
	  title: _propTypes["default"].string,
	  tabIndex: _propTypes["default"].number,
	  error: _propTypes["default"].bool,
	  errorMessage: _propTypes["default"].string,
	  autoTrigger: _propTypes["default"].bool,
	  defaultIndex: _propTypes["default"].number,
	  disabled: _propTypes["default"].bool,
	  overflow: _propTypes["default"].bool
	};
	var _default = DropDown;
	exports["default"] = _default;

/***/ },
/* 1902 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.TextFilter = exports.RangeFilter = exports.ListFilter = exports.ItemFilter = exports.CounterFilter = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _reactstrap = __webpack_require__(48);
	
	var _Slider = _interopRequireDefault(__webpack_require__(700));
	
	var _Button = _interopRequireDefault(__webpack_require__(97));
	
	var _Counter = _interopRequireDefault(__webpack_require__(692));
	
	var _FilterInput = _interopRequireDefault(__webpack_require__(696));
	
	var _LabelInput = _interopRequireDefault(__webpack_require__(697));
	
	var _Checkbox = _interopRequireDefault(__webpack_require__(274));
	
	var _RadioButton = _interopRequireDefault(__webpack_require__(699));
	
	var _classNames2 = _interopRequireDefault(__webpack_require__(61));
	
	var _formatters = __webpack_require__(427);
	
	var _helpers = __webpack_require__(176);
	
	__webpack_require__(2552);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var RangeInput = function RangeInput(_ref) {
	  var formatFn = _ref.formatFn,
	      value = _ref.value,
	      onChange = _ref.onChange,
	      onStep = _ref.onStep;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      editing = _useState2[0],
	      setEditing = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(function () {
	    return formatFn(value);
	  }),
	      _useState4 = _slicedToArray(_useState3, 2),
	      internalVal = _useState4[0],
	      setInternalVal = _useState4[1];
	
	  (0, _react.useEffect)(function () {
	    setInternalVal(formatFn(value));
	  }, [value, formatFn]);
	  var changePending = (0, _react.useRef)(false);
	
	  var handleChange = function handleChange(e) {
	    if (!isNaN(e.target.value.replaceAll(':', ''))) {
	      setInternalVal(e.target.value);
	      changePending.current = true;
	    }
	  };
	
	  var blur = function blur() {
	    setEditing(false);
	
	    if (changePending.current) {
	      onChange(internalVal);
	      changePending.current = false;
	    }
	  };
	
	  var inputRef = (0, _react.useRef)(null);
	
	  var onKeyDown = function onKeyDown(e) {
	    if (e.key === 'ArrowUp') {
	      //Arrow Up
	      onStep(value + 1);
	      e.preventDefault();
	    } else if (e.key === 'ArrowDown') {
	      //Arrow Down
	      onStep(value - 1);
	      e.preventDefault();
	    } else if (e.key === 'Enter') {
	      inputRef.current.blur();
	    }
	  };
	
	  return /*#__PURE__*/_react["default"].createElement("input", {
	    ref: inputRef,
	    type: "text",
	    className: "sb-rf-input",
	    value: editing ? internalVal : formatFn(value),
	    onChange: handleChange,
	    onKeyDown: onKeyDown,
	    onFocus: function onFocus() {
	      return setEditing(true);
	    },
	    onBlur: blur
	  });
	};
	
	var RangeFilter = function RangeFilter(_ref2) {
	  var type = _ref2.type,
	      value = _ref2.value,
	      onChange = _ref2.onChange,
	      min = _ref2.min,
	      max = _ref2.max,
	      onSave = _ref2.onSave,
	      saveLabel = _ref2.saveLabel,
	      resetLabel = _ref2.resetLabel;
	
	  var _value = _slicedToArray(value, 2),
	      low = _value[0],
	      high = _value[1];
	
	  var lowLimit = low || min;
	  var highLimit = high || max;
	  var formatVal = (0, _react.useCallback)(function (val) {
	    if (type === 'time') {
	      return (0, _formatters.formatTime)(val);
	    } else {
	      return val;
	    }
	  }, [type]);
	
	  var changeLowValue = function changeLowValue(val) {
	    return onChange([Math.min(Math.max(val, min), highLimit - 1), highLimit]);
	  };
	
	  var changeHighValue = function changeHighValue(val) {
	    return onChange([lowLimit, Math.max(Math.min(val, max), lowLimit + 1)]);
	  };
	
	  var handleChange = function handleChange(val, fn, defaultVal) {
	    if (val) {
	      if (type === 'time') {
	        if ((0, _helpers.isValidTime)(val)) {
	          fn((0, _helpers.getTime)(val));
	        }
	      } else {
	        fn(parseInt(val, 10));
	      }
	    } else {
	      fn(defaultVal);
	    }
	  };
	
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: "sb-filter-body sb-range-filter"
	  }, /*#__PURE__*/_react["default"].createElement("header", null, /*#__PURE__*/_react["default"].createElement(RangeInput, {
	    formatFn: formatVal,
	    value: lowLimit,
	    onChange: function onChange(v) {
	      return handleChange(v, changeLowValue, min);
	    },
	    onStep: changeLowValue
	  }), /*#__PURE__*/_react["default"].createElement("span", null, "-"), /*#__PURE__*/_react["default"].createElement(RangeInput, {
	    formatFn: formatVal,
	    value: highLimit,
	    onChange: function onChange(v) {
	      return handleChange(v, changeHighValue, max);
	    },
	    onStep: changeHighValue
	  })), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "sb-filter-main"
	  }, /*#__PURE__*/_react["default"].createElement(_Slider["default"], {
	    value: [lowLimit, highLimit],
	    onChange: onChange,
	    min: min,
	    max: max
	  })), /*#__PURE__*/_react["default"].createElement("footer", null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
	    onClick: function onClick() {
	      return onChange(undefined);
	    }
	  }, resetLabel), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
	    color: "primary",
	    onClick: onSave
	  }, saveLabel)));
	};
	
	exports.RangeFilter = RangeFilter;
	RangeFilter.propTypes = {
	  type: _propTypes["default"].oneOf(['time', 'integer']),
	  value: _propTypes["default"].arrayOf(_propTypes["default"].number),
	  onChange: _propTypes["default"].func.isRequired,
	  min: _propTypes["default"].number,
	  max: _propTypes["default"].number,
	  onSave: _propTypes["default"].func,
	  saveLabel: _propTypes["default"].string,
	  resetLabel: _propTypes["default"].string
	};
	RangeFilter.defaultProps = {
	  type: 'time',
	  value: []
	};
	
	var label = function label(v) {
	  return _typeof(v) === 'object' ? v.label : '' + v;
	};
	
	var val = function val(v) {
	  return _typeof(v) === 'object' ? v.value : v;
	};
	
	var hasMoreThan = function hasMoreThan(arr, val, limit) {
	  var count = 0;
	
	  for (var i = 0; i < arr.length; i++) {
	    if (count > limit) return true;
	    if (label(arr[i]).toLowerCase().includes(val.toLowerCase())) count++;
	  }
	
	  return false;
	};
	
	var ListFilter = function ListFilter(_ref3) {
	  var id = _ref3.id,
	      placeholder = _ref3.placeholder,
	      list = _ref3.list,
	      values = _ref3.values,
	      value = _ref3.value,
	      type = _ref3.type,
	      search = _ref3.search,
	      smart = _ref3.smart,
	      selectAll = _ref3.selectAll,
	      noReset = _ref3.noReset,
	      noButtons = _ref3.noButtons,
	      _onChange = _ref3.onChange,
	      onSave = _ref3.onSave,
	      labels = _ref3.labels;
	  var dynamicSearch = smart && list && list.length > 50;
	  var hasSelectAll = selectAll && type === 'checks';
	  var hasHeader = search || smart || hasSelectAll;
	
	  var _useState5 = (0, _react.useState)(dynamicSearch ? [] : list),
	      _useState6 = _slicedToArray(_useState5, 2),
	      filteredList = _useState6[0],
	      setFilteredList = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(''),
	      _useState8 = _slicedToArray(_useState7, 2),
	      searchValue = _useState8[0],
	      setSearchValue = _useState8[1];
	
	  (0, _react.useEffect)(function () {
	    if (smart && list && list.length > 50) {
	      if (searchValue.length > 2) {
	        if (hasMoreThan(list, searchValue, 50)) setFilteredList(list.filter(function (v) {
	          return label(v).toLowerCase() === searchValue.toLowerCase();
	        }));else setFilteredList(list.filter(function (v) {
	          return label(v).toLowerCase().includes(searchValue.toLowerCase());
	        }));
	      } else {
	        if (hasMoreThan(list, searchValue, 10)) setFilteredList(list.filter(function (v) {
	          return label(v).toLowerCase() === searchValue.toLowerCase();
	        }));else setFilteredList(list.filter(function (v) {
	          return label(v).toLowerCase().includes(searchValue.toLowerCase());
	        }));
	      }
	    }
	  }, [smart, searchValue, list]);
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: 'sb-filter-body sb-list-filter' + (search || smart ? ' sb-search-filter' : '') + (noButtons ? ' no-buttons' : ''),
	    id: id
	  }, hasHeader && /*#__PURE__*/_react["default"].createElement("header", null, dynamicSearch ? /*#__PURE__*/_react["default"].createElement(_FilterInput["default"], {
	    placeholder: placeholder,
	    customFilter: true,
	    onChange: setSearchValue
	  }) : (smart || search) && /*#__PURE__*/_react["default"].createElement(_FilterInput["default"], {
	    placeholder: placeholder,
	    data: list,
	    filterBy: "label",
	    onChange: setFilteredList,
	    ignoreCase: true
	  }), hasSelectAll && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
	    color: "tertiary",
	    onClick: function onClick() {
	      return _onChange(list.map(function (v) {
	        return val(v);
	      }));
	    }
	  }, labels.selectAll)), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "sb-filter-main"
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "sbf-list-filter-scroll"
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "sbf-list-filter-list"
	  }, dynamicSearch && searchValue === '' ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, values.map(function (v, i) {
	    return /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
	      key: val(v),
	      id: id + '-chk-' + i,
	      caption: label(v),
	      checked: true,
	      onChange: function onChange() {
	        return _onChange(values.filter(function (e) {
	          return e !== val(v);
	        }));
	      },
	      tooltip: label(v).length > 23 && label(v)
	    });
	  })) : filteredList.map(function (v, i) {
	    return type === 'checks' ? /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
	      key: i,
	      id: id + '-chk-' + i,
	      caption: label(v),
	      checked: values.includes(val(v)),
	      onChange: function onChange(checked) {
	        return _onChange(checked ? [].concat(_toConsumableArray(values), [val(v)]) : values.filter(function (e) {
	          return e !== val(v);
	        }));
	      },
	      tooltip: label(v).length > 23 && label(v)
	    }) : /*#__PURE__*/_react["default"].createElement(_RadioButton["default"], {
	      key: i,
	      id: id + '-rdb-' + i,
	      name: id,
	      label: label(v),
	      value: val(v),
	      checked: value === val(v),
	      onChange: _onChange,
	      tooltip: label(v).length > 23 && label(v)
	    });
	  })))), !noButtons && /*#__PURE__*/_react["default"].createElement("footer", null, !noReset && labels.reset != null && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
	    onClick: function onClick() {
	      return _onChange(type === 'checks' ? [] : null);
	    }
	  }, labels.reset), labels.save != null && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
	    color: "primary",
	    onClick: onSave
	  }, labels.save)));
	};
	
	exports.ListFilter = ListFilter;
	ListFilter.propTypes = {
	  id: _propTypes["default"].string.isRequired,
	  placeholder: _propTypes["default"].string,
	  list: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].shape({
	    label: _propTypes["default"].string,
	    value: _propTypes["default"].any
	  })])),
	  values: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])),
	  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  search: _propTypes["default"].bool,
	  smart: _propTypes["default"].bool,
	  selectAll: _propTypes["default"].bool,
	  noReset: _propTypes["default"].bool,
	  noButtons: _propTypes["default"].bool,
	  type: _propTypes["default"].oneOf(['checks', 'radios']),
	  onChange: _propTypes["default"].func.isRequired,
	  onSave: _propTypes["default"].func,
	  labels: _propTypes["default"].shape({
	    reset: _propTypes["default"].string,
	    save: _propTypes["default"].string,
	    selectAll: _propTypes["default"].string
	  })
	};
	ListFilter.defaultProps = {
	  list: [],
	  values: [],
	  value: null,
	  search: false,
	  smart: false,
	  selectAll: false,
	  noReset: false,
	  noButtons: false,
	  type: 'checks',
	  labels: {}
	};
	
	var TextFilter = function TextFilter(_ref4) {
	  var placeholder = _ref4.placeholder,
	      value = _ref4.value,
	      onChange = _ref4.onChange,
	      onSave = _ref4.onSave,
	      saveLabel = _ref4.saveLabel,
	      minValLength = _ref4.minValLength,
	      numeric = _ref4.numeric;
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: "sb-filter-body sb-text-filter"
	  }, /*#__PURE__*/_react["default"].createElement("header", null, /*#__PURE__*/_react["default"].createElement(_LabelInput["default"], {
	    value: value,
	    onChange: onChange,
	    placeholder: placeholder,
	    label: placeholder,
	    onlyNumbers: numeric
	  })), /*#__PURE__*/_react["default"].createElement("footer", null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
	    color: "primary",
	    onClick: onSave,
	    disabled: minValLength != null && value.length < minValLength
	  }, saveLabel)));
	};
	
	exports.TextFilter = TextFilter;
	TextFilter.propTypes = {
	  value: _propTypes["default"].string,
	  onChange: _propTypes["default"].func.isRequired,
	  onSave: _propTypes["default"].func,
	  placeholder: _propTypes["default"].string,
	  saveLabel: _propTypes["default"].string
	};
	TextFilter.defaultProps = {
	  value: ''
	};
	
	var ItemFilter = function ItemFilter(_ref5) {
	  var placeholder = _ref5.placeholder,
	      values = _ref5.values,
	      onChange = _ref5.onChange,
	      onSave = _ref5.onSave,
	      resetLabel = _ref5.resetLabel,
	      saveLabel = _ref5.saveLabel,
	      noReset = _ref5.noReset,
	      minValLength = _ref5.minValLength,
	      numeric = _ref5.numeric;
	
	  var _useState9 = (0, _react.useState)(''),
	      _useState10 = _slicedToArray(_useState9, 2),
	      value = _useState10[0],
	      setValue = _useState10[1];
	
	  var addValue = function addValue() {
	    onChange([].concat(_toConsumableArray(values), [value]));
	    setValue('');
	  };
	
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: "sb-filter-body sb-item-filter"
	  }, /*#__PURE__*/_react["default"].createElement("header", null, /*#__PURE__*/_react["default"].createElement(_LabelInput["default"], {
	    value: value,
	    onChange: setValue,
	    placeholder: placeholder,
	    label: placeholder,
	    onlyNumbers: numeric
	  }), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
	    color: "primary",
	    onClick: addValue,
	    disabled: minValLength != null ? value.length < minValLength : value.length === 0
	  }, /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon larger plus"
	  }))), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "sb-filter-main"
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "sbf-list-filter-scroll"
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "sbf-list-filter-list"
	  }, values.map(function (v) {
	    return /*#__PURE__*/_react["default"].createElement("div", {
	      className: "sbif-item"
	    }, v, /*#__PURE__*/_react["default"].createElement("i", {
	      className: "gcl-icon clickable close-circle",
	      onClick: function onClick() {
	        return onChange(values.filter(function (l) {
	          return l !== v;
	        }));
	      }
	    }));
	  })))), /*#__PURE__*/_react["default"].createElement("footer", null, !noReset && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
	    onClick: function onClick() {
	      return onChange([]);
	    }
	  }, resetLabel), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
	    color: "primary",
	    onClick: onSave
	  }, saveLabel)));
	};
	
	exports.ItemFilter = ItemFilter;
	ItemFilter.propTypes = {
	  values: _propTypes["default"].array,
	  onChange: _propTypes["default"].func.isRequired,
	  onSave: _propTypes["default"].func,
	  placeholder: _propTypes["default"].string,
	  saveLabel: _propTypes["default"].string,
	  resetLabel: _propTypes["default"].string,
	  noReset: _propTypes["default"].bool,
	  minValLength: _propTypes["default"].number,
	  numeric: _propTypes["default"].bool
	};
	ItemFilter.defaultProps = {
	  values: []
	};
	
	var CounterFilter = function CounterFilter(_ref6) {
	  var value = _ref6.value,
	      onChange = _ref6.onChange,
	      step = _ref6.step,
	      min = _ref6.min,
	      max = _ref6.max,
	      onSave = _ref6.onSave,
	      noButtons = _ref6.noButtons,
	      message = _ref6.message,
	      saveLabel = _ref6.saveLabel,
	      resetLabel = _ref6.resetLabel;
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: "sb-filter-body sb-counter-filter"
	  }, /*#__PURE__*/_react["default"].createElement("header", {
	    lang: "en"
	  }, message), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "sb-filter-main"
	  }, /*#__PURE__*/_react["default"].createElement(_Counter["default"], {
	    start: value,
	    min: min,
	    max: max,
	    step: step,
	    onChange: onChange
	  })), !noButtons && /*#__PURE__*/_react["default"].createElement("footer", null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
	    onClick: function onClick() {
	      return onChange(undefined);
	    }
	  }, resetLabel), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
	    color: "primary",
	    onClick: onSave
	  }, saveLabel)));
	};
	
	exports.CounterFilter = CounterFilter;
	CounterFilter.propTypes = {
	  value: _propTypes["default"].number,
	  onChange: _propTypes["default"].func.isRequired,
	  step: _propTypes["default"].number,
	  min: _propTypes["default"].number,
	  max: _propTypes["default"].number,
	  onSave: _propTypes["default"].func,
	  noButtons: _propTypes["default"].bool,
	  message: _propTypes["default"].string,
	  saveLabel: _propTypes["default"].string,
	  resetLabel: _propTypes["default"].string
	};
	
	var FilterPopover = function FilterPopover(_ref7) {
	  var _classNames;
	
	  var id = _ref7.id,
	      placeholder = _ref7.placeholder,
	      valueLabel = _ref7.valueLabel,
	      labelPlural = _ref7.labelPlural,
	      value = _ref7.value,
	      className = _ref7.className,
	      onSave = _ref7.onSave,
	      disabled = _ref7.disabled,
	      large = _ref7.large,
	      position = _ref7.position,
	      customToggle = _ref7.customToggle,
	      tooltip = _ref7.tooltip,
	      children = _ref7.children;
	
	  var _useState11 = (0, _react.useState)(false),
	      _useState12 = _slicedToArray(_useState11, 2),
	      isOpen = _useState12[0],
	      setOpen = _useState12[1];
	
	  var toggle = function toggle() {
	    return setOpen(!isOpen);
	  };
	
	  var saveHandler = function saveHandler() {
	    setOpen(false);
	    onSave && onSave();
	  };
	
	  var label = function label() {
	    var composed = function composed(val) {
	      return val > 0 ? "".concat(val, " ").concat(val === 1 ? valueLabel : labelPlural || valueLabel) : valueLabel;
	    };
	
	    if (!value) return placeholder;
	    if (Array.isArray(value)) return value.length > 0 ? "".concat(value[0], " - ").concat(value[value.length - 1]) : placeholder;
	    if (isNaN(value) || valueLabel == null) return value;else return composed(value);
	  };
	
	  var classes = (0, _classNames2["default"])((_classNames = {}, _defineProperty(_classNames, className, className), _defineProperty(_classNames, "disabled", disabled), _defineProperty(_classNames, "empty", !value || Array.isArray(value) && value.length === 0), _defineProperty(_classNames, "open", isOpen), _classNames));
	  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, customToggle ? /*#__PURE__*/_react["default"].cloneElement(customToggle, {
	    id: id,
	    disabled: disabled,
	    className: customToggle.props.className + ' ' + (0, _classNames2["default"])({
	      'sb-filter-custom-toggle': true,
	      empty: !value || Array.isArray(value) && value.length === 0,
	      open: isOpen
	    })
	  }) : /*#__PURE__*/_react["default"].createElement("div", {
	    id: id,
	    className: 'sb-filter-toggle ' + classes
	  }, label()), tooltip && /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
	    target: id
	  }, tooltip), /*#__PURE__*/_react["default"].createElement(_reactstrap.Popover, {
	    className: 'sb-filter-popover' + (large ? ' large' : ''),
	    placement: 'bottom-' + position,
	    target: id,
	    isOpen: isOpen,
	    toggle: toggle,
	    disabled: disabled,
	    trigger: "legacy",
	    hideArrow: true,
	    fade: false
	  }, /*#__PURE__*/_react["default"].createElement(_reactstrap.PopoverBody, null, children && /*#__PURE__*/_react["default"].cloneElement(children, {
	    onSave: saveHandler
	  }))));
	};
	
	FilterPopover.propTypes = {
	  id: _propTypes["default"].string.isRequired,
	  placeholder: _propTypes["default"].string,
	  valueLabel: _propTypes["default"].string,
	  labelPlural: _propTypes["default"].string,
	  value: _propTypes["default"].any,
	  onSave: _propTypes["default"].func,
	  disabled: _propTypes["default"].bool,
	  large: _propTypes["default"].bool,
	  customToggle: _propTypes["default"].node,
	  tooltip: _propTypes["default"].string,
	  className: _propTypes["default"].string,
	  position: _propTypes["default"].oneOf(['start', 'end'])
	};
	FilterPopover.defaultProps = {
	  className: '',
	  large: false,
	  position: 'start'
	};
	var _default = FilterPopover;
	exports["default"] = _default;

/***/ },
/* 1903 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _IconItem = _interopRequireDefault(__webpack_require__(694));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var IconItemList = function IconItemList(props) {
	  var _useState = (0, _react.useState)(props.activeItem),
	      _useState2 = _slicedToArray(_useState, 2),
	      activeItem = _useState2[0],
	      setActiveItem = _useState2[1];
	
	  var onChange = function onChange(id) {
	    if (activeItem !== id) {
	      setActiveItem(id);
	      props.onChange(id);
	    }
	  };
	
	  return props.list.map(function (item) {
	    return /*#__PURE__*/_react["default"].createElement(_IconItem["default"], {
	      id: item.id,
	      onClick: function onClick() {
	        return onChange(item.id);
	      },
	      active: activeItem === item.id,
	      disabled: props.disabledItems.includes(item.id),
	      icon: props.icon,
	      size: props.size
	    }, item.label);
	  });
	};
	
	IconItemList.propTypes = {
	  list: _propTypes["default"].arrayOf(_propTypes["default"].shape({
	    id: _propTypes["default"].string.isRequired,
	    label: _propTypes["default"].string.isRequired
	  })).isRequired,
	  activeItem: _propTypes["default"].string.isRequired,
	  disabledItems: _propTypes["default"].array.isRequired,
	  icon: _propTypes["default"].string.isRequired,
	  size: _propTypes["default"].oneOf(['small', 'large', ''])
	};
	IconItemList.defaultProps = {
	  onChange: function onChange() {
	    return console.warn('no function was assigned as prop');
	  },
	  disabledItems: [],
	  icon: '',
	  size: ''
	};
	var _default = IconItemList;
	exports["default"] = _default;

/***/ },
/* 1904 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	__webpack_require__(1009);
	
	__webpack_require__(1010);
	
	var _classNames = _interopRequireDefault(__webpack_require__(61));
	
	var _CheckboxContext = __webpack_require__(423);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var CheckAll = function CheckAll(props) {
	  var _useState = (0, _react.useState)(props.checked),
	      _useState2 = _slicedToArray(_useState, 2),
	      checked = _useState2[0],
	      setChecked = _useState2[1];
	
	  var classes = (0, _classNames["default"])({
	    disabled: props.disabled,
	    checked: checked
	  });
	
	  var _useState3 = (0, _react.useState)(''),
	      _useState4 = _slicedToArray(_useState3, 2),
	      isCheckAll = _useState4[0],
	      setIsCheckAll = _useState4[1];
	
	  var _useContext = (0, _react.useContext)(_CheckboxContext.Context),
	      _useContext2 = _slicedToArray(_useContext, 9),
	      onCheckAll = _useContext2[3],
	      checkAllValue = _useContext2[5],
	      checkedIds = _useContext2[6],
	      checkboxIds = _useContext2[8];
	
	  (0, _react.useEffect)(function () {
	    if (checkAllValue !== checked) {
	      props.onChange(checkAllValue);
	      setChecked(checkAllValue);
	    }
	
	    if (checkedIds.length === checkboxIds.length) {
	      setIsCheckAll('-checked');
	    } else if (checkAllValue) {
	      setIsCheckAll('-line');
	    } else {
	      setIsCheckAll('');
	    }
	  }, [checkAllValue, checkedIds.length, checkboxIds.length]);
	  (0, _react.useEffect)(function () {
	    if (checked !== props.checked) {
	      if (!props.disabled) {
	        props.onChange(!checked);
	        onCheckAll && onCheckAll(!checked);
	        setChecked(!checked);
	      }
	    }
	  }, [props.checked]);
	
	  var onChange = function onChange(e) {
	    e.stopPropagation();
	
	    if (!props.disabled) {
	      props.onChange(!checked);
	      onCheckAll && onCheckAll(!checked);
	      setChecked(!checked);
	    }
	  };
	
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-check ".concat(props.className, " ").concat(classes),
	    onClick: onChange
	  }, /*#__PURE__*/_react["default"].createElement("input", {
	    type: "checkbox",
	    disabled: props.disabled,
	    id: "checkall-id-".concat(props.id),
	    name: "checkall-".concat(props.id),
	    checked: checked,
	    onChange: props.onChange
	  }), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-check-item ".concat(props.captionPosition)
	  }, props.threeStates ? /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon checkbox".concat(isCheckAll, " ")
	  }) : /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon checkbox".concat(checked ? '-line' : '', " ")
	  })), props.icon && /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon ".concat(props.icon, " ").concat(props.iconSize, " glc-check-icon")
	  }), /*#__PURE__*/_react["default"].createElement("span", null, props.caption));
	};
	
	CheckAll.defaultProps = {
	  onChange: function onChange() {},
	  className: '',
	  captionPosition: 'right',
	  icon: '',
	  iconSize: '',
	  threeStates: false
	};
	CheckAll.propTypes = {
	  className: _propTypes["default"].string,
	  disabled: _propTypes["default"].bool,
	  onChange: _propTypes["default"].func.isRequired,
	  caption: _propTypes["default"].string,
	  checked: _propTypes["default"].bool,
	  captionPosition: _propTypes["default"].oneOf(['left', 'right']),
	  id: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired,
	  icon: _propTypes["default"].string,
	  iconSize: _propTypes["default"].oneOf(['small', 'large', '']),
	  threeStates: _propTypes["default"].bool
	};
	var _default = CheckAll;
	exports["default"] = _default;

/***/ },
/* 1905 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactstrap = __webpack_require__(48);
	
	__webpack_require__(2558);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var InputFileUpload = function InputFileUpload(_ref) {
	  var required = _ref.required,
	      placeholder = _ref.placeholder,
	      onFile = _ref.onFile,
	      errorMsgs = _ref.errorMsgs,
	      errorFileNull = _ref.errorFileNull,
	      mimetypeAcept = _ref.mimetypeAcept,
	      _ref$isLoading = _ref.isLoading,
	      isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
	      _ref$isFileUpload = _ref.isFileUpload,
	      isFileUpload = _ref$isFileUpload === void 0 ? false : _ref$isFileUpload;
	  var inputRef = (0, _react.useRef)(null);
	
	  var _useState = (0, _react.useState)(null),
	      _useState2 = _slicedToArray(_useState, 2),
	      file = _useState2[0],
	      setFile = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(null),
	      _useState4 = _slicedToArray(_useState3, 2),
	      error = _useState4[0],
	      setError = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      isLoad = _useState6[0],
	      setIsLoading = _useState6[1];
	
	  (0, _react.useEffect)(function () {
	    if (isFileUpload === -2) {
	      setError(errorMsgs[3]);
	    }
	  }, [isFileUpload]);
	  (0, _react.useEffect)(function () {
	    setIsLoading(isLoading);
	  }, [isLoading]);
	  (0, _react.useEffect)(function () {
	    errorFileNull && setError(errorMsgs[2]);
	  }, [errorFileNull]);
	
	  var onFileUpload = function onFileUpload(e) {
	    var filesAdded = e.dataTransfer ? e.dataTransfer.files : e.target.files;
	
	    if (mimetypeAcept.filter(function (i) {
	      return i === filesAdded[0].name.split('.').pop();
	    }).length === 0) {
	      setError(errorMsgs[1]);
	      setFile(filesAdded[0]);
	      return;
	    }
	
	    if (filesAdded[0].size / 1000000 > 40) {
	      setError(errorMsgs[0]);
	      setFile(filesAdded[0]);
	      return;
	    } else {
	      setError(null);
	      onFile(filesAdded[0]);
	      setFile(filesAdded[0]);
	      setIsLoading(true);
	    }
	  };
	
	  var onClickAttach = function onClickAttach() {
	    if (!isLoad) {
	      onFile(null);
	      setFile(null);
	      inputRef.current.value = '';
	      inputRef.current.click();
	    }
	  };
	
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-input-file-upload ".concat(file != null ? 'populated' : '', " ").concat(error ? 'error' : '')
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "input-file-upload-container",
	    onClick: onClickAttach
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-ifu-file-wrapper"
	  }, /*#__PURE__*/_react["default"].createElement("span", {
	    className: "gcl-ifu-placeholder"
	  }, placeholder, required && /*#__PURE__*/_react["default"].createElement("span", {
	    className: "required"
	  }, "*")), file != null && /*#__PURE__*/_react["default"].createElement("span", {
	    className: "gcl-ifu-filename"
	  }, file.name)), isLoad ? /*#__PURE__*/_react["default"].createElement(_reactstrap.Spinner, {
	    color: "primary",
	    className: "spinner"
	  }) : /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon upload"
	  })), error && /*#__PURE__*/_react["default"].createElement("span", {
	    className: "gcl-labelInput-error"
	  }, error), /*#__PURE__*/_react["default"].createElement("input", {
	    type: "file",
	    className: "input",
	    disabled: isLoad,
	    onChange: onFileUpload,
	    ref: inputRef
	  }));
	};
	
	var _default = InputFileUpload;
	exports["default"] = _default;

/***/ },
/* 1906 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	__webpack_require__(2561);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var MessageInput = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
	  var _ref$value = _ref.value,
	      value = _ref$value === void 0 ? '' : _ref$value,
	      onChange = _ref.onChange,
	      onEnter = _ref.onEnter,
	      maxChars = _ref.maxChars,
	      disabled = _ref.disabled,
	      placeholder = _ref.placeholder;
	  var areaRef = (0, _react.useRef)(null);
	  (0, _react.useImperativeHandle)(ref, function () {
	    return {
	      focus: function focus() {
	        areaRef.current.focus();
	      }
	    };
	  });
	
	  var handleChange = function handleChange(e) {
	    var newVal = e.currentTarget.value;
	    if (maxChars && newVal.length > maxChars) return;
	    onChange(newVal);
	  };
	
	  var calculateRows = function calculateRows() {
	    areaRef.current.rows = 1;
	    var newRows = Math.ceil((areaRef.current.scrollHeight - 44) / 20);
	    areaRef.current.rows = 1 + newRows;
	  };
	
	  (0, _react.useLayoutEffect)(calculateRows, [value]);
	
	  var handleKeyDown = function handleKeyDown(e) {
	    if (e.key === 'Enter') {
	      e.preventDefault();
	
	      if (!(e.shiftKey || e.ctrlKey || e.altKey)) {
	        onEnter && onEnter();
	      } else {
	        onChange(value + '\r\n');
	      }
	    }
	  };
	
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: 'gcl-message-input' + (disabled ? ' disabled' : '')
	  }, /*#__PURE__*/_react["default"].createElement("textarea", {
	    ref: areaRef,
	    value: value,
	    onChange: handleChange,
	    onKeyDown: handleKeyDown,
	    disabled: disabled,
	    placeholder: placeholder,
	    rows: 1,
	    spellCheck: "true"
	  }), maxChars && /*#__PURE__*/_react["default"].createElement("span", {
	    className: "gcl-mi-counter"
	  }, /*#__PURE__*/_react["default"].createElement("span", {
	    className: value.length === maxChars ? 'gcl-mi-alert' : undefined
	  }, value.length), "/", maxChars));
	});
	MessageInput.propTypes = {
	  value: _propTypes["default"].string.isRequired,
	  onChange: _propTypes["default"].func.isRequired,
	  onEnter: _propTypes["default"].func,
	  maxChars: _propTypes["default"].number,
	  disabled: _propTypes["default"].bool,
	  placeholder: _propTypes["default"].string
	};
	var _default = MessageInput;
	exports["default"] = _default;

/***/ },
/* 1907 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	__webpack_require__(2563);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var LoadingBar = function LoadingBar() {
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: "sb-loading-progress-bar"
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "sb-loading-progress-carga"
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "sb-loading-progress-gradiente"
	  })));
	};
	
	var _default = LoadingBar;
	exports["default"] = _default;

/***/ },
/* 1908 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.SubMenu = exports.MenuItem = exports.Menu = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _hooks = __webpack_require__(110);
	
	var _classNames = _interopRequireDefault(__webpack_require__(61));
	
	__webpack_require__(2564);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var MenuBar = function MenuBar(_ref) {
	  var onSelect = _ref.onSelect,
	      children = _ref.children;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      isOpen = _useState2[0],
	      setOpen = _useState2[1];
	
	  var toggle = function toggle() {
	    return setOpen(!isOpen);
	  };
	
	  var handleSelect = function handleSelect(e) {
	    setTimeout(function () {
	      return setOpen(false);
	    }, 300);
	    onSelect(e.target.id);
	  };
	
	  return /*#__PURE__*/_react["default"].createElement("nav", {
	    className: 'gcl-menubar' + (isOpen ? ' open' : ''),
	    role: "menu"
	  }, /*#__PURE__*/_react["default"].createElement("span", {
	    className: "gcl-menubar-toggle",
	    onClick: toggle
	  }, /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon menu"
	  }), "Menu"), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-menu-container"
	  }, /*#__PURE__*/_react["default"].createElement("header", null, /*#__PURE__*/_react["default"].createElement("h4", null, "Menu"), /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon close clickable",
	    onClick: toggle
	  })), Array.isArray(children) ? children.map(function (child, i) {
	    return /*#__PURE__*/_react["default"].cloneElement(child, {
	      key: i,
	      onSelect: handleSelect
	    });
	  }) : /*#__PURE__*/_react["default"].cloneElement(children, {
	    onSelect: handleSelect
	  })));
	};
	
	var Menu = function Menu(_ref2) {
	  var label = _ref2.label,
	      onSelect = _ref2.onSelect,
	      children = _ref2.children;
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      isOpen = _useState4[0],
	      setOpen = _useState4[1];
	
	  var toggle = function toggle() {
	    return setOpen(!isOpen);
	  };
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      selected = _useState6[0],
	      setSelected = _useState6[1];
	
	  var wrapperRef = (0, _react.useRef)(null);
	  (0, _hooks.useOutsideClick)(wrapperRef, function () {
	    return setTimeout(function () {
	      return setOpen(false);
	    }, 300);
	  });
	
	  var handleSelect = function handleSelect(e) {
	    setSelected(true);
	    setTimeout(function () {
	      setOpen(false);
	      setSelected(false);
	    }, 600);
	    onSelect(e);
	  };
	
	  var _useScaledRightLimit = (0, _hooks.useScaledRightLimit)(),
	      _useScaledRightLimit2 = _slicedToArray(_useScaledRightLimit, 2),
	      menuRef = _useScaledRightLimit2[0],
	      right = _useScaledRightLimit2[1];
	
	  var classes = (0, _classNames["default"])({
	    show: isOpen,
	    hide: selected,
	    'right-aligned': right
	  });
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-menu",
	    ref: wrapperRef
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-menu-toggle",
	    onClick: toggle
	  }, /*#__PURE__*/_react["default"].createElement("span", {
	    className: "gcl-menu-label"
	  }, label), /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon chevron-right"
	  })), /*#__PURE__*/_react["default"].createElement("div", {
	    ref: menuRef,
	    className: 'gcl-menu-list gcl-fader on-parent-hover with-delay ' + classes
	  }, /*#__PURE__*/_react["default"].createElement("h4", {
	    onClick: toggle
	  }, /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon chevron-left"
	  }), label), children && /*#__PURE__*/_react["default"].createElement("ul", null, Array.isArray(children) ? children.map(function (child, i) {
	    return /*#__PURE__*/_react["default"].cloneElement(child, {
	      key: i,
	      onClick: handleSelect
	    });
	  }) : /*#__PURE__*/_react["default"].cloneElement(children, {
	    onClick: handleSelect
	  }))));
	};
	
	exports.Menu = Menu;
	
	var MenuItem = function MenuItem(_ref3) {
	  var id = _ref3.id,
	      onClick = _ref3.onClick,
	      children = _ref3.children;
	
	  var _useState7 = (0, _react.useState)(false),
	      _useState8 = _slicedToArray(_useState7, 2),
	      submenuOpen = _useState8[0],
	      setSubmenuOpen = _useState8[1];
	
	  var ref = (0, _react.useRef)(null);
	  (0, _hooks.useOutsideClick)(ref, function () {
	    return setSubmenuOpen(false);
	  });
	  var hasSubMenu = Array.isArray(children);
	  return /*#__PURE__*/_react["default"].createElement("li", {
	    id: id,
	    ref: ref,
	    className: 'gcl-menuitem' + (hasSubMenu ? ' submenu' : ''),
	    onClick: hasSubMenu ? function () {
	      return setSubmenuOpen(!submenuOpen);
	    } : onClick
	  }, hasSubMenu ? children.map(function (child, i) {
	    return /*#__PURE__*/_react["default"].isValidElement(child) ? /*#__PURE__*/_react["default"].cloneElement(child, {
	      key: i,
	      onSelect: onClick,
	      isOpen: submenuOpen
	    }) : child;
	  }) : children);
	};
	
	exports.MenuItem = MenuItem;
	
	var SubMenu = function SubMenu(_ref4) {
	  var isOpen = _ref4.isOpen,
	      onSelect = _ref4.onSelect,
	      children = _ref4.children;
	
	  var _useScaledRightLimit3 = (0, _hooks.useScaledRightLimit)(),
	      _useScaledRightLimit4 = _slicedToArray(_useScaledRightLimit3, 2),
	      menuRef = _useScaledRightLimit4[0],
	      right = _useScaledRightLimit4[1];
	
	  var classes = (0, _classNames["default"])({
	    'touch-show': isOpen,
	    'right-aligned': right
	  });
	  return /*#__PURE__*/_react["default"].createElement("ul", {
	    ref: menuRef,
	    className: 'gcl-submenu gcl-fader on-parent-hover with-delay ' + classes
	  }, Array.isArray(children) ? children.map(function (child, i) {
	    return /*#__PURE__*/_react["default"].cloneElement(child, {
	      key: i,
	      onClick: onSelect
	    });
	  }) : /*#__PURE__*/_react["default"].cloneElement(children, {
	    onClick: onSelect
	  }));
	};
	
	exports.SubMenu = SubMenu;
	MenuBar.propTypes = {
	  onSelect: _propTypes["default"].func.isRequired
	};
	var _default = MenuBar;
	exports["default"] = _default;

/***/ },
/* 1909 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	__webpack_require__(2565);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var NotificationCounter = function NotificationCounter(_ref) {
	  var id = _ref.id,
	      icon = _ref.icon,
	      color = _ref.color,
	      pending = _ref.pending,
	      _onClick = _ref.onClick;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      active = _useState2[0],
	      setActive = _useState2[1];
	
	  var wrapperRef = (0, _react.useRef)(null);
	  (0, _react.useEffect)(function () {
	    function handleClickOutside(event) {
	      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
	        setActive(false);
	      }
	    } // Bind the event listener
	
	
	    document.addEventListener('mousedown', handleClickOutside);
	    return function () {
	      // Unbind the event listener on clean up
	      document.removeEventListener('mousedown', handleClickOutside);
	    };
	  }, [wrapperRef]);
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    id: id,
	    ref: wrapperRef,
	    className: "gcl-nc-tab ".concat(active ? 'active' : '', " ").concat(color),
	    onClick: function onClick() {
	      setActive(true);
	
	      _onClick();
	    }
	  }, pending > 0 && /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-nc-count"
	  }, /*#__PURE__*/_react["default"].createElement("span", null, "+", pending)), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-nc-icon"
	  }, /*#__PURE__*/_react["default"].createElement("i", {
	    className: 'gcl-icon ' + icon
	  })));
	};
	
	NotificationCounter.propTypes = {
	  id: _propTypes["default"].string,
	  icon: _propTypes["default"].string,
	  pending: _propTypes["default"].number,
	  onClick: _propTypes["default"].func.isRequired,
	  color: _propTypes["default"].oneOf(['agent', 'admin', 'something'])
	};
	NotificationCounter.defaultProps = {
	  pending: 0,
	  icon: 'chat',
	  color: 'agent',
	  onClick: function onClick() {
	    return console.warn('no function was assigned as prop');
	  }
	};
	var _default = NotificationCounter;
	exports["default"] = _default;

/***/ },
/* 1910 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	__webpack_require__(2566);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var NumericStepper = function NumericStepper(_ref) {
	  var title = _ref.title,
	      label = _ref.label,
	      value = _ref.value,
	      onChange = _ref.onChange,
	      error = _ref.error,
	      min = _ref.min,
	      max = _ref.max;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      focused = _useState2[0],
	      setFocused = _useState2[1];
	
	  var limitedValue = function limitedValue(val) {
	    if (min != null && val < min) {
	      return onChange(min);
	    }
	
	    if (max != null && val > max) {
	      return onChange(max);
	    }
	
	    return onChange(val);
	  };
	
	  var changeHandler = function changeHandler(e) {
	    if (e.target.value) {
	      var val = parseInt(e.target.value, 10);
	      if (isNaN(val)) return; // setShowHour(val <= 2 ? val : null);
	
	      limitedValue(val);
	    } else {
	      // setShowHour(0);
	      limitedValue(value != null ? value : 0);
	    }
	  };
	
	  var onKeyDown = function onKeyDown(e) {
	    if (e.keyCode === 38) {
	      //Arrow Up
	      limitedValue(value + 1);
	      e.preventDefault();
	    } else if (e.keyCode === 40) {
	      //Arrow Down
	      limitedValue(value - 1);
	      e.preventDefault();
	    }
	  };
	
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: 'gcl-numeric-stepper' + (focused ? ' focused' : '') + (error ? ' error' : '')
	  }, title && /*#__PURE__*/_react["default"].createElement("span", {
	    className: "gcl-ns-label"
	  }, title), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-ns-wrapper"
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-ns-input-container"
	  }, /*#__PURE__*/_react["default"].createElement("input", {
	    type: "text",
	    pattern: "[0-9]*",
	    className: "gcl-ns-input",
	    value: value,
	    onChange: changeHandler,
	    onKeyDown: onKeyDown,
	    onFocus: function onFocus() {
	      return setFocused(true);
	    },
	    onBlur: function onBlur() {
	      return setFocused(false);
	    }
	  }), /*#__PURE__*/_react["default"].createElement("span", null, label)), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-ns-buttons"
	  }, /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon clickable chevron-up",
	    tabIndex: -1,
	    onClick: function onClick() {
	      return limitedValue(value + 1);
	    },
	    onMouseDown: function onMouseDown() {
	      return setFocused(true);
	    },
	    onFocus: function onFocus() {
	      return setFocused(true);
	    },
	    onBlur: function onBlur() {
	      return setFocused(false);
	    }
	  }), /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon clickable chevron",
	    tabIndex: -1,
	    onClick: function onClick() {
	      return limitedValue(value - 1);
	    },
	    onMouseDown: function onMouseDown() {
	      return setFocused(true);
	    },
	    onFocus: function onFocus() {
	      return setFocused(true);
	    },
	    onBlur: function onBlur() {
	      return setFocused(false);
	    }
	  }))));
	};
	
	NumericStepper.propTypes = {
	  title: _propTypes["default"].string,
	  label: _propTypes["default"].string,
	  value: _propTypes["default"].number.isRequired,
	  onChange: _propTypes["default"].func.isRequired,
	  min: _propTypes["default"].number,
	  max: _propTypes["default"].number
	};
	var _default = NumericStepper;
	exports["default"] = _default;

/***/ },
/* 1911 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	__webpack_require__(2568);
	
	__webpack_require__(2569);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var RatingStars = function RatingStars(_ref) {
	  var count = _ref.count,
	      isHalf = _ref.isHalf,
	      icon = _ref.icon,
	      size = _ref.size,
	      onChange = _ref.onChange,
	      value = _ref.value;
	
	  var _useState = (0, _react.useState)(value),
	      _useState2 = _slicedToArray(_useState, 2),
	      rating = _useState2[0],
	      setRating = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(0),
	      _useState4 = _slicedToArray(_useState3, 2),
	      hover = _useState4[0],
	      setHover = _useState4[1];
	
	  var isEnd = function isEnd(number) {
	    return number % 2 === 0;
	  };
	
	  var internalCount = isHalf ? count * 2 : count;
	
	  var getArray = function getArray() {
	    var array = [];
	    var plus = isHalf ? 2 : 1;
	
	    for (var index = 1; index <= internalCount; index += plus) {
	      array.push( /*#__PURE__*/_react["default"].createElement("div", {
	        className: 'gcl-rating-container'
	      }, getButton(index), isHalf && getButton(index + 1)));
	    }
	
	    return array.map(function (v) {
	      return v;
	    });
	  };
	
	  var getButton = function getButton(index) {
	    return /*#__PURE__*/_react["default"].createElement("button", {
	      type: "button",
	      key: index,
	      className: "gcl-ritem ".concat(index <= (hover || rating) ? 'on' : 'off', " ").concat(isHalf ? isEnd(index) ? 'end' : 'start' : '', " ").concat(size),
	      onClick: function onClick() {
	        onChange(isHalf ? index / 2 : index);
	        setRating(index);
	      },
	      onMouseEnter: function onMouseEnter() {
	        return setHover(index);
	      },
	      onMouseLeave: function onMouseLeave() {
	        return setHover(rating);
	      }
	    }, /*#__PURE__*/_react["default"].createElement("i", {
	      className: 'gcl-icon ' + icon
	    }));
	  };
	
	  (0, _react.useEffect)(function () {
	    setRating(isHalf ? value * 2 : value);
	    setHover(isHalf ? value * 2 : value);
	  }, [value]);
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-rating"
	  }, getArray());
	};
	
	RatingStars.propTypes = {
	  icon: _propTypes["default"].string,
	  halfIcon: _propTypes["default"].string,
	  isHalf: _propTypes["default"].bool,
	  size: _propTypes["default"].oneOf(['small', 'large', ''])
	};
	RatingStars.defaultProps = {
	  icon: 'star',
	  halfIcon: '',
	  isHalf: false,
	  size: '',
	  value: 0
	};
	var _default = RatingStars;
	exports["default"] = _default;

/***/ },
/* 1912 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _types = __webpack_require__(276);
	
	var _OutsideClickWrapper = _interopRequireDefault(__webpack_require__(219));
	
	var _hooks = __webpack_require__(110);
	
	var _reactstrap = __webpack_require__(48);
	
	__webpack_require__(2570);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var SearchSelectionAgent = function SearchSelectionAgent(_ref) {
	  var options = _ref.options,
	      noDefault = _ref.noDefault,
	      defaultIndex = _ref.defaultIndex,
	      disabled = _ref.disabled,
	      keyResult = _ref.keyResult,
	      filterBy = _ref.filterBy,
	      ignoreCase = _ref.ignoreCase,
	      onSelected = _ref.onSelected,
	      placeholder = _ref.placeholder,
	      sort = _ref.sort;
	
	  var _useState = (0, _react.useState)(options),
	      _useState2 = _slicedToArray(_useState, 2),
	      option = _useState2[0],
	      setOption = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      isOpen = _useState4[0],
	      setOpen = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(''),
	      _useState6 = _slicedToArray(_useState5, 2),
	      value = _useState6[0],
	      setValue = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(undefined),
	      _useState8 = _slicedToArray(_useState7, 2),
	      selection = _useState8[0],
	      setSelection = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(false),
	      _useState10 = _slicedToArray(_useState9, 2),
	      isDisplayBySearch = _useState10[0],
	      setIsDisplayBySearch = _useState10[1];
	
	  var _useScaledBottomLimit = (0, _hooks.useScaledBottomLimit)(),
	      _useScaledBottomLimit2 = _slicedToArray(_useScaledBottomLimit, 2),
	      menuRef = _useScaledBottomLimit2[0],
	      limit = _useScaledBottomLimit2[1];
	
	  var inputRef = (0, _react.useRef)();
	  var filterRef = (0, _react.useRef)(filter);
	  var stringifiedData = JSON.stringify(options);
	  var tooltipRef = (0, _react.useRef)();
	
	  var toggle = function toggle() {
	    return setOpen(!isOpen);
	  };
	
	  (0, _react.useEffect)(function () {
	    if (noDefault) return;
	    var selected = defaultIndex && options[defaultIndex] ? options[defaultIndex] : options[0];
	    setSelection(selected);
	  }, [JSON.stringify(options)]);
	  (0, _react.useEffect)(function () {
	    if (isOpen && selection !== undefined) {
	      setValue('');
	    } else if (!isOpen && selection !== undefined) {
	      setValue(selection[filterBy]);
	    }
	  }, [isOpen]);
	  (0, _react.useEffect)(function () {
	    filterRef.current();
	  }, [value, stringifiedData, isDisplayBySearch]);
	
	  var setState = function setState(inputValue) {
	    !isDisplayBySearch && setIsDisplayBySearch(true);
	
	    if (!disabled) {
	      if (inputValue.length > 0) setOpen(true);
	      setValue(inputValue);
	
	      if (selection !== undefined && inputValue.length === 0) {
	        setValue('');
	        setSelection(undefined);
	      }
	    }
	  };
	
	  var filter = function filter() {
	    var data = Array.isArray(options) ? options : convertDicToArray(options);
	    var filteredData = data.filter(arrayFilter);
	
	    if (value === '') {
	      setOption(filteredData);
	    } else {
	      var sortedFilterData = sortData(filteredData);
	      ;
	      setOption(sortedFilterData);
	    }
	  };
	
	  filterRef.current = filter;
	
	  var sortData = function sortData(data) {
	    if (filterBy && sort && isDisplayBySearch) {
	      var temp = data.map(function (element) {
	        return element[filterBy];
	      }).sort();
	      var sortedData = [];
	      temp.map(function (t) {
	        return data.forEach(function (element) {
	          if (element[filterBy] === t) {
	            sortedData = [].concat(_toConsumableArray(sortedData), [element]);
	          }
	        });
	      });
	      return sortedData;
	    }
	
	    return data;
	  };
	
	  var convertDicToArray = function convertDicToArray(dic) {
	    return Object.keys(dic).map(function (key) {
	      var element = dic[key];
	      element[keyResult] = key;
	      return element;
	    });
	  };
	
	  var arrayFilter = function arrayFilter(data) {
	    if (_typeof(data) === 'object') {
	      if (Array.isArray(data)) {
	        // array de arrays
	        return data.filter(arrayFilter).some(function (x) {
	          return x;
	        });
	      } //array of objects
	      else if (filterBy) {
	          return searchByKeyIn(data);
	        }
	
	      throw new Error("filterBy value wasn't assigned as prop");
	    }
	
	    return valueIn(data); //array of string or integers
	  };
	
	  var searchByKeyIn = function searchByKeyIn(data) {
	    if (Array.isArray(filterBy)) {
	      return filterBy.some(function (element) {
	        return element in data ? valueIn(data[element]) : false;
	      });
	    }
	
	    return filterBy in data ? valueIn(data[filterBy]) : false;
	  };
	
	  var valueIn = function valueIn(data) {
	    var stringData = data.toString();
	    return ignoreCase ? stringData.toLowerCase().includes(value.toLowerCase()) : stringData.includes(value);
	  };
	
	  (0, _react.useEffect)(function () {
	    if (selection) {
	      setValue(selection[filterBy]);
	      onSelected(selection);
	    }
	  }, [selection]);
	
	  var handleKeyPress = function handleKeyPress(event) {
	    if (event.key === 'Enter') {
	      setSelection(option[0]);
	      setOpen(false);
	    }
	  };
	
	  var handleOnBlur = function handleOnBlur() {
	    if (value.length === 0) setValue(selection[filterBy]);
	  };
	
	  var displayList = function displayList() {
	    setIsDisplayBySearch(false);
	    !disabled && toggle(isOpen);
	  };
	
	  return /*#__PURE__*/_react["default"].createElement(_OutsideClickWrapper["default"], {
	    action: function action() {
	      return setOpen(false);
	    }
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-search-selection-agent-wrapper"
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-search-selection-agent ".concat(isOpen ? 'open' : ''),
	    ref: tooltipRef
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-search-selection-agent-body"
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-search-selection-agent-body-placeholder"
	  }), /*#__PURE__*/_react["default"].createElement("input", {
	    ref: inputRef,
	    type: "text",
	    value: value,
	    disabled: disabled,
	    onKeyPress: handleKeyPress,
	    onBlur: handleOnBlur,
	    onChange: function onChange(e) {
	      return setState(e.target.value);
	    },
	    placeholder: placeholder
	  })), value.length > 38 && /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
	    placement: "top",
	    hideArrow: true,
	    target: tooltipRef,
	    delay: {
	      show: 500,
	      hide: 100
	    },
	    boundariesElement: "window",
	    className: "gcl-labelInput-tooltip dispositions"
	  }, value), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-search-selection-agent-icon",
	    onClick: function onClick() {
	      return displayList();
	    }
	  }, /*#__PURE__*/_react["default"].createElement("i", {
	    className: 'gcl-icon triangle'
	  }))), isOpen && /*#__PURE__*/_react["default"].createElement("ul", {
	    ref: menuRef,
	    className: "gcl-search-selection-agent-dropdown-list"
	  }, option.map(function (option, i) {
	    return /*#__PURE__*/_react["default"].createElement(Option, {
	      key: i,
	      option: option,
	      selection: selection,
	      setSelection: setSelection,
	      setOpen: setOpen,
	      filterBy: filterBy
	    });
	  }))));
	};
	
	var Option = function Option(_ref2) {
	  var option = _ref2.option,
	      selection = _ref2.selection,
	      setSelection = _ref2.setSelection,
	      setOpen = _ref2.setOpen,
	      filterBy = _ref2.filterBy;
	  var refTooltip = (0, _react.useRef)();
	  var refTooltipOption = (0, _react.useRef)();
	  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("li", {
	    className: "gcl-dropdown-agent-item ".concat(option === selection ? '--selected' : ''),
	    key: option.id,
	    onClick: function onClick() {
	      setSelection(option);
	      setOpen(false);
	    },
	    ref: refTooltipOption
	  }, /*#__PURE__*/_react["default"].createElement("span", null, option[filterBy]), option.icon && /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon ".concat(option.icon),
	    ref: refTooltip
	  })), option.tooltiptext && /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
	    placement: "top",
	    target: refTooltip,
	    autohide: false,
	    trigger: 'hover'
	  }, option.tooltiptext), option[filterBy].length > 34 && /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
	    placement: "top",
	    hideArrow: true,
	    target: refTooltipOption,
	    delay: {
	      show: 500,
	      hide: 100
	    },
	    boundariesElement: "window",
	    className: "gcl-labelInput-tooltip dispositions"
	  }, option[filterBy]));
	};
	
	SearchSelectionAgent.propTypes = {
	  disabled: _propTypes["default"].bool,
	  options: _propTypes["default"].arrayOf(_types.dropdownType).isRequired,
	  filterBy: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array]).isRequired,
	  //nombre de la(s) propiedade(s) a buscar
	  onSelected: _propTypes["default"].func.isRequired,
	  sort: _propTypes["default"].bool
	};
	var _default = SearchSelectionAgent;
	exports["default"] = _default;

/***/ },
/* 1913 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _types = __webpack_require__(276);
	
	var _OutsideClickWrapper = _interopRequireDefault(__webpack_require__(219));
	
	var _hooks = __webpack_require__(110);
	
	var _reactstrap = __webpack_require__(48);
	
	__webpack_require__(2571);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var Option = function Option(_ref) {
	  var option = _ref.option,
	      selection = _ref.selection,
	      setSelection = _ref.setSelection,
	      setOpen = _ref.setOpen,
	      swapStyles = _ref.swapStyles;
	  var refTooltip = (0, _react.useRef)();
	  var refTooltipOptions = (0, _react.useRef)();
	  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("li", {
	    className: "gcl-dropdown-item ".concat(option === selection ? '--selected ' : '', " ").concat(swapStyles ? '--nStyles' : ''),
	    key: option.id,
	    onClick: function onClick() {
	      setSelection(option);
	      setOpen(false);
	    },
	    ref: refTooltipOptions
	  }, /*#__PURE__*/_react["default"].createElement("span", null, option.text), option.icon && /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon ".concat(option.icon),
	    ref: refTooltip
	  })), option.tooltiptext && /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
	    placement: "top",
	    target: refTooltip,
	    autohide: false,
	    trigger: 'hover'
	  }, option.tooltiptext), option.text.length > 34 && /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
	    placement: "top",
	    target: refTooltipOptions,
	    boundariesElement: "window"
	  }, option.text));
	};
	
	var SearchSelection = function SearchSelection(props) {
	  var _useState = (0, _react.useState)(props.options),
	      _useState2 = _slicedToArray(_useState, 2),
	      option = _useState2[0],
	      setOption = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      isOpen = _useState4[0],
	      setOpen = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(''),
	      _useState6 = _slicedToArray(_useState5, 2),
	      value = _useState6[0],
	      setValue = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(undefined),
	      _useState8 = _slicedToArray(_useState7, 2),
	      selection = _useState8[0],
	      setSelection = _useState8[1];
	
	  var inputRef = (0, _react.useRef)();
	  var tooltipRef = (0, _react.useRef)();
	  var stringifiedData = JSON.stringify(props.options);
	  (0, _react.useEffect)(function () {
	    if (props.noDefault) return;
	    var selected = props.defaultIndex && props.options[props.defaultIndex] ? props.options[props.defaultIndex] : props.options[0];
	    setSelection(selected);
	  }, [JSON.stringify(props.options)]);
	  (0, _react.useEffect)(function () {
	    if (isOpen && selection !== undefined) {
	      setValue('');
	    } else if (!isOpen && selection !== undefined) {
	      setValue(selection.text);
	    }
	  }, [isOpen]);
	  (0, _react.useEffect)(function () {
	    filterRef.current();
	  }, [value, stringifiedData]);
	
	  var toggle = function toggle() {
	    return setOpen(!isOpen);
	  };
	
	  var setState = function setState(inputValue) {
	    if (!props.disabled) {
	      if (inputValue.length > 0) setOpen(true);
	      setValue(inputValue);
	
	      if (selection !== undefined && inputValue.length === 0) {
	        setValue('');
	        setSelection(undefined);
	      }
	    }
	  };
	
	  var filter = function filter() {
	    var data = Array.isArray(props.options) ? props.options : convertDicToArray(props.options);
	    var filteredData = data.filter(arrayFilter);
	
	    if (value.length > 0) {
	      filteredData.sort(function (a, b) {
	        if (a.text > b.text) {
	          return 1;
	        }
	
	        if (a.text < b.text) {
	          return -1;
	        }
	
	        return 0;
	      });
	    }
	
	    setOption(filteredData);
	  };
	
	  var filterRef = (0, _react.useRef)(filter);
	  filterRef.current = filter;
	
	  var convertDicToArray = function convertDicToArray(dic) {
	    return Object.keys(dic).map(function (key) {
	      var element = dic[key];
	      element[props.keyResult] = key;
	      return element;
	    });
	  };
	
	  var arrayFilter = function arrayFilter(data) {
	    if (_typeof(data) === 'object') {
	      if (Array.isArray(data)) {
	        // array de arrays
	        return data.filter(arrayFilter).some(function (x) {
	          return x;
	        });
	      } //array of objects
	      else if (props.filterBy) {
	          return searchByKeyIn(data);
	        }
	
	      throw new Error("filterBy value wasn't assigned as prop");
	    }
	
	    return valueIn(data); //array of string or integers
	  };
	
	  var searchByKeyIn = function searchByKeyIn(data) {
	    if (Array.isArray(props.filterBy)) {
	      return props.filterBy.some(function (element) {
	        return element in data ? valueIn(data[element]) : false;
	      });
	    }
	
	    return props.filterBy in data ? valueIn(data[props.filterBy]) : false;
	  };
	
	  var valueIn = function valueIn(data) {
	    var stringData = data.toString();
	    return props.ignoreCase ? stringData.toLowerCase().includes(value.toLowerCase()) : stringData.includes(value);
	  };
	
	  (0, _react.useEffect)(function () {
	    if (selection) {
	      setValue(selection.text);
	      props.onSelected(selection);
	    }
	  }, [selection]);
	
	  var _useScaledBottomLimit = (0, _hooks.useScaledBottomLimit)(),
	      _useScaledBottomLimit2 = _slicedToArray(_useScaledBottomLimit, 2),
	      menuRef = _useScaledBottomLimit2[0],
	      limit = _useScaledBottomLimit2[1];
	
	  var handleKeyPress = function handleKeyPress(event) {
	    if (event.key === 'Enter') {
	      setSelection(option[0]);
	      setOpen(false);
	    }
	  };
	
	  var handleOnBlur = function handleOnBlur() {
	    if (value.length === 0) setValue(selection.text);
	  };
	
	  return /*#__PURE__*/_react["default"].createElement(_OutsideClickWrapper["default"], {
	    action: function action() {
	      return setOpen(false);
	    }
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-search-selection-wrapper"
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-search-selection"
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-search-selection-body",
	    ref: tooltipRef
	  }, (selection || isOpen) && /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-search-selection-body-placeholder ".concat(isOpen ? '--open' : '', " ").concat(isOpen ? '' : selection ? '--selected' : '')
	  }, props.placeholder), /*#__PURE__*/_react["default"].createElement("input", {
	    ref: inputRef,
	    type: props.numeric ? 'number' : 'text',
	    onChange: function onChange(e) {
	      return setState(e.target.value);
	    },
	    value: value,
	    placeholder: props.placeholder,
	    disabled: props.disabled,
	    onKeyPress: handleKeyPress,
	    onBlur: handleOnBlur
	  })), value.length > 30 && /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
	    placement: "top",
	    target: tooltipRef,
	    delay: {
	      show: 500,
	      hide: 100
	    },
	    boundariesElement: 'window'
	  }, value), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-search-selection-icon"
	  }, /*#__PURE__*/_react["default"].createElement("i", {
	    className: 'gcl-icon ' + (isOpen && props.swapStyles ? 'nStyles ' : '') + (isOpen ? 'chevron-up' : 'chevron'),
	    onClick: function onClick() {
	      !props.disabled && toggle(isOpen);
	    }
	  }))), isOpen && /*#__PURE__*/_react["default"].createElement("ul", {
	    ref: menuRef,
	    className: 'gcl-search-selection-dropdown-list' + (props.swapStyles ? ' nStyles' : '')
	  }, option.map(function (option, i) {
	    return /*#__PURE__*/_react["default"].createElement(Option, {
	      key: i,
	      option: option,
	      selection: selection,
	      setSelection: setSelection,
	      setOpen: setOpen,
	      swapStyles: props.swapStyles
	    });
	  }))));
	};
	
	SearchSelection.propTypes = {
	  disabled: _propTypes["default"].bool,
	  options: _propTypes["default"].arrayOf(_types.dropdownType).isRequired,
	  filterBy: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array]),
	  //nombre de la(s) propiedade(s) a buscar
	  placeholder: _propTypes["default"].string,
	  onSelected: _propTypes["default"].func.isRequired,
	  swapStyles: _propTypes["default"].bool
	};
	var _default = SearchSelection;
	exports["default"] = _default;

/***/ },
/* 1914 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _Checkbox = _interopRequireDefault(__webpack_require__(274));
	
	var _ButtonIcon = _interopRequireDefault(__webpack_require__(421));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	__webpack_require__(2572);
	
	__webpack_require__(2573);
	
	var _reactstrap = __webpack_require__(48);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var SelectListItem = function SelectListItem(_ref) {
	  var idCheck = _ref.idCheck,
	      label = _ref.label,
	      checked = _ref.checked,
	      disabledCheck = _ref.disabledCheck,
	      selected = _ref.selected,
	      onCheckChange = _ref.onCheckChange,
	      onEdit = _ref.onEdit,
	      onDelete = _ref.onDelete,
	      onSelected = _ref.onSelected,
	      disabledDelete = _ref.disabledDelete,
	      disabledEdit = _ref.disabledEdit,
	      tooltips = _ref.tooltips;
	
	  var _useState = (0, _react.useState)(selected),
	      _useState2 = _slicedToArray(_useState, 2),
	      _selected = _useState2[0],
	      setSelected = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(checked),
	      _useState4 = _slicedToArray(_useState3, 2),
	      _checked = _useState4[0],
	      setChecked = _useState4[1];
	
	  (0, _react.useEffect)(function () {
	    _selected !== selected && setSelected(selected);
	  }, [selected]);
	  (0, _react.useEffect)(function () {
	    _checked !== checked && setChecked(_checked);
	  }, [checked]);
	
	  var selectedChange = function selectedChange() {
	    if (!_selected) {
	      setSelected(true);
	      onSelected(idCheck);
	    }
	  };
	
	  var onChecked = function onChecked(flag) {
	    onCheckChange({
	      id: idCheck,
	      value: flag
	    });
	    setChecked(flag);
	  };
	
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-selectList-item ".concat(_selected ? 'selected' : '', " ").concat(_checked ? 'checked' : '')
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: 'gcl-selectList-item-title'
	  }, /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
	    id: idCheck,
	    checked: checked,
	    disabled: disabledCheck,
	    onChange: onChecked
	  }), /*#__PURE__*/_react["default"].createElement("span", {
	    id: 'gcl-selectList-item-label-' + idCheck
	  }, label), /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
	    placement: "top",
	    target: 'gcl-selectList-item-label-' + idCheck
	  }, label)), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-selectList-item-btns ".concat(_selected && 'selected', " ")
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: 'gcl-selectList-container'
	  }, /*#__PURE__*/_react["default"].createElement(_ButtonIcon["default"], {
	    id: "trash-".concat(idCheck),
	    icon: "trash",
	    onClick: function onClick() {
	      return onDelete(idCheck);
	    },
	    disabled: disabledDelete
	  })), /*#__PURE__*/_react["default"].createElement(_ButtonIcon["default"], {
	    icon: "chevron-right",
	    shape: "circle",
	    onClick: selectedChange
	  })), tooltips && tooltips["delete"] && /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
	    placement: "top",
	    target: "trash-".concat(idCheck)
	  }, tooltips["delete"]));
	};
	
	SelectListItem.propTypes = {
	  idCheck: _propTypes["default"].isRequired,
	  label: _propTypes["default"].string,
	  checked: _propTypes["default"].bool,
	  disabledCheck: _propTypes["default"].bool,
	  selected: _propTypes["default"].bool,
	  disabledEdit: _propTypes["default"].bool,
	  disabledDelete: _propTypes["default"].bool,
	  onCheckChange: _propTypes["default"].func,
	  onEdit: _propTypes["default"].func,
	  onDelete: _propTypes["default"].func,
	  onSelected: _propTypes["default"].func,
	  tooltips: _propTypes["default"].shape({
	    "delete": _propTypes["default"].string,
	    select: _propTypes["default"].string
	  })
	};
	SelectListItem.defaultProps = {
	  checked: false,
	  disabledCheck: false,
	  selected: false,
	  disabledEdit: false,
	  disabledDelete: false,
	  onCheckChange: function onCheckChange() {},
	  onEdit: function onEdit() {},
	  onDelete: function onDelete() {},
	  onSelected: function onSelected() {}
	};
	var _default = SelectListItem;
	exports["default"] = _default;

/***/ },
/* 1915 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.SelectOptionIcon = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _reactstrap = __webpack_require__(48);
	
	var _classNames = _interopRequireDefault(__webpack_require__(61));
	
	__webpack_require__(2574);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var SelectOptionIcon = function SelectOptionIcon(_ref) {
	  var icon = _ref.icon;
	  return /*#__PURE__*/_react["default"].createElement("span", {
	    className: "gcl-option-icon"
	  }, /*#__PURE__*/_react["default"].createElement("i", {
	    className: 'gcl-icon ' + icon
	  }));
	};
	
	exports.SelectOptionIcon = SelectOptionIcon;
	
	var Select = function Select(_ref2) {
	  var id = _ref2.id,
	      options = _ref2.options,
	      placeholder = _ref2.placeholder,
	      value = _ref2.value,
	      onChange = _ref2.onChange,
	      filter = _ref2.filter,
	      disabled = _ref2.disabled,
	      fixedWidth = _ref2.fixedWidth,
	      fullWidth = _ref2.fullWidth,
	      customToggle = _ref2.customToggle,
	      tooltip = _ref2.tooltip,
	      overflow = _ref2.overflow,
	      positionFixed = _ref2.positionFixed,
	      large = _ref2.large;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      isOpen = _useState2[0],
	      setOpen = _useState2[1];
	
	  (0, _react.useEffect)(function () {
	    if (!isOpen) {
	      setTooltipOpen(false);
	    }
	  }, [isOpen]);
	
	  var toggle = function toggle() {
	    return setOpen(function (open) {
	      return !open;
	    });
	  };
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      isTooltipOpen = _useState4[0],
	      setTooltipOpen = _useState4[1];
	
	  var classes = (0, _classNames["default"])({
	    fixed: fixedWidth,
	    block: fullWidth,
	    filter: filter,
	    custom: customToggle != null,
	    large: large
	  });
	  var menuClasses = (0, _classNames["default"])({
	    filter: filter,
	    large: large,
	    custom: customToggle != null,
	    fixed: positionFixed
	  });
	  var ref = (0, _react.useRef)(null);
	
	  var _useState5 = (0, _react.useState)(),
	      _useState6 = _slicedToArray(_useState5, 2),
	      toggleWidth = _useState6[0],
	      setToggleWidth = _useState6[1];
	
	  (0, _react.useLayoutEffect)(function () {
	    if (ref.current) setToggleWidth(ref.current.offsetWidth);
	  }, [value]);
	  return /*#__PURE__*/_react["default"].createElement(_reactstrap.Dropdown, {
	    isOpen: isOpen,
	    toggle: toggle,
	    disabled: disabled,
	    className: 'gcl-select ' + classes
	  }, customToggle ? /*#__PURE__*/_react["default"].createElement(_reactstrap.DropdownToggle, {
	    id: id,
	    tag: "span",
	    className: "gcl-select-custom-toggle ".concat(isOpen ? 'open' : '', " ").concat(disabled ? 'disabled' : '')
	  }, /*#__PURE__*/_react["default"].cloneElement(customToggle, {
	    disabled: disabled
	  })) : /*#__PURE__*/_react["default"].createElement(_reactstrap.DropdownToggle, {
	    id: id,
	    tag: "div",
	    innerRef: ref,
	    className: "gcl-select-toggle ".concat(value == null ? 'placeholder' : '', " ").concat(isOpen ? 'open' : '', " ").concat(disabled ? 'disabled' : '')
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-select-value"
	  }, value != null && value.icon != null && /*#__PURE__*/_react["default"].createElement("span", {
	    className: "gcl-select-icon"
	  }, value.icon), /*#__PURE__*/_react["default"].createElement("span", {
	    className: "gcl-select-label"
	  }, value != null ? value.label : placeholder)), /*#__PURE__*/_react["default"].createElement("i", {
	    className: 'gcl-icon gcl-select-toggle-icon ' + (isOpen ? 'chevron-up' : 'chevron')
	  })), tooltip && /*#__PURE__*/_react["default"].createElement(_reactstrap.Tooltip, {
	    target: id,
	    isOpen: !isOpen && isTooltipOpen,
	    toggle: function toggle() {
	      return setTooltipOpen(function (o) {
	        return !o;
	      });
	    }
	  }, tooltip), /*#__PURE__*/_react["default"].createElement(_reactstrap.DropdownMenu, {
	    className: 'gcl-select-menu gcl-fader ' + menuClasses,
	    container: overflow ? 'body' : undefined,
	    positionFixed: positionFixed,
	    style: {
	      width: toggleWidth
	    }
	  }, options && options.map(function (o) {
	    return /*#__PURE__*/_react["default"].createElement(_reactstrap.DropdownItem, {
	      className: value != null && value.value === o.value ? 'selected' : undefined,
	      key: o.value,
	      onClick: function onClick() {
	        return onChange(o);
	      }
	    }, filter ? value != null && value.value === o.value && /*#__PURE__*/_react["default"].createElement("i", {
	      className: "gcl-icon gcl-select-filter-icon sent"
	    }) : o.icon != null && /*#__PURE__*/_react["default"].createElement("span", {
	      className: "gcl-select-icon"
	    }, o.icon), /*#__PURE__*/_react["default"].createElement("span", {
	      className: "gcl-select-label"
	    }, o.label));
	  })));
	};
	
	Select.propTypes = {
	  id: _propTypes["default"].string,
	  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
	    value: _propTypes["default"].any,
	    label: _propTypes["default"].string
	  })).isRequired,
	  value: _propTypes["default"].shape({
	    value: _propTypes["default"].any,
	    label: _propTypes["default"].string
	  }),
	  placeholder: _propTypes["default"].string,
	  onChange: _propTypes["default"].func.isRequired,
	  filter: _propTypes["default"].bool,
	  disabled: _propTypes["default"].bool,
	  fixedWidth: _propTypes["default"].bool,
	  fullWidth: _propTypes["default"].bool,
	  customToggle: _propTypes["default"].node,
	  tooltip: _propTypes["default"].string,
	  overflow: _propTypes["default"].bool,
	  positionFixed: _propTypes["default"].bool,
	  large: _propTypes["default"].bool
	};
	Select.defaultProps = {
	  options: []
	};
	var _default = Select;
	exports["default"] = _default;

/***/ },
/* 1916 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _recharts = __webpack_require__(987);
	
	__webpack_require__(2575);
	
	__webpack_require__(2576);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	// const CustomActiveDot = () => <div className='slc-custom-dot'><div className='slc-dot-center' /></div>
	var CustomTooltip = function CustomTooltip(_ref) {
	  var active = _ref.active,
	      payload = _ref.payload,
	      label = _ref.label,
	      labelX = _ref.labelX,
	      labelY = _ref.labelY,
	      unit = _ref.unit;
	
	  if (active && payload && payload.length) {
	    return /*#__PURE__*/_react["default"].createElement("div", {
	      className: "gcl-chart-tooltip"
	    }, /*#__PURE__*/_react["default"].createElement("p", {
	      className: "gcl-ct-x"
	    }, labelX != null && /*#__PURE__*/_react["default"].createElement("span", null, labelX, ": "), /*#__PURE__*/_react["default"].createElement("span", null, label)), /*#__PURE__*/_react["default"].createElement("p", {
	      className: "gcl-ct-y"
	    }, labelY != null && /*#__PURE__*/_react["default"].createElement("span", null, labelY, ": "), /*#__PURE__*/_react["default"].createElement("span", null, "".concat(payload[0].value).concat(unit != null ? unit : ''))));
	  }
	
	  return null;
	};
	
	var SimpleLineChart = function SimpleLineChart(_ref2) {
	  var data = _ref2.data,
	      width = _ref2.width,
	      height = _ref2.height,
	      dataKeyY = _ref2.dataKeyY,
	      dataKeyX = _ref2.dataKeyX,
	      labelY = _ref2.labelY,
	      labelX = _ref2.labelX,
	      unit = _ref2.unit,
	      tickCount = _ref2.tickCount,
	      small = _ref2.small;
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: 'gcl-simple-line-chart' + (small ? ' small' : '')
	  }, /*#__PURE__*/_react["default"].createElement(_recharts.ResponsiveContainer, {
	    width: width,
	    height: height
	  }, /*#__PURE__*/_react["default"].createElement(_recharts.LineChart, {
	    data: data,
	    margin: {
	      top: 18,
	      right: small ? 18 : 36,
	      left: small ? 0 : 36,
	      bottom: small ? 0 : 18
	    }
	  }, /*#__PURE__*/_react["default"].createElement(_recharts.CartesianGrid, {
	    vertical: false
	  }), /*#__PURE__*/_react["default"].createElement(_recharts.XAxis, {
	    dataKey: dataKeyX,
	    tickMargin: small ? 10 : 16,
	    tickSize: small ? 4 : 9
	  }), /*#__PURE__*/_react["default"].createElement(_recharts.YAxis, {
	    dataKey: dataKeyY,
	    tickMargin: 8,
	    tickSize: small ? 12 : 18,
	    unit: unit,
	    type: "number",
	    tickCount: tickCount
	  }), /*#__PURE__*/_react["default"].createElement(_recharts.Tooltip, {
	    offset: 5,
	    content: /*#__PURE__*/_react["default"].createElement(CustomTooltip, {
	      labelX: labelX,
	      labelY: labelY,
	      unit: unit
	    })
	  }), /*#__PURE__*/_react["default"].createElement(_recharts.Legend, null), /*#__PURE__*/_react["default"].createElement(_recharts.Line, {
	    type: "linear",
	    dataKey: dataKeyY,
	    dot: false,
	    strokeWidth: small ? 3 : 8,
	    legendType: 'none',
	    activeDot: small ? {
	      strokeWidth: 4,
	      r: 6
	    } : {
	      strokeWidth: 8,
	      r: 16
	    }
	  }))));
	};
	
	var _default = SimpleLineChart;
	exports["default"] = _default;

/***/ },
/* 1917 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _recharts = __webpack_require__(987);
	
	var _formatters = __webpack_require__(427);
	
	__webpack_require__(2577);
	
	__webpack_require__(2578);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var SimplePieChart = function SimplePieChart(_ref) {
	  var data = _ref.data,
	      width = _ref.width,
	      height = _ref.height,
	      colors = _ref.colors,
	      title = _ref.title,
	      innerRadius = _ref.innerRadius,
	      outerRadius = _ref.outerRadius,
	      currentValue = _ref.currentValue,
	      paddingAngle = _ref.paddingAngle,
	      onMouseEnter = _ref.onMouseEnter;
	
	  var _useState = (0, _react.useState)({
	    active: false,
	    index: -1
	  }),
	      _useState2 = _slicedToArray(_useState, 2),
	      hover = _useState2[0],
	      toggleHover = _useState2[1];
	
	  var handleOnMouseEnter = function handleOnMouseEnter(entry, active, index) {
	    toggleHover({
	      active: active,
	      index: index
	    });
	
	    if (onMouseEnter && typeof onMouseEnter === 'function') {
	      onMouseEnter(_objectSpread(_objectSpread({}, entry), {}, {
	        activeIndex: index
	      }));
	    }
	  };
	
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-simple-pie-chart",
	    style: {
	      width: "".concat(width, "px")
	    }
	  }, /*#__PURE__*/_react["default"].createElement(_recharts.PieChart, {
	    width: width,
	    height: height
	  }, /*#__PURE__*/_react["default"].createElement(_recharts.Pie, {
	    data: data,
	    dataKey: "value",
	    nameKey: "name",
	    cx: "50%",
	    cy: "50%",
	    innerRadius: innerRadius,
	    outerRadius: outerRadius,
	    fill: "#82ca9d",
	    paddingAngle: paddingAngle
	  }, data.map(function (entry, index) {
	    return /*#__PURE__*/_react["default"].createElement(_recharts.Cell, {
	      key: "cell-".concat(index),
	      onMouseEnter: function onMouseEnter() {
	        return handleOnMouseEnter(entry, true, index);
	      },
	      onMouseLeave: function onMouseLeave() {
	        return toggleHover({
	          active: false,
	          index: index
	        });
	      },
	      fill: colors[index % colors.length],
	      stroke: hover.active && index === hover.index ? colors[index % colors.length] : 'transparent',
	      strokeWidth: 6
	    });
	  }))), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "title"
	  }, /*#__PURE__*/_react["default"].createElement("span", null, title), /*#__PURE__*/_react["default"].createElement("span", null, (0, _formatters.formatNumberQuantity)(currentValue))));
	};
	
	var _default = SimplePieChart;
	exports["default"] = _default;

/***/ },
/* 1918 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = __webpack_require__(1);
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var useStopWatch = function useStopWatch() {
	  var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1000;
	
	  var _useState = (0, _react.useState)(0),
	      _useState2 = _slicedToArray(_useState, 2),
	      seconds = _useState2[0],
	      setSeconds = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(0),
	      _useState4 = _slicedToArray(_useState3, 2),
	      minutes = _useState4[0],
	      setMinutes = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(0),
	      _useState6 = _slicedToArray(_useState5, 2),
	      hours = _useState6[0],
	      setHours = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(0),
	      _useState8 = _slicedToArray(_useState7, 2),
	      delta = _useState8[0],
	      setDelta = _useState8[1];
	
	  var interval = null;
	  (0, _react.useEffect)(function () {
	    var moduleDelta = delta % 3600;
	    setHours(Math.floor(delta / 3600));
	    setMinutes(Math.floor(moduleDelta / 60));
	    setSeconds(Math.floor(moduleDelta % 60));
	  }, [delta]);
	
	  var startTimer = function startTimer() {
	    if (!interval) {
	      var start = Date.now();
	      interval = setInterval(function () {
	        var delta = Date.now() - start;
	        setDelta(delta / 1000);
	      }, delay);
	    }
	  };
	
	  var stopTimer = function stopTimer() {
	    clearInterval(interval);
	    clear();
	    interval = null;
	  };
	
	  var clear = function clear() {
	    setHours(0);
	    setMinutes(0);
	    setSeconds(0);
	    setDelta(0);
	  };
	
	  var zeroPad = function zeroPad(value) {
	    return value < 10 ? "0".concat(value) : value;
	  };
	
	  var fullFormat = function fullFormat() {
	    return '' + zeroPad(hours) + ':' + zeroPad(minutes) + ':' + zeroPad(seconds);
	  };
	
	  return {
	    seconds: seconds,
	    minutes: minutes,
	    hours: hours,
	    fullFormat: fullFormat,
	    start: startTimer,
	    stop: stopTimer
	  };
	};
	
	var _default = useStopWatch;
	exports["default"] = _default;

/***/ },
/* 1919 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = __webpack_require__(1);
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var useStopWatch = function useStopWatch() {
	  var hoursInitial = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	  var minutesInitial = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	  var secondsInitial = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	  var delay = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1000;
	  var isAscending = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	
	  var _useState = (0, _react.useState)(secondsInitial),
	      _useState2 = _slicedToArray(_useState, 2),
	      seconds = _useState2[0],
	      setSeconds = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(minutesInitial),
	      _useState4 = _slicedToArray(_useState3, 2),
	      minutes = _useState4[0],
	      setMinutes = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(hoursInitial),
	      _useState6 = _slicedToArray(_useState5, 2),
	      hours = _useState6[0],
	      setHours = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(hoursInitial * 3600 + minutesInitial * 60 + secondsInitial),
	      _useState8 = _slicedToArray(_useState7, 2),
	      delta = _useState8[0],
	      setDelta = _useState8[1];
	
	  var interval = null;
	  (0, _react.useEffect)(function () {
	    var moduleDelta = delta % 3600;
	    setHours(Math.floor(delta / 3600));
	    setMinutes(Math.floor(moduleDelta / 60));
	    setSeconds(Math.floor(moduleDelta % 60));
	  }, [delta]);
	
	  var startTimer = function startTimer() {
	    if (!interval) {
	      var start = Date.now();
	      interval = setInterval(function () {
	        var dateDiff = Date.now() - start;
	        var deltaCalculated = isAscending ? delta + Math.floor(dateDiff / 1000) : delta - Math.floor(dateDiff / 1000);
	        setDelta(Math.ceil(deltaCalculated));
	      }, delay);
	    }
	  };
	
	  var stopTimer = function stopTimer() {
	    clearInterval(interval);
	    clear();
	    interval = null;
	  };
	
	  var clear = function clear() {
	    setHours(hoursInitial);
	    setMinutes(minutesInitial);
	    setSeconds(secondsInitial);
	    setDelta(hoursInitial * 3600 + minutesInitial * 60 + secondsInitial);
	  };
	
	  var zeroPad = function zeroPad(value) {
	    return value < 10 ? "0".concat(value) : value;
	  };
	
	  var fullFormat = function fullFormat() {
	    var hoursShow = !hours ? 0 : hours;
	    var minutesShow = !minutes ? 0 : minutes;
	    var secondsShow = !seconds ? 0 : seconds;
	    return '' + zeroPad(hoursShow) + ':' + zeroPad(minutesShow) + ':' + zeroPad(secondsShow);
	  };
	
	  return {
	    seconds: seconds,
	    minutes: minutes,
	    hours: hours,
	    fullFormat: fullFormat,
	    start: startTimer,
	    stop: stopTimer
	  };
	};
	
	var _default = useStopWatch;
	exports["default"] = _default;

/***/ },
/* 1920 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = __webpack_require__(1);
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var useStopWatch = function useStopWatch() {
	  var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1000;
	  var interval = null;
	
	  var _useState = (0, _react.useState)(0),
	      _useState2 = _slicedToArray(_useState, 2),
	      seconds = _useState2[0],
	      setSeconds = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(0),
	      _useState4 = _slicedToArray(_useState3, 2),
	      minutes = _useState4[0],
	      setMinutes = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(0),
	      _useState6 = _slicedToArray(_useState5, 2),
	      hours = _useState6[0],
	      setHours = _useState6[1];
	
	  var zeroPad = function zeroPad(value) {
	    return value < 10 ? "0".concat(value) : value;
	  };
	
	  (0, _react.useEffect)(function () {
	    var sec = seconds;
	    var min = minutes;
	    var hrs = hours;
	
	    if (sec === 60) {
	      sec = 0;
	      min = min + 1;
	    }
	
	    if (min === 60) {
	      sec = 0;
	      min = 0;
	      hrs = hrs + 1;
	    }
	
	    setHours(hrs);
	    setMinutes(min);
	    setSeconds(sec);
	  }, [seconds]);
	
	  var startTimer = function startTimer() {
	    if (!interval) {
	      interval = setInterval(function () {
	        setSeconds(function (prevSeconds) {
	          return prevSeconds + 1;
	        });
	      }, delay);
	    }
	  };
	
	  var stopTimer = function stopTimer() {
	    clearInterval(interval);
	    reset();
	    interval = null;
	  };
	
	  var reset = function reset() {
	    setHours(0);
	    setMinutes(0);
	    setSeconds(0);
	  };
	
	  var fullFormat = function fullFormat() {
	    return '' + zeroPad(hours) + ':' + zeroPad(minutes) + ':' + zeroPad(seconds);
	  };
	
	  return {
	    seconds: seconds,
	    minutes: minutes,
	    hours: hours,
	    fullFormat: fullFormat,
	    start: startTimer,
	    stop: stopTimer
	  };
	};
	
	var _default = useStopWatch;
	exports["default"] = _default;

/***/ },
/* 1921 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CreateWorker = /*#__PURE__*/_createClass(function CreateWorker(worker) {
	  _classCallCheck(this, CreateWorker);
	
	  ;
	  var code = worker.toString();
	  code = code.substring(code.indexOf("{") + 1, code.lastIndexOf("}"));
	  code = new Blob([code], {
	    type: 'application/javascript'
	  });
	  code = new Worker(URL.createObjectURL(code));
	  return code;
	});
	
	exports["default"] = CreateWorker;

/***/ },
/* 1922 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = __webpack_require__(1);
	
	var _CreateWorker = _interopRequireDefault(__webpack_require__(1921));
	
	var _worker = _interopRequireDefault(__webpack_require__(1923));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var workingWorker = new _CreateWorker["default"](_worker["default"]);
	
	var useStopWatch = function useStopWatch() {
	  var cleanTimer = {
	    seconds: 0,
	    minutes: 0,
	    hours: 0,
	    complete: '00:00:00'
	  };
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      enabled = _useState2[0],
	      setEnabled = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(cleanTimer),
	      _useState4 = _slicedToArray(_useState3, 2),
	      timer = _useState4[0],
	      setTimer = _useState4[1];
	
	  workingWorker.addEventListener('message', function (_ref) {
	    var data = _ref.data;
	    setTimer(data);
	  });
	
	  var startTimer = function startTimer() {
	    if (!enabled) {
	      workingWorker = new _CreateWorker["default"](_worker["default"]);
	      workingWorker.postMessage('start');
	      setEnabled(true);
	    }
	  };
	
	  var stopTimer = function stopTimer() {
	    workingWorker.terminate();
	    setTimer(cleanTimer);
	    setEnabled(false);
	  };
	
	  return {
	    seconds: timer.seconds,
	    minutes: timer.minutes,
	    hours: timer.hours,
	    fullFormat: timer.complete,
	    start: startTimer,
	    stop: stopTimer
	  };
	};
	
	var _default = useStopWatch;
	exports["default"] = _default;

/***/ },
/* 1923 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var worker = function worker() {
	  var zeroPad = function zeroPad(value) {
	    return value < 10 ? "0".concat(value) : value;
	  };
	
	  var countFunc = function countFunc() {
	    var start = Date.now();
	    setInterval(function () {
	      var delta = (Date.now() - start) / 1000;
	      var moduleDelta = delta % 3600;
	      var hours = Math.floor(delta / 3600);
	      var minutes = Math.floor(moduleDelta / 60);
	      var seconds = Math.floor(moduleDelta % 60);
	      var complete = '' + zeroPad(hours) + ':' + zeroPad(minutes) + ':' + zeroPad(seconds);
	      postMessage({
	        hours: hours,
	        minutes: minutes,
	        seconds: seconds,
	        complete: complete
	      });
	    }, 700);
	  }; // eslint-disable-next-line no-restricted-globals
	
	
	  self.onmessage = function () {
	    countFunc();
	  };
	};
	
	var _default = worker;
	exports["default"] = _default;

/***/ },
/* 1924 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "useStopWatchBasic", {
	  enumerable: true,
	  get: function get() {
	    return _useStopWatch["default"];
	  }
	});
	Object.defineProperty(exports, "useStopWatchCountDown", {
	  enumerable: true,
	  get: function get() {
	    return _useStopWatch4["default"];
	  }
	});
	Object.defineProperty(exports, "useStopWatchInterval", {
	  enumerable: true,
	  get: function get() {
	    return _useStopWatch2["default"];
	  }
	});
	Object.defineProperty(exports, "useStopWatchWorker", {
	  enumerable: true,
	  get: function get() {
	    return _useStopWatch3["default"];
	  }
	});
	
	var _useStopWatch = _interopRequireDefault(__webpack_require__(1918));
	
	var _useStopWatch2 = _interopRequireDefault(__webpack_require__(1920));
	
	var _useStopWatch3 = _interopRequireDefault(__webpack_require__(1922));
	
	var _useStopWatch4 = _interopRequireDefault(__webpack_require__(1919));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/***/ },
/* 1925 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	__webpack_require__(2580);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var Switch = function Switch(_ref) {
	  var disabled = _ref.disabled,
	      checked = _ref.checked,
	      onChange = _ref.onChange;
	
	  var changeHandler = function changeHandler(_ref2) {
	    var target = _ref2.target;
	    onChange(target.checked);
	  };
	
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: "switch-container"
	  }, /*#__PURE__*/_react["default"].createElement("label", {
	    className: "switch"
	  }, /*#__PURE__*/_react["default"].createElement("input", {
	    type: "checkbox",
	    onChange: changeHandler,
	    disabled: disabled,
	    checked: checked
	  }), /*#__PURE__*/_react["default"].createElement("span", {
	    className: "slider round"
	  })));
	};
	
	Switch.propTypes = {
	  onChange: _propTypes["default"].func.isRequired,
	  disabled: _propTypes["default"].bool,
	  checked: _propTypes["default"].bool
	};
	Switch.defaultProps = {
	  onChange: function onChange() {
	    return console.warn('no function was assigned as prop');
	  },
	  disabled: false,
	  checked: false
	};
	var _default = Switch;
	exports["default"] = _default;

/***/ },
/* 1926 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	__webpack_require__(2581);
	
	__webpack_require__(2582);
	
	var _useItemSelect = _interopRequireDefault(__webpack_require__(426));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var Tab = function Tab(props) {
	  var _useTab = (0, _useItemSelect["default"])(props),
	      _useTab2 = _slicedToArray(_useTab, 2),
	      setChecked = _useTab2[0],
	      classes = _useTab2[1];
	
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: 'gcl-tab-primary ' + classes,
	    tabIndex: props.id,
	    onClick: setChecked
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: 'gcl-tab-primary-text'
	  }, props.children), /*#__PURE__*/_react["default"].createElement("div", {
	    className: 'gcl-tab-primary-footer'
	  }));
	};
	
	Tab.propTypes = {
	  disabled: _propTypes["default"].bool,
	  checked: _propTypes["default"].bool,
	  id: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired,
	  children: _propTypes["default"].any.isRequired
	};
	Tab.defaultProps = {
	  checked: false,
	  disabled: false
	};
	var _default = Tab;
	exports["default"] = _default;

/***/ },
/* 1927 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	__webpack_require__(2583);
	
	var _useItemSelect = _interopRequireDefault(__webpack_require__(426));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var Tab = function Tab(props) {
	  var _useTab = (0, _useItemSelect["default"])(props),
	      _useTab2 = _slicedToArray(_useTab, 2),
	      setChecked = _useTab2[0],
	      classes = _useTab2[1];
	
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: 'gcl-tab-secondary ' + classes,
	    tabindex: props.id,
	    onClick: setChecked
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: 'gcl-tab-secondary-id'
	  }, props.id), /*#__PURE__*/_react["default"].createElement("div", {
	    className: 'gcl-tab-secondary-text'
	  }, props.children));
	};
	
	Tab.propTypes = {
	  disabled: _propTypes["default"].bool,
	  checked: _propTypes["default"].bool,
	  id: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired,
	  children: _propTypes["default"].any.isRequired
	};
	Tab.defaultProps = {
	  checked: false,
	  disabled: false
	};
	var _default = Tab;
	exports["default"] = _default;

/***/ },
/* 1928 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	__webpack_require__(2584);
	
	__webpack_require__(2585);
	
	var _useItemSelect = _interopRequireDefault(__webpack_require__(426));
	
	var _reactstrap = __webpack_require__(48);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var Tab = function Tab(props) {
	  var _useTab = (0, _useItemSelect["default"])(props),
	      _useTab2 = _slicedToArray(_useTab, 2),
	      onClick = _useTab2[0],
	      classes = _useTab2[1];
	
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    id: props.id,
	    onClick: onClick,
	    className: 'gcl-sidebar-tab ' + classes,
	    disabled: props.disabled
	  }, props.unread === true ? /*#__PURE__*/_react["default"].createElement("span", {
	    className: "gcl-st-dot"
	  }) : props.unread > 0 && /*#__PURE__*/_react["default"].createElement("div", {
	    className: 'gcl-sidebar-tab-counter'
	  }, (props.unread > 9 ? '+' : '') + Math.min(props.unread, 9)), props.children, props.tooltip && /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
	    target: props.id,
	    placement: "right",
	    trigger: "hover",
	    boundariesElement: "window"
	  }, props.tooltip));
	};
	
	Tab.propTypes = {
	  disabled: _propTypes["default"].bool,
	  checked: _propTypes["default"].bool,
	  id: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired,
	  children: _propTypes["default"].any.isRequired,
	  unread: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].number])
	};
	Tab.defaultProps = {
	  checked: false,
	  disabled: false,
	  unread: false
	};
	var _default = Tab;
	exports["default"] = _default;

/***/ },
/* 1929 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _ItemSelectContext = __webpack_require__(425);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var TabPanel = function TabPanel(props) {
	  var _useContext = (0, _react.useContext)(_ItemSelectContext.Context),
	      _useContext2 = _slicedToArray(_useContext, 1),
	      currentTab = _useContext2[0];
	
	  return currentTab === props.tabIdRef ? /*#__PURE__*/_react["default"].createElement("div", {
	    className: props.className
	  }, props.children) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null);
	};
	
	TabPanel.propTypes = {
	  className: _propTypes["default"].string,
	  tabIdRef: _propTypes["default"].any.isRequired
	};
	var _default = TabPanel;
	exports["default"] = _default;

/***/ },
/* 1930 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.Row = exports.Column = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	__webpack_require__(2586);
	
	__webpack_require__(2587);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var Table = function Table(_ref) {
	  var children = _ref.children,
	      _ref$className = _ref.className,
	      className = _ref$className === void 0 ? '' : _ref$className;
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-table ".concat(className)
	  }, children);
	};
	
	var Row = function Row(_ref2) {
	  var children = _ref2.children,
	      type = _ref2.type,
	      position = _ref2.position,
	      assigned = _ref2.assigned,
	      selected = _ref2.selected,
	      _ref2$className = _ref2.className,
	      className = _ref2$className === void 0 ? '' : _ref2$className;
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-table-row ".concat(type === 'header' || type === 'footer' ? 'gcl-' + type : '', " ").concat(position, " ").concat(className).concat(assigned ? ' assigned' : '').concat(selected ? ' selected' : '')
	  }, children);
	};
	
	exports.Row = Row;
	
	var Column = function Column(_ref3) {
	  var children = _ref3.children,
	      _ref3$className = _ref3.className,
	      className = _ref3$className === void 0 ? '' : _ref3$className;
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-table-column ".concat(className)
	  }, children);
	};
	
	exports.Column = Column;
	Table.propTypes = {
	  children: _propTypes["default"].node,
	  className: _propTypes["default"].string
	};
	Row.propTypes = {
	  children: _propTypes["default"].node,
	  type: _propTypes["default"].oneOf(['header', 'footer', '']),
	  position: _propTypes["default"].oneOf(['fixed', '']),
	  assigned: _propTypes["default"].bool,
	  selected: _propTypes["default"].bool,
	  className: _propTypes["default"].string
	};
	Row.defaultProps = {
	  type: '',
	  position: ''
	};
	Column.propTypes = {
	  children: _propTypes["default"].node,
	  className: _propTypes["default"].string
	};
	var _default = Table;
	exports["default"] = _default;

/***/ },
/* 1931 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _hooks = __webpack_require__(424);
	
	__webpack_require__(2589);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var IconToast = function IconToast(_ref) {
	  var icon = _ref.icon,
	      iconColor = _ref.iconColor,
	      title = _ref.title,
	      message = _ref.message,
	      color = _ref.color,
	      btnComponent = _ref.btnComponent,
	      onDismiss = _ref.onDismiss,
	      onClose = _ref.onClose,
	      timeout = _ref.timeout;
	
	  var _useOpenAndDismiss = (0, _hooks.useOpenAndDismiss)(onClose, onDismiss, timeout),
	      _useOpenAndDismiss2 = _slicedToArray(_useOpenAndDismiss, 2),
	      isOpen = _useOpenAndDismiss2[0],
	      dismissToast = _useOpenAndDismiss2[1];
	
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: 'gcl-icon-toast-wrapper' + (isOpen ? ' open' : '')
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: 'gcl-icon-toast' + (title == null ? ' no-title' : '')
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-toast-color ".concat(color)
	  }), /*#__PURE__*/_react["default"].createElement("div", {
	    className: 'gcl-toast-icon ' + iconColor
	  }, icon && /*#__PURE__*/_react["default"].createElement("i", {
	    className: 'gcl-icon ' + icon
	  })), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-toast-body"
	  }, title && /*#__PURE__*/_react["default"].createElement("p", {
	    className: "gcl-toast-title"
	  }, title), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-toast-msg"
	  }, message)), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-toast-btn"
	  }, /*#__PURE__*/_react["default"].cloneElement(btnComponent, {
	    onClick: dismissToast
	  }))));
	};
	
	IconToast.propTypes = {
	  icon: _propTypes["default"].string,
	  title: _propTypes["default"].string,
	  message: _propTypes["default"].string.isRequired,
	  btnComponent: _propTypes["default"].element.isRequired,
	  onDismiss: _propTypes["default"].func,
	  onClose: _propTypes["default"].func,
	  timeout: _propTypes["default"].number,
	  color: _propTypes["default"].oneOf(['blue', 'red', 'green', 'yellow']),
	  iconColor: _propTypes["default"].oneOf(['blue', 'red', 'green', 'yellow'])
	};
	IconToast.defaultProps = {
	  color: 'blue',
	  timeout: 7500
	};
	var _default = IconToast;
	exports["default"] = _default;

/***/ },
/* 1932 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _Button = _interopRequireDefault(__webpack_require__(97));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _hooks = __webpack_require__(424);
	
	__webpack_require__(2590);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var SnackBarToast = function SnackBarToast(_ref) {
	  var type = _ref.type,
	      message = _ref.message,
	      onClose = _ref.onClose,
	      onDismiss = _ref.onDismiss,
	      position = _ref.position,
	      btnLabel = _ref.btnLabel,
	      btnComponent = _ref.btnComponent,
	      timeout = _ref.timeout;
	
	  var _useOpenAndDismiss = (0, _hooks.useOpenAndDismiss)(onClose, onDismiss, timeout),
	      _useOpenAndDismiss2 = _slicedToArray(_useOpenAndDismiss, 2),
	      isOpen = _useOpenAndDismiss2[0],
	      dismissToast = _useOpenAndDismiss2[1];
	
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: 'gcl-sidebar-toast-wrapper' + (isOpen ? ' open' : '')
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-sidebar-toast ".concat(position.includes('Right') ? 'right' : 'left', " ").concat(type)
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-sidebar-toast-msg"
	  }, message), /*#__PURE__*/_react["default"].createElement("div", null, btnComponent != null ? /*#__PURE__*/_react["default"].cloneElement(btnComponent, {
	    onClick: dismissToast
	  }) : /*#__PURE__*/_react["default"].createElement(_Button["default"], {
	    color: "tertiary",
	    alt: true,
	    onClick: dismissToast
	  }, btnLabel))));
	};
	
	SnackBarToast.propTypes = {
	  message: _propTypes["default"].string.isRequired,
	  onClose: _propTypes["default"].func.isRequired,
	  onDismiss: _propTypes["default"].func,
	  btnLabel: _propTypes["default"].string,
	  btnComponent: _propTypes["default"].element,
	  timeout: _propTypes["default"].number,
	  type: _propTypes["default"].oneOf(['dark', 'light']),
	  position: _propTypes["default"].oneOf(['topLeft', 'topRight', 'bottomLeft', 'bottomRight']).isRequired
	};
	SnackBarToast.defaultProps = {
	  type: 'dark',
	  timeout: 3000
	};
	var _default = SnackBarToast;
	exports["default"] = _default;

/***/ },
/* 1933 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.useToasts = exports.ToastProvider = exports.ToastConsumer = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _Toast = _interopRequireDefault(__webpack_require__(702));
	
	var _SnackBarToast = _interopRequireDefault(__webpack_require__(1932));
	
	var _IconToast = _interopRequireDefault(__webpack_require__(1931));
	
	__webpack_require__(2592);
	
	var _excluded = ["id"];
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var queueContext = /*#__PURE__*/_react["default"].createContext({
	  queue: [],
	  addToast: function addToast() {},
	  removeToast: function removeToast() {}
	});
	
	var useQueueContext = function useQueueContext() {
	  var _useState = (0, _react.useState)([]),
	      _useState2 = _slicedToArray(_useState, 2),
	      queue = _useState2[0],
	      setQueue = _useState2[1];
	
	  var idCounter = (0, _react.useRef)(0);
	
	  var addToast = function addToast(message, options) {
	    return setQueue(function (q) {
	      return [].concat(_toConsumableArray(q), [_objectSpread({
	        id: idCounter.current++,
	        message: message
	      }, options)]);
	    });
	  };
	
	  var removeToast = function removeToast(id) {
	    return setQueue(function (q) {
	      return q.filter(function (toast) {
	        return toast.id !== id;
	      });
	    });
	  };
	
	  return {
	    queue: queue,
	    addToast: addToast,
	    removeToast: removeToast
	  };
	};
	
	var useToasts = function useToasts() {
	  var ctx = (0, _react.useContext)(queueContext);
	  return _objectSpread({}, ctx);
	};
	
	exports.useToasts = useToasts;
	
	var ToastContainer = function ToastContainer() {
	  var _useToasts = useToasts(),
	      queue = _useToasts.queue,
	      removeToast = _useToasts.removeToast;
	
	  var positions = ['topLeft', 'topRight', 'bottomLeft', 'bottomRight'];
	
	  var toastContainer = function toastContainer(position) {
	    return /*#__PURE__*/_react["default"].createElement("div", {
	      key: position,
	      className: 'gcl-toast-container ' + position
	    }, queue.filter(function (t) {
	      return t.position === position;
	    }).map(function (_ref) {
	      var id = _ref.id,
	          toast = _objectWithoutProperties(_ref, _excluded);
	
	      return /*#__PURE__*/_react["default"].createElement(ToastChooser, {
	        key: id,
	        group: toast.group,
	        toast: toast,
	        onClose: function onClose() {
	          return removeToast(id);
	        }
	      });
	    }));
	  };
	
	  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, positions.map(function (position) {
	    return toastContainer(position);
	  }));
	};
	
	var ToastChooser = function ToastChooser(_ref2) {
	  var group = _ref2.group,
	      toast = _ref2.toast,
	      onClose = _ref2.onClose;
	
	  switch (group) {
	    case 'snackbar':
	      return /*#__PURE__*/_react["default"].createElement(_SnackBarToast["default"], _extends({
	        onClose: onClose
	      }, toast));
	
	    case 'inbox':
	      return /*#__PURE__*/_react["default"].createElement(_Toast["default"], _extends({
	        onClose: onClose
	      }, toast));
	
	    case 'icon':
	      return /*#__PURE__*/_react["default"].createElement(_IconToast["default"], _extends({
	        onClose: onClose
	      }, toast));
	
	    default:
	      return null;
	  }
	};
	
	var ToastProvider = function ToastProvider(_ref3) {
	  var children = _ref3.children;
	  return /*#__PURE__*/_react["default"].createElement(queueContext.Provider, {
	    value: useQueueContext()
	  }, /*#__PURE__*/_react["default"].createElement(ToastContainer, null), children);
	};
	
	exports.ToastProvider = ToastProvider;
	
	var ToastConsumer = function ToastConsumer(_ref4) {
	  var children = _ref4.children;
	  return /*#__PURE__*/_react["default"].createElement(queueContext.Consumer, null, function (context) {
	    return children(context);
	  });
	};
	
	exports.ToastConsumer = ToastConsumer;

/***/ },
/* 1934 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classNames = _interopRequireDefault(__webpack_require__(61));
	
	__webpack_require__(2593);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var ToggleChip = function ToggleChip(_ref) {
	  var id = _ref.id,
	      label = _ref.label,
	      active = _ref.active,
	      toggle = _ref.toggle,
	      disabled = _ref.disabled,
	      tabIndex = _ref.tabIndex;
	  var classes = (0, _classNames["default"])({
	    active: active,
	    disabled: disabled
	  });
	  return /*#__PURE__*/_react["default"].createElement("button", {
	    id: id,
	    className: 'uin-toggle-chip ' + classes,
	    onClick: toggle,
	    tabIndex: tabIndex
	  }, /*#__PURE__*/_react["default"].createElement("span", {
	    className: "uin-chip-icon"
	  }, /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon sent"
	  })), /*#__PURE__*/_react["default"].createElement("span", {
	    className: "uin-chip-label"
	  }, label));
	};
	
	ToggleChip.propTypes = {
	  label: _propTypes["default"].string.isRequired,
	  active: _propTypes["default"].bool,
	  toggle: _propTypes["default"].func.isRequired,
	  disabled: _propTypes["default"].bool
	};
	var _default = ToggleChip;
	exports["default"] = _default;

/***/ },
/* 1935 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.UNAVAILABLE_ICONS_DICTIONARY = exports.UNAVAILABLE_ICONS = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	__webpack_require__(2594);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var UNAVAILABLE_ICON_TYPES = {
	  4: 'admin',
	  1: 'food',
	  11: 'time',
	  10: 'water',
	  16: 'elevator',
	  7: 'lunch',
	  13: 'medic',
	  6: 'meeting',
	  15: 'money',
	  14: 'notify',
	  3: 'people',
	  12: 'unknown',
	  2: 'restroom',
	  5: 'talking',
	  8: 'station',
	  9: 'coffee'
	};
	var UNAVAILABLE_ICONS = new Proxy(UNAVAILABLE_ICON_TYPES, {
	  get: function get(object, property) {
	    return object.hasOwnProperty(property) ? object[property] : 'unknown';
	  }
	});
	exports.UNAVAILABLE_ICONS = UNAVAILABLE_ICONS;
	var UNAVAILABLE_ICONS_DICT = {
	  4: 'admin-v2',
	  1: 'apple',
	  11: 'clock',
	  10: 'droplet',
	  16: 'elevator',
	  7: 'lunch',
	  13: 'medic',
	  6: 'meeting-v2',
	  15: 'money',
	  14: 'notify',
	  3: 'people',
	  12: 'question-neg',
	  2: 'restroom',
	  5: 'speech',
	  8: 'station-cog',
	  9: 'teacup'
	};
	var UNAVAILABLE_ICONS_DICTIONARY = new Proxy(UNAVAILABLE_ICONS_DICT, {
	  get: function get(object, property) {
	    return object.hasOwnProperty(property) ? object[property] : 'question-neg';
	  }
	});
	exports.UNAVAILABLE_ICONS_DICTIONARY = UNAVAILABLE_ICONS_DICTIONARY;
	
	var UnavailableIcon = function UnavailableIcon(_ref) {
	  var type = _ref.type,
	      size = _ref.size,
	      selected = _ref.selected,
	      onClick = _ref.onClick;
	  return /*#__PURE__*/_react["default"].createElement("span", {
	    className: "gcl-unavailable-icon ".concat(size, " ").concat(onClick != null ? 'selectable' : '', " ").concat(selected ? 'selected' : ''),
	    "data-unavailable-status": UNAVAILABLE_ICONS[type],
	    onClick: onClick
	  }, /*#__PURE__*/_react["default"].createElement("i", {
	    className: 'gcl-icon ' + UNAVAILABLE_ICONS_DICTIONARY[type]
	  }));
	};
	
	UnavailableIcon.propTypes = {
	  type: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  size: _propTypes["default"].oneOf(['sm', 'md', 'lg']),
	  selected: _propTypes["default"].bool,
	  onClick: _propTypes["default"].func
	};
	UnavailableIcon.defaultProps = {
	  type: 12,
	  size: 'lg'
	};
	var _default = UnavailableIcon;
	exports["default"] = _default;

/***/ },
/* 1936 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _Checkbox = _interopRequireDefault(__webpack_require__(274));
	
	var _Button = _interopRequireDefault(__webpack_require__(97));
	
	var _DropDownMenu = _interopRequireWildcard(__webpack_require__(693));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	__webpack_require__(2595);
	
	__webpack_require__(2596);
	
	var _reactstrap = __webpack_require__(48);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var WGResourceItem = function WGResourceItem(_ref) {
	  var idCheck = _ref.idCheck,
	      label = _ref.label,
	      disabledCheck = _ref.disabledCheck,
	      selected = _ref.selected,
	      onEdit = _ref.onEdit,
	      onDelete = _ref.onDelete,
	      onAssociations = _ref.onAssociations,
	      onClickedChange = _ref.onClickedChange,
	      campaignType = _ref.campaignType,
	      iconSrc = _ref.iconSrc,
	      clicked = _ref.clicked,
	      labelCampaignType = _ref.labelCampaignType,
	      labelButtonClicked = _ref.labelButtonClicked,
	      labelButtonNotClicked = _ref.labelButtonNotClicked,
	      labelEdit = _ref.labelEdit,
	      labelAssociations = _ref.labelAssociations,
	      labelDelete = _ref.labelDelete,
	      titleLabel = _ref.titleLabel,
	      disabled = _ref.disabled,
	      warning = _ref.warning,
	      labelRemove = _ref.labelRemove,
	      onRemove = _ref.onRemove;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      checked = _useState2[0],
	      setChecked = _useState2[1];
	
	  var refTooltip = (0, _react.useRef)();
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-WGResource-item ".concat(clicked ? 'clicked' : '', " ").concat(selected ? 'selected' : '', " ").concat(checked ? 'checked' : '')
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: 'gcl-WGResource-item-title'
	  }, /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
	    id: idCheck,
	    checked: checked,
	    disabled: disabledCheck,
	    onChange: setChecked,
	    assigned: clicked
	  }), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "glc-WGResource-icon ".concat(campaignType == '0' ? 'inbound' : 'outbound')
	  }, /*#__PURE__*/_react["default"].createElement("i", {
	    className: 'gcl-icon ' + iconSrc
	  })), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-WGResource-item-campaign"
	  }, /*#__PURE__*/_react["default"].createElement("span", {
	    className: "gcl-WGResource-item-campaign-label"
	  }, titleLabel), /*#__PURE__*/_react["default"].createElement("span", {
	    ref: refTooltip
	  }, label), /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
	    placement: "top",
	    target: refTooltip,
	    autohide: false,
	    trigger: 'hover'
	  }, label))), /*#__PURE__*/_react["default"].createElement("span", {
	    className: "glc-campaign-type"
	  }, labelCampaignType), /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-WGResource-item-btns ".concat(selected && 'selected', " ")
	  }, /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-WGResource-item-warning ".concat(warning && 'show')
	  }, /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon info",
	    id: 'gcl-WGResource-item-btns' + idCheck
	  }), /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
	    delay: {
	      show: 500,
	      hide: 100
	    },
	    placement: "top",
	    target: 'gcl-WGResource-item-btns' + idCheck
	  }, warning)), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
	    toggle: true,
	    onClick: onClickedChange,
	    active: clicked,
	    disabled: disabled
	  }, clicked ? labelButtonNotClicked : labelButtonClicked), /*#__PURE__*/_react["default"].createElement(_DropDownMenu["default"], null, onEdit != null && /*#__PURE__*/_react["default"].createElement(_DropDownMenu.Option, {
	    onClick: function onClick() {
	      onEdit({
	        id: idCheck,
	        campaignType: campaignType
	      });
	    }
	  }, /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon edit"
	  }), labelEdit), /*#__PURE__*/_react["default"].createElement(_DropDownMenu.Option, {
	    onClick: onAssociations
	  }, /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon association"
	  }), labelAssociations), onRemove != null && /*#__PURE__*/_react["default"].createElement(_DropDownMenu.Option, {
	    onClick: onRemove
	  }, /*#__PURE__*/_react["default"].createElement("i", {
	    "class": "gcl-icon rounded-arrow"
	  }), labelRemove), onDelete != null && /*#__PURE__*/_react["default"].createElement(_DropDownMenu.Option, {
	    onClick: function onClick() {
	      onDelete({
	        id: idCheck,
	        campaignType: campaignType
	      });
	    }
	  }, /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon trash"
	  }), labelDelete))));
	};
	
	WGResourceItem.propTypes = {
	  idCheck: _propTypes["default"].isRequired,
	  label: _propTypes["default"].string,
	  checked: _propTypes["default"].bool,
	  disabledCheck: _propTypes["default"].bool,
	  selected: _propTypes["default"].bool,
	  onCheckChange: _propTypes["default"].func,
	  onEdit: _propTypes["default"].func,
	  onDelete: _propTypes["default"].func,
	  onClickedChange: _propTypes["default"].func,
	  onAssociations: _propTypes["default"].func,
	  campaignType: _propTypes["default"].string,
	  iconSrc: _propTypes["default"].string,
	  clicked: _propTypes["default"].bool,
	  labelCampaignType: _propTypes["default"].string,
	  labelButtonClicked: _propTypes["default"].string,
	  labelButtonNotClicked: _propTypes["default"].string,
	  labelEdit: _propTypes["default"].string,
	  labelDelete: _propTypes["default"].string,
	  labelAssociations: _propTypes["default"].string,
	  titleLabel: _propTypes["default"].string,
	  disabled: _propTypes["default"].bool,
	  warning: _propTypes["default"].string
	};
	WGResourceItem.defaultProps = {
	  disabledCheck: false,
	  selected: false,
	  onCheckChange: function onCheckChange() {},
	  onAssociations: function onAssociations() {},
	  onClickedChange: function onClickedChange() {},
	  campaignType: '1',
	  iconSrc: '',
	  clicked: false,
	  labelCampaignType: '',
	  labelButtonClicked: 'Assign',
	  labelButtonNotClicked: 'Unassign',
	  labelEdit: 'Edit',
	  labelDelete: 'Delete',
	  labelAssociations: 'Associations',
	  titleLabel: '',
	  disabled: false,
	  warning: null
	};
	var _default = WGResourceItem;
	exports["default"] = _default;

/***/ },
/* 1937 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.WizardStep = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classNames = _interopRequireDefault(__webpack_require__(61));
	
	__webpack_require__(2597);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var WizardProgressBar = function WizardProgressBar(_ref) {
	  var children = _ref.children;
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-wizard-progress"
	  }, children);
	};
	
	WizardProgressBar.propTypes = {};
	var _default = WizardProgressBar;
	exports["default"] = _default;
	
	var WizardStep = function WizardStep(_ref2) {
	  var id = _ref2.id,
	      active = _ref2.active,
	      completed = _ref2.completed,
	      disabled = _ref2.disabled,
	      optional = _ref2.optional,
	      captionOptional = _ref2.captionOptional,
	      onClick = _ref2.onClick,
	      children = _ref2.children;
	  var classes = (0, _classNames["default"])({
	    completed: completed,
	    active: active,
	    disabled: disabled,
	    optional: optional
	  });
	  return /*#__PURE__*/_react["default"].createElement("div", {
	    className: 'gcl-wizard-step ' + classes
	  }, optional && /*#__PURE__*/_react["default"].createElement("div", {
	    className: "gcl-wizard-step-caption-optional"
	  }, captionOptional), /*#__PURE__*/_react["default"].createElement("button", {
	    className: "gcl-step-btn",
	    onClick: onClick,
	    disabled: active || disabled
	  }, /*#__PURE__*/_react["default"].createElement("i", {
	    className: "gcl-icon selected"
	  })), /*#__PURE__*/_react["default"].createElement("label", null, children));
	};
	
	exports.WizardStep = WizardStep;

/***/ },
/* 1938 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = __webpack_require__(1);
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var useTimerDownUp = function useTimerDownUp(_ref) {
	  var secondsInitial = _ref.secondsInitial,
	      _ref$isAscending = _ref.isAscending,
	      isAscending = _ref$isAscending === void 0 ? false : _ref$isAscending,
	      _ref$delay = _ref.delay,
	      delay = _ref$delay === void 0 ? 1000 : _ref$delay,
	      _ref$counterUpMax = _ref.counterUpMax,
	      counterUpMax = _ref$counterUpMax === void 0 ? 30000 : _ref$counterUpMax;
	
	  var _useState = (0, _react.useState)(Math.floor(secondsInitial / 3600)),
	      _useState2 = _slicedToArray(_useState, 2),
	      hours = _useState2[0],
	      setHours = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(Math.floor(secondsInitial % 3600 / 60)),
	      _useState4 = _slicedToArray(_useState3, 2),
	      minutes = _useState4[0],
	      setMinutes = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(Math.floor(secondsInitial % 3600 % 60)),
	      _useState6 = _slicedToArray(_useState5, 2),
	      seconds = _useState6[0],
	      setSeconds = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(secondsInitial),
	      _useState8 = _slicedToArray(_useState7, 2),
	      timeLeft = _useState8[0],
	      setTimeLeft = _useState8[1];
	
	  var interval = (0, _react.useRef)();
	  (0, _react.useEffect)(function () {
	    if (timeLeft <= 0 || timeLeft >= counterUpMax) {
	      stopTimer();
	    }
	
	    var moduleDelta = timeLeft % 3600;
	    setHours(Math.floor(timeLeft / 3600));
	    setMinutes(Math.floor(moduleDelta / 60));
	    setSeconds(Math.floor(moduleDelta % 60));
	
	    if (interval.current === null && timeLeft >= 0 && timeLeft <= counterUpMax) {
	      startTimer();
	    }
	  }, [timeLeft]);
	  (0, _react.useEffect)(function () {
	    stopTimer();
	    reset();
	  }, [secondsInitial]);
	
	  var startTimer = function startTimer() {
	    if (!interval.current) {
	      var timeNowMilliseconds = Date.now();
	      interval.current = setInterval(function () {
	        var timeNowSeconds = Date.now();
	        var timerTranscurrent = Math.round((timeNowSeconds - timeNowMilliseconds) / 1000);
	
	        if (isAscending) {
	          setTimeLeft(timeLeft + timerTranscurrent);
	        } else {
	          setTimeLeft(timeLeft - timerTranscurrent);
	        }
	      }, delay);
	    }
	  };
	
	  var stopTimer = function stopTimer() {
	    clearInterval(interval.current);
	    interval.current = null;
	  };
	
	  var reset = function reset() {
	    setHours(Math.floor(secondsInitial / 3600));
	    setMinutes(Math.floor(secondsInitial % 3600 / 60));
	    setSeconds(Math.floor(secondsInitial % 3600 % 60));
	    setTimeLeft(secondsInitial);
	  };
	
	  var clear = function clear() {
	    stopTimer();
	    setHours(0);
	    setMinutes(0);
	    setSeconds(0);
	    setTimeLeft(0);
	  };
	
	  var zeroPad = function zeroPad(value) {
	    return value.toString().padStart(2, '0');
	  };
	
	  var fullFormat = function fullFormat() {
	    return "".concat(zeroPad(hours), ":").concat(zeroPad(minutes), ":").concat(zeroPad(seconds));
	  };
	
	  return {
	    timeLeft: timeLeft,
	    setTimeLeft: setTimeLeft,
	    hours: hours,
	    minutes: minutes,
	    seconds: seconds,
	    startTimer: startTimer,
	    stopTimer: stopTimer,
	    clear: clear,
	    reset: reset,
	    fullFormat: fullFormat
	  };
	};
	
	var _default = useTimerDownUp;
	exports["default"] = _default;

/***/ },
/* 1939 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RequestException = exports.NotFoundException = void 0;
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NotFoundException = /*#__PURE__*/_createClass(function NotFoundException(message) {
	  _classCallCheck(this, NotFoundException);
	
	  this.name = 'NotFound';
	  this.message = message;
	  this.stack = new Error().stack;
	});
	
	exports.NotFoundException = NotFoundException;
	
	var RequestException = /*#__PURE__*/_createClass(function RequestException(status, message) {
	  _classCallCheck(this, RequestException);
	
	  this.name = 'RequestException';
	  this.status = status;
	  this.message = message;
	  this.stack = new Error().stack;
	});
	
	exports.RequestException = RequestException;

/***/ },
/* 1940 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.range = void 0;
	
	var range = function range(start, stop, step) {
	  return Array.from({
	    length: (stop - start) / step + 1
	  }, function (_, i) {
	    return start + i * step;
	  });
	};
	
	exports.range = range;

/***/ },
/* 1941 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {!function(e,t){ true?t(exports,__webpack_require__(1),__webpack_require__(2),__webpack_require__(3),__webpack_require__(398),__webpack_require__(96),__webpack_require__(393),__webpack_require__(262),__webpack_require__(261),__webpack_require__(95),__webpack_require__(209),__webpack_require__(170),__webpack_require__(385),__webpack_require__(669),__webpack_require__(667),__webpack_require__(214),__webpack_require__(670),__webpack_require__(414),__webpack_require__(671),__webpack_require__(641),__webpack_require__(639),__webpack_require__(636),__webpack_require__(210),__webpack_require__(394),__webpack_require__(397),__webpack_require__(640),__webpack_require__(395),__webpack_require__(643),__webpack_require__(396),__webpack_require__(663),__webpack_require__(661),__webpack_require__(659),__webpack_require__(268),__webpack_require__(662),__webpack_require__(664),__webpack_require__(410),__webpack_require__(409),__webpack_require__(120),__webpack_require__(386),__webpack_require__(387),__webpack_require__(388),__webpack_require__(211),__webpack_require__(109),__webpack_require__(213),__webpack_require__(269),__webpack_require__(270),__webpack_require__(265),__webpack_require__(392),__webpack_require__(266),__webpack_require__(646),__webpack_require__(172),__webpack_require__(399),__webpack_require__(402),__webpack_require__(400),__webpack_require__(644),__webpack_require__(645),__webpack_require__(654),__webpack_require__(9),__webpack_require__(411),__webpack_require__(658),__webpack_require__(940),__webpack_require__(75),__webpack_require__(31)):"function"==typeof define&&define.amd?define(["exports","react","prop-types","classnames","date-fns/isDate","date-fns/isValid","date-fns/format","date-fns/addMinutes","date-fns/addHours","date-fns/addDays","date-fns/addWeeks","date-fns/addMonths","date-fns/addYears","date-fns/subMinutes","date-fns/subHours","date-fns/subDays","date-fns/subWeeks","date-fns/subMonths","date-fns/subYears","date-fns/getSeconds","date-fns/getMinutes","date-fns/getHours","date-fns/getDay","date-fns/getDate","date-fns/getWeek","date-fns/getMonth","date-fns/getQuarter","date-fns/getYear","date-fns/getTime","date-fns/setSeconds","date-fns/setMinutes","date-fns/setHours","date-fns/setMonth","date-fns/setQuarter","date-fns/setYear","date-fns/min","date-fns/max","date-fns/differenceInCalendarDays","date-fns/differenceInCalendarMonths","date-fns/differenceInCalendarWeeks","date-fns/differenceInCalendarYears","date-fns/startOfDay","date-fns/startOfWeek","date-fns/startOfMonth","date-fns/startOfQuarter","date-fns/startOfYear","date-fns/endOfDay","date-fns/endOfWeek","date-fns/endOfMonth","date-fns/isEqual","date-fns/isSameDay","date-fns/isSameMonth","date-fns/isSameYear","date-fns/isSameQuarter","date-fns/isAfter","date-fns/isBefore","date-fns/isWithinInterval","date-fns/toDate","date-fns/parse","date-fns/parseISO","react-onclickoutside","react-popper","react-dom"],t):t((e=e||self).DatePicker={},e.React,e.PropTypes,e.classNames,e.isDate,e.isValidDate,e.format,e.addMinutes,e.addHours,e.utils,e.utils$1,e.addMonths,e.addYears,e.subMinutes,e.subHours,e.subDays,e.subWeeks,e.subMonths,e.subYears,e.getSeconds,e.getMinutes,e.getHours,e.getDay,e.getDate,e.dfgetWeek,e.getMonth,e.getQuarter,e.getYear,e.getTime,e.setSeconds,e.setMinutes,e.setHours,e.utils$2,e.utils$3,e.utils$4,e.min,e.max,e.differenceInCalendarDays,e.differenceInCalendarMonths,e.differenceInCalendarWeeks,e.differenceInCalendarYears,e.startOfDay,e.startOfWeek,e.startOfMonth,e.startOfQuarter,e.startOfYear,e.endOfDay,e.endOfWeek,e.endOfMonth,e.dfIsEqual,e.dfIsSameDay,e.dfIsSameMonth,e.dfIsSameYear,e.dfIsSameQuarter,e.isAfter,e.isBefore,e.isWithinInterval,e.toDate,e.parse,e.parseISO,e.onClickOutside,e.ReactPopper,e.ReactDOM)}(this,(function(e,t,r,n,a,o,s,p,i,c,l,d,u,h,f,m,y,v,w,D,k,g,b,C,_,O,S,P,M,E,N,Y,x,T,I,L,j,R,F,q,W,A,B,H,K,Q,V,U,$,z,G,J,X,Z,ee,te,re,ne,ae,oe,se,pe,ie){"use strict";function ce(e){return(ce="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function le(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function de(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}function ue(e,t,r){return t&&de(e.prototype,t),r&&de(e,r),e}function he(e,t,r){return t in e?Object.defineProperty(e,t,{value:r,enumerable:!0,configurable:!0,writable:!0}):e[t]=r,e}function fe(){return(fe=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n])}return e}).apply(this,arguments)}function me(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,n)}return r}function ye(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?me(Object(r),!0).forEach((function(t){he(e,t,r[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):me(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}function ve(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&De(e,t)}function we(e){return(we=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function De(e,t){return(De=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function ke(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function ge(e,t){return!t||"object"!=typeof t&&"function"!=typeof t?ke(e):t}function be(e){var t=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Date.prototype.toString.call(Reflect.construct(Date,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,n=we(e);if(t){var a=we(this).constructor;r=Reflect.construct(n,arguments,a)}else r=n.apply(this,arguments);return ge(this,r)}}function Ce(e,t){switch(e){case"P":return t.date({width:"short"});case"PP":return t.date({width:"medium"});case"PPP":return t.date({width:"long"});case"PPPP":default:return t.date({width:"full"})}}function _e(e,t){switch(e){case"p":return t.time({width:"short"});case"pp":return t.time({width:"medium"});case"ppp":return t.time({width:"long"});case"pppp":default:return t.time({width:"full"})}}t=t&&Object.prototype.hasOwnProperty.call(t,"default")?t.default:t,r=r&&Object.prototype.hasOwnProperty.call(r,"default")?r.default:r,n=n&&Object.prototype.hasOwnProperty.call(n,"default")?n.default:n,a=a&&Object.prototype.hasOwnProperty.call(a,"default")?a.default:a,o=o&&Object.prototype.hasOwnProperty.call(o,"default")?o.default:o,s=s&&Object.prototype.hasOwnProperty.call(s,"default")?s.default:s,p=p&&Object.prototype.hasOwnProperty.call(p,"default")?p.default:p,i=i&&Object.prototype.hasOwnProperty.call(i,"default")?i.default:i,c=c&&Object.prototype.hasOwnProperty.call(c,"default")?c.default:c,l=l&&Object.prototype.hasOwnProperty.call(l,"default")?l.default:l,d=d&&Object.prototype.hasOwnProperty.call(d,"default")?d.default:d,u=u&&Object.prototype.hasOwnProperty.call(u,"default")?u.default:u,h=h&&Object.prototype.hasOwnProperty.call(h,"default")?h.default:h,f=f&&Object.prototype.hasOwnProperty.call(f,"default")?f.default:f,m=m&&Object.prototype.hasOwnProperty.call(m,"default")?m.default:m,y=y&&Object.prototype.hasOwnProperty.call(y,"default")?y.default:y,v=v&&Object.prototype.hasOwnProperty.call(v,"default")?v.default:v,w=w&&Object.prototype.hasOwnProperty.call(w,"default")?w.default:w,D=D&&Object.prototype.hasOwnProperty.call(D,"default")?D.default:D,k=k&&Object.prototype.hasOwnProperty.call(k,"default")?k.default:k,g=g&&Object.prototype.hasOwnProperty.call(g,"default")?g.default:g,b=b&&Object.prototype.hasOwnProperty.call(b,"default")?b.default:b,C=C&&Object.prototype.hasOwnProperty.call(C,"default")?C.default:C,_=_&&Object.prototype.hasOwnProperty.call(_,"default")?_.default:_,O=O&&Object.prototype.hasOwnProperty.call(O,"default")?O.default:O,S=S&&Object.prototype.hasOwnProperty.call(S,"default")?S.default:S,P=P&&Object.prototype.hasOwnProperty.call(P,"default")?P.default:P,M=M&&Object.prototype.hasOwnProperty.call(M,"default")?M.default:M,E=E&&Object.prototype.hasOwnProperty.call(E,"default")?E.default:E,N=N&&Object.prototype.hasOwnProperty.call(N,"default")?N.default:N,Y=Y&&Object.prototype.hasOwnProperty.call(Y,"default")?Y.default:Y,x=x&&Object.prototype.hasOwnProperty.call(x,"default")?x.default:x,T=T&&Object.prototype.hasOwnProperty.call(T,"default")?T.default:T,I=I&&Object.prototype.hasOwnProperty.call(I,"default")?I.default:I,L=L&&Object.prototype.hasOwnProperty.call(L,"default")?L.default:L,j=j&&Object.prototype.hasOwnProperty.call(j,"default")?j.default:j,R=R&&Object.prototype.hasOwnProperty.call(R,"default")?R.default:R,F=F&&Object.prototype.hasOwnProperty.call(F,"default")?F.default:F,q=q&&Object.prototype.hasOwnProperty.call(q,"default")?q.default:q,W=W&&Object.prototype.hasOwnProperty.call(W,"default")?W.default:W,A=A&&Object.prototype.hasOwnProperty.call(A,"default")?A.default:A,B=B&&Object.prototype.hasOwnProperty.call(B,"default")?B.default:B,H=H&&Object.prototype.hasOwnProperty.call(H,"default")?H.default:H,K=K&&Object.prototype.hasOwnProperty.call(K,"default")?K.default:K,Q=Q&&Object.prototype.hasOwnProperty.call(Q,"default")?Q.default:Q,V=V&&Object.prototype.hasOwnProperty.call(V,"default")?V.default:V,U=U&&Object.prototype.hasOwnProperty.call(U,"default")?U.default:U,$=$&&Object.prototype.hasOwnProperty.call($,"default")?$.default:$,z=z&&Object.prototype.hasOwnProperty.call(z,"default")?z.default:z,G=G&&Object.prototype.hasOwnProperty.call(G,"default")?G.default:G,J=J&&Object.prototype.hasOwnProperty.call(J,"default")?J.default:J,X=X&&Object.prototype.hasOwnProperty.call(X,"default")?X.default:X,Z=Z&&Object.prototype.hasOwnProperty.call(Z,"default")?Z.default:Z,ee=ee&&Object.prototype.hasOwnProperty.call(ee,"default")?ee.default:ee,te=te&&Object.prototype.hasOwnProperty.call(te,"default")?te.default:te,re=re&&Object.prototype.hasOwnProperty.call(re,"default")?re.default:re,ne=ne&&Object.prototype.hasOwnProperty.call(ne,"default")?ne.default:ne,ae=ae&&Object.prototype.hasOwnProperty.call(ae,"default")?ae.default:ae,oe=oe&&Object.prototype.hasOwnProperty.call(oe,"default")?oe.default:oe,se=se&&Object.prototype.hasOwnProperty.call(se,"default")?se.default:se,ie=ie&&Object.prototype.hasOwnProperty.call(ie,"default")?ie.default:ie;var Oe={p:_e,P:function(e,t){var r,n=e.match(/(P+)(p+)?/),a=n[1],o=n[2];if(!o)return Ce(e,t);switch(a){case"P":r=t.dateTime({width:"short"});break;case"PP":r=t.dateTime({width:"medium"});break;case"PPP":r=t.dateTime({width:"long"});break;case"PPPP":default:r=t.dateTime({width:"full"})}return r.replace("{{date}}",Ce(a,t)).replace("{{time}}",_e(o,t))}},Se=/P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;function Pe(e){var t=e?"string"==typeof e||e instanceof String?oe(e):ne(e):new Date;return Ee(t)?t:null}function Me(e,t,r,n){var a=null,o=Ve(r)||Qe(),p=!0;return Array.isArray(t)?(t.forEach((function(t){var r=ae(e,t,new Date,{locale:o});n&&(p=Ee(r)&&e===s(r,t,{awareOfUnicodeTokens:!0})),Ee(r)&&p&&(a=r)})),a):(a=ae(e,t,new Date,{locale:o}),n?p=Ee(a)&&e===s(a,t,{awareOfUnicodeTokens:!0}):Ee(a)||(t=t.match(Se).map((function(e){var t=e[0];return"p"===t||"P"===t?o?(0,Oe[t])(e,o.formatLong):t:e})).join(""),e.length>0&&(a=ae(e,t.slice(0,e.length),new Date)),Ee(a)||(a=new Date(e))),Ee(a)&&p?a:null)}function Ee(e){return o(e)&&ee(e,new Date("1/1/1000"))}function Ne(e,t,r){if("en"===r)return s(e,t,{awareOfUnicodeTokens:!0});var n=Ve(r);return r&&!n&&console.warn('A locale object was not found for the provided string ["'.concat(r,'"].')),!n&&Qe()&&Ve(Qe())&&(n=Ve(Qe())),s(e,t,{locale:n||null,awareOfUnicodeTokens:!0})}function Ye(e,t){var r=t.hour,n=void 0===r?0:r,a=t.minute,o=void 0===a?0:a,s=t.second;return Y(N(E(e,void 0===s?0:s),o),n)}function xe(e,t){var r=t&&Ve(t)||Qe()&&Ve(Qe());return _(e,r?{locale:r}:null)}function Te(e,t){return Ne(e,"ddd",t)}function Ie(e){return A(e)}function Le(e,t){var r=Ve(t||Qe());return B(e,{locale:r})}function je(e){return H(e)}function Re(e){return Q(e)}function Fe(e){return K(e)}function qe(e,t){return e&&t?X(e,t):!e&&!t}function We(e,t){return e&&t?J(e,t):!e&&!t}function Ae(e,t){return e&&t?Z(e,t):!e&&!t}function Be(e,t){return e&&t?G(e,t):!e&&!t}function He(e,t){return e&&t?z(e,t):!e&&!t}function Ke(e,t,r){var n,a=A(t),o=V(r);try{n=re(e,{start:a,end:o})}catch(e){n=!1}return n}function Qe(){return("undefined"!=typeof window?window:global).__localeId__}function Ve(e){if("string"==typeof e){var t="undefined"!=typeof window?window:global;return t.__localeData__?t.__localeData__[e]:null}return e}function Ue(e,t){return Ne(x(Pe(),e),"LLLL",t)}function $e(e,t){return Ne(x(Pe(),e),"LLL",t)}function ze(e,t){return Ne(T(Pe(),e),"QQQ",t)}function Ge(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.maxDate,a=t.excludeDates,o=t.includeDates,s=t.filterDate;return nt(e,{minDate:r,maxDate:n})||a&&a.some((function(t){return Be(e,t)}))||o&&!o.some((function(t){return Be(e,t)}))||s&&!s(Pe(e))||!1}function Je(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.excludeDates;return r&&r.some((function(t){return Be(e,t)}))||!1}function Xe(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.maxDate,a=t.excludeDates,o=t.includeDates,s=t.filterDate;return nt(e,{minDate:r,maxDate:n})||a&&a.some((function(t){return We(e,t)}))||o&&!o.some((function(t){return We(e,t)}))||s&&!s(Pe(e))||!1}function Ze(e,t,r,n){var a=P(e),o=O(e),s=P(t),p=O(t),i=P(n);return a===s&&a===i?o<=r&&r<=p:a<s?i===a&&o<=r||i===s&&p>=r||i<s&&i>a:void 0}function et(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.maxDate,a=t.excludeDates,o=t.includeDates,s=t.filterDate;return nt(e,{minDate:r,maxDate:n})||a&&a.some((function(t){return Ae(e,t)}))||o&&!o.some((function(t){return Ae(e,t)}))||s&&!s(Pe(e))||!1}function tt(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.maxDate,a=new Date(e,0,1);return nt(a,{minDate:r,maxDate:n})||!1}function rt(e,t,r,n){var a=P(e),o=S(e),s=P(t),p=S(t),i=P(n);return a===s&&a===i?o<=r&&r<=p:a<s?i===a&&o<=r||i===s&&p>=r||i<s&&i>a:void 0}function nt(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.maxDate;return r&&R(e,r)<0||n&&R(e,n)>0}function at(e,t){for(var r=t.length,n=0;n<r;n++)if(g(t[n])===g(e)&&k(t[n])===k(e))return!0;return!1}function ot(e,t){var r=t.minTime,n=t.maxTime;if(!r||!n)throw new Error("Both minTime and maxTime props required");var a,o=Pe(),s=Y(N(o,k(e)),g(e)),p=Y(N(o,k(r)),g(r)),i=Y(N(o,k(n)),g(n));try{a=!re(s,{start:p,end:i})}catch(e){a=!1}return a}function st(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.includeDates,a=v(e,1);return r&&F(r,a)>0||n&&n.every((function(e){return F(e,a)>0}))||!1}function pt(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.maxDate,n=t.includeDates,a=d(e,1);return r&&F(a,r)>0||n&&n.every((function(e){return F(a,e)>0}))||!1}function it(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.includeDates,a=w(e,1);return r&&W(r,a)>0||n&&n.every((function(e){return W(e,a)>0}))||!1}function ct(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.maxDate,n=t.includeDates,a=u(e,1);return r&&W(a,r)>0||n&&n.every((function(e){return W(a,e)>0}))||!1}function lt(e){var t=e.minDate,r=e.includeDates;if(r&&t){var n=r.filter((function(e){return R(e,t)>=0}));return L(n)}return r?L(r):t}function dt(e){var t=e.maxDate,r=e.includeDates;if(r&&t){var n=r.filter((function(e){return R(e,t)<=0}));return j(n)}return r?j(r):t}function ut(){for(var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"react-datepicker__day--highlighted",r=new Map,n=0,o=e.length;n<o;n++){var s=e[n];if(a(s)){var p=Ne(s,"MM.dd.yyyy"),i=r.get(p)||[];i.includes(t)||(i.push(t),r.set(p,i))}else if("object"===ce(s)){var c=Object.keys(s),l=c[0],d=s[c[0]];if("string"==typeof l&&d.constructor===Array)for(var u=0,h=d.length;u<h;u++){var f=Ne(d[u],"MM.dd.yyyy"),m=r.get(f)||[];m.includes(l)||(m.push(l),r.set(f,m))}}}return r}function ht(e,t,r,n,a){for(var o=a.length,s=[],c=0;c<o;c++){var l=p(i(e,g(a[c])),k(a[c])),d=p(e,(r+1)*n);ee(l,t)&&te(l,d)&&s.push(a[c])}return s}function ft(e){return e<10?"0".concat(e):"".concat(e)}function mt(e){var t=12*Math.ceil(P(e)/12);return{startPeriod:t-11,endPeriod:t}}function yt(e,t,r,n){for(var a=[],o=0;o<2*t+1;o++){var s=e+t-o,p=!0;r&&(p=P(r)<=s),n&&p&&(p=P(n)>=s),p&&a.push(s)}return a}var vt=se(function(e){ve(a,e);var r=be(a);function a(e){var n;le(this,a),he(ke(n=r.call(this,e)),"renderOptions",(function(){var e=n.props.year,r=n.state.yearsList.map((function(r){return t.createElement("div",{className:e===r?"react-datepicker__year-option react-datepicker__year-option--selected_year":"react-datepicker__year-option",key:r,onClick:n.onChange.bind(ke(n),r)},e===r?t.createElement("span",{className:"react-datepicker__year-option--selected"},"✓"):"",r)})),a=n.props.minDate?P(n.props.minDate):null,o=n.props.maxDate?P(n.props.maxDate):null;return o&&n.state.yearsList.find((function(e){return e===o}))||r.unshift(t.createElement("div",{className:"react-datepicker__year-option",key:"upcoming",onClick:n.incrementYears},t.createElement("a",{className:"react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming"}))),a&&n.state.yearsList.find((function(e){return e===a}))||r.push(t.createElement("div",{className:"react-datepicker__year-option",key:"previous",onClick:n.decrementYears},t.createElement("a",{className:"react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous"}))),r})),he(ke(n),"onChange",(function(e){n.props.onChange(e)})),he(ke(n),"handleClickOutside",(function(){n.props.onCancel()})),he(ke(n),"shiftYears",(function(e){var t=n.state.yearsList.map((function(t){return t+e}));n.setState({yearsList:t})})),he(ke(n),"incrementYears",(function(){return n.shiftYears(1)})),he(ke(n),"decrementYears",(function(){return n.shiftYears(-1)}));var o=e.yearDropdownItemNumber,s=e.scrollableYearDropdown,p=o||(s?10:5);return n.state={yearsList:yt(n.props.year,p,n.props.minDate,n.props.maxDate)},n}return ue(a,[{key:"render",value:function(){var e=n({"react-datepicker__year-dropdown":!0,"react-datepicker__year-dropdown--scrollable":this.props.scrollableYearDropdown});return t.createElement("div",{className:e},this.renderOptions())}}]),a}(t.Component)),wt=function(e){ve(n,e);var r=be(n);function n(){var e;le(this,n);for(var a=arguments.length,o=new Array(a),s=0;s<a;s++)o[s]=arguments[s];return he(ke(e=r.call.apply(r,[this].concat(o))),"state",{dropdownVisible:!1}),he(ke(e),"renderSelectOptions",(function(){for(var r=e.props.minDate?P(e.props.minDate):1900,n=e.props.maxDate?P(e.props.maxDate):2100,a=[],o=r;o<=n;o++)a.push(t.createElement("option",{key:o,value:o},o));return a})),he(ke(e),"onSelectChange",(function(t){e.onChange(t.target.value)})),he(ke(e),"renderSelectMode",(function(){return t.createElement("select",{value:e.props.year,className:"react-datepicker__year-select",onChange:e.onSelectChange},e.renderSelectOptions())})),he(ke(e),"renderReadView",(function(r){return t.createElement("div",{key:"read",style:{visibility:r?"visible":"hidden"},className:"react-datepicker__year-read-view",onClick:function(t){return e.toggleDropdown(t)}},t.createElement("span",{className:"react-datepicker__year-read-view--down-arrow"}),t.createElement("span",{className:"react-datepicker__year-read-view--selected-year"},e.props.year))})),he(ke(e),"renderDropdown",(function(){return t.createElement(vt,{key:"dropdown",year:e.props.year,onChange:e.onChange,onCancel:e.toggleDropdown,minDate:e.props.minDate,maxDate:e.props.maxDate,scrollableYearDropdown:e.props.scrollableYearDropdown,yearDropdownItemNumber:e.props.yearDropdownItemNumber})})),he(ke(e),"renderScrollMode",(function(){var t=e.state.dropdownVisible,r=[e.renderReadView(!t)];return t&&r.unshift(e.renderDropdown()),r})),he(ke(e),"onChange",(function(t){e.toggleDropdown(),t!==e.props.year&&e.props.onChange(t)})),he(ke(e),"toggleDropdown",(function(t){e.setState({dropdownVisible:!e.state.dropdownVisible},(function(){e.props.adjustDateOnChange&&e.handleYearChange(e.props.date,t)}))})),he(ke(e),"handleYearChange",(function(t,r){e.onSelect(t,r),e.setOpen()})),he(ke(e),"onSelect",(function(t,r){e.props.onSelect&&e.props.onSelect(t,r)})),he(ke(e),"setOpen",(function(){e.props.setOpen&&e.props.setOpen(!0)})),e}return ue(n,[{key:"render",value:function(){var e;switch(this.props.dropdownMode){case"scroll":e=this.renderScrollMode();break;case"select":e=this.renderSelectMode()}return t.createElement("div",{className:"react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode)},e)}}]),n}(t.Component),Dt=se(function(e){ve(n,e);var r=be(n);function n(){var e;le(this,n);for(var a=arguments.length,o=new Array(a),s=0;s<a;s++)o[s]=arguments[s];return he(ke(e=r.call.apply(r,[this].concat(o))),"renderOptions",(function(){return e.props.monthNames.map((function(r,n){return t.createElement("div",{className:e.props.month===n?"react-datepicker__month-option react-datepicker__month-option--selected_month":"react-datepicker__month-option",key:r,onClick:e.onChange.bind(ke(e),n)},e.props.month===n?t.createElement("span",{className:"react-datepicker__month-option--selected"},"✓"):"",r)}))})),he(ke(e),"onChange",(function(t){return e.props.onChange(t)})),he(ke(e),"handleClickOutside",(function(){return e.props.onCancel()})),e}return ue(n,[{key:"render",value:function(){return t.createElement("div",{className:"react-datepicker__month-dropdown"},this.renderOptions())}}]),n}(t.Component)),kt=function(e){ve(n,e);var r=be(n);function n(){var e;le(this,n);for(var a=arguments.length,o=new Array(a),s=0;s<a;s++)o[s]=arguments[s];return he(ke(e=r.call.apply(r,[this].concat(o))),"state",{dropdownVisible:!1}),he(ke(e),"renderSelectOptions",(function(e){return e.map((function(e,r){return t.createElement("option",{key:r,value:r},e)}))})),he(ke(e),"renderSelectMode",(function(r){return t.createElement("select",{value:e.props.month,className:"react-datepicker__month-select",onChange:function(t){return e.onChange(t.target.value)}},e.renderSelectOptions(r))})),he(ke(e),"renderReadView",(function(r,n){return t.createElement("div",{key:"read",style:{visibility:r?"visible":"hidden"},className:"react-datepicker__month-read-view",onClick:e.toggleDropdown},t.createElement("span",{className:"react-datepicker__month-read-view--down-arrow"}),t.createElement("span",{className:"react-datepicker__month-read-view--selected-month"},n[e.props.month]))})),he(ke(e),"renderDropdown",(function(r){return t.createElement(Dt,{key:"dropdown",month:e.props.month,monthNames:r,onChange:e.onChange,onCancel:e.toggleDropdown})})),he(ke(e),"renderScrollMode",(function(t){var r=e.state.dropdownVisible,n=[e.renderReadView(!r,t)];return r&&n.unshift(e.renderDropdown(t)),n})),he(ke(e),"onChange",(function(t){e.toggleDropdown(),t!==e.props.month&&e.props.onChange(t)})),he(ke(e),"toggleDropdown",(function(){return e.setState({dropdownVisible:!e.state.dropdownVisible})})),e}return ue(n,[{key:"render",value:function(){var e,r=this,n=[0,1,2,3,4,5,6,7,8,9,10,11].map(this.props.useShortMonthInDropdown?function(e){return $e(e,r.props.locale)}:function(e){return Ue(e,r.props.locale)});switch(this.props.dropdownMode){case"scroll":e=this.renderScrollMode(n);break;case"select":e=this.renderSelectMode(n)}return t.createElement("div",{className:"react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode)},e)}}]),n}(t.Component);function gt(e,t){for(var r=[],n=je(e),a=je(t);!ee(n,a);)r.push(Pe(n)),n=d(n,1);return r}var bt=se(function(e){ve(a,e);var r=be(a);function a(e){var n;return le(this,a),he(ke(n=r.call(this,e)),"renderOptions",(function(){return n.state.monthYearsList.map((function(e){var r=M(e),a=qe(n.props.date,e)&&We(n.props.date,e);return t.createElement("div",{className:a?"react-datepicker__month-year-option --selected_month-year":"react-datepicker__month-year-option",key:r,onClick:n.onChange.bind(ke(n),r)},a?t.createElement("span",{className:"react-datepicker__month-year-option--selected"},"✓"):"",Ne(e,n.props.dateFormat))}))})),he(ke(n),"onChange",(function(e){return n.props.onChange(e)})),he(ke(n),"handleClickOutside",(function(){n.props.onCancel()})),n.state={monthYearsList:gt(n.props.minDate,n.props.maxDate)},n}return ue(a,[{key:"render",value:function(){var e=n({"react-datepicker__month-year-dropdown":!0,"react-datepicker__month-year-dropdown--scrollable":this.props.scrollableMonthYearDropdown});return t.createElement("div",{className:e},this.renderOptions())}}]),a}(t.Component)),Ct=function(e){ve(n,e);var r=be(n);function n(){var e;le(this,n);for(var a=arguments.length,o=new Array(a),s=0;s<a;s++)o[s]=arguments[s];return he(ke(e=r.call.apply(r,[this].concat(o))),"state",{dropdownVisible:!1}),he(ke(e),"renderSelectOptions",(function(){for(var r=je(e.props.minDate),n=je(e.props.maxDate),a=[];!ee(r,n);){var o=M(r);a.push(t.createElement("option",{key:o,value:o},Ne(r,e.props.dateFormat,e.props.locale))),r=d(r,1)}return a})),he(ke(e),"onSelectChange",(function(t){e.onChange(t.target.value)})),he(ke(e),"renderSelectMode",(function(){return t.createElement("select",{value:M(je(e.props.date)),className:"react-datepicker__month-year-select",onChange:e.onSelectChange},e.renderSelectOptions())})),he(ke(e),"renderReadView",(function(r){var n=Ne(e.props.date,e.props.dateFormat,e.props.locale);return t.createElement("div",{key:"read",style:{visibility:r?"visible":"hidden"},className:"react-datepicker__month-year-read-view",onClick:function(t){return e.toggleDropdown(t)}},t.createElement("span",{className:"react-datepicker__month-year-read-view--down-arrow"}),t.createElement("span",{className:"react-datepicker__month-year-read-view--selected-month-year"},n))})),he(ke(e),"renderDropdown",(function(){return t.createElement(bt,{key:"dropdown",date:e.props.date,dateFormat:e.props.dateFormat,onChange:e.onChange,onCancel:e.toggleDropdown,minDate:e.props.minDate,maxDate:e.props.maxDate,scrollableMonthYearDropdown:e.props.scrollableMonthYearDropdown})})),he(ke(e),"renderScrollMode",(function(){var t=e.state.dropdownVisible,r=[e.renderReadView(!t)];return t&&r.unshift(e.renderDropdown()),r})),he(ke(e),"onChange",(function(t){e.toggleDropdown();var r=Pe(parseInt(t));qe(e.props.date,r)&&We(e.props.date,r)||e.props.onChange(r)})),he(ke(e),"toggleDropdown",(function(){return e.setState({dropdownVisible:!e.state.dropdownVisible})})),e}return ue(n,[{key:"render",value:function(){var e;switch(this.props.dropdownMode){case"scroll":e=this.renderScrollMode();break;case"select":e=this.renderSelectMode()}return t.createElement("div",{className:"react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode)},e)}}]),n}(t.Component),_t=function(e){ve(a,e);var r=be(a);function a(){var e;le(this,a);for(var o=arguments.length,s=new Array(o),p=0;p<o;p++)s[p]=arguments[p];return he(ke(e=r.call.apply(r,[this].concat(s))),"dayEl",t.createRef()),he(ke(e),"handleClick",(function(t){!e.isDisabled()&&e.props.onClick&&e.props.onClick(t)})),he(ke(e),"handleMouseEnter",(function(t){!e.isDisabled()&&e.props.onMouseEnter&&e.props.onMouseEnter(t)})),he(ke(e),"handleOnKeyDown",(function(t){" "===t.key&&(t.preventDefault(),t.key="Enter"),e.props.handleOnKeyDown(t)})),he(ke(e),"isSameDay",(function(t){return Be(e.props.day,t)})),he(ke(e),"isKeyboardSelected",(function(){return!e.props.disabledKeyboardNavigation&&!e.isSameDay(e.props.selected)&&e.isSameDay(e.props.preSelection)})),he(ke(e),"isDisabled",(function(){return Ge(e.props.day,e.props)})),he(ke(e),"isExcluded",(function(){return Je(e.props.day,e.props)})),he(ke(e),"getHighLightedClass",(function(t){var r=e.props,n=r.day,a=r.highlightDates;if(!a)return!1;var o=Ne(n,"MM.dd.yyyy");return a.get(o)})),he(ke(e),"isInRange",(function(){var t=e.props,r=t.day,n=t.startDate,a=t.endDate;return!(!n||!a)&&Ke(r,n,a)})),he(ke(e),"isInSelectingRange",(function(){var t=e.props,r=t.day,n=t.selectsStart,a=t.selectsEnd,o=t.selectsRange,s=t.selectingDate,p=t.startDate,i=t.endDate;return!(!(n||a||o)||!s||e.isDisabled())&&(n&&i&&(te(s,i)||He(s,i))?Ke(r,s,i):(a&&p&&(ee(s,p)||He(s,p))||!(!o||!p||i||!ee(s,p)&&!He(s,p)))&&Ke(r,p,s))})),he(ke(e),"isSelectingRangeStart",(function(){if(!e.isInSelectingRange())return!1;var t=e.props,r=t.day,n=t.selectingDate,a=t.startDate;return Be(r,t.selectsStart?n:a)})),he(ke(e),"isSelectingRangeEnd",(function(){if(!e.isInSelectingRange())return!1;var t=e.props,r=t.day,n=t.selectingDate,a=t.endDate;return Be(r,t.selectsEnd?n:a)})),he(ke(e),"isRangeStart",(function(){var t=e.props,r=t.day,n=t.startDate,a=t.endDate;return!(!n||!a)&&Be(n,r)})),he(ke(e),"isRangeEnd",(function(){var t=e.props,r=t.day,n=t.startDate,a=t.endDate;return!(!n||!a)&&Be(a,r)})),he(ke(e),"isWeekend",(function(){var t=b(e.props.day);return 0===t||6===t})),he(ke(e),"isOutsideMonth",(function(){return void 0!==e.props.month&&e.props.month!==O(e.props.day)})),he(ke(e),"getClassNames",(function(t){var r=e.props.dayClassName?e.props.dayClassName(t):void 0;return n("react-datepicker__day",r,"react-datepicker__day--"+Te(e.props.day),{"react-datepicker__day--disabled":e.isDisabled(),"react-datepicker__day--excluded":e.isExcluded(),"react-datepicker__day--selected":e.isSameDay(e.props.selected),"react-datepicker__day--keyboard-selected":e.isKeyboardSelected(),"react-datepicker__day--range-start":e.isRangeStart(),"react-datepicker__day--range-end":e.isRangeEnd(),"react-datepicker__day--in-range":e.isInRange(),"react-datepicker__day--in-selecting-range":e.isInSelectingRange(),"react-datepicker__day--selecting-range-start":e.isSelectingRangeStart(),"react-datepicker__day--selecting-range-end":e.isSelectingRangeEnd(),"react-datepicker__day--today":e.isSameDay(Pe()),"react-datepicker__day--weekend":e.isWeekend(),"react-datepicker__day--outside-month":e.isOutsideMonth()},e.getHighLightedClass("react-datepicker__day--highlighted"))})),he(ke(e),"getAriaLabel",(function(){var t=e.props,r=t.day,n=t.ariaLabelPrefixWhenEnabled,a=void 0===n?"Choose":n,o=t.ariaLabelPrefixWhenDisabled,s=void 0===o?"Not available":o,p=e.isDisabled()||e.isExcluded()?s:a;return"".concat(p," ").concat(Ne(r,"PPPP"))})),he(ke(e),"getTabIndex",(function(t,r){var n=t||e.props.selected,a=r||e.props.preSelection;return e.isKeyboardSelected()||e.isSameDay(n)&&Be(a,n)?0:-1})),he(ke(e),"handleFocusDay",(function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},r=!1;0===e.getTabIndex()&&!t.isInputFocused&&e.isSameDay(e.props.preSelection)&&(document.activeElement&&document.activeElement!==document.body||(r=!0),e.props.containerRef&&e.props.containerRef.current&&e.props.containerRef.current.contains(document.activeElement)&&document.activeElement.classList.contains("react-datepicker__day")&&(r=!0)),r&&e.dayEl.current.focus({preventScroll:!0})})),he(ke(e),"render",(function(){return t.createElement("div",{ref:e.dayEl,className:e.getClassNames(e.props.day),onKeyDown:e.handleOnKeyDown,onClick:e.handleClick,onMouseEnter:e.handleMouseEnter,tabIndex:e.getTabIndex(),"aria-label":e.getAriaLabel(),role:"button","aria-disabled":e.isDisabled()},e.props.renderDayContents?e.props.renderDayContents(C(e.props.day),e.props.day):C(e.props.day))})),e}return ue(a,[{key:"componentDidMount",value:function(){this.handleFocusDay()}},{key:"componentDidUpdate",value:function(e){this.handleFocusDay(e)}}]),a}(t.Component),Ot=function(e){ve(a,e);var r=be(a);function a(){var e;le(this,a);for(var t=arguments.length,n=new Array(t),o=0;o<t;o++)n[o]=arguments[o];return he(ke(e=r.call.apply(r,[this].concat(n))),"handleClick",(function(t){e.props.onClick&&e.props.onClick(t)})),e}return ue(a,[{key:"render",value:function(){var e=this.props,r=e.weekNumber,a=e.ariaLabelPrefix,o=void 0===a?"week ":a,s={"react-datepicker__week-number":!0,"react-datepicker__week-number--clickable":!!e.onClick};return t.createElement("div",{className:n(s),"aria-label":"".concat(o," ").concat(this.props.weekNumber),onClick:this.handleClick},r)}}]),a}(t.Component),St=function(e){ve(n,e);var r=be(n);function n(){var e;le(this,n);for(var a=arguments.length,o=new Array(a),s=0;s<a;s++)o[s]=arguments[s];return he(ke(e=r.call.apply(r,[this].concat(o))),"handleDayClick",(function(t,r){e.props.onDayClick&&e.props.onDayClick(t,r)})),he(ke(e),"handleDayMouseEnter",(function(t){e.props.onDayMouseEnter&&e.props.onDayMouseEnter(t)})),he(ke(e),"handleWeekClick",(function(t,r,n){"function"==typeof e.props.onWeekSelect&&e.props.onWeekSelect(t,r,n),e.props.shouldCloseOnSelect&&e.props.setOpen(!1)})),he(ke(e),"formatWeekNumber",(function(t){return e.props.formatWeekNumber?e.props.formatWeekNumber(t):xe(t,e.props.locale)})),he(ke(e),"renderDays",(function(){var r=Le(e.props.day,e.props.locale),n=[],a=e.formatWeekNumber(r);if(e.props.showWeekNumber){var o=e.props.onWeekSelect?e.handleWeekClick.bind(ke(e),r,a):void 0;n.push(t.createElement(Ot,{key:"W",weekNumber:a,onClick:o,ariaLabelPrefix:e.props.ariaLabelPrefix}))}return n.concat([0,1,2,3,4,5,6].map((function(n){var a=c(r,n);return t.createElement(_t,{ariaLabelPrefixWhenEnabled:e.props.chooseDayAriaLabelPrefix,ariaLabelPrefixWhenDisabled:e.props.disabledDayAriaLabelPrefix,key:a.valueOf(),day:a,month:e.props.month,onClick:e.handleDayClick.bind(ke(e),a),onMouseEnter:e.handleDayMouseEnter.bind(ke(e),a),minDate:e.props.minDate,maxDate:e.props.maxDate,excludeDates:e.props.excludeDates,includeDates:e.props.includeDates,highlightDates:e.props.highlightDates,selectingDate:e.props.selectingDate,filterDate:e.props.filterDate,preSelection:e.props.preSelection,selected:e.props.selected,selectsStart:e.props.selectsStart,selectsEnd:e.props.selectsEnd,selectsRange:e.props.selectsRange,startDate:e.props.startDate,endDate:e.props.endDate,dayClassName:e.props.dayClassName,renderDayContents:e.props.renderDayContents,disabledKeyboardNavigation:e.props.disabledKeyboardNavigation,handleOnKeyDown:e.props.handleOnKeyDown,isInputFocused:e.props.isInputFocused,containerRef:e.props.containerRef})})))})),e}return ue(n,[{key:"render",value:function(){return t.createElement("div",{className:"react-datepicker__week"},this.renderDays())}}],[{key:"defaultProps",get:function(){return{shouldCloseOnSelect:!0}}}]),n}(t.Component),Pt=function(e){ve(a,e);var r=be(a);function a(){var e;le(this,a);for(var o=arguments.length,s=new Array(o),p=0;p<o;p++)s[p]=arguments[p];return he(ke(e=r.call.apply(r,[this].concat(s))),"handleDayClick",(function(t,r){e.props.onDayClick&&e.props.onDayClick(t,r,e.props.orderInDisplay)})),he(ke(e),"handleDayMouseEnter",(function(t){e.props.onDayMouseEnter&&e.props.onDayMouseEnter(t)})),he(ke(e),"handleMouseLeave",(function(){e.props.onMouseLeave&&e.props.onMouseLeave()})),he(ke(e),"isRangeStartMonth",(function(t){var r=e.props,n=r.day,a=r.startDate,o=r.endDate;return!(!a||!o)&&We(x(n,t),a)})),he(ke(e),"isRangeStartQuarter",(function(t){var r=e.props,n=r.day,a=r.startDate,o=r.endDate;return!(!a||!o)&&Ae(T(n,t),a)})),he(ke(e),"isRangeEndMonth",(function(t){var r=e.props,n=r.day,a=r.startDate,o=r.endDate;return!(!a||!o)&&We(x(n,t),o)})),he(ke(e),"isRangeEndQuarter",(function(t){var r=e.props,n=r.day,a=r.startDate,o=r.endDate;return!(!a||!o)&&Ae(T(n,t),o)})),he(ke(e),"isWeekInMonth",(function(t){var r=e.props.day,n=c(t,6);return We(t,r)||We(n,r)})),he(ke(e),"renderWeeks",(function(){for(var r=[],n=e.props.fixedHeight,a=Le(je(e.props.day),e.props.locale),o=0,s=!1;r.push(t.createElement(St,{ariaLabelPrefix:e.props.weekAriaLabelPrefix,chooseDayAriaLabelPrefix:e.props.chooseDayAriaLabelPrefix,disabledDayAriaLabelPrefix:e.props.disabledDayAriaLabelPrefix,key:o,day:a,month:O(e.props.day),onDayClick:e.handleDayClick,onDayMouseEnter:e.handleDayMouseEnter,onWeekSelect:e.props.onWeekSelect,formatWeekNumber:e.props.formatWeekNumber,locale:e.props.locale,minDate:e.props.minDate,maxDate:e.props.maxDate,excludeDates:e.props.excludeDates,includeDates:e.props.includeDates,highlightDates:e.props.highlightDates,selectingDate:e.props.selectingDate,filterDate:e.props.filterDate,preSelection:e.props.preSelection,selected:e.props.selected,selectsStart:e.props.selectsStart,selectsEnd:e.props.selectsEnd,selectsRange:e.props.selectsRange,showWeekNumber:e.props.showWeekNumbers,startDate:e.props.startDate,endDate:e.props.endDate,dayClassName:e.props.dayClassName,setOpen:e.props.setOpen,shouldCloseOnSelect:e.props.shouldCloseOnSelect,disabledKeyboardNavigation:e.props.disabledKeyboardNavigation,renderDayContents:e.props.renderDayContents,handleOnKeyDown:e.props.handleOnKeyDown,isInputFocused:e.props.isInputFocused,containerRef:e.props.containerRef})),!s;){o++,a=l(a,1);var p=n&&o>=6,i=!n&&!e.isWeekInMonth(a);if(p||i){if(!e.props.peekNextMonth)break;s=!0}}return r})),he(ke(e),"onMonthClick",(function(t,r){e.handleDayClick(je(x(e.props.day,r)),t)})),he(ke(e),"onQuarterClick",(function(t,r){e.handleDayClick(Fe(T(e.props.day,r)),t)})),he(ke(e),"getMonthClassNames",(function(t){var r=e.props,a=r.day,o=r.startDate,s=r.endDate,p=r.selected,i=r.minDate,c=r.maxDate;return n("react-datepicker__month-text","react-datepicker__month-".concat(t),{"react-datepicker__month--disabled":(i||c)&&Xe(x(a,t),e.props),"react-datepicker__month--selected":O(a)===t&&P(a)===P(p),"react-datepicker__month--in-range":Ze(o,s,t,a),"react-datepicker__month--range-start":e.isRangeStartMonth(t),"react-datepicker__month--range-end":e.isRangeEndMonth(t)})})),he(ke(e),"getQuarterClassNames",(function(t){var r=e.props,a=r.day,o=r.startDate,s=r.endDate,p=r.selected,i=r.minDate,c=r.maxDate;return n("react-datepicker__quarter-text","react-datepicker__quarter-".concat(t),{"react-datepicker__quarter--disabled":(i||c)&&et(T(a,t),e.props),"react-datepicker__quarter--selected":S(a)===t&&P(a)===P(p),"react-datepicker__quarter--in-range":rt(o,s,t,a),"react-datepicker__quarter--range-start":e.isRangeStartQuarter(t),"react-datepicker__quarter--range-end":e.isRangeEndQuarter(t)})})),he(ke(e),"renderMonths",(function(){var r=e.props,n=r.showFullMonthYearPicker,a=r.showTwoColumnMonthYearPicker,o=r.locale;return(a?[[0,1],[2,3],[4,5],[6,7],[8,9],[10,11]]:[[0,1,2],[3,4,5],[6,7,8],[9,10,11]]).map((function(r,a){return t.createElement("div",{className:"react-datepicker__month-wrapper",key:a},r.map((function(r,a){return t.createElement("div",{key:a,onClick:function(t){e.onMonthClick(t,r)},className:e.getMonthClassNames(r)},n?Ue(r,o):$e(r,o))})))}))})),he(ke(e),"renderQuarters",(function(){return t.createElement("div",{className:"react-datepicker__quarter-wrapper"},[1,2,3,4].map((function(r,n){return t.createElement("div",{key:n,onClick:function(t){e.onQuarterClick(t,r)},className:e.getQuarterClassNames(r)},ze(r,e.props.locale))})))})),he(ke(e),"getClassNames",(function(){var t=e.props,r=t.selectingDate,a=t.selectsStart,o=t.selectsEnd,s=t.showMonthYearPicker,p=t.showQuarterYearPicker;return n("react-datepicker__month",{"react-datepicker__month--selecting-range":r&&(a||o)},{"react-datepicker__monthPicker":s},{"react-datepicker__quarterPicker":p})})),e}return ue(a,[{key:"render",value:function(){var e=this.props,r=e.showMonthYearPicker,n=e.showQuarterYearPicker,a=e.day,o=e.ariaLabelPrefix,s=void 0===o?"month ":o;return t.createElement("div",{className:this.getClassNames(),onMouseLeave:this.handleMouseLeave,"aria-label":"".concat(s," ").concat(Ne(a,"yyyy-MM"))},r?this.renderMonths():n?this.renderQuarters():this.renderWeeks())}}]),a}(t.Component),Mt=function(e){ve(n,e);var r=be(n);function n(){var e;le(this,n);for(var a=arguments.length,o=new Array(a),s=0;s<a;s++)o[s]=arguments[s];return he(ke(e=r.call.apply(r,[this].concat(o))),"state",{height:null}),he(ke(e),"handleClick",(function(t){(e.props.minTime||e.props.maxTime)&&ot(t,e.props)||e.props.excludeTimes&&at(t,e.props.excludeTimes)||e.props.includeTimes&&!at(t,e.props.includeTimes)||e.props.onChange(t)})),he(ke(e),"liClasses",(function(t,r,n){var a=["react-datepicker__time-list-item",e.props.timeClassName?e.props.timeClassName(t,r,n):void 0];return e.props.selected&&r===g(t)&&n===k(t)&&a.push("react-datepicker__time-list-item--selected"),((e.props.minTime||e.props.maxTime)&&ot(t,e.props)||e.props.excludeTimes&&at(t,e.props.excludeTimes)||e.props.includeTimes&&!at(t,e.props.includeTimes))&&a.push("react-datepicker__time-list-item--disabled"),e.props.injectTimes&&(60*g(t)+k(t))%e.props.intervals!=0&&a.push("react-datepicker__time-list-item--injected"),a.join(" ")})),he(ke(e),"renderTimes",(function(){for(var r=[],n=e.props.format?e.props.format:"p",a=e.props.intervals,o=e.props.selected||e.props.openToDate||Pe(),s=g(o),i=k(o),c=Ie(Pe()),l=1440/a,d=e.props.injectTimes&&e.props.injectTimes.sort((function(e,t){return e-t})),u=[],h=0;h<l;h++){var f=p(c,h*a);if(r.push(f),d){var m=ht(c,f,h,a,d);r=r.concat(m)}s===g(f)&&u.push(f)}return r.map((function(r,a){return t.createElement("li",{key:a,onClick:e.handleClick.bind(ke(e),r),className:e.liClasses(r,s,i),ref:function(t){s===g(r)&&(i>=k(r)?e.centerLi=t:e.centerLi||u.indexOf(r)!==u.length-1||(e.centerLi=t))}},Ne(r,n,e.props.locale))}))})),e}return ue(n,[{key:"componentDidMount",value:function(){this.list.scrollTop=n.calcCenterPosition(this.props.monthRef?this.props.monthRef.clientHeight-this.header.clientHeight:this.list.clientHeight,this.centerLi),this.props.monthRef&&this.header&&this.setState({height:this.props.monthRef.clientHeight-this.header.clientHeight})}},{key:"render",value:function(){var e=this,r=this.state.height;return t.createElement("div",{className:"react-datepicker__time-container ".concat(this.props.todayButton?"react-datepicker__time-container--with-today-button":"")},t.createElement("div",{className:"react-datepicker__header react-datepicker__header--time",ref:function(t){e.header=t}},t.createElement("div",{className:"react-datepicker-time__header"},this.props.timeCaption)),t.createElement("div",{className:"react-datepicker__time"},t.createElement("div",{className:"react-datepicker__time-box"},t.createElement("ul",{className:"react-datepicker__time-list",ref:function(t){e.list=t},style:r?{height:r}:{}},this.renderTimes()))))}}],[{key:"defaultProps",get:function(){return{intervals:30,onTimeChange:function(){},todayButton:null,timeCaption:"Time"}}}]),n}(t.Component);he(Mt,"calcCenterPosition",(function(e,t){return t.offsetTop-(e/2-t.clientHeight/2)}));var Et=function(e){ve(a,e);var r=be(a);function a(e){var t;return le(this,a),he(ke(t=r.call(this,e)),"handleYearClick",(function(e,r){t.props.onDayClick&&t.props.onDayClick(e,r)})),he(ke(t),"isSameDay",(function(e,t){return Be(e,t)})),he(ke(t),"isKeyboardSelected",(function(e){var r=Re(I(t.props.date,e));return!t.props.disabledKeyboardNavigation&&!t.props.inline&&!Be(r,Re(t.props.selected))&&Be(r,Re(t.props.preSelection))})),he(ke(t),"onYearClick",(function(e,r){var n=t.props.date;t.handleYearClick(Re(I(n,r)),e)})),he(ke(t),"getYearClassNames",(function(e){var r=t.props,a=r.minDate,o=r.maxDate,s=r.selected;return n("react-datepicker__year-text",{"react-datepicker__year-text--selected":e===P(s),"react-datepicker__year-text--disabled":(a||o)&&tt(e,t.props),"react-datepicker__year-text--keyboard-selected":t.isKeyboardSelected(e)})})),t}return ue(a,[{key:"render",value:function(){for(var e=this,r=[],n=mt(this.props.date),a=n.startPeriod,o=n.endPeriod,s=function(n){r.push(t.createElement("div",{onClick:function(t){e.onYearClick(t,n)},className:e.getYearClassNames(n),key:n},n))},p=a;p<=o;p++)s(p);return t.createElement("div",{className:"react-datepicker__year"},t.createElement("div",{className:"react-datepicker__year-wrapper"},r))}}]),a}(t.Component),Nt=function(e){ve(n,e);var r=be(n);function n(e){var a;return le(this,n),he(ke(a=r.call(this,e)),"onTimeChange",(function(e){a.setState({time:e});var t=new Date;t.setHours(e.split(":")[0]),t.setMinutes(e.split(":")[1]),a.props.onChange(t)})),he(ke(a),"renderTimeInput",(function(){var e=a.state.time,r=a.props,n=r.timeString,o=r.customTimeInput;return o?t.cloneElement(o,{value:e,onChange:a.onTimeChange}):t.createElement("input",{type:"time",className:"react-datepicker-time__input",placeholder:"Time",name:"time-input",required:!0,value:e,onChange:function(e){a.onTimeChange(e.target.value||n)}})})),a.state={time:a.props.timeString},a}return ue(n,[{key:"render",value:function(){return t.createElement("div",{className:"react-datepicker__input-time-container"},t.createElement("div",{className:"react-datepicker-time__caption"},this.props.timeInputLabel),t.createElement("div",{className:"react-datepicker-time__input-container"},t.createElement("div",{className:"react-datepicker-time__input"},this.renderTimeInput())))}}]),n}(t.Component);function Yt(e){var r=e.className,n=e.children,a=e.showPopperArrow,o=e.arrowProps,s=void 0===o?{}:o;return t.createElement("div",{className:r},a&&t.createElement("div",fe({className:"react-datepicker__triangle"},s)),n)}var xt=["react-datepicker__year-select","react-datepicker__month-select","react-datepicker__month-year-select"],Tt=function(e){ve(a,e);var r=be(a);function a(e){var o;return le(this,a),he(ke(o=r.call(this,e)),"handleClickOutside",(function(e){o.props.onClickOutside(e)})),he(ke(o),"setClickOutsideRef",(function(){return o.containerRef.current})),he(ke(o),"handleDropdownFocus",(function(e){(function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=(e.className||"").split(/\s+/);return xt.some((function(e){return t.indexOf(e)>=0}))})(e.target)&&o.props.onDropdownFocus()})),he(ke(o),"getDateInView",(function(){var e=o.props,t=e.preSelection,r=e.selected,n=e.openToDate,a=lt(o.props),s=dt(o.props),p=Pe(),i=n||r||t;return i||(a&&te(p,a)?a:s&&ee(p,s)?s:p)})),he(ke(o),"increaseMonth",(function(){o.setState((function(e){var t=e.date;return{date:d(t,1)}}),(function(){return o.handleMonthChange(o.state.date)}))})),he(ke(o),"decreaseMonth",(function(){o.setState((function(e){var t=e.date;return{date:v(t,1)}}),(function(){return o.handleMonthChange(o.state.date)}))})),he(ke(o),"handleDayClick",(function(e,t,r){return o.props.onSelect(e,t,r)})),he(ke(o),"handleDayMouseEnter",(function(e){o.setState({selectingDate:e}),o.props.onDayMouseEnter&&o.props.onDayMouseEnter(e)})),he(ke(o),"handleMonthMouseLeave",(function(){o.setState({selectingDate:null}),o.props.onMonthMouseLeave&&o.props.onMonthMouseLeave()})),he(ke(o),"handleYearChange",(function(e){o.props.onYearChange&&o.props.onYearChange(e),o.props.adjustDateOnChange&&(o.props.onSelect&&o.props.onSelect(e),o.props.setOpen&&o.props.setOpen(!0)),o.props.setPreSelection&&o.props.setPreSelection(e)})),he(ke(o),"handleMonthChange",(function(e){o.props.onMonthChange&&o.props.onMonthChange(e),o.props.adjustDateOnChange&&(o.props.onSelect&&o.props.onSelect(e),o.props.setOpen&&o.props.setOpen(!0)),o.props.setPreSelection&&o.props.setPreSelection(e)})),he(ke(o),"handleMonthYearChange",(function(e){o.handleYearChange(e),o.handleMonthChange(e)})),he(ke(o),"changeYear",(function(e){o.setState((function(t){var r=t.date;return{date:I(r,e)}}),(function(){return o.handleYearChange(o.state.date)}))})),he(ke(o),"changeMonth",(function(e){o.setState((function(t){var r=t.date;return{date:x(r,e)}}),(function(){return o.handleMonthChange(o.state.date)}))})),he(ke(o),"changeMonthYear",(function(e){o.setState((function(t){var r=t.date;return{date:I(x(r,O(e)),P(e))}}),(function(){return o.handleMonthYearChange(o.state.date)}))})),he(ke(o),"header",(function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:o.state.date,r=Le(e,o.props.locale),a=[];return o.props.showWeekNumbers&&a.push(t.createElement("div",{key:"W",className:"react-datepicker__day-name"},o.props.weekLabel||"#")),a.concat([0,1,2,3,4,5,6].map((function(e){var a=c(r,e),s=o.formatWeekday(a,o.props.locale),p=o.props.weekDayClassName?o.props.weekDayClassName(a):void 0;return t.createElement("div",{key:e,className:n("react-datepicker__day-name",p)},s)})))})),he(ke(o),"formatWeekday",(function(e,t){return o.props.formatWeekDay?function(e,t,r){return t(Ne(e,"EEEE",r))}(e,o.props.formatWeekDay,t):o.props.useWeekdaysShort?function(e,t){return Ne(e,"EEE",t)}(e,t):function(e,t){return Ne(e,"EEEEEE",t)}(e,t)})),he(ke(o),"decreaseYear",(function(){o.setState((function(e){var t=e.date;return{date:w(t,o.props.showYearPicker?12:1)}}),(function(){return o.handleYearChange(o.state.date)}))})),he(ke(o),"renderPreviousButton",(function(){if(!o.props.renderCustomHeader){var e;switch(!0){case o.props.showMonthYearPicker:e=it(o.state.date,o.props);break;case o.props.showYearPicker:e=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=Re(w(e,12)),a=mt(n),o=a.startPeriod,s=a.endPeriod,p=r&&P(r);return p&&(p<o||p>s)||!1}(o.state.date,o.props);break;default:e=st(o.state.date,o.props)}if((o.props.forceShowMonthNavigation||o.props.showDisabledMonthNavigation||!e)&&!o.props.showTimeSelectOnly){var r=["react-datepicker__navigation","react-datepicker__navigation--previous"],n=o.decreaseMonth;(o.props.showMonthYearPicker||o.props.showQuarterYearPicker||o.props.showYearPicker)&&(n=o.decreaseYear),e&&o.props.showDisabledMonthNavigation&&(r.push("react-datepicker__navigation--previous--disabled"),n=null);var a=o.props.showMonthYearPicker||o.props.showQuarterYearPicker||o.props.showYearPicker,s=o.props,p=s.previousMonthAriaLabel,i=void 0===p?"Previous Month":p,c=s.previousYearAriaLabel,l=void 0===c?"Previous Year":c;return t.createElement("button",{type:"button",className:r.join(" "),onClick:n,"aria-label":a?l:i},a?o.props.previousYearButtonLabel:o.props.previousMonthButtonLabel)}}})),he(ke(o),"increaseYear",(function(){o.setState((function(e){var t=e.date;return{date:u(t,o.props.showYearPicker?12:1)}}),(function(){return o.handleYearChange(o.state.date)}))})),he(ke(o),"renderNextButton",(function(){if(!o.props.renderCustomHeader){var e;switch(!0){case o.props.showMonthYearPicker:e=ct(o.state.date,o.props);break;case o.props.showYearPicker:e=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.maxDate,n=u(e,12),a=mt(n),o=a.startPeriod,s=a.endPeriod,p=r&&P(r);return p&&(p<o||p>s)||!1}(o.state.date,o.props);break;default:e=pt(o.state.date,o.props)}if((o.props.forceShowMonthNavigation||o.props.showDisabledMonthNavigation||!e)&&!o.props.showTimeSelectOnly){var r=["react-datepicker__navigation","react-datepicker__navigation--next"];o.props.showTimeSelect&&r.push("react-datepicker__navigation--next--with-time"),o.props.todayButton&&r.push("react-datepicker__navigation--next--with-today-button");var n=o.increaseMonth;(o.props.showMonthYearPicker||o.props.showQuarterYearPicker||o.props.showYearPicker)&&(n=o.increaseYear),e&&o.props.showDisabledMonthNavigation&&(r.push("react-datepicker__navigation--next--disabled"),n=null);var a=o.props.showMonthYearPicker||o.props.showQuarterYearPicker||o.props.showYearPicker,s=o.props,p=s.nextMonthAriaLabel,i=void 0===p?"Next Month":p,c=s.nextYearAriaLabel,l=void 0===c?"Next Year":c;return t.createElement("button",{type:"button",className:r.join(" "),onClick:n,"aria-label":a?l:i},a?o.props.nextYearButtonLabel:o.props.nextMonthButtonLabel)}}})),he(ke(o),"renderCurrentMonth",(function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:o.state.date,r=["react-datepicker__current-month"];return o.props.showYearDropdown&&r.push("react-datepicker__current-month--hasYearDropdown"),o.props.showMonthDropdown&&r.push("react-datepicker__current-month--hasMonthDropdown"),o.props.showMonthYearDropdown&&r.push("react-datepicker__current-month--hasMonthYearDropdown"),t.createElement("div",{className:r.join(" ")},Ne(e,o.props.dateFormat,o.props.locale))})),he(ke(o),"renderYearDropdown",(function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(o.props.showYearDropdown&&!e)return t.createElement(wt,{adjustDateOnChange:o.props.adjustDateOnChange,date:o.state.date,onSelect:o.props.onSelect,setOpen:o.props.setOpen,dropdownMode:o.props.dropdownMode,onChange:o.changeYear,minDate:o.props.minDate,maxDate:o.props.maxDate,year:P(o.state.date),scrollableYearDropdown:o.props.scrollableYearDropdown,yearDropdownItemNumber:o.props.yearDropdownItemNumber})})),he(ke(o),"renderMonthDropdown",(function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(o.props.showMonthDropdown&&!e)return t.createElement(kt,{dropdownMode:o.props.dropdownMode,locale:o.props.locale,onChange:o.changeMonth,month:O(o.state.date),useShortMonthInDropdown:o.props.useShortMonthInDropdown})})),he(ke(o),"renderMonthYearDropdown",(function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(o.props.showMonthYearDropdown&&!e)return t.createElement(Ct,{dropdownMode:o.props.dropdownMode,locale:o.props.locale,dateFormat:o.props.dateFormat,onChange:o.changeMonthYear,minDate:o.props.minDate,maxDate:o.props.maxDate,date:o.state.date,scrollableMonthYearDropdown:o.props.scrollableMonthYearDropdown})})),he(ke(o),"renderTodayButton",(function(){if(o.props.todayButton&&!o.props.showTimeSelectOnly)return t.createElement("div",{className:"react-datepicker__today-button",onClick:function(e){return o.props.onSelect(A(Pe()),e)}},o.props.todayButton)})),he(ke(o),"renderDefaultHeader",(function(e){var r=e.monthDate,n=e.i;return t.createElement("div",{className:"react-datepicker__header"},o.renderCurrentMonth(r),t.createElement("div",{className:"react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(o.props.dropdownMode),onFocus:o.handleDropdownFocus},o.renderMonthDropdown(0!==n),o.renderMonthYearDropdown(0!==n),o.renderYearDropdown(0!==n)),t.createElement("div",{className:"react-datepicker__day-names"},o.header(r)))})),he(ke(o),"renderCustomHeader",(function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},r=e.monthDate,n=e.i;if(0!==n&&void 0!==n)return null;var a=st(o.state.date,o.props),s=pt(o.state.date,o.props),p=it(o.state.date,o.props),i=ct(o.state.date,o.props),c=!o.props.showMonthYearPicker&&!o.props.showQuarterYearPicker&&!o.props.showYearPicker;return t.createElement("div",{className:"react-datepicker__header react-datepicker__header--custom",onFocus:o.props.onDropdownFocus},o.props.renderCustomHeader(ye(ye({},o.state),{},{changeMonth:o.changeMonth,changeYear:o.changeYear,decreaseMonth:o.decreaseMonth,increaseMonth:o.increaseMonth,decreaseYear:o.decreaseYear,increaseYear:o.increaseYear,prevMonthButtonDisabled:a,nextMonthButtonDisabled:s,prevYearButtonDisabled:p,nextYearButtonDisabled:i})),c&&t.createElement("div",{className:"react-datepicker__day-names"},o.header(r)))})),he(ke(o),"renderYearHeader",(function(){var e=o.state.date,r=o.props.showYearPicker,n=mt(e),a=n.startPeriod,s=n.endPeriod;return t.createElement("div",{className:"react-datepicker__header react-datepicker-year-header"},r?"".concat(a," - ").concat(s):P(e))})),he(ke(o),"renderHeader",(function(e){switch(!0){case void 0!==o.props.renderCustomHeader:return o.renderCustomHeader(e);case o.props.showMonthYearPicker||o.props.showQuarterYearPicker||o.props.showYearPicker:return o.renderYearHeader(e);default:return o.renderDefaultHeader(e)}})),he(ke(o),"renderMonths",(function(){if(!o.props.showTimeSelectOnly&&!o.props.showYearPicker){for(var e=[],r=o.props.showPreviousMonths?o.props.monthsShown-1:0,n=v(o.state.date,r),a=0;a<o.props.monthsShown;++a){var s=a-o.props.monthSelectedIn,p=d(n,s),i="month-".concat(a);e.push(t.createElement("div",{key:i,ref:function(e){o.monthContainer=e},className:"react-datepicker__month-container"},o.renderHeader({monthDate:p,i:a}),t.createElement(Pt,{chooseDayAriaLabelPrefix:o.props.chooseDayAriaLabelPrefix,disabledDayAriaLabelPrefix:o.props.disabledDayAriaLabelPrefix,weekAriaLabelPrefix:o.props.weekAriaLabelPrefix,onChange:o.changeMonthYear,day:p,dayClassName:o.props.dayClassName,monthClassName:o.props.monthClassName,onDayClick:o.handleDayClick,handleOnKeyDown:o.props.handleOnKeyDown,onDayMouseEnter:o.handleDayMouseEnter,onMouseLeave:o.handleMonthMouseLeave,onWeekSelect:o.props.onWeekSelect,orderInDisplay:a,formatWeekNumber:o.props.formatWeekNumber,locale:o.props.locale,minDate:o.props.minDate,maxDate:o.props.maxDate,excludeDates:o.props.excludeDates,highlightDates:o.props.highlightDates,selectingDate:o.state.selectingDate,includeDates:o.props.includeDates,fixedHeight:o.props.fixedHeight,filterDate:o.props.filterDate,preSelection:o.props.preSelection,selected:o.props.selected,selectsStart:o.props.selectsStart,selectsEnd:o.props.selectsEnd,selectsRange:o.props.selectsRange,showWeekNumbers:o.props.showWeekNumbers,startDate:o.props.startDate,endDate:o.props.endDate,peekNextMonth:o.props.peekNextMonth,setOpen:o.props.setOpen,shouldCloseOnSelect:o.props.shouldCloseOnSelect,renderDayContents:o.props.renderDayContents,disabledKeyboardNavigation:o.props.disabledKeyboardNavigation,showMonthYearPicker:o.props.showMonthYearPicker,showFullMonthYearPicker:o.props.showFullMonthYearPicker,showTwoColumnMonthYearPicker:o.props.showTwoColumnMonthYearPicker,showYearPicker:o.props.showYearPicker,showQuarterYearPicker:o.props.showQuarterYearPicker,isInputFocused:o.props.isInputFocused,containerRef:o.containerRef})))}return e}})),he(ke(o),"renderYears",(function(){if(!o.props.showTimeSelectOnly)return o.props.showYearPicker?t.createElement("div",{className:"react-datepicker__year--container"},o.renderHeader(),t.createElement(Et,fe({onDayClick:o.handleDayClick,date:o.state.date},o.props))):void 0})),he(ke(o),"renderTimeSection",(function(){if(o.props.showTimeSelect&&(o.state.monthContainer||o.props.showTimeSelectOnly))return t.createElement(Mt,{selected:o.props.selected,openToDate:o.props.openToDate,onChange:o.props.onTimeChange,timeClassName:o.props.timeClassName,format:o.props.timeFormat,includeTimes:o.props.includeTimes,intervals:o.props.timeIntervals,minTime:o.props.minTime,maxTime:o.props.maxTime,excludeTimes:o.props.excludeTimes,timeCaption:o.props.timeCaption,todayButton:o.props.todayButton,showMonthDropdown:o.props.showMonthDropdown,showMonthYearDropdown:o.props.showMonthYearDropdown,showYearDropdown:o.props.showYearDropdown,withPortal:o.props.withPortal,monthRef:o.state.monthContainer,injectTimes:o.props.injectTimes,locale:o.props.locale})})),he(ke(o),"renderInputTimeSection",(function(){var e=new Date(o.props.selected),r=Ee(e)&&Boolean(o.props.selected)?"".concat(ft(e.getHours()),":").concat(ft(e.getMinutes())):"";if(o.props.showTimeInput)return t.createElement(Nt,{timeString:r,timeInputLabel:o.props.timeInputLabel,onChange:o.props.onTimeChange,customTimeInput:o.props.customTimeInput})})),o.containerRef=t.createRef(),o.state={date:o.getDateInView(),selectingDate:null,monthContainer:null},o}return ue(a,null,[{key:"defaultProps",get:function(){return{onDropdownFocus:function(){},monthsShown:1,monthSelectedIn:0,forceShowMonthNavigation:!1,timeCaption:"Time",previousYearButtonLabel:"Previous Year",nextYearButtonLabel:"Next Year",previousMonthButtonLabel:"Previous Month",nextMonthButtonLabel:"Next Month",customTimeInput:null}}}]),ue(a,[{key:"componentDidMount",value:function(){var e=this;this.props.showTimeSelect&&(this.assignMonthContainer=void e.setState({monthContainer:e.monthContainer}))}},{key:"componentDidUpdate",value:function(e){this.props.preSelection&&!Be(this.props.preSelection,e.preSelection)?this.setState({date:this.props.preSelection}):this.props.openToDate&&!Be(this.props.openToDate,e.openToDate)&&this.setState({date:this.props.openToDate})}},{key:"render",value:function(){var e=this.props.container||Yt;return t.createElement("div",{ref:this.containerRef},t.createElement(e,{className:n("react-datepicker",this.props.className,{"react-datepicker--time-only":this.props.showTimeSelectOnly}),showPopperArrow:this.props.showPopperArrow,arrowProps:this.props.arrowProps},this.renderPreviousButton(),this.renderNextButton(),this.renderMonths(),this.renderYears(),this.renderTodayButton(),this.renderTimeSection(),this.renderInputTimeSection(),this.props.children))}}]),a}(t.Component),It=function(e){return!e.disabled&&-1!==e.tabIndex},Lt=function(e){ve(n,e);var r=be(n);function n(e){var a;return le(this,n),he(ke(a=r.call(this,e)),"getTabChildren",(function(){return Array.prototype.slice.call(a.tabLoopRef.current.querySelectorAll("[tabindex], a, button, input, select, textarea"),1,-1).filter(It)})),he(ke(a),"handleFocusStart",(function(e){var t=a.getTabChildren();t&&t.length>1&&t[t.length-1].focus()})),he(ke(a),"handleFocusEnd",(function(e){var t=a.getTabChildren();t&&t.length>1&&t[0].focus()})),a.tabLoopRef=t.createRef(),a}return ue(n,null,[{key:"defaultProps",get:function(){return{enableTabLoop:!0}}}]),ue(n,[{key:"render",value:function(){return this.props.enableTabLoop?t.createElement("div",{className:"react-datepicker__tab-loop",ref:this.tabLoopRef},t.createElement("div",{className:"react-datepicker__tab-loop__start",tabIndex:"0",onFocus:this.handleFocusStart}),this.props.children,t.createElement("div",{className:"react-datepicker__tab-loop__end",tabIndex:"0",onFocus:this.handleFocusEnd})):this.props.children}}]),n}(t.Component),jt=function(e){ve(r,e);var t=be(r);function r(e){var n;return le(this,r),(n=t.call(this,e)).el=document.createElement("div"),n}return ue(r,[{key:"componentDidMount",value:function(){this.portalRoot=document.getElementById(this.props.portalId),this.portalRoot||(this.portalRoot=document.createElement("div"),this.portalRoot.setAttribute("id",this.props.portalId),document.body.appendChild(this.portalRoot)),this.portalRoot.appendChild(this.el)}},{key:"componentWillUnmount",value:function(){this.portalRoot.removeChild(this.el)}},{key:"render",value:function(){return ie.createPortal(this.props.children,this.el)}}]),r}(t.Component),Rt=function(e){ve(a,e);var r=be(a);function a(){return le(this,a),r.apply(this,arguments)}return ue(a,[{key:"render",value:function(){var e,r=this.props,a=r.className,o=r.wrapperClassName,s=r.hidePopper,p=r.popperComponent,i=r.popperModifiers,c=r.popperPlacement,l=r.popperProps,d=r.targetComponent,u=r.enableTabLoop,h=r.popperOnKeyDown,f=r.portalId;if(!s){var m=n("react-datepicker-popper",a);e=t.createElement(pe.Popper,fe({modifiers:i,placement:c},l),(function(e){var r=e.ref,n=e.style,a=e.placement,o=e.arrowProps;return t.createElement(Lt,{enableTabLoop:u},t.createElement("div",fe({ref:r,style:n},{className:m,"data-placement":a,onKeyDown:h}),t.cloneElement(p,{arrowProps:o})))}))}this.props.popperContainer&&(e=t.createElement(this.props.popperContainer,{},e)),f&&!s&&(e=t.createElement(jt,{portalId:f},e));var y=n("react-datepicker-wrapper",o);return t.createElement(pe.Manager,{className:"react-datepicker-manager"},t.createElement(pe.Reference,null,(function(e){var r=e.ref;return t.createElement("div",{ref:r,className:y},d)})),e)}}],[{key:"defaultProps",get:function(){return{hidePopper:!0,popperModifiers:{preventOverflow:{enabled:!0,escapeWithReference:!0,boundariesElement:"viewport"}},popperProps:{},popperPlacement:"bottom-start"}}}]),a}(t.Component),Ft=se(Tt);var qt=function(e){ve(o,e);var r=be(o);function o(e){var s;return le(this,o),he(ke(s=r.call(this,e)),"getPreSelection",(function(){return s.props.openToDate?s.props.openToDate:s.props.selectsEnd&&s.props.startDate?s.props.startDate:s.props.selectsStart&&s.props.endDate?s.props.endDate:Pe()})),he(ke(s),"calcInitialState",(function(){var e=s.getPreSelection(),t=lt(s.props),r=dt(s.props),n=t&&te(e,t)?t:r&&ee(e,r)?r:e;return{open:s.props.startOpen||!1,preventFocus:!1,preSelection:s.props.selected?s.props.selected:n,highlightDates:ut(s.props.highlightDates),focused:!1}})),he(ke(s),"clearPreventFocusTimeout",(function(){s.preventFocusTimeout&&clearTimeout(s.preventFocusTimeout)})),he(ke(s),"setFocus",(function(){s.input&&s.input.focus&&s.input.focus({preventScroll:!0})})),he(ke(s),"setBlur",(function(){s.input&&s.input.blur&&s.input.blur(),s.cancelFocusInput()})),he(ke(s),"setOpen",(function(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];s.setState({open:e,preSelection:e&&s.state.open?s.state.preSelection:s.calcInitialState().preSelection,lastPreSelectChange:At},(function(){e||s.setState((function(e){return{focused:!!t&&e.focused}}),(function(){!t&&s.setBlur(),s.setState({inputValue:null})}))}))})),he(ke(s),"inputOk",(function(){return a(s.state.preSelection)})),he(ke(s),"isCalendarOpen",(function(){return void 0===s.props.open?s.state.open&&!s.props.disabled&&!s.props.readOnly:s.props.open})),he(ke(s),"handleFocus",(function(e){s.state.preventFocus||(s.props.onFocus(e),s.props.preventOpenOnFocus||s.props.readOnly||s.setOpen(!0)),s.setState({focused:!0})})),he(ke(s),"cancelFocusInput",(function(){clearTimeout(s.inputFocusTimeout),s.inputFocusTimeout=null})),he(ke(s),"deferFocusInput",(function(){s.cancelFocusInput(),s.inputFocusTimeout=setTimeout((function(){return s.setFocus()}),1)})),he(ke(s),"handleDropdownFocus",(function(){s.cancelFocusInput()})),he(ke(s),"handleBlur",(function(e){(!s.state.open||s.props.withPortal||s.props.showTimeInput)&&s.props.onBlur(e),s.setState({focused:!1})})),he(ke(s),"handleCalendarClickOutside",(function(e){s.props.inline||s.setOpen(!1),s.props.onClickOutside(e),s.props.withPortal&&e.preventDefault()})),he(ke(s),"handleChange",(function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];var n=t[0];if(!s.props.onChangeRaw||(s.props.onChangeRaw.apply(ke(s),t),"function"==typeof n.isDefaultPrevented&&!n.isDefaultPrevented())){s.setState({inputValue:n.target.value,lastPreSelectChange:Wt});var a=Me(n.target.value,s.props.dateFormat,s.props.locale,s.props.strictParsing);!a&&n.target.value||s.setSelected(a,n,!0)}})),he(ke(s),"handleSelect",(function(e,t,r){s.setState({preventFocus:!0},(function(){return s.preventFocusTimeout=setTimeout((function(){return s.setState({preventFocus:!1})}),50),s.preventFocusTimeout})),s.props.onChangeRaw&&s.props.onChangeRaw(t),s.setSelected(e,t,!1,r),!s.props.shouldCloseOnSelect||s.props.showTimeSelect?s.setPreSelection(e):s.props.inline||s.setOpen(!1)})),he(ke(s),"setSelected",(function(e,t,r,n){var a=e;if(null===a||!Ge(a,s.props)){var o=s.props,p=o.onChange,i=o.selectsRange,c=o.startDate,l=o.endDate;if(!He(s.props.selected,a)||s.props.allowSameDay||i)if(null!==a&&(!s.props.selected||r&&(s.props.showTimeSelect||s.props.showTimeSelectOnly||s.props.showTimeInput)||(a=Ye(a,{hour:g(s.props.selected),minute:k(s.props.selected),second:D(s.props.selected)})),s.props.inline||s.setState({preSelection:a}),s.props.focusSelectedMonth||s.setState({monthSelectedIn:n})),i){var d=c&&!l,u=c&&l;!c&&!l?p([a,null],t):d&&(te(a,c)?p([a,null],t):p([c,a],t)),u&&p([a,null],t)}else p(a,t);r||(s.props.onSelect(a,t),s.setState({inputValue:null}))}})),he(ke(s),"setPreSelection",(function(e){var t=void 0!==s.props.minDate,r=void 0!==s.props.maxDate,n=!0;e&&(t&&r?n=Ke(e,s.props.minDate,s.props.maxDate):t?n=ee(e,s.props.minDate):r&&(n=te(e,s.props.maxDate))),n&&s.setState({preSelection:e})})),he(ke(s),"handleTimeChange",(function(e){var t=Ye(s.props.selected?s.props.selected:s.getPreSelection(),{hour:g(e),minute:k(e)});s.setState({preSelection:t}),s.props.onChange(t),s.props.shouldCloseOnSelect&&s.setOpen(!1),s.props.showTimeInput&&s.setOpen(!0),s.setState({inputValue:null})})),he(ke(s),"onInputClick",(function(){s.props.disabled||s.props.readOnly||s.setOpen(!0),s.props.onInputClick()})),he(ke(s),"onInputKeyDown",(function(e){s.props.onKeyDown(e);var t=e.key;if(s.state.open||s.props.inline||s.props.preventOpenOnFocus){if(s.state.open){if("ArrowDown"===t||"ArrowUp"===t){e.preventDefault();var r=s.calendar.componentNode&&s.calendar.componentNode.querySelector('.react-datepicker__day[tabindex="0"]');return void(r&&r.focus({preventScroll:!0}))}var n=Pe(s.state.preSelection);"Enter"===t?(e.preventDefault(),s.inputOk()&&s.state.lastPreSelectChange===At?(s.handleSelect(n,e),!s.props.shouldCloseOnSelect&&s.setPreSelection(n)):s.setOpen(!1)):"Escape"===t&&(e.preventDefault(),s.setOpen(!1)),s.inputOk()||s.props.onInputError({code:1,msg:"Date input not valid."})}}else"ArrowDown"!==t&&"ArrowUp"!==t&&"Enter"!==t||s.onInputClick()})),he(ke(s),"onDayKeyDown",(function(e){s.props.onKeyDown(e);var t=e.key,r=Pe(s.state.preSelection);if("Enter"===t)e.preventDefault(),s.handleSelect(r,e),!s.props.shouldCloseOnSelect&&s.setPreSelection(r);else if("Escape"===t)e.preventDefault(),s.setOpen(!1),s.inputOk()||s.props.onInputError({code:1,msg:"Date input not valid."});else if(!s.props.disabledKeyboardNavigation){var n;switch(t){case"ArrowLeft":n=m(r,1);break;case"ArrowRight":n=c(r,1);break;case"ArrowUp":n=y(r,1);break;case"ArrowDown":n=l(r,1);break;case"PageUp":n=v(r,1);break;case"PageDown":n=d(r,1);break;case"Home":n=w(r,1);break;case"End":n=u(r,1)}if(!n)return void(s.props.onInputError&&s.props.onInputError({code:1,msg:"Date input not valid."}));e.preventDefault(),s.setState({lastPreSelectChange:At}),s.props.adjustDateOnChange&&s.setSelected(n),s.setPreSelection(n)}})),he(ke(s),"onPopperKeyDown",(function(e){"Escape"===e.key&&(e.preventDefault(),s.setState({preventFocus:!0},(function(){s.setOpen(!1),setTimeout((function(){s.setFocus(),s.setState({preventFocus:!1})}))})))})),he(ke(s),"onClearClick",(function(e){e&&e.preventDefault&&e.preventDefault(),s.props.onChange(null,e),s.setState({inputValue:null})})),he(ke(s),"clear",(function(){s.onClearClick()})),he(ke(s),"onScroll",(function(e){"boolean"==typeof s.props.closeOnScroll&&s.props.closeOnScroll?e.target!==document&&e.target!==document.documentElement&&e.target!==document.body||s.setOpen(!1):"function"==typeof s.props.closeOnScroll&&s.props.closeOnScroll(e)&&s.setOpen(!1)})),he(ke(s),"renderCalendar",(function(){return s.props.inline||s.isCalendarOpen()?t.createElement(Ft,{ref:function(e){s.calendar=e},locale:s.props.locale,chooseDayAriaLabelPrefix:s.props.chooseDayAriaLabelPrefix,disabledDayAriaLabelPrefix:s.props.disabledDayAriaLabelPrefix,weekAriaLabelPrefix:s.props.weekAriaLabelPrefix,adjustDateOnChange:s.props.adjustDateOnChange,setOpen:s.setOpen,shouldCloseOnSelect:s.props.shouldCloseOnSelect,dateFormat:s.props.dateFormatCalendar,useWeekdaysShort:s.props.useWeekdaysShort,formatWeekDay:s.props.formatWeekDay,dropdownMode:s.props.dropdownMode,selected:s.props.selected,preSelection:s.state.preSelection,onSelect:s.handleSelect,onWeekSelect:s.props.onWeekSelect,openToDate:s.props.openToDate,minDate:s.props.minDate,maxDate:s.props.maxDate,selectsStart:s.props.selectsStart,selectsEnd:s.props.selectsEnd,selectsRange:s.props.selectsRange,startDate:s.props.startDate,endDate:s.props.endDate,excludeDates:s.props.excludeDates,filterDate:s.props.filterDate,onClickOutside:s.handleCalendarClickOutside,formatWeekNumber:s.props.formatWeekNumber,highlightDates:s.state.highlightDates,includeDates:s.props.includeDates,includeTimes:s.props.includeTimes,injectTimes:s.props.injectTimes,peekNextMonth:s.props.peekNextMonth,showMonthDropdown:s.props.showMonthDropdown,showPreviousMonths:s.props.showPreviousMonths,useShortMonthInDropdown:s.props.useShortMonthInDropdown,showMonthYearDropdown:s.props.showMonthYearDropdown,showWeekNumbers:s.props.showWeekNumbers,showYearDropdown:s.props.showYearDropdown,withPortal:s.props.withPortal,forceShowMonthNavigation:s.props.forceShowMonthNavigation,showDisabledMonthNavigation:s.props.showDisabledMonthNavigation,scrollableYearDropdown:s.props.scrollableYearDropdown,scrollableMonthYearDropdown:s.props.scrollableMonthYearDropdown,todayButton:s.props.todayButton,weekLabel:s.props.weekLabel,outsideClickIgnoreClass:"react-datepicker-ignore-onclickoutside",fixedHeight:s.props.fixedHeight,monthsShown:s.props.monthsShown,monthSelectedIn:s.state.monthSelectedIn,onDropdownFocus:s.handleDropdownFocus,onMonthChange:s.props.onMonthChange,onYearChange:s.props.onYearChange,dayClassName:s.props.dayClassName,weekDayClassName:s.props.weekDayClassName,monthClassName:s.props.monthClassName,timeClassName:s.props.timeClassName,showTimeSelect:s.props.showTimeSelect,showTimeSelectOnly:s.props.showTimeSelectOnly,onTimeChange:s.handleTimeChange,timeFormat:s.props.timeFormat,timeIntervals:s.props.timeIntervals,minTime:s.props.minTime,maxTime:s.props.maxTime,excludeTimes:s.props.excludeTimes,timeCaption:s.props.timeCaption,className:s.props.calendarClassName,container:s.props.calendarContainer,yearDropdownItemNumber:s.props.yearDropdownItemNumber,previousMonthButtonLabel:s.props.previousMonthButtonLabel,nextMonthButtonLabel:s.props.nextMonthButtonLabel,previousYearButtonLabel:s.props.previousYearButtonLabel,nextYearButtonLabel:s.props.nextYearButtonLabel,timeInputLabel:s.props.timeInputLabel,disabledKeyboardNavigation:s.props.disabledKeyboardNavigation,renderCustomHeader:s.props.renderCustomHeader,popperProps:s.props.popperProps,renderDayContents:s.props.renderDayContents,onDayMouseEnter:s.props.onDayMouseEnter,onMonthMouseLeave:s.props.onMonthMouseLeave,showTimeInput:s.props.showTimeInput,showMonthYearPicker:s.props.showMonthYearPicker,showFullMonthYearPicker:s.props.showFullMonthYearPicker,showTwoColumnMonthYearPicker:s.props.showTwoColumnMonthYearPicker,showYearPicker:s.props.showYearPicker,showQuarterYearPicker:s.props.showQuarterYearPicker,showPopperArrow:s.props.showPopperArrow,excludeScrollbar:s.props.excludeScrollbar,handleOnKeyDown:s.onDayKeyDown,isInputFocused:s.state.focused,customTimeInput:s.props.customTimeInput,setPreSelection:s.setPreSelection},s.props.children):null})),he(ke(s),"renderDateInput",(function(){var e,r,a,o,p,i=n(s.props.className,he({},"react-datepicker-ignore-onclickoutside",s.state.open)),c=s.props.customInput||t.createElement("input",{type:"text"}),l=s.props.customInputRef||"ref",d="string"==typeof s.props.value?s.props.value:"string"==typeof s.state.inputValue?s.state.inputValue:(r=s.props.selected,a=s.props,o=a.dateFormat,p=a.locale,r&&Ne(r,Array.isArray(o)?o[0]:o,p)||"");return t.cloneElement(c,(he(e={},l,(function(e){s.input=e})),he(e,"value",d),he(e,"onBlur",s.handleBlur),he(e,"onChange",s.handleChange),he(e,"onClick",s.onInputClick),he(e,"onFocus",s.handleFocus),he(e,"onKeyDown",s.onInputKeyDown),he(e,"id",s.props.id),he(e,"name",s.props.name),he(e,"autoFocus",s.props.autoFocus),he(e,"placeholder",s.props.placeholderText),he(e,"disabled",s.props.disabled),he(e,"autoComplete",s.props.autoComplete),he(e,"className",n(c.props.className,i)),he(e,"title",s.props.title),he(e,"readOnly",s.props.readOnly),he(e,"required",s.props.required),he(e,"tabIndex",s.props.tabIndex),he(e,"aria-labelledby",s.props.ariaLabelledBy),e))})),he(ke(s),"renderClearButton",(function(){var e=s.props,r=e.isClearable,n=e.selected,a=e.clearButtonTitle,o=e.ariaLabelClose,p=void 0===o?"Close":o;return r&&null!=n?t.createElement("button",{type:"button",className:"react-datepicker__close-icon","aria-label":p,onClick:s.onClearClick,title:a,tabIndex:-1}):null})),s.state=s.calcInitialState(),s}return ue(o,null,[{key:"defaultProps",get:function(){return{allowSameDay:!1,dateFormat:"MM/dd/yyyy",dateFormatCalendar:"LLLL yyyy",onChange:function(){},disabled:!1,disabledKeyboardNavigation:!1,dropdownMode:"scroll",onFocus:function(){},onBlur:function(){},onKeyDown:function(){},onInputClick:function(){},onSelect:function(){},onClickOutside:function(){},onMonthChange:function(){},onCalendarOpen:function(){},onCalendarClose:function(){},preventOpenOnFocus:!1,onYearChange:function(){},onInputError:function(){},monthsShown:1,readOnly:!1,withPortal:!1,shouldCloseOnSelect:!0,showTimeSelect:!1,showTimeInput:!1,showPreviousMonths:!1,showMonthYearPicker:!1,showFullMonthYearPicker:!1,showTwoColumnMonthYearPicker:!1,showYearPicker:!1,showQuarterYearPicker:!1,strictParsing:!1,timeIntervals:30,timeCaption:"Time",previousMonthButtonLabel:"Previous Month",nextMonthButtonLabel:"Next Month",previousYearButtonLabel:"Previous Year",nextYearButtonLabel:"Next Year",timeInputLabel:"Time",enableTabLoop:!0,renderDayContents:function(e){return e},focusSelectedMonth:!1,showPopperArrow:!0,excludeScrollbar:!0,customTimeInput:null}}}]),ue(o,[{key:"componentDidMount",value:function(){window.addEventListener("scroll",this.onScroll,!0)}},{key:"componentDidUpdate",value:function(e,t){var r,n;e.inline&&(r=e.selected,n=this.props.selected,r&&n?O(r)!==O(n)||P(r)!==P(n):r!==n)&&this.setPreSelection(this.props.selected),void 0!==this.state.monthSelectedIn&&e.monthsShown!==this.props.monthsShown&&this.setState({monthSelectedIn:0}),e.highlightDates!==this.props.highlightDates&&this.setState({highlightDates:ut(this.props.highlightDates)}),t.focused||He(e.selected,this.props.selected)||this.setState({inputValue:null}),t.open!==this.state.open&&(!1===t.open&&!0===this.state.open&&this.props.onCalendarOpen(),!0===t.open&&!1===this.state.open&&this.props.onCalendarClose())}},{key:"componentWillUnmount",value:function(){this.clearPreventFocusTimeout(),window.removeEventListener("scroll",this.onScroll,!0)}},{key:"render",value:function(){var e=this.renderCalendar();return this.props.inline&&!this.props.withPortal?e:this.props.withPortal?t.createElement("div",null,this.props.inline?null:t.createElement("div",{className:"react-datepicker__input-container"},this.renderDateInput(),this.renderClearButton()),this.state.open||this.props.inline?t.createElement("div",{className:"react-datepicker__portal"},e):null):t.createElement(Rt,{className:this.props.popperClassName,wrapperClassName:this.props.wrapperClassName,hidePopper:!this.isCalendarOpen(),portalId:this.props.portalId,popperModifiers:this.props.popperModifiers,targetComponent:t.createElement("div",{className:"react-datepicker__input-container"},this.renderDateInput(),this.renderClearButton()),popperContainer:this.props.popperContainer,popperComponent:e,popperPlacement:this.props.popperPlacement,popperProps:this.props.popperProps,popperOnKeyDown:this.onPopperKeyDown,enableTabLoop:this.props.enableTabLoop})}}]),o}(t.Component),Wt="input",At="navigate";e.CalendarContainer=Yt,e.default=qt,e.getDefaultLocale=Qe,e.registerLocale=function(e,t){var r="undefined"!=typeof window?window:global;r.__localeData__||(r.__localeData__={}),r.__localeData__[e]=t},e.setDefaultLocale=function(e){("undefined"!=typeof window?window:global).__localeId__=e},Object.defineProperty(e,"__esModule",{value:!0})}));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1942 */
[2679, 13],
/* 1943 */
[2680, 13],
/* 1944 */
[2681, 13],
/* 1945 */
[2684, 13],
/* 1946 */
[2685, 428, 13],
/* 1947 */
[2686, 13],
/* 1948 */
[2687, 13],
/* 1949 */
[2688, 13],
/* 1950 */
[2689, 13],
/* 1951 */
[2690, 13],
/* 1952 */
[2691, 13],
/* 1953 */
[2692, 13],
/* 1954 */
[2693, 13],
/* 1955 */
[2694, 13],
/* 1956 */
[2695, 13],
/* 1957 */
[2696, 13],
/* 1958 */
[2697, 13],
/* 1959 */
[2698, 13],
/* 1960 */
[2699, 13],
/* 1961 */
[2705, 13],
/* 1962 */
[2707, 13],
/* 1963 */
[2709, 13, 710],
/* 1964 */
[2711, 220, 13],
/* 1965 */
[2712, 220, 13],
/* 1966 */
[2713, 220, 13, 428],
/* 1967 */
[2715, 13],
/* 1968 */
[2716, 13],
/* 1969 */
[2717, 13],
/* 1970 */
[2718, 13],
/* 1971 */
[2719, 13],
/* 1972 */
[2720, 13],
/* 1973 */
[2721, 13, 711],
/* 1974 */
[2722, 277],
/* 1975 */
[2724, 13],
/* 1976 */
[2725, 13],
/* 1977 */
[2726, 13],
/* 1978 */
[2727, 13],
/* 1979 */
[2728, 13],
/* 1980 */
[2729, 13],
/* 1981 */
[2730, 13],
/* 1982 */
[2731, 13],
/* 1983 */
[2732, 13],
/* 1984 */
[2733, 2001, 221, 13],
/* 1985 */
[2734, 13],
/* 1986 */
[2735, 13],
/* 1987 */
[2736, 13],
/* 1988 */
[2737, 13],
/* 1989 */
[2738, 13],
/* 1990 */
[2739, 13],
/* 1991 */
[2740, 13],
/* 1992 */
[2741, 13],
/* 1993 */
[2742, 13],
/* 1994 */
[2743, 13],
/* 1995 */
[2744, 13],
/* 1996 */
[2745, 13],
/* 1997 */
[2746, 13],
/* 1998 */
[2748, 13],
/* 1999 */
[2749, 13],
/* 2000 */
[2751, 13],
/* 2001 */
[2752, 13],
/* 2002 */
[2753, 13],
/* 2003 */
[2754, 13],
/* 2004 */
[2755, 13],
/* 2005 */
[2756, 714, 13],
/* 2006 */
[2757, 714, 13],
/* 2007 */
[2758, 13],
/* 2008 */
[2759, 13, 221],
/* 2009 */
[2760, 13],
/* 2010 */
[2761, 13],
/* 2011 */
[2764, 703],
/* 2012 */
[2765, 704, 13],
/* 2013 */
[2766, 705, 429, 707, 708, 706],
/* 2014 */
[2767, 709, 13],
/* 2015 */
[2768, 277, 13],
/* 2016 */
[2769, 712, 13],
/* 2017 */
[2770, 715, 13],
/* 2018 */
1526,
/* 2019 */
/***/ function(module, exports, __webpack_require__) {

	// [NUXIBA]  Version: 2022.0.0 - 2022-11-10  
	 (function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define([], factory);
		else if(typeof exports === 'object')
			exports["LoggerEntryPoint"] = factory();
		else
			root["LoggerEntryPoint"] = factory();
	})(typeof self !== 'undefined' ? self : this, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 3);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var bind = __webpack_require__(5);
	var isBuffer = __webpack_require__(15);
	
	/*global toString:true*/
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return toString.call(val) === '[object Array]';
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	function isArrayBuffer(val) {
	  return toString.call(val) === '[object ArrayBuffer]';
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(val) {
	  return (typeof FormData !== 'undefined') && (val instanceof FormData);
	}
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  var result;
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
	  }
	  return result;
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	function isDate(val) {
	  return toString.call(val) === '[object Date]';
	}
	
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	function isFile(val) {
	  return toString.call(val) === '[object File]';
	}
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	function isBlob(val) {
	  return toString.call(val) === '[object Blob]';
	}
	
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */
	function isFunction(val) {
	  return toString.call(val) === '[object Function]';
	}
	
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */
	function isStream(val) {
	  return isObject(val) && isFunction(val.pipe);
	}
	
	/**
	 * Determine if a value is a URLSearchParams object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	 */
	function isURLSearchParams(val) {
	  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
	}
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.replace(/^\s*/, '').replace(/\s*$/, '');
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  navigator.product -> 'ReactNative'
	 */
	function isStandardBrowserEnv() {
	  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
	    return false;
	  }
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object') {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }
	
	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (typeof result[key] === 'object' && typeof val === 'object') {
	      result[key] = merge(result[key], val);
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	/**
	 * Extends object a by mutably adding to it the properties of object b.
	 *
	 * @param {Object} a The object to be extended
	 * @param {Object} b The object to copy properties from
	 * @param {Object} thisArg The object to bind function to
	 * @return {Object} The resulting value of object a
	 */
	function extend(a, b, thisArg) {
	  forEach(b, function assignValue(val, key) {
	    if (thisArg && typeof val === 'function') {
	      a[key] = bind(val, thisArg);
	    } else {
	      a[key] = val;
	    }
	  });
	  return a;
	}
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isBuffer: isBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isFunction: isFunction,
	  isStream: isStream,
	  isURLSearchParams: isURLSearchParams,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  extend: extend,
	  trim: trim
	};
	
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var instance = null;
	
	var Constants = exports.Constants = function Constants() {
	    _classCallCheck(this, Constants);
	
	    if (!instance) {
	        instance = this;
	    }
	};
	
	Constants._LOGGER_VAR_WINDOW = "NuxibaLogger";
	Constants._LOGGER_CONFIGURATION_FILE_LOCALE = './logger.json';
	Constants._LOGGER_CONFIGURATION_FILE_REMOTE = 'logger.json';
	Constants._LOGGER_CONFIGURATION_FILE_ENCODE = 'utf8';
	Constants._LOGGER_CONFIGURATION_ASSIGNED = window[Constants._LOGGER_VAR_WINDOW] ? true : false;
	Constants._LOG_LEVELS = {
	    "TRACE": { logLevel: 0 },
	    "DEBUG": { logLevel: 1 },
	    "INFO": { logLevel: 2 },
	    "WARN": { logLevel: 3 },
	    "ERROR": { logLevel: 4 }
	};
	Constants._Log_CONSOLE = {
	    "TRACE": console.log,
	    "DEBUG": console.log,
	    "INFO": console.info,
	    "WARN": console.warn,
	    "ERROR": console.error
	};
	Constants._CONFIGURATIONS = {
	    "_ENABLE_DEFAULT": true,
	    "_ENABLE_AJAX": false,
	    "_USE_WINDOW_ORIGIN": true,
	    "_SERVER": "http://127.0.0.1",
	    "_DOMAIN": "/LoggerWS/api/Logger",
	    "_SEVERITY": "INFO",
	    "_SEVERITY_CONSOLE": "INFO",
	    "_NUMBER_ATTEMP_POST": 10,
	    "_FILTER_USER_POST": [],
	    "_FILTER_APP_POST": []
	};
	Constants._REST = {
	    _POST_METHOD: "POST",
	    _MODE: "cors",
	    _CONTENT_TYPE: "content-type",
	    _APPLICATION_JSON: "application/json"
	};
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(process) {
	
	var utils = __webpack_require__(0);
	var normalizeHeaderName = __webpack_require__(18);
	
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	function setContentTypeIfUnset(headers, value) {
	  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
	    headers['Content-Type'] = value;
	  }
	}
	
	function getDefaultAdapter() {
	  var adapter;
	  if (typeof XMLHttpRequest !== 'undefined') {
	    // For browsers use XHR adapter
	    adapter = __webpack_require__(6);
	  } else if (typeof process !== 'undefined') {
	    // For node use HTTP adapter
	    adapter = __webpack_require__(6);
	  }
	  return adapter;
	}
	
	var defaults = {
	  adapter: getDefaultAdapter(),
	
	  transformRequest: [function transformRequest(data, headers) {
	    normalizeHeaderName(headers, 'Content-Type');
	    if (utils.isFormData(data) ||
	      utils.isArrayBuffer(data) ||
	      utils.isBuffer(data) ||
	      utils.isStream(data) ||
	      utils.isFile(data) ||
	      utils.isBlob(data)
	    ) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isURLSearchParams(data)) {
	      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	      return data.toString();
	    }
	    if (utils.isObject(data)) {
	      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
	      return JSON.stringify(data);
	    }
	    return data;
	  }],
	
	  transformResponse: [function transformResponse(data) {
	    /*eslint no-param-reassign:0*/
	    if (typeof data === 'string') {
	      try {
	        data = JSON.parse(data);
	      } catch (e) { /* Ignore */ }
	    }
	    return data;
	  }],
	
	  /**
	   * A timeout in milliseconds to abort a request. If set to 0 (default) a
	   * timeout is not created.
	   */
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	
	  maxContentLength: -1,
	
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  }
	};
	
	defaults.headers = {
	  common: {
	    'Accept': 'application/json, text/plain, */*'
	  }
	};
	
	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  defaults.headers[method] = {};
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
	});
	
	module.exports = defaults;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17)))
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.LoggerInstance = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _LoggerDispatcher = __webpack_require__(12);
	
	var _Constants = __webpack_require__(1);
	
	var _LoggerLocal = __webpack_require__(11);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var usertype = 'AGENT';
	var userId = '';
	var application = '';
	
	var LoggerInstance = function () {
		function LoggerInstance() {
			_classCallCheck(this, LoggerInstance);
		}
	
		_createClass(LoggerInstance, null, [{
			key: 'setUsertype',
			value: function setUsertype(value) {
				usertype = value;
			}
		}, {
			key: 'setUserId',
			value: function setUserId(value) {
				userId = value;
			}
		}, {
			key: 'getUserId',
			value: function getUserId() {
				return userId;
			}
		}, {
			key: 'setApplication',
			value: function setApplication(value) {
				application = value;
			}
		}, {
			key: 'setLocalLogger',
			value: function setLocalLogger(value) {
				_LoggerLocal.LoggerLocal.setEnabled(value);
			}
		}, {
			key: 'setLocalStorageTime',
			value: function setLocalStorageTime(minutes) {
				_LoggerLocal.LoggerLocal.setStorageTimeMin(minutes);
			}
		}, {
			key: 'getApplication',
			value: function getApplication() {
				return application;
			}
		}, {
			key: 'SetUseServerWithLocation',
			value: function SetUseServerWithLocation(useWindowLocation) {
				window[_Constants.Constants._LOGGER_VAR_WINDOW]._USE_WINDOW_LOCATION = useWindowLocation;
			}
		}, {
			key: 'addUserId',
			value: function addUserId(msg) {
				if (userId) {
					var userIdPrint = '[UserId:' + userId + ']';
					msg.unshift(userIdPrint);
				}
			}
		}, {
			key: 'Group',
			value: function Group(label) {
				console.group(label);
			}
		}, {
			key: 'GroupEnd',
			value: function GroupEnd() {
				console.groupEnd();
			}
		}, {
			key: 'CleanLocalLog',
			value: function CleanLocalLog() {
				_LoggerLocal.LoggerLocal.Clean();
			}
		}, {
			key: 'Trace',
			value: function Trace() {
				for (var _len = arguments.length, msg = Array(_len), _key = 0; _key < _len; _key++) {
					msg[_key] = arguments[_key];
				}
	
				_LoggerDispatcher.LoggerDispatcher.Dispatch(usertype, 'Trace', ['[UserId:' + userId + ']'].concat(msg));
			}
		}, {
			key: 'Debug',
			value: function Debug() {
				for (var _len2 = arguments.length, msg = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
					msg[_key2] = arguments[_key2];
				}
	
				LoggerInstance.addUserId(msg);
				_LoggerDispatcher.LoggerDispatcher.Dispatch(usertype, 'Debug', ['[UserId:' + userId + ']'].concat(msg));
			}
		}, {
			key: 'Warning',
			value: function Warning() {
				for (var _len3 = arguments.length, msg = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
					msg[_key3] = arguments[_key3];
				}
	
				LoggerInstance.addUserId(msg);
				_LoggerDispatcher.LoggerDispatcher.Dispatch(usertype, 'Warn', ['[UserId:' + userId + ']'].concat(msg));
			}
		}, {
			key: 'Warn',
			value: function Warn() {
				for (var _len4 = arguments.length, msg = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
					msg[_key4] = arguments[_key4];
				}
	
				LoggerInstance.Warning(msg);
			}
		}, {
			key: 'Info',
			value: function Info() {
				for (var _len5 = arguments.length, msg = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
					msg[_key5] = arguments[_key5];
				}
	
				LoggerInstance.addUserId(msg);
				_LoggerDispatcher.LoggerDispatcher.Dispatch(usertype, 'Info', ['[UserId:' + userId + ']'].concat(msg));
			}
		}, {
			key: 'Error',
			value: function Error() {
				for (var _len6 = arguments.length, msg = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
					msg[_key6] = arguments[_key6];
				}
	
				LoggerInstance.addUserId(msg);
				_LoggerDispatcher.LoggerDispatcher.Dispatch(usertype, 'Error', ['[UserId:' + userId + ']'].concat(msg));
			}
		}, {
			key: 'JsWarning',
			value: function JsWarning() {
				for (var _len7 = arguments.length, msg = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
					msg[_key7] = arguments[_key7];
				}
	
				LoggerInstance.addUserId(msg);
				_LoggerDispatcher.LoggerDispatcher.Dispatch(usertype, 'Warn', ['[UserId:' + userId + ']'].concat(msg), true);
			}
		}, {
			key: 'JsError',
			value: function JsError() {
				for (var _len8 = arguments.length, msg = Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
					msg[_key8] = arguments[_key8];
				}
	
				LoggerInstance.addUserId(msg);
				_LoggerDispatcher.LoggerDispatcher.Dispatch(usertype, 'Error', ['[UserId:' + userId + ']'].concat(msg), true);
			}
		}, {
			key: 'LevelConsole',
			get: function get() {
				return window[_Constants.Constants._LOGGER_VAR_WINDOW]._SEVERITY_CONSOLE;
			}
		}]);
	
		return LoggerInstance;
	}();
	
	exports.LoggerInstance = LoggerInstance;
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __webpack_require__) {
	
	module.exports = __webpack_require__(14);
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	module.exports = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	    return fn.apply(thisArg, args);
	  };
	};
	
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var utils = __webpack_require__(0);
	var settle = __webpack_require__(19);
	var buildURL = __webpack_require__(21);
	var parseHeaders = __webpack_require__(22);
	var isURLSameOrigin = __webpack_require__(23);
	var createError = __webpack_require__(7);
	
	module.exports = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	
	    if (utils.isFormData(requestData)) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }
	
	    var request = new XMLHttpRequest();
	
	    // HTTP basic authentication
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password || '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }
	
	    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);
	
	    // Set the request timeout in MS
	    request.timeout = config.timeout;
	
	    // Listen for ready state
	    request.onreadystatechange = function handleLoad() {
	      if (!request || request.readyState !== 4) {
	        return;
	      }
	
	      // The request errored out and we didn't get a response, this will be
	      // handled by onerror instead
	      // With one exception: request that using file: protocol, most browsers
	      // will return status as 0 even though it's a successful request
	      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	        return;
	      }
	
	      // Prepare the response
	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
	      var response = {
	        data: responseData,
	        status: request.status,
	        statusText: request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };
	
	      settle(resolve, reject, response);
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle low level network errors
	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(createError('Network Error', config, null, request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle timeout
	    request.ontimeout = function handleTimeout() {
	      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
	        request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.
	    if (utils.isStandardBrowserEnv()) {
	      var cookies = __webpack_require__(24);
	
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
	          cookies.read(config.xsrfCookieName) :
	          undefined;
	
	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    }
	
	    // Add headers to the request
	    if ('setRequestHeader' in request) {
	      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    }
	
	    // Add withCredentials to request if needed
	    if (config.withCredentials) {
	      request.withCredentials = true;
	    }
	
	    // Add responseType to request if needed
	    if (config.responseType) {
	      try {
	        request.responseType = config.responseType;
	      } catch (e) {
	        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
	        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
	        if (config.responseType !== 'json') {
	          throw e;
	        }
	      }
	    }
	
	    // Handle progress if needed
	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    }
	
	    // Not all browsers support upload events
	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }
	
	    if (config.cancelToken) {
	      // Handle cancellation
	      config.cancelToken.promise.then(function onCanceled(cancel) {
	        if (!request) {
	          return;
	        }
	
	        request.abort();
	        reject(cancel);
	        // Clean up request
	        request = null;
	      });
	    }
	
	    if (requestData === undefined) {
	      requestData = null;
	    }
	
	    // Send the request
	    request.send(requestData);
	  });
	};
	
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var enhanceError = __webpack_require__(20);
	
	/**
	 * Create an Error with the specified message, config, error code, request and response.
	 *
	 * @param {string} message The error message.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */
	module.exports = function createError(message, config, code, request, response) {
	  var error = new Error(message);
	  return enhanceError(error, config, code, request, response);
	};
	
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	module.exports = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};
	
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	/**
	 * A `Cancel` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */
	function Cancel(message) {
	  this.message = message;
	}
	
	Cancel.prototype.toString = function toString() {
	  return 'Cancel' + (this.message ? ': ' + this.message : '');
	};
	
	Cancel.prototype.__CANCEL__ = true;
	
	module.exports = Cancel;
	
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.LoggerUtils = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Constants = __webpack_require__(1);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LoggerUtils = function () {
		function LoggerUtils() {
			_classCallCheck(this, LoggerUtils);
		}
	
		_createClass(LoggerUtils, null, [{
			key: 'GetLogLevelBySeverity',
			value: function GetLogLevelBySeverity(severity) {
				var logLevel = 1;
				severity = severity.toUpperCase();
				if (_Constants.Constants._LOG_LEVELS[severity]) {
					logLevel = _Constants.Constants._LOG_LEVELS[severity].logLevel;
				}
				return logLevel;
			}
		}, {
			key: 'IsAllowedRemoteToLogBySeverity',
			value: function IsAllowedRemoteToLogBySeverity(severity) {
				return LoggerUtils.GetLogLevelBySeverity(severity) >= LoggerUtils.GetCurrentRemoteSeverityLevelConfigured();
			}
		}, {
			key: 'GetCurrentRemoteSeverityLevelConfigured',
			value: function GetCurrentRemoteSeverityLevelConfigured() {
				return LoggerUtils.GetLogLevelBySeverity(window[_Constants.Constants._LOGGER_VAR_WINDOW]['_SEVERITY']);
			}
		}, {
			key: 'IsAllowedConsoleToLogBySeverity',
			value: function IsAllowedConsoleToLogBySeverity(severity) {
				return LoggerUtils.GetLogLevelBySeverity(severity) >= LoggerUtils.GetCurrentConsoleSeverityLevelConfigured();
			}
		}, {
			key: 'GetCurrentConsoleSeverityLevelConfigured',
			value: function GetCurrentConsoleSeverityLevelConfigured() {
				return LoggerUtils.GetLogLevelBySeverity(window[_Constants.Constants._LOGGER_VAR_WINDOW]['_SEVERITY_CONSOLE']);
			}
		}, {
			key: 'ToStringMessage',
			value: function ToStringMessage() {
				var messageString = '';
	
				for (var _len = arguments.length, message = Array(_len), _key = 0; _key < _len; _key++) {
					message[_key] = arguments[_key];
				}
	
				message.forEach(function (entry) {
					messageString += LoggerUtils.ToStringObject(entry);
				});
				return messageString;
			}
		}, {
			key: 'ToStringObject',
			value: function ToStringObject(entry) {
				return LoggerUtils.IsObject(entry) ? '\n' + LoggerUtils.JsonToString(entry) : entry;
			}
		}, {
			key: 'IsObject',
			value: function IsObject(value) {
				return value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value.constructor === Object;
			}
		}, {
			key: 'JsonToString',
			value: function JsonToString(entry) {
				var seen = [];
				var jsonReplacerConst = 2;
				return JSON.stringify(entry, function (key, val) {
					if (val && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) == 'object') {
						seen.push(val);
					}
					return val;
				}, jsonReplacerConst);
			}
		}]);
	
		return LoggerUtils;
	}();
	
	exports.LoggerUtils = LoggerUtils;
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ls = window.localStorage;
	var logKey = 'LOG-' + new Date().getDate() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getFullYear();
	var logDateKey = 'GalateaLoggerDate';
	var enabled = false;
	var storageTimeMin = 0;
	var firstLogTs = null;
	var storageTimeFactor = 60000;
	
	var LoggerLocal = function () {
		function LoggerLocal() {
			_classCallCheck(this, LoggerLocal);
		}
	
		_createClass(LoggerLocal, null, [{
			key: 'getKey',
			value: function getKey() {
				return logKey;
			}
		}, {
			key: 'setEnabled',
			value: function setEnabled(value) {
				enabled = value;
			}
		}, {
			key: 'setStorageTimeMin',
			value: function setStorageTimeMin(minutes) {
				storageTimeMin = minutes;
			}
		}, {
			key: 'Add',
			value: function Add(message, usertype, severity) {
				if (enabled) {
					var ts = new Date();
					var prevEntries = ls.getItem(logKey);
					var newEntry = usertype + '-' + severity + ' ' + ts.getDate() + '-' + (ts.getMonth() + 1) + '-' + ts.getFullYear() + '-' + ts.getDate() + ' ' + ts.toLocaleTimeString() + ' - MSG: ' + message;
					if (prevEntries) {
						if (!firstLogTs) {
							firstLogTs = new Date(JSON.parse(ls.getItem(logDateKey)));
						}
						if (storageTimeMin !== 0 && (ts - firstLogTs) / storageTimeFactor > storageTimeMin) {
							LoggerLocal.Clean();
							firstLogTs = ts;
							ls.setItem(logDateKey, JSON.stringify(ts));
						} else {
							newEntry = prevEntries + ';' + newEntry;
						}
						ls.setItem(logKey, '' + newEntry);
					} else {
						firstLogTs = ts;
						ls.setItem(logKey, newEntry);
						ls.setItem(logDateKey, JSON.stringify(ts));
					}
				}
			}
		}, {
			key: 'getRawLogs',
			value: function getRawLogs() {
				return ls.getItem(logKey);
			}
		}, {
			key: 'getLogs',
			value: function getLogs() {
				return ls.getItem(logKey).replaceAll(';', '\n');
			}
		}, {
			key: 'Clean',
			value: function Clean() {
				console.log('Cleaning local storage ', logKey);
				ls.removeItem(logKey);
			}
		}]);
	
		return LoggerLocal;
	}();
	
	exports.LoggerLocal = LoggerLocal;
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.LoggerDispatcher = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _LoggerRestClient = __webpack_require__(13);
	
	var _Constants = __webpack_require__(1);
	
	var _LoggerUtils = __webpack_require__(10);
	
	var _LoggerConfigurator = __webpack_require__(32);
	
	var _LoggerInstance = __webpack_require__(3);
	
	var _LoggerLocal = __webpack_require__(11);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ls = window.localStorage;
	
	var LoggerDispatcher = function () {
		function LoggerDispatcher() {
			_classCallCheck(this, LoggerDispatcher);
		}
	
		_createClass(LoggerDispatcher, null, [{
			key: 'Dispatch',
			value: function Dispatch(usertype, severity, message, hideInConsole) {
				_LoggerLocal.LoggerLocal.Add(message, usertype, severity);
				_LoggerConfigurator.LoggerConfigurator.Init(function () {
					!hideInConsole && LoggerDispatcher.DefaultOutput.apply(LoggerDispatcher, [usertype, severity].concat(_toConsumableArray(message)));
					LoggerDispatcher.RemoteOutput.apply(LoggerDispatcher, [usertype, severity].concat(_toConsumableArray(message)));
				});
			}
		}, {
			key: 'RemoteOutput',
			value: function RemoteOutput(usertype, severity) {
				if (window[_Constants.Constants._LOGGER_VAR_WINDOW] && window[_Constants.Constants._LOGGER_VAR_WINDOW]['_ENABLE_AJAX'] && _LoggerUtils.LoggerUtils.IsAllowedRemoteToLogBySeverity(severity)) {
					for (var _len = arguments.length, message = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
						message[_key - 2] = arguments[_key];
					}
	
					if (severity.toUpperCase() === 'WARN' || severity.toUpperCase() === 'ERROR') {
						_LoggerRestClient.LoggerRestClient.log(usertype, severity, '[' + usertype + '] ' + message);
					} else {
						var isEmptyFilterUser = window[_Constants.Constants._LOGGER_VAR_WINDOW]._FILTER_USER_POST.length === 0;
						var isEmptyFilterApp = window[_Constants.Constants._LOGGER_VAR_WINDOW]._FILTER_APP_POST.length === 0;
	
						if (isEmptyFilterUser && isEmptyFilterApp) {
							_LoggerRestClient.LoggerRestClient.log.apply(_LoggerRestClient.LoggerRestClient, [usertype, severity].concat(message));
						} else {
							var containtUserId = true;
							var containtApp = true;
	
							if (!isEmptyFilterUser) {
								containtUserId = window[_Constants.Constants._LOGGER_VAR_WINDOW]._FILTER_USER_POST.find(function (ele) {
									return ele === _LoggerInstance.LoggerInstance.getUserId();
								});
							}
							if (!isEmptyFilterApp) {
								containtApp = window[_Constants.Constants._LOGGER_VAR_WINDOW]._FILTER_APP_POST.find(function (ele) {
									return ele === _LoggerInstance.LoggerInstance.getApplication();
								});
							}
	
							if (containtUserId && containtApp) {
								_LoggerRestClient.LoggerRestClient.log(usertype, severity, '[' + usertype + '] ' + message);
							}
						}
					}
				}
			}
		}, {
			key: 'DefaultOutput',
			value: function DefaultOutput(usertype, severity) {
				severity = severity.toUpperCase();
				if (window[_Constants.Constants._LOGGER_VAR_WINDOW] && window[_Constants.Constants._LOGGER_VAR_WINDOW]._ENABLE_DEFAULT && _LoggerUtils.LoggerUtils.IsAllowedConsoleToLogBySeverity(severity)) {
					var _consoleLogLevel;
	
					var consoleLogLevel = console.log;
					if (_Constants.Constants._Log_CONSOLE[severity]) {
						consoleLogLevel = _Constants.Constants._Log_CONSOLE[severity];
					}
					var time = new Date().toLocaleTimeString();
	
					for (var _len2 = arguments.length, message = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
						message[_key2 - 2] = arguments[_key2];
					}
	
					(_consoleLogLevel = consoleLogLevel).call.apply(_consoleLogLevel, [null, '[' + time + '][' + severity + '][' + usertype + ']'].concat(message));
				}
			}
		}]);
	
		return LoggerDispatcher;
	}();
	
	exports.LoggerDispatcher = LoggerDispatcher;
	
	/***/ }),
	/* 13 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.LoggerRestClient = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _axios = __webpack_require__(4);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _Constants = __webpack_require__(1);
	
	var _LoggerUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var numberAttemp = 0;
	var numMessageWarn = true;
	
	var LoggerRestClient = function () {
		function LoggerRestClient() {
			_classCallCheck(this, LoggerRestClient);
		}
	
		_createClass(LoggerRestClient, null, [{
			key: 'log',
			value: function log(usertype, severity) {
				if (window[_Constants.Constants._LOGGER_VAR_WINDOW]._ENABLE_AJAX) {
					if (window[_Constants.Constants._LOGGER_VAR_WINDOW]._NUMBER_ATTEMP_POST === 0 || numberAttemp < window[_Constants.Constants._LOGGER_VAR_WINDOW]._NUMBER_ATTEMP_POST) {
						try {
							var serverUrl = new URL(window[_Constants.Constants._LOGGER_VAR_WINDOW]['_SERVER']);
							var server = new URL(window[_Constants.Constants._LOGGER_VAR_WINDOW]['_DOMAIN'], serverUrl);
	
							for (var _len = arguments.length, message = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
								message[_key - 2] = arguments[_key];
							}
	
							var msg = _LoggerUtils.LoggerUtils.ToStringMessage(message);
							_axios2.default.post(server, { UserType: usertype, Message: msg, Severity: severity }).then(function () {
								numberAttemp = 0;
							}).catch(function (error) {
								numberAttemp++;
								console.warn('It was not possible to send the message server:', server, error);
							});
						} catch (e) {
							numberAttemp++;
							console.error('it was not possible to send the log message because an error ocurred servidor:' + window[_Constants.Constants._LOGGER_VAR_WINDOW]['_SERVER'] + ' error:' + e + ' recommendation: you could check the logger configuration');
						}
					} else {
						if (numMessageWarn) {
							numMessageWarn = false;
							console.warn('number of attempts to overcome Api web is necessary to check the configuration file for logger.json');
						}
					}
				}
			}
		}]);
	
		return LoggerRestClient;
	}();
	
	exports.LoggerRestClient = LoggerRestClient;
	
	/***/ }),
	/* 14 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var utils = __webpack_require__(0);
	var bind = __webpack_require__(5);
	var Axios = __webpack_require__(16);
	var defaults = __webpack_require__(2);
	
	/**
	 * Create an instance of Axios
	 *
	 * @param {Object} defaultConfig The default config for the instance
	 * @return {Axios} A new instance of Axios
	 */
	function createInstance(defaultConfig) {
	  var context = new Axios(defaultConfig);
	  var instance = bind(Axios.prototype.request, context);
	
	  // Copy axios.prototype to instance
	  utils.extend(instance, Axios.prototype, context);
	
	  // Copy context to instance
	  utils.extend(instance, context);
	
	  return instance;
	}
	
	// Create the default instance to be exported
	var axios = createInstance(defaults);
	
	// Expose Axios class to allow class inheritance
	axios.Axios = Axios;
	
	// Factory for creating new instances
	axios.create = function create(instanceConfig) {
	  return createInstance(utils.merge(defaults, instanceConfig));
	};
	
	// Expose Cancel & CancelToken
	axios.Cancel = __webpack_require__(9);
	axios.CancelToken = __webpack_require__(30);
	axios.isCancel = __webpack_require__(8);
	
	// Expose all/spread
	axios.all = function all(promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__(31);
	
	module.exports = axios;
	
	// Allow use of default import syntax in TypeScript
	module.exports.default = axios;
	
	
	/***/ }),
	/* 15 */
	/***/ (function(module, exports) {
	
	/*!
	 * Determine if an object is a Buffer
	 *
	 * @author   Feross Aboukhadijeh <https://feross.org>
	 * @license  MIT
	 */
	
	module.exports = function isBuffer (obj) {
	  return obj != null && obj.constructor != null &&
	    typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
	}
	
	
	/***/ }),
	/* 16 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var defaults = __webpack_require__(2);
	var utils = __webpack_require__(0);
	var InterceptorManager = __webpack_require__(25);
	var dispatchRequest = __webpack_require__(26);
	
	/**
	 * Create a new instance of Axios
	 *
	 * @param {Object} instanceConfig The default config for the instance
	 */
	function Axios(instanceConfig) {
	  this.defaults = instanceConfig;
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	
	/**
	 * Dispatch a request
	 *
	 * @param {Object} config The config specific for this request (merged with this.defaults)
	 */
	Axios.prototype.request = function request(config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof config === 'string') {
	    config = utils.merge({
	      url: arguments[0]
	    }, arguments[1]);
	  }
	
	  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
	  config.method = config.method.toLowerCase();
	
	  // Hook up interceptors middleware
	  var chain = [dispatchRequest, undefined];
	  var promise = Promise.resolve(config);
	
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    chain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    chain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  while (chain.length) {
	    promise = promise.then(chain.shift(), chain.shift());
	  }
	
	  return promise;
	};
	
	// Provide aliases for supported request methods
	utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url
	    }));
	  };
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, data, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	});
	
	module.exports = Axios;
	
	
	/***/ }),
	/* 17 */
	/***/ (function(module, exports) {
	
	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };
	
	
	/***/ }),
	/* 18 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var utils = __webpack_require__(0);
	
	module.exports = function normalizeHeaderName(headers, normalizedName) {
	  utils.forEach(headers, function processHeader(value, name) {
	    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	      headers[normalizedName] = value;
	      delete headers[name];
	    }
	  });
	};
	
	
	/***/ }),
	/* 19 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var createError = __webpack_require__(7);
	
	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	module.exports = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  // Note: status is not exposed by XDomainRequest
	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(createError(
	      'Request failed with status code ' + response.status,
	      response.config,
	      null,
	      response.request,
	      response
	    ));
	  }
	};
	
	
	/***/ }),
	/* 20 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	/**
	 * Update an Error with the specified config, error code, and response.
	 *
	 * @param {Error} error The error to update.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The error.
	 */
	module.exports = function enhanceError(error, config, code, request, response) {
	  error.config = config;
	  if (code) {
	    error.code = code;
	  }
	  error.request = request;
	  error.response = response;
	  return error;
	};
	
	
	/***/ }),
	/* 21 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var utils = __webpack_require__(0);
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%40/gi, '@').
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }
	
	  var serializedParams;
	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else if (utils.isURLSearchParams(params)) {
	    serializedParams = params.toString();
	  } else {
	    var parts = [];
	
	    utils.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }
	
	      if (utils.isArray(val)) {
	        key = key + '[]';
	      } else {
	        val = [val];
	      }
	
	      utils.forEach(val, function parseValue(v) {
	        if (utils.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils.isObject(v)) {
	          v = JSON.stringify(v);
	        }
	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	
	    serializedParams = parts.join('&');
	  }
	
	  if (serializedParams) {
	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }
	
	  return url;
	};
	
	
	/***/ }),
	/* 22 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var utils = __webpack_require__(0);
	
	// Headers whose duplicates are ignored by node
	// c.f. https://nodejs.org/api/http.html#http_message_headers
	var ignoreDuplicateOf = [
	  'age', 'authorization', 'content-length', 'content-type', 'etag',
	  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
	  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
	  'referer', 'retry-after', 'user-agent'
	];
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
	        return;
	      }
	      if (key === 'set-cookie') {
	        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
	      } else {
	        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	      }
	    }
	  });
	
	  return parsed;
	};
	
	
	/***/ }),
	/* 23 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var utils = __webpack_require__(0);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	  (function standardBrowserEnv() {
	    var msie = /(msie|trident)/i.test(navigator.userAgent);
	    var urlParsingNode = document.createElement('a');
	    var originURL;
	
	    /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	    function resolveURL(url) {
	      var href = url;
	
	      if (msie) {
	        // IE needs attribute set twice to normalize properties
	        urlParsingNode.setAttribute('href', href);
	        href = urlParsingNode.href;
	      }
	
	      urlParsingNode.setAttribute('href', href);
	
	      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	      return {
	        href: urlParsingNode.href,
	        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	        host: urlParsingNode.host,
	        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	        hostname: urlParsingNode.hostname,
	        port: urlParsingNode.port,
	        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	                  urlParsingNode.pathname :
	                  '/' + urlParsingNode.pathname
	      };
	    }
	
	    originURL = resolveURL(window.location.href);
	
	    /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	    return function isURLSameOrigin(requestURL) {
	      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	      return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	    };
	  })() :
	
	  // Non standard browser envs (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return function isURLSameOrigin() {
	      return true;
	    };
	  })()
	);
	
	
	/***/ }),
	/* 24 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var utils = __webpack_require__(0);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs support document.cookie
	  (function standardBrowserEnv() {
	    return {
	      write: function write(name, value, expires, path, domain, secure) {
	        var cookie = [];
	        cookie.push(name + '=' + encodeURIComponent(value));
	
	        if (utils.isNumber(expires)) {
	          cookie.push('expires=' + new Date(expires).toGMTString());
	        }
	
	        if (utils.isString(path)) {
	          cookie.push('path=' + path);
	        }
	
	        if (utils.isString(domain)) {
	          cookie.push('domain=' + domain);
	        }
	
	        if (secure === true) {
	          cookie.push('secure');
	        }
	
	        document.cookie = cookie.join('; ');
	      },
	
	      read: function read(name) {
	        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	        return (match ? decodeURIComponent(match[3]) : null);
	      },
	
	      remove: function remove(name) {
	        this.write(name, '', Date.now() - 86400000);
	      }
	    };
	  })() :
	
	  // Non standard browser env (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return {
	      write: function write() {},
	      read: function read() { return null; },
	      remove: function remove() {}
	    };
	  })()
	);
	
	
	/***/ }),
	/* 25 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var utils = __webpack_require__(0);
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function use(fulfilled, rejected) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;
	
	
	/***/ }),
	/* 26 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var utils = __webpack_require__(0);
	var transformData = __webpack_require__(27);
	var isCancel = __webpack_require__(8);
	var defaults = __webpack_require__(2);
	var isAbsoluteURL = __webpack_require__(28);
	var combineURLs = __webpack_require__(29);
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	function throwIfCancellationRequested(config) {
	  if (config.cancelToken) {
	    config.cancelToken.throwIfRequested();
	  }
	}
	
	/**
	 * Dispatch a request to the server using the configured adapter.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  throwIfCancellationRequested(config);
	
	  // Support baseURL config
	  if (config.baseURL && !isAbsoluteURL(config.url)) {
	    config.url = combineURLs(config.baseURL, config.url);
	  }
	
	  // Ensure headers exist
	  config.headers = config.headers || {};
	
	  // Transform request data
	  config.data = transformData(
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Flatten headers
	  config.headers = utils.merge(
	    config.headers.common || {},
	    config.headers[config.method] || {},
	    config.headers || {}
	  );
	
	  utils.forEach(
	    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
	    function cleanHeaderConfig(method) {
	      delete config.headers[method];
	    }
	  );
	
	  var adapter = config.adapter || defaults.adapter;
	
	  return adapter(config).then(function onAdapterResolution(response) {
	    throwIfCancellationRequested(config);
	
	    // Transform response data
	    response.data = transformData(
	      response.data,
	      response.headers,
	      config.transformResponse
	    );
	
	    return response;
	  }, function onAdapterRejection(reason) {
	    if (!isCancel(reason)) {
	      throwIfCancellationRequested(config);
	
	      // Transform response data
	      if (reason && reason.response) {
	        reason.response.data = transformData(
	          reason.response.data,
	          reason.response.headers,
	          config.transformResponse
	        );
	      }
	    }
	
	    return Promise.reject(reason);
	  });
	};
	
	
	/***/ }),
	/* 27 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var utils = __webpack_require__(0);
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  /*eslint no-param-reassign:0*/
	  utils.forEach(fns, function transform(fn) {
	    data = fn(data, headers);
	  });
	
	  return data;
	};
	
	
	/***/ }),
	/* 28 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	module.exports = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};
	
	
	/***/ }),
	/* 29 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	module.exports = function combineURLs(baseURL, relativeURL) {
	  return relativeURL
	    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
	    : baseURL;
	};
	
	
	/***/ }),
	/* 30 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var Cancel = __webpack_require__(9);
	
	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */
	function CancelToken(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }
	
	  var resolvePromise;
	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });
	
	  var token = this;
	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }
	
	    token.reason = new Cancel(message);
	    resolvePromise(token.reason);
	  });
	}
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};
	
	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */
	CancelToken.source = function source() {
	  var cancel;
	  var token = new CancelToken(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};
	
	module.exports = CancelToken;
	
	
	/***/ }),
	/* 31 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};
	
	
	/***/ }),
	/* 32 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.LoggerConfigurator = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Constants = __webpack_require__(1);
	
	var _axios = __webpack_require__(4);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _loadFirst = true;
	
	var LoggerConfigurator = function () {
		function LoggerConfigurator() {
			_classCallCheck(this, LoggerConfigurator);
		}
	
		_createClass(LoggerConfigurator, null, [{
			key: 'Init',
			value: function Init(callback) {
				if (_loadFirst && LoggerConfigurator.IsConfigurationNotAssigned()) {
					_loadFirst = false;
					LoggerConfigurator.GetByExecutionEnvironment(callback);
				} else {
					callback();
				}
			}
		}, {
			key: 'Setup',
			value: function Setup(configuration, callback) {
				console.info('Setup ', configuration);
				if (configuration) {
					window[_Constants.Constants._LOGGER_VAR_WINDOW] = {};
	
					var _iteratorNormalCompletion = true;
					var _didIteratorError = false;
					var _iteratorError = undefined;
	
					try {
						for (var _iterator = Object.entries(_Constants.Constants._CONFIGURATIONS)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
							var _step$value = _slicedToArray(_step.value, 2),
							    key = _step$value[0],
							    value = _step$value[1];
	
							setValueDefatult(configuration, key, value);
						}
					} catch (err) {
						_didIteratorError = true;
						_iteratorError = err;
					} finally {
						try {
							if (!_iteratorNormalCompletion && _iterator.return) {
								_iterator.return();
							}
						} finally {
							if (_didIteratorError) {
								throw _iteratorError;
							}
						}
					}
	
					Object.keys(configuration).forEach(function (key) {
						return window[_Constants.Constants._LOGGER_VAR_WINDOW][key] = configuration[key];
					});
	
					if (window[_Constants.Constants._LOGGER_VAR_WINDOW]._USE_WINDOW_ORIGIN) {
						LoggerConfigurator.SetConfigurationServer();
					}
				} else {
					window[_Constants.Constants._LOGGER_VAR_WINDOW] = _Constants.Constants._CONFIGURATIONS;
					console.info('Logger will use default configuration ... ', _Constants.Constants._CONFIGURATIONS);
				}
				callback();
			}
		}, {
			key: 'GetByExecutionEnvironment',
			value: function GetByExecutionEnvironment(callback) {
				if (LoggerConfigurator.IsBrowser()) {
					LoggerConfigurator.GetRemote(callback);
				} else {
					LoggerConfigurator.GetLocal(callback);
				}
			}
		}, {
			key: 'IsBrowser',
			value: function IsBrowser() {
				return window ? true : false;
			}
		}, {
			key: 'GetLocal',
			value: function GetLocal(callback) {
				LoggerConfigurator.Setup(null, callback);
			}
		}, {
			key: 'GetRemote',
			value: function GetRemote(callback) {
	
				var remoteLocation = '' + window.location.origin + window.location.pathname;
				var arrayPathname = remoteLocation.split('/');
				console.log("Remove Last element ", arrayPathname.pop());
				remoteLocation = arrayPathname.join('/') + '/';
	
				remoteLocation = remoteLocation + _Constants.Constants._LOGGER_CONFIGURATION_FILE_REMOTE;
	
				_axios2.default.get(remoteLocation, { responseType: 'json' }).then(function (response) {
					LoggerConfigurator.Setup(response.data, callback);
				}).catch(function (error) {
					console.error('It was not possible to get remote file configuration', error);
					LoggerConfigurator.Setup(null, callback);
				});
			}
		}, {
			key: 'SetConfigurationServer',
			value: function SetConfigurationServer() {
				if (window[_Constants.Constants._LOGGER_VAR_WINDOW]._USE_WINDOW_ORIGIN) {
					var hostname = window.location.hostname;
					if (hostname !== '127.0.0.1' && hostname !== 'localhost') {
						var remoteLocation = window.location.origin;
						console.debug('SetConfigurationServer withLocation', remoteLocation);
						window[_Constants.Constants._LOGGER_VAR_WINDOW]['_SERVER'] = remoteLocation;
					}
				}
			}
		}, {
			key: 'ExistExternalConfiguration',
			value: function ExistExternalConfiguration(configuration) {
				return configuration ? true : false;
			}
		}, {
			key: 'IsConfigurationNotAssigned',
			value: function IsConfigurationNotAssigned() {
				return !_Constants.Constants._LOGGER_CONFIGURATION_ASSIGNED;
			}
		}]);
	
		return LoggerConfigurator;
	}();
	
	function setValueDefatult(configuration, property, valueDefault) {
		if (configuration[property] === undefined) {
			console.info('file logger.json does not contain field [%s] set value default [%s]', property, valueDefault);
			configuration[property] = valueDefault;
		}
	}
	
	exports.LoggerConfigurator = LoggerConfigurator;
	
	/***/ })
	/******/ ]);
	});
	//# sourceMappingURL=global-logger-services-js-bundle.js.map 

/***/ },
/* 2020 */
/***/ function(module, exports, __webpack_require__) {

	// [NUXIBA]  Version: 2022.0.1 - 2022-11-10 14:18:54  
	 !function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.EntryPoint=t():e.EntryPoint=t()}("undefined"!=typeof self?self:this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=0)}([function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0}),t.WebSocketFactory=void 0;var o=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),i=n(1);t.WebSocketFactory=function(){function e(){r(this,e)}return o(e,[{key:"buildClient",value:function(){return new i.WebSocketClient}}]),e}()},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0}),t.WebSocketClient=void 0;var o=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),i=n(2),a=null,u=null;t.WebSocketClient=function(){function e(){return r(this,e),a||(i.Logger.Trace("WebSocketClient constructor"),this.WSParameter={serverIP:"",port:"",keepAliveTimeResponse:0,keepAliveTimeRequest:3e4,keepAliveMessage:"ping",onError:function(e){console.log("Stack")},onDisconnected:function(){console.log("Stack")},onConnected:function(){console.log("Stack")},onMessage:function(e){console.log("Stack",e)},onOpen:function(){console.log("Stack")},onClose:function(){console.log("Stack")}},this.tm=null,this.timerPing=null),a}return o(e,[{key:"setUserType",value:function(e){i.Logger.setUsertype(e)}},{key:"setUserId",value:function(e){i.Logger.setUserId(e)}},{key:"manageKeepAlive",value:function(){this.WSParameter.keepAliveTimeResponse>0&&1===u.readyState&&(i.Logger.Trace("Keep Alive configured"),i.Logger.Trace("Sending every  ["+this.WSParameter.keepAliveTimeRequest+"] milisenconds"),i.Logger.Trace("Response expected within  ["+this.WSParameter.keepAliveTimeResponse+"] milisenconds"),this.ping())}},{key:"ping",value:function(){i.Logger.Trace("[WebSocketClient] Ping",this.WSParameter.keepAliveMessage);var e=this;this.send(this.WSParameter.keepAliveMessage),this.tm=setTimeout(function(){i.Logger.Trace("Closed by ping"),e.executeOnClose(),u.close(1e3,"Close not recieve ping server"),e.cleanData()},this.WSParameter.keepAliveTimeResponse+250)}},{key:"pong",value:function(){i.Logger.Trace("[WebSocketClient] Pong");var e=this;clearTimeout(this.tm),this.timerPing=setTimeout(function(){e.ping()},this.WSParameter.keepAliveTimeRequest)}},{key:"connect",value:function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(window.WebboSocket=window.WebSocket||window.MozWebSocket,!window.WebSocket)return void(n.WSParameter.onError&&this.WSParameter.onError(" [WebSocketClient] Sorry, but your browser doesn't support WebSockets."));var t=e?"wss":"ws";u=new WebSocket(t+"://"+this.WSParameter.serverIP+":"+this.WSParameter.port),i.Logger.Trace("Connection created ",u);var n=this;u.onopen=function(){n.WSParameter.onOpen&&(i.Logger.Trace(" OnOpen"),n.manageKeepAlive(),n.WSParameter.onOpen())},u.onerror=function(e){n.WSParameter.onError&&(i.Logger.Error(" OnError ",e),n.WSParameter.onError(e))},u.onmessage=function(e){"pong"===e.data?n.pong():n.WSParameter.onMessage&&n.WSParameter.onMessage(e)},u.onclose=function(){n.executeOnClose()}}},{key:"executeOnClose",value:function(){this.WSParameter.onClose&&this.WSParameter.onClose()}},{key:"send",value:function(e){u&&e&&1===u.readyState&&(i.Logger.Trace("Sending: ",e),u.send(e))}},{key:"close",value:function(){u&&(u.close(),this.cleanData(),i.Logger.Trace("Closed connection"))}},{key:"cleanData",value:function(){u=null,clearTimeout(this.tm),clearTimeout(this.timerPing),i.Logger.Trace("Data cleaned")}}]),e}()},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0}),t.Logger=void 0;var o=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),i=n(3);i.LoggerInstance.setApplication("Web-Socket-Client");t.Logger=function(){function e(){r(this,e)}return o(e,null,[{key:"setUserType",value:function(e){i.LoggerInstance.setUsertype(e)}},{key:"setUserId",value:function(e){i.LoggerInstance.setUserId(e)}},{key:"Group",value:function(e){i.LoggerInstance.Group(e)}},{key:"GroupEnd",value:function(){i.LoggerInstance.GroupEnd()}},{key:"Trace",value:function(){for(var e=arguments.length,t=Array(e),n=0;n<e;n++)t[n]=arguments[n];i.LoggerInstance.Trace(["[Web-Socket-Client]"].concat(t))}},{key:"Debug",value:function(){for(var e=arguments.length,t=Array(e),n=0;n<e;n++)t[n]=arguments[n];i.LoggerInstance.Debug(["[Web-Socket-Client]"].concat(t))}},{key:"Warning",value:function(){for(var e=arguments.length,t=Array(e),n=0;n<e;n++)t[n]=arguments[n];i.LoggerInstance.Warning(["[Web-Socket-Client]"].concat(t))}},{key:"Info",value:function(){for(var e=arguments.length,t=Array(e),n=0;n<e;n++)t[n]=arguments[n];i.LoggerInstance.Info.apply(i.LoggerInstance,["[Web-Socket-Client] "].concat(t))}},{key:"Error",value:function(){for(var e=arguments.length,t=Array(e),n=0;n<e;n++)t[n]=arguments[n];i.LoggerInstance.Error.apply(i.LoggerInstance,["[Web-Socket-Client] "].concat(t))}}]),e}()},function(e,t,n){!function(t,n){e.exports=n()}("undefined"!=typeof self&&self,function(){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=3)}([function(e,t,n){"use strict";function r(e){return"[object Array]"===S.call(e)}function o(e){return"[object ArrayBuffer]"===S.call(e)}function i(e){return"undefined"!=typeof FormData&&e instanceof FormData}function a(e){return"undefined"!=typeof ArrayBuffer&&ArrayBuffer.isView?ArrayBuffer.isView(e):e&&e.buffer&&e.buffer instanceof ArrayBuffer}function u(e){return"string"==typeof e}function s(e){return"number"==typeof e}function c(e){return void 0===e}function l(e){return null!==e&&"object"==typeof e}function f(e){return"[object Date]"===S.call(e)}function p(e){return"[object File]"===S.call(e)}function g(e){return"[object Blob]"===S.call(e)}function d(e){return"[object Function]"===S.call(e)}function y(e){return l(e)&&d(e.pipe)}function v(e){return"undefined"!=typeof URLSearchParams&&e instanceof URLSearchParams}function h(e){return e.replace(/^\s*/,"").replace(/\s*$/,"")}function m(){return("undefined"==typeof navigator||"ReactNative"!==navigator.product)&&("undefined"!=typeof window&&"undefined"!=typeof document)}function _(e,t){if(null!==e&&void 0!==e)if("object"!=typeof e&&(e=[e]),r(e))for(var n=0,o=e.length;n<o;n++)t.call(null,e[n],n,e);else for(var i in e)Object.prototype.hasOwnProperty.call(e,i)&&t.call(null,e[i],i,e)}function L(){function e(e,n){"object"==typeof t[n]&&"object"==typeof e?t[n]=L(t[n],e):t[n]=e}for(var t={},n=0,r=arguments.length;n<r;n++)_(arguments[n],e);return t}function w(e,t,n){return _(t,function(t,r){e[r]=n&&"function"==typeof t?O(t,n):t}),e}var O=n(5),E=n(15),S=Object.prototype.toString;e.exports={isArray:r,isArrayBuffer:o,isBuffer:E,isFormData:i,isArrayBufferView:a,isString:u,isNumber:s,isObject:l,isUndefined:c,isDate:f,isFile:p,isBlob:g,isFunction:d,isStream:y,isURLSearchParams:v,isStandardBrowserEnv:m,forEach:_,merge:L,extend:w,trim:h}},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var o=null,i=t.Constants=function e(){r(this,e),o||(o=this)};i._LOGGER_VAR_WINDOW="NuxibaLogger",i._LOGGER_CONFIGURATION_FILE_LOCALE="./logger.json",i._LOGGER_CONFIGURATION_FILE_REMOTE="logger.json",i._LOGGER_CONFIGURATION_FILE_ENCODE="utf8",i._LOGGER_CONFIGURATION_ASSIGNED=!!window[i._LOGGER_VAR_WINDOW],i._LOG_LEVELS={TRACE:{logLevel:0},DEBUG:{logLevel:1},INFO:{logLevel:2},WARN:{logLevel:3},ERROR:{logLevel:4}},i._Log_CONSOLE={TRACE:console.log,DEBUG:console.log,INFO:console.info,WARN:console.warn,ERROR:console.error},i._CONFIGURATIONS={_ENABLE_DEFAULT:!0,_ENABLE_AJAX:!1,_USE_WINDOW_ORIGIN:!0,_SERVER:"http://127.0.0.1",_DOMAIN:"/LoggerWS/api/Logger",_SEVERITY:"INFO",_SEVERITY_CONSOLE:"INFO",_NUMBER_ATTEMP_POST:10,_FILTER_USER_POST:[],_FILTER_APP_POST:[]},i._REST={_POST_METHOD:"POST",_MODE:"cors",_CONTENT_TYPE:"content-type",_APPLICATION_JSON:"application/json"}},function(e,t,n){"use strict";(function(t){function r(e,t){!o.isUndefined(e)&&o.isUndefined(e["Content-Type"])&&(e["Content-Type"]=t)}var o=n(0),i=n(18),a={"Content-Type":"application/x-www-form-urlencoded"},u={adapter:function(){var e;return"undefined"!=typeof XMLHttpRequest?e=n(6):void 0!==t&&(e=n(6)),e}(),transformRequest:[function(e,t){return i(t,"Content-Type"),o.isFormData(e)||o.isArrayBuffer(e)||o.isBuffer(e)||o.isStream(e)||o.isFile(e)||o.isBlob(e)?e:o.isArrayBufferView(e)?e.buffer:o.isURLSearchParams(e)?(r(t,"application/x-www-form-urlencoded;charset=utf-8"),e.toString()):o.isObject(e)?(r(t,"application/json;charset=utf-8"),JSON.stringify(e)):e}],transformResponse:[function(e){if("string"==typeof e)try{e=JSON.parse(e)}catch(e){}return e}],timeout:0,xsrfCookieName:"XSRF-TOKEN",xsrfHeaderName:"X-XSRF-TOKEN",maxContentLength:-1,validateStatus:function(e){return e>=200&&e<300}};u.headers={common:{Accept:"application/json, text/plain, */*"}},o.forEach(["delete","get","head"],function(e){u.headers[e]={}}),o.forEach(["post","put","patch"],function(e){u.headers[e]=o.merge(a)}),e.exports=u}).call(t,n(17))},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0}),t.LoggerInstance=void 0;var o=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),i=n(12),a=n(1),u=n(11),s="AGENT",c="",l="",f=function(){function e(){r(this,e)}return o(e,null,[{key:"setUsertype",value:function(e){s=e}},{key:"setUserId",value:function(e){c=e}},{key:"getUserId",value:function(){return c}},{key:"setApplication",value:function(e){l=e}},{key:"setLocalLogger",value:function(e){u.LoggerLocal.setEnabled(e)}},{key:"setLocalStorageTime",value:function(e){u.LoggerLocal.setStorageTimeMin(e)}},{key:"getApplication",value:function(){return l}},{key:"SetUseServerWithLocation",value:function(e){window[a.Constants._LOGGER_VAR_WINDOW]._USE_WINDOW_LOCATION=e}},{key:"addUserId",value:function(e){if(c){var t="[UserId:"+c+"]";e.unshift(t)}}},{key:"Group",value:function(e){console.group(e)}},{key:"GroupEnd",value:function(){console.groupEnd()}},{key:"CleanLocalLog",value:function(){u.LoggerLocal.Clean()}},{key:"Trace",value:function(){for(var e=arguments.length,t=Array(e),n=0;n<e;n++)t[n]=arguments[n];i.LoggerDispatcher.Dispatch(s,"Trace",["[UserId:"+c+"]"].concat(t))}},{key:"Debug",value:function(){for(var t=arguments.length,n=Array(t),r=0;r<t;r++)n[r]=arguments[r];e.addUserId(n),i.LoggerDispatcher.Dispatch(s,"Debug",["[UserId:"+c+"]"].concat(n))}},{key:"Warning",value:function(){for(var t=arguments.length,n=Array(t),r=0;r<t;r++)n[r]=arguments[r];e.addUserId(n),i.LoggerDispatcher.Dispatch(s,"Warn",["[UserId:"+c+"]"].concat(n))}},{key:"Warn",value:function(){for(var t=arguments.length,n=Array(t),r=0;r<t;r++)n[r]=arguments[r];e.Warning(n)}},{key:"Info",value:function(){for(var t=arguments.length,n=Array(t),r=0;r<t;r++)n[r]=arguments[r];e.addUserId(n),i.LoggerDispatcher.Dispatch(s,"Info",["[UserId:"+c+"]"].concat(n))}},{key:"Error",value:function(){for(var t=arguments.length,n=Array(t),r=0;r<t;r++)n[r]=arguments[r];e.addUserId(n),i.LoggerDispatcher.Dispatch(s,"Error",["[UserId:"+c+"]"].concat(n))}},{key:"JsWarning",value:function(){for(var t=arguments.length,n=Array(t),r=0;r<t;r++)n[r]=arguments[r];e.addUserId(n),i.LoggerDispatcher.Dispatch(s,"Warn",["[UserId:"+c+"]"].concat(n),!0)}},{key:"JsError",value:function(){for(var t=arguments.length,n=Array(t),r=0;r<t;r++)n[r]=arguments[r];e.addUserId(n),i.LoggerDispatcher.Dispatch(s,"Error",["[UserId:"+c+"]"].concat(n),!0)}},{key:"LevelConsole",get:function(){return window[a.Constants._LOGGER_VAR_WINDOW]._SEVERITY_CONSOLE}}]),e}();t.LoggerInstance=f},function(e,t,n){e.exports=n(14)},function(e,t,n){"use strict";e.exports=function(e,t){return function(){for(var n=new Array(arguments.length),r=0;r<n.length;r++)n[r]=arguments[r];return e.apply(t,n)}}},function(e,t,n){"use strict";var r=n(0),o=n(19),i=n(21),a=n(22),u=n(23),s=n(7);e.exports=function(e){return new Promise(function(t,c){var l=e.data,f=e.headers;r.isFormData(l)&&delete f["Content-Type"];var p=new XMLHttpRequest;if(e.auth){var g=e.auth.username||"",d=e.auth.password||"";f.Authorization="Basic "+btoa(g+":"+d)}if(p.open(e.method.toUpperCase(),i(e.url,e.params,e.paramsSerializer),!0),p.timeout=e.timeout,p.onreadystatechange=function(){if(p&&4===p.readyState&&(0!==p.status||p.responseURL&&0===p.responseURL.indexOf("file:"))){var n="getAllResponseHeaders"in p?a(p.getAllResponseHeaders()):null,r=e.responseType&&"text"!==e.responseType?p.response:p.responseText,i={data:r,status:p.status,statusText:p.statusText,headers:n,config:e,request:p};o(t,c,i),p=null}},p.onerror=function(){c(s("Network Error",e,null,p)),p=null},p.ontimeout=function(){c(s("timeout of "+e.timeout+"ms exceeded",e,"ECONNABORTED",p)),p=null},r.isStandardBrowserEnv()){var y=n(24),v=(e.withCredentials||u(e.url))&&e.xsrfCookieName?y.read(e.xsrfCookieName):void 0;v&&(f[e.xsrfHeaderName]=v)}if("setRequestHeader"in p&&r.forEach(f,function(e,t){void 0===l&&"content-type"===t.toLowerCase()?delete f[t]:p.setRequestHeader(t,e)}),e.withCredentials&&(p.withCredentials=!0),e.responseType)try{p.responseType=e.responseType}catch(t){if("json"!==e.responseType)throw t}"function"==typeof e.onDownloadProgress&&p.addEventListener("progress",e.onDownloadProgress),"function"==typeof e.onUploadProgress&&p.upload&&p.upload.addEventListener("progress",e.onUploadProgress),e.cancelToken&&e.cancelToken.promise.then(function(e){p&&(p.abort(),c(e),p=null)}),void 0===l&&(l=null),p.send(l)})}},function(e,t,n){"use strict";var r=n(20);e.exports=function(e,t,n,o,i){var a=new Error(e);return r(a,t,n,o,i)}},function(e,t,n){"use strict";e.exports=function(e){return!(!e||!e.__CANCEL__)}},function(e,t,n){"use strict";function r(e){this.message=e}r.prototype.toString=function(){return"Cancel"+(this.message?": "+this.message:"")},r.prototype.__CANCEL__=!0,e.exports=r},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0}),t.LoggerUtils=void 0;var o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},i=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),a=n(1),u=function(){function e(){r(this,e)}return i(e,null,[{key:"GetLogLevelBySeverity",value:function(e){var t=1;return e=e.toUpperCase(),a.Constants._LOG_LEVELS[e]&&(t=a.Constants._LOG_LEVELS[e].logLevel),t}},{key:"IsAllowedRemoteToLogBySeverity",value:function(t){return e.GetLogLevelBySeverity(t)>=e.GetCurrentRemoteSeverityLevelConfigured()}},{key:"GetCurrentRemoteSeverityLevelConfigured",value:function(){return e.GetLogLevelBySeverity(window[a.Constants._LOGGER_VAR_WINDOW]._SEVERITY)}},{key:"IsAllowedConsoleToLogBySeverity",value:function(t){return e.GetLogLevelBySeverity(t)>=e.GetCurrentConsoleSeverityLevelConfigured()}},{key:"GetCurrentConsoleSeverityLevelConfigured",value:function(){return e.GetLogLevelBySeverity(window[a.Constants._LOGGER_VAR_WINDOW]._SEVERITY_CONSOLE)}},{key:"ToStringMessage",value:function(){for(var t="",n=arguments.length,r=Array(n),o=0;o<n;o++)r[o]=arguments[o];return r.forEach(function(n){t+=e.ToStringObject(n)}),t}},{key:"ToStringObject",value:function(t){return e.IsObject(t)?"\n"+e.JsonToString(t):t}},{key:"IsObject",value:function(e){return e&&"object"===(void 0===e?"undefined":o(e))&&e.constructor===Object}},{key:"JsonToString",value:function(e){var t=[];return JSON.stringify(e,function(e,n){return n&&"object"==(void 0===n?"undefined":o(n))&&t.push(n),n},2)}}]),e}();t.LoggerUtils=u},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var o=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),i=window.localStorage,a="LOG-"+(new Date).getDate()+"-"+((new Date).getMonth()+1)+"-"+(new Date).getFullYear(),u=!1,s=0,c=null,l=function(){function e(){r(this,e)}return o(e,null,[{key:"getKey",value:function(){return a}},{key:"setEnabled",value:function(e){u=e}},{key:"setStorageTimeMin",value:function(e){s=e}},{key:"Add",value:function(t,n,r){if(u){var o=new Date,l=i.getItem(a),f=n+"-"+r+" "+o.getDate()+"-"+(o.getMonth()+1)+"-"+o.getFullYear()+"-"+o.getDate()+" "+o.toLocaleTimeString()+" - MSG: "+t;l?(c||(c=new Date(JSON.parse(i.getItem("GalateaLoggerDate")))),0!==s&&(o-c)/6e4>s?(e.Clean(),c=o,i.setItem("GalateaLoggerDate",JSON.stringify(o))):f=l+";"+f,i.setItem(a,""+f)):(c=o,i.setItem(a,f),i.setItem("GalateaLoggerDate",JSON.stringify(o)))}}},{key:"getRawLogs",value:function(){return i.getItem(a)}},{key:"getLogs",value:function(){return i.getItem(a).replaceAll(";","\n")}},{key:"Clean",value:function(){console.log("Cleaning local storage ",a),i.removeItem(a)}}]),e}();t.LoggerLocal=l},function(e,t,n){"use strict";function r(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0}),t.LoggerDispatcher=void 0;var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),a=n(13),u=n(1),s=n(10),c=n(32),l=n(3),f=n(11),p=(window.localStorage,function(){function e(){o(this,e)}return i(e,null,[{key:"Dispatch",value:function(t,n,o,i){f.LoggerLocal.Add(o,t,n),c.LoggerConfigurator.Init(function(){!i&&e.DefaultOutput.apply(e,[t,n].concat(r(o))),e.RemoteOutput.apply(e,[t,n].concat(r(o)))})}},{key:"RemoteOutput",value:function(e,t){if(window[u.Constants._LOGGER_VAR_WINDOW]&&window[u.Constants._LOGGER_VAR_WINDOW]._ENABLE_AJAX&&s.LoggerUtils.IsAllowedRemoteToLogBySeverity(t)){for(var n=arguments.length,r=Array(n>2?n-2:0),o=2;o<n;o++)r[o-2]=arguments[o];if("WARN"===t.toUpperCase()||"ERROR"===t.toUpperCase())a.LoggerRestClient.log(e,t,"["+e+"] "+r);else{var i=0===window[u.Constants._LOGGER_VAR_WINDOW]._FILTER_USER_POST.length,c=0===window[u.Constants._LOGGER_VAR_WINDOW]._FILTER_APP_POST.length;if(i&&c)a.LoggerRestClient.log.apply(a.LoggerRestClient,[e,t].concat(r));else{var f=!0,p=!0;i||(f=window[u.Constants._LOGGER_VAR_WINDOW]._FILTER_USER_POST.find(function(e){return e===l.LoggerInstance.getUserId()})),c||(p=window[u.Constants._LOGGER_VAR_WINDOW]._FILTER_APP_POST.find(function(e){return e===l.LoggerInstance.getApplication()})),f&&p&&a.LoggerRestClient.log(e,t,"["+e+"] "+r)}}}}},{key:"DefaultOutput",value:function(e,t){if(t=t.toUpperCase(),window[u.Constants._LOGGER_VAR_WINDOW]&&window[u.Constants._LOGGER_VAR_WINDOW]._ENABLE_DEFAULT&&s.LoggerUtils.IsAllowedConsoleToLogBySeverity(t)){var n,r=console.log;u.Constants._Log_CONSOLE[t]&&(r=u.Constants._Log_CONSOLE[t]);for(var o=(new Date).toLocaleTimeString(),i=arguments.length,a=Array(i>2?i-2:0),c=2;c<i;c++)a[c-2]=arguments[c];(n=r).call.apply(n,[null,"["+o+"]["+t+"]["+e+"]"].concat(a))}}}]),e}());t.LoggerDispatcher=p},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0}),t.LoggerRestClient=void 0;var o=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),i=n(4),a=function(e){return e&&e.__esModule?e:{default:e}}(i),u=n(1),s=n(10),c=0,l=!0,f=function(){function e(){r(this,e)}return o(e,null,[{key:"log",value:function(e,t){if(window[u.Constants._LOGGER_VAR_WINDOW]._ENABLE_AJAX)if(0===window[u.Constants._LOGGER_VAR_WINDOW]._NUMBER_ATTEMP_POST||c<window[u.Constants._LOGGER_VAR_WINDOW]._NUMBER_ATTEMP_POST)try{for(var n=new URL(window[u.Constants._LOGGER_VAR_WINDOW]._SERVER),r=new URL(window[u.Constants._LOGGER_VAR_WINDOW]._DOMAIN,n),o=arguments.length,i=Array(o>2?o-2:0),f=2;f<o;f++)i[f-2]=arguments[f];var p=s.LoggerUtils.ToStringMessage(i);a.default.post(r,{UserType:e,Message:p,Severity:t}).then(function(){c=0}).catch(function(e){c++,console.warn("It was not possible to send the message server:",r,e)})}catch(e){c++,console.error("it was not possible to send the log message because an error ocurred servidor:"+window[u.Constants._LOGGER_VAR_WINDOW]._SERVER+" error:"+e+" recommendation: you could check the logger configuration")}else l&&(l=!1,console.warn("number of attempts to overcome Api web is necessary to check the configuration file for logger.json"))}}]),e}();t.LoggerRestClient=f},function(e,t,n){"use strict";function r(e){var t=new a(e),n=i(a.prototype.request,t);return o.extend(n,a.prototype,t),o.extend(n,t),n}var o=n(0),i=n(5),a=n(16),u=n(2),s=r(u);s.Axios=a,s.create=function(e){return r(o.merge(u,e))},s.Cancel=n(9),s.CancelToken=n(30),s.isCancel=n(8),s.all=function(e){return Promise.all(e)},s.spread=n(31),e.exports=s,e.exports.default=s},function(e,t){/*!
	 * Determine if an object is a Buffer
	 *
	 * @author   Feross Aboukhadijeh <https://feross.org>
	 * @license  MIT
	 */
	e.exports=function(e){return null!=e&&null!=e.constructor&&"function"==typeof e.constructor.isBuffer&&e.constructor.isBuffer(e)}},function(e,t,n){"use strict";function r(e){this.defaults=e,this.interceptors={request:new a,response:new a}}var o=n(2),i=n(0),a=n(25),u=n(26);r.prototype.request=function(e){"string"==typeof e&&(e=i.merge({url:arguments[0]},arguments[1])),e=i.merge(o,{method:"get"},this.defaults,e),e.method=e.method.toLowerCase();var t=[u,void 0],n=Promise.resolve(e);for(this.interceptors.request.forEach(function(e){t.unshift(e.fulfilled,e.rejected)}),this.interceptors.response.forEach(function(e){t.push(e.fulfilled,e.rejected)});t.length;)n=n.then(t.shift(),t.shift());return n},i.forEach(["delete","get","head","options"],function(e){r.prototype[e]=function(t,n){return this.request(i.merge(n||{},{method:e,url:t}))}}),i.forEach(["post","put","patch"],function(e){r.prototype[e]=function(t,n,r){return this.request(i.merge(r||{},{method:e,url:t,data:n}))}}),e.exports=r},function(e,t){function n(){throw new Error("setTimeout has not been defined")}function r(){throw new Error("clearTimeout has not been defined")}function o(e){if(l===setTimeout)return setTimeout(e,0);if((l===n||!l)&&setTimeout)return l=setTimeout,setTimeout(e,0);try{return l(e,0)}catch(t){try{return l.call(null,e,0)}catch(t){return l.call(this,e,0)}}}function i(e){if(f===clearTimeout)return clearTimeout(e);if((f===r||!f)&&clearTimeout)return f=clearTimeout,clearTimeout(e);try{return f(e)}catch(t){try{return f.call(null,e)}catch(t){return f.call(this,e)}}}function a(){y&&g&&(y=!1,g.length?d=g.concat(d):v=-1,d.length&&u())}function u(){if(!y){var e=o(a);y=!0;for(var t=d.length;t;){for(g=d,d=[];++v<t;)g&&g[v].run();v=-1,t=d.length}g=null,y=!1,i(e)}}function s(e,t){this.fun=e,this.array=t}function c(){}var l,f,p=e.exports={};!function(){try{l="function"==typeof setTimeout?setTimeout:n}catch(e){l=n}try{f="function"==typeof clearTimeout?clearTimeout:r}catch(e){f=r}}();var g,d=[],y=!1,v=-1;p.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];d.push(new s(e,t)),1!==d.length||y||o(u)},s.prototype.run=function(){this.fun.apply(null,this.array)},p.title="browser",p.browser=!0,p.env={},p.argv=[],p.version="",p.versions={},p.on=c,p.addListener=c,p.once=c,p.off=c,p.removeListener=c,p.removeAllListeners=c,p.emit=c,p.prependListener=c,p.prependOnceListener=c,p.listeners=function(e){return[]},p.binding=function(e){throw new Error("process.binding is not supported")},p.cwd=function(){return"/"},p.chdir=function(e){throw new Error("process.chdir is not supported")},p.umask=function(){return 0}},function(e,t,n){"use strict";var r=n(0);e.exports=function(e,t){r.forEach(e,function(n,r){r!==t&&r.toUpperCase()===t.toUpperCase()&&(e[t]=n,delete e[r])})}},function(e,t,n){"use strict";var r=n(7);e.exports=function(e,t,n){var o=n.config.validateStatus;n.status&&o&&!o(n.status)?t(r("Request failed with status code "+n.status,n.config,null,n.request,n)):e(n)}},function(e,t,n){"use strict";e.exports=function(e,t,n,r,o){return e.config=t,n&&(e.code=n),e.request=r,e.response=o,e}},function(e,t,n){"use strict";function r(e){return encodeURIComponent(e).replace(/%40/gi,"@").replace(/%3A/gi,":").replace(/%24/g,"$").replace(/%2C/gi,",").replace(/%20/g,"+").replace(/%5B/gi,"[").replace(/%5D/gi,"]")}var o=n(0);e.exports=function(e,t,n){if(!t)return e;var i;if(n)i=n(t);else if(o.isURLSearchParams(t))i=t.toString();else{var a=[];o.forEach(t,function(e,t){null!==e&&void 0!==e&&(o.isArray(e)?t+="[]":e=[e],o.forEach(e,function(e){o.isDate(e)?e=e.toISOString():o.isObject(e)&&(e=JSON.stringify(e)),a.push(r(t)+"="+r(e))}))}),i=a.join("&")}return i&&(e+=(-1===e.indexOf("?")?"?":"&")+i),e}},function(e,t,n){"use strict";var r=n(0),o=["age","authorization","content-length","content-type","etag","expires","from","host","if-modified-since","if-unmodified-since","last-modified","location","max-forwards","proxy-authorization","referer","retry-after","user-agent"];e.exports=function(e){var t,n,i,a={};return e?(r.forEach(e.split("\n"),function(e){if(i=e.indexOf(":"),t=r.trim(e.substr(0,i)).toLowerCase(),n=r.trim(e.substr(i+1)),t){if(a[t]&&o.indexOf(t)>=0)return;a[t]="set-cookie"===t?(a[t]?a[t]:[]).concat([n]):a[t]?a[t]+", "+n:n}}),a):a}},function(e,t,n){"use strict";var r=n(0);e.exports=r.isStandardBrowserEnv()?function(){function e(e){var t=e;return n&&(o.setAttribute("href",t),t=o.href),o.setAttribute("href",t),{href:o.href,protocol:o.protocol?o.protocol.replace(/:$/,""):"",host:o.host,search:o.search?o.search.replace(/^\?/,""):"",hash:o.hash?o.hash.replace(/^#/,""):"",hostname:o.hostname,port:o.port,pathname:"/"===o.pathname.charAt(0)?o.pathname:"/"+o.pathname}}var t,n=/(msie|trident)/i.test(navigator.userAgent),o=document.createElement("a");return t=e(window.location.href),function(n){var o=r.isString(n)?e(n):n;return o.protocol===t.protocol&&o.host===t.host}}():function(){return function(){return!0}}()},function(e,t,n){"use strict";var r=n(0);e.exports=r.isStandardBrowserEnv()?function(){return{write:function(e,t,n,o,i,a){var u=[];u.push(e+"="+encodeURIComponent(t)),r.isNumber(n)&&u.push("expires="+new Date(n).toGMTString()),r.isString(o)&&u.push("path="+o),r.isString(i)&&u.push("domain="+i),!0===a&&u.push("secure"),document.cookie=u.join("; ")},read:function(e){var t=document.cookie.match(new RegExp("(^|;\\s*)("+e+")=([^;]*)"));return t?decodeURIComponent(t[3]):null},remove:function(e){this.write(e,"",Date.now()-864e5)}}}():function(){return{write:function(){},read:function(){return null},remove:function(){}}}()},function(e,t,n){"use strict";function r(){this.handlers=[]}var o=n(0);r.prototype.use=function(e,t){return this.handlers.push({fulfilled:e,rejected:t}),this.handlers.length-1},r.prototype.eject=function(e){this.handlers[e]&&(this.handlers[e]=null)},r.prototype.forEach=function(e){o.forEach(this.handlers,function(t){null!==t&&e(t)})},e.exports=r},function(e,t,n){"use strict";function r(e){e.cancelToken&&e.cancelToken.throwIfRequested()}var o=n(0),i=n(27),a=n(8),u=n(2),s=n(28),c=n(29);e.exports=function(e){return r(e),e.baseURL&&!s(e.url)&&(e.url=c(e.baseURL,e.url)),e.headers=e.headers||{},e.data=i(e.data,e.headers,e.transformRequest),e.headers=o.merge(e.headers.common||{},e.headers[e.method]||{},e.headers||{}),o.forEach(["delete","get","head","post","put","patch","common"],function(t){delete e.headers[t]}),(e.adapter||u.adapter)(e).then(function(t){return r(e),t.data=i(t.data,t.headers,e.transformResponse),t},function(t){return a(t)||(r(e),t&&t.response&&(t.response.data=i(t.response.data,t.response.headers,e.transformResponse))),Promise.reject(t)})}},function(e,t,n){"use strict";var r=n(0);e.exports=function(e,t,n){return r.forEach(n,function(n){e=n(e,t)}),e}},function(e,t,n){"use strict";e.exports=function(e){return/^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(e)}},function(e,t,n){"use strict";e.exports=function(e,t){return t?e.replace(/\/+$/,"")+"/"+t.replace(/^\/+/,""):e}},function(e,t,n){"use strict";function r(e){if("function"!=typeof e)throw new TypeError("executor must be a function.");var t;this.promise=new Promise(function(e){t=e});var n=this;e(function(e){n.reason||(n.reason=new o(e),t(n.reason))})}var o=n(9);r.prototype.throwIfRequested=function(){if(this.reason)throw this.reason},r.source=function(){var e;return{token:new r(function(t){e=t}),cancel:e}},e.exports=r},function(e,t,n){"use strict";e.exports=function(e){return function(t){return e.apply(null,t)}}},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t,n){void 0===e[t]&&(console.info("file logger.json does not contain field [%s] set value default [%s]",t,n),e[t]=n)}Object.defineProperty(t,"__esModule",{value:!0}),t.LoggerConfigurator=void 0;var i=function(){function e(e,t){var n=[],r=!0,o=!1,i=void 0;try{for(var a,u=e[Symbol.iterator]();!(r=(a=u.next()).done)&&(n.push(a.value),!t||n.length!==t);r=!0);}catch(e){o=!0,i=e}finally{try{!r&&u.return&&u.return()}finally{if(o)throw i}}return n}return function(t,n){if(Array.isArray(t))return t;if(Symbol.iterator in Object(t))return e(t,n);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}(),a=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),u=n(1),s=n(4),c=function(e){return e&&e.__esModule?e:{default:e}}(s),l=!0,f=function(){function e(){r(this,e)}return a(e,null,[{key:"Init",value:function(t){l&&e.IsConfigurationNotAssigned()?(l=!1,e.GetByExecutionEnvironment(t)):t()}},{key:"Setup",value:function(t,n){if(console.info("Setup ",t),t){window[u.Constants._LOGGER_VAR_WINDOW]={};var r=!0,a=!1,s=void 0;try{for(var c,l=Object.entries(u.Constants._CONFIGURATIONS)[Symbol.iterator]();!(r=(c=l.next()).done);r=!0){var f=i(c.value,2),p=f[0],g=f[1];o(t,p,g)}}catch(e){a=!0,s=e}finally{try{!r&&l.return&&l.return()}finally{if(a)throw s}}Object.keys(t).forEach(function(e){return window[u.Constants._LOGGER_VAR_WINDOW][e]=t[e]}),window[u.Constants._LOGGER_VAR_WINDOW]._USE_WINDOW_ORIGIN&&e.SetConfigurationServer()}else window[u.Constants._LOGGER_VAR_WINDOW]=u.Constants._CONFIGURATIONS,console.info("Logger will use default configuration ... ",u.Constants._CONFIGURATIONS);n()}},{key:"GetByExecutionEnvironment",value:function(t){e.IsBrowser()?e.GetRemote(t):e.GetLocal(t)}},{key:"IsBrowser",value:function(){return!!window}},{key:"GetLocal",value:function(t){e.Setup(null,t)}},{key:"GetRemote",value:function(t){var n=""+window.location.origin+window.location.pathname,r=n.split("/");console.log("Remove Last element ",r.pop()),n=r.join("/")+"/",n+=u.Constants._LOGGER_CONFIGURATION_FILE_REMOTE,c.default.get(n,{responseType:"json"}).then(function(n){e.Setup(n.data,t)}).catch(function(n){console.error("It was not possible to get remote file configuration",n),e.Setup(null,t)})}},{key:"SetConfigurationServer",value:function(){if(window[u.Constants._LOGGER_VAR_WINDOW]._USE_WINDOW_ORIGIN){var e=window.location.hostname;if("127.0.0.1"!==e&&"localhost"!==e){var t=window.location.origin;console.debug("SetConfigurationServer withLocation",t),window[u.Constants._LOGGER_VAR_WINDOW]._SERVER=t}}}},{key:"ExistExternalConfiguration",value:function(e){return!!e}},{key:"IsConfigurationNotAssigned",value:function(){return!u.Constants._LOGGER_CONFIGURATION_ASSIGNED}}]),e}();t.LoggerConfigurator=f}])})}])}); 

/***/ },
/* 2021 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {// @flow
	'use strict';
	
	var key = '__global_unique_id__';
	
	module.exports = function() {
	  return global[key] = (global[key] || 0) + 1;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 2022 */
/***/ function(module, exports) {

	'use strict';
	
	var test = {
		__proto__: null,
		foo: {}
	};
	
	var $Object = Object;
	
	/** @type {import('.')} */
	module.exports = function hasProto() {
		// @ts-expect-error: TS errors on an inherited property for some reason
		return { __proto__: test }.foo === test.foo
			&& !(test instanceof $Object);
	};


/***/ },
/* 2023 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var origSymbol = typeof Symbol !== 'undefined' && Symbol;
	var hasSymbolSham = __webpack_require__(718);
	
	module.exports = function hasNativeSymbols() {
		if (typeof origSymbol !== 'function') { return false; }
		if (typeof Symbol !== 'function') { return false; }
		if (typeof origSymbol('foo') !== 'symbol') { return false; }
		if (typeof Symbol('bar') !== 'symbol') { return false; }
	
		return hasSymbolSham();
	};


/***/ },
/* 2024 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var call = Function.prototype.call;
	var $hasOwn = Object.prototype.hasOwnProperty;
	var bind = __webpack_require__(420);
	
	/** @type {import('.')} */
	module.exports = bind.call(call, $hasOwn);


/***/ },
/* 2025 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var reactIs = __webpack_require__(935);
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	  childContextTypes: true,
	  contextType: true,
	  contextTypes: true,
	  defaultProps: true,
	  displayName: true,
	  getDefaultProps: true,
	  getDerivedStateFromError: true,
	  getDerivedStateFromProps: true,
	  mixins: true,
	  propTypes: true,
	  type: true
	};
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	var FORWARD_REF_STATICS = {
	  '$$typeof': true,
	  render: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true
	};
	var MEMO_STATICS = {
	  '$$typeof': true,
	  compare: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true,
	  type: true
	};
	var TYPE_STATICS = {};
	TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
	TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
	
	function getStatics(component) {
	  // React v16.11 and below
	  if (reactIs.isMemo(component)) {
	    return MEMO_STATICS;
	  } // React v16.12 and above
	
	
	  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
	}
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = Object.prototype;
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	  if (typeof sourceComponent !== 'string') {
	    // don't hoist over string (html) components
	    if (objectPrototype) {
	      var inheritedComponent = getPrototypeOf(sourceComponent);
	
	      if (inheritedComponent && inheritedComponent !== objectPrototype) {
	        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	      }
	    }
	
	    var keys = getOwnPropertyNames(sourceComponent);
	
	    if (getOwnPropertySymbols) {
	      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	    }
	
	    var targetStatics = getStatics(targetComponent);
	    var sourceStatics = getStatics(sourceComponent);
	
	    for (var i = 0; i < keys.length; ++i) {
	      var key = keys[i];
	
	      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
	        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	
	        try {
	          // Avoid failures from read-only properties
	          defineProperty(targetComponent, key, descriptor);
	        } catch (e) {}
	      }
	    }
	  }
	
	  return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ },
/* 2026 */
/***/ function(module, exports) {

	'use strict';
	/**
	 * Copyright (C) 2017-present by Andrea Giammarchi - @WebReflection
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in
	 * all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	 * THE SOFTWARE.
	 */
	
	var replace = ''.replace;
	
	var ca = /[&<>'"]/g;
	var es = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34);/g;
	
	var esca = {
	  '&': '&amp;',
	  '<': '&lt;',
	  '>': '&gt;',
	  "'": '&#39;',
	  '"': '&quot;'
	};
	var unes = {
	  '&amp;': '&',
	  '&#38;': '&',
	  '&lt;': '<',
	  '&#60;': '<',
	  '&gt;': '>',
	  '&#62;': '>',
	  '&apos;': "'",
	  '&#39;': "'",
	  '&quot;': '"',
	  '&#34;': '"'
	};
	
	function escape(es) {
	  return replace.call(es, ca, pe);
	}
	exports.escape = escape;
	
	function unescape(un) {
	  return replace.call(un, es, cape);
	}
	exports.unescape = unescape;
	
	function pe(m) {
	  return esca[m];
	}
	
	function cape(m) {
	  return unes[m];
	}


/***/ },
/* 2027 */
/***/ function(module, exports, __webpack_require__) {

	var e,t=(e=__webpack_require__(2619))&&"object"==typeof e&&"default"in e?e.default:e,n=/\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;function r(e){var r={type:"tag",name:"",voidElement:!1,attrs:{},children:[]},i=e.match(/<\/?([^\s]+?)[/\s>]/);if(i&&(r.name=i[1],(t[i[1]]||"/"===e.charAt(e.length-2))&&(r.voidElement=!0),r.name.startsWith("!--"))){var s=e.indexOf("--\x3e");return{type:"comment",comment:-1!==s?e.slice(4,s):""}}for(var c=new RegExp(n),a=null;null!==(a=c.exec(e));)if(a[0].trim())if(a[1]){var o=a[1].trim(),u=[o,""];o.indexOf("=")>-1&&(u=o.split("=")),r.attrs[u[0]]=u[1],c.lastIndex--}else a[2]&&(r.attrs[a[2]]=a[3].trim().substring(1,a[3].length-1));return r}var i=/<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g,s=/^\s*$/,c=Object.create(null);function a(e,t){switch(t.type){case"text":return e+t.content;case"tag":return e+="<"+t.name+(t.attrs?function(e){var t=[];for(var n in e)t.push(n+'="'+e[n]+'"');return t.length?" "+t.join(" "):""}(t.attrs):"")+(t.voidElement?"/>":">"),t.voidElement?e:e+t.children.reduce(a,"")+"</"+t.name+">";case"comment":return e+"\x3c!--"+t.comment+"--\x3e"}}module.exports={parse:function(e,t){t||(t={}),t.components||(t.components=c);var n,a=[],o=[],u=-1,l=!1;if(0!==e.indexOf("<")){var m=e.indexOf("<");a.push({type:"text",content:-1===m?e:e.substring(0,m)})}return e.replace(i,function(i,c){if(l){if(i!=="</"+n.name+">")return;l=!1}var m,d="/"!==i.charAt(1),f=i.startsWith("\x3c!--"),h=c+i.length,p=e.charAt(h);if(f){var v=r(i);return u<0?(a.push(v),a):((m=o[u]).children.push(v),a)}if(d&&(u++,"tag"===(n=r(i)).type&&t.components[n.name]&&(n.type="component",l=!0),n.voidElement||l||!p||"<"===p||n.children.push({type:"text",content:e.slice(h,e.indexOf("<",h))}),0===u&&a.push(n),(m=o[u-1])&&m.children.push(n),o[u]=n),(!d||n.voidElement)&&(u>-1&&(n.voidElement||n.name===i.slice(2,-1))&&(u--,n=-1===u?a:o[u]),!l&&"<"!==p&&p)){m=-1===u?a:o[u].children;var x=e.indexOf("<",h),g=e.slice(h,-1===x?void 0:x);s.test(g)&&(g=" "),(x>-1&&u+m.length>=0||" "!==g)&&m.push({type:"text",content:g})}}),a},stringify:function(e){return e.reduce(function(e,t){return e+a("",t)},"")}};
	//# sourceMappingURL=html-parse-stringify.js.map


/***/ },
/* 2028 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = CollectingHandler;
	
	function CollectingHandler(cbs) {
	    this._cbs = cbs || {};
	    this.events = [];
	}
	
	var EVENTS = __webpack_require__(177).EVENTS;
	Object.keys(EVENTS).forEach(function(name) {
	    if (EVENTS[name] === 0) {
	        name = "on" + name;
	        CollectingHandler.prototype[name] = function() {
	            this.events.push([name]);
	            if (this._cbs[name]) this._cbs[name]();
	        };
	    } else if (EVENTS[name] === 1) {
	        name = "on" + name;
	        CollectingHandler.prototype[name] = function(a) {
	            this.events.push([name, a]);
	            if (this._cbs[name]) this._cbs[name](a);
	        };
	    } else if (EVENTS[name] === 2) {
	        name = "on" + name;
	        CollectingHandler.prototype[name] = function(a, b) {
	            this.events.push([name, a, b]);
	            if (this._cbs[name]) this._cbs[name](a, b);
	        };
	    } else {
	        throw Error("wrong number of arguments");
	    }
	});
	
	CollectingHandler.prototype.onreset = function() {
	    this.events = [];
	    if (this._cbs.onreset) this._cbs.onreset();
	};
	
	CollectingHandler.prototype.restart = function() {
	    if (this._cbs.onreset) this._cbs.onreset();
	
	    for (var i = 0, len = this.events.length; i < len; i++) {
	        if (this._cbs[this.events[i][0]]) {
	            var num = this.events[i].length;
	
	            if (num === 1) {
	                this._cbs[this.events[i][0]]();
	            } else if (num === 2) {
	                this._cbs[this.events[i][0]](this.events[i][1]);
	            } else {
	                this._cbs[this.events[i][0]](
	                    this.events[i][1],
	                    this.events[i][2]
	                );
	            }
	        }
	    }
	};


/***/ },
/* 2029 */
/***/ function(module, exports, __webpack_require__) {

	var DomHandler = __webpack_require__(683);
	var DomUtils = __webpack_require__(685);
	
	//TODO: make this a streamable handler
	function FeedHandler(callback, options) {
	    this.init(callback, options);
	}
	
	__webpack_require__(278)(FeedHandler, DomHandler);
	
	FeedHandler.prototype.init = DomHandler;
	
	function getElements(what, where) {
	    return DomUtils.getElementsByTagName(what, where, true);
	}
	function getOneElement(what, where) {
	    return DomUtils.getElementsByTagName(what, where, true, 1)[0];
	}
	function fetch(what, where, recurse) {
	    return DomUtils.getText(
	        DomUtils.getElementsByTagName(what, where, recurse, 1)
	    ).trim();
	}
	
	function addConditionally(obj, prop, what, where, recurse) {
	    var tmp = fetch(what, where, recurse);
	    if (tmp) obj[prop] = tmp;
	}
	
	var isValidFeed = function(value) {
	    return value === "rss" || value === "feed" || value === "rdf:RDF";
	};
	
	FeedHandler.prototype.onend = function() {
	    var feed = {},
	        feedRoot = getOneElement(isValidFeed, this.dom),
	        tmp,
	        childs;
	
	    if (feedRoot) {
	        if (feedRoot.name === "feed") {
	            childs = feedRoot.children;
	
	            feed.type = "atom";
	            addConditionally(feed, "id", "id", childs);
	            addConditionally(feed, "title", "title", childs);
	            if (
	                (tmp = getOneElement("link", childs)) &&
	                (tmp = tmp.attribs) &&
	                (tmp = tmp.href)
	            )
	                feed.link = tmp;
	            addConditionally(feed, "description", "subtitle", childs);
	            if ((tmp = fetch("updated", childs))) feed.updated = new Date(tmp);
	            addConditionally(feed, "author", "email", childs, true);
	
	            feed.items = getElements("entry", childs).map(function(item) {
	                var entry = {},
	                    tmp;
	
	                item = item.children;
	
	                addConditionally(entry, "id", "id", item);
	                addConditionally(entry, "title", "title", item);
	                if (
	                    (tmp = getOneElement("link", item)) &&
	                    (tmp = tmp.attribs) &&
	                    (tmp = tmp.href)
	                )
	                    entry.link = tmp;
	                if ((tmp = fetch("summary", item) || fetch("content", item)))
	                    entry.description = tmp;
	                if ((tmp = fetch("updated", item)))
	                    entry.pubDate = new Date(tmp);
	                return entry;
	            });
	        } else {
	            childs = getOneElement("channel", feedRoot.children).children;
	
	            feed.type = feedRoot.name.substr(0, 3);
	            feed.id = "";
	            addConditionally(feed, "title", "title", childs);
	            addConditionally(feed, "link", "link", childs);
	            addConditionally(feed, "description", "description", childs);
	            if ((tmp = fetch("lastBuildDate", childs)))
	                feed.updated = new Date(tmp);
	            addConditionally(feed, "author", "managingEditor", childs, true);
	
	            feed.items = getElements("item", feedRoot.children).map(function(
	                item
	            ) {
	                var entry = {},
	                    tmp;
	
	                item = item.children;
	
	                addConditionally(entry, "id", "guid", item);
	                addConditionally(entry, "title", "title", item);
	                addConditionally(entry, "link", "link", item);
	                addConditionally(entry, "description", "description", item);
	                if ((tmp = fetch("pubDate", item)))
	                    entry.pubDate = new Date(tmp);
	                return entry;
	            });
	        }
	    }
	    this.dom = feed;
	    DomHandler.prototype._handleCallback.call(
	        this,
	        feedRoot ? null : Error("couldn't find root of feed")
	    );
	};
	
	module.exports = FeedHandler;


/***/ },
/* 2030 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = ProxyHandler;
	
	function ProxyHandler(cbs) {
	    this._cbs = cbs || {};
	}
	
	var EVENTS = __webpack_require__(177).EVENTS;
	Object.keys(EVENTS).forEach(function(name) {
	    if (EVENTS[name] === 0) {
	        name = "on" + name;
	        ProxyHandler.prototype[name] = function() {
	            if (this._cbs[name]) this._cbs[name]();
	        };
	    } else if (EVENTS[name] === 1) {
	        name = "on" + name;
	        ProxyHandler.prototype[name] = function(a) {
	            if (this._cbs[name]) this._cbs[name](a);
	        };
	    } else if (EVENTS[name] === 2) {
	        name = "on" + name;
	        ProxyHandler.prototype[name] = function(a, b) {
	            if (this._cbs[name]) this._cbs[name](a, b);
	        };
	    } else {
	        throw Error("wrong number of arguments");
	    }
	});


/***/ },
/* 2031 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = Stream;
	
	var Parser = __webpack_require__(721);
	
	function Stream(options) {
	    Parser.call(this, new Cbs(this), options);
	}
	
	__webpack_require__(278)(Stream, Parser);
	
	Stream.prototype.readable = true;
	
	function Cbs(scope) {
	    this.scope = scope;
	}
	
	var EVENTS = __webpack_require__(177).EVENTS;
	
	Object.keys(EVENTS).forEach(function(name) {
	    if (EVENTS[name] === 0) {
	        Cbs.prototype["on" + name] = function() {
	            this.scope.emit(name);
	        };
	    } else if (EVENTS[name] === 1) {
	        Cbs.prototype["on" + name] = function(a) {
	            this.scope.emit(name, a);
	        };
	    } else if (EVENTS[name] === 2) {
	        Cbs.prototype["on" + name] = function(a, b) {
	            this.scope.emit(name, a, b);
	        };
	    } else {
	        throw Error("wrong number of arguments!");
	    }
	});


/***/ },
/* 2032 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = __webpack_require__(129);
	var _objectSpread = __webpack_require__(1051);
	var _classCallCheck = __webpack_require__(484);
	var _createClass = __webpack_require__(485);
	var _possibleConstructorReturn = __webpack_require__(1052);
	var _getPrototypeOf = __webpack_require__(1047);
	var _assertThisInitialized = __webpack_require__(22);
	var _inherits = __webpack_require__(1048);
	
	function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }
	
	var _typeof__default = /*#__PURE__*/_interopDefaultLegacy(_typeof);
	var _objectSpread__default = /*#__PURE__*/_interopDefaultLegacy(_objectSpread);
	var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);
	var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);
	var _possibleConstructorReturn__default = /*#__PURE__*/_interopDefaultLegacy(_possibleConstructorReturn);
	var _getPrototypeOf__default = /*#__PURE__*/_interopDefaultLegacy(_getPrototypeOf);
	var _assertThisInitialized__default = /*#__PURE__*/_interopDefaultLegacy(_assertThisInitialized);
	var _inherits__default = /*#__PURE__*/_interopDefaultLegacy(_inherits);
	
	var consoleLogger = {
	  type: 'logger',
	  log: function log(args) {
	    this.output('log', args);
	  },
	  warn: function warn(args) {
	    this.output('warn', args);
	  },
	  error: function error(args) {
	    this.output('error', args);
	  },
	  output: function output(type, args) {
	    if (console && console[type]) console[type].apply(console, args);
	  }
	};
	
	var Logger = function () {
	  function Logger(concreteLogger) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    _classCallCheck__default['default'](this, Logger);
	
	    this.init(concreteLogger, options);
	  }
	
	  _createClass__default['default'](Logger, [{
	    key: "init",
	    value: function init(concreteLogger) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      this.prefix = options.prefix || 'i18next:';
	      this.logger = concreteLogger || consoleLogger;
	      this.options = options;
	      this.debug = options.debug;
	    }
	  }, {
	    key: "setDebug",
	    value: function setDebug(bool) {
	      this.debug = bool;
	    }
	  }, {
	    key: "log",
	    value: function log() {
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return this.forward(args, 'log', '', true);
	    }
	  }, {
	    key: "warn",
	    value: function warn() {
	      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return this.forward(args, 'warn', '', true);
	    }
	  }, {
	    key: "error",
	    value: function error() {
	      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	        args[_key3] = arguments[_key3];
	      }
	
	      return this.forward(args, 'error', '');
	    }
	  }, {
	    key: "deprecate",
	    value: function deprecate() {
	      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	        args[_key4] = arguments[_key4];
	      }
	
	      return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
	    }
	  }, {
	    key: "forward",
	    value: function forward(args, lvl, prefix, debugOnly) {
	      if (debugOnly && !this.debug) return null;
	      if (typeof args[0] === 'string') args[0] = "".concat(prefix).concat(this.prefix, " ").concat(args[0]);
	      return this.logger[lvl](args);
	    }
	  }, {
	    key: "create",
	    value: function create(moduleName) {
	      return new Logger(this.logger, _objectSpread__default['default']({}, {
	        prefix: "".concat(this.prefix, ":").concat(moduleName, ":")
	      }, this.options));
	    }
	  }]);
	
	  return Logger;
	}();
	
	var baseLogger = new Logger();
	
	var EventEmitter = function () {
	  function EventEmitter() {
	    _classCallCheck__default['default'](this, EventEmitter);
	
	    this.observers = {};
	  }
	
	  _createClass__default['default'](EventEmitter, [{
	    key: "on",
	    value: function on(events, listener) {
	      var _this = this;
	
	      events.split(' ').forEach(function (event) {
	        _this.observers[event] = _this.observers[event] || [];
	
	        _this.observers[event].push(listener);
	      });
	      return this;
	    }
	  }, {
	    key: "off",
	    value: function off(event, listener) {
	      if (!this.observers[event]) return;
	
	      if (!listener) {
	        delete this.observers[event];
	        return;
	      }
	
	      this.observers[event] = this.observers[event].filter(function (l) {
	        return l !== listener;
	      });
	    }
	  }, {
	    key: "emit",
	    value: function emit(event) {
	      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      if (this.observers[event]) {
	        var cloned = [].concat(this.observers[event]);
	        cloned.forEach(function (observer) {
	          observer.apply(void 0, args);
	        });
	      }
	
	      if (this.observers['*']) {
	        var _cloned = [].concat(this.observers['*']);
	
	        _cloned.forEach(function (observer) {
	          observer.apply(observer, [event].concat(args));
	        });
	      }
	    }
	  }]);
	
	  return EventEmitter;
	}();
	
	function defer() {
	  var res;
	  var rej;
	  var promise = new Promise(function (resolve, reject) {
	    res = resolve;
	    rej = reject;
	  });
	  promise.resolve = res;
	  promise.reject = rej;
	  return promise;
	}
	function makeString(object) {
	  if (object == null) return '';
	  return '' + object;
	}
	function copy(a, s, t) {
	  a.forEach(function (m) {
	    if (s[m]) t[m] = s[m];
	  });
	}
	
	function getLastOfPath(object, path, Empty) {
	  function cleanKey(key) {
	    return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
	  }
	
	  function canNotTraverseDeeper() {
	    return !object || typeof object === 'string';
	  }
	
	  var stack = typeof path !== 'string' ? [].concat(path) : path.split('.');
	
	  while (stack.length > 1) {
	    if (canNotTraverseDeeper()) return {};
	    var key = cleanKey(stack.shift());
	    if (!object[key] && Empty) object[key] = new Empty();
	
	    if (Object.prototype.hasOwnProperty.call(object, key)) {
	      object = object[key];
	    } else {
	      object = {};
	    }
	  }
	
	  if (canNotTraverseDeeper()) return {};
	  return {
	    obj: object,
	    k: cleanKey(stack.shift())
	  };
	}
	
	function setPath(object, path, newValue) {
	  var _getLastOfPath = getLastOfPath(object, path, Object),
	      obj = _getLastOfPath.obj,
	      k = _getLastOfPath.k;
	
	  obj[k] = newValue;
	}
	function pushPath(object, path, newValue, concat) {
	  var _getLastOfPath2 = getLastOfPath(object, path, Object),
	      obj = _getLastOfPath2.obj,
	      k = _getLastOfPath2.k;
	
	  obj[k] = obj[k] || [];
	  if (concat) obj[k] = obj[k].concat(newValue);
	  if (!concat) obj[k].push(newValue);
	}
	function getPath(object, path) {
	  var _getLastOfPath3 = getLastOfPath(object, path),
	      obj = _getLastOfPath3.obj,
	      k = _getLastOfPath3.k;
	
	  if (!obj) return undefined;
	  return obj[k];
	}
	function getPathWithDefaults(data, defaultData, key) {
	  var value = getPath(data, key);
	
	  if (value !== undefined) {
	    return value;
	  }
	
	  return getPath(defaultData, key);
	}
	function deepExtend(target, source, overwrite) {
	  for (var prop in source) {
	    if (prop !== '__proto__' && prop !== 'constructor') {
	      if (prop in target) {
	        if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
	          if (overwrite) target[prop] = source[prop];
	        } else {
	          deepExtend(target[prop], source[prop], overwrite);
	        }
	      } else {
	        target[prop] = source[prop];
	      }
	    }
	  }
	
	  return target;
	}
	function regexEscape(str) {
	  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
	}
	var _entityMap = {
	  '&': '&amp;',
	  '<': '&lt;',
	  '>': '&gt;',
	  '"': '&quot;',
	  "'": '&#39;',
	  '/': '&#x2F;'
	};
	function escape(data) {
	  if (typeof data === 'string') {
	    return data.replace(/[&<>"'\/]/g, function (s) {
	      return _entityMap[s];
	    });
	  }
	
	  return data;
	}
	var isIE10 = typeof window !== 'undefined' && window.navigator && window.navigator.userAgent && window.navigator.userAgent.indexOf('MSIE') > -1;
	
	var ResourceStore = function (_EventEmitter) {
	  _inherits__default['default'](ResourceStore, _EventEmitter);
	
	  function ResourceStore(data) {
	    var _this;
	
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
	      ns: ['translation'],
	      defaultNS: 'translation'
	    };
	
	    _classCallCheck__default['default'](this, ResourceStore);
	
	    _this = _possibleConstructorReturn__default['default'](this, _getPrototypeOf__default['default'](ResourceStore).call(this));
	
	    if (isIE10) {
	      EventEmitter.call(_assertThisInitialized__default['default'](_this));
	    }
	
	    _this.data = data || {};
	    _this.options = options;
	
	    if (_this.options.keySeparator === undefined) {
	      _this.options.keySeparator = '.';
	    }
	
	    return _this;
	  }
	
	  _createClass__default['default'](ResourceStore, [{
	    key: "addNamespaces",
	    value: function addNamespaces(ns) {
	      if (this.options.ns.indexOf(ns) < 0) {
	        this.options.ns.push(ns);
	      }
	    }
	  }, {
	    key: "removeNamespaces",
	    value: function removeNamespaces(ns) {
	      var index = this.options.ns.indexOf(ns);
	
	      if (index > -1) {
	        this.options.ns.splice(index, 1);
	      }
	    }
	  }, {
	    key: "getResource",
	    value: function getResource(lng, ns, key) {
	      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
	      var path = [lng, ns];
	      if (key && typeof key !== 'string') path = path.concat(key);
	      if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);
	
	      if (lng.indexOf('.') > -1) {
	        path = lng.split('.');
	      }
	
	      return getPath(this.data, path);
	    }
	  }, {
	    key: "addResource",
	    value: function addResource(lng, ns, key, value) {
	      var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
	        silent: false
	      };
	      var keySeparator = this.options.keySeparator;
	      if (keySeparator === undefined) keySeparator = '.';
	      var path = [lng, ns];
	      if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
	
	      if (lng.indexOf('.') > -1) {
	        path = lng.split('.');
	        value = ns;
	        ns = path[1];
	      }
	
	      this.addNamespaces(ns);
	      setPath(this.data, path, value);
	      if (!options.silent) this.emit('added', lng, ns, key, value);
	    }
	  }, {
	    key: "addResources",
	    value: function addResources(lng, ns, resources) {
	      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
	        silent: false
	      };
	
	      for (var m in resources) {
	        if (typeof resources[m] === 'string' || Object.prototype.toString.apply(resources[m]) === '[object Array]') this.addResource(lng, ns, m, resources[m], {
	          silent: true
	        });
	      }
	
	      if (!options.silent) this.emit('added', lng, ns, resources);
	    }
	  }, {
	    key: "addResourceBundle",
	    value: function addResourceBundle(lng, ns, resources, deep, overwrite) {
	      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
	        silent: false
	      };
	      var path = [lng, ns];
	
	      if (lng.indexOf('.') > -1) {
	        path = lng.split('.');
	        deep = resources;
	        resources = ns;
	        ns = path[1];
	      }
	
	      this.addNamespaces(ns);
	      var pack = getPath(this.data, path) || {};
	
	      if (deep) {
	        deepExtend(pack, resources, overwrite);
	      } else {
	        pack = _objectSpread__default['default']({}, pack, resources);
	      }
	
	      setPath(this.data, path, pack);
	      if (!options.silent) this.emit('added', lng, ns, resources);
	    }
	  }, {
	    key: "removeResourceBundle",
	    value: function removeResourceBundle(lng, ns) {
	      if (this.hasResourceBundle(lng, ns)) {
	        delete this.data[lng][ns];
	      }
	
	      this.removeNamespaces(ns);
	      this.emit('removed', lng, ns);
	    }
	  }, {
	    key: "hasResourceBundle",
	    value: function hasResourceBundle(lng, ns) {
	      return this.getResource(lng, ns) !== undefined;
	    }
	  }, {
	    key: "getResourceBundle",
	    value: function getResourceBundle(lng, ns) {
	      if (!ns) ns = this.options.defaultNS;
	      if (this.options.compatibilityAPI === 'v1') return _objectSpread__default['default']({}, {}, this.getResource(lng, ns));
	      return this.getResource(lng, ns);
	    }
	  }, {
	    key: "getDataByLanguage",
	    value: function getDataByLanguage(lng) {
	      return this.data[lng];
	    }
	  }, {
	    key: "toJSON",
	    value: function toJSON() {
	      return this.data;
	    }
	  }]);
	
	  return ResourceStore;
	}(EventEmitter);
	
	var postProcessor = {
	  processors: {},
	  addPostProcessor: function addPostProcessor(module) {
	    this.processors[module.name] = module;
	  },
	  handle: function handle(processors, value, key, options, translator) {
	    var _this = this;
	
	    processors.forEach(function (processor) {
	      if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
	    });
	    return value;
	  }
	};
	
	var checkedLoadedFor = {};
	
	var Translator = function (_EventEmitter) {
	  _inherits__default['default'](Translator, _EventEmitter);
	
	  function Translator(services) {
	    var _this;
	
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    _classCallCheck__default['default'](this, Translator);
	
	    _this = _possibleConstructorReturn__default['default'](this, _getPrototypeOf__default['default'](Translator).call(this));
	
	    if (isIE10) {
	      EventEmitter.call(_assertThisInitialized__default['default'](_this));
	    }
	
	    copy(['resourceStore', 'languageUtils', 'pluralResolver', 'interpolator', 'backendConnector', 'i18nFormat', 'utils'], services, _assertThisInitialized__default['default'](_this));
	    _this.options = options;
	
	    if (_this.options.keySeparator === undefined) {
	      _this.options.keySeparator = '.';
	    }
	
	    _this.logger = baseLogger.create('translator');
	    return _this;
	  }
	
	  _createClass__default['default'](Translator, [{
	    key: "changeLanguage",
	    value: function changeLanguage(lng) {
	      if (lng) this.language = lng;
	    }
	  }, {
	    key: "exists",
	    value: function exists(key) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
	        interpolation: {}
	      };
	      var resolved = this.resolve(key, options);
	      return resolved && resolved.res !== undefined;
	    }
	  }, {
	    key: "extractFromKey",
	    value: function extractFromKey(key, options) {
	      var nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
	      if (nsSeparator === undefined) nsSeparator = ':';
	      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
	      var namespaces = options.ns || this.options.defaultNS;
	
	      if (nsSeparator && key.indexOf(nsSeparator) > -1) {
	        var m = key.match(this.interpolator.nestingRegexp);
	
	        if (m && m.length > 0) {
	          return {
	            key: key,
	            namespaces: namespaces
	          };
	        }
	
	        var parts = key.split(nsSeparator);
	        if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
	        key = parts.join(keySeparator);
	      }
	
	      if (typeof namespaces === 'string') namespaces = [namespaces];
	      return {
	        key: key,
	        namespaces: namespaces
	      };
	    }
	  }, {
	    key: "translate",
	    value: function translate(keys, options, lastKey) {
	      var _this2 = this;
	
	      if (_typeof__default['default'](options) !== 'object' && this.options.overloadTranslationOptionHandler) {
	        options = this.options.overloadTranslationOptionHandler(arguments);
	      }
	
	      if (!options) options = {};
	      if (keys === undefined || keys === null) return '';
	      if (!Array.isArray(keys)) keys = [String(keys)];
	      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
	
	      var _this$extractFromKey = this.extractFromKey(keys[keys.length - 1], options),
	          key = _this$extractFromKey.key,
	          namespaces = _this$extractFromKey.namespaces;
	
	      var namespace = namespaces[namespaces.length - 1];
	      var lng = options.lng || this.language;
	      var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
	
	      if (lng && lng.toLowerCase() === 'cimode') {
	        if (appendNamespaceToCIMode) {
	          var nsSeparator = options.nsSeparator || this.options.nsSeparator;
	          return namespace + nsSeparator + key;
	        }
	
	        return key;
	      }
	
	      var resolved = this.resolve(keys, options);
	      var res = resolved && resolved.res;
	      var resUsedKey = resolved && resolved.usedKey || key;
	      var resExactUsedKey = resolved && resolved.exactUsedKey || key;
	      var resType = Object.prototype.toString.apply(res);
	      var noObject = ['[object Number]', '[object Function]', '[object RegExp]'];
	      var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
	      var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
	      var handleAsObject = typeof res !== 'string' && typeof res !== 'boolean' && typeof res !== 'number';
	
	      if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === 'string' && resType === '[object Array]')) {
	        if (!options.returnObjects && !this.options.returnObjects) {
	          this.logger.warn('accessing an object - but returnObjects options is not enabled!');
	          return this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, options) : "key '".concat(key, " (").concat(this.language, ")' returned an object instead of string.");
	        }
	
	        if (keySeparator) {
	          var resTypeIsArray = resType === '[object Array]';
	          var copy = resTypeIsArray ? [] : {};
	          var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
	
	          for (var m in res) {
	            if (Object.prototype.hasOwnProperty.call(res, m)) {
	              var deepKey = "".concat(newKeyToUse).concat(keySeparator).concat(m);
	              copy[m] = this.translate(deepKey, _objectSpread__default['default']({}, options, {
	                joinArrays: false,
	                ns: namespaces
	              }));
	              if (copy[m] === deepKey) copy[m] = res[m];
	            }
	          }
	
	          res = copy;
	        }
	      } else if (handleAsObjectInI18nFormat && typeof joinArrays === 'string' && resType === '[object Array]') {
	        res = res.join(joinArrays);
	        if (res) res = this.extendTranslation(res, keys, options, lastKey);
	      } else {
	        var usedDefault = false;
	        var usedKey = false;
	        var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
	        var hasDefaultValue = Translator.hasDefaultValue(options);
	        var defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count) : '';
	        var defaultValue = options["defaultValue".concat(defaultValueSuffix)] || options.defaultValue;
	
	        if (!this.isValidLookup(res) && hasDefaultValue) {
	          usedDefault = true;
	          res = defaultValue;
	        }
	
	        if (!this.isValidLookup(res)) {
	          usedKey = true;
	          res = key;
	        }
	
	        var updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
	
	        if (usedKey || usedDefault || updateMissing) {
	          this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);
	
	          if (keySeparator) {
	            var fk = this.resolve(key, _objectSpread__default['default']({}, options, {
	              keySeparator: false
	            }));
	            if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
	          }
	
	          var lngs = [];
	          var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
	
	          if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) {
	            for (var i = 0; i < fallbackLngs.length; i++) {
	              lngs.push(fallbackLngs[i]);
	            }
	          } else if (this.options.saveMissingTo === 'all') {
	            lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
	          } else {
	            lngs.push(options.lng || this.language);
	          }
	
	          var send = function send(l, k, fallbackValue) {
	            if (_this2.options.missingKeyHandler) {
	              _this2.options.missingKeyHandler(l, namespace, k, updateMissing ? fallbackValue : res, updateMissing, options);
	            } else if (_this2.backendConnector && _this2.backendConnector.saveMissing) {
	              _this2.backendConnector.saveMissing(l, namespace, k, updateMissing ? fallbackValue : res, updateMissing, options);
	            }
	
	            _this2.emit('missingKey', l, namespace, k, res);
	          };
	
	          if (this.options.saveMissing) {
	            if (this.options.saveMissingPlurals && needsPluralHandling) {
	              lngs.forEach(function (language) {
	                _this2.pluralResolver.getSuffixes(language).forEach(function (suffix) {
	                  send([language], key + suffix, options["defaultValue".concat(suffix)] || defaultValue);
	                });
	              });
	            } else {
	              send(lngs, key, defaultValue);
	            }
	          }
	        }
	
	        res = this.extendTranslation(res, keys, options, resolved, lastKey);
	        if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = "".concat(namespace, ":").concat(key);
	        if (usedKey && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(res);
	      }
	
	      return res;
	    }
	  }, {
	    key: "extendTranslation",
	    value: function extendTranslation(res, key, options, resolved, lastKey) {
	      var _this3 = this;
	
	      if (this.i18nFormat && this.i18nFormat.parse) {
	        res = this.i18nFormat.parse(res, options, resolved.usedLng, resolved.usedNS, resolved.usedKey, {
	          resolved: resolved
	        });
	      } else if (!options.skipInterpolation) {
	        if (options.interpolation) this.interpolator.init(_objectSpread__default['default']({}, options, {
	          interpolation: _objectSpread__default['default']({}, this.options.interpolation, options.interpolation)
	        }));
	        var skipOnVariables = options.interpolation && options.interpolation.skipOnVariables || this.options.interpolation.skipOnVariables;
	        var nestBef;
	
	        if (skipOnVariables) {
	          var nb = res.match(this.interpolator.nestingRegexp);
	          nestBef = nb && nb.length;
	        }
	
	        var data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
	        if (this.options.interpolation.defaultVariables) data = _objectSpread__default['default']({}, this.options.interpolation.defaultVariables, data);
	        res = this.interpolator.interpolate(res, data, options.lng || this.language, options);
	
	        if (skipOnVariables) {
	          var na = res.match(this.interpolator.nestingRegexp);
	          var nestAft = na && na.length;
	          if (nestBef < nestAft) options.nest = false;
	        }
	
	        if (options.nest !== false) res = this.interpolator.nest(res, function () {
	          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	          }
	
	          if (lastKey && lastKey[0] === args[0] && !options.context) {
	            _this3.logger.warn("It seems you are nesting recursively key: ".concat(args[0], " in key: ").concat(key[0]));
	
	            return null;
	          }
	
	          return _this3.translate.apply(_this3, args.concat([key]));
	        }, options);
	        if (options.interpolation) this.interpolator.reset();
	      }
	
	      var postProcess = options.postProcess || this.options.postProcess;
	      var postProcessorNames = typeof postProcess === 'string' ? [postProcess] : postProcess;
	
	      if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) {
	        res = postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? _objectSpread__default['default']({
	          i18nResolved: resolved
	        }, options) : options, this);
	      }
	
	      return res;
	    }
	  }, {
	    key: "resolve",
	    value: function resolve(keys) {
	      var _this4 = this;
	
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var found;
	      var usedKey;
	      var exactUsedKey;
	      var usedLng;
	      var usedNS;
	      if (typeof keys === 'string') keys = [keys];
	      keys.forEach(function (k) {
	        if (_this4.isValidLookup(found)) return;
	
	        var extracted = _this4.extractFromKey(k, options);
	
	        var key = extracted.key;
	        usedKey = key;
	        var namespaces = extracted.namespaces;
	        if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);
	        var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
	        var needsContextHandling = options.context !== undefined && typeof options.context === 'string' && options.context !== '';
	        var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);
	        namespaces.forEach(function (ns) {
	          if (_this4.isValidLookup(found)) return;
	          usedNS = ns;
	
	          if (!checkedLoadedFor["".concat(codes[0], "-").concat(ns)] && _this4.utils && _this4.utils.hasLoadedNamespace && !_this4.utils.hasLoadedNamespace(usedNS)) {
	            checkedLoadedFor["".concat(codes[0], "-").concat(ns)] = true;
	
	            _this4.logger.warn("key \"".concat(usedKey, "\" for languages \"").concat(codes.join(', '), "\" won't get resolved as namespace \"").concat(usedNS, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
	          }
	
	          codes.forEach(function (code) {
	            if (_this4.isValidLookup(found)) return;
	            usedLng = code;
	            var finalKey = key;
	            var finalKeys = [finalKey];
	
	            if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) {
	              _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
	            } else {
	              var pluralSuffix;
	              if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count);
	              if (needsPluralHandling && needsContextHandling) finalKeys.push(finalKey + pluralSuffix);
	              if (needsContextHandling) finalKeys.push(finalKey += "".concat(_this4.options.contextSeparator).concat(options.context));
	              if (needsPluralHandling) finalKeys.push(finalKey += pluralSuffix);
	            }
	
	            var possibleKey;
	
	            while (possibleKey = finalKeys.pop()) {
	              if (!_this4.isValidLookup(found)) {
	                exactUsedKey = possibleKey;
	                found = _this4.getResource(code, ns, possibleKey, options);
	              }
	            }
	          });
	        });
	      });
	      return {
	        res: found,
	        usedKey: usedKey,
	        exactUsedKey: exactUsedKey,
	        usedLng: usedLng,
	        usedNS: usedNS
	      };
	    }
	  }, {
	    key: "isValidLookup",
	    value: function isValidLookup(res) {
	      return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
	    }
	  }, {
	    key: "getResource",
	    value: function getResource(code, ns, key) {
	      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	      if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
	      return this.resourceStore.getResource(code, ns, key, options);
	    }
	  }], [{
	    key: "hasDefaultValue",
	    value: function hasDefaultValue(options) {
	      var prefix = 'defaultValue';
	
	      for (var option in options) {
	        if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) {
	          return true;
	        }
	      }
	
	      return false;
	    }
	  }]);
	
	  return Translator;
	}(EventEmitter);
	
	function capitalize(string) {
	  return string.charAt(0).toUpperCase() + string.slice(1);
	}
	
	var LanguageUtil = function () {
	  function LanguageUtil(options) {
	    _classCallCheck__default['default'](this, LanguageUtil);
	
	    this.options = options;
	    this.whitelist = this.options.supportedLngs || false;
	    this.supportedLngs = this.options.supportedLngs || false;
	    this.logger = baseLogger.create('languageUtils');
	  }
	
	  _createClass__default['default'](LanguageUtil, [{
	    key: "getScriptPartFromCode",
	    value: function getScriptPartFromCode(code) {
	      if (!code || code.indexOf('-') < 0) return null;
	      var p = code.split('-');
	      if (p.length === 2) return null;
	      p.pop();
	      if (p[p.length - 1].toLowerCase() === 'x') return null;
	      return this.formatLanguageCode(p.join('-'));
	    }
	  }, {
	    key: "getLanguagePartFromCode",
	    value: function getLanguagePartFromCode(code) {
	      if (!code || code.indexOf('-') < 0) return code;
	      var p = code.split('-');
	      return this.formatLanguageCode(p[0]);
	    }
	  }, {
	    key: "formatLanguageCode",
	    value: function formatLanguageCode(code) {
	      if (typeof code === 'string' && code.indexOf('-') > -1) {
	        var specialCases = ['hans', 'hant', 'latn', 'cyrl', 'cans', 'mong', 'arab'];
	        var p = code.split('-');
	
	        if (this.options.lowerCaseLng) {
	          p = p.map(function (part) {
	            return part.toLowerCase();
	          });
	        } else if (p.length === 2) {
	          p[0] = p[0].toLowerCase();
	          p[1] = p[1].toUpperCase();
	          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
	        } else if (p.length === 3) {
	          p[0] = p[0].toLowerCase();
	          if (p[1].length === 2) p[1] = p[1].toUpperCase();
	          if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();
	          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
	          if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
	        }
	
	        return p.join('-');
	      }
	
	      return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
	    }
	  }, {
	    key: "isWhitelisted",
	    value: function isWhitelisted(code) {
	      this.logger.deprecate('languageUtils.isWhitelisted', 'function "isWhitelisted" will be renamed to "isSupportedCode" in the next major - please make sure to rename it\'s usage asap.');
	      return this.isSupportedCode(code);
	    }
	  }, {
	    key: "isSupportedCode",
	    value: function isSupportedCode(code) {
	      if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) {
	        code = this.getLanguagePartFromCode(code);
	      }
	
	      return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
	    }
	  }, {
	    key: "getBestMatchFromCodes",
	    value: function getBestMatchFromCodes(codes) {
	      var _this = this;
	
	      if (!codes) return null;
	      var found;
	      codes.forEach(function (code) {
	        if (found) return;
	
	        var cleanedLng = _this.formatLanguageCode(code);
	
	        if (!_this.options.supportedLngs || _this.isSupportedCode(cleanedLng)) found = cleanedLng;
	      });
	
	      if (!found && this.options.supportedLngs) {
	        codes.forEach(function (code) {
	          if (found) return;
	
	          var lngOnly = _this.getLanguagePartFromCode(code);
	
	          if (_this.isSupportedCode(lngOnly)) return found = lngOnly;
	          found = _this.options.supportedLngs.find(function (supportedLng) {
	            if (supportedLng.indexOf(lngOnly) === 0) return supportedLng;
	          });
	        });
	      }
	
	      if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
	      return found;
	    }
	  }, {
	    key: "getFallbackCodes",
	    value: function getFallbackCodes(fallbacks, code) {
	      if (!fallbacks) return [];
	      if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
	      if (typeof fallbacks === 'string') fallbacks = [fallbacks];
	      if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;
	      if (!code) return fallbacks["default"] || [];
	      var found = fallbacks[code];
	      if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
	      if (!found) found = fallbacks[this.formatLanguageCode(code)];
	      if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
	      if (!found) found = fallbacks["default"];
	      return found || [];
	    }
	  }, {
	    key: "toResolveHierarchy",
	    value: function toResolveHierarchy(code, fallbackCode) {
	      var _this2 = this;
	
	      var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
	      var codes = [];
	
	      var addCode = function addCode(c) {
	        if (!c) return;
	
	        if (_this2.isSupportedCode(c)) {
	          codes.push(c);
	        } else {
	          _this2.logger.warn("rejecting language code not found in supportedLngs: ".concat(c));
	        }
	      };
	
	      if (typeof code === 'string' && code.indexOf('-') > -1) {
	        if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
	        if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
	        if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
	      } else if (typeof code === 'string') {
	        addCode(this.formatLanguageCode(code));
	      }
	
	      fallbackCodes.forEach(function (fc) {
	        if (codes.indexOf(fc) < 0) addCode(_this2.formatLanguageCode(fc));
	      });
	      return codes;
	    }
	  }]);
	
	  return LanguageUtil;
	}();
	
	var sets = [{
	  lngs: ['ach', 'ak', 'am', 'arn', 'br', 'fil', 'gun', 'ln', 'mfe', 'mg', 'mi', 'oc', 'pt', 'pt-BR', 'tg', 'tl', 'ti', 'tr', 'uz', 'wa'],
	  nr: [1, 2],
	  fc: 1
	}, {
	  lngs: ['af', 'an', 'ast', 'az', 'bg', 'bn', 'ca', 'da', 'de', 'dev', 'el', 'en', 'eo', 'es', 'et', 'eu', 'fi', 'fo', 'fur', 'fy', 'gl', 'gu', 'ha', 'hi', 'hu', 'hy', 'ia', 'it', 'kn', 'ku', 'lb', 'mai', 'ml', 'mn', 'mr', 'nah', 'nap', 'nb', 'ne', 'nl', 'nn', 'no', 'nso', 'pa', 'pap', 'pms', 'ps', 'pt-PT', 'rm', 'sco', 'se', 'si', 'so', 'son', 'sq', 'sv', 'sw', 'ta', 'te', 'tk', 'ur', 'yo'],
	  nr: [1, 2],
	  fc: 2
	}, {
	  lngs: ['ay', 'bo', 'cgg', 'fa', 'ht', 'id', 'ja', 'jbo', 'ka', 'kk', 'km', 'ko', 'ky', 'lo', 'ms', 'sah', 'su', 'th', 'tt', 'ug', 'vi', 'wo', 'zh'],
	  nr: [1],
	  fc: 3
	}, {
	  lngs: ['be', 'bs', 'cnr', 'dz', 'hr', 'ru', 'sr', 'uk'],
	  nr: [1, 2, 5],
	  fc: 4
	}, {
	  lngs: ['ar'],
	  nr: [0, 1, 2, 3, 11, 100],
	  fc: 5
	}, {
	  lngs: ['cs', 'sk'],
	  nr: [1, 2, 5],
	  fc: 6
	}, {
	  lngs: ['csb', 'pl'],
	  nr: [1, 2, 5],
	  fc: 7
	}, {
	  lngs: ['cy'],
	  nr: [1, 2, 3, 8],
	  fc: 8
	}, {
	  lngs: ['fr'],
	  nr: [1, 2],
	  fc: 9
	}, {
	  lngs: ['ga'],
	  nr: [1, 2, 3, 7, 11],
	  fc: 10
	}, {
	  lngs: ['gd'],
	  nr: [1, 2, 3, 20],
	  fc: 11
	}, {
	  lngs: ['is'],
	  nr: [1, 2],
	  fc: 12
	}, {
	  lngs: ['jv'],
	  nr: [0, 1],
	  fc: 13
	}, {
	  lngs: ['kw'],
	  nr: [1, 2, 3, 4],
	  fc: 14
	}, {
	  lngs: ['lt'],
	  nr: [1, 2, 10],
	  fc: 15
	}, {
	  lngs: ['lv'],
	  nr: [1, 2, 0],
	  fc: 16
	}, {
	  lngs: ['mk'],
	  nr: [1, 2],
	  fc: 17
	}, {
	  lngs: ['mnk'],
	  nr: [0, 1, 2],
	  fc: 18
	}, {
	  lngs: ['mt'],
	  nr: [1, 2, 11, 20],
	  fc: 19
	}, {
	  lngs: ['or'],
	  nr: [2, 1],
	  fc: 2
	}, {
	  lngs: ['ro'],
	  nr: [1, 2, 20],
	  fc: 20
	}, {
	  lngs: ['sl'],
	  nr: [5, 1, 2, 3],
	  fc: 21
	}, {
	  lngs: ['he', 'iw'],
	  nr: [1, 2, 20, 21],
	  fc: 22
	}];
	var _rulesPluralsTypes = {
	  1: function _(n) {
	    return Number(n > 1);
	  },
	  2: function _(n) {
	    return Number(n != 1);
	  },
	  3: function _(n) {
	    return 0;
	  },
	  4: function _(n) {
	    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
	  },
	  5: function _(n) {
	    return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
	  },
	  6: function _(n) {
	    return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
	  },
	  7: function _(n) {
	    return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
	  },
	  8: function _(n) {
	    return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
	  },
	  9: function _(n) {
	    return Number(n >= 2);
	  },
	  10: function _(n) {
	    return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
	  },
	  11: function _(n) {
	    return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
	  },
	  12: function _(n) {
	    return Number(n % 10 != 1 || n % 100 == 11);
	  },
	  13: function _(n) {
	    return Number(n !== 0);
	  },
	  14: function _(n) {
	    return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
	  },
	  15: function _(n) {
	    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
	  },
	  16: function _(n) {
	    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
	  },
	  17: function _(n) {
	    return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
	  },
	  18: function _(n) {
	    return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
	  },
	  19: function _(n) {
	    return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
	  },
	  20: function _(n) {
	    return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
	  },
	  21: function _(n) {
	    return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
	  },
	  22: function _(n) {
	    return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
	  }
	};
	
	function createRules() {
	  var rules = {};
	  sets.forEach(function (set) {
	    set.lngs.forEach(function (l) {
	      rules[l] = {
	        numbers: set.nr,
	        plurals: _rulesPluralsTypes[set.fc]
	      };
	    });
	  });
	  return rules;
	}
	
	var PluralResolver = function () {
	  function PluralResolver(languageUtils) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    _classCallCheck__default['default'](this, PluralResolver);
	
	    this.languageUtils = languageUtils;
	    this.options = options;
	    this.logger = baseLogger.create('pluralResolver');
	    this.rules = createRules();
	  }
	
	  _createClass__default['default'](PluralResolver, [{
	    key: "addRule",
	    value: function addRule(lng, obj) {
	      this.rules[lng] = obj;
	    }
	  }, {
	    key: "getRule",
	    value: function getRule(code) {
	      return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
	    }
	  }, {
	    key: "needsPlural",
	    value: function needsPlural(code) {
	      var rule = this.getRule(code);
	      return rule && rule.numbers.length > 1;
	    }
	  }, {
	    key: "getPluralFormsOfKey",
	    value: function getPluralFormsOfKey(code, key) {
	      return this.getSuffixes(code).map(function (suffix) {
	        return key + suffix;
	      });
	    }
	  }, {
	    key: "getSuffixes",
	    value: function getSuffixes(code) {
	      var _this = this;
	
	      var rule = this.getRule(code);
	
	      if (!rule) {
	        return [];
	      }
	
	      return rule.numbers.map(function (number) {
	        return _this.getSuffix(code, number);
	      });
	    }
	  }, {
	    key: "getSuffix",
	    value: function getSuffix(code, count) {
	      var _this2 = this;
	
	      var rule = this.getRule(code);
	
	      if (rule) {
	        var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
	        var suffix = rule.numbers[idx];
	
	        if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
	          if (suffix === 2) {
	            suffix = 'plural';
	          } else if (suffix === 1) {
	            suffix = '';
	          }
	        }
	
	        var returnSuffix = function returnSuffix() {
	          return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
	        };
	
	        if (this.options.compatibilityJSON === 'v1') {
	          if (suffix === 1) return '';
	          if (typeof suffix === 'number') return "_plural_".concat(suffix.toString());
	          return returnSuffix();
	        } else if (this.options.compatibilityJSON === 'v2') {
	          return returnSuffix();
	        } else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
	          return returnSuffix();
	        }
	
	        return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
	      }
	
	      this.logger.warn("no plural rule found for: ".concat(code));
	      return '';
	    }
	  }]);
	
	  return PluralResolver;
	}();
	
	var Interpolator = function () {
	  function Interpolator() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck__default['default'](this, Interpolator);
	
	    this.logger = baseLogger.create('interpolator');
	    this.options = options;
	
	    this.format = options.interpolation && options.interpolation.format || function (value) {
	      return value;
	    };
	
	    this.init(options);
	  }
	
	  _createClass__default['default'](Interpolator, [{
	    key: "init",
	    value: function init() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      if (!options.interpolation) options.interpolation = {
	        escapeValue: true
	      };
	      var iOpts = options.interpolation;
	      this.escape = iOpts.escape !== undefined ? iOpts.escape : escape;
	      this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
	      this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
	      this.prefix = iOpts.prefix ? regexEscape(iOpts.prefix) : iOpts.prefixEscaped || '{{';
	      this.suffix = iOpts.suffix ? regexEscape(iOpts.suffix) : iOpts.suffixEscaped || '}}';
	      this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
	      this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
	      this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';
	      this.nestingPrefix = iOpts.nestingPrefix ? regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || regexEscape('$t(');
	      this.nestingSuffix = iOpts.nestingSuffix ? regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || regexEscape(')');
	      this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ',';
	      this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
	      this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
	      this.resetRegExp();
	    }
	  }, {
	    key: "reset",
	    value: function reset() {
	      if (this.options) this.init(this.options);
	    }
	  }, {
	    key: "resetRegExp",
	    value: function resetRegExp() {
	      var regexpStr = "".concat(this.prefix, "(.+?)").concat(this.suffix);
	      this.regexp = new RegExp(regexpStr, 'g');
	      var regexpUnescapeStr = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
	      this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');
	      var nestingRegexpStr = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
	      this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
	    }
	  }, {
	    key: "interpolate",
	    value: function interpolate(str, data, lng, options) {
	      var _this = this;
	
	      var match;
	      var value;
	      var replaces;
	      var defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
	
	      function regexSafe(val) {
	        return val.replace(/\$/g, '$$$$');
	      }
	
	      var handleFormat = function handleFormat(key) {
	        if (key.indexOf(_this.formatSeparator) < 0) {
	          var path = getPathWithDefaults(data, defaultData, key);
	          return _this.alwaysFormat ? _this.format(path, undefined, lng) : path;
	        }
	
	        var p = key.split(_this.formatSeparator);
	        var k = p.shift().trim();
	        var f = p.join(_this.formatSeparator).trim();
	        return _this.format(getPathWithDefaults(data, defaultData, k), f, lng, options);
	      };
	
	      this.resetRegExp();
	      var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
	      var skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables || this.options.interpolation.skipOnVariables;
	      var todos = [{
	        regex: this.regexpUnescape,
	        safeValue: function safeValue(val) {
	          return regexSafe(val);
	        }
	      }, {
	        regex: this.regexp,
	        safeValue: function safeValue(val) {
	          return _this.escapeValue ? regexSafe(_this.escape(val)) : regexSafe(val);
	        }
	      }];
	      todos.forEach(function (todo) {
	        replaces = 0;
	
	        while (match = todo.regex.exec(str)) {
	          value = handleFormat(match[1].trim());
	
	          if (value === undefined) {
	            if (typeof missingInterpolationHandler === 'function') {
	              var temp = missingInterpolationHandler(str, match, options);
	              value = typeof temp === 'string' ? temp : '';
	            } else if (skipOnVariables) {
	              value = match[0];
	              continue;
	            } else {
	              _this.logger.warn("missed to pass in variable ".concat(match[1], " for interpolating ").concat(str));
	
	              value = '';
	            }
	          } else if (typeof value !== 'string' && !_this.useRawValueToEscape) {
	            value = makeString(value);
	          }
	
	          str = str.replace(match[0], todo.safeValue(value));
	          todo.regex.lastIndex = 0;
	          replaces++;
	
	          if (replaces >= _this.maxReplaces) {
	            break;
	          }
	        }
	      });
	      return str;
	    }
	  }, {
	    key: "nest",
	    value: function nest(str, fc) {
	      var _this2 = this;
	
	      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	      var match;
	      var value;
	
	      var clonedOptions = _objectSpread__default['default']({}, options);
	
	      clonedOptions.applyPostProcessor = false;
	      delete clonedOptions.defaultValue;
	
	      function handleHasOptions(key, inheritedOptions) {
	        var sep = this.nestingOptionsSeparator;
	        if (key.indexOf(sep) < 0) return key;
	        var c = key.split(new RegExp("".concat(sep, "[ ]*{")));
	        var optionsString = "{".concat(c[1]);
	        key = c[0];
	        optionsString = this.interpolate(optionsString, clonedOptions);
	        optionsString = optionsString.replace(/'/g, '"');
	
	        try {
	          clonedOptions = JSON.parse(optionsString);
	          if (inheritedOptions) clonedOptions = _objectSpread__default['default']({}, inheritedOptions, clonedOptions);
	        } catch (e) {
	          this.logger.warn("failed parsing options string in nesting for key ".concat(key), e);
	          return "".concat(key).concat(sep).concat(optionsString);
	        }
	
	        delete clonedOptions.defaultValue;
	        return key;
	      }
	
	      while (match = this.nestingRegexp.exec(str)) {
	        var formatters = [];
	        var doReduce = false;
	
	        if (match[0].includes(this.formatSeparator) && !/{.*}/.test(match[1])) {
	          var r = match[1].split(this.formatSeparator).map(function (elem) {
	            return elem.trim();
	          });
	          match[1] = r.shift();
	          formatters = r;
	          doReduce = true;
	        }
	
	        value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
	        if (value && match[0] === str && typeof value !== 'string') return value;
	        if (typeof value !== 'string') value = makeString(value);
	
	        if (!value) {
	          this.logger.warn("missed to resolve ".concat(match[1], " for nesting ").concat(str));
	          value = '';
	        }
	
	        if (doReduce) {
	          value = formatters.reduce(function (v, f) {
	            return _this2.format(v, f, options.lng, options);
	          }, value.trim());
	        }
	
	        str = str.replace(match[0], value);
	        this.regexp.lastIndex = 0;
	      }
	
	      return str;
	    }
	  }]);
	
	  return Interpolator;
	}();
	
	function remove(arr, what) {
	  var found = arr.indexOf(what);
	
	  while (found !== -1) {
	    arr.splice(found, 1);
	    found = arr.indexOf(what);
	  }
	}
	
	var Connector = function (_EventEmitter) {
	  _inherits__default['default'](Connector, _EventEmitter);
	
	  function Connector(backend, store, services) {
	    var _this;
	
	    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	    _classCallCheck__default['default'](this, Connector);
	
	    _this = _possibleConstructorReturn__default['default'](this, _getPrototypeOf__default['default'](Connector).call(this));
	
	    if (isIE10) {
	      EventEmitter.call(_assertThisInitialized__default['default'](_this));
	    }
	
	    _this.backend = backend;
	    _this.store = store;
	    _this.services = services;
	    _this.languageUtils = services.languageUtils;
	    _this.options = options;
	    _this.logger = baseLogger.create('backendConnector');
	    _this.state = {};
	    _this.queue = [];
	
	    if (_this.backend && _this.backend.init) {
	      _this.backend.init(services, options.backend, options);
	    }
	
	    return _this;
	  }
	
	  _createClass__default['default'](Connector, [{
	    key: "queueLoad",
	    value: function queueLoad(languages, namespaces, options, callback) {
	      var _this2 = this;
	
	      var toLoad = [];
	      var pending = [];
	      var toLoadLanguages = [];
	      var toLoadNamespaces = [];
	      languages.forEach(function (lng) {
	        var hasAllNamespaces = true;
	        namespaces.forEach(function (ns) {
	          var name = "".concat(lng, "|").concat(ns);
	
	          if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) {
	            _this2.state[name] = 2;
	          } else if (_this2.state[name] < 0) ; else if (_this2.state[name] === 1) {
	            if (pending.indexOf(name) < 0) pending.push(name);
	          } else {
	            _this2.state[name] = 1;
	            hasAllNamespaces = false;
	            if (pending.indexOf(name) < 0) pending.push(name);
	            if (toLoad.indexOf(name) < 0) toLoad.push(name);
	            if (toLoadNamespaces.indexOf(ns) < 0) toLoadNamespaces.push(ns);
	          }
	        });
	        if (!hasAllNamespaces) toLoadLanguages.push(lng);
	      });
	
	      if (toLoad.length || pending.length) {
	        this.queue.push({
	          pending: pending,
	          loaded: {},
	          errors: [],
	          callback: callback
	        });
	      }
	
	      return {
	        toLoad: toLoad,
	        pending: pending,
	        toLoadLanguages: toLoadLanguages,
	        toLoadNamespaces: toLoadNamespaces
	      };
	    }
	  }, {
	    key: "loaded",
	    value: function loaded(name, err, data) {
	      var s = name.split('|');
	      var lng = s[0];
	      var ns = s[1];
	      if (err) this.emit('failedLoading', lng, ns, err);
	
	      if (data) {
	        this.store.addResourceBundle(lng, ns, data);
	      }
	
	      this.state[name] = err ? -1 : 2;
	      var loaded = {};
	      this.queue.forEach(function (q) {
	        pushPath(q.loaded, [lng], ns);
	        remove(q.pending, name);
	        if (err) q.errors.push(err);
	
	        if (q.pending.length === 0 && !q.done) {
	          Object.keys(q.loaded).forEach(function (l) {
	            if (!loaded[l]) loaded[l] = [];
	
	            if (q.loaded[l].length) {
	              q.loaded[l].forEach(function (ns) {
	                if (loaded[l].indexOf(ns) < 0) loaded[l].push(ns);
	              });
	            }
	          });
	          q.done = true;
	
	          if (q.errors.length) {
	            q.callback(q.errors);
	          } else {
	            q.callback();
	          }
	        }
	      });
	      this.emit('loaded', loaded);
	      this.queue = this.queue.filter(function (q) {
	        return !q.done;
	      });
	    }
	  }, {
	    key: "read",
	    value: function read(lng, ns, fcName) {
	      var _this3 = this;
	
	      var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
	      var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 350;
	      var callback = arguments.length > 5 ? arguments[5] : undefined;
	      if (!lng.length) return callback(null, {});
	      return this.backend[fcName](lng, ns, function (err, data) {
	        if (err && data && tried < 5) {
	          setTimeout(function () {
	            _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
	          }, wait);
	          return;
	        }
	
	        callback(err, data);
	      });
	    }
	  }, {
	    key: "prepareLoading",
	    value: function prepareLoading(languages, namespaces) {
	      var _this4 = this;
	
	      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	      var callback = arguments.length > 3 ? arguments[3] : undefined;
	
	      if (!this.backend) {
	        this.logger.warn('No backend was added via i18next.use. Will not load resources.');
	        return callback && callback();
	      }
	
	      if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
	      if (typeof namespaces === 'string') namespaces = [namespaces];
	      var toLoad = this.queueLoad(languages, namespaces, options, callback);
	
	      if (!toLoad.toLoad.length) {
	        if (!toLoad.pending.length) callback();
	        return null;
	      }
	
	      toLoad.toLoad.forEach(function (name) {
	        _this4.loadOne(name);
	      });
	    }
	  }, {
	    key: "load",
	    value: function load(languages, namespaces, callback) {
	      this.prepareLoading(languages, namespaces, {}, callback);
	    }
	  }, {
	    key: "reload",
	    value: function reload(languages, namespaces, callback) {
	      this.prepareLoading(languages, namespaces, {
	        reload: true
	      }, callback);
	    }
	  }, {
	    key: "loadOne",
	    value: function loadOne(name) {
	      var _this5 = this;
	
	      var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	      var s = name.split('|');
	      var lng = s[0];
	      var ns = s[1];
	      this.read(lng, ns, 'read', undefined, undefined, function (err, data) {
	        if (err) _this5.logger.warn("".concat(prefix, "loading namespace ").concat(ns, " for language ").concat(lng, " failed"), err);
	        if (!err && data) _this5.logger.log("".concat(prefix, "loaded namespace ").concat(ns, " for language ").concat(lng), data);
	
	        _this5.loaded(name, err, data);
	      });
	    }
	  }, {
	    key: "saveMissing",
	    value: function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
	      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
	
	      if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
	        this.logger.warn("did not save key \"".concat(key, "\" as the namespace \"").concat(namespace, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
	        return;
	      }
	
	      if (key === undefined || key === null || key === '') return;
	
	      if (this.backend && this.backend.create) {
	        this.backend.create(languages, namespace, key, fallbackValue, null, _objectSpread__default['default']({}, options, {
	          isUpdate: isUpdate
	        }));
	      }
	
	      if (!languages || !languages[0]) return;
	      this.store.addResource(languages[0], namespace, key, fallbackValue);
	    }
	  }]);
	
	  return Connector;
	}(EventEmitter);
	
	function get() {
	  return {
	    debug: false,
	    initImmediate: true,
	    ns: ['translation'],
	    defaultNS: ['translation'],
	    fallbackLng: ['dev'],
	    fallbackNS: false,
	    whitelist: false,
	    nonExplicitWhitelist: false,
	    supportedLngs: false,
	    nonExplicitSupportedLngs: false,
	    load: 'all',
	    preload: false,
	    simplifyPluralSuffix: true,
	    keySeparator: '.',
	    nsSeparator: ':',
	    pluralSeparator: '_',
	    contextSeparator: '_',
	    partialBundledLanguages: false,
	    saveMissing: false,
	    updateMissing: false,
	    saveMissingTo: 'fallback',
	    saveMissingPlurals: true,
	    missingKeyHandler: false,
	    missingInterpolationHandler: false,
	    postProcess: false,
	    postProcessPassResolved: false,
	    returnNull: true,
	    returnEmptyString: true,
	    returnObjects: false,
	    joinArrays: false,
	    returnedObjectHandler: false,
	    parseMissingKeyHandler: false,
	    appendNamespaceToMissingKey: false,
	    appendNamespaceToCIMode: false,
	    overloadTranslationOptionHandler: function handle(args) {
	      var ret = {};
	      if (_typeof__default['default'](args[1]) === 'object') ret = args[1];
	      if (typeof args[1] === 'string') ret.defaultValue = args[1];
	      if (typeof args[2] === 'string') ret.tDescription = args[2];
	
	      if (_typeof__default['default'](args[2]) === 'object' || _typeof__default['default'](args[3]) === 'object') {
	        var options = args[3] || args[2];
	        Object.keys(options).forEach(function (key) {
	          ret[key] = options[key];
	        });
	      }
	
	      return ret;
	    },
	    interpolation: {
	      escapeValue: true,
	      format: function format(value, _format, lng, options) {
	        return value;
	      },
	      prefix: '{{',
	      suffix: '}}',
	      formatSeparator: ',',
	      unescapePrefix: '-',
	      nestingPrefix: '$t(',
	      nestingSuffix: ')',
	      nestingOptionsSeparator: ',',
	      maxReplaces: 1000,
	      skipOnVariables: false
	    }
	  };
	}
	function transformOptions(options) {
	  if (typeof options.ns === 'string') options.ns = [options.ns];
	  if (typeof options.fallbackLng === 'string') options.fallbackLng = [options.fallbackLng];
	  if (typeof options.fallbackNS === 'string') options.fallbackNS = [options.fallbackNS];
	
	  if (options.whitelist) {
	    if (options.whitelist && options.whitelist.indexOf('cimode') < 0) {
	      options.whitelist = options.whitelist.concat(['cimode']);
	    }
	
	    options.supportedLngs = options.whitelist;
	  }
	
	  if (options.nonExplicitWhitelist) {
	    options.nonExplicitSupportedLngs = options.nonExplicitWhitelist;
	  }
	
	  if (options.supportedLngs && options.supportedLngs.indexOf('cimode') < 0) {
	    options.supportedLngs = options.supportedLngs.concat(['cimode']);
	  }
	
	  return options;
	}
	
	function noop() {}
	
	var I18n = function (_EventEmitter) {
	  _inherits__default['default'](I18n, _EventEmitter);
	
	  function I18n() {
	    var _this;
	
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var callback = arguments.length > 1 ? arguments[1] : undefined;
	
	    _classCallCheck__default['default'](this, I18n);
	
	    _this = _possibleConstructorReturn__default['default'](this, _getPrototypeOf__default['default'](I18n).call(this));
	
	    if (isIE10) {
	      EventEmitter.call(_assertThisInitialized__default['default'](_this));
	    }
	
	    _this.options = transformOptions(options);
	    _this.services = {};
	    _this.logger = baseLogger;
	    _this.modules = {
	      external: []
	    };
	
	    if (callback && !_this.isInitialized && !options.isClone) {
	      if (!_this.options.initImmediate) {
	        _this.init(options, callback);
	
	        return _possibleConstructorReturn__default['default'](_this, _assertThisInitialized__default['default'](_this));
	      }
	
	      setTimeout(function () {
	        _this.init(options, callback);
	      }, 0);
	    }
	
	    return _this;
	  }
	
	  _createClass__default['default'](I18n, [{
	    key: "init",
	    value: function init() {
	      var _this2 = this;
	
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var callback = arguments.length > 1 ? arguments[1] : undefined;
	
	      if (typeof options === 'function') {
	        callback = options;
	        options = {};
	      }
	
	      if (options.whitelist && !options.supportedLngs) {
	        this.logger.deprecate('whitelist', 'option "whitelist" will be renamed to "supportedLngs" in the next major - please make sure to rename this option asap.');
	      }
	
	      if (options.nonExplicitWhitelist && !options.nonExplicitSupportedLngs) {
	        this.logger.deprecate('whitelist', 'options "nonExplicitWhitelist" will be renamed to "nonExplicitSupportedLngs" in the next major - please make sure to rename this option asap.');
	      }
	
	      this.options = _objectSpread__default['default']({}, get(), this.options, transformOptions(options));
	      this.format = this.options.interpolation.format;
	      if (!callback) callback = noop;
	
	      function createClassOnDemand(ClassOrObject) {
	        if (!ClassOrObject) return null;
	        if (typeof ClassOrObject === 'function') return new ClassOrObject();
	        return ClassOrObject;
	      }
	
	      if (!this.options.isClone) {
	        if (this.modules.logger) {
	          baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
	        } else {
	          baseLogger.init(null, this.options);
	        }
	
	        var lu = new LanguageUtil(this.options);
	        this.store = new ResourceStore(this.options.resources, this.options);
	        var s = this.services;
	        s.logger = baseLogger;
	        s.resourceStore = this.store;
	        s.languageUtils = lu;
	        s.pluralResolver = new PluralResolver(lu, {
	          prepend: this.options.pluralSeparator,
	          compatibilityJSON: this.options.compatibilityJSON,
	          simplifyPluralSuffix: this.options.simplifyPluralSuffix
	        });
	        s.interpolator = new Interpolator(this.options);
	        s.utils = {
	          hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
	        };
	        s.backendConnector = new Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
	        s.backendConnector.on('*', function (event) {
	          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	            args[_key - 1] = arguments[_key];
	          }
	
	          _this2.emit.apply(_this2, [event].concat(args));
	        });
	
	        if (this.modules.languageDetector) {
	          s.languageDetector = createClassOnDemand(this.modules.languageDetector);
	          s.languageDetector.init(s, this.options.detection, this.options);
	        }
	
	        if (this.modules.i18nFormat) {
	          s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
	          if (s.i18nFormat.init) s.i18nFormat.init(this);
	        }
	
	        this.translator = new Translator(this.services, this.options);
	        this.translator.on('*', function (event) {
	          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	            args[_key2 - 1] = arguments[_key2];
	          }
	
	          _this2.emit.apply(_this2, [event].concat(args));
	        });
	        this.modules.external.forEach(function (m) {
	          if (m.init) m.init(_this2);
	        });
	      }
	
	      if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
	        var codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
	        if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
	      }
	
	      if (!this.services.languageDetector && !this.options.lng) {
	        this.logger.warn('init: no languageDetector is used and no lng is defined');
	      }
	
	      var storeApi = ['getResource', 'hasResourceBundle', 'getResourceBundle', 'getDataByLanguage'];
	      storeApi.forEach(function (fcName) {
	        _this2[fcName] = function () {
	          var _this2$store;
	
	          return (_this2$store = _this2.store)[fcName].apply(_this2$store, arguments);
	        };
	      });
	      var storeApiChained = ['addResource', 'addResources', 'addResourceBundle', 'removeResourceBundle'];
	      storeApiChained.forEach(function (fcName) {
	        _this2[fcName] = function () {
	          var _this2$store2;
	
	          (_this2$store2 = _this2.store)[fcName].apply(_this2$store2, arguments);
	
	          return _this2;
	        };
	      });
	      var deferred = defer();
	
	      var load = function load() {
	        var finish = function finish(err, t) {
	          if (_this2.isInitialized) _this2.logger.warn('init: i18next is already initialized. You should call init just once!');
	          _this2.isInitialized = true;
	          if (!_this2.options.isClone) _this2.logger.log('initialized', _this2.options);
	
	          _this2.emit('initialized', _this2.options);
	
	          deferred.resolve(t);
	          callback(err, t);
	        };
	
	        if (_this2.languages && _this2.options.compatibilityAPI !== 'v1' && !_this2.isInitialized) return finish(null, _this2.t.bind(_this2));
	
	        _this2.changeLanguage(_this2.options.lng, finish);
	      };
	
	      if (this.options.resources || !this.options.initImmediate) {
	        load();
	      } else {
	        setTimeout(load, 0);
	      }
	
	      return deferred;
	    }
	  }, {
	    key: "loadResources",
	    value: function loadResources(language) {
	      var _this3 = this;
	
	      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
	      var usedCallback = callback;
	      var usedLng = typeof language === 'string' ? language : this.language;
	      if (typeof language === 'function') usedCallback = language;
	
	      if (!this.options.resources || this.options.partialBundledLanguages) {
	        if (usedLng && usedLng.toLowerCase() === 'cimode') return usedCallback();
	        var toLoad = [];
	
	        var append = function append(lng) {
	          if (!lng) return;
	
	          var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);
	
	          lngs.forEach(function (l) {
	            if (toLoad.indexOf(l) < 0) toLoad.push(l);
	          });
	        };
	
	        if (!usedLng) {
	          var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
	          fallbacks.forEach(function (l) {
	            return append(l);
	          });
	        } else {
	          append(usedLng);
	        }
	
	        if (this.options.preload) {
	          this.options.preload.forEach(function (l) {
	            return append(l);
	          });
	        }
	
	        this.services.backendConnector.load(toLoad, this.options.ns, usedCallback);
	      } else {
	        usedCallback(null);
	      }
	    }
	  }, {
	    key: "reloadResources",
	    value: function reloadResources(lngs, ns, callback) {
	      var deferred = defer();
	      if (!lngs) lngs = this.languages;
	      if (!ns) ns = this.options.ns;
	      if (!callback) callback = noop;
	      this.services.backendConnector.reload(lngs, ns, function (err) {
	        deferred.resolve();
	        callback(err);
	      });
	      return deferred;
	    }
	  }, {
	    key: "use",
	    value: function use(module) {
	      if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
	      if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');
	
	      if (module.type === 'backend') {
	        this.modules.backend = module;
	      }
	
	      if (module.type === 'logger' || module.log && module.warn && module.error) {
	        this.modules.logger = module;
	      }
	
	      if (module.type === 'languageDetector') {
	        this.modules.languageDetector = module;
	      }
	
	      if (module.type === 'i18nFormat') {
	        this.modules.i18nFormat = module;
	      }
	
	      if (module.type === 'postProcessor') {
	        postProcessor.addPostProcessor(module);
	      }
	
	      if (module.type === '3rdParty') {
	        this.modules.external.push(module);
	      }
	
	      return this;
	    }
	  }, {
	    key: "changeLanguage",
	    value: function changeLanguage(lng, callback) {
	      var _this4 = this;
	
	      this.isLanguageChangingTo = lng;
	      var deferred = defer();
	      this.emit('languageChanging', lng);
	
	      var done = function done(err, l) {
	        if (l) {
	          _this4.language = l;
	          _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
	
	          _this4.translator.changeLanguage(l);
	
	          _this4.isLanguageChangingTo = undefined;
	
	          _this4.emit('languageChanged', l);
	
	          _this4.logger.log('languageChanged', l);
	        } else {
	          _this4.isLanguageChangingTo = undefined;
	        }
	
	        deferred.resolve(function () {
	          return _this4.t.apply(_this4, arguments);
	        });
	        if (callback) callback(err, function () {
	          return _this4.t.apply(_this4, arguments);
	        });
	      };
	
	      var setLng = function setLng(lngs) {
	        var l = typeof lngs === 'string' ? lngs : _this4.services.languageUtils.getBestMatchFromCodes(lngs);
	
	        if (l) {
	          if (!_this4.language) {
	            _this4.language = l;
	            _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
	          }
	
	          if (!_this4.translator.language) _this4.translator.changeLanguage(l);
	          if (_this4.services.languageDetector) _this4.services.languageDetector.cacheUserLanguage(l);
	        }
	
	        _this4.loadResources(l, function (err) {
	          done(err, l);
	        });
	      };
	
	      if (!lng && this.services.languageDetector && !this.services.languageDetector.async) {
	        setLng(this.services.languageDetector.detect());
	      } else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
	        this.services.languageDetector.detect(setLng);
	      } else {
	        setLng(lng);
	      }
	
	      return deferred;
	    }
	  }, {
	    key: "getFixedT",
	    value: function getFixedT(lng, ns) {
	      var _this5 = this;
	
	      var fixedT = function fixedT(key, opts) {
	        var options;
	
	        if (_typeof__default['default'](opts) !== 'object') {
	          for (var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
	            rest[_key3 - 2] = arguments[_key3];
	          }
	
	          options = _this5.options.overloadTranslationOptionHandler([key, opts].concat(rest));
	        } else {
	          options = _objectSpread__default['default']({}, opts);
	        }
	
	        options.lng = options.lng || fixedT.lng;
	        options.lngs = options.lngs || fixedT.lngs;
	        options.ns = options.ns || fixedT.ns;
	        return _this5.t(key, options);
	      };
	
	      if (typeof lng === 'string') {
	        fixedT.lng = lng;
	      } else {
	        fixedT.lngs = lng;
	      }
	
	      fixedT.ns = ns;
	      return fixedT;
	    }
	  }, {
	    key: "t",
	    value: function t() {
	      var _this$translator;
	
	      return this.translator && (_this$translator = this.translator).translate.apply(_this$translator, arguments);
	    }
	  }, {
	    key: "exists",
	    value: function exists() {
	      var _this$translator2;
	
	      return this.translator && (_this$translator2 = this.translator).exists.apply(_this$translator2, arguments);
	    }
	  }, {
	    key: "setDefaultNamespace",
	    value: function setDefaultNamespace(ns) {
	      this.options.defaultNS = ns;
	    }
	  }, {
	    key: "hasLoadedNamespace",
	    value: function hasLoadedNamespace(ns) {
	      var _this6 = this;
	
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      if (!this.isInitialized) {
	        this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
	        return false;
	      }
	
	      if (!this.languages || !this.languages.length) {
	        this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
	        return false;
	      }
	
	      var lng = this.languages[0];
	      var fallbackLng = this.options ? this.options.fallbackLng : false;
	      var lastLng = this.languages[this.languages.length - 1];
	      if (lng.toLowerCase() === 'cimode') return true;
	
	      var loadNotPending = function loadNotPending(l, n) {
	        var loadState = _this6.services.backendConnector.state["".concat(l, "|").concat(n)];
	
	        return loadState === -1 || loadState === 2;
	      };
	
	      if (options.precheck) {
	        var preResult = options.precheck(this, loadNotPending);
	        if (preResult !== undefined) return preResult;
	      }
	
	      if (this.hasResourceBundle(lng, ns)) return true;
	      if (!this.services.backendConnector.backend) return true;
	      if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
	      return false;
	    }
	  }, {
	    key: "loadNamespaces",
	    value: function loadNamespaces(ns, callback) {
	      var _this7 = this;
	
	      var deferred = defer();
	
	      if (!this.options.ns) {
	        callback && callback();
	        return Promise.resolve();
	      }
	
	      if (typeof ns === 'string') ns = [ns];
	      ns.forEach(function (n) {
	        if (_this7.options.ns.indexOf(n) < 0) _this7.options.ns.push(n);
	      });
	      this.loadResources(function (err) {
	        deferred.resolve();
	        if (callback) callback(err);
	      });
	      return deferred;
	    }
	  }, {
	    key: "loadLanguages",
	    value: function loadLanguages(lngs, callback) {
	      var deferred = defer();
	      if (typeof lngs === 'string') lngs = [lngs];
	      var preloaded = this.options.preload || [];
	      var newLngs = lngs.filter(function (lng) {
	        return preloaded.indexOf(lng) < 0;
	      });
	
	      if (!newLngs.length) {
	        if (callback) callback();
	        return Promise.resolve();
	      }
	
	      this.options.preload = preloaded.concat(newLngs);
	      this.loadResources(function (err) {
	        deferred.resolve();
	        if (callback) callback(err);
	      });
	      return deferred;
	    }
	  }, {
	    key: "dir",
	    value: function dir(lng) {
	      if (!lng) lng = this.languages && this.languages.length > 0 ? this.languages[0] : this.language;
	      if (!lng) return 'rtl';
	      var rtlLngs = ['ar', 'shu', 'sqr', 'ssh', 'xaa', 'yhd', 'yud', 'aao', 'abh', 'abv', 'acm', 'acq', 'acw', 'acx', 'acy', 'adf', 'ads', 'aeb', 'aec', 'afb', 'ajp', 'apc', 'apd', 'arb', 'arq', 'ars', 'ary', 'arz', 'auz', 'avl', 'ayh', 'ayl', 'ayn', 'ayp', 'bbz', 'pga', 'he', 'iw', 'ps', 'pbt', 'pbu', 'pst', 'prp', 'prd', 'ug', 'ur', 'ydd', 'yds', 'yih', 'ji', 'yi', 'hbo', 'men', 'xmn', 'fa', 'jpr', 'peo', 'pes', 'prs', 'dv', 'sam'];
	      return rtlLngs.indexOf(this.services.languageUtils.getLanguagePartFromCode(lng)) >= 0 ? 'rtl' : 'ltr';
	    }
	  }, {
	    key: "createInstance",
	    value: function createInstance() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var callback = arguments.length > 1 ? arguments[1] : undefined;
	      return new I18n(options, callback);
	    }
	  }, {
	    key: "cloneInstance",
	    value: function cloneInstance() {
	      var _this8 = this;
	
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
	
	      var mergedOptions = _objectSpread__default['default']({}, this.options, options, {
	        isClone: true
	      });
	
	      var clone = new I18n(mergedOptions);
	      var membersToCopy = ['store', 'services', 'language'];
	      membersToCopy.forEach(function (m) {
	        clone[m] = _this8[m];
	      });
	      clone.services = _objectSpread__default['default']({}, this.services);
	      clone.services.utils = {
	        hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
	      };
	      clone.translator = new Translator(clone.services, clone.options);
	      clone.translator.on('*', function (event) {
	        for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
	          args[_key4 - 1] = arguments[_key4];
	        }
	
	        clone.emit.apply(clone, [event].concat(args));
	      });
	      clone.init(mergedOptions, callback);
	      clone.translator.options = clone.options;
	      clone.translator.backendConnector.services.utils = {
	        hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
	      };
	      return clone;
	    }
	  }]);
	
	  return I18n;
	}(EventEmitter);
	
	var i18next = new I18n();
	
	module.exports = i18next;


/***/ },
/* 2033 */
/***/ function(module, exports) {

	function n(n){for(var r=arguments.length,t=Array(r>1?r-1:0),e=1;e<r;e++)t[e-1]=arguments[e];throw Error("[Immer] minified error nr: "+n+(t.length?" "+t.map((function(n){return"'"+n+"'"})).join(","):"")+". Find the full error at: https://bit.ly/3cXEKWf")}function r(n){return!!n&&!!n[H]}function t(n){var r;return!!n&&(function(n){if(!n||"object"!=typeof n)return!1;var r=Object.getPrototypeOf(n);if(null===r)return!0;var t=Object.hasOwnProperty.call(r,"constructor")&&r.constructor;return t===Object||"function"==typeof t&&Function.toString.call(t)===Q}(n)||Array.isArray(n)||!!n[G]||!!(null===(r=n.constructor)||void 0===r?void 0:r[G])||c(n)||v(n))}function e(n,r,t){void 0===t&&(t=!1),0===i(n)?(t?Object.keys:T)(n).forEach((function(e){t&&"symbol"==typeof e||r(e,n[e],n)})):n.forEach((function(t,e){return r(e,t,n)}))}function i(n){var r=n[H];return r?r.t>3?r.t-4:r.t:Array.isArray(n)?1:c(n)?2:v(n)?3:0}function u(n,r){return 2===i(n)?n.has(r):Object.prototype.hasOwnProperty.call(n,r)}function o(n,r){return 2===i(n)?n.get(r):n[r]}function f(n,r,t){var e=i(n);2===e?n.set(r,t):3===e?n.add(t):n[r]=t}function a(n,r){return n===r?0!==n||1/n==1/r:n!=n&&r!=r}function c(n){return W&&n instanceof Map}function v(n){return X&&n instanceof Set}function s(n){return n.i||n.u}function p(n){if(Array.isArray(n))return Array.prototype.slice.call(n);var r=U(n);delete r[H];for(var t=T(r),e=0;e<t.length;e++){var i=t[e],u=r[i];!1===u.writable&&(u.writable=!0,u.configurable=!0),(u.get||u.set)&&(r[i]={configurable:!0,writable:!0,enumerable:u.enumerable,value:n[i]})}return Object.create(Object.getPrototypeOf(n),r)}function l(n,u){return void 0===u&&(u=!1),h(n)||r(n)||!t(n)||(i(n)>1&&(n.set=n.add=n.clear=n.delete=d),Object.freeze(n),u&&e(n,(function(n,r){return l(r,!0)}),!0)),n}function d(){n(2)}function h(n){return null==n||"object"!=typeof n||Object.isFrozen(n)}function y(r){var t=V[r];return t||n(18,r),t}function _(n,r){V[n]||(V[n]=r)}function b(){return I}function m(n,r){r&&(y("Patches"),n.o=[],n.v=[],n.s=r)}function j(n){O(n),n.p.forEach(w),n.p=null}function O(n){n===I&&(I=n.l)}function x(n){return I={p:[],l:I,h:n,_:!0,m:0}}function w(n){var r=n[H];0===r.t||1===r.t?r.j():r.O=!0}function S(r,e){e.m=e.p.length;var i=e.p[0],u=void 0!==r&&r!==i;return e.h.S||y("ES5").P(e,r,u),u?(i[H].g&&(j(e),n(4)),t(r)&&(r=P(e,r),e.l||M(e,r)),e.o&&y("Patches").M(i[H].u,r,e.o,e.v)):r=P(e,i,[]),j(e),e.o&&e.s(e.o,e.v),r!==B?r:void 0}function P(n,r,t){if(h(r))return r;var i=r[H];if(!i)return e(r,(function(e,u){return g(n,i,r,e,u,t)}),!0),r;if(i.A!==n)return r;if(!i.g)return M(n,i.u,!0),i.u;if(!i.R){i.R=!0,i.A.m--;var u=4===i.t||5===i.t?i.i=p(i.k):i.i,o=u,f=!1;3===i.t&&(o=new Set(u),u.clear(),f=!0),e(o,(function(r,e){return g(n,i,u,r,e,t,f)})),M(n,u,!1),t&&n.o&&y("Patches").F(i,t,n.o,n.v)}return i.i}function g(n,e,i,o,a,c,v){if(r(a)){var s=P(n,a,c&&e&&3!==e.t&&!u(e.N,o)?c.concat(o):void 0);if(f(i,o,s),!r(s))return;n._=!1}else v&&i.add(a);if(t(a)&&!h(a)){if(!n.h.D&&n.m<1)return;P(n,a),e&&e.A.l||M(n,a)}}function M(n,r,t){void 0===t&&(t=!1),!n.l&&n.h.D&&n._&&l(r,t)}function A(n,r){var t=n[H];return(t?s(t):n)[r]}function z(n,r){if(r in n)for(var t=Object.getPrototypeOf(n);t;){var e=Object.getOwnPropertyDescriptor(t,r);if(e)return e;t=Object.getPrototypeOf(t)}}function E(n){n.g||(n.g=!0,n.l&&E(n.l))}function R(n){n.i||(n.i=p(n.u))}function k(n,r,t){var e=c(r)?y("MapSet").K(r,t):v(r)?y("MapSet").$(r,t):n.S?function(n,r){var t=Array.isArray(n),e={t:t?1:0,A:r?r.A:b(),g:!1,R:!1,N:{},l:r,u:n,k:null,i:null,j:null,C:!1},i=e,u=Y;t&&(i=[e],u=Z);var o=Proxy.revocable(i,u),f=o.revoke,a=o.proxy;return e.k=a,e.j=f,a}(r,t):y("ES5").I(r,t);return(t?t.A:b()).p.push(e),e}function F(u){return r(u)||n(22,u),function n(r){if(!t(r))return r;var u,a=r[H],c=i(r);if(a){if(!a.g&&(a.t<4||!y("ES5").J(a)))return a.u;a.R=!0,u=N(r,c),a.R=!1}else u=N(r,c);return e(u,(function(r,t){a&&o(a.u,r)===t||f(u,r,n(t))})),3===c?new Set(u):u}(u)}function N(n,r){switch(r){case 2:return new Map(n);case 3:return Array.from(n)}return p(n)}function D(){function n(n,r){var t=f[n];return t?t.enumerable=r:f[n]=t={configurable:!0,enumerable:r,get:function(){return Y.get(this[H],n)},set:function(r){Y.set(this[H],n,r)}},t}function t(n){for(var r=n.length-1;r>=0;r--){var t=n[r][H];if(!t.g)switch(t.t){case 5:o(t)&&E(t);break;case 4:i(t)&&E(t)}}}function i(n){for(var r=n.u,t=n.k,e=T(t),i=e.length-1;i>=0;i--){var o=e[i];if(o!==H){var f=r[o];if(void 0===f&&!u(r,o))return!0;var c=t[o],v=c&&c[H];if(v?v.u!==f:!a(c,f))return!0}}var s=!!r[H];return e.length!==T(r).length+(s?0:1)}function o(n){var r=n.k;if(r.length!==n.u.length)return!0;var t=Object.getOwnPropertyDescriptor(r,r.length-1);if(t&&!t.get)return!0;for(var e=0;e<r.length;e++)if(!r.hasOwnProperty(e))return!0;return!1}var f={};_("ES5",{I:function(r,t){var e=Array.isArray(r),i=function(r,t){if(r){for(var e=Array(t.length),i=0;i<t.length;i++)Object.defineProperty(e,""+i,n(i,!0));return e}var u=U(t);delete u[H];for(var o=T(u),f=0;f<o.length;f++){var a=o[f];u[a]=n(a,r||!!u[a].enumerable)}return Object.create(Object.getPrototypeOf(t),u)}(e,r),u={t:e?5:4,A:t?t.A:b(),g:!1,R:!1,N:{},l:t,u:r,k:i,i:null,O:!1,C:!1};return Object.defineProperty(i,H,{value:u,writable:!0}),i},P:function(n,i,f){f?r(i)&&i[H].A===n&&t(n.p):(n.o&&function n(r){if(r&&"object"==typeof r){var t=r[H];if(t){var i=t.u,f=t.k,a=t.N,c=t.t;if(4===c)e(f,(function(r){r!==H&&(void 0!==i[r]||u(i,r)?a[r]||n(f[r]):(a[r]=!0,E(t)))})),e(i,(function(n){void 0!==f[n]||u(f,n)||(a[n]=!1,E(t))}));else if(5===c){if(o(t)&&(E(t),a.length=!0),f.length<i.length)for(var v=f.length;v<i.length;v++)a[v]=!1;else for(var s=i.length;s<f.length;s++)a[s]=!0;for(var p=Math.min(f.length,i.length),l=0;l<p;l++)f.hasOwnProperty(l)||(a[l]=!0),void 0===a[l]&&n(f[l])}}}}(n.p[0]),t(n.p))},J:function(n){return 4===n.t?i(n):o(n)}})}function K(){function f(n){if(!t(n))return n;if(Array.isArray(n))return n.map(f);if(c(n))return new Map(Array.from(n.entries()).map((function(n){return[n[0],f(n[1])]})));if(v(n))return new Set(Array.from(n).map(f));var r=Object.create(Object.getPrototypeOf(n));for(var e in n)r[e]=f(n[e]);return u(n,G)&&(r[G]=n[G]),r}function a(n){return r(n)?f(n):n}var s="add";_("Patches",{W:function(r,t){return t.forEach((function(t){for(var e=t.path,u=t.op,a=r,c=0;c<e.length-1;c++){var v=i(a),p=e[c];"string"!=typeof p&&"number"!=typeof p&&(p=""+p),0!==v&&1!==v||"__proto__"!==p&&"constructor"!==p||n(24),"function"==typeof a&&"prototype"===p&&n(24),"object"!=typeof(a=o(a,p))&&n(15,e.join("/"))}var l=i(a),d=f(t.value),h=e[e.length-1];switch(u){case"replace":switch(l){case 2:return a.set(h,d);case 3:n(16);default:return a[h]=d}case s:switch(l){case 1:return"-"===h?a.push(d):a.splice(h,0,d);case 2:return a.set(h,d);case 3:return a.add(d);default:return a[h]=d}case"remove":switch(l){case 1:return a.splice(h,1);case 2:return a.delete(h);case 3:return a.delete(t.value);default:return delete a[h]}default:n(17,u)}})),r},F:function(n,r,t,i){switch(n.t){case 0:case 4:case 2:return function(n,r,t,i){var f=n.u,c=n.i;e(n.N,(function(n,e){var v=o(f,n),p=o(c,n),l=e?u(f,n)?"replace":s:"remove";if(v!==p||"replace"!==l){var d=r.concat(n);t.push("remove"===l?{op:l,path:d}:{op:l,path:d,value:p}),i.push(l===s?{op:"remove",path:d}:"remove"===l?{op:s,path:d,value:a(v)}:{op:"replace",path:d,value:a(v)})}}))}(n,r,t,i);case 5:case 1:return function(n,r,t,e){var i=n.u,u=n.N,o=n.i;if(o.length<i.length){var f=[o,i];i=f[0],o=f[1];var c=[e,t];t=c[0],e=c[1]}for(var v=0;v<i.length;v++)if(u[v]&&o[v]!==i[v]){var p=r.concat([v]);t.push({op:"replace",path:p,value:a(o[v])}),e.push({op:"replace",path:p,value:a(i[v])})}for(var l=i.length;l<o.length;l++){var d=r.concat([l]);t.push({op:s,path:d,value:a(o[l])})}i.length<o.length&&e.push({op:"replace",path:r.concat(["length"]),value:i.length})}(n,r,t,i);case 3:return function(n,r,t,e){var i=n.u,u=n.i,o=0;i.forEach((function(n){if(!u.has(n)){var i=r.concat([o]);t.push({op:"remove",path:i,value:n}),e.unshift({op:s,path:i,value:n})}o++})),o=0,u.forEach((function(n){if(!i.has(n)){var u=r.concat([o]);t.push({op:s,path:u,value:n}),e.unshift({op:"remove",path:u,value:n})}o++}))}(n,r,t,i)}},M:function(n,r,t,e){t.push({op:"replace",path:[],value:r===B?void 0:r}),e.push({op:"replace",path:[],value:n})}})}function $(){function r(n,r){function t(){this.constructor=n}f(n,r),n.prototype=(t.prototype=r.prototype,new t)}function i(n){n.i||(n.N=new Map,n.i=new Map(n.u))}function u(n){n.i||(n.i=new Set,n.u.forEach((function(r){if(t(r)){var e=k(n.A.h,r,n);n.p.set(r,e),n.i.add(e)}else n.i.add(r)})))}function o(r){r.O&&n(3,JSON.stringify(s(r)))}var f=function(n,r){return(f=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(n,r){n.__proto__=r}||function(n,r){for(var t in r)r.hasOwnProperty(t)&&(n[t]=r[t])})(n,r)},a=function(){function n(n,r){return this[H]={t:2,l:r,A:r?r.A:b(),g:!1,R:!1,i:void 0,N:void 0,u:n,k:this,C:!1,O:!1},this}r(n,Map);var u=n.prototype;return Object.defineProperty(u,"size",{get:function(){return s(this[H]).size}}),u.has=function(n){return s(this[H]).has(n)},u.set=function(n,r){var t=this[H];return o(t),s(t).has(n)&&s(t).get(n)===r||(i(t),E(t),t.N.set(n,!0),t.i.set(n,r),t.N.set(n,!0)),this},u.delete=function(n){if(!this.has(n))return!1;var r=this[H];return o(r),i(r),E(r),r.u.has(n)?r.N.set(n,!1):r.N.delete(n),r.i.delete(n),!0},u.clear=function(){var n=this[H];o(n),s(n).size&&(i(n),E(n),n.N=new Map,e(n.u,(function(r){n.N.set(r,!1)})),n.i.clear())},u.forEach=function(n,r){var t=this;s(this[H]).forEach((function(e,i){n.call(r,t.get(i),i,t)}))},u.get=function(n){var r=this[H];o(r);var e=s(r).get(n);if(r.R||!t(e))return e;if(e!==r.u.get(n))return e;var u=k(r.A.h,e,r);return i(r),r.i.set(n,u),u},u.keys=function(){return s(this[H]).keys()},u.values=function(){var n,r=this,t=this.keys();return(n={})[L]=function(){return r.values()},n.next=function(){var n=t.next();return n.done?n:{done:!1,value:r.get(n.value)}},n},u.entries=function(){var n,r=this,t=this.keys();return(n={})[L]=function(){return r.entries()},n.next=function(){var n=t.next();if(n.done)return n;var e=r.get(n.value);return{done:!1,value:[n.value,e]}},n},u[L]=function(){return this.entries()},n}(),c=function(){function n(n,r){return this[H]={t:3,l:r,A:r?r.A:b(),g:!1,R:!1,i:void 0,u:n,k:this,p:new Map,O:!1,C:!1},this}r(n,Set);var t=n.prototype;return Object.defineProperty(t,"size",{get:function(){return s(this[H]).size}}),t.has=function(n){var r=this[H];return o(r),r.i?!!r.i.has(n)||!(!r.p.has(n)||!r.i.has(r.p.get(n))):r.u.has(n)},t.add=function(n){var r=this[H];return o(r),this.has(n)||(u(r),E(r),r.i.add(n)),this},t.delete=function(n){if(!this.has(n))return!1;var r=this[H];return o(r),u(r),E(r),r.i.delete(n)||!!r.p.has(n)&&r.i.delete(r.p.get(n))},t.clear=function(){var n=this[H];o(n),s(n).size&&(u(n),E(n),n.i.clear())},t.values=function(){var n=this[H];return o(n),u(n),n.i.values()},t.entries=function(){var n=this[H];return o(n),u(n),n.i.entries()},t.keys=function(){return this.values()},t[L]=function(){return this.values()},t.forEach=function(n,r){for(var t=this.values(),e=t.next();!e.done;)n.call(r,e.value,e.value,this),e=t.next()},n}();_("MapSet",{K:function(n,r){return new a(n,r)},$:function(n,r){return new c(n,r)}})}var C;Object.defineProperty(exports,"__esModule",{value:!0});var I,J="undefined"!=typeof Symbol&&"symbol"==typeof Symbol("x"),W="undefined"!=typeof Map,X="undefined"!=typeof Set,q="undefined"!=typeof Proxy&&void 0!==Proxy.revocable&&"undefined"!=typeof Reflect,B=J?Symbol.for("immer-nothing"):((C={})["immer-nothing"]=!0,C),G=J?Symbol.for("immer-draftable"):"__$immer_draftable",H=J?Symbol.for("immer-state"):"__$immer_state",L="undefined"!=typeof Symbol&&Symbol.iterator||"@@iterator",Q=""+Object.prototype.constructor,T="undefined"!=typeof Reflect&&Reflect.ownKeys?Reflect.ownKeys:void 0!==Object.getOwnPropertySymbols?function(n){return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n))}:Object.getOwnPropertyNames,U=Object.getOwnPropertyDescriptors||function(n){var r={};return T(n).forEach((function(t){r[t]=Object.getOwnPropertyDescriptor(n,t)})),r},V={},Y={get:function(n,r){if(r===H)return n;var e=s(n);if(!u(e,r))return function(n,r,t){var e,i=z(r,t);return i?"value"in i?i.value:null===(e=i.get)||void 0===e?void 0:e.call(n.k):void 0}(n,e,r);var i=e[r];return n.R||!t(i)?i:i===A(n.u,r)?(R(n),n.i[r]=k(n.A.h,i,n)):i},has:function(n,r){return r in s(n)},ownKeys:function(n){return Reflect.ownKeys(s(n))},set:function(n,r,t){var e=z(s(n),r);if(null==e?void 0:e.set)return e.set.call(n.k,t),!0;if(!n.g){var i=A(s(n),r),o=null==i?void 0:i[H];if(o&&o.u===t)return n.i[r]=t,n.N[r]=!1,!0;if(a(t,i)&&(void 0!==t||u(n.u,r)))return!0;R(n),E(n)}return n.i[r]===t&&(void 0!==t||r in n.i)||Number.isNaN(t)&&Number.isNaN(n.i[r])||(n.i[r]=t,n.N[r]=!0),!0},deleteProperty:function(n,r){return void 0!==A(n.u,r)||r in n.u?(n.N[r]=!1,R(n),E(n)):delete n.N[r],n.i&&delete n.i[r],!0},getOwnPropertyDescriptor:function(n,r){var t=s(n),e=Reflect.getOwnPropertyDescriptor(t,r);return e?{writable:!0,configurable:1!==n.t||"length"!==r,enumerable:e.enumerable,value:t[r]}:e},defineProperty:function(){n(11)},getPrototypeOf:function(n){return Object.getPrototypeOf(n.u)},setPrototypeOf:function(){n(12)}},Z={};e(Y,(function(n,r){Z[n]=function(){return arguments[0]=arguments[0][0],r.apply(this,arguments)}})),Z.deleteProperty=function(n,r){return Z.set.call(this,n,r,void 0)},Z.set=function(n,r,t){return Y.set.call(this,n[0],r,t,n[0])};var nn=function(){function e(r){var e=this;this.S=q,this.D=!0,this.produce=function(r,i,u){if("function"==typeof r&&"function"!=typeof i){var o=i;i=r;var f=e;return function(n){var r=this;void 0===n&&(n=o);for(var t=arguments.length,e=Array(t>1?t-1:0),u=1;u<t;u++)e[u-1]=arguments[u];return f.produce(n,(function(n){var t;return(t=i).call.apply(t,[r,n].concat(e))}))}}var a;if("function"!=typeof i&&n(6),void 0!==u&&"function"!=typeof u&&n(7),t(r)){var c=x(e),v=k(e,r,void 0),s=!0;try{a=i(v),s=!1}finally{s?j(c):O(c)}return"undefined"!=typeof Promise&&a instanceof Promise?a.then((function(n){return m(c,u),S(n,c)}),(function(n){throw j(c),n})):(m(c,u),S(a,c))}if(!r||"object"!=typeof r){if(void 0===(a=i(r))&&(a=r),a===B&&(a=void 0),e.D&&l(a,!0),u){var p=[],d=[];y("Patches").M(r,a,p,d),u(p,d)}return a}n(21,r)},this.produceWithPatches=function(n,r){if("function"==typeof n)return function(r){for(var t=arguments.length,i=Array(t>1?t-1:0),u=1;u<t;u++)i[u-1]=arguments[u];return e.produceWithPatches(r,(function(r){return n.apply(void 0,[r].concat(i))}))};var t,i,u=e.produce(n,r,(function(n,r){t=n,i=r}));return"undefined"!=typeof Promise&&u instanceof Promise?u.then((function(n){return[n,t,i]})):[u,t,i]},"boolean"==typeof(null==r?void 0:r.useProxies)&&this.setUseProxies(r.useProxies),"boolean"==typeof(null==r?void 0:r.autoFreeze)&&this.setAutoFreeze(r.autoFreeze)}var i=e.prototype;return i.createDraft=function(e){t(e)||n(8),r(e)&&(e=F(e));var i=x(this),u=k(this,e,void 0);return u[H].C=!0,O(i),u},i.finishDraft=function(n,r){var t=(n&&n[H]).A;return m(t,r),S(void 0,t)},i.setAutoFreeze=function(n){this.D=n},i.setUseProxies=function(r){r&&!q&&n(20),this.S=r},i.applyPatches=function(n,t){var e;for(e=t.length-1;e>=0;e--){var i=t[e];if(0===i.path.length&&"replace"===i.op){n=i.value;break}}e>-1&&(t=t.slice(e+1));var u=y("Patches").W;return r(n)?u(n,t):this.produce(n,(function(n){return u(n,t)}))},e}(),rn=new nn,tn=rn.produce,en=rn.produceWithPatches.bind(rn),un=rn.setAutoFreeze.bind(rn),on=rn.setUseProxies.bind(rn),fn=rn.applyPatches.bind(rn),an=rn.createDraft.bind(rn),cn=rn.finishDraft.bind(rn);exports.Immer=nn,exports.applyPatches=fn,exports.castDraft=function(n){return n},exports.castImmutable=function(n){return n},exports.createDraft=an,exports.current=F,exports.default=tn,exports.enableAllPlugins=function(){D(),$(),K()},exports.enableES5=D,exports.enableMapSet=$,exports.enablePatches=K,exports.finishDraft=cn,exports.freeze=l,exports.immerable=G,exports.isDraft=r,exports.isDraftable=t,exports.nothing=B,exports.original=function(t){return r(t)||n(23,t),t[H].u},exports.produce=tn,exports.produceWithPatches=en,exports.setAutoFreeze=un,exports.setUseProxies=on;
	//# sourceMappingURL=immer.cjs.production.min.js.map


/***/ },
/* 2034 */
/***/ function(module, exports, __webpack_require__) {

	
	'use strict'
	
	if (true) {
	  module.exports = __webpack_require__(2033)
	} else {
	  module.exports = require('./immer.cjs.development.js')
	}


/***/ },
/* 2035 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var hasToStringTag = __webpack_require__(431)();
	var callBound = __webpack_require__(520);
	
	var $toString = callBound('Object.prototype.toString');
	
	var isStandardArguments = function isArguments(value) {
		if (hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) {
			return false;
		}
		return $toString(value) === '[object Arguments]';
	};
	
	var isLegacyArguments = function isArguments(value) {
		if (isStandardArguments(value)) {
			return true;
		}
		return value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			$toString(value) !== '[object Array]' &&
			$toString(value.callee) === '[object Function]';
	};
	
	var supportsStandardArguments = (function () {
		return isStandardArguments(arguments);
	}());
	
	isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests
	
	module.exports = supportsStandardArguments ? isStandardArguments : isLegacyArguments;


/***/ },
/* 2036 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var getDay = Date.prototype.getDay;
	var tryDateObject = function tryDateGetDayCall(value) {
		try {
			getDay.call(value);
			return true;
		} catch (e) {
			return false;
		}
	};
	
	var toStr = Object.prototype.toString;
	var dateClass = '[object Date]';
	var hasToStringTag = __webpack_require__(431)();
	
	module.exports = function isDateObject(value) {
		if (typeof value !== 'object' || value === null) {
			return false;
		}
		return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
	};


/***/ },
/* 2037 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	/**
	 * Constants.
	 */
	
	var IS_MAC = typeof window != 'undefined' && /Mac|iPod|iPhone|iPad/.test(window.navigator.platform);
	
	var MODIFIERS = {
	  alt: 'altKey',
	  control: 'ctrlKey',
	  meta: 'metaKey',
	  shift: 'shiftKey'
	};
	
	var ALIASES = {
	  add: '+',
	  break: 'pause',
	  cmd: 'meta',
	  command: 'meta',
	  ctl: 'control',
	  ctrl: 'control',
	  del: 'delete',
	  down: 'arrowdown',
	  esc: 'escape',
	  ins: 'insert',
	  left: 'arrowleft',
	  mod: IS_MAC ? 'meta' : 'control',
	  opt: 'alt',
	  option: 'alt',
	  return: 'enter',
	  right: 'arrowright',
	  space: ' ',
	  spacebar: ' ',
	  up: 'arrowup',
	  win: 'meta',
	  windows: 'meta'
	};
	
	var CODES = {
	  backspace: 8,
	  tab: 9,
	  enter: 13,
	  shift: 16,
	  control: 17,
	  alt: 18,
	  pause: 19,
	  capslock: 20,
	  escape: 27,
	  ' ': 32,
	  pageup: 33,
	  pagedown: 34,
	  end: 35,
	  home: 36,
	  arrowleft: 37,
	  arrowup: 38,
	  arrowright: 39,
	  arrowdown: 40,
	  insert: 45,
	  delete: 46,
	  meta: 91,
	  numlock: 144,
	  scrolllock: 145,
	  ';': 186,
	  '=': 187,
	  ',': 188,
	  '-': 189,
	  '.': 190,
	  '/': 191,
	  '`': 192,
	  '[': 219,
	  '\\': 220,
	  ']': 221,
	  '\'': 222
	};
	
	for (var f = 1; f < 20; f++) {
	  CODES['f' + f] = 111 + f;
	}
	
	/**
	 * Is hotkey?
	 */
	
	function isHotkey(hotkey, options, event) {
	  if (options && !('byKey' in options)) {
	    event = options;
	    options = null;
	  }
	
	  if (!Array.isArray(hotkey)) {
	    hotkey = [hotkey];
	  }
	
	  var array = hotkey.map(function (string) {
	    return parseHotkey(string, options);
	  });
	  var check = function check(e) {
	    return array.some(function (object) {
	      return compareHotkey(object, e);
	    });
	  };
	  var ret = event == null ? check : check(event);
	  return ret;
	}
	
	function isCodeHotkey(hotkey, event) {
	  return isHotkey(hotkey, event);
	}
	
	function isKeyHotkey(hotkey, event) {
	  return isHotkey(hotkey, { byKey: true }, event);
	}
	
	/**
	 * Parse.
	 */
	
	function parseHotkey(hotkey, options) {
	  var byKey = options && options.byKey;
	  var ret = {};
	
	  // Special case to handle the `+` key since we use it as a separator.
	  hotkey = hotkey.replace('++', '+add');
	  var values = hotkey.split('+');
	  var length = values.length;
	
	  // Ensure that all the modifiers are set to false unless the hotkey has them.
	
	  for (var k in MODIFIERS) {
	    ret[MODIFIERS[k]] = false;
	  }
	
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var value = _step.value;
	
	      var optional = value.endsWith('?') && value.length > 1;
	
	      if (optional) {
	        value = value.slice(0, -1);
	      }
	
	      var name = toKeyName(value);
	      var modifier = MODIFIERS[name];
	
	      if (length === 1 || !modifier) {
	        if (byKey) {
	          ret.key = name;
	        } else {
	          ret.which = toKeyCode(value);
	        }
	      }
	
	      if (modifier) {
	        ret[modifier] = optional ? null : true;
	      }
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  return ret;
	}
	
	/**
	 * Compare.
	 */
	
	function compareHotkey(object, event) {
	  for (var key in object) {
	    var expected = object[key];
	    var actual = void 0;
	
	    if (expected == null) {
	      continue;
	    }
	
	    if (key === 'key' && event.key != null) {
	      actual = event.key.toLowerCase();
	    } else if (key === 'which') {
	      actual = expected === 91 && event.which === 93 ? 91 : event.which;
	    } else {
	      actual = event[key];
	    }
	
	    if (actual == null && expected === false) {
	      continue;
	    }
	
	    if (actual !== expected) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	/**
	 * Utils.
	 */
	
	function toKeyCode(name) {
	  name = toKeyName(name);
	  var code = CODES[name] || name.toUpperCase().charCodeAt(0);
	  return code;
	}
	
	function toKeyName(name) {
	  name = name.toLowerCase();
	  name = ALIASES[name] || name;
	  return name;
	}
	
	/**
	 * Export.
	 */
	
	exports.default = isHotkey;
	exports.isHotkey = isHotkey;
	exports.isCodeHotkey = isCodeHotkey;
	exports.isKeyHotkey = isKeyHotkey;
	exports.parseHotkey = parseHotkey;
	exports.compareHotkey = compareHotkey;
	exports.toKeyCode = toKeyCode;
	exports.toKeyName = toKeyName;

/***/ },
/* 2038 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/*!
	 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
	 *
	 * Copyright (c) 2014-2017, Jon Schlinkert.
	 * Released under the MIT License.
	 */
	
	function isObject(o) {
	  return Object.prototype.toString.call(o) === '[object Object]';
	}
	
	function isPlainObject(o) {
	  var ctor,prot;
	
	  if (isObject(o) === false) return false;
	
	  // If has modified constructor
	  ctor = o.constructor;
	  if (ctor === undefined) return true;
	
	  // If has modified prototype
	  prot = ctor.prototype;
	  if (isObject(prot) === false) return false;
	
	  // If constructor does not have an Object-specific method
	  if (prot.hasOwnProperty('isPrototypeOf') === false) {
	    return false;
	  }
	
	  // Most likely a plain Object
	  return true;
	}
	
	exports.isPlainObject = isPlainObject;


/***/ },
/* 2039 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var callBound = __webpack_require__(520);
	var hasToStringTag = __webpack_require__(431)();
	var has;
	var $exec;
	var isRegexMarker;
	var badStringifier;
	
	if (hasToStringTag) {
		has = callBound('Object.prototype.hasOwnProperty');
		$exec = callBound('RegExp.prototype.exec');
		isRegexMarker = {};
	
		var throwRegexMarker = function () {
			throw isRegexMarker;
		};
		badStringifier = {
			toString: throwRegexMarker,
			valueOf: throwRegexMarker
		};
	
		if (typeof Symbol.toPrimitive === 'symbol') {
			badStringifier[Symbol.toPrimitive] = throwRegexMarker;
		}
	}
	
	var $toString = callBound('Object.prototype.toString');
	var gOPD = Object.getOwnPropertyDescriptor;
	var regexClass = '[object RegExp]';
	
	module.exports = hasToStringTag
		// eslint-disable-next-line consistent-return
		? function isRegex(value) {
			if (!value || typeof value !== 'object') {
				return false;
			}
	
			var descriptor = gOPD(value, 'lastIndex');
			var hasLastIndexDataProperty = descriptor && has(descriptor, 'value');
			if (!hasLastIndexDataProperty) {
				return false;
			}
	
			try {
				$exec(value, badStringifier);
			} catch (e) {
				return e === isRegexMarker;
			}
		}
		: function isRegex(value) {
			// In older browsers, typeof regex incorrectly returns 'function'
			if (!value || (typeof value !== 'object' && typeof value !== 'function')) {
				return false;
			}
	
			return $toString(value) === regexClass;
		};


/***/ },
/* 2040 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ },
/* 2041 */
/***/ function(module, exports) {

	module.exports = {
		"en": {
			"commons": {
				"types": {
					"HOME": "All",
					"TWITTER": "Twitter",
					"CHAT": "Chat",
					"MAIL": "Email",
					"WHATSAPP": "WhatsApp",
					"MESSENGER": "Messenger",
					"TELEGRAM": "Telegram"
				},
				"ok": "OK",
				"cancel": "Cancel",
				"new-convo": "(new conversation)",
				"no-subject": "(no subject)",
				"admin": "Administrator",
				"reply": "Reply",
				"downloadzip": "Download zip file",
				"media": "Channel"
			},
			"list": {
				"no-conv": "No conversations to show"
			},
			"header": {
				"time": "Conversation time",
				"finish": {
					"action": "Finish conversation",
					"title": "Finish conversation",
					"content": "Are you sure you want to complete this operation? The conversation will be terminated and deleted.",
					"commit": "Finish"
				},
				"unassign": {
					"action": "Unassign conversation",
					"title": "Unassign conversation",
					"content": "Are you sure you want to complete this operation? The conversation will be removed from your inbox and assigned to a different agent.",
					"commit": "Unassign"
				},
				"spam": {
					"action": "Mark email as spam",
					"title": "Mark email as spam",
					"content": "Are you sure you want to complete this operation? The email will be removed from your inbox and the sender will be blocked.",
					"commit": "Mark"
				},
				"discard": {
					"action": "Discard conversation",
					"title": "Discard conversation",
					"content": "Are you sure you want to complete this operation? The conversation will be deleted and you won’t be able to recover it.",
					"commit": "Discard"
				},
				"wrapup": {
					"action": "Disposition conversation"
				},
				"view-contact": {
					"action": "View contact"
				}
			},
			"wrapup": {
				"title": "Wrap-up time",
				"select": "Save",
				"placeholder": "Select disposition",
				"placeholderSub": "Select sub-disposition",
				"end": "Finish",
				"endconversation": "Finish conversation"
			},
			"chat": {
				"no-messages": "No messages have been received yet. Wait a moment or start the conversation now.",
				"disabled": "The Administrator has disabled this conversation. You can't send or receive messages.",
				"response-placeholder": "Type your message here. ",
				"search-placeholder": "Search",
				"templates": "Templates",
				"delivered": "Delivered",
				"read": "Read",
				"can-see": "Contact can see this message",
				"cant-see": "Contact can't see this message",
				"send-enter": "Press Enter to send.",
				"newline-enter": "Press Shift + Enter to insert a line break.",
				"greetings": {
					"morning": "Good morning",
					"afternoon": "Good afternoon",
					"night": "Good evening"
				},
				"time": "[Time]",
				"drop-file": "Drop files here to attach",
				"loading": "Attaching",
				"divider-yesterday": "Yesterday",
				"divider-today": "Today",
				"loading-messsages": "Loading messages",
				"errorSize": {
					"attachErrorTitleSingle": "Unable to attach file",
					"attachErrorSingle": "Maximum file size allowed is 16 MB.",
					"attachErrorSingleWhatsapp": "Maximum file size allowed is 64 MB.",
					"attachErrorTitleMultiple": "Unable to attach files",
					"attachErrorMultiple": "Maximum size per file is 16 MB.",
					"attachErrorMultipleWhatsapp": "Maximum size per file is 64 MB.",
					"attachErrorCommit": "Close"
				},
				"errorFormat": {
					"attachErrorTitleSingle": "Unable to attach file",
					"attachErrorTitleMultiple": "Unable to attach files",
					"attachErrorMessage": "Invalid format. Supported formats are JPG, PNG, BMP, and GIF.",
					"attachErrorMessageWhatsapp": "Invalid format. Try using another image, audio, video, or document file extension.",
					"attachErrorCommit": "Close"
				}
			},
			"whatsapp": {
				"unsupported": "Content not supported",
				"notAvailable": "Content not available",
				"rejectedMessage": "Rejected by Meta",
				"unsupported-sticker": "This is a sticker, it can't be visualized.",
				"image": "Image",
				"video": "Video",
				"audio": "Audio",
				"file": "File"
			},
			"mail-editor": {
				"cc": "CC",
				"bcc": "BCC",
				"add-cc": "Add Cc recipients",
				"add-bcc": "Add Bcc recipients",
				"show-quoted": "Show trimmed content",
				"from": "From",
				"sent": "Sent",
				"to": "To",
				"subject": "Subject",
				"send": "Send",
				"format": "Formatting options",
				"attach": "Attach files",
				"link": "Insert link",
				"discard": "Discard",
				"drop-files": "Drop files here.",
				"invalid-size": "File cannot exceed 10MB",
				"unsafe-file": "Blocked for security reasons",
				"sending": "Sending email...",
				"openlink": "Open link",
				"change": "Change",
				"delete": "Remove"
			},
			"links-modal": {
				"title": "Insert link",
				"label-text": "Text to display",
				"label-url": "Web address (URL)",
				"insert": "Insert",
				"text-error": "Format error",
				"url-error": "Invalid URL"
			},
			"media-viewer": {
				"download": "Download",
				"back": "Back",
				"no-preview": "No preview available"
			},
			"new-message-bar": {
				"spam": "Mark as spam",
				"reply": "Reply",
				"unassign": "Unassign"
			},
			"contact-info": {
				"title": "Contact information",
				"phone": "Phone number",
				"data": "Additional data",
				"unassign": "Unassign conversation",
				"finish": "Finish conversation"
			}
		},
		"es": {
			"commons": {
				"types": {
					"HOME": "Todos",
					"TWITTER": "Twitter",
					"CHAT": "Chat",
					"MAIL": "Correo electrónico",
					"WHATSAPP": "WhatsApp",
					"MESSENGER": "Messenger",
					"TELEGRAM": "Telegram"
				},
				"ok": "Aceptar",
				"cancel": "Cancelar",
				"new-convo": "(nueva conversación)",
				"no-subject": "(sin asunto)",
				"admin": "Administrador",
				"reply": "Responder",
				"downloadzip": "Descargar archivo zip",
				"media": "Canal"
			},
			"list": {
				"no-conv": "No hay conversaciones para mostrar"
			},
			"header": {
				"time": "Tiempo de conversación",
				"finish": {
					"action": "Terminar conversación",
					"title": "Terminar conversación",
					"content": "¿Está seguro de que desea realizar esta operación? La conversación se cerrará y se eliminará.",
					"commit": "Terminar"
				},
				"unassign": {
					"action": "Desasignar conversación",
					"title": "Desasignar conversación",
					"content": "¿Está seguro de que desea realizar esta operación? La conversación desaparecerá de su bandeja de entrada y será asignada a otro agente.",
					"commit": "Desasignar"
				},
				"spam": {
					"action": "Marcar correo como no deseado",
					"title": "Marcar correo como no deseado",
					"content": "¿Está seguro de que desea realizar esta operación? El correo desaparecerá de su bandeja de entrada y el remitente será bloqueado.",
					"commit": "Marcar"
				},
				"discard": {
					"action": "Descartar conversación",
					"title": "Descartar conversación",
					"content": "¿Está seguro de que desea realizar esta operación? La conversación se eliminará y no podrá recuperarla.",
					"commit": "Descartar"
				},
				"wrapup": {
					"action": "Calificar conversación"
				},
				"view-contact": {
					"action": "Ver contacto"
				}
			},
			"wrapup": {
				"title": "Tiempo de notas",
				"select": "Guardar",
				"placeholder": "Seleccione una calificación",
				"placeholderSub": "Seleccione una sub calificación",
				"end": "Terminar",
				"endconversation": "Terminar conversación"
			},
			"chat": {
				"no-messages": "No se han recibido mensajes aún. Espere un momento o inicie la conversación ahora. ",
				"disabled": "El administrador ha deshabilitado la conversación. No puede enviar o recibir mensajes.",
				"response-placeholder": "Escriba su mensaje aquí.",
				"search-placeholder": "Buscar",
				"templates": "Plantillas",
				"delivered": "Entregado",
				"read": "Leído",
				"can-see": "El contacto puede ver este mensaje.",
				"cant-see": "El contacto no puede ver este mensaje.",
				"send-enter": "Presiona Entrar para enviar.",
				"newline-enter": "Presiona Mayús + Entrar para agregar un salto de línea.",
				"greetings": {
					"morning": "Buenos días",
					"afternoon": "Buenas tardes",
					"night": "Buenas noches"
				},
				"time": "[Hora]",
				"drop-file": "Suelte los archivos aquí para adjuntar",
				"loading": "Adjuntando",
				"divider-yesterday": "Ayer",
				"divider-today": "Hoy",
				"loading-messsages": "Cargando mensajes",
				"errorSize": {
					"attachErrorTitleSingle": "Error al adjuntar archivo",
					"attachErrorSingle": "El límite de tamaño permitido es de 16 MB.",
					"attachErrorSingleWhatsapp": "El límite de tamaño permitido es de 64 MB.",
					"attachErrorTitleMultiple": "Error al adjuntar archivos",
					"attachErrorMultiple": "El límite de tamaño por archivo es de 16 MB.",
					"attachErrorMultipleWhatsapp": "El límite de tamaño por archivo es de 64 MB.",
					"attachErrorCommit": "Cerrar"
				},
				"errorFormat": {
					"attachErrorTitleSingle": "Error al adjuntar archivo",
					"attachErrorTitleMultiple": "Error al adjuntar archivos",
					"attachErrorMessage": "Formato inválido. Los formatos soportados son JPG, PNG, BMP y GIF.",
					"attachErrorMessageWhatsapp": "Formato inválido. Intente con otra extensión de archivo de imagen, audio, video o documento.",
					"attachErrorCommit": "Cerrar"
				}
			},
			"whatsapp": {
				"unsupported": "Contenido no soportado",
				"notAvailable": "Contenido no disponible",
				"rejectedMessage": "Rechazado por Meta",
				"unsupported-sticker": "Este es un sticker, no se puede ver.",
				"image": "Imagen",
				"video": "Video",
				"audio": "Audio",
				"file": "Archivo"
			},
			"mail-editor": {
				"cc": "CC",
				"bcc": "CCO",
				"add-cc": "Agregar destinatarios a Cc",
				"add-bcc": "Agregar destinatarios a Cco",
				"show-quoted": "Mostrar contenido recortado",
				"from": "De",
				"sent": "Enviado",
				"to": "Para",
				"subject": "Asunto",
				"send": "Enviar",
				"format": "Opciones de formato",
				"attach": "Adjuntar archivos",
				"link": "Insertar vínculo",
				"discard": "Descartar",
				"drop-files": "Suelte los archivos aquí.",
				"invalid-size": "El archivo no puede superar los 10MB",
				"unsafe-file": "Bloqueado por motivos de seguridad",
				"sending": "Enviando correo...",
				"openlink": "Abrir vínculo",
				"change": "Modificar",
				"delete": "Eliminar"
			},
			"links-modal": {
				"title": "Insertar vínculo",
				"label-text": "Texto para mostrar",
				"label-url": "Dirección web (URL)",
				"insert": "Insertar",
				"text-error": "Error de formato",
				"url-error": "URL Inválida"
			},
			"media-viewer": {
				"download": "Descargar",
				"back": "Atrás",
				"no-preview": "No hay vista previa disponible"
			},
			"new-message-bar": {
				"spam": "Marcar como spam",
				"reply": "Responder",
				"unassign": "Desasignar"
			},
			"contact-info": {
				"title": "Información del contacto",
				"phone": "Teléfono",
				"data": "Datos adicionales",
				"unassign": "Desasignar conversación",
				"finish": "Terminar conversación"
			}
		}
	};

/***/ },
/* 2042 */
/***/ function(module, exports) {

	module.exports = {
		"_from": "git+ssh://git@bitbucket.org/nuxibatechnologies/cw-unified-inbox.git#2.4.4",
		"_id": "cw-unified-inbox@2.4.4",
		"_inBundle": false,
		"_integrity": "",
		"_location": "/cw-unified-inbox",
		"_phantomChildren": {
			"@babel/runtime": "7.24.5",
			"classnames": "2.5.1",
			"htmlparser2": "3.10.1",
			"prop-types": "15.8.1",
			"react-popper": "1.3.11",
			"react-transition-group": "2.9.0"
		},
		"_requested": {
			"type": "git",
			"raw": "cw-unified-inbox@git+ssh://git@bitbucket.org/nuxibatechnologies/cw-unified-inbox.git#2.4.4",
			"name": "cw-unified-inbox",
			"escapedName": "cw-unified-inbox",
			"rawSpec": "git+ssh://git@bitbucket.org/nuxibatechnologies/cw-unified-inbox.git#2.4.4",
			"saveSpec": "git+ssh://git@bitbucket.org/nuxibatechnologies/cw-unified-inbox.git#2.4.4",
			"fetchSpec": "ssh://git@bitbucket.org/nuxibatechnologies/cw-unified-inbox.git",
			"gitCommittish": "2.4.4"
		},
		"_requiredBy": [
			"#USER",
			"/"
		],
		"_resolved": "git+ssh://git@bitbucket.org/nuxibatechnologies/cw-unified-inbox.git#e8e62e73f3ec4ca6bd2767d90f236bdb4d175f1a",
		"_spec": "cw-unified-inbox@git+ssh://git@bitbucket.org/nuxibatechnologies/cw-unified-inbox.git#2.4.4",
		"_where": "C:\\jenkis\\.jenkins\\workspace\\CW_RELEASE\\P\\CW_Galatea_Agent_UI_RELEASE",
		"bundleDependencies": false,
		"dependencies": {
			"date-fns": "2.28.0",
			"escape-html": "1.0.3",
			"global-components-library": "git+ssh://git@bitbucket.org/nuxibatechnologies/global-components-library.git#1.98.0",
			"i18next": "19.9.2",
			"react-html-parser": "2.0.2",
			"react-i18next": "11.15.3",
			"react-input-emoji": "4.0.9",
			"reactstrap": "8.10.0",
			"slate": "^0.78.0",
			"slate-react": "^0.79.0"
		},
		"deprecated": false,
		"devDependencies": {
			"@babel/cli": "7.16.8",
			"@babel/preset-env": "7.16.11",
			"@babel/preset-react": "7.16.7",
			"@storybook/addon-actions": "^5.3.21",
			"@storybook/addon-knobs": "^5.3.21",
			"@storybook/addon-links": "^5.3.21",
			"@storybook/addon-storyshots": "^5.3.21",
			"@storybook/addons": "^5.3.22",
			"@storybook/preset-create-react-app": "^2.1.2",
			"@storybook/react": "^5.3.21",
			"check-prop-types": "1.1.2",
			"cross-env": "7.0.3",
			"css-loader": "3.4.2",
			"enzyme": "3.11.0",
			"enzyme-adapter-react-16": "1.15.6",
			"eslint": "6.8.0",
			"eslint-plugin-react": "7.28.0",
			"jest-cli": "^25.5.4",
			"node-sass": "4.14.1",
			"node-sass-chokidar": "1.5.0",
			"prettier": "2.5.1",
			"react": "16.14.0",
			"react-dom": "16.14.0",
			"react-scripts": "3.4.1",
			"react-test-renderer": "16.14.0",
			"storybook-addon-i18n": "^5.1.13"
		},
		"eslintConfig": {
			"extends": "react-app"
		},
		"files": [
			"dist"
		],
		"homepage": "https://bitbucket.org/nuxibatechnologies/cw-unified-inbox#readme",
		"jest": {
			"coverageReporters": [
				"json",
				"html",
				"text",
				"cobertura"
			],
			"collectCoverageFrom": [
				"src/**/*.{js,jsx}",
				"!**/node_modules/**",
				"!**/output/**",
				"!**/build/**",
				"!**/public/**",
				"!**/coverage/**",
				"!src/index.js",
				"!src/i18n.js"
			],
			"coverageThreshold": {
				"global": {
					"branches": 80,
					"functions": 80,
					"lines": 80,
					"statements": -10
				}
			}
		},
		"main": "dist/index.js",
		"name": "cw-unified-inbox",
		"peerDependencies": {
			"node-sass": "4.13.1"
		},
		"prettier": {
			"printWidth": 200,
			"tabWidth": 2,
			"useTabs": true,
			"semi": true,
			"singleQuote": true,
			"trailingComma": "none",
			"bracketSpacing": true,
			"jsxBracketSameLine": true,
			"jsxSingleQuote": true,
			"arrowParens": "avoid",
			"proseWrap": "always"
		},
		"private": true,
		"repository": {
			"type": "git",
			"url": "git+https://bitbucket.org/nuxibatechnologies/cw-unified-inbox.git"
		},
		"scripts": {
			"build-css": "node-sass-chokidar ./src/styles/bundle.scss -o ./src/styles/css",
			"build-storybook": "build-storybook",
			"clean": "rimraf dist",
			"compile": "npm run build-css && npm run clean && cross-env NODE_ENV=production babel src --out-dir dist --copy-files --no-copy-ignored --ignore __tests__,src/**/*.spec.js,src/**/*.test.js,src/stories,src/test,src/setupTests.js,__snapshots__",
			"format": "prettier --write \"**/*.+(js|jsx|json|css|md)\"",
			"storybook": "start-storybook -p 9009",
			"test": "react-scripts test --coverage --watchAll=true --coverageDirectory=output/coverage",
			"testsingle": "react-scripts test"
		},
		"version": "2.4.4"
	};

/***/ },
/* 2043 */
/***/ function(module, exports) {

	module.exports = {
		"elementNames": {
			"altglyph": "altGlyph",
			"altglyphdef": "altGlyphDef",
			"altglyphitem": "altGlyphItem",
			"animatecolor": "animateColor",
			"animatemotion": "animateMotion",
			"animatetransform": "animateTransform",
			"clippath": "clipPath",
			"feblend": "feBlend",
			"fecolormatrix": "feColorMatrix",
			"fecomponenttransfer": "feComponentTransfer",
			"fecomposite": "feComposite",
			"feconvolvematrix": "feConvolveMatrix",
			"fediffuselighting": "feDiffuseLighting",
			"fedisplacementmap": "feDisplacementMap",
			"fedistantlight": "feDistantLight",
			"fedropshadow": "feDropShadow",
			"feflood": "feFlood",
			"fefunca": "feFuncA",
			"fefuncb": "feFuncB",
			"fefuncg": "feFuncG",
			"fefuncr": "feFuncR",
			"fegaussianblur": "feGaussianBlur",
			"feimage": "feImage",
			"femerge": "feMerge",
			"femergenode": "feMergeNode",
			"femorphology": "feMorphology",
			"feoffset": "feOffset",
			"fepointlight": "fePointLight",
			"fespecularlighting": "feSpecularLighting",
			"fespotlight": "feSpotLight",
			"fetile": "feTile",
			"feturbulence": "feTurbulence",
			"foreignobject": "foreignObject",
			"glyphref": "glyphRef",
			"lineargradient": "linearGradient",
			"radialgradient": "radialGradient",
			"textpath": "textPath"
		},
		"attributeNames": {
			"definitionurl": "definitionURL",
			"attributename": "attributeName",
			"attributetype": "attributeType",
			"basefrequency": "baseFrequency",
			"baseprofile": "baseProfile",
			"calcmode": "calcMode",
			"clippathunits": "clipPathUnits",
			"diffuseconstant": "diffuseConstant",
			"edgemode": "edgeMode",
			"filterunits": "filterUnits",
			"glyphref": "glyphRef",
			"gradienttransform": "gradientTransform",
			"gradientunits": "gradientUnits",
			"kernelmatrix": "kernelMatrix",
			"kernelunitlength": "kernelUnitLength",
			"keypoints": "keyPoints",
			"keysplines": "keySplines",
			"keytimes": "keyTimes",
			"lengthadjust": "lengthAdjust",
			"limitingconeangle": "limitingConeAngle",
			"markerheight": "markerHeight",
			"markerunits": "markerUnits",
			"markerwidth": "markerWidth",
			"maskcontentunits": "maskContentUnits",
			"maskunits": "maskUnits",
			"numoctaves": "numOctaves",
			"pathlength": "pathLength",
			"patterncontentunits": "patternContentUnits",
			"patterntransform": "patternTransform",
			"patternunits": "patternUnits",
			"pointsatx": "pointsAtX",
			"pointsaty": "pointsAtY",
			"pointsatz": "pointsAtZ",
			"preservealpha": "preserveAlpha",
			"preserveaspectratio": "preserveAspectRatio",
			"primitiveunits": "primitiveUnits",
			"refx": "refX",
			"refy": "refY",
			"repeatcount": "repeatCount",
			"repeatdur": "repeatDur",
			"requiredextensions": "requiredExtensions",
			"requiredfeatures": "requiredFeatures",
			"specularconstant": "specularConstant",
			"specularexponent": "specularExponent",
			"spreadmethod": "spreadMethod",
			"startoffset": "startOffset",
			"stddeviation": "stdDeviation",
			"stitchtiles": "stitchTiles",
			"surfacescale": "surfaceScale",
			"systemlanguage": "systemLanguage",
			"tablevalues": "tableValues",
			"targetx": "targetX",
			"targety": "targetY",
			"textlength": "textLength",
			"viewbox": "viewBox",
			"viewtarget": "viewTarget",
			"xchannelselector": "xChannelSelector",
			"ychannelselector": "yChannelSelector",
			"zoomandpan": "zoomAndPan"
		}
	};

/***/ },
/* 2044 */
/***/ function(module, exports) {

	module.exports = {
		"0": 65533,
		"128": 8364,
		"130": 8218,
		"131": 402,
		"132": 8222,
		"133": 8230,
		"134": 8224,
		"135": 8225,
		"136": 710,
		"137": 8240,
		"138": 352,
		"139": 8249,
		"140": 338,
		"142": 381,
		"145": 8216,
		"146": 8217,
		"147": 8220,
		"148": 8221,
		"149": 8226,
		"150": 8211,
		"151": 8212,
		"152": 732,
		"153": 8482,
		"154": 353,
		"155": 8250,
		"156": 339,
		"158": 382,
		"159": 376
	};

/***/ },
/* 2045 */
/***/ function(module, exports) {

	module.exports = {
		"Aacute": "Á",
		"aacute": "á",
		"Acirc": "Â",
		"acirc": "â",
		"acute": "´",
		"AElig": "Æ",
		"aelig": "æ",
		"Agrave": "À",
		"agrave": "à",
		"amp": "&",
		"AMP": "&",
		"Aring": "Å",
		"aring": "å",
		"Atilde": "Ã",
		"atilde": "ã",
		"Auml": "Ä",
		"auml": "ä",
		"brvbar": "¦",
		"Ccedil": "Ç",
		"ccedil": "ç",
		"cedil": "¸",
		"cent": "¢",
		"copy": "©",
		"COPY": "©",
		"curren": "¤",
		"deg": "°",
		"divide": "÷",
		"Eacute": "É",
		"eacute": "é",
		"Ecirc": "Ê",
		"ecirc": "ê",
		"Egrave": "È",
		"egrave": "è",
		"ETH": "Ð",
		"eth": "ð",
		"Euml": "Ë",
		"euml": "ë",
		"frac12": "½",
		"frac14": "¼",
		"frac34": "¾",
		"gt": ">",
		"GT": ">",
		"Iacute": "Í",
		"iacute": "í",
		"Icirc": "Î",
		"icirc": "î",
		"iexcl": "¡",
		"Igrave": "Ì",
		"igrave": "ì",
		"iquest": "¿",
		"Iuml": "Ï",
		"iuml": "ï",
		"laquo": "«",
		"lt": "<",
		"LT": "<",
		"macr": "¯",
		"micro": "µ",
		"middot": "·",
		"nbsp": " ",
		"not": "¬",
		"Ntilde": "Ñ",
		"ntilde": "ñ",
		"Oacute": "Ó",
		"oacute": "ó",
		"Ocirc": "Ô",
		"ocirc": "ô",
		"Ograve": "Ò",
		"ograve": "ò",
		"ordf": "ª",
		"ordm": "º",
		"Oslash": "Ø",
		"oslash": "ø",
		"Otilde": "Õ",
		"otilde": "õ",
		"Ouml": "Ö",
		"ouml": "ö",
		"para": "¶",
		"plusmn": "±",
		"pound": "£",
		"quot": "\"",
		"QUOT": "\"",
		"raquo": "»",
		"reg": "®",
		"REG": "®",
		"sect": "§",
		"shy": "­",
		"sup1": "¹",
		"sup2": "²",
		"sup3": "³",
		"szlig": "ß",
		"THORN": "Þ",
		"thorn": "þ",
		"times": "×",
		"Uacute": "Ú",
		"uacute": "ú",
		"Ucirc": "Û",
		"ucirc": "û",
		"Ugrave": "Ù",
		"ugrave": "ù",
		"uml": "¨",
		"Uuml": "Ü",
		"uuml": "ü",
		"Yacute": "Ý",
		"yacute": "ý",
		"yen": "¥",
		"yuml": "ÿ"
	};

/***/ },
/* 2046 */
2044,
/* 2047 */
723,
/* 2048 */
2045,
/* 2049 */
724,
/* 2050 */
/***/ function(module, exports) {

	module.exports = {
		"name": "cw-galatea-agent-ui",
		"version": "125.20231211.13",
		"private": true,
		"homepage": ".",
		"dependencies": {
			"@babel/polyfill": "7.12.1",
			"babel-plugin-transform-class-properties": "6.24.1",
			"bootstrap": "5.1.3",
			"cw-galatea-agent-controller-js": "git+ssh://git@bitbucket.org/nuxibatechnologies/cw-galatea-agent-controller.git#2022.1.2",
			"cw-galatea-api-js": "git+ssh://git@bitbucket.org/nuxibatechnologies/cw-galatea-api-js.git#2023.828.0",
			"cw-unified-inbox": "git+ssh://git@bitbucket.org/nuxibatechnologies/cw-unified-inbox.git#2.4.4",
			"es6-promise": "^4.1.0",
			"global-audio-player-js": "git+ssh://git@bitbucket.org/nuxibatechnologies/global-audio-player-js.git",
			"global-common-utilities-js": "git+ssh://git@bitbucket.org/nuxibatechnologies/global-common-utilities-js.git",
			"global-components-library": "git+ssh://git@bitbucket.org/nuxibatechnologies/global-components-library.git#1.98.0",
			"global-logger-services-js": "git+ssh://git@bitbucket.org/nuxibatechnologies/global-logger-services-js.git",
			"global-web-socket-client-js": "git+ssh://git@bitbucket.org/nuxibatechnologies/global-web-socket-client-js.git",
			"i18next": "19.9.2",
			"moment-range": "3.0.3",
			"node-sass-chokidar": "0.0.3",
			"react": "16.14.0",
			"react-autosize-textarea": "3.0.1",
			"react-bootstrap": "0.31.0",
			"react-bootstrap-select": "0.14.0",
			"react-datepicker": "0.60.2",
			"react-dom": "16.14.0",
			"react-draggable": "4.4.5",
			"react-html-parser": "1.0.3",
			"react-i18next": "11.15.3",
			"react-modal": "3.14.4",
			"react-preload": "0.5.1",
			"react-redux": "7.2.6",
			"react-resizable": "1.11.1",
			"react-simple-pie-chart": "0.4.1",
			"react-simple-range": "1.6.0",
			"react-table": "6.7.4",
			"reactstrap": "8.10.1",
			"redux": "3.6.0",
			"redux-actions": "2.6.1",
			"redux-thunk": "2.4.1",
			"regenerator-runtime": "0.13.9"
		},
		"devDependencies": {
			"@babel/cli": "^7.16.8",
			"@babel/core": "^7.16.7",
			"@babel/plugin-transform-regenerator": "^7.16.7",
			"@babel/preset-env": "^7.16.11",
			"@babel/preset-react": "^7.16.7",
			"javascript-obfuscator": "^0.24.6",
			"node-sass-chokidar": "0.0.3",
			"npm-run-all": "^4.0.2",
			"react-scripts": "^0.9.5",
			"sonarqube-scanner": "^2.8.2"
		},
		"scripts": {
			"build-css": "node-sass-chokidar ./node_modules/cw-unified-inbox/dist -o ./node_modules/cw-unified-inbox/dist && node-sass-chokidar ./node_modules/global-components-library/dist -o ./node_modules/global-components-library/dist && node-sass-chokidar ./src -o ./src",
			"watch-css": "npm run build-css && node-sass-chokidar --include-path ./src --include-path ./node_modules/ src/ -o src/ --watch",
			"start-js": "react-scripts start",
			"start": "npm-run-all -p watch-css start-js",
			"parse-slate": "babel --plugins @babel/plugin-transform-regenerator ./node_modules/slate/dist/index.js -o ./node_modules/slate/dist/index.js",
			"build": "npm run parse-slate && npm run build-css && react-scripts build && call Obfuscator.bat && call AfterObfuscation.bat",
			"buildWithoutObfuscation": "npm run parse-slate && npm run build-css && react-scripts build",
			"test": "react-scripts test --env=jsdom",
			"obfuscate": "Obfuscator.bat && call AfterObfuscation.bat",
			"eject": "react-scripts eject",
			"install-dependencies": "npm install --legacy-peer-deps",
			"sonarScanner": "node sonarqube-scanner.js CW_Galatea_Agent_UI_DEV",
			"sonarScanner:release": "node sonarqube-scanner.js CW_Galatea_Agent_UI_RELEASE"
		}
	};

/***/ },
/* 2051 */
/***/ function(module, exports, __webpack_require__) {

	// Load in dependencies
	var computedStyle = __webpack_require__(1206);
	
	/**
	 * Calculate the `line-height` of a given node
	 * @param {HTMLElement} node Element to calculate line height of. Must be in the DOM.
	 * @returns {Number} `line-height` of the element in pixels
	 */
	function lineHeight(node) {
	  // Grab the line-height via style
	  var lnHeightStr = computedStyle(node, 'line-height');
	  var lnHeight = parseFloat(lnHeightStr, 10);
	
	  // If the lineHeight did not contain a unit (i.e. it was numeric), convert it to ems (e.g. '2.3' === '2.3em')
	  if (lnHeightStr === lnHeight + '') {
	    // Save the old lineHeight style and update the em unit to the element
	    var _lnHeightStyle = node.style.lineHeight;
	    node.style.lineHeight = lnHeightStr + 'em';
	
	    // Calculate the em based height
	    lnHeightStr = computedStyle(node, 'line-height');
	    lnHeight = parseFloat(lnHeightStr, 10);
	
	    // Revert the lineHeight style
	    if (_lnHeightStyle) {
	      node.style.lineHeight = _lnHeightStyle;
	    } else {
	      delete node.style.lineHeight;
	    }
	  }
	
	  // If the lineHeight is in `pt`, convert it to pixels (4px for 3pt)
	  // DEV: `em` units are converted to `pt` in IE6
	  // Conversion ratio from https://developer.mozilla.org/en-US/docs/Web/CSS/length
	  if (lnHeightStr.indexOf('pt') !== -1) {
	    lnHeight *= 4;
	    lnHeight /= 3;
	  // Otherwise, if the lineHeight is in `mm`, convert it to pixels (96px for 25.4mm)
	  } else if (lnHeightStr.indexOf('mm') !== -1) {
	    lnHeight *= 96;
	    lnHeight /= 25.4;
	  // Otherwise, if the lineHeight is in `cm`, convert it to pixels (96px for 2.54cm)
	  } else if (lnHeightStr.indexOf('cm') !== -1) {
	    lnHeight *= 96;
	    lnHeight /= 2.54;
	  // Otherwise, if the lineHeight is in `in`, convert it to pixels (96px for 1in)
	  } else if (lnHeightStr.indexOf('in') !== -1) {
	    lnHeight *= 96;
	  // Otherwise, if the lineHeight is in `pc`, convert it to pixels (12pt for 1pc)
	  } else if (lnHeightStr.indexOf('pc') !== -1) {
	    lnHeight *= 16;
	  }
	
	  // Continue our computation
	  lnHeight = Math.round(lnHeight);
	
	  // If the line-height is "normal", calculate by font-size
	  if (lnHeightStr === 'normal') {
	    // Create a temporary node
	    var nodeName = node.nodeName;
	    var _node = document.createElement(nodeName);
	    _node.innerHTML = '&nbsp;';
	
	    // If we have a text area, reset it to only 1 row
	    // https://github.com/twolfson/line-height/issues/4
	    if (nodeName.toUpperCase() === 'TEXTAREA') {
	      _node.setAttribute('rows', '1');
	    }
	
	    // Set the font-size of the element
	    var fontSizeStr = computedStyle(node, 'font-size');
	    _node.style.fontSize = fontSizeStr;
	
	    // Remove default padding/border which can affect offset height
	    // https://github.com/twolfson/line-height/issues/4
	    // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetHeight
	    _node.style.padding = '0px';
	    _node.style.border = '0px';
	
	    // Append it to the body
	    var body = document.body;
	    body.appendChild(_node);
	
	    // Assume the line height of the element is the height
	    var height = _node.offsetHeight;
	    lnHeight = height;
	
	    // Remove our child from the DOM
	    body.removeChild(_node);
	  }
	
	  // Return the calculated height
	  return lnHeight;
	}
	
	// Export lineHeight
	module.exports = lineHeight;


/***/ },
/* 2052 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match words composed of alphanumeric characters. */
	var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	/** Used to match Latin Unicode letters (excluding mathematical operators). */
	var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23',
	    rsComboSymbolsRange = '\\u20d0-\\u20f0',
	    rsDingbatRange = '\\u2700-\\u27bf',
	    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	    rsPunctuationRange = '\\u2000-\\u206f',
	    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	    rsVarRange = '\\ufe0e\\ufe0f',
	    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	/** Used to compose unicode capture groups. */
	var rsApos = "['\u2019]",
	    rsAstral = '[' + rsAstralRange + ']',
	    rsBreak = '[' + rsBreakRange + ']',
	    rsCombo = '[' + rsComboMarksRange + rsComboSymbolsRange + ']',
	    rsDigits = '\\d+',
	    rsDingbat = '[' + rsDingbatRange + ']',
	    rsLower = '[' + rsLowerRange + ']',
	    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	    rsFitz = '\\ud83c[\\udffb-\\udfff]',
	    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	    rsNonAstral = '[^' + rsAstralRange + ']',
	    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	    rsUpper = '[' + rsUpperRange + ']',
	    rsZWJ = '\\u200d';
	
	/** Used to compose unicode regexes. */
	var rsLowerMisc = '(?:' + rsLower + '|' + rsMisc + ')',
	    rsUpperMisc = '(?:' + rsUpper + '|' + rsMisc + ')',
	    rsOptLowerContr = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	    rsOptUpperContr = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	    reOptMod = rsModifier + '?',
	    rsOptVar = '[' + rsVarRange + ']?',
	    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	    rsSeq = rsOptVar + reOptMod + rsOptJoin,
	    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	/** Used to match apostrophes. */
	var reApos = RegExp(rsApos, 'g');
	
	/**
	 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	 */
	var reComboMark = RegExp(rsCombo, 'g');
	
	/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	/** Used to match complex or compound words. */
	var reUnicodeWord = RegExp([
	  rsUpper + '?' + rsLower + '+' + rsOptLowerContr + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	  rsUpperMisc + '+' + rsOptUpperContr + '(?=' + [rsBreak, rsUpper + rsLowerMisc, '$'].join('|') + ')',
	  rsUpper + '?' + rsLowerMisc + '+' + rsOptLowerContr,
	  rsUpper + '+' + rsOptUpperContr,
	  rsDigits,
	  rsEmoji
	].join('|'), 'g');
	
	/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboMarksRange + rsComboSymbolsRange + rsVarRange + ']');
	
	/** Used to detect strings that need a more robust regexp to match words. */
	var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	/** Used to map Latin Unicode letters to basic Latin letters. */
	var deburredLetters = {
	  // Latin-1 Supplement block.
	  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	  '\xc7': 'C',  '\xe7': 'c',
	  '\xd0': 'D',  '\xf0': 'd',
	  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	  '\xd1': 'N',  '\xf1': 'n',
	  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	  '\xc6': 'Ae', '\xe6': 'ae',
	  '\xde': 'Th', '\xfe': 'th',
	  '\xdf': 'ss',
	  // Latin Extended-A block.
	  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	  '\u0134': 'J',  '\u0135': 'j',
	  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	  '\u0174': 'W',  '\u0175': 'w',
	  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	  '\u0132': 'IJ', '\u0133': 'ij',
	  '\u0152': 'Oe', '\u0153': 'oe',
	  '\u0149': "'n", '\u017f': 'ss'
	};
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}
	
	/**
	 * Converts an ASCII `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function asciiToArray(string) {
	  return string.split('');
	}
	
	/**
	 * Splits an ASCII `string` into an array of its words.
	 *
	 * @private
	 * @param {string} The string to inspect.
	 * @returns {Array} Returns the words of `string`.
	 */
	function asciiWords(string) {
	  return string.match(reAsciiWord) || [];
	}
	
	/**
	 * The base implementation of `_.propertyOf` without support for deep paths.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyOf(object) {
	  return function(key) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	/**
	 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	 * letters to basic Latin letters.
	 *
	 * @private
	 * @param {string} letter The matched letter to deburr.
	 * @returns {string} Returns the deburred letter.
	 */
	var deburrLetter = basePropertyOf(deburredLetters);
	
	/**
	 * Checks if `string` contains Unicode symbols.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	 */
	function hasUnicode(string) {
	  return reHasUnicode.test(string);
	}
	
	/**
	 * Checks if `string` contains a word composed of Unicode symbols.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {boolean} Returns `true` if a word is found, else `false`.
	 */
	function hasUnicodeWord(string) {
	  return reHasUnicodeWord.test(string);
	}
	
	/**
	 * Converts `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function stringToArray(string) {
	  return hasUnicode(string)
	    ? unicodeToArray(string)
	    : asciiToArray(string);
	}
	
	/**
	 * Converts a Unicode `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function unicodeToArray(string) {
	  return string.match(reUnicode) || [];
	}
	
	/**
	 * Splits a Unicode `string` into an array of its words.
	 *
	 * @private
	 * @param {string} The string to inspect.
	 * @returns {Array} Returns the words of `string`.
	 */
	function unicodeWords(string) {
	  return string.match(reUnicodeWord) || [];
	}
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;
	
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = end > length ? length : end;
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : ((end - start) >>> 0);
	  start >>>= 0;
	
	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Casts `array` to a slice if it's needed.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {number} start The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the cast slice.
	 */
	function castSlice(array, start, end) {
	  var length = array.length;
	  end = end === undefined ? length : end;
	  return (!start && end >= length) ? array : baseSlice(array, start, end);
	}
	
	/**
	 * Creates a function like `_.lowerFirst`.
	 *
	 * @private
	 * @param {string} methodName The name of the `String` case method to use.
	 * @returns {Function} Returns the new case function.
	 */
	function createCaseFirst(methodName) {
	  return function(string) {
	    string = toString(string);
	
	    var strSymbols = hasUnicode(string)
	      ? stringToArray(string)
	      : undefined;
	
	    var chr = strSymbols
	      ? strSymbols[0]
	      : string.charAt(0);
	
	    var trailing = strSymbols
	      ? castSlice(strSymbols, 1).join('')
	      : string.slice(1);
	
	    return chr[methodName]() + trailing;
	  };
	}
	
	/**
	 * Creates a function like `_.camelCase`.
	 *
	 * @private
	 * @param {Function} callback The function to combine each word.
	 * @returns {Function} Returns the new compounder function.
	 */
	function createCompounder(callback) {
	  return function(string) {
	    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	  };
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	/**
	 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to convert.
	 * @returns {string} Returns the camel cased string.
	 * @example
	 *
	 * _.camelCase('Foo Bar');
	 * // => 'fooBar'
	 *
	 * _.camelCase('--foo-bar--');
	 * // => 'fooBar'
	 *
	 * _.camelCase('__FOO_BAR__');
	 * // => 'fooBar'
	 */
	var camelCase = createCompounder(function(result, word, index) {
	  word = word.toLowerCase();
	  return result + (index ? capitalize(word) : word);
	});
	
	/**
	 * Converts the first character of `string` to upper case and the remaining
	 * to lower case.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to capitalize.
	 * @returns {string} Returns the capitalized string.
	 * @example
	 *
	 * _.capitalize('FRED');
	 * // => 'Fred'
	 */
	function capitalize(string) {
	  return upperFirst(toString(string).toLowerCase());
	}
	
	/**
	 * Deburrs `string` by converting
	 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	 * letters to basic Latin letters and removing
	 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to deburr.
	 * @returns {string} Returns the deburred string.
	 * @example
	 *
	 * _.deburr('déjà vu');
	 * // => 'deja vu'
	 */
	function deburr(string) {
	  string = toString(string);
	  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	}
	
	/**
	 * Converts the first character of `string` to upper case.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category String
	 * @param {string} [string=''] The string to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.upperFirst('fred');
	 * // => 'Fred'
	 *
	 * _.upperFirst('FRED');
	 * // => 'FRED'
	 */
	var upperFirst = createCaseFirst('toUpperCase');
	
	/**
	 * Splits `string` into an array of its words.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to inspect.
	 * @param {RegExp|string} [pattern] The pattern to match words.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Array} Returns the words of `string`.
	 * @example
	 *
	 * _.words('fred, barney, & pebbles');
	 * // => ['fred', 'barney', 'pebbles']
	 *
	 * _.words('fred, barney, & pebbles', /[^, ]+/g);
	 * // => ['fred', 'barney', '&', 'pebbles']
	 */
	function words(string, pattern, guard) {
	  string = toString(string);
	  pattern = guard ? undefined : pattern;
	
	  if (pattern === undefined) {
	    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	  }
	  return string.match(pattern) || [];
	}
	
	module.exports = camelCase;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 2053 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as the internal argument placeholder. */
	var PLACEHOLDER = '__lodash_placeholder__';
	
	/** Used to compose bitmasks for function metadata. */
	var BIND_FLAG = 1,
	    BIND_KEY_FLAG = 2,
	    CURRY_BOUND_FLAG = 4,
	    CURRY_FLAG = 8,
	    CURRY_RIGHT_FLAG = 16,
	    PARTIAL_FLAG = 32,
	    PARTIAL_RIGHT_FLAG = 64,
	    ARY_FLAG = 128,
	    REARG_FLAG = 256,
	    FLIP_FLAG = 512;
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_SAFE_INTEGER = 9007199254740991,
	    MAX_INTEGER = 1.7976931348623157e+308,
	    NAN = 0 / 0;
	
	/** Used to associate wrap methods with their bit flags. */
	var wrapFlags = [
	  ['ary', ARY_FLAG],
	  ['bind', BIND_FLAG],
	  ['bindKey', BIND_KEY_FLAG],
	  ['curry', CURRY_FLAG],
	  ['curryRight', CURRY_RIGHT_FLAG],
	  ['flip', FLIP_FLAG],
	  ['partial', PARTIAL_FLAG],
	  ['partialRight', PARTIAL_RIGHT_FLAG],
	  ['rearg', REARG_FLAG]
	];
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    symbolTag = '[object Symbol]';
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to match wrap detail comments. */
	var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	    reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	    reSplitDetails = /,? & /;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	/**
	 * A specialized version of `_.includes` for arrays without support for
	 * specifying an index to search from.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludes(array, value) {
	  var length = array ? array.length : 0;
	  return !!length && baseIndexOf(array, value, 0) > -1;
	}
	
	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  if (value !== value) {
	    return baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	/**
	 * Gets the number of `placeholder` occurrences in `array`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} placeholder The placeholder to search for.
	 * @returns {number} Returns the placeholder count.
	 */
	function countHolders(array, placeholder) {
	  var length = array.length,
	      result = 0;
	
	  while (length--) {
	    if (array[length] === placeholder) {
	      result++;
	    }
	  }
	  return result;
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/**
	 * Replaces all `placeholder` elements in `array` with an internal placeholder
	 * and returns an array of their indexes.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {*} placeholder The placeholder to replace.
	 * @returns {Array} Returns the new array of placeholder indexes.
	 */
	function replaceHolders(array, placeholder) {
	  var index = -1,
	      length = array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (value === placeholder || value === PLACEHOLDER) {
	      array[index] = PLACEHOLDER;
	      result[resIndex++] = index;
	    }
	  }
	  return result;
	}
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/* Used to set `toString` methods. */
	var defineProperty = (function() {
	  var func = getNative(Object, 'defineProperty'),
	      name = getNative.name;
	
	  return (name && name.length > 2) ? func : undefined;
	}());
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} prototype The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	function baseCreate(proto) {
	  return isObject(proto) ? objectCreate(proto) : {};
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * Creates an array that is the composition of partially applied arguments,
	 * placeholders, and provided arguments into a single array of arguments.
	 *
	 * @private
	 * @param {Array} args The provided arguments.
	 * @param {Array} partials The arguments to prepend to those provided.
	 * @param {Array} holders The `partials` placeholder indexes.
	 * @params {boolean} [isCurried] Specify composing for a curried function.
	 * @returns {Array} Returns the new array of composed arguments.
	 */
	function composeArgs(args, partials, holders, isCurried) {
	  var argsIndex = -1,
	      argsLength = args.length,
	      holdersLength = holders.length,
	      leftIndex = -1,
	      leftLength = partials.length,
	      rangeLength = nativeMax(argsLength - holdersLength, 0),
	      result = Array(leftLength + rangeLength),
	      isUncurried = !isCurried;
	
	  while (++leftIndex < leftLength) {
	    result[leftIndex] = partials[leftIndex];
	  }
	  while (++argsIndex < holdersLength) {
	    if (isUncurried || argsIndex < argsLength) {
	      result[holders[argsIndex]] = args[argsIndex];
	    }
	  }
	  while (rangeLength--) {
	    result[leftIndex++] = args[argsIndex++];
	  }
	  return result;
	}
	
	/**
	 * This function is like `composeArgs` except that the arguments composition
	 * is tailored for `_.partialRight`.
	 *
	 * @private
	 * @param {Array} args The provided arguments.
	 * @param {Array} partials The arguments to append to those provided.
	 * @param {Array} holders The `partials` placeholder indexes.
	 * @params {boolean} [isCurried] Specify composing for a curried function.
	 * @returns {Array} Returns the new array of composed arguments.
	 */
	function composeArgsRight(args, partials, holders, isCurried) {
	  var argsIndex = -1,
	      argsLength = args.length,
	      holdersIndex = -1,
	      holdersLength = holders.length,
	      rightIndex = -1,
	      rightLength = partials.length,
	      rangeLength = nativeMax(argsLength - holdersLength, 0),
	      result = Array(rangeLength + rightLength),
	      isUncurried = !isCurried;
	
	  while (++argsIndex < rangeLength) {
	    result[argsIndex] = args[argsIndex];
	  }
	  var offset = argsIndex;
	  while (++rightIndex < rightLength) {
	    result[offset + rightIndex] = partials[rightIndex];
	  }
	  while (++holdersIndex < holdersLength) {
	    if (isUncurried || argsIndex < argsLength) {
	      result[offset + holders[holdersIndex]] = args[argsIndex++];
	    }
	  }
	  return result;
	}
	
	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	/**
	 * Creates a function that wraps `func` to invoke it with the optional `this`
	 * binding of `thisArg`.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createBind(func, bitmask, thisArg) {
	  var isBind = bitmask & BIND_FLAG,
	      Ctor = createCtor(func);
	
	  function wrapper() {
	    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	    return fn.apply(isBind ? thisArg : this, arguments);
	  }
	  return wrapper;
	}
	
	/**
	 * Creates a function that produces an instance of `Ctor` regardless of
	 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	 *
	 * @private
	 * @param {Function} Ctor The constructor to wrap.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createCtor(Ctor) {
	  return function() {
	    // Use a `switch` statement to work with class constructors. See
	    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	    // for more details.
	    var args = arguments;
	    switch (args.length) {
	      case 0: return new Ctor;
	      case 1: return new Ctor(args[0]);
	      case 2: return new Ctor(args[0], args[1]);
	      case 3: return new Ctor(args[0], args[1], args[2]);
	      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	    }
	    var thisBinding = baseCreate(Ctor.prototype),
	        result = Ctor.apply(thisBinding, args);
	
	    // Mimic the constructor's `return` behavior.
	    // See https://es5.github.io/#x13.2.2 for more details.
	    return isObject(result) ? result : thisBinding;
	  };
	}
	
	/**
	 * Creates a function that wraps `func` to enable currying.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {number} arity The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createCurry(func, bitmask, arity) {
	  var Ctor = createCtor(func);
	
	  function wrapper() {
	    var length = arguments.length,
	        args = Array(length),
	        index = length,
	        placeholder = getHolder(wrapper);
	
	    while (index--) {
	      args[index] = arguments[index];
	    }
	    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	      ? []
	      : replaceHolders(args, placeholder);
	
	    length -= holders.length;
	    if (length < arity) {
	      return createRecurry(
	        func, bitmask, createHybrid, wrapper.placeholder, undefined,
	        args, holders, undefined, undefined, arity - length);
	    }
	    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	    return apply(fn, this, args);
	  }
	  return wrapper;
	}
	
	/**
	 * Creates a function that wraps `func` to invoke it with optional `this`
	 * binding of `thisArg`, partial application, and currying.
	 *
	 * @private
	 * @param {Function|string} func The function or method name to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to prepend to those provided to
	 *  the new function.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [partialsRight] The arguments to append to those provided
	 *  to the new function.
	 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	  var isAry = bitmask & ARY_FLAG,
	      isBind = bitmask & BIND_FLAG,
	      isBindKey = bitmask & BIND_KEY_FLAG,
	      isCurried = bitmask & (CURRY_FLAG | CURRY_RIGHT_FLAG),
	      isFlip = bitmask & FLIP_FLAG,
	      Ctor = isBindKey ? undefined : createCtor(func);
	
	  function wrapper() {
	    var length = arguments.length,
	        args = Array(length),
	        index = length;
	
	    while (index--) {
	      args[index] = arguments[index];
	    }
	    if (isCurried) {
	      var placeholder = getHolder(wrapper),
	          holdersCount = countHolders(args, placeholder);
	    }
	    if (partials) {
	      args = composeArgs(args, partials, holders, isCurried);
	    }
	    if (partialsRight) {
	      args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	    }
	    length -= holdersCount;
	    if (isCurried && length < arity) {
	      var newHolders = replaceHolders(args, placeholder);
	      return createRecurry(
	        func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	        args, newHolders, argPos, ary, arity - length
	      );
	    }
	    var thisBinding = isBind ? thisArg : this,
	        fn = isBindKey ? thisBinding[func] : func;
	
	    length = args.length;
	    if (argPos) {
	      args = reorder(args, argPos);
	    } else if (isFlip && length > 1) {
	      args.reverse();
	    }
	    if (isAry && ary < length) {
	      args.length = ary;
	    }
	    if (this && this !== root && this instanceof wrapper) {
	      fn = Ctor || createCtor(fn);
	    }
	    return fn.apply(thisBinding, args);
	  }
	  return wrapper;
	}
	
	/**
	 * Creates a function that wraps `func` to invoke it with the `this` binding
	 * of `thisArg` and `partials` prepended to the arguments it receives.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} partials The arguments to prepend to those provided to
	 *  the new function.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createPartial(func, bitmask, thisArg, partials) {
	  var isBind = bitmask & BIND_FLAG,
	      Ctor = createCtor(func);
	
	  function wrapper() {
	    var argsIndex = -1,
	        argsLength = arguments.length,
	        leftIndex = -1,
	        leftLength = partials.length,
	        args = Array(leftLength + argsLength),
	        fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	    while (++leftIndex < leftLength) {
	      args[leftIndex] = partials[leftIndex];
	    }
	    while (argsLength--) {
	      args[leftIndex++] = arguments[++argsIndex];
	    }
	    return apply(fn, isBind ? thisArg : this, args);
	  }
	  return wrapper;
	}
	
	/**
	 * Creates a function that wraps `func` to continue currying.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {Function} wrapFunc The function to create the `func` wrapper.
	 * @param {*} placeholder The placeholder value.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to prepend to those provided to
	 *  the new function.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	  var isCurry = bitmask & CURRY_FLAG,
	      newHolders = isCurry ? holders : undefined,
	      newHoldersRight = isCurry ? undefined : holders,
	      newPartials = isCurry ? partials : undefined,
	      newPartialsRight = isCurry ? undefined : partials;
	
	  bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
	  bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);
	
	  if (!(bitmask & CURRY_BOUND_FLAG)) {
	    bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
	  }
	
	  var result = wrapFunc(func, bitmask, thisArg, newPartials, newHolders, newPartialsRight, newHoldersRight, argPos, ary, arity);
	  result.placeholder = placeholder;
	  return setWrapToString(result, func, bitmask);
	}
	
	/**
	 * Creates a function that either curries or invokes `func` with optional
	 * `this` binding and partially applied arguments.
	 *
	 * @private
	 * @param {Function|string} func The function or method name to wrap.
	 * @param {number} bitmask The bitmask flags.
	 *  The bitmask may be composed of the following flags:
	 *     1 - `_.bind`
	 *     2 - `_.bindKey`
	 *     4 - `_.curry` or `_.curryRight` of a bound function
	 *     8 - `_.curry`
	 *    16 - `_.curryRight`
	 *    32 - `_.partial`
	 *    64 - `_.partialRight`
	 *   128 - `_.rearg`
	 *   256 - `_.ary`
	 *   512 - `_.flip`
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to be partially applied.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	  var isBindKey = bitmask & BIND_KEY_FLAG;
	  if (!isBindKey && typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var length = partials ? partials.length : 0;
	  if (!length) {
	    bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
	    partials = holders = undefined;
	  }
	  ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	  arity = arity === undefined ? arity : toInteger(arity);
	  length -= holders ? holders.length : 0;
	
	  if (bitmask & PARTIAL_RIGHT_FLAG) {
	    var partialsRight = partials,
	        holdersRight = holders;
	
	    partials = holders = undefined;
	  }
	
	  var newData = [
	    func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	    argPos, ary, arity
	  ];
	
	  func = newData[0];
	  bitmask = newData[1];
	  thisArg = newData[2];
	  partials = newData[3];
	  holders = newData[4];
	  arity = newData[9] = newData[9] == null
	    ? (isBindKey ? 0 : func.length)
	    : nativeMax(newData[9] - length, 0);
	
	  if (!arity && bitmask & (CURRY_FLAG | CURRY_RIGHT_FLAG)) {
	    bitmask &= ~(CURRY_FLAG | CURRY_RIGHT_FLAG);
	  }
	  if (!bitmask || bitmask == BIND_FLAG) {
	    var result = createBind(func, bitmask, thisArg);
	  } else if (bitmask == CURRY_FLAG || bitmask == CURRY_RIGHT_FLAG) {
	    result = createCurry(func, bitmask, arity);
	  } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !holders.length) {
	    result = createPartial(func, bitmask, thisArg, partials);
	  } else {
	    result = createHybrid.apply(undefined, newData);
	  }
	  return setWrapToString(result, func, bitmask);
	}
	
	/**
	 * Gets the argument placeholder value for `func`.
	 *
	 * @private
	 * @param {Function} func The function to inspect.
	 * @returns {*} Returns the placeholder value.
	 */
	function getHolder(func) {
	  var object = func;
	  return object.placeholder;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * Extracts wrapper details from the `source` body comment.
	 *
	 * @private
	 * @param {string} source The source to inspect.
	 * @returns {Array} Returns the wrapper details.
	 */
	function getWrapDetails(source) {
	  var match = source.match(reWrapDetails);
	  return match ? match[1].split(reSplitDetails) : [];
	}
	
	/**
	 * Inserts wrapper `details` in a comment at the top of the `source` body.
	 *
	 * @private
	 * @param {string} source The source to modify.
	 * @returns {Array} details The details to insert.
	 * @returns {string} Returns the modified source.
	 */
	function insertWrapDetails(source, details) {
	  var length = details.length,
	      lastIndex = length - 1;
	
	  details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	  details = details.join(length > 2 ? ', ' : ' ');
	  return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Reorder `array` according to the specified indexes where the element at
	 * the first index is assigned as the first element, the element at
	 * the second index is assigned as the second element, and so on.
	 *
	 * @private
	 * @param {Array} array The array to reorder.
	 * @param {Array} indexes The arranged array indexes.
	 * @returns {Array} Returns `array`.
	 */
	function reorder(array, indexes) {
	  var arrLength = array.length,
	      length = nativeMin(indexes.length, arrLength),
	      oldArray = copyArray(array);
	
	  while (length--) {
	    var index = indexes[length];
	    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	  }
	  return array;
	}
	
	/**
	 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	 * with wrapper details in a comment at the top of the source body.
	 *
	 * @private
	 * @param {Function} wrapper The function to modify.
	 * @param {Function} reference The reference function.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @returns {Function} Returns `wrapper`.
	 */
	var setWrapToString = !defineProperty ? identity : function(wrapper, reference, bitmask) {
	  var source = (reference + '');
	  return defineProperty(wrapper, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)))
	  });
	};
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Updates wrapper `details` based on `bitmask` flags.
	 *
	 * @private
	 * @returns {Array} details The details to modify.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @returns {Array} Returns `details`.
	 */
	function updateWrapDetails(details, bitmask) {
	  arrayEach(wrapFlags, function(pair) {
	    var value = '_.' + pair[0];
	    if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	      details.push(value);
	    }
	  });
	  return details.sort();
	}
	
	/**
	 * Creates a function that accepts arguments of `func` and either invokes
	 * `func` returning its result, if at least `arity` number of arguments have
	 * been provided, or returns a function that accepts the remaining `func`
	 * arguments, and so on. The arity of `func` may be specified if `func.length`
	 * is not sufficient.
	 *
	 * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	 * may be used as a placeholder for provided arguments.
	 *
	 * **Note:** This method doesn't set the "length" property of curried functions.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.0.0
	 * @category Function
	 * @param {Function} func The function to curry.
	 * @param {number} [arity=func.length] The arity of `func`.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Function} Returns the new curried function.
	 * @example
	 *
	 * var abc = function(a, b, c) {
	 *   return [a, b, c];
	 * };
	 *
	 * var curried = _.curry(abc);
	 *
	 * curried(1)(2)(3);
	 * // => [1, 2, 3]
	 *
	 * curried(1, 2)(3);
	 * // => [1, 2, 3]
	 *
	 * curried(1, 2, 3);
	 * // => [1, 2, 3]
	 *
	 * // Curried with placeholders.
	 * curried(1)(_, 3)(2);
	 * // => [1, 2, 3]
	 */
	function curry(func, arity, guard) {
	  arity = guard ? undefined : arity;
	  var result = createWrap(func, CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	  result.placeholder = curry.placeholder;
	  return result;
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	// Assign default placeholders.
	curry.placeholder = {};
	
	module.exports = curry;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 2054 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = debounce;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 2055 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	/**
	 * Creates a throttled function that only invokes `func` at most once per
	 * every `wait` milliseconds. The throttled function comes with a `cancel`
	 * method to cancel delayed `func` invocations and a `flush` method to
	 * immediately invoke them. Provide `options` to indicate whether `func`
	 * should be invoked on the leading and/or trailing edge of the `wait`
	 * timeout. The `func` is invoked with the last arguments provided to the
	 * throttled function. Subsequent calls to the throttled function return the
	 * result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the throttled function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.throttle` and `_.debounce`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to throttle.
	 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=true]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new throttled function.
	 * @example
	 *
	 * // Avoid excessively updating the position while scrolling.
	 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	 *
	 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	 * jQuery(element).on('click', throttled);
	 *
	 * // Cancel the trailing throttled invocation.
	 * jQuery(window).on('popstate', throttled.cancel);
	 */
	function throttle(func, wait, options) {
	  var leading = true,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  if (isObject(options)) {
	    leading = 'leading' in options ? !!options.leading : leading;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	  return debounce(func, wait, {
	    'leading': leading,
	    'maxWait': wait,
	    'trailing': trailing
	  });
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = throttle;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 2056 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(149),
	    root = __webpack_require__(84);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ },
/* 2057 */
/***/ function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(2124),
	    hashDelete = __webpack_require__(2125),
	    hashGet = __webpack_require__(2126),
	    hashHas = __webpack_require__(2127),
	    hashSet = __webpack_require__(2128);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ },
/* 2058 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(149),
	    root = __webpack_require__(84);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ },
/* 2059 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(149),
	    root = __webpack_require__(84);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ },
/* 2060 */
/***/ function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ },
/* 2061 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ },
/* 2062 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.every` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if all elements pass the predicate check,
	 *  else `false`.
	 */
	function arrayEvery(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (!predicate(array[index], index, array)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = arrayEvery;


/***/ },
/* 2063 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(223),
	    keys = __webpack_require__(183);
	
	/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return object && copyObject(source, keys(source), object);
	}
	
	module.exports = baseAssign;


/***/ },
/* 2064 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(223),
	    keysIn = __webpack_require__(454);
	
	/**
	 * The base implementation of `_.assignIn` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssignIn(object, source) {
	  return object && copyObject(source, keysIn(source), object);
	}
	
	module.exports = baseAssignIn;


/***/ },
/* 2065 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(436),
	    arrayEach = __webpack_require__(2061),
	    assignValue = __webpack_require__(732),
	    baseAssign = __webpack_require__(2063),
	    baseAssignIn = __webpack_require__(2064),
	    cloneBuffer = __webpack_require__(2100),
	    copyArray = __webpack_require__(2107),
	    copySymbols = __webpack_require__(2108),
	    copySymbolsIn = __webpack_require__(2109),
	    getAllKeys = __webpack_require__(743),
	    getAllKeysIn = __webpack_require__(744),
	    getTag = __webpack_require__(286),
	    initCloneArray = __webpack_require__(2129),
	    initCloneByTag = __webpack_require__(2130),
	    initCloneObject = __webpack_require__(2131),
	    isArray = __webpack_require__(43),
	    isBuffer = __webpack_require__(452),
	    isMap = __webpack_require__(2171),
	    isObject = __webpack_require__(72),
	    isSet = __webpack_require__(2172),
	    keys = __webpack_require__(183),
	    keysIn = __webpack_require__(454);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_FLAT_FLAG = 2,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	cloneableTags[boolTag] = cloneableTags[dateTag] =
	cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	cloneableTags[int32Tag] = cloneableTags[mapTag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[setTag] =
	cloneableTags[stringTag] = cloneableTags[symbolTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Deep clone
	 *  2 - Flatten inherited properties
	 *  4 - Clone symbols
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, bitmask, customizer, key, object, stack) {
	  var result,
	      isDeep = bitmask & CLONE_DEEP_FLAG,
	      isFlat = bitmask & CLONE_FLAT_FLAG,
	      isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	  if (customizer) {
	    result = object ? customizer(value, key, object, stack) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return copyArray(value, result);
	    }
	  } else {
	    var tag = getTag(value),
	        isFunc = tag == funcTag || tag == genTag;
	
	    if (isBuffer(value)) {
	      return cloneBuffer(value, isDeep);
	    }
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      result = (isFlat || isFunc) ? {} : initCloneObject(value);
	      if (!isDeep) {
	        return isFlat
	          ? copySymbolsIn(value, baseAssignIn(result, value))
	          : copySymbols(value, baseAssign(result, value));
	      }
	    } else {
	      if (!cloneableTags[tag]) {
	        return object ? value : {};
	      }
	      result = initCloneByTag(value, tag, isDeep);
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stack || (stack = new Stack);
	  var stacked = stack.get(value);
	  if (stacked) {
	    return stacked;
	  }
	  stack.set(value, result);
	
	  if (isSet(value)) {
	    value.forEach(function(subValue) {
	      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	    });
	  } else if (isMap(value)) {
	    value.forEach(function(subValue, key) {
	      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	    });
	  }
	
	  var keysFunc = isFull
	    ? (isFlat ? getAllKeysIn : getAllKeys)
	    : (isFlat ? keysIn : keys);
	
	  var props = isArr ? undefined : keysFunc(value);
	  arrayEach(props || value, function(subValue, key) {
	    if (props) {
	      key = subValue;
	      subValue = value[key];
	    }
	    // Recursively populate clone (susceptible to call stack limits).
	    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	  });
	  return result;
	}
	
	module.exports = baseClone;


/***/ },
/* 2066 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(72);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	module.exports = baseCreate;


/***/ },
/* 2067 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(281);
	
	/**
	 * The base implementation of `_.every` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if all elements pass the predicate check,
	 *  else `false`
	 */
	function baseEvery(collection, predicate) {
	  var result = true;
	  baseEach(collection, function(value, index, collection) {
	    result = !!predicate(value, index, collection);
	    return result;
	  });
	  return result;
	}
	
	module.exports = baseEvery;


/***/ },
/* 2068 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(281);
	
	/**
	 * The base implementation of `_.filter` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function baseFilter(collection, predicate) {
	  var result = [];
	  baseEach(collection, function(value, index, collection) {
	    if (predicate(value, index, collection)) {
	      result.push(value);
	    }
	  });
	  return result;
	}
	
	module.exports = baseFilter;


/***/ },
/* 2069 */
/***/ function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(2112);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ },
/* 2070 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ },
/* 2071 */
/***/ function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(733),
	    baseIsNaN = __webpack_require__(2077),
	    strictIndexOf = __webpack_require__(2159);
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  return value === value
	    ? strictIndexOf(array, value, fromIndex)
	    : baseFindIndex(array, baseIsNaN, fromIndex);
	}
	
	module.exports = baseIndexOf;


/***/ },
/* 2072 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(435),
	    arrayIncludes = __webpack_require__(728),
	    arrayIncludesWith = __webpack_require__(729),
	    arrayMap = __webpack_require__(179),
	    baseUnary = __webpack_require__(222),
	    cacheHas = __webpack_require__(441);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * The base implementation of methods like `_.intersection`, without support
	 * for iteratee shorthands, that accepts an array of arrays to inspect.
	 *
	 * @private
	 * @param {Array} arrays The arrays to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of shared values.
	 */
	function baseIntersection(arrays, iteratee, comparator) {
	  var includes = comparator ? arrayIncludesWith : arrayIncludes,
	      length = arrays[0].length,
	      othLength = arrays.length,
	      othIndex = othLength,
	      caches = Array(othLength),
	      maxLength = Infinity,
	      result = [];
	
	  while (othIndex--) {
	    var array = arrays[othIndex];
	    if (othIndex && iteratee) {
	      array = arrayMap(array, baseUnary(iteratee));
	    }
	    maxLength = nativeMin(array.length, maxLength);
	    caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	      ? new SetCache(othIndex && array)
	      : undefined;
	  }
	  array = arrays[0];
	
	  var index = -1,
	      seen = caches[0];
	
	  outer:
	  while (++index < length && result.length < maxLength) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (!(seen
	          ? cacheHas(seen, computed)
	          : includes(result, computed, comparator)
	        )) {
	      othIndex = othLength;
	      while (--othIndex) {
	        var cache = caches[othIndex];
	        if (!(cache
	              ? cacheHas(cache, computed)
	              : includes(arrays[othIndex], computed, comparator))
	            ) {
	          continue outer;
	        }
	      }
	      if (seen) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseIntersection;


/***/ },
/* 2073 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(125),
	    isObjectLike = __webpack_require__(85);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ },
/* 2074 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(436),
	    equalArrays = __webpack_require__(741),
	    equalByTag = __webpack_require__(2117),
	    equalObjects = __webpack_require__(2118),
	    getTag = __webpack_require__(286),
	    isArray = __webpack_require__(43),
	    isBuffer = __webpack_require__(452),
	    isTypedArray = __webpack_require__(753);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ },
/* 2075 */
/***/ function(module, exports, __webpack_require__) {

	var getTag = __webpack_require__(286),
	    isObjectLike = __webpack_require__(85);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]';
	
	/**
	 * The base implementation of `_.isMap` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 */
	function baseIsMap(value) {
	  return isObjectLike(value) && getTag(value) == mapTag;
	}
	
	module.exports = baseIsMap;


/***/ },
/* 2076 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(436),
	    baseIsEqual = __webpack_require__(440);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ },
/* 2077 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	module.exports = baseIsNaN;


/***/ },
/* 2078 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(38),
	    isMasked = __webpack_require__(2134),
	    isObject = __webpack_require__(72),
	    toSource = __webpack_require__(751);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ },
/* 2079 */
/***/ function(module, exports, __webpack_require__) {

	var getTag = __webpack_require__(286),
	    isObjectLike = __webpack_require__(85);
	
	/** `Object#toString` result references. */
	var setTag = '[object Set]';
	
	/**
	 * The base implementation of `_.isSet` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	 */
	function baseIsSet(value) {
	  return isObjectLike(value) && getTag(value) == setTag;
	}
	
	module.exports = baseIsSet;


/***/ },
/* 2080 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(125),
	    isLength = __webpack_require__(453),
	    isObjectLike = __webpack_require__(85);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ },
/* 2081 */
/***/ function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(447),
	    nativeKeys = __webpack_require__(2147);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ },
/* 2082 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(72),
	    isPrototype = __webpack_require__(447),
	    nativeKeysIn = __webpack_require__(2148);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeysIn;


/***/ },
/* 2083 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(2076),
	    getMatchData = __webpack_require__(2120),
	    matchesStrictComparable = __webpack_require__(747);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ },
/* 2084 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(440),
	    get = __webpack_require__(180),
	    hasIn = __webpack_require__(2168),
	    isKey = __webpack_require__(446),
	    isStrictComparable = __webpack_require__(746),
	    matchesStrictComparable = __webpack_require__(747),
	    toKey = __webpack_require__(224);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ },
/* 2085 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(179),
	    baseGet = __webpack_require__(283),
	    baseIteratee = __webpack_require__(80),
	    baseMap = __webpack_require__(738),
	    baseSortBy = __webpack_require__(2092),
	    baseUnary = __webpack_require__(222),
	    compareMultiple = __webpack_require__(2106),
	    identity = __webpack_require__(181),
	    isArray = __webpack_require__(43);
	
	/**
	 * The base implementation of `_.orderBy` without param guards.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	 * @param {string[]} orders The sort orders of `iteratees`.
	 * @returns {Array} Returns the new sorted array.
	 */
	function baseOrderBy(collection, iteratees, orders) {
	  if (iteratees.length) {
	    iteratees = arrayMap(iteratees, function(iteratee) {
	      if (isArray(iteratee)) {
	        return function(value) {
	          return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
	        }
	      }
	      return iteratee;
	    });
	  } else {
	    iteratees = [identity];
	  }
	
	  var index = -1;
	  iteratees = arrayMap(iteratees, baseUnary(baseIteratee));
	
	  var result = baseMap(collection, function(value, key, collection) {
	    var criteria = arrayMap(iteratees, function(iteratee) {
	      return iteratee(value);
	    });
	    return { 'criteria': criteria, 'index': ++index, 'value': value };
	  });
	
	  return baseSortBy(result, function(object, other) {
	    return compareMultiple(object, other, orders);
	  });
	}
	
	module.exports = baseOrderBy;


/***/ },
/* 2086 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ },
/* 2087 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(283);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ },
/* 2088 */
/***/ function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeCeil = Math.ceil,
	    nativeMax = Math.max;
	
	/**
	 * The base implementation of `_.range` and `_.rangeRight` which doesn't
	 * coerce arguments.
	 *
	 * @private
	 * @param {number} start The start of the range.
	 * @param {number} end The end of the range.
	 * @param {number} step The value to increment or decrement by.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Array} Returns the range of numbers.
	 */
	function baseRange(start, end, step, fromRight) {
	  var index = -1,
	      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	      result = Array(length);
	
	  while (length--) {
	    result[fromRight ? length : ++index] = start;
	    start += step;
	  }
	  return result;
	}
	
	module.exports = baseRange;


/***/ },
/* 2089 */
/***/ function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(2162),
	    defineProperty = __webpack_require__(740),
	    identity = __webpack_require__(181);
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ },
/* 2090 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;
	
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = end > length ? length : end;
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : ((end - start) >>> 0);
	  start >>>= 0;
	
	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}
	
	module.exports = baseSlice;


/***/ },
/* 2091 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(281);
	
	/**
	 * The base implementation of `_.some` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function baseSome(collection, predicate) {
	  var result;
	
	  baseEach(collection, function(value, index, collection) {
	    result = predicate(value, index, collection);
	    return !result;
	  });
	  return !!result;
	}
	
	module.exports = baseSome;


/***/ },
/* 2092 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.sortBy` which uses `comparer` to define the
	 * sort order of `array` and replaces criteria objects with their corresponding
	 * values.
	 *
	 * @private
	 * @param {Array} array The array to sort.
	 * @param {Function} comparer The function to define sort order.
	 * @returns {Array} Returns `array`.
	 */
	function baseSortBy(array, comparer) {
	  var length = array.length;
	
	  array.sort(comparer);
	  while (length--) {
	    array[length] = array[length].value;
	  }
	  return array;
	}
	
	module.exports = baseSortBy;


/***/ },
/* 2093 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.sum` and `_.sumBy` without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {number} Returns the sum.
	 */
	function baseSum(array, iteratee) {
	  var result,
	      index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    var current = iteratee(array[index]);
	    if (current !== undefined) {
	      result = result === undefined ? current : (result + current);
	    }
	  }
	  return result;
	}
	
	module.exports = baseSum;


/***/ },
/* 2094 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ },
/* 2095 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(178),
	    arrayMap = __webpack_require__(179),
	    isArray = __webpack_require__(43),
	    isSymbol = __webpack_require__(182);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ },
/* 2096 */
/***/ function(module, exports, __webpack_require__) {

	var trimmedEndIndex = __webpack_require__(2161);
	
	/** Used to match leading whitespace. */
	var reTrimStart = /^\s+/;
	
	/**
	 * The base implementation of `_.trim`.
	 *
	 * @private
	 * @param {string} string The string to trim.
	 * @returns {string} Returns the trimmed string.
	 */
	function baseTrim(string) {
	  return string
	    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
	    : string;
	}
	
	module.exports = baseTrim;


/***/ },
/* 2097 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(435),
	    arrayIncludes = __webpack_require__(728),
	    arrayIncludesWith = __webpack_require__(729),
	    cacheHas = __webpack_require__(441),
	    createSet = __webpack_require__(2115),
	    setToArray = __webpack_require__(449);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new duplicate free array.
	 */
	function baseUniq(array, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      length = array.length,
	      isCommon = true,
	      result = [],
	      seen = result;
	
	  if (comparator) {
	    isCommon = false;
	    includes = arrayIncludesWith;
	  }
	  else if (length >= LARGE_ARRAY_SIZE) {
	    var set = iteratee ? null : createSet(array);
	    if (set) {
	      return setToArray(set);
	    }
	    isCommon = false;
	    includes = cacheHas;
	    seen = new SetCache;
	  }
	  else {
	    seen = iteratee ? [] : result;
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (isCommon && computed === computed) {
	      var seenIndex = seen.length;
	      while (seenIndex--) {
	        if (seen[seenIndex] === computed) {
	          continue outer;
	        }
	      }
	      if (iteratee) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	    else if (!includes(seen, computed, comparator)) {
	      if (seen !== result) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseUniq;


/***/ },
/* 2098 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(284),
	    last = __webpack_require__(754),
	    parent = __webpack_require__(2150),
	    toKey = __webpack_require__(224);
	
	/**
	 * The base implementation of `_.unset`.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The property path to unset.
	 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	 */
	function baseUnset(object, path) {
	  path = castPath(path, object);
	  object = parent(object, path);
	  return object == null || delete object[toKey(last(path))];
	}
	
	module.exports = baseUnset;


/***/ },
/* 2099 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLikeObject = __webpack_require__(2170);
	
	/**
	 * Casts `value` to an empty array if it's not an array like object.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Array|Object} Returns the cast array-like object.
	 */
	function castArrayLikeObject(value) {
	  return isArrayLikeObject(value) ? value : [];
	}
	
	module.exports = castArrayLikeObject;


/***/ },
/* 2100 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(84);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	  buffer.copy(result);
	  return result;
	}
	
	module.exports = cloneBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(192)(module)))

/***/ },
/* 2101 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(442);
	
	/**
	 * Creates a clone of `dataView`.
	 *
	 * @private
	 * @param {Object} dataView The data view to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned data view.
	 */
	function cloneDataView(dataView, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	}
	
	module.exports = cloneDataView;


/***/ },
/* 2102 */
/***/ function(module, exports) {

	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */
	function cloneRegExp(regexp) {
	  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	  result.lastIndex = regexp.lastIndex;
	  return result;
	}
	
	module.exports = cloneRegExp;


/***/ },
/* 2103 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(178);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */
	function cloneSymbol(symbol) {
	  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	}
	
	module.exports = cloneSymbol;


/***/ },
/* 2104 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(442);
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	module.exports = cloneTypedArray;


/***/ },
/* 2105 */
/***/ function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(182);
	
	/**
	 * Compares values to sort them in ascending order.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {number} Returns the sort order indicator for `value`.
	 */
	function compareAscending(value, other) {
	  if (value !== other) {
	    var valIsDefined = value !== undefined,
	        valIsNull = value === null,
	        valIsReflexive = value === value,
	        valIsSymbol = isSymbol(value);
	
	    var othIsDefined = other !== undefined,
	        othIsNull = other === null,
	        othIsReflexive = other === other,
	        othIsSymbol = isSymbol(other);
	
	    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	        (valIsNull && othIsDefined && othIsReflexive) ||
	        (!valIsDefined && othIsReflexive) ||
	        !valIsReflexive) {
	      return 1;
	    }
	    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	        (othIsNull && valIsDefined && valIsReflexive) ||
	        (!othIsDefined && valIsReflexive) ||
	        !othIsReflexive) {
	      return -1;
	    }
	  }
	  return 0;
	}
	
	module.exports = compareAscending;


/***/ },
/* 2106 */
/***/ function(module, exports, __webpack_require__) {

	var compareAscending = __webpack_require__(2105);
	
	/**
	 * Used by `_.orderBy` to compare multiple properties of a value to another
	 * and stable sort them.
	 *
	 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	 * specify an order of "desc" for descending or "asc" for ascending sort order
	 * of corresponding values.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {boolean[]|string[]} orders The order to sort by for each property.
	 * @returns {number} Returns the sort order indicator for `object`.
	 */
	function compareMultiple(object, other, orders) {
	  var index = -1,
	      objCriteria = object.criteria,
	      othCriteria = other.criteria,
	      length = objCriteria.length,
	      ordersLength = orders.length;
	
	  while (++index < length) {
	    var result = compareAscending(objCriteria[index], othCriteria[index]);
	    if (result) {
	      if (index >= ordersLength) {
	        return result;
	      }
	      var order = orders[index];
	      return result * (order == 'desc' ? -1 : 1);
	    }
	  }
	  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	  // that causes it, under certain circumstances, to provide the same value for
	  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	  // for more details.
	  //
	  // This also ensures a stable sort in V8 and other engines.
	  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	  return object.index - other.index;
	}
	
	module.exports = compareMultiple;


/***/ },
/* 2107 */
/***/ function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = copyArray;


/***/ },
/* 2108 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(223),
	    getSymbols = __webpack_require__(444);
	
	/**
	 * Copies own symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbols(source, object) {
	  return copyObject(source, getSymbols(source), object);
	}
	
	module.exports = copySymbols;


/***/ },
/* 2109 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(223),
	    getSymbolsIn = __webpack_require__(745);
	
	/**
	 * Copies own and inherited symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbolsIn(source, object) {
	  return copyObject(source, getSymbolsIn(source), object);
	}
	
	module.exports = copySymbolsIn;


/***/ },
/* 2110 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(84);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ },
/* 2111 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(150);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ },
/* 2112 */
/***/ function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ },
/* 2113 */
/***/ function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(80),
	    isArrayLike = __webpack_require__(150),
	    keys = __webpack_require__(183);
	
	/**
	 * Creates a `_.find` or `_.findLast` function.
	 *
	 * @private
	 * @param {Function} findIndexFunc The function to find the collection index.
	 * @returns {Function} Returns the new find function.
	 */
	function createFind(findIndexFunc) {
	  return function(collection, predicate, fromIndex) {
	    var iterable = Object(collection);
	    if (!isArrayLike(collection)) {
	      var iteratee = baseIteratee(predicate, 3);
	      collection = keys(collection);
	      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	    }
	    var index = findIndexFunc(collection, predicate, fromIndex);
	    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	  };
	}
	
	module.exports = createFind;


/***/ },
/* 2114 */
/***/ function(module, exports, __webpack_require__) {

	var baseRange = __webpack_require__(2088),
	    isIterateeCall = __webpack_require__(287),
	    toFinite = __webpack_require__(762);
	
	/**
	 * Creates a `_.range` or `_.rangeRight` function.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new range function.
	 */
	function createRange(fromRight) {
	  return function(start, end, step) {
	    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	      end = step = undefined;
	    }
	    // Ensure the sign of `-0` is preserved.
	    start = toFinite(start);
	    if (end === undefined) {
	      end = start;
	      start = 0;
	    } else {
	      end = toFinite(end);
	    }
	    step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	    return baseRange(start, end, step, fromRight);
	  };
	}
	
	module.exports = createRange;


/***/ },
/* 2115 */
/***/ function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(725),
	    noop = __webpack_require__(2177),
	    setToArray = __webpack_require__(449);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Creates a set object of `values`.
	 *
	 * @private
	 * @param {Array} values The values to add to the set.
	 * @returns {Object} Returns the new set.
	 */
	var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	  return new Set(values);
	};
	
	module.exports = createSet;


/***/ },
/* 2116 */
/***/ function(module, exports, __webpack_require__) {

	var isPlainObject = __webpack_require__(225);
	
	/**
	 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	 * objects.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {string} key The key of the property to inspect.
	 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	 */
	function customOmitClone(value) {
	  return isPlainObject(value) ? undefined : value;
	}
	
	module.exports = customOmitClone;


/***/ },
/* 2117 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(178),
	    Uint8Array = __webpack_require__(726),
	    eq = __webpack_require__(289),
	    equalArrays = __webpack_require__(741),
	    mapToArray = __webpack_require__(2145),
	    setToArray = __webpack_require__(449);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ },
/* 2118 */
/***/ function(module, exports, __webpack_require__) {

	var getAllKeys = __webpack_require__(743);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Check that cyclic values are equal.
	  var objStacked = stack.get(object);
	  var othStacked = stack.get(other);
	  if (objStacked && othStacked) {
	    return objStacked == other && othStacked == object;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ },
/* 2119 */
/***/ function(module, exports, __webpack_require__) {

	var flatten = __webpack_require__(2167),
	    overRest = __webpack_require__(749),
	    setToString = __webpack_require__(750);
	
	/**
	 * A specialized version of `baseRest` which flattens the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @returns {Function} Returns the new function.
	 */
	function flatRest(func) {
	  return setToString(overRest(func, undefined, flatten), func + '');
	}
	
	module.exports = flatRest;


/***/ },
/* 2120 */
/***/ function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(746),
	    keys = __webpack_require__(183);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ },
/* 2121 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(178);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ },
/* 2122 */
/***/ function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ },
/* 2123 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(284),
	    isArguments = __webpack_require__(451),
	    isArray = __webpack_require__(43),
	    isIndex = __webpack_require__(445),
	    isLength = __webpack_require__(453),
	    toKey = __webpack_require__(224);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ },
/* 2124 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(288);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ },
/* 2125 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ },
/* 2126 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(288);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ },
/* 2127 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(288);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ },
/* 2128 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(288);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ },
/* 2129 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = new array.constructor(length);
	
	  // Add properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}
	
	module.exports = initCloneArray;


/***/ },
/* 2130 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(442),
	    cloneDataView = __webpack_require__(2101),
	    cloneRegExp = __webpack_require__(2102),
	    cloneSymbol = __webpack_require__(2103),
	    cloneTypedArray = __webpack_require__(2104);
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return cloneArrayBuffer(object);
	
	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);
	
	    case dataViewTag:
	      return cloneDataView(object, isDeep);
	
	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      return cloneTypedArray(object, isDeep);
	
	    case mapTag:
	      return new Ctor;
	
	    case numberTag:
	    case stringTag:
	      return new Ctor(object);
	
	    case regexpTag:
	      return cloneRegExp(object);
	
	    case setTag:
	      return new Ctor;
	
	    case symbolTag:
	      return cloneSymbol(object);
	  }
	}
	
	module.exports = initCloneByTag;


/***/ },
/* 2131 */
/***/ function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(2066),
	    getPrototype = __webpack_require__(443),
	    isPrototype = __webpack_require__(447);
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	module.exports = initCloneObject;


/***/ },
/* 2132 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(178),
	    isArguments = __webpack_require__(451),
	    isArray = __webpack_require__(43);
	
	/** Built-in value references. */
	var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	module.exports = isFlattenable;


/***/ },
/* 2133 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ },
/* 2134 */
/***/ function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(2110);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ },
/* 2135 */
/***/ function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ },
/* 2136 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(280);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ },
/* 2137 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(280);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ },
/* 2138 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(280);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ },
/* 2139 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(280);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ },
/* 2140 */
/***/ function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(2057),
	    ListCache = __webpack_require__(279),
	    Map = __webpack_require__(433);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ },
/* 2141 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(285);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ },
/* 2142 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(285);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ },
/* 2143 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(285);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ },
/* 2144 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(285);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ },
/* 2145 */
/***/ function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ },
/* 2146 */
/***/ function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(2175);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ },
/* 2147 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(748);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ },
/* 2148 */
/***/ function(module, exports) {

	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = nativeKeysIn;


/***/ },
/* 2149 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ },
/* 2150 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(283),
	    baseSlice = __webpack_require__(2090);
	
	/**
	 * Gets the parent value at `path` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} path The path to get the parent value of.
	 * @returns {*} Returns the parent value.
	 */
	function parent(object, path) {
	  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	}
	
	module.exports = parent;


/***/ },
/* 2151 */
/***/ function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ },
/* 2152 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ },
/* 2153 */
/***/ function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ },
/* 2154 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(279);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ },
/* 2155 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ },
/* 2156 */
/***/ function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ },
/* 2157 */
/***/ function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ },
/* 2158 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(279),
	    Map = __webpack_require__(433),
	    MapCache = __webpack_require__(434);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ },
/* 2159 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.indexOf` which performs strict equality
	 * comparisons of values, i.e. `===`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function strictIndexOf(array, value, fromIndex) {
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = strictIndexOf;


/***/ },
/* 2160 */
/***/ function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(2146);
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (string.charCodeAt(0) === 46 /* . */) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, subString) {
	    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ },
/* 2161 */
/***/ function(module, exports) {

	/** Used to match a single whitespace character. */
	var reWhitespace = /\s/;
	
	/**
	 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
	 * character of `string`.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {number} Returns the index of the last non-whitespace character.
	 */
	function trimmedEndIndex(string) {
	  var index = string.length;
	
	  while (index-- && reWhitespace.test(string.charAt(index))) {}
	  return index;
	}
	
	module.exports = trimmedEndIndex;


/***/ },
/* 2162 */
/***/ function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ },
/* 2163 */
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(727),
	    baseFilter = __webpack_require__(2068),
	    baseIteratee = __webpack_require__(80),
	    isArray = __webpack_require__(43);
	
	/**
	 * Iterates over elements of `collection`, returning an array of all elements
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * **Note:** Unlike `_.remove`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 * @see _.reject
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': true },
	 *   { 'user': 'fred',   'age': 40, 'active': false }
	 * ];
	 *
	 * _.filter(users, function(o) { return !o.active; });
	 * // => objects for ['fred']
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.filter(users, { 'age': 36, 'active': true });
	 * // => objects for ['barney']
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.filter(users, ['active', false]);
	 * // => objects for ['fred']
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.filter(users, 'active');
	 * // => objects for ['barney']
	 *
	 * // Combining several predicates using `_.overEvery` or `_.overSome`.
	 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
	 * // => objects for ['fred', 'barney']
	 */
	function filter(collection, predicate) {
	  var func = isArray(collection) ? arrayFilter : baseFilter;
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = filter;


/***/ },
/* 2164 */
/***/ function(module, exports, __webpack_require__) {

	var createFind = __webpack_require__(2113),
	    findIndex = __webpack_require__(2165);
	
	/**
	 * Iterates over elements of `collection`, returning the first element
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {*} Returns the matched element, else `undefined`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'age': 36, 'active': true },
	 *   { 'user': 'fred',    'age': 40, 'active': false },
	 *   { 'user': 'pebbles', 'age': 1,  'active': true }
	 * ];
	 *
	 * _.find(users, function(o) { return o.age < 40; });
	 * // => object for 'barney'
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.find(users, { 'age': 1, 'active': true });
	 * // => object for 'pebbles'
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.find(users, ['active', false]);
	 * // => object for 'fred'
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.find(users, 'active');
	 * // => object for 'barney'
	 */
	var find = createFind(findIndex);
	
	module.exports = find;


/***/ },
/* 2165 */
/***/ function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(733),
	    baseIteratee = __webpack_require__(80),
	    toInteger = __webpack_require__(2183);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * This method is like `_.find` except that it returns the index of the first
	 * element `predicate` returns truthy for instead of the element itself.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {number} Returns the index of the found element, else `-1`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'active': false },
	 *   { 'user': 'fred',    'active': false },
	 *   { 'user': 'pebbles', 'active': true }
	 * ];
	 *
	 * _.findIndex(users, function(o) { return o.user == 'barney'; });
	 * // => 0
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.findIndex(users, { 'user': 'fred', 'active': false });
	 * // => 1
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.findIndex(users, ['active', false]);
	 * // => 0
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.findIndex(users, 'active');
	 * // => 2
	 */
	function findIndex(array, predicate, fromIndex) {
	  var length = array == null ? 0 : array.length;
	  if (!length) {
	    return -1;
	  }
	  var index = fromIndex == null ? 0 : toInteger(fromIndex);
	  if (index < 0) {
	    index = nativeMax(length + index, 0);
	  }
	  return baseFindIndex(array, baseIteratee(predicate, 3), index);
	}
	
	module.exports = findIndex;


/***/ },
/* 2166 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(439),
	    map = __webpack_require__(2173);
	
	/**
	 * Creates a flattened array of values by running each element in `collection`
	 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	 * with three arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * function duplicate(n) {
	 *   return [n, n];
	 * }
	 *
	 * _.flatMap([1, 2], duplicate);
	 * // => [1, 1, 2, 2]
	 */
	function flatMap(collection, iteratee) {
	  return baseFlatten(map(collection, iteratee), 1);
	}
	
	module.exports = flatMap;


/***/ },
/* 2167 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(439);
	
	/**
	 * Flattens `array` a single level deep.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to flatten.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * _.flatten([1, [2, [3, [4]], 5]]);
	 * // => [1, 2, [3, [4]], 5]
	 */
	function flatten(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? baseFlatten(array, 1) : [];
	}
	
	module.exports = flatten;


/***/ },
/* 2168 */
/***/ function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(2070),
	    hasPath = __webpack_require__(2123);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ },
/* 2169 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(179),
	    baseIntersection = __webpack_require__(2072),
	    baseRest = __webpack_require__(739),
	    castArrayLikeObject = __webpack_require__(2099);
	
	/**
	 * Creates an array of unique values that are included in all given arrays
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons. The order and references of result values are
	 * determined by the first array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @returns {Array} Returns the new array of intersecting values.
	 * @example
	 *
	 * _.intersection([2, 1], [2, 3]);
	 * // => [2]
	 */
	var intersection = baseRest(function(arrays) {
	  var mapped = arrayMap(arrays, castArrayLikeObject);
	  return (mapped.length && mapped[0] === arrays[0])
	    ? baseIntersection(mapped)
	    : [];
	});
	
	module.exports = intersection;


/***/ },
/* 2170 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(150),
	    isObjectLike = __webpack_require__(85);
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	module.exports = isArrayLikeObject;


/***/ },
/* 2171 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsMap = __webpack_require__(2075),
	    baseUnary = __webpack_require__(222),
	    nodeUtil = __webpack_require__(448);
	
	/* Node.js helper references. */
	var nodeIsMap = nodeUtil && nodeUtil.isMap;
	
	/**
	 * Checks if `value` is classified as a `Map` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 * @example
	 *
	 * _.isMap(new Map);
	 * // => true
	 *
	 * _.isMap(new WeakMap);
	 * // => false
	 */
	var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	module.exports = isMap;


/***/ },
/* 2172 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsSet = __webpack_require__(2079),
	    baseUnary = __webpack_require__(222),
	    nodeUtil = __webpack_require__(448);
	
	/* Node.js helper references. */
	var nodeIsSet = nodeUtil && nodeUtil.isSet;
	
	/**
	 * Checks if `value` is classified as a `Set` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	 * @example
	 *
	 * _.isSet(new Set);
	 * // => true
	 *
	 * _.isSet(new WeakSet);
	 * // => false
	 */
	var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	module.exports = isSet;


/***/ },
/* 2173 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(179),
	    baseIteratee = __webpack_require__(80),
	    baseMap = __webpack_require__(738),
	    isArray = __webpack_require__(43);
	
	/**
	 * Creates an array of values by running each element in `collection` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	 *
	 * The guarded methods are:
	 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * _.map([4, 8], square);
	 * // => [16, 64]
	 *
	 * _.map({ 'a': 4, 'b': 8 }, square);
	 * // => [16, 64] (iteration order is not guaranteed)
	 *
	 * var users = [
	 *   { 'user': 'barney' },
	 *   { 'user': 'fred' }
	 * ];
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.map(users, 'user');
	 * // => ['barney', 'fred']
	 */
	function map(collection, iteratee) {
	  var func = isArray(collection) ? arrayMap : baseMap;
	  return func(collection, baseIteratee(iteratee, 3));
	}
	
	module.exports = map;


/***/ },
/* 2174 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(438),
	    baseForOwn = __webpack_require__(734),
	    baseIteratee = __webpack_require__(80);
	
	/**
	 * Creates an object with the same keys as `object` and values generated
	 * by running each own enumerable string keyed property of `object` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, key, object).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Object} Returns the new mapped object.
	 * @see _.mapKeys
	 * @example
	 *
	 * var users = {
	 *   'fred':    { 'user': 'fred',    'age': 40 },
	 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	 * };
	 *
	 * _.mapValues(users, function(o) { return o.age; });
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.mapValues(users, 'age');
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 */
	function mapValues(object, iteratee) {
	  var result = {};
	  iteratee = baseIteratee(iteratee, 3);
	
	  baseForOwn(object, function(value, key, object) {
	    baseAssignValue(result, key, iteratee(value, key, object));
	  });
	  return result;
	}
	
	module.exports = mapValues;


/***/ },
/* 2175 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(434);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ },
/* 2176 */
/***/ function(module, exports, __webpack_require__) {

	var baseExtremum = __webpack_require__(282),
	    baseIteratee = __webpack_require__(80),
	    baseLt = __webpack_require__(737);
	
	/**
	 * This method is like `_.min` except that it accepts `iteratee` which is
	 * invoked for each element in `array` to generate the criterion by which
	 * the value is ranked. The iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	 * @returns {*} Returns the minimum value.
	 * @example
	 *
	 * var objects = [{ 'n': 1 }, { 'n': 2 }];
	 *
	 * _.minBy(objects, function(o) { return o.n; });
	 * // => { 'n': 1 }
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.minBy(objects, 'n');
	 * // => { 'n': 1 }
	 */
	function minBy(array, iteratee) {
	  return (array && array.length)
	    ? baseExtremum(array, baseIteratee(iteratee, 2), baseLt)
	    : undefined;
	}
	
	module.exports = minBy;


/***/ },
/* 2177 */
/***/ function(module, exports) {

	/**
	 * This method returns `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.3.0
	 * @category Util
	 * @example
	 *
	 * _.times(2, _.noop);
	 * // => [undefined, undefined]
	 */
	function noop() {
	  // No operation performed.
	}
	
	module.exports = noop;


/***/ },
/* 2178 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(84);
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	module.exports = now;


/***/ },
/* 2179 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(2086),
	    basePropertyDeep = __webpack_require__(2087),
	    isKey = __webpack_require__(446),
	    toKey = __webpack_require__(224);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ },
/* 2180 */
/***/ function(module, exports, __webpack_require__) {

	var arraySome = __webpack_require__(731),
	    baseIteratee = __webpack_require__(80),
	    baseSome = __webpack_require__(2091),
	    isArray = __webpack_require__(43),
	    isIterateeCall = __webpack_require__(287);
	
	/**
	 * Checks if `predicate` returns truthy for **any** element of `collection`.
	 * Iteration is stopped once `predicate` returns truthy. The predicate is
	 * invoked with three arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 * @example
	 *
	 * _.some([null, 0, 'yes', false], Boolean);
	 * // => true
	 *
	 * var users = [
	 *   { 'user': 'barney', 'active': true },
	 *   { 'user': 'fred',   'active': false }
	 * ];
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.some(users, { 'user': 'barney', 'active': false });
	 * // => false
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.some(users, ['active', false]);
	 * // => true
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.some(users, 'active');
	 * // => true
	 */
	function some(collection, predicate, guard) {
	  var func = isArray(collection) ? arraySome : baseSome;
	  if (guard && isIterateeCall(collection, predicate, guard)) {
	    predicate = undefined;
	  }
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = some;


/***/ },
/* 2181 */
/***/ function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ },
/* 2182 */
/***/ function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(80),
	    baseSum = __webpack_require__(2093);
	
	/**
	 * This method is like `_.sum` except that it accepts `iteratee` which is
	 * invoked for each element in `array` to generate the value to be summed.
	 * The iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	 * @returns {number} Returns the sum.
	 * @example
	 *
	 * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	 *
	 * _.sumBy(objects, function(o) { return o.n; });
	 * // => 20
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.sumBy(objects, 'n');
	 * // => 20
	 */
	function sumBy(array, iteratee) {
	  return (array && array.length)
	    ? baseSum(array, baseIteratee(iteratee, 2))
	    : 0;
	}
	
	module.exports = sumBy;


/***/ },
/* 2183 */
/***/ function(module, exports, __webpack_require__) {

	var toFinite = __webpack_require__(762);
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	module.exports = toInteger;


/***/ },
/* 2184 */
/***/ function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(2095);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ },
/* 2185 */
/***/ function(module, exports, __webpack_require__) {

	var Mexp=__webpack_require__(2189);
	Mexp.prototype.formulaEval = function () {
		"use strict";
		var stack=[],pop1,pop2,pop3;
		var disp=[];
		var temp='';
		var arr=this.value;
		for(var i=0;i<arr.length;i++){
			if(arr[i].type===1||arr[i].type===3){
				disp.push({value:arr[i].type===3?arr[i].show:arr[i].value,type:1});
			}
			else if(arr[i].type===13){
				disp.push({value:arr[i].show,type:1});
			}
			else if(arr[i].type===0){
				disp[disp.length-1]={value:arr[i].show+(arr[i].show!="-"?"(":"")+disp[disp.length-1].value+(arr[i].show!="-"?")":""),type:0};
			}
			else if(arr[i].type===7){
				disp[disp.length-1]={value:(disp[disp.length-1].type!=1?"(":"")+disp[disp.length-1].value+(disp[disp.length-1].type!=1?")":"")+arr[i].show,type:7};
			}
			else if(arr[i].type===10){
				pop1=disp.pop();
				pop2=disp.pop();
				if(arr[i].show==='P'||arr[i].show==='C')disp.push({value:"<sup>"+pop2.value+"</sup>"+arr[i].show+"<sub>"+pop1.value+"</sub>",type:10});
				else disp.push({value:(pop2.type!=1?"(":"")+pop2.value+(pop2.type!=1?")":"")+"<sup>"+pop1.value+"</sup>",type:1});
			}
			else if(arr[i].type===2||arr[i].type===9){
				pop1=disp.pop();
				pop2=disp.pop();
				disp.push({value:(pop2.type!=1?"(":"")+pop2.value+(pop2.type!=1?")":"")+arr[i].show+(pop1.type!=1?"(":"")+pop1.value+(pop1.type!=1?")":""),type:arr[i].type});
			}
			else if(arr[i].type===12){
				pop1=disp.pop();
				pop2=disp.pop();
				pop3=disp.pop();
				disp.push({value:arr[i].show+"("+pop3.value+","+pop2.value+","+pop1.value+")",type:12});
			}
		}
		return disp[0].value;
	};
	module.exports=Mexp;

/***/ },
/* 2186 */
/***/ function(module, exports, __webpack_require__) {

	'use strict'
	var Mexp = __webpack_require__(2187)
	function inc(arr, val) {
		for (var i = 0; i < arr.length; i++) {
			arr[i] += val
		}
		return arr
	}
	var tokens = [
		{ token: 'sin', show: 'sin', type: 0, value: Mexp.math.sin },
		{ token: 'cos', show: 'cos', type: 0, value: Mexp.math.cos },
		{ token: 'tan', show: 'tan', type: 0, value: Mexp.math.tan },
		{ token: 'pi', show: '&pi;', type: 3, value: 'PI' },
		{ token: '(', show: '(', type: 4, value: '(' },
		{ token: ')', show: ')', type: 5, value: ')' },
		{ token: 'P', show: 'P', type: 10, value: Mexp.math.P },
		{ token: 'C', show: 'C', type: 10, value: Mexp.math.C },
		{ token: ' ', show: ' ', type: 14, value: ' '.anchor },
		{ token: 'asin', show: 'asin', type: 0, value: Mexp.math.asin },
		{ token: 'acos', show: 'acos', type: 0, value: Mexp.math.acos },
		{ token: 'atan', show: 'atan', type: 0, value: Mexp.math.atan },
		{ token: '7', show: '7', type: 1, value: '7' },
		{ token: '8', show: '8', type: 1, value: '8' },
		{ token: '9', show: '9', type: 1, value: '9' },
		{ token: 'int', show: 'Int', type: 0, value: Math.floor },
		{ token: 'cosh', show: 'cosh', type: 0, value: Mexp.math.cosh },
		{ token: 'acosh', show: 'acosh', type: 0, value: Mexp.math.acosh },
		{ token: 'ln', show: ' ln', type: 0, value: Math.log },
		{ token: '^', show: '^', type: 10, value: Math.pow },
		{ token: 'root', show: 'root', type: 0, value: Math.sqrt },
		{ token: '4', show: '4', type: 1, value: '4' },
		{ token: '5', show: '5', type: 1, value: '5' },
		{ token: '6', show: '6', type: 1, value: '6' },
		{ token: '/', show: '&divide;', type: 2, value: Mexp.math.div },
		{ token: '!', show: '!', type: 7, value: Mexp.math.fact },
		{ token: 'tanh', show: 'tanh', type: 0, value: Mexp.math.tanh },
		{ token: 'atanh', show: 'atanh', type: 0, value: Mexp.math.atanh },
		{ token: 'Mod', show: ' Mod ', type: 2, value: Mexp.math.mod },
		{ token: '1', show: '1', type: 1, value: '1' },
		{ token: '2', show: '2', type: 1, value: '2' },
		{ token: '3', show: '3', type: 1, value: '3' },
		{ token: '*', show: '&times;', type: 2, value: Mexp.math.mul },
		{ token: 'sinh', show: 'sinh', type: 0, value: Mexp.math.sinh },
		{ token: 'asinh', show: 'asinh', type: 0, value: Mexp.math.asinh },
		{ token: 'e', show: 'e', type: 3, value: 'E' },
		{ token: 'log', show: ' log', type: 0, value: Mexp.math.log },
		{ token: '0', show: '0', type: 1, value: '0' },
		{ token: '.', show: '.', type: 6, value: '.' },
		{ token: '+', show: '+', type: 9, value: Mexp.math.add },
		{ token: '-', show: '-', type: 9, value: Mexp.math.sub },
		{ token: ',', show: ',', type: 11, value: ',' },
		{ token: 'Sigma', show: '&Sigma;', type: 12, value: Mexp.math.sigma },
		{ token: 'n', show: 'n', type: 13, value: 'n' },
		{ token: 'Pi', show: '&Pi;', type: 12, value: Mexp.math.Pi },
		{ token: 'pow', show: 'pow', type: 8, value: Math.pow, numberOfArguments: 2 },
		{ token: '&', show: '&', type: 9, value: Mexp.math.and },
	]
	var preced = {
		0: 11,
		1: 0,
		2: 3,
		3: 0,
		4: 0,
		5: 0,
		6: 0,
		7: 11,
		8: 11,
		9: 1,
		10: 10,
		11: 0,
		12: 11,
		13: 0,
		14: -1,
		15: 11, // will be filtered after lexer
	} // stores precedence by types
	for (var i = 0; i < tokens.length; i++) {
		tokens[i].precedence = preced[tokens[i].type]
	}
	var type0 = {
		0: true,
		1: true,
		3: true,
		4: true,
		6: true,
		8: true,
		9: true,
		12: true,
		13: true,
		14: true,
		15: true,
	} // type2:true,type4:true,type9:true,type11:true,type21:true,type22
	var type1 = {
		0: true,
		1: true,
		2: true,
		3: true,
		4: true,
		5: true,
		6: true,
		7: true,
		8: true,
		9: true,
		10: true,
		11: true,
		12: true,
		13: true,
		15: true,
	} // type3:true,type5:true,type7:true,type23
	var type1Asterick = {
		0: true,
		3: true,
		4: true,
		8: true,
		12: true,
		13: true,
		15: true,
	}
	var empty = {}
	var type3Asterick = {
		0: true,
		1: true,
		3: true,
		4: true,
		6: true,
		8: true,
		12: true,
		13: true,
		15: true,
	} // type_5:true,type_7:true,type_23
	var type6 = {
		1: true,
	}
	var newAr = [
		[],
		[
			'1',
			'2',
			'3',
			'7',
			'8',
			'9',
			'4',
			'5',
			'6',
			'+',
			'-',
			'*',
			'/',
			'(',
			')',
			'^',
			'!',
			'P',
			'C',
			'e',
			'0',
			'.',
			',',
			'n',
			' ',
			'&',
		],
		['pi', 'ln', 'Pi'],
		['sin', 'cos', 'tan', 'Del', 'int', 'Mod', 'log', 'pow'],
		['asin', 'acos', 'atan', 'cosh', 'root', 'tanh', 'sinh'],
		['acosh', 'atanh', 'asinh', 'Sigma'],
	]
	
	function match(str1, str2, i, x) {
		for (var f = 0; f < x; f++) {
			if (str1[i + f] !== str2[f]) {
				return false
			}
		}
		return true
	}
	Mexp.tokenTypes = {
		FUNCTION_WITH_ONE_ARG: 0,
		NUMBER: 1,
		BINARY_OPERATOR_HIGH_PRECENDENCE: 2,
		CONSTANT: 3,
		OPENING_PARENTHESIS: 4,
		CLOSING_PARENTHESIS: 5,
		DECIMAL: 6,
		POSTFIX_FUNCTION_WITH_ONE_ARG: 7,
		FUNCTION_WITH_N_ARGS: 8,
		BINARY_OPERATOR_LOW_PRECENDENCE: 9,
		BINARY_OPERATOR_PERMUTATION: 10,
		COMMA: 11,
		EVALUATED_FUNCTION: 12,
		EVALUATED_FUNCTION_PARAMETER: 13,
		SPACE: 14,
	}
	/**
	  
	  0 : function with syntax function_name(Maths_exp)
	  1 : numbers
	  2 : binary operators like * / Mod left associate and same precedence
	  3 : Math constant values like e,pi,Cruncher ans
	  4 : opening bracket
	  5 : closing bracket
	  6 : decimal
	  7 : function with syntax (Math_exp)function_name
	  8: function with syntax function_name(Math_exp1,Math_exp2)
	  9 : binary operator like +,-
	  10: binary operator like P C or ^
	  11: ,
	  12: function with , seperated three parameters and third parameter is a string that will be mexp string
	  13: variable of Sigma function
	 */
	Mexp.addToken = function (newTokens) {
		for (var i = 0; i < newTokens.length; i++) {
			var x = newTokens[i].token.length
			var temp = -1
			if (newTokens[i].type === Mexp.tokenTypes.FUNCTION_WITH_N_ARGS && newTokens[i].numberOfArguments === undefined) {
				newTokens[i].numberOfArguments = 2
			}
	
			// newAr is a specially designed data structure index of 1d array = length of tokens
			newAr[x] = newAr[x] || []
			for (var y = 0; y < newAr[x].length; y++) {
				if (newTokens[i].token === newAr[x][y]) {
					temp = indexOfToken(newAr[x][y], tokens)
					break
				}
			}
			if (temp === -1) {
				tokens.push(newTokens[i])
				newTokens[i].precedence = preced[newTokens[i].type]
				if (newAr.length <= newTokens[i].token.length) {
					newAr[newTokens[i].token.length] = []
				}
				newAr[newTokens[i].token.length].push(newTokens[i].token)
			} else {
				// overwrite
				tokens[temp] = newTokens[i]
				newTokens[i].precedence = preced[newTokens[i].type]
			}
		}
	}
	
	function indexOfToken(key, tokens) {
		for (var search = 0; search < tokens.length; search++) {
			if (tokens[search].token === key) return search
		}
		return -1
	}
	function tokenize(string) {
		var nodes = []
		var length = string.length
		var key, x, y
		for (var i = 0; i < length; i++) {
			if (i < length - 1 && string[i] === ' ' && string[i + 1] === ' ') {
				continue
			}
			key = ''
			for (x = string.length - i > newAr.length - 2 ? newAr.length - 1 : string.length - i; x > 0; x--) {
				if (newAr[x] === undefined) continue
				for (y = 0; y < newAr[x].length; y++) {
					if (match(string, newAr[x][y], i, x)) {
						key = newAr[x][y]
						y = newAr[x].length
						x = 0
					}
				}
			}
			i += key.length - 1
			if (key === '') {
				throw new Mexp.Exception("Can't understand after " + string.slice(i))
			}
			nodes.push(tokens[indexOfToken(key, tokens)])
		}
		return nodes
	}
	
	var changeSignObj = {
		value: Mexp.math.changeSign,
		type: 0,
		pre: 21,
		show: '-',
	}
	var closingParObj = {
		value: ')',
		show: ')',
		type: 5,
		pre: 0,
	}
	var openingParObj = {
		value: '(',
		type: 4,
		pre: 0,
		show: '(',
	}
	Mexp.lex = function (inp, tokens) {
		'use strict'
	
		var str = [openingParObj]
	
		var ptc = [] // Parenthesis to close at the beginning is after one token
		var inpStr = inp
		var allowed = type0
		var bracToClose = 0
		var asterick = empty
		var prevKey = ''
		var i
		if (typeof tokens !== 'undefined') {
			Mexp.addToken(tokens)
		}
		var obj = {}
		var nodes = tokenize(inpStr)
		for (i = 0; i < nodes.length; i++) {
			var node = nodes[i]
			if (node.type === 14) {
				if (
					i > 0 &&
					i < nodes.length - 1 &&
					nodes[i + 1].type === 1 &&
					(nodes[i - 1].type === 1 || nodes[i - 1].type === 6)
				) {
					throw new Mexp.Exception('Unexpected Space')
				}
				continue
			}
			var cToken = node.token
			var cType = node.type
			var cEv = node.value
			var cPre = node.precedence
			var cShow = node.show
			var pre = str[str.length - 1]
			var j
			for (j = ptc.length; j--; ) {
				// loop over ptc
				if (ptc[j] === 0) {
					if ([0, 2, 3, 4, 5, 9, 11, 12, 13].indexOf(cType) !== -1) {
						if (allowed[cType] !== true) {
							throw new Mexp.Exception(cToken + ' is not allowed after ' + prevKey)
						}
						str.push(closingParObj)
						allowed = type1
						asterick = type3Asterick
						ptc.pop()
					}
				} else break
			}
			if (allowed[cType] !== true) {
				throw new Mexp.Exception(cToken + ' is not allowed after ' + prevKey)
			}
			if (asterick[cType] === true) {
				cType = 2
				cEv = Mexp.math.mul
				cShow = '&times;'
				cPre = 3
				i = i - 1
			}
			obj = {
				value: cEv,
				type: cType,
				pre: cPre,
				show: cShow,
				numberOfArguments: node.numberOfArguments,
			}
			if (cType === 0) {
				allowed = type0
				asterick = empty
				inc(ptc, 2)
				str.push(obj)
				if (nodes[i + 1].type !== 4) {
					str.push(openingParObj)
					ptc.push(2)
				}
				// bracToClose++
			} else if (cType === 1) {
				if (pre.type === 1) {
					pre.value += cEv
					inc(ptc, 1)
				} else {
					str.push(obj)
				}
				allowed = type1
				asterick = type1Asterick
			} else if (cType === 2) {
				allowed = type0
				asterick = empty
				inc(ptc, 2)
				str.push(obj)
			} else if (cType === 3) {
				// constant
				str.push(obj)
				allowed = type1
				asterick = type3Asterick
			} else if (cType === 4) {
				inc(ptc, 1)
				bracToClose++
				allowed = type0
				asterick = empty
				str.push(obj)
			} else if (cType === 5) {
				if (!bracToClose) {
					throw new Mexp.Exception('Closing parenthesis are more than opening one, wait What!!!')
				}
				bracToClose--
				allowed = type1
				asterick = type3Asterick
				str.push(obj)
				inc(ptc, 1)
			} else if (cType === 6) {
				if (pre.hasDec) {
					throw new Mexp.Exception('Two decimals are not allowed in one number')
				}
				if (pre.type !== 1) {
					pre = {
						value: 0,
						type: 1,
						pre: 0,
					} // pre needs to be changed as it will the last value now to be safe in later code
					str.push(pre)
					// inc(ptc, 1)
				}
				allowed = type6
				inc(ptc, 1)
				asterick = empty
				pre.value += cEv
				pre.hasDec = true
			} else if (cType === 7) {
				allowed = type1
				asterick = type3Asterick
				inc(ptc, 1)
				str.push(obj)
			}
			if (cType === 8) {
				allowed = type0
				asterick = empty
				inc(ptc, node.numberOfArguments + 2)
				str.push(obj)
				// str.push(openingParObj)
				if (nodes[i + 1].type !== 4) {
					str.push(openingParObj)
					ptc.push(node.numberOfArguments + 2)
				}
			} else if (cType === 9) {
				if (pre.type === 9) {
					if (pre.value === Mexp.math.add) {
						pre.value = cEv
						pre.show = cShow
						inc(ptc, 1)
					} else if (pre.value === Mexp.math.sub && cShow === '-') {
						pre.value = Mexp.math.add
						pre.show = '+'
						inc(ptc, 1)
					}
				} else if (pre.type !== 5 && pre.type !== 7 && pre.type !== 1 && pre.type !== 3 && pre.type !== 13) {
					// changesign only when negative is found
					if (cToken === '-') {
						// do nothing for + token
						// don't add with the above if statement as that will run the else statement of parent if on Ctoken +
						allowed = type0
						asterick = empty
						inc(ptc, 2).push(2)
						str.push(changeSignObj)
						str.push(openingParObj)
					}
				} else {
					str.push(obj)
					inc(ptc, 2)
				}
				allowed = type0
				asterick = empty
			} else if (cType === 10) {
				allowed = type0
				asterick = empty
				inc(ptc, 2)
				str.push(obj)
			} else if (cType === 11) {
				allowed = type0
				asterick = empty
				str.push(obj)
			} else if (cType === 12) {
				allowed = type0
				asterick = empty
				inc(ptc, 6)
				str.push(obj)
				if (nodes[i + 1].type !== 4) {
					str.push(openingParObj)
					ptc.push(6)
				}
			} else if (cType === 13) {
				allowed = type1
				asterick = type3Asterick
				str.push(obj)
			}
	
			inc(ptc, -1)
			prevKey = cToken
		}
		for (j = ptc.length; j--; ) {
			// loop over ptc
			str.push(closingParObj)
		}
		if (allowed[5] !== true) {
			throw new Mexp.Exception('complete the expression')
		}
		while (bracToClose--) {
			str.push(closingParObj)
		}
	
		str.push(closingParObj)
		//        console.log(str);
		return new Mexp(str)
	}
	module.exports = Mexp


/***/ },
/* 2187 */
/***/ function(module, exports) {

	"use strict";
	var Mexp = function (parsed) {
	  this.value = parsed
	}
	
	Mexp.math = {
	  isDegree: true, // mode of calculator
	  acos: function (x) {
	    return (Mexp.math.isDegree ? 180 / Math.PI * Math.acos(x) : Math.acos(x))
	  },
	  add: function (a, b) {
	    return a + b
	  },
	  asin: function (x) {
	    return (Mexp.math.isDegree ? 180 / Math.PI * Math.asin(x) : Math.asin(x))
	  },
	  atan: function (x) {
	    return (Mexp.math.isDegree ? 180 / Math.PI * Math.atan(x) : Math.atan(x))
	  },
	  acosh: function (x) {
	    return Math.log(x + Math.sqrt(x * x - 1))
	  },
	  asinh: function (x) {
	    return Math.log(x + Math.sqrt(x * x + 1))
	  },
	  atanh: function (x) {
	    return Math.log((1 + x) / (1 - x))
	  },
	  C: function (n, r) {
	    var pro = 1
	    var other = n - r
	    var choice = r
	    if (choice < other) {
	      choice = other
	      other = r
	    }
	    for (var i = choice + 1; i <= n; i++) {
	      pro *= i
	    }
	    return pro / Mexp.math.fact(other)
	  },
	  changeSign: function (x) {
	    return -x
	  },
	  cos: function (x) {
	    if (Mexp.math.isDegree) x = Mexp.math.toRadian(x)
	    return Math.cos(x)
	  },
	  cosh: function (x) {
	    return (Math.pow(Math.E, x) + Math.pow(Math.E, -1 * x)) / 2
	  },
	  div: function (a, b) {
	    return a / b
	  },
	  fact: function (n) {
	    if (n % 1 !== 0) return 'NaN'
	    var pro = 1
	    for (var i = 2; i <= n; i++) {
	      pro *= i
	    }
	    return pro
	  },
	  inverse: function (x) {
	    return 1 / x
	  },
	  log: function (i) {
	    return Math.log(i) / Math.log(10)
	  },
	  mod: function (a, b) {
	    return a % b
	  },
	  mul: function (a, b) {
	    return a * b
	  },
	  P: function (n, r) {
	    var pro = 1
	    for (var i = Math.floor(n) - Math.floor(r) + 1; i <= Math.floor(n); i++) {
	      pro *= i
	    }
	    return pro
	  },
	  Pi: function (low, high, ex) {
	    var pro = 1
	    for (var i = low; i <= high; i++) {
	      pro *= Number(ex.postfixEval({
	        n: i
	      }))
	    }
	    return pro
	  },
	  pow10x: function (e) {
	    var x = 1
	    while (e--) {
	      x *= 10
	    }
	    return x
	  },
	  sigma: function (low, high, ex) {
	    var sum = 0
	    for (var i = low; i <= high; i++) {
	      sum += Number(ex.postfixEval({
	        n: i
	      }))
	    }
	    return sum
	  },
	  sin: function (x) {
	    if (Mexp.math.isDegree) x = Mexp.math.toRadian(x)
	    return Math.sin(x)
	  },
	  sinh: function (x) {
	    return (Math.pow(Math.E, x) - Math.pow(Math.E, -1 * x)) / 2
	  },
	  sub: function (a, b) {
	    return a - b
	  },
	  tan: function (x) {
	    if (Mexp.math.isDegree) x = Mexp.math.toRadian(x)
	    return Math.tan(x)
	  },
	  tanh: function (x) {
	    return Mexp.sinha(x) / Mexp.cosha(x)
	  },
	  toRadian: function (x) {
	    return x * Math.PI / 180
	  },
	  and: function (a, b) {
	    return a & b
	  }
	}
	Mexp.Exception = function (message) {
	  this.message = message
	}
	module.exports = Mexp


/***/ },
/* 2188 */
/***/ function(module, exports, __webpack_require__) {

	
	var Mexp = __webpack_require__(2186);
	
	Mexp.prototype.toPostfix = function () {
		'use strict';
		var post = [], elem, popped, prep, pre, ele;
		var stack = [{ value: "(", type: 4, pre: 0 }];
		var arr = this.value;
		for (var i = 1; i < arr.length; i++) {
			if (arr[i].type === 1 || arr[i].type === 3 || arr[i].type === 13) {	//if token is number,constant,or n(which is also a special constant in our case)
				if (arr[i].type === 1)
					arr[i].value = Number(arr[i].value);
				post.push(arr[i]);
			}
			else if (arr[i].type === 4) {
				stack.push(arr[i]);
			}
			else if (arr[i].type === 5) {
				while ((popped = stack.pop()).type !== 4) {
					post.push(popped);
				}
			}
			else if (arr[i].type === 11) {
				while ((popped = stack.pop()).type !== 4) {
					post.push(popped);
				}
				stack.push(popped);
			}
			else {
				elem = arr[i];
				pre = elem.pre;
				ele = stack[stack.length - 1];
				prep = ele.pre;
				var flag = ele.value == 'Math.pow' && elem.value == 'Math.pow';
				if (pre > prep) stack.push(elem);
				else {
					while (prep >= pre && !flag || flag && pre < prep) {
						popped = stack.pop();
						ele = stack[stack.length - 1];
						post.push(popped);
						prep = ele.pre;
						flag = elem.value == 'Math.pow' && ele.value == 'Math.pow';
					}
					stack.push(elem);
				}
			}
		}
		return new Mexp(post);
	};
	module.exports = Mexp;

/***/ },
/* 2189 */
/***/ function(module, exports, __webpack_require__) {

	var Mexp = __webpack_require__(2188)
	Mexp.prototype.postfixEval = function (UserDefined) {
		'use strict'
		UserDefined = UserDefined || {}
		UserDefined.PI = Math.PI
		UserDefined.E = Math.E
		var stack = [],
			pop1,
			pop2,
			pop3
		var disp = []
		var temp = ''
		var arr = this.value
		var bool = typeof UserDefined.n !== 'undefined'
		for (var i = 0; i < arr.length; i++) {
			if (arr[i].type === 1) {
				stack.push({ value: arr[i].value, type: 1 })
			} else if (arr[i].type === 3) {
				stack.push({ value: UserDefined[arr[i].value], type: 1 })
			} else if (arr[i].type === 0) {
				if (typeof stack[stack.length - 1].type === 'undefined') {
					stack[stack.length - 1].value.push(arr[i])
				} else stack[stack.length - 1].value = arr[i].value(stack[stack.length - 1].value)
			} else if (arr[i].type === 7) {
				if (typeof stack[stack.length - 1].type === 'undefined') {
					stack[stack.length - 1].value.push(arr[i])
				} else stack[stack.length - 1].value = arr[i].value(stack[stack.length - 1].value)
			} else if (arr[i].type === 8) {
				var popped = []
				for (var x = 0; x < arr[i].numberOfArguments; x++) {
					popped.push(stack.pop().value)
				}
				stack.push({ type: 1, value: arr[i].value.apply(arr[i], popped.reverse()) })
			} else if (arr[i].type === 10) {
				pop1 = stack.pop()
				pop2 = stack.pop()
				if (typeof pop2.type === 'undefined') {
					pop2.value = pop2.concat(pop1)
					pop2.value.push(arr[i])
					stack.push(pop2)
				} else if (typeof pop1.type === 'undefined') {
					pop1.unshift(pop2)
					pop1.push(arr[i])
					stack.push(pop1)
				} else {
					stack.push({ type: 1, value: arr[i].value(pop2.value, pop1.value) })
				}
			} else if (arr[i].type === 2 || arr[i].type === 9) {
				pop1 = stack.pop()
				pop2 = stack.pop()
				if (typeof pop2.type === 'undefined') {
					pop2 = pop2.concat(pop1)
					pop2.push(arr[i])
					stack.push(pop2)
				} else if (typeof pop1.type === 'undefined') {
					pop1.unshift(pop2)
					pop1.push(arr[i])
					stack.push(pop1)
				} else {
					stack.push({ type: 1, value: arr[i].value(pop2.value, pop1.value) })
				}
			} else if (arr[i].type === 12) {
				pop1 = stack.pop()
				if (typeof pop1.type !== 'undefined') {
					pop1 = [pop1]
				}
				pop2 = stack.pop()
				pop3 = stack.pop()
				stack.push({ type: 1, value: arr[i].value(pop3.value, pop2.value, new Mexp(pop1)) })
			} else if (arr[i].type === 13) {
				if (bool) {
					stack.push({ value: UserDefined[arr[i].value], type: 3 })
				} else stack.push([arr[i]])
			}
		}
		if (stack.length > 1) {
			throw new Mexp.Exception('Uncaught Syntax error')
		}
		return stack[0].value > 1000000000000000 ? 'Infinity' : parseFloat(stack[0].value.toFixed(15))
	}
	Mexp.eval = function (str, tokens, obj) {
		if (typeof tokens === 'undefined') {
			return this.lex(str).toPostfix().postfixEval()
		} else if (typeof obj === 'undefined') {
			if (typeof tokens.length !== 'undefined') return this.lex(str, tokens).toPostfix().postfixEval()
			else return this.lex(str).toPostfix().postfixEval(tokens)
		} else return this.lex(str, tokens).toPostfix().postfixEval(obj)
	}
	module.exports = Mexp


/***/ },
/* 2190 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 765,
		"./af.js": 765,
		"./ar": 773,
		"./ar-dz": 766,
		"./ar-dz.js": 766,
		"./ar-kw": 767,
		"./ar-kw.js": 767,
		"./ar-ly": 768,
		"./ar-ly.js": 768,
		"./ar-ma": 769,
		"./ar-ma.js": 769,
		"./ar-ps": 770,
		"./ar-ps.js": 770,
		"./ar-sa": 771,
		"./ar-sa.js": 771,
		"./ar-tn": 772,
		"./ar-tn.js": 772,
		"./ar.js": 773,
		"./az": 774,
		"./az.js": 774,
		"./be": 775,
		"./be.js": 775,
		"./bg": 776,
		"./bg.js": 776,
		"./bm": 777,
		"./bm.js": 777,
		"./bn": 779,
		"./bn-bd": 778,
		"./bn-bd.js": 778,
		"./bn.js": 779,
		"./bo": 780,
		"./bo.js": 780,
		"./br": 781,
		"./br.js": 781,
		"./bs": 782,
		"./bs.js": 782,
		"./ca": 783,
		"./ca.js": 783,
		"./cs": 784,
		"./cs.js": 784,
		"./cv": 785,
		"./cv.js": 785,
		"./cy": 786,
		"./cy.js": 786,
		"./da": 787,
		"./da.js": 787,
		"./de": 790,
		"./de-at": 788,
		"./de-at.js": 788,
		"./de-ch": 789,
		"./de-ch.js": 789,
		"./de.js": 790,
		"./dv": 791,
		"./dv.js": 791,
		"./el": 792,
		"./el.js": 792,
		"./en-au": 793,
		"./en-au.js": 793,
		"./en-ca": 794,
		"./en-ca.js": 794,
		"./en-gb": 795,
		"./en-gb.js": 795,
		"./en-ie": 796,
		"./en-ie.js": 796,
		"./en-il": 797,
		"./en-il.js": 797,
		"./en-in": 798,
		"./en-in.js": 798,
		"./en-nz": 799,
		"./en-nz.js": 799,
		"./en-sg": 800,
		"./en-sg.js": 800,
		"./eo": 801,
		"./eo.js": 801,
		"./es": 805,
		"./es-do": 802,
		"./es-do.js": 802,
		"./es-mx": 803,
		"./es-mx.js": 803,
		"./es-us": 804,
		"./es-us.js": 804,
		"./es.js": 805,
		"./et": 806,
		"./et.js": 806,
		"./eu": 807,
		"./eu.js": 807,
		"./fa": 808,
		"./fa.js": 808,
		"./fi": 809,
		"./fi.js": 809,
		"./fil": 810,
		"./fil.js": 810,
		"./fo": 811,
		"./fo.js": 811,
		"./fr": 814,
		"./fr-ca": 812,
		"./fr-ca.js": 812,
		"./fr-ch": 813,
		"./fr-ch.js": 813,
		"./fr.js": 814,
		"./fy": 815,
		"./fy.js": 815,
		"./ga": 816,
		"./ga.js": 816,
		"./gd": 817,
		"./gd.js": 817,
		"./gl": 818,
		"./gl.js": 818,
		"./gom-deva": 819,
		"./gom-deva.js": 819,
		"./gom-latn": 820,
		"./gom-latn.js": 820,
		"./gu": 821,
		"./gu.js": 821,
		"./he": 822,
		"./he.js": 822,
		"./hi": 823,
		"./hi.js": 823,
		"./hr": 824,
		"./hr.js": 824,
		"./hu": 825,
		"./hu.js": 825,
		"./hy-am": 826,
		"./hy-am.js": 826,
		"./id": 827,
		"./id.js": 827,
		"./is": 828,
		"./is.js": 828,
		"./it": 830,
		"./it-ch": 829,
		"./it-ch.js": 829,
		"./it.js": 830,
		"./ja": 831,
		"./ja.js": 831,
		"./jv": 832,
		"./jv.js": 832,
		"./ka": 833,
		"./ka.js": 833,
		"./kk": 834,
		"./kk.js": 834,
		"./km": 835,
		"./km.js": 835,
		"./kn": 836,
		"./kn.js": 836,
		"./ko": 837,
		"./ko.js": 837,
		"./ku": 839,
		"./ku-kmr": 838,
		"./ku-kmr.js": 838,
		"./ku.js": 839,
		"./ky": 840,
		"./ky.js": 840,
		"./lb": 841,
		"./lb.js": 841,
		"./lo": 842,
		"./lo.js": 842,
		"./lt": 843,
		"./lt.js": 843,
		"./lv": 844,
		"./lv.js": 844,
		"./me": 845,
		"./me.js": 845,
		"./mi": 846,
		"./mi.js": 846,
		"./mk": 847,
		"./mk.js": 847,
		"./ml": 848,
		"./ml.js": 848,
		"./mn": 849,
		"./mn.js": 849,
		"./mr": 850,
		"./mr.js": 850,
		"./ms": 852,
		"./ms-my": 851,
		"./ms-my.js": 851,
		"./ms.js": 852,
		"./mt": 853,
		"./mt.js": 853,
		"./my": 854,
		"./my.js": 854,
		"./nb": 855,
		"./nb.js": 855,
		"./ne": 856,
		"./ne.js": 856,
		"./nl": 858,
		"./nl-be": 857,
		"./nl-be.js": 857,
		"./nl.js": 858,
		"./nn": 859,
		"./nn.js": 859,
		"./oc-lnc": 860,
		"./oc-lnc.js": 860,
		"./pa-in": 861,
		"./pa-in.js": 861,
		"./pl": 862,
		"./pl.js": 862,
		"./pt": 864,
		"./pt-br": 863,
		"./pt-br.js": 863,
		"./pt.js": 864,
		"./ro": 865,
		"./ro.js": 865,
		"./ru": 866,
		"./ru.js": 866,
		"./sd": 867,
		"./sd.js": 867,
		"./se": 868,
		"./se.js": 868,
		"./si": 869,
		"./si.js": 869,
		"./sk": 870,
		"./sk.js": 870,
		"./sl": 871,
		"./sl.js": 871,
		"./sq": 872,
		"./sq.js": 872,
		"./sr": 874,
		"./sr-cyrl": 873,
		"./sr-cyrl.js": 873,
		"./sr.js": 874,
		"./ss": 875,
		"./ss.js": 875,
		"./sv": 876,
		"./sv.js": 876,
		"./sw": 877,
		"./sw.js": 877,
		"./ta": 878,
		"./ta.js": 878,
		"./te": 879,
		"./te.js": 879,
		"./tet": 880,
		"./tet.js": 880,
		"./tg": 881,
		"./tg.js": 881,
		"./th": 882,
		"./th.js": 882,
		"./tk": 883,
		"./tk.js": 883,
		"./tl-ph": 884,
		"./tl-ph.js": 884,
		"./tlh": 885,
		"./tlh.js": 885,
		"./tr": 886,
		"./tr.js": 886,
		"./tzl": 887,
		"./tzl.js": 887,
		"./tzm": 889,
		"./tzm-latn": 888,
		"./tzm-latn.js": 888,
		"./tzm.js": 889,
		"./ug-cn": 890,
		"./ug-cn.js": 890,
		"./uk": 891,
		"./uk.js": 891,
		"./ur": 892,
		"./ur.js": 892,
		"./uz": 894,
		"./uz-latn": 893,
		"./uz-latn.js": 893,
		"./uz.js": 894,
		"./vi": 895,
		"./vi.js": 895,
		"./x-pseudo": 896,
		"./x-pseudo.js": 896,
		"./yo": 897,
		"./yo.js": 897,
		"./zh-cn": 898,
		"./zh-cn.js": 898,
		"./zh-hk": 899,
		"./zh-hk.js": 899,
		"./zh-mo": 900,
		"./zh-mo.js": 900,
		"./zh-tw": 901,
		"./zh-tw.js": 901
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 2190;


/***/ },
/* 2191 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(518)
	var ieee754 = __webpack_require__(722)
	var isArray = __webpack_require__(2040)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 2192 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(216);
	var callBind = __webpack_require__(338);
	
	var implementation = __webpack_require__(903);
	var getPolyfill = __webpack_require__(904);
	var shim = __webpack_require__(2193);
	
	var polyfill = callBind(getPolyfill(), Object);
	
	define(polyfill, {
		getPolyfill: getPolyfill,
		implementation: implementation,
		shim: shim
	});
	
	module.exports = polyfill;


/***/ },
/* 2193 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var getPolyfill = __webpack_require__(904);
	var define = __webpack_require__(216);
	
	module.exports = function shimObjectIs() {
		var polyfill = getPolyfill();
		define(Object, { is: polyfill }, {
			is: function testObjectIs() {
				return Object.is !== polyfill;
			}
		});
		return polyfill;
	};


/***/ },
/* 2194 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var keysShim;
	if (!Object.keys) {
		// modified from https://github.com/es-shims/es5-shim
		var has = Object.prototype.hasOwnProperty;
		var toStr = Object.prototype.toString;
		var isArgs = __webpack_require__(906); // eslint-disable-line global-require
		var isEnumerable = Object.prototype.propertyIsEnumerable;
		var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
		var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
		var dontEnums = [
			'toString',
			'toLocaleString',
			'valueOf',
			'hasOwnProperty',
			'isPrototypeOf',
			'propertyIsEnumerable',
			'constructor'
		];
		var equalsConstructorPrototype = function (o) {
			var ctor = o.constructor;
			return ctor && ctor.prototype === o;
		};
		var excludedKeys = {
			$applicationCache: true,
			$console: true,
			$external: true,
			$frame: true,
			$frameElement: true,
			$frames: true,
			$innerHeight: true,
			$innerWidth: true,
			$onmozfullscreenchange: true,
			$onmozfullscreenerror: true,
			$outerHeight: true,
			$outerWidth: true,
			$pageXOffset: true,
			$pageYOffset: true,
			$parent: true,
			$scrollLeft: true,
			$scrollTop: true,
			$scrollX: true,
			$scrollY: true,
			$self: true,
			$webkitIndexedDB: true,
			$webkitStorageInfo: true,
			$window: true
		};
		var hasAutomationEqualityBug = (function () {
			/* global window */
			if (typeof window === 'undefined') { return false; }
			for (var k in window) {
				try {
					if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
						try {
							equalsConstructorPrototype(window[k]);
						} catch (e) {
							return true;
						}
					}
				} catch (e) {
					return true;
				}
			}
			return false;
		}());
		var equalsConstructorPrototypeIfNotBuggy = function (o) {
			/* global window */
			if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
				return equalsConstructorPrototype(o);
			}
			try {
				return equalsConstructorPrototype(o);
			} catch (e) {
				return false;
			}
		};
	
		keysShim = function keys(object) {
			var isObject = object !== null && typeof object === 'object';
			var isFunction = toStr.call(object) === '[object Function]';
			var isArguments = isArgs(object);
			var isString = isObject && toStr.call(object) === '[object String]';
			var theKeys = [];
	
			if (!isObject && !isFunction && !isArguments) {
				throw new TypeError('Object.keys called on a non-object');
			}
	
			var skipProto = hasProtoEnumBug && isFunction;
			if (isString && object.length > 0 && !has.call(object, 0)) {
				for (var i = 0; i < object.length; ++i) {
					theKeys.push(String(i));
				}
			}
	
			if (isArguments && object.length > 0) {
				for (var j = 0; j < object.length; ++j) {
					theKeys.push(String(j));
				}
			} else {
				for (var name in object) {
					if (!(skipProto && name === 'prototype') && has.call(object, name)) {
						theKeys.push(String(name));
					}
				}
			}
	
			if (hasDontEnumBug) {
				var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);
	
				for (var k = 0; k < dontEnums.length; ++k) {
					if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
						theKeys.push(dontEnums[k]);
					}
				}
			}
			return theKeys;
		};
	}
	module.exports = keysShim;


/***/ },
/* 2195 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
	(function() {
	  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - nodeLoadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    moduleLoadTime = getNanoSeconds();
	    upTime = process.uptime() * 1e9;
	    nodeLoadTime = moduleLoadTime - upTime;
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	//# sourceMappingURL=performance-now.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(902)))

/***/ },
/* 2196 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(908);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 2197 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(908);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 2198 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = deprecated;
	
	var _warning = __webpack_require__(319);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function deprecated(validator, reason) {
	  return function validate(props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] != null) {
	      var messageKey = componentName + '.' + propName;
	
	      (0, _warning2.default)(warned[messageKey], 'The ' + location + ' `' + propFullNameSafe + '` of ' + ('`' + componentNameSafe + '` is deprecated. ' + reason + '.'));
	
	      warned[messageKey] = true;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
	      args[_key - 5] = arguments[_key];
	    }
	
	    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	  };
	}
	
	/* eslint-disable no-underscore-dangle */
	function _resetWarned() {
	  warned = {};
	}
	
	deprecated._resetWarned = _resetWarned;
	/* eslint-enable no-underscore-dangle */
	
	module.exports = exports['default'];

/***/ },
/* 2199 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(2200);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bigint: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 2200 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 2201 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	var __rest = (this && this.__rest) || function (s, e) {
	    var t = {};
	    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	        t[p] = s[p];
	    if (s != null && typeof Object.getOwnPropertySymbols === "function")
	        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
	            t[p[i]] = s[p[i]];
	    return t;
	};
	exports.__esModule = true;
	var React = __webpack_require__(1);
	var PropTypes = __webpack_require__(2);
	var autosize = __webpack_require__(1058);
	var _getLineHeight = __webpack_require__(2051);
	var getLineHeight = _getLineHeight;
	var UPDATE = 'autosize:update';
	var DESTROY = 'autosize:destroy';
	var RESIZED = 'autosize:resized';
	/**
	 * A light replacement for built-in textarea component
	 * which automaticaly adjusts its height to match the content
	 */
	var TextareaAutosize = /** @class */ (function (_super) {
	    __extends(TextareaAutosize, _super);
	    function TextareaAutosize() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.state = {
	            lineHeight: null
	        };
	        _this.dispatchEvent = function (EVENT_TYPE) {
	            var event = document.createEvent('Event');
	            event.initEvent(EVENT_TYPE, true, false);
	            _this.textarea.dispatchEvent(event);
	        };
	        _this.updateLineHeight = function () {
	            _this.setState({
	                lineHeight: getLineHeight(_this.textarea)
	            });
	        };
	        _this.onChange = function (e) {
	            var onChange = _this.props.onChange;
	            _this.currentValue = e.currentTarget.value;
	            onChange && onChange(e);
	        };
	        _this.saveDOMNodeRef = function (ref) {
	            var innerRef = _this.props.innerRef;
	            if (innerRef) {
	                innerRef(ref);
	            }
	            _this.textarea = ref;
	        };
	        _this.getLocals = function () {
	            var _a = _this, _b = _a.props, onResize = _b.onResize, maxRows = _b.maxRows, onChange = _b.onChange, style = _b.style, innerRef = _b.innerRef, props = __rest(_b, ["onResize", "maxRows", "onChange", "style", "innerRef"]), lineHeight = _a.state.lineHeight, saveDOMNodeRef = _a.saveDOMNodeRef;
	            var maxHeight = maxRows && lineHeight ? lineHeight * maxRows : null;
	            return __assign({}, props, { saveDOMNodeRef: saveDOMNodeRef, style: maxHeight ? __assign({}, style, { maxHeight: maxHeight }) : style, onChange: _this.onChange });
	        };
	        return _this;
	    }
	    TextareaAutosize.prototype.componentDidMount = function () {
	        var _this = this;
	        var _a = this.props, onResize = _a.onResize, maxRows = _a.maxRows;
	        if (typeof maxRows === 'number') {
	            this.updateLineHeight();
	        }
	        /*
	          the defer is needed to:
	            - force "autosize" to activate the scrollbar when this.props.maxRows is passed
	            - support StyledComponents (see #71)
	        */
	        setTimeout(function () { return autosize(_this.textarea); });
	        if (onResize) {
	            this.textarea.addEventListener(RESIZED, onResize);
	        }
	    };
	    TextareaAutosize.prototype.componentWillUnmount = function () {
	        var onResize = this.props.onResize;
	        if (onResize) {
	            this.textarea.removeEventListener(RESIZED, onResize);
	        }
	        this.dispatchEvent(DESTROY);
	    };
	    TextareaAutosize.prototype.render = function () {
	        var _a = this.getLocals(), children = _a.children, saveDOMNodeRef = _a.saveDOMNodeRef, locals = __rest(_a, ["children", "saveDOMNodeRef"]);
	        return (React.createElement("textarea", __assign({}, locals, { ref: saveDOMNodeRef }), children));
	    };
	    TextareaAutosize.prototype.componentDidUpdate = function () {
	        if (this.props.value !== this.currentValue) {
	            this.dispatchEvent(UPDATE);
	        }
	    };
	    TextareaAutosize.defaultProps = {
	        rows: 1
	    };
	    TextareaAutosize.propTypes = {
	        rows: PropTypes.number,
	        maxRows: PropTypes.number,
	        onResize: PropTypes.func,
	        innerRef: PropTypes.func
	    };
	    return TextareaAutosize;
	}(React.Component));
	exports["default"] = TextareaAutosize;


/***/ },
/* 2202 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PanelGroup = __webpack_require__(929);
	
	var _PanelGroup2 = _interopRequireDefault(_PanelGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Accordion = function (_React$Component) {
	  (0, _inherits3['default'])(Accordion, _React$Component);
	
	  function Accordion() {
	    (0, _classCallCheck3['default'])(this, Accordion);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Accordion.prototype.render = function render() {
	    return _react2['default'].createElement(
	      _PanelGroup2['default'],
	      (0, _extends3['default'])({}, this.props, { accordion: true }),
	      this.props.children
	    );
	  };
	
	  return Accordion;
	}(_react2['default'].Component);
	
	exports['default'] = Accordion;
	module.exports = exports['default'];

/***/ },
/* 2203 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(157);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _extends3 = __webpack_require__(18);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(24);
	
	var _StyleConfig = __webpack_require__(64);
	
	var _CloseButton = __webpack_require__(915);
	
	var _CloseButton2 = _interopRequireDefault(_CloseButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  onDismiss: _propTypes2['default'].func,
	  closeLabel: _propTypes2['default'].string
	};
	
	var defaultProps = {
	  closeLabel: 'Close alert'
	};
	
	var Alert = function (_React$Component) {
	  (0, _inherits3['default'])(Alert, _React$Component);
	
	  function Alert() {
	    (0, _classCallCheck3['default'])(this, Alert);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Alert.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        onDismiss = _props.onDismiss,
	        closeLabel = _props.closeLabel,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['onDismiss', 'closeLabel', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var dismissable = !!onDismiss;
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'dismissable')] = dismissable, _extends2));
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends4['default'])({}, elementProps, {
	        role: 'alert',
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      dismissable && _react2['default'].createElement(_CloseButton2['default'], {
	        onClick: onDismiss,
	        label: closeLabel
	      }),
	      children
	    );
	  };
	
	  return Alert;
	}(_react2['default'].Component);
	
	Alert.propTypes = propTypes;
	Alert.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsStyles)((0, _values2['default'])(_StyleConfig.State), _StyleConfig.State.INFO, (0, _bootstrapUtils.bsClass)('alert', Alert));
	module.exports = exports['default'];

/***/ },
/* 2204 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: `pullRight` doesn't belong here. There's no special handling here.
	
	var propTypes = {
	  pullRight: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  pullRight: false
	};
	
	var Badge = function (_React$Component) {
	  (0, _inherits3['default'])(Badge, _React$Component);
	
	  function Badge() {
	    (0, _classCallCheck3['default'])(this, Badge);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Badge.prototype.hasContent = function hasContent(children) {
	    var result = false;
	
	    _react2['default'].Children.forEach(children, function (child) {
	      if (result) {
	        return;
	      }
	
	      if (child || child === 0) {
	        result = true;
	      }
	    });
	
	    return result;
	  };
	
	  Badge.prototype.render = function render() {
	    var _props = this.props,
	        pullRight = _props.pullRight,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['pullRight', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      'pull-right': pullRight,
	
	      // Hack for collapsing on IE8.
	      hidden: !this.hasContent(children)
	    });
	
	    return _react2['default'].createElement(
	      'span',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      children
	    );
	  };
	
	  return Badge;
	}(_react2['default'].Component);
	
	Badge.propTypes = propTypes;
	Badge.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('badge', Badge);
	module.exports = exports['default'];

/***/ },
/* 2205 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BreadcrumbItem = __webpack_require__(912);
	
	var _BreadcrumbItem2 = _interopRequireDefault(_BreadcrumbItem);
	
	var _bootstrapUtils = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Breadcrumb = function (_React$Component) {
	  (0, _inherits3['default'])(Breadcrumb, _React$Component);
	
	  function Breadcrumb() {
	    (0, _classCallCheck3['default'])(this, Breadcrumb);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Breadcrumb.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('ol', (0, _extends3['default'])({}, elementProps, {
	      role: 'navigation',
	      'aria-label': 'breadcrumbs',
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Breadcrumb;
	}(_react2['default'].Component);
	
	Breadcrumb.Item = _BreadcrumbItem2['default'];
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('breadcrumb', Breadcrumb);
	module.exports = exports['default'];

/***/ },
/* 2206 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(226);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _bootstrapUtils = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ButtonToolbar = function (_React$Component) {
	  (0, _inherits3['default'])(ButtonToolbar, _React$Component);
	
	  function ButtonToolbar() {
	    (0, _classCallCheck3['default'])(this, ButtonToolbar);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ButtonToolbar.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('div', (0, _extends3['default'])({}, elementProps, {
	      role: 'toolbar',
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return ButtonToolbar;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('btn-toolbar', (0, _bootstrapUtils.bsSizes)(_Button2['default'].SIZES, ButtonToolbar));
	module.exports = exports['default'];

/***/ },
/* 2207 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _CarouselCaption = __webpack_require__(2208);
	
	var _CarouselCaption2 = _interopRequireDefault(_CarouselCaption);
	
	var _CarouselItem = __webpack_require__(914);
	
	var _CarouselItem2 = _interopRequireDefault(_CarouselItem);
	
	var _Glyphicon = __webpack_require__(459);
	
	var _Glyphicon2 = _interopRequireDefault(_Glyphicon);
	
	var _SafeAnchor = __webpack_require__(99);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _bootstrapUtils = __webpack_require__(24);
	
	var _ValidComponentChildren = __webpack_require__(74);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: `slide` should be `animate`.
	
	// TODO: Use uncontrollable.
	
	var propTypes = {
	  slide: _propTypes2['default'].bool,
	  indicators: _propTypes2['default'].bool,
	  interval: _propTypes2['default'].number,
	  controls: _propTypes2['default'].bool,
	  pauseOnHover: _propTypes2['default'].bool,
	  wrap: _propTypes2['default'].bool,
	  /**
	   * Callback fired when the active item changes.
	   *
	   * ```js
	   * (eventKey: any) => any | (eventKey: any, event: Object) => any
	   * ```
	   *
	   * If this callback takes two or more arguments, the second argument will
	   * be a persisted event object with `direction` set to the direction of the
	   * transition.
	   */
	  onSelect: _propTypes2['default'].func,
	  onSlideEnd: _propTypes2['default'].func,
	  activeIndex: _propTypes2['default'].number,
	  defaultActiveIndex: _propTypes2['default'].number,
	  direction: _propTypes2['default'].oneOf(['prev', 'next']),
	  prevIcon: _propTypes2['default'].node,
	  /**
	   * Label shown to screen readers only, can be used to show the previous element
	   * in the carousel.
	   * Set to null to deactivate.
	   */
	  prevLabel: _propTypes2['default'].string,
	  nextIcon: _propTypes2['default'].node,
	  /**
	   * Label shown to screen readers only, can be used to show the next element
	   * in the carousel.
	   * Set to null to deactivate.
	   */
	  nextLabel: _propTypes2['default'].string
	};
	
	var defaultProps = {
	  slide: true,
	  interval: 5000,
	  pauseOnHover: true,
	  wrap: true,
	  indicators: true,
	  controls: true,
	  prevIcon: _react2['default'].createElement(_Glyphicon2['default'], { glyph: 'chevron-left' }),
	  prevLabel: 'Previous',
	  nextIcon: _react2['default'].createElement(_Glyphicon2['default'], { glyph: 'chevron-right' }),
	  nextLabel: 'Next'
	};
	
	var Carousel = function (_React$Component) {
	  (0, _inherits3['default'])(Carousel, _React$Component);
	
	  function Carousel(props, context) {
	    (0, _classCallCheck3['default'])(this, Carousel);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleMouseOver = _this.handleMouseOver.bind(_this);
	    _this.handleMouseOut = _this.handleMouseOut.bind(_this);
	    _this.handlePrev = _this.handlePrev.bind(_this);
	    _this.handleNext = _this.handleNext.bind(_this);
	    _this.handleItemAnimateOutEnd = _this.handleItemAnimateOutEnd.bind(_this);
	
	    var defaultActiveIndex = props.defaultActiveIndex;
	
	
	    _this.state = {
	      activeIndex: defaultActiveIndex != null ? defaultActiveIndex : 0,
	      previousActiveIndex: null,
	      direction: null
	    };
	
	    _this.isUnmounted = false;
	    return _this;
	  }
	
	  Carousel.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var activeIndex = this.getActiveIndex();
	
	    if (nextProps.activeIndex != null && nextProps.activeIndex !== activeIndex) {
	      clearTimeout(this.timeout);
	
	      this.setState({
	        previousActiveIndex: activeIndex,
	        direction: nextProps.direction != null ? nextProps.direction : this.getDirection(activeIndex, nextProps.activeIndex)
	      });
	    }
	  };
	
	  Carousel.prototype.componentDidMount = function componentDidMount() {
	    this.waitForNext();
	  };
	
	  Carousel.prototype.componentWillUnmount = function componentWillUnmount() {
	    clearTimeout(this.timeout);
	    this.isUnmounted = true;
	  };
	
	  Carousel.prototype.handleMouseOver = function handleMouseOver() {
	    if (this.props.pauseOnHover) {
	      this.pause();
	    }
	  };
	
	  Carousel.prototype.handleMouseOut = function handleMouseOut() {
	    if (this.isPaused) {
	      this.play();
	    }
	  };
	
	  Carousel.prototype.handlePrev = function handlePrev(e) {
	    var index = this.getActiveIndex() - 1;
	
	    if (index < 0) {
	      if (!this.props.wrap) {
	        return;
	      }
	      index = _ValidComponentChildren2['default'].count(this.props.children) - 1;
	    }
	
	    this.select(index, e, 'prev');
	  };
	
	  Carousel.prototype.handleNext = function handleNext(e) {
	    var index = this.getActiveIndex() + 1;
	    var count = _ValidComponentChildren2['default'].count(this.props.children);
	
	    if (index > count - 1) {
	      if (!this.props.wrap) {
	        return;
	      }
	      index = 0;
	    }
	
	    this.select(index, e, 'next');
	  };
	
	  Carousel.prototype.handleItemAnimateOutEnd = function handleItemAnimateOutEnd() {
	    var _this2 = this;
	
	    this.setState({
	      previousActiveIndex: null,
	      direction: null
	    }, function () {
	      _this2.waitForNext();
	
	      if (_this2.props.onSlideEnd) {
	        _this2.props.onSlideEnd();
	      }
	    });
	  };
	
	  Carousel.prototype.getActiveIndex = function getActiveIndex() {
	    var activeIndexProp = this.props.activeIndex;
	    return activeIndexProp != null ? activeIndexProp : this.state.activeIndex;
	  };
	
	  Carousel.prototype.getDirection = function getDirection(prevIndex, index) {
	    if (prevIndex === index) {
	      return null;
	    }
	
	    return prevIndex > index ? 'prev' : 'next';
	  };
	
	  Carousel.prototype.select = function select(index, e, direction) {
	    clearTimeout(this.timeout);
	
	    // TODO: Is this necessary? Seems like the only risk is if the component
	    // unmounts while handleItemAnimateOutEnd fires.
	    if (this.isUnmounted) {
	      return;
	    }
	
	    var previousActiveIndex = this.props.slide ? this.getActiveIndex() : null;
	    direction = direction || this.getDirection(previousActiveIndex, index);
	
	    var onSelect = this.props.onSelect;
	
	
	    if (onSelect) {
	      if (onSelect.length > 1) {
	        // React SyntheticEvents are pooled, so we need to remove this event
	        // from the pool to add a custom property. To avoid unnecessarily
	        // removing objects from the pool, only do this when the listener
	        // actually wants the event.
	        if (e) {
	          e.persist();
	          e.direction = direction;
	        } else {
	          e = { direction: direction };
	        }
	
	        onSelect(index, e);
	      } else {
	        onSelect(index);
	      }
	    }
	
	    if (this.props.activeIndex == null && index !== previousActiveIndex) {
	      if (this.state.previousActiveIndex != null) {
	        // If currently animating don't activate the new index.
	        // TODO: look into queueing this canceled call and
	        // animating after the current animation has ended.
	        return;
	      }
	
	      this.setState({
	        activeIndex: index,
	        previousActiveIndex: previousActiveIndex,
	        direction: direction
	      });
	    }
	  };
	
	  Carousel.prototype.waitForNext = function waitForNext() {
	    var _props = this.props,
	        slide = _props.slide,
	        interval = _props.interval,
	        activeIndexProp = _props.activeIndex;
	
	
	    if (!this.isPaused && slide && interval && activeIndexProp == null) {
	      this.timeout = setTimeout(this.handleNext, interval);
	    }
	  };
	
	  // This might be a public API.
	
	
	  Carousel.prototype.pause = function pause() {
	    this.isPaused = true;
	    clearTimeout(this.timeout);
	  };
	
	  // This might be a public API.
	
	
	  Carousel.prototype.play = function play() {
	    this.isPaused = false;
	    this.waitForNext();
	  };
	
	  Carousel.prototype.renderIndicators = function renderIndicators(children, activeIndex, bsProps) {
	    var _this3 = this;
	
	    var indicators = [];
	
	    _ValidComponentChildren2['default'].forEach(children, function (child, index) {
	      indicators.push(_react2['default'].createElement('li', {
	        key: index,
	        className: index === activeIndex ? 'active' : null,
	        onClick: function onClick(e) {
	          return _this3.select(index, e);
	        }
	      }),
	
	      // Force whitespace between indicator elements. Bootstrap requires
	      // this for correct spacing of elements.
	      ' ');
	    });
	
	    return _react2['default'].createElement(
	      'ol',
	      { className: (0, _bootstrapUtils.prefix)(bsProps, 'indicators') },
	      indicators
	    );
	  };
	
	  Carousel.prototype.renderControls = function renderControls(properties) {
	    var wrap = properties.wrap,
	        children = properties.children,
	        activeIndex = properties.activeIndex,
	        prevIcon = properties.prevIcon,
	        nextIcon = properties.nextIcon,
	        bsProps = properties.bsProps,
	        prevLabel = properties.prevLabel,
	        nextLabel = properties.nextLabel;
	
	    var controlClassName = (0, _bootstrapUtils.prefix)(bsProps, 'control');
	    var count = _ValidComponentChildren2['default'].count(children);
	
	    return [(wrap || activeIndex !== 0) && _react2['default'].createElement(
	      _SafeAnchor2['default'],
	      {
	        key: 'prev',
	        className: (0, _classnames2['default'])(controlClassName, 'left'),
	        onClick: this.handlePrev
	      },
	      prevIcon,
	      prevLabel && _react2['default'].createElement(
	        'span',
	        { className: 'sr-only' },
	        prevLabel
	      )
	    ), (wrap || activeIndex !== count - 1) && _react2['default'].createElement(
	      _SafeAnchor2['default'],
	      {
	        key: 'next',
	        className: (0, _classnames2['default'])(controlClassName, 'right'),
	        onClick: this.handleNext
	      },
	      nextIcon,
	      nextLabel && _react2['default'].createElement(
	        'span',
	        { className: 'sr-only' },
	        nextLabel
	      )
	    )];
	  };
	
	  Carousel.prototype.render = function render() {
	    var _this4 = this;
	
	    var _props2 = this.props,
	        slide = _props2.slide,
	        indicators = _props2.indicators,
	        controls = _props2.controls,
	        wrap = _props2.wrap,
	        prevIcon = _props2.prevIcon,
	        prevLabel = _props2.prevLabel,
	        nextIcon = _props2.nextIcon,
	        nextLabel = _props2.nextLabel,
	        className = _props2.className,
	        children = _props2.children,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['slide', 'indicators', 'controls', 'wrap', 'prevIcon', 'prevLabel', 'nextIcon', 'nextLabel', 'className', 'children']);
	    var _state = this.state,
	        previousActiveIndex = _state.previousActiveIndex,
	        direction = _state.direction;
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['interval', 'pauseOnHover', 'onSelect', 'onSlideEnd', 'activeIndex', // Accessed via this.getActiveIndex().
	    'defaultActiveIndex', 'direction']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var activeIndex = this.getActiveIndex();
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      slide: slide
	    });
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes),
	        onMouseOver: this.handleMouseOver,
	        onMouseOut: this.handleMouseOut
	      }),
	      indicators && this.renderIndicators(children, activeIndex, bsProps),
	      _react2['default'].createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'inner') },
	        _ValidComponentChildren2['default'].map(children, function (child, index) {
	          var active = index === activeIndex;
	          var previousActive = slide && index === previousActiveIndex;
	
	          return (0, _react.cloneElement)(child, {
	            active: active,
	            index: index,
	            animateOut: previousActive,
	            animateIn: active && previousActiveIndex != null && slide,
	            direction: direction,
	            onAnimateOutEnd: previousActive ? _this4.handleItemAnimateOutEnd : null
	          });
	        })
	      ),
	      controls && this.renderControls({
	        wrap: wrap,
	        children: children,
	        activeIndex: activeIndex,
	        prevIcon: prevIcon,
	        prevLabel: prevLabel,
	        nextIcon: nextIcon,
	        nextLabel: nextLabel,
	        bsProps: bsProps
	      })
	    );
	  };
	
	  return Carousel;
	}(_react2['default'].Component);
	
	Carousel.propTypes = propTypes;
	Carousel.defaultProps = defaultProps;
	
	Carousel.Caption = _CarouselCaption2['default'];
	Carousel.Item = _CarouselItem2['default'];
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('carousel', Carousel);
	module.exports = exports['default'];

/***/ },
/* 2208 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(42);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var CarouselCaption = function (_React$Component) {
	  (0, _inherits3['default'])(CarouselCaption, _React$Component);
	
	  function CarouselCaption() {
	    (0, _classCallCheck3['default'])(this, CarouselCaption);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  CarouselCaption.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return CarouselCaption;
	}(_react2['default'].Component);
	
	CarouselCaption.propTypes = propTypes;
	CarouselCaption.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('carousel-caption', CarouselCaption);
	module.exports = exports['default'];

/***/ },
/* 2209 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(100);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  inline: _propTypes2['default'].bool,
	  disabled: _propTypes2['default'].bool,
	  /**
	   * Only valid if `inline` is not set.
	   */
	  validationState: _propTypes2['default'].oneOf(['success', 'warning', 'error', null]),
	  /**
	   * Attaches a ref to the `<input>` element. Only functions can be used here.
	   *
	   * ```js
	   * <Checkbox inputRef={ref => { this.input = ref; }} />
	   * ```
	   */
	  inputRef: _propTypes2['default'].func
	};
	
	var defaultProps = {
	  inline: false,
	  disabled: false
	};
	
	var Checkbox = function (_React$Component) {
	  (0, _inherits3['default'])(Checkbox, _React$Component);
	
	  function Checkbox() {
	    (0, _classCallCheck3['default'])(this, Checkbox);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Checkbox.prototype.render = function render() {
	    var _props = this.props,
	        inline = _props.inline,
	        disabled = _props.disabled,
	        validationState = _props.validationState,
	        inputRef = _props.inputRef,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['inline', 'disabled', 'validationState', 'inputRef', 'className', 'style', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var input = _react2['default'].createElement('input', (0, _extends3['default'])({}, elementProps, {
	      ref: inputRef,
	      type: 'checkbox',
	      disabled: disabled
	    }));
	
	    if (inline) {
	      var _classes2;
	
	      var _classes = (_classes2 = {}, _classes2[(0, _bootstrapUtils.prefix)(bsProps, 'inline')] = true, _classes2.disabled = disabled, _classes2);
	
	      // Use a warning here instead of in propTypes to get better-looking
	      // generated documentation.
	       false ? (0, _warning2['default'])(!validationState, '`validationState` is ignored on `<Checkbox inline>`. To display ' + 'validation state on an inline checkbox, set `validationState` on a ' + 'parent `<FormGroup>` or other element instead.') : void 0;
	
	      return _react2['default'].createElement(
	        'label',
	        { className: (0, _classnames2['default'])(className, _classes), style: style },
	        input,
	        children
	      );
	    }
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      disabled: disabled
	    });
	    if (validationState) {
	      classes['has-' + validationState] = true;
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      { className: (0, _classnames2['default'])(className, classes), style: style },
	      _react2['default'].createElement(
	        'label',
	        null,
	        input,
	        children
	      )
	    );
	  };
	
	  return Checkbox;
	}(_react2['default'].Component);
	
	Checkbox.propTypes = propTypes;
	Checkbox.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('checkbox', Checkbox);
	module.exports = exports['default'];

/***/ },
/* 2210 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(42);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(24);
	
	var _capitalize = __webpack_require__(931);
	
	var _capitalize2 = _interopRequireDefault(_capitalize);
	
	var _StyleConfig = __webpack_require__(64);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default'],
	
	  /**
	   * Apply clearfix
	   *
	   * on Extra small devices Phones
	   *
	   * adds class `visible-xs-block`
	   */
	  visibleXsBlock: _propTypes2['default'].bool,
	  /**
	   * Apply clearfix
	   *
	   * on Small devices Tablets
	   *
	   * adds class `visible-sm-block`
	   */
	  visibleSmBlock: _propTypes2['default'].bool,
	  /**
	   * Apply clearfix
	   *
	   * on Medium devices Desktops
	   *
	   * adds class `visible-md-block`
	   */
	  visibleMdBlock: _propTypes2['default'].bool,
	  /**
	   * Apply clearfix
	   *
	   * on Large devices Desktops
	   *
	   * adds class `visible-lg-block`
	   */
	  visibleLgBlock: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Clearfix = function (_React$Component) {
	  (0, _inherits3['default'])(Clearfix, _React$Component);
	
	  function Clearfix() {
	    (0, _classCallCheck3['default'])(this, Clearfix);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Clearfix.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    _StyleConfig.DEVICE_SIZES.forEach(function (size) {
	      var propName = 'visible' + (0, _capitalize2['default'])(size) + 'Block';
	      if (elementProps[propName]) {
	        classes['visible-' + size + '-block'] = true;
	      }
	
	      delete elementProps[propName];
	    });
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Clearfix;
	}(_react2['default'].Component);
	
	Clearfix.propTypes = propTypes;
	Clearfix.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('clearfix', Clearfix);
	module.exports = exports['default'];

/***/ },
/* 2211 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(42);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(24);
	
	var _StyleConfig = __webpack_require__(64);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default'],
	
	  /**
	   * The number of columns you wish to span
	   *
	   * for Extra small devices Phones (<768px)
	   *
	   * class-prefix `col-xs-`
	   */
	  xs: _propTypes2['default'].number,
	  /**
	   * The number of columns you wish to span
	   *
	   * for Small devices Tablets (≥768px)
	   *
	   * class-prefix `col-sm-`
	   */
	  sm: _propTypes2['default'].number,
	  /**
	   * The number of columns you wish to span
	   *
	   * for Medium devices Desktops (≥992px)
	   *
	   * class-prefix `col-md-`
	   */
	  md: _propTypes2['default'].number,
	  /**
	   * The number of columns you wish to span
	   *
	   * for Large devices Desktops (≥1200px)
	   *
	   * class-prefix `col-lg-`
	   */
	  lg: _propTypes2['default'].number,
	  /**
	   * Hide column
	   *
	   * on Extra small devices Phones
	   *
	   * adds class `hidden-xs`
	   */
	  xsHidden: _propTypes2['default'].bool,
	  /**
	   * Hide column
	   *
	   * on Small devices Tablets
	   *
	   * adds class `hidden-sm`
	   */
	  smHidden: _propTypes2['default'].bool,
	  /**
	   * Hide column
	   *
	   * on Medium devices Desktops
	   *
	   * adds class `hidden-md`
	   */
	  mdHidden: _propTypes2['default'].bool,
	  /**
	   * Hide column
	   *
	   * on Large devices Desktops
	   *
	   * adds class `hidden-lg`
	   */
	  lgHidden: _propTypes2['default'].bool,
	  /**
	   * Move columns to the right
	   *
	   * for Extra small devices Phones
	   *
	   * class-prefix `col-xs-offset-`
	   */
	  xsOffset: _propTypes2['default'].number,
	  /**
	   * Move columns to the right
	   *
	   * for Small devices Tablets
	   *
	   * class-prefix `col-sm-offset-`
	   */
	  smOffset: _propTypes2['default'].number,
	  /**
	   * Move columns to the right
	   *
	   * for Medium devices Desktops
	   *
	   * class-prefix `col-md-offset-`
	   */
	  mdOffset: _propTypes2['default'].number,
	  /**
	   * Move columns to the right
	   *
	   * for Large devices Desktops
	   *
	   * class-prefix `col-lg-offset-`
	   */
	  lgOffset: _propTypes2['default'].number,
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Extra small devices Phones
	   *
	   * class-prefix `col-xs-push-`
	   */
	  xsPush: _propTypes2['default'].number,
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Small devices Tablets
	   *
	   * class-prefix `col-sm-push-`
	   */
	  smPush: _propTypes2['default'].number,
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Medium devices Desktops
	   *
	   * class-prefix `col-md-push-`
	   */
	  mdPush: _propTypes2['default'].number,
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Large devices Desktops
	   *
	   * class-prefix `col-lg-push-`
	   */
	  lgPush: _propTypes2['default'].number,
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Extra small devices Phones
	   *
	   * class-prefix `col-xs-pull-`
	   */
	  xsPull: _propTypes2['default'].number,
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Small devices Tablets
	   *
	   * class-prefix `col-sm-pull-`
	   */
	  smPull: _propTypes2['default'].number,
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Medium devices Desktops
	   *
	   * class-prefix `col-md-pull-`
	   */
	  mdPull: _propTypes2['default'].number,
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Large devices Desktops
	   *
	   * class-prefix `col-lg-pull-`
	   */
	  lgPull: _propTypes2['default'].number
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Col = function (_React$Component) {
	  (0, _inherits3['default'])(Col, _React$Component);
	
	  function Col() {
	    (0, _classCallCheck3['default'])(this, Col);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Col.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = [];
	
	    _StyleConfig.DEVICE_SIZES.forEach(function (size) {
	      function popProp(propSuffix, modifier) {
	        var propName = '' + size + propSuffix;
	        var propValue = elementProps[propName];
	
	        if (propValue != null) {
	          classes.push((0, _bootstrapUtils.prefix)(bsProps, '' + size + modifier + '-' + propValue));
	        }
	
	        delete elementProps[propName];
	      }
	
	      popProp('', '');
	      popProp('Offset', '-offset');
	      popProp('Push', '-push');
	      popProp('Pull', '-pull');
	
	      var hiddenPropName = size + 'Hidden';
	      if (elementProps[hiddenPropName]) {
	        classes.push('hidden-' + size);
	      }
	      delete elementProps[hiddenPropName];
	    });
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Col;
	}(_react2['default'].Component);
	
	Col.propTypes = propTypes;
	Col.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('col', Col);
	module.exports = exports['default'];

/***/ },
/* 2212 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(100);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Uses `controlId` from `<FormGroup>` if not explicitly specified.
	   */
	  htmlFor: _propTypes2['default'].string,
	  srOnly: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  srOnly: false
	};
	
	var contextTypes = {
	  $bs_formGroup: _propTypes2['default'].object
	};
	
	var ControlLabel = function (_React$Component) {
	  (0, _inherits3['default'])(ControlLabel, _React$Component);
	
	  function ControlLabel() {
	    (0, _classCallCheck3['default'])(this, ControlLabel);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ControlLabel.prototype.render = function render() {
	    var formGroup = this.context.$bs_formGroup;
	    var controlId = formGroup && formGroup.controlId;
	
	    var _props = this.props,
	        _props$htmlFor = _props.htmlFor,
	        htmlFor = _props$htmlFor === undefined ? controlId : _props$htmlFor,
	        srOnly = _props.srOnly,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['htmlFor', 'srOnly', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	     false ? (0, _warning2['default'])(controlId == null || htmlFor === controlId, '`controlId` is ignored on `<ControlLabel>` when `htmlFor` is specified.') : void 0;
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      'sr-only': srOnly
	    });
	
	    return _react2['default'].createElement('label', (0, _extends3['default'])({}, elementProps, {
	      htmlFor: htmlFor,
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return ControlLabel;
	}(_react2['default'].Component);
	
	ControlLabel.propTypes = propTypes;
	ControlLabel.defaultProps = defaultProps;
	ControlLabel.contextTypes = contextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('control-label', ControlLabel);
	module.exports = exports['default'];

/***/ },
/* 2213 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Dropdown = __webpack_require__(295);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _splitComponentProps2 = __webpack_require__(297);
	
	var _splitComponentProps3 = _interopRequireDefault(_splitComponentProps2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _extends3['default'])({}, _Dropdown2['default'].propTypes, {
	
	  // Toggle props.
	  bsStyle: _propTypes2['default'].string,
	  bsSize: _propTypes2['default'].string,
	  title: _propTypes2['default'].node.isRequired,
	  noCaret: _propTypes2['default'].bool,
	
	  // Override generated docs from <Dropdown>.
	  /**
	   * @private
	   */
	  children: _propTypes2['default'].node
	});
	
	var DropdownButton = function (_React$Component) {
	  (0, _inherits3['default'])(DropdownButton, _React$Component);
	
	  function DropdownButton() {
	    (0, _classCallCheck3['default'])(this, DropdownButton);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  DropdownButton.prototype.render = function render() {
	    var _props = this.props,
	        bsSize = _props.bsSize,
	        bsStyle = _props.bsStyle,
	        title = _props.title,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['bsSize', 'bsStyle', 'title', 'children']);
	
	    var _splitComponentProps = (0, _splitComponentProps3['default'])(props, _Dropdown2['default'].ControlledComponent),
	        dropdownProps = _splitComponentProps[0],
	        toggleProps = _splitComponentProps[1];
	
	    return _react2['default'].createElement(
	      _Dropdown2['default'],
	      (0, _extends3['default'])({}, dropdownProps, {
	        bsSize: bsSize,
	        bsStyle: bsStyle
	      }),
	      _react2['default'].createElement(
	        _Dropdown2['default'].Toggle,
	        (0, _extends3['default'])({}, toggleProps, {
	          bsSize: bsSize,
	          bsStyle: bsStyle
	        }),
	        title
	      ),
	      _react2['default'].createElement(
	        _Dropdown2['default'].Menu,
	        null,
	        children
	      )
	    );
	  };
	
	  return DropdownButton;
	}(_react2['default'].Component);
	
	DropdownButton.propTypes = propTypes;
	
	exports['default'] = DropdownButton;
	module.exports = exports['default'];

/***/ },
/* 2214 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(18);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _from = __webpack_require__(1198);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _keycode = __webpack_require__(432);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _RootCloseWrapper = __webpack_require__(942);
	
	var _RootCloseWrapper2 = _interopRequireDefault(_RootCloseWrapper);
	
	var _bootstrapUtils = __webpack_require__(24);
	
	var _createChainedFunction = __webpack_require__(62);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _ValidComponentChildren = __webpack_require__(74);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  open: _propTypes2['default'].bool,
	  pullRight: _propTypes2['default'].bool,
	  onClose: _propTypes2['default'].func,
	  labelledBy: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number]),
	  onSelect: _propTypes2['default'].func,
	  rootCloseEvent: _propTypes2['default'].oneOf(['click', 'mousedown'])
	};
	
	var defaultProps = {
	  bsRole: 'menu',
	  pullRight: false
	};
	
	var DropdownMenu = function (_React$Component) {
	  (0, _inherits3['default'])(DropdownMenu, _React$Component);
	
	  function DropdownMenu(props) {
	    (0, _classCallCheck3['default'])(this, DropdownMenu);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));
	
	    _this.handleRootClose = _this.handleRootClose.bind(_this);
	    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
	    return _this;
	  }
	
	  DropdownMenu.prototype.handleRootClose = function handleRootClose(event) {
	    this.props.onClose(event, { source: 'rootClose' });
	  };
	
	  DropdownMenu.prototype.handleKeyDown = function handleKeyDown(event) {
	    switch (event.keyCode) {
	      case _keycode2['default'].codes.down:
	        this.focusNext();
	        event.preventDefault();
	        break;
	      case _keycode2['default'].codes.up:
	        this.focusPrevious();
	        event.preventDefault();
	        break;
	      case _keycode2['default'].codes.esc:
	      case _keycode2['default'].codes.tab:
	        this.props.onClose(event, { source: 'keydown' });
	        break;
	      default:
	    }
	  };
	
	  DropdownMenu.prototype.getItemsAndActiveIndex = function getItemsAndActiveIndex() {
	    var items = this.getFocusableMenuItems();
	    var activeIndex = items.indexOf(document.activeElement);
	
	    return { items: items, activeIndex: activeIndex };
	  };
	
	  DropdownMenu.prototype.getFocusableMenuItems = function getFocusableMenuItems() {
	    var node = _reactDom2['default'].findDOMNode(this);
	    if (!node) {
	      return [];
	    }
	
	    return (0, _from2['default'])(node.querySelectorAll('[tabIndex="-1"]'));
	  };
	
	  DropdownMenu.prototype.focusNext = function focusNext() {
	    var _getItemsAndActiveInd = this.getItemsAndActiveIndex(),
	        items = _getItemsAndActiveInd.items,
	        activeIndex = _getItemsAndActiveInd.activeIndex;
	
	    if (items.length === 0) {
	      return;
	    }
	
	    var nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
	    items[nextIndex].focus();
	  };
	
	  DropdownMenu.prototype.focusPrevious = function focusPrevious() {
	    var _getItemsAndActiveInd2 = this.getItemsAndActiveIndex(),
	        items = _getItemsAndActiveInd2.items,
	        activeIndex = _getItemsAndActiveInd2.activeIndex;
	
	    if (items.length === 0) {
	      return;
	    }
	
	    var prevIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
	    items[prevIndex].focus();
	  };
	
	  DropdownMenu.prototype.render = function render() {
	    var _extends2,
	        _this2 = this;
	
	    var _props = this.props,
	        open = _props.open,
	        pullRight = _props.pullRight,
	        labelledBy = _props.labelledBy,
	        onSelect = _props.onSelect,
	        className = _props.className,
	        rootCloseEvent = _props.rootCloseEvent,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['open', 'pullRight', 'labelledBy', 'onSelect', 'className', 'rootCloseEvent', 'children']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['onClose']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'right')] = pullRight, _extends2));
	
	    return _react2['default'].createElement(
	      _RootCloseWrapper2['default'],
	      {
	        disabled: !open,
	        onRootClose: this.handleRootClose,
	        event: rootCloseEvent
	      },
	      _react2['default'].createElement(
	        'ul',
	        (0, _extends4['default'])({}, elementProps, {
	          role: 'menu',
	          className: (0, _classnames2['default'])(className, classes),
	          'aria-labelledby': labelledBy
	        }),
	        _ValidComponentChildren2['default'].map(children, function (child) {
	          return _react2['default'].cloneElement(child, {
	            onKeyDown: (0, _createChainedFunction2['default'])(child.props.onKeyDown, _this2.handleKeyDown),
	            onSelect: (0, _createChainedFunction2['default'])(child.props.onSelect, onSelect)
	          });
	        })
	      )
	    );
	  };
	
	  return DropdownMenu;
	}(_react2['default'].Component);
	
	DropdownMenu.propTypes = propTypes;
	DropdownMenu.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('dropdown-menu', DropdownMenu);
	module.exports = exports['default'];

/***/ },
/* 2215 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(42);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  horizontal: _propTypes2['default'].bool,
	  inline: _propTypes2['default'].bool,
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  horizontal: false,
	  inline: false,
	  componentClass: 'form'
	};
	
	var Form = function (_React$Component) {
	  (0, _inherits3['default'])(Form, _React$Component);
	
	  function Form() {
	    (0, _classCallCheck3['default'])(this, Form);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Form.prototype.render = function render() {
	    var _props = this.props,
	        horizontal = _props.horizontal,
	        inline = _props.inline,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['horizontal', 'inline', 'componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = [];
	    if (horizontal) {
	      classes.push((0, _bootstrapUtils.prefix)(bsProps, 'horizontal'));
	    }
	    if (inline) {
	      classes.push((0, _bootstrapUtils.prefix)(bsProps, 'inline'));
	    }
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Form;
	}(_react2['default'].Component);
	
	Form.propTypes = propTypes;
	Form.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('form', Form);
	module.exports = exports['default'];

/***/ },
/* 2216 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(42);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _warning = __webpack_require__(100);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _FormControlFeedback = __webpack_require__(2217);
	
	var _FormControlFeedback2 = _interopRequireDefault(_FormControlFeedback);
	
	var _FormControlStatic = __webpack_require__(2218);
	
	var _FormControlStatic2 = _interopRequireDefault(_FormControlStatic);
	
	var _bootstrapUtils = __webpack_require__(24);
	
	var _StyleConfig = __webpack_require__(64);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default'],
	  /**
	   * Only relevant if `componentClass` is `'input'`.
	   */
	  type: _propTypes2['default'].string,
	  /**
	   * Uses `controlId` from `<FormGroup>` if not explicitly specified.
	   */
	  id: _propTypes2['default'].string,
	  /**
	   * Attaches a ref to the `<input>` element. Only functions can be used here.
	   *
	   * ```js
	   * <FormControl inputRef={ref => { this.input = ref; }} />
	   * ```
	   */
	  inputRef: _propTypes2['default'].func
	};
	
	var defaultProps = {
	  componentClass: 'input'
	};
	
	var contextTypes = {
	  $bs_formGroup: _propTypes2['default'].object
	};
	
	var FormControl = function (_React$Component) {
	  (0, _inherits3['default'])(FormControl, _React$Component);
	
	  function FormControl() {
	    (0, _classCallCheck3['default'])(this, FormControl);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  FormControl.prototype.render = function render() {
	    var formGroup = this.context.$bs_formGroup;
	    var controlId = formGroup && formGroup.controlId;
	
	    var _props = this.props,
	        Component = _props.componentClass,
	        type = _props.type,
	        _props$id = _props.id,
	        id = _props$id === undefined ? controlId : _props$id,
	        inputRef = _props.inputRef,
	        className = _props.className,
	        bsSize = _props.bsSize,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'type', 'id', 'inputRef', 'className', 'bsSize']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	     false ? (0, _warning2['default'])(controlId == null || id === controlId, '`controlId` is ignored on `<FormControl>` when `id` is specified.') : void 0;
	
	    // input[type="file"] should not have .form-control.
	    var classes = void 0;
	    if (type !== 'file') {
	      classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	    }
	
	    // If user provides a size, make sure to append it to classes as input-
	    // e.g. if bsSize is small, it will append input-sm
	    if (bsSize) {
	      var size = _StyleConfig.SIZE_MAP[bsSize] || bsSize;
	      classes[(0, _bootstrapUtils.prefix)({ bsClass: 'input' }, size)] = true;
	    }
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      type: type,
	      id: id,
	      ref: inputRef,
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return FormControl;
	}(_react2['default'].Component);
	
	FormControl.propTypes = propTypes;
	FormControl.defaultProps = defaultProps;
	FormControl.contextTypes = contextTypes;
	
	FormControl.Feedback = _FormControlFeedback2['default'];
	FormControl.Static = _FormControlStatic2['default'];
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('form-control', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.SMALL, _StyleConfig.Size.LARGE], FormControl));
	module.exports = exports['default'];

/***/ },
/* 2217 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Glyphicon = __webpack_require__(459);
	
	var _Glyphicon2 = _interopRequireDefault(_Glyphicon);
	
	var _bootstrapUtils = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var defaultProps = {
	  bsRole: 'feedback'
	};
	
	var contextTypes = {
	  $bs_formGroup: _propTypes2['default'].object
	};
	
	var FormControlFeedback = function (_React$Component) {
	  (0, _inherits3['default'])(FormControlFeedback, _React$Component);
	
	  function FormControlFeedback() {
	    (0, _classCallCheck3['default'])(this, FormControlFeedback);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  FormControlFeedback.prototype.getGlyph = function getGlyph(validationState) {
	    switch (validationState) {
	      case 'success':
	        return 'ok';
	      case 'warning':
	        return 'warning-sign';
	      case 'error':
	        return 'remove';
	      default:
	        return null;
	    }
	  };
	
	  FormControlFeedback.prototype.renderDefaultFeedback = function renderDefaultFeedback(formGroup, className, classes, elementProps) {
	    var glyph = this.getGlyph(formGroup && formGroup.validationState);
	    if (!glyph) {
	      return null;
	    }
	
	    return _react2['default'].createElement(_Glyphicon2['default'], (0, _extends3['default'])({}, elementProps, {
	      glyph: glyph,
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  FormControlFeedback.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    if (!children) {
	      return this.renderDefaultFeedback(this.context.$bs_formGroup, className, classes, elementProps);
	    }
	
	    var child = _react2['default'].Children.only(children);
	    return _react2['default'].cloneElement(child, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(child.props.className, className, classes)
	    }));
	  };
	
	  return FormControlFeedback;
	}(_react2['default'].Component);
	
	FormControlFeedback.defaultProps = defaultProps;
	FormControlFeedback.contextTypes = contextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('form-control-feedback', FormControlFeedback);
	module.exports = exports['default'];

/***/ },
/* 2218 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(42);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'p'
	};
	
	var FormControlStatic = function (_React$Component) {
	  (0, _inherits3['default'])(FormControlStatic, _React$Component);
	
	  function FormControlStatic() {
	    (0, _classCallCheck3['default'])(this, FormControlStatic);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  FormControlStatic.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return FormControlStatic;
	}(_react2['default'].Component);
	
	FormControlStatic.propTypes = propTypes;
	FormControlStatic.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('form-control-static', FormControlStatic);
	module.exports = exports['default'];

/***/ },
/* 2219 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(24);
	
	var _StyleConfig = __webpack_require__(64);
	
	var _ValidComponentChildren = __webpack_require__(74);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Sets `id` on `<FormControl>` and `htmlFor` on `<FormGroup.Label>`.
	   */
	  controlId: _propTypes2['default'].string,
	  validationState: _propTypes2['default'].oneOf(['success', 'warning', 'error', null])
	};
	
	var childContextTypes = {
	  $bs_formGroup: _propTypes2['default'].object.isRequired
	};
	
	var FormGroup = function (_React$Component) {
	  (0, _inherits3['default'])(FormGroup, _React$Component);
	
	  function FormGroup() {
	    (0, _classCallCheck3['default'])(this, FormGroup);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  FormGroup.prototype.getChildContext = function getChildContext() {
	    var _props = this.props,
	        controlId = _props.controlId,
	        validationState = _props.validationState;
	
	
	    return {
	      $bs_formGroup: {
	        controlId: controlId,
	        validationState: validationState
	      }
	    };
	  };
	
	  FormGroup.prototype.hasFeedback = function hasFeedback(children) {
	    var _this2 = this;
	
	    return _ValidComponentChildren2['default'].some(children, function (child) {
	      return child.props.bsRole === 'feedback' || child.props.children && _this2.hasFeedback(child.props.children);
	    });
	  };
	
	  FormGroup.prototype.render = function render() {
	    var _props2 = this.props,
	        validationState = _props2.validationState,
	        className = _props2.className,
	        children = _props2.children,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['validationState', 'className', 'children']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['controlId']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      'has-feedback': this.hasFeedback(children)
	    });
	    if (validationState) {
	      classes['has-' + validationState] = true;
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      children
	    );
	  };
	
	  return FormGroup;
	}(_react2['default'].Component);
	
	FormGroup.propTypes = propTypes;
	FormGroup.childContextTypes = childContextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('form-group', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], FormGroup));
	module.exports = exports['default'];

/***/ },
/* 2220 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var HelpBlock = function (_React$Component) {
	  (0, _inherits3['default'])(HelpBlock, _React$Component);
	
	  function HelpBlock() {
	    (0, _classCallCheck3['default'])(this, HelpBlock);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  HelpBlock.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('span', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return HelpBlock;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('help-block', HelpBlock);
	module.exports = exports['default'];

/***/ },
/* 2221 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Sets image as responsive image
	   */
	  responsive: _propTypes2['default'].bool,
	
	  /**
	   * Sets image shape as rounded
	   */
	  rounded: _propTypes2['default'].bool,
	
	  /**
	   * Sets image shape as circle
	   */
	  circle: _propTypes2['default'].bool,
	
	  /**
	   * Sets image shape as thumbnail
	   */
	  thumbnail: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  responsive: false,
	  rounded: false,
	  circle: false,
	  thumbnail: false
	};
	
	var Image = function (_React$Component) {
	  (0, _inherits3['default'])(Image, _React$Component);
	
	  function Image() {
	    (0, _classCallCheck3['default'])(this, Image);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Image.prototype.render = function render() {
	    var _classes;
	
	    var _props = this.props,
	        responsive = _props.responsive,
	        rounded = _props.rounded,
	        circle = _props.circle,
	        thumbnail = _props.thumbnail,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['responsive', 'rounded', 'circle', 'thumbnail', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (_classes = {}, _classes[(0, _bootstrapUtils.prefix)(bsProps, 'responsive')] = responsive, _classes[(0, _bootstrapUtils.prefix)(bsProps, 'rounded')] = rounded, _classes[(0, _bootstrapUtils.prefix)(bsProps, 'circle')] = circle, _classes[(0, _bootstrapUtils.prefix)(bsProps, 'thumbnail')] = thumbnail, _classes);
	
	    return _react2['default'].createElement('img', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Image;
	}(_react2['default'].Component);
	
	Image.propTypes = propTypes;
	Image.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('img', Image);
	module.exports = exports['default'];

/***/ },
/* 2222 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _InputGroupAddon = __webpack_require__(2223);
	
	var _InputGroupAddon2 = _interopRequireDefault(_InputGroupAddon);
	
	var _InputGroupButton = __webpack_require__(2224);
	
	var _InputGroupButton2 = _interopRequireDefault(_InputGroupButton);
	
	var _bootstrapUtils = __webpack_require__(24);
	
	var _StyleConfig = __webpack_require__(64);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var InputGroup = function (_React$Component) {
	  (0, _inherits3['default'])(InputGroup, _React$Component);
	
	  function InputGroup() {
	    (0, _classCallCheck3['default'])(this, InputGroup);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  InputGroup.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('span', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return InputGroup;
	}(_react2['default'].Component);
	
	InputGroup.Addon = _InputGroupAddon2['default'];
	InputGroup.Button = _InputGroupButton2['default'];
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('input-group', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], InputGroup));
	module.exports = exports['default'];

/***/ },
/* 2223 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var InputGroupAddon = function (_React$Component) {
	  (0, _inherits3['default'])(InputGroupAddon, _React$Component);
	
	  function InputGroupAddon() {
	    (0, _classCallCheck3['default'])(this, InputGroupAddon);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  InputGroupAddon.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('span', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return InputGroupAddon;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('input-group-addon', InputGroupAddon);
	module.exports = exports['default'];

/***/ },
/* 2224 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var InputGroupButton = function (_React$Component) {
	  (0, _inherits3['default'])(InputGroupButton, _React$Component);
	
	  function InputGroupButton() {
	    (0, _classCallCheck3['default'])(this, InputGroupButton);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  InputGroupButton.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('span', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return InputGroupButton;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('input-group-btn', InputGroupButton);
	module.exports = exports['default'];

/***/ },
/* 2225 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _elementType = __webpack_require__(42);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Jumbotron = function (_React$Component) {
	  (0, _inherits3['default'])(Jumbotron, _React$Component);
	
	  function Jumbotron() {
	    (0, _classCallCheck3['default'])(this, Jumbotron);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Jumbotron.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Jumbotron;
	}(_react2['default'].Component);
	
	Jumbotron.propTypes = propTypes;
	Jumbotron.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('jumbotron', Jumbotron);
	module.exports = exports['default'];

/***/ },
/* 2226 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(157);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(24);
	
	var _StyleConfig = __webpack_require__(64);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Label = function (_React$Component) {
	  (0, _inherits3['default'])(Label, _React$Component);
	
	  function Label() {
	    (0, _classCallCheck3['default'])(this, Label);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Label.prototype.hasContent = function hasContent(children) {
	    var result = false;
	
	    _react2['default'].Children.forEach(children, function (child) {
	      if (result) {
	        return;
	      }
	
	      if (child || child === 0) {
	        result = true;
	      }
	    });
	
	    return result;
	  };
	
	  Label.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	
	      // Hack for collapsing on IE8.
	      hidden: !this.hasContent(children)
	    });
	
	    return _react2['default'].createElement(
	      'span',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      children
	    );
	  };
	
	  return Label;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('label', (0, _bootstrapUtils.bsStyles)([].concat((0, _values2['default'])(_StyleConfig.State), [_StyleConfig.Style.DEFAULT, _StyleConfig.Style.PRIMARY]), _StyleConfig.Style.DEFAULT, Label));
	module.exports = exports['default'];

/***/ },
/* 2227 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(42);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _ListGroupItem = __webpack_require__(918);
	
	var _ListGroupItem2 = _interopRequireDefault(_ListGroupItem);
	
	var _bootstrapUtils = __webpack_require__(24);
	
	var _ValidComponentChildren = __webpack_require__(74);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * You can use a custom element type for this component.
	   *
	   * If not specified, it will be treated as `'li'` if every child is a
	   * non-actionable `<ListGroupItem>`, and `'div'` otherwise.
	   */
	  componentClass: _elementType2['default']
	};
	
	function getDefaultComponent(children) {
	  if (!children) {
	    // FIXME: This is the old behavior. Is this right?
	    return 'div';
	  }
	
	  if (_ValidComponentChildren2['default'].some(children, function (child) {
	    return child.type !== _ListGroupItem2['default'] || child.props.href || child.props.onClick;
	  })) {
	    return 'div';
	  }
	
	  return 'ul';
	}
	
	var ListGroup = function (_React$Component) {
	  (0, _inherits3['default'])(ListGroup, _React$Component);
	
	  function ListGroup() {
	    (0, _classCallCheck3['default'])(this, ListGroup);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ListGroup.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        _props$componentClass = _props.componentClass,
	        Component = _props$componentClass === undefined ? getDefaultComponent(children) : _props$componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['children', 'componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    var useListItem = Component === 'ul' && _ValidComponentChildren2['default'].every(children, function (child) {
	      return child.type === _ListGroupItem2['default'];
	    });
	
	    return _react2['default'].createElement(
	      Component,
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      useListItem ? _ValidComponentChildren2['default'].map(children, function (child) {
	        return (0, _react.cloneElement)(child, { listItem: true });
	      }) : children
	    );
	  };
	
	  return ListGroup;
	}(_react2['default'].Component);
	
	ListGroup.propTypes = propTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('list-group', ListGroup);
	module.exports = exports['default'];

/***/ },
/* 2228 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(42);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var MediaBody = function (_React$Component) {
	  (0, _inherits3['default'])(MediaBody, _React$Component);
	
	  function MediaBody() {
	    (0, _classCallCheck3['default'])(this, MediaBody);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaBody.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return MediaBody;
	}(_react2['default'].Component);
	
	MediaBody.propTypes = propTypes;
	MediaBody.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('media-body', MediaBody);
	module.exports = exports['default'];

/***/ },
/* 2229 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(42);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'h4'
	};
	
	var MediaHeading = function (_React$Component) {
	  (0, _inherits3['default'])(MediaHeading, _React$Component);
	
	  function MediaHeading() {
	    (0, _classCallCheck3['default'])(this, MediaHeading);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaHeading.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return MediaHeading;
	}(_react2['default'].Component);
	
	MediaHeading.propTypes = propTypes;
	MediaHeading.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('media-heading', MediaHeading);
	module.exports = exports['default'];

/***/ },
/* 2230 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Media = __webpack_require__(460);
	
	var _Media2 = _interopRequireDefault(_Media);
	
	var _bootstrapUtils = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Align the media to the top, middle, or bottom of the media object.
	   */
	  align: _propTypes2['default'].oneOf(['top', 'middle', 'bottom'])
	};
	
	var MediaLeft = function (_React$Component) {
	  (0, _inherits3['default'])(MediaLeft, _React$Component);
	
	  function MediaLeft() {
	    (0, _classCallCheck3['default'])(this, MediaLeft);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaLeft.prototype.render = function render() {
	    var _props = this.props,
	        align = _props.align,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['align', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    if (align) {
	      // The class is e.g. `media-top`, not `media-left-top`.
	      classes[(0, _bootstrapUtils.prefix)(_Media2['default'].defaultProps, align)] = true;
	    }
	
	    return _react2['default'].createElement('div', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return MediaLeft;
	}(_react2['default'].Component);
	
	MediaLeft.propTypes = propTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('media-left', MediaLeft);
	module.exports = exports['default'];

/***/ },
/* 2231 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var MediaList = function (_React$Component) {
	  (0, _inherits3['default'])(MediaList, _React$Component);
	
	  function MediaList() {
	    (0, _classCallCheck3['default'])(this, MediaList);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaList.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('ul', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return MediaList;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('media-list', MediaList);
	module.exports = exports['default'];

/***/ },
/* 2232 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var MediaListItem = function (_React$Component) {
	  (0, _inherits3['default'])(MediaListItem, _React$Component);
	
	  function MediaListItem() {
	    (0, _classCallCheck3['default'])(this, MediaListItem);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaListItem.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('li', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return MediaListItem;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('media', MediaListItem);
	module.exports = exports['default'];

/***/ },
/* 2233 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Media = __webpack_require__(460);
	
	var _Media2 = _interopRequireDefault(_Media);
	
	var _bootstrapUtils = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Align the media to the top, middle, or bottom of the media object.
	   */
	  align: _propTypes2['default'].oneOf(['top', 'middle', 'bottom'])
	};
	
	var MediaRight = function (_React$Component) {
	  (0, _inherits3['default'])(MediaRight, _React$Component);
	
	  function MediaRight() {
	    (0, _classCallCheck3['default'])(this, MediaRight);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaRight.prototype.render = function render() {
	    var _props = this.props,
	        align = _props.align,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['align', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    if (align) {
	      // The class is e.g. `media-top`, not `media-right-top`.
	      classes[(0, _bootstrapUtils.prefix)(_Media2['default'].defaultProps, align)] = true;
	    }
	
	    return _react2['default'].createElement('div', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return MediaRight;
	}(_react2['default'].Component);
	
	MediaRight.propTypes = propTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('media-right', MediaRight);
	module.exports = exports['default'];

/***/ },
/* 2234 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _all = __webpack_require__(302);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _SafeAnchor = __webpack_require__(99);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _bootstrapUtils = __webpack_require__(24);
	
	var _createChainedFunction = __webpack_require__(62);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Highlight the menu item as active.
	   */
	  active: _propTypes2['default'].bool,
	
	  /**
	   * Disable the menu item, making it unselectable.
	   */
	  disabled: _propTypes2['default'].bool,
	
	  /**
	   * Styles the menu item as a horizontal rule, providing visual separation between
	   * groups of menu items.
	   */
	  divider: (0, _all2['default'])(_propTypes2['default'].bool, function (_ref) {
	    var divider = _ref.divider,
	        children = _ref.children;
	    return divider && children ? new Error('Children will not be rendered for dividers') : null;
	  }),
	
	  /**
	   * Value passed to the `onSelect` handler, useful for identifying the selected menu item.
	   */
	  eventKey: _propTypes2['default'].any,
	
	  /**
	   * Styles the menu item as a header label, useful for describing a group of menu items.
	   */
	  header: _propTypes2['default'].bool,
	
	  /**
	   * HTML `href` attribute corresponding to `a.href`.
	   */
	  href: _propTypes2['default'].string,
	
	  /**
	   * Callback fired when the menu item is clicked.
	   */
	  onClick: _propTypes2['default'].func,
	
	  /**
	   * Callback fired when the menu item is selected.
	   *
	   * ```js
	   * (eventKey: any, event: Object) => any
	   * ```
	   */
	  onSelect: _propTypes2['default'].func
	};
	
	var defaultProps = {
	  divider: false,
	  disabled: false,
	  header: false
	};
	
	var MenuItem = function (_React$Component) {
	  (0, _inherits3['default'])(MenuItem, _React$Component);
	
	  function MenuItem(props, context) {
	    (0, _classCallCheck3['default'])(this, MenuItem);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  MenuItem.prototype.handleClick = function handleClick(event) {
	    var _props = this.props,
	        href = _props.href,
	        disabled = _props.disabled,
	        onSelect = _props.onSelect,
	        eventKey = _props.eventKey;
	
	
	    if (!href || disabled) {
	      event.preventDefault();
	    }
	
	    if (disabled) {
	      return;
	    }
	
	    if (onSelect) {
	      onSelect(eventKey, event);
	    }
	  };
	
	  MenuItem.prototype.render = function render() {
	    var _props2 = this.props,
	        active = _props2.active,
	        disabled = _props2.disabled,
	        divider = _props2.divider,
	        header = _props2.header,
	        onClick = _props2.onClick,
	        className = _props2.className,
	        style = _props2.style,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['active', 'disabled', 'divider', 'header', 'onClick', 'className', 'style']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['eventKey', 'onSelect']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    if (divider) {
	      // Forcibly blank out the children; separators shouldn't render any.
	      elementProps.children = undefined;
	
	      return _react2['default'].createElement('li', (0, _extends3['default'])({}, elementProps, {
	        role: 'separator',
	        className: (0, _classnames2['default'])(className, 'divider'),
	        style: style
	      }));
	    }
	
	    if (header) {
	      return _react2['default'].createElement('li', (0, _extends3['default'])({}, elementProps, {
	        role: 'heading',
	        className: (0, _classnames2['default'])(className, (0, _bootstrapUtils.prefix)(bsProps, 'header')),
	        style: style
	      }));
	    }
	
	    return _react2['default'].createElement(
	      'li',
	      {
	        role: 'presentation',
	        className: (0, _classnames2['default'])(className, { active: active, disabled: disabled }),
	        style: style
	      },
	      _react2['default'].createElement(_SafeAnchor2['default'], (0, _extends3['default'])({}, elementProps, {
	        role: 'menuitem',
	        tabIndex: '-1',
	        onClick: (0, _createChainedFunction2['default'])(onClick, this.handleClick)
	      }))
	    );
	  };
	
	  return MenuItem;
	}(_react2['default'].Component);
	
	MenuItem.propTypes = propTypes;
	MenuItem.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('dropdown', MenuItem);
	module.exports = exports['default'];

/***/ },
/* 2235 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _events = __webpack_require__(1694);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _ownerDocument = __webpack_require__(173);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	var _inDOM = __webpack_require__(123);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	var _scrollbarSize = __webpack_require__(680);
	
	var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Modal = __webpack_require__(2288);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _isOverflowing = __webpack_require__(945);
	
	var _isOverflowing2 = _interopRequireDefault(_isOverflowing);
	
	var _elementType = __webpack_require__(42);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _Fade = __webpack_require__(296);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	var _ModalBody = __webpack_require__(919);
	
	var _ModalBody2 = _interopRequireDefault(_ModalBody);
	
	var _ModalDialog = __webpack_require__(2236);
	
	var _ModalDialog2 = _interopRequireDefault(_ModalDialog);
	
	var _ModalFooter = __webpack_require__(920);
	
	var _ModalFooter2 = _interopRequireDefault(_ModalFooter);
	
	var _ModalHeader = __webpack_require__(921);
	
	var _ModalHeader2 = _interopRequireDefault(_ModalHeader);
	
	var _ModalTitle = __webpack_require__(922);
	
	var _ModalTitle2 = _interopRequireDefault(_ModalTitle);
	
	var _bootstrapUtils = __webpack_require__(24);
	
	var _createChainedFunction = __webpack_require__(62);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _splitComponentProps2 = __webpack_require__(297);
	
	var _splitComponentProps3 = _interopRequireDefault(_splitComponentProps2);
	
	var _StyleConfig = __webpack_require__(64);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _extends3['default'])({}, _Modal2['default'].propTypes, _ModalDialog2['default'].propTypes, {
	
	  /**
	   * Include a backdrop component. Specify 'static' for a backdrop that doesn't
	   * trigger an "onHide" when clicked.
	   */
	  backdrop: _propTypes2['default'].oneOf(['static', true, false]),
	
	  /**
	   * Close the modal when escape key is pressed
	   */
	  keyboard: _propTypes2['default'].bool,
	
	  /**
	   * Open and close the Modal with a slide and fade animation.
	   */
	  animation: _propTypes2['default'].bool,
	
	  /**
	   * A Component type that provides the modal content Markup. This is a useful
	   * prop when you want to use your own styles and markup to create a custom
	   * modal component.
	   */
	  dialogComponentClass: _elementType2['default'],
	
	  /**
	   * When `true` The modal will automatically shift focus to itself when it
	   * opens, and replace it to the last focused element when it closes.
	   * Generally this should never be set to false as it makes the Modal less
	   * accessible to assistive technologies, like screen-readers.
	   */
	  autoFocus: _propTypes2['default'].bool,
	
	  /**
	   * When `true` The modal will prevent focus from leaving the Modal while
	   * open. Consider leaving the default value here, as it is necessary to make
	   * the Modal work well with assistive technologies, such as screen readers.
	   */
	  enforceFocus: _propTypes2['default'].bool,
	
	  /**
	   * When `true` The modal will restore focus to previously focused element once
	   * modal is hidden
	   */
	  restoreFocus: _propTypes2['default'].bool,
	
	  /**
	   * When `true` The modal will show itself.
	   */
	  show: _propTypes2['default'].bool,
	
	  /**
	   * A callback fired when the header closeButton or non-static backdrop is
	   * clicked. Required if either are specified.
	   */
	  onHide: _propTypes2['default'].func,
	
	  /**
	   * Callback fired before the Modal transitions in
	   */
	  onEnter: _propTypes2['default'].func,
	
	  /**
	   * Callback fired as the Modal begins to transition in
	   */
	  onEntering: _propTypes2['default'].func,
	
	  /**
	   * Callback fired after the Modal finishes transitioning in
	   */
	  onEntered: _propTypes2['default'].func,
	
	  /**
	   * Callback fired right before the Modal transitions out
	   */
	  onExit: _propTypes2['default'].func,
	
	  /**
	   * Callback fired as the Modal begins to transition out
	   */
	  onExiting: _propTypes2['default'].func,
	
	  /**
	   * Callback fired after the Modal finishes transitioning out
	   */
	  onExited: _propTypes2['default'].func,
	
	  /**
	   * @private
	   */
	  container: _Modal2['default'].propTypes.container
	});
	
	var defaultProps = (0, _extends3['default'])({}, _Modal2['default'].defaultProps, {
	  animation: true,
	  dialogComponentClass: _ModalDialog2['default']
	});
	
	var childContextTypes = {
	  $bs_modal: _propTypes2['default'].shape({
	    onHide: _propTypes2['default'].func
	  })
	};
	
	var Modal = function (_React$Component) {
	  (0, _inherits3['default'])(Modal, _React$Component);
	
	  function Modal(props, context) {
	    (0, _classCallCheck3['default'])(this, Modal);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleEntering = _this.handleEntering.bind(_this);
	    _this.handleExited = _this.handleExited.bind(_this);
	    _this.handleWindowResize = _this.handleWindowResize.bind(_this);
	    _this.handleDialogClick = _this.handleDialogClick.bind(_this);
	
	    _this.state = {
	      style: {}
	    };
	    return _this;
	  }
	
	  Modal.prototype.getChildContext = function getChildContext() {
	    return {
	      $bs_modal: {
	        onHide: this.props.onHide
	      }
	    };
	  };
	
	  Modal.prototype.componentWillUnmount = function componentWillUnmount() {
	    // Clean up the listener if we need to.
	    this.handleExited();
	  };
	
	  Modal.prototype.handleEntering = function handleEntering() {
	    // FIXME: This should work even when animation is disabled.
	    _events2['default'].on(window, 'resize', this.handleWindowResize);
	    this.updateStyle();
	  };
	
	  Modal.prototype.handleExited = function handleExited() {
	    // FIXME: This should work even when animation is disabled.
	    _events2['default'].off(window, 'resize', this.handleWindowResize);
	  };
	
	  Modal.prototype.handleWindowResize = function handleWindowResize() {
	    this.updateStyle();
	  };
	
	  Modal.prototype.handleDialogClick = function handleDialogClick(e) {
	    if (e.target !== e.currentTarget) {
	      return;
	    }
	
	    this.props.onHide();
	  };
	
	  Modal.prototype.updateStyle = function updateStyle() {
	    if (!_inDOM2['default']) {
	      return;
	    }
	
	    var dialogNode = this._modal.getDialogElement();
	    var dialogHeight = dialogNode.scrollHeight;
	
	    var document = (0, _ownerDocument2['default'])(dialogNode);
	    var bodyIsOverflowing = (0, _isOverflowing2['default'])(_reactDom2['default'].findDOMNode(this.props.container || document.body));
	    var modalIsOverflowing = dialogHeight > document.documentElement.clientHeight;
	
	    this.setState({
	      style: {
	        paddingRight: bodyIsOverflowing && !modalIsOverflowing ? (0, _scrollbarSize2['default'])() : undefined,
	        paddingLeft: !bodyIsOverflowing && modalIsOverflowing ? (0, _scrollbarSize2['default'])() : undefined
	      }
	    });
	  };
	
	  Modal.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        backdrop = _props.backdrop,
	        animation = _props.animation,
	        show = _props.show,
	        Dialog = _props.dialogComponentClass,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        onEntering = _props.onEntering,
	        onExited = _props.onExited,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['backdrop', 'animation', 'show', 'dialogComponentClass', 'className', 'style', 'children', 'onEntering', 'onExited']);
	
	    var _splitComponentProps = (0, _splitComponentProps3['default'])(props, _Modal2['default']),
	        baseModalProps = _splitComponentProps[0],
	        dialogProps = _splitComponentProps[1];
	
	    var inClassName = show && !animation && 'in';
	
	    return _react2['default'].createElement(
	      _Modal2['default'],
	      (0, _extends3['default'])({}, baseModalProps, {
	        ref: function ref(c) {
	          _this2._modal = c;
	        },
	        show: show,
	        onEntering: (0, _createChainedFunction2['default'])(onEntering, this.handleEntering),
	        onExited: (0, _createChainedFunction2['default'])(onExited, this.handleExited),
	        backdrop: backdrop,
	        backdropClassName: (0, _classnames2['default'])((0, _bootstrapUtils.prefix)(props, 'backdrop'), inClassName),
	        containerClassName: (0, _bootstrapUtils.prefix)(props, 'open'),
	        transition: animation ? _Fade2['default'] : undefined,
	        dialogTransitionTimeout: Modal.TRANSITION_DURATION,
	        backdropTransitionTimeout: Modal.BACKDROP_TRANSITION_DURATION
	      }),
	      _react2['default'].createElement(
	        Dialog,
	        (0, _extends3['default'])({}, dialogProps, {
	          style: (0, _extends3['default'])({}, this.state.style, style),
	          className: (0, _classnames2['default'])(className, inClassName),
	          onClick: backdrop === true ? this.handleDialogClick : null
	        }),
	        children
	      )
	    );
	  };
	
	  return Modal;
	}(_react2['default'].Component);
	
	Modal.propTypes = propTypes;
	Modal.defaultProps = defaultProps;
	Modal.childContextTypes = childContextTypes;
	
	Modal.Body = _ModalBody2['default'];
	Modal.Header = _ModalHeader2['default'];
	Modal.Title = _ModalTitle2['default'];
	Modal.Footer = _ModalFooter2['default'];
	
	Modal.Dialog = _ModalDialog2['default'];
	
	Modal.TRANSITION_DURATION = 300;
	Modal.BACKDROP_TRANSITION_DURATION = 150;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('modal', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], Modal));
	module.exports = exports['default'];

/***/ },
/* 2236 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(18);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(24);
	
	var _StyleConfig = __webpack_require__(64);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * A css class to apply to the Modal dialog DOM node.
	   */
	  dialogClassName: _propTypes2['default'].string
	};
	
	var ModalDialog = function (_React$Component) {
	  (0, _inherits3['default'])(ModalDialog, _React$Component);
	
	  function ModalDialog() {
	    (0, _classCallCheck3['default'])(this, ModalDialog);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalDialog.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        dialogClassName = _props.dialogClassName,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['dialogClassName', 'className', 'style', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var bsClassName = (0, _bootstrapUtils.prefix)(bsProps);
	
	    var modalStyle = (0, _extends4['default'])({ display: 'block' }, style);
	
	    var dialogClasses = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[bsClassName] = false, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'dialog')] = true, _extends2));
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends4['default'])({}, elementProps, {
	        tabIndex: '-1',
	        role: 'dialog',
	        style: modalStyle,
	        className: (0, _classnames2['default'])(className, bsClassName)
	      }),
	      _react2['default'].createElement(
	        'div',
	        { className: (0, _classnames2['default'])(dialogClassName, dialogClasses) },
	        _react2['default'].createElement(
	          'div',
	          { className: (0, _bootstrapUtils.prefix)(bsProps, 'content'), role: 'document' },
	          children
	        )
	      )
	    );
	  };
	
	  return ModalDialog;
	}(_react2['default'].Component);
	
	ModalDialog.propTypes = propTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('modal', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], ModalDialog));
	module.exports = exports['default'];

/***/ },
/* 2237 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Dropdown = __webpack_require__(295);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _splitComponentProps2 = __webpack_require__(297);
	
	var _splitComponentProps3 = _interopRequireDefault(_splitComponentProps2);
	
	var _ValidComponentChildren = __webpack_require__(74);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _extends3['default'])({}, _Dropdown2['default'].propTypes, {
	
	  // Toggle props.
	  title: _propTypes2['default'].node.isRequired,
	  noCaret: _propTypes2['default'].bool,
	  active: _propTypes2['default'].bool,
	
	  // Override generated docs from <Dropdown>.
	  /**
	   * @private
	   */
	  children: _propTypes2['default'].node
	});
	
	var NavDropdown = function (_React$Component) {
	  (0, _inherits3['default'])(NavDropdown, _React$Component);
	
	  function NavDropdown() {
	    (0, _classCallCheck3['default'])(this, NavDropdown);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  NavDropdown.prototype.isActive = function isActive(_ref, activeKey, activeHref) {
	    var props = _ref.props;
	
	    var _this2 = this;
	
	    if (props.active || activeKey != null && props.eventKey === activeKey || activeHref && props.href === activeHref) {
	      return true;
	    }
	
	    if (_ValidComponentChildren2['default'].some(props.children, function (child) {
	      return _this2.isActive(child, activeKey, activeHref);
	    })) {
	      return true;
	    }
	
	    return props.active;
	  };
	
	  NavDropdown.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props = this.props,
	        title = _props.title,
	        activeKey = _props.activeKey,
	        activeHref = _props.activeHref,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['title', 'activeKey', 'activeHref', 'className', 'style', 'children']);
	
	
	    var active = this.isActive(this, activeKey, activeHref);
	    delete props.active; // Accessed via this.isActive().
	    delete props.eventKey; // Accessed via this.isActive().
	
	    var _splitComponentProps = (0, _splitComponentProps3['default'])(props, _Dropdown2['default'].ControlledComponent),
	        dropdownProps = _splitComponentProps[0],
	        toggleProps = _splitComponentProps[1];
	
	    // Unlike for the other dropdowns, styling needs to go to the `<Dropdown>`
	    // rather than the `<Dropdown.Toggle>`.
	
	    return _react2['default'].createElement(
	      _Dropdown2['default'],
	      (0, _extends3['default'])({}, dropdownProps, {
	        componentClass: 'li',
	        className: (0, _classnames2['default'])(className, { active: active }),
	        style: style
	      }),
	      _react2['default'].createElement(
	        _Dropdown2['default'].Toggle,
	        (0, _extends3['default'])({}, toggleProps, { useAnchor: true }),
	        title
	      ),
	      _react2['default'].createElement(
	        _Dropdown2['default'].Menu,
	        null,
	        _ValidComponentChildren2['default'].map(children, function (child) {
	          return _react2['default'].cloneElement(child, {
	            active: _this3.isActive(child, activeKey, activeHref)
	          });
	        })
	      )
	    );
	  };
	
	  return NavDropdown;
	}(_react2['default'].Component);
	
	NavDropdown.propTypes = propTypes;
	
	exports['default'] = NavDropdown;
	module.exports = exports['default'];

/***/ },
/* 2238 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(18);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(42);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _uncontrollable = __webpack_require__(318);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _Grid = __webpack_require__(917);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _NavbarBrand = __webpack_require__(925);
	
	var _NavbarBrand2 = _interopRequireDefault(_NavbarBrand);
	
	var _NavbarCollapse = __webpack_require__(2239);
	
	var _NavbarCollapse2 = _interopRequireDefault(_NavbarCollapse);
	
	var _NavbarHeader = __webpack_require__(2240);
	
	var _NavbarHeader2 = _interopRequireDefault(_NavbarHeader);
	
	var _NavbarToggle = __webpack_require__(2241);
	
	var _NavbarToggle2 = _interopRequireDefault(_NavbarToggle);
	
	var _bootstrapUtils = __webpack_require__(24);
	
	var _StyleConfig = __webpack_require__(64);
	
	var _createChainedFunction = __webpack_require__(62);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Create a fixed navbar along the top of the screen, that scrolls with the
	   * page
	   */
	  fixedTop: _propTypes2['default'].bool,
	  /**
	   * Create a fixed navbar along the bottom of the screen, that scrolls with
	   * the page
	   */
	  fixedBottom: _propTypes2['default'].bool,
	  /**
	   * Create a full-width navbar that scrolls away with the page
	   */
	  staticTop: _propTypes2['default'].bool,
	  /**
	   * An alternative dark visual style for the Navbar
	   */
	  inverse: _propTypes2['default'].bool,
	  /**
	   * Allow the Navbar to fluidly adjust to the page or container width, instead
	   * of at the predefined screen breakpoints
	   */
	  fluid: _propTypes2['default'].bool,
	
	  /**
	   * Set a custom element for this component.
	   */
	  componentClass: _elementType2['default'],
	  /**
	   * A callback fired when the `<Navbar>` body collapses or expands. Fired when
	   * a `<Navbar.Toggle>` is clicked and called with the new `navExpanded`
	   * boolean value.
	   *
	   * @controllable navExpanded
	   */
	  onToggle: _propTypes2['default'].func,
	  /**
	   * A callback fired when a descendant of a child `<Nav>` is selected. Should
	   * be used to execute complex closing or other miscellaneous actions desired
	   * after selecting a descendant of `<Nav>`. Does nothing if no `<Nav>` or `<Nav>`
	   * descendants exist. The callback is called with an eventKey, which is a
	   * prop from the selected `<Nav>` descendant, and an event.
	   *
	   * ```js
	   * function (
	   * 	Any eventKey,
	   * 	SyntheticEvent event?
	   * )
	   * ```
	   *
	   * For basic closing behavior after all `<Nav>` descendant onSelect events in
	   * mobile viewports, try using collapseOnSelect.
	   *
	   * Note: If you are manually closing the navbar using this `OnSelect` prop,
	   * ensure that you are setting `expanded` to false and not *toggling* between
	   * true and false.
	   */
	  onSelect: _propTypes2['default'].func,
	  /**
	   * Sets `expanded` to `false` after the onSelect event of a descendant of a
	   * child `<Nav>`. Does nothing if no `<Nav>` or `<Nav>` descendants exist.
	   *
	   * The onSelect callback should be used instead for more complex operations
	   * that need to be executed after the `select` event of `<Nav>` descendants.
	   */
	  collapseOnSelect: _propTypes2['default'].bool,
	  /**
	   * Explicitly set the visiblity of the navbar body
	   *
	   * @controllable onToggle
	   */
	  expanded: _propTypes2['default'].bool,
	
	  role: _propTypes2['default'].string
	}; // TODO: Remove this pragma once we upgrade eslint-config-airbnb.
	/* eslint-disable react/no-multi-comp */
	
	var defaultProps = {
	  componentClass: 'nav',
	  fixedTop: false,
	  fixedBottom: false,
	  staticTop: false,
	  inverse: false,
	  fluid: false,
	  collapseOnSelect: false
	};
	
	var childContextTypes = {
	  $bs_navbar: _propTypes2['default'].shape({
	    bsClass: _propTypes2['default'].string,
	    expanded: _propTypes2['default'].bool,
	    onToggle: _propTypes2['default'].func.isRequired,
	    onSelect: _propTypes2['default'].func
	  })
	};
	
	var Navbar = function (_React$Component) {
	  (0, _inherits3['default'])(Navbar, _React$Component);
	
	  function Navbar(props, context) {
	    (0, _classCallCheck3['default'])(this, Navbar);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleToggle = _this.handleToggle.bind(_this);
	    _this.handleCollapse = _this.handleCollapse.bind(_this);
	    return _this;
	  }
	
	  Navbar.prototype.getChildContext = function getChildContext() {
	    var _props = this.props,
	        bsClass = _props.bsClass,
	        expanded = _props.expanded,
	        onSelect = _props.onSelect,
	        collapseOnSelect = _props.collapseOnSelect;
	
	
	    return {
	      $bs_navbar: {
	        bsClass: bsClass,
	        expanded: expanded,
	        onToggle: this.handleToggle,
	        onSelect: (0, _createChainedFunction2['default'])(onSelect, collapseOnSelect ? this.handleCollapse : null)
	      }
	    };
	  };
	
	  Navbar.prototype.handleCollapse = function handleCollapse() {
	    var _props2 = this.props,
	        onToggle = _props2.onToggle,
	        expanded = _props2.expanded;
	
	
	    if (expanded) {
	      onToggle(false);
	    }
	  };
	
	  Navbar.prototype.handleToggle = function handleToggle() {
	    var _props3 = this.props,
	        onToggle = _props3.onToggle,
	        expanded = _props3.expanded;
	
	
	    onToggle(!expanded);
	  };
	
	  Navbar.prototype.render = function render() {
	    var _extends2;
	
	    var _props4 = this.props,
	        Component = _props4.componentClass,
	        fixedTop = _props4.fixedTop,
	        fixedBottom = _props4.fixedBottom,
	        staticTop = _props4.staticTop,
	        inverse = _props4.inverse,
	        fluid = _props4.fluid,
	        className = _props4.className,
	        children = _props4.children,
	        props = (0, _objectWithoutProperties3['default'])(_props4, ['componentClass', 'fixedTop', 'fixedBottom', 'staticTop', 'inverse', 'fluid', 'className', 'children']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['expanded', 'onToggle', 'onSelect', 'collapseOnSelect']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    // will result in some false positives but that seems better
	    // than false negatives. strict `undefined` check allows explicit
	    // "nulling" of the role if the user really doesn't want one
	
	
	    if (elementProps.role === undefined && Component !== 'nav') {
	      elementProps.role = 'navigation';
	    }
	
	    if (inverse) {
	      bsProps.bsStyle = _StyleConfig.Style.INVERSE;
	    }
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'fixed-top')] = fixedTop, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'fixed-bottom')] = fixedBottom, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'static-top')] = staticTop, _extends2));
	
	    return _react2['default'].createElement(
	      Component,
	      (0, _extends4['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      _react2['default'].createElement(
	        _Grid2['default'],
	        { fluid: fluid },
	        children
	      )
	    );
	  };
	
	  return Navbar;
	}(_react2['default'].Component);
	
	Navbar.propTypes = propTypes;
	Navbar.defaultProps = defaultProps;
	Navbar.childContextTypes = childContextTypes;
	
	(0, _bootstrapUtils.bsClass)('navbar', Navbar);
	
	var UncontrollableNavbar = (0, _uncontrollable2['default'])(Navbar, { expanded: 'onToggle' });
	
	function createSimpleWrapper(tag, suffix, displayName) {
	  var Wrapper = function Wrapper(_ref, _ref2) {
	    var _ref2$$bs_navbar = _ref2.$bs_navbar,
	        navbarProps = _ref2$$bs_navbar === undefined ? { bsClass: 'navbar' } : _ref2$$bs_navbar;
	    var Component = _ref.componentClass,
	        className = _ref.className,
	        pullRight = _ref.pullRight,
	        pullLeft = _ref.pullLeft,
	        props = (0, _objectWithoutProperties3['default'])(_ref, ['componentClass', 'className', 'pullRight', 'pullLeft']);
	    return _react2['default'].createElement(Component, (0, _extends4['default'])({}, props, {
	      className: (0, _classnames2['default'])(className, (0, _bootstrapUtils.prefix)(navbarProps, suffix), pullRight && (0, _bootstrapUtils.prefix)(navbarProps, 'right'), pullLeft && (0, _bootstrapUtils.prefix)(navbarProps, 'left'))
	    }));
	  };
	
	  Wrapper.displayName = displayName;
	
	  Wrapper.propTypes = {
	    componentClass: _elementType2['default'],
	    pullRight: _propTypes2['default'].bool,
	    pullLeft: _propTypes2['default'].bool
	  };
	
	  Wrapper.defaultProps = {
	    componentClass: tag,
	    pullRight: false,
	    pullLeft: false
	  };
	
	  Wrapper.contextTypes = {
	    $bs_navbar: _propTypes2['default'].shape({
	      bsClass: _propTypes2['default'].string
	    })
	  };
	
	  return Wrapper;
	}
	
	UncontrollableNavbar.Brand = _NavbarBrand2['default'];
	UncontrollableNavbar.Header = _NavbarHeader2['default'];
	UncontrollableNavbar.Toggle = _NavbarToggle2['default'];
	UncontrollableNavbar.Collapse = _NavbarCollapse2['default'];
	
	UncontrollableNavbar.Form = createSimpleWrapper('div', 'form', 'NavbarForm');
	UncontrollableNavbar.Text = createSimpleWrapper('p', 'text', 'NavbarText');
	UncontrollableNavbar.Link = createSimpleWrapper('a', 'link', 'NavbarLink');
	
	// Set bsStyles here so they can be overridden.
	exports['default'] = (0, _bootstrapUtils.bsStyles)([_StyleConfig.Style.DEFAULT, _StyleConfig.Style.INVERSE], _StyleConfig.Style.DEFAULT, UncontrollableNavbar);
	module.exports = exports['default'];

/***/ },
/* 2239 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Collapse = __webpack_require__(458);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	var _bootstrapUtils = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var contextTypes = {
	  $bs_navbar: _propTypes2['default'].shape({
	    bsClass: _propTypes2['default'].string,
	    expanded: _propTypes2['default'].bool
	  })
	};
	
	var NavbarCollapse = function (_React$Component) {
	  (0, _inherits3['default'])(NavbarCollapse, _React$Component);
	
	  function NavbarCollapse() {
	    (0, _classCallCheck3['default'])(this, NavbarCollapse);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  NavbarCollapse.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['children']);
	
	    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	    var bsClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'collapse');
	
	    return _react2['default'].createElement(
	      _Collapse2['default'],
	      (0, _extends3['default'])({ 'in': navbarProps.expanded }, props),
	      _react2['default'].createElement(
	        'div',
	        { className: bsClassName },
	        children
	      )
	    );
	  };
	
	  return NavbarCollapse;
	}(_react2['default'].Component);
	
	NavbarCollapse.contextTypes = contextTypes;
	
	exports['default'] = NavbarCollapse;
	module.exports = exports['default'];

/***/ },
/* 2240 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var contextTypes = {
	  $bs_navbar: _propTypes2['default'].shape({
	    bsClass: _propTypes2['default'].string
	  })
	};
	
	var NavbarHeader = function (_React$Component) {
	  (0, _inherits3['default'])(NavbarHeader, _React$Component);
	
	  function NavbarHeader() {
	    (0, _classCallCheck3['default'])(this, NavbarHeader);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  NavbarHeader.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	    var bsClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'header');
	
	    return _react2['default'].createElement('div', (0, _extends3['default'])({}, props, { className: (0, _classnames2['default'])(className, bsClassName) }));
	  };
	
	  return NavbarHeader;
	}(_react2['default'].Component);
	
	NavbarHeader.contextTypes = contextTypes;
	
	exports['default'] = NavbarHeader;
	module.exports = exports['default'];

/***/ },
/* 2241 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(24);
	
	var _createChainedFunction = __webpack_require__(62);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  onClick: _propTypes2['default'].func,
	  /**
	   * The toggle content, if left empty it will render the default toggle (seen above).
	   */
	  children: _propTypes2['default'].node
	};
	
	var contextTypes = {
	  $bs_navbar: _propTypes2['default'].shape({
	    bsClass: _propTypes2['default'].string,
	    expanded: _propTypes2['default'].bool,
	    onToggle: _propTypes2['default'].func.isRequired
	  })
	};
	
	var NavbarToggle = function (_React$Component) {
	  (0, _inherits3['default'])(NavbarToggle, _React$Component);
	
	  function NavbarToggle() {
	    (0, _classCallCheck3['default'])(this, NavbarToggle);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  NavbarToggle.prototype.render = function render() {
	    var _props = this.props,
	        onClick = _props.onClick,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['onClick', 'className', 'children']);
	
	    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	    var buttonProps = (0, _extends3['default'])({
	      type: 'button'
	    }, props, {
	      onClick: (0, _createChainedFunction2['default'])(onClick, navbarProps.onToggle),
	      className: (0, _classnames2['default'])(className, (0, _bootstrapUtils.prefix)(navbarProps, 'toggle'), !navbarProps.expanded && 'collapsed')
	    });
	
	    if (children) {
	      return _react2['default'].createElement(
	        'button',
	        buttonProps,
	        children
	      );
	    }
	
	    return _react2['default'].createElement(
	      'button',
	      buttonProps,
	      _react2['default'].createElement(
	        'span',
	        { className: 'sr-only' },
	        'Toggle navigation'
	      ),
	      _react2['default'].createElement('span', { className: 'icon-bar' }),
	      _react2['default'].createElement('span', { className: 'icon-bar' }),
	      _react2['default'].createElement('span', { className: 'icon-bar' })
	    );
	  };
	
	  return NavbarToggle;
	}(_react2['default'].Component);
	
	NavbarToggle.propTypes = propTypes;
	NavbarToggle.contextTypes = contextTypes;
	
	exports['default'] = NavbarToggle;
	module.exports = exports['default'];

/***/ },
/* 2242 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _contains = __webpack_require__(174);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _warning = __webpack_require__(100);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _Overlay = __webpack_require__(926);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _createChainedFunction = __webpack_require__(62);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Check if value one is inside or equal to the of value
	 *
	 * @param {string} one
	 * @param {string|array} of
	 * @returns {boolean}
	 */
	function isOneOf(one, of) {
	  if (Array.isArray(of)) {
	    return of.indexOf(one) >= 0;
	  }
	  return one === of;
	}
	
	var triggerType = _propTypes2['default'].oneOf(['click', 'hover', 'focus']);
	
	var propTypes = (0, _extends3['default'])({}, _Overlay2['default'].propTypes, {
	
	  /**
	  * Specify which action or actions trigger Overlay visibility
	  */
	  trigger: _propTypes2['default'].oneOfType([triggerType, _propTypes2['default'].arrayOf(triggerType)]),
	
	  /**
	   * A millisecond delay amount to show and hide the Overlay once triggered
	   */
	  delay: _propTypes2['default'].number,
	  /**
	   * A millisecond delay amount before showing the Overlay once triggered.
	   */
	  delayShow: _propTypes2['default'].number,
	  /**
	   * A millisecond delay amount before hiding the Overlay once triggered.
	   */
	  delayHide: _propTypes2['default'].number,
	
	  // FIXME: This should be `defaultShow`.
	  /**
	   * The initial visibility state of the Overlay. For more nuanced visibility
	   * control, consider using the Overlay component directly.
	   */
	  defaultOverlayShown: _propTypes2['default'].bool,
	
	  /**
	   * An element or text to overlay next to the target.
	   */
	  overlay: _propTypes2['default'].node.isRequired,
	
	  /**
	   * @private
	   */
	  onBlur: _propTypes2['default'].func,
	  /**
	   * @private
	   */
	  onClick: _propTypes2['default'].func,
	  /**
	   * @private
	   */
	  onFocus: _propTypes2['default'].func,
	  /**
	   * @private
	   */
	  onMouseOut: _propTypes2['default'].func,
	  /**
	   * @private
	   */
	  onMouseOver: _propTypes2['default'].func,
	
	  // Overridden props from `<Overlay>`.
	  /**
	   * @private
	   */
	  target: _propTypes2['default'].oneOf([null]),
	  /**
	  * @private
	  */
	  onHide: _propTypes2['default'].oneOf([null]),
	  /**
	   * @private
	   */
	  show: _propTypes2['default'].oneOf([null])
	});
	
	var defaultProps = {
	  defaultOverlayShown: false,
	  trigger: ['hover', 'focus']
	};
	
	var OverlayTrigger = function (_React$Component) {
	  (0, _inherits3['default'])(OverlayTrigger, _React$Component);
	
	  function OverlayTrigger(props, context) {
	    (0, _classCallCheck3['default'])(this, OverlayTrigger);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleToggle = _this.handleToggle.bind(_this);
	    _this.handleDelayedShow = _this.handleDelayedShow.bind(_this);
	    _this.handleDelayedHide = _this.handleDelayedHide.bind(_this);
	    _this.handleHide = _this.handleHide.bind(_this);
	
	    _this.handleMouseOver = function (e) {
	      return _this.handleMouseOverOut(_this.handleDelayedShow, e);
	    };
	    _this.handleMouseOut = function (e) {
	      return _this.handleMouseOverOut(_this.handleDelayedHide, e);
	    };
	
	    _this._mountNode = null;
	
	    _this.state = {
	      show: props.defaultOverlayShown
	    };
	    return _this;
	  }
	
	  OverlayTrigger.prototype.componentDidMount = function componentDidMount() {
	    this._mountNode = document.createElement('div');
	    this.renderOverlay();
	  };
	
	  OverlayTrigger.prototype.componentDidUpdate = function componentDidUpdate() {
	    this.renderOverlay();
	  };
	
	  OverlayTrigger.prototype.componentWillUnmount = function componentWillUnmount() {
	    _reactDom2['default'].unmountComponentAtNode(this._mountNode);
	    this._mountNode = null;
	
	    clearTimeout(this._hoverShowDelay);
	    clearTimeout(this._hoverHideDelay);
	  };
	
	  OverlayTrigger.prototype.handleToggle = function handleToggle() {
	    if (this.state.show) {
	      this.hide();
	    } else {
	      this.show();
	    }
	  };
	
	  OverlayTrigger.prototype.handleDelayedShow = function handleDelayedShow() {
	    var _this2 = this;
	
	    if (this._hoverHideDelay != null) {
	      clearTimeout(this._hoverHideDelay);
	      this._hoverHideDelay = null;
	      return;
	    }
	
	    if (this.state.show || this._hoverShowDelay != null) {
	      return;
	    }
	
	    var delay = this.props.delayShow != null ? this.props.delayShow : this.props.delay;
	
	    if (!delay) {
	      this.show();
	      return;
	    }
	
	    this._hoverShowDelay = setTimeout(function () {
	      _this2._hoverShowDelay = null;
	      _this2.show();
	    }, delay);
	  };
	
	  OverlayTrigger.prototype.handleDelayedHide = function handleDelayedHide() {
	    var _this3 = this;
	
	    if (this._hoverShowDelay != null) {
	      clearTimeout(this._hoverShowDelay);
	      this._hoverShowDelay = null;
	      return;
	    }
	
	    if (!this.state.show || this._hoverHideDelay != null) {
	      return;
	    }
	
	    var delay = this.props.delayHide != null ? this.props.delayHide : this.props.delay;
	
	    if (!delay) {
	      this.hide();
	      return;
	    }
	
	    this._hoverHideDelay = setTimeout(function () {
	      _this3._hoverHideDelay = null;
	      _this3.hide();
	    }, delay);
	  };
	
	  // Simple implementation of mouseEnter and mouseLeave.
	  // React's built version is broken: https://github.com/facebook/react/issues/4251
	  // for cases when the trigger is disabled and mouseOut/Over can cause flicker
	  // moving from one child element to another.
	
	
	  OverlayTrigger.prototype.handleMouseOverOut = function handleMouseOverOut(handler, e) {
	    var target = e.currentTarget;
	    var related = e.relatedTarget || e.nativeEvent.toElement;
	
	    if (!related || related !== target && !(0, _contains2['default'])(target, related)) {
	      handler(e);
	    }
	  };
	
	  OverlayTrigger.prototype.handleHide = function handleHide() {
	    this.hide();
	  };
	
	  OverlayTrigger.prototype.show = function show() {
	    this.setState({ show: true });
	  };
	
	  OverlayTrigger.prototype.hide = function hide() {
	    this.setState({ show: false });
	  };
	
	  OverlayTrigger.prototype.makeOverlay = function makeOverlay(overlay, props) {
	    return _react2['default'].createElement(
	      _Overlay2['default'],
	      (0, _extends3['default'])({}, props, {
	        show: this.state.show,
	        onHide: this.handleHide,
	        target: this
	      }),
	      overlay
	    );
	  };
	
	  OverlayTrigger.prototype.renderOverlay = function renderOverlay() {
	    _reactDom2['default'].unstable_renderSubtreeIntoContainer(this, this._overlay, this._mountNode);
	  };
	
	  OverlayTrigger.prototype.render = function render() {
	    var _props = this.props,
	        trigger = _props.trigger,
	        overlay = _props.overlay,
	        children = _props.children,
	        onBlur = _props.onBlur,
	        onClick = _props.onClick,
	        onFocus = _props.onFocus,
	        onMouseOut = _props.onMouseOut,
	        onMouseOver = _props.onMouseOver,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['trigger', 'overlay', 'children', 'onBlur', 'onClick', 'onFocus', 'onMouseOut', 'onMouseOver']);
	
	
	    delete props.delay;
	    delete props.delayShow;
	    delete props.delayHide;
	    delete props.defaultOverlayShown;
	
	    var child = _react2['default'].Children.only(children);
	    var childProps = child.props;
	    var triggerProps = {};
	
	    if (this.state.show) {
	      triggerProps['aria-describedby'] = overlay.props.id;
	    }
	
	    // FIXME: The logic here for passing through handlers on this component is
	    // inconsistent. We shouldn't be passing any of these props through.
	
	    triggerProps.onClick = (0, _createChainedFunction2['default'])(childProps.onClick, onClick);
	
	    if (isOneOf('click', trigger)) {
	      triggerProps.onClick = (0, _createChainedFunction2['default'])(triggerProps.onClick, this.handleToggle);
	    }
	
	    if (isOneOf('hover', trigger)) {
	       false ? (0, _warning2['default'])(!(trigger === 'hover'), '[react-bootstrap] Specifying only the `"hover"` trigger limits the ' + 'visibility of the overlay to just mouse users. Consider also ' + 'including the `"focus"` trigger so that touch and keyboard only ' + 'users can see the overlay as well.') : void 0;
	
	      triggerProps.onMouseOver = (0, _createChainedFunction2['default'])(childProps.onMouseOver, onMouseOver, this.handleMouseOver);
	      triggerProps.onMouseOut = (0, _createChainedFunction2['default'])(childProps.onMouseOut, onMouseOut, this.handleMouseOut);
	    }
	
	    if (isOneOf('focus', trigger)) {
	      triggerProps.onFocus = (0, _createChainedFunction2['default'])(childProps.onFocus, onFocus, this.handleDelayedShow);
	      triggerProps.onBlur = (0, _createChainedFunction2['default'])(childProps.onBlur, onBlur, this.handleDelayedHide);
	    }
	
	    this._overlay = this.makeOverlay(overlay, props);
	
	    return (0, _react.cloneElement)(child, triggerProps);
	  };
	
	  return OverlayTrigger;
	}(_react2['default'].Component);
	
	OverlayTrigger.propTypes = propTypes;
	OverlayTrigger.defaultProps = defaultProps;
	
	exports['default'] = OverlayTrigger;
	module.exports = exports['default'];

/***/ },
/* 2243 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var PageHeader = function (_React$Component) {
	  (0, _inherits3['default'])(PageHeader, _React$Component);
	
	  function PageHeader() {
	    (0, _classCallCheck3['default'])(this, PageHeader);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  PageHeader.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      _react2['default'].createElement(
	        'h1',
	        null,
	        children
	      )
	    );
	  };
	
	  return PageHeader;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('page-header', PageHeader);
	module.exports = exports['default'];

/***/ },
/* 2244 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PagerItem = __webpack_require__(927);
	
	var _PagerItem2 = _interopRequireDefault(_PagerItem);
	
	var _deprecationWarning = __webpack_require__(2263);
	
	var _deprecationWarning2 = _interopRequireDefault(_deprecationWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _deprecationWarning2['default'].wrapper(_PagerItem2['default'], '`<PageItem>`', '`<Pager.Item>`');
	module.exports = exports['default'];

/***/ },
/* 2245 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PagerItem = __webpack_require__(927);
	
	var _PagerItem2 = _interopRequireDefault(_PagerItem);
	
	var _bootstrapUtils = __webpack_require__(24);
	
	var _createChainedFunction = __webpack_require__(62);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _ValidComponentChildren = __webpack_require__(74);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  onSelect: _propTypes2['default'].func
	};
	
	var Pager = function (_React$Component) {
	  (0, _inherits3['default'])(Pager, _React$Component);
	
	  function Pager() {
	    (0, _classCallCheck3['default'])(this, Pager);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Pager.prototype.render = function render() {
	    var _props = this.props,
	        onSelect = _props.onSelect,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['onSelect', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(
	      'ul',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      _ValidComponentChildren2['default'].map(children, function (child) {
	        return (0, _react.cloneElement)(child, {
	          onSelect: (0, _createChainedFunction2['default'])(child.props.onSelect, onSelect)
	        });
	      })
	    );
	  };
	
	  return Pager;
	}(_react2['default'].Component);
	
	Pager.propTypes = propTypes;
	
	Pager.Item = _PagerItem2['default'];
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('pager', Pager);
	module.exports = exports['default'];

/***/ },
/* 2246 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(42);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _PaginationButton = __webpack_require__(928);
	
	var _PaginationButton2 = _interopRequireDefault(_PaginationButton);
	
	var _bootstrapUtils = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  activePage: _propTypes2['default'].number,
	  items: _propTypes2['default'].number,
	  maxButtons: _propTypes2['default'].number,
	
	  /**
	   * When `true`, will display the first and the last button page when
	   * displaying ellipsis.
	   */
	  boundaryLinks: _propTypes2['default'].bool,
	
	  /**
	   * When `true`, will display the default node value ('&hellip;').
	   * Otherwise, will display provided node (when specified).
	   */
	  ellipsis: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].node]),
	
	  /**
	   * When `true`, will display the default node value ('&laquo;').
	   * Otherwise, will display provided node (when specified).
	   */
	  first: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].node]),
	
	  /**
	   * When `true`, will display the default node value ('&raquo;').
	   * Otherwise, will display provided node (when specified).
	   */
	  last: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].node]),
	
	  /**
	   * When `true`, will display the default node value ('&lsaquo;').
	   * Otherwise, will display provided node (when specified).
	   */
	  prev: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].node]),
	
	  /**
	   * When `true`, will display the default node value ('&rsaquo;').
	   * Otherwise, will display provided node (when specified).
	   */
	  next: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].node]),
	
	  onSelect: _propTypes2['default'].func,
	
	  /**
	   * You can use a custom element for the buttons
	   */
	  buttonComponentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  activePage: 1,
	  items: 1,
	  maxButtons: 0,
	  first: false,
	  last: false,
	  prev: false,
	  next: false,
	  ellipsis: true,
	  boundaryLinks: false
	};
	
	var Pagination = function (_React$Component) {
	  (0, _inherits3['default'])(Pagination, _React$Component);
	
	  function Pagination() {
	    (0, _classCallCheck3['default'])(this, Pagination);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Pagination.prototype.renderPageButtons = function renderPageButtons(activePage, items, maxButtons, boundaryLinks, ellipsis, buttonProps) {
	    var pageButtons = [];
	
	    var startPage = void 0;
	    var endPage = void 0;
	
	    if (maxButtons && maxButtons < items) {
	      startPage = Math.max(Math.min(activePage - Math.floor(maxButtons / 2, 10), items - maxButtons + 1), 1);
	      endPage = startPage + maxButtons - 1;
	    } else {
	      startPage = 1;
	      endPage = items;
	    }
	
	    for (var page = startPage; page <= endPage; ++page) {
	      pageButtons.push(_react2['default'].createElement(
	        _PaginationButton2['default'],
	        (0, _extends3['default'])({}, buttonProps, {
	          key: page,
	          eventKey: page,
	          active: page === activePage
	        }),
	        page
	      ));
	    }
	
	    if (ellipsis && boundaryLinks && startPage > 1) {
	      if (startPage > 2) {
	        pageButtons.unshift(_react2['default'].createElement(
	          _PaginationButton2['default'],
	          {
	            key: 'ellipsisFirst',
	            disabled: true,
	            componentClass: buttonProps.componentClass
	          },
	          _react2['default'].createElement(
	            'span',
	            { 'aria-label': 'More' },
	            ellipsis === true ? '\u2026' : ellipsis
	          )
	        ));
	      }
	
	      pageButtons.unshift(_react2['default'].createElement(
	        _PaginationButton2['default'],
	        (0, _extends3['default'])({}, buttonProps, {
	          key: 1,
	          eventKey: 1,
	          active: false
	        }),
	        '1'
	      ));
	    }
	
	    if (ellipsis && endPage < items) {
	      if (!boundaryLinks || endPage < items - 1) {
	        pageButtons.push(_react2['default'].createElement(
	          _PaginationButton2['default'],
	          {
	            key: 'ellipsis',
	            disabled: true,
	            componentClass: buttonProps.componentClass
	          },
	          _react2['default'].createElement(
	            'span',
	            { 'aria-label': 'More' },
	            ellipsis === true ? '\u2026' : ellipsis
	          )
	        ));
	      }
	
	      if (boundaryLinks) {
	        pageButtons.push(_react2['default'].createElement(
	          _PaginationButton2['default'],
	          (0, _extends3['default'])({}, buttonProps, {
	            key: items,
	            eventKey: items,
	            active: false
	          }),
	          items
	        ));
	      }
	    }
	
	    return pageButtons;
	  };
	
	  Pagination.prototype.render = function render() {
	    var _props = this.props,
	        activePage = _props.activePage,
	        items = _props.items,
	        maxButtons = _props.maxButtons,
	        boundaryLinks = _props.boundaryLinks,
	        ellipsis = _props.ellipsis,
	        first = _props.first,
	        last = _props.last,
	        prev = _props.prev,
	        next = _props.next,
	        onSelect = _props.onSelect,
	        buttonComponentClass = _props.buttonComponentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['activePage', 'items', 'maxButtons', 'boundaryLinks', 'ellipsis', 'first', 'last', 'prev', 'next', 'onSelect', 'buttonComponentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    var buttonProps = {
	      onSelect: onSelect,
	      componentClass: buttonComponentClass
	    };
	
	    return _react2['default'].createElement(
	      'ul',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      first && _react2['default'].createElement(
	        _PaginationButton2['default'],
	        (0, _extends3['default'])({}, buttonProps, {
	          eventKey: 1,
	          disabled: activePage === 1
	        }),
	        _react2['default'].createElement(
	          'span',
	          { 'aria-label': 'First' },
	          first === true ? '\xAB' : first
	        )
	      ),
	      prev && _react2['default'].createElement(
	        _PaginationButton2['default'],
	        (0, _extends3['default'])({}, buttonProps, {
	          eventKey: activePage - 1,
	          disabled: activePage === 1
	        }),
	        _react2['default'].createElement(
	          'span',
	          { 'aria-label': 'Previous' },
	          prev === true ? '\u2039' : prev
	        )
	      ),
	      this.renderPageButtons(activePage, items, maxButtons, boundaryLinks, ellipsis, buttonProps),
	      next && _react2['default'].createElement(
	        _PaginationButton2['default'],
	        (0, _extends3['default'])({}, buttonProps, {
	          eventKey: activePage + 1,
	          disabled: activePage >= items
	        }),
	        _react2['default'].createElement(
	          'span',
	          { 'aria-label': 'Next' },
	          next === true ? '\u203A' : next
	        )
	      ),
	      last && _react2['default'].createElement(
	        _PaginationButton2['default'],
	        (0, _extends3['default'])({}, buttonProps, {
	          eventKey: items,
	          disabled: activePage >= items
	        }),
	        _react2['default'].createElement(
	          'span',
	          { 'aria-label': 'Last' },
	          last === true ? '\xBB' : last
	        )
	      )
	    );
	  };
	
	  return Pagination;
	}(_react2['default'].Component);
	
	Pagination.propTypes = propTypes;
	Pagination.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('pagination', Pagination);
	module.exports = exports['default'];

/***/ },
/* 2247 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(157);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Collapse = __webpack_require__(458);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	var _bootstrapUtils = __webpack_require__(24);
	
	var _StyleConfig = __webpack_require__(64);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: Use uncontrollable.
	
	var propTypes = {
	  collapsible: _propTypes2['default'].bool,
	  onSelect: _propTypes2['default'].func,
	  header: _propTypes2['default'].node,
	  id: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number]),
	  footer: _propTypes2['default'].node,
	  defaultExpanded: _propTypes2['default'].bool,
	  expanded: _propTypes2['default'].bool,
	  eventKey: _propTypes2['default'].any,
	  headerRole: _propTypes2['default'].string,
	  panelRole: _propTypes2['default'].string,
	
	  // From Collapse.
	  onEnter: _propTypes2['default'].func,
	  onEntering: _propTypes2['default'].func,
	  onEntered: _propTypes2['default'].func,
	  onExit: _propTypes2['default'].func,
	  onExiting: _propTypes2['default'].func,
	  onExited: _propTypes2['default'].func
	};
	
	var defaultProps = {
	  defaultExpanded: false
	};
	
	var Panel = function (_React$Component) {
	  (0, _inherits3['default'])(Panel, _React$Component);
	
	  function Panel(props, context) {
	    (0, _classCallCheck3['default'])(this, Panel);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleClickTitle = _this.handleClickTitle.bind(_this);
	
	    _this.state = {
	      expanded: _this.props.defaultExpanded
	    };
	    return _this;
	  }
	
	  Panel.prototype.handleClickTitle = function handleClickTitle(e) {
	    // FIXME: What the heck? This API is horrible. This needs to go away!
	    e.persist();
	    e.selected = true;
	
	    if (this.props.onSelect) {
	      this.props.onSelect(this.props.eventKey, e);
	    } else {
	      e.preventDefault();
	    }
	
	    if (e.selected) {
	      this.setState({ expanded: !this.state.expanded });
	    }
	  };
	
	  Panel.prototype.renderHeader = function renderHeader(collapsible, header, id, role, expanded, bsProps) {
	    var titleClassName = (0, _bootstrapUtils.prefix)(bsProps, 'title');
	
	    if (!collapsible) {
	      if (!_react2['default'].isValidElement(header)) {
	        return header;
	      }
	
	      return (0, _react.cloneElement)(header, {
	        className: (0, _classnames2['default'])(header.props.className, titleClassName)
	      });
	    }
	
	    if (!_react2['default'].isValidElement(header)) {
	      return _react2['default'].createElement(
	        'h4',
	        { role: 'presentation', className: titleClassName },
	        this.renderAnchor(header, id, role, expanded)
	      );
	    }
	
	    return (0, _react.cloneElement)(header, {
	      className: (0, _classnames2['default'])(header.props.className, titleClassName),
	      children: this.renderAnchor(header.props.children, id, role, expanded)
	    });
	  };
	
	  Panel.prototype.renderAnchor = function renderAnchor(header, id, role, expanded) {
	    return _react2['default'].createElement(
	      'a',
	      {
	        role: role,
	        href: id && '#' + id,
	        onClick: this.handleClickTitle,
	        'aria-controls': id,
	        'aria-expanded': expanded,
	        'aria-selected': expanded,
	        className: expanded ? null : 'collapsed'
	      },
	      header
	    );
	  };
	
	  Panel.prototype.renderCollapsibleBody = function renderCollapsibleBody(id, expanded, role, children, bsProps, animationHooks) {
	    return _react2['default'].createElement(
	      _Collapse2['default'],
	      (0, _extends3['default'])({ 'in': expanded }, animationHooks),
	      _react2['default'].createElement(
	        'div',
	        {
	          id: id,
	          role: role,
	          className: (0, _bootstrapUtils.prefix)(bsProps, 'collapse'),
	          'aria-hidden': !expanded
	        },
	        this.renderBody(children, bsProps)
	      )
	    );
	  };
	
	  Panel.prototype.renderBody = function renderBody(rawChildren, bsProps) {
	    var children = [];
	    var bodyChildren = [];
	
	    var bodyClassName = (0, _bootstrapUtils.prefix)(bsProps, 'body');
	
	    function maybeAddBody() {
	      if (!bodyChildren.length) {
	        return;
	      }
	
	      // Derive the key from the index here, since we need to make one up.
	      children.push(_react2['default'].createElement(
	        'div',
	        { key: children.length, className: bodyClassName },
	        bodyChildren
	      ));
	
	      bodyChildren = [];
	    }
	
	    // Convert to array so we can re-use keys.
	    _react2['default'].Children.toArray(rawChildren).forEach(function (child) {
	      if (_react2['default'].isValidElement(child) && child.props.fill) {
	        maybeAddBody();
	
	        // Remove the child's unknown `fill` prop.
	        children.push((0, _react.cloneElement)(child, { fill: undefined }));
	
	        return;
	      }
	
	      bodyChildren.push(child);
	    });
	
	    maybeAddBody();
	
	    return children;
	  };
	
	  Panel.prototype.render = function render() {
	    var _props = this.props,
	        collapsible = _props.collapsible,
	        header = _props.header,
	        id = _props.id,
	        footer = _props.footer,
	        propsExpanded = _props.expanded,
	        headerRole = _props.headerRole,
	        panelRole = _props.panelRole,
	        className = _props.className,
	        children = _props.children,
	        onEnter = _props.onEnter,
	        onEntering = _props.onEntering,
	        onEntered = _props.onEntered,
	        onExit = _props.onExit,
	        onExiting = _props.onExiting,
	        onExited = _props.onExited,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['collapsible', 'header', 'id', 'footer', 'expanded', 'headerRole', 'panelRole', 'className', 'children', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['defaultExpanded', 'eventKey', 'onSelect']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var expanded = propsExpanded != null ? propsExpanded : this.state.expanded;
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes),
	        id: collapsible ? null : id
	      }),
	      header && _react2['default'].createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'heading') },
	        this.renderHeader(collapsible, header, id, headerRole, expanded, bsProps)
	      ),
	      collapsible ? this.renderCollapsibleBody(id, expanded, panelRole, children, bsProps, { onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited }) : this.renderBody(children, bsProps),
	      footer && _react2['default'].createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'footer') },
	        footer
	      )
	    );
	  };
	
	  return Panel;
	}(_react2['default'].Component);
	
	Panel.propTypes = propTypes;
	Panel.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('panel', (0, _bootstrapUtils.bsStyles)([].concat((0, _values2['default'])(_StyleConfig.State), [_StyleConfig.Style.DEFAULT, _StyleConfig.Style.PRIMARY]), _StyleConfig.Style.DEFAULT, Panel));
	module.exports = exports['default'];

/***/ },
/* 2248 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(18);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _isRequiredForA11y = __webpack_require__(303);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _bootstrapUtils = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * An html id attribute, necessary for accessibility
	   * @type {string}
	   * @required
	   */
	  id: (0, _isRequiredForA11y2['default'])(_propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number])),
	
	  /**
	   * Sets the direction the Popover is positioned towards.
	   */
	  placement: _propTypes2['default'].oneOf(['top', 'right', 'bottom', 'left']),
	
	  /**
	   * The "top" position value for the Popover.
	   */
	  positionTop: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	  /**
	   * The "left" position value for the Popover.
	   */
	  positionLeft: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	
	  /**
	   * The "top" position value for the Popover arrow.
	   */
	  arrowOffsetTop: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	  /**
	   * The "left" position value for the Popover arrow.
	   */
	  arrowOffsetLeft: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	
	  /**
	   * Title content
	   */
	  title: _propTypes2['default'].node
	};
	
	var defaultProps = {
	  placement: 'right'
	};
	
	var Popover = function (_React$Component) {
	  (0, _inherits3['default'])(Popover, _React$Component);
	
	  function Popover() {
	    (0, _classCallCheck3['default'])(this, Popover);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Popover.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        placement = _props.placement,
	        positionTop = _props.positionTop,
	        positionLeft = _props.positionLeft,
	        arrowOffsetTop = _props.arrowOffsetTop,
	        arrowOffsetLeft = _props.arrowOffsetLeft,
	        title = _props.title,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['placement', 'positionTop', 'positionLeft', 'arrowOffsetTop', 'arrowOffsetLeft', 'title', 'className', 'style', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[placement] = true, _extends2));
	
	    var outerStyle = (0, _extends4['default'])({
	      display: 'block',
	      top: positionTop,
	      left: positionLeft
	    }, style);
	
	    var arrowStyle = {
	      top: arrowOffsetTop,
	      left: arrowOffsetLeft
	    };
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends4['default'])({}, elementProps, {
	        role: 'tooltip',
	        className: (0, _classnames2['default'])(className, classes),
	        style: outerStyle
	      }),
	      _react2['default'].createElement('div', { className: 'arrow', style: arrowStyle }),
	      title && _react2['default'].createElement(
	        'h3',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'title') },
	        title
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'content') },
	        children
	      )
	    );
	  };
	
	  return Popover;
	}(_react2['default'].Component);
	
	Popover.propTypes = propTypes;
	Popover.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('popover', Popover);
	module.exports = exports['default'];

/***/ },
/* 2249 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(157);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _extends3 = __webpack_require__(18);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(24);
	
	var _StyleConfig = __webpack_require__(64);
	
	var _ValidComponentChildren = __webpack_require__(74);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ROUND_PRECISION = 1000;
	
	/**
	 * Validate that children, if any, are instances of `<ProgressBar>`.
	 */
	function onlyProgressBar(props, propName, componentName) {
	  var children = props[propName];
	  if (!children) {
	    return null;
	  }
	
	  var error = null;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (error) {
	      return;
	    }
	
	    if (child.type === ProgressBar) {
	      // eslint-disable-line no-use-before-define
	      return;
	    }
	
	    var childIdentifier = _react2['default'].isValidElement(child) ? child.type.displayName || child.type.name || child.type : child;
	    error = new Error('Children of ' + componentName + ' can contain only ProgressBar ' + ('components. Found ' + childIdentifier + '.'));
	  });
	
	  return error;
	}
	
	var propTypes = {
	  min: _propTypes2['default'].number,
	  now: _propTypes2['default'].number,
	  max: _propTypes2['default'].number,
	  label: _propTypes2['default'].node,
	  srOnly: _propTypes2['default'].bool,
	  striped: _propTypes2['default'].bool,
	  active: _propTypes2['default'].bool,
	  children: onlyProgressBar,
	
	  /**
	   * @private
	   */
	  isChild: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  min: 0,
	  max: 100,
	  active: false,
	  isChild: false,
	  srOnly: false,
	  striped: false
	};
	
	function getPercentage(now, min, max) {
	  var percentage = (now - min) / (max - min) * 100;
	  return Math.round(percentage * ROUND_PRECISION) / ROUND_PRECISION;
	}
	
	var ProgressBar = function (_React$Component) {
	  (0, _inherits3['default'])(ProgressBar, _React$Component);
	
	  function ProgressBar() {
	    (0, _classCallCheck3['default'])(this, ProgressBar);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ProgressBar.prototype.renderProgressBar = function renderProgressBar(_ref) {
	    var _extends2;
	
	    var min = _ref.min,
	        now = _ref.now,
	        max = _ref.max,
	        label = _ref.label,
	        srOnly = _ref.srOnly,
	        striped = _ref.striped,
	        active = _ref.active,
	        className = _ref.className,
	        style = _ref.style,
	        props = (0, _objectWithoutProperties3['default'])(_ref, ['min', 'now', 'max', 'label', 'srOnly', 'striped', 'active', 'className', 'style']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {
	      active: active
	    }, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'striped')] = active || striped, _extends2));
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends4['default'])({}, elementProps, {
	        role: 'progressbar',
	        className: (0, _classnames2['default'])(className, classes),
	        style: (0, _extends4['default'])({ width: getPercentage(now, min, max) + '%' }, style),
	        'aria-valuenow': now,
	        'aria-valuemin': min,
	        'aria-valuemax': max
	      }),
	      srOnly ? _react2['default'].createElement(
	        'span',
	        { className: 'sr-only' },
	        label
	      ) : label
	    );
	  };
	
	  ProgressBar.prototype.render = function render() {
	    var _props = this.props,
	        isChild = _props.isChild,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['isChild']);
	
	
	    if (isChild) {
	      return this.renderProgressBar(props);
	    }
	
	    var min = props.min,
	        now = props.now,
	        max = props.max,
	        label = props.label,
	        srOnly = props.srOnly,
	        striped = props.striped,
	        active = props.active,
	        bsClass = props.bsClass,
	        bsStyle = props.bsStyle,
	        className = props.className,
	        children = props.children,
	        wrapperProps = (0, _objectWithoutProperties3['default'])(props, ['min', 'now', 'max', 'label', 'srOnly', 'striped', 'active', 'bsClass', 'bsStyle', 'className', 'children']);
	
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends4['default'])({}, wrapperProps, {
	        className: (0, _classnames2['default'])(className, 'progress')
	      }),
	      children ? _ValidComponentChildren2['default'].map(children, function (child) {
	        return (0, _react.cloneElement)(child, { isChild: true });
	      }) : this.renderProgressBar({
	        min: min, now: now, max: max, label: label, srOnly: srOnly, striped: striped, active: active, bsClass: bsClass, bsStyle: bsStyle
	      })
	    );
	  };
	
	  return ProgressBar;
	}(_react2['default'].Component);
	
	ProgressBar.propTypes = propTypes;
	ProgressBar.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('progress-bar', (0, _bootstrapUtils.bsStyles)((0, _values2['default'])(_StyleConfig.State), ProgressBar));
	module.exports = exports['default'];

/***/ },
/* 2250 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(100);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  inline: _propTypes2['default'].bool,
	  disabled: _propTypes2['default'].bool,
	  /**
	   * Only valid if `inline` is not set.
	   */
	  validationState: _propTypes2['default'].oneOf(['success', 'warning', 'error', null]),
	  /**
	   * Attaches a ref to the `<input>` element. Only functions can be used here.
	   *
	   * ```js
	   * <Radio inputRef={ref => { this.input = ref; }} />
	   * ```
	   */
	  inputRef: _propTypes2['default'].func
	};
	
	var defaultProps = {
	  inline: false,
	  disabled: false
	};
	
	var Radio = function (_React$Component) {
	  (0, _inherits3['default'])(Radio, _React$Component);
	
	  function Radio() {
	    (0, _classCallCheck3['default'])(this, Radio);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Radio.prototype.render = function render() {
	    var _props = this.props,
	        inline = _props.inline,
	        disabled = _props.disabled,
	        validationState = _props.validationState,
	        inputRef = _props.inputRef,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['inline', 'disabled', 'validationState', 'inputRef', 'className', 'style', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var input = _react2['default'].createElement('input', (0, _extends3['default'])({}, elementProps, {
	      ref: inputRef,
	      type: 'radio',
	      disabled: disabled
	    }));
	
	    if (inline) {
	      var _classes2;
	
	      var _classes = (_classes2 = {}, _classes2[(0, _bootstrapUtils.prefix)(bsProps, 'inline')] = true, _classes2.disabled = disabled, _classes2);
	
	      // Use a warning here instead of in propTypes to get better-looking
	      // generated documentation.
	       false ? (0, _warning2['default'])(!validationState, '`validationState` is ignored on `<Radio inline>`. To display ' + 'validation state on an inline radio, set `validationState` on a ' + 'parent `<FormGroup>` or other element instead.') : void 0;
	
	      return _react2['default'].createElement(
	        'label',
	        { className: (0, _classnames2['default'])(className, _classes), style: style },
	        input,
	        children
	      );
	    }
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      disabled: disabled
	    });
	    if (validationState) {
	      classes['has-' + validationState] = true;
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      { className: (0, _classnames2['default'])(className, classes), style: style },
	      _react2['default'].createElement(
	        'label',
	        null,
	        input,
	        children
	      )
	    );
	  };
	
	  return Radio;
	}(_react2['default'].Component);
	
	Radio.propTypes = propTypes;
	Radio.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('radio', Radio);
	module.exports = exports['default'];

/***/ },
/* 2251 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(18);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(100);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: This should probably take a single `aspectRatio` prop.
	
	var propTypes = {
	  /**
	   * This component requires a single child element
	   */
	  children: _propTypes2['default'].element.isRequired,
	  /**
	   * 16by9 aspect ratio
	   */
	  a16by9: _propTypes2['default'].bool,
	  /**
	   * 4by3 aspect ratio
	   */
	  a4by3: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  a16by9: false,
	  a4by3: false
	};
	
	var ResponsiveEmbed = function (_React$Component) {
	  (0, _inherits3['default'])(ResponsiveEmbed, _React$Component);
	
	  function ResponsiveEmbed() {
	    (0, _classCallCheck3['default'])(this, ResponsiveEmbed);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ResponsiveEmbed.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        a16by9 = _props.a16by9,
	        a4by3 = _props.a4by3,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['a16by9', 'a4by3', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	     false ? (0, _warning2['default'])(a16by9 || a4by3, 'Either `a16by9` or `a4by3` must be set.') : void 0;
	     false ? (0, _warning2['default'])(!(a16by9 && a4by3), 'Only one of `a16by9` or `a4by3` can be set.') : void 0;
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, '16by9')] = a16by9, _extends2[(0, _bootstrapUtils.prefix)(bsProps, '4by3')] = a4by3, _extends2));
	
	    return _react2['default'].createElement(
	      'div',
	      { className: (0, _classnames2['default'])(classes) },
	      (0, _react.cloneElement)(children, (0, _extends4['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, (0, _bootstrapUtils.prefix)(bsProps, 'item'))
	      }))
	    );
	  };
	
	  return ResponsiveEmbed;
	}(_react2['default'].Component);
	
	ResponsiveEmbed.propTypes = propTypes;
	ResponsiveEmbed.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('embed-responsive', ResponsiveEmbed);
	module.exports = exports['default'];

/***/ },
/* 2252 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(42);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Row = function (_React$Component) {
	  (0, _inherits3['default'])(Row, _React$Component);
	
	  function Row() {
	    (0, _classCallCheck3['default'])(this, Row);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Row.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Row;
	}(_react2['default'].Component);
	
	Row.propTypes = propTypes;
	Row.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('row', Row);
	module.exports = exports['default'];

/***/ },
/* 2253 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Button = __webpack_require__(226);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Dropdown = __webpack_require__(295);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _SplitToggle = __webpack_require__(2254);
	
	var _SplitToggle2 = _interopRequireDefault(_SplitToggle);
	
	var _splitComponentProps2 = __webpack_require__(297);
	
	var _splitComponentProps3 = _interopRequireDefault(_splitComponentProps2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _extends3['default'])({}, _Dropdown2['default'].propTypes, {
	
	  // Toggle props.
	  bsStyle: _propTypes2['default'].string,
	  bsSize: _propTypes2['default'].string,
	  href: _propTypes2['default'].string,
	  onClick: _propTypes2['default'].func,
	  /**
	   * The content of the split button.
	   */
	  title: _propTypes2['default'].node.isRequired,
	  /**
	   * Accessible label for the toggle; the value of `title` if not specified.
	   */
	  toggleLabel: _propTypes2['default'].string,
	
	  // Override generated docs from <Dropdown>.
	  /**
	   * @private
	   */
	  children: _propTypes2['default'].node
	});
	
	var SplitButton = function (_React$Component) {
	  (0, _inherits3['default'])(SplitButton, _React$Component);
	
	  function SplitButton() {
	    (0, _classCallCheck3['default'])(this, SplitButton);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  SplitButton.prototype.render = function render() {
	    var _props = this.props,
	        bsSize = _props.bsSize,
	        bsStyle = _props.bsStyle,
	        title = _props.title,
	        toggleLabel = _props.toggleLabel,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['bsSize', 'bsStyle', 'title', 'toggleLabel', 'children']);
	
	    var _splitComponentProps = (0, _splitComponentProps3['default'])(props, _Dropdown2['default'].ControlledComponent),
	        dropdownProps = _splitComponentProps[0],
	        buttonProps = _splitComponentProps[1];
	
	    return _react2['default'].createElement(
	      _Dropdown2['default'],
	      (0, _extends3['default'])({}, dropdownProps, {
	        bsSize: bsSize,
	        bsStyle: bsStyle
	      }),
	      _react2['default'].createElement(
	        _Button2['default'],
	        (0, _extends3['default'])({}, buttonProps, {
	          disabled: props.disabled,
	          bsSize: bsSize,
	          bsStyle: bsStyle
	        }),
	        title
	      ),
	      _react2['default'].createElement(_SplitToggle2['default'], {
	        'aria-label': toggleLabel || title,
	        bsSize: bsSize,
	        bsStyle: bsStyle
	      }),
	      _react2['default'].createElement(
	        _Dropdown2['default'].Menu,
	        null,
	        children
	      )
	    );
	  };
	
	  return SplitButton;
	}(_react2['default'].Component);
	
	SplitButton.propTypes = propTypes;
	
	SplitButton.Toggle = _SplitToggle2['default'];
	
	exports['default'] = SplitButton;
	module.exports = exports['default'];

/***/ },
/* 2254 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DropdownToggle = __webpack_require__(916);
	
	var _DropdownToggle2 = _interopRequireDefault(_DropdownToggle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var SplitToggle = function (_React$Component) {
	  (0, _inherits3['default'])(SplitToggle, _React$Component);
	
	  function SplitToggle() {
	    (0, _classCallCheck3['default'])(this, SplitToggle);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  SplitToggle.prototype.render = function render() {
	    return _react2['default'].createElement(_DropdownToggle2['default'], (0, _extends3['default'])({}, this.props, {
	      useAnchor: false,
	      noCaret: false
	    }));
	  };
	
	  return SplitToggle;
	}(_react2['default'].Component);
	
	SplitToggle.defaultProps = _DropdownToggle2['default'].defaultProps;
	
	exports['default'] = SplitToggle;
	module.exports = exports['default'];

/***/ },
/* 2255 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TabContainer = __webpack_require__(461);
	
	var _TabContainer2 = _interopRequireDefault(_TabContainer);
	
	var _TabContent = __webpack_require__(462);
	
	var _TabContent2 = _interopRequireDefault(_TabContent);
	
	var _TabPane = __webpack_require__(930);
	
	var _TabPane2 = _interopRequireDefault(_TabPane);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _extends3['default'])({}, _TabPane2['default'].propTypes, {
	
	  disabled: _propTypes2['default'].bool,
	
	  title: _propTypes2['default'].node,
	
	  /**
	   * tabClassName is used as className for the associated NavItem
	   */
	  tabClassName: _propTypes2['default'].string
	});
	
	var Tab = function (_React$Component) {
	  (0, _inherits3['default'])(Tab, _React$Component);
	
	  function Tab() {
	    (0, _classCallCheck3['default'])(this, Tab);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Tab.prototype.render = function render() {
	    var props = (0, _extends3['default'])({}, this.props);
	
	    // These props are for the parent `<Tabs>` rather than the `<TabPane>`.
	    delete props.title;
	    delete props.disabled;
	    delete props.tabClassName;
	
	    return _react2['default'].createElement(_TabPane2['default'], props);
	  };
	
	  return Tab;
	}(_react2['default'].Component);
	
	Tab.propTypes = propTypes;
	
	Tab.Container = _TabContainer2['default'];
	Tab.Content = _TabContent2['default'];
	Tab.Pane = _TabPane2['default'];
	
	exports['default'] = Tab;
	module.exports = exports['default'];

/***/ },
/* 2256 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(18);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  striped: _propTypes2['default'].bool,
	  bordered: _propTypes2['default'].bool,
	  condensed: _propTypes2['default'].bool,
	  hover: _propTypes2['default'].bool,
	  responsive: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  bordered: false,
	  condensed: false,
	  hover: false,
	  responsive: false,
	  striped: false
	};
	
	var Table = function (_React$Component) {
	  (0, _inherits3['default'])(Table, _React$Component);
	
	  function Table() {
	    (0, _classCallCheck3['default'])(this, Table);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Table.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        striped = _props.striped,
	        bordered = _props.bordered,
	        condensed = _props.condensed,
	        hover = _props.hover,
	        responsive = _props.responsive,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['striped', 'bordered', 'condensed', 'hover', 'responsive', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'striped')] = striped, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'bordered')] = bordered, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'condensed')] = condensed, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'hover')] = hover, _extends2));
	
	    var table = _react2['default'].createElement('table', (0, _extends4['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	
	    if (responsive) {
	      return _react2['default'].createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'responsive') },
	        table
	      );
	    }
	
	    return table;
	  };
	
	  return Table;
	}(_react2['default'].Component);
	
	Table.propTypes = propTypes;
	Table.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('table', Table);
	module.exports = exports['default'];

/***/ },
/* 2257 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _isRequiredForA11y = __webpack_require__(303);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _uncontrollable = __webpack_require__(318);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _Nav = __webpack_require__(923);
	
	var _Nav2 = _interopRequireDefault(_Nav);
	
	var _NavItem = __webpack_require__(924);
	
	var _NavItem2 = _interopRequireDefault(_NavItem);
	
	var _TabContainer = __webpack_require__(461);
	
	var _TabContainer2 = _interopRequireDefault(_TabContainer);
	
	var _TabContent = __webpack_require__(462);
	
	var _TabContent2 = _interopRequireDefault(_TabContent);
	
	var _bootstrapUtils = __webpack_require__(24);
	
	var _ValidComponentChildren = __webpack_require__(74);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var TabContainer = _TabContainer2['default'].ControlledComponent;
	
	var propTypes = {
	  /**
	   * Mark the Tab with a matching `eventKey` as active.
	   *
	   * @controllable onSelect
	   */
	  activeKey: _propTypes2['default'].any,
	
	  /**
	   * Navigation style
	   */
	  bsStyle: _propTypes2['default'].oneOf(['tabs', 'pills']),
	
	  animation: _propTypes2['default'].bool,
	
	  id: (0, _isRequiredForA11y2['default'])(_propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number])),
	
	  /**
	   * Callback fired when a Tab is selected.
	   *
	   * ```js
	   * function (
	   * 	Any eventKey,
	   * 	SyntheticEvent event?
	   * )
	   * ```
	   *
	   * @controllable activeKey
	   */
	  onSelect: _propTypes2['default'].func,
	
	  /**
	   * Wait until the first "enter" transition to mount tabs (add them to the DOM)
	   */
	  mountOnEnter: _propTypes2['default'].bool,
	
	  /**
	   * Unmount tabs (remove it from the DOM) when it is no longer visible
	   */
	  unmountOnExit: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  bsStyle: 'tabs',
	  animation: true,
	  mountOnEnter: false,
	  unmountOnExit: false
	};
	
	function getDefaultActiveKey(children) {
	  var defaultActiveKey = void 0;
	  _ValidComponentChildren2['default'].forEach(children, function (child) {
	    if (defaultActiveKey == null) {
	      defaultActiveKey = child.props.eventKey;
	    }
	  });
	
	  return defaultActiveKey;
	}
	
	var Tabs = function (_React$Component) {
	  (0, _inherits3['default'])(Tabs, _React$Component);
	
	  function Tabs() {
	    (0, _classCallCheck3['default'])(this, Tabs);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Tabs.prototype.renderTab = function renderTab(child) {
	    var _child$props = child.props,
	        title = _child$props.title,
	        eventKey = _child$props.eventKey,
	        disabled = _child$props.disabled,
	        tabClassName = _child$props.tabClassName;
	
	    if (title == null) {
	      return null;
	    }
	
	    return _react2['default'].createElement(
	      _NavItem2['default'],
	      {
	        eventKey: eventKey,
	        disabled: disabled,
	        className: tabClassName
	      },
	      title
	    );
	  };
	
	  Tabs.prototype.render = function render() {
	    var _props = this.props,
	        id = _props.id,
	        onSelect = _props.onSelect,
	        animation = _props.animation,
	        mountOnEnter = _props.mountOnEnter,
	        unmountOnExit = _props.unmountOnExit,
	        bsClass = _props.bsClass,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        _props$activeKey = _props.activeKey,
	        activeKey = _props$activeKey === undefined ? getDefaultActiveKey(children) : _props$activeKey,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['id', 'onSelect', 'animation', 'mountOnEnter', 'unmountOnExit', 'bsClass', 'className', 'style', 'children', 'activeKey']);
	
	
	    return _react2['default'].createElement(
	      TabContainer,
	      {
	        id: id,
	        activeKey: activeKey,
	        onSelect: onSelect,
	        className: className,
	        style: style
	      },
	      _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          _Nav2['default'],
	          (0, _extends3['default'])({}, props, {
	            role: 'tablist'
	          }),
	          _ValidComponentChildren2['default'].map(children, this.renderTab)
	        ),
	        _react2['default'].createElement(
	          _TabContent2['default'],
	          {
	            bsClass: bsClass,
	            animation: animation,
	            mountOnEnter: mountOnEnter,
	            unmountOnExit: unmountOnExit
	          },
	          children
	        )
	      )
	    );
	  };
	
	  return Tabs;
	}(_react2['default'].Component);
	
	Tabs.propTypes = propTypes;
	Tabs.defaultProps = defaultProps;
	
	(0, _bootstrapUtils.bsClass)('tab', Tabs);
	
	exports['default'] = (0, _uncontrollable2['default'])(Tabs, { activeKey: 'onSelect' });
	module.exports = exports['default'];

/***/ },
/* 2258 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SafeAnchor = __webpack_require__(99);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _bootstrapUtils = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  src: _propTypes2['default'].string,
	  alt: _propTypes2['default'].string,
	  href: _propTypes2['default'].string
	};
	
	var Thumbnail = function (_React$Component) {
	  (0, _inherits3['default'])(Thumbnail, _React$Component);
	
	  function Thumbnail() {
	    (0, _classCallCheck3['default'])(this, Thumbnail);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Thumbnail.prototype.render = function render() {
	    var _props = this.props,
	        src = _props.src,
	        alt = _props.alt,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['src', 'alt', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var Component = elementProps.href ? _SafeAnchor2['default'] : 'div';
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(
	      Component,
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      _react2['default'].createElement('img', { src: src, alt: alt }),
	      children && _react2['default'].createElement(
	        'div',
	        { className: 'caption' },
	        children
	      )
	    );
	  };
	
	  return Thumbnail;
	}(_react2['default'].Component);
	
	Thumbnail.propTypes = propTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('thumbnail', Thumbnail);
	module.exports = exports['default'];

/***/ },
/* 2259 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(18);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _isRequiredForA11y = __webpack_require__(303);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _bootstrapUtils = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * An html id attribute, necessary for accessibility
	   * @type {string|number}
	   * @required
	   */
	  id: (0, _isRequiredForA11y2['default'])(_propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number])),
	
	  /**
	   * Sets the direction the Tooltip is positioned towards.
	   */
	  placement: _propTypes2['default'].oneOf(['top', 'right', 'bottom', 'left']),
	
	  /**
	   * The "top" position value for the Tooltip.
	   */
	  positionTop: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	  /**
	   * The "left" position value for the Tooltip.
	   */
	  positionLeft: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	
	  /**
	   * The "top" position value for the Tooltip arrow.
	   */
	  arrowOffsetTop: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	  /**
	   * The "left" position value for the Tooltip arrow.
	   */
	  arrowOffsetLeft: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string])
	};
	
	var defaultProps = {
	  placement: 'right'
	};
	
	var Tooltip = function (_React$Component) {
	  (0, _inherits3['default'])(Tooltip, _React$Component);
	
	  function Tooltip() {
	    (0, _classCallCheck3['default'])(this, Tooltip);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Tooltip.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        placement = _props.placement,
	        positionTop = _props.positionTop,
	        positionLeft = _props.positionLeft,
	        arrowOffsetTop = _props.arrowOffsetTop,
	        arrowOffsetLeft = _props.arrowOffsetLeft,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['placement', 'positionTop', 'positionLeft', 'arrowOffsetTop', 'arrowOffsetLeft', 'className', 'style', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[placement] = true, _extends2));
	
	    var outerStyle = (0, _extends4['default'])({
	      top: positionTop,
	      left: positionLeft
	    }, style);
	
	    var arrowStyle = {
	      top: arrowOffsetTop,
	      left: arrowOffsetLeft
	    };
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends4['default'])({}, elementProps, {
	        role: 'tooltip',
	        className: (0, _classnames2['default'])(className, classes),
	        style: outerStyle
	      }),
	      _react2['default'].createElement('div', { className: (0, _bootstrapUtils.prefix)(bsProps, 'arrow'), style: arrowStyle }),
	      _react2['default'].createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'inner') },
	        children
	      )
	    );
	  };
	
	  return Tooltip;
	}(_react2['default'].Component);
	
	Tooltip.propTypes = propTypes;
	Tooltip.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('tooltip', Tooltip);
	module.exports = exports['default'];

/***/ },
/* 2260 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(24);
	
	var _StyleConfig = __webpack_require__(64);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Well = function (_React$Component) {
	  (0, _inherits3['default'])(Well, _React$Component);
	
	  function Well() {
	    (0, _classCallCheck3['default'])(this, Well);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Well.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('div', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Well;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('well', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], Well));
	module.exports = exports['default'];

/***/ },
/* 2261 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.requiredRoles = requiredRoles;
	exports.exclusiveRoles = exclusiveRoles;
	
	var _createChainableTypeChecker = __webpack_require__(467);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	var _ValidComponentChildren = __webpack_require__(74);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function requiredRoles() {
	  for (var _len = arguments.length, roles = Array(_len), _key = 0; _key < _len; _key++) {
	    roles[_key] = arguments[_key];
	  }
	
	  return (0, _createChainableTypeChecker2['default'])(function (props, propName, component) {
	    var missing = void 0;
	
	    roles.every(function (role) {
	      if (!_ValidComponentChildren2['default'].some(props.children, function (child) {
	        return child.props.bsRole === role;
	      })) {
	        missing = role;
	        return false;
	      }
	
	      return true;
	    });
	
	    if (missing) {
	      return new Error('(children) ' + component + ' - Missing a required child with bsRole: ' + (missing + '. ' + component + ' must have at least one child of each of ') + ('the following bsRoles: ' + roles.join(', ')));
	    }
	
	    return null;
	  });
	}
	
	function exclusiveRoles() {
	  for (var _len2 = arguments.length, roles = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    roles[_key2] = arguments[_key2];
	  }
	
	  return (0, _createChainableTypeChecker2['default'])(function (props, propName, component) {
	    var duplicate = void 0;
	
	    roles.every(function (role) {
	      var childrenWithRole = _ValidComponentChildren2['default'].filter(props.children, function (child) {
	        return child.props.bsRole === role;
	      });
	
	      if (childrenWithRole.length > 1) {
	        duplicate = role;
	        return false;
	      }
	
	      return true;
	    });
	
	    if (duplicate) {
	      return new Error('(children) ' + component + ' - Duplicate children detected of bsRole: ' + (duplicate + '. Only one child each allowed with the following ') + ('bsRoles: ' + roles.join(', ')));
	    }
	
	    return null;
	  });
	}

/***/ },
/* 2262 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Copyright 2013-2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This file contains a modified version of:
	 * https://github.com/facebook/react/blob/v0.12.0/src/addons/transitions/ReactTransitionEvents.js
	 *
	 * This source code is licensed under the BSD-style license found here:
	 * https://github.com/facebook/react/blob/v0.12.0/LICENSE
	 * An additional grant of patent rights can be found here:
	 * https://github.com/facebook/react/blob/v0.12.0/PATENTS
	 */
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * EVENT_NAME_MAP is used to determine which event fired when a
	 * transition/animation ends, based on the style property used to
	 * define that event.
	 */
	var EVENT_NAME_MAP = {
	  transitionend: {
	    'transition': 'transitionend',
	    'WebkitTransition': 'webkitTransitionEnd',
	    'MozTransition': 'mozTransitionEnd',
	    'OTransition': 'oTransitionEnd',
	    'msTransition': 'MSTransitionEnd'
	  },
	
	  animationend: {
	    'animation': 'animationend',
	    'WebkitAnimation': 'webkitAnimationEnd',
	    'MozAnimation': 'mozAnimationEnd',
	    'OAnimation': 'oAnimationEnd',
	    'msAnimation': 'MSAnimationEnd'
	  }
	};
	
	var endEvents = [];
	
	function detectEvents() {
	  var testEl = document.createElement('div');
	  var style = testEl.style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are useable, and if not remove them
	  // from the map
	  if (!('AnimationEvent' in window)) {
	    delete EVENT_NAME_MAP.animationend.animation;
	  }
	
	  if (!('TransitionEvent' in window)) {
	    delete EVENT_NAME_MAP.transitionend.transition;
	  }
	
	  for (var baseEventName in EVENT_NAME_MAP) {
	    // eslint-disable-line guard-for-in
	    var baseEvents = EVENT_NAME_MAP[baseEventName];
	    for (var styleName in baseEvents) {
	      if (styleName in style) {
	        endEvents.push(baseEvents[styleName]);
	        break;
	      }
	    }
	  }
	}
	
	if (canUseDOM) {
	  detectEvents();
	}
	
	// We use the raw {add|remove}EventListener() call because EventListener
	// does not know how to remove event listeners and we really should
	// clean up. Also, these events are not triggered in older browsers
	// so we should be A-OK here.
	
	function addEventListener(node, eventName, eventListener) {
	  node.addEventListener(eventName, eventListener, false);
	}
	
	function removeEventListener(node, eventName, eventListener) {
	  node.removeEventListener(eventName, eventListener, false);
	}
	
	var ReactTransitionEvents = {
	  addEndEventListener: function addEndEventListener(node, eventListener) {
	    if (endEvents.length === 0) {
	      // If CSS transitions are not supported, trigger an "end animation"
	      // event immediately.
	      window.setTimeout(eventListener, 0);
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      addEventListener(node, endEvent, eventListener);
	    });
	  },
	  removeEndEventListener: function removeEndEventListener(node, eventListener) {
	    if (endEvents.length === 0) {
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      removeEventListener(node, endEvent, eventListener);
	    });
	  }
	};
	
	exports['default'] = ReactTransitionEvents;
	module.exports = exports['default'];

/***/ },
/* 2263 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _typeof2 = __webpack_require__(337);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	exports._resetWarned = _resetWarned;
	
	var _warning = __webpack_require__(100);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var warned = {};
	
	function deprecationWarning(oldname, newname, link) {
	  var message = void 0;
	
	  if ((typeof oldname === 'undefined' ? 'undefined' : (0, _typeof3['default'])(oldname)) === 'object') {
	    message = oldname.message;
	  } else {
	    message = oldname + ' is deprecated. Use ' + newname + ' instead.';
	
	    if (link) {
	      message += '\nYou can read more about it at ' + link;
	    }
	  }
	
	  if (warned[message]) {
	    return;
	  }
	
	   false ? (0, _warning2['default'])(false, message) : void 0;
	  warned[message] = true;
	}
	
	deprecationWarning.wrapper = function (Component) {
	  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  return function (_Component) {
	    (0, _inherits3['default'])(DeprecatedComponent, _Component);
	
	    function DeprecatedComponent() {
	      (0, _classCallCheck3['default'])(this, DeprecatedComponent);
	      return (0, _possibleConstructorReturn3['default'])(this, _Component.apply(this, arguments));
	    }
	
	    DeprecatedComponent.prototype.componentWillMount = function componentWillMount() {
	      deprecationWarning.apply(undefined, args);
	
	      if (_Component.prototype.componentWillMount) {
	        var _Component$prototype$;
	
	        for (var _len2 = arguments.length, methodArgs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	          methodArgs[_key2] = arguments[_key2];
	        }
	
	        (_Component$prototype$ = _Component.prototype.componentWillMount).call.apply(_Component$prototype$, [this].concat(methodArgs));
	      }
	    };
	
	    return DeprecatedComponent;
	  }(Component);
	};
	
	exports['default'] = deprecationWarning;
	function _resetWarned() {
	  warned = {};
	}

/***/ },
/* 2264 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ValidComponentChildren = exports.createChainedFunction = exports.bootstrapUtils = undefined;
	
	var _bootstrapUtils2 = __webpack_require__(24);
	
	var _bootstrapUtils = _interopRequireWildcard(_bootstrapUtils2);
	
	var _createChainedFunction2 = __webpack_require__(62);
	
	var _createChainedFunction3 = _interopRequireDefault(_createChainedFunction2);
	
	var _ValidComponentChildren2 = __webpack_require__(74);
	
	var _ValidComponentChildren3 = _interopRequireDefault(_ValidComponentChildren2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	exports.bootstrapUtils = _bootstrapUtils;
	exports.createChainedFunction = _createChainedFunction3['default'];
	exports.ValidComponentChildren = _ValidComponentChildren3['default'];

/***/ },
/* 2265 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = _interopDefault(__webpack_require__(1));
	var PropTypes = _interopDefault(__webpack_require__(2));
	var classnames = _interopDefault(__webpack_require__(3));
	var onClickOutside = _interopDefault(__webpack_require__(940));
	var moment = _interopDefault(__webpack_require__(8));
	var reactPopper = __webpack_require__(2270);
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	};
	
	
	
	
	
	
	
	
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	
	
	
	
	
	
	
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	
	
	
	
	
	
	
	
	
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	function generateYears(year, noOfYear, minDate, maxDate) {
	  var list = [];
	  for (var i = 0; i < 2 * noOfYear + 1; i++) {
	    var newYear = year + noOfYear - i;
	    var isInRange = true;
	
	    if (minDate) {
	      isInRange = minDate.year() <= newYear;
	    }
	
	    if (maxDate && isInRange) {
	      isInRange = maxDate.year() >= newYear;
	    }
	
	    if (isInRange) {
	      list.push(newYear);
	    }
	  }
	
	  return list;
	}
	
	var YearDropdownOptions = function (_React$Component) {
	  inherits(YearDropdownOptions, _React$Component);
	
	  function YearDropdownOptions(props) {
	    classCallCheck(this, YearDropdownOptions);
	
	    var _this = possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.renderOptions = function () {
	      var selectedYear = _this.props.year;
	      var options = _this.state.yearsList.map(function (year) {
	        return React.createElement(
	          'div',
	          { className: 'react-datepicker__year-option',
	            key: year,
	            ref: year,
	            onClick: _this.onChange.bind(_this, year) },
	          selectedYear === year ? React.createElement(
	            'span',
	            { className: 'react-datepicker__year-option--selected' },
	            '\u2713'
	          ) : '',
	          year
	        );
	      });
	
	      var minYear = _this.props.minDate ? _this.props.minDate.year() : null;
	      var maxYear = _this.props.maxDate ? _this.props.maxDate.year() : null;
	
	      if (!maxYear || !_this.state.yearsList.find(function (year) {
	        return year === maxYear;
	      })) {
	        options.unshift(React.createElement(
	          'div',
	          { className: 'react-datepicker__year-option',
	            ref: 'upcoming',
	            key: 'upcoming',
	            onClick: _this.incrementYears },
	          React.createElement('a', { className: 'react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming' })
	        ));
	      }
	
	      if (!minYear || !_this.state.yearsList.find(function (year) {
	        return year === minYear;
	      })) {
	        options.push(React.createElement(
	          'div',
	          { className: 'react-datepicker__year-option',
	            ref: 'previous',
	            key: 'previous',
	            onClick: _this.decrementYears },
	          React.createElement('a', { className: 'react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous' })
	        ));
	      }
	
	      return options;
	    };
	
	    _this.onChange = function (year) {
	      _this.props.onChange(year);
	    };
	
	    _this.handleClickOutside = function () {
	      _this.props.onCancel();
	    };
	
	    _this.shiftYears = function (amount) {
	      var years = _this.state.yearsList.map(function (year) {
	        return year + amount;
	      });
	
	      _this.setState({
	        yearsList: years
	      });
	    };
	
	    _this.incrementYears = function () {
	      return _this.shiftYears(1);
	    };
	
	    _this.decrementYears = function () {
	      return _this.shiftYears(-1);
	    };
	
	    var yearDropdownItemNumber = props.yearDropdownItemNumber,
	        scrollableYearDropdown = props.scrollableYearDropdown;
	
	    var noOfYear = yearDropdownItemNumber || (scrollableYearDropdown ? 10 : 5);
	
	    _this.state = {
	      yearsList: generateYears(_this.props.year, noOfYear, _this.props.minDate, _this.props.maxDate)
	    };
	    return _this;
	  }
	
	  YearDropdownOptions.prototype.render = function render() {
	    var dropdownClass = classnames({
	      'react-datepicker__year-dropdown': true,
	      'react-datepicker__year-dropdown--scrollable': this.props.scrollableYearDropdown
	    });
	
	    return React.createElement(
	      'div',
	      { className: dropdownClass },
	      this.renderOptions()
	    );
	  };
	
	  return YearDropdownOptions;
	}(React.Component);
	
	YearDropdownOptions.propTypes = {
	  minDate: PropTypes.object,
	  maxDate: PropTypes.object,
	  onCancel: PropTypes.func.isRequired,
	  onChange: PropTypes.func.isRequired,
	  scrollableYearDropdown: PropTypes.bool,
	  year: PropTypes.number.isRequired,
	  yearDropdownItemNumber: PropTypes.number
	};
	
	var dayOfWeekCodes = {
	  1: 'mon',
	  2: 'tue',
	  3: 'wed',
	  4: 'thu',
	  5: 'fri',
	  6: 'sat',
	  7: 'sun'
	
	  // These functions are not exported so
	  // that we avoid magic strings like 'days'
	};function set$1(date, unit, to) {
	  return date.set(unit, to);
	}
	
	function add(date, amount, unit) {
	  return date.add(amount, unit);
	}
	
	function subtract(date, amount, unit) {
	  return date.subtract(amount, unit);
	}
	
	function get$1(date, unit) {
	  return date.get(unit);
	}
	
	function getStartOf(date, unit) {
	  return date.startOf(unit);
	}
	
	function isSame(date1, date2, unit) {
	  return date1.isSame(date2, unit);
	}
	
	// ** Date Constructors **
	
	function newDate(point) {
	  return moment(point);
	}
	
	function newDateWithOffset(utcOffset) {
	  return moment().utc().utcOffset(utcOffset);
	}
	
	function now(maybeFixedUtcOffset) {
	  if (maybeFixedUtcOffset == null) {
	    return newDate();
	  }
	  return newDateWithOffset(maybeFixedUtcOffset);
	}
	
	function cloneDate(date) {
	  return date.clone();
	}
	
	function parseDate(value, _ref) {
	  var dateFormat = _ref.dateFormat,
	      locale = _ref.locale;
	
	  var m = moment(value, dateFormat, locale || moment.locale(), true);
	  return m.isValid() ? m : null;
	}
	
	// ** Date "Reflection" **
	
	function isMoment(date) {
	  return moment.isMoment(date);
	}
	
	function isDate(date) {
	  return moment.isDate(date);
	}
	
	// ** Date Formatting **
	
	function formatDate(date, format) {
	  return date.format(format);
	}
	
	function safeDateFormat(date, _ref2) {
	  var dateFormat = _ref2.dateFormat,
	      locale = _ref2.locale;
	
	  return date && date.clone().locale(locale || moment.locale()).format(Array.isArray(dateFormat) ? dateFormat[0] : dateFormat) || '';
	}
	
	// ** Date Setters **
	
	function setTime(date, _ref3) {
	  var hour = _ref3.hour,
	      minute = _ref3.minute,
	      second = _ref3.second;
	
	  date.set({ hour: hour, minute: minute, second: second });
	  return date;
	}
	
	function setMonth(date, month) {
	  return set$1(date, 'month', month);
	}
	
	function setYear(date, year) {
	  return set$1(date, 'year', year);
	}
	
	
	
	// ** Date Getters **
	
	function getSecond(date) {
	  return get$1(date, 'second');
	}
	
	function getMinute(date) {
	  return get$1(date, 'minute');
	}
	
	function getHour(date) {
	  return get$1(date, 'hour');
	}
	
	// Returns day of week
	function getDay(date) {
	  return get$1(date, 'day');
	}
	
	function getWeek(date) {
	  return get$1(date, 'week');
	}
	
	function getMonth(date) {
	  return get$1(date, 'month');
	}
	
	function getYear(date) {
	  return get$1(date, 'year');
	}
	
	// Returns day of month
	function getDate(date) {
	  return get$1(date, 'date');
	}
	
	
	
	function getDayOfWeekCode(day) {
	  return dayOfWeekCodes[day.isoWeekday()];
	}
	
	// *** Start of ***
	
	function getStartOfDay(date) {
	  return getStartOf(date, 'day');
	}
	
	function getStartOfWeek(date) {
	  return getStartOf(date, 'week');
	}
	function getStartOfMonth(date) {
	  return getStartOf(date, 'month');
	}
	
	function getStartOfDate(date) {
	  return getStartOf(date, 'date');
	}
	
	// *** End of ***
	
	
	
	
	
	// ** Date Math **
	
	// *** Addition ***
	
	function addMinutes(date, amount) {
	  return add(date, amount, 'minutes');
	}
	
	function addDays(date, amount) {
	  return add(date, amount, 'days');
	}
	
	function addWeeks(date, amount) {
	  return add(date, amount, 'weeks');
	}
	
	function addMonths(date, amount) {
	  return add(date, amount, 'months');
	}
	
	function addYears(date, amount) {
	  return add(date, amount, 'years');
	}
	
	// *** Subtraction ***
	function subtractDays(date, amount) {
	  return subtract(date, amount, 'days');
	}
	
	function subtractWeeks(date, amount) {
	  return subtract(date, amount, 'weeks');
	}
	
	function subtractMonths(date, amount) {
	  return subtract(date, amount, 'months');
	}
	
	function subtractYears(date, amount) {
	  return subtract(date, amount, 'years');
	}
	
	// ** Date Comparison **
	
	function isBefore(date1, date2) {
	  return date1.isBefore(date2);
	}
	
	function isAfter(date1, date2) {
	  return date1.isAfter(date2);
	}
	
	
	
	function isSameMonth(date1, date2) {
	  return isSame(date1, date2, 'month');
	}
	
	function isSameDay(moment1, moment2) {
	  if (moment1 && moment2) {
	    return moment1.isSame(moment2, 'day');
	  } else {
	    return !moment1 && !moment2;
	  }
	}
	
	
	
	function isDayInRange(day, startDate, endDate) {
	  var before = startDate.clone().startOf('day').subtract(1, 'seconds');
	  var after = endDate.clone().startOf('day').add(1, 'seconds');
	  return day.clone().startOf('day').isBetween(before, after);
	}
	
	// *** Diffing ***
	
	
	
	// ** Date Localization **
	
	function localizeDate(date, locale) {
	  return date.clone().locale(locale || moment.locale());
	}
	
	
	
	
	
	
	
	function getLocaleData(date) {
	  return date.localeData();
	}
	
	function getLocaleDataForLocale(locale) {
	  return moment.localeData(locale);
	}
	
	function getWeekdayMinInLocale(locale, date) {
	  return locale.weekdaysMin(date);
	}
	
	function getWeekdayShortInLocale(locale, date) {
	  return locale.weekdaysShort(date);
	}
	
	// TODO what is this format exactly?
	function getMonthInLocale(locale, date, format) {
	  return locale.months(date, format);
	}
	
	// ** Utils for some components **
	
	function isDayDisabled(day) {
	  var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      minDate = _ref4.minDate,
	      maxDate = _ref4.maxDate,
	      excludeDates = _ref4.excludeDates,
	      includeDates = _ref4.includeDates,
	      filterDate = _ref4.filterDate;
	
	  return minDate && day.isBefore(minDate, 'day') || maxDate && day.isAfter(maxDate, 'day') || excludeDates && excludeDates.some(function (excludeDate) {
	    return isSameDay(day, excludeDate);
	  }) || includeDates && !includeDates.some(function (includeDate) {
	    return isSameDay(day, includeDate);
	  }) || filterDate && !filterDate(day.clone()) || false;
	}
	
	function isTimeDisabled(time, disabledTimes) {
	  var l = disabledTimes.length;
	  for (var i = 0; i < l; i++) {
	    if (disabledTimes[i].get('hours') === time.get('hours') && disabledTimes[i].get('minutes') === time.get('minutes')) {
	      return true;
	    }
	  }
	
	  return false;
	}
	
	function isTimeInDisabledRange(time, _ref5) {
	  var minTime = _ref5.minTime,
	      maxTime = _ref5.maxTime;
	
	  if (!minTime || !maxTime) {
	    throw new Error('Both minTime and maxTime props required');
	  }
	
	  var base = moment().hours(0).minutes(0).seconds(0);
	  var baseTime = base.clone().hours(time.get('hours')).minutes(time.get('minutes'));
	  var min = base.clone().hours(minTime.get('hours')).minutes(minTime.get('minutes'));
	  var max = base.clone().hours(maxTime.get('hours')).minutes(maxTime.get('minutes'));
	
	  return !(baseTime.isSameOrAfter(min) && baseTime.isSameOrBefore(max));
	}
	
	function allDaysDisabledBefore(day, unit) {
	  var _ref6 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
	      minDate = _ref6.minDate,
	      includeDates = _ref6.includeDates;
	
	  var dateBefore = day.clone().subtract(1, unit);
	  return minDate && dateBefore.isBefore(minDate, unit) || includeDates && includeDates.every(function (includeDate) {
	    return dateBefore.isBefore(includeDate, unit);
	  }) || false;
	}
	
	function allDaysDisabledAfter(day, unit) {
	  var _ref7 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
	      maxDate = _ref7.maxDate,
	      includeDates = _ref7.includeDates;
	
	  var dateAfter = day.clone().add(1, unit);
	  return maxDate && dateAfter.isAfter(maxDate, unit) || includeDates && includeDates.every(function (includeDate) {
	    return dateAfter.isAfter(includeDate, unit);
	  }) || false;
	}
	
	function getEffectiveMinDate(_ref8) {
	  var minDate = _ref8.minDate,
	      includeDates = _ref8.includeDates;
	
	  if (includeDates && minDate) {
	    return moment.min(includeDates.filter(function (includeDate) {
	      return minDate.isSameOrBefore(includeDate, 'day');
	    }));
	  } else if (includeDates) {
	    return moment.min(includeDates);
	  } else {
	    return minDate;
	  }
	}
	
	function getEffectiveMaxDate(_ref9) {
	  var maxDate = _ref9.maxDate,
	      includeDates = _ref9.includeDates;
	
	  if (includeDates && maxDate) {
	    return moment.max(includeDates.filter(function (includeDate) {
	      return maxDate.isSameOrAfter(includeDate, 'day');
	    }));
	  } else if (includeDates) {
	    return moment.max(includeDates);
	  } else {
	    return maxDate;
	  }
	}
	
	var WrappedYearDropdownOptions = onClickOutside(YearDropdownOptions);
	
	var YearDropdown = function (_React$Component) {
	  inherits(YearDropdown, _React$Component);
	
	  function YearDropdown() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, YearDropdown);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      dropdownVisible: false
	    }, _this.renderSelectOptions = function () {
	      var minYear = _this.props.minDate ? getYear(_this.props.minDate) : 1900;
	      var maxYear = _this.props.maxDate ? getYear(_this.props.maxDate) : 2100;
	
	      var options = [];
	      for (var i = minYear; i <= maxYear; i++) {
	        options.push(React.createElement(
	          'option',
	          { key: i, value: i },
	          i
	        ));
	      }
	      return options;
	    }, _this.onSelectChange = function (e) {
	      _this.onChange(e.target.value);
	    }, _this.renderSelectMode = function () {
	      return React.createElement(
	        'select',
	        {
	          value: _this.props.year,
	          className: 'react-datepicker__year-select',
	          onChange: _this.onSelectChange },
	        _this.renderSelectOptions()
	      );
	    }, _this.renderReadView = function (visible) {
	      return React.createElement(
	        'div',
	        { key: 'read', style: { visibility: visible ? 'visible' : 'hidden' }, className: 'react-datepicker__year-read-view', onClick: _this.toggleDropdown },
	        React.createElement('span', { className: 'react-datepicker__year-read-view--down-arrow' }),
	        React.createElement(
	          'span',
	          { className: 'react-datepicker__year-read-view--selected-year' },
	          _this.props.year
	        )
	      );
	    }, _this.renderDropdown = function () {
	      return React.createElement(WrappedYearDropdownOptions, {
	        key: 'dropdown',
	        ref: 'options',
	        year: _this.props.year,
	        onChange: _this.onChange,
	        onCancel: _this.toggleDropdown,
	        minDate: _this.props.minDate,
	        maxDate: _this.props.maxDate,
	        scrollableYearDropdown: _this.props.scrollableYearDropdown,
	        yearDropdownItemNumber: _this.props.yearDropdownItemNumber });
	    }, _this.renderScrollMode = function () {
	      var dropdownVisible = _this.state.dropdownVisible;
	
	      var result = [_this.renderReadView(!dropdownVisible)];
	      if (dropdownVisible) {
	        result.unshift(_this.renderDropdown());
	      }
	      return result;
	    }, _this.onChange = function (year) {
	      _this.toggleDropdown();
	      if (year === _this.props.year) return;
	      _this.props.onChange(year);
	    }, _this.toggleDropdown = function () {
	      _this.setState({
	        dropdownVisible: !_this.state.dropdownVisible
	      });
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  YearDropdown.prototype.render = function render() {
	    var renderedDropdown = void 0;
	    switch (this.props.dropdownMode) {
	      case 'scroll':
	        renderedDropdown = this.renderScrollMode();
	        break;
	      case 'select':
	        renderedDropdown = this.renderSelectMode();
	        break;
	    }
	
	    return React.createElement(
	      'div',
	      {
	        className: 'react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--' + this.props.dropdownMode },
	      renderedDropdown
	    );
	  };
	
	  return YearDropdown;
	}(React.Component);
	
	YearDropdown.propTypes = {
	  dropdownMode: PropTypes.oneOf(['scroll', 'select']).isRequired,
	  maxDate: PropTypes.object,
	  minDate: PropTypes.object,
	  onChange: PropTypes.func.isRequired,
	  scrollableYearDropdown: PropTypes.bool,
	  year: PropTypes.number.isRequired,
	  yearDropdownItemNumber: PropTypes.number
	};
	
	var MonthDropdownOptions = function (_React$Component) {
	  inherits(MonthDropdownOptions, _React$Component);
	
	  function MonthDropdownOptions() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, MonthDropdownOptions);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.renderOptions = function () {
	      return _this.props.monthNames.map(function (month, i) {
	        return React.createElement(
	          'div',
	          { className: 'react-datepicker__month-option',
	            key: month,
	            ref: month,
	            onClick: _this.onChange.bind(_this, i) },
	          _this.props.month === i ? React.createElement(
	            'span',
	            { className: 'react-datepicker__month-option--selected' },
	            '\u2713'
	          ) : '',
	          month
	        );
	      });
	    }, _this.onChange = function (month) {
	      return _this.props.onChange(month);
	    }, _this.handleClickOutside = function () {
	      return _this.props.onCancel();
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  MonthDropdownOptions.prototype.render = function render() {
	    return React.createElement(
	      'div',
	      { className: 'react-datepicker__month-dropdown' },
	      this.renderOptions()
	    );
	  };
	
	  return MonthDropdownOptions;
	}(React.Component);
	
	MonthDropdownOptions.propTypes = {
	  onCancel: PropTypes.func.isRequired,
	  onChange: PropTypes.func.isRequired,
	  month: PropTypes.number.isRequired,
	  monthNames: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired
	};
	
	var WrappedMonthDropdownOptions = onClickOutside(MonthDropdownOptions);
	
	var MonthDropdown = function (_React$Component) {
	  inherits(MonthDropdown, _React$Component);
	
	  function MonthDropdown() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, MonthDropdown);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      dropdownVisible: false
	    }, _this.renderSelectOptions = function (monthNames) {
	      return monthNames.map(function (M, i) {
	        return React.createElement(
	          'option',
	          { key: i, value: i },
	          M
	        );
	      });
	    }, _this.renderSelectMode = function (monthNames) {
	      return React.createElement(
	        'select',
	        { value: _this.props.month, className: 'react-datepicker__month-select', onChange: function onChange(e) {
	            return _this.onChange(e.target.value);
	          } },
	        _this.renderSelectOptions(monthNames)
	      );
	    }, _this.renderReadView = function (visible, monthNames) {
	      return React.createElement(
	        'div',
	        { key: 'read', style: { visibility: visible ? 'visible' : 'hidden' }, className: 'react-datepicker__month-read-view', onClick: _this.toggleDropdown },
	        React.createElement(
	          'span',
	          { className: 'react-datepicker__month-read-view--selected-month' },
	          monthNames[_this.props.month]
	        ),
	        React.createElement('span', { className: 'react-datepicker__month-read-view--down-arrow' })
	      );
	    }, _this.renderDropdown = function (monthNames) {
	      return React.createElement(WrappedMonthDropdownOptions, {
	        key: 'dropdown',
	        ref: 'options',
	        month: _this.props.month,
	        monthNames: monthNames,
	        onChange: _this.onChange,
	        onCancel: _this.toggleDropdown });
	    }, _this.renderScrollMode = function (monthNames) {
	      var dropdownVisible = _this.state.dropdownVisible;
	
	      var result = [_this.renderReadView(!dropdownVisible, monthNames)];
	      if (dropdownVisible) {
	        result.unshift(_this.renderDropdown(monthNames));
	      }
	      return result;
	    }, _this.onChange = function (month) {
	      _this.toggleDropdown();
	      if (month !== _this.props.month) {
	        _this.props.onChange(month);
	      }
	    }, _this.toggleDropdown = function () {
	      return _this.setState({
	        dropdownVisible: !_this.state.dropdownVisible
	      });
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  MonthDropdown.prototype.render = function render() {
	    var _this2 = this;
	
	    var localeData = getLocaleDataForLocale(this.props.locale);
	    var monthNames = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(function (M) {
	      return getMonthInLocale(localeData, newDate({ M: M }), _this2.props.dateFormat);
	    });
	
	    var renderedDropdown = void 0;
	    switch (this.props.dropdownMode) {
	      case 'scroll':
	        renderedDropdown = this.renderScrollMode(monthNames);
	        break;
	      case 'select':
	        renderedDropdown = this.renderSelectMode(monthNames);
	        break;
	    }
	
	    return React.createElement(
	      'div',
	      {
	        className: 'react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--' + this.props.dropdownMode },
	      renderedDropdown
	    );
	  };
	
	  return MonthDropdown;
	}(React.Component);
	
	MonthDropdown.propTypes = {
	  dropdownMode: PropTypes.oneOf(['scroll', 'select']).isRequired,
	  locale: PropTypes.string,
	  dateFormat: PropTypes.string.isRequired,
	  month: PropTypes.number.isRequired,
	  onChange: PropTypes.func.isRequired
	};
	
	var Day = function (_React$Component) {
	  inherits(Day, _React$Component);
	
	  function Day() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, Day);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
	      if (!_this.isDisabled() && _this.props.onClick) {
	        _this.props.onClick(event);
	      }
	    }, _this.handleMouseEnter = function (event) {
	      if (!_this.isDisabled() && _this.props.onMouseEnter) {
	        _this.props.onMouseEnter(event);
	      }
	    }, _this.isSameDay = function (other) {
	      return isSameDay(_this.props.day, other);
	    }, _this.isKeyboardSelected = function () {
	      return !_this.props.inline && !_this.isSameDay(_this.props.selected) && _this.isSameDay(_this.props.preSelection);
	    }, _this.isDisabled = function () {
	      return isDayDisabled(_this.props.day, _this.props);
	    }, _this.getHighLightedClass = function (defaultClassName) {
	      var _this$props = _this.props,
	          day = _this$props.day,
	          highlightDates = _this$props.highlightDates;
	
	
	      if (!highlightDates) {
	        var _ref;
	
	        return _ref = {}, _ref[defaultClassName] = false, _ref;
	      }
	
	      var classNames = {};
	      for (var i = 0, len = highlightDates.length; i < len; i++) {
	        var obj = highlightDates[i];
	        if (isMoment(obj)) {
	          if (isSameDay(day, obj)) {
	            classNames[defaultClassName] = true;
	          }
	        } else if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object') {
	          var keys = Object.keys(obj);
	          var arr = obj[keys[0]];
	          if (typeof keys[0] === 'string' && arr.constructor === Array) {
	            for (var k = 0, _len2 = arr.length; k < _len2; k++) {
	              if (isSameDay(day, arr[k])) {
	                classNames[keys[0]] = true;
	              }
	            }
	          }
	        }
	      }
	
	      return classNames;
	    }, _this.isInRange = function () {
	      var _this$props2 = _this.props,
	          day = _this$props2.day,
	          startDate = _this$props2.startDate,
	          endDate = _this$props2.endDate;
	
	      if (!startDate || !endDate) {
	        return false;
	      }
	      return isDayInRange(day, startDate, endDate);
	    }, _this.isInSelectingRange = function () {
	      var _this$props3 = _this.props,
	          day = _this$props3.day,
	          selectsStart = _this$props3.selectsStart,
	          selectsEnd = _this$props3.selectsEnd,
	          selectingDate = _this$props3.selectingDate,
	          startDate = _this$props3.startDate,
	          endDate = _this$props3.endDate;
	
	
	      if (!(selectsStart || selectsEnd) || !selectingDate || _this.isDisabled()) {
	        return false;
	      }
	
	      if (selectsStart && endDate && selectingDate.isSameOrBefore(endDate)) {
	        return isDayInRange(day, selectingDate, endDate);
	      }
	
	      if (selectsEnd && startDate && selectingDate.isSameOrAfter(startDate)) {
	        return isDayInRange(day, startDate, selectingDate);
	      }
	
	      return false;
	    }, _this.isSelectingRangeStart = function () {
	      if (!_this.isInSelectingRange()) {
	        return false;
	      }
	
	      var _this$props4 = _this.props,
	          day = _this$props4.day,
	          selectingDate = _this$props4.selectingDate,
	          startDate = _this$props4.startDate,
	          selectsStart = _this$props4.selectsStart;
	
	
	      if (selectsStart) {
	        return isSameDay(day, selectingDate);
	      } else {
	        return isSameDay(day, startDate);
	      }
	    }, _this.isSelectingRangeEnd = function () {
	      if (!_this.isInSelectingRange()) {
	        return false;
	      }
	
	      var _this$props5 = _this.props,
	          day = _this$props5.day,
	          selectingDate = _this$props5.selectingDate,
	          endDate = _this$props5.endDate,
	          selectsEnd = _this$props5.selectsEnd;
	
	
	      if (selectsEnd) {
	        return isSameDay(day, selectingDate);
	      } else {
	        return isSameDay(day, endDate);
	      }
	    }, _this.isRangeStart = function () {
	      var _this$props6 = _this.props,
	          day = _this$props6.day,
	          startDate = _this$props6.startDate,
	          endDate = _this$props6.endDate;
	
	      if (!startDate || !endDate) {
	        return false;
	      }
	      return isSameDay(startDate, day);
	    }, _this.isRangeEnd = function () {
	      var _this$props7 = _this.props,
	          day = _this$props7.day,
	          startDate = _this$props7.startDate,
	          endDate = _this$props7.endDate;
	
	      if (!startDate || !endDate) {
	        return false;
	      }
	      return isSameDay(endDate, day);
	    }, _this.isWeekend = function () {
	      var weekday = getDay(_this.props.day);
	      return weekday === 0 || weekday === 6;
	    }, _this.isOutsideMonth = function () {
	      return _this.props.month !== undefined && _this.props.month !== getMonth(_this.props.day);
	    }, _this.getClassNames = function (date) {
	      var dayClassName = _this.props.dayClassName ? _this.props.dayClassName(date) : undefined;
	      return classnames('react-datepicker__day', dayClassName, 'react-datepicker__day--' + getDayOfWeekCode(_this.props.day), {
	        'react-datepicker__day--disabled': _this.isDisabled(),
	        'react-datepicker__day--selected': _this.isSameDay(_this.props.selected),
	        'react-datepicker__day--keyboard-selected': _this.isKeyboardSelected(),
	        'react-datepicker__day--range-start': _this.isRangeStart(),
	        'react-datepicker__day--range-end': _this.isRangeEnd(),
	        'react-datepicker__day--in-range': _this.isInRange(),
	        'react-datepicker__day--in-selecting-range': _this.isInSelectingRange(),
	        'react-datepicker__day--selecting-range-start': _this.isSelectingRangeStart(),
	        'react-datepicker__day--selecting-range-end': _this.isSelectingRangeEnd(),
	        'react-datepicker__day--today': _this.isSameDay(now(_this.props.utcOffset)),
	        'react-datepicker__day--weekend': _this.isWeekend(),
	        'react-datepicker__day--outside-month': _this.isOutsideMonth()
	      }, _this.getHighLightedClass('react-datepicker__day--highlighted'));
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  Day.prototype.render = function render() {
	    return React.createElement(
	      'div',
	      {
	        className: this.getClassNames(this.props.day),
	        onClick: this.handleClick,
	        onMouseEnter: this.handleMouseEnter,
	        'aria-label': 'day-' + getDate(this.props.day),
	        role: 'option' },
	      getDate(this.props.day)
	    );
	  };
	
	  return Day;
	}(React.Component);
	
	Day.propTypes = {
	  day: PropTypes.object.isRequired,
	  dayClassName: PropTypes.func,
	  endDate: PropTypes.object,
	  highlightDates: PropTypes.array,
	  inline: PropTypes.bool,
	  month: PropTypes.number,
	  onClick: PropTypes.func,
	  onMouseEnter: PropTypes.func,
	  preSelection: PropTypes.object,
	  selected: PropTypes.object,
	  selectingDate: PropTypes.object,
	  selectsEnd: PropTypes.bool,
	  selectsStart: PropTypes.bool,
	  startDate: PropTypes.object,
	  utcOffset: PropTypes.number
	};
	
	var WeekNumber = function (_React$Component) {
	  inherits(WeekNumber, _React$Component);
	
	  function WeekNumber() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, WeekNumber);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
	      if (_this.props.onClick) {
	        _this.props.onClick(event);
	      }
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  WeekNumber.prototype.render = function render() {
	    var weekNumberClasses = {
	      'react-datepicker__week-number': true,
	      'react-datepicker__week-number--clickable': !!this.props.onClick
	    };
	    return React.createElement(
	      'div',
	      {
	        className: classnames(weekNumberClasses),
	        'aria-label': 'week-' + this.props.weekNumber,
	        onClick: this.handleClick },
	      this.props.weekNumber
	    );
	  };
	
	  return WeekNumber;
	}(React.Component);
	
	WeekNumber.propTypes = {
	  weekNumber: PropTypes.number.isRequired,
	  onClick: PropTypes.func
	};
	
	var Week = function (_React$Component) {
	  inherits(Week, _React$Component);
	
	  function Week() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, Week);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleDayClick = function (day, event) {
	      if (_this.props.onDayClick) {
	        _this.props.onDayClick(day, event);
	      }
	    }, _this.handleDayMouseEnter = function (day) {
	      if (_this.props.onDayMouseEnter) {
	        _this.props.onDayMouseEnter(day);
	      }
	    }, _this.handleWeekClick = function (day, weekNumber, event) {
	      if (typeof _this.props.onWeekSelect === 'function') {
	        _this.props.onWeekSelect(day, weekNumber, event);
	      }
	    }, _this.formatWeekNumber = function (startOfWeek) {
	      if (_this.props.formatWeekNumber) {
	        return _this.props.formatWeekNumber(startOfWeek);
	      }
	      return getWeek(startOfWeek);
	    }, _this.renderDays = function () {
	      var startOfWeek = getStartOfWeek(cloneDate(_this.props.day));
	      var days = [];
	      var weekNumber = _this.formatWeekNumber(startOfWeek);
	      if (_this.props.showWeekNumber) {
	        var onClickAction = _this.props.onWeekSelect ? _this.handleWeekClick.bind(_this, startOfWeek, weekNumber) : undefined;
	        days.push(React.createElement(WeekNumber, { key: 'W', weekNumber: weekNumber, onClick: onClickAction }));
	      }
	      return days.concat([0, 1, 2, 3, 4, 5, 6].map(function (offset) {
	        var day = addDays(cloneDate(startOfWeek), offset);
	        return React.createElement(Day, {
	          key: offset,
	          day: day,
	          month: _this.props.month,
	          onClick: _this.handleDayClick.bind(_this, day),
	          onMouseEnter: _this.handleDayMouseEnter.bind(_this, day),
	          minDate: _this.props.minDate,
	          maxDate: _this.props.maxDate,
	          excludeDates: _this.props.excludeDates,
	          includeDates: _this.props.includeDates,
	          inline: _this.props.inline,
	          highlightDates: _this.props.highlightDates,
	          selectingDate: _this.props.selectingDate,
	          filterDate: _this.props.filterDate,
	          preSelection: _this.props.preSelection,
	          selected: _this.props.selected,
	          selectsStart: _this.props.selectsStart,
	          selectsEnd: _this.props.selectsEnd,
	          startDate: _this.props.startDate,
	          endDate: _this.props.endDate,
	          dayClassName: _this.props.dayClassName,
	          utcOffset: _this.props.utcOffset });
	      }));
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  Week.prototype.render = function render() {
	    return React.createElement(
	      'div',
	      { className: 'react-datepicker__week' },
	      this.renderDays()
	    );
	  };
	
	  return Week;
	}(React.Component);
	
	Week.propTypes = {
	  day: PropTypes.object.isRequired,
	  dayClassName: PropTypes.func,
	  endDate: PropTypes.object,
	  excludeDates: PropTypes.array,
	  filterDate: PropTypes.func,
	  formatWeekNumber: PropTypes.func,
	  highlightDates: PropTypes.array,
	  includeDates: PropTypes.array,
	  inline: PropTypes.bool,
	  maxDate: PropTypes.object,
	  minDate: PropTypes.object,
	  month: PropTypes.number,
	  onDayClick: PropTypes.func,
	  onDayMouseEnter: PropTypes.func,
	  onWeekSelect: PropTypes.func,
	  preSelection: PropTypes.object,
	  selected: PropTypes.object,
	  selectingDate: PropTypes.object,
	  selectsEnd: PropTypes.bool,
	  selectsStart: PropTypes.bool,
	  showWeekNumber: PropTypes.bool,
	  startDate: PropTypes.object,
	  utcOffset: PropTypes.number
	};
	
	var FIXED_HEIGHT_STANDARD_WEEK_COUNT = 6;
	
	var Month = function (_React$Component) {
	  inherits(Month, _React$Component);
	
	  function Month() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, Month);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleDayClick = function (day, event) {
	      if (_this.props.onDayClick) {
	        _this.props.onDayClick(day, event);
	      }
	    }, _this.handleDayMouseEnter = function (day) {
	      if (_this.props.onDayMouseEnter) {
	        _this.props.onDayMouseEnter(day);
	      }
	    }, _this.handleMouseLeave = function () {
	      if (_this.props.onMouseLeave) {
	        _this.props.onMouseLeave();
	      }
	    }, _this.isWeekInMonth = function (startOfWeek) {
	      var day = _this.props.day;
	      var endOfWeek = addDays(cloneDate(startOfWeek), 6);
	      return isSameMonth(startOfWeek, day) || isSameMonth(endOfWeek, day);
	    }, _this.renderWeeks = function () {
	      var weeks = [];
	      var isFixedHeight = _this.props.fixedHeight;
	      var currentWeekStart = getStartOfWeek(getStartOfMonth(cloneDate(_this.props.day)));
	      var i = 0;
	      var breakAfterNextPush = false;
	
	      while (true) {
	        weeks.push(React.createElement(Week, {
	          key: i,
	          day: currentWeekStart,
	          month: getMonth(_this.props.day),
	          onDayClick: _this.handleDayClick,
	          onDayMouseEnter: _this.handleDayMouseEnter,
	          onWeekSelect: _this.props.onWeekSelect,
	          formatWeekNumber: _this.props.formatWeekNumber,
	          minDate: _this.props.minDate,
	          maxDate: _this.props.maxDate,
	          excludeDates: _this.props.excludeDates,
	          includeDates: _this.props.includeDates,
	          inline: _this.props.inline,
	          highlightDates: _this.props.highlightDates,
	          selectingDate: _this.props.selectingDate,
	          filterDate: _this.props.filterDate,
	          preSelection: _this.props.preSelection,
	          selected: _this.props.selected,
	          selectsStart: _this.props.selectsStart,
	          selectsEnd: _this.props.selectsEnd,
	          showWeekNumber: _this.props.showWeekNumbers,
	          startDate: _this.props.startDate,
	          endDate: _this.props.endDate,
	          dayClassName: _this.props.dayClassName,
	          utcOffset: _this.props.utcOffset }));
	
	        if (breakAfterNextPush) break;
	
	        i++;
	        currentWeekStart = addWeeks(cloneDate(currentWeekStart), 1);
	
	        // If one of these conditions is true, we will either break on this week
	        // or break on the next week
	        var isFixedAndFinalWeek = isFixedHeight && i >= FIXED_HEIGHT_STANDARD_WEEK_COUNT;
	        var isNonFixedAndOutOfMonth = !isFixedHeight && !_this.isWeekInMonth(currentWeekStart);
	
	        if (isFixedAndFinalWeek || isNonFixedAndOutOfMonth) {
	          if (_this.props.peekNextMonth) {
	            breakAfterNextPush = true;
	          } else {
	            break;
	          }
	        }
	      }
	
	      return weeks;
	    }, _this.getClassNames = function () {
	      var _this$props = _this.props,
	          selectingDate = _this$props.selectingDate,
	          selectsStart = _this$props.selectsStart,
	          selectsEnd = _this$props.selectsEnd;
	
	      return classnames('react-datepicker__month', {
	        'react-datepicker__month--selecting-range': selectingDate && (selectsStart || selectsEnd)
	      });
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  Month.prototype.render = function render() {
	    return React.createElement(
	      'div',
	      { className: this.getClassNames(), onMouseLeave: this.handleMouseLeave, role: 'listbox' },
	      this.renderWeeks()
	    );
	  };
	
	  return Month;
	}(React.Component);
	
	Month.propTypes = {
	  day: PropTypes.object.isRequired,
	  dayClassName: PropTypes.func,
	  endDate: PropTypes.object,
	  excludeDates: PropTypes.array,
	  filterDate: PropTypes.func,
	  fixedHeight: PropTypes.bool,
	  formatWeekNumber: PropTypes.func,
	  highlightDates: PropTypes.array,
	  includeDates: PropTypes.array,
	  inline: PropTypes.bool,
	  maxDate: PropTypes.object,
	  minDate: PropTypes.object,
	  onDayClick: PropTypes.func,
	  onDayMouseEnter: PropTypes.func,
	  onMouseLeave: PropTypes.func,
	  onWeekSelect: PropTypes.func,
	  peekNextMonth: PropTypes.bool,
	  preSelection: PropTypes.object,
	  selected: PropTypes.object,
	  selectingDate: PropTypes.object,
	  selectsEnd: PropTypes.bool,
	  selectsStart: PropTypes.bool,
	  showWeekNumbers: PropTypes.bool,
	  startDate: PropTypes.object,
	  utcOffset: PropTypes.number
	};
	
	var Time = function (_React$Component) {
	  inherits(Time, _React$Component);
	
	  function Time() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, Time);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (time) {
	      if ((_this.props.minTime || _this.props.maxTime) && isTimeInDisabledRange(time, _this.props) || _this.props.excludeTimes && isTimeDisabled(time, _this.props.excludeTimes)) {
	        return;
	      }
	
	      _this.props.onChange(time);
	    }, _this.liClasses = function (time, currH, currM) {
	      var classes = ['react-datepicker__time-list-item'];
	
	      if (currH === getHour(time) && currM === getMinute(time)) {
	        classes.push('react-datepicker__time-list-item--selected');
	      }
	      if ((_this.props.minTime || _this.props.maxTime) && isTimeInDisabledRange(time, _this.props) || _this.props.excludeTimes && isTimeDisabled(time, _this.props.excludeTimes)) {
	        classes.push('react-datepicker__time-list-item--disabled');
	      }
	
	      return classes.join(' ');
	    }, _this.renderTimes = function () {
	      var times = [];
	      var format = _this.props.format ? _this.props.format : 'hh:mm A';
	      var intervals = _this.props.intervals;
	      var activeTime = _this.props.selected ? _this.props.selected : newDate();
	      var currH = getHour(activeTime);
	      var currM = getMinute(activeTime);
	      var base = getStartOfDay(newDate());
	      var multiplier = 1440 / intervals;
	      for (var i = 0; i < multiplier; i++) {
	        times.push(addMinutes(cloneDate(base), i * intervals));
	      }
	
	      return times.map(function (time, i) {
	        return React.createElement(
	          'li',
	          { key: i, onClick: _this.handleClick.bind(_this, time), className: _this.liClasses(time, currH, currM) },
	          formatDate(time, format)
	        );
	      });
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  Time.prototype.componentDidMount = function componentDidMount() {
	    // code to ensure selected time will always be in focus within time window when it first appears
	    var multiplier = 60 / this.props.intervals;
	    var currH = this.props.selected ? getHour(this.props.selected) : getHour(newDate());
	    this.list.scrollTop = 30 * (multiplier * currH);
	  };
	
	  Time.prototype.render = function render() {
	    var _this2 = this;
	
	    var height = null;
	    if (this.props.monthRef) {
	      height = this.props.monthRef.clientHeight - 39;
	    }
	
	    return React.createElement(
	      'div',
	      { className: 'react-datepicker__time-container ' + (this.props.todayButton ? 'react-datepicker__time-container--with-today-button' : '') },
	      React.createElement(
	        'div',
	        { className: 'react-datepicker__header react-datepicker__header--time' },
	        React.createElement(
	          'div',
	          { className: 'react-datepicker-time__header' },
	          'Time'
	        )
	      ),
	      React.createElement(
	        'div',
	        { className: 'react-datepicker__time' },
	        React.createElement(
	          'div',
	          { className: 'react-datepicker__time-box' },
	          React.createElement(
	            'ul',
	            { className: 'react-datepicker__time-list', ref: function ref(list) {
	                _this2.list = list;
	              }, style: height ? { height: height } : {} },
	            this.renderTimes.bind(this)()
	          )
	        )
	      )
	    );
	  };
	
	  createClass(Time, null, [{
	    key: 'defaultProps',
	    get: function get$$1() {
	      return {
	        intervals: 30,
	        onTimeChange: function onTimeChange() {},
	        todayButton: null
	      };
	    }
	  }]);
	  return Time;
	}(React.Component);
	
	Time.propTypes = {
	  format: PropTypes.string,
	  intervals: PropTypes.number,
	  selected: PropTypes.object,
	  onChange: PropTypes.func,
	  todayButton: PropTypes.string,
	  minTime: PropTypes.object,
	  maxTime: PropTypes.object,
	  excludeTimes: PropTypes.array,
	  monthRef: PropTypes.object
	};
	
	var DROPDOWN_FOCUS_CLASSNAMES = ['react-datepicker__year-select', 'react-datepicker__month-select'];
	
	var isDropdownSelect = function isDropdownSelect() {
	  var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var classNames = (element.className || '').split(/\s+/);
	  return DROPDOWN_FOCUS_CLASSNAMES.some(function (testClassname) {
	    return classNames.indexOf(testClassname) >= 0;
	  });
	};
	
	var Calendar = function (_React$Component) {
	  inherits(Calendar, _React$Component);
	  createClass(Calendar, null, [{
	    key: 'defaultProps',
	    get: function get$$1() {
	      return {
	        onDropdownFocus: function onDropdownFocus() {},
	        monthsShown: 1,
	        forceShowMonthNavigation: false
	      };
	    }
	  }]);
	
	  function Calendar(props) {
	    classCallCheck(this, Calendar);
	
	    var _this = possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.handleClickOutside = function (event) {
	      _this.props.onClickOutside(event);
	    };
	
	    _this.handleDropdownFocus = function (event) {
	      if (isDropdownSelect(event.target)) {
	        _this.props.onDropdownFocus();
	      }
	    };
	
	    _this.getDateInView = function () {
	      var _this$props = _this.props,
	          preSelection = _this$props.preSelection,
	          selected = _this$props.selected,
	          openToDate = _this$props.openToDate,
	          utcOffset = _this$props.utcOffset;
	
	      var minDate = getEffectiveMinDate(_this.props);
	      var maxDate = getEffectiveMaxDate(_this.props);
	      var current = now(utcOffset);
	      var initialDate = openToDate || selected || preSelection;
	      if (initialDate) {
	        return initialDate;
	      } else {
	        if (minDate && isBefore(current, minDate)) {
	          return minDate;
	        } else if (maxDate && isAfter(current, maxDate)) {
	          return maxDate;
	        }
	      }
	      return current;
	    };
	
	    _this.localizeDate = function (date) {
	      return localizeDate(date, _this.props.locale);
	    };
	
	    _this.increaseMonth = function () {
	      _this.setState({
	        date: addMonths(cloneDate(_this.state.date), 1)
	      }, function () {
	        return _this.handleMonthChange(_this.state.date);
	      });
	    };
	
	    _this.decreaseMonth = function () {
	      _this.setState({
	        date: subtractMonths(cloneDate(_this.state.date), 1)
	      }, function () {
	        return _this.handleMonthChange(_this.state.date);
	      });
	    };
	
	    _this.handleDayClick = function (day, event) {
	      return _this.props.onSelect(day, event);
	    };
	
	    _this.handleDayMouseEnter = function (day) {
	      return _this.setState({ selectingDate: day });
	    };
	
	    _this.handleMonthMouseLeave = function () {
	      return _this.setState({ selectingDate: null });
	    };
	
	    _this.handleMonthChange = function (date) {
	      if (_this.props.onMonthChange) {
	        _this.props.onMonthChange(date);
	      }
	    };
	
	    _this.changeYear = function (year) {
	      _this.setState({
	        date: setYear(cloneDate(_this.state.date), year)
	      });
	    };
	
	    _this.changeMonth = function (month) {
	      _this.setState({
	        date: setMonth(cloneDate(_this.state.date), month)
	      }, function () {
	        return _this.handleMonthChange(_this.state.date);
	      });
	    };
	
	    _this.header = function () {
	      var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.date;
	
	      var startOfWeek = getStartOfWeek(cloneDate(date));
	      var dayNames = [];
	      if (_this.props.showWeekNumbers) {
	        dayNames.push(React.createElement(
	          'div',
	          { key: 'W', className: 'react-datepicker__day-name' },
	          _this.props.weekLabel || '#'
	        ));
	      }
	      return dayNames.concat([0, 1, 2, 3, 4, 5, 6].map(function (offset) {
	        var day = addDays(cloneDate(startOfWeek), offset);
	        var localeData = getLocaleData(day);
	        var weekDayName = _this.props.useWeekdaysShort ? getWeekdayShortInLocale(localeData, day) : getWeekdayMinInLocale(localeData, day);
	        return React.createElement(
	          'div',
	          { key: offset, className: 'react-datepicker__day-name' },
	          weekDayName
	        );
	      }));
	    };
	
	    _this.renderPreviousMonthButton = function () {
	      if (!_this.props.forceShowMonthNavigation && allDaysDisabledBefore(_this.state.date, 'month', _this.props)) {
	        return;
	      }
	      return React.createElement('a', {
	        className: 'react-datepicker__navigation react-datepicker__navigation--previous',
	        onClick: _this.decreaseMonth });
	    };
	
	    _this.renderNextMonthButton = function () {
	      if (!_this.props.forceShowMonthNavigation && allDaysDisabledAfter(_this.state.date, 'month', _this.props)) {
	        return;
	      }
	
	      var classes = ['react-datepicker__navigation', 'react-datepicker__navigation--next'];
	      if (_this.props.showTimeSelect) {
	        classes.push('react-datepicker__navigation--next--with-time');
	      }
	      if (_this.props.todayButton) {
	        classes.push('react-datepicker__navigation--next--with-today-button');
	      }
	
	      return React.createElement('a', {
	        className: classes.join(' '),
	        onClick: _this.increaseMonth });
	    };
	
	    _this.renderCurrentMonth = function () {
	      var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.date;
	
	      var classes = ['react-datepicker__current-month'];
	
	      if (_this.props.showYearDropdown) {
	        classes.push('react-datepicker__current-month--hasYearDropdown');
	      }
	      if (_this.props.showMonthDropdown) {
	        classes.push('react-datepicker__current-month--hasMonthDropdown');
	      }
	      return React.createElement(
	        'div',
	        { className: classes.join(' ') },
	        formatDate(date, _this.props.dateFormat)
	      );
	    };
	
	    _this.renderYearDropdown = function () {
	      var overrideHide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      if (!_this.props.showYearDropdown || overrideHide) {
	        return;
	      }
	      return React.createElement(YearDropdown, {
	        dropdownMode: _this.props.dropdownMode,
	        onChange: _this.changeYear,
	        minDate: _this.props.minDate,
	        maxDate: _this.props.maxDate,
	        year: getYear(_this.state.date),
	        scrollableYearDropdown: _this.props.scrollableYearDropdown,
	        yearDropdownItemNumber: _this.props.yearDropdownItemNumber });
	    };
	
	    _this.renderMonthDropdown = function () {
	      if (!_this.props.showMonthDropdown) {
	        return;
	      }
	      return React.createElement(MonthDropdown, {
	        dropdownMode: _this.props.dropdownMode,
	        locale: _this.props.locale,
	        dateFormat: _this.props.dateFormat,
	        onChange: _this.changeMonth,
	        month: getMonth(_this.state.date) });
	    };
	
	    _this.renderTodayButton = function () {
	      if (!_this.props.todayButton) {
	        return;
	      }
	      return React.createElement(
	        'div',
	        {
	          className: 'react-datepicker__today-button',
	          onClick: function onClick(e) {
	            return _this.props.onSelect(getStartOfDate(now(_this.props.utcOffset)), e);
	          } },
	        _this.props.todayButton
	      );
	    };
	
	    _this.renderMonths = function () {
	      var monthList = [];
	      for (var i = 0; i < _this.props.monthsShown; ++i) {
	        var monthDate = addMonths(cloneDate(_this.state.date), i);
	        var monthKey = 'month-' + i;
	        monthList.push(React.createElement(
	          'div',
	          { key: monthKey, ref: function ref(div) {
	              _this.monthContainer = div;
	            }, className: 'react-datepicker__month-container' },
	          React.createElement(
	            'div',
	            { className: 'react-datepicker__header' },
	            _this.renderCurrentMonth(monthDate),
	            React.createElement(
	              'div',
	              {
	                className: 'react-datepicker__header__dropdown react-datepicker__header__dropdown--' + _this.props.dropdownMode,
	                onFocus: _this.handleDropdownFocus },
	              _this.renderMonthDropdown(i !== 0),
	              _this.renderYearDropdown(i !== 0)
	            ),
	            React.createElement(
	              'div',
	              { className: 'react-datepicker__day-names' },
	              _this.header(monthDate)
	            )
	          ),
	          React.createElement(Month, {
	            day: monthDate,
	            dayClassName: _this.props.dayClassName,
	            onDayClick: _this.handleDayClick,
	            onDayMouseEnter: _this.handleDayMouseEnter,
	            onMouseLeave: _this.handleMonthMouseLeave,
	            onWeekSelect: _this.props.onWeekSelect,
	            formatWeekNumber: _this.props.formatWeekNumber,
	            minDate: _this.props.minDate,
	            maxDate: _this.props.maxDate,
	            excludeDates: _this.props.excludeDates,
	            highlightDates: _this.props.highlightDates,
	            selectingDate: _this.state.selectingDate,
	            includeDates: _this.props.includeDates,
	            inline: _this.props.inline,
	            fixedHeight: _this.props.fixedHeight,
	            filterDate: _this.props.filterDate,
	            preSelection: _this.props.preSelection,
	            selected: _this.props.selected,
	            selectsStart: _this.props.selectsStart,
	            selectsEnd: _this.props.selectsEnd,
	            showWeekNumbers: _this.props.showWeekNumbers,
	            startDate: _this.props.startDate,
	            endDate: _this.props.endDate,
	            peekNextMonth: _this.props.peekNextMonth,
	            utcOffset: _this.props.utcOffset })
	        ));
	      }
	      return monthList;
	    };
	
	    _this.renderTimeSection = function () {
	      if (_this.props.showTimeSelect) {
	        return React.createElement(Time, {
	          selected: _this.props.selected,
	          onChange: _this.props.onTimeChange,
	          format: _this.props.timeFormat,
	          intervals: _this.props.timeIntervals,
	          minTime: _this.props.minTime,
	          maxTime: _this.props.maxTime,
	          excludeTimes: _this.props.excludeTimes,
	          todayButton: _this.props.todayButton,
	          showMonthDropdown: _this.props.showMonthDropdown,
	          showYearDropdown: _this.props.showYearDropdown,
	          withPortal: _this.props.withPortal,
	          monthRef: _this.state.monthContainer });
	      } else {
	        return;
	      }
	    };
	
	    _this.state = {
	      date: _this.localizeDate(_this.getDateInView()),
	      selectingDate: null,
	      monthContainer: _this.monthContainer
	    };
	    return _this;
	  }
	
	  Calendar.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    /* monthContainer height is needed in time component to determine the height for the ul in the time component. setState here so height is given after final component layout is rendered */
	    if (this.props.showTimeSelect) {
	      this.assignMonthContainer = function () {
	        _this2.setState({ monthContainer: _this2.monthContainer });
	      }();
	    }
	  };
	
	  Calendar.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.preSelection && !isSameDay(nextProps.preSelection, this.props.preSelection)) {
	      this.setState({
	        date: this.localizeDate(nextProps.preSelection)
	      });
	    } else if (nextProps.openToDate && !isSameDay(nextProps.openToDate, this.props.openToDate)) {
	      this.setState({
	        date: this.localizeDate(nextProps.openToDate)
	      });
	    }
	  };
	
	  Calendar.prototype.render = function render() {
	    return React.createElement(
	      'div',
	      { className: classnames('react-datepicker', this.props.className) },
	      React.createElement('div', { className: 'react-datepicker__triangle' }),
	      this.renderPreviousMonthButton(),
	      this.renderNextMonthButton(),
	      this.renderMonths(),
	      this.renderTodayButton(),
	      this.renderTimeSection(),
	      this.props.children
	    );
	  };
	
	  return Calendar;
	}(React.Component);
	
	Calendar.propTypes = {
	  className: PropTypes.string,
	  children: PropTypes.node,
	  dateFormat: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
	  dayClassName: PropTypes.func,
	  dropdownMode: PropTypes.oneOf(['scroll', 'select']).isRequired,
	  endDate: PropTypes.object,
	  excludeDates: PropTypes.array,
	  filterDate: PropTypes.func,
	  fixedHeight: PropTypes.bool,
	  formatWeekNumber: PropTypes.func,
	  highlightDates: PropTypes.array,
	  includeDates: PropTypes.array,
	  inline: PropTypes.bool,
	  locale: PropTypes.string,
	  maxDate: PropTypes.object,
	  minDate: PropTypes.object,
	  monthsShown: PropTypes.number,
	  onClickOutside: PropTypes.func.isRequired,
	  onMonthChange: PropTypes.func,
	  forceShowMonthNavigation: PropTypes.bool,
	  onDropdownFocus: PropTypes.func,
	  onSelect: PropTypes.func.isRequired,
	  onWeekSelect: PropTypes.func,
	  showTimeSelect: PropTypes.bool,
	  timeFormat: PropTypes.string,
	  timeIntervals: PropTypes.number,
	  onTimeChange: PropTypes.func,
	  minTime: PropTypes.object,
	  maxTime: PropTypes.object,
	  excludeTimes: PropTypes.array,
	  openToDate: PropTypes.object,
	  peekNextMonth: PropTypes.bool,
	  scrollableYearDropdown: PropTypes.bool,
	  preSelection: PropTypes.object,
	  selected: PropTypes.object,
	  selectsEnd: PropTypes.bool,
	  selectsStart: PropTypes.bool,
	  showMonthDropdown: PropTypes.bool,
	  showWeekNumbers: PropTypes.bool,
	  showYearDropdown: PropTypes.bool,
	  startDate: PropTypes.object,
	  todayButton: PropTypes.string,
	  useWeekdaysShort: PropTypes.bool,
	  withPortal: PropTypes.bool,
	  utcOffset: PropTypes.number,
	  weekLabel: PropTypes.string,
	  yearDropdownItemNumber: PropTypes.number
	};
	
	var popperPlacementPositions = ['auto', 'auto-left', 'auto-right', 'bottom', 'bottom-end', 'bottom-start', 'left', 'left-end', 'left-start', 'right', 'right-end', 'right-start', 'top', 'top-end', 'top-start'];
	
	var PopperComponent = function (_React$Component) {
	  inherits(PopperComponent, _React$Component);
	
	  function PopperComponent() {
	    classCallCheck(this, PopperComponent);
	    return possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  PopperComponent.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        hidePopper = _props.hidePopper,
	        popperComponent = _props.popperComponent,
	        popperModifiers = _props.popperModifiers,
	        popperPlacement = _props.popperPlacement,
	        targetComponent = _props.targetComponent;
	
	
	    var popper = void 0;
	
	    if (!hidePopper) {
	      var classes = classnames('react-datepicker-popper', className);
	      popper = React.createElement(
	        reactPopper.Popper,
	        {
	          className: classes,
	          modifiers: popperModifiers,
	          placement: popperPlacement },
	        popperComponent
	      );
	    }
	
	    if (this.props.popperContainer) {
	      popper = React.createElement(this.props.popperContainer, {}, popper);
	    }
	
	    return React.createElement(
	      reactPopper.Manager,
	      null,
	      React.createElement(
	        reactPopper.Target,
	        { className: 'react-datepicker-wrapper' },
	        targetComponent
	      ),
	      popper
	    );
	  };
	
	  createClass(PopperComponent, null, [{
	    key: 'defaultProps',
	    get: function get$$1() {
	      return {
	        hidePopper: true,
	        popperModifiers: {
	          preventOverflow: {
	            enabled: true,
	            escapeWithReference: true,
	            boundariesElement: 'viewport'
	          }
	        },
	        popperPlacement: 'bottom-start'
	      };
	    }
	  }]);
	  return PopperComponent;
	}(React.Component);
	
	PopperComponent.propTypes = {
	  className: PropTypes.string,
	  hidePopper: PropTypes.bool,
	  popperComponent: PropTypes.element,
	  popperModifiers: PropTypes.object, // <datepicker/> props
	  popperPlacement: PropTypes.oneOf(popperPlacementPositions), // <datepicker/> props
	  popperContainer: PropTypes.func,
	  targetComponent: PropTypes.element
	};
	
	var outsideClickIgnoreClass = 'react-datepicker-ignore-onclickoutside';
	var WrappedCalendar = onClickOutside(Calendar);
	
	/**
	 * General datepicker component.
	 */
	
	var DatePicker = function (_React$Component) {
	  inherits(DatePicker, _React$Component);
	  createClass(DatePicker, null, [{
	    key: 'defaultProps',
	    get: function get$$1() {
	      return {
	        allowSameDay: false,
	        dateFormat: 'L',
	        dateFormatCalendar: 'MMMM YYYY',
	        onChange: function onChange() {},
	
	        disabled: false,
	        disabledKeyboardNavigation: false,
	        dropdownMode: 'scroll',
	        onFocus: function onFocus() {},
	        onBlur: function onBlur() {},
	        onKeyDown: function onKeyDown() {},
	        onSelect: function onSelect() {},
	        onClickOutside: function onClickOutside$$1() {},
	        onMonthChange: function onMonthChange() {},
	
	        monthsShown: 1,
	        withPortal: false,
	        shouldCloseOnSelect: true,
	        showTimeSelect: false,
	        timeIntervals: 30
	      };
	    }
	  }]);
	
	  function DatePicker(props) {
	    classCallCheck(this, DatePicker);
	
	    var _this = possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.getPreSelection = function () {
	      return _this.props.openToDate ? newDate(_this.props.openToDate) : _this.props.selectsEnd && _this.props.startDate ? newDate(_this.props.startDate) : _this.props.selectsStart && _this.props.endDate ? newDate(_this.props.endDate) : now(_this.props.utcOffset);
	    };
	
	    _this.calcInitialState = function () {
	      var defaultPreSelection = _this.getPreSelection();
	      var minDate = getEffectiveMinDate(_this.props);
	      var maxDate = getEffectiveMaxDate(_this.props);
	      var boundedPreSelection = minDate && isBefore(defaultPreSelection, minDate) ? minDate : maxDate && isAfter(defaultPreSelection, maxDate) ? maxDate : defaultPreSelection;
	
	      return {
	        open: _this.props.startOpen || false,
	        preventFocus: false,
	        preSelection: _this.props.selected ? newDate(_this.props.selected) : boundedPreSelection
	      };
	    };
	
	    _this.clearPreventFocusTimeout = function () {
	      if (_this.preventFocusTimeout) {
	        clearTimeout(_this.preventFocusTimeout);
	      }
	    };
	
	    _this.setFocus = function () {
	      _this.input.focus();
	    };
	
	    _this.setOpen = function (open) {
	      _this.setState({
	        open: open,
	        preSelection: open && _this.state.open ? _this.state.preSelection : _this.calcInitialState().preSelection
	      });
	    };
	
	    _this.handleFocus = function (event) {
	      if (!_this.state.preventFocus) {
	        _this.props.onFocus(event);
	        _this.setOpen(true);
	      }
	    };
	
	    _this.cancelFocusInput = function () {
	      clearTimeout(_this.inputFocusTimeout);
	      _this.inputFocusTimeout = null;
	    };
	
	    _this.deferFocusInput = function () {
	      _this.cancelFocusInput();
	      _this.inputFocusTimeout = setTimeout(function () {
	        return _this.setFocus();
	      }, 1);
	    };
	
	    _this.handleDropdownFocus = function () {
	      _this.cancelFocusInput();
	    };
	
	    _this.handleBlur = function (event) {
	      if (_this.state.open) {
	        _this.deferFocusInput();
	      } else {
	        _this.props.onBlur(event);
	      }
	    };
	
	    _this.handleCalendarClickOutside = function (event) {
	      if (!_this.props.inline) {
	        _this.setOpen(false);
	      }
	      _this.props.onClickOutside(event);
	      if (_this.props.withPortal) {
	        event.preventDefault();
	      }
	    };
	
	    _this.handleChange = function (event) {
	      if (_this.props.onChangeRaw) {
	        _this.props.onChangeRaw(event);
	        if (event.isDefaultPrevented()) {
	          return;
	        }
	      }
	      _this.setState({ inputValue: event.target.value });
	      var date = parseDate(event.target.value, _this.props);
	      if (date || !event.target.value) {
	        _this.setSelected(date, event, true);
	      }
	    };
	
	    _this.handleSelect = function (date, event) {
	      // Preventing onFocus event to fix issue
	      // https://github.com/Hacker0x01/react-datepicker/issues/628
	      _this.setState({ preventFocus: true }, function () {
	        _this.preventFocusTimeout = setTimeout(function () {
	          return _this.setState({ preventFocus: false });
	        }, 50);
	        return _this.preventFocusTimeout;
	      });
	      _this.setSelected(date, event);
	      if (!_this.props.shouldCloseOnSelect) {
	        _this.setPreSelection(date);
	      } else if (!_this.props.inline) {
	        _this.setOpen(false);
	      }
	    };
	
	    _this.setSelected = function (date, event, keepInput) {
	      var changedDate = date;
	
	      if (changedDate !== null && isDayDisabled(changedDate, _this.props)) {
	        return;
	      }
	
	      if (!isSameDay(_this.props.selected, changedDate) || _this.props.allowSameDay) {
	        if (changedDate !== null) {
	          if (_this.props.selected) {
	            changedDate = setTime(newDate(changedDate), {
	              hour: getHour(_this.props.selected),
	              minute: getMinute(_this.props.selected),
	              second: getSecond(_this.props.selected)
	            });
	          }
	          _this.setState({
	            preSelection: changedDate
	          });
	        }
	        _this.props.onChange(changedDate, event);
	      }
	
	      _this.props.onSelect(changedDate, event);
	
	      if (!keepInput) {
	        _this.setState({ inputValue: null });
	      }
	    };
	
	    _this.setPreSelection = function (date) {
	      var isDateRangePresent = typeof _this.props.minDate !== 'undefined' && typeof _this.props.maxDate !== 'undefined';
	      var isValidDateSelection = isDateRangePresent && date ? isDayInRange(date, _this.props.minDate, _this.props.maxDate) : true;
	      if (isValidDateSelection) {
	        _this.setState({
	          preSelection: date
	        });
	      }
	    };
	
	    _this.handleTimeChange = function (time) {
	      var selected = _this.props.selected ? _this.props.selected : _this.getPreSelection();
	      var changedDate = setTime(cloneDate(selected), {
	        hour: getHour(time),
	        minute: getMinute(time)
	      });
	
	      _this.setState({
	        preSelection: changedDate
	      });
	
	      _this.props.onChange(changedDate);
	    };
	
	    _this.onInputClick = function () {
	      if (!_this.props.disabled) {
	        _this.setOpen(true);
	      }
	    };
	
	    _this.onInputKeyDown = function (event) {
	      _this.props.onKeyDown(event);
	      var eventKey = event.key;
	      if (!_this.state.open && !_this.props.inline) {
	        if (eventKey !== 'Enter' && eventKey !== 'Escape' && eventKey !== 'Tab') {
	          _this.onInputClick();
	        }
	        return;
	      }
	      var copy = newDate(_this.state.preSelection);
	      if (eventKey === 'Enter') {
	        event.preventDefault();
	        if (isMoment(_this.state.preSelection) || isDate(_this.state.preSelection)) {
	          _this.handleSelect(copy, event);
	          !_this.props.shouldCloseOnSelect && _this.setPreSelection(copy);
	        } else {
	          _this.setOpen(false);
	        }
	      } else if (eventKey === 'Escape') {
	        event.preventDefault();
	        _this.setOpen(false);
	      } else if (eventKey === 'Tab') {
	        _this.setOpen(false);
	      } else if (!_this.props.disabledKeyboardNavigation) {
	        var newSelection = void 0;
	        switch (eventKey) {
	          case 'ArrowLeft':
	            event.preventDefault();
	            newSelection = subtractDays(copy, 1);
	            break;
	          case 'ArrowRight':
	            event.preventDefault();
	            newSelection = addDays(copy, 1);
	            break;
	          case 'ArrowUp':
	            event.preventDefault();
	            newSelection = subtractWeeks(copy, 1);
	            break;
	          case 'ArrowDown':
	            event.preventDefault();
	            newSelection = addWeeks(copy, 1);
	            break;
	          case 'PageUp':
	            event.preventDefault();
	            newSelection = subtractMonths(copy, 1);
	            break;
	          case 'PageDown':
	            event.preventDefault();
	            newSelection = addMonths(copy, 1);
	            break;
	          case 'Home':
	            event.preventDefault();
	            newSelection = subtractYears(copy, 1);
	            break;
	          case 'End':
	            event.preventDefault();
	            newSelection = addYears(copy, 1);
	            break;
	        }
	        _this.setPreSelection(newSelection);
	      }
	    };
	
	    _this.onClearClick = function (event) {
	      event.preventDefault();
	      _this.props.onChange(null, event);
	      _this.setState({ inputValue: null });
	    };
	
	    _this.renderCalendar = function () {
	      if (!_this.props.inline && (!_this.state.open || _this.props.disabled)) {
	        return null;
	      }
	      return React.createElement(
	        WrappedCalendar,
	        {
	          ref: function ref(elem) {
	            _this.calendar = elem;
	          },
	          locale: _this.props.locale,
	          dateFormat: _this.props.dateFormatCalendar,
	          useWeekdaysShort: _this.props.useWeekdaysShort,
	          dropdownMode: _this.props.dropdownMode,
	          selected: _this.props.selected,
	          preSelection: _this.state.preSelection,
	          onSelect: _this.handleSelect,
	          onWeekSelect: _this.props.onWeekSelect,
	          openToDate: _this.props.openToDate,
	          minDate: _this.props.minDate,
	          maxDate: _this.props.maxDate,
	          selectsStart: _this.props.selectsStart,
	          selectsEnd: _this.props.selectsEnd,
	          startDate: _this.props.startDate,
	          endDate: _this.props.endDate,
	          excludeDates: _this.props.excludeDates,
	          filterDate: _this.props.filterDate,
	          onClickOutside: _this.handleCalendarClickOutside,
	          formatWeekNumber: _this.props.formatWeekNumber,
	          highlightDates: _this.props.highlightDates,
	          includeDates: _this.props.includeDates,
	          inline: _this.props.inline,
	          peekNextMonth: _this.props.peekNextMonth,
	          showMonthDropdown: _this.props.showMonthDropdown,
	          showWeekNumbers: _this.props.showWeekNumbers,
	          showYearDropdown: _this.props.showYearDropdown,
	          withPortal: _this.props.withPortal,
	          forceShowMonthNavigation: _this.props.forceShowMonthNavigation,
	          scrollableYearDropdown: _this.props.scrollableYearDropdown,
	          todayButton: _this.props.todayButton,
	          weekLabel: _this.props.weekLabel,
	          utcOffset: _this.props.utcOffset,
	          outsideClickIgnoreClass: outsideClickIgnoreClass,
	          fixedHeight: _this.props.fixedHeight,
	          monthsShown: _this.props.monthsShown,
	          onDropdownFocus: _this.handleDropdownFocus,
	          onMonthChange: _this.props.onMonthChange,
	          dayClassName: _this.props.dayClassName,
	          showTimeSelect: _this.props.showTimeSelect,
	          onTimeChange: _this.handleTimeChange,
	          timeFormat: _this.props.timeFormat,
	          timeIntervals: _this.props.timeIntervals,
	          minTime: _this.props.minTime,
	          maxTime: _this.props.maxTime,
	          excludeTimes: _this.props.excludeTimes,
	          className: _this.props.calendarClassName,
	          yearDropdownItemNumber: _this.props.yearDropdownItemNumber },
	        _this.props.children
	      );
	    };
	
	    _this.renderDateInput = function () {
	      var _classnames;
	
	      var className = classnames(_this.props.className, (_classnames = {}, _classnames[outsideClickIgnoreClass] = _this.state.open, _classnames));
	
	      var customInput = _this.props.customInput || React.createElement('input', { type: 'text' });
	      var inputValue = typeof _this.props.value === 'string' ? _this.props.value : typeof _this.state.inputValue === 'string' ? _this.state.inputValue : safeDateFormat(_this.props.selected, _this.props);
	
	      return React.cloneElement(customInput, {
	        ref: function ref(input) {
	          _this.input = input;
	        },
	        value: inputValue,
	        onBlur: _this.handleBlur,
	        onChange: _this.handleChange,
	        onClick: _this.onInputClick,
	        onFocus: _this.handleFocus,
	        onKeyDown: _this.onInputKeyDown,
	        id: _this.props.id,
	        name: _this.props.name,
	        autoFocus: _this.props.autoFocus,
	        placeholder: _this.props.placeholderText,
	        disabled: _this.props.disabled,
	        autoComplete: _this.props.autoComplete,
	        className: className,
	        title: _this.props.title,
	        readOnly: _this.props.readOnly,
	        required: _this.props.required,
	        tabIndex: _this.props.tabIndex
	      });
	    };
	
	    _this.renderClearButton = function () {
	      if (_this.props.isClearable && _this.props.selected != null) {
	        return React.createElement('a', { className: 'react-datepicker__close-icon', href: '#', onClick: _this.onClearClick });
	      } else {
	        return null;
	      }
	    };
	
	    _this.state = _this.calcInitialState();
	    return _this;
	  }
	
	  DatePicker.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var currentMonth = this.props.selected && getMonth(this.props.selected);
	    var nextMonth = nextProps.selected && getMonth(nextProps.selected);
	    if (this.props.inline && currentMonth !== nextMonth) {
	      this.setPreSelection(nextProps.selected);
	    }
	  };
	
	  DatePicker.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.clearPreventFocusTimeout();
	  };
	
	  DatePicker.prototype.render = function render() {
	    var calendar = this.renderCalendar();
	
	    if (this.props.inline && !this.props.withPortal) {
	      return calendar;
	    }
	
	    if (this.props.withPortal) {
	      return React.createElement(
	        'div',
	        null,
	        !this.props.inline ? React.createElement(
	          'div',
	          { className: 'react-datepicker__input-container' },
	          this.renderDateInput(),
	          this.renderClearButton()
	        ) : null,
	        this.state.open || this.props.inline ? React.createElement(
	          'div',
	          { className: 'react-datepicker__portal' },
	          calendar
	        ) : null
	      );
	    }
	
	    return React.createElement(PopperComponent, {
	      className: this.props.popperClassName,
	      hidePopper: !this.state.open || this.props.disabled,
	      popperModifiers: this.props.popperModifiers,
	      targetComponent: React.createElement(
	        'div',
	        { className: 'react-datepicker__input-container' },
	        this.renderDateInput(),
	        this.renderClearButton()
	      ),
	      popperContainer: this.props.popperContainer,
	      popperComponent: calendar,
	      popperPlacement: this.props.popperPlacement });
	  };
	
	  return DatePicker;
	}(React.Component);
	
	DatePicker.propTypes = {
	  allowSameDay: PropTypes.bool,
	  autoComplete: PropTypes.string,
	  autoFocus: PropTypes.bool,
	  calendarClassName: PropTypes.string,
	  children: PropTypes.node,
	  className: PropTypes.string,
	  customInput: PropTypes.element,
	  dateFormat: PropTypes.oneOfType([// eslint-disable-line react/no-unused-prop-types
	  PropTypes.string, PropTypes.array]),
	  dateFormatCalendar: PropTypes.string,
	  dayClassName: PropTypes.func,
	  disabled: PropTypes.bool,
	  disabledKeyboardNavigation: PropTypes.bool,
	  dropdownMode: PropTypes.oneOf(['scroll', 'select']).isRequired,
	  endDate: PropTypes.object,
	  excludeDates: PropTypes.array,
	  filterDate: PropTypes.func,
	  fixedHeight: PropTypes.bool,
	  formatWeekNumber: PropTypes.func,
	  highlightDates: PropTypes.array,
	  id: PropTypes.string,
	  includeDates: PropTypes.array,
	  inline: PropTypes.bool,
	  isClearable: PropTypes.bool,
	  locale: PropTypes.string,
	  maxDate: PropTypes.object,
	  minDate: PropTypes.object,
	  monthsShown: PropTypes.number,
	  name: PropTypes.string,
	  onBlur: PropTypes.func,
	  onChange: PropTypes.func.isRequired,
	  onSelect: PropTypes.func,
	  onWeekSelect: PropTypes.func,
	  onClickOutside: PropTypes.func,
	  onChangeRaw: PropTypes.func,
	  onFocus: PropTypes.func,
	  onKeyDown: PropTypes.func,
	  onMonthChange: PropTypes.func,
	  openToDate: PropTypes.object,
	  peekNextMonth: PropTypes.bool,
	  placeholderText: PropTypes.string,
	  popperContainer: PropTypes.func,
	  popperClassName: PropTypes.string, // <PopperComponent/> props
	  popperModifiers: PropTypes.object, // <PopperComponent/> props
	  popperPlacement: PropTypes.oneOf(popperPlacementPositions), // <PopperComponent/> props
	  readOnly: PropTypes.bool,
	  required: PropTypes.bool,
	  scrollableYearDropdown: PropTypes.bool,
	  selected: PropTypes.object,
	  selectsEnd: PropTypes.bool,
	  selectsStart: PropTypes.bool,
	  showMonthDropdown: PropTypes.bool,
	  showWeekNumbers: PropTypes.bool,
	  showYearDropdown: PropTypes.bool,
	  forceShowMonthNavigation: PropTypes.bool,
	  startDate: PropTypes.object,
	  startOpen: PropTypes.bool,
	  tabIndex: PropTypes.number,
	  title: PropTypes.string,
	  todayButton: PropTypes.string,
	  useWeekdaysShort: PropTypes.bool,
	  utcOffset: PropTypes.number,
	  value: PropTypes.string,
	  weekLabel: PropTypes.string,
	  withPortal: PropTypes.bool,
	  yearDropdownItemNumber: PropTypes.number,
	  shouldCloseOnSelect: PropTypes.bool,
	  showTimeSelect: PropTypes.bool,
	  timeFormat: PropTypes.string,
	  timeIntervals: PropTypes.number,
	  minTime: PropTypes.object,
	  maxTime: PropTypes.object,
	  excludeTimes: PropTypes.array
	};
	
	module.exports = DatePicker;


/***/ },
/* 2266 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Arrow = function Arrow(props, context) {
	  var _props$component = props.component,
	      component = _props$component === undefined ? 'span' : _props$component,
	      innerRef = props.innerRef,
	      children = props.children,
	      restProps = _objectWithoutProperties(props, ['component', 'innerRef', 'children']);
	
	  var popper = context.popper;
	
	  var arrowRef = function arrowRef(node) {
	    popper.setArrowNode(node);
	    if (typeof innerRef === 'function') {
	      innerRef(node);
	    }
	  };
	  var arrowStyle = popper.getArrowStyle();
	
	  if (typeof children === 'function') {
	    var arrowProps = {
	      ref: arrowRef,
	      style: arrowStyle
	    };
	    return children({ arrowProps: arrowProps, restProps: restProps });
	  }
	
	  var componentProps = _extends({}, restProps, {
	    style: _extends({}, arrowStyle, restProps.style)
	  });
	
	  if (typeof component === 'string') {
	    componentProps.ref = arrowRef;
	  } else {
	    componentProps.innerRef = arrowRef;
	  }
	
	  return (0, _react.createElement)(component, componentProps, children);
	};
	
	Arrow.contextTypes = {
	  popper: _propTypes2.default.object.isRequired
	};
	
	Arrow.propTypes = {
	  component: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
	  innerRef: _propTypes2.default.func,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func])
	};
	
	exports.default = Arrow;

/***/ },
/* 2267 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Manager = function (_Component) {
	  _inherits(Manager, _Component);
	
	  function Manager() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Manager);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Manager.__proto__ || Object.getPrototypeOf(Manager)).call.apply(_ref, [this].concat(args))), _this), _this._setTargetNode = function (node) {
	      _this._targetNode = node;
	    }, _this._getTargetNode = function () {
	      return _this._targetNode;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Manager, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        popperManager: {
	          setTargetNode: this._setTargetNode,
	          getTargetNode: this._getTargetNode
	        }
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          tag = _props.tag,
	          children = _props.children,
	          restProps = _objectWithoutProperties(_props, ['tag', 'children']);
	
	      if (tag !== false) {
	        return (0, _react.createElement)(tag, restProps, children);
	      } else {
	        return children;
	      }
	    }
	  }]);
	
	  return Manager;
	}(_react.Component);
	
	Manager.childContextTypes = {
	  popperManager: _propTypes2.default.object.isRequired
	};
	Manager.propTypes = {
	  tag: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool])
	};
	Manager.defaultProps = {
	  tag: 'div'
	};
	exports.default = Manager;

/***/ },
/* 2268 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _popper = __webpack_require__(907);
	
	var _popper2 = _interopRequireDefault(_popper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var noop = function noop() {
	  return null;
	};
	
	var Popper = function (_Component) {
	  _inherits(Popper, _Component);
	
	  function Popper() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Popper);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Popper.__proto__ || Object.getPrototypeOf(Popper)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this._setArrowNode = function (node) {
	      _this._arrowNode = node;
	    }, _this._getTargetNode = function () {
	      return _this.context.popperManager.getTargetNode();
	    }, _this._getOffsets = function (data) {
	      return Object.keys(data.offsets).map(function (key) {
	        return data.offsets[key];
	      });
	    }, _this._isDataDirty = function (data) {
	      if (_this.state.data) {
	        return JSON.stringify(_this._getOffsets(_this.state.data)) !== JSON.stringify(_this._getOffsets(data));
	      } else {
	        return true;
	      }
	    }, _this._updateStateModifier = {
	      enabled: true,
	      order: 900,
	      fn: function fn(data) {
	        if (_this._isDataDirty(data)) {
	          _this.setState({ data: data });
	        }
	        return data;
	      }
	    }, _this._getPopperStyle = function () {
	      var data = _this.state.data;
	
	      // If Popper isn't instantiated, hide the popperElement
	      // to avoid flash of unstyled content
	
	      if (!_this._popper || !data) {
	        return {
	          position: 'absolute',
	          pointerEvents: 'none',
	          opacity: 0
	        };
	      }
	
	      var _data$offsets$popper = data.offsets.popper,
	          top = _data$offsets$popper.top,
	          left = _data$offsets$popper.left,
	          position = _data$offsets$popper.position;
	
	
	      return _extends({
	        position: position
	      }, data.styles);
	    }, _this._getPopperPlacement = function () {
	      return !!_this.state.data ? _this.state.data.placement : undefined;
	    }, _this._getPopperHide = function () {
	      return !!_this.state.data && _this.state.data.hide ? '' : undefined;
	    }, _this._getArrowStyle = function () {
	      if (!_this.state.data || !_this.state.data.offsets.arrow) {
	        return {};
	      } else {
	        var _this$state$data$offs = _this.state.data.offsets.arrow,
	            top = _this$state$data$offs.top,
	            left = _this$state$data$offs.left;
	
	        return { top: top, left: left };
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Popper, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        popper: {
	          setArrowNode: this._setArrowNode,
	          getArrowStyle: this._getArrowStyle
	        }
	      };
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._updatePopper();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(lastProps) {
	      if (lastProps.placement !== this.props.placement || lastProps.eventsEnabled !== this.props.eventsEnabled) {
	        this._updatePopper();
	      }
	
	      if (this._popper && lastProps.children !== this.props.children) {
	        this._popper.scheduleUpdate();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._destroyPopper();
	    }
	  }, {
	    key: '_updatePopper',
	    value: function _updatePopper() {
	      this._destroyPopper();
	      if (this._node) {
	        this._createPopper();
	      }
	    }
	  }, {
	    key: '_createPopper',
	    value: function _createPopper() {
	      var _props = this.props,
	          placement = _props.placement,
	          eventsEnabled = _props.eventsEnabled;
	
	      var modifiers = _extends({}, this.props.modifiers, {
	        applyStyle: { enabled: false },
	        updateState: this._updateStateModifier
	      });
	
	      if (this._arrowNode) {
	        modifiers.arrow = {
	          element: this._arrowNode
	        };
	      }
	
	      this._popper = new _popper2.default(this._getTargetNode(), this._node, {
	        placement: placement,
	        eventsEnabled: eventsEnabled,
	        modifiers: modifiers
	      });
	
	      // schedule an update to make sure everything gets positioned correct
	      // after being instantiated
	      this._popper.scheduleUpdate();
	    }
	  }, {
	    key: '_destroyPopper',
	    value: function _destroyPopper() {
	      if (this._popper) {
	        this._popper.destroy();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          component = _props2.component,
	          innerRef = _props2.innerRef,
	          placement = _props2.placement,
	          eventsEnabled = _props2.eventsEnabled,
	          modifiers = _props2.modifiers,
	          children = _props2.children,
	          restProps = _objectWithoutProperties(_props2, ['component', 'innerRef', 'placement', 'eventsEnabled', 'modifiers', 'children']);
	
	      var popperRef = function popperRef(node) {
	        _this2._node = node;
	        if (typeof innerRef === 'function') {
	          innerRef(node);
	        }
	      };
	      var popperStyle = this._getPopperStyle();
	      var popperPlacement = this._getPopperPlacement();
	      var popperHide = this._getPopperHide();
	
	      if (typeof children === 'function') {
	        var _popperProps;
	
	        var popperProps = (_popperProps = {
	          ref: popperRef,
	          style: popperStyle
	        }, _defineProperty(_popperProps, 'data-placement', popperPlacement), _defineProperty(_popperProps, 'data-x-out-of-boundaries', popperHide), _popperProps);
	        return children({
	          popperProps: popperProps,
	          restProps: restProps,
	          scheduleUpdate: this._popper && this._popper.scheduleUpdate
	        });
	      }
	
	      var componentProps = _extends({}, restProps, {
	        style: _extends({}, restProps.style, popperStyle),
	        'data-placement': popperPlacement,
	        'data-x-out-of-boundaries': popperHide
	      });
	
	      if (typeof component === 'string') {
	        componentProps.ref = popperRef;
	      } else {
	        componentProps.innerRef = popperRef;
	      }
	
	      return (0, _react.createElement)(component, componentProps, children);
	    }
	  }]);
	
	  return Popper;
	}(_react.Component);
	
	Popper.contextTypes = {
	  popperManager: _propTypes2.default.object.isRequired
	};
	Popper.childContextTypes = {
	  popper: _propTypes2.default.object.isRequired
	};
	Popper.propTypes = {
	  component: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
	  innerRef: _propTypes2.default.func,
	  placement: _propTypes2.default.oneOf(_popper2.default.placements),
	  eventsEnabled: _propTypes2.default.bool,
	  modifiers: _propTypes2.default.object,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func])
	};
	Popper.defaultProps = {
	  component: 'div',
	  placement: 'bottom',
	  eventsEnabled: true,
	  modifiers: {}
	};
	exports.default = Popper;

/***/ },
/* 2269 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Target = function Target(props, context) {
	  var _props$component = props.component,
	      component = _props$component === undefined ? 'div' : _props$component,
	      innerRef = props.innerRef,
	      children = props.children,
	      restProps = _objectWithoutProperties(props, ['component', 'innerRef', 'children']);
	
	  var popperManager = context.popperManager;
	
	  var targetRef = function targetRef(node) {
	    popperManager.setTargetNode(node);
	    if (typeof innerRef === 'function') {
	      innerRef(node);
	    }
	  };
	
	  if (typeof children === 'function') {
	    var targetProps = { ref: targetRef };
	    return children({ targetProps: targetProps, restProps: restProps });
	  }
	
	  var componentProps = _extends({}, restProps);
	
	  if (typeof component === 'string') {
	    componentProps.ref = targetRef;
	  } else {
	    componentProps.innerRef = targetRef;
	  }
	
	  return (0, _react.createElement)(component, componentProps, children);
	};
	
	Target.contextTypes = {
	  popperManager: _propTypes2.default.object.isRequired
	};
	
	Target.propTypes = {
	  component: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
	  innerRef: _propTypes2.default.func,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func])
	};
	
	exports.default = Target;

/***/ },
/* 2270 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Arrow = exports.Popper = exports.Target = exports.Manager = undefined;
	
	var _Manager2 = __webpack_require__(2267);
	
	var _Manager3 = _interopRequireDefault(_Manager2);
	
	var _Target2 = __webpack_require__(2269);
	
	var _Target3 = _interopRequireDefault(_Target2);
	
	var _Popper2 = __webpack_require__(2268);
	
	var _Popper3 = _interopRequireDefault(_Popper2);
	
	var _Arrow2 = __webpack_require__(2266);
	
	var _Arrow3 = _interopRequireDefault(_Arrow2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Manager = _Manager3.default;
	exports.Target = _Target3.default;
	exports.Popper = _Popper3.default;
	exports.Arrow = _Arrow3.default;

/***/ },
/* 2271 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v16.14.0
	 * react-dom.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	/*
	 Modernizr 3.0.0pre (Custom Build) | MIT
	*/
	'use strict';var aa=__webpack_require__(1),n=__webpack_require__(456),r=__webpack_require__(2462);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));
	function ba(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,k){da=!1;ea=null;ba.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,k){ja.apply(this,arguments);if(da){if(da){var l=ea;da=!1;ea=null}else throw Error(u(198));fa||(fa=!0,ha=l)}}var la=null,ma=null,na=null;
	function oa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=na(c);ka(d,b,void 0,a);a.currentTarget=null}var pa=null,qa={};
	function ra(){if(pa)for(var a in qa){var b=qa[a],c=pa.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!sa[c]){if(!b.extractEvents)throw Error(u(97,a));sa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(ta.hasOwnProperty(h))throw Error(u(99,h));ta[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ua(k[e],g,h);e=!0}else f.registrationName?(ua(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
	function ua(a,b,c){if(va[a])throw Error(u(100,a));va[a]=b;wa[a]=b.eventTypes[c].dependencies}var sa=[],ta={},va={},wa={};function xa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!qa.hasOwnProperty(c)||qa[c]!==d){if(qa[c])throw Error(u(102,c));qa[c]=d;b=!0}}b&&ra()}var ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),za=null,Aa=null,Ba=null;
	function Ca(a){if(a=ma(a)){if("function"!==typeof za)throw Error(u(280));var b=a.stateNode;b&&(b=la(b),za(a.stateNode,a.type,b))}}function Da(a){Aa?Ba?Ba.push(a):Ba=[a]:Aa=a}function Ea(){if(Aa){var a=Aa,b=Ba;Ba=Aa=null;Ca(a);if(b)for(a=0;a<b.length;a++)Ca(b[a])}}function Fa(a,b){return a(b)}function Ga(a,b,c,d,e){return a(b,c,d,e)}function Ha(){}var Ia=Fa,Ja=!1,Ka=!1;function La(){if(null!==Aa||null!==Ba)Ha(),Ea()}
	function Ma(a,b,c){if(Ka)return a(b,c);Ka=!0;try{return Ia(a,b,c)}finally{Ka=!1,La()}}var Na=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Oa=Object.prototype.hasOwnProperty,Pa={},Qa={};
	function Ra(a){if(Oa.call(Qa,a))return!0;if(Oa.call(Pa,a))return!1;if(Na.test(a))return Qa[a]=!0;Pa[a]=!0;return!1}function Sa(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
	function Ta(a,b,c,d){if(null===b||"undefined"===typeof b||Sa(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function v(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var C={};
	"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){C[a]=new v(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];C[b]=new v(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){C[a]=new v(a,2,!1,a.toLowerCase(),null,!1)});
	["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){C[a]=new v(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){C[a]=new v(a,3,!1,a.toLowerCase(),null,!1)});
	["checked","multiple","muted","selected"].forEach(function(a){C[a]=new v(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){C[a]=new v(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){C[a]=new v(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){C[a]=new v(a,5,!1,a.toLowerCase(),null,!1)});var Ua=/[\-:]([a-z])/g;function Va(a){return a[1].toUpperCase()}
	"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Ua,
	Va);C[b]=new v(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!1)});
	C.xlinkHref=new v("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!0)});var Wa=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Wa.hasOwnProperty("ReactCurrentDispatcher")||(Wa.ReactCurrentDispatcher={current:null});Wa.hasOwnProperty("ReactCurrentBatchConfig")||(Wa.ReactCurrentBatchConfig={suspense:null});
	function Xa(a,b,c,d){var e=C.hasOwnProperty(b)?C[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Ta(b,c,e,d)&&(c=null),d||null===e?Ra(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
	var Ya=/^(.*)[\\\/]/,E="function"===typeof Symbol&&Symbol.for,Za=E?Symbol.for("react.element"):60103,$a=E?Symbol.for("react.portal"):60106,ab=E?Symbol.for("react.fragment"):60107,bb=E?Symbol.for("react.strict_mode"):60108,cb=E?Symbol.for("react.profiler"):60114,db=E?Symbol.for("react.provider"):60109,eb=E?Symbol.for("react.context"):60110,fb=E?Symbol.for("react.concurrent_mode"):60111,gb=E?Symbol.for("react.forward_ref"):60112,hb=E?Symbol.for("react.suspense"):60113,ib=E?Symbol.for("react.suspense_list"):
	60120,jb=E?Symbol.for("react.memo"):60115,kb=E?Symbol.for("react.lazy"):60116,lb=E?Symbol.for("react.block"):60121,mb="function"===typeof Symbol&&Symbol.iterator;function nb(a){if(null===a||"object"!==typeof a)return null;a=mb&&a[mb]||a["@@iterator"];return"function"===typeof a?a:null}function ob(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
	function pb(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ab:return"Fragment";case $a:return"Portal";case cb:return"Profiler";case bb:return"StrictMode";case hb:return"Suspense";case ib:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case eb:return"Context.Consumer";case db:return"Context.Provider";case gb:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
	"ForwardRef");case jb:return pb(a.type);case lb:return pb(a.render);case kb:if(a=1===a._status?a._result:null)return pb(a)}return null}function qb(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=pb(a.type);c=null;d&&(c=pb(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ya,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
	function rb(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function sb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
	function tb(a){var b=sb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
	null;delete a[b]}}}}function xb(a){a._valueTracker||(a._valueTracker=tb(a))}function yb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=sb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function zb(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
	function Ab(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=rb(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Bb(a,b){b=b.checked;null!=b&&Xa(a,"checked",b,!1)}
	function Cb(a,b){Bb(a,b);var c=rb(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Db(a,b.type,c):b.hasOwnProperty("defaultValue")&&Db(a,b.type,rb(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
	function Eb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
	function Db(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Fb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Gb(a,b){a=n({children:void 0},b);if(b=Fb(b.children))a.children=b;return a}
	function Hb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+rb(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
	function Ib(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Jb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(u(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(u(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:rb(c)}}
	function Kb(a,b){var c=rb(b.value),d=rb(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Lb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Mb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
	function Nb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ob(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Nb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
	var Pb,Qb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Mb.svg||"innerHTML"in a)a.innerHTML=b;else{Pb=Pb||document.createElement("div");Pb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Pb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
	function Rb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Sb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Tb={animationend:Sb("Animation","AnimationEnd"),animationiteration:Sb("Animation","AnimationIteration"),animationstart:Sb("Animation","AnimationStart"),transitionend:Sb("Transition","TransitionEnd")},Ub={},Vb={};
	ya&&(Vb=document.createElement("div").style,"AnimationEvent"in window||(delete Tb.animationend.animation,delete Tb.animationiteration.animation,delete Tb.animationstart.animation),"TransitionEvent"in window||delete Tb.transitionend.transition);function Wb(a){if(Ub[a])return Ub[a];if(!Tb[a])return a;var b=Tb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Vb)return Ub[a]=b[c];return a}
	var Xb=Wb("animationend"),Yb=Wb("animationiteration"),Zb=Wb("animationstart"),$b=Wb("transitionend"),ac="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bc=new ("function"===typeof WeakMap?WeakMap:Map);function cc(a){var b=bc.get(a);void 0===b&&(b=new Map,bc.set(a,b));return b}
	function dc(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function ec(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function fc(a){if(dc(a)!==a)throw Error(u(188));}
	function gc(a){var b=a.alternate;if(!b){b=dc(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return fc(e),a;if(f===d)return fc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
	c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function hc(a){a=gc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
	function ic(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function jc(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var kc=null;
	function lc(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)oa(a,b[d],c[d]);else b&&oa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function mc(a){null!==a&&(kc=ic(kc,a));a=kc;kc=null;if(a){jc(a,lc);if(kc)throw Error(u(95));if(fa)throw a=ha,fa=!1,ha=null,a;}}
	function nc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function oc(a){if(!ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var pc=[];function qc(a){a.topLevelType=null;a.nativeEvent=null;a.targetInst=null;a.ancestors.length=0;10>pc.length&&pc.push(a)}
	function rc(a,b,c,d){if(pc.length){var e=pc.pop();e.topLevelType=a;e.eventSystemFlags=d;e.nativeEvent=b;e.targetInst=c;return e}return{topLevelType:a,eventSystemFlags:d,nativeEvent:b,targetInst:c,ancestors:[]}}
	function sc(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=tc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=nc(a.nativeEvent);d=a.topLevelType;var f=a.nativeEvent,g=a.eventSystemFlags;0===c&&(g|=64);for(var h=null,k=0;k<sa.length;k++){var l=sa[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=
	ic(h,l))}mc(h)}}function uc(a,b,c){if(!c.has(a)){switch(a){case "scroll":vc(b,"scroll",!0);break;case "focus":case "blur":vc(b,"focus",!0);vc(b,"blur",!0);c.set("blur",null);c.set("focus",null);break;case "cancel":case "close":oc(a)&&vc(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===ac.indexOf(a)&&F(a,b)}c.set(a,null)}}
	var wc,xc,yc,zc=!1,Ac=[],Bc=null,Cc=null,Dc=null,Ec=new Map,Fc=new Map,Gc=[],Hc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),Ic="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
	function Jc(a,b){var c=cc(b);Hc.forEach(function(a){uc(a,b,c)});Ic.forEach(function(a){uc(a,b,c)})}function Kc(a,b,c,d,e){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:e,container:d}}
	function Lc(a,b){switch(a){case "focus":case "blur":Bc=null;break;case "dragenter":case "dragleave":Cc=null;break;case "mouseover":case "mouseout":Dc=null;break;case "pointerover":case "pointerout":Ec.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":Fc.delete(b.pointerId)}}function Mc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=Kc(b,c,d,e,f),null!==b&&(b=Nc(b),null!==b&&xc(b)),a;a.eventSystemFlags|=d;return a}
	function Oc(a,b,c,d,e){switch(b){case "focus":return Bc=Mc(Bc,a,b,c,d,e),!0;case "dragenter":return Cc=Mc(Cc,a,b,c,d,e),!0;case "mouseover":return Dc=Mc(Dc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;Ec.set(f,Mc(Ec.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,Fc.set(f,Mc(Fc.get(f)||null,a,b,c,d,e)),!0}return!1}
	function Pc(a){var b=tc(a.target);if(null!==b){var c=dc(b);if(null!==c)if(b=c.tag,13===b){if(b=ec(c),null!==b){a.blockedOn=b;r.unstable_runWithPriority(a.priority,function(){yc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Qc(a){if(null!==a.blockedOn)return!1;var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);if(null!==b){var c=Nc(b);null!==c&&xc(c);a.blockedOn=b;return!1}return!0}
	function Sc(a,b,c){Qc(a)&&c.delete(b)}function Tc(){for(zc=!1;0<Ac.length;){var a=Ac[0];if(null!==a.blockedOn){a=Nc(a.blockedOn);null!==a&&wc(a);break}var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);null!==b?a.blockedOn=b:Ac.shift()}null!==Bc&&Qc(Bc)&&(Bc=null);null!==Cc&&Qc(Cc)&&(Cc=null);null!==Dc&&Qc(Dc)&&(Dc=null);Ec.forEach(Sc);Fc.forEach(Sc)}function Uc(a,b){a.blockedOn===b&&(a.blockedOn=null,zc||(zc=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Tc)))}
	function Vc(a){function b(b){return Uc(b,a)}if(0<Ac.length){Uc(Ac[0],a);for(var c=1;c<Ac.length;c++){var d=Ac[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==Bc&&Uc(Bc,a);null!==Cc&&Uc(Cc,a);null!==Dc&&Uc(Dc,a);Ec.forEach(b);Fc.forEach(b);for(c=0;c<Gc.length;c++)d=Gc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<Gc.length&&(c=Gc[0],null===c.blockedOn);)Pc(c),null===c.blockedOn&&Gc.shift()}
	var Wc={},Yc=new Map,Zc=new Map,$c=["abort","abort",Xb,"animationEnd",Yb,"animationIteration",Zb,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart","lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking",
	"seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",$b,"transitionEnd","waiting","waiting"];function ad(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1],f="on"+(e[0].toUpperCase()+e.slice(1));f={phasedRegistrationNames:{bubbled:f,captured:f+"Capture"},dependencies:[d],eventPriority:b};Zc.set(d,b);Yc.set(d,f);Wc[e]=f}}
	ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),0);
	ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);ad($c,2);for(var bd="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),cd=0;cd<bd.length;cd++)Zc.set(bd[cd],0);
	var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function F(a,b){vc(b,a,!1)}function vc(a,b,c){var d=Zc.get(b);switch(void 0===d?2:d){case 0:d=gd.bind(null,b,1,a);break;case 1:d=hd.bind(null,b,1,a);break;default:d=id.bind(null,b,1,a)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function gd(a,b,c,d){Ja||Ha();var e=id,f=Ja;Ja=!0;try{Ga(e,a,b,c,d)}finally{(Ja=f)||La()}}function hd(a,b,c,d){ed(dd,id.bind(null,a,b,c,d))}
	function id(a,b,c,d){if(fd)if(0<Ac.length&&-1<Hc.indexOf(a))a=Kc(null,a,b,c,d),Ac.push(a);else{var e=Rc(a,b,c,d);if(null===e)Lc(a,d);else if(-1<Hc.indexOf(a))a=Kc(e,a,b,c,d),Ac.push(a);else if(!Oc(e,a,b,c,d)){Lc(a,d);a=rc(a,d,null,b);try{Ma(sc,a)}finally{qc(a)}}}}
	function Rc(a,b,c,d){c=nc(d);c=tc(c);if(null!==c){var e=dc(c);if(null===e)c=null;else{var f=e.tag;if(13===f){c=ec(e);if(null!==c)return c;c=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;c=null}else e!==c&&(c=null)}}a=rc(a,d,c,b);try{Ma(sc,a)}finally{qc(a)}return null}
	var jd={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
	floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},kd=["Webkit","ms","Moz","O"];Object.keys(jd).forEach(function(a){kd.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);jd[b]=jd[a]})});function ld(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||jd.hasOwnProperty(a)&&jd[a]?(""+b).trim():b+"px"}
	function md(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ld(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var nd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
	function od(a,b){if(b){if(nd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
	function pd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var qd=Mb.html;function rd(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=cc(a);b=wa[b];for(var d=0;d<b.length;d++)uc(b[d],a,c)}function sd(){}
	function td(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ud(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function vd(a,b){var c=ud(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ud(c)}}
	function wd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?wd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function xd(){for(var a=window,b=td();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=td(a.document)}return b}
	function yd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var zd="$",Ad="/$",Bd="$?",Cd="$!",Dd=null,Ed=null;function Fd(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
	function Gd(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Hd="function"===typeof setTimeout?setTimeout:void 0,Id="function"===typeof clearTimeout?clearTimeout:void 0;function Jd(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
	function Kd(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===zd||c===Cd||c===Bd){if(0===b)return a;b--}else c===Ad&&b++}a=a.previousSibling}return null}var Ld=Math.random().toString(36).slice(2),Md="__reactInternalInstance$"+Ld,Nd="__reactEventHandlers$"+Ld,Od="__reactContainere$"+Ld;
	function tc(a){var b=a[Md];if(b)return b;for(var c=a.parentNode;c;){if(b=c[Od]||c[Md]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=Kd(a);null!==a;){if(c=a[Md])return c;a=Kd(a)}return b}a=c;c=a.parentNode}return null}function Nc(a){a=a[Md]||a[Od];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function Pd(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function Qd(a){return a[Nd]||null}
	function Rd(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
	function Sd(a,b){var c=a.stateNode;if(!c)return null;var d=la(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,
	b,typeof c));return c}function Td(a,b,c){if(b=Sd(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a)}function Ud(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Rd(b);for(b=c.length;0<b--;)Td(c[b],"captured",a);for(b=0;b<c.length;b++)Td(c[b],"bubbled",a)}}
	function Vd(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Sd(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a))}function Wd(a){a&&a.dispatchConfig.registrationName&&Vd(a._targetInst,null,a)}function Xd(a){jc(a,Ud)}var Yd=null,Zd=null,$d=null;
	function ae(){if($d)return $d;var a,b=Zd,c=b.length,d,e="value"in Yd?Yd.value:Yd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return $d=e.slice(a,1<d?1-d:void 0)}function be(){return!0}function ce(){return!1}
	function G(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?be:ce;this.isPropagationStopped=ce;return this}
	n(G.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=be)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=be)},persist:function(){this.isPersistent=be},isPersistent:ce,destructor:function(){var a=this.constructor.Interface,
	b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ce;this._dispatchInstances=this._dispatchListeners=null}});G.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
	G.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;de(c);return c};de(G);function ee(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
	function fe(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function de(a){a.eventPool=[];a.getPooled=ee;a.release=fe}var ge=G.extend({data:null}),he=G.extend({data:null}),ie=[9,13,27,32],je=ya&&"CompositionEvent"in window,ke=null;ya&&"documentMode"in document&&(ke=document.documentMode);
	var le=ya&&"TextEvent"in window&&!ke,me=ya&&(!je||ke&&8<ke&&11>=ke),ne=String.fromCharCode(32),oe={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
	captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},pe=!1;
	function qe(a,b){switch(a){case "keyup":return-1!==ie.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function re(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var se=!1;function te(a,b){switch(a){case "compositionend":return re(b);case "keypress":if(32!==b.which)return null;pe=!0;return ne;case "textInput":return a=b.data,a===ne&&pe?null:a;default:return null}}
	function ue(a,b){if(se)return"compositionend"===a||!je&&qe(a,b)?(a=ae(),$d=Zd=Yd=null,se=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return me&&"ko"!==b.locale?null:b.data;default:return null}}
	var ve={eventTypes:oe,extractEvents:function(a,b,c,d){var e;if(je)b:{switch(a){case "compositionstart":var f=oe.compositionStart;break b;case "compositionend":f=oe.compositionEnd;break b;case "compositionupdate":f=oe.compositionUpdate;break b}f=void 0}else se?qe(a,c)&&(f=oe.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=oe.compositionStart);f?(me&&"ko"!==c.locale&&(se||f!==oe.compositionStart?f===oe.compositionEnd&&se&&(e=ae()):(Yd=d,Zd="value"in Yd?Yd.value:Yd.textContent,se=!0)),f=ge.getPooled(f,
	b,c,d),e?f.data=e:(e=re(c),null!==e&&(f.data=e)),Xd(f),e=f):e=null;(a=le?te(a,c):ue(a,c))?(b=he.getPooled(oe.beforeInput,b,c,d),b.data=a,Xd(b)):b=null;return null===e?b:null===b?e:[e,b]}},we={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function xe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!we[a.type]:"textarea"===b?!0:!1}
	var ye={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function ze(a,b,c){a=G.getPooled(ye.change,a,b,c);a.type="change";Da(c);Xd(a);return a}var Ae=null,Be=null;function Ce(a){mc(a)}function De(a){var b=Pd(a);if(yb(b))return a}function Ee(a,b){if("change"===a)return b}var Fe=!1;ya&&(Fe=oc("input")&&(!document.documentMode||9<document.documentMode));
	function Ge(){Ae&&(Ae.detachEvent("onpropertychange",He),Be=Ae=null)}function He(a){if("value"===a.propertyName&&De(Be))if(a=ze(Be,a,nc(a)),Ja)mc(a);else{Ja=!0;try{Fa(Ce,a)}finally{Ja=!1,La()}}}function Ie(a,b,c){"focus"===a?(Ge(),Ae=b,Be=c,Ae.attachEvent("onpropertychange",He)):"blur"===a&&Ge()}function Je(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return De(Be)}function Ke(a,b){if("click"===a)return De(b)}function Le(a,b){if("input"===a||"change"===a)return De(b)}
	var Me={eventTypes:ye,_isInputEventSupported:Fe,extractEvents:function(a,b,c,d){var e=b?Pd(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ee;else if(xe(e))if(Fe)g=Le;else{g=Je;var h=Ie}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=Ke);if(g&&(g=g(a,b)))return ze(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Db(e,"number",e.value)}},Ne=G.extend({view:null,detail:null}),
	Oe={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pe(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Oe[a])?!!b[a]:!1}function Qe(){return Pe}
	var Re=0,Se=0,Te=!1,Ue=!1,Ve=Ne.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Qe,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Re;Re=a.screenX;return Te?"mousemove"===a.type?a.screenX-b:0:(Te=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
	var b=Se;Se=a.screenY;return Ue?"mousemove"===a.type?a.screenY-b:0:(Ue=!0,0)}}),We=Ve.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),Xe={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
	dependencies:["pointerout","pointerover"]}},Ye={eventTypes:Xe,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;f=d.window===d?d:(f=d.ownerDocument)?f.defaultView||f.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?tc(b):null,null!==b){var h=dc(b);if(b!==h||5!==b.tag&&6!==b.tag)b=null}}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===
	a){var k=Ve;var l=Xe.mouseLeave;var m=Xe.mouseEnter;var p="mouse"}else if("pointerout"===a||"pointerover"===a)k=We,l=Xe.pointerLeave,m=Xe.pointerEnter,p="pointer";a=null==g?f:Pd(g);f=null==b?f:Pd(b);l=k.getPooled(l,g,c,d);l.type=p+"leave";l.target=a;l.relatedTarget=f;c=k.getPooled(m,b,c,d);c.type=p+"enter";c.target=f;c.relatedTarget=a;d=g;p=b;if(d&&p)a:{k=d;m=p;g=0;for(a=k;a;a=Rd(a))g++;a=0;for(b=m;b;b=Rd(b))a++;for(;0<g-a;)k=Rd(k),g--;for(;0<a-g;)m=Rd(m),a--;for(;g--;){if(k===m||k===m.alternate)break a;
	k=Rd(k);m=Rd(m)}k=null}else k=null;m=k;for(k=[];d&&d!==m;){g=d.alternate;if(null!==g&&g===m)break;k.push(d);d=Rd(d)}for(d=[];p&&p!==m;){g=p.alternate;if(null!==g&&g===m)break;d.push(p);p=Rd(p)}for(p=0;p<k.length;p++)Vd(k[p],"bubbled",l);for(p=d.length;0<p--;)Vd(d[p],"captured",c);return 0===(e&64)?[l]:[l,c]}};function Ze(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var $e="function"===typeof Object.is?Object.is:Ze,af=Object.prototype.hasOwnProperty;
	function bf(a,b){if($e(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!af.call(b,c[d])||!$e(a[c[d]],b[c[d]]))return!1;return!0}
	var cf=ya&&"documentMode"in document&&11>=document.documentMode,df={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ef=null,ff=null,gf=null,hf=!1;
	function jf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(hf||null==ef||ef!==td(c))return null;c=ef;"selectionStart"in c&&yd(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return gf&&bf(gf,c)?null:(gf=c,a=G.getPooled(df.select,ff,a,b),a.type="select",a.target=ef,Xd(a),a)}
	var kf={eventTypes:df,extractEvents:function(a,b,c,d,e,f){e=f||(d.window===d?d.document:9===d.nodeType?d:d.ownerDocument);if(!(f=!e)){a:{e=cc(e);f=wa.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Pd(b):window;switch(a){case "focus":if(xe(e)||"true"===e.contentEditable)ef=e,ff=b,gf=null;break;case "blur":gf=ff=ef=null;break;case "mousedown":hf=!0;break;case "contextmenu":case "mouseup":case "dragend":return hf=!1,jf(c,d);case "selectionchange":if(cf)break;
	case "keydown":case "keyup":return jf(c,d)}return null}},lf=G.extend({animationName:null,elapsedTime:null,pseudoElement:null}),mf=G.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),nf=Ne.extend({relatedTarget:null});function of(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
	var pf={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},qf={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
	116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},rf=Ne.extend({key:function(a){if(a.key){var b=pf[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=of(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?qf[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Qe,charCode:function(a){return"keypress"===
	a.type?of(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?of(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),sf=Ve.extend({dataTransfer:null}),tf=Ne.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Qe}),uf=G.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),vf=Ve.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
	a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),wf={eventTypes:Wc,extractEvents:function(a,b,c,d){var e=Yc.get(a);if(!e)return null;switch(a){case "keypress":if(0===of(c))return null;case "keydown":case "keyup":a=rf;break;case "blur":case "focus":a=nf;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=
	Ve;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=sf;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=tf;break;case Xb:case Yb:case Zb:a=lf;break;case $b:a=uf;break;case "scroll":a=Ne;break;case "wheel":a=vf;break;case "copy":case "cut":case "paste":a=mf;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=
	We;break;default:a=G}b=a.getPooled(e,b,c,d);Xd(b);return b}};if(pa)throw Error(u(101));pa=Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ra();var xf=Nc;la=Qd;ma=xf;na=Pd;xa({SimpleEventPlugin:wf,EnterLeaveEventPlugin:Ye,ChangeEventPlugin:Me,SelectEventPlugin:kf,BeforeInputEventPlugin:ve});var yf=[],zf=-1;function H(a){0>zf||(a.current=yf[zf],yf[zf]=null,zf--)}
	function I(a,b){zf++;yf[zf]=a.current;a.current=b}var Af={},J={current:Af},K={current:!1},Bf=Af;function Cf(a,b){var c=a.type.contextTypes;if(!c)return Af;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
	function Df(){H(K);H(J)}function Ef(a,b,c){if(J.current!==Af)throw Error(u(168));I(J,b);I(K,c)}function Ff(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,pb(b)||"Unknown",e));return n({},c,{},d)}function Gf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Af;Bf=J.current;I(J,a);I(K,K.current);return!0}
	function Hf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(a=Ff(a,b,Bf),d.__reactInternalMemoizedMergedChildContext=a,H(K),H(J),I(J,a)):H(K);I(K,c)}
	var If=r.unstable_runWithPriority,Jf=r.unstable_scheduleCallback,Kf=r.unstable_cancelCallback,Lf=r.unstable_requestPaint,Mf=r.unstable_now,Nf=r.unstable_getCurrentPriorityLevel,Of=r.unstable_ImmediatePriority,Pf=r.unstable_UserBlockingPriority,Qf=r.unstable_NormalPriority,Rf=r.unstable_LowPriority,Sf=r.unstable_IdlePriority,Tf={},Uf=r.unstable_shouldYield,Vf=void 0!==Lf?Lf:function(){},Wf=null,Xf=null,Yf=!1,Zf=Mf(),$f=1E4>Zf?Mf:function(){return Mf()-Zf};
	function ag(){switch(Nf()){case Of:return 99;case Pf:return 98;case Qf:return 97;case Rf:return 96;case Sf:return 95;default:throw Error(u(332));}}function bg(a){switch(a){case 99:return Of;case 98:return Pf;case 97:return Qf;case 96:return Rf;case 95:return Sf;default:throw Error(u(332));}}function cg(a,b){a=bg(a);return If(a,b)}function dg(a,b,c){a=bg(a);return Jf(a,b,c)}function eg(a){null===Wf?(Wf=[a],Xf=Jf(Of,fg)):Wf.push(a);return Tf}function gg(){if(null!==Xf){var a=Xf;Xf=null;Kf(a)}fg()}
	function fg(){if(!Yf&&null!==Wf){Yf=!0;var a=0;try{var b=Wf;cg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Wf=null}catch(c){throw null!==Wf&&(Wf=Wf.slice(a+1)),Jf(Of,gg),c;}finally{Yf=!1}}}function hg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function ig(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var jg={current:null},kg=null,lg=null,mg=null;function ng(){mg=lg=kg=null}
	function og(a){var b=jg.current;H(jg);a.type._context._currentValue=b}function pg(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}function qg(a,b){kg=a;mg=lg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(rg=!0),a.firstContext=null)}
	function sg(a,b){if(mg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)mg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===lg){if(null===kg)throw Error(u(308));lg=b;kg.dependencies={expirationTime:0,firstContext:b,responders:null}}else lg=lg.next=b}return a._currentValue}var tg=!1;function ug(a){a.updateQueue={baseState:a.memoizedState,baseQueue:null,shared:{pending:null},effects:null}}
	function vg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,baseQueue:a.baseQueue,shared:a.shared,effects:a.effects})}function wg(a,b){a={expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null};return a.next=a}function xg(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
	function yg(a,b){var c=a.alternate;null!==c&&vg(c,a);a=a.updateQueue;c=a.baseQueue;null===c?(a.baseQueue=b.next=b,b.next=b):(b.next=c.next,c.next=b)}
	function zg(a,b,c,d){var e=a.updateQueue;tg=!1;var f=e.baseQueue,g=e.shared.pending;if(null!==g){if(null!==f){var h=f.next;f.next=g.next;g.next=h}f=g;e.shared.pending=null;h=a.alternate;null!==h&&(h=h.updateQueue,null!==h&&(h.baseQueue=g))}if(null!==f){h=f.next;var k=e.baseState,l=0,m=null,p=null,x=null;if(null!==h){var z=h;do{g=z.expirationTime;if(g<d){var ca={expirationTime:z.expirationTime,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null};null===x?(p=x=
	ca,m=k):x=x.next=ca;g>l&&(l=g)}else{null!==x&&(x=x.next={expirationTime:1073741823,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null});Ag(g,z.suspenseConfig);a:{var D=a,t=z;g=b;ca=c;switch(t.tag){case 1:D=t.payload;if("function"===typeof D){k=D.call(ca,k,g);break a}k=D;break a;case 3:D.effectTag=D.effectTag&-4097|64;case 0:D=t.payload;g="function"===typeof D?D.call(ca,k,g):D;if(null===g||void 0===g)break a;k=n({},k,g);break a;case 2:tg=!0}}null!==z.callback&&
	(a.effectTag|=32,g=e.effects,null===g?e.effects=[z]:g.push(z))}z=z.next;if(null===z||z===h)if(g=e.shared.pending,null===g)break;else z=f.next=g.next,g.next=h,e.baseQueue=f=g,e.shared.pending=null}while(1)}null===x?m=k:x.next=p;e.baseState=m;e.baseQueue=x;Bg(l);a.expirationTime=l;a.memoizedState=k}}
	function Cg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=e;e=c;if("function"!==typeof d)throw Error(u(191,d));d.call(e)}}}var Dg=Wa.ReactCurrentBatchConfig,Eg=(new aa.Component).refs;function Fg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;0===a.expirationTime&&(a.updateQueue.baseState=c)}
	var Jg={isMounted:function(a){return(a=a._reactInternalFiber)?dc(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Gg(),d=Dg.suspense;
	c=Hg(c,a,d);d=wg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);xg(a,d);Ig(a,c)}};function Kg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!bf(c,d)||!bf(e,f):!0}
	function Lg(a,b,c){var d=!1,e=Af;var f=b.contextType;"object"===typeof f&&null!==f?f=sg(f):(e=L(b)?Bf:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Cf(a,e):Af);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Jg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
	function Mg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Jg.enqueueReplaceState(b,b.state,null)}
	function Ng(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Eg;ug(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=sg(f):(f=L(b)?Bf:J.current,e.context=Cf(a,f));zg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Fg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
	(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Jg.enqueueReplaceState(e,e.state,null),zg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Og=Array.isArray;
	function Pg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Eg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
	function Qg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
	function Rg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Sg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
	2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Tg(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Pg(a,b,c),d.return=a,d;d=Ug(c.type,c.key,c.props,null,a.mode,d);d.ref=Pg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
	c.implementation)return b=Vg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Wg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Tg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Za:return c=Ug(b.type,b.key,b.props,null,a.mode,c),c.ref=Pg(a,null,b),c.return=a,c;case $a:return b=Vg(b,a.mode,c),b.return=a,b}if(Og(b)||
	nb(b))return b=Wg(b,a.mode,c,null),b.return=a,b;Qg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Za:return c.key===e?c.type===ab?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case $a:return c.key===e?l(a,b,c,d):null}if(Og(c)||nb(c))return null!==e?null:m(a,b,c,d,null);Qg(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
	a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Za:return a=a.get(null===d.key?c:d.key)||null,d.type===ab?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case $a:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Og(d)||nb(d))return a=a.get(c)||null,m(b,a,d,e,null);Qg(b,d)}return null}function ca(e,g,h,k){for(var l=null,t=null,m=g,y=g=0,A=null;null!==m&&y<h.length;y++){m.index>y?(A=m,m=null):A=m.sibling;var q=x(e,m,h[y],k);if(null===q){null===m&&(m=A);break}a&&
	m&&null===q.alternate&&b(e,m);g=f(q,g,y);null===t?l=q:t.sibling=q;t=q;m=A}if(y===h.length)return c(e,m),l;if(null===m){for(;y<h.length;y++)m=p(e,h[y],k),null!==m&&(g=f(m,g,y),null===t?l=m:t.sibling=m,t=m);return l}for(m=d(e,m);y<h.length;y++)A=z(m,e,y,h[y],k),null!==A&&(a&&null!==A.alternate&&m.delete(null===A.key?y:A.key),g=f(A,g,y),null===t?l=A:t.sibling=A,t=A);a&&m.forEach(function(a){return b(e,a)});return l}function D(e,g,h,l){var k=nb(h);if("function"!==typeof k)throw Error(u(150));h=k.call(h);
	if(null==h)throw Error(u(151));for(var m=k=null,t=g,y=g=0,A=null,q=h.next();null!==t&&!q.done;y++,q=h.next()){t.index>y?(A=t,t=null):A=t.sibling;var D=x(e,t,q.value,l);if(null===D){null===t&&(t=A);break}a&&t&&null===D.alternate&&b(e,t);g=f(D,g,y);null===m?k=D:m.sibling=D;m=D;t=A}if(q.done)return c(e,t),k;if(null===t){for(;!q.done;y++,q=h.next())q=p(e,q.value,l),null!==q&&(g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);return k}for(t=d(e,t);!q.done;y++,q=h.next())q=z(t,e,y,q.value,l),null!==q&&(a&&null!==
	q.alternate&&t.delete(null===q.key?y:q.key),g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);a&&t.forEach(function(a){return b(e,a)});return k}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ab&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Za:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ab){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,
	k.sibling);d=e(k,f.props);d.ref=Pg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ab?(d=Wg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ug(f.type,f.key,f.props,null,a.mode,h),h.ref=Pg(a,d,f),h.return=a,a=h)}return g(a);case $a:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=
	d.sibling}d=Vg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Tg(f,a.mode,h),d.return=a,a=d),g(a);if(Og(f))return ca(a,d,f,h);if(nb(f))return D(a,d,f,h);l&&Qg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var Xg=Rg(!0),Yg=Rg(!1),Zg={},$g={current:Zg},ah={current:Zg},bh={current:Zg};
	function ch(a){if(a===Zg)throw Error(u(174));return a}function dh(a,b){I(bh,b);I(ah,a);I($g,Zg);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ob(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=Ob(b,a)}H($g);I($g,b)}function eh(){H($g);H(ah);H(bh)}function fh(a){ch(bh.current);var b=ch($g.current);var c=Ob(b,a.type);b!==c&&(I(ah,a),I($g,c))}function gh(a){ah.current===a&&(H($g),H(ah))}var M={current:0};
	function hh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===Bd||c.data===Cd))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function ih(a,b){return{responder:a,props:b}}
	var jh=Wa.ReactCurrentDispatcher,kh=Wa.ReactCurrentBatchConfig,lh=0,N=null,O=null,P=null,mh=!1;function Q(){throw Error(u(321));}function nh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!$e(a[c],b[c]))return!1;return!0}
	function oh(a,b,c,d,e,f){lh=f;N=b;b.memoizedState=null;b.updateQueue=null;b.expirationTime=0;jh.current=null===a||null===a.memoizedState?ph:qh;a=c(d,e);if(b.expirationTime===lh){f=0;do{b.expirationTime=0;if(!(25>f))throw Error(u(301));f+=1;P=O=null;b.updateQueue=null;jh.current=rh;a=c(d,e)}while(b.expirationTime===lh)}jh.current=sh;b=null!==O&&null!==O.next;lh=0;P=O=N=null;mh=!1;if(b)throw Error(u(300));return a}
	function th(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===P?N.memoizedState=P=a:P=P.next=a;return P}function uh(){if(null===O){var a=N.alternate;a=null!==a?a.memoizedState:null}else a=O.next;var b=null===P?N.memoizedState:P.next;if(null!==b)P=b,O=a;else{if(null===a)throw Error(u(310));O=a;a={memoizedState:O.memoizedState,baseState:O.baseState,baseQueue:O.baseQueue,queue:O.queue,next:null};null===P?N.memoizedState=P=a:P=P.next=a}return P}
	function vh(a,b){return"function"===typeof b?b(a):b}
	function wh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=O,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.expirationTime;if(l<lh){var m={expirationTime:k.expirationTime,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null};null===h?(g=h=m,f=d):h=h.next=m;l>N.expirationTime&&
	(N.expirationTime=l,Bg(l))}else null!==h&&(h=h.next={expirationTime:1073741823,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),Ag(l,k.suspenseConfig),d=k.eagerReducer===a?k.eagerState:a(d,k.action);k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;$e(d,b.memoizedState)||(rg=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
	function xh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);$e(f,b.memoizedState)||(rg=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
	function yh(a){var b=th();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:vh,lastRenderedState:a};a=a.dispatch=zh.bind(null,N,a);return[b.memoizedState,a]}function Ah(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=N.updateQueue;null===b?(b={lastEffect:null},N.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}
	function Bh(){return uh().memoizedState}function Ch(a,b,c,d){var e=th();N.effectTag|=a;e.memoizedState=Ah(1|b,c,void 0,void 0===d?null:d)}function Dh(a,b,c,d){var e=uh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&nh(d,g.deps)){Ah(b,c,f,d);return}}N.effectTag|=a;e.memoizedState=Ah(1|b,c,f,d)}function Eh(a,b){return Ch(516,4,a,b)}function Fh(a,b){return Dh(516,4,a,b)}function Gh(a,b){return Dh(4,2,a,b)}
	function Hh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Ih(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Dh(4,2,Hh.bind(null,b,a),c)}function Jh(){}function Kh(a,b){th().memoizedState=[a,void 0===b?null:b];return a}function Lh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
	function Mh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function Nh(a,b,c){var d=ag();cg(98>d?98:d,function(){a(!0)});cg(97<d?97:d,function(){var d=kh.suspense;kh.suspense=void 0===b?null:b;try{a(!1),c()}finally{kh.suspense=d}})}
	function zh(a,b,c){var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e={expirationTime:d,suspenseConfig:e,action:c,eagerReducer:null,eagerState:null,next:null};var f=b.pending;null===f?e.next=e:(e.next=f.next,f.next=e);b.pending=e;f=a.alternate;if(a===N||null!==f&&f===N)mh=!0,e.expirationTime=lh,N.expirationTime=lh;else{if(0===a.expirationTime&&(null===f||0===f.expirationTime)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.eagerReducer=f;e.eagerState=h;if($e(h,g))return}catch(k){}finally{}Ig(a,
	d)}}
	var sh={readContext:sg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},ph={readContext:sg,useCallback:Kh,useContext:sg,useEffect:Eh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Ch(4,2,Hh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Ch(4,2,a,b)},useMemo:function(a,b){var c=th();b=void 0===b?null:b;a=a();c.memoizedState=[a,
	b];return a},useReducer:function(a,b,c){var d=th();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=zh.bind(null,N,a);return[d.memoizedState,a]},useRef:function(a){var b=th();a={current:a};return b.memoizedState=a},useState:yh,useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=yh(a),d=c[0],e=c[1];Eh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=
	c}},[a,b]);return d},useTransition:function(a){var b=yh(!1),c=b[0];b=b[1];return[Kh(Nh.bind(null,b,a),[b,a]),c]}},qh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:wh,useRef:Bh,useState:function(){return wh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=wh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=
	wh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,b,a),[b,a]),c]}},rh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:xh,useRef:Bh,useState:function(){return xh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=xh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=xh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,
	b,a),[b,a]),c]}},Oh=null,Ph=null,Qh=!1;function Rh(a,b){var c=Sh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
	function Th(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
	function Uh(a){if(Qh){var b=Ph;if(b){var c=b;if(!Th(a,b)){b=Jd(c.nextSibling);if(!b||!Th(a,b)){a.effectTag=a.effectTag&-1025|2;Qh=!1;Oh=a;return}Rh(Oh,c)}Oh=a;Ph=Jd(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,Qh=!1,Oh=a}}function Vh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;Oh=a}
	function Wh(a){if(a!==Oh)return!1;if(!Qh)return Vh(a),Qh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Gd(b,a.memoizedProps))for(b=Ph;b;)Rh(a,b),b=Jd(b.nextSibling);Vh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===Ad){if(0===b){Ph=Jd(a.nextSibling);break a}b--}else c!==zd&&c!==Cd&&c!==Bd||b++}a=a.nextSibling}Ph=null}}else Ph=Oh?Jd(a.stateNode.nextSibling):null;return!0}
	function Xh(){Ph=Oh=null;Qh=!1}var Yh=Wa.ReactCurrentOwner,rg=!1;function R(a,b,c,d){b.child=null===a?Yg(b,null,c,d):Xg(b,a.child,c,d)}function Zh(a,b,c,d,e){c=c.render;var f=b.ref;qg(b,e);d=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
	function ai(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!bi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ci(a,b,g,d,e,f);a=Ug(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:bf,c(e,d)&&a.ref===b.ref))return $h(a,b,f);b.effectTag|=1;a=Sg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
	function ci(a,b,c,d,e,f){return null!==a&&bf(a.memoizedProps,d)&&a.ref===b.ref&&(rg=!1,e<f)?(b.expirationTime=a.expirationTime,$h(a,b,f)):di(a,b,c,d,f)}function ei(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function di(a,b,c,d,e){var f=L(c)?Bf:J.current;f=Cf(b,f);qg(b,e);c=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
	function fi(a,b,c,d,e){if(L(c)){var f=!0;Gf(b)}else f=!1;qg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Lg(b,c,d),Ng(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
	"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l);tg=!1;var x=b.memoizedState;g.state=x;zg(b,d,g,e);k=b.memoizedState;h!==d||x!==k||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),k=b.memoizedState),(h=tg||Kg(b,c,h,d,x,k,l))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
	typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,vg(a,b),h=b.memoizedProps,g.props=b.type===b.elementType?h:ig(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l)),m=c.getDerivedStateFromProps,(p="function"===typeof m||"function"===
	typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l),tg=!1,k=b.memoizedState,g.state=k,zg(b,d,g,e),x=b.memoizedState,h!==d||k!==x||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),x=b.memoizedState),(m=tg||Kg(b,c,h,d,k,x,l))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
	x,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=l,d=m):
	("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return gi(a,b,c,d,f,e)}
	function gi(a,b,c,d,e,f){ei(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Hf(b,c,!1),$h(a,b,f);d=b.stateNode;Yh.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Xg(b,a.child,null,f),b.child=Xg(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Hf(b,c,!0);return b.child}function hi(a){var b=a.stateNode;b.pendingContext?Ef(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ef(a,b.context,!1);dh(a,b.containerInfo)}
	var ii={dehydrated:null,retryTime:0};
	function ji(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1);if(null===a){void 0!==e.fallback&&Uh(b);if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=
	b;e.sibling=c;b.memoizedState=ii;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=Yg(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=Sg(a,a.pendingProps);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=Sg(d,e);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=ii;b.child=c;return d}c=Xg(b,a.child,e.children,c);b.memoizedState=null;return b.child=
	c}a=a.child;if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=ii;b.child=e;return c}b.memoizedState=null;return b.child=Xg(b,a,e.children,c)}
	function ki(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);pg(a.return,b)}function li(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
	function mi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&ki(a,c);else if(19===a.tag)ki(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d);if(0===(b.mode&2))b.memoizedState=
	null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===hh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);li(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===hh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}li(b,!0,c,null,f,b.lastEffect);break;case "together":li(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
	function $h(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Bg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=Sg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Sg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}var ni,oi,pi,qi;
	ni=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};oi=function(){};
	pi=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;ch($g.current);a=null;switch(c){case "input":f=zb(g,f);d=zb(g,d);a=[];break;case "option":f=Gb(g,f);d=Gb(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Ib(g,f);d=Ib(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=sd)}od(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
	h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(va.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
	c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(va.hasOwnProperty(h)?(null!=l&&rd(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;if(b.updateQueue=e)b.effectTag|=4}};
	qi=function(a,b,c,d){c!==d&&(b.effectTag|=4)};function ri(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
	function si(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return L(b.type)&&Df(),null;case 3:return eh(),H(K),H(J),c=b.stateNode,c.pendingContext&&(c.context=c.pendingContext,c.pendingContext=null),null!==a&&null!==a.child||!Wh(b)||(b.effectTag|=4),oi(b),null;case 5:gh(b);c=ch(bh.current);var e=b.type;if(null!==a&&null!=b.stateNode)pi(a,b,e,d,c),a.ref!==b.ref&&(b.effectTag|=128);else{if(!d){if(null===b.stateNode)throw Error(u(166));
	return null}a=ch($g.current);if(Wh(b)){d=b.stateNode;e=b.type;var f=b.memoizedProps;d[Md]=b;d[Nd]=f;switch(e){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(a=0;a<ac.length;a++)F(ac[a],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Ab(d,f);F("invalid",d);rd(c,"onChange");break;case "select":d._wrapperState=
	{wasMultiple:!!f.multiple};F("invalid",d);rd(c,"onChange");break;case "textarea":Jb(d,f),F("invalid",d),rd(c,"onChange")}od(e,f);a=null;for(var g in f)if(f.hasOwnProperty(g)){var h=f[g];"children"===g?"string"===typeof h?d.textContent!==h&&(a=["children",h]):"number"===typeof h&&d.textContent!==""+h&&(a=["children",""+h]):va.hasOwnProperty(g)&&null!=h&&rd(c,g)}switch(e){case "input":xb(d);Eb(d,f,!0);break;case "textarea":xb(d);Lb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&
	(d.onclick=sd)}c=a;b.updateQueue=c;null!==c&&(b.effectTag|=4)}else{g=9===c.nodeType?c:c.ownerDocument;a===qd&&(a=Nb(e));a===qd?"script"===e?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(e,{is:d.is}):(a=g.createElement(e),"select"===e&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,e);a[Md]=b;a[Nd]=d;ni(a,b,!1,!1);b.stateNode=a;g=pd(e,d);switch(e){case "iframe":case "object":case "embed":F("load",
	a);h=d;break;case "video":case "audio":for(h=0;h<ac.length;h++)F(ac[h],a);h=d;break;case "source":F("error",a);h=d;break;case "img":case "image":case "link":F("error",a);F("load",a);h=d;break;case "form":F("reset",a);F("submit",a);h=d;break;case "details":F("toggle",a);h=d;break;case "input":Ab(a,d);h=zb(a,d);F("invalid",a);rd(c,"onChange");break;case "option":h=Gb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};h=n({},d,{value:void 0});F("invalid",a);rd(c,"onChange");break;case "textarea":Jb(a,
	d);h=Ib(a,d);F("invalid",a);rd(c,"onChange");break;default:h=d}od(e,h);var k=h;for(f in k)if(k.hasOwnProperty(f)){var l=k[f];"style"===f?md(a,l):"dangerouslySetInnerHTML"===f?(l=l?l.__html:void 0,null!=l&&Qb(a,l)):"children"===f?"string"===typeof l?("textarea"!==e||""!==l)&&Rb(a,l):"number"===typeof l&&Rb(a,""+l):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(va.hasOwnProperty(f)?null!=l&&rd(c,f):null!=l&&Xa(a,f,l,g))}switch(e){case "input":xb(a);Eb(a,d,!1);
	break;case "textarea":xb(a);Lb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+rb(d.value));break;case "select":a.multiple=!!d.multiple;c=d.value;null!=c?Hb(a,!!d.multiple,c,!1):null!=d.defaultValue&&Hb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof h.onClick&&(a.onclick=sd)}Fd(e,d)&&(b.effectTag|=4)}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)qi(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(u(166));
	c=ch(bh.current);ch($g.current);Wh(b)?(c=b.stateNode,d=b.memoizedProps,c[Md]=b,c.nodeValue!==d&&(b.effectTag|=4)):(c=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),c[Md]=b,b.stateNode=c)}return null;case 13:H(M);d=b.memoizedState;if(0!==(b.effectTag&64))return b.expirationTime=c,b;c=null!==d;d=!1;null===a?void 0!==b.memoizedProps.fallback&&Wh(b):(e=a.memoizedState,d=null!==e,c||null===e||(e=a.child.sibling,null!==e&&(f=b.firstEffect,null!==f?(b.firstEffect=e,e.nextEffect=f):(b.firstEffect=b.lastEffect=
	e,e.nextEffect=null),e.effectTag=8)));if(c&&!d&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))S===ti&&(S=ui);else{if(S===ti||S===ui)S=vi;0!==wi&&null!==T&&(xi(T,U),yi(T,wi))}if(c||d)b.effectTag|=4;return null;case 4:return eh(),oi(b),null;case 10:return og(b),null;case 17:return L(b.type)&&Df(),null;case 19:H(M);d=b.memoizedState;if(null===d)return null;e=0!==(b.effectTag&64);f=d.rendering;if(null===f)if(e)ri(d,!1);else{if(S!==ti||null!==a&&0!==(a.effectTag&
	64))for(f=b.child;null!==f;){a=hh(f);if(null!==a){b.effectTag|=64;ri(d,!1);e=a.updateQueue;null!==e&&(b.updateQueue=e,b.effectTag|=4);null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;for(d=b.child;null!==d;)e=d,f=c,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,a=e.alternate,null===a?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=a.childExpirationTime,
	e.expirationTime=a.expirationTime,e.child=a.child,e.memoizedProps=a.memoizedProps,e.memoizedState=a.memoizedState,e.updateQueue=a.updateQueue,f=a.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),d=d.sibling;I(M,M.current&1|2);return b.child}f=f.sibling}}else{if(!e)if(a=hh(f),null!==a){if(b.effectTag|=64,e=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.effectTag|=4),ri(d,!0),null===d.tail&&"hidden"===d.tailMode&&!f.alternate)return b=
	b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*$f()-d.renderingStartTime>d.tailExpiration&&1<c&&(b.effectTag|=64,e=!0,ri(d,!1),b.expirationTime=b.childExpirationTime=c-1);d.isBackwards?(f.sibling=b.child,b.child=f):(c=d.last,null!==c?c.sibling=f:b.child=f,d.last=f)}return null!==d.tail?(0===d.tailExpiration&&(d.tailExpiration=$f()+500),c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=$f(),c.sibling=null,b=M.current,I(M,e?b&1|2:b&1),c):null}throw Error(u(156,
	b.tag));}function zi(a){switch(a.tag){case 1:L(a.type)&&Df();var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:eh();H(K);H(J);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return gh(a),null;case 13:return H(M),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return H(M),null;case 4:return eh(),null;case 10:return og(a),null;default:return null}}function Ai(a,b){return{value:a,source:b,stack:qb(b)}}
	var Bi="function"===typeof WeakSet?WeakSet:Set;function Ci(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=qb(c));null!==c&&pb(c.type);b=b.value;null!==a&&1===a.tag&&pb(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Di(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ei(a,c)}}function Fi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ei(a,c)}else b.current=null}
	function Gi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:ig(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:case 5:case 6:case 4:case 17:return}throw Error(u(163));}
	function Hi(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.destroy;c.destroy=void 0;void 0!==d&&d()}c=c.next}while(c!==b)}}function Ii(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d()}c=c.next}while(c!==b)}}
	function Ji(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:Ii(3,c);return;case 1:a=c.stateNode;if(c.effectTag&4)if(null===b)a.componentDidMount();else{var d=c.elementType===c.type?b.memoizedProps:ig(c.type,b.memoizedProps);a.componentDidUpdate(d,b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)}b=c.updateQueue;null!==b&&Cg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Cg(c,b,a)}return;
	case 5:a=c.stateNode;null===b&&c.effectTag&4&&Fd(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Vc(c))));return;case 19:case 17:case 20:case 21:return}throw Error(u(163));}
	function Ki(a,b,c){"function"===typeof Li&&Li(b);switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;cg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ei(g,h)}}a=a.next}while(a!==d)})}break;case 1:Fi(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Di(b,c);break;case 5:Fi(b);break;case 4:Mi(a,b,c)}}
	function Ni(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;a.stateNode=null;null!==b&&Ni(b)}function Oi(a){return 5===a.tag||3===a.tag||4===a.tag}
	function Pi(a){a:{for(var b=a.return;null!==b;){if(Oi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Rb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Oi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
	if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}d?Qi(a,c,b):Ri(a,c,b)}
	function Qi(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=sd));else if(4!==d&&(a=a.child,null!==a))for(Qi(a,b,c),a=a.sibling;null!==a;)Qi(a,b,c),a=a.sibling}
	function Ri(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(Ri(a,b,c),a=a.sibling;null!==a;)Ri(a,b,c),a=a.sibling}
	function Mi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Ki(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break a;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
	f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Ki(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
	function Si(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:Hi(3,b);return;case 1:return;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Nd]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Bb(c,d);pd(a,e);b=pd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?md(c,h):"dangerouslySetInnerHTML"===g?Qb(c,h):"children"===g?Rb(c,h):Xa(c,g,h,b)}switch(a){case "input":Cb(c,d);break;
	case "textarea":Kb(c,d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Hb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Hb(c,!!d.multiple,d.defaultValue,!0):Hb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;return;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Vc(b.containerInfo));return;case 12:return;case 13:c=b;null===b.memoizedState?
	d=!1:(d=!0,c=b.child,Ti=$f());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ld("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=
	f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}Ui(b);return;case 19:Ui(b);return;case 17:return}throw Error(u(163));}function Ui(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Bi);b.forEach(function(b){var d=Vi.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
	var Wi="function"===typeof WeakMap?WeakMap:Map;function Xi(a,b,c){c=wg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Yi||(Yi=!0,Zi=d);Ci(a,b)};return c}
	function $i(a,b,c){c=wg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ci(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===aj?aj=new Set([this]):aj.add(this),Ci(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
	var bj=Math.ceil,cj=Wa.ReactCurrentDispatcher,dj=Wa.ReactCurrentOwner,V=0,ej=8,fj=16,gj=32,ti=0,hj=1,ij=2,ui=3,vi=4,jj=5,W=V,T=null,X=null,U=0,S=ti,kj=null,lj=1073741823,mj=1073741823,nj=null,wi=0,oj=!1,Ti=0,pj=500,Y=null,Yi=!1,Zi=null,aj=null,qj=!1,rj=null,sj=90,tj=null,uj=0,vj=null,wj=0;function Gg(){return(W&(fj|gj))!==V?1073741821-($f()/10|0):0!==wj?wj:wj=1073741821-($f()/10|0)}
	function Hg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=ag();if(0===(b&4))return 99===d?1073741823:1073741822;if((W&fj)!==V)return U;if(null!==c)a=hg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=hg(a,150,100);break;case 97:case 96:a=hg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==T&&a===U&&--a;return a}
	function Ig(a,b){if(50<uj)throw uj=0,vj=null,Error(u(185));a=xj(a,b);if(null!==a){var c=ag();1073741823===b?(W&ej)!==V&&(W&(fj|gj))===V?yj(a):(Z(a),W===V&&gg()):Z(a);(W&4)===V||98!==c&&99!==c||(null===tj?tj=new Map([[a,b]]):(c=tj.get(a),(void 0===c||c>b)&&tj.set(a,b)))}}
	function xj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(T===e&&(Bg(b),S===vi&&xi(e,U)),yi(e,b));return e}
	function zj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Aj(a,b))return b;var c=a.lastPingedTime;a=a.nextKnownPendingLevel;a=c>a?c:a;return 2>=a&&b!==a?0:a}
	function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=eg(yj.bind(null,a));else{var b=zj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Gg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Tf&&Kf(c)}a.callbackExpirationTime=
	b;a.callbackPriority=d;b=1073741823===b?eg(yj.bind(null,a)):dg(d,Bj.bind(null,a),{timeout:10*(1073741821-b)-$f()});a.callbackNode=b}}}
	function Bj(a,b){wj=0;if(b)return b=Gg(),Cj(a,b),Z(a),null;var c=zj(a);if(0!==c){b=a.callbackNode;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&c===U||Ej(a,c);if(null!==X){var d=W;W|=fj;var e=Fj();do try{Gj();break}catch(h){Hj(a,h)}while(1);ng();W=d;cj.current=e;if(S===hj)throw b=kj,Ej(a,c),xi(a,c),Z(a),b;if(null===X)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=S,T=null,d){case ti:case hj:throw Error(u(345));case ij:Cj(a,2<c?2:c);break;case ui:xi(a,c);d=a.lastSuspendedTime;
	c===d&&(a.nextKnownPendingLevel=Ij(e));if(1073741823===lj&&(e=Ti+pj-$f(),10<e)){if(oj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Ej(a,c);break}}f=zj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=Hd(Jj.bind(null,a),e);break}Jj(a);break;case vi:xi(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Ij(e));if(oj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Ej(a,c);break}e=zj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
	d;break}1073741823!==mj?d=10*(1073741821-mj)-$f():1073741823===lj?d=0:(d=10*(1073741821-lj)-5E3,e=$f(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*bj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=Hd(Jj.bind(null,a),d);break}Jj(a);break;case jj:if(1073741823!==lj&&null!==nj){f=lj;var g=nj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=$f()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){xi(a,c);a.timeoutHandle=
	Hd(Jj.bind(null,a),d);break}}Jj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Bj.bind(null,a)}}return null}
	function yj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&b===U||Ej(a,b);if(null!==X){var c=W;W|=fj;var d=Fj();do try{Kj();break}catch(e){Hj(a,e)}while(1);ng();W=c;cj.current=d;if(S===hj)throw c=kj,Ej(a,b),xi(a,b),Z(a),c;if(null!==X)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;T=null;Jj(a);Z(a)}return null}function Lj(){if(null!==tj){var a=tj;tj=null;a.forEach(function(a,c){Cj(c,a);Z(c)});gg()}}
	function Mj(a,b){var c=W;W|=1;try{return a(b)}finally{W=c,W===V&&gg()}}function Nj(a,b){var c=W;W&=-2;W|=ej;try{return a(b)}finally{W=c,W===V&&gg()}}
	function Ej(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Id(c));if(null!==X)for(c=X.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Df();break;case 3:eh();H(K);H(J);break;case 5:gh(d);break;case 4:eh();break;case 13:H(M);break;case 19:H(M);break;case 10:og(d)}c=c.return}T=a;X=Sg(a.current,null);U=b;S=ti;kj=null;mj=lj=1073741823;nj=null;wi=0;oj=!1}
	function Hj(a,b){do{try{ng();jh.current=sh;if(mh)for(var c=N.memoizedState;null!==c;){var d=c.queue;null!==d&&(d.pending=null);c=c.next}lh=0;P=O=N=null;mh=!1;if(null===X||null===X.return)return S=hj,kj=b,X=null;a:{var e=a,f=X.return,g=X,h=b;b=U;g.effectTag|=2048;g.firstEffect=g.lastEffect=null;if(null!==h&&"object"===typeof h&&"function"===typeof h.then){var k=h;if(0===(g.mode&2)){var l=g.alternate;l?(g.updateQueue=l.updateQueue,g.memoizedState=l.memoizedState,g.expirationTime=l.expirationTime):(g.updateQueue=
	null,g.memoizedState=null)}var m=0!==(M.current&1),p=f;do{var x;if(x=13===p.tag){var z=p.memoizedState;if(null!==z)x=null!==z.dehydrated?!0:!1;else{var ca=p.memoizedProps;x=void 0===ca.fallback?!1:!0!==ca.unstable_avoidThisFallback?!0:m?!1:!0}}if(x){var D=p.updateQueue;if(null===D){var t=new Set;t.add(k);p.updateQueue=t}else D.add(k);if(0===(p.mode&2)){p.effectTag|=64;g.effectTag&=-2981;if(1===g.tag)if(null===g.alternate)g.tag=17;else{var y=wg(1073741823,null);y.tag=2;xg(g,y)}g.expirationTime=1073741823;
	break a}h=void 0;g=b;var A=e.pingCache;null===A?(A=e.pingCache=new Wi,h=new Set,A.set(k,h)):(h=A.get(k),void 0===h&&(h=new Set,A.set(k,h)));if(!h.has(g)){h.add(g);var q=Oj.bind(null,e,k,g);k.then(q,q)}p.effectTag|=4096;p.expirationTime=b;break a}p=p.return}while(null!==p);h=Error((pb(g.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+qb(g))}S!==
	jj&&(S=ij);h=Ai(h,g);p=f;do{switch(p.tag){case 3:k=h;p.effectTag|=4096;p.expirationTime=b;var B=Xi(p,k,b);yg(p,B);break a;case 1:k=h;var w=p.type,ub=p.stateNode;if(0===(p.effectTag&64)&&("function"===typeof w.getDerivedStateFromError||null!==ub&&"function"===typeof ub.componentDidCatch&&(null===aj||!aj.has(ub)))){p.effectTag|=4096;p.expirationTime=b;var vb=$i(p,k,b);yg(p,vb);break a}}p=p.return}while(null!==p)}X=Pj(X)}catch(Xc){b=Xc;continue}break}while(1)}
	function Fj(){var a=cj.current;cj.current=sh;return null===a?sh:a}function Ag(a,b){a<lj&&2<a&&(lj=a);null!==b&&a<mj&&2<a&&(mj=a,nj=b)}function Bg(a){a>wi&&(wi=a)}function Kj(){for(;null!==X;)X=Qj(X)}function Gj(){for(;null!==X&&!Uf();)X=Qj(X)}function Qj(a){var b=Rj(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=Pj(a));dj.current=null;return b}
	function Pj(a){X=a;do{var b=X.alternate;a=X.return;if(0===(X.effectTag&2048)){b=si(b,X,U);if(1===U||1!==X.childExpirationTime){for(var c=0,d=X.child;null!==d;){var e=d.expirationTime,f=d.childExpirationTime;e>c&&(c=e);f>c&&(c=f);d=d.sibling}X.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=X.firstEffect),null!==X.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=X.firstEffect),a.lastEffect=X.lastEffect),1<X.effectTag&&(null!==
	a.lastEffect?a.lastEffect.nextEffect=X:a.firstEffect=X,a.lastEffect=X))}else{b=zi(X);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=X.sibling;if(null!==b)return b;X=a}while(null!==X);S===ti&&(S=jj);return null}function Ij(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Jj(a){var b=ag();cg(99,Sj.bind(null,a,b));return null}
	function Sj(a,b){do Dj();while(null!==rj);if((W&(fj|gj))!==V)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Ij(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
	d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===T&&(X=T=null,U=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=W;W|=gj;dj.current=null;Dd=fd;var g=xd();if(yd(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
	m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(wb){h=null;break a}var p=0,x=-1,z=-1,ca=0,D=0,t=g,y=null;b:for(;;){for(var A;;){t!==h||0!==l&&3!==t.nodeType||(x=p+l);t!==m||0!==k&&3!==t.nodeType||(z=p+k);3===t.nodeType&&(p+=t.nodeValue.length);if(null===(A=t.firstChild))break;y=t;t=A}for(;;){if(t===g)break b;y===h&&++ca===l&&(x=p);y===m&&++D===k&&(z=p);if(null!==(A=t.nextSibling))break;t=y;y=t.parentNode}t=A}h=-1===x||-1===z?null:{start:x,end:z}}else h=null}h=h||{start:0,end:0}}else h=
	null;Ed={activeElementDetached:null,focusedElem:g,selectionRange:h};fd=!1;Y=e;do try{Tj()}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var q=Y.effectTag;q&16&&Rb(Y.stateNode,"");if(q&128){var B=Y.alternate;if(null!==B){var w=B.ref;null!==w&&("function"===typeof w?w(null):w.current=null)}}switch(q&1038){case 2:Pi(Y);Y.effectTag&=-3;break;case 6:Pi(Y);Y.effectTag&=-3;Si(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=
	-1025;Si(Y.alternate,Y);break;case 4:Si(Y.alternate,Y);break;case 8:l=Y,Mi(g,l,h),Ni(l)}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);w=Ed;B=xd();q=w.focusedElem;h=w.selectionRange;if(B!==q&&q&&q.ownerDocument&&wd(q.ownerDocument.documentElement,q)){null!==h&&yd(q)&&(B=h.start,w=h.end,void 0===w&&(w=B),"selectionStart"in q?(q.selectionStart=B,q.selectionEnd=Math.min(w,q.value.length)):(w=(B=q.ownerDocument||document)&&B.defaultView||window,w.getSelection&&
	(w=w.getSelection(),l=q.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!w.extend&&g>h&&(l=h,h=g,g=l),l=vd(q,g),m=vd(q,h),l&&m&&(1!==w.rangeCount||w.anchorNode!==l.node||w.anchorOffset!==l.offset||w.focusNode!==m.node||w.focusOffset!==m.offset)&&(B=B.createRange(),B.setStart(l.node,l.offset),w.removeAllRanges(),g>h?(w.addRange(B),w.extend(m.node,m.offset)):(B.setEnd(m.node,m.offset),w.addRange(B))))));B=[];for(w=q;w=w.parentNode;)1===w.nodeType&&B.push({element:w,left:w.scrollLeft,
	top:w.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<B.length;q++)w=B[q],w.element.scrollLeft=w.left,w.element.scrollTop=w.top}fd=!!Dd;Ed=Dd=null;a.current=c;Y=e;do try{for(q=a;null!==Y;){var ub=Y.effectTag;ub&36&&Ji(q,Y.alternate,Y);if(ub&128){B=void 0;var vb=Y.ref;if(null!==vb){var Xc=Y.stateNode;switch(Y.tag){case 5:B=Xc;break;default:B=Xc}"function"===typeof vb?vb(B):vb.current=B}}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=
	null;Vf();W=f}else a.current=c;if(qj)qj=!1,rj=a,sj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(aj=null);1073741823===b?a===vj?uj++:(uj=0,vj=a):uj=0;"function"===typeof Uj&&Uj(c.stateNode,d);Z(a);if(Yi)throw Yi=!1,a=Zi,Zi=null,a;if((W&ej)!==V)return null;gg();return null}function Tj(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Gi(Y.alternate,Y);0===(a&512)||qj||(qj=!0,dg(97,function(){Dj();return null}));Y=Y.nextEffect}}
	function Dj(){if(90!==sj){var a=97<sj?97:sj;sj=90;return cg(a,Vj)}}function Vj(){if(null===rj)return!1;var a=rj;rj=null;if((W&(fj|gj))!==V)throw Error(u(331));var b=W;W|=gj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:case 22:Hi(5,c),Ii(5,c)}}catch(d){if(null===a)throw Error(u(330));Ei(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}W=b;gg();return!0}
	function Wj(a,b,c){b=Ai(c,b);b=Xi(a,b,1073741823);xg(a,b);a=xj(a,1073741823);null!==a&&Z(a)}function Ei(a,b){if(3===a.tag)Wj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){Wj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===aj||!aj.has(d))){a=Ai(b,a);a=$i(c,a,1073741823);xg(c,a);c=xj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
	function Oj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);T===a&&U===c?S===vi||S===ui&&1073741823===lj&&$f()-Ti<pj?Ej(a,U):oj=!0:Aj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,Z(a)))}function Vi(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Gg(),b=Hg(b,a,null));a=xj(a,b);null!==a&&Z(a)}var Rj;
	Rj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)rg=!0;else{if(d<c){rg=!1;switch(b.tag){case 3:hi(b);Xh();break;case 5:fh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Gf(b);break;case 4:dh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;e=b.type._context;I(jg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;
	if(0!==d&&d>=c)return ji(a,b,c);I(M,M.current&1);b=$h(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return mi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current);if(!d)return null}return $h(a,b,c)}rg=!1}}else rg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Cf(b,J.current);qg(b,c);e=oh(null,
	b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(L(d)){var f=!0;Gf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;ug(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Fg(b,d,g,a);e.updater=Jg;b.stateNode=e;e._reactInternalFiber=b;Ng(b,d,a,c);b=gi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:a:{e=b.elementType;null!==a&&(a.alternate=
	null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;ob(e);if(1!==e._status)throw e._result;e=e._result;b.type=e;f=b.tag=Xj(e);a=ig(e,a);switch(f){case 0:b=di(null,b,e,a,c);break a;case 1:b=fi(null,b,e,a,c);break a;case 11:b=Zh(null,b,e,a,c);break a;case 14:b=ai(null,b,e,ig(e.type,a),d,c);break a}throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),di(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),fi(a,b,d,e,c);
	case 3:hi(b);d=b.updateQueue;if(null===a||null===d)throw Error(u(282));d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;vg(a,b);zg(b,d,null,c);d=b.memoizedState.element;if(d===e)Xh(),b=$h(a,b,c);else{if(e=b.stateNode.hydrate)Ph=Jd(b.stateNode.containerInfo.firstChild),Oh=b,e=Qh=!0;if(e)for(c=Yg(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),Xh();b=b.child}return b;case 5:return fh(b),null===a&&Uh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:
	null,g=e.children,Gd(d,e)?g=null:null!==f&&Gd(d,f)&&(b.effectTag|=16),ei(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&Uh(b),null;case 13:return ji(a,b,c);case 4:return dh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Xg(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),Zh(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,
	b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(jg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=$e(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!K.current){b=$h(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==
	k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=wg(c,null),l.tag=2,xg(h,l));h.expirationTime<c&&(h.expirationTime=c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);pg(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=
	g}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,qg(b,c),e=sg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;case 14:return e=b.type,f=ig(e,b.pendingProps),f=ig(e.type,f),ai(a,b,e,f,d,c);case 15:return ci(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Gf(b)):a=!1,qg(b,c),Lg(b,d,e),Ng(b,d,e,c),gi(null,
	b,d,!0,a,c);case 19:return mi(a,b,c)}throw Error(u(156,b.tag));};var Uj=null,Li=null;function Yj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Uj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Li=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
	function Zj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Sh(a,b,c,d){return new Zj(a,b,c,d)}
	function bi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Xj(a){if("function"===typeof a)return bi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gb)return 11;if(a===jb)return 14}return 2}
	function Sg(a,b){var c=a.alternate;null===c?(c=Sh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
	firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
	function Ug(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)bi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ab:return Wg(c.children,e,f,b);case fb:g=8;e|=7;break;case bb:g=8;e|=1;break;case cb:return a=Sh(12,c,b,e|8),a.elementType=cb,a.type=cb,a.expirationTime=f,a;case hb:return a=Sh(13,c,b,e),a.type=hb,a.elementType=hb,a.expirationTime=f,a;case ib:return a=Sh(19,c,b,e),a.elementType=ib,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case db:g=
	10;break a;case eb:g=9;break a;case gb:g=11;break a;case jb:g=14;break a;case kb:g=16;d=null;break a;case lb:g=22;break a}throw Error(u(130,null==a?a:typeof a,""));}b=Sh(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Wg(a,b,c,d){a=Sh(7,a,d,b);a.expirationTime=c;return a}function Tg(a,b,c){a=Sh(6,a,null,b);a.expirationTime=c;return a}
	function Vg(a,b,c){b=Sh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
	function ak(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
	function Aj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function xi(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
	function yi(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Cj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
	function bk(a,b,c,d){var e=b.current,f=Gg(),g=Dg.suspense;f=Hg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(dc(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=Ff(c,k,h);break a}}c=h}else c=Af;null===b.context?b.context=c:b.pendingContext=c;b=wg(f,g);b.payload={element:a};d=void 0===
	d?null:d;null!==d&&(b.callback=d);xg(e,b);Ig(e,f);return f}function ck(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function dk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function ek(a,b){dk(a,b);(a=a.alternate)&&dk(a,b)}
	function fk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new ak(a,b,c),e=Sh(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;ug(e);a[Od]=d.current;c&&0!==b&&Jc(a,9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}fk.prototype.render=function(a){bk(a,this._internalRoot,null,null)};fk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;bk(null,a,null,function(){b[Od]=null})};
	function gk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function hk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new fk(a,0,b?{hydrate:!0}:void 0)}
	function ik(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=ck(g);h.call(a)}}bk(b,g,a,e)}else{f=c._reactRootContainer=hk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=ck(g);k.call(a)}}Nj(function(){bk(b,g,a,e)})}return ck(g)}function jk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$a,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
	wc=function(a){if(13===a.tag){var b=hg(Gg(),150,100);Ig(a,b);ek(a,b)}};xc=function(a){13===a.tag&&(Ig(a,3),ek(a,3))};yc=function(a){if(13===a.tag){var b=Gg();b=Hg(b,a,null);Ig(a,b);ek(a,b)}};
	za=function(a,b,c){switch(b){case "input":Cb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Qd(d);if(!e)throw Error(u(90));yb(d);Cb(d,e)}}}break;case "textarea":Kb(a,c);break;case "select":b=c.value,null!=b&&Hb(a,!!c.multiple,b,!1)}};Fa=Mj;
	Ga=function(a,b,c,d,e){var f=W;W|=4;try{return cg(98,a.bind(null,b,c,d,e))}finally{W=f,W===V&&gg()}};Ha=function(){(W&(1|fj|gj))===V&&(Lj(),Dj())};Ia=function(a,b){var c=W;W|=2;try{return a(b)}finally{W=c,W===V&&gg()}};function kk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!gk(b))throw Error(u(200));return jk(a,b,null,c)}var lk={Events:[Nc,Pd,Qd,xa,ta,Xd,function(a){jc(a,Wd)},Da,Ea,id,mc,Dj,{current:!1}]};
	(function(a){var b=a.findFiberByHostInstance;return Yj(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Wa.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hc(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:tc,bundleType:0,version:"16.14.0",
	rendererPackageName:"react-dom"});exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=lk;exports.createPortal=kk;exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=hc(b);a=null===a?null:a.stateNode;return a};
	exports.flushSync=function(a,b){if((W&(fj|gj))!==V)throw Error(u(187));var c=W;W|=1;try{return cg(99,a.bind(null,b))}finally{W=c,gg()}};exports.hydrate=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!0,c)};exports.render=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!1,c)};
	exports.unmountComponentAtNode=function(a){if(!gk(a))throw Error(u(40));return a._reactRootContainer?(Nj(function(){ik(null,null,a,!1,function(){a._reactRootContainer=null;a[Od]=null})}),!0):!1};exports.unstable_batchedUpdates=Mj;exports.unstable_createPortal=function(a,b){return kk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
	exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!gk(c))throw Error(u(200));if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return ik(a,b,c,!1,d)};exports.version="16.14.0";


/***/ },
/* 2272 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "DraggableCore", {
	  enumerable: true,
	  get: function get() {
	    return _DraggableCore.default;
	  }
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(31));
	
	var _clsx2 = _interopRequireDefault(__webpack_require__(1204));
	
	var _domFns = __webpack_require__(463);
	
	var _positionFns = __webpack_require__(933);
	
	var _shims = __webpack_require__(299);
	
	var _DraggableCore = _interopRequireDefault(__webpack_require__(2273));
	
	var _log = _interopRequireDefault(__webpack_require__(932));
	
	var _excluded = ["axis", "bounds", "children", "defaultPosition", "defaultClassName", "defaultClassNameDragging", "defaultClassNameDragged", "position", "positionOffset", "scale"];
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	//
	// Define <Draggable>
	//
	var Draggable = /*#__PURE__*/function (_React$Component) {
	  _inherits(Draggable, _React$Component);
	
	  var _super = _createSuper(Draggable);
	
	  function Draggable(props
	  /*: DraggableProps*/
	  ) {
	    var _this;
	
	    _classCallCheck(this, Draggable);
	
	    _this = _super.call(this, props);
	
	    _defineProperty(_assertThisInitialized(_this), "onDragStart", function (e, coreData) {
	      (0, _log.default)('Draggable: onDragStart: %j', coreData); // Short-circuit if user's callback killed it.
	
	      var shouldStart = _this.props.onStart(e, (0, _positionFns.createDraggableData)(_assertThisInitialized(_this), coreData)); // Kills start event on core as well, so move handlers are never bound.
	
	
	      if (shouldStart === false) return false;
	
	      _this.setState({
	        dragging: true,
	        dragged: true
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onDrag", function (e, coreData) {
	      if (!_this.state.dragging) return false;
	      (0, _log.default)('Draggable: onDrag: %j', coreData);
	      var uiData = (0, _positionFns.createDraggableData)(_assertThisInitialized(_this), coreData);
	      var newState
	      /*: $Shape<DraggableState>*/
	      = {
	        x: uiData.x,
	        y: uiData.y
	      }; // Keep within bounds.
	
	      if (_this.props.bounds) {
	        // Save original x and y.
	        var x = newState.x,
	            y = newState.y; // Add slack to the values used to calculate bound position. This will ensure that if
	        // we start removing slack, the element won't react to it right away until it's been
	        // completely removed.
	
	        newState.x += _this.state.slackX;
	        newState.y += _this.state.slackY; // Get bound position. This will ceil/floor the x and y within the boundaries.
	
	        var _getBoundPosition = (0, _positionFns.getBoundPosition)(_assertThisInitialized(_this), newState.x, newState.y),
	            _getBoundPosition2 = _slicedToArray(_getBoundPosition, 2),
	            newStateX = _getBoundPosition2[0],
	            newStateY = _getBoundPosition2[1];
	
	        newState.x = newStateX;
	        newState.y = newStateY; // Recalculate slack by noting how much was shaved by the boundPosition handler.
	
	        newState.slackX = _this.state.slackX + (x - newState.x);
	        newState.slackY = _this.state.slackY + (y - newState.y); // Update the event we fire to reflect what really happened after bounds took effect.
	
	        uiData.x = newState.x;
	        uiData.y = newState.y;
	        uiData.deltaX = newState.x - _this.state.x;
	        uiData.deltaY = newState.y - _this.state.y;
	      } // Short-circuit if user's callback killed it.
	
	
	      var shouldUpdate = _this.props.onDrag(e, uiData);
	
	      if (shouldUpdate === false) return false;
	
	      _this.setState(newState);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onDragStop", function (e, coreData) {
	      if (!_this.state.dragging) return false; // Short-circuit if user's callback killed it.
	
	      var shouldContinue = _this.props.onStop(e, (0, _positionFns.createDraggableData)(_assertThisInitialized(_this), coreData));
	
	      if (shouldContinue === false) return false;
	      (0, _log.default)('Draggable: onDragStop: %j', coreData);
	      var newState
	      /*: $Shape<DraggableState>*/
	      = {
	        dragging: false,
	        slackX: 0,
	        slackY: 0
	      }; // If this is a controlled component, the result of this operation will be to
	      // revert back to the old position. We expect a handler on `onDragStop`, at the least.
	
	      var controlled = Boolean(_this.props.position);
	
	      if (controlled) {
	        var _this$props$position = _this.props.position,
	            x = _this$props$position.x,
	            y = _this$props$position.y;
	        newState.x = x;
	        newState.y = y;
	      }
	
	      _this.setState(newState);
	    });
	
	    _this.state = {
	      // Whether or not we are currently dragging.
	      dragging: false,
	      // Whether or not we have been dragged before.
	      dragged: false,
	      // Current transform x and y.
	      x: props.position ? props.position.x : props.defaultPosition.x,
	      y: props.position ? props.position.y : props.defaultPosition.y,
	      prevPropsPosition: _objectSpread({}, props.position),
	      // Used for compensating for out-of-bounds drags
	      slackX: 0,
	      slackY: 0,
	      // Can only determine if SVG after mounting
	      isElementSVG: false
	    };
	
	    if (props.position && !(props.onDrag || props.onStop)) {
	      // eslint-disable-next-line no-console
	      console.warn('A `position` was applied to this <Draggable>, without drag handlers. This will make this ' + 'component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the ' + '`position` of this element.');
	    }
	
	    return _this;
	  }
	
	  _createClass(Draggable, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      // Check to see if the element passed is an instanceof SVGElement
	      if (typeof window.SVGElement !== 'undefined' && this.findDOMNode() instanceof window.SVGElement) {
	        this.setState({
	          isElementSVG: true
	        });
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.setState({
	        dragging: false
	      }); // prevents invariant if unmounted while dragging
	    } // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
	    // the underlying DOM node ourselves. See the README for more information.
	
	  }, {
	    key: "findDOMNode",
	    value: function findDOMNode()
	    /*: ?HTMLElement*/
	    {
	      var _this$props$nodeRef$c, _this$props, _this$props$nodeRef;
	
	      return (_this$props$nodeRef$c = (_this$props = this.props) === null || _this$props === void 0 ? void 0 : (_this$props$nodeRef = _this$props.nodeRef) === null || _this$props$nodeRef === void 0 ? void 0 : _this$props$nodeRef.current) !== null && _this$props$nodeRef$c !== void 0 ? _this$props$nodeRef$c : _reactDom.default.findDOMNode(this);
	    }
	  }, {
	    key: "render",
	    value: function render()
	    /*: ReactElement<any>*/
	    {
	      var _clsx;
	
	      var _this$props2 = this.props,
	          axis = _this$props2.axis,
	          bounds = _this$props2.bounds,
	          children = _this$props2.children,
	          defaultPosition = _this$props2.defaultPosition,
	          defaultClassName = _this$props2.defaultClassName,
	          defaultClassNameDragging = _this$props2.defaultClassNameDragging,
	          defaultClassNameDragged = _this$props2.defaultClassNameDragged,
	          position = _this$props2.position,
	          positionOffset = _this$props2.positionOffset,
	          scale = _this$props2.scale,
	          draggableCoreProps = _objectWithoutProperties(_this$props2, _excluded);
	
	      var style = {};
	      var svgTransform = null; // If this is controlled, we don't want to move it - unless it's dragging.
	
	      var controlled = Boolean(position);
	      var draggable = !controlled || this.state.dragging;
	      var validPosition = position || defaultPosition;
	      var transformOpts = {
	        // Set left if horizontal drag is enabled
	        x: (0, _positionFns.canDragX)(this) && draggable ? this.state.x : validPosition.x,
	        // Set top if vertical drag is enabled
	        y: (0, _positionFns.canDragY)(this) && draggable ? this.state.y : validPosition.y
	      }; // If this element was SVG, we use the `transform` attribute.
	
	      if (this.state.isElementSVG) {
	        svgTransform = (0, _domFns.createSVGTransform)(transformOpts, positionOffset);
	      } else {
	        // Add a CSS transform to move the element around. This allows us to move the element around
	        // without worrying about whether or not it is relatively or absolutely positioned.
	        // If the item you are dragging already has a transform set, wrap it in a <span> so <Draggable>
	        // has a clean slate.
	        style = (0, _domFns.createCSSTransform)(transformOpts, positionOffset);
	      } // Mark with class while dragging
	
	
	      var className = (0, _clsx2.default)(children.props.className || '', defaultClassName, (_clsx = {}, _defineProperty(_clsx, defaultClassNameDragging, this.state.dragging), _defineProperty(_clsx, defaultClassNameDragged, this.state.dragged), _clsx)); // Reuse the child provided
	      // This makes it flexible to use whatever element is wanted (div, ul, etc)
	
	      return /*#__PURE__*/React.createElement(_DraggableCore.default, _extends({}, draggableCoreProps, {
	        onStart: this.onDragStart,
	        onDrag: this.onDrag,
	        onStop: this.onDragStop
	      }), /*#__PURE__*/React.cloneElement(React.Children.only(children), {
	        className: className,
	        style: _objectSpread(_objectSpread({}, children.props.style), style),
	        transform: svgTransform
	      }));
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: // React 16.3+
	    // Arity (props, state)
	    function getDerivedStateFromProps(_ref, _ref2)
	    /*: ?$Shape<DraggableState>*/
	    {
	      var position = _ref.position;
	      var prevPropsPosition = _ref2.prevPropsPosition;
	
	      // Set x/y if a new position is provided in props that is different than the previous.
	      if (position && (!prevPropsPosition || position.x !== prevPropsPosition.x || position.y !== prevPropsPosition.y)) {
	        (0, _log.default)('Draggable: getDerivedStateFromProps %j', {
	          position: position,
	          prevPropsPosition: prevPropsPosition
	        });
	        return {
	          x: position.x,
	          y: position.y,
	          prevPropsPosition: _objectSpread({}, position)
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return Draggable;
	}(React.Component);
	
	exports.default = Draggable;
	
	_defineProperty(Draggable, "displayName", 'Draggable');
	
	_defineProperty(Draggable, "propTypes", _objectSpread(_objectSpread({}, _DraggableCore.default.propTypes), {}, {
	  /**
	   * `axis` determines which axis the draggable can move.
	   *
	   *  Note that all callbacks will still return data as normal. This only
	   *  controls flushing to the DOM.
	   *
	   * 'both' allows movement horizontally and vertically.
	   * 'x' limits movement to horizontal axis.
	   * 'y' limits movement to vertical axis.
	   * 'none' limits all movement.
	   *
	   * Defaults to 'both'.
	   */
	  axis: _propTypes.default.oneOf(['both', 'x', 'y', 'none']),
	
	  /**
	   * `bounds` determines the range of movement available to the element.
	   * Available values are:
	   *
	   * 'parent' restricts movement within the Draggable's parent node.
	   *
	   * Alternatively, pass an object with the following properties, all of which are optional:
	   *
	   * {left: LEFT_BOUND, right: RIGHT_BOUND, bottom: BOTTOM_BOUND, top: TOP_BOUND}
	   *
	   * All values are in px.
	   *
	   * Example:
	   *
	   * ```jsx
	   *   let App = React.createClass({
	   *       render: function () {
	   *         return (
	   *            <Draggable bounds={{right: 300, bottom: 300}}>
	   *              <div>Content</div>
	   *           </Draggable>
	   *         );
	   *       }
	   *   });
	   * ```
	   */
	  bounds: _propTypes.default.oneOfType([_propTypes.default.shape({
	    left: _propTypes.default.number,
	    right: _propTypes.default.number,
	    top: _propTypes.default.number,
	    bottom: _propTypes.default.number
	  }), _propTypes.default.string, _propTypes.default.oneOf([false])]),
	  defaultClassName: _propTypes.default.string,
	  defaultClassNameDragging: _propTypes.default.string,
	  defaultClassNameDragged: _propTypes.default.string,
	
	  /**
	   * `defaultPosition` specifies the x and y that the dragged item should start at
	   *
	   * Example:
	   *
	   * ```jsx
	   *      let App = React.createClass({
	   *          render: function () {
	   *              return (
	   *                  <Draggable defaultPosition={{x: 25, y: 25}}>
	   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
	   *                  </Draggable>
	   *              );
	   *          }
	   *      });
	   * ```
	   */
	  defaultPosition: _propTypes.default.shape({
	    x: _propTypes.default.number,
	    y: _propTypes.default.number
	  }),
	  positionOffset: _propTypes.default.shape({
	    x: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	    y: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
	  }),
	
	  /**
	   * `position`, if present, defines the current position of the element.
	   *
	   *  This is similar to how form elements in React work - if no `position` is supplied, the component
	   *  is uncontrolled.
	   *
	   * Example:
	   *
	   * ```jsx
	   *      let App = React.createClass({
	   *          render: function () {
	   *              return (
	   *                  <Draggable position={{x: 25, y: 25}}>
	   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
	   *                  </Draggable>
	   *              );
	   *          }
	   *      });
	   * ```
	   */
	  position: _propTypes.default.shape({
	    x: _propTypes.default.number,
	    y: _propTypes.default.number
	  }),
	
	  /**
	   * These properties should be defined on the child, not here.
	   */
	  className: _shims.dontSetMe,
	  style: _shims.dontSetMe,
	  transform: _shims.dontSetMe
	}));
	
	_defineProperty(Draggable, "defaultProps", _objectSpread(_objectSpread({}, _DraggableCore.default.defaultProps), {}, {
	  axis: 'both',
	  bounds: false,
	  defaultClassName: 'react-draggable',
	  defaultClassNameDragging: 'react-draggable-dragging',
	  defaultClassNameDragged: 'react-draggable-dragged',
	  defaultPosition: {
	    x: 0,
	    y: 0
	  },
	  scale: 1
	}));

/***/ },
/* 2273 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(31));
	
	var _domFns = __webpack_require__(463);
	
	var _positionFns = __webpack_require__(933);
	
	var _shims = __webpack_require__(299);
	
	var _log = _interopRequireDefault(__webpack_require__(932));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// Simple abstraction for dragging events names.
	var eventsFor = {
	  touch: {
	    start: 'touchstart',
	    move: 'touchmove',
	    stop: 'touchend'
	  },
	  mouse: {
	    start: 'mousedown',
	    move: 'mousemove',
	    stop: 'mouseup'
	  }
	}; // Default to mouse events.
	
	var dragEventFor = eventsFor.mouse;
	/*:: type DraggableCoreState = {
	  dragging: boolean,
	  lastX: number,
	  lastY: number,
	  touchIdentifier: ?number
	};*/
	
	/*:: export type DraggableData = {
	  node: HTMLElement,
	  x: number, y: number,
	  deltaX: number, deltaY: number,
	  lastX: number, lastY: number,
	};*/
	
	/*:: export type DraggableEventHandler = (e: MouseEvent, data: DraggableData) => void | false;*/
	
	/*:: export type ControlPosition = {x: number, y: number};*/
	
	/*:: export type PositionOffsetControlPosition = {x: number|string, y: number|string};*/
	
	/*:: export type DraggableCoreDefaultProps = {
	  allowAnyClick: boolean,
	  disabled: boolean,
	  enableUserSelectHack: boolean,
	  onStart: DraggableEventHandler,
	  onDrag: DraggableEventHandler,
	  onStop: DraggableEventHandler,
	  onMouseDown: (e: MouseEvent) => void,
	  scale: number,
	};*/
	
	/*:: export type DraggableCoreProps = {
	  ...DraggableCoreDefaultProps,
	  cancel: string,
	  children: ReactElement<any>,
	  offsetParent: HTMLElement,
	  grid: [number, number],
	  handle: string,
	  nodeRef?: ?React.ElementRef<any>,
	};*/
	
	//
	// Define <DraggableCore>.
	//
	// <DraggableCore> is for advanced usage of <Draggable>. It maintains minimal internal state so it can
	// work well with libraries that require more control over the element.
	//
	var DraggableCore = /*#__PURE__*/function (_React$Component) {
	  _inherits(DraggableCore, _React$Component);
	
	  var _super = _createSuper(DraggableCore);
	
	  function DraggableCore() {
	    var _this;
	
	    _classCallCheck(this, DraggableCore);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _super.call.apply(_super, [this].concat(args));
	
	    _defineProperty(_assertThisInitialized(_this), "state", {
	      dragging: false,
	      // Used while dragging to determine deltas.
	      lastX: NaN,
	      lastY: NaN,
	      touchIdentifier: null
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "mounted", false);
	
	    _defineProperty(_assertThisInitialized(_this), "handleDragStart", function (e) {
	      // Make it possible to attach event handlers on top of this one.
	      _this.props.onMouseDown(e); // Only accept left-clicks.
	
	
	      if (!_this.props.allowAnyClick && typeof e.button === 'number' && e.button !== 0) return false; // Get nodes. Be sure to grab relative document (could be iframed)
	
	      var thisNode = _this.findDOMNode();
	
	      if (!thisNode || !thisNode.ownerDocument || !thisNode.ownerDocument.body) {
	        throw new Error('<DraggableCore> not mounted on DragStart!');
	      }
	
	      var ownerDocument = thisNode.ownerDocument; // Short circuit if handle or cancel prop was provided and selector doesn't match.
	
	      if (_this.props.disabled || !(e.target instanceof ownerDocument.defaultView.Node) || _this.props.handle && !(0, _domFns.matchesSelectorAndParentsTo)(e.target, _this.props.handle, thisNode) || _this.props.cancel && (0, _domFns.matchesSelectorAndParentsTo)(e.target, _this.props.cancel, thisNode)) {
	        return;
	      } // Prevent scrolling on mobile devices, like ipad/iphone.
	      // Important that this is after handle/cancel.
	
	
	      if (e.type === 'touchstart') e.preventDefault(); // Set touch identifier in component state if this is a touch event. This allows us to
	      // distinguish between individual touches on multitouch screens by identifying which
	      // touchpoint was set to this element.
	
	      var touchIdentifier = (0, _domFns.getTouchIdentifier)(e);
	
	      _this.setState({
	        touchIdentifier: touchIdentifier
	      }); // Get the current drag point from the event. This is used as the offset.
	
	
	      var position = (0, _positionFns.getControlPosition)(e, touchIdentifier, _assertThisInitialized(_this));
	      if (position == null) return; // not possible but satisfies flow
	
	      var x = position.x,
	          y = position.y; // Create an event object with all the data parents need to make a decision here.
	
	      var coreEvent = (0, _positionFns.createCoreData)(_assertThisInitialized(_this), x, y);
	      (0, _log.default)('DraggableCore: handleDragStart: %j', coreEvent); // Call event handler. If it returns explicit false, cancel.
	
	      (0, _log.default)('calling', _this.props.onStart);
	
	      var shouldUpdate = _this.props.onStart(e, coreEvent);
	
	      if (shouldUpdate === false || _this.mounted === false) return; // Add a style to the body to disable user-select. This prevents text from
	      // being selected all over the page.
	
	      if (_this.props.enableUserSelectHack) (0, _domFns.addUserSelectStyles)(ownerDocument); // Initiate dragging. Set the current x and y as offsets
	      // so we know how much we've moved during the drag. This allows us
	      // to drag elements around even if they have been moved, without issue.
	
	      _this.setState({
	        dragging: true,
	        lastX: x,
	        lastY: y
	      }); // Add events to the document directly so we catch when the user's mouse/touch moves outside of
	      // this element. We use different events depending on whether or not we have detected that this
	      // is a touch-capable device.
	
	
	      (0, _domFns.addEvent)(ownerDocument, dragEventFor.move, _this.handleDrag);
	      (0, _domFns.addEvent)(ownerDocument, dragEventFor.stop, _this.handleDragStop);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "handleDrag", function (e) {
	      // Get the current drag point from the event. This is used as the offset.
	      var position = (0, _positionFns.getControlPosition)(e, _this.state.touchIdentifier, _assertThisInitialized(_this));
	      if (position == null) return;
	      var x = position.x,
	          y = position.y; // Snap to grid if prop has been provided
	
	      if (Array.isArray(_this.props.grid)) {
	        var deltaX = x - _this.state.lastX,
	            deltaY = y - _this.state.lastY;
	
	        var _snapToGrid = (0, _positionFns.snapToGrid)(_this.props.grid, deltaX, deltaY);
	
	        var _snapToGrid2 = _slicedToArray(_snapToGrid, 2);
	
	        deltaX = _snapToGrid2[0];
	        deltaY = _snapToGrid2[1];
	        if (!deltaX && !deltaY) return; // skip useless drag
	
	        x = _this.state.lastX + deltaX, y = _this.state.lastY + deltaY;
	      }
	
	      var coreEvent = (0, _positionFns.createCoreData)(_assertThisInitialized(_this), x, y);
	      (0, _log.default)('DraggableCore: handleDrag: %j', coreEvent); // Call event handler. If it returns explicit false, trigger end.
	
	      var shouldUpdate = _this.props.onDrag(e, coreEvent);
	
	      if (shouldUpdate === false || _this.mounted === false) {
	        try {
	          // $FlowIgnore
	          _this.handleDragStop(new MouseEvent('mouseup'));
	        } catch (err) {
	          // Old browsers
	          var event = ((document.createEvent('MouseEvents')
	          /*: any*/
	          )
	          /*: MouseTouchEvent*/
	          ); // I see why this insanity was deprecated
	          // $FlowIgnore
	
	          event.initMouseEvent('mouseup', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
	
	          _this.handleDragStop(event);
	        }
	
	        return;
	      }
	
	      _this.setState({
	        lastX: x,
	        lastY: y
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "handleDragStop", function (e) {
	      if (!_this.state.dragging) return;
	      var position = (0, _positionFns.getControlPosition)(e, _this.state.touchIdentifier, _assertThisInitialized(_this));
	      if (position == null) return;
	      var x = position.x,
	          y = position.y; // Snap to grid if prop has been provided
	
	      if (Array.isArray(_this.props.grid)) {
	        var deltaX = x - _this.state.lastX || 0;
	        var deltaY = y - _this.state.lastY || 0;
	
	        var _snapToGrid3 = (0, _positionFns.snapToGrid)(_this.props.grid, deltaX, deltaY);
	
	        var _snapToGrid4 = _slicedToArray(_snapToGrid3, 2);
	
	        deltaX = _snapToGrid4[0];
	        deltaY = _snapToGrid4[1];
	        x = _this.state.lastX + deltaX, y = _this.state.lastY + deltaY;
	      }
	
	      var coreEvent = (0, _positionFns.createCoreData)(_assertThisInitialized(_this), x, y); // Call event handler
	
	      var shouldContinue = _this.props.onStop(e, coreEvent);
	
	      if (shouldContinue === false || _this.mounted === false) return false;
	
	      var thisNode = _this.findDOMNode();
	
	      if (thisNode) {
	        // Remove user-select hack
	        if (_this.props.enableUserSelectHack) (0, _domFns.removeUserSelectStyles)(thisNode.ownerDocument);
	      }
	
	      (0, _log.default)('DraggableCore: handleDragStop: %j', coreEvent); // Reset the el.
	
	      _this.setState({
	        dragging: false,
	        lastX: NaN,
	        lastY: NaN
	      });
	
	      if (thisNode) {
	        // Remove event handlers
	        (0, _log.default)('DraggableCore: Removing handlers');
	        (0, _domFns.removeEvent)(thisNode.ownerDocument, dragEventFor.move, _this.handleDrag);
	        (0, _domFns.removeEvent)(thisNode.ownerDocument, dragEventFor.stop, _this.handleDragStop);
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onMouseDown", function (e) {
	      dragEventFor = eventsFor.mouse; // on touchscreen laptops we could switch back to mouse
	
	      return _this.handleDragStart(e);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onMouseUp", function (e) {
	      dragEventFor = eventsFor.mouse;
	      return _this.handleDragStop(e);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onTouchStart", function (e) {
	      // We're on a touch device now, so change the event handlers
	      dragEventFor = eventsFor.touch;
	      return _this.handleDragStart(e);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onTouchEnd", function (e) {
	      // We're on a touch device now, so change the event handlers
	      dragEventFor = eventsFor.touch;
	      return _this.handleDragStop(e);
	    });
	
	    return _this;
	  }
	
	  _createClass(DraggableCore, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.mounted = true; // Touch handlers must be added with {passive: false} to be cancelable.
	      // https://developers.google.com/web/updates/2017/01/scrolling-intervention
	
	      var thisNode = this.findDOMNode();
	
	      if (thisNode) {
	        (0, _domFns.addEvent)(thisNode, eventsFor.touch.start, this.onTouchStart, {
	          passive: false
	        });
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.mounted = false; // Remove any leftover event handlers. Remove both touch and mouse handlers in case
	      // some browser quirk caused a touch event to fire during a mouse move, or vice versa.
	
	      var thisNode = this.findDOMNode();
	
	      if (thisNode) {
	        var ownerDocument = thisNode.ownerDocument;
	        (0, _domFns.removeEvent)(ownerDocument, eventsFor.mouse.move, this.handleDrag);
	        (0, _domFns.removeEvent)(ownerDocument, eventsFor.touch.move, this.handleDrag);
	        (0, _domFns.removeEvent)(ownerDocument, eventsFor.mouse.stop, this.handleDragStop);
	        (0, _domFns.removeEvent)(ownerDocument, eventsFor.touch.stop, this.handleDragStop);
	        (0, _domFns.removeEvent)(thisNode, eventsFor.touch.start, this.onTouchStart, {
	          passive: false
	        });
	        if (this.props.enableUserSelectHack) (0, _domFns.removeUserSelectStyles)(ownerDocument);
	      }
	    } // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
	    // the underlying DOM node ourselves. See the README for more information.
	
	  }, {
	    key: "findDOMNode",
	    value: function findDOMNode()
	    /*: ?HTMLElement*/
	    {
	      var _this$props, _this$props2, _this$props2$nodeRef;
	
	      return (_this$props = this.props) !== null && _this$props !== void 0 && _this$props.nodeRef ? (_this$props2 = this.props) === null || _this$props2 === void 0 ? void 0 : (_this$props2$nodeRef = _this$props2.nodeRef) === null || _this$props2$nodeRef === void 0 ? void 0 : _this$props2$nodeRef.current : _reactDom.default.findDOMNode(this);
	    }
	  }, {
	    key: "render",
	    value: function render()
	    /*: React.Element<any>*/
	    {
	      // Reuse the child provided
	      // This makes it flexible to use whatever element is wanted (div, ul, etc)
	      return /*#__PURE__*/React.cloneElement(React.Children.only(this.props.children), {
	        // Note: mouseMove handler is attached to document so it will still function
	        // when the user drags quickly and leaves the bounds of the element.
	        onMouseDown: this.onMouseDown,
	        onMouseUp: this.onMouseUp,
	        // onTouchStart is added on `componentDidMount` so they can be added with
	        // {passive: false}, which allows it to cancel. See
	        // https://developers.google.com/web/updates/2017/01/scrolling-intervention
	        onTouchEnd: this.onTouchEnd
	      });
	    }
	  }]);
	
	  return DraggableCore;
	}(React.Component);
	
	exports.default = DraggableCore;
	
	_defineProperty(DraggableCore, "displayName", 'DraggableCore');
	
	_defineProperty(DraggableCore, "propTypes", {
	  /**
	   * `allowAnyClick` allows dragging using any mouse button.
	   * By default, we only accept the left button.
	   *
	   * Defaults to `false`.
	   */
	  allowAnyClick: _propTypes.default.bool,
	
	  /**
	   * `disabled`, if true, stops the <Draggable> from dragging. All handlers,
	   * with the exception of `onMouseDown`, will not fire.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * By default, we add 'user-select:none' attributes to the document body
	   * to prevent ugly text selection during drag. If this is causing problems
	   * for your app, set this to `false`.
	   */
	  enableUserSelectHack: _propTypes.default.bool,
	
	  /**
	   * `offsetParent`, if set, uses the passed DOM node to compute drag offsets
	   * instead of using the parent node.
	   */
	  offsetParent: function offsetParent(props
	  /*: DraggableCoreProps*/
	  , propName
	  /*: $Keys<DraggableCoreProps>*/
	  ) {
	    if (props[propName] && props[propName].nodeType !== 1) {
	      throw new Error('Draggable\'s offsetParent must be a DOM Node.');
	    }
	  },
	
	  /**
	   * `grid` specifies the x and y that dragging should snap to.
	   */
	  grid: _propTypes.default.arrayOf(_propTypes.default.number),
	
	  /**
	   * `handle` specifies a selector to be used as the handle that initiates drag.
	   *
	   * Example:
	   *
	   * ```jsx
	   *   let App = React.createClass({
	   *       render: function () {
	   *         return (
	   *            <Draggable handle=".handle">
	   *              <div>
	   *                  <div className="handle">Click me to drag</div>
	   *                  <div>This is some other content</div>
	   *              </div>
	   *           </Draggable>
	   *         );
	   *       }
	   *   });
	   * ```
	   */
	  handle: _propTypes.default.string,
	
	  /**
	   * `cancel` specifies a selector to be used to prevent drag initialization.
	   *
	   * Example:
	   *
	   * ```jsx
	   *   let App = React.createClass({
	   *       render: function () {
	   *           return(
	   *               <Draggable cancel=".cancel">
	   *                   <div>
	   *                     <div className="cancel">You can't drag from here</div>
	   *                     <div>Dragging here works fine</div>
	   *                   </div>
	   *               </Draggable>
	   *           );
	   *       }
	   *   });
	   * ```
	   */
	  cancel: _propTypes.default.string,
	
	  /* If running in React Strict mode, ReactDOM.findDOMNode() is deprecated.
	   * Unfortunately, in order for <Draggable> to work properly, we need raw access
	   * to the underlying DOM node. If you want to avoid the warning, pass a `nodeRef`
	   * as in this example:
	   *
	   * function MyComponent() {
	   *   const nodeRef = React.useRef(null);
	   *   return (
	   *     <Draggable nodeRef={nodeRef}>
	   *       <div ref={nodeRef}>Example Target</div>
	   *     </Draggable>
	   *   );
	   * }
	   *
	   * This can be used for arbitrarily nested components, so long as the ref ends up
	   * pointing to the actual child DOM node and not a custom component.
	   */
	  nodeRef: _propTypes.default.object,
	
	  /**
	   * Called when dragging starts.
	   * If this function returns the boolean false, dragging will be canceled.
	   */
	  onStart: _propTypes.default.func,
	
	  /**
	   * Called while dragging.
	   * If this function returns the boolean false, dragging will be canceled.
	   */
	  onDrag: _propTypes.default.func,
	
	  /**
	   * Called when dragging stops.
	   * If this function returns the boolean false, the drag will remain active.
	   */
	  onStop: _propTypes.default.func,
	
	  /**
	   * A workaround option which can be passed if onMouseDown needs to be accessed,
	   * since it'll always be blocked (as there is internal use of onMouseDown)
	   */
	  onMouseDown: _propTypes.default.func,
	
	  /**
	   * `scale`, if set, applies scaling while dragging an element
	   */
	  scale: _propTypes.default.number,
	
	  /**
	   * These properties should be defined on the child, not here.
	   */
	  className: _shims.dontSetMe,
	  style: _shims.dontSetMe,
	  transform: _shims.dontSetMe
	});
	
	_defineProperty(DraggableCore, "defaultProps", {
	  allowAnyClick: false,
	  // by default only accept left click
	  disabled: false,
	  enableUserSelectHack: true,
	  onStart: function onStart() {},
	  onDrag: function onDrag() {},
	  onStop: function onStop() {},
	  onMouseDown: function onMouseDown() {},
	  scale: 1
	});

/***/ },
/* 2274 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.browserPrefixToKey = browserPrefixToKey;
	exports.browserPrefixToStyle = browserPrefixToStyle;
	exports.default = void 0;
	exports.getPrefix = getPrefix;
	var prefixes = ['Moz', 'Webkit', 'O', 'ms'];
	
	function getPrefix()
	/*: string*/
	{
	  var _window$document, _window$document$docu;
	
	  var prop
	  /*: string*/
	  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'transform';
	  // Ensure we're running in an environment where there is actually a global
	  // `window` obj
	  if (typeof window === 'undefined') return ''; // If we're in a pseudo-browser server-side environment, this access
	  // path may not exist, so bail out if it doesn't.
	
	  var style = (_window$document = window.document) === null || _window$document === void 0 ? void 0 : (_window$document$docu = _window$document.documentElement) === null || _window$document$docu === void 0 ? void 0 : _window$document$docu.style;
	  if (!style) return '';
	  if (prop in style) return '';
	
	  for (var i = 0; i < prefixes.length; i++) {
	    if (browserPrefixToKey(prop, prefixes[i]) in style) return prefixes[i];
	  }
	
	  return '';
	}
	
	function browserPrefixToKey(prop
	/*: string*/
	, prefix
	/*: string*/
	)
	/*: string*/
	{
	  return prefix ? "".concat(prefix).concat(kebabToTitleCase(prop)) : prop;
	}
	
	function browserPrefixToStyle(prop
	/*: string*/
	, prefix
	/*: string*/
	)
	/*: string*/
	{
	  return prefix ? "-".concat(prefix.toLowerCase(), "-").concat(prop) : prop;
	}
	
	function kebabToTitleCase(str
	/*: string*/
	)
	/*: string*/
	{
	  var out = '';
	  var shouldCapitalize = true;
	
	  for (var i = 0; i < str.length; i++) {
	    if (shouldCapitalize) {
	      out += str[i].toUpperCase();
	      shouldCapitalize = false;
	    } else if (str[i] === '-') {
	      shouldCapitalize = true;
	    } else {
	      out += str[i];
	    }
	  }
	
	  return out;
	} // Default export is the prefix itself, like 'Moz', 'Webkit', etc
	// Note that you may have to re-test for certain things; for instance, Chrome 50
	// can handle unprefixed `transform`, but not unprefixed `user-select`
	
	
	var _default = (getPrefix()
	/*: string*/
	);
	
	exports.default = _default;

/***/ },
/* 2275 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.I18nextProvider = I18nextProvider;
	
	var _react = __webpack_require__(1);
	
	var _context = __webpack_require__(184);
	
	function I18nextProvider(_ref) {
	  var i18n = _ref.i18n,
	      defaultNS = _ref.defaultNS,
	      children = _ref.children;
	  var value = (0, _react.useMemo)(function () {
	    return {
	      i18n: i18n,
	      defaultNS: defaultNS
	    };
	  }, [i18n, defaultNS]);
	  return (0, _react.createElement)(_context.I18nContext.Provider, {
	    value: value
	  }, children);
	}

/***/ },
/* 2276 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	var _typeof3 = __webpack_require__(129);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.nodesToString = nodesToString;
	exports.Trans = Trans;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(234));
	
	var _typeof2 = _interopRequireDefault(__webpack_require__(129));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(27));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _htmlParseStringify = _interopRequireDefault(__webpack_require__(2027));
	
	var _htmlEscaper = __webpack_require__(2026);
	
	var _context = __webpack_require__(184);
	
	var _utils = __webpack_require__(300);
	
	var _excluded = ["format"],
	    _excluded2 = ["children", "count", "parent", "i18nKey", "tOptions", "values", "defaults", "components", "ns", "i18n", "t", "shouldUnescape"];
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function hasChildren(node, checkLength) {
	  if (!node) return false;
	  var base = node.props ? node.props.children : node.children;
	  if (checkLength) return base.length > 0;
	  return !!base;
	}
	
	function getChildren(node) {
	  if (!node) return [];
	  return node && node.children ? node.children : node.props && node.props.children;
	}
	
	function hasValidReactChildren(children) {
	  if (Object.prototype.toString.call(children) !== '[object Array]') return false;
	  return children.every(function (child) {
	    return _react["default"].isValidElement(child);
	  });
	}
	
	function getAsArray(data) {
	  return Array.isArray(data) ? data : [data];
	}
	
	function mergeProps(source, target) {
	  var newTarget = _objectSpread({}, target);
	
	  newTarget.props = Object.assign(source.props, target.props);
	  return newTarget;
	}
	
	function nodesToString(children, i18nOptions) {
	  if (!children) return '';
	  var stringNode = '';
	  var childrenArray = getAsArray(children);
	  var keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
	  childrenArray.forEach(function (child, childIndex) {
	    if (typeof child === 'string') {
	      stringNode += "".concat(child);
	    } else if (_react["default"].isValidElement(child)) {
	      var childPropsCount = Object.keys(child.props).length;
	      var shouldKeepChild = keepArray.indexOf(child.type) > -1;
	      var childChildren = child.props.children;
	
	      if (!childChildren && shouldKeepChild && childPropsCount === 0) {
	        stringNode += "<".concat(child.type, "/>");
	      } else if (!childChildren && (!shouldKeepChild || childPropsCount !== 0)) {
	        stringNode += "<".concat(childIndex, "></").concat(childIndex, ">");
	      } else if (child.props.i18nIsDynamicList) {
	        stringNode += "<".concat(childIndex, "></").concat(childIndex, ">");
	      } else if (shouldKeepChild && childPropsCount === 1 && typeof childChildren === 'string') {
	        stringNode += "<".concat(child.type, ">").concat(childChildren, "</").concat(child.type, ">");
	      } else {
	        var content = nodesToString(childChildren, i18nOptions);
	        stringNode += "<".concat(childIndex, ">").concat(content, "</").concat(childIndex, ">");
	      }
	    } else if (child === null) {
	      (0, _utils.warn)("Trans: the passed in value is invalid - seems you passed in a null child.");
	    } else if ((0, _typeof2["default"])(child) === 'object') {
	      var format = child.format,
	          clone = (0, _objectWithoutProperties2["default"])(child, _excluded);
	      var keys = Object.keys(clone);
	
	      if (keys.length === 1) {
	        var value = format ? "".concat(keys[0], ", ").concat(format) : keys[0];
	        stringNode += "{{".concat(value, "}}");
	      } else {
	        (0, _utils.warn)("react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.", child);
	      }
	    } else {
	      (0, _utils.warn)("Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.", child);
	    }
	  });
	  return stringNode;
	}
	
	function renderNodes(children, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape) {
	  if (targetString === '') return [];
	  var keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
	  var emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.join('|')).test(targetString);
	  if (!children && !emptyChildrenButNeedsHandling) return [targetString];
	  var data = {};
	
	  function getData(childs) {
	    var childrenArray = getAsArray(childs);
	    childrenArray.forEach(function (child) {
	      if (typeof child === 'string') return;
	      if (hasChildren(child)) getData(getChildren(child));else if ((0, _typeof2["default"])(child) === 'object' && !_react["default"].isValidElement(child)) Object.assign(data, child);
	    });
	  }
	
	  getData(children);
	
	  var ast = _htmlParseStringify["default"].parse("<0>".concat(targetString, "</0>"));
	
	  var opts = _objectSpread(_objectSpread({}, data), combinedTOpts);
	
	  function renderInner(child, node, rootReactNode) {
	    var childs = getChildren(child);
	    var mappedChildren = mapAST(childs, node.children, rootReactNode);
	    return hasValidReactChildren(childs) && mappedChildren.length === 0 ? childs : mappedChildren;
	  }
	
	  function pushTranslatedJSX(child, inner, mem, i, isVoid) {
	    if (child.dummy) child.children = inner;
	    mem.push(_react["default"].cloneElement(child, _objectSpread(_objectSpread({}, child.props), {}, {
	      key: i
	    }), isVoid ? undefined : inner));
	  }
	
	  function mapAST(reactNode, astNode, rootReactNode) {
	    var reactNodes = getAsArray(reactNode);
	    var astNodes = getAsArray(astNode);
	    return astNodes.reduce(function (mem, node, i) {
	      var translationContent = node.children && node.children[0] && node.children[0].content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);
	
	      if (node.type === 'tag') {
	        var tmp = reactNodes[parseInt(node.name, 10)];
	        if (!tmp && rootReactNode.length === 1 && rootReactNode[0][node.name]) tmp = rootReactNode[0][node.name];
	        if (!tmp) tmp = {};
	        var child = Object.keys(node.attrs).length !== 0 ? mergeProps({
	          props: node.attrs
	        }, tmp) : tmp;
	
	        var isElement = _react["default"].isValidElement(child);
	
	        var isValidTranslationWithChildren = isElement && hasChildren(node, true) && !node.voidElement;
	        var isEmptyTransWithHTML = emptyChildrenButNeedsHandling && (0, _typeof2["default"])(child) === 'object' && child.dummy && !isElement;
	        var isKnownComponent = (0, _typeof2["default"])(children) === 'object' && children !== null && Object.hasOwnProperty.call(children, node.name);
	
	        if (typeof child === 'string') {
	          var value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
	          mem.push(value);
	        } else if (hasChildren(child) || isValidTranslationWithChildren) {
	            var inner = renderInner(child, node, rootReactNode);
	            pushTranslatedJSX(child, inner, mem, i);
	          } else if (isEmptyTransWithHTML) {
	          var _inner = mapAST(reactNodes, node.children, rootReactNode);
	
	          mem.push(_react["default"].cloneElement(child, _objectSpread(_objectSpread({}, child.props), {}, {
	            key: i
	          }), _inner));
	        } else if (Number.isNaN(parseFloat(node.name))) {
	          if (isKnownComponent) {
	            var _inner2 = renderInner(child, node, rootReactNode);
	
	            pushTranslatedJSX(child, _inner2, mem, i, node.voidElement);
	          } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
	            if (node.voidElement) {
	              mem.push(_react["default"].createElement(node.name, {
	                key: "".concat(node.name, "-").concat(i)
	              }));
	            } else {
	              var _inner3 = mapAST(reactNodes, node.children, rootReactNode);
	
	              mem.push(_react["default"].createElement(node.name, {
	                key: "".concat(node.name, "-").concat(i)
	              }, _inner3));
	            }
	          } else if (node.voidElement) {
	            mem.push("<".concat(node.name, " />"));
	          } else {
	            var _inner4 = mapAST(reactNodes, node.children, rootReactNode);
	
	            mem.push("<".concat(node.name, ">").concat(_inner4, "</").concat(node.name, ">"));
	          }
	        } else if ((0, _typeof2["default"])(child) === 'object' && !isElement) {
	          var content = node.children[0] ? translationContent : null;
	          if (content) mem.push(content);
	        } else if (node.children.length === 1 && translationContent) {
	          mem.push(_react["default"].cloneElement(child, _objectSpread(_objectSpread({}, child.props), {}, {
	            key: i
	          }), translationContent));
	        } else {
	          mem.push(_react["default"].cloneElement(child, _objectSpread(_objectSpread({}, child.props), {}, {
	            key: i
	          })));
	        }
	      } else if (node.type === 'text') {
	        var wrapTextNodes = i18nOptions.transWrapTextNodes;
	
	        var _content = shouldUnescape ? (0, _htmlEscaper.unescape)(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);
	
	        if (wrapTextNodes) {
	          mem.push(_react["default"].createElement(wrapTextNodes, {
	            key: "".concat(node.name, "-").concat(i)
	          }, _content));
	        } else {
	          mem.push(_content);
	        }
	      }
	
	      return mem;
	    }, []);
	  }
	
	  var result = mapAST([{
	    dummy: true,
	    children: children || []
	  }], ast, getAsArray(children || []));
	  return getChildren(result[0]);
	}
	
	function Trans(_ref) {
	  var children = _ref.children,
	      count = _ref.count,
	      parent = _ref.parent,
	      i18nKey = _ref.i18nKey,
	      _ref$tOptions = _ref.tOptions,
	      tOptions = _ref$tOptions === void 0 ? {} : _ref$tOptions,
	      values = _ref.values,
	      defaults = _ref.defaults,
	      components = _ref.components,
	      ns = _ref.ns,
	      i18nFromProps = _ref.i18n,
	      tFromProps = _ref.t,
	      shouldUnescape = _ref.shouldUnescape,
	      additionalProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded2);
	
	  var _ref2 = (0, _react.useContext)(_context.I18nContext) || {},
	      i18nFromContext = _ref2.i18n,
	      defaultNSFromContext = _ref2.defaultNS;
	
	  var i18n = i18nFromProps || i18nFromContext || (0, _context.getI18n)();
	
	  if (!i18n) {
	    (0, _utils.warnOnce)('You will need to pass in an i18next instance by using i18nextReactModule');
	    return children;
	  }
	
	  var t = tFromProps || i18n.t.bind(i18n) || function (k) {
	    return k;
	  };
	
	  var reactI18nextOptions = _objectSpread(_objectSpread({}, (0, _context.getDefaults)()), i18n.options && i18n.options.react);
	
	  var namespaces = ns || t.ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
	  namespaces = typeof namespaces === 'string' ? [namespaces] : namespaces || ['translation'];
	  var defaultValue = defaults || nodesToString(children, reactI18nextOptions) || reactI18nextOptions.transEmptyNodeValue || i18nKey;
	  var hashTransKey = reactI18nextOptions.hashTransKey;
	  var key = i18nKey || (hashTransKey ? hashTransKey(defaultValue) : defaultValue);
	  var interpolationOverride = values ? tOptions.interpolation : {
	    interpolation: _objectSpread(_objectSpread({}, tOptions.interpolation), {}, {
	      prefix: '#$?',
	      suffix: '?$#'
	    })
	  };
	
	  var combinedTOpts = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, tOptions), {}, {
	    count: count
	  }, values), interpolationOverride), {}, {
	    defaultValue: defaultValue,
	    ns: namespaces
	  });
	
	  var translation = key ? t(key, combinedTOpts) : defaultValue;
	  var content = renderNodes(components || children, translation, i18n, reactI18nextOptions, combinedTOpts, shouldUnescape);
	  var useAsParent = parent !== undefined ? parent : reactI18nextOptions.defaultTransParent;
	  return useAsParent ? _react["default"].createElement(useAsParent, additionalProps, content) : content;
	}

/***/ },
/* 2277 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Translation = Translation;
	
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(320));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(234));
	
	var _useTranslation3 = __webpack_require__(464);
	
	var _excluded = ["ns", "children"];
	
	function Translation(props) {
	  var ns = props.ns,
	      children = props.children,
	      options = (0, _objectWithoutProperties2["default"])(props, _excluded);
	
	  var _useTranslation = (0, _useTranslation3.useTranslation)(ns, options),
	      _useTranslation2 = (0, _slicedToArray2["default"])(_useTranslation, 3),
	      t = _useTranslation2[0],
	      i18n = _useTranslation2[1],
	      ready = _useTranslation2[2];
	
	  return children(t, {
	    i18n: i18n,
	    lng: i18n.language
	  }, ready);
	}

/***/ },
/* 2278 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.withSSR = withSSR;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(27));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(234));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _useSSR = __webpack_require__(934);
	
	var _context = __webpack_require__(184);
	
	var _utils = __webpack_require__(300);
	
	var _excluded = ["initialI18nStore", "initialLanguage"];
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function withSSR() {
	  return function Extend(WrappedComponent) {
	    function I18nextWithSSR(_ref) {
	      var initialI18nStore = _ref.initialI18nStore,
	          initialLanguage = _ref.initialLanguage,
	          rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
	      (0, _useSSR.useSSR)(initialI18nStore, initialLanguage);
	      return _react["default"].createElement(WrappedComponent, _objectSpread({}, rest));
	    }
	
	    I18nextWithSSR.getInitialProps = (0, _context.composeInitialProps)(WrappedComponent);
	    I18nextWithSSR.displayName = "withI18nextSSR(".concat((0, _utils.getDisplayName)(WrappedComponent), ")");
	    I18nextWithSSR.WrappedComponent = WrappedComponent;
	    return I18nextWithSSR;
	  };
	}

/***/ },
/* 2279 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.withTranslation = withTranslation;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(27));
	
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(320));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(234));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _useTranslation3 = __webpack_require__(464);
	
	var _utils = __webpack_require__(300);
	
	var _excluded = ["forwardedRef"];
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function withTranslation(ns) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  return function Extend(WrappedComponent) {
	    function I18nextWithTranslation(_ref) {
	      var forwardedRef = _ref.forwardedRef,
	          rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
	
	      var _useTranslation = (0, _useTranslation3.useTranslation)(ns, rest),
	          _useTranslation2 = (0, _slicedToArray2["default"])(_useTranslation, 3),
	          t = _useTranslation2[0],
	          i18n = _useTranslation2[1],
	          ready = _useTranslation2[2];
	
	      var passDownProps = _objectSpread(_objectSpread({}, rest), {}, {
	        t: t,
	        i18n: i18n,
	        tReady: ready
	      });
	
	      if (options.withRef && forwardedRef) {
	        passDownProps.ref = forwardedRef;
	      } else if (!options.withRef && forwardedRef) {
	        passDownProps.forwardedRef = forwardedRef;
	      }
	
	      return _react["default"].createElement(WrappedComponent, passDownProps);
	    }
	
	    I18nextWithTranslation.displayName = "withI18nextTranslation(".concat((0, _utils.getDisplayName)(WrappedComponent), ")");
	    I18nextWithTranslation.WrappedComponent = WrappedComponent;
	
	    var forwardRef = function forwardRef(props, ref) {
	      return _react["default"].createElement(I18nextWithTranslation, Object.assign({}, props, {
	        forwardedRef: ref
	      }));
	    };
	
	    return options.withRef ? _react["default"].forwardRef(forwardRef) : I18nextWithTranslation;
	  };
	}

/***/ },
/* 2280 */
/***/ function(module, exports) {

	/** @license React v16.13.1
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
	exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
	exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
	exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ },
/* 2281 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.bodyOpenClassName = exports.portalClassName = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ModalPortal = __webpack_require__(2282);
	
	var _ModalPortal2 = _interopRequireDefault(_ModalPortal);
	
	var _ariaAppHider = __webpack_require__(936);
	
	var ariaAppHider = _interopRequireWildcard(_ariaAppHider);
	
	var _safeHTMLElement = __webpack_require__(465);
	
	var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);
	
	var _reactLifecyclesCompat = __webpack_require__(227);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var portalClassName = exports.portalClassName = "ReactModalPortal";
	var bodyOpenClassName = exports.bodyOpenClassName = "ReactModal__Body--open";
	
	var isReact16 = _safeHTMLElement.canUseDOM && _reactDom2.default.createPortal !== undefined;
	
	var createHTMLElement = function createHTMLElement(name) {
	  return document.createElement(name);
	};
	
	var getCreatePortal = function getCreatePortal() {
	  return isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;
	};
	
	function getParentElement(parentSelector) {
	  return parentSelector();
	}
	
	var Modal = function (_Component) {
	  _inherits(Modal, _Component);
	
	  function Modal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Modal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function () {
	      !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
	      var parent = getParentElement(_this.props.parentSelector);
	      if (parent && parent.contains(_this.node)) {
	        parent.removeChild(_this.node);
	      } else {
	        // eslint-disable-next-line no-console
	        console.warn('React-Modal: "parentSelector" prop did not returned any DOM ' + "element. Make sure that the parent element is unmounted to " + "avoid any memory leaks.");
	      }
	    }, _this.portalRef = function (ref) {
	      _this.portal = ref;
	    }, _this.renderPortal = function (props) {
	      var createPortal = getCreatePortal();
	      var portal = createPortal(_this, _react2.default.createElement(_ModalPortal2.default, _extends({ defaultStyles: Modal.defaultStyles }, props)), _this.node);
	      _this.portalRef(portal);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Modal, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (!_safeHTMLElement.canUseDOM) return;
	
	      if (!isReact16) {
	        this.node = createHTMLElement("div");
	      }
	      this.node.className = this.props.portalClassName;
	
	      var parent = getParentElement(this.props.parentSelector);
	      parent.appendChild(this.node);
	
	      !isReact16 && this.renderPortal(this.props);
	    }
	  }, {
	    key: "getSnapshotBeforeUpdate",
	    value: function getSnapshotBeforeUpdate(prevProps) {
	      var prevParent = getParentElement(prevProps.parentSelector);
	      var nextParent = getParentElement(this.props.parentSelector);
	      return { prevParent: prevParent, nextParent: nextParent };
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, _, snapshot) {
	      if (!_safeHTMLElement.canUseDOM) return;
	      var _props = this.props,
	          isOpen = _props.isOpen,
	          portalClassName = _props.portalClassName;
	
	
	      if (prevProps.portalClassName !== portalClassName) {
	        this.node.className = portalClassName;
	      }
	
	      var prevParent = snapshot.prevParent,
	          nextParent = snapshot.nextParent;
	
	      if (nextParent !== prevParent) {
	        prevParent.removeChild(this.node);
	        nextParent.appendChild(this.node);
	      }
	
	      // Stop unnecessary renders if modal is remaining closed
	      if (!prevProps.isOpen && !isOpen) return;
	
	      !isReact16 && this.renderPortal(this.props);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (!_safeHTMLElement.canUseDOM || !this.node || !this.portal) return;
	
	      var state = this.portal.state;
	      var now = Date.now();
	      var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);
	
	      if (closesAt) {
	        if (!state.beforeClose) {
	          this.portal.closeWithTimeout();
	        }
	
	        setTimeout(this.removePortal, closesAt - now);
	      } else {
	        this.removePortal();
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      if (!_safeHTMLElement.canUseDOM || !isReact16) {
	        return null;
	      }
	
	      if (!this.node && isReact16) {
	        this.node = createHTMLElement("div");
	      }
	
	      var createPortal = getCreatePortal();
	      return createPortal(_react2.default.createElement(_ModalPortal2.default, _extends({
	        ref: this.portalRef,
	        defaultStyles: Modal.defaultStyles
	      }, this.props)), this.node);
	    }
	  }], [{
	    key: "setAppElement",
	    value: function setAppElement(element) {
	      ariaAppHider.setElement(element);
	    }
	
	    /* eslint-disable react/no-unused-prop-types */
	
	    /* eslint-enable react/no-unused-prop-types */
	
	  }]);
	
	  return Modal;
	}(_react.Component);
	
	Modal.propTypes = {
	  isOpen: _propTypes2.default.bool.isRequired,
	  style: _propTypes2.default.shape({
	    content: _propTypes2.default.object,
	    overlay: _propTypes2.default.object
	  }),
	  portalClassName: _propTypes2.default.string,
	  bodyOpenClassName: _propTypes2.default.string,
	  htmlOpenClassName: _propTypes2.default.string,
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	    base: _propTypes2.default.string.isRequired,
	    afterOpen: _propTypes2.default.string.isRequired,
	    beforeClose: _propTypes2.default.string.isRequired
	  })]),
	  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	    base: _propTypes2.default.string.isRequired,
	    afterOpen: _propTypes2.default.string.isRequired,
	    beforeClose: _propTypes2.default.string.isRequired
	  })]),
	  appElement: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_safeHTMLElement2.default), _propTypes2.default.instanceOf(_safeHTMLElement.SafeHTMLCollection), _propTypes2.default.instanceOf(_safeHTMLElement.SafeNodeList), _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_safeHTMLElement2.default))]),
	  onAfterOpen: _propTypes2.default.func,
	  onRequestClose: _propTypes2.default.func,
	  closeTimeoutMS: _propTypes2.default.number,
	  ariaHideApp: _propTypes2.default.bool,
	  shouldFocusAfterRender: _propTypes2.default.bool,
	  shouldCloseOnOverlayClick: _propTypes2.default.bool,
	  shouldReturnFocusAfterClose: _propTypes2.default.bool,
	  preventScroll: _propTypes2.default.bool,
	  parentSelector: _propTypes2.default.func,
	  aria: _propTypes2.default.object,
	  data: _propTypes2.default.object,
	  role: _propTypes2.default.string,
	  contentLabel: _propTypes2.default.string,
	  shouldCloseOnEsc: _propTypes2.default.bool,
	  overlayRef: _propTypes2.default.func,
	  contentRef: _propTypes2.default.func,
	  id: _propTypes2.default.string,
	  overlayElement: _propTypes2.default.func,
	  contentElement: _propTypes2.default.func
	};
	Modal.defaultProps = {
	  isOpen: false,
	  portalClassName: portalClassName,
	  bodyOpenClassName: bodyOpenClassName,
	  role: "dialog",
	  ariaHideApp: true,
	  closeTimeoutMS: 0,
	  shouldFocusAfterRender: true,
	  shouldCloseOnEsc: true,
	  shouldCloseOnOverlayClick: true,
	  shouldReturnFocusAfterClose: true,
	  preventScroll: false,
	  parentSelector: function parentSelector() {
	    return document.body;
	  },
	  overlayElement: function overlayElement(props, contentEl) {
	    return _react2.default.createElement(
	      "div",
	      props,
	      contentEl
	    );
	  },
	  contentElement: function contentElement(props, children) {
	    return _react2.default.createElement(
	      "div",
	      props,
	      children
	    );
	  }
	};
	Modal.defaultStyles = {
	  overlay: {
	    position: "fixed",
	    top: 0,
	    left: 0,
	    right: 0,
	    bottom: 0,
	    backgroundColor: "rgba(255, 255, 255, 0.75)"
	  },
	  content: {
	    position: "absolute",
	    top: "40px",
	    left: "40px",
	    right: "40px",
	    bottom: "40px",
	    border: "1px solid #ccc",
	    background: "#fff",
	    overflow: "auto",
	    WebkitOverflowScrolling: "touch",
	    borderRadius: "4px",
	    outline: "none",
	    padding: "20px"
	  }
	};
	
	
	(0, _reactLifecyclesCompat.polyfill)(Modal);
	
	if (false) {
	  Modal.setCreateHTMLElement = function (fn) {
	    return createHTMLElement = fn;
	  };
	}
	
	exports.default = Modal;

/***/ },
/* 2282 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _focusManager = __webpack_require__(2285);
	
	var focusManager = _interopRequireWildcard(_focusManager);
	
	var _scopeTab = __webpack_require__(2286);
	
	var _scopeTab2 = _interopRequireDefault(_scopeTab);
	
	var _ariaAppHider = __webpack_require__(936);
	
	var ariaAppHider = _interopRequireWildcard(_ariaAppHider);
	
	var _classList = __webpack_require__(2284);
	
	var classList = _interopRequireWildcard(_classList);
	
	var _safeHTMLElement = __webpack_require__(465);
	
	var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);
	
	var _portalOpenInstances = __webpack_require__(937);
	
	var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);
	
	__webpack_require__(2283);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// so that our CSS is statically analyzable
	var CLASS_NAMES = {
	  overlay: "ReactModal__Overlay",
	  content: "ReactModal__Content"
	};
	
	var TAB_KEY = 9;
	var ESC_KEY = 27;
	
	var ariaHiddenInstances = 0;
	
	var ModalPortal = function (_Component) {
	  _inherits(ModalPortal, _Component);
	
	  function ModalPortal(props) {
	    _classCallCheck(this, ModalPortal);
	
	    var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));
	
	    _this.setOverlayRef = function (overlay) {
	      _this.overlay = overlay;
	      _this.props.overlayRef && _this.props.overlayRef(overlay);
	    };
	
	    _this.setContentRef = function (content) {
	      _this.content = content;
	      _this.props.contentRef && _this.props.contentRef(content);
	    };
	
	    _this.afterClose = function () {
	      var _this$props = _this.props,
	          appElement = _this$props.appElement,
	          ariaHideApp = _this$props.ariaHideApp,
	          htmlOpenClassName = _this$props.htmlOpenClassName,
	          bodyOpenClassName = _this$props.bodyOpenClassName;
	
	      // Remove classes.
	
	      bodyOpenClassName && classList.remove(document.body, bodyOpenClassName);
	
	      htmlOpenClassName && classList.remove(document.getElementsByTagName("html")[0], htmlOpenClassName);
	
	      // Reset aria-hidden attribute if all modals have been removed
	      if (ariaHideApp && ariaHiddenInstances > 0) {
	        ariaHiddenInstances -= 1;
	
	        if (ariaHiddenInstances === 0) {
	          ariaAppHider.show(appElement);
	        }
	      }
	
	      if (_this.props.shouldFocusAfterRender) {
	        if (_this.props.shouldReturnFocusAfterClose) {
	          focusManager.returnFocus(_this.props.preventScroll);
	          focusManager.teardownScopedFocus();
	        } else {
	          focusManager.popWithoutFocus();
	        }
	      }
	
	      if (_this.props.onAfterClose) {
	        _this.props.onAfterClose();
	      }
	
	      _portalOpenInstances2.default.deregister(_this);
	    };
	
	    _this.open = function () {
	      _this.beforeOpen();
	      if (_this.state.afterOpen && _this.state.beforeClose) {
	        clearTimeout(_this.closeTimer);
	        _this.setState({ beforeClose: false });
	      } else {
	        if (_this.props.shouldFocusAfterRender) {
	          focusManager.setupScopedFocus(_this.node);
	          focusManager.markForFocusLater();
	        }
	
	        _this.setState({ isOpen: true }, function () {
	          _this.openAnimationFrame = requestAnimationFrame(function () {
	            _this.setState({ afterOpen: true });
	
	            if (_this.props.isOpen && _this.props.onAfterOpen) {
	              _this.props.onAfterOpen({
	                overlayEl: _this.overlay,
	                contentEl: _this.content
	              });
	            }
	          });
	        });
	      }
	    };
	
	    _this.close = function () {
	      if (_this.props.closeTimeoutMS > 0) {
	        _this.closeWithTimeout();
	      } else {
	        _this.closeWithoutTimeout();
	      }
	    };
	
	    _this.focusContent = function () {
	      return _this.content && !_this.contentHasFocus() && _this.content.focus({ preventScroll: true });
	    };
	
	    _this.closeWithTimeout = function () {
	      var closesAt = Date.now() + _this.props.closeTimeoutMS;
	      _this.setState({ beforeClose: true, closesAt: closesAt }, function () {
	        _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
	      });
	    };
	
	    _this.closeWithoutTimeout = function () {
	      _this.setState({
	        beforeClose: false,
	        isOpen: false,
	        afterOpen: false,
	        closesAt: null
	      }, _this.afterClose);
	    };
	
	    _this.handleKeyDown = function (event) {
	      if (event.keyCode === TAB_KEY) {
	        (0, _scopeTab2.default)(_this.content, event);
	      }
	
	      if (_this.props.shouldCloseOnEsc && event.keyCode === ESC_KEY) {
	        event.stopPropagation();
	        _this.requestClose(event);
	      }
	    };
	
	    _this.handleOverlayOnClick = function (event) {
	      if (_this.shouldClose === null) {
	        _this.shouldClose = true;
	      }
	
	      if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
	        if (_this.ownerHandlesClose()) {
	          _this.requestClose(event);
	        } else {
	          _this.focusContent();
	        }
	      }
	      _this.shouldClose = null;
	    };
	
	    _this.handleContentOnMouseUp = function () {
	      _this.shouldClose = false;
	    };
	
	    _this.handleOverlayOnMouseDown = function (event) {
	      if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) {
	        event.preventDefault();
	      }
	    };
	
	    _this.handleContentOnClick = function () {
	      _this.shouldClose = false;
	    };
	
	    _this.handleContentOnMouseDown = function () {
	      _this.shouldClose = false;
	    };
	
	    _this.requestClose = function (event) {
	      return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
	    };
	
	    _this.ownerHandlesClose = function () {
	      return _this.props.onRequestClose;
	    };
	
	    _this.shouldBeClosed = function () {
	      return !_this.state.isOpen && !_this.state.beforeClose;
	    };
	
	    _this.contentHasFocus = function () {
	      return document.activeElement === _this.content || _this.content.contains(document.activeElement);
	    };
	
	    _this.buildClassName = function (which, additional) {
	      var classNames = (typeof additional === "undefined" ? "undefined" : _typeof(additional)) === "object" ? additional : {
	        base: CLASS_NAMES[which],
	        afterOpen: CLASS_NAMES[which] + "--after-open",
	        beforeClose: CLASS_NAMES[which] + "--before-close"
	      };
	      var className = classNames.base;
	      if (_this.state.afterOpen) {
	        className = className + " " + classNames.afterOpen;
	      }
	      if (_this.state.beforeClose) {
	        className = className + " " + classNames.beforeClose;
	      }
	      return typeof additional === "string" && additional ? className + " " + additional : className;
	    };
	
	    _this.attributesFromObject = function (prefix, items) {
	      return Object.keys(items).reduce(function (acc, name) {
	        acc[prefix + "-" + name] = items[name];
	        return acc;
	      }, {});
	    };
	
	    _this.state = {
	      afterOpen: false,
	      beforeClose: false
	    };
	
	    _this.shouldClose = null;
	    _this.moveFromContentToOverlay = null;
	    return _this;
	  }
	
	  _createClass(ModalPortal, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (this.props.isOpen) {
	        this.open();
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (false) {
	        if (prevProps.bodyOpenClassName !== this.props.bodyOpenClassName) {
	          // eslint-disable-next-line no-console
	          console.warn('React-Modal: "bodyOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
	        }
	        if (prevProps.htmlOpenClassName !== this.props.htmlOpenClassName) {
	          // eslint-disable-next-line no-console
	          console.warn('React-Modal: "htmlOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
	        }
	      }
	
	      if (this.props.isOpen && !prevProps.isOpen) {
	        this.open();
	      } else if (!this.props.isOpen && prevProps.isOpen) {
	        this.close();
	      }
	
	      // Focus only needs to be set once when the modal is being opened
	      if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) {
	        this.focusContent();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.state.isOpen) {
	        this.afterClose();
	      }
	      clearTimeout(this.closeTimer);
	      cancelAnimationFrame(this.openAnimationFrame);
	    }
	  }, {
	    key: "beforeOpen",
	    value: function beforeOpen() {
	      var _props = this.props,
	          appElement = _props.appElement,
	          ariaHideApp = _props.ariaHideApp,
	          htmlOpenClassName = _props.htmlOpenClassName,
	          bodyOpenClassName = _props.bodyOpenClassName;
	
	      // Add classes.
	
	      bodyOpenClassName && classList.add(document.body, bodyOpenClassName);
	
	      htmlOpenClassName && classList.add(document.getElementsByTagName("html")[0], htmlOpenClassName);
	
	      if (ariaHideApp) {
	        ariaHiddenInstances += 1;
	        ariaAppHider.hide(appElement);
	      }
	
	      _portalOpenInstances2.default.register(this);
	    }
	
	    // Don't steal focus from inner elements
	
	  }, {
	    key: "render",
	    value: function render() {
	      var _props2 = this.props,
	          id = _props2.id,
	          className = _props2.className,
	          overlayClassName = _props2.overlayClassName,
	          defaultStyles = _props2.defaultStyles,
	          children = _props2.children;
	
	      var contentStyles = className ? {} : defaultStyles.content;
	      var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;
	
	      if (this.shouldBeClosed()) {
	        return null;
	      }
	
	      var overlayProps = {
	        ref: this.setOverlayRef,
	        className: this.buildClassName("overlay", overlayClassName),
	        style: _extends({}, overlayStyles, this.props.style.overlay),
	        onClick: this.handleOverlayOnClick,
	        onMouseDown: this.handleOverlayOnMouseDown
	      };
	
	      var contentProps = _extends({
	        id: id,
	        ref: this.setContentRef,
	        style: _extends({}, contentStyles, this.props.style.content),
	        className: this.buildClassName("content", className),
	        tabIndex: "-1",
	        onKeyDown: this.handleKeyDown,
	        onMouseDown: this.handleContentOnMouseDown,
	        onMouseUp: this.handleContentOnMouseUp,
	        onClick: this.handleContentOnClick,
	        role: this.props.role,
	        "aria-label": this.props.contentLabel
	      }, this.attributesFromObject("aria", _extends({ modal: true }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
	        "data-testid": this.props.testId
	      });
	
	      var contentElement = this.props.contentElement(contentProps, children);
	      return this.props.overlayElement(overlayProps, contentElement);
	    }
	  }]);
	
	  return ModalPortal;
	}(_react.Component);
	
	ModalPortal.defaultProps = {
	  style: {
	    overlay: {},
	    content: {}
	  },
	  defaultStyles: {}
	};
	ModalPortal.propTypes = {
	  isOpen: _propTypes2.default.bool.isRequired,
	  defaultStyles: _propTypes2.default.shape({
	    content: _propTypes2.default.object,
	    overlay: _propTypes2.default.object
	  }),
	  style: _propTypes2.default.shape({
	    content: _propTypes2.default.object,
	    overlay: _propTypes2.default.object
	  }),
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  bodyOpenClassName: _propTypes2.default.string,
	  htmlOpenClassName: _propTypes2.default.string,
	  ariaHideApp: _propTypes2.default.bool,
	  appElement: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_safeHTMLElement2.default), _propTypes2.default.instanceOf(_safeHTMLElement.SafeHTMLCollection), _propTypes2.default.instanceOf(_safeHTMLElement.SafeNodeList), _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_safeHTMLElement2.default))]),
	  onAfterOpen: _propTypes2.default.func,
	  onAfterClose: _propTypes2.default.func,
	  onRequestClose: _propTypes2.default.func,
	  closeTimeoutMS: _propTypes2.default.number,
	  shouldFocusAfterRender: _propTypes2.default.bool,
	  shouldCloseOnOverlayClick: _propTypes2.default.bool,
	  shouldReturnFocusAfterClose: _propTypes2.default.bool,
	  preventScroll: _propTypes2.default.bool,
	  role: _propTypes2.default.string,
	  contentLabel: _propTypes2.default.string,
	  aria: _propTypes2.default.object,
	  data: _propTypes2.default.object,
	  children: _propTypes2.default.node,
	  shouldCloseOnEsc: _propTypes2.default.bool,
	  overlayRef: _propTypes2.default.func,
	  contentRef: _propTypes2.default.func,
	  id: _propTypes2.default.string,
	  overlayElement: _propTypes2.default.func,
	  contentElement: _propTypes2.default.func,
	  testId: _propTypes2.default.string
	};
	exports.default = ModalPortal;
	module.exports = exports["default"];

/***/ },
/* 2283 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.resetState = resetState;
	exports.log = log;
	
	var _portalOpenInstances = __webpack_require__(937);
	
	var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Body focus trap see Issue #742
	
	var before = void 0,
	    after = void 0,
	    instances = [];
	
	/* eslint-disable no-console */
	/* istanbul ignore next */
	function resetState() {
	  var _arr = [before, after];
	
	  for (var _i = 0; _i < _arr.length; _i++) {
	    var item = _arr[_i];
	    if (!item) continue;
	    item.parentNode && item.parentNode.removeChild(item);
	  }
	  before = after = null;
	  instances = [];
	}
	
	/* istanbul ignore next */
	function log() {
	  console.log("bodyTrap ----------");
	  console.log(instances.length);
	  var _arr2 = [before, after];
	  for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
	    var item = _arr2[_i2];
	    var check = item || {};
	    console.log(check.nodeName, check.className, check.id);
	  }
	  console.log("edn bodyTrap ----------");
	}
	/* eslint-enable no-console */
	
	function focusContent() {
	  if (instances.length === 0) {
	    if (false) {
	      // eslint-disable-next-line no-console
	      console.warn("React-Modal: Open instances > 0 expected");
	    }
	    return;
	  }
	  instances[instances.length - 1].focusContent();
	}
	
	function bodyTrap(eventType, openInstances) {
	  if (!before && !after) {
	    before = document.createElement("div");
	    before.setAttribute("data-react-modal-body-trap", "");
	    before.style.position = "absolute";
	    before.style.opacity = "0";
	    before.setAttribute("tabindex", "0");
	    before.addEventListener("focus", focusContent);
	    after = before.cloneNode();
	    after.addEventListener("focus", focusContent);
	  }
	
	  instances = openInstances;
	
	  if (instances.length > 0) {
	    // Add focus trap
	    if (document.body.firstChild !== before) {
	      document.body.insertBefore(before, document.body.firstChild);
	    }
	    if (document.body.lastChild !== after) {
	      document.body.appendChild(after);
	    }
	  } else {
	    // Remove focus trap
	    if (before.parentElement) {
	      before.parentElement.removeChild(before);
	    }
	    if (after.parentElement) {
	      after.parentElement.removeChild(after);
	    }
	  }
	}
	
	_portalOpenInstances2.default.subscribe(bodyTrap);

/***/ },
/* 2284 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.resetState = resetState;
	exports.log = log;
	var htmlClassList = {};
	var docBodyClassList = {};
	
	/* eslint-disable no-console */
	/* istanbul ignore next */
	function removeClass(at, cls) {
	  at.classList.remove(cls);
	}
	
	/* istanbul ignore next */
	function resetState() {
	  var htmlElement = document.getElementsByTagName("html")[0];
	  for (var cls in htmlClassList) {
	    removeClass(htmlElement, htmlClassList[cls]);
	  }
	
	  var body = document.body;
	  for (var _cls in docBodyClassList) {
	    removeClass(body, docBodyClassList[_cls]);
	  }
	
	  htmlClassList = {};
	  docBodyClassList = {};
	}
	
	/* istanbul ignore next */
	function log() {
	  if (false) {
	    var classes = document.getElementsByTagName("html")[0].className;
	    var buffer = "Show tracked classes:\n\n";
	
	    buffer += "<html /> (" + classes + "):\n  ";
	    for (var x in htmlClassList) {
	      buffer += "  " + x + " " + htmlClassList[x] + "\n  ";
	    }
	
	    classes = document.body.className;
	
	    buffer += "\n\ndoc.body (" + classes + "):\n  ";
	    for (var _x in docBodyClassList) {
	      buffer += "  " + _x + " " + docBodyClassList[_x] + "\n  ";
	    }
	
	    buffer += "\n";
	
	    console.log(buffer);
	  }
	}
	/* eslint-enable no-console */
	
	/**
	 * Track the number of reference of a class.
	 * @param {object} poll The poll to receive the reference.
	 * @param {string} className The class name.
	 * @return {string}
	 */
	var incrementReference = function incrementReference(poll, className) {
	  if (!poll[className]) {
	    poll[className] = 0;
	  }
	  poll[className] += 1;
	  return className;
	};
	
	/**
	 * Drop the reference of a class.
	 * @param {object} poll The poll to receive the reference.
	 * @param {string} className The class name.
	 * @return {string}
	 */
	var decrementReference = function decrementReference(poll, className) {
	  if (poll[className]) {
	    poll[className] -= 1;
	  }
	  return className;
	};
	
	/**
	 * Track a class and add to the given class list.
	 * @param {Object} classListRef A class list of an element.
	 * @param {Object} poll         The poll to be used.
	 * @param {Array}  classes      The list of classes to be tracked.
	 */
	var trackClass = function trackClass(classListRef, poll, classes) {
	  classes.forEach(function (className) {
	    incrementReference(poll, className);
	    classListRef.add(className);
	  });
	};
	
	/**
	 * Untrack a class and remove from the given class list if the reference
	 * reaches 0.
	 * @param {Object} classListRef A class list of an element.
	 * @param {Object} poll         The poll to be used.
	 * @param {Array}  classes      The list of classes to be untracked.
	 */
	var untrackClass = function untrackClass(classListRef, poll, classes) {
	  classes.forEach(function (className) {
	    decrementReference(poll, className);
	    poll[className] === 0 && classListRef.remove(className);
	  });
	};
	
	/**
	 * Public inferface to add classes to the document.body.
	 * @param {string} bodyClass The class string to be added.
	 *                           It may contain more then one class
	 *                           with ' ' as separator.
	 */
	var add = exports.add = function add(element, classString) {
	  return trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
	};
	
	/**
	 * Public inferface to remove classes from the document.body.
	 * @param {string} bodyClass The class string to be added.
	 *                           It may contain more then one class
	 *                           with ' ' as separator.
	 */
	var remove = exports.remove = function remove(element, classString) {
	  return untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
	};

/***/ },
/* 2285 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.resetState = resetState;
	exports.log = log;
	exports.handleBlur = handleBlur;
	exports.handleFocus = handleFocus;
	exports.markForFocusLater = markForFocusLater;
	exports.returnFocus = returnFocus;
	exports.popWithoutFocus = popWithoutFocus;
	exports.setupScopedFocus = setupScopedFocus;
	exports.teardownScopedFocus = teardownScopedFocus;
	
	var _tabbable = __webpack_require__(938);
	
	var _tabbable2 = _interopRequireDefault(_tabbable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var focusLaterElements = [];
	var modalElement = null;
	var needToFocus = false;
	
	/* eslint-disable no-console */
	/* istanbul ignore next */
	function resetState() {
	  focusLaterElements = [];
	}
	
	/* istanbul ignore next */
	function log() {
	  if (false) {
	    console.log("focusManager ----------");
	    focusLaterElements.forEach(function (f) {
	      var check = f || {};
	      console.log(check.nodeName, check.className, check.id);
	    });
	    console.log("end focusManager ----------");
	  }
	}
	/* eslint-enable no-console */
	
	function handleBlur() {
	  needToFocus = true;
	}
	
	function handleFocus() {
	  if (needToFocus) {
	    needToFocus = false;
	    if (!modalElement) {
	      return;
	    }
	    // need to see how jQuery shims document.on('focusin') so we don't need the
	    // setTimeout, firefox doesn't support focusin, if it did, we could focus
	    // the element outside of a setTimeout. Side-effect of this implementation
	    // is that the document.body gets focus, and then we focus our element right
	    // after, seems fine.
	    setTimeout(function () {
	      if (modalElement.contains(document.activeElement)) {
	        return;
	      }
	      var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
	      el.focus();
	    }, 0);
	  }
	}
	
	function markForFocusLater() {
	  focusLaterElements.push(document.activeElement);
	}
	
	/* eslint-disable no-console */
	function returnFocus() {
	  var preventScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	  var toFocus = null;
	  try {
	    if (focusLaterElements.length !== 0) {
	      toFocus = focusLaterElements.pop();
	      toFocus.focus({ preventScroll: preventScroll });
	    }
	    return;
	  } catch (e) {
	    console.warn(["You tried to return focus to", toFocus, "but it is not in the DOM anymore"].join(" "));
	  }
	}
	/* eslint-enable no-console */
	
	function popWithoutFocus() {
	  focusLaterElements.length > 0 && focusLaterElements.pop();
	}
	
	function setupScopedFocus(element) {
	  modalElement = element;
	
	  if (window.addEventListener) {
	    window.addEventListener("blur", handleBlur, false);
	    document.addEventListener("focus", handleFocus, true);
	  } else {
	    window.attachEvent("onBlur", handleBlur);
	    document.attachEvent("onFocus", handleFocus);
	  }
	}
	
	function teardownScopedFocus() {
	  modalElement = null;
	
	  if (window.addEventListener) {
	    window.removeEventListener("blur", handleBlur);
	    document.removeEventListener("focus", handleFocus);
	  } else {
	    window.detachEvent("onBlur", handleBlur);
	    document.detachEvent("onFocus", handleFocus);
	  }
	}

/***/ },
/* 2286 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = scopeTab;
	
	var _tabbable = __webpack_require__(938);
	
	var _tabbable2 = _interopRequireDefault(_tabbable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getActiveElement() {
	  var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
	
	  return el.activeElement.shadowRoot ? getActiveElement(el.activeElement.shadowRoot) : el.activeElement;
	}
	
	function scopeTab(node, event) {
	  var tabbable = (0, _tabbable2.default)(node);
	
	  if (!tabbable.length) {
	    // Do nothing, since there are no elements that can receive focus.
	    event.preventDefault();
	    return;
	  }
	
	  var target = void 0;
	
	  var shiftKey = event.shiftKey;
	  var head = tabbable[0];
	  var tail = tabbable[tabbable.length - 1];
	  var activeElement = getActiveElement();
	
	  // proceed with default browser behavior on tab.
	  // Focus on last element on shift + tab.
	  if (node === activeElement) {
	    if (!shiftKey) return;
	    target = tail;
	  }
	
	  if (tail === activeElement && !shiftKey) {
	    target = head;
	  }
	
	  if (head === activeElement && shiftKey) {
	    target = tail;
	  }
	
	  if (target) {
	    event.preventDefault();
	    target.focus();
	    return;
	  }
	
	  // Safari radio issue.
	  //
	  // Safari does not move the focus to the radio button,
	  // so we need to force it to really walk through all elements.
	  //
	  // This is very error prone, since we are trying to guess
	  // if it is a safari browser from the first occurence between
	  // chrome or safari.
	  //
	  // The chrome user agent contains the first ocurrence
	  // as the 'chrome/version' and later the 'safari/version'.
	  var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
	  var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;
	
	  // If we are not in safari desktop, let the browser control
	  // the focus
	  if (!isSafariDesktop) return;
	
	  var x = tabbable.indexOf(activeElement);
	
	  if (x > -1) {
	    x += shiftKey ? -1 : 1;
	  }
	
	  target = tabbable[x];
	
	  // If the tabbable element does not exist,
	  // focus head/tail based on shiftKey
	  if (typeof target === "undefined") {
	    event.preventDefault();
	    target = shiftKey ? tail : head;
	    target.focus();
	    return;
	  }
	
	  event.preventDefault();
	
	  target.focus();
	}
	module.exports = exports["default"];

/***/ },
/* 2287 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _componentOrElement = __webpack_require__(294);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _getContainer = __webpack_require__(301);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	var _ownerDocument = __webpack_require__(185);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
	 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
	 * The children of `<Portal/>` component will be appended to the `container` specified.
	 */
	var Portal = function (_React$Component) {
	  _inherits(Portal, _React$Component);
	
	  function Portal() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Portal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._mountOverlayTarget = function () {
	      if (!_this._overlayTarget) {
	        _this._overlayTarget = document.createElement('div');
	        _this._portalContainerNode = (0, _getContainer2.default)(_this.props.container, (0, _ownerDocument2.default)(_this).body);
	        _this._portalContainerNode.appendChild(_this._overlayTarget);
	      }
	    }, _this._unmountOverlayTarget = function () {
	      if (_this._overlayTarget) {
	        _this._portalContainerNode.removeChild(_this._overlayTarget);
	        _this._overlayTarget = null;
	      }
	      _this._portalContainerNode = null;
	    }, _this._renderOverlay = function () {
	      var overlay = !_this.props.children ? null : _react2.default.Children.only(_this.props.children);
	
	      // Save reference for future access.
	      if (overlay !== null) {
	        _this._mountOverlayTarget();
	
	        var initialRender = !_this._overlayInstance;
	
	        _this._overlayInstance = _reactDom2.default.unstable_renderSubtreeIntoContainer(_this, overlay, _this._overlayTarget, function () {
	          if (initialRender && _this.props.onRendered) {
	            _this.props.onRendered();
	          }
	        });
	      } else {
	        // Unrender if the component is null for transitions to null
	        _this._unrenderOverlay();
	        _this._unmountOverlayTarget();
	      }
	    }, _this._unrenderOverlay = function () {
	      if (_this._overlayTarget) {
	        _reactDom2.default.unmountComponentAtNode(_this._overlayTarget);
	        _this._overlayInstance = null;
	      }
	    }, _this.getMountNode = function () {
	      return _this._overlayTarget;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Portal.prototype.componentDidMount = function componentDidMount() {
	    this._isMounted = true;
	    this._renderOverlay();
	  };
	
	  Portal.prototype.componentDidUpdate = function componentDidUpdate() {
	    this._renderOverlay();
	  };
	
	  Portal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this._overlayTarget && nextProps.container !== this.props.container) {
	      this._portalContainerNode.removeChild(this._overlayTarget);
	      this._portalContainerNode = (0, _getContainer2.default)(nextProps.container, (0, _ownerDocument2.default)(this).body);
	      this._portalContainerNode.appendChild(this._overlayTarget);
	    }
	  };
	
	  Portal.prototype.componentWillUnmount = function componentWillUnmount() {
	    this._isMounted = false;
	    this._unrenderOverlay();
	    this._unmountOverlayTarget();
	  };
	
	  Portal.prototype.render = function render() {
	    return null;
	  };
	
	  return Portal;
	}(_react2.default.Component);
	
	Portal.displayName = 'Portal';
	Portal.propTypes = {
	  /**
	   * A Node, Component instance, or function that returns either. The `container` will have the Portal children
	   * appended to it.
	   */
	  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
	
	  onRendered: _propTypes2.default.func
	};
	exports.default = Portal;
	module.exports = exports['default'];

/***/ },
/* 2288 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _activeElement = __webpack_require__(674);
	
	var _activeElement2 = _interopRequireDefault(_activeElement);
	
	var _contains = __webpack_require__(174);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _inDOM = __webpack_require__(123);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _componentOrElement = __webpack_require__(294);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _deprecated = __webpack_require__(2198);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _elementType = __webpack_require__(909);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _warning = __webpack_require__(2296);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ModalManager = __webpack_require__(2289);
	
	var _ModalManager2 = _interopRequireDefault(_ModalManager);
	
	var _Portal = __webpack_require__(941);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _RefHolder = __webpack_require__(2292);
	
	var _RefHolder2 = _interopRequireDefault(_RefHolder);
	
	var _addEventListener = __webpack_require__(944);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _addFocusListener = __webpack_require__(2293);
	
	var _addFocusListener2 = _interopRequireDefault(_addFocusListener);
	
	var _getContainer = __webpack_require__(301);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	var _ownerDocument = __webpack_require__(185);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/prop-types */
	
	var modalManager = new _ModalManager2.default();
	
	/**
	 * Love them or hate them, `<Modal/>` provides a solid foundation for creating dialogs, lightboxes, or whatever else.
	 * The Modal component renders its `children` node in front of a backdrop component.
	 *
	 * The Modal offers a few helpful features over using just a `<Portal/>` component and some styles:
	 *
	 * - Manages dialog stacking when one-at-a-time just isn't enough.
	 * - Creates a backdrop, for disabling interaction below the modal.
	 * - It properly manages focus; moving to the modal content, and keeping it there until the modal is closed.
	 * - It disables scrolling of the page content while open.
	 * - Adds the appropriate ARIA roles are automatically.
	 * - Easily pluggable animations via a `<Transition/>` component.
	 *
	 * Note that, in the same way the backdrop element prevents users from clicking or interacting
	 * with the page content underneath the Modal, Screen readers also need to be signaled to not to
	 * interact with page content while the Modal is open. To do this, we use a common technique of applying
	 * the `aria-hidden='true'` attribute to the non-Modal elements in the Modal `container`. This means that for
	 * a Modal to be truly modal, it should have a `container` that is _outside_ your app's
	 * React hierarchy (such as the default: document.body).
	 */
	
	var Modal = function (_React$Component) {
	  _inherits(Modal, _React$Component);
	
	  function Modal() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Modal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Modal.prototype.omitProps = function omitProps(props, propTypes) {
	
	    var keys = Object.keys(props);
	    var newProps = {};
	    keys.map(function (prop) {
	      if (!Object.prototype.hasOwnProperty.call(propTypes, prop)) {
	        newProps[prop] = props[prop];
	      }
	    });
	
	    return newProps;
	  };
	
	  Modal.prototype.render = function render() {
	    var _props = this.props,
	        show = _props.show,
	        container = _props.container,
	        children = _props.children,
	        Transition = _props.transition,
	        backdrop = _props.backdrop,
	        dialogTransitionTimeout = _props.dialogTransitionTimeout,
	        className = _props.className,
	        style = _props.style,
	        onExit = _props.onExit,
	        onExiting = _props.onExiting,
	        onEnter = _props.onEnter,
	        onEntering = _props.onEntering,
	        onEntered = _props.onEntered;
	
	
	    var dialog = _react2.default.Children.only(children);
	    var filteredProps = this.omitProps(this.props, Modal.propTypes);
	
	    var mountModal = show || Transition && !this.state.exited;
	    if (!mountModal) {
	      return null;
	    }
	
	    var _dialog$props = dialog.props,
	        role = _dialog$props.role,
	        tabIndex = _dialog$props.tabIndex;
	
	
	    if (role === undefined || tabIndex === undefined) {
	      dialog = (0, _react.cloneElement)(dialog, {
	        role: role === undefined ? 'document' : role,
	        tabIndex: tabIndex == null ? '-1' : tabIndex
	      });
	    }
	
	    if (Transition) {
	      dialog = _react2.default.createElement(
	        Transition,
	        {
	          transitionAppear: true,
	          unmountOnExit: true,
	          'in': show,
	          timeout: dialogTransitionTimeout,
	          onExit: onExit,
	          onExiting: onExiting,
	          onExited: this.handleHidden,
	          onEnter: onEnter,
	          onEntering: onEntering,
	          onEntered: onEntered
	        },
	        dialog
	      );
	    }
	
	    return _react2.default.createElement(
	      _Portal2.default,
	      {
	        ref: this.setMountNode,
	        container: container,
	        onRendered: this.onPortalRendered
	      },
	      _react2.default.createElement(
	        'div',
	        _extends({
	          ref: this.setModalNodeRef,
	          role: role || 'dialog'
	        }, filteredProps, {
	          style: style,
	          className: className
	        }),
	        backdrop && this.renderBackdrop(),
	        _react2.default.createElement(
	          _RefHolder2.default,
	          { ref: this.setDialogRef },
	          dialog
	        )
	      )
	    );
	  };
	
	  Modal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.show) {
	      this.setState({ exited: false });
	    } else if (!nextProps.transition) {
	      // Otherwise let handleHidden take care of marking exited.
	      this.setState({ exited: true });
	    }
	  };
	
	  Modal.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
	    if (!this.props.show && nextProps.show) {
	      this.checkForFocus();
	    }
	  };
	
	  Modal.prototype.componentDidMount = function componentDidMount() {
	    this._isMounted = true;
	    if (this.props.show) {
	      this.onShow();
	    }
	  };
	
	  Modal.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var transition = this.props.transition;
	
	
	    if (prevProps.show && !this.props.show && !transition) {
	      // Otherwise handleHidden will call this.
	      this.onHide();
	    } else if (!prevProps.show && this.props.show) {
	      this.onShow();
	    }
	  };
	
	  Modal.prototype.componentWillUnmount = function componentWillUnmount() {
	    var _props2 = this.props,
	        show = _props2.show,
	        transition = _props2.transition;
	
	
	    this._isMounted = false;
	
	    if (show || transition && !this.state.exited) {
	      this.onHide();
	    }
	  };
	
	  Modal.prototype.autoFocus = function autoFocus() {
	    if (!this.props.autoFocus) {
	      return;
	    }
	
	    var dialogElement = this.getDialogElement();
	    var currentActiveElement = (0, _activeElement2.default)((0, _ownerDocument2.default)(this));
	
	    if (dialogElement && !(0, _contains2.default)(dialogElement, currentActiveElement)) {
	      this.lastFocus = currentActiveElement;
	
	      if (!dialogElement.hasAttribute('tabIndex')) {
	        (0, _warning2.default)(false, 'The modal content node does not accept focus. For the benefit of ' + 'assistive technologies, the tabIndex of the node is being set ' + 'to "-1".');
	
	        dialogElement.setAttribute('tabIndex', -1);
	      }
	
	      dialogElement.focus();
	    }
	  };
	
	  Modal.prototype.restoreLastFocus = function restoreLastFocus() {
	    // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
	    if (this.lastFocus && this.lastFocus.focus) {
	      this.lastFocus.focus();
	      this.lastFocus = null;
	    }
	  };
	
	  Modal.prototype.getDialogElement = function getDialogElement() {
	    return _reactDom2.default.findDOMNode(this.dialog);
	  };
	
	  Modal.prototype.isTopModal = function isTopModal() {
	    return this.props.manager.isTopModal(this);
	  };
	
	  return Modal;
	}(_react2.default.Component);
	
	Modal.propTypes = _extends({}, _Portal2.default.propTypes, {
	
	  /**
	   * Set the visibility of the Modal
	   */
	  show: _propTypes2.default.bool,
	
	  /**
	   * A Node, Component instance, or function that returns either. The Modal is appended to it's container element.
	   *
	   * For the sake of assistive technologies, the container should usually be the document body, so that the rest of the
	   * page content can be placed behind a virtual backdrop as well as a visual one.
	   */
	  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
	
	  /**
	   * A callback fired when the Modal is opening.
	   */
	  onShow: _propTypes2.default.func,
	
	  /**
	   * A callback fired when either the backdrop is clicked, or the escape key is pressed.
	   *
	   * The `onHide` callback only signals intent from the Modal,
	   * you must actually set the `show` prop to `false` for the Modal to close.
	   */
	  onHide: _propTypes2.default.func,
	
	  /**
	   * Include a backdrop component.
	   */
	  backdrop: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['static'])]),
	
	  /**
	   * A function that returns a backdrop component. Useful for custom
	   * backdrop rendering.
	   *
	   * ```js
	   *  renderBackdrop={props => <MyBackdrop {...props} />}
	   * ```
	   */
	  renderBackdrop: _propTypes2.default.func,
	
	  /**
	   * A callback fired when the escape key, if specified in `keyboard`, is pressed.
	   */
	  onEscapeKeyDown: _propTypes2.default.func,
	
	  /**
	   * Support for this function will be deprecated. Please use `onEscapeKeyDown` instead
	   * A callback fired when the escape key, if specified in `keyboard`, is pressed.
	   * @deprecated
	   */
	  onEscapeKeyUp: (0, _deprecated2.default)(_propTypes2.default.func, 'Please use onEscapeKeyDown instead for consistency'),
	
	  /**
	   * A callback fired when the backdrop, if specified, is clicked.
	   */
	  onBackdropClick: _propTypes2.default.func,
	
	  /**
	   * A style object for the backdrop component.
	   */
	  backdropStyle: _propTypes2.default.object,
	
	  /**
	   * A css class or classes for the backdrop component.
	   */
	  backdropClassName: _propTypes2.default.string,
	
	  /**
	   * A css class or set of classes applied to the modal container when the modal is open,
	   * and removed when it is closed.
	   */
	  containerClassName: _propTypes2.default.string,
	
	  /**
	   * Close the modal when escape key is pressed
	   */
	  keyboard: _propTypes2.default.bool,
	
	  /**
	   * A `<Transition/>` component to use for the dialog and backdrop components.
	   */
	  transition: _elementType2.default,
	
	  /**
	   * The `timeout` of the dialog transition if specified. This number is used to ensure that
	   * transition callbacks are always fired, even if browser transition events are canceled.
	   *
	   * See the Transition `timeout` prop for more infomation.
	   */
	  dialogTransitionTimeout: _propTypes2.default.number,
	
	  /**
	   * The `timeout` of the backdrop transition if specified. This number is used to
	   * ensure that transition callbacks are always fired, even if browser transition events are canceled.
	   *
	   * See the Transition `timeout` prop for more infomation.
	   */
	  backdropTransitionTimeout: _propTypes2.default.number,
	
	  /**
	   * When `true` The modal will automatically shift focus to itself when it opens, and
	   * replace it to the last focused element when it closes. This also
	   * works correctly with any Modal children that have the `autoFocus` prop.
	   *
	   * Generally this should never be set to `false` as it makes the Modal less
	   * accessible to assistive technologies, like screen readers.
	   */
	  autoFocus: _propTypes2.default.bool,
	
	  /**
	   * When `true` The modal will prevent focus from leaving the Modal while open.
	   *
	   * Generally this should never be set to `false` as it makes the Modal less
	   * accessible to assistive technologies, like screen readers.
	   */
	  enforceFocus: _propTypes2.default.bool,
	
	  /**
	   * When `true` The modal will restore focus to previously focused element once
	   * modal is hidden
	   */
	  restoreFocus: _propTypes2.default.bool,
	
	  /**
	   * Callback fired before the Modal transitions in
	   */
	  onEnter: _propTypes2.default.func,
	
	  /**
	   * Callback fired as the Modal begins to transition in
	   */
	  onEntering: _propTypes2.default.func,
	
	  /**
	   * Callback fired after the Modal finishes transitioning in
	   */
	  onEntered: _propTypes2.default.func,
	
	  /**
	   * Callback fired right before the Modal transitions out
	   */
	  onExit: _propTypes2.default.func,
	
	  /**
	   * Callback fired as the Modal begins to transition out
	   */
	  onExiting: _propTypes2.default.func,
	
	  /**
	   * Callback fired after the Modal finishes transitioning out
	   */
	  onExited: _propTypes2.default.func,
	
	  /**
	   * A ModalManager instance used to track and manage the state of open
	   * Modals. Useful when customizing how modals interact within a container
	   */
	  manager: _propTypes2.default.object.isRequired
	});
	Modal.defaultProps = {
	  show: false,
	  backdrop: true,
	  keyboard: true,
	  autoFocus: true,
	  enforceFocus: true,
	  restoreFocus: true,
	  onHide: function onHide() {},
	  manager: modalManager,
	  renderBackdrop: function renderBackdrop(props) {
	    return _react2.default.createElement('div', props);
	  }
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.state = { exited: !this.props.show };
	
	  this.renderBackdrop = function () {
	    var _props3 = _this2.props,
	        backdropStyle = _props3.backdropStyle,
	        backdropClassName = _props3.backdropClassName,
	        renderBackdrop = _props3.renderBackdrop,
	        Transition = _props3.transition,
	        backdropTransitionTimeout = _props3.backdropTransitionTimeout;
	
	
	    var backdropRef = function backdropRef(ref) {
	      return _this2.backdrop = ref;
	    };
	
	    var backdrop = renderBackdrop({
	      ref: backdropRef,
	      style: backdropStyle,
	      className: backdropClassName,
	      onClick: _this2.handleBackdropClick
	    });
	
	    if (Transition) {
	      backdrop = _react2.default.createElement(
	        Transition,
	        { transitionAppear: true,
	          'in': _this2.props.show,
	          timeout: backdropTransitionTimeout
	        },
	        backdrop
	      );
	    }
	
	    return backdrop;
	  };
	
	  this.onPortalRendered = function () {
	    _this2.autoFocus();
	
	    if (_this2.props.onShow) {
	      _this2.props.onShow();
	    }
	  };
	
	  this.onShow = function () {
	    var doc = (0, _ownerDocument2.default)(_this2);
	    var container = (0, _getContainer2.default)(_this2.props.container, doc.body);
	
	    _this2.props.manager.add(_this2, container, _this2.props.containerClassName);
	
	    _this2._onDocumentKeydownListener = (0, _addEventListener2.default)(doc, 'keydown', _this2.handleDocumentKeyDown);
	
	    _this2._onDocumentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', _this2.handleDocumentKeyUp);
	
	    _this2._onFocusinListener = (0, _addFocusListener2.default)(_this2.enforceFocus);
	  };
	
	  this.onHide = function () {
	    _this2.props.manager.remove(_this2);
	
	    _this2._onDocumentKeydownListener.remove();
	
	    _this2._onDocumentKeyupListener.remove();
	
	    _this2._onFocusinListener.remove();
	
	    if (_this2.props.restoreFocus) {
	      _this2.restoreLastFocus();
	    }
	  };
	
	  this.setMountNode = function (ref) {
	    _this2.mountNode = ref ? ref.getMountNode() : ref;
	  };
	
	  this.setModalNodeRef = function (ref) {
	    _this2.modalNode = ref;
	  };
	
	  this.setDialogRef = function (ref) {
	    _this2.dialog = ref;
	  };
	
	  this.handleHidden = function () {
	    _this2.setState({ exited: true });
	    _this2.onHide();
	
	    if (_this2.props.onExited) {
	      var _props4;
	
	      (_props4 = _this2.props).onExited.apply(_props4, arguments);
	    }
	  };
	
	  this.handleBackdropClick = function (e) {
	    if (e.target !== e.currentTarget) {
	      return;
	    }
	
	    if (_this2.props.onBackdropClick) {
	      _this2.props.onBackdropClick(e);
	    }
	
	    if (_this2.props.backdrop === true) {
	      _this2.props.onHide();
	    }
	  };
	
	  this.handleDocumentKeyDown = function (e) {
	    if (_this2.props.keyboard && e.keyCode === 27 && _this2.isTopModal()) {
	      if (_this2.props.onEscapeKeyDown) {
	        _this2.props.onEscapeKeyDown(e);
	      }
	
	      _this2.props.onHide();
	    }
	  };
	
	  this.handleDocumentKeyUp = function (e) {
	    if (_this2.props.keyboard && e.keyCode === 27 && _this2.isTopModal()) {
	      if (_this2.props.onEscapeKeyUp) {
	        _this2.props.onEscapeKeyUp(e);
	      }
	    }
	  };
	
	  this.checkForFocus = function () {
	    if (_inDOM2.default) {
	      _this2.lastFocus = (0, _activeElement2.default)();
	    }
	  };
	
	  this.enforceFocus = function () {
	    if (!_this2.props.enforceFocus || !_this2._isMounted || !_this2.isTopModal()) {
	      return;
	    }
	
	    var dialogElement = _this2.getDialogElement();
	    var currentActiveElement = (0, _activeElement2.default)((0, _ownerDocument2.default)(_this2));
	
	    if (dialogElement && !(0, _contains2.default)(dialogElement, currentActiveElement)) {
	      dialogElement.focus();
	    }
	  };
	};
	
	Modal.Manager = _ModalManager2.default;
	
	exports.default = Modal;
	module.exports = exports['default'];

/***/ },
/* 2289 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _class = __webpack_require__(1692);
	
	var _class2 = _interopRequireDefault(_class);
	
	var _style = __webpack_require__(273);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _scrollbarSize = __webpack_require__(680);
	
	var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);
	
	var _isOverflowing = __webpack_require__(945);
	
	var _isOverflowing2 = _interopRequireDefault(_isOverflowing);
	
	var _manageAriaHidden = __webpack_require__(2295);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function findIndexOf(arr, cb) {
	  var idx = -1;
	  arr.some(function (d, i) {
	    if (cb(d, i)) {
	      idx = i;
	      return true;
	    }
	  });
	  return idx;
	}
	
	function findContainer(data, modal) {
	  return findIndexOf(data, function (d) {
	    return d.modals.indexOf(modal) !== -1;
	  });
	}
	
	function setContainerStyle(state, container) {
	  var style = { overflow: 'hidden' };
	
	  // we are only interested in the actual `style` here
	  // becasue we will override it
	  state.style = {
	    overflow: container.style.overflow,
	    paddingRight: container.style.paddingRight
	  };
	
	  if (state.overflowing) {
	    // use computed style, here to get the real padding
	    // to add our scrollbar width
	    style.paddingRight = parseInt((0, _style2.default)(container, 'paddingRight') || 0, 10) + (0, _scrollbarSize2.default)() + 'px';
	  }
	
	  (0, _style2.default)(container, style);
	}
	
	function removeContainerStyle(_ref, container) {
	  var style = _ref.style;
	
	
	  Object.keys(style).forEach(function (key) {
	    return container.style[key] = style[key];
	  });
	}
	/**
	 * Proper state managment for containers and the modals in those containers.
	 *
	 * @internal Used by the Modal to ensure proper styling of containers.
	 */
	
	var ModalManager = function ModalManager() {
	  var _this = this;
	
	  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref2$hideSiblingNode = _ref2.hideSiblingNodes,
	      hideSiblingNodes = _ref2$hideSiblingNode === undefined ? true : _ref2$hideSiblingNode,
	      _ref2$handleContainer = _ref2.handleContainerOverflow,
	      handleContainerOverflow = _ref2$handleContainer === undefined ? true : _ref2$handleContainer;
	
	  _classCallCheck(this, ModalManager);
	
	  this.add = function (modal, container, className) {
	    var modalIdx = _this.modals.indexOf(modal);
	    var containerIdx = _this.containers.indexOf(container);
	
	    if (modalIdx !== -1) {
	      return modalIdx;
	    }
	
	    modalIdx = _this.modals.length;
	    _this.modals.push(modal);
	
	    if (_this.hideSiblingNodes) {
	      (0, _manageAriaHidden.hideSiblings)(container, modal.mountNode);
	    }
	
	    if (containerIdx !== -1) {
	      _this.data[containerIdx].modals.push(modal);
	      return modalIdx;
	    }
	
	    var data = {
	      modals: [modal],
	      //right now only the first modal of a container will have its classes applied
	      classes: className ? className.split(/\s+/) : [],
	
	      overflowing: (0, _isOverflowing2.default)(container)
	    };
	
	    if (_this.handleContainerOverflow) {
	      setContainerStyle(data, container);
	    }
	
	    data.classes.forEach(_class2.default.addClass.bind(null, container));
	
	    _this.containers.push(container);
	    _this.data.push(data);
	
	    return modalIdx;
	  };
	
	  this.remove = function (modal) {
	    var modalIdx = _this.modals.indexOf(modal);
	
	    if (modalIdx === -1) {
	      return;
	    }
	
	    var containerIdx = findContainer(_this.data, modal);
	    var data = _this.data[containerIdx];
	    var container = _this.containers[containerIdx];
	
	    data.modals.splice(data.modals.indexOf(modal), 1);
	
	    _this.modals.splice(modalIdx, 1);
	
	    // if that was the last modal in a container,
	    // clean up the container
	    if (data.modals.length === 0) {
	      data.classes.forEach(_class2.default.removeClass.bind(null, container));
	
	      if (_this.handleContainerOverflow) {
	        removeContainerStyle(data, container);
	      }
	
	      if (_this.hideSiblingNodes) {
	        (0, _manageAriaHidden.showSiblings)(container, modal.mountNode);
	      }
	      _this.containers.splice(containerIdx, 1);
	      _this.data.splice(containerIdx, 1);
	    } else if (_this.hideSiblingNodes) {
	      //otherwise make sure the next top modal is visible to a SR
	      (0, _manageAriaHidden.ariaHidden)(false, data.modals[data.modals.length - 1].mountNode);
	    }
	  };
	
	  this.isTopModal = function (modal) {
	    return !!_this.modals.length && _this.modals[_this.modals.length - 1] === modal;
	  };
	
	  this.hideSiblingNodes = hideSiblingNodes;
	  this.handleContainerOverflow = handleContainerOverflow;
	  this.modals = [];
	  this.containers = [];
	  this.data = [];
	};
	
	exports.default = ModalManager;
	module.exports = exports['default'];

/***/ },
/* 2290 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(909);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Portal = __webpack_require__(941);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Position = __webpack_require__(2291);
	
	var _Position2 = _interopRequireDefault(_Position);
	
	var _RootCloseWrapper = __webpack_require__(942);
	
	var _RootCloseWrapper2 = _interopRequireDefault(_RootCloseWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Built on top of `<Position/>` and `<Portal/>`, the overlay component is great for custom tooltip overlays.
	 */
	var Overlay = function (_React$Component) {
	  _inherits(Overlay, _React$Component);
	
	  function Overlay(props, context) {
	    _classCallCheck(this, Overlay);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.handleHidden = function () {
	      _this.setState({ exited: true });
	
	      if (_this.props.onExited) {
	        var _this$props;
	
	        (_this$props = _this.props).onExited.apply(_this$props, arguments);
	      }
	    };
	
	    _this.state = { exited: !props.show };
	    _this.onHiddenListener = _this.handleHidden.bind(_this);
	    return _this;
	  }
	
	  Overlay.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.show) {
	      this.setState({ exited: false });
	    } else if (!nextProps.transition) {
	      // Otherwise let handleHidden take care of marking exited.
	      this.setState({ exited: true });
	    }
	  };
	
	  Overlay.prototype.render = function render() {
	    var _props = this.props,
	        container = _props.container,
	        containerPadding = _props.containerPadding,
	        target = _props.target,
	        placement = _props.placement,
	        shouldUpdatePosition = _props.shouldUpdatePosition,
	        rootClose = _props.rootClose,
	        children = _props.children,
	        Transition = _props.transition,
	        props = _objectWithoutProperties(_props, ['container', 'containerPadding', 'target', 'placement', 'shouldUpdatePosition', 'rootClose', 'children', 'transition']);
	
	    // Don't un-render the overlay while it's transitioning out.
	
	
	    var mountOverlay = props.show || Transition && !this.state.exited;
	    if (!mountOverlay) {
	      // Don't bother showing anything if we don't have to.
	      return null;
	    }
	
	    var child = children;
	
	    // Position is be inner-most because it adds inline styles into the child,
	    // which the other wrappers don't forward correctly.
	    child = _react2.default.createElement(
	      _Position2.default,
	      { container: container, containerPadding: containerPadding, target: target, placement: placement, shouldUpdatePosition: shouldUpdatePosition },
	      child
	    );
	
	    if (Transition) {
	      var onExit = props.onExit,
	          onExiting = props.onExiting,
	          onEnter = props.onEnter,
	          onEntering = props.onEntering,
	          onEntered = props.onEntered;
	
	      // This animates the child node by injecting props, so it must precede
	      // anything that adds a wrapping div.
	
	      child = _react2.default.createElement(
	        Transition,
	        {
	          'in': props.show,
	          transitionAppear: true,
	          onExit: onExit,
	          onExiting: onExiting,
	          onExited: this.onHiddenListener,
	          onEnter: onEnter,
	          onEntering: onEntering,
	          onEntered: onEntered
	        },
	        child
	      );
	    }
	
	    // This goes after everything else because it adds a wrapping div.
	    if (rootClose) {
	      child = _react2.default.createElement(
	        _RootCloseWrapper2.default,
	        { onRootClose: props.onHide },
	        child
	      );
	    }
	
	    return _react2.default.createElement(
	      _Portal2.default,
	      { container: container },
	      child
	    );
	  };
	
	  return Overlay;
	}(_react2.default.Component);
	
	Overlay.propTypes = _extends({}, _Portal2.default.propTypes, _Position2.default.propTypes, {
	
	  /**
	   * Set the visibility of the Overlay
	   */
	  show: _propTypes2.default.bool,
	
	  /**
	   * Specify whether the overlay should trigger `onHide` when the user clicks outside the overlay
	   */
	  rootClose: _propTypes2.default.bool,
	
	  /**
	   * A Callback fired by the Overlay when it wishes to be hidden.
	   *
	   * __required__ when `rootClose` is `true`.
	   *
	   * @type func
	   */
	  onHide: function onHide(props) {
	    var propType = _propTypes2.default.func;
	    if (props.rootClose) {
	      propType = propType.isRequired;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return propType.apply(undefined, [props].concat(args));
	  },
	
	
	  /**
	   * A `<Transition/>` component used to animate the overlay changes visibility.
	   */
	  transition: _elementType2.default,
	
	  /**
	   * Callback fired before the Overlay transitions in
	   */
	  onEnter: _propTypes2.default.func,
	
	  /**
	   * Callback fired as the Overlay begins to transition in
	   */
	  onEntering: _propTypes2.default.func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning in
	   */
	  onEntered: _propTypes2.default.func,
	
	  /**
	   * Callback fired right before the Overlay transitions out
	   */
	  onExit: _propTypes2.default.func,
	
	  /**
	   * Callback fired as the Overlay begins to transition out
	   */
	  onExiting: _propTypes2.default.func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning out
	   */
	  onExited: _propTypes2.default.func
	});
	
	exports.default = Overlay;
	module.exports = exports['default'];

/***/ },
/* 2291 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _componentOrElement = __webpack_require__(294);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _calculatePosition = __webpack_require__(2294);
	
	var _calculatePosition2 = _interopRequireDefault(_calculatePosition);
	
	var _getContainer = __webpack_require__(301);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	var _ownerDocument = __webpack_require__(185);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The Position component calculates the coordinates for its child, to position
	 * it relative to a `target` component or node. Useful for creating callouts
	 * and tooltips, the Position component injects a `style` props with `left` and
	 * `top` values for positioning your component.
	 *
	 * It also injects "arrow" `left`, and `top` values for styling callout arrows
	 * for giving your components a sense of directionality.
	 */
	var Position = function (_React$Component) {
	  _inherits(Position, _React$Component);
	
	  function Position(props, context) {
	    _classCallCheck(this, Position);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.getTarget = function () {
	      var target = _this.props.target;
	
	      var targetElement = typeof target === 'function' ? target() : target;
	      return targetElement && _reactDom2.default.findDOMNode(targetElement) || null;
	    };
	
	    _this.maybeUpdatePosition = function (placementChanged) {
	      var target = _this.getTarget();
	
	      if (!_this.props.shouldUpdatePosition && target === _this._lastTarget && !placementChanged) {
	        return;
	      }
	
	      _this.updatePosition(target);
	    };
	
	    _this.state = {
	      positionLeft: 0,
	      positionTop: 0,
	      arrowOffsetLeft: null,
	      arrowOffsetTop: null
	    };
	
	    _this._needsFlush = false;
	    _this._lastTarget = null;
	    return _this;
	  }
	
	  Position.prototype.componentDidMount = function componentDidMount() {
	    this.updatePosition(this.getTarget());
	  };
	
	  Position.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
	    this._needsFlush = true;
	  };
	
	  Position.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (this._needsFlush) {
	      this._needsFlush = false;
	      this.maybeUpdatePosition(this.props.placement !== prevProps.placement);
	    }
	  };
	
	  Position.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        className = _props.className,
	        props = _objectWithoutProperties(_props, ['children', 'className']);
	
	    var _state = this.state,
	        positionLeft = _state.positionLeft,
	        positionTop = _state.positionTop,
	        arrowPosition = _objectWithoutProperties(_state, ['positionLeft', 'positionTop']);
	
	    // These should not be forwarded to the child.
	
	
	    delete props.target;
	    delete props.container;
	    delete props.containerPadding;
	    delete props.shouldUpdatePosition;
	
	    var child = _react2.default.Children.only(children);
	    return (0, _react.cloneElement)(child, _extends({}, props, arrowPosition, {
	      // FIXME: Don't forward `positionLeft` and `positionTop` via both props
	      // and `props.style`.
	      positionLeft: positionLeft,
	      positionTop: positionTop,
	      className: (0, _classnames2.default)(className, child.props.className),
	      style: _extends({}, child.props.style, {
	        left: positionLeft,
	        top: positionTop
	      })
	    }));
	  };
	
	  Position.prototype.updatePosition = function updatePosition(target) {
	    this._lastTarget = target;
	
	    if (!target) {
	      this.setState({
	        positionLeft: 0,
	        positionTop: 0,
	        arrowOffsetLeft: null,
	        arrowOffsetTop: null
	      });
	
	      return;
	    }
	
	    var overlay = _reactDom2.default.findDOMNode(this);
	    var container = (0, _getContainer2.default)(this.props.container, (0, _ownerDocument2.default)(this).body);
	
	    this.setState((0, _calculatePosition2.default)(this.props.placement, overlay, target, container, this.props.containerPadding));
	  };
	
	  return Position;
	}(_react2.default.Component);
	
	Position.propTypes = {
	  /**
	   * A node, element, or function that returns either. The child will be
	   * be positioned next to the `target` specified.
	   */
	  target: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
	
	  /**
	   * "offsetParent" of the component
	   */
	  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
	  /**
	   * Minimum spacing in pixels between container border and component border
	   */
	  containerPadding: _propTypes2.default.number,
	  /**
	   * How to position the component relative to the target
	   */
	  placement: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
	  /**
	   * Whether the position should be changed on each update
	   */
	  shouldUpdatePosition: _propTypes2.default.bool
	};
	
	Position.displayName = 'Position';
	
	Position.defaultProps = {
	  containerPadding: 0,
	  placement: 'right',
	  shouldUpdatePosition: false
	};
	
	exports.default = Position;
	module.exports = exports['default'];

/***/ },
/* 2292 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  children: _propTypes2.default.node
	};
	
	/**
	 * Internal helper component to allow attaching a non-conflicting ref to a
	 * child element that may not accept refs.
	 */
	
	var RefHolder = function (_React$Component) {
	  _inherits(RefHolder, _React$Component);
	
	  function RefHolder() {
	    _classCallCheck(this, RefHolder);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  RefHolder.prototype.render = function render() {
	    return this.props.children;
	  };
	
	  return RefHolder;
	}(_react2.default.Component);
	
	RefHolder.propTypes = propTypes;
	
	exports.default = RefHolder;
	module.exports = exports['default'];

/***/ },
/* 2293 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = addFocusListener;
	/**
	 * Firefox doesn't have a focusin event so using capture is easiest way to get bubbling
	 * IE8 can't do addEventListener, but does have onfocusin, so we use that in ie8
	 *
	 * We only allow one Listener at a time to avoid stack overflows
	 */
	function addFocusListener(handler) {
	  var useFocusin = !document.addEventListener;
	  var remove = void 0;
	
	  if (useFocusin) {
	    document.attachEvent('onfocusin', handler);
	    remove = function remove() {
	      return document.detachEvent('onfocusin', handler);
	    };
	  } else {
	    document.addEventListener('focus', handler, true);
	    remove = function remove() {
	      return document.removeEventListener('focus', handler, true);
	    };
	  }
	
	  return { remove: remove };
	}
	module.exports = exports['default'];

/***/ },
/* 2294 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = calculatePosition;
	
	var _offset = __webpack_require__(676);
	
	var _offset2 = _interopRequireDefault(_offset);
	
	var _position = __webpack_require__(1697);
	
	var _position2 = _interopRequireDefault(_position);
	
	var _scrollTop = __webpack_require__(677);
	
	var _scrollTop2 = _interopRequireDefault(_scrollTop);
	
	var _ownerDocument = __webpack_require__(185);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getContainerDimensions(containerNode) {
	  var width = void 0,
	      height = void 0,
	      scroll = void 0;
	
	  if (containerNode.tagName === 'BODY') {
	    width = window.innerWidth;
	    height = window.innerHeight;
	
	    scroll = (0, _scrollTop2.default)((0, _ownerDocument2.default)(containerNode).documentElement) || (0, _scrollTop2.default)(containerNode);
	  } else {
	    var _getOffset = (0, _offset2.default)(containerNode);
	
	    width = _getOffset.width;
	    height = _getOffset.height;
	
	    scroll = (0, _scrollTop2.default)(containerNode);
	  }
	
	  return { width: width, height: height, scroll: scroll };
	}
	
	function getTopDelta(top, overlayHeight, container, padding) {
	  var containerDimensions = getContainerDimensions(container);
	  var containerScroll = containerDimensions.scroll;
	  var containerHeight = containerDimensions.height;
	
	  var topEdgeOffset = top - padding - containerScroll;
	  var bottomEdgeOffset = top + padding - containerScroll + overlayHeight;
	
	  if (topEdgeOffset < 0) {
	    return -topEdgeOffset;
	  } else if (bottomEdgeOffset > containerHeight) {
	    return containerHeight - bottomEdgeOffset;
	  } else {
	    return 0;
	  }
	}
	
	function getLeftDelta(left, overlayWidth, container, padding) {
	  var containerDimensions = getContainerDimensions(container);
	  var containerWidth = containerDimensions.width;
	
	  var leftEdgeOffset = left - padding;
	  var rightEdgeOffset = left + padding + overlayWidth;
	
	  if (leftEdgeOffset < 0) {
	    return -leftEdgeOffset;
	  } else if (rightEdgeOffset > containerWidth) {
	    return containerWidth - rightEdgeOffset;
	  }
	
	  return 0;
	}
	
	function calculatePosition(placement, overlayNode, target, container, padding) {
	  var childOffset = container.tagName === 'BODY' ? (0, _offset2.default)(target) : (0, _position2.default)(target, container);
	
	  var _getOffset2 = (0, _offset2.default)(overlayNode),
	      overlayHeight = _getOffset2.height,
	      overlayWidth = _getOffset2.width;
	
	  var positionLeft = void 0,
	      positionTop = void 0,
	      arrowOffsetLeft = void 0,
	      arrowOffsetTop = void 0;
	
	  if (placement === 'left' || placement === 'right') {
	    positionTop = childOffset.top + (childOffset.height - overlayHeight) / 2;
	
	    if (placement === 'left') {
	      positionLeft = childOffset.left - overlayWidth;
	    } else {
	      positionLeft = childOffset.left + childOffset.width;
	    }
	
	    var topDelta = getTopDelta(positionTop, overlayHeight, container, padding);
	
	    positionTop += topDelta;
	    arrowOffsetTop = 50 * (1 - 2 * topDelta / overlayHeight) + '%';
	    arrowOffsetLeft = void 0;
	  } else if (placement === 'top' || placement === 'bottom') {
	    positionLeft = childOffset.left + (childOffset.width - overlayWidth) / 2;
	
	    if (placement === 'top') {
	      positionTop = childOffset.top - overlayHeight;
	    } else {
	      positionTop = childOffset.top + childOffset.height;
	    }
	
	    var leftDelta = getLeftDelta(positionLeft, overlayWidth, container, padding);
	
	    positionLeft += leftDelta;
	    arrowOffsetLeft = 50 * (1 - 2 * leftDelta / overlayWidth) + '%';
	    arrowOffsetTop = void 0;
	  } else {
	    throw new Error('calcOverlayPosition(): No such placement of "' + placement + '" found.');
	  }
	
	  return { positionLeft: positionLeft, positionTop: positionTop, arrowOffsetLeft: arrowOffsetLeft, arrowOffsetTop: arrowOffsetTop };
	}
	module.exports = exports['default'];

/***/ },
/* 2295 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.ariaHidden = ariaHidden;
	exports.hideSiblings = hideSiblings;
	exports.showSiblings = showSiblings;
	
	var BLACKLIST = ['template', 'script', 'style'];
	
	var isHidable = function isHidable(_ref) {
	  var nodeType = _ref.nodeType,
	      tagName = _ref.tagName;
	  return nodeType === 1 && BLACKLIST.indexOf(tagName.toLowerCase()) === -1;
	};
	
	var siblings = function siblings(container, mount, cb) {
	  mount = [].concat(mount);
	
	  [].forEach.call(container.children, function (node) {
	    if (mount.indexOf(node) === -1 && isHidable(node)) {
	      cb(node);
	    }
	  });
	};
	
	function ariaHidden(show, node) {
	  if (!node) {
	    return;
	  }
	  if (show) {
	    node.setAttribute('aria-hidden', 'true');
	  } else {
	    node.removeAttribute('aria-hidden');
	  }
	}
	
	function hideSiblings(container, mountNode) {
	  siblings(container, mountNode, function (node) {
	    return ariaHidden(true, node);
	  });
	}
	
	function showSiblings(container, mountNode) {
	  siblings(container, mountNode, function (node) {
	    return ariaHidden(false, node);
	  });
	}

/***/ },
/* 2296 */
100,
/* 2297 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(154);
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Popper;
	exports.placements = exports.InnerPopper = void 0;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(20));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(27));
	
	var _deepEqual = _interopRequireDefault(__webpack_require__(1690));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _popper = _interopRequireDefault(__webpack_require__(907));
	
	var _Manager = __webpack_require__(466);
	
	var _utils = __webpack_require__(946);
	
	var initialStyle = {
	  position: 'absolute',
	  top: 0,
	  left: 0,
	  opacity: 0,
	  pointerEvents: 'none'
	};
	var initialArrowStyle = {};
	
	var InnerPopper =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(InnerPopper, _React$Component);
	
	  function InnerPopper() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "state", {
	      data: undefined,
	      placement: undefined
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "popperInstance", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "popperNode", null);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "arrowNode", null);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "setPopperNode", function (popperNode) {
	      if (!popperNode || _this.popperNode === popperNode) return;
	      (0, _utils.setRef)(_this.props.innerRef, popperNode);
	      _this.popperNode = popperNode;
	
	      _this.updatePopperInstance();
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "setArrowNode", function (arrowNode) {
	      _this.arrowNode = arrowNode;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "updateStateModifier", {
	      enabled: true,
	      order: 900,
	      fn: function fn(data) {
	        var placement = data.placement;
	
	        _this.setState({
	          data: data,
	          placement: placement
	        });
	
	        return data;
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "getOptions", function () {
	      return {
	        placement: _this.props.placement,
	        eventsEnabled: _this.props.eventsEnabled,
	        positionFixed: _this.props.positionFixed,
	        modifiers: (0, _extends2.default)({}, _this.props.modifiers, {
	          arrow: (0, _extends2.default)({}, _this.props.modifiers && _this.props.modifiers.arrow, {
	            enabled: !!_this.arrowNode,
	            element: _this.arrowNode
	          }),
	          applyStyle: {
	            enabled: false
	          },
	          updateStateModifier: _this.updateStateModifier
	        })
	      };
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "getPopperStyle", function () {
	      return !_this.popperNode || !_this.state.data ? initialStyle : (0, _extends2.default)({
	        position: _this.state.data.offsets.popper.position
	      }, _this.state.data.styles);
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "getPopperPlacement", function () {
	      return !_this.state.data ? undefined : _this.state.placement;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "getArrowStyle", function () {
	      return !_this.arrowNode || !_this.state.data ? initialArrowStyle : _this.state.data.arrowStyles;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "getOutOfBoundariesState", function () {
	      return _this.state.data ? _this.state.data.hide : undefined;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "destroyPopperInstance", function () {
	      if (!_this.popperInstance) return;
	
	      _this.popperInstance.destroy();
	
	      _this.popperInstance = null;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "updatePopperInstance", function () {
	      _this.destroyPopperInstance();
	
	      var _assertThisInitialize = (0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)),
	          popperNode = _assertThisInitialize.popperNode;
	
	      var referenceElement = _this.props.referenceElement;
	      if (!referenceElement || !popperNode) return;
	      _this.popperInstance = new _popper.default(referenceElement, popperNode, _this.getOptions());
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "scheduleUpdate", function () {
	      if (_this.popperInstance) {
	        _this.popperInstance.scheduleUpdate();
	      }
	    });
	    return _this;
	  }
	
	  var _proto = InnerPopper.prototype;
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
	    // If the Popper.js options have changed, update the instance (destroy + create)
	    if (this.props.placement !== prevProps.placement || this.props.referenceElement !== prevProps.referenceElement || this.props.positionFixed !== prevProps.positionFixed || !(0, _deepEqual.default)(this.props.modifiers, prevProps.modifiers, {
	      strict: true
	    })) {
	      // develop only check that modifiers isn't being updated needlessly
	      if (false) {
	        if (this.props.modifiers !== prevProps.modifiers && this.props.modifiers != null && prevProps.modifiers != null && (0, _utils.shallowEqual)(this.props.modifiers, prevProps.modifiers)) {
	          console.warn("'modifiers' prop reference updated even though all values appear the same.\nConsider memoizing the 'modifiers' object to avoid needless rendering.");
	        }
	      }
	
	      this.updatePopperInstance();
	    } else if (this.props.eventsEnabled !== prevProps.eventsEnabled && this.popperInstance) {
	      this.props.eventsEnabled ? this.popperInstance.enableEventListeners() : this.popperInstance.disableEventListeners();
	    } // A placement difference in state means popper determined a new placement
	    // apart from the props value. By the time the popper element is rendered with
	    // the new position Popper has already measured it, if the place change triggers
	    // a size change it will result in a misaligned popper. So we schedule an update to be sure.
	
	
	    if (prevState.placement !== this.state.placement) {
	      this.scheduleUpdate();
	    }
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    (0, _utils.setRef)(this.props.innerRef, null);
	    this.destroyPopperInstance();
	  };
	
	  _proto.render = function render() {
	    return (0, _utils.unwrapArray)(this.props.children)({
	      ref: this.setPopperNode,
	      style: this.getPopperStyle(),
	      placement: this.getPopperPlacement(),
	      outOfBoundaries: this.getOutOfBoundariesState(),
	      scheduleUpdate: this.scheduleUpdate,
	      arrowProps: {
	        ref: this.setArrowNode,
	        style: this.getArrowStyle()
	      }
	    });
	  };
	
	  return InnerPopper;
	}(React.Component);
	
	exports.InnerPopper = InnerPopper;
	(0, _defineProperty2.default)(InnerPopper, "defaultProps", {
	  placement: 'bottom',
	  eventsEnabled: true,
	  referenceElement: undefined,
	  positionFixed: false
	});
	var placements = _popper.default.placements;
	exports.placements = placements;
	
	function Popper(_ref) {
	  var referenceElement = _ref.referenceElement,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["referenceElement"]);
	  return React.createElement(_Manager.ManagerReferenceNodeContext.Consumer, null, function (referenceNode) {
	    return React.createElement(InnerPopper, (0, _extends2.default)({
	      referenceElement: referenceElement !== undefined ? referenceElement : referenceNode
	    }, props));
	  });
	}

/***/ },
/* 2298 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(154);
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Reference;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(20));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(27));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _warning = _interopRequireDefault(__webpack_require__(319));
	
	var _Manager = __webpack_require__(466);
	
	var _utils = __webpack_require__(946);
	
	var InnerReference =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(InnerReference, _React$Component);
	
	  function InnerReference() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "refHandler", function (node) {
	      (0, _utils.setRef)(_this.props.innerRef, node);
	      (0, _utils.safeInvoke)(_this.props.setReferenceNode, node);
	    });
	    return _this;
	  }
	
	  var _proto = InnerReference.prototype;
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    (0, _utils.setRef)(this.props.innerRef, null);
	  };
	
	  _proto.render = function render() {
	    (0, _warning.default)(Boolean(this.props.setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
	    return (0, _utils.unwrapArray)(this.props.children)({
	      ref: this.refHandler
	    });
	  };
	
	  return InnerReference;
	}(React.Component);
	
	function Reference(props) {
	  return React.createElement(_Manager.ManagerReferenceNodeSetterContext.Consumer, null, function (setReferenceNode) {
	    return React.createElement(InnerReference, (0, _extends2.default)({
	      setReferenceNode: setReferenceNode
	    }, props));
	  });
	}

/***/ },
/* 2299 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4)["default"];
	
	var _interopRequireWildcard = __webpack_require__(154)["default"];
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _Context = __webpack_require__(151);
	
	var _Subscription = __webpack_require__(468);
	
	var _useIsomorphicLayoutEffect = __webpack_require__(469);
	
	function Provider(_ref) {
	  var store = _ref.store,
	      context = _ref.context,
	      children = _ref.children;
	  var contextValue = (0, _react.useMemo)(function () {
	    var subscription = (0, _Subscription.createSubscription)(store);
	    subscription.onStateChange = subscription.notifyNestedSubs;
	    return {
	      store: store,
	      subscription: subscription
	    };
	  }, [store]);
	  var previousState = (0, _react.useMemo)(function () {
	    return store.getState();
	  }, [store]);
	  (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function () {
	    var subscription = contextValue.subscription;
	    subscription.trySubscribe();
	
	    if (previousState !== store.getState()) {
	      subscription.notifyNestedSubs();
	    }
	
	    return function () {
	      subscription.tryUnsubscribe();
	      subscription.onStateChange = null;
	    };
	  }, [contextValue, previousState]);
	  var Context = context || _Context.ReactReduxContext;
	  return /*#__PURE__*/_react["default"].createElement(Context.Provider, {
	    value: contextValue
	  }, children);
	}
	
	if (false) {
	  Provider.propTypes = {
	    store: _propTypes["default"].shape({
	      subscribe: _propTypes["default"].func.isRequired,
	      dispatch: _propTypes["default"].func.isRequired,
	      getState: _propTypes["default"].func.isRequired
	    }),
	    context: _propTypes["default"].object,
	    children: _propTypes["default"].any
	  };
	}
	
	var _default = Provider;
	exports["default"] = _default;

/***/ },
/* 2300 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4)["default"];
	
	exports.__esModule = true;
	exports.createConnect = createConnect;
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _connectAdvanced = _interopRequireDefault(__webpack_require__(947));
	
	var _shallowEqual = _interopRequireDefault(__webpack_require__(952));
	
	var _mapDispatchToProps = _interopRequireDefault(__webpack_require__(2301));
	
	var _mapStateToProps = _interopRequireDefault(__webpack_require__(2302));
	
	var _mergeProps = _interopRequireDefault(__webpack_require__(2303));
	
	var _selectorFactory = _interopRequireDefault(__webpack_require__(2304));
	
	var _excluded = ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"];
	
	/*
	  connect is a facade over connectAdvanced. It turns its args into a compatible
	  selectorFactory, which has the signature:
	
	    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
	  
	  connect passes its args to connectAdvanced as options, which will in turn pass them to
	  selectorFactory each time a Connect component instance is instantiated or hot reloaded.
	
	  selectorFactory returns a final props selector from its mapStateToProps,
	  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
	  mergePropsFactories, and pure args.
	
	  The resulting final props selector is called by the Connect component instance whenever
	  it receives new props or store state.
	 */
	function match(arg, factories, name) {
	  for (var i = factories.length - 1; i >= 0; i--) {
	    var result = factories[i](arg);
	    if (result) return result;
	  }
	
	  return function (dispatch, options) {
	    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
	  };
	}
	
	function strictEqual(a, b) {
	  return a === b;
	} // createConnect with default args builds the 'official' connect behavior. Calling it with
	// different options opens up some testing and extensibility scenarios
	
	
	function createConnect(_temp) {
	  var _ref = _temp === void 0 ? {} : _temp,
	      _ref$connectHOC = _ref.connectHOC,
	      connectHOC = _ref$connectHOC === void 0 ? _connectAdvanced["default"] : _ref$connectHOC,
	      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
	      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? _mapStateToProps["default"] : _ref$mapStateToPropsF,
	      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
	      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? _mapDispatchToProps["default"] : _ref$mapDispatchToPro,
	      _ref$mergePropsFactor = _ref.mergePropsFactories,
	      mergePropsFactories = _ref$mergePropsFactor === void 0 ? _mergeProps["default"] : _ref$mergePropsFactor,
	      _ref$selectorFactory = _ref.selectorFactory,
	      selectorFactory = _ref$selectorFactory === void 0 ? _selectorFactory["default"] : _ref$selectorFactory;
	
	  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
	    if (_ref2 === void 0) {
	      _ref2 = {};
	    }
	
	    var _ref3 = _ref2,
	        _ref3$pure = _ref3.pure,
	        pure = _ref3$pure === void 0 ? true : _ref3$pure,
	        _ref3$areStatesEqual = _ref3.areStatesEqual,
	        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
	        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
	        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? _shallowEqual["default"] : _ref3$areOwnPropsEqua,
	        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
	        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? _shallowEqual["default"] : _ref3$areStatePropsEq,
	        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
	        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? _shallowEqual["default"] : _ref3$areMergedPropsE,
	        extraOptions = (0, _objectWithoutPropertiesLoose2["default"])(_ref3, _excluded);
	    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
	    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
	    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
	    return connectHOC(selectorFactory, (0, _extends2["default"])({
	      // used in error messages
	      methodName: 'connect',
	      // used to compute Connect's displayName from the wrapped component's displayName.
	      getDisplayName: function getDisplayName(name) {
	        return "Connect(" + name + ")";
	      },
	      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
	      shouldHandleStateChanges: Boolean(mapStateToProps),
	      // passed through to selectorFactory
	      initMapStateToProps: initMapStateToProps,
	      initMapDispatchToProps: initMapDispatchToProps,
	      initMergeProps: initMergeProps,
	      pure: pure,
	      areStatesEqual: areStatesEqual,
	      areOwnPropsEqual: areOwnPropsEqual,
	      areStatePropsEqual: areStatePropsEqual,
	      areMergedPropsEqual: areMergedPropsEqual
	    }, extraOptions));
	  };
	}
	
	var _default = /*#__PURE__*/createConnect();
	
	exports["default"] = _default;

/***/ },
/* 2301 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4)["default"];
	
	exports.__esModule = true;
	exports["default"] = void 0;
	exports.whenMapDispatchToPropsIsFunction = whenMapDispatchToPropsIsFunction;
	exports.whenMapDispatchToPropsIsMissing = whenMapDispatchToPropsIsMissing;
	exports.whenMapDispatchToPropsIsObject = whenMapDispatchToPropsIsObject;
	
	var _bindActionCreators = _interopRequireDefault(__webpack_require__(2309));
	
	var _wrapMapToProps = __webpack_require__(948);
	
	function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
	  return typeof mapDispatchToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
	}
	
	function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
	  return !mapDispatchToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return {
	      dispatch: dispatch
	    };
	  }) : undefined;
	}
	
	function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
	  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return (0, _bindActionCreators["default"])(mapDispatchToProps, dispatch);
	  }) : undefined;
	}
	
	var _default = [whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject];
	exports["default"] = _default;

/***/ },
/* 2302 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	exports.whenMapStateToPropsIsFunction = whenMapStateToPropsIsFunction;
	exports.whenMapStateToPropsIsMissing = whenMapStateToPropsIsMissing;
	
	var _wrapMapToProps = __webpack_require__(948);
	
	function whenMapStateToPropsIsFunction(mapStateToProps) {
	  return typeof mapStateToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
	}
	
	function whenMapStateToPropsIsMissing(mapStateToProps) {
	  return !mapStateToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function () {
	    return {};
	  }) : undefined;
	}
	
	var _default = [whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing];
	exports["default"] = _default;

/***/ },
/* 2303 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4)["default"];
	
	exports.__esModule = true;
	exports["default"] = void 0;
	exports.defaultMergeProps = defaultMergeProps;
	exports.whenMergePropsIsFunction = whenMergePropsIsFunction;
	exports.whenMergePropsIsOmitted = whenMergePropsIsOmitted;
	exports.wrapMergePropsFunc = wrapMergePropsFunc;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _verifyPlainObject = _interopRequireDefault(__webpack_require__(953));
	
	function defaultMergeProps(stateProps, dispatchProps, ownProps) {
	  return (0, _extends2["default"])({}, ownProps, stateProps, dispatchProps);
	}
	
	function wrapMergePropsFunc(mergeProps) {
	  return function initMergePropsProxy(dispatch, _ref) {
	    var displayName = _ref.displayName,
	        pure = _ref.pure,
	        areMergedPropsEqual = _ref.areMergedPropsEqual;
	    var hasRunOnce = false;
	    var mergedProps;
	    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
	      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	      if (hasRunOnce) {
	        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
	      } else {
	        hasRunOnce = true;
	        mergedProps = nextMergedProps;
	        if (false) (0, _verifyPlainObject["default"])(mergedProps, displayName, 'mergeProps');
	      }
	
	      return mergedProps;
	    };
	  };
	}
	
	function whenMergePropsIsFunction(mergeProps) {
	  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
	}
	
	function whenMergePropsIsOmitted(mergeProps) {
	  return !mergeProps ? function () {
	    return defaultMergeProps;
	  } : undefined;
	}
	
	var _default = [whenMergePropsIsFunction, whenMergePropsIsOmitted];
	exports["default"] = _default;

/***/ },
/* 2304 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4)["default"];
	
	exports.__esModule = true;
	exports["default"] = finalPropsSelectorFactory;
	exports.impureFinalPropsSelectorFactory = impureFinalPropsSelectorFactory;
	exports.pureFinalPropsSelectorFactory = pureFinalPropsSelectorFactory;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _verifySubselectors = _interopRequireDefault(__webpack_require__(2305));
	
	var _excluded = ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"];
	
	function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
	  return function impureFinalPropsSelector(state, ownProps) {
	    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
	  };
	}
	
	function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
	  var areStatesEqual = _ref.areStatesEqual,
	      areOwnPropsEqual = _ref.areOwnPropsEqual,
	      areStatePropsEqual = _ref.areStatePropsEqual;
	  var hasRunAtLeastOnce = false;
	  var state;
	  var ownProps;
	  var stateProps;
	  var dispatchProps;
	  var mergedProps;
	
	  function handleFirstCall(firstState, firstOwnProps) {
	    state = firstState;
	    ownProps = firstOwnProps;
	    stateProps = mapStateToProps(state, ownProps);
	    dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    hasRunAtLeastOnce = true;
	    return mergedProps;
	  }
	
	  function handleNewPropsAndNewState() {
	    stateProps = mapStateToProps(state, ownProps);
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewProps() {
	    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewState() {
	    var nextStateProps = mapStateToProps(state, ownProps);
	    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
	    stateProps = nextStateProps;
	    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleSubsequentCalls(nextState, nextOwnProps) {
	    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
	    var stateChanged = !areStatesEqual(nextState, state);
	    state = nextState;
	    ownProps = nextOwnProps;
	    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
	    if (propsChanged) return handleNewProps();
	    if (stateChanged) return handleNewState();
	    return mergedProps;
	  }
	
	  return function pureFinalPropsSelector(nextState, nextOwnProps) {
	    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
	  };
	} // TODO: Add more comments
	// If pure is true, the selector returned by selectorFactory will memoize its results,
	// allowing connectAdvanced's shouldComponentUpdate to return false if final
	// props have not changed. If false, the selector will always return a new
	// object and shouldComponentUpdate will always return true.
	
	
	function finalPropsSelectorFactory(dispatch, _ref2) {
	  var initMapStateToProps = _ref2.initMapStateToProps,
	      initMapDispatchToProps = _ref2.initMapDispatchToProps,
	      initMergeProps = _ref2.initMergeProps,
	      options = (0, _objectWithoutPropertiesLoose2["default"])(_ref2, _excluded);
	  var mapStateToProps = initMapStateToProps(dispatch, options);
	  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
	  var mergeProps = initMergeProps(dispatch, options);
	
	  if (false) {
	    (0, _verifySubselectors["default"])(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
	  }
	
	  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
	  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
	}

/***/ },
/* 2305 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4)["default"];
	
	exports.__esModule = true;
	exports["default"] = verifySubselectors;
	
	var _warning = _interopRequireDefault(__webpack_require__(954));
	
	function verify(selector, methodName, displayName) {
	  if (!selector) {
	    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
	  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
	    if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) {
	      (0, _warning["default"])("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
	    }
	  }
	}
	
	function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
	  verify(mapStateToProps, 'mapStateToProps', displayName);
	  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
	  verify(mergeProps, 'mergeProps', displayName);
	}

/***/ },
/* 2306 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4)["default"];
	
	exports.__esModule = true;
	
	var _Provider = _interopRequireDefault(__webpack_require__(2299));
	
	exports.Provider = _Provider["default"];
	
	var _connectAdvanced = _interopRequireDefault(__webpack_require__(947));
	
	exports.connectAdvanced = _connectAdvanced["default"];
	
	var _Context = __webpack_require__(151);
	
	exports.ReactReduxContext = _Context.ReactReduxContext;
	
	var _connect = _interopRequireDefault(__webpack_require__(2300));
	
	exports.connect = _connect["default"];
	
	var _useDispatch = __webpack_require__(2307);
	
	exports.useDispatch = _useDispatch.useDispatch;
	exports.createDispatchHook = _useDispatch.createDispatchHook;
	
	var _useSelector = __webpack_require__(2308);
	
	exports.useSelector = _useSelector.useSelector;
	exports.createSelectorHook = _useSelector.createSelectorHook;
	
	var _useStore = __webpack_require__(950);
	
	exports.useStore = _useStore.useStore;
	exports.createStoreHook = _useStore.createStoreHook;
	
	var _shallowEqual = _interopRequireDefault(__webpack_require__(952));
	
	exports.shallowEqual = _shallowEqual["default"];

/***/ },
/* 2307 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.createDispatchHook = createDispatchHook;
	exports.useDispatch = void 0;
	
	var _Context = __webpack_require__(151);
	
	var _useStore = __webpack_require__(950);
	
	/**
	 * Hook factory, which creates a `useDispatch` hook bound to a given context.
	 *
	 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
	 * @returns {Function} A `useDispatch` hook bound to the specified context.
	 */
	function createDispatchHook(context) {
	  if (context === void 0) {
	    context = _Context.ReactReduxContext;
	  }
	
	  var useStore = context === _Context.ReactReduxContext ? _useStore.useStore : (0, _useStore.createStoreHook)(context);
	  return function useDispatch() {
	    var store = useStore();
	    return store.dispatch;
	  };
	}
	/**
	 * A hook to access the redux `dispatch` function.
	 *
	 * @returns {any|function} redux store's `dispatch` function
	 *
	 * @example
	 *
	 * import React, { useCallback } from 'react'
	 * import { useDispatch } from 'react-redux'
	 *
	 * export const CounterComponent = ({ value }) => {
	 *   const dispatch = useDispatch()
	 *   const increaseCounter = useCallback(() => dispatch({ type: 'increase-counter' }), [])
	 *   return (
	 *     <div>
	 *       <span>{value}</span>
	 *       <button onClick={increaseCounter}>Increase counter</button>
	 *     </div>
	 *   )
	 * }
	 */
	
	
	var useDispatch = /*#__PURE__*/createDispatchHook();
	exports.useDispatch = useDispatch;

/***/ },
/* 2308 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.createSelectorHook = createSelectorHook;
	exports.useSelector = void 0;
	
	var _react = __webpack_require__(1);
	
	var _useReduxContext2 = __webpack_require__(949);
	
	var _Subscription = __webpack_require__(468);
	
	var _useIsomorphicLayoutEffect = __webpack_require__(469);
	
	var _Context = __webpack_require__(151);
	
	var refEquality = function refEquality(a, b) {
	  return a === b;
	};
	
	function useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
	  var _useReducer = (0, _react.useReducer)(function (s) {
	    return s + 1;
	  }, 0),
	      forceRender = _useReducer[1];
	
	  var subscription = (0, _react.useMemo)(function () {
	    return (0, _Subscription.createSubscription)(store, contextSub);
	  }, [store, contextSub]);
	  var latestSubscriptionCallbackError = (0, _react.useRef)();
	  var latestSelector = (0, _react.useRef)();
	  var latestStoreState = (0, _react.useRef)();
	  var latestSelectedState = (0, _react.useRef)();
	  var storeState = store.getState();
	  var selectedState;
	
	  try {
	    if (selector !== latestSelector.current || storeState !== latestStoreState.current || latestSubscriptionCallbackError.current) {
	      var newSelectedState = selector(storeState); // ensure latest selected state is reused so that a custom equality function can result in identical references
	
	      if (latestSelectedState.current === undefined || !equalityFn(newSelectedState, latestSelectedState.current)) {
	        selectedState = newSelectedState;
	      } else {
	        selectedState = latestSelectedState.current;
	      }
	    } else {
	      selectedState = latestSelectedState.current;
	    }
	  } catch (err) {
	    if (latestSubscriptionCallbackError.current) {
	      err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
	    }
	
	    throw err;
	  }
	
	  (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function () {
	    latestSelector.current = selector;
	    latestStoreState.current = storeState;
	    latestSelectedState.current = selectedState;
	    latestSubscriptionCallbackError.current = undefined;
	  });
	  (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function () {
	    function checkForUpdates() {
	      try {
	        var newStoreState = store.getState(); // Avoid calling selector multiple times if the store's state has not changed
	
	        if (newStoreState === latestStoreState.current) {
	          return;
	        }
	
	        var _newSelectedState = latestSelector.current(newStoreState);
	
	        if (equalityFn(_newSelectedState, latestSelectedState.current)) {
	          return;
	        }
	
	        latestSelectedState.current = _newSelectedState;
	        latestStoreState.current = newStoreState;
	      } catch (err) {
	        // we ignore all errors here, since when the component
	        // is re-rendered, the selectors are called again, and
	        // will throw again, if neither props nor store state
	        // changed
	        latestSubscriptionCallbackError.current = err;
	      }
	
	      forceRender();
	    }
	
	    subscription.onStateChange = checkForUpdates;
	    subscription.trySubscribe();
	    checkForUpdates();
	    return function () {
	      return subscription.tryUnsubscribe();
	    };
	  }, [store, subscription]);
	  return selectedState;
	}
	/**
	 * Hook factory, which creates a `useSelector` hook bound to a given context.
	 *
	 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
	 * @returns {Function} A `useSelector` hook bound to the specified context.
	 */
	
	
	function createSelectorHook(context) {
	  if (context === void 0) {
	    context = _Context.ReactReduxContext;
	  }
	
	  var useReduxContext = context === _Context.ReactReduxContext ? _useReduxContext2.useReduxContext : function () {
	    return (0, _react.useContext)(context);
	  };
	  return function useSelector(selector, equalityFn) {
	    if (equalityFn === void 0) {
	      equalityFn = refEquality;
	    }
	
	    if (false) {
	      if (!selector) {
	        throw new Error("You must pass a selector to useSelector");
	      }
	
	      if (typeof selector !== 'function') {
	        throw new Error("You must pass a function as a selector to useSelector");
	      }
	
	      if (typeof equalityFn !== 'function') {
	        throw new Error("You must pass a function as an equality function to useSelector");
	      }
	    }
	
	    var _useReduxContext = useReduxContext(),
	        store = _useReduxContext.store,
	        contextSub = _useReduxContext.subscription;
	
	    var selectedState = useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
	    (0, _react.useDebugValue)(selectedState);
	    return selectedState;
	  };
	}
	/**
	 * A hook to access the redux store's state. This hook takes a selector function
	 * as an argument. The selector is called with the store state.
	 *
	 * This hook takes an optional equality comparison function as the second parameter
	 * that allows you to customize the way the selected state is compared to determine
	 * whether the component needs to be re-rendered.
	 *
	 * @param {Function} selector the selector function
	 * @param {Function=} equalityFn the function that will be used to determine equality
	 *
	 * @returns {any} the selected state
	 *
	 * @example
	 *
	 * import React from 'react'
	 * import { useSelector } from 'react-redux'
	 *
	 * export const CounterComponent = () => {
	 *   const counter = useSelector(state => state.counter)
	 *   return <div>{counter}</div>
	 * }
	 */
	
	
	var useSelector = /*#__PURE__*/createSelectorHook();
	exports.useSelector = useSelector;

/***/ },
/* 2309 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = bindActionCreators;
	
	function bindActionCreators(actionCreators, dispatch) {
	  var boundActionCreators = {};
	
	  var _loop = function _loop(key) {
	    var actionCreator = actionCreators[key];
	
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = function () {
	        return dispatch(actionCreator.apply(void 0, arguments));
	      };
	    }
	  };
	
	  for (var key in actionCreators) {
	    _loop(key);
	  }
	
	  return boundActionCreators;
	}

/***/ },
/* 2310 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = isPlainObject;
	
	/**
	 * @param {any} obj The object to inspect.
	 * @returns {boolean} True if the argument appears to be a plain object.
	 */
	function isPlainObject(obj) {
	  if (typeof obj !== 'object' || obj === null) return false;
	  var proto = Object.getPrototypeOf(obj);
	  if (proto === null) return true;
	  var baseProto = proto;
	
	  while (Object.getPrototypeOf(baseProto) !== null) {
	    baseProto = Object.getPrototypeOf(baseProto);
	  }
	
	  return proto === baseProto;
	}

/***/ },
/* 2311 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.unstable_batchedUpdates = void 0;
	
	var _reactDom = __webpack_require__(31);
	
	exports.unstable_batchedUpdates = _reactDom.unstable_batchedUpdates;

/***/ },
/* 2312 */
/***/ function(module, exports) {

	/** @license React v17.0.2
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	'use strict';var b=60103,c=60106,d=60107,e=60108,f=60114,g=60109,h=60110,k=60112,l=60113,m=60120,n=60115,p=60116,q=60121,r=60122,u=60117,v=60129,w=60131;
	if("function"===typeof Symbol&&Symbol.for){var x=Symbol.for;b=x("react.element");c=x("react.portal");d=x("react.fragment");e=x("react.strict_mode");f=x("react.profiler");g=x("react.provider");h=x("react.context");k=x("react.forward_ref");l=x("react.suspense");m=x("react.suspense_list");n=x("react.memo");p=x("react.lazy");q=x("react.block");r=x("react.server.block");u=x("react.fundamental");v=x("react.debug_trace_mode");w=x("react.legacy_hidden")}
	function y(a){if("object"===typeof a&&null!==a){var t=a.$$typeof;switch(t){case b:switch(a=a.type,a){case d:case f:case e:case l:case m:return a;default:switch(a=a&&a.$$typeof,a){case h:case k:case p:case n:case g:return a;default:return t}}case c:return t}}}var z=g,A=b,B=k,C=d,D=p,E=n,F=c,G=f,H=e,I=l;exports.ContextConsumer=h;exports.ContextProvider=z;exports.Element=A;exports.ForwardRef=B;exports.Fragment=C;exports.Lazy=D;exports.Memo=E;exports.Portal=F;exports.Profiler=G;exports.StrictMode=H;
	exports.Suspense=I;exports.isAsyncMode=function(){return!1};exports.isConcurrentMode=function(){return!1};exports.isContextConsumer=function(a){return y(a)===h};exports.isContextProvider=function(a){return y(a)===g};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===b};exports.isForwardRef=function(a){return y(a)===k};exports.isFragment=function(a){return y(a)===d};exports.isLazy=function(a){return y(a)===p};exports.isMemo=function(a){return y(a)===n};
	exports.isPortal=function(a){return y(a)===c};exports.isProfiler=function(a){return y(a)===f};exports.isStrictMode=function(a){return y(a)===e};exports.isSuspense=function(a){return y(a)===l};exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===d||a===f||a===v||a===e||a===l||a===m||a===w||"object"===typeof a&&null!==a&&(a.$$typeof===p||a.$$typeof===n||a.$$typeof===g||a.$$typeof===h||a.$$typeof===k||a.$$typeof===u||a.$$typeof===q||a[0]===r)?!0:!1};
	exports.typeOf=y;


/***/ },
/* 2313 */
[2772, 2312],
/* 2314 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _Resizable = _interopRequireDefault(__webpack_require__(955));
	
	var _propTypes2 = __webpack_require__(956);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var ResizableBox = /*#__PURE__*/function (_React$Component) {
	  _inheritsLoose(ResizableBox, _React$Component);
	
	  function ResizableBox() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	
	    _defineProperty(_assertThisInitialized(_this), "state", {
	      width: _this.props.width,
	      height: _this.props.height,
	      propsWidth: _this.props.width,
	      propsHeight: _this.props.height
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onResize", function (e, data) {
	      var size = data.size;
	
	      if (_this.props.onResize) {
	        e.persist && e.persist();
	
	        _this.setState(size, function () {
	          return _this.props.onResize && _this.props.onResize(e, data);
	        });
	      } else {
	        _this.setState(size);
	      }
	    });
	
	    return _this;
	  }
	
	  ResizableBox.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
	    // If parent changes height/width, set that in our state.
	    if (state.propsWidth !== props.width || state.propsHeight !== props.height) {
	      return {
	        width: props.width,
	        height: props.height,
	        propsWidth: props.width,
	        propsHeight: props.height
	      };
	    }
	
	    return null;
	  };
	
	  var _proto = ResizableBox.prototype;
	
	  _proto.render = function render() {
	    // Basic wrapper around a Resizable instance.
	    // If you use Resizable directly, you are responsible for updating the child component
	    // with a new width and height.
	    var _this$props = this.props,
	        handle = _this$props.handle,
	        handleSize = _this$props.handleSize,
	        onResize = _this$props.onResize,
	        onResizeStart = _this$props.onResizeStart,
	        onResizeStop = _this$props.onResizeStop,
	        draggableOpts = _this$props.draggableOpts,
	        minConstraints = _this$props.minConstraints,
	        maxConstraints = _this$props.maxConstraints,
	        lockAspectRatio = _this$props.lockAspectRatio,
	        axis = _this$props.axis,
	        width = _this$props.width,
	        height = _this$props.height,
	        resizeHandles = _this$props.resizeHandles,
	        style = _this$props.style,
	        transformScale = _this$props.transformScale,
	        props = _objectWithoutPropertiesLoose(_this$props, ["handle", "handleSize", "onResize", "onResizeStart", "onResizeStop", "draggableOpts", "minConstraints", "maxConstraints", "lockAspectRatio", "axis", "width", "height", "resizeHandles", "style", "transformScale"]);
	
	    return /*#__PURE__*/React.createElement(_Resizable.default, {
	      axis: axis,
	      draggableOpts: draggableOpts,
	      handle: handle,
	      handleSize: handleSize,
	      height: this.state.height,
	      lockAspectRatio: lockAspectRatio,
	      maxConstraints: maxConstraints,
	      minConstraints: minConstraints,
	      onResizeStart: onResizeStart,
	      onResize: this.onResize,
	      onResizeStop: onResizeStop,
	      resizeHandles: resizeHandles,
	      transformScale: transformScale,
	      width: this.state.width
	    }, /*#__PURE__*/React.createElement("div", _extends({}, props, {
	      style: _objectSpread(_objectSpread({}, style), {}, {
	        width: this.state.width + 'px',
	        height: this.state.height + 'px'
	      })
	    })));
	  };
	
	  return ResizableBox;
	}(React.Component);
	
	exports.default = ResizableBox;
	
	_defineProperty(ResizableBox, "propTypes", _objectSpread(_objectSpread({}, _propTypes2.resizableProps), {}, {
	  children: _propTypes.default.element
	}));

/***/ },
/* 2315 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.cloneElement = cloneElement;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// React.addons.cloneWithProps look-alike that merges style & className.
	function cloneElement(element, props) {
	  if (props.style && element.props.style) {
	    props.style = _objectSpread(_objectSpread({}, element.props.style), props.style);
	  }
	
	  if (props.className && element.props.className) {
	    props.className = element.props.className + " " + props.className;
	  }
	
	  return /*#__PURE__*/_react.default.cloneElement(element, props);
	}

/***/ },
/* 2316 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	module.exports = function() {
	  throw new Error("Don't instantiate Resizable directly! Use require('react-resizable').Resizable");
	};
	
	module.exports.Resizable = __webpack_require__(955).default;
	module.exports.ResizableBox = __webpack_require__(2314).default;


/***/ },
/* 2317 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _resizeObserverPolyfill = __webpack_require__(2459);
	
	var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);
	
	var _lodash = __webpack_require__(2054);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _lodash3 = __webpack_require__(2055);
	
	var _lodash4 = _interopRequireDefault(_lodash3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var listMode = { debounce: _lodash2.default, throttle: _lodash4.default };
	
	var styles = {
	  position: 'absolute',
	  width: 0,
	  height: 0,
	  visibility: 'hidden',
	  display: 'none'
	};
	
	var ResizeDetector = function (_PureComponent) {
	  _inherits(ResizeDetector, _PureComponent);
	
	  function ResizeDetector(props) {
	    _classCallCheck(this, ResizeDetector);
	
	    var _this = _possibleConstructorReturn(this, (ResizeDetector.__proto__ || Object.getPrototypeOf(ResizeDetector)).call(this, props));
	
	    _this.createResizeObserver = function (entries) {
	      var _this$props = _this.props,
	          handleWidth = _this$props.handleWidth,
	          handleHeight = _this$props.handleHeight,
	          onResize = _this$props.onResize;
	
	      entries.forEach(function (entry) {
	        var _entry$contentRect = entry.contentRect,
	            width = _entry$contentRect.width,
	            height = _entry$contentRect.height;
	
	        var notifyWidth = handleWidth && _this.width !== width;
	        var notifyHeight = handleHeight && _this.height !== height;
	        if (!_this.skipOnMount && (notifyWidth || notifyHeight)) {
	          onResize(width, height);
	        }
	        _this.width = width;
	        _this.height = height;
	        _this.skipOnMount = false;
	      });
	    };
	
	    var skipOnMount = props.skipOnMount,
	        refreshMode = props.refreshMode,
	        refreshRate = props.refreshRate;
	
	
	    _this.width = undefined;
	    _this.height = undefined;
	    _this.skipOnMount = skipOnMount;
	
	    var resizeObserver = listMode[refreshMode] && listMode[refreshMode](_this.createResizeObserver, refreshRate) || _this.createResizeObserver;
	
	    _this.ro = new _resizeObserverPolyfill2.default(resizeObserver);
	    return _this;
	  }
	
	  _createClass(ResizeDetector, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var resizableElementId = this.props.resizableElementId;
	
	      var resizableElement = resizableElementId ? document.getElementById(resizableElementId) : this.el.parentElement;
	      this.ro.observe(resizableElement);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var resizableElementId = this.props.resizableElementId;
	
	      var resizableElement = resizableElementId ? document.getElementById(resizableElementId) : this.el.parentElement;
	      this.ro.unobserve(resizableElement);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement('div', {
	        style: styles,
	        ref: function ref(el) {
	          _this2.el = el;
	        }
	      });
	    }
	  }]);
	
	  return ResizeDetector;
	}(_react.PureComponent);
	
	exports.default = ResizeDetector;
	
	
	ResizeDetector.propTypes = {
	  handleWidth: _propTypes2.default.bool,
	  handleHeight: _propTypes2.default.bool,
	  skipOnMount: _propTypes2.default.bool,
	  refreshRate: _propTypes2.default.number,
	  refreshMode: _propTypes2.default.string,
	  resizableElementId: _propTypes2.default.string,
	  onResize: _propTypes2.default.func
	};
	
	ResizeDetector.defaultProps = {
	  handleWidth: false,
	  handleHeight: false,
	  skipOnMount: false,
	  refreshRate: 1000,
	  refreshMode: undefined,
	  resizableElementId: '',
	  onResize: function onResize(e) {
	    return e;
	  }
	};

/***/ },
/* 2318 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ResizeDetector = __webpack_require__(2317);
	
	var _ResizeDetector2 = _interopRequireDefault(_ResizeDetector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ResizeDetector2.default;

/***/ },
/* 2319 */
/***/ function(module, exports, __webpack_require__) {

	// @remove-on-eject-begin
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	// @remove-on-eject-end
	'use strict';
	
	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(2197).enable();
	  window.Promise = __webpack_require__(2196);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(2320);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(456);


/***/ },
/* 2320 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 2321 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var size = 100;
	var radCircumference = Math.PI * 2;
	var center = size / 2;
	var radius = center - 1; // padding to prevent clipping
	
	/**
	 * @param {Object[]} slices
	 * @return {Object[]}
	 */
	function renderPaths(slices) {
	  var total = slices.reduce(function (totalValue, _ref) {
	    var value = _ref.value;
	    return totalValue + value;
	  }, 0);
	
	  var radSegment = 0;
	  var lastX = radius;
	  var lastY = 0;
	
	  return slices.map(function (_ref2, index) {
	    var color = _ref2.color;
	    var value = _ref2.value;
	
	    // Should we just draw a circle?
	    if (value === total) {
	      return _react2.default.createElement('circle', {
	        r: radius,
	        cx: center,
	        cy: center,
	        fill: color,
	        key: index
	      });
	    }
	
	    if (value === 0) {
	      return;
	    }
	
	    var valuePercentage = value / total;
	
	    // Should the arc go the long way round?
	    var longArc = valuePercentage <= 0.5 ? 0 : 1;
	
	    radSegment += valuePercentage * radCircumference;
	    var nextX = Math.cos(radSegment) * radius;
	    var nextY = Math.sin(radSegment) * radius;
	
	    // d is a string that describes the path of the slice.
	    // The weirdly placed minus signs [eg, (-(lastY))] are due to the fact
	    // that our calculations are for a graph with positive Y values going up,
	    // but on the screen positive Y values go down.
	    var d = ['M ' + center + ',' + center, 'l ' + lastX + ',' + -lastY, 'a' + radius + ',' + radius, '0', longArc + ',0', nextX - lastX + ',' + -(nextY - lastY), 'z'].join(' ');
	
	    lastX = nextX;
	    lastY = nextY;
	
	    return _react2.default.createElement('path', { d: d, fill: color, key: index });
	  });
	}
	
	/**
	 * Generates an SVG pie chart.
	 * @see {http://wiki.scribus.net/canvas/Making_a_Pie_Chart}
	 */
	
	var PieChart = (function (_React$Component) {
	  _inherits(PieChart, _React$Component);
	
	  function PieChart() {
	    _classCallCheck(this, PieChart);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(PieChart).apply(this, arguments));
	  }
	
	  _createClass(PieChart, [{
	    key: 'render',
	
	    /**
	     * @return {Object}
	     */
	    value: function render() {
	      return _react2.default.createElement(
	        'svg',
	        { viewBox: '0 0 ' + size + ' ' + size },
	        _react2.default.createElement(
	          'g',
	          { transform: 'rotate(-90 ' + center + ' ' + center + ')' },
	          renderPaths(this.props.slices)
	        )
	      );
	    }
	  }]);
	
	  return PieChart;
	})(_react2.default.Component);
	
	exports.default = PieChart;
	
	PieChart.propTypes = {
	  slices: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    color: _propTypes2.default.string.isRequired, // hex color
	    value: _propTypes2.default.number.isRequired
	  })).isRequired
	};
	module.exports = exports['default'];


/***/ },
/* 2322 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactTransitionGroup = __webpack_require__(126);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _AnimateGroupChild = _interopRequireDefault(__webpack_require__(2323));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function AnimateGroup(props) {
	  var component = props.component,
	      children = props.children,
	      appear = props.appear,
	      enter = props.enter,
	      leave = props.leave;
	  return _react.default.createElement(_reactTransitionGroup.TransitionGroup, {
	    component: component
	  }, _react.Children.map(children, function (child, index) {
	    return _react.default.createElement(_AnimateGroupChild.default, {
	      appearOptions: appear,
	      enterOptions: enter,
	      leaveOptions: leave,
	      key: "child-".concat(index)
	    }, child);
	  }));
	}
	
	AnimateGroup.propTypes = {
	  appear: _propTypes.default.object,
	  enter: _propTypes.default.object,
	  leave: _propTypes.default.object,
	  children: _propTypes.default.oneOfType([_propTypes.default.array, _propTypes.default.element]),
	  component: _propTypes.default.any
	};
	AnimateGroup.defaultProps = {
	  component: 'span'
	};
	var _default = AnimateGroup;
	exports.default = _default;

/***/ },
/* 2323 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _isNumber2 = _interopRequireDefault(__webpack_require__(291));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactTransitionGroup = __webpack_require__(126);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _Animate = _interopRequireDefault(__webpack_require__(958));
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var parseDurationOfSingleTransition = function parseDurationOfSingleTransition() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var steps = options.steps,
	      duration = options.duration;
	
	  if (steps && steps.length) {
	    return steps.reduce(function (result, entry) {
	      return result + ((0, _isNumber2.default)(entry.duration) && entry.duration > 0 ? entry.duration : 0);
	    }, 0);
	  }
	
	  if ((0, _isNumber2.default)(duration)) {
	    return duration;
	  }
	
	  return 0;
	};
	
	var AnimateGroupChild =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(AnimateGroupChild, _Component);
	
	  function AnimateGroupChild() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, AnimateGroupChild);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(AnimateGroupChild)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      isActive: false
	    };
	
	    _this.handleEnter = function (node, isAppearing) {
	      var _this$props = _this.props,
	          appearOptions = _this$props.appearOptions,
	          enterOptions = _this$props.enterOptions;
	
	      _this.handleStyleActive(isAppearing ? appearOptions : enterOptions);
	    };
	
	    _this.handleExit = function () {
	      _this.handleStyleActive(_this.props.leaveOptions);
	    };
	
	    return _this;
	  }
	
	  _createClass(AnimateGroupChild, [{
	    key: "handleStyleActive",
	    value: function handleStyleActive(style) {
	      if (style) {
	        var onAnimationEnd = style.onAnimationEnd ? function () {
	          style.onAnimationEnd();
	        } : null;
	        this.setState(_objectSpread({}, style, {
	          onAnimationEnd: onAnimationEnd,
	          isActive: true
	        }));
	      }
	    }
	  }, {
	    key: "parseTimeout",
	    value: function parseTimeout() {
	      var _this$props2 = this.props,
	          appearOptions = _this$props2.appearOptions,
	          enterOptions = _this$props2.enterOptions,
	          leaveOptions = _this$props2.leaveOptions;
	      return parseDurationOfSingleTransition(appearOptions) + parseDurationOfSingleTransition(enterOptions) + parseDurationOfSingleTransition(leaveOptions);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _this$props3 = this.props,
	          children = _this$props3.children,
	          appearOptions = _this$props3.appearOptions,
	          enterOptions = _this$props3.enterOptions,
	          leaveOptions = _this$props3.leaveOptions,
	          props = _objectWithoutProperties(_this$props3, ["children", "appearOptions", "enterOptions", "leaveOptions"]);
	
	      return _react.default.createElement(_reactTransitionGroup.Transition, _extends({}, props, {
	        onEnter: this.handleEnter,
	        onExit: this.handleExit,
	        timeout: this.parseTimeout()
	      }), function () {
	        return _react.default.createElement(_Animate.default, _this2.state, _react.Children.only(children));
	      });
	    }
	  }]);
	
	  return AnimateGroupChild;
	}(_react.Component);
	
	AnimateGroupChild.propTypes = {
	  appearOptions: _propTypes.default.object,
	  enterOptions: _propTypes.default.object,
	  leaveOptions: _propTypes.default.object,
	  children: _propTypes.default.element
	};
	var _default = AnimateGroupChild;
	exports.default = _default;

/***/ },
/* 2324 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createAnimateManager;
	
	var _setRafTimeout = _interopRequireDefault(__webpack_require__(2326));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _toArray(arr) { return _arrayWithHoles(arr) || _iterableToArray(arr) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function createAnimateManager() {
	  var currStyle = {};
	
	  var handleChange = function handleChange() {
	    return null;
	  };
	
	  var shouldStop = false;
	
	  var setStyle = function setStyle(_style) {
	    if (shouldStop) {
	      return;
	    }
	
	    if (Array.isArray(_style)) {
	      if (!_style.length) {
	        return;
	      }
	
	      var styles = _style;
	
	      var _styles = _toArray(styles),
	          curr = _styles[0],
	          restStyles = _styles.slice(1);
	
	      if (typeof curr === 'number') {
	        (0, _setRafTimeout.default)(setStyle.bind(null, restStyles), curr);
	        return;
	      }
	
	      setStyle(curr);
	      (0, _setRafTimeout.default)(setStyle.bind(null, restStyles));
	      return;
	    }
	
	    if (_typeof(_style) === 'object') {
	      currStyle = _style;
	      handleChange(currStyle);
	    }
	
	    if (typeof _style === 'function') {
	      _style();
	    }
	  };
	
	  return {
	    stop: function stop() {
	      shouldStop = true;
	    },
	    start: function start(style) {
	      shouldStop = false;
	      setStyle(style);
	    },
	    subscribe: function subscribe(_handleChange) {
	      handleChange = _handleChange;
	      return function () {
	        handleChange = function handleChange() {
	          return null;
	        };
	      };
	    }
	  };
	}

/***/ },
/* 2325 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _filter2 = _interopRequireDefault(__webpack_require__(2163));
	
	var _raf = _interopRequireWildcard(__webpack_require__(911));
	
	var _util = __webpack_require__(304);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var alpha = function alpha(begin, end, k) {
	  return begin + (end - begin) * k;
	};
	
	var needContinue = function needContinue(_ref) {
	  var from = _ref.from,
	      to = _ref.to;
	  return from !== to;
	};
	/*
	 * @description: cal new from value and velocity in each stepper
	 * @return: { [styleProperty]: { from, to, velocity } }
	 */
	
	
	var calStepperVals = function calStepperVals(easing, preVals, steps) {
	  var nextStepVals = (0, _util.mapObject)(function (key, val) {
	    if (needContinue(val)) {
	      var _easing = easing(val.from, val.to, val.velocity),
	          _easing2 = _slicedToArray(_easing, 2),
	          newX = _easing2[0],
	          newV = _easing2[1];
	
	      return _objectSpread({}, val, {
	        from: newX,
	        velocity: newV
	      });
	    }
	
	    return val;
	  }, preVals);
	
	  if (steps < 1) {
	    return (0, _util.mapObject)(function (key, val) {
	      if (needContinue(val)) {
	        return _objectSpread({}, val, {
	          velocity: alpha(val.velocity, nextStepVals[key].velocity, steps),
	          from: alpha(val.from, nextStepVals[key].from, steps)
	        });
	      }
	
	      return val;
	    }, preVals);
	  }
	
	  return calStepperVals(easing, nextStepVals, steps - 1);
	}; // configure update function
	
	
	var _default = function _default(from, to, easing, duration, render) {
	  var interKeys = (0, _util.getIntersectionKeys)(from, to);
	  var timingStyle = interKeys.reduce(function (res, key) {
	    return _objectSpread({}, res, _defineProperty({}, key, [from[key], to[key]]));
	  }, {});
	  var stepperStyle = interKeys.reduce(function (res, key) {
	    return _objectSpread({}, res, _defineProperty({}, key, {
	      from: from[key],
	      velocity: 0,
	      to: to[key]
	    }));
	  }, {});
	  var cafId = -1;
	  var preTime;
	  var beginTime;
	
	  var update = function update() {
	    return null;
	  };
	
	  var getCurrStyle = function getCurrStyle() {
	    return (0, _util.mapObject)(function (key, val) {
	      return val.from;
	    }, stepperStyle);
	  };
	
	  var shouldStopAnimation = function shouldStopAnimation() {
	    return !(0, _filter2.default)(stepperStyle, needContinue).length;
	  }; // stepper timing function like spring
	
	
	  var stepperUpdate = function stepperUpdate(now) {
	    if (!preTime) {
	      preTime = now;
	    }
	
	    var deltaTime = now - preTime;
	    var steps = deltaTime / easing.dt;
	    stepperStyle = calStepperVals(easing, stepperStyle, steps); // get union set and add compatible prefix
	
	    render(_objectSpread({}, from, to, getCurrStyle(stepperStyle)));
	    preTime = now;
	
	    if (!shouldStopAnimation()) {
	      cafId = (0, _raf.default)(update);
	    }
	  }; // t => val timing function like cubic-bezier
	
	
	  var timingUpdate = function timingUpdate(now) {
	    if (!beginTime) {
	      beginTime = now;
	    }
	
	    var t = (now - beginTime) / duration;
	    var currStyle = (0, _util.mapObject)(function (key, val) {
	      return alpha.apply(void 0, _toConsumableArray(val).concat([easing(t)]));
	    }, timingStyle); // get union set and add compatible prefix
	
	    render(_objectSpread({}, from, to, currStyle));
	
	    if (t < 1) {
	      cafId = (0, _raf.default)(update);
	    } else {
	      var finalStyle = (0, _util.mapObject)(function (key, val) {
	        return alpha.apply(void 0, _toConsumableArray(val).concat([easing(1)]));
	      }, timingStyle);
	      render(_objectSpread({}, from, to, finalStyle));
	    }
	  };
	
	  update = easing.isStepper ? stepperUpdate : timingUpdate; // return start animation method
	
	  return function () {
	    (0, _raf.default)(update); // return stop animation method
	
	    return function () {
	      (0, _raf.cancel)(cafId);
	    };
	  };
	};
	
	exports.default = _default;

/***/ },
/* 2326 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setRafTimeout;
	
	var _raf = _interopRequireDefault(__webpack_require__(911));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function setRafTimeout(callback) {
	  var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	  var currTime = -1;
	
	  var shouldUpdate = function shouldUpdate(now) {
	    if (currTime < 0) {
	      currTime = now;
	    }
	
	    if (now - currTime > timeout) {
	      callback(now);
	      currTime = -1;
	    } else {
	      (0, _raf.default)(shouldUpdate);
	    }
	  };
	
	  (0, _raf.default)(shouldUpdate);
	}

/***/ },
/* 2327 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(2));
	
	var _addClass = _interopRequireDefault(__webpack_require__(416));
	
	var _removeClass = _interopRequireDefault(__webpack_require__(417));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _Transition = _interopRequireDefault(__webpack_require__(960));
	
	var _PropTypes = __webpack_require__(962);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var addClass = function addClass(node, classes) {
	  return node && classes && classes.split(' ').forEach(function (c) {
	    return (0, _addClass.default)(node, c);
	  });
	};
	
	var removeClass = function removeClass(node, classes) {
	  return node && classes && classes.split(' ').forEach(function (c) {
	    return (0, _removeClass.default)(node, c);
	  });
	};
	/**
	 * A transition component inspired by the excellent
	 * [ng-animate](http://www.nganimate.org/) library, you should use it if you're
	 * using CSS transitions or animations. It's built upon the
	 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
	 * component, so it inherits all of its props.
	 *
	 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
	 * and `exit` states of the transition. The first class is applied and then a
	 * second `*-active` class in order to activate the CSSS transition. After the
	 * transition, matching `*-done` class names are applied to persist the
	 * transition state.
	 *
	 * ```jsx
	 * function App() {
	 *   const [inProp, setInProp] = useState(false);
	 *   return (
	 *     <div>
	 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
	 *         <div>
	 *           {"I'll receive my-node-* classes"}
	 *         </div>
	 *       </CSSTransition>
	 *       <button type="button" onClick={() => setInProp(true)}>
	 *         Click to Enter
	 *       </button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the `in` prop is set to `true`, the child component will first receive
	 * the class `example-enter`, then the `example-enter-active` will be added in
	 * the next tick. `CSSTransition` [forces a
	 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
	 * between before adding the `example-enter-active`. This is an important trick
	 * because it allows us to transition between `example-enter` and
	 * `example-enter-active` even though they were added immediately one after
	 * another. Most notably, this is what makes it possible for us to animate
	 * _appearance_.
	 *
	 * ```css
	 * .my-node-enter {
	 *   opacity: 0;
	 * }
	 * .my-node-enter-active {
	 *   opacity: 1;
	 *   transition: opacity 200ms;
	 * }
	 * .my-node-exit {
	 *   opacity: 1;
	 * }
	 * .my-node-exit-active {
	 *   opacity: 0;
	 *   transition: opacity: 200ms;
	 * }
	 * ```
	 *
	 * `*-active` classes represent which styles you want to animate **to**.
	 */
	
	
	var CSSTransition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(CSSTransition, _React$Component);
	
	  function CSSTransition() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	
	    _this.onEnter = function (node, appearing) {
	      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
	          className = _this$getClassNames.className;
	
	      _this.removeClasses(node, 'exit');
	
	      addClass(node, className);
	
	      if (_this.props.onEnter) {
	        _this.props.onEnter(node, appearing);
	      }
	    };
	
	    _this.onEntering = function (node, appearing) {
	      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
	          activeClassName = _this$getClassNames2.activeClassName;
	
	      _this.reflowAndAddClass(node, activeClassName);
	
	      if (_this.props.onEntering) {
	        _this.props.onEntering(node, appearing);
	      }
	    };
	
	    _this.onEntered = function (node, appearing) {
	      var appearClassName = _this.getClassNames('appear').doneClassName;
	
	      var enterClassName = _this.getClassNames('enter').doneClassName;
	
	      var doneClassName = appearing ? appearClassName + " " + enterClassName : enterClassName;
	
	      _this.removeClasses(node, appearing ? 'appear' : 'enter');
	
	      addClass(node, doneClassName);
	
	      if (_this.props.onEntered) {
	        _this.props.onEntered(node, appearing);
	      }
	    };
	
	    _this.onExit = function (node) {
	      var _this$getClassNames3 = _this.getClassNames('exit'),
	          className = _this$getClassNames3.className;
	
	      _this.removeClasses(node, 'appear');
	
	      _this.removeClasses(node, 'enter');
	
	      addClass(node, className);
	
	      if (_this.props.onExit) {
	        _this.props.onExit(node);
	      }
	    };
	
	    _this.onExiting = function (node) {
	      var _this$getClassNames4 = _this.getClassNames('exit'),
	          activeClassName = _this$getClassNames4.activeClassName;
	
	      _this.reflowAndAddClass(node, activeClassName);
	
	      if (_this.props.onExiting) {
	        _this.props.onExiting(node);
	      }
	    };
	
	    _this.onExited = function (node) {
	      var _this$getClassNames5 = _this.getClassNames('exit'),
	          doneClassName = _this$getClassNames5.doneClassName;
	
	      _this.removeClasses(node, 'exit');
	
	      addClass(node, doneClassName);
	
	      if (_this.props.onExited) {
	        _this.props.onExited(node);
	      }
	    };
	
	    _this.getClassNames = function (type) {
	      var classNames = _this.props.classNames;
	      var isStringClassNames = typeof classNames === 'string';
	      var prefix = isStringClassNames && classNames ? classNames + '-' : '';
	      var className = isStringClassNames ? prefix + type : classNames[type];
	      var activeClassName = isStringClassNames ? className + '-active' : classNames[type + 'Active'];
	      var doneClassName = isStringClassNames ? className + '-done' : classNames[type + 'Done'];
	      return {
	        className: className,
	        activeClassName: activeClassName,
	        doneClassName: doneClassName
	      };
	    };
	
	    return _this;
	  }
	
	  var _proto = CSSTransition.prototype;
	
	  _proto.removeClasses = function removeClasses(node, type) {
	    var _this$getClassNames6 = this.getClassNames(type),
	        className = _this$getClassNames6.className,
	        activeClassName = _this$getClassNames6.activeClassName,
	        doneClassName = _this$getClassNames6.doneClassName;
	
	    className && removeClass(node, className);
	    activeClassName && removeClass(node, activeClassName);
	    doneClassName && removeClass(node, doneClassName);
	  };
	
	  _proto.reflowAndAddClass = function reflowAndAddClass(node, className) {
	    // This is for to force a repaint,
	    // which is necessary in order to transition styles when adding a class name.
	    if (className) {
	      /* eslint-disable no-unused-expressions */
	      node && node.scrollTop;
	      /* eslint-enable no-unused-expressions */
	
	      addClass(node, className);
	    }
	  };
	
	  _proto.render = function render() {
	    var props = _extends({}, this.props);
	
	    delete props.classNames;
	    return _react.default.createElement(_Transition.default, _extends({}, props, {
	      onEnter: this.onEnter,
	      onEntered: this.onEntered,
	      onEntering: this.onEntering,
	      onExit: this.onExit,
	      onExiting: this.onExiting,
	      onExited: this.onExited
	    }));
	  };
	
	  return CSSTransition;
	}(_react.default.Component);
	
	CSSTransition.defaultProps = {
	  classNames: ''
	};
	CSSTransition.propTypes =  false ? _extends({}, _Transition.default.propTypes, {
	  /**
	   * The animation classNames applied to the component as it enters, exits or
	   * has finished the transition. A single name can be provided and it will be
	   * suffixed for each stage: e.g.
	   *
	   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`,
	   * `fade-enter-done`, `fade-exit`, `fade-exit-active`, `fade-exit-done`,
	   * `fade-appear`, `fade-appear-active`, and `fade-appear-done`.
	   *
	   * **Note**: `fade-appear-done` and `fade-enter-done` will _both_ be applied.
	   * This allows you to define different behavior for when appearing is done and
	   * when regular entering is done, using selectors like
	   * `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply an
	   * epic entrance animation when element first appears in the DOM using
	   * [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
	   * simply use `fade-enter-done` for defining both cases.
	   *
	   * Each individual classNames can also be specified independently like:
	   *
	   * ```js
	   * classNames={{
	   *  appear: 'my-appear',
	   *  appearActive: 'my-active-appear',
	   *  appearDone: 'my-done-appear',
	   *  enter: 'my-enter',
	   *  enterActive: 'my-active-enter',
	   *  enterDone: 'my-done-enter',
	   *  exit: 'my-exit',
	   *  exitActive: 'my-active-exit',
	   *  exitDone: 'my-done-exit',
	   * }}
	   * ```
	   *
	   * If you want to set these classes using CSS Modules:
	   *
	   * ```js
	   * import styles from './styles.css';
	   * ```
	   *
	   * you might want to use camelCase in your CSS file, that way could simply
	   * spread them instead of listing them one by one:
	   *
	   * ```js
	   * classNames={{ ...styles }}
	   * ```
	   *
	   * @type {string | {
	   *  appear?: string,
	   *  appearActive?: string,
	   *  appearDone?: string,
	   *  enter?: string,
	   *  enterActive?: string,
	   *  enterDone?: string,
	   *  exit?: string,
	   *  exitActive?: string,
	   *  exitDone?: string,
	   * }}
	   */
	  classNames: _PropTypes.classNamesShape,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
	   * applied.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEnter: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter-active' or
	   * 'appear-active' class is applied.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or
	   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntered: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' class is
	   * applied.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExit: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExiting: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' classes
	   * are **removed** and the `exit-done` class is added to the DOM node.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExited: PropTypes.func
	}) : {};
	var _default = CSSTransition;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 2328 */
[2773, 961],
/* 2329 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	exports.getInitialChildMapping = getInitialChildMapping;
	exports.getNextChildMapping = getNextChildMapping;
	
	var _react = __webpack_require__(1);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children, mapFn) {
	  var mapper = function mapper(child) {
	    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
	  };
	
	  var result = Object.create(null);
	  if (children) _react.Children.map(children, function (c) {
	    return c;
	  }).forEach(function (child) {
	    // run the map function here instead so that the key is the computed one
	    result[child.key] = mapper(child);
	  });
	  return result;
	}
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	
	
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    return key in next ? next[key] : prev[key];
	  } // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	
	
	  var nextKeysPending = Object.create(null);
	  var pendingKeys = [];
	
	  for (var prevKey in prev) {
	    if (prevKey in next) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i;
	  var childMapping = {};
	
	  for (var nextKey in next) {
	    if (nextKeysPending[nextKey]) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	
	    childMapping[nextKey] = getValueForKey(nextKey);
	  } // Finally, add the keys which didn't appear before any key in `next`
	
	
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}
	
	function getProp(child, prop, props) {
	  return props[prop] != null ? props[prop] : child.props[prop];
	}
	
	function getInitialChildMapping(props, onExited) {
	  return getChildMapping(props.children, function (child) {
	    return (0, _react.cloneElement)(child, {
	      onExited: onExited.bind(null, child),
	      in: true,
	      appear: getProp(child, 'appear', props),
	      enter: getProp(child, 'enter', props),
	      exit: getProp(child, 'exit', props)
	    });
	  });
	}
	
	function getNextChildMapping(nextProps, prevChildMapping, onExited) {
	  var nextChildMapping = getChildMapping(nextProps.children);
	  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
	  Object.keys(children).forEach(function (key) {
	    var child = children[key];
	    if (!(0, _react.isValidElement)(child)) return;
	    var hasPrev = key in prevChildMapping;
	    var hasNext = key in nextChildMapping;
	    var prevChild = prevChildMapping[key];
	    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
	
	    if (hasNext && (!hasPrev || isLeaving)) {
	      // console.log('entering', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        onExited: onExited.bind(null, child),
	        in: true,
	        exit: getProp(child, 'exit', nextProps),
	        enter: getProp(child, 'enter', nextProps)
	      });
	    } else if (!hasNext && hasPrev && !isLeaving) {
	      // item is old (exiting)
	      // console.log('leaving', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        in: false
	      });
	    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
	      // item hasn't changed transition states
	      // copy over the last transition props;
	      // console.log('unchanged', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        onExited: onExited.bind(null, child),
	        in: prevChild.props.in,
	        exit: getProp(child, 'exit', nextProps),
	        enter: getProp(child, 'enter', nextProps)
	      });
	    }
	  });
	  return children;
	}

/***/ },
/* 2330 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v16.14.0
	 * react.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var l=__webpack_require__(456),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
	60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
	var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
	function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
	function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
	function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
	function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
	function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
	0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
	function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
	var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
	exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
	exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
	key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
	exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
	exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.14.0";


/***/ },
/* 2331 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(14);
	
	var _excluded = ["className", "cssModule", "color", "innerRef", "pill", "tag"];
	var propTypes = {
	  color: _propTypes.default.string,
	  pill: _propTypes.default.bool,
	  tag: _utils.tagPropType,
	  innerRef: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func, _propTypes.default.string]),
	  children: _propTypes.default.node,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  color: 'secondary',
	  pill: false,
	  tag: 'span'
	};
	
	var Badge = function Badge(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      color = props.color,
	      innerRef = props.innerRef,
	      pill = props.pill,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'badge', 'badge-' + color, pill ? 'badge-pill' : false), cssModule);
	
	  if (attributes.href && Tag === 'span') {
	    Tag = 'a';
	  }
	
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes,
	    ref: innerRef
	  }));
	};
	
	Badge.propTypes = propTypes;
	Badge.defaultProps = defaultProps;
	var _default = Badge;
	exports.default = _default;

/***/ },
/* 2332 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(14);
	
	var _excluded = ["className", "listClassName", "cssModule", "children", "tag", "listTag", "aria-label"];
	var propTypes = {
	  tag: _utils.tagPropType,
	  listTag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  listClassName: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  children: _propTypes.default.node,
	  'aria-label': _propTypes.default.string
	};
	var defaultProps = {
	  tag: 'nav',
	  listTag: 'ol',
	  'aria-label': 'breadcrumb'
	};
	
	var Breadcrumb = function Breadcrumb(props) {
	  var className = props.className,
	      listClassName = props.listClassName,
	      cssModule = props.cssModule,
	      children = props.children,
	      Tag = props.tag,
	      ListTag = props.listTag,
	      label = props['aria-label'],
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className), cssModule);
	  var listClasses = (0, _utils.mapToCssModules)((0, _classnames.default)('breadcrumb', listClassName), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes,
	    "aria-label": label
	  }), /*#__PURE__*/_react.default.createElement(ListTag, {
	    className: listClasses
	  }, children));
	};
	
	Breadcrumb.propTypes = propTypes;
	Breadcrumb.defaultProps = defaultProps;
	var _default = Breadcrumb;
	exports.default = _default;

/***/ },
/* 2333 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(14);
	
	var _excluded = ["className", "cssModule", "active", "tag"];
	var propTypes = {
	  tag: _utils.tagPropType,
	  active: _propTypes.default.bool,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'li'
	};
	
	var BreadcrumbItem = function BreadcrumbItem(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      active = props.active,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, active ? 'active' : false, 'breadcrumb-item'), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes,
	    "aria-current": active ? 'page' : undefined
	  }));
	};
	
	BreadcrumbItem.propTypes = propTypes;
	BreadcrumbItem.defaultProps = defaultProps;
	var _default = BreadcrumbItem;
	exports.default = _default;

/***/ },
/* 2334 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(14);
	
	var _excluded = ["className", "cssModule", "size", "vertical", "tag"];
	var propTypes = {
	  tag: _utils.tagPropType,
	  'aria-label': _propTypes.default.string,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  role: _propTypes.default.string,
	  size: _propTypes.default.string,
	  vertical: _propTypes.default.bool
	};
	var defaultProps = {
	  tag: 'div',
	  role: 'group'
	};
	
	var ButtonGroup = function ButtonGroup(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      size = props.size,
	      vertical = props.vertical,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, size ? 'btn-group-' + size : false, vertical ? 'btn-group-vertical' : 'btn-group'), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	ButtonGroup.propTypes = propTypes;
	ButtonGroup.defaultProps = defaultProps;
	var _default = ButtonGroup;
	exports.default = _default;

/***/ },
/* 2335 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(20));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _Button = _interopRequireDefault(__webpack_require__(470));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(14);
	
	var _excluded = ["className"];
	var propTypes = {
	  onClick: _propTypes.default.func,
	  onBlur: _propTypes.default.func,
	  onFocus: _propTypes.default.func,
	  defaultValue: _propTypes.default.bool
	};
	var defaultProps = {
	  defaultValue: false
	};
	
	var ButtonToggle = /*#__PURE__*/function (_React$Component) {
	  (0, _inheritsLoose2.default)(ButtonToggle, _React$Component);
	
	  function ButtonToggle(props) {
	    var _this;
	
	    _this = _React$Component.call(this, props) || this;
	    _this.state = {
	      toggled: props.defaultValue,
	      focus: false
	    };
	    _this.onBlur = _this.onBlur.bind((0, _assertThisInitialized2.default)(_this));
	    _this.onFocus = _this.onFocus.bind((0, _assertThisInitialized2.default)(_this));
	    _this.onClick = _this.onClick.bind((0, _assertThisInitialized2.default)(_this));
	    return _this;
	  }
	
	  var _proto = ButtonToggle.prototype;
	
	  _proto.onBlur = function onBlur(e) {
	    if (this.props.onBlur) {
	      this.props.onBlur(e);
	    }
	
	    this.setState({
	      focus: false
	    });
	  };
	
	  _proto.onFocus = function onFocus(e) {
	    if (this.props.onFocus) {
	      this.props.onFocus(e);
	    }
	
	    this.setState({
	      focus: true
	    });
	  };
	
	  _proto.onClick = function onClick(e) {
	    if (this.props.onClick) {
	      this.props.onClick(e);
	    }
	
	    this.setState(function (_ref) {
	      var toggled = _ref.toggled;
	      return {
	        toggled: !toggled
	      };
	    });
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        className = _this$props.className,
	        attributes = (0, _objectWithoutPropertiesLoose2.default)(_this$props, _excluded);
	    var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, {
	      focus: this.state.focus
	    }), this.props.cssModule);
	    return /*#__PURE__*/_react.default.createElement(_Button.default, (0, _extends2.default)({
	      active: this.state.toggled,
	      onBlur: this.onBlur,
	      onFocus: this.onFocus,
	      onClick: this.onClick,
	      className: classes
	    }, attributes));
	  };
	
	  return ButtonToggle;
	}(_react.default.Component);
	
	ButtonToggle.propTypes = propTypes;
	ButtonToggle.defaultProps = defaultProps;
	var _default = ButtonToggle;
	exports.default = _default;

/***/ },
/* 2336 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(14);
	
	var _excluded = ["className", "cssModule", "tag"];
	var propTypes = {
	  tag: _utils.tagPropType,
	  'aria-label': _propTypes.default.string,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  role: _propTypes.default.string
	};
	var defaultProps = {
	  tag: 'div',
	  role: 'toolbar'
	};
	
	var ButtonToolbar = function ButtonToolbar(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'btn-toolbar'), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	ButtonToolbar.propTypes = propTypes;
	ButtonToolbar.defaultProps = defaultProps;
	var _default = ButtonToolbar;
	exports.default = _default;

/***/ },
/* 2337 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(14);
	
	var _excluded = ["className", "cssModule", "color", "body", "inverse", "outline", "tag", "innerRef"];
	var propTypes = {
	  tag: _utils.tagPropType,
	  inverse: _propTypes.default.bool,
	  color: _propTypes.default.string,
	  body: _propTypes.default.bool,
	  outline: _propTypes.default.bool,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  innerRef: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string, _propTypes.default.func])
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var Card = function Card(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      color = props.color,
	      body = props.body,
	      inverse = props.inverse,
	      outline = props.outline,
	      Tag = props.tag,
	      innerRef = props.innerRef,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'card', inverse ? 'text-white' : false, body ? 'card-body' : false, color ? (outline ? 'border' : 'bg') + "-" + color : false), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes,
	    ref: innerRef
	  }));
	};
	
	Card.propTypes = propTypes;
	Card.defaultProps = defaultProps;
	var _default = Card;
	exports.default = _default;

/***/ },
/* 2338 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(14);
	
	var _excluded = ["className", "cssModule", "innerRef", "tag"];
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  innerRef: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string, _propTypes.default.func])
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var CardBody = function CardBody(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      innerRef = props.innerRef,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'card-body'), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes,
	    ref: innerRef
	  }));
	};
	
	CardBody.propTypes = propTypes;
	CardBody.defaultProps = defaultProps;
	var _default = CardBody;
	exports.default = _default;

/***/ },
/* 2339 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(14);
	
	var _excluded = ["className", "cssModule", "tag"];
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var CardColumns = function CardColumns(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'card-columns'), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	CardColumns.propTypes = propTypes;
	CardColumns.defaultProps = defaultProps;
	var _default = CardColumns;
	exports.default = _default;

/***/ },
/* 2340 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(14);
	
	var _excluded = ["className", "cssModule", "tag"];
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var CardDeck = function CardDeck(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'card-deck'), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	CardDeck.propTypes = propTypes;
	CardDeck.defaultProps = defaultProps;
	var _default = CardDeck;
	exports.default = _default;

/***/ },
/* 2341 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(14);
	
	var _excluded = ["className", "cssModule", "tag"];
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var CardFooter = function CardFooter(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'card-footer'), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	CardFooter.propTypes = propTypes;
	CardFooter.defaultProps = defaultProps;
	var _default = CardFooter;
	exports.default = _default;

/***/ },
/* 2342 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(14);
	
	var _excluded = ["className", "cssModule", "tag"];
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var CardGroup = function CardGroup(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'card-group'), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	CardGroup.propTypes = propTypes;
	CardGroup.defaultProps = defaultProps;
	var _default = CardGroup;
	exports.default = _default;

/***/ },
/* 2343 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(14);
	
	var _excluded = ["className", "cssModule", "tag"];
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var CardHeader = function CardHeader(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'card-header'), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	CardHeader.propTypes = propTypes;
	CardHeader.defaultProps = defaultProps;
	var _default = CardHeader;
	exports.default = _default;

/***/ },
/* 2344 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(14);
	
	var _excluded = ["className", "cssModule", "top", "bottom", "tag"];
	var propTypes = {
	  tag: _utils.tagPropType,
	  top: _propTypes.default.bool,
	  bottom: _propTypes.default.bool,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'img'
	};
	
	var CardImg = function CardImg(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      top = props.top,
	      bottom = props.bottom,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
	  var cardImgClassName = 'card-img';
	
	  if (top) {
	    cardImgClassName = 'card-img-top';
	  }
	
	  if (bottom) {
	    cardImgClassName = 'card-img-bottom';
	  }
	
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, cardImgClassName), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	CardImg.propTypes = propTypes;
	CardImg.defaultProps = defaultProps;
	var _default = CardImg;
	exports.default = _default;

/***/ },
/* 2345 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(14);
	
	var _excluded = ["className", "cssModule", "tag"];
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var CardImgOverlay = function CardImgOverlay(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'card-img-overlay'), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	CardImgOverlay.propTypes = propTypes;
	CardImgOverlay.defaultProps = defaultProps;
	var _default = CardImgOverlay;
	exports.default = _default;

/***/ },
/* 2346 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(14);
	
	var _excluded = ["className", "cssModule", "tag", "innerRef"];
	var propTypes = {
	  tag: _utils.tagPropType,
	  innerRef: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func, _propTypes.default.string]),
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'a'
	};
	
	var CardLink = function CardLink(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      innerRef = props.innerRef,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'card-link'), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    ref: innerRef,
	    className: classes
	  }));
	};
	
	CardLink.propTypes = propTypes;
	CardLink.defaultProps = defaultProps;
	var _default = CardLink;
	exports.default = _default;

/***/ },
/* 2347 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(14);
	
	var _excluded = ["className", "cssModule", "tag"];
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var CardSubtitle = function CardSubtitle(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'card-subtitle'), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	CardSubtitle.propTypes = propTypes;
	CardSubtitle.defaultProps = defaultProps;
	var _default = CardSubtitle;
	exports.default = _default;

/***/ },
/* 2348 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(14);
	
	var _excluded = ["className", "cssModule", "tag"];
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'p'
	};
	
	var CardText = function CardText(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'card-text'), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	CardText.propTypes = propTypes;
	CardText.defaultProps = defaultProps;
	var _default = CardText;
	exports.default = _default;

/***/ },
/* 2349 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(14);
	
	var _excluded = ["className", "cssModule", "tag"];
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var CardTitle = function CardTitle(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'card-title'), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	CardTitle.propTypes = propTypes;
	CardTitle.defaultProps = defaultProps;
	var _default = CardTitle;
	exports.default = _default;

/***/ },
/* 2350 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(14);
	
	var _excluded = ["className", "cssModule", "widths", "tag"];
	var colWidths = ['xs', 'sm', 'md', 'lg', 'xl'];
	
	var stringOrNumberProp = _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]);
	
	var columnProps = _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.number, _propTypes.default.string, _propTypes.default.shape({
	  size: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.number, _propTypes.default.string]),
	  order: stringOrNumberProp,
	  offset: stringOrNumberProp
	})]);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  xs: columnProps,
	  sm: columnProps,
	  md: columnProps,
	  lg: columnProps,
	  xl: columnProps,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  widths: _propTypes.default.array
	};
	var defaultProps = {
	  tag: 'div',
	  widths: colWidths
	};
	
	var getColumnSizeClass = function getColumnSizeClass(isXs, colWidth, colSize) {
	  if (colSize === true || colSize === '') {
	    return isXs ? 'col' : "col-" + colWidth;
	  } else if (colSize === 'auto') {
	    return isXs ? 'col-auto' : "col-" + colWidth + "-auto";
	  }
	
	  return isXs ? "col-" + colSize : "col-" + colWidth + "-" + colSize;
	};
	
	var Col = function Col(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      widths = props.widths,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
	  var colClasses = [];
	  widths.forEach(function (colWidth, i) {
	    var columnProp = props[colWidth];
	    delete attributes[colWidth];
	
	    if (!columnProp && columnProp !== '') {
	      return;
	    }
	
	    var isXs = !i;
	
	    if ((0, _utils.isObject)(columnProp)) {
	      var _classNames;
	
	      var colSizeInterfix = isXs ? '-' : "-" + colWidth + "-";
	      var colClass = getColumnSizeClass(isXs, colWidth, columnProp.size);
	      colClasses.push((0, _utils.mapToCssModules)((0, _classnames.default)((_classNames = {}, _classNames[colClass] = columnProp.size || columnProp.size === '', _classNames["order" + colSizeInterfix + columnProp.order] = columnProp.order || columnProp.order === 0, _classNames["offset" + colSizeInterfix + columnProp.offset] = columnProp.offset || columnProp.offset === 0, _classNames)), cssModule));
	    } else {
	      var _colClass = getColumnSizeClass(isXs, colWidth, columnProp);
	
	      colClasses.push(_colClass);
	    }
	  });
	
	  if (!colClasses.length) {
	    colClasses.push('col');
	  }
	
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, colClasses), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	Col.propTypes = propTypes;
	Col.defaultProps = defaultProps;
	var _default = Col;
	exports.default = _default;

/***/ },
/* 2351 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(14);
	
	var _excluded = ["className", "cssModule", "fluid", "tag"];
	var propTypes = {
	  tag: _utils.tagPropType,
	  fluid: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var Container = function Container(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      fluid = props.fluid,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
	  var containerClass = 'container';
	
	  if (fluid === true) {
	    containerClass = 'container-fluid';
	  } else if (fluid) {
	    containerClass = "container-" + fluid;
	  }
	
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, containerClass), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	Container.propTypes = propTypes;
	Container.defaultProps = defaultProps;
	var _default = Container;
	exports.default = _default;

/***/ },
/* 2352 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(14);
	
	var _CustomFileInput = _interopRequireDefault(__webpack_require__(970));
	
	var _excluded = ["className", "label", "inline", "valid", "invalid", "cssModule", "children", "bsSize", "innerRef", "htmlFor"],
	    _excluded2 = ["type"],
	    _excluded3 = ["hidden"];
	var propTypes = {
	  className: _propTypes.default.string,
	  id: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,
	  type: _propTypes.default.string.isRequired,
	  label: _propTypes.default.node,
	  inline: _propTypes.default.bool,
	  valid: _propTypes.default.bool,
	  invalid: _propTypes.default.bool,
	  bsSize: _propTypes.default.string,
	  htmlFor: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.array, _propTypes.default.func]),
	  innerRef: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string, _propTypes.default.func])
	};
	
	function CustomInput(props) {
	  var className = props.className,
	      label = props.label,
	      inline = props.inline,
	      valid = props.valid,
	      invalid = props.invalid,
	      cssModule = props.cssModule,
	      children = props.children,
	      bsSize = props.bsSize,
	      innerRef = props.innerRef,
	      htmlFor = props.htmlFor,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
	  var type = attributes.type;
	  var customClass = (0, _utils.mapToCssModules)((0, _classnames.default)(className, "custom-" + type, bsSize ? "custom-" + type + "-" + bsSize : false), cssModule);
	  var validationClassNames = (0, _utils.mapToCssModules)((0, _classnames.default)(invalid && "is-invalid", valid && "is-valid"), cssModule);
	  var labelHtmlFor = htmlFor || attributes.id;
	
	  if (type === "select") {
	    var _type = attributes.type,
	        _rest = (0, _objectWithoutPropertiesLoose2.default)(attributes, _excluded2);
	
	    return /*#__PURE__*/_react.default.createElement("select", (0, _extends2.default)({}, _rest, {
	      ref: innerRef,
	      className: (0, _classnames.default)(validationClassNames, customClass),
	      "aria-invalid": invalid
	    }), children);
	  }
	
	  if (type === "file") {
	    return /*#__PURE__*/_react.default.createElement(_CustomFileInput.default, props);
	  }
	
	  if (type !== "checkbox" && type !== "radio" && type !== "switch") {
	    return /*#__PURE__*/_react.default.createElement("input", (0, _extends2.default)({}, attributes, {
	      ref: innerRef,
	      "aria-invalid": invalid,
	      className: (0, _classnames.default)(validationClassNames, customClass)
	    }));
	  }
	
	  var wrapperClasses = (0, _classnames.default)(customClass, (0, _utils.mapToCssModules)((0, _classnames.default)("custom-control", {
	    "custom-control-inline": inline
	  }), cssModule));
	  var hidden = attributes.hidden,
	      rest = (0, _objectWithoutPropertiesLoose2.default)(attributes, _excluded3);
	  return /*#__PURE__*/_react.default.createElement("div", {
	    className: wrapperClasses,
	    hidden: hidden || false
	  }, /*#__PURE__*/_react.default.createElement("input", (0, _extends2.default)({}, rest, {
	    type: type === "switch" ? "checkbox" : type,
	    ref: innerRef,
	    "aria-invalid": invalid,
	    className: (0, _classnames.default)(validationClassNames, (0, _utils.mapToCssModules)("custom-control-input", cssModule))
	  })), /*#__PURE__*/_react.default.createElement("label", {
	    className: (0, _utils.mapToCssModules)("custom-control-label", cssModule),
	    htmlFor: labelHtmlFor
	  }, label), children);
	}
	
	CustomInput.propTypes = propTypes;
	var _default = CustomInput;
	exports.default = _default;

/***/ },
/* 2353 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(20));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _DropdownContext = __webpack_require__(228);
	
	var _utils = __webpack_require__(14);
	
	var _excluded = ["className", "cssModule", "divider", "tag", "header", "active", "text"];
	var propTypes = {
	  children: _propTypes.default.node,
	  active: _propTypes.default.bool,
	  disabled: _propTypes.default.bool,
	  divider: _propTypes.default.bool,
	  tag: _utils.tagPropType,
	  header: _propTypes.default.bool,
	  onClick: _propTypes.default.func,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  toggle: _propTypes.default.bool,
	  text: _propTypes.default.bool
	};
	var defaultProps = {
	  tag: 'button',
	  toggle: true
	};
	
	var DropdownItem = /*#__PURE__*/function (_React$Component) {
	  (0, _inheritsLoose2.default)(DropdownItem, _React$Component);
	
	  function DropdownItem(props) {
	    var _this;
	
	    _this = _React$Component.call(this, props) || this;
	    _this.onClick = _this.onClick.bind((0, _assertThisInitialized2.default)(_this));
	    _this.getTabIndex = _this.getTabIndex.bind((0, _assertThisInitialized2.default)(_this));
	    return _this;
	  }
	
	  var _proto = DropdownItem.prototype;
	
	  _proto.getRole = function getRole() {
	    if (this.context.menuRole === 'listbox') {
	      return 'option';
	    }
	
	    return 'menuitem';
	  };
	
	  _proto.onClick = function onClick(e) {
	    var _this$props = this.props,
	        disabled = _this$props.disabled,
	        header = _this$props.header,
	        divider = _this$props.divider,
	        text = _this$props.text;
	
	    if (disabled || header || divider || text) {
	      e.preventDefault();
	      return;
	    }
	
	    if (this.props.onClick) {
	      this.props.onClick(e);
	    }
	
	    if (this.props.toggle) {
	      this.context.toggle(e);
	    }
	  };
	
	  _proto.getTabIndex = function getTabIndex() {
	    var _this$props2 = this.props,
	        disabled = _this$props2.disabled,
	        header = _this$props2.header,
	        divider = _this$props2.divider,
	        text = _this$props2.text;
	
	    if (disabled || header || divider || text) {
	      return '-1';
	    }
	
	    return '0';
	  };
	
	  _proto.render = function render() {
	    var tabIndex = this.getTabIndex();
	    var role = tabIndex > -1 ? this.getRole() : undefined;
	
	    var _omit = (0, _utils.omit)(this.props, ['toggle']),
	        className = _omit.className,
	        cssModule = _omit.cssModule,
	        divider = _omit.divider,
	        Tag = _omit.tag,
	        header = _omit.header,
	        active = _omit.active,
	        text = _omit.text,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_omit, _excluded);
	
	    var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, {
	      disabled: props.disabled,
	      'dropdown-item': !divider && !header && !text,
	      active: active,
	      'dropdown-header': header,
	      'dropdown-divider': divider,
	      'dropdown-item-text': text
	    }), cssModule);
	
	    if (Tag === 'button') {
	      if (header) {
	        Tag = 'h6';
	      } else if (divider) {
	        Tag = 'div';
	      } else if (props.href) {
	        Tag = 'a';
	      } else if (text) {
	        Tag = 'span';
	      }
	    }
	
	    return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({
	      type: Tag === 'button' && (props.onClick || this.props.toggle) ? 'button' : undefined
	    }, props, {
	      tabIndex: tabIndex,
	      role: role,
	      className: classes,
	      onClick: this.onClick
	    }));
	  };
	
	  return DropdownItem;
	}(_react.default.Component);
	
	DropdownItem.propTypes = propTypes;
	DropdownItem.defaultProps = defaultProps;
	DropdownItem.contextType = _DropdownContext.DropdownContext;
	var _default = DropdownItem;
	exports.default = _default;

/***/ },
/* 2354 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(27));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(20));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(31));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _reactPopper = __webpack_require__(75);
	
	var _DropdownContext = __webpack_require__(228);
	
	var _utils = __webpack_require__(14);
	
	var _excluded = ["className", "cssModule", "right", "tag", "flip", "modifiers", "persist", "positionFixed", "container"];
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  children: _propTypes.default.node.isRequired,
	  right: _propTypes.default.bool,
	  flip: _propTypes.default.bool,
	  modifiers: _propTypes.default.object,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  persist: _propTypes.default.bool,
	  positionFixed: _propTypes.default.bool,
	  container: _utils.targetPropType
	};
	var defaultProps = {
	  tag: 'div',
	  flip: true
	};
	var noFlipModifier = {
	  flip: {
	    enabled: false
	  }
	};
	var directionPositionMap = {
	  up: 'top',
	  left: 'left',
	  right: 'right',
	  down: 'bottom'
	};
	
	var DropdownMenu = /*#__PURE__*/function (_React$Component) {
	  (0, _inheritsLoose2.default)(DropdownMenu, _React$Component);
	
	  function DropdownMenu() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = DropdownMenu.prototype;
	
	  _proto.getRole = function getRole() {
	    if (this.context.menuRole === 'listbox') {
	      return 'listbox';
	    }
	
	    return 'menu';
	  };
	
	  _proto.render = function render() {
	    var _this = this;
	
	    var _this$props = this.props,
	        className = _this$props.className,
	        cssModule = _this$props.cssModule,
	        right = _this$props.right,
	        tag = _this$props.tag,
	        flip = _this$props.flip,
	        modifiers = _this$props.modifiers,
	        persist = _this$props.persist,
	        positionFixed = _this$props.positionFixed,
	        container = _this$props.container,
	        attrs = (0, _objectWithoutPropertiesLoose2.default)(_this$props, _excluded);
	    var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'dropdown-menu', {
	      'dropdown-menu-right': right,
	      show: this.context.isOpen
	    }), cssModule);
	    var Tag = tag;
	
	    if (persist || this.context.isOpen && !this.context.inNavbar) {
	      var position1 = directionPositionMap[this.context.direction] || 'bottom';
	      var position2 = right ? 'end' : 'start';
	      var poperPlacement = position1 + "-" + position2;
	      var poperModifiers = !flip ? _objectSpread(_objectSpread({}, modifiers), noFlipModifier) : modifiers;
	      var popperPositionFixed = !!positionFixed;
	
	      var popper = /*#__PURE__*/_react.default.createElement(_reactPopper.Popper, {
	        placement: poperPlacement,
	        modifiers: poperModifiers,
	        positionFixed: popperPositionFixed
	      }, function (_ref) {
	        var ref = _ref.ref,
	            style = _ref.style,
	            placement = _ref.placement;
	
	        var combinedStyle = _objectSpread(_objectSpread({}, _this.props.style), style);
	
	        var handleRef = function handleRef(tagRef) {
	          // Send the ref to `react-popper`
	          ref(tagRef); // Send the ref to the parent Dropdown so that clicks outside
	          // it will cause it to close
	
	          var onMenuRef = _this.context.onMenuRef;
	          if (onMenuRef) onMenuRef(tagRef);
	        };
	
	        return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({
	          tabIndex: "-1",
	          role: _this.getRole(),
	          ref: handleRef
	        }, attrs, {
	          style: combinedStyle,
	          "aria-hidden": !_this.context.isOpen,
	          className: classes,
	          "x-placement": placement
	        }));
	      });
	
	      if (container) {
	        return /*#__PURE__*/_reactDom.default.createPortal(popper, (0, _utils.getTarget)(container));
	      } else {
	        return popper;
	      }
	    }
	
	    return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({
	      tabIndex: "-1",
	      role: this.getRole()
	    }, attrs, {
	      "aria-hidden": !this.context.isOpen,
	      className: classes,
	      "x-placement": attrs.placement
	    }));
	  };
	
	  return DropdownMenu;
	}(_react.default.Component);
	
	;
	DropdownMenu.propTypes = propTypes;
	DropdownMenu.defaultProps = defaultProps;
	DropdownMenu.contextType = _DropdownContext.DropdownContext;
	var _default = DropdownMenu;
	exports.default = _default;

/***/ },
/* 2355 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(20));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _reactPopper = __webpack_require__(75);
	
	var _DropdownContext = __webpack_require__(228);
	
	var _utils = __webpack_require__(14);
	
	var _Button = _interopRequireDefault(__webpack_require__(470));
	
	var _excluded = ["className", "color", "cssModule", "caret", "split", "nav", "tag", "innerRef"];
	var propTypes = {
	  caret: _propTypes.default.bool,
	  color: _propTypes.default.string,
	  children: _propTypes.default.node,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  disabled: _propTypes.default.bool,
	  onClick: _propTypes.default.func,
	  'aria-haspopup': _propTypes.default.bool,
	  split: _propTypes.default.bool,
	  tag: _utils.tagPropType,
	  nav: _propTypes.default.bool
	};
	var defaultProps = {
	  color: 'secondary',
	  'aria-haspopup': true
	};
	
	var DropdownToggle = /*#__PURE__*/function (_React$Component) {
	  (0, _inheritsLoose2.default)(DropdownToggle, _React$Component);
	
	  function DropdownToggle(props) {
	    var _this;
	
	    _this = _React$Component.call(this, props) || this;
	    _this.onClick = _this.onClick.bind((0, _assertThisInitialized2.default)(_this));
	    return _this;
	  }
	
	  var _proto = DropdownToggle.prototype;
	
	  _proto.onClick = function onClick(e) {
	    if (this.props.disabled || this.context.disabled) {
	      e.preventDefault();
	      return;
	    }
	
	    if (this.props.nav && !this.props.tag) {
	      e.preventDefault();
	    }
	
	    if (this.props.onClick) {
	      this.props.onClick(e);
	    }
	
	    this.context.toggle(e);
	  };
	
	  _proto.getRole = function getRole() {
	    return this.context.menuRole || this.props['aria-haspopup'];
	  };
	
	  _proto.render = function render() {
	    var _this2 = this;
	
	    var _this$props = this.props,
	        className = _this$props.className,
	        color = _this$props.color,
	        cssModule = _this$props.cssModule,
	        caret = _this$props.caret,
	        split = _this$props.split,
	        nav = _this$props.nav,
	        tag = _this$props.tag,
	        innerRef = _this$props.innerRef,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, _excluded);
	    var ariaLabel = props['aria-label'] || 'Toggle Dropdown';
	    var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, {
	      'dropdown-toggle': caret || split,
	      'dropdown-toggle-split': split,
	      'nav-link': nav
	    }), cssModule);
	    var children = typeof props.children !== 'undefined' ? props.children : /*#__PURE__*/_react.default.createElement("span", {
	      className: "sr-only"
	    }, ariaLabel);
	    var Tag;
	
	    if (nav && !tag) {
	      Tag = 'a';
	      props.href = '#';
	    } else if (!tag) {
	      Tag = _Button.default;
	      props.color = color;
	      props.cssModule = cssModule;
	    } else {
	      Tag = tag;
	    }
	
	    if (this.context.inNavbar) {
	      return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, props, {
	        className: classes,
	        onClick: this.onClick,
	        "aria-expanded": this.context.isOpen,
	        "aria-haspopup": this.getRole(),
	        children: children
	      }));
	    }
	
	    return /*#__PURE__*/_react.default.createElement(_reactPopper.Reference, {
	      innerRef: innerRef
	    }, function (_ref) {
	      var _ref2;
	
	      var ref = _ref.ref;
	      return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, props, (_ref2 = {}, _ref2[typeof Tag === 'string' ? 'ref' : 'innerRef'] = ref, _ref2), {
	        className: classes,
	        onClick: _this2.onClick,
	        "aria-expanded": _this2.context.isOpen,
	        "aria-haspopup": _this2.getRole(),
	        children: children
	      }));
	    });
	  };
	
	  return DropdownToggle;
	}(_react.default.Component);
	
	DropdownToggle.propTypes = propTypes;
	DropdownToggle.defaultProps = defaultProps;
	DropdownToggle.contextType = _DropdownContext.DropdownContext;
	var _default = DropdownToggle;
	exports.default = _default;

/***/ },
/* 2356 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(20));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(14);
	
	var _excluded = ["className", "cssModule", "inline", "tag", "innerRef"];
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var propTypes = {
	  children: _propTypes.default.node,
	  inline: _propTypes.default.bool,
	  tag: _utils.tagPropType,
	  innerRef: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func, _propTypes.default.string]),
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'form'
	};
	
	var Form = /*#__PURE__*/function (_Component) {
	  (0, _inheritsLoose2.default)(Form, _Component);
	
	  function Form(props) {
	    var _this;
	
	    _this = _Component.call(this, props) || this;
	    _this.getRef = _this.getRef.bind((0, _assertThisInitialized2.default)(_this));
	    _this.submit = _this.submit.bind((0, _assertThisInitialized2.default)(_this));
	    return _this;
	  }
	
	  var _proto = Form.prototype;
	
	  _proto.getRef = function getRef(ref) {
	    if (this.props.innerRef) {
	      this.props.innerRef(ref);
	    }
	
	    this.ref = ref;
	  };
	
	  _proto.submit = function submit() {
	    if (this.ref) {
	      this.ref.submit();
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        className = _this$props.className,
	        cssModule = _this$props.cssModule,
	        inline = _this$props.inline,
	        Tag = _this$props.tag,
	        innerRef = _this$props.innerRef,
	        attributes = (0, _objectWithoutPropertiesLoose2.default)(_this$props, _excluded);
	    var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, inline ? 'form-inline' : false), cssModule);
	    return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	      ref: innerRef,
	      className: classes
	    }));
	  };
	
	  return Form;
	}(_react.Component);
	
	Form.propTypes = propTypes;
	Form.defaultProps = defaultProps;
	var _default = Form;
	exports.default = _default;

/***/ },
/* 2357 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(14);
	
	var _excluded = ["className", "cssModule", "valid", "tooltip", "tag"];
	var propTypes = {
	  children: _propTypes.default.node,
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  valid: _propTypes.default.bool,
	  tooltip: _propTypes.default.bool
	};
	var defaultProps = {
	  tag: 'div',
	  valid: undefined
	};
	
	var FormFeedback = function FormFeedback(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      valid = props.valid,
	      tooltip = props.tooltip,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
	  var validMode = tooltip ? 'tooltip' : 'feedback';
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, valid ? "valid-" + validMode : "invalid-" + validMode), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	FormFeedback.propTypes = propTypes;
	FormFeedback.defaultProps = defaultProps;
	var _default = FormFeedback;
	exports.default = _default;

/***/ },
/* 2358 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(14);
	
	var _excluded = ["className", "cssModule", "row", "disabled", "check", "inline", "tag"];
	var propTypes = {
	  children: _propTypes.default.node,
	  row: _propTypes.default.bool,
	  check: _propTypes.default.bool,
	  inline: _propTypes.default.bool,
	  disabled: _propTypes.default.bool,
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var FormGroup = function FormGroup(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      row = props.row,
	      disabled = props.disabled,
	      check = props.check,
	      inline = props.inline,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, row ? 'row' : false, check ? 'form-check' : 'form-group', check && inline ? 'form-check-inline' : false, check && disabled ? 'disabled' : false), cssModule);
	
	  if (Tag === 'fieldset') {
	    attributes.disabled = disabled;
	  }
	
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	FormGroup.propTypes = propTypes;
	FormGroup.defaultProps = defaultProps;
	var _default = FormGroup;
	exports.default = _default;

/***/ },
/* 2359 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(14);
	
	var _excluded = ["className", "cssModule", "inline", "color", "tag"];
	var propTypes = {
	  children: _propTypes.default.node,
	  inline: _propTypes.default.bool,
	  tag: _utils.tagPropType,
	  color: _propTypes.default.string,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'small',
	  color: 'muted'
	};
	
	var FormText = function FormText(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      inline = props.inline,
	      color = props.color,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, !inline ? 'form-text' : false, color ? "text-" + color : false), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	FormText.propTypes = propTypes;
	FormText.defaultProps = defaultProps;
	var _default = FormText;
	exports.default = _default;

/***/ },
/* 2360 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(20));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(14);
	
	var _excluded = ["className", "cssModule", "type", "bsSize", "valid", "invalid", "tag", "addon", "plaintext", "innerRef"];
	var propTypes = {
	  children: _propTypes.default.node,
	  type: _propTypes.default.string,
	  size: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  bsSize: _propTypes.default.string,
	  valid: _propTypes.default.bool,
	  invalid: _propTypes.default.bool,
	  tag: _utils.tagPropType,
	  innerRef: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func, _propTypes.default.string]),
	  plaintext: _propTypes.default.bool,
	  addon: _propTypes.default.bool,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  type: 'text'
	};
	
	var Input = /*#__PURE__*/function (_React$Component) {
	  (0, _inheritsLoose2.default)(Input, _React$Component);
	
	  function Input(props) {
	    var _this;
	
	    _this = _React$Component.call(this, props) || this;
	    _this.getRef = _this.getRef.bind((0, _assertThisInitialized2.default)(_this));
	    _this.focus = _this.focus.bind((0, _assertThisInitialized2.default)(_this));
	    return _this;
	  }
	
	  var _proto = Input.prototype;
	
	  _proto.getRef = function getRef(ref) {
	    if (this.props.innerRef) {
	      this.props.innerRef(ref);
	    }
	
	    this.ref = ref;
	  };
	
	  _proto.focus = function focus() {
	    if (this.ref) {
	      this.ref.focus();
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        className = _this$props.className,
	        cssModule = _this$props.cssModule,
	        type = _this$props.type,
	        bsSize = _this$props.bsSize,
	        valid = _this$props.valid,
	        invalid = _this$props.invalid,
	        tag = _this$props.tag,
	        addon = _this$props.addon,
	        plaintext = _this$props.plaintext,
	        innerRef = _this$props.innerRef,
	        attributes = (0, _objectWithoutPropertiesLoose2.default)(_this$props, _excluded);
	    var checkInput = ['radio', 'checkbox'].indexOf(type) > -1;
	    var isNotaNumber = new RegExp('\\D', 'g');
	    var fileInput = type === 'file';
	    var textareaInput = type === 'textarea';
	    var selectInput = type === 'select';
	    var rangeInput = type === 'range';
	    var Tag = tag || (selectInput || textareaInput ? type : 'input');
	    var formControlClass = 'form-control';
	
	    if (plaintext) {
	      formControlClass = formControlClass + "-plaintext";
	      Tag = tag || 'input';
	    } else if (fileInput) {
	      formControlClass = formControlClass + "-file";
	    } else if (rangeInput) {
	      formControlClass = formControlClass + "-range";
	    } else if (checkInput) {
	      if (addon) {
	        formControlClass = null;
	      } else {
	        formControlClass = 'form-check-input';
	      }
	    }
	
	    if (attributes.size && isNotaNumber.test(attributes.size)) {
	      (0, _utils.warnOnce)('Please use the prop "bsSize" instead of the "size" to bootstrap\'s input sizing.');
	      bsSize = attributes.size;
	      delete attributes.size;
	    }
	
	    var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, invalid && 'is-invalid', valid && 'is-valid', bsSize ? "form-control-" + bsSize : false, formControlClass), cssModule);
	
	    if (Tag === 'input' || tag && typeof tag === 'function') {
	      attributes.type = type;
	    }
	
	    if (attributes.children && !(plaintext || type === 'select' || typeof Tag !== 'string' || Tag === 'select')) {
	      (0, _utils.warnOnce)("Input with a type of \"" + type + "\" cannot have children. Please use \"value\"/\"defaultValue\" instead.");
	      delete attributes.children;
	    }
	
	    return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	      ref: innerRef,
	      className: classes,
	      "aria-invalid": invalid
	    }));
	  };
	
	  return Input;
	}(_react.default.Component);
	
	Input.propTypes = propTypes;
	Input.defaultProps = defaultProps;
	var _default = Input;
	exports.default = _default;

/***/ },
/* 2361 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(14);
	
	var _excluded = ["className", "cssModule", "tag", "size"];
	var propTypes = {
	  tag: _utils.tagPropType,
	  size: _propTypes.default.string,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var InputGroup = function InputGroup(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      size = props.size,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'input-group', size ? "input-group-" + size : null), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	InputGroup.propTypes = propTypes;
	InputGroup.defaultProps = defaultProps;
	var _default = InputGroup;
	exports.default = _default;

/***/ },
/* 2362 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(14);
	
	var _InputGroupText = _interopRequireDefault(__webpack_require__(971));
	
	var _excluded = ["className", "cssModule", "tag", "addonType", "children"];
	var propTypes = {
	  tag: _utils.tagPropType,
	  addonType: _propTypes.default.oneOf(['prepend', 'append']).isRequired,
	  children: _propTypes.default.node,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var InputGroupAddon = function InputGroupAddon(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      addonType = props.addonType,
	      children = props.children,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'input-group-' + addonType), cssModule); // Convenience to assist with transition
	
	  if (typeof children === 'string') {
	    return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	      className: classes
	    }), /*#__PURE__*/_react.default.createElement(_InputGroupText.default, {
	      children: children
	    }));
	  }
	
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes,
	    children: children
	  }));
	};
	
	InputGroupAddon.propTypes = propTypes;
	InputGroupAddon.defaultProps = defaultProps;
	var _default = InputGroupAddon;
	exports.default = _default;

/***/ },
/* 2363 */
[2722, 305],
/* 2364 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(14);
	
	var _excluded = ["className", "cssModule", "tag", "fluid"];
	var propTypes = {
	  tag: _utils.tagPropType,
	  fluid: _propTypes.default.bool,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var Jumbotron = function Jumbotron(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      fluid = props.fluid,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'jumbotron', fluid ? 'jumbotron-fluid' : false), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	Jumbotron.propTypes = propTypes;
	Jumbotron.defaultProps = defaultProps;
	var _default = Jumbotron;
	exports.default = _default;

/***/ },
/* 2365 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(14);
	
	var _excluded = ["className", "cssModule", "hidden", "widths", "tag", "check", "size", "for"];
	var colWidths = ['xs', 'sm', 'md', 'lg', 'xl'];
	
	var stringOrNumberProp = _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]);
	
	var columnProps = _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string, _propTypes.default.number, _propTypes.default.shape({
	  size: stringOrNumberProp,
	  order: stringOrNumberProp,
	  offset: stringOrNumberProp
	})]);
	
	var propTypes = {
	  children: _propTypes.default.node,
	  hidden: _propTypes.default.bool,
	  check: _propTypes.default.bool,
	  size: _propTypes.default.string,
	  for: _propTypes.default.string,
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  xs: columnProps,
	  sm: columnProps,
	  md: columnProps,
	  lg: columnProps,
	  xl: columnProps,
	  widths: _propTypes.default.array
	};
	var defaultProps = {
	  tag: 'label',
	  widths: colWidths
	};
	
	var getColumnSizeClass = function getColumnSizeClass(isXs, colWidth, colSize) {
	  if (colSize === true || colSize === '') {
	    return isXs ? 'col' : "col-" + colWidth;
	  } else if (colSize === 'auto') {
	    return isXs ? 'col-auto' : "col-" + colWidth + "-auto";
	  }
	
	  return isXs ? "col-" + colSize : "col-" + colWidth + "-" + colSize;
	};
	
	var Label = function Label(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      hidden = props.hidden,
	      widths = props.widths,
	      Tag = props.tag,
	      check = props.check,
	      size = props.size,
	      htmlFor = props.for,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
	  var colClasses = [];
	  widths.forEach(function (colWidth, i) {
	    var columnProp = props[colWidth];
	    delete attributes[colWidth];
	
	    if (!columnProp && columnProp !== '') {
	      return;
	    }
	
	    var isXs = !i;
	    var colClass;
	
	    if ((0, _utils.isObject)(columnProp)) {
	      var _classNames;
	
	      var colSizeInterfix = isXs ? '-' : "-" + colWidth + "-";
	      colClass = getColumnSizeClass(isXs, colWidth, columnProp.size);
	      colClasses.push((0, _utils.mapToCssModules)((0, _classnames.default)((_classNames = {}, _classNames[colClass] = columnProp.size || columnProp.size === '', _classNames["order" + colSizeInterfix + columnProp.order] = columnProp.order || columnProp.order === 0, _classNames["offset" + colSizeInterfix + columnProp.offset] = columnProp.offset || columnProp.offset === 0, _classNames))), cssModule);
	    } else {
	      colClass = getColumnSizeClass(isXs, colWidth, columnProp);
	      colClasses.push(colClass);
	    }
	  });
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, hidden ? 'sr-only' : false, check ? 'form-check-label' : false, size ? "col-form-label-" + size : false, colClasses, colClasses.length ? 'col-form-label' : false), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({
	    htmlFor: htmlFor
	  }, attributes, {
	    className: classes
	  }));
	};
	
	Label.propTypes = propTypes;
	Label.defaultProps = defaultProps;
	var _default = Label;
	exports.default = _default;

/***/ },
/* 2366 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(14);
	
	var _excluded = ["className", "cssModule", "tag", "type"];
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  type: _propTypes.default.string
	};
	var defaultProps = {
	  tag: 'ul'
	};
	var List = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      type = props.type,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, type ? "list-" + type : false), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes,
	    ref: ref
	  }));
	});
	List.propTypes = propTypes;
	List.defaultProps = defaultProps;
	var _default = List;
	exports.default = _default;

/***/ },
/* 2367 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(14);
	
	var _excluded = ["className", "cssModule", "tag", "flush", "horizontal"];
	var propTypes = {
	  tag: _utils.tagPropType,
	  flush: _propTypes.default.bool,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  horizontal: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string])
	};
	var defaultProps = {
	  tag: 'ul',
	  horizontal: false
	};
	
	var getHorizontalClass = function getHorizontalClass(horizontal) {
	  if (horizontal === false) {
	    return false;
	  } else if (horizontal === true || horizontal === "xs") {
	    return "list-group-horizontal";
	  }
	
	  return "list-group-horizontal-" + horizontal;
	};
	
	var ListGroup = function ListGroup(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      flush = props.flush,
	      horizontal = props.horizontal,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'list-group', // list-group-horizontal cannot currently be mixed with list-group-flush
	  // we only try to apply horizontal classes if flush is false
	  flush ? 'list-group-flush' : getHorizontalClass(horizontal)), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	ListGroup.propTypes = propTypes;
	ListGroup.defaultProps = defaultProps;
	var _default = ListGroup;
	exports.default = _default;

/***/ },
/* 2368 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(14);
	
	var _excluded = ["className", "cssModule", "tag", "active", "disabled", "action", "color"];
	var propTypes = {
	  tag: _utils.tagPropType,
	  active: _propTypes.default.bool,
	  disabled: _propTypes.default.bool,
	  color: _propTypes.default.string,
	  action: _propTypes.default.bool,
	  className: _propTypes.default.any,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'li'
	};
	
	var handleDisabledOnClick = function handleDisabledOnClick(e) {
	  e.preventDefault();
	};
	
	var ListGroupItem = function ListGroupItem(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      active = props.active,
	      disabled = props.disabled,
	      action = props.action,
	      color = props.color,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, active ? 'active' : false, disabled ? 'disabled' : false, action ? 'list-group-item-action' : false, color ? "list-group-item-" + color : false, 'list-group-item'), cssModule); // Prevent click event when disabled.
	
	  if (disabled) {
	    attributes.onClick = handleDisabledOnClick;
	  }
	
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	ListGroupItem.propTypes = propTypes;
	ListGroupItem.defaultProps = defaultProps;
	var _default = ListGroupItem;
	exports.default = _default;

/***/ },
/* 2369 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(14);
	
	var _excluded = ["className", "cssModule", "tag"];
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.any,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'h5'
	};
	
	var ListGroupItemHeading = function ListGroupItemHeading(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'list-group-item-heading'), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	ListGroupItemHeading.propTypes = propTypes;
	ListGroupItemHeading.defaultProps = defaultProps;
	var _default = ListGroupItemHeading;
	exports.default = _default;

/***/ },
/* 2370 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(14);
	
	var _excluded = ["className", "cssModule", "tag"];
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.any,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'p'
	};
	
	var ListGroupItemText = function ListGroupItemText(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'list-group-item-text'), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	ListGroupItemText.propTypes = propTypes;
	ListGroupItemText.defaultProps = defaultProps;
	var _default = ListGroupItemText;
	exports.default = _default;

/***/ },
/* 2371 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(14);
	
	var _excluded = ["className", "cssModule", "tag"];
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'li'
	};
	var ListInlineItem = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'list-inline-item'), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes,
	    ref: ref
	  }));
	});
	ListInlineItem.propTypes = propTypes;
	ListInlineItem.defaultProps = defaultProps;
	var _default = ListInlineItem;
	exports.default = _default;

/***/ },
/* 2372 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(14);
	
	var _excluded = ["body", "bottom", "className", "cssModule", "heading", "left", "list", "middle", "object", "right", "tag", "top"];
	var propTypes = {
	  body: _propTypes.default.bool,
	  bottom: _propTypes.default.bool,
	  children: _propTypes.default.node,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  heading: _propTypes.default.bool,
	  left: _propTypes.default.bool,
	  list: _propTypes.default.bool,
	  middle: _propTypes.default.bool,
	  object: _propTypes.default.bool,
	  right: _propTypes.default.bool,
	  tag: _utils.tagPropType,
	  top: _propTypes.default.bool
	};
	
	var Media = function Media(props) {
	  var body = props.body,
	      bottom = props.bottom,
	      className = props.className,
	      cssModule = props.cssModule,
	      heading = props.heading,
	      left = props.left,
	      list = props.list,
	      middle = props.middle,
	      object = props.object,
	      right = props.right,
	      tag = props.tag,
	      top = props.top,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
	  var defaultTag;
	
	  if (heading) {
	    defaultTag = 'h4';
	  } else if (attributes.href) {
	    defaultTag = 'a';
	  } else if (attributes.src || object) {
	    defaultTag = 'img';
	  } else if (list) {
	    defaultTag = 'ul';
	  } else {
	    defaultTag = 'div';
	  }
	
	  var Tag = tag || defaultTag;
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, {
	    'media-body': body,
	    'media-heading': heading,
	    'media-left': left,
	    'media-right': right,
	    'media-top': top,
	    'media-bottom': bottom,
	    'media-middle': middle,
	    'media-object': object,
	    'media-list': list,
	    media: !body && !heading && !left && !right && !top && !bottom && !middle && !object && !list
	  }), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	Media.propTypes = propTypes;
	var _default = Media;
	exports.default = _default;

/***/ },
/* 2373 */
[2733, 2390, 229, 14],
/* 2374 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(14);
	
	var _excluded = ["className", "cssModule", "tag"];
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var ModalBody = function ModalBody(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'modal-body'), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	ModalBody.propTypes = propTypes;
	ModalBody.defaultProps = defaultProps;
	var _default = ModalBody;
	exports.default = _default;

/***/ },
/* 2375 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(14);
	
	var _excluded = ["className", "cssModule", "tag"];
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var ModalFooter = function ModalFooter(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'modal-footer'), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	ModalFooter.propTypes = propTypes;
	ModalFooter.defaultProps = defaultProps;
	var _default = ModalFooter;
	exports.default = _default;

/***/ },
/* 2376 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(14);
	
	var _excluded = ["className", "cssModule", "children", "toggle", "tag", "wrapTag", "closeAriaLabel", "charCode", "close"];
	var propTypes = {
	  tag: _utils.tagPropType,
	  wrapTag: _utils.tagPropType,
	  toggle: _propTypes.default.func,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  children: _propTypes.default.node,
	  closeAriaLabel: _propTypes.default.string,
	  charCode: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  close: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'h5',
	  wrapTag: 'div',
	  closeAriaLabel: 'Close',
	  charCode: 215
	};
	
	var ModalHeader = function ModalHeader(props) {
	  var closeButton;
	  var className = props.className,
	      cssModule = props.cssModule,
	      children = props.children,
	      toggle = props.toggle,
	      Tag = props.tag,
	      WrapTag = props.wrapTag,
	      closeAriaLabel = props.closeAriaLabel,
	      charCode = props.charCode,
	      close = props.close,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'modal-header'), cssModule);
	
	  if (!close && toggle) {
	    var closeIcon = typeof charCode === 'number' ? String.fromCharCode(charCode) : charCode;
	    closeButton = /*#__PURE__*/_react.default.createElement("button", {
	      type: "button",
	      onClick: toggle,
	      className: (0, _utils.mapToCssModules)('close', cssModule),
	      "aria-label": closeAriaLabel
	    }, /*#__PURE__*/_react.default.createElement("span", {
	      "aria-hidden": "true"
	    }, closeIcon));
	  }
	
	  return /*#__PURE__*/_react.default.createElement(WrapTag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }), /*#__PURE__*/_react.default.createElement(Tag, {
	    className: (0, _utils.mapToCssModules)('modal-title', cssModule)
	  }, children), close || closeButton);
	};
	
	ModalHeader.propTypes = propTypes;
	ModalHeader.defaultProps = defaultProps;
	var _default = ModalHeader;
	exports.default = _default;

/***/ },
/* 2377 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(14);
	
	var _excluded = ["className", "cssModule", "tabs", "pills", "vertical", "horizontal", "justified", "fill", "navbar", "card", "tag"];
	var propTypes = {
	  tabs: _propTypes.default.bool,
	  pills: _propTypes.default.bool,
	  vertical: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
	  horizontal: _propTypes.default.string,
	  justified: _propTypes.default.bool,
	  fill: _propTypes.default.bool,
	  navbar: _propTypes.default.bool,
	  card: _propTypes.default.bool,
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'ul',
	  vertical: false
	};
	
	var getVerticalClass = function getVerticalClass(vertical) {
	  if (vertical === false) {
	    return false;
	  } else if (vertical === true || vertical === 'xs') {
	    return 'flex-column';
	  }
	
	  return "flex-" + vertical + "-column";
	};
	
	var Nav = function Nav(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      tabs = props.tabs,
	      pills = props.pills,
	      vertical = props.vertical,
	      horizontal = props.horizontal,
	      justified = props.justified,
	      fill = props.fill,
	      navbar = props.navbar,
	      card = props.card,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, navbar ? 'navbar-nav' : 'nav', horizontal ? "justify-content-" + horizontal : false, getVerticalClass(vertical), {
	    'nav-tabs': tabs,
	    'card-header-tabs': card && tabs,
	    'nav-pills': pills,
	    'card-header-pills': card && pills,
	    'nav-justified': justified,
	    'nav-fill': fill
	  }), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	Nav.propTypes = propTypes;
	Nav.defaultProps = defaultProps;
	var _default = Nav;
	exports.default = _default;

/***/ },
/* 2378 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(14);
	
	var _excluded = ["className", "cssModule", "active", "tag"];
	var propTypes = {
	  tag: _utils.tagPropType,
	  active: _propTypes.default.bool,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'li'
	};
	
	var NavItem = function NavItem(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      active = props.active,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'nav-item', active ? 'active' : false), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	NavItem.propTypes = propTypes;
	NavItem.defaultProps = defaultProps;
	var _default = NavItem;
	exports.default = _default;

/***/ },
/* 2379 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(20));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(14);
	
	var _excluded = ["className", "cssModule", "active", "tag", "innerRef"];
	var propTypes = {
	  tag: _utils.tagPropType,
	  innerRef: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func, _propTypes.default.string]),
	  disabled: _propTypes.default.bool,
	  active: _propTypes.default.bool,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  onClick: _propTypes.default.func,
	  href: _propTypes.default.any
	};
	var defaultProps = {
	  tag: 'a'
	};
	
	var NavLink = /*#__PURE__*/function (_React$Component) {
	  (0, _inheritsLoose2.default)(NavLink, _React$Component);
	
	  function NavLink(props) {
	    var _this;
	
	    _this = _React$Component.call(this, props) || this;
	    _this.onClick = _this.onClick.bind((0, _assertThisInitialized2.default)(_this));
	    return _this;
	  }
	
	  var _proto = NavLink.prototype;
	
	  _proto.onClick = function onClick(e) {
	    if (this.props.disabled) {
	      e.preventDefault();
	      return;
	    }
	
	    if (this.props.href === '#') {
	      e.preventDefault();
	    }
	
	    if (this.props.onClick) {
	      this.props.onClick(e);
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        className = _this$props.className,
	        cssModule = _this$props.cssModule,
	        active = _this$props.active,
	        Tag = _this$props.tag,
	        innerRef = _this$props.innerRef,
	        attributes = (0, _objectWithoutPropertiesLoose2.default)(_this$props, _excluded);
	    var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'nav-link', {
	      disabled: attributes.disabled,
	      active: active
	    }), cssModule);
	    return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	      ref: innerRef,
	      onClick: this.onClick,
	      className: classes
	    }));
	  };
	
	  return NavLink;
	}(_react.default.Component);
	
	NavLink.propTypes = propTypes;
	NavLink.defaultProps = defaultProps;
	var _default = NavLink;
	exports.default = _default;

/***/ },
/* 2380 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(14);
	
	var _excluded = ["expand", "className", "cssModule", "light", "dark", "fixed", "sticky", "color", "tag"];
	var propTypes = {
	  light: _propTypes.default.bool,
	  dark: _propTypes.default.bool,
	  full: _propTypes.default.bool,
	  fixed: _propTypes.default.string,
	  sticky: _propTypes.default.string,
	  color: _propTypes.default.string,
	  role: _propTypes.default.string,
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  expand: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string])
	};
	var defaultProps = {
	  tag: 'nav',
	  expand: false
	};
	
	var getExpandClass = function getExpandClass(expand) {
	  if (expand === false) {
	    return false;
	  } else if (expand === true || expand === 'xs') {
	    return 'navbar-expand';
	  }
	
	  return "navbar-expand-" + expand;
	};
	
	var Navbar = function Navbar(props) {
	  var _classNames;
	
	  var expand = props.expand,
	      className = props.className,
	      cssModule = props.cssModule,
	      light = props.light,
	      dark = props.dark,
	      fixed = props.fixed,
	      sticky = props.sticky,
	      color = props.color,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'navbar', getExpandClass(expand), (_classNames = {
	    'navbar-light': light,
	    'navbar-dark': dark
	  }, _classNames["bg-" + color] = color, _classNames["fixed-" + fixed] = fixed, _classNames["sticky-" + sticky] = sticky, _classNames)), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	Navbar.propTypes = propTypes;
	Navbar.defaultProps = defaultProps;
	var _default = Navbar;
	exports.default = _default;

/***/ },
/* 2381 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(14);
	
	var _excluded = ["className", "cssModule", "tag"];
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'a'
	};
	
	var NavbarBrand = function NavbarBrand(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'navbar-brand'), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	NavbarBrand.propTypes = propTypes;
	NavbarBrand.defaultProps = defaultProps;
	var _default = NavbarBrand;
	exports.default = _default;

/***/ },
/* 2382 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(14);
	
	var _excluded = ["className", "cssModule", "active", "tag"];
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'span'
	};
	
	var NavbarText = function NavbarText(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      active = props.active,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'navbar-text'), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	NavbarText.propTypes = propTypes;
	NavbarText.defaultProps = defaultProps;
	var _default = NavbarText;
	exports.default = _default;

/***/ },
/* 2383 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(14);
	
	var _excluded = ["className", "cssModule", "children", "tag"];
	var propTypes = {
	  tag: _utils.tagPropType,
	  type: _propTypes.default.string,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  children: _propTypes.default.node
	};
	var defaultProps = {
	  tag: 'button',
	  type: 'button'
	};
	
	var NavbarToggler = function NavbarToggler(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      children = props.children,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'navbar-toggler'), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({
	    "aria-label": "Toggle navigation"
	  }, attributes, {
	    className: classes
	  }), children || /*#__PURE__*/_react.default.createElement("span", {
	    className: (0, _utils.mapToCssModules)('navbar-toggler-icon', cssModule)
	  }));
	};
	
	NavbarToggler.propTypes = propTypes;
	NavbarToggler.defaultProps = defaultProps;
	var _default = NavbarToggler;
	exports.default = _default;

/***/ },
/* 2384 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(14);
	
	var _excluded = ["className", "listClassName", "cssModule", "size", "tag", "listTag", "aria-label"];
	var propTypes = {
	  children: _propTypes.default.node,
	  className: _propTypes.default.string,
	  listClassName: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  size: _propTypes.default.string,
	  tag: _utils.tagPropType,
	  listTag: _utils.tagPropType,
	  'aria-label': _propTypes.default.string
	};
	var defaultProps = {
	  tag: 'nav',
	  listTag: 'ul',
	  'aria-label': 'pagination'
	};
	
	var Pagination = function Pagination(props) {
	  var _classNames;
	
	  var className = props.className,
	      listClassName = props.listClassName,
	      cssModule = props.cssModule,
	      size = props.size,
	      Tag = props.tag,
	      ListTag = props.listTag,
	      label = props['aria-label'],
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className), cssModule);
	  var listClasses = (0, _utils.mapToCssModules)((0, _classnames.default)(listClassName, 'pagination', (_classNames = {}, _classNames["pagination-" + size] = !!size, _classNames)), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, {
	    className: classes,
	    "aria-label": label
	  }, /*#__PURE__*/_react.default.createElement(ListTag, (0, _extends2.default)({}, attributes, {
	    className: listClasses
	  })));
	};
	
	Pagination.propTypes = propTypes;
	Pagination.defaultProps = defaultProps;
	var _default = Pagination;
	exports.default = _default;

/***/ },
/* 2385 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(14);
	
	var _excluded = ["active", "className", "cssModule", "disabled", "tag"];
	var propTypes = {
	  active: _propTypes.default.bool,
	  children: _propTypes.default.node,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  disabled: _propTypes.default.bool,
	  tag: _utils.tagPropType
	};
	var defaultProps = {
	  tag: 'li'
	};
	
	var PaginationItem = function PaginationItem(props) {
	  var active = props.active,
	      className = props.className,
	      cssModule = props.cssModule,
	      disabled = props.disabled,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'page-item', {
	    active: active,
	    disabled: disabled
	  }), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	PaginationItem.propTypes = propTypes;
	PaginationItem.defaultProps = defaultProps;
	var _default = PaginationItem;
	exports.default = _default;

/***/ },
/* 2386 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(14);
	
	var _excluded = ["className", "cssModule", "next", "previous", "first", "last", "tag"];
	var propTypes = {
	  'aria-label': _propTypes.default.string,
	  children: _propTypes.default.node,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  next: _propTypes.default.bool,
	  previous: _propTypes.default.bool,
	  first: _propTypes.default.bool,
	  last: _propTypes.default.bool,
	  tag: _utils.tagPropType
	};
	var defaultProps = {
	  tag: 'a'
	};
	
	var PaginationLink = function PaginationLink(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      next = props.next,
	      previous = props.previous,
	      first = props.first,
	      last = props.last,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'page-link'), cssModule);
	  var defaultAriaLabel;
	
	  if (previous) {
	    defaultAriaLabel = 'Previous';
	  } else if (next) {
	    defaultAriaLabel = 'Next';
	  } else if (first) {
	    defaultAriaLabel = 'First';
	  } else if (last) {
	    defaultAriaLabel = 'Last';
	  }
	
	  var ariaLabel = props['aria-label'] || defaultAriaLabel;
	  var defaultCaret;
	
	  if (previous) {
	    defaultCaret = "\u2039";
	  } else if (next) {
	    defaultCaret = "\u203A";
	  } else if (first) {
	    defaultCaret = "\xAB";
	  } else if (last) {
	    defaultCaret = "\xBB";
	  }
	
	  var children = props.children;
	
	  if (children && Array.isArray(children) && children.length === 0) {
	    children = null;
	  }
	
	  if (!attributes.href && Tag === 'a') {
	    Tag = 'button';
	  }
	
	  if (previous || next || first || last) {
	    children = [/*#__PURE__*/_react.default.createElement("span", {
	      "aria-hidden": "true",
	      key: "caret"
	    }, children || defaultCaret), /*#__PURE__*/_react.default.createElement("span", {
	      className: "sr-only",
	      key: "sr"
	    }, ariaLabel)];
	  }
	
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes,
	    "aria-label": ariaLabel
	  }), children);
	};
	
	PaginationLink.propTypes = propTypes;
	PaginationLink.defaultProps = defaultProps;
	var _default = PaginationLink;
	exports.default = _default;

/***/ },
/* 2387 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(14);
	
	var _excluded = ["className", "cssModule", "tag"];
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var PopoverBody = function PopoverBody(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'popover-body'), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	PopoverBody.propTypes = propTypes;
	PopoverBody.defaultProps = defaultProps;
	var _default = PopoverBody;
	exports.default = _default;

/***/ },
/* 2388 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(14);
	
	var _excluded = ["className", "cssModule", "tag"];
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'h3'
	};
	
	var PopoverHeader = function PopoverHeader(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'popover-header'), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	PopoverHeader.propTypes = propTypes;
	PopoverHeader.defaultProps = defaultProps;
	var _default = PopoverHeader;
	exports.default = _default;

/***/ },
/* 2389 */
[2751, 14],
/* 2390 */
[2752, 14],
/* 2391 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(27));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(14);
	
	var _excluded = ["children", "className", "barClassName", "cssModule", "value", "min", "max", "animated", "striped", "color", "bar", "multi", "tag", "style", "barStyle", "barAriaValueText", "barAriaLabelledBy"];
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	var propTypes = {
	  children: _propTypes.default.node,
	  bar: _propTypes.default.bool,
	  multi: _propTypes.default.bool,
	  tag: _utils.tagPropType,
	  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  min: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  max: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  animated: _propTypes.default.bool,
	  striped: _propTypes.default.bool,
	  color: _propTypes.default.string,
	  className: _propTypes.default.string,
	  barClassName: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  style: _propTypes.default.object,
	  barStyle: _propTypes.default.object,
	  barAriaValueText: _propTypes.default.string,
	  barAriaLabelledBy: _propTypes.default.string
	};
	var defaultProps = {
	  tag: 'div',
	  value: 0,
	  min: 0,
	  max: 100,
	  style: {},
	  barStyle: {}
	};
	
	var Progress = function Progress(props) {
	  var children = props.children,
	      className = props.className,
	      barClassName = props.barClassName,
	      cssModule = props.cssModule,
	      value = props.value,
	      min = props.min,
	      max = props.max,
	      animated = props.animated,
	      striped = props.striped,
	      color = props.color,
	      bar = props.bar,
	      multi = props.multi,
	      Tag = props.tag,
	      style = props.style,
	      barStyle = props.barStyle,
	      barAriaValueText = props.barAriaValueText,
	      barAriaLabelledBy = props.barAriaLabelledBy,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
	  var percent = (0, _utils.toNumber)(value) / (0, _utils.toNumber)(max) * 100;
	  var progressClasses = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'progress'), cssModule);
	  var progressBarClasses = (0, _utils.mapToCssModules)((0, _classnames.default)('progress-bar', bar ? className || barClassName : barClassName, animated ? 'progress-bar-animated' : null, color ? "bg-" + color : null, striped || animated ? 'progress-bar-striped' : null), cssModule);
	  var progressBarProps = {
	    className: progressBarClasses,
	    style: _objectSpread(_objectSpread(_objectSpread({}, bar ? style : {}), barStyle), {}, {
	      width: percent + "%"
	    }),
	    role: 'progressbar',
	    'aria-valuenow': value,
	    'aria-valuemin': min,
	    'aria-valuemax': max,
	    'aria-valuetext': barAriaValueText,
	    'aria-labelledby': barAriaLabelledBy,
	    children: children
	  };
	
	  if (bar) {
	    return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, progressBarProps));
	  }
	
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    style: style,
	    className: progressClasses
	  }), multi ? children : /*#__PURE__*/_react.default.createElement("div", progressBarProps));
	};
	
	Progress.propTypes = propTypes;
	Progress.defaultProps = defaultProps;
	var _default = Progress;
	exports.default = _default;

/***/ },
/* 2392 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(14);
	
	var _excluded = ["className", "cssModule", "noGutters", "tag", "form", "widths"];
	var rowColWidths = ['xs', 'sm', 'md', 'lg', 'xl'];
	
	var rowColsPropType = _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  noGutters: _propTypes.default.bool,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  form: _propTypes.default.bool,
	  xs: rowColsPropType,
	  sm: rowColsPropType,
	  md: rowColsPropType,
	  lg: rowColsPropType,
	  xl: rowColsPropType
	};
	var defaultProps = {
	  tag: 'div',
	  widths: rowColWidths
	};
	
	var Row = function Row(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      noGutters = props.noGutters,
	      Tag = props.tag,
	      form = props.form,
	      widths = props.widths,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
	  var colClasses = [];
	  widths.forEach(function (colWidth, i) {
	    var colSize = props[colWidth];
	    delete attributes[colWidth];
	
	    if (!colSize) {
	      return;
	    }
	
	    var isXs = !i;
	    colClasses.push(isXs ? "row-cols-" + colSize : "row-cols-" + colWidth + "-" + colSize);
	  });
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, noGutters ? 'no-gutters' : null, form ? 'form-row' : 'row', colClasses), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	Row.propTypes = propTypes;
	Row.defaultProps = defaultProps;
	var _default = Row;
	exports.default = _default;

/***/ },
/* 2393 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(14);
	
	var _excluded = ["className", "cssModule", "type", "size", "color", "children", "tag"];
	var propTypes = {
	  tag: _utils.tagPropType,
	  type: _propTypes.default.string,
	  size: _propTypes.default.string,
	  color: _propTypes.default.string,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  children: _propTypes.default.string
	};
	var defaultProps = {
	  tag: 'div',
	  type: 'border',
	  children: 'Loading...'
	};
	
	var Spinner = function Spinner(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      type = props.type,
	      size = props.size,
	      color = props.color,
	      children = props.children,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, size ? "spinner-" + type + "-" + size : false, "spinner-" + type, color ? "text-" + color : false), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({
	    role: "status"
	  }, attributes, {
	    className: classes
	  }), children && /*#__PURE__*/_react.default.createElement("span", {
	    className: (0, _utils.mapToCssModules)('sr-only', cssModule)
	  }, children));
	};
	
	Spinner.propTypes = propTypes;
	Spinner.defaultProps = defaultProps;
	var _default = Spinner;
	exports.default = _default;

/***/ },
/* 2394 */
[2756, 974, 14],
/* 2395 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = TabPane;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _TabContext = __webpack_require__(974);
	
	var _utils = __webpack_require__(14);
	
	var _excluded = ["className", "cssModule", "tabId", "tag"];
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  tabId: _propTypes.default.any
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	function TabPane(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      tabId = props.tabId,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
	
	  var getClasses = function getClasses(activeTabId) {
	    return (0, _utils.mapToCssModules)((0, _classnames.default)('tab-pane', className, {
	      active: tabId === activeTabId
	    }), cssModule);
	  };
	
	  return /*#__PURE__*/_react.default.createElement(_TabContext.TabContext.Consumer, null, function (_ref) {
	    var activeTabId = _ref.activeTabId;
	    return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	      className: getClasses(activeTabId)
	    }));
	  });
	}
	
	TabPane.propTypes = propTypes;
	TabPane.defaultProps = defaultProps;

/***/ },
/* 2396 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(14);
	
	var _excluded = ["className", "cssModule", "size", "bordered", "borderless", "striped", "dark", "hover", "responsive", "tag", "responsiveTag", "innerRef"];
	var propTypes = {
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  size: _propTypes.default.string,
	  bordered: _propTypes.default.bool,
	  borderless: _propTypes.default.bool,
	  striped: _propTypes.default.bool,
	  dark: _propTypes.default.bool,
	  hover: _propTypes.default.bool,
	  responsive: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
	  tag: _utils.tagPropType,
	  responsiveTag: _utils.tagPropType,
	  innerRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.string, _propTypes.default.object])
	};
	var defaultProps = {
	  tag: 'table',
	  responsiveTag: 'div'
	};
	
	var Table = function Table(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      size = props.size,
	      bordered = props.bordered,
	      borderless = props.borderless,
	      striped = props.striped,
	      dark = props.dark,
	      hover = props.hover,
	      responsive = props.responsive,
	      Tag = props.tag,
	      ResponsiveTag = props.responsiveTag,
	      innerRef = props.innerRef,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'table', size ? 'table-' + size : false, bordered ? 'table-bordered' : false, borderless ? 'table-borderless' : false, striped ? 'table-striped' : false, dark ? 'table-dark' : false, hover ? 'table-hover' : false), cssModule);
	
	  var table = /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    ref: innerRef,
	    className: classes
	  }));
	
	  if (responsive) {
	    var responsiveClassName = (0, _utils.mapToCssModules)(responsive === true ? 'table-responsive' : "table-responsive-" + responsive, cssModule);
	    return /*#__PURE__*/_react.default.createElement(ResponsiveTag, {
	      className: responsiveClassName
	    }, table);
	  }
	
	  return table;
	};
	
	Table.propTypes = propTypes;
	Table.defaultProps = defaultProps;
	var _default = Table;
	exports.default = _default;

/***/ },
/* 2397 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(27));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(14);
	
	var _Fade = _interopRequireDefault(__webpack_require__(229));
	
	var _excluded = ["className", "cssModule", "tag", "isOpen", "children", "transition", "fade", "innerRef"];
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	var propTypes = {
	  children: _propTypes.default.node,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  fade: _propTypes.default.bool,
	  isOpen: _propTypes.default.bool,
	  tag: _utils.tagPropType,
	  transition: _propTypes.default.shape(_Fade.default.propTypes),
	  innerRef: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string, _propTypes.default.func])
	};
	var defaultProps = {
	  isOpen: true,
	  tag: 'div',
	  fade: true,
	  transition: _objectSpread(_objectSpread({}, _Fade.default.defaultProps), {}, {
	    unmountOnExit: true
	  })
	};
	
	function Toast(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      isOpen = props.isOpen,
	      children = props.children,
	      transition = props.transition,
	      fade = props.fade,
	      innerRef = props.innerRef,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'toast'), cssModule);
	
	  var toastTransition = _objectSpread(_objectSpread(_objectSpread({}, _Fade.default.defaultProps), transition), {}, {
	    baseClass: fade ? transition.baseClass : '',
	    timeout: fade ? transition.timeout : 0
	  });
	
	  return /*#__PURE__*/_react.default.createElement(_Fade.default, (0, _extends2.default)({}, attributes, toastTransition, {
	    tag: Tag,
	    className: classes,
	    in: isOpen,
	    role: "alert",
	    innerRef: innerRef
	  }), children);
	}
	
	Toast.propTypes = propTypes;
	Toast.defaultProps = defaultProps;
	var _default = Toast;
	exports.default = _default;

/***/ },
/* 2398 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(14);
	
	var _excluded = ["className", "cssModule", "innerRef", "tag"];
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  innerRef: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string, _propTypes.default.func])
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var ToastBody = function ToastBody(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      innerRef = props.innerRef,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'toast-body'), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes,
	    ref: innerRef
	  }));
	};
	
	ToastBody.propTypes = propTypes;
	ToastBody.defaultProps = defaultProps;
	var _default = ToastBody;
	exports.default = _default;

/***/ },
/* 2399 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(14);
	
	var _excluded = ["className", "cssModule", "children", "toggle", "tag", "wrapTag", "closeAriaLabel", "charCode", "close", "tagClassName", "icon"];
	var propTypes = {
	  tag: _utils.tagPropType,
	  icon: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
	  wrapTag: _utils.tagPropType,
	  toggle: _propTypes.default.func,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  children: _propTypes.default.node,
	  closeAriaLabel: _propTypes.default.string,
	  charCode: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  close: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'strong',
	  wrapTag: 'div',
	  tagClassName: 'mr-auto',
	  closeAriaLabel: 'Close',
	  charCode: 215
	};
	
	var ToastHeader = function ToastHeader(props) {
	  var closeButton;
	  var icon;
	  var className = props.className,
	      cssModule = props.cssModule,
	      children = props.children,
	      toggle = props.toggle,
	      Tag = props.tag,
	      WrapTag = props.wrapTag,
	      closeAriaLabel = props.closeAriaLabel,
	      charCode = props.charCode,
	      close = props.close,
	      tagClassName = props.tagClassName,
	      iconProp = props.icon,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'toast-header'), cssModule);
	
	  if (!close && toggle) {
	    var closeIcon = typeof charCode === 'number' ? String.fromCharCode(charCode) : charCode;
	    closeButton = /*#__PURE__*/_react.default.createElement("button", {
	      type: "button",
	      onClick: toggle,
	      className: (0, _utils.mapToCssModules)('close', cssModule),
	      "aria-label": closeAriaLabel
	    }, /*#__PURE__*/_react.default.createElement("span", {
	      "aria-hidden": "true"
	    }, closeIcon));
	  }
	
	  if (typeof iconProp === "string") {
	    icon = /*#__PURE__*/_react.default.createElement("svg", {
	      className: (0, _utils.mapToCssModules)("rounded text-" + iconProp),
	      width: "20",
	      height: "20",
	      xmlns: "http://www.w3.org/2000/svg",
	      preserveAspectRatio: "xMidYMid slice",
	      focusable: "false",
	      role: "img"
	    }, /*#__PURE__*/_react.default.createElement("rect", {
	      fill: "currentColor",
	      width: "100%",
	      height: "100%"
	    }));
	  } else if (iconProp) {
	    icon = iconProp;
	  }
	
	  return /*#__PURE__*/_react.default.createElement(WrapTag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }), icon, /*#__PURE__*/_react.default.createElement(Tag, {
	    className: (0, _utils.mapToCssModules)((0, _classnames.default)(tagClassName, {
	      "ml-2": icon != null
	    }), cssModule)
	  }, children), close || closeButton);
	};
	
	ToastHeader.propTypes = propTypes;
	ToastHeader.defaultProps = defaultProps;
	var _default = ToastHeader;
	exports.default = _default;

/***/ },
/* 2400 */
[2764, 963],
/* 2401 */
[2765, 964, 14],
/* 2402 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(20));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _Carousel = _interopRequireDefault(__webpack_require__(965));
	
	var _CarouselItem = _interopRequireDefault(__webpack_require__(471));
	
	var _CarouselControl = _interopRequireDefault(__webpack_require__(967));
	
	var _CarouselIndicators = _interopRequireDefault(__webpack_require__(968));
	
	var _CarouselCaption = _interopRequireDefault(__webpack_require__(966));
	
	var _excluded = ["defaultActiveIndex", "autoPlay", "indicators", "controls", "items", "goToIndex"];
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var propTypes = {
	  items: _propTypes.default.array.isRequired,
	  indicators: _propTypes.default.bool,
	  controls: _propTypes.default.bool,
	  autoPlay: _propTypes.default.bool,
	  defaultActiveIndex: _propTypes.default.number,
	  activeIndex: _propTypes.default.number,
	  next: _propTypes.default.func,
	  previous: _propTypes.default.func,
	  goToIndex: _propTypes.default.func
	};
	
	var UncontrolledCarousel = /*#__PURE__*/function (_Component) {
	  (0, _inheritsLoose2.default)(UncontrolledCarousel, _Component);
	
	  function UncontrolledCarousel(props) {
	    var _this;
	
	    _this = _Component.call(this, props) || this;
	    _this.animating = false;
	    _this.state = {
	      activeIndex: props.defaultActiveIndex || 0
	    };
	    _this.next = _this.next.bind((0, _assertThisInitialized2.default)(_this));
	    _this.previous = _this.previous.bind((0, _assertThisInitialized2.default)(_this));
	    _this.goToIndex = _this.goToIndex.bind((0, _assertThisInitialized2.default)(_this));
	    _this.onExiting = _this.onExiting.bind((0, _assertThisInitialized2.default)(_this));
	    _this.onExited = _this.onExited.bind((0, _assertThisInitialized2.default)(_this));
	    return _this;
	  }
	
	  var _proto = UncontrolledCarousel.prototype;
	
	  _proto.onExiting = function onExiting() {
	    this.animating = true;
	  };
	
	  _proto.onExited = function onExited() {
	    this.animating = false;
	  };
	
	  _proto.next = function next() {
	    if (this.animating) return;
	    var nextIndex = this.state.activeIndex === this.props.items.length - 1 ? 0 : this.state.activeIndex + 1;
	    this.setState({
	      activeIndex: nextIndex
	    });
	  };
	
	  _proto.previous = function previous() {
	    if (this.animating) return;
	    var nextIndex = this.state.activeIndex === 0 ? this.props.items.length - 1 : this.state.activeIndex - 1;
	    this.setState({
	      activeIndex: nextIndex
	    });
	  };
	
	  _proto.goToIndex = function goToIndex(newIndex) {
	    if (this.animating) return;
	    this.setState({
	      activeIndex: newIndex
	    });
	  };
	
	  _proto.render = function render() {
	    var _this2 = this;
	
	    var _this$props = this.props,
	        defaultActiveIndex = _this$props.defaultActiveIndex,
	        autoPlay = _this$props.autoPlay,
	        indicators = _this$props.indicators,
	        controls = _this$props.controls,
	        items = _this$props.items,
	        goToIndex = _this$props.goToIndex,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, _excluded);
	    var activeIndex = this.state.activeIndex;
	    var slides = items.map(function (item) {
	      var key = item.key || item.src;
	      return /*#__PURE__*/_react.default.createElement(_CarouselItem.default, {
	        onExiting: _this2.onExiting,
	        onExited: _this2.onExited,
	        key: key
	      }, /*#__PURE__*/_react.default.createElement("img", {
	        className: "d-block w-100",
	        src: item.src,
	        alt: item.altText
	      }), /*#__PURE__*/_react.default.createElement(_CarouselCaption.default, {
	        captionText: item.caption,
	        captionHeader: item.header || item.caption
	      }));
	    });
	    return /*#__PURE__*/_react.default.createElement(_Carousel.default, (0, _extends2.default)({
	      activeIndex: activeIndex,
	      next: this.next,
	      previous: this.previous,
	      ride: autoPlay ? 'carousel' : undefined
	    }, props), indicators && /*#__PURE__*/_react.default.createElement(_CarouselIndicators.default, {
	      items: items,
	      activeIndex: props.activeIndex || activeIndex,
	      onClickHandler: goToIndex || this.goToIndex
	    }), slides, controls && /*#__PURE__*/_react.default.createElement(_CarouselControl.default, {
	      direction: "prev",
	      directionText: "Previous",
	      onClickHandler: props.previous || this.previous
	    }), controls && /*#__PURE__*/_react.default.createElement(_CarouselControl.default, {
	      direction: "next",
	      directionText: "Next",
	      onClickHandler: props.next || this.next
	    }));
	  };
	
	  return UncontrolledCarousel;
	}(_react.Component);
	
	UncontrolledCarousel.propTypes = propTypes;
	UncontrolledCarousel.defaultProps = {
	  controls: true,
	  indicators: true,
	  autoPlay: true
	};
	var _default = UncontrolledCarousel;
	exports.default = _default;

/***/ },
/* 2403 */
[2767, 969, 14],
/* 2404 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(27));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(20));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _Dropdown = _interopRequireDefault(__webpack_require__(305));
	
	var _utils = __webpack_require__(14);
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	var omitKeys = ['defaultOpen'];
	
	var UncontrolledDropdown = /*#__PURE__*/function (_Component) {
	  (0, _inheritsLoose2.default)(UncontrolledDropdown, _Component);
	
	  function UncontrolledDropdown(props) {
	    var _this;
	
	    _this = _Component.call(this, props) || this;
	    _this.state = {
	      isOpen: props.defaultOpen || false
	    };
	    _this.toggle = _this.toggle.bind((0, _assertThisInitialized2.default)(_this));
	    return _this;
	  }
	
	  var _proto = UncontrolledDropdown.prototype;
	
	  _proto.toggle = function toggle(e) {
	    var _this2 = this;
	
	    var isOpen = !this.state.isOpen;
	    this.setState({
	      isOpen: isOpen
	    }, function () {
	      if (_this2.props.onToggle) {
	        _this2.props.onToggle(e, isOpen);
	      }
	    });
	  };
	
	  _proto.render = function render() {
	    return /*#__PURE__*/_react.default.createElement(_Dropdown.default, (0, _extends2.default)({
	      isOpen: this.state.isOpen,
	      toggle: this.toggle
	    }, (0, _utils.omit)(this.props, omitKeys)));
	  };
	
	  return UncontrolledDropdown;
	}(_react.Component);
	
	exports.default = UncontrolledDropdown;
	UncontrolledDropdown.propTypes = _objectSpread({
	  defaultOpen: _propTypes.default.bool,
	  onToggle: _propTypes.default.func
	}, _Dropdown.default.propTypes);

/***/ },
/* 2405 */
[2769, 972, 14],
/* 2406 */
[2770, 975, 14],
/* 2407 */
1526,
/* 2408 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(2));
	
	var _addClass = _interopRequireDefault(__webpack_require__(416));
	
	var _removeClass = _interopRequireDefault(__webpack_require__(417));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _Transition = _interopRequireDefault(__webpack_require__(977));
	
	var _PropTypes = __webpack_require__(980);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var addClass = function addClass(node, classes) {
	  return node && classes && classes.split(' ').forEach(function (c) {
	    return (0, _addClass.default)(node, c);
	  });
	};
	
	var removeClass = function removeClass(node, classes) {
	  return node && classes && classes.split(' ').forEach(function (c) {
	    return (0, _removeClass.default)(node, c);
	  });
	};
	/**
	 * A transition component inspired by the excellent
	 * [ng-animate](http://www.nganimate.org/) library, you should use it if you're
	 * using CSS transitions or animations. It's built upon the
	 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
	 * component, so it inherits all of its props.
	 *
	 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
	 * and `exit` states of the transition. The first class is applied and then a
	 * second `*-active` class in order to activate the CSSS transition. After the
	 * transition, matching `*-done` class names are applied to persist the
	 * transition state.
	 *
	 * ```jsx
	 * function App() {
	 *   const [inProp, setInProp] = useState(false);
	 *   return (
	 *     <div>
	 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
	 *         <div>
	 *           {"I'll receive my-node-* classes"}
	 *         </div>
	 *       </CSSTransition>
	 *       <button type="button" onClick={() => setInProp(true)}>
	 *         Click to Enter
	 *       </button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the `in` prop is set to `true`, the child component will first receive
	 * the class `example-enter`, then the `example-enter-active` will be added in
	 * the next tick. `CSSTransition` [forces a
	 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
	 * between before adding the `example-enter-active`. This is an important trick
	 * because it allows us to transition between `example-enter` and
	 * `example-enter-active` even though they were added immediately one after
	 * another. Most notably, this is what makes it possible for us to animate
	 * _appearance_.
	 *
	 * ```css
	 * .my-node-enter {
	 *   opacity: 0;
	 * }
	 * .my-node-enter-active {
	 *   opacity: 1;
	 *   transition: opacity 200ms;
	 * }
	 * .my-node-exit {
	 *   opacity: 1;
	 * }
	 * .my-node-exit-active {
	 *   opacity: 0;
	 *   transition: opacity 200ms;
	 * }
	 * ```
	 *
	 * `*-active` classes represent which styles you want to animate **to**.
	 */
	
	
	var CSSTransition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(CSSTransition, _React$Component);
	
	  function CSSTransition() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	
	    _this.onEnter = function (node, appearing) {
	      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
	          className = _this$getClassNames.className;
	
	      _this.removeClasses(node, 'exit');
	
	      addClass(node, className);
	
	      if (_this.props.onEnter) {
	        _this.props.onEnter(node, appearing);
	      }
	    };
	
	    _this.onEntering = function (node, appearing) {
	      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
	          activeClassName = _this$getClassNames2.activeClassName;
	
	      _this.reflowAndAddClass(node, activeClassName);
	
	      if (_this.props.onEntering) {
	        _this.props.onEntering(node, appearing);
	      }
	    };
	
	    _this.onEntered = function (node, appearing) {
	      var appearClassName = _this.getClassNames('appear').doneClassName;
	
	      var enterClassName = _this.getClassNames('enter').doneClassName;
	
	      var doneClassName = appearing ? appearClassName + " " + enterClassName : enterClassName;
	
	      _this.removeClasses(node, appearing ? 'appear' : 'enter');
	
	      addClass(node, doneClassName);
	
	      if (_this.props.onEntered) {
	        _this.props.onEntered(node, appearing);
	      }
	    };
	
	    _this.onExit = function (node) {
	      var _this$getClassNames3 = _this.getClassNames('exit'),
	          className = _this$getClassNames3.className;
	
	      _this.removeClasses(node, 'appear');
	
	      _this.removeClasses(node, 'enter');
	
	      addClass(node, className);
	
	      if (_this.props.onExit) {
	        _this.props.onExit(node);
	      }
	    };
	
	    _this.onExiting = function (node) {
	      var _this$getClassNames4 = _this.getClassNames('exit'),
	          activeClassName = _this$getClassNames4.activeClassName;
	
	      _this.reflowAndAddClass(node, activeClassName);
	
	      if (_this.props.onExiting) {
	        _this.props.onExiting(node);
	      }
	    };
	
	    _this.onExited = function (node) {
	      var _this$getClassNames5 = _this.getClassNames('exit'),
	          doneClassName = _this$getClassNames5.doneClassName;
	
	      _this.removeClasses(node, 'exit');
	
	      addClass(node, doneClassName);
	
	      if (_this.props.onExited) {
	        _this.props.onExited(node);
	      }
	    };
	
	    _this.getClassNames = function (type) {
	      var classNames = _this.props.classNames;
	      var isStringClassNames = typeof classNames === 'string';
	      var prefix = isStringClassNames && classNames ? classNames + '-' : '';
	      var className = isStringClassNames ? prefix + type : classNames[type];
	      var activeClassName = isStringClassNames ? className + '-active' : classNames[type + 'Active'];
	      var doneClassName = isStringClassNames ? className + '-done' : classNames[type + 'Done'];
	      return {
	        className: className,
	        activeClassName: activeClassName,
	        doneClassName: doneClassName
	      };
	    };
	
	    return _this;
	  }
	
	  var _proto = CSSTransition.prototype;
	
	  _proto.removeClasses = function removeClasses(node, type) {
	    var _this$getClassNames6 = this.getClassNames(type),
	        className = _this$getClassNames6.className,
	        activeClassName = _this$getClassNames6.activeClassName,
	        doneClassName = _this$getClassNames6.doneClassName;
	
	    className && removeClass(node, className);
	    activeClassName && removeClass(node, activeClassName);
	    doneClassName && removeClass(node, doneClassName);
	  };
	
	  _proto.reflowAndAddClass = function reflowAndAddClass(node, className) {
	    // This is for to force a repaint,
	    // which is necessary in order to transition styles when adding a class name.
	    if (className) {
	      /* eslint-disable no-unused-expressions */
	      node && node.scrollTop;
	      /* eslint-enable no-unused-expressions */
	
	      addClass(node, className);
	    }
	  };
	
	  _proto.render = function render() {
	    var props = _extends({}, this.props);
	
	    delete props.classNames;
	    return _react.default.createElement(_Transition.default, _extends({}, props, {
	      onEnter: this.onEnter,
	      onEntered: this.onEntered,
	      onEntering: this.onEntering,
	      onExit: this.onExit,
	      onExiting: this.onExiting,
	      onExited: this.onExited
	    }));
	  };
	
	  return CSSTransition;
	}(_react.default.Component);
	
	CSSTransition.defaultProps = {
	  classNames: ''
	};
	CSSTransition.propTypes =  false ? _extends({}, _Transition.default.propTypes, {
	  /**
	   * The animation classNames applied to the component as it enters, exits or
	   * has finished the transition. A single name can be provided and it will be
	   * suffixed for each stage: e.g.
	   *
	   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`,
	   * `fade-enter-done`, `fade-exit`, `fade-exit-active`, `fade-exit-done`,
	   * `fade-appear`, `fade-appear-active`, and `fade-appear-done`.
	   *
	   * **Note**: `fade-appear-done` and `fade-enter-done` will _both_ be applied.
	   * This allows you to define different behavior for when appearing is done and
	   * when regular entering is done, using selectors like
	   * `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply an
	   * epic entrance animation when element first appears in the DOM using
	   * [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
	   * simply use `fade-enter-done` for defining both cases.
	   *
	   * Each individual classNames can also be specified independently like:
	   *
	   * ```js
	   * classNames={{
	   *  appear: 'my-appear',
	   *  appearActive: 'my-active-appear',
	   *  appearDone: 'my-done-appear',
	   *  enter: 'my-enter',
	   *  enterActive: 'my-active-enter',
	   *  enterDone: 'my-done-enter',
	   *  exit: 'my-exit',
	   *  exitActive: 'my-active-exit',
	   *  exitDone: 'my-done-exit',
	   * }}
	   * ```
	   *
	   * If you want to set these classes using CSS Modules:
	   *
	   * ```js
	   * import styles from './styles.css';
	   * ```
	   *
	   * you might want to use camelCase in your CSS file, that way could simply
	   * spread them instead of listing them one by one:
	   *
	   * ```js
	   * classNames={{ ...styles }}
	   * ```
	   *
	   * @type {string | {
	   *  appear?: string,
	   *  appearActive?: string,
	   *  appearDone?: string,
	   *  enter?: string,
	   *  enterActive?: string,
	   *  enterDone?: string,
	   *  exit?: string,
	   *  exitActive?: string,
	   *  exitDone?: string,
	   * }}
	   */
	  classNames: _PropTypes.classNamesShape,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
	   * applied.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEnter: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter-active' or
	   * 'appear-active' class is applied.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or
	   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntered: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' class is
	   * applied.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExit: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExiting: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' classes
	   * are **removed** and the `exit-done` class is added to the DOM node.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExited: PropTypes.func
	}) : {};
	var _default = CSSTransition;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 2409 */
[2773, 978],
/* 2410 */
2329,
/* 2411 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getTickValuesFixedDomain = exports.getTickValues = exports.getNiceTickValues = void 0;
	
	var _decimal = _interopRequireDefault(__webpack_require__(673));
	
	var _utils = __webpack_require__(981);
	
	var _arithmetic = _interopRequireDefault(__webpack_require__(2413));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	/**
	 * Calculate a interval of a minimum value and a maximum value
	 *
	 * @param  {Number} min       The minimum value
	 * @param  {Number} max       The maximum value
	 * @return {Array} An interval
	 */
	function getValidInterval(_ref) {
	  var _ref2 = _slicedToArray(_ref, 2),
	      min = _ref2[0],
	      max = _ref2[1];
	
	  var validMin = min,
	      validMax = max; // exchange
	
	  if (min > max) {
	    validMin = max;
	    validMax = min;
	  }
	
	  return [validMin, validMax];
	}
	/**
	 * Calculate the step which is easy to understand between ticks, like 10, 20, 25
	 *
	 * @param  {Decimal} roughStep        The rough step calculated by deviding the
	 * difference by the tickCount
	 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
	 * @param  {Integer} correctionFactor A correction factor
	 * @return {Decimal} The step which is easy to understand between two ticks
	 */
	
	
	function getFormatStep(roughStep, allowDecimals, correctionFactor) {
	  if (roughStep.lte(0)) {
	    return new _decimal.default(0);
	  }
	
	  var digitCount = _arithmetic.default.getDigitCount(roughStep.toNumber()); // The ratio between the rough step and the smallest number which has a bigger
	  // order of magnitudes than the rough step
	
	
	  var digitCountValue = new _decimal.default(10).pow(digitCount);
	  var stepRatio = roughStep.div(digitCountValue); // When an integer and a float multiplied, the accuracy of result may be wrong
	
	  var stepRatioScale = digitCount !== 1 ? 0.05 : 0.1;
	  var amendStepRatio = new _decimal.default(Math.ceil(stepRatio.div(stepRatioScale).toNumber())).add(correctionFactor).mul(stepRatioScale);
	  var formatStep = amendStepRatio.mul(digitCountValue);
	  return allowDecimals ? formatStep : new _decimal.default(Math.ceil(formatStep));
	}
	/**
	 * calculate the ticks when the minimum value equals to the maximum value
	 *
	 * @param  {Number}  value         The minimum valuue which is also the maximum value
	 * @param  {Integer} tickCount     The count of ticks
	 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
	 * @return {Array}                 ticks
	 */
	
	
	function getTickOfSingleValue(value, tickCount, allowDecimals) {
	  var step = 1; // calculate the middle value of ticks
	
	  var middle = new _decimal.default(value);
	
	  if (!middle.isint() && allowDecimals) {
	    var absVal = Math.abs(value);
	
	    if (absVal < 1) {
	      // The step should be a float number when the difference is smaller than 1
	      step = new _decimal.default(10).pow(_arithmetic.default.getDigitCount(value) - 1);
	      middle = new _decimal.default(Math.floor(middle.div(step).toNumber())).mul(step);
	    } else if (absVal > 1) {
	      // Return the maximum integer which is smaller than 'value' when 'value' is greater than 1
	      middle = new _decimal.default(Math.floor(value));
	    }
	  } else if (value === 0) {
	    middle = new _decimal.default(Math.floor((tickCount - 1) / 2));
	  } else if (!allowDecimals) {
	    middle = new _decimal.default(Math.floor(value));
	  }
	
	  var middleIndex = Math.floor((tickCount - 1) / 2);
	  var fn = (0, _utils.compose)((0, _utils.map)(function (n) {
	    return middle.add(new _decimal.default(n - middleIndex).mul(step)).toNumber();
	  }), _utils.range);
	  return fn(0, tickCount);
	}
	/**
	 * Calculate the step
	 *
	 * @param  {Number}  min              The minimum value of an interval
	 * @param  {Number}  max              The maximum value of an interval
	 * @param  {Integer} tickCount        The count of ticks
	 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
	 * @param  {Number}  correctionFactor A correction factor
	 * @return {Object}  The step, minimum value of ticks, maximum value of ticks
	 */
	
	
	function calculateStep(min, max, tickCount, allowDecimals) {
	  var correctionFactor = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
	
	  // dirty hack (for recharts' test)
	  if (!Number.isFinite((max - min) / (tickCount - 1))) {
	    return {
	      step: new _decimal.default(0),
	      tickMin: new _decimal.default(0),
	      tickMax: new _decimal.default(0)
	    };
	  } // The step which is easy to understand between two ticks
	
	
	  var step = getFormatStep(new _decimal.default(max).sub(min).div(tickCount - 1), allowDecimals, correctionFactor); // A medial value of ticks
	
	  var middle; // When 0 is inside the interval, 0 should be a tick
	
	  if (min <= 0 && max >= 0) {
	    middle = new _decimal.default(0);
	  } else {
	    // calculate the middle value
	    middle = new _decimal.default(min).add(max).div(2); // minus modulo value
	
	    middle = middle.sub(new _decimal.default(middle).mod(step));
	  }
	
	  var belowCount = Math.ceil(middle.sub(min).div(step).toNumber());
	  var upCount = Math.ceil(new _decimal.default(max).sub(middle).div(step).toNumber());
	  var scaleCount = belowCount + upCount + 1;
	
	  if (scaleCount > tickCount) {
	    // When more ticks need to cover the interval, step should be bigger.
	    return calculateStep(min, max, tickCount, allowDecimals, correctionFactor + 1);
	  }
	
	  if (scaleCount < tickCount) {
	    // When less ticks can cover the interval, we should add some additional ticks
	    upCount = max > 0 ? upCount + (tickCount - scaleCount) : upCount;
	    belowCount = max > 0 ? belowCount : belowCount + (tickCount - scaleCount);
	  }
	
	  return {
	    step: step,
	    tickMin: middle.sub(new _decimal.default(belowCount).mul(step)),
	    tickMax: middle.add(new _decimal.default(upCount).mul(step))
	  };
	}
	/**
	 * Calculate the ticks of an interval, the count of ticks will be guraranteed
	 *
	 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
	 * @param  {Integer} tickCount     The count of ticks
	 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
	 * @return {Array}   ticks
	 */
	
	
	function getNiceTickValuesFn(_ref3) {
	  var _ref4 = _slicedToArray(_ref3, 2),
	      min = _ref4[0],
	      max = _ref4[1];
	
	  var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
	  var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	  // More than two ticks should be return
	  var count = Math.max(tickCount, 2);
	
	  var _getValidInterval = getValidInterval([min, max]),
	      _getValidInterval2 = _slicedToArray(_getValidInterval, 2),
	      cormin = _getValidInterval2[0],
	      cormax = _getValidInterval2[1];
	
	  if (cormin === -Infinity || cormax === Infinity) {
	    var _values = cormax === Infinity ? [cormin].concat(_toConsumableArray((0, _utils.range)(0, tickCount - 1).map(function () {
	      return Infinity;
	    }))) : [].concat(_toConsumableArray((0, _utils.range)(0, tickCount - 1).map(function () {
	      return -Infinity;
	    })), [cormax]);
	
	    return min > max ? (0, _utils.reverse)(_values) : _values;
	  }
	
	  if (cormin === cormax) {
	    return getTickOfSingleValue(cormin, tickCount, allowDecimals);
	  } // Get the step between two ticks
	
	
	  var _calculateStep = calculateStep(cormin, cormax, count, allowDecimals),
	      step = _calculateStep.step,
	      tickMin = _calculateStep.tickMin,
	      tickMax = _calculateStep.tickMax;
	
	  var values = _arithmetic.default.rangeStep(tickMin, tickMax.add(new _decimal.default(0.1).mul(step)), step);
	
	  return min > max ? (0, _utils.reverse)(values) : values;
	}
	/**
	 * Calculate the ticks of an interval, the count of ticks won't be guraranteed
	 *
	 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
	 * @param  {Integer} tickCount     The count of ticks
	 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
	 * @return {Array}   ticks
	 */
	
	
	function getTickValuesFn(_ref5) {
	  var _ref6 = _slicedToArray(_ref5, 2),
	      min = _ref6[0],
	      max = _ref6[1];
	
	  var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
	  var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	  // More than two ticks should be return
	  var count = Math.max(tickCount, 2);
	
	  var _getValidInterval3 = getValidInterval([min, max]),
	      _getValidInterval4 = _slicedToArray(_getValidInterval3, 2),
	      cormin = _getValidInterval4[0],
	      cormax = _getValidInterval4[1];
	
	  if (cormin === -Infinity || cormax === Infinity) {
	    return [min, max];
	  }
	
	  if (cormin === cormax) {
	    return getTickOfSingleValue(cormin, tickCount, allowDecimals);
	  }
	
	  var step = getFormatStep(new _decimal.default(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
	  var fn = (0, _utils.compose)((0, _utils.map)(function (n) {
	    return new _decimal.default(cormin).add(new _decimal.default(n).mul(step)).toNumber();
	  }), _utils.range);
	  var values = fn(0, count).filter(function (entry) {
	    return entry >= cormin && entry <= cormax;
	  });
	  return min > max ? (0, _utils.reverse)(values) : values;
	}
	/**
	 * Calculate the ticks of an interval, the count of ticks won't be guraranteed,
	 * but the domain will be guaranteed
	 *
	 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
	 * @param  {Integer} tickCount     The count of ticks
	 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
	 * @return {Array}   ticks
	 */
	
	
	function getTickValuesFixedDomainFn(_ref7, tickCount) {
	  var _ref8 = _slicedToArray(_ref7, 2),
	      min = _ref8[0],
	      max = _ref8[1];
	
	  var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  // More than two ticks should be return
	  var _getValidInterval5 = getValidInterval([min, max]),
	      _getValidInterval6 = _slicedToArray(_getValidInterval5, 2),
	      cormin = _getValidInterval6[0],
	      cormax = _getValidInterval6[1];
	
	  if (cormin === -Infinity || cormax === Infinity) {
	    return [min, max];
	  }
	
	  if (cormin === cormax) {
	    return [cormin];
	  }
	
	  var count = Math.max(tickCount, 2);
	  var step = getFormatStep(new _decimal.default(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
	  var values = [].concat(_toConsumableArray(_arithmetic.default.rangeStep(new _decimal.default(cormin), new _decimal.default(cormax).sub(new _decimal.default(0.99).mul(step)), step)), [cormax]);
	  return min > max ? (0, _utils.reverse)(values) : values;
	}
	
	var getNiceTickValues = (0, _utils.memoize)(getNiceTickValuesFn);
	exports.getNiceTickValues = getNiceTickValues;
	var getTickValues = (0, _utils.memoize)(getTickValuesFn);
	exports.getTickValues = getTickValues;
	var getTickValuesFixedDomain = (0, _utils.memoize)(getTickValuesFixedDomainFn);
	exports.getTickValuesFixedDomain = getTickValuesFixedDomain;

/***/ },
/* 2412 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "getTickValues", {
	  enumerable: true,
	  get: function get() {
	    return _getNiceTickValues.getTickValues;
	  }
	});
	Object.defineProperty(exports, "getNiceTickValues", {
	  enumerable: true,
	  get: function get() {
	    return _getNiceTickValues.getNiceTickValues;
	  }
	});
	Object.defineProperty(exports, "getTickValuesFixedDomain", {
	  enumerable: true,
	  get: function get() {
	    return _getNiceTickValues.getTickValuesFixedDomain;
	  }
	});
	
	var _getNiceTickValues = __webpack_require__(2411);

/***/ },
/* 2413 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _decimal = _interopRequireDefault(__webpack_require__(673));
	
	var _utils = __webpack_require__(981);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @fileOverview 一些公用的运算方法
	 * @author xile611
	 * @date 2015-09-17
	 */
	
	/**
	 * 获取数值的位数
	 * 其中绝对值属于区间[0.1, 1)， 得到的值为0
	 * 绝对值属于区间[0.01, 0.1)，得到的位数为 -1
	 * 绝对值属于区间[0.001, 0.01)，得到的位数为 -2
	 *
	 * @param  {Number} value 数值
	 * @return {Integer} 位数
	 */
	function getDigitCount(value) {
	  var result;
	
	  if (value === 0) {
	    result = 1;
	  } else {
	    result = Math.floor(new _decimal.default(value).abs().log(10).toNumber()) + 1;
	  }
	
	  return result;
	}
	/**
	 * 按照固定的步长获取[start, end)这个区间的数据
	 * 并且需要处理js计算精度的问题
	 *
	 * @param  {Decimal} start 起点
	 * @param  {Decimal} end   终点，不包含该值
	 * @param  {Decimal} step  步长
	 * @return {Array}         若干数值
	 */
	
	
	function rangeStep(start, end, step) {
	  var num = new _decimal.default(start);
	  var i = 0;
	  var result = []; // magic number to prevent infinite loop
	
	  while (num.lt(end) && i < 100000) {
	    result.push(num.toNumber());
	    num = num.add(step);
	    i++;
	  }
	
	  return result;
	}
	/**
	 * 对数值进行线性插值
	 *
	 * @param  {Number} a  定义域的极点
	 * @param  {Number} b  定义域的极点
	 * @param  {Number} t  [0, 1]内的某个值
	 * @return {Number}    定义域内的某个值
	 */
	
	
	var interpolateNumber = (0, _utils.curry)(function (a, b, t) {
	  var newA = +a;
	  var newB = +b;
	  return newA + t * (newB - newA);
	});
	/**
	 * 线性插值的逆运算
	 *
	 * @param  {Number} a 定义域的极点
	 * @param  {Number} b 定义域的极点
	 * @param  {Number} x 可以认为是插值后的一个输出值
	 * @return {Number}   当x在 a ~ b这个范围内时，返回值属于[0, 1]
	 */
	
	var uninterpolateNumber = (0, _utils.curry)(function (a, b, x) {
	  var diff = b - +a;
	  diff = diff || Infinity;
	  return (x - a) / diff;
	});
	/**
	 * 线性插值的逆运算，并且有截断的操作
	 *
	 * @param  {Number} a 定义域的极点
	 * @param  {Number} b 定义域的极点
	 * @param  {Number} x 可以认为是插值后的一个输出值
	 * @return {Number}   当x在 a ~ b这个区间内时，返回值属于[0, 1]，
	 * 当x不在 a ~ b这个区间时，会截断到 a ~ b 这个区间
	 */
	
	var uninterpolateTruncation = (0, _utils.curry)(function (a, b, x) {
	  var diff = b - +a;
	  diff = diff || Infinity;
	  return Math.max(0, Math.min(1, (x - a) / diff));
	});
	var _default = {
	  rangeStep: rangeStep,
	  getDigitCount: getDigitCount,
	  interpolateNumber: interpolateNumber,
	  uninterpolateNumber: uninterpolateNumber,
	  uninterpolateTruncation: uninterpolateTruncation
	};
	exports.default = _default;

/***/ },
/* 2414 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(38));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _ReactUtils = __webpack_require__(29);
	
	var _DataUtils = __webpack_require__(39);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var CartesianGrid =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(CartesianGrid, _PureComponent);
	
	  function CartesianGrid() {
	    _classCallCheck(this, CartesianGrid);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(CartesianGrid).apply(this, arguments));
	  }
	
	  _createClass(CartesianGrid, [{
	    key: "renderHorizontal",
	
	    /**
	     * Draw the horizontal grid lines
	     * @param {Array} horizontalPoints either passed in as props or generated from function
	     * @return {Group} Horizontal lines
	     */
	    value: function renderHorizontal(horizontalPoints) {
	      var _this = this;
	
	      var _this$props = this.props,
	          x = _this$props.x,
	          width = _this$props.width,
	          horizontal = _this$props.horizontal;
	
	      if (!horizontalPoints || !horizontalPoints.length) {
	        return null;
	      }
	
	      var items = horizontalPoints.map(function (entry, i) {
	        var props = _objectSpread({}, _this.props, {
	          x1: x,
	          y1: entry,
	          x2: x + width,
	          y2: entry,
	          key: "line-".concat(i),
	          index: i
	        });
	
	        return _this.constructor.renderLineItem(horizontal, props);
	      });
	      return _react["default"].createElement("g", {
	        className: "recharts-cartesian-grid-horizontal"
	      }, items);
	    }
	    /**
	     * Draw vertical grid lines
	     * @param {Array} verticalPoints either passed in as props or generated from function
	     * @return {Group} Vertical lines
	     */
	
	  }, {
	    key: "renderVertical",
	    value: function renderVertical(verticalPoints) {
	      var _this2 = this;
	
	      var _this$props2 = this.props,
	          y = _this$props2.y,
	          height = _this$props2.height,
	          vertical = _this$props2.vertical;
	
	      if (!verticalPoints || !verticalPoints.length) {
	        return null;
	      }
	
	      var items = verticalPoints.map(function (entry, i) {
	        var props = _objectSpread({}, _this2.props, {
	          x1: entry,
	          y1: y,
	          x2: entry,
	          y2: y + height,
	          key: "line-".concat(i),
	          index: i
	        });
	
	        return _this2.constructor.renderLineItem(vertical, props);
	      });
	      return _react["default"].createElement("g", {
	        className: "recharts-cartesian-grid-vertical"
	      }, items);
	    }
	    /**
	     * Draw vertical grid stripes filled by colors
	     * @param {Array} verticalPoints either passed in as props or generated from function
	     * @return {Group} Vertical stripes
	     */
	
	  }, {
	    key: "renderVerticalStripes",
	    value: function renderVerticalStripes(verticalPoints) {
	      var verticalFill = this.props.verticalFill;
	
	      if (!verticalFill || !verticalFill.length) {
	        return null;
	      }
	
	      var _this$props3 = this.props,
	          fillOpacity = _this$props3.fillOpacity,
	          x = _this$props3.x,
	          y = _this$props3.y,
	          width = _this$props3.width,
	          height = _this$props3.height;
	      var verticalPointsUpdated = verticalPoints.slice().sort(function (a, b) {
	        return a - b;
	      });
	
	      if (x !== verticalPointsUpdated[0]) {
	        verticalPointsUpdated.unshift(0);
	      }
	
	      var items = verticalPointsUpdated.map(function (entry, i) {
	        var lineWidth = verticalPointsUpdated[i + 1] ? verticalPointsUpdated[i + 1] - entry : x + width - entry;
	
	        if (lineWidth <= 0) {
	          return null;
	        }
	
	        var colorIndex = i % verticalFill.length;
	        return _react["default"].createElement("rect", {
	          key: "react-".concat(i) // eslint-disable-line react/no-array-index-key
	          ,
	          x: Math.round(entry + x - x),
	          y: y,
	          width: lineWidth,
	          height: height,
	          stroke: "none",
	          fill: verticalFill[colorIndex],
	          fillOpacity: fillOpacity,
	          className: "recharts-cartesian-grid-bg"
	        });
	      });
	      return _react["default"].createElement("g", {
	        className: "recharts-cartesian-gridstripes-vertical"
	      }, items);
	    }
	    /**
	     * Draw horizontal grid stripes filled by colors
	     * @param {Array} horizontalPoints either passed in as props or generated from function
	     * @return {Group} Horizontal stripes
	     */
	
	  }, {
	    key: "renderHorizontalStripes",
	    value: function renderHorizontalStripes(horizontalPoints) {
	      var horizontalFill = this.props.horizontalFill;
	
	      if (!horizontalFill || !horizontalFill.length) {
	        return null;
	      }
	
	      var _this$props4 = this.props,
	          fillOpacity = _this$props4.fillOpacity,
	          x = _this$props4.x,
	          y = _this$props4.y,
	          width = _this$props4.width,
	          height = _this$props4.height;
	      var horizontalPointsUpdated = horizontalPoints.slice().sort(function (a, b) {
	        return a - b;
	      });
	
	      if (y !== horizontalPointsUpdated[0]) {
	        horizontalPointsUpdated.unshift(0);
	      }
	
	      var items = horizontalPointsUpdated.map(function (entry, i) {
	        var lineHeight = horizontalPointsUpdated[i + 1] ? horizontalPointsUpdated[i + 1] - entry : y + height - entry;
	
	        if (lineHeight <= 0) {
	          return null;
	        }
	
	        var colorIndex = i % horizontalFill.length;
	        return _react["default"].createElement("rect", {
	          key: "react-".concat(i) // eslint-disable-line react/no-array-index-key
	          ,
	          y: Math.round(entry + y - y),
	          x: x,
	          height: lineHeight,
	          width: width,
	          stroke: "none",
	          fill: horizontalFill[colorIndex],
	          fillOpacity: fillOpacity,
	          className: "recharts-cartesian-grid-bg"
	        });
	      });
	      return _react["default"].createElement("g", {
	        className: "recharts-cartesian-gridstripes-horizontal"
	      }, items);
	    }
	  }, {
	    key: "renderBackground",
	    value: function renderBackground() {
	      var fill = this.props.fill;
	
	      if (!fill || fill === 'none') {
	        return null;
	      }
	
	      var _this$props5 = this.props,
	          fillOpacity = _this$props5.fillOpacity,
	          x = _this$props5.x,
	          y = _this$props5.y,
	          width = _this$props5.width,
	          height = _this$props5.height;
	      return _react["default"].createElement("rect", {
	        x: x,
	        y: y,
	        width: width,
	        height: height,
	        stroke: "none",
	        fill: fill,
	        fillOpacity: fillOpacity,
	        className: "recharts-cartesian-grid-bg"
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props6 = this.props,
	          x = _this$props6.x,
	          y = _this$props6.y,
	          width = _this$props6.width,
	          height = _this$props6.height,
	          horizontal = _this$props6.horizontal,
	          vertical = _this$props6.vertical,
	          horizontalCoordinatesGenerator = _this$props6.horizontalCoordinatesGenerator,
	          verticalCoordinatesGenerator = _this$props6.verticalCoordinatesGenerator,
	          xAxis = _this$props6.xAxis,
	          yAxis = _this$props6.yAxis,
	          offset = _this$props6.offset,
	          chartWidth = _this$props6.chartWidth,
	          chartHeight = _this$props6.chartHeight;
	
	      if (!(0, _DataUtils.isNumber)(width) || width <= 0 || !(0, _DataUtils.isNumber)(height) || height <= 0 || !(0, _DataUtils.isNumber)(x) || x !== +x || !(0, _DataUtils.isNumber)(y) || y !== +y) {
	        return null;
	      }
	
	      var _this$props7 = this.props,
	          horizontalPoints = _this$props7.horizontalPoints,
	          verticalPoints = _this$props7.verticalPoints; // No horizontal points are specified
	
	      if ((!horizontalPoints || !horizontalPoints.length) && (0, _isFunction2["default"])(horizontalCoordinatesGenerator)) {
	        horizontalPoints = horizontalCoordinatesGenerator({
	          yAxis: yAxis,
	          width: chartWidth,
	          height: chartHeight,
	          offset: offset
	        });
	      } // No vertical points are specified
	
	
	      if ((!verticalPoints || !verticalPoints.length) && (0, _isFunction2["default"])(verticalCoordinatesGenerator)) {
	        verticalPoints = verticalCoordinatesGenerator({
	          xAxis: xAxis,
	          width: chartWidth,
	          height: chartHeight,
	          offset: offset
	        });
	      }
	
	      return _react["default"].createElement("g", {
	        className: "recharts-cartesian-grid"
	      }, this.renderBackground(), horizontal && this.renderHorizontal(horizontalPoints), vertical && this.renderVertical(verticalPoints), horizontal && this.renderHorizontalStripes(horizontalPoints), vertical && this.renderVerticalStripes(verticalPoints));
	    }
	  }], [{
	    key: "renderLineItem",
	    value: function renderLineItem(option, props) {
	      var lineItem;
	
	      if (_react["default"].isValidElement(option)) {
	        lineItem = _react["default"].cloneElement(option, props);
	      } else if ((0, _isFunction2["default"])(option)) {
	        lineItem = option(props);
	      } else {
	        var x1 = props.x1,
	            y1 = props.y1,
	            x2 = props.x2,
	            y2 = props.y2,
	            key = props.key,
	            others = _objectWithoutProperties(props, ["x1", "y1", "x2", "y2", "key"]);
	
	        lineItem = _react["default"].createElement("line", _extends({}, (0, _ReactUtils.getPresentationAttributes)(others), {
	          x1: x1,
	          y1: y1,
	          x2: x2,
	          y2: y2,
	          fill: "none",
	          key: key
	        }));
	      }
	
	      return lineItem;
	    }
	  }]);
	
	  return CartesianGrid;
	}(_react.PureComponent);
	
	CartesianGrid.displayName = 'CartesianGrid';
	CartesianGrid.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  x: _propTypes["default"].number,
	  y: _propTypes["default"].number,
	  width: _propTypes["default"].number,
	  height: _propTypes["default"].number,
	  horizontal: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].element, _propTypes["default"].func, _propTypes["default"].bool]),
	  vertical: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].element, _propTypes["default"].func, _propTypes["default"].bool]),
	  horizontalPoints: _propTypes["default"].arrayOf(_propTypes["default"].number),
	  verticalPoints: _propTypes["default"].arrayOf(_propTypes["default"].number),
	  horizontalCoordinatesGenerator: _propTypes["default"].func,
	  verticalCoordinatesGenerator: _propTypes["default"].func,
	  xAxis: _propTypes["default"].object,
	  yAxis: _propTypes["default"].object,
	  offset: _propTypes["default"].object,
	  chartWidth: _propTypes["default"].number,
	  chartHeight: _propTypes["default"].number,
	  verticalFill: _propTypes["default"].arrayOf(_propTypes["default"].string),
	  horizontalFill: _propTypes["default"].arrayOf(_propTypes["default"].string)
	});
	CartesianGrid.defaultProps = {
	  horizontal: true,
	  vertical: true,
	  // The ordinates of horizontal grid lines
	  horizontalPoints: [],
	  // The abscissas of vertical grid lines
	  verticalPoints: [],
	  stroke: '#ccc',
	  fill: 'none',
	  // The fill of colors of grid lines
	  verticalFill: [],
	  horizontalFill: []
	};
	var _default = CartesianGrid;
	exports["default"] = _default;

/***/ },
/* 2415 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _generateCategoricalChart = _interopRequireDefault(__webpack_require__(112));
	
	var _Area = _interopRequireDefault(__webpack_require__(473));
	
	var _XAxis = _interopRequireDefault(__webpack_require__(186));
	
	var _YAxis = _interopRequireDefault(__webpack_require__(187));
	
	var _CartesianUtils = __webpack_require__(128);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * @fileOverview Area Chart
	 */
	var _default = (0, _generateCategoricalChart["default"])({
	  chartName: 'AreaChart',
	  GraphicalChild: _Area["default"],
	  axisComponents: [{
	    axisType: 'xAxis',
	    AxisComp: _XAxis["default"]
	  }, {
	    axisType: 'yAxis',
	    AxisComp: _YAxis["default"]
	  }],
	  formatAxisMap: _CartesianUtils.formatAxisMap
	});
	
	exports["default"] = _default;

/***/ },
/* 2416 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _generateCategoricalChart = _interopRequireDefault(__webpack_require__(112));
	
	var _Bar = _interopRequireDefault(__webpack_require__(474));
	
	var _XAxis = _interopRequireDefault(__webpack_require__(186));
	
	var _YAxis = _interopRequireDefault(__webpack_require__(187));
	
	var _CartesianUtils = __webpack_require__(128);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * @fileOverview Bar Chart
	 */
	var _default = (0, _generateCategoricalChart["default"])({
	  chartName: 'BarChart',
	  GraphicalChild: _Bar["default"],
	  axisComponents: [{
	    axisType: 'xAxis',
	    AxisComp: _XAxis["default"]
	  }, {
	    axisType: 'yAxis',
	    AxisComp: _YAxis["default"]
	  }],
	  formatAxisMap: _CartesianUtils.formatAxisMap
	});
	
	exports["default"] = _default;

/***/ },
/* 2417 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _generateCategoricalChart = _interopRequireDefault(__webpack_require__(112));
	
	var _Area = _interopRequireDefault(__webpack_require__(473));
	
	var _Bar = _interopRequireDefault(__webpack_require__(474));
	
	var _Line = _interopRequireDefault(__webpack_require__(475));
	
	var _Scatter = _interopRequireDefault(__webpack_require__(476));
	
	var _XAxis = _interopRequireDefault(__webpack_require__(186));
	
	var _YAxis = _interopRequireDefault(__webpack_require__(187));
	
	var _ZAxis = _interopRequireDefault(__webpack_require__(306));
	
	var _CartesianUtils = __webpack_require__(128);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * @fileOverview Composed Chart
	 */
	var _default = (0, _generateCategoricalChart["default"])({
	  chartName: 'ComposedChart',
	  GraphicalChild: [_Line["default"], _Area["default"], _Bar["default"], _Scatter["default"]],
	  axisComponents: [{
	    axisType: 'xAxis',
	    AxisComp: _XAxis["default"]
	  }, {
	    axisType: 'yAxis',
	    AxisComp: _YAxis["default"]
	  }, {
	    axisType: 'zAxis',
	    AxisComp: _ZAxis["default"]
	  }],
	  formatAxisMap: _CartesianUtils.formatAxisMap
	});
	
	exports["default"] = _default;

/***/ },
/* 2418 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _generateCategoricalChart = _interopRequireDefault(__webpack_require__(112));
	
	var _Funnel = _interopRequireDefault(__webpack_require__(988));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * @fileOverview Funnel Chart
	 */
	var _default = (0, _generateCategoricalChart["default"])({
	  chartName: 'FunnelChart',
	  GraphicalChild: _Funnel["default"],
	  eventType: 'item',
	  axisComponents: [],
	  defaultProps: {
	    layout: 'centric'
	  },
	  propTypes: {
	    layout: _propTypes["default"].oneOf(['centric'])
	  }
	});
	
	exports["default"] = _default;

/***/ },
/* 2419 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _generateCategoricalChart = _interopRequireDefault(__webpack_require__(112));
	
	var _Line = _interopRequireDefault(__webpack_require__(475));
	
	var _XAxis = _interopRequireDefault(__webpack_require__(186));
	
	var _YAxis = _interopRequireDefault(__webpack_require__(187));
	
	var _CartesianUtils = __webpack_require__(128);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * @fileOverview Line Chart
	 */
	var _default = (0, _generateCategoricalChart["default"])({
	  chartName: 'LineChart',
	  GraphicalChild: _Line["default"],
	  axisComponents: [{
	    axisType: 'xAxis',
	    AxisComp: _XAxis["default"]
	  }, {
	    axisType: 'yAxis',
	    AxisComp: _YAxis["default"]
	  }],
	  formatAxisMap: _CartesianUtils.formatAxisMap
	});
	
	exports["default"] = _default;

/***/ },
/* 2420 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _generateCategoricalChart = _interopRequireDefault(__webpack_require__(112));
	
	var _PolarAngleAxis = _interopRequireDefault(__webpack_require__(308));
	
	var _PolarRadiusAxis = _interopRequireDefault(__webpack_require__(309));
	
	var _PolarUtils = __webpack_require__(86);
	
	var _Pie = _interopRequireDefault(__webpack_require__(989));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * @fileOverview Pie Chart
	 */
	var _default = (0, _generateCategoricalChart["default"])({
	  chartName: 'PieChart',
	  GraphicalChild: _Pie["default"],
	  eventType: 'item',
	  legendContent: 'children',
	  axisComponents: [{
	    axisType: 'angleAxis',
	    AxisComp: _PolarAngleAxis["default"]
	  }, {
	    axisType: 'radiusAxis',
	    AxisComp: _PolarRadiusAxis["default"]
	  }],
	  formatAxisMap: _PolarUtils.formatAxisMap,
	  defaultProps: {
	    layout: 'centric',
	    startAngle: 0,
	    endAngle: 360,
	    cx: '50%',
	    cy: '50%',
	    innerRadius: 0,
	    outerRadius: '80%'
	  },
	  propTypes: {
	    layout: _propTypes["default"].oneOf(['centric']),
	    startAngle: _propTypes["default"].number,
	    endAngle: _propTypes["default"].number,
	    cx: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	    cy: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	    innerRadius: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	    outerRadius: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
	  }
	});
	
	exports["default"] = _default;

/***/ },
/* 2421 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _generateCategoricalChart = _interopRequireDefault(__webpack_require__(112));
	
	var _Radar = _interopRequireDefault(__webpack_require__(990));
	
	var _PolarAngleAxis = _interopRequireDefault(__webpack_require__(308));
	
	var _PolarRadiusAxis = _interopRequireDefault(__webpack_require__(309));
	
	var _PolarUtils = __webpack_require__(86);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * @fileOverview Radar Chart
	 */
	var _default = (0, _generateCategoricalChart["default"])({
	  chartName: 'RadarChart',
	  GraphicalChild: _Radar["default"],
	  axisComponents: [{
	    axisType: 'angleAxis',
	    AxisComp: _PolarAngleAxis["default"]
	  }, {
	    axisType: 'radiusAxis',
	    AxisComp: _PolarRadiusAxis["default"]
	  }],
	  formatAxisMap: _PolarUtils.formatAxisMap,
	  defaultProps: {
	    layout: 'centric',
	    startAngle: 90,
	    endAngle: -270,
	    cx: '50%',
	    cy: '50%',
	    innerRadius: 0,
	    outerRadius: '80%'
	  },
	  propTypes: {
	    layout: _propTypes["default"].oneOf(['centric']),
	    startAngle: _propTypes["default"].number,
	    endAngle: _propTypes["default"].number,
	    cx: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	    cy: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	    innerRadius: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	    outerRadius: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
	  }
	});
	
	exports["default"] = _default;

/***/ },
/* 2422 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _generateCategoricalChart = _interopRequireDefault(__webpack_require__(112));
	
	var _PolarAngleAxis = _interopRequireDefault(__webpack_require__(308));
	
	var _PolarRadiusAxis = _interopRequireDefault(__webpack_require__(309));
	
	var _PolarUtils = __webpack_require__(86);
	
	var _RadialBar = _interopRequireDefault(__webpack_require__(991));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * @fileOverview Radar Bar Chart
	 */
	var _default = (0, _generateCategoricalChart["default"])({
	  chartName: 'RadialBarChart',
	  GraphicalChild: _RadialBar["default"],
	  legendContent: 'children',
	  axisComponents: [{
	    axisType: 'angleAxis',
	    AxisComp: _PolarAngleAxis["default"]
	  }, {
	    axisType: 'radiusAxis',
	    AxisComp: _PolarRadiusAxis["default"]
	  }],
	  formatAxisMap: _PolarUtils.formatAxisMap,
	  defaultProps: {
	    layout: 'radial',
	    startAngle: 0,
	    endAngle: 360,
	    cx: '50%',
	    cy: '50%',
	    innerRadius: 0,
	    outerRadius: '80%'
	  },
	  propTypes: {
	    layout: _propTypes["default"].oneOf(['radial']),
	    startAngle: _propTypes["default"].number,
	    endAngle: _propTypes["default"].number,
	    cx: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	    cy: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	    innerRadius: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	    outerRadius: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
	  }
	});
	
	exports["default"] = _default;

/***/ },
/* 2423 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(38));
	
	var _sumBy2 = _interopRequireDefault(__webpack_require__(2182));
	
	var _min2 = _interopRequireDefault(__webpack_require__(757));
	
	var _maxBy2 = _interopRequireDefault(__webpack_require__(756));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _Surface = _interopRequireDefault(__webpack_require__(231));
	
	var _Layer = _interopRequireDefault(__webpack_require__(49));
	
	var _Tooltip = _interopRequireDefault(__webpack_require__(307));
	
	var _Rectangle = _interopRequireDefault(__webpack_require__(190));
	
	var _ShallowEqual = __webpack_require__(314);
	
	var _ReactUtils = __webpack_require__(29);
	
	var _ChartUtils = __webpack_require__(66);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var defaultCoordinateOfTooltip = {
	  x: 0,
	  y: 0
	};
	
	var interpolationGenerator = function interpolationGenerator(a, b) {
	  var ka = +a;
	  var kb = b - ka;
	  return function (t) {
	    return ka + kb * t;
	  };
	};
	
	var centerY = function centerY(node) {
	  return node.y + node.dy / 2;
	};
	
	var getValue = function getValue(entry) {
	  return entry && entry.value || 0;
	};
	
	var getSumOfIds = function getSumOfIds(links, ids) {
	  return ids.reduce(function (result, id) {
	    return result + getValue(links[id]);
	  }, 0);
	};
	
	var getSumWithWeightedSource = function getSumWithWeightedSource(tree, links, ids) {
	  return ids.reduce(function (result, id) {
	    var link = links[id];
	    var sourceNode = tree[link.source];
	    return result + centerY(sourceNode) * getValue(links[id]);
	  }, 0);
	};
	
	var getSumWithWeightedTarget = function getSumWithWeightedTarget(tree, links, ids) {
	  return ids.reduce(function (result, id) {
	    var link = links[id];
	    var targetNode = tree[link.target];
	    return result + centerY(targetNode) * getValue(links[id]);
	  }, 0);
	};
	
	var ascendingY = function ascendingY(a, b) {
	  return a.y - b.y;
	};
	
	var searchTargetsAndSources = function searchTargetsAndSources(links, id) {
	  var sourceNodes = [];
	  var sourceLinks = [];
	  var targetNodes = [];
	  var targetLinks = [];
	
	  for (var i = 0, len = links.length; i < len; i++) {
	    var link = links[i];
	
	    if (link.source === id) {
	      targetNodes.push(link.target);
	      targetLinks.push(i);
	    }
	
	    if (link.target === id) {
	      sourceNodes.push(link.source);
	      sourceLinks.push(i);
	    }
	  }
	
	  return {
	    sourceNodes: sourceNodes,
	    sourceLinks: sourceLinks,
	    targetLinks: targetLinks,
	    targetNodes: targetNodes
	  };
	};
	
	var updateDepthOfTargets = function updateDepthOfTargets(tree, curNode) {
	  var targetNodes = curNode.targetNodes;
	
	  for (var i = 0, len = targetNodes.length; i < len; i++) {
	    var target = tree[targetNodes[i]];
	
	    if (target) {
	      target.depth = Math.max(curNode.depth + 1, target.depth);
	      updateDepthOfTargets(tree, target);
	    }
	  }
	};
	
	var getNodesTree = function getNodesTree(_ref, width, nodeWidth) {
	  var nodes = _ref.nodes,
	      links = _ref.links;
	  var tree = nodes.map(function (entry, index) {
	    var result = searchTargetsAndSources(links, index);
	    return _objectSpread({}, entry, {}, result, {
	      value: Math.max(getSumOfIds(links, result.sourceLinks), getSumOfIds(links, result.targetLinks)),
	      depth: 0
	    });
	  });
	
	  for (var i = 0, len = tree.length; i < len; i++) {
	    var node = tree[i];
	
	    if (!node.sourceNodes.length) {
	      updateDepthOfTargets(tree, node);
	    }
	  }
	
	  var maxDepth = (0, _maxBy2["default"])(tree, function (entry) {
	    return entry.depth;
	  }).depth;
	
	  if (maxDepth >= 1) {
	    var childWidth = (width - nodeWidth) / maxDepth;
	
	    for (var _i = 0, _len = tree.length; _i < _len; _i++) {
	      var _node = tree[_i];
	
	      if (!_node.targetNodes.length) {
	        _node.depth = maxDepth;
	      }
	
	      _node.x = _node.depth * childWidth;
	      _node.dx = nodeWidth;
	    }
	  }
	
	  return {
	    tree: tree,
	    maxDepth: maxDepth
	  };
	};
	
	var getDepthTree = function getDepthTree(tree) {
	  var result = [];
	
	  for (var i = 0, len = tree.length; i < len; i++) {
	    var node = tree[i];
	
	    if (!result[node.depth]) {
	      result[node.depth] = [];
	    }
	
	    result[node.depth].push(node);
	  }
	
	  return result;
	};
	
	var updateYOfTree = function updateYOfTree(depthTree, height, nodePadding, links) {
	  var yRatio = (0, _min2["default"])(depthTree.map(function (nodes) {
	    return (height - (nodes.length - 1) * nodePadding) / (0, _sumBy2["default"])(nodes, getValue);
	  }));
	
	  for (var d = 0, maxDepth = depthTree.length; d < maxDepth; d++) {
	    for (var i = 0, len = depthTree[d].length; i < len; i++) {
	      var node = depthTree[d][i];
	      node.y = i;
	      node.dy = node.value * yRatio;
	    }
	  }
	
	  return links.map(function (link) {
	    return _objectSpread({}, link, {
	      dy: getValue(link) * yRatio
	    });
	  });
	};
	
	var resolveCollisions = function resolveCollisions(depthTree, height, nodePadding) {
	  for (var i = 0, len = depthTree.length; i < len; i++) {
	    var nodes = depthTree[i];
	    var n = nodes.length; // Sort by the value of y
	
	    nodes.sort(ascendingY);
	    var y0 = 0;
	
	    for (var j = 0; j < n; j++) {
	      var node = nodes[j];
	      var dy = y0 - node.y;
	
	      if (dy > 0) {
	        node.y += dy;
	      }
	
	      y0 = node.y + node.dy + nodePadding;
	    }
	
	    y0 = height + nodePadding;
	
	    for (var _j = n - 1; _j >= 0; _j--) {
	      var _node2 = nodes[_j];
	
	      var _dy = _node2.y + _node2.dy + nodePadding - y0;
	
	      if (_dy > 0) {
	        _node2.y -= _dy;
	        y0 = _node2.y;
	      } else {
	        break;
	      }
	    }
	  }
	};
	
	var relaxLeftToRight = function relaxLeftToRight(tree, depthTree, links, alpha) {
	  for (var i = 0, maxDepth = depthTree.length; i < maxDepth; i++) {
	    var nodes = depthTree[i];
	
	    for (var j = 0, len = nodes.length; j < len; j++) {
	      var node = nodes[j];
	
	      if (node.sourceLinks.length) {
	        var sourceSum = getSumOfIds(links, node.sourceLinks);
	        var weightedSum = getSumWithWeightedSource(tree, links, node.sourceLinks);
	        var y = weightedSum / sourceSum;
	        node.y += (y - centerY(node)) * alpha;
	      }
	    }
	  }
	};
	
	var relaxRightToLeft = function relaxRightToLeft(tree, depthTree, links, alpha) {
	  for (var i = depthTree.length - 1; i >= 0; i--) {
	    var nodes = depthTree[i];
	
	    for (var j = 0, len = nodes.length; j < len; j++) {
	      var node = nodes[j];
	
	      if (node.targetLinks.length) {
	        var targetSum = getSumOfIds(links, node.targetLinks);
	        var weightedSum = getSumWithWeightedTarget(tree, links, node.targetLinks);
	        var y = weightedSum / targetSum;
	        node.y += (y - centerY(node)) * alpha;
	      }
	    }
	  }
	};
	
	var updateYOfLinks = function updateYOfLinks(tree, links) {
	  for (var i = 0, len = tree.length; i < len; i++) {
	    var node = tree[i];
	    var sy = 0;
	    var ty = 0;
	    node.targetLinks.sort(function (a, b) {
	      return tree[links[a].target].y - tree[links[b].target].y;
	    });
	    node.sourceLinks.sort(function (a, b) {
	      return tree[links[a].source].y - tree[links[b].source].y;
	    });
	
	    for (var j = 0, tLen = node.targetLinks.length; j < tLen; j++) {
	      var link = links[node.targetLinks[j]];
	
	      if (link) {
	        link.sy = sy;
	        sy += link.dy;
	      }
	    }
	
	    for (var _j2 = 0, sLen = node.sourceLinks.length; _j2 < sLen; _j2++) {
	      var _link = links[node.sourceLinks[_j2]];
	
	      if (_link) {
	        _link.ty = ty;
	        ty += _link.dy;
	      }
	    }
	  }
	};
	
	var computeData = function computeData(_ref2) {
	  var data = _ref2.data,
	      width = _ref2.width,
	      height = _ref2.height,
	      iterations = _ref2.iterations,
	      nodeWidth = _ref2.nodeWidth,
	      nodePadding = _ref2.nodePadding;
	  var links = data.links;
	
	  var _getNodesTree = getNodesTree(data, width, nodeWidth),
	      tree = _getNodesTree.tree;
	
	  var depthTree = getDepthTree(tree);
	  var newLinks = updateYOfTree(depthTree, height, nodePadding, links);
	  resolveCollisions(depthTree, height, nodePadding);
	  var alpha = 1;
	
	  for (var i = 1; i <= iterations; i++) {
	    relaxRightToLeft(tree, depthTree, newLinks, alpha *= 0.99);
	    resolveCollisions(depthTree, height, nodePadding);
	    relaxLeftToRight(tree, depthTree, newLinks, alpha);
	    resolveCollisions(depthTree, height, nodePadding);
	  }
	
	  updateYOfLinks(tree, newLinks);
	  return {
	    nodes: tree,
	    links: newLinks
	  };
	};
	
	var getCoordinateOfTooltip = function getCoordinateOfTooltip(el, type) {
	  if (type === 'node') {
	    return {
	      x: el.x + el.width / 2,
	      y: el.y + el.height / 2
	    };
	  }
	
	  return {
	    x: (el.sourceX + el.targetX) / 2,
	    y: (el.sourceY + el.targetY) / 2
	  };
	};
	
	var getPayloadOfTooltip = function getPayloadOfTooltip(el, type, nameKey) {
	  var payload = el.payload;
	
	  if (type === 'node') {
	    return [{
	      payload: el,
	      name: (0, _ChartUtils.getValueByDataKey)(payload, nameKey, ''),
	      value: (0, _ChartUtils.getValueByDataKey)(payload, 'value')
	    }];
	  }
	
	  if (payload.source && payload.target) {
	    var sourceName = (0, _ChartUtils.getValueByDataKey)(payload.source, nameKey, '');
	    var targetName = (0, _ChartUtils.getValueByDataKey)(payload.target, nameKey, '');
	    return [{
	      payload: el,
	      name: "".concat(sourceName, " - ").concat(targetName),
	      value: (0, _ChartUtils.getValueByDataKey)(payload, 'value')
	    }];
	  }
	
	  return [];
	};
	
	var Sankey =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Sankey, _PureComponent);
	
	  function Sankey(props) {
	    var _this;
	
	    _classCallCheck(this, Sankey);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(Sankey).call(this, props));
	    _this.state = _this.constructor.createDefaultState(props);
	    return _this;
	  } // eslint-disable-next-line camelcase
	
	
	  _createClass(Sankey, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _this$props = this.props,
	          data = _this$props.data,
	          width = _this$props.width,
	          height = _this$props.height,
	          margin = _this$props.margin,
	          iterations = _this$props.iterations,
	          nodeWidth = _this$props.nodeWidth,
	          nodePadding = _this$props.nodePadding,
	          nameKey = _this$props.nameKey;
	
	      if (nextProps.data !== data || nextProps.width !== width || nextProps.height !== height || !(0, _ShallowEqual.shallowEqual)(nextProps.margin, margin) || nextProps.iterations !== iterations || nextProps.nodeWidth !== nodeWidth || nextProps.nodePadding !== nodePadding || nextProps.nameKey !== nameKey) {
	        this.setState(this.constructor.createDefaultState(nextProps));
	      }
	    }
	    /**
	     * Returns default, reset state for the sankey chart.
	     * @param  {Object} props The latest props
	     * @return {Object} Whole new state
	     */
	
	  }, {
	    key: "handleMouseEnter",
	    value: function handleMouseEnter(el, type, e) {
	      var _this$props2 = this.props,
	          onMouseEnter = _this$props2.onMouseEnter,
	          children = _this$props2.children;
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip["default"]);
	
	      if (tooltipItem) {
	        this.setState({
	          activeElement: el,
	          activeElementType: type,
	          isTooltipActive: true
	        }, function () {
	          if (onMouseEnter) {
	            onMouseEnter(el, type, e);
	          }
	        });
	      } else if (onMouseEnter) {
	        onMouseEnter(el, type, e);
	      }
	    }
	  }, {
	    key: "handleMouseLeave",
	    value: function handleMouseLeave(el, type, e) {
	      var _this$props3 = this.props,
	          onMouseLeave = _this$props3.onMouseLeave,
	          children = _this$props3.children;
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip["default"]);
	
	      if (tooltipItem) {
	        this.setState({
	          isTooltipActive: false
	        }, function () {
	          if (onMouseLeave) {
	            onMouseLeave(el, type, e);
	          }
	        });
	      } else if (onMouseLeave) {
	        onMouseLeave(el, type, e);
	      }
	    }
	  }, {
	    key: "handleClick",
	    value: function handleClick(el, type, e) {
	      var onClick = this.props.onClick;
	      if (onClick) onClick(el, type, e);
	    }
	  }, {
	    key: "renderLinks",
	    value: function renderLinks(links, nodes) {
	      var _this2 = this;
	
	      var _this$props4 = this.props,
	          linkCurvature = _this$props4.linkCurvature,
	          linkContent = _this$props4.link,
	          margin = _this$props4.margin;
	      var top = margin.top || 0;
	      var left = margin.left || 0;
	      return _react["default"].createElement(_Layer["default"], {
	        className: "recharts-sankey-links",
	        key: "recharts-sankey-links"
	      }, links.map(function (link, i) {
	        var sourceRelativeY = link.sy,
	            targetRelativeY = link.ty,
	            linkWidth = link.dy;
	        var source = nodes[link.source];
	        var target = nodes[link.target];
	        var sourceX = source.x + source.dx + left;
	        var targetX = target.x + left;
	        var interpolationFunc = interpolationGenerator(sourceX, targetX);
	        var sourceControlX = interpolationFunc(linkCurvature);
	        var targetControlX = interpolationFunc(1 - linkCurvature);
	        var sourceY = source.y + sourceRelativeY + linkWidth / 2 + top;
	        var targetY = target.y + targetRelativeY + linkWidth / 2 + top;
	
	        var linkProps = _objectSpread({
	          sourceX: sourceX,
	          targetX: targetX,
	          sourceY: sourceY,
	          targetY: targetY,
	          sourceControlX: sourceControlX,
	          targetControlX: targetControlX,
	          sourceRelativeY: sourceRelativeY,
	          targetRelativeY: targetRelativeY,
	          linkWidth: linkWidth,
	          index: i,
	          payload: _objectSpread({}, link, {
	            source: source,
	            target: target
	          })
	        }, (0, _ReactUtils.getPresentationAttributes)(linkContent));
	
	        var events = {
	          onMouseEnter: _this2.handleMouseEnter.bind(_this2, linkProps, 'link'),
	          onMouseLeave: _this2.handleMouseLeave.bind(_this2, linkProps, 'link'),
	          onClick: _this2.handleClick.bind(_this2, linkProps, 'link')
	        };
	        return (// eslint-disable-next-line react/no-array-index-key
	          _react["default"].createElement(_Layer["default"], _extends({
	            key: "link".concat(i)
	          }, events), _this2.constructor.renderLinkItem(linkContent, linkProps))
	        );
	      }));
	    }
	  }, {
	    key: "renderNodes",
	    value: function renderNodes(nodes) {
	      var _this3 = this;
	
	      var _this$props5 = this.props,
	          nodeContent = _this$props5.node,
	          margin = _this$props5.margin;
	      var top = margin.top || 0;
	      var left = margin.left || 0;
	      return _react["default"].createElement(_Layer["default"], {
	        className: "recharts-sankey-nodes",
	        key: "recharts-sankey-nodes"
	      }, nodes.map(function (node, i) {
	        var x = node.x,
	            y = node.y,
	            dx = node.dx,
	            dy = node.dy;
	
	        var nodeProps = _objectSpread({}, (0, _ReactUtils.getPresentationAttributes)(nodeContent), {
	          x: x + left,
	          y: y + top,
	          width: dx,
	          height: dy,
	          index: i,
	          payload: node
	        });
	
	        var events = {
	          onMouseEnter: _this3.handleMouseEnter.bind(_this3, nodeProps, 'node'),
	          onMouseLeave: _this3.handleMouseLeave.bind(_this3, nodeProps, 'node'),
	          onClick: _this3.handleClick.bind(_this3, nodeProps, 'node')
	        };
	        return (// eslint-disable-next-line react/no-array-index-key
	          _react["default"].createElement(_Layer["default"], _extends({
	            key: "node".concat(i)
	          }, events), _this3.constructor.renderNodeItem(nodeContent, nodeProps))
	        );
	      }));
	    }
	  }, {
	    key: "renderTooltip",
	    value: function renderTooltip() {
	      var _this$props6 = this.props,
	          children = _this$props6.children,
	          width = _this$props6.width,
	          height = _this$props6.height,
	          nameKey = _this$props6.nameKey;
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip["default"]);
	
	      if (!tooltipItem) {
	        return null;
	      }
	
	      var _this$state = this.state,
	          isTooltipActive = _this$state.isTooltipActive,
	          activeElement = _this$state.activeElement,
	          activeElementType = _this$state.activeElementType;
	      var viewBox = {
	        x: 0,
	        y: 0,
	        width: width,
	        height: height
	      };
	      var coordinate = activeElement ? getCoordinateOfTooltip(activeElement, activeElementType) : defaultCoordinateOfTooltip;
	      var payload = activeElement ? getPayloadOfTooltip(activeElement, activeElementType, nameKey) : [];
	      return _react["default"].cloneElement(tooltipItem, {
	        viewBox: viewBox,
	        active: isTooltipActive,
	        coordinate: coordinate,
	        label: '',
	        payload: payload
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      if (!(0, _ReactUtils.validateWidthHeight)(this)) {
	        return null;
	      }
	
	      var _this$props7 = this.props,
	          width = _this$props7.width,
	          height = _this$props7.height,
	          className = _this$props7.className,
	          style = _this$props7.style,
	          children = _this$props7.children,
	          others = _objectWithoutProperties(_this$props7, ["width", "height", "className", "style", "children"]);
	
	      var _this$state2 = this.state,
	          links = _this$state2.links,
	          nodes = _this$state2.nodes;
	      var attrs = (0, _ReactUtils.getPresentationAttributes)(others);
	      return _react["default"].createElement("div", {
	        className: (0, _classnames["default"])('recharts-wrapper', className),
	        style: _objectSpread({}, style, {
	          position: 'relative',
	          cursor: 'default',
	          width: width,
	          height: height
	        })
	      }, _react["default"].createElement(_Surface["default"], _extends({}, attrs, {
	        width: width,
	        height: height
	      }), (0, _ReactUtils.filterSvgElements)(children), this.renderLinks(links, nodes), this.renderNodes(nodes)), this.renderTooltip());
	    }
	  }], [{
	    key: "createDefaultState",
	    value: function createDefaultState(props) {
	      var data = props.data,
	          width = props.width,
	          height = props.height,
	          margin = props.margin,
	          iterations = props.iterations,
	          nodeWidth = props.nodeWidth,
	          nodePadding = props.nodePadding;
	      var contentWidth = width - (margin && margin.left || 0) - (margin && margin.right || 0);
	      var contentHeight = height - (margin && margin.top || 0) - (margin && margin.bottom || 0);
	
	      var _computeData = computeData({
	        data: data,
	        width: contentWidth,
	        height: contentHeight,
	        iterations: iterations,
	        nodeWidth: nodeWidth,
	        nodePadding: nodePadding
	      }),
	          links = _computeData.links,
	          nodes = _computeData.nodes;
	
	      return {
	        activeElement: null,
	        activeElementType: null,
	        isTooltipActive: false,
	        nodes: nodes,
	        links: links
	      };
	    }
	  }, {
	    key: "renderLinkItem",
	    value: function renderLinkItem(option, props) {
	      if (_react["default"].isValidElement(option)) {
	        return _react["default"].cloneElement(option, props);
	      }
	
	      if ((0, _isFunction2["default"])(option)) {
	        return option(props);
	      }
	
	      var sourceX = props.sourceX,
	          sourceY = props.sourceY,
	          sourceControlX = props.sourceControlX,
	          targetX = props.targetX,
	          targetY = props.targetY,
	          targetControlX = props.targetControlX,
	          linkWidth = props.linkWidth,
	          others = _objectWithoutProperties(props, ["sourceX", "sourceY", "sourceControlX", "targetX", "targetY", "targetControlX", "linkWidth"]);
	
	      return _react["default"].createElement("path", _extends({
	        className: "recharts-sankey-link",
	        d: "\n          M".concat(sourceX, ",").concat(sourceY, "\n          C").concat(sourceControlX, ",").concat(sourceY, " ").concat(targetControlX, ",").concat(targetY, " ").concat(targetX, ",").concat(targetY, "\n        "),
	        fill: "none",
	        stroke: "#333",
	        strokeWidth: linkWidth,
	        strokeOpacity: "0.2"
	      }, (0, _ReactUtils.getPresentationAttributes)(others)));
	    }
	  }, {
	    key: "renderNodeItem",
	    value: function renderNodeItem(option, props) {
	      if (_react["default"].isValidElement(option)) {
	        return _react["default"].cloneElement(option, props);
	      }
	
	      if ((0, _isFunction2["default"])(option)) {
	        return option(props);
	      }
	
	      return _react["default"].createElement(_Rectangle["default"], _extends({
	        className: "recharts-sankey-node",
	        fill: "#0088fe",
	        fillOpacity: "0.8"
	      }, props));
	    }
	  }]);
	
	  return Sankey;
	}(_react.PureComponent);
	
	Sankey.displayName = 'Sankey';
	Sankey.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {}, _ReactUtils.EVENT_ATTRIBUTES, {
	  nameKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func]),
	  dataKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func]),
	  width: _propTypes["default"].number,
	  height: _propTypes["default"].number,
	  data: _propTypes["default"].shape({
	    nodes: _propTypes["default"].array,
	    links: _propTypes["default"].arrayOf(_propTypes["default"].shape({
	      target: _propTypes["default"].number,
	      source: _propTypes["default"].number,
	      value: _propTypes["default"].number
	    }))
	  }),
	  nodePadding: _propTypes["default"].number,
	  nodeWidth: _propTypes["default"].number,
	  linkCurvature: _propTypes["default"].number,
	  iterations: _propTypes["default"].number,
	  node: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].element, _propTypes["default"].func]),
	  link: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].element, _propTypes["default"].func]),
	  style: _propTypes["default"].object,
	  className: _propTypes["default"].string,
	  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),
	  margin: _propTypes["default"].shape({
	    top: _propTypes["default"].number,
	    right: _propTypes["default"].number,
	    bottom: _propTypes["default"].number,
	    left: _propTypes["default"].number
	  })
	});
	Sankey.defaultProps = {
	  nodePadding: 10,
	  nodeWidth: 10,
	  nameKey: 'name',
	  dataKey: 'value',
	  linkCurvature: 0.5,
	  iterations: 32,
	  margin: {
	    top: 5,
	    right: 5,
	    bottom: 5,
	    left: 5
	  }
	};
	var _default = Sankey;
	exports["default"] = _default;

/***/ },
/* 2424 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _generateCategoricalChart = _interopRequireDefault(__webpack_require__(112));
	
	var _Scatter = _interopRequireDefault(__webpack_require__(476));
	
	var _XAxis = _interopRequireDefault(__webpack_require__(186));
	
	var _YAxis = _interopRequireDefault(__webpack_require__(187));
	
	var _ZAxis = _interopRequireDefault(__webpack_require__(306));
	
	var _CartesianUtils = __webpack_require__(128);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * @fileOverview Scatter Chart
	 */
	var _default = (0, _generateCategoricalChart["default"])({
	  chartName: 'ScatterChart',
	  GraphicalChild: _Scatter["default"],
	  eventType: 'single',
	  axisComponents: [{
	    axisType: 'xAxis',
	    AxisComp: _XAxis["default"]
	  }, {
	    axisType: 'yAxis',
	    AxisComp: _YAxis["default"]
	  }, {
	    axisType: 'zAxis',
	    AxisComp: _ZAxis["default"]
	  }],
	  formatAxisMap: _CartesianUtils.formatAxisMap
	});
	
	exports["default"] = _default;

/***/ },
/* 2425 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _get2 = _interopRequireDefault(__webpack_require__(180));
	
	var _omit2 = _interopRequireDefault(__webpack_require__(758));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(38));
	
	var _isNaN2 = _interopRequireDefault(__webpack_require__(290));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _reactSmooth = _interopRequireDefault(__webpack_require__(81));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _Surface = _interopRequireDefault(__webpack_require__(231));
	
	var _Layer = _interopRequireDefault(__webpack_require__(49));
	
	var _Rectangle = _interopRequireDefault(__webpack_require__(190));
	
	var _ReactUtils = __webpack_require__(29);
	
	var _Tooltip = _interopRequireDefault(__webpack_require__(307));
	
	var _Polygon = _interopRequireDefault(__webpack_require__(310));
	
	var _ChartUtils = __webpack_require__(66);
	
	var _Constants = __webpack_require__(2432);
	
	var _DOMUtils = __webpack_require__(312);
	
	var _DataUtils = __webpack_require__(39);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var computeNode = function computeNode(_ref) {
	  var depth = _ref.depth,
	      node = _ref.node,
	      index = _ref.index,
	      valueKey = _ref.valueKey;
	  var children = node.children;
	  var childDepth = depth + 1;
	  var computedChildren = children && children.length ? children.map(function (child, i) {
	    return computeNode({
	      depth: childDepth,
	      node: child,
	      index: i,
	      valueKey: valueKey
	    });
	  }) : null;
	  var value;
	
	  if (children && children.length) {
	    value = computedChildren.reduce(function (result, child) {
	      return result + child.value;
	    }, 0);
	  } else {
	    value = (0, _isNaN2["default"])(node[valueKey]) || node[valueKey] <= 0 ? 0 : node[valueKey];
	  }
	
	  return _objectSpread({}, node, {
	    children: computedChildren,
	    value: value,
	    depth: depth,
	    index: index
	  });
	};
	
	var filterRect = function filterRect(node) {
	  return {
	    x: node.x,
	    y: node.y,
	    width: node.width,
	    height: node.height
	  };
	}; // Compute the area for each child based on value & scale.
	
	
	var getAreaOfChildren = function getAreaOfChildren(children, areaValueRatio) {
	  var ratio = areaValueRatio < 0 ? 0 : areaValueRatio;
	  return children.map(function (child) {
	    var area = child.value * ratio;
	    return _objectSpread({}, child, {
	      area: (0, _isNaN2["default"])(area) || area <= 0 ? 0 : area
	    });
	  });
	}; // Computes the score for the specified row, as the worst aspect ratio.
	
	
	var getWorstScore = function getWorstScore(row, parentSize, aspectRatio) {
	  var parentArea = parentSize * parentSize;
	  var rowArea = row.area * row.area;
	
	  var _row$reduce = row.reduce(function (result, child) {
	    return {
	      min: Math.min(result.min, child.area),
	      max: Math.max(result.max, child.area)
	    };
	  }, {
	    min: Infinity,
	    max: 0
	  }),
	      min = _row$reduce.min,
	      max = _row$reduce.max;
	
	  return rowArea ? Math.max(parentArea * max * aspectRatio / rowArea, rowArea / (parentArea * min * aspectRatio)) : Infinity;
	};
	
	var horizontalPosition = function horizontalPosition(row, parentSize, parentRect, isFlush) {
	  var rowHeight = parentSize ? Math.round(row.area / parentSize) : 0;
	
	  if (isFlush || rowHeight > parentRect.height) {
	    rowHeight = parentRect.height;
	  }
	
	  var curX = parentRect.x;
	  var child;
	
	  for (var i = 0, len = row.length; i < len; i++) {
	    child = row[i];
	    child.x = curX;
	    child.y = parentRect.y;
	    child.height = rowHeight;
	    child.width = Math.min(rowHeight ? Math.round(child.area / rowHeight) : 0, parentRect.x + parentRect.width - curX);
	    curX += child.width;
	  } // what's z
	
	
	  child.z = true; // add the remain x to the last one of row
	
	  child.width += parentRect.x + parentRect.width - curX;
	  return _objectSpread({}, parentRect, {
	    y: parentRect.y + rowHeight,
	    height: parentRect.height - rowHeight
	  });
	};
	
	var verticalPosition = function verticalPosition(row, parentSize, parentRect, isFlush) {
	  var rowWidth = parentSize ? Math.round(row.area / parentSize) : 0;
	
	  if (isFlush || rowWidth > parentRect.width) {
	    rowWidth = parentRect.width;
	  }
	
	  var curY = parentRect.y;
	  var child;
	
	  for (var i = 0, len = row.length; i < len; i++) {
	    child = row[i];
	    child.x = parentRect.x;
	    child.y = curY;
	    child.width = rowWidth;
	    child.height = Math.min(rowWidth ? Math.round(child.area / rowWidth) : 0, parentRect.y + parentRect.height - curY);
	    curY += child.height;
	  }
	
	  child.z = false;
	  child.height += parentRect.y + parentRect.height - curY;
	  return _objectSpread({}, parentRect, {
	    x: parentRect.x + rowWidth,
	    width: parentRect.width - rowWidth
	  });
	};
	
	var position = function position(row, parentSize, parentRect, isFlush) {
	  if (parentSize === parentRect.width) {
	    return horizontalPosition(row, parentSize, parentRect, isFlush);
	  }
	
	  return verticalPosition(row, parentSize, parentRect, isFlush);
	}; // Recursively arranges the specified node's children into squarified rows.
	
	
	var squarify = function squarify(node, aspectRatio) {
	  var children = node.children;
	
	  if (children && children.length) {
	    var rect = filterRect(node);
	    var row = [];
	    var best = Infinity; // the best row score so far
	
	    var child, score; // the current row score
	
	    var size = Math.min(rect.width, rect.height); // initial orientation
	
	    var scaleChildren = getAreaOfChildren(children, rect.width * rect.height / node.value);
	    var tempChildren = scaleChildren.slice();
	    row.area = 0;
	
	    while (tempChildren.length > 0) {
	      // row first
	      // eslint-disable-next-line prefer-destructuring
	      row.push(child = tempChildren[0]);
	      row.area += child.area;
	      score = getWorstScore(row, size, aspectRatio);
	
	      if (score <= best) {
	        // continue with this orientation
	        tempChildren.shift();
	        best = score;
	      } else {
	        // abort, and try a different orientation
	        row.area -= row.pop().area;
	        rect = position(row, size, rect, false);
	        size = Math.min(rect.width, rect.height);
	        row.length = row.area = 0;
	        best = Infinity;
	      }
	    }
	
	    if (row.length) {
	      rect = position(row, size, rect, true);
	      row.length = row.area = 0;
	    }
	
	    return _objectSpread({}, node, {
	      children: scaleChildren.map(function (c) {
	        return squarify(c, aspectRatio);
	      })
	    });
	  }
	
	  return node;
	};
	
	var Treemap =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Treemap, _PureComponent);
	
	  function Treemap() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Treemap);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Treemap)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = _this.constructor.createDefaultState();
	
	    _this.handleAnimationEnd = function () {
	      var onAnimationEnd = _this.props.onAnimationEnd;
	
	      _this.setState({
	        isAnimationFinished: true
	      });
	
	      if ((0, _isFunction2["default"])(onAnimationEnd)) {
	        onAnimationEnd();
	      }
	    };
	
	    _this.handleAnimationStart = function () {
	      var onAnimationStart = _this.props.onAnimationStart;
	
	      _this.setState({
	        isAnimationFinished: false
	      });
	
	      if ((0, _isFunction2["default"])(onAnimationStart)) {
	        onAnimationStart();
	      }
	    };
	
	    return _this;
	  }
	
	  _createClass(Treemap, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this$props = this.props,
	          type = _this$props.type,
	          width = _this$props.width,
	          height = _this$props.height,
	          data = _this$props.data,
	          dataKey = _this$props.dataKey,
	          aspectRatio = _this$props.aspectRatio;
	
	      var _this$computeRoot = this.computeRoot({
	        type: type,
	        width: width,
	        height: height,
	        data: data,
	        dataKey: dataKey,
	        aspectRatio: aspectRatio
	      }),
	          formatRoot = _this$computeRoot.formatRoot,
	          currentRoot = _this$computeRoot.currentRoot,
	          nestIndex = _this$computeRoot.nestIndex;
	
	      this.setState({
	        formatRoot: formatRoot,
	        currentRoot: currentRoot,
	        nestIndex: nestIndex
	      });
	    }
	  }, {
	    key: "computeRoot",
	    value: function computeRoot(_ref2) {
	      var type = _ref2.type,
	          width = _ref2.width,
	          height = _ref2.height,
	          data = _ref2.data,
	          dataKey = _ref2.dataKey,
	          aspectRatio = _ref2.aspectRatio;
	      var root = computeNode({
	        depth: 0,
	        node: {
	          children: data,
	          x: 0,
	          y: 0,
	          width: width,
	          height: height
	        },
	        index: 0,
	        valueKey: dataKey
	      });
	      var formatRoot = squarify(root, aspectRatio);
	      var nestIndex = this.state.nestIndex;
	
	      if (type === 'nest') {
	        nestIndex.push(root);
	      }
	
	      return {
	        formatRoot: formatRoot,
	        currentRoot: root,
	        nestIndex: nestIndex
	      };
	    } // eslint-disable-next-line camelcase
	
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var type = nextProps.type,
	          width = nextProps.width,
	          height = nextProps.height,
	          data = nextProps.data,
	          dataKey = nextProps.dataKey,
	          aspectRatio = nextProps.aspectRatio;
	
	      if (data !== this.props.data || type !== this.props.type || width !== this.props.width || height !== this.props.height || dataKey !== this.props.dataKey || aspectRatio !== this.props.aspectRatio) {
	        var nextRoot = this.computeRoot({
	          type: type,
	          width: width,
	          height: height,
	          data: data,
	          dataKey: dataKey,
	          aspectRatio: aspectRatio
	        });
	        this.setState(_objectSpread({}, this.constructor.createDefaultState(), {}, nextRoot, {
	          nestIndex: [nextRoot.currentRoot]
	        }));
	      }
	    }
	    /**
	     * Returns default, reset state for the treemap chart.
	     * @return {Object} Whole new state
	     */
	
	  }, {
	    key: "handleMouseEnter",
	    value: function handleMouseEnter(node, e) {
	      var _this$props2 = this.props,
	          onMouseEnter = _this$props2.onMouseEnter,
	          children = _this$props2.children;
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip["default"]);
	
	      if (tooltipItem) {
	        this.setState({
	          isTooltipActive: true,
	          activeNode: node
	        }, function () {
	          if (onMouseEnter) {
	            onMouseEnter(node, e);
	          }
	        });
	      } else if (onMouseEnter) {
	        onMouseEnter(node, e);
	      }
	    }
	  }, {
	    key: "handleMouseLeave",
	    value: function handleMouseLeave(node, e) {
	      var _this$props3 = this.props,
	          onMouseLeave = _this$props3.onMouseLeave,
	          children = _this$props3.children;
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip["default"]);
	
	      if (tooltipItem) {
	        this.setState({
	          isTooltipActive: false,
	          activeNode: null
	        }, function () {
	          if (onMouseLeave) {
	            onMouseLeave(node, e);
	          }
	        });
	      } else if (onMouseLeave) {
	        onMouseLeave(node, e);
	      }
	    }
	  }, {
	    key: "handleClick",
	    value: function handleClick(node) {
	      var _this$props4 = this.props,
	          onClick = _this$props4.onClick,
	          type = _this$props4.type;
	
	      if (type === 'nest' && node.children) {
	        var _this$props5 = this.props,
	            width = _this$props5.width,
	            height = _this$props5.height,
	            dataKey = _this$props5.dataKey,
	            aspectRatio = _this$props5.aspectRatio;
	        var root = computeNode({
	          depth: 0,
	          node: _objectSpread({}, node, {
	            x: 0,
	            y: 0,
	            width: width,
	            height: height
	          }),
	          index: 0,
	          valueKey: dataKey
	        });
	        var formatRoot = squarify(root, aspectRatio);
	        var nestIndex = this.state.nestIndex;
	        nestIndex.push(node);
	        this.setState({
	          formatRoot: formatRoot,
	          currentRoot: root,
	          nestIndex: nestIndex
	        });
	      }
	
	      if (onClick) {
	        onClick(node);
	      }
	    }
	  }, {
	    key: "handleNestIndex",
	    value: function handleNestIndex(node, i) {
	      var nestIndex = this.state.nestIndex;
	      var _this$props6 = this.props,
	          width = _this$props6.width,
	          height = _this$props6.height,
	          dataKey = _this$props6.dataKey,
	          aspectRatio = _this$props6.aspectRatio;
	      var root = computeNode({
	        depth: 0,
	        node: _objectSpread({}, node, {
	          x: 0,
	          y: 0,
	          width: width,
	          height: height
	        }),
	        index: 0,
	        valueKey: dataKey
	      });
	      var formatRoot = squarify(root, aspectRatio);
	      nestIndex = nestIndex.slice(0, i + 1);
	      this.setState({
	        formatRoot: formatRoot,
	        currentRoot: node,
	        nestIndex: nestIndex
	      });
	    }
	  }, {
	    key: "renderItem",
	    value: function renderItem(content, nodeProps, isLeaf) {
	      var _this2 = this;
	
	      var _this$props7 = this.props,
	          isAnimationActive = _this$props7.isAnimationActive,
	          animationBegin = _this$props7.animationBegin,
	          animationDuration = _this$props7.animationDuration,
	          animationEasing = _this$props7.animationEasing,
	          isUpdateAnimationActive = _this$props7.isUpdateAnimationActive,
	          type = _this$props7.type,
	          animationId = _this$props7.animationId,
	          colorPanel = _this$props7.colorPanel;
	      var isAnimationFinished = this.state.isAnimationFinished;
	      var width = nodeProps.width,
	          height = nodeProps.height,
	          x = nodeProps.x,
	          y = nodeProps.y,
	          depth = nodeProps.depth;
	      var translateX = parseInt((Math.random() * 2 - 1) * width, 10);
	      var event = {};
	
	      if (isLeaf || type === 'nest') {
	        event = {
	          onMouseEnter: this.handleMouseEnter.bind(this, nodeProps),
	          onMouseLeave: this.handleMouseLeave.bind(this, nodeProps),
	          onClick: this.handleClick.bind(this, nodeProps)
	        };
	      }
	
	      if (!isAnimationActive) {
	        return _react["default"].createElement(_Layer["default"], event, this.constructor.renderContentItem(content, _objectSpread({}, nodeProps, {
	          isAnimationActive: false,
	          isUpdateAnimationActive: false,
	          width: width,
	          height: height,
	          x: x,
	          y: y
	        }), type, colorPanel));
	      }
	
	      return _react["default"].createElement(_reactSmooth["default"], {
	        begin: animationBegin,
	        duration: animationDuration,
	        isActive: isAnimationActive,
	        easing: animationEasing,
	        key: "treemap-".concat(animationId),
	        from: {
	          x: x,
	          y: y,
	          width: width,
	          height: height
	        },
	        to: {
	          x: x,
	          y: y,
	          width: width,
	          height: height
	        },
	        onAnimationStart: this.handleAnimationStart,
	        onAnimationEnd: this.handleAnimationEnd
	      }, function (_ref3) {
	        var currX = _ref3.x,
	            currY = _ref3.y,
	            currWidth = _ref3.width,
	            currHeight = _ref3.height;
	        return _react["default"].createElement(_reactSmooth["default"], {
	          from: "translate(".concat(translateX, "px, ").concat(translateX, "px)"),
	          to: "translate(0, 0)",
	          attributeName: "transform",
	          begin: animationBegin,
	          easing: animationEasing,
	          isActive: isAnimationActive,
	          duration: animationDuration
	        }, _react["default"].createElement(_Layer["default"], event, function () {
	          // when animation Duration , only render depth=1 nodes
	          if (depth > 2 && !isAnimationFinished) {
	            return null;
	          }
	
	          return _this2.constructor.renderContentItem(content, _objectSpread({}, nodeProps, {
	            isAnimationActive: isAnimationActive,
	            isUpdateAnimationActive: !isUpdateAnimationActive,
	            width: currWidth,
	            height: currHeight,
	            x: currX,
	            y: currY
	          }), type, colorPanel);
	        }()));
	      });
	    }
	  }, {
	    key: "renderNode",
	    value: function renderNode(root, node, i) {
	      var _this3 = this;
	
	      var _this$props8 = this.props,
	          content = _this$props8.content,
	          type = _this$props8.type;
	
	      var nodeProps = _objectSpread({}, (0, _ReactUtils.getPresentationAttributes)(this.props), {}, node, {
	        root: root
	      });
	
	      var isLeaf = !node.children || !node.children.length;
	      var currentRoot = this.state.currentRoot;
	      var isCurrentRootChild = (currentRoot.children || []).filter(function (item) {
	        return item.depth === node.depth && item.name === node.name;
	      });
	
	      if (!isCurrentRootChild.length && root.depth && type === 'nest') {
	        return null;
	      }
	
	      return (// eslint-disable-next-line react/no-array-index-key
	        _react["default"].createElement(_Layer["default"], {
	          key: "recharts-treemap-node-".concat(i),
	          className: "recharts-treemap-depth-".concat(node.depth)
	        }, this.renderItem(content, nodeProps, isLeaf), node.children && node.children.length ? node.children.map(function (child, index) {
	          return _this3.renderNode(node, child, index);
	        }) : null)
	      );
	    }
	  }, {
	    key: "renderAllNodes",
	    value: function renderAllNodes() {
	      var formatRoot = this.state.formatRoot;
	
	      if (!formatRoot) {
	        return null;
	      }
	
	      return this.renderNode(formatRoot, formatRoot, 0);
	    }
	  }, {
	    key: "renderTooltip",
	    value: function renderTooltip() {
	      var _this$props9 = this.props,
	          children = _this$props9.children,
	          nameKey = _this$props9.nameKey;
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip["default"]);
	
	      if (!tooltipItem) {
	        return null;
	      }
	
	      var _this$props10 = this.props,
	          width = _this$props10.width,
	          height = _this$props10.height,
	          dataKey = _this$props10.dataKey;
	      var _this$state = this.state,
	          isTooltipActive = _this$state.isTooltipActive,
	          activeNode = _this$state.activeNode;
	      var viewBox = {
	        x: 0,
	        y: 0,
	        width: width,
	        height: height
	      };
	      var coordinate = activeNode ? {
	        x: activeNode.x + activeNode.width / 2,
	        y: activeNode.y + activeNode.height / 2
	      } : null;
	      var payload = isTooltipActive && activeNode ? [{
	        payload: activeNode,
	        name: (0, _ChartUtils.getValueByDataKey)(activeNode, nameKey, ''),
	        value: (0, _ChartUtils.getValueByDataKey)(activeNode, dataKey)
	      }] : [];
	      return _react["default"].cloneElement(tooltipItem, {
	        viewBox: viewBox,
	        active: isTooltipActive,
	        coordinate: coordinate,
	        label: '',
	        payload: payload
	      });
	    } // render nest treemap
	
	  }, {
	    key: "renderNestIndex",
	    value: function renderNestIndex() {
	      var _this4 = this;
	
	      var _this$props11 = this.props,
	          nameKey = _this$props11.nameKey,
	          nestIndexContent = _this$props11.nestIndexContent;
	      var nestIndex = this.state.nestIndex;
	      return _react["default"].createElement("div", {
	        className: "recharts-treemap-nest-index-wrapper",
	        style: {
	          marginTop: '8px',
	          textAlign: 'center'
	        }
	      }, nestIndex.map(function (item, i) {
	        var name = (0, _get2["default"])(item, nameKey, 'root');
	        var content = null;
	
	        if (_react["default"].isValidElement(nestIndexContent)) {
	          content = _react["default"].cloneElement(nestIndexContent, item, i);
	        }
	
	        if ((0, _isFunction2["default"])(nestIndexContent)) {
	          content = nestIndexContent(item, i);
	        } else {
	          content = name;
	        }
	
	        return (// eslint-disable-next-line jsx-a11y/click-events-have-key-events
	          _react["default"].createElement("div", {
	            onClick: _this4.handleNestIndex.bind(_this4, item, i),
	            key: "nest-index-".concat((0, _DataUtils.uniqueId)()),
	            className: "recharts-treemap-nest-index-box",
	            style: {
	              cursor: 'pointer',
	              display: 'inline-block',
	              padding: '0 7px',
	              background: '#000',
	              color: '#fff',
	              marginRight: '3px'
	            }
	          }, content)
	        );
	      }));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      if (!(0, _ReactUtils.validateWidthHeight)(this)) {
	        return null;
	      }
	
	      var _this$props12 = this.props,
	          width = _this$props12.width,
	          height = _this$props12.height,
	          className = _this$props12.className,
	          style = _this$props12.style,
	          children = _this$props12.children,
	          type = _this$props12.type,
	          others = _objectWithoutProperties(_this$props12, ["width", "height", "className", "style", "children", "type"]);
	
	      var attrs = (0, _ReactUtils.getPresentationAttributes)(others);
	      return _react["default"].createElement("div", {
	        className: (0, _classnames["default"])('recharts-wrapper', className),
	        style: _objectSpread({}, style, {
	          position: 'relative',
	          cursor: 'default',
	          width: width,
	          height: height
	        })
	      }, _react["default"].createElement(_Surface["default"], _extends({}, attrs, {
	        width: width,
	        height: type === 'nest' ? height - 30 : height
	      }), this.renderAllNodes(), (0, _ReactUtils.filterSvgElements)(children)), this.renderTooltip(), type === 'nest' && this.renderNestIndex());
	    }
	  }], [{
	    key: "createDefaultState",
	    value: function createDefaultState() {
	      return {
	        isTooltipActive: false,
	        isAnimationFinished: false,
	        activeNode: null,
	        currentRoot: null,
	        formatRoot: null,
	        nestIndex: []
	      };
	    }
	  }, {
	    key: "renderContentItem",
	    value: function renderContentItem(content, nodeProps, type, colorPanel) {
	      if (_react["default"].isValidElement(content)) {
	        return _react["default"].cloneElement(content, nodeProps);
	      }
	
	      if ((0, _isFunction2["default"])(content)) {
	        return content(nodeProps);
	      } // optimize default shape
	
	
	      var x = nodeProps.x,
	          y = nodeProps.y,
	          width = nodeProps.width,
	          height = nodeProps.height,
	          index = nodeProps.index;
	      var arrow = null;
	
	      if (width > 10 && height > 10 && nodeProps.children && type === 'nest') {
	        arrow = _react["default"].createElement(_Polygon["default"], {
	          points: [{
	            x: x + 2,
	            y: y + height / 2
	          }, {
	            x: x + 6,
	            y: y + height / 2 + 3
	          }, {
	            x: x + 2,
	            y: y + height / 2 + 6
	          }]
	        });
	      }
	
	      var text = null;
	      var nameSize = (0, _DOMUtils.getStringSize)(nodeProps.name);
	
	      if (width > 20 && height > 20 && nameSize.width < width && nameSize.height < height) {
	        text = _react["default"].createElement("text", {
	          x: x + 8,
	          y: y + height / 2 + 7,
	          fontSize: 14
	        }, nodeProps.name);
	      }
	
	      var colors = colorPanel || _Constants.COLOR_PANEL;
	      return _react["default"].createElement("g", null, _react["default"].createElement(_Rectangle["default"], _extends({
	        fill: nodeProps.depth < 2 ? colors[index % colors.length] : 'rgba(255,255,255,0)',
	        stroke: "#fff"
	      }, (0, _omit2["default"])(nodeProps, 'children'))), arrow, text);
	    }
	  }]);
	
	  return Treemap;
	}(_react.PureComponent);
	
	Treemap.displayName = 'Treemap';
	Treemap.propTypes = {
	  width: _propTypes["default"].number,
	  height: _propTypes["default"].number,
	  data: _propTypes["default"].array,
	  animationId: _propTypes["default"].number,
	  style: _propTypes["default"].object,
	  aspectRatio: _propTypes["default"].number,
	  content: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].func]),
	  fill: _propTypes["default"].string,
	  stroke: _propTypes["default"].string,
	  className: _propTypes["default"].string,
	  nameKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func]),
	  dataKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func]),
	  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),
	  // optional values flat/nest, flat show whole treemap, nest only show depth=1 node
	  type: _propTypes["default"].oneOf(['flat', 'nest']),
	  colorPanel: _propTypes["default"].array,
	  // customize nest index content
	  nestIndexContent: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].func]),
	  onAnimationStart: _propTypes["default"].func,
	  onAnimationEnd: _propTypes["default"].func,
	  onMouseEnter: _propTypes["default"].func,
	  onMouseLeave: _propTypes["default"].func,
	  onClick: _propTypes["default"].func,
	  isAnimationActive: _propTypes["default"].bool,
	  isUpdateAnimationActive: _propTypes["default"].bool,
	  animationBegin: _propTypes["default"].number,
	  animationDuration: _propTypes["default"].number,
	  animationEasing: _propTypes["default"].oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
	};
	Treemap.defaultProps = {
	  dataKey: 'value',
	  aspectRatio: 0.5 * (1 + Math.sqrt(5)),
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  isUpdateAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'linear',
	  type: 'flat'
	};
	var _default = Treemap;
	exports["default"] = _default;

/***/ },
/* 2426 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = Customized;
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(38));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _Layer = _interopRequireDefault(__webpack_require__(49));
	
	var _LogUtils = __webpack_require__(191);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	/**
	 * custom svg elements by rechart instance props and state.
	 * @returns {Object}   svg elements
	 */
	function Customized(_ref) {
	  var component = _ref.component,
	      props = _objectWithoutProperties(_ref, ["component"]);
	
	  var child;
	
	  if ((0, _react.isValidElement)(component)) {
	    child = (0, _react.cloneElement)(component, props);
	  } else if ((0, _isFunction2["default"])(component)) {
	    child = component(props);
	  } else {
	    (0, _LogUtils.warn)(false, 'Customized\'s props `component` must be React.element or Function, but got %s.', _typeof(component));
	  }
	
	  return _react["default"].createElement(_Layer["default"], {
	    className: "recharts-customized-wrapper"
	  }, child);
	}
	
	Customized.displayName = 'Customized';
	Customized.propTypes = {
	  component: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].func]).isRequired
	};

/***/ },
/* 2427 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _Surface = _interopRequireDefault(__webpack_require__(231));
	
	var _Symbols = _interopRequireDefault(__webpack_require__(478));
	
	var _ReactUtils = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var SIZE = 32;
	
	var ICON_TYPES = _ReactUtils.LEGEND_TYPES.filter(function (type) {
	  return type !== 'none';
	});
	
	var DefaultLegendContent =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(DefaultLegendContent, _PureComponent);
	
	  function DefaultLegendContent() {
	    _classCallCheck(this, DefaultLegendContent);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(DefaultLegendContent).apply(this, arguments));
	  }
	
	  _createClass(DefaultLegendContent, [{
	    key: "renderIcon",
	
	    /**
	     * Render the path of icon
	     * @param {Object} data Data of each legend item
	     * @return {String} Path element
	     */
	    value: function renderIcon(data) {
	      var inactiveColor = this.props.inactiveColor;
	      var halfSize = SIZE / 2;
	      var sixthSize = SIZE / 6;
	      var thirdSize = SIZE / 3;
	      var color = data.inactive ? inactiveColor : data.color;
	
	      if (data.type === 'plainline') {
	        return _react["default"].createElement("line", {
	          strokeWidth: 4,
	          fill: "none",
	          stroke: color,
	          strokeDasharray: data.payload.strokeDasharray,
	          x1: 0,
	          y1: halfSize,
	          x2: SIZE,
	          y2: halfSize,
	          className: "recharts-legend-icon"
	        });
	      }
	
	      if (data.type === 'line') {
	        return _react["default"].createElement("path", {
	          strokeWidth: 4,
	          fill: "none",
	          stroke: color,
	          d: "M0,".concat(halfSize, "h").concat(thirdSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(2 * thirdSize, ",").concat(halfSize, "\n            H").concat(SIZE, "M").concat(2 * thirdSize, ",").concat(halfSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(thirdSize, ",").concat(halfSize),
	          className: "recharts-legend-icon"
	        });
	      }
	
	      if (data.type === 'rect') {
	        return _react["default"].createElement("path", {
	          stroke: "none",
	          fill: color,
	          d: "M0,".concat(SIZE / 8, "h").concat(SIZE, "v").concat(SIZE * 3 / 4, "h").concat(-SIZE, "z"),
	          className: "recharts-legend-icon"
	        });
	      }
	
	      return _react["default"].createElement(_Symbols["default"], {
	        fill: color,
	        cx: halfSize,
	        cy: halfSize,
	        size: SIZE,
	        sizeType: "diameter",
	        type: data.type
	      });
	    }
	    /**
	     * Draw items of legend
	     * @return {ReactElement} Items
	     */
	
	  }, {
	    key: "renderItems",
	    value: function renderItems() {
	      var _this = this;
	
	      var _this$props = this.props,
	          payload = _this$props.payload,
	          iconSize = _this$props.iconSize,
	          layout = _this$props.layout,
	          formatter = _this$props.formatter;
	      var viewBox = {
	        x: 0,
	        y: 0,
	        width: SIZE,
	        height: SIZE
	      };
	      var itemStyle = {
	        display: layout === 'horizontal' ? 'inline-block' : 'block',
	        marginRight: 10
	      };
	      var svgStyle = {
	        display: 'inline-block',
	        verticalAlign: 'middle',
	        marginRight: 4
	      };
	      return payload.map(function (entry, i) {
	        var _classNames;
	
	        var finalFormatter = entry.formatter || formatter;
	        var className = (0, _classnames["default"])((_classNames = {
	          'recharts-legend-item': true
	        }, _defineProperty(_classNames, "legend-item-".concat(i), true), _defineProperty(_classNames, "inactive", entry.inactive), _classNames));
	
	        if (entry.type === 'none') {
	          return null;
	        }
	
	        return _react["default"].createElement("li", _extends({
	          className: className,
	          style: itemStyle,
	          key: "legend-item-".concat(i) // eslint-disable-line react/no-array-index-key
	
	        }, (0, _ReactUtils.filterEventsOfChild)(_this.props, entry, i)), _react["default"].createElement(_Surface["default"], {
	          width: iconSize,
	          height: iconSize,
	          viewBox: viewBox,
	          style: svgStyle
	        }, _this.renderIcon(entry)), _react["default"].createElement("span", {
	          className: "recharts-legend-item-text"
	        }, finalFormatter ? finalFormatter(entry.value, entry, i) : entry.value));
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          payload = _this$props2.payload,
	          layout = _this$props2.layout,
	          align = _this$props2.align;
	
	      if (!payload || !payload.length) {
	        return null;
	      }
	
	      var finalStyle = {
	        padding: 0,
	        margin: 0,
	        textAlign: layout === 'horizontal' ? align : 'left'
	      };
	      return _react["default"].createElement("ul", {
	        className: "recharts-default-legend",
	        style: finalStyle
	      }, this.renderItems());
	    }
	  }]);
	
	  return DefaultLegendContent;
	}(_react.PureComponent);
	
	DefaultLegendContent.displayName = 'Legend';
	DefaultLegendContent.propTypes = {
	  content: _propTypes["default"].element,
	  iconSize: _propTypes["default"].number,
	  iconType: _propTypes["default"].oneOf(ICON_TYPES),
	  layout: _propTypes["default"].oneOf(['horizontal', 'vertical']),
	  align: _propTypes["default"].oneOf(['center', 'left', 'right']),
	  verticalAlign: _propTypes["default"].oneOf(['top', 'bottom', 'middle']),
	  payload: _propTypes["default"].arrayOf(_propTypes["default"].shape({
	    value: _propTypes["default"].any,
	    id: _propTypes["default"].any,
	    type: _propTypes["default"].oneOf(_ReactUtils.LEGEND_TYPES)
	  })),
	  inactiveColor: _propTypes["default"].string,
	  formatter: _propTypes["default"].func,
	  onMouseEnter: _propTypes["default"].func,
	  onMouseLeave: _propTypes["default"].func,
	  onClick: _propTypes["default"].func
	};
	DefaultLegendContent.defaultProps = {
	  iconSize: 14,
	  layout: 'horizontal',
	  align: 'center',
	  verticalAlign: 'middle',
	  inactiveColor: '#ccc'
	};
	var _default = DefaultLegendContent;
	exports["default"] = _default;

/***/ },
/* 2428 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _sortBy2 = _interopRequireDefault(__webpack_require__(455));
	
	var _isArray2 = _interopRequireDefault(__webpack_require__(43));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _DataUtils = __webpack_require__(39);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var defaultFormatter = function defaultFormatter(value) {
	  return (0, _isArray2["default"])(value) && (0, _DataUtils.isNumOrStr)(value[0]) && (0, _DataUtils.isNumOrStr)(value[1]) ? value.join(' ~ ') : value;
	};
	
	var DefaultTooltipContent =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(DefaultTooltipContent, _PureComponent);
	
	  function DefaultTooltipContent() {
	    _classCallCheck(this, DefaultTooltipContent);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(DefaultTooltipContent).apply(this, arguments));
	  }
	
	  _createClass(DefaultTooltipContent, [{
	    key: "renderContent",
	    value: function renderContent() {
	      var _this$props = this.props,
	          payload = _this$props.payload,
	          separator = _this$props.separator,
	          formatter = _this$props.formatter,
	          itemStyle = _this$props.itemStyle,
	          itemSorter = _this$props.itemSorter;
	
	      if (payload && payload.length) {
	        var listStyle = {
	          padding: 0,
	          margin: 0
	        };
	        var items = (itemSorter ? (0, _sortBy2["default"])(payload, itemSorter) : payload).map(function (entry, i) {
	          if (entry.type === 'none') {
	            return null;
	          }
	
	          var finalItemStyle = _objectSpread({
	            display: 'block',
	            paddingTop: 4,
	            paddingBottom: 4,
	            color: entry.color || '#000'
	          }, itemStyle);
	
	          var finalFormatter = entry.formatter || formatter || defaultFormatter;
	          var name = entry.name,
	              value = entry.value;
	
	          if (finalFormatter) {
	            var formatted = finalFormatter(value, name, entry, i);
	
	            if (Array.isArray(formatted)) {
	              var _formatted = _slicedToArray(formatted, 2);
	
	              value = _formatted[0];
	              name = _formatted[1];
	            } else {
	              value = formatted;
	            }
	          }
	
	          return (// eslint-disable-next-line react/no-array-index-key
	            _react["default"].createElement("li", {
	              className: "recharts-tooltip-item",
	              key: "tooltip-item-".concat(i),
	              style: finalItemStyle
	            }, (0, _DataUtils.isNumOrStr)(name) ? _react["default"].createElement("span", {
	              className: "recharts-tooltip-item-name"
	            }, name) : null, (0, _DataUtils.isNumOrStr)(name) ? _react["default"].createElement("span", {
	              className: "recharts-tooltip-item-separator"
	            }, separator) : null, _react["default"].createElement("span", {
	              className: "recharts-tooltip-item-value"
	            }, value), _react["default"].createElement("span", {
	              className: "recharts-tooltip-item-unit"
	            }, entry.unit || ''))
	          );
	        });
	        return _react["default"].createElement("ul", {
	          className: "recharts-tooltip-item-list",
	          style: listStyle
	        }, items);
	      }
	
	      return null;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          wrapperClassName = _this$props2.wrapperClassName,
	          contentStyle = _this$props2.contentStyle,
	          labelClassName = _this$props2.labelClassName,
	          labelStyle = _this$props2.labelStyle,
	          label = _this$props2.label,
	          labelFormatter = _this$props2.labelFormatter;
	
	      var finalStyle = _objectSpread({
	        margin: 0,
	        padding: 10,
	        backgroundColor: '#fff',
	        border: '1px solid #ccc',
	        whiteSpace: 'nowrap'
	      }, contentStyle);
	
	      var finalLabelStyle = _objectSpread({
	        margin: 0
	      }, labelStyle);
	
	      var hasLabel = (0, _DataUtils.isNumOrStr)(label);
	      var finalLabel = hasLabel ? label : '';
	      var wrapperCN = (0, _classnames["default"])('recharts-default-tooltip', wrapperClassName);
	      var labelCN = (0, _classnames["default"])('recharts-tooltip-label', labelClassName);
	
	      if (hasLabel && labelFormatter) {
	        finalLabel = labelFormatter(label);
	      }
	
	      return _react["default"].createElement("div", {
	        className: wrapperCN,
	        style: finalStyle
	      }, _react["default"].createElement("p", {
	        className: labelCN,
	        style: finalLabelStyle
	      }, finalLabel), this.renderContent());
	    }
	  }]);
	
	  return DefaultTooltipContent;
	}(_react.PureComponent);
	
	DefaultTooltipContent.displayName = 'DefaultTooltipContent';
	DefaultTooltipContent.propTypes = {
	  separator: _propTypes["default"].string,
	  wrapperClassName: _propTypes["default"].string,
	  labelClassName: _propTypes["default"].string,
	  formatter: _propTypes["default"].func,
	  contentStyle: _propTypes["default"].object,
	  itemStyle: _propTypes["default"].object,
	  labelStyle: _propTypes["default"].object,
	  labelFormatter: _propTypes["default"].func,
	  label: _propTypes["default"].any,
	  payload: _propTypes["default"].arrayOf(_propTypes["default"].shape({
	    name: _propTypes["default"].any,
	    value: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string, _propTypes["default"].array]),
	    unit: _propTypes["default"].any
	  })),
	  itemSorter: _propTypes["default"].func
	};
	DefaultTooltipContent.defaultProps = {
	  separator: ' : ',
	  contentStyle: {},
	  itemStyle: {},
	  labelStyle: {}
	};
	var _default = DefaultTooltipContent;
	exports["default"] = _default;

/***/ },
/* 2429 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _debounce2 = _interopRequireDefault(__webpack_require__(450));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _reactResizeDetector = _interopRequireDefault(__webpack_require__(2318));
	
	var _DataUtils = __webpack_require__(39);
	
	var _LogUtils = __webpack_require__(191);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var ResponsiveContainer =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(ResponsiveContainer, _Component);
	
	  function ResponsiveContainer(props) {
	    var _this;
	
	    _classCallCheck(this, ResponsiveContainer);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(ResponsiveContainer).call(this, props));
	
	    _this.updateDimensionsImmediate = function () {
	      if (!_this.mounted) {
	        return;
	      }
	
	      var newSize = _this.getContainerSize();
	
	      if (newSize) {
	        var _this$state = _this.state,
	            oldWidth = _this$state.containerWidth,
	            oldHeight = _this$state.containerHeight;
	        var containerWidth = newSize.containerWidth,
	            containerHeight = newSize.containerHeight;
	
	        if (containerWidth !== oldWidth || containerHeight !== oldHeight) {
	          _this.setState({
	            containerWidth: containerWidth,
	            containerHeight: containerHeight
	          });
	        }
	      }
	    };
	
	    _this.state = {
	      containerWidth: -1,
	      containerHeight: -1
	    };
	    _this.handleResize = props.debounce > 0 ? (0, _debounce2["default"])(_this.updateDimensionsImmediate, props.debounce) : _this.updateDimensionsImmediate;
	    return _this;
	  }
	  /* eslint-disable  react/no-did-mount-set-state */
	
	
	  _createClass(ResponsiveContainer, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.mounted = true;
	      var size = this.getContainerSize();
	
	      if (size) {
	        this.setState(size);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.mounted = false;
	    }
	  }, {
	    key: "getContainerSize",
	    value: function getContainerSize() {
	      if (!this.container) {
	        return null;
	      }
	
	      return {
	        containerWidth: this.container.clientWidth,
	        containerHeight: this.container.clientHeight
	      };
	    }
	  }, {
	    key: "renderChart",
	    value: function renderChart() {
	      var _this$state2 = this.state,
	          containerWidth = _this$state2.containerWidth,
	          containerHeight = _this$state2.containerHeight;
	
	      if (containerWidth < 0 || containerHeight < 0) {
	        return null;
	      }
	
	      var _this$props = this.props,
	          aspect = _this$props.aspect,
	          width = _this$props.width,
	          height = _this$props.height,
	          minWidth = _this$props.minWidth,
	          minHeight = _this$props.minHeight,
	          maxHeight = _this$props.maxHeight,
	          children = _this$props.children;
	      (0, _LogUtils.warn)((0, _DataUtils.isPercent)(width) || (0, _DataUtils.isPercent)(height), "The width(%s) and height(%s) are both fixed numbers,\n       maybe you don't need to use a ResponsiveContainer.", width, height);
	      (0, _LogUtils.warn)(!aspect || aspect > 0, 'The aspect(%s) must be greater than zero.', aspect);
	      var calculatedWidth = (0, _DataUtils.isPercent)(width) ? containerWidth : width;
	      var calculatedHeight = (0, _DataUtils.isPercent)(height) ? containerHeight : height;
	
	      if (aspect && aspect > 0) {
	        // Preserve the desired aspect ratio
	        if (calculatedWidth) {
	          // Will default to using width for aspect ratio
	          calculatedHeight = calculatedWidth / aspect;
	        } else if (calculatedHeight) {
	          // But we should also take height into consideration
	          calculatedWidth = calculatedHeight * aspect;
	        } // if maxHeight is set, overwrite if calculatedHeight is greater than maxHeight
	
	
	        if (maxHeight && calculatedHeight > maxHeight) {
	          calculatedHeight = maxHeight;
	        }
	      }
	
	      (0, _LogUtils.warn)(calculatedWidth > 0 || calculatedHeight > 0, "The width(%s) and height(%s) of chart should be greater than 0,\n       please check the style of container, or the props width(%s) and height(%s),\n       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the\n       height and width.", calculatedWidth, calculatedHeight, width, height, minWidth, minHeight, aspect);
	      return _react["default"].cloneElement(children, {
	        width: calculatedWidth,
	        height: calculatedHeight
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _this$props2 = this.props,
	          minWidth = _this$props2.minWidth,
	          minHeight = _this$props2.minHeight,
	          width = _this$props2.width,
	          height = _this$props2.height,
	          maxHeight = _this$props2.maxHeight,
	          id = _this$props2.id,
	          className = _this$props2.className;
	      var style = {
	        width: width,
	        height: height,
	        minWidth: minWidth,
	        minHeight: minHeight,
	        maxHeight: maxHeight
	      };
	      return _react["default"].createElement("div", {
	        id: id,
	        className: (0, _classnames["default"])('recharts-responsive-container', className),
	        style: style,
	        ref: function ref(node) {
	          _this2.container = node;
	        }
	      }, this.renderChart(), _react["default"].createElement(_reactResizeDetector["default"], {
	        handleWidth: true,
	        handleHeight: true,
	        onResize: this.handleResize
	      }));
	    }
	  }]);
	
	  return ResponsiveContainer;
	}(_react.Component);
	
	ResponsiveContainer.displayName = 'ResponsiveContainer';
	ResponsiveContainer.propTypes = {
	  aspect: _propTypes["default"].number,
	  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  height: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  minHeight: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  minWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  maxHeight: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  children: _propTypes["default"].node.isRequired,
	  debounce: _propTypes["default"].number,
	  id: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  className: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
	};
	ResponsiveContainer.defaultProps = {
	  width: '100%',
	  height: '100%',
	  debounce: 0
	};
	var _default = ResponsiveContainer;
	exports["default"] = _default;

/***/ },
/* 2430 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _PolarUtils = __webpack_require__(86);
	
	var _ReactUtils = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var PolarGrid =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(PolarGrid, _PureComponent);
	
	  function PolarGrid() {
	    _classCallCheck(this, PolarGrid);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(PolarGrid).apply(this, arguments));
	  }
	
	  _createClass(PolarGrid, [{
	    key: "getPolygonPath",
	    value: function getPolygonPath(radius) {
	      var _this$props = this.props,
	          cx = _this$props.cx,
	          cy = _this$props.cy,
	          polarAngles = _this$props.polarAngles;
	      var path = '';
	      polarAngles.forEach(function (angle, i) {
	        var point = (0, _PolarUtils.polarToCartesian)(cx, cy, radius, angle);
	
	        if (i) {
	          path += "L ".concat(point.x, ",").concat(point.y);
	        } else {
	          path += "M ".concat(point.x, ",").concat(point.y);
	        }
	      });
	      path += 'Z';
	      return path;
	    }
	    /**
	     * Draw axis of radial line
	     * @return {[type]} The lines
	     */
	
	  }, {
	    key: "renderPolarAngles",
	    value: function renderPolarAngles() {
	      var _this$props2 = this.props,
	          cx = _this$props2.cx,
	          cy = _this$props2.cy,
	          innerRadius = _this$props2.innerRadius,
	          outerRadius = _this$props2.outerRadius,
	          polarAngles = _this$props2.polarAngles;
	
	      if (!polarAngles || !polarAngles.length) {
	        return null;
	      }
	
	      var props = _objectSpread({
	        stroke: '#ccc'
	      }, (0, _ReactUtils.getPresentationAttributes)(this.props));
	
	      return _react["default"].createElement("g", {
	        className: "recharts-polar-grid-angle"
	      }, polarAngles.map(function (entry, i) {
	        var start = (0, _PolarUtils.polarToCartesian)(cx, cy, innerRadius, entry);
	        var end = (0, _PolarUtils.polarToCartesian)(cx, cy, outerRadius, entry);
	        return _react["default"].createElement("line", _extends({}, props, {
	          key: "line-".concat(i) // eslint-disable-line react/no-array-index-key
	          ,
	          x1: start.x,
	          y1: start.y,
	          x2: end.x,
	          y2: end.y
	        }));
	      }));
	    }
	    /**
	     * Draw concentric circles
	     * @param {Number} radius The radius of circle
	     * @param {Number} index  The index of circle
	     * @param {Object} extraProps Extra props
	     * @return {ReactElement} circle
	     */
	
	  }, {
	    key: "renderConcentricCircle",
	    value: function renderConcentricCircle(radius, index, extraProps) {
	      var _this$props3 = this.props,
	          cx = _this$props3.cx,
	          cy = _this$props3.cy;
	
	      var props = _objectSpread({
	        stroke: '#ccc'
	      }, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	        fill: 'none'
	      }, extraProps);
	
	      return _react["default"].createElement("circle", _extends({}, props, {
	        className: "recharts-polar-grid-concentric-circle",
	        key: "circle-".concat(index),
	        cx: cx,
	        cy: cy,
	        r: radius
	      }));
	    }
	    /**
	     * Draw concentric polygons
	     * @param {Number} radius     The radius of polygon
	     * @param {Number} index      The index of polygon
	     * @param {Object} extraProps Extra props
	     * @return {ReactElement} polygon
	     */
	
	  }, {
	    key: "renderConcentricPolygon",
	    value: function renderConcentricPolygon(radius, index, extraProps) {
	      var props = _objectSpread({
	        stroke: '#ccc'
	      }, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	        fill: 'none'
	      }, extraProps);
	
	      return _react["default"].createElement("path", _extends({}, props, {
	        className: "recharts-polar-grid-concentric-polygon",
	        key: "path-".concat(index),
	        d: this.getPolygonPath(radius)
	      }));
	    }
	    /**
	     * Draw concentric axis
	     * @return {ReactElement} Concentric axis
	     * @todo Optimize the name
	     */
	
	  }, {
	    key: "renderConcentricPath",
	    value: function renderConcentricPath() {
	      var _this = this;
	
	      var _this$props4 = this.props,
	          polarRadius = _this$props4.polarRadius,
	          gridType = _this$props4.gridType;
	
	      if (!polarRadius || !polarRadius.length) {
	        return null;
	      }
	
	      return _react["default"].createElement("g", {
	        className: "recharts-polar-grid-concentric"
	      }, polarRadius.map(function (entry, i) {
	        return gridType === 'circle' ? _this.renderConcentricCircle(entry, i) : _this.renderConcentricPolygon(entry, i);
	      }));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var outerRadius = this.props.outerRadius;
	
	      if (outerRadius <= 0) {
	        return null;
	      }
	
	      return _react["default"].createElement("g", {
	        className: "recharts-polar-grid"
	      }, this.renderPolarAngles(), this.renderConcentricPath());
	    }
	  }]);
	
	  return PolarGrid;
	}(_react.PureComponent);
	
	PolarGrid.displayName = 'PolarGrid';
	PolarGrid.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  cx: _propTypes["default"].number,
	  cy: _propTypes["default"].number,
	  innerRadius: _propTypes["default"].number,
	  outerRadius: _propTypes["default"].number,
	  polarAngles: _propTypes["default"].arrayOf(_propTypes["default"].number),
	  polarRadius: _propTypes["default"].arrayOf(_propTypes["default"].number),
	  gridType: _propTypes["default"].oneOf(['polygon', 'circle'])
	});
	PolarGrid.defaultProps = {
	  cx: 0,
	  cy: 0,
	  innerRadius: 0,
	  outerRadius: 0,
	  gridType: 'polygon'
	};
	var _default = PolarGrid;
	exports["default"] = _default;

/***/ },
/* 2431 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(1208);
	
	__webpack_require__(1209);
	
	/* eslint no-proto: 0 */
	var testObject = {};
	
	if (!(Object.setPrototypeOf || testObject.__proto__)) {
	  var nativeGetPrototypeOf = Object.getPrototypeOf;
	
	  Object.getPrototypeOf = function (object) {
	    if (object.__proto__) {
	      return object.__proto__;
	    }
	
	    return nativeGetPrototypeOf.call(Object, object);
	  };
	}

/***/ },
/* 2432 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.COLOR_PANEL = void 0;
	var COLOR_PANEL = ['#1890FF', '#66B5FF', '#41D9C7', '#2FC25B', '#6EDB8F', '#9AE65C', '#FACC14', '#E6965C', '#57AD71', '#223273', '#738AE6', '#7564CC', '#8543E0', '#A877ED', '#5C8EE6', '#13C2C2', '#70E0E0', '#5CA3E6', '#3436C7', '#8082FF', '#DD81E6', '#F04864', '#FA7D92', '#D598D9'];
	exports.COLOR_PANEL = COLOR_PANEL;

/***/ },
/* 2433 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.generatePrefixStyle = void 0;
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var PREFIX_LIST = ['Webkit', 'Moz', 'O', 'ms'];
	
	var generatePrefixStyle = function generatePrefixStyle(name, value) {
	  if (!name) {
	    return null;
	  }
	
	  var camelName = name.replace(/(\w)/, function (v) {
	    return v.toUpperCase();
	  });
	  var result = PREFIX_LIST.reduce(function (res, entry) {
	    return _objectSpread({}, res, _defineProperty({}, entry + camelName, value));
	  }, {});
	  result[name] = value;
	  return result;
	};
	
	exports.generatePrefixStyle = generatePrefixStyle;

/***/ },
/* 2434 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.detectReferenceElementsDomain = void 0;
	
	var _ReferenceDot = _interopRequireDefault(__webpack_require__(985));
	
	var _ReferenceLine = _interopRequireDefault(__webpack_require__(986));
	
	var _ReferenceArea = _interopRequireDefault(__webpack_require__(984));
	
	var _IfOverflowMatches = __webpack_require__(313);
	
	var _ReactUtils = __webpack_require__(29);
	
	var _DataUtils = __webpack_require__(39);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var detectReferenceElementsDomain = function detectReferenceElementsDomain(children, domain, axisId, axisType, specifiedTicks) {
	  var lines = (0, _ReactUtils.findAllByType)(children, _ReferenceLine["default"]);
	  var dots = (0, _ReactUtils.findAllByType)(children, _ReferenceDot["default"]);
	  var elements = lines.concat(dots);
	  var areas = (0, _ReactUtils.findAllByType)(children, _ReferenceArea["default"]);
	  var idKey = "".concat(axisType, "Id");
	  var valueKey = axisType[0];
	  var finalDomain = domain;
	
	  if (elements.length) {
	    finalDomain = elements.reduce(function (result, el) {
	      if (el.props[idKey] === axisId && (0, _IfOverflowMatches.ifOverflowMatches)(el.props, 'extendDomain') && (0, _DataUtils.isNumber)(el.props[valueKey])) {
	        var value = el.props[valueKey];
	        return [Math.min(result[0], value), Math.max(result[1], value)];
	      }
	
	      return result;
	    }, finalDomain);
	  }
	
	  if (areas.length) {
	    var key1 = "".concat(valueKey, "1");
	    var key2 = "".concat(valueKey, "2");
	    finalDomain = areas.reduce(function (result, el) {
	      if (el.props[idKey] === axisId && (0, _IfOverflowMatches.ifOverflowMatches)(el.props, 'extendDomain') && (0, _DataUtils.isNumber)(el.props[key1]) && (0, _DataUtils.isNumber)(el.props[key2])) {
	        var value1 = el.props[key1];
	        var value2 = el.props[key2];
	        return [Math.min(result[0], value1, value2), Math.max(result[1], value1, value2)];
	      }
	
	      return result;
	    }, finalDomain);
	  }
	
	  if (specifiedTicks && specifiedTicks.length) {
	    finalDomain = specifiedTicks.reduce(function (result, tick) {
	      if ((0, _DataUtils.isNumber)(tick)) {
	        return [Math.min(result[0], tick), Math.max(result[1], tick)];
	      }
	
	      return result;
	    }, finalDomain);
	  }
	
	  return finalDomain;
	};
	
	exports.detectReferenceElementsDomain = detectReferenceElementsDomain;

/***/ },
/* 2435 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SYNC_EVENT = exports.eventCenter = void 0;
	
	var _events = _interopRequireDefault(__webpack_require__(687));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var eventCenter = new _events["default"]();
	exports.eventCenter = eventCenter;
	
	if (eventCenter.setMaxListeners) {
	  eventCenter.setMaxListeners(10);
	}
	
	var SYNC_EVENT = 'recharts.syncMouseEvents';
	exports.SYNC_EVENT = SYNC_EVENT;

/***/ },
/* 2436 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies
	 */
	var balanced = __webpack_require__(2437)
	var reduceFunctionCall = __webpack_require__(2438)
	var mexp = __webpack_require__(2185)
	
	/**
	 * Constantes
	 */
	var MAX_STACK = 100 // should be enough for a single calc()...
	var NESTED_CALC_RE = /(\+|\-|\*|\\|[^a-z]|)(\s*)(\()/g
	
	/**
	 * Global variables
	 */
	var stack
	
	/**
	 * Expose reduceCSSCalc plugin
	 *
	 * @type {Function}
	 */
	module.exports = reduceCSSCalc
	
	/**
	 * Reduce CSS calc() in a string, whenever it's possible
	 *
	 * @param {String} value css input
	 */
	function reduceCSSCalc(value, decimalPrecision) {
	  stack = 0
	  decimalPrecision = Math.pow(10, decimalPrecision === undefined ? 5 : decimalPrecision)
	
	  // Allow calc() on multiple lines
	  value = value.replace(/\n+/g, " ")
	
	  /**
	   * Evaluates an expression
	   *
	   * @param {String} expression
	   * @returns {String}
	   */
	  function evaluateExpression (expression, functionIdentifier, call) {
	    if (stack++ > MAX_STACK) {
	      stack = 0
	      throw new Error("Call stack overflow for " + call)
	    }
	
	    if (expression === "") {
	      throw new Error(functionIdentifier + "(): '" + call + "' must contain a non-whitespace string")
	    }
	
	    expression = evaluateNestedExpression(expression, call)
	
	    var units = getUnitsInExpression(expression)
	
	    // If the expression contains multiple units or CSS variables,
	    // then let the expression be (i.e. browser calc())
	    if (units.length > 1 || expression.indexOf("var(") > -1) {
	      return functionIdentifier + "(" + expression + ")"
	    }
	
	    var unit = units[0] || ""
	
	    if (unit === "%") {
	      // Convert percentages to numbers, to handle expressions like: 50% * 50% (will become: 25%):
	      // console.log(expression)
	      expression = expression.replace(/\b[0-9\.]+%/g, function(percent) {
	        return parseFloat(percent.slice(0, -1)) * 0.01
	      })
	    }
	
	    // Remove units in expression:
	    var toEvaluate = expression.replace(new RegExp(unit, "gi"), "")
	    var result
	
	    try {
	      result = mexp.eval(toEvaluate)
	    }
	    catch (e) {
	      return functionIdentifier + "(" + expression + ")"
	    }
	
	    // Transform back to a percentage result:
	    if (unit === "%") {
	      result *= 100
	    }
	
	    // adjust rounding shit
	    // (0.1 * 0.2 === 0.020000000000000004)
	    if (functionIdentifier.length || unit === "%") {
	      result = Math.round(result * decimalPrecision) / decimalPrecision
	    }
	
	    // Add unit
	    result += unit
	
	    return result
	  }
	
	  /**
	   * Evaluates nested expressions
	   *
	   * @param {String} expression
	   * @returns {String}
	   */
	  function evaluateNestedExpression(expression, call) {
	    // Remove the calc part from nested expressions to ensure
	    // better browser compatibility
	    expression = expression.replace(/((?:\-[a-z]+\-)?calc)/g, "")
	    var evaluatedPart = ""
	    var nonEvaluatedPart = expression
	    var matches
	    while ((matches = NESTED_CALC_RE.exec(nonEvaluatedPart))) {
	      if (matches[0].index > 0) {
	        evaluatedPart += nonEvaluatedPart.substring(0, matches[0].index)
	      }
	
	      var balancedExpr = balanced("(", ")", nonEvaluatedPart.substring([0].index))
	      if (balancedExpr.body === "") {
	        throw new Error("'" + expression + "' must contain a non-whitespace string")
	      }
	
	      var evaluated = evaluateExpression(balancedExpr.body, "", call)
	
	      evaluatedPart += balancedExpr.pre + evaluated
	      nonEvaluatedPart = balancedExpr.post
	    }
	
	    return evaluatedPart + nonEvaluatedPart
	  }
	
	  return reduceFunctionCall(value, /((?:\-[a-z]+\-)?calc)\(/, evaluateExpression)
	}
	
	/**
	 * Checks what units are used in an expression
	 *
	 * @param {String} expression
	 * @returns {Array}
	 */
	
	function getUnitsInExpression(expression) {
	  var uniqueUnits = []
	  var uniqueLowerCaseUnits = []
	  var unitRegEx = /[\.0-9]([%a-z]+)/gi
	  var matches = unitRegEx.exec(expression)
	
	  while (matches) {
	    if (!matches || !matches[1]) {
	      continue
	    }
	
	    if (uniqueLowerCaseUnits.indexOf(matches[1].toLowerCase()) === -1) {
	      uniqueUnits.push(matches[1])
	      uniqueLowerCaseUnits.push(matches[1].toLowerCase())
	    }
	
	    matches = unitRegEx.exec(expression)
	  }
	
	  return uniqueUnits
	}


/***/ },
/* 2437 */
/***/ function(module, exports) {

	module.exports = balanced;
	function balanced(a, b, str) {
	  if (a instanceof RegExp) a = maybeMatch(a, str);
	  if (b instanceof RegExp) b = maybeMatch(b, str);
	
	  var r = range(a, b, str);
	
	  return r && {
	    start: r[0],
	    end: r[1],
	    pre: str.slice(0, r[0]),
	    body: str.slice(r[0] + a.length, r[1]),
	    post: str.slice(r[1] + b.length)
	  };
	}
	
	function maybeMatch(reg, str) {
	  var m = str.match(reg);
	  return m ? m[0] : null;
	}
	
	balanced.range = range;
	function range(a, b, str) {
	  var begs, beg, left, right, result;
	  var ai = str.indexOf(a);
	  var bi = str.indexOf(b, ai + 1);
	  var i = ai;
	
	  if (ai >= 0 && bi > 0) {
	    begs = [];
	    left = str.length;
	
	    while (i >= 0 && !result) {
	      if (i == ai) {
	        begs.push(i);
	        ai = str.indexOf(a, i + 1);
	      } else if (begs.length == 1) {
	        result = [ begs.pop(), bi ];
	      } else {
	        beg = begs.pop();
	        if (beg < left) {
	          left = beg;
	          right = bi;
	        }
	
	        bi = str.indexOf(b, i + 1);
	      }
	
	      i = ai < bi && ai >= 0 ? ai : bi;
	    }
	
	    if (begs.length) {
	      result = [ left, right ];
	    }
	  }
	
	  return result;
	}


/***/ },
/* 2438 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * Module dependencies
	 */
	var balanced = __webpack_require__(1203)
	
	/**
	 * Expose `reduceFunctionCall`
	 *
	 * @type {Function}
	 */
	module.exports = reduceFunctionCall
	
	/**
	 * Walkthrough all expressions, evaluate them and insert them into the declaration
	 *
	 * @param {Array} expressions
	 * @param {Object} declaration
	 */
	
	function reduceFunctionCall(string, functionRE, callback) {
	  var call = string
	  return getFunctionCalls(string, functionRE).reduce(function(string, obj) {
	    return string.replace(obj.functionIdentifier + "(" + obj.matches.body + ")", evalFunctionCall(obj.matches.body, obj.functionIdentifier, callback, call, functionRE))
	  }, string)
	}
	
	/**
	 * Parses expressions in a value
	 *
	 * @param {String} value
	 * @returns {Array}
	 * @api private
	 */
	
	function getFunctionCalls(call, functionRE) {
	  var expressions = []
	
	  var fnRE = typeof functionRE === "string" ? new RegExp("\\b(" + functionRE + ")\\(") : functionRE
	  do {
	    var searchMatch = fnRE.exec(call)
	    if (!searchMatch) {
	      return expressions
	    }
	    if (searchMatch[1] === undefined) {
	      throw new Error("Missing the first couple of parenthesis to get the function identifier in " + functionRE)
	    }
	    var fn = searchMatch[1]
	    var startIndex = searchMatch.index
	    var matches = balanced("(", ")", call.substring(startIndex))
	
	    if (!matches || matches.start !== searchMatch[0].length - 1) {
	      throw new SyntaxError(fn + "(): missing closing ')' in the value '" + call + "'")
	    }
	
	    expressions.push({matches: matches, functionIdentifier: fn})
	    call = matches.post
	  }
	  while (fnRE.test(call))
	
	  return expressions
	}
	
	/**
	 * Evaluates an expression
	 *
	 * @param {String} expression
	 * @returns {String}
	 * @api private
	 */
	
	function evalFunctionCall (string, functionIdentifier, callback, call, functionRE) {
	  // allow recursivity
	  return callback(reduceFunctionCall(string, functionRE, callback), functionIdentifier, call)
	}


/***/ },
/* 2439 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  for (var _len = arguments.length, reducers = Array(_len), _key = 0; _key < _len; _key++) {
	    reducers[_key] = arguments[_key];
	  }
	
	  return function (previous, current) {
	    return reducers.reduce(function (p, r) {
	      return r(p, current);
	    }, previous);
	  };
	};
	
	module.exports = exports["default"];

/***/ },
/* 2440 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = combineActions;
	
	var _invariant = __webpack_require__(124);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _isFunction = __webpack_require__(315);
	
	var _isFunction2 = _interopRequireDefault(_isFunction);
	
	var _isSymbol = __webpack_require__(2451);
	
	var _isSymbol2 = _interopRequireDefault(_isSymbol);
	
	var _isEmpty = __webpack_require__(998);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _toString = __webpack_require__(1001);
	
	var _toString2 = _interopRequireDefault(_toString);
	
	var _isString = __webpack_require__(1000);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	var _constants = __webpack_require__(232);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isValidActionType(type) {
	  return (0, _isString2.default)(type) || (0, _isFunction2.default)(type) || (0, _isSymbol2.default)(type);
	}
	
	function isValidActionTypes(types) {
	  if ((0, _isEmpty2.default)(types)) {
	    return false;
	  }
	  return types.every(isValidActionType);
	}
	
	function combineActions() {
	  for (var _len = arguments.length, actionsTypes = Array(_len), _key = 0; _key < _len; _key++) {
	    actionsTypes[_key] = arguments[_key];
	  }
	
	  (0, _invariant2.default)(isValidActionTypes(actionsTypes), 'Expected action types to be strings, symbols, or action creators');
	  var combinedActionType = actionsTypes.map(_toString2.default).join(_constants.ACTION_TYPE_DELIMITER);
	  return { toString: function toString() {
	      return combinedActionType;
	    } };
	}

/***/ },
/* 2441 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createActions;
	
	var _invariant = __webpack_require__(124);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _isPlainObject = __webpack_require__(233);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _isFunction = __webpack_require__(315);
	
	var _isFunction2 = _interopRequireDefault(_isFunction);
	
	var _identity = __webpack_require__(480);
	
	var _identity2 = _interopRequireDefault(_identity);
	
	var _isArray = __webpack_require__(2449);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _isString = __webpack_require__(1000);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	var _isNil = __webpack_require__(999);
	
	var _isNil2 = _interopRequireDefault(_isNil);
	
	var _getLastElement = __webpack_require__(2447);
	
	var _getLastElement2 = _interopRequireDefault(_getLastElement);
	
	var _camelCase = __webpack_require__(996);
	
	var _camelCase2 = _interopRequireDefault(_camelCase);
	
	var _arrayToObject = __webpack_require__(2444);
	
	var _arrayToObject2 = _interopRequireDefault(_arrayToObject);
	
	var _flattenActionMap = __webpack_require__(2445);
	
	var _flattenActionMap2 = _interopRequireDefault(_flattenActionMap);
	
	var _unflattenActionCreators = __webpack_require__(2453);
	
	var _unflattenActionCreators2 = _interopRequireDefault(_unflattenActionCreators);
	
	var _createAction = __webpack_require__(479);
	
	var _createAction2 = _interopRequireDefault(_createAction);
	
	var _constants = __webpack_require__(232);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function createActions(actionMap) {
	  for (var _len = arguments.length, identityActions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    identityActions[_key - 1] = arguments[_key];
	  }
	
	  var options = (0, _isPlainObject2.default)((0, _getLastElement2.default)(identityActions)) ? identityActions.pop() : {};
	  (0, _invariant2.default)(identityActions.every(_isString2.default) && ((0, _isString2.default)(actionMap) || (0, _isPlainObject2.default)(actionMap)), 'Expected optional object followed by string action types');
	  if ((0, _isString2.default)(actionMap)) {
	    return actionCreatorsFromIdentityActions([actionMap].concat(identityActions), options);
	  }
	  return _extends({}, actionCreatorsFromActionMap(actionMap, options), actionCreatorsFromIdentityActions(identityActions, options));
	}
	
	function actionCreatorsFromActionMap(actionMap, options) {
	  var flatActionMap = (0, _flattenActionMap2.default)(actionMap, options);
	  var flatActionCreators = actionMapToActionCreators(flatActionMap);
	  return (0, _unflattenActionCreators2.default)(flatActionCreators, options);
	}
	
	function actionMapToActionCreators(actionMap) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      prefix = _ref.prefix,
	      _ref$namespace = _ref.namespace,
	      namespace = _ref$namespace === undefined ? _constants.DEFAULT_NAMESPACE : _ref$namespace;
	
	  function isValidActionMapValue(actionMapValue) {
	    if ((0, _isFunction2.default)(actionMapValue) || (0, _isNil2.default)(actionMapValue)) {
	      return true;
	    }
	
	    if ((0, _isArray2.default)(actionMapValue)) {
	      var _actionMapValue = _slicedToArray(actionMapValue, 2),
	          _actionMapValue$ = _actionMapValue[0],
	          payload = _actionMapValue$ === undefined ? _identity2.default : _actionMapValue$,
	          meta = _actionMapValue[1];
	
	      return (0, _isFunction2.default)(payload) && (0, _isFunction2.default)(meta);
	    }
	
	    return false;
	  }
	
	  return (0, _arrayToObject2.default)(Object.keys(actionMap), function (partialActionCreators, type) {
	    var actionMapValue = actionMap[type];
	    (0, _invariant2.default)(isValidActionMapValue(actionMapValue), 'Expected function, undefined, null, or array with payload and meta ' + ('functions for ' + type));
	    var prefixedType = prefix ? '' + prefix + namespace + type : type;
	    var actionCreator = (0, _isArray2.default)(actionMapValue) ? _createAction2.default.apply(undefined, [prefixedType].concat(_toConsumableArray(actionMapValue))) : (0, _createAction2.default)(prefixedType, actionMapValue);
	    return _extends({}, partialActionCreators, _defineProperty({}, type, actionCreator));
	  });
	}
	
	function actionCreatorsFromIdentityActions(identityActions, options) {
	  var actionMap = (0, _arrayToObject2.default)(identityActions, function (partialActionMap, type) {
	    return _extends({}, partialActionMap, _defineProperty({}, type, _identity2.default));
	  });
	  var actionCreators = actionMapToActionCreators(actionMap, options);
	  return (0, _arrayToObject2.default)(Object.keys(actionCreators), function (partialActionCreators, type) {
	    return _extends({}, partialActionCreators, _defineProperty({}, (0, _camelCase2.default)(type), actionCreators[type]));
	  });
	}

/***/ },
/* 2442 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(2053);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _createAction = __webpack_require__(479);
	
	var _createAction2 = _interopRequireDefault(_createAction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (type, payloadCreator) {
	  return (0, _lodash2.default)((0, _createAction2.default)(type, payloadCreator), payloadCreator.length);
	};

/***/ },
/* 2443 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = handleActions;
	
	var _reduceReducers = __webpack_require__(2439);
	
	var _reduceReducers2 = _interopRequireDefault(_reduceReducers);
	
	var _invariant = __webpack_require__(124);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _isPlainObject = __webpack_require__(233);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _isMap = __webpack_require__(316);
	
	var _isMap2 = _interopRequireDefault(_isMap);
	
	var _ownKeys = __webpack_require__(481);
	
	var _ownKeys2 = _interopRequireDefault(_ownKeys);
	
	var _flattenReducerMap = __webpack_require__(2446);
	
	var _flattenReducerMap2 = _interopRequireDefault(_flattenReducerMap);
	
	var _handleAction = __webpack_require__(994);
	
	var _handleAction2 = _interopRequireDefault(_handleAction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function get(key, x) {
	  return (0, _isMap2.default)(x) ? x.get(key) : x[key];
	}
	
	function handleActions(handlers, defaultState) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  (0, _invariant2.default)((0, _isPlainObject2.default)(handlers) || (0, _isMap2.default)(handlers), 'Expected handlers to be a plain object.');
	  var flattenedReducerMap = (0, _flattenReducerMap2.default)(handlers, options);
	  var reducers = (0, _ownKeys2.default)(flattenedReducerMap).map(function (type) {
	    return (0, _handleAction2.default)(type, get(type, flattenedReducerMap), defaultState);
	  });
	  var reducer = _reduceReducers2.default.apply(undefined, _toConsumableArray(reducers));
	  return function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
	    var action = arguments[1];
	    return reducer(state, action);
	  };
	}

/***/ },
/* 2444 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (array, callback) {
	  return array.reduce(function (partialObject, element) {
	    return callback(partialObject, element);
	  }, {});
	};

/***/ },
/* 2445 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isPlainObject = __webpack_require__(233);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _flattenWhenNode = __webpack_require__(997);
	
	var _flattenWhenNode2 = _interopRequireDefault(_flattenWhenNode);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _flattenWhenNode2.default)(_isPlainObject2.default);

/***/ },
/* 2446 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isPlainObject = __webpack_require__(233);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _isMap = __webpack_require__(316);
	
	var _isMap2 = _interopRequireDefault(_isMap);
	
	var _hasGeneratorInterface = __webpack_require__(2448);
	
	var _hasGeneratorInterface2 = _interopRequireDefault(_hasGeneratorInterface);
	
	var _flattenWhenNode = __webpack_require__(997);
	
	var _flattenWhenNode2 = _interopRequireDefault(_flattenWhenNode);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _flattenWhenNode2.default)(function (node) {
	  return ((0, _isPlainObject2.default)(node) || (0, _isMap2.default)(node)) && !(0, _hasGeneratorInterface2.default)(node);
	});

/***/ },
/* 2447 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (array) {
	  return array[array.length - 1];
	};

/***/ },
/* 2448 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = hasGeneratorInterface;
	
	var _ownKeys = __webpack_require__(481);
	
	var _ownKeys2 = _interopRequireDefault(_ownKeys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hasGeneratorInterface(handler) {
	  var keys = (0, _ownKeys2.default)(handler);
	  var hasOnlyInterfaceNames = keys.every(function (ownKey) {
	    return ownKey === 'next' || ownKey === 'throw';
	  });
	  return keys.length && keys.length <= 2 && hasOnlyInterfaceNames;
	}

/***/ },
/* 2449 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (value) {
	  return Array.isArray(value);
	};

/***/ },
/* 2450 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (value) {
	  return value === null;
	};

/***/ },
/* 2451 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = function (value) {
	  return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'symbol' || (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && Object.prototype.toString.call(value) === '[object Symbol]';
	};

/***/ },
/* 2452 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (value) {
	  return value === undefined;
	};

/***/ },
/* 2453 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = unflattenActionCreators;
	
	var _constants = __webpack_require__(232);
	
	var _isEmpty = __webpack_require__(998);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _camelCase = __webpack_require__(996);
	
	var _camelCase2 = _interopRequireDefault(_camelCase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function unflattenActionCreators(flatActionCreators) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$namespace = _ref.namespace,
	      namespace = _ref$namespace === undefined ? _constants.DEFAULT_NAMESPACE : _ref$namespace,
	      prefix = _ref.prefix;
	
	  function unflatten(flatActionType) {
	    var partialNestedActionCreators = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var partialFlatActionTypePath = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
	    var nextNamespace = (0, _camelCase2.default)(partialFlatActionTypePath.shift());
	    if ((0, _isEmpty2.default)(partialFlatActionTypePath)) {
	      partialNestedActionCreators[nextNamespace] = flatActionCreators[flatActionType];
	    } else {
	      if (!partialNestedActionCreators[nextNamespace]) {
	        partialNestedActionCreators[nextNamespace] = {};
	      }
	      unflatten(flatActionType, partialNestedActionCreators[nextNamespace], partialFlatActionTypePath);
	    }
	  }
	
	  var nestedActionCreators = {};
	  Object.getOwnPropertyNames(flatActionCreators).forEach(function (type) {
	    var unprefixedType = prefix ? type.replace('' + prefix + namespace, '') : type;
	    return unflatten(type, nestedActionCreators, unprefixedType.split(namespace));
	  });
	
	  return nestedActionCreators;
	}

/***/ },
/* 2454 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = applyMiddleware;
	
	var _compose = __webpack_require__(1002);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, preloadedState, enhancer) {
	      var store = createStore(reducer, preloadedState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2['default'].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ },
/* 2455 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ },
/* 2456 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = combineReducers;
	
	var _createStore = __webpack_require__(1003);
	
	var _isPlainObject = __webpack_require__(225);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(1004);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2['default'])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerSanity(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        (0, _warning2['default'])('No reducer provided for key "' + key + '"');
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  if (false) {
	    var unexpectedKeyCache = {};
	  }
	
	  var sanityError;
	  try {
	    assertReducerSanity(finalReducers);
	  } catch (e) {
	    sanityError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	    var action = arguments[1];
	
	    if (sanityError) {
	      throw sanityError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	      if (warningMessage) {
	        (0, _warning2['default'])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var i = 0; i < finalReducerKeys.length; i++) {
	      var key = finalReducerKeys[i];
	      var reducer = finalReducers[key];
	      var previousStateForKey = state[key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ },
/* 2457 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(216);
	var callBind = __webpack_require__(338);
	
	var implementation = __webpack_require__(1006);
	var getPolyfill = __webpack_require__(1007);
	var shim = __webpack_require__(2458);
	
	var flagsBound = callBind(getPolyfill());
	
	define(flagsBound, {
		getPolyfill: getPolyfill,
		implementation: implementation,
		shim: shim
	});
	
	module.exports = flagsBound;


/***/ },
/* 2458 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var supportsDescriptors = __webpack_require__(216).supportsDescriptors;
	var getPolyfill = __webpack_require__(1007);
	var gOPD = Object.getOwnPropertyDescriptor;
	var defineProperty = Object.defineProperty;
	var TypeErr = TypeError;
	var getProto = Object.getPrototypeOf;
	var regex = /a/;
	
	module.exports = function shimFlags() {
		if (!supportsDescriptors || !getProto) {
			throw new TypeErr('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
		}
		var polyfill = getPolyfill();
		var proto = getProto(regex);
		var descriptor = gOPD(proto, 'flags');
		if (!descriptor || descriptor.get !== polyfill) {
			defineProperty(proto, 'flags', {
				configurable: true,
				enumerable: false,
				get: polyfill
			});
		}
		return polyfill;
	};


/***/ },
/* 2459 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.ResizeObserver = factory());
	}(this, (function () { 'use strict';
	
	    /**
	     * A collection of shims that provide minimal functionality of the ES6 collections.
	     *
	     * These implementations are not meant to be used outside of the ResizeObserver
	     * modules as they cover only a limited range of use cases.
	     */
	    /* eslint-disable require-jsdoc, valid-jsdoc */
	    var MapShim = (function () {
	        if (typeof Map !== 'undefined') {
	            return Map;
	        }
	        /**
	         * Returns index in provided array that matches the specified key.
	         *
	         * @param {Array<Array>} arr
	         * @param {*} key
	         * @returns {number}
	         */
	        function getIndex(arr, key) {
	            var result = -1;
	            arr.some(function (entry, index) {
	                if (entry[0] === key) {
	                    result = index;
	                    return true;
	                }
	                return false;
	            });
	            return result;
	        }
	        return /** @class */ (function () {
	            function class_1() {
	                this.__entries__ = [];
	            }
	            Object.defineProperty(class_1.prototype, "size", {
	                /**
	                 * @returns {boolean}
	                 */
	                get: function () {
	                    return this.__entries__.length;
	                },
	                enumerable: true,
	                configurable: true
	            });
	            /**
	             * @param {*} key
	             * @returns {*}
	             */
	            class_1.prototype.get = function (key) {
	                var index = getIndex(this.__entries__, key);
	                var entry = this.__entries__[index];
	                return entry && entry[1];
	            };
	            /**
	             * @param {*} key
	             * @param {*} value
	             * @returns {void}
	             */
	            class_1.prototype.set = function (key, value) {
	                var index = getIndex(this.__entries__, key);
	                if (~index) {
	                    this.__entries__[index][1] = value;
	                }
	                else {
	                    this.__entries__.push([key, value]);
	                }
	            };
	            /**
	             * @param {*} key
	             * @returns {void}
	             */
	            class_1.prototype.delete = function (key) {
	                var entries = this.__entries__;
	                var index = getIndex(entries, key);
	                if (~index) {
	                    entries.splice(index, 1);
	                }
	            };
	            /**
	             * @param {*} key
	             * @returns {void}
	             */
	            class_1.prototype.has = function (key) {
	                return !!~getIndex(this.__entries__, key);
	            };
	            /**
	             * @returns {void}
	             */
	            class_1.prototype.clear = function () {
	                this.__entries__.splice(0);
	            };
	            /**
	             * @param {Function} callback
	             * @param {*} [ctx=null]
	             * @returns {void}
	             */
	            class_1.prototype.forEach = function (callback, ctx) {
	                if (ctx === void 0) { ctx = null; }
	                for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
	                    var entry = _a[_i];
	                    callback.call(ctx, entry[1], entry[0]);
	                }
	            };
	            return class_1;
	        }());
	    })();
	
	    /**
	     * Detects whether window and document objects are available in current environment.
	     */
	    var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
	
	    // Returns global object of a current environment.
	    var global$1 = (function () {
	        if (typeof global !== 'undefined' && global.Math === Math) {
	            return global;
	        }
	        if (typeof self !== 'undefined' && self.Math === Math) {
	            return self;
	        }
	        if (typeof window !== 'undefined' && window.Math === Math) {
	            return window;
	        }
	        // eslint-disable-next-line no-new-func
	        return Function('return this')();
	    })();
	
	    /**
	     * A shim for the requestAnimationFrame which falls back to the setTimeout if
	     * first one is not supported.
	     *
	     * @returns {number} Requests' identifier.
	     */
	    var requestAnimationFrame$1 = (function () {
	        if (typeof requestAnimationFrame === 'function') {
	            // It's required to use a bounded function because IE sometimes throws
	            // an "Invalid calling object" error if rAF is invoked without the global
	            // object on the left hand side.
	            return requestAnimationFrame.bind(global$1);
	        }
	        return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
	    })();
	
	    // Defines minimum timeout before adding a trailing call.
	    var trailingTimeout = 2;
	    /**
	     * Creates a wrapper function which ensures that provided callback will be
	     * invoked only once during the specified delay period.
	     *
	     * @param {Function} callback - Function to be invoked after the delay period.
	     * @param {number} delay - Delay after which to invoke callback.
	     * @returns {Function}
	     */
	    function throttle (callback, delay) {
	        var leadingCall = false, trailingCall = false, lastCallTime = 0;
	        /**
	         * Invokes the original callback function and schedules new invocation if
	         * the "proxy" was called during current request.
	         *
	         * @returns {void}
	         */
	        function resolvePending() {
	            if (leadingCall) {
	                leadingCall = false;
	                callback();
	            }
	            if (trailingCall) {
	                proxy();
	            }
	        }
	        /**
	         * Callback invoked after the specified delay. It will further postpone
	         * invocation of the original function delegating it to the
	         * requestAnimationFrame.
	         *
	         * @returns {void}
	         */
	        function timeoutCallback() {
	            requestAnimationFrame$1(resolvePending);
	        }
	        /**
	         * Schedules invocation of the original function.
	         *
	         * @returns {void}
	         */
	        function proxy() {
	            var timeStamp = Date.now();
	            if (leadingCall) {
	                // Reject immediately following calls.
	                if (timeStamp - lastCallTime < trailingTimeout) {
	                    return;
	                }
	                // Schedule new call to be in invoked when the pending one is resolved.
	                // This is important for "transitions" which never actually start
	                // immediately so there is a chance that we might miss one if change
	                // happens amids the pending invocation.
	                trailingCall = true;
	            }
	            else {
	                leadingCall = true;
	                trailingCall = false;
	                setTimeout(timeoutCallback, delay);
	            }
	            lastCallTime = timeStamp;
	        }
	        return proxy;
	    }
	
	    // Minimum delay before invoking the update of observers.
	    var REFRESH_DELAY = 20;
	    // A list of substrings of CSS properties used to find transition events that
	    // might affect dimensions of observed elements.
	    var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
	    // Check if MutationObserver is available.
	    var mutationObserverSupported = typeof MutationObserver !== 'undefined';
	    /**
	     * Singleton controller class which handles updates of ResizeObserver instances.
	     */
	    var ResizeObserverController = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserverController.
	         *
	         * @private
	         */
	        function ResizeObserverController() {
	            /**
	             * Indicates whether DOM listeners have been added.
	             *
	             * @private {boolean}
	             */
	            this.connected_ = false;
	            /**
	             * Tells that controller has subscribed for Mutation Events.
	             *
	             * @private {boolean}
	             */
	            this.mutationEventsAdded_ = false;
	            /**
	             * Keeps reference to the instance of MutationObserver.
	             *
	             * @private {MutationObserver}
	             */
	            this.mutationsObserver_ = null;
	            /**
	             * A list of connected observers.
	             *
	             * @private {Array<ResizeObserverSPI>}
	             */
	            this.observers_ = [];
	            this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
	            this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
	        }
	        /**
	         * Adds observer to observers list.
	         *
	         * @param {ResizeObserverSPI} observer - Observer to be added.
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.addObserver = function (observer) {
	            if (!~this.observers_.indexOf(observer)) {
	                this.observers_.push(observer);
	            }
	            // Add listeners if they haven't been added yet.
	            if (!this.connected_) {
	                this.connect_();
	            }
	        };
	        /**
	         * Removes observer from observers list.
	         *
	         * @param {ResizeObserverSPI} observer - Observer to be removed.
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.removeObserver = function (observer) {
	            var observers = this.observers_;
	            var index = observers.indexOf(observer);
	            // Remove observer if it's present in registry.
	            if (~index) {
	                observers.splice(index, 1);
	            }
	            // Remove listeners if controller has no connected observers.
	            if (!observers.length && this.connected_) {
	                this.disconnect_();
	            }
	        };
	        /**
	         * Invokes the update of observers. It will continue running updates insofar
	         * it detects changes.
	         *
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.refresh = function () {
	            var changesDetected = this.updateObservers_();
	            // Continue running updates if changes have been detected as there might
	            // be future ones caused by CSS transitions.
	            if (changesDetected) {
	                this.refresh();
	            }
	        };
	        /**
	         * Updates every observer from observers list and notifies them of queued
	         * entries.
	         *
	         * @private
	         * @returns {boolean} Returns "true" if any observer has detected changes in
	         *      dimensions of it's elements.
	         */
	        ResizeObserverController.prototype.updateObservers_ = function () {
	            // Collect observers that have active observations.
	            var activeObservers = this.observers_.filter(function (observer) {
	                return observer.gatherActive(), observer.hasActive();
	            });
	            // Deliver notifications in a separate cycle in order to avoid any
	            // collisions between observers, e.g. when multiple instances of
	            // ResizeObserver are tracking the same element and the callback of one
	            // of them changes content dimensions of the observed target. Sometimes
	            // this may result in notifications being blocked for the rest of observers.
	            activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
	            return activeObservers.length > 0;
	        };
	        /**
	         * Initializes DOM listeners.
	         *
	         * @private
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.connect_ = function () {
	            // Do nothing if running in a non-browser environment or if listeners
	            // have been already added.
	            if (!isBrowser || this.connected_) {
	                return;
	            }
	            // Subscription to the "Transitionend" event is used as a workaround for
	            // delayed transitions. This way it's possible to capture at least the
	            // final state of an element.
	            document.addEventListener('transitionend', this.onTransitionEnd_);
	            window.addEventListener('resize', this.refresh);
	            if (mutationObserverSupported) {
	                this.mutationsObserver_ = new MutationObserver(this.refresh);
	                this.mutationsObserver_.observe(document, {
	                    attributes: true,
	                    childList: true,
	                    characterData: true,
	                    subtree: true
	                });
	            }
	            else {
	                document.addEventListener('DOMSubtreeModified', this.refresh);
	                this.mutationEventsAdded_ = true;
	            }
	            this.connected_ = true;
	        };
	        /**
	         * Removes DOM listeners.
	         *
	         * @private
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.disconnect_ = function () {
	            // Do nothing if running in a non-browser environment or if listeners
	            // have been already removed.
	            if (!isBrowser || !this.connected_) {
	                return;
	            }
	            document.removeEventListener('transitionend', this.onTransitionEnd_);
	            window.removeEventListener('resize', this.refresh);
	            if (this.mutationsObserver_) {
	                this.mutationsObserver_.disconnect();
	            }
	            if (this.mutationEventsAdded_) {
	                document.removeEventListener('DOMSubtreeModified', this.refresh);
	            }
	            this.mutationsObserver_ = null;
	            this.mutationEventsAdded_ = false;
	            this.connected_ = false;
	        };
	        /**
	         * "Transitionend" event handler.
	         *
	         * @private
	         * @param {TransitionEvent} event
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
	            var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
	            // Detect whether transition may affect dimensions of an element.
	            var isReflowProperty = transitionKeys.some(function (key) {
	                return !!~propertyName.indexOf(key);
	            });
	            if (isReflowProperty) {
	                this.refresh();
	            }
	        };
	        /**
	         * Returns instance of the ResizeObserverController.
	         *
	         * @returns {ResizeObserverController}
	         */
	        ResizeObserverController.getInstance = function () {
	            if (!this.instance_) {
	                this.instance_ = new ResizeObserverController();
	            }
	            return this.instance_;
	        };
	        /**
	         * Holds reference to the controller's instance.
	         *
	         * @private {ResizeObserverController}
	         */
	        ResizeObserverController.instance_ = null;
	        return ResizeObserverController;
	    }());
	
	    /**
	     * Defines non-writable/enumerable properties of the provided target object.
	     *
	     * @param {Object} target - Object for which to define properties.
	     * @param {Object} props - Properties to be defined.
	     * @returns {Object} Target object.
	     */
	    var defineConfigurable = (function (target, props) {
	        for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
	            var key = _a[_i];
	            Object.defineProperty(target, key, {
	                value: props[key],
	                enumerable: false,
	                writable: false,
	                configurable: true
	            });
	        }
	        return target;
	    });
	
	    /**
	     * Returns the global object associated with provided element.
	     *
	     * @param {Object} target
	     * @returns {Object}
	     */
	    var getWindowOf = (function (target) {
	        // Assume that the element is an instance of Node, which means that it
	        // has the "ownerDocument" property from which we can retrieve a
	        // corresponding global object.
	        var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
	        // Return the local global object if it's not possible extract one from
	        // provided element.
	        return ownerGlobal || global$1;
	    });
	
	    // Placeholder of an empty content rectangle.
	    var emptyRect = createRectInit(0, 0, 0, 0);
	    /**
	     * Converts provided string to a number.
	     *
	     * @param {number|string} value
	     * @returns {number}
	     */
	    function toFloat(value) {
	        return parseFloat(value) || 0;
	    }
	    /**
	     * Extracts borders size from provided styles.
	     *
	     * @param {CSSStyleDeclaration} styles
	     * @param {...string} positions - Borders positions (top, right, ...)
	     * @returns {number}
	     */
	    function getBordersSize(styles) {
	        var positions = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            positions[_i - 1] = arguments[_i];
	        }
	        return positions.reduce(function (size, position) {
	            var value = styles['border-' + position + '-width'];
	            return size + toFloat(value);
	        }, 0);
	    }
	    /**
	     * Extracts paddings sizes from provided styles.
	     *
	     * @param {CSSStyleDeclaration} styles
	     * @returns {Object} Paddings box.
	     */
	    function getPaddings(styles) {
	        var positions = ['top', 'right', 'bottom', 'left'];
	        var paddings = {};
	        for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
	            var position = positions_1[_i];
	            var value = styles['padding-' + position];
	            paddings[position] = toFloat(value);
	        }
	        return paddings;
	    }
	    /**
	     * Calculates content rectangle of provided SVG element.
	     *
	     * @param {SVGGraphicsElement} target - Element content rectangle of which needs
	     *      to be calculated.
	     * @returns {DOMRectInit}
	     */
	    function getSVGContentRect(target) {
	        var bbox = target.getBBox();
	        return createRectInit(0, 0, bbox.width, bbox.height);
	    }
	    /**
	     * Calculates content rectangle of provided HTMLElement.
	     *
	     * @param {HTMLElement} target - Element for which to calculate the content rectangle.
	     * @returns {DOMRectInit}
	     */
	    function getHTMLElementContentRect(target) {
	        // Client width & height properties can't be
	        // used exclusively as they provide rounded values.
	        var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
	        // By this condition we can catch all non-replaced inline, hidden and
	        // detached elements. Though elements with width & height properties less
	        // than 0.5 will be discarded as well.
	        //
	        // Without it we would need to implement separate methods for each of
	        // those cases and it's not possible to perform a precise and performance
	        // effective test for hidden elements. E.g. even jQuery's ':visible' filter
	        // gives wrong results for elements with width & height less than 0.5.
	        if (!clientWidth && !clientHeight) {
	            return emptyRect;
	        }
	        var styles = getWindowOf(target).getComputedStyle(target);
	        var paddings = getPaddings(styles);
	        var horizPad = paddings.left + paddings.right;
	        var vertPad = paddings.top + paddings.bottom;
	        // Computed styles of width & height are being used because they are the
	        // only dimensions available to JS that contain non-rounded values. It could
	        // be possible to utilize the getBoundingClientRect if only it's data wasn't
	        // affected by CSS transformations let alone paddings, borders and scroll bars.
	        var width = toFloat(styles.width), height = toFloat(styles.height);
	        // Width & height include paddings and borders when the 'border-box' box
	        // model is applied (except for IE).
	        if (styles.boxSizing === 'border-box') {
	            // Following conditions are required to handle Internet Explorer which
	            // doesn't include paddings and borders to computed CSS dimensions.
	            //
	            // We can say that if CSS dimensions + paddings are equal to the "client"
	            // properties then it's either IE, and thus we don't need to subtract
	            // anything, or an element merely doesn't have paddings/borders styles.
	            if (Math.round(width + horizPad) !== clientWidth) {
	                width -= getBordersSize(styles, 'left', 'right') + horizPad;
	            }
	            if (Math.round(height + vertPad) !== clientHeight) {
	                height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
	            }
	        }
	        // Following steps can't be applied to the document's root element as its
	        // client[Width/Height] properties represent viewport area of the window.
	        // Besides, it's as well not necessary as the <html> itself neither has
	        // rendered scroll bars nor it can be clipped.
	        if (!isDocumentElement(target)) {
	            // In some browsers (only in Firefox, actually) CSS width & height
	            // include scroll bars size which can be removed at this step as scroll
	            // bars are the only difference between rounded dimensions + paddings
	            // and "client" properties, though that is not always true in Chrome.
	            var vertScrollbar = Math.round(width + horizPad) - clientWidth;
	            var horizScrollbar = Math.round(height + vertPad) - clientHeight;
	            // Chrome has a rather weird rounding of "client" properties.
	            // E.g. for an element with content width of 314.2px it sometimes gives
	            // the client width of 315px and for the width of 314.7px it may give
	            // 314px. And it doesn't happen all the time. So just ignore this delta
	            // as a non-relevant.
	            if (Math.abs(vertScrollbar) !== 1) {
	                width -= vertScrollbar;
	            }
	            if (Math.abs(horizScrollbar) !== 1) {
	                height -= horizScrollbar;
	            }
	        }
	        return createRectInit(paddings.left, paddings.top, width, height);
	    }
	    /**
	     * Checks whether provided element is an instance of the SVGGraphicsElement.
	     *
	     * @param {Element} target - Element to be checked.
	     * @returns {boolean}
	     */
	    var isSVGGraphicsElement = (function () {
	        // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
	        // interface.
	        if (typeof SVGGraphicsElement !== 'undefined') {
	            return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
	        }
	        // If it's so, then check that element is at least an instance of the
	        // SVGElement and that it has the "getBBox" method.
	        // eslint-disable-next-line no-extra-parens
	        return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
	            typeof target.getBBox === 'function'); };
	    })();
	    /**
	     * Checks whether provided element is a document element (<html>).
	     *
	     * @param {Element} target - Element to be checked.
	     * @returns {boolean}
	     */
	    function isDocumentElement(target) {
	        return target === getWindowOf(target).document.documentElement;
	    }
	    /**
	     * Calculates an appropriate content rectangle for provided html or svg element.
	     *
	     * @param {Element} target - Element content rectangle of which needs to be calculated.
	     * @returns {DOMRectInit}
	     */
	    function getContentRect(target) {
	        if (!isBrowser) {
	            return emptyRect;
	        }
	        if (isSVGGraphicsElement(target)) {
	            return getSVGContentRect(target);
	        }
	        return getHTMLElementContentRect(target);
	    }
	    /**
	     * Creates rectangle with an interface of the DOMRectReadOnly.
	     * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
	     *
	     * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
	     * @returns {DOMRectReadOnly}
	     */
	    function createReadOnlyRect(_a) {
	        var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
	        // If DOMRectReadOnly is available use it as a prototype for the rectangle.
	        var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
	        var rect = Object.create(Constr.prototype);
	        // Rectangle's properties are not writable and non-enumerable.
	        defineConfigurable(rect, {
	            x: x, y: y, width: width, height: height,
	            top: y,
	            right: x + width,
	            bottom: height + y,
	            left: x
	        });
	        return rect;
	    }
	    /**
	     * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
	     * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
	     *
	     * @param {number} x - X coordinate.
	     * @param {number} y - Y coordinate.
	     * @param {number} width - Rectangle's width.
	     * @param {number} height - Rectangle's height.
	     * @returns {DOMRectInit}
	     */
	    function createRectInit(x, y, width, height) {
	        return { x: x, y: y, width: width, height: height };
	    }
	
	    /**
	     * Class that is responsible for computations of the content rectangle of
	     * provided DOM element and for keeping track of it's changes.
	     */
	    var ResizeObservation = /** @class */ (function () {
	        /**
	         * Creates an instance of ResizeObservation.
	         *
	         * @param {Element} target - Element to be observed.
	         */
	        function ResizeObservation(target) {
	            /**
	             * Broadcasted width of content rectangle.
	             *
	             * @type {number}
	             */
	            this.broadcastWidth = 0;
	            /**
	             * Broadcasted height of content rectangle.
	             *
	             * @type {number}
	             */
	            this.broadcastHeight = 0;
	            /**
	             * Reference to the last observed content rectangle.
	             *
	             * @private {DOMRectInit}
	             */
	            this.contentRect_ = createRectInit(0, 0, 0, 0);
	            this.target = target;
	        }
	        /**
	         * Updates content rectangle and tells whether it's width or height properties
	         * have changed since the last broadcast.
	         *
	         * @returns {boolean}
	         */
	        ResizeObservation.prototype.isActive = function () {
	            var rect = getContentRect(this.target);
	            this.contentRect_ = rect;
	            return (rect.width !== this.broadcastWidth ||
	                rect.height !== this.broadcastHeight);
	        };
	        /**
	         * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
	         * from the corresponding properties of the last observed content rectangle.
	         *
	         * @returns {DOMRectInit} Last observed content rectangle.
	         */
	        ResizeObservation.prototype.broadcastRect = function () {
	            var rect = this.contentRect_;
	            this.broadcastWidth = rect.width;
	            this.broadcastHeight = rect.height;
	            return rect;
	        };
	        return ResizeObservation;
	    }());
	
	    var ResizeObserverEntry = /** @class */ (function () {
	        /**
	         * Creates an instance of ResizeObserverEntry.
	         *
	         * @param {Element} target - Element that is being observed.
	         * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
	         */
	        function ResizeObserverEntry(target, rectInit) {
	            var contentRect = createReadOnlyRect(rectInit);
	            // According to the specification following properties are not writable
	            // and are also not enumerable in the native implementation.
	            //
	            // Property accessors are not being used as they'd require to define a
	            // private WeakMap storage which may cause memory leaks in browsers that
	            // don't support this type of collections.
	            defineConfigurable(this, { target: target, contentRect: contentRect });
	        }
	        return ResizeObserverEntry;
	    }());
	
	    var ResizeObserverSPI = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserver.
	         *
	         * @param {ResizeObserverCallback} callback - Callback function that is invoked
	         *      when one of the observed elements changes it's content dimensions.
	         * @param {ResizeObserverController} controller - Controller instance which
	         *      is responsible for the updates of observer.
	         * @param {ResizeObserver} callbackCtx - Reference to the public
	         *      ResizeObserver instance which will be passed to callback function.
	         */
	        function ResizeObserverSPI(callback, controller, callbackCtx) {
	            /**
	             * Collection of resize observations that have detected changes in dimensions
	             * of elements.
	             *
	             * @private {Array<ResizeObservation>}
	             */
	            this.activeObservations_ = [];
	            /**
	             * Registry of the ResizeObservation instances.
	             *
	             * @private {Map<Element, ResizeObservation>}
	             */
	            this.observations_ = new MapShim();
	            if (typeof callback !== 'function') {
	                throw new TypeError('The callback provided as parameter 1 is not a function.');
	            }
	            this.callback_ = callback;
	            this.controller_ = controller;
	            this.callbackCtx_ = callbackCtx;
	        }
	        /**
	         * Starts observing provided element.
	         *
	         * @param {Element} target - Element to be observed.
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.observe = function (target) {
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            // Do nothing if current environment doesn't have the Element interface.
	            if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	                return;
	            }
	            if (!(target instanceof getWindowOf(target).Element)) {
	                throw new TypeError('parameter 1 is not of type "Element".');
	            }
	            var observations = this.observations_;
	            // Do nothing if element is already being observed.
	            if (observations.has(target)) {
	                return;
	            }
	            observations.set(target, new ResizeObservation(target));
	            this.controller_.addObserver(this);
	            // Force the update of observations.
	            this.controller_.refresh();
	        };
	        /**
	         * Stops observing provided element.
	         *
	         * @param {Element} target - Element to stop observing.
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.unobserve = function (target) {
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            // Do nothing if current environment doesn't have the Element interface.
	            if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	                return;
	            }
	            if (!(target instanceof getWindowOf(target).Element)) {
	                throw new TypeError('parameter 1 is not of type "Element".');
	            }
	            var observations = this.observations_;
	            // Do nothing if element is not being observed.
	            if (!observations.has(target)) {
	                return;
	            }
	            observations.delete(target);
	            if (!observations.size) {
	                this.controller_.removeObserver(this);
	            }
	        };
	        /**
	         * Stops observing all elements.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.disconnect = function () {
	            this.clearActive();
	            this.observations_.clear();
	            this.controller_.removeObserver(this);
	        };
	        /**
	         * Collects observation instances the associated element of which has changed
	         * it's content rectangle.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.gatherActive = function () {
	            var _this = this;
	            this.clearActive();
	            this.observations_.forEach(function (observation) {
	                if (observation.isActive()) {
	                    _this.activeObservations_.push(observation);
	                }
	            });
	        };
	        /**
	         * Invokes initial callback function with a list of ResizeObserverEntry
	         * instances collected from active resize observations.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.broadcastActive = function () {
	            // Do nothing if observer doesn't have active observations.
	            if (!this.hasActive()) {
	                return;
	            }
	            var ctx = this.callbackCtx_;
	            // Create ResizeObserverEntry instance for every active observation.
	            var entries = this.activeObservations_.map(function (observation) {
	                return new ResizeObserverEntry(observation.target, observation.broadcastRect());
	            });
	            this.callback_.call(ctx, entries, ctx);
	            this.clearActive();
	        };
	        /**
	         * Clears the collection of active observations.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.clearActive = function () {
	            this.activeObservations_.splice(0);
	        };
	        /**
	         * Tells whether observer has active observations.
	         *
	         * @returns {boolean}
	         */
	        ResizeObserverSPI.prototype.hasActive = function () {
	            return this.activeObservations_.length > 0;
	        };
	        return ResizeObserverSPI;
	    }());
	
	    // Registry of internal observers. If WeakMap is not available use current shim
	    // for the Map collection as it has all required methods and because WeakMap
	    // can't be fully polyfilled anyway.
	    var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
	    /**
	     * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
	     * exposing only those methods and properties that are defined in the spec.
	     */
	    var ResizeObserver = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserver.
	         *
	         * @param {ResizeObserverCallback} callback - Callback that is invoked when
	         *      dimensions of the observed elements change.
	         */
	        function ResizeObserver(callback) {
	            if (!(this instanceof ResizeObserver)) {
	                throw new TypeError('Cannot call a class as a function.');
	            }
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            var controller = ResizeObserverController.getInstance();
	            var observer = new ResizeObserverSPI(callback, controller, this);
	            observers.set(this, observer);
	        }
	        return ResizeObserver;
	    }());
	    // Expose public methods of ResizeObserver.
	    [
	        'observe',
	        'unobserve',
	        'disconnect'
	    ].forEach(function (method) {
	        ResizeObserver.prototype[method] = function () {
	            var _a;
	            return (_a = observers.get(this))[method].apply(_a, arguments);
	        };
	    });
	
	    var index = (function () {
	        // Export existing implementation if available.
	        if (typeof global$1.ResizeObserver !== 'undefined') {
	            return global$1.ResizeObserver;
	        }
	        return ResizeObserver;
	    })();
	
	    return index;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 2460 */
/***/ function(module, exports, __webpack_require__) {

	/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
	/* eslint-disable node/no-deprecated-api */
	var buffer = __webpack_require__(519)
	var Buffer = buffer.Buffer
	
	// alternative to using Object.keys for old browsers
	function copyProps (src, dst) {
	  for (var key in src) {
	    dst[key] = src[key]
	  }
	}
	if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
	  module.exports = buffer
	} else {
	  // Copy properties from require('buffer')
	  copyProps(buffer, exports)
	  exports.Buffer = SafeBuffer
	}
	
	function SafeBuffer (arg, encodingOrOffset, length) {
	  return Buffer(arg, encodingOrOffset, length)
	}
	
	SafeBuffer.prototype = Object.create(Buffer.prototype)
	
	// Copy static methods from Buffer
	copyProps(Buffer, SafeBuffer)
	
	SafeBuffer.from = function (arg, encodingOrOffset, length) {
	  if (typeof arg === 'number') {
	    throw new TypeError('Argument must not be a number')
	  }
	  return Buffer(arg, encodingOrOffset, length)
	}
	
	SafeBuffer.alloc = function (size, fill, encoding) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  var buf = Buffer(size)
	  if (fill !== undefined) {
	    if (typeof encoding === 'string') {
	      buf.fill(fill, encoding)
	    } else {
	      buf.fill(fill)
	    }
	  } else {
	    buf.fill(0)
	  }
	  return buf
	}
	
	SafeBuffer.allocUnsafe = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return Buffer(size)
	}
	
	SafeBuffer.allocUnsafeSlow = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return buffer.SlowBuffer(size)
	}


/***/ },
/* 2461 */
/***/ function(module, exports) {

	/** @license React v0.19.1
	 * scheduler.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var f,g,h,k,l;
	if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
	y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
	typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
	function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
	function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
	function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
	function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
	function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
	exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
	exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
	exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ },
/* 2462 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(2461);
	} else {
	  module.exports = require('./cjs/scheduler.development.js');
	}


/***/ },
/* 2463 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	var _computeScrollIntoView = _interopRequireDefault(__webpack_require__(1205));
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	function isOptionsObject(options) {
	  return options === Object(options) && Object.keys(options).length !== 0;
	}
	function defaultBehavior(actions, behavior) {
	  if (behavior === void 0) {
	    behavior = 'auto';
	  }
	  var canSmoothScroll = ('scrollBehavior' in document.body.style);
	  actions.forEach(function (_ref) {
	    var el = _ref.el,
	      top = _ref.top,
	      left = _ref.left;
	    if (el.scroll && canSmoothScroll) {
	      el.scroll({
	        top: top,
	        left: left,
	        behavior: behavior
	      });
	    } else {
	      el.scrollTop = top;
	      el.scrollLeft = left;
	    }
	  });
	}
	function getOptions(options) {
	  if (options === false) {
	    return {
	      block: 'end',
	      inline: 'nearest'
	    };
	  }
	  if (isOptionsObject(options)) {
	    return options;
	  }
	  return {
	    block: 'start',
	    inline: 'nearest'
	  };
	}
	function scrollIntoView(target, options) {
	  var isTargetAttached = target.isConnected || target.ownerDocument.documentElement.contains(target);
	  if (isOptionsObject(options) && typeof options.behavior === 'function') {
	    return options.behavior(isTargetAttached ? (0, _computeScrollIntoView["default"])(target, options) : []);
	  }
	  if (!isTargetAttached) {
	    return;
	  }
	  var computeOptions = getOptions(options);
	  return defaultBehavior((0, _computeScrollIntoView["default"])(target, computeOptions), computeOptions.behavior);
	}
	var _default = scrollIntoView;
	exports["default"] = _default;
	module.exports = exports.default;

/***/ },
/* 2464 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(218);
	var define = __webpack_require__(415);
	var hasDescriptors = __webpack_require__(430)();
	var gOPD = __webpack_require__(717);
	
	var $TypeError = __webpack_require__(175);
	var $floor = GetIntrinsic('%Math.floor%');
	
	/** @type {import('.')} */
	module.exports = function setFunctionLength(fn, length) {
		if (typeof fn !== 'function') {
			throw new $TypeError('`fn` is not a function');
		}
		if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $floor(length) !== length) {
			throw new $TypeError('`length` must be a positive 32-bit integer');
		}
	
		var loose = arguments.length > 2 && !!arguments[2];
	
		var functionLengthIsConfigurable = true;
		var functionLengthIsWritable = true;
		if ('length' in fn && gOPD) {
			var desc = gOPD(fn, 'length');
			if (desc && !desc.configurable) {
				functionLengthIsConfigurable = false;
			}
			if (desc && !desc.writable) {
				functionLengthIsWritable = false;
			}
		}
	
		if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
			if (hasDescriptors) {
				define(/** @type {Parameters<define>[0]} */ (fn), 'length', length, true, true);
			} else {
				define(/** @type {Parameters<define>[0]} */ (fn), 'length', length);
			}
		}
		return fn;
	};


/***/ },
/* 2465 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(415);
	var hasDescriptors = __webpack_require__(430)();
	var functionsHaveConfigurableNames = __webpack_require__(1878).functionsHaveConfigurableNames();
	
	var $TypeError = __webpack_require__(175);
	
	/** @type {import('.')} */
	module.exports = function setFunctionName(fn, name) {
		if (typeof fn !== 'function') {
			throw new $TypeError('`fn` is not a function');
		}
		var loose = arguments.length > 2 && !!arguments[2];
		if (!loose || functionsHaveConfigurableNames) {
			if (hasDescriptors) {
				define(/** @type {Parameters<define>[0]} */ (fn), 'name', name, true, true);
			} else {
				define(/** @type {Parameters<define>[0]} */ (fn), 'name', name);
			}
		}
		return fn;
	};


/***/ },
/* 2466 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	/*<replacement>*/
	
	var Buffer = __webpack_require__(2460).Buffer;
	/*</replacement>*/
	
	var isEncoding = Buffer.isEncoding || function (encoding) {
	  encoding = '' + encoding;
	  switch (encoding && encoding.toLowerCase()) {
	    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
	      return true;
	    default:
	      return false;
	  }
	};
	
	function _normalizeEncoding(enc) {
	  if (!enc) return 'utf8';
	  var retried;
	  while (true) {
	    switch (enc) {
	      case 'utf8':
	      case 'utf-8':
	        return 'utf8';
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return 'utf16le';
	      case 'latin1':
	      case 'binary':
	        return 'latin1';
	      case 'base64':
	      case 'ascii':
	      case 'hex':
	        return enc;
	      default:
	        if (retried) return; // undefined
	        enc = ('' + enc).toLowerCase();
	        retried = true;
	    }
	  }
	};
	
	// Do not cache `Buffer.isEncoding` when checking encoding names as some
	// modules monkey-patch it to support additional encodings
	function normalizeEncoding(enc) {
	  var nenc = _normalizeEncoding(enc);
	  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
	  return nenc || enc;
	}
	
	// StringDecoder provides an interface for efficiently splitting a series of
	// buffers into a series of JS strings without breaking apart multi-byte
	// characters.
	exports.StringDecoder = StringDecoder;
	function StringDecoder(encoding) {
	  this.encoding = normalizeEncoding(encoding);
	  var nb;
	  switch (this.encoding) {
	    case 'utf16le':
	      this.text = utf16Text;
	      this.end = utf16End;
	      nb = 4;
	      break;
	    case 'utf8':
	      this.fillLast = utf8FillLast;
	      nb = 4;
	      break;
	    case 'base64':
	      this.text = base64Text;
	      this.end = base64End;
	      nb = 3;
	      break;
	    default:
	      this.write = simpleWrite;
	      this.end = simpleEnd;
	      return;
	  }
	  this.lastNeed = 0;
	  this.lastTotal = 0;
	  this.lastChar = Buffer.allocUnsafe(nb);
	}
	
	StringDecoder.prototype.write = function (buf) {
	  if (buf.length === 0) return '';
	  var r;
	  var i;
	  if (this.lastNeed) {
	    r = this.fillLast(buf);
	    if (r === undefined) return '';
	    i = this.lastNeed;
	    this.lastNeed = 0;
	  } else {
	    i = 0;
	  }
	  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
	  return r || '';
	};
	
	StringDecoder.prototype.end = utf8End;
	
	// Returns only complete characters in a Buffer
	StringDecoder.prototype.text = utf8Text;
	
	// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
	StringDecoder.prototype.fillLast = function (buf) {
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
	  this.lastNeed -= buf.length;
	};
	
	// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
	// continuation byte. If an invalid byte is detected, -2 is returned.
	function utf8CheckByte(byte) {
	  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
	  return byte >> 6 === 0x02 ? -1 : -2;
	}
	
	// Checks at most 3 bytes at the end of a Buffer in order to detect an
	// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
	// needed to complete the UTF-8 character (if applicable) are returned.
	function utf8CheckIncomplete(self, buf, i) {
	  var j = buf.length - 1;
	  if (j < i) return 0;
	  var nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 1;
	    return nb;
	  }
	  if (--j < i || nb === -2) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 2;
	    return nb;
	  }
	  if (--j < i || nb === -2) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) {
	      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
	    }
	    return nb;
	  }
	  return 0;
	}
	
	// Validates as many continuation bytes for a multi-byte UTF-8 character as
	// needed or are available. If we see a non-continuation byte where we expect
	// one, we "replace" the validated continuation bytes we've seen so far with
	// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
	// behavior. The continuation byte check is included three times in the case
	// where all of the continuation bytes for a character exist in the same buffer.
	// It is also done this way as a slight performance increase instead of using a
	// loop.
	function utf8CheckExtraBytes(self, buf, p) {
	  if ((buf[0] & 0xC0) !== 0x80) {
	    self.lastNeed = 0;
	    return '\ufffd';
	  }
	  if (self.lastNeed > 1 && buf.length > 1) {
	    if ((buf[1] & 0xC0) !== 0x80) {
	      self.lastNeed = 1;
	      return '\ufffd';
	    }
	    if (self.lastNeed > 2 && buf.length > 2) {
	      if ((buf[2] & 0xC0) !== 0x80) {
	        self.lastNeed = 2;
	        return '\ufffd';
	      }
	    }
	  }
	}
	
	// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
	function utf8FillLast(buf) {
	  var p = this.lastTotal - this.lastNeed;
	  var r = utf8CheckExtraBytes(this, buf, p);
	  if (r !== undefined) return r;
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, p, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, p, 0, buf.length);
	  this.lastNeed -= buf.length;
	}
	
	// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
	// partial character, the character's bytes are buffered until the required
	// number of bytes are available.
	function utf8Text(buf, i) {
	  var total = utf8CheckIncomplete(this, buf, i);
	  if (!this.lastNeed) return buf.toString('utf8', i);
	  this.lastTotal = total;
	  var end = buf.length - (total - this.lastNeed);
	  buf.copy(this.lastChar, 0, end);
	  return buf.toString('utf8', i, end);
	}
	
	// For UTF-8, a replacement character is added when ending on a partial
	// character.
	function utf8End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + '\ufffd';
	  return r;
	}
	
	// UTF-16LE typically needs two bytes per character, but even if we have an even
	// number of bytes available, we need to check if we end on a leading/high
	// surrogate. In that case, we need to wait for the next two bytes in order to
	// decode the last character properly.
	function utf16Text(buf, i) {
	  if ((buf.length - i) % 2 === 0) {
	    var r = buf.toString('utf16le', i);
	    if (r) {
	      var c = r.charCodeAt(r.length - 1);
	      if (c >= 0xD800 && c <= 0xDBFF) {
	        this.lastNeed = 2;
	        this.lastTotal = 4;
	        this.lastChar[0] = buf[buf.length - 2];
	        this.lastChar[1] = buf[buf.length - 1];
	        return r.slice(0, -1);
	      }
	    }
	    return r;
	  }
	  this.lastNeed = 1;
	  this.lastTotal = 2;
	  this.lastChar[0] = buf[buf.length - 1];
	  return buf.toString('utf16le', i, buf.length - 1);
	}
	
	// For UTF-16LE we do not explicitly append special replacement characters if we
	// end on a partial character, we simply let v8 handle that.
	function utf16End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) {
	    var end = this.lastTotal - this.lastNeed;
	    return r + this.lastChar.toString('utf16le', 0, end);
	  }
	  return r;
	}
	
	function base64Text(buf, i) {
	  var n = (buf.length - i) % 3;
	  if (n === 0) return buf.toString('base64', i);
	  this.lastNeed = 3 - n;
	  this.lastTotal = 3;
	  if (n === 1) {
	    this.lastChar[0] = buf[buf.length - 1];
	  } else {
	    this.lastChar[0] = buf[buf.length - 2];
	    this.lastChar[1] = buf[buf.length - 1];
	  }
	  return buf.toString('base64', i, buf.length - n);
	}
	
	function base64End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
	  return r;
	}
	
	// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
	function simpleWrite(buf) {
	  return buf.toString(this.encoding);
	}
	
	function simpleEnd(buf) {
	  return buf && buf.length ? this.write(buf) : '';
	}

/***/ },
/* 2467 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(2468);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(192)(module)))

/***/ },
/* 2468 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ },
/* 2469 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;// TinyColor v1.4.2
	// https://github.com/bgrins/TinyColor
	// Brian Grinstead, MIT License
	
	(function(Math) {
	
	var trimLeft = /^\s+/,
	    trimRight = /\s+$/,
	    tinyCounter = 0,
	    mathRound = Math.round,
	    mathMin = Math.min,
	    mathMax = Math.max,
	    mathRandom = Math.random;
	
	function tinycolor (color, opts) {
	
	    color = (color) ? color : '';
	    opts = opts || { };
	
	    // If input is already a tinycolor, return itself
	    if (color instanceof tinycolor) {
	       return color;
	    }
	    // If we are called as a function, call using new instead
	    if (!(this instanceof tinycolor)) {
	        return new tinycolor(color, opts);
	    }
	
	    var rgb = inputToRGB(color);
	    this._originalInput = color,
	    this._r = rgb.r,
	    this._g = rgb.g,
	    this._b = rgb.b,
	    this._a = rgb.a,
	    this._roundA = mathRound(100*this._a) / 100,
	    this._format = opts.format || rgb.format;
	    this._gradientType = opts.gradientType;
	
	    // Don't let the range of [0,255] come back in [0,1].
	    // Potentially lose a little bit of precision here, but will fix issues where
	    // .5 gets interpreted as half of the total, instead of half of 1
	    // If it was supposed to be 128, this was already taken care of by `inputToRgb`
	    if (this._r < 1) { this._r = mathRound(this._r); }
	    if (this._g < 1) { this._g = mathRound(this._g); }
	    if (this._b < 1) { this._b = mathRound(this._b); }
	
	    this._ok = rgb.ok;
	    this._tc_id = tinyCounter++;
	}
	
	tinycolor.prototype = {
	    isDark: function() {
	        return this.getBrightness() < 128;
	    },
	    isLight: function() {
	        return !this.isDark();
	    },
	    isValid: function() {
	        return this._ok;
	    },
	    getOriginalInput: function() {
	      return this._originalInput;
	    },
	    getFormat: function() {
	        return this._format;
	    },
	    getAlpha: function() {
	        return this._a;
	    },
	    getBrightness: function() {
	        //http://www.w3.org/TR/AERT#color-contrast
	        var rgb = this.toRgb();
	        return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
	    },
	    getLuminance: function() {
	        //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
	        var rgb = this.toRgb();
	        var RsRGB, GsRGB, BsRGB, R, G, B;
	        RsRGB = rgb.r/255;
	        GsRGB = rgb.g/255;
	        BsRGB = rgb.b/255;
	
	        if (RsRGB <= 0.03928) {R = RsRGB / 12.92;} else {R = Math.pow(((RsRGB + 0.055) / 1.055), 2.4);}
	        if (GsRGB <= 0.03928) {G = GsRGB / 12.92;} else {G = Math.pow(((GsRGB + 0.055) / 1.055), 2.4);}
	        if (BsRGB <= 0.03928) {B = BsRGB / 12.92;} else {B = Math.pow(((BsRGB + 0.055) / 1.055), 2.4);}
	        return (0.2126 * R) + (0.7152 * G) + (0.0722 * B);
	    },
	    setAlpha: function(value) {
	        this._a = boundAlpha(value);
	        this._roundA = mathRound(100*this._a) / 100;
	        return this;
	    },
	    toHsv: function() {
	        var hsv = rgbToHsv(this._r, this._g, this._b);
	        return { h: hsv.h * 360, s: hsv.s, v: hsv.v, a: this._a };
	    },
	    toHsvString: function() {
	        var hsv = rgbToHsv(this._r, this._g, this._b);
	        var h = mathRound(hsv.h * 360), s = mathRound(hsv.s * 100), v = mathRound(hsv.v * 100);
	        return (this._a == 1) ?
	          "hsv("  + h + ", " + s + "%, " + v + "%)" :
	          "hsva(" + h + ", " + s + "%, " + v + "%, "+ this._roundA + ")";
	    },
	    toHsl: function() {
	        var hsl = rgbToHsl(this._r, this._g, this._b);
	        return { h: hsl.h * 360, s: hsl.s, l: hsl.l, a: this._a };
	    },
	    toHslString: function() {
	        var hsl = rgbToHsl(this._r, this._g, this._b);
	        var h = mathRound(hsl.h * 360), s = mathRound(hsl.s * 100), l = mathRound(hsl.l * 100);
	        return (this._a == 1) ?
	          "hsl("  + h + ", " + s + "%, " + l + "%)" :
	          "hsla(" + h + ", " + s + "%, " + l + "%, "+ this._roundA + ")";
	    },
	    toHex: function(allow3Char) {
	        return rgbToHex(this._r, this._g, this._b, allow3Char);
	    },
	    toHexString: function(allow3Char) {
	        return '#' + this.toHex(allow3Char);
	    },
	    toHex8: function(allow4Char) {
	        return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
	    },
	    toHex8String: function(allow4Char) {
	        return '#' + this.toHex8(allow4Char);
	    },
	    toRgb: function() {
	        return { r: mathRound(this._r), g: mathRound(this._g), b: mathRound(this._b), a: this._a };
	    },
	    toRgbString: function() {
	        return (this._a == 1) ?
	          "rgb("  + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ")" :
	          "rgba(" + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ", " + this._roundA + ")";
	    },
	    toPercentageRgb: function() {
	        return { r: mathRound(bound01(this._r, 255) * 100) + "%", g: mathRound(bound01(this._g, 255) * 100) + "%", b: mathRound(bound01(this._b, 255) * 100) + "%", a: this._a };
	    },
	    toPercentageRgbString: function() {
	        return (this._a == 1) ?
	          "rgb("  + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%)" :
	          "rgba(" + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
	    },
	    toName: function() {
	        if (this._a === 0) {
	            return "transparent";
	        }
	
	        if (this._a < 1) {
	            return false;
	        }
	
	        return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
	    },
	    toFilter: function(secondColor) {
	        var hex8String = '#' + rgbaToArgbHex(this._r, this._g, this._b, this._a);
	        var secondHex8String = hex8String;
	        var gradientType = this._gradientType ? "GradientType = 1, " : "";
	
	        if (secondColor) {
	            var s = tinycolor(secondColor);
	            secondHex8String = '#' + rgbaToArgbHex(s._r, s._g, s._b, s._a);
	        }
	
	        return "progid:DXImageTransform.Microsoft.gradient("+gradientType+"startColorstr="+hex8String+",endColorstr="+secondHex8String+")";
	    },
	    toString: function(format) {
	        var formatSet = !!format;
	        format = format || this._format;
	
	        var formattedString = false;
	        var hasAlpha = this._a < 1 && this._a >= 0;
	        var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");
	
	        if (needsAlphaFormat) {
	            // Special case for "transparent", all other non-alpha formats
	            // will return rgba when there is transparency.
	            if (format === "name" && this._a === 0) {
	                return this.toName();
	            }
	            return this.toRgbString();
	        }
	        if (format === "rgb") {
	            formattedString = this.toRgbString();
	        }
	        if (format === "prgb") {
	            formattedString = this.toPercentageRgbString();
	        }
	        if (format === "hex" || format === "hex6") {
	            formattedString = this.toHexString();
	        }
	        if (format === "hex3") {
	            formattedString = this.toHexString(true);
	        }
	        if (format === "hex4") {
	            formattedString = this.toHex8String(true);
	        }
	        if (format === "hex8") {
	            formattedString = this.toHex8String();
	        }
	        if (format === "name") {
	            formattedString = this.toName();
	        }
	        if (format === "hsl") {
	            formattedString = this.toHslString();
	        }
	        if (format === "hsv") {
	            formattedString = this.toHsvString();
	        }
	
	        return formattedString || this.toHexString();
	    },
	    clone: function() {
	        return tinycolor(this.toString());
	    },
	
	    _applyModification: function(fn, args) {
	        var color = fn.apply(null, [this].concat([].slice.call(args)));
	        this._r = color._r;
	        this._g = color._g;
	        this._b = color._b;
	        this.setAlpha(color._a);
	        return this;
	    },
	    lighten: function() {
	        return this._applyModification(lighten, arguments);
	    },
	    brighten: function() {
	        return this._applyModification(brighten, arguments);
	    },
	    darken: function() {
	        return this._applyModification(darken, arguments);
	    },
	    desaturate: function() {
	        return this._applyModification(desaturate, arguments);
	    },
	    saturate: function() {
	        return this._applyModification(saturate, arguments);
	    },
	    greyscale: function() {
	        return this._applyModification(greyscale, arguments);
	    },
	    spin: function() {
	        return this._applyModification(spin, arguments);
	    },
	
	    _applyCombination: function(fn, args) {
	        return fn.apply(null, [this].concat([].slice.call(args)));
	    },
	    analogous: function() {
	        return this._applyCombination(analogous, arguments);
	    },
	    complement: function() {
	        return this._applyCombination(complement, arguments);
	    },
	    monochromatic: function() {
	        return this._applyCombination(monochromatic, arguments);
	    },
	    splitcomplement: function() {
	        return this._applyCombination(splitcomplement, arguments);
	    },
	    triad: function() {
	        return this._applyCombination(triad, arguments);
	    },
	    tetrad: function() {
	        return this._applyCombination(tetrad, arguments);
	    }
	};
	
	// If input is an object, force 1 into "1.0" to handle ratios properly
	// String input requires "1.0" as input, so 1 will be treated as 1
	tinycolor.fromRatio = function(color, opts) {
	    if (typeof color == "object") {
	        var newColor = {};
	        for (var i in color) {
	            if (color.hasOwnProperty(i)) {
	                if (i === "a") {
	                    newColor[i] = color[i];
	                }
	                else {
	                    newColor[i] = convertToPercentage(color[i]);
	                }
	            }
	        }
	        color = newColor;
	    }
	
	    return tinycolor(color, opts);
	};
	
	// Given a string or object, convert that input to RGB
	// Possible string inputs:
	//
	//     "red"
	//     "#f00" or "f00"
	//     "#ff0000" or "ff0000"
	//     "#ff000000" or "ff000000"
	//     "rgb 255 0 0" or "rgb (255, 0, 0)"
	//     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
	//     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
	//     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
	//     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
	//     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
	//     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
	//
	function inputToRGB(color) {
	
	    var rgb = { r: 0, g: 0, b: 0 };
	    var a = 1;
	    var s = null;
	    var v = null;
	    var l = null;
	    var ok = false;
	    var format = false;
	
	    if (typeof color == "string") {
	        color = stringInputToObject(color);
	    }
	
	    if (typeof color == "object") {
	        if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
	            rgb = rgbToRgb(color.r, color.g, color.b);
	            ok = true;
	            format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
	        }
	        else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
	            s = convertToPercentage(color.s);
	            v = convertToPercentage(color.v);
	            rgb = hsvToRgb(color.h, s, v);
	            ok = true;
	            format = "hsv";
	        }
	        else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
	            s = convertToPercentage(color.s);
	            l = convertToPercentage(color.l);
	            rgb = hslToRgb(color.h, s, l);
	            ok = true;
	            format = "hsl";
	        }
	
	        if (color.hasOwnProperty("a")) {
	            a = color.a;
	        }
	    }
	
	    a = boundAlpha(a);
	
	    return {
	        ok: ok,
	        format: color.format || format,
	        r: mathMin(255, mathMax(rgb.r, 0)),
	        g: mathMin(255, mathMax(rgb.g, 0)),
	        b: mathMin(255, mathMax(rgb.b, 0)),
	        a: a
	    };
	}
	
	
	// Conversion Functions
	// --------------------
	
	// `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
	// <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>
	
	// `rgbToRgb`
	// Handle bounds / percentage checking to conform to CSS color spec
	// <http://www.w3.org/TR/css3-color/>
	// *Assumes:* r, g, b in [0, 255] or [0, 1]
	// *Returns:* { r, g, b } in [0, 255]
	function rgbToRgb(r, g, b){
	    return {
	        r: bound01(r, 255) * 255,
	        g: bound01(g, 255) * 255,
	        b: bound01(b, 255) * 255
	    };
	}
	
	// `rgbToHsl`
	// Converts an RGB color value to HSL.
	// *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
	// *Returns:* { h, s, l } in [0,1]
	function rgbToHsl(r, g, b) {
	
	    r = bound01(r, 255);
	    g = bound01(g, 255);
	    b = bound01(b, 255);
	
	    var max = mathMax(r, g, b), min = mathMin(r, g, b);
	    var h, s, l = (max + min) / 2;
	
	    if(max == min) {
	        h = s = 0; // achromatic
	    }
	    else {
	        var d = max - min;
	        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
	        switch(max) {
	            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
	            case g: h = (b - r) / d + 2; break;
	            case b: h = (r - g) / d + 4; break;
	        }
	
	        h /= 6;
	    }
	
	    return { h: h, s: s, l: l };
	}
	
	// `hslToRgb`
	// Converts an HSL color value to RGB.
	// *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
	// *Returns:* { r, g, b } in the set [0, 255]
	function hslToRgb(h, s, l) {
	    var r, g, b;
	
	    h = bound01(h, 360);
	    s = bound01(s, 100);
	    l = bound01(l, 100);
	
	    function hue2rgb(p, q, t) {
	        if(t < 0) t += 1;
	        if(t > 1) t -= 1;
	        if(t < 1/6) return p + (q - p) * 6 * t;
	        if(t < 1/2) return q;
	        if(t < 2/3) return p + (q - p) * (2/3 - t) * 6;
	        return p;
	    }
	
	    if(s === 0) {
	        r = g = b = l; // achromatic
	    }
	    else {
	        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
	        var p = 2 * l - q;
	        r = hue2rgb(p, q, h + 1/3);
	        g = hue2rgb(p, q, h);
	        b = hue2rgb(p, q, h - 1/3);
	    }
	
	    return { r: r * 255, g: g * 255, b: b * 255 };
	}
	
	// `rgbToHsv`
	// Converts an RGB color value to HSV
	// *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
	// *Returns:* { h, s, v } in [0,1]
	function rgbToHsv(r, g, b) {
	
	    r = bound01(r, 255);
	    g = bound01(g, 255);
	    b = bound01(b, 255);
	
	    var max = mathMax(r, g, b), min = mathMin(r, g, b);
	    var h, s, v = max;
	
	    var d = max - min;
	    s = max === 0 ? 0 : d / max;
	
	    if(max == min) {
	        h = 0; // achromatic
	    }
	    else {
	        switch(max) {
	            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
	            case g: h = (b - r) / d + 2; break;
	            case b: h = (r - g) / d + 4; break;
	        }
	        h /= 6;
	    }
	    return { h: h, s: s, v: v };
	}
	
	// `hsvToRgb`
	// Converts an HSV color value to RGB.
	// *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
	// *Returns:* { r, g, b } in the set [0, 255]
	 function hsvToRgb(h, s, v) {
	
	    h = bound01(h, 360) * 6;
	    s = bound01(s, 100);
	    v = bound01(v, 100);
	
	    var i = Math.floor(h),
	        f = h - i,
	        p = v * (1 - s),
	        q = v * (1 - f * s),
	        t = v * (1 - (1 - f) * s),
	        mod = i % 6,
	        r = [v, q, p, p, t, v][mod],
	        g = [t, v, v, q, p, p][mod],
	        b = [p, p, t, v, v, q][mod];
	
	    return { r: r * 255, g: g * 255, b: b * 255 };
	}
	
	// `rgbToHex`
	// Converts an RGB color to hex
	// Assumes r, g, and b are contained in the set [0, 255]
	// Returns a 3 or 6 character hex
	function rgbToHex(r, g, b, allow3Char) {
	
	    var hex = [
	        pad2(mathRound(r).toString(16)),
	        pad2(mathRound(g).toString(16)),
	        pad2(mathRound(b).toString(16))
	    ];
	
	    // Return a 3 character hex if possible
	    if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) {
	        return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
	    }
	
	    return hex.join("");
	}
	
	// `rgbaToHex`
	// Converts an RGBA color plus alpha transparency to hex
	// Assumes r, g, b are contained in the set [0, 255] and
	// a in [0, 1]. Returns a 4 or 8 character rgba hex
	function rgbaToHex(r, g, b, a, allow4Char) {
	
	    var hex = [
	        pad2(mathRound(r).toString(16)),
	        pad2(mathRound(g).toString(16)),
	        pad2(mathRound(b).toString(16)),
	        pad2(convertDecimalToHex(a))
	    ];
	
	    // Return a 4 character hex if possible
	    if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) {
	        return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
	    }
	
	    return hex.join("");
	}
	
	// `rgbaToArgbHex`
	// Converts an RGBA color to an ARGB Hex8 string
	// Rarely used, but required for "toFilter()"
	function rgbaToArgbHex(r, g, b, a) {
	
	    var hex = [
	        pad2(convertDecimalToHex(a)),
	        pad2(mathRound(r).toString(16)),
	        pad2(mathRound(g).toString(16)),
	        pad2(mathRound(b).toString(16))
	    ];
	
	    return hex.join("");
	}
	
	// `equals`
	// Can be called with any tinycolor input
	tinycolor.equals = function (color1, color2) {
	    if (!color1 || !color2) { return false; }
	    return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
	};
	
	tinycolor.random = function() {
	    return tinycolor.fromRatio({
	        r: mathRandom(),
	        g: mathRandom(),
	        b: mathRandom()
	    });
	};
	
	
	// Modification Functions
	// ----------------------
	// Thanks to less.js for some of the basics here
	// <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>
	
	function desaturate(color, amount) {
	    amount = (amount === 0) ? 0 : (amount || 10);
	    var hsl = tinycolor(color).toHsl();
	    hsl.s -= amount / 100;
	    hsl.s = clamp01(hsl.s);
	    return tinycolor(hsl);
	}
	
	function saturate(color, amount) {
	    amount = (amount === 0) ? 0 : (amount || 10);
	    var hsl = tinycolor(color).toHsl();
	    hsl.s += amount / 100;
	    hsl.s = clamp01(hsl.s);
	    return tinycolor(hsl);
	}
	
	function greyscale(color) {
	    return tinycolor(color).desaturate(100);
	}
	
	function lighten (color, amount) {
	    amount = (amount === 0) ? 0 : (amount || 10);
	    var hsl = tinycolor(color).toHsl();
	    hsl.l += amount / 100;
	    hsl.l = clamp01(hsl.l);
	    return tinycolor(hsl);
	}
	
	function brighten(color, amount) {
	    amount = (amount === 0) ? 0 : (amount || 10);
	    var rgb = tinycolor(color).toRgb();
	    rgb.r = mathMax(0, mathMin(255, rgb.r - mathRound(255 * - (amount / 100))));
	    rgb.g = mathMax(0, mathMin(255, rgb.g - mathRound(255 * - (amount / 100))));
	    rgb.b = mathMax(0, mathMin(255, rgb.b - mathRound(255 * - (amount / 100))));
	    return tinycolor(rgb);
	}
	
	function darken (color, amount) {
	    amount = (amount === 0) ? 0 : (amount || 10);
	    var hsl = tinycolor(color).toHsl();
	    hsl.l -= amount / 100;
	    hsl.l = clamp01(hsl.l);
	    return tinycolor(hsl);
	}
	
	// Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
	// Values outside of this range will be wrapped into this range.
	function spin(color, amount) {
	    var hsl = tinycolor(color).toHsl();
	    var hue = (hsl.h + amount) % 360;
	    hsl.h = hue < 0 ? 360 + hue : hue;
	    return tinycolor(hsl);
	}
	
	// Combination Functions
	// ---------------------
	// Thanks to jQuery xColor for some of the ideas behind these
	// <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>
	
	function complement(color) {
	    var hsl = tinycolor(color).toHsl();
	    hsl.h = (hsl.h + 180) % 360;
	    return tinycolor(hsl);
	}
	
	function triad(color) {
	    var hsl = tinycolor(color).toHsl();
	    var h = hsl.h;
	    return [
	        tinycolor(color),
	        tinycolor({ h: (h + 120) % 360, s: hsl.s, l: hsl.l }),
	        tinycolor({ h: (h + 240) % 360, s: hsl.s, l: hsl.l })
	    ];
	}
	
	function tetrad(color) {
	    var hsl = tinycolor(color).toHsl();
	    var h = hsl.h;
	    return [
	        tinycolor(color),
	        tinycolor({ h: (h + 90) % 360, s: hsl.s, l: hsl.l }),
	        tinycolor({ h: (h + 180) % 360, s: hsl.s, l: hsl.l }),
	        tinycolor({ h: (h + 270) % 360, s: hsl.s, l: hsl.l })
	    ];
	}
	
	function splitcomplement(color) {
	    var hsl = tinycolor(color).toHsl();
	    var h = hsl.h;
	    return [
	        tinycolor(color),
	        tinycolor({ h: (h + 72) % 360, s: hsl.s, l: hsl.l}),
	        tinycolor({ h: (h + 216) % 360, s: hsl.s, l: hsl.l})
	    ];
	}
	
	function analogous(color, results, slices) {
	    results = results || 6;
	    slices = slices || 30;
	
	    var hsl = tinycolor(color).toHsl();
	    var part = 360 / slices;
	    var ret = [tinycolor(color)];
	
	    for (hsl.h = ((hsl.h - (part * results >> 1)) + 720) % 360; --results; ) {
	        hsl.h = (hsl.h + part) % 360;
	        ret.push(tinycolor(hsl));
	    }
	    return ret;
	}
	
	function monochromatic(color, results) {
	    results = results || 6;
	    var hsv = tinycolor(color).toHsv();
	    var h = hsv.h, s = hsv.s, v = hsv.v;
	    var ret = [];
	    var modification = 1 / results;
	
	    while (results--) {
	        ret.push(tinycolor({ h: h, s: s, v: v}));
	        v = (v + modification) % 1;
	    }
	
	    return ret;
	}
	
	// Utility Functions
	// ---------------------
	
	tinycolor.mix = function(color1, color2, amount) {
	    amount = (amount === 0) ? 0 : (amount || 50);
	
	    var rgb1 = tinycolor(color1).toRgb();
	    var rgb2 = tinycolor(color2).toRgb();
	
	    var p = amount / 100;
	
	    var rgba = {
	        r: ((rgb2.r - rgb1.r) * p) + rgb1.r,
	        g: ((rgb2.g - rgb1.g) * p) + rgb1.g,
	        b: ((rgb2.b - rgb1.b) * p) + rgb1.b,
	        a: ((rgb2.a - rgb1.a) * p) + rgb1.a
	    };
	
	    return tinycolor(rgba);
	};
	
	
	// Readability Functions
	// ---------------------
	// <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)
	
	// `contrast`
	// Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
	tinycolor.readability = function(color1, color2) {
	    var c1 = tinycolor(color1);
	    var c2 = tinycolor(color2);
	    return (Math.max(c1.getLuminance(),c2.getLuminance())+0.05) / (Math.min(c1.getLuminance(),c2.getLuminance())+0.05);
	};
	
	// `isReadable`
	// Ensure that foreground and background color combinations meet WCAG2 guidelines.
	// The third argument is an optional Object.
	//      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
	//      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
	// If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.
	
	// *Example*
	//    tinycolor.isReadable("#000", "#111") => false
	//    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
	tinycolor.isReadable = function(color1, color2, wcag2) {
	    var readability = tinycolor.readability(color1, color2);
	    var wcag2Parms, out;
	
	    out = false;
	
	    wcag2Parms = validateWCAG2Parms(wcag2);
	    switch (wcag2Parms.level + wcag2Parms.size) {
	        case "AAsmall":
	        case "AAAlarge":
	            out = readability >= 4.5;
	            break;
	        case "AAlarge":
	            out = readability >= 3;
	            break;
	        case "AAAsmall":
	            out = readability >= 7;
	            break;
	    }
	    return out;
	
	};
	
	// `mostReadable`
	// Given a base color and a list of possible foreground or background
	// colors for that base, returns the most readable color.
	// Optionally returns Black or White if the most readable color is unreadable.
	// *Example*
	//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
	//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
	//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
	//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
	tinycolor.mostReadable = function(baseColor, colorList, args) {
	    var bestColor = null;
	    var bestScore = 0;
	    var readability;
	    var includeFallbackColors, level, size ;
	    args = args || {};
	    includeFallbackColors = args.includeFallbackColors ;
	    level = args.level;
	    size = args.size;
	
	    for (var i= 0; i < colorList.length ; i++) {
	        readability = tinycolor.readability(baseColor, colorList[i]);
	        if (readability > bestScore) {
	            bestScore = readability;
	            bestColor = tinycolor(colorList[i]);
	        }
	    }
	
	    if (tinycolor.isReadable(baseColor, bestColor, {"level":level,"size":size}) || !includeFallbackColors) {
	        return bestColor;
	    }
	    else {
	        args.includeFallbackColors=false;
	        return tinycolor.mostReadable(baseColor,["#fff", "#000"],args);
	    }
	};
	
	
	// Big List of Colors
	// ------------------
	// <http://www.w3.org/TR/css3-color/#svg-color>
	var names = tinycolor.names = {
	    aliceblue: "f0f8ff",
	    antiquewhite: "faebd7",
	    aqua: "0ff",
	    aquamarine: "7fffd4",
	    azure: "f0ffff",
	    beige: "f5f5dc",
	    bisque: "ffe4c4",
	    black: "000",
	    blanchedalmond: "ffebcd",
	    blue: "00f",
	    blueviolet: "8a2be2",
	    brown: "a52a2a",
	    burlywood: "deb887",
	    burntsienna: "ea7e5d",
	    cadetblue: "5f9ea0",
	    chartreuse: "7fff00",
	    chocolate: "d2691e",
	    coral: "ff7f50",
	    cornflowerblue: "6495ed",
	    cornsilk: "fff8dc",
	    crimson: "dc143c",
	    cyan: "0ff",
	    darkblue: "00008b",
	    darkcyan: "008b8b",
	    darkgoldenrod: "b8860b",
	    darkgray: "a9a9a9",
	    darkgreen: "006400",
	    darkgrey: "a9a9a9",
	    darkkhaki: "bdb76b",
	    darkmagenta: "8b008b",
	    darkolivegreen: "556b2f",
	    darkorange: "ff8c00",
	    darkorchid: "9932cc",
	    darkred: "8b0000",
	    darksalmon: "e9967a",
	    darkseagreen: "8fbc8f",
	    darkslateblue: "483d8b",
	    darkslategray: "2f4f4f",
	    darkslategrey: "2f4f4f",
	    darkturquoise: "00ced1",
	    darkviolet: "9400d3",
	    deeppink: "ff1493",
	    deepskyblue: "00bfff",
	    dimgray: "696969",
	    dimgrey: "696969",
	    dodgerblue: "1e90ff",
	    firebrick: "b22222",
	    floralwhite: "fffaf0",
	    forestgreen: "228b22",
	    fuchsia: "f0f",
	    gainsboro: "dcdcdc",
	    ghostwhite: "f8f8ff",
	    gold: "ffd700",
	    goldenrod: "daa520",
	    gray: "808080",
	    green: "008000",
	    greenyellow: "adff2f",
	    grey: "808080",
	    honeydew: "f0fff0",
	    hotpink: "ff69b4",
	    indianred: "cd5c5c",
	    indigo: "4b0082",
	    ivory: "fffff0",
	    khaki: "f0e68c",
	    lavender: "e6e6fa",
	    lavenderblush: "fff0f5",
	    lawngreen: "7cfc00",
	    lemonchiffon: "fffacd",
	    lightblue: "add8e6",
	    lightcoral: "f08080",
	    lightcyan: "e0ffff",
	    lightgoldenrodyellow: "fafad2",
	    lightgray: "d3d3d3",
	    lightgreen: "90ee90",
	    lightgrey: "d3d3d3",
	    lightpink: "ffb6c1",
	    lightsalmon: "ffa07a",
	    lightseagreen: "20b2aa",
	    lightskyblue: "87cefa",
	    lightslategray: "789",
	    lightslategrey: "789",
	    lightsteelblue: "b0c4de",
	    lightyellow: "ffffe0",
	    lime: "0f0",
	    limegreen: "32cd32",
	    linen: "faf0e6",
	    magenta: "f0f",
	    maroon: "800000",
	    mediumaquamarine: "66cdaa",
	    mediumblue: "0000cd",
	    mediumorchid: "ba55d3",
	    mediumpurple: "9370db",
	    mediumseagreen: "3cb371",
	    mediumslateblue: "7b68ee",
	    mediumspringgreen: "00fa9a",
	    mediumturquoise: "48d1cc",
	    mediumvioletred: "c71585",
	    midnightblue: "191970",
	    mintcream: "f5fffa",
	    mistyrose: "ffe4e1",
	    moccasin: "ffe4b5",
	    navajowhite: "ffdead",
	    navy: "000080",
	    oldlace: "fdf5e6",
	    olive: "808000",
	    olivedrab: "6b8e23",
	    orange: "ffa500",
	    orangered: "ff4500",
	    orchid: "da70d6",
	    palegoldenrod: "eee8aa",
	    palegreen: "98fb98",
	    paleturquoise: "afeeee",
	    palevioletred: "db7093",
	    papayawhip: "ffefd5",
	    peachpuff: "ffdab9",
	    peru: "cd853f",
	    pink: "ffc0cb",
	    plum: "dda0dd",
	    powderblue: "b0e0e6",
	    purple: "800080",
	    rebeccapurple: "663399",
	    red: "f00",
	    rosybrown: "bc8f8f",
	    royalblue: "4169e1",
	    saddlebrown: "8b4513",
	    salmon: "fa8072",
	    sandybrown: "f4a460",
	    seagreen: "2e8b57",
	    seashell: "fff5ee",
	    sienna: "a0522d",
	    silver: "c0c0c0",
	    skyblue: "87ceeb",
	    slateblue: "6a5acd",
	    slategray: "708090",
	    slategrey: "708090",
	    snow: "fffafa",
	    springgreen: "00ff7f",
	    steelblue: "4682b4",
	    tan: "d2b48c",
	    teal: "008080",
	    thistle: "d8bfd8",
	    tomato: "ff6347",
	    turquoise: "40e0d0",
	    violet: "ee82ee",
	    wheat: "f5deb3",
	    white: "fff",
	    whitesmoke: "f5f5f5",
	    yellow: "ff0",
	    yellowgreen: "9acd32"
	};
	
	// Make it easy to access colors via `hexNames[hex]`
	var hexNames = tinycolor.hexNames = flip(names);
	
	
	// Utilities
	// ---------
	
	// `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
	function flip(o) {
	    var flipped = { };
	    for (var i in o) {
	        if (o.hasOwnProperty(i)) {
	            flipped[o[i]] = i;
	        }
	    }
	    return flipped;
	}
	
	// Return a valid alpha value [0,1] with all invalid values being set to 1
	function boundAlpha(a) {
	    a = parseFloat(a);
	
	    if (isNaN(a) || a < 0 || a > 1) {
	        a = 1;
	    }
	
	    return a;
	}
	
	// Take input from [0, n] and return it as [0, 1]
	function bound01(n, max) {
	    if (isOnePointZero(n)) { n = "100%"; }
	
	    var processPercent = isPercentage(n);
	    n = mathMin(max, mathMax(0, parseFloat(n)));
	
	    // Automatically convert percentage into number
	    if (processPercent) {
	        n = parseInt(n * max, 10) / 100;
	    }
	
	    // Handle floating point rounding errors
	    if ((Math.abs(n - max) < 0.000001)) {
	        return 1;
	    }
	
	    // Convert into [0, 1] range if it isn't already
	    return (n % max) / parseFloat(max);
	}
	
	// Force a number between 0 and 1
	function clamp01(val) {
	    return mathMin(1, mathMax(0, val));
	}
	
	// Parse a base-16 hex value into a base-10 integer
	function parseIntFromHex(val) {
	    return parseInt(val, 16);
	}
	
	// Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
	// <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
	function isOnePointZero(n) {
	    return typeof n == "string" && n.indexOf('.') != -1 && parseFloat(n) === 1;
	}
	
	// Check to see if string passed in is a percentage
	function isPercentage(n) {
	    return typeof n === "string" && n.indexOf('%') != -1;
	}
	
	// Force a hex value to have 2 characters
	function pad2(c) {
	    return c.length == 1 ? '0' + c : '' + c;
	}
	
	// Replace a decimal with it's percentage value
	function convertToPercentage(n) {
	    if (n <= 1) {
	        n = (n * 100) + "%";
	    }
	
	    return n;
	}
	
	// Converts a decimal to a hex value
	function convertDecimalToHex(d) {
	    return Math.round(parseFloat(d) * 255).toString(16);
	}
	// Converts a hex value to a decimal
	function convertHexToDecimal(h) {
	    return (parseIntFromHex(h) / 255);
	}
	
	var matchers = (function() {
	
	    // <http://www.w3.org/TR/css3-values/#integers>
	    var CSS_INTEGER = "[-\\+]?\\d+%?";
	
	    // <http://www.w3.org/TR/css3-values/#number-value>
	    var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";
	
	    // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
	    var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";
	
	    // Actual matching.
	    // Parentheses and commas are optional, but not required.
	    // Whitespace can take the place of commas or opening paren
	    var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
	    var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
	
	    return {
	        CSS_UNIT: new RegExp(CSS_UNIT),
	        rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
	        rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
	        hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
	        hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
	        hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
	        hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
	        hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
	        hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
	        hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
	        hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
	    };
	})();
	
	// `isValidCSSUnit`
	// Take in a single string / number and check to see if it looks like a CSS unit
	// (see `matchers` above for definition).
	function isValidCSSUnit(color) {
	    return !!matchers.CSS_UNIT.exec(color);
	}
	
	// `stringInputToObject`
	// Permissive string parsing.  Take in a number of formats, and output an object
	// based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
	function stringInputToObject(color) {
	
	    color = color.replace(trimLeft,'').replace(trimRight, '').toLowerCase();
	    var named = false;
	    if (names[color]) {
	        color = names[color];
	        named = true;
	    }
	    else if (color == 'transparent') {
	        return { r: 0, g: 0, b: 0, a: 0, format: "name" };
	    }
	
	    // Try to match string input using regular expressions.
	    // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
	    // Just return an object and let the conversion functions handle that.
	    // This way the result will be the same whether the tinycolor is initialized with string or object.
	    var match;
	    if ((match = matchers.rgb.exec(color))) {
	        return { r: match[1], g: match[2], b: match[3] };
	    }
	    if ((match = matchers.rgba.exec(color))) {
	        return { r: match[1], g: match[2], b: match[3], a: match[4] };
	    }
	    if ((match = matchers.hsl.exec(color))) {
	        return { h: match[1], s: match[2], l: match[3] };
	    }
	    if ((match = matchers.hsla.exec(color))) {
	        return { h: match[1], s: match[2], l: match[3], a: match[4] };
	    }
	    if ((match = matchers.hsv.exec(color))) {
	        return { h: match[1], s: match[2], v: match[3] };
	    }
	    if ((match = matchers.hsva.exec(color))) {
	        return { h: match[1], s: match[2], v: match[3], a: match[4] };
	    }
	    if ((match = matchers.hex8.exec(color))) {
	        return {
	            r: parseIntFromHex(match[1]),
	            g: parseIntFromHex(match[2]),
	            b: parseIntFromHex(match[3]),
	            a: convertHexToDecimal(match[4]),
	            format: named ? "name" : "hex8"
	        };
	    }
	    if ((match = matchers.hex6.exec(color))) {
	        return {
	            r: parseIntFromHex(match[1]),
	            g: parseIntFromHex(match[2]),
	            b: parseIntFromHex(match[3]),
	            format: named ? "name" : "hex"
	        };
	    }
	    if ((match = matchers.hex4.exec(color))) {
	        return {
	            r: parseIntFromHex(match[1] + '' + match[1]),
	            g: parseIntFromHex(match[2] + '' + match[2]),
	            b: parseIntFromHex(match[3] + '' + match[3]),
	            a: convertHexToDecimal(match[4] + '' + match[4]),
	            format: named ? "name" : "hex8"
	        };
	    }
	    if ((match = matchers.hex3.exec(color))) {
	        return {
	            r: parseIntFromHex(match[1] + '' + match[1]),
	            g: parseIntFromHex(match[2] + '' + match[2]),
	            b: parseIntFromHex(match[3] + '' + match[3]),
	            format: named ? "name" : "hex"
	        };
	    }
	
	    return false;
	}
	
	function validateWCAG2Parms(parms) {
	    // return valid WCAG2 parms for isReadable.
	    // If input parms are invalid, return {"level":"AA", "size":"small"}
	    var level, size;
	    parms = parms || {"level":"AA", "size":"small"};
	    level = (parms.level || "AA").toUpperCase();
	    size = (parms.size || "small").toLowerCase();
	    if (level !== "AA" && level !== "AAA") {
	        level = "AA";
	    }
	    if (size !== "small" && size !== "large") {
	        size = "small";
	    }
	    return {"level":level, "size":size};
	}
	
	// Node: Export function
	if (typeof module !== "undefined" && module.exports) {
	    module.exports = tinycolor;
	}
	// AMD/requirejs: Define the module
	else if (true) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {return tinycolor;}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	// Browser: Expose to window
	else {
	    window.tinycolor = tinycolor;
	}
	
	})(Math);


/***/ },
/* 2470 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createUncontrollable;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(124);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _utils = __webpack_require__(2471);
	
	var utils = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function createUncontrollable(mixin, set) {
	
	  return uncontrollable;
	
	  function uncontrollable(Component, controlledValues) {
	    var _class, _temp;
	
	    var methods = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
	    var displayName = Component.displayName || Component.name || 'Component',
	        basePropTypes = utils.getType(Component).propTypes,
	        isCompositeComponent = utils.isReactComponent(Component),
	        controlledProps = Object.keys(controlledValues),
	        propTypes;
	
	    var OMIT_PROPS = ['valueLink', 'checkedLink'].concat(controlledProps.map(utils.defaultKey));
	
	    propTypes = utils.uncontrolledPropTypes(controlledValues, basePropTypes, displayName);
	
	    (0, _invariant2.default)(isCompositeComponent || !methods.length, '[uncontrollable] stateless function components cannot pass through methods ' + 'because they have no associated instances. Check component: ' + displayName + ', ' + 'attempting to pass through methods: ' + methods.join(', '));
	
	    methods = utils.transform(methods, function (obj, method) {
	      obj[method] = function () {
	        var _refs$inner;
	
	        return (_refs$inner = this.refs.inner)[method].apply(_refs$inner, arguments);
	      };
	    }, {});
	
	    var component = (_temp = _class = function (_React$Component) {
	      _inherits(component, _React$Component);
	
	      function component() {
	        _classCallCheck(this, component);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	      }
	
	      component.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return !mixin.shouldComponentUpdate || mixin.shouldComponentUpdate.apply(this, args);
	      };
	
	      component.prototype.componentWillMount = function componentWillMount() {
	        var _this2 = this;
	
	        var props = this.props;
	
	        this._values = {};
	
	        controlledProps.forEach(function (key) {
	          _this2._values[key] = props[utils.defaultKey(key)];
	        });
	      };
	
	      /**
	       * If a prop switches from controlled to Uncontrolled
	       * reset its value to the defaultValue
	       */
	
	
	      component.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        var _this3 = this;
	
	        var props = this.props;
	
	        if (mixin.componentWillReceiveProps) {
	          mixin.componentWillReceiveProps.call(this, nextProps);
	        }
	
	        controlledProps.forEach(function (key) {
	          if (utils.getValue(nextProps, key) === undefined && utils.getValue(props, key) !== undefined) {
	            _this3._values[key] = nextProps[utils.defaultKey(key)];
	          }
	        });
	      };
	
	      component.prototype.componentWillUnmount = function componentWillUnmount() {
	        this.unmounted = true;
	      };
	
	      component.prototype.getControlledInstance = function getControlledInstance() {
	        return this.refs.inner;
	      };
	
	      component.prototype.render = function render() {
	        var _this4 = this;
	
	        var newProps = {},
	            props = omitProps(this.props);
	
	        utils.each(controlledValues, function (handle, propName) {
	          var linkPropName = utils.getLinkName(propName),
	              prop = _this4.props[propName];
	
	          if (linkPropName && !isProp(_this4.props, propName) && isProp(_this4.props, linkPropName)) {
	            prop = _this4.props[linkPropName].value;
	          }
	
	          newProps[propName] = prop !== undefined ? prop : _this4._values[propName];
	
	          newProps[handle] = setAndNotify.bind(_this4, propName);
	        });
	
	        newProps = _extends({}, props, newProps, {
	          ref: isCompositeComponent ? 'inner' : null
	        });
	
	        return _react2.default.createElement(Component, newProps);
	      };
	
	      return component;
	    }(_react2.default.Component), _class.displayName = 'Uncontrolled(' + displayName + ')', _class.propTypes = propTypes, _temp);
	
	    _extends(component.prototype, methods);
	
	    component.ControlledComponent = Component;
	
	    /**
	     * useful when wrapping a Component and you want to control
	     * everything
	     */
	    component.deferControlTo = function (newComponent) {
	      var additions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var nextMethods = arguments[2];
	
	      return uncontrollable(newComponent, _extends({}, controlledValues, additions), nextMethods);
	    };
	
	    return component;
	
	    function setAndNotify(propName, value) {
	      var linkName = utils.getLinkName(propName),
	          handler = this.props[controlledValues[propName]];
	
	      if (linkName && isProp(this.props, linkName) && !handler) {
	        handler = this.props[linkName].requestChange;
	      }
	
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      set(this, propName, handler, value, args);
	    }
	
	    function isProp(props, prop) {
	      return props[prop] !== undefined;
	    }
	
	    function omitProps(props) {
	      var result = {};
	
	      utils.each(props, function (value, key) {
	        if (OMIT_PROPS.indexOf(key) === -1) result[key] = value;
	      });
	
	      return result;
	    }
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 2471 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.version = undefined;
	exports.uncontrolledPropTypes = uncontrolledPropTypes;
	exports.getType = getType;
	exports.getValue = getValue;
	exports.getLinkName = getLinkName;
	exports.defaultKey = defaultKey;
	exports.chain = chain;
	exports.transform = transform;
	exports.each = each;
	exports.has = has;
	exports.isReactComponent = isReactComponent;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(124);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function readOnlyPropType(handler, name) {
	  return function (props, propName) {
	    if (props[propName] !== undefined) {
	      if (!props[handler]) {
	        return new Error('You have provided a `' + propName + '` prop to ' + '`' + name + '` without an `' + handler + '` handler. This will render a read-only field. ' + 'If the field should be mutable use `' + defaultKey(propName) + '`. Otherwise, set `' + handler + '`');
	      }
	    }
	  };
	}
	
	function uncontrolledPropTypes(controlledValues, basePropTypes, displayName) {
	  var propTypes = {};
	
	  if (false) {
	    transform(controlledValues, function (obj, handler, prop) {
	      (0, _invariant2.default)(typeof handler === 'string' && handler.trim().length, 'Uncontrollable - [%s]: the prop `%s` needs a valid handler key name in order to make it uncontrollable', displayName, prop);
	
	      obj[prop] = readOnlyPropType(handler, displayName);
	    }, propTypes);
	  }
	
	  return propTypes;
	}
	
	var version = exports.version = _react2.default.version.split('.').map(parseFloat);
	
	function getType(component) {
	  if (version[0] >= 15 || version[0] === 0 && version[1] >= 13) return component;
	
	  return component.type;
	}
	
	function getValue(props, name) {
	  var linkPropName = getLinkName(name);
	
	  if (linkPropName && !isProp(props, name) && isProp(props, linkPropName)) return props[linkPropName].value;
	
	  return props[name];
	}
	
	function isProp(props, prop) {
	  return props[prop] !== undefined;
	}
	
	function getLinkName(name) {
	  return name === 'value' ? 'valueLink' : name === 'checked' ? 'checkedLink' : null;
	}
	
	function defaultKey(key) {
	  return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
	}
	
	function chain(thisArg, a, b) {
	  return function chainedFunction() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    a && a.call.apply(a, [thisArg].concat(args));
	    b && b.call.apply(b, [thisArg].concat(args));
	  };
	}
	
	function transform(obj, cb, seed) {
	  each(obj, cb.bind(null, seed = seed || (Array.isArray(obj) ? [] : {})));
	  return seed;
	}
	
	function each(obj, cb, thisArg) {
	  if (Array.isArray(obj)) return obj.forEach(cb, thisArg);
	
	  for (var key in obj) {
	    if (has(obj, key)) cb.call(thisArg, obj[key], key, obj);
	  }
	}
	
	function has(o, k) {
	  return o ? Object.prototype.hasOwnProperty.call(o, k) : false;
	}
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	function isReactComponent(component) {
	  return !!(component && component.prototype && component.prototype.isReactComponent);
	}

/***/ },
/* 2472 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,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"

/***/ },
/* 2473 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,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"

/***/ },
/* 2474 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,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"

/***/ },
/* 2475 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,QGltcG9ydCAnLi4vLi4vc3R5bGVzL3ZhcmlhYmxlcy5zY3NzJzsNCg0KLnVpbi1jb252LWhlYWRlciB7DQoJZGlzcGxheTogZmxleDsNCgliYWNrZ3JvdW5kLWNvbG9yOiB3aGl0ZTsNCglib3JkZXItYm90dG9tOiAxcHggc29saWQgJGdyZXktMjAwOw0KCWhlaWdodDogNC41cmVtOw0KCWZsZXg6IDAgMCBhdXRvOw0KCWFsaWduLWl0ZW1zOiBjZW50ZXI7DQoJcGFkZGluZzogMCAxcmVtOw0KCWJveC1zaXppbmc6IGNvbnRlbnQtYm94Ow0KCWp1c3RpZnktY29udGVudDogc3BhY2UtYmV0d2VlbjsNCgkudWluLWNvbnYtc3ViamVjdCB7DQoJCW1hcmdpbi1ib3R0b206IDA7DQoJCWNvbG9yOiAkZ3JleS02MDA7DQoJfQ0KCS51aW4tY29udi10aW1lIHsNCgkJZGlzcGxheTogZmxleDsNCgkJanVzdGlmeS1jb250ZW50OiBjZW50ZXI7DQoJCWFsaWduLWl0ZW1zOiBjZW50ZXI7DQoJCWZsZXgtd3JhcDogd3JhcDsNCgkJZm9udC1zaXplOiAxNHB4Ow0KCQljb2xvcjogJGdyZXktNzAwOw0KCQliIHsNCgkJCW1hcmdpbi1sZWZ0OiA4cHg7DQoJCQljb2xvcjogJGdyZXktOTAwOw0KCQkJZm9udC13ZWlnaHQ6ICRtZWRpdW07DQoJCX0NCgl9DQp9DQo="

/***/ },
/* 2476 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,QGltcG9ydCAnLi4vLi4vc3R5bGVzL3ZhcmlhYmxlcy5zY3NzJzsNCg0KLnVpbi1jb252LWxpc3Qgew0KCWhlaWdodDogMTAwJTsNCgl3aWR0aDogMTAwJTsNCglvdmVyZmxvdzogYXV0bzsNCiAgICBvdmVyZmxvdy14OiBoaWRkZW47DQp9DQo="

/***/ },
/* 2477 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,QGltcG9ydCAnLi4vLi4vLi4vc3R5bGVzL3ZhcmlhYmxlcy5zY3NzJzsNCg0KLnVpbi1jaGF0LWZvb3RlciB7DQoJZGlzcGxheTogZmxleDsNCglwYWRkaW5nOiAwIDAuODEyNXJlbTsNCgloZWlnaHQ6IDQuNzVyZW07DQoJYWxpZ24taXRlbXM6IGNlbnRlcjsNCglnYXA6IDAuODEyNXJlbTsNCgliYWNrZ3JvdW5kLWNvbG9yOiB3aGl0ZTsNCglib3JkZXItdG9wOiAxcHggc29saWQgJGdyZXktMjAwOw0KDQoJLnVpbi1tZXNzYWdlLWlucHV0IHsNCgkJZmxleC1ncm93OiAxOw0KCX0NCg0KCS5pbnB1dCB7DQoJCWRpc3BsYXk6IG5vbmU7DQoJfQ0KfQ0K"

/***/ },
/* 2478 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,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"

/***/ },
/* 2479 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,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"

/***/ },
/* 2480 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,QGltcG9ydCAnLi4vLi4vLi4vc3R5bGVzL3ZhcmlhYmxlcy5zY3NzJzsNCg0KLnVpbi1jb252LWNvbnRhY3QtaW5mbyB7DQoJd2lkdGg6IDE4LjEyNXJlbTsNCgloZWlnaHQ6IDEwMCU7DQoJZmxleDogMCAwIGF1dG87DQoJYm9yZGVyLWxlZnQ6IDFweCBzb2xpZCAkZ3JleS0xMDA7DQoJZGlzcGxheTogZmxleDsNCglmbGV4LWRpcmVjdGlvbjogY29sdW1uOw0KDQoJaGVhZGVyIHsNCgkJaGVpZ2h0OiA0LjVyZW07DQoJCWZsZXg6IDAgMCBhdXRvOw0KCQliYWNrZ3JvdW5kLWNvbG9yOiB3aGl0ZTsNCgkJcGFkZGluZzogMCAxcmVtOw0KCQlkaXNwbGF5OiBmbGV4Ow0KCQlhbGlnbi1pdGVtczogY2VudGVyOw0KCQljb2xvcjogJGdyZXktNjAwOw0KCQlib3JkZXItYm90dG9tOiAxcHggc29saWQgJGdyZXktMjAwOw0KCQlib3gtc2l6aW5nOiBjb250ZW50LWJveDsNCg0KCQkuZ2NsLWljb24gew0KCQkJbWFyZ2luLXJpZ2h0OiAxcmVtOw0KCQl9DQoJfQ0KDQoJLnVpbi1jb250YWN0LWJvZHkgew0KCQlmbGV4OiAxIDEgMTAwJTsNCgkJYmFja2dyb3VuZC1jb2xvcjogJGdyZXktNTA7DQoJCWRpc3BsYXk6IGZsZXg7DQoJCWZsZXgtZGlyZWN0aW9uOiBjb2x1bW47DQoJCXBhZGRpbmc6IDAgMXJlbTsNCgkJY29sb3I6ICRncmV5LTcwMDsNCg0KCQliIHsNCgkJCWZvbnQtd2VpZ2h0OiAkbWVkaXVtOw0KCQkJbWFyZ2luLWJvdHRvbTogMC4yNXJlbTsNCgkJfQ0KDQoJCT4gZGl2IHsNCgkJCWRpc3BsYXk6IGZsZXg7DQoJCQlmbGV4LWRpcmVjdGlvbjogY29sdW1uOw0KCQl9DQoNCgkJLnVpbi1jb250YWN0LXRpdGxlIHsNCgkJCWZsZXg6IDAgMCBhdXRvOw0KCQkJcGFkZGluZzogMS41cmVtIDAuNXJlbSAxcmVtOw0KCQkJYm9yZGVyLWJvdHRvbTogMXB4IHNvbGlkICRncmV5LTIwMDsNCgkJfQ0KDQoJCS51aW4tY29udGFjdC1pbmZvIHsNCgkJCWZsZXg6IDEgMSAxMDAlOw0KCQkJcGFkZGluZzogMXJlbSAwLjVyZW07DQoNCgkJCWIgew0KCQkJCW1hcmdpbi1ib3R0b206IDFyZW07DQoJCQl9DQoJCQlzcGFuIHsNCgkJCQltYXJnaW46IDAgMCAxcmVtIDAuNXJlbTsNCgkJCX0NCgkJfQ0KDQoJCS51aW4tY29udGFjdC1hY3Rpb25zIHsNCgkJCWZsZXg6IDAgMCBhdXRvOw0KCQkJcGFkZGluZy1ib3R0b206IDFyZW07DQoJCQlhbGlnbi1pdGVtczogY2VudGVyOw0KCQkJZ2FwOiAxcmVtOw0KCQl9DQoJfQ0KfQ0K"

/***/ },
/* 2481 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,QGltcG9ydCAnLi4vLi4vc3R5bGVzL3ZhcmlhYmxlcy5zY3NzJzsNCg0KLnVpbi1jb252ZXJzYXRpb24tdmlldyB7DQoJZGlzcGxheTogZmxleDsNCgl3aWR0aDogMTAwJTsNCgloZWlnaHQ6IDEwMCU7DQoJZmxleDogMSAxIGF1dG87DQoJb3ZlcmZsb3c6IGhpZGRlbjsNCg0KCS51aW4tY29udi12aWV3LXdyYXBwZXIgew0KCQlmbGV4OiAxIDEgMTAwJTsNCgkJb3ZlcmZsb3c6IGhpZGRlbjsNCgkJZGlzcGxheTogZmxleDsNCgkJZmxleC1kaXJlY3Rpb246IGNvbHVtbjsNCgkJLnVpbi1jb252LXZpZXcgew0KCQkJZmxleDogMSAxIDEwMCU7DQoJCQlvdmVyZmxvdzogaGlkZGVuOw0KCQkJYmFja2dyb3VuZC1jb2xvcjogI2Y4ZjlmOTsNCgkJCSYuZW1wdHkgew0KCQkJCWJhY2tncm91bmQtY29sb3I6ICRncmV5LTUwOw0KCQkJfQ0KCQl9DQoJfQ0KDQoJLnVpbi1jb252LWNvbnRhY3QtaW5mby13cmFwcGVyIHsNCgkJd2lkdGg6IDA7DQoJCXRyYW5zaXRpb246IHdpZHRoIDAuM3MgY3ViaWMtYmV6aWVyKDAuNCwgMCwgMC4yLCAxKTsNCg0KCQkmLm9wZW4gew0KCQkJd2lkdGg6IDE4LjEyNXJlbTsNCgkJfQ0KCX0NCn0NCg=="

/***/ },
/* 2482 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,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"

/***/ },
/* 2483 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,QGltcG9ydCAnLi4vLi4vc3R5bGVzL3ZhcmlhYmxlcy5zY3NzJzsNCg0KLnVpbi1kcmFnLWFyZWEgew0KCXBvc2l0aW9uOiBhYnNvbHV0ZTsNCgl3aWR0aDogMTAwJTsNCgloZWlnaHQ6IDEwMCU7DQoJdG9wOiAwOw0KCWxlZnQ6IDA7DQoJei1pbmRleDogOTk5Ow0KCXBhZGRpbmc6IDAuNXJlbTsNCgkuaW1hZ2UtdXBsb2FkLXdyYXAgew0KCQlwb3NpdGlvbjogcmVsYXRpdmU7DQoJCWRpc3BsYXk6IGZsZXg7DQoJCWZsZXgtZGlyZWN0aW9uOiBjb2x1bW47DQoJCWFsaWduLWl0ZW1zOiBjZW50ZXI7DQoJCWp1c3RpZnktY29udGVudDogY2VudGVyOw0KCQloZWlnaHQ6IDEwMCU7DQoJCXdpZHRoOiAxMDAlOw0KCQlib3JkZXItcmFkaXVzOiAwLjI1cmVtOw0KCQliYWNrZ3JvdW5kLWNvbG9yOiAkYmx1ZS01MDAtMjQ7DQoJCWJvcmRlcjogMnB4IGRhc2hlZCAkYmx1ZS0zMDA7DQoNCgkJLmZpbGUtdXBsb2FkLWlucHV0IHsNCgkJCXBvc2l0aW9uOiBhYnNvbHV0ZTsNCgkJCXdpZHRoOiAxMDAlOw0KCQkJaGVpZ2h0OiAxMDAlOw0KCQkJb3V0bGluZTogbm9uZTsNCgkJCW9wYWNpdHk6IDA7DQoJCQljdXJzb3I6IHBvaW50ZXI7DQoJCX0NCg0KCQkudGV4dC1pbmZvcm1hdGlvbiB7DQoJCQlmb250LXNpemU6IDEuNXJlbTsNCgkJCWNvbG9yOiAkYmx1ZS0zMDA7DQoJCQlmb250LXdlaWdodDogJG1lZGl1bTsNCg0KCQkJJi5ob3ZlciB7DQoJCQkJdmlzaWJpbGl0eTogdmlzaWJsZTsNCgkJCX0NCgkJfQ0KDQoJCS5zcGlubmVyLWJvcmRlciB7DQoJCQl3aWR0aDogMi43NXJlbTsNCgkJCWhlaWdodDogMi43NXJlbTsNCgkJCW1hcmdpbi1ib3R0b206IDFyZW07DQoJCX0NCgl9DQoNCgkmLmxvYWRpbmcgew0KCQkuaW1hZ2UtdXBsb2FkLXdyYXAgew0KCQkJYmFja2dyb3VuZC1jb2xvcjogJGJsdWUtNTA7DQoNCgkJCS50ZXh0LWluZm9ybWF0aW9uIHsNCgkJCQlmb250LXNpemU6IDAuODc1cmVtOw0KCQkJCWNvbG9yOiAkYmx1ZTsNCgkJCX0NCgkJfQ0KCX0NCn0NCg=="

/***/ },
/* 2484 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,QGltcG9ydCAnLi4vLi4vc3R5bGVzL3ZhcmlhYmxlcy5zY3NzJzsNCg0KLnVpbi1ncm91cC1pbWFnZSB7DQoJYm9yZGVyLXJhZGl1czogMC41cmVtOw0KCW92ZXJmbG93OiBoaWRkZW47DQoJZGlzcGxheTogZmxleDsNCg0KCSYuY29udGFpbiB7DQoJCWhlaWdodDogMzEycHg7DQoJCXdpZHRoOiAzMTJweDsNCgkJZ2FwOiAwLjI1cmVtOw0KDQoJCT4gKiB7DQoJCQlmbGV4OiAxIDEgMDsNCgkJCW1pbi13aWR0aDogMDsNCgkJCWhlaWdodDogMTAwJTsNCgkJCWJvcmRlci1yYWRpdXM6IDAuNXJlbTsNCgkJfQ0KDQoJCWRpdiB7DQoJCQlkaXNwbGF5OiBmbGV4Ow0KCQkJZmxleC1kaXJlY3Rpb246IGNvbHVtbjsNCgkJCWdhcDogMC4yNXJlbTsNCgkJCXBvc2l0aW9uOiByZWxhdGl2ZTsNCg0KCQkJaW1nIHsNCgkJCQl3aWR0aDogMTAwJTsNCgkJCQloZWlnaHQ6IDUwJTsNCgkJCQlib3JkZXItcmFkaXVzOiAwLjVyZW07DQoJCQl9DQoNCgkJCXNwYW4gew0KCQkJCXBvc2l0aW9uOiBhYnNvbHV0ZTsNCgkJCQl0b3A6IGNhbGMoNTAlICsgMC4xMjVyZW0pOw0KCQkJCWxlZnQ6IDA7DQoJCQkJaGVpZ2h0OiBjYWxjKDUwJSAtIDAuMTI1cmVtKTsNCgkJCQl3aWR0aDogMTAwJTsNCgkJCQliYWNrZ3JvdW5kLWNvbG9yOiByZ2JhKDAsIDAsIDAsIDAuNDgpOw0KCQkJCWJvcmRlci1yYWRpdXM6IDAuNXJlbTsNCgkJCQlmb250LXNpemU6IDJyZW07DQoJCQkJZm9udC13ZWlnaHQ6ICRzZW1pYm9sZDsNCgkJCQljb2xvcjogd2hpdGU7DQoJCQkJbGV0dGVyLXNwYWNpbmc6IDIuNTZweDsNCgkJCQlkaXNwbGF5OiBmbGV4Ow0KCQkJCWFsaWduLWl0ZW1zOiBjZW50ZXI7DQoJCQkJanVzdGlmeS1jb250ZW50OiBjZW50ZXI7DQoJCQkJY3Vyc29yOiBwb2ludGVyOw0KCQkJfQ0KCQl9DQoNCgkJaW1nIHsNCgkJCW9iamVjdC1maXQ6IGNvdmVyOw0KCQl9DQoJfQ0KDQoJPiBpbWcgew0KCQl3aWR0aDogMTAwJTsNCgl9DQoNCglpbWcgew0KCQljdXJzb3I6IHBvaW50ZXI7DQoJfQ0KfQ0K"

/***/ },
/* 2485 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,QGltcG9ydCAnLi4vLi4vc3R5bGVzL3ZhcmlhYmxlcy5zY3NzJzsNCg0KLnVpbi1saW5rcyB7DQoJLm1vZGFsLWNvbnRlbnQgew0KCQl3aWR0aDogNDAwcHg7DQoJCS5tb2RhbC1oZWFkZXIgew0KCQkJYm9yZGVyOiBub25lOw0KCQkJLm1vZGFsLXRpdGxlIHsNCgkJCQlmb250LXNpemU6IDIwcHg7DQoJCQkJZm9udC13ZWlnaHQ6ICRzZW1pYm9sZDsNCgkJCQljb2xvcjogJGdyZXktNjAwOw0KCQkJfQ0KCQkJYnV0dG9uLmNsb3NlIHsNCgkJCQlvdXRsaW5lOiAwOw0KCQkJCXNwYW4gew0KCQkJCQljb2xvcjogJGdyZXktNDAwOw0KCQkJCQlvdXRsaW5lOiAwOw0KCQkJCX0NCgkJCX0NCgkJfQ0KCQkubW9kYWwtYm9keSB7DQoJCQk+IGRpdjpsYXN0LWNoaWxkIHsNCgkJCQltYXJnaW4tdG9wOiA0MHB4Ow0KCQkJfQ0KCQl9DQoJCS5tb2RhbC1mb290ZXIgew0KCQkJd2lkdGg6IDEwMCU7DQoJCQloZWlnaHQ6IDIwJTsNCgkJCWRpc3BsYXk6IGZsZXg7DQoJCQlmbGV4LWRpcmVjdGlvbjogcm93Ow0KCQkJYWxpZ24taXRlbXM6IGNlbnRlcjsNCgkJCWp1c3RpZnktY29udGVudDogZmxleC1lbmQ7DQoJCQlib3JkZXI6IG5vbmU7DQoJCQlib3JkZXItdG9wOiBub25lOw0KCQl9DQoJfQ0KfQ0K"

/***/ },
/* 2486 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,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"

/***/ },
/* 2487 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,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"

/***/ },
/* 2488 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,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"

/***/ },
/* 2489 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,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"

/***/ },
/* 2490 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,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"

/***/ },
/* 2491 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,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"

/***/ },
/* 2492 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,QGltcG9ydCAnLi4vLi4vc3R5bGVzL3ZhcmlhYmxlcy5zY3NzJzsNCg0KLnVpbi1maWxlLW1lc3NhZ2Ugew0KCWRpc3BsYXk6IGZsZXg7DQoJbWFyZ2luOiAwLjI1cmVtIDAuNzVyZW0gMC4yNXJlbTsNCgl3aWR0aDogMTguNXJlbTsNCg0KCS51aW4tZmlsZS1pY29uIHsNCiAgICAgICAgZmxleDogMCAwIGF1dG87DQoJCWRpc3BsYXk6IGZsZXg7DQoJCW1hcmdpbi10b3A6IDAuMjVyZW07DQoJCW1hcmdpbi1yaWdodDogMC43NXJlbTsNCg0KCQkucmVzcG9uc2UgJiAuZ2NsLWljb24gew0KCQkJYmFja2dyb3VuZC1jb2xvcjogd2hpdGU7DQoJCX0NCgl9DQoNCgkudWluLWZpbGUtaW5mbyB7DQoJCWRpc3BsYXk6IGZsZXg7DQoJCWZsZXgtZGlyZWN0aW9uOiBjb2x1bW47DQoJCWxpbmUtaGVpZ2h0OiAxLjI1cmVtOw0KCQltYXJnaW4tcmlnaHQ6IDFyZW07DQoJCWZsZXg6IDEgMSAxMDAlOw0KICAgICAgICBvdmVyZmxvdzogaGlkZGVuOw0KDQoJCS51aW4tZmlsZS1uYW1lIHsNCgkJCWZvbnQtc2l6ZTogMC44NzVyZW07DQoJCQljb2xvcjogIzY5NzM3YTsNCgkJCW1hcmdpbi1ib3R0b206IDAuMjVyZW07DQogICAgICAgICAgICBtYXgtd2lkdGg6IDEwMCU7DQogICAgICAgICAgICBvdmVyZmxvdzogaGlkZGVuOw0KICAgICAgICAgICAgdGV4dC1vdmVyZmxvdzogZWxsaXBzaXM7DQoNCgkJCS5yZXNwb25zZSAmIHsNCgkJCQljb2xvcjogd2hpdGU7DQoJCQl9DQoJCX0NCgkJLnVpbi1maWxlLWRhdGEgew0KCQkJZm9udC1zaXplOiAwLjc1cmVtOw0KCQkJY29sb3I6ICRncmV5LTYwMDsNCg0KCQkJLnJlc3BvbnNlICYgew0KCQkJCWNvbG9yOiB3aGl0ZTsNCgkJCX0NCgkJfQ0KCX0NCg0KCS5nY2wtYnRuSWNvbiB7DQoJCWZsZXg6IDAgMCBhdXRvOw0KCQltYXJnaW4tdG9wOiAwLjVyZW07DQoNCgkJLnJlc3BvbnNlICYgLmdjbC1pY29uIHsNCgkJCWJhY2tncm91bmQtY29sb3I6IHdoaXRlOw0KCQkJdHJhbnNpdGlvbjogb3BhY2l0eSAwLjNzIGVhc2Utb3V0Ow0KCQkJJjpob3ZlciB7DQoJCQkJb3BhY2l0eTogMC44Ow0KCQkJfQ0KCQkJJjphY3RpdmUgew0KCQkJCW9wYWNpdHk6IDAuNjsNCgkJCX0NCgkJfQ0KCX0NCn0NCg=="

/***/ },
/* 2493 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,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"

/***/ },
/* 2494 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,QGltcG9ydCAnLi4vLi4vc3R5bGVzL3ZhcmlhYmxlcy5zY3NzJzsNCg0KLnVpbi12aWRlby1jb250YWluZXIgew0KICAgIC8vIGhlaWdodCAgICAgICA6IDEwMCU7DQogICAgd2lkdGggICAgICAgIDogMTAwJTsNCiAgICBib3JkZXItcmFkaXVzOiAwLjVyZW07DQogICAgb3ZlcmZsb3cgICAgIDogaGlkZGVuOw0KDQogICAgLnVpbi12aWRlby13cmFwZXIgew0KICAgICAgICBkaXNwbGF5ICAgICAgICA6IGZsZXg7DQogICAgICAgIGp1c3RpZnktY29udGVudDogY2VudGVyOw0KICAgICAgICBhbGlnbi1pdGVtcyAgICA6IGNlbnRlcjsNCiAgICAgICAgcG9zaXRpb246IHJlbGF0aXZlOw0KICAgICAgICBjdXJzb3I6IHBvaW50ZXI7DQoNCiAgICAgICAgLnVpbi12aWRlby1pY29uIHsNCiAgICAgICAgICAgIGRpc3BsYXkgICAgICAgICA6IGZsZXg7DQogICAgICAgICAgICBiYWNrZ3JvdW5kLWNvbG9yOiByZ2JhKDAsMCwwLDAuNTYpOw0KICAgICAgICAgICAgYm9yZGVyLXJhZGl1cyAgIDogNTAlOw0KICAgICAgICAgICAgd2lkdGg6IDMuNXJlbTsNCiAgICAgICAgICAgIGhlaWdodDogMy41cmVtOw0KICAgICAgICAgICAganVzdGlmeS1jb250ZW50IDogY2VudGVyOw0KICAgICAgICAgICAgYWxpZ24taXRlbXMgICAgIDogY2VudGVyOw0KICAgICAgICAgICAgcG9zaXRpb24gICAgICAgIDogYWJzb2x1dGU7DQogICAgICAgICAgICB6LWluZGV4ICAgICAgICAgOiAxOw0KDQogICAgICAgICAgICAuZ2NsLWljb24gew0KICAgICAgICAgICAgICAgIGJhY2tncm91bmQtY29sb3I6IHdoaXRlOw0KICAgICAgICAgICAgfQ0KICAgICAgICB9DQoNCiAgICAgICAgLnVpbi12aWRlby12aWRlbyB7DQogICAgICAgICAgICBkaXNwbGF5OiBmbGV4Ow0KICAgICAgICAgICAgLnZpZGVvew0KICAgICAgICAgICAgICAgIG1heC13aWR0aCAgICA6IDMyOHB4Ow0KICAgICAgICAgICAgfQ0KICAgICAgICB9DQogICAgfQ0KfQ=="

/***/ },
/* 2495 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,QGltcG9ydCAnLi4vLi4vc3R5bGVzL3ZhcmlhYmxlcy5zY3NzJzsNCg0KLnVpbi1tZXNzYWdlLWJhci1jb250ZWluZXJ7DQogICAgZGlzcGxheTogZmxleDsNCiAgICBqdXN0aWZ5LWNvbnRlbnQ6IHNwYWNlLWFyb3VuZDsNCiAgICBhbGlnbi1pdGVtczogY2VudGVyOw0KICAgIGJhY2tncm91bmQtY29sb3I6ICRncmV5LTUwOw0KICAgIG1pbi1oZWlnaHQ6IDg0cHg7DQogICAgd2lkdGg6IDEwMCU7DQp9"

/***/ },
/* 2496 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,QGltcG9ydCAnLi4vLi4vc3R5bGVzL3ZhcmlhYmxlcy5zY3NzJzsNCg0KLnVpbi1zZy1jb250YWluZXIgew0KCWRpc3BsYXk6IGZsZXg7DQoJcGFkZGluZzogMC4yNXJlbSAxcmVtOw0KCWFsaWduLWl0ZW1zOiBjZW50ZXI7DQoNCgkudWluLXNnLXNlcGFyYXRvciB7DQoJCWRpc3BsYXk6IGlubGluZS1ibG9jazsNCgkJd2lkdGg6IDFweDsNCgkJaGVpZ2h0OiAxLjVyZW07DQoJCWJhY2tncm91bmQtY29sb3I6ICRncmV5LTEwMDsNCgkJbWFyZ2luOiAwIDAuMjVyZW07DQoJfQ0KfQ0K"

/***/ },
/* 2497 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,QGltcG9ydCAnLi4vLi4vc3R5bGVzL3ZhcmlhYmxlcy5zY3NzJzsNCg0KLnVpbi1uZXctdGFiLWJhciB7DQoJZGlzcGxheTogZmxleDsNCglmbGV4LWRpcmVjdGlvbjogY29sdW1uOw0KCXBhZGRpbmctbGVmdDogMC41cmVtOw0KCXBhZGRpbmctcmlnaHQ6IDAuNXJlbTsNCgl3aWR0aDogMTQuMzc1cmVtOw0KCXRyYW5zaXRpb246IHdpZHRoIDAuM3MgY3ViaWMtYmV6aWVyKDAuNCwgMCwgMC4yLCAxKTsNCg0KCSYuY29sbGFwc2VkIHsNCgkJd2lkdGg6IDMuNXJlbTsNCgl9DQoNCgkudWluLW5ldy10YWItYmFyLXRpdGxlIHsNCgkJZGlzcGxheTogZmxleDsNCgkJYWxpZ24taXRlbXM6IGNlbnRlcjsNCgkJanVzdGlmeS1jb250ZW50OiBmbGV4LWVuZDsNCgkJaGVpZ2h0OiAxLjVyZW07DQoJCW1hcmdpbjogMXJlbSAwLjVyZW0gMXJlbTsNCgkJb3ZlcmZsb3c6IGhpZGRlbjsNCg0KCQkvKiAuY29sbGFwc2VkICYgew0KCQkJanVzdGlmeS1jb250ZW50OiBjZW50ZXI7DQoJCX0gKi8NCgkJLnVpbi1uZXctdGFiLWJhci10aXRsZS1mb250IHsNCgkJCWZsZXg6IDEgMSAxMDAlOw0KCQkJZm9udC13ZWlnaHQ6ICRtZWRpdW07DQoJCQlmb250LXNpemU6IDAuNjI1cmVtOw0KCQkJbGV0dGVyLXNwYWNpbmc6IDEuNnB4Ow0KCQkJdGV4dC10cmFuc2Zvcm06IHVwcGVyY2FzZTsNCgkJCWNvbG9yOiAkZ3JleS02MDA7DQoJCX0NCgkJLnVpbi1uZXctdGFiLWJhci10aXRsZS1pY29uIHsNCgkJCWZsZXg6IDAgMCBhdXRvOw0KCQkJZGlzcGxheTogZmxleDsNCgkJCWp1c3RpZnktY29udGVudDogY2VudGVyOw0KCQkJYWxpZ24taXRlbXM6IGNlbnRlcjsNCgkJCXdpZHRoOiAyNHB4Ow0KCQkJaGVpZ2h0OiAyNHB4Ow0KICAgICAgICAgICAgbWFyZ2luLWxlZnQ6IDFyZW07DQoJCQlib3JkZXItcmFkaXVzOiAwLjlyZW07DQoJCQlib3JkZXI6IDFweCAkZ3JleS0xMDAgc29saWQ7DQoJCX0NCgl9DQp9DQo="

/***/ },
/* 2498 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,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"

/***/ },
/* 2499 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,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"

/***/ },
/* 2500 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,QGltcG9ydCAnLi4vLi4vc3R5bGVzL3ZhcmlhYmxlcy5zY3NzJzsNCg0KLnVpbi10eXBpbmctaW5kaWNhdG9yIHsNCgktLXNpemU6IDAuNXJlbTsNCg0KCXdpZHRoOiBjYWxjKCh2YXIoLS1zaXplKSAqIDMpICsgMC41cmVtKTsNCgloZWlnaHQ6IHZhcigtLXNpemUpOw0KCXBhZGRpbmc6IDAuMjVyZW0gMDsNCglwb3NpdGlvbjogcmVsYXRpdmU7DQoJYm94LXNpemluZzogY29udGVudC1ib3g7DQoNCgkmLmNvbnRhaW5lZCB7DQoJCWJhY2tncm91bmQtY29sb3I6ICRncmV5LTEwMDsNCgkJYm9yZGVyLXJhZGl1czogY2FsYyh2YXIoLS1zaXplKSAqIDQpOw0KCQlwYWRkaW5nOiBjYWxjKHZhcigtLXNpemUpICogMikgMC44NzVyZW07DQoJfQ0KDQoJJi5zbWFsbCB7DQoJCS0tc2l6ZTogMC4zNzVyZW07DQoJfQ0KDQoJLnVpbi10aS1kb3Qgew0KCQl3aWR0aDogdmFyKC0tc2l6ZSk7DQoJCWhlaWdodDogdmFyKC0tc2l6ZSk7DQoJCWJhY2tncm91bmQtY29sb3I6ICRncmV5LTQwMDsNCgkJYm9yZGVyLXJhZGl1czogdmFyKC0tc2l6ZSk7DQoJCXRyYW5zZm9ybTogdHJhbnNsYXRlWSgwcHgpOw0KCQktbXMtdHJhbnNmb3JtOiB0cmFuc2xhdGVZKDBweCk7DQoJCWRpc3BsYXk6IGlubGluZS1ibG9jazsNCgkJdmVydGljYWwtYWxpZ246IHRvcDsNCgkJdHJhbnNpdGlvbjogYmFja2dyb3VuZC1jb2xvciAwLjNzIGVhc2Utb3V0Ow0KDQoJCSY6bm90KDpmaXJzdC1jaGlsZCkgew0KCQkJbWFyZ2luLWxlZnQ6IDAuMjVyZW07DQoJCX0NCg0KCQkmOmZpcnN0LWNoaWxkIHsNCgkJCWFuaW1hdGlvbjogdHJhbnNsYXRlWSAwLjVzIGVhc2Utb3V0IGluZmluaXRlOw0KCQl9DQoNCgkJJjpudGgtY2hpbGQoMikgew0KCQkJYW5pbWF0aW9uOiB0cmFuc2xhdGVZIDAuNXMgZWFzZS1vdXQgMC4ycyBpbmZpbml0ZTsNCgkJfQ0KDQoJCSY6bnRoLWNoaWxkKDMpIHsNCgkJCWFuaW1hdGlvbjogdHJhbnNsYXRlWSAwLjVzIGVhc2Utb3V0IDAuM3MgaW5maW5pdGU7DQoJCX0NCgl9DQp9DQoNCkBrZXlmcmFtZXMgdHJhbnNsYXRlWSB7DQoJMCUsDQoJMTAwJSB7DQoJCS1tcy10cmFuc2Zvcm06IHRyYW5zbGF0ZVkoMHB4KTsNCgkJdHJhbnNmb3JtOiB0cmFuc2xhdGVZKDBweCk7DQoJfQ0KCTUwJSB7DQoJCS1tcy10cmFuc2Zvcm06IHRyYW5zbGF0ZVkoLTUwJSk7DQoJCXRyYW5zZm9ybTogdHJhbnNsYXRlWSgtNTAlKTsNCgl9DQp9DQo="

/***/ },
/* 2501 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,QGltcG9ydCAnLi4vc3R5bGVzL3ZhcmlhYmxlcy5zY3NzJzsNCg0KLnVpbi1jb250YWluZXIgew0KCWRpc3BsYXk6IGZsZXg7DQoJd2lkdGg6IDEwMCU7DQoJaGVpZ2h0OiAxMDAlOw0KCW92ZXJmbG93OiBoaWRkZW47DQoJLnVpbi11bS10YWJzIHsNCgkJZGlzcGxheTogZmxleDsNCgkJanVzdGlmeS1jb250ZW50OiBjZW50ZXI7DQoJCWJvcmRlci1yaWdodDogMXB4ICRncmV5LTEwMCBzb2xpZDsNCiAgICAgICAgZmxleDogMCAwIGF1dG87DQoJfQ0KCS51aW4td3JhcHBlci1jb252ZXJzYXRpb24gew0KCQlkaXNwbGF5OiBmbGV4Ow0KCQlmbGV4OiAxIDEgMTAwJTsNCgkJb3ZlcmZsb3c6IGhpZGRlbjsNCgkJLnVpbS1jb252ZXJzYXRpb24gew0KCQkJd2lkdGg6IDI0cmVtOw0KICAgICAgICAgICAgZmxleDogMCAwIGF1dG87DQoJCQlib3JkZXItcmlnaHQ6IDFweCAkZ3JleS0xMDAgc29saWQ7DQoJCX0NCgl9DQp9DQo="

/***/ },
/* 2502 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,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"

/***/ },
/* 2503 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,QGltcG9ydCAnLi4vLi4vLi4vc3R5bGVzL3ZhcmlhYmxlcy5zY3NzJzsNCg0KLnVpbi1hZGRyZXNzLWlucHV0IHsNCglwYWRkaW5nOiAwLjVyZW0gMXJlbSAwOw0KCWJvcmRlci1ib3R0b206IDFweCBzb2xpZCAkZ3JleS0yMDA7DQoJZGlzcGxheTogZmxleDsNCglsaW5lLWhlaWdodDogMi41cmVtOw0KCW1pbi1oZWlnaHQ6IDMuNXJlbTsNCglhbGlnbi1pdGVtczogYmFzZWxpbmU7DQoNCgkudWluLWFpbi1sYWJlbCB7DQoJCWZvbnQtc2l6ZTogMC44NzVyZW07DQoJCWNvbG9yOiAkZ3JleS03MDA7DQoJCWZvbnQtd2VpZ2h0OiAkbWVkaXVtOw0KCQl0ZXh0LXRyYW5zZm9ybTogdXBwZXJjYXNlOw0KCQlsaW5lLWhlaWdodDogMS4yNXJlbTsNCgkJZmxleC1zaHJpbms6IDA7DQoJCW1hcmdpbjogMCAxcmVtIDAuNXJlbSAwOw0KCX0NCg0KCS51aW4tYWluLWFkZHJlc3NlcyB7DQoJCWRpc3BsYXk6IGZsZXg7DQoJCWZsZXgtd3JhcDogd3JhcDsNCgkJZmxleC1ncm93OiAxOw0KDQoJCS51aW4taW5wdXQtY2hpcCB7DQoJCQltYXJnaW46IDAgMC41cmVtIDAuNXJlbSAwOw0KCQl9DQoJfQ0KfQ0KDQoudWluLWFpbi1saXN0LWlucHV0IHsNCglvdXRsaW5lOiBub25lOw0KCWJvcmRlcjogbm9uZTsNCgltYXJnaW4tYm90dG9tOiAwLjVyZW07DQoJZmxleC1ncm93OiAxOw0KDQoJaW5wdXQgew0KCQlvdXRsaW5lOiBub25lOw0KCQlib3JkZXI6IG5vbmU7DQoJCWZvbnQtc2l6ZTogMXJlbTsNCgkJZm9udC13ZWlnaHQ6ICRtZWRpdW07DQoJCWNvbG9yOiAkZ3JleS03MDA7DQoJCXBhZGRpbmc6IDA7DQoJCWhlaWdodDogMi41cmVtOw0KCQl3aWR0aDogMTAwJTsNCgl9DQoNCgkmLmF1dG8gew0KCQlmbGV4OiAwIDAgYXV0bzsNCgkJbWFyZ2luLXJpZ2h0OiAwLjVyZW07DQoJCWlucHV0IHsNCgkJCW1pbi13aWR0aDogMnJlbTsNCgkJfQ0KCX0NCn0NCg=="

/***/ },
/* 2504 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,QGltcG9ydCAnLi4vLi4vLi4vc3R5bGVzL3ZhcmlhYmxlcy5zY3NzJzsNCg0KLnVpbi1jb250YWN0LWRhdGEgew0KCWp1c3RpZnktY29udGVudDpmbGV4LXN0YXJ0Ow0KCWRpc3BsYXk6IGZsZXg7DQoJYWxpZ24taXRlbXM6IGNlbnRlcjsNCiAgICBmbGV4OiAwIDAgYXV0bzsNCiAgICBvdmVyZmxvdzogaGlkZGVuOw0KDQoJLnVpbi1pbWFnZS1pY29uIHsNCgkJaGVpZ2h0OiA0MHB4Ow0KCQl3aWR0aDogNDBweDsNCgkJbWFyZ2luLXJpZ2h0OiAxNnB4Ow0KICAgICAgICBmbGV4OiAwIDAgYXV0bzsNCg0KCQlpbWcgew0KCQkJaGVpZ2h0OiBjYWxjKDYwJSk7DQoJCQl3aWR0aDogY2FsYyg2MCUpOw0KCQl9DQoJfQ0KDQoJaDYgew0KCQlmb250LXNpemU6IDIwcHg7DQoJCW1hcmdpbi1ib3R0b206IDA7DQoJCWNvbG9yOiAkZ3JleS02MDA7DQoJfQ0KDQoJLnVpbi1jb250YWN0LWFjY291bnQgew0KCQlkaXNwbGF5OiBmbGV4Ow0KICAgICAgICBtYXJnaW4tcmlnaHQ6IDFyZW07DQoJCWZsZXgtZGlyZWN0aW9uOiBjb2x1bW47DQogICAgICAgIGZsZXg6IDEgMSAxMDAlOw0KICAgICAgICBvdmVyZmxvdzogaGlkZGVuOw0KDQoJCXAgew0KCQkJbWFyZ2luLWJvdHRvbTogMDsNCgkJCWNvbG9yOiAkZ3JleS03MDA7DQoJCQlmb250LXdlaWdodDogJG1lZGl1bTsNCgkJCWxpbmUtaGVpZ2h0OiAyMnB4Ow0KICAgICAgICAgICAgb3ZlcmZsb3c6IGhpZGRlbjsNCiAgICAgICAgICAgIHdoaXRlLXNwYWNlOiBub3dyYXA7DQogICAgICAgICAgICB0ZXh0LW92ZXJmbG93OiBlbGxpcHNpczsNCgkJfQ0KCQlzcGFuIHsNCgkJCWNvbG9yOiAkZ3JleS01MDA7DQogICAgICAgICAgICBvdmVyZmxvdzogaGlkZGVuOw0KICAgICAgICAgICAgd2hpdGUtc3BhY2U6IG5vd3JhcDsNCiAgICAgICAgICAgIHRleHQtb3ZlcmZsb3c6IGVsbGlwc2lzOw0KCQl9DQoJfQ0KfQ0K"

/***/ },
/* 2505 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,QGltcG9ydCAnLi4vLi4vLi4vc3R5bGVzL3ZhcmlhYmxlcy5zY3NzJzsNCg0KLnVpbi1kYXRlLWRpdmlkZXIgew0KICAgIG1hcmdpbjogMXJlbSAwOw0KICAgIGRpc3BsYXk6IGZsZXg7DQogICAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7DQogICAgcG9zaXRpb246IHJlbGF0aXZlOw0KICAgIC51aW4tZGF0ZS1kaXZpZGVyLWNvbnRhaW5lciB7DQogICAgICAgIHdpZHRoOiAxMDAlOw0KICAgICAgICBkaXNwbGF5OiBmbGV4Ow0KICAgICAgICBhbGlnbi1pdGVtczogY2VudGVyOw0KICAgICAgICAmOjpiZWZvcmV7DQogICAgICAgICAgICBtYXJnaW4tcmlnaHQ6IDAuNXJlbTsNCiAgICAgICAgfQ0KICAgICAgICAmOjphZnRlcnsNCiAgICAgICAgICAgIG1hcmdpbi1sZWZ0OiAwLjVyZW07DQogICAgICAgIH0NCiAgICAgICAgJjpiZWZvcmUsICY6YWZ0ZXJ7DQogICAgICAgICAgICBkaXNwbGF5OiBpbmxpbmUtYmxvY2s7DQogICAgICAgICAgICBjb250ZW50OiAiIjsNCiAgICAgICAgICAgIGJvcmRlci10b3A6IDFweCBzb2xpZCAkZ3JleS0zMDA7DQogICAgICAgICAgICB3aWR0aDogMTAwJTsNCiAgICAgICAgfQ0KICAgICAgICBzcGFuew0KICAgICAgICAgICAgZm9udC1zaXplOiAwLjg3NXJlbTsNCiAgICAgICAgICAgIGZvbnQtd2VpZ2h0OiAkbWVkaXVtOw0KICAgICAgICAgICAgY29sb3I6ICRncmV5LTUwMDsNCiAgICAgICAgICAgIGJvcmRlcjogMXB4IHNvbGlkICRncmV5LTUwMDsNCiAgICAgICAgICAgIGJvcmRlci1yYWRpdXM6IDEuNXJlbTsNCiAgICAgICAgICAgIGp1c3RpZnktY29udGVudDogY2VudGVyOw0KICAgICAgICAgICAgZmxleC13cmFwOiBub3dyYXA7DQogICAgICAgICAgICBkaXNwbGF5OiBpbmxpbmUtYmxvY2s7DQogICAgICAgICAgICB3aWR0aDogYXV0bzsNCiAgICAgICAgICAgIHdoaXRlLXNwYWNlOiBub3dyYXA7DQogICAgICAgICAgICBwYWRkaW5nOiAwLjM3NXJlbSAxcmVtOw0KICAgICAgICB9DQogICAgfQ0KfQ0K"

/***/ },
/* 2506 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,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"

/***/ },
/* 2507 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,QGltcG9ydCAnLi4vLi4vLi4vc3R5bGVzL3ZhcmlhYmxlcy5zY3NzJzsNCg0KLnVpbi1pY29uLWJ0biB7DQoJYWxsOiB1bnNldDsNCglkaXNwbGF5OiBpbmxpbmUtYmxvY2s7DQoJaGVpZ2h0OiAycmVtOw0KCXdpZHRoOiAycmVtOw0KCXBhZGRpbmc6IDAuMTg3NXJlbTsNCglvdXRsaW5lOiBub25lOw0KCWJvcmRlci1yYWRpdXM6IDAuNXJlbTsNCgl0cmFuc2l0aW9uOiBib3gtc2hhZG93IDAuMnMgZWFzZS1vdXQsIGJhY2tncm91bmQtY29sb3IgMC4ycyBlYXNlLW91dDsNCg0KCS5nY2wtaWNvbiB7DQoJCWJhY2tncm91bmQtY29sb3I6ICRibHVlOw0KCX0NCg0KCSY6Zm9jdXMgew0KCQlib3gtc2hhZG93OiAkZm9jdXMtc2hhZG93Ow0KDQoJCS5nY2wtaWNvbiB7DQoJCQliYWNrZ3JvdW5kLWNvbG9yOiAkYmx1ZS02MDA7DQoJCX0NCgl9DQoNCgkmOmhvdmVyIC5nY2wtaWNvbiB7DQoJCWJhY2tncm91bmQtY29sb3I6ICRibHVlLTYwMDsNCgl9DQoNCgkmOmFjdGl2ZSB7DQoJCWJveC1zaGFkb3c6IG5vbmU7DQoNCgkJLmdjbC1pY29uIHsNCgkJCWJhY2tncm91bmQtY29sb3I6ICRibHVlLTcwMDsNCgkJfQ0KCX0NCg0KCSY6ZGlzYWJsZWQgLmdjbC1pY29uIHsNCgkJYmFja2dyb3VuZC1jb2xvcjogJGdyZXktMjAwOw0KCX0NCg0KCSYuc2Vjb25kYXJ5IHsNCgkJJjpub3QoLmxhcmdlKSB7DQoJCQloZWlnaHQ6IDEuNXJlbTsNCgkJCXdpZHRoOiAxLjVyZW07DQoJCQlwYWRkaW5nOiAwLjI1cmVtOw0KCQkJYm9yZGVyLXJhZGl1czogMC4yNXJlbTsNCgkJfQ0KDQoJCS5nY2wtaWNvbiB7DQoJCQliYWNrZ3JvdW5kLWNvbG9yOiAkZ3JleS03MDA7DQoJCX0NCg0KCQkmOmhvdmVyIHsNCgkJCWJhY2tncm91bmQtY29sb3I6ICRncmV5LTEwMDsNCg0KCQkJLmdjbC1pY29uIHsNCgkJCQliYWNrZ3JvdW5kLWNvbG9yOiAkYmxhY2stMTAwOw0KCQkJfQ0KCQl9DQoNCgkJJjpmb2N1czpub3QoLmxhcmdlKSB7DQoJCQlib3gtc2hhZG93OiAkZm9jdXMtc2hhZG93LXNtYWxsOw0KCQkJei1pbmRleDogMTsNCgkJfQ0KDQoJCSY6YWN0aXZlIHsNCgkJCWJveC1zaGFkb3c6IG5vbmU7DQoJCQliYWNrZ3JvdW5kLWNvbG9yOiAkZ3JleS0yMDA7DQoNCgkJCS5nY2wtaWNvbiB7DQoJCQkJYmFja2dyb3VuZC1jb2xvcjogJGJsYWNrLTIwMDsNCgkJCX0NCgkJfQ0KDQoJCSYuYWN0aXZlIHsNCgkJCWJhY2tncm91bmQtY29sb3I6ICRncmV5LTIwMDsNCg0KCQkJLmdjbC1pY29uIHsNCgkJCQliYWNrZ3JvdW5kLWNvbG9yOiAkYmxhY2stMjAwOw0KCQkJfQ0KCQl9DQoNCgkJJjpkaXNhYmxlZCB7DQoJCQliYWNrZ3JvdW5kLWNvbG9yOiAkZ3JleS01MDsNCg0KCQkJLmdjbC1pY29uIHsNCgkJCQliYWNrZ3JvdW5kLWNvbG9yOiAkZ3JleS0yMDA7DQoJCQl9DQoJCX0NCgl9DQp9DQo="

/***/ },
/* 2508 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,QGltcG9ydCAnLi4vLi4vLi4vc3R5bGVzL3ZhcmlhYmxlcy5zY3NzJzsNCg0KLnVpbi1pbWFnZS1pY29uIHsNCglkaXNwbGF5OiBpbmxpbmUtZmxleDsNCglib3JkZXItcmFkaXVzOiA1MCU7DQoJYWxpZ24taXRlbXM6IGNlbnRlcjsNCglqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjsNCgliYWNrZ3JvdW5kLWNvbG9yOiAkb3JhbmdlLTEwMDsNCglvdmVyZmxvdzogaGlkZGVuOw0KCXdpZHRoOiAycmVtOw0KCWhlaWdodDogMnJlbTsNCg0KCSYub3V0Ym91bmQgew0KCQliYWNrZ3JvdW5kLWNvbG9yOiAkZ3JlZW47DQoJfQ0KDQoJJi5pY29uIHsNCgkJYmFja2dyb3VuZC1jb2xvcjogJGdyZXktNTAwOw0KCX0NCg0KCWltZyB7DQoJCWhlaWdodDogY2FsYyg2MCUpOw0KCQl3aWR0aDogY2FsYyg2MCUpOw0KCX0NCg0KCS5nY2wtaWNvbiB7DQoJCWJhY2tncm91bmQtY29sb3I6IHdoaXRlOw0KDQoJCWhlaWdodDogNzUlOw0KCQl3aWR0aDogNzUlOw0KCQlsaW5lLWhlaWdodDogNzUlOw0KCQliYWNrZ3JvdW5kLXNpemU6IDEwMCU7DQoJCW1hc2stc2l6ZTogMTAwJTsNCgkJLXdlYmtpdC1tYXNrLXNpemU6IDEwMCU7DQoJfQ0KfQ0K"

/***/ },
/* 2509 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,QGltcG9ydCAnLi4vLi4vLi4vc3R5bGVzL3ZhcmlhYmxlcy5zY3NzJzsNCg0KLnVpbi1pbnB1dC1jaGlwIHsNCglkaXNwbGF5OiBpbmxpbmUtZmxleDsNCglhbGlnbi1pdGVtczogY2VudGVyOw0KCWJhY2tncm91bmQtY29sb3I6ICRncmV5LTIwMDsNCgloZWlnaHQ6IDIuNXJlbTsNCglwYWRkaW5nOiAwIDAuNXJlbSAwIDFyZW07DQoJY29sb3I6ICRncmV5LTcwMDsNCglib3JkZXItcmFkaXVzOiAxLjI1cmVtOw0KCWZvbnQtc2l6ZTogMXJlbTsNCglmb250LXdlaWdodDogJG1lZGl1bTsNCglvdmVyZmxvdzogaGlkZGVuOw0KCXdoaXRlLXNwYWNlOiBub3dyYXA7DQoJdHJhbnNpdGlvbjogYmFja2dyb3VuZC1jb2xvciAwLjJzIGVhc2Utb3V0LCBjb2xvciAwLjJzIGVhc2Utb3V0Ow0KDQoJLmdjbC1pY29uIHsNCgkJYmFja2dyb3VuZC1jb2xvcjogJGdyZXktNzAwOw0KCQljdXJzb3I6IHBvaW50ZXI7DQoJCW1hcmdpbi1sZWZ0OiAwLjVyZW07DQoJCWZsZXgtc2hyaW5rOiAwOw0KDQoJCSY6aG92ZXIgew0KCQkJYmFja2dyb3VuZC1jb2xvcjogJGJsYWNrLTEwMDsNCgkJfQ0KDQoJCSY6YWN0aXZlIHsNCgkJCWJhY2tncm91bmQtY29sb3I6ICRibGFjay0yMDA7DQoJCX0NCgl9DQoNCgkudWluLWNocC1lcnJvciB7DQoJCWNvbG9yOiAkY2hhdC1yZWQtNjAwOw0KCQltYXJnaW4tbGVmdDogMC41cmVtOw0KCX0NCg0KCSYuaW50ZXJhY3RpdmUgew0KCQkmOmhvdmVyIHsNCgkJCWJhY2tncm91bmQtY29sb3I6ICRncmV5LTMwMDsNCgkJCWNvbG9yOiAkZ3JleS04MDA7DQoJCX0NCgkJJjphY3RpdmUgew0KCQkJYmFja2dyb3VuZC1jb2xvcjogJGdyZXktNDAwOw0KCQkJY29sb3I6ICRibGFjay0yMDA7DQoJCQl0cmFuc2l0aW9uOiBub25lOw0KCQl9DQoJfQ0KDQoJJi5ibHVlIHsNCgkJYmFja2dyb3VuZC1jb2xvcjogJGJsdWUtMTAwOw0KCQljb2xvcjogJGJsdWU7DQoNCgkJLmdjbC1pY29uIHsNCgkJCWJhY2tncm91bmQtY29sb3I6ICRibHVlOw0KDQoJCQkmOmhvdmVyIHsNCgkJCQliYWNrZ3JvdW5kLWNvbG9yOiAkYmx1ZS03MDA7DQoJCQl9DQoJCQkmOmFjdGl2ZSB7DQoJCQkJYmFja2dyb3VuZC1jb2xvcjogJGJsdWUtODAwOw0KCQkJfQ0KCQl9DQoJfQ0KDQoJJi5pbnZhbGlkIHsNCgkJYmFja2dyb3VuZC1jb2xvcjogJGNoYXQtcmVkLTMwMDsNCgkJY29sb3I6IHdoaXRlOw0KDQoJCS5nY2wtaWNvbiB7DQoJCQliYWNrZ3JvdW5kLWNvbG9yOiAkcmVkLTUwOw0KDQoJCQkmOmhvdmVyIHsNCgkJCQliYWNrZ3JvdW5kLWNvbG9yOiB3aGl0ZTsNCgkJCX0NCgkJfQ0KDQoJCSYuaW50ZXJhY3RpdmUgew0KCQkJJjpob3ZlciB7DQoJCQkJYmFja2dyb3VuZC1jb2xvcjogJGNoYXQtcmVkLTQwMDsNCgkJCQljb2xvcjogd2hpdGU7DQoJCQl9DQoNCgkJCSY6YWN0aXZlIHsNCgkJCQliYWNrZ3JvdW5kLWNvbG9yOiAkY2hhdC1yZWQ7DQoJCQl9DQoJCX0NCgl9DQp9DQo="

/***/ },
/* 2510 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,QGltcG9ydCAnLi4vLi4vLi4vc3R5bGVzL3ZhcmlhYmxlcy5zY3NzJzsNCg0KLnVpbi1tZXNzYWdlLWlucHV0IHsNCglwb3NpdGlvbjogcmVsYXRpdmU7DQoJZm9udC1zaXplOiAwLjg3NXJlbTsNCgl0ZXh0YXJlYSB7DQoJCS13ZWJraXQtYXBwZWFyYW5jZTogbm9uZTsNCgkJYm9yZGVyOiBub25lOw0KCQlvdXRsaW5lOiBub25lOw0KCQlyZXNpemU6IG5vbmU7DQoJCWRpc3BsYXk6IGJsb2NrOw0KCQlvdmVyZmxvdzogaGlkZGVuOw0KCQl3aWR0aDogMTAwJTsNCgkJYm9yZGVyOiAxcHggc29saWQgJGdyZXktNDAwOw0KCQlib3JkZXItcmFkaXVzOiAwLjI1cmVtOw0KDQoJCWZvbnQtd2VpZ2h0OiAkbWVkaXVtOw0KCQlsaW5lLWhlaWdodDogMS4yNXJlbTsNCgkJY29sb3I6ICRncmV5LTcwMDsNCgkJcGFkZGluZzogMC43NXJlbSA1LjYyNXJlbSAwLjc1cmVtIDFyZW07DQoNCgkJdHJhbnNpdGlvbjogYm9yZGVyLWNvbG9yIDAuM3MgZWFzZS1vdXQ7DQoJCW1heC1oZWlnaHQ6IDQuNnJlbTsNCgkJJjo6cGxhY2Vob2xkZXIgew0KCQkJY29sb3I6ICRncmV5LTMwMDsNCgkJfQ0KDQoJCSY6aG92ZXIgew0KCQkJYm9yZGVyLWNvbG9yOiAkZ3JleS01MDA7DQoJCX0NCg0KCQkmOmRpc2FibGVkIHsNCgkJCWJvcmRlci1jb2xvcjogJGdyZXktMTAwOw0KCQkJYmFja2dyb3VuZC1jb2xvcjogJGdyZXktMTAwOw0KCQl9DQoJfQ0KDQoJLnVpbi1taS1jb3VudGVyIHsNCgkJY29sb3I6ICRncmV5LTUwMDsNCgkJbGluZS1oZWlnaHQ6IDEuMjVyZW07DQoJCXBvc2l0aW9uOiBhYnNvbHV0ZTsNCgkJYm90dG9tOiAwLjc1cmVtOw0KCQlyaWdodDogMXJlbTsNCg0KCQlzcGFuLnVpbi1taS1hbGVydCB7DQoJCQljb2xvcjogJGNoYXQtcmVkOw0KCQl9DQoJfQ0KDQoJJi5kaXNhYmxlZCAudWluLW1pLWNvdW50ZXIgew0KCQljb2xvcjogJGdyZXktMzAwOw0KCX0NCn0NCg=="

/***/ },
/* 2511 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,QGltcG9ydCAnLi4vLi4vLi4vc3R5bGVzL3ZhcmlhYmxlcy5zY3NzJzsNCg0KLnVpbi1yZWFzc2lnbi1kaXZpZGVyIHsNCiAgICBtYXJnaW46IDFyZW0gMDsNCiAgICBkaXNwbGF5OiBmbGV4Ow0KICAgIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47DQogICAgYWxpZ24taXRlbXM6IGVuZDsNCiAgICAudWluLXJlYXNzaWduLWRpdmlkZXItbGluZSB7DQogICAgICAgIG1hcmdpbi1ib3R0b206IDAuOHJlbTsNCiAgICAgICAgaGVpZ2h0OiAxcHg7DQogICAgICAgIHdpZHRoOiAxMDAlOw0KICAgICAgICBiYWNrZ3JvdW5kLWNvbG9yOiAkZ3JleS0yMDA7DQogICAgfQ0KICAgIC51aW4tcmVhc3NpZ24tZGl2aWRlci1zcGFuIHsNCiAgICAgICAgbWFyZ2luLXJpZ2h0OiAwLjVyZW07DQogICAgICAgIGZvbnQtc2l6ZTogMC44NzVyZW07DQogICAgICAgIGZvbnQtd2VpZ2h0OiAkbWVkaXVtOw0KICAgICAgICBjb2xvcjogJGdyZXktNTAwOw0KICAgIH0NCn0="

/***/ },
/* 2512 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,QGltcG9ydCAnLi4vLi4vLi4vc3R5bGVzL3ZhcmlhYmxlcy5zY3NzJzsNCg0KLnVpbi10b2dnbGUtY2hpcCB7DQoJZGlzcGxheTogaW5saW5lLWZsZXg7DQoJaGVpZ2h0OiAyLjI1cmVtOw0KDQoJYmFja2dyb3VuZC1jb2xvcjogd2hpdGU7DQoJYm9yZGVyOiAxcHggc29saWQgJGdyZXktNjAwOw0KCWJvcmRlci1yYWRpdXM6IDEuMTI1cmVtOw0KCWFsaWduLWl0ZW1zOiBjZW50ZXI7DQoJcGFkZGluZzogMCAxcmVtOw0KCWN1cnNvcjogcG9pbnRlcjsNCgl1c2VyLXNlbGVjdDogbm9uZTsNCg0KCXRyYW5zaXRpb246IGJhY2tncm91bmQtY29sb3IgMC4zcyBlYXNlLW91dCwgYm9yZGVyLWNvbG9yIDAuM3MgZWFzZS1vdXQsIHBhZGRpbmcgMC4zcyBlYXNlLW91dCwgYm94LXNoYWRvdyAwLjJzIGVhc2Utb3V0Ow0KDQoJLnVpbi1jaGlwLWxhYmVsIHsNCgkJbGluZS1oZWlnaHQ6IDEuNXJlbTsNCgkJZm9udC1zaXplOiAwLjg3NXJlbTsNCgkJZm9udC13ZWlnaHQ6ICRzZW1pYm9sZDsNCgkJY29sb3I6ICRncmV5LTYwMDsNCgkJdGV4dC10cmFuc2Zvcm06IHVwcGVyY2FzZTsNCgkJbGV0dGVyLXNwYWNpbmc6IDEuMTJweDsNCg0KCQl0cmFuc2l0aW9uOiBjb2xvciAwLjNzIGVhc2Utb3V0Ow0KCX0NCg0KCS51aW4tY2hpcC1pY29uIHsNCgkJZGlzcGxheTogZmxleDsNCgkJanVzdGlmeS1jb250ZW50OiBmbGV4LXN0YXJ0Ow0KCQl3aWR0aDogMDsNCgkJb3ZlcmZsb3c6IGhpZGRlbjsNCgkJdHJhbnNpdGlvbjogd2lkdGggMC4zcyBlYXNlLW91dDsNCg0KCQkuZ2NsLWljb24gew0KCQkJZmxleC1zaHJpbms6IDA7DQoJCX0NCgl9DQoNCgkmOmhvdmVyIHsNCgkJYmFja2dyb3VuZC1jb2xvcjogJGN5YW4tNTAwLTI0Ow0KCQlib3JkZXItY29sb3I6ICRncmV5LTgwMDsNCg0KCQkudWluLWNoaXAtbGFiZWwgew0KCQkJY29sb3I6ICRncmV5LTgwMDsNCgkJfQ0KCX0NCg0KCSY6Zm9jdXMgew0KCQliYWNrZ3JvdW5kLWNvbG9yOiAkY3lhbi01MDAtMjQ7DQoJCWJvcmRlci1jb2xvcjogJGN5YW47DQoJCW91dGxpbmU6IG5vbmU7DQoJCWJveC1zaGFkb3c6IDAgMCAwIDNweCAkY3lhbi0yMDA7DQoJfQ0KDQoJJi5hY3RpdmUgew0KCQliYWNrZ3JvdW5kLWNvbG9yOiAkY3lhbi01MDAtMjQ7DQoJCWJvcmRlci1jb2xvcjogJGJsdWUtNDAwOw0KCQlwYWRkaW5nLWxlZnQ6IDAuNXJlbTsNCg0KCQkudWluLWNoaXAtbGFiZWwgew0KCQkJY29sb3I6ICRibHVlLTQwMDsNCgkJfQ0KDQoJCS51aW4tY2hpcC1pY29uIHsNCgkJCXdpZHRoOiAxLjc1cmVtOw0KDQoJCQkuZ2NsLWljb24gew0KCQkJCWJhY2tncm91bmQtY29sb3I6ICRibHVlLTQwMDsNCgkJCX0NCgkJfQ0KCX0NCg0KCSYuZGlzYWJsZWQgew0KCQlwb2ludGVyLWV2ZW50czogbm9uZTsNCgkJYmFja2dyb3VuZC1jb2xvcjogJGdyZXktMjAwOw0KCQlib3JkZXItY29sb3I6ICRncmV5LTIwMDsNCg0KCQkudWluLWNoaXAtbGFiZWwgew0KCQkJY29sb3I6ICRncmV5LTQwMDsNCgkJfQ0KCX0NCn0NCg=="

/***/ },
/* 2513 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/empty-chat-ph.552e02a7.png";

/***/ },
/* 2514 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/empty-placeholder.a7434ccd.png";

/***/ },
/* 2515 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,QGltcG9ydCAnLi4vLi4vc3R5bGVzL3ZhcmlhYmxlcy5zY3NzJzsNCg0KLnVpbi1hZGRyZXNzLWlucHV0IHsNCglwYWRkaW5nOiAwLjVyZW0gMXJlbSAwOw0KCWJvcmRlci1ib3R0b206IDFweCBzb2xpZCAkZ3JleS0yMDA7DQoJZGlzcGxheTogZmxleDsNCglsaW5lLWhlaWdodDogMi41cmVtOw0KCW1pbi1oZWlnaHQ6IDMuNXJlbTsNCglhbGlnbi1pdGVtczogYmFzZWxpbmU7DQoNCgkudWluLWFpbi1sYWJlbCB7DQoJCWZvbnQtc2l6ZTogMC44NzVyZW07DQoJCWNvbG9yOiAkZ3JleS03MDA7DQoJCWZvbnQtd2VpZ2h0OiAkbWVkaXVtOw0KCQlsaW5lLWhlaWdodDogMS4yNXJlbTsNCgkJZmxleC1zaHJpbms6IDA7DQoJCW1hcmdpbjogMCAxcmVtIDAuNXJlbSAwOw0KCX0NCg0KCS51aW4tYWluLWFkZHJlc3NlcyB7DQoJCWRpc3BsYXk6IGZsZXg7DQoJCWZsZXgtd3JhcDogd3JhcDsNCgkJZmxleC1ncm93OiAxOw0KDQoJCS51aW4taW5wdXQtY2hpcCB7DQoJCQltYXJnaW46IDAgMC41cmVtIDAuNXJlbSAwOw0KCQl9DQoJfQ0KfQ0KDQoudWluLWFpbi1saXN0LWlucHV0IHsNCglvdXRsaW5lOiBub25lOw0KCWJvcmRlcjogbm9uZTsNCgltYXJnaW4tYm90dG9tOiAwLjVyZW07DQoJZmxleC1ncm93OiAxOw0KDQoJaW5wdXQgew0KCQliYWNrZ3JvdW5kLWNvbG9yOiB0cmFuc3BhcmVudDsNCgkJb3V0bGluZTogbm9uZTsNCgkJYm9yZGVyOiBub25lOw0KCQlmb250LXNpemU6IDFyZW07DQoJCWZvbnQtd2VpZ2h0OiAkbWVkaXVtOw0KCQljb2xvcjogJGdyZXktNzAwOw0KCQlwYWRkaW5nOiAwOw0KCQloZWlnaHQ6IDIuNXJlbTsNCgkJd2lkdGg6IDEwMCU7DQoJfQ0KDQoJJi5hdXRvIHsNCgkJZmxleDogMCAwIGF1dG87DQoJCW1hcmdpbi1yaWdodDogMC41cmVtOw0KCQlpbnB1dCB7DQoJCQltaW4td2lkdGg6IDJyZW07DQoJCX0NCgl9DQp9DQoNCi50aGVtZS1kYXJrIHsNCgkudWluLWFkZHJlc3MtaW5wdXQgew0KCQlib3JkZXItYm90dG9tLWNvbG9yOiAkZ3JleS03MDA7DQoJCS51aW4tYWluLWxhYmVsIHsNCgkJCWNvbG9yOiAkZ3JleS0zMDA7DQoJCX0NCgl9DQoJLnVpbi1haW4tbGlzdC1pbnB1dCBpbnB1dCB7DQoJCWNvbG9yOiAkZ3JleS0zMDA7DQoJfQ0KfQ0K"

/***/ },
/* 2516 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,QGltcG9ydCAnLi4vLi4vc3R5bGVzL3ZhcmlhYmxlcy5zY3NzJzsNCg0KLm1vZGFsLWRpYWxvZyB7DQoJJi5nY2wteHMgew0KCQl3aWR0aDogMjVyZW07DQoJCW1heC13aWR0aDogMjVyZW07DQoJfQ0KCSYuZ2NsLXNtIHsNCgkJd2lkdGg6IDM1cmVtOw0KCQltYXgtd2lkdGg6IDM1cmVtOw0KCX0NCgkmLmdjbC1tZCB7DQoJCXdpZHRoOiAzOHJlbTsNCgkJbWF4LXdpZHRoOiAzOHJlbTsNCgl9DQoJJi5nY2wtbGcgew0KCQl3aWR0aDogNDQuNXJlbTsNCgkJbWF4LXdpZHRoOiA0NC41cmVtOw0KCX0NCgkmLmdjbC14bCB7DQoJCXdpZHRoOiA1MXJlbTsNCgkJbWF4LXdpZHRoOiA1MXJlbTsNCg0KCQlAaW5jbHVkZSB0YWJsZXQgew0KCQkJd2lkdGg6IDQ1cmVtOw0KCQkJbWF4LXdpZHRoOiA0NXJlbTsNCgkJfQ0KCX0NCn0NCg0KLm1vZGFsLWhlYWRlciB7DQoJJi5nY2wtbGFyZ2Ugew0KCQkubW9kYWwtdGl0bGUgew0KCQkJZm9udC1zaXplOiAxLjVyZW07DQoJCQlmb250LXdlaWdodDogJG1lZGl1bTsNCgkJCWxpbmUtaGVpZ2h0OiAycmVtOw0KCQl9DQoJfQ0KDQoJLmdjbC1zdWJ0aXRsZSB7DQoJCWZvbnQtd2VpZ2h0OiAkbWVkaXVtOw0KCQljb2xvcjogJGdyZXktNTAwOw0KCQltYXJnaW4tYm90dG9tOiAwOw0KCQltYXJnaW4tdG9wOiAwLjVyZW07DQoJCWxpbmUtaGVpZ2h0OiAxLjVyZW07DQoNCgkJLnRoZW1lLWRhcmsgJiB7DQoJCQljb2xvcjogJGdyZXktMzAwOw0KCQl9DQoJfQ0KfQ0KDQoubW9kYWwtZm9vdGVyLmdjbC1ib3JkZXJlZCB7DQoJYm9yZGVyLXRvcDogMXB4IHNvbGlkICRncmV5LTIwMDsNCglwYWRkaW5nLXRvcDogMXJlbTsNCg0KCS50aGVtZS1kYXJrICYgew0KCQliYWNrZ3JvdW5kLWNvbG9yOiAkYmxhY2stMjAwOw0KCQlib3JkZXItY29sb3I6ICRncmV5LTkwMDsNCgl9DQp9DQo="

/***/ },
/* 2517 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,QGltcG9ydCAnLi4vLi4vc3R5bGVzL3ZhcmlhYmxlcy5zY3NzJzsNCg0KLmdjbC1hZ2VudC1idG4gew0KICAgIGRpc3BsYXk6IGZsZXg7DQogICAgYWxpZ24taXRlbXM6IGNlbnRlcjsNCiAgICBqdXN0aWZ5LWNvbnRlbnQ6Y2VudGVyOw0KCWZvbnQtZmFtaWx5OiAkZm9udEFnZW50Ow0KCWhlaWdodDogMi4yNXJlbTsNCglib3JkZXItcmFkaXVzOiAwLjI1cmVtOw0KCXBhZGRpbmc6IDAuMzc1cmVtIDFyZW07DQoJZm9udC1zaXplOiAwLjg3NXJlbTsNCglmb250LXdlaWdodDogJHNlbWlib2xkOw0KCWxldHRlci1zcGFjaW5nOiAxLjEycHg7DQoJb3V0bGluZTogMDsNCgljdXJzb3I6IHBvaW50ZXI7DQoNCgl0cmFuc2l0aW9uOiBiYWNrZ3JvdW5kLWNvbG9yIDAuM3MgZWFzZS1vdXQsIGJvcmRlci1jb2xvciAwLjNzIGVhc2Utb3V0LCBjb2xvciAwLjNzIGVhc2Utb3V0LCBib3gtc2hhZG93IDAuMnMgZWFzZS1vdXQ7DQoNCgkuZ2NsLWFnZW50LWljb24gew0KICAgICAgICBkaXNwbGF5OiBmbGV4Ow0KICAgICAgICBhbGlnbi1pdGVtczogY2VudGVyOw0KCQltYXJnaW4tbGVmdDogLTAuMXJlbTsNCgkJbWFyZ2luLXJpZ2h0OiAwLjVyZW07DQoJfQ0KDQoJJi5wcmltYXJ5IHsNCgkJLmdjbC1hZ2VudC1pY29uIHsNCiAgICAgICAgICAgIGJhY2tncm91bmQtY29sb3I6IHRyYW5zcGFyZW50Ow0KICAgICAgICAgICAgLmdjbC1pY29uew0KCQkJCWJhY2tncm91bmQtY29sb3I6ICR3aGl0ZTsNCgkJCX0NCgkJfQ0KICAgICAgICAmLmJsdWUgew0KICAgICAgICAgICAgYmFja2dyb3VuZDogdHJhbnNwYXJlbnQgbGluZWFyLWdyYWRpZW50KDE4MGRlZywgJGFnZW50LWJsdWUtMjAwIDAlLCAkYWdlbnQtYmx1ZS03MDAgMTAwJSkgMCUgMCUgbm8tcmVwZWF0IHBhZGRpbmctYm94Ow0KICAgICAgICAgICAgYm9yZGVyOiBzb2xpZCAxcHggJGFnZW50LWJsdWUtMjAwOw0KICAgICAgICAgICAgY29sb3I6ICR3aGl0ZTsNCg0KICAgICAgICAgICAgJjpob3ZlciB7DQogICAgICAgICAgICAgICAgYmFja2dyb3VuZC1jb2xvcjogJGFnZW50LWJsdWUtNTAwIDAlIDAlIG5vLXJlcGVhdCBwYWRkaW5nLWJveDsNCiAgICAgICAgICAgICAgICBib3gtc2hhZG93OiAwcHggMHB4IDhweCAkYWdlbnQtYmx1ZS00MDA7DQogICAgICAgICAgICB9DQogICAgICAgICAgICAmOmZvY3VzIHsNCiAgICAgICAgICAgICAgICBiYWNrZ3JvdW5kLWNvbG9yOiAkYWdlbnQtYmx1ZS01MDAgMCUgMCUgbm8tcmVwZWF0IHBhZGRpbmctYm94Ow0KICAgICAgICAgICAgICAgIGJveC1zaGFkb3c6IDBweCAwcHggOHB4ICRhZ2VudC1ibHVlLTMwMDsNCiAgICAgICAgICAgIH0NCiAgICAgICAgICAgICY6YWN0aXZlIHsNCiAgICAgICAgICAgICAgICBiYWNrZ3JvdW5kOiB0cmFuc3BhcmVudCBsaW5lYXItZ3JhZGllbnQoMTgwZGVnLCAkYWdlbnQtYmx1ZS0yMDAgMCUsICRhZ2VudC1ibHVlLTcwMCAxMDAlKSAwJSAwJSBuby1yZXBlYXQgcGFkZGluZy1ib3g7DQogICAgDQogICAgICAgICAgICB9DQogICAgICAgICAgICAmOmRpc2FibGVkIHsNCiAgICAgICAgICAgICAgICBiYWNrZ3JvdW5kLWNvbG9yOiB0cmFuc3BhcmVudCBsaW5lYXItZ3JhZGllbnQoMTgwZGVnLCAkYWdlbnQtYmx1ZS0yMDAgMCUsICRhZ2VudC1ibHVlLTcwMCAxMDAlKSAwJSAwJSBuby1yZXBlYXQgcGFkZGluZy1ib3g7DQogICAgICAgICAgICAgICAgb3BhY2l0eTogMC40Ow0KICAgICAgICAgICAgICAgIGNvbG9yOiAkd2hpdGU7CQ0KICAgICAgICAgICAgfQ0KICAgICAgICAgICAgJi52MjpkaXNhYmxlZHsNCiAgICAgICAgICAgICAgICBiYWNrZ3JvdW5kOiAkZ3JleS0xMDAgMCUgMCUgbm8tcmVwZWF0IHBhZGRpbmctYm94Ow0KICAgICAgICAgICAgICAgIGNvbG9yOiAkZ3JleS0zMDA7DQogICAgICAgICAgICAgICAgYm9yZGVyOiAxcHggc29saWQgI0NDQ0ZEMjsNCiAgICAgICAgICAgICAgICBib3JkZXItcmFkaXVzOiA1cHg7DQogICAgICAgICAgICAgICAgLmdjbC1hZ2VudC1pY29uIHsNCiAgICAgICAgICAgICAgICAgICAgYmFja2dyb3VuZC1jb2xvcjogdHJhbnNwYXJlbnQ7DQogICAgICAgICAgICAgICAgICAgIC5nY2wtaWNvbnsNCiAgICAgICAgICAgICAgICAgICAgICAgIGJhY2tncm91bmQtY29sb3I6ICRncmV5LTMwMDsNCiAgICAgICAgICAgICAgICAgICAgfQ0KICAgICAgICAgICAgICAgIH0NCiAgICAgICAgICAgIH0NCiAgICAgICAgfQ0KICAgICAgICAmLnllbGxvdyB7DQogICAgICAgICAgICBiYWNrZ3JvdW5kOiB0cmFuc3BhcmVudCBsaW5lYXItZ3JhZGllbnQoMTgwZGVnLCAkYWdlbnQteWVsbG93LTUwMCAwJSwgJGFnZW50LXllbGxvdy04MDAgMTAwJSkgMCUgMCUgbm8tcmVwZWF0IHBhZGRpbmctYm94Ow0KICAgICAgICAgICAgYm9yZGVyOiBzb2xpZCAxcHggJGFnZW50LXllbGxvdy01MDA7DQogICAgICAgICAgICBjb2xvcjogJHdoaXRlOw0KDQogICAgICAgICAgICAmOmhvdmVyIHsNCiAgICAgICAgICAgICAgICBiYWNrZ3JvdW5kOiAkYWdlbnQteWVsbG93LTYwMCAwJSAwJSBuby1yZXBlYXQgcGFkZGluZy1ib3g7DQogICAgICAgICAgICAgICAgYm94LXNoYWRvdzogMHB4IDBweCA4cHggJGFnZW50LXllbGxvdy00MDA7DQogICAgICAgICAgICB9DQogICAgICAgICAgICAmOmZvY3VzIHsNCiAgICAgICAgICAgICAgICBiYWNrZ3JvdW5kOiAkYWdlbnQteWVsbG93LTYwMCAwJSBuby1yZXBlYXQgcGFkZGluZy1ib3g7DQogICAgICAgICAgICAgICAgYm94LXNoYWRvdzogMHB4IDBweCA4cHggJGN5YW47DQogICAgICAgICAgICAgICAgYm9yZGVyOiAxcHggc29saWQgJGN5YW47DQogICAgICAgICAgICB9DQogICAgICAgICAgICAmOmFjdGl2ZSB7DQogICAgICAgICAgICAgICAgYmFja2dyb3VuZDogJGFnZW50LXllbGxvdy03MDAgMCUgMCUgbm8tcmVwZWF0IHBhZGRpbmctYm94Ow0KICAgICAgICAgICAgfQ0KICAgICAgICAgICAgJjpkaXNhYmxlZCB7DQogICAgICAgICAgICAgICAgYmFja2dyb3VuZDp0cmFuc3BhcmVudCBsaW5lYXItZ3JhZGllbnQoMTgwZGVnLCAkYWdlbnQteWVsbG93LTUwMCAwJSwgJGFnZW50LXllbGxvdy04MDAgMTAwJSkgMCUgMCUgbm8tcmVwZWF0IHBhZGRpbmctYm94Ow0KICAgICAgICAgICAgICAgIG9wYWNpdHk6IDAuNDsNCiAgICAgICAgICAgICAgICBjb2xvcjogJHdoaXRlOwkNCiAgICAgICAgICAgIH0NCiAgICAgICAgfQ0KICAgICAgICAmLmdyZWVuIHsNCiAgICAgICAgICAgIGJhY2tncm91bmQ6ICRhZ2VudC1ncmVlbi02NTA7DQogICAgICAgICAgICBib3JkZXI6IHNvbGlkIDFweCAkYWdlbnQtZ3JlZW4tNjUwOw0KICAgICAgICAgICAgY29sb3I6JHdoaXRlOw0KICAgICAgICAgICAgJjpob3ZlciB7DQogICAgICAgICAgICAgICAgYmFja2dyb3VuZDogJGFnZW50LWdyZWVuLTU1MCAwJSAwJSBuby1yZXBlYXQgcGFkZGluZy1ib3g7DQogICAgICAgICAgICB9DQogICAgICAgICAgICAmOmZvY3VzIHsNCiAgICAgICAgICAgICAgICBiYWNrZ3JvdW5kLWNvbG9yOiRhZ2VudC1ncmVlbi01NTAgMCUgMCUgbm8tcmVwZWF0IHBhZGRpbmctYm94Ow0KICAgICAgICAgICAgICAgIGJveC1zaGFkb3c6IDBweCAwcHggOHB4ICRhZ2VudC1ncmVlbi03MDA7DQogICAgICAgICAgICAgICAgYm9yZGVyOiBzb2xpZCAxcHggJGFnZW50LWdyZWVuLTYwMDsNCiAgICAgICAgICAgIH0NCiAgICAgICAgICAgICY6YWN0aXZlIHsNCiAgICAgICAgICAgICAgICBiYWNrZ3JvdW5kOiAkYWdlbnQtZ3JlZW4tNzUwOw0KICAgICAgICAgICAgICAgIGJvcmRlcjogMXB4IHNvbGlkICRhZ2VudC1ncmVlbi04MDA7DQogICAgDQogICAgICAgICAgICB9DQogICAgICAgICAgICAmOmRpc2FibGVkIHsNCiAgICAgICAgICAgICAgICBiYWNrZ3JvdW5kOiAkZ3JleS0xMDAgMCUgMCUgbm8tcmVwZWF0IHBhZGRpbmctYm94Ow0KICAgICAgICAgICAgICAgIGNvbG9yOiAkZ3JleS0zMDA7DQogICAgICAgICAgICAgICAgYm9yZGVyOm5vbmU7DQogICAgICAgICAgICAgICAgLmdjbC1hZ2VudC1pY29uIHsNCiAgICAgICAgICAgICAgICAgICAgYmFja2dyb3VuZC1jb2xvcjogdHJhbnNwYXJlbnQ7DQogICAgICAgICAgICAgICAgICAgIC5nY2wtaWNvbnsNCiAgICAgICAgICAgICAgICAgICAgICAgIGJhY2tncm91bmQtY29sb3I6ICRncmV5LTMwMDsNCiAgICAgICAgICAgICAgICAgICAgfQ0KICAgICAgICAgICAgICAgIH0JDQogICAgICAgICAgICB9DQogICAgICAgICAgICAmLnYyOmRpc2FibGVkew0KICAgICAgICAgICAgICAgIGJhY2tncm91bmQ6ICRncmVlbi00MDAtNzAgMCUgMCUgbm8tcmVwZWF0IHBhZGRpbmctYm94Ow0KICAgICAgICAgICAgICAgIGNvbG9yOiAkd2hpdGU7CQ0KICAgICAgICAgICAgICAgIC5nY2wtYWdlbnQtaWNvbiB7DQogICAgICAgICAgICAgICAgICAgIC5nY2wtaWNvbnsNCiAgICAgICAgICAgICAgICAgICAgICAgIGJhY2tncm91bmQtY29sb3I6ICR3aGl0ZTsNCiAgICAgICAgICAgICAgICAgICAgfQ0KICAgICAgICAgICAgICAgIH0NCiAgICAgICAgICAgIH0NCiAgICAgICAgfQkNCgl9DQogICAgDQoNCgkmLnNlY29uZGFyeSB7DQoJCWJhY2tncm91bmQ6IHRyYW5zcGFyZW50Ow0KCQlib3JkZXI6IDFweCBzb2xpZCAkZ3JleS0zMDA7DQoJCWNvbG9yOiAkYWdlbnQtYmx1ZS0xNTA7DQogICAgICAgIGhlaWdodDogMi4yNXJlbTsNCiAgICAgICAgLmdjbC1hZ2VudC1pY29uIHsNCiAgICAgICAgICAgIGJhY2tncm91bmQtY29sb3I6IHRyYW5zcGFyZW50Ow0KICAgICAgICB9DQoJCQ0KICAgICAgICAmLmJsdWV7DQogICAgICAgICAgICAuZ2NsLWFnZW50LWljb24gew0KICAgICAgICAgICAgICAgIC5nY2wtaWNvbnsNCiAgICAgICAgICAgICAgICAgICAgYmFja2dyb3VuZC1jb2xvcjogJGFnZW50LWJsdWUtMTUwOw0KICAgICAgICAgICAgICAgIH0NCiAgICAgICAgICAgIH0NCiAgICAgICAgICAgICY6aG92ZXIgew0KICAgICAgICAgICAgICAgIGJhY2tncm91bmQ6ICRhZ2VudC13aGl0ZS02MDAgMCUgMCUgbm8tcmVwZWF0IHBhZGRpbmctYm94Ow0KICAgICAgICAgICAgICAgIGJvcmRlcjogMXB4IHNvbGlkICRhZ2VudC1ibHVlLTE1MDsNCiAgICAgICAgICAgIH0NCiAgICAgICAgICAgICY6Zm9jdXMgew0KICAgICAgICAgICAgICAgIGJhY2tncm91bmQ6ICRhZ2VudC13aGl0ZS02MDAgMCUgMCUgbm8tcmVwZWF0IHBhZGRpbmctYm94Ow0KICAgICAgICAgICAgICAgIGJveC1zaGFkb3c6IDBweCAwcHggOHB4ICRhZ2VudC1ibHVlLTQ1MDsNCiAgICAgICAgICAgICAgICBib3JkZXI6IDFweCBzb2xpZCAkYWdlbnQtYmx1ZS01MDsNCiAgICAgICAgICAgIH0NCiAgICAgICAgICAgICY6YWN0aXZlIHsNCiAgICAgICAgICAgICAgICBiYWNrZ3JvdW5kOiAkYWdlbnQtYmx1ZS0yNSAwJSAwJSBuby1yZXBlYXQgcGFkZGluZy1ib3g7DQogICAgICAgICAgICAgICAgYm9yZGVyOiAxcHggc29saWQgJGFnZW50LWJsdWUtMTAwOw0KICAgICAgICAgICAgICAgIGNvbG9yOiRhZ2VudC1ibHVlLTY1MDsNCiAgICAgICAgICAgIH0NCg0KICAgICAgICAgICAgJjpkaXNhYmxlZCB7DQogICAgICAgICAgICAgICAgYmFja2dyb3VuZDogJGdyZXktMTAwIDAlIDAlIG5vLXJlcGVhdCBwYWRkaW5nLWJveDsNCiAgICAgICAgICAgICAgICBib3JkZXI6IDFweCBzb2xpZCAkZ3JleS0yMDA7DQogICAgICAgICAgICAgICAgY29sb3I6ICRncmV5LTMwMDsNCiAgICAgICAgICAgICAgICAuZ2NsLWFnZW50LWljb24gew0KICAgICAgICAgICAgICAgICAgICAuZ2NsLWljb257DQogICAgICAgICAgICAgICAgICAgICAgICBiYWNrZ3JvdW5kLWNvbG9yOiAkZ3JleS0zMDA7DQogICAgICAgICAgICAgICAgICAgIH0NCiAgICAgICAgICAgICAgICB9DQogICAgICAgICAgICB9DQogICAgICAgIH0NCiAgICAgICAgJi5yZWR7DQogICAgICAgICAgICBjb2xvcjokYWdlbnQtcmVkLTc1MDsNCiAgICAgICAgICAgIC5nY2wtYWdlbnQtaWNvbiB7DQogICAgICAgICAgICAgICAgLmdjbC1pY29uew0KICAgICAgICAgICAgICAgICAgICBiYWNrZ3JvdW5kLWNvbG9yOiRhZ2VudC1yZWQtNzUwOw0KICAgICAgICAgICAgICAgIH0NCiAgICAgICAgICAgIH0NCiAgICAgICAgICAgICY6aG92ZXIgew0KICAgICAgICAgICAgICAgIGJhY2tncm91bmQ6ICRhZ2VudC1yZWQtNjUwIDAlIDAlIG5vLXJlcGVhdCBwYWRkaW5nLWJveDsNCiAgICAgICAgICAgICAgICBib3JkZXI6IDFweCBzb2xpZCAkYWdlbnQtcmVkLTc1MDsNCiAgICAgICAgICAgIH0NCiAgICAgICAgICAgICY6Zm9jdXMgew0KICAgICAgICAgICAgICAgIGJhY2tncm91bmQ6ICRhZ2VudC1yZWQtNjUwIDAlIDAlIG5vLXJlcGVhdCBwYWRkaW5nLWJveDsNCiAgICAgICAgICAgICAgICBib3gtc2hhZG93OiAwcHggMHB4IDhweCAkYWdlbnQtcmVkLTgwMDsNCiAgICAgICAgICAgICAgICBib3JkZXI6IDFweCBzb2xpZCAkYWdlbnQtcmVkLTcyNTsNCiAgICAgICAgICAgIH0NCiAgICAgICAgICAgICY6YWN0aXZlIHsNCiAgICAgICAgICAgICAgICBiYWNrZ3JvdW5kOiAkYWdlbnQtcmVkLTcwMCAwJSAwJSBuby1yZXBlYXQgcGFkZGluZy1ib3g7DQogICAgICAgICAgICAgICAgYm9yZGVyOiAxcHggc29saWQgJGFnZW50LXJlZC03NzU7DQogICAgICAgICAgICB9DQoNCiAgICAgICAgICAgICY6ZGlzYWJsZWQgew0KICAgICAgICAgICAgICAgIGJhY2tncm91bmQ6ICRncmV5LTEwMCAwJSAwJSBuby1yZXBlYXQgcGFkZGluZy1ib3g7DQogICAgICAgICAgICAgICAgYm9yZGVyOiAxcHggc29saWQgJGdyZXktMjAwOw0KICAgICAgICAgICAgICAgIGNvbG9yOiAkZ3JleS0zMDA7DQogICAgICAgICAgICAgICAgLmdjbC1hZ2VudC1pY29uIHsNCiAgICAgICAgICAgICAgICAgICAgLmdjbC1pY29uew0KICAgICAgICAgICAgICAgICAgICAgICAgYmFja2dyb3VuZC1jb2xvcjogJGdyZXktMzAwOw0KICAgICAgICAgICAgICAgICAgICB9DQogICAgICAgICAgICAgICAgfQ0KICAgICAgICAgICAgfQ0KICAgICAgICB9DQoJfQ0KDQoJJi50ZXJ0aWFyeSB7DQoJCWJhY2tncm91bmQtY29sb3I6IHRyYW5zcGFyZW50Ow0KCQlib3JkZXI6IDFweCBzb2xpZCB0cmFuc3BhcmVudDsNCgkJY29sb3I6ICRhZ2VudC1ibHVlLTE1MDsNCgkJcGFkZGluZzogMCAwLjVyZW07DQoNCgkJJjpob3ZlciB7DQoJCQliYWNrZ3JvdW5kOiAkYWdlbnQtYmx1ZS04MDAgMCUgMCUgbm8tcmVwZWF0IHBhZGRpbmctYm94Ow0KCQl9DQoJCSY6Zm9jdXMgew0KCQkJYmFja2dyb3VuZDogJGFnZW50LXdoaXRlLTYwMCAwJSAwJSBuby1yZXBlYXQgcGFkZGluZy1ib3g7DQogICAgICAgICAgICBib3gtc2hhZG93OiAwcHggMHB4IDhweCAkYWdlbnQtYmx1ZS03MjU7DQoJCX0NCgkJJjphY3RpdmUgew0KICAgICAgICAgICAgY29sb3I6JGFnZW50LWJsdWUtNjUwOw0KCQkJYmFja2dyb3VuZDogJGFnZW50LWJsdWUtNzUwIDAlIDAlIG5vLXJlcGVhdCBwYWRkaW5nLWJveDsNCiAgICAgICAgICAgIGJvcmRlcjogJGFnZW50LWJsdWUtNzUwOw0KCQl9DQoJCSY6ZGlzYWJsZWQgew0KICAgICAgICAgICAgY29sb3I6ICRncmV5LTMwMDsNCiAgICAgICAgICAgIGJhY2tncm91bmQ6ICRncmV5LTEwMCAwJSAwJSBuby1yZXBlYXQgcGFkZGluZy1ib3g7DQogICAgICAgICAgICBib3JkZXI6IDFweCBzb2xpZCAkZ3JleS0yMDA7DQoJCX0NCgl9DQoNCgkmOmRpc2FibGVkIHsNCgkJY3Vyc29yOiBkZWZhdWx0Ow0KCQlwb2ludGVyLWV2ZW50czogbm9uZTsNCgkJYm94LXNoYWRvdzogbm9uZTsNCgl9DQp9DQo="

/***/ },
/* 2518 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,QGltcG9ydCAnLi4vLi4vc3R5bGVzL3ZhcmlhYmxlcy5zY3NzJzsNCg0KLmdsYy1hZ2VudFN0YXRlIHsNCgl3aWR0aDogNS41cmVtOw0KCWhlaWdodDogMS43NXJlbTsNCglkaXNwbGF5OiBpbmxpbmUtZmxleDsNCgljb2xvcjogJHdoaXRlOw0KCWZvbnQtc2l6ZTogMC42MjVyZW07DQoJYm9yZGVyLXJhZGl1czogMC41cmVtOw0KCW92ZXJmbG93OiBoaWRkZW47DQoNCgkmID4gZGl2IHsNCgkJZGlzcGxheTogZmxleDsNCgkJanVzdGlmeS1jb250ZW50OiBjZW50ZXI7DQoJCWFsaWduLWl0ZW1zOiBjZW50ZXI7DQoJCWJvcmRlcjogMC4xMjVyZW0gc29saWQgJGJsYWNrLTEwMC0xMjsNCgl9DQoNCgkuZ2xjLWFnZW50U3RhdGUtaWNvbiB7DQoJCWZsZXg6IDAgMCAxLjYyNXJlbTsNCgkJaGVpZ2h0OiAxMDAlOw0KCQlib3JkZXItcmFkaXVzOiAwLjVyZW0gMCAwIDAuNXJlbTsNCgkJYm9yZGVyLXJpZ2h0OiBub25lOw0KCQliYWNrZ3JvdW5kLWNvbG9yOiB3aGl0ZTsNCg0KCQkuZ2NsLWljb24gew0KCQkJYmFja2dyb3VuZC1jb2xvcjogdmFyKC0tc3RhdHVzLWljb24tY29sb3IpOw0KCQl9DQoJfQ0KDQoJLmdsYy1hZ2VudFN0YXRlLWxhYmVsIHsNCgkJZmxleDogMSAxIDEwMCU7DQoJCW1pbi13aWR0aDogMDsNCgkJb3ZlcmZsb3c6IGhpZGRlbjsNCgkJaGVpZ2h0OiAxMDAlOw0KCQlqdXN0aWZ5LWNvbnRlbnQ6IHN0YXJ0Ow0KCQlib3JkZXItcmFkaXVzOiAwIDAuNXJlbSAwLjVyZW0gMDsNCgkJcGFkZGluZzogMCAwLjM3NXJlbSAwIDAuMjVyZW07DQoJCWJvcmRlci1sZWZ0OiBub25lOw0KDQoJCWJhY2tncm91bmQtY29sb3I6IHZhcigtLXN0YXR1cy1jYXJkLWNvbG9yKTsNCgl9DQp9DQo="

/***/ },
/* 2519 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,QGltcG9ydCAnLi4vLi4vc3R5bGVzL3ZhcmlhYmxlcy5zY3NzJzsNCi5nY2wtYXJlYXMtaXRlbSB7DQoJYm9yZGVyLXRvcDogMC4wNjI1cmVtICRncmV5LTMwMCBzb2xpZDsNCgkuZ2NsLWFyZWFzLWl0ZW0td3JhcGVyIHsNCgkJZGlzcGxheTogZmxleDsNCgkJcGFkZGluZy1sZWZ0OiA4cHg7DQoJCS5nY2wtYXJlYXMtaXRlbS1oZWFkIHsNCgkJCWRpc3BsYXk6IGZsZXg7DQoJCQlhbGlnbi1pdGVtczogY2VudGVyOw0KCQkJanVzdGlmeS1jb250ZW50OiBjZW50ZXI7DQoJCQkuZ2NsLWFyZWFzLWl0ZW0taWNvbiB7DQoJCQkJaGVpZ2h0OiAyLjVyZW07DQoJCQkJd2lkdGg6IDIuNXJlbTsNCgkJCQlib3JkZXItcmFkaXVzOiAwLjI1cmVtOw0KCQkJCWRpc3BsYXk6IGZsZXg7DQoJCQkJYWxpZ24taXRlbXM6IGNlbnRlcjsNCgkJCQlqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjsNCgkJCQltYXJnaW46IDhweDsNCgkJCQkmLmFnZW50IHsNCgkJCQkJYmFja2dyb3VuZC1jb2xvcjogJGJsdWUtMzAwOw0KCQkJCX0NCgkJCQkmLmFkbWluIHsNCgkJCQkJYmFja2dyb3VuZC1jb2xvcjogJGJsdWUtNDAwOw0KCQkJCX0NCgkJCQkmLmluYm91bmQgew0KCQkJCQliYWNrZ3JvdW5kLWNvbG9yOiAkb3JhbmdlLTgwOw0KCQkJCX0NCgkJCQkmLm91dGJvdW5kIHsNCgkJCQkJYmFja2dyb3VuZC1jb2xvcjogJGdyZWVuOw0KCQkJCX0NCgkJCQlpIHsNCgkJCQkJYmFja2dyb3VuZC1jb2xvcjogJHdoaXRlOw0KCQkJCX0NCgkJCX0NCgkJfQ0KCQkuZ2NsLWFyZWFzLWl0ZW0tYm9keSB7DQoJCQlkaXNwbGF5OiBmbGV4Ow0KCQkJZmxleC1kaXJlY3Rpb246IGNvbHVtbjsNCgkJCWp1c3RpZnktY29udGVudDogY2VudGVyOw0KCQkJbWFyZ2luOiA4cHg7DQoJCQkuZ2NsLXRpdGxlLWFyZWFzIHsNCgkJCQlmb250LXNpemU6IDFyZW07DQoJCQkJZm9udC13ZWlnaHQ6ICRtZWRpdW07DQoJCQkJY29sb3I6ICRncmV5LTYwMDsNCgkJCX0NCgkJCS5nY2wtY29udGVudC1jb3VudGVyLWFyZWFzIHsNCgkJCQljb2xvcjogJGdyZXktNTAwOw0KCQkJCWZvbnQtc2l6ZTogMXJlbTsNCgkJCQlmb250LXdlaWdodDogJHJlZ3VsYXI7DQoJCQl9DQoJCX0NCgl9DQp9DQo="

/***/ },
/* 2520 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,QGltcG9ydCAnLi4vLi4vc3R5bGVzL3ZhcmlhYmxlcy5zY3NzJzsNCi5nY2wtYXJlYXMtY291bnRlci1pdGVtIHsNCgl3aWR0aDogMjMuNXJlbTsNCgltYXgtd2lkdGg6IDIzLjVyZW07DQoJYm9yZGVyLWJvdHRvbTogMXB4IHNvbGlkICRncmV5LTIwMDsNCgkvL2JhY2tncm91bmQtY29sb3I6IHJlZDsNCgkuZ2NsLWFyZWFzLWNvdW50ZXItaXRlbS13cmFwZXIgew0KCQlkaXNwbGF5OiBmbGV4Ow0KCQlqdXN0aWZ5LWNvbnRlbnQ6IHNwYWNlLWFyb3VuZDsNCgkJbWFyZ2luLWJvdHRvbTogMC41cmVtOw0KCQltYXJnaW4tdG9wOiAwLjVyZW07DQoJCS5nY2wtYXJlYXMtY291bnRlci1pdGVtLWhlYWQgew0KCQkJZGlzcGxheTogZmxleDsNCgkJCWFsaWduLWl0ZW1zOiBjZW50ZXI7DQoJCQlqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjsNCgkJCS5nY2wtYXJlYXMtY291bnRlci1pdGVtLWljb24gew0KCQkJCWhlaWdodDogMy41cmVtOw0KCQkJCXdpZHRoOiAzLjVyZW07DQoJCQkJYm9yZGVyLXJhZGl1czogMC4yNXJlbTsNCgkJCQlkaXNwbGF5OiBmbGV4Ow0KCQkJCWFsaWduLWl0ZW1zOiBjZW50ZXI7DQoJCQkJanVzdGlmeS1jb250ZW50OiBjZW50ZXI7DQoJCQkJLy9tYXJnaW46IDAuNXJlbTsNCgkJCQlib3JkZXI6IDAuMDYzcmVtIHNvbGlkICRncmV5LTIwMDsNCgkJCQkmLm1zbiB7DQoJCQkJCWkgew0KCQkJCQkJYmFja2dyb3VuZC1jb2xvcjogJGJsdWUtNDAwOw0KCQkJCQl9DQoJCQkJfQ0KCQkJCSYuZW1haWwgew0KCQkJCQlpIHsNCgkJCQkJCWJhY2tncm91bmQtY29sb3I6ICR5ZWxsb3c7DQoJCQkJCX0NCgkJCQl9DQoJCQkJJi50d2l0dGVyIHsNCgkJCQkJaSB7DQoJCQkJCQliYWNrZ3JvdW5kLWNvbG9yOiAkY3lhbjsNCgkJCQkJfQ0KCQkJCX0NCgkJCX0NCgkJfQ0KCQkuZ2NsLWFyZWFzLWNvdW50ZXItaXRlbS1ib2R5IHsNCgkJCWRpc3BsYXk6IGZsZXg7DQoJCQlmbGV4LWRpcmVjdGlvbjogY29sdW1uOw0KCQkJanVzdGlmeS1jb250ZW50OiBjZW50ZXI7DQoJCQl3aWR0aDogOS41cmVtOw0KCQkJaGVpZ2h0OiA0LjYyNXJlbTsNCgkJCWxpbmUtaGVpZ2h0OiAxcmVtOw0KCQkJaHlwaGVuczogYXV0bzsNCgkJCS5nY2wtdGl0bGUtYXJlYXMgew0KCQkJCWZvbnQtc2l6ZTogMC44NzVyZW07DQoJCQkJZm9udC13ZWlnaHQ6ICRyZWd1bGFyOw0KCQkJCWNvbG9yOiAkZ3JleS02MDA7DQoJCQl9DQoJCX0NCgkJLmdjbC1hcmVhcy1jb3VudGVyLWl0ZW0tY291bnRlciB7DQoJCQlkaXNwbGF5OiBmbGV4Ow0KCQl9DQoJfQ0KfQ0K"

/***/ },
/* 2521 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,QGltcG9ydCAnLi4vLi4vc3R5bGVzL3ZhcmlhYmxlcy5zY3NzJzsNCg0KLnRoZW1lLWRhcmsgLmdjbC1hcmVhcy1jb3VudGVyLWl0ZW0gew0KICAgIGJvcmRlci1ib3R0b206IDFweCBzb2xpZCAkZ3JleS03MDA7DQogICAgLmdjbC1hcmVhcy1jb3VudGVyLWl0ZW0td3JhcGVyIC5nY2wtYXJlYXMtY291bnRlci1pdGVtLWhlYWQgLmdjbC1hcmVhcy1jb3VudGVyLWl0ZW0taWNvbnsNCiAgICAgICAgYm9yZGVyOiAwLjA2M3JlbSBzb2xpZCAkZ3JleS03MDA7DQogICAgfQ0KICAgIC5nY2wtYXJlYXMtY291bnRlci1pdGVtLWJvZHkgLmdjbC10aXRsZS1hcmVhc3sNCiAgICAgICAgY29sb3I6ICRncmV5LTMwMDsNCiAgICB9DQp9"

/***/ },
/* 2522 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,QGltcG9ydCAnLi4vLi4vc3R5bGVzL3ZhcmlhYmxlcy5zY3NzJzsNCg0KLmdjbC1hdWRpby1pY29uIHsNCgloZWlnaHQ6IDEuNXJlbTsNCgl3aWR0aDogMS41cmVtOw0KCXBvc2l0aW9uOiByZWxhdGl2ZTsNCglwYWRkaW5nOiA0cHggM3B4Ow0KCWRpc3BsYXk6IGlubGluZS1mbGV4Ow0KCWFsaWduLWl0ZW1zOiBmbGV4LWVuZDsNCglqdXN0aWZ5LWNvbnRlbnQ6IHNwYWNlLWJldHdlZW47DQoNCgkuZ2NsLWJhciB7DQoJCWhlaWdodDogMTAwJTsNCgkJd2lkdGg6IDNweDsNCgkJYmFja2dyb3VuZC1jb2xvcjogJGJsdWUtNDAwOw0KCQlib3JkZXItcmFkaXVzOiAxNXB4Ow0KCQl0cmFuc2Zvcm0tb3JpZ2luOiAxMDAlIDEwMCU7DQoNCgkJJjpudGgtY2hpbGQoMSkgew0KCQkJYW5pbWF0aW9uOiBmaXJzdC1iYXIgMS41cyBpbmZpbml0ZSBsaW5lYXI7DQoJCX0NCgkJJjpudGgtY2hpbGQoMikgew0KCQkJYW5pbWF0aW9uOiBzZWNvbmQtYmFyIDFzIGluZmluaXRlIGxpbmVhcjsNCgkJfQ0KCQkmOm50aC1jaGlsZCgzKSB7DQoJCQlhbmltYXRpb246IHRoaXJkLWJhciAxcyBpbmZpbml0ZSAwLjVzIGxpbmVhcjsNCgkJfQ0KCQkmOm50aC1jaGlsZCg0KSB7DQoJCQlhbmltYXRpb246IHNlY29uZC1iYXIgMXMgaW5maW5pdGUgMC4ycyBsaW5lYXI7DQoJCX0NCgl9DQoNCgkudGhlbWUtZGFyayAmIC5nY2wtYmFyIHsNCgkJYmFja2dyb3VuZC1jb2xvcjogJGdvbGQ7DQoJfQ0KfQ0KDQpAa2V5ZnJhbWVzIGZpcnN0LWJhciB7DQoJMCUgew0KCQl0cmFuc2Zvcm06IHNjYWxlWSgwLjYpOw0KCX0NCgkyNSUgew0KCQl0cmFuc2Zvcm06IHNjYWxlWSgwLjMpOw0KCX0NCgk1MCUgew0KCQl0cmFuc2Zvcm06IHNjYWxlWSgwLjIpOw0KCX0NCgkxMDAlIHsNCgkJdHJhbnNmb3JtOiBzY2FsZVkoMC42KTsNCgl9DQp9DQoNCkBrZXlmcmFtZXMgc2Vjb25kLWJhciB7DQoJMCUgew0KCQl0cmFuc2Zvcm06IHNjYWxlWSgxKTsNCgl9DQoJMjUlIHsNCgkJdHJhbnNmb3JtOiBzY2FsZVkoMC42KTsNCgl9DQoJNTAlIHsNCgkJdHJhbnNmb3JtOiBzY2FsZVkoMC40KTsNCgl9DQoJMTAwJSB7DQoJCXRyYW5zZm9ybTogc2NhbGVZKDEpOw0KCX0NCn0NCg0KQGtleWZyYW1lcyB0aGlyZC1iYXIgew0KCTAlIHsNCgkJdHJhbnNmb3JtOiBzY2FsZVkoMC44KTsNCgl9DQoJMjUlIHsNCgkJdHJhbnNmb3JtOiBzY2FsZVkoMC42KTsNCgl9DQoJNTAlIHsNCgkJdHJhbnNmb3JtOiBzY2FsZVkoMC41KTsNCgl9DQoJMTAwJSB7DQoJCXRyYW5zZm9ybTogc2NhbGVZKDAuOSk7DQoJfQ0KfQ0K"

/***/ },
/* 2523 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,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"

/***/ },
/* 2524 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,QGltcG9ydCAnLi4vLi4vc3R5bGVzL3ZhcmlhYmxlcy5zY3NzJzsNCg0KLnRoZW1lLWRhcmsgLmdjbC1idG5JY29uIHsNCgljb2xvcjogJGdyZXktNjAwOw0KDQoJLmdjbC1pY29uIHsNCgkJYmFja2dyb3VuZC1jb2xvcjogJGdyZXktMzAwOw0KCX0NCg0KCSYuc3F1YXJlIHsNCgkJJjpob3ZlciB7DQoJCQlpIHsNCgkJCQliYWNrZ3JvdW5kLWNvbG9yOiAkZ3JleS0yMDA7DQoJCQl9DQoJCX0NCg0KCQkmOmFjdGl2ZSB7DQoJCQlpIHsNCgkJCQliYWNrZ3JvdW5kLWNvbG9yOiAkZ3JleS01MDA7DQoJCQl9DQoJCX0NCg0KCQkmLnByaW1hcnkgew0KCQkJLmdjbC1pY29uIHsNCgkJCQliYWNrZ3JvdW5kLWNvbG9yOiAkZ29sZDsNCgkJCX0NCg0KCQkJJjpob3ZlciB7DQoJCQkJaSB7DQoJCQkJCWJhY2tncm91bmQtY29sb3I6ICRnb2xkLTQwMDsNCgkJCQl9DQoJCQl9DQoNCgkJCSY6YWN0aXZlIHsNCgkJCQlpIHsNCgkJCQkJYmFja2dyb3VuZC1jb2xvcjogJGdvbGQtMzAwOw0KCQkJCX0NCgkJCX0NCgkJfQ0KDQoJCSYuZGlzYWJsZWQgew0KCQkJLmdjbC1pY29uIHsNCgkJCQliYWNrZ3JvdW5kLWNvbG9yOiAkZ3JleS03MDA7DQoJCQl9DQoJCX0NCgl9DQoNCgkmLmNpcmNsZSB7DQoJCWJhY2tncm91bmQtY29sb3I6ICRibGFjay0yMDA7DQoJCWJvcmRlci1jb2xvcjogJGJsYWNrLTIwMDsNCgkJLmdjbC1pY29uIHsNCgkJCWJhY2tncm91bmQtY29sb3I6ICRncmV5LTMwMDsNCgkJfQ0KDQoJCSY6aG92ZXIgew0KCQkJYm9yZGVyLWNvbG9yOiAkZ3JleS0zMDA7DQoJCQliYWNrZ3JvdW5kLWNvbG9yOiAkZ3JleS05MDA7DQoJCQkuZ2NsLWljb24gew0KCQkJCWJhY2tncm91bmQtY29sb3I6ICRncmV5LTMwMDsNCgkJCX0NCgkJfQ0KDQoJCSY6Zm9jdXMgew0KCQkJYm9yZGVyLWNvbG9yOiAkZ3JleS0zMDA7DQoJCQliYWNrZ3JvdW5kLWNvbG9yOiAkZ3JleS05MDA7DQoJCQkuZ2NsLWljb24gew0KCQkJCWJhY2tncm91bmQtY29sb3I6ICRncmV5LTMwMDsNCgkJCX0NCgkJfQ0KDQoJCSY6YWN0aXZlIHsNCgkJCXRyYW5zaXRpb246IG5vbmU7DQoJCQliYWNrZ3JvdW5kLWNvbG9yOiAkYmxhY2stMzAwOw0KCQkJYm9yZGVyLWNvbG9yOiAkYmxhY2stMzAwOw0KCQkJLmdjbC1pY29uIHsNCgkJCQliYWNrZ3JvdW5kLWNvbG9yOiAkZ3JleS0zMDA7DQoJCQl9DQoJCX0NCgkJJi5kaXNhYmxlZCB7DQoJCQliYWNrZ3JvdW5kLWNvbG9yOiAkYmxhY2stMTAwOw0KCQkJYm9yZGVyLWNvbG9yOiAkYmxhY2stMTAwOw0KCQkJLmdjbC1pY29uIHsNCgkJCQliYWNrZ3JvdW5kLWNvbG9yOiAkZ3JleS04MDA7DQoJCQl9DQoJCX0NCgl9DQp9DQo="

/***/ },
/* 2525 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,QGltcG9ydCAnLi4vLi4vc3R5bGVzL3ZhcmlhYmxlcy5zY3NzJzsNCg0KLmdjbC1idXR0b24tc3dpdGNoIHsNCglkaXNwbGF5OiBmbGV4Ow0KCWZsZXgtZGlyZWN0aW9uOiByb3c7DQoJanVzdGlmeS1jb250ZW50OiBjZW50ZXI7DQoJYWxpZ24taXRlbXM6IGNlbnRlcjsNCglwYWRkaW5nOiAwLjI1cmVtOw0KCWdhcDogMC4yNXJlbTsNCgl3aWR0aDogZml0LWNvbnRlbnQ7DQoJaGVpZ2h0OiAzcmVtOw0KCWJhY2tncm91bmQ6ICRibHVlLTUwOw0KCWJvcmRlcjogMXB4IHNvbGlkICRibHVlLTEwMDsNCglib3gtc2l6aW5nOiBib3JkZXItYm94Ow0KCWJvcmRlci1yYWRpdXM6IDAuNXJlbTsNCg0KCS50aGVtZS1kYXJrICYgew0KCQliYWNrZ3JvdW5kOiAkYmxhY2stMjAwOw0KCQlib3JkZXItY29sb3I6ICRibGFjay0xMDA7DQoJfQ0KDQoJJi5kaXNhYmxlZCB7DQoJCWJhY2tncm91bmQ6ICRncmV5LTUwOw0KCQlib3JkZXItY29sb3I6ICRncmV5LTEwMDsNCgkJY3Vyc29yOiBkZWZhdWx0Ow0KCX0NCg0KCS5nY2wtYnV0dG9uLXN3aXRjaC1vcHRpb24gew0KCQlkaXNwbGF5OiBmbGV4Ow0KCQlmbGV4LWRpcmVjdGlvbjogcm93Ow0KCQlqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjsNCgkJYWxpZ24taXRlbXM6IGNlbnRlcjsNCgkJcGFkZGluZzogMC41cmVtIDFyZW07DQoJCWN1cnNvcjogcG9pbnRlcjsNCg0KCQkvLyB3aWR0aDogNi4xMjVyZW07DQoJCWhlaWdodDogMi41cmVtOw0KDQoJCWJhY2tncm91bmQ6ICRibHVlLTUwOw0KDQoJCWJvcmRlcjogMC4xMjVyZW0gc29saWQgJGJsdWUtNTA7DQoJCWJveC1zaXppbmc6IGJvcmRlci1ib3g7DQoJCWJvcmRlci1yYWRpdXM6IDAuMzc1cmVtOw0KDQoJCWZsZXg6IG5vbmU7DQoJCWZsZXgtZ3JvdzogMDsNCg0KCQlmb250LXdlaWdodDogJG1lZGl1bTsNCgkJZm9udC1zaXplOiAxcmVtOw0KCQlsaW5lLWhlaWdodDogMS41cmVtOw0KDQoJCXRleHQtYWxpZ246IGNlbnRlcjsNCgkJY29sb3I6ICRibHVlLTQwMDsNCg0KCQl0cmFuc2l0aW9uOiBiYWNrZ3JvdW5kIDAuM3MgZWFzZS1vdXQsIGJvcmRlci1jb2xvciAwLjNzIGVhc2Utb3V0LCBjb2xvciAwLjNzIGVhc2Utb3V0Ow0KDQoJCS50aGVtZS1kYXJrICYgew0KCQkJYmFja2dyb3VuZDogJGJsYWNrLTIwMDsNCgkJCWJvcmRlci1jb2xvcjogJGJsYWNrLTIwMDsNCgkJCWNvbG9yOiAkZ29sZDsNCgkJfQ0KDQoJCSY6aG92ZXIgew0KCQkJYmFja2dyb3VuZDogJGJsdWUtMTAwOw0KCQkJYm9yZGVyLWNvbG9yOiAkYmx1ZS0xMDA7DQoJCQljb2xvcjogJGJsdWU7DQoNCgkJCS50aGVtZS1kYXJrICYgew0KCQkJCWJhY2tncm91bmQ6ICRnb2xkLTMyOw0KCQkJCWJvcmRlci1jb2xvcjogdHJhbnNwYXJlbnQ7DQoJCQkJY29sb3I6ICRnb2xkLTQwMDsNCgkJCX0NCgkJfQ0KDQoJCSY6Zm9jdXMgew0KCQkJYm9yZGVyLWNvbG9yOiAkY3lhbi00MDA7DQoJCX0NCg0KCQkmOmFjdGl2ZSB7DQoJCQliYWNrZ3JvdW5kOiAkYmx1ZS0yMDA7DQoJCQlib3JkZXItY29sb3I6ICRibHVlLTIwMDsNCgkJCWNvbG9yOiAkd2hpdGU7DQoNCgkJCS50aGVtZS1kYXJrICYgew0KCQkJCWJhY2tncm91bmQ6ICRnb2xkLTE2Ow0KCQkJCWJvcmRlci1jb2xvcjogdHJhbnNwYXJlbnQ7DQoJCQkJY29sb3I6ICRnb2xkOw0KCQkJfQ0KCQl9DQoNCgkJJi5kaXNhYmxlZCB7DQoJCQliYWNrZ3JvdW5kOiAkZ3JleS01MDsNCgkJCWJvcmRlci1jb2xvcjogJGdyZXktNTA7DQoJCQljb2xvcjogJGdyZXktMjAwOw0KCQl9DQoNCgkJJi5zZWxlY3RlZCB7DQoJCQliYWNrZ3JvdW5kOiAkYmx1ZS00MDA7DQoJCQlib3JkZXItY29sb3I6ICRibHVlLTQwMDsNCgkJCWNvbG9yOiAkd2hpdGU7DQoNCgkJCS50aGVtZS1kYXJrICYgew0KCQkJCWJhY2tncm91bmQ6ICRnb2xkOw0KCQkJCWJvcmRlci1jb2xvcjogJGdvbGQ7DQoJCQkJY29sb3I6ICRibGFjay0yMDA7DQoJCQl9DQoJCX0NCg0KCQkmLnNlbGVjdGVkLmRpc2FibGVkIHsNCgkJCWJhY2tncm91bmQ6ICRncmV5LTEwMDsNCgkJCWJvcmRlci1jb2xvcjogJGdyZXktMTAwOw0KCQkJY29sb3I6ICRncmV5LTIwMDsNCgkJfQ0KCX0NCn0NCg=="

/***/ },
/* 2526 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,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"

/***/ },
/* 2527 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,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"

/***/ },
/* 2528 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,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"

/***/ },
/* 2529 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,QGltcG9ydCAnLi4vLi4vc3R5bGVzL3ZhcmlhYmxlcy5zY3NzJzsNCg0KLmdjbC1jYW1wLWljb24gew0KCWRpc3BsYXk6IGlubGluZS1mbGV4Ow0KCWFsaWduLWl0ZW1zOiBjZW50ZXI7DQoJanVzdGlmeS1jb250ZW50OiBjZW50ZXI7DQoJd2lkdGg6IDIuNXJlbTsNCgloZWlnaHQ6IDIuNXJlbTsNCglmbGV4OiAwIDAgYXV0bzsNCglib3JkZXItcmFkaXVzOiAwLjI1cmVtOw0KCXBvc2l0aW9uOiByZWxhdGl2ZTsNCg0KCSYuaW5ib3VuZCB7DQoJCWJhY2tncm91bmQtY29sb3I6ICRvcmFuZ2UtODA7DQoJfQ0KCSYub3V0Ym91bmQgew0KCQliYWNrZ3JvdW5kLWNvbG9yOiAkZ3JlZW47DQoJfQ0KCT4gLmdjbC1pY29uIHsNCgkJd2lkdGg6IDJyZW07DQoJCWhlaWdodDogMnJlbTsNCgkJYmFja2dyb3VuZC1jb2xvcjogd2hpdGU7DQoJCS50aGVtZS1kYXJrICYgew0KCQkJYmFja2dyb3VuZC1jb2xvcjogJGJsYWNrLTEwMDsNCgkJfQ0KCX0NCg0KCS5nY2wtY2ktY2hhbm5lbCB7DQoJCXBvc2l0aW9uOiBhYnNvbHV0ZTsNCgkJYm9yZGVyLXJhZGl1czogNTAlOw0KCQl3aWR0aDogMS4xMjVyZW07DQoJCWhlaWdodDogMS4xMjVyZW07DQoJCWJhY2tncm91bmQtY29sb3I6IHZhcigtLWNoYW5uZWwtY29sb3IpOw0KCQlkaXNwbGF5OiBmbGV4Ow0KCQlhbGlnbi1pdGVtczogY2VudGVyOw0KCQlqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjsNCgkJYm9yZGVyOiAxcHggc29saWQgd2hpdGU7DQoJCWJveC1zaXppbmc6IGNvbnRlbnQtYm94Ow0KCQlyaWdodDogLTAuNjI1cmVtOw0KCQlib3R0b206IC0wLjYyNXJlbTsNCg0KCQkudGhlbWUtZGFyayAmIHsNCgkJCWJvcmRlci1jb2xvcjogJGJsYWNrLTEwMDsNCgkJfQ0KDQoJCS5nY2wtaWNvbiB7DQoJCQl3aWR0aDogMC44NzVyZW07DQoJCQloZWlnaHQ6IDAuODc1cmVtOw0KCQkJYmFja2dyb3VuZC1jb2xvcjogd2hpdGU7DQoJCX0NCgl9DQoNCgkmLmdjbC1zbSB7DQoJCXdpZHRoOiAycmVtOw0KCQloZWlnaHQ6IDJyZW07DQoNCgkJPiAuZ2NsLWljb24gew0KCQkJd2lkdGg6IDEuNXJlbTsNCgkJCWhlaWdodDogMS41cmVtOw0KCQl9DQoJfQ0KDQoJJi5nY2wtbGcgew0KCQl3aWR0aDogNXJlbTsNCgkJaGVpZ2h0OiA1cmVtOw0KCQlib3JkZXItcmFkaXVzOiAwLjVyZW07DQoNCgkJJi5pbmJvdW5kIHsNCgkJCWJhY2tncm91bmQ6IGxpbmVhci1ncmFkaWVudCgxODBkZWcsIHJnYmEoMjU1LCAxNjYsIDI5LCAxKSwgcmdiYSgyNTUsIDEzNywgMCwgMSkpOw0KCQl9DQoJCSYub3V0Ym91bmQgew0KCQkJYmFja2dyb3VuZC1jb2xvcjogIzBlZGUzMzsNCgkJCWJhY2tncm91bmQ6IGxpbmVhci1ncmFkaWVudCgxODBkZWcsIHJnYmEoMTQsIDIyMiwgNTEsIDEpLCByZ2JhKDEwLCAxODAsIDM3LCAxKSk7DQoJCX0NCg0KCQk+IC5nY2wtaWNvbiB7DQoJCQl3aWR0aDogM3JlbTsNCgkJCWhlaWdodDogM3JlbTsNCgkJfQ0KDQoJCS5nY2wtY2ktY2hhbm5lbCB7DQoJCQl3aWR0aDogMnJlbTsNCgkJCWhlaWdodDogMnJlbTsNCgkJCWJvcmRlci13aWR0aDogMnB4Ow0KCQkJcmlnaHQ6IC0wLjc1cmVtOw0KCQkJYm90dG9tOiAtMC43NXJlbTsNCg0KCQkJLmdjbC1pY29uIHsNCgkJCQl3aWR0aDogMS41cmVtOw0KCQkJCWhlaWdodDogMS41cmVtOw0KCQkJfQ0KCQl9DQoJfQ0KDQoJJi53aXRoLWNoYW5uZWwgew0KCQltYXJnaW4tcmlnaHQ6IDAuNjI1cmVtOw0KDQoJCSYuZ2NsLWxnIHsNCgkJCW1hcmdpbi1yaWdodDogMC43NXJlbTsNCgkJfQ0KCX0NCn0NCg=="

/***/ },
/* 2530 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,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"

/***/ },
/* 2531 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,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"

/***/ },
/* 2532 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,QGltcG9ydCAnLi4vLi4vc3R5bGVzL3ZhcmlhYmxlcy5zY3NzJzsNCg0KLnRoZW1lLWRhcmsgLmdjbC1jYW1waXRlbSB7DQoJYm9yZGVyLWJvdHRvbS1jb2xvcjogJGdyZXktNzAwOw0KCSY6aG92ZXIgew0KCQliYWNrZ3JvdW5kLWNvbG9yOiAkZ3JleS05MDA7DQoNCgkJLmdjbC1jYW1waXRlbS1uYW1lLA0KCQkuZ2xjLWNhbXBpdGVtLW1lc3NhZ2Ugew0KCQkJY29sb3I6ICRncmV5LTIwMDsNCgkJfQ0KCX0NCg0KCSY6YWN0aXZlIHsNCgkJYmFja2dyb3VuZC1jb2xvcjogJGJsYWNrLTIwMDsNCg0KCQkuZ2NsLWNhbXBpdGVtLW5hbWUsDQoJCS5nbGMtY2FtcGl0ZW0tbWVzc2FnZSB7DQoJCQljb2xvcjogJGdyZXktMjAwOw0KCQl9DQoJfQ0KDQoJJi5hY3RpdmUgew0KCQliYWNrZ3JvdW5kLWNvbG9yOiAkYmxhY2stMjAwOw0KDQoJCSY6aG92ZXIgew0KCQkJYmFja2dyb3VuZC1jb2xvcjogJGdyZXktOTAwOw0KCQl9DQoNCgkJJjphY3RpdmUgew0KCQkJYmFja2dyb3VuZC1jb2xvcjogJGJsYWNrLTMwMDsNCgkJfQ0KCX0NCg0KCS5nbGMtY2FtcGl0ZW0tZG90IHsNCgkJYmFja2dyb3VuZDogJGNoYXQtcmVkOw0KCQlib3gtc2hhZG93OiAwIDAgMCAwLjI1cmVtICNmZjMzNGI1MjsNCg0KCQkmLnRydWUgew0KCQkJYmFja2dyb3VuZDogIzRlZmEzMzsNCgkJCWJveC1zaGFkb3c6IDAgMCAwIDAuMjVyZW0gIzRlZmEzMzUyOw0KCQl9DQoJfQ0KDQoJLmdjbC1jYW1waXRlbS1uYW1lLA0KCS5nbGMtY2FtcGl0ZW0tbWVzc2FnZSB7DQoJCWNvbG9yOiAkZ3JleS0zMDA7DQoJfQ0KfQ0K"

/***/ },
/* 2533 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,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"

/***/ },
/* 2534 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,QGltcG9ydCAnLi4vLi4vc3R5bGVzL3ZhcmlhYmxlcy5zY3NzJzsNCg0KLnRoZW1lLWRhcmsgLmdjbC1jYXJkcy1mb3JtYXQgew0KCWJhY2tncm91bmQtY29sb3I6ICRibGFjay0xMDA7DQoJJiA+IC5jaGVja2VkIHsNCgkJYm9yZGVyOiBzb2xpZCAkZ29sZCAwLjVweDsNCgkJLmdjbC1oZWFkLWNhcmRzLWZvcm1hdCAuZ2NsLWJ0biAuZ2NsLWRkLWNvbnRhaW5lciAuZ2NsLWRkLWljb24gLmdjbC1kZC1idXR0b24gLm1vcmV7DQoJCQliYWNrZ3JvdW5kLWNvbG9yOiAkZ29sZDsNCgkJfQ0KCX0NCgkuZ2NsLWhlYWQtY2FyZHMtZm9ybWF0ew0KCQlib3JkZXItdG9wLWxlZnQtcmFkaXVzOiAwLjVyZW07DQogICAgCWJvcmRlci10b3AtcmlnaHQtcmFkaXVzOiAwLjVyZW07DQoJCWJhY2tncm91bmQtY29sb3I6ICRibGFjay0xMDA7DQoJfQ0KCQ0KCS5nY2wtaGVhZC1jYXJkcy1mb3JtYXQgPiAuZ2NsLWhlYWQtY2FyZHMtaWNvbi1mb3JtYXQgPiBpIHsNCgkJYmFja2dyb3VuZC1jb2xvcjogJGdvbGQ7DQoJfQ0KDQoJLmdjbC1jYXJkcy1ib2R5LWZvcm1hdCB7DQoJCWJhY2tncm91bmQtY29sb3I6ICRibGFjay0xMDA7DQoJCSYuZ2NsLWNhcmRzLWJvZHktY29sb3ItZm9ybWF0IHsNCgkJCWJhY2tncm91bmQtY29sb3I6ICRncmV5LTgwMDsNCgkJfQ0KCQkuZ2NsLXRpdGxlLWNhcmRzLWZvcm1hdCB7DQoJCQljb2xvcjogJGdyZXktMzAwOw0KCQl9DQoJCS5nY2wtZGVzY3JpcHRpb24tY2FyZHMtZm9ybWF0IHsNCgkJCWNvbG9yOiAkZ3JleS0zMDA7DQoJCX0NCgkJLmdjbC1jb250ZW50LWRhdGUtY2FyZHMtZm9ybWF0IHsNCgkJCWNvbG9yOiAkZ3JleS0zMDA7DQoJCX0NCgkJJi5jaGVja2VkIHsNCgkJCS5nY2wtdGl0bGUtY2FyZHMtZm9ybWF0IHsNCgkJCQljb2xvcjogJGdvbGQ7DQoJCQl9DQoJCQkuZ2NsLWRlc2NyaXB0aW9uLWNhcmRzLWZvcm1hdCB7DQoJCQkJY29sb3I6ICRnb2xkOw0KCQkJfQ0KCQkJLmdjbC1jb250ZW50LWRhdGUtY2FyZHMtZm9ybWF0IHsNCgkJCQljb2xvcjogJGdvbGQ7DQoJCQl9DQoJCX0NCgl9DQp9DQo="

/***/ },
/* 2535 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,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"

/***/ },
/* 2536 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,QGltcG9ydCAnLi4vLi4vc3R5bGVzL3ZhcmlhYmxlcy5zY3NzJzsNCg0KLnRoZW1lLWRhcmsgLmdjbC1jYXJkcyB7DQoJYmFja2dyb3VuZC1jb2xvcjogJGJsYWNrLTEwMDsNCgkmID4gLmNoZWNrZWQgew0KCQlib3JkZXI6IHNvbGlkICRnb2xkIDAuNXB4Ow0KCX0NCg0KCS5nY2wtaGVhZC1jYXJkcyA+IC5nY2wtaGVhZC1jYXJkcy1pY29uID4gaSB7DQoJCWJhY2tncm91bmQtY29sb3I6ICRnb2xkOw0KCX0NCg0KCS5nY2wtY2FyZHMtYm9keSB7DQoJCSYuZ2NsLWNhcmRzLWJvZHktY29sb3Igew0KCQkJYmFja2dyb3VuZC1jb2xvcjogJGdyZXktODAwOw0KCQl9DQoJCS5nY2wtdGl0bGUtY2FyZHMgew0KCQkJY29sb3I6ICRncmV5LTMwMDsNCgkJfQ0KCQkuZ2NsLWNvbnRlbnQtZGF0ZS1jYXJkcyB7DQoJCQljb2xvcjogJGdyZXktMzAwOw0KCQl9DQoJCSYuY2hlY2tlZCB7DQoJCQkuZ2NsLXRpdGxlLWNhcmRzIHsNCgkJCQljb2xvcjogJGdvbGQ7DQoJCQl9DQoJCQkuZ2NsLWNvbnRlbnQtZGF0ZS1jYXJkcyB7DQoJCQkJY29sb3I6ICRnb2xkOw0KCQkJfQ0KCQl9DQoJfQ0KfQ0K"

/***/ },
/* 2537 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,QGltcG9ydCAnLi4vLi4vc3R5bGVzL3ZhcmlhYmxlcy5zY3NzJzsNCg0KLmdsYy1jaGlwcyB7DQoJZGlzcGxheTogaW5saW5lLWZsZXg7DQoJYmFja2dyb3VuZC1jb2xvcjogJGdyZXktMTAwOw0KCWhlaWdodDogMi4yNXJlbTsNCglib3JkZXItcmFkaXVzOiAxLjEyNXJlbTsNCglwYWRkaW5nOiAwIDFyZW07DQoJZm9udC1zaXplOiAwLjg3NXJlbTsNCgljb2xvcjogJGdyZXktNjAwOw0KCXZlcnRpY2FsLWFsaWduOiBtaWRkbGU7DQoJYWxpZ24taXRlbXM6IGNlbnRlcjsNCgltYXJnaW4tcmlnaHQ6IDAuNXJlbTsNCgljdXJzb3I6IHBvaW50ZXI7DQoNCglpIHsNCgkJbWFyZ2luLWxlZnQ6IDAuNXJlbTsNCgkJYmFja2dyb3VuZC1jb2xvcjogJGdyZXktNjAwOw0KCX0NCg0KCSYubGVmdCB7DQoJCWk6Zmlyc3Qtb2YtdHlwZSB7DQoJCQltYXJnaW4tcmlnaHQ6IDAuNXJlbTsNCgkJCW1hcmdpbi1sZWZ0OiAwOw0KCQl9DQoJfQ0KDQoJJjpob3ZlciB7DQoJCWJhY2tncm91bmQtY29sb3I6ICRncmV5LTIwMDsNCgkJY29sb3I6ICRncmV5LTgwMDsNCgkJaSB7DQoJCQliYWNrZ3JvdW5kLWNvbG9yOiAkZ3JleS04MDA7DQoJCX0NCgl9DQoNCgkmOmFjdGl2ZSB7DQoJCWJhY2tncm91bmQtY29sb3I6ICRncmV5LTMwMDsNCgkJY29sb3I6ICRibGFjay0xMDA7DQoJCWkgew0KCQkJYmFja2dyb3VuZC1jb2xvcjogJGJsYWNrLTEwMDsNCgkJfQ0KCX0NCg0KCSYuY2hlY2tlZCB7DQoJCWJhY2tncm91bmQtY29sb3I6ICRibHVlLTc1Ow0KCQljb2xvcjogJGJsdWUtNDAwOw0KCQlpIHsNCgkJCWJhY2tncm91bmQtY29sb3I6ICRibHVlLTQwMDsNCgkJfQ0KCX0NCg0KCSYuZGlzYWJsZWQgew0KCQliYWNrZ3JvdW5kLWNvbG9yOiAkZ3JleS01MDsNCgkJcG9pbnRlci1ldmVudHM6IG5vbmU7DQoJCWNvbG9yOiAkZ3JleS0yMDA7DQoJCWkgew0KCQkJYmFja2dyb3VuZC1jb2xvcjogJGdyZXktMjAwOw0KCQl9DQoJfQ0KfQ0K"

/***/ },
/* 2538 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,QGltcG9ydCAnLi4vLi4vc3R5bGVzL3ZhcmlhYmxlcy5zY3NzJzsNCg0KLnRoZW1lLWRhcmsgLmdsYy1jaGlwcyB7DQoJYmFja2dyb3VuZC1jb2xvcjogJGJsYWNrLTEwMDsNCgljb2xvcjogJGdyZXktMzAwOw0KDQoJaSB7DQoJCWJhY2tncm91bmQtY29sb3I6ICRncmV5LTMwMDsNCgl9DQoNCgkmOmhvdmVyIHsNCgkJYmFja2dyb3VuZC1jb2xvcjogJGdyZXktOTAwOw0KCQljb2xvcjogJGdyZXktMjAwOw0KCQlpIHsNCgkJCWJhY2tncm91bmQtY29sb3I6ICRncmV5LTIwMDsNCgkJfQ0KCX0NCg0KCSY6YWN0aXZlIHsNCgkJYmFja2dyb3VuZC1jb2xvcjogJGJsYWNrLTMwMDsNCiAgICAgICAgY29sb3I6ICRncmV5LTMwMDsNCiAgICAgICAgYm9yZGVyOiAxcHggc29saWQgJGJsYWNrLTMwMDsNCgkJaSB7DQoJCQliYWNrZ3JvdW5kLWNvbG9yOiAkZ3JleS0zMDA7DQoJCX0NCgl9DQoNCgkmLmNoZWNrZWQgew0KCQliYWNrZ3JvdW5kLWNvbG9yOiAkYmxhY2stMTAwOw0KCQljb2xvcjogJGdvbGQ7DQoJCWkgew0KCQkJYmFja2dyb3VuZC1jb2xvcjogJGdvbGQ7DQoJCX0NCgl9DQoNCgkmLmRpc2FibGVkIHsNCgkJYmFja2dyb3VuZC1jb2xvcjogJGdyZXktOTAwOw0KCQljb2xvcjogJGdyZXktNjAwOw0KCQlpIHsNCgkJCWJhY2tncm91bmQtY29sb3I6ICRncmV5LTYwMDsNCgkJfQ0KCX0NCn0NCg=="

/***/ },
/* 2539 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,QGltcG9ydCAnLi4vLi4vc3R5bGVzL3ZhcmlhYmxlcy5zY3NzJzsNCg0KLmdjbC1jb2xvci1waWNrZXIgew0KCWRpc3BsYXk6IGlubGluZS1ibG9jazsNCglib3JkZXI6IDFweCBzb2xpZCAkZ3JleS00NTA7DQoJYm9yZGVyLXJhZGl1czogMC41cmVtOw0KCWJhY2tncm91bmQtY29sb3I6IHdoaXRlOw0KCXBhZGRpbmc6IDFyZW07DQoNCgkudGhlbWUtZGFyayAmIHsNCgkJYmFja2dyb3VuZC1jb2xvcjogJGdyZXktOTAwOw0KCQlib3JkZXItY29sb3I6ICRncmV5LTgwMDsNCgl9DQoNCgkuZ2NsLWNwLXdyYXBwZXIgew0KCQlkaXNwbGF5OiBmbGV4Ow0KCQltYXJnaW4tYm90dG9tOiAxcmVtOw0KCX0NCg0KCS5nY2wtY3Atc2F0LWNvbnRhaW5lciB7DQoJCXBvc2l0aW9uOiByZWxhdGl2ZTsNCgkJd2lkdGg6IDkuNXJlbTsNCgkJaGVpZ2h0OiA5LjVyZW07DQoJCW1hcmdpbi1yaWdodDogMC43NXJlbTsNCgl9DQoNCgkuZ2NsLWNwLWxhYmVsIHsNCgkJY29sb3I6ICRncmV5LTUwMDsNCgkJdGV4dC10cmFuc2Zvcm06IHVwcGVyY2FzZTsNCg0KCQkudGhlbWUtZGFyayAmIHsNCgkJCWNvbG9yOiAkZ3JleS0zMDA7DQoJCX0NCgl9DQp9DQo="

/***/ },
/* 2540 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,QGltcG9ydCAnLi4vLi4vc3R5bGVzL3ZhcmlhYmxlcy5zY3NzJzsNCg0KLmdjbC1jb2xvci1waWNrZXItcG9wb3ZlciB7DQoJcG9zaXRpb246IHJlbGF0aXZlOw0KCXotaW5kZXg6IDE7DQoJZGlzcGxheTogaW5saW5lLWJsb2NrOw0KDQoJLmdjbC1jcC1jb250YWluZXIgew0KCQlkaXNwbGF5OiBmbGV4Ow0KCQlhbGlnbi1pdGVtczogY2VudGVyOw0KDQoJCS5nY2wtY3AtdG9nZ2xlIHsNCgkJCWRpc3BsYXk6IGZsZXg7DQoJCQlhbGlnbi1pdGVtczogY2VudGVyOw0KCQkJYm9yZGVyOiAxcHggc29saWQgJGdyZXktMzAwOw0KCQkJYm9yZGVyLXJhZGl1czogMC41cmVtOw0KCQkJcGFkZGluZzogMXJlbTsNCgkJCWN1cnNvcjogcG9pbnRlcjsNCgkJCXRyYW5zaXRpb246IGJvcmRlci1yYWRpdXMgMC4zcyBjdWJpYy1iZXppZXIoMC4zLCAwLCAwLCAxKSwgYm9yZGVyIDAuM3MgZWFzZS1vdXQ7DQoNCgkJCS50aGVtZS1kYXJrICYgew0KCQkJCWJvcmRlci1jb2xvcjogJGdyZXktODAwOw0KCQkJfQ0KDQoJCQkuZ2NsLWNvbG9yLXN3YXRjaCB7DQoJCQkJbWFyZ2luLXJpZ2h0OiAwLjVyZW07DQoJCQl9DQoNCgkJCSYub3BlbiB7DQoJCQkJYm9yZGVyLXJhZGl1czogMC41cmVtIDAuNXJlbSAwIDA7DQoJCQkJYm9yZGVyLWNvbG9yOiAkZ3JleS00NTA7DQoNCgkJCQkudGhlbWUtZGFyayAmIHsNCgkJCQkJYm9yZGVyLWNvbG9yOiAkZ3JleS02MDA7DQoJCQkJfQ0KCQkJfQ0KCQl9DQoNCgkJLmdjbC1jcC1sYWJlbCB7DQoJCQljdXJzb3I6IHBvaW50ZXI7DQoJCQljb2xvcjogJGdyZXktNTAwOw0KCQkJbWFyZ2luLWxlZnQ6IDEuNXJlbTsNCg0KCQkJLnJlcXVpcmVkIHsNCgkJCQljb2xvcjogJHJlZDsNCgkJCX0NCg0KCQkJLnRoZW1lLWRhcmsgJiB7DQoJCQkJY29sb3I6ICRncmV5LTMwMDsNCgkJCX0NCgkJfQ0KDQoJCSY6aG92ZXIgew0KCQkJLmdjbC1jcC10b2dnbGUgew0KCQkJCWJvcmRlci1jb2xvcjogJGdyZXktNDUwOw0KDQoJCQkJLnRoZW1lLWRhcmsgJiB7DQoJCQkJCWJvcmRlci1jb2xvcjogJGdyZXktNjAwOw0KCQkJCX0NCgkJCX0NCgkJfQ0KCX0NCg0KCS5nY2wtY29sb3Itc3dhdGNoIHsNCgkJd2lkdGg6IDJyZW07DQoJCWhlaWdodDogMS41cmVtOw0KCQlib3JkZXI6IDFweCBzb2xpZCAkZ3JleS00MDA7DQoJCWJvcmRlci1yYWRpdXM6IDAuMjVyZW07DQoNCgkJLnRoZW1lLWRhcmsgJiB7DQoJCQlib3JkZXItY29sb3I6ICRibGFjay0xMDA7DQoJCX0NCgl9DQoNCgkuZ2NsLWZhZGVyIHsNCgkJdHJhbnNmb3JtLW9yaWdpbjogdG9wIGxlZnQ7DQoJCW1hcmdpbi10b3A6IC0xcHg7DQoJfQ0KDQoJLmdjbC1jb2xvci1waWNrZXIgew0KCQlwb3NpdGlvbjogYWJzb2x1dGU7DQoJCWJvcmRlci1yYWRpdXM6IDAgMC41cmVtIDAuNXJlbSAwLjVyZW07DQoJCWJveC1zaGFkb3c6ICRwb3B1cC1zaGFkb3ctZGFyazsNCgl9DQp9DQo="

/***/ },
/* 2541 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,LmdjbC1jcC1odWUgew0KCWJvcmRlci1yYWRpdXM6IDAuNXJlbTsNCgl3aWR0aDogMC41cmVtOw0KCWhlaWdodDogOS41cmVtOw0KDQoJLmdjbC1jcGgtY29udGFpbmVyIHsNCgkJYmFja2dyb3VuZDogbGluZWFyLWdyYWRpZW50KDkwZGVnLCAjZjAwIDAlLCAjZmYwIDE3JSwgIzBmMCAzMyUsICMwZmYgNTAlLCAjMDBmIDY3JSwgI2YwZiA4MyUsICNmMDAgMTAwJSk7DQoJCWJhY2tncm91bmQ6IC13ZWJraXQtbGluZWFyLWdyYWRpZW50KDkwZGVnLCAjZjAwIDAlLCAjZmYwIDE3JSwgIzBmMCAzMyUsICMwZmYgNTAlLCAjMDBmIDY3JSwgI2YwZiA4MyUsICNmMDAgMTAwJSk7DQoNCgkJcGFkZGluZzogMCAycHg7DQoJCXBvc2l0aW9uOiByZWxhdGl2ZTsNCgkJaGVpZ2h0OiAxMDAlOw0KCQlib3JkZXItcmFkaXVzOiAwLjVyZW07DQoJfQ0KDQoJLmdjbC1jcGgtcG9pbnRlciB7DQoJCXBvc2l0aW9uOiBhYnNvbHV0ZTsNCgkJbGVmdDogLTAuMjVyZW07DQoJfQ0KDQoJLmdjbC1jcGgtc2xpZGVyIHsNCgkJd2lkdGg6IDFyZW07DQoJCWhlaWdodDogMXJlbTsNCgkJYm9yZGVyLXJhZGl1czogNTAlOw0KCQlib3JkZXI6IDJweCBzb2xpZCB3aGl0ZTsNCgkJYm94LXNoYWRvdzogaW5zZXQgMCAwIDFweCAxcHggcmdiYSgwLCAwLCAwLCAwLjA0KSwgMCAwIDFweCAxcHggcmdiYSgwLCAwLCAwLCAwLjIpOw0KCQl0cmFuc2Zvcm06IHRyYW5zbGF0ZVkoLTAuNXJlbSk7DQoJfQ0KfQ0K"

/***/ },
/* 2542 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,LmdjbC1jcC1zYXR1cmF0aW9uIHsNCglwb3NpdGlvbjogYWJzb2x1dGU7DQoJdG9wOiAwOw0KCWJvdHRvbTogMDsNCglsZWZ0OiAwOw0KCXJpZ2h0OiAwOw0KDQoJLnNhdHVyYXRpb24td2hpdGUgew0KCQlwb3NpdGlvbjogYWJzb2x1dGU7DQoJCXRvcDogMDsNCgkJYm90dG9tOiAwOw0KCQlsZWZ0OiAwOw0KCQlyaWdodDogMDsNCgkJYmFja2dyb3VuZDogLXdlYmtpdC1saW5lYXItZ3JhZGllbnQodG8gcmlnaHQsICNmZmYsIHJnYmEoMjU1LCAyNTUsIDI1NSwgMCkpOw0KCQliYWNrZ3JvdW5kOiBsaW5lYXItZ3JhZGllbnQodG8gcmlnaHQsICNmZmYsIHJnYmEoMjU1LCAyNTUsIDI1NSwgMCkpOw0KCX0NCgkuc2F0dXJhdGlvbi1ibGFjayB7DQoJCXBvc2l0aW9uOiBhYnNvbHV0ZTsNCgkJdG9wOiAwOw0KCQlib3R0b206IDA7DQoJCWxlZnQ6IDA7DQoJCXJpZ2h0OiAwOw0KCQliYWNrZ3JvdW5kOiAtd2Via2l0LWxpbmVhci1ncmFkaWVudCh0byB0b3AsICMwMDAsIHJnYmEoMCwgMCwgMCwgMCkpOw0KCQliYWNrZ3JvdW5kOiBsaW5lYXItZ3JhZGllbnQodG8gdG9wLCAjMDAwLCByZ2JhKDAsIDAsIDAsIDApKTsNCgl9DQoNCgkuZ2NsLWNwcy1wb2ludGVyIHsNCgkJcG9zaXRpb246IGFic29sdXRlOw0KCQljdXJzb3I6IGRlZmF1bHQ7DQoNCgkJLmdjbC1jcHMtY2lyY2xlIHsNCgkJCXdpZHRoOiAxcmVtOw0KCQkJaGVpZ2h0OiAxcmVtOw0KCQkJYm9yZGVyOiAycHggc29saWQgd2hpdGU7DQoJCQlib3gtc2hhZG93OiBpbnNldCAwIDAgMXB4IDFweCByZ2JhKDAsIDAsIDAsIDAuMTIpLCAwIDAgMXB4IDFweCByZ2JhKDAsIDAsIDAsIDAuMik7DQoJCQlib3JkZXItcmFkaXVzOiA1MCU7DQoJCQljdXJzb3I6IGdyYWI7DQoJCQl0cmFuc2Zvcm06IHRyYW5zbGF0ZSgtMC41cmVtLCAtMC41cmVtKTsNCgkJfQ0KCX0NCn0NCg=="

/***/ },
/* 2543 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,QGltcG9ydCAnLi4vLi4vc3R5bGVzL3ZhcmlhYmxlcy5zY3NzJzsNCg0KLmdjbC1jb3VudGVyIHsNCglkaXNwbGF5OiBmbGV4Ow0KCWFsaWduLWl0ZW1zOiBjZW50ZXI7DQoJd2lkdGg6IDEzNnB4Ow0KCW1pbi13aWR0aDogMTM2cHg7DQoJJiA+IGlucHV0LmdjbC1jb3VudGVyLWlucHV0Ojotd2Via2l0LW91dGVyLXNwaW4tYnV0dG9uLA0KCSYgPiBpbnB1dC5nY2wtY291bnRlci1pbnB1dDo6LXdlYmtpdC1pbm5lci1zcGluLWJ1dHRvbiB7DQoJCS13ZWJraXQtYXBwZWFyYW5jZTogbm9uZTsNCgkJbWFyZ2luOiAwOw0KCX0NCg0KCSYgPiBpbnB1dFt0eXBlPSdudW1iZXInXS5nY2wtY291bnRlci1pbnB1dCB7DQoJCS1tb3otYXBwZWFyYW5jZTogdGV4dGZpZWxkOw0KDQoJCSYuZGlzYWJsZWQgew0KCQkJYmFja2dyb3VuZC1jb2xvcjogJGdyZXktNTA7DQoJCQlib3JkZXItY29sb3I6ICRncmV5LTUwLTg7DQoJCQlwb2ludGVyLWV2ZW50czogbm9uZTsNCgkJCWNvbG9yOiAkZ3JleS0yMDA7DQoJCX0NCgl9DQoNCgkmID4gYnV0dG9uLmdjbC1idG4uc2Vjb25kYXJ5IHsNCgkJaGVpZ2h0OiAycmVtOw0KCQl3aWR0aDogMnJlbTsNCgkJbWluLXdpZHRoOiAycmVtOw0KCQlwYWRkaW5nOiAwOw0KCQlib3JkZXItcmFkaXVzOiAxcmVtOw0KCQlkaXNwbGF5OiBmbGV4Ow0KCQlhbGlnbi1pdGVtczogY2VudGVyOw0KCQlqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjsNCgkJaS5nY2wtaWNvbiB7DQoJCQltYXJnaW46IHVuc2V0Ow0KCQkJdmVydGljYWwtYWxpZ246IHVuc2V0Ow0KCQl9DQoJfQ0KDQoJJiA+IGlucHV0IHsNCgkJYWxpZ24taXRlbXM6IGNlbnRlcjsNCgkJaGVpZ2h0OiAzLjVyZW07DQoJCXdpZHRoOiAzLjVyZW07DQoJCWJvcmRlcjogMC4wNjNyZW0gc29saWQgJGdyZXktNDAwOw0KCQlib3JkZXItcmFkaXVzOiAwLjI1cmVtOw0KCQljb2xvcjogJGdyZXktNDAwOw0KCQliYWNrZ3JvdW5kLWNvbG9yOiB3aGl0ZTsNCgkJZm9udC1zaXplOiAxLjI1cmVtOw0KCQl0ZXh0LWFsaWduOiBjZW50ZXI7DQoJCW1hcmdpbjogMCAwLjVyZW07DQoJCXRyYW5zaXRpb246IGJhY2tncm91bmQtY29sb3IgMC4zcyBlYXNlLW91dCwgYm9yZGVyLWNvbG9yIDAuM3MgZWFzZS1vdXQsIGJveC1zaGFkb3cgMC4zcyBlYXNlLW91dCwgY29sb3IgMC4zcyBlYXNlLW91dDsNCgkJJjpob3ZlciB7DQoJCQlib3JkZXItY29sb3I6ICRncmV5LTYwMDsNCgkJCWNvbG9yOiAkZ3JleS02MDA7DQoJCX0NCgkJJjpmb2N1cyB7DQoJCQlvdXRsaW5lOiBub25lOw0KCQkJY29sb3I6ICRncmV5LTYwMDsNCgkJCWJvcmRlci1jb2xvcjogJGJsdWU7DQoJCQlib3gtc2hhZG93OiAwIDAgMC41cmVtICRibHVlLTIwMDsNCgkJfQ0KCX0NCn0NCg=="

/***/ },
/* 2544 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,QGltcG9ydCAnLi4vLi4vc3R5bGVzL3ZhcmlhYmxlcy5zY3NzJzsNCg0KLnRoZW1lLWRhcmsgLmdjbC1jb3VudGVyIHsNCgkmID4gaW5wdXRbdHlwZT0nbnVtYmVyJ10uZ2NsLWNvdW50ZXItaW5wdXQuZGlzYWJsZWQgew0KCQliYWNrZ3JvdW5kLWNvbG9yOiAkZ3JleS05MDA7DQoJCWJvcmRlci1jb2xvcjogJGdyZXktNzAwOw0KCQlwb2ludGVyLWV2ZW50czogbm9uZTsNCgkJY29sb3I6ICRncmV5LTcwMDsNCgl9DQoNCgkmID4gaW5wdXQgew0KCQlib3JkZXItY29sb3I6ICRncmV5LTgwMDsNCgkJYmFja2dyb3VuZC1jb2xvcjogJGJsYWNrLTIwMDsNCgkJY29sb3I6ICRncmV5LTMwMDsNCgkJJjpob3ZlciB7DQoJCQlib3JkZXItY29sb3I6ICRncmV5LTUwMDsNCgkJCWNvbG9yOiAkZ3JleS0yMDA7DQoJCX0NCgkJJjpmb2N1cyB7DQoJCQlib3JkZXItY29sb3I6ICRnb2xkOw0KCQkJYm94LXNoYWRvdzogMCAwIDAuNXJlbSAkZ29sZC0zMjsNCgkJCWNvbG9yOiAkZ3JleS0yMDA7DQoJCX0NCgl9DQp9DQo="

/***/ },
/* 2545 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,QGltcG9ydCAnLi4vLi4vc3R5bGVzL3ZhcmlhYmxlcy5zY3NzJzsNCg0KLmdjbC1kaWFsb2ctYm94IHsNCgl3aWR0aDogMzByZW07DQoJYm94LXNpemluZzogYm9yZGVyLWJveDsNCg0KCS5tb2RhbC1jb250ZW50IHsNCgkJLmdjbC1kaWFsb2ctYm94LXdyYXBwZXIgew0KCQkJcGFkZGluZzogMDsNCgkJCWJvcmRlci1yYWRpdXM6IDhweDsNCgkJfQ0KCQkuZ2NsLWRpYWxvZy1ib3gtYm9keSB7DQoJCQloZWlnaHQ6IDEwMCU7DQoJCQlwYWRkaW5nOiAycmVtIDEuNXJlbSAxLjVyZW07DQoNCgkJCS5nY2wtdGl0bGUtZGlhbG9nLWJveCB7DQoJCQkJbGluZS1oZWlnaHQ6IDEuNzVyZW07DQoJCQkJdGV4dC1vdmVyZmxvdzogZWxsaXBzaXM7DQoJCQkJd2hpdGUtc3BhY2U6IG5vd3JhcDsNCgkJCQlvdmVyZmxvdzogaGlkZGVuOw0KCQkJCWZvbnQtc2l6ZTogMS4yNXJlbTsNCgkJCQlmb250LXdlaWdodDogJHNlbWlib2xkOw0KCQkJCWNvbG9yOiAkZ3JleS02MDA7DQoJCQkJbWFyZ2luLWJvdHRvbTogMS41cmVtOw0KDQoJCQkJLnRoZW1lLWRhcmsgJiB7DQoJCQkJCWNvbG9yOiAkZ3JleS0zMDA7DQoJCQkJfQ0KCQkJfQ0KCQkJLmdjbC1jb250ZW50LWRpYWxvZy1ib3ggew0KCQkJCWNvbG9yOiAkZ3JleS01MDA7DQoJCQkJZm9udC1zaXplOiAxcmVtOw0KDQoJCQkJLnRoZW1lLWRhcmsgJiB7DQoJCQkJCWNvbG9yOiAkZ3JleS0zMDA7DQoJCQkJfQ0KCQkJfQ0KCQl9DQoJfQ0KCS5tb2RhbC1mb290ZXIgew0KCQlib3JkZXItdG9wOiBub25lOw0KCQlwYWRkaW5nOiAwLjVyZW07DQoJfQ0KfQ0K"

/***/ },
/* 2546 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,QGltcG9ydCAnLi4vLi4vc3R5bGVzL3ZhcmlhYmxlcy5zY3NzJzsNCg0KLmdjbC1kbmQgew0KCWRpc3BsYXk6IGJsb2NrOw0KCXBhZGRpbmc6IDA7DQoJbWFyZ2luOiAwOw0KCSYucmVsYXRpdmUgew0KCQlwb3NpdGlvbjogcmVsYXRpdmU7DQoJfQ0KCSYuYWJzb2x1dGUgew0KCQlwb3NpdGlvbjogYWJzb2x1dGU7DQoJfQ0KCWlucHV0IHsNCgkJZGlzcGxheTogbm9uZTsNCgl9DQp9DQo="

/***/ },
/* 2547 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,QGltcG9ydCAnLi4vLi4vc3R5bGVzL3ZhcmlhYmxlcy5zY3NzJzsNCg0KLmdjbC1kbmQtbWFpbiB7DQoJcG9zaXRpb246IGFic29sdXRlOw0KCXZpc2liaWxpdHk6IGhpZGRlbjsNCgkmLmRyYWdnaW5nLA0KCSYubG9hZGluZyB7DQoJCXZpc2liaWxpdHk6IHZpc2libGU7DQoJCXdpZHRoOiBjYWxjKDEwMCUgLSAxcmVtKTsNCgkJaGVpZ2h0OiBjYWxjKDEwMCUgLSAxcmVtKTsNCgkJZGlzcGxheTogZmxleDsNCgkJZmxleC1kaXJlY3Rpb246IGNvbHVtbjsNCgkJYWxpZ24taXRlbXM6IGNlbnRlcjsNCgkJanVzdGlmeS1jb250ZW50OiBjZW50ZXI7DQoJCWJvcmRlcjogZGFzaGVkIDJweCAkYmx1ZS0zMDA7DQoJCWJhY2tncm91bmQtY29sb3I6ICRibHVlLTEwMDsNCgkJYm9yZGVyLXJhZGl1czogMC41cmVtOw0KCQlvcGFjaXR5OiAwLjc1Ow0KCQlwYWRkaW5nOiAwOw0KCQl0b3A6IDAuNXJlbTsNCgkJbGVmdDogMC41cmVtOw0KCQljb2xvcjogJGJsdWUtMzAwOw0KCQlmb250LXNpemU6IDJyZW07DQoJCXotaW5kZXg6IDk5OTsNCgl9DQoJLmdjbC1kbmQtbWFpbi1sb2FkZXIgew0KCQlkaXNwbGF5OiBmbGV4Ow0KCQlmbGV4LWRpcmVjdGlvbjogY29sdW1uOw0KCQlhbGlnbi1pdGVtczogY2VudGVyOw0KCQlqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjsNCgkJaGVpZ2h0OiBhdXRvOw0KCQltaW4taGVpZ2h0OiA2cmVtOw0KCQl3aWR0aDogYXV0bzsNCgkJLnNwaW5uZXItYm9yZGVyLnRleHQtcHJpbWFyeSB7DQoJCQloZWlnaHQ6IDIuNzVyZW07DQoJCQl3aWR0aDogMi43NXJlbTsNCgkJCWJvcmRlcjogMC4xMjVyZW0gc29saWQgJGJsdWU7DQoJCQlib3JkZXItYm90dG9tOiAwLjEyNXJlbSBzb2xpZCB0cmFuc3BhcmVudDsNCgkJfQ0KCQlzcGFuIHsNCgkJCWZvbnQtc2l6ZTogMC44NzVyZW07DQoJCQlmb250LXdlaWdodDogNDAwOw0KCQkJY29sb3I6ICRibHVlOw0KCQl9DQoJfQ0KfQ0K"

/***/ },
/* 2548 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,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"

/***/ },
/* 2549 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,QGltcG9ydCAnLi4vLi4vc3R5bGVzL3ZhcmlhYmxlcy5zY3NzJzsNCg0KLnRoZW1lLWRhcmsgLmdjbC1kZC1jb250YWluZXIgew0KCS5nY2wtZGQtaWNvbiB7DQoJCS5nY2wtZGQtYnV0dG9uIHsNCgkJCT4gLmdjbC1pY29uIHsNCgkJCQliYWNrZ3JvdW5kLWNvbG9yOiAkZ3JleS0zMDA7DQoJCQl9DQoJCQkmOmhvdmVyID4gLmdjbC1pY29uIHsNCgkJCQliYWNrZ3JvdW5kLWNvbG9yOiAkZ3JleS0yMDA7DQoJCQl9DQoJCQkmOmZvY3VzID4gLmdjbC1pY29uIHsNCgkJCQliYWNrZ3JvdW5kLWNvbG9yOiAkZ3JleS0zMDA7DQoJCQl9DQoJCQkmOmFjdGl2ZSA+IC5nY2wtaWNvbiB7DQoJCQkJYmFja2dyb3VuZC1jb2xvcjogJGdyZXktNTAwOw0KCQkJfQ0KCQkJJjpkaXNhYmxlZCA+IC5nY2wtaWNvbiB7DQoJCQkJYmFja2dyb3VuZC1jb2xvcjogJGdyZXktNzAwOw0KCQkJfQ0KCQl9DQoJfQ0KCS5nY2wtZGQtbWVudS1jb250YWluZXIgew0KCQliYWNrZ3JvdW5kLWNvbG9yOiAkZ3JleS04MDA7DQoJCWJvcmRlcjogMXB4IHNvbGlkICRncmV5LTcwMDsNCgkJLmdjbC1kZC1tZW51LXdyYXAgew0KCQkJLmdjbC1kZC1vcHRpb24gew0KCQkJCWNvbG9yOiAkZ3JleS0zMDA7DQoJCQkJPiAuZ2NsLWljb24gew0KCQkJCQliYWNrZ3JvdW5kLWNvbG9yOiAkZ3JleS0zMDA7DQoJCQkJfQ0KCQkJCSY6aG92ZXIgew0KCQkJCQliYWNrZ3JvdW5kLWNvbG9yOiAkZ3JleS03MDA7DQoJCQkJCWNvbG9yOiAkZ3JleS0xMDA7DQoNCgkJCQkJPiAuZ2NsLWljb24gew0KCQkJCQkJYmFja2dyb3VuZC1jb2xvcjogJGdyZXktMTAwOw0KCQkJCQl9DQoJCQkJfQ0KCQkJfQ0KCQl9DQoJfQ0KfQ0K"

/***/ },
/* 2550 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,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"

/***/ },
/* 2551 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,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"

/***/ },
/* 2552 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,QGltcG9ydCAnLi4vLi4vc3R5bGVzL3ZhcmlhYmxlcy5zY3NzJzsNCg0KLnNiLWZpbHRlci10b2dnbGUgew0KCWRpc3BsYXk6IGlubGluZS1mbGV4Ow0KCWhlaWdodDogMi4yNXJlbTsNCglsaW5lLWhlaWdodDogMi4yNXJlbTsNCgljdXJzb3I6IHBvaW50ZXI7DQoJcG9zaXRpb246IHJlbGF0aXZlOw0KCWJvcmRlcjogMXB4IHNvbGlkICRncmV5LTcwMDsNCgliYWNrZ3JvdW5kLWNvbG9yOiAkYmxhY2stNDAwLTg7DQoJY29sb3I6ICRncmV5LTcwMDsNCglib3JkZXItcmFkaXVzOiAxLjEyNXJlbTsNCglhbGlnbi1pdGVtczogY2VudGVyOw0KCXRleHQtdHJhbnNmb3JtOiB1cHBlcmNhc2U7DQoJZm9udC13ZWlnaHQ6ICRzZW1pYm9sZDsNCglmb250LXNpemU6IDAuODc1cmVtOw0KCWxldHRlci1zcGFjaW5nOiAxLjEycHg7DQoJcGFkZGluZzogMCAxcmVtOw0KCXVzZXItc2VsZWN0OiBub25lOw0KCXRyYW5zaXRpb246IGJhY2tncm91bmQtY29sb3IgMC4ycyBlYXNlLW91dCwgYm9yZGVyLWNvbG9yIDAuMnMgZWFzZS1vdXQsIGNvbG9yIDAuMnMgZWFzZS1vdXQ7DQoNCgkmOmhvdmVyIHsNCgkJYmFja2dyb3VuZC1jb2xvcjogJGJsYWNrLTQwMC0xNjsNCgkJYm9yZGVyLWNvbG9yOiAkZ3JleS04MDA7DQoJCWNvbG9yOiAkZ3JleS04MDA7DQoJfQ0KDQoJJi5lbXB0eTpub3QoLm9wZW4pOm5vdCgucmVhY3QtZGF0ZXBpY2tlci1pZ25vcmUtb25jbGlja291dHNpZGUpIHsNCgkJYmFja2dyb3VuZC1jb2xvcjogdHJhbnNwYXJlbnQ7DQoJCWJvcmRlci1jb2xvcjogJGdyZXktNTAwOw0KCQljb2xvcjogJGdyZXktNjAwOw0KDQoJCSY6aG92ZXIgew0KCQkJYm9yZGVyLWNvbG9yOiAkZ3JleS03MDA7DQoJCQljb2xvcjogJGdyZXktNzAwOw0KCQl9DQoJfQ0KDQoJJi5kaXNhYmxlZCB7DQoJCXBvaW50ZXItZXZlbnRzOiBub25lOw0KCQlvcGFjaXR5OiAwLjMyOw0KCX0NCn0NCg0KLnNiLWZpbHRlci1jdXN0b20tdG9nZ2xlIHsNCgkmLmdjbC1pY29uIHsNCgkJJjpub3QoLmVtcHR5KTpub3QoLm9wZW4pOm5vdCg6YWN0aXZlKSB7DQoJCQliYWNrZ3JvdW5kLWNvbG9yOiAkZ3JleS02MDA7DQoNCgkJCS50aGVtZS1kYXJrICYgew0KCQkJCWJhY2tncm91bmQtY29sb3I6ICRncmV5LTIwMDsNCgkJCX0NCgkJfQ0KCQkmLm9wZW4gew0KCQkJYmFja2dyb3VuZC1jb2xvcjogJGJsdWUtNDAwOw0KDQoJCQkudGhlbWUtZGFyayAmIHsNCgkJCQliYWNrZ3JvdW5kLWNvbG9yOiAkZ29sZDsNCgkJCX0NCgkJfQ0KCX0NCn0NCg0KLnNiLWZpbHRlci1wb3BvdmVyIHsNCgkucG9wb3ZlciB7DQoJCWZvbnQtZmFtaWx5OiAkZm9udDsNCgkJZm9udC1zaXplOiAxcmVtOw0KCQliYWNrZ3JvdW5kLWNvbG9yOiB3aGl0ZTsNCgkJYm9yZGVyLWNvbG9yOiAkZ3JleS01MDsNCgkJYm9yZGVyLXJhZGl1czogMC41cmVtOw0KCQlib3gtc2hhZG93OiAkcG9wdXAtc2hhZG93LWRhcms7DQoJCW1heC13aWR0aDogMTcuNXJlbTsNCgkJei1pbmRleDogMTA1MDsNCgl9DQoJLnBvcG92ZXItYm9keSB7DQoJCXBhZGRpbmc6IDA7DQoJCWNvbG9yOiAkZ3JleS02MDA7DQoJfQ0KCUBtZWRpYSBzY3JlZW4gYW5kIChwb2ludGVyOiBmaW5lKSB7DQoJCTo6LXdlYmtpdC1zY3JvbGxiYXIgew0KCQkJd2lkdGg6IDAuODc1cmVtOw0KCQl9DQoJCTo6LXdlYmtpdC1zY3JvbGxiYXItdHJhY2sgew0KCQkJYmFja2dyb3VuZC1jb2xvcjogcmdiYSgyNTUsIDI1NSwgMjU1LCAwLjIpOw0KCQkJYm9yZGVyOiAwLjI1cmVtIHNvbGlkIHdoaXRlOw0KCQl9DQoJCTo6LXdlYmtpdC1zY3JvbGxiYXItdGh1bWIgew0KCQkJYmFja2dyb3VuZC1jb2xvcjogJGdyZXktMjAwOw0KCQkJYm9yZGVyLXJhZGl1czogMC41cmVtOw0KCQkJYm9yZGVyOiAwLjI1cmVtIHNvbGlkIHdoaXRlOw0KCQl9DQoJfQ0KDQoJLnNiLWZpbHRlci1ib2R5IHsNCgkJaGVhZGVyIHsNCgkJCXBhZGRpbmc6IDFyZW07DQoNCgkJCS5nY2wtZmlsdGVyLWlucHV0IHsNCgkJCQl3aWR0aDogMTAwJTsNCgkJCX0NCgkJCS5nY2wtYnRuIHsNCgkJCQl3aWR0aDogMTAwJTsNCgkJCQltYXgtd2lkdGg6IDE1LjVyZW07DQoJCQl9DQoJCX0NCgkJLnNiLWZpbHRlci1tYWluIHsNCgkJCXBhZGRpbmc6IDAgMXJlbTsNCgkJCW1heC1oZWlnaHQ6IDEzLjVyZW07DQoJCQlvdmVyZmxvdy15OiBvdmVybGF5Ow0KCQkJb3ZlcmZsb3c6IGF1dG87DQoJCQlzY3JvbGxiYXItd2lkdGg6IHRoaW47DQoJCX0NCgkJZm9vdGVyIHsNCgkJCXBhZGRpbmc6IDFyZW07DQoJCQlkaXNwbGF5OiBmbGV4Ow0KCQkJanVzdGlmeS1jb250ZW50OiBzcGFjZS1iZXR3ZWVuOw0KDQoJCQlidXR0b24gew0KCQkJCSY6b25seS1jaGlsZCB7DQoJCQkJCW1hcmdpbi1sZWZ0OiBhdXRvOw0KCQkJCX0NCgkJCQkmOm50aC1jaGlsZCgyKSB7DQoJCQkJCW1hcmdpbi1sZWZ0OiAxcmVtOw0KCQkJCX0NCgkJCX0NCgkJfQ0KDQoJCSYuc2ItcmFuZ2UtZmlsdGVyIHsNCgkJCXdpZHRoOiAxNXJlbTsNCgkJCWhlYWRlciB7DQoJCQkJdGV4dC1hbGlnbjogY2VudGVyOw0KCQkJCXNwYW4gew0KCQkJCQlmb250LXNpemU6IDFyZW07DQoJCQkJCWNvbG9yOiAkYmx1ZS00MDA7DQoJCQkJCWRpc3BsYXk6IGlubGluZS1ibG9jazsNCgkJCQkJbWFyZ2luOiAwIDAuNXJlbTsNCgkJCQl9DQoJCQl9DQoJCQlmb290ZXIgew0KCQkJCW1hcmdpbi10b3A6IDFyZW07DQoJCQl9DQoNCgkJCS5zYi1yZi1pbnB1dCB7DQoJCQkJYm9yZGVyOiAxcHggc29saWQgJGdyZXktMzAwOw0KCQkJCWhlaWdodDogMi41cmVtOw0KCQkJCWxpbmUtaGVpZ2h0OiAyLjVyZW07DQoJCQkJd2lkdGg6IDUuMjVyZW07DQoJCQkJY29sb3I6ICRibHVlLTQwMDsNCgkJCQl0ZXh0LWFsaWduOiBjZW50ZXI7DQoJCQkJcGFkZGluZzogMDsNCgkJCQktbW96LWFwcGVhcmFuY2U6IHRleHRmaWVsZDsNCgkJCQlib3JkZXItcmFkaXVzOiAwLjI1cmVtOw0KCQkJCWZvbnQtd2VpZ2h0OiAkcmVndWxhcjsNCgkJCQl0cmFuc2l0aW9uOiBib3gtc2hhZG93IDAuM3MgZWFzZS1vdXQsIGJvcmRlci1jb2xvciAwLjNzIGVhc2Utb3V0Ow0KDQoJCQkJJjpmb2N1cyB7DQoJCQkJCW91dGxpbmU6IG5vbmU7DQoJCQkJCWJvcmRlci1jb2xvcjogJGJsdWUtNDAwOw0KCQkJCQlib3gtc2hhZG93OiAwIDAgMC41cmVtICRibHVlLTQwMC00MDsNCgkJCQl9DQoJCQl9DQoJCX0NCg0KCQkmLnNiLWNvdW50ZXItZmlsdGVyIHsNCgkJCXdpZHRoOiAxNXJlbTsNCgkJCWhlYWRlciB7DQoJCQkJZm9udC1zaXplOiAwLjc1cmVtOw0KCQkJCWNvbG9yOiAkZ3JleS02MDA7DQoJCQkJbGluZS1oZWlnaHQ6IDEuMTI1cmVtOw0KCQkJCWRpc3BsYXk6IGlubGluZS1ibG9jazsNCgkJCQktd2Via2l0LWh5cGhlbnM6IGF1dG87DQoJCQkJLW1zLWh5cGhlbnM6IGF1dG87DQoJCQkJaHlwaGVuczogYXV0bzsNCg0KCQkJCS50aGVtZS1kYXJrICYgew0KCQkJCQljb2xvcjogJGdyZXktMzAwOw0KCQkJCX0NCgkJCX0NCgkJCWZvb3RlciB7DQoJCQkJbWFyZ2luLXRvcDogLTFyZW07DQoJCQl9DQoNCgkJCS5zYi1maWx0ZXItbWFpbiB7DQoJCQkJZGlzcGxheTogZmxleDsNCgkJCQlqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjsNCgkJCQlwYWRkaW5nLWJvdHRvbTogMS41cmVtOw0KCQkJfQ0KCQl9DQoNCgkJJi5zYi1saXN0LWZpbHRlciB7DQoJCQltaW4td2lkdGg6IDE3LjVyZW07DQoJCQlwYWRkaW5nLXRvcDogMXJlbTsNCg0KCQkJJi5uby1idXR0b25zIHsNCgkJCQlwYWRkaW5nOiAwLjVyZW0gMDsNCgkJCX0NCg0KCQkJaGVhZGVyIHsNCgkJCQlwYWRkaW5nLXRvcDogMDsNCgkJCQkuZ2NsLWJ0biB7DQoJCQkJCW1hcmdpbi1ib3R0b206IC0wLjVyZW07DQoJCQkJfQ0KCQkJfQ0KDQoJCQkuZ2NsLWNoZWNrIHNwYW4gew0KCQkJCXdoaXRlLXNwYWNlOiBub3dyYXA7DQoJCQkJdGV4dC1vdmVyZmxvdzogZWxsaXBzaXM7DQoJCQkJb3ZlcmZsb3c6IGhpZGRlbjsNCgkJCX0NCg0KCQkJJi5zYi1zZWFyY2gtZmlsdGVyIHsNCgkJCQkmLm5vLWJ1dHRvbnMgew0KCQkJCQlwYWRkaW5nOiAxcmVtIDA7DQoJCQkJfQ0KDQoJCQkJLnNiLWZpbHRlci1tYWluIHsNCgkJCQkJbWF4LWhlaWdodDogOS44NzVyZW07DQoJCQkJfQ0KDQoJCQkJaGVhZGVyIHsNCgkJCQkJZGlzcGxheTogZmxleDsNCgkJCQkJZmxleC1kaXJlY3Rpb246IGNvbHVtbjsNCgkJCQkJYWxpZ24taXRlbXM6IGNlbnRlcjsNCgkJCQkJYm9yZGVyLWJvdHRvbTogMXB4IHNvbGlkICRncmV5LTIwMDsNCg0KCQkJCQkuZ2NsLWJ0biB7DQoJCQkJCQltYXJnaW4tdG9wOiAwLjVyZW07DQoJCQkJCX0NCgkJCQl9DQoJCQkJZm9vdGVyIHsNCgkJCQkJYm9yZGVyLXRvcDogMXB4IHNvbGlkICRncmV5LTIwMDsNCgkJCQl9DQoJCQl9DQoJCX0NCg0KCQkmLnNiLWxpc3QtZmlsdGVyLA0KCQkmLnNiLWl0ZW0tZmlsdGVyIHsNCgkJCS5zYi1maWx0ZXItbWFpbiB7DQoJCQkJcGFkZGluZzogMDsNCgkJCQlwb3NpdGlvbjogcmVsYXRpdmU7DQoJCQkJYm94LXNoYWRvdzogaW5zZXQgMCAxMnB4IDhweCAtOHB4ICRibGFjay00MDAtOCwgaW5zZXQgMCAtMTJweCA4cHggLThweCAkYmxhY2stNDAwLTg7DQoJCQl9DQoJCQkuc2JmLWxpc3QtZmlsdGVyLXNjcm9sbCB7DQoJCQkJcGFkZGluZzogMCAwLjVyZW07DQoJCQkJYm94LXNoYWRvdzogaW5zZXQgMCAxNnB4IDhweCAtOHB4IHdoaXRlLCBpbnNldCAwIC0xNnB4IDhweCAtOHB4IHdoaXRlOw0KDQoJCQkJLnNiZi1saXN0LWZpbHRlci1saXN0IHsNCgkJCQkJcGFkZGluZzogMC41cmVtIDA7DQoJCQkJfQ0KCQkJfQ0KCQl9DQoNCgkJJi5zYi1pdGVtLWZpbHRlciB7DQoJCQltaW4td2lkdGg6IDE3LjVyZW07DQoJCQloZWFkZXIgew0KCQkJCWRpc3BsYXk6IGZsZXg7DQoJCQkJLmdjbC1vdXRzaWRlLWNsaWNrLXdyYXBwZXIgew0KCQkJCQlmbGV4OiAxIDEgYXV0bzsNCgkJCQkJbWFyZ2luLXJpZ2h0OiAxcmVtOw0KCQkJCQkuZ2xjLWxhYmVsSW5wdXQgew0KCQkJCQkJbWluLXdpZHRoOiAwOw0KCQkJCQl9DQoJCQkJfQ0KDQoJCQkJLmdjbC1idG4gew0KCQkJCQl3aWR0aDogMy41cmVtOw0KCQkJCQloZWlnaHQ6IDMuNXJlbTsNCgkJCQkJcGFkZGluZzogMDsNCgkJCQkJZmxleDogMCAwIGF1dG87DQoJCQkJCS5nY2wtaWNvbiB7DQoJCQkJCQltYXJnaW46IDA7DQoJCQkJCX0NCgkJCQl9DQoJCQl9DQoNCgkJCS5zYmYtbGlzdC1maWx0ZXItc2Nyb2xsIHsNCgkJCQlwYWRkaW5nOiAwIDFyZW07DQoNCgkJCQkuc2JmLWxpc3QtZmlsdGVyLWxpc3Qgew0KCQkJCX0NCgkJCX0NCgkJCS5zYmlmLWl0ZW0gew0KCQkJCWJhY2tncm91bmQtY29sb3I6ICRncmV5LTUwOw0KCQkJCWNvbG9yOiAkZ3JleS03MDA7DQoJCQkJcGFkZGluZzogMC41cmVtIDAuNXJlbSAwLjVyZW0gMXJlbTsNCgkJCQlib3JkZXItcmFkaXVzOiAwLjI1cmVtOw0KCQkJCWRpc3BsYXk6IGZsZXg7DQoJCQkJanVzdGlmeS1jb250ZW50OiBzcGFjZS1iZXR3ZWVuOw0KCQkJCWFsaWduLWl0ZW1zOiBjZW50ZXI7DQoJCQkJbWFyZ2luLWJvdHRvbTogMC41cmVtOw0KCQkJfQ0KCQl9DQoJfQ0KDQoJJi5sYXJnZSB7DQoJCS5wb3BvdmVyIHsNCgkJCW1heC13aWR0aDogMjZyZW07DQoJCQl3aWR0aDogMjZyZW07DQoJCX0NCgkJLnNiLWZpbHRlci1ib2R5LnNiLWxpc3QtZmlsdGVyLnNiLXNlYXJjaC1maWx0ZXIgLnNiLWZpbHRlci1tYWluIHsNCgkJCW1heC1oZWlnaHQ6IDEzLjc1cmVtOw0KCQl9DQoJfQ0KfQ0KDQoudGhlbWUtZGFyayAuc2ItZmlsdGVyLXRvZ2dsZSB7DQoJYm9yZGVyLWNvbG9yOiAkZ3JleS0zMDA7DQoJYmFja2dyb3VuZC1jb2xvcjogJGdyZXktNTAtODsNCgljb2xvcjogJGdyZXktMzAwOw0KDQoJJjpob3ZlciB7DQoJCWJhY2tncm91bmQtY29sb3I6ICRncmV5LTUwLTE2Ow0KCX0NCg0KCSYuZW1wdHk6bm90KC5vcGVuKSB7DQoJCWJhY2tncm91bmQtY29sb3I6IHRyYW5zcGFyZW50Ow0KCQlib3JkZXItY29sb3I6ICRncmV5LTUwMDsNCgkJY29sb3I6ICRncmV5LTUwMDsNCg0KCQkmOmhvdmVyIHsNCgkJCWJvcmRlci1jb2xvcjogJGdyZXktMzAwOw0KCQkJY29sb3I6ICRncmV5LTMwMDsNCgkJfQ0KCX0NCn0NCg0KLnRoZW1lLWRhcmsgLnNiLWZpbHRlci1wb3BvdmVyIHsNCgkucG9wb3ZlciB7DQoJCWJhY2tncm91bmQtY29sb3I6ICRibGFjay0xMDA7DQoJCWJvcmRlci1jb2xvcjogJGdyZXktOTAwOw0KCX0NCgkucG9wb3Zlci1ib2R5IHsNCgkJY29sb3I6ICRncmV5LTUwMDsNCgl9DQoJQG1lZGlhIHNjcmVlbiBhbmQgKHBvaW50ZXI6IGZpbmUpIHsNCgkJOjotd2Via2l0LXNjcm9sbGJhci10cmFjayB7DQoJCQliYWNrZ3JvdW5kLWNvbG9yOiByZ2JhKDM4LCA1NCwgNjQsIDAuMDIpOw0KCQkJYm9yZGVyOiAwLjI1cmVtIHNvbGlkICRibGFjay0xMDA7DQoJCX0NCgkJOjotd2Via2l0LXNjcm9sbGJhci10aHVtYiB7DQoJCQliYWNrZ3JvdW5kLWNvbG9yOiAkZ3JleS03MDA7DQoJCQlib3JkZXItcmFkaXVzOiAwLjVyZW07DQoJCQlib3JkZXI6IDAuMjVyZW0gc29saWQgJGJsYWNrLTEwMDsNCgkJfQ0KCX0NCg0KCS5zYi1maWx0ZXItYm9keSB7DQoJCSYuc2ItcmFuZ2UtZmlsdGVyIHsNCgkJCWhlYWRlciBzcGFuIHsNCgkJCQljb2xvcjogJGdvbGQ7DQoJCQl9DQoJCQkuc2ItcmYtaW5wdXQgew0KCQkJCWJhY2tncm91bmQtY29sb3I6ICRibGFjay0yMDA7DQoJCQkJYm9yZGVyLWNvbG9yOiAkZ3JleS01MDA7DQoJCQkJY29sb3I6ICRnb2xkOw0KDQoJCQkJJjpmb2N1cyB7DQoJCQkJCWJvcmRlci1jb2xvcjogJGdvbGQ7DQoJCQkJCWJveC1zaGFkb3c6IDAgMCAwLjVyZW0gJGdvbGQtNDA7DQoJCQkJfQ0KCQkJfQ0KCQl9DQoJCSYuc2ItbGlzdC1maWx0ZXIgew0KCQkJLnNiLWZpbHRlci1tYWluIHsNCgkJCQlib3gtc2hhZG93OiBpbnNldCAwIDEycHggOHB4IC04cHggJGJsYWNrLTQwMC0zMiwgaW5zZXQgMCAtMTJweCA4cHggLThweCAkYmxhY2stNDAwLTMyOw0KCQkJfQ0KCQkJLnNiZi1saXN0LWZpbHRlci1zY3JvbGwgew0KCQkJCXBhZGRpbmc6IDAgMC41cmVtOw0KCQkJCWJveC1zaGFkb3c6IGluc2V0IDAgMTZweCA4cHggLThweCAkYmxhY2stMTAwLCBpbnNldCAwIC0xNnB4IDhweCAtOHB4ICRibGFjay0xMDA7DQoJCQl9DQoJCQkmLnNiLXNlYXJjaC1maWx0ZXIgew0KCQkJCWhlYWRlciB7DQoJCQkJCWJvcmRlci1ib3R0b20tY29sb3I6ICRncmV5LTkwMDsNCgkJCQl9DQoJCQkJZm9vdGVyIHsNCgkJCQkJYm9yZGVyLXRvcDogMXB4IHNvbGlkICRncmV5LTkwMDsNCgkJCQl9DQoJCQl9DQoJCX0NCgl9DQp9DQo="

/***/ },
/* 2553 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,QGltcG9ydCAnLi4vLi4vc3R5bGVzL3ZhcmlhYmxlcy5zY3NzJzsNCg0KLmdjbC1pY29uLWl0ZW0gew0KCWRpc3BsYXk6IGZsZXg7DQoJZmxleC1kaXJlY3Rpb246IHJvdzsNCgloZWlnaHQ6IDMuMDYzcmVtOw0KCWFsaWduLWl0ZW1zOiBjZW50ZXI7DQoJZm9udC1mYW1pbHk6ICRmb250Ow0KCWJhY2tncm91bmQtY29sb3I6IGluaGVyaXQ7DQoJcGFkZGluZzogew0KCQlsZWZ0OiAxcmVtOw0KCQlyaWdodDogMXJlbTsNCgl9DQoJY3Vyc29yOiBwb2ludGVyOw0KDQoJLmdjbC1pY29uLWl0ZW0tdGV4dCB7DQoJCXBhZGRpbmctbGVmdDogMXJlbTsNCgkJY29sb3I6ICRncmV5LTYwMDsNCgkJZm9udC1zaXplOiAxcmVtOw0KCX0NCg0KCSY6aG92ZXIsDQoJJjphY3RpdmUgew0KCQliYWNrZ3JvdW5kLWNvbG9yOiAkZ3JleS01MDsNCgkJLmdjbC1pY29uLWl0ZW0tdGV4dCB7DQoJCQljb2xvcjogJGdyZXktODAwOw0KCQl9DQoJCWkuZ2NsLWljb24gew0KCQkJYmFja2dyb3VuZC1jb2xvcjogJGdyZXktODAwOw0KCQl9DQoJfQ0KDQoJJjphY3RpdmUgew0KCQlib3JkZXI6IDFweCAkZ3JleS01MDAgc29saWQ7DQoJCWJveC1zaXppbmc6IGJvcmRlci1ib3g7DQoJCS1tb3otYm94LXNpemluZzogYm9yZGVyLWJveDsNCgkJLXdlYmtpdC1ib3gtc2l6aW5nOiBib3JkZXItYm94Ow0KCQliYWNrZ3JvdW5kLWNvbG9yOiAkZ3JleS0xMDA7DQoJfQ0KDQoJJi5kaXNhYmxlZCB7DQoJCXBvaW50ZXItZXZlbnRzOiBub25lOw0KCQktbW96LXVzZXItc2VsZWN0OiBub25lOw0KCQktd2Via2l0LXVzZXItc2VsZWN0OiBub25lOw0KCQktbXMtdXNlci1zZWxlY3Q6IG5vbmU7DQoJCXVzZXItc2VsZWN0OiBub25lOw0KDQoJCS5nY2wtaWNvbi1pdGVtLXRleHQgew0KCQkJY29sb3I6ICRncmV5LTMwMDsNCgkJfQ0KCQlpLmdjbC1pY29uIHsNCgkJCWJhY2tncm91bmQtY29sb3I6ICRncmV5LTMwMDsNCgkJfQ0KCX0NCg0KCSY6Zm9jdXMgew0KCQliYWNrZ3JvdW5kLWNvbG9yOiAkZ3JleS0yMDA7DQoJfQ0KCSYuYWN0aXZlIHsNCgkJYmFja2dyb3VuZC1jb2xvcjogJGJsdWUtNDAwOw0KCQkuZ2NsLWljb24taXRlbS10ZXh0IHsNCgkJCWNvbG9yOiAkd2hpdGU7DQoJCX0NCgkJaS5nY2wtaWNvbiB7DQoJCQliYWNrZ3JvdW5kLWNvbG9yOiAkd2hpdGU7DQoJCX0NCgl9DQp9DQo="

/***/ },
/* 2554 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,QGltcG9ydCAnLi4vLi4vc3R5bGVzL3ZhcmlhYmxlcy5zY3NzJzsNCg0KLnRoZW1lLWRhcmsgLmdjbC1pY29uLWl0ZW0gew0KICAgIGJhY2tncm91bmQtY29sb3I6ICRibGFjay0xMDA7DQogICAgYm9yZGVyOiAxcHggICRncmV5LTcwMCBzb2xpZDsNCgkuZ2NsLWljb24taXRlbS10ZXh0IHsNCgkJY29sb3I6ICRncmV5LTMwMDsNCiAgICB9DQogICAgaS5nY2wtaWNvbiB7DQogICAgICAgIGJhY2tncm91bmQtY29sb3I6ICRncmV5LTMwMDsNCiAgICB9DQoNCgkmOmhvdmVyLA0KCSY6YWN0aXZlIHsNCgkJYmFja2dyb3VuZC1jb2xvcjogJGdyZXktOTAwOw0KCQkuZ2NsLWljb24taXRlbS10ZXh0IHsNCgkJCWNvbG9yOiAkZ3JleS0yMDA7DQoJCX0NCgkJaS5nY2wtaWNvbiB7DQoJCQliYWNrZ3JvdW5kLWNvbG9yOiAkZ3JleS0yMDA7DQoJCX0NCgl9DQoNCgkmOmFjdGl2ZSB7DQoJCWJvcmRlcjogMXB4ICMxQTlERkMgc29saWQ7DQoJCWJhY2tncm91bmQtY29sb3I6ICRncmV5LTgwMDsNCgl9DQoNCgkmLmRpc2FibGVkIHsNCiAgICAgICAgYmFja2dyb3VuZC1jb2xvcjogJGdyZXktOTAwOw0KCQkuZ2NsLWljb24taXRlbS10ZXh0IHsNCgkJCWNvbG9yOiAkZ3JleS03MDA7DQoJCX0NCgkJaS5nY2wtaWNvbiB7DQoJCQliYWNrZ3JvdW5kLWNvbG9yOiAkZ3JleS03MDA7DQoJCX0NCgl9DQoNCgkmOmZvY3VzIHsNCgkJYmFja2dyb3VuZC1jb2xvcjogJGJsYWNrLTIwMDsNCiAgICAgICAgOw0KCX0NCgkmLmFjdGl2ZSB7DQoJCWJhY2tncm91bmQtY29sb3I6ICRnb2xkOw0KCQkuZ2NsLWljb24taXRlbS10ZXh0IHsNCgkJCWNvbG9yOiAkd2hpdGU7DQoJCX0NCgkJaS5nY2wtaWNvbiB7DQoJCQliYWNrZ3JvdW5kLWNvbG9yOiAkd2hpdGU7DQoJCX0NCgl9DQp9"

/***/ },
/* 2555 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,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"

/***/ },
/* 2556 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,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"

/***/ },
/* 2557 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,QGltcG9ydCAnLi4vLi4vLi4vc3R5bGVzL3ZhcmlhYmxlcy5zY3NzJzsNCg0KQG1peGluIHNldENvbG9yKCRjb2xvcikgew0KCWNvbG9yOiAkY29sb3I7DQoJaSB7DQoJCWJhY2tncm91bmQtY29sb3I6ICRjb2xvcjsNCgl9DQp9DQoNCi50aGVtZS1kYXJrIC5nY2wtZmlsdGVyLWlucHV0IHsNCglib3JkZXItY29sb3I6ICRncmV5LTgwMDsNCgliYWNrZ3JvdW5kLWNvbG9yOiAkYmxhY2stMjAwOw0KCUBpbmNsdWRlIHNldENvbG9yKCRncmV5LTYwMCk7DQoNCgkmOmhvdmVyIHsNCgkJQGluY2x1ZGUgc2V0Q29sb3IoJGdyZXktMzAwKTsNCgkJYm9yZGVyLWNvbG9yOiAkZ3JleS01MDA7DQoJCTo6cGxhY2Vob2xkZXIgew0KCQkJY29sb3I6ICRncmV5LTMwMDsNCgkJfQ0KCX0NCg0KCSYuZmlsbGVkIHsNCgkJQGluY2x1ZGUgc2V0Q29sb3IoJGdyZXktNDAwKTsNCgkJYmFja2dyb3VuZC1jb2xvcjogJGJsYWNrLTMwMDsNCgkJYm9yZGVyLWNvbG9yOiAkZ3JleS02MDA7DQoJfQ0KDQoJJi5maWxsZWQ6aG92ZXIgew0KCQlAaW5jbHVkZSBzZXRDb2xvcigkZ3JleS0zMDApOw0KCQlpLmNsb3NlLWNpcmNsZTpob3ZlciB7DQoJCQliYWNrZ3JvdW5kLWNvbG9yOiAkZ3JleS0zMDA7DQoJCX0NCgl9DQoJJi5kaXNhYmxlZCB7DQoJCUBpbmNsdWRlIHNldENvbG9yKCRncmV5LTcwMCk7DQoJCWJhY2tncm91bmQtY29sb3I6ICRncmV5LTkwMDsNCgkJYm9yZGVyLWNvbG9yOiAkZ3JleS04MDA7DQoJCTo6cGxhY2Vob2xkZXIgew0KCQkJY29sb3I6ICRncmV5LTcwMDsNCgkJfQ0KCX0NCg0KCSY6Zm9jdXMsDQoJJjpmb2N1cy13aXRoaW4sDQoJJi5maWxsZWQ6Zm9jdXMtd2l0aGluIHsNCgkJYm9yZGVyLWNvbG9yOiAkZ29sZDsNCgkJYm94LXNoYWRvdzogMCAwIDFyZW0gI2Y1ZWJkMjNkOw0KCQlAaW5jbHVkZSBzZXRDb2xvcigkZ29sZCk7DQoJCWNvbG9yOiAkZ3JleS0yMDA7DQoJCWkuY2xvc2UtY2lyY2xlOmhvdmVyIHsNCgkJCWJhY2tncm91bmQtY29sb3I6ICRnb2xkLTQwMDsNCgkJfQ0KCX0NCn0NCg=="

/***/ },
/* 2558 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,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"

/***/ },
/* 2559 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,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"

/***/ },
/* 2560 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,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"

/***/ },
/* 2561 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,QGltcG9ydCAiLi4vLi4vLi4vc3R5bGVzL3ZhcmlhYmxlcy5zY3NzIjsNCi5nY2wtbWVzc2FnZS1pbnB1dCB7DQoJZm9udC1zaXplOiAwLjg3NXJlbTsNCgl0ZXh0YXJlYSB7DQoJCS13ZWJraXQtYXBwZWFyYW5jZTogbm9uZTsNCgkJYm9yZGVyOiBub25lOw0KCQlvdXRsaW5lOiBub25lOw0KCQlyZXNpemU6IG5vbmU7DQoJCWRpc3BsYXk6IGJsb2NrOw0KCQlvdmVyZmxvdzogaGlkZGVuOw0KCQl3aWR0aDogMTAwJTsNCgkJYm9yZGVyOiAxcHggc29saWQgJGdyZXktNDAwOw0KCQlib3JkZXItcmFkaXVzOiAwLjI1cmVtOw0KDQoJCWZvbnQtd2VpZ2h0OiAkbWVkaXVtOw0KCQlsaW5lLWhlaWdodDogMS4yNXJlbTsNCgkJY29sb3I6ICRncmV5LTcwMDsNCgkJcGFkZGluZzogMC43NXJlbSA1LjYyNXJlbSAwLjc1cmVtIDFyZW07DQoNCgkJdHJhbnNpdGlvbjogYm9yZGVyLWNvbG9yIDAuM3MgZWFzZS1vdXQ7DQoJCW1heC1oZWlnaHQ6IDQuNnJlbTsNCgkJJjo6cGxhY2Vob2xkZXIgew0KCQkJY29sb3I6ICRncmV5LTMwMDsNCgkJfQ0KDQoJCSY6aG92ZXIgew0KCQkJYm9yZGVyLWNvbG9yOiAkZ3JleS01MDA7DQoJCX0NCg0KCQkmOmRpc2FibGVkIHsNCgkJCWJvcmRlci1jb2xvcjogJGdyZXktMTAwOw0KCQkJYmFja2dyb3VuZC1jb2xvcjogJGdyZXktMTAwOw0KCQl9DQoJfQ0KDQoJLmdjbC1taS1jb3VudGVyIHsNCgkJY29sb3I6ICRncmV5LTUwMDsNCgkJbGluZS1oZWlnaHQ6IDEuMjVyZW07DQoJCXBvc2l0aW9uOiBhYnNvbHV0ZTsNCgkJYm90dG9tOiAwLjc1cmVtOw0KCQlyaWdodDogMXJlbTsNCg0KCQlzcGFuLmdjbC1taS1hbGVydCB7DQoJCQljb2xvcjogJGNoYXQtcmVkOw0KCQl9DQoJfQ0KDQoJJi5kaXNhYmxlZCAuZ2NsLW1pLWNvdW50ZXIgew0KCQljb2xvcjogJGdyZXktMzAwOw0KCX0NCn0NCg=="

/***/ },
/* 2562 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,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"

/***/ },
/* 2563 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,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"

/***/ },
/* 2564 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,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"

/***/ },
/* 2565 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,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"

/***/ },
/* 2566 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,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"

/***/ },
/* 2567 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,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"

/***/ },
/* 2568 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,QGltcG9ydCAnLi4vLi4vc3R5bGVzL3ZhcmlhYmxlcy5zY3NzJzsNCg0KQG1peGluIHNldFdpZHRoKCR3aWR0aCkgew0KCXdpZHRoOiAkd2lkdGg7DQoJJiA+IGkgew0KCQltYXJnaW4tbGVmdDogMCAtICR3aWR0aDsNCgl9DQp9DQoNCi5nY2wtcmF0aW5nIHsNCgkmID4gLmdjbC1yYXRpbmctY29udGFpbmVyIHsNCgkJZGlzcGxheTogaW5saW5lLWZsZXg7DQoJCSYgPiBidXR0b24gew0KCQkJYWxsOiB1bnNldDsNCgkJCWN1cnNvcjogcG9pbnRlcjsNCgkJCSYuZW5kIHsNCgkJCQlvdmVyZmxvdzogaGlkZGVuOw0KCQkJCUBpbmNsdWRlIHNldFdpZHRoKDAuNzVyZW0pOw0KCQkJCSYuc21hbGwgew0KCQkJCQlAaW5jbHVkZSBzZXRXaWR0aCgwLjVyZW0pOw0KCQkJCX0NCgkJCQkmLmxhcmdlIHsNCgkJCQkJQGluY2x1ZGUgc2V0V2lkdGgoMXJlbSk7DQoJCQkJfQ0KCQkJfQ0KCQkJJi5zdGFydCB7DQoJCQkJd2lkdGg6IDAuNzVyZW07DQoJCQkJb3ZlcmZsb3c6IGhpZGRlbjsNCgkJCQkmLnNtYWxsIHsNCgkJCQkJd2lkdGg6IDAuNXJlbTsNCgkJCQl9DQoJCQkJJi5sYXJnZSB7DQoJCQkJCXdpZHRoOiAxcmVtOw0KCQkJCX0NCgkJCX0NCg0KCQkJJi5sYXJnZSA+IGkgew0KCQkJCXdpZHRoOiAycmVtOw0KCQkJfQ0KCQkJJi5zbWFsbCA+IGkgew0KCQkJCXdpZHRoOiAxcmVtOw0KCQkJfQ0KCQl9DQoJfQ0KDQoJLm9uIHsNCgkJJiA+IGkgew0KCQkJYmFja2dyb3VuZC1jb2xvcjogJGJsdWU7DQoJCX0NCgl9DQp9DQo="

/***/ },
/* 2569 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,QGltcG9ydCAnLi4vLi4vc3R5bGVzL3ZhcmlhYmxlcy5zY3NzJzsNCg0KLnRoZW1lLWRhcmsgLmdjbC1yYXRpbmcgew0KCS5vbiA+IGkgew0KCQliYWNrZ3JvdW5kLWNvbG9yOiAkZ29sZDsNCgl9DQp9DQo="

/***/ },
/* 2570 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,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"

/***/ },
/* 2571 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,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"

/***/ },
/* 2572 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,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"

/***/ },
/* 2573 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,QGltcG9ydCAnLi4vLi4vc3R5bGVzL3ZhcmlhYmxlcy5zY3NzJzsNCg0KLnRoZW1lLWRhcmsgLmdjbC1zZWxlY3RMaXN0LWl0ZW0gew0KCXNwYW4gew0KCQljb2xvcjogJGdyZXktMzAwOw0KCX0NCgkmLnNlbGVjdGVkIHsNCgkJYmFja2dyb3VuZC1jb2xvcjogJGdyZXktODAwOw0KCX0NCg0KCSYuY2hlY2tlZCB7DQoJCWJhY2tncm91bmQtY29sb3I6ICRncmV5LTkwMDsNCgkJJiA+IC5nY2wtc2VsZWN0TGlzdC1pdGVtLWJ0bnMgew0KCQkJJiAuZ2NsLWJ0bkljb24uc3F1YXJlID4gaSB7DQoJCQkJYmFja2dyb3VuZC1jb2xvcjogJGdvbGQtNDAwOw0KCQkJfQ0KCQl9DQoNCgkJJiA+IC5nY2wtc2VsZWN0TGlzdC1pdGVtLXRpdGxlID4gc3BhbiB7DQoJCQljb2xvcjogJGdvbGQtNDAwOw0KCQl9DQoJfQ0KDQoJJiA+IC5nY2wtc2VsZWN0TGlzdC1pdGVtLWJ0bnMgew0KCQkmIC5nY2wtYnRuSWNvbi5jaXJjbGUgew0KCQkJYmFja2dyb3VuZC1jb2xvcjogJGJsYWNrLTEwMDsNCgkJCSY6aG92ZXIgew0KCQkJCWJvcmRlci1jb2xvcjogJGdvbGQtMjAwOw0KCQkJfQ0KCQl9DQoJCSYuc2VsZWN0ZWQgLmdjbC1idG5JY29uLmNpcmNsZSB7DQoJCQliYWNrZ3JvdW5kLWNvbG9yOiAkZ29sZC00MDA7DQoJCQlib3JkZXItY29sb3I6ICRnb2xkLTQwMDsNCgkJCSY6aG92ZXIgew0KCQkJCWJvcmRlci1jb2xvcjogJGdvbGQ7DQoJCQkJYmFja2dyb3VuZC1jb2xvcjogJGdvbGQtMzAwOw0KCQkJfQ0KCQl9DQoJfQ0KfQ0K"

/***/ },
/* 2574 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,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"

/***/ },
/* 2575 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,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"

/***/ },
/* 2576 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,LnRoZW1lLWRhcmsgew0KCS5zbGMtY3VzdG9tLWRvdCB7DQoJCWJvcmRlcjogc29saWQgMC41cmVtICMyOTYyZmY7DQoJCWJvcmRlci1yYWRpdXM6IDUwJTsNCgkJd2lkdGg6IDJyZW07DQoJCWhlaWdodDogMnJlbTsNCgkJbWF4LXdpZHRoOiAycmVtOw0KCQltaW4td2lkdGg6IDJyZW07DQoJCS5zbGMtZG90LWNlbnRlciB7DQoJCQlib3JkZXItcmFkaXVzOiA1MCU7DQoJCQl3aWR0aDogMXJlbTsNCgkJCWhlaWdodDogMXJlbTsNCgkJCW1heC13aWR0aDogMXJlbTsNCgkJCW1pbi13aWR0aDogMXJlbTsNCgkJCWJhY2tncm91bmQtY29sb3I6ICNjYmQ5ZmY7DQoJCX0NCgl9DQp9DQo="

/***/ },
/* 2577 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,LmdjbC1zaW1wbGUtcGllLWNoYXJ0IHsNCgkvLyBib3JkZXI6IHNvbGlkIDFweCByZWQ7DQoJZGlzcGxheTogZmxleDsNCglmbGV4LWRpcmVjdGlvbjogY29sdW1uOw0KCWFsaWduLWl0ZW1zOiBjZW50ZXI7DQoJanVzdGlmeS1jb250ZW50OiBjZW50ZXI7DQoJbWFyZ2luOiAwOw0KCXBhZGRpbmc6IDA7DQoJdGV4dC1hbGlnbjogY2VudGVyOw0KCXBvc2l0aW9uOiByZWxhdGl2ZTsNCgkudGl0bGUgew0KCQlwb3NpdGlvbjogYWJzb2x1dGU7DQoJCW92ZXJmbG93OiBoaWRkZW47DQoJCW1heC13aWR0aDogNC4yNXJlbTsNCgkJZm9udC1zaXplOiAwLjc1cmVtOw0KCQljb2xvcjogIzY2NzE3ODsNCgkJZGlzcGxheTogZmxleDsNCgkJZmxleC1kaXJlY3Rpb246IGNvbHVtbjsNCgkJYWxpZ24taXRlbXM6IGNlbnRlcjsNCgkJanVzdGlmeS1jb250ZW50OiBjZW50ZXI7DQoNCgkJc3BhbiB7DQoJCQl3aWR0aDogMTAwJTsNCgkJCXdoaXRlLXNwYWNlOiBub3dyYXA7DQoJCQl0ZXh0LW92ZXJmbG93OiBlbGxpcHNpczsNCgkJCW92ZXJmbG93OiBoaWRkZW47DQoJCX0NCgl9DQp9DQo="

/***/ },
/* 2578 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,LnRoZW1lLWRhcmsgew0KCS5nY2wtc2ltcGxlLXBpZS1jaGFydCB7DQoJCS8vIGJvcmRlcjogc29saWQgMXB4IHJlZDsNCgkJZGlzcGxheTogZmxleDsNCgkJZmxleC1kaXJlY3Rpb246IGNvbHVtbjsNCgkJYWxpZ24taXRlbXM6IGNlbnRlcjsNCgkJanVzdGlmeS1jb250ZW50OiBjZW50ZXI7DQoJCW1hcmdpbjogMDsNCgkJcGFkZGluZzogMDsNCgkJdGV4dC1hbGlnbjogY2VudGVyOw0KCQkudGl0bGUgew0KCQkJcG9zaXRpb246IGFic29sdXRlOw0KCQkJZm9udC1zaXplOiAwLjc1cmVtOw0KCQkJY29sb3I6ICNjY2NmZDI7DQoJCQlkaXNwbGF5OiBmbGV4Ow0KCQkJZmxleC1kaXJlY3Rpb246IGNvbHVtbjsNCgkJCWFsaWduLWl0ZW1zOiBjZW50ZXI7DQoJCQlqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjsNCgkJfQ0KCX0NCn0NCg=="

/***/ },
/* 2579 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,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"

/***/ },
/* 2580 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,QGltcG9ydCAnLi4vLi4vc3R5bGVzL3ZhcmlhYmxlcy5zY3NzJzsNCg0KLnN3aXRjaC1jb250YWluZXIgew0KCWRpc3BsYXk6IGlubGluZS1ibG9jazsNCgkuc3dpdGNoIHsNCgkJcG9zaXRpb246IHJlbGF0aXZlOw0KCQl3aWR0aDogMi41cmVtOw0KCQloZWlnaHQ6IDEuNXJlbTsNCgkJbWFyZ2luLWJvdHRvbTogMDsNCg0KCQkuc2xpZGVyIHsNCgkJCXBvc2l0aW9uOiBhYnNvbHV0ZTsNCgkJCWN1cnNvcjogcG9pbnRlcjsNCgkJCXRvcDogMDsNCgkJCWxlZnQ6IDA7DQoJCQlyaWdodDogMDsNCgkJCWJvdHRvbTogMDsNCgkJCWJhY2tncm91bmQtY29sb3I6ICRncmV5LTQwMDsNCgkJCXRyYW5zaXRpb246IGFsbCAwLjNzIGVhc2Utb3V0Ow0KCQkJJi5yb3VuZCB7DQoJCQkJYm9yZGVyLXJhZGl1czogMnJlbTsNCgkJCQkmOjpiZWZvcmUgew0KCQkJCQlib3JkZXItcmFkaXVzOiA1MCU7DQoJCQkJfQ0KCQkJfQ0KDQoJCQkmOmhvdmVyIHsNCgkJCQliYWNrZ3JvdW5kLWNvbG9yOiAkZ3JleS01MDA7DQoJCQl9DQoNCgkJCSY6YWN0aXZlIHsNCgkJCQliYWNrZ3JvdW5kLWNvbG9yOiAkZ3JleS02MDA7DQoJCQl9DQoNCgkJCSY6OmJlZm9yZSB7DQoJCQkJcG9zaXRpb246IGFic29sdXRlOw0KCQkJCWNvbnRlbnQ6ICcnOw0KCQkJCWhlaWdodDogMS4yNXJlbTsNCgkJCQl3aWR0aDogMS4yNXJlbTsNCgkJCQlsZWZ0OiAycHg7DQoJCQkJYm90dG9tOiAycHg7DQoJCQkJYmFja2dyb3VuZC1jb2xvcjogd2hpdGU7DQoJCQkJdHJhbnNpdGlvbjogYWxsIDAuM3MgZWFzZS1vdXQ7DQoJCQl9DQoJCX0NCg0KCQlpbnB1dCB7DQoJCQlvcGFjaXR5OiAwOw0KCQkJd2lkdGg6IDA7DQoJCQloZWlnaHQ6IDA7DQoNCgkJCSY6Y2hlY2tlZCArIC5zbGlkZXIgew0KCQkJCWJhY2tncm91bmQtY29sb3I6ICRibHVlLTQwMDsNCg0KCQkJCSY6OmJlZm9yZSB7DQoJCQkJCS13ZWJraXQtdHJhbnNmb3JtOiB0cmFuc2xhdGVYKDFyZW0pOw0KCQkJCQktbXMtdHJhbnNmb3JtOiB0cmFuc2xhdGVYKDFyZW0pOw0KCQkJCQl0cmFuc2Zvcm06IHRyYW5zbGF0ZVgoMXJlbSk7DQoJCQkJfQ0KDQoJCQkJJjpob3ZlciB7DQoJCQkJCWJhY2tncm91bmQtY29sb3I6ICRibHVlOw0KCQkJCX0NCg0KCQkJCSY6YWN0aXZlIHsNCgkJCQkJYmFja2dyb3VuZC1jb2xvcjogJGJsdWUtNjAwOw0KCQkJCX0NCgkJCX0NCg0KCQkJJjpmb2N1cyArIC5zbGlkZXIgew0KCQkJCWJveC1zaGFkb3c6IDAgMCAwIDFweCAkY3lhbi00MDA7DQoJCQl9DQoNCgkJCSY6ZGlzYWJsZWQgKyAuc2xpZGVyIHsNCgkJCQliYWNrZ3JvdW5kLWNvbG9yOiAkZ3JleS0yMDA7DQoJCQkJcG9pbnRlci1ldmVudHM6IG5vbmU7DQoJCQl9DQoJCX0NCgl9DQp9DQoNCi50aGVtZS1kYXJrIC5zd2l0Y2gtY29udGFpbmVyIC5zd2l0Y2ggew0KCS5zbGlkZXIgew0KCQliYWNrZ3JvdW5kLWNvbG9yOiAkYmxhY2stMTAwOw0KCQkmOjpiZWZvcmUgew0KCQkJYmFja2dyb3VuZC1jb2xvcjogJGdyZXktNTAwOw0KCQl9DQoJCSY6aG92ZXIgew0KCQkJYmFja2dyb3VuZC1jb2xvcjogJGJsYWNrLTIwMDsNCgkJCSY6OmJlZm9yZSB7DQoJCQkJYmFja2dyb3VuZC1jb2xvcjogJGdyZXktNDAwOw0KCQkJfQ0KCQl9DQoJCSY6YWN0aXZlIHsNCgkJCWJhY2tncm91bmQtY29sb3I6ICRibGFjay0xMDA7DQoJCQkmOjpiZWZvcmUgew0KCQkJCWJhY2tncm91bmQtY29sb3I6ICRncmV5LTUwMDsNCgkJCX0NCgkJfQ0KCX0NCglpbnB1dCB7DQoJCSY6Y2hlY2tlZCArIC5zbGlkZXIgew0KCQkJYmFja2dyb3VuZC1jb2xvcjogJGdyZXktNzAwOw0KCQkJJjo6YmVmb3JlIHsNCgkJCQliYWNrZ3JvdW5kLWNvbG9yOiAkZ29sZC00MDA7DQoJCQl9DQoJCQkmOmhvdmVyIHsNCgkJCQliYWNrZ3JvdW5kLWNvbG9yOiAkZ3JleS02MDA7DQoJCQkJJjo6YmVmb3JlIHsNCgkJCQkJYmFja2dyb3VuZC1jb2xvcjogJGdvbGQtMzAwOw0KCQkJCX0NCgkJCX0NCgkJCSY6YWN0aXZlIHsNCgkJCQliYWNrZ3JvdW5kLWNvbG9yOiAkZ3JleS03MDA7DQoJCQkJJjo6YmVmb3JlIHsNCgkJCQkJYmFja2dyb3VuZC1jb2xvcjogJGdvbGQtNDAwOw0KCQkJCX0NCgkJCX0NCgkJfQ0KDQoJCSY6ZGlzYWJsZWQgKyAuc2xpZGVyIHsNCgkJCWJhY2tncm91bmQtY29sb3I6ICRncmV5LTgwMDsNCgkJCSY6OmJlZm9yZSB7DQoJCQkJYmFja2dyb3VuZC1jb2xvcjogJGdyZXktNjAwOw0KCQkJfQ0KCQl9DQoJfQ0KfQ0K"

/***/ },
/* 2581 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,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"

/***/ },
/* 2582 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,QGltcG9ydCAnLi4vLi4vLi4vc3R5bGVzL3ZhcmlhYmxlcy5zY3NzJzsNCg0KLnRoZW1lLWRhcmsgLmdjbC10YWItcHJpbWFyeSB7DQoJY29sb3I6ICRncmV5LTMwMDsNCg0KCS5nY2wtaWNvbiB7DQoJCWJhY2tncm91bmQtY29sb3I6ICRncmV5LTMwMDsNCgl9DQoNCgkmOmhvdmVyIHsNCgkJY29sb3I6ICRncmV5LTIwMDsNCgkJYmFja2dyb3VuZC1jb2xvcjogJGdvbGQtMTY7DQoJCS5nY2wtaWNvbiB7DQoJCQliYWNrZ3JvdW5kLWNvbG9yOiAkZ3JleS0yMDA7DQoJCX0NCgl9DQoNCgkmOmZvY3VzIHsNCgkJY29sb3I6ICRncmV5LTIwMDsNCgkJYmFja2dyb3VuZC1jb2xvcjogJGdvbGQtMjQ7DQoJCS5nY2wtaWNvbiB7DQoJCQliYWNrZ3JvdW5kLWNvbG9yOiAkZ3JleS0yMDA7DQoJCX0NCgkJLmdjbC10YWItcHJpbWFyeS10ZXh0IHsNCgkJCWJveC1zaGFkb3c6IG5vbmU7DQoJCX0NCgl9DQoNCgkmOmFjdGl2ZSB7DQoJCWNvbG9yOiAkZ3JleS0yMDA7DQoJCWJhY2tncm91bmQtY29sb3I6ICRnb2xkLTMyOw0KCQkuZ2NsLWljb24gew0KCQkJYmFja2dyb3VuZC1jb2xvcjogJGdyZXktMjAwOw0KCQl9DQoJfQ0KDQoJJi5kaXNhYmxlZCB7DQoJCWNvbG9yOiAkZ3JleS03MDA7DQoJCWJhY2tncm91bmQtY29sb3I6ICRncmV5LTkwMDsNCgkJLmdjbC1pY29uIHsNCgkJCWJhY2tncm91bmQtY29sb3I6ICRncmV5LTcwMDsNCgkJfQ0KCQkvL2F1biBubyBlcyBlbCBjb2xvciBmaW5hbCBwZXJvIGVuIGxvcyBzcGVjcyBubyB2ZW5pYSBkaXNhYmxlZCBzb2xvIHBvciBzaSBzZSBuZWNlc2l0YQ0KCX0NCg0KCSYuYWN0aXZlIHsNCgkJY29sb3I6ICRnb2xkOw0KCQkuZ2NsLWljb24sDQoJCS5nY2wtdGFiLXByaW1hcnktZm9vdGVyIHsNCgkJCWJhY2tncm91bmQtY29sb3I6ICRnb2xkOw0KCQl9DQoNCgkJJjphY3RpdmUgew0KCQkJY29sb3I6ICRnb2xkLTQwMDsNCgkJCS5nY2wtaWNvbiwNCgkJCS5nY2wtdGFiLXByaW1hcnktZm9vdGVyIHsNCgkJCQliYWNrZ3JvdW5kLWNvbG9yOiAkZ29sZC00MDA7DQoJCQl9DQoJCX0NCgl9DQp9DQo="

/***/ },
/* 2583 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,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"

/***/ },
/* 2584 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,QGltcG9ydCAnLi4vLi4vLi4vc3R5bGVzL3ZhcmlhYmxlcy5zY3NzJzsNCg0KLmdjbC1zaWRlYmFyLXRhYiB7DQoJaGVpZ2h0OiAzcmVtOw0KCXdpZHRoOiAzcmVtOw0KCWxpbmUtaGVpZ2h0OiAzcmVtOw0KCWJvcmRlci1yYWRpdXM6IDAuMjVyZW07DQoJY3Vyc29yOiBwb2ludGVyOw0KCWRpc3BsYXk6IGZsZXg7DQoJYWxpZ24taXRlbXM6IGNlbnRlcjsNCglqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjsNCgljb2xvcjogJGdyZXktNjAwOw0KCXBvc2l0aW9uOiByZWxhdGl2ZTsNCglib3JkZXI6IDJweCBzb2xpZCB0cmFuc3BhcmVudDsNCgl0cmFuc2l0aW9uOiBiYWNrZ3JvdW5kLWNvbG9yIDAuM3MgZWFzZS1vdXQsIGJvcmRlci1jb2xvciAwLjNzOw0KDQoJJjpmb2N1cyB7DQoJCW91dGxpbmU6IDA7DQoJfQ0KDQoJJi5kaXNhYmxlZCB7DQoJCXBvaW50ZXItZXZlbnRzOiBub25lOw0KCQliYWNrZ3JvdW5kLWNvbG9yOiAkZ3JleS0xMDA7DQoJCS5nY2wtaWNvbiB7DQoJCQliYWNrZ3JvdW5kLWNvbG9yOiAkZ3JleS0zMDA7DQoJCX0NCgl9DQoNCgkmOmhvdmVyIHsNCgkJYmFja2dyb3VuZC1jb2xvcjogJGJsdWUtNzU7DQoJCS5nY2wtaWNvbiB7DQoJCQliYWNrZ3JvdW5kLWNvbG9yOiAkZ3JleS03MDA7DQoJCX0NCgl9DQoNCgkmOmFjdGl2ZSB7DQoJCWJhY2tncm91bmQtY29sb3I6ICRibHVlLTIwMDsNCgkJLmdjbC1pY29uIHsNCgkJCWJhY2tncm91bmQtY29sb3I6ICRncmV5LTkwMDsNCgkJfQ0KCX0NCg0KCSYuYWN0aXZlIHsNCgkJYmFja2dyb3VuZC1jb2xvcjogJGJsdWUtNzU7DQoJCWJvcmRlci1jb2xvcjogJGJsdWU7DQoJCS5nY2wtaWNvbiB7DQoJCQliYWNrZ3JvdW5kLWNvbG9yOiAkYmx1ZTsNCgkJfQ0KDQoJCSY6aG92ZXIgew0KCQkJYmFja2dyb3VuZC1jb2xvcjogJGJsdWUtMTAwOw0KCQkJYm9yZGVyLWNvbG9yOiAkYmx1ZS02MDA7DQoJCQkuZ2NsLWljb24gew0KCQkJCWJhY2tncm91bmQtY29sb3I6ICRibHVlLTYwMDsNCgkJCX0NCgkJfQ0KDQoJCSY6YWN0aXZlIHsNCgkJCWJhY2tncm91bmQtY29sb3I6ICRibHVlLTIwMDsNCgkJCWJvcmRlci1jb2xvcjogJGJsdWUtNzAwOw0KCQkJLmdjbC1pY29uIHsNCgkJCQliYWNrZ3JvdW5kLWNvbG9yOiAkYmx1ZS03MDA7DQoJCQl9DQoJCX0NCgl9DQoNCgkuZ2NsLXN0LWRvdCwNCgkuZ2NsLXNpZGViYXItdGFiLWNvdW50ZXIgew0KCQlwb3NpdGlvbjogYWJzb2x1dGU7DQoJCWJhY2tncm91bmQtY29sb3I6ICRyZWQ7DQoJCXotaW5kZXg6IDM7DQoJCWJvcmRlci1yYWRpdXM6IDUwJTsNCgl9DQoNCgkuZ2NsLXN0LWRvdCB7DQoJCWhlaWdodDogMC41cmVtOw0KCQl3aWR0aDogMC41cmVtOw0KCQl0b3A6IDAuMzc1cmVtOw0KCQlyaWdodDogMC4zNzVyZW07DQoJfQ0KDQoJLmdjbC1zaWRlYmFyLXRhYi1jb3VudGVyIHsNCgkJY29sb3I6IHdoaXRlOw0KCQlmb250LXNpemU6IDAuNzVyZW07DQoJCWZvbnQtd2VpZ2h0OiAkc2VtaWJvbGQ7DQoJCWhlaWdodDogMjFweDsNCgkJd2lkdGg6IDIxcHg7DQoNCgkJdG9wOiAwLjEyNXJlbTsNCgkJcmlnaHQ6IDAuMTI1cmVtOw0KDQoJCWRpc3BsYXk6IGZsZXg7DQoJCWFsaWduLWl0ZW1zOiBjZW50ZXI7DQoJCWp1c3RpZnktY29udGVudDogY2VudGVyOw0KCX0NCn0NCg=="

/***/ },
/* 2585 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,QGltcG9ydCAnLi4vLi4vLi4vc3R5bGVzL3ZhcmlhYmxlcy5zY3NzJzsNCg0KLnRoZW1lLWRhcmsgLmdjbC1zaWRlYmFyLXRhYiB7DQoJY29sb3I6ICRncmV5LTUwMDsNCg0KCSYuZGlzYWJsZWQgew0KCQliYWNrZ3JvdW5kLWNvbG9yOiAkZ3JleS05MDA7DQoJCS5nY2wtaWNvbiB7DQoJCQliYWNrZ3JvdW5kLWNvbG9yOiAkZ3JleS03MDA7DQoJCX0NCgl9DQoNCgkmOmhvdmVyIHsNCgkJYmFja2dyb3VuZC1jb2xvcjogJGJsYWNrLTIwMDsNCgkJLmdjbC1pY29uIHsNCgkJCWJhY2tncm91bmQtY29sb3I6ICRncmV5LTQwMDsNCgkJfQ0KCX0NCg0KCSY6YWN0aXZlIHsNCgkJYmFja2dyb3VuZC1jb2xvcjogJGJsYWNrLTMwMDsNCgkJLmdjbC1pY29uIHsNCgkJCWJhY2tncm91bmQtY29sb3I6ICRncmV5LTMwMDsNCgkJfQ0KCX0NCg0KCSYuYWN0aXZlIHsNCgkJYmFja2dyb3VuZC1jb2xvcjogJGJsYWNrLTMwMDsNCgkJYm9yZGVyLWNvbG9yOiAkZ29sZDsNCgkJLmdjbC1pY29uIHsNCgkJCWJhY2tncm91bmQtY29sb3I6ICRnb2xkOw0KCQl9DQoJCSY6aG92ZXIgew0KCQkJYmFja2dyb3VuZC1jb2xvcjogJGJsYWNrLTMwMDsNCgkJCWJvcmRlci1jb2xvcjogJGdvbGQtNDAwOw0KCQkJLmdjbC1pY29uIHsNCgkJCQliYWNrZ3JvdW5kLWNvbG9yOiAkZ29sZC00MDA7DQoJCQl9DQoJCX0NCgkJJjphY3RpdmUgew0KCQkJYmFja2dyb3VuZC1jb2xvcjogJGJsYWNrLTQwMDsNCgkJCWJvcmRlci1jb2xvcjogJGdvbGQtNjAwOw0KCQkJLmdjbC1pY29uIHsNCgkJCQliYWNrZ3JvdW5kLWNvbG9yOiAkZ29sZC02MDA7DQoJCQl9DQoJCX0NCgl9DQp9DQo="

/***/ },
/* 2586 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,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"

/***/ },
/* 2587 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,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"

/***/ },
/* 2588 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,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"

/***/ },
/* 2589 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,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"

/***/ },
/* 2590 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,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"

/***/ },
/* 2591 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,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"

/***/ },
/* 2592 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,LmdjbC10b2FzdC1jb250YWluZXIgew0KCXBvc2l0aW9uOiBmaXhlZDsNCgl6LWluZGV4OiAxMDYwOw0KCW1heC1oZWlnaHQ6IDEwMCU7DQoJb3ZlcmZsb3c6IGhpZGRlbjsNCglwYWRkaW5nOiAxcmVtOw0KCWRpc3BsYXk6IGZsZXg7DQoJZmxleC1kaXJlY3Rpb246IGNvbHVtbjsNCg0KCSYudG9wTGVmdCB7DQoJCXRvcDogMHB4Ow0KCQlsZWZ0OiAwcHg7DQoJfQ0KCSYudG9wUmlnaHQgew0KCQl0b3A6IDBweDsNCgkJcmlnaHQ6IDBweDsNCgkJYWxpZ24taXRlbXM6IGZsZXgtZW5kOw0KCX0NCgkmLmJvdHRvbUxlZnQgew0KCQlib3R0b206IDBweDsNCgkJbGVmdDogMHB4Ow0KCX0NCgkmLmJvdHRvbVJpZ2h0IHsNCgkJYm90dG9tOiAwcHg7DQoJCXJpZ2h0OiAwcHg7DQoJCWFsaWduLWl0ZW1zOiBmbGV4LWVuZDsNCgl9DQp9DQo="

/***/ },
/* 2593 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,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"

/***/ },
/* 2594 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,QGltcG9ydCAnLi4vLi4vc3R5bGVzL3ZhcmlhYmxlcy5zY3NzJzsNCg0KLmdjbC11bmF2YWlsYWJsZS1pY29uIHsNCglkaXNwbGF5OiBpbmxpbmUtZmxleDsNCgl3aWR0aDogM3JlbTsNCgloZWlnaHQ6IDNyZW07DQoJYm9yZGVyLXJhZGl1czogMC41cmVtOw0KCWFsaWduLWl0ZW1zOiBjZW50ZXI7DQoJanVzdGlmeS1jb250ZW50OiBjZW50ZXI7DQoJYmFja2dyb3VuZC1jb2xvcjogdmFyKC0tc3RhdHVzLWNvbG9yKTsNCg0KCS5nY2wtaWNvbiB7DQoJCWJhY2tncm91bmQtY29sb3I6IHdoaXRlOw0KCQl3aWR0aDogMi41cmVtOw0KCQloZWlnaHQ6IDIuNXJlbTsNCgl9DQoNCgkudGhlbWUtZGFyayAmIHsNCgkJLmdjbC1pY29uIHsNCgkJCWJhY2tncm91bmQtY29sb3I6ICRibGFjay0xMDA7DQoJCX0NCgl9DQoNCgkmLnNlbGVjdGFibGUgew0KCQljdXJzb3I6IHBvaW50ZXI7DQoJCXRyYW5zaXRpb246IGJveC1zaGFkb3cgMC4zcyBlYXNlLW91dCwgb3BhY2l0eSAwLjNzIGVhc2Utb3V0Ow0KCX0NCgkmLnNlbGVjdGVkIHsNCgkJYm9yZGVyOiAycHggc29saWQgJGJsdWUtNDAwOw0KCQlib3gtc2hhZG93OiAwIDAuMjVyZW0gMC41cmVtIDAgJGJsdWUtNDAwLTQ4Ow0KDQoJCS50aGVtZS1kYXJrICYgew0KCQkJYm9yZGVyLWNvbG9yOiAkZ29sZDsNCgkJCWJveC1zaGFkb3c6IDAgMC4yNXJlbSAwLjVyZW0gMCAkZ29sZC00MDsNCgkJfQ0KCX0NCg0KCSYubWQgew0KCQl3aWR0aDogMi41cmVtOw0KCQloZWlnaHQ6IDIuNXJlbTsNCg0KCQkuZ2NsLWljb24gew0KCQkJd2lkdGg6IDJyZW07DQoJCQloZWlnaHQ6IDJyZW07DQoJCX0NCgl9DQoNCgkmLnNtIHsNCgkJd2lkdGg6IDEuNzVyZW07DQoJCWhlaWdodDogMS43NXJlbTsNCgkJYm9yZGVyLXJhZGl1czogMC4yNXJlbTsNCg0KCQkuZ2NsLWljb24gew0KCQkJd2lkdGg6IDEuNXJlbTsNCgkJCWhlaWdodDogMS41cmVtOw0KCQl9DQoJfQ0KfQ0K"

/***/ },
/* 2595 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,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"

/***/ },
/* 2596 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,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"

/***/ },
/* 2597 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,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"

/***/ },
/* 2598 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,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"

/***/ },
/* 2599 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/logoKolobAgent.99ca184d.png";

/***/ },
/* 2600 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/imgLogin.304d6e56.png";

/***/ },
/* 2601 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ValidandoTelefonia.a501f756.gif";

/***/ },
/* 2602 */
/***/ function(module, exports) {

	module.exports = "data:image/gif;base64,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"

/***/ },
/* 2603 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/DTMF_Click.aa6e9b1c.mp3";

/***/ },
/* 2604 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/Fax-machine-sound.928a5764.mp3";

/***/ },
/* 2605 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/TelValidationSound.21d988dc.mp3";

/***/ },
/* 2606 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/XFerToneB.e7450c1a.mp3";

/***/ },
/* 2607 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/beepChat2.dab7a9a5.mp3";

/***/ },
/* 2608 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/busy-sound.ec3de3a6.mp3";

/***/ },
/* 2609 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/dry-pop-up-notification.8bbfcaa4.wav";

/***/ },
/* 2610 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/other-congestion-not_service.2e4d3fe1.mp3";

/***/ },
/* 2611 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 2612 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 2613 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGgAAABuCAYAAADLRVa8AAAACXBIWXMAABYlAAAWJQFJUiTwAAAbRUlEQVR4nO1da5Ac1XX+zr3d89zdWa2kFSDQyhKkIAEkAY4fgJFJYmwltvUjDhXbZUTFcRzbqUDschw7joUdV9mYiqHicsrENktVYio2CYQQubCJLUBO/CBYIghRNg9hLIGEJHa0r5np6Xvy4z76dk/PaiWk3Z3Fp6r33u6Z2e6+33znfPfcvneImXG8tuObH/hMszH11nartaIdtQaa0xPlOI5JEIEEQRCBiBAEAZf7+ieJCKVK3z4ZBEfDQuVHMhAvXHjV5z973Cd+BRrNBqAf3/PR86Ym6jeOjx2+vH7kUI0MAEKYkgCQAcYDiAgQgiBIgKSAFAIkBITZCsVyXKr2v1QoVZ4MS5V/D8LCN89+/cefPvW33Ts2I0A77rzupsMvPPe+I4de7NeND6/xOwGSghKgHEASQmqQhEzAEVKAKKnr44RCeaBRqvY/FRbK9wXF0pdWX/KRZ+auORae5QK041//4ubnn33y/UfHjhTJb/AZANKNjRRAUgiQTBgkhNSMEkldvycBjnwAhUCh1NcoVQfvDwvlL5x10fUPzn0Tza+lAPrRf3z8HfueeWL00IEXKmkAjh8g4bkyksIwiAwwmi3CgWZBIQOQBs+CJQ1Y/cvOiquDZ+wGxAeXjPzBjvlrtrkzB9CD37r+rp89+vDmOG7nAOADJEAEEBHCMORq/0AjCIJmsVLeSwCzUn1Rq3GGUipsNaYLCRgyBZrPEmncnQbCY5k07lFYd0iQhSJqK9aiUK6NswpuAIVfq63cNDbP7XjKjJgZ9976noO/ePpny4kShlhwfICEIAwNrxivLVm2o1gqf/nVb7vp3mOd4JH//PAnW42pdzUmj54dtyNJQosFkQLDuLtApkSEEBIkCFIKwIAmpQSRQFAooG/ZaoTloYhVeCcrdWNt5aadc9Foc2n0ndvf//jk+NiZpUr1JQIzEXGlb+ARKeV+ZmYiMAAmgiqWy1/bcNVndp/oyR67/+PXTk8e/fT0+NiZZJklpCcSpHFzElJmYpLHQqLEHYalCvqXnwNWAZSSDwC4ubZy090nr4nm12Yls0+27dn+N2ubjcl7p+pHztWNngBFhiWp+OXFIUGmNEAKIoCA0sAKVIdWozUdgRWeBbC1tnLT6Jzf3Em2eQHI2s92fPrKqaNH7o6a0/0d4MjExQnDKMsm8uKXBohAAEiGGFhxLkAFRI02gN4Hal4BsvbEA5/89vTE2FUEUJZRQto4JB0wDiQSIGEB0kwCCJUlZ6JYXYHmZBPm/nYBuK62ctP2+bzPE7EFARAAPPXDz75nevylr7OKpRACIjDxRmQACyww9nWtKIGESSBCUKiif/hcNCamoGJ3jw8A2FJbuWnvPN3mcduCAQgA9v7k82ump+q7uR2VtMQWXl/IZ5B08jzFHlsHAAJEUEL/8l9D1IzQbsb+qW6AFhMLXp4vKIAA4NmHb1zTmp7YrTgqaRACp+AsQFJIJx4A3QXw2QMHkhYS1aVrAQ7RnJxOnQqaTdvn9g6PzxYcQADwi0e+sCZqTu5mFZdctkF6clwm/SULDuCxCfZYYtWhEUAU0ZxoZE93C7SQWJBsWpAAAcAvH/3iq6LG5OPg2Lm7JBvhMYgECLpEChwLkC0Z1aGzIIIKGkcnkLnvZwFsXogdXTHfF9DNzrzw+mcK5eqbSQZMpnNKJADTNyIhQRSAKADMRhSAROCOE4Wp+tRLz0O1p1EeHDDCwtkIgJ/W923bOj93290WLIOs7X/slo/E0dQXSEoTjwRISs0iCjoZZNiTuDrzj1j/YTAqg6dBFiqYHjuaZRKgld7mheLyFjxAALB/9827wO0LtXoLTDwKDTDSgUNd3Zw1NkAplAeHIcNyN5AWjMvrCYAA4Pndt0wJKcpCBCAZQAgJQIOjgUlYpIEDOgECwJpFgEK5tgxSFjBVH887ZR26czt6qu5pNrZgY1DWZBj+tWaLBJE0MUd2xiAKABEAFJrjoVfXr9n3NepHEMcRSv3VvFPWANw233GpZxgEAAd//pWnhAjWkAggKHDujUjCMkh3Wj1XB1OYGKTdnNIsYgUioDK0HHGrjebkJHJZB9xeW7lpyxzcYof1DIMAQAqxJWGQzyaZsEkkbCHhqToReCwK3TEGYerIIQTFAsJiEQbJrF1T37dttL5v2+Ac33JvMQgADj89+qSQpbVpcIxYgB+PLIN8GccA65JZAYg1mziGlAKVoeWYeuklqFihC5N2Adg4lwqvpxikTV3r3Jofj5DTJ8rZYFxjEr90GccKjfE6KkuWQAgCoPJOvg7A9rlkUs8xCABeevaOJ0mW15LX2FrRyRkYBOhGNzHIMSgGc1KW+vogCyVMHTmiP0u53+E5Y1IPMggAq0+SFQjwwTGxSXiZBJHOLiQM6/wckUBj4igARrGvCkABbEBN25wxqScBWrL6XXcwq4btB6UbOXBuz5fUEAkwKfdoAYZw5fTYEYTlCmSxAIZycStj6wCMnup77UmAAADcvl+LA+FEQqLufMboflA6DmVAcv9DZyOUitGcqKM8MAgimgmkt9f3bRs9lbfZswAxq5t0fPFB8oHKEQgiC473WaS31tQE2q0GKrVB6BxeV5CuOZWd2Z4UCdbq+++bFrJcghdf/CyDZpMRCWw7qG0tCFQb4DaYM6VK6iQYfctWojFeRzTdMONNvgBJ2bWnIi3UswwCAFbRT/3kqB68S7u8hEG+qPAZ52cdvJFZACqO0Rw/glJ/TWPCMzLptvq+betP9j32NEDg+B4AGUmduD0bj2zfxzxh4r3P5lQzktxjSHNyDHHUQKm/HzDgzADSSVd2PQ3Q4Flv/1xuj5/8qnFLSD9Q0vHGvA+b+nT9IMJyH4JCCNuX6gJSDcD2E7iVrtbTAAEAq+ZExzeZ/ZROrGMKlGlUeA1rPuc+nm1wXY+jBpoTh1Hsq8F2dGcAaV1937abT9b9LQKAoj2JAFCAt9lgr0VAbBo2RgIEm8G6dCNzttGZ0Th6AEIGCEtl+CDBgZSyP6/v27b5ZNxf7wPEam8qEWqSn+A2oDR7EqBineJxpQXT/7wPWAKU7hu9iGLfQAKOHbawQKXtpGS/ex4gcPyYy61l8moWHE7J5wQc66JS+zMA1hg/ACKBsFz1QJoxHo2+3Nvr6X6QtfEDD7AbH8omTVOmPDA0kIn7MwAqC6p3zAAMbqNUOw3FvmGMv7jf6xPZZ/J82e7s+trKTScck3qfQYBjTcKgdpo93gaOXWc1z+UxvNhik6XGFTIUGkefB5FAoVxJM8c+69DJpK31fdtWn+i9LQ6AVDyVBUmDETmRgAxICXM8cPJKsBdnGCqOMF3fh0KlHykgO9yds5fl6hYFQGBFaWB8V2W3CFB+Oic9FqTVXQzd2KbkvI3RHD8IGZYQhMUMa7z4lRYNV5yoqlscAMFTbhlhAE7n2DjDKAuOleFJmbg1WzJrWd6OptGcPISwXPFYc0zRcEKqblEAxKzGrcvyAdDARGCVdXW+2vPVnQ9SjiT34k2j/gLCUp/WBKn4ozL7DqQagOuO994WBUDg+JBWYBFsprqbSEixin2xkAYJBhw4kNjbFBrjBwEwwmIVabfG6f10PPrU8QqGRQEQM3sxKPJY5DMn8txflBpu6IhHtg4rxzvjEJjRGD+IoJhkFlKsSXVi067ueO5tUQAEMHXEFxUZJkUOtCx7OlNBHotScYlzt8bRgwjL/WbIyZfaKrOfAumK+r5tG2d7Z4sEIHVWuuGjBABlFJ3KHO+IRxacNhJwdPxhVmDVCdT00QMAgKBgWGTcWhoU3/U52zrbO1skAMWhS+WojEjIAAIjt/1sAZQvMPwyC4wCVNrdNScPQ4TFlEBIxaHuLNoymztbHACZfpAD5BgiIa+vlHJvKtbAWHAsKDksak4cRlAsz5BVyKo6Z1tnc2uLAyBEkrNsUTkiQaVZ1enqbGncmgeOzyINnC4b44cQFCoJCCm3llV1KRaNzIZFiwKgOBoTvntLscX0gzo6qimWxSZOmcZX7DEoASoFnNlaU/rh0kTNdXFt+a5u67HurecBOvTkHRewyk+QgvPjkf86qxisYij2AUhYhBRQBjzDHrCCilpot6YgZDgLFdchGEaOlQIKTmnrzYnxH7NSsAtZgJP1EnIHUpjNcdOArOvMdt+WytR9BvngJC6v3ZyECApIABDIdW3MYAKIGSCGGZa4DkDX1bl6nkFAfDn7QV3FUKbM25LX0rEkvcWdxzrAST7fbk5CiMBMFDuGa2N4sQqAVnRdH9fqeYBYRauZVabhNRDKa2C3z+ljCXimnhIJvmvLA0ezKGpMgmQAghko7BAM+WzyQOqao+t5gOJ4qj/d4LZB4zQwGTCUxxINXNLv8YFNi4X8fdvQJPyH8nE8LLqmW6a7p2PQ/v/78nkc1yV58QdA8rhvN5tNHAKDlckMKK+j6hjEDiT9D8hMJFNgYpABhbqySF+HF4u2AOgYGu9xBvFfMccphnS6rWxsiTtcXzdmpMoUgzxwlAUUbmpLarOCIYdFmX5RrpvraYBYtd7SEdjZjz+dAiEBJBN78txaBsxOsOxcV8sgCQhv9gQk2M1CB7IschhpG8kTCz3t4uL25BCUnvDLhNSqi4B/71nz4oDv3uxxX1577i5xcWl3FxT7oOIIRBIMAYLSrouN5GY93Z+t23Ouzd+c5N7iX2nPAvTsTz7/AY6nhVsUyfR7qCP++PsJZMnjZj5YXhzK7nMGIOUDVDXT+tsuHhGzZg8rMBGSXllGgpMFjACgo9Pasy6OVfvDWl7HicviPHcVozMmeZnqjKLr3jfqrurCUj8AO9PczJEVnVMtU0vWpGKQi0W17FhRzzJItcfX6F67t3iflz1wk0tSq105z292jJbLure8zALYSWrf3QkZIixV0ZxsamDsUIRljfZtAOn/RTBujmwMymXRdnuJPQnQkzs+cSdUBLuYbNf445aAMZYKSt3iELq4OpXr7sq1FQAAFdv5SARiAftUEBlIAPZiE8y+FfupWLQZnqLrSYA4br7VfksB5MSf7Dwg+8F0ZcY4pN9ggIETDVmAKktOR9RsgKhoXJedPaHApDSjzD4gXN/IigX95WL/yzNS37dttV2ZuOcAeuL+6z4hhCqASHsOIvPFM/sdCyh1+DhTeJ1FoJM9XdwclHF3pg/UP/wqEFXN41cxNKMVSCWz/YgUmPUFOXAcq8z/J+/itJu7GehBgMDtjylHnnT8AaxgpU72uM87/pj9nDg0g6Lzs92lvqUIS31oNUKA2LgzwxoRAyygn1HQs/tcrHGz9CxIMK+5c29ELwL02Lb3/qUMgj7tF44dfygHpfRsjlnEoQyT/D7S0pEL0W61AYQgMt8a9xwdmbQPgdjMgDDAEJEWDGQkt8mCw7o78AZ7hT0FEICtrPKVWyr+GPfG+f/Dk7gzxSF9zIKTAggKIihgYMUaMAZBHADGjZFjjALImxlBCsRGMLAwKk6lXB4DNi6tOvr8d9YMnP6mp3sGoJ13vfOeoFAusfFvSfzRgDB7fPHY1GkJcpzaz7DHByrFJi0Olo6sAyDB3A8SephCX0HCJGYFQgyXXXCgsWEaGdeYjUsAMy4G0BsAPfwvb7u8UB78Pa2oyMUfTq02D/PNRQabjEgw1Wwcsn2SZJ8zwCT7hXI/VpzzGjAPg1SgGxrW5Srj0uwsCTKgkL4+FpptIM0iA5Z7+NEyCXQxgG/1BEBCFu9hBum8G1z8cWj48ceouhn4Yyo5rs0ct+6tG0BnrnsTVCwBWTPsEabvI0BWydk+kJPaMUCmf8R6Np51ccgM8mk3RxuAHohBP/7G795VKA8Osoo9YWBYZL+VLvxQxn117QiZXfaKrJrLAYoZZ5y/EdUlZ4DCcwAWYNW5UgkzmYyC7hex6QORZZTrA9iSDZA2ywCAeQmwwAH6n9t/++pidelmVtZVUAKCxyIXf2aMPVmzzEnq+XEIDpwlq34Dy9dcBArOAaiqH/MSJg6ySDYIADEYJi5RVtlp8UAsYKdcEgsNklF2RHwesIAB+u/bNl5WqCy9w4oC982cKf7kxp6sJSzymZONQ2kmMYZWnY+RDW+GUsOQ6ANB6AVsDTishOkHkZHRWl4zKxDH+coOKpHcNq9o83bgPgALc5b3D77+hpFCaXCP0E8Dpowy8Yd81pBLkWY/hax7yzKnaxwCMLz2Yqy84ErE7UGIYIVbxVGvQ0cmO559rrvLZDCk58ECSQrJ1e0XQ0XDC45BO7562UihMpQLDuB/s4EOoeDiTz5QnFNLXFvmOAAZFjFy0Sb0D78KcXsJGH1gFcHm0fTogf65As0ksynt5phiwyLSLLKxyZPcWorr5xi0eLD9I4ApvnRBAfTQVy8dKVaG9sgu4HSaH8jzXj2GSJjBhladjzMv/C2wAtrRAAABEpHphjIg2MwT1hlqEgGAEIAAC5M98OS3jUt2Upjrw1m3aESDTvmYrAPp/7og7KFbXzdSrC7bI4PSLMGZjR2/+x5adT5OP/dSBMUKWtMM1S6BZAwSEYRlL6BdkmAAAezwtVtAXVlAbONTEm9UbOKOHY6Ijcw2McioOjNssTAAeujW119drC69TYYnE5zZW6FSw+DpZ2P52ZcgKFTQGJ9EY2IaRCFItiAMERUUhIkPEN7MBcGA0sEdJj5ZkZAovFjXhcnXwfaXkvQQkLg4w7z5B+ihf7z0uvLAaX9HQs5WH58UK9eG0b/sLAytOh/l2jBaU+NojE8iaowZEVCAkCahCYBYQXhNJxw7OWGTA0qZprXuzQcjpxPLthshTEyyZ5pnBv3g62/cXqmdccWpPEe5NgwZFlGpDaNQqaFcW4G+ZWciakygNTWO6foR1A/8EipmCFmACIoQBhwF1k3FnDSZYY39zgufQYBhEZsQInPYRAmbDJMSFqkkn6flOs0LQA/d+vqrC9Wh20p9y2bt0gqVGgqVAbffv2yVq8uwiHJtueuby7CEcm0YcdTEdF3PI22MHwKrGIefexQvPvMw4ijSYARFCFmEkAXdB24TVKAb285RgCsT0OD2jdszTIPQA3k6PinA/GRBwh6fRRac2BuW8EUD75lTgB78ymtHSv3L/nn47Ndeao9VasNODzcnx1CsDkK1mwARaqedAwAY2/9Ekjwwbz78y52Io4b7bW8QQUVNTNVfAJlj+ska+9PSRciwZAApQQbFRKIzdO8dAEsDQADX6MIBA7jeEgN2fEc7IxgWhWboh426g0nfSKRSQh44bhzJZr6N/C4vWb9zTgFavvaSgbDUv3Pi8N4v7X/8+y94L60220YAV+gfFdQ/xeka2+67YzIXCP2oU9LZA7lOH1Rbn4wAKEoyqkT62QAVG9YQwLF2bQg46W6BIci6OiSsgRbPgkKjw6xgQCIeiHNcnnZ1ybCEP55k+nILMZPw7c+dvpGE3EIkNpMQtWMBkgAn0wDmvi4hQ82iICxp95ZxdbpeMFsRJEO3TyJMShGCZAgS+jcihCndbxe5Mr2WN5HszDA4saDZo9qTzxWqI6vmXcXl2Vs+9vx2mGfD7rtpZAsIW8E84h5ZcsyAUVnmuD+E7B/L1FW7BZjcMoPdpAjdl9HtpLzrsbHIMseKBc0acz1IcnkkTMTyXR0BLLyRU+fy4qSkhE1gPgQs4GSptas+8uwogNHvfnHtFjC2gnjEb3BOgQPjjnxAkKmbZGQcaRCETm4qwMUkhv6ZDQueMoAnosFl7Uz80V8KVzdoEhgsPA/VAZZ1eTYlFCfygOPHgB569Pd3rn9qFOD1AN/gRelUstN2HJlN48LL3QFAxp0zx1BxA6rdhIqbpmzpumqZegsct8BKb3o/glItuBnkbGeSt6BUBKXs0jMR4C1J0zEDnfWz3P4PTdmSOboLWKAx6Fj2vb8/bz2RHCUh1nWNQy5OJXFJdI1LAiIoQcoiRFBI4pGJRVIWQYGJScLEIlkwMaigf9NVJLFIxydd+r+fp3/gI/vrX97z2+5576YSQVUCPcQg3678sz07GbyRwbd3sslYZkhb1xJ2Je83TssyJ25BtVsJk+IWYtWCiiPNHmXYE2u2sHmNHaPa6dIu7GQWdXLrBuX9uAcRSEjE0fiT9jYWfAzqZld+aPcYgC3b/2H9TgBfpM6nM726H4ts1aRw/HdzDKWa/uNtYDM4aGWAsuk082ErMNiT3GSFh1UaNvNtcqhWKCQS3HSFjBRX8dS/uf/Viy4uaw985aKNROJuIWTt2DJ7du4vcXMlCBmmXF5209I7BAlbD0w97eacW/PrGVcHsBKybKfk9aaLy9oVf/LIdgAbGVzPPjiaZlTWur/GKtLiIG46AeDEQlY0OPfWgl0sMFmCJlmrLl1PL+Fpy3bjwP3+dSwKgADgDe97eCeA9QDvslI4ZalYxZnj/ru9mnF5iZLT8Uc5tZYoOeVA8cGyqw0niwqmlkhLxaMYKm7GcTT+Xv+yFw1AAHD5e3+8FzpdtOv4HTejk33QaaK4aQBpgGPDijhKs8QXCR6L3KJN2dJbM5XNOqtx6/C28uAFz/lXtagAAoDL/uiHYwA2grErOfry42wCiu/esgB5rs2CxIlrs2C5VSBT/aJWpNqTf5o976IDCAAuvfYHGiT4IL180y5Py23VwRy/w2rdVhKD8hYbhOfe2s1Dnygv2bAve85FoeJmsh/905WjJMQ13RVcWuWJLirP1c1rqU6s6ay6xKoomNIkU6ngJU/D9O+7UgBW0aPlwQvW5V3/omSQb6959/e2AHT7y/onOUvLWHeWMKmbezNMyqR5nIuLG/tVe+Kqbqde9AABwG++87tbANww87syT6bmPiGRPqiDe1YsWLBaiaz2QVEpd9eI2xPvqS573Qt5ZwNeIQABwKv/8L6tAF0LIM0IShXogkyH2XFRsMqJP60EjNT63amlOqdVe3xT3/LL/mum87xiAAKAS67eNgpgA4C6PmKfQM0DhTJll9dsqseX19wGw1dpkafgIjBHB1V76s19w2/8/rGu+RUFEABc/I57dwJYDcIDQPJYgjZK45GqU141ZTozkJc09eS2iv6X4+b5/adf9eBsrnfRq7iZbNfdv38dCbk1Nax+jPzdTEMW/uf1kETohiggwnEieePgWVf/7fFc4yuOQb6t23znzQDWA7g9Ly5ZRtlHOGiG93QKCPPLKppJ32AVbThecIBXOIN8e2zbu1cTia0k5DX5jMnpH+U+yOI+VychRoUMb1l69oeeOdHr+hVAGXv8vmtXk5CbhRCbieQV3Ycqcju9u4QQ20mI7St+/aNdl1o+HvsVQMewn2//4EYScj0JMWhAWk1CjBHJMQPSXkFi78oNn9p+Ks7///nX7K/TEZ7yAAAAAElFTkSuQmCC"

/***/ },
/* 2614 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 2615 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 2616 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/Recurso6.60a4e08f.png";

/***/ },
/* 2617 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,QG1peGluIGtleWZyYW1lcygkYW5pbWF0aW9uLW5hbWUpIHsNCiAgQC13ZWJraXQta2V5ZnJhbWVzICN7JGFuaW1hdGlvbi1uYW1lfSB7DQogICAgQGNvbnRlbnQ7DQogIH0NCiAgQC1tb3ota2V5ZnJhbWVzICN7JGFuaW1hdGlvbi1uYW1lfSB7DQogICAgQGNvbnRlbnQ7DQogIH0NCiAgQC1tcy1rZXlmcmFtZXMgI3skYW5pbWF0aW9uLW5hbWV9IHsNCiAgICBAY29udGVudDsNCiAgfQ0KICBALW8ta2V5ZnJhbWVzICN7JGFuaW1hdGlvbi1uYW1lfSB7DQogICAgQGNvbnRlbnQ7DQogIH0NCiAgQGtleWZyYW1lcyAjeyRhbmltYXRpb24tbmFtZX0gew0KICAgIEBjb250ZW50Ow0KICB9DQp9DQoNCkBtaXhpbiBhbmltYXRpb24oJG5hbWUpIHsNCiAgYW5pbWF0aW9uOiAkbmFtZSA2cyBjdWJpYy1iZXppZXIoMCwgMCwgMC4xNywgMS4wMykgZm9yd2FyZHM7DQogIC13ZWJraXQtYW5pbWF0aW9uOiAkbmFtZSA2cyBjdWJpYy1iZXppZXIoMCwgMCwgMC4xNywgMS4wMykgZm9yd2FyZHM7DQogIC1tb3otYW5pbWF0aW9uOiAkbmFtZSA2cyBjdWJpYy1iZXppZXIoMCwgMCwgMC4xNywgMS4wMykgZm9yd2FyZHM7DQogIC1tcy1hbmltYXRpb246ICRuYW1lIDZzIGN1YmljLWJlemllcigwLCAwLCAwLjE3LCAxLjAzKSBmb3J3YXJkczsNCiAgLW8tYW5pbWF0aW9uOiAkbmFtZSA2cyBjdWJpYy1iZXppZXIoMCwgMCwgMC4xNywgMS4wMykgZm9yd2FyZHM7DQogIC13ZWJraXQtYmFja2ZhY2UtdmlzaWJpbGl0eTogaGlkZGVuOw0KICAtbW96LWJhY2tmYWNlLXZpc2liaWxpdHk6IGhpZGRlbjsNCiAgLW1zLWJhY2tmYWNlLXZpc2liaWxpdHk6IGhpZGRlbjsNCiAgLW8tYmFja2ZhY2UtdmlzaWJpbGl0eTogaGlkZGVuOw0KICBiYWNrZmFjZS12aXNpYmlsaXR5OiBoaWRkZW47DQp9DQoNCkBtaXhpbiBhbmltYXRpb24yKCRuYW1lLCAkc2VjKSB7DQogIGFuaW1hdGlvbjogJG5hbWUgNnMgY3ViaWMtYmV6aWVyKDAsIDAsIDAuMTcsIDEuMDMpICN7JHNlY30gZm9yd2FyZHM7DQogIC13ZWJraXQtYW5pbWF0aW9uOiAkbmFtZSA2cyBjdWJpYy1iZXppZXIoMCwgMCwgMC4xNywgMS4wMykgI3skc2VjfSBmb3J3YXJkczsNCiAgLW1vei1hbmltYXRpb246ICRuYW1lIDZzIGN1YmljLWJlemllcigwLCAwLCAwLjE3LCAxLjAzKSAjeyRzZWN9IGZvcndhcmRzOw0KICAtbXMtYW5pbWF0aW9uOiAkbmFtZSA2cyBjdWJpYy1iZXppZXIoMCwgMCwgMC4xNywgMS4wMykgI3skc2VjfSBmb3J3YXJkczsNCiAgLW8tYW5pbWF0aW9uOiAkbmFtZSA2cyBjdWJpYy1iZXppZXIoMCwgMCwgMC4xNywgMS4wMykgI3skc2VjfSBmb3J3YXJkczsNCn0NCg0KQGluY2x1ZGUga2V5ZnJhbWVzKCJteWZpcnN0XzAxIikgew0KICAwJSB7DQogICAgdHJhbnNmb3JtOiByb3RhdGUoLTE4MGRlZykgc2NhbGUoMCk7DQogIH0NCiAgMTAlLA0KICAxMDAlIHsNCiAgICB0cmFuc2Zvcm06IHJvdGF0ZSgwZGVnKSBzY2FsZSgxKTsNCiAgfQ0KfQ0KDQpAaW5jbHVkZSBrZXlmcmFtZXMoIm15Zmlyc3RfMDIiKSB7DQogIDAlLA0KICA5JSB7DQogICAgdHJhbnNmb3JtOiByb3RhdGUoLTE4MGRlZykgc2NhbGUoMCk7DQogIH0NCiAgMTklLA0KICAxMDAlIHsNCiAgICB0cmFuc2Zvcm06IHJvdGF0ZSgwZGVnKSBzY2FsZSgxKTsNCiAgICBkaXNwbGF5OiBibG9jazsNCiAgfQ0KfQ0KDQpAaW5jbHVkZSBrZXlmcmFtZXMoIm15Zmlyc3RfMDMiKSB7DQogIDAlLA0KICAxOCUgew0KICAgIHRyYW5zZm9ybTogcm90YXRlKC0xODBkZWcpIHNjYWxlKDApOw0KICB9DQogIDI4JSwNCiAgMTAwJSB7DQogICAgdHJhbnNmb3JtOiByb3RhdGUoMGRlZykgc2NhbGUoMSk7DQogIH0NCn0NCg0KQGluY2x1ZGUga2V5ZnJhbWVzKCJteWZpcnN0XzA0Iikgew0KICAwJSwNCiAgMjclIHsNCiAgICB0cmFuc2Zvcm06IHJvdGF0ZSgtMTgwZGVnKSBzY2FsZSgwKTsNCiAgfQ0KICAzNyUsDQogIDEwMCUgew0KICAgIHRyYW5zZm9ybTogcm90YXRlKDBkZWcpIHNjYWxlKDEpOw0KICB9DQp9DQoNCkBpbmNsdWRlIGtleWZyYW1lcygibXlmaXJzdF8wNSIpIHsNCiAgMCUgew0KICAgIHRyYW5zZm9ybTogcm90YXRlKC0xODBkZWcpIHNjYWxlKDApOw0KICB9DQogIDM2JSB7DQogICAgdHJhbnNmb3JtOiByb3RhdGUoLTE4MGRlZykgc2NhbGUoMCk7DQogIH0NCiAgNDYlIHsNCiAgICB0cmFuc2Zvcm06IHJvdGF0ZSgwZGVnKSBzY2FsZSgxKTsNCiAgfQ0KICAxMDAlIHsNCiAgICB0cmFuc2Zvcm06IHJvdGF0ZSgwZGVnKSBzY2FsZSgxKTsNCiAgfQ0KfQ0KDQpAaW5jbHVkZSBrZXlmcmFtZXMoImFuaW1hY2lvbl8wMiIpIHsNCiAgMCUgew0KICAgIHRyYW5zZm9ybTogcm90YXRlKC00NTBkZWcpIHNjYWxlKDApOw0KICB9DQogIDYwJSB7DQogICAgdHJhbnNmb3JtOiByb3RhdGUoMGRlZykgc2NhbGUoMSk7DQogIH0NCiAgMTAwJSB7DQogICAgdHJhbnNmb3JtOiByb3RhdGUoMGRlZykgc2NhbGUoMSk7DQogIH0NCn0NCg0KQGluY2x1ZGUga2V5ZnJhbWVzKCJhbmltYWNpb25fMDMiKSB7DQogIDAlIHsNCiAgICBvcGFjaXR5OiAwOw0KICB9DQogIDQwJSB7DQogICAgb3BhY2l0eTogMDsNCiAgfQ0KICA1MCUgew0KICAgIG9wYWNpdHk6IDE7DQogIH0NCiAgMTAwJSB7DQogICAgb3BhY2l0eTogMTsNCiAgfQ0KfQ0KDQpAaW5jbHVkZSBrZXlmcmFtZXMoImFuaW1hY2lvbl8wM18yIikgew0KICAwJSwNCiAgNDAlIHsNCiAgICBvcGFjaXR5OiAwOw0KICB9DQogIDUwJSwNCiAgMTAwJSB7DQogICAgb3BhY2l0eTogMTsNCiAgfQ0KfQ0KDQpAaW5jbHVkZSBrZXlmcmFtZXMoImFuaW1hY2lvbl8wM18xIikgew0KICAxMDAlIHsNCiAgICBvcGFjaXR5OiAxOw0KICB9DQp9DQoNCkBpbmNsdWRlIGtleWZyYW1lcygiZ2FsYXh5Iikgew0KICAwJSB7DQogICAgb3BhY2l0eTogMDsNCiAgfQ0KICA0MCUgew0KICAgIG9wYWNpdHk6IDA7DQogIH0NCiAgNTAlIHsNCiAgICBvcGFjaXR5OiAxOw0KICB9DQogIDEwMCUgew0KICAgIG9wYWNpdHk6IDE7DQogIH0NCn0NCg0KQGluY2x1ZGUga2V5ZnJhbWVzKCJhbmltYWNpb25fMDQiKSB7DQogIDAlLA0KICA4MCUgew0KICAgIG9wYWNpdHk6IDE7DQogIH0NCiAgOTAlLA0KICAxMDAlIHsNCiAgICBvcGFjaXR5OiAxOw0KICB9DQp9DQoNCkBpbmNsdWRlIGtleWZyYW1lcygidGV4dG9fb3BhY2lkYWQiKSB7DQogIDAlLA0KICA1MCUsDQogIDEwMCUgew0KICAgIG9wYWNpdHk6IDE7DQogIH0NCiAgNjAlLA0KICA5MCUgew0KICAgIG9wYWNpdHk6IDE7DQogIH0NCn0NCg0KQGluY2x1ZGUga2V5ZnJhbWVzKCJ0ZXh0b19vcGFjaWRhZF8wMSIpIHsNCiAgMCUsDQogIDUwJSB7DQogICAgb3BhY2l0eTogMDsNCiAgfQ0KICA2MCUsDQogIDEwMCUgew0KICAgIG9wYWNpdHk6IDE7DQogIH0NCn0NCg0KQGluY2x1ZGUga2V5ZnJhbWVzKCJibHVyXzAxIikgew0KICAwJSB7DQogICAgZmlsdGVyOiBibHVyKDVweCk7DQogICAgb3BhY2l0eTogMDsNCiAgfQ0KICA4MCUgew0KICAgIGZpbHRlcjogYmx1cig1cHgpOw0KICAgIG9wYWNpdHk6IDAuNTsNCiAgfQ0KICA5NSUsDQogIDEwMCUgew0KICAgIGZpbHRlcjogYmx1cigyMHB4KTsNCiAgICBvcGFjaXR5OiAxOw0KICB9DQp9DQoNCkBpbmNsdWRlIGtleWZyYW1lcygiYnJpZ2h0bmVzc18wMSIpIHsNCiAgMCUsDQogIDQwJSB7DQogICAgZmlsdGVyOiBicmlnaHRuZXNzKDEuMyk7DQogIH0NCiAgNjAlLA0KICAxMDAlIHsNCiAgICBmaWx0ZXI6IGJyaWdodG5lc3MoMSk7DQogIH0NCn0NCg0KQGluY2x1ZGUga2V5ZnJhbWVzKCJibHVyXzAyIikgew0KICAwJSB7DQogICAgZmlsdGVyOiBibHVyKDJweCkgYnJpZ2h0bmVzcygxLjUpOw0KICAgIHRyYW5zZm9ybTogc2NhbGUoMCk7DQogIH0NCiAgNDUlIHsNCiAgICBmaWx0ZXI6IGJsdXIoMnB4KSBicmlnaHRuZXNzKDEuNSk7DQogICAgdHJhbnNmb3JtOiBzY2FsZSgxKTsNCiAgfQ0KICA4MCUsDQogIDEwMCUgew0KICAgIGZpbHRlcjogYmx1cigzMHB4KSBicmlnaHRuZXNzKDEuNSk7DQogICAgdHJhbnNmb3JtOiBzY2FsZSgxKTsNCiAgfQ0KfQ0KDQpAaW5jbHVkZSBrZXlmcmFtZXMoImNvbG9yXzAzIikgew0KICAwJSwNCiAgNjAlLA0KICA2NSUsDQogIDEwMCUgew0KICAgIC13ZWJraXQtdGV4dC1zdHJva2U6IDFweCByZ2IoMjU1LCAyNTUsIDI1NSk7DQogICAgY29sb3I6IHJnYigyNTUsIDI1NSwgMjU1KTsNCiAgfQ0KICA2MyUgew0KICAgIC13ZWJraXQtdGV4dC1zdHJva2U6IDFweCByZ2IoMjU1LCAyMTcsIDY2KTsNCiAgICBjb2xvcjogcmdiKDI1NSwgMjE3LCA2Nik7DQogIH0NCn0NCg0KQGluY2x1ZGUga2V5ZnJhbWVzKCJyb3RhdGVfMDEiKSB7DQogIDAlIHsNCiAgICBvcGFjaXR5OiAxOw0KICAgIHRyYW5zZm9ybTogcm90YXRlKDBkZWcpOw0KICB9DQogIDEwMCUgew0KICAgIG9wYWNpdHk6IDE7DQogICAgdHJhbnNmb3JtOiByb3RhdGUoMzYwZGVnKTsNCiAgfQ0KfQ0K"

/***/ },
/* 2618 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,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"

/***/ },
/* 2619 */
/***/ function(module, exports) {

	/**
	 * This file automatically generated from `pre-publish.js`.
	 * Do not manually edit.
	 */
	
	module.exports = {
	  "area": true,
	  "base": true,
	  "br": true,
	  "col": true,
	  "embed": true,
	  "hr": true,
	  "img": true,
	  "input": true,
	  "link": true,
	  "meta": true,
	  "param": true,
	  "source": true,
	  "track": true,
	  "wbr": true
	};


/***/ },
/* 2620 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./001.png": 1011,
		"./002.png": 1012,
		"./003.png": 1013,
		"./004.png": 1014,
		"./005.png": 1015,
		"./006.png": 1016,
		"./007.png": 1017,
		"./008.png": 1018,
		"./009.png": 1019,
		"./010.png": 1020,
		"./011.png": 1021,
		"./012.png": 1022,
		"./013.png": 1023,
		"./014.png": 1024,
		"./015.png": 1025,
		"./016.png": 1026,
		"./017.png": 1027,
		"./018.png": 1028,
		"./019.png": 1029,
		"./020.png": 1030,
		"./021.png": 1031,
		"./022.png": 1032,
		"./023.png": 1033,
		"./024.png": 1034,
		"./025.png": 1035,
		"./026.png": 1036,
		"./027.png": 1037,
		"./028.png": 1038,
		"./029.png": 1039,
		"./030.png": 1040,
		"./031.png": 1041,
		"./032.png": 1042
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 2620;


/***/ },
/* 2621 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ },
/* 2622 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	__webpack_require__(__webpack_module_template_argument_0__);
	module.exports = __webpack_require__(__webpack_module_template_argument_1__).Object.entries;


/***/ },
/* 2623 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	__webpack_require__(__webpack_module_template_argument_0__);
	module.exports = __webpack_require__(__webpack_module_template_argument_1__).Object.values;


/***/ },
/* 2624 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ },
/* 2625 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(__webpack_module_template_argument_0__);
	var toLength = __webpack_require__(__webpack_module_template_argument_1__);
	var toAbsoluteIndex = __webpack_require__(__webpack_module_template_argument_2__);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ },
/* 2626 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(__webpack_module_template_argument_0__);
	var TAG = __webpack_require__(__webpack_module_template_argument_1__)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ },
/* 2627 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	var $defineProperty = __webpack_require__(__webpack_module_template_argument_0__);
	var createDesc = __webpack_require__(__webpack_module_template_argument_1__);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ },
/* 2628 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ },
/* 2629 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(__webpack_module_template_argument_0__)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 2630 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	var document = __webpack_require__(__webpack_module_template_argument_1__).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ },
/* 2631 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(__webpack_module_template_argument_0__);
	var gOPS = __webpack_require__(__webpack_module_template_argument_1__);
	var pIE = __webpack_require__(__webpack_module_template_argument_2__);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ },
/* 2632 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var dP = __webpack_require__(__webpack_module_template_argument_0__);
	var createDesc = __webpack_require__(__webpack_module_template_argument_1__);
	module.exports = __webpack_require__(__webpack_module_template_argument_2__) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ },
/* 2633 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var document = __webpack_require__(__webpack_module_template_argument_0__).document;
	module.exports = document && document.documentElement;


/***/ },
/* 2634 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	module.exports = !__webpack_require__(__webpack_module_template_argument_0__) && !__webpack_require__(__webpack_module_template_argument_1__)(function () {
	  return Object.defineProperty(__webpack_require__(__webpack_module_template_argument_2__)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 2635 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(__webpack_module_template_argument_0__);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ },
/* 2636 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(__webpack_module_template_argument_0__);
	var ITERATOR = __webpack_require__(__webpack_module_template_argument_1__)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ },
/* 2637 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ },
/* 2638 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ },
/* 2639 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	'use strict';
	var create = __webpack_require__(__webpack_module_template_argument_0__);
	var descriptor = __webpack_require__(__webpack_module_template_argument_1__);
	var setToStringTag = __webpack_require__(__webpack_module_template_argument_2__);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(__webpack_module_template_argument_3__)(IteratorPrototype, __webpack_require__(__webpack_module_template_argument_4__)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ },
/* 2640 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__) {

	'use strict';
	var LIBRARY = __webpack_require__(__webpack_module_template_argument_0__);
	var $export = __webpack_require__(__webpack_module_template_argument_1__);
	var redefine = __webpack_require__(__webpack_module_template_argument_2__);
	var hide = __webpack_require__(__webpack_module_template_argument_3__);
	var Iterators = __webpack_require__(__webpack_module_template_argument_4__);
	var $iterCreate = __webpack_require__(__webpack_module_template_argument_5__);
	var setToStringTag = __webpack_require__(__webpack_module_template_argument_6__);
	var getPrototypeOf = __webpack_require__(__webpack_module_template_argument_7__);
	var ITERATOR = __webpack_require__(__webpack_module_template_argument_8__)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ },
/* 2641 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var ITERATOR = __webpack_require__(__webpack_module_template_argument_0__)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ },
/* 2642 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	var META = __webpack_require__(__webpack_module_template_argument_0__)('meta');
	var isObject = __webpack_require__(__webpack_module_template_argument_1__);
	var has = __webpack_require__(__webpack_module_template_argument_2__);
	var setDesc = __webpack_require__(__webpack_module_template_argument_3__).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(__webpack_module_template_argument_4__)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ },
/* 2643 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var DESCRIPTORS = __webpack_require__(__webpack_module_template_argument_0__);
	var getKeys = __webpack_require__(__webpack_module_template_argument_1__);
	var gOPS = __webpack_require__(__webpack_module_template_argument_2__);
	var pIE = __webpack_require__(__webpack_module_template_argument_3__);
	var toObject = __webpack_require__(__webpack_module_template_argument_4__);
	var IObject = __webpack_require__(__webpack_module_template_argument_5__);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(__webpack_module_template_argument_6__)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;


/***/ },
/* 2644 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(__webpack_module_template_argument_0__);
	var dPs = __webpack_require__(__webpack_module_template_argument_1__);
	var enumBugKeys = __webpack_require__(__webpack_module_template_argument_2__);
	var IE_PROTO = __webpack_require__(__webpack_module_template_argument_3__)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(__webpack_module_template_argument_4__)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(__webpack_module_template_argument_5__).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ },
/* 2645 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var anObject = __webpack_require__(__webpack_module_template_argument_0__);
	var IE8_DOM_DEFINE = __webpack_require__(__webpack_module_template_argument_1__);
	var toPrimitive = __webpack_require__(__webpack_module_template_argument_2__);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(__webpack_module_template_argument_3__) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ },
/* 2646 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var dP = __webpack_require__(__webpack_module_template_argument_0__);
	var anObject = __webpack_require__(__webpack_module_template_argument_1__);
	var getKeys = __webpack_require__(__webpack_module_template_argument_2__);
	
	module.exports = __webpack_require__(__webpack_module_template_argument_3__) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ },
/* 2647 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__) {

	var pIE = __webpack_require__(__webpack_module_template_argument_0__);
	var createDesc = __webpack_require__(__webpack_module_template_argument_1__);
	var toIObject = __webpack_require__(__webpack_module_template_argument_2__);
	var toPrimitive = __webpack_require__(__webpack_module_template_argument_3__);
	var has = __webpack_require__(__webpack_module_template_argument_4__);
	var IE8_DOM_DEFINE = __webpack_require__(__webpack_module_template_argument_5__);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(__webpack_module_template_argument_6__) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ },
/* 2648 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(__webpack_module_template_argument_0__);
	var gOPN = __webpack_require__(__webpack_module_template_argument_1__).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ },
/* 2649 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(__webpack_module_template_argument_0__);
	var hiddenKeys = __webpack_require__(__webpack_module_template_argument_1__).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ },
/* 2650 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(__webpack_module_template_argument_0__);
	var toObject = __webpack_require__(__webpack_module_template_argument_1__);
	var IE_PROTO = __webpack_require__(__webpack_module_template_argument_2__)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ },
/* 2651 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var has = __webpack_require__(__webpack_module_template_argument_0__);
	var toIObject = __webpack_require__(__webpack_module_template_argument_1__);
	var arrayIndexOf = __webpack_require__(__webpack_module_template_argument_2__)(false);
	var IE_PROTO = __webpack_require__(__webpack_module_template_argument_3__)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ },
/* 2652 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(__webpack_module_template_argument_0__);
	var enumBugKeys = __webpack_require__(__webpack_module_template_argument_1__);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ },
/* 2653 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var DESCRIPTORS = __webpack_require__(__webpack_module_template_argument_0__);
	var getKeys = __webpack_require__(__webpack_module_template_argument_1__);
	var toIObject = __webpack_require__(__webpack_module_template_argument_2__);
	var isEnum = __webpack_require__(__webpack_module_template_argument_3__).f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) {
	      key = keys[i++];
	      if (!DESCRIPTORS || isEnum.call(O, key)) {
	        result.push(isEntries ? [key, O[key]] : O[key]);
	      }
	    }
	    return result;
	  };
	};


/***/ },
/* 2654 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	var anObject = __webpack_require__(__webpack_module_template_argument_1__);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(__webpack_module_template_argument_2__)(Function.call, __webpack_require__(__webpack_module_template_argument_3__).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ },
/* 2655 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var def = __webpack_require__(__webpack_module_template_argument_0__).f;
	var has = __webpack_require__(__webpack_module_template_argument_1__);
	var TAG = __webpack_require__(__webpack_module_template_argument_2__)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ },
/* 2656 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var shared = __webpack_require__(__webpack_module_template_argument_0__)('keys');
	var uid = __webpack_require__(__webpack_module_template_argument_1__);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ },
/* 2657 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var core = __webpack_require__(__webpack_module_template_argument_0__);
	var global = __webpack_require__(__webpack_module_template_argument_1__);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(__webpack_module_template_argument_2__) ? 'pure' : 'global',
	  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
	});


/***/ },
/* 2658 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var toInteger = __webpack_require__(__webpack_module_template_argument_0__);
	var defined = __webpack_require__(__webpack_module_template_argument_1__);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ },
/* 2659 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var toInteger = __webpack_require__(__webpack_module_template_argument_0__);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ },
/* 2660 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(__webpack_module_template_argument_0__);
	var defined = __webpack_require__(__webpack_module_template_argument_1__);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ },
/* 2661 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(__webpack_module_template_argument_0__);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ },
/* 2662 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ },
/* 2663 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ },
/* 2664 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	var global = __webpack_require__(__webpack_module_template_argument_0__);
	var core = __webpack_require__(__webpack_module_template_argument_1__);
	var LIBRARY = __webpack_require__(__webpack_module_template_argument_2__);
	var wksExt = __webpack_require__(__webpack_module_template_argument_3__);
	var defineProperty = __webpack_require__(__webpack_module_template_argument_4__).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ },
/* 2665 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	exports.f = __webpack_require__(__webpack_module_template_argument_0__);


/***/ },
/* 2666 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var store = __webpack_require__(__webpack_module_template_argument_0__)('wks');
	var uid = __webpack_require__(__webpack_module_template_argument_1__);
	var Symbol = __webpack_require__(__webpack_module_template_argument_2__).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ },
/* 2667 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var classof = __webpack_require__(__webpack_module_template_argument_0__);
	var ITERATOR = __webpack_require__(__webpack_module_template_argument_1__)('iterator');
	var Iterators = __webpack_require__(__webpack_module_template_argument_2__);
	module.exports = __webpack_require__(__webpack_module_template_argument_3__).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ },
/* 2668 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__) {

	'use strict';
	var ctx = __webpack_require__(__webpack_module_template_argument_0__);
	var $export = __webpack_require__(__webpack_module_template_argument_1__);
	var toObject = __webpack_require__(__webpack_module_template_argument_2__);
	var call = __webpack_require__(__webpack_module_template_argument_3__);
	var isArrayIter = __webpack_require__(__webpack_module_template_argument_4__);
	var toLength = __webpack_require__(__webpack_module_template_argument_5__);
	var createProperty = __webpack_require__(__webpack_module_template_argument_6__);
	var getIterFn = __webpack_require__(__webpack_module_template_argument_7__);
	
	$export($export.S + $export.F * !__webpack_require__(__webpack_module_template_argument_8__)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ },
/* 2669 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	'use strict';
	var addToUnscopables = __webpack_require__(__webpack_module_template_argument_0__);
	var step = __webpack_require__(__webpack_module_template_argument_1__);
	var Iterators = __webpack_require__(__webpack_module_template_argument_2__);
	var toIObject = __webpack_require__(__webpack_module_template_argument_3__);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(__webpack_module_template_argument_4__)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ },
/* 2670 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(__webpack_module_template_argument_1__) });


/***/ },
/* 2671 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(__webpack_module_template_argument_1__) });


/***/ },
/* 2672 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(__webpack_module_template_argument_1__).set });


/***/ },
/* 2673 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	var $at = __webpack_require__(__webpack_module_template_argument_0__)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(__webpack_module_template_argument_1__)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ },
/* 2674 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__, __webpack_module_template_argument_9__, __webpack_module_template_argument_10__, __webpack_module_template_argument_11__, __webpack_module_template_argument_12__, __webpack_module_template_argument_13__, __webpack_module_template_argument_14__, __webpack_module_template_argument_15__, __webpack_module_template_argument_16__, __webpack_module_template_argument_17__, __webpack_module_template_argument_18__, __webpack_module_template_argument_19__, __webpack_module_template_argument_20__, __webpack_module_template_argument_21__, __webpack_module_template_argument_22__, __webpack_module_template_argument_23__, __webpack_module_template_argument_24__, __webpack_module_template_argument_25__, __webpack_module_template_argument_26__, __webpack_module_template_argument_27__, __webpack_module_template_argument_28__, __webpack_module_template_argument_29__, __webpack_module_template_argument_30__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(__webpack_module_template_argument_0__);
	var has = __webpack_require__(__webpack_module_template_argument_1__);
	var DESCRIPTORS = __webpack_require__(__webpack_module_template_argument_2__);
	var $export = __webpack_require__(__webpack_module_template_argument_3__);
	var redefine = __webpack_require__(__webpack_module_template_argument_4__);
	var META = __webpack_require__(__webpack_module_template_argument_5__).KEY;
	var $fails = __webpack_require__(__webpack_module_template_argument_6__);
	var shared = __webpack_require__(__webpack_module_template_argument_7__);
	var setToStringTag = __webpack_require__(__webpack_module_template_argument_8__);
	var uid = __webpack_require__(__webpack_module_template_argument_9__);
	var wks = __webpack_require__(__webpack_module_template_argument_10__);
	var wksExt = __webpack_require__(__webpack_module_template_argument_11__);
	var wksDefine = __webpack_require__(__webpack_module_template_argument_12__);
	var enumKeys = __webpack_require__(__webpack_module_template_argument_13__);
	var isArray = __webpack_require__(__webpack_module_template_argument_14__);
	var anObject = __webpack_require__(__webpack_module_template_argument_15__);
	var isObject = __webpack_require__(__webpack_module_template_argument_16__);
	var toObject = __webpack_require__(__webpack_module_template_argument_17__);
	var toIObject = __webpack_require__(__webpack_module_template_argument_18__);
	var toPrimitive = __webpack_require__(__webpack_module_template_argument_19__);
	var createDesc = __webpack_require__(__webpack_module_template_argument_20__);
	var _create = __webpack_require__(__webpack_module_template_argument_21__);
	var gOPNExt = __webpack_require__(__webpack_module_template_argument_22__);
	var $GOPD = __webpack_require__(__webpack_module_template_argument_23__);
	var $GOPS = __webpack_require__(__webpack_module_template_argument_24__);
	var $DP = __webpack_require__(__webpack_module_template_argument_25__);
	var $keys = __webpack_require__(__webpack_module_template_argument_26__);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(__webpack_module_template_argument_27__).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(__webpack_module_template_argument_28__).f = $propertyIsEnumerable;
	  $GOPS.f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(__webpack_module_template_argument_29__)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443
	var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });
	
	$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    return $GOPS.f(toObject(it));
	  }
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(__webpack_module_template_argument_30__)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ },
/* 2675 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	var $entries = __webpack_require__(__webpack_module_template_argument_1__)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it) {
	    return $entries(it);
	  }
	});


/***/ },
/* 2676 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	var $values = __webpack_require__(__webpack_module_template_argument_1__)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it) {
	    return $values(it);
	  }
	});


/***/ },
/* 2677 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	__webpack_require__(__webpack_module_template_argument_0__)('asyncIterator');


/***/ },
/* 2678 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(27));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Fade = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_1__));
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	var propTypes = {
	  children: _propTypes.default.node,
	  className: _propTypes.default.string,
	  closeClassName: _propTypes.default.string,
	  closeAriaLabel: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  color: _propTypes.default.string,
	  fade: _propTypes.default.bool,
	  isOpen: _propTypes.default.bool,
	  toggle: _propTypes.default.func,
	  tag: _utils.tagPropType,
	  transition: _propTypes.default.shape(_Fade.default.propTypes),
	  innerRef: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string, _propTypes.default.func])
	};
	var defaultProps = {
	  color: 'success',
	  isOpen: true,
	  tag: 'div',
	  closeAriaLabel: 'Close',
	  fade: true,
	  transition: _objectSpread(_objectSpread({}, _Fade.default.defaultProps), {}, {
	    unmountOnExit: true
	  })
	};
	
	function Alert(props) {
	  var className = props.className,
	      closeClassName = props.closeClassName,
	      closeAriaLabel = props.closeAriaLabel,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      color = props.color,
	      isOpen = props.isOpen,
	      toggle = props.toggle,
	      children = props.children,
	      transition = props.transition,
	      fade = props.fade,
	      innerRef = props.innerRef,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "closeClassName", "closeAriaLabel", "cssModule", "tag", "color", "isOpen", "toggle", "children", "transition", "fade", "innerRef"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'alert', "alert-" + color, {
	    'alert-dismissible': toggle
	  }), cssModule);
	  var closeClasses = (0, _utils.mapToCssModules)((0, _classnames.default)('close', closeClassName), cssModule);
	
	  var alertTransition = _objectSpread(_objectSpread(_objectSpread({}, _Fade.default.defaultProps), transition), {}, {
	    baseClass: fade ? transition.baseClass : '',
	    timeout: fade ? transition.timeout : 0
	  });
	
	  return /*#__PURE__*/_react.default.createElement(_Fade.default, (0, _extends2.default)({}, attributes, alertTransition, {
	    tag: Tag,
	    className: classes,
	    in: isOpen,
	    role: "alert",
	    innerRef: innerRef
	  }), toggle ? /*#__PURE__*/_react.default.createElement("button", {
	    type: "button",
	    className: closeClasses,
	    "aria-label": closeAriaLabel,
	    onClick: toggle
	  }, /*#__PURE__*/_react.default.createElement("span", {
	    "aria-hidden": "true"
	  }, "\xD7")) : null, children);
	}
	
	Alert.propTypes = propTypes;
	Alert.defaultProps = defaultProps;
	var _default = Alert;
	exports.default = _default;

/***/ },
/* 2679 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	var propTypes = {
	  color: _propTypes.default.string,
	  pill: _propTypes.default.bool,
	  tag: _utils.tagPropType,
	  innerRef: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func, _propTypes.default.string]),
	  children: _propTypes.default.node,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  color: 'secondary',
	  pill: false,
	  tag: 'span'
	};
	
	var Badge = function Badge(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      color = props.color,
	      innerRef = props.innerRef,
	      pill = props.pill,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "color", "innerRef", "pill", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'badge', 'badge-' + color, pill ? 'badge-pill' : false), cssModule);
	
	  if (attributes.href && Tag === 'span') {
	    Tag = 'a';
	  }
	
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes,
	    ref: innerRef
	  }));
	};
	
	Badge.propTypes = propTypes;
	Badge.defaultProps = defaultProps;
	var _default = Badge;
	exports.default = _default;

/***/ },
/* 2680 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  listTag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  listClassName: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  children: _propTypes.default.node,
	  'aria-label': _propTypes.default.string
	};
	var defaultProps = {
	  tag: 'nav',
	  listTag: 'ol',
	  'aria-label': 'breadcrumb'
	};
	
	var Breadcrumb = function Breadcrumb(props) {
	  var className = props.className,
	      listClassName = props.listClassName,
	      cssModule = props.cssModule,
	      children = props.children,
	      Tag = props.tag,
	      ListTag = props.listTag,
	      label = props['aria-label'],
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "listClassName", "cssModule", "children", "tag", "listTag", "aria-label"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className), cssModule);
	  var listClasses = (0, _utils.mapToCssModules)((0, _classnames.default)('breadcrumb', listClassName), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes,
	    "aria-label": label
	  }), /*#__PURE__*/_react.default.createElement(ListTag, {
	    className: listClasses
	  }, children));
	};
	
	Breadcrumb.propTypes = propTypes;
	Breadcrumb.defaultProps = defaultProps;
	var _default = Breadcrumb;
	exports.default = _default;

/***/ },
/* 2681 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  active: _propTypes.default.bool,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'li'
	};
	
	var BreadcrumbItem = function BreadcrumbItem(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      active = props.active,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "active", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, active ? 'active' : false, 'breadcrumb-item'), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes,
	    "aria-current": active ? 'page' : undefined
	  }));
	};
	
	BreadcrumbItem.propTypes = propTypes;
	BreadcrumbItem.defaultProps = defaultProps;
	var _default = BreadcrumbItem;
	exports.default = _default;

/***/ },
/* 2682 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(20));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	var propTypes = {
	  active: _propTypes.default.bool,
	  'aria-label': _propTypes.default.string,
	  block: _propTypes.default.bool,
	  color: _propTypes.default.string,
	  disabled: _propTypes.default.bool,
	  outline: _propTypes.default.bool,
	  tag: _utils.tagPropType,
	  innerRef: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func, _propTypes.default.string]),
	  onClick: _propTypes.default.func,
	  size: _propTypes.default.string,
	  children: _propTypes.default.node,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  close: _propTypes.default.bool
	};
	var defaultProps = {
	  color: 'secondary',
	  tag: 'button'
	};
	
	var Button = /*#__PURE__*/function (_React$Component) {
	  (0, _inheritsLoose2.default)(Button, _React$Component);
	
	  function Button(props) {
	    var _this;
	
	    _this = _React$Component.call(this, props) || this;
	    _this.onClick = _this.onClick.bind((0, _assertThisInitialized2.default)(_this));
	    return _this;
	  }
	
	  var _proto = Button.prototype;
	
	  _proto.onClick = function onClick(e) {
	    if (this.props.disabled) {
	      e.preventDefault();
	      return;
	    }
	
	    if (this.props.onClick) {
	      return this.props.onClick(e);
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        active = _this$props.active,
	        ariaLabel = _this$props['aria-label'],
	        block = _this$props.block,
	        className = _this$props.className,
	        close = _this$props.close,
	        cssModule = _this$props.cssModule,
	        color = _this$props.color,
	        outline = _this$props.outline,
	        size = _this$props.size,
	        Tag = _this$props.tag,
	        innerRef = _this$props.innerRef,
	        attributes = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["active", "aria-label", "block", "className", "close", "cssModule", "color", "outline", "size", "tag", "innerRef"]);
	
	    if (close && typeof attributes.children === 'undefined') {
	      attributes.children = /*#__PURE__*/_react.default.createElement("span", {
	        "aria-hidden": true
	      }, "\xD7");
	    }
	
	    var btnOutlineColor = "btn" + (outline ? '-outline' : '') + "-" + color;
	    var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, {
	      close: close
	    }, close || 'btn', close || btnOutlineColor, size ? "btn-" + size : false, block ? 'btn-block' : false, {
	      active: active,
	      disabled: this.props.disabled
	    }), cssModule);
	
	    if (attributes.href && Tag === 'button') {
	      Tag = 'a';
	    }
	
	    var defaultAriaLabel = close ? 'Close' : null;
	    return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({
	      type: Tag === 'button' && attributes.onClick ? 'button' : undefined
	    }, attributes, {
	      className: classes,
	      ref: innerRef,
	      onClick: this.onClick,
	      "aria-label": ariaLabel || defaultAriaLabel
	    }));
	  };
	
	  return Button;
	}(_react.default.Component);
	
	Button.propTypes = propTypes;
	Button.defaultProps = defaultProps;
	var _default = Button;
	exports.default = _default;

/***/ },
/* 2683 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _Dropdown = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var propTypes = {
	  children: _propTypes.default.node
	};
	
	var ButtonDropdown = function ButtonDropdown(props) {
	  return /*#__PURE__*/_react.default.createElement(_Dropdown.default, (0, _extends2.default)({
	    group: true
	  }, props));
	};
	
	ButtonDropdown.propTypes = propTypes;
	var _default = ButtonDropdown;
	exports.default = _default;

/***/ },
/* 2684 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  'aria-label': _propTypes.default.string,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  role: _propTypes.default.string,
	  size: _propTypes.default.string,
	  vertical: _propTypes.default.bool
	};
	var defaultProps = {
	  tag: 'div',
	  role: 'group'
	};
	
	var ButtonGroup = function ButtonGroup(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      size = props.size,
	      vertical = props.vertical,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "size", "vertical", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, size ? 'btn-group-' + size : false, vertical ? 'btn-group-vertical' : 'btn-group'), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	ButtonGroup.propTypes = propTypes;
	ButtonGroup.defaultProps = defaultProps;
	var _default = ButtonGroup;
	exports.default = _default;

/***/ },
/* 2685 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(20));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _Button = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_1__);
	
	var propTypes = {
	  onClick: _propTypes.default.func,
	  onBlur: _propTypes.default.func,
	  onFocus: _propTypes.default.func,
	  defaultValue: _propTypes.default.bool
	};
	var defaultProps = {
	  defaultValue: false
	};
	
	var ButtonToggle = /*#__PURE__*/function (_React$Component) {
	  (0, _inheritsLoose2.default)(ButtonToggle, _React$Component);
	
	  function ButtonToggle(props) {
	    var _this;
	
	    _this = _React$Component.call(this, props) || this;
	    _this.state = {
	      toggled: props.defaultValue,
	      focus: false
	    };
	    _this.onBlur = _this.onBlur.bind((0, _assertThisInitialized2.default)(_this));
	    _this.onFocus = _this.onFocus.bind((0, _assertThisInitialized2.default)(_this));
	    _this.onClick = _this.onClick.bind((0, _assertThisInitialized2.default)(_this));
	    return _this;
	  }
	
	  var _proto = ButtonToggle.prototype;
	
	  _proto.onBlur = function onBlur(e) {
	    if (this.props.onBlur) {
	      this.props.onBlur(e);
	    }
	
	    this.setState({
	      focus: false
	    });
	  };
	
	  _proto.onFocus = function onFocus(e) {
	    if (this.props.onFocus) {
	      this.props.onFocus(e);
	    }
	
	    this.setState({
	      focus: true
	    });
	  };
	
	  _proto.onClick = function onClick(e) {
	    if (this.props.onClick) {
	      this.props.onClick(e);
	    }
	
	    this.setState(function (_ref) {
	      var toggled = _ref.toggled;
	      return {
	        toggled: !toggled
	      };
	    });
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        className = _this$props.className,
	        attributes = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["className"]);
	    var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, {
	      focus: this.state.focus
	    }), this.props.cssModule);
	    return /*#__PURE__*/_react.default.createElement(_Button.default, (0, _extends2.default)({
	      active: this.state.toggled,
	      onBlur: this.onBlur,
	      onFocus: this.onFocus,
	      onClick: this.onClick,
	      className: classes
	    }, attributes));
	  };
	
	  return ButtonToggle;
	}(_react.default.Component);
	
	ButtonToggle.propTypes = propTypes;
	ButtonToggle.defaultProps = defaultProps;
	var _default = ButtonToggle;
	exports.default = _default;

/***/ },
/* 2686 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  'aria-label': _propTypes.default.string,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  role: _propTypes.default.string
	};
	var defaultProps = {
	  tag: 'div',
	  role: 'toolbar'
	};
	
	var ButtonToolbar = function ButtonToolbar(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'btn-toolbar'), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	ButtonToolbar.propTypes = propTypes;
	ButtonToolbar.defaultProps = defaultProps;
	var _default = ButtonToolbar;
	exports.default = _default;

/***/ },
/* 2687 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  inverse: _propTypes.default.bool,
	  color: _propTypes.default.string,
	  body: _propTypes.default.bool,
	  outline: _propTypes.default.bool,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  innerRef: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string, _propTypes.default.func])
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var Card = function Card(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      color = props.color,
	      body = props.body,
	      inverse = props.inverse,
	      outline = props.outline,
	      Tag = props.tag,
	      innerRef = props.innerRef,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "color", "body", "inverse", "outline", "tag", "innerRef"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'card', inverse ? 'text-white' : false, body ? 'card-body' : false, color ? (outline ? 'border' : 'bg') + "-" + color : false), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes,
	    ref: innerRef
	  }));
	};
	
	Card.propTypes = propTypes;
	Card.defaultProps = defaultProps;
	var _default = Card;
	exports.default = _default;

/***/ },
/* 2688 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  innerRef: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string, _propTypes.default.func])
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var CardBody = function CardBody(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      innerRef = props.innerRef,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "innerRef", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'card-body'), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes,
	    ref: innerRef
	  }));
	};
	
	CardBody.propTypes = propTypes;
	CardBody.defaultProps = defaultProps;
	var _default = CardBody;
	exports.default = _default;

/***/ },
/* 2689 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var CardColumns = function CardColumns(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'card-columns'), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	CardColumns.propTypes = propTypes;
	CardColumns.defaultProps = defaultProps;
	var _default = CardColumns;
	exports.default = _default;

/***/ },
/* 2690 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var CardDeck = function CardDeck(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'card-deck'), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	CardDeck.propTypes = propTypes;
	CardDeck.defaultProps = defaultProps;
	var _default = CardDeck;
	exports.default = _default;

/***/ },
/* 2691 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var CardFooter = function CardFooter(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'card-footer'), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	CardFooter.propTypes = propTypes;
	CardFooter.defaultProps = defaultProps;
	var _default = CardFooter;
	exports.default = _default;

/***/ },
/* 2692 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var CardGroup = function CardGroup(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'card-group'), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	CardGroup.propTypes = propTypes;
	CardGroup.defaultProps = defaultProps;
	var _default = CardGroup;
	exports.default = _default;

/***/ },
/* 2693 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var CardHeader = function CardHeader(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'card-header'), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	CardHeader.propTypes = propTypes;
	CardHeader.defaultProps = defaultProps;
	var _default = CardHeader;
	exports.default = _default;

/***/ },
/* 2694 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  top: _propTypes.default.bool,
	  bottom: _propTypes.default.bool,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'img'
	};
	
	var CardImg = function CardImg(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      top = props.top,
	      bottom = props.bottom,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "top", "bottom", "tag"]);
	  var cardImgClassName = 'card-img';
	
	  if (top) {
	    cardImgClassName = 'card-img-top';
	  }
	
	  if (bottom) {
	    cardImgClassName = 'card-img-bottom';
	  }
	
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, cardImgClassName), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	CardImg.propTypes = propTypes;
	CardImg.defaultProps = defaultProps;
	var _default = CardImg;
	exports.default = _default;

/***/ },
/* 2695 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var CardImgOverlay = function CardImgOverlay(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'card-img-overlay'), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	CardImgOverlay.propTypes = propTypes;
	CardImgOverlay.defaultProps = defaultProps;
	var _default = CardImgOverlay;
	exports.default = _default;

/***/ },
/* 2696 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  innerRef: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func, _propTypes.default.string]),
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'a'
	};
	
	var CardLink = function CardLink(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      innerRef = props.innerRef,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag", "innerRef"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'card-link'), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    ref: innerRef,
	    className: classes
	  }));
	};
	
	CardLink.propTypes = propTypes;
	CardLink.defaultProps = defaultProps;
	var _default = CardLink;
	exports.default = _default;

/***/ },
/* 2697 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var CardSubtitle = function CardSubtitle(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'card-subtitle'), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	CardSubtitle.propTypes = propTypes;
	CardSubtitle.defaultProps = defaultProps;
	var _default = CardSubtitle;
	exports.default = _default;

/***/ },
/* 2698 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'p'
	};
	
	var CardText = function CardText(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'card-text'), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	CardText.propTypes = propTypes;
	CardText.defaultProps = defaultProps;
	var _default = CardText;
	exports.default = _default;

/***/ },
/* 2699 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var CardTitle = function CardTitle(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'card-title'), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	CardTitle.propTypes = propTypes;
	CardTitle.defaultProps = defaultProps;
	var _default = CardTitle;
	exports.default = _default;

/***/ },
/* 2700 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(20));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _CarouselItem = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_1__);
	
	var SWIPE_THRESHOLD = 40;
	
	var Carousel = /*#__PURE__*/function (_React$Component) {
	  (0, _inheritsLoose2.default)(Carousel, _React$Component);
	
	  function Carousel(props) {
	    var _this;
	
	    _this = _React$Component.call(this, props) || this;
	    _this.handleKeyPress = _this.handleKeyPress.bind((0, _assertThisInitialized2.default)(_this));
	    _this.renderItems = _this.renderItems.bind((0, _assertThisInitialized2.default)(_this));
	    _this.hoverStart = _this.hoverStart.bind((0, _assertThisInitialized2.default)(_this));
	    _this.hoverEnd = _this.hoverEnd.bind((0, _assertThisInitialized2.default)(_this));
	    _this.handleTouchStart = _this.handleTouchStart.bind((0, _assertThisInitialized2.default)(_this));
	    _this.handleTouchEnd = _this.handleTouchEnd.bind((0, _assertThisInitialized2.default)(_this));
	    _this.touchStartX = 0;
	    _this.touchStartY = 0;
	    _this.state = {
	      activeIndex: _this.props.activeIndex,
	      direction: 'right',
	      indicatorClicked: false
	    };
	    return _this;
	  }
	
	  var _proto = Carousel.prototype;
	
	  _proto.getChildContext = function getChildContext() {
	    return {
	      direction: this.state.direction
	    };
	  };
	
	  _proto.componentDidMount = function componentDidMount() {
	    // Set up the cycle
	    if (this.props.ride === 'carousel') {
	      this.setInterval();
	    } // TODO: move this to the specific carousel like bootstrap. Currently it will trigger ALL carousels on the page.
	
	
	    document.addEventListener('keyup', this.handleKeyPress);
	  };
	
	  Carousel.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
	    var newState = null;
	    var activeIndex = prevState.activeIndex,
	        direction = prevState.direction,
	        indicatorClicked = prevState.indicatorClicked;
	
	    if (nextProps.activeIndex !== activeIndex) {
	      // Calculate the direction to turn
	      if (nextProps.activeIndex === activeIndex + 1) {
	        direction = 'right';
	      } else if (nextProps.activeIndex === activeIndex - 1) {
	        direction = 'left';
	      } else if (nextProps.activeIndex < activeIndex) {
	        direction = indicatorClicked ? 'left' : 'right';
	      } else if (nextProps.activeIndex !== activeIndex) {
	        direction = indicatorClicked ? 'right' : 'left';
	      }
	
	      newState = {
	        activeIndex: nextProps.activeIndex,
	        direction: direction,
	        indicatorClicked: false
	      };
	    }
	
	    return newState;
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
	    if (prevState.activeIndex === this.state.activeIndex) return;
	    this.setInterval(this.props);
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.clearInterval();
	    document.removeEventListener('keyup', this.handleKeyPress);
	  };
	
	  _proto.setInterval = function (_setInterval) {
	    function setInterval() {
	      return _setInterval.apply(this, arguments);
	    }
	
	    setInterval.toString = function () {
	      return _setInterval.toString();
	    };
	
	    return setInterval;
	  }(function (props) {
	    if (props === void 0) {
	      props = this.props;
	    }
	
	    // make sure not to have multiple intervals going...
	    this.clearInterval();
	
	    if (props.interval) {
	      this.cycleInterval = setInterval(function () {
	        props.next();
	      }, parseInt(props.interval, 10));
	    }
	  });
	
	  _proto.clearInterval = function (_clearInterval) {
	    function clearInterval() {
	      return _clearInterval.apply(this, arguments);
	    }
	
	    clearInterval.toString = function () {
	      return _clearInterval.toString();
	    };
	
	    return clearInterval;
	  }(function () {
	    clearInterval(this.cycleInterval);
	  });
	
	  _proto.hoverStart = function hoverStart() {
	    if (this.props.pause === 'hover') {
	      this.clearInterval();
	    }
	
	    if (this.props.mouseEnter) {
	      var _this$props;
	
	      (_this$props = this.props).mouseEnter.apply(_this$props, arguments);
	    }
	  };
	
	  _proto.hoverEnd = function hoverEnd() {
	    if (this.props.pause === 'hover') {
	      this.setInterval();
	    }
	
	    if (this.props.mouseLeave) {
	      var _this$props2;
	
	      (_this$props2 = this.props).mouseLeave.apply(_this$props2, arguments);
	    }
	  };
	
	  _proto.handleKeyPress = function handleKeyPress(evt) {
	    if (this.props.keyboard) {
	      if (evt.keyCode === 37) {
	        this.props.previous();
	      } else if (evt.keyCode === 39) {
	        this.props.next();
	      }
	    }
	  };
	
	  _proto.handleTouchStart = function handleTouchStart(e) {
	    if (!this.props.enableTouch) {
	      return;
	    }
	
	    this.touchStartX = e.changedTouches[0].screenX;
	    this.touchStartY = e.changedTouches[0].screenY;
	  };
	
	  _proto.handleTouchEnd = function handleTouchEnd(e) {
	    if (!this.props.enableTouch) {
	      return;
	    }
	
	    var currentX = e.changedTouches[0].screenX;
	    var currentY = e.changedTouches[0].screenY;
	    var diffX = Math.abs(this.touchStartX - currentX);
	    var diffY = Math.abs(this.touchStartY - currentY); // Don't swipe if Y-movement is bigger than X-movement
	
	    if (diffX < diffY) {
	      return;
	    }
	
	    if (diffX < SWIPE_THRESHOLD) {
	      return;
	    }
	
	    if (currentX < this.touchStartX) {
	      this.props.next();
	    } else {
	      this.props.previous();
	    }
	  };
	
	  _proto.renderItems = function renderItems(carouselItems, className) {
	    var _this2 = this;
	
	    var slide = this.props.slide;
	    return /*#__PURE__*/_react.default.createElement("div", {
	      className: className
	    }, carouselItems.map(function (item, index) {
	      var isIn = index === _this2.state.activeIndex;
	      return /*#__PURE__*/_react.default.cloneElement(item, {
	        in: isIn,
	        slide: slide
	      });
	    }));
	  };
	
	  _proto.render = function render() {
	    var _this3 = this;
	
	    var _this$props3 = this.props,
	        cssModule = _this$props3.cssModule,
	        slide = _this$props3.slide,
	        className = _this$props3.className;
	    var outerClasses = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'carousel', slide && 'slide'), cssModule);
	    var innerClasses = (0, _utils.mapToCssModules)((0, _classnames.default)('carousel-inner'), cssModule); // filter out booleans, null, or undefined
	
	    var children = this.props.children.filter(function (child) {
	      return child !== null && child !== undefined && typeof child !== 'boolean';
	    });
	    var slidesOnly = children.every(function (child) {
	      return child.type === _CarouselItem.default;
	    }); // Rendering only slides
	
	    if (slidesOnly) {
	      return /*#__PURE__*/_react.default.createElement("div", {
	        className: outerClasses,
	        onMouseEnter: this.hoverStart,
	        onMouseLeave: this.hoverEnd
	      }, this.renderItems(children, innerClasses));
	    } // Rendering slides and controls
	
	
	    if (children[0] instanceof Array) {
	      var _carouselItems = children[0];
	      var _controlLeft = children[1];
	      var _controlRight = children[2];
	      return /*#__PURE__*/_react.default.createElement("div", {
	        className: outerClasses,
	        onMouseEnter: this.hoverStart,
	        onMouseLeave: this.hoverEnd
	      }, this.renderItems(_carouselItems, innerClasses), _controlLeft, _controlRight);
	    } // Rendering indicators, slides and controls
	
	
	    var indicators = children[0];
	
	    var wrappedOnClick = function wrappedOnClick(e) {
	      if (typeof indicators.props.onClickHandler === 'function') {
	        _this3.setState({
	          indicatorClicked: true
	        }, function () {
	          return indicators.props.onClickHandler(e);
	        });
	      }
	    };
	
	    var wrappedIndicators = /*#__PURE__*/_react.default.cloneElement(indicators, {
	      onClickHandler: wrappedOnClick
	    });
	
	    var carouselItems = children[1];
	    var controlLeft = children[2];
	    var controlRight = children[3];
	    return /*#__PURE__*/_react.default.createElement("div", {
	      className: outerClasses,
	      onMouseEnter: this.hoverStart,
	      onMouseLeave: this.hoverEnd,
	      onTouchStart: this.handleTouchStart,
	      onTouchEnd: this.handleTouchEnd
	    }, wrappedIndicators, this.renderItems(carouselItems, innerClasses), controlLeft, controlRight);
	  };
	
	  return Carousel;
	}(_react.default.Component);
	
	Carousel.propTypes = {
	  // the current active slide of the carousel
	  activeIndex: _propTypes.default.number,
	  // a function which should advance the carousel to the next slide (via activeIndex)
	  next: _propTypes.default.func.isRequired,
	  // a function which should advance the carousel to the previous slide (via activeIndex)
	  previous: _propTypes.default.func.isRequired,
	  // controls if the left and right arrow keys should control the carousel
	  keyboard: _propTypes.default.bool,
	
	  /* If set to "hover", pauses the cycling of the carousel on mouseenter and resumes the cycling of the carousel on
	   * mouseleave. If set to false, hovering over the carousel won't pause it. (default: "hover")
	   */
	  pause: _propTypes.default.oneOf(['hover', false]),
	  // Autoplays the carousel after the user manually cycles the first item. If "carousel", autoplays the carousel on load.
	  // This is how bootstrap defines it... I would prefer a bool named autoplay or something...
	  ride: _propTypes.default.oneOf(['carousel']),
	  // the interval at which the carousel automatically cycles (default: 5000)
	  // eslint-disable-next-line react/no-unused-prop-types
	  interval: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string, _propTypes.default.bool]),
	  children: _propTypes.default.array,
	  // called when the mouse enters the Carousel
	  mouseEnter: _propTypes.default.func,
	  // called when the mouse exits the Carousel
	  mouseLeave: _propTypes.default.func,
	  // controls whether the slide animation on the Carousel works or not
	  slide: _propTypes.default.bool,
	  cssModule: _propTypes.default.object,
	  className: _propTypes.default.string,
	  enableTouch: _propTypes.default.bool
	};
	Carousel.defaultProps = {
	  interval: 5000,
	  pause: 'hover',
	  keyboard: true,
	  slide: true,
	  enableTouch: true
	};
	Carousel.childContextTypes = {
	  direction: _propTypes.default.string
	};
	var _default = Carousel;
	exports.default = _default;

/***/ },
/* 2701 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	var CarouselCaption = function CarouselCaption(props) {
	  var captionHeader = props.captionHeader,
	      captionText = props.captionText,
	      cssModule = props.cssModule,
	      className = props.className;
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'carousel-caption', 'd-none', 'd-md-block'), cssModule);
	  return /*#__PURE__*/_react.default.createElement("div", {
	    className: classes
	  }, /*#__PURE__*/_react.default.createElement("h3", null, captionHeader), /*#__PURE__*/_react.default.createElement("p", null, captionText));
	};
	
	CarouselCaption.propTypes = {
	  captionHeader: _propTypes.default.node,
	  captionText: _propTypes.default.node.isRequired,
	  cssModule: _propTypes.default.object,
	  className: _propTypes.default.string
	};
	var _default = CarouselCaption;
	exports.default = _default;

/***/ },
/* 2702 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	var CarouselControl = function CarouselControl(props) {
	  var direction = props.direction,
	      onClickHandler = props.onClickHandler,
	      cssModule = props.cssModule,
	      directionText = props.directionText,
	      className = props.className;
	  var anchorClasses = (0, _utils.mapToCssModules)((0, _classnames.default)(className, "carousel-control-" + direction), cssModule);
	  var iconClasses = (0, _utils.mapToCssModules)((0, _classnames.default)("carousel-control-" + direction + "-icon"), cssModule);
	  var screenReaderClasses = (0, _utils.mapToCssModules)((0, _classnames.default)('sr-only'), cssModule);
	  return (
	    /*#__PURE__*/
	    // We need to disable this linting rule to use an `<a>` instead of
	    // `<button>` because that's what the Bootstrap examples require:
	    // https://getbootstrap.com/docs/4.5/components/carousel/#with-controls
	    // eslint-disable-next-line jsx-a11y/anchor-is-valid
	    _react.default.createElement("a", {
	      className: anchorClasses,
	      style: {
	        cursor: "pointer"
	      },
	      role: "button",
	      tabIndex: "0",
	      onClick: function onClick(e) {
	        e.preventDefault();
	        onClickHandler();
	      }
	    }, /*#__PURE__*/_react.default.createElement("span", {
	      className: iconClasses,
	      "aria-hidden": "true"
	    }), /*#__PURE__*/_react.default.createElement("span", {
	      className: screenReaderClasses
	    }, directionText || direction))
	  );
	};
	
	CarouselControl.propTypes = {
	  direction: _propTypes.default.oneOf(['prev', 'next']).isRequired,
	  onClickHandler: _propTypes.default.func.isRequired,
	  cssModule: _propTypes.default.object,
	  directionText: _propTypes.default.string,
	  className: _propTypes.default.string
	};
	var _default = CarouselControl;
	exports.default = _default;

/***/ },
/* 2703 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	var CarouselIndicators = function CarouselIndicators(props) {
	  var items = props.items,
	      activeIndex = props.activeIndex,
	      cssModule = props.cssModule,
	      onClickHandler = props.onClickHandler,
	      className = props.className;
	  var listClasses = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'carousel-indicators'), cssModule);
	  var indicators = items.map(function (item, idx) {
	    var indicatorClasses = (0, _utils.mapToCssModules)((0, _classnames.default)({
	      active: activeIndex === idx
	    }), cssModule);
	    return /*#__PURE__*/_react.default.createElement("li", {
	      key: "" + (item.key || Object.values(item).join('')),
	      onClick: function onClick(e) {
	        e.preventDefault();
	        onClickHandler(idx);
	      },
	      className: indicatorClasses
	    });
	  });
	  return /*#__PURE__*/_react.default.createElement("ol", {
	    className: listClasses
	  }, indicators);
	};
	
	CarouselIndicators.propTypes = {
	  items: _propTypes.default.array.isRequired,
	  activeIndex: _propTypes.default.number.isRequired,
	  cssModule: _propTypes.default.object,
	  onClickHandler: _propTypes.default.func.isRequired,
	  className: _propTypes.default.string
	};
	var _default = CarouselIndicators;
	exports.default = _default;

/***/ },
/* 2704 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(27));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(20));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _reactTransitionGroup = __webpack_require__(126);
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	var CarouselItem = /*#__PURE__*/function (_React$Component) {
	  (0, _inheritsLoose2.default)(CarouselItem, _React$Component);
	
	  function CarouselItem(props) {
	    var _this;
	
	    _this = _React$Component.call(this, props) || this;
	    _this.state = {
	      startAnimation: false
	    };
	    _this.onEnter = _this.onEnter.bind((0, _assertThisInitialized2.default)(_this));
	    _this.onEntering = _this.onEntering.bind((0, _assertThisInitialized2.default)(_this));
	    _this.onExit = _this.onExit.bind((0, _assertThisInitialized2.default)(_this));
	    _this.onExiting = _this.onExiting.bind((0, _assertThisInitialized2.default)(_this));
	    _this.onExited = _this.onExited.bind((0, _assertThisInitialized2.default)(_this));
	    return _this;
	  }
	
	  var _proto = CarouselItem.prototype;
	
	  _proto.onEnter = function onEnter(node, isAppearing) {
	    this.setState({
	      startAnimation: false
	    });
	    this.props.onEnter(node, isAppearing);
	  };
	
	  _proto.onEntering = function onEntering(node, isAppearing) {
	    // getting this variable triggers a reflow
	    var offsetHeight = node.offsetHeight;
	    this.setState({
	      startAnimation: true
	    });
	    this.props.onEntering(node, isAppearing);
	    return offsetHeight;
	  };
	
	  _proto.onExit = function onExit(node) {
	    this.setState({
	      startAnimation: false
	    });
	    this.props.onExit(node);
	  };
	
	  _proto.onExiting = function onExiting(node) {
	    this.setState({
	      startAnimation: true
	    });
	    node.dispatchEvent(new CustomEvent('slide.bs.carousel'));
	    this.props.onExiting(node);
	  };
	
	  _proto.onExited = function onExited(node) {
	    node.dispatchEvent(new CustomEvent('slid.bs.carousel'));
	    this.props.onExited(node);
	  };
	
	  _proto.render = function render() {
	    var _this2 = this;
	
	    var _this$props = this.props,
	        isIn = _this$props.in,
	        children = _this$props.children,
	        cssModule = _this$props.cssModule,
	        slide = _this$props.slide,
	        Tag = _this$props.tag,
	        className = _this$props.className,
	        transitionProps = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["in", "children", "cssModule", "slide", "tag", "className"]);
	    return /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.Transition, (0, _extends2.default)({}, transitionProps, {
	      enter: slide,
	      exit: slide,
	      in: isIn,
	      onEnter: this.onEnter,
	      onEntering: this.onEntering,
	      onExit: this.onExit,
	      onExiting: this.onExiting,
	      onExited: this.onExited
	    }), function (status) {
	      var direction = _this2.context.direction;
	      var isActive = status === _utils.TransitionStatuses.ENTERED || status === _utils.TransitionStatuses.EXITING;
	      var directionClassName = (status === _utils.TransitionStatuses.ENTERING || status === _utils.TransitionStatuses.EXITING) && _this2.state.startAnimation && (direction === 'right' ? 'carousel-item-left' : 'carousel-item-right');
	      var orderClassName = status === _utils.TransitionStatuses.ENTERING && (direction === 'right' ? 'carousel-item-next' : 'carousel-item-prev');
	      var itemClasses = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'carousel-item', isActive && 'active', directionClassName, orderClassName), cssModule);
	      return /*#__PURE__*/_react.default.createElement(Tag, {
	        className: itemClasses
	      }, children);
	    });
	  };
	
	  return CarouselItem;
	}(_react.default.Component);
	
	CarouselItem.propTypes = _objectSpread(_objectSpread({}, _reactTransitionGroup.Transition.propTypes), {}, {
	  tag: _utils.tagPropType,
	  in: _propTypes.default.bool,
	  cssModule: _propTypes.default.object,
	  children: _propTypes.default.node,
	  slide: _propTypes.default.bool,
	  className: _propTypes.default.string
	});
	CarouselItem.defaultProps = _objectSpread(_objectSpread({}, _reactTransitionGroup.Transition.defaultProps), {}, {
	  tag: 'div',
	  timeout: _utils.TransitionTimeouts.Carousel,
	  slide: true
	});
	CarouselItem.contextTypes = {
	  direction: _propTypes.default.string
	};
	var _default = CarouselItem;
	exports.default = _default;

/***/ },
/* 2705 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	var colWidths = ['xs', 'sm', 'md', 'lg', 'xl'];
	
	var stringOrNumberProp = _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]);
	
	var columnProps = _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.number, _propTypes.default.string, _propTypes.default.shape({
	  size: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.number, _propTypes.default.string]),
	  order: stringOrNumberProp,
	  offset: stringOrNumberProp
	})]);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  xs: columnProps,
	  sm: columnProps,
	  md: columnProps,
	  lg: columnProps,
	  xl: columnProps,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  widths: _propTypes.default.array
	};
	var defaultProps = {
	  tag: 'div',
	  widths: colWidths
	};
	
	var getColumnSizeClass = function getColumnSizeClass(isXs, colWidth, colSize) {
	  if (colSize === true || colSize === '') {
	    return isXs ? 'col' : "col-" + colWidth;
	  } else if (colSize === 'auto') {
	    return isXs ? 'col-auto' : "col-" + colWidth + "-auto";
	  }
	
	  return isXs ? "col-" + colSize : "col-" + colWidth + "-" + colSize;
	};
	
	var Col = function Col(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      widths = props.widths,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "widths", "tag"]);
	  var colClasses = [];
	  widths.forEach(function (colWidth, i) {
	    var columnProp = props[colWidth];
	    delete attributes[colWidth];
	
	    if (!columnProp && columnProp !== '') {
	      return;
	    }
	
	    var isXs = !i;
	
	    if ((0, _utils.isObject)(columnProp)) {
	      var _classNames;
	
	      var colSizeInterfix = isXs ? '-' : "-" + colWidth + "-";
	      var colClass = getColumnSizeClass(isXs, colWidth, columnProp.size);
	      colClasses.push((0, _utils.mapToCssModules)((0, _classnames.default)((_classNames = {}, _classNames[colClass] = columnProp.size || columnProp.size === '', _classNames["order" + colSizeInterfix + columnProp.order] = columnProp.order || columnProp.order === 0, _classNames["offset" + colSizeInterfix + columnProp.offset] = columnProp.offset || columnProp.offset === 0, _classNames)), cssModule));
	    } else {
	      var _colClass = getColumnSizeClass(isXs, colWidth, columnProp);
	
	      colClasses.push(_colClass);
	    }
	  });
	
	  if (!colClasses.length) {
	    colClasses.push('col');
	  }
	
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, colClasses), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	Col.propTypes = propTypes;
	Col.defaultProps = defaultProps;
	var _default = Col;
	exports.default = _default;

/***/ },
/* 2706 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(20));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(27));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _reactTransitionGroup = __webpack_require__(126);
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _transitionStatusToCl;
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	var propTypes = _objectSpread(_objectSpread({}, _reactTransitionGroup.Transition.propTypes), {}, {
	  isOpen: _propTypes.default.bool,
	  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]),
	  tag: _utils.tagPropType,
	  className: _propTypes.default.node,
	  navbar: _propTypes.default.bool,
	  cssModule: _propTypes.default.object,
	  innerRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.string, _propTypes.default.object])
	});
	
	var defaultProps = _objectSpread(_objectSpread({}, _reactTransitionGroup.Transition.defaultProps), {}, {
	  isOpen: false,
	  appear: false,
	  enter: true,
	  exit: true,
	  tag: 'div',
	  timeout: _utils.TransitionTimeouts.Collapse
	});
	
	var transitionStatusToClassHash = (_transitionStatusToCl = {}, _transitionStatusToCl[_utils.TransitionStatuses.ENTERING] = 'collapsing', _transitionStatusToCl[_utils.TransitionStatuses.ENTERED] = 'collapse show', _transitionStatusToCl[_utils.TransitionStatuses.EXITING] = 'collapsing', _transitionStatusToCl[_utils.TransitionStatuses.EXITED] = 'collapse', _transitionStatusToCl);
	
	function getTransitionClass(status) {
	  return transitionStatusToClassHash[status] || 'collapse';
	}
	
	function getHeight(node) {
	  return node.scrollHeight;
	}
	
	var Collapse = /*#__PURE__*/function (_Component) {
	  (0, _inheritsLoose2.default)(Collapse, _Component);
	
	  function Collapse(props) {
	    var _this;
	
	    _this = _Component.call(this, props) || this;
	    _this.state = {
	      height: null
	    };
	    ['onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited'].forEach(function (name) {
	      _this[name] = _this[name].bind((0, _assertThisInitialized2.default)(_this));
	    });
	    return _this;
	  }
	
	  var _proto = Collapse.prototype;
	
	  _proto.onEntering = function onEntering(node, isAppearing) {
	    this.setState({
	      height: getHeight(node)
	    });
	    this.props.onEntering(node, isAppearing);
	  };
	
	  _proto.onEntered = function onEntered(node, isAppearing) {
	    this.setState({
	      height: null
	    });
	    this.props.onEntered(node, isAppearing);
	  };
	
	  _proto.onExit = function onExit(node) {
	    this.setState({
	      height: getHeight(node)
	    });
	    this.props.onExit(node);
	  };
	
	  _proto.onExiting = function onExiting(node) {
	    // getting this variable triggers a reflow
	    var _unused = node.offsetHeight; // eslint-disable-line no-unused-vars
	
	    this.setState({
	      height: 0
	    });
	    this.props.onExiting(node);
	  };
	
	  _proto.onExited = function onExited(node) {
	    this.setState({
	      height: null
	    });
	    this.props.onExited(node);
	  };
	
	  _proto.render = function render() {
	    var _this2 = this;
	
	    var _this$props = this.props,
	        Tag = _this$props.tag,
	        isOpen = _this$props.isOpen,
	        className = _this$props.className,
	        navbar = _this$props.navbar,
	        cssModule = _this$props.cssModule,
	        children = _this$props.children,
	        innerRef = _this$props.innerRef,
	        otherProps = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["tag", "isOpen", "className", "navbar", "cssModule", "children", "innerRef"]);
	    var height = this.state.height;
	    var transitionProps = (0, _utils.pick)(otherProps, _utils.TransitionPropTypeKeys);
	    var childProps = (0, _utils.omit)(otherProps, _utils.TransitionPropTypeKeys);
	    return /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.Transition, (0, _extends2.default)({}, transitionProps, {
	      in: isOpen,
	      onEntering: this.onEntering,
	      onEntered: this.onEntered,
	      onExit: this.onExit,
	      onExiting: this.onExiting,
	      onExited: this.onExited
	    }), function (status) {
	      var collapseClass = getTransitionClass(status);
	      var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, collapseClass, navbar && 'navbar-collapse'), cssModule);
	      var style = height === null ? null : {
	        height: height
	      };
	      return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, childProps, {
	        style: _objectSpread(_objectSpread({}, childProps.style), style),
	        className: classes,
	        ref: _this2.props.innerRef
	      }), children);
	    });
	  };
	
	  return Collapse;
	}(_react.Component);
	
	Collapse.propTypes = propTypes;
	Collapse.defaultProps = defaultProps;
	var _default = Collapse;
	exports.default = _default;

/***/ },
/* 2707 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  fluid: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var Container = function Container(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      fluid = props.fluid,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "fluid", "tag"]);
	  var containerClass = 'container';
	
	  if (fluid === true) {
	    containerClass = 'container-fluid';
	  } else if (fluid) {
	    containerClass = "container-" + fluid;
	  }
	
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, containerClass), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	Container.propTypes = propTypes;
	Container.defaultProps = defaultProps;
	var _default = Container;
	exports.default = _default;

/***/ },
/* 2708 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(20));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	var propTypes = {
	  className: _propTypes.default.string,
	  id: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,
	  label: _propTypes.default.node,
	  valid: _propTypes.default.bool,
	  invalid: _propTypes.default.bool,
	  bsSize: _propTypes.default.string,
	  htmlFor: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  onChange: _propTypes.default.func,
	  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.array, _propTypes.default.func]),
	  innerRef: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string, _propTypes.default.func])
	};
	
	var CustomFileInput = /*#__PURE__*/function (_React$Component) {
	  (0, _inheritsLoose2.default)(CustomFileInput, _React$Component);
	
	  function CustomFileInput(props) {
	    var _this;
	
	    _this = _React$Component.call(this, props) || this;
	    _this.state = {
	      files: null
	    };
	    _this.onChange = _this.onChange.bind((0, _assertThisInitialized2.default)(_this));
	    return _this;
	  }
	
	  var _proto = CustomFileInput.prototype;
	
	  _proto.onChange = function onChange(e) {
	    var input = e.target;
	    var onChange = this.props.onChange;
	    var files = this.getSelectedFiles(input);
	
	    if (typeof onChange === "function") {
	      onChange.apply(void 0, arguments);
	    }
	
	    this.setState({
	      files: files
	    });
	  };
	
	  _proto.getSelectedFiles = function getSelectedFiles(input) {
	    var multiple = this.props.multiple;
	
	    if (multiple && input.files) {
	      var files = [].slice.call(input.files);
	      return files.map(function (file) {
	        return file.name;
	      }).join(", ");
	    }
	
	    if (input.value.indexOf("fakepath") !== -1) {
	      var parts = input.value.split("\\");
	      return parts[parts.length - 1];
	    }
	
	    return input.value;
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        className = _this$props.className,
	        label = _this$props.label,
	        valid = _this$props.valid,
	        invalid = _this$props.invalid,
	        cssModule = _this$props.cssModule,
	        children = _this$props.children,
	        bsSize = _this$props.bsSize,
	        innerRef = _this$props.innerRef,
	        htmlFor = _this$props.htmlFor,
	        type = _this$props.type,
	        onChange = _this$props.onChange,
	        dataBrowse = _this$props.dataBrowse,
	        hidden = _this$props.hidden,
	        attributes = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["className", "label", "valid", "invalid", "cssModule", "children", "bsSize", "innerRef", "htmlFor", "type", "onChange", "dataBrowse", "hidden"]);
	    var customClass = (0, _utils.mapToCssModules)((0, _classnames.default)(className, "custom-file"), cssModule);
	    var validationClassNames = (0, _utils.mapToCssModules)((0, _classnames.default)(invalid && "is-invalid", valid && "is-valid"), cssModule);
	    var labelHtmlFor = htmlFor || attributes.id;
	    var files = this.state.files;
	    return /*#__PURE__*/_react.default.createElement("div", {
	      className: customClass,
	      hidden: hidden || false
	    }, /*#__PURE__*/_react.default.createElement("input", (0, _extends2.default)({
	      type: "file"
	    }, attributes, {
	      ref: innerRef,
	      "aria-invalid": invalid,
	      className: (0, _classnames.default)(validationClassNames, (0, _utils.mapToCssModules)("custom-file-input", cssModule)),
	      onChange: this.onChange
	    })), /*#__PURE__*/_react.default.createElement("label", {
	      className: (0, _utils.mapToCssModules)("custom-file-label", cssModule),
	      htmlFor: labelHtmlFor,
	      "data-browse": dataBrowse
	    }, files || label || "Choose file"), children);
	  };
	
	  return CustomFileInput;
	}(_react.default.Component);
	
	CustomFileInput.propTypes = propTypes;
	var _default = CustomFileInput;
	exports.default = _default;

/***/ },
/* 2709 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _CustomFileInput = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_1__));
	
	var propTypes = {
	  className: _propTypes.default.string,
	  id: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,
	  type: _propTypes.default.string.isRequired,
	  label: _propTypes.default.node,
	  inline: _propTypes.default.bool,
	  valid: _propTypes.default.bool,
	  invalid: _propTypes.default.bool,
	  bsSize: _propTypes.default.string,
	  htmlFor: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.array, _propTypes.default.func]),
	  innerRef: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string, _propTypes.default.func])
	};
	
	function CustomInput(props) {
	  var className = props.className,
	      label = props.label,
	      inline = props.inline,
	      valid = props.valid,
	      invalid = props.invalid,
	      cssModule = props.cssModule,
	      children = props.children,
	      bsSize = props.bsSize,
	      innerRef = props.innerRef,
	      htmlFor = props.htmlFor,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "label", "inline", "valid", "invalid", "cssModule", "children", "bsSize", "innerRef", "htmlFor"]);
	  var type = attributes.type;
	  var customClass = (0, _utils.mapToCssModules)((0, _classnames.default)(className, "custom-" + type, bsSize ? "custom-" + type + "-" + bsSize : false), cssModule);
	  var validationClassNames = (0, _utils.mapToCssModules)((0, _classnames.default)(invalid && "is-invalid", valid && "is-valid"), cssModule);
	  var labelHtmlFor = htmlFor || attributes.id;
	
	  if (type === "select") {
	    var _type = attributes.type,
	        _rest = (0, _objectWithoutPropertiesLoose2.default)(attributes, ["type"]);
	
	    return /*#__PURE__*/_react.default.createElement("select", (0, _extends2.default)({}, _rest, {
	      ref: innerRef,
	      className: (0, _classnames.default)(validationClassNames, customClass),
	      "aria-invalid": invalid
	    }), children);
	  }
	
	  if (type === "file") {
	    return /*#__PURE__*/_react.default.createElement(_CustomFileInput.default, props);
	  }
	
	  if (type !== "checkbox" && type !== "radio" && type !== "switch") {
	    return /*#__PURE__*/_react.default.createElement("input", (0, _extends2.default)({}, attributes, {
	      ref: innerRef,
	      "aria-invalid": invalid,
	      className: (0, _classnames.default)(validationClassNames, customClass)
	    }));
	  }
	
	  var wrapperClasses = (0, _classnames.default)(customClass, (0, _utils.mapToCssModules)((0, _classnames.default)("custom-control", {
	    "custom-control-inline": inline
	  }), cssModule));
	  var hidden = attributes.hidden,
	      rest = (0, _objectWithoutPropertiesLoose2.default)(attributes, ["hidden"]);
	  return /*#__PURE__*/_react.default.createElement("div", {
	    className: wrapperClasses,
	    hidden: hidden || false
	  }, /*#__PURE__*/_react.default.createElement("input", (0, _extends2.default)({}, rest, {
	    type: type === "switch" ? "checkbox" : type,
	    ref: innerRef,
	    "aria-invalid": invalid,
	    className: (0, _classnames.default)(validationClassNames, (0, _utils.mapToCssModules)("custom-control-input", cssModule))
	  })), /*#__PURE__*/_react.default.createElement("label", {
	    className: (0, _utils.mapToCssModules)("custom-control-label", cssModule),
	    htmlFor: labelHtmlFor
	  }, label), children);
	}
	
	CustomInput.propTypes = propTypes;
	var _default = CustomInput;
	exports.default = _default;

/***/ },
/* 2710 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(20));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _reactPopper = __webpack_require__(75);
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _DropdownContext = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _utils = __webpack_require__(__webpack_module_template_argument_1__);
	
	/* eslint react/no-find-dom-node: 0 */
	// https://github.com/yannickcr/eslint-plugin-react/blob/master/docs/rules/no-find-dom-node.md
	var propTypes = {
	  a11y: _propTypes.default.bool,
	  disabled: _propTypes.default.bool,
	  direction: _propTypes.default.oneOf(['up', 'down', 'left', 'right']),
	  group: _propTypes.default.bool,
	  isOpen: _propTypes.default.bool,
	  nav: _propTypes.default.bool,
	  active: _propTypes.default.bool,
	  addonType: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.oneOf(['prepend', 'append'])]),
	  size: _propTypes.default.string,
	  tag: _utils.tagPropType,
	  toggle: _propTypes.default.func,
	  children: _propTypes.default.node,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  inNavbar: _propTypes.default.bool,
	  setActiveFromChild: _propTypes.default.bool,
	  menuRole: _propTypes.default.oneOf(['listbox', 'menu'])
	};
	var defaultProps = {
	  a11y: true,
	  isOpen: false,
	  direction: 'down',
	  nav: false,
	  active: false,
	  addonType: false,
	  inNavbar: false,
	  setActiveFromChild: false
	};
	var preventDefaultKeys = [_utils.keyCodes.space, _utils.keyCodes.enter, _utils.keyCodes.up, _utils.keyCodes.down, _utils.keyCodes.end, _utils.keyCodes.home];
	
	var Dropdown = /*#__PURE__*/function (_React$Component) {
	  (0, _inheritsLoose2.default)(Dropdown, _React$Component);
	
	  function Dropdown(props) {
	    var _this;
	
	    _this = _React$Component.call(this, props) || this;
	    _this.addEvents = _this.addEvents.bind((0, _assertThisInitialized2.default)(_this));
	    _this.handleDocumentClick = _this.handleDocumentClick.bind((0, _assertThisInitialized2.default)(_this));
	    _this.handleKeyDown = _this.handleKeyDown.bind((0, _assertThisInitialized2.default)(_this));
	    _this.removeEvents = _this.removeEvents.bind((0, _assertThisInitialized2.default)(_this));
	    _this.toggle = _this.toggle.bind((0, _assertThisInitialized2.default)(_this));
	    _this.handleMenuRef = _this.handleMenuRef.bind((0, _assertThisInitialized2.default)(_this));
	    _this.containerRef = /*#__PURE__*/_react.default.createRef();
	    _this.menuRef = /*#__PURE__*/_react.default.createRef();
	    return _this;
	  }
	
	  var _proto = Dropdown.prototype;
	
	  _proto.handleMenuRef = function handleMenuRef(menuRef) {
	    this.menuRef.current = menuRef;
	  };
	
	  _proto.getContextValue = function getContextValue() {
	    return {
	      toggle: this.toggle,
	      isOpen: this.props.isOpen,
	      direction: this.props.direction === 'down' && this.props.dropup ? 'up' : this.props.direction,
	      inNavbar: this.props.inNavbar,
	      disabled: this.props.disabled,
	      // Callback that should be called by DropdownMenu to provide a ref to
	      // a HTML tag that's used for the DropdownMenu
	      onMenuRef: this.handleMenuRef,
	      menuRole: this.props.menuRole
	    };
	  };
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.handleProps();
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (this.props.isOpen !== prevProps.isOpen) {
	      this.handleProps();
	    }
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.removeEvents();
	  };
	
	  _proto.getContainer = function getContainer() {
	    return this.containerRef.current;
	  };
	
	  _proto.getMenu = function getMenu() {
	    return this.menuRef.current;
	  };
	
	  _proto.getMenuCtrl = function getMenuCtrl() {
	    if (this._$menuCtrl) return this._$menuCtrl;
	    this._$menuCtrl = this.getContainer().querySelector('[aria-expanded]');
	    return this._$menuCtrl;
	  };
	
	  _proto.getItemType = function getItemType() {
	    if (this.context.menuRole === 'listbox') {
	      return 'option';
	    }
	
	    return 'menuitem';
	  };
	
	  _proto.getMenuItems = function getMenuItems() {
	    // In a real menu with a child DropdownMenu, `this.getMenu()` should never
	    // be null, but it is sometimes null in tests. To mitigate that, we just
	    // use `this.getContainer()` as the fallback `menuContainer`.
	    var menuContainer = this.getMenu() || this.getContainer();
	    return [].slice.call(menuContainer.querySelectorAll("[role=\"" + this.getItemType() + "\"]"));
	  };
	
	  _proto.addEvents = function addEvents() {
	    var _this2 = this;
	
	    ['click', 'touchstart', 'keyup'].forEach(function (event) {
	      return document.addEventListener(event, _this2.handleDocumentClick, true);
	    });
	  };
	
	  _proto.removeEvents = function removeEvents() {
	    var _this3 = this;
	
	    ['click', 'touchstart', 'keyup'].forEach(function (event) {
	      return document.removeEventListener(event, _this3.handleDocumentClick, true);
	    });
	  };
	
	  _proto.handleDocumentClick = function handleDocumentClick(e) {
	    if (e && (e.which === 3 || e.type === 'keyup' && e.which !== _utils.keyCodes.tab)) return;
	    var container = this.getContainer();
	    var menu = this.getMenu();
	    var clickIsInContainer = container.contains(e.target) && container !== e.target;
	    var clickIsInMenu = menu && menu.contains(e.target) && menu !== e.target;
	
	    if ((clickIsInContainer || clickIsInMenu) && (e.type !== 'keyup' || e.which === _utils.keyCodes.tab)) {
	      return;
	    }
	
	    this.toggle(e);
	  };
	
	  _proto.handleKeyDown = function handleKeyDown(e) {
	    var _this4 = this;
	
	    var isTargetMenuItem = e.target.getAttribute('role') === 'menuitem' || e.target.getAttribute('role') === 'option';
	    var isTargetMenuCtrl = this.getMenuCtrl() === e.target;
	    var isTab = _utils.keyCodes.tab === e.which;
	
	    if (/input|textarea/i.test(e.target.tagName) || isTab && !this.props.a11y || isTab && !(isTargetMenuItem || isTargetMenuCtrl)) {
	      return;
	    }
	
	    if (preventDefaultKeys.indexOf(e.which) !== -1 || e.which >= 48 && e.which <= 90) {
	      e.preventDefault();
	    }
	
	    if (this.props.disabled) return;
	
	    if (isTargetMenuCtrl) {
	      if ([_utils.keyCodes.space, _utils.keyCodes.enter, _utils.keyCodes.up, _utils.keyCodes.down].indexOf(e.which) > -1) {
	        // Open the menu (if not open) and focus the first menu item
	        if (!this.props.isOpen) {
	          this.toggle(e);
	        }
	
	        setTimeout(function () {
	          return _this4.getMenuItems()[0].focus();
	        });
	      } else if (this.props.isOpen && isTab) {
	        // Focus the first menu item if tabbing from an open menu. We need this
	        // for cases where the DropdownMenu sets a custom container, which may
	        // not be the natural next item to tab to from the DropdownToggle.
	        e.preventDefault();
	        this.getMenuItems()[0].focus();
	      } else if (this.props.isOpen && e.which === _utils.keyCodes.esc) {
	        this.toggle(e);
	      }
	    }
	
	    if (this.props.isOpen && isTargetMenuItem) {
	      if ([_utils.keyCodes.tab, _utils.keyCodes.esc].indexOf(e.which) > -1) {
	        this.toggle(e);
	        this.getMenuCtrl().focus();
	      } else if ([_utils.keyCodes.space, _utils.keyCodes.enter].indexOf(e.which) > -1) {
	        e.target.click();
	        this.getMenuCtrl().focus();
	      } else if ([_utils.keyCodes.down, _utils.keyCodes.up].indexOf(e.which) > -1 || [_utils.keyCodes.n, _utils.keyCodes.p].indexOf(e.which) > -1 && e.ctrlKey) {
	        var $menuitems = this.getMenuItems();
	        var index = $menuitems.indexOf(e.target);
	
	        if (_utils.keyCodes.up === e.which || _utils.keyCodes.p === e.which && e.ctrlKey) {
	          index = index !== 0 ? index - 1 : $menuitems.length - 1;
	        } else if (_utils.keyCodes.down === e.which || _utils.keyCodes.n === e.which && e.ctrlKey) {
	          index = index === $menuitems.length - 1 ? 0 : index + 1;
	        }
	
	        $menuitems[index].focus();
	      } else if (_utils.keyCodes.end === e.which) {
	        var _$menuitems = this.getMenuItems();
	
	        _$menuitems[_$menuitems.length - 1].focus();
	      } else if (_utils.keyCodes.home === e.which) {
	        var _$menuitems2 = this.getMenuItems();
	
	        _$menuitems2[0].focus();
	      } else if (e.which >= 48 && e.which <= 90) {
	        var _$menuitems3 = this.getMenuItems();
	
	        var charPressed = String.fromCharCode(e.which).toLowerCase();
	
	        for (var i = 0; i < _$menuitems3.length; i += 1) {
	          var firstLetter = _$menuitems3[i].textContent && _$menuitems3[i].textContent[0].toLowerCase();
	
	          if (firstLetter === charPressed) {
	            _$menuitems3[i].focus();
	
	            break;
	          }
	        }
	      }
	    }
	  };
	
	  _proto.handleProps = function handleProps() {
	    if (this.props.isOpen) {
	      this.addEvents();
	    } else {
	      this.removeEvents();
	    }
	  };
	
	  _proto.toggle = function toggle(e) {
	    if (this.props.disabled) {
	      return e && e.preventDefault();
	    }
	
	    return this.props.toggle(e);
	  };
	
	  _proto.render = function render() {
	    var _classNames, _ref;
	
	    var _omit = (0, _utils.omit)(this.props, ['toggle', 'disabled', 'inNavbar', 'a11y']),
	        className = _omit.className,
	        cssModule = _omit.cssModule,
	        direction = _omit.direction,
	        isOpen = _omit.isOpen,
	        group = _omit.group,
	        size = _omit.size,
	        nav = _omit.nav,
	        setActiveFromChild = _omit.setActiveFromChild,
	        active = _omit.active,
	        addonType = _omit.addonType,
	        tag = _omit.tag,
	        menuRole = _omit.menuRole,
	        attrs = (0, _objectWithoutPropertiesLoose2.default)(_omit, ["className", "cssModule", "direction", "isOpen", "group", "size", "nav", "setActiveFromChild", "active", "addonType", "tag", "menuRole"]);
	
	    var Tag = tag || (nav ? 'li' : 'div');
	    var subItemIsActive = false;
	
	    if (setActiveFromChild) {
	      _react.default.Children.map(this.props.children[1].props.children, function (dropdownItem) {
	        if (dropdownItem && dropdownItem.props.active) subItemIsActive = true;
	      });
	    }
	
	    var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, direction !== 'down' && "drop" + direction, nav && active ? 'active' : false, setActiveFromChild && subItemIsActive ? 'active' : false, (_classNames = {}, _classNames["input-group-" + addonType] = addonType, _classNames['btn-group'] = group, _classNames["btn-group-" + size] = !!size, _classNames.dropdown = !group && !addonType, _classNames.show = isOpen, _classNames['nav-item'] = nav, _classNames)), cssModule);
	    return /*#__PURE__*/_react.default.createElement(_DropdownContext.DropdownContext.Provider, {
	      value: this.getContextValue()
	    }, /*#__PURE__*/_react.default.createElement(_reactPopper.Manager, null, /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attrs, (_ref = {}, _ref[typeof Tag === 'string' ? 'ref' : 'innerRef'] = this.containerRef, _ref), {
	      onKeyDown: this.handleKeyDown,
	      className: classes
	    }))));
	  };
	
	  return Dropdown;
	}(_react.default.Component);
	
	Dropdown.propTypes = propTypes;
	Dropdown.defaultProps = defaultProps;
	var _default = Dropdown;
	exports.default = _default;

/***/ },
/* 2711 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(20));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _DropdownContext = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _utils = __webpack_require__(__webpack_module_template_argument_1__);
	
	var propTypes = {
	  children: _propTypes.default.node,
	  active: _propTypes.default.bool,
	  disabled: _propTypes.default.bool,
	  divider: _propTypes.default.bool,
	  tag: _utils.tagPropType,
	  header: _propTypes.default.bool,
	  onClick: _propTypes.default.func,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  toggle: _propTypes.default.bool,
	  text: _propTypes.default.bool
	};
	var defaultProps = {
	  tag: 'button',
	  toggle: true
	};
	
	var DropdownItem = /*#__PURE__*/function (_React$Component) {
	  (0, _inheritsLoose2.default)(DropdownItem, _React$Component);
	
	  function DropdownItem(props) {
	    var _this;
	
	    _this = _React$Component.call(this, props) || this;
	    _this.onClick = _this.onClick.bind((0, _assertThisInitialized2.default)(_this));
	    _this.getTabIndex = _this.getTabIndex.bind((0, _assertThisInitialized2.default)(_this));
	    return _this;
	  }
	
	  var _proto = DropdownItem.prototype;
	
	  _proto.getRole = function getRole() {
	    if (this.context.menuRole === 'listbox') {
	      return 'option';
	    }
	
	    return 'menuitem';
	  };
	
	  _proto.onClick = function onClick(e) {
	    var _this$props = this.props,
	        disabled = _this$props.disabled,
	        header = _this$props.header,
	        divider = _this$props.divider,
	        text = _this$props.text;
	
	    if (disabled || header || divider || text) {
	      e.preventDefault();
	      return;
	    }
	
	    if (this.props.onClick) {
	      this.props.onClick(e);
	    }
	
	    if (this.props.toggle) {
	      this.context.toggle(e);
	    }
	  };
	
	  _proto.getTabIndex = function getTabIndex() {
	    var _this$props2 = this.props,
	        disabled = _this$props2.disabled,
	        header = _this$props2.header,
	        divider = _this$props2.divider,
	        text = _this$props2.text;
	
	    if (disabled || header || divider || text) {
	      return '-1';
	    }
	
	    return '0';
	  };
	
	  _proto.render = function render() {
	    var tabIndex = this.getTabIndex();
	    var role = tabIndex > -1 ? this.getRole() : undefined;
	
	    var _omit = (0, _utils.omit)(this.props, ['toggle']),
	        className = _omit.className,
	        cssModule = _omit.cssModule,
	        divider = _omit.divider,
	        Tag = _omit.tag,
	        header = _omit.header,
	        active = _omit.active,
	        text = _omit.text,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_omit, ["className", "cssModule", "divider", "tag", "header", "active", "text"]);
	
	    var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, {
	      disabled: props.disabled,
	      'dropdown-item': !divider && !header && !text,
	      active: active,
	      'dropdown-header': header,
	      'dropdown-divider': divider,
	      'dropdown-item-text': text
	    }), cssModule);
	
	    if (Tag === 'button') {
	      if (header) {
	        Tag = 'h6';
	      } else if (divider) {
	        Tag = 'div';
	      } else if (props.href) {
	        Tag = 'a';
	      } else if (text) {
	        Tag = 'span';
	      }
	    }
	
	    return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({
	      type: Tag === 'button' && (props.onClick || this.props.toggle) ? 'button' : undefined
	    }, props, {
	      tabIndex: tabIndex,
	      role: role,
	      className: classes,
	      onClick: this.onClick
	    }));
	  };
	
	  return DropdownItem;
	}(_react.default.Component);
	
	DropdownItem.propTypes = propTypes;
	DropdownItem.defaultProps = defaultProps;
	DropdownItem.contextType = _DropdownContext.DropdownContext;
	var _default = DropdownItem;
	exports.default = _default;

/***/ },
/* 2712 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(27));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(20));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(31));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _reactPopper = __webpack_require__(75);
	
	var _DropdownContext = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _utils = __webpack_require__(__webpack_module_template_argument_1__);
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  children: _propTypes.default.node.isRequired,
	  right: _propTypes.default.bool,
	  flip: _propTypes.default.bool,
	  modifiers: _propTypes.default.object,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  persist: _propTypes.default.bool,
	  positionFixed: _propTypes.default.bool,
	  container: _utils.targetPropType
	};
	var defaultProps = {
	  tag: 'div',
	  flip: true
	};
	var noFlipModifier = {
	  flip: {
	    enabled: false
	  }
	};
	var directionPositionMap = {
	  up: 'top',
	  left: 'left',
	  right: 'right',
	  down: 'bottom'
	};
	
	var DropdownMenu = /*#__PURE__*/function (_React$Component) {
	  (0, _inheritsLoose2.default)(DropdownMenu, _React$Component);
	
	  function DropdownMenu() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = DropdownMenu.prototype;
	
	  _proto.getRole = function getRole() {
	    if (this.context.menuRole === 'listbox') {
	      return 'listbox';
	    }
	
	    return 'menu';
	  };
	
	  _proto.render = function render() {
	    var _this = this;
	
	    var _this$props = this.props,
	        className = _this$props.className,
	        cssModule = _this$props.cssModule,
	        right = _this$props.right,
	        tag = _this$props.tag,
	        flip = _this$props.flip,
	        modifiers = _this$props.modifiers,
	        persist = _this$props.persist,
	        positionFixed = _this$props.positionFixed,
	        container = _this$props.container,
	        attrs = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["className", "cssModule", "right", "tag", "flip", "modifiers", "persist", "positionFixed", "container"]);
	    var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'dropdown-menu', {
	      'dropdown-menu-right': right,
	      show: this.context.isOpen
	    }), cssModule);
	    var Tag = tag;
	
	    if (persist || this.context.isOpen && !this.context.inNavbar) {
	      var position1 = directionPositionMap[this.context.direction] || 'bottom';
	      var position2 = right ? 'end' : 'start';
	      var poperPlacement = position1 + "-" + position2;
	      var poperModifiers = !flip ? _objectSpread(_objectSpread({}, modifiers), noFlipModifier) : modifiers;
	      var popperPositionFixed = !!positionFixed;
	
	      var popper = /*#__PURE__*/_react.default.createElement(_reactPopper.Popper, {
	        placement: poperPlacement,
	        modifiers: poperModifiers,
	        positionFixed: popperPositionFixed
	      }, function (_ref) {
	        var ref = _ref.ref,
	            style = _ref.style,
	            placement = _ref.placement;
	
	        var combinedStyle = _objectSpread(_objectSpread({}, _this.props.style), style);
	
	        var handleRef = function handleRef(tagRef) {
	          // Send the ref to `react-popper`
	          ref(tagRef); // Send the ref to the parent Dropdown so that clicks outside
	          // it will cause it to close
	
	          var onMenuRef = _this.context.onMenuRef;
	          if (onMenuRef) onMenuRef(tagRef);
	        };
	
	        return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({
	          tabIndex: "-1",
	          role: _this.getRole(),
	          ref: handleRef
	        }, attrs, {
	          style: combinedStyle,
	          "aria-hidden": !_this.context.isOpen,
	          className: classes,
	          "x-placement": placement
	        }));
	      });
	
	      if (container) {
	        return /*#__PURE__*/_reactDom.default.createPortal(popper, (0, _utils.getTarget)(container));
	      } else {
	        return popper;
	      }
	    }
	
	    return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({
	      tabIndex: "-1",
	      role: this.getRole()
	    }, attrs, {
	      "aria-hidden": !this.context.isOpen,
	      className: classes,
	      "x-placement": attrs.placement
	    }));
	  };
	
	  return DropdownMenu;
	}(_react.default.Component);
	
	;
	DropdownMenu.propTypes = propTypes;
	DropdownMenu.defaultProps = defaultProps;
	DropdownMenu.contextType = _DropdownContext.DropdownContext;
	var _default = DropdownMenu;
	exports.default = _default;

/***/ },
/* 2713 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(20));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _reactPopper = __webpack_require__(75);
	
	var _DropdownContext = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _utils = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _Button = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_2__));
	
	var propTypes = {
	  caret: _propTypes.default.bool,
	  color: _propTypes.default.string,
	  children: _propTypes.default.node,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  disabled: _propTypes.default.bool,
	  onClick: _propTypes.default.func,
	  'aria-haspopup': _propTypes.default.bool,
	  split: _propTypes.default.bool,
	  tag: _utils.tagPropType,
	  nav: _propTypes.default.bool
	};
	var defaultProps = {
	  color: 'secondary',
	  'aria-haspopup': true
	};
	
	var DropdownToggle = /*#__PURE__*/function (_React$Component) {
	  (0, _inheritsLoose2.default)(DropdownToggle, _React$Component);
	
	  function DropdownToggle(props) {
	    var _this;
	
	    _this = _React$Component.call(this, props) || this;
	    _this.onClick = _this.onClick.bind((0, _assertThisInitialized2.default)(_this));
	    return _this;
	  }
	
	  var _proto = DropdownToggle.prototype;
	
	  _proto.onClick = function onClick(e) {
	    if (this.props.disabled || this.context.disabled) {
	      e.preventDefault();
	      return;
	    }
	
	    if (this.props.nav && !this.props.tag) {
	      e.preventDefault();
	    }
	
	    if (this.props.onClick) {
	      this.props.onClick(e);
	    }
	
	    this.context.toggle(e);
	  };
	
	  _proto.getRole = function getRole() {
	    return this.context.menuRole || this.props['aria-haspopup'];
	  };
	
	  _proto.render = function render() {
	    var _this2 = this;
	
	    var _this$props = this.props,
	        className = _this$props.className,
	        color = _this$props.color,
	        cssModule = _this$props.cssModule,
	        caret = _this$props.caret,
	        split = _this$props.split,
	        nav = _this$props.nav,
	        tag = _this$props.tag,
	        innerRef = _this$props.innerRef,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["className", "color", "cssModule", "caret", "split", "nav", "tag", "innerRef"]);
	    var ariaLabel = props['aria-label'] || 'Toggle Dropdown';
	    var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, {
	      'dropdown-toggle': caret || split,
	      'dropdown-toggle-split': split,
	      'nav-link': nav
	    }), cssModule);
	    var children = typeof props.children !== 'undefined' ? props.children : /*#__PURE__*/_react.default.createElement("span", {
	      className: "sr-only"
	    }, ariaLabel);
	    var Tag;
	
	    if (nav && !tag) {
	      Tag = 'a';
	      props.href = '#';
	    } else if (!tag) {
	      Tag = _Button.default;
	      props.color = color;
	      props.cssModule = cssModule;
	    } else {
	      Tag = tag;
	    }
	
	    if (this.context.inNavbar) {
	      return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, props, {
	        className: classes,
	        onClick: this.onClick,
	        "aria-expanded": this.context.isOpen,
	        "aria-haspopup": this.getRole(),
	        children: children
	      }));
	    }
	
	    return /*#__PURE__*/_react.default.createElement(_reactPopper.Reference, {
	      innerRef: innerRef
	    }, function (_ref) {
	      var _ref2;
	
	      var ref = _ref.ref;
	      return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, props, (_ref2 = {}, _ref2[typeof Tag === 'string' ? 'ref' : 'innerRef'] = ref, _ref2), {
	        className: classes,
	        onClick: _this2.onClick,
	        "aria-expanded": _this2.context.isOpen,
	        "aria-haspopup": _this2.getRole(),
	        children: children
	      }));
	    });
	  };
	
	  return DropdownToggle;
	}(_react.default.Component);
	
	DropdownToggle.propTypes = propTypes;
	DropdownToggle.defaultProps = defaultProps;
	DropdownToggle.contextType = _DropdownContext.DropdownContext;
	var _default = DropdownToggle;
	exports.default = _default;

/***/ },
/* 2714 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(27));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _reactTransitionGroup = __webpack_require__(126);
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	var propTypes = _objectSpread(_objectSpread({}, _reactTransitionGroup.Transition.propTypes), {}, {
	  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]),
	  tag: _utils.tagPropType,
	  baseClass: _propTypes.default.string,
	  baseClassActive: _propTypes.default.string,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  innerRef: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string, _propTypes.default.func])
	});
	
	var defaultProps = _objectSpread(_objectSpread({}, _reactTransitionGroup.Transition.defaultProps), {}, {
	  tag: 'div',
	  baseClass: 'fade',
	  baseClassActive: 'show',
	  timeout: _utils.TransitionTimeouts.Fade,
	  appear: true,
	  enter: true,
	  exit: true,
	  in: true
	});
	
	function Fade(props) {
	  var Tag = props.tag,
	      baseClass = props.baseClass,
	      baseClassActive = props.baseClassActive,
	      className = props.className,
	      cssModule = props.cssModule,
	      children = props.children,
	      innerRef = props.innerRef,
	      otherProps = (0, _objectWithoutPropertiesLoose2.default)(props, ["tag", "baseClass", "baseClassActive", "className", "cssModule", "children", "innerRef"]);
	  var transitionProps = (0, _utils.pick)(otherProps, _utils.TransitionPropTypeKeys);
	  var childProps = (0, _utils.omit)(otherProps, _utils.TransitionPropTypeKeys);
	  return /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.Transition, transitionProps, function (status) {
	    var isActive = status === 'entered';
	    var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, baseClass, isActive && baseClassActive), cssModule);
	    return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({
	      className: classes
	    }, childProps, {
	      ref: innerRef
	    }), children);
	  });
	}
	
	Fade.propTypes = propTypes;
	Fade.defaultProps = defaultProps;
	var _default = Fade;
	exports.default = _default;

/***/ },
/* 2715 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(20));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var propTypes = {
	  children: _propTypes.default.node,
	  inline: _propTypes.default.bool,
	  tag: _utils.tagPropType,
	  innerRef: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func, _propTypes.default.string]),
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'form'
	};
	
	var Form = /*#__PURE__*/function (_Component) {
	  (0, _inheritsLoose2.default)(Form, _Component);
	
	  function Form(props) {
	    var _this;
	
	    _this = _Component.call(this, props) || this;
	    _this.getRef = _this.getRef.bind((0, _assertThisInitialized2.default)(_this));
	    _this.submit = _this.submit.bind((0, _assertThisInitialized2.default)(_this));
	    return _this;
	  }
	
	  var _proto = Form.prototype;
	
	  _proto.getRef = function getRef(ref) {
	    if (this.props.innerRef) {
	      this.props.innerRef(ref);
	    }
	
	    this.ref = ref;
	  };
	
	  _proto.submit = function submit() {
	    if (this.ref) {
	      this.ref.submit();
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        className = _this$props.className,
	        cssModule = _this$props.cssModule,
	        inline = _this$props.inline,
	        Tag = _this$props.tag,
	        innerRef = _this$props.innerRef,
	        attributes = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["className", "cssModule", "inline", "tag", "innerRef"]);
	    var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, inline ? 'form-inline' : false), cssModule);
	    return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	      ref: innerRef,
	      className: classes
	    }));
	  };
	
	  return Form;
	}(_react.Component);
	
	Form.propTypes = propTypes;
	Form.defaultProps = defaultProps;
	var _default = Form;
	exports.default = _default;

/***/ },
/* 2716 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	var propTypes = {
	  children: _propTypes.default.node,
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  valid: _propTypes.default.bool,
	  tooltip: _propTypes.default.bool
	};
	var defaultProps = {
	  tag: 'div',
	  valid: undefined
	};
	
	var FormFeedback = function FormFeedback(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      valid = props.valid,
	      tooltip = props.tooltip,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "valid", "tooltip", "tag"]);
	  var validMode = tooltip ? 'tooltip' : 'feedback';
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, valid ? "valid-" + validMode : "invalid-" + validMode), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	FormFeedback.propTypes = propTypes;
	FormFeedback.defaultProps = defaultProps;
	var _default = FormFeedback;
	exports.default = _default;

/***/ },
/* 2717 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	var propTypes = {
	  children: _propTypes.default.node,
	  row: _propTypes.default.bool,
	  check: _propTypes.default.bool,
	  inline: _propTypes.default.bool,
	  disabled: _propTypes.default.bool,
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var FormGroup = function FormGroup(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      row = props.row,
	      disabled = props.disabled,
	      check = props.check,
	      inline = props.inline,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "row", "disabled", "check", "inline", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, row ? 'row' : false, check ? 'form-check' : 'form-group', check && inline ? 'form-check-inline' : false, check && disabled ? 'disabled' : false), cssModule);
	
	  if (Tag === 'fieldset') {
	    attributes.disabled = disabled;
	  }
	
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	FormGroup.propTypes = propTypes;
	FormGroup.defaultProps = defaultProps;
	var _default = FormGroup;
	exports.default = _default;

/***/ },
/* 2718 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	var propTypes = {
	  children: _propTypes.default.node,
	  inline: _propTypes.default.bool,
	  tag: _utils.tagPropType,
	  color: _propTypes.default.string,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'small',
	  color: 'muted'
	};
	
	var FormText = function FormText(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      inline = props.inline,
	      color = props.color,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "inline", "color", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, !inline ? 'form-text' : false, color ? "text-" + color : false), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	FormText.propTypes = propTypes;
	FormText.defaultProps = defaultProps;
	var _default = FormText;
	exports.default = _default;

/***/ },
/* 2719 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(20));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	/* eslint react/prefer-stateless-function: 0 */
	var propTypes = {
	  children: _propTypes.default.node,
	  type: _propTypes.default.string,
	  size: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  bsSize: _propTypes.default.string,
	  valid: _propTypes.default.bool,
	  invalid: _propTypes.default.bool,
	  tag: _utils.tagPropType,
	  innerRef: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func, _propTypes.default.string]),
	  plaintext: _propTypes.default.bool,
	  addon: _propTypes.default.bool,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  type: 'text'
	};
	
	var Input = /*#__PURE__*/function (_React$Component) {
	  (0, _inheritsLoose2.default)(Input, _React$Component);
	
	  function Input(props) {
	    var _this;
	
	    _this = _React$Component.call(this, props) || this;
	    _this.getRef = _this.getRef.bind((0, _assertThisInitialized2.default)(_this));
	    _this.focus = _this.focus.bind((0, _assertThisInitialized2.default)(_this));
	    return _this;
	  }
	
	  var _proto = Input.prototype;
	
	  _proto.getRef = function getRef(ref) {
	    if (this.props.innerRef) {
	      this.props.innerRef(ref);
	    }
	
	    this.ref = ref;
	  };
	
	  _proto.focus = function focus() {
	    if (this.ref) {
	      this.ref.focus();
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        className = _this$props.className,
	        cssModule = _this$props.cssModule,
	        type = _this$props.type,
	        bsSize = _this$props.bsSize,
	        valid = _this$props.valid,
	        invalid = _this$props.invalid,
	        tag = _this$props.tag,
	        addon = _this$props.addon,
	        plaintext = _this$props.plaintext,
	        innerRef = _this$props.innerRef,
	        attributes = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["className", "cssModule", "type", "bsSize", "valid", "invalid", "tag", "addon", "plaintext", "innerRef"]);
	    var checkInput = ['radio', 'checkbox'].indexOf(type) > -1;
	    var isNotaNumber = new RegExp('\\D', 'g');
	    var fileInput = type === 'file';
	    var textareaInput = type === 'textarea';
	    var selectInput = type === 'select';
	    var rangeInput = type === 'range';
	    var Tag = tag || (selectInput || textareaInput ? type : 'input');
	    var formControlClass = 'form-control';
	
	    if (plaintext) {
	      formControlClass = formControlClass + "-plaintext";
	      Tag = tag || 'input';
	    } else if (fileInput) {
	      formControlClass = formControlClass + "-file";
	    } else if (rangeInput) {
	      formControlClass = formControlClass + "-range";
	    } else if (checkInput) {
	      if (addon) {
	        formControlClass = null;
	      } else {
	        formControlClass = 'form-check-input';
	      }
	    }
	
	    if (attributes.size && isNotaNumber.test(attributes.size)) {
	      (0, _utils.warnOnce)('Please use the prop "bsSize" instead of the "size" to bootstrap\'s input sizing.');
	      bsSize = attributes.size;
	      delete attributes.size;
	    }
	
	    var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, invalid && 'is-invalid', valid && 'is-valid', bsSize ? "form-control-" + bsSize : false, formControlClass), cssModule);
	
	    if (Tag === 'input' || tag && typeof tag === 'function') {
	      attributes.type = type;
	    }
	
	    if (attributes.children && !(plaintext || type === 'select' || typeof Tag !== 'string' || Tag === 'select')) {
	      (0, _utils.warnOnce)("Input with a type of \"" + type + "\" cannot have children. Please use \"value\"/\"defaultValue\" instead.");
	      delete attributes.children;
	    }
	
	    return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	      ref: innerRef,
	      className: classes,
	      "aria-invalid": invalid
	    }));
	  };
	
	  return Input;
	}(_react.default.Component);
	
	Input.propTypes = propTypes;
	Input.defaultProps = defaultProps;
	var _default = Input;
	exports.default = _default;

/***/ },
/* 2720 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  size: _propTypes.default.string,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var InputGroup = function InputGroup(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      size = props.size,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag", "size"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'input-group', size ? "input-group-" + size : null), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	InputGroup.propTypes = propTypes;
	InputGroup.defaultProps = defaultProps;
	var _default = InputGroup;
	exports.default = _default;

/***/ },
/* 2721 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _InputGroupText = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_1__));
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  addonType: _propTypes.default.oneOf(['prepend', 'append']).isRequired,
	  children: _propTypes.default.node,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var InputGroupAddon = function InputGroupAddon(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      addonType = props.addonType,
	      children = props.children,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag", "addonType", "children"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'input-group-' + addonType), cssModule); // Convenience to assist with transition
	
	  if (typeof children === 'string') {
	    return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	      className: classes
	    }), /*#__PURE__*/_react.default.createElement(_InputGroupText.default, {
	      children: children
	    }));
	  }
	
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes,
	    children: children
	  }));
	};
	
	InputGroupAddon.propTypes = propTypes;
	InputGroupAddon.defaultProps = defaultProps;
	var _default = InputGroupAddon;
	exports.default = _default;

/***/ },
/* 2722 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _Dropdown = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var propTypes = {
	  addonType: _propTypes.default.oneOf(['prepend', 'append']).isRequired,
	  children: _propTypes.default.node
	};
	
	var InputGroupButtonDropdown = function InputGroupButtonDropdown(props) {
	  return /*#__PURE__*/_react.default.createElement(_Dropdown.default, props);
	};
	
	InputGroupButtonDropdown.propTypes = propTypes;
	var _default = InputGroupButtonDropdown;
	exports.default = _default;

/***/ },
/* 2723 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'span'
	};
	
	var InputGroupText = function InputGroupText(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'input-group-text'), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	InputGroupText.propTypes = propTypes;
	InputGroupText.defaultProps = defaultProps;
	var _default = InputGroupText;
	exports.default = _default;

/***/ },
/* 2724 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  fluid: _propTypes.default.bool,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var Jumbotron = function Jumbotron(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      fluid = props.fluid,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag", "fluid"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'jumbotron', fluid ? 'jumbotron-fluid' : false), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	Jumbotron.propTypes = propTypes;
	Jumbotron.defaultProps = defaultProps;
	var _default = Jumbotron;
	exports.default = _default;

/***/ },
/* 2725 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	var colWidths = ['xs', 'sm', 'md', 'lg', 'xl'];
	
	var stringOrNumberProp = _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]);
	
	var columnProps = _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string, _propTypes.default.number, _propTypes.default.shape({
	  size: stringOrNumberProp,
	  order: stringOrNumberProp,
	  offset: stringOrNumberProp
	})]);
	
	var propTypes = {
	  children: _propTypes.default.node,
	  hidden: _propTypes.default.bool,
	  check: _propTypes.default.bool,
	  size: _propTypes.default.string,
	  for: _propTypes.default.string,
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  xs: columnProps,
	  sm: columnProps,
	  md: columnProps,
	  lg: columnProps,
	  xl: columnProps,
	  widths: _propTypes.default.array
	};
	var defaultProps = {
	  tag: 'label',
	  widths: colWidths
	};
	
	var getColumnSizeClass = function getColumnSizeClass(isXs, colWidth, colSize) {
	  if (colSize === true || colSize === '') {
	    return isXs ? 'col' : "col-" + colWidth;
	  } else if (colSize === 'auto') {
	    return isXs ? 'col-auto' : "col-" + colWidth + "-auto";
	  }
	
	  return isXs ? "col-" + colSize : "col-" + colWidth + "-" + colSize;
	};
	
	var Label = function Label(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      hidden = props.hidden,
	      widths = props.widths,
	      Tag = props.tag,
	      check = props.check,
	      size = props.size,
	      htmlFor = props.for,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "hidden", "widths", "tag", "check", "size", "for"]);
	  var colClasses = [];
	  widths.forEach(function (colWidth, i) {
	    var columnProp = props[colWidth];
	    delete attributes[colWidth];
	
	    if (!columnProp && columnProp !== '') {
	      return;
	    }
	
	    var isXs = !i;
	    var colClass;
	
	    if ((0, _utils.isObject)(columnProp)) {
	      var _classNames;
	
	      var colSizeInterfix = isXs ? '-' : "-" + colWidth + "-";
	      colClass = getColumnSizeClass(isXs, colWidth, columnProp.size);
	      colClasses.push((0, _utils.mapToCssModules)((0, _classnames.default)((_classNames = {}, _classNames[colClass] = columnProp.size || columnProp.size === '', _classNames["order" + colSizeInterfix + columnProp.order] = columnProp.order || columnProp.order === 0, _classNames["offset" + colSizeInterfix + columnProp.offset] = columnProp.offset || columnProp.offset === 0, _classNames))), cssModule);
	    } else {
	      colClass = getColumnSizeClass(isXs, colWidth, columnProp);
	      colClasses.push(colClass);
	    }
	  });
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, hidden ? 'sr-only' : false, check ? 'form-check-label' : false, size ? "col-form-label-" + size : false, colClasses, colClasses.length ? 'col-form-label' : false), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({
	    htmlFor: htmlFor
	  }, attributes, {
	    className: classes
	  }));
	};
	
	Label.propTypes = propTypes;
	Label.defaultProps = defaultProps;
	var _default = Label;
	exports.default = _default;

/***/ },
/* 2726 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  type: _propTypes.default.string
	};
	var defaultProps = {
	  tag: 'ul'
	};
	var List = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      type = props.type,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag", "type"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, type ? "list-" + type : false), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes,
	    ref: ref
	  }));
	});
	List.propTypes = propTypes;
	List.defaultProps = defaultProps;
	var _default = List;
	exports.default = _default;

/***/ },
/* 2727 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  flush: _propTypes.default.bool,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  horizontal: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string])
	};
	var defaultProps = {
	  tag: 'ul',
	  horizontal: false
	};
	
	var getHorizontalClass = function getHorizontalClass(horizontal) {
	  if (horizontal === false) {
	    return false;
	  } else if (horizontal === true || horizontal === "xs") {
	    return "list-group-horizontal";
	  }
	
	  return "list-group-horizontal-" + horizontal;
	};
	
	var ListGroup = function ListGroup(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      flush = props.flush,
	      horizontal = props.horizontal,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag", "flush", "horizontal"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'list-group', // list-group-horizontal cannot currently be mixed with list-group-flush
	  // we only try to apply horizontal classes if flush is false
	  flush ? 'list-group-flush' : getHorizontalClass(horizontal)), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	ListGroup.propTypes = propTypes;
	ListGroup.defaultProps = defaultProps;
	var _default = ListGroup;
	exports.default = _default;

/***/ },
/* 2728 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  active: _propTypes.default.bool,
	  disabled: _propTypes.default.bool,
	  color: _propTypes.default.string,
	  action: _propTypes.default.bool,
	  className: _propTypes.default.any,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'li'
	};
	
	var handleDisabledOnClick = function handleDisabledOnClick(e) {
	  e.preventDefault();
	};
	
	var ListGroupItem = function ListGroupItem(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      active = props.active,
	      disabled = props.disabled,
	      action = props.action,
	      color = props.color,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag", "active", "disabled", "action", "color"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, active ? 'active' : false, disabled ? 'disabled' : false, action ? 'list-group-item-action' : false, color ? "list-group-item-" + color : false, 'list-group-item'), cssModule); // Prevent click event when disabled.
	
	  if (disabled) {
	    attributes.onClick = handleDisabledOnClick;
	  }
	
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	ListGroupItem.propTypes = propTypes;
	ListGroupItem.defaultProps = defaultProps;
	var _default = ListGroupItem;
	exports.default = _default;

/***/ },
/* 2729 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.any,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'h5'
	};
	
	var ListGroupItemHeading = function ListGroupItemHeading(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'list-group-item-heading'), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	ListGroupItemHeading.propTypes = propTypes;
	ListGroupItemHeading.defaultProps = defaultProps;
	var _default = ListGroupItemHeading;
	exports.default = _default;

/***/ },
/* 2730 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.any,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'p'
	};
	
	var ListGroupItemText = function ListGroupItemText(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'list-group-item-text'), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	ListGroupItemText.propTypes = propTypes;
	ListGroupItemText.defaultProps = defaultProps;
	var _default = ListGroupItemText;
	exports.default = _default;

/***/ },
/* 2731 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'li'
	};
	var ListInlineItem = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'list-inline-item'), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes,
	    ref: ref
	  }));
	});
	ListInlineItem.propTypes = propTypes;
	ListInlineItem.defaultProps = defaultProps;
	var _default = ListInlineItem;
	exports.default = _default;

/***/ },
/* 2732 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	var propTypes = {
	  body: _propTypes.default.bool,
	  bottom: _propTypes.default.bool,
	  children: _propTypes.default.node,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  heading: _propTypes.default.bool,
	  left: _propTypes.default.bool,
	  list: _propTypes.default.bool,
	  middle: _propTypes.default.bool,
	  object: _propTypes.default.bool,
	  right: _propTypes.default.bool,
	  tag: _utils.tagPropType,
	  top: _propTypes.default.bool
	};
	
	var Media = function Media(props) {
	  var body = props.body,
	      bottom = props.bottom,
	      className = props.className,
	      cssModule = props.cssModule,
	      heading = props.heading,
	      left = props.left,
	      list = props.list,
	      middle = props.middle,
	      object = props.object,
	      right = props.right,
	      tag = props.tag,
	      top = props.top,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["body", "bottom", "className", "cssModule", "heading", "left", "list", "middle", "object", "right", "tag", "top"]);
	  var defaultTag;
	
	  if (heading) {
	    defaultTag = 'h4';
	  } else if (attributes.href) {
	    defaultTag = 'a';
	  } else if (attributes.src || object) {
	    defaultTag = 'img';
	  } else if (list) {
	    defaultTag = 'ul';
	  } else {
	    defaultTag = 'div';
	  }
	
	  var Tag = tag || defaultTag;
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, {
	    'media-body': body,
	    'media-heading': heading,
	    'media-left': left,
	    'media-right': right,
	    'media-top': top,
	    'media-bottom': bottom,
	    'media-middle': middle,
	    'media-object': object,
	    'media-list': list,
	    media: !body && !heading && !left && !right && !top && !bottom && !middle && !object && !list
	  }), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	Media.propTypes = propTypes;
	var _default = Media;
	exports.default = _default;

/***/ },
/* 2733 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(27));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(20));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _Portal = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var _Fade = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_1__));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_2__);
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function noop() {}
	
	var FadePropTypes = _propTypes.default.shape(_Fade.default.propTypes);
	
	var propTypes = {
	  isOpen: _propTypes.default.bool,
	  autoFocus: _propTypes.default.bool,
	  centered: _propTypes.default.bool,
	  scrollable: _propTypes.default.bool,
	  size: _propTypes.default.string,
	  toggle: _propTypes.default.func,
	  keyboard: _propTypes.default.bool,
	  role: _propTypes.default.string,
	  labelledBy: _propTypes.default.string,
	  backdrop: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.oneOf(['static'])]),
	  onEnter: _propTypes.default.func,
	  onExit: _propTypes.default.func,
	  onOpened: _propTypes.default.func,
	  onClosed: _propTypes.default.func,
	  children: _propTypes.default.node,
	  className: _propTypes.default.string,
	  wrapClassName: _propTypes.default.string,
	  modalClassName: _propTypes.default.string,
	  backdropClassName: _propTypes.default.string,
	  contentClassName: _propTypes.default.string,
	  external: _propTypes.default.node,
	  fade: _propTypes.default.bool,
	  cssModule: _propTypes.default.object,
	  zIndex: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  backdropTransition: FadePropTypes,
	  modalTransition: FadePropTypes,
	  innerRef: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string, _propTypes.default.func]),
	  unmountOnClose: _propTypes.default.bool,
	  returnFocusAfterClose: _propTypes.default.bool,
	  container: _utils.targetPropType,
	  trapFocus: _propTypes.default.bool
	};
	var propsToOmit = Object.keys(propTypes);
	var defaultProps = {
	  isOpen: false,
	  autoFocus: true,
	  centered: false,
	  scrollable: false,
	  role: 'dialog',
	  backdrop: true,
	  keyboard: true,
	  zIndex: 1050,
	  fade: true,
	  onOpened: noop,
	  onClosed: noop,
	  modalTransition: {
	    timeout: _utils.TransitionTimeouts.Modal
	  },
	  backdropTransition: {
	    mountOnEnter: true,
	    timeout: _utils.TransitionTimeouts.Fade // uses standard fade transition
	
	  },
	  unmountOnClose: true,
	  returnFocusAfterClose: true,
	  container: 'body',
	  trapFocus: false
	};
	
	var Modal = /*#__PURE__*/function (_React$Component) {
	  (0, _inheritsLoose2.default)(Modal, _React$Component);
	
	  function Modal(props) {
	    var _this;
	
	    _this = _React$Component.call(this, props) || this;
	    _this._element = null;
	    _this._originalBodyPadding = null;
	    _this.getFocusableChildren = _this.getFocusableChildren.bind((0, _assertThisInitialized2.default)(_this));
	    _this.handleBackdropClick = _this.handleBackdropClick.bind((0, _assertThisInitialized2.default)(_this));
	    _this.handleBackdropMouseDown = _this.handleBackdropMouseDown.bind((0, _assertThisInitialized2.default)(_this));
	    _this.handleEscape = _this.handleEscape.bind((0, _assertThisInitialized2.default)(_this));
	    _this.handleStaticBackdropAnimation = _this.handleStaticBackdropAnimation.bind((0, _assertThisInitialized2.default)(_this));
	    _this.handleTab = _this.handleTab.bind((0, _assertThisInitialized2.default)(_this));
	    _this.onOpened = _this.onOpened.bind((0, _assertThisInitialized2.default)(_this));
	    _this.onClosed = _this.onClosed.bind((0, _assertThisInitialized2.default)(_this));
	    _this.manageFocusAfterClose = _this.manageFocusAfterClose.bind((0, _assertThisInitialized2.default)(_this));
	    _this.clearBackdropAnimationTimeout = _this.clearBackdropAnimationTimeout.bind((0, _assertThisInitialized2.default)(_this));
	    _this.trapFocus = _this.trapFocus.bind((0, _assertThisInitialized2.default)(_this));
	    _this.state = {
	      isOpen: false,
	      showStaticBackdropAnimation: false
	    };
	    return _this;
	  }
	
	  var _proto = Modal.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    var _this$props = this.props,
	        isOpen = _this$props.isOpen,
	        autoFocus = _this$props.autoFocus,
	        onEnter = _this$props.onEnter;
	
	    if (isOpen) {
	      this.init();
	      this.setState({
	        isOpen: true
	      });
	
	      if (autoFocus) {
	        this.setFocus();
	      }
	    }
	
	    if (onEnter) {
	      onEnter();
	    } // traps focus inside the Modal, even if the browser address bar is focused
	
	
	    document.addEventListener('focus', this.trapFocus, true);
	    this._isMounted = true;
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
	    if (this.props.isOpen && !prevProps.isOpen) {
	      this.init();
	      this.setState({
	        isOpen: true
	      }); // let render() renders Modal Dialog first
	
	      return;
	    } // now Modal Dialog is rendered and we can refer this._element and this._dialog
	
	
	    if (this.props.autoFocus && this.state.isOpen && !prevState.isOpen) {
	      this.setFocus();
	    }
	
	    if (this._element && prevProps.zIndex !== this.props.zIndex) {
	      this._element.style.zIndex = this.props.zIndex;
	    }
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.clearBackdropAnimationTimeout();
	
	    if (this.props.onExit) {
	      this.props.onExit();
	    }
	
	    if (this._element) {
	      this.destroy();
	
	      if (this.props.isOpen || this.state.isOpen) {
	        this.close();
	      }
	    }
	
	    document.removeEventListener('focus', this.trapFocus, true);
	    this._isMounted = false;
	  };
	
	  _proto.trapFocus = function trapFocus(ev) {
	    if (!this.props.trapFocus) {
	      return;
	    }
	
	    if (!this._element) //element is not attached
	      return;
	    if (this._dialog && this._dialog.parentNode === ev.target) // initial focus when the Modal is opened
	      return;
	    if (this.modalIndex < Modal.openCount - 1) // last opened modal
	      return;
	    var children = this.getFocusableChildren();
	
	    for (var i = 0; i < children.length; i++) {
	      // focus is already inside the Modal
	      if (children[i] === ev.target) return;
	    }
	
	    if (children.length > 0) {
	      // otherwise focus the first focusable element in the Modal
	      ev.preventDefault();
	      ev.stopPropagation();
	      children[0].focus();
	    }
	  };
	
	  _proto.onOpened = function onOpened(node, isAppearing) {
	    this.props.onOpened();
	    (this.props.modalTransition.onEntered || noop)(node, isAppearing);
	  };
	
	  _proto.onClosed = function onClosed(node) {
	    var unmountOnClose = this.props.unmountOnClose; // so all methods get called before it is unmounted
	
	    this.props.onClosed();
	    (this.props.modalTransition.onExited || noop)(node);
	
	    if (unmountOnClose) {
	      this.destroy();
	    }
	
	    this.close();
	
	    if (this._isMounted) {
	      this.setState({
	        isOpen: false
	      });
	    }
	  };
	
	  _proto.setFocus = function setFocus() {
	    if (this._dialog && this._dialog.parentNode && typeof this._dialog.parentNode.focus === 'function') {
	      this._dialog.parentNode.focus();
	    }
	  };
	
	  _proto.getFocusableChildren = function getFocusableChildren() {
	    return this._element.querySelectorAll(_utils.focusableElements.join(', '));
	  };
	
	  _proto.getFocusedChild = function getFocusedChild() {
	    var currentFocus;
	    var focusableChildren = this.getFocusableChildren();
	
	    try {
	      currentFocus = document.activeElement;
	    } catch (err) {
	      currentFocus = focusableChildren[0];
	    }
	
	    return currentFocus;
	  } // not mouseUp because scrollbar fires it, shouldn't close when user scrolls
	  ;
	
	  _proto.handleBackdropClick = function handleBackdropClick(e) {
	    if (e.target === this._mouseDownElement) {
	      e.stopPropagation();
	      var backdrop = this._dialog ? this._dialog.parentNode : null;
	
	      if (backdrop && e.target === backdrop && this.props.backdrop === 'static') {
	        this.handleStaticBackdropAnimation();
	      }
	
	      if (!this.props.isOpen || this.props.backdrop !== true) return;
	
	      if (backdrop && e.target === backdrop && this.props.toggle) {
	        this.props.toggle(e);
	      }
	    }
	  };
	
	  _proto.handleTab = function handleTab(e) {
	    if (e.which !== 9) return;
	    if (this.modalIndex < Modal.openCount - 1) return; // last opened modal
	
	    var focusableChildren = this.getFocusableChildren();
	    var totalFocusable = focusableChildren.length;
	    if (totalFocusable === 0) return;
	    var currentFocus = this.getFocusedChild();
	    var focusedIndex = 0;
	
	    for (var i = 0; i < totalFocusable; i += 1) {
	      if (focusableChildren[i] === currentFocus) {
	        focusedIndex = i;
	        break;
	      }
	    }
	
	    if (e.shiftKey && focusedIndex === 0) {
	      e.preventDefault();
	      focusableChildren[totalFocusable - 1].focus();
	    } else if (!e.shiftKey && focusedIndex === totalFocusable - 1) {
	      e.preventDefault();
	      focusableChildren[0].focus();
	    }
	  };
	
	  _proto.handleBackdropMouseDown = function handleBackdropMouseDown(e) {
	    this._mouseDownElement = e.target;
	  };
	
	  _proto.handleEscape = function handleEscape(e) {
	    if (this.props.isOpen && e.keyCode === _utils.keyCodes.esc && this.props.toggle) {
	      if (this.props.keyboard) {
	        e.preventDefault();
	        e.stopPropagation();
	        this.props.toggle(e);
	      } else if (this.props.backdrop === 'static') {
	        e.preventDefault();
	        e.stopPropagation();
	        this.handleStaticBackdropAnimation();
	      }
	    }
	  };
	
	  _proto.handleStaticBackdropAnimation = function handleStaticBackdropAnimation() {
	    var _this2 = this;
	
	    this.clearBackdropAnimationTimeout();
	    this.setState({
	      showStaticBackdropAnimation: true
	    });
	    this._backdropAnimationTimeout = setTimeout(function () {
	      _this2.setState({
	        showStaticBackdropAnimation: false
	      });
	    }, 100);
	  };
	
	  _proto.init = function init() {
	    try {
	      this._triggeringElement = document.activeElement;
	    } catch (err) {
	      this._triggeringElement = null;
	    }
	
	    if (!this._element) {
	      this._element = document.createElement('div');
	
	      this._element.setAttribute('tabindex', '-1');
	
	      this._element.style.position = 'relative';
	      this._element.style.zIndex = this.props.zIndex;
	      this._mountContainer = (0, _utils.getTarget)(this.props.container);
	
	      this._mountContainer.appendChild(this._element);
	    }
	
	    this._originalBodyPadding = (0, _utils.getOriginalBodyPadding)();
	    (0, _utils.conditionallyUpdateScrollbar)();
	
	    if (Modal.openCount === 0) {
	      document.body.className = (0, _classnames.default)(document.body.className, (0, _utils.mapToCssModules)('modal-open', this.props.cssModule));
	    }
	
	    this.modalIndex = Modal.openCount;
	    Modal.openCount += 1;
	  };
	
	  _proto.destroy = function destroy() {
	    if (this._element) {
	      this._mountContainer.removeChild(this._element);
	
	      this._element = null;
	    }
	
	    this.manageFocusAfterClose();
	  };
	
	  _proto.manageFocusAfterClose = function manageFocusAfterClose() {
	    if (this._triggeringElement) {
	      var returnFocusAfterClose = this.props.returnFocusAfterClose;
	      if (this._triggeringElement.focus && returnFocusAfterClose) this._triggeringElement.focus();
	      this._triggeringElement = null;
	    }
	  };
	
	  _proto.close = function close() {
	    if (Modal.openCount <= 1) {
	      var modalOpenClassName = (0, _utils.mapToCssModules)('modal-open', this.props.cssModule); // Use regex to prevent matching `modal-open` as part of a different class, e.g. `my-modal-opened`
	
	      var modalOpenClassNameRegex = new RegExp("(^| )" + modalOpenClassName + "( |$)");
	      document.body.className = document.body.className.replace(modalOpenClassNameRegex, ' ').trim();
	    }
	
	    this.manageFocusAfterClose();
	    Modal.openCount = Math.max(0, Modal.openCount - 1);
	    (0, _utils.setScrollbarWidth)(this._originalBodyPadding);
	  };
	
	  _proto.renderModalDialog = function renderModalDialog() {
	    var _classNames,
	        _this3 = this;
	
	    var attributes = (0, _utils.omit)(this.props, propsToOmit);
	    var dialogBaseClass = 'modal-dialog';
	    return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, attributes, {
	      className: (0, _utils.mapToCssModules)((0, _classnames.default)(dialogBaseClass, this.props.className, (_classNames = {}, _classNames["modal-" + this.props.size] = this.props.size, _classNames[dialogBaseClass + "-centered"] = this.props.centered, _classNames[dialogBaseClass + "-scrollable"] = this.props.scrollable, _classNames)), this.props.cssModule),
	      role: "document",
	      ref: function ref(c) {
	        _this3._dialog = c;
	      }
	    }), /*#__PURE__*/_react.default.createElement("div", {
	      className: (0, _utils.mapToCssModules)((0, _classnames.default)('modal-content', this.props.contentClassName), this.props.cssModule)
	    }, this.props.children));
	  };
	
	  _proto.render = function render() {
	    var unmountOnClose = this.props.unmountOnClose;
	
	    if (!!this._element && (this.state.isOpen || !unmountOnClose)) {
	      var isModalHidden = !!this._element && !this.state.isOpen && !unmountOnClose;
	      this._element.style.display = isModalHidden ? 'none' : 'block';
	      var _this$props2 = this.props,
	          wrapClassName = _this$props2.wrapClassName,
	          modalClassName = _this$props2.modalClassName,
	          backdropClassName = _this$props2.backdropClassName,
	          cssModule = _this$props2.cssModule,
	          isOpen = _this$props2.isOpen,
	          backdrop = _this$props2.backdrop,
	          role = _this$props2.role,
	          labelledBy = _this$props2.labelledBy,
	          external = _this$props2.external,
	          innerRef = _this$props2.innerRef;
	      var modalAttributes = {
	        onClick: this.handleBackdropClick,
	        onMouseDown: this.handleBackdropMouseDown,
	        onKeyUp: this.handleEscape,
	        onKeyDown: this.handleTab,
	        style: {
	          display: 'block'
	        },
	        'aria-labelledby': labelledBy,
	        role: role,
	        tabIndex: '-1'
	      };
	      var hasTransition = this.props.fade;
	
	      var modalTransition = _objectSpread(_objectSpread(_objectSpread({}, _Fade.default.defaultProps), this.props.modalTransition), {}, {
	        baseClass: hasTransition ? this.props.modalTransition.baseClass : '',
	        timeout: hasTransition ? this.props.modalTransition.timeout : 0
	      });
	
	      var backdropTransition = _objectSpread(_objectSpread(_objectSpread({}, _Fade.default.defaultProps), this.props.backdropTransition), {}, {
	        baseClass: hasTransition ? this.props.backdropTransition.baseClass : '',
	        timeout: hasTransition ? this.props.backdropTransition.timeout : 0
	      });
	
	      var Backdrop = backdrop && (hasTransition ? /*#__PURE__*/_react.default.createElement(_Fade.default, (0, _extends2.default)({}, backdropTransition, {
	        in: isOpen && !!backdrop,
	        cssModule: cssModule,
	        className: (0, _utils.mapToCssModules)((0, _classnames.default)('modal-backdrop', backdropClassName), cssModule)
	      })) : /*#__PURE__*/_react.default.createElement("div", {
	        className: (0, _utils.mapToCssModules)((0, _classnames.default)('modal-backdrop', 'show', backdropClassName), cssModule)
	      }));
	      return /*#__PURE__*/_react.default.createElement(_Portal.default, {
	        node: this._element
	      }, /*#__PURE__*/_react.default.createElement("div", {
	        className: (0, _utils.mapToCssModules)(wrapClassName)
	      }, /*#__PURE__*/_react.default.createElement(_Fade.default, (0, _extends2.default)({}, modalAttributes, modalTransition, {
	        in: isOpen,
	        onEntered: this.onOpened,
	        onExited: this.onClosed,
	        cssModule: cssModule,
	        className: (0, _utils.mapToCssModules)((0, _classnames.default)('modal', modalClassName, this.state.showStaticBackdropAnimation && 'modal-static'), cssModule),
	        innerRef: innerRef
	      }), external, this.renderModalDialog()), Backdrop));
	    }
	
	    return null;
	  };
	
	  _proto.clearBackdropAnimationTimeout = function clearBackdropAnimationTimeout() {
	    if (this._backdropAnimationTimeout) {
	      clearTimeout(this._backdropAnimationTimeout);
	      this._backdropAnimationTimeout = undefined;
	    }
	  };
	
	  return Modal;
	}(_react.default.Component);
	
	Modal.propTypes = propTypes;
	Modal.defaultProps = defaultProps;
	Modal.openCount = 0;
	var _default = Modal;
	exports.default = _default;

/***/ },
/* 2734 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var ModalBody = function ModalBody(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'modal-body'), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	ModalBody.propTypes = propTypes;
	ModalBody.defaultProps = defaultProps;
	var _default = ModalBody;
	exports.default = _default;

/***/ },
/* 2735 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var ModalFooter = function ModalFooter(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'modal-footer'), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	ModalFooter.propTypes = propTypes;
	ModalFooter.defaultProps = defaultProps;
	var _default = ModalFooter;
	exports.default = _default;

/***/ },
/* 2736 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  wrapTag: _utils.tagPropType,
	  toggle: _propTypes.default.func,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  children: _propTypes.default.node,
	  closeAriaLabel: _propTypes.default.string,
	  charCode: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  close: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'h5',
	  wrapTag: 'div',
	  closeAriaLabel: 'Close',
	  charCode: 215
	};
	
	var ModalHeader = function ModalHeader(props) {
	  var closeButton;
	  var className = props.className,
	      cssModule = props.cssModule,
	      children = props.children,
	      toggle = props.toggle,
	      Tag = props.tag,
	      WrapTag = props.wrapTag,
	      closeAriaLabel = props.closeAriaLabel,
	      charCode = props.charCode,
	      close = props.close,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "children", "toggle", "tag", "wrapTag", "closeAriaLabel", "charCode", "close"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'modal-header'), cssModule);
	
	  if (!close && toggle) {
	    var closeIcon = typeof charCode === 'number' ? String.fromCharCode(charCode) : charCode;
	    closeButton = /*#__PURE__*/_react.default.createElement("button", {
	      type: "button",
	      onClick: toggle,
	      className: (0, _utils.mapToCssModules)('close', cssModule),
	      "aria-label": closeAriaLabel
	    }, /*#__PURE__*/_react.default.createElement("span", {
	      "aria-hidden": "true"
	    }, closeIcon));
	  }
	
	  return /*#__PURE__*/_react.default.createElement(WrapTag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }), /*#__PURE__*/_react.default.createElement(Tag, {
	    className: (0, _utils.mapToCssModules)('modal-title', cssModule)
	  }, children), close || closeButton);
	};
	
	ModalHeader.propTypes = propTypes;
	ModalHeader.defaultProps = defaultProps;
	var _default = ModalHeader;
	exports.default = _default;

/***/ },
/* 2737 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	var propTypes = {
	  tabs: _propTypes.default.bool,
	  pills: _propTypes.default.bool,
	  vertical: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
	  horizontal: _propTypes.default.string,
	  justified: _propTypes.default.bool,
	  fill: _propTypes.default.bool,
	  navbar: _propTypes.default.bool,
	  card: _propTypes.default.bool,
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'ul',
	  vertical: false
	};
	
	var getVerticalClass = function getVerticalClass(vertical) {
	  if (vertical === false) {
	    return false;
	  } else if (vertical === true || vertical === 'xs') {
	    return 'flex-column';
	  }
	
	  return "flex-" + vertical + "-column";
	};
	
	var Nav = function Nav(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      tabs = props.tabs,
	      pills = props.pills,
	      vertical = props.vertical,
	      horizontal = props.horizontal,
	      justified = props.justified,
	      fill = props.fill,
	      navbar = props.navbar,
	      card = props.card,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tabs", "pills", "vertical", "horizontal", "justified", "fill", "navbar", "card", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, navbar ? 'navbar-nav' : 'nav', horizontal ? "justify-content-" + horizontal : false, getVerticalClass(vertical), {
	    'nav-tabs': tabs,
	    'card-header-tabs': card && tabs,
	    'nav-pills': pills,
	    'card-header-pills': card && pills,
	    'nav-justified': justified,
	    'nav-fill': fill
	  }), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	Nav.propTypes = propTypes;
	Nav.defaultProps = defaultProps;
	var _default = Nav;
	exports.default = _default;

/***/ },
/* 2738 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  active: _propTypes.default.bool,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'li'
	};
	
	var NavItem = function NavItem(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      active = props.active,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "active", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'nav-item', active ? 'active' : false), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	NavItem.propTypes = propTypes;
	NavItem.defaultProps = defaultProps;
	var _default = NavItem;
	exports.default = _default;

/***/ },
/* 2739 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(20));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  innerRef: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func, _propTypes.default.string]),
	  disabled: _propTypes.default.bool,
	  active: _propTypes.default.bool,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  onClick: _propTypes.default.func,
	  href: _propTypes.default.any
	};
	var defaultProps = {
	  tag: 'a'
	};
	
	var NavLink = /*#__PURE__*/function (_React$Component) {
	  (0, _inheritsLoose2.default)(NavLink, _React$Component);
	
	  function NavLink(props) {
	    var _this;
	
	    _this = _React$Component.call(this, props) || this;
	    _this.onClick = _this.onClick.bind((0, _assertThisInitialized2.default)(_this));
	    return _this;
	  }
	
	  var _proto = NavLink.prototype;
	
	  _proto.onClick = function onClick(e) {
	    if (this.props.disabled) {
	      e.preventDefault();
	      return;
	    }
	
	    if (this.props.href === '#') {
	      e.preventDefault();
	    }
	
	    if (this.props.onClick) {
	      this.props.onClick(e);
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        className = _this$props.className,
	        cssModule = _this$props.cssModule,
	        active = _this$props.active,
	        Tag = _this$props.tag,
	        innerRef = _this$props.innerRef,
	        attributes = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["className", "cssModule", "active", "tag", "innerRef"]);
	    var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'nav-link', {
	      disabled: attributes.disabled,
	      active: active
	    }), cssModule);
	    return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	      ref: innerRef,
	      onClick: this.onClick,
	      className: classes
	    }));
	  };
	
	  return NavLink;
	}(_react.default.Component);
	
	NavLink.propTypes = propTypes;
	NavLink.defaultProps = defaultProps;
	var _default = NavLink;
	exports.default = _default;

/***/ },
/* 2740 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	var propTypes = {
	  light: _propTypes.default.bool,
	  dark: _propTypes.default.bool,
	  full: _propTypes.default.bool,
	  fixed: _propTypes.default.string,
	  sticky: _propTypes.default.string,
	  color: _propTypes.default.string,
	  role: _propTypes.default.string,
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  expand: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string])
	};
	var defaultProps = {
	  tag: 'nav',
	  expand: false
	};
	
	var getExpandClass = function getExpandClass(expand) {
	  if (expand === false) {
	    return false;
	  } else if (expand === true || expand === 'xs') {
	    return 'navbar-expand';
	  }
	
	  return "navbar-expand-" + expand;
	};
	
	var Navbar = function Navbar(props) {
	  var _classNames;
	
	  var expand = props.expand,
	      className = props.className,
	      cssModule = props.cssModule,
	      light = props.light,
	      dark = props.dark,
	      fixed = props.fixed,
	      sticky = props.sticky,
	      color = props.color,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["expand", "className", "cssModule", "light", "dark", "fixed", "sticky", "color", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'navbar', getExpandClass(expand), (_classNames = {
	    'navbar-light': light,
	    'navbar-dark': dark
	  }, _classNames["bg-" + color] = color, _classNames["fixed-" + fixed] = fixed, _classNames["sticky-" + sticky] = sticky, _classNames)), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	Navbar.propTypes = propTypes;
	Navbar.defaultProps = defaultProps;
	var _default = Navbar;
	exports.default = _default;

/***/ },
/* 2741 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'a'
	};
	
	var NavbarBrand = function NavbarBrand(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'navbar-brand'), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	NavbarBrand.propTypes = propTypes;
	NavbarBrand.defaultProps = defaultProps;
	var _default = NavbarBrand;
	exports.default = _default;

/***/ },
/* 2742 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'span'
	};
	
	var NavbarText = function NavbarText(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      active = props.active,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "active", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'navbar-text'), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	NavbarText.propTypes = propTypes;
	NavbarText.defaultProps = defaultProps;
	var _default = NavbarText;
	exports.default = _default;

/***/ },
/* 2743 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  type: _propTypes.default.string,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  children: _propTypes.default.node
	};
	var defaultProps = {
	  tag: 'button',
	  type: 'button'
	};
	
	var NavbarToggler = function NavbarToggler(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      children = props.children,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "children", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'navbar-toggler'), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({
	    "aria-label": "Toggle navigation"
	  }, attributes, {
	    className: classes
	  }), children || /*#__PURE__*/_react.default.createElement("span", {
	    className: (0, _utils.mapToCssModules)('navbar-toggler-icon', cssModule)
	  }));
	};
	
	NavbarToggler.propTypes = propTypes;
	NavbarToggler.defaultProps = defaultProps;
	var _default = NavbarToggler;
	exports.default = _default;

/***/ },
/* 2744 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	var propTypes = {
	  children: _propTypes.default.node,
	  className: _propTypes.default.string,
	  listClassName: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  size: _propTypes.default.string,
	  tag: _utils.tagPropType,
	  listTag: _utils.tagPropType,
	  'aria-label': _propTypes.default.string
	};
	var defaultProps = {
	  tag: 'nav',
	  listTag: 'ul',
	  'aria-label': 'pagination'
	};
	
	var Pagination = function Pagination(props) {
	  var _classNames;
	
	  var className = props.className,
	      listClassName = props.listClassName,
	      cssModule = props.cssModule,
	      size = props.size,
	      Tag = props.tag,
	      ListTag = props.listTag,
	      label = props['aria-label'],
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "listClassName", "cssModule", "size", "tag", "listTag", "aria-label"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className), cssModule);
	  var listClasses = (0, _utils.mapToCssModules)((0, _classnames.default)(listClassName, 'pagination', (_classNames = {}, _classNames["pagination-" + size] = !!size, _classNames)), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, {
	    className: classes,
	    "aria-label": label
	  }, /*#__PURE__*/_react.default.createElement(ListTag, (0, _extends2.default)({}, attributes, {
	    className: listClasses
	  })));
	};
	
	Pagination.propTypes = propTypes;
	Pagination.defaultProps = defaultProps;
	var _default = Pagination;
	exports.default = _default;

/***/ },
/* 2745 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	var propTypes = {
	  active: _propTypes.default.bool,
	  children: _propTypes.default.node,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  disabled: _propTypes.default.bool,
	  tag: _utils.tagPropType
	};
	var defaultProps = {
	  tag: 'li'
	};
	
	var PaginationItem = function PaginationItem(props) {
	  var active = props.active,
	      className = props.className,
	      cssModule = props.cssModule,
	      disabled = props.disabled,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["active", "className", "cssModule", "disabled", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'page-item', {
	    active: active,
	    disabled: disabled
	  }), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	PaginationItem.propTypes = propTypes;
	PaginationItem.defaultProps = defaultProps;
	var _default = PaginationItem;
	exports.default = _default;

/***/ },
/* 2746 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	var propTypes = {
	  'aria-label': _propTypes.default.string,
	  children: _propTypes.default.node,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  next: _propTypes.default.bool,
	  previous: _propTypes.default.bool,
	  first: _propTypes.default.bool,
	  last: _propTypes.default.bool,
	  tag: _utils.tagPropType
	};
	var defaultProps = {
	  tag: 'a'
	};
	
	var PaginationLink = function PaginationLink(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      next = props.next,
	      previous = props.previous,
	      first = props.first,
	      last = props.last,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "next", "previous", "first", "last", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'page-link'), cssModule);
	  var defaultAriaLabel;
	
	  if (previous) {
	    defaultAriaLabel = 'Previous';
	  } else if (next) {
	    defaultAriaLabel = 'Next';
	  } else if (first) {
	    defaultAriaLabel = 'First';
	  } else if (last) {
	    defaultAriaLabel = 'Last';
	  }
	
	  var ariaLabel = props['aria-label'] || defaultAriaLabel;
	  var defaultCaret;
	
	  if (previous) {
	    defaultCaret = "\u2039";
	  } else if (next) {
	    defaultCaret = "\u203A";
	  } else if (first) {
	    defaultCaret = "\xAB";
	  } else if (last) {
	    defaultCaret = "\xBB";
	  }
	
	  var children = props.children;
	
	  if (children && Array.isArray(children) && children.length === 0) {
	    children = null;
	  }
	
	  if (!attributes.href && Tag === 'a') {
	    Tag = 'button';
	  }
	
	  if (previous || next || first || last) {
	    children = [/*#__PURE__*/_react.default.createElement("span", {
	      "aria-hidden": "true",
	      key: "caret"
	    }, children || defaultCaret), /*#__PURE__*/_react.default.createElement("span", {
	      className: "sr-only",
	      key: "sr"
	    }, ariaLabel)];
	  }
	
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes,
	    "aria-label": ariaLabel
	  }), children);
	};
	
	PaginationLink.propTypes = propTypes;
	PaginationLink.defaultProps = defaultProps;
	var _default = PaginationLink;
	exports.default = _default;

/***/ },
/* 2747 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _TooltipPopoverWrapper = _interopRequireWildcard(__webpack_require__(__webpack_module_template_argument_0__));
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var defaultProps = {
	  placement: 'right',
	  placementPrefix: 'bs-popover',
	  trigger: 'click'
	};
	
	var Popover = function Popover(props) {
	  var popperClasses = (0, _classnames.default)('popover', 'show', props.popperClassName);
	  var classes = (0, _classnames.default)('popover-inner', props.innerClassName);
	  return /*#__PURE__*/_react.default.createElement(_TooltipPopoverWrapper.default, (0, _extends2.default)({}, props, {
	    popperClassName: popperClasses,
	    innerClassName: classes
	  }));
	};
	
	Popover.propTypes = _TooltipPopoverWrapper.propTypes;
	Popover.defaultProps = defaultProps;
	var _default = Popover;
	exports.default = _default;

/***/ },
/* 2748 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var PopoverBody = function PopoverBody(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'popover-body'), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	PopoverBody.propTypes = propTypes;
	PopoverBody.defaultProps = defaultProps;
	var _default = PopoverBody;
	exports.default = _default;

/***/ },
/* 2749 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'h3'
	};
	
	var PopoverHeader = function PopoverHeader(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'popover-header'), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	PopoverHeader.propTypes = propTypes;
	PopoverHeader.defaultProps = defaultProps;
	var _default = PopoverHeader;
	exports.default = _default;

/***/ },
/* 2750 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(20));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(27));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(31));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _reactPopper = __webpack_require__(75);
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Fade = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_1__));
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function noop() {}
	
	var propTypes = {
	  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]).isRequired,
	  popperClassName: _propTypes.default.string,
	  placement: _propTypes.default.string,
	  placementPrefix: _propTypes.default.string,
	  arrowClassName: _propTypes.default.string,
	  hideArrow: _propTypes.default.bool,
	  tag: _utils.tagPropType,
	  isOpen: _propTypes.default.bool.isRequired,
	  cssModule: _propTypes.default.object,
	  offset: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  fallbackPlacement: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.array]),
	  flip: _propTypes.default.bool,
	  container: _utils.targetPropType,
	  target: _utils.targetPropType.isRequired,
	  modifiers: _propTypes.default.object,
	  positionFixed: _propTypes.default.bool,
	  boundariesElement: _propTypes.default.oneOfType([_propTypes.default.string, _utils.DOMElement]),
	  onClosed: _propTypes.default.func,
	  fade: _propTypes.default.bool,
	  transition: _propTypes.default.shape(_Fade.default.propTypes)
	};
	var defaultProps = {
	  boundariesElement: 'scrollParent',
	  placement: 'auto',
	  hideArrow: false,
	  isOpen: false,
	  offset: 0,
	  fallbackPlacement: 'flip',
	  flip: true,
	  container: 'body',
	  modifiers: {},
	  onClosed: noop,
	  fade: true,
	  transition: _objectSpread({}, _Fade.default.defaultProps)
	};
	
	var PopperContent = /*#__PURE__*/function (_React$Component) {
	  (0, _inheritsLoose2.default)(PopperContent, _React$Component);
	
	  function PopperContent(props) {
	    var _this;
	
	    _this = _React$Component.call(this, props) || this;
	    _this.setTargetNode = _this.setTargetNode.bind((0, _assertThisInitialized2.default)(_this));
	    _this.getTargetNode = _this.getTargetNode.bind((0, _assertThisInitialized2.default)(_this));
	    _this.getRef = _this.getRef.bind((0, _assertThisInitialized2.default)(_this));
	    _this.onClosed = _this.onClosed.bind((0, _assertThisInitialized2.default)(_this));
	    _this.state = {
	      isOpen: props.isOpen
	    };
	    return _this;
	  }
	
	  PopperContent.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
	    if (props.isOpen && !state.isOpen) {
	      return {
	        isOpen: props.isOpen
	      };
	    } else return null;
	  };
	
	  var _proto = PopperContent.prototype;
	
	  _proto.componentDidUpdate = function componentDidUpdate() {
	    if (this._element && this._element.childNodes && this._element.childNodes[0] && this._element.childNodes[0].focus) {
	      this._element.childNodes[0].focus();
	    }
	  };
	
	  _proto.setTargetNode = function setTargetNode(node) {
	    this.targetNode = typeof node === 'string' ? (0, _utils.getTarget)(node) : node;
	  };
	
	  _proto.getTargetNode = function getTargetNode() {
	    return this.targetNode;
	  };
	
	  _proto.getContainerNode = function getContainerNode() {
	    return (0, _utils.getTarget)(this.props.container);
	  };
	
	  _proto.getRef = function getRef(ref) {
	    this._element = ref;
	  };
	
	  _proto.onClosed = function onClosed() {
	    this.props.onClosed();
	    this.setState({
	      isOpen: false
	    });
	  };
	
	  _proto.renderChildren = function renderChildren() {
	    var _this$props = this.props,
	        cssModule = _this$props.cssModule,
	        children = _this$props.children,
	        isOpen = _this$props.isOpen,
	        flip = _this$props.flip,
	        target = _this$props.target,
	        offset = _this$props.offset,
	        fallbackPlacement = _this$props.fallbackPlacement,
	        placementPrefix = _this$props.placementPrefix,
	        _arrowClassName = _this$props.arrowClassName,
	        hideArrow = _this$props.hideArrow,
	        _popperClassName = _this$props.popperClassName,
	        tag = _this$props.tag,
	        container = _this$props.container,
	        modifiers = _this$props.modifiers,
	        positionFixed = _this$props.positionFixed,
	        boundariesElement = _this$props.boundariesElement,
	        onClosed = _this$props.onClosed,
	        fade = _this$props.fade,
	        transition = _this$props.transition,
	        placement = _this$props.placement,
	        attrs = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["cssModule", "children", "isOpen", "flip", "target", "offset", "fallbackPlacement", "placementPrefix", "arrowClassName", "hideArrow", "popperClassName", "tag", "container", "modifiers", "positionFixed", "boundariesElement", "onClosed", "fade", "transition", "placement"]);
	    var arrowClassName = (0, _utils.mapToCssModules)((0, _classnames.default)('arrow', _arrowClassName), cssModule);
	    var popperClassName = (0, _utils.mapToCssModules)((0, _classnames.default)(_popperClassName, placementPrefix ? placementPrefix + "-auto" : ''), this.props.cssModule);
	
	    var extendedModifiers = _objectSpread({
	      offset: {
	        offset: offset
	      },
	      flip: {
	        enabled: flip,
	        behavior: fallbackPlacement
	      },
	      preventOverflow: {
	        boundariesElement: boundariesElement
	      }
	    }, modifiers);
	
	    var popperTransition = _objectSpread(_objectSpread(_objectSpread({}, _Fade.default.defaultProps), transition), {}, {
	      baseClass: fade ? transition.baseClass : '',
	      timeout: fade ? transition.timeout : 0
	    });
	
	    return /*#__PURE__*/_react.default.createElement(_Fade.default, (0, _extends2.default)({}, popperTransition, attrs, {
	      in: isOpen,
	      onExited: this.onClosed,
	      tag: tag
	    }), /*#__PURE__*/_react.default.createElement(_reactPopper.Popper, {
	      referenceElement: this.targetNode,
	      modifiers: extendedModifiers,
	      placement: placement,
	      positionFixed: positionFixed
	    }, function (_ref) {
	      var ref = _ref.ref,
	          style = _ref.style,
	          placement = _ref.placement,
	          outOfBoundaries = _ref.outOfBoundaries,
	          arrowProps = _ref.arrowProps,
	          scheduleUpdate = _ref.scheduleUpdate;
	      return /*#__PURE__*/_react.default.createElement("div", {
	        ref: ref,
	        style: style,
	        className: popperClassName,
	        "x-placement": placement,
	        "x-out-of-boundaries": outOfBoundaries ? 'true' : undefined
	      }, typeof children === 'function' ? children({
	        scheduleUpdate: scheduleUpdate
	      }) : children, !hideArrow && /*#__PURE__*/_react.default.createElement("span", {
	        ref: arrowProps.ref,
	        className: arrowClassName,
	        style: arrowProps.style
	      }));
	    }));
	  };
	
	  _proto.render = function render() {
	    this.setTargetNode(this.props.target);
	
	    if (this.state.isOpen) {
	      return this.props.container === 'inline' ? this.renderChildren() : /*#__PURE__*/_reactDom.default.createPortal( /*#__PURE__*/_react.default.createElement("div", {
	        ref: this.getRef
	      }, this.renderChildren()), this.getContainerNode());
	    }
	
	    return null;
	  };
	
	  return PopperContent;
	}(_react.default.Component);
	
	PopperContent.propTypes = propTypes;
	PopperContent.defaultProps = defaultProps;
	var _default = PopperContent;
	exports.default = _default;

/***/ },
/* 2751 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	var PopperTargetHelper = function PopperTargetHelper(props, context) {
	  context.popperManager.setTargetNode((0, _utils.getTarget)(props.target));
	  return null;
	};
	
	PopperTargetHelper.contextTypes = {
	  popperManager: _propTypes.default.object.isRequired
	};
	PopperTargetHelper.propTypes = {
	  target: _utils.targetPropType.isRequired
	};
	var _default = PopperTargetHelper;
	exports.default = _default;

/***/ },
/* 2752 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(20));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(31));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	var propTypes = {
	  children: _propTypes.default.node.isRequired,
	  node: _propTypes.default.any
	};
	
	var Portal = /*#__PURE__*/function (_React$Component) {
	  (0, _inheritsLoose2.default)(Portal, _React$Component);
	
	  function Portal() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = Portal.prototype;
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    if (this.defaultNode) {
	      document.body.removeChild(this.defaultNode);
	    }
	
	    this.defaultNode = null;
	  };
	
	  _proto.render = function render() {
	    if (!_utils.canUseDOM) {
	      return null;
	    }
	
	    if (!this.props.node && !this.defaultNode) {
	      this.defaultNode = document.createElement('div');
	      document.body.appendChild(this.defaultNode);
	    }
	
	    return /*#__PURE__*/_reactDom.default.createPortal(this.props.children, this.props.node || this.defaultNode);
	  };
	
	  return Portal;
	}(_react.default.Component);
	
	Portal.propTypes = propTypes;
	var _default = Portal;
	exports.default = _default;

/***/ },
/* 2753 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(27));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	var propTypes = {
	  children: _propTypes.default.node,
	  bar: _propTypes.default.bool,
	  multi: _propTypes.default.bool,
	  tag: _utils.tagPropType,
	  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  min: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  max: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  animated: _propTypes.default.bool,
	  striped: _propTypes.default.bool,
	  color: _propTypes.default.string,
	  className: _propTypes.default.string,
	  barClassName: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  style: _propTypes.default.object,
	  barStyle: _propTypes.default.object,
	  barAriaValueText: _propTypes.default.string,
	  barAriaLabelledBy: _propTypes.default.string
	};
	var defaultProps = {
	  tag: 'div',
	  value: 0,
	  min: 0,
	  max: 100,
	  style: {},
	  barStyle: {}
	};
	
	var Progress = function Progress(props) {
	  var children = props.children,
	      className = props.className,
	      barClassName = props.barClassName,
	      cssModule = props.cssModule,
	      value = props.value,
	      min = props.min,
	      max = props.max,
	      animated = props.animated,
	      striped = props.striped,
	      color = props.color,
	      bar = props.bar,
	      multi = props.multi,
	      Tag = props.tag,
	      style = props.style,
	      barStyle = props.barStyle,
	      barAriaValueText = props.barAriaValueText,
	      barAriaLabelledBy = props.barAriaLabelledBy,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["children", "className", "barClassName", "cssModule", "value", "min", "max", "animated", "striped", "color", "bar", "multi", "tag", "style", "barStyle", "barAriaValueText", "barAriaLabelledBy"]);
	  var percent = (0, _utils.toNumber)(value) / (0, _utils.toNumber)(max) * 100;
	  var progressClasses = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'progress'), cssModule);
	  var progressBarClasses = (0, _utils.mapToCssModules)((0, _classnames.default)('progress-bar', bar ? className || barClassName : barClassName, animated ? 'progress-bar-animated' : null, color ? "bg-" + color : null, striped || animated ? 'progress-bar-striped' : null), cssModule);
	  var progressBarProps = {
	    className: progressBarClasses,
	    style: _objectSpread(_objectSpread(_objectSpread({}, bar ? style : {}), barStyle), {}, {
	      width: percent + "%"
	    }),
	    role: 'progressbar',
	    'aria-valuenow': value,
	    'aria-valuemin': min,
	    'aria-valuemax': max,
	    'aria-valuetext': barAriaValueText,
	    'aria-labelledby': barAriaLabelledBy,
	    children: children
	  };
	
	  if (bar) {
	    return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, progressBarProps));
	  }
	
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    style: style,
	    className: progressClasses
	  }), multi ? children : /*#__PURE__*/_react.default.createElement("div", progressBarProps));
	};
	
	Progress.propTypes = propTypes;
	Progress.defaultProps = defaultProps;
	var _default = Progress;
	exports.default = _default;

/***/ },
/* 2754 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	var rowColWidths = ['xs', 'sm', 'md', 'lg', 'xl'];
	
	var rowColsPropType = _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  noGutters: _propTypes.default.bool,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  form: _propTypes.default.bool,
	  xs: rowColsPropType,
	  sm: rowColsPropType,
	  md: rowColsPropType,
	  lg: rowColsPropType,
	  xl: rowColsPropType
	};
	var defaultProps = {
	  tag: 'div',
	  widths: rowColWidths
	};
	
	var Row = function Row(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      noGutters = props.noGutters,
	      Tag = props.tag,
	      form = props.form,
	      widths = props.widths,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "noGutters", "tag", "form", "widths"]);
	  var colClasses = [];
	  widths.forEach(function (colWidth, i) {
	    var colSize = props[colWidth];
	    delete attributes[colWidth];
	
	    if (!colSize) {
	      return;
	    }
	
	    var isXs = !i;
	    colClasses.push(isXs ? "row-cols-" + colSize : "row-cols-" + colWidth + "-" + colSize);
	  });
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, noGutters ? 'no-gutters' : null, form ? 'form-row' : 'row', colClasses), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	Row.propTypes = propTypes;
	Row.defaultProps = defaultProps;
	var _default = Row;
	exports.default = _default;

/***/ },
/* 2755 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  type: _propTypes.default.string,
	  size: _propTypes.default.string,
	  color: _propTypes.default.string,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  children: _propTypes.default.string
	};
	var defaultProps = {
	  tag: 'div',
	  type: 'border',
	  children: 'Loading...'
	};
	
	var Spinner = function Spinner(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      type = props.type,
	      size = props.size,
	      color = props.color,
	      children = props.children,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "type", "size", "color", "children", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, size ? "spinner-" + type + "-" + size : false, "spinner-" + type, color ? "text-" + color : false), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({
	    role: "status"
	  }, attributes, {
	    className: classes
	  }), children && /*#__PURE__*/_react.default.createElement("span", {
	    className: (0, _utils.mapToCssModules)('sr-only', cssModule)
	  }, children));
	};
	
	Spinner.propTypes = propTypes;
	Spinner.defaultProps = defaultProps;
	var _default = Spinner;
	exports.default = _default;

/***/ },
/* 2756 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(20));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _TabContext = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _utils = __webpack_require__(__webpack_module_template_argument_1__);
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  activeTab: _propTypes.default.any,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var TabContent = /*#__PURE__*/function (_Component) {
	  (0, _inheritsLoose2.default)(TabContent, _Component);
	
	  TabContent.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
	    if (prevState.activeTab !== nextProps.activeTab) {
	      return {
	        activeTab: nextProps.activeTab
	      };
	    }
	
	    return null;
	  };
	
	  function TabContent(props) {
	    var _this;
	
	    _this = _Component.call(this, props) || this;
	    _this.state = {
	      activeTab: _this.props.activeTab
	    };
	    return _this;
	  }
	
	  var _proto = TabContent.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        className = _this$props.className,
	        cssModule = _this$props.cssModule,
	        Tag = _this$props.tag;
	    var attributes = (0, _utils.omit)(this.props, Object.keys(propTypes));
	    var classes = (0, _utils.mapToCssModules)((0, _classnames.default)('tab-content', className), cssModule);
	    return /*#__PURE__*/_react.default.createElement(_TabContext.TabContext.Provider, {
	      value: {
	        activeTabId: this.state.activeTab
	      }
	    }, /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	      className: classes
	    })));
	  };
	
	  return TabContent;
	}(_react.Component);
	
	var _default = TabContent;
	exports.default = _default;
	TabContent.propTypes = propTypes;
	TabContent.defaultProps = defaultProps;

/***/ },
/* 2757 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = TabPane;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _TabContext = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _utils = __webpack_require__(__webpack_module_template_argument_1__);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  tabId: _propTypes.default.any
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	function TabPane(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      tabId = props.tabId,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tabId", "tag"]);
	
	  var getClasses = function getClasses(activeTabId) {
	    return (0, _utils.mapToCssModules)((0, _classnames.default)('tab-pane', className, {
	      active: tabId === activeTabId
	    }), cssModule);
	  };
	
	  return /*#__PURE__*/_react.default.createElement(_TabContext.TabContext.Consumer, null, function (_ref) {
	    var activeTabId = _ref.activeTabId;
	    return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	      className: getClasses(activeTabId)
	    }));
	  });
	}
	
	TabPane.propTypes = propTypes;
	TabPane.defaultProps = defaultProps;

/***/ },
/* 2758 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	var propTypes = {
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  size: _propTypes.default.string,
	  bordered: _propTypes.default.bool,
	  borderless: _propTypes.default.bool,
	  striped: _propTypes.default.bool,
	  dark: _propTypes.default.bool,
	  hover: _propTypes.default.bool,
	  responsive: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
	  tag: _utils.tagPropType,
	  responsiveTag: _utils.tagPropType,
	  innerRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.string, _propTypes.default.object])
	};
	var defaultProps = {
	  tag: 'table',
	  responsiveTag: 'div'
	};
	
	var Table = function Table(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      size = props.size,
	      bordered = props.bordered,
	      borderless = props.borderless,
	      striped = props.striped,
	      dark = props.dark,
	      hover = props.hover,
	      responsive = props.responsive,
	      Tag = props.tag,
	      ResponsiveTag = props.responsiveTag,
	      innerRef = props.innerRef,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "size", "bordered", "borderless", "striped", "dark", "hover", "responsive", "tag", "responsiveTag", "innerRef"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'table', size ? 'table-' + size : false, bordered ? 'table-bordered' : false, borderless ? 'table-borderless' : false, striped ? 'table-striped' : false, dark ? 'table-dark' : false, hover ? 'table-hover' : false), cssModule);
	
	  var table = /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    ref: innerRef,
	    className: classes
	  }));
	
	  if (responsive) {
	    var responsiveClassName = (0, _utils.mapToCssModules)(responsive === true ? 'table-responsive' : "table-responsive-" + responsive, cssModule);
	    return /*#__PURE__*/_react.default.createElement(ResponsiveTag, {
	      className: responsiveClassName
	    }, table);
	  }
	
	  return table;
	};
	
	Table.propTypes = propTypes;
	Table.defaultProps = defaultProps;
	var _default = Table;
	exports.default = _default;

/***/ },
/* 2759 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(27));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Fade = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_1__));
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	var propTypes = {
	  children: _propTypes.default.node,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  fade: _propTypes.default.bool,
	  isOpen: _propTypes.default.bool,
	  tag: _utils.tagPropType,
	  transition: _propTypes.default.shape(_Fade.default.propTypes),
	  innerRef: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string, _propTypes.default.func])
	};
	var defaultProps = {
	  isOpen: true,
	  tag: 'div',
	  fade: true,
	  transition: _objectSpread(_objectSpread({}, _Fade.default.defaultProps), {}, {
	    unmountOnExit: true
	  })
	};
	
	function Toast(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      isOpen = props.isOpen,
	      children = props.children,
	      transition = props.transition,
	      fade = props.fade,
	      innerRef = props.innerRef,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag", "isOpen", "children", "transition", "fade", "innerRef"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'toast'), cssModule);
	
	  var toastTransition = _objectSpread(_objectSpread(_objectSpread({}, _Fade.default.defaultProps), transition), {}, {
	    baseClass: fade ? transition.baseClass : '',
	    timeout: fade ? transition.timeout : 0
	  });
	
	  return /*#__PURE__*/_react.default.createElement(_Fade.default, (0, _extends2.default)({}, attributes, toastTransition, {
	    tag: Tag,
	    className: classes,
	    in: isOpen,
	    role: "alert",
	    innerRef: innerRef
	  }), children);
	}
	
	Toast.propTypes = propTypes;
	Toast.defaultProps = defaultProps;
	var _default = Toast;
	exports.default = _default;

/***/ },
/* 2760 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  innerRef: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string, _propTypes.default.func])
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var ToastBody = function ToastBody(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      innerRef = props.innerRef,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "innerRef", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'toast-body'), cssModule);
	  return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes,
	    ref: innerRef
	  }));
	};
	
	ToastBody.propTypes = propTypes;
	ToastBody.defaultProps = defaultProps;
	var _default = ToastBody;
	exports.default = _default;

/***/ },
/* 2761 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  icon: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
	  wrapTag: _utils.tagPropType,
	  toggle: _propTypes.default.func,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  children: _propTypes.default.node,
	  closeAriaLabel: _propTypes.default.string,
	  charCode: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  close: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'strong',
	  wrapTag: 'div',
	  tagClassName: 'mr-auto',
	  closeAriaLabel: 'Close',
	  charCode: 215
	};
	
	var ToastHeader = function ToastHeader(props) {
	  var closeButton;
	  var icon;
	  var className = props.className,
	      cssModule = props.cssModule,
	      children = props.children,
	      toggle = props.toggle,
	      Tag = props.tag,
	      WrapTag = props.wrapTag,
	      closeAriaLabel = props.closeAriaLabel,
	      charCode = props.charCode,
	      close = props.close,
	      tagClassName = props.tagClassName,
	      iconProp = props.icon,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "children", "toggle", "tag", "wrapTag", "closeAriaLabel", "charCode", "close", "tagClassName", "icon"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'toast-header'), cssModule);
	
	  if (!close && toggle) {
	    var closeIcon = typeof charCode === 'number' ? String.fromCharCode(charCode) : charCode;
	    closeButton = /*#__PURE__*/_react.default.createElement("button", {
	      type: "button",
	      onClick: toggle,
	      className: (0, _utils.mapToCssModules)('close', cssModule),
	      "aria-label": closeAriaLabel
	    }, /*#__PURE__*/_react.default.createElement("span", {
	      "aria-hidden": "true"
	    }, closeIcon));
	  }
	
	  if (typeof iconProp === "string") {
	    icon = /*#__PURE__*/_react.default.createElement("svg", {
	      className: (0, _utils.mapToCssModules)("rounded text-" + iconProp),
	      width: "20",
	      height: "20",
	      xmlns: "http://www.w3.org/2000/svg",
	      preserveAspectRatio: "xMidYMid slice",
	      focusable: "false",
	      role: "img"
	    }, /*#__PURE__*/_react.default.createElement("rect", {
	      fill: "currentColor",
	      width: "100%",
	      height: "100%"
	    }));
	  } else if (iconProp) {
	    icon = iconProp;
	  }
	
	  return /*#__PURE__*/_react.default.createElement(WrapTag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }), icon, /*#__PURE__*/_react.default.createElement(Tag, {
	    className: (0, _utils.mapToCssModules)((0, _classnames.default)(tagClassName, {
	      "ml-2": icon != null
	    }), cssModule)
	  }, children), close || closeButton);
	};
	
	ToastHeader.propTypes = propTypes;
	ToastHeader.defaultProps = defaultProps;
	var _default = ToastHeader;
	exports.default = _default;

/***/ },
/* 2762 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _TooltipPopoverWrapper = _interopRequireWildcard(__webpack_require__(__webpack_module_template_argument_0__));
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var defaultProps = {
	  placement: 'top',
	  autohide: true,
	  placementPrefix: 'bs-tooltip',
	  trigger: 'hover focus'
	};
	
	var Tooltip = function Tooltip(props) {
	  var popperClasses = (0, _classnames.default)('tooltip', 'show', props.popperClassName);
	  var classes = (0, _classnames.default)('tooltip-inner', props.innerClassName);
	  return /*#__PURE__*/_react.default.createElement(_TooltipPopoverWrapper.default, (0, _extends2.default)({}, props, {
	    popperClassName: popperClasses,
	    innerClassName: classes
	  }));
	};
	
	Tooltip.propTypes = _TooltipPopoverWrapper.propTypes;
	Tooltip.defaultProps = defaultProps;
	var _default = Tooltip;
	exports.default = _default;

/***/ },
/* 2763 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = exports.propTypes = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(20));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _PopperContent = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_1__);
	
	var propTypes = {
	  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),
	  placement: _propTypes.default.oneOf(_utils.PopperPlacements),
	  target: _utils.targetPropType.isRequired,
	  container: _utils.targetPropType,
	  isOpen: _propTypes.default.bool,
	  disabled: _propTypes.default.bool,
	  hideArrow: _propTypes.default.bool,
	  boundariesElement: _propTypes.default.oneOfType([_propTypes.default.string, _utils.DOMElement]),
	  className: _propTypes.default.string,
	  innerClassName: _propTypes.default.string,
	  arrowClassName: _propTypes.default.string,
	  popperClassName: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  toggle: _propTypes.default.func,
	  autohide: _propTypes.default.bool,
	  placementPrefix: _propTypes.default.string,
	  delay: _propTypes.default.oneOfType([_propTypes.default.shape({
	    show: _propTypes.default.number,
	    hide: _propTypes.default.number
	  }), _propTypes.default.number]),
	  modifiers: _propTypes.default.object,
	  positionFixed: _propTypes.default.bool,
	  offset: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  innerRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.string, _propTypes.default.object]),
	  trigger: _propTypes.default.string,
	  fade: _propTypes.default.bool,
	  flip: _propTypes.default.bool
	};
	exports.propTypes = propTypes;
	var DEFAULT_DELAYS = {
	  show: 0,
	  hide: 50
	};
	var defaultProps = {
	  isOpen: false,
	  hideArrow: false,
	  autohide: false,
	  delay: DEFAULT_DELAYS,
	  toggle: function toggle() {},
	  trigger: 'click',
	  fade: true
	};
	
	function isInDOMSubtree(element, subtreeRoot) {
	  return subtreeRoot && (element === subtreeRoot || subtreeRoot.contains(element));
	}
	
	function isInDOMSubtrees(element, subtreeRoots) {
	  if (subtreeRoots === void 0) {
	    subtreeRoots = [];
	  }
	
	  return subtreeRoots && subtreeRoots.length && subtreeRoots.filter(function (subTreeRoot) {
	    return isInDOMSubtree(element, subTreeRoot);
	  })[0];
	}
	
	var TooltipPopoverWrapper = /*#__PURE__*/function (_React$Component) {
	  (0, _inheritsLoose2.default)(TooltipPopoverWrapper, _React$Component);
	
	  function TooltipPopoverWrapper(props) {
	    var _this;
	
	    _this = _React$Component.call(this, props) || this;
	    _this._targets = [];
	    _this.currentTargetElement = null;
	    _this.addTargetEvents = _this.addTargetEvents.bind((0, _assertThisInitialized2.default)(_this));
	    _this.handleDocumentClick = _this.handleDocumentClick.bind((0, _assertThisInitialized2.default)(_this));
	    _this.removeTargetEvents = _this.removeTargetEvents.bind((0, _assertThisInitialized2.default)(_this));
	    _this.toggle = _this.toggle.bind((0, _assertThisInitialized2.default)(_this));
	    _this.showWithDelay = _this.showWithDelay.bind((0, _assertThisInitialized2.default)(_this));
	    _this.hideWithDelay = _this.hideWithDelay.bind((0, _assertThisInitialized2.default)(_this));
	    _this.onMouseOverTooltipContent = _this.onMouseOverTooltipContent.bind((0, _assertThisInitialized2.default)(_this));
	    _this.onMouseLeaveTooltipContent = _this.onMouseLeaveTooltipContent.bind((0, _assertThisInitialized2.default)(_this));
	    _this.show = _this.show.bind((0, _assertThisInitialized2.default)(_this));
	    _this.hide = _this.hide.bind((0, _assertThisInitialized2.default)(_this));
	    _this.onEscKeyDown = _this.onEscKeyDown.bind((0, _assertThisInitialized2.default)(_this));
	    _this.getRef = _this.getRef.bind((0, _assertThisInitialized2.default)(_this));
	    _this.state = {
	      isOpen: props.isOpen
	    };
	    _this._isMounted = false;
	    return _this;
	  }
	
	  var _proto = TooltipPopoverWrapper.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this._isMounted = true;
	    this.updateTarget();
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this._isMounted = false;
	    this.removeTargetEvents();
	    this._targets = null;
	    this.clearShowTimeout();
	    this.clearHideTimeout();
	  };
	
	  TooltipPopoverWrapper.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
	    if (props.isOpen && !state.isOpen) {
	      return {
	        isOpen: props.isOpen
	      };
	    } else return null;
	  };
	
	  _proto.onMouseOverTooltipContent = function onMouseOverTooltipContent() {
	    if (this.props.trigger.indexOf('hover') > -1 && !this.props.autohide) {
	      if (this._hideTimeout) {
	        this.clearHideTimeout();
	      }
	
	      if (this.state.isOpen && !this.props.isOpen) {
	        this.toggle();
	      }
	    }
	  };
	
	  _proto.onMouseLeaveTooltipContent = function onMouseLeaveTooltipContent(e) {
	    if (this.props.trigger.indexOf('hover') > -1 && !this.props.autohide) {
	      if (this._showTimeout) {
	        this.clearShowTimeout();
	      }
	
	      e.persist();
	      this._hideTimeout = setTimeout(this.hide.bind(this, e), this.getDelay('hide'));
	    }
	  };
	
	  _proto.onEscKeyDown = function onEscKeyDown(e) {
	    if (e.key === 'Escape') {
	      this.hide(e);
	    }
	  };
	
	  _proto.getRef = function getRef(ref) {
	    var innerRef = this.props.innerRef;
	
	    if (innerRef) {
	      if (typeof innerRef === 'function') {
	        innerRef(ref);
	      } else if (typeof innerRef === 'object') {
	        innerRef.current = ref;
	      }
	    }
	
	    this._popover = ref;
	  };
	
	  _proto.getDelay = function getDelay(key) {
	    var delay = this.props.delay;
	
	    if (typeof delay === 'object') {
	      return isNaN(delay[key]) ? DEFAULT_DELAYS[key] : delay[key];
	    }
	
	    return delay;
	  };
	
	  _proto.getCurrentTarget = function getCurrentTarget(target) {
	    if (!target) return null;
	
	    var index = this._targets.indexOf(target);
	
	    if (index >= 0) return this._targets[index];
	    return this.getCurrentTarget(target.parentElement);
	  };
	
	  _proto.show = function show(e) {
	    if (!this.props.isOpen) {
	      this.clearShowTimeout();
	      this.currentTargetElement = e ? e.currentTarget || this.getCurrentTarget(e.target) : null;
	
	      if (e && e.composedPath && typeof e.composedPath === 'function') {
	        var path = e.composedPath();
	        this.currentTargetElement = path && path[0] || this.currentTargetElement;
	      }
	
	      this.toggle(e);
	    }
	  };
	
	  _proto.showWithDelay = function showWithDelay(e) {
	    if (this._hideTimeout) {
	      this.clearHideTimeout();
	    }
	
	    this._showTimeout = setTimeout(this.show.bind(this, e), this.getDelay('show'));
	  };
	
	  _proto.hide = function hide(e) {
	    if (this.props.isOpen) {
	      this.clearHideTimeout();
	      this.currentTargetElement = null;
	      this.toggle(e);
	    }
	  };
	
	  _proto.hideWithDelay = function hideWithDelay(e) {
	    if (this._showTimeout) {
	      this.clearShowTimeout();
	    }
	
	    this._hideTimeout = setTimeout(this.hide.bind(this, e), this.getDelay('hide'));
	  };
	
	  _proto.clearShowTimeout = function clearShowTimeout() {
	    clearTimeout(this._showTimeout);
	    this._showTimeout = undefined;
	  };
	
	  _proto.clearHideTimeout = function clearHideTimeout() {
	    clearTimeout(this._hideTimeout);
	    this._hideTimeout = undefined;
	  };
	
	  _proto.handleDocumentClick = function handleDocumentClick(e) {
	    var triggers = this.props.trigger.split(' ');
	
	    if (triggers.indexOf('legacy') > -1 && (this.props.isOpen || isInDOMSubtrees(e.target, this._targets))) {
	      if (this._hideTimeout) {
	        this.clearHideTimeout();
	      }
	
	      if (this.props.isOpen && !isInDOMSubtree(e.target, this._popover)) {
	        this.hideWithDelay(e);
	      } else if (!this.props.isOpen) {
	        this.showWithDelay(e);
	      }
	    } else if (triggers.indexOf('click') > -1 && isInDOMSubtrees(e.target, this._targets)) {
	      if (this._hideTimeout) {
	        this.clearHideTimeout();
	      }
	
	      if (!this.props.isOpen) {
	        this.showWithDelay(e);
	      } else {
	        this.hideWithDelay(e);
	      }
	    }
	  };
	
	  _proto.addEventOnTargets = function addEventOnTargets(type, handler, isBubble) {
	    this._targets.forEach(function (target) {
	      target.addEventListener(type, handler, isBubble);
	    });
	  };
	
	  _proto.removeEventOnTargets = function removeEventOnTargets(type, handler, isBubble) {
	    this._targets.forEach(function (target) {
	      target.removeEventListener(type, handler, isBubble);
	    });
	  };
	
	  _proto.addTargetEvents = function addTargetEvents() {
	    if (this.props.trigger) {
	      var triggers = this.props.trigger.split(' ');
	
	      if (triggers.indexOf('manual') === -1) {
	        if (triggers.indexOf('click') > -1 || triggers.indexOf('legacy') > -1) {
	          document.addEventListener('click', this.handleDocumentClick, true);
	        }
	
	        if (this._targets && this._targets.length) {
	          if (triggers.indexOf('hover') > -1) {
	            this.addEventOnTargets('mouseover', this.showWithDelay, true);
	            this.addEventOnTargets('mouseout', this.hideWithDelay, true);
	          }
	
	          if (triggers.indexOf('focus') > -1) {
	            this.addEventOnTargets('focusin', this.show, true);
	            this.addEventOnTargets('focusout', this.hide, true);
	          }
	
	          this.addEventOnTargets('keydown', this.onEscKeyDown, true);
	        }
	      }
	    }
	  };
	
	  _proto.removeTargetEvents = function removeTargetEvents() {
	    if (this._targets) {
	      this.removeEventOnTargets('mouseover', this.showWithDelay, true);
	      this.removeEventOnTargets('mouseout', this.hideWithDelay, true);
	      this.removeEventOnTargets('keydown', this.onEscKeyDown, true);
	      this.removeEventOnTargets('focusin', this.show, true);
	      this.removeEventOnTargets('focusout', this.hide, true);
	    }
	
	    document.removeEventListener('click', this.handleDocumentClick, true);
	  };
	
	  _proto.updateTarget = function updateTarget() {
	    var newTarget = (0, _utils.getTarget)(this.props.target, true);
	
	    if (newTarget !== this._targets) {
	      this.removeTargetEvents();
	      this._targets = newTarget ? Array.from(newTarget) : [];
	      this.currentTargetElement = this.currentTargetElement || this._targets[0];
	      this.addTargetEvents();
	    }
	  };
	
	  _proto.toggle = function toggle(e) {
	    if (this.props.disabled || !this._isMounted) {
	      return e && e.preventDefault();
	    }
	
	    return this.props.toggle(e);
	  };
	
	  _proto.render = function render() {
	    var _this2 = this;
	
	    if (this.props.isOpen) {
	      this.updateTarget();
	    }
	
	    var target = this.currentTargetElement || this._targets[0];
	
	    if (!target) {
	      return null;
	    }
	
	    var _this$props = this.props,
	        className = _this$props.className,
	        cssModule = _this$props.cssModule,
	        innerClassName = _this$props.innerClassName,
	        isOpen = _this$props.isOpen,
	        hideArrow = _this$props.hideArrow,
	        boundariesElement = _this$props.boundariesElement,
	        placement = _this$props.placement,
	        placementPrefix = _this$props.placementPrefix,
	        arrowClassName = _this$props.arrowClassName,
	        popperClassName = _this$props.popperClassName,
	        container = _this$props.container,
	        modifiers = _this$props.modifiers,
	        positionFixed = _this$props.positionFixed,
	        offset = _this$props.offset,
	        fade = _this$props.fade,
	        flip = _this$props.flip,
	        children = _this$props.children;
	    var attributes = (0, _utils.omit)(this.props, Object.keys(propTypes));
	    var popperClasses = (0, _utils.mapToCssModules)(popperClassName, cssModule);
	    var classes = (0, _utils.mapToCssModules)(innerClassName, cssModule);
	    return /*#__PURE__*/_react.default.createElement(_PopperContent.default, {
	      className: className,
	      target: target,
	      isOpen: isOpen,
	      hideArrow: hideArrow,
	      boundariesElement: boundariesElement,
	      placement: placement,
	      placementPrefix: placementPrefix,
	      arrowClassName: arrowClassName,
	      popperClassName: popperClasses,
	      container: container,
	      modifiers: modifiers,
	      positionFixed: positionFixed,
	      offset: offset,
	      cssModule: cssModule,
	      fade: fade,
	      flip: flip
	    }, function (_ref) {
	      var scheduleUpdate = _ref.scheduleUpdate;
	      return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, attributes, {
	        ref: _this2.getRef,
	        className: classes,
	        role: "tooltip",
	        onMouseOver: _this2.onMouseOverTooltipContent,
	        onMouseLeave: _this2.onMouseLeaveTooltipContent,
	        onKeyDown: _this2.onEscKeyDown
	      }), typeof children === 'function' ? children({
	        scheduleUpdate: scheduleUpdate
	      }) : children);
	    });
	  };
	
	  return TooltipPopoverWrapper;
	}(_react.default.Component);
	
	TooltipPopoverWrapper.propTypes = propTypes;
	TooltipPopoverWrapper.defaultProps = defaultProps;
	var _default = TooltipPopoverWrapper;
	exports.default = _default;

/***/ },
/* 2764 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(20));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _Alert = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var UncontrolledAlert = /*#__PURE__*/function (_Component) {
	  (0, _inheritsLoose2.default)(UncontrolledAlert, _Component);
	
	  function UncontrolledAlert(props) {
	    var _this;
	
	    _this = _Component.call(this, props) || this;
	    _this.state = {
	      isOpen: true
	    };
	    _this.toggle = _this.toggle.bind((0, _assertThisInitialized2.default)(_this));
	    return _this;
	  }
	
	  var _proto = UncontrolledAlert.prototype;
	
	  _proto.toggle = function toggle() {
	    this.setState({
	      isOpen: !this.state.isOpen
	    });
	  };
	
	  _proto.render = function render() {
	    return /*#__PURE__*/_react.default.createElement(_Alert.default, (0, _extends2.default)({
	      isOpen: this.state.isOpen,
	      toggle: this.toggle
	    }, this.props));
	  };
	
	  return UncontrolledAlert;
	}(_react.Component);
	
	var _default = UncontrolledAlert;
	exports.default = _default;

/***/ },
/* 2765 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(27));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(20));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _ButtonDropdown = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_1__);
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	var omitKeys = ['defaultOpen'];
	
	var UncontrolledButtonDropdown = /*#__PURE__*/function (_Component) {
	  (0, _inheritsLoose2.default)(UncontrolledButtonDropdown, _Component);
	
	  function UncontrolledButtonDropdown(props) {
	    var _this;
	
	    _this = _Component.call(this, props) || this;
	    _this.state = {
	      isOpen: props.defaultOpen || false
	    };
	    _this.toggle = _this.toggle.bind((0, _assertThisInitialized2.default)(_this));
	    return _this;
	  }
	
	  var _proto = UncontrolledButtonDropdown.prototype;
	
	  _proto.toggle = function toggle() {
	    this.setState({
	      isOpen: !this.state.isOpen
	    });
	  };
	
	  _proto.render = function render() {
	    return /*#__PURE__*/_react.default.createElement(_ButtonDropdown.default, (0, _extends2.default)({
	      isOpen: this.state.isOpen,
	      toggle: this.toggle
	    }, (0, _utils.omit)(this.props, omitKeys)));
	  };
	
	  return UncontrolledButtonDropdown;
	}(_react.Component);
	
	exports.default = UncontrolledButtonDropdown;
	UncontrolledButtonDropdown.propTypes = _objectSpread({
	  defaultOpen: _propTypes.default.bool
	}, _ButtonDropdown.default.propTypes);

/***/ },
/* 2766 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(20));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _Carousel = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var _CarouselItem = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_1__));
	
	var _CarouselControl = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_2__));
	
	var _CarouselIndicators = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_3__));
	
	var _CarouselCaption = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_4__));
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var propTypes = {
	  items: _propTypes.default.array.isRequired,
	  indicators: _propTypes.default.bool,
	  controls: _propTypes.default.bool,
	  autoPlay: _propTypes.default.bool,
	  defaultActiveIndex: _propTypes.default.number,
	  activeIndex: _propTypes.default.number,
	  next: _propTypes.default.func,
	  previous: _propTypes.default.func,
	  goToIndex: _propTypes.default.func
	};
	
	var UncontrolledCarousel = /*#__PURE__*/function (_Component) {
	  (0, _inheritsLoose2.default)(UncontrolledCarousel, _Component);
	
	  function UncontrolledCarousel(props) {
	    var _this;
	
	    _this = _Component.call(this, props) || this;
	    _this.animating = false;
	    _this.state = {
	      activeIndex: props.defaultActiveIndex || 0
	    };
	    _this.next = _this.next.bind((0, _assertThisInitialized2.default)(_this));
	    _this.previous = _this.previous.bind((0, _assertThisInitialized2.default)(_this));
	    _this.goToIndex = _this.goToIndex.bind((0, _assertThisInitialized2.default)(_this));
	    _this.onExiting = _this.onExiting.bind((0, _assertThisInitialized2.default)(_this));
	    _this.onExited = _this.onExited.bind((0, _assertThisInitialized2.default)(_this));
	    return _this;
	  }
	
	  var _proto = UncontrolledCarousel.prototype;
	
	  _proto.onExiting = function onExiting() {
	    this.animating = true;
	  };
	
	  _proto.onExited = function onExited() {
	    this.animating = false;
	  };
	
	  _proto.next = function next() {
	    if (this.animating) return;
	    var nextIndex = this.state.activeIndex === this.props.items.length - 1 ? 0 : this.state.activeIndex + 1;
	    this.setState({
	      activeIndex: nextIndex
	    });
	  };
	
	  _proto.previous = function previous() {
	    if (this.animating) return;
	    var nextIndex = this.state.activeIndex === 0 ? this.props.items.length - 1 : this.state.activeIndex - 1;
	    this.setState({
	      activeIndex: nextIndex
	    });
	  };
	
	  _proto.goToIndex = function goToIndex(newIndex) {
	    if (this.animating) return;
	    this.setState({
	      activeIndex: newIndex
	    });
	  };
	
	  _proto.render = function render() {
	    var _this2 = this;
	
	    var _this$props = this.props,
	        defaultActiveIndex = _this$props.defaultActiveIndex,
	        autoPlay = _this$props.autoPlay,
	        indicators = _this$props.indicators,
	        controls = _this$props.controls,
	        items = _this$props.items,
	        goToIndex = _this$props.goToIndex,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["defaultActiveIndex", "autoPlay", "indicators", "controls", "items", "goToIndex"]);
	    var activeIndex = this.state.activeIndex;
	    var slides = items.map(function (item) {
	      var key = item.key || item.src;
	      return /*#__PURE__*/_react.default.createElement(_CarouselItem.default, {
	        onExiting: _this2.onExiting,
	        onExited: _this2.onExited,
	        key: key
	      }, /*#__PURE__*/_react.default.createElement("img", {
	        className: "d-block w-100",
	        src: item.src,
	        alt: item.altText
	      }), /*#__PURE__*/_react.default.createElement(_CarouselCaption.default, {
	        captionText: item.caption,
	        captionHeader: item.header || item.caption
	      }));
	    });
	    return /*#__PURE__*/_react.default.createElement(_Carousel.default, (0, _extends2.default)({
	      activeIndex: activeIndex,
	      next: this.next,
	      previous: this.previous,
	      ride: autoPlay ? 'carousel' : undefined
	    }, props), indicators && /*#__PURE__*/_react.default.createElement(_CarouselIndicators.default, {
	      items: items,
	      activeIndex: props.activeIndex || activeIndex,
	      onClickHandler: goToIndex || this.goToIndex
	    }), slides, controls && /*#__PURE__*/_react.default.createElement(_CarouselControl.default, {
	      direction: "prev",
	      directionText: "Previous",
	      onClickHandler: props.previous || this.previous
	    }), controls && /*#__PURE__*/_react.default.createElement(_CarouselControl.default, {
	      direction: "next",
	      directionText: "Next",
	      onClickHandler: props.next || this.next
	    }));
	  };
	
	  return UncontrolledCarousel;
	}(_react.Component);
	
	UncontrolledCarousel.propTypes = propTypes;
	UncontrolledCarousel.defaultProps = {
	  controls: true,
	  indicators: true,
	  autoPlay: true
	};
	var _default = UncontrolledCarousel;
	exports.default = _default;

/***/ },
/* 2767 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(20));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _Collapse = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_1__);
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var omitKeys = ['toggleEvents', 'defaultOpen'];
	var propTypes = {
	  defaultOpen: _propTypes.default.bool,
	  toggler: _propTypes.default.string.isRequired,
	  toggleEvents: _propTypes.default.arrayOf(_propTypes.default.string)
	};
	var defaultProps = {
	  toggleEvents: _utils.defaultToggleEvents
	};
	
	var UncontrolledCollapse = /*#__PURE__*/function (_Component) {
	  (0, _inheritsLoose2.default)(UncontrolledCollapse, _Component);
	
	  function UncontrolledCollapse(props) {
	    var _this;
	
	    _this = _Component.call(this, props) || this;
	    _this.togglers = null;
	    _this.removeEventListeners = null;
	    _this.toggle = _this.toggle.bind((0, _assertThisInitialized2.default)(_this));
	    _this.state = {
	      isOpen: props.defaultOpen || false
	    };
	    return _this;
	  }
	
	  var _proto = UncontrolledCollapse.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.togglers = (0, _utils.findDOMElements)(this.props.toggler);
	
	    if (this.togglers.length) {
	      this.removeEventListeners = (0, _utils.addMultipleEventListeners)(this.togglers, this.toggle, this.props.toggleEvents);
	    }
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    if (this.togglers.length && this.removeEventListeners) {
	      this.removeEventListeners();
	    }
	  };
	
	  _proto.toggle = function toggle(e) {
	    this.setState(function (_ref) {
	      var isOpen = _ref.isOpen;
	      return {
	        isOpen: !isOpen
	      };
	    });
	    e.preventDefault();
	  };
	
	  _proto.render = function render() {
	    return /*#__PURE__*/_react.default.createElement(_Collapse.default, (0, _extends2.default)({
	      isOpen: this.state.isOpen
	    }, (0, _utils.omit)(this.props, omitKeys)));
	  };
	
	  return UncontrolledCollapse;
	}(_react.Component);
	
	UncontrolledCollapse.propTypes = propTypes;
	UncontrolledCollapse.defaultProps = defaultProps;
	var _default = UncontrolledCollapse;
	exports.default = _default;

/***/ },
/* 2768 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(27));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(20));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _Dropdown = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_1__);
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	var omitKeys = ['defaultOpen'];
	
	var UncontrolledDropdown = /*#__PURE__*/function (_Component) {
	  (0, _inheritsLoose2.default)(UncontrolledDropdown, _Component);
	
	  function UncontrolledDropdown(props) {
	    var _this;
	
	    _this = _Component.call(this, props) || this;
	    _this.state = {
	      isOpen: props.defaultOpen || false
	    };
	    _this.toggle = _this.toggle.bind((0, _assertThisInitialized2.default)(_this));
	    return _this;
	  }
	
	  var _proto = UncontrolledDropdown.prototype;
	
	  _proto.toggle = function toggle(e) {
	    this.setState({
	      isOpen: !this.state.isOpen
	    });
	
	    if (this.props.onToggle) {
	      this.props.onToggle(e, !this.state.isOpen);
	    }
	  };
	
	  _proto.render = function render() {
	    return /*#__PURE__*/_react.default.createElement(_Dropdown.default, (0, _extends2.default)({
	      isOpen: this.state.isOpen,
	      toggle: this.toggle
	    }, (0, _utils.omit)(this.props, omitKeys)));
	  };
	
	  return UncontrolledDropdown;
	}(_react.Component);
	
	exports.default = UncontrolledDropdown;
	UncontrolledDropdown.propTypes = _objectSpread({
	  defaultOpen: _propTypes.default.bool,
	  onToggle: _propTypes.default.func
	}, _Dropdown.default.propTypes);

/***/ },
/* 2769 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(27));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(20));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _Popover = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_1__);
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	var omitKeys = ['defaultOpen'];
	
	var UncontrolledPopover = /*#__PURE__*/function (_Component) {
	  (0, _inheritsLoose2.default)(UncontrolledPopover, _Component);
	
	  function UncontrolledPopover(props) {
	    var _this;
	
	    _this = _Component.call(this, props) || this;
	    _this.state = {
	      isOpen: props.defaultOpen || false
	    };
	    _this.toggle = _this.toggle.bind((0, _assertThisInitialized2.default)(_this));
	    return _this;
	  }
	
	  var _proto = UncontrolledPopover.prototype;
	
	  _proto.toggle = function toggle() {
	    this.setState({
	      isOpen: !this.state.isOpen
	    });
	  };
	
	  _proto.render = function render() {
	    return /*#__PURE__*/_react.default.createElement(_Popover.default, (0, _extends2.default)({
	      isOpen: this.state.isOpen,
	      toggle: this.toggle
	    }, (0, _utils.omit)(this.props, omitKeys)));
	  };
	
	  return UncontrolledPopover;
	}(_react.Component);
	
	exports.default = UncontrolledPopover;
	UncontrolledPopover.propTypes = _objectSpread({
	  defaultOpen: _propTypes.default.bool
	}, _Popover.default.propTypes);

/***/ },
/* 2770 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(27));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(20));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _Tooltip = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var _utils = __webpack_require__(__webpack_module_template_argument_1__);
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	var omitKeys = ['defaultOpen'];
	
	var UncontrolledTooltip = /*#__PURE__*/function (_Component) {
	  (0, _inheritsLoose2.default)(UncontrolledTooltip, _Component);
	
	  function UncontrolledTooltip(props) {
	    var _this;
	
	    _this = _Component.call(this, props) || this;
	    _this.state = {
	      isOpen: props.defaultOpen || false
	    };
	    _this.toggle = _this.toggle.bind((0, _assertThisInitialized2.default)(_this));
	    return _this;
	  }
	
	  var _proto = UncontrolledTooltip.prototype;
	
	  _proto.toggle = function toggle() {
	    this.setState({
	      isOpen: !this.state.isOpen
	    });
	  };
	
	  _proto.render = function render() {
	    return /*#__PURE__*/_react.default.createElement(_Tooltip.default, (0, _extends2.default)({
	      isOpen: this.state.isOpen,
	      toggle: this.toggle
	    }, (0, _utils.omit)(this.props, omitKeys)));
	  };
	
	  return UncontrolledTooltip;
	}(_react.Component);
	
	exports.default = UncontrolledTooltip;
	UncontrolledTooltip.propTypes = _objectSpread({
	  defaultOpen: _propTypes.default.bool
	}, _Tooltip.default.propTypes);

/***/ },
/* 2771 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__, __webpack_module_template_argument_9__, __webpack_module_template_argument_10__, __webpack_module_template_argument_11__, __webpack_module_template_argument_12__, __webpack_module_template_argument_13__, __webpack_module_template_argument_14__, __webpack_module_template_argument_15__, __webpack_module_template_argument_16__, __webpack_module_template_argument_17__, __webpack_module_template_argument_18__, __webpack_module_template_argument_19__, __webpack_module_template_argument_20__, __webpack_module_template_argument_21__, __webpack_module_template_argument_22__, __webpack_module_template_argument_23__, __webpack_module_template_argument_24__, __webpack_module_template_argument_25__, __webpack_module_template_argument_26__, __webpack_module_template_argument_27__, __webpack_module_template_argument_28__, __webpack_module_template_argument_29__, __webpack_module_template_argument_30__, __webpack_module_template_argument_31__, __webpack_module_template_argument_32__, __webpack_module_template_argument_33__, __webpack_module_template_argument_34__, __webpack_module_template_argument_35__, __webpack_module_template_argument_36__, __webpack_module_template_argument_37__, __webpack_module_template_argument_38__, __webpack_module_template_argument_39__, __webpack_module_template_argument_40__, __webpack_module_template_argument_41__, __webpack_module_template_argument_42__, __webpack_module_template_argument_43__, __webpack_module_template_argument_44__, __webpack_module_template_argument_45__, __webpack_module_template_argument_46__, __webpack_module_template_argument_47__, __webpack_module_template_argument_48__, __webpack_module_template_argument_49__, __webpack_module_template_argument_50__, __webpack_module_template_argument_51__, __webpack_module_template_argument_52__, __webpack_module_template_argument_53__, __webpack_module_template_argument_54__, __webpack_module_template_argument_55__, __webpack_module_template_argument_56__, __webpack_module_template_argument_57__, __webpack_module_template_argument_58__, __webpack_module_template_argument_59__, __webpack_module_template_argument_60__, __webpack_module_template_argument_61__, __webpack_module_template_argument_62__, __webpack_module_template_argument_63__, __webpack_module_template_argument_64__, __webpack_module_template_argument_65__, __webpack_module_template_argument_66__, __webpack_module_template_argument_67__, __webpack_module_template_argument_68__, __webpack_module_template_argument_69__, __webpack_module_template_argument_70__, __webpack_module_template_argument_71__, __webpack_module_template_argument_72__, __webpack_module_template_argument_73__, __webpack_module_template_argument_74__, __webpack_module_template_argument_75__, __webpack_module_template_argument_76__, __webpack_module_template_argument_77__, __webpack_module_template_argument_78__, __webpack_module_template_argument_79__, __webpack_module_template_argument_80__, __webpack_module_template_argument_81__, __webpack_module_template_argument_82__, __webpack_module_template_argument_83__, __webpack_module_template_argument_84__, __webpack_module_template_argument_85__, __webpack_module_template_argument_86__, __webpack_module_template_argument_87__, __webpack_module_template_argument_88__, __webpack_module_template_argument_89__, __webpack_module_template_argument_90__, __webpack_module_template_argument_91__, __webpack_module_template_argument_92__, __webpack_module_template_argument_93__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	exports.__esModule = true;
	exports.Polyfill = exports.Util = exports.DropdownContext = void 0;
	
	var _Container2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	exports.Container = _Container2.default;
	
	var _Row2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_1__));
	
	exports.Row = _Row2.default;
	
	var _Col2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_2__));
	
	exports.Col = _Col2.default;
	
	var _Navbar2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_3__));
	
	exports.Navbar = _Navbar2.default;
	
	var _NavbarBrand2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_4__));
	
	exports.NavbarBrand = _NavbarBrand2.default;
	
	var _NavbarText2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_5__));
	
	exports.NavbarText = _NavbarText2.default;
	
	var _NavbarToggler2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_6__));
	
	exports.NavbarToggler = _NavbarToggler2.default;
	
	var _Nav2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_7__));
	
	exports.Nav = _Nav2.default;
	
	var _NavItem2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_8__));
	
	exports.NavItem = _NavItem2.default;
	
	var _NavLink2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_9__));
	
	exports.NavLink = _NavLink2.default;
	
	var _Breadcrumb2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_10__));
	
	exports.Breadcrumb = _Breadcrumb2.default;
	
	var _BreadcrumbItem2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_11__));
	
	exports.BreadcrumbItem = _BreadcrumbItem2.default;
	
	var _Button2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_12__));
	
	exports.Button = _Button2.default;
	
	var _ButtonToggle2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_13__));
	
	exports.ButtonToggle = _ButtonToggle2.default;
	
	var _ButtonDropdown2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_14__));
	
	exports.ButtonDropdown = _ButtonDropdown2.default;
	
	var _ButtonGroup2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_15__));
	
	exports.ButtonGroup = _ButtonGroup2.default;
	
	var _ButtonToolbar2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_16__));
	
	exports.ButtonToolbar = _ButtonToolbar2.default;
	
	var _Dropdown2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_17__));
	
	exports.Dropdown = _Dropdown2.default;
	
	var _DropdownItem2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_18__));
	
	exports.DropdownItem = _DropdownItem2.default;
	
	var _DropdownMenu2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_19__));
	
	exports.DropdownMenu = _DropdownMenu2.default;
	
	var _DropdownToggle2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_20__));
	
	exports.DropdownToggle = _DropdownToggle2.default;
	
	var _DropdownContext = __webpack_require__(__webpack_module_template_argument_21__);
	
	exports.DropdownContext = _DropdownContext.DropdownContext;
	
	var _Fade2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_22__));
	
	exports.Fade = _Fade2.default;
	
	var _Badge2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_23__));
	
	exports.Badge = _Badge2.default;
	
	var _Card2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_24__));
	
	exports.Card = _Card2.default;
	
	var _CardGroup2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_25__));
	
	exports.CardGroup = _CardGroup2.default;
	
	var _CardDeck2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_26__));
	
	exports.CardDeck = _CardDeck2.default;
	
	var _CardColumns2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_27__));
	
	exports.CardColumns = _CardColumns2.default;
	
	var _CardBody2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_28__));
	
	exports.CardBody = _CardBody2.default;
	
	var _CardLink2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_29__));
	
	exports.CardLink = _CardLink2.default;
	
	var _CardFooter2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_30__));
	
	exports.CardFooter = _CardFooter2.default;
	
	var _CardHeader2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_31__));
	
	exports.CardHeader = _CardHeader2.default;
	
	var _CardImg2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_32__));
	
	exports.CardImg = _CardImg2.default;
	
	var _CardImgOverlay2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_33__));
	
	exports.CardImgOverlay = _CardImgOverlay2.default;
	
	var _Carousel2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_34__));
	
	exports.Carousel = _Carousel2.default;
	
	var _UncontrolledCarousel2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_35__));
	
	exports.UncontrolledCarousel = _UncontrolledCarousel2.default;
	
	var _CarouselControl2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_36__));
	
	exports.CarouselControl = _CarouselControl2.default;
	
	var _CarouselItem2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_37__));
	
	exports.CarouselItem = _CarouselItem2.default;
	
	var _CarouselIndicators2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_38__));
	
	exports.CarouselIndicators = _CarouselIndicators2.default;
	
	var _CarouselCaption2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_39__));
	
	exports.CarouselCaption = _CarouselCaption2.default;
	
	var _CardSubtitle2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_40__));
	
	exports.CardSubtitle = _CardSubtitle2.default;
	
	var _CardText2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_41__));
	
	exports.CardText = _CardText2.default;
	
	var _CardTitle2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_42__));
	
	exports.CardTitle = _CardTitle2.default;
	
	var _CustomFileInput2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_43__));
	
	exports.CustomFileInput = _CustomFileInput2.default;
	
	var _CustomInput2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_44__));
	
	exports.CustomInput = _CustomInput2.default;
	
	var _PopperContent2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_45__));
	
	exports.PopperContent = _PopperContent2.default;
	
	var _PopperTargetHelper2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_46__));
	
	exports.PopperTargetHelper = _PopperTargetHelper2.default;
	
	var _Popover2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_47__));
	
	exports.Popover = _Popover2.default;
	
	var _UncontrolledPopover2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_48__));
	
	exports.UncontrolledPopover = _UncontrolledPopover2.default;
	
	var _PopoverHeader2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_49__));
	
	exports.PopoverHeader = _PopoverHeader2.default;
	
	var _PopoverBody2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_50__));
	
	exports.PopoverBody = _PopoverBody2.default;
	
	var _Progress2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_51__));
	
	exports.Progress = _Progress2.default;
	
	var _Modal2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_52__));
	
	exports.Modal = _Modal2.default;
	
	var _ModalHeader2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_53__));
	
	exports.ModalHeader = _ModalHeader2.default;
	
	var _ModalBody2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_54__));
	
	exports.ModalBody = _ModalBody2.default;
	
	var _ModalFooter2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_55__));
	
	exports.ModalFooter = _ModalFooter2.default;
	
	var _Tooltip2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_56__));
	
	exports.Tooltip = _Tooltip2.default;
	
	var _Table2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_57__));
	
	exports.Table = _Table2.default;
	
	var _ListGroup2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_58__));
	
	exports.ListGroup = _ListGroup2.default;
	
	var _Form2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_59__));
	
	exports.Form = _Form2.default;
	
	var _FormFeedback2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_60__));
	
	exports.FormFeedback = _FormFeedback2.default;
	
	var _FormGroup2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_61__));
	
	exports.FormGroup = _FormGroup2.default;
	
	var _FormText2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_62__));
	
	exports.FormText = _FormText2.default;
	
	var _Input2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_63__));
	
	exports.Input = _Input2.default;
	
	var _InputGroup2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_64__));
	
	exports.InputGroup = _InputGroup2.default;
	
	var _InputGroupAddon2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_65__));
	
	exports.InputGroupAddon = _InputGroupAddon2.default;
	
	var _InputGroupButtonDropdown2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_66__));
	
	exports.InputGroupButtonDropdown = _InputGroupButtonDropdown2.default;
	
	var _InputGroupText2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_67__));
	
	exports.InputGroupText = _InputGroupText2.default;
	
	var _Label2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_68__));
	
	exports.Label = _Label2.default;
	
	var _Media2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_69__));
	
	exports.Media = _Media2.default;
	
	var _Pagination2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_70__));
	
	exports.Pagination = _Pagination2.default;
	
	var _PaginationItem2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_71__));
	
	exports.PaginationItem = _PaginationItem2.default;
	
	var _PaginationLink2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_72__));
	
	exports.PaginationLink = _PaginationLink2.default;
	
	var _TabContent2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_73__));
	
	exports.TabContent = _TabContent2.default;
	
	var _TabPane2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_74__));
	
	exports.TabPane = _TabPane2.default;
	
	var _Jumbotron2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_75__));
	
	exports.Jumbotron = _Jumbotron2.default;
	
	var _Alert2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_76__));
	
	exports.Alert = _Alert2.default;
	
	var _Toast2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_77__));
	
	exports.Toast = _Toast2.default;
	
	var _ToastBody2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_78__));
	
	exports.ToastBody = _ToastBody2.default;
	
	var _ToastHeader2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_79__));
	
	exports.ToastHeader = _ToastHeader2.default;
	
	var _Collapse2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_80__));
	
	exports.Collapse = _Collapse2.default;
	
	var _ListGroupItem2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_81__));
	
	exports.ListGroupItem = _ListGroupItem2.default;
	
	var _ListGroupItemHeading2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_82__));
	
	exports.ListGroupItemHeading = _ListGroupItemHeading2.default;
	
	var _ListGroupItemText2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_83__));
	
	exports.ListGroupItemText = _ListGroupItemText2.default;
	
	var _List2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_84__));
	
	exports.List = _List2.default;
	
	var _ListInlineItem2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_85__));
	
	exports.ListInlineItem = _ListInlineItem2.default;
	
	var _UncontrolledAlert2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_86__));
	
	exports.UncontrolledAlert = _UncontrolledAlert2.default;
	
	var _UncontrolledButtonDropdown2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_87__));
	
	exports.UncontrolledButtonDropdown = _UncontrolledButtonDropdown2.default;
	
	var _UncontrolledCollapse2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_88__));
	
	exports.UncontrolledCollapse = _UncontrolledCollapse2.default;
	
	var _UncontrolledDropdown2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_89__));
	
	exports.UncontrolledDropdown = _UncontrolledDropdown2.default;
	
	var _UncontrolledTooltip2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_90__));
	
	exports.UncontrolledTooltip = _UncontrolledTooltip2.default;
	
	var _Spinner2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_91__));
	
	exports.Spinner = _Spinner2.default;
	
	var _Util = _interopRequireWildcard(__webpack_require__(__webpack_module_template_argument_92__));
	
	exports.Util = _Util;
	
	var _Polyfill = _interopRequireWildcard(__webpack_require__(__webpack_module_template_argument_93__));
	
	exports.Polyfill = _Polyfill;
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/***/ },
/* 2772 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(__webpack_module_template_argument_0__);
	} else {
	  module.exports = require('./cjs/react-is.development.js');
	}


/***/ },
/* 2773 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = __webpack_require__(31);
	
	var _TransitionGroup = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	/**
	 * The `<ReplaceTransition>` component is a specialized `Transition` component
	 * that animates between two children.
	 *
	 * ```jsx
	 * <ReplaceTransition in>
	 *   <Fade><div>I appear first</div></Fade>
	 *   <Fade><div>I replace the above</div></Fade>
	 * </ReplaceTransition>
	 * ```
	 */
	var ReplaceTransition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(ReplaceTransition, _React$Component);
	
	  function ReplaceTransition() {
	    var _this;
	
	    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
	      _args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;
	
	    _this.handleEnter = function () {
	      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return _this.handleLifecycle('onEnter', 0, args);
	    };
	
	    _this.handleEntering = function () {
	      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	        args[_key3] = arguments[_key3];
	      }
	
	      return _this.handleLifecycle('onEntering', 0, args);
	    };
	
	    _this.handleEntered = function () {
	      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	        args[_key4] = arguments[_key4];
	      }
	
	      return _this.handleLifecycle('onEntered', 0, args);
	    };
	
	    _this.handleExit = function () {
	      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	        args[_key5] = arguments[_key5];
	      }
	
	      return _this.handleLifecycle('onExit', 1, args);
	    };
	
	    _this.handleExiting = function () {
	      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
	        args[_key6] = arguments[_key6];
	      }
	
	      return _this.handleLifecycle('onExiting', 1, args);
	    };
	
	    _this.handleExited = function () {
	      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
	        args[_key7] = arguments[_key7];
	      }
	
	      return _this.handleLifecycle('onExited', 1, args);
	    };
	
	    return _this;
	  }
	
	  var _proto = ReplaceTransition.prototype;
	
	  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
	    var _child$props;
	
	    var children = this.props.children;
	
	    var child = _react.default.Children.toArray(children)[idx];
	
	    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
	    if (this.props[handler]) this.props[handler]((0, _reactDom.findDOMNode)(this));
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        children = _this$props.children,
	        inProp = _this$props.in,
	        props = _objectWithoutPropertiesLoose(_this$props, ["children", "in"]);
	
	    var _React$Children$toArr = _react.default.Children.toArray(children),
	        first = _React$Children$toArr[0],
	        second = _React$Children$toArr[1];
	
	    delete props.onEnter;
	    delete props.onEntering;
	    delete props.onEntered;
	    delete props.onExit;
	    delete props.onExiting;
	    delete props.onExited;
	    return _react.default.createElement(_TransitionGroup.default, props, inProp ? _react.default.cloneElement(first, {
	      key: 'first',
	      onEnter: this.handleEnter,
	      onEntering: this.handleEntering,
	      onEntered: this.handleEntered
	    }) : _react.default.cloneElement(second, {
	      key: 'second',
	      onEnter: this.handleExit,
	      onEntering: this.handleExiting,
	      onEntered: this.handleExited
	    }));
	  };
	
	  return ReplaceTransition;
	}(_react.default.Component);
	
	ReplaceTransition.propTypes =  false ? {
	  in: _propTypes.default.bool.isRequired,
	  children: function children(props, propName) {
	    if (_react.default.Children.count(props[propName]) !== 2) return new Error("\"" + propName + "\" must be exactly two transition components.");
	    return null;
	  }
	} : {};
	var _default = ReplaceTransition;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 2774 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	"use strict";
	
	var _CSSTransition = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var _ReplaceTransition = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_1__));
	
	var _TransitionGroup = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_2__));
	
	var _Transition = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_3__));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  Transition: _Transition.default,
	  TransitionGroup: _TransitionGroup.default,
	  ReplaceTransition: _ReplaceTransition.default,
	  CSSTransition: _CSSTransition.default
	};

/***/ }
/******/ ])));


// WEBPACK FOOTER //
// static/js/main.a1b5f003.js